/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1804);
	module.exports = __webpack_require__(2252);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(217);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(2398);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Responsive = __webpack_require__(3806);
	
	Object.defineProperty(exports, 'Responsive', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Responsive).default;
	  }
	});
	
	var _Confirm = __webpack_require__(3802);
	
	Object.defineProperty(exports, 'Confirm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Confirm).default;
	  }
	});
	
	var _Portal = __webpack_require__(488);
	
	Object.defineProperty(exports, 'Portal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Portal).default;
	  }
	});
	
	var _Radio = __webpack_require__(770);
	
	Object.defineProperty(exports, 'Radio', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Radio).default;
	  }
	});
	
	var _Select = __webpack_require__(1628);
	
	Object.defineProperty(exports, 'Select', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Select).default;
	  }
	});
	
	var _TextArea = __webpack_require__(1629);
	
	Object.defineProperty(exports, 'TextArea', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextArea).default;
	  }
	});
	
	var _Visibility = __webpack_require__(3810);
	
	Object.defineProperty(exports, 'Visibility', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Visibility).default;
	  }
	});
	
	var _Breadcrumb = __webpack_require__(3812);
	
	Object.defineProperty(exports, 'Breadcrumb', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Breadcrumb).default;
	  }
	});
	
	var _BreadcrumbDivider = __webpack_require__(1630);
	
	Object.defineProperty(exports, 'BreadcrumbDivider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BreadcrumbDivider).default;
	  }
	});
	
	var _BreadcrumbSection = __webpack_require__(1631);
	
	Object.defineProperty(exports, 'BreadcrumbSection', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BreadcrumbSection).default;
	  }
	});
	
	var _Form = __webpack_require__(3814);
	
	Object.defineProperty(exports, 'Form', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Form).default;
	  }
	});
	
	var _FormButton = __webpack_require__(1632);
	
	Object.defineProperty(exports, 'FormButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormButton).default;
	  }
	});
	
	var _FormCheckbox = __webpack_require__(1633);
	
	Object.defineProperty(exports, 'FormCheckbox', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormCheckbox).default;
	  }
	});
	
	var _FormDropdown = __webpack_require__(1634);
	
	Object.defineProperty(exports, 'FormDropdown', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormDropdown).default;
	  }
	});
	
	var _FormField = __webpack_require__(161);
	
	Object.defineProperty(exports, 'FormField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormField).default;
	  }
	});
	
	var _FormGroup = __webpack_require__(1635);
	
	Object.defineProperty(exports, 'FormGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormGroup).default;
	  }
	});
	
	var _FormInput = __webpack_require__(1636);
	
	Object.defineProperty(exports, 'FormInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormInput).default;
	  }
	});
	
	var _FormRadio = __webpack_require__(1637);
	
	Object.defineProperty(exports, 'FormRadio', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormRadio).default;
	  }
	});
	
	var _FormSelect = __webpack_require__(1638);
	
	Object.defineProperty(exports, 'FormSelect', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormSelect).default;
	  }
	});
	
	var _FormTextArea = __webpack_require__(1639);
	
	Object.defineProperty(exports, 'FormTextArea', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormTextArea).default;
	  }
	});
	
	var _Grid = __webpack_require__(3815);
	
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	
	var _GridColumn = __webpack_require__(771);
	
	Object.defineProperty(exports, 'GridColumn', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GridColumn).default;
	  }
	});
	
	var _GridRow = __webpack_require__(1641);
	
	Object.defineProperty(exports, 'GridRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GridRow).default;
	  }
	});
	
	var _Menu = __webpack_require__(3816);
	
	Object.defineProperty(exports, 'Menu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Menu).default;
	  }
	});
	
	var _MenuHeader = __webpack_require__(1643);
	
	Object.defineProperty(exports, 'MenuHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MenuHeader).default;
	  }
	});
	
	var _MenuItem = __webpack_require__(1644);
	
	Object.defineProperty(exports, 'MenuItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MenuItem).default;
	  }
	});
	
	var _MenuMenu = __webpack_require__(1645);
	
	Object.defineProperty(exports, 'MenuMenu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MenuMenu).default;
	  }
	});
	
	var _Message = __webpack_require__(3818);
	
	Object.defineProperty(exports, 'Message', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Message).default;
	  }
	});
	
	var _MessageContent = __webpack_require__(1646);
	
	Object.defineProperty(exports, 'MessageContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageContent).default;
	  }
	});
	
	var _MessageHeader = __webpack_require__(1647);
	
	Object.defineProperty(exports, 'MessageHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageHeader).default;
	  }
	});
	
	var _MessageItem = __webpack_require__(772);
	
	Object.defineProperty(exports, 'MessageItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageItem).default;
	  }
	});
	
	var _MessageList = __webpack_require__(1648);
	
	Object.defineProperty(exports, 'MessageList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageList).default;
	  }
	});
	
	var _Table = __webpack_require__(3820);
	
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Table).default;
	  }
	});
	
	var _TableBody = __webpack_require__(1649);
	
	Object.defineProperty(exports, 'TableBody', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableBody).default;
	  }
	});
	
	var _TableCell = __webpack_require__(489);
	
	Object.defineProperty(exports, 'TableCell', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableCell).default;
	  }
	});
	
	var _TableFooter = __webpack_require__(1650);
	
	Object.defineProperty(exports, 'TableFooter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableFooter).default;
	  }
	});
	
	var _TableHeader = __webpack_require__(773);
	
	Object.defineProperty(exports, 'TableHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableHeader).default;
	  }
	});
	
	var _TableHeaderCell = __webpack_require__(1651);
	
	Object.defineProperty(exports, 'TableHeaderCell', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableHeaderCell).default;
	  }
	});
	
	var _TableRow = __webpack_require__(1652);
	
	Object.defineProperty(exports, 'TableRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableRow).default;
	  }
	});
	
	var _Button = __webpack_require__(1653);
	
	Object.defineProperty(exports, 'Button', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	var _ButtonContent = __webpack_require__(1654);
	
	Object.defineProperty(exports, 'ButtonContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ButtonContent).default;
	  }
	});
	
	var _ButtonGroup = __webpack_require__(1655);
	
	Object.defineProperty(exports, 'ButtonGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ButtonGroup).default;
	  }
	});
	
	var _ButtonOr = __webpack_require__(1656);
	
	Object.defineProperty(exports, 'ButtonOr', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ButtonOr).default;
	  }
	});
	
	var _Container = __webpack_require__(3822);
	
	Object.defineProperty(exports, 'Container', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Container).default;
	  }
	});
	
	var _Divider = __webpack_require__(3824);
	
	Object.defineProperty(exports, 'Divider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Divider).default;
	  }
	});
	
	var _Flag = __webpack_require__(1657);
	
	Object.defineProperty(exports, 'Flag', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Flag).default;
	  }
	});
	
	var _Header = __webpack_require__(3827);
	
	Object.defineProperty(exports, 'Header', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Header).default;
	  }
	});
	
	var _HeaderContent = __webpack_require__(1658);
	
	Object.defineProperty(exports, 'HeaderContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeaderContent).default;
	  }
	});
	
	var _HeaderSubheader = __webpack_require__(1659);
	
	Object.defineProperty(exports, 'HeaderSubheader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeaderSubheader).default;
	  }
	});
	
	var _Icon = __webpack_require__(77);
	
	Object.defineProperty(exports, 'Icon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Icon).default;
	  }
	});
	
	var _IconGroup = __webpack_require__(1660);
	
	Object.defineProperty(exports, 'IconGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IconGroup).default;
	  }
	});
	
	var _Image = __webpack_require__(268);
	
	Object.defineProperty(exports, 'Image', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Image).default;
	  }
	});
	
	var _ImageGroup = __webpack_require__(1662);
	
	Object.defineProperty(exports, 'ImageGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ImageGroup).default;
	  }
	});
	
	var _Input = __webpack_require__(774);
	
	Object.defineProperty(exports, 'Input', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Input).default;
	  }
	});
	
	var _Label = __webpack_require__(492);
	
	Object.defineProperty(exports, 'Label', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Label).default;
	  }
	});
	
	var _LabelDetail = __webpack_require__(1663);
	
	Object.defineProperty(exports, 'LabelDetail', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LabelDetail).default;
	  }
	});
	
	var _LabelGroup = __webpack_require__(1664);
	
	Object.defineProperty(exports, 'LabelGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LabelGroup).default;
	  }
	});
	
	var _List = __webpack_require__(3830);
	
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	
	var _ListContent = __webpack_require__(776);
	
	Object.defineProperty(exports, 'ListContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListContent).default;
	  }
	});
	
	var _ListDescription = __webpack_require__(493);
	
	Object.defineProperty(exports, 'ListDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListDescription).default;
	  }
	});
	
	var _ListHeader = __webpack_require__(494);
	
	Object.defineProperty(exports, 'ListHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListHeader).default;
	  }
	});
	
	var _ListIcon = __webpack_require__(777);
	
	Object.defineProperty(exports, 'ListIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListIcon).default;
	  }
	});
	
	var _ListItem = __webpack_require__(1665);
	
	Object.defineProperty(exports, 'ListItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItem).default;
	  }
	});
	
	var _ListList = __webpack_require__(1666);
	
	Object.defineProperty(exports, 'ListList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListList).default;
	  }
	});
	
	var _Loader = __webpack_require__(3832);
	
	Object.defineProperty(exports, 'Loader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Loader).default;
	  }
	});
	
	var _Rail = __webpack_require__(3834);
	
	Object.defineProperty(exports, 'Rail', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rail).default;
	  }
	});
	
	var _Reveal = __webpack_require__(3836);
	
	Object.defineProperty(exports, 'Reveal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Reveal).default;
	  }
	});
	
	var _RevealContent = __webpack_require__(1667);
	
	Object.defineProperty(exports, 'RevealContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RevealContent).default;
	  }
	});
	
	var _Segment = __webpack_require__(3837);
	
	Object.defineProperty(exports, 'Segment', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Segment).default;
	  }
	});
	
	var _SegmentGroup = __webpack_require__(1669);
	
	Object.defineProperty(exports, 'SegmentGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SegmentGroup).default;
	  }
	});
	
	var _Step = __webpack_require__(3838);
	
	Object.defineProperty(exports, 'Step', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Step).default;
	  }
	});
	
	var _StepContent = __webpack_require__(1671);
	
	Object.defineProperty(exports, 'StepContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepContent).default;
	  }
	});
	
	var _StepDescription = __webpack_require__(778);
	
	Object.defineProperty(exports, 'StepDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepDescription).default;
	  }
	});
	
	var _StepGroup = __webpack_require__(1672);
	
	Object.defineProperty(exports, 'StepGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepGroup).default;
	  }
	});
	
	var _StepTitle = __webpack_require__(779);
	
	Object.defineProperty(exports, 'StepTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepTitle).default;
	  }
	});
	
	var _Accordion = __webpack_require__(3860);
	
	Object.defineProperty(exports, 'Accordion', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Accordion).default;
	  }
	});
	
	var _AccordionAccordion = __webpack_require__(1674);
	
	Object.defineProperty(exports, 'AccordionAccordion', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccordionAccordion).default;
	  }
	});
	
	var _AccordionContent = __webpack_require__(782);
	
	Object.defineProperty(exports, 'AccordionContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccordionContent).default;
	  }
	});
	
	var _AccordionTitle = __webpack_require__(783);
	
	Object.defineProperty(exports, 'AccordionTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccordionTitle).default;
	  }
	});
	
	var _Checkbox = __webpack_require__(495);
	
	Object.defineProperty(exports, 'Checkbox', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkbox).default;
	  }
	});
	
	var _Dimmer = __webpack_require__(1676);
	
	Object.defineProperty(exports, 'Dimmer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dimmer).default;
	  }
	});
	
	var _DimmerDimmable = __webpack_require__(1675);
	
	Object.defineProperty(exports, 'DimmerDimmable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DimmerDimmable).default;
	  }
	});
	
	var _Dropdown = __webpack_require__(784);
	
	Object.defineProperty(exports, 'Dropdown', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dropdown).default;
	  }
	});
	
	var _DropdownDivider = __webpack_require__(1677);
	
	Object.defineProperty(exports, 'DropdownDivider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownDivider).default;
	  }
	});
	
	var _DropdownHeader = __webpack_require__(1678);
	
	Object.defineProperty(exports, 'DropdownHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownHeader).default;
	  }
	});
	
	var _DropdownItem = __webpack_require__(1679);
	
	Object.defineProperty(exports, 'DropdownItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownItem).default;
	  }
	});
	
	var _DropdownMenu = __webpack_require__(1680);
	
	Object.defineProperty(exports, 'DropdownMenu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownMenu).default;
	  }
	});
	
	var _DropdownSearchInput = __webpack_require__(1681);
	
	Object.defineProperty(exports, 'DropdownSearchInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownSearchInput).default;
	  }
	});
	
	var _Embed = __webpack_require__(3865);
	
	Object.defineProperty(exports, 'Embed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Embed).default;
	  }
	});
	
	var _Modal = __webpack_require__(1686);
	
	Object.defineProperty(exports, 'Modal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Modal).default;
	  }
	});
	
	var _ModalActions = __webpack_require__(1682);
	
	Object.defineProperty(exports, 'ModalActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalActions).default;
	  }
	});
	
	var _ModalContent = __webpack_require__(1683);
	
	Object.defineProperty(exports, 'ModalContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalContent).default;
	  }
	});
	
	var _ModalDescription = __webpack_require__(1684);
	
	Object.defineProperty(exports, 'ModalDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalDescription).default;
	  }
	});
	
	var _ModalHeader = __webpack_require__(1685);
	
	Object.defineProperty(exports, 'ModalHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalHeader).default;
	  }
	});
	
	var _Popup = __webpack_require__(3868);
	
	Object.defineProperty(exports, 'Popup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Popup).default;
	  }
	});
	
	var _PopupContent = __webpack_require__(1687);
	
	Object.defineProperty(exports, 'PopupContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PopupContent).default;
	  }
	});
	
	var _PopupHeader = __webpack_require__(1688);
	
	Object.defineProperty(exports, 'PopupHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PopupHeader).default;
	  }
	});
	
	var _Progress = __webpack_require__(3870);
	
	Object.defineProperty(exports, 'Progress', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Progress).default;
	  }
	});
	
	var _Rating = __webpack_require__(3872);
	
	Object.defineProperty(exports, 'Rating', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rating).default;
	  }
	});
	
	var _RatingIcon = __webpack_require__(1689);
	
	Object.defineProperty(exports, 'RatingIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RatingIcon).default;
	  }
	});
	
	var _Search = __webpack_require__(3874);
	
	Object.defineProperty(exports, 'Search', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Search).default;
	  }
	});
	
	var _SearchCategory = __webpack_require__(1690);
	
	Object.defineProperty(exports, 'SearchCategory', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchCategory).default;
	  }
	});
	
	var _SearchResult = __webpack_require__(1691);
	
	Object.defineProperty(exports, 'SearchResult', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchResult).default;
	  }
	});
	
	var _SearchResults = __webpack_require__(1692);
	
	Object.defineProperty(exports, 'SearchResults', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchResults).default;
	  }
	});
	
	var _Sidebar = __webpack_require__(3876);
	
	Object.defineProperty(exports, 'Sidebar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sidebar).default;
	  }
	});
	
	var _SidebarPushable = __webpack_require__(1693);
	
	Object.defineProperty(exports, 'SidebarPushable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SidebarPushable).default;
	  }
	});
	
	var _SidebarPusher = __webpack_require__(1694);
	
	Object.defineProperty(exports, 'SidebarPusher', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SidebarPusher).default;
	  }
	});
	
	var _Sticky = __webpack_require__(3878);
	
	Object.defineProperty(exports, 'Sticky', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sticky).default;
	  }
	});
	
	var _Tab = __webpack_require__(3880);
	
	Object.defineProperty(exports, 'Tab', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tab).default;
	  }
	});
	
	var _TabPane = __webpack_require__(1695);
	
	Object.defineProperty(exports, 'TabPane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TabPane).default;
	  }
	});
	
	var _Transition = __webpack_require__(3881);
	
	Object.defineProperty(exports, 'Transition', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Transition).default;
	  }
	});
	
	var _TransitionGroup = __webpack_require__(1697);
	
	Object.defineProperty(exports, 'TransitionGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TransitionGroup).default;
	  }
	});
	
	var _Advertisement = __webpack_require__(3883);
	
	Object.defineProperty(exports, 'Advertisement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Advertisement).default;
	  }
	});
	
	var _Card = __webpack_require__(1698);
	
	Object.defineProperty(exports, 'Card', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Card).default;
	  }
	});
	
	var _CardContent = __webpack_require__(1699);
	
	Object.defineProperty(exports, 'CardContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardContent).default;
	  }
	});
	
	var _CardDescription = __webpack_require__(785);
	
	Object.defineProperty(exports, 'CardDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardDescription).default;
	  }
	});
	
	var _CardGroup = __webpack_require__(1700);
	
	Object.defineProperty(exports, 'CardGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardGroup).default;
	  }
	});
	
	var _CardHeader = __webpack_require__(786);
	
	Object.defineProperty(exports, 'CardHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardHeader).default;
	  }
	});
	
	var _CardMeta = __webpack_require__(787);
	
	Object.defineProperty(exports, 'CardMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardMeta).default;
	  }
	});
	
	var _Comment = __webpack_require__(3885);
	
	Object.defineProperty(exports, 'Comment', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Comment).default;
	  }
	});
	
	var _CommentAction = __webpack_require__(1701);
	
	Object.defineProperty(exports, 'CommentAction', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentAction).default;
	  }
	});
	
	var _CommentActions = __webpack_require__(1702);
	
	Object.defineProperty(exports, 'CommentActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentActions).default;
	  }
	});
	
	var _CommentAuthor = __webpack_require__(1703);
	
	Object.defineProperty(exports, 'CommentAuthor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentAuthor).default;
	  }
	});
	
	var _CommentAvatar = __webpack_require__(1704);
	
	Object.defineProperty(exports, 'CommentAvatar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentAvatar).default;
	  }
	});
	
	var _CommentContent = __webpack_require__(1705);
	
	Object.defineProperty(exports, 'CommentContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentContent).default;
	  }
	});
	
	var _CommentGroup = __webpack_require__(1706);
	
	Object.defineProperty(exports, 'CommentGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentGroup).default;
	  }
	});
	
	var _CommentMetadata = __webpack_require__(1707);
	
	Object.defineProperty(exports, 'CommentMetadata', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentMetadata).default;
	  }
	});
	
	var _CommentText = __webpack_require__(1708);
	
	Object.defineProperty(exports, 'CommentText', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentText).default;
	  }
	});
	
	var _Feed = __webpack_require__(3887);
	
	Object.defineProperty(exports, 'Feed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Feed).default;
	  }
	});
	
	var _FeedContent = __webpack_require__(788);
	
	Object.defineProperty(exports, 'FeedContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedContent).default;
	  }
	});
	
	var _FeedDate = __webpack_require__(496);
	
	Object.defineProperty(exports, 'FeedDate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedDate).default;
	  }
	});
	
	var _FeedEvent = __webpack_require__(1709);
	
	Object.defineProperty(exports, 'FeedEvent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedEvent).default;
	  }
	});
	
	var _FeedExtra = __webpack_require__(789);
	
	Object.defineProperty(exports, 'FeedExtra', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedExtra).default;
	  }
	});
	
	var _FeedLabel = __webpack_require__(790);
	
	Object.defineProperty(exports, 'FeedLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedLabel).default;
	  }
	});
	
	var _FeedLike = __webpack_require__(791);
	
	Object.defineProperty(exports, 'FeedLike', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedLike).default;
	  }
	});
	
	var _FeedMeta = __webpack_require__(792);
	
	Object.defineProperty(exports, 'FeedMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedMeta).default;
	  }
	});
	
	var _FeedSummary = __webpack_require__(793);
	
	Object.defineProperty(exports, 'FeedSummary', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedSummary).default;
	  }
	});
	
	var _FeedUser = __webpack_require__(794);
	
	Object.defineProperty(exports, 'FeedUser', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedUser).default;
	  }
	});
	
	var _Item = __webpack_require__(3888);
	
	Object.defineProperty(exports, 'Item', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Item).default;
	  }
	});
	
	var _ItemContent = __webpack_require__(1711);
	
	Object.defineProperty(exports, 'ItemContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemContent).default;
	  }
	});
	
	var _ItemDescription = __webpack_require__(795);
	
	Object.defineProperty(exports, 'ItemDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemDescription).default;
	  }
	});
	
	var _ItemExtra = __webpack_require__(796);
	
	Object.defineProperty(exports, 'ItemExtra', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemExtra).default;
	  }
	});
	
	var _ItemGroup = __webpack_require__(1712);
	
	Object.defineProperty(exports, 'ItemGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemGroup).default;
	  }
	});
	
	var _ItemHeader = __webpack_require__(797);
	
	Object.defineProperty(exports, 'ItemHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemHeader).default;
	  }
	});
	
	var _ItemImage = __webpack_require__(1713);
	
	Object.defineProperty(exports, 'ItemImage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemImage).default;
	  }
	});
	
	var _ItemMeta = __webpack_require__(798);
	
	Object.defineProperty(exports, 'ItemMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemMeta).default;
	  }
	});
	
	var _Statistic = __webpack_require__(3889);
	
	Object.defineProperty(exports, 'Statistic', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Statistic).default;
	  }
	});
	
	var _StatisticGroup = __webpack_require__(1715);
	
	Object.defineProperty(exports, 'StatisticGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StatisticGroup).default;
	  }
	});
	
	var _StatisticLabel = __webpack_require__(1716);
	
	Object.defineProperty(exports, 'StatisticLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StatisticLabel).default;
	  }
	});
	
	var _StatisticValue = __webpack_require__(1717);
	
	Object.defineProperty(exports, 'StatisticValue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StatisticValue).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(3034)();
	}


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * lodash <https://lodash.com/>
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.16.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://github.com/es-shims.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for function metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256,
	      FLIP_FLAG = 512;
	
	  /** Used to compose bitmasks for comparison styles. */
	  var UNORDERED_COMPARE_FLAG = 1,
	      PARTIAL_COMPARE_FLAG = 2;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 500,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', ARY_FLAG],
	    ['bind', BIND_FLAG],
	    ['bindKey', BIND_KEY_FLAG],
	    ['curry', CURRY_FLAG],
	    ['curryRight', CURRY_RIGHT_FLAG],
	    ['flip', FLIP_FLAG],
	    ['partial', PARTIAL_FLAG],
	    ['partialRight', PARTIAL_RIGHT_FLAG],
	    ['rearg', REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	      rsComboSymbolsRange = '\\u20d0-\\u20f0',
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	    rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	    rsUpper + '+' + rsOptUpperContr,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array ? array.length : 0;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array ? array.length : 0;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array ? array.length : 0;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array ? array.length : 0;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        iteratorSymbol = Symbol ? Symbol.iterator : undefined,
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array of at least `200` elements
	     * and any iteratees accept only one argument. The heuristic for whether a
	     * section qualifies for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
	          (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function assignInDefaults(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          isNil = object == null,
	          length = paths.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = isNil ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {boolean} [isFull] Specify a clone including symbols.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var props = isArr ? undefined : (isFull ? getAllKeys : keys)(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      return objectToString.call(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      if (!isKey(path, object)) {
	        path = castPath(path);
	        object = parent(object, path);
	        path = last(path);
	      }
	      var func = object == null ? object : object[toKey(path)];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && objectToString.call(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && objectToString.call(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, bitmask, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = getTag(object);
	        objTag = objTag == argsTag ? objectTag : objTag;
	      }
	      if (!othIsArr) {
	        othTag = getTag(other);
	        othTag = othTag == argsTag ? objectTag : othTag;
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	          : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	      }
	      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObject(value) && objectToString.call(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, props) {
	      object = Object(object);
	      return basePickBy(object, props, function(value, key) {
	        return key in object;
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick from.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, props, predicate) {
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (predicate(value, key)) {
	          baseAssignValue(result, key, value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          }
	          else if (!isKey(index, array)) {
	            var path = castPath(index),
	                object = parent(array, path);
	
	            if (object != null) {
	              delete object[toKey(last(path))];
	            }
	          }
	          else {
	            delete array[toKey(index)];
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	      object = parent(object, path);
	
	      var key = toKey(last(path));
	      return !(object != null && hasOwnProperty.call(object, key)) || delete object[key];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var index = -1,
	          length = arrays.length;
	
	      while (++index < length) {
	        var result = result
	          ? arrayPush(
	              baseDifference(result, arrays[index], iteratee, comparator),
	              baseDifference(arrays[index], result, iteratee, comparator)
	            )
	          : arrays[index];
	      }
	      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 &&
	              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	          isFlip = bitmask & FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	      if (!(bitmask & CURRY_BOUND_FLAG)) {
	        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     *   512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] == null
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, customizer, bitmask, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= UNORDERED_COMPARE_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	    /**
	     * Creates an array of the own and inherited enumerable symbol properties
	     * of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = objectToString.call(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : undefined;
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object ? object.length : 0;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      string = toString(string);
	
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to process.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array ? array.length : 0;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs ? pairs.length : 0,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array ? array.length : 0;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (comparator === last(mapped)) {
	        comparator = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array ? nativeJoin.call(array, separator) : '';
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array ? array.length : 0,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array ? nativeReverse.call(array) : array;
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array ? array.length : 0;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length)
	        ? baseUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      return (array && array.length)
	        ? baseUniq(array, undefined, comparator)
	        : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return partial(wrapper, value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, false, true);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      return baseClone(value, false, true, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, true, true);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      return baseClone(value, true, true, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && objectToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return value != null && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      return (objectToString.call(value) == errorTag) ||
	        (typeof value.message == 'string' && typeof value.name == 'string');
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed array and other constructors.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && objectToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || objectToString.call(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return (typeof Ctor == 'function' &&
	        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (iteratorSymbol && value[iteratorSymbol]) {
	        return iteratorToArray(value[iteratorSymbol]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, assignInDefaults);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, mergeDefaults);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable string keyed properties of `object` that are
	     * not omitted.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      props = arrayMap(props, toKey);
	      return basePick(object, baseDifference(getAllKeysIn(object), props));
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, props) {
	      return object == null ? {} : basePick(object, arrayMap(props, toKey));
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      return object == null ? {} : basePickBy(object, getAllKeysIn(object), getIteratee(predicate));
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        object = undefined;
	        length = 1;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object ? baseValues(object, keys(object)) : [];
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = baseClamp(toInteger(position), 0, string.length);
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, assignInDefaults);
	
	      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs ? pairs.length : 0,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (iteratorSymbol) {
	      lodash.prototype[iteratorSymbol] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(53)(module)))

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.17.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i in momentProperties) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _ordinalParseLenient.
	    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return this._months;
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return this._monthsShort;
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    //can't just apply() to create a date:
	    //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    //the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    //the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return this._weekdays;
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    ordinalParse: defaultOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(3016)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	        hooks.createFromInputFallback(config);
	    }
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse)) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (input === undefined) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (typeof(input) === 'object') {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString () {
	    var m = this.clone().utc();
	    if (0 < m.year() && m.year() <= 9999) {
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            return this.toDate().toISOString();
	        } else {
	            return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    } else {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$1 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$1;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this[units + 's']();
	}
	
	function makeGetter(name) {
	    return function () {
	        return this._data[name];
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    s: 45,  // seconds to minute
	    m: 45,  // minutes to hour
	    h: 22,  // hours to day
	    d: 26,  // days to month
	    M: 11   // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds < thresholds.s && ['s', seconds]  ||
	            minutes <= 1           && ['m']           ||
	            minutes < thresholds.m && ['mm', minutes] ||
	            hours   <= 1           && ['h']           ||
	            hours   < thresholds.h && ['hh', hours]   ||
	            days    <= 1           && ['d']           ||
	            days    < thresholds.d && ['dd', days]    ||
	            months  <= 1           && ['M']           ||
	            months  < thresholds.M && ['MM', months]  ||
	            years   <= 1           && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    return true;
	}
	
	function humanize (withSuffix) {
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.17.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)(module)))

/***/ },
/* 8 */
[4449, 2787],
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(2786)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)(module)))

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = exports.objectDiff = exports.normalizeTransitionDuration = exports.normalizeOffset = exports.numberToWord = exports.numberToWordMap = exports.keyboardKey = exports.SUI = exports.META = exports.leven = exports.isBrowser = exports.partitionHTMLInputProps = exports.htmlInputProps = exports.htmlInputEvents = exports.htmlInputAttrs = exports.getElementType = exports.getUnhandledProps = exports.eventStack = exports.makeDebugger = exports.debug = exports.customPropTypes = exports.useWidthProp = exports.useVerticalAlignProp = exports.useTextAlignProp = exports.useMultipleProp = exports.useValueAndKey = exports.useKeyOrValueAndKey = exports.useKeyOnly = exports.childrenUtils = exports.mergeChildMappings = exports.getChildMapping = exports.AutoControlledComponent = undefined;
	
	var _AutoControlledComponent = __webpack_require__(2837);
	
	Object.defineProperty(exports, 'AutoControlledComponent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AutoControlledComponent).default;
	  }
	});
	
	var _childMapping = __webpack_require__(2839);
	
	Object.defineProperty(exports, 'getChildMapping', {
	  enumerable: true,
	  get: function get() {
	    return _childMapping.getChildMapping;
	  }
	});
	Object.defineProperty(exports, 'mergeChildMappings', {
	  enumerable: true,
	  get: function get() {
	    return _childMapping.mergeChildMappings;
	  }
	});
	
	var _classNameBuilders = __webpack_require__(2841);
	
	Object.defineProperty(exports, 'useKeyOnly', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useKeyOnly;
	  }
	});
	Object.defineProperty(exports, 'useKeyOrValueAndKey', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useKeyOrValueAndKey;
	  }
	});
	Object.defineProperty(exports, 'useValueAndKey', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useValueAndKey;
	  }
	});
	Object.defineProperty(exports, 'useMultipleProp', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useMultipleProp;
	  }
	});
	Object.defineProperty(exports, 'useTextAlignProp', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useTextAlignProp;
	  }
	});
	Object.defineProperty(exports, 'useVerticalAlignProp', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useVerticalAlignProp;
	  }
	});
	Object.defineProperty(exports, 'useWidthProp', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useWidthProp;
	  }
	});
	
	var _debug = __webpack_require__(2843);
	
	Object.defineProperty(exports, 'debug', {
	  enumerable: true,
	  get: function get() {
	    return _debug.debug;
	  }
	});
	Object.defineProperty(exports, 'makeDebugger', {
	  enumerable: true,
	  get: function get() {
	    return _debug.makeDebugger;
	  }
	});
	
	var _factories = __webpack_require__(2848);
	
	Object.keys(_factories).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _factories[key];
	    }
	  });
	});
	
	var _getUnhandledProps = __webpack_require__(2850);
	
	Object.defineProperty(exports, 'getUnhandledProps', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getUnhandledProps).default;
	  }
	});
	
	var _getElementType = __webpack_require__(2849);
	
	Object.defineProperty(exports, 'getElementType', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getElementType).default;
	  }
	});
	
	var _htmlInputPropsUtils = __webpack_require__(2851);
	
	Object.defineProperty(exports, 'htmlInputAttrs', {
	  enumerable: true,
	  get: function get() {
	    return _htmlInputPropsUtils.htmlInputAttrs;
	  }
	});
	Object.defineProperty(exports, 'htmlInputEvents', {
	  enumerable: true,
	  get: function get() {
	    return _htmlInputPropsUtils.htmlInputEvents;
	  }
	});
	Object.defineProperty(exports, 'htmlInputProps', {
	  enumerable: true,
	  get: function get() {
	    return _htmlInputPropsUtils.htmlInputProps;
	  }
	});
	Object.defineProperty(exports, 'partitionHTMLInputProps', {
	  enumerable: true,
	  get: function get() {
	    return _htmlInputPropsUtils.partitionHTMLInputProps;
	  }
	});
	
	var _isBrowser = __webpack_require__(647);
	
	Object.defineProperty(exports, 'isBrowser', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isBrowser).default;
	  }
	});
	
	var _leven = __webpack_require__(1232);
	
	Object.defineProperty(exports, 'leven', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_leven).default;
	  }
	});
	
	var _keyboardKey = __webpack_require__(2852);
	
	Object.defineProperty(exports, 'keyboardKey', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_keyboardKey).default;
	  }
	});
	
	var _numberToWord = __webpack_require__(648);
	
	Object.defineProperty(exports, 'numberToWordMap', {
	  enumerable: true,
	  get: function get() {
	    return _numberToWord.numberToWordMap;
	  }
	});
	Object.defineProperty(exports, 'numberToWord', {
	  enumerable: true,
	  get: function get() {
	    return _numberToWord.numberToWord;
	  }
	});
	
	var _objectDiff = __webpack_require__(2855);
	
	Object.defineProperty(exports, 'objectDiff', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_objectDiff).default;
	  }
	});
	
	var _childrenUtils2 = __webpack_require__(2840);
	
	var _childrenUtils = _interopRequireWildcard(_childrenUtils2);
	
	var _customPropTypes2 = __webpack_require__(2842);
	
	var _customPropTypes = _interopRequireWildcard(_customPropTypes2);
	
	var _eventStack2 = __webpack_require__(2846);
	
	var _eventStack3 = _interopRequireDefault(_eventStack2);
	
	var _META2 = __webpack_require__(1231);
	
	var _META = _interopRequireWildcard(_META2);
	
	var _SUI2 = __webpack_require__(2838);
	
	var _SUI = _interopRequireWildcard(_SUI2);
	
	var _normalizeOffset2 = __webpack_require__(2853);
	
	var _normalizeOffset3 = _interopRequireDefault(_normalizeOffset2);
	
	var _normalizeTransitionDuration2 = __webpack_require__(2854);
	
	var _normalizeTransitionDuration3 = _interopRequireDefault(_normalizeTransitionDuration2);
	
	var _shallowEqual2 = __webpack_require__(2856);
	
	var _shallowEqual3 = _interopRequireDefault(_shallowEqual2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.childrenUtils = _childrenUtils;
	exports.customPropTypes = _customPropTypes;
	exports.eventStack = _eventStack3.default;
	exports.META = _META;
	exports.SUI = _SUI;
	exports.normalizeOffset = _normalizeOffset3.default;
	exports.normalizeTransitionDuration = _normalizeTransitionDuration3.default;
	exports.shallowEqual = _shallowEqual3.default;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = exports.objectDiff = exports.normalizeTransitionDuration = exports.normalizeOffset = exports.numberToWord = exports.numberToWordMap = exports.keyboardKey = exports.SUI = exports.META = exports.leven = exports.isBrowser = exports.partitionHTMLInputProps = exports.htmlInputProps = exports.htmlInputEvents = exports.htmlInputAttrs = exports.getElementType = exports.getUnhandledProps = exports.eventStack = exports.makeDebugger = exports.debug = exports.customPropTypes = exports.useWidthProp = exports.useVerticalAlignProp = exports.useTextAlignProp = exports.useOnlyProp = exports.useValueAndKey = exports.useKeyOrValueAndKey = exports.useKeyOnly = exports.childrenUtils = exports.mergeChildMappings = exports.getChildMapping = exports.AutoControlledComponent = undefined;
	
	var _AutoControlledComponent = __webpack_require__(3839);
	
	Object.defineProperty(exports, 'AutoControlledComponent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AutoControlledComponent).default;
	  }
	});
	
	var _childMapping = __webpack_require__(3842);
	
	Object.defineProperty(exports, 'getChildMapping', {
	  enumerable: true,
	  get: function get() {
	    return _childMapping.getChildMapping;
	  }
	});
	Object.defineProperty(exports, 'mergeChildMappings', {
	  enumerable: true,
	  get: function get() {
	    return _childMapping.mergeChildMappings;
	  }
	});
	
	var _classNameBuilders = __webpack_require__(3844);
	
	Object.defineProperty(exports, 'useKeyOnly', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useKeyOnly;
	  }
	});
	Object.defineProperty(exports, 'useKeyOrValueAndKey', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useKeyOrValueAndKey;
	  }
	});
	Object.defineProperty(exports, 'useValueAndKey', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useValueAndKey;
	  }
	});
	Object.defineProperty(exports, 'useOnlyProp', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useOnlyProp;
	  }
	});
	Object.defineProperty(exports, 'useTextAlignProp', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useTextAlignProp;
	  }
	});
	Object.defineProperty(exports, 'useVerticalAlignProp', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useVerticalAlignProp;
	  }
	});
	Object.defineProperty(exports, 'useWidthProp', {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useWidthProp;
	  }
	});
	
	var _debug = __webpack_require__(3846);
	
	Object.defineProperty(exports, 'debug', {
	  enumerable: true,
	  get: function get() {
	    return _debug.debug;
	  }
	});
	Object.defineProperty(exports, 'makeDebugger', {
	  enumerable: true,
	  get: function get() {
	    return _debug.makeDebugger;
	  }
	});
	
	var _factories = __webpack_require__(3851);
	
	Object.keys(_factories).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _factories[key];
	    }
	  });
	});
	
	var _getUnhandledProps = __webpack_require__(3853);
	
	Object.defineProperty(exports, 'getUnhandledProps', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getUnhandledProps).default;
	  }
	});
	
	var _getElementType = __webpack_require__(3852);
	
	Object.defineProperty(exports, 'getElementType', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getElementType).default;
	  }
	});
	
	var _htmlInputPropsUtils = __webpack_require__(3854);
	
	Object.defineProperty(exports, 'htmlInputAttrs', {
	  enumerable: true,
	  get: function get() {
	    return _htmlInputPropsUtils.htmlInputAttrs;
	  }
	});
	Object.defineProperty(exports, 'htmlInputEvents', {
	  enumerable: true,
	  get: function get() {
	    return _htmlInputPropsUtils.htmlInputEvents;
	  }
	});
	Object.defineProperty(exports, 'htmlInputProps', {
	  enumerable: true,
	  get: function get() {
	    return _htmlInputPropsUtils.htmlInputProps;
	  }
	});
	Object.defineProperty(exports, 'partitionHTMLInputProps', {
	  enumerable: true,
	  get: function get() {
	    return _htmlInputPropsUtils.partitionHTMLInputProps;
	  }
	});
	
	var _isBrowser = __webpack_require__(780);
	
	Object.defineProperty(exports, 'isBrowser', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isBrowser).default;
	  }
	});
	
	var _leven = __webpack_require__(1673);
	
	Object.defineProperty(exports, 'leven', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_leven).default;
	  }
	});
	
	var _keyboardKey = __webpack_require__(3855);
	
	Object.defineProperty(exports, 'keyboardKey', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_keyboardKey).default;
	  }
	});
	
	var _numberToWord = __webpack_require__(781);
	
	Object.defineProperty(exports, 'numberToWordMap', {
	  enumerable: true,
	  get: function get() {
	    return _numberToWord.numberToWordMap;
	  }
	});
	Object.defineProperty(exports, 'numberToWord', {
	  enumerable: true,
	  get: function get() {
	    return _numberToWord.numberToWord;
	  }
	});
	
	var _objectDiff = __webpack_require__(3858);
	
	Object.defineProperty(exports, 'objectDiff', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_objectDiff).default;
	  }
	});
	
	var _childrenUtils2 = __webpack_require__(3843);
	
	var _childrenUtils = _interopRequireWildcard(_childrenUtils2);
	
	var _customPropTypes2 = __webpack_require__(3845);
	
	var _customPropTypes = _interopRequireWildcard(_customPropTypes2);
	
	var _eventStack2 = __webpack_require__(3849);
	
	var _eventStack3 = _interopRequireDefault(_eventStack2);
	
	var _META2 = __webpack_require__(3840);
	
	var _META = _interopRequireWildcard(_META2);
	
	var _SUI2 = __webpack_require__(3841);
	
	var _SUI = _interopRequireWildcard(_SUI2);
	
	var _normalizeOffset2 = __webpack_require__(3856);
	
	var _normalizeOffset3 = _interopRequireDefault(_normalizeOffset2);
	
	var _normalizeTransitionDuration2 = __webpack_require__(3857);
	
	var _normalizeTransitionDuration3 = _interopRequireDefault(_normalizeTransitionDuration2);
	
	var _shallowEqual2 = __webpack_require__(3859);
	
	var _shallowEqual3 = _interopRequireDefault(_shallowEqual2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.childrenUtils = _childrenUtils;
	exports.customPropTypes = _customPropTypes;
	exports.eventStack = _eventStack3.default;
	exports.META = _META;
	exports.SUI = _SUI;
	exports.normalizeOffset = _normalizeOffset3.default;
	exports.normalizeTransitionDuration = _normalizeTransitionDuration3.default;
	exports.shallowEqual = _shallowEqual3.default;

/***/ },
/* 12 */
[4449, 4074],
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _isPlaceholder = __webpack_require__(434);
	
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2
	             : _curry1(function(_b) { return fn(a, _b); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
	             : fn(a, b);
	    }
	  };
	};


/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var _extends = _interopDefault(__webpack_require__(2));
	var shallowEqual = _interopDefault(__webpack_require__(208));
	var _classCallCheck = _interopDefault(__webpack_require__(14));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(19));
	var _inherits = _interopDefault(__webpack_require__(18));
	var reactLifecyclesCompat = __webpack_require__(3361);
	var _objectWithoutProperties = _interopDefault(__webpack_require__(120));
	var _Object$keys = _interopDefault(__webpack_require__(940));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(3633));
	var changeEmitter = __webpack_require__(2412);
	var $$observable = _interopDefault(__webpack_require__(1784));
	
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	var setDisplayName = function setDisplayName(displayName) {
	  return setStatic('displayName', displayName);
	};
	
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + getDisplayName(BaseComponent) + ')';
	};
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var MapProps = function MapProps(props) {
	      return factory(propsMapper(props));
	    };
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
	    }
	    return MapProps;
	  };
	};
	
	var withProps = function withProps(input) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var pick = function pick(obj, keys) {
	  var result = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	  return result;
	};
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !shallowEqual(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
	    };
	
	    var WithPropsOnChange = function (_Component) {
	      _inherits(WithPropsOnChange, _Component);
	
	      function WithPropsOnChange() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithPropsOnChange);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          computedProps: propsMapper(_this.props),
	          prevProps: _this.props
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithPropsOnChange.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	        if (shouldMap(prevState.prevProps, nextProps)) {
	          return {
	            computedProps: propsMapper(nextProps),
	            prevProps: nextProps
	          };
	        }
	
	        return null;
	      };
	
	      WithPropsOnChange.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.state.computedProps));
	      };
	
	      return WithPropsOnChange;
	    }(React.Component);
	
	    reactLifecyclesCompat.polyfill(WithPropsOnChange);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
	    }
	
	    return WithPropsOnChange;
	  };
	};
	
	var mapValues = function mapValues(obj, func) {
	  var result = {};
	  /* eslint-disable no-restricted-syntax */
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      result[key] = func(obj[key], key);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	  return result;
	};
	
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithHandlers = function (_Component) {
	      _inherits(WithHandlers, _Component);
	
	      function WithHandlers() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithHandlers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithHandlers.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return WithHandlers;
	    }(React.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler) {
	        return function () {
	          var handler = createHandler(_this2.props);
	
	          if (false) {
	            console.error(
	            // eslint-disable-line no-console
	            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	          }
	
	          return handler.apply(undefined, arguments);
	        };
	      });
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
	    }
	    return WithHandlers;
	  };
	};
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	    DefaultProps.defaultProps = props;
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
	    }
	    return DefaultProps;
	  };
	};
	
	var omit = function omit(obj, keys) {
	  var rest = _objectWithoutProperties(obj, []);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (rest.hasOwnProperty(key)) {
	      delete rest[key];
	    }
	  }
	  return rest;
	};
	
	var renameProp = function renameProp(oldName, newName) {
	  var hoc = mapProps(function (props) {
	    var _extends2;
	
	    return _extends({}, omit(props, [oldName]), (_extends2 = {}, _extends2[newName] = props[oldName], _extends2));
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var keys = _Object$keys;
	
	
	var mapKeys = function mapKeys(obj, func) {
	  return keys(obj).reduce(function (result, key) {
	    var val = obj[key];
	    /* eslint-disable no-param-reassign */
	    result[func(val, key)] = val;
	    /* eslint-enable no-param-reassign */
	    return result;
	  }, {});
	};
	
	var renameProps = function renameProps(nameMap) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
	      return nameMap[oldName];
	    }));
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var flattenProp = function flattenProp(propName) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var FlattenProp = function FlattenProp(props) {
	      return factory(_extends({}, props, props[propName]));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
	    }
	    return FlattenProp;
	  };
	};
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithState = function (_Component) {
	      _inherits(WithState, _Component);
	
	      function WithState() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithState);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        }, _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithState.prototype.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
	      };
	
	      return WithState;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
	    }
	    return WithState;
	  };
	};
	
	var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithStateHandlers = function (_Component) {
	      _inherits(WithStateHandlers, _Component);
	
	      function WithStateHandlers() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithStateHandlers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        var propsChanged = nextProps !== this.props;
	        // the idea is to skip render if stateUpdater handler return undefined
	        // this allows to create no state update handlers with access to state and props
	        var stateChanged = !shallowEqual(nextState, this.state);
	        return propsChanged || stateChanged;
	      };
	
	      WithStateHandlers.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
	      };
	
	      return WithStateHandlers;
	    }(React.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
	      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
	        return function (mayBeEvent) {
	          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	
	          // Having that functional form of setState can be called async
	          // we need to persist SyntheticEvent
	          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
	            mayBeEvent.persist();
	          }
	
	          _this2.setState(function (state, props) {
	            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
	          });
	        };
	      });
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
	    }
	    return WithStateHandlers;
	  };
	};
	
	var noop = function noop() {};
	
	var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithReducer = function (_Component) {
	      _inherits(WithReducer, _Component);
	
	      function WithReducer() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithReducer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: _this.initializeStateValue()
	        }, _this.dispatch = function (action) {
	          var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: reducer(stateValue, action)
	            };
	          }, function () {
	            return callback(_this.state.stateValue);
	          });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
	        if (initialState !== undefined) {
	          return typeof initialState === 'function' ? initialState(this.props) : initialState;
	        }
	        return reducer(undefined, { type: '@@recompose/INIT' });
	      };
	
	      WithReducer.prototype.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[dispatchName] = this.dispatch, _extends2)));
	      };
	
	      return WithReducer;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
	    }
	    return WithReducer;
	  };
	};
	
	var identity = function identity(Component) {
	  return Component;
	};
	
	var branch = function branch(test, left) {
	  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
	  return function (BaseComponent) {
	    var leftFactory = void 0;
	    var rightFactory = void 0;
	    var Branch = function Branch(props) {
	      if (test(props)) {
	        leftFactory = leftFactory || React.createFactory(left(BaseComponent));
	        return leftFactory(props);
	      }
	      rightFactory = rightFactory || React.createFactory(right(BaseComponent));
	      return rightFactory(props);
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
	    }
	    return Branch;
	  };
	};
	
	var renderComponent = function renderComponent(Component) {
	  return function (_) {
	    var factory = React.createFactory(Component);
	    var RenderComponent = function RenderComponent(props) {
	      return factory(props);
	    };
	    if (false) {
	      RenderComponent.displayName = wrapDisplayName(Component, 'renderComponent');
	    }
	    return RenderComponent;
	  };
	};
	
	var Nothing = function (_Component) {
	  _inherits(Nothing, _Component);
	
	  function Nothing() {
	    _classCallCheck(this, Nothing);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Nothing.prototype.render = function render() {
	    return null;
	  };
	
	  return Nothing;
	}(React.Component);
	
	var renderNothing = function renderNothing(_) {
	  return Nothing;
	};
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      _inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        _classCallCheck(this, ShouldUpdate);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	var pure = function pure(BaseComponent) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(props, nextProps);
	  });
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(pick(nextProps, propKeys), pick(props, propKeys));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
	  var propTypes = BaseComponent.propTypes;
	
	  if (false) {
	    if (!propTypes) {
	      /* eslint-disable */
	      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
	      /* eslint-enable */
	    }
	  }
	
	  var propKeys = _Object$keys(propTypes || {});
	  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
	  }
	  return OnlyUpdateForPropTypes;
	};
	
	var withContext = function withContext(childContextTypes, getChildContext) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithContext = function (_Component) {
	      _inherits(WithContext, _Component);
	
	      function WithContext() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithContext);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
	          return getChildContext(_this.props);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithContext.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return WithContext;
	    }(React.Component);
	
	    WithContext.childContextTypes = childContextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
	    }
	    return WithContext;
	  };
	};
	
	var getContext = function getContext(contextTypes) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var GetContext = function GetContext(ownerProps, context) {
	      return factory(_extends({}, ownerProps, context));
	    };
	
	    GetContext.contextTypes = contextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
	    }
	    return GetContext;
	  };
	};
	
	var lifecycle = function lifecycle(spec) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    if (false) {
	      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
	    }
	
	    var Lifecycle = function (_Component) {
	      _inherits(Lifecycle, _Component);
	
	      function Lifecycle() {
	        _classCallCheck(this, Lifecycle);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      Lifecycle.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.state));
	      };
	
	      return Lifecycle;
	    }(React.Component);
	
	    _Object$keys(spec).forEach(function (hook) {
	      return Lifecycle.prototype[hook] = spec[hook];
	    });
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
	    }
	    return Lifecycle;
	  };
	};
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.render === 'function');
	};
	
	var toClass = function toClass(baseComponent) {
	  var _class, _temp;
	
	  return isClassComponent(baseComponent) ? baseComponent : (_temp = _class = function (_Component) {
	    _inherits(ToClass, _Component);
	
	    function ToClass() {
	      _classCallCheck(this, ToClass);
	
	      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ToClass.prototype.render = function render() {
	      if (typeof baseComponent === 'string') {
	        return React__default.createElement(baseComponent, this.props);
	      }
	      return baseComponent(this.props, this.context);
	    };
	
	    return ToClass;
	  }(React.Component), _class.displayName = getDisplayName(baseComponent), _class.propTypes = baseComponent.propTypes, _class.contextTypes = baseComponent.contextTypes, _class.defaultProps = baseComponent.defaultProps, _temp);
	};
	
	var setPropTypes = function setPropTypes(propTypes) {
	  return setStatic('propTypes', propTypes);
	};
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}
	
	var createSink = function createSink(callback) {
	  var Sink = function (_Component) {
	    _inherits(Sink, _Component);
	
	    function Sink() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Sink);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Sink.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
	      callback(nextProps);
	      return null;
	    };
	
	    Sink.prototype.render = function render() {
	      return null;
	    };
	
	    return Sink;
	  }(React.Component);
	
	  reactLifecyclesCompat.polyfill(Sink);
	  return Sink;
	};
	
	var componentFromProp = function componentFromProp(propName) {
	  var Component = function Component(props) {
	    return React.createElement(props[propName], omit(props, [propName]));
	  };
	  Component.displayName = 'componentFromProp(' + propName + ')';
	  return Component;
	};
	
	var nest = function nest() {
	  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
	    Components[_key] = arguments[_key];
	  }
	
	  var factories = Components.map(React.createFactory);
	  var Nest = function Nest(_ref) {
	    var children = _ref.children,
	        props = _objectWithoutProperties(_ref, ['children']);
	
	    return factories.reduceRight(function (child, factory) {
	      return factory(props, child);
	    }, children);
	  };
	
	  if (false) {
	    var displayNames = Components.map(getDisplayName);
	    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
	  }
	
	  return Nest;
	};
	
	var hoistStatics = function hoistStatics(higherOrderComponent, blacklist) {
	  return function (BaseComponent) {
	    var NewComponent = higherOrderComponent(BaseComponent);
	    hoistNonReactStatics(NewComponent, BaseComponent, blacklist);
	    return NewComponent;
	  };
	};
	
	var _config = {
	  fromESObservable: null,
	  toESObservable: null
	};
	
	var configureObservable = function configureObservable(c) {
	  _config = c;
	};
	
	var config = {
	  fromESObservable: function fromESObservable(observable) {
	    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
	  },
	  toESObservable: function toESObservable(stream) {
	    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
	  }
	};
	
	var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
	  return function (propsToVdom) {
	    return function (_Component) {
	      _inherits(ComponentFromStream, _Component);
	
	      function ComponentFromStream() {
	        var _config$fromESObserva;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ComponentFromStream);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = changeEmitter.createChangeEmitter(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
	          subscribe: function subscribe(observer) {
	            var unsubscribe = _this.propsEmitter.listen(function (props) {
	              if (props) {
	                observer.next(props);
	              } else {
	                observer.complete();
	              }
	            });
	            return { unsubscribe: unsubscribe };
	          }
	        }, _config$fromESObserva[$$observable] = function () {
	          return this;
	        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      // Stream of props
	
	
	      // Stream of vdom
	
	
	      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        // Subscribe to child prop changes so we know when to re-render
	        this.subscription = this.vdom$.subscribe({
	          next: function next(vdom) {
	            _this2.setState({ vdom: vdom });
	          }
	        });
	        this.propsEmitter.emit(this.props);
	      };
	
	      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        // Receive new props from the owner
	        this.propsEmitter.emit(nextProps);
	      };
	
	      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        return nextState.vdom !== this.state.vdom;
	      };
	
	      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
	        // Call without arguments to complete stream
	        this.propsEmitter.emit();
	
	        // Clean-up subscription before un-mounting
	        this.subscription.unsubscribe();
	      };
	
	      ComponentFromStream.prototype.render = function render() {
	        return this.state.vdom;
	      };
	
	      return ComponentFromStream;
	    }(React.Component);
	  };
	};
	
	var componentFromStream = function componentFromStream(propsToVdom) {
	  return componentFromStreamWithConfig(config)(propsToVdom);
	};
	
	var identity$1 = function identity(t) {
	  return t;
	};
	
	var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
	  var componentFromStream$$1 = componentFromStreamWithConfig({
	    fromESObservable: identity$1,
	    toESObservable: identity$1
	  });
	  return function (transform) {
	    return function (BaseComponent) {
	      var factory = React.createFactory(BaseComponent);
	      var fromESObservable = config$$1.fromESObservable,
	          toESObservable = config$$1.toESObservable;
	
	      return componentFromStream$$1(function (props$) {
	        var _ref;
	
	        return _ref = {
	          subscribe: function subscribe(observer) {
	            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
	              next: function next(childProps) {
	                return observer.next(factory(childProps));
	              }
	            });
	            return {
	              unsubscribe: function unsubscribe() {
	                return subscription.unsubscribe();
	              }
	            };
	          }
	        }, _ref[$$observable] = function () {
	          return this;
	        }, _ref;
	      });
	    };
	  };
	};
	
	var mapPropsStream = function mapPropsStream(transform) {
	  var hoc = mapPropsStreamWithConfig(config)(transform);
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
	  return function () {
	    var _config$fromESObserva;
	
	    var emitter = changeEmitter.createChangeEmitter();
	    var stream = config$$1.fromESObservable((_config$fromESObserva = {
	      subscribe: function subscribe(observer) {
	        var unsubscribe = emitter.listen(function (value) {
	          return observer.next(value);
	        });
	        return { unsubscribe: unsubscribe };
	      }
	    }, _config$fromESObserva[$$observable] = function () {
	      return this;
	    }, _config$fromESObserva));
	    return {
	      handler: emitter.emit,
	      stream: stream
	    };
	  };
	};
	
	var createEventHandler = createEventHandlerWithConfig(config);
	
	// Higher-order component helpers
	
	exports.mapProps = mapProps;
	exports.withProps = withProps;
	exports.withPropsOnChange = withPropsOnChange;
	exports.withHandlers = withHandlers;
	exports.defaultProps = defaultProps;
	exports.renameProp = renameProp;
	exports.renameProps = renameProps;
	exports.flattenProp = flattenProp;
	exports.withState = withState;
	exports.withStateHandlers = withStateHandlers;
	exports.withReducer = withReducer;
	exports.branch = branch;
	exports.renderComponent = renderComponent;
	exports.renderNothing = renderNothing;
	exports.shouldUpdate = shouldUpdate;
	exports.pure = pure;
	exports.onlyUpdateForKeys = onlyUpdateForKeys;
	exports.onlyUpdateForPropTypes = onlyUpdateForPropTypes;
	exports.withContext = withContext;
	exports.getContext = getContext;
	exports.lifecycle = lifecycle;
	exports.toClass = toClass;
	exports.setStatic = setStatic;
	exports.setPropTypes = setPropTypes;
	exports.setDisplayName = setDisplayName;
	exports.compose = compose;
	exports.getDisplayName = getDisplayName;
	exports.wrapDisplayName = wrapDisplayName;
	exports.shallowEqual = shallowEqual;
	exports.isClassComponent = isClassComponent;
	exports.createSink = createSink;
	exports.componentFromProp = componentFromProp;
	exports.nest = nest;
	exports.hoistStatics = hoistStatics;
	exports.componentFromStream = componentFromStream;
	exports.componentFromStreamWithConfig = componentFromStreamWithConfig;
	exports.mapPropsStream = mapPropsStream;
	exports.mapPropsStreamWithConfig = mapPropsStreamWithConfig;
	exports.createEventHandler = createEventHandler;
	exports.createEventHandlerWithConfig = createEventHandlerWithConfig;
	exports.setObservableConfig = configureObservable;


/***/ },
/* 16 */
[4185, 2394],
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(939);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(2401);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(2399);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(131);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(131);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1855);

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authService = undefined;
	
	var _auth0Js = __webpack_require__(1847);
	
	var _auth0Js2 = _interopRequireDefault(_auth0Js);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jwtDecode = __webpack_require__(1298);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	var _queryString = __webpack_require__(1427);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _events = __webpack_require__(667);
	
	var _jwtHelper = __webpack_require__(2388);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var loginDefaultArgs = {
	  realm: 'Username-Password-Authentication'
	};
	
	var CORQ_DOMAIN = 'data.corq.studio';
	var CORQ_REFERRER = 'corq.studio';
	var IMPERSONATOR_DOMAIN = 'imp.dyzio.co';
	var AUTH0_ISSUER = 'dyzio.eu.auth0.com';
	
	var Auth = function (_EventEmitter) {
	  _inherits(Auth, _EventEmitter);
	
	  function Auth() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Auth);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Auth.__proto__ || Object.getPrototypeOf(Auth)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return Auth;
	}(_events.EventEmitter);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.isImperonatorDomain = function () {
	    var hostname = window.location.hostname;
	
	    return hostname === IMPERSONATOR_DOMAIN;
	  };
	
	  this.auth0 = new _auth0Js2.default.WebAuth({
	    domain: this.isImperonatorDomain() ? AUTH0_ISSUER : ("auth0.dyzio.co"),
	    clientID: ("MxuEZkaXquZnlJeL9oE8QhyQzhMtjfTp"),
	    redirectUri: window.location.origin + '/auth',
	    responseType: 'token'
	  });
	
	  this.uid = function () {
	    var profile = _this2.getProfile();
	    return profile ? profile.app_metadata.dyzio.u_id : null;
	  };
	
	  this.socialLogin = function (args) {
	    return _this2.auth0.authorize(args);
	  };
	
	  this.parseHash = function () {
	    return new Promise(function (resolve, reject) {
	      var hostname = window.location.hostname;
	
	      var parsedHash = _queryString2.default.parse(window.location.hash);
	      var referrer = parsedHash.referrer;
	
	      if (hostname === CORQ_DOMAIN && referrer === CORQ_REFERRER) {
	        var decoded = (0, _jwtDecode2.default)(parsedHash.id_token);
	        localStorage.setItem('id_token', parsedHash.id_token);
	        localStorage.setItem('profile', JSON.stringify(decoded));
	        _this2.emit('profile_updated', decoded);
	        resolve();
	      } else {
	        _this2.auth0.parseHash({
	          hash: window.location.hash,
	          __enableIdPInitiatedLogin: true
	        }, function (err, authResult) {
	          if (err) {
	            reject(err);
	          }
	          if (authResult && authResult.accessToken && authResult.idToken) {
	            _this2.auth0.client.userInfo(authResult.accessToken, function (error, profile) {
	              if (error) {
	                reject(error);
	              }
	              localStorage.setItem('id_token', authResult.idToken);
	              localStorage.setItem('profile', JSON.stringify(profile));
	              _this2.emit('profile_updated', profile);
	              resolve();
	            });
	          } else {
	            reject('Missing token.');
	          }
	        });
	      }
	    });
	  };
	
	  this.getProfile = function () {
	    var profile = localStorage.getItem('profile');
	    return profile ? JSON.parse(profile) : {};
	  };
	
	  this.loggedIn = function () {
	    var token = _this2.getToken();
	    return !!token && !(0, _jwtHelper.isTokenExpired)(token);
	  };
	
	  this.logout = function () {
	    localStorage.removeItem('id_token');
	    localStorage.removeItem('profile');
	    localStorage.removeItem('dyzio-upgrade-modal');
	  };
	
	  this.login = function (args, onError) {
	    return _this2.auth0.login(_lodash2.default.assign(loginDefaultArgs, args), onError);
	  };
	
	  this.signup = function (args, onError) {
	    return _this2.auth0.redirect.signupAndLogin(args, onError);
	  };
	
	  this.getToken = function () {
	    return localStorage.getItem('id_token');
	  };
	};
	
	var authService = exports.authService = new Auth();

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hasRESTClient = function hasRESTClient(WrapperComponent) {
	  var _class, _temp, _initialiseProps;
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class(props) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	      _initialiseProps.call(_this);
	
	      var token = _authService.authService.getToken();
	      _this.campaignAPIClient = _axios2.default.create({
	        baseURL: ("https://dl6gzrmms2.execute-api.eu-west-1.amazonaws.com/production"),
	        timeout: 6000
	      });
	      _this.oauthTokenAPIClient = _axios2.default.create({
	        baseURL: ("https://uiqcrs8dhb.execute-api.eu-west-1.amazonaws.com/production"),
	        timeout: 15000
	      });
	      _this.oauthTokenAPIClient.CancelToken = _axios2.default.CancelToken;
	      _this.oauthTokenAPIClient.isCancel = _axios2.default.isCancel;
	      _this.restClient = _axios2.default.create({
	        baseURL: ("https://api2.dyzio.co/v1"),
	        timeout: 30000,
	        headers: {
	          'Content-Type': 'application/json',
	          Authorization: 'Bearer ' + token
	        }
	      });
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, {
	          restClient: this.restClient,
	          campaignAPIClient: this.campaignAPIClient,
	          oauthTokenAPIClient: this.oauthTokenAPIClient,
	          buildRESTClient: this.buildRESTClient
	        }));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _initialiseProps = function _initialiseProps() {
	    this.buildRESTClient = function (_ref) {
	      var _ref$baseURL = _ref.baseURL,
	          baseURL = _ref$baseURL === undefined ? ("https://api2.dyzio.co/v1") : _ref$baseURL,
	          _ref$hasToken = _ref.hasToken,
	          hasToken = _ref$hasToken === undefined ? true : _ref$hasToken,
	          timeout = _ref.timeout;
	
	      var token = _authService.authService.getToken();
	      return _axios2.default.create({
	        baseURL: baseURL,
	        timeout: timeout || 6000,
	        headers: {
	          'Content-Type': 'application/json',
	          Authorization: hasToken ? 'Bearer ' + token : undefined
	        }
	      });
	    };
	  }, _temp;
	};
	
	exports.default = hasRESTClient;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hasUserInfo = function hasUserInfo(WrapperComponent) {
	  return function (_Component) {
	    _inherits(HasUserInfo, _Component);
	
	    function HasUserInfo() {
	      _classCallCheck(this, HasUserInfo);
	
	      return _possibleConstructorReturn(this, (HasUserInfo.__proto__ || Object.getPrototypeOf(HasUserInfo)).apply(this, arguments));
	    }
	
	    _createClass(HasUserInfo, [{
	      key: 'render',
	      value: function render() {
	        var profile = _authService.authService.getProfile();
	
	        var userInfo = {
	          name: 'Anony Mous',
	          email: 'anon@anonymous.com'
	        };
	
	        if (profile && _lodash2.default.has(profile, 'app_metadata')) {
	          var _profile$app_metadata = profile.app_metadata.dyzio,
	              email = _profile$app_metadata.email,
	              name = _profile$app_metadata.name,
	              organisationId = _profile$app_metadata.o_id,
	              role = _profile$app_metadata.role,
	              userId = _profile$app_metadata.u_id,
	              isUserSuperAdmin = _profile$app_metadata.isUserSuperAdmin;
	
	
	          var isDyzioUser = _lodash2.default.endsWith(email, '@dyzio.co') || _lodash2.default.endsWith(email, '@gifta.co.uk');
	          var _userInfo = {
	            email: email,
	            name: name,
	            organisationId: organisationId,
	            role: role,
	            userId: userId,
	            isUserSuperAdmin: isUserSuperAdmin,
	            isDyzioUser: isDyzioUser
	          };
	
	          return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, {
	            userInfo: _userInfo
	          }));
	        }
	
	        return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, { userInfo: userInfo }));
	      }
	    }]);
	
	    return HasUserInfo;
	  }(_react.Component);
	};
	
	exports.default = hasUserInfo;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Responsive = __webpack_require__(2802);
	
	Object.defineProperty(exports, 'Responsive', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Responsive).default;
	  }
	});
	
	var _Confirm = __webpack_require__(2797);
	
	Object.defineProperty(exports, 'Confirm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Confirm).default;
	  }
	});
	
	var _Portal = __webpack_require__(306);
	
	Object.defineProperty(exports, 'Portal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Portal).default;
	  }
	});
	
	var _Radio = __webpack_require__(637);
	
	Object.defineProperty(exports, 'Radio', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Radio).default;
	  }
	});
	
	var _Ref = __webpack_require__(1185);
	
	Object.defineProperty(exports, 'Ref', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Ref).default;
	  }
	});
	
	var _Select = __webpack_require__(1186);
	
	Object.defineProperty(exports, 'Select', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Select).default;
	  }
	});
	
	var _TextArea = __webpack_require__(1187);
	
	Object.defineProperty(exports, 'TextArea', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextArea).default;
	  }
	});
	
	var _TransitionablePortal = __webpack_require__(2806);
	
	Object.defineProperty(exports, 'TransitionablePortal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TransitionablePortal).default;
	  }
	});
	
	var _Visibility = __webpack_require__(2808);
	
	Object.defineProperty(exports, 'Visibility', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Visibility).default;
	  }
	});
	
	var _Breadcrumb = __webpack_require__(2810);
	
	Object.defineProperty(exports, 'Breadcrumb', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Breadcrumb).default;
	  }
	});
	
	var _BreadcrumbDivider = __webpack_require__(1188);
	
	Object.defineProperty(exports, 'BreadcrumbDivider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BreadcrumbDivider).default;
	  }
	});
	
	var _BreadcrumbSection = __webpack_require__(1189);
	
	Object.defineProperty(exports, 'BreadcrumbSection', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BreadcrumbSection).default;
	  }
	});
	
	var _Form = __webpack_require__(2812);
	
	Object.defineProperty(exports, 'Form', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Form).default;
	  }
	});
	
	var _FormButton = __webpack_require__(1190);
	
	Object.defineProperty(exports, 'FormButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormButton).default;
	  }
	});
	
	var _FormCheckbox = __webpack_require__(1191);
	
	Object.defineProperty(exports, 'FormCheckbox', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormCheckbox).default;
	  }
	});
	
	var _FormDropdown = __webpack_require__(1192);
	
	Object.defineProperty(exports, 'FormDropdown', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormDropdown).default;
	  }
	});
	
	var _FormField = __webpack_require__(153);
	
	Object.defineProperty(exports, 'FormField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormField).default;
	  }
	});
	
	var _FormGroup = __webpack_require__(1193);
	
	Object.defineProperty(exports, 'FormGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormGroup).default;
	  }
	});
	
	var _FormInput = __webpack_require__(1194);
	
	Object.defineProperty(exports, 'FormInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormInput).default;
	  }
	});
	
	var _FormRadio = __webpack_require__(1195);
	
	Object.defineProperty(exports, 'FormRadio', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormRadio).default;
	  }
	});
	
	var _FormSelect = __webpack_require__(1196);
	
	Object.defineProperty(exports, 'FormSelect', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormSelect).default;
	  }
	});
	
	var _FormTextArea = __webpack_require__(1197);
	
	Object.defineProperty(exports, 'FormTextArea', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormTextArea).default;
	  }
	});
	
	var _Grid = __webpack_require__(2813);
	
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	
	var _GridColumn = __webpack_require__(638);
	
	Object.defineProperty(exports, 'GridColumn', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GridColumn).default;
	  }
	});
	
	var _GridRow = __webpack_require__(1199);
	
	Object.defineProperty(exports, 'GridRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GridRow).default;
	  }
	});
	
	var _Menu = __webpack_require__(2814);
	
	Object.defineProperty(exports, 'Menu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Menu).default;
	  }
	});
	
	var _MenuHeader = __webpack_require__(1201);
	
	Object.defineProperty(exports, 'MenuHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MenuHeader).default;
	  }
	});
	
	var _MenuItem = __webpack_require__(1202);
	
	Object.defineProperty(exports, 'MenuItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MenuItem).default;
	  }
	});
	
	var _MenuMenu = __webpack_require__(1203);
	
	Object.defineProperty(exports, 'MenuMenu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MenuMenu).default;
	  }
	});
	
	var _Message = __webpack_require__(2816);
	
	Object.defineProperty(exports, 'Message', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Message).default;
	  }
	});
	
	var _MessageContent = __webpack_require__(1204);
	
	Object.defineProperty(exports, 'MessageContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageContent).default;
	  }
	});
	
	var _MessageHeader = __webpack_require__(1205);
	
	Object.defineProperty(exports, 'MessageHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageHeader).default;
	  }
	});
	
	var _MessageItem = __webpack_require__(639);
	
	Object.defineProperty(exports, 'MessageItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageItem).default;
	  }
	});
	
	var _MessageList = __webpack_require__(1206);
	
	Object.defineProperty(exports, 'MessageList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageList).default;
	  }
	});
	
	var _Table = __webpack_require__(2818);
	
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Table).default;
	  }
	});
	
	var _TableBody = __webpack_require__(1207);
	
	Object.defineProperty(exports, 'TableBody', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableBody).default;
	  }
	});
	
	var _TableCell = __webpack_require__(412);
	
	Object.defineProperty(exports, 'TableCell', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableCell).default;
	  }
	});
	
	var _TableFooter = __webpack_require__(1208);
	
	Object.defineProperty(exports, 'TableFooter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableFooter).default;
	  }
	});
	
	var _TableHeader = __webpack_require__(640);
	
	Object.defineProperty(exports, 'TableHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableHeader).default;
	  }
	});
	
	var _TableHeaderCell = __webpack_require__(1209);
	
	Object.defineProperty(exports, 'TableHeaderCell', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableHeaderCell).default;
	  }
	});
	
	var _TableRow = __webpack_require__(1210);
	
	Object.defineProperty(exports, 'TableRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableRow).default;
	  }
	});
	
	var _Button = __webpack_require__(1211);
	
	Object.defineProperty(exports, 'Button', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	var _ButtonContent = __webpack_require__(1212);
	
	Object.defineProperty(exports, 'ButtonContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ButtonContent).default;
	  }
	});
	
	var _ButtonGroup = __webpack_require__(1213);
	
	Object.defineProperty(exports, 'ButtonGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ButtonGroup).default;
	  }
	});
	
	var _ButtonOr = __webpack_require__(1214);
	
	Object.defineProperty(exports, 'ButtonOr', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ButtonOr).default;
	  }
	});
	
	var _Container = __webpack_require__(2820);
	
	Object.defineProperty(exports, 'Container', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Container).default;
	  }
	});
	
	var _Divider = __webpack_require__(2822);
	
	Object.defineProperty(exports, 'Divider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Divider).default;
	  }
	});
	
	var _Flag = __webpack_require__(1215);
	
	Object.defineProperty(exports, 'Flag', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Flag).default;
	  }
	});
	
	var _Header = __webpack_require__(2825);
	
	Object.defineProperty(exports, 'Header', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Header).default;
	  }
	});
	
	var _HeaderContent = __webpack_require__(1216);
	
	Object.defineProperty(exports, 'HeaderContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeaderContent).default;
	  }
	});
	
	var _HeaderSubheader = __webpack_require__(1217);
	
	Object.defineProperty(exports, 'HeaderSubheader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeaderSubheader).default;
	  }
	});
	
	var _Icon = __webpack_require__(75);
	
	Object.defineProperty(exports, 'Icon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Icon).default;
	  }
	});
	
	var _IconGroup = __webpack_require__(1218);
	
	Object.defineProperty(exports, 'IconGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IconGroup).default;
	  }
	});
	
	var _Image = __webpack_require__(247);
	
	Object.defineProperty(exports, 'Image', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Image).default;
	  }
	});
	
	var _ImageGroup = __webpack_require__(1220);
	
	Object.defineProperty(exports, 'ImageGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ImageGroup).default;
	  }
	});
	
	var _Input = __webpack_require__(641);
	
	Object.defineProperty(exports, 'Input', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Input).default;
	  }
	});
	
	var _Label = __webpack_require__(415);
	
	Object.defineProperty(exports, 'Label', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Label).default;
	  }
	});
	
	var _LabelDetail = __webpack_require__(1221);
	
	Object.defineProperty(exports, 'LabelDetail', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LabelDetail).default;
	  }
	});
	
	var _LabelGroup = __webpack_require__(1222);
	
	Object.defineProperty(exports, 'LabelGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LabelGroup).default;
	  }
	});
	
	var _List = __webpack_require__(2828);
	
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	
	var _ListContent = __webpack_require__(643);
	
	Object.defineProperty(exports, 'ListContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListContent).default;
	  }
	});
	
	var _ListDescription = __webpack_require__(416);
	
	Object.defineProperty(exports, 'ListDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListDescription).default;
	  }
	});
	
	var _ListHeader = __webpack_require__(417);
	
	Object.defineProperty(exports, 'ListHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListHeader).default;
	  }
	});
	
	var _ListIcon = __webpack_require__(644);
	
	Object.defineProperty(exports, 'ListIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListIcon).default;
	  }
	});
	
	var _ListItem = __webpack_require__(1223);
	
	Object.defineProperty(exports, 'ListItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItem).default;
	  }
	});
	
	var _ListList = __webpack_require__(1224);
	
	Object.defineProperty(exports, 'ListList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListList).default;
	  }
	});
	
	var _Loader = __webpack_require__(2830);
	
	Object.defineProperty(exports, 'Loader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Loader).default;
	  }
	});
	
	var _Rail = __webpack_require__(2832);
	
	Object.defineProperty(exports, 'Rail', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rail).default;
	  }
	});
	
	var _Reveal = __webpack_require__(2834);
	
	Object.defineProperty(exports, 'Reveal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Reveal).default;
	  }
	});
	
	var _RevealContent = __webpack_require__(1225);
	
	Object.defineProperty(exports, 'RevealContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RevealContent).default;
	  }
	});
	
	var _Segment = __webpack_require__(2835);
	
	Object.defineProperty(exports, 'Segment', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Segment).default;
	  }
	});
	
	var _SegmentGroup = __webpack_require__(1227);
	
	Object.defineProperty(exports, 'SegmentGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SegmentGroup).default;
	  }
	});
	
	var _Step = __webpack_require__(2836);
	
	Object.defineProperty(exports, 'Step', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Step).default;
	  }
	});
	
	var _StepContent = __webpack_require__(1229);
	
	Object.defineProperty(exports, 'StepContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepContent).default;
	  }
	});
	
	var _StepDescription = __webpack_require__(645);
	
	Object.defineProperty(exports, 'StepDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepDescription).default;
	  }
	});
	
	var _StepGroup = __webpack_require__(1230);
	
	Object.defineProperty(exports, 'StepGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepGroup).default;
	  }
	});
	
	var _StepTitle = __webpack_require__(646);
	
	Object.defineProperty(exports, 'StepTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepTitle).default;
	  }
	});
	
	var _Accordion = __webpack_require__(2857);
	
	Object.defineProperty(exports, 'Accordion', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Accordion).default;
	  }
	});
	
	var _AccordionAccordion = __webpack_require__(1233);
	
	Object.defineProperty(exports, 'AccordionAccordion', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccordionAccordion).default;
	  }
	});
	
	var _AccordionContent = __webpack_require__(649);
	
	Object.defineProperty(exports, 'AccordionContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccordionContent).default;
	  }
	});
	
	var _AccordionTitle = __webpack_require__(650);
	
	Object.defineProperty(exports, 'AccordionTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccordionTitle).default;
	  }
	});
	
	var _Checkbox = __webpack_require__(418);
	
	Object.defineProperty(exports, 'Checkbox', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkbox).default;
	  }
	});
	
	var _Dimmer = __webpack_require__(1235);
	
	Object.defineProperty(exports, 'Dimmer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dimmer).default;
	  }
	});
	
	var _DimmerDimmable = __webpack_require__(1234);
	
	Object.defineProperty(exports, 'DimmerDimmable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DimmerDimmable).default;
	  }
	});
	
	var _Dropdown = __webpack_require__(651);
	
	Object.defineProperty(exports, 'Dropdown', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dropdown).default;
	  }
	});
	
	var _DropdownDivider = __webpack_require__(1236);
	
	Object.defineProperty(exports, 'DropdownDivider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownDivider).default;
	  }
	});
	
	var _DropdownHeader = __webpack_require__(1237);
	
	Object.defineProperty(exports, 'DropdownHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownHeader).default;
	  }
	});
	
	var _DropdownItem = __webpack_require__(1238);
	
	Object.defineProperty(exports, 'DropdownItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownItem).default;
	  }
	});
	
	var _DropdownMenu = __webpack_require__(1239);
	
	Object.defineProperty(exports, 'DropdownMenu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownMenu).default;
	  }
	});
	
	var _DropdownSearchInput = __webpack_require__(1240);
	
	Object.defineProperty(exports, 'DropdownSearchInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownSearchInput).default;
	  }
	});
	
	var _Embed = __webpack_require__(2862);
	
	Object.defineProperty(exports, 'Embed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Embed).default;
	  }
	});
	
	var _Modal = __webpack_require__(1245);
	
	Object.defineProperty(exports, 'Modal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Modal).default;
	  }
	});
	
	var _ModalActions = __webpack_require__(1241);
	
	Object.defineProperty(exports, 'ModalActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalActions).default;
	  }
	});
	
	var _ModalContent = __webpack_require__(1242);
	
	Object.defineProperty(exports, 'ModalContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalContent).default;
	  }
	});
	
	var _ModalDescription = __webpack_require__(1243);
	
	Object.defineProperty(exports, 'ModalDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalDescription).default;
	  }
	});
	
	var _ModalHeader = __webpack_require__(1244);
	
	Object.defineProperty(exports, 'ModalHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalHeader).default;
	  }
	});
	
	var _Popup = __webpack_require__(2865);
	
	Object.defineProperty(exports, 'Popup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Popup).default;
	  }
	});
	
	var _PopupContent = __webpack_require__(1246);
	
	Object.defineProperty(exports, 'PopupContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PopupContent).default;
	  }
	});
	
	var _PopupHeader = __webpack_require__(1247);
	
	Object.defineProperty(exports, 'PopupHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PopupHeader).default;
	  }
	});
	
	var _Progress = __webpack_require__(2867);
	
	Object.defineProperty(exports, 'Progress', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Progress).default;
	  }
	});
	
	var _Rating = __webpack_require__(2869);
	
	Object.defineProperty(exports, 'Rating', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rating).default;
	  }
	});
	
	var _RatingIcon = __webpack_require__(1248);
	
	Object.defineProperty(exports, 'RatingIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RatingIcon).default;
	  }
	});
	
	var _Search = __webpack_require__(2871);
	
	Object.defineProperty(exports, 'Search', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Search).default;
	  }
	});
	
	var _SearchCategory = __webpack_require__(1249);
	
	Object.defineProperty(exports, 'SearchCategory', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchCategory).default;
	  }
	});
	
	var _SearchResult = __webpack_require__(1250);
	
	Object.defineProperty(exports, 'SearchResult', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchResult).default;
	  }
	});
	
	var _SearchResults = __webpack_require__(1251);
	
	Object.defineProperty(exports, 'SearchResults', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchResults).default;
	  }
	});
	
	var _Sidebar = __webpack_require__(2873);
	
	Object.defineProperty(exports, 'Sidebar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sidebar).default;
	  }
	});
	
	var _SidebarPushable = __webpack_require__(1252);
	
	Object.defineProperty(exports, 'SidebarPushable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SidebarPushable).default;
	  }
	});
	
	var _SidebarPusher = __webpack_require__(1253);
	
	Object.defineProperty(exports, 'SidebarPusher', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SidebarPusher).default;
	  }
	});
	
	var _Sticky = __webpack_require__(2875);
	
	Object.defineProperty(exports, 'Sticky', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sticky).default;
	  }
	});
	
	var _Tab = __webpack_require__(2877);
	
	Object.defineProperty(exports, 'Tab', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tab).default;
	  }
	});
	
	var _TabPane = __webpack_require__(1254);
	
	Object.defineProperty(exports, 'TabPane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TabPane).default;
	  }
	});
	
	var _Transition = __webpack_require__(1257);
	
	Object.defineProperty(exports, 'Transition', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Transition).default;
	  }
	});
	
	var _TransitionGroup = __webpack_require__(1256);
	
	Object.defineProperty(exports, 'TransitionGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TransitionGroup).default;
	  }
	});
	
	var _Advertisement = __webpack_require__(2879);
	
	Object.defineProperty(exports, 'Advertisement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Advertisement).default;
	  }
	});
	
	var _Card = __webpack_require__(1258);
	
	Object.defineProperty(exports, 'Card', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Card).default;
	  }
	});
	
	var _CardContent = __webpack_require__(1259);
	
	Object.defineProperty(exports, 'CardContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardContent).default;
	  }
	});
	
	var _CardDescription = __webpack_require__(652);
	
	Object.defineProperty(exports, 'CardDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardDescription).default;
	  }
	});
	
	var _CardGroup = __webpack_require__(1260);
	
	Object.defineProperty(exports, 'CardGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardGroup).default;
	  }
	});
	
	var _CardHeader = __webpack_require__(653);
	
	Object.defineProperty(exports, 'CardHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardHeader).default;
	  }
	});
	
	var _CardMeta = __webpack_require__(654);
	
	Object.defineProperty(exports, 'CardMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardMeta).default;
	  }
	});
	
	var _Comment = __webpack_require__(2881);
	
	Object.defineProperty(exports, 'Comment', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Comment).default;
	  }
	});
	
	var _CommentAction = __webpack_require__(1261);
	
	Object.defineProperty(exports, 'CommentAction', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentAction).default;
	  }
	});
	
	var _CommentActions = __webpack_require__(1262);
	
	Object.defineProperty(exports, 'CommentActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentActions).default;
	  }
	});
	
	var _CommentAuthor = __webpack_require__(1263);
	
	Object.defineProperty(exports, 'CommentAuthor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentAuthor).default;
	  }
	});
	
	var _CommentAvatar = __webpack_require__(1264);
	
	Object.defineProperty(exports, 'CommentAvatar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentAvatar).default;
	  }
	});
	
	var _CommentContent = __webpack_require__(1265);
	
	Object.defineProperty(exports, 'CommentContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentContent).default;
	  }
	});
	
	var _CommentGroup = __webpack_require__(1266);
	
	Object.defineProperty(exports, 'CommentGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentGroup).default;
	  }
	});
	
	var _CommentMetadata = __webpack_require__(1267);
	
	Object.defineProperty(exports, 'CommentMetadata', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentMetadata).default;
	  }
	});
	
	var _CommentText = __webpack_require__(1268);
	
	Object.defineProperty(exports, 'CommentText', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentText).default;
	  }
	});
	
	var _Feed = __webpack_require__(2883);
	
	Object.defineProperty(exports, 'Feed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Feed).default;
	  }
	});
	
	var _FeedContent = __webpack_require__(655);
	
	Object.defineProperty(exports, 'FeedContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedContent).default;
	  }
	});
	
	var _FeedDate = __webpack_require__(419);
	
	Object.defineProperty(exports, 'FeedDate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedDate).default;
	  }
	});
	
	var _FeedEvent = __webpack_require__(1269);
	
	Object.defineProperty(exports, 'FeedEvent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedEvent).default;
	  }
	});
	
	var _FeedExtra = __webpack_require__(656);
	
	Object.defineProperty(exports, 'FeedExtra', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedExtra).default;
	  }
	});
	
	var _FeedLabel = __webpack_require__(657);
	
	Object.defineProperty(exports, 'FeedLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedLabel).default;
	  }
	});
	
	var _FeedLike = __webpack_require__(658);
	
	Object.defineProperty(exports, 'FeedLike', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedLike).default;
	  }
	});
	
	var _FeedMeta = __webpack_require__(659);
	
	Object.defineProperty(exports, 'FeedMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedMeta).default;
	  }
	});
	
	var _FeedSummary = __webpack_require__(660);
	
	Object.defineProperty(exports, 'FeedSummary', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedSummary).default;
	  }
	});
	
	var _FeedUser = __webpack_require__(661);
	
	Object.defineProperty(exports, 'FeedUser', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeedUser).default;
	  }
	});
	
	var _Item = __webpack_require__(2884);
	
	Object.defineProperty(exports, 'Item', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Item).default;
	  }
	});
	
	var _ItemContent = __webpack_require__(1271);
	
	Object.defineProperty(exports, 'ItemContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemContent).default;
	  }
	});
	
	var _ItemDescription = __webpack_require__(662);
	
	Object.defineProperty(exports, 'ItemDescription', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemDescription).default;
	  }
	});
	
	var _ItemExtra = __webpack_require__(663);
	
	Object.defineProperty(exports, 'ItemExtra', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemExtra).default;
	  }
	});
	
	var _ItemGroup = __webpack_require__(1272);
	
	Object.defineProperty(exports, 'ItemGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemGroup).default;
	  }
	});
	
	var _ItemHeader = __webpack_require__(664);
	
	Object.defineProperty(exports, 'ItemHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemHeader).default;
	  }
	});
	
	var _ItemImage = __webpack_require__(1273);
	
	Object.defineProperty(exports, 'ItemImage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemImage).default;
	  }
	});
	
	var _ItemMeta = __webpack_require__(665);
	
	Object.defineProperty(exports, 'ItemMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemMeta).default;
	  }
	});
	
	var _Statistic = __webpack_require__(2885);
	
	Object.defineProperty(exports, 'Statistic', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Statistic).default;
	  }
	});
	
	var _StatisticGroup = __webpack_require__(1275);
	
	Object.defineProperty(exports, 'StatisticGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StatisticGroup).default;
	  }
	});
	
	var _StatisticLabel = __webpack_require__(1276);
	
	Object.defineProperty(exports, 'StatisticLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StatisticLabel).default;
	  }
	});
	
	var _StatisticValue = __webpack_require__(1277);
	
	Object.defineProperty(exports, 'StatisticValue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StatisticValue).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assertString;
	function assertString(input) {
	  if (typeof input !== 'string') {
	    throw new TypeError('This library (validator.js) validates strings only');
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _defaultCopy = __webpack_require__(2266);
	
	var _defaultCopy2 = _interopRequireDefault(_defaultCopy);
	
	var _dyzio = __webpack_require__(2292);
	
	var _dyzio2 = _interopRequireDefault(_dyzio);
	
	var _hitch = __webpack_require__(2307);
	
	var _hitch2 = _interopRequireDefault(_hitch);
	
	var _disrupt = __webpack_require__(2288);
	
	var _disrupt2 = _interopRequireDefault(_disrupt);
	
	var _marshall = __webpack_require__(2319);
	
	var _marshall2 = _interopRequireDefault(_marshall);
	
	var _addfluence = __webpack_require__(2268);
	
	var _addfluence2 = _interopRequireDefault(_addfluence);
	
	var _vizz = __webpack_require__(2365);
	
	var _vizz2 = _interopRequireDefault(_vizz);
	
	var _pgone = __webpack_require__(2334);
	
	var _pgone2 = _interopRequireDefault(_pgone);
	
	var _travlrr = __webpack_require__(2360);
	
	var _travlrr2 = _interopRequireDefault(_travlrr);
	
	var _voxogram = __webpack_require__(2366);
	
	var _voxogram2 = _interopRequireDefault(_voxogram);
	
	var _kin = __webpack_require__(2313);
	
	var _kin2 = _interopRequireDefault(_kin);
	
	var _bmb = __webpack_require__(2275);
	
	var _bmb2 = _interopRequireDefault(_bmb);
	
	var _afterparty = __webpack_require__(2269);
	
	var _afterparty2 = _interopRequireDefault(_afterparty);
	
	var _goblue = __webpack_require__(2305);
	
	var _goblue2 = _interopRequireDefault(_goblue);
	
	var _dorchester = __webpack_require__(2290);
	
	var _dorchester2 = _interopRequireDefault(_dorchester);
	
	var _corq = __webpack_require__(2284);
	
	var _corq2 = _interopRequireDefault(_corq);
	
	var _corqAgency = __webpack_require__(2283);
	
	var _corqAgency2 = _interopRequireDefault(_corqAgency);
	
	var _theInfluencer = __webpack_require__(2355);
	
	var _theInfluencer2 = _interopRequireDefault(_theInfluencer);
	
	var _suforia = __webpack_require__(2349);
	
	var _suforia2 = _interopRequireDefault(_suforia);
	
	var _theroom = __webpack_require__(2358);
	
	var _theroom2 = _interopRequireDefault(_theroom);
	
	var _stylist = __webpack_require__(2348);
	
	var _stylist2 = _interopRequireDefault(_stylist);
	
	var _lacaja = __webpack_require__(2314);
	
	var _lacaja2 = _interopRequireDefault(_lacaja);
	
	var _crowdpointanalytics = __webpack_require__(2285);
	
	var _crowdpointanalytics2 = _interopRequireDefault(_crowdpointanalytics);
	
	var _climateCitizen = __webpack_require__(2282);
	
	var _climateCitizen2 = _interopRequireDefault(_climateCitizen);
	
	var _bds = __webpack_require__(2273);
	
	var _bds2 = _interopRequireDefault(_bds);
	
	var _marmalade = __webpack_require__(2318);
	
	var _marmalade2 = _interopRequireDefault(_marmalade);
	
	var _influxer = __webpack_require__(2310);
	
	var _influxer2 = _interopRequireDefault(_influxer);
	
	var _incast = __webpack_require__(2308);
	
	var _incast2 = _interopRequireDefault(_incast);
	
	var _upload = __webpack_require__(2364);
	
	var _upload2 = _interopRequireDefault(_upload);
	
	var _gifta = __webpack_require__(2302);
	
	var _gifta2 = _interopRequireDefault(_gifta);
	
	var _inspace = __webpack_require__(2311);
	
	var _inspace2 = _interopRequireDefault(_inspace);
	
	var _moi = __webpack_require__(2322);
	
	var _moi2 = _interopRequireDefault(_moi);
	
	var _flyt = __webpack_require__(2299);
	
	var _flyt2 = _interopRequireDefault(_flyt);
	
	var _rightlander = __webpack_require__(2336);
	
	var _rightlander2 = _interopRequireDefault(_rightlander);
	
	var _pulse = __webpack_require__(2335);
	
	var _pulse2 = _interopRequireDefault(_pulse);
	
	var _influxcrowd = __webpack_require__(2309);
	
	var _influxcrowd2 = _interopRequireDefault(_influxcrowd);
	
	var _ntw = __webpack_require__(2330);
	
	var _ntw2 = _interopRequireDefault(_ntw);
	
	var _stardust = __webpack_require__(2347);
	
	var _stardust2 = _interopRequireDefault(_stardust);
	
	var _freefolk = __webpack_require__(2300);
	
	var _freefolk2 = _interopRequireDefault(_freefolk);
	
	var _broadway = __webpack_require__(2278);
	
	var _broadway2 = _interopRequireDefault(_broadway);
	
	var _moonboots = __webpack_require__(2324);
	
	var _moonboots2 = _interopRequireDefault(_moonboots);
	
	var _parentstars = __webpack_require__(2333);
	
	var _parentstars2 = _interopRequireDefault(_parentstars);
	
	var _genfluencer = __webpack_require__(2301);
	
	var _genfluencer2 = _interopRequireDefault(_genfluencer);
	
	var _mingoapp = __webpack_require__(2321);
	
	var _mingoapp2 = _interopRequireDefault(_mingoapp);
	
	var _mecinc = __webpack_require__(2320);
	
	var _mecinc2 = _interopRequireDefault(_mecinc);
	
	var _selectbrity = __webpack_require__(2341);
	
	var _selectbrity2 = _interopRequireDefault(_selectbrity);
	
	var _snackDrawer = __webpack_require__(2345);
	
	var _snackDrawer2 = _interopRequireDefault(_snackDrawer);
	
	var _agent = __webpack_require__(2270);
	
	var _agent2 = _interopRequireDefault(_agent);
	
	var _roomunlocked = __webpack_require__(2338);
	
	var _roomunlocked2 = _interopRequireDefault(_roomunlocked);
	
	var _globalMedia = __webpack_require__(2304);
	
	var _globalMedia2 = _interopRequireDefault(_globalMedia);
	
	var _sendy = __webpack_require__(2342);
	
	var _sendy2 = _interopRequireDefault(_sendy);
	
	var _lineup = __webpack_require__(2316);
	
	var _lineup2 = _interopRequireDefault(_lineup);
	
	var _sweatcoin = __webpack_require__(2350);
	
	var _sweatcoin2 = _interopRequireDefault(_sweatcoin);
	
	var _abbottlyon = __webpack_require__(2267);
	
	var _abbottlyon2 = _interopRequireDefault(_abbottlyon);
	
	var _monumental = __webpack_require__(2323);
	
	var _monumental2 = _interopRequireDefault(_monumental);
	
	var _kemosabe = __webpack_require__(2312);
	
	var _kemosabe2 = _interopRequireDefault(_kemosabe);
	
	var _msqsource = __webpack_require__(2326);
	
	var _msqsource2 = _interopRequireDefault(_msqsource);
	
	var _toptrumps = __webpack_require__(2359);
	
	var _toptrumps2 = _interopRequireDefault(_toptrumps);
	
	var _embellishedlondon = __webpack_require__(2296);
	
	var _embellishedlondon2 = _interopRequireDefault(_embellishedlondon);
	
	var _theinfluenceroom = __webpack_require__(2356);
	
	var _theinfluenceroom2 = _interopRequireDefault(_theinfluenceroom);
	
	var _thenottinghillcompany = __webpack_require__(2357);
	
	var _thenottinghillcompany2 = _interopRequireDefault(_thenottinghillcompany);
	
	var _truestart = __webpack_require__(2361);
	
	var _truestart2 = _interopRequireDefault(_truestart);
	
	var _wefluens = __webpack_require__(2367);
	
	var _wefluens2 = _interopRequireDefault(_wefluens);
	
	var _caffeineBullet = __webpack_require__(2279);
	
	var _caffeineBullet2 = _interopRequireDefault(_caffeineBullet);
	
	var _umbertoGiannini = __webpack_require__(2362);
	
	var _umbertoGiannini2 = _interopRequireDefault(_umbertoGiannini);
	
	var _boldAndGrit = __webpack_require__(2276);
	
	var _boldAndGrit2 = _interopRequireDefault(_boldAndGrit);
	
	var _shopfluence = __webpack_require__(2344);
	
	var _shopfluence2 = _interopRequireDefault(_shopfluence);
	
	var _herbalessentials = __webpack_require__(2306);
	
	var _herbalessentials2 = _interopRequireDefault(_herbalessentials);
	
	var _mothercuppa = __webpack_require__(2325);
	
	var _mothercuppa2 = _interopRequireDefault(_mothercuppa);
	
	var _elsas = __webpack_require__(2295);
	
	var _elsas2 = _interopRequireDefault(_elsas);
	
	var _myota = __webpack_require__(2327);
	
	var _myota2 = _interopRequireDefault(_myota);
	
	var _dogdynamics = __webpack_require__(2289);
	
	var _dogdynamics2 = _interopRequireDefault(_dogdynamics);
	
	var _fiercelondon = __webpack_require__(2298);
	
	var _fiercelondon2 = _interopRequireDefault(_fiercelondon);
	
	var _elemis = __webpack_require__(2294);
	
	var _elemis2 = _interopRequireDefault(_elemis);
	
	var _starbox = __webpack_require__(2346);
	
	var _starbox2 = _interopRequireDefault(_starbox);
	
	var _seho = __webpack_require__(2340);
	
	var _seho2 = _interopRequireDefault(_seho);
	
	var _campfire = __webpack_require__(2280);
	
	var _campfire2 = _interopRequireDefault(_campfire);
	
	var _elemisMain = __webpack_require__(2293);
	
	var _elemisMain2 = _interopRequireDefault(_elemisMain);
	
	var _ripple = __webpack_require__(2337);
	
	var _ripple2 = _interopRequireDefault(_ripple);
	
	var _sandi = __webpack_require__(2339);
	
	var _sandi2 = _interopRequireDefault(_sandi);
	
	var _diso = __webpack_require__(2287);
	
	var _diso2 = _interopRequireDefault(_diso);
	
	var _equi = __webpack_require__(2297);
	
	var _equi2 = _interopRequireDefault(_equi);
	
	var _glaze = __webpack_require__(2303);
	
	var _glaze2 = _interopRequireDefault(_glaze);
	
	var _akara = __webpack_require__(2271);
	
	var _akara2 = _interopRequireDefault(_akara);
	
	var _luna = __webpack_require__(2317);
	
	var _luna2 = _interopRequireDefault(_luna);
	
	var _chubby = __webpack_require__(2281);
	
	var _chubby2 = _interopRequireDefault(_chubby);
	
	var _dreamlab = __webpack_require__(2291);
	
	var _dreamlab2 = _interopRequireDefault(_dreamlab);
	
	var _langton = __webpack_require__(2315);
	
	var _langton2 = _interopRequireDefault(_langton);
	
	var _paddington = __webpack_require__(2331);
	
	var _paddington2 = _interopRequireDefault(_paddington);
	
	var _bornnouli = __webpack_require__(2277);
	
	var _bornnouli2 = _interopRequireDefault(_bornnouli);
	
	var _shellrimula = __webpack_require__(2343);
	
	var _shellrimula2 = _interopRequireDefault(_shellrimula);
	
	var _wildfusion = __webpack_require__(2368);
	
	var _wildfusion2 = _interopRequireDefault(_wildfusion);
	
	var _palome = __webpack_require__(2332);
	
	var _palome2 = _interopRequireDefault(_palome);
	
	var _wren = __webpack_require__(2369);
	
	var _wren2 = _interopRequireDefault(_wren);
	
	var _bevas = __webpack_require__(2274);
	
	var _bevas2 = _interopRequireDefault(_bevas);
	
	var _diem = __webpack_require__(2286);
	
	var _diem2 = _interopRequireDefault(_diem);
	
	var _underarmour = __webpack_require__(2363);
	
	var _underarmour2 = _interopRequireDefault(_underarmour);
	
	var _allwyn = __webpack_require__(2272);
	
	var _allwyn2 = _interopRequireDefault(_allwyn);
	
	var _novai = __webpack_require__(2329);
	
	var _novai2 = _interopRequireDefault(_novai);
	
	var _nlBeauty = __webpack_require__(2328);
	
	var _nlBeauty2 = _interopRequireDefault(_nlBeauty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DOMAIN_THEME_MAP = {
	  'app.hitchesports.com': _hitch2.default,
	  'disrupt.dyzio.co': _disrupt2.default,
	  'marshall.dyzio.co': _marshall2.default,
	  'addfluence.dyzio.co': _addfluence2.default,
	  'vizz.dyzio.co': _vizz2.default,
	  'data.vizz-agency.com': _vizz2.default,
	  'pgone.dyzio.co': _pgone2.default,
	  'travlrr.dyzio.co': _travlrr2.default,
	  'app.voxogram.com': _voxogram2.default,
	  'data.kincommunity.com': _kin2.default,
	  'influencers.goblue42.com': _goblue2.default,
	  'blue42.dyzio.co': _goblue2.default,
	  'bmb.dyzio.co': _bmb2.default,
	  'corq.dyzio.co': _corq2.default,
	  'data.corq.studio': _corq2.default,
	  'creators.corq.studio': _corqAgency2.default,
	  'afterparty.dyzio.co': _afterparty2.default,
	  'creators.dorchestercollection.com': _dorchester2.default,
	  'the-influencer.dyzio.co': _theInfluencer2.default,
	  'data.theinfluencer.es': _theInfluencer2.default,
	  'data.contentclub.es': _theInfluencer2.default,
	  'data.suforia.com': _suforia2.default,
	  'campaigns.theroom.io': _theroom2.default,
	  'campaigns.stylist.co.uk': _stylist2.default,
	  'lacaja.dyzio.co': _lacaja2.default,
	  'cpa.dyzio.co': _crowdpointanalytics2.default,
	  'tracking.crowdpointanalytics.com': _crowdpointanalytics2.default,
	  'climate-citizen.dyzio.co': _climateCitizen2.default,
	  'influencers.climate-citizen.org': _climateCitizen2.default,
	  'bds.dyzio.co': _bds2.default,
	  'brandfluencers.bdsmktg.com': _bds2.default,
	  'marmalade.dyzio.co': _marmalade2.default,
	  'influxer.dyzio.co': _influxer2.default,
	  'creators.influxer.co.uk': _influxer2.default,
	  'incast.dyzio.co': _incast2.default,
	  'influencers.incast.us': _incast2.default,
	  'upload.dyzio.co': _upload2.default,
	  'creators.uploadagency.com': _upload2.default,
	  'gifta.dyzio.co': _gifta2.default,
	  'influencers.gifta.co.uk': _gifta2.default,
	  'influencers.inspace.asia': _inspace2.default,
	  'inspace.dyzio.co': _inspace2.default,
	  'moi.dyzio.co': _moi2.default,
	  'flyt.dyzio.co': _flyt2.default,
	  'influencers.flytexperience.com': _flyt2.default,
	  'rightlander.dyzio.co': _rightlander2.default,
	  'pulse.dyzio.co': _pulse2.default,
	  'influencers.pulse.africa': _pulse2.default,
	  'influxcrowd.dyzio.co': _influxcrowd2.default,
	  'connect.influxcrowd.com': _influxcrowd2.default,
	  'ntw.dyzio.co': _ntw2.default,
	  'stardust.dyzio.co': _stardust2.default,
	  'freefolk.dyzio.co': _freefolk2.default,
	  'collaborations.freefolkagency.com': _freefolk2.default,
	  'collaborations.broadwaysocial.media': _broadway2.default,
	  'campaigns.mymoonboots.io': _moonboots2.default,
	  'broadway.dyzio.co': _broadway2.default,
	  'moonboots.dyzio.co': _moonboots2.default,
	  'parentstars.dyzio.co': _parentstars2.default,
	  'platform.parentstars.co.uk': _parentstars2.default,
	  'creators.genfluencer.io': _genfluencer2.default,
	  'influencers.mingoapp.dk': _mingoapp2.default,
	  'creators.mecinc.gg': _mecinc2.default,
	  'selectbrity.dyzio.co': _selectbrity2.default,
	  'creators.snackdrawer.com': _snackDrawer2.default,
	  'attentionseeker.snackdrawer.com': _snackDrawer2.default,
	  'agent99.dyzio.co': _agent2.default,
	  'creators.roomunlocked.com': _roomunlocked2.default,
	  'creators.global-media.gr': _globalMedia2.default,
	  'senders.sendy.io': _sendy2.default,
	  'lineup.dyzio.co': _lineup2.default,
	  'sweatcoin.dyzio.co': _sweatcoin2.default,
	  'collaborators.abbottlyon.com': _abbottlyon2.default,
	  'abbottlyon.dyzio.co': _abbottlyon2.default,
	  'creators.monumentalmarketing.co.uk': _monumental2.default,
	  'monumental.dyzio.co': _monumental2.default,
	  'kemosabe.dyzio.co': _kemosabe2.default,
	  'msqsource.dyzio.co': _msqsource2.default,
	  'toptrumps.dyzio.co': _toptrumps2.default,
	  'creators.toptrumps.com': _toptrumps2.default,
	  'embellishedlondon.dyzio.co': _embellishedlondon2.default,
	  'creators.embellishedlondon.com': _embellishedlondon2.default,
	  'creators.theinfluenceroom.com': _theinfluenceroom2.default,
	  'thenottinghillcompany.shopfluence.app': _thenottinghillcompany2.default,
	  'truestart.shopfluence.app': _truestart2.default,
	  'creators.wefluens.com': _wefluens2.default,
	  'caffeinebullet.shopfluence.app': _caffeineBullet2.default,
	  'umbertogiannini.shopfluence.app': _umbertoGiannini2.default,
	  'boldandgrit.shopfluence.app': _boldAndGrit2.default,
	  'creators.shopfluence.app': _shopfluence2.default,
	  'herbalessentials.shopfluence.app': _herbalessentials2.default,
	  'mothercuppa.shopfluence.app': _mothercuppa2.default,
	  'elsasorganics.shopfluence.app': _elsas2.default,
	  'myota.shopfluence.app': _myota2.default,
	  'dogdynamics.shopfluence.app': _dogdynamics2.default,
	  'fiercelondon.shopfluence.app': _fiercelondon2.default,
	  'elemis.shopfluence.app': _elemis2.default,
	  'creators.starbox.co.uk': _starbox2.default,
	  'get.seho.app': _seho2.default,
	  'creators.campfire.co.uk': _campfire2.default,
	  'creators.elemis.com': _elemis2.default,
	  'equi.shopfluence.app': _equi2.default,
	  'rippleco.shopfluence.app': _ripple2.default,
	  'ripple.shopfluence.app': _ripple2.default,
	  'sandi.shopfluence.app': _sandi2.default,
	  'diso.shopfluence.app': _diso2.default,
	  'glaze.shopfluence.app': _glaze2.default,
	  'akara.shopfluence.app': _akara2.default,
	  'luna.shopfluence.app': _luna2.default,
	  'chubby.shopfluence.app': _chubby2.default,
	  'bevas.shopfluence.app': _bevas2.default,
	  'diem.shopfluence.app': _diem2.default,
	  'sandi.dyzio.co': _sandi2.default,
	  'm3labscreators.msqpartners.com': _msqsource2.default,
	  'campaigns.langtonpr.com': _langton2.default,
	  'campaigns.dreamlabstudio.co.uk': _dreamlab2.default,
	  'paddington.shopfluence.app': _paddington2.default,
	  'bornnouli.shopfluence.app': _bornnouli2.default,
	  'shellrimula.msqpartners.com': _shellrimula2.default,
	  'influencers.wildfusions.com': _wildfusion2.default,
	  'creators.palome.com': _palome2.default,
	  'wren.dyzio.co': _wren2.default,
	  'underarmour.dyzio.co': _underarmour2.default,
	  'allwyn.dyzio.co': _allwyn2.default,
	  'influencers.novaiinfluencer.ai': _novai2.default,
	  'nlbeauty.shopfluence.app': _nlBeauty2.default
	};
	
	var OVERRIDE = null;
	var NO_OVERRIDE = null;
	var OVERRIDE_THEME =  true ? NO_OVERRIDE : OVERRIDE;
	
	var ThemeSelector = {
	  theme: function theme(themeName) {
	    if (OVERRIDE_THEME) {
	      var _copy = OVERRIDE_THEME ? _extends({}, _defaultCopy2.default, OVERRIDE_THEME.copy) : _defaultCopy2.default;
	      var _theme = _extends({}, OVERRIDE_THEME || _dyzio2.default, {
	        copy: _copy
	      });
	      return _theme;
	    }
	    var hostname = _lodash2.default.toLower(themeName || window.location.hostname);
	    var copy = DOMAIN_THEME_MAP[hostname] ? _extends({}, _defaultCopy2.default, DOMAIN_THEME_MAP[hostname].copy) : _defaultCopy2.default;
	    var theme = _extends({}, DOMAIN_THEME_MAP[hostname] || _dyzio2.default, {
	      copy: copy
	    });
	    return theme;
	  },
	  isWhiteLabel: function isWhiteLabel() {
	    if (OVERRIDE_THEME) return true;
	
	    var labels = _lodash2.default.keys(DOMAIN_THEME_MAP);
	    var hostname = _lodash2.default.toLower(window.location.hostname);
	    return _lodash2.default.includes(labels, hostname);
	  },
	  isFullWhiteLabel: function isFullWhiteLabel() {
	    return _lodash2.default.get(ThemeSelector.theme(), 'isFullWhiteLabel', false);
	  },
	  getAppTitle: function getAppTitle() {
	    return _lodash2.default.get(ThemeSelector.theme(), 'title', 'dyzio');
	  },
	  getTermsAndConditionsLink: function getTermsAndConditionsLink() {
	    var defaultLink = _dyzio2.default.termsAndConditionsLink;
	    return _lodash2.default.get(ThemeSelector.theme(), 'termsAndConditionsLink', defaultLink);
	  },
	  getInfluencerTermsAndConditionsLink: function getInfluencerTermsAndConditionsLink() {
	    var defaultLink = _dyzio2.default.influencerTermsAndConditionsLink;
	    var link = _lodash2.default.get(ThemeSelector.theme(), 'influencerTermsAndConditionsLink', defaultLink);
	    return link;
	  },
	  isOverridden: function isOverridden() {
	    return OVERRIDE !== null;
	  }
	};
	
	exports.default = ThemeSelector;

/***/ },
/* 27 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Static configuration used across application
	var ORGANISATION_OWNER = exports.ORGANISATION_OWNER = 'ORGANISATION_OWNER';
	var ORGANISATION_ADMIN = exports.ORGANISATION_ADMIN = 'ORGANISATION_ADMIN';
	var ORGANISATION_MEMBER = exports.ORGANISATION_MEMBER = 'ORGANISATION_MEMBER';
	
	var CAMPAIGN_OWNER = exports.CAMPAIGN_OWNER = 'CAMPAIGN_OWNER';
	var CAMPAIGN_ADMIN = exports.CAMPAIGN_ADMIN = 'CAMPAIGN_ADMIN';
	var TEAM_MEMBER = exports.TEAM_MEMBER = 'TEAM_MEMBER';
	var CLIENT = exports.CLIENT = 'CLIENT';
	var INFLUENCER = exports.INFLUENCER = 'INFLUENCER';
	var TALENT_AGENT = exports.TALENT_AGENT = 'TALENT_AGENT';
	var PRODUCTION_COMPANY = exports.PRODUCTION_COMPANY = 'PRODUCTION_COMPANY';
	var PARTNER_AGENCY = exports.PARTNER_AGENCY = 'PARTNER_AGENCY';
	
	var DOCUMENT = exports.DOCUMENT = 'DOCUMENT';
	var BRIEF = exports.BRIEF = 'BRIEF';
	var CONTRACT = exports.CONTRACT = 'CONTRACT';
	var DELIVERABLE = exports.DELIVERABLE = 'DELIVERABLE';
	var DELIVERABLE_SET = exports.DELIVERABLE_SET = 'DELIVERABLE_SET';
	var DELIVERABLE_SUBMIT = exports.DELIVERABLE_SUBMIT = 'DELIVERABLE_SUBMIT';
	var SIGNED_CONTRACT = exports.SIGNED_CONTRACT = 'SIGNED_CONTRACT';
	var TRACKED_ASSET = exports.TRACKED_ASSET = 'TRACKED_ASSET';
	var SUPPORTING_FILE = exports.SUPPORTING_FILE = 'SUPPORTING_FILE';
	var ENGAGEMENT_SCORE = exports.ENGAGEMENT_SCORE = 'ENGAGEMENT_SCORE';
	var ELEMIS_REPORT = exports.ELEMIS_REPORT = 'ELEMIS_REPORT';
	
	var FACEBOOK = exports.FACEBOOK = 'FACEBOOK';
	var YOUTUBE = exports.YOUTUBE = 'YOUTUBE';
	var INSTAGRAM = exports.INSTAGRAM = 'INSTAGRAM';
	var TIKTOK = exports.TIKTOK = 'TIKTOK';
	var TWITTER = exports.TWITTER = 'TWITTER';
	var SNAPCHAT = exports.SNAPCHAT = 'SNAPCHAT';
	var TELEGRAM = exports.TELEGRAM = 'TELEGRAM';
	var VK = exports.VK = 'VK';
	
	var VIDEO = exports.VIDEO = 'VIDEO';
	var IMAGE = exports.IMAGE = 'IMAGE';
	var TEXT = exports.TEXT = 'TEXT';
	var BLOG = exports.BLOG = 'BLOG';
	var OTHER = exports.OTHER = 'OTHER';
	
	var ACTIVE = exports.ACTIVE = 'ACTIVE';
	var ARCHIVED = exports.ARCHIVED = 'ARCHIVED';
	
	var ASSIGNED = exports.ASSIGNED = 'ASSIGNED';
	var ADDED = exports.ADDED = 'ADDED';
	var APPROVED = exports.APPROVED = 'APPROVED';
	
	var YOUTUBE_WATCH_URL = exports.YOUTUBE_WATCH_URL = 'https://www.youtube.com/watch?v=';
	
	var DISCUSSION_PAGE = exports.DISCUSSION_PAGE = 'DISCUSSION_PAGE';
	var DELIVERABLE_PAGE = exports.DELIVERABLE_PAGE = 'DELIVERABLE_PAGE';
	
	// File types
	var YOUTUBE_URL = exports.YOUTUBE_URL = 'YOUTUBE_URL';
	var IMAGE_URL = exports.IMAGE_URL = 'IMAGE_URL';
	var FILE_URL = exports.FILE_URL = 'FILE_URL';
	var PDF_URL = exports.PDF_URL = 'PDF_URL';
	var DOC_URL = exports.DOC_URL = 'DOC_URL';
	var EXTERNAL_URL = exports.EXTERNAL_URL = 'EXTERNAL_URL';
	var TEXT_CONTENT = exports.TEXT_CONTENT = 'TEXT_CONTENT';
	
	var ALL = exports.ALL = 'ALL';
	var MILESTONES = exports.MILESTONES = 'MILESTONES';
	var NONE = exports.NONE = 'NONE';
	
	var INSTANTLY = exports.INSTANTLY = 'INSTANTLY';
	var HOURLY = exports.HOURLY = 'HOURLY';
	var DAILY = exports.DAILY = 'DAILY';
	
	var USER = exports.USER = 'USER';
	var CAMPAIGN = exports.CAMPAIGN = 'CAMPAIGN';
	
	var COLLABORATIONS = exports.COLLABORATIONS = 'COLLABORATIONS';
	var ANALYTICS = exports.ANALYTICS = 'ANALYTICS';
	var PAYMENTS = exports.PAYMENTS = 'PAYMENTS';
	var GROUP_CHATS = exports.GROUP_CHATS = 'GROUP_CHATS';
	var NOTIFICATIONS = exports.NOTIFICATIONS = 'NOTIFICATIONS';
	var AUDIT_TRAIL = exports.AUDIT_TRAIL = 'AUDIT_TRAIL';
	
	var SEND_BRIEF_ALL = exports.SEND_BRIEF_ALL = 'SEND_BRIEF_ALL';
	var SEND_DELIVERABLE_ALL = exports.SEND_DELIVERABLE_ALL = 'SEND_DELIVERABLE_ALL';
	var UPLOAD_SUPPORTING_FILE = exports.UPLOAD_SUPPORTING_FILE = 'UPLOAD_SUPPORTING_FILE';
	var LS_PER_PAGE_KEY = exports.LS_PER_PAGE_KEY = 'pp-key';

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(3481);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(3482);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var _isPlaceholder = __webpack_require__(434);
	
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	};


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reportError = reportError;
	exports.reportWarning = reportWarning;
	exports.reportInfo = reportInfo;
	exports.configureRollbarUser = configureRollbarUser;
	exports.configureAppcuesUser = configureAppcuesUser;
	
	var _rollbar = __webpack_require__(1626);
	
	var _rollbar2 = _interopRequireDefault(_rollbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reportError(errorName, error) {
	  if (errorName && error) _rollbar2.default.error(errorName, error);
	}
	
	function reportWarning(warningName, warning) {
	  if (warningName && warning) _rollbar2.default.warning(warningName, warning);
	}
	
	function reportInfo(infoName, info) {
	  if (infoName && info) _rollbar2.default.info(infoName, info);
	}
	
	function configureRollbarUser(userData) {
	  var id = userData.id,
	      username = userData.username,
	      email = userData.email;
	
	  var rollbarConfig = {
	    accessToken: '3affd941e3d0437ea5f446c0a2769419',
	    captureUncaught: true,
	    payload: {
	      environment: window.location.hostname,
	      person: {
	        id: id,
	        username: username,
	        email: email
	      },
	      client: {
	        javascript: {
	          source_map_enabled: true,
	          code_version: 'latest',
	          guess_uncaught_frames: true
	        }
	      }
	    }
	  };
	
	  _rollbar2.default.configure(rollbarConfig);
	}
	
	function configureAppcuesUser(userData) {
	  var id = userData.id,
	      username = userData.username,
	      email = userData.email;
	
	  Appcues.identify(id, {
	    name: username,
	    email: email,
	    created_at: new Date()
	  });
	}

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.20';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(53)(module)))

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.4
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.4',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0'
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, null, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value * power) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp('(' + decimal.suffixes.concat(binary.suffixes).join('|') + ')')
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i)));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            value = value * 100;
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            return numeral._.stringToNumber(string) * 0.01;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DyzioModalHeader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _dyzioButtons = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerStyles = {
	  textCenter: {
	    textAlign: 'center'
	  },
	  description: {
	    fontSize: 13,
	    fontWeight: 'normal',
	    color: 'gray'
	  }
	};
	
	var closeModalIconStyle = {
	  float: 'right',
	  cursor: 'pointer'
	};
	
	var noMarginStyle = {
	  margin: 0
	};
	
	var textCenteredStyle = {
	  textAlign: 'center'
	};
	
	var DyzioModalHeader = exports.DyzioModalHeader = function DyzioModalHeader(_ref) {
	  var headerText = _ref.headerText,
	      onClose = _ref.onClose;
	  return _react2.default.createElement(
	    _semanticUiReact.Modal.Header,
	    { style: headerStyles.textCenter },
	    headerText,
	    _react2.default.createElement(_semanticUiReact.Icon, {
	      name: 'delete',
	      position: 'right',
	      style: closeModalIconStyle,
	      onClick: onClose
	    })
	  );
	};
	
	var DyzioModal = function DyzioModal(props) {
	  var size = props.size,
	      mountNode = props.mountNode,
	      style = props.style,
	      onClose = props.onClose,
	      headerText = props.headerText,
	      headerDescription = props.headerDescription,
	      children = props.children,
	      hasActionButton = props.hasActionButton,
	      actionButtonColor = props.actionButtonColor,
	      hasCloseButton = props.hasCloseButton,
	      actionButtonContent = props.actionButtonContent,
	      actionButtonIcon = props.actionButtonIcon,
	      onActionButtonClick = props.onActionButtonClick,
	      hasFeedbackProvider = props.hasFeedbackProvider,
	      feedbackContent = props.feedbackContent,
	      feedbackIcon = props.feedbackIcon,
	      feedbackType = props.feedbackType,
	      shouldDisableActionButton = props.shouldDisableActionButton,
	      onOpen = props.onOpen;
	
	
	  var withActions = hasActionButton || hasCloseButton;
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      size: size,
	      open: true,
	      mountNode: mountNode,
	      style: style,
	      onClose: onClose,
	      onOpen: onOpen,
	      closeOnEscape: true,
	      closeOnDimmerClick: true
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Header,
	      { style: headerStyles.textCenter },
	      headerText,
	      _react2.default.createElement(_semanticUiReact.Icon, {
	        name: 'delete',
	        position: 'right',
	        style: closeModalIconStyle,
	        onClick: onClose
	      }),
	      headerDescription && _react2.default.createElement(
	        _semanticUiReact.Modal.Description,
	        { style: headerStyles.description },
	        headerDescription
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      children,
	      hasFeedbackProvider && _react2.default.createElement(
	        _semanticUiReact.Modal.Content,
	        { extra: true },
	        _react2.default.createElement(_semanticUiReact.Divider, { fitted: true }),
	        _react2.default.createElement(
	          _semanticUiReact.Message,
	          {
	            info: feedbackType === 'info',
	            warning: feedbackType === 'warning',
	            error: feedbackType === 'error'
	          },
	          feedbackIcon && _react2.default.createElement(_semanticUiReact.Icon, { name: feedbackIcon }),
	          feedbackContent
	        )
	      )
	    ),
	    withActions && _react2.default.createElement(
	      _semanticUiReact.Modal.Actions,
	      { style: hasCloseButton ? textCenteredStyle : null },
	      hasActionButton && _react2.default.createElement(_dyzioButtons.DyzioModalActionButton, {
	        label: actionButtonContent,
	        onClick: onActionButtonClick,
	        style: noMarginStyle,
	        fluid: !hasCloseButton,
	        color: actionButtonColor,
	        hasIcon: true,
	        icon: actionButtonIcon,
	        disabled: shouldDisableActionButton
	      }),
	      hasCloseButton && _react2.default.createElement(_dyzioButtons.DyzioCancelButton, {
	        label: _react2.default.createElement(
	          'span',
	          null,
	          'Close'
	        ),
	        onClick: onClose,
	        color: 'grey',
	        floated: null,
	        icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'close' }),
	        hasIcon: true
	      })
	    )
	  );
	};
	
	DyzioModal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  headerText: _propTypes2.default.string.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  hasActionButton: _propTypes2.default.bool,
	  hasFeedbackProvider: _propTypes2.default.bool,
	  shouldDisableActionButton: _propTypes2.default.bool,
	  mountNode: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  size: _propTypes2.default.string,
	  actionButtonColor: _propTypes2.default.string,
	  actionButtonIcon: _propTypes2.default.any,
	  actionButtonContent: _propTypes2.default.any
	};
	
	DyzioModal.defaultProps = {
	  mountNode: typeof document !== 'undefined' && document.body,
	  style: {},
	  hasFeedbackProvider: false,
	  hasActionButton: false,
	  shouldDisableActionButton: false,
	  size: 'large',
	  actionButtonColor: 'pink'
	};
	
	exports.default = DyzioModal;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _curry2 = __webpack_require__(13);
	var _isPlaceholder = __webpack_require__(434);
	
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3
	             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
	             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _curry1(function(_c) { return fn(a, b, _c); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
	             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
	             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
	             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
	             : fn(a, b, c);
	    }
	  };
	};


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(183);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(741);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(262);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(3500);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(1557);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(3494);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(3513);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(3495);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(3496);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(1558);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(3498);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(3493);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(3497);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(3499);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(3512);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(465);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(3501);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(3510);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(1563);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(3503);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(3504);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(3508);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(1560);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TargetLink = function TargetLink(props) {
	  if (!props.renderIf) return _react2.default.createElement(
	    'div',
	    null,
	    props.children
	  );
	
	  return _react2.default.createElement(
	    'a',
	    {
	      style: props.style,
	      href: props.href,
	      target: props.target,
	      rel: 'noopener noreferrer'
	    },
	    props.children
	  );
	};
	
	TargetLink.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  href: _propTypes2.default.string.isRequired,
	  renderIf: _propTypes2.default.bool.isRequired,
	  target: _propTypes2.default.string,
	  style: _propTypes2.default.object
	};
	
	TargetLink.defaultProps = {
	  target: '_blank',
	  style: {}
	};
	
	exports.default = TargetLink;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /*
		     * Local polyfil of Object.create
		     */
		    var create = Object.create || (function () {
		        function F() {};
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;
	
		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });
	
		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);
	
		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hasJSONAPIClient = function hasJSONAPIClient(WrapperComponent) {
	  return function (_Component) {
	    _inherits(HasJSONAPIClient, _Component);
	
	    function HasJSONAPIClient(props) {
	      _classCallCheck(this, HasJSONAPIClient);
	
	      var _this = _possibleConstructorReturn(this, (HasJSONAPIClient.__proto__ || Object.getPrototypeOf(HasJSONAPIClient)).call(this, props));
	
	      _this.jsonAPIClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	        header: {
	          Authorization: 'Bearer ' + _authService.authService.getToken()
	        }
	      });
	      return _this;
	    }
	
	    _createClass(HasJSONAPIClient, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, { jsonAPIClient: this.jsonAPIClient }));
	      }
	    }]);
	
	    return HasJSONAPIClient;
	  }(_react.Component);
	};
	
	exports.default = hasJSONAPIClient;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(110);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 42 */
[4445, 1727, 185, 519],
/* 43 */
[4445, 984, 177, 403],
/* 44 */
[4393, 2621, 177],
/* 45 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 46 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 48 */
[4393, 3908, 185],
/* 49 */
47,
/* 50 */
/***/ function(module, exports) {

	/**
	 * The default argument placeholder value for methods.
	 *
	 * @type {Object}
	 */
	module.exports = {};


/***/ },
/* 51 */
[4365, 2732, 2734],
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAssetPublishedDateMessage = exports.getAssetType = exports.formatAssetPublishedData = undefined;
	exports.commaFormatted = commaFormatted;
	exports.percentFormatted = percentFormatted;
	exports.percentFormatted1dp = percentFormatted1dp;
	exports.countFormat = countFormat;
	exports.ierFormat = ierFormat;
	exports.ierFormat2DP = ierFormat2DP;
	exports.priceFormatted = priceFormatted;
	exports.emvTotalPriceFormatted = emvTotalPriceFormatted;
	exports.scientificFormatted = scientificFormatted;
	exports.paidReportFormat = paidReportFormat;
	exports.getGraphLabelFormatting = getGraphLabelFormatting;
	exports.getGraphLabelPercentageFormatting = getGraphLabelPercentageFormatting;
	exports.sciFormatted = sciFormatted;
	
	var _numeral = __webpack_require__(152);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatAssetPublishedData = exports.formatAssetPublishedData = function formatAssetPublishedData(post) {
	  var publishedDate = _lodash2.default.get(post.trackedAsset, 'publishedDate', null) || post.publishedDate;
	  return (0, _moment2.default)(publishedDate).format('YYYY-MM-DD');
	};
	
	var getAssetType = exports.getAssetType = function getAssetType(post) {
	  if (post.isIGTV) return 'IGTV';
	  if (post.isReel) return 'REEL';
	  if (post.isVideo || _lodash2.default.get(post, 'trackedAsset.assetType', '') === 'VIDEO') return 'video';
	  if (post.isCarousel || _lodash2.default.get(post, 'trackedAsset.assetType', '') === 'CAROUSEL') return 'carousel';
	  if (post.type === 'stories' || post.isStory || _lodash2.default.get(post, 'trackedAsset.assetType', '') === 'STORY') return 'story';
	  if (_lodash2.default.get(post, 'assetType') === 'TEXT') return 'post';
	
	  return 'image';
	};
	
	var TELEGRAM = 'TELEGRAM';
	
	var getPlatform = function getPlatform(post, isTelegram) {
	  if (isTelegram) return TELEGRAM;
	  return post.trackedAsset ? _lodash2.default.get(post, 'trackedAsset.platform') : _lodash2.default.get(post, 'platform');
	};
	
	var getAssetPublishedDateMessage = exports.getAssetPublishedDateMessage = function getAssetPublishedDateMessage(post) {
	  var isTelegram = post.assetURL && post.assetURL.match(/\/\/t.me\//i);
	  var DEFAULT_PLATFORM = 'Instagram';
	  var platform = getPlatform(post, isTelegram);
	  var assetType = isTelegram ? 'message' : getAssetType(post);
	  var date = post.trackedAsset ? post.trackedAsset.publishedDate : post.publishedDate;
	  var msg = _lodash2.default.capitalize(platform || DEFAULT_PLATFORM) + ' ' + assetType + ' ';
	  msg += 'posted at ' + (0, _moment2.default)(date).format('LT') + ' on ' + formatAssetPublishedData(post);
	  return msg;
	};
	
	function commaFormatted(number) {
	  var de = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	  return number ? (0, _numeral2.default)(number).format('0,0') : de;
	}
	
	function percentFormatted(number) {
	  return (0, _numeral2.default)(number).format('0.00');
	}
	
	function percentFormatted1dp(number) {
	  return (0, _numeral2.default)(number).format('0.0');
	}
	
	function countFormat() {
	  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  var numberFormat = number > 1000000 ? '0.0a' : '0a';
	  return (0, _numeral2.default)(number).format(numberFormat);
	}
	
	function ierFormat(num) {
	  return (0, _numeral2.default)(num).format('0.0');
	}
	
	function ierFormat2DP(num) {
	  return (0, _numeral2.default)(num).format('0.00');
	}
	
	function priceFormatted(number) {
	  return (0, _numeral2.default)(number).format('0,0[.]00');
	}
	
	function emvTotalPriceFormatted(number) {
	  return (0, _numeral2.default)(number).format('0,0');
	}
	
	function scientificFormatted(number) {
	  var format = number > 1000000 ? '0.00a' : '0.0a';
	  return (0, _numeral2.default)(number).format(format);
	}
	
	function paidReportFormat(number) {
	  if (!number) return '-';
	  var format = number > 1000000 || number < 100000 && number > 1000 ? '0.0a' : '0,0a';
	  return (0, _numeral2.default)(number).format(format);
	}
	
	function getGraphLabelFormatting(tooltipItem, data) {
	  var label = data.labels[tooltipItem.index];
	  var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	  return label + ' - ' + commaFormatted(datasetLabel);
	}
	
	function getGraphLabelPercentageFormatting(tooltipItem, data) {
	  var label = data.labels[tooltipItem.index];
	  var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	  return label + ' - ' + commaFormatted(datasetLabel) + ' %';
	}
	
	function sciFormatted(number) {
	  var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	
	  if (!number) return def;
	  var format = number > 1000 ? '0.0a' : '0';
	  format = number > 1000000 ? '0.0a' : format;
	  return (0, _numeral2.default)(number).format(format);
	}

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1619)

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;
	
	var _runSaga = __webpack_require__(3784);
	
	Object.defineProperty(exports, 'runSaga', {
	  enumerable: true,
	  get: function get() {
	    return _runSaga.runSaga;
	  }
	});
	
	var _channel = __webpack_require__(486);
	
	Object.defineProperty(exports, 'END', {
	  enumerable: true,
	  get: function get() {
	    return _channel.END;
	  }
	});
	Object.defineProperty(exports, 'eventChannel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.eventChannel;
	  }
	});
	Object.defineProperty(exports, 'channel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.channel;
	  }
	});
	
	var _buffers = __webpack_require__(485);
	
	Object.defineProperty(exports, 'buffers', {
	  enumerable: true,
	  get: function get() {
	    return _buffers.buffers;
	  }
	});
	
	var _sagaHelpers = __webpack_require__(3785);
	
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.throttle;
	  }
	});
	
	var _utils = __webpack_require__(160);
	
	Object.defineProperty(exports, 'delay', {
	  enumerable: true,
	  get: function get() {
	    return _utils.delay;
	  }
	});
	Object.defineProperty(exports, 'CANCEL', {
	  enumerable: true,
	  get: function get() {
	    return _utils.CANCEL;
	  }
	});
	
	var _middleware = __webpack_require__(3783);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	var _effects = __webpack_require__(1619);
	
	var effects = _interopRequireWildcard(_effects);
	
	var _utils2 = __webpack_require__(3786);
	
	var utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _middleware2.default;
	exports.effects = effects;
	exports.utils = utils;

/***/ },
/* 56 */
50,
/* 57 */
[4365, 4023, 4025],
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(941)
	var ieee754 = __webpack_require__(2934)
	var isArray = __webpack_require__(2943)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58).Buffer, (function() { return this; }())))

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var DOMProperty = __webpack_require__(260);
	var ReactDOMComponentFlags = __webpack_require__(1508);
	
	var invariant = __webpack_require__(36);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/* @flow weak */
	"use strict";
	var Client = module.exports = function(path, auth, options) {
	  if (!path) {
	    throw new Error("API path is needed to construct an instanceof jsonapi-client");
	  }
	  auth = auth || { };
	  options = options || {};
	  
	  this._construct(path, auth, options);
	};
	
	if (typeof window !== "undefined") {
	  window.JsonapiClient = Client; // eslint-disable-line
	}
	
	var Promise = __webpack_require__(839);
	// Promise.denodeify = function(a) { return a; };
	var Resource = __webpack_require__(1805);
	Client.Resource = Resource;
	var Transport = __webpack_require__(1806);
	var createResourceCache = __webpack_require__(1807);
	
	Client.prototype._construct = function(path, auth, options) {
	  this._resourceCache = createResourceCache(options);
	  this._transport = new Transport(path, auth);
	};
	
	Client.prototype.find = Promise.denodeify(function(type, options, callback) {
	  var self = this;
	
	  if (typeof options === "function") {
	    callback = options;
	    options = { };
	  }
	
	  this._transport.search(type, options, function(err, rawResponse, rawResources, rawIncludes) {
	    if (err) return callback(err);
	
	    var resources = rawResources.map(function(someRawResource) {
	      return new Resource(someRawResource, self);
	    });
	    if (rawIncludes) {
	      rawIncludes.forEach(function(someRawResource) {
	        return new Resource(someRawResource, self);
	      });
	    }
	
	    return callback(null, resources);
	  });
	});
	
	Client.prototype.get = Promise.denodeify(function(type, id, options, callback) {
	  var self = this;
	
	  if (typeof options === "function") {
	    callback = options;
	    options = { };
	  }
	
	  this._transport.find(type, id, options, function(err, rawResponse, rawResource, rawIncludes) {
	    if (err) return callback(err);
	
	    var resource = new Resource(rawResource, self);
	    if (rawIncludes) {
	      rawIncludes.forEach(function(someRawResource) {
	        return new Resource(someRawResource, self);
	      });
	    }
	
	    return callback(null, resource);
	  });
	});
	
	Client.prototype._getRelated = function(resource, relation, options, callback) {
	  var self = this;
	  this._transport.fetch(resource, relation, options, function(err, rawResponse, rawResources, rawIncludes) {
	    if (err) return callback(err);
	
	    if (rawIncludes) {
	      rawIncludes.forEach(function(someRawResource) {
	        return new Resource(someRawResource, self);
	      });
	    }
	
	    if (!(rawResources instanceof Array)) {
	      var rawResource = new Resource(rawResources, self);
	      return callback(null, rawResource);
	    }
	
	    var resources = rawResources.map(function(someRawResource) {
	      return new Resource(someRawResource, self);
	    });
	
	    return callback(null, resources);
	  });
	};
	
	Client.prototype.create = function(type, properties) {
	  var newResource = new Resource({
	    id: null,
	    type: type,
	    attributes: properties || { },
	    relationships: { }
	  }, this);
	  return newResource;
	};
	
	Client.prototype._remoteCreate = function(resource, callback) {
	  this._transport.create(resource, callback);
	};
	
	Client.prototype._update = function(resource, callback) {
	  this._transport.update(resource, callback);
	};
	
	Client.prototype._delete = function(resource, callback) {
	  this._transport.delete(resource, callback);
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scientificFormat = scientificFormat;
	exports.commaFormatted = commaFormatted;
	exports.ierFormat = ierFormat;
	exports.countFormat = countFormat;
	exports.formatNumberWithPercentage = formatNumberWithPercentage;
	exports.ierFormat2DP = ierFormat2DP;
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scientificFormat(number) {
	  return number && (0, _numeral2.default)(number).format('0a') || '-';
	}
	
	function commaFormatted(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	}
	
	function ierFormat(num) {
	  return (0, _numeral2.default)(num).format('0.0');
	}
	
	function countFormat() {
	  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  var numberFormat = number > 1000000 ? '0.0a' : '0a';
	  return (0, _numeral2.default)(number).format(numberFormat);
	}
	
	function formatNumberWithPercentage(numerator, denominator) {
	  if (!numerator) return '0%';
	  var percentage = numerator / denominator;
	  return percentage < 0.01 ? '<0.1%' : (0, _numeral2.default)(percentage).format('0.0%');
	}
	
	function ierFormat2DP(num) {
	  return (0, _numeral2.default)(num).format('0.00');
	}

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(2396);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 64 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(180);
	var _isTransformer = __webpack_require__(692);
	
	
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with one of the given method names, it will
	 * execute that function (functor case). Otherwise, if it is a transformer,
	 * uses transducer [xf] to return a new transformer (transducer case).
	 * Otherwise, it will default to executing [fn].
	 *
	 * @private
	 * @param {Array} methodNames properties to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	module.exports = function _dispatchable(methodNames, xf, fn) {
	  return function() {
	    if (arguments.length === 0) {
	      return fn();
	    }
	    var args = Array.prototype.slice.call(arguments, 0);
	    var obj = args.pop();
	    if (!_isArray(obj)) {
	      var idx = 0;
	      while (idx < methodNames.length) {
	        if (typeof obj[methodNames[idx]] === 'function') {
	          return obj[methodNames[idx]].apply(obj, args);
	        }
	        idx += 1;
	      }
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	    return fn.apply(this, arguments);
	  };
	};


/***/ },
/* 66 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 67 */
/***/ function(module, exports) {

	module.exports = {
	  init: function() {
	    return this.xf['@@transducer/init']();
	  },
	  result: function(result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(199));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./evpkdf"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Cipher core components.
		 */
		CryptoJS.lib.Cipher || (function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var Base64 = C_enc.Base64;
		    var C_algo = C.algo;
		    var EvpKDF = C_algo.EvpKDF;
	
		    /**
		     * Abstract base cipher template.
		     *
		     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
		     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
		     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
		     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
		     */
		    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {WordArray} iv The IV to use for this operation.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Creates this cipher in encryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
		         */
		        createEncryptor: function (key, cfg) {
		            return this.create(this._ENC_XFORM_MODE, key, cfg);
		        },
	
		        /**
		         * Creates this cipher in decryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
		         */
		        createDecryptor: function (key, cfg) {
		            return this.create(this._DEC_XFORM_MODE, key, cfg);
		        },
	
		        /**
		         * Initializes a newly created cipher.
		         *
		         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
		         */
		        init: function (xformMode, key, cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Store transform mode and key
		            this._xformMode = xformMode;
		            this._key = key;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this cipher to its initial state.
		         *
		         * @example
		         *
		         *     cipher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-cipher logic
		            this._doReset();
		        },
	
		        /**
		         * Adds data to be encrypted or decrypted.
		         *
		         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.process('data');
		         *     var encrypted = cipher.process(wordArray);
		         */
		        process: function (dataUpdate) {
		            // Append
		            this._append(dataUpdate);
	
		            // Process available blocks
		            return this._process();
		        },
	
		        /**
		         * Finalizes the encryption or decryption process.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after final processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.finalize();
		         *     var encrypted = cipher.finalize('data');
		         *     var encrypted = cipher.finalize(wordArray);
		         */
		        finalize: function (dataUpdate) {
		            // Final data update
		            if (dataUpdate) {
		                this._append(dataUpdate);
		            }
	
		            // Perform concrete-cipher logic
		            var finalProcessedData = this._doFinalize();
	
		            return finalProcessedData;
		        },
	
		        keySize: 128/32,
	
		        ivSize: 128/32,
	
		        _ENC_XFORM_MODE: 1,
	
		        _DEC_XFORM_MODE: 2,
	
		        /**
		         * Creates shortcut functions to a cipher's object interface.
		         *
		         * @param {Cipher} cipher The cipher to create a helper for.
		         *
		         * @return {Object} An object with encrypt and decrypt shortcut functions.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
		         */
		        _createHelper: (function () {
		            function selectCipherStrategy(key) {
		                if (typeof key == 'string') {
		                    return PasswordBasedCipher;
		                } else {
		                    return SerializableCipher;
		                }
		            }
	
		            return function (cipher) {
		                return {
		                    encrypt: function (message, key, cfg) {
		                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
		                    },
	
		                    decrypt: function (ciphertext, key, cfg) {
		                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
		                    }
		                };
		            };
		        }())
		    });
	
		    /**
		     * Abstract base stream cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
		     */
		    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
		        _doFinalize: function () {
		            // Process partial blocks
		            var finalProcessedBlocks = this._process(!!'flush');
	
		            return finalProcessedBlocks;
		        },
	
		        blockSize: 1
		    });
	
		    /**
		     * Mode namespace.
		     */
		    var C_mode = C.mode = {};
	
		    /**
		     * Abstract base block cipher mode template.
		     */
		    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
		        /**
		         * Creates this mode for encryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
		         */
		        createEncryptor: function (cipher, iv) {
		            return this.Encryptor.create(cipher, iv);
		        },
	
		        /**
		         * Creates this mode for decryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
		         */
		        createDecryptor: function (cipher, iv) {
		            return this.Decryptor.create(cipher, iv);
		        },
	
		        /**
		         * Initializes a newly created mode.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
		         */
		        init: function (cipher, iv) {
		            this._cipher = cipher;
		            this._iv = iv;
		        }
		    });
	
		    /**
		     * Cipher Block Chaining mode.
		     */
		    var CBC = C_mode.CBC = (function () {
		        /**
		         * Abstract base CBC mode.
		         */
		        var CBC = BlockCipherMode.extend();
	
		        /**
		         * CBC encryptor.
		         */
		        CBC.Encryptor = CBC.extend({
		            /**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */
		            processBlock: function (words, offset) {
		                // Shortcuts
		                var cipher = this._cipher;
		                var blockSize = cipher.blockSize;
	
		                // XOR and encrypt
		                xorBlock.call(this, words, offset, blockSize);
		                cipher.encryptBlock(words, offset);
	
		                // Remember this block to use with next block
		                this._prevBlock = words.slice(offset, offset + blockSize);
		            }
		        });
	
		        /**
		         * CBC decryptor.
		         */
		        CBC.Decryptor = CBC.extend({
		            /**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */
		            processBlock: function (words, offset) {
		                // Shortcuts
		                var cipher = this._cipher;
		                var blockSize = cipher.blockSize;
	
		                // Remember this block to use with next block
		                var thisBlock = words.slice(offset, offset + blockSize);
	
		                // Decrypt and XOR
		                cipher.decryptBlock(words, offset);
		                xorBlock.call(this, words, offset, blockSize);
	
		                // This block becomes the previous block
		                this._prevBlock = thisBlock;
		            }
		        });
	
		        function xorBlock(words, offset, blockSize) {
		            // Shortcut
		            var iv = this._iv;
	
		            // Choose mixing block
		            if (iv) {
		                var block = iv;
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            } else {
		                var block = this._prevBlock;
		            }
	
		            // XOR blocks
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= block[i];
		            }
		        }
	
		        return CBC;
		    }());
	
		    /**
		     * Padding namespace.
		     */
		    var C_pad = C.pad = {};
	
		    /**
		     * PKCS #5/7 padding strategy.
		     */
		    var Pkcs7 = C_pad.Pkcs7 = {
		        /**
		         * Pads data using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to pad.
		         * @param {number} blockSize The multiple that the data should be padded to.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
		         */
		        pad: function (data, blockSize) {
		            // Shortcut
		            var blockSizeBytes = blockSize * 4;
	
		            // Count padding bytes
		            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
		            // Create padding word
		            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;
	
		            // Create padding
		            var paddingWords = [];
		            for (var i = 0; i < nPaddingBytes; i += 4) {
		                paddingWords.push(paddingWord);
		            }
		            var padding = WordArray.create(paddingWords, nPaddingBytes);
	
		            // Add padding
		            data.concat(padding);
		        },
	
		        /**
		         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to unpad.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
		         */
		        unpad: function (data) {
		            // Get number of padding bytes from last byte
		            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		            // Remove padding
		            data.sigBytes -= nPaddingBytes;
		        }
		    };
	
		    /**
		     * Abstract base block cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
		     */
		    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {Mode} mode The block mode to use. Default: CBC
		         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
		         */
		        cfg: Cipher.cfg.extend({
		            mode: CBC,
		            padding: Pkcs7
		        }),
	
		        reset: function () {
		            // Reset cipher
		            Cipher.reset.call(this);
	
		            // Shortcuts
		            var cfg = this.cfg;
		            var iv = cfg.iv;
		            var mode = cfg.mode;
	
		            // Reset block mode
		            if (this._xformMode == this._ENC_XFORM_MODE) {
		                var modeCreator = mode.createEncryptor;
		            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
		                var modeCreator = mode.createDecryptor;
		                // Keep at least one block in the buffer for unpadding
		                this._minBufferSize = 1;
		            }
	
		            if (this._mode && this._mode.__creator == modeCreator) {
		                this._mode.init(this, iv && iv.words);
		            } else {
		                this._mode = modeCreator.call(mode, this, iv && iv.words);
		                this._mode.__creator = modeCreator;
		            }
		        },
	
		        _doProcessBlock: function (words, offset) {
		            this._mode.processBlock(words, offset);
		        },
	
		        _doFinalize: function () {
		            // Shortcut
		            var padding = this.cfg.padding;
	
		            // Finalize
		            if (this._xformMode == this._ENC_XFORM_MODE) {
		                // Pad data
		                padding.pad(this._data, this.blockSize);
	
		                // Process final blocks
		                var finalProcessedBlocks = this._process(!!'flush');
		            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
		                // Process final blocks
		                var finalProcessedBlocks = this._process(!!'flush');
	
		                // Unpad data
		                padding.unpad(finalProcessedBlocks);
		            }
	
		            return finalProcessedBlocks;
		        },
	
		        blockSize: 128/32
		    });
	
		    /**
		     * A collection of cipher parameters.
		     *
		     * @property {WordArray} ciphertext The raw ciphertext.
		     * @property {WordArray} key The key to this ciphertext.
		     * @property {WordArray} iv The IV used in the ciphering operation.
		     * @property {WordArray} salt The salt used with a key derivation function.
		     * @property {Cipher} algorithm The cipher algorithm.
		     * @property {Mode} mode The block mode used in the ciphering operation.
		     * @property {Padding} padding The padding scheme used in the ciphering operation.
		     * @property {number} blockSize The block size of the cipher.
		     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
		     */
		    var CipherParams = C_lib.CipherParams = Base.extend({
		        /**
		         * Initializes a newly created cipher params object.
		         *
		         * @param {Object} cipherParams An object with any of the possible cipher parameters.
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.lib.CipherParams.create({
		         *         ciphertext: ciphertextWordArray,
		         *         key: keyWordArray,
		         *         iv: ivWordArray,
		         *         salt: saltWordArray,
		         *         algorithm: CryptoJS.algo.AES,
		         *         mode: CryptoJS.mode.CBC,
		         *         padding: CryptoJS.pad.PKCS7,
		         *         blockSize: 4,
		         *         formatter: CryptoJS.format.OpenSSL
		         *     });
		         */
		        init: function (cipherParams) {
		            this.mixIn(cipherParams);
		        },
	
		        /**
		         * Converts this cipher params object to a string.
		         *
		         * @param {Format} formatter (Optional) The formatting strategy to use.
		         *
		         * @return {string} The stringified cipher params.
		         *
		         * @throws Error If neither the formatter nor the default formatter is set.
		         *
		         * @example
		         *
		         *     var string = cipherParams + '';
		         *     var string = cipherParams.toString();
		         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
		         */
		        toString: function (formatter) {
		            return (formatter || this.formatter).stringify(this);
		        }
		    });
	
		    /**
		     * Format namespace.
		     */
		    var C_format = C.format = {};
	
		    /**
		     * OpenSSL formatting strategy.
		     */
		    var OpenSSLFormatter = C_format.OpenSSL = {
		        /**
		         * Converts a cipher params object to an OpenSSL-compatible string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The OpenSSL-compatible string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
		         */
		        stringify: function (cipherParams) {
		            // Shortcuts
		            var ciphertext = cipherParams.ciphertext;
		            var salt = cipherParams.salt;
	
		            // Format
		            if (salt) {
		                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
		            } else {
		                var wordArray = ciphertext;
		            }
	
		            return wordArray.toString(Base64);
		        },
	
		        /**
		         * Converts an OpenSSL-compatible string to a cipher params object.
		         *
		         * @param {string} openSSLStr The OpenSSL-compatible string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
		         */
		        parse: function (openSSLStr) {
		            // Parse base64
		            var ciphertext = Base64.parse(openSSLStr);
	
		            // Shortcut
		            var ciphertextWords = ciphertext.words;
	
		            // Test for salt
		            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
		                // Extract salt
		                var salt = WordArray.create(ciphertextWords.slice(2, 4));
	
		                // Remove salt from ciphertext
		                ciphertextWords.splice(0, 4);
		                ciphertext.sigBytes -= 16;
		            }
	
		            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
		        }
		    };
	
		    /**
		     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
		     */
		    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
		         */
		        cfg: Base.extend({
		            format: OpenSSLFormatter
		        }),
	
		        /**
		         * Encrypts a message.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */
		        encrypt: function (cipher, message, key, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Encrypt
		            var encryptor = cipher.createEncryptor(key, cfg);
		            var ciphertext = encryptor.finalize(message);
	
		            // Shortcut
		            var cipherCfg = encryptor.cfg;
	
		            // Create and return serializable cipher params
		            return CipherParams.create({
		                ciphertext: ciphertext,
		                key: key,
		                iv: cipherCfg.iv,
		                algorithm: cipher,
		                mode: cipherCfg.mode,
		                padding: cipherCfg.padding,
		                blockSize: cipher.blockSize,
		                formatter: cfg.format
		            });
		        },
	
		        /**
		         * Decrypts serialized ciphertext.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */
		        decrypt: function (cipher, ciphertext, key, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Convert string to CipherParams
		            ciphertext = this._parse(ciphertext, cfg.format);
	
		            // Decrypt
		            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
	
		            return plaintext;
		        },
	
		        /**
		         * Converts serialized ciphertext to CipherParams,
		         * else assumed CipherParams already and returns ciphertext unchanged.
		         *
		         * @param {CipherParams|string} ciphertext The ciphertext.
		         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
		         *
		         * @return {CipherParams} The unserialized ciphertext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
		         */
		        _parse: function (ciphertext, format) {
		            if (typeof ciphertext == 'string') {
		                return format.parse(ciphertext, this);
		            } else {
		                return ciphertext;
		            }
		        }
		    });
	
		    /**
		     * Key derivation function namespace.
		     */
		    var C_kdf = C.kdf = {};
	
		    /**
		     * OpenSSL key derivation function.
		     */
		    var OpenSSLKdf = C_kdf.OpenSSL = {
		        /**
		         * Derives a key and IV from a password.
		         *
		         * @param {string} password The password to derive from.
		         * @param {number} keySize The size in words of the key to generate.
		         * @param {number} ivSize The size in words of the IV to generate.
		         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
		         *
		         * @return {CipherParams} A cipher params object with the key, IV, and salt.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
		         */
		        execute: function (password, keySize, ivSize, salt) {
		            // Generate random salt
		            if (!salt) {
		                salt = WordArray.random(64/8);
		            }
	
		            // Derive key and IV
		            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);
	
		            // Separate key and IV
		            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
		            key.sigBytes = keySize * 4;
	
		            // Return params
		            return CipherParams.create({ key: key, iv: iv, salt: salt });
		        }
		    };
	
		    /**
		     * A serializable cipher wrapper that derives the key from a password,
		     * and returns ciphertext as a serializable cipher params object.
		     */
		    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
		         */
		        cfg: SerializableCipher.cfg.extend({
		            kdf: OpenSSLKdf
		        }),
	
		        /**
		         * Encrypts a message using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
		         */
		        encrypt: function (cipher, message, password, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Derive key and other params
		            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);
	
		            // Add IV to config
		            cfg.iv = derivedParams.iv;
	
		            // Encrypt
		            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
	
		            // Mix in derived params
		            ciphertext.mixIn(derivedParams);
	
		            return ciphertext;
		        },
	
		        /**
		         * Decrypts serialized ciphertext using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
		         */
		        decrypt: function (cipher, ciphertext, password, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Convert string to CipherParams
		            ciphertext = this._parse(ciphertext, cfg.format);
	
		            // Derive key and other params
		            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);
	
		            // Add IV to config
		            cfg.iv = derivedParams.iv;
	
		            // Decrypt
		            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
	
		            return plaintext;
		        }
		    });
		}());
	
	
	}));

/***/ },
/* 69 */
[4415, 148, 95, 987, 47],
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(3514);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3654);


/***/ },
/* 72 */
[4415, 162, 114, 1730, 49],
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DyzioDeleteButton = exports.DyzioModalActionButton = exports.DyzioCancelButton = exports.DyzioSecondaryButton = exports.DyzioPrimaryButton = undefined;
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DyzioPrimaryButton = exports.DyzioPrimaryButton = function DyzioPrimaryButton(props) {
	  var fluid = props.fluid,
	      label = props.label,
	      hasIcon = props.hasIcon,
	      floated = props.floated,
	      loading = props.loading,
	      icon = props.icon,
	      onClick = props.onClick,
	      size = props.size,
	      style = props.style,
	      color = props.color,
	      disabled = props.disabled,
	      labelPosition = props.labelPosition;
	
	
	  return _react2.default.createElement(
	    _semanticUiReact.Button,
	    {
	      inverted: true,
	      disabled: loading || disabled,
	      fluid: fluid,
	      size: size || 'medium',
	      style: style,
	      floated: floated,
	      color: color || 'pink',
	      icon: hasIcon,
	      labelPosition: labelPosition,
	      onClick: onClick,
	      loading: loading
	    },
	    hasIcon && icon,
	    label
	  );
	};
	
	DyzioPrimaryButton.defaultProps = {
	  labelPosition: 'left',
	  floated: 'left'
	};
	
	var DyzioSecondaryButton = exports.DyzioSecondaryButton = function DyzioSecondaryButton(props) {
	  var fluid = props.fluid,
	      label = props.label,
	      hasIcon = props.hasIcon,
	      loading = props.loading,
	      icon = props.icon,
	      onClick = props.onClick,
	      style = props.style,
	      disabled = props.disabled,
	      size = props.size,
	      floated = props.floated,
	      color = props.color,
	      labelPosition = props.labelPosition;
	
	
	  return _react2.default.createElement(
	    _semanticUiReact.Button,
	    {
	      inverted: true,
	      disabled: loading || disabled,
	      fluid: fluid,
	      size: size || 'medium',
	      style: style,
	      floated: floated,
	      color: color || 'green',
	      icon: hasIcon,
	      labelPosition: labelPosition,
	      onClick: onClick,
	      loading: loading
	    },
	    hasIcon && icon,
	    label
	  );
	};
	
	DyzioSecondaryButton.defaultProps = {
	  labelPosition: 'left',
	  floated: 'left'
	};
	
	var DyzioCancelButton = exports.DyzioCancelButton = function DyzioCancelButton(props) {
	  var fluid = props.fluid,
	      label = props.label,
	      hasIcon = props.hasIcon,
	      loading = props.loading,
	      icon = props.icon,
	      onClick = props.onClick,
	      style = props.style,
	      disabled = props.disabled;
	
	
	  var normalFontWeightStyle = (0, _extends3.default)({
	    fontWeight: 700
	  }, style);
	
	  return _react2.default.createElement(
	    _semanticUiReact.Button,
	    {
	      disabled: loading || disabled,
	      fluid: fluid,
	      style: normalFontWeightStyle,
	      icon: hasIcon,
	      labelPosition: 'left',
	      onClick: onClick,
	      loading: loading,
	      className: 'dyzio-cancel-button'
	    },
	    hasIcon && icon,
	    label
	  );
	};
	
	var DyzioModalActionButton = exports.DyzioModalActionButton = function DyzioModalActionButton(props) {
	  var fluid = props.fluid,
	      label = props.label,
	      hasIcon = props.hasIcon,
	      loading = props.loading,
	      color = props.color,
	      icon = props.icon,
	      onClick = props.onClick,
	      style = props.style,
	      disabled = props.disabled;
	
	
	  var normalFontWeightStyle = (0, _extends3.default)({
	    fontWeight: 700
	  }, style);
	
	  return _react2.default.createElement(
	    _semanticUiReact.Button,
	    {
	      fluid: fluid,
	      onClick: onClick,
	      loading: loading,
	      color: color,
	      icon: hasIcon,
	      disabled: loading || disabled,
	      style: normalFontWeightStyle
	    },
	    hasIcon && icon,
	    label
	  );
	};
	
	DyzioModalActionButton.defaultProps = {
	  color: 'pink'
	};
	
	var DyzioDeleteButton = exports.DyzioDeleteButton = function DyzioDeleteButton(props) {
	  var fluid = props.fluid,
	      label = props.label,
	      hasIcon = props.hasIcon,
	      floated = props.floated,
	      loading = props.loading,
	      icon = props.icon,
	      onClick = props.onClick,
	      size = props.size,
	      color = props.color,
	      disabled = props.disabled,
	      labelPosition = props.labelPosition;
	
	
	  return _react2.default.createElement(
	    _semanticUiReact.Button,
	    {
	      inverted: true,
	      disabled: loading || disabled,
	      fluid: fluid,
	      size: size || 'medium',
	      floated: floated,
	      color: 'red',
	      icon: hasIcon,
	      labelPosition: labelPosition,
	      onClick: onClick,
	      loading: loading
	    },
	    hasIcon && icon,
	    label
	  );
	};
	
	DyzioDeleteButton.propTypes = {
	  onClick: _propTypes2.default.func.isRequired
	};
	
	DyzioDeleteButton.defaultProps = {
	  label: 'Delete',
	  hasIcon: true,
	  icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'delete' }),
	  labelPosition: 'left',
	  floated: 'left'
	};

/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 75 */
[4503, 414],
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(3289);


/***/ },
/* 77 */
[4503, 491],
/* 78 */
[4333, 1003],
/* 79 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(135);
	var _curry1 = __webpack_require__(29);
	var _curry2 = __webpack_require__(13);
	var _curryN = __webpack_require__(431);
	
	
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
	 * the following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      var sumArgs = (...args) => R.sum(args);
	 *
	 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	  return _arity(length, _curryN(length, [], fn));
	});


/***/ },
/* 81 */
/***/ function(module, exports) {

	module.exports = {
	  DISPLAY_FORMAT: 'L',
	  ISO_FORMAT: 'YYYY-MM-DD',
	
	  START_DATE: 'startDate',
	  END_DATE: 'endDate',
	
	  HORIZONTAL_ORIENTATION: 'horizontal',
	  VERTICAL_ORIENTATION: 'vertical',
	
	  ANCHOR_LEFT: 'left',
	  ANCHOR_RIGHT: 'right',
	};


/***/ },
/* 82 */
[4333, 1744],
/* 83 */
79,
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toDate = __webpack_require__(834);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	var _toFloat = __webpack_require__(1798);
	
	var _toFloat2 = _interopRequireDefault(_toFloat);
	
	var _toInt = __webpack_require__(4144);
	
	var _toInt2 = _interopRequireDefault(_toInt);
	
	var _toBoolean = __webpack_require__(4143);
	
	var _toBoolean2 = _interopRequireDefault(_toBoolean);
	
	var _equals = __webpack_require__(4102);
	
	var _equals2 = _interopRequireDefault(_equals);
	
	var _contains = __webpack_require__(4101);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _matches = __webpack_require__(4140);
	
	var _matches2 = _interopRequireDefault(_matches);
	
	var _isEmail = __webpack_require__(1791);
	
	var _isEmail2 = _interopRequireDefault(_isEmail);
	
	var _isURL = __webpack_require__(4135);
	
	var _isURL2 = _interopRequireDefault(_isURL);
	
	var _isMACAddress = __webpack_require__(4128);
	
	var _isMACAddress2 = _interopRequireDefault(_isMACAddress);
	
	var _isIP = __webpack_require__(1795);
	
	var _isIP2 = _interopRequireDefault(_isIP);
	
	var _isFQDN = __webpack_require__(833);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	var _isBoolean = __webpack_require__(4110);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isAlpha = __webpack_require__(4105);
	
	var _isAlpha2 = _interopRequireDefault(_isAlpha);
	
	var _isAlphanumeric = __webpack_require__(4106);
	
	var _isAlphanumeric2 = _interopRequireDefault(_isAlphanumeric);
	
	var _isNumeric = __webpack_require__(4133);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _isLowercase = __webpack_require__(4127);
	
	var _isLowercase2 = _interopRequireDefault(_isLowercase);
	
	var _isUppercase = __webpack_require__(4137);
	
	var _isUppercase2 = _interopRequireDefault(_isUppercase);
	
	var _isAscii = __webpack_require__(4107);
	
	var _isAscii2 = _interopRequireDefault(_isAscii);
	
	var _isFullWidth = __webpack_require__(1792);
	
	var _isFullWidth2 = _interopRequireDefault(_isFullWidth);
	
	var _isHalfWidth = __webpack_require__(1793);
	
	var _isHalfWidth2 = _interopRequireDefault(_isHalfWidth);
	
	var _isVariableWidth = __webpack_require__(4138);
	
	var _isVariableWidth2 = _interopRequireDefault(_isVariableWidth);
	
	var _isMultibyte = __webpack_require__(4132);
	
	var _isMultibyte2 = _interopRequireDefault(_isMultibyte);
	
	var _isSurrogatePair = __webpack_require__(4134);
	
	var _isSurrogatePair2 = _interopRequireDefault(_isSurrogatePair);
	
	var _isInt = __webpack_require__(4124);
	
	var _isInt2 = _interopRequireDefault(_isInt);
	
	var _isFloat = __webpack_require__(4117);
	
	var _isFloat2 = _interopRequireDefault(_isFloat);
	
	var _isDecimal = __webpack_require__(4114);
	
	var _isDecimal2 = _interopRequireDefault(_isDecimal);
	
	var _isHexadecimal = __webpack_require__(1794);
	
	var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);
	
	var _isDivisibleBy = __webpack_require__(4115);
	
	var _isDivisibleBy2 = _interopRequireDefault(_isDivisibleBy);
	
	var _isHexColor = __webpack_require__(4118);
	
	var _isHexColor2 = _interopRequireDefault(_isHexColor);
	
	var _isMD = __webpack_require__(4129);
	
	var _isMD2 = _interopRequireDefault(_isMD);
	
	var _isJSON = __webpack_require__(4125);
	
	var _isJSON2 = _interopRequireDefault(_isJSON);
	
	var _isEmpty = __webpack_require__(4116);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isLength = __webpack_require__(4126);
	
	var _isLength2 = _interopRequireDefault(_isLength);
	
	var _isByteLength = __webpack_require__(1790);
	
	var _isByteLength2 = _interopRequireDefault(_isByteLength);
	
	var _isUUID = __webpack_require__(4136);
	
	var _isUUID2 = _interopRequireDefault(_isUUID);
	
	var _isMongoId = __webpack_require__(4131);
	
	var _isMongoId2 = _interopRequireDefault(_isMongoId);
	
	var _isAfter = __webpack_require__(4104);
	
	var _isAfter2 = _interopRequireDefault(_isAfter);
	
	var _isBefore = __webpack_require__(4109);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _isIn = __webpack_require__(4123);
	
	var _isIn2 = _interopRequireDefault(_isIn);
	
	var _isCreditCard = __webpack_require__(4111);
	
	var _isCreditCard2 = _interopRequireDefault(_isCreditCard);
	
	var _isISIN = __webpack_require__(4120);
	
	var _isISIN2 = _interopRequireDefault(_isISIN);
	
	var _isISBN = __webpack_require__(4119);
	
	var _isISBN2 = _interopRequireDefault(_isISBN);
	
	var _isISSN = __webpack_require__(4122);
	
	var _isISSN2 = _interopRequireDefault(_isISSN);
	
	var _isMobilePhone = __webpack_require__(4130);
	
	var _isMobilePhone2 = _interopRequireDefault(_isMobilePhone);
	
	var _isCurrency = __webpack_require__(4112);
	
	var _isCurrency2 = _interopRequireDefault(_isCurrency);
	
	var _isISO = __webpack_require__(4121);
	
	var _isISO2 = _interopRequireDefault(_isISO);
	
	var _isBase = __webpack_require__(4108);
	
	var _isBase2 = _interopRequireDefault(_isBase);
	
	var _isDataURI = __webpack_require__(4113);
	
	var _isDataURI2 = _interopRequireDefault(_isDataURI);
	
	var _ltrim = __webpack_require__(1796);
	
	var _ltrim2 = _interopRequireDefault(_ltrim);
	
	var _rtrim = __webpack_require__(1797);
	
	var _rtrim2 = _interopRequireDefault(_rtrim);
	
	var _trim = __webpack_require__(4145);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _escape = __webpack_require__(4103);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	var _unescape = __webpack_require__(4146);
	
	var _unescape2 = _interopRequireDefault(_unescape);
	
	var _stripLow = __webpack_require__(4142);
	
	var _stripLow2 = _interopRequireDefault(_stripLow);
	
	var _whitelist = __webpack_require__(4147);
	
	var _whitelist2 = _interopRequireDefault(_whitelist);
	
	var _blacklist = __webpack_require__(1789);
	
	var _blacklist2 = _interopRequireDefault(_blacklist);
	
	var _isWhitelisted = __webpack_require__(4139);
	
	var _isWhitelisted2 = _interopRequireDefault(_isWhitelisted);
	
	var _normalizeEmail = __webpack_require__(4141);
	
	var _normalizeEmail2 = _interopRequireDefault(_normalizeEmail);
	
	var _toString = __webpack_require__(835);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var version = '7.0.0';
	
	var validator = {
	  version: version,
	  toDate: _toDate2.default,
	  toFloat: _toFloat2.default,
	  toInt: _toInt2.default,
	  toBoolean: _toBoolean2.default,
	  equals: _equals2.default,
	  contains: _contains2.default,
	  matches: _matches2.default,
	  isEmail: _isEmail2.default,
	  isURL: _isURL2.default,
	  isMACAddress: _isMACAddress2.default,
	  isIP: _isIP2.default,
	  isFQDN: _isFQDN2.default,
	  isBoolean: _isBoolean2.default,
	  isAlpha: _isAlpha2.default,
	  isAlphanumeric: _isAlphanumeric2.default,
	  isNumeric: _isNumeric2.default,
	  isLowercase: _isLowercase2.default,
	  isUppercase: _isUppercase2.default,
	  isAscii: _isAscii2.default,
	  isFullWidth: _isFullWidth2.default,
	  isHalfWidth: _isHalfWidth2.default,
	  isVariableWidth: _isVariableWidth2.default,
	  isMultibyte: _isMultibyte2.default,
	  isSurrogatePair: _isSurrogatePair2.default,
	  isInt: _isInt2.default,
	  isFloat: _isFloat2.default,
	  isDecimal: _isDecimal2.default,
	  isHexadecimal: _isHexadecimal2.default,
	  isDivisibleBy: _isDivisibleBy2.default,
	  isHexColor: _isHexColor2.default,
	  isMD5: _isMD2.default,
	  isJSON: _isJSON2.default,
	  isEmpty: _isEmpty2.default,
	  isLength: _isLength2.default,
	  isByteLength: _isByteLength2.default,
	  isUUID: _isUUID2.default,
	  isMongoId: _isMongoId2.default,
	  isAfter: _isAfter2.default,
	  isBefore: _isBefore2.default,
	  isIn: _isIn2.default,
	  isCreditCard: _isCreditCard2.default,
	  isISIN: _isISIN2.default,
	  isISBN: _isISBN2.default,
	  isISSN: _isISSN2.default,
	  isMobilePhone: _isMobilePhone2.default,
	  isCurrency: _isCurrency2.default,
	  isISO8601: _isISO2.default,
	  isBase64: _isBase2.default,
	  isDataURI: _isDataURI2.default,
	  ltrim: _ltrim2.default,
	  rtrim: _rtrim2.default,
	  trim: _trim2.default,
	  escape: _escape2.default,
	  unescape: _unescape2.default,
	  stripLow: _stripLow2.default,
	  whitelist: _whitelist2.default,
	  blacklist: _blacklist2.default,
	  isWhitelisted: _isWhitelisted2.default,
	  normalizeEmail: _normalizeEmail2.default,
	  toString: _toString2.default
	};
	
	exports.default = validator;
	module.exports = exports['default'];

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable no-param-reassign */
	/* eslint-disable no-restricted-syntax */
	/* eslint-disable guard-for-in */
	
	var assert = __webpack_require__(166);
	var objectAssign = __webpack_require__(1838);
	
	function pick(object, keys) {
	  return keys.reduce(function(prev, key) {
	    if (object[key]) {
	      prev[key] = object[key];
	    }
	    return prev;
	  }, {});
	}
	
	function getKeysNotIn(obj, allowedKeys) {
	  var notAllowed = [];
	  for (var key in obj) {
	    if (allowedKeys.indexOf(key) === -1) {
	      notAllowed.push(key);
	    }
	  }
	  return notAllowed;
	}
	
	function objectValues(obj) {
	  var values = [];
	  for (var key in obj) {
	    values.push(obj[key]);
	  }
	  return values;
	}
	
	function extend() {
	  var params = objectValues(arguments);
	  params.unshift({});
	  return objectAssign.get().apply(undefined, params);
	}
	
	function merge(object, keys) {
	  return {
	    base: keys ? pick(object, keys) : object,
	    with: function(object2, keys2) {
	      object2 = keys2 ? pick(object2, keys2) : object2;
	      return extend(this.base, object2);
	    }
	  };
	}
	
	function blacklist(object, blacklistedKeys) {
	  return Object.keys(object).reduce(function(p, key) {
	    if (blacklistedKeys.indexOf(key) === -1) {
	      p[key] = object[key];
	    }
	    return p;
	  }, {});
	}
	
	function camelToSnake(str) {
	  var newKey = '';
	  var index = 0;
	  var code;
	  var wasPrevNumber = true;
	  var wasPrevUppercase = true;
	
	  while (index < str.length) {
	    code = str.charCodeAt(index);
	    if (
	      (!wasPrevUppercase && code >= 65 && code <= 90) ||
	      (!wasPrevNumber && code >= 48 && code <= 57)
	    ) {
	      newKey += '_';
	      newKey += str[index].toLowerCase();
	    } else {
	      newKey += str[index].toLowerCase();
	    }
	    wasPrevNumber = code >= 48 && code <= 57;
	    wasPrevUppercase = code >= 65 && code <= 90;
	    index++;
	  }
	
	  return newKey;
	}
	
	function snakeToCamel(str) {
	  var parts = str.split('_');
	  return parts.reduce(function(p, c) {
	    return p + c.charAt(0).toUpperCase() + c.slice(1);
	  }, parts.shift());
	}
	
	function toSnakeCase(object, exceptions) {
	  if (typeof object !== 'object' || assert.isArray(object) || object === null) {
	    return object;
	  }
	  exceptions = exceptions || [];
	
	  return Object.keys(object).reduce(function(p, key) {
	    var newKey = exceptions.indexOf(key) === -1 ? camelToSnake(key) : key;
	    p[newKey] = toSnakeCase(object[key]);
	    return p;
	  }, {});
	}
	
	function toCamelCase(object, exceptions) {
	  if (typeof object !== 'object' || assert.isArray(object) || object === null) {
	    return object;
	  }
	
	  exceptions = exceptions || [];
	
	  return Object.keys(object).reduce(function(p, key) {
	    var newKey = exceptions.indexOf(key) === -1 ? snakeToCamel(key) : key;
	    p[newKey] = toCamelCase(object[key]);
	    return p;
	  }, {});
	}
	
	function getLocationFromUrl(href) {
	  var match = href.match(
	    /^(https?:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/
	  );
	  return (
	    match && {
	      href: href,
	      protocol: match[1],
	      host: match[2],
	      hostname: match[3],
	      port: match[4],
	      pathname: match[5],
	      search: match[6],
	      hash: match[7]
	    }
	  );
	}
	
	function getOriginFromUrl(url) {
	  if (!url) {
	    return undefined;
	  }
	  var parsed = getLocationFromUrl(url);
	  var origin = parsed.protocol + '//' + parsed.hostname;
	  if (parsed.port) {
	    origin += ':' + parsed.port;
	  }
	  return origin;
	}
	
	module.exports = {
	  toSnakeCase: toSnakeCase,
	  toCamelCase: toCamelCase,
	  blacklist: blacklist,
	  merge: merge,
	  pick: pick,
	  getKeysNotIn: getKeysNotIn,
	  extend: extend,
	  getOriginFromUrl: getOriginFromUrl,
	  getLocationFromUrl: getLocationFromUrl
	};


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AxiosService = function () {
	  function AxiosService(baseURL, timeout, paramHeaders) {
	    _classCallCheck(this, AxiosService);
	
	    var headers = paramHeaders;
	
	    // Set default headers if not provided
	    if (!headers['Content-type']) {
	      headers['Content-type'] = 'application/json';
	    } // eslint-disable-line dot-notation
	    if (!headers['Accept']) {
	      headers['Accept'] = 'application/json';
	    } // eslint-disable-line dot-notation
	
	    this.instance = _axios2.default.create({
	      baseURL: baseURL,
	      timeout: timeout,
	      headers: headers
	    });
	  }
	
	  // Get existing data API request
	
	
	  _createClass(AxiosService, [{
	    key: 'get',
	    value: function get(apiURL, params) {
	      return this.instance.get(apiURL, params);
	    }
	
	    // Post new data API request
	
	  }, {
	    key: 'post',
	    value: function post(apiURL, params) {
	      return this.instance.post(apiURL, params);
	    }
	
	    // Delete current data API request
	
	  }, {
	    key: 'delete',
	    value: function _delete(apiURL, params) {
	      return this.instance.delete(apiURL, params);
	    }
	
	    // Update current data API request
	
	  }, {
	    key: 'put',
	    value: function put(apiURL, params) {
	      return this.instance.put(apiURL, params);
	    }
	
	    // Patch a current data set API request
	
	  }, {
	    key: 'patch',
	    value: function patch(apiURL, params) {
	      return this.instance.patch(apiURL, params);
	    }
	  }]);
	
	  return AxiosService;
	}();
	
	exports.default = AxiosService;

/***/ },
/* 87 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(587)('wks');
	var uid = __webpack_require__(373);
	var Symbol = __webpack_require__(87).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 89 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 90 */
/***/ function(module, exports) {

	module.exports = function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	};


/***/ },
/* 91 */
74,
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BlogIcon = exports.PinterestIcon = exports.TwitterIcon = exports.InstagramIcon = exports.FacebookIcon = exports.YoutubeIcon = exports.TiktokIcon = exports.TwitchIcon = exports.TelegramIcon = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var twitterLogoStyle = {
	  color: '#1dcaff'
	};
	
	var facebookLogoStyle = {
	  color: '#3B5998'
	};
	
	var TelegramIcon = exports.TelegramIcon = function TelegramIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram', size: size, color: 'blue' });
	};
	
	var TwitchIcon = exports.TwitchIcon = function TwitchIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitch', size: size, color: 'purple' });
	};
	
	var TiktokIcon = exports.TiktokIcon = function TiktokIcon() {
	  var style = { width: 15, height: 15, display: 'inline-block' };
	  return _react2.default.createElement(_semanticUiReact.Image, { src: '/icons/tik-tok.svg', style: style });
	};
	
	var YoutubeIcon = exports.YoutubeIcon = function YoutubeIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', size: size, color: 'red' });
	};
	
	var FacebookIcon = exports.FacebookIcon = function FacebookIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', size: size, style: facebookLogoStyle });
	};
	
	var InstagramIcon = exports.InstagramIcon = function InstagramIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', size: size, color: 'pink' });
	};
	
	var TwitterIcon = exports.TwitterIcon = function TwitterIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter', size: size, style: twitterLogoStyle });
	};
	
	var PinterestIcon = exports.PinterestIcon = function PinterestIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'pinterest', size: size, color: 'red' });
	};
	
	var BlogIcon = exports.BlogIcon = function BlogIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'globe', size: size, color: 'blue' });
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderCountryName = undefined;
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _countryData = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderCountryName = exports.renderCountryName = function renderCountryName(code) {
	  var country = _lodash2.default.find(_countryData.countries.all, ['alpha2', code]);
	  return _lodash2.default.get(country, 'name', '-');
	};
	
	var countries = [{
	  text: 'United Kingdom',
	  value: 'GB',
	  key: 'GB',
	  flag: 'gb'
	}, {
	  text: 'United Kingdom',
	  value: 'UK',
	  key: 'UK',
	  flag: 'gb'
	}, {
	  text: 'United States',
	  value: 'US',
	  key: 'US',
	  flag: 'us'
	}, {
	  text: 'Ireland',
	  value: 'IE',
	  key: 'IE',
	  flag: 'ie'
	}, {
	  text: 'Global',
	  value: 'ZZ',
	  key: 'ZZ',
	  image: { src: '/icons/global-icon.png' }
	}, {
	  text: 'Afghanistan',
	  value: 'AF',
	  key: 'AF',
	  flag: 'af'
	}, {
	  text: 'Åland Islands',
	  value: 'AX',
	  key: 'AX',
	  flag: 'ax'
	}, {
	  text: 'Albania',
	  value: 'AL',
	  key: 'AL',
	  flag: 'al'
	}, {
	  text: 'Algeria',
	  value: 'DZ',
	  key: 'DZ',
	  flag: 'dz'
	}, {
	  text: 'American Samoa',
	  value: 'AS',
	  key: 'AS',
	  flag: 'as'
	}, {
	  text: 'AndorrA',
	  value: 'AD',
	  key: 'AD',
	  flag: 'ad'
	}, {
	  text: 'Angola',
	  value: 'AO',
	  key: 'AO',
	  flag: 'ao'
	}, {
	  text: 'Anguilla',
	  value: 'AI',
	  key: 'AI',
	  flag: 'ai'
	}, {
	  text: 'Antigua and Barbuda',
	  value: 'AG',
	  key: 'AG',
	  flag: 'ag'
	}, {
	  text: 'Argentina',
	  value: 'AR',
	  key: 'AR',
	  flag: 'ar'
	}, {
	  text: 'Armenia',
	  value: 'AM',
	  key: 'AM',
	  flag: 'am'
	}, {
	  text: 'Aruba',
	  value: 'AW',
	  key: 'AW',
	  flag: 'aw'
	}, {
	  text: 'Australia',
	  value: 'AU',
	  key: 'AU',
	  flag: 'au'
	}, {
	  text: 'Austria',
	  value: 'AT',
	  key: 'AT',
	  flag: 'at'
	}, {
	  text: 'Azerbaijan',
	  value: 'AZ',
	  key: 'AZ',
	  flag: 'az'
	}, {
	  text: 'Bahamas',
	  value: 'BS',
	  key: 'BS',
	  flag: 'bs'
	}, {
	  text: 'Bahrain',
	  value: 'BH',
	  key: 'BH',
	  flag: 'bh'
	}, {
	  text: 'Bangladesh',
	  value: 'BD',
	  key: 'BD',
	  flag: 'bd'
	}, {
	  text: 'Barbados',
	  value: 'BB',
	  key: 'BB',
	  flag: 'bb'
	}, {
	  text: 'Belarus',
	  value: 'BY',
	  flag: 'by'
	}, {
	  text: 'Belgium',
	  value: 'BE',
	  key: 'BE',
	  flag: 'be'
	}, {
	  text: 'Belize',
	  value: 'BZ',
	  key: 'BZ',
	  flag: 'bz'
	}, {
	  text: 'Benin',
	  value: 'BJ',
	  key: 'BJ',
	  flag: 'bj'
	}, {
	  text: 'Bermuda',
	  value: 'BM',
	  key: 'BM',
	  flag: 'bm'
	}, {
	  text: 'Bhutan',
	  value: 'BT',
	  key: 'BT',
	  flag: 'bt'
	}, {
	  text: 'Bolivia',
	  value: 'BO',
	  key: 'BO',
	  flag: 'bo'
	}, {
	  text: 'Bosnia and Herzegovina',
	  value: 'BA',
	  key: 'BA',
	  flag: 'ba'
	}, {
	  text: 'Botswana',
	  value: 'BW',
	  key: 'BW',
	  flag: 'bw'
	}, {
	  text: 'Bouvet Island',
	  value: 'BV',
	  key: 'BV',
	  flag: 'bv'
	}, {
	  text: 'Brazil',
	  value: 'BR',
	  key: 'BR',
	  flag: 'br'
	}, {
	  text: 'British Indian Ocean Territory',
	  value: 'IO',
	  key: 'IO',
	  flag: 'io'
	}, {
	  text: 'Brunei Darussalam',
	  value: 'BN',
	  key: 'BN',
	  flag: 'bn'
	}, {
	  text: 'Bulgaria',
	  value: 'BG',
	  key: 'BG',
	  flag: 'bg'
	}, {
	  text: 'Burkina Faso',
	  value: 'BF',
	  key: 'BF',
	  flag: 'bf'
	}, {
	  text: 'Burundi',
	  value: 'BI',
	  key: 'BI',
	  flag: 'bi'
	}, {
	  text: 'Cambodia',
	  value: 'KH',
	  key: 'KH',
	  flag: 'kh'
	}, {
	  text: 'Cameroon',
	  value: 'CM',
	  flag: 'cm'
	}, {
	  text: 'Canada',
	  value: 'CA',
	  key: 'CA',
	  flag: 'ca'
	}, {
	  text: 'Cape Verde',
	  value: 'CV',
	  key: 'CV',
	  flag: 'cv'
	}, {
	  text: 'Cayman Islands',
	  value: 'KY',
	  key: 'KY',
	  flag: 'ky'
	}, {
	  text: 'Central African Republic',
	  value: 'CF',
	  key: 'CF',
	  flag: 'cf'
	}, {
	  text: 'Chad',
	  value: 'TD',
	  key: 'TD',
	  flag: 'td'
	}, {
	  text: 'Chile',
	  value: 'CL',
	  key: 'CL',
	  flag: 'cl'
	}, {
	  text: 'China',
	  value: 'CN',
	  key: 'CN',
	  flag: 'cn'
	}, {
	  text: 'Christmas Island',
	  value: 'CX',
	  key: 'CX',
	  flag: 'cx'
	}, {
	  text: 'Cocos (Keeling) Islands',
	  value: 'CC',
	  key: 'CC',
	  flag: 'cc'
	}, {
	  text: 'Colombia',
	  value: 'CO',
	  key: 'CO',
	  flag: 'co'
	}, {
	  text: 'Comoros',
	  value: 'KM',
	  key: 'KM',
	  flag: 'km'
	}, {
	  text: 'Congo',
	  value: 'CG',
	  key: 'CG',
	  flag: 'cg'
	}, {
	  text: 'Congo, The Democratic Republic of the',
	  value: 'CD',
	  key: 'CD',
	  flag: 'cd'
	}, {
	  text: 'Cook Islands',
	  value: 'CK',
	  key: 'CK',
	  flag: 'ck'
	}, {
	  text: 'Costa Rica',
	  value: 'CR',
	  key: 'CR',
	  flag: 'cr'
	}, {
	  text: 'Cote D"Ivoire',
	  value: 'CI',
	  key: 'CI',
	  flag: 'ci'
	}, {
	  text: 'Croatia',
	  value: 'HR',
	  key: 'HR',
	  flag: 'hr'
	}, {
	  text: 'Cuba',
	  value: 'CU',
	  key: 'CU',
	  flag: 'cu'
	}, {
	  text: 'Cyprus',
	  value: 'CY',
	  key: 'CY',
	  flag: 'cy'
	}, {
	  text: 'Czech Republic',
	  value: 'CZ',
	  key: 'CZ',
	  flag: 'cz'
	}, {
	  text: 'Denmark',
	  value: 'DK',
	  key: 'DK',
	  flag: 'dk'
	}, {
	  text: 'Djibouti',
	  value: 'DJ',
	  key: 'DJ',
	  flag: 'dj'
	}, {
	  text: 'Dominica',
	  value: 'DM',
	  key: 'DM',
	  flag: 'dm'
	}, {
	  text: 'Dominican Republic',
	  value: 'DO',
	  key: 'DO',
	  flag: 'do'
	}, {
	  text: 'Ecuador',
	  value: 'EC',
	  key: 'EC',
	  flag: 'ec'
	}, {
	  text: 'Egypt',
	  value: 'EG',
	  key: 'EG',
	  flag: 'eg'
	}, {
	  text: 'El Salvador',
	  value: 'SV',
	  key: 'SV',
	  flag: 'sv'
	}, {
	  text: 'Equatorial Guinea',
	  value: 'GQ',
	  key: 'GQ',
	  flag: 'gq'
	}, {
	  text: 'Eritrea',
	  value: 'ER',
	  key: 'ER',
	  flag: 'er'
	}, {
	  text: 'Estonia',
	  value: 'EE',
	  key: 'EE',
	  flag: 'ee'
	}, {
	  text: 'Ethiopia',
	  value: 'ET',
	  key: 'ET',
	  flag: 'et'
	}, {
	  text: 'Falkland Islands (Malvinas)',
	  value: 'FK',
	  key: 'FK',
	  flag: 'fk'
	}, {
	  text: 'Faroe Islands',
	  value: 'FO',
	  key: 'FO',
	  flag: 'fo'
	}, {
	  text: 'Fiji',
	  value: 'FJ',
	  key: 'FJ',
	  flag: 'fj'
	}, {
	  text: 'Finland',
	  value: 'FI',
	  key: 'FI',
	  flag: 'fi'
	}, {
	  text: 'France',
	  value: 'FR',
	  key: 'FR',
	  flag: 'fr'
	}, {
	  text: 'French Guiana',
	  value: 'GF',
	  key: 'GF',
	  flag: 'gf'
	}, {
	  text: 'French Polynesia',
	  value: 'PF',
	  key: 'PF',
	  flag: 'pf'
	}, {
	  text: 'French Southern Territories',
	  value: 'TF',
	  key: 'TF',
	  flag: 'tf'
	}, {
	  text: 'Gabon',
	  value: 'GA',
	  key: 'GA',
	  flag: 'ga'
	}, {
	  text: 'Gambia',
	  value: 'GM',
	  key: 'GM',
	  flag: 'gm'
	}, {
	  text: 'Georgia',
	  value: 'GE',
	  key: 'GE',
	  flag: 'ge'
	}, {
	  text: 'Germany',
	  value: 'DE',
	  key: 'DE',
	  flag: 'de'
	}, {
	  text: 'Ghana',
	  value: 'GH',
	  key: 'GH',
	  flag: 'gh'
	}, {
	  text: 'Gibraltar',
	  value: 'GI',
	  key: 'GI',
	  flag: 'gi'
	}, {
	  text: 'Greece',
	  value: 'GR',
	  key: 'GR',
	  flag: 'gr'
	}, {
	  text: 'Greenland',
	  value: 'GL',
	  key: 'GL',
	  flag: 'gl'
	}, {
	  text: 'Grenada',
	  value: 'GD',
	  key: 'GD',
	  flag: 'gd'
	}, {
	  text: 'Guadeloupe',
	  value: 'GP',
	  key: 'GP',
	  flag: 'gp'
	}, {
	  text: 'Guam',
	  value: 'GU',
	  key: 'GU',
	  flag: 'gu'
	}, {
	  text: 'Guatemala',
	  value: 'GT',
	  flag: 'gt'
	}, {
	  text: 'Guinea',
	  value: 'GN',
	  key: 'GN',
	  flag: 'gn'
	}, {
	  text: 'Guinea-Bissau',
	  value: 'GW',
	  key: 'GW',
	  flag: 'gw'
	}, {
	  text: 'Guyana',
	  value: 'GY',
	  key: 'GY',
	  flag: 'gy'
	}, {
	  text: 'Haiti',
	  value: 'HT',
	  key: 'HT',
	  flag: 'ht'
	}, {
	  text: 'Heard Island and Mcdonald Islands',
	  value: 'HM',
	  key: 'HM',
	  flag: 'hm'
	}, {
	  text: 'Holy See (Vatican City State)',
	  value: 'VA',
	  key: 'VA',
	  flag: 'va'
	}, {
	  text: 'Honduras',
	  value: 'HN',
	  key: 'HN',
	  flag: 'hn'
	}, {
	  text: 'Hong Kong',
	  value: 'HK',
	  key: 'HK',
	  flag: 'hk'
	}, {
	  text: 'Hungary',
	  value: 'HU',
	  key: 'HU',
	  flag: 'hu'
	}, {
	  text: 'Iceland',
	  value: 'IS',
	  key: 'IS',
	  flag: 'is'
	}, {
	  text: 'India',
	  value: 'IN',
	  key: 'IN',
	  flag: 'in'
	}, {
	  text: 'Indonesia',
	  value: 'ID',
	  key: 'ID',
	  flag: 'id'
	}, {
	  text: 'Iran, Islamic Republic Of',
	  value: 'IR',
	  key: 'IR',
	  flag: 'ir'
	}, {
	  text: 'Iraq',
	  value: 'IQ',
	  key: 'IQ',
	  flag: 'iq'
	}, {
	  text: 'Israel',
	  value: 'IL',
	  key: 'IL',
	  flag: 'il'
	}, {
	  text: 'Italy',
	  value: 'IT',
	  key: 'IT',
	  flag: 'it'
	}, {
	  text: 'Jamaica',
	  value: 'JM',
	  key: 'JM',
	  flag: 'jm'
	}, {
	  text: 'Japan',
	  value: 'JP',
	  key: 'JP',
	  flag: 'jp'
	}, {
	  text: 'Jordan',
	  value: 'JO',
	  key: 'JO',
	  flag: 'jo'
	}, {
	  text: 'Kazakhstan',
	  value: 'KZ',
	  key: 'KZ',
	  flag: 'kz'
	}, {
	  text: 'Kenya',
	  value: 'KE',
	  key: 'KE',
	  flag: 'ke'
	}, {
	  text: 'Kiribati',
	  value: 'KI',
	  key: 'KI',
	  flag: 'ki'
	}, {
	  text: 'Korea, Democratic People"S Republic of',
	  value: 'KP',
	  key: 'KP',
	  flag: 'kp'
	}, {
	  text: 'Korea, Republic of',
	  value: 'KR',
	  key: 'KR',
	  flag: 'kr'
	}, {
	  text: 'Kuwait',
	  value: 'KW',
	  key: 'KW',
	  flag: 'kw'
	}, {
	  text: 'Kyrgyzstan',
	  value: 'KG',
	  key: 'KG',
	  flag: 'kg'
	}, {
	  text: 'Lao People"S Democratic Republic',
	  value: 'LA',
	  key: 'LA',
	  flag: 'la'
	}, {
	  text: 'Latvia',
	  value: 'LV',
	  key: 'LV',
	  flag: 'lv'
	}, {
	  text: 'Lebanon',
	  value: 'LB',
	  key: 'LB',
	  flag: 'lb'
	}, {
	  text: 'Lesotho',
	  value: 'LS',
	  key: 'LS',
	  flag: 'ls'
	}, {
	  text: 'Liberia',
	  value: 'LR',
	  key: 'LR',
	  flag: 'lr'
	}, {
	  text: 'Libyan Arab Jamahiriya',
	  value: 'LY',
	  key: 'LY',
	  flag: 'ly'
	}, {
	  text: 'Liechtenstein',
	  value: 'LI',
	  key: 'LI',
	  flag: 'li'
	}, {
	  text: 'Lithuania',
	  value: 'LT',
	  key: 'LT',
	  flag: 'lt'
	}, {
	  text: 'Luxembourg',
	  value: 'LU',
	  key: 'LU',
	  flag: 'lu'
	}, {
	  text: 'Macao',
	  value: 'MO',
	  key: 'MO',
	  flag: 'mo'
	}, {
	  text: 'Macedonia, The Former Yugoslav Republic of',
	  value: 'MK',
	  key: 'MK',
	  flag: 'mk'
	}, {
	  text: 'Madagascar',
	  value: 'MG',
	  key: 'MG',
	  flag: 'mg'
	}, {
	  text: 'Malawi',
	  value: 'MW',
	  key: 'MW',
	  flag: 'mw'
	}, {
	  text: 'Malaysia',
	  value: 'MY',
	  key: 'MY',
	  flag: 'my'
	}, {
	  text: 'Maldives',
	  value: 'MV',
	  key: 'MV',
	  flag: 'mv'
	}, {
	  text: 'Mali',
	  value: 'ML',
	  key: 'ML',
	  flag: 'ml'
	}, {
	  text: 'Malta',
	  value: 'MT',
	  key: 'MT',
	  flag: 'mt'
	}, {
	  text: 'Marshall Islands',
	  value: 'MH',
	  key: 'MH',
	  flag: 'mh'
	}, {
	  text: 'Martinique',
	  value: 'MQ',
	  key: 'MQ',
	  flag: 'mq'
	}, {
	  text: 'Mauritania',
	  value: 'MR',
	  key: 'MR',
	  flag: 'mr'
	}, {
	  text: 'Mauritius',
	  value: 'MU',
	  key: 'MU',
	  flag: 'mu'
	}, {
	  text: 'Mayotte',
	  value: 'YT',
	  key: 'YT',
	  flag: 'yt'
	}, {
	  text: 'Mexico',
	  value: 'MX',
	  key: 'MX',
	  flag: 'mx'
	}, {
	  text: 'Micronesia, Federated States of',
	  value: 'FM',
	  key: 'FM',
	  flag: 'fm'
	}, {
	  text: 'Moldova, Republic of',
	  value: 'MD',
	  key: 'MD',
	  flag: 'md'
	}, {
	  text: 'Monaco',
	  value: 'MC',
	  key: 'MC',
	  flag: 'mc'
	}, {
	  text: 'Mongolia',
	  value: 'MN',
	  key: 'MN',
	  flag: 'mn'
	}, {
	  text: 'Montserrat',
	  value: 'MS',
	  key: 'MS',
	  flag: 'ms'
	}, {
	  text: 'Morocco',
	  value: 'MA',
	  key: 'MA',
	  flag: 'ma'
	}, {
	  text: 'Mozambique',
	  value: 'MZ',
	  key: 'MZ',
	  flag: 'mz'
	}, {
	  text: 'Myanmar',
	  value: 'MM',
	  key: 'MM',
	  flag: 'mm'
	}, {
	  text: 'Namibia',
	  value: 'NA',
	  key: 'NA',
	  flag: 'na'
	}, {
	  text: 'Nauru',
	  value: 'NR',
	  key: 'NR',
	  flag: 'nr'
	}, {
	  text: 'Nepal',
	  value: 'NP',
	  key: 'NP',
	  flag: 'np'
	}, {
	  text: 'Netherlands',
	  value: 'NL',
	  key: 'NL',
	  flag: 'nl'
	}, {
	  text: 'Netherlands Antilles',
	  value: 'AN',
	  key: 'AN',
	  flag: 'an'
	}, {
	  text: 'New Caledonia',
	  value: 'NC',
	  key: 'NC',
	  flag: 'nc'
	}, {
	  text: 'New Zealand',
	  value: 'NZ',
	  key: 'NZ',
	  flag: 'nz'
	}, {
	  text: 'Nicaragua',
	  value: 'NI',
	  key: 'NI',
	  flag: 'ni'
	}, {
	  text: 'Niger',
	  value: 'NE',
	  key: 'NE',
	  flag: 'ne'
	}, {
	  text: 'Nigeria',
	  value: 'NG',
	  key: 'NG',
	  flag: 'ng'
	}, {
	  text: 'Niue',
	  value: 'NU',
	  key: 'NU',
	  flag: 'nu'
	}, {
	  text: 'Norfolk Island',
	  value: 'NF',
	  key: 'NF',
	  flag: 'nf'
	}, {
	  text: 'Northern Mariana Islands',
	  value: 'MP',
	  key: 'MP',
	  flag: 'mp'
	}, {
	  text: 'Norway',
	  value: 'NO',
	  key: 'NO',
	  flag: 'no'
	}, {
	  text: 'Oman',
	  value: 'OM',
	  key: 'OM',
	  flag: 'om'
	}, {
	  text: 'Pakistan',
	  value: 'PK',
	  key: 'PK',
	  flag: 'pk'
	}, {
	  text: 'Palau',
	  value: 'PW',
	  key: 'PW',
	  flag: 'pw'
	}, {
	  text: 'Palestinian Territory, Occupied',
	  value: 'PS',
	  key: 'PS',
	  flag: 'ps'
	}, {
	  text: 'Panama',
	  value: 'PA',
	  key: 'PA',
	  flag: 'pa'
	}, {
	  text: 'Papua New Guinea',
	  value: 'PG',
	  key: 'PG',
	  flag: 'pg'
	}, {
	  text: 'Paraguay',
	  value: 'PY',
	  key: 'PY',
	  flag: 'py'
	}, {
	  text: 'Peru',
	  value: 'PE',
	  key: 'PE',
	  flag: 'pe'
	}, {
	  text: 'Philippines',
	  value: 'PH',
	  key: 'PH',
	  flag: 'ph'
	}, {
	  text: 'Pitcairn',
	  value: 'PN',
	  key: 'PN',
	  flag: 'pn'
	}, {
	  text: 'Poland',
	  value: 'PL',
	  key: 'PL',
	  flag: 'pl'
	}, {
	  text: 'Portugal',
	  value: 'PT',
	  key: 'PT',
	  flag: 'pt'
	}, {
	  text: 'Puerto Rico',
	  value: 'PR',
	  key: 'PR',
	  flag: 'pr'
	}, {
	  text: 'Qatar',
	  value: 'QA',
	  key: 'QA',
	  flag: 'qa'
	}, {
	  text: 'Reunion',
	  value: 'RE',
	  key: 'RE',
	  flag: 're'
	}, {
	  text: 'Romania',
	  value: 'RO',
	  key: 'RO',
	  flag: 'ro'
	}, {
	  text: 'Russian Federation',
	  value: 'RU',
	  key: 'RU',
	  flag: 'ru'
	}, {
	  text: 'RWANDA',
	  value: 'RW',
	  key: 'RW',
	  flag: 'rw'
	}, {
	  text: 'Saint Helena',
	  value: 'SH',
	  key: 'SH',
	  flag: 'sh'
	}, {
	  text: 'Saint Kitts and Nevis',
	  value: 'KN',
	  key: 'KN',
	  flag: 'kn'
	}, {
	  text: 'Saint Lucia',
	  value: 'LC',
	  key: 'LC',
	  flag: 'lc'
	}, {
	  text: 'Saint Pierre and Miquelon',
	  value: 'PM',
	  key: 'PM',
	  flag: 'pm'
	}, {
	  text: 'Saint Vincent and the Grenadines',
	  value: 'VC',
	  key: 'VC',
	  flag: 'vc'
	}, {
	  text: 'Samoa',
	  value: 'WS',
	  key: 'WS',
	  flag: 'ws'
	}, {
	  text: 'San Marino',
	  value: 'SM',
	  key: 'SM',
	  flag: 'sm'
	}, {
	  text: 'Sao Tome and Principe',
	  value: 'ST',
	  key: 'ST',
	  flag: 'st'
	}, {
	  text: 'Saudi Arabia',
	  value: 'SA',
	  key: 'SA',
	  flag: 'sa'
	}, {
	  text: 'Senegal',
	  value: 'SN',
	  key: 'SN',
	  flag: 'sn'
	}, {
	  text: 'Serbia',
	  value: 'RS',
	  key: 'RS',
	  flag: 'rs'
	}, {
	  text: 'Montenegro',
	  value: 'ME',
	  key: 'ME',
	  flag: 'me'
	}, {
	  text: 'Seychelles',
	  value: 'SC',
	  key: 'SC',
	  flag: 'sc'
	}, {
	  text: 'Sierra Leone',
	  value: 'SL',
	  key: 'SL',
	  flag: 'sl'
	}, {
	  text: 'Singapore',
	  value: 'SG',
	  key: 'SG',
	  flag: 'sg'
	}, {
	  text: 'Slovakia',
	  value: 'SK',
	  key: 'SK',
	  flag: 'sk'
	}, {
	  text: 'Slovenia',
	  value: 'SI',
	  key: 'SI',
	  flag: 'si'
	}, {
	  text: 'Solomon Islands',
	  value: 'SB',
	  key: 'SB',
	  flag: 'sb'
	}, {
	  text: 'Somalia',
	  value: 'SO',
	  key: 'SO',
	  flag: 'so'
	}, {
	  text: 'South Africa',
	  value: 'ZA',
	  key: 'ZA',
	  flag: 'za'
	}, {
	  text: 'South Georgia and the South Sandwich Islands',
	  value: 'GS',
	  key: 'GS',
	  flag: 'gs'
	}, {
	  text: 'Spain',
	  value: 'ES',
	  key: 'ES',
	  flag: 'es'
	}, {
	  text: 'Sri Lanka',
	  value: 'LK',
	  key: 'LK',
	  flag: 'lk'
	}, {
	  text: 'Sudan',
	  value: 'SD',
	  key: 'SD',
	  flag: 'sd'
	}, {
	  text: 'Suritext',
	  value: 'SR',
	  key: 'SR',
	  flag: 'sr'
	}, {
	  text: 'Svalbard and Jan Mayen',
	  value: 'SJ',
	  key: 'SJ',
	  flag: 'sj'
	}, {
	  text: 'Swaziland',
	  value: 'SZ',
	  key: 'SZ',
	  flag: 'sz'
	}, {
	  text: 'Sweden',
	  value: 'SE',
	  key: 'SE',
	  flag: 'se'
	}, {
	  text: 'Switzerland',
	  value: 'CH',
	  key: 'CH',
	  flag: 'ch'
	}, {
	  text: 'Syrian Arab Republic',
	  value: 'SY',
	  key: 'SY',
	  flag: 'sy'
	}, {
	  text: 'Taiwan, Province of China',
	  value: 'TW',
	  key: 'TW',
	  flag: 'tw'
	}, {
	  text: 'Tajikistan',
	  value: 'TJ',
	  key: 'TJ',
	  flag: 'tj'
	}, {
	  text: 'Tanzania, United Republic of',
	  value: 'TZ',
	  key: 'TZ',
	  flag: 'tz'
	}, {
	  text: 'Thailand',
	  value: 'TH',
	  key: 'TH',
	  flag: 'th'
	}, {
	  text: 'Timor-Leste',
	  value: 'TL',
	  key: 'TL',
	  flag: 'tl'
	}, {
	  text: 'Togo',
	  value: 'TG',
	  key: 'TG',
	  flag: 'tg'
	}, {
	  text: 'Tokelau',
	  value: 'TK',
	  key: 'TK',
	  flag: 'tk'
	}, {
	  text: 'Tonga',
	  value: 'TO',
	  key: 'TO',
	  flag: 'to'
	}, {
	  text: 'Trinidad and Tobago',
	  value: 'TT',
	  key: 'TT',
	  flag: 'tt'
	}, {
	  text: 'Tunisia',
	  value: 'TN',
	  key: 'TN',
	  flag: 'tn'
	}, {
	  text: 'Turkey',
	  value: 'TR',
	  key: 'TR',
	  flag: 'gw'
	}, {
	  text: 'Turkmenistan',
	  value: 'TM',
	  key: 'TM',
	  flag: 'tm'
	}, {
	  text: 'Turks and Caicos Islands',
	  value: 'TC',
	  key: 'TC',
	  flag: 'tc'
	}, {
	  text: 'Tuvalu',
	  value: 'TV',
	  key: 'TV',
	  flag: 'tv'
	}, {
	  text: 'Uganda',
	  value: 'UG',
	  key: 'UG',
	  flag: 'ug'
	}, {
	  text: 'Ukraine',
	  value: 'UA',
	  key: 'UA',
	  flag: 'ua'
	}, {
	  text: 'United Arab Emirates',
	  value: 'AE',
	  key: 'AE',
	  flag: 'ae'
	}, {
	  text: 'United States Minor Outlying Islands',
	  value: 'UM',
	  key: 'UM',
	  flag: 'um'
	}, {
	  text: 'Uruguay',
	  value: 'UY',
	  key: 'UY',
	  flag: 'uy'
	}, {
	  text: 'Uzbekistan',
	  value: 'UZ',
	  key: 'UZ',
	  flag: 'uz'
	}, {
	  text: 'Vanuatu',
	  value: 'VU',
	  key: 'VU',
	  flag: 'vu'
	}, {
	  text: 'Venezuela',
	  value: 'VE',
	  key: 'VE',
	  flag: 've'
	}, {
	  text: 'Viet Nam',
	  value: 'VN',
	  key: 'VN',
	  flag: 'vn'
	}, {
	  text: 'Virgin Islands, British',
	  value: 'VG',
	  key: 'VG',
	  flag: 'vg'
	}, {
	  text: 'Virgin Islands, U.S.',
	  value: 'VI',
	  key: 'VI',
	  flag: 'vi'
	}, {
	  text: 'Wallis and Futuna',
	  value: 'WF',
	  key: 'WF',
	  flag: 'wf'
	}, {
	  text: 'Western Sahara',
	  value: 'EH',
	  key: 'EH',
	  flag: 'eh'
	}, {
	  text: 'Yemen',
	  value: 'YE',
	  key: 'YE',
	  flag: 'ye'
	}, {
	  text: 'Zambia',
	  value: 'ZM',
	  key: 'ZM',
	  flag: 'zm'
	}, {
	  text: 'Zimbabwe',
	  value: 'ZW',
	  key: 'ZW',
	  flag: 'zw'
	}];
	
	exports.default = countries;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = JSONApiClient;
	exports.unauthorisedJSONApiClient = unauthorisedJSONApiClient;
	
	var _authService = __webpack_require__(21);
	
	var _Client = __webpack_require__(2379);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var client = null;
	
	function JSONApiClient() {
	
	  var token = _authService.authService.getToken();
	  if (!token) {
	    client = null;
	    // TODO should probably throw an error here.
	    return;
	  }
	
	  client = new _Client2.default(("https://api2.dyzio.co/v1"), {
	    header: {
	      Authorization: 'Bearer ' + _authService.authService.getToken()
	    }
	  });
	  return client;
	}
	
	function unauthorisedJSONApiClient() {
	  return new _Client2.default(("https://api2.dyzio.co/v1"), {});
	}

/***/ },
/* 95 */
[4233, 2632, 2633, 179, 47, 2770],
/* 96 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 97 */
[4413, 978, 390, 123],
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseStartTime = parseStartTime;
	exports.parseEndTime = parseEndTime;
	exports.randomString = randomString;
	exports.queryString = queryString;
	exports.getSDK = getSDK;
	exports.getConfig = getConfig;
	exports.omit = omit;
	exports.callPlayer = callPlayer;
	exports.isObject = isObject;
	exports.isEqual = isEqual;
	exports.isMediaStream = isMediaStream;
	
	var _react = __webpack_require__(1);
	
	var _loadScript = _interopRequireDefault(__webpack_require__(423));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(2549));
	
	var _props = __webpack_require__(411);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
	var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
	var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
	var MATCH_NUMERIC = /^\d+$/; // Parse YouTube URL for a start time param, ie ?t=1h14m30s
	// and return the start time in seconds
	
	function parseTimeParam(url, pattern) {
	  var match = url.match(pattern);
	
	  if (match) {
	    var stamp = match[1];
	
	    if (stamp.match(MATCH_START_STAMP)) {
	      return parseTimeString(stamp);
	    }
	
	    if (MATCH_NUMERIC.test(stamp)) {
	      return parseInt(stamp);
	    }
	  }
	
	  return undefined;
	}
	
	function parseTimeString(stamp) {
	  var seconds = 0;
	  var array = MATCH_START_STAMP.exec(stamp);
	
	  while (array !== null) {
	    var _array = array,
	        _array2 = _slicedToArray(_array, 3),
	        count = _array2[1],
	        period = _array2[2];
	
	    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
	    if (period === 'm') seconds += parseInt(count, 10) * 60;
	    if (period === 's') seconds += parseInt(count, 10);
	    array = MATCH_START_STAMP.exec(stamp);
	  }
	
	  return seconds;
	}
	
	function parseStartTime(url) {
	  return parseTimeParam(url, MATCH_START_QUERY);
	}
	
	function parseEndTime(url) {
	  return parseTimeParam(url, MATCH_END_QUERY);
	} // http://stackoverflow.com/a/38622545
	
	
	function randomString() {
	  return Math.random().toString(36).substr(2, 5);
	}
	
	function queryString(object) {
	  return Object.keys(object).map(function (key) {
	    return "".concat(key, "=").concat(object[key]);
	  }).join('&');
	} // Util function to load an external SDK
	// or return the SDK if it is already loaded
	
	
	var requests = {};
	
	function getSDK(url, sdkGlobal) {
	  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
	    return true;
	  };
	  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript["default"];
	
	  if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
	    return Promise.resolve(window[sdkGlobal]);
	  }
	
	  return new Promise(function (resolve, reject) {
	    // If we are already loading the SDK, add the resolve and reject
	    // functions to the existing array of requests
	    if (requests[url]) {
	      requests[url].push({
	        resolve: resolve,
	        reject: reject
	      });
	      return;
	    }
	
	    requests[url] = [{
	      resolve: resolve,
	      reject: reject
	    }];
	
	    var onLoaded = function onLoaded(sdk) {
	      // When loaded, resolve all pending request promises
	      requests[url].forEach(function (request) {
	        return request.resolve(sdk);
	      });
	    };
	
	    if (sdkReady) {
	      var previousOnReady = window[sdkReady];
	
	      window[sdkReady] = function () {
	        if (previousOnReady) previousOnReady();
	        onLoaded(window[sdkGlobal]);
	      };
	    }
	
	    fetchScript(url, function (err) {
	      if (err) {
	        // Loading the SDK failed – reject all requests and
	        // reset the array of requests for this SDK
	        requests[url].forEach(function (request) {
	          return request.reject(err);
	        });
	        requests[url] = null;
	      } else if (!sdkReady) {
	        onLoaded(window[sdkGlobal]);
	      }
	    });
	  });
	}
	
	function getConfig(props, defaultProps, showWarning) {
	  var config = (0, _deepmerge["default"])(defaultProps.config, props.config);
	
	  var _iterator = _createForOfIteratorHelper(_props.DEPRECATED_CONFIG_PROPS),
	      _step;
	
	  try {
	    for (_iterator.s(); !(_step = _iterator.n()).done;) {
	      var p = _step.value;
	
	      if (props[p]) {
	        var key = p.replace(/Config$/, '');
	        config = (0, _deepmerge["default"])(config, _defineProperty({}, key, props[p]));
	
	        if (showWarning) {
	          var link = 'https://github.com/CookPete/react-player#config-prop';
	          var message = "ReactPlayer: %c".concat(p, " %cis deprecated, please use the config prop instead \u2013 ").concat(link);
	          console.warn(message, 'font-weight: bold', '');
	        }
	      }
	    }
	  } catch (err) {
	    _iterator.e(err);
	  } finally {
	    _iterator.f();
	  }
	
	  return config;
	}
	
	function omit(object) {
	  var _ref;
	
	  for (var _len = arguments.length, arrays = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    arrays[_key - 1] = arguments[_key];
	  }
	
	  var omitKeys = (_ref = []).concat.apply(_ref, arrays);
	
	  var output = {};
	  var keys = Object.keys(object);
	
	  for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
	    var key = _keys[_i2];
	
	    if (omitKeys.indexOf(key) === -1) {
	      output[key] = object[key];
	    }
	  }
	
	  return output;
	}
	
	function callPlayer(method) {
	  var _this$player;
	
	  // Util method for calling a method on this.player
	  // but guard against errors and console.warn instead
	  if (!this.player || !this.player[method]) {
	    var message = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(method, "%c \u2013 ");
	
	    if (!this.player) {
	      message += 'The player was not available';
	    } else if (!this.player[method]) {
	      message += 'The method was not available';
	    }
	
	    console.warn(message, 'font-weight: bold', '');
	    return null;
	  }
	
	  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return (_this$player = this.player)[method].apply(_this$player, args);
	}
	
	function isObject(val) {
	  return val !== null && _typeof(val) === 'object';
	} // Deep comparison of two objects, but ignoring functions
	// and React elements, for use in shouldComponentUpdate
	
	
	function isEqual(a, b) {
	  if (typeof a === 'function' && typeof b === 'function') {
	    return true;
	  }
	
	  if ((0, _react.isValidElement)(a) && (0, _react.isValidElement)(b)) {
	    return true;
	  }
	
	  if (a instanceof Array && b instanceof Array) {
	    if (a.length !== b.length) {
	      return false;
	    }
	
	    for (var i = 0; i !== a.length; i++) {
	      if (!isEqual(a[i], b[i])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  if (isObject(a) && isObject(b)) {
	    if (Object.keys(a).length !== Object.keys(b).length) {
	      return false;
	    }
	
	    for (var _i3 = 0, _Object$keys = Object.keys(a); _i3 < _Object$keys.length; _i3++) {
	      var key = _Object$keys[_i3];
	
	      if (!isEqual(a[key], b[key])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return a === b;
	}
	
	function isMediaStream(url) {
	  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
	}

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _map = __webpack_require__(435);
	var _reduce = __webpack_require__(112);
	var _xmap = __webpack_require__(3129);
	var curryN = __webpack_require__(80);
	var keys = __webpack_require__(136);
	
	
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      var double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 * @symb R.map(f, [a, b]) = [f(a), f(b)]
	 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
	 * @symb R.map(f, functor_o) = functor_o.map(f)
	 */
	module.exports = _curry2(_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function() {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	    case '[object Object]':
	      return _reduce(function(acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	    default:
	      return _map(fn, functor);
	  }
	}));


/***/ },
/* 100 */
96,
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var objectHelper = __webpack_require__(85);
	
	function redirect(url) {
	  getWindow().location = url;
	}
	
	function getDocument() {
	  return getWindow().document;
	}
	
	function getWindow() {
	  return window;
	}
	
	function getOrigin() {
	  var location = getWindow().location;
	  var origin = location.origin;
	
	  if (!origin) {
	    origin = objectHelper.getOriginFromUrl(location.href);
	  }
	
	  return origin;
	}
	
	module.exports = {
	  redirect: redirect,
	  getDocument: getDocument,
	  getWindow: getWindow,
	  getOrigin: getOrigin
	};


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(856);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setModal = setModal;
	exports.clearModal = clearModal;
	exports.modalLoading = modalLoading;
	
	var _modal = __webpack_require__(169);
	
	function setModal(modalName) {
	  return {
	    type: _modal.MODAL_SET,
	    modalName: modalName
	  };
	}
	
	function clearModal() {
	  return {
	    type: _modal.MODAL_CLEAR
	  };
	}
	
	function modalLoading(loading) {
	  return {
	    type: _modal.MODAL_LOADING,
	    loading: loading
	  };
	}

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TextInput(props) {
	  var error = props.meta.touched && props.meta.error ? 'error' : '';
	  var disabled = props.disabled ? 'disabled' : '';
	  var errorClass = props.className + ' small error';
	
	  if (props.img) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-field image' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: props.id },
	        props.label
	      ),
	      _react2.default.createElement('input', Object.assign({}, props.input, {
	        id: props.id,
	        name: props.name,
	        className: (0, _classnames2.default)(error, disabled, props.className),
	        disabled: props.disabled ? true : false,
	        placeholder: props.placeholder,
	        type: props.type
	      })),
	      _react2.default.createElement('img', { alt: 'test', src: props.img }),
	      props.meta.touched && props.meta.error && _react2.default.createElement(
	        'p',
	        { className: errorClass },
	        props.meta.error
	      )
	    );
	  } else {
	    return _react2.default.createElement(
	      'div',
	      { className: 'form-field' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: props.id },
	        props.label
	      ),
	      _react2.default.createElement('input', Object.assign({}, props.input, {
	        id: props.id,
	        name: props.name,
	        className: (0, _classnames2.default)(error, disabled, props.className),
	        disabled: props.disabled ? true : false,
	        placeholder: props.placeholder,
	        type: props.type
	      })),
	      props.meta.touched && props.meta.error && _react2.default.createElement(
	        'p',
	        { className: errorClass },
	        props.meta.error
	      )
	    );
	  }
	}
	
	TextInput.propTypes = {
	  input: _react2.default.PropTypes.object,
	  meta: _react2.default.PropTypes.object
	};
	
	exports.default = TextInput;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearStatusBar = clearStatusBar;
	exports.setStatusBar = setStatusBar;
	
	var _constants = __webpack_require__(562);
	
	function clearStatusBar() {
	  return {
	    type: _constants.CLEAR_STATUS_BAR
	  };
	}
	
	function setStatusBar(message, colour) {
	  return {
	    type: _constants.SET_STATUS_BAR,
	    message: message,
	    colour: colour
	  };
	}

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(15);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _resources = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hasOrganisation = function hasOrganisation(WrapperComponent) {
	  return function (_Component) {
	    _inherits(_class2, _Component);
	
	    function _class2() {
	      _classCallCheck(this, _class2);
	
	      var _this = _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this));
	
	      _this.componentDidMount = function () {
	        var _this$props = _this.props,
	            userInfo = _this$props.userInfo,
	            jsonAPIClient = _this$props.jsonAPIClient;
	
	        if (userInfo) {
	          var organisationId = userInfo.organisationId;
	
	          jsonAPIClient.get(_resources.ORGANISATION_RESOURCE, organisationId).then(function (organisationResource) {
	            var organisation = organisationResource.toJSON();
	            return _this.setState({ organisation: organisation, organisationLoading: false });
	          }).catch(function (err) {
	            (0, _errorHandlingService.reportError)('Unknown error', err);
	            return _this.setState({ organisationError: false, organisationLoading: false });
	          });
	        }
	      };
	
	      _this.state = {
	        organisationLoading: true,
	        organisationError: false
	      };
	      return _this;
	    }
	
	    _createClass(_class2, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, this.state));
	      }
	    }]);
	
	    return _class2;
	  }(_react.Component);
	};
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _hasJsonapiClient2.default, hasOrganisation);

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.timeout = timeout;
	exports.getInfluencerFromOrganisations = getInfluencerFromOrganisations;
	exports.getDate = getDate;
	exports.round = round;
	exports.roundNumberToSmallestDecimal = roundNumberToSmallestDecimal;
	exports.dyzioEngagementScore = dyzioEngagementScore;
	exports.isAnImageFile = isAnImageFile;
	exports.isPdfFile = isPdfFile;
	exports.isWordFile = isWordFile;
	exports.getFileType = getFileType;
	exports.getMostRecentDocument = getMostRecentDocument;
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _assetUrlHelperService = __webpack_require__(362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Promise based timeout
	function timeout(ms) {
	  return new Promise(function (resolve) {
	    return setTimeout(resolve, ms);
	  });
	}
	
	function getInfluencerFromOrganisations(organisations) {
	  if (organisations) {
	    var isDiscussionOrganisation = function isDiscussionOrganisation(organisation) {
	      return organisation.influencer !== null;
	    };
	    var discussionOrganisation = _lodash2.default.find(organisations, isDiscussionOrganisation);
	    var influencer = discussionOrganisation && discussionOrganisation.influencer;
	    return influencer;
	  }
	  return null;
	}
	
	function getDate(dateSent) {
	  var today = (0, _moment2.default)();
	  // let yesterday = moment().subtract(1, 'day');
	
	  if ((0, _moment2.default)(dateSent).isSame(today, 'day')) {
	    var endDate = (0, _moment2.default)(dateSent).format('HH:mm');
	    return 'Today, ' + endDate;
	  }
	  return (0, _moment2.default)(dateSent).format('ddd D MMM, HH:mm');
	}
	
	function round(value, precision) {
	  var multiplier = Math.pow(10, precision || 0);
	  return Math.round(value * multiplier) / multiplier;
	}
	
	function roundNumberToSmallestDecimal(number, precision) {
	  if (precision >= 10 || !number) return 0; // Requires number and high precision means number is too small
	  var roundedNumber = round(number, precision);
	  return roundedNumber || roundNumberToSmallestDecimal(number, precision + 1);
	}
	
	function dyzioEngagementScore(likeCount, dislikeCount, commentCount, viewCount) {
	  var likePercentage = likeCount / viewCount * 100;
	  var dislikePercentage = dislikeCount / viewCount * 100;
	  var commentPercentage = commentCount / viewCount * 100;
	
	  var COMMENT_WEIGHTING = 50;
	  var COMMENT_WEIGHTING_PERCENTAGE = 1;
	  var LIKE_WEIGHTING = 50;
	  var LIKE_WEIGHTING_PERCENTAGE = 5;
	
	  var commentEngagementScore = commentCount ? round(commentPercentage / COMMENT_WEIGHTING_PERCENTAGE * COMMENT_WEIGHTING) : 0;
	  var likeEngagementScore = likeCount && dislikeCount ? round((likePercentage - dislikePercentage) / LIKE_WEIGHTING_PERCENTAGE * LIKE_WEIGHTING) : 0;
	  var dyzioEngagementScore = commentEngagementScore + likeEngagementScore;
	  return dyzioEngagementScore;
	}
	
	function isAnImageFile(filePath) {
	  if (!filePath) return false;
	  return (/\.(gif|jpg|jpeg|tiff|png)$/i.test(filePath)
	  );
	}
	
	function isPdfFile(filePath) {
	  if (!filePath) return false;
	  return _lodash2.default.includes(filePath.toLowerCase(), '.pdf');
	}
	
	function isWordFile(filePath) {
	  if (!filePath) return false;
	  return _lodash2.default.includes(filePath.toLowerCase(), '.doc');
	}
	
	function getFileType(filePath) {
	  if ((0, _assetUrlHelperService.extractYoutubeVideoID)(filePath)) return _staticConfiguration.YOUTUBE_URL;
	  if (isAnImageFile(filePath)) return _staticConfiguration.IMAGE_URL;
	  if (isPdfFile(filePath)) return _staticConfiguration.PDF_URL;
	  if (isWordFile(filePath)) return _staticConfiguration.DOC_URL;
	  return _staticConfiguration.FILE_URL;
	}
	
	function getMostRecentDocument(deliverable) {
	  var highestVersionDocument = null;
	  var currentHighestVersion = 0;
	  if (deliverable.documents && deliverable.documents[0]) {
	    deliverable.documents.forEach(function (document) {
	      if (document.version > currentHighestVersion) {
	        highestVersionDocument = document;
	        currentHighestVersion = document.version;
	      }
	    });
	  }
	  return highestVersionDocument || deliverable.document;
	}

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2469), __esModule: true };

/***/ },
/* 109 */
[4387, 298],
/* 110 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _equals = __webpack_require__(3104);
	
	
	/**
	 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	 * cyclical data structures.
	 *
	 * Dispatches symmetrically to the `equals` methods of both arguments, if
	 * present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> b -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      R.equals(1, 1); //=> true
	 *      R.equals(1, '1'); //=> false
	 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	 *
	 *      var a = {}; a.v = a;
	 *      var b = {}; b.v = b;
	 *      R.equals(a, b); //=> true
	 */
	module.exports = _curry2(function equals(a, b) {
	  return _equals(a, b, [], []);
	});


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var _isArrayLike = __webpack_require__(432);
	var _xwrap = __webpack_require__(1457);
	var bind = __webpack_require__(1435);
	
	
	module.exports = (function() {
	  function _arrayReduce(xf, acc, list) {
	    var idx = 0;
	    var len = list.length;
	    while (idx < len) {
	      acc = xf['@@transducer/step'](acc, list[idx]);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      idx += 1;
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _iterableReduce(xf, acc, iter) {
	    var step = iter.next();
	    while (!step.done) {
	      acc = xf['@@transducer/step'](acc, step.value);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      step = iter.next();
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _methodReduce(xf, acc, obj, methodName) {
	    return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
	  }
	
	  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
	  return function _reduce(fn, acc, list) {
	    if (typeof fn === 'function') {
	      fn = _xwrap(fn);
	    }
	    if (_isArrayLike(list)) {
	      return _arrayReduce(fn, acc, list);
	    }
	    if (typeof list['fantasy-land/reduce'] === 'function') {
	      return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
	    }
	    if (list[symIterator] != null) {
	      return _iterableReduce(fn, acc, list[symIterator]());
	    }
	    if (typeof list.next === 'function') {
	      return _iterableReduce(fn, acc, list);
	    }
	    if (typeof list.reduce === 'function') {
	      return _methodReduce(fn, acc, list, 'reduce');
	    }
	
	    throw new TypeError('reduce: list must be array or iterable');
	  };
	}());


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 114 */
[4233, 3919, 3920, 188, 49, 4058],
/* 115 */
[4387, 336],
/* 116 */
[4413, 1722, 506, 126],
/* 117 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getCampaignId = exports.getCampaignId = function getCampaignId(state) {
	  return state.campaign.get('campaignId');
	};
	var getCampaignName = exports.getCampaignName = function getCampaignName(state) {
	  return state.campaign.getIn(['campaign', 'name']);
	};
	var getCampaignLoading = exports.getCampaignLoading = function getCampaignLoading(state) {
	  return state.campaign.get('campaignLoading');
	};
	var getPermissionId = exports.getPermissionId = function getPermissionId(state) {
	  return state.campaign.get('myPermissionId');
	};
	var getTeamDiscussionId = exports.getTeamDiscussionId = function getTeamDiscussionId(state) {
	  return state.campaign.get('teamDiscussionId');
	};
	var getClientDiscussionId = exports.getClientDiscussionId = function getClientDiscussionId(state) {
	  return state.campaign.get('clientDiscussionId');
	};
	var getPartnerAgencyDiscussionId = exports.getPartnerAgencyDiscussionId = function getPartnerAgencyDiscussionId(state) {
	  return state.campaign.get('partnerAgencyDiscussionId');
	};
	var getTeamOrganisationId = exports.getTeamOrganisationId = function getTeamOrganisationId(state) {
	  return state.campaign.get('teamOrganisationId');
	};
	
	// Extracts members by role, ignores the logged in user.
	var getRoleMembers = exports.getRoleMembers = function getRoleMembers(state, roles) {
	  var members = state.campaign.get('members');
	  var myPermissionId = state.campaign.get('myPermissionId');
	  var roleMembers = [];
	  members.forEach(function (member) {
	    var exists = roles.find(function (role) {
	      return role === member.get('role');
	    });
	    if (exists && myPermissionId !== member.get('id')) {
	      roleMembers.push({ permissionId: member.get('id'), userId: member.getIn(['user', 'id']), name: member.get('name') });
	    }
	  });
	  return roleMembers;
	};

/***/ },
/* 118 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getUserId = exports.getUserId = function getUserId(state) {
	  return state.userData.getIn(['userData', 'id']);
	};
	var getUserName = exports.getUserName = function getUserName(state) {
	  return state.userData.getIn(['userData', 'name']);
	};
	var getOrganisationId = exports.getOrganisationId = function getOrganisationId(state) {
	  return state.userData.getIn(['userData', 'organisationId']);
	};
	var getUserLoaded = exports.getUserLoaded = function getUserLoaded(state) {
	  return state.userData.get('userLoaded');
	};

/***/ },
/* 119 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.trackEvent = trackEvent;
	exports.identifyUser = identifyUser;
	function trackEvent(eventName, eventData) {
	  analytics.track(eventName, _extends({}, eventData));
	}
	
	function identifyUser(userData) {
	  analytics.identify(userData.id, {
	    name: userData.username,
	    email: userData.email
	  });
	}

/***/ },
/* 120 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(87);
	var core = __webpack_require__(64);
	var ctx = __webpack_require__(235);
	var hide = __webpack_require__(197);
	var has = __webpack_require__(196);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 122 */
/***/ function(module, exports) {

	module.exports = {
	  'cap': false,
	  'curry': false,
	  'fixed': false,
	  'immutable': false,
	  'rearg': false
	};


/***/ },
/* 123 */
[4395, 205, 626],
/* 124 */
/***/ function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	module.exports = function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	
	  idx = 0;
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	  idx = 0;
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(45);
	
	var CallbackQueue = __webpack_require__(1506);
	var PooledClass = __webpack_require__(213);
	var ReactFeatureFlags = __webpack_require__(1514);
	var ReactReconciler = __webpack_require__(214);
	var Transaction = __webpack_require__(450);
	
	var invariant = __webpack_require__(36);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 126 */
[4395, 224, 823],
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DyzioStorage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DYZIO_IDENTIFEIR = 'dyzio';
	
	var DyzioStorage = exports.DyzioStorage = function DyzioStorage() {
	  var _this = this;
	
	  _classCallCheck(this, DyzioStorage);
	
	  this.KEYS = {
	    CAMPAIGN_VIEW_MODE: 'campaign-view-modes',
	    CAMPAGINS_LIST_VIEW_MODE: 'campaigns-list-view-mode',
	    TABLE_COLUMNS_SETTINGS: 'table-columns-settings',
	    CAMPAIGNS_LIST_PER_PAGE: 'campaigns-list-per-page',
	    CAMPAIGNS_LIST_SORT_BY: 'campaigns-list-sort-by',
	    CAMPAIGNS_LIST_FILTER: 'campaigns-list-filter',
	    UPGRADE_MODAL_KEY: 'upgrade-modal',
	    SHOW_NEW_INFLUENCER_TAB_MODAL: 'new-influencer-tab'
	  };
	
	  this.set = function (key, value) {
	    localStorage.setItem(DYZIO_IDENTIFEIR + '-' + key, JSON.stringify(value));
	  };
	
	  this.getTableColumnsSettings = function (_ref) {
	    var userId = _ref.userId;
	
	    var record = _this.get(_this.KEYS.TABLE_COLUMNS_SETTINGS + '-' + userId);
	    if (!record || !record.columns) {
	      return {
	        columns: {}
	      };
	    }
	    return record;
	  };
	
	  this.updateTableColumnSettings = function (_ref2) {
	    var userId = _ref2.userId,
	        settings = _ref2.settings;
	
	    _this.set(_this.KEYS.TABLE_COLUMNS_SETTINGS + '-' + userId, settings);
	  };
	
	  this.getCampaignSettings = function (_ref3) {
	    var campaignId = _ref3.campaignId,
	        key = _ref3.key;
	    return _this.get(key + '-' + campaignId);
	  };
	
	  this.updateCampaignSettings = function (_ref4) {
	    var campaignId = _ref4.campaignId,
	        key = _ref4.key,
	        value = _ref4.value;
	    return _this.set(key + '-' + campaignId, value);
	  };
	
	  this.get = function (key) {
	    var value = localStorage.getItem(DYZIO_IDENTIFEIR + '-' + key);
	    try {
	      return value ? JSON.parse(value) : {};
	    } catch (error) {
	      return {};
	    }
	  };
	};
	
	var hasLocalStorageClient = function hasLocalStorageClient(WrapperComponent) {
	  return function (_Component) {
	    _inherits(HasLocalStorageClient, _Component);
	
	    function HasLocalStorageClient() {
	      _classCallCheck(this, HasLocalStorageClient);
	
	      return _possibleConstructorReturn(this, (HasLocalStorageClient.__proto__ || Object.getPrototypeOf(HasLocalStorageClient)).apply(this, arguments));
	    }
	
	    _createClass(HasLocalStorageClient, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, { dyzioStorage: new DyzioStorage() }));
	      }
	    }]);
	
	    return HasLocalStorageClient;
	  }(_react.Component);
	};
	
	exports.default = hasLocalStorageClient;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderCurrencyQuantity = exports.renderCurrencySymbol = exports.CURRENCY_USD = exports.CURRENCY_EUR = exports.CURRENCY_GBP = exports.DYZIO_CURRENCIES = undefined;
	
	var _countryData = __webpack_require__(175);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DYZIO_ENABLED_CURRENCIES_ALL = _lodash2.default.map(_countryData.currencies.all, 'code');
	
	var DYZIO_ENABLED_CURRENCIES_DEFAULTS = ['GBP', 'USD', 'EUR', 'divider'];
	
	var DYZIO_ENABLED_CURRENCIES_NON_DEFAULTS = _lodash2.default.reject(DYZIO_ENABLED_CURRENCIES_ALL, function (code) {
	  return code === 'GBP' || code === 'USD' || code === 'EUR';
	});
	
	var DYZIO_ENABLED_CURRENCIES = _lodash2.default.concat(DYZIO_ENABLED_CURRENCIES_DEFAULTS, DYZIO_ENABLED_CURRENCIES_NON_DEFAULTS);
	
	var generateDyzioCurrencies = function generateDyzioCurrencies() {
	  return _lodash2.default.map(DYZIO_ENABLED_CURRENCIES, function (currencyCode) {
	    var currency = _lodash2.default.find(_countryData.currencies.all, ['code', currencyCode]);
	    if (currencyCode === 'divider') {
	      return { component: _semanticUiReact.Dropdown.Divider };
	    }
	    return {
	      key: currency.code,
	      text: currency.symbol + ' - ' + currency.name + ' (' + currency.code + ')',
	      value: currency.code
	    };
	  });
	};
	
	var DYZIO_CURRENCIES = exports.DYZIO_CURRENCIES = generateDyzioCurrencies();
	
	var CURRENCY_GBP = exports.CURRENCY_GBP = 'GBP';
	var CURRENCY_EUR = exports.CURRENCY_EUR = 'EUR';
	var CURRENCY_USD = exports.CURRENCY_USD = 'USD';
	
	var renderCurrencySymbol = exports.renderCurrencySymbol = function renderCurrencySymbol(currencyCode) {
	  var currency = _lodash2.default.find(_countryData.currencies.all, ['code', currencyCode]);
	  return currency ? currency.symbol : '';
	};
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	
	var renderCurrencyQuantity = exports.renderCurrencyQuantity = function renderCurrencyQuantity(_ref) {
	  var currency = _ref.currency,
	      amount = _ref.amount;
	  return renderCurrencySymbol(currency) + ' ' + cf(amount);
	};

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createCampaign = createCampaign;
	exports.getCampaignOld = getCampaignOld;
	exports.getCampaign = getCampaign;
	exports.getCampaignMembers = getCampaignMembers;
	exports.getCampaignDiscussions = getCampaignDiscussions;
	exports.getScheduleDeliverables = getScheduleDeliverables;
	exports.updateCampaign = updateCampaign;
	exports.getCampaignDiscussionsOld = getCampaignDiscussionsOld;
	exports.getCampaignPermissions = getCampaignPermissions;
	exports.removeCampaignPermissionFromCampaign = removeCampaignPermissionFromCampaign;
	exports.removePendingInviationFromCampaign = removePendingInviationFromCampaign;
	exports.addDiscussionToCampaign = addDiscussionToCampaign;
	exports.addCampaignPermission = addCampaignPermission;
	exports.addChatDiscussionToCamapign = addChatDiscussionToCamapign;
	exports.getCampaignTrackedAssets = getCampaignTrackedAssets;
	exports.updateCampaignTrackedAssets = updateCampaignTrackedAssets;
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	var _authService = __webpack_require__(21);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO Client brief needs adding
	function createCampaign(campaignData, clientOrganisationData) {
	  var client = (0, _jsonapiService2.default)();
	
	  var campaign = client.create('campaigns');
	  campaign.set('name', campaignData.name);
	  campaign.set('campaignType', campaignData.campaignType);
	  campaign.set('memberCount', 1);
	  campaign.set('description', 'Description generated at ' + new Date().toTimeString());
	  campaign.set('budget', campaignData.budget);
	  campaign.set('clientBrief', 'https://s3-eu-west-1.amazonaws.com/cf-templates-o6s432he4qgr-eu-west-1/2016202Jd5-dyzio-aws-stack.json');
	  if (campaignData.liveDate) campaign.set('liveDate', campaignData.liveDate);
	  if (clientOrganisationData.hasClient === 'yes') {
	    campaign.set('client', { type: 'organisations', id: clientOrganisationData.id });
	  }
	
	  return campaign.sync().then(function (response) {
	    return response;
	  });
	}
	
	function getCampaignOld(campaignId) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('campaigns', campaignId, { include: ['owner', 'pendingInvitations', 'members'] }).then(function (response) {
	    return response;
	  });
	}
	
	function makeCampaignQuery(campaignId) {
	  var query = '\n  query CampaignDiscussions {\n    campaigns(id: "' + campaignId + '") {\n      id\n      name\n      description\n      budget\n      campaignType\n      liveDate\n      endDate\n      currency\n      approvalStatus\n      workflow\n      hashtags\n      discussions {\n        id\n        name\n        budget\n      }\n      owner {\n        id\n        name\n      }\n      client {\n        id\n        name\n      }\n      partnerAgency {\n        id\n        name\n      }\n      memberCount\n      members {\n        id\n        name\n        email\n        campaign {\n          id\n        }\n        organisation {\n          id\n          name\n        }\n        role\n        metadata\n        sendDailyNotifications\n        sendWeeklyNotifications\n      }\n      pendingInvitations {\n        id\n        email\n        name\n        campaign {\n          id\n        }\n        role\n        organisation {\n          id\n          name\n        }\n        status\n        metadata\n      }\n      teamDiscussion\n      clientDiscussion\n      partnerAgencyDiscussion\n      createdDate\n      createdBy\n    }\n  }\n  ';
	  return query;
	}
	
	function getCampaign(campaignId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, {
	    Authorization: 'Bearer ' + _authService.authService.getToken()
	  });
	  var query = makeCampaignQuery(campaignId);
	
	  console.log('IN THE ORIGINAL CODE');
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    return response.data.data.campaigns[0];
	  });
	}
	
	function getCampaignMembers(campaignId) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('campaigns', campaignId, { include: ['members'] }).then(function (response, error) {
	    return (
	      // Returns resource object
	      response
	    );
	  });
	}
	
	function makeCampaignDiscussionQuery(campaignId) {
	  var query = '\n  query CampaignDiscussions {\n    campaigns(id: "' + campaignId + '") {\n      id\n      currency\n      discussions {\n        id\n        name\n        budget\n        budgetStatus\n        discussionType\n        lastScannedDate\n        lastSuccessfulStoryScan\n        isScanningCompleted\n        internalDiscountCode\n        workflowStatus\n        discountCode\n        commission\n        stories {\n          id\n          platform\n          caption\n          assetId\n          assetURL\n          assetType\n          createdDate\n          createdBy\n          createdSource\n          latestReach\n          latestImpressions\n          savedThumbnailUrl\n        }\n        organisations {\n          id\n          name\n          influencer {\n            id\n            name\n            email\n            totalSocialReach\n            youtubeCount\n            facebookCount\n            twitterCount\n            instagramCount\n            primarySocialHandle\n            youtubeChannelTitle\n            thumbnail\n            facebook\n            twitter\n            instagram\n            youtube\n            instagramVerified\n            twitterVerified\n            facebookVerified\n            instagramAuthorised\n            twitterAuthorised\n            facebookAuthorised\n            youtubeAuthorised\n            instagramStatus\n            twitterStatus\n            facebookStatus\n            youtubeStatus\n            instagramBusinessAccount\n          }\n        }\n        invitations {\n          id\n          status\n          link\n          metadata\n        }\n        channelURL\n        currentBrief\n        members {\n          id\n          name\n          role\n        }\n        documents {\n          id\n          name\n          filePath\n          docType\n          fileType\n          size\n          discussion {\n            id\n          }\n          message\n          approved\n          createdBy\n          createdDate\n          approvedBy\n          approvalDate\n          version\n        }\n        deliverables {\n          id\n          title\n          channelType\n          assetType\n          dueDate\n          liveDateEnd\n          live\n          description\n          createdBy\n          createdDate\n          document {\n            id\n            name\n            approved\n            version\n          }\n          documents {\n            id\n            name\n            approved\n            version\n          }\n        }\n        trackedAssets {\n          id\n          assetId\n          assetURL\n          platform\n          assetType\n          createdBy\n          createdDate\n          createdSource\n          publishedDate\n          savedThumbnailUrl\n          supportingData {\n            id\n            filePath\n            engagements\n            impressions\n            saves\n            reach\n            createdBy\n            createdDate\n          }\n        }\n        currentContract\n        signedContract\n      }\n    }\n  }\n  ';
	  return query;
	}
	
	function getCampaignDiscussions(campaignId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, {
	    Authorization: 'Bearer ' + _authService.authService.getToken()
	  });
	  var query = makeCampaignDiscussionQuery(campaignId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    return response.data.data.campaigns[0].discussions;
	  });
	}
	
	function makeScheduleDeliverablesQuery(campaignId) {
	  var query = '\n  query ScheduleDeliverables {\n    campaigns(id: "' + campaignId + '") {\n      id\n      name\n      discussions {\n        id\n        name\n        members {\n          id\n          name\n          role\n        }\n        deliverables {\n          id\n          title\n          channelType\n          assetType\n          dueDate\n          liveDateEnd\n          live\n          description\n          createdBy\n          createdDate\n          document {\n            id\n            name\n            approved\n            docType\n            filePath\n            message\n            createdDate\n            createdBy\n            removed\n            approvedBy\n            approvalDate\n            version\n          }\n          documents {\n            id\n            name\n            approved\n            docType\n            filePath\n            message\n            createdDate\n            createdBy\n            removed\n            approvedBy\n            approvalDate\n            version\n          }\n          version\n        }\n      }\n    }\n  }\n  ';
	  return query;
	}
	
	function getScheduleDeliverables(campaignId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = makeScheduleDeliverablesQuery(campaignId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    return response.data.data.campaigns[0];
	  });
	}
	
	function updateCampaign(id, budget) {
	  var client = (0, _jsonapiService2.default)();
	  return client.get('campaigns', id).then(function (campaign) {
	    if (budget) campaign.set('budget', budget);
	    return campaign.sync();
	  });
	}
	
	function getCampaignDiscussionsOld(campaignId) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('campaigns', campaignId, { include: ['discussions'] }).then(function (response) {
	    // Returns JSON object
	    var campaign = response.toJSONTree();
	    return campaign.discussions;
	  });
	}
	
	function getCampaignPermissions(userId) {
	  console.log('getCampaignPermissions');
	  var client = (0, _jsonapiService2.default)();
	  var options = {
	    filter: {
	      user: userId
	    },
	    include: ['campaign'],
	    sort: ['-createdDate']
	  };
	
	  return client.find('campaignPermission', options).then(function (permissions) {
	    var campaignPermissions = [];
	    permissions.forEach(function (permission) {
	      campaignPermissions.push(permission.toJSONTree());
	    });
	    // Returns JSON object
	    return campaignPermissions;
	  });
	}
	
	function removeCampaignPermissionFromCampaign(campaignId, campaignPermission) {
	  var client = (0, _jsonapiService2.default)();
	
	  client.get('campaigns', campaignId, {}).then(function (campaign) {
	    campaign.relationships('members').remove(campaignPermission);
	    return campaign.sync().then(function (campaign) {
	      return campaign;
	    });
	  });
	}
	
	function removePendingInviationFromCampaign(campaignId, campaignInvitation) {
	  // TODO Requires it's own client to not have circular issues which needs addressing
	  var client = (0, _jsonapiService2.default)();
	
	  client.get('campaigns', campaignId, {}).then(function (campaign) {
	    campaign.relationships('pendingInvitations').remove(campaignInvitation);
	    return campaign.sync().then(function (campaign) {
	      return campaign;
	    });
	  });
	}
	
	function addDiscussionToCampaign(campaignId, discussion) {
	  var client = (0, _jsonapiService2.default)();
	
	  client.get('campaigns', campaignId, {}).then(function (campaign) {
	    campaign.relationships('discussions').add(discussion);
	    return campaign.sync().then(function (campaign) {
	      return campaign;
	    });
	  });
	}
	
	function addCampaignPermission(campaignResource, campaignPermission) {
	  campaignResource.relationships('members').add(campaignPermission);
	  return campaignResource.sync().then(function (response) {
	    return response;
	  });
	}
	
	// This doesn't sync the data but instead only preps the resource for syncing.
	function addChatDiscussionToCamapign(campaignResource, discussionName, discussionResource) {
	  campaignResource.relationships('discussions').add(discussionResource);
	  campaignResource.set(discussionName, discussionResource.toJSON().id);
	}
	
	function makeCampaignTrackedAssetsQuery(campaignId) {
	  var query = '\n  query CampaignTrackedAssets {\n    campaigns(id: "' + campaignId + '") {\n      id\n      name\n      trackedAssets {\n        id\n        assetId\n        assetURL\n        platform\n        assetType\n        createdSource\n        createdBy\n        createdDate\n        user {\n          id\n        }\n        campaign {\n          id\n          name\n        }\n        discussion {\n          id\n          name\n        }\n      }\n      discussions {\n        id\n        name\n        trackedAssets {\n          id\n          assetId\n          assetURL\n          platform\n          assetType\n          createdSource\n          createdBy\n          createdDate\n          user {\n            id\n          }\n          campaign {\n            id\n            name\n          }\n          discussion {\n            id\n            name\n          }\n        }\n      }\n    }\n  }';
	  return query;
	}
	
	function getCampaignTrackedAssets(campaignId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = makeCampaignTrackedAssetsQuery(campaignId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    var campaign = response.data.data.campaigns[0];
	    var trackedAssetsList = [];
	    if (campaign.trackedAssets && campaign.trackedAssets[0]) {
	      campaign.trackedAssets.forEach(function (trackedAsset) {
	        return trackedAssetsList.push(trackedAsset);
	      });
	    }
	    campaign.discussions.forEach(function (discussion) {
	      if (discussion.trackedAssets && discussion.trackedAssets[0]) {
	        discussion.trackedAssets.forEach(function (trackedAsset) {
	          return trackedAssetsList.push(trackedAsset);
	        });
	      }
	    });
	    return trackedAssetsList;
	  });
	}
	
	function updateCampaignTrackedAssets(campaignId, trackedAsset) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('campaigns', campaignId, {}).then(function (campaign) {
	    campaign.relationships('trackedAssets').add(trackedAsset);
	    return campaign.sync();
	  });
	}

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(2397);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(938);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(2404);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(2403);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(174);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 133 */
[4221, 244, 2674, 2705],
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createSinglePlayer;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _props = __webpack_require__(411);
	
	var _utils = __webpack_require__(98);
	
	var _Player = _interopRequireDefault(__webpack_require__(632));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SUPPORTED_PROPS = Object.keys(_props.propTypes);
	
	function createSinglePlayer(activePlayer) {
	  var _class, _temp;
	
	  return _temp = _class = /*#__PURE__*/function (_Component) {
	    _inherits(SinglePlayer, _Component);
	
	    var _super = _createSuper(SinglePlayer);
	
	    function SinglePlayer() {
	      var _this;
	
	      _classCallCheck(this, SinglePlayer);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _super.call.apply(_super, [this].concat(args));
	
	      _defineProperty(_assertThisInitialized(_this), "config", (0, _utils.getConfig)(_this.props, _props.defaultProps, true));
	
	      _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
	        if (!_this.player) return null;
	        return _this.player.getDuration();
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
	        if (!_this.player) return null;
	        return _this.player.getCurrentTime();
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
	        if (!_this.player) return null;
	        return _this.player.getSecondsLoaded();
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
	        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
	        if (!_this.player) return null;
	        return _this.player.getInternalPlayer(key);
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
	        if (!_this.player) return null;
	
	        _this.player.seekTo(fraction, type);
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
	        _this.player = player;
	      });
	
	      return _this;
	    }
	
	    _createClass(SinglePlayer, [{
	      key: "shouldComponentUpdate",
	      value: function shouldComponentUpdate(nextProps) {
	        return !(0, _utils.isEqual)(this.props, nextProps);
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate() {
	        this.config = (0, _utils.getConfig)(this.props, _props.defaultProps);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this$config$file = this.config.file,
	            forceVideo = _this$config$file.forceVideo,
	            forceAudio = _this$config$file.forceAudio,
	            forceHLS = _this$config$file.forceHLS,
	            forceDASH = _this$config$file.forceDASH;
	        var skipCanPlay = forceVideo || forceAudio || forceHLS || forceDASH;
	
	        if (!activePlayer.canPlay(this.props.url) && !skipCanPlay) {
	          return null;
	        }
	
	        var _this$props = this.props,
	            style = _this$props.style,
	            width = _this$props.width,
	            height = _this$props.height,
	            Wrapper = _this$props.wrapper;
	        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props.DEPRECATED_CONFIG_PROPS);
	        return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
	          style: _objectSpread({}, style, {
	            width: width,
	            height: height
	          })
	        }, otherProps), /*#__PURE__*/_react["default"].createElement(_Player["default"], _extends({}, this.props, {
	          ref: this.ref,
	          activePlayer: activePlayer,
	          config: this.config
	        })));
	      }
	    }]);
	
	    return SinglePlayer;
	  }(_react.Component), _defineProperty(_class, "displayName", "".concat(activePlayer.displayName, "Player")), _defineProperty(_class, "propTypes", _props.propTypes), _defineProperty(_class, "defaultProps", _props.defaultProps), _defineProperty(_class, "canPlay", activePlayer.canPlay), _temp;
	}

/***/ },
/* 135 */
/***/ function(module, exports) {

	module.exports = function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0: return function() { return fn.apply(this, arguments); };
	    case 1: return function(a0) { return fn.apply(this, arguments); };
	    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
	    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
	    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
	    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
	    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
	    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	};


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _has = __webpack_require__(90);
	var _isArguments = __webpack_require__(1452);
	
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @see R.keysIn, R.values
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	module.exports = (function() {
	  // cover IE < 9 keys issues
	  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
	                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	  // Safari bug
	  var hasArgsEnumBug = (function() {
	    'use strict';
	    return arguments.propertyIsEnumerable('length');
	  }());
	
	  var contains = function contains(list, item) {
	    var idx = 0;
	    while (idx < list.length) {
	      if (list[idx] === item) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  };
	
	  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
	    _curry1(function keys(obj) {
	      return Object(obj) !== obj ? [] : Object.keys(obj);
	    }) :
	    _curry1(function keys(obj) {
	      if (Object(obj) !== obj) {
	        return [];
	      }
	      var prop, nIdx;
	      var ks = [];
	      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	      for (prop in obj) {
	        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	          ks[ks.length] = prop;
	        }
	      }
	      if (hasEnumBug) {
	        nIdx = nonEnumerableProps.length - 1;
	        while (nIdx >= 0) {
	          prop = nonEnumerableProps[nIdx];
	          if (_has(prop, obj) && !contains(ks, prop)) {
	            ks[ks.length] = prop;
	          }
	          nIdx -= 1;
	        }
	      }
	      return ks;
	    });
	}());


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var _reduce = __webpack_require__(112);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * [`R.reduced`](#reduced) to shortcut the iteration.
	 *
	 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
	 * is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present. When
	 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
	 * shortcuting, as this is not implemented by `reduce`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *                -               -10
	 *               / \              / \
	 *              -   4           -6   4
	 *             / \              / \
	 *            -   3   ==>     -3   3
	 *           / \              / \
	 *          -   2           -1   2
	 *         / \              / \
	 *        0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	module.exports = _curry3(_reduce);


/***/ },
/* 138 */
[4333, 1608],
/* 139 */
47,
/* 140 */
[4221, 269, 3965, 3996],
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 142 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_DISCUSSION = exports.LOAD_DISCUSSION = 'Dyzio/Discussion/LOAD_DISCUSSION';
	var LOAD_DISCUSSION_ERROR = exports.LOAD_DISCUSSION_ERROR = 'Dyzio/Discussion/LOAD_DISCUSSION_ERROR';
	var LOAD_DISCUSSION_SUCCESS = exports.LOAD_DISCUSSION_SUCCESS = 'Dyzio/Discussion/LOAD_DISCUSSION_SUCCESS';
	
	var CLEAR_DISCUSSION = exports.CLEAR_DISCUSSION = 'Dyzio/Discussion/CLEAR_DISCUSSION';
	var SET_DISCUSSION = exports.SET_DISCUSSION = 'Dyzio/Discussion/SET_DISCUSSION';
	
	var LOAD_SENDBIRD_MESSAGES = exports.LOAD_SENDBIRD_MESSAGES = 'Dyzio/Discussion/LOAD_SENDBIRD_MESSAGES';
	var LOAD_MORE_MESSAGES = exports.LOAD_MORE_MESSAGES = 'Dyzio/Discussion/LOAD_MORE_MESSAGES';
	
	var SEND_MESSAGE = exports.SEND_MESSAGE = 'Dyzio/Discussion/SEND_MESSAGE';
	var RECEIVE_MESSAGE = exports.RECEIVE_MESSAGE = 'Dyzio/Discussion/RECEIVE_MESSAGE';
	var UPDATE_MESSAGES = exports.UPDATE_MESSAGES = 'Dyzio/Discussion/UPDATE_MESSAGES';
	var DELETE_MESSAGE = exports.DELETE_MESSAGE = 'Dyzio/Discussion/DELETE_MESSAGE';
	
	var NEW_DOCUMENT = exports.NEW_DOCUMENT = 'Dyzio/Discussion/NEW_DOCUMENT';
	var UPDATE_DOCUMENTS = exports.UPDATE_DOCUMENTS = 'Dyzio/Discussion/UPDATE_DOCUMENTS';
	var REMOVE_DOCUMENT = exports.REMOVE_DOCUMENT = 'Dyzio/Discussion/REMOVE_DOCUMENT';
	var APPROVE_DOCUMENT = exports.APPROVE_DOCUMENT = 'Dyzio/Discussion/APPROVE_DOCUMENT';
	var UNAPPROVE_DOCUMENT = exports.UNAPPROVE_DOCUMENT = 'Dyzio/Discussion/UNAPPROVE_DOCUMENT';
	
	var UPDATE_DELIVERABLES = exports.UPDATE_DELIVERABLES = 'Dyzio/Discussion/UPDATE_DELIVERABLES';
	var UPDATE_DELIVERABLE_DOCUMENT = exports.UPDATE_DELIVERABLE_DOCUMENT = 'Dyzio/Discussion/UPDATE_DELIVERABLE_DOCUMENT';
	var UPDATE_DELIVERABLE_IS_LIVE = exports.UPDATE_DELIVERABLE_IS_LIVE = 'Dyzio/Discussion/UPDATE_DELIVERABLE_IS_LIVE';
	
	var UPDATE_DELIVERABLE_APPROVED = exports.UPDATE_DELIVERABLE_APPROVED = 'Dyzio/Discussion/UPDATE_DELIVERABLE_APPROVED';
	var UPDATE_DELIVERABLE_APPROVED_SUCCESS = exports.UPDATE_DELIVERABLE_APPROVED_SUCCESS = 'Dyzio/Discussion/UPDATE_DELIVERABLE_APPROVED_SUCCESS';
	var UPDATE_DELIVERABLE_APPROVED_ERROR = exports.UPDATE_DELIVERABLE_APPROVED_ERROR = 'Dyzio/Discussion/UPDATE_DELIVERABLE_APPROVED_ERROR';
	
	var SET_DISCUSSION_TYPE = exports.SET_DISCUSSION_TYPE = 'Dyzio/Discussion/SET_DISCUSSION_TYPE';
	
	var UPDATE_CURRENT_BRIEF = exports.UPDATE_CURRENT_BRIEF = 'Dyzio/Discussion/UPDATE_CURRENT_BRIEF';
	var UPDATE_CURRENT_CONTRACT = exports.UPDATE_CURRENT_CONTRACT = 'Dyzio/Discussion/UPDATE_CURRENT_CONTRACT';
	var UPDATE_SIGNED_CONTRACT = exports.UPDATE_SIGNED_CONTRACT = 'Dyzio/Discussion/UPDATE_SIGNED_CONTRACT';
	
	var UPDATE_DOCS_STATUS = exports.UPDATE_DOCS_STATUS = 'Dyzio/Discussion/UPDATE_DOCS_STATUS';
	var UPDATE_DELIVERABLE_STATUS = exports.UPDATE_DELIVERABLE_STATUS = 'Dyzio/Discussion/UPDATE_DELIVERABLE_STATUS';
	var UPDATE_BUDGET = exports.UPDATE_BUDGET = 'Dyzio/Discussion/UPDATE_BUDGET';
	var UPDATE_BUDGET_SUCCESS = exports.UPDATE_BUDGET_SUCCESS = 'Dyzio/Discussion/UPDATE_BUDGET_SUCCESS';
	var UPDATE_BUDGET_ERROR = exports.UPDATE_BUDGET_ERROR = 'Dyzio/Discussion/UPDATE_BUDGET_ERROR';
	
	var UPDATE_TRACKED_ASSETS = exports.UPDATE_TRACKED_ASSETS = 'Dyzio/Discussion/UPDATE_TRACKED_ASSETS';

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkUserIsTeamMember = checkUserIsTeamMember;
	exports.checkUserHasAdminRights = checkUserHasAdminRights;
	
	var _staticConfiguration = __webpack_require__(27);
	
	function checkUserIsTeamMember(role) {
	  if (role === _staticConfiguration.CAMPAIGN_OWNER || role === _staticConfiguration.CAMPAIGN_ADMIN || role === _staticConfiguration.TEAM_MEMBER) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	function checkUserHasAdminRights(role) {
	  if (role === _staticConfiguration.CAMPAIGN_OWNER || role === _staticConfiguration.CAMPAIGN_ADMIN) {
	    return true;
	  } else {
	    return false;
	  }
	}

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(236)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(132);
	var IE8_DOM_DEFINE = __webpack_require__(945);
	var toPrimitive = __webpack_require__(590);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(144) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _formatting = __webpack_require__(52);
	
	var _demographicRow = __webpack_require__(2552);
	
	var _demographicRow2 = _interopRequireDefault(_demographicRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DemographicsLocationTable = function DemographicsLocationTable(_ref) {
	  var data = _ref.data,
	      uniqueKey = _ref.uniqueKey,
	      metric = _ref.metric,
	      itemLabel = _ref.itemLabel,
	      metricLabel = _ref.metricLabel,
	      rowsToShow = _ref.rowsToShow;
	
	  var rows = _lodash2.default.orderBy(data, metric, ['desc']);
	  var displayed = rowsToShow < 0 ? rows : _lodash2.default.take(rows, rowsToShow);
	  var restOfTheWorld = _lodash2.default.filter(data, function (item) {
	    return !_lodash2.default.find(displayed, [uniqueKey, item[uniqueKey]]);
	  });
	  var totalMetric = _lodash2.default.sumBy(rows, metric);
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { basic: 'very', columns: 'three', singleLine: true, textAlign: 'center' },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Header,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { textAlign: 'left' },
	          itemLabel
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          metricLabel || _lodash2.default.startCase(metric)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Percentage'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _lodash2.default.map(displayed, function (row) {
	        return _react2.default.createElement(_demographicRow2.default, {
	          row: row,
	          metric: metric,
	          uniqueKey: uniqueKey,
	          totalMetric: totalMetric
	        });
	      }),
	      !_lodash2.default.isEmpty(restOfTheWorld) && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { textAlign: 'left' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'globe', color: 'pink' }),
	          '  Rest of World'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfTheWorld, metric))
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfTheWorld, function (row) {
	            return row.percentage || 100 * row[metric] / totalMetric;
	          })),
	          ' %'
	        )
	      )
	    )
	  );
	};
	
	DemographicsLocationTable.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  metric: _propTypes2.default.string.isRequired,
	  itemLabel: _propTypes2.default.string,
	  metricLabel: _propTypes2.default.string,
	  uniqueKey: _propTypes2.default.string,
	  rowsToShow: _propTypes2.default.number
	};
	
	DemographicsLocationTable.defaultProps = {
	  metricLabel: undefined,
	  uniqueKey: 'countryCode',
	  itemLabel: 'Country',
	  rowsToShow: 5
	};
	
	exports.default = DemographicsLocationTable;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var itemStyle = {
	  padding: 10
	};
	
	var Pagination = function Pagination(props) {
	  var onPageIncrement = props.onPageIncrement,
	      onPageDecrement = props.onPageDecrement,
	      currentPage = props.currentPage,
	      totalPages = props.totalPages;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Menu,
	    { floated: 'right', pagination: true },
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      { style: itemStyle, onClick: onPageDecrement, as: 'a', icon: true, disabled: currentPage <= 1 },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'left chevron' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      { style: itemStyle, as: 'span' },
	      currentPage,
	      ' / ',
	      totalPages
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      { style: itemStyle, onClick: onPageIncrement, as: 'a', icon: true, disabled: currentPage === totalPages },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'right chevron' })
	    )
	  );
	};
	
	Pagination.propTypes = {
	  onPageIncrement: _propTypes2.default.func.isRequired,
	  onPageDecrement: _propTypes2.default.func.isRequired,
	  currentPage: _propTypes2.default.number.isRequired,
	  totalPages: _propTypes2.default.number.isRequired
	};
	
	exports.default = Pagination;

/***/ },
/* 148 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 149 */
[4391, 389, 123, 627, 150, 305],
/* 150 */
[4435, 1041],
/* 151 */
[4438, 612],
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.6',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0',
	            scalePercentBy100: true
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat,
	            scalePercentBy100: defaults.scalePercentBy100
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                leadingCount = 0,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, 0, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (int.length < leadingCount) {
	                for (var i = leadingCount - int.length; i > 0; i--) {
	                    int = '0' + int;
	                }
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        numeral.register('format', 'bps', {
	            regexps: {
	                format: /(BPS)/,
	                unformat: /(BPS)/
	            },
	            format: function(value, format, roundingFunction) {
	                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
	                    output;
	
	                value = value * 10000;
	
	                // check for space before BPS
	                format = format.replace(/\s?BPS/, '');
	
	                output = numeral._.numberToFormat(value, format, roundingFunction);
	
	                if (numeral._.includes(output, ')')) {
	                    output = output.split('');
	
	                    output.splice(-1, 0, space + 'BPS');
	
	                    output = output.join('');
	                } else {
	                    output = output + space + 'BPS';
	                }
	
	                return output;
	            },
	            unformat: function(string) {
	                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
	            }
	        });
	})();
	
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
	            return decimal.suffixes.indexOf(item) < 0;
	        }));
	        var unformatRegex = allSuffixes.join('|');
	        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
	        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp(unformatRegex)
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            if (numeral.options.scalePercentBy100) {
	                value = value * 100;
	            }
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            var number = numeral._.stringToNumber(string);
	            if (numeral.options.scalePercentBy100) {
	                return number * 0.01;
	            }
	            return number;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get2 = __webpack_require__(109);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isNil2 = __webpack_require__(74);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Checkbox = __webpack_require__(418);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Radio = __webpack_require__(637);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A field is a form element containing a label and an input.
	 * @see Form
	 * @see Button
	 * @see Checkbox
	 * @see Dropdown
	 * @see Input
	 * @see Radio
	 * @see Select
	 * @see Visibility
	 */
	function FormField(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      control = props.control,
	      disabled = props.disabled,
	      error = props.error,
	      inline = props.inline,
	      label = props.label,
	      required = props.required,
	      type = props.type,
	      width = props.width;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(inline, 'inline'), (0, _lib.useKeyOnly)(required, 'required'), (0, _lib.useWidthProp)(width, 'wide'), 'field', className);
	  var rest = (0, _lib.getUnhandledProps)(FormField, props);
	  var ElementType = (0, _lib.getElementType)(FormField, props);
	
	  // ----------------------------------------
	  // No Control
	  // ----------------------------------------
	
	  if ((0, _isNil3.default)(control)) {
	    if ((0, _isNil3.default)(label)) {
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        _lib.childrenUtils.isNil(children) ? content : children
	      );
	    }
	
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      (0, _lib.createHTMLLabel)(label)
	    );
	  }
	
	  // ----------------------------------------
	  // Checkbox/Radio Control
	  // ----------------------------------------
	  var controlProps = (0, _extends3.default)({}, rest, { content: content, children: children, disabled: disabled, required: required, type: type
	
	    // wrap HTML checkboxes/radios in the label
	  });if (control === 'input' && (type === 'checkbox' || type === 'radio')) {
	    return _react2.default.createElement(
	      ElementType,
	      { className: classes },
	      _react2.default.createElement(
	        'label',
	        null,
	        (0, _react.createElement)(control, controlProps),
	        ' ',
	        label
	      )
	    );
	  }
	
	  // pass label prop to controls that support it
	  if (control === _Checkbox2.default || control === _Radio2.default) {
	    return _react2.default.createElement(
	      ElementType,
	      { className: classes },
	      (0, _react.createElement)(control, (0, _extends3.default)({}, controlProps, { label: label }))
	    );
	  }
	
	  // ----------------------------------------
	  // Other Control
	  // ----------------------------------------
	
	  return _react2.default.createElement(
	    ElementType,
	    { className: classes },
	    (0, _lib.createHTMLLabel)(label, { defaultProps: {
	        htmlFor: (0, _get3.default)(controlProps, 'id') }
	    }),
	    (0, _react.createElement)(control, controlProps)
	  );
	}
	
	FormField.handledProps = ['as', 'children', 'className', 'content', 'control', 'disabled', 'error', 'inline', 'label', 'required', 'type', 'width'];
	FormField._meta = {
	  name: 'FormField',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	FormField.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /**
	   * A form control component (i.e. Dropdown) or HTML tagName (i.e. 'input').
	   * Extra FormField props are passed to the control component.
	   * Mutually exclusive with children.
	   */
	  control: _lib.customPropTypes.some([_propTypes2.default.func, _propTypes2.default.oneOf(['button', 'input', 'select', 'textarea'])]),
	
	  /** Individual fields may be disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** Individual fields may display an error state. */
	  error: _propTypes2.default.bool,
	
	  /** A field can have its label next to instead of above it. */
	  inline: _propTypes2.default.bool,
	
	  // Heads Up!
	  // Do not disallow children with `label` shorthand
	  // The `control` might accept a `label` prop and `children`
	  /** Mutually exclusive with children. */
	  label: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object]),
	
	  /** A field can show that input is mandatory. */
	  required: _propTypes2.default.bool,
	
	  /** Passed to the control component (i.e. <input type='password' />) */
	  type: _lib.customPropTypes.every([_lib.customPropTypes.demand(['control'])]
	  // don't strictly validate HTML types
	  // a control might be passed that uses a `type` prop with unknown values
	  // let the control validate if for us
	  ),
	
	  /** A field can specify its width in grid columns */
	  width: _propTypes2.default.oneOf(_lib.SUI.WIDTHS)
	} : {};
	
	exports.default = FormField;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* globals
		AggregateError,
		Atomics,
		FinalizationRegistry,
		SharedArrayBuffer,
		WeakRef,
	*/
	
	var undefined;
	
	var $SyntaxError = SyntaxError;
	var $Function = Function;
	var $TypeError = TypeError;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			// eslint-disable-next-line no-new-func
			return Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(669)();
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var asyncGenFunction = getEvalledConstructor('async function* () {}');
	var asyncGenFunctionPrototype = asyncGenFunction ? asyncGenFunction.prototype : undefined;
	var asyncGenPrototype = asyncGenFunctionPrototype ? asyncGenFunctionPrototype.prototype : undefined;
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': getEvalledConstructor('async function () {}'),
		'%AsyncGenerator%': asyncGenFunctionPrototype,
		'%AsyncGeneratorFunction%': asyncGenFunction,
		'%AsyncIteratorPrototype%': asyncGenPrototype ? getProto(asyncGenPrototype) : undefined,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': getEvalledConstructor('function* () {}'),
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%ReferenceError%': ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	var LEGACY_ALIASES = {
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(668);
	var hasOwn = __webpack_require__(2927);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var PooledClass = __webpack_require__(213);
	
	var emptyFunction = __webpack_require__(110);
	var warning = __webpack_require__(41);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 156 */
[4333, 1541],
/* 157 */
47,
/* 158 */
[4333, 1577],
/* 159 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.check = check;
	exports.remove = remove;
	exports.deferred = deferred;
	exports.arrayOfDeffered = arrayOfDeffered;
	exports.delay = delay;
	exports.createMockTask = createMockTask;
	exports.autoInc = autoInc;
	exports.makeIterator = makeIterator;
	exports.log = log;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var sym = exports.sym = function sym(id) {
	  return '@@redux-saga/' + id;
	};
	var TASK = exports.TASK = sym('TASK');
	var HELPER = exports.HELPER = sym('HELPER');
	var MATCH = exports.MATCH = sym('MATCH');
	var CANCEL = exports.CANCEL = sym('cancelPromise');
	var konst = exports.konst = function konst(v) {
	  return function () {
	    return v;
	  };
	};
	var kTrue = exports.kTrue = konst(true);
	var kFalse = exports.kFalse = konst(false);
	var noop = exports.noop = function noop() {};
	var ident = exports.ident = function ident(v) {
	  return v;
	};
	
	function check(value, predicate, error) {
	  if (!predicate(value)) {
	    log('error', 'uncaught at check', error);
	    throw new Error(error);
	  }
	}
	
	var is = exports.is = {
	  undef: function undef(v) {
	    return v === null || v === undefined;
	  },
	  notUndef: function notUndef(v) {
	    return v !== null && v !== undefined;
	  },
	  func: function func(f) {
	    return typeof f === 'function';
	  },
	  number: function number(n) {
	    return typeof n === 'number';
	  },
	  array: Array.isArray,
	  promise: function promise(p) {
	    return p && is.func(p.then);
	  },
	  iterator: function iterator(it) {
	    return it && is.func(it.next) && is.func(it.throw);
	  },
	  task: function task(t) {
	    return t && t[TASK];
	  },
	  observable: function observable(ob) {
	    return ob && is.func(ob.subscribe);
	  },
	  buffer: function buffer(buf) {
	    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
	  },
	  pattern: function pattern(pat) {
	    return pat && (typeof pat === 'string' || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
	  },
	  channel: function channel(ch) {
	    return ch && is.func(ch.take) && is.func(ch.close);
	  },
	  helper: function helper(it) {
	    return it && it[HELPER];
	  }
	};
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	}
	
	function deferred() {
	  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var def = _extends({}, props);
	  var promise = new Promise(function (resolve, reject) {
	    def.resolve = resolve;
	    def.reject = reject;
	  });
	  def.promise = promise;
	  return def;
	}
	
	function arrayOfDeffered(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(deferred());
	  }
	  return arr;
	}
	
	function delay(ms) {
	  var val = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	  var timeoutId = void 0;
	  var promise = new Promise(function (resolve) {
	    timeoutId = setTimeout(function () {
	      return resolve(val);
	    }, ms);
	  });
	
	  promise[CANCEL] = function () {
	    return clearTimeout(timeoutId);
	  };
	
	  return promise;
	}
	
	function createMockTask() {
	  var _ref;
	
	  var running = true;
	  var _result = void 0,
	      _error = void 0;
	
	  return _ref = {}, _defineProperty(_ref, TASK, true), _defineProperty(_ref, 'isRunning', function isRunning() {
	    return running;
	  }), _defineProperty(_ref, 'result', function result() {
	    return _result;
	  }), _defineProperty(_ref, 'error', function error() {
	    return _error;
	  }), _defineProperty(_ref, 'setRunning', function setRunning(b) {
	    return running = b;
	  }), _defineProperty(_ref, 'setResult', function setResult(r) {
	    return _result = r;
	  }), _defineProperty(_ref, 'setError', function setError(e) {
	    return _error = e;
	  }), _ref;
	}
	
	function autoInc() {
	  var seed = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var kThrow = function kThrow(err) {
	  throw err;
	};
	var kReturn = function kReturn(value) {
	  return { value: value, done: true };
	};
	function makeIterator(next) {
	  var thro = arguments.length <= 1 || arguments[1] === undefined ? kThrow : arguments[1];
	  var name = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	  var isHelper = arguments[3];
	
	  var iterator = { name: name, next: next, throw: thro, return: kReturn };
	
	  if (isHelper) {
	    iterator[HELPER] = true;
	  }
	  if (typeof Symbol !== 'undefined') {
	    iterator[Symbol.iterator] = function () {
	      return iterator;
	    };
	  }
	  return iterator;
	}
	
	/**
	  Print error in a useful way whether in a browser environment
	  (with expandable error stack traces), or in a node.js environment
	  (text-only log output)
	 **/
	function log(level, message, error) {
	  /*eslint-disable no-console*/
	  if (typeof window === 'undefined') {
	    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
	  } else {
	    console[level](message, error);
	  }
	}
	
	var internalErr = exports.internalErr = function internalErr(err) {
	  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
	};

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get2 = __webpack_require__(115);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isNil2 = __webpack_require__(91);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Checkbox = __webpack_require__(495);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Radio = __webpack_require__(770);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A field is a form element containing a label and an input.
	 * @see Form
	 * @see Button
	 * @see Checkbox
	 * @see Dropdown
	 * @see Input
	 * @see Radio
	 * @see Select
	 * @see Visibility
	 */
	function FormField(props) {
	  var children = props.children,
	      className = props.className,
	      control = props.control,
	      disabled = props.disabled,
	      error = props.error,
	      inline = props.inline,
	      label = props.label,
	      required = props.required,
	      type = props.type,
	      width = props.width;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(inline, 'inline'), (0, _lib.useKeyOnly)(required, 'required'), (0, _lib.useWidthProp)(width, 'wide'), 'field', className);
	  var rest = (0, _lib.getUnhandledProps)(FormField, props);
	  var ElementType = (0, _lib.getElementType)(FormField, props);
	
	  // ----------------------------------------
	  // No Control
	  // ----------------------------------------
	
	  if ((0, _isNil3.default)(control)) {
	    if ((0, _isNil3.default)(label)) return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      (0, _lib.createHTMLLabel)(label)
	    );
	  }
	
	  // ----------------------------------------
	  // Checkbox/Radio Control
	  // ----------------------------------------
	  var controlProps = (0, _extends3.default)({}, rest, { children: children, disabled: disabled, required: required, type: type
	
	    // wrap HTML checkboxes/radios in the label
	  });if (control === 'input' && (type === 'checkbox' || type === 'radio')) {
	    return _react2.default.createElement(
	      ElementType,
	      { className: classes },
	      _react2.default.createElement(
	        'label',
	        null,
	        (0, _react.createElement)(control, controlProps),
	        ' ',
	        label
	      )
	    );
	  }
	
	  // pass label prop to controls that support it
	  if (control === _Checkbox2.default || control === _Radio2.default) {
	    return _react2.default.createElement(
	      ElementType,
	      { className: classes },
	      (0, _react.createElement)(control, (0, _extends3.default)({}, controlProps, { label: label }))
	    );
	  }
	
	  // ----------------------------------------
	  // Other Control
	  // ----------------------------------------
	
	  return _react2.default.createElement(
	    ElementType,
	    { className: classes },
	    (0, _lib.createHTMLLabel)(label, { defaultProps: {
	        htmlFor: (0, _get3.default)(controlProps, 'id') }
	    }),
	    (0, _react.createElement)(control, controlProps)
	  );
	}
	
	FormField.handledProps = ['as', 'children', 'className', 'control', 'disabled', 'error', 'inline', 'label', 'required', 'type', 'width'];
	FormField._meta = {
	  name: 'FormField',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	FormField.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /**
	   * A form control component (i.e. Dropdown) or HTML tagName (i.e. 'input').
	   * Extra FormField props are passed to the control component.
	   * Mutually exclusive with children.
	   */
	  control: _lib.customPropTypes.some([_propTypes2.default.func, _propTypes2.default.oneOf(['button', 'input', 'select', 'textarea'])]),
	
	  /** Individual fields may be disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** Individual fields may display an error state. */
	  error: _propTypes2.default.bool,
	
	  /** A field can have its label next to instead of above it. */
	  inline: _propTypes2.default.bool,
	
	  // Heads Up!
	  // Do not disallow children with `label` shorthand
	  // The `control` might accept a `label` prop and `children`
	  /** Mutually exclusive with children. */
	  label: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object]),
	
	  /** A field can show that input is mandatory. */
	  required: _propTypes2.default.bool,
	
	  /** Passed to the control component (i.e. <input type='password' />) */
	  type: _lib.customPropTypes.every([_lib.customPropTypes.demand(['control'])]
	  // don't strictly validate HTML types
	  // a control might be passed that uses a `type` prop with unknown values
	  // let the control validate if for us
	  ),
	
	  /** A field can specify its width in grid columns */
	  width: _propTypes2.default.oneOf(_lib.SUI.WIDTHS)
	} : {};
	
	exports.default = FormField;

/***/ },
/* 162 */
148,
/* 163 */
122,
/* 164 */
[4435, 1781],
/* 165 */
[4438, 810],
/* 166 */
/***/ function(module, exports) {

	var toString = Object.prototype.toString;
	
	function attribute(o, attr, type, text) {
	  type = type === 'array' ? 'object' : type;
	  if (o && typeof o[attr] !== type) {
	    throw new Error(text);
	  }
	}
	
	function variable(o, type, text) {
	  if (typeof o !== type) {
	    throw new Error(text);
	  }
	}
	
	function value(o, values, text) {
	  if (values.indexOf(o) === -1) {
	    throw new Error(text);
	  }
	}
	
	function check(o, config, attributes) {
	  if (!config.optional || o) {
	    variable(o, config.type, config.message);
	  }
	  if (config.type === 'object' && attributes) {
	    var keys = Object.keys(attributes);
	
	    for (var index = 0; index < keys.length; index++) {
	      var a = keys[index];
	      if (!attributes[a].optional || o[a]) {
	        if (!attributes[a].condition || attributes[a].condition(o)) {
	          attribute(o, a, attributes[a].type, attributes[a].message);
	          if (attributes[a].values) {
	            value(o[a], attributes[a].values, attributes[a].value_message);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Wrap `Array.isArray` Polyfill for IE9
	 * source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
	 *
	 * @param {Array} array
	 * @private
	 */
	function isArray(array) {
	  if (this.supportsIsArray()) {
	    return Array.isArray(array);
	  }
	
	  return toString.call(array) === '[object Array]';
	}
	
	function supportsIsArray() {
	  return Array.isArray != null;
	}
	
	module.exports = {
	  check: check,
	  attribute: attribute,
	  variable: variable,
	  value: value,
	  isArray: isArray,
	  supportsIsArray: supportsIsArray
	};


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var error = __webpack_require__(848);
	var objectHelper = __webpack_require__(85);
	
	function wrapCallback(cb, options) {
	  options = options || {};
	  options.ignoreCasing = options.ignoreCasing ? options.ignoreCasing : false;
	
	  return function(err, data) {
	    var errObj;
	
	    if (!err && !data) {
	      return cb(error.buildResponse('generic_error', 'Something went wrong'));
	    }
	
	    if (!err && data.err) {
	      err = data.err;
	      data = null;
	    }
	
	    if (!err && data.error) {
	      err = data;
	      data = null;
	    }
	
	    if (err) {
	      errObj = {
	        original: err
	      };
	
	      if (err.response && err.response.statusCode) {
	        errObj.statusCode = err.response.statusCode;
	      }
	
	      if (err.response && err.response.statusText) {
	        errObj.statusText = err.response.statusText;
	      }
	
	      if (err.response && err.response.body) {
	        err = err.response.body;
	      }
	
	      if (err.err) {
	        err = err.err;
	      }
	      errObj.code = err.error || err.code || err.error_code || err.status || null;
	      errObj.description =
	        err.errorDescription ||
	        err.error_description ||
	        err.description ||
	        err.error ||
	        err.details ||
	        err.err ||
	        null;
	      if (options.forceLegacyError) {
	        errObj.error = errObj.code;
	        errObj.error_description = errObj.description;
	      }
	
	      if (err.name) {
	        errObj.name = err.name;
	      }
	
	      if (err.policy) {
	        errObj.policy = err.policy;
	      }
	
	      return cb(errObj);
	    }
	
	    if (data.type && (data.type === 'text/html' || data.type === 'text/plain')) {
	      return cb(null, data.text);
	    }
	
	    if (options.ignoreCasing) {
	      return cb(null, data.body || data);
	    }
	
	    return cb(null, objectHelper.toCamelCase(data.body || data));
	  };
	}
	
	module.exports = wrapCallback;


/***/ },
/* 168 */
[4183, 1854],
/* 169 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MODAL_SET = exports.MODAL_SET = 'Dyzio/Modal/MODAL_SET';
	var MODAL_CLEAR = exports.MODAL_CLEAR = 'Dyzio/Modal/MODAL_CLEAR';
	var MODAL_LOADING = exports.MODAL_LOADING = 'Dyzio/Modal/MODAL_LOADING';
	var MODAL_ERROR = exports.MODAL_ERROR = 'Dyzio/Modal/MODAL_ERROR';

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _actions = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatusBar = function (_React$Component) {
	  _inherits(StatusBar, _React$Component);
	
	  function StatusBar() {
	    _classCallCheck(this, StatusBar);
	
	    return _possibleConstructorReturn(this, (StatusBar.__proto__ || Object.getPrototypeOf(StatusBar)).apply(this, arguments));
	  }
	
	  _createClass(StatusBar, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // Message and colour are required to render the status bar
	      var _props = this.props,
	          message = _props.message,
	          colour = _props.colour;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        message && colour && _react2.default.createElement(
	          'div',
	          { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('status-bar', colour) },
	            _react2.default.createElement(
	              'div',
	              { className: 'status-text' },
	              _react2.default.createElement(
	                'p',
	                null,
	                message
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'status-close' },
	              _react2.default.createElement('img', { onClick: function onClick() {
	                  return _this2.props.onClearStatusBar();
	                }, className: 'status_cross_icon', src: '/icons/cross.svg', alt: 'Status close' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StatusBar;
	}(_react2.default.Component);
	
	StatusBar.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    message: state.statusBar.get('message'),
	    colour: state.statusBar.get('colour')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onSetStatusBar: function onSetStatusBar(message, colour) {
	      return dispatch((0, _actions.setStatusBar)(message, colour));
	    },
	    onClearStatusBar: function onClearStatusBar() {
	      return dispatch((0, _actions.clearStatusBar)());
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StatusBar);

/***/ },
/* 171 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INFLUENCER_RESOURCE = exports.INFLUENCER_RESOURCE = 'influencer';
	var INFLUENCER_LINK_RESOURCE = exports.INFLUENCER_LINK_RESOURCE = 'influencerLink';
	var ORGANISATION_RESOURCE = exports.ORGANISATION_RESOURCE = 'organisations';
	var DATA_REQUESTS_RESOURCE = exports.DATA_REQUESTS_RESOURCE = 'dataRequests';

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createDiscussion = createDiscussion;
	exports.getDiscussionOld = getDiscussionOld;
	exports.addDiscussionDocument = addDiscussionDocument;
	exports.updateDiscussionDeliverables = updateDiscussionDeliverables;
	exports.removeMemberFromDiscussion = removeMemberFromDiscussion;
	exports.getDiscussion = getDiscussion;
	exports.getReceiveMessageDiscussion = getReceiveMessageDiscussion;
	exports.updateDiscussionTrackedVideos = updateDiscussionTrackedVideos;
	exports.updateDiscussionTrackedAssets = updateDiscussionTrackedAssets;
	exports.updateBudgetServer = updateBudgetServer;
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _authService = __webpack_require__(21);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createDiscussion(discussionData) {
	  var client = (0, _jsonapiService2.default)();
	
	  var discussion = client.create('discussions');
	
	  discussion.set('name', discussionData.name);
	  discussion.set('members', discussionData.members);
	  discussion.set('channelURL', discussionData.channelURL);
	  discussion.set('campaign', { type: 'campaigns', id: discussionData.campaignId });
	  discussion.set('organisations', discussionData.organisationsList);
	
	  return discussion.sync().then(function (response) {
	    return response;
	  });
	}
	
	function getDiscussionOld(discussionId) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('discussions', discussionId, { include: ['documents', 'deliverables'] }).then(function (response) {
	    return response;
	  });
	}
	
	function addDiscussionDocument(discussionId, documentData) {
	  var client = (0, _jsonapiService2.default)();
	
	  var documentDataJSON = documentData.toJSONTree();
	  var docType = documentDataJSON.docType;
	  var approved = documentDataJSON.approved;
	  var docId = documentDataJSON.id;
	
	  return client.get('discussions', discussionId, {}).then(function (discussion) {
	    discussion.relationships('documents').add(documentData);
	    if (!approved && docType === _staticConfiguration.BRIEF) discussion.set('currentBrief', docId);
	    if (!approved && docType === _staticConfiguration.CONTRACT) discussion.set('currentContract', docId);
	    if (approved && docType === _staticConfiguration.SIGNED_CONTRACT) discussion.set('signedContract', docId);
	    return discussion.sync();
	  });
	}
	
	function updateDiscussionDeliverables(discussionId, deliverableData) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('discussions', discussionId, {}).then(function (discussion) {
	    discussion.relationships('deliverables').add(deliverableData);
	    return discussion.sync();
	  });
	}
	
	function removeMemberFromDiscussion(discussionId, campaignPermission) {
	  var client = (0, _jsonapiService2.default)();
	
	  client.get('discussions', discussionId, {}).then(function (discussion) {
	    discussion.relationships('members').remove(campaignPermission);
	    return discussion.sync().then(function (discussion) {
	      return discussion;
	    });
	  });
	}
	
	function makeDiscussionQuery(discussionId) {
	  var query = '\n  query Discussions {\n    discussions(id: "' + discussionId + '") {\n      id\n      name\n      members {\n        id\n        user {\n          id\n        }\n        email\n        role\n        name\n      }\n      organisations {\n        id\n        name\n        orgType\n        influencer {\n          id\n          name\n          thumbnail\n        }\n      }\n      documents {\n        id\n        name\n        filePath\n        docType\n        fileType\n        size\n        message\n        discussion {\n          id\n        }\n        approved\n        createdDate\n        createdBy\n        approvedBy\n        approvalDate\n        removed\n        version\n      }\n      currentBrief\n      currentContract\n      signedContract\n      deliverables {\n        id\n        title\n        channelType\n        assetType\n        dueDate\n        liveDateStart\n        liveDateEnd\n        live\n        description\n        createdBy\n        createdDate\n        discussion {\n          id\n          name\n        }\n        document {\n          id\n          name\n          filePath\n          fileType\n          size\n          message\n          approved\n          approvedBy\n          approvalDate\n          version\n        }\n        documents {\n          id\n          name\n          filePath\n          fileType\n          size\n          message\n          approved\n          approvedBy\n          approvalDate\n          version\n        }\n        version\n        comments {\n          id\n          comment\n          commentType\n          deliverable {\n            id\n          }\n          document {\n            id\n            name\n          }\n          user {\n            id\n            name\n          }\n          createdBy\n          createdDate\n        }\n      }\n      campaign {\n        id\n      }\n      channelURL\n      budget\n      budgetStatus\n      discountCode\n      commission\n      discussionType\n      invitations {\n        id\n        status\n        link\n        metadata\n      }\n      trackedVideos {\n        id\n        youtubeId\n        campaign {\n          id\n          name\n        }\n        discussion {\n          id\n          name\n        }\n        createdBy\n        createdDate\n      }\n      trackedAssets {\n        id\n        assetId\n        assetURL\n        platform\n        assetType\n        campaign {\n          id\n          name\n        }\n        discussion {\n          id\n          name\n        }\n        createdBy\n        createdDate\n        createdSource\n        publishedDate\n      }\n    }\n  }\n  ';
	  return query;
	}
	
	function getDiscussion(discussionId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, {
	    Authorization: 'Bearer ' + _authService.authService.getToken()
	  });
	
	  var query = makeDiscussionQuery(discussionId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    return response.data.data.discussions[0];
	  });
	}
	
	function makeReceiveMessageDiscussionQuery(discussionId) {
	  var query = '\n  query Discussions {\n    discussions(id: "' + discussionId + '") {\n      id\n      name\n      campaign {\n        id\n        name\n      }\n    }\n  }\n  ';
	  return query;
	}
	
	function getReceiveMessageDiscussion(discussionId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, {
	    Authorization: 'Bearer ' + _authService.authService.getToken()
	  });
	
	  var query = makeReceiveMessageDiscussionQuery(discussionId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    return response.data.data.discussions[0];
	  });
	}
	
	function updateDiscussionTrackedVideos(discussionId, trackedVideo) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('discussions', discussionId, {}).then(function (discussion) {
	    discussion.relationships('trackedVideos').add(trackedVideo);
	    return discussion.sync();
	  });
	}
	
	function updateDiscussionTrackedAssets(discussionId, trackedAsset) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('discussions', discussionId, {}).then(function (discussion) {
	    discussion.relationships('trackedAssets').add(trackedAsset);
	    return discussion.sync();
	  });
	}
	
	function updateBudgetServer(budget, status, d) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('discussions', d, {}).then(function (discussion) {
	    discussion.set('budget', budget);
	    discussion.set('budgetStatus', status);
	    return discussion.sync();
	  });
	}

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTrackedAssetAnalytics = getTrackedAssetAnalytics;
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTrackedAssetAnalytics(trackedAssetsList) {
	
	  var endpoint = '' + ("https://influencers.dyzio.co/api/v2/trackedassetrequest");
	  var payload = {
	    data: trackedAssetsList
	  };
	  var headers = {
	    'Content-Type': 'application/json'
	  };
	
	  return _axios2.default.post(endpoint, payload, headers).then(function (response) {
	    return response.data.data;
	  });
	}

/***/ },
/* 174 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(831);
	var continents = __webpack_require__(2513);
	var regions = __webpack_require__(960);
	var countriesAll = __webpack_require__(2946);
	var currenciesAll = __webpack_require__(2947);
	var languagesAll = __webpack_require__(2948);
	var lookup = __webpack_require__(2514);
	
	var getSymbol = __webpack_require__(2544)
	
	exports.continents = continents;
	exports.regions = regions;
	
	exports.countries = {
	  all: countriesAll,
	};
	
	_.each(countriesAll, function (country) {
	  // prefer assigned country codes over inactive ones
	  var exportedAlpha2 = exports.countries[country.alpha2];
	  if (!exportedAlpha2 || exportedAlpha2.status === 'deleted') {
	    exports.countries[country.alpha2] = country;
	  }
	
	  var exportedAlpha3 = exports.countries[country.alpha3];
	  if (!exportedAlpha3 || exportedAlpha3.status === 'deleted') {
	    exports.countries[country.alpha3] = country;
	  }
	});
	
	exports.currencies = {
	  all: currenciesAll,
	};
	
	_.each(currenciesAll, function (currency) {
	  //If the symbol isn't available, default to the currency code
	  var symbol = getSymbol(currency.code);
	  if (symbol == '?') {
	    symbol = currency.code;
	  }
	
	  currency.symbol = symbol;
	  exports.currencies[currency.code] = currency;
	});
	
	exports.languages = {
	  all: languagesAll,
	};
	
	// Note that for the languages there are several entries with the same alpha3 -
	// eg Dutch and Flemish. Not sure how to best deal with that - here whichever
	// comes last wins.
	_.each(languagesAll, function (language) {
	  exports.languages[language.alpha2] = language;
	  exports.languages[language.bibliographic] = language;
	  exports.languages[language.alpha3] = language;
	});
	
	exports.lookup = lookup({
	    countries: countriesAll,
	    currencies: currenciesAll,
	    languages: languagesAll
	});
	
	var callingCountries = {all: []};
	
	var callingCodesAll = _.reduce(countriesAll, function (codes, country) {
	  if (country.countryCallingCodes && country.countryCallingCodes.length) {
	    callingCountries.all.push(country);
	
	    callingCountries[country.alpha2] = country;
	    callingCountries[country.alpha3] = country;
	
	    _.each(country.countryCallingCodes, function (code) {
	      if (codes.indexOf(code) == -1) {
	        codes.push(code);
	      }
	    });
	  }
	  return codes;
	}, []);
	
	delete callingCountries['']; // remove empty alpha3s
	exports.callingCountries = callingCountries;
	
	callingCodesAll.sort(function (a, b) {
	  var parse = function (str) { return parseInt(str) };
	  var splitA = _.map(a.split(' '), parse);
	  var splitB = _.map(b.split(' '), parse);
	
	  if (splitA[0] < splitB[0]) {
	    return -1;
	  } else if (splitA[0] > splitB[0]) {
	    return 1;
	  } else {
	    // Same - check split[1]
	    if (splitA[1] === undefined && splitB[1] !== undefined) {
	      return -1;
	    } else if (splitA[1] !== undefined && splitB[1] === undefined) {
	      return 1;
	    } else if (splitA[1] < splitB[1]) {
	      return -1;
	    } else if (splitA[1] > splitB[1]) {
	      return 1;
	    } else {
	      return 0;
	    }
	  }
	});
	
	exports.callingCodes = {
	  all: callingCodesAll
	};


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(207);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var chartStyles = {
	  width: '100%'
	};
	
	var getChartOptions = function getChartOptions(_ref) {
	  var rgbColorCode = _ref.rgbColorCode,
	      suggestedMax = _ref.suggestedMax,
	      suggestedMin = _ref.suggestedMin;
	  return {
	    responsive: true,
	    showScale: false,
	    tooltips: {
	      enabled: true,
	      mode: 'single',
	      callbacks: {
	        label: _formatting.getGraphLabelFormatting
	      }
	    },
	    legend: {
	      labels: {
	        usePointStyle: true,
	        fontSize: 12
	      }
	    },
	    scales: {
	      xAxes: [{
	        stacked: true,
	        gridLines: {
	          display: false
	        }
	      }],
	      yAxes: [{
	        id: 'followers',
	        type: 'linear',
	        position: 'left',
	        stacked: false,
	        gridLines: {
	          display: false
	        },
	        ticks: {
	          // eslint-disable-next-line
	          callback: function callback(label, index, labels) {
	            return (0, _formatting.scientificFormatted)(label);
	          },
	
	          fontColor: rgbColorCode,
	          suggestedMin: suggestedMin,
	          suggestedMax: suggestedMax
	        }
	      }]
	    }
	  };
	};
	
	var FollowersBarChart = function FollowersBarChart(_ref2) {
	  var label = _ref2.label,
	      labels = _ref2.labels,
	      values = _ref2.values,
	      _ref2$rgbColorCode = _ref2.rgbColorCode,
	      rgbColorCode = _ref2$rgbColorCode === undefined ? '#fc4085' : _ref2$rgbColorCode,
	      percentageRange = _ref2.percentageRange;
	
	  var data = {
	    labels: labels,
	    datasets: [{
	      label: label,
	      type: 'line',
	      backgroundColor: rgbColorCode + '11',
	      borderColor: rgbColorCode,
	      borderCapStyle: 'butt',
	      borderJoinStyle: 'miter',
	      borderWidth: 2,
	      fill: false,
	      data: values
	    }]
	  };
	
	  var suggestedMax = void 0;
	  var suggestedMin = void 0;
	
	  if (percentageRange) {
	    var calculatedIncrement = _lodash2.default.mean(values) / 100 * percentageRange;
	    suggestedMin = _lodash2.default.min(values) - calculatedIncrement;
	    suggestedMax = _lodash2.default.max(values) + calculatedIncrement;
	  }
	
	  var options = getChartOptions({ rgbColorCode: rgbColorCode, suggestedMax: suggestedMax, suggestedMin: suggestedMin });
	  return _react2.default.createElement(_reactChartjs.Bar, {
	    style: chartStyles,
	    data: data,
	    options: options
	  });
	};
	
	exports.default = FollowersBarChart;

/***/ },
/* 177 */
[4243, 179, 1014, 622],
/* 178 */
[4388, 2617, 1008],
/* 179 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 180 */
/***/ function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return (val != null &&
	          val.length >= 0 &&
	          Object.prototype.toString.call(val) === '[object Array]');
	};


/***/ },
/* 181 */
/***/ function(module, exports) {

	module.exports = function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x :
	    {
	      '@@transducer/value': x,
	      '@@transducer/reduced': true
	    };
	};


/***/ },
/* 182 */
[4449, 3273],
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 184 */
96,
/* 185 */
[4243, 188, 1755, 819],
/* 186 */
[4342, 225],
/* 187 */
[4388, 3904, 1749],
/* 188 */
179,
/* 189 */
[4391, 505, 126, 824, 164, 524],
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (name, context, definition) {
	  if (typeof module !== 'undefined' && module.exports) module.exports = definition();
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  else context[name] = definition();
	})('urljoin', this, function () {
	
	  function normalize (str, options) {
	
	    // make sure protocol is followed by two slashes
	    str = str.replace(/:\//g, '://');
	
	    // remove consecutive slashes
	    str = str.replace(/([^:\s])\/+/g, '$1/');
	
	    // remove trailing slash before parameters or hash
	    str = str.replace(/\/(\?|&|#[^!])/g, '$1');
	
	    // replace ? in parameters with &
	    str = str.replace(/(\?.+)\?/g, '$1&');
	
	    return str;
	  }
	
	  return function () {
	    var input = arguments;
	    var options = {};
	
	    if (typeof arguments[0] === 'object') {
	      // new syntax with array and options
	      input = arguments[0];
	      options = arguments[1] || {};
	    }
	
	    var joined = [].slice.call(input, 0).join('/');
	    return normalize(joined, options);
	  };
	
	});


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAvatar = __webpack_require__(701);
	
	var _reactAvatar2 = _interopRequireDefault(_reactAvatar);
	
	var _tooltip = __webpack_require__(554);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var profileColours = {
	  '0': '#e0afde',
	  '1': '#9ad2ff',
	  '2': '#8dcece',
	  '3': '#d1e297',
	  '4': '#fff28c',
	  '5': '#fed995',
	  '6': '#ffc6db',
	  '7': '#92f2dc'
	};
	
	function getNameBasedColour(name, min, max) {
	  var firstLetter = name ? name[0].toLowerCase() : 'a';
	  var charCode = firstLetter.charCodeAt(0);
	
	  // ASCI char numbers from 97 to 122 for a to z char codes - change these into 0 to 8
	  return Math.floor(charCode / 3.5 - 27);
	}
	
	function AvatarProfile(props) {
	  var roleFormatted = props.role ? props.role.toLowerCase().replace('_', ' ') : null;
	  if (props.plain) {
	    return _react2.default.createElement(_reactAvatar2.default, { fgColor: '#1D1937', name: props.name, round: true, color: profileColours[getNameBasedColour(props.name, 0, 8)], size: props.size });
	  }
	  if (props.pending === true) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      props.name ? _react2.default.createElement(
	        _tooltip2.default,
	        { content: props.name, role: roleFormatted, email: props.email, style: 'frame' },
	        _react2.default.createElement(_reactAvatar2.default, { fgColor: '#1D1937', name: props.name, round: true, color: '#e8e8eb', size: props.size })
	      ) : _react2.default.createElement(_reactAvatar2.default, { size: props.size, round: true, fgColor: '#1D1937', color: '#e8e8eb', name: '?' })
	    );
	  } else {
	    if (props.noTooltip) {
	      return _react2.default.createElement(_reactAvatar2.default, { fgColor: '#1D1937', name: props.name, round: true, color: profileColours[getNameBasedColour(props.name, 0, 8)], size: props.size });
	    } else {
	      return _react2.default.createElement(
	        _tooltip2.default,
	        { content: props.name, role: roleFormatted, email: props.email, style: 'frame' },
	        _react2.default.createElement(_reactAvatar2.default, { fgColor: '#1D1937', name: props.name, round: true, color: profileColours[getNameBasedColour(props.name, 0, 8)], size: props.size })
	      );
	    }
	  }
	}
	
	exports.default = AvatarProfile;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _helpLink = __webpack_require__(546);
	
	var _helpLink2 = _interopRequireDefault(_helpLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contentStyle = {
	  color: 'gray',
	  padding: '25px 0'
	};
	
	var wrapperStyle = {
	  padding: '50px 0',
	  textAlign: 'center'
	};
	
	var imageProps = {
	  display: 'block',
	  margin: '0 auto'
	};
	
	var buttonStyle = {
	  margin: '0 auto',
	  display: 'block'
	};
	
	var contexts = {
	  CAMPAIGNS: {
	    imageSrc: '/images/empty-campaigns.svg'
	  },
	  INFLUENCER: {
	    imageSrc: '/images/no-influencers.svg'
	  }
	};
	
	var DyzioEmptyState = function DyzioEmptyState(props) {
	  var content = props.content,
	      onClick = props.onClick,
	      buttonLabel = props.buttonLabel,
	      isSearchContext = props.isSearchContext,
	      helpUrl = props.helpUrl,
	      context = props.context;
	
	  return _react2.default.createElement(
	    'div',
	    { style: wrapperStyle },
	    _react2.default.createElement(_semanticUiReact.Image, { src: _lodash2.default.get(contexts, context).imageSrc, style: imageProps }),
	    _react2.default.createElement(
	      'h4',
	      { style: contentStyle },
	      content
	    ),
	    !isSearchContext && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	        label: buttonLabel,
	        hasIcon: true,
	        floated: null,
	        style: buttonStyle,
	        onClick: onClick,
	        icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' })
	      }),
	      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	      _react2.default.createElement(_helpLink2.default, { url: helpUrl })
	    )
	  );
	};
	
	DyzioEmptyState.propTypes = {
	  content: _propTypes2.default.any.isRequired,
	  buttonLabel: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  isSearchContext: _propTypes2.default.bool.isRequired,
	  context: _propTypes2.default.string.isRequired,
	  helpUrl: _propTypes2.default.string.isRequired
	};
	
	exports.default = DyzioEmptyState;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(37);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _influencerIcon = __webpack_require__(1966);
	
	var _influencerIcon2 = _interopRequireDefault(_influencerIcon);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfluencerContextBar = function (_Component) {
	  _inherits(InfluencerContextBar, _Component);
	
	  function InfluencerContextBar() {
	    _classCallCheck(this, InfluencerContextBar);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerContextBar.__proto__ || Object.getPrototypeOf(InfluencerContextBar)).call(this));
	
	    _this.onPrivateLinkClick = function () {
	      var modalOpen = _this.state.modalOpen;
	
	      _this.setState({
	        modalOpen: !modalOpen
	      });
	    };
	
	    _this.state = {
	      popupOpen: false,
	      modalOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(InfluencerContextBar, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          leftButtonCallback = _props.leftButtonCallback,
	          rightButtonCallback = _props.rightButtonCallback,
	          leftButtonLabel = _props.leftButtonLabel,
	          rightButtonLabel = _props.rightButtonLabel,
	          organisationName = _props.organisationName,
	          hasCTA = _props.hasCTA,
	          hasPrivateLink = _props.hasPrivateLink,
	          cta = _props.cta,
	          title = _props.title,
	          onBackClick = _props.onBackClick;
	
	
	      var boxStyle = {
	        paddingTop: 19,
	        paddingBottom: 19
	      };
	
	      var _ThemeSelector$theme = _themeSelector2.default.theme(),
	          disableHelpLinks = _ThemeSelector$theme.disableHelpLinks;
	
	      var modalOpen = this.state.modalOpen;
	
	
	      if (organisationName) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'influencer-context-bar', style: boxStyle },
	          hasCTA && _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement('div', { className: 'space' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              cta
	            )
	          ),
	          _react2.default.createElement('div', { className: 'spacer small' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                title
	              )
	            ),
	            _react2.default.createElement('div', { className: 'space' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'light' },
	                organisationName || ''
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement('div', { className: 'horizontal-spacer' })
	            ),
	            hasPrivateLink && _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { onClick: this.onPrivateLinkClick },
	                  _react2.default.createElement('img', { className: 'inline', src: '/icons/padlock.svg', alt: 'private' }),
	                  '\xA0\xA0Private'
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'space' }),
	            leftButtonCallback && _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  basic: true,
	                  onClick: leftButtonCallback,
	                  size: 'medium'
	                },
	                leftButtonLabel
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement('div', { className: 'horizontal-spacer' })
	            ),
	            rightButtonCallback && _react2.default.createElement(
	              'div',
	              { className: 'item', onMouseOver: function onMouseOver() {
	                  return _this2.setState({ popupOpen: true });
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'dropdown open-left' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'dropdown-selector' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Button,
	                    {
	                      color: 'pink',
	                      size: 'medium',
	                      onClick: rightButtonCallback
	                    },
	                    rightButtonLabel
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'dropdown-area ' + (this.props.showTooltip && 'visible') },
	                  _react2.default.createElement('div', { className: 'arrow' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'dropdown-content' },
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          { className: 'no-effect' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'add an influencer to get started'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          modalOpen && _react2.default.createElement(
	            _dyzioModal2.default,
	            {
	              headerText: 'Your Private Database',
	              onClose: this.onPrivateLinkClick,
	              size: 'tiny'
	            },
	            _react2.default.createElement(_influencerIcon2.default, { centered: true }),
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(
	              _semanticUiReact.Container,
	              { textAlign: 'center' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Your "My Influencers" database is private.\n                  Your influencers are never shared with other companies and the influencers are not notified\n                  when you add them to the database.'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                !disableHelpLinks && _react2.default.createElement(
	                  _targetLink2.default,
	                  {
	                    renderIf: true,
	                    href: 'https://help.dyzio.co/my-influencers-database/dyzio-private-database'
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\xA0Read more'
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-hero flex small' },
	        _react2.default.createElement(
	          'div',
	          { className: 'item' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(
	              'a',
	              { style: { cursor: 'pointer' }, onClick: onBackClick || _reactRouter.browserHistory.goBack },
	              _react2.default.createElement('img', { src: '/icons/chevron-left.svg', alt: 'back' }),
	              ' ',
	              title
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'space' }),
	        leftButtonCallback && _react2.default.createElement(
	          'div',
	          { className: 'item' },
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            {
	              basic: true,
	              onClick: leftButtonCallback,
	              size: 'medium'
	            },
	            leftButtonLabel
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item' },
	          _react2.default.createElement('div', { className: 'horizontal-spacer' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item' },
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            {
	              color: 'pink',
	              size: 'medium',
	              onClick: rightButtonCallback
	            },
	            rightButtonLabel
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencerContextBar;
	}(_react.Component);
	
	InfluencerContextBar.propTypes = {
	  organisationName: _propTypes2.default.string,
	  showTooltip: _propTypes2.default.bool,
	  hasCTA: _propTypes2.default.bool,
	  cta: _propTypes2.default.node,
	  title: _propTypes2.default.string.isRequired,
	  leftButtonCallback: _propTypes2.default.func,
	  rightButtonCallback: _propTypes2.default.func.isRequired,
	  leftButtonLabel: _propTypes2.default.string,
	  rightButtonLabel: _propTypes2.default.string.isRequired,
	  hasPrivateLink: _propTypes2.default.bool
	};
	InfluencerContextBar.defaultProps = {
	  hasCTA: false,
	  showTooltip: false,
	  cta: _react2.default.createElement('div', null),
	  hasPrivateLink: false,
	  leftButtonCallback: null,
	  leftButtonLabel: null
	};
	InfluencerContextBar.defaultProps = {
	  organisationName: ''
	};
	exports.default = InfluencerContextBar;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViewModes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _searchInput = __webpack_require__(2195);
	
	var _searchInput2 = _interopRequireDefault(_searchInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openUrl = function openUrl(url) {
	  window.open(url, '_blank');
	};
	
	var ViewModes = exports.ViewModes = {
	  cardsSmall: 'cards.small',
	  cardsLarge: 'cards.large',
	  table: 'table.default'
	};
	
	var TabActionBar = function TabActionBar(props) {
	  var hasCampaignFilter = props.hasCampaignFilter,
	      hasSmallCardsView = props.hasSmallCardsView,
	      hasLargeCardsView = props.hasLargeCardsView,
	      hasTableView = props.hasTableView,
	      hasActionButton = props.hasActionButton,
	      hasSearchBox = props.hasSearchBox,
	      hasPerPageSelector = props.hasPerPageSelector,
	      isSmallCards = props.isSmallCards,
	      isLargeCards = props.isLargeCards,
	      isTableView = props.isTableView,
	      actionButtonProps = props.actionButtonProps,
	      groupByOptions = props.groupByOptions,
	      sortByOptions = props.sortByOptions,
	      onViewModeChanged = props.onViewModeChanged,
	      onGroupByChanged = props.onGroupByChanged,
	      onSortByChanged = props.onSortByChanged,
	      helpPageUrl = props.helpPageUrl,
	      shouldDisableButtons = props.shouldDisableButtons,
	      perPageOptions = props.perPageOptions,
	      onSearchInputSubmit = props.onSearchInputSubmit,
	      onSearchCleared = props.onSearchCleared,
	      onPerPageValueChanged = props.onPerPageValueChanged,
	      perPage = props.perPage,
	      sort = props.sort,
	      onCampaignFilterChanged = props.onCampaignFilterChanged,
	      campaignFilter = props.campaignFilter,
	      campaignFilterOptions = props.campaignFilterOptions,
	      hasCampaignTypeFilter = props.hasCampaignTypeFilter,
	      campaignTypesOptions = props.campaignTypesOptions,
	      onCamapignTypeFilterChanged = props.onCamapignTypeFilterChanged;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Menu,
	    { icon: true },
	    hasSmallCardsView && _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      {
	        disabled: shouldDisableButtons,
	        className: 'dyzio-tab',
	        name: ViewModes.cardsSmall,
	        active: !shouldDisableButtons && isSmallCards,
	        onClick: onViewModeChanged
	      },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'grid layout' })
	    ),
	    hasLargeCardsView && _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      {
	        disabled: shouldDisableButtons,
	        className: 'dyzio-tab',
	        name: ViewModes.cardsLarge,
	        active: !shouldDisableButtons && isLargeCards,
	        onClick: onViewModeChanged
	      },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'block layout' })
	    ),
	    hasTableView && _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      {
	        disabled: shouldDisableButtons,
	        className: 'dyzio-tab',
	        name: ViewModes.table,
	        active: !shouldDisableButtons && isTableView,
	        onClick: onViewModeChanged
	      },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'list layout' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      { onClick: function onClick() {
	          return openUrl(helpPageUrl);
	        } },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'help circle', color: 'blue' }),
	        content: 'Click here to find out more about this page and how to use it.'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Menu,
	      { position: 'right' },
	      hasSearchBox && _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        null,
	        _react2.default.createElement(_searchInput2.default, { onSearchCleared: onSearchCleared, onSubmit: onSearchInputSubmit })
	      ),
	      hasCampaignTypeFilter && _react2.default.createElement(_semanticUiReact.Dropdown, {
	        onChange: onCamapignTypeFilterChanged,
	        text: 'Type',
	        defaultValue: 'all',
	        options: campaignTypesOptions,
	        simple: true,
	        item: true
	      }),
	      groupByOptions && _react2.default.createElement(_semanticUiReact.Dropdown, {
	        disabled: shouldDisableButtons,
	        onChange: onGroupByChanged,
	        text: 'Group by',
	        options: groupByOptions,
	        simple: true,
	        item: true
	      }),
	      sortByOptions && _react2.default.createElement(_semanticUiReact.Dropdown, {
	        disabled: shouldDisableButtons,
	        onChange: onSortByChanged,
	        text: 'Sort by',
	        options: sortByOptions,
	        simple: true,
	        value: sort || null,
	        item: true
	      }),
	      hasPerPageSelector && _react2.default.createElement(_semanticUiReact.Dropdown, {
	        disabled: shouldDisableButtons,
	        onChange: onPerPageValueChanged,
	        simple: true,
	        item: true,
	        value: perPage,
	        options: perPageOptions,
	        text: 'Per page'
	      }),
	      hasCampaignFilter && _react2.default.createElement(_semanticUiReact.Dropdown, {
	        onChange: onCampaignFilterChanged,
	        simple: true,
	        item: true,
	        value: campaignFilter,
	        options: campaignFilterOptions,
	        text: campaignFilter.value
	      }),
	      hasActionButton && _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          { icon: true, inverted: true, labelPosition: 'left', color: 'pink', onClick: actionButtonProps.onClick },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' }),
	          actionButtonProps.content
	        )
	      )
	    )
	  );
	};
	
	TabActionBar.propTypes = {
	  hasSmallCardsView: _propTypes.PropTypes.bool,
	  hasLargeCardsView: _propTypes.PropTypes.bool,
	  hasTableView: _propTypes.PropTypes.bool,
	  hasActionButton: _propTypes.PropTypes.bool.isRequired,
	  actionButtonProps: _propTypes.PropTypes.object.isRequired,
	  isSmallCards: _propTypes.PropTypes.bool.isRequired,
	  isLargeCards: _propTypes.PropTypes.bool.isRequired,
	  isTableView: _propTypes.PropTypes.bool.isRequired,
	  groupByOptions: _propTypes.PropTypes.array.isRequired,
	  sortByOptions: _propTypes.PropTypes.array.isRequired,
	  onViewModeChanged: _propTypes.PropTypes.func.isRequired,
	  onGroupByChanged: _propTypes.PropTypes.func.isRequired,
	  onSortByChanged: _propTypes.PropTypes.func.isRequired,
	  onSearchInputSubmit: _propTypes.PropTypes.func,
	  helpPageUrl: _propTypes.PropTypes.string.isRequired,
	  perPage: _propTypes.PropTypes.number.isRequired,
	  shouldDisableButtons: _propTypes.PropTypes.bool,
	  hasSearchBox: _propTypes.PropTypes.bool,
	  hasPerPageSelector: _propTypes.PropTypes.bool,
	  sort: _propTypes.PropTypes.object,
	  onPerPageValueChanged: _propTypes.PropTypes.func,
	  onSearchCleared: _propTypes.PropTypes.func,
	  perPageOptions: _propTypes.PropTypes.array,
	  hasCampaignFilter: _propTypes.PropTypes.bool,
	  onCampaignFilterChanged: _propTypes.PropTypes.func,
	  campaignFilter: _propTypes.PropTypes.string,
	  campaignFilterOptions: _propTypes.PropTypes.array,
	  hasCampaignTypeFilter: _propTypes.PropTypes.bool,
	  campaignTypesOptions: _propTypes.PropTypes.array,
	  onCamapignTypeFilterChanged: _propTypes.PropTypes.func
	};
	
	TabActionBar.defaultProps = {
	  hasCampaignFilter: false,
	  hasSmallCardsView: true,
	  hasLargeCardsView: true,
	  hasTableView: true,
	  shouldDisableButtons: false,
	  hasSearchBox: false,
	  hasPerPageSelector: false,
	  onSearchQueryChanged: null,
	  onPerPageChanged: null,
	  onPerPageValueChanged: null,
	  campaignFilter: 'ACTIVE',
	  onCampaignFilterChanged: null,
	  onSearchInputSubmit: null,
	  onSearchCleared: null,
	  sort: null,
	  perPageOptions: [],
	  campaignFilterOptions: [],
	  hasCampaignTypeFilter: false,
	  campaignTypesOptions: [],
	  onCamapignTypeFilterChanged: _lodash2.default.noop
	};
	
	exports.default = TabActionBar;

/***/ },
/* 195 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_DISCUSSIONS = exports.LOAD_DISCUSSIONS = 'Dyzio/DiscussionList/LOAD_DISCUSSIONS';
	var LOAD_DISCUSSIONS_SUCCESS = exports.LOAD_DISCUSSIONS_SUCCESS = 'Dyzio/DiscussionList/LOAD_DISCUSSIONS_SUCCESS';
	var LOAD_DISCUSSIONS_ERROR = exports.LOAD_DISCUSSIONS_ERROR = 'Dyzio/DiscussionList/LOAD_DISCUSSIONS_ERROR';
	var CLEAR_DISCUSSIONS = exports.CLEAR_DISCUSSIONS = 'Dyzio/DiscussionList/CLEAR_DISCUSSIONS';
	
	var SET_RELOAD_DISCUSSIONS = exports.SET_RELOAD_DISCUSSIONS = 'Dyzio/DiscussionList/SET_RELOAD_DISCUSSIONS';
	var RELOAD_DISCUSSIONS = exports.RELOAD_DISCUSSIONS = 'Dyzio/DiscussionList/RELOAD_DISCUSSIONS';
	var RELOAD_DISCUSSIONS_SUCCESS = exports.RELOAD_DISCUSSIONS_SUCCESS = 'Dyzio/DiscussionList/RELOAD_DISCUSSIONS_SUCCESS';
	
	var SET_UNREAD_MESSAGE_COUNT = exports.SET_UNREAD_MESSAGE_COUNT = 'Dyzio/DiscussionList/SET_UNREAD_MESSAGE_COUNT';
	var INCREMENT_UNREAD_MESSAGE_COUNT = exports.INCREMENT_UNREAD_MESSAGE_COUNT = 'Dyzio/DiscussionList/INCREMENT_UNREAD_MESSAGE_COUNT';

/***/ },
/* 196 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(145);
	var createDesc = __webpack_require__(293);
	module.exports = __webpack_require__(144) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(946);
	var defined = __webpack_require__(578);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(596), __webpack_require__(595));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha1", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var MD5 = C_algo.MD5;
	
		    /**
		     * This key derivation function is meant to conform with EVP_BytesToKey.
		     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
		     */
		    var EvpKDF = C_algo.EvpKDF = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */
		        cfg: Base.extend({
		            keySize: 128/32,
		            hasher: MD5,
		            iterations: 1
		        }),
	
		        /**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.EvpKDF.create();
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
		         */
		        init: function (cfg) {
		            this.cfg = this.cfg.extend(cfg);
		        },
	
		        /**
		         * Derives a key from a password.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */
		        compute: function (password, salt) {
		            // Shortcut
		            var cfg = this.cfg;
	
		            // Init hasher
		            var hasher = cfg.hasher.create();
	
		            // Initial values
		            var derivedKey = WordArray.create();
	
		            // Shortcuts
		            var derivedKeyWords = derivedKey.words;
		            var keySize = cfg.keySize;
		            var iterations = cfg.iterations;
	
		            // Generate key
		            while (derivedKeyWords.length < keySize) {
		                if (block) {
		                    hasher.update(block);
		                }
		                var block = hasher.update(password).finalize(salt);
		                hasher.reset();
	
		                // Iterations
		                for (var i = 1; i < iterations; i++) {
		                    block = hasher.finalize(block);
		                    hasher.reset();
		                }
	
		                derivedKey.concat(block);
		            }
		            derivedKey.sigBytes = keySize * 4;
	
		            return derivedKey;
		        }
		    });
	
		    /**
		     * Derives a key from a password.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.EvpKDF(password, salt);
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
		     */
		    C.EvpKDF = function (password, salt, cfg) {
		        return EvpKDF.create(cfg).compute(password, salt);
		    };
		}());
	
	
		return CryptoJS.EvpKDF;
	
	}));

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(1421);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 201 */
[4212, 609, 2659],
/* 202 */
[4296, 2627, 2675],
/* 203 */
[4301, 2603, 604, 2605, 974, 976, 133, 1020],
/* 204 */
[4342, 206],
/* 205 */
[4402, 133, 96],
/* 206 */
[4408, 133, 79],
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Chart", {
	  enumerable: true,
	  get: function get() {
	    return _chart["default"];
	  }
	});
	exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(8));
	
	var _chart = _interopRequireDefault(__webpack_require__(2601));
	
	var _isEqual = _interopRequireDefault(__webpack_require__(625));
	
	var _keyBy = _interopRequireDefault(__webpack_require__(1032));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NODE_ENV = typeof process !== 'undefined' && process.env && ("production");
	
	var ChartComponent = /*#__PURE__*/function (_React$Component) {
	  _inherits(ChartComponent, _React$Component);
	
	  var _super = _createSuper(ChartComponent);
	
	  function ChartComponent() {
	    var _this;
	
	    _classCallCheck(this, ChartComponent);
	
	    _this = _super.call(this);
	
	    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
	      var instance = _this.chartInstance;
	      var _this$props = _this.props,
	          getDatasetAtEvent = _this$props.getDatasetAtEvent,
	          getElementAtEvent = _this$props.getElementAtEvent,
	          getElementsAtEvent = _this$props.getElementsAtEvent,
	          onElementsClick = _this$props.onElementsClick;
	      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
	      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
	      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
	      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
	      _this.element = element;
	    });
	
	    _this.chartInstance = undefined;
	    return _this;
	  }
	
	  _createClass(ChartComponent, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.renderChart();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.props.redraw) {
	        this.destroyChart();
	        this.renderChart();
	        return;
	      }
	
	      this.updateChart();
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _this$props2 = this.props,
	          redraw = _this$props2.redraw,
	          type = _this$props2.type,
	          options = _this$props2.options,
	          plugins = _this$props2.plugins,
	          legend = _this$props2.legend,
	          height = _this$props2.height,
	          width = _this$props2.width;
	
	      if (nextProps.redraw === true) {
	        return true;
	      }
	
	      if (height !== nextProps.height || width !== nextProps.width) {
	        return true;
	      }
	
	      if (type !== nextProps.type) {
	        return true;
	      }
	
	      if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
	        return true;
	      }
	
	      if (!(0, _isEqual["default"])(options, nextProps.options)) {
	        return true;
	      }
	
	      var nextData = this.transformDataProp(nextProps);
	
	      if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
	        return true;
	      }
	
	      return !(0, _isEqual["default"])(plugins, nextProps.plugins);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.destroyChart();
	    }
	  }, {
	    key: "transformDataProp",
	    value: function transformDataProp(props) {
	      var data = props.data;
	
	      if (typeof data == 'function') {
	        var node = this.element;
	        return data(node);
	      } else {
	        return data;
	      }
	    } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
	    // this makes impossible to compare the current and next data changes
	    // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
	    // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617
	
	  }, {
	    key: "memoizeDataProps",
	    value: function memoizeDataProps() {
	      if (!this.props.data) {
	        return;
	      }
	
	      var data = this.transformDataProp(this.props);
	      this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
	        datasets: data.datasets && data.datasets.map(function (set) {
	          return _objectSpread({}, set);
	        })
	      });
	      this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed
	
	      return data;
	    }
	  }, {
	    key: "checkDatasets",
	    value: function checkDatasets(datasets) {
	      var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
	      var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
	      var multipleDatasets = datasets.length > 1;
	
	      if (isDev && multipleDatasets && !usingCustomKeyProvider) {
	        var shouldWarn = false;
	        datasets.forEach(function (dataset) {
	          if (!dataset.label) {
	            shouldWarn = true;
	          }
	        });
	
	        if (shouldWarn) {
	          console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
	        }
	      }
	    }
	  }, {
	    key: "getCurrentDatasets",
	    value: function getCurrentDatasets() {
	      return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
	    }
	  }, {
	    key: "saveCurrentDatasets",
	    value: function saveCurrentDatasets() {
	      var _this2 = this;
	
	      this.datasets = this.datasets || {};
	      var currentDatasets = this.getCurrentDatasets();
	      currentDatasets.forEach(function (d) {
	        _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
	      });
	    }
	  }, {
	    key: "updateChart",
	    value: function updateChart() {
	      var _this3 = this;
	
	      var options = this.props.options;
	      var data = this.memoizeDataProps(this.props);
	      if (!this.chartInstance) return;
	
	      if (options) {
	        this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
	      } // Pipe datasets to chart instance datasets enabling
	      // seamless transitions
	
	
	      var currentDatasets = this.getCurrentDatasets();
	      var nextDatasets = data.datasets || [];
	      this.checkDatasets(currentDatasets);
	      var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
	      // on each dataset.
	
	      this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
	        var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
	
	        if (current && current.type === next.type && next.data) {
	          // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
	          // The data array must be edited in place. As chart.js adds listeners to it.
	          current.data.splice(next.data.length);
	          next.data.forEach(function (point, pid) {
	            current.data[pid] = next.data[pid];
	          });
	
	          var _data = next.data,
	              otherProps = _objectWithoutProperties(next, ["data"]); // Merge properties. Notice a weakness here. If a property is removed
	          // from next, it will be retained by current and never disappears.
	          // Workaround is to set value to null or undefined in next.
	
	
	          return _objectSpread(_objectSpread({}, current), otherProps);
	        } else {
	          return next;
	        }
	      });
	
	      var datasets = data.datasets,
	          rest = _objectWithoutProperties(data, ["datasets"]);
	
	      this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
	      this.chartInstance.update();
	    }
	  }, {
	    key: "renderChart",
	    value: function renderChart() {
	      var _this$props3 = this.props,
	          options = _this$props3.options,
	          legend = _this$props3.legend,
	          type = _this$props3.type,
	          plugins = _this$props3.plugins;
	      var node = this.element;
	      var data = this.memoizeDataProps();
	
	      if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
	        options.legend = legend;
	      }
	
	      this.chartInstance = new _chart["default"](node, {
	        type: type,
	        data: data,
	        options: options,
	        plugins: plugins
	      });
	    }
	  }, {
	    key: "destroyChart",
	    value: function destroyChart() {
	      if (!this.chartInstance) {
	        return;
	      } // Put all of the datasets that have existed in the chart back on the chart
	      // so that the metadata associated with this chart get destroyed.
	      // This allows the datasets to be used in another chart. This can happen,
	      // for example, in a tabbed UI where the chart gets created each time the
	      // tab gets switched to the chart and uses the same data).
	
	
	      this.saveCurrentDatasets();
	      var datasets = Object.values(this.datasets);
	      this.chartInstance.config.data.datasets = datasets;
	      this.chartInstance.destroy();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          height = _this$props4.height,
	          width = _this$props4.width,
	          id = _this$props4.id;
	      return /*#__PURE__*/_react["default"].createElement("canvas", {
	        ref: this.ref,
	        height: height,
	        width: width,
	        id: id,
	        onClick: this.handleOnClick
	      });
	    }
	  }]);
	
	  return ChartComponent;
	}(_react["default"].Component);
	
	_defineProperty(ChartComponent, "getLabelAsKey", function (d) {
	  return d.label;
	});
	
	_defineProperty(ChartComponent, "propTypes", {
	  data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
	  getDatasetAtEvent: _propTypes["default"].func,
	  getElementAtEvent: _propTypes["default"].func,
	  getElementsAtEvent: _propTypes["default"].func,
	  height: _propTypes["default"].number,
	  legend: _propTypes["default"].object,
	  onElementsClick: _propTypes["default"].func,
	  options: _propTypes["default"].object,
	  plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  redraw: _propTypes["default"].bool,
	  type: function type(props, propName, componentName) {
	    if (!_chart["default"].controllers[props[propName]]) {
	      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
	    }
	  },
	  width: _propTypes["default"].number,
	  datasetKeyProvider: _propTypes["default"].func
	});
	
	_defineProperty(ChartComponent, "defaultProps", {
	  legend: {
	    display: true,
	    position: 'bottom'
	  },
	  type: 'doughnut',
	  height: 150,
	  width: 300,
	  redraw: false,
	  options: {},
	  datasetKeyProvider: ChartComponent.getLabelAsKey
	});
	
	var _default = ChartComponent;
	exports["default"] = _default;
	
	var Doughnut = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Doughnut, _React$Component2);
	
	  var _super2 = _createSuper(Doughnut);
	
	  function Doughnut() {
	    _classCallCheck(this, Doughnut);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Doughnut, [{
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref) {
	          return _this4.chartInstance = _ref && _ref.chartInstance;
	        },
	        type: "doughnut"
	      }));
	    }
	  }]);
	
	  return Doughnut;
	}(_react["default"].Component);
	
	exports.Doughnut = Doughnut;
	
	var Pie = /*#__PURE__*/function (_React$Component3) {
	  _inherits(Pie, _React$Component3);
	
	  var _super3 = _createSuper(Pie);
	
	  function Pie() {
	    _classCallCheck(this, Pie);
	
	    return _super3.apply(this, arguments);
	  }
	
	  _createClass(Pie, [{
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref2) {
	          return _this5.chartInstance = _ref2 && _ref2.chartInstance;
	        },
	        type: "pie"
	      }));
	    }
	  }]);
	
	  return Pie;
	}(_react["default"].Component);
	
	exports.Pie = Pie;
	
	var Line = /*#__PURE__*/function (_React$Component4) {
	  _inherits(Line, _React$Component4);
	
	  var _super4 = _createSuper(Line);
	
	  function Line() {
	    _classCallCheck(this, Line);
	
	    return _super4.apply(this, arguments);
	  }
	
	  _createClass(Line, [{
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref3) {
	          return _this6.chartInstance = _ref3 && _ref3.chartInstance;
	        },
	        type: "line"
	      }));
	    }
	  }]);
	
	  return Line;
	}(_react["default"].Component);
	
	exports.Line = Line;
	
	var Bar = /*#__PURE__*/function (_React$Component5) {
	  _inherits(Bar, _React$Component5);
	
	  var _super5 = _createSuper(Bar);
	
	  function Bar() {
	    _classCallCheck(this, Bar);
	
	    return _super5.apply(this, arguments);
	  }
	
	  _createClass(Bar, [{
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref4) {
	          return _this7.chartInstance = _ref4 && _ref4.chartInstance;
	        },
	        type: "bar"
	      }));
	    }
	  }]);
	
	  return Bar;
	}(_react["default"].Component);
	
	exports.Bar = Bar;
	
	var HorizontalBar = /*#__PURE__*/function (_React$Component6) {
	  _inherits(HorizontalBar, _React$Component6);
	
	  var _super6 = _createSuper(HorizontalBar);
	
	  function HorizontalBar() {
	    _classCallCheck(this, HorizontalBar);
	
	    return _super6.apply(this, arguments);
	  }
	
	  _createClass(HorizontalBar, [{
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref5) {
	          return _this8.chartInstance = _ref5 && _ref5.chartInstance;
	        },
	        type: "horizontalBar"
	      }));
	    }
	  }]);
	
	  return HorizontalBar;
	}(_react["default"].Component);
	
	exports.HorizontalBar = HorizontalBar;
	
	var Radar = /*#__PURE__*/function (_React$Component7) {
	  _inherits(Radar, _React$Component7);
	
	  var _super7 = _createSuper(Radar);
	
	  function Radar() {
	    _classCallCheck(this, Radar);
	
	    return _super7.apply(this, arguments);
	  }
	
	  _createClass(Radar, [{
	    key: "render",
	    value: function render() {
	      var _this9 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref6) {
	          return _this9.chartInstance = _ref6 && _ref6.chartInstance;
	        },
	        type: "radar"
	      }));
	    }
	  }]);
	
	  return Radar;
	}(_react["default"].Component);
	
	exports.Radar = Radar;
	
	var Polar = /*#__PURE__*/function (_React$Component8) {
	  _inherits(Polar, _React$Component8);
	
	  var _super8 = _createSuper(Polar);
	
	  function Polar() {
	    _classCallCheck(this, Polar);
	
	    return _super8.apply(this, arguments);
	  }
	
	  _createClass(Polar, [{
	    key: "render",
	    value: function render() {
	      var _this10 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref7) {
	          return _this10.chartInstance = _ref7 && _ref7.chartInstance;
	        },
	        type: "polarArea"
	      }));
	    }
	  }]);
	
	  return Polar;
	}(_react["default"].Component);
	
	exports.Polar = Polar;
	
	var Bubble = /*#__PURE__*/function (_React$Component9) {
	  _inherits(Bubble, _React$Component9);
	
	  var _super9 = _createSuper(Bubble);
	
	  function Bubble() {
	    _classCallCheck(this, Bubble);
	
	    return _super9.apply(this, arguments);
	  }
	
	  _createClass(Bubble, [{
	    key: "render",
	    value: function render() {
	      var _this11 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref8) {
	          return _this11.chartInstance = _ref8 && _ref8.chartInstance;
	        },
	        type: "bubble"
	      }));
	    }
	  }]);
	
	  return Bubble;
	}(_react["default"].Component);
	
	exports.Bubble = Bubble;
	
	var Scatter = /*#__PURE__*/function (_React$Component10) {
	  _inherits(Scatter, _React$Component10);
	
	  var _super10 = _createSuper(Scatter);
	
	  function Scatter() {
	    _classCallCheck(this, Scatter);
	
	    return _super10.apply(this, arguments);
	  }
	
	  _createClass(Scatter, [{
	    key: "render",
	    value: function render() {
	      var _this12 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref9) {
	          return _this12.chartInstance = _ref9 && _ref9.chartInstance;
	        },
	        type: "scatter"
	      }));
	    }
	  }]);
	
	  return Scatter;
	}(_react["default"].Component);
	
	exports.Scatter = Scatter;
	var defaults = _chart["default"].defaults;
	exports.defaults = defaults;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 208 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(529);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var _indexOf = __webpack_require__(1451);
	
	
	module.exports = function _contains(a, list) {
	  return _indexOf(list, a, 0) >= 0;
	};


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(307);
	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));


/***/ },
/* 213 */
[4583, 46],
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(3309);
	var ReactInstrumentation = __webpack_require__(113);
	
	var warning = __webpack_require__(41);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(7);
	var momentValidationWrapper = __webpack_require__(3364);
	var core = __webpack_require__(3363);
	
	module.exports = {
	
	  momentObj : core.createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(value);
	    },
	    'Moment'
	  ),
	
	  momentString : core.createMomentChecker(
	    'string',
	    function(str) {
	      return typeof str === 'string';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(moment(value));
	    },
	    'Moment'
	  ),
	
	  momentDurationObj : core.createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return moment.isDuration(value);
	    },
	    'Duration'
	  ),
	
	};


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var ReactChildren = __webpack_require__(3623);
	var ReactComponent = __webpack_require__(749);
	var ReactPureComponent = __webpack_require__(3628);
	var ReactClass = __webpack_require__(3624);
	var ReactDOMFactories = __webpack_require__(3625);
	var ReactElement = __webpack_require__(264);
	var ReactPropTypes = __webpack_require__(3626);
	var ReactVersion = __webpack_require__(3629);
	
	var onlyChild = __webpack_require__(3631);
	var warning = __webpack_require__(41);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 218 */
[4296, 3702, 3733],
/* 219 */
79,
/* 220 */
[4212, 807, 3949],
/* 221 */
[4253, 49, 816, 1761, 165],
/* 222 */
[4296, 3914, 3966],
/* 223 */
[4301, 3890, 801, 3892, 1718, 1720, 140, 1762],
/* 224 */
[4402, 140, 100],
/* 225 */
[4408, 140, 83],
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(667).EventEmitter;
	var inherits = __webpack_require__(250);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(4164);
	Stream.Writable = __webpack_require__(4166);
	Stream.Duplex = __webpack_require__(4162);
	Stream.Transform = __webpack_require__(4165);
	Stream.PassThrough = __webpack_require__(4163);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	/*</replacement>*/
	
	
	/*<replacement>*/
	var util = __webpack_require__(295);
	util.inherits = __webpack_require__(250);
	/*</replacement>*/
	
	var Readable = __webpack_require__(1801);
	var Writable = __webpack_require__(837);
	
	util.inherits(Duplex, Readable);
	
	forEach(objectKeys(Writable.prototype), function(method) {
	  if (!Duplex.prototype[method])
	    Duplex.prototype[method] = Writable.prototype[method];
	});
	
	function Duplex(options) {
	  if (!(this instanceof Duplex))
	    return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false)
	    this.readable = false;
	
	  if (options && options.writable === false)
	    this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false)
	    this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended)
	    return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  process.nextTick(this.end.bind(this));
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(529);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('Promise constructor\'s argument is not a function');
	  }
	  this._75 = 0;
	  this._83 = 0;
	  this._18 = null;
	  this._38 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._47 = null;
	Promise._71 = null;
	Promise._44 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	}
	function handle(self, deferred) {
	  while (self._83 === 3) {
	    self = self._18;
	  }
	  if (Promise._47) {
	    Promise._47(self);
	  }
	  if (self._83 === 0) {
	    if (self._75 === 0) {
	      self._75 = 1;
	      self._38 = deferred;
	      return;
	    }
	    if (self._75 === 1) {
	      self._75 = 2;
	      self._38 = [self._38, deferred];
	      return;
	    }
	    self._38.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._83 === 1) {
	        resolve(deferred.promise, self._18);
	      } else {
	        reject(deferred.promise, self._18);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._18);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._83 = 3;
	      self._18 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._83 = 1;
	  self._18 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._83 = 2;
	  self._18 = newValue;
	  if (Promise._71) {
	    Promise._71(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._75 === 1) {
	    handle(self, self._38);
	    self._38 = null;
	  }
	  if (self._75 === 2) {
	    for (var i = 0; i < self._38.length; i++) {
	      handle(self, self._38[i]);
	    }
	    self._38 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  });
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 229 */
/***/ function(module, exports) {

	/* eslint-disable no-console */
	
	function Warn(options) {
	  this.disableWarnings = options.disableWarnings;
	}
	
	Warn.prototype.warning = function(message) {
	  if (this.disableWarnings) {
	    return;
	  }
	
	  console.warn(message);
	};
	
	module.exports = Warn;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _feedTypeCards = __webpack_require__(2135);
	
	var _feedTypeCards2 = _interopRequireDefault(_feedTypeCards);
	
	var _feedTypeTable = __webpack_require__(2136);
	
	var _feedTypeTable2 = _interopRequireDefault(_feedTypeTable);
	
	var _withDyzioEventsData = __webpack_require__(284);
	
	var _static = __webpack_require__(358);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PER_PAGE = 8;
	var DEBOUNCE_TIMEOUT = 200;
	var TABLE_VIEW_MODE_PAGE_LIMIT = 100;
	var TABLE_VIEW_MODE_COLLAB_LIMIT = 8;
	
	var paginationStyle = {
	  marginTop: 5,
	  marginBottom: 10,
	  float: 'right'
	};
	
	var EventsFeed = function (_Component) {
	  _inherits(EventsFeed, _Component);
	
	  function EventsFeed() {
	    _classCallCheck(this, EventsFeed);
	
	    var _this = _possibleConstructorReturn(this, (EventsFeed.__proto__ || Object.getPrototypeOf(EventsFeed)).call(this));
	
	    _this.onFeedBodyScroll = _lodash2.default.debounce(function (_ref) {
	      var scrollHeight = _ref.scrollHeight,
	          scrollTop = _ref.scrollTop,
	          clientHeight = _ref.clientHeight;
	
	      var isBottom = scrollHeight - scrollTop === clientHeight;
	      if (isBottom) {
	        _this.loadMore();
	      }
	    }, DEBOUNCE_TIMEOUT);
	
	    _this.onEventTypeFilterChanged = function (event, data) {
	      var eventTypeFilter = data.value;
	
	      _this.setState({
	        eventTypeFilter: eventTypeFilter
	      }, _this.fetchEvents);
	    };
	
	    _this.onSearchByCreatedBy = function (value) {
	      return _this.setState({
	        eventSearchTerm: value
	      }, _this.fetchEvents);
	    };
	
	    _this.onClearSearch = function () {
	      return _this.setState({
	        eventSearchTerm: ''
	      }, _this.fetchEvents);
	    };
	
	    _this.loadMore = function () {
	      var _this$state = _this.state,
	          isLoadingMore = _this$state.isLoadingMore,
	          canLoadMore = _this$state.canLoadMore;
	
	      if (isLoadingMore || !canLoadMore) return;
	      _this.setState({
	        isLoadingMore: true,
	        currentOffset: _lodash2.default.add(_this.state.currentOffset, PER_PAGE)
	      }, _this.fetchEvents);
	    };
	
	    _this.onPaginationDecrease = function () {
	      var currentOffset = _this.state.currentOffset;
	
	      if (currentOffset === 0) return;
	      _this.setState({
	        currentOffset: _lodash2.default.subtract(currentOffset, PER_PAGE)
	      }, _this.fetchEvents);
	    };
	
	    _this.onPaginationIncrease = function () {
	      _this.setState({
	        currentOffset: _lodash2.default.add(_this.state.currentOffset, PER_PAGE)
	      }, _this.fetchEvents);
	    };
	
	    _this.fetchEvents = function () {
	      var _this$props = _this.props,
	          getDyzioEvents = _this$props.getDyzioEvents,
	          campaignId = _this$props.campaignId,
	          organisationId = _this$props.organisationId,
	          discussionId = _this$props.discussionId,
	          feedType = _this$props.feedType,
	          viewMode = _this$props.viewMode;
	      var _this$state2 = _this.state,
	          currentOffset = _this$state2.currentOffset,
	          eventTypeFilter = _this$state2.eventTypeFilter,
	          isLoadingMore = _this$state2.isLoadingMore,
	          eventSearchTerm = _this$state2.eventSearchTerm;
	
	
	      var campaignFilter = {
	        campaign: campaignId,
	        eventType: _static.FEED_TYPES.CAMPAIGN
	      };
	
	      var organisationFilter = {
	        organisation: organisationId,
	        eventType: _static.FEED_TYPES.ORGANISATION
	      };
	
	      var allFilter = {
	        organisation: organisationId,
	        eventName: [_withDyzioEventsData.EVENT_TYPES.INFLUENCER_CREATED, _withDyzioEventsData.EVENT_TYPES.USER_CREATED, _withDyzioEventsData.EVENT_TYPES.CAMPAIGN_CREATED, _withDyzioEventsData.EVENT_TYPES.SHORTLIST_CREATED, _withDyzioEventsData.EVENT_TYPES.TRACKED_ASSED_CREATED]
	      };
	
	      var page = {
	        limit: PER_PAGE,
	        offset: currentOffset
	      };
	
	      var shouldFilterByEventType = _withDyzioEventsData.EVENT_TYPES.ALL !== eventTypeFilter;
	      var shouldFetchAllEvents = _static.FEED_TYPES.ALL === feedType;
	      var shouldFilterByTerm = !_lodash2.default.isEmpty(eventSearchTerm);
	      var isTableViewMode = viewMode === _static.FEED_VIEW_MODES.TABLE;
	      var isCollaborationMode = feedType === _static.FEED_TYPES.COLLABORATION;
	
	      if (shouldFilterByEventType) {
	        _lodash2.default.assign(organisationFilter, { eventName: eventTypeFilter });
	      }
	
	      if (shouldFilterByTerm) {
	        _lodash2.default.assign(organisationFilter, { createdBy: ':' + eventSearchTerm });
	      }
	
	      if (isTableViewMode) {
	        _lodash2.default.set(page, 'limit', isCollaborationMode ? TABLE_VIEW_MODE_COLLAB_LIMIT : TABLE_VIEW_MODE_PAGE_LIMIT);
	      }
	
	      var singleFilter = _lodash2.default.eq(_static.FEED_TYPES.ORGANISATION, feedType) ? organisationFilter : campaignFilter;
	
	      if (feedType === _static.FEED_TYPES.COLLABORATION && discussionId) {
	        _lodash2.default.assign(campaignFilter, { discussion: discussionId });
	      }
	
	      getDyzioEvents({
	        filter: shouldFetchAllEvents ? allFilter : singleFilter,
	        page: page
	      }).then(function (events) {
	        var canLoadMore = _lodash2.default.size(events) === PER_PAGE;
	        _this.setState({
	          events: isLoadingMore ? _lodash2.default.concat(_this.state.events, events) : events,
	          isLoading: false,
	          isLoadingMore: false,
	          canLoadMore: canLoadMore,
	          noEvents: _lodash2.default.isEmpty(events)
	        });
	        return events;
	      }).catch(function () {
	        _this.setState({
	          hasFailedToLoad: true,
	          isLoadingMore: false,
	          isLoading: false,
	          noEvents: false,
	          canLoadMore: false
	        });
	      });
	    };
	
	    _this.state = {
	      noEvents: false,
	      isLoading: true,
	      isLoadingMore: false,
	      eventTypeFilter: _withDyzioEventsData.EVENT_TYPES.ALL,
	      eventSearchTerm: '',
	      canLoadMore: true,
	      hasFailedToLoad: false,
	      events: [],
	      currentOffset: 0
	    };
	    return _this;
	  }
	
	  _createClass(EventsFeed, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchEvents();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          events = _state.events,
	          noEvents = _state.noEvents,
	          isLoadingMore = _state.isLoadingMore,
	          canLoadMore = _state.canLoadMore,
	          eventTypeFilter = _state.eventTypeFilter,
	          currentOffset = _state.currentOffset;
	      var _props = this.props,
	          isCompact = _props.isCompact,
	          shouldRenderFilters = _props.shouldRenderFilters,
	          viewMode = _props.viewMode,
	          hasExportFeature = _props.hasExportFeature,
	          csvFileName = _props.csvFileName,
	          feedType = _props.feedType;
	
	
	      var feedBodyProps = {
	        events: events,
	        isLoading: isLoading,
	        noEvents: noEvents,
	        isCompact: isCompact,
	        onFeedBodyScroll: this.onFeedBodyScroll
	      };
	
	      var eventProps = _extends({
	        shouldRenderFilters: shouldRenderFilters,
	        eventTypeFilter: eventTypeFilter,
	        canLoadMore: canLoadMore,
	        isLoadingMore: isLoadingMore,
	        onEventTypeFilterChanged: this.onEventTypeFilterChanged,
	        onSearch: this.onSearchByCreatedBy,
	        onClearSearch: this.onClearSearch
	      }, this.props, feedBodyProps);
	
	      var isCollaborationMode = feedType === _static.FEED_TYPES.COLLABORATION;
	
	      var tableViewProps = {
	        events: events,
	        csvFileName: csvFileName,
	        hasExportFeature: hasExportFeature,
	        isLoading: isLoading,
	        isCollaborationMode: isCollaborationMode
	      };
	
	      var isCardsViewMode = viewMode === _static.FEED_VIEW_MODES.CARDS;
	      var isTableViewMode = viewMode === _static.FEED_VIEW_MODES.TABLE;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        isCardsViewMode && _react2.default.createElement(_feedTypeCards2.default, eventProps),
	        isTableViewMode && _react2.default.createElement(_feedTypeTable2.default, tableViewProps),
	        isCollaborationMode && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Button.Group,
	            { style: paginationStyle },
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              { disabled: currentOffset === 0, icon: true, onClick: this.onPaginationDecrease },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'angle left' })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              { icon: true, onClick: this.onPaginationIncrease },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'angle right' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EventsFeed;
	}(_react.Component);
	
	EventsFeed.propTypes = {
	  getDyzioEvents: _propTypes2.default.func.isRequired,
	  campaignId: _propTypes2.default.string,
	  csvFileName: _propTypes2.default.string,
	  organisationId: _propTypes2.default.string,
	  shouldRenderFilters: _propTypes2.default.bool,
	  feedType: _propTypes2.default.oneOf([].concat(_toConsumableArray(_static.FEED_TYPES))).isRequired,
	  viewMode: _propTypes2.default.oneOf([].concat(_toConsumableArray(_static.FEED_VIEW_MODES))),
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  cardColour: _propTypes2.default.string,
	  isCompact: _propTypes2.default.bool,
	  hasExportFeature: _propTypes2.default.bool
	};
	
	EventsFeed.defaultProps = {
	  title: 'Campaign Events',
	  description: 'view the history of your automated channel report.',
	  shouldRenderFilters: false,
	  viewMode: _static.FEED_VIEW_MODES.CARDS,
	  isCompact: false,
	  hasExportFeature: false
	};
	
	exports.default = (0, _recompose.compose)(_withDyzioEventsData.withDyzioEventsData)(EventsFeed);

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bowser = __webpack_require__(368);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isFullWhiteLabel = _themeSelector2.default.isFullWhiteLabel();
	var PLATFORM_NAME = isFullWhiteLabel ? 'our website' : 'dyzio';
	
	var BrowserHandler = module.exports;
	
	var isDyzio = _lodash2.default.eq(_lodash2.default.get(window, 'origin'), 'https://app.dyzio.co');
	
	var chromeDownloadLink = function chromeDownloadLink() {
	  return _react2.default.createElement(
	    'a',
	    { target: '_blank', href: 'https://www.google.co.uk/chrome/browser/desktop/index.html' },
	    'chrome'
	  );
	};
	
	var SafariMessage = function SafariMessage() {
	  if (isDyzio) return null;
	  return _react2.default.createElement(_semanticUiReact.Message, {
	    warning: true,
	    icon: 'frown',
	    content: _react2.default.createElement(
	      'span',
	      null,
	      'Sorry - you cannot log in to the system using Safari at the minute... please try using ',
	      chromeDownloadLink(),
	      ' instead.'
	    )
	  });
	};
	
	BrowserHandler.safariHandle = {
	  default: function _default() {
	    if (_bowser2.default.safari) {
	      return _react2.default.createElement(SafariMessage, null);
	    }
	    return _react2.default.createElement('div', null);
	  }
	};
	BrowserHandler.handle = {
	  chrome: function chrome() {
	    return _react2.default.createElement(
	      'p',
	      null,
	      'Chrome is the best browser to use for ',
	      PLATFORM_NAME,
	      '. Bravo!'
	    );
	  },
	  ie: function ie() {
	    return doNotUseIE();
	  },
	  opera: function opera() {
	    return shouldBeFine('Opera');
	  },
	  edge: function edge() {
	    return shouldBeFine('Edge');
	  },
	  default: function _default(browser) {
	    if (_bowser2.default.safari) {
	      return _react2.default.createElement('div', null);
	    }
	    return weRecommendChrome();
	  }
	};
	
	var weRecommendChrome = function weRecommendChrome() {
	  return _react2.default.createElement(
	    'p',
	    null,
	    'We recommend using ',
	    chromeDownloadLink(),
	    ' with ',
	    PLATFORM_NAME,
	    '. It\'s fast, secure and free!'
	  );
	};
	
	var upgradeSafari = function upgradeSafari() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'browser-warning' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Hi, it looks like you are using an old version of Safari.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Unfortunately ',
	      PLATFORM_NAME,
	      ' will not work well in this browser.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You should use Google ',
	      chromeDownloadLink(),
	      ' or ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://support.apple.com/en-gb/HT204416' },
	        'upgrade Safari'
	      ),
	      '.'
	    )
	  );
	};
	
	var doNotUseIE = function doNotUseIE() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'browser-warning' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Hi, it looks like you are using Internet Explorer.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Unfortunately ',
	      PLATFORM_NAME,
	      ' will not work well in this browser.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We recommend using ',
	      chromeDownloadLink(),
	      '. It\'s fast, secure and free!'
	    )
	  );
	};
	
	var shouldBeFine = function shouldBeFine(browser) {
	  return _react2.default.createElement(
	    'p',
	    null,
	    PLATFORM_NAME,
	    ' should work fine in ',
	    browser,
	    ', but we recommend using ',
	    chromeDownloadLink(),
	    '.'
	  );
	};

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	
	var transformHashtagstIntoArray = function transformHashtagstIntoArray() {
	  var hashtagsString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return _.reject(_.map(_.split(hashtagsString, ','), function (tag) {
	    return _.trim(tag);
	  }), _.isEmpty);
	};
	
	module.exports = {
	  transformHashtagstIntoArray: transformHashtagstIntoArray
	};

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(2402);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ },
/* 234 */
[4185, 3790],
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(370);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 236 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 237 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(578);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * Base64 encoding strategy.
		     */
		    var Base64 = C_enc.Base64 = {
		        /**
		         * Converts a word array to a Base64 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Base64 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
		            var map = this._map;
	
		            // Clamp excess bits
		            wordArray.clamp();
	
		            // Convert
		            var base64Chars = [];
		            for (var i = 0; i < sigBytes; i += 3) {
		                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
		                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
		                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;
	
		                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;
	
		                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
		                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
		                }
		            }
	
		            // Add padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                while (base64Chars.length % 4) {
		                    base64Chars.push(paddingChar);
		                }
		            }
	
		            return base64Chars.join('');
		        },
	
		        /**
		         * Converts a Base64 string to a word array.
		         *
		         * @param {string} base64Str The Base64 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
		         */
		        parse: function (base64Str) {
		            // Shortcuts
		            var base64StrLength = base64Str.length;
		            var map = this._map;
		            var reverseMap = this._reverseMap;
	
		            if (!reverseMap) {
		                    reverseMap = this._reverseMap = [];
		                    for (var j = 0; j < map.length; j++) {
		                        reverseMap[map.charCodeAt(j)] = j;
		                    }
		            }
	
		            // Ignore padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                var paddingIndex = base64Str.indexOf(paddingChar);
		                if (paddingIndex !== -1) {
		                    base64StrLength = paddingIndex;
		                }
		            }
	
		            // Convert
		            return parseLoop(base64Str, base64StrLength, reverseMap);
	
		        },
	
		        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
		    };
	
		    function parseLoop(base64Str, base64StrLength, reverseMap) {
		      var words = [];
		      var nBytes = 0;
		      for (var i = 0; i < base64StrLength; i++) {
		          if (i % 4) {
		              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
		              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
		              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
		              nBytes++;
		          }
		      }
		      return WordArray.create(words, nBytes);
		    }
		}());
	
	
		return CryptoJS.enc.Base64;
	
	}));

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var T = [];
	
		    // Compute constants
		    (function () {
		        for (var i = 0; i < 64; i++) {
		            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
		        }
		    }());
	
		    /**
		     * MD5 hash algorithm.
		     */
		    var MD5 = C_algo.MD5 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
	
		            // Shortcuts
		            var H = this._hash.words;
	
		            var M_offset_0  = M[offset + 0];
		            var M_offset_1  = M[offset + 1];
		            var M_offset_2  = M[offset + 2];
		            var M_offset_3  = M[offset + 3];
		            var M_offset_4  = M[offset + 4];
		            var M_offset_5  = M[offset + 5];
		            var M_offset_6  = M[offset + 6];
		            var M_offset_7  = M[offset + 7];
		            var M_offset_8  = M[offset + 8];
		            var M_offset_9  = M[offset + 9];
		            var M_offset_10 = M[offset + 10];
		            var M_offset_11 = M[offset + 11];
		            var M_offset_12 = M[offset + 12];
		            var M_offset_13 = M[offset + 13];
		            var M_offset_14 = M[offset + 14];
		            var M_offset_15 = M[offset + 15];
	
		            // Working varialbes
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
	
		            // Computation
		            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
		            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
		            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
		            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
		            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
		            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
		            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
		            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
		            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
		            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
		            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
		            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
		            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
		            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
		            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
		            b = FF(b, c, d, a, M_offset_15, 22, T[15]);
	
		            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
		            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
		            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
		            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
		            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
		            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
		            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
		            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
		            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
		            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
		            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
		            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
		            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
		            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
		            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
		            b = GG(b, c, d, a, M_offset_12, 20, T[31]);
	
		            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
		            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
		            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
		            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
		            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
		            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
		            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
		            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
		            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
		            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
		            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
		            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
		            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
		            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
		            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
		            b = HH(b, c, d, a, M_offset_2,  23, T[47]);
	
		            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
		            d = II(d, a, b, c, M_offset_7,  10, T[49]);
		            c = II(c, d, a, b, M_offset_14, 15, T[50]);
		            b = II(b, c, d, a, M_offset_5,  21, T[51]);
		            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
		            d = II(d, a, b, c, M_offset_3,  10, T[53]);
		            c = II(c, d, a, b, M_offset_10, 15, T[54]);
		            b = II(b, c, d, a, M_offset_1,  21, T[55]);
		            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
		            d = II(d, a, b, c, M_offset_15, 10, T[57]);
		            c = II(c, d, a, b, M_offset_6,  15, T[58]);
		            b = II(b, c, d, a, M_offset_13, 21, T[59]);
		            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
		            d = II(d, a, b, c, M_offset_11, 10, T[61]);
		            c = II(c, d, a, b, M_offset_2,  15, T[62]);
		            b = II(b, c, d, a, M_offset_9,  21, T[63]);
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	
		            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
		            var nBitsTotalL = nBitsTotal;
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
		                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
		            );
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
		            );
	
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    function FF(a, b, c, d, x, s, t) {
		        var n = a + ((b & c) | (~b & d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function GG(a, b, c, d, x, s, t) {
		        var n = a + ((b & d) | (c & ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function HH(a, b, c, d, x, s, t) {
		        var n = a + (b ^ c ^ d) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function II(a, b, c, d, x, s, t) {
		        var n = a + (c ^ (b | ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.MD5('message');
		     *     var hash = CryptoJS.MD5(wordArray);
		     */
		    C.MD5 = Hasher._createHelper(MD5);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacMD5(message, key);
		     */
		    C.HmacMD5 = Hasher._createHmacHelper(MD5);
		}(Math));
	
	
		return CryptoJS.MD5;
	
	}));

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactChartjs = __webpack_require__(207);
	
	var _colors = __webpack_require__(380);
	
	var _demographics = __webpack_require__(972);
	
	var _constants = __webpack_require__(971);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getGraphLabelFormatting = function getGraphLabelFormatting(tooltipItem, data) {
	  var label = data.labels[tooltipItem.index];
	  var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	  return label + ' - ' + (0, _formatting.percentFormatted)(datasetLabel) + '%';
	};
	
	var getBarOptions = function getBarOptions() {
	  return {
	    tooltips: {
	      mode: 'single',
	      intersect: false,
	      callbacks: {
	        label: function label(tooltipItem, data) {
	          return getGraphLabelFormatting(tooltipItem, data);
	        }
	      }
	    },
	    responsive: true,
	    showScale: false,
	    scales: {
	      xAxes: [{
	        stacked: true
	      }],
	      yAxes: [{
	        stacked: true
	      }]
	    }
	  };
	};
	
	var getAgeGraph = function getAgeGraph(data) {
	  var sortedData = (0, _lodash2.default)(data).toPairs().sortBy(0).fromPairs().value();
	  var values = (0, _demographics.reduceGraphDataByGender)(sortedData);
	  var ageGroups = _lodash2.default.flattenDeep(_lodash2.default.map(values, function (value) {
	    return _lodash2.default.map(value, 'group');
	  }));
	  return {
	    labels: _lodash2.default.uniq(ageGroups),
	    datasets: [{
	      label: _constants.GENDERS.M.text,
	      backgroundColor: _colors.dyzioPalette.blue,
	      borderColor: _colors.dyzioPalette.blue,
	      borderWidth: 1,
	      hoverBackgroundColor: _colors.dyzioPalette.blue,
	      hoverBorderColor: _colors.dyzioPalette.blue,
	      data: _lodash2.default.map(values.M || [], 'percentage')
	    }, {
	      label: _constants.GENDERS.F.text,
	      backgroundColor: _colors.dyzioPalette.pink,
	      borderColor: _colors.dyzioPalette.pink,
	      borderWidth: 1,
	      hoverBackgroundColor: _colors.dyzioPalette.pink,
	      hoverBorderColor: _colors.dyzioPalette.pink,
	      data: _lodash2.default.map(values.F || [], 'percentage')
	    }, {
	      label: _constants.GENDERS.U.text,
	      backgroundColor: _colors.dyzioPalette.grey,
	      borderColor: _colors.dyzioPalette.grey,
	      borderWidth: 1,
	      hoverBackgroundColor: _colors.dyzioPalette.grey,
	      hoverBorderColor: _colors.dyzioPalette.grey,
	      data: _lodash2.default.map(values.U || [], 'percentage')
	    }]
	  };
	};
	
	var DemographicsAgeGraph = function DemographicsAgeGraph(_ref) {
	  var data = _ref.audienceDemographics.data;
	
	  var graphData = getAgeGraph(data);
	  var graphOptions = getBarOptions();
	  return _react2.default.createElement(_reactChartjs.HorizontalBar, { data: graphData, options: graphOptions });
	};
	
	DemographicsAgeGraph.propTypes = {
	  audienceDemographics: _propTypes2.default.object.isRequired
	};
	
	exports.default = DemographicsAgeGraph;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var startsWithVowel = function startsWithVowel() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return value.match('^[aieouAIEOU].*');
	};
	
	var NotAvailableComponent = function NotAvailableComponent(_ref) {
	  var metricName = _ref.metricName,
	      platform = _ref.platform,
	      assetType = _ref.assetType;
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline', color: 'grey' }),
	    content: 'The ' + _lodash2.default.capitalize(platform) + ' platform does not support ' + _lodash2.default.capitalize(metricName) + ' for ' + (startsWithVowel(assetType) ? 'an' : 'a') + ' ' + assetType + '.'
	  });
	};
	
	exports.default = NotAvailableComponent;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isVideoUrl = exports.happyES = exports.resolvePlatformIcon = exports.getSupportingDataField = exports.getS3Url = undefined;
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getS3Url = exports.getS3Url = function getS3Url(url) {
	  var defaultUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://s3-eu-west-1.amazonaws.com/dyzio-static-files/images/instagram-story2.png';
	
	  if (!url) return defaultUrl;
	  var bucket = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/';
	  return '' + bucket + url;
	};
	
	var getSupportingDataField = exports.getSupportingDataField = function getSupportingDataField(supportingData) {
	  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'impressions';
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
	  var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
	    return o.createdDate;
	  }));
	  var lastSupportingData = _lodash2.default.head(ordered);
	
	  if (key === 'filePath') {
	    return _lodash2.default.get(lastSupportingData, key, null);
	  }
	
	  if (_lodash2.default.has(lastSupportingData, 'data.' + key)) {
	    return _lodash2.default.toInteger(_lodash2.default.get(lastSupportingData, 'data.' + key, 0));
	  }
	  return _lodash2.default.toInteger(_lodash2.default.get(lastSupportingData, key, defaultValue));
	};
	
	var resolvePlatformIcon = exports.resolvePlatformIcon = function resolvePlatformIcon(platform) {
	  var icons = {
	    SNAPCHAT: {
	      color: 'yellow',
	      name: 'snapchat'
	    },
	    VK: {
	      color: 'blue',
	      name: 'vk'
	    },
	    BLOG: {
	      color: 'gray',
	      name: 'pencil'
	    },
	    DEFAULT: {
	      color: 'pink',
	      name: 'image'
	    }
	  };
	  return _lodash2.default.get(icons, platform);
	};
	
	var happyES = exports.happyES = function happyES() {
	  var name = 'MD';
	  return name;
	};
	
	var isVideoUrl = exports.isVideoUrl = function isVideoUrl(url) {
	  console.log('isVideoUrl', url);
	  var videoFormats = ['.mp4', '.mov', '.avi', 'wmv'];
	  var result = false;
	  _lodash2.default.forEach(videoFormats, function (format) {
	    if (_lodash2.default.includes(_lodash2.default.toLower(url), format)) {
	      result = true;
	    }
	  });
	  console.log('isVideoUrl', result);
	  return result;
	};

/***/ },
/* 244 */
[4197, 78],
/* 245 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 246 */
[4361, 296, 201, 995, 47],
/* 247 */
[4504, 1219],
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 249 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 250 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 251 */
[4182, 3037, 3036, 1425],
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  F: __webpack_require__(3040),
	  T: __webpack_require__(3041),
	  __: __webpack_require__(3042),
	  add: __webpack_require__(426),
	  addIndex: __webpack_require__(3043),
	  adjust: __webpack_require__(1430),
	  all: __webpack_require__(3044),
	  allPass: __webpack_require__(3045),
	  always: __webpack_require__(253),
	  and: __webpack_require__(1431),
	  any: __webpack_require__(1432),
	  anyPass: __webpack_require__(3046),
	  ap: __webpack_require__(681),
	  aperture: __webpack_require__(3047),
	  append: __webpack_require__(3048),
	  apply: __webpack_require__(1433),
	  applySpec: __webpack_require__(3049),
	  ascend: __webpack_require__(3050),
	  assoc: __webpack_require__(427),
	  assocPath: __webpack_require__(1434),
	  binary: __webpack_require__(3051),
	  bind: __webpack_require__(1435),
	  both: __webpack_require__(3052),
	  call: __webpack_require__(3053),
	  chain: __webpack_require__(682),
	  clamp: __webpack_require__(3054),
	  clone: __webpack_require__(3055),
	  comparator: __webpack_require__(3056),
	  complement: __webpack_require__(3057),
	  compose: __webpack_require__(683),
	  composeK: __webpack_require__(1436),
	  composeP: __webpack_require__(3058),
	  concat: __webpack_require__(684),
	  cond: __webpack_require__(3059),
	  construct: __webpack_require__(3060),
	  constructN: __webpack_require__(1437),
	  contains: __webpack_require__(3061),
	  converge: __webpack_require__(1438),
	  countBy: __webpack_require__(3062),
	  curry: __webpack_require__(428),
	  curryN: __webpack_require__(80),
	  dec: __webpack_require__(3063),
	  defaultTo: __webpack_require__(1439),
	  descend: __webpack_require__(3064),
	  difference: __webpack_require__(1440),
	  differenceWith: __webpack_require__(1441),
	  dissoc: __webpack_require__(1442),
	  dissocPath: __webpack_require__(3065),
	  divide: __webpack_require__(3066),
	  drop: __webpack_require__(1443),
	  dropLast: __webpack_require__(3067),
	  dropLastWhile: __webpack_require__(3068),
	  dropRepeats: __webpack_require__(3069),
	  dropRepeatsWith: __webpack_require__(1444),
	  dropWhile: __webpack_require__(3070),
	  either: __webpack_require__(3071),
	  empty: __webpack_require__(1445),
	  endsWith: __webpack_require__(3072),
	  eqBy: __webpack_require__(3073),
	  eqProps: __webpack_require__(3074),
	  equals: __webpack_require__(111),
	  evolve: __webpack_require__(3075),
	  filter: __webpack_require__(685),
	  find: __webpack_require__(3076),
	  findIndex: __webpack_require__(3077),
	  findLast: __webpack_require__(3078),
	  findLastIndex: __webpack_require__(3079),
	  flatten: __webpack_require__(3080),
	  flip: __webpack_require__(429),
	  forEach: __webpack_require__(3081),
	  forEachObjIndexed: __webpack_require__(3082),
	  fromPairs: __webpack_require__(3083),
	  groupBy: __webpack_require__(3084),
	  groupWith: __webpack_require__(3085),
	  gt: __webpack_require__(3086),
	  gte: __webpack_require__(3087),
	  has: __webpack_require__(3088),
	  hasIn: __webpack_require__(3089),
	  head: __webpack_require__(3090),
	  identical: __webpack_require__(1446),
	  identity: __webpack_require__(686),
	  ifElse: __webpack_require__(3091),
	  inc: __webpack_require__(3092),
	  indexBy: __webpack_require__(3093),
	  indexOf: __webpack_require__(3094),
	  init: __webpack_require__(3095),
	  innerJoin: __webpack_require__(3096),
	  insert: __webpack_require__(3097),
	  insertAll: __webpack_require__(3098),
	  intersection: __webpack_require__(3133),
	  intersectionWith: __webpack_require__(3134),
	  intersperse: __webpack_require__(3135),
	  into: __webpack_require__(3136),
	  invert: __webpack_require__(3137),
	  invertObj: __webpack_require__(3138),
	  invoker: __webpack_require__(309),
	  is: __webpack_require__(1458),
	  isEmpty: __webpack_require__(3139),
	  isNil: __webpack_require__(1459),
	  join: __webpack_require__(3140),
	  juxt: __webpack_require__(1460),
	  keys: __webpack_require__(136),
	  keysIn: __webpack_require__(3141),
	  last: __webpack_require__(1461),
	  lastIndexOf: __webpack_require__(3142),
	  length: __webpack_require__(1462),
	  lens: __webpack_require__(436),
	  lensIndex: __webpack_require__(3143),
	  lensPath: __webpack_require__(3144),
	  lensProp: __webpack_require__(3145),
	  lift: __webpack_require__(437),
	  liftN: __webpack_require__(1463),
	  lt: __webpack_require__(3146),
	  lte: __webpack_require__(3147),
	  map: __webpack_require__(99),
	  mapAccum: __webpack_require__(3148),
	  mapAccumRight: __webpack_require__(3149),
	  mapObjIndexed: __webpack_require__(3150),
	  match: __webpack_require__(3151),
	  mathMod: __webpack_require__(3152),
	  max: __webpack_require__(254),
	  maxBy: __webpack_require__(3153),
	  mean: __webpack_require__(1464),
	  median: __webpack_require__(3154),
	  memoize: __webpack_require__(3155),
	  memoizeWith: __webpack_require__(1465),
	  merge: __webpack_require__(3156),
	  mergeAll: __webpack_require__(3157),
	  mergeDeepLeft: __webpack_require__(3158),
	  mergeDeepRight: __webpack_require__(3159),
	  mergeDeepWith: __webpack_require__(3160),
	  mergeDeepWithKey: __webpack_require__(438),
	  mergeWith: __webpack_require__(3161),
	  mergeWithKey: __webpack_require__(693),
	  min: __webpack_require__(3162),
	  minBy: __webpack_require__(3163),
	  modulo: __webpack_require__(3164),
	  multiply: __webpack_require__(1466),
	  nAry: __webpack_require__(439),
	  negate: __webpack_require__(3165),
	  none: __webpack_require__(3166),
	  not: __webpack_require__(1467),
	  nth: __webpack_require__(310),
	  nthArg: __webpack_require__(3167),
	  o: __webpack_require__(3168),
	  objOf: __webpack_require__(1468),
	  of: __webpack_require__(3169),
	  omit: __webpack_require__(3170),
	  once: __webpack_require__(3171),
	  or: __webpack_require__(1469),
	  over: __webpack_require__(1470),
	  pair: __webpack_require__(3172),
	  partial: __webpack_require__(3173),
	  partialRight: __webpack_require__(3174),
	  partition: __webpack_require__(3175),
	  path: __webpack_require__(311),
	  pathEq: __webpack_require__(3176),
	  pathOr: __webpack_require__(3177),
	  pathSatisfies: __webpack_require__(3178),
	  pick: __webpack_require__(3179),
	  pickAll: __webpack_require__(1471),
	  pickBy: __webpack_require__(3180),
	  pipe: __webpack_require__(1472),
	  pipeK: __webpack_require__(3181),
	  pipeP: __webpack_require__(1473),
	  pluck: __webpack_require__(312),
	  prepend: __webpack_require__(1474),
	  product: __webpack_require__(3182),
	  project: __webpack_require__(3183),
	  prop: __webpack_require__(694),
	  propEq: __webpack_require__(3184),
	  propIs: __webpack_require__(3185),
	  propOr: __webpack_require__(3186),
	  propSatisfies: __webpack_require__(3187),
	  props: __webpack_require__(3188),
	  range: __webpack_require__(3189),
	  reduce: __webpack_require__(137),
	  reduceBy: __webpack_require__(440),
	  reduceRight: __webpack_require__(1475),
	  reduceWhile: __webpack_require__(3190),
	  reduced: __webpack_require__(3191),
	  reject: __webpack_require__(441),
	  remove: __webpack_require__(1476),
	  repeat: __webpack_require__(3192),
	  replace: __webpack_require__(3193),
	  reverse: __webpack_require__(442),
	  scan: __webpack_require__(3194),
	  sequence: __webpack_require__(1477),
	  set: __webpack_require__(3195),
	  slice: __webpack_require__(212),
	  sort: __webpack_require__(3196),
	  sortBy: __webpack_require__(3197),
	  sortWith: __webpack_require__(3198),
	  split: __webpack_require__(3199),
	  splitAt: __webpack_require__(3200),
	  splitEvery: __webpack_require__(3201),
	  splitWhen: __webpack_require__(3202),
	  startsWith: __webpack_require__(3203),
	  subtract: __webpack_require__(3204),
	  sum: __webpack_require__(1478),
	  symmetricDifference: __webpack_require__(3205),
	  symmetricDifferenceWith: __webpack_require__(3206),
	  tail: __webpack_require__(695),
	  take: __webpack_require__(696),
	  takeLast: __webpack_require__(1479),
	  takeLastWhile: __webpack_require__(3207),
	  takeWhile: __webpack_require__(3208),
	  tap: __webpack_require__(3209),
	  test: __webpack_require__(3210),
	  times: __webpack_require__(1480),
	  toLower: __webpack_require__(3211),
	  toPairs: __webpack_require__(3212),
	  toPairsIn: __webpack_require__(3213),
	  toString: __webpack_require__(313),
	  toUpper: __webpack_require__(3214),
	  transduce: __webpack_require__(3215),
	  transpose: __webpack_require__(3216),
	  traverse: __webpack_require__(3217),
	  trim: __webpack_require__(3218),
	  tryCatch: __webpack_require__(3219),
	  type: __webpack_require__(697),
	  unapply: __webpack_require__(3220),
	  unary: __webpack_require__(3221),
	  uncurryN: __webpack_require__(3222),
	  unfold: __webpack_require__(3223),
	  union: __webpack_require__(3224),
	  unionWith: __webpack_require__(3225),
	  uniq: __webpack_require__(698),
	  uniqBy: __webpack_require__(1481),
	  uniqWith: __webpack_require__(699),
	  unless: __webpack_require__(3226),
	  unnest: __webpack_require__(3227),
	  until: __webpack_require__(3228),
	  update: __webpack_require__(700),
	  useWith: __webpack_require__(1482),
	  values: __webpack_require__(1483),
	  valuesIn: __webpack_require__(3229),
	  view: __webpack_require__(3230),
	  when: __webpack_require__(3231),
	  where: __webpack_require__(1484),
	  whereEq: __webpack_require__(3232),
	  without: __webpack_require__(3233),
	  xprod: __webpack_require__(3234),
	  zip: __webpack_require__(3235),
	  zipObj: __webpack_require__(3236),
	  zipWith: __webpack_require__(3237)
	};


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Returns a function that always returns the given value. Note that for
	 * non-primitives the value returned is a reference to the original value.
	 *
	 * This function is known as `const`, `constant`, or `K` (for K combinator) in
	 * other languages and libraries.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> (* -> a)
	 * @param {*} val The value to wrap in a function
	 * @return {Function} A Function :: * -> val.
	 * @example
	 *
	 *      var t = R.always('Tee');
	 *      t(); //=> 'Tee'
	 */
	module.exports = _curry1(function always(val) {
	  return function() {
	    return val;
	  };
	});


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns the larger of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.maxBy, R.min
	 * @example
	 *
	 *      R.max(789, 123); //=> 789
	 *      R.max('a', 'b'); //=> 'b'
	 */
	module.exports = _curry2(function max(a, b) { return b > a ? b : a; });


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BrowserDetection = function (_React$Component) {
	  _inherits(BrowserDetection, _React$Component);
	
	  function BrowserDetection(props) {
	    _classCallCheck(this, BrowserDetection);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BrowserDetection).call(this, props));
	
	    var isOpera = !!window.opr && !!opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
	    var isFirefox = typeof InstallTrigger !== 'undefined';
	    var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
	    var isIE = /*@cc_on!@*/false || !!document.documentMode;
	    var isEdge = !isIE && !!window.StyleMedia;
	    var isChrome = !!window.chrome && !!window.chrome.webstore;
	    var isBlink = (isChrome || isOpera) && !!window.CSS;
	    var browser = undefined;
	
	    if (isOpera) {
	      browser = 'opera';
	    } else if (isFirefox) {
	      browser = 'firefox';
	    } else if (isSafari) {
	      browser = 'safari';
	    } else if (isIE) {
	      browser = 'ie';
	    } else if (isEdge) {
	      browser = 'edge';
	    } else if (isChrome) {
	      browser = 'chrome';
	    } else if (isBlink) {
	      browser = 'blink';
	    } else {
	      browser = 'unknown';
	    }
	
	    _this.state = {
	      browser: browser,
	      children: _react2.default.createElement('div', null)
	    };
	    return _this;
	  }
	
	  _createClass(BrowserDetection, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState(this.getConfigs.call(this));
	    }
	  }, {
	    key: 'getConfigs',
	    value: function getConfigs() {
	      var children = this.props.children;
	      var browser = this.state.browser;
	
	      var func = children[browser] || children.default;
	      return {
	        browser: browser,
	        children: func(browser)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return this.props.once ? this.state.children : function () {
	        return _this2.getConfigs.call(_this2).children;
	      }();
	    }
	  }]);
	
	  return BrowserDetection;
	}(_react2.default.Component);
	
	BrowserDetection.defaultProps = {
	  once: true
	};
	
	BrowserDetection.propTypes = {
	  children: _react2.default.PropTypes.object.isRequired,
	  once: _react2.default.PropTypes.bool
	};
	
	exports.default = BrowserDetection;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(81);
	
	exports['default'] = _react.PropTypes.oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION]);

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isSameDay;
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isSameDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return a.isSame(b, 'day');
	}

/***/ },
/* 258 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clone = clone;
	exports.isDate = isDate;
	exports.addMonths = addMonths;
	exports.isSameDay = isSameDay;
	exports.isSameMonth = isSameMonth;
	exports.isDayBefore = isDayBefore;
	exports.isDayAfter = isDayAfter;
	exports.isPastDay = isPastDay;
	exports.isFutureDay = isFutureDay;
	exports.isDayBetween = isDayBetween;
	exports.addDayToRange = addDayToRange;
	exports.isDayInRange = isDayInRange;
	exports.getWeekNumber = getWeekNumber;
	/**
	 * Clone a date object.
	 *
	 * @export
	 * @param  {Date} d The date to clone
	 * @return {Date} The cloned date
	 */
	function clone(d) {
	  return new Date(d.getTime());
	}
	
	/**
	 * Return `true` if the passed value is a valid JavaScript Date object.
	 *
	 * @export
	 * @param {any} value
	 * @returns {Boolean}
	 */
	function isDate(value) {
	  return value instanceof Date && !isNaN(value.valueOf());
	}
	
	/**
	 * Return `d` as a new date with `n` months added.
	 *
	 * @export
	 * @param {Date} d
	 * @param {number} n
	 */
	function addMonths(d, n) {
	  var newDate = clone(d);
	  newDate.setMonth(d.getMonth() + n);
	  return newDate;
	}
	
	/**
	 * Return `true` if two dates are the same day, ignoring the time.
	 *
	 * @export
	 * @param  {Date}  d1
	 * @param  {Date}  d2
	 * @return {Boolean}
	 */
	function isSameDay(d1, d2) {
	  if (!d1 || !d2) {
	    return false;
	  }
	  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
	}
	
	/**
	 * Return `true` if two dates fall in the same month.
	 *
	 * @export
	 * @param  {Date}  d1
	 * @param  {Date}  d2
	 * @return {Boolean}
	 */
	function isSameMonth(d1, d2) {
	  if (!d1 || !d2) {
	    return false;
	  }
	  return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
	}
	
	/**
	 * Returns `true` if the first day is before the second day.
	 *
	 * @export
	 * @param {Date} d1
	 * @param {Date} d2
	 * @returns {Boolean}
	 */
	function isDayBefore(d1, d2) {
	  var day1 = clone(d1).setHours(0, 0, 0, 0);
	  var day2 = clone(d2).setHours(0, 0, 0, 0);
	  return day1 < day2;
	}
	
	/**
	 * Returns `true` if the first day is after the second day.
	 *
	 * @export
	 * @param {Date} d1
	 * @param {Date} d2
	 * @returns {Boolean}
	 */
	function isDayAfter(d1, d2) {
	  var day1 = clone(d1).setHours(0, 0, 0, 0);
	  var day2 = clone(d2).setHours(0, 0, 0, 0);
	  return day1 > day2;
	}
	
	/**
	 * Return `true` if a day is in the past, e.g. yesterday or any day
	 * before yesterday.
	 *
	 * @export
	 * @param  {Date}  d
	 * @return {Boolean}
	 */
	function isPastDay(d) {
	  var today = new Date();
	  today.setHours(0, 0, 0, 0);
	  return isDayBefore(d, today);
	}
	
	/**
	 * Return `true` if a day is in the future, e.g. tomorrow or any day
	 * after tomorrow.
	 *
	 * @export
	 * @param  {Date}  d
	 * @return {Boolean}
	 */
	function isFutureDay(d) {
	  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
	  tomorrow.setHours(0, 0, 0, 0);
	  return d >= tomorrow;
	}
	
	/**
	 * Return `true` if day `d` is between days `d1` and `d2`,
	 * without including them.
	 *
	 * @export
	 * @param  {Date}  d
	 * @param  {Date}  d1
	 * @param  {Date}  d2
	 * @return {Boolean}
	 */
	function isDayBetween(d, d1, d2) {
	  var date = clone(d);
	  date.setHours(0, 0, 0, 0);
	  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
	}
	
	/**
	 * Add a day to a range and return a new range. A range is an object with
	 * `from` and `to` days.
	 *
	 * @export
	 * @param {Date} day
	 * @param {Object} range
	 * @return {Object} Returns a new range object
	 */
	function addDayToRange(day) {
	  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
	  var from = range.from,
	      to = range.to;
	
	  if (!from) {
	    from = day;
	  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
	    from = null;
	    to = null;
	  } else if (to && isDayBefore(day, from)) {
	    from = day;
	  } else if (to && isSameDay(day, to)) {
	    from = day;
	    to = day;
	  } else {
	    to = day;
	    if (isDayBefore(to, from)) {
	      to = from;
	      from = day;
	    }
	  }
	
	  return { from: from, to: to };
	}
	
	/**
	 * Return `true` if a day is included in a range of days.
	 *
	 * @export
	 * @param  {Date}  day
	 * @param  {Object}  range
	 * @return {Boolean}
	 */
	function isDayInRange(day, range) {
	  var from = range.from,
	      to = range.to;
	
	  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
	}
	
	/**
	 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
	 * for the given day.
	 *
	 * @export
	 * @param {Date} day
	 * @returns {Number}
	 */
	function getWeekNumber(day) {
	  var date = clone(day);
	  date.setHours(0, 0, 0);
	  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
	  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
	}
	
	exports.default = {
	  addDayToRange: addDayToRange,
	  addMonths: addMonths,
	  clone: clone,
	  getWeekNumber: getWeekNumber,
	  isDate: isDate,
	  isDayAfter: isDayAfter,
	  isDayBefore: isDayBefore,
	  isDayBetween: isDayBetween,
	  isDayInRange: isDayInRange,
	  isFutureDay: isFutureDay,
	  isPastDay: isPastDay,
	  isSameDay: isSameDay,
	  isSameMonth: isSameMonth
	};
	//# sourceMappingURL=DateUtils.js.map

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(708);
	var setInnerHTML = __webpack_require__(452);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(716);
	var setTextContent = __webpack_require__(1529);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(36);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 261 */
[4296, 3407, 3430],
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 263 */
[4296, 3562, 3575],
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var ReactCurrentOwner = __webpack_require__(159);
	
	var warning = __webpack_require__(41);
	var canDefineProperty = __webpack_require__(1588);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(1586);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 265 */
46,
/* 266 */
[4221, 478, 3730, 3759],
/* 267 */
[4437, 1600, 1605, 139, 484, 1614, 330, 1618],
/* 268 */
[4504, 1661],
/* 269 */
[4197, 82],
/* 270 */
245,
/* 271 */
[4264, 501, 503],
/* 272 */
[4361, 334, 220, 1736, 49],
/* 273 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 274 */
[4182, 1829, 1828, 530],
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable no-param-reassign */
	var request = __webpack_require__(1831);
	var base64Url = __webpack_require__(1837);
	var version = __webpack_require__(532);
	
	// ------------------------------------------------ RequestWrapper
	
	function RequestWrapper(req) {
	  this.request = req;
	  this.method = req.method;
	  this.url = req.url;
	  this.body = req._data;
	  this.headers = req._header;
	}
	
	RequestWrapper.prototype.abort = function() {
	  this.request.abort();
	};
	
	RequestWrapper.prototype.getMethod = function() {
	  return this.method;
	};
	
	RequestWrapper.prototype.getBody = function() {
	  return this.body;
	};
	
	RequestWrapper.prototype.getUrl = function() {
	  return this.url;
	};
	
	RequestWrapper.prototype.getHeaders = function() {
	  return this.headers;
	};
	
	// ------------------------------------------------ RequestObj
	
	function RequestObj(req) {
	  this.request = req;
	}
	
	RequestObj.prototype.set = function(key, value) {
	  this.request = this.request.set(key, value);
	  return this;
	};
	
	RequestObj.prototype.send = function(body) {
	  this.request = this.request.send(body);
	  return this;
	};
	
	RequestObj.prototype.withCredentials = function() {
	  this.request = this.request.withCredentials();
	  return this;
	};
	
	RequestObj.prototype.end = function(cb) {
	  this.request = this.request.end(cb);
	  return new RequestWrapper(this.request);
	};
	
	// ------------------------------------------------ RequestBuilder
	
	function RequestBuilder(options) {
	  this._sendTelemetry = options._sendTelemetry === false ? options._sendTelemetry : true;
	  this._telemetryInfo = options._telemetryInfo || null;
	  this._timesToRetryFailedRequests = options._timesToRetryFailedRequests;
	  this.headers = options.headers || {};
	}
	
	RequestBuilder.prototype.setCommonConfiguration = function(ongoingRequest, options) {
	  options = options || {};
	
	  if (this._timesToRetryFailedRequests > 0) {
	    ongoingRequest = ongoingRequest.retry(this._timesToRetryFailedRequests);
	  }
	
	  if (options.noHeaders) {
	    return ongoingRequest;
	  }
	
	  var headers = this.headers;
	  ongoingRequest = ongoingRequest.set('Content-Type', 'application/json');
	
	  var keys = Object.keys(this.headers);
	
	  for (var a = 0; a < keys.length; a++) {
	    ongoingRequest = ongoingRequest.set(keys[a], headers[keys[a]]);
	  }
	
	  if (this._sendTelemetry) {
	    ongoingRequest = ongoingRequest.set('Auth0-Client', this.getTelemetryData());
	  }
	
	  return ongoingRequest;
	};
	
	RequestBuilder.prototype.getTelemetryData = function() {
	  var clientInfo = this._telemetryInfo || { name: 'auth0.js', version: version.raw };
	  var jsonClientInfo = JSON.stringify(clientInfo);
	  return base64Url.encode(jsonClientInfo);
	};
	
	RequestBuilder.prototype.get = function(url, options) {
	  return new RequestObj(this.setCommonConfiguration(request.get(url), options));
	};
	
	RequestBuilder.prototype.post = function(url, options) {
	  return new RequestObj(this.setCommonConfiguration(request.post(url), options));
	};
	
	RequestBuilder.prototype.patch = function(url, options) {
	  return new RequestObj(this.setCommonConfiguration(request.patch(url), options));
	};
	
	module.exports = RequestBuilder;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactTweetEmbed = __webpack_require__(469);
	
	var _reactTweetEmbed2 = _interopRequireDefault(_reactTweetEmbed);
	
	var _reactYoutube = __webpack_require__(745);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	var _reactTelegramEmbed = __webpack_require__(3533);
	
	var _reactTelegramEmbed2 = _interopRequireDefault(_reactTelegramEmbed);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _limitsExceededModal = __webpack_require__(886);
	
	var _limitsExceededModal2 = _interopRequireDefault(_limitsExceededModal);
	
	var _dyzioInstagramEmbed = __webpack_require__(346);
	
	var _dyzioInstagramEmbed2 = _interopRequireDefault(_dyzioInstagramEmbed);
	
	var _assetUrlHelperService = __webpack_require__(362);
	
	var _facebookEmbed = __webpack_require__(873);
	
	var _facebookEmbed2 = _interopRequireDefault(_facebookEmbed);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var helpLinkUrl = _react2.default.createElement(
	  'a',
	  {
	    href: 'http://help.dyzio.co/getting-started/how-to-find-trackable-asset-urls',
	    target: '_blank',
	    rel: 'noopener noreferrer'
	  },
	  _react2.default.createElement(
	    'b',
	    null,
	    'How to find trackable asset URLs'
	  )
	);
	
	var noPadding = {
	  padding: 0
	};
	
	var previewBlockStyle = {
	  color: '#666666',
	  minHeight: 350,
	  height: 'auto'
	};
	
	var platformColors = {
	  twitter: '#00aced',
	  facebook: '#3b5998',
	  youtube: '#cc181e',
	  instagram: '#cd486b'
	};
	
	var platformsObjects = {
	  twitter: 'tweet',
	  facebook: 'video, photo or post',
	  youtube: 'youtube video',
	  instagram: 'instagram post',
	  tiktok: 'tiktok video',
	  telegram: 'telegram post',
	  external: 'asset'
	};
	
	var previewIconStyle = {
	  marginTop: 150
	};
	
	var AddAssetForm = function (_React$Component) {
	  _inherits(AddAssetForm, _React$Component);
	
	  function AddAssetForm() {
	    var _this2 = this;
	
	    _classCallCheck(this, AddAssetForm);
	
	    var _this = _possibleConstructorReturn(this, (AddAssetForm.__proto__ || Object.getPrototypeOf(AddAssetForm)).call(this));
	
	    _this.onAssetUrlChanged = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e, data) {
	        var value, _this$props, platform, posts, details, existing, state, assetId, handle, videoMetaUrl, meta;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                value = data.value;
	                _this$props = _this.props, platform = _this$props.platform, posts = _this$props.posts;
	                details = (0, _assetUrlHelperService.extractAssetURLData)(value);
	                existing = _lodash2.default.find(posts.data.posts, ['trackedAsset.assetURL', details && details.assetURL || '']);
	
	
	                console.log(details);
	                console.log(platform);
	                console.log(value);
	
	                if (!existing) {
	                  _context.next = 10;
	                  break;
	                }
	
	                _this.setState({
	                  isDuplicateEntry: true
	                });
	                return _context.abrupt('return');
	
	              case 10:
	                state = _this.state;
	
	
	                _this.setState({
	                  isLoading: true,
	                  embedValue: null,
	                  hasError: false
	                });
	
	                if (!details || !details.platform || _lodash2.default.lowerCase(platform) !== _lodash2.default.lowerCase(details.platform)) {
	                  _this.setState({
	                    hasError: !_lodash2.default.isEmpty(value),
	                    isLoading: false,
	                    embedValue: null,
	                    inputValue: null,
	                    isDuplicateEntry: false
	                  });
	                }
	
	                _context.t0 = details.platform;
	                _context.next = _context.t0 === 'FACEBOOK' ? 16 : _context.t0 === 'TWITTER' ? 24 : _context.t0 === 'INSTAGRAM' ? 31 : _context.t0 === 'YOUTUBE' ? 39 : _context.t0 === 'TIKTOK' ? 46 : _context.t0 === 'TELEGRAM' ? 53 : 61;
	                break;
	
	              case 16:
	                state.isFacebook = true;
	                state.isTweet = false;
	                state.isInstagram = false;
	                state.isYoutube = false;
	                state.isTiktok = false;
	                state.embedValue = details.assetURL;
	                state.embedType = details.assetType;
	                return _context.abrupt('break', 62);
	
	              case 24:
	                state.isFacebook = false;
	                state.isTweet = true;
	                state.isInstagram = false;
	                state.isYoutube = false;
	                state.isTiktok = false;
	                state.embedValue = details.assetId;
	                return _context.abrupt('break', 62);
	
	              case 31:
	                state.isFacebook = false;
	                state.isTweet = false;
	                state.isInstagram = true;
	                state.isYoutube = false;
	                state.isTiktok = false;
	                state.embedValue = details.assetURL;
	                state.embedId = details.assetId;
	                return _context.abrupt('break', 62);
	
	              case 39:
	                state.isFacebook = false;
	                state.isTweet = false;
	                state.isInstagram = false;
	                state.isYoutube = true;
	                state.isTiktok = false;
	                state.embedValue = details.assetId;
	                return _context.abrupt('break', 62);
	
	              case 46:
	                state.isFacebook = false;
	                state.isTweet = false;
	                state.isInstagram = false;
	                state.isYoutube = false;
	                state.isTiktok = true;
	                state.embedValue = details.assetURL;
	                return _context.abrupt('break', 62);
	
	              case 53:
	                state.isFacebook = false;
	                state.isTweet = false;
	                state.isInstagram = false;
	                state.isYoutube = false;
	                state.isTiktok = false;
	                state.isTelegram = true;
	                state.embedValue = details.assetURL;
	                return _context.abrupt('break', 62);
	
	              case 61:
	                state.embedValue = null;
	
	              case 62:
	                if (!state.isTiktok) {
	                  _context.next = 77;
	                  break;
	                }
	
	                assetId = details.assetId, handle = details.handle;
	                videoMetaUrl = ("https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/tiktok/") + 'meta/user/' + handle + '/post/' + assetId;
	                _context.prev = 65;
	                _context.next = 68;
	                return (0, _axios2.default)(videoMetaUrl);
	
	              case 68:
	                meta = _context.sent;
	
	                state.embedImage = _lodash2.default.get(meta.data, 'imageUrl');
	                console.log(state.embedImage);
	                _context.next = 77;
	                break;
	
	              case 73:
	                _context.prev = 73;
	                _context.t1 = _context['catch'](65);
	
	                console.log(_context.t1);
	                state.isLoading = false;
	
	              case 77:
	
	                state.isLoading = false;
	                state.inputValue = details.assetURL;
	                state.isDuplicateEntry = false;
	                state.details = details;
	                _this.setState(state);
	
	                console.log(state);
	
	              case 83:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[65, 73]]);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onFocus = function (e) {
	      return e.target.select();
	    };
	
	    _this.onFormSubmit = function () {
	      var _this$state = _this.state,
	          hasError = _this$state.hasError,
	          isLoading = _this$state.isLoading,
	          previewUrl = _this$state.previewUrl,
	          embedValue = _this$state.embedValue,
	          details = _this$state.details;
	
	      var hasPost = previewUrl || embedValue;
	      var canSubmit = !hasError && !isLoading;
	      if (canSubmit && hasPost) {
	        _this.props.addAssetHandler(details);
	      }
	    };
	
	    _this.handleAddAsset = function () {
	      _this.setState({
	        isAddingAsset: true
	      }, function () {
	        var details = _this.state.details;
	        var popupToggleHandler = _this.state.popupToggleHandler;
	
	        _this.props.addAssetHandler(details);
	      });
	    };
	
	    _this.state = {
	      inputValue: null,
	      isLoading: false,
	      isTweet: false,
	      isFacebook: false,
	      isInstagram: false,
	      isYoutube: false,
	      isTiktok: false,
	      isTelegram: false,
	      hasError: false,
	      embedValue: null,
	      embedId: null,
	      isDuplicateEntry: false,
	      isAddingAsset: false
	    };
	    return _this;
	  }
	
	  _createClass(AddAssetForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.input) this.input.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          platform = _props.platform,
	          popupToggleHandler = _props.popupToggleHandler,
	          isOverLimit = _props.isOverLimit;
	      var _state = this.state,
	          inputValue = _state.inputValue,
	          hasError = _state.hasError,
	          isLoading = _state.isLoading,
	          previewUrl = _state.previewUrl,
	          isTweet = _state.isTweet,
	          isFacebook = _state.isFacebook,
	          isYoutube = _state.isYoutube,
	          isInstagram = _state.isInstagram,
	          isTiktok = _state.isTiktok,
	          isTelegram = _state.isTelegram,
	          embedValue = _state.embedValue,
	          embedType = _state.embedType,
	          embedId = _state.embedId,
	          embedImage = _state.embedImage,
	          isDuplicateEntry = _state.isDuplicateEntry,
	          isAddingAsset = _state.isAddingAsset;
	
	
	      var inputIconStyle = {
	        color: platformColors[platform]
	      };
	
	      var inputLabel = {
	        basic: true,
	        content: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: platform, style: inputIconStyle }),
	          ' URL'
	        )
	      };
	
	      var icon = isLoading ? 'refresh' : 'arrow circle outline up';
	
	      var youtubeEmbedOpts = {
	        color: 'white',
	        width: '100%',
	        showinfo: 1
	      };
	
	      var assetTypeText = platformsObjects[platform];
	
	      var _ThemeSelector$theme = _themeSelector2.default.theme(),
	          disableHelpLinks = _ThemeSelector$theme.disableHelpLinks;
	
	      var actionButtonIcon = isAddingAsset ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'spinner', loading: true }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'add' });
	
	      if (isOverLimit) {
	        return _react2.default.createElement(
	          _dyzioModal2.default,
	          {
	            onClose: popupToggleHandler,
	            onOpen: this.onOpen,
	            onActionButtonClick: this.handleAddAsset,
	            hasActionButton: true,
	            actionButtonContent: 'Add ' + assetTypeText,
	            actionButtonIcon: actionButtonIcon,
	            shouldDisableActionButton: true,
	            headerText: 'Add a new ' + assetTypeText + ' to your campaign',
	            size: 'tiny'
	          },
	          _react2.default.createElement(_limitsExceededModal2.default, { assetType: 'tracked asset' })
	        );
	      }
	
	      return _react2.default.createElement(
	        _dyzioModal2.default,
	        {
	          onClose: popupToggleHandler,
	          onOpen: this.onOpen,
	          onActionButtonClick: this.handleAddAsset,
	          hasActionButton: true,
	          actionButtonContent: 'Add ' + assetTypeText,
	          actionButtonIcon: actionButtonIcon,
	          shouldDisableActionButton: hasError || isAddingAsset || isLoading || !(previewUrl || embedValue),
	          headerText: 'Add a new ' + assetTypeText + ' to your campaign',
	          size: 'tiny',
	          hasFeedbackProvider: !disableHelpLinks,
	          feedbackType: 'info',
	          feedbackIcon: 'info circle',
	          feedbackContent: helpLinkUrl
	        },
	        isDuplicateEntry && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { fluid: true, error: true },
	          'This asset has already been added to the campaign.'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Form,
	          { onSubmit: this.onFormSubmit },
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(_semanticUiReact.Input, {
	              fluid: true,
	              value: inputValue,
	              label: inputLabel,
	              labelPosition: 'left',
	              style: noPadding,
	              onFocus: this.onFocus,
	              onChange: this.onAssetUrlChanged,
	              ref: function ref(i) {
	                _this3.input = i;
	              }
	            })
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Container,
	              { textAlign: 'center', style: previewBlockStyle },
	              hasError && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus circle', size: 'huge', style: previewIconStyle }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    'invalid ',
	                    _lodash2.default.upperFirst(platformsObjects[platform]),
	                    ' url.'
	                  )
	                )
	              ),
	              !previewUrl && !embedValue && !hasError && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { loading: isLoading, name: icon, size: 'huge', style: previewIconStyle }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    isLoading ? 'please wait...' : 'paste ' + platformsObjects[platform] + ' url above'
	                  )
	                )
	              ),
	              !hasError && !isLoading && embedValue && isTweet && _react2.default.createElement(_reactTweetEmbed2.default, {
	                id: embedValue
	              }),
	              !hasError && !isLoading && embedValue && isInstagram && _react2.default.createElement(_dyzioInstagramEmbed2.default, {
	                assetId: embedId
	              }),
	              !hasError && !isLoading && embedValue && isFacebook && _react2.default.createElement(_facebookEmbed2.default, {
	                url: embedValue,
	                type: embedType
	              }),
	              !hasError && !isLoading && embedValue && isYoutube && _react2.default.createElement(_reactYoutube2.default, {
	                videoId: embedValue,
	                opts: youtubeEmbedOpts
	              }),
	              !hasError && !isLoading && embedValue && isTiktok && _react2.default.createElement(_semanticUiReact.Image, { src: embedImage, size: 'medium', centered: true }),
	              !hasError && !isLoading && embedValue && isTelegram && _react2.default.createElement(_reactTelegramEmbed2.default, { src: embedValue })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddAssetForm;
	}(_react2.default.Component);
	
	AddAssetForm.propTypes = {
	  addAssetHandler: _propTypes2.default.func.isRequired,
	  popupToggleHandler: _propTypes2.default.func.isRequired,
	  platform: _propTypes2.default.string.isRequired,
	  posts: _propTypes2.default.array,
	  isOpen: _propTypes2.default.bool.isRequired,
	  isOverLimit: _propTypes2.default.bool.isRequired
	};
	
	AddAssetForm.defaultProps = {
	  posts: { data: { posts: [] } }
	};
	
	exports.default = AddAssetForm;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var findIcon = function findIcon(count, error) {
	  if (error) {
	    return 'close';
	  }
	  return (0, _lodash.isNumber)(count) ? 'check' : 'search';
	};
	var externalIconStyle = {
	  color: '#20c49e'
	};
	/*
	Regex to extract ids or pages in either of the following formats:
	  www.facebook.com/pages/Post-Planner/5478569871236
	  www.facebook.com/PostPlanner
	*/
	var FACEBOOK_REGEX = /^(?:https?:\/\/)?(?:www\.|m\.|touch\.)?(?:facebook\.com|fb(?:\.me|\.com))\/(?!$)(?:(?:\w)*#!\/)?(?:pages\/)?(?:photo\.php\?fbid=)?(?:[\w\-]*\/)*?(?:\/)?(?:profile\.php\?id=)?([^\/?&\s]*)(?:\/|&|\?)?.*$/;
	/*
	  Regex to extrac ids for any page which is just
	  blahblah.com/example
	*/
	var SIMPLE_REGEX = /\.com\/([^/\s#?]*)/;
	
	var LINKEDIN_REGEX = /\.com\/in\/([^/\s#?]*)/;
	
	var YOUTUBE_REGEX = /\.com\/(?:user\/|channel\/|@)?([^/\s#?]*)/;
	
	var TWITCH_REGEX = /\.tv\/([^/\s#?]*)?/;
	
	var TIKTOK_REGEX = /@([^/\s#?]*)?/;
	
	var TELEGRAM_REGEX = /https:\/\/t\.me\/([^/\s#?]*)?/;
	
	var NetworkHandleInput = function (_React$Component) {
	  _inherits(NetworkHandleInput, _React$Component);
	
	  function NetworkHandleInput(_ref) {
	    var value = _ref.value;
	
	    _classCallCheck(this, NetworkHandleInput);
	
	    var _this = _possibleConstructorReturn(this, (NetworkHandleInput.__proto__ || Object.getPrototypeOf(NetworkHandleInput)).call(this));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      timeout: undefined,
	      value: value
	    };
	    return _this;
	  }
	
	  return NetworkHandleInput;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.networkHandleRegex = {
	    facebook: FACEBOOK_REGEX,
	    instagram: SIMPLE_REGEX,
	    twitter: SIMPLE_REGEX,
	    youtube: YOUTUBE_REGEX,
	    linkedin: LINKEDIN_REGEX,
	    twitch: TWITCH_REGEX,
	    tiktok: TIKTOK_REGEX,
	    telegram: TELEGRAM_REGEX
	  };
	
	  this.handleChange = function (e, v) {
	    clearTimeout(_this2.state.timeout);
	    var timeout = setTimeout(function () {
	      var _props = _this2.props,
	          onChange = _props.onChange,
	          network = _props.network;
	
	      var regex = _this2.networkHandleRegex[network];
	      console.log(regex, v);
	      if (regex) {
	        var handleMatches = (0, _lodash.isFunction)(regex) ? regex(v.value) : (0, _lodash.compact)(regex.exec(v.value));
	        var handle = handleMatches[1] || (0, _lodash.replace)(v.value, /@/, '');
	        var value = !(0, _lodash.isEqual)(network, 'youtube') ? (0, _lodash.toLower)(handle) : handle;
	        console.log(value);
	        _this2.setState({ value: value });
	        onChange(e, _extends({}, v, { value: value }));
	      } else {
	        onChange(e, v);
	      }
	    }, 1000);
	    _this2.setState({ timeout: timeout, value: v.value });
	  };
	
	  this.keyPressUpdate = function (e, v) {
	    console.log(e, v);
	    _this2.setState({ value: v.value });
	    // if (e.keyCode === 13) {
	    //   this.handleChange(e, v);
	    // }
	  };
	
	  this.render = function () {
	    var _props2 = _this2.props,
	        network = _props2.network,
	        error = _props2.error,
	        loading = _props2.loading,
	        count = _props2.count,
	        disabled = _props2.disabled,
	        readOnly = _props2.readOnly,
	        fluid = _props2.fluid,
	        target = _props2.target,
	        to = _props2.to,
	        as = _props2.as,
	        isPersonalPage = _props2.isPersonalPage,
	        fromComponent = _props2.fromComponent,
	        placeholder = _props2.placeholder,
	        loadState = _props2.loadState;
	    var value = _this2.state.value;
	
	    var linkIcon = _react2.default.createElement(_semanticUiReact.Icon, { name: 'external', basic: true, circular: true, style: externalIconStyle });
	    var fromSignUp = fromComponent === 'signup';
	    var buttonText = loadState === 'PRELOADED' ? 'change' : 'look up';
	    if (fromSignUp) {
	      return _react2.default.createElement(_semanticUiReact.Input, {
	        placeholder: placeholder || (0, _lodash.capitalize)(network) + ' handle'
	        // icon={(to && readOnly) ? linkIcon : findIcon(isPersonalPage ? 1 : count, error)}
	        // loading={loading}
	        , name: network,
	        action: {
	          color: loadState === 'PRELOADED' ? 'grey' : 'teal',
	          content: loading ? null : buttonText,
	          icon: loading ? 'circle notched loading' : null,
	          onClick: _this2.handleChange,
	          name: network,
	          value: value
	        },
	        value: value,
	        onChange: _this2.keyPressUpdate,
	        label: !readOnly && '@',
	        error: error && network,
	        disabled: disabled,
	        readOnly: readOnly,
	        fluid: fluid,
	        target: target,
	        to: to,
	        as: as
	      });
	    }
	
	    return _react2.default.createElement(_semanticUiReact.Input, {
	      placeholder: placeholder || (0, _lodash.capitalize)(network) + ' handle',
	      icon: to && readOnly ? linkIcon : findIcon(isPersonalPage ? 1 : count, error),
	      loading: loading,
	      name: network,
	      onChange: _this2.handleChange,
	      value: value,
	      label: !readOnly && '@',
	      error: error && network,
	      disabled: disabled,
	      readOnly: readOnly,
	      fluid: fluid,
	      target: target,
	      to: to,
	      as: as
	    });
	  };
	};
	
	NetworkHandleInput.propTypes = {
	  network: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.string,
	  error: _propTypes2.default.string.isRequired,
	  loading: _propTypes2.default.bool.isRequired,
	  count: _propTypes2.default.number.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  disabled: _propTypes2.default.bool,
	  readOnly: _propTypes2.default.bool,
	  fluid: _propTypes2.default.bool,
	  target: _propTypes2.default.string,
	  as: _propTypes2.default.object,
	  to: _propTypes2.default.string,
	  fromComponent: _propTypes2.default.string
	};
	NetworkHandleInput.defaultProps = {
	  value: '',
	  disabled: false,
	  readOnly: false,
	  fluid: false,
	  target: undefined,
	  as: undefined,
	  to: undefined,
	  fromComponent: ''
	};
	
	exports.default = NetworkHandleInput;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PoweredByDyzio = function PoweredByDyzio() {
	  var isWhiteLabel = _themeSelector2.default.isWhiteLabel();
	  var isFullWhiteLabel = _themeSelector2.default.isFullWhiteLabel();
	
	  // Full white label doesn't mention dyzio
	  // i.e. app.voxogram.com
	  if (isFullWhiteLabel) return null;
	
	  // partial white label shows powered by dyzio
	  if (isWhiteLabel) {
	    return _react2.default.createElement(
	      'table',
	      { style: { margin: '0 auto' } },
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'powered by\xA0'
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement('img', { src: '/dyzio-logo.png', alt: 'dyzio beta', style: { height: '50px' } })
	        )
	      )
	    );
	  }
	
	  return null;
	};
	
	exports.default = PoweredByDyzio;

/***/ },
/* 279 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_ANALYTICS_ASSET_LIST = exports.LOAD_ANALYTICS_ASSET_LIST = 'Dyzio/AnalyticsAssetList/LOAD_ANALYTICS_ASSET_LIST';
	var LOAD_ANALYTICS_ASSET_LIST_ERROR = exports.LOAD_ANALYTICS_ASSET_LIST_ERROR = 'Dyzio/AnalyticsAssetList/LOAD_ANALYTICS_ASSET_LIST_ERROR';
	var LOAD_ANALYTICS_ASSET_LIST_SUCCESS = exports.LOAD_ANALYTICS_ASSET_LIST_SUCCESS = 'Dyzio/AnalyticsAssetList/LOAD_ANALYTICS_ASSET_LIST_SUCCESS';
	
	var SORT_ANALYTICS_ASSET_LIST = exports.SORT_ANALYTICS_ASSET_LIST = 'Dyzio/AnalyticsAssetList/SORT_ANALYTICS_ASSET_LIST';
	var FILTER_ANALYTICS_ASSET_LIST = exports.FILTER_ANALYTICS_ASSET_LIST = 'Dyzio/AnalyticsAssetList/FILTER_ANALYTICS_ASSET_LIST';
	var UPDATE_ANALYTICS_ASSET_LIST = exports.UPDATE_ANALYTICS_ASSET_LIST = 'Dyzio/AnalyticsAssetList/UPDATE_ANALYTICS_ASSET_LIST';
	
	var GET_NEW_ASSET = exports.GET_NEW_ASSET = 'Dyzio/AnalyticsAssetList/GET_NEW_ASSET';
	var GET_NEW_ASSET_ERROR = exports.GET_NEW_ASSET_ERROR = 'Dyzio/AnalyticsAssetList/GET_NEW_ASSET_ERROR';
	var ADD_TRACKED_ASSET_TO_LIST = exports.ADD_TRACKED_ASSET_TO_LIST = 'Dyzio/AnalyticsAssetList/ADD_TRACKED_ASSET_TO_LIST';

/***/ },
/* 280 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CAMPAIGN = exports.LOAD_CAMPAIGN = 'Dyzio/Campaign/LOAD_CAMPAIGN';
	var LOADING_CAMPAIGN = exports.LOADING_CAMPAIGN = 'Dyzio/Campaign/LOADING_CAMPAIGN';
	var LOAD_CAMPAIGN_SUCCESS = exports.LOAD_CAMPAIGN_SUCCESS = 'Dyzio/Campaign/LOAD_CAMPAIGN_SUCCESS';
	var LOAD_CAMPAIGN_ERROR = exports.LOAD_CAMPAIGN_ERROR = 'Dyzio/Campaign/LOAD_CAMPAIGN_ERROR';
	
	var SET_MY_PERMISSION_INFO = exports.SET_MY_PERMISSION_INFO = 'Dyzio/Campaign/SET_MY_PERMISSION_INFO';

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateProfileContactDetails = updateProfileContactDetails;
	exports.updateProfileSocialDetails = updateProfileSocialDetails;
	exports.updateProfileTags = updateProfileTags;
	exports.updateDescription = updateDescription;
	exports.updatePayments = updatePayments;
	exports.updateDemographics = updateDemographics;
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _authService = __webpack_require__(21);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ax = _axios2.default.create({
	  baseURL: ("https://api2.dyzio.co/v1"),
	  timeout: 2000,
	  headers: {
	    Authorization: 'Bearer ' + _authService.authService.getToken()
	  }
	});
	
	function updateProfileContactDetails(influencerID, name, email, contactNumber, addressLine1, city, region, postalCode, country, agentName, agentEmail, agentContactNumber) {
	  var patch = {
	    data: {
	      attributes: {
	        name: name,
	        email: email,
	        contactNumber: contactNumber,
	        addressLine1: addressLine1,
	        city: city,
	        region: region,
	        postalCode: postalCode,
	        country: country,
	        agentName: agentName,
	        agentEmail: agentEmail,
	        agentContactNumber: agentContactNumber
	      }
	    }
	  };
	
	  ax.patch('/influencer/' + influencerID, patch).then(function (r) {
	    return r.data;
	  }).catch(function (e) {
	    (0, _errorHandlingService.reportError)('Can not patch influencer', e);
	  });
	}
	
	function updateProfileSocialDetails(influencerID, facebook, facebookCount, instagram, instagramCount, instagramId, twitter, twitterCount, youtube, youtubeCount, twitch, web, snapchat, pinterest, linkedin, tiktok, tiktokCount) {
	  var patch = {
	    data: {
	      attributes: {
	        facebook: facebook,
	        facebookCount: facebookCount,
	        instagram: instagram,
	        instagramCount: instagramCount,
	        instagramId: instagramId,
	        twitter: twitter,
	        twitterCount: twitterCount,
	        youtube: youtube,
	        youtubeCount: youtubeCount,
	        twitch: twitch,
	        web: web,
	        snapchat: snapchat,
	        pinterest: pinterest,
	        linkedin: linkedin,
	        tiktok: tiktok,
	        tiktokCount: tiktokCount
	      }
	    }
	  };
	
	  ax.patch('/influencer/' + influencerID, patch).then(function (r) {
	    return r.data;
	  }).catch(function (e) {
	    (0, _errorHandlingService.reportError)('Can not patch influencer', e);
	  });
	}
	
	function updateProfileTags(influencerDetailsID, contentTags, brandTags) {
	  var contentTagsSplit = _lodash2.default.split(contentTags, ',');
	  var contentTagArray = _lodash2.default.map(contentTagsSplit, function (tag) {
	    return _lodash2.default.trim(tag);
	  });
	  var brandTagsSplit = _lodash2.default.split(brandTags, ',');
	  var brandTagArray = _lodash2.default.map(brandTagsSplit, function (tag) {
	    return _lodash2.default.trim(tag);
	  });
	
	  var patch = {
	    data: {
	      attributes: {
	        contentTags: contentTagArray,
	        brandTags: brandTagArray
	      }
	    }
	  };
	
	  ax.patch('/influencerDetails/' + influencerDetailsID, patch).then(function (r) {
	    return r.data;
	  }).catch(function (e) {
	    (0, _errorHandlingService.reportError)('Can not patch influencr details', e);
	  });
	}
	
	function updateDescription(influencerDetailsID, description) {
	  var patch = {
	    data: {
	      attributes: {
	        description: description
	      }
	    }
	  };
	
	  ax.patch('/influencerDetails/' + influencerDetailsID, patch).then(function (r) {
	    return r.data;
	  }).catch(function (e) {
	    (0, _errorHandlingService.reportError)('Can not patch influencr details', e);
	  });
	}
	
	function updatePayments(influencerID, paypalEmail, discountCode) {
	  var patch = {
	    data: {
	      attributes: {
	        paypalEmail: paypalEmail,
	        discountCode: discountCode
	      }
	    }
	  };
	
	  ax.patch('/influencer/' + influencerID, patch).then(function (r) {
	    return r.data;
	  }).catch(function (e) {
	    (0, _errorHandlingService.reportError)('Can not patch influencer', e);
	  });
	}
	
	function updateDemographics(influencerID, _ref) {
	  var gender = _ref.gender,
	      ageBracket = _ref.ageBracket,
	      ethnicity = _ref.ethnicity;
	
	  var patch = {
	    data: {
	      attributes: {
	        gender: gender,
	        ageBracket: ageBracket,
	        ethnicity: ethnicity
	      }
	    }
	  };
	
	  ax.patch('/influencer/' + influencerID, patch).then(function (r) {
	    return r.data;
	  }).catch(function (e) {
	    (0, _errorHandlingService.reportError)('Can not patch influencer demographics', e);
	  });
	}

/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CAMPAIGNS = exports.LOAD_CAMPAIGNS = 'Dyzio/CampaignList/LOAD_CAMPAIGNS';
	var LOAD_CAMPAIGNS_SUCCESS = exports.LOAD_CAMPAIGNS_SUCCESS = 'Dyzio/CampaignList/LOAD_CAMPAIGNS_SUCCESS';
	var LOAD_CAMPAIGNS_ERROR = exports.LOAD_CAMPAIGNS_ERROR = 'Dyzio/CampaignList/LOAD_CAMPAIGNS_ERROR';
	var SET_CAMPAIGN_PERMISSION = exports.SET_CAMPAIGN_PERMISSION = 'Dyzio/CampaignList/SET_CAMPAIGN_PERMISSION';
	
	var SET_PERMISSION_STATUS = exports.SET_PERMISSION_STATUS = 'Dyzio/Campaign/SET_PERMISSION_STATUS';
	var UPDATE_PERMISSION = exports.UPDATE_PERMISSION = 'Dyzio/Campaign/UPDATE_PERMISSION';
	
	var UPDATE_SHOW_CAMPAIGNS_LIST = exports.UPDATE_SHOW_CAMPAIGNS_LIST = 'Dyzio/Campaign/UPDATE_SHOW_CAMPAIGNS_LIST';

/***/ },
/* 283 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ADD_TRACKED_ASSET = exports.ADD_TRACKED_ASSET = 'Dyzio/TrackAssetModal/ADD_TRACKED_ASSET';
	
	var SET_TRACKED_ASSET_DATA = exports.SET_TRACKED_ASSET_DATA = 'Dyzio/TrackAssetModal/SET_TRACKED_ASSET_DATA';

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EVENT_TYPES = {
	  INFLUENCER_CREATED: 'influencerLink_created',
	  USER_CREATED: 'users_created',
	  CAMPAIGN_CREATED: 'campaigns_created',
	  SHORTLIST_CREATED: 'shortlists_created',
	  CAMPAIGN_SCANNED: 'campaign_scan',
	  TRACKED_ASSED_CREATED: 'trackedAssets_created',
	  CAMPAIGN_PERMISSION_CREATED: 'campaignPermission_created',
	  CAMPAIGN_INVITATION_CREATED: 'campaignInvitation_created',
	  CAMPAIGN_INVITATION_UPDATED: 'campaignInvitation_updated',
	  ALL: 'all'
	};
	
	var withDyzioEventsData = function withDyzioEventsData(WrapperComponent) {
	  return function (_Component) {
	    _inherits(HasJSONAPIClient, _Component);
	
	    function HasJSONAPIClient(props) {
	      _classCallCheck(this, HasJSONAPIClient);
	
	      var _this = _possibleConstructorReturn(this, (HasJSONAPIClient.__proto__ || Object.getPrototypeOf(HasJSONAPIClient)).call(this, props));
	
	      _this.getDyzioEvents = function (params) {
	        return _this.jsonAPIClient.find('dyzioevents', _extends({
	          sort: '-createdDate'
	        }, params)).then(function (response) {
	          var json = _lodash2.default.map(response, function (item) {
	            return item.toJSON();
	          });
	          return json;
	        });
	      };
	
	      _this.jsonAPIClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	        header: {
	          Authorization: 'Bearer ' + _authService.authService.getToken()
	        }
	      });
	      return _this;
	    }
	
	    _createClass(HasJSONAPIClient, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, {
	          getDyzioEvents: this.getDyzioEvents
	        }));
	      }
	    }]);
	
	    return HasJSONAPIClient;
	  }(_react.Component);
	};
	
	module.exports = {
	  withDyzioEventsData: withDyzioEventsData,
	  EVENT_TYPES: EVENT_TYPES
	};

/***/ },
/* 285 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getPermissionListLoading = exports.getPermissionListLoading = function getPermissionListLoading(state) {
	  return state.campaignList.get('loading');
	};
	var getCampaignPermissionOrganisationId = exports.getCampaignPermissionOrganisationId = function getCampaignPermissionOrganisationId(state, campaignId) {
	  return state.campaignList.getIn(['campaigns', campaignId, 'organisation', 'id']);
	};
	var getCampaignPermissionRole = exports.getCampaignPermissionRole = function getCampaignPermissionRole(state, campaignId) {
	  return state.campaignList.getIn(['campaigns', campaignId, 'role']);
	};
	var getCampaignPermissionId = exports.getCampaignPermissionId = function getCampaignPermissionId(state, campaignId) {
	  return state.campaignList.getIn(['campaigns', campaignId, 'id']);
	};
	var getCampaignPermissionName = exports.getCampaignPermissionName = function getCampaignPermissionName(state, campaignId) {
	  return state.campaignList.getIn(['campaigns', campaignId, 'name']);
	};
	var getArchivedCampaignPermissionId = exports.getArchivedCampaignPermissionId = function getArchivedCampaignPermissionId(state, campaignId) {
	  return state.campaignList.getIn(['archivedCampaigns', campaignId, 'id']);
	};
	var getCampaignPermissionStatus = exports.getCampaignPermissionStatus = function getCampaignPermissionStatus(state, campaignId) {
	  return state.campaignList.getIn(['campaigns', campaignId, 'status']);
	};
	var getCampaignPermissionStatusFilter = exports.getCampaignPermissionStatusFilter = function getCampaignPermissionStatusFilter(state) {
	  return state.campaignList.get('statusFilter');
	};
	var getCampaignPermissionsByStatus = exports.getCampaignPermissionsByStatus = function getCampaignPermissionsByStatus(state, status) {
	  var campaignPermissions = state.campaignList.get('campaigns');
	  var filteredCampaignPermissions = campaignPermissions.filter(function (campaignPermission) {
	    return campaignPermission.get('status') === status;
	  });
	  return filteredCampaignPermissions;
	};
	var getIsMyCampaignPermission = exports.getIsMyCampaignPermission = function getIsMyCampaignPermission(state, permissionId) {
	  var campaignPermissions = state.campaignList.get('campaigns');
	  var isMyCampaignPermission = campaignPermissions.find(function (campaignPermission) {
	    return campaignPermission.get('id') === permissionId;
	  });
	  return isMyCampaignPermission;
	};

/***/ },
/* 286 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EMAIL_REGULAR_EXPRESSION = exports.EMAIL_REGULAR_EXPRESSION = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.commaFormatted = commaFormatted;
	exports.percentFormatted = percentFormatted;
	exports.scientificFormatted = scientificFormatted;
	exports.getGraphLabelFormatting = getGraphLabelFormatting;
	exports.getGraphLabelPercentageFormatting = getGraphLabelPercentageFormatting;
	exports.sciFormatted = sciFormatted;
	exports.sf = sf;
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function commaFormatted(number) {
	  return (0, _numeral2.default)(number).format('0,0');
	}
	
	function percentFormatted(number) {
	  return (0, _numeral2.default)(number).format('0.00');
	}
	
	function scientificFormatted(number) {
	  var format = number > 1000000 ? '0.00a' : '0.0a';
	  return (0, _numeral2.default)(number).format(format);
	}
	
	function getGraphLabelFormatting(tooltipItem, data) {
	  var label = data.labels[tooltipItem.index];
	  var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	  return label + ' - ' + commaFormatted(datasetLabel);
	}
	
	function getGraphLabelPercentageFormatting(tooltipItem, data) {
	  var label = data.labels[tooltipItem.index];
	  var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	  return label + ' - ' + commaFormatted(datasetLabel) + ' %';
	}
	
	function sciFormatted(number) {
	  if (!number) return '-';
	  var format = number > 1000000 ? '0.0a' : '0,0a';
	  return (0, _numeral2.default)(number).format(format);
	}
	
	function sf(num) {
	  if (!num) return '-';
	  return (0, _numeral2.default)(num).format('0a');
	}

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createDeliverable = createDeliverable;
	exports.updateDeliverableInfo = updateDeliverableInfo;
	exports.updateDeliverableIsLive = updateDeliverableIsLive;
	exports.updateDeliverableData = updateDeliverableData;
	exports.updateDeliverableComments = updateDeliverableComments;
	exports.getDeliverable = getDeliverable;
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	var _authService = __webpack_require__(21);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createDeliverable(deliverableData) {
	
	  var client = (0, _jsonapiService2.default)();
	
	  var deliverable = client.create('deliverables');
	
	  deliverable.set('title', deliverableData.title);
	  deliverable.set('channelType', deliverableData.channelType);
	  deliverable.set('assetType', deliverableData.assetType);
	  deliverable.set('dueDate', deliverableData.dueDate);
	  if (deliverableData.liveDateStart) {
	    deliverable.set('liveDateStart', deliverableData.liveDateStart);
	  }
	  deliverable.set('liveDateEnd', deliverableData.liveDateEnd);
	  deliverable.set('live', false);
	  if (deliverableData.description) {
	    deliverable.set('description', deliverableData.description);
	  }
	  deliverable.set('discussion', { type: 'discussions', id: deliverableData.discussionId });
	
	  return deliverable.sync().then(function (response) {
	    // Returns a resource not a JSON object
	    return response;
	  });
	}
	
	// Updates main deliverable data created when assigning a deliverable
	function updateDeliverableInfo(deliverableId, deliverableData) {
	
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('deliverables', deliverableId, {}).then(function (deliverable) {
	    deliverable.set('title', deliverableData.title);
	    deliverable.set('channelType', deliverableData.channelType);
	    deliverable.set('assetType', deliverableData.assetType);
	    deliverable.set('dueDate', deliverableData.dueDate);
	    deliverable.set('liveDateEnd', deliverableData.liveDateEnd);
	    if (deliverableData.description) deliverable.set('description', deliverableData.description);
	    return deliverable.sync();
	  });
	}
	
	function updateDeliverableIsLive(deliverableId, deliverableData) {
	
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('deliverables', deliverableId, {}).then(function (deliverable) {
	    deliverable.set('live', deliverableData.live);
	    return deliverable.sync();
	  });
	}
	
	// Updates document, comments and version data used when adding deliverables
	function updateDeliverableData(deliverableId, data) {
	  var document = data.document,
	      comments = data.comments,
	      version = data.version;
	
	
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('deliverables', deliverableId, {}).then(function (deliverable) {
	    if (document) {
	      deliverable.relationships('documents').add(document);
	      deliverable.set('version', version);
	    }
	    if (comments && comments.length > 0) {
	      _lodash2.default.forEach(comments, function (comment) {
	        return deliverable.relationships('comments').add(comment);
	      });
	    }
	    return deliverable.sync();
	  });
	}
	
	function updateDeliverableComments(deliverableId, commentData) {
	
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('deliverables', deliverableId, {}).then(function (deliverable) {
	    deliverable.relationships('comments').add(commentData);
	    return deliverable.sync();
	  });
	}
	
	function makeDeliverableQuery(deliverableId) {
	  var query = '\n  query Deliverables {\n    deliverables(id: "' + deliverableId + '") {\n      id\n      title\n      channelType\n      assetType\n      dueDate\n      liveDateStart\n      liveDateEnd\n      live\n      description\n      createdBy\n      createdDate\n      document {\n        id\n        name\n        docType\n        fileType\n        size\n        discussion {\n          id\n        }\n        filePath\n        message\n        createdBy\n        createdDate\n        approved\n        approvalDate\n        approvedBy\n        version\n      }\n      documents {\n        id\n        name\n        docType\n        fileType\n        size\n        discussion {\n          id\n        }\n        filePath\n        message\n        createdBy\n        createdDate\n        approved\n        approvalDate\n        approvedBy\n        version\n      }\n      version\n      discussion {\n        id\n        name\n        channelURL\n        campaign {\n          id\n          name\n        }\n      }\n      comments {\n        id\n        comment\n        commentType\n        deliverable {\n          id\n        }\n        document {\n          id\n          name\n        }\n        user {\n          id\n          name\n        }\n        createdBy\n        createdDate\n      }\n    }\n  }\n  ';
	  return query;
	}
	
	function getDeliverable(deliverableId) {
	
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = makeDeliverableQuery(deliverableId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    return response.data.data.deliverables[0];
	  });
	}

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(668);
	var GetIntrinsic = __webpack_require__(154);
	
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	var $max = GetIntrinsic('%Math.max%');
	
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}
	
	module.exports = function callBind(originalFunction) {
		var func = $reflectApply(bind, $call, arguments);
		if ($gOPD && $defineProperty) {
			var desc = $gOPD(func, 'length');
			if (desc.configurable) {
				// original length, plus the receiver, minus any additional arguments (after the receiver)
				$defineProperty(
					func,
					'length',
					{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
				);
			}
		}
		return func;
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 290 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 291 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(953);
	var enumBugKeys = __webpack_require__(580);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 293 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(2493)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(949)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58).Buffer))

/***/ },
/* 296 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 297 */
[4210, 96],
/* 298 */
[4219, 299, 204],
/* 299 */
[4253, 47, 619, 1019, 151],
/* 300 */
[4264, 385, 387],
/* 301 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 302 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 303 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 304 */
[4398, 78, 2777],
/* 305 */
[4444, 2642, 97],
/* 306 */
[4457, 2798],
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(180);
	
	
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	module.exports = function _checkForMethod(methodname, fn) {
	  return function() {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
	      fn.apply(this, arguments) :
	      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	};


/***/ },
/* 308 */
/***/ function(module, exports) {

	module.exports = function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	};


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _isFunction = __webpack_require__(433);
	var curryN = __webpack_require__(80);
	var toString = __webpack_require__(313);
	
	
	/**
	 * Turns a named method with a specified arity into a function that can be
	 * called directly supplied with arguments and a target object.
	 *
	 * The returned function is curried and accepts `arity + 1` parameters where
	 * the final parameter is the target object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
	 * @param {Number} arity Number of arguments the returned function should take
	 *        before the target object.
	 * @param {String} method Name of the method to call.
	 * @return {Function} A new curried function.
	 * @see R.construct
	 * @example
	 *
	 *      var sliceFrom = R.invoker(1, 'slice');
	 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
	 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
	 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
	 * @symb R.invoker(0, 'method')(o) = o['method']()
	 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
	 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
	 */
	module.exports = _curry2(function invoker(arity, method) {
	  return curryN(arity + 1, function() {
	    var target = arguments[arity];
	    if (target != null && _isFunction(target[method])) {
	      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
	    }
	    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
	  });
	});


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _isString = __webpack_require__(308);
	
	
	/**
	 * Returns the nth element of the given list or string. If n is negative the
	 * element at index length + n is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> a | Undefined
	 * @sig Number -> String -> String
	 * @param {Number} offset
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      var list = ['foo', 'bar', 'baz', 'quux'];
	 *      R.nth(1, list); //=> 'bar'
	 *      R.nth(-1, list); //=> 'quux'
	 *      R.nth(-99, list); //=> undefined
	 *
	 *      R.nth(2, 'abc'); //=> 'c'
	 *      R.nth(3, 'abc'); //=> ''
	 * @symb R.nth(-1, [a, b, c]) = c
	 * @symb R.nth(0, [a, b, c]) = a
	 * @symb R.nth(1, [a, b, c]) = b
	 */
	module.exports = _curry2(function nth(offset, list) {
	  var idx = offset < 0 ? list.length + offset : offset;
	  return _isString(list) ? list.charAt(idx) : list[idx];
	});


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Retrieve the value at a given path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {a} -> a | Undefined
	 * @param {Array} path The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path`.
	 * @see R.prop
	 * @example
	 *
	 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
	 */
	module.exports = _curry2(function path(paths, obj) {
	  var val = obj;
	  var idx = 0;
	  while (idx < paths.length) {
	    if (val == null) {
	      return;
	    }
	    val = val[paths[idx]];
	    idx += 1;
	  }
	  return val;
	});


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var map = __webpack_require__(99);
	var prop = __webpack_require__(694);
	
	
	/**
	 * Returns a new list by plucking the same named property off all objects in
	 * the list supplied.
	 *
	 * `pluck` will work on
	 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
	 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => k -> f {k: v} -> f v
	 * @param {Number|String} key The key name to pluck off of each object.
	 * @param {Array} f The array or functor to consider.
	 * @return {Array} The list of values for the given key.
	 * @see R.props
	 * @example
	 *
	 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
	 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
	 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
	 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
	 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
	 */
	module.exports = _curry2(function pluck(p, list) {
	  return map(prop(p), list);
	});


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _toString = __webpack_require__(3116);
	
	
	/**
	 * Returns the string representation of the given value. `eval`'ing the output
	 * should result in a value equivalent to the input value. Many of the built-in
	 * `toString` methods do not satisfy this requirement.
	 *
	 * If the given value is an `[object Object]` with a `toString` method other
	 * than `Object.prototype.toString`, this method is invoked with no arguments
	 * to produce the return value. This means user-defined constructor functions
	 * can provide a suitable `toString` method. For example:
	 *
	 *     function Point(x, y) {
	 *       this.x = x;
	 *       this.y = y;
	 *     }
	 *
	 *     Point.prototype.toString = function() {
	 *       return 'new Point(' + this.x + ', ' + this.y + ')';
	 *     };
	 *
	 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category String
	 * @sig * -> String
	 * @param {*} val
	 * @return {String}
	 * @example
	 *
	 *      R.toString(42); //=> '42'
	 *      R.toString('abc'); //=> '"abc"'
	 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
	 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
	 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
	 */
	module.exports = _curry1(function toString(val) { return _toString(val, []); });


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.fetch = fetch;
	exports.fetchJSONP = fetchJSONP;
	exports.getRandomColor = getRandomColor;
	exports.cacheFailingSource = cacheFailingSource;
	exports.hasSourceFailedBefore = hasSourceFailedBefore;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetch(url, successCb, errorCb) {
	    var request = new XMLHttpRequest();
	    request.onreadystatechange = function () {
	        if (request.readyState === 4) {
	            if (request.status === 200) {
	                var data = JSON.parse(request.responseText);
	                successCb(data);
	            } else {
	                errorCb(request.status);
	            }
	        }
	    };
	    request.open('GET', url, true);
	    request.send();
	}
	
	function fetchJSONP(url, successCb, errorCb) {
	    var callbackName = 'jsonp_cb_' + Math.round(100000 * Math.random());
	
	    var script = document.createElement('script');
	    script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName;
	    document.body.appendChild(script);
	
	    script.onerror = function () {
	        errorCb();
	    };
	
	    window[callbackName] = function (data) {
	        delete window[callbackName];
	        document.body.removeChild(script);
	        successCb(data);
	    };
	}
	
	var defaultColors = ['#d73d32', '#7e3794', '#4285f4', '#67ae3f', '#d61a7f', '#ff4080'];
	
	function _stringAsciiCodeSum(value) {
	    return [].concat((0, _toConsumableArray3.default)(value)).map(function (letter) {
	        return letter.charCodeAt(0);
	    }).reduce(function (current, previous) {
	        return previous + current;
	    });
	}
	
	function getRandomColor(value) {
	    var colors = arguments.length <= 1 || arguments[1] === undefined ? defaultColors : arguments[1];
	
	    // if no value is passed, always return transparent color otherwise
	    // a rerender would show a new color which would will
	    // give strange effects when an interface is loading
	    // and gets rerendered a few consequent times
	    if (!value) return 'transparent';
	
	    // value based random color index
	    // the reason we don't just use a random number is to make sure that
	    // a certain value will always get the same color assigned given
	    // a fixed set of colors
	    var sum = _stringAsciiCodeSum(value);
	    var colorIndex = sum % colors.length;
	    return colors[colorIndex];
	}
	
	function _hasLocalStorage() {
	    return typeof Storage !== 'undefined';
	}
	
	var CACHE_KEY = 'react-avatar';
	
	function cacheFailingSource(source) {
	    // cache not available
	    if (!_hasLocalStorage) return;
	
	    var cache = localStorage.getItem(CACHE_KEY) || '';
	
	    // already in cache
	    if (cache.indexOf(source) > -1) return;
	
	    var cacheList = cache.split(';');
	    cacheList.push(source);
	
	    // only keep the last 20 results so we don't fill up local storage
	    cacheList = cacheList.slice(-20);
	
	    localStorage.setItem(CACHE_KEY, cacheList.join(';'));
	}
	
	function hasSourceFailedBefore(source) {
	    var cache = localStorage.getItem(CACHE_KEY) || '';
	    return cache.indexOf(source) > -1;
	}

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _require = __webpack_require__(3248),
	    CopyToClipboard = _require.CopyToClipboard;
	
	CopyToClipboard.CopyToClipboard = CopyToClipboard;
	module.exports = CopyToClipboard;

/***/ },
/* 316 */
[4450, 3251],
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isInclusivelyAfterDay;
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isSameDay = __webpack_require__(257);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isInclusivelyAfterDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return a.isAfter(b) || (0, _isSameDay2['default'])(a, b);
	}

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toMomentObject;
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toMomentObject(dateString, customFormat) {
	  var dateFormats = customFormat ? [customFormat, _constants.DISPLAY_FORMAT, _constants.ISO_FORMAT] : [_constants.DISPLAY_FORMAT, _constants.ISO_FORMAT];
	
	  var date = (0, _moment2['default'])(dateString, dateFormats, true);
	  return date.isValid() ? date.hour(12) : null;
	}

/***/ },
/* 319 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LEFT = exports.LEFT = 37;
	var UP = exports.UP = 38;
	var RIGHT = exports.RIGHT = 39;
	var DOWN = exports.DOWN = 40;
	var ENTER = exports.ENTER = 13;
	var SPACE = exports.SPACE = 32;
	var ESC = exports.ESC = 27;
	var TAB = exports.TAB = 9;
	//# sourceMappingURL=keys.js.map

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var EventPluginRegistry = __webpack_require__(709);
	var EventPluginUtils = __webpack_require__(710);
	var ReactErrorUtils = __webpack_require__(714);
	
	var accumulateInto = __webpack_require__(1523);
	var forEachAccumulated = __webpack_require__(1524);
	var invariant = __webpack_require__(36);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(320);
	var EventPluginUtils = __webpack_require__(710);
	
	var accumulateInto = __webpack_require__(1523);
	var forEachAccumulated = __webpack_require__(1524);
	var warning = __webpack_require__(41);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 322 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(155);
	
	var getEventTarget = __webpack_require__(719);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 324 */
[4221, 457, 3427, 3455],
/* 325 */
96,
/* 326 */
79,
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	exports.Link = __webpack_require__(3517);
	exports.Button = __webpack_require__(3515);
	exports.Element = __webpack_require__(3516);
	exports.Helpers = __webpack_require__(467);
	exports.scroller = __webpack_require__(1566);
	exports.Events = __webpack_require__(744);
	exports.scrollSpy = __webpack_require__(1565);
	exports.animateScroll = __webpack_require__(743);


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/react-select
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(76);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactInputAutosize = __webpack_require__(3358);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsDefaultArrowRenderer = __webpack_require__(3525);
	
	var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);
	
	var _utilsDefaultFilterOptions = __webpack_require__(1567);
	
	var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
	var _utilsDefaultMenuRenderer = __webpack_require__(1568);
	
	var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
	var _Async = __webpack_require__(3520);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(3521);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(3522);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Option = __webpack_require__(3523);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(3524);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function stringifyValue(value) {
		var valueType = typeof value;
		if (valueType === 'string') {
			return value;
		} else if (valueType === 'object') {
			return JSON.stringify(value);
		} else if (valueType === 'number' || valueType === 'boolean') {
			return String(value);
		} else {
			return '';
		}
	}
	
	var stringOrNode = _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]);
	
	var instanceId = 1;
	
	var Select = _react2['default'].createClass({
	
		displayName: 'Select',
	
		propTypes: {
			addLabelText: _react2['default'].PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
			'aria-label': _react2['default'].PropTypes.string, // Aria label (for assistive tech)
			'aria-labelledby': _react2['default'].PropTypes.string, // HTML ID of an element that should be used as the label (for assistive tech)
			arrowRenderer: _react2['default'].PropTypes.func, // Create drop-down caret element
			autoBlur: _react2['default'].PropTypes.bool, // automatically blur the component when an option is selected
			autofocus: _react2['default'].PropTypes.bool, // autofocus the component on mount
			autosize: _react2['default'].PropTypes.bool, // whether to enable autosizing or not
			backspaceRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
			backspaceToRemoveMessage: _react2['default'].PropTypes.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
			className: _react2['default'].PropTypes.string, // className for the outer element
			clearAllText: stringOrNode, // title for the "clear" control when multi: true
			clearValueText: stringOrNode, // title for the "clear" control
			clearable: _react2['default'].PropTypes.bool, // should it be possible to reset value
			delimiter: _react2['default'].PropTypes.string, // delimiter to use to join multiple values for the hidden field value
			disabled: _react2['default'].PropTypes.bool, // whether the Select is disabled or not
			escapeClearsValue: _react2['default'].PropTypes.bool, // whether escape clears the value when the menu is closed
			filterOption: _react2['default'].PropTypes.func, // method to filter a single option (option, filterString)
			filterOptions: _react2['default'].PropTypes.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
			ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering
			ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering
			inputProps: _react2['default'].PropTypes.object, // custom attributes for the Input
			inputRenderer: _react2['default'].PropTypes.func, // returns a custom input component
			instanceId: _react2['default'].PropTypes.string, // set the components instanceId
			isLoading: _react2['default'].PropTypes.bool, // whether the Select is loading externally or not (such as options being loaded)
			joinValues: _react2['default'].PropTypes.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
			labelKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			matchPos: _react2['default'].PropTypes.string, // (any|start) match the start or entire string when filtering
			matchProp: _react2['default'].PropTypes.string, // (any|label|value) which option property to filter on
			menuBuffer: _react2['default'].PropTypes.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
			menuContainerStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu container
			menuRenderer: _react2['default'].PropTypes.func, // renders a custom menu with options
			menuStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu
			multi: _react2['default'].PropTypes.bool, // multi-value input
			name: _react2['default'].PropTypes.string, // generates a hidden <input /> tag with this field name for html forms
			noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
			onBlur: _react2['default'].PropTypes.func, // onBlur handler: function (event) {}
			onBlurResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared on blur
			onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
			onClose: _react2['default'].PropTypes.func, // fires when the menu is closed
			onCloseResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared when menu is closed through the arrow
			onFocus: _react2['default'].PropTypes.func, // onFocus handler: function (event) {}
			onInputChange: _react2['default'].PropTypes.func, // onInputChange handler: function (inputValue) {}
			onInputKeyDown: _react2['default'].PropTypes.func, // input keyDown handler: function (event) {}
			onMenuScrollToBottom: _react2['default'].PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
			onOpen: _react2['default'].PropTypes.func, // fires when the menu is opened
			onValueClick: _react2['default'].PropTypes.func, // onClick handler for value labels: function (value, event) {}
			openAfterFocus: _react2['default'].PropTypes.bool, // boolean to enable opening dropdown when focused
			openOnFocus: _react2['default'].PropTypes.bool, // always open options menu on focus
			optionClassName: _react2['default'].PropTypes.string, // additional class(es) to apply to the <Option /> elements
			optionComponent: _react2['default'].PropTypes.func, // option component to render in dropdown
			optionRenderer: _react2['default'].PropTypes.func, // optionRenderer: function (option) {}
			options: _react2['default'].PropTypes.array, // array of options
			pageSize: _react2['default'].PropTypes.number, // number of entries to page when using page up/down keys
			placeholder: stringOrNode, // field placeholder, displayed when there's no value
			required: _react2['default'].PropTypes.bool, // applies HTML5 required attribute when needed
			resetValue: _react2['default'].PropTypes.any, // value to use when you clear the control
			scrollMenuIntoView: _react2['default'].PropTypes.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
			searchable: _react2['default'].PropTypes.bool, // whether to enable searching feature or not
			simpleValue: _react2['default'].PropTypes.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
			style: _react2['default'].PropTypes.object, // optional style to apply to the control
			tabIndex: _react2['default'].PropTypes.string, // optional tab index of the control
			tabSelectsValue: _react2['default'].PropTypes.bool, // whether to treat tabbing out while focused to be value selection
			value: _react2['default'].PropTypes.any, // initial field value
			valueComponent: _react2['default'].PropTypes.func, // value component to render
			valueKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			valueRenderer: _react2['default'].PropTypes.func, // valueRenderer: function (option) {}
			wrapperStyle: _react2['default'].PropTypes.object },
	
		// optional style to apply to the component wrapper
		statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },
	
		getDefaultProps: function getDefaultProps() {
			return {
				addLabelText: 'Add "{label}"?',
				arrowRenderer: _utilsDefaultArrowRenderer2['default'],
				autosize: true,
				backspaceRemoves: true,
				backspaceToRemoveMessage: 'Press backspace to remove {label}',
				clearable: true,
				clearAllText: 'Clear all',
				clearValueText: 'Clear value',
				delimiter: ',',
				disabled: false,
				escapeClearsValue: true,
				filterOptions: _utilsDefaultFilterOptions2['default'],
				ignoreAccents: true,
				ignoreCase: true,
				inputProps: {},
				isLoading: false,
				joinValues: false,
				labelKey: 'label',
				matchPos: 'any',
				matchProp: 'any',
				menuBuffer: 0,
				menuRenderer: _utilsDefaultMenuRenderer2['default'],
				multi: false,
				noResultsText: 'No results found',
				onBlurResetsInput: true,
				onCloseResetsInput: true,
				openAfterFocus: false,
				optionComponent: _Option2['default'],
				pageSize: 5,
				placeholder: 'Select...',
				required: false,
				scrollMenuIntoView: true,
				searchable: true,
				simpleValue: false,
				tabSelectsValue: true,
				valueComponent: _Value2['default'],
				valueKey: 'value'
			};
		},
	
		getInitialState: function getInitialState() {
			return {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
		},
	
		componentWillMount: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);
	
			if (this.props.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], this.props.multi)
				});
			}
		},
	
		componentDidMount: function componentDidMount() {
			if (this.props.autofocus) {
				this.focus();
			}
		},
	
		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);
	
			if (nextProps.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], nextProps.multi)
				});
			}
		},
	
		componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
			if (nextState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(nextState.isOpen);
				var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
				handler && handler();
			}
		},
	
		componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
				var menuNode = _reactDom2['default'].findDOMNode(this.menu);
				menuNode.scrollTop = focusedOptionNode.offsetTop;
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}
	
			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
				var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
		},
	
		componentWillUnmount: function componentWillUnmount() {
			document.removeEventListener('touchstart', this.handleTouchOutside);
		},
	
		toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				document.addEventListener('touchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		},
	
		handleTouchOutside: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		},
	
		focus: function focus() {
			if (!this.input) return;
			this.input.focus();
	
			if (this.props.openAfterFocus) {
				this.setState({
					isOpen: true
				});
			}
		},
	
		blurInput: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		handleTouchEnd: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Fire the mouse events
			this.handleMouseDown(event);
		},
	
		handleTouchEndClearValue: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Clear the value
			this.clearValue(event);
		},
	
		handleMouseDown: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
	
			if (event.target.tagName === 'INPUT') {
				return;
			}
	
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
	
			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}
	
			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();
	
				var input = this.input;
				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}
	
				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';
	
				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: true,
					isPseudoFocused: false
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = true;
				this.focus();
			}
		},
	
		handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If the menu isn't open, let the event bubble to the main handleMouseDown
			if (!this.state.isOpen) {
				return;
			}
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
			// close the menu
			this.closeMenu();
		},
	
		handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
	
			this._openAfterFocus = true;
			this.focus();
		},
	
		closeMenu: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: ''
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: this.state.inputValue
				});
			}
			this.hasScrolledToOption = false;
		},
	
		handleInputFocus: function handleInputFocus(event) {
			if (this.props.disabled) return;
			var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
			this.setState({
				isFocused: true,
				isOpen: isOpen
			});
			this._openAfterFocus = false;
		},
	
		handleInputBlur: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}
	
			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = '';
			}
			this.setState(onBlurredState);
		},
	
		handleInputChange: function handleInputChange(event) {
			var newInputValue = event.target.value;
	
			if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
				var nextState = this.props.onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && typeof nextState !== 'object') {
					newInputValue = '' + nextState;
				}
			}
	
			this.setState({
				isOpen: true,
				isPseudoFocused: false,
				inputValue: newInputValue
			});
		},
	
		handleKeyDown: function handleKeyDown(event) {
			if (this.props.disabled) return;
	
			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}
	
			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						return;
					}
					this.selectFocusedOption();
					return;
				case 13:
					// enter
					if (!this.state.isOpen) return;
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 27:
					// escape
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 38:
					// up
					this.focusPreviousOption();
					break;
				case 40:
					// down
					this.focusNextOption();
					break;
				case 33:
					// page up
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						return;
					}
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						return;
					}
					this.focusStartOption();
					break;
				default:
					return;
			}
			event.preventDefault();
		},
	
		handleValueClick: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		},
	
		handleMenuScroll: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;
	
			if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
				this.props.onMenuScrollToBottom();
			}
		},
	
		handleRequired: function handleRequired(value, multi) {
			if (!value) return true;
			return multi ? value.length === 0 : Object.keys(value).length === 0;
		},
	
		getOptionLabel: function getOptionLabel(op) {
			return op[this.props.labelKey];
		},
	
		/**
	  * Turns a value into an array from the given options
	  * @param	{String|Number|Array}	value		- the value of the select input
	  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	  * @returns	{Array}	the value of the select represented in an array
	  */
		getValueArray: function getValueArray(value, nextProps) {
			var _this = this;
	
			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = typeof nextProps === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') value = value.split(props.delimiter);
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return _this.expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = this.expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		},
	
		/**
	  * Retrieve a value from the given options and valueKey
	  * @param	{String|Number|Array}	value	- the selected value(s)
	  * @param	{Object}		props	- the Select component's props (or nextProps)
	  */
		expandValue: function expandValue(value, props) {
			var valueType = typeof value;
			if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
			var options = props.options;
			var valueKey = props.valueKey;
	
			if (!options) return;
			for (var i = 0; i < options.length; i++) {
				if (options[i][valueKey] === value) return options[i];
			}
		},
	
		setValue: function setValue(value) {
			var _this2 = this;
	
			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (!this.props.onChange) return;
			if (this.props.required) {
				var required = this.handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			this.props.onChange(value);
		},
	
		selectValue: function selectValue(value) {
			var _this3 = this;
	
			//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
			this.hasScrolledToOption = false;
			if (this.props.multi) {
				this.setState({
					inputValue: '',
					focusedIndex: null
				}, function () {
					_this3.addValue(value);
				});
			} else {
				this.setState({
					isOpen: false,
					inputValue: '',
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		},
	
		addValue: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.concat(value));
		},
	
		popValue: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(valueArray.slice(0, valueArray.length - 1));
		},
	
		removeValue: function removeValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i !== value;
			}));
			this.focus();
		},
	
		clearValue: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
			this.setValue(this.getResetValue());
			this.setState({
				isOpen: false,
				inputValue: ''
			}, this.focus);
		},
	
		getResetValue: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		},
	
		focusOption: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		},
	
		focusNextOption: function focusNextOption() {
			this.focusAdjacentOption('next');
		},
	
		focusPreviousOption: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		},
	
		focusPageUpOption: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		},
	
		focusPageDownOption: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		},
	
		focusStartOption: function focusStartOption() {
			this.focusAdjacentOption('start');
		},
	
		focusEndOption: function focusEndOption() {
			this.focusAdjacentOption('end');
		},
	
		focusAdjacentOption: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this._focusedOption || options[dir === 'next' ? 0 : options.length - 1].option
				});
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var potentialIndex = focusedIndex + this.props.pageSize;
				if (potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = potentialIndex;
				}
			}
	
			if (focusedIndex === -1) {
				focusedIndex = 0;
			}
	
			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		},
	
		getFocusedOption: function getFocusedOption() {
			return this._focusedOption;
		},
	
		getInputValue: function getInputValue() {
			return this.state.inputValue;
		},
	
		selectFocusedOption: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		},
	
		renderLoading: function renderLoading() {
			if (!this.props.isLoading) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				_react2['default'].createElement('span', { className: 'Select-loading' })
			);
		},
	
		renderValue: function renderValue(valueArray, isOpen) {
			var _this4 = this;
	
			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				return !this.state.inputValue ? _react2['default'].createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return _react2['default'].createElement(
						ValueComponent,
						{
							id: _this4._instancePrefix + '-value-' + i,
							instancePrefix: _this4._instancePrefix,
							disabled: _this4.props.disabled || value.clearableValue === false,
							key: 'value-' + i + '-' + value[_this4.props.valueKey],
							onClick: onClick,
							onRemove: _this4.removeValue,
							value: value
						},
						renderLabel(value, i),
						_react2['default'].createElement(
							'span',
							{ className: 'Select-aria-only' },
							' '
						)
					);
				});
			} else if (!this.state.inputValue) {
				if (isOpen) onClick = null;
				return _react2['default'].createElement(
					ValueComponent,
					{
						id: this._instancePrefix + '-value-item',
						disabled: this.props.disabled,
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		},
	
		renderInput: function renderInput(valueArray, focusedOptionIndex) {
			var _this5 = this;
	
			if (this.props.inputRenderer) {
				return this.props.inputRenderer();
			} else {
				var _classNames;
	
				var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
				var isOpen = !!this.state.isOpen;
	
				var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				// TODO: Check how this project includes Object.assign()
				var inputProps = _extends({}, this.props.inputProps, {
					role: 'combobox',
					'aria-expanded': '' + isOpen,
					'aria-owns': ariaOwns,
					'aria-haspopup': '' + isOpen,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-label': this.props['aria-label'],
					className: className,
					tabIndex: this.props.tabIndex,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this5.input = _ref;
					},
					required: this.state.required,
					value: this.state.inputValue
				});
	
				if (this.props.disabled || !this.props.searchable) {
					var _props$inputProps = this.props.inputProps;
					var inputClassName = _props$inputProps.inputClassName;
	
					var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);
	
					return _react2['default'].createElement('div', _extends({}, divProps, {
						role: 'combobox',
						'aria-expanded': isOpen,
						'aria-owns': isOpen ? this._instancePrefix + '-list' : this._instancePrefix + '-value',
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						className: className,
						tabIndex: this.props.tabIndex || 0,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function (ref) {
							return _this5.input = ref;
						},
						'aria-readonly': '' + !!this.props.disabled,
						style: { border: 0, width: 1, display: 'inline-block' } }));
				}
	
				if (this.props.autosize) {
					return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5px' }));
				}
				return _react2['default'].createElement(
					'div',
					{ className: className },
					_react2['default'].createElement('input', inputProps)
				);
			}
		},
	
		renderClear: function renderClear() {
			if (!this.props.clearable || !this.props.value || this.props.value === 0 || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					onMouseDown: this.clearValue,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEndClearValue
				},
				_react2['default'].createElement('span', { className: 'Select-clear', dangerouslySetInnerHTML: { __html: '&times;' } })
			);
		},
	
		renderArrow: function renderArrow() {
			var onMouseDown = this.handleMouseDownOnArrow;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown });
	
			return _react2['default'].createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		},
	
		filterOptions: function filterOptions(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];
	
				return filterOptions(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		},
	
		onOptionRef: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		},
	
		renderMenu: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey,
					onOptionRef: this.onOptionRef
				});
			} else if (this.props.noResultsText) {
				return _react2['default'].createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		},
	
		renderHiddenField: function renderHiddenField(valueArray) {
			var _this6 = this;
	
			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this6.props.valueKey]);
				}).join(this.props.delimiter);
				return _react2['default'].createElement('input', {
					type: 'hidden',
					ref: function (ref) {
						return _this6.value = ref;
					},
					name: this.props.name,
					value: value,
					disabled: this.props.disabled });
			}
			return valueArray.map(function (item, index) {
				return _react2['default'].createElement('input', { key: 'hidden.' + index,
					type: 'hidden',
					ref: 'value' + index,
					name: _this6.props.name,
					value: stringifyValue(item[_this6.props.valueKey]),
					disabled: _this6.props.disabled });
			});
		},
	
		getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;
	
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = options.indexOf(focusedOption);
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}
	
			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		},
	
		renderOuter: function renderOuter(options, valueArray, focusedOption) {
			var _this7 = this;
	
			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}
	
			return _react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this7.menuContainer = ref;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				_react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this7.menu = ref;
						}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
						style: this.props.menuStyle,
						onScroll: this.handleMenuScroll,
						onMouseDown: this.handleMouseDownOnMenu },
					menu
				)
			);
		},
	
		render: function render() {
			var _this8 = this;
	
			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = (0, _classnames2['default'])('Select', this.props.className, {
				'Select--multi': this.props.multi,
				'Select--single': !this.props.multi,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'has-value': valueArray.length
			});
	
			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = _react2['default'].createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}
	
			return _react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this8.wrapper = ref;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				_react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this8.control = ref;
						},
						className: 'Select-control',
						style: this.props.style,
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove
					},
					_react2['default'].createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
			);
		}
	
	});
	
	exports['default'] = Select;
	module.exports = exports['default'];

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _splice = __webpack_require__(3680);
	
	var _splice2 = _interopRequireDefault(_splice);
	
	var _getIn = __webpack_require__(1597);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	var _setIn = __webpack_require__(3679);
	
	var _setIn2 = _interopRequireDefault(_setIn);
	
	var _deepEqual = __webpack_require__(3676);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _deleteIn = __webpack_require__(3677);
	
	var _deleteIn2 = _interopRequireDefault(_deleteIn);
	
	var _keys = __webpack_require__(3678);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var structure = {
	  empty: {},
	  emptyList: [],
	  getIn: _getIn2.default,
	  setIn: _setIn2.default,
	  deepEqual: _deepEqual2.default,
	  deleteIn: _deleteIn2.default,
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  keys: _keys2.default,
	  size: function size(array) {
	    return array ? array.length : 0;
	  },
	  splice: _splice2.default,
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	
	exports.default = structure;

/***/ },
/* 330 */
[4342, 484],
/* 331 */
303,
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(1622);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(3789);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(3788);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(3787);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(1621);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(1623);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(58)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 334 */
296,
/* 335 */
[4210, 100],
/* 336 */
[4219, 221, 186],
/* 337 */
301,
/* 338 */
302,
/* 339 */
303,
/* 340 */
[4398, 82, 4065],
/* 341 */
[4405, 140, 514, 83],
/* 342 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = merge;
	function merge() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaults = arguments[1];
	
	  for (var key in defaults) {
	    if (typeof obj[key] === 'undefined') {
	      obj[key] = defaults[key];
	    }
	  }
	  return obj;
	}
	module.exports = exports['default'];

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resolveAssetPlatform = function resolveAssetPlatform(platform) {
	  var icons = {
	    INSTAGRAM: {
	      name: 'instagram',
	      color: 'pink',
	      label: 'Instagram'
	    },
	    VK: {
	      name: 'vk',
	      color: 'blue',
	      label: 'VK'
	    },
	    SNAPCHAT: {
	      name: 'snapchat',
	      color: 'yellow',
	      label: 'Snapchat'
	    },
	    FACEBOOK: {
	      name: 'facebook',
	      color: 'blue',
	      label: 'Facebook'
	    },
	    TWITTER: {
	      name: 'twitter',
	      color: 'blue',
	      label: 'Twitter'
	    },
	    BLOG: {
	      name: 'pencil',
	      color: 'gray',
	      label: 'Blog'
	    }
	  };
	  return _lodash2.default.get(icons, platform);
	};
	
	var resolveAssetTypeIcon = function resolveAssetTypeIcon(assetType) {
	  var icons = {
	    STORY: {
	      iconName: 'circle',
	      label: 'Story'
	    },
	    VIDEO: {
	      iconName: 'youtube play',
	      label: 'Video'
	    },
	    IMAGE: {
	      iconName: 'picture',
	      label: 'Image'
	    },
	    TEXT: {
	      iconName: null,
	      label: 'post'
	    }
	  };
	  return _lodash2.default.get(icons, assetType);
	};
	
	var AssetTypeIcon = function AssetTypeIcon(_ref) {
	  var asset = _ref.asset,
	      renderLabelAsText = _ref.renderLabelAsText;
	
	  if (_lodash2.default.isNil(_lodash2.default.get(asset, 'type'))) {
	    return null;
	  }
	  var primaryIcon = resolveAssetPlatform(_lodash2.default.get(asset, 'platform'));
	  var secondaryIcon = resolveAssetTypeIcon(_lodash2.default.get(asset, 'assetType'));
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { name: primaryIcon.name, color: primaryIcon.color }),
	      secondaryIcon && secondaryIcon.iconName && _react2.default.createElement(_semanticUiReact.Icon, {
	        name: secondaryIcon.iconName,
	        color: primaryIcon.color
	      }),
	      renderLabelAsText && _react2.default.createElement(
	        'span',
	        null,
	        primaryIcon.label,
	        ' ',
	        secondaryIcon.label
	      )
	    ),
	    content: primaryIcon.label + ' ' + secondaryIcon.label
	  });
	};
	
	AssetTypeIcon.propTypes = {
	  asset: _propTypes2.default.object.isRequired,
	  renderLabelAsText: _propTypes2.default.bool
	};
	
	AssetTypeIcon.defaultProps = {
	  renderLabelAsText: false
	};
	
	exports.default = AssetTypeIcon;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerStyles = {
	  width: '100%',
	  height: 80,
	  paddingLeft: 'calc(50vw - 670px)',
	  paddingRight: 'calc(50vw - 670px)',
	  paddingTop: '20px',
	  background: '#FFF',
	  borderBottom: '1px solid #e8e8eb'
	};
	
	var campaignTitleStyle = {
	  padding: '0px 20px'
	};
	
	var CampaignDashboardHeader = function CampaignDashboardHeader(props) {
	  var name = props.name;
	
	  return _react2.default.createElement(
	    'div',
	    { style: headerStyles },
	    _react2.default.createElement(
	      'h2',
	      { style: campaignTitleStyle },
	      name
	    )
	  );
	};
	
	CampaignDashboardHeader.propTypes = {
	  name: _propTypes2.default.string.isRequired
	};
	
	exports.default = CampaignDashboardHeader;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmationModal = function ConfirmationModal(props) {
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      open: true, onClose: props.onCancel,
	      closeOnEscape: true,
	      size: props.size
	    },
	    props.headerText && _react2.default.createElement(
	      _semanticUiReact.Modal.Header,
	      null,
	      props.headerText
	    ),
	    props.bodyText && _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      props.bodyText,
	      _react2.default.createElement(
	        'div',
	        { className: 'align-right' },
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          { onClick: props.onCancel, color: 'grey' },
	          'Nope'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          { onClick: props.onConfirm, color: 'pink' },
	          'Do it!'
	        )
	      )
	    )
	  );
	};
	
	ConfirmationModal.defaultProps = {
	  size: 'tiny',
	  headerText: null,
	  bodyText: null
	};
	
	ConfirmationModal.propTypes = {
	  size: _propTypes2.default.string,
	  headerText: _propTypes2.default.string,
	  bodyText: _propTypes2.default.string,
	  onCancel: _propTypes2.default.func.isRequired,
	  onConfirm: _propTypes2.default.func.isRequired
	};
	
	exports.default = ConfirmationModal;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EMBED_API = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer/instagram/embed';
	
	var imgStyle = { margin: '0px auto' };
	var width100 = { width: '100%' };
	
	var instagramStyle = {
	  height: '300px',
	  minHeight: '300px',
	  width: '300px',
	  objectFit: 'cover',
	  display: 'block',
	  margin: '0px auto'
	};
	
	var getStyle = function getStyle(useInstagramStyle, maxWidth) {
	  if (useInstagramStyle) return instagramStyle;
	  if (maxWidth) return width100;
	  return imgStyle;
	};
	
	var DyzioInstagramEmbed = function (_Component) {
	  _inherits(DyzioInstagramEmbed, _Component);
	
	  function DyzioInstagramEmbed() {
	    _classCallCheck(this, DyzioInstagramEmbed);
	
	    var _this = _possibleConstructorReturn(this, (DyzioInstagramEmbed.__proto__ || Object.getPrototypeOf(DyzioInstagramEmbed)).call(this));
	
	    _this.state = {
	      savedThumbnailUrl: '',
	      error: false,
	      loading: true
	    };
	    return _this;
	  }
	
	  _createClass(DyzioInstagramEmbed, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var assetId, _ref2, status, data, _$get, savedThumbnailUrl;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                assetId = this.props.assetId;
	                _context.prev = 1;
	                _context.next = 4;
	                return (0, _axios2.default)(EMBED_API + '/' + assetId + '/data');
	
	              case 4:
	                _ref2 = _context.sent;
	                status = _ref2.status;
	                data = _ref2.data;
	
	
	                if (_lodash2.default.isEqual(status, 200)) {
	                  _$get = _lodash2.default.get(data, 'data'), savedThumbnailUrl = _$get.savedThumbnailUrl;
	
	                  this.setState({
	                    savedThumbnailUrl: savedThumbnailUrl,
	                    loading: false
	                  });
	                } else {
	                  this.setState({
	                    error: true,
	                    loading: false
	                  });
	                }
	                _context.next = 13;
	                break;
	
	              case 10:
	                _context.prev = 10;
	                _context.t0 = _context['catch'](1);
	
	                this.setState({
	                  error: true,
	                  loading: false
	                });
	
	              case 13:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[1, 10]]);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          savedThumbnailUrl = _state.savedThumbnailUrl,
	          error = _state.error,
	          loading = _state.loading;
	      var _props = this.props,
	          maxWidth = _props.maxWidth,
	          useInstagramStyle = _props.useInstagramStyle;
	
	
	      var derivedStyle = getStyle(useInstagramStyle, maxWidth);
	
	      if (error) {
	        return _react2.default.createElement(_semanticUiReact.Message, {
	          header: 'Error Fetching Asset',
	          content: 'Please check the url and retry.'
	        });
	      }
	
	      if (loading) {
	        return _react2.default.createElement(_semanticUiReact.Message, {
	          header: 'Loading Asset'
	        });
	      }
	
	      if (savedThumbnailUrl) {
	        return _react2.default.createElement(_semanticUiReact.Image, {
	          size: 'large',
	          style: derivedStyle,
	          src: savedThumbnailUrl
	        });
	      }
	
	      return _react2.default.createElement(_semanticUiReact.Message, {
	        header: 'Error Fetching Asset',
	        content: 'Please check the url and retry.'
	      });
	    }
	  }]);
	
	  return DyzioInstagramEmbed;
	}(_react.Component);
	
	DyzioInstagramEmbed.propTypes = {
	  assetId: _propTypes2.default.string.isRequired,
	  useInstagramStyle: _propTypes2.default.string,
	  maxWidth: _propTypes2.default.string
	};
	
	DyzioInstagramEmbed.defaultProps = {
	  maxWidth: false,
	  useInstagramStyle: false
	};
	
	exports.default = DyzioInstagramEmbed;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FavouriteStar = function FavouriteStar(_ref) {
	  var asset = _ref.asset,
	      _onClick = _ref.onClick;
	
	  //
	  var isStory = _lodash2.default.get(asset, 'type') === 'stories';
	
	  var favourite = isStory ? _lodash2.default.get(asset, 'favourite') : _lodash2.default.get(asset, 'trackedAsset.favourite');
	  var assetId = isStory ? _lodash2.default.get(asset, 'id') : _lodash2.default.get(asset, 'trackedAsset.id');
	
	  if (_lodash2.default.isNil(assetId)) {
	    assetId = _lodash2.default.get(asset, 'id');
	  }
	
	  if (_lodash2.default.isNil(favourite)) {
	    favourite = _lodash2.default.get(asset, 'favourite');
	  }
	
	  var assetType = isStory ? 'stories' : 'trackedAsset';
	  return _react2.default.createElement(_semanticUiReact.Icon, {
	    name: favourite ? 'star' : 'star empty',
	    color: favourite ? 'orange' : 'gray',
	    onClick: function onClick() {
	      return _onClick({ assetId: assetId, favourite: favourite, assetType: assetType });
	    }
	  });
	};
	
	FavouriteStar.propTypes = {
	  asset: _propTypes2.default.object.isRequired,
	  onClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = FavouriteStar;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _reactRouter = __webpack_require__(37);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _recompose = __webpack_require__(15);
	
	var _withPendingInvitations = __webpack_require__(923);
	
	var _withPendingInvitations2 = _interopRequireDefault(_withPendingInvitations);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _userHandler = __webpack_require__(2227);
	
	var _userHandler2 = _interopRequireDefault(_userHandler);
	
	var _authService = __webpack_require__(21);
	
	var _actions = __webpack_require__(2241);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _actions2 = __webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var V2_ORGS = [];
	
	var ELEMIS = 'df27f0a0-7ad2-4161-b14e-f928b464a85b';
	var LAUNCH_METRICS = '4a6b0ee0-6c1a-423b-984f-49a7cb849d1e';
	var ABBOTT_LYON = '6b7ed405-e8ef-4b8d-9515-f09108e9e367';
	var ELEVEN_MEADOW = '2434ffc0-b36a-4b07-84ac-7ec04069c4c9';
	
	var invitationNotificationIconStyle = {
	  background: '#20c49e',
	  color: 'white'
	};
	
	var RESTRICTED_CORQ_DOMAINS = ['data.corq.studio', 'corq.dyzio.co'];
	
	// TODO Needs refactoring to have user widget separate that extracts user data
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props, context) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var userProfile = _authService.authService.getProfile();
	
	    if (userProfile) {
	      _this.props.onUpdateUser(userProfile);
	    }
	    _authService.authService.on('profile_updated', function (newProfile) {
	      _this.props.onUpdateUser(newProfile);
	    });
	
	    _this.state = {
	      updated: false,
	      pendingInvitationsCount: 0
	    };
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          user = _props.user,
	          userData = _props.userData;
	      var pendingInvitationsCount = this.state.pendingInvitationsCount;
	
	
	      var profile = _authService.authService.getProfile();
	      var _profile$app_metadata = profile.app_metadata.dyzio,
	          role = _profile$app_metadata.role,
	          enrolledBy = _profile$app_metadata.enrolledBy;
	
	      var selfEnrolled = role === 'INFLUENCER' && enrolledBy === 'SELF';
	      var organisationId = userData.get('organisationId');
	      var isV2Org = _lodash2.default.includes(V2_ORGS, organisationId);
	
	      var theme = _themeSelector2.default.theme();
	      var isLightOnDark = theme.isLightOnDark;
	
	      var linkStyle = theme.linkStyle || {};
	      var headerStyle = theme.headerStyle || {};
	      var showHelpLink = !selfEnrolled && !theme.disableHelpLinks;
	
	      var showShortlists = !theme.hideShortlists;
	      var showMyInfluencers = !theme.hideMyInfluencers;
	      var showHomepage = !theme.hideHomepage;
	      var showCampaignsV2 = showShortlists; // overload this for convenience
	
	      var host = window.location.host;
	
	
	      var isCorq = _lodash2.default.includes(RESTRICTED_CORQ_DOMAINS, host);
	      var isElemis = organisationId === ELEMIS;
	      var isLaunchMetrics = organisationId === LAUNCH_METRICS;
	      var isAbbottLyon = organisationId === ABBOTT_LYON;
	      var isElevenMeadow = organisationId === ELEVEN_MEADOW;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-navigation-header', style: headerStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-item' },
	          _react2.default.createElement('img', {
	            onClick: function onClick() {
	              return _this2.context.router.push('/');
	            },
	            className: 'logo',
	            style: { height: theme.headerLogo.size || 40 },
	            src: theme.headerLogo.src,
	            alt: theme.headerLogo.alt
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-item' },
	          user && user.role !== 'INFLUENCER' && showHomepage && _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { style: linkStyle, to: '/home' },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'home' }),
	              'Home'
	            )
	          )
	        ),
	        isLaunchMetrics && _react2.default.createElement(
	          'div',
	          { className: 'flex-item' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { style: linkStyle, to: '/launch-metrics/dashboard' },
	              'Dashboard'
	            )
	          )
	        ),
	        isAbbottLyon && _react2.default.createElement(
	          'div',
	          { className: 'flex-item' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { style: linkStyle, to: '/abbott-lyon/dashboard' },
	              'Dashboard'
	            )
	          )
	        ),
	        isAbbottLyon && _react2.default.createElement(
	          'div',
	          { className: 'flex-item' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { style: linkStyle, to: '/abbott-lyon/orders' },
	              'Orders'
	            )
	          )
	        ),
	        isElevenMeadow && _react2.default.createElement(
	          'div',
	          { className: 'flex-item' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { style: linkStyle, to: '/eleven-meadow/dashboard' },
	              'Dashboard'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-item' },
	          user && user.role !== 'INFLUENCER' && showMyInfluencers && _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { style: linkStyle, to: '/influencers' },
	              'My Influencers'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-item' },
	          user && user.role !== 'INFLUENCER' && showShortlists && _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { style: linkStyle, to: '/shortlists' },
	              'Shortlists'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-item dropdown' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { style: linkStyle, onClick: function onClick() {
	                  return _this2.context.router.push('/dashboard');
	                } },
	              'Campaigns'
	            )
	          )
	        ),
	        isV2Org && showCampaignsV2 && _react2.default.createElement(
	          'div',
	          { className: 'flex-item' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { style: _lodash2.default.assign({ color: 'orange' }, linkStyle), to: '/campaigns/v2' },
	              'Campaigns V2',
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'lab' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-item' },
	          user && user.role === 'INFLUENCER' && !selfEnrolled && _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { style: linkStyle, to: '/influencer/authorisation' },
	              'Authorisation'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-item' },
	          user && user.role === 'INFLUENCER' && !selfEnrolled && _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { style: linkStyle, to: '/influencer/my-requests' },
	              'My requests'
	            )
	          )
	        ),
	        isElemis && _react2.default.createElement(
	          'div',
	          { className: 'flex-item dropdown' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { style: linkStyle, onClick: function onClick() {
	                  return _this2.context.router.push('/creators/approvals');
	                } },
	              'Approvals'
	            )
	          )
	        ),
	        isElemis && _react2.default.createElement(
	          'div',
	          { className: 'flex-item dropdown' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { style: linkStyle, onClick: function onClick() {
	                  return _this2.context.router.push('/shopfluence/dashboard');
	                } },
	              'Dashboard'
	            )
	          )
	        ),
	        isElemis && _react2.default.createElement(
	          'div',
	          { className: 'flex-item dropdown' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { style: linkStyle, onClick: function onClick() {
	                  return _this2.context.router.push('/skinsiders/dashboard');
	                } },
	              _react2.default.createElement(
	                'em',
	                null,
	                'SKINSIDERS'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'flex-spacer' }),
	        showHelpLink && _react2.default.createElement(
	          'div',
	          { className: 'flex-item' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { style: linkStyle, href: 'http://help.dyzio.co', target: '_blank', rel: 'noopener noreferrer' },
	              'Help'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-item dropdown' },
	          _react2.default.createElement(_userHandler2.default, { isLightOnDark: isLightOnDark })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-item mobile' },
	          _react2.default.createElement('img', {
	            src: '/icons/menu-white.svg',
	            alt: 'menu',
	            className: 'menu',
	            onClick: this.handleMenuClick
	          })
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react2.default.Component);
	
	Header.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	    var _props2, getPendingInvitationsCountByEmail, email, pendingInvitationsCount;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            if (!_this3.props.campaignsList.size) {
	              _this3.props.onLoadingCampaignsList();
	            }
	            _props2 = _this3.props, getPendingInvitationsCountByEmail = _props2.getPendingInvitationsCountByEmail, email = _props2.userInfo.email;
	            _context.next = 4;
	            return getPendingInvitationsCountByEmail(email);
	
	          case 4:
	            pendingInvitationsCount = _context.sent;
	
	            _this3.setState({
	              pendingInvitationsCount: pendingInvitationsCount
	            });
	
	          case 6:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this3);
	  }));
	
	  this.componentWillReceiveProps = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(nextProps) {
	      var user, updated, userProfile;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              user = nextProps.user;
	              updated = _this3.state.updated;
	
	              if (user && !updated) {
	                userProfile = _authService.authService.getProfile();
	
	                if (userProfile) {
	                  _this3.props.onUpdateUser(userProfile, user);
	                  _this3.setState({
	                    updated: true
	                  });
	                }
	              }
	
	            case 3:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this3);
	    }));
	
	    return function (_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  this.profileFeedback = function (action) {
	    window.Intercom('shutdown');
	    _authService.authService.logout();
	    _this3.context.router.push(action);
	  };
	};
	
	Header.propTypes = {
	  onUpdateUser: _propTypes2.default.func.isRequired,
	  user: _propTypes2.default.object,
	  userData: _propTypes2.default.object
	};
	
	Header.defaultProps = {
	  user: null,
	  userData: null
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onUpdateUser: function onUpdateUser(userData) {
	      dispatch((0, _actions.updateUser)(userData));
	    },
	    onLoadingCampaignsList: function onLoadingCampaignsList() {
	      return dispatch((0, _actions2.loadingCampaignsList)());
	    },
	    dispatch: dispatch
	  };
	}
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    campaignsList: state.campaignList.get('campaigns'),
	    currentUser: state.userData.get('currentUser'),
	    userData: state.userData.get('userData'),
	    user: state.user.user
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withPendingInvitations2.default, _hasUserInfo2.default)(Header);

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noMargin = {
	  margin: '0'
	};
	
	var autoMargin = {
	  margin: 'auto'
	};
	
	var InfluencerCardPreview = function InfluencerCardPreview(props) {
	  var name = props.name,
	      thumbnail = props.thumbnail,
	      primarySocialHandle = props.primarySocialHandle,
	      facebookCount = props.facebookCount,
	      twitterCount = props.twitterCount,
	      instagramCount = props.instagramCount,
	      youtubeCount = props.youtubeCount,
	      tiktokCount = props.tiktokCount,
	      telegramFound = props.telegramFound,
	      primarySocialHandleYoutube = props.primarySocialHandleYoutube,
	      youtubeChannelTitle = props.youtubeChannelTitle,
	      showTelegram = props.showTelegram,
	      instagramLoading = props.instagramLoading,
	      brandLogo = props.brandLogo;
	
	
	  var instagramComputed = _lodash2.default.isNumber(instagramCount);
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { padded: true, textAlign: 'center' },
	    _react2.default.createElement('div', { className: !thumbnail && 'faded' }),
	    !instagramLoading && !thumbnail && !_lodash2.default.isNil(brandLogo) && _react2.default.createElement(_semanticUiReact.Image, {
	      src: brandLogo.src,
	      alt: brandLogo.alt,
	      size: 'medium',
	      style: autoMargin
	    }),
	    !instagramLoading && !thumbnail && _lodash2.default.isNil(brandLogo) && _react2.default.createElement(_semanticUiReact.Image, {
	      src: '/icons/grey-box.svg',
	      alt: 'Thumbnail image',
	      avatar: true,
	      size: 'tiny'
	    }),
	    !instagramLoading && thumbnail && _react2.default.createElement(_semanticUiReact.Image, {
	      src: thumbnail || '/icons/grey-box.svg',
	      alt: 'Thumbnail image',
	      avatar: true,
	      size: 'tiny'
	    }),
	    instagramLoading && _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle notched', loading: true, color: 'teal', size: 'huge' }),
	    _react2.default.createElement('div', { className: 'spacer small' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      name || 'Name'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'light' },
	      primarySocialHandleYoutube && youtubeChannelTitle,
	      !primarySocialHandleYoutube && primarySocialHandle,
	      !primarySocialHandleYoutube && !primarySocialHandle && '@handle'
	    ),
	    _react2.default.createElement('div', { className: 'spacer small' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex social-stripe' },
	      _react2.default.createElement('div', { className: 'instagram ' + (instagramComputed && 'active') }),
	      _react2.default.createElement('div', { className: 'twitter ' + (twitterCount > 0 && 'active') }),
	      _react2.default.createElement('div', { className: 'tiktok ' + (tiktokCount > 0 && 'active') }),
	      _react2.default.createElement('div', { className: 'youtube ' + (youtubeCount > 0 && 'active') }),
	      _react2.default.createElement('div', { className: 'facebook ' + (facebookCount > 0 && 'active') }),
	      showTelegram && _react2.default.createElement('div', { className: 'telegram ' + (telegramFound > 0 && 'active') })
	    ),
	    _react2.default.createElement('div', { className: 'spacer small' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex' },
	      _react2.default.createElement(
	        'div',
	        { className: 'equal align-center ' + (!instagramComputed && 'faded') },
	        _react2.default.createElement('img', { src: '/icons/instagram.svg', alt: 'Instagram' }),
	        instagramComputed && instagramCount < 0 && _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_semanticUiReact.Popup, {
	            trigger: _react2.default.createElement(_semanticUiReact.Icon, { style: noMargin, name: 'clock', color: 'orange' }),
	            content: 'The follower count will populate shortly'
	          })
	        ),
	        instagramComputed && instagramCount >= 0 && _react2.default.createElement(
	          'p',
	          null,
	          (0, _numeral2.default)(instagramCount).format('0a')
	        ),
	        !instagramComputed && _react2.default.createElement(
	          'p',
	          null,
	          '-'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'equal align-center ' + (!twitterCount && 'faded') },
	        _react2.default.createElement('img', { src: '/icons/twitter.svg', alt: 'Twitter' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          twitterCount ? (0, _numeral2.default)(twitterCount).format('0a') : '-'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'equal align-center ' + (!tiktokCount && 'faded') },
	        _react2.default.createElement('img', { src: '/icons/tiktok.svg', alt: 'Tiktok', height: '28' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          tiktokCount ? (0, _numeral2.default)(tiktokCount).format('0a') : '-'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'equal align-center ' + (!youtubeCount && 'faded') },
	        _react2.default.createElement('img', { src: '/icons/youtube.svg', alt: 'YouTube' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          youtubeCount ? (0, _numeral2.default)(youtubeCount).format('0a') : '-'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'equal align-center ' + (!facebookCount && 'faded') },
	        _react2.default.createElement('img', { src: '/icons/facebook.svg', alt: 'Facebook' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          facebookCount ? (0, _numeral2.default)(facebookCount).format('0a') : '-'
	        )
	      ),
	      showTelegram && _react2.default.createElement(
	        'div',
	        { className: 'equal align-center ' + (telegramFound === 0 && 'faded') },
	        _react2.default.createElement('img', { src: '/icons/telegram.svg', alt: 'Telegram', height: '28' }),
	        telegramFound > 0 && _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'green' })
	        ),
	        (!telegramFound || telegramFound <= 0) && _react2.default.createElement(
	          'p',
	          null,
	          '-'
	        )
	      )
	    )
	  );
	};
	
	InfluencerCardPreview.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  primarySocialHandle: _propTypes2.default.string.isRequired,
	  thumbnail: _propTypes2.default.string.isRequired,
	  youtubeCount: _propTypes2.default.number.isRequired,
	  twitterCount: _propTypes2.default.number.isRequired,
	  instagramCount: _propTypes2.default.number.isRequired,
	  tiktokCount: _propTypes2.default.number.isRequired,
	  facebookCount: _propTypes2.default.number.isRequired,
	  telegramFound: _propTypes2.default.number.isRequired,
	  primarySocialHandleYoutube: _propTypes2.default.bool.isRequired,
	  showTelegram: _propTypes2.default.bool,
	  instagramLoading: _propTypes2.default.bool,
	  brandLogo: _propTypes2.default.object
	};
	
	InfluencerCardPreview.defaultProps = {
	  showTelegram: true,
	  instagramLoading: false,
	  brandLogo: null
	};
	
	exports.default = InfluencerCardPreview;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlainHeader = function PlainHeader(_ref) {
	  var title = _ref.title;
	  return _react2.default.createElement(
	    "div",
	    { className: "plain-header" },
	    _react2.default.createElement(
	      "h1",
	      null,
	      title
	    )
	  );
	};
	
	exports.default = PlainHeader;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = _themeSelector2.default.theme();
	var IS_WHITE_LABEL = _themeSelector2.default.isWhiteLabel();
	var PLATFORM_NAME = IS_WHITE_LABEL ? theme.platformName : 'dyzio';
	
	var PrivateDataComponent = function PrivateDataComponent() {
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'orange' }),
	    content: 'This is private data. The influencer must log in and authorise ' + PLATFORM_NAME + ' to fetch it for you.'
	  });
	};
	
	exports.default = PrivateDataComponent;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _plainHeader = __webpack_require__(350);
	
	var _plainHeader2 = _interopRequireDefault(_plainHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tabs = function (_React$Component) {
	  _inherits(Tabs, _React$Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeTab = function (pane) {
	      return function () {
	        _this.props.onClick(pane);
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tabs, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          hideTabs = _props.hideTabs,
	          active = _props.active,
	          title = _props.title,
	          tabsStyle = _props.tabsStyle,
	          headerStyle = _props.headerStyle,
	          onClick = _props.onClick,
	          panesTitles = _props.panesTitles;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: '' + headerStyle },
	        title && _react2.default.createElement(_plainHeader2.default, { title: title }),
	        _react2.default.createElement(
	          'div',
	          { className: tabsStyle },
	          !hideTabs && _react2.default.createElement(
	            'ul',
	            { className: 'panes' },
	            data.map(function (pane) {
	              var formattedPane = pane.charAt(0).toUpperCase() + pane.slice(1).toLowerCase();
	              return _react2.default.createElement(
	                'li',
	                { key: pane, className: active === pane ? 'active' : '' },
	                _react2.default.createElement(
	                  'p',
	                  { onClick: onClick(pane) },
	                  panesTitles ? panesTitles[pane].toLowerCase() : formattedPane
	                )
	              );
	            }),
	            _react2.default.createElement('li', { className: 'spacer' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_react2.default.Component);
	
	exports.default = Tabs;
	
	
	Tabs.propTypes = {
	  onClick: _react2.default.PropTypes.func
	};

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactFileDrop = __webpack_require__(724);
	
	var _helperFunctions = __webpack_require__(107);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Uploader = function (_React$Component) {
	  _inherits(Uploader, _React$Component);
	
	  function Uploader(props, context) {
	    _classCallCheck(this, Uploader);
	
	    var _this = _possibleConstructorReturn(this, (Uploader.__proto__ || Object.getPrototypeOf(Uploader)).call(this, props, context));
	
	    _this.state = {
	      progress: 0,
	      fileName: ''
	    };
	    return _this;
	  }
	
	  _createClass(Uploader, [{
	    key: 'onDragOver',
	    value: function onDragOver(event) {
	      this.props.updateUploaderState(2);
	    }
	  }, {
	    key: 'onDragLeave',
	    value: function onDragLeave(event) {
	      this.props.updateUploaderState(1);
	    }
	  }, {
	    key: 'resetUploader',
	    value: function resetUploader() {
	      this.props.updateUploaderState(1);
	    }
	  }, {
	    key: 'getSignedUrl',
	    value: function getSignedUrl(file, timestamp) {
	      try {
	        var endpoint = ("https://ikv9l9y8rc.execute-api.eu-west-1.amazonaws.com/production/uploads/reservation");
	        var payload = {
	          data: {
	            filepath: timestamp + '-' + file.name.replace(/(?:[^\w?.]+_*|_+)+/g, '_'),
	            contentType: file.type ? file.type : 'text/plain'
	          }
	        };
	        var headers = {};
	
	        return _axios2.default.post(endpoint, payload, headers);
	      } catch (error) {
	        (0, _errorHandlingService.reportError)('GET_FILE_SIGNED_URL_ERROR', error.message);
	      }
	    }
	  }, {
	    key: 'checkUploadSuccess',
	    value: function checkUploadSuccess(fileName, timestampFormatted) {
	      try {
	        var endpoint = ("https://1hweifjj4e.execute-api.eu-west-1.amazonaws.com/production/file") + '/processed' + timestampFormatted + fileName;
	        var headers = {};
	
	        return _axios2.default.get(endpoint, headers);
	      } catch (error) {
	        (0, _errorHandlingService.reportError)('CHECK_FILE_UPLOAD_ERROR', error.message);
	      }
	    }
	  }, {
	    key: 'uploadToS3',
	    value: function uploadToS3(url, file) {
	      try {
	        var context = this;
	        var options = {
	          headers: {
	            'Content-Type': file.type ? file.type : 'text/plain'
	          },
	          onUploadProgress: function onUploadProgress(progressEvent) {
	            var progressPercentage = progressEvent.loaded / progressEvent.total * 100;
	            var progressRounded = Math.round(progressPercentage);
	
	            context.setState({ progress: progressRounded });
	          }
	        };
	
	        return _axios2.default.put(url, file, options);
	      } catch (error) {
	        (0, _errorHandlingService.reportError)('UPLOAD_FILE_TO_S3_ERROR', error.message);
	      }
	    }
	  }, {
	    key: 'onDrop',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(files, event) {
	        var _this2 = this;
	
	        var file, url, time, timestamp, responseData, context, fileName, fileType, docType, size, timestampFormatted;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                // this.setState({ uploader: 3 });
	                this.props.updateUploaderState(3);
	                file = files[0];
	                url = null;
	                time = new Date();
	                timestamp = time.getTime();
	                _context.next = 7;
	                return this.getSignedUrl(file, timestamp).then(function (response) {
	                  url = response.data.body.url;
	                  // this.setState({ uploader: 4 });
	                  _this2.props.updateUploaderState(4);
	                });
	
	              case 7:
	                _context.next = 9;
	                return this.uploadToS3(url, file).then(function (response) {
	                  // this.setState({ uploader: 5 });
	                  _this2.props.updateUploaderState(5);
	                  return response.config.data;
	                });
	
	              case 9:
	                responseData = _context.sent;
	                context = this;
	                fileName = file.name.replace(/(?:[^\w?.]+_*|_+)+/g, '_');
	                fileType = responseData.type;
	                docType = this.props.docType;
	                size = responseData.size;
	                timestampFormatted = '-' + timestamp + '-';
	                _context.next = 18;
	                return (0, _helperFunctions.timeout)(3000);
	
	              case 18:
	                _context.next = 20;
	                return context.checkUploadSuccess(fileName, timestampFormatted).then(function (response) {
	                  var documentData = {
	                    name: fileName,
	                    docType: docType,
	                    fileType: fileType,
	                    filePath: 'processed' + timestampFormatted + fileName,
	                    size: size
	                  };
	
	                  // Call callback here with the data
	                  _this2.props.uploadDataCallback(documentData);
	
	                  context.setState({ fileName: fileName, documentData: documentData });
	                  _this2.props.updateUploaderState(6);
	                }).catch(function (error) {
	                  _this2.props.updateUploaderState(7);
	                });
	
	              case 20:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function onDrop(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return onDrop;
	    }()
	  }, {
	    key: 'onSelect',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(event) {
	        var _this3 = this;
	
	        var path, selectedFile, url, time, timestamp, responseData, context, fileName, fileType, docType, size, timestampFormatted;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                this.props.updateUploaderState(3);
	                path = event.target.value;
	                selectedFile = event.target.files[0];
	                url = null;
	                time = new Date();
	                timestamp = time.getTime();
	                _context2.next = 8;
	                return this.getSignedUrl(selectedFile, timestamp).then(function (response) {
	                  url = response.data.body.url;
	                  // this.setState({ uploader: 4 });
	                  _this3.props.updateUploaderState(4);
	                });
	
	              case 8:
	                _context2.next = 10;
	                return this.uploadToS3(url, selectedFile).then(function (response) {
	                  // this.setState({ uploader: 5 });
	                  _this3.props.updateUploaderState(5);
	                  return response.config.data;
	                });
	
	              case 10:
	                responseData = _context2.sent;
	                context = this;
	                fileName = selectedFile.name.replace(/(?:[^\w?.]+_*|_+)+/g, '_');
	                fileType = responseData.type ? responseData.type : 'text/plain';
	                docType = this.props.docType;
	                size = responseData.size;
	                timestampFormatted = '-' + timestamp + '-';
	                _context2.next = 19;
	                return (0, _helperFunctions.timeout)(3000);
	
	              case 19:
	                _context2.next = 21;
	                return context.checkUploadSuccess(fileName, timestampFormatted).then(function (response) {
	                  var documentData = {
	                    name: fileName,
	                    docType: docType,
	                    fileType: fileType,
	                    filePath: 'processed' + timestampFormatted + fileName,
	                    size: size
	                  };
	
	                  // context.setState({ uploader: 6, fileName, documentData });
	                  context.setState({ fileName: fileName, documentData: documentData });
	                  _this3.props.updateUploaderState(6);
	
	                  // Call callback here with the data
	                  _this3.props.uploadDataCallback(documentData);
	                }).catch(function (error) {
	                  _this3.props.updateUploaderState(7);
	                });
	
	              case 21:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function onSelect(_x3) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return onSelect;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var uploaderState = this.props.uploaderState;
	
	      var uploaderDisplay = uploaderState === 6 ? 'display' : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'uploader ' + uploaderDisplay },
	        _react2.default.createElement(_reactFileDrop.FileDrop, {
	          frame: document,
	          onDragOver: this.onDragOver.bind(this),
	          onDragLeave: this.onDragLeave.bind(this),
	          onDrop: this.onDrop.bind(this),
	          targetAlwaysVisible: true
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'uploader-content' },
	          uploaderState === 1 && _react2.default.createElement(
	            'div',
	            { className: 'uploader-center' },
	            _react2.default.createElement('img', { src: '/icons/upload.svg', alt: 'upload' }),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              'upload file'
	            )
	          ),
	          uploaderState === 2 && _react2.default.createElement(
	            'div',
	            { className: 'uploader-center' },
	            _react2.default.createElement('img', { src: '/icons/drop.svg', alt: 'upload' }),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              'drop anywhere to upload'
	            )
	          ),
	          uploaderState === 3 && _react2.default.createElement(
	            'div',
	            { className: 'uploader-center' },
	            _react2.default.createElement('div', { className: 'processing-spinner' }),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\xA0\xA0'
	            )
	          ),
	          uploaderState === 4 && _react2.default.createElement(
	            'div',
	            { className: 'uploader-center' },
	            _react2.default.createElement('div', { className: 'uploading-spinner' }),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              'uploading... ',
	              this.state.progress,
	              '%'
	            )
	          ),
	          uploaderState === 5 && _react2.default.createElement(
	            'div',
	            { className: 'uploader-center' },
	            _react2.default.createElement('div', { className: 'processing-spinner' }),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              'processing...'
	            )
	          ),
	          uploaderState === 6 && _react2.default.createElement(
	            'div',
	            { className: 'uploader-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'uploaded-document' },
	              _react2.default.createElement(
	                'div',
	                { className: 'left' },
	                _react2.default.createElement('img', {
	                  src: '/icons/generic-document.svg',
	                  alt: 'uploaded document'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'center' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  this.state.fileName
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                _react2.default.createElement('img', { src: '/icons/close-small.svg', alt: 'close', onClick: this.resetUploader.bind(this) })
	              )
	            )
	          ),
	          uploaderState === 7 && _react2.default.createElement(
	            'div',
	            { className: 'uploader-center' },
	            _react2.default.createElement('img', { src: '/icons/error.svg', alt: 'upload error' }),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'black' },
	              'upload failed',
	              _react2.default.createElement(
	                'span',
	                { className: 'absolute' },
	                _react2.default.createElement(
	                  'a',
	                  { onClick: this.resetUploader.bind(this) },
	                  'Retry'
	                )
	              )
	            )
	          )
	        ),
	        uploaderState !== 6 && uploaderState !== 7 && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('input', {
	            type: 'file',
	            className: 'uploader',
	            id: 'uploader',
	            ref: 'uploader',
	            onChange: this.onSelect.bind(this)
	          }),
	          _react2.default.createElement('label', { htmlFor: 'uploader' })
	        )
	      );
	    }
	  }]);
	
	  return Uploader;
	}(_react2.default.Component);
	
	Uploader.contextTypes = {
	  router: _react.PropTypes.object
	};
	exports.default = Uploader;

/***/ },
/* 354 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_SENDBIRD_USER = exports.LOAD_SENDBIRD_USER = 'Dyzio/Sendbird/LOAD_SENDBIRD_USER';
	var LOAD_SENDBIRD_USER_SUCCESS = exports.LOAD_SENDBIRD_USER_SUCCESS = 'Dyzio/Sendbird/LOAD_SENDBIRD_USER_SUCCESS';
	var LOAD_SENDBIRD_USER_ERROR = exports.LOAD_SENDBIRD_USER_ERROR = 'Dyzio/Sendbird/LOAD_SENDBIRD_USER_ERROR';
	
	var LOAD_SENDBIRD_CHANNEL = exports.LOAD_SENDBIRD_CHANNEL = 'Dyzio/Sendbird/LOAD_SENDBIRD_CHANNEL';
	var LOAD_SENDBIRD_CHANNEL_SUCCESS = exports.LOAD_SENDBIRD_CHANNEL_SUCCESS = 'Dyzio/Sendbird/LOAD_SENDBIRD_CHANNEL_SUCCESS';
	var LOAD_SENDBIRD_CHANNEL_ERROR = exports.LOAD_SENDBIRD_CHANNEL_ERROR = 'Dyzio/Sendbird/LOAD_SENDBIRD_CHANNEL_ERROR';
	
	var SET_SENDBIRD_CHANNEL_URL = exports.SET_SENDBIRD_CHANNEL_URL = 'Dyzio/Sendbird/SET_SENDBIRD_CHANNEL_URL';
	var SET_MESSAGE_LIST_QUERY = exports.SET_MESSAGE_LIST_QUERY = 'Dyzio/Sendbird/SET_MESSAGE_LIST_QUERY';
	
	var CLEAR_SENDBIRD_DATA = exports.CLEAR_SENDBIRD_DATA = 'Dyzio/Sendbird/CLEAR_SENDBIRD_DATA';

/***/ },
/* 355 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CAMPAIGN_ANALYTICS = exports.LOAD_CAMPAIGN_ANALYTICS = 'Dyzio/CampaignAnalytics/LOAD_CAMPAIGN_ANALYTICS';
	var LOAD_CAMPAIGN_ANALYTICS_SUCCESS = exports.LOAD_CAMPAIGN_ANALYTICS_SUCCESS = 'Dyzio/CampaignAnalytics/LOAD_CAMPAIGN_ANALYTICS_SUCCESS';
	var LOAD_CAMPAIGN_ANALYTICS_ERROR = exports.LOAD_CAMPAIGN_ANALYTICS_ERROR = 'Dyzio/CampaignAnalytics/LOAD_CAMPAIGN_ANALYTICS_ERROR';
	var LOAD_CAMPAIGN_ANALYTICS_SET_LOADING = exports.LOAD_CAMPAIGN_ANALYTICS_SET_LOADING = 'Dyzio/CampaignAnalytics/LOAD_CAMPAIGN_ANALYTICS_SET_LOADING';
	
	var UPDATE_CAMPAIGN_ANALYTICS = exports.UPDATE_CAMPAIGN_ANALYTICS = 'Dyzio/CampaignAnalytics/UPDATE_CAMPAIGN_ANALYTICS';
	var UPDATE_CAMPAIGN_ANALYTICS_TOTALS = exports.UPDATE_CAMPAIGN_ANALYTICS_TOTALS = 'Dyzio/CampaignAnalytics/UPDATE_CAMPAIGN_ANALYTICS_TOTALS';
	
	var GET_NEW_CAMPAIGN_ANALYTICS = exports.GET_NEW_CAMPAIGN_ANALYTICS = 'Dyzio/CampaignAnalytics/GET_NEW_CAMPAIGN_ANALYTICS';

/***/ },
/* 356 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_MEMBERS_SUCCESS = exports.LOAD_MEMBERS_SUCCESS = 'Dyzio/CampaignMemberManage/LOAD_MEMBERS';
	
	var REMOVE_PENDING_MEMBER = exports.REMOVE_PENDING_MEMBER = 'Dyzio/CampaignMemberManage/REMOVE_PENDING_MEMBER';
	var REMOVE_PENDING_MEMBER_SUCCESS = exports.REMOVE_PENDING_MEMBER_SUCCESS = 'Dyzio/CampaignMemberManage/REMOVE_PENDING_MEMBER_SUCCESS';
	
	var REMOVE_MEMBER = exports.REMOVE_MEMBER = 'Dyzio/CampaignMemberManage/REMOVE_MEMBER';
	var REMOVE_MEMBER_SUCCESS = exports.REMOVE_MEMBER_SUCCESS = 'Dyzio/CampaignMemberManage/REMOVE_MEMBER_SUCCESS';
	
	var REMOVE_MEMBER_ERROR = exports.REMOVE_MEMBER_ERROR = 'Dyzio/CampaignMemberManage/REMOVE_MEMBER_ERROR';
	
	var SHOW_REMOVE_MODAL = exports.SHOW_REMOVE_MODAL = 'Dyzio/CampaignMemberManage/SHOW_REMOVE_MODAL';
	var HIDE_REMOVE_MODAL = exports.HIDE_REMOVE_MODAL = 'Dyzio/CampaignMemberManage/HIDE_REMOVE_MODAL';

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FeedTitleAndDescription = exports.FeedLeftImage = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var influencerAvatarStyle = {
	  width: 50,
	  height: 50,
	  marginRight: 20,
	  float: 'left'
	};
	
	var descriptionStyle = {
	  color: 'gray'
	};
	
	var titleStyle = {
	  marginTop: 5,
	  textOverflow: 'ellipsis',
	  whiteSpace: 'nowrap',
	  width: 171,
	  overflow: 'hidden'
	};
	
	var feedEventStyle = { marginBottom: 20 };
	
	var FeedLeftImage = exports.FeedLeftImage = function FeedLeftImage(props) {
	  return _react2.default.createElement(_semanticUiReact.Image, Object.assign({
	    className: 'circular',
	    style: influencerAvatarStyle,
	    size: 'tiny'
	  }, props));
	};
	
	var FeedTitleAndDescription = exports.FeedTitleAndDescription = function FeedTitleAndDescription(_ref) {
	  var title = _ref.title,
	      description = _ref.description;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: titleStyle },
	      title
	    ),
	    _react2.default.createElement(
	      'span',
	      { style: descriptionStyle },
	      description
	    )
	  );
	};
	
	FeedTitleAndDescription.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string.isRequired
	};
	
	var FeedEvent = function FeedEvent(_ref2) {
	  var createdBy = _ref2.createdBy,
	      createdDate = _ref2.createdDate,
	      actionText = _ref2.actionText,
	      children = _ref2.children,
	      isCompact = _ref2.isCompact;
	  return _react2.default.createElement(
	    _semanticUiReact.Feed.Event,
	    { style: feedEventStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Feed.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Feed.Summary,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Feed.User,
	          null,
	          createdBy
	        ),
	        ' ',
	        actionText,
	        !isCompact && _react2.default.createElement(
	          _semanticUiReact.Feed.Date,
	          null,
	          (0, _moment2.default)(createdDate).fromNow()
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Feed.Extra,
	        null,
	        children
	      )
	    )
	  );
	};
	
	FeedEvent.propTypes = {
	  createdBy: _propTypes2.default.string.isRequired,
	  actionText: _propTypes2.default.string.isRequired,
	  createdDate: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.node.isRequired,
	  isCompact: _propTypes2.default.bool
	};
	
	FeedEvent.defaultProps = {
	  isCompact: true
	};
	
	exports.default = FeedEvent;

/***/ },
/* 358 */
/***/ function(module, exports) {

	'use strict';
	
	var FEED_TYPES = {
	  COLLABORATION: 'COLLABORATION',
	  CAMPAIGN: 'CAMPAIGN',
	  ORGANISATION: 'ORGANISATION',
	  ALL: 'ALL'
	};
	
	var FEED_VIEW_MODES = {
	  CARDS: 'CARDS',
	  TABLE: 'TABLE'
	};
	
	module.exports = {
	  FEED_TYPES: FEED_TYPES,
	  FEED_VIEW_MODES: FEED_VIEW_MODES
	};

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setPermissionStatus = setPermissionStatus;
	exports.loadingCampaignsList = loadingCampaignsList;
	exports.loadCampaignsError = loadCampaignsError;
	exports.loadingCampaignsSuccess = loadingCampaignsSuccess;
	exports.setCampaignPermission = setCampaignPermission;
	exports.updateShowCampaignsList = updateShowCampaignsList;
	
	var _constants = __webpack_require__(282);
	
	function setPermissionStatus(campaignPermissionId, campaignId, status) {
	  return {
	    type: _constants.SET_PERMISSION_STATUS,
	    campaignPermissionId: campaignPermissionId,
	    campaignId: campaignId,
	    status: status
	  };
	}
	
	function loadingCampaignsList() {
	  return {
	    type: _constants.LOAD_CAMPAIGNS
	  };
	}
	
	function loadCampaignsError(error) {
	  return {
	    type: _constants.LOAD_CAMPAIGNS_ERROR,
	    error: error
	  };
	}
	
	function loadingCampaignsSuccess(campaigns) {
	  return {
	    type: _constants.LOAD_CAMPAIGNS_SUCCESS,
	    campaigns: campaigns
	  };
	}
	
	function setCampaignPermission(campaignPermission) {
	  return {
	    type: _constants.SET_CAMPAIGN_PERMISSION,
	    campaignPermission: campaignPermission
	  };
	}
	
	function updateShowCampaignsList(campaignPermissionStatus) {
	  return {
	    type: _constants.UPDATE_SHOW_CAMPAIGNS_LIST,
	    campaignPermissionStatus: campaignPermissionStatus
	  };
	}

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withGuestIntercom = function withGuestIntercom(WrapperComponent) {
	  return function (_Component) {
	    _inherits(WithIntercom, _Component);
	
	    function WithIntercom() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, WithIntercom);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithIntercom.__proto__ || Object.getPrototypeOf(WithIntercom)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
	        var _ThemeSelector$theme = _themeSelector2.default.theme(),
	            disableIntercom = _ThemeSelector$theme.disableIntercom;
	
	        if (!disableIntercom) {
	          var settings = {
	            app_id: 'xef2tjr2'
	          };
	          window.Intercom('boot', settings);
	        }
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(WithIntercom, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapperComponent, this.props);
	      }
	    }]);
	
	    return WithIntercom;
	  }(_react.Component);
	};
	
	exports.default = withGuestIntercom;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getApprovedDeliverables = exports.getAddedDeliverables = exports.getDiscussionMembers = exports.getDeliverableName = exports.getDeliverableObject = exports.getSignedContract = exports.getCurrentContract = exports.getCurrentBrief = exports.getMessageListQuery = exports.getDiscussionName = exports.getDiscussionId = undefined;
	
	var _immutable = __webpack_require__(34);
	
	var getDiscussionId = exports.getDiscussionId = function getDiscussionId(state) {
	  return state.discussion.get('discussionId');
	};
	var getDiscussionName = exports.getDiscussionName = function getDiscussionName(state) {
	  return state.discussion.get('name');
	};
	var getMessageListQuery = exports.getMessageListQuery = function getMessageListQuery(state) {
	  return state.discussion.get('messageListQuery');
	};
	var getCurrentBrief = exports.getCurrentBrief = function getCurrentBrief(state) {
	  return state.discussion.get('currentBrief');
	};
	var getCurrentContract = exports.getCurrentContract = function getCurrentContract(state) {
	  return state.discussion.get('currentContract');
	};
	var getSignedContract = exports.getSignedContract = function getSignedContract(state) {
	  return state.discussion.get('signedContract');
	};
	var getDeliverableObject = exports.getDeliverableObject = function getDeliverableObject(state, deliverableId) {
	  return state.discussion.getIn(['deliverables', deliverableId]);
	};
	var getDeliverableName = exports.getDeliverableName = function getDeliverableName(state, deliverableId) {
	  return state.discussion.getIn(['deliverables', deliverableId, 'title']);
	};
	
	var getDiscussionMembers = exports.getDiscussionMembers = function getDiscussionMembers(state) {
	  var members = state.members.get('members');
	  var organisations = state.discussion.get('organisations');
	
	  var currentMembers = [];
	  if (members && members.size > 0 && organisations) {
	    members.forEach(function (member) {
	      var userInDiscussion = organisations.find(function (organisation) {
	        return member.getIn(['organisation', 'id']) === organisation.get('id');
	      });
	      if (userInDiscussion) currentMembers.push(member);
	    });
	  }
	  return (0, _immutable.fromJS)(currentMembers);
	};
	
	var getAddedDeliverables = exports.getAddedDeliverables = function getAddedDeliverables(state) {
	  var deliverables = state.discussion.get('deliverables');
	  var addedDeliverables = {};
	  deliverables.forEach(function (deliverable) {
	    var deliverableDocuments = deliverable.get('documents');
	    if (deliverableDocuments && deliverableDocuments.first()) {
	      addedDeliverables[deliverable.get('id')] = deliverable;
	    } else if (deliverable.get('document')) addedDeliverables[deliverable.get('id')] = deliverable;
	  });
	  return (0, _immutable.fromJS)(addedDeliverables);
	};
	
	var getApprovedDeliverables = exports.getApprovedDeliverables = function getApprovedDeliverables(state) {
	  var deliverables = state.discussion.get('deliverables');
	  var approvedDeliverables = {};
	  deliverables.forEach(function (deliverable) {
	    var deliverableDocuments = deliverable.get('documents');
	    if (deliverableDocuments && deliverableDocuments.first()) {
	      if (deliverableDocuments.find(function (document) {
	        return document.get('approved') === true;
	      })) {
	        approvedDeliverables[deliverable.get('id')] = deliverable;
	      }
	    } else if (deliverable.getIn(['document', 'approved'])) approvedDeliverables[deliverable.get('id')] = deliverable;
	  });
	  return (0, _immutable.fromJS)(approvedDeliverables);
	};

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extractAssetURLData = extractAssetURLData;
	exports.extractTwitterStatusId = extractTwitterStatusId;
	exports.extractYoutubeVideoID = extractYoutubeVideoID;
	exports.extractFacebookVideoID = extractFacebookVideoID;
	exports.extractFacebookPhotoID = extractFacebookPhotoID;
	exports.extractFacebookPostID = extractFacebookPostID;
	exports.extractTiktokID = extractTiktokID;
	exports.extractInstagramID = extractInstagramID;
	exports.extractTelegramID = extractTelegramID;
	
	var _staticConfiguration = __webpack_require__(27);
	
	function extractAssetURLData(assetURL) {
	  var twitterId = extractTwitterStatusId(assetURL);
	  if (twitterId) {
	    return {
	      platform: _staticConfiguration.TWITTER,
	      assetType: _staticConfiguration.TEXT, // TODO we should determine what they are  really
	      assetId: twitterId,
	      assetURL: assetURL
	    };
	  }
	
	  var youtubeId = extractYoutubeVideoID(assetURL);
	  if (youtubeId) {
	    return {
	      platform: _staticConfiguration.YOUTUBE,
	      assetType: _staticConfiguration.VIDEO,
	      assetId: youtubeId,
	      assetURL: 'https://www.youtube.com/watch?v=' + youtubeId
	    };
	  }
	
	  var facebookVideoData = extractFacebookVideoID(assetURL);
	  if (facebookVideoData) {
	    return {
	      platform: _staticConfiguration.FACEBOOK,
	      assetType: _staticConfiguration.VIDEO,
	      assetId: facebookVideoData.id,
	      assetURL: 'https://www.facebook.com/' + facebookVideoData.owner + '/videos/' + facebookVideoData.id + '/'
	    };
	  }
	
	  var facebookPhotoData = extractFacebookPhotoID(assetURL);
	  if (facebookPhotoData) {
	    return {
	      platform: _staticConfiguration.FACEBOOK,
	      assetType: _staticConfiguration.IMAGE,
	      assetId: facebookPhotoData.id,
	      assetURL: 'https://www.facebook.com/' + facebookPhotoData.owner + '/photos/' + facebookPhotoData.id + '/'
	    };
	  }
	
	  var facebookPostData = extractFacebookPostID(assetURL);
	  if (facebookPostData) {
	    return {
	      platform: _staticConfiguration.FACEBOOK,
	      assetType: _staticConfiguration.TEXT,
	      assetId: facebookPostData.id,
	      assetURL: 'https://www.facebook.com/' + facebookPostData.owner + '/posts/' + facebookPostData.id + '/'
	    };
	  }
	
	  var instagramId = extractInstagramID(assetURL);
	  if (instagramId) {
	    return {
	      platform: _staticConfiguration.INSTAGRAM,
	      assetType: _staticConfiguration.IMAGE, // TODO this may not be correct
	      assetId: instagramId,
	      assetURL: 'https://www.instagram.com/p/' + instagramId + '/'
	    };
	  }
	
	  var tiktokResult = extractTiktokID(assetURL);
	  if (tiktokResult) {
	    var tiktokHandle = tiktokResult.tiktokHandle,
	        tiktokId = tiktokResult.tiktokId;
	
	    return {
	      platform: _staticConfiguration.TIKTOK,
	      assetType: _staticConfiguration.VIDEO, // TODO this may not be correct
	      assetId: tiktokId,
	      handle: tiktokHandle,
	      assetURL: 'https://www.tiktok.com/@' + tiktokHandle + '/video/' + tiktokId + '/'
	    };
	  }
	
	  // https://t.me/gembaba/308847
	  var telegramResult = extractTelegramID(assetURL);
	  if (telegramResult) {
	    var telegramHandle = telegramResult.telegramHandle,
	        telegramId = telegramResult.telegramId;
	
	    return {
	      platform: _staticConfiguration.TELEGRAM,
	      assetType: _staticConfiguration.TEXT, // TODO this may not be correct
	      assetId: telegramHandle + '/' + telegramId,
	      handle: telegramHandle,
	      assetURL: 'https://t.me/' + telegramHandle + '/' + telegramId
	    };
	  }
	
	  return null;
	}
	
	function extractTwitterStatusId(url) {
	  if (!url) return null;
	  var regEx = /status\/(\d*)(\/?)$/;
	  var match = url.match(regEx);
	  return match ? match[1] : null;
	}
	
	function extractYoutubeVideoID(url) {
	  if (!url || !url.match(/youtu/)) return null;
	  var regExp = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/;
	  var match = url.match(regExp);
	  return match && match[2].length == 11 ? match[2] : null;
	}
	
	function extractFacebookVideoID(url) {
	  if (!url || !url.match(/facebook/)) return null;
	  var regExp = /^http(?:s?):\/\/(?:www\.|web\.|m\.)?facebook\.com\/([A-z0-9\.]+)\/videos(?:\/[0-9A-z].+)?\/(\d+)(?:.+)?$/;
	  var match = url.match(regExp);
	  return match ? { id: match[2], owner: match[1] } : null;
	}
	
	function extractFacebookPhotoID(url) {
	  if (!url || !url.match(/facebook/)) return null;
	  var regExp = /^http(?:s?):\/\/(?:www\.|web\.|m\.)?facebook\.com\/([A-z0-9\.]+)\/photos(?:\/[0-9A-z].+)?\/(\d+)(?:.+)?$/;
	  // https://www.facebook.com/ginaisfunny/photos/a.386636203612.165877.29074218612/10155268288808613/?type=3
	  var match = url.match(regExp);
	  return match ? { id: match[2], owner: match[1] } : null;
	}
	
	function extractFacebookPostID(url) {
	  if (!url || !url.match(/facebook/)) return null;
	  var regExp = /^http(?:s?):\/\/(?:www\.|web\.|m\.)?facebook\.com\/([A-z0-9\.]+)\/posts(?:\/[0-9A-z].+)?\/(\d+)(?:.+)?$/;
	  // https://www.facebook.com/ginaisfunny/photos/a.386636203612.165877.29074218612/10155268288808613/?type=3
	  var match = url.match(regExp);
	  return match ? { id: match[2], owner: match[1] } : null;
	}
	
	function extractTiktokID(url) {
	  if (!url) return null;
	  if (!url.match(/tiktok/)) return null;
	  var regExp = /^http(?:s?):\/\/(?:www\.|web\.|m\.)?tiktok\.com\/\@([A-z0-9\.]+)\/(?:video|photo)(?:\/[0-9A-z].+)?\/(\d+)(?:.+)?$/;
	  // https://www.tiktok.com/@therock/video/6879854011848150277?lang=en&is_copy_url=1&is_from_webapp=v1
	  var match = url.match(regExp);
	  return match ? { tiktokHandle: match[1], tiktokId: match[2] } : null;
	}
	
	function extractInstagramID(url) {
	  if (!url || !url.match(/instagram/)) return null;
	  var regExp = /https?:\/\/[w\.]*instagram\.[^\/]*\/([^?]*)\/([a-zA-Z0-9_-]{1,11})/;
	  var match = url.match(regExp);
	  return match ? match[2] : null;
	}
	
	function extractTelegramID(url) {
	  if (!url) return null;
	  var regExp = /https:\/\/t.me\/(.*)\/(\d*)/;
	  var match = url.match(regExp);
	  return match ? { telegramHandle: match[1], telegramId: match[2] } : null;
	}

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createCampaignPermission = createCampaignPermission;
	exports.getCampaignPermission = getCampaignPermission;
	exports.deleteCampaignPermission = deleteCampaignPermission;
	exports.updatePermissionStatus = updatePermissionStatus;
	exports.getCampaignPermissionTrackedAssets = getCampaignPermissionTrackedAssets;
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	var _authService = __webpack_require__(21);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	var _staticConfiguration = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createCampaignPermission(campaignPermissionData) {
	  var client = (0, _jsonapiService2.default)();
	
	  var campaignPermission = client.create('campaignPermission');
	
	  campaignPermission.set('campaign', { type: 'campaigns', id: campaignPermissionData.campaignId });
	  campaignPermission.set('user', { type: 'users', id: campaignPermissionData.userId });
	  campaignPermission.set('email', campaignPermissionData.email);
	  campaignPermission.set('role', campaignPermissionData.role);
	  campaignPermission.set('organisation', { type: 'organisations', id: campaignPermissionData.organisationId });
	
	  return campaignPermission.sync().then(function (response) {
	    return response;
	  });
	}
	
	function getCampaignPermission(permissionId) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('campaignPermission', permissionId, {}).then(function (response) {
	    return response;
	  });
	}
	
	function deleteCampaignPermission(campaignPermission) {
	  return campaignPermission.delete().then(function (response) {
	    return response;
	  });
	}
	
	function updatePermissionStatus(permissionId, status) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('campaignPermission', permissionId, {}).then(function (campaignPermission) {
	    campaignPermission.set('status', status);
	    return campaignPermission.sync();
	  });
	}
	
	function makeTrackedAssetsQuery(userId) {
	  var query = '\n  query CampaignPermissionTrackedAssets {\n    campaignPermission(user: "' + userId + '") {\n      id\n      role\n      campaign {\n        id\n        name\n        currency\n        trackedAssets {\n          id\n          assetId\n          assetURL\n          platform\n          assetType\n          createdSource\n          createdBy\n          createdDate\n          user {\n            id\n          }\n          campaign {\n            id\n            name\n          }\n          discussion {\n            id\n            name\n          }\n        }\n        discussions {\n          id\n          name\n          trackedAssets {\n            id\n            assetId\n            assetURL\n            platform\n            assetType\n            createdSource\n            createdBy\n            createdDate\n            user {\n              id\n            }\n            campaign {\n              id\n              name\n            }\n            discussion {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n  ';
	  return query;
	}
	
	function getCampaignPermissionTrackedAssets(userId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = makeTrackedAssetsQuery(userId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    var campaignPermissions = response.data.data.campaignPermission;
	    var filteredCampaignPermissions = [];
	    campaignPermissions.forEach(function (campaignPermission) {
	      var role = campaignPermission.role;
	      if (role === _staticConfiguration.CAMPAIGN_OWNER || role === _staticConfiguration.CAMPAIGN_ADMIN || role === _staticConfiguration.TEAM_MEMBER) {
	        filteredCampaignPermissions.push(campaignPermission);
	      }
	    });
	    return filteredCampaignPermissions;
	  });
	}

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createDocument = createDocument;
	exports.getDocument = getDocument;
	exports.removeDocument = removeDocument;
	exports.updateDocumentApproved = updateDocumentApproved;
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	var _authService = __webpack_require__(21);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createDocument(documentData) {
	
	  var client = (0, _jsonapiService2.default)();
	
	  var document = client.create('documents');
	
	  document.set('name', documentData.name);
	  document.set('filePath', documentData.filePath);
	  document.set('docType', documentData.docType);
	  document.set('fileType', documentData.fileType);
	  document.set('size', documentData.size);
	  document.set('discussion', { type: 'discussions', id: documentData.discussionId });
	  if (documentData.message) {
	    document.set('message', documentData.message);
	  }
	  if (documentData.version) {
	    document.set('version', documentData.version);
	  }
	  document.set('approved', documentData.approved);
	
	  return document.sync().then(function (response) {
	    // Returns a resource not a JSON object
	    return response;
	  });
	}
	
	function getDocument(documentId) {
	
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('documents', documentId, {}).then(function (response) {
	    // Returns resource object
	    return response;
	  });
	}
	
	function removeDocument(documentId) {
	
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  return axiosService.patch('/documents/' + documentId, {
	    data: {
	      id: documentId,
	      type: 'documents',
	      attributes: {
	        removed: true,
	        filePath: 'removed',
	        approved: false
	      }
	    }
	  }).then(function (response) {
	    var documentData = response.data.data.attributes;
	    documentData.id = response.data.data.id;
	    // Returns JSON object
	    return documentData;
	  });
	}
	
	function updateDocumentApproved(documentId, approvedData) {
	
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var approved = approvedData.approved;
	  var approvedBy = approvedData.approvedBy;
	  var approvalDate = approvedData.approvalDate;
	
	  return axiosService.patch('/documents/' + documentId, {
	    data: {
	      id: documentId,
	      type: 'documents',
	      attributes: {
	        approved: approved,
	        approvedBy: approvedBy,
	        approvalDate: approvalDate
	      }
	    }
	  }).then(function (response) {
	    var documentData = response.data.data.attributes;
	    documentData.id = response.data.data.id;
	    // Returns JSON object
	    return documentData;
	  });
	}

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _errorHandlingService = __webpack_require__(30);
	
	exports.default = function (restClient, args) {
	  return restClient({
	    method: 'post',
	    url: '/roadblock-notification',
	    data: _extends({}, args),
	    timeout: 10000,
	    baseURL: ("https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production")
	  }).catch(function (error) {
	    (0, _errorHandlingService.reportError)('SEND_NOTIFICATION_ERROR', error);
	  });
	};

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendBirdService = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */
	
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _sendbird = __webpack_require__(4077);
	
	var _sendbird2 = _interopRequireDefault(_sendbird);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var pify = __webpack_require__(3025);
	
	var SendBirdService = function () {
	  function SendBirdService() {
	    _classCallCheck(this, SendBirdService);
	
	    this.sendBirdService = new _sendbird2.default({
	      appId: ("19BE92C4-AD3E-41C4-BF11-CEAF34653DC5") });
	    console.log('created sendbird: ' + ("19BE92C4-AD3E-41C4-BF11-CEAF34653DC5"));
	
	    this.removeSendbirdChannelHandler = this.removeSendbirdChannelHandler.bind(this);
	    this.connectSendbirdUser = this.connectSendbirdUser.bind(this);
	    this.swapSendbirdConnectUserResponse = this.swapSendbirdConnectUserResponse.bind(this);
	    this.createSendbirdChannel = this.createSendbirdChannel.bind(this);
	    this.swapSendbirdCreateChannelResponse = this.swapSendbirdCreateChannelResponse.bind(this);
	    this.fetchSendbirdChannel = this.fetchSendbirdChannel.bind(this);
	    this.swapFetchSendbirdChannelResponse = this.swapFetchSendbirdChannelResponse.bind(this);
	    this.sendSendbirdMessage = this.sendSendbirdMessage.bind(this);
	    this.swapSendSendbirdSendMessageResponse = this.swapSendSendbirdSendMessageResponse.bind(this);
	    this.loadSendbirdMessages = this.loadSendbirdMessages.bind(this);
	    this.swapLoadSendbirdMessagesResponse = this.swapLoadSendbirdMessagesResponse.bind(this);
	    this.getSendbirdService = this.getSendbirdService.bind(this);
	  }
	
	  _createClass(SendBirdService, [{
	    key: 'getSendbirdService',
	    value: function getSendbirdService() {
	      return this.sendBirdService;
	    }
	  }, {
	    key: 'removeSendbirdChannelHandler',
	    value: function removeSendbirdChannelHandler(discussionId) {
	      this.sendBirdService.removeChannelHandler(discussionId);
	    }
	  }, {
	    key: 'connectSendbirdUser',
	    value: function connectSendbirdUser(userId) {
	      // Create a promise-based version of the connect Sendbird callback function
	      return pify(this.swapSendbirdConnectUserResponse)(userId).then(function (response) {
	        return response;
	      });
	    }
	
	    // Sendbird returns response and error the wrong way round
	
	  }, {
	    key: 'swapSendbirdConnectUserResponse',
	    value: function swapSendbirdConnectUserResponse(userId, callback) {
	      this.sendBirdService.connect(userId, function (user, error) {
	        if (user) {
	          callback(null, user);
	        } else {
	          callback(error, null);
	        }
	      });
	    }
	  }, {
	    key: 'createSendbirdChannel',
	    value: function createSendbirdChannel(sendbirdMembers) {
	      // Create a promise-based version of the connect Sendbird callback function
	      return pify(this.swapSendbirdCreateChannelResponse)(sendbirdMembers).then(function (response) {
	        return response.url;
	      });
	    }
	
	    // Sendbird returns response and error the wrong way round
	
	  }, {
	    key: 'swapSendbirdCreateChannelResponse',
	    value: function swapSendbirdCreateChannelResponse(sendbirdMembers, callback) {
	      this.sendBirdService.GroupChannel.createChannelWithUserIds(sendbirdMembers, false, 'APPROPRIATE-CHANNEL-NAME', 'coverURL', {}, function (channel, error) {
	        if (channel) {
	          callback(null, channel);
	        } else {
	          callback(error, null);
	        }
	      });
	    }
	  }, {
	    key: 'fetchSendbirdChannel',
	    value: function fetchSendbirdChannel(channelURL) {
	      // Create a promise-based version of the connect Sendbird callback function
	      return pify(this.swapFetchSendbirdChannelResponse)(channelURL).then(function (response) {
	        return response;
	      });
	    }
	  }, {
	    key: 'swapFetchSendbirdChannelResponse',
	    value: function swapFetchSendbirdChannelResponse(channelURL, callback) {
	      this.sendBirdService.GroupChannel.getChannel(channelURL, function (channel, error) {
	        if (channel) {
	          callback(null, channel);
	        } else {
	          callback(error, null);
	        }
	      });
	    }
	  }, {
	    key: 'sendSendbirdMessage',
	    value: function sendSendbirdMessage(channel, message, metaData) {
	
	      // Create a promise-based version of the load message Sendbird callback function
	      return pify(this.swapSendSendbirdSendMessageResponse)(channel, message, metaData).then(function (response) {
	        return response;
	      });
	    }
	  }, {
	    key: 'swapSendSendbirdSendMessageResponse',
	    value: function swapSendSendbirdSendMessageResponse(channel, message, metaData, callback) {
	
	      var data = JSON.stringify(metaData);
	      channel.sendUserMessage(message, data, 'Message', function (message, error) {
	        if (message) {
	          callback(null, message);
	        } else {
	          callback(error, null);
	        }
	      });
	    }
	  }, {
	    key: 'removeSendbirdMessage',
	    value: function removeSendbirdMessage(channelURL, messageId) {
	
	      var endpoint = 'https://api.sendbird.com/v3/group_channels/' + channelURL + '/messages/' + messageId;
	      var payload = {};
	      var headers = {
	        'Content-Type': 'application/json'
	      };
	
	      return _axios2.default.delete(endpoint, payload, headers).then(function (response) {
	        return response;
	      });
	    }
	  }, {
	    key: 'loadSendbirdMessages',
	    value: function loadSendbirdMessages(messageListQuery, channel) {
	
	      // Create a promise-based version of the load message Sendbird callback function
	      return pify(this.swapLoadSendbirdMessagesResponse)(messageListQuery, channel).then(function (response) {
	        return response;
	      });
	    }
	  }, {
	    key: 'swapLoadSendbirdMessagesResponse',
	    value: function swapLoadSendbirdMessagesResponse(messageListQuery, channel, callback) {
	
	      messageListQuery.load(100, true, function (messageList, error) {
	        if (messageList) {
	          var reversedMessageList = messageList.reverse();
	          callback(null, reversedMessageList);
	        } else {
	          callback(error, null);
	        }
	      });
	    }
	  }]);
	
	  return SendBirdService;
	}();
	
	var sendBirdService = exports.sendBirdService = new SendBirdService();

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(108);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(2400);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(4148)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)os/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/chrome.+? edge/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && !result.msedge && (android || result.silk)) {
	      result.android = t
	    } else if (!result.windowsphone && !result.msedge && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	    } else if (mac) {
	      result.mac = t
	    } else if (xbox) {
	      result.xbox = t
	    } else if (windows) {
	      result.windows = t
	    } else if (linux) {
	      result.linux = t
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  return bowser
	});


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(154);
	
	var callBind = __webpack_require__(289);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ },
/* 370 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 371 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(145).f;
	var has = __webpack_require__(196);
	var TAG = __webpack_require__(88)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 373 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2499);
	var global = __webpack_require__(87);
	var hide = __webpack_require__(197);
	var Iterators = __webpack_require__(237);
	var TO_STRING_TAG = __webpack_require__(88)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var X32WordArray = C_lib.WordArray;
	
		    /**
		     * x64 namespace.
		     */
		    var C_x64 = C.x64 = {};
	
		    /**
		     * A 64-bit word.
		     */
		    var X64Word = C_x64.Word = Base.extend({
		        /**
		         * Initializes a newly created 64-bit word.
		         *
		         * @param {number} high The high 32 bits.
		         * @param {number} low The low 32 bits.
		         *
		         * @example
		         *
		         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
		         */
		        init: function (high, low) {
		            this.high = high;
		            this.low = low;
		        }
	
		        /**
		         * Bitwise NOTs this word.
		         *
		         * @return {X64Word} A new x64-Word object after negating.
		         *
		         * @example
		         *
		         *     var negated = x64Word.not();
		         */
		        // not: function () {
		            // var high = ~this.high;
		            // var low = ~this.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise ANDs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to AND with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ANDing.
		         *
		         * @example
		         *
		         *     var anded = x64Word.and(anotherX64Word);
		         */
		        // and: function (word) {
		            // var high = this.high & word.high;
		            // var low = this.low & word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise ORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to OR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ORing.
		         *
		         * @example
		         *
		         *     var ored = x64Word.or(anotherX64Word);
		         */
		        // or: function (word) {
		            // var high = this.high | word.high;
		            // var low = this.low | word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise XORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to XOR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after XORing.
		         *
		         * @example
		         *
		         *     var xored = x64Word.xor(anotherX64Word);
		         */
		        // xor: function (word) {
		            // var high = this.high ^ word.high;
		            // var low = this.low ^ word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Shifts this word n bits to the left.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftL(25);
		         */
		        // shiftL: function (n) {
		            // if (n < 32) {
		                // var high = (this.high << n) | (this.low >>> (32 - n));
		                // var low = this.low << n;
		            // } else {
		                // var high = this.low << (n - 32);
		                // var low = 0;
		            // }
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Shifts this word n bits to the right.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftR(7);
		         */
		        // shiftR: function (n) {
		            // if (n < 32) {
		                // var low = (this.low >>> n) | (this.high << (32 - n));
		                // var high = this.high >>> n;
		            // } else {
		                // var low = this.high >>> (n - 32);
		                // var high = 0;
		            // }
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Rotates this word n bits to the left.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotL(25);
		         */
		        // rotL: function (n) {
		            // return this.shiftL(n).or(this.shiftR(64 - n));
		        // },
	
		        /**
		         * Rotates this word n bits to the right.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotR(7);
		         */
		        // rotR: function (n) {
		            // return this.shiftR(n).or(this.shiftL(64 - n));
		        // },
	
		        /**
		         * Adds this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to add with this word.
		         *
		         * @return {X64Word} A new x64-Word object after adding.
		         *
		         * @example
		         *
		         *     var added = x64Word.add(anotherX64Word);
		         */
		        // add: function (word) {
		            // var low = (this.low + word.low) | 0;
		            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
		            // var high = (this.high + word.high + carry) | 0;
	
		            // return X64Word.create(high, low);
		        // }
		    });
	
		    /**
		     * An array of 64-bit words.
		     *
		     * @property {Array} words The array of CryptoJS.x64.Word objects.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var X64WordArray = C_x64.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create();
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ]);
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ], 10);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 8;
		            }
		        },
	
		        /**
		         * Converts this 64-bit word array to a 32-bit word array.
		         *
		         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
		         *
		         * @example
		         *
		         *     var x32WordArray = x64WordArray.toX32();
		         */
		        toX32: function () {
		            // Shortcuts
		            var x64Words = this.words;
		            var x64WordsLength = x64Words.length;
	
		            // Convert
		            var x32Words = [];
		            for (var i = 0; i < x64WordsLength; i++) {
		                var x64Word = x64Words[i];
		                x32Words.push(x64Word.high);
		                x32Words.push(x64Word.low);
		            }
	
		            return X32WordArray.create(x32Words, this.sigBytes);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {X64WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = x64WordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
	
		            // Clone "words" array
		            var words = clone.words = this.words.slice(0);
	
		            // Clone each X64Word object
		            var wordsLength = words.length;
		            for (var i = 0; i < wordsLength; i++) {
		                words[i] = words[i].clone();
		            }
	
		            return clone;
		        }
		    });
		}());
	
	
		return CryptoJS;
	
	}));

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactChartjs = __webpack_require__(207);
	
	var _colors = __webpack_require__(380);
	
	var _formatting = __webpack_require__(52);
	
	var _constants = __webpack_require__(971);
	
	var _demographics = __webpack_require__(972);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var options = {
	  legend: {
	    display: false
	  },
	  tooltips: {
	    callbacks: {
	      label: _formatting.getGraphLabelPercentageFormatting
	    }
	  }
	};
	
	var getViewsByGender = function getViewsByGender(data) {
	  var values = (0, _demographics.reduceGraphDataByGender)(data);
	  return {
	    data: {
	      labels: _lodash2.default.map(_lodash2.default.uniq(_lodash2.default.keys(values)), function (key) {
	        return _lodash2.default.get(_constants.GENDERS, key).text || 'Unknown';
	      }),
	      datasets: [{
	        data: _lodash2.default.map(values, function (value) {
	          return _lodash2.default.sumBy(value, 'percentage');
	        }),
	        backgroundColor: [_colors.dyzioPalette.blue, _colors.dyzioPalette.pink],
	        hoverBackgroundColor: [_colors.dyzioPalette.blue, _colors.dyzioPalette.pink]
	      }]
	    }
	  };
	};
	
	var DemographicsGenderGraph = function DemographicsGenderGraph(_ref) {
	  var data = _ref.audienceDemographics.data;
	
	  var genderViewingData = getViewsByGender(data);
	  return _react2.default.createElement(_reactChartjs.Doughnut, (0, _extends3.default)({}, genderViewingData, { options: options }));
	};
	
	DemographicsGenderGraph.propTypes = {
	  audienceDemographics: _propTypes2.default.object.isRequired
	};
	
	exports.default = DemographicsGenderGraph;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(108);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _numeral = __webpack_require__(152);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _demographicsAgeGraph = __webpack_require__(241);
	
	var _demographicsAgeGraph2 = _interopRequireDefault(_demographicsAgeGraph);
	
	var _followersBarChart = __webpack_require__(176);
	
	var _followersBarChart2 = _interopRequireDefault(_followersBarChart);
	
	var _locationTabs = __webpack_require__(2561);
	
	var _locationTabs2 = _interopRequireDefault(_locationTabs);
	
	var _authToken = __webpack_require__(2599);
	
	var _authToken2 = _interopRequireDefault(_authToken);
	
	var _formatting = __webpack_require__(52);
	
	var _fullCityModal = __webpack_require__(2559);
	
	var _fullCityModal2 = _interopRequireDefault(_fullCityModal);
	
	var _fullCountryModal = __webpack_require__(2560);
	
	var _fullCountryModal2 = _interopRequireDefault(_fullCountryModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	var avgFormat = function avgFormat(num) {
	  var entity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'posts';
	  return _lodash2.default.isNil(num) || num === 0 ? 'no ' + entity : (0, _numeral2.default)(num).format('0,0');
	};
	
	var textCenterStyle = {
	  textAlign: 'center',
	  width: '100%'
	};
	
	var pageBreakStyle = {
	  pageBreakBefore: 'always'
	};
	
	var notificationStyle = {
	  paddingTop: 100,
	  paddingBottom: 100
	};
	
	var noBorderStyle = (0, _extends3.default)({
	  boxShadow: 'none',
	  border: 'none'
	}, pageBreakStyle);
	
	var messageStyle = { color: 'grey', fontSize: 16 };
	var pad5 = {
	  padding: 5
	};
	var bgGrey = {
	  backgroundColor: '#eee'
	};
	
	var pinkText = {
	  color: '#e03997'
	};
	
	var pad50 = {
	  paddingTop: 50
	};
	
	var fluid = {
	  widht: '100%',
	  display: 'block',
	  textAlign: 'left'
	};
	
	var noMarginStyle = {
	  margin: 0
	};
	
	var noVerticalMargin = {
	  marginTop: 0,
	  marginBottom: 0
	};
	
	var DaysStats = function DaysStats(_ref) {
	  var loading = _ref.loading,
	      insights = _ref.insights;
	
	  var last14DaysPostsReachAvg = _lodash2.default.get(insights, 'last14DaysPostsReachAvg', '-');
	  var last30DaysPostsReachAvg = _lodash2.default.get(insights, 'last30DaysPostsReachAvg', '-');
	
	  var last14DaysPostsImpressionsAvg = _lodash2.default.get(insights, 'last14DaysPostsImpressionsAvg', '-');
	  var last30DaysPostsImpressionsAvg = _lodash2.default.get(insights, 'last30DaysPostsImpressionsAvg', '-');
	
	  var storiesStats = _lodash2.default.get(insights, 'storiesStats');
	
	  var storiesPane = {
	    menuItem: { key: 'stories', icon: 'circle outline', content: 'Stories' },
	    render: function render() {
	      return _react2.default.createElement(
	        _semanticUiReact.Tab.Pane,
	        null,
	        _react2.default.createElement(
	          'h5',
	          { style: noVerticalMargin },
	          'average reach'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very', style: noMarginStyle },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                '14 days'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { textAlign: 'center' },
	                avgFormat(_lodash2.default.get(storiesStats, 'days14Reach', 0), 'stories')
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                '30 days'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { textAlign: 'center' },
	                avgFormat(_lodash2.default.get(storiesStats, 'days30Reach', 0), 'stories')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        _react2.default.createElement(
	          'h5',
	          { style: noVerticalMargin },
	          'average impressions'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very', style: noMarginStyle },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                '14 days'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { textAlign: 'center' },
	                avgFormat(_lodash2.default.get(storiesStats, 'days14Impressions', 0), 'stories')
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                '30 days'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { textAlign: 'center' },
	                avgFormat(_lodash2.default.get(storiesStats, 'days30Impressions', 0), 'stories')
	              )
	            )
	          )
	        )
	      );
	    } };
	
	  var postsPane = {
	    menuItem: { key: 'posts', icon: 'clone outline', content: 'Posts' },
	    render: function render() {
	      return _react2.default.createElement(
	        _semanticUiReact.Tab.Pane,
	        null,
	        _react2.default.createElement(
	          'h5',
	          { style: noVerticalMargin },
	          'average reach'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very', style: noMarginStyle },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                '14 days'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { textAlign: 'center' },
	                avgFormat(last14DaysPostsReachAvg)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                '30 days'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { textAlign: 'center' },
	                avgFormat(last30DaysPostsReachAvg)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        _react2.default.createElement(
	          'h5',
	          { style: noVerticalMargin },
	          'average impressions'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very', style: noMarginStyle },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                '14 days'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { textAlign: 'center' },
	                avgFormat(last14DaysPostsImpressionsAvg)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                '30 days'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { textAlign: 'center' },
	                avgFormat(last30DaysPostsImpressionsAvg)
	              )
	            )
	          )
	        )
	      );
	    }
	  };
	
	  var panes = [postsPane];
	
	  if (_lodash2.default.isNil(storiesStats)) {
	    panes.push({
	      menuItem: { key: 'stories', icon: 'circle outline', content: 'Stories' },
	      render: function render() {
	        return _react2.default.createElement(
	          _semanticUiReact.Tab.Pane,
	          null,
	          _react2.default.createElement(
	            'h5',
	            { style: noVerticalMargin },
	            'no stories data available yet.'
	          )
	        );
	      }
	    });
	  } else {
	    panes.unshift(storiesPane);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: fluid },
	    loading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'loading data' }),
	    !loading && !insights && _react2.default.createElement(
	      'span',
	      null,
	      'Failed to load data.'
	    ),
	    !loading && insights && _react2.default.createElement(_semanticUiReact.Tab, { panes: panes })
	  );
	};
	
	var InstagramProfileData = function (_React$Component) {
	  (0, _inherits3.default)(InstagramProfileData, _React$Component);
	
	  function InstagramProfileData() {
	    (0, _classCallCheck3.default)(this, InstagramProfileData);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InstagramProfileData.__proto__ || (0, _getPrototypeOf2.default)(InstagramProfileData)).call(this));
	
	    _this.componentDidMount = function () {
	      var influencer = _this.props.influencer;
	
	      _this.api.get('/instagram/' + influencer.instagram + '/history').then(function (response) {
	        var items = response.data.items;
	
	        return _this.setState({
	          items: _lodash2.default.reverse(items),
	          loading: false
	        });
	      });
	
	      _this.instagramApi.get('stats/' + influencer.instagram).then(function (response) {
	        var data = response.data.data;
	
	        return _this.setState({
	          isLoadingStats: false,
	          instagramStats: data
	        });
	      });
	
	      if (influencer.instagramData) {
	        _this.reachApi.get(influencer.id + '/instagram/insights').then(function (response) {
	          var data = response.data.data;
	
	          return _this.setState({
	            insights: data,
	            isLoadingInsights: false
	          });
	        }).catch(function () {
	          _this.setState({
	            insights: null,
	            isLoadingInsights: false
	          });
	        });
	      }
	    };
	
	    _this.toggleFullCityModal = function () {
	      var fullCityModalOpen = _this.state.fullCityModalOpen;
	
	      return _this.setState({
	        fullCityModalOpen: !fullCityModalOpen
	      });
	    };
	
	    _this.toggleFullCountryModal = function () {
	      var fullCountryModalOpen = _this.state.fullCountryModalOpen;
	
	      return _this.setState({
	        fullCountryModalOpen: !fullCountryModalOpen
	      });
	    };
	
	    _this.state = {
	      insights: null,
	      isLoadingStats: true,
	      isLoadingInsights: true,
	      items: [],
	      loading: true,
	      oneDay: true
	    };
	    var token = (0, _authToken2.default)();
	    var newsfeedApi = 'https://b7o8doqzfb.execute-api.eu-west-1.amazonaws.com/production';
	    var instagramDataApi = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer';
	    var reachAndImpressionsApi = 'https://uiqcrs8dhb.execute-api.eu-west-1.amazonaws.com/production/influencer';
	
	    _this.api = _axios2.default.create({
	      baseURL: newsfeedApi,
	      timeout: 10000,
	      headers: {
	        Authorization: 'Bearer ' + token
	      }
	    });
	    _this.instagramApi = _axios2.default.create({
	      baseURL: instagramDataApi,
	      timeout: 10000,
	      headers: {
	        Authorization: 'Bearer ' + token
	      }
	    });
	
	    _this.reachApi = _axios2.default.create({
	      baseURL: reachAndImpressionsApi,
	      timeout: 20000,
	      headers: {
	        Authorization: 'Bearer ' + token
	      }
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(InstagramProfileData, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          influencer = _props.influencer,
	          disableBorders = _props.disableBorders,
	          usedByACRCampaign = _props.usedByACRCampaign,
	          organisationId = _props.organisationId,
	          displayAuthorisedData = _props.displayAuthorisedData;
	      var _state = this.state,
	          items = _state.items,
	          insights = _state.insights,
	          loading = _state.loading,
	          instagramStats = _state.instagramStats,
	          isLoadingInsights = _state.isLoadingInsights,
	          isLoadingStats = _state.isLoadingStats,
	          fullCityModalOpen = _state.fullCityModalOpen,
	          fullCountryModalOpen = _state.fullCountryModalOpen;
	      var instagramEngagementRate = influencer.instagramEngagementRate;
	      var instagramData = influencer.instagramData;
	
	      var igDataExists = _lodash2.default.size(instagramData) > 0;
	
	      var instagram = influencer.instagram,
	          instagramThumbnail = influencer.instagramThumbnail;
	
	
	      var hasInstagramHandle = _lodash2.default.isString(instagram);
	      var hasEnoughData = true;
	
	      var graphData = {
	        label: 'followers',
	        labels: _lodash2.default.map(items, function (item) {
	          return (0, _moment2.default)(item.createdAt).format('MMM D');
	        }),
	        values: _lodash2.default.map(items, 'followerCount')
	      };
	
	      var lastItem = _lodash2.default.last(items);
	      var percentageChange = void 0;
	      var followersInLast30Days = 0;
	
	      var thirtyDaysAgo = (0, _moment2.default)().subtract('days', 30);
	      var last30DaysPosts = _lodash2.default.filter(items, function (item) {
	        var createdDate = (0, _moment2.default)(item.createdAt);
	        return createdDate.isAfter(thirtyDaysAgo);
	      });
	
	      if (!loading && last30DaysPosts.length > 0) {
	        var first = _lodash2.default.head(last30DaysPosts).followerCount;
	        var last = _lodash2.default.last(last30DaysPosts).followerCount;
	        percentageChange = (last - first) / first;
	        followersInLast30Days = last - first;
	      }
	
	      var canViewPrivateData = displayAuthorisedData || usedByACRCampaign;
	
	      if (!instagramEngagementRate && instagramStats && lastItem) {
	        var engs = instagramStats.engagementsPerPost || 0;
	        var fc = lastItem.followerCount || 0;
	
	        if (engs && fc) instagramEngagementRate = engs / fc * 100;
	      }
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        {
	          loading: loading,
	          color: disableBorders ? '' : 'pink',
	          style: disableBorders ? noBorderStyle : pageBreakStyle
	        },
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
	          'Instagram'
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        influencer && influencer.instagramPrivate && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { icon: true, warning: true },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock' }),
	          _react2.default.createElement(
	            _semanticUiReact.Message.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Message.Header,
	              null,
	              'Private account'
	            ),
	            'This Instagram account is private'
	          )
	        ),
	        !lastItem && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { icon: true, warning: true },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'area graph' }),
	          _react2.default.createElement(
	            _semanticUiReact.Message.Content,
	            null,
	            'Instagram stats not available yet, please come back later'
	          )
	        ),
	        lastItem && _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { columns: 3 },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 3 },
	              hasInstagramHandle && !loading && _react2.default.createElement(
	                'div',
	                { style: pad50 },
	                _react2.default.createElement(_semanticUiReact.Image, {
	                  src: instagramThumbnail || lastItem.profilePic,
	                  className: 'circular',
	                  centered: true,
	                  size: 'small'
	                }),
	                _react2.default.createElement(
	                  _semanticUiReact.Table,
	                  { basic: 'very', fluid: true, textAlign: 'center' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Body,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        lastItem.handle,
	                        '\xA0',
	                        lastItem.isVerified && _react2.default.createElement(_semanticUiReact.Popup, {
	                          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' }),
	                          content: 'verified account'
	                        }),
	                        '\xA0',
	                        _react2.default.createElement(_semanticUiReact.Popup, {
	                          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'briefcase', color: lastItem.isBusinessAccount ? 'pink' : 'grey' }),
	                          content: (lastItem.isBusinessAccount ? '' : 'Not an') + ' Instagram business account'
	                        }),
	                        influencer && influencer.instagramPrivate && _react2.default.createElement(_semanticUiReact.Popup, {
	                          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'red' }),
	                          content: 'This account is private'
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        cf(lastItem.followerCount),
	                        ' followers'
	                      )
	                    ),
	                    !lastItem.isVerified && _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        _react2.default.createElement(_semanticUiReact.Popup, {
	                          trigger: _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'grey', content: 'not verified' }),
	                          content: lastItem.handle + ' is not verified by Instagram (blue tick)'
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 8 },
	              !hasInstagramHandle && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Header,
	                  { as: 'h2', icon: true, textAlign: 'center', style: notificationStyle },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus', color: 'orange', circular: true }),
	                  _react2.default.createElement(
	                    _semanticUiReact.Header.Content,
	                    { style: messageStyle },
	                    'no Instagram channel for this influencer'
	                  )
	                )
	              ),
	              hasInstagramHandle && !hasEnoughData && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Header,
	                  { as: 'h2', icon: true, textAlign: 'center', style: notificationStyle },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock', color: 'orange', circular: true }),
	                  _react2.default.createElement(
	                    _semanticUiReact.Header.Content,
	                    { style: messageStyle },
	                    'we have not collected enough ',
	                    _react2.default.createElement('br', null),
	                    ' data for this channel yet'
	                  )
	                )
	              ),
	              hasInstagramHandle && hasEnoughData && _react2.default.createElement(
	                'div',
	                { className: 'chart-wrapper-print' },
	                _react2.default.createElement(_followersBarChart2.default, (0, _extends3.default)({}, graphData, {
	                  percentageRange: 0.5
	                }))
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 5 },
	              hasInstagramHandle && isLoadingStats && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading...' }),
	              hasInstagramHandle && instagramStats && !isLoadingStats && _react2.default.createElement(
	                'div',
	                null,
	                instagramEngagementRate && _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  { style: textCenterStyle },
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    null,
	                    (0, _formatting.ierFormat)(instagramEngagementRate),
	                    '%'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'engagement rate'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table,
	                  { basic: 'very', fluid: true, compact: true },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Body,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        '30 day trend'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        _react2.default.createElement(_semanticUiReact.Label, {
	                          basic: true,
	                          color: percentageChange > 0 ? 'green' : 'red',
	                          content: (0, _numeral2.default)(percentageChange).format('+0.0%')
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'avg. likes per post'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        cf(instagramStats.likesPerPost)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'avg. comments per post'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        cf(instagramStats.commentsPerPost)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'avg. engagements per post'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        cf(instagramStats.engagementsPerPost)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'posts per week'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        cf(instagramStats.average7DaysPosts)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'posts per month'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        cf(instagramStats.average30DaysPosts)
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          canViewPrivateData && igDataExists && _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { textAlign: 'center' },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 16 },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Audience Demographics and Regions',
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'orange' }),
	                  content: 'Private data collected from Instagram Insights API'
	                })
	              )
	            )
	          ),
	          canViewPrivateData && igDataExists && _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { textAlign: 'center' },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 3 },
	              _react2.default.createElement(DaysStats, { loading: isLoadingInsights, insights: insights })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 8 },
	              _react2.default.createElement(
	                'h5',
	                null,
	                'Channel demographic by gender / age'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'chart-wrapper-print' },
	                _react2.default.createElement(_demographicsAgeGraph2.default, instagramData)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 5 },
	              _react2.default.createElement(_locationTabs2.default, (0, _extends3.default)({}, instagramData, {
	                onFullCityClick: this.toggleFullCityModal,
	                onFullCountryClick: this.toggleFullCountryModal
	              })),
	              fullCityModalOpen && _react2.default.createElement(_fullCityModal2.default, (0, _extends3.default)({}, instagramData, { onToggle: this.toggleFullCityModal })),
	              fullCountryModalOpen && _react2.default.createElement(_fullCountryModal2.default, (0, _extends3.default)({}, instagramData, {
	                onToggle: this.toggleFullCountryModal
	              }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return InstagramProfileData;
	}(_react2.default.Component);
	
	InstagramProfileData.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  loading: _propTypes2.default.bool.isRequired,
	  disableBorders: _propTypes2.default.bool,
	  usedByACRCampaign: _propTypes2.default.bool,
	  displayAuthorisedData: _propTypes2.default.bool
	};
	
	InstagramProfileData.defaultProps = {
	  disableBorders: false,
	  usedByACRCampaign: false,
	  displayAuthorisedData: false
	};
	
	exports.default = InstagramProfileData;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHighlightWords = __webpack_require__(3357);
	
	var _reactHighlightWords2 = _interopRequireDefault(_reactHighlightWords);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var highlightStyle = {
	  backgroundColor: '#FDB02B'
	};
	
	var emptyArray = [];
	
	var TextHighlighter = function TextHighlighter(_ref) {
	  var text = _ref.text,
	      enabled = _ref.enabled,
	      words = _ref.words,
	      style = _ref.style;
	  return _react2.default.createElement(_reactHighlightWords2.default, {
	    highlightStyle: highlightStyle,
	    searchWords: enabled ? words : emptyArray,
	    textToHighlight: text,
	    autoEscape: true,
	    style: style
	  });
	};
	
	TextHighlighter.propTypes = {
	  text: _propTypes2.default.string,
	  words: _propTypes2.default.array,
	  enabled: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	};
	
	TextHighlighter.defaultProps = {
	  enabled: 'false',
	  words: [],
	  text: '',
	  style: {}
	};
	
	exports.default = TextHighlighter;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrivateDataComponent = function PrivateDataComponent(_ref) {
	  var post = _ref.post;
	
	  var influencerName = post.channelTitle || post.influencerName || post.twitterHandle;
	  var hostname = _lodash2.default.toLower(window.location.hostname);
	  var platformName = hostname.match(/voxogram/) ? 'voxogram' : 'dyzio';
	
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'grey' }),
	    content: influencerName + ' has not authorised ' + platformName + ' to fetch this data.'
	  });
	};
	
	exports.default = PrivateDataComponent;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var randomColor = __webpack_require__(3238);
	
	var _require = __webpack_require__(31),
	    replace = _require.replace;
	
	var dyzioPalette = exports.dyzioPalette = {
	  pink: '#fc4085',
	  bgPink: '#ffecf3',
	  green: '#20c49e',
	  bgGreen: '#d4faf1',
	  amber: '#fdb02b',
	  bgAmber: '#fff1d5',
	  blue: '#9ad2ff',
	  yellow: '#fff28c',
	  white: '#f7fafa',
	  turquoise: '#8dcece',
	  darkBlue: '#233B4B',
	  grey: '#8c8c8c'
	};
	
	var getRowColors = exports.getRowColors = function getRowColors(index) {
	  var opacity = 0.7;
	  var fullOpacity = 1;
	  var backgroundColours = ['rgba(252, 64, 133, ' + opacity + ')', 'rgba(32, 196, 158, ' + opacity + ')', 'rgba(253, 176, 43, ' + opacity + ')', 'rgba(154, 210, 255, ' + opacity + ')', 'rgba(255, 242, 140, ' + opacity + ')', 'rgba(247, 250, 250, ' + opacity + ')'];
	  var mainColor = backgroundColours[index] || randomColor({ format: 'rgba', luminosity: 'light', alpha: 0.7 });
	  var borderColor = replace(mainColor, opacity, fullOpacity);
	  return {
	    mainColor: mainColor,
	    borderColor: borderColor
	  };
	};

/***/ },
/* 381 */
[4189, 2690, 2691, 2692, 2693, 2694],
/* 382 */
[4195, 605, 2709, 2710],
/* 383 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 384 */
[4200, 389],
/* 385 */
[4203, 387, 303],
/* 386 */
[4204, 303],
/* 387 */
[4208, 1001],
/* 388 */
[4216, 608, 2687],
/* 389 */
[4222, 985, 2626, 2716],
/* 390 */
[4234, 302, 2703],
/* 391 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 392 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 393 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 394 */
[4274, 297, 96],
/* 395 */
[4283, 992, 2661, 2664, 999, 2667, 615, 2702, 1015, 1016, 150],
/* 396 */
[4294, 2688],
/* 397 */
[4297, 1013],
/* 398 */
[4310, 303, 123, 301, 96],
/* 399 */
[4327, 202],
/* 400 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 401 */
[4369, 51, 2731, 50],
/* 402 */
[4394, 2622, 79],
/* 403 */
[4396, 123, 79],
/* 404 */
[4399, 390, 203, 402, 47, 123, 304, 302, 406],
/* 405 */
[4405, 133, 397, 79],
/* 406 */
[4409, 2629, 245, 620],
/* 407 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ },
/* 408 */
[4423, 979, 201, 95, 2637, 47],
/* 409 */
[4436, 96, 206],
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "FilePlayer", {
	  enumerable: true,
	  get: function get() {
	    return _FilePlayer["default"];
	  }
	});
	Object.defineProperty(exports, "YouTube", {
	  enumerable: true,
	  get: function get() {
	    return _YouTube["default"];
	  }
	});
	Object.defineProperty(exports, "SoundCloud", {
	  enumerable: true,
	  get: function get() {
	    return _SoundCloud["default"];
	  }
	});
	Object.defineProperty(exports, "Vimeo", {
	  enumerable: true,
	  get: function get() {
	    return _Vimeo["default"];
	  }
	});
	Object.defineProperty(exports, "Facebook", {
	  enumerable: true,
	  get: function get() {
	    return _Facebook["default"];
	  }
	});
	Object.defineProperty(exports, "Streamable", {
	  enumerable: true,
	  get: function get() {
	    return _Streamable["default"];
	  }
	});
	Object.defineProperty(exports, "Wistia", {
	  enumerable: true,
	  get: function get() {
	    return _Wistia["default"];
	  }
	});
	Object.defineProperty(exports, "Twitch", {
	  enumerable: true,
	  get: function get() {
	    return _Twitch["default"];
	  }
	});
	Object.defineProperty(exports, "DailyMotion", {
	  enumerable: true,
	  get: function get() {
	    return _DailyMotion["default"];
	  }
	});
	Object.defineProperty(exports, "Mixcloud", {
	  enumerable: true,
	  get: function get() {
	    return _Mixcloud["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _props = __webpack_require__(411);
	
	var _utils = __webpack_require__(98);
	
	var _players = _interopRequireDefault(__webpack_require__(2794));
	
	var _Player4 = _interopRequireDefault(__webpack_require__(632));
	
	var _Preview = _interopRequireDefault(__webpack_require__(2793));
	
	var _FilePlayer = _interopRequireWildcard(__webpack_require__(1180));
	
	var _preload = _interopRequireDefault(__webpack_require__(2795));
	
	var _YouTube = _interopRequireDefault(__webpack_require__(636));
	
	var _SoundCloud = _interopRequireDefault(__webpack_require__(634));
	
	var _Vimeo = _interopRequireDefault(__webpack_require__(635));
	
	var _Facebook = _interopRequireDefault(__webpack_require__(1179));
	
	var _Streamable = _interopRequireDefault(__webpack_require__(1182));
	
	var _Wistia = _interopRequireDefault(__webpack_require__(1184));
	
	var _Twitch = _interopRequireDefault(__webpack_require__(1183));
	
	var _DailyMotion = _interopRequireDefault(__webpack_require__(633));
	
	var _Mixcloud = _interopRequireDefault(__webpack_require__(1181));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SUPPORTED_PROPS = Object.keys(_props.propTypes);
	var customPlayers = [];
	
	var ReactPlayer = /*#__PURE__*/function (_Component) {
	  _inherits(ReactPlayer, _Component);
	
	  var _super = _createSuper(ReactPlayer);
	
	  function ReactPlayer() {
	    var _this;
	
	    _classCallCheck(this, ReactPlayer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "config", (0, _utils.getConfig)(_this.props, _props.defaultProps, true));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      showPreview: !!_this.props.light
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleClickPreview", function () {
	      _this.setState({
	        showPreview: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "showPreview", function () {
	      _this.setState({
	        showPreview: true
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
	      if (!_this.player) return null;
	      return _this.player.getDuration();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
	      if (!_this.player) return null;
	      return _this.player.getCurrentTime();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
	      if (!_this.player) return null;
	      return _this.player.getSecondsLoaded();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
	      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
	      if (!_this.player) return null;
	      return _this.player.getInternalPlayer(key);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
	      if (!_this.player) return null;
	
	      _this.player.seekTo(fraction, type);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
	      _this.props.onReady(_assertThisInitialized(_this));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "wrapperRef", function (wrapper) {
	      _this.wrapper = wrapper;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "activePlayerRef", function (player) {
	      _this.player = player;
	    });
	
	    return _this;
	  }
	
	  _createClass(ReactPlayer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.progressFrequency) {
	        var message = 'ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead';
	        console.warn(message, 'font-weight: bold', '', 'font-weight: bold', '');
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _utils.isEqual)(this.props, nextProps) || !(0, _utils.isEqual)(this.state, nextState);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var light = this.props.light;
	      this.config = (0, _utils.getConfig)(this.props, _props.defaultProps);
	
	      if (!prevProps.light && light) {
	        this.setState({
	          showPreview: true
	        });
	      }
	
	      if (prevProps.light && !light) {
	        this.setState({
	          showPreview: false
	        });
	      }
	    }
	  }, {
	    key: "getActivePlayer",
	    value: function getActivePlayer(url) {
	      for (var _i = 0, _arr = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i < _arr.length; _i++) {
	        var _Player = _arr[_i];
	
	        if (_Player.canPlay(url)) {
	          return _Player;
	        }
	      } // Fall back to FilePlayer if nothing else can play the URL
	
	
	      return _FilePlayer.FilePlayer;
	    }
	  }, {
	    key: "renderActivePlayer",
	    value: function renderActivePlayer(url, activePlayer) {
	      if (!url) return null;
	      return /*#__PURE__*/_react["default"].createElement(_Player4["default"], _extends({}, this.props, {
	        key: activePlayer.displayName,
	        ref: this.activePlayerRef,
	        config: this.config,
	        activePlayer: activePlayer,
	        onReady: this.handleReady
	      }));
	    }
	  }, {
	    key: "sortPlayers",
	    value: function sortPlayers(a, b) {
	      // Retain player order to prevent weird iframe behaviour when switching players
	      if (a && b) {
	        return a.key < b.key ? -1 : 1;
	      }
	
	      return 0;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          url = _this$props.url,
	          controls = _this$props.controls,
	          style = _this$props.style,
	          width = _this$props.width,
	          height = _this$props.height,
	          light = _this$props.light,
	          playIcon = _this$props.playIcon,
	          Wrapper = _this$props.wrapper;
	      var showPreview = this.state.showPreview && url;
	      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props.DEPRECATED_CONFIG_PROPS);
	      var activePlayer = this.getActivePlayer(url);
	      var renderedActivePlayer = this.renderActivePlayer(url, activePlayer);
	      var preloadPlayers = (0, _preload["default"])(url, controls, this.config);
	      var players = [renderedActivePlayer].concat(_toConsumableArray(preloadPlayers)).sort(this.sortPlayers);
	
	      var preview = /*#__PURE__*/_react["default"].createElement(_Preview["default"], {
	        url: url,
	        light: light,
	        playIcon: playIcon,
	        onClick: this.handleClickPreview
	      });
	
	      return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
	        ref: this.wrapperRef,
	        style: _objectSpread({}, style, {
	          width: width,
	          height: height
	        })
	      }, otherProps), showPreview ? preview : players);
	    }
	  }]);
	
	  return ReactPlayer;
	}(_react.Component);
	
	exports["default"] = ReactPlayer;
	
	_defineProperty(ReactPlayer, "addCustomPlayer", function (player) {
	  customPlayers.push(player);
	});
	
	_defineProperty(ReactPlayer, "removeCustomPlayers", function () {
	  customPlayers = [];
	});
	
	_defineProperty(ReactPlayer, "displayName", 'ReactPlayer');
	
	_defineProperty(ReactPlayer, "propTypes", _props.propTypes);
	
	_defineProperty(ReactPlayer, "defaultProps", _props.defaultProps);
	
	_defineProperty(ReactPlayer, "canPlay", function (url) {
	  for (var _i2 = 0, _arr2 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i2 < _arr2.length; _i2++) {
	    var _Player2 = _arr2[_i2];
	
	    if (_Player2.canPlay(url)) {
	      return true;
	    }
	  }
	
	  return false;
	});
	
	_defineProperty(ReactPlayer, "canEnablePIP", function (url) {
	  for (var _i3 = 0, _arr3 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i3 < _arr3.length; _i3++) {
	    var _Player3 = _arr3[_i3];
	
	    if (_Player3.canEnablePIP && _Player3.canEnablePIP(url)) {
	      return true;
	    }
	  }
	
	  return false;
	});

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var string = _propTypes["default"].string,
	    bool = _propTypes["default"].bool,
	    number = _propTypes["default"].number,
	    array = _propTypes["default"].array,
	    oneOfType = _propTypes["default"].oneOfType,
	    shape = _propTypes["default"].shape,
	    object = _propTypes["default"].object,
	    func = _propTypes["default"].func,
	    node = _propTypes["default"].node;
	var propTypes = {
	  url: oneOfType([string, array, object]),
	  playing: bool,
	  loop: bool,
	  controls: bool,
	  volume: number,
	  muted: bool,
	  playbackRate: number,
	  width: oneOfType([string, number]),
	  height: oneOfType([string, number]),
	  style: object,
	  progressInterval: number,
	  playsinline: bool,
	  pip: bool,
	  light: oneOfType([bool, string]),
	  playIcon: node,
	  wrapper: oneOfType([string, func, shape({
	    render: func.isRequired
	  })]),
	  config: shape({
	    soundcloud: shape({
	      options: object,
	      preload: bool
	    }),
	    youtube: shape({
	      playerVars: object,
	      embedOptions: object,
	      preload: bool
	    }),
	    facebook: shape({
	      appId: string,
	      version: string,
	      playerId: string
	    }),
	    dailymotion: shape({
	      params: object,
	      preload: bool
	    }),
	    vimeo: shape({
	      playerOptions: object,
	      preload: bool
	    }),
	    file: shape({
	      attributes: object,
	      tracks: array,
	      forceVideo: bool,
	      forceAudio: bool,
	      forceHLS: bool,
	      forceDASH: bool,
	      hlsOptions: object,
	      hlsVersion: string,
	      dashVersion: string
	    }),
	    wistia: shape({
	      options: object
	    }),
	    mixcloud: shape({
	      options: object
	    }),
	    twitch: shape({
	      options: object,
	      playerId: string
	    })
	  }),
	  onReady: func,
	  onStart: func,
	  onPlay: func,
	  onPause: func,
	  onBuffer: func,
	  onBufferEnd: func,
	  onEnded: func,
	  onError: func,
	  onDuration: func,
	  onSeek: func,
	  onProgress: func,
	  onEnablePIP: func,
	  onDisablePIP: func
	};
	exports.propTypes = propTypes;
	var defaultProps = {
	  playing: false,
	  loop: false,
	  controls: false,
	  volume: null,
	  muted: false,
	  playbackRate: 1,
	  width: '640px',
	  height: '360px',
	  style: {},
	  progressInterval: 1000,
	  playsinline: false,
	  pip: false,
	  light: false,
	  wrapper: 'div',
	  config: {
	    soundcloud: {
	      options: {
	        visual: true,
	        // Undocumented, but makes player fill container and look better
	        buying: false,
	        liking: false,
	        download: false,
	        sharing: false,
	        show_comments: false,
	        show_playcount: false
	      }
	    },
	    youtube: {
	      playerVars: {
	        playsinline: 1,
	        showinfo: 0,
	        rel: 0,
	        iv_load_policy: 3,
	        modestbranding: 1
	      },
	      embedOptions: {},
	      preload: false
	    },
	    facebook: {
	      appId: '1309697205772819',
	      version: 'v3.3',
	      playerId: null
	    },
	    dailymotion: {
	      params: {
	        api: 1,
	        'endscreen-enable': false
	      },
	      preload: false
	    },
	    vimeo: {
	      playerOptions: {
	        autopause: false,
	        byline: false,
	        portrait: false,
	        title: false
	      },
	      preload: false
	    },
	    file: {
	      attributes: {},
	      tracks: [],
	      forceVideo: false,
	      forceAudio: false,
	      forceHLS: false,
	      forceDASH: false,
	      hlsOptions: {},
	      hlsVersion: '0.13.1',
	      dashVersion: '2.9.2'
	    },
	    wistia: {
	      options: {}
	    },
	    mixcloud: {
	      options: {
	        hide_cover: 1
	      }
	    },
	    twitch: {
	      options: {},
	      playerId: null
	    }
	  },
	  onReady: function onReady() {},
	  onStart: function onStart() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onBuffer: function onBuffer() {},
	  onBufferEnd: function onBufferEnd() {},
	  onEnded: function onEnded() {},
	  onError: function onError() {},
	  onDuration: function onDuration() {},
	  onSeek: function onSeek() {},
	  onProgress: function onProgress() {},
	  onEnablePIP: function onEnablePIP() {},
	  onDisablePIP: function onDisablePIP() {}
	};
	exports.defaultProps = defaultProps;
	var DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'fileConfig', 'wistiaConfig'];
	exports.DEPRECATED_CONFIG_PROPS = DEPRECATED_CONFIG_PROPS;

/***/ },
/* 412 */
[4487, 43, 8, 10, 75],
/* 413 */
[4494, 1211],
/* 414 */
[4502, 43, 8, 10, 1218],
/* 415 */
[4508, 642],
/* 416 */
[4510, 8, 10],
/* 417 */
[4511, 8, 10],
/* 418 */
[4535, 2858],
/* 419 */
[4565, 8, 10],
/* 420 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(2932);
	
	var _runTransitionHook = __webpack_require__(673);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(209);
	
	var _deprecate = __webpack_require__(672);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 422 */
/***/ function(module, exports) {

	var JsonWebTokenError = function (message, error) {
	  Error.call(this, message);
	  if(Error.captureStackTrace) {
	    Error.captureStackTrace(this, this.constructor);
	  }
	  this.name = 'JsonWebTokenError';
	  this.message = message;
	  if (error) this.inner = error;
	};
	
	JsonWebTokenError.prototype = Object.create(Error.prototype);
	JsonWebTokenError.prototype.constructor = JsonWebTokenError;
	
	module.exports = JsonWebTokenError;


/***/ },
/* 423 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 424 */
79,
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* @license
	Papa Parse
	v5.4.1
	https://github.com/mholt/PapaParse
	License: MIT
	*/
	!function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&"undefined"!=typeof exports?module.exports=t():e.Papa=t()}(this,function s(){"use strict";var f="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==f?f:{};var n=!f.document&&!!f.postMessage,o=f.IS_PAPA_WORKER||!1,a={},u=0,b={parse:function(e,t){var r=(t=t||{}).dynamicTyping||!1;J(r)&&(t.dynamicTypingFunction=r,r={});if(t.dynamicTyping=r,t.transform=!!J(t.transform)&&t.transform,t.worker&&b.WORKERS_SUPPORTED){var i=function(){if(!b.WORKERS_SUPPORTED)return!1;var e=(r=f.URL||f.webkitURL||null,i=s.toString(),b.BLOB_URL||(b.BLOB_URL=r.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ","(",i,")();"],{type:"text/javascript"})))),t=new f.Worker(e);var r,i;return t.onmessage=_,t.id=u++,a[t.id]=t}();return i.userStep=t.step,i.userChunk=t.chunk,i.userComplete=t.complete,i.userError=t.error,t.step=J(t.step),t.chunk=J(t.chunk),t.complete=J(t.complete),t.error=J(t.error),delete t.worker,void i.postMessage({input:e,config:t,workerId:i.id})}var n=null;b.NODE_STREAM_INPUT,"string"==typeof e?(e=function(e){if(65279===e.charCodeAt(0))return e.slice(1);return e}(e),n=t.download?new l(t):new p(t)):!0===e.readable&&J(e.read)&&J(e.on)?n=new g(t):(f.File&&e instanceof File||e instanceof Object)&&(n=new c(t));return n.stream(e)},unparse:function(e,t){var n=!1,_=!0,m=",",y="\r\n",s='"',a=s+s,r=!1,i=null,o=!1;!function(){if("object"!=typeof t)return;"string"!=typeof t.delimiter||b.BAD_DELIMITERS.filter(function(e){return-1!==t.delimiter.indexOf(e)}).length||(m=t.delimiter);("boolean"==typeof t.quotes||"function"==typeof t.quotes||Array.isArray(t.quotes))&&(n=t.quotes);"boolean"!=typeof t.skipEmptyLines&&"string"!=typeof t.skipEmptyLines||(r=t.skipEmptyLines);"string"==typeof t.newline&&(y=t.newline);"string"==typeof t.quoteChar&&(s=t.quoteChar);"boolean"==typeof t.header&&(_=t.header);if(Array.isArray(t.columns)){if(0===t.columns.length)throw new Error("Option columns is empty");i=t.columns}void 0!==t.escapeChar&&(a=t.escapeChar+s);("boolean"==typeof t.escapeFormulae||t.escapeFormulae instanceof RegExp)&&(o=t.escapeFormulae instanceof RegExp?t.escapeFormulae:/^[=+\-@\t\r].*$/)}();var u=new RegExp(Q(s),"g");"string"==typeof e&&(e=JSON.parse(e));if(Array.isArray(e)){if(!e.length||Array.isArray(e[0]))return h(null,e,r);if("object"==typeof e[0])return h(i||Object.keys(e[0]),e,r)}else if("object"==typeof e)return"string"==typeof e.data&&(e.data=JSON.parse(e.data)),Array.isArray(e.data)&&(e.fields||(e.fields=e.meta&&e.meta.fields||i),e.fields||(e.fields=Array.isArray(e.data[0])?e.fields:"object"==typeof e.data[0]?Object.keys(e.data[0]):[]),Array.isArray(e.data[0])||"object"==typeof e.data[0]||(e.data=[e.data])),h(e.fields||[],e.data||[],r);throw new Error("Unable to serialize unrecognized input");function h(e,t,r){var i="";"string"==typeof e&&(e=JSON.parse(e)),"string"==typeof t&&(t=JSON.parse(t));var n=Array.isArray(e)&&0<e.length,s=!Array.isArray(t[0]);if(n&&_){for(var a=0;a<e.length;a++)0<a&&(i+=m),i+=v(e[a],a);0<t.length&&(i+=y)}for(var o=0;o<t.length;o++){var u=n?e.length:t[o].length,h=!1,f=n?0===Object.keys(t[o]).length:0===t[o].length;if(r&&!n&&(h="greedy"===r?""===t[o].join("").trim():1===t[o].length&&0===t[o][0].length),"greedy"===r&&n){for(var d=[],l=0;l<u;l++){var c=s?e[l]:l;d.push(t[o][c])}h=""===d.join("").trim()}if(!h){for(var p=0;p<u;p++){0<p&&!f&&(i+=m);var g=n&&s?e[p]:p;i+=v(t[o][g],p)}o<t.length-1&&(!r||0<u&&!f)&&(i+=y)}}return i}function v(e,t){if(null==e)return"";if(e.constructor===Date)return JSON.stringify(e).slice(1,25);var r=!1;o&&"string"==typeof e&&o.test(e)&&(e="'"+e,r=!0);var i=e.toString().replace(u,a);return(r=r||!0===n||"function"==typeof n&&n(e,t)||Array.isArray(n)&&n[t]||function(e,t){for(var r=0;r<t.length;r++)if(-1<e.indexOf(t[r]))return!0;return!1}(i,b.BAD_DELIMITERS)||-1<i.indexOf(m)||" "===i.charAt(0)||" "===i.charAt(i.length-1))?s+i+s:i}}};if(b.RECORD_SEP=String.fromCharCode(30),b.UNIT_SEP=String.fromCharCode(31),b.BYTE_ORDER_MARK="\ufeff",b.BAD_DELIMITERS=["\r","\n",'"',b.BYTE_ORDER_MARK],b.WORKERS_SUPPORTED=!n&&!!f.Worker,b.NODE_STREAM_INPUT=1,b.LocalChunkSize=10485760,b.RemoteChunkSize=5242880,b.DefaultDelimiter=",",b.Parser=E,b.ParserHandle=r,b.NetworkStreamer=l,b.FileStreamer=c,b.StringStreamer=p,b.ReadableStreamStreamer=g,f.jQuery){var d=f.jQuery;d.fn.parse=function(o){var r=o.config||{},u=[];return this.each(function(e){if(!("INPUT"===d(this).prop("tagName").toUpperCase()&&"file"===d(this).attr("type").toLowerCase()&&f.FileReader)||!this.files||0===this.files.length)return!0;for(var t=0;t<this.files.length;t++)u.push({file:this.files[t],inputElem:this,instanceConfig:d.extend({},r)})}),e(),this;function e(){if(0!==u.length){var e,t,r,i,n=u[0];if(J(o.before)){var s=o.before(n.file,n.inputElem);if("object"==typeof s){if("abort"===s.action)return e="AbortError",t=n.file,r=n.inputElem,i=s.reason,void(J(o.error)&&o.error({name:e},t,r,i));if("skip"===s.action)return void h();"object"==typeof s.config&&(n.instanceConfig=d.extend(n.instanceConfig,s.config))}else if("skip"===s)return void h()}var a=n.instanceConfig.complete;n.instanceConfig.complete=function(e){J(a)&&a(e,n.file,n.inputElem),h()},b.parse(n.file,n.instanceConfig)}else J(o.complete)&&o.complete()}function h(){u.splice(0,1),e()}}}function h(e){this._handle=null,this._finished=!1,this._completed=!1,this._halted=!1,this._input=null,this._baseIndex=0,this._partialLine="",this._rowCount=0,this._start=0,this._nextChunk=null,this.isFirstChunk=!0,this._completeResults={data:[],errors:[],meta:{}},function(e){var t=w(e);t.chunkSize=parseInt(t.chunkSize),e.step||e.chunk||(t.chunkSize=null);this._handle=new r(t),(this._handle.streamer=this)._config=t}.call(this,e),this.parseChunk=function(e,t){if(this.isFirstChunk&&J(this._config.beforeFirstChunk)){var r=this._config.beforeFirstChunk(e);void 0!==r&&(e=r)}this.isFirstChunk=!1,this._halted=!1;var i=this._partialLine+e;this._partialLine="";var n=this._handle.parse(i,this._baseIndex,!this._finished);if(!this._handle.paused()&&!this._handle.aborted()){var s=n.meta.cursor;this._finished||(this._partialLine=i.substring(s-this._baseIndex),this._baseIndex=s),n&&n.data&&(this._rowCount+=n.data.length);var a=this._finished||this._config.preview&&this._rowCount>=this._config.preview;if(o)f.postMessage({results:n,workerId:b.WORKER_ID,finished:a});else if(J(this._config.chunk)&&!t){if(this._config.chunk(n,this._handle),this._handle.paused()||this._handle.aborted())return void(this._halted=!0);n=void 0,this._completeResults=void 0}return this._config.step||this._config.chunk||(this._completeResults.data=this._completeResults.data.concat(n.data),this._completeResults.errors=this._completeResults.errors.concat(n.errors),this._completeResults.meta=n.meta),this._completed||!a||!J(this._config.complete)||n&&n.meta.aborted||(this._config.complete(this._completeResults,this._input),this._completed=!0),a||n&&n.meta.paused||this._nextChunk(),n}this._halted=!0},this._sendError=function(e){J(this._config.error)?this._config.error(e):o&&this._config.error&&f.postMessage({workerId:b.WORKER_ID,error:e,finished:!1})}}function l(e){var i;(e=e||{}).chunkSize||(e.chunkSize=b.RemoteChunkSize),h.call(this,e),this._nextChunk=n?function(){this._readChunk(),this._chunkLoaded()}:function(){this._readChunk()},this.stream=function(e){this._input=e,this._nextChunk()},this._readChunk=function(){if(this._finished)this._chunkLoaded();else{if(i=new XMLHttpRequest,this._config.withCredentials&&(i.withCredentials=this._config.withCredentials),n||(i.onload=v(this._chunkLoaded,this),i.onerror=v(this._chunkError,this)),i.open(this._config.downloadRequestBody?"POST":"GET",this._input,!n),this._config.downloadRequestHeaders){var e=this._config.downloadRequestHeaders;for(var t in e)i.setRequestHeader(t,e[t])}if(this._config.chunkSize){var r=this._start+this._config.chunkSize-1;i.setRequestHeader("Range","bytes="+this._start+"-"+r)}try{i.send(this._config.downloadRequestBody)}catch(e){this._chunkError(e.message)}n&&0===i.status&&this._chunkError()}},this._chunkLoaded=function(){4===i.readyState&&(i.status<200||400<=i.status?this._chunkError():(this._start+=this._config.chunkSize?this._config.chunkSize:i.responseText.length,this._finished=!this._config.chunkSize||this._start>=function(e){var t=e.getResponseHeader("Content-Range");if(null===t)return-1;return parseInt(t.substring(t.lastIndexOf("/")+1))}(i),this.parseChunk(i.responseText)))},this._chunkError=function(e){var t=i.statusText||e;this._sendError(new Error(t))}}function c(e){var i,n;(e=e||{}).chunkSize||(e.chunkSize=b.LocalChunkSize),h.call(this,e);var s="undefined"!=typeof FileReader;this.stream=function(e){this._input=e,n=e.slice||e.webkitSlice||e.mozSlice,s?((i=new FileReader).onload=v(this._chunkLoaded,this),i.onerror=v(this._chunkError,this)):i=new FileReaderSync,this._nextChunk()},this._nextChunk=function(){this._finished||this._config.preview&&!(this._rowCount<this._config.preview)||this._readChunk()},this._readChunk=function(){var e=this._input;if(this._config.chunkSize){var t=Math.min(this._start+this._config.chunkSize,this._input.size);e=n.call(e,this._start,t)}var r=i.readAsText(e,this._config.encoding);s||this._chunkLoaded({target:{result:r}})},this._chunkLoaded=function(e){this._start+=this._config.chunkSize,this._finished=!this._config.chunkSize||this._start>=this._input.size,this.parseChunk(e.target.result)},this._chunkError=function(){this._sendError(i.error)}}function p(e){var r;h.call(this,e=e||{}),this.stream=function(e){return r=e,this._nextChunk()},this._nextChunk=function(){if(!this._finished){var e,t=this._config.chunkSize;return t?(e=r.substring(0,t),r=r.substring(t)):(e=r,r=""),this._finished=!r,this.parseChunk(e)}}}function g(e){h.call(this,e=e||{});var t=[],r=!0,i=!1;this.pause=function(){h.prototype.pause.apply(this,arguments),this._input.pause()},this.resume=function(){h.prototype.resume.apply(this,arguments),this._input.resume()},this.stream=function(e){this._input=e,this._input.on("data",this._streamData),this._input.on("end",this._streamEnd),this._input.on("error",this._streamError)},this._checkIsFinished=function(){i&&1===t.length&&(this._finished=!0)},this._nextChunk=function(){this._checkIsFinished(),t.length?this.parseChunk(t.shift()):r=!0},this._streamData=v(function(e){try{t.push("string"==typeof e?e:e.toString(this._config.encoding)),r&&(r=!1,this._checkIsFinished(),this.parseChunk(t.shift()))}catch(e){this._streamError(e)}},this),this._streamError=v(function(e){this._streamCleanUp(),this._sendError(e)},this),this._streamEnd=v(function(){this._streamCleanUp(),i=!0,this._streamData("")},this),this._streamCleanUp=v(function(){this._input.removeListener("data",this._streamData),this._input.removeListener("end",this._streamEnd),this._input.removeListener("error",this._streamError)},this)}function r(m){var a,o,u,i=Math.pow(2,53),n=-i,s=/^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/,h=/^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/,t=this,r=0,f=0,d=!1,e=!1,l=[],c={data:[],errors:[],meta:{}};if(J(m.step)){var p=m.step;m.step=function(e){if(c=e,_())g();else{if(g(),0===c.data.length)return;r+=e.data.length,m.preview&&r>m.preview?o.abort():(c.data=c.data[0],p(c,t))}}}function y(e){return"greedy"===m.skipEmptyLines?""===e.join("").trim():1===e.length&&0===e[0].length}function g(){return c&&u&&(k("Delimiter","UndetectableDelimiter","Unable to auto-detect delimiting character; defaulted to '"+b.DefaultDelimiter+"'"),u=!1),m.skipEmptyLines&&(c.data=c.data.filter(function(e){return!y(e)})),_()&&function(){if(!c)return;function e(e,t){J(m.transformHeader)&&(e=m.transformHeader(e,t)),l.push(e)}if(Array.isArray(c.data[0])){for(var t=0;_()&&t<c.data.length;t++)c.data[t].forEach(e);c.data.splice(0,1)}else c.data.forEach(e)}(),function(){if(!c||!m.header&&!m.dynamicTyping&&!m.transform)return c;function e(e,t){var r,i=m.header?{}:[];for(r=0;r<e.length;r++){var n=r,s=e[r];m.header&&(n=r>=l.length?"__parsed_extra":l[r]),m.transform&&(s=m.transform(s,n)),s=v(n,s),"__parsed_extra"===n?(i[n]=i[n]||[],i[n].push(s)):i[n]=s}return m.header&&(r>l.length?k("FieldMismatch","TooManyFields","Too many fields: expected "+l.length+" fields but parsed "+r,f+t):r<l.length&&k("FieldMismatch","TooFewFields","Too few fields: expected "+l.length+" fields but parsed "+r,f+t)),i}var t=1;!c.data.length||Array.isArray(c.data[0])?(c.data=c.data.map(e),t=c.data.length):c.data=e(c.data,0);m.header&&c.meta&&(c.meta.fields=l);return f+=t,c}()}function _(){return m.header&&0===l.length}function v(e,t){return r=e,m.dynamicTypingFunction&&void 0===m.dynamicTyping[r]&&(m.dynamicTyping[r]=m.dynamicTypingFunction(r)),!0===(m.dynamicTyping[r]||m.dynamicTyping)?"true"===t||"TRUE"===t||"false"!==t&&"FALSE"!==t&&(function(e){if(s.test(e)){var t=parseFloat(e);if(n<t&&t<i)return!0}return!1}(t)?parseFloat(t):h.test(t)?new Date(t):""===t?null:t):t;var r}function k(e,t,r,i){var n={type:e,code:t,message:r};void 0!==i&&(n.row=i),c.errors.push(n)}this.parse=function(e,t,r){var i=m.quoteChar||'"';if(m.newline||(m.newline=function(e,t){e=e.substring(0,1048576);var r=new RegExp(Q(t)+"([^]*?)"+Q(t),"gm"),i=(e=e.replace(r,"")).split("\r"),n=e.split("\n"),s=1<n.length&&n[0].length<i[0].length;if(1===i.length||s)return"\n";for(var a=0,o=0;o<i.length;o++)"\n"===i[o][0]&&a++;return a>=i.length/2?"\r\n":"\r"}(e,i)),u=!1,m.delimiter)J(m.delimiter)&&(m.delimiter=m.delimiter(e),c.meta.delimiter=m.delimiter);else{var n=function(e,t,r,i,n){var s,a,o,u;n=n||[",","\t","|",";",b.RECORD_SEP,b.UNIT_SEP];for(var h=0;h<n.length;h++){var f=n[h],d=0,l=0,c=0;o=void 0;for(var p=new E({comments:i,delimiter:f,newline:t,preview:10}).parse(e),g=0;g<p.data.length;g++)if(r&&y(p.data[g]))c++;else{var _=p.data[g].length;l+=_,void 0!==o?0<_&&(d+=Math.abs(_-o),o=_):o=_}0<p.data.length&&(l/=p.data.length-c),(void 0===a||d<=a)&&(void 0===u||u<l)&&1.99<l&&(a=d,s=f,u=l)}return{successful:!!(m.delimiter=s),bestDelimiter:s}}(e,m.newline,m.skipEmptyLines,m.comments,m.delimitersToGuess);n.successful?m.delimiter=n.bestDelimiter:(u=!0,m.delimiter=b.DefaultDelimiter),c.meta.delimiter=m.delimiter}var s=w(m);return m.preview&&m.header&&s.preview++,a=e,o=new E(s),c=o.parse(a,t,r),g(),d?{meta:{paused:!0}}:c||{meta:{paused:!1}}},this.paused=function(){return d},this.pause=function(){d=!0,o.abort(),a=J(m.chunk)?"":a.substring(o.getCharIndex())},this.resume=function(){t.streamer._halted?(d=!1,t.streamer.parseChunk(a,!0)):setTimeout(t.resume,3)},this.aborted=function(){return e},this.abort=function(){e=!0,o.abort(),c.meta.aborted=!0,J(m.complete)&&m.complete(c),a=""}}function Q(e){return e.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function E(j){var z,M=(j=j||{}).delimiter,P=j.newline,U=j.comments,q=j.step,N=j.preview,B=j.fastMode,K=z=void 0===j.quoteChar||null===j.quoteChar?'"':j.quoteChar;if(void 0!==j.escapeChar&&(K=j.escapeChar),("string"!=typeof M||-1<b.BAD_DELIMITERS.indexOf(M))&&(M=","),U===M)throw new Error("Comment character same as delimiter");!0===U?U="#":("string"!=typeof U||-1<b.BAD_DELIMITERS.indexOf(U))&&(U=!1),"\n"!==P&&"\r"!==P&&"\r\n"!==P&&(P="\n");var W=0,H=!1;this.parse=function(i,t,r){if("string"!=typeof i)throw new Error("Input must be a string");var n=i.length,e=M.length,s=P.length,a=U.length,o=J(q),u=[],h=[],f=[],d=W=0;if(!i)return L();if(j.header&&!t){var l=i.split(P)[0].split(M),c=[],p={},g=!1;for(var _ in l){var m=l[_];J(j.transformHeader)&&(m=j.transformHeader(m,_));var y=m,v=p[m]||0;for(0<v&&(g=!0,y=m+"_"+v),p[m]=v+1;c.includes(y);)y=y+"_"+v;c.push(y)}if(g){var k=i.split(P);k[0]=c.join(M),i=k.join(P)}}if(B||!1!==B&&-1===i.indexOf(z)){for(var b=i.split(P),E=0;E<b.length;E++){if(f=b[E],W+=f.length,E!==b.length-1)W+=P.length;else if(r)return L();if(!U||f.substring(0,a)!==U){if(o){if(u=[],I(f.split(M)),F(),H)return L()}else I(f.split(M));if(N&&N<=E)return u=u.slice(0,N),L(!0)}}return L()}for(var w=i.indexOf(M,W),R=i.indexOf(P,W),C=new RegExp(Q(K)+Q(z),"g"),S=i.indexOf(z,W);;)if(i[W]!==z)if(U&&0===f.length&&i.substring(W,W+a)===U){if(-1===R)return L();W=R+s,R=i.indexOf(P,W),w=i.indexOf(M,W)}else if(-1!==w&&(w<R||-1===R))f.push(i.substring(W,w)),W=w+e,w=i.indexOf(M,W);else{if(-1===R)break;if(f.push(i.substring(W,R)),D(R+s),o&&(F(),H))return L();if(N&&u.length>=N)return L(!0)}else for(S=W,W++;;){if(-1===(S=i.indexOf(z,S+1)))return r||h.push({type:"Quotes",code:"MissingQuotes",message:"Quoted field unterminated",row:u.length,index:W}),T();if(S===n-1)return T(i.substring(W,S).replace(C,z));if(z!==K||i[S+1]!==K){if(z===K||0===S||i[S-1]!==K){-1!==w&&w<S+1&&(w=i.indexOf(M,S+1)),-1!==R&&R<S+1&&(R=i.indexOf(P,S+1));var O=A(-1===R?w:Math.min(w,R));if(i.substr(S+1+O,e)===M){f.push(i.substring(W,S).replace(C,z)),i[W=S+1+O+e]!==z&&(S=i.indexOf(z,W)),w=i.indexOf(M,W),R=i.indexOf(P,W);break}var x=A(R);if(i.substring(S+1+x,S+1+x+s)===P){if(f.push(i.substring(W,S).replace(C,z)),D(S+1+x+s),w=i.indexOf(M,W),S=i.indexOf(z,W),o&&(F(),H))return L();if(N&&u.length>=N)return L(!0);break}h.push({type:"Quotes",code:"InvalidQuotes",message:"Trailing quote on quoted field is malformed",row:u.length,index:W}),S++}}else S++}return T();function I(e){u.push(e),d=W}function A(e){var t=0;if(-1!==e){var r=i.substring(S+1,e);r&&""===r.trim()&&(t=r.length)}return t}function T(e){return r||(void 0===e&&(e=i.substring(W)),f.push(e),W=n,I(f),o&&F()),L()}function D(e){W=e,I(f),f=[],R=i.indexOf(P,W)}function L(e){return{data:u,errors:h,meta:{delimiter:M,linebreak:P,aborted:H,truncated:!!e,cursor:d+(t||0)}}}function F(){q(L()),u=[],h=[]}},this.abort=function(){H=!0},this.getCharIndex=function(){return W}}function _(e){var t=e.data,r=a[t.workerId],i=!1;if(t.error)r.userError(t.error,t.file);else if(t.results&&t.results.data){var n={abort:function(){i=!0,m(t.workerId,{data:[],errors:[],meta:{aborted:!0}})},pause:y,resume:y};if(J(r.userStep)){for(var s=0;s<t.results.data.length&&(r.userStep({data:t.results.data[s],errors:t.results.errors,meta:t.results.meta},n),!i);s++);delete t.results}else J(r.userChunk)&&(r.userChunk(t.results,n,t.file),delete t.results)}t.finished&&!i&&m(t.workerId,t.results)}function m(e,t){var r=a[e];J(r.userComplete)&&r.userComplete(t),r.terminate(),delete a[e]}function y(){throw new Error("Not implemented.")}function w(e){if("object"!=typeof e||null===e)return e;var t=Array.isArray(e)?[]:{};for(var r in e)t[r]=w(e[r]);return t}function v(e,t){return function(){e.apply(t,arguments)}}function J(e){return"function"==typeof e}return o&&(f.onmessage=function(e){var t=e.data;void 0===b.WORKER_ID&&t&&(b.WORKER_ID=t.workerId);if("string"==typeof t.input)f.postMessage({workerId:b.WORKER_ID,results:b.parse(t.input,t.config),finished:!0});else if(f.File&&t.input instanceof File||t.input instanceof Object){var r=b.parse(t.input,t.config);r&&f.postMessage({workerId:b.WORKER_ID,results:r,finished:!0})}}),(l.prototype=Object.create(h.prototype)).constructor=l,(c.prototype=Object.create(h.prototype)).constructor=c,(p.prototype=Object.create(p.prototype)).constructor=p,(g.prototype=Object.create(h.prototype)).constructor=g,b});

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Adds two values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Number}
	 * @see R.subtract
	 * @example
	 *
	 *      R.add(2, 3);       //=>  5
	 *      R.add(7)(10);      //=> 17
	 */
	module.exports = _curry2(function add(a, b) {
	  return Number(a) + Number(b);
	});


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the specified
	 * property with the given value. Note that this copies and flattens prototype
	 * properties onto the new object as well. All non-primitive properties are
	 * copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig String -> a -> {k: v} -> {k: v}
	 * @param {String} prop The property name to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except for the changed property.
	 * @see R.dissoc
	 * @example
	 *
	 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry3(function assoc(prop, val, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  result[prop] = val;
	  return result;
	});


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var curryN = __webpack_require__(80);
	
	
	/**
	 * Returns a curried equivalent of the provided function. The curried function
	 * has two unusual capabilities. First, its arguments needn't be provided one
	 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
	 * the following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> a) -> (* -> a)
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curryN
	 * @example
	 *
	 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
	 *
	 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry1(function curry(fn) {
	  return curryN(fn.length, fn);
	});


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var curry = __webpack_require__(428);
	
	
	/**
	 * Returns a new function much like the supplied one, except that the first two
	 * arguments' order is reversed.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> b -> c -> ... -> z) -> (b -> a -> c -> ... -> z)
	 * @param {Function} fn The function to invoke with its first two parameters reversed.
	 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
	 * @example
	 *
	 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
	 *
	 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
	 * @symb R.flip(f)(a, b, c) = f(b, a, c)
	 */
	module.exports = _curry1(function flip(fn) {
	  return curry(function(a, b) {
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = b;
	    args[1] = a;
	    return fn.apply(this, args);
	  });
	});


/***/ },
/* 430 */
/***/ function(module, exports) {

	module.exports = function _containsWith(pred, x, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    if (pred(x, list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	};


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(135);
	var _isPlaceholder = __webpack_require__(434);
	
	
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curryN(length, received, fn) {
	  return function() {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	      if (combinedIdx < received.length &&
	          (!_isPlaceholder(received[combinedIdx]) ||
	           argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	      combined[combinedIdx] = result;
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	      combinedIdx += 1;
	    }
	    return left <= 0 ? fn.apply(this, combined)
	                     : _arity(left, _curryN(length, combined, fn));
	  };
	};


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _isArray = __webpack_require__(180);
	var _isString = __webpack_require__(308);
	
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @private
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @example
	 *
	 *      _isArrayLike([]); //=> true
	 *      _isArrayLike(true); //=> false
	 *      _isArrayLike({}); //=> false
	 *      _isArrayLike({length: 10}); //=> false
	 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	module.exports = _curry1(function isArrayLike(x) {
	  if (_isArray(x)) { return true; }
	  if (!x) { return false; }
	  if (typeof x !== 'object') { return false; }
	  if (_isString(x)) { return false; }
	  if (x.nodeType === 1) { return !!x.length; }
	  if (x.length === 0) { return true; }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});


/***/ },
/* 433 */
/***/ function(module, exports) {

	module.exports = function _isFunction(x) {
	  return Object.prototype.toString.call(x) === '[object Function]';
	};


/***/ },
/* 434 */
/***/ function(module, exports) {

	module.exports = function _isPlaceholder(a) {
	  return a != null &&
	         typeof a === 'object' &&
	         a['@@functional/placeholder'] === true;
	};


/***/ },
/* 435 */
/***/ function(module, exports) {

	module.exports = function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var map = __webpack_require__(99);
	
	
	/**
	 * Returns a lens for the given getter and setter functions. The getter "gets"
	 * the value of the focus; the setter "sets" the value of the focus. The setter
	 * should not mutate the data structure.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
	 * @param {Function} getter
	 * @param {Function} setter
	 * @return {Lens}
	 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry2(function lens(getter, setter) {
	  return function(toFunctorFn) {
	    return function(target) {
	      return map(
	        function(focus) {
	          return setter(focus, target);
	        },
	        toFunctorFn(getter(target))
	      );
	    };
	  };
	});


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var liftN = __webpack_require__(1463);
	
	
	/**
	 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
	 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.liftN
	 * @example
	 *
	 *      var madd3 = R.lift((a, b, c) => a + b + c);
	 *
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 *
	 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
	 *
	 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
	 */
	module.exports = _curry1(function lift(fn) {
	  return liftN(fn.length, fn);
	});


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var _isObject = __webpack_require__(691);
	var mergeWithKey = __webpack_require__(693);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects.
	 * If a key exists in both objects:
	 * - and both associated values are also objects then the values will be
	 *   recursively merged.
	 * - otherwise the provided function is applied to the key and associated values
	 *   using the resulting value as the new value associated with the key.
	 * If a key only exists in one object, the value will be associated with the key
	 * of the resulting object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.mergeWithKey, R.mergeDeep, R.mergeDeepWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeDeepWithKey(concatValues,
	 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
	 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
	 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
	 */
	module.exports = _curry3(function mergeDeepWithKey(fn, lObj, rObj) {
	  return mergeWithKey(function(k, lVal, rVal) {
	    if (_isObject(lVal) && _isObject(rVal)) {
	      return mergeDeepWithKey(fn, lVal, rVal);
	    } else {
	      return fn(k, lVal, rVal);
	    }
	  }, lObj, rObj);
	});


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly `n` parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} n The desired arity of the new function.
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity `n`.
	 * @see R.binary, R.unary
	 * @example
	 *
	 *      var takesTwoArgs = (a, b) => [a, b];
	 *
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.nAry(1, takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only `n` arguments are passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.nAry(0, f)(a, b) = f()
	 * @symb R.nAry(1, f)(a, b) = f(a)
	 * @symb R.nAry(2, f)(a, b) = f(a, b)
	 */
	module.exports = _curry2(function nAry(n, fn) {
	  switch (n) {
	    case 0: return function() {return fn.call(this);};
	    case 1: return function(a0) {return fn.call(this, a0);};
	    case 2: return function(a0, a1) {return fn.call(this, a0, a1);};
	    case 3: return function(a0, a1, a2) {return fn.call(this, a0, a1, a2);};
	    case 4: return function(a0, a1, a2, a3) {return fn.call(this, a0, a1, a2, a3);};
	    case 5: return function(a0, a1, a2, a3, a4) {return fn.call(this, a0, a1, a2, a3, a4);};
	    case 6: return function(a0, a1, a2, a3, a4, a5) {return fn.call(this, a0, a1, a2, a3, a4, a5);};
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6);};
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);};
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);};
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);};
	    default: throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
	  }
	});


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(431);
	var _dispatchable = __webpack_require__(65);
	var _has = __webpack_require__(90);
	var _reduce = __webpack_require__(112);
	var _xreduceBy = __webpack_require__(3130);
	
	
	/**
	 * Groups the elements of the list according to the result of calling
	 * the String-returning function `keyFn` on each element and reduces the elements
	 * of each group to a single value via the reducer function `valueFn`.
	 *
	 * This function is basically a more general [`groupBy`](#groupBy) function.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
	 * @param {Function} valueFn The function that reduces the elements of each group to a single
	 *        value. Receives two values, accumulator for a particular group and the current element.
	 * @param {*} acc The (initial) accumulator value for each group.
	 * @param {Function} keyFn The function that maps the list's element into a key.
	 * @param {Array} list The array to group.
	 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
	 *         `valueFn` for elements which produced that key when passed to `keyFn`.
	 * @see R.groupBy, R.reduce
	 * @example
	 *
	 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
	 *      var namesByGrade = reduceToNamesBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Lucy', score: 92},
	 *                      {name: 'Drew', score: 85},
	 *                      // ...
	 *                      {name: 'Bart', score: 62}];
	 *      namesByGrade(students);
	 *      // {
	 *      //   'A': ['Lucy'],
	 *      //   'B': ['Drew']
	 *      //   // ...,
	 *      //   'F': ['Bart']
	 *      // }
	 */
	module.exports = _curryN(4, [], _dispatchable([], _xreduceBy,
	  function reduceBy(valueFn, valueAcc, keyFn, list) {
	    return _reduce(function(acc, elt) {
	      var key = keyFn(elt);
	      acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
	      return acc;
	    }, {}, list);
	  }));


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(1449);
	var _curry2 = __webpack_require__(13);
	var filter = __webpack_require__(685);
	
	
	/**
	 * The complement of [`filter`](#filter).
	 *
	 * Acts as a transducer if a transformer is given in list position. Filterable
	 * objects include plain objects or any object that has a filter method such
	 * as `Array`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _isString = __webpack_require__(308);
	
	
	/**
	 * Returns a new list or string with the elements or characters in reverse
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {Array|String}
	 * @example
	 *
	 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	 *      R.reverse([1, 2]);     //=> [2, 1]
	 *      R.reverse([1]);        //=> [1]
	 *      R.reverse([]);         //=> []
	 *
	 *      R.reverse('abc');      //=> 'cba'
	 *      R.reverse('ab');       //=> 'ba'
	 *      R.reverse('a');        //=> 'a'
	 *      R.reverse('');         //=> ''
	 */
	module.exports = _curry1(function reverse(list) {
	  return _isString(list) ? list.split('').reverse().join('') :
	                           Array.prototype.slice.call(list, 0).reverse();
	});


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(208);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chart = exports.defaults = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(76);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _chart = __webpack_require__(2413);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _lodash = __webpack_require__(2977);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChartComponent = function (_React$Component) {
	  _inherits(ChartComponent, _React$Component);
	
	  function ChartComponent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChartComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChartComponent.__proto__ || Object.getPrototypeOf(ChartComponent)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClick = function (event) {
	      var instance = _this.chart_instance;
	
	      var _this$props = _this.props,
	          getDatasetAtEvent = _this$props.getDatasetAtEvent,
	          getElementAtEvent = _this$props.getElementAtEvent,
	          getElementsAtEvent = _this$props.getElementsAtEvent,
	          onElementsClick = _this$props.onElementsClick;
	
	
	      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
	      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
	      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
	      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChartComponent, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.chart_instance = undefined;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderChart();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.redraw) {
	        this.chart_instance.destroy();
	        this.renderChart();
	        return;
	      }
	
	      this.updateChart();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props,
	          redraw = _props.redraw,
	          type = _props.type,
	          options = _props.options,
	          legend = _props.legend,
	          height = _props.height,
	          width = _props.width;
	
	
	      if (nextProps.redraw === true) {
	        return true;
	      }
	
	      if (height !== nextProps.height || width !== nextProps.width) {
	        return true;
	      }
	
	      if (type !== nextProps.type) {
	        return true;
	      }
	
	      if (!(0, _lodash2.default)(legend, nextProps.legend)) {
	        return true;
	      }
	
	      if (!(0, _lodash2.default)(options, nextProps.options)) {
	        return true;
	      }
	
	      return !(0, _lodash2.default)(this.shadowDataProp, nextProps.data);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.chart_instance.destroy();
	    }
	
	    // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
	    // this makes impossible to compare the current and next data changes
	    // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
	    // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617
	
	  }, {
	    key: 'memoizeDataProps',
	    value: function memoizeDataProps() {
	      var data = this.props.data;
	
	
	      if (!data) {
	        return;
	      }
	
	      this.shadowDataProp = _extends({}, data, {
	        datasets: data.datasets && data.datasets.map(function (set) {
	          return Object.assign({}, set);
	        })
	      });
	    }
	  }, {
	    key: 'updateChart',
	    value: function updateChart() {
	      var _props2 = this.props,
	          data = _props2.data,
	          options = _props2.options;
	
	
	      this.memoizeDataProps();
	
	      if (!this.chart_instance) return;
	
	      if (options) {
	        this.chart_instance.options = _chart2.default.helpers.configMerge(this.chart_instance.options, options);
	      }
	
	      // Pipe datasets to chart instance datasets enabling
	      // seamless transitions
	      var currentDatasets = this.chart_instance.config.data && this.chart_instance.config.data.datasets || [];
	      var nextDatasets = data.datasets || [];
	
	      nextDatasets.forEach(function (dataset, sid) {
	        if (currentDatasets[sid] && currentDatasets[sid].data) {
	          currentDatasets[sid].data.splice(nextDatasets[sid].data.length);
	
	          dataset.data.forEach(function (point, pid) {
	            currentDatasets[sid].data[pid] = nextDatasets[sid].data[pid];
	          });
	
	          var _data = dataset.data,
	              otherProps = _objectWithoutProperties(dataset, ['data']);
	
	          currentDatasets[sid] = _extends({
	            data: currentDatasets[sid].data
	          }, currentDatasets[sid], otherProps);
	        } else {
	          currentDatasets[sid] = nextDatasets[sid];
	        }
	      });
	
	      var datasets = data.datasets,
	          rest = _objectWithoutProperties(data, ['datasets']);
	
	      this.chart_instance.config.data = _extends({}, this.chart_instance.config.data, rest);
	
	      this.chart_instance.update();
	    }
	  }, {
	    key: 'renderChart',
	    value: function renderChart() {
	      var _props3 = this.props,
	          data = _props3.data,
	          options = _props3.options,
	          legend = _props3.legend,
	          type = _props3.type,
	          redraw = _props3.redraw;
	
	      var node = _reactDom2.default.findDOMNode(this);
	
	      this.memoizeDataProps();
	
	      this.chart_instance = new _chart2.default(node, {
	        type: type,
	        data: data,
	        options: options
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          height = _props4.height,
	          width = _props4.width,
	          onElementsClick = _props4.onElementsClick;
	
	
	      return _react2.default.createElement('canvas', {
	        height: height,
	        width: width,
	        onClick: this.handleOnClick
	      });
	    }
	  }]);
	
	  return ChartComponent;
	}(_react2.default.Component);
	
	ChartComponent.propTypes = {
	  data: _react.PropTypes.object.isRequired,
	  getDatasetAtEvent: _react.PropTypes.func,
	  getElementAtEvent: _react.PropTypes.func,
	  getElementsAtEvent: _react.PropTypes.func,
	  height: _react.PropTypes.number,
	  legend: _react.PropTypes.object,
	  onElementsClick: _react.PropTypes.func,
	  options: _react.PropTypes.object,
	  redraw: _react.PropTypes.bool,
	  type: _react.PropTypes.oneOf(['doughnut', 'pie', 'line', 'bar', 'horizontalBar', 'radar', 'polarArea', 'bubble']),
	  width: _react.PropTypes.number
	};
	ChartComponent.defaultProps = {
	  legend: {
	    display: true,
	    position: 'bottom'
	  },
	  type: 'doughnut',
	  height: 150,
	  width: 300,
	  redraw: false,
	  options: {}
	};
	exports.default = ChartComponent;
	
	var Doughnut = exports.Doughnut = function (_React$Component2) {
	  _inherits(Doughnut, _React$Component2);
	
	  function Doughnut() {
	    _classCallCheck(this, Doughnut);
	
	    return _possibleConstructorReturn(this, (Doughnut.__proto__ || Object.getPrototypeOf(Doughnut)).apply(this, arguments));
	  }
	
	  _createClass(Doughnut, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref2) {
	          return _this3.chart_instance = _ref2 && _ref2.chart_instance;
	        },
	        type: 'doughnut'
	      }));
	    }
	  }]);
	
	  return Doughnut;
	}(_react2.default.Component);
	
	var Pie = exports.Pie = function (_React$Component3) {
	  _inherits(Pie, _React$Component3);
	
	  function Pie() {
	    _classCallCheck(this, Pie);
	
	    return _possibleConstructorReturn(this, (Pie.__proto__ || Object.getPrototypeOf(Pie)).apply(this, arguments));
	  }
	
	  _createClass(Pie, [{
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref3) {
	          return _this5.chart_instance = _ref3 && _ref3.chart_instance;
	        },
	        type: 'pie'
	      }));
	    }
	  }]);
	
	  return Pie;
	}(_react2.default.Component);
	
	var Line = exports.Line = function (_React$Component4) {
	  _inherits(Line, _React$Component4);
	
	  function Line() {
	    _classCallCheck(this, Line);
	
	    return _possibleConstructorReturn(this, (Line.__proto__ || Object.getPrototypeOf(Line)).apply(this, arguments));
	  }
	
	  _createClass(Line, [{
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref4) {
	          return _this7.chart_instance = _ref4 && _ref4.chart_instance;
	        },
	        type: 'line'
	      }));
	    }
	  }]);
	
	  return Line;
	}(_react2.default.Component);
	
	var Bar = exports.Bar = function (_React$Component5) {
	  _inherits(Bar, _React$Component5);
	
	  function Bar() {
	    _classCallCheck(this, Bar);
	
	    return _possibleConstructorReturn(this, (Bar.__proto__ || Object.getPrototypeOf(Bar)).apply(this, arguments));
	  }
	
	  _createClass(Bar, [{
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref5) {
	          return _this9.chart_instance = _ref5 && _ref5.chart_instance;
	        },
	        type: 'bar'
	      }));
	    }
	  }]);
	
	  return Bar;
	}(_react2.default.Component);
	
	var HorizontalBar = exports.HorizontalBar = function (_React$Component6) {
	  _inherits(HorizontalBar, _React$Component6);
	
	  function HorizontalBar() {
	    _classCallCheck(this, HorizontalBar);
	
	    return _possibleConstructorReturn(this, (HorizontalBar.__proto__ || Object.getPrototypeOf(HorizontalBar)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalBar, [{
	    key: 'render',
	    value: function render() {
	      var _this11 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref6) {
	          return _this11.chart_instance = _ref6 && _ref6.chart_instance;
	        },
	        type: 'horizontalBar'
	      }));
	    }
	  }]);
	
	  return HorizontalBar;
	}(_react2.default.Component);
	
	var Radar = exports.Radar = function (_React$Component7) {
	  _inherits(Radar, _React$Component7);
	
	  function Radar() {
	    _classCallCheck(this, Radar);
	
	    return _possibleConstructorReturn(this, (Radar.__proto__ || Object.getPrototypeOf(Radar)).apply(this, arguments));
	  }
	
	  _createClass(Radar, [{
	    key: 'render',
	    value: function render() {
	      var _this13 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref7) {
	          return _this13.chart_instance = _ref7 && _ref7.chart_instance;
	        },
	        type: 'radar'
	      }));
	    }
	  }]);
	
	  return Radar;
	}(_react2.default.Component);
	
	var Polar = exports.Polar = function (_React$Component8) {
	  _inherits(Polar, _React$Component8);
	
	  function Polar() {
	    _classCallCheck(this, Polar);
	
	    return _possibleConstructorReturn(this, (Polar.__proto__ || Object.getPrototypeOf(Polar)).apply(this, arguments));
	  }
	
	  _createClass(Polar, [{
	    key: 'render',
	    value: function render() {
	      var _this15 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref8) {
	          return _this15.chart_instance = _ref8 && _ref8.chart_instance;
	        },
	        type: 'polarArea'
	      }));
	    }
	  }]);
	
	  return Polar;
	}(_react2.default.Component);
	
	var Bubble = exports.Bubble = function (_React$Component9) {
	  _inherits(Bubble, _React$Component9);
	
	  function Bubble() {
	    _classCallCheck(this, Bubble);
	
	    return _possibleConstructorReturn(this, (Bubble.__proto__ || Object.getPrototypeOf(Bubble)).apply(this, arguments));
	  }
	
	  _createClass(Bubble, [{
	    key: 'render',
	    value: function render() {
	      var _this17 = this;
	
	      return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref9) {
	          return _this17.chart_instance = _ref9 && _ref9.chart_instance;
	        },
	        type: 'bubble'
	      }));
	    }
	  }]);
	
	  return Bubble;
	}(_react2.default.Component);
	
	var defaults = exports.defaults = _chart2.default.defaults;
	exports.Chart = _chart2.default;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(3253));
	var classnames = _interopDefault(__webpack_require__(5));
	var onClickOutside = _interopDefault(__webpack_require__(3372));
	var moment = _interopDefault(__webpack_require__(7));
	var reactPopper = __webpack_require__(3381);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	function generateYears(year, noOfYear, minDate, maxDate) {
	  var list = [];
	  for (var i = 0; i < 2 * noOfYear + 1; i++) {
	    var newYear = year + noOfYear - i;
	    var isInRange = true;
	
	    if (minDate) {
	      isInRange = minDate.year() <= newYear;
	    }
	
	    if (maxDate && isInRange) {
	      isInRange = maxDate.year() >= newYear;
	    }
	
	    if (isInRange) {
	      list.push(newYear);
	    }
	  }
	
	  return list;
	}
	
	var YearDropdownOptions = function (_React$Component) {
	  inherits(YearDropdownOptions, _React$Component);
	
	  function YearDropdownOptions(props) {
	    classCallCheck(this, YearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      var selectedYear = _this.props.year;
	      var options = _this.state.yearsList.map(function (year) {
	        return React.createElement(
	          "div",
	          {
	            className: selectedYear === year ? "react-datepicker__year-option --selected_year" : "react-datepicker__year-option",
	            key: year,
	            ref: year,
	            onClick: _this.onChange.bind(_this, year)
	          },
	          selectedYear === year ? React.createElement(
	            "span",
	            { className: "react-datepicker__year-option--selected" },
	            "\u2713"
	          ) : "",
	          year
	        );
	      });
	
	      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
	      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;
	
	      if (!maxYear || !_this.state.yearsList.find(function (year) {
	        return year === maxYear;
	      })) {
	        options.unshift(React.createElement(
	          "div",
	          {
	            className: "react-datepicker__year-option",
	            ref: "upcoming",
	            key: "upcoming",
	            onClick: _this.incrementYears
	          },
	          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
	        ));
	      }
	
	      if (!minYear || !_this.state.yearsList.find(function (year) {
	        return year === minYear;
	      })) {
	        options.push(React.createElement(
	          "div",
	          {
	            className: "react-datepicker__year-option",
	            ref: "previous",
	            key: "previous",
	            onClick: _this.decrementYears
	          },
	          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
	        ));
	      }
	
	      return options;
	    };
	
	    _this.onChange = function (year) {
	      _this.props.onChange(year);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.shiftYears = function (amount) {
	      var years = _this.state.yearsList.map(function (year) {
	        return year + amount;
	      });
	
	      _this.setState({
	        yearsList: years
	      });
	    };
	
	    _this.incrementYears = function () {
	      return _this.shiftYears(1);
	    };
	
	    _this.decrementYears = function () {
	      return _this.shiftYears(-1);
	    };
	
	    var yearDropdownItemNumber = props.yearDropdownItemNumber,
	        scrollableYearDropdown = props.scrollableYearDropdown;
	
	    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
	
	    _this.state = {
	      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  YearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      "react-datepicker__year-dropdown": true,
	      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
	    });
	
	    return React.createElement(
	      "div",
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return YearDropdownOptions;
	}(React.Component);
	
	YearDropdownOptions.propTypes = {
	  minDate: PropTypes.object,
	  maxDate: PropTypes.object,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number
	};
	
	var dayOfWeekCodes = {
	  1: "mon",
	  2: "tue",
	  3: "wed",
	  4: "thu",
	  5: "fri",
	  6: "sat",
	  7: "sun"
	};
	
	// These functions are not exported so
	// that we avoid magic strings like 'days'
	function set$1(date, unit, to) {
	  return date.set(unit, to);
	}
	
	function add(date, amount, unit) {
	  return date.add(amount, unit);
	}
	
	function subtract(date, amount, unit) {
	  return date.subtract(amount, unit);
	}
	
	function get$1(date, unit) {
	  return date.get(unit);
	}
	
	function getStartOf(date, unit) {
	  return date.startOf(unit);
	}
	
	// ** Date Constructors **
	
	function newDate(point) {
	  return moment(point);
	}
	
	function newDateWithOffset(utcOffset) {
	  return moment().utc().utcOffset(utcOffset);
	}
	
	function now(maybeFixedUtcOffset) {
	  if (maybeFixedUtcOffset == null) {
	    return newDate();
	  }
	  return newDateWithOffset(maybeFixedUtcOffset);
	}
	
	function cloneDate(date) {
	  return date.clone();
	}
	
	function parseDate(value, _ref) {
	  var dateFormat = _ref.dateFormat,
	      locale = _ref.locale;
	
	  var m = moment(value, dateFormat, locale || moment.locale(), true);
	  return m.isValid() ? m : null;
	}
	
	// ** Date "Reflection" **
	
	function isMoment(date) {
	  return moment.isMoment(date);
	}
	
	function isDate(date) {
	  return moment.isDate(date);
	}
	
	// ** Date Formatting **
	
	function formatDate(date, format) {
	  return date.format(format);
	}
	
	function safeDateFormat(date, _ref2) {
	  var dateFormat = _ref2.dateFormat,
	      locale = _ref2.locale;
	
	  return date && date.clone().locale(locale || moment.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
	}
	
	// ** Date Setters **
	
	function setTime(date, _ref3) {
	  var hour = _ref3.hour,
	      minute = _ref3.minute,
	      second = _ref3.second;
	
	  date.set({ hour: hour, minute: minute, second: second });
	  return date;
	}
	
	function setMonth(date, month) {
	  return set$1(date, "month", month);
	}
	
	function setYear(date, year) {
	  return set$1(date, "year", year);
	}
	
	
	
	// ** Date Getters **
	
	function getSecond(date) {
	  return get$1(date, "second");
	}
	
	function getMinute(date) {
	  return get$1(date, "minute");
	}
	
	function getHour(date) {
	  return get$1(date, "hour");
	}
	
	// Returns day of week
	function getDay(date) {
	  return get$1(date, "day");
	}
	
	function getWeek(date) {
	  return get$1(date, "week");
	}
	
	function getMonth(date) {
	  return get$1(date, "month");
	}
	
	function getYear(date) {
	  return get$1(date, "year");
	}
	
	// Returns day of month
	function getDate(date) {
	  return get$1(date, "date");
	}
	
	
	
	function getDayOfWeekCode(day) {
	  return dayOfWeekCodes[day.isoWeekday()];
	}
	
	// *** Start of ***
	
	function getStartOfDay(date) {
	  return getStartOf(date, "day");
	}
	
	function getStartOfWeek(date) {
	  return getStartOf(date, "week");
	}
	function getStartOfMonth(date) {
	  return getStartOf(date, "month");
	}
	
	function getStartOfDate(date) {
	  return getStartOf(date, "date");
	}
	
	// *** End of ***
	
	
	
	
	
	// ** Date Math **
	
	// *** Addition ***
	
	function addMinutes(date, amount) {
	  return add(date, amount, "minutes");
	}
	
	function addHours(date, amount) {
	  return add(date, amount, "hours");
	}
	
	function addDays(date, amount) {
	  return add(date, amount, "days");
	}
	
	function addWeeks(date, amount) {
	  return add(date, amount, "weeks");
	}
	
	function addMonths(date, amount) {
	  return add(date, amount, "months");
	}
	
	function addYears(date, amount) {
	  return add(date, amount, "years");
	}
	
	// *** Subtraction ***
	function subtractDays(date, amount) {
	  return subtract(date, amount, "days");
	}
	
	function subtractWeeks(date, amount) {
	  return subtract(date, amount, "weeks");
	}
	
	function subtractMonths(date, amount) {
	  return subtract(date, amount, "months");
	}
	
	function subtractYears(date, amount) {
	  return subtract(date, amount, "years");
	}
	
	// ** Date Comparison **
	
	function isBefore(date1, date2) {
	  return date1.isBefore(date2);
	}
	
	function isAfter(date1, date2) {
	  return date1.isAfter(date2);
	}
	
	
	
	function isSameYear(date1, date2) {
	  if (date1 && date2) {
	    return date1.isSame(date2, "year");
	  } else {
	    return !date1 && !date2;
	  }
	}
	
	function isSameMonth(date1, date2) {
	  if (date1 && date2) {
	    return date1.isSame(date2, "month");
	  } else {
	    return !date1 && !date2;
	  }
	}
	
	function isSameDay(moment1, moment2) {
	  if (moment1 && moment2) {
	    return moment1.isSame(moment2, "day");
	  } else {
	    return !moment1 && !moment2;
	  }
	}
	
	
	
	function isDayInRange(day, startDate, endDate) {
	  var before = startDate.clone().startOf("day").subtract(1, "seconds");
	  var after = endDate.clone().startOf("day").add(1, "seconds");
	  return day.clone().startOf("day").isBetween(before, after);
	}
	
	// *** Diffing ***
	
	
	
	// ** Date Localization **
	
	function localizeDate(date, locale) {
	  return date.clone().locale(locale || moment.locale());
	}
	
	
	
	
	
	
	
	function getLocaleData(date) {
	  return date.localeData();
	}
	
	function getLocaleDataForLocale(locale) {
	  return moment.localeData(locale);
	}
	
	function getWeekdayMinInLocale(locale, date) {
	  return locale.weekdaysMin(date);
	}
	
	function getWeekdayShortInLocale(locale, date) {
	  return locale.weekdaysShort(date);
	}
	
	// TODO what is this format exactly?
	function getMonthInLocale(locale, date, format) {
	  return locale.months(date, format);
	}
	
	function getMonthShortInLocale(locale, date) {
	  return locale.monthsShort(date);
	}
	
	// ** Utils for some components **
	
	function isDayDisabled(day) {
	  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      minDate = _ref4.minDate,
	      maxDate = _ref4.maxDate,
	      excludeDates = _ref4.excludeDates,
	      includeDates = _ref4.includeDates,
	      filterDate = _ref4.filterDate;
	
	  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
	    return isSameDay(day, excludeDate);
	  }) || includeDates && !includeDates.some(function (includeDate) {
	    return isSameDay(day, includeDate);
	  }) || filterDate && !filterDate(day.clone()) || false;
	}
	
	function isTimeDisabled(time, disabledTimes) {
	  var l = disabledTimes.length;
	  for (var i = 0; i < l; i++) {
	    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isTimeInDisabledRange(time, _ref5) {
	  var minTime = _ref5.minTime,
	      maxTime = _ref5.maxTime;
	
	  if (!minTime || !maxTime) {
	    throw new Error("Both minTime and maxTime props required");
	  }
	
	  var base = moment().hours(0).minutes(0).seconds(0);
	  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
	  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
	  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));
	
	  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
	}
	
	function allDaysDisabledBefore(day, unit) {
	  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      minDate = _ref6.minDate,
	      includeDates = _ref6.includeDates;
	
	  var dateBefore = day.clone().subtract(1, unit);
	  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateBefore.isBefore(includeDate, unit);
	  }) || false;
	}
	
	function allDaysDisabledAfter(day, unit) {
	  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      maxDate = _ref7.maxDate,
	      includeDates = _ref7.includeDates;
	
	  var dateAfter = day.clone().add(1, unit);
	  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateAfter.isAfter(includeDate, unit);
	  }) || false;
	}
	
	function getEffectiveMinDate(_ref8) {
	  var minDate = _ref8.minDate,
	      includeDates = _ref8.includeDates;
	
	  if (includeDates && minDate) {
	    return moment.min(includeDates.filter(function (includeDate) {
	      return minDate.isSameOrBefore(includeDate, "day");
	    }));
	  } else if (includeDates) {
	    return moment.min(includeDates);
	  } else {
	    return minDate;
	  }
	}
	
	function getEffectiveMaxDate(_ref9) {
	  var maxDate = _ref9.maxDate,
	      includeDates = _ref9.includeDates;
	
	  if (includeDates && maxDate) {
	    return moment.max(includeDates.filter(function (includeDate) {
	      return maxDate.isSameOrAfter(includeDate, "day");
	    }));
	  } else if (includeDates) {
	    return moment.max(includeDates);
	  } else {
	    return maxDate;
	  }
	}
	
	function getHightLightDaysMap() {
	  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";
	
	  var dateClasses = new Map();
	  for (var i = 0, len = highlightDates.length; i < len; i++) {
	    var obj = highlightDates[i];
	    if (isMoment(obj)) {
	      var key = obj.format("MM.DD.YYYY");
	      var classNamesArr = dateClasses.get(key) || [];
	      if (!classNamesArr.includes(defaultClassName)) {
	        classNamesArr.push(defaultClassName);
	        dateClasses.set(key, classNamesArr);
	      }
	    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
	      var keys = Object.keys(obj);
	      var className = keys[0];
	      var arrOfMoments = obj[keys[0]];
	      if (typeof className === "string" && arrOfMoments.constructor === Array) {
	        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
	          var _key = arrOfMoments[k].format("MM.DD.YYYY");
	          var _classNamesArr = dateClasses.get(_key) || [];
	          if (!_classNamesArr.includes(className)) {
	            _classNamesArr.push(className);
	            dateClasses.set(_key, _classNamesArr);
	          }
	        }
	      }
	    }
	  }
	
	  return dateClasses;
	}
	
	function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
	  var l = injectedTimes.length;
	  var times = [];
	  for (var i = 0; i < l; i++) {
	    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
	    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);
	
	    if (injectedTime.isBetween(currentTime, nextTime)) {
	      times.push(injectedTimes[i]);
	    }
	  }
	
	  return times;
	}
	
	var WrappedYearDropdownOptions = onClickOutside(YearDropdownOptions);
	
	var YearDropdown = function (_React$Component) {
	  inherits(YearDropdown, _React$Component);
	
	  function YearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, YearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
	      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;
	
	      var options = [];
	      for (var i = minYear; i <= maxYear; i++) {
	        options.push(React.createElement(
	          "option",
	          { key: i, value: i },
	          i
	        ));
	      }
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        "select",
	        {
	          value: _this.props.year,
	          className: "react-datepicker__year-select",
	          onChange: _this.onSelectChange
	        },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__year-read-view",
	          onClick: function onClick(event) {
	            return _this.toggleDropdown(event);
	          }
	        },
	        React.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__year-read-view--selected-year" },
	          _this.props.year
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedYearDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        year: _this.props.year,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	      });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (year) {
	      _this.toggleDropdown();
	      if (year === _this.props.year) return;
	      _this.props.onChange(year);
	    }, _this.toggleDropdown = function (event) {
	      _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      }, function () {
	        if (_this.props.adjustDateOnChange) {
	          _this.handleYearChange(_this.props.date, event);
	        }
	      });
	    }, _this.handleYearChange = function (date, event) {
	      _this.onSelect(date, event);
	      _this.setOpen();
	    }, _this.onSelect = function (date, event) {
	      if (_this.props.onSelect) {
	        _this.props.onSelect(date, event);
	      }
	    }, _this.setOpen = function () {
	      if (_this.props.setOpen) {
	        _this.props.setOpen(true);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  YearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return YearDropdown;
	}(React.Component);
	
	YearDropdown.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number,
	  date: PropTypes.object,
	  onSelect: PropTypes.func,
	  setOpen: PropTypes.func
	};
	
	var MonthDropdownOptions = function (_React$Component) {
	  inherits(MonthDropdownOptions, _React$Component);
	
	  function MonthDropdownOptions() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdownOptions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
	      return _this.props.monthNames.map(function (month, i) {
	        return React.createElement(
	          "div",
	          {
	            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
	            key: month,
	            ref: month,
	            onClick: _this.onChange.bind(_this, i)
	          },
	          _this.props.month === i ? React.createElement(
	            "span",
	            { className: "react-datepicker__month-option--selected" },
	            "\u2713"
	          ) : "",
	          month
	        );
	      });
	    }, _this.onChange = function (month) {
	      return _this.props.onChange(month);
	    }, _this.handleClickOutside = function () {
	      return _this.props.onCancel();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdownOptions.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "react-datepicker__month-dropdown" },
	      this.renderOptions()
	    );
	  };
	
	  return MonthDropdownOptions;
	}(React.Component);
	
	MonthDropdownOptions.propTypes = {
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  month: PropTypes.number.isRequired,
	  monthNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
	};
	
	var WrappedMonthDropdownOptions = onClickOutside(MonthDropdownOptions);
	
	var MonthDropdown = function (_React$Component) {
	  inherits(MonthDropdown, _React$Component);
	
	  function MonthDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function (monthNames) {
	      return monthNames.map(function (M, i) {
	        return React.createElement(
	          "option",
	          { key: i, value: i },
	          M
	        );
	      });
	    }, _this.renderSelectMode = function (monthNames) {
	      return React.createElement(
	        "select",
	        {
	          value: _this.props.month,
	          className: "react-datepicker__month-select",
	          onChange: function onChange(e) {
	            return _this.onChange(e.target.value);
	          }
	        },
	        _this.renderSelectOptions(monthNames)
	      );
	    }, _this.renderReadView = function (visible, monthNames) {
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__month-read-view",
	          onClick: _this.toggleDropdown
	        },
	        React.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__month-read-view--selected-month" },
	          monthNames[_this.props.month]
	        )
	      );
	    }, _this.renderDropdown = function (monthNames) {
	      return React.createElement(WrappedMonthDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        month: _this.props.month,
	        monthNames: monthNames,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown
	      });
	    }, _this.renderScrollMode = function (monthNames) {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown(monthNames));
	      }
	      return result;
	    }, _this.onChange = function (month) {
	      _this.toggleDropdown();
	      if (month !== _this.props.month) {
	        _this.props.onChange(month);
	      }
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdown.prototype.render = function render() {
	    var _this2 = this;
	
	    var localeData = getLocaleDataForLocale(this.props.locale);
	    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
	      return getMonthShortInLocale(localeData, newDate({ M: M }));
	    } : function (M) {
	      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
	    });
	
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode(monthNames);
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode(monthNames);
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return MonthDropdown;
	}(React.Component);
	
	MonthDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  locale: PropTypes.string,
	  dateFormat: PropTypes.string.isRequired,
	  month: PropTypes.number.isRequired,
	  onChange: PropTypes.func.isRequired,
	  useShortMonthInDropdown: PropTypes.bool
	};
	
	function generateMonthYears(minDate, maxDate) {
	  var list = [];
	
	  var currDate = getStartOfMonth(cloneDate(minDate));
	  var lastDate = getStartOfMonth(cloneDate(maxDate));
	
	  while (!isAfter(currDate, lastDate)) {
	    list.push(cloneDate(currDate));
	
	    addMonths(currDate, 1);
	  }
	
	  return list;
	}
	
	var MonthYearDropdownOptions = function (_React$Component) {
	  inherits(MonthYearDropdownOptions, _React$Component);
	
	  function MonthYearDropdownOptions(props) {
	    classCallCheck(this, MonthYearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      return _this.state.monthYearsList.map(function (monthYear) {
	        var monthYearPoint = monthYear.valueOf();
	
	        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);
	
	        return React.createElement(
	          "div",
	          {
	            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
	            key: monthYearPoint,
	            ref: monthYearPoint,
	            onClick: _this.onChange.bind(_this, monthYearPoint)
	          },
	          isSameMonthYear ? React.createElement(
	            "span",
	            { className: "react-datepicker__month-year-option--selected" },
	            "\u2713"
	          ) : "",
	          formatDate(monthYear, _this.props.dateFormat)
	        );
	      });
	    };
	
	    _this.onChange = function (monthYear) {
	      return _this.props.onChange(monthYear);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.state = {
	      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  MonthYearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      "react-datepicker__month-year-dropdown": true,
	      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
	    });
	
	    return React.createElement(
	      "div",
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return MonthYearDropdownOptions;
	}(React.Component);
	
	MonthYearDropdownOptions.propTypes = {
	  minDate: PropTypes.object.isRequired,
	  maxDate: PropTypes.object.isRequired,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  date: PropTypes.object.isRequired,
	  dateFormat: PropTypes.string.isRequired
	};
	
	var WrappedMonthYearDropdownOptions = onClickOutside(MonthYearDropdownOptions);
	
	var MonthYearDropdown = function (_React$Component) {
	  inherits(MonthYearDropdown, _React$Component);
	
	  function MonthYearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthYearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
	      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));
	
	      var options = [];
	
	      while (!isAfter(currDate, lastDate)) {
	        var timepoint = currDate.valueOf();
	        options.push(React.createElement(
	          "option",
	          { key: timepoint, value: timepoint },
	          formatDate(currDate, _this.props.dateFormat)
	        ));
	
	        addMonths(currDate, 1);
	      }
	
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        "select",
	        {
	          value: getStartOfMonth(_this.props.date).valueOf(),
	          className: "react-datepicker__month-year-select",
	          onChange: _this.onSelectChange
	        },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);
	
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__month-year-read-view",
	          onClick: function onClick(event) {
	            return _this.toggleDropdown(event);
	          }
	        },
	        React.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__month-year-read-view--selected-month-year" },
	          yearMonth
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedMonthYearDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        date: _this.props.date,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: localizeDate(_this.props.minDate, _this.props.locale),
	        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
	        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
	      });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (monthYearPoint) {
	      _this.toggleDropdown();
	
	      var changedDate = newDate(parseInt(monthYearPoint));
	
	      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
	        return;
	      }
	
	      _this.props.onChange(changedDate);
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthYearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return MonthYearDropdown;
	}(React.Component);
	
	MonthYearDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  dateFormat: PropTypes.string.isRequired,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object.isRequired,
	  minDate: PropTypes.object.isRequired,
	  date: PropTypes.object.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableMonthYearDropdown: PropTypes.bool
	};
	
	var Day = function (_React$Component) {
	  inherits(Day, _React$Component);
	
	  function Day() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Day);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (!_this.isDisabled() && _this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.isDisabled() && _this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.isSameDay = function (other) {
	      return isSameDay(_this.props.day, other);
	    }, _this.isKeyboardSelected = function () {
	      return !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
	    }, _this.isDisabled = function () {
	      return isDayDisabled(_this.props.day, _this.props);
	    }, _this.getHighLightedClass = function (defaultClassName) {
	      var _this$props = _this.props,
	          day = _this$props.day,
	          highlightDates = _this$props.highlightDates;
	
	
	      if (!highlightDates) {
	        return false;
	      }
	
	      // Looking for className in the Map of {'day string, 'className'}
	      var dayStr = day.format("MM.DD.YYYY");
	      return highlightDates.get(dayStr);
	    }, _this.isInRange = function () {
	      var _this$props2 = _this.props,
	          day = _this$props2.day,
	          startDate = _this$props2.startDate,
	          endDate = _this$props2.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isDayInRange(day, startDate, endDate);
	    }, _this.isInSelectingRange = function () {
	      var _this$props3 = _this.props,
	          day = _this$props3.day,
	          selectsStart = _this$props3.selectsStart,
	          selectsEnd = _this$props3.selectsEnd,
	          selectingDate = _this$props3.selectingDate,
	          startDate = _this$props3.startDate,
	          endDate = _this$props3.endDate;
	
	
	      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
	        return false;
	      }
	
	      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
	        return isDayInRange(day, selectingDate, endDate);
	      }
	
	      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
	        return isDayInRange(day, startDate, selectingDate);
	      }
	
	      return false;
	    }, _this.isSelectingRangeStart = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props4 = _this.props,
	          day = _this$props4.day,
	          selectingDate = _this$props4.selectingDate,
	          startDate = _this$props4.startDate,
	          selectsStart = _this$props4.selectsStart;
	
	
	      if (selectsStart) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, startDate);
	      }
	    }, _this.isSelectingRangeEnd = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props5 = _this.props,
	          day = _this$props5.day,
	          selectingDate = _this$props5.selectingDate,
	          endDate = _this$props5.endDate,
	          selectsEnd = _this$props5.selectsEnd;
	
	
	      if (selectsEnd) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, endDate);
	      }
	    }, _this.isRangeStart = function () {
	      var _this$props6 = _this.props,
	          day = _this$props6.day,
	          startDate = _this$props6.startDate,
	          endDate = _this$props6.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(startDate, day);
	    }, _this.isRangeEnd = function () {
	      var _this$props7 = _this.props,
	          day = _this$props7.day,
	          startDate = _this$props7.startDate,
	          endDate = _this$props7.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(endDate, day);
	    }, _this.isWeekend = function () {
	      var weekday = getDay(_this.props.day);
	      return weekday === 0 || weekday === 6;
	    }, _this.isOutsideMonth = function () {
	      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
	    }, _this.getClassNames = function (date) {
	      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
	      return classnames("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
	        "react-datepicker__day--disabled": _this.isDisabled(),
	        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
	        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
	        "react-datepicker__day--range-start": _this.isRangeStart(),
	        "react-datepicker__day--range-end": _this.isRangeEnd(),
	        "react-datepicker__day--in-range": _this.isInRange(),
	        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
	        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
	        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
	        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
	        "react-datepicker__day--weekend": _this.isWeekend(),
	        "react-datepicker__day--outside-month": _this.isOutsideMonth()
	      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Day.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: this.getClassNames(this.props.day),
	        onClick: this.handleClick,
	        onMouseEnter: this.handleMouseEnter,
	        "aria-label": "day-" + getDate(this.props.day),
	        role: "option"
	      },
	      getDate(this.props.day)
	    );
	  };
	
	  return Day;
	}(React.Component);
	
	Day.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  highlightDates: PropTypes.instanceOf(Map),
	  inline: PropTypes.bool,
	  month: PropTypes.number,
	  onClick: PropTypes.func,
	  onMouseEnter: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var WeekNumber = function (_React$Component) {
	  inherits(WeekNumber, _React$Component);
	
	  function WeekNumber() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, WeekNumber);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  WeekNumber.prototype.render = function render() {
	    var weekNumberClasses = {
	      "react-datepicker__week-number": true,
	      "react-datepicker__week-number--clickable": !!this.props.onClick
	    };
	    return React.createElement(
	      "div",
	      {
	        className: classnames(weekNumberClasses),
	        "aria-label": "week-" + this.props.weekNumber,
	        onClick: this.handleClick
	      },
	      this.props.weekNumber
	    );
	  };
	
	  return WeekNumber;
	}(React.Component);
	
	WeekNumber.propTypes = {
	  weekNumber: PropTypes.number.isRequired,
	  onClick: PropTypes.func
	};
	
	var Week = function (_React$Component) {
	  inherits(Week, _React$Component);
	
	  function Week() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Week);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleWeekClick = function (day, weekNumber, event) {
	      if (typeof _this.props.onWeekSelect === "function") {
	        _this.props.onWeekSelect(day, weekNumber, event);
	      }
	    }, _this.formatWeekNumber = function (startOfWeek) {
	      if (_this.props.formatWeekNumber) {
	        return _this.props.formatWeekNumber(startOfWeek);
	      }
	      return getWeek(startOfWeek);
	    }, _this.renderDays = function () {
	      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
	      var days = [];
	      var weekNumber = _this.formatWeekNumber(startOfWeek);
	      if (_this.props.showWeekNumber) {
	        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
	        days.push(React.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
	      }
	      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        return React.createElement(Day, {
	          key: offset,
	          day: day,
	          month: _this.props.month,
	          onClick: _this.handleDayClick.bind(_this, day),
	          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset
	        });
	      }));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Week.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "react-datepicker__week" },
	      this.renderDays()
	    );
	  };
	
	  return Week;
	}(React.Component);
	
	Week.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  month: PropTypes.number,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumber: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
	
	var Month = function (_React$Component) {
	  inherits(Month, _React$Component);
	
	  function Month() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleMouseLeave = function () {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave();
	      }
	    }, _this.isWeekInMonth = function (startOfWeek) {
	      var day = _this.props.day;
	      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
	      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
	    }, _this.renderWeeks = function () {
	      var weeks = [];
	      var isFixedHeight = _this.props.fixedHeight;
	      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
	      var i = 0;
	      var breakAfterNextPush = false;
	
	      while (true) {
	        weeks.push(React.createElement(Week, {
	          key: i,
	          day: currentWeekStart,
	          month: getMonth(_this.props.day),
	          onDayClick: _this.handleDayClick,
	          onDayMouseEnter: _this.handleDayMouseEnter,
	          onWeekSelect: _this.props.onWeekSelect,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          showWeekNumber: _this.props.showWeekNumbers,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset
	        }));
	
	        if (breakAfterNextPush) break;
	
	        i++;
	        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);
	
	        // If one of these conditions is true, we will either break on this week
	        // or break on the next week
	        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
	        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
	
	        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
	          if (_this.props.peekNextMonth) {
	            breakAfterNextPush = true;
	          } else {
	            break;
	          }
	        }
	      }
	
	      return weeks;
	    }, _this.getClassNames = function () {
	      var _this$props = _this.props,
	          selectingDate = _this$props.selectingDate,
	          selectsStart = _this$props.selectsStart,
	          selectsEnd = _this$props.selectsEnd;
	
	      return classnames("react-datepicker__month", {
	        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Month.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: this.getClassNames(),
	        onMouseLeave: this.handleMouseLeave,
	        role: "listbox"
	      },
	      this.renderWeeks()
	    );
	  };
	
	  return Month;
	}(React.Component);
	
	Month.propTypes = {
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onMouseLeave: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  peekNextMonth: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.number
	};
	
	var Time = function (_React$Component) {
	  inherits(Time, _React$Component);
	
	  function Time() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Time);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
	        return;
	      }
	
	      _this.props.onChange(time);
	    }, _this.liClasses = function (time, currH, currM) {
	      var classes = ["react-datepicker__time-list-item"];
	
	      if (currH === getHour(time) && currM === getMinute(time)) {
	        classes.push("react-datepicker__time-list-item--selected");
	      }
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
	        classes.push("react-datepicker__time-list-item--disabled");
	      }
	      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
	        classes.push("react-datepicker__time-list-item--injected");
	      }
	
	      return classes.join(" ");
	    }, _this.renderTimes = function () {
	      var times = [];
	      var format = _this.props.format ? _this.props.format : "hh:mm A";
	      var intervals = _this.props.intervals;
	      var activeTime = _this.props.selected ? _this.props.selected : newDate();
	      var currH = getHour(activeTime);
	      var currM = getMinute(activeTime);
	      var base = getStartOfDay(newDate());
	      var multiplier = 1440 / intervals;
	      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
	        return a - b;
	      });
	      for (var i = 0; i < multiplier; i++) {
	        var currentTime = addMinutes(cloneDate(base), i * intervals);
	        times.push(currentTime);
	
	        if (sortedInjectTimes) {
	          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
	          times = times.concat(timesToInject);
	        }
	      }
	
	      return times.map(function (time, i) {
	        return React.createElement(
	          "li",
	          {
	            key: i,
	            onClick: _this.handleClick.bind(_this, time),
	            className: _this.liClasses(time, currH, currM)
	          },
	          formatDate(time, format)
	        );
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Time.prototype.componentDidMount = function componentDidMount() {
	    // code to ensure selected time will always be in focus within time window when it first appears
	    var multiplier = 60 / this.props.intervals;
	    var currH = this.props.selected ? getHour(this.props.selected) : getHour(newDate());
	    this.list.scrollTop = 30 * (multiplier * currH);
	  };
	
	  Time.prototype.render = function render() {
	    var _this2 = this;
	
	    var height = null;
	    if (this.props.monthRef) {
	      height = this.props.monthRef.clientHeight - 39;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
	      },
	      React.createElement(
	        "div",
	        { className: "react-datepicker__header react-datepicker__header--time" },
	        React.createElement(
	          "div",
	          { className: "react-datepicker-time__header" },
	          this.props.timeCaption
	        )
	      ),
	      React.createElement(
	        "div",
	        { className: "react-datepicker__time" },
	        React.createElement(
	          "div",
	          { className: "react-datepicker__time-box" },
	          React.createElement(
	            "ul",
	            {
	              className: "react-datepicker__time-list",
	              ref: function ref(list) {
	                _this2.list = list;
	              },
	              style: height ? { height: height } : {}
	            },
	            this.renderTimes.bind(this)()
	          )
	        )
	      )
	    );
	  };
	
	  createClass(Time, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        intervals: 30,
	        onTimeChange: function onTimeChange() {},
	        todayButton: null,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	  return Time;
	}(React.Component);
	
	Time.propTypes = {
	  format: PropTypes.string,
	  includeTimes: PropTypes.array,
	  intervals: PropTypes.number,
	  selected: PropTypes.object,
	  onChange: PropTypes.func,
	  todayButton: PropTypes.string,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  monthRef: PropTypes.object,
	  timeCaption: PropTypes.string,
	  injectTimes: PropTypes.array
	};
	
	var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];
	
	var isDropdownSelect = function isDropdownSelect() {
	  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var classNames = (element.className || "").split(/\s+/);
	  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
	    return classNames.indexOf(testClassname) >= 0;
	  });
	};
	
	var Calendar = function (_React$Component) {
	  inherits(Calendar, _React$Component);
	  createClass(Calendar, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        onDropdownFocus: function onDropdownFocus() {},
	        monthsShown: 1,
	        forceShowMonthNavigation: false,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	
	  function Calendar(props) {
	    classCallCheck(this, Calendar);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleClickOutside = function (event) {
	      _this.props.onClickOutside(event);
	    };
	
	    _this.handleDropdownFocus = function (event) {
	      if (isDropdownSelect(event.target)) {
	        _this.props.onDropdownFocus();
	      }
	    };
	
	    _this.getDateInView = function () {
	      var _this$props = _this.props,
	          preSelection = _this$props.preSelection,
	          selected = _this$props.selected,
	          openToDate = _this$props.openToDate,
	          utcOffset = _this$props.utcOffset;
	
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var current = now(utcOffset);
	      var initialDate = openToDate || selected || preSelection;
	      if (initialDate) {
	        return initialDate;
	      } else {
	        if (minDate && isBefore(current, minDate)) {
	          return minDate;
	        } else if (maxDate && isAfter(current, maxDate)) {
	          return maxDate;
	        }
	      }
	      return current;
	    };
	
	    _this.localizeDate = function (date) {
	      return localizeDate(date, _this.props.locale);
	    };
	
	    _this.increaseMonth = function () {
	      _this.setState({
	        date: addMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.decreaseMonth = function () {
	      _this.setState({
	        date: subtractMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.handleDayClick = function (day, event) {
	      return _this.props.onSelect(day, event);
	    };
	
	    _this.handleDayMouseEnter = function (day) {
	      return _this.setState({ selectingDate: day });
	    };
	
	    _this.handleMonthMouseLeave = function () {
	      return _this.setState({ selectingDate: null });
	    };
	
	    _this.handleYearChange = function (date) {
	      if (_this.props.onYearChange) {
	        _this.props.onYearChange(date);
	      }
	    };
	
	    _this.handleMonthChange = function (date) {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(date);
	      }
	      if (_this.props.adjustDateOnChange) {
	        if (_this.props.onSelect) {
	          _this.props.onSelect(date);
	        }
	        if (_this.props.setOpen) {
	          _this.props.setOpen(true);
	        }
	      }
	    };
	
	    _this.handleMonthYearChange = function (date) {
	      _this.handleYearChange(date);
	      _this.handleMonthChange(date);
	    };
	
	    _this.changeYear = function (year) {
	      _this.setState({
	        date: setYear(cloneDate(_this.state.date), year)
	      }, function () {
	        return _this.handleYearChange(_this.state.date);
	      });
	    };
	
	    _this.changeMonth = function (month) {
	      _this.setState({
	        date: setMonth(cloneDate(_this.state.date), month)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.changeMonthYear = function (monthYear) {
	      _this.setState({
	        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
	      }, function () {
	        return _this.handleMonthYearChange(_this.state.date);
	      });
	    };
	
	    _this.header = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var startOfWeek = getStartOfWeek(cloneDate(date));
	      var dayNames = [];
	      if (_this.props.showWeekNumbers) {
	        dayNames.push(React.createElement(
	          "div",
	          { key: "W", className: "react-datepicker__day-name" },
	          _this.props.weekLabel || "#"
	        ));
	      }
	      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        var localeData = getLocaleData(day);
	        var weekDayName = _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
	        return React.createElement(
	          "div",
	          { key: offset, className: "react-datepicker__day-name" },
	          weekDayName
	        );
	      }));
	    };
	
	    _this.renderPreviousMonthButton = function () {
	      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);
	
	      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];
	
	      var clickHandler = _this.decreaseMonth;
	
	      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
	        classes.push("react-datepicker__navigation--previous--disabled");
	        clickHandler = null;
	      }
	
	      return React.createElement("button", {
	        type: "button",
	        className: classes.join(" "),
	        onClick: clickHandler
	      });
	    };
	
	    _this.renderNextMonthButton = function () {
	      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);
	
	      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
	      if (_this.props.showTimeSelect) {
	        classes.push("react-datepicker__navigation--next--with-time");
	      }
	      if (_this.props.todayButton) {
	        classes.push("react-datepicker__navigation--next--with-today-button");
	      }
	
	      var clickHandler = _this.increaseMonth;
	
	      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
	        classes.push("react-datepicker__navigation--next--disabled");
	        clickHandler = null;
	      }
	
	      return React.createElement("button", {
	        type: "button",
	        className: classes.join(" "),
	        onClick: clickHandler
	      });
	    };
	
	    _this.renderCurrentMonth = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var classes = ["react-datepicker__current-month"];
	
	      if (_this.props.showYearDropdown) {
	        classes.push("react-datepicker__current-month--hasYearDropdown");
	      }
	      if (_this.props.showMonthDropdown) {
	        classes.push("react-datepicker__current-month--hasMonthDropdown");
	      }
	      if (_this.props.showMonthYearDropdown) {
	        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
	      }
	      return React.createElement(
	        "div",
	        { className: classes.join(" ") },
	        formatDate(date, _this.props.dateFormat)
	      );
	    };
	
	    _this.renderYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(YearDropdown, {
	        adjustDateOnChange: _this.props.adjustDateOnChange,
	        date: _this.state.date,
	        onSelect: _this.props.onSelect,
	        setOpen: _this.props.setOpen,
	        dropdownMode: _this.props.dropdownMode,
	        onChange: _this.changeYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        year: getYear(_this.state.date),
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	      });
	    };
	
	    _this.renderMonthDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showMonthDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(MonthDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonth,
	        month: getMonth(_this.state.date),
	        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
	      });
	    };
	
	    _this.renderMonthYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showMonthYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(MonthYearDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonthYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        date: _this.state.date,
	        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
	      });
	    };
	
	    _this.renderTodayButton = function () {
	      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
	        return;
	      }
	      return React.createElement(
	        "div",
	        {
	          className: "react-datepicker__today-button",
	          onClick: function onClick(e) {
	            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
	          }
	        },
	        _this.props.todayButton
	      );
	    };
	
	    _this.renderMonths = function () {
	      if (_this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var monthList = [];
	      for (var i = 0; i < _this.props.monthsShown; ++i) {
	        var monthDate = addMonths(cloneDate(_this.state.date), i);
	        var monthKey = "month-" + i;
	        monthList.push(React.createElement(
	          "div",
	          {
	            key: monthKey,
	            ref: function ref(div) {
	              _this.monthContainer = div;
	            },
	            className: "react-datepicker__month-container"
	          },
	          React.createElement(
	            "div",
	            { className: "react-datepicker__header" },
	            _this.renderCurrentMonth(monthDate),
	            React.createElement(
	              "div",
	              {
	                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
	                onFocus: _this.handleDropdownFocus
	              },
	              _this.renderMonthDropdown(i !== 0),
	              _this.renderMonthYearDropdown(i !== 0),
	              _this.renderYearDropdown(i !== 0)
	            ),
	            React.createElement(
	              "div",
	              { className: "react-datepicker__day-names" },
	              _this.header(monthDate)
	            )
	          ),
	          React.createElement(Month, {
	            day: monthDate,
	            dayClassName: _this.props.dayClassName,
	            onDayClick: _this.handleDayClick,
	            onDayMouseEnter: _this.handleDayMouseEnter,
	            onMouseLeave: _this.handleMonthMouseLeave,
	            onWeekSelect: _this.props.onWeekSelect,
	            formatWeekNumber: _this.props.formatWeekNumber,
	            minDate: _this.props.minDate,
	            maxDate: _this.props.maxDate,
	            excludeDates: _this.props.excludeDates,
	            highlightDates: _this.props.highlightDates,
	            selectingDate: _this.state.selectingDate,
	            includeDates: _this.props.includeDates,
	            inline: _this.props.inline,
	            fixedHeight: _this.props.fixedHeight,
	            filterDate: _this.props.filterDate,
	            preSelection: _this.props.preSelection,
	            selected: _this.props.selected,
	            selectsStart: _this.props.selectsStart,
	            selectsEnd: _this.props.selectsEnd,
	            showWeekNumbers: _this.props.showWeekNumbers,
	            startDate: _this.props.startDate,
	            endDate: _this.props.endDate,
	            peekNextMonth: _this.props.peekNextMonth,
	            utcOffset: _this.props.utcOffset
	          })
	        ));
	      }
	      return monthList;
	    };
	
	    _this.renderTimeSection = function () {
	      if (_this.props.showTimeSelect) {
	        return React.createElement(Time, {
	          selected: _this.props.selected,
	          onChange: _this.props.onTimeChange,
	          format: _this.props.timeFormat,
	          includeTimes: _this.props.includeTimes,
	          intervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          timeCaption: _this.props.timeCaption,
	          todayButton: _this.props.todayButton,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          showMonthYearDropdown: _this.props.showMonthYearDropdown,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          monthRef: _this.state.monthContainer,
	          injectTimes: _this.props.injectTimes
	        });
	      }
	    };
	
	    _this.state = {
	      date: _this.localizeDate(_this.getDateInView()),
	      selectingDate: null,
	      monthContainer: _this.monthContainer
	    };
	    return _this;
	  }
	
	  Calendar.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    // monthContainer height is needed in time component
	    // to determine the height for the ul in the time component
	    // setState here so height is given after final component
	    // layout is rendered
	    if (this.props.showTimeSelect) {
	      this.assignMonthContainer = function () {
	        _this2.setState({ monthContainer: _this2.monthContainer });
	      }();
	    }
	  };
	
	  Calendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.preSelection && !isSameDay(nextProps.preSelection, this.props.preSelection)) {
	      this.setState({
	        date: this.localizeDate(nextProps.preSelection)
	      });
	    } else if (nextProps.openToDate && !isSameDay(nextProps.openToDate, this.props.openToDate)) {
	      this.setState({
	        date: this.localizeDate(nextProps.openToDate)
	      });
	    }
	  };
	
	  Calendar.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: classnames("react-datepicker", this.props.className, {
	          "react-datepicker--time-only": this.props.showTimeSelectOnly
	        })
	      },
	      React.createElement("div", { className: "react-datepicker__triangle" }),
	      this.renderPreviousMonthButton(),
	      this.renderNextMonthButton(),
	      this.renderMonths(),
	      this.renderTodayButton(),
	      this.renderTimeSection(),
	      this.props.children
	    );
	  };
	
	  return Calendar;
	}(React.Component);
	
	Calendar.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  className: PropTypes.string,
	  children: PropTypes.node,
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
	  dayClassName: PropTypes.func,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]),
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  includeTimes: PropTypes.array,
	  injectTimes: PropTypes.array,
	  inline: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  onClickOutside: PropTypes.func.isRequired,
	  onMonthChange: PropTypes.func,
	  onYearChange: PropTypes.func,
	  forceShowMonthNavigation: PropTypes.bool,
	  onDropdownFocus: PropTypes.func,
	  onSelect: PropTypes.func.isRequired,
	  onWeekSelect: PropTypes.func,
	  showTimeSelect: PropTypes.bool,
	  showTimeSelectOnly: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  onTimeChange: PropTypes.func,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  timeCaption: PropTypes.string,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showMonthYearDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  startDate: PropTypes.object,
	  todayButton: PropTypes.string,
	  useWeekdaysShort: PropTypes.bool,
	  withPortal: PropTypes.bool,
	  utcOffset: PropTypes.number,
	  weekLabel: PropTypes.string,
	  yearDropdownItemNumber: PropTypes.number,
	  setOpen: PropTypes.func,
	  useShortMonthInDropdown: PropTypes.bool,
	  showDisabledMonthNavigation: PropTypes.bool
	};
	
	var popperPlacementPositions = ["auto", "auto-left", "auto-right", "bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];
	
	var PopperComponent = function (_React$Component) {
	  inherits(PopperComponent, _React$Component);
	
	  function PopperComponent() {
	    classCallCheck(this, PopperComponent);
	    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PopperComponent.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        hidePopper = _props.hidePopper,
	        popperComponent = _props.popperComponent,
	        popperModifiers = _props.popperModifiers,
	        popperPlacement = _props.popperPlacement,
	        targetComponent = _props.targetComponent;
	
	
	    var popper = void 0;
	
	    if (!hidePopper) {
	      var classes = classnames("react-datepicker-popper", className);
	      popper = React.createElement(
	        reactPopper.Popper,
	        {
	          className: classes,
	          modifiers: popperModifiers,
	          placement: popperPlacement
	        },
	        popperComponent
	      );
	    }
	
	    if (this.props.popperContainer) {
	      popper = React.createElement(this.props.popperContainer, {}, popper);
	    }
	
	    return React.createElement(
	      reactPopper.Manager,
	      null,
	      React.createElement(
	        reactPopper.Target,
	        { className: "react-datepicker-wrapper" },
	        targetComponent
	      ),
	      popper
	    );
	  };
	
	  createClass(PopperComponent, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        hidePopper: true,
	        popperModifiers: {
	          preventOverflow: {
	            enabled: true,
	            escapeWithReference: true,
	            boundariesElement: "viewport"
	          }
	        },
	        popperPlacement: "bottom-start"
	      };
	    }
	  }]);
	  return PopperComponent;
	}(React.Component);
	
	PopperComponent.propTypes = {
	  className: PropTypes.string,
	  hidePopper: PropTypes.bool,
	  popperComponent: PropTypes.element,
	  popperModifiers: PropTypes.object, // <datepicker/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <datepicker/> props
	  popperContainer: PropTypes.func,
	  targetComponent: PropTypes.element
	};
	
	var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
	var WrappedCalendar = onClickOutside(Calendar);
	
	// Compares dates year+month combinations
	function hasPreSelectionChanged(date1, date2) {
	  if (date1 && date2) {
	    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
	  }
	
	  return date1 !== date2;
	}
	
	/**
	 * General datepicker component.
	 */
	
	var DatePicker = function (_React$Component) {
	  inherits(DatePicker, _React$Component);
	  createClass(DatePicker, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        allowSameDay: false,
	        dateFormat: "L",
	        dateFormatCalendar: "MMMM YYYY",
	        onChange: function onChange() {},
	
	        disabled: false,
	        disabledKeyboardNavigation: false,
	        dropdownMode: "scroll",
	        onFocus: function onFocus() {},
	        onBlur: function onBlur() {},
	        onKeyDown: function onKeyDown() {},
	        onSelect: function onSelect() {},
	        onClickOutside: function onClickOutside$$1() {},
	        onMonthChange: function onMonthChange() {},
	
	        preventOpenOnFocus: false,
	        onYearChange: function onYearChange() {},
	
	        monthsShown: 1,
	        withPortal: false,
	        shouldCloseOnSelect: true,
	        showTimeSelect: false,
	        timeIntervals: 30,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	
	  function DatePicker(props) {
	    classCallCheck(this, DatePicker);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.getPreSelection = function () {
	      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
	    };
	
	    _this.calcInitialState = function () {
	      var defaultPreSelection = _this.getPreSelection();
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
	      return {
	        open: _this.props.startOpen || false,
	        preventFocus: false,
	        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
	        // transforming highlighted days (perhaps nested array)
	        // to flat Map for faster access in day.jsx
	        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
	        focused: false
	      };
	    };
	
	    _this.clearPreventFocusTimeout = function () {
	      if (_this.preventFocusTimeout) {
	        clearTimeout(_this.preventFocusTimeout);
	      }
	    };
	
	    _this.setFocus = function () {
	      if (_this.input && _this.input.focus) {
	        _this.input.focus();
	      }
	    };
	
	    _this.setOpen = function (open) {
	      _this.setState({
	        open: open,
	        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection
	      });
	    };
	
	    _this.handleFocus = function (event) {
	      if (!_this.state.preventFocus) {
	        _this.props.onFocus(event);
	        if (!_this.props.preventOpenOnFocus) {
	          _this.setOpen(true);
	        }
	      }
	      _this.setState({ focused: true });
	    };
	
	    _this.cancelFocusInput = function () {
	      clearTimeout(_this.inputFocusTimeout);
	      _this.inputFocusTimeout = null;
	    };
	
	    _this.deferFocusInput = function () {
	      _this.cancelFocusInput();
	      _this.inputFocusTimeout = setTimeout(function () {
	        return _this.setFocus();
	      }, 1);
	    };
	
	    _this.handleDropdownFocus = function () {
	      _this.cancelFocusInput();
	    };
	
	    _this.handleBlur = function (event) {
	      if (_this.state.open) {
	        _this.deferFocusInput();
	      } else {
	        _this.props.onBlur(event);
	      }
	      _this.setState({ focused: false });
	    };
	
	    _this.handleCalendarClickOutside = function (event) {
	      if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	      _this.props.onClickOutside(event);
	      if (_this.props.withPortal) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleChange = function () {
	      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
	        allArgs[_key] = arguments[_key];
	      }
	
	      var event = allArgs[0];
	      if (_this.props.onChangeRaw) {
	        _this.props.onChangeRaw.apply(_this, allArgs);
	        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
	          return;
	        }
	      }
	      _this.setState({ inputValue: event.target.value });
	      var date = parseDate(event.target.value, _this.props);
	      if (date || !event.target.value) {
	        _this.setSelected(date, event, true);
	      }
	    };
	
	    _this.handleSelect = function (date, event) {
	      // Preventing onFocus event to fix issue
	      // https://github.com/Hacker0x01/react-datepicker/issues/628
	      _this.setState({ preventFocus: true }, function () {
	        _this.preventFocusTimeout = setTimeout(function () {
	          return _this.setState({ preventFocus: false });
	        }, 50);
	        return _this.preventFocusTimeout;
	      });
	      _this.setSelected(date, event);
	      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
	        _this.setPreSelection(date);
	      } else if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	    };
	
	    _this.setSelected = function (date, event, keepInput) {
	      var changedDate = date;
	
	      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
	        return;
	      }
	
	      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
	        if (changedDate !== null) {
	          if (_this.props.selected) {
	            var selected = _this.props.selected;
	            if (keepInput) selected = newDate(changedDate);
	            changedDate = setTime(newDate(changedDate), {
	              hour: getHour(selected),
	              minute: getMinute(selected),
	              second: getSecond(selected)
	            });
	          }
	          _this.setState({
	            preSelection: changedDate
	          });
	        }
	        _this.props.onChange(changedDate, event);
	      }
	
	      _this.props.onSelect(changedDate, event);
	
	      if (!keepInput) {
	        _this.setState({ inputValue: null });
	      }
	    };
	
	    _this.setPreSelection = function (date) {
	      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
	      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
	      if (isValidDateSelection) {
	        _this.setState({
	          preSelection: date
	        });
	      }
	    };
	
	    _this.handleTimeChange = function (time) {
	      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
	      var changedDate = setTime(cloneDate(selected), {
	        hour: getHour(time),
	        minute: getMinute(time)
	      });
	
	      _this.setState({
	        preSelection: changedDate
	      });
	
	      _this.props.onChange(changedDate);
	      _this.setOpen(false);
	      _this.setState({ inputValue: null });
	    };
	
	    _this.onInputClick = function () {
	      if (!_this.props.disabled) {
	        _this.setOpen(true);
	      }
	    };
	
	    _this.onInputKeyDown = function (event) {
	      _this.props.onKeyDown(event);
	      var eventKey = event.key;
	      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
	        if (eventKey !== "Enter" && eventKey !== "Escape" && eventKey !== "Tab") {
	          _this.onInputClick();
	        }
	        return;
	      }
	      var copy = newDate(_this.state.preSelection);
	      if (eventKey === "Enter") {
	        event.preventDefault();
	        if (isMoment(_this.state.preSelection) || isDate(_this.state.preSelection)) {
	          _this.handleSelect(copy, event);
	          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
	        } else {
	          _this.setOpen(false);
	        }
	      } else if (eventKey === "Escape") {
	        event.preventDefault();
	        _this.setOpen(false);
	      } else if (eventKey === "Tab") {
	        _this.setOpen(false);
	      } else if (!_this.props.disabledKeyboardNavigation) {
	        var newSelection = void 0;
	        switch (eventKey) {
	          case "ArrowLeft":
	            event.preventDefault();
	            newSelection = subtractDays(copy, 1);
	            break;
	          case "ArrowRight":
	            event.preventDefault();
	            newSelection = addDays(copy, 1);
	            break;
	          case "ArrowUp":
	            event.preventDefault();
	            newSelection = subtractWeeks(copy, 1);
	            break;
	          case "ArrowDown":
	            event.preventDefault();
	            newSelection = addWeeks(copy, 1);
	            break;
	          case "PageUp":
	            event.preventDefault();
	            newSelection = subtractMonths(copy, 1);
	            break;
	          case "PageDown":
	            event.preventDefault();
	            newSelection = addMonths(copy, 1);
	            break;
	          case "Home":
	            event.preventDefault();
	            newSelection = subtractYears(copy, 1);
	            break;
	          case "End":
	            event.preventDefault();
	            newSelection = addYears(copy, 1);
	            break;
	        }
	        if (_this.props.adjustDateOnChange) {
	          _this.setSelected(newSelection);
	        }
	        _this.setPreSelection(newSelection);
	      }
	    };
	
	    _this.onClearClick = function (event) {
	      if (event) {
	        if (event.preventDefault) {
	          event.preventDefault();
	        }
	      }
	      _this.props.onChange(null, event);
	      _this.setState({ inputValue: null });
	    };
	
	    _this.clear = function () {
	      _this.onClearClick();
	    };
	
	    _this.renderCalendar = function () {
	      if (!_this.props.inline && (!_this.state.open || _this.props.disabled)) {
	        return null;
	      }
	      return React.createElement(
	        WrappedCalendar,
	        {
	          ref: function ref(elem) {
	            _this.calendar = elem;
	          },
	          locale: _this.props.locale,
	          adjustDateOnChange: _this.props.adjustDateOnChange,
	          setOpen: _this.setOpen,
	          dateFormat: _this.props.dateFormatCalendar,
	          useWeekdaysShort: _this.props.useWeekdaysShort,
	          dropdownMode: _this.props.dropdownMode,
	          selected: _this.props.selected,
	          preSelection: _this.state.preSelection,
	          onSelect: _this.handleSelect,
	          onWeekSelect: _this.props.onWeekSelect,
	          openToDate: _this.props.openToDate,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          excludeDates: _this.props.excludeDates,
	          filterDate: _this.props.filterDate,
	          onClickOutside: _this.handleCalendarClickOutside,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          highlightDates: _this.state.highlightDates,
	          includeDates: _this.props.includeDates,
	          includeTimes: _this.props.includeTimes,
	          injectTimes: _this.props.injectTimes,
	          inline: _this.props.inline,
	          peekNextMonth: _this.props.peekNextMonth,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
	          showMonthYearDropdown: _this.props.showMonthYearDropdown,
	          showWeekNumbers: _this.props.showWeekNumbers,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
	          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
	          scrollableYearDropdown: _this.props.scrollableYearDropdown,
	          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
	          todayButton: _this.props.todayButton,
	          weekLabel: _this.props.weekLabel,
	          utcOffset: _this.props.utcOffset,
	          outsideClickIgnoreClass: outsideClickIgnoreClass,
	          fixedHeight: _this.props.fixedHeight,
	          monthsShown: _this.props.monthsShown,
	          onDropdownFocus: _this.handleDropdownFocus,
	          onMonthChange: _this.props.onMonthChange,
	          onYearChange: _this.props.onYearChange,
	          dayClassName: _this.props.dayClassName,
	          showTimeSelect: _this.props.showTimeSelect,
	          showTimeSelectOnly: _this.props.showTimeSelectOnly,
	          onTimeChange: _this.handleTimeChange,
	          timeFormat: _this.props.timeFormat,
	          timeIntervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          timeCaption: _this.props.timeCaption,
	          className: _this.props.calendarClassName,
	          yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	        },
	        _this.props.children
	      );
	    };
	
	    _this.renderDateInput = function () {
	      var _classnames, _React$cloneElement;
	
	      var className = classnames(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));
	
	      var customInput = _this.props.customInput || React.createElement("input", { type: "text" });
	      var customInputRef = _this.props.customInputRef || "ref";
	      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);
	
	      return React.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
	        _this.input = input;
	      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
	    };
	
	    _this.renderClearButton = function () {
	      if (_this.props.isClearable && _this.props.selected != null) {
	        return React.createElement("button", {
	          className: "react-datepicker__close-icon",
	          onClick: _this.onClearClick,
	          title: _this.props.clearButtonTitle,
	          tabIndex: -1
	        });
	      } else {
	        return null;
	      }
	    };
	
	    _this.state = _this.calcInitialState();
	    return _this;
	  }
	
	  DatePicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.inline && hasPreSelectionChanged(this.props.selected, nextProps.selected)) {
	      this.setPreSelection(nextProps.selected);
	    }
	    if (this.props.highlightDates !== nextProps.highlightDates) {
	      this.setState({
	        highlightDates: getHightLightDaysMap(nextProps.highlightDates)
	      });
	    }
	    if (!this.state.focused) this.setState({ inputValue: null });
	  };
	
	  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearPreventFocusTimeout();
	  };
	
	  DatePicker.prototype.render = function render() {
	    var calendar = this.renderCalendar();
	
	    if (this.props.inline && !this.props.withPortal) {
	      return calendar;
	    }
	
	    if (this.props.withPortal) {
	      return React.createElement(
	        "div",
	        null,
	        !this.props.inline ? React.createElement(
	          "div",
	          { className: "react-datepicker__input-container" },
	          this.renderDateInput(),
	          this.renderClearButton()
	        ) : null,
	        this.state.open || this.props.inline ? React.createElement(
	          "div",
	          { className: "react-datepicker__portal" },
	          calendar
	        ) : null
	      );
	    }
	
	    return React.createElement(PopperComponent, {
	      className: this.props.popperClassName,
	      hidePopper: !this.state.open || this.props.disabled,
	      popperModifiers: this.props.popperModifiers,
	      targetComponent: React.createElement(
	        "div",
	        { className: "react-datepicker__input-container" },
	        this.renderDateInput(),
	        this.renderClearButton()
	      ),
	      popperContainer: this.props.popperContainer,
	      popperComponent: calendar,
	      popperPlacement: this.props.popperPlacement
	    });
	  };
	
	  return DatePicker;
	}(React.Component);
	
	DatePicker.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  allowSameDay: PropTypes.bool,
	  autoComplete: PropTypes.string,
	  autoFocus: PropTypes.bool,
	  calendarClassName: PropTypes.string,
	  children: PropTypes.node,
	  className: PropTypes.string,
	  customInput: PropTypes.element,
	  customInputRef: PropTypes.string,
	  // eslint-disable-next-line react/no-unused-prop-types
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	  dateFormatCalendar: PropTypes.string,
	  dayClassName: PropTypes.func,
	  disabled: PropTypes.bool,
	  disabledKeyboardNavigation: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.array,
	  id: PropTypes.string,
	  includeDates: PropTypes.array,
	  includeTimes: PropTypes.array,
	  injectTimes: PropTypes.array,
	  inline: PropTypes.bool,
	  isClearable: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  name: PropTypes.string,
	  onBlur: PropTypes.func,
	  onChange: PropTypes.func.isRequired,
	  onSelect: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  onClickOutside: PropTypes.func,
	  onChangeRaw: PropTypes.func,
	  onFocus: PropTypes.func,
	  onKeyDown: PropTypes.func,
	  onMonthChange: PropTypes.func,
	  onYearChange: PropTypes.func,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  placeholderText: PropTypes.string,
	  popperContainer: PropTypes.func,
	  popperClassName: PropTypes.string, // <PopperComponent/> props
	  popperModifiers: PropTypes.object, // <PopperComponent/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <PopperComponent/> props
	  preventOpenOnFocus: PropTypes.bool,
	  readOnly: PropTypes.bool,
	  required: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showMonthYearDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  forceShowMonthNavigation: PropTypes.bool,
	  showDisabledMonthNavigation: PropTypes.bool,
	  startDate: PropTypes.object,
	  startOpen: PropTypes.bool,
	  tabIndex: PropTypes.number,
	  timeCaption: PropTypes.string,
	  title: PropTypes.string,
	  todayButton: PropTypes.string,
	  useWeekdaysShort: PropTypes.bool,
	  utcOffset: PropTypes.number,
	  value: PropTypes.string,
	  weekLabel: PropTypes.string,
	  withPortal: PropTypes.bool,
	  yearDropdownItemNumber: PropTypes.number,
	  shouldCloseOnSelect: PropTypes.bool,
	  showTimeSelect: PropTypes.bool,
	  showTimeSelectOnly: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  useShortMonthInDropdown: PropTypes.bool,
	  clearButtonTitle: PropTypes.string
	};
	
	module.exports = DatePicker;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.cancelEvent = cancelEvent;
	exports.getFirstDayOfMonth = getFirstDayOfMonth;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getModifiersFromProps = getModifiersFromProps;
	exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
	exports.isRangeOfDates = isRangeOfDates;
	exports.getMonthsDiff = getMonthsDiff;
	exports.getWeekArray = getWeekArray;
	exports.startOfMonth = startOfMonth;
	exports.getDayNodes = getDayNodes;
	exports.nodeListToArray = nodeListToArray;
	exports.hasOwnProp = hasOwnProp;
	
	var _DateUtils = __webpack_require__(258);
	
	var _LocaleUtils = __webpack_require__(705);
	
	var _classNames = __webpack_require__(447);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cancelEvent(e) {
	  e.preventDefault();
	  e.stopPropagation();
	}
	
	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
	}
	
	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	
	  return resultDate.getDate();
	}
	
	function getModifiersFromProps(props) {
	  var modifiers = _extends({}, props.modifiers);
	  if (props.selectedDays) {
	    modifiers[props.classNames.selected] = props.selectedDays;
	  }
	  if (props.disabledDays) {
	    modifiers[props.classNames.disabled] = props.disabledDays;
	  }
	  return modifiers;
	}
	
	function getFirstDayOfWeekFromProps(props) {
	  var firstDayOfWeek = props.firstDayOfWeek,
	      _props$locale = props.locale,
	      locale = _props$locale === undefined ? 'en' : _props$locale,
	      _props$localeUtils = props.localeUtils,
	      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;
	
	  if (!isNaN(firstDayOfWeek)) {
	    return firstDayOfWeek;
	  }
	  if (localeUtils.getFirstDayOfWeek) {
	    return localeUtils.getFirstDayOfWeek(locale);
	  }
	  return 0;
	}
	
	function isRangeOfDates(value) {
	  return !!(value && value.from && value.to);
	}
	
	function getMonthsDiff(d1, d2) {
	  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
	}
	
	function getWeekArray(d) {
	  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
	  var fixedWeeks = arguments[2];
	
	  var daysInMonth = getDaysInMonth(d);
	  var dayArray = [];
	
	  var week = [];
	  var weekArray = [];
	
	  for (var i = 1; i <= daysInMonth; i += 1) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
	  }
	
	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      weekArray.push(week);
	      week = [];
	    }
	    week.push(day);
	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      weekArray.push(week);
	    }
	  });
	
	  // unshift days to start the first week
	  var firstWeek = weekArray[0];
	  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
	    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
	    outsideDate.setDate(firstWeek[0].getDate() - 1);
	    firstWeek.unshift(outsideDate);
	  }
	
	  // push days until the end of the last week
	  var lastWeek = weekArray[weekArray.length - 1];
	  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
	    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
	    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
	    lastWeek.push(_outsideDate);
	  }
	
	  // add extra weeks to reach 6 weeks
	  if (fixedWeeks && weekArray.length < 6) {
	    var lastExtraWeek = void 0;
	
	    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
	      lastExtraWeek = weekArray[weekArray.length - 1];
	      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
	      var extraWeek = [];
	
	      for (var j = 0; j < 7; j += 1) {
	        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
	        _outsideDate2.setDate(lastDay.getDate() + j + 1);
	        extraWeek.push(_outsideDate2);
	      }
	
	      weekArray.push(extraWeek);
	    }
	  }
	
	  return weekArray;
	}
	
	function startOfMonth(d) {
	  var newDate = (0, _DateUtils.clone)(d);
	  newDate.setDate(1);
	  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
	  return newDate;
	}
	
	function getDayNodes(node, classNames) {
	  var outsideClassName = void 0;
	  if (classNames === _classNames2.default) {
	    // When using CSS modules prefix the modifier as required by the BEM syntax
	    outsideClassName = classNames.day + '--' + classNames.outside;
	  } else {
	    outsideClassName = '' + classNames.outside;
	  }
	  var dayQuery = classNames.day.replace(/ /g, '.');
	  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
	  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
	  return node.querySelectorAll(selector);
	}
	
	function nodeListToArray(nodeList) {
	  return Array.prototype.slice.call(nodeList, 0);
	}
	
	function hasOwnProp(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	//# sourceMappingURL=Helpers.js.map

/***/ },
/* 447 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Proxy object to map classnames when css modules are not used
	
	exports.default = {
	  container: 'DayPicker',
	  wrapper: 'DayPicker-wrapper',
	  interactionDisabled: 'DayPicker--interactionDisabled',
	  months: 'DayPicker-Months',
	  month: 'DayPicker-Month',
	
	  navBar: 'DayPicker-NavBar',
	  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
	  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
	  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',
	
	  caption: 'DayPicker-Caption',
	  weekdays: 'DayPicker-Weekdays',
	  weekdaysRow: 'DayPicker-WeekdaysRow',
	  weekday: 'DayPicker-Weekday',
	  body: 'DayPicker-Body',
	  week: 'DayPicker-Week',
	  weekNumber: 'DayPicker-WeekNumber',
	  day: 'DayPicker-Day',
	  footer: 'DayPicker-Footer',
	  todayButton: 'DayPicker-TodayButton',
	
	  // default modifiers
	  today: 'today',
	  selected: 'selected',
	  disabled: 'disabled',
	  outside: 'outside'
	};
	//# sourceMappingURL=classNames.js.map

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var EventPluginRegistry = __webpack_require__(709);
	var ReactEventEmitterMixin = __webpack_require__(3302);
	var ViewportMetrics = __webpack_require__(1522);
	
	var getVendorPrefixedEventName = __webpack_require__(3333);
	var isEventSupported = __webpack_require__(721);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(323);
	var ViewportMetrics = __webpack_require__(1522);
	
	var getEventModifierState = __webpack_require__(718);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(36);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 451 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(89);
	var DOMNamespaces = __webpack_require__(708);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(716);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props3 = __webpack_require__(730);
	
	var _YouTube = __webpack_require__(3378);
	
	var _YouTube2 = _interopRequireDefault(_YouTube);
	
	var _SoundCloud = __webpack_require__(3373);
	
	var _SoundCloud2 = _interopRequireDefault(_SoundCloud);
	
	var _Vimeo = __webpack_require__(3376);
	
	var _Vimeo2 = _interopRequireDefault(_Vimeo);
	
	var _FilePlayer = __webpack_require__(455);
	
	var _FilePlayer2 = _interopRequireDefault(_FilePlayer);
	
	var _Streamable = __webpack_require__(3374);
	
	var _Streamable2 = _interopRequireDefault(_Streamable);
	
	var _Vidme = __webpack_require__(3375);
	
	var _Vidme2 = _interopRequireDefault(_Vidme);
	
	var _Wistia = __webpack_require__(3377);
	
	var _Wistia2 = _interopRequireDefault(_Wistia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactPlayer = function (_Component) {
	  _inherits(ReactPlayer, _Component);
	
	  function ReactPlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactPlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.seekTo = function (fraction) {
	      if (_this.player) {
	        _this.player.seekTo(fraction);
	      }
	    }, _this.progress = function () {
	      if (_this.props.url && _this.player) {
	        var loaded = _this.player.getFractionLoaded() || 0;
	        var played = _this.player.getFractionPlayed() || 0;
	        var progress = {};
	        if (loaded !== _this.prevLoaded) {
	          progress.loaded = loaded;
	        }
	        if (played !== _this.prevPlayed) {
	          progress.played = played;
	        }
	        if (progress.loaded || progress.played) {
	          _this.props.onProgress(progress);
	        }
	        _this.prevLoaded = loaded;
	        _this.prevPlayed = played;
	      }
	      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency);
	    }, _this.ref = function (player) {
	      _this.player = player;
	    }, _this.renderPlayer = function (Player) {
	      var active = Player.canPlay(_this.props.url);
	
	      var _this$props = _this.props,
	          youtubeConfig = _this$props.youtubeConfig,
	          soundcloudConfig = _this$props.soundcloudConfig,
	          vimeoConfig = _this$props.vimeoConfig,
	          fileConfig = _this$props.fileConfig,
	          activeProps = _objectWithoutProperties(_this$props, ['youtubeConfig', 'soundcloudConfig', 'vimeoConfig', 'fileConfig']);
	
	      var props = active ? _extends({}, activeProps, { ref: _this.ref }) : {};
	      return _react2['default'].createElement(Player, _extends({
	        key: Player.displayName,
	        youtubeConfig: youtubeConfig,
	        soundcloudConfig: soundcloudConfig,
	        vimeoConfig: vimeoConfig,
	        fileConfig: fileConfig
	      }, props));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReactPlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.progress();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.progressTimeout);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.url !== nextProps.url || this.props.playing !== nextProps.playing || this.props.volume !== nextProps.volume || this.props.playbackRate !== nextProps.playbackRate || this.props.height !== nextProps.height || this.props.width !== nextProps.width || this.props.hidden !== nextProps.hidden;
	    }
	  }, {
	    key: 'renderPlayers',
	    value: function renderPlayers() {
	      // Build array of players to render based on URL and preload config
	      var _props = this.props,
	          url = _props.url,
	          youtubeConfig = _props.youtubeConfig,
	          vimeoConfig = _props.vimeoConfig;
	
	      var players = [];
	      if (_YouTube2['default'].canPlay(url)) {
	        players.push(_YouTube2['default']);
	      } else if (_SoundCloud2['default'].canPlay(url)) {
	        players.push(_SoundCloud2['default']);
	      } else if (_Vimeo2['default'].canPlay(url)) {
	        players.push(_Vimeo2['default']);
	      } else if (_Streamable2['default'].canPlay(url)) {
	        players.push(_Streamable2['default']);
	      } else if (_Vidme2['default'].canPlay(url)) {
	        players.push(_Vidme2['default']);
	      } else if (_Wistia2['default'].canPlay(url)) {
	        players.push(_Wistia2['default']);
	      } else if (url) {
	        // Fall back to FilePlayer if nothing else can play the URL
	        players.push(_FilePlayer2['default']);
	      }
	      // Render additional players if preload config is set
	      if (!_YouTube2['default'].canPlay(url) && youtubeConfig.preload) {
	        players.push(_YouTube2['default']);
	      }
	      if (!_Vimeo2['default'].canPlay(url) && vimeoConfig.preload) {
	        players.push(_Vimeo2['default']);
	      }
	      return players.map(this.renderPlayer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          style = _props2.style,
	          width = _props2.width,
	          height = _props2.height,
	          className = _props2.className,
	          hidden = _props2.hidden;
	
	      var players = this.renderPlayers();
	      return _react2['default'].createElement(
	        'div',
	        { style: _extends({}, style, { width: width, height: height }), className: className, hidden: hidden },
	        players
	      );
	    }
	  }]);
	
	  return ReactPlayer;
	}(_react.Component);
	
	ReactPlayer.displayName = 'ReactPlayer';
	ReactPlayer.propTypes = _props3.propTypes;
	ReactPlayer.defaultProps = _props3.defaultProps;
	exports['default'] = ReactPlayer;
	module.exports = exports['default'];

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _props2 = __webpack_require__(730);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEEK_ON_PLAY_EXPIRY = 5000;
	
	var Base = function (_Component) {
	  _inherits(Base, _Component);
	
	  function Base() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Base);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Base.__proto__ || Object.getPrototypeOf(Base)).call.apply(_ref, [this].concat(args))), _this), _this.isReady = false, _this.startOnPlay = true, _this.durationOnPlay = false, _this.seekOnPlay = null, _this.onPlay = function () {
	      var _this$props = _this.props,
	          volume = _this$props.volume,
	          onStart = _this$props.onStart,
	          onPlay = _this$props.onPlay,
	          onDuration = _this$props.onDuration,
	          playbackRate = _this$props.playbackRate;
	
	      if (_this.startOnPlay) {
	        _this.setPlaybackRate(playbackRate);
	        _this.setVolume(volume);
	        onStart();
	        _this.startOnPlay = false;
	      }
	      onPlay();
	      if (_this.seekOnPlay) {
	        _this.seekTo(_this.seekOnPlay);
	        _this.seekOnPlay = null;
	      }
	      if (_this.durationOnPlay) {
	        onDuration(_this.getDuration());
	        _this.durationOnPlay = false;
	      }
	    }, _this.onReady = function () {
	      var _this$props2 = _this.props,
	          onReady = _this$props2.onReady,
	          playing = _this$props2.playing,
	          onDuration = _this$props2.onDuration;
	
	      _this.isReady = true;
	      onReady();
	      if (playing || _this.preloading) {
	        _this.preloading = false;
	        if (_this.loadOnReady) {
	          _this.load(_this.loadOnReady);
	          _this.loadOnReady = null;
	        } else {
	          _this.play();
	        }
	      }
	      var duration = _this.getDuration();
	      if (duration) {
	        onDuration(duration);
	      } else {
	        _this.durationOnPlay = true;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Base, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var url = this.props.url;
	
	      this.mounted = true;
	      if (url) {
	        this.load(url);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	      this.mounted = false;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          url = _props.url,
	          playing = _props.playing,
	          volume = _props.volume,
	          playbackRate = _props.playbackRate;
	      // Invoke player methods based on incoming props
	
	      if (url !== nextProps.url && nextProps.url) {
	        this.seekOnPlay = null;
	        this.startOnPlay = true;
	        this.load(nextProps.url);
	      } else if (url && !nextProps.url) {
	        this.stop();
	        clearTimeout(this.updateTimeout);
	      } else if (!playing && nextProps.playing) {
	        this.play();
	      } else if (playing && !nextProps.playing) {
	        this.pause();
	      } else if (volume !== nextProps.volume) {
	        this.setVolume(nextProps.volume);
	      } else if (playbackRate !== nextProps.playbackRate) {
	        this.setPlaybackRate(nextProps.playbackRate);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.url !== nextProps.url;
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      var _this2 = this;
	
	      // When seeking before player is ready, store value and seek later
	      if (!this.isReady && fraction !== 0) {
	        this.seekOnPlay = fraction;
	        setTimeout(function () {
	          _this2.seekOnPlay = null;
	        }, SEEK_ON_PLAY_EXPIRY);
	      }
	    }
	  }]);
	
	  return Base;
	}(_react.Component);
	
	Base.propTypes = _props2.propTypes;
	Base.defaultProps = _props2.defaultProps;
	exports['default'] = Base;
	module.exports = exports['default'];

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Base2 = __webpack_require__(454);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
	
	var FilePlayer = function (_Base) {
	  _inherits(FilePlayer, _Base);
	
	  function FilePlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FilePlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.ref = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FilePlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onPause = _props.onPause,
	          onEnded = _props.onEnded,
	          onError = _props.onError;
	
	      this.player.addEventListener('canplay', this.onReady);
	      this.player.addEventListener('play', this.onPlay);
	      this.player.addEventListener('pause', function () {
	        if (_this2.mounted) {
	          onPause();
	        }
	      });
	      this.player.addEventListener('ended', onEnded);
	      this.player.addEventListener('error', onError);
	      this.player.setAttribute('webkit-playsinline', '');
	      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props2 = this.props,
	          onPause = _props2.onPause,
	          onEnded = _props2.onEnded,
	          onError = _props2.onError;
	
	      this.player.removeEventListener('canplay', this.onReady);
	      this.player.removeEventListener('play', this.onPlay);
	      this.player.removeEventListener('pause', onPause);
	      this.player.removeEventListener('ended', onEnded);
	      this.player.removeEventListener('error', onError);
	      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentWillUnmount', this).call(this);
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      this.player.src = url;
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.player.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.player.removeAttribute('src');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'seekTo', this).call(this, fraction);
	      this.player.currentTime = this.getDuration() * fraction;
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.player.volume = fraction;
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.player.playbackRate = rate;
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady) return null;
	      return this.player.duration;
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady) return null;
	      return this.player.currentTime / this.getDuration();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      if (!this.isReady || this.player.buffered.length === 0) return null;
	      return this.player.buffered.end(0) / this.getDuration();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          url = _props3.url,
	          loop = _props3.loop,
	          controls = _props3.controls,
	          fileConfig = _props3.fileConfig;
	
	      var Media = AUDIO_EXTENSIONS.test(url) ? 'audio' : 'video';
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement(Media, _extends({
	        ref: this.ref,
	        style: style,
	        preload: 'auto',
	        controls: controls,
	        loop: loop
	      }, fileConfig.attributes));
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return true;
	    }
	  }]);
	
	  return FilePlayer;
	}(_Base3['default']);
	
	FilePlayer.displayName = 'FilePlayer';
	exports['default'] = FilePlayer;
	module.exports = exports['default'];

/***/ },
/* 456 */
[4189, 3441, 3442, 3443, 3444, 3445],
/* 457 */
[4197, 156],
/* 458 */
[4204, 738],
/* 459 */
[4294, 3438],
/* 460 */
[4327, 261],
/* 461 */
[4342, 463],
/* 462 */
[4395, 1549, 739],
/* 463 */
[4408, 324, 326],
/* 464 */
[4413, 3395, 3409, 462],
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(466);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(3507);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(183);
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(76);
	
	var animateScroll = __webpack_require__(743);
	var scrollSpy = __webpack_require__(1565);
	var defaultScroller = __webpack_require__(1566);
	var assign = __webpack_require__(45);
	
	
	var protoTypes = {
	  to: React.PropTypes.string.isRequired,
	  containerId: React.PropTypes.string,
	  activeClass:React.PropTypes.string,
	  spy: React.PropTypes.bool,
	  smooth: React.PropTypes.bool,
	  offset: React.PropTypes.number,
	  delay: React.PropTypes.number,
	  isDynamic: React.PropTypes.bool,
	  onClick: React.PropTypes.func,
	  duration: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.func]),
	  absolute: React.PropTypes.bool,
	  onSetActive: React.PropTypes.func
	};
	
	var Helpers = {
	
	  Scroll: function (Component, customScroller) {
	
	    var scroller = customScroller || defaultScroller;
	
	    return React.createClass({
	
	      propTypes: protoTypes,
	
	      getDefaultProps: function() {
	        return {offset: 0};
	      },
	
	      scrollTo : function(to, props) {
	          scroller.scrollTo(to, props);
	      },
	
	      handleClick: function(event) {
	
	        /*
	         * give the posibility to override onClick
	         */
	
	        if(this.props.onClick) {
	          this.props.onClick(event);
	        }
	
	        /*
	         * dont bubble the navigation
	         */
	
	        if (event.stopPropagation) event.stopPropagation();
	        if (event.preventDefault) event.preventDefault();
	
	        /*
	         * do the magic!
	         */
	        this.scrollTo(this.props.to, this.props);
	
	      },
	
	      spyHandler: function(y) {
	        var element = scroller.get(this.props.to);
	        if (!element) return;
	        var cords = element.getBoundingClientRect();
	        var topBound = cords.top + y;
	        var bottomBound = topBound + cords.height;
	        var offsetY = y - this.props.offset;
	        var to = this.props.to;
	        var isInside = (offsetY >= topBound && offsetY <= bottomBound);
	        var isOutside = (offsetY < topBound || offsetY > bottomBound);
	        var activeLink = scroller.getActiveLink();
	
	        if (isOutside && activeLink === to) {
	          scroller.setActiveLink(void 0);
	          this.setState({ active : false });
	
	        } else if (isInside && activeLink != to) {
	          scroller.setActiveLink(to);
	          this.setState({ active : true });
	
	          if(this.props.onSetActive) {
	            this.props.onSetActive(to);
	          }
	
	          scrollSpy.updateStates();
	        }
	      },
	
	      componentDidMount: function() {
	
	
	
	        var containerId = this.props.containerId;
	
	        var scrollSpyContainer = containerId ? document.getElementById(containerId) : document;
	
	        if(!scrollSpy.isMounted(scrollSpyContainer)) {
	          scrollSpy.mount(scrollSpyContainer);
	        }
	
	
	        if(this.props.spy) {
	          var to = this.props.to;
	          var element = null;
	          var elemTopBound = 0;
	          var elemBottomBound = 0;
	
	          this._stateHandler = function() {
	            if(scroller.getActiveLink() != to) {
	                this.setState({ active : false });
	            }
	          }.bind(this)
	
	          scrollSpy.addStateHandler(this._stateHandler);
	
	          this._spyHandler = function(y) {
	
	            var containerTop = 0;
	            if(scrollSpyContainer.getBoundingClientRect) {
	              var containerCords = scrollSpyContainer.getBoundingClientRect();
	              containerTop = containerCords.top;
	            }
	
	            if(!element || this.props.isDynamic) {
	                element = scroller.get(to);
	                if(!element){ return;}
	
	                var cords = element.getBoundingClientRect();
	                elemTopBound = (cords.top - containerTop + y);
	                elemBottomBound = elemTopBound + cords.height;
	            }
	
	
	
	            var offsetY = y - this.props.offset;
	            var isInside = (offsetY >= Math.floor(elemTopBound) && offsetY <= Math.floor(elemBottomBound));
	            var isOutside = (offsetY < Math.floor(elemTopBound) || offsetY > Math.floor(elemBottomBound));
	            var activeLink = scroller.getActiveLink();
	
	            if (isOutside && activeLink === to) {
	              scroller.setActiveLink(void 0);
	              this.setState({ active : false });
	
	            } else if (isInside && activeLink != to) {
	              scroller.setActiveLink(to);
	              this.setState({ active : true });
	
	              if(this.props.onSetActive) {
	                this.props.onSetActive(to);
	              }
	
	              scrollSpy.updateStates();
	
	            }
	          }.bind(this);
	
	          scrollSpy.addSpyHandler(this._spyHandler, scrollSpyContainer);
	        }
	      },
	      componentWillUnmount: function() {
	        scrollSpy.unmount(this._stateHandler, this._spyHandler);
	      },
	      render: function() {
	
	        var className = "";
	        if(this.state && this.state.active) {
	          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
	        } else {
	          className = this.props.className;
	        }
	
	        var props = assign({}, this.props);
	
	        for(var prop in protoTypes) {
	          if(props.hasOwnProperty(prop)) {
	            delete props[prop];
	          }
	        }
	
	        props.className = className;
	        props.onClick = this.handleClick;
	
	        return React.createElement(Component, props);
	      }
	    });
	  },
	
	
	  Element: function(Component) {
	    return React.createClass({
	      propTypes: {
	        name: React.PropTypes.string,
	        id:   React.PropTypes.string
	      },
	      componentDidMount: function() {
	        this.registerElems(this.props.name);
	      },
	      componentWillReceiveProps: function(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          this.registerElems(nextProps.name);
	        }
	      },
	      componentWillUnmount: function() {
	        defaultScroller.unregister(this.props.name);
	      },
	      registerElems: function(name) {
	        var domNode = ReactDOM.findDOMNode(this);
	        defaultScroller.register(name, domNode);
	      },
	      render: function() {
	        return React.createElement(Component, this.props);
	      }
	    });
	  }
	};
	
	module.exports = Helpers;


/***/ },
/* 468 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  POSITION: {
	    TOP_LEFT: 'top-left',
	    TOP_RIGHT: 'top-right',
	    TOP_CENTER: 'top-center',
	    BOTTOM_LEFT: 'bottom-left',
	    BOTTOM_RIGHT: 'bottom-right',
	    BOTTOM_CENTER: 'bottom-center'
	  },
	  TYPE: {
	    INFO: 'info',
	    SUCCESS: 'success',
	    WARNING: 'warning',
	    ERROR: 'error',
	    DEFAULT: 'default'
	  },
	  ACTION: {
	    SHOW: 'SHOW_TOAST',
	    CLEAR: 'CLEAR_TOAST',
	    MOUNTED: 'CONTAINER_MOUNTED'
	  }
	};

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var callbacks = [];
	
	function addScript(src, cb) {
	  if (callbacks.length === 0) {
	    callbacks.push(cb);
	    var s = document.createElement('script');
	    s.setAttribute('src', src);
	    s.onload = function () {
	      return callbacks.forEach(function (cb) {
	        return cb();
	      });
	    };
	    document.body.appendChild(s);
	  } else {
	    callbacks.push(cb);
	  }
	}
	
	var TweetEmbed = function (_React$Component) {
	  _inherits(TweetEmbed, _React$Component);
	
	  function TweetEmbed() {
	    _classCallCheck(this, TweetEmbed);
	
	    return _possibleConstructorReturn(this, (TweetEmbed.__proto__ || Object.getPrototypeOf(TweetEmbed)).apply(this, arguments));
	  }
	
	  _createClass(TweetEmbed, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var renderTweet = function renderTweet() {
	        window.twttr.ready().then(function (_ref) {
	          var widgets = _ref.widgets;
	          var _props = _this2.props,
	              options = _props.options,
	              onTweetLoadSuccess = _props.onTweetLoadSuccess,
	              onTweetLoadError = _props.onTweetLoadError;
	
	          widgets.createTweetEmbed(_this2.props.id, _this2._div, options).then(onTweetLoadSuccess).catch(onTweetLoadError);
	        });
	      };
	
	      if (!window.twttr) {
	        var isLocal = window.location.protocol.indexOf('file') >= 0;
	        var protocol = isLocal ? this.props.protocol : '';
	
	        addScript(protocol + '//platform.twitter.com/widgets.js', renderTweet);
	      } else {
	        renderTweet();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement('div', { className: this.props.className, ref: function ref(c) {
	          _this3._div = c;
	        } });
	    }
	  }]);
	
	  return TweetEmbed;
	}(_react2.default.Component);
	
	TweetEmbed.propTypes = {
	  id: _react.PropTypes.string,
	  options: _react.PropTypes.object,
	  protocol: _react.PropTypes.string,
	  onTweetLoadSuccess: _react.PropTypes.func,
	  onTweetLoadError: _react.PropTypes.func,
	  className: _react.PropTypes.string
	};
	
	TweetEmbed.defaultProps = {
	  protocol: 'https:',
	  options: {},
	  className: null
	};
	
	exports.default = TweetEmbed;

/***/ },
/* 470 */
[4189, 3585, 3586, 3587, 3588, 3589],
/* 471 */
[4204, 1579],
/* 472 */
[4221, 747, 3572, 3598],
/* 473 */
[4294, 3582],
/* 474 */
[4327, 263],
/* 475 */
79,
/* 476 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatName;
	function formatName(context, name) {
	  var sectionPrefix = context._reduxForm.sectionPrefix;
	
	  return !sectionPrefix ? name : sectionPrefix + "." + name;
	}

/***/ },
/* 477 */
[4189, 3744, 3745, 3746, 3747, 3748],
/* 478 */
[4197, 138],
/* 479 */
[4204, 331],
/* 480 */
[4208, 1606],
/* 481 */
[4294, 3742],
/* 482 */
[4327, 218],
/* 483 */
[4395, 765, 766],
/* 484 */
[4408, 266, 219],
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buffers = exports.BUFFER_OVERFLOW = undefined;
	
	var _utils = __webpack_require__(160);
	
	var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';
	
	var ON_OVERFLOW_THROW = 1;
	var ON_OVERFLOW_DROP = 2;
	var ON_OVERFLOW_SLIDE = 3;
	var ON_OVERFLOW_EXPAND = 4;
	
	var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };
	
	function ringBuffer() {
	  var limit = arguments.length <= 0 || arguments[0] === undefined ? 10 : arguments[0];
	  var overflowAction = arguments[1];
	
	  var arr = new Array(limit);
	  var length = 0;
	  var pushIndex = 0;
	  var popIndex = 0;
	
	  var push = function push(it) {
	    arr[pushIndex] = it;
	    pushIndex = (pushIndex + 1) % limit;
	    length++;
	  };
	
	  var take = function take() {
	    if (length != 0) {
	      var it = arr[popIndex];
	      arr[popIndex] = null;
	      length--;
	      popIndex = (popIndex + 1) % limit;
	      return it;
	    }
	  };
	
	  var flush = function flush() {
	    var items = [];
	    while (length) {
	      items.push(take());
	    }
	    return items;
	  };
	
	  return {
	    isEmpty: function isEmpty() {
	      return length == 0;
	    },
	    put: function put(it) {
	      if (length < limit) {
	        push(it);
	      } else {
	        var doubledLimit = void 0;
	        switch (overflowAction) {
	          case ON_OVERFLOW_THROW:
	            throw new Error(BUFFER_OVERFLOW);
	          case ON_OVERFLOW_SLIDE:
	            arr[pushIndex] = it;
	            pushIndex = (pushIndex + 1) % limit;
	            popIndex = pushIndex;
	            break;
	          case ON_OVERFLOW_EXPAND:
	            doubledLimit = 2 * limit;
	
	            arr = flush();
	
	            length = arr.length;
	            pushIndex = arr.length;
	            popIndex = 0;
	
	            arr.length = doubledLimit;
	            limit = doubledLimit;
	
	            push(it);
	            break;
	          default:
	          // DROP
	        }
	      }
	    },
	    take: take, flush: flush
	  };
	}
	
	var buffers = exports.buffers = {
	  none: function none() {
	    return zeroBuffer;
	  },
	  fixed: function fixed(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_THROW);
	  },
	  dropping: function dropping(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_DROP);
	  },
	  sliding: function sliding(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
	  },
	  expanding: function expanding(initialSize) {
	    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
	  }
	};

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.emitter = emitter;
	exports.channel = channel;
	exports.eventChannel = eventChannel;
	exports.stdChannel = stdChannel;
	
	var _utils = __webpack_require__(160);
	
	var _buffers = __webpack_require__(485);
	
	var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
	var END = exports.END = { type: CHANNEL_END_TYPE };
	var isEnd = exports.isEnd = function isEnd(a) {
	  return a && a.type === CHANNEL_END_TYPE;
	};
	
	function emitter() {
	  var subscribers = [];
	
	  function subscribe(sub) {
	    subscribers.push(sub);
	    return function () {
	      return (0, _utils.remove)(subscribers, sub);
	    };
	  }
	
	  function emit(item) {
	    var arr = subscribers.slice();
	    for (var i = 0, len = arr.length; i < len; i++) {
	      arr[i](item);
	    }
	  }
	
	  return {
	    subscribe: subscribe,
	    emit: emit
	  };
	}
	
	var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
	var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';
	
	if (false) {
	  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
	}
	
	function channel() {
	  var buffer = arguments.length <= 0 || arguments[0] === undefined ? _buffers.buffers.fixed() : arguments[0];
	
	  var closed = false;
	  var takers = [];
	
	  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);
	
	  function checkForbiddenStates() {
	    if (closed && takers.length) {
	      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
	    }
	    if (takers.length && !buffer.isEmpty()) {
	      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
	    }
	  }
	
	  function put(input) {
	    checkForbiddenStates();
	    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
	    if (closed) {
	      return;
	    }
	    if (!takers.length) {
	      return buffer.put(input);
	    }
	    for (var i = 0; i < takers.length; i++) {
	      var cb = takers[i];
	      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
	        takers.splice(i, 1);
	        return cb(input);
	      }
	    }
	  }
	
	  function take(cb) {
	    checkForbiddenStates();
	    (0, _utils.check)(cb, _utils.is.func, 'channel.take\'s callback must be a function');
	
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	    } else if (!buffer.isEmpty()) {
	      cb(buffer.take());
	    } else {
	      takers.push(cb);
	      cb.cancel = function () {
	        return (0, _utils.remove)(takers, cb);
	      };
	    }
	  }
	
	  function flush(cb) {
	    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
	    (0, _utils.check)(cb, _utils.is.func, 'channel.flush\' callback must be a function');
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	      return;
	    }
	    cb(buffer.flush());
	  }
	
	  function close() {
	    checkForbiddenStates();
	    if (!closed) {
	      closed = true;
	      if (takers.length) {
	        var arr = takers;
	        takers = [];
	        for (var i = 0, len = arr.length; i < len; i++) {
	          arr[i](END);
	        }
	      }
	    }
	  }
	
	  return { take: take, put: put, flush: flush, close: close,
	    get __takers__() {
	      return takers;
	    },
	    get __closed__() {
	      return closed;
	    }
	  };
	}
	
	function eventChannel(subscribe) {
	  var buffer = arguments.length <= 1 || arguments[1] === undefined ? _buffers.buffers.none() : arguments[1];
	  var matcher = arguments[2];
	
	  /**
	    should be if(typeof matcher !== undefined) instead?
	    see PR #273 for a background discussion
	  **/
	  if (arguments.length > 2) {
	    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
	  }
	
	  var chan = channel(buffer);
	  var unsubscribe = subscribe(function (input) {
	    if (isEnd(input)) {
	      chan.close();
	    } else if (!matcher || matcher(input)) {
	      chan.put(input);
	    }
	  });
	
	  if (!_utils.is.func(unsubscribe)) {
	    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
	  }
	
	  return {
	    take: chan.take,
	    flush: chan.flush,
	    close: function close() {
	      if (!chan.__closed__) {
	        chan.close();
	        unsubscribe();
	      }
	    }
	  };
	}
	
	function stdChannel(subscribe) {
	  var chan = eventChannel(subscribe);
	
	  return _extends({}, chan, {
	    take: function take(cb, matcher) {
	      if (arguments.length > 1) {
	        (0, _utils.check)(matcher, _utils.is.func, 'channel.take\'s matcher argument must be a function');
	        cb[_utils.MATCH] = matcher;
	      }
	      chan.take(cb);
	    }
	  });
	}

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.asEffect = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.take = take;
	exports.takem = takem;
	exports.put = put;
	exports.race = race;
	exports.call = call;
	exports.apply = apply;
	exports.cps = cps;
	exports.fork = fork;
	exports.spawn = spawn;
	exports.join = join;
	exports.cancel = cancel;
	exports.select = select;
	exports.actionChannel = actionChannel;
	exports.cancelled = cancelled;
	exports.flush = flush;
	
	var _utils = __webpack_require__(160);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IO = (0, _utils.sym)('IO');
	var TAKE = 'TAKE';
	var PUT = 'PUT';
	var RACE = 'RACE';
	var CALL = 'CALL';
	var CPS = 'CPS';
	var FORK = 'FORK';
	var JOIN = 'JOIN';
	var CANCEL = 'CANCEL';
	var SELECT = 'SELECT';
	var ACTION_CHANNEL = 'ACTION_CHANNEL';
	var CANCELLED = 'CANCELLED';
	var FLUSH = 'FLUSH';
	
	var effect = function effect(type, payload) {
	  var _ref;
	
	  return _ref = {}, _defineProperty(_ref, IO, true), _defineProperty(_ref, type, payload), _ref;
	};
	
	function take() {
	  var patternOrChannel = arguments.length <= 0 || arguments[0] === undefined ? '*' : arguments[0];
	
	  if (arguments.length) {
	    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
	  }
	  if (_utils.is.pattern(patternOrChannel)) {
	    return effect(TAKE, { pattern: patternOrChannel });
	  }
	  if (_utils.is.channel(patternOrChannel)) {
	    return effect(TAKE, { channel: patternOrChannel });
	  }
	  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
	}
	
	function takem() {
	  var eff = take.apply(undefined, arguments);
	  eff[TAKE].maybe = true;
	  return eff;
	}
	
	function put(channel, action) {
	  if (arguments.length > 1) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
	    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
	    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
	  } else {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
	    action = channel;
	    channel = null;
	  }
	  return effect(PUT, { channel: channel, action: action });
	}
	
	put.sync = function () {
	  var eff = put.apply(undefined, arguments);
	  eff[PUT].sync = true;
	  return eff;
	};
	
	function race(effects) {
	  return effect(RACE, effects);
	}
	
	function getFnCallDesc(meth, fn, args) {
	  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');
	
	  var context = null;
	  if (_utils.is.array(fn)) {
	    var _fn = fn;
	
	    var _fn2 = _slicedToArray(_fn, 2);
	
	    context = _fn2[0];
	    fn = _fn2[1];
	  } else if (fn.fn) {
	    var _fn3 = fn;
	    context = _fn3.context;
	    fn = _fn3.fn;
	  }
	  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');
	
	  return { context: context, fn: fn, args: args };
	}
	
	function call(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return effect(CALL, getFnCallDesc('call', fn, args));
	}
	
	function apply(context, fn) {
	  var args = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
	}
	
	function cps(fn) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return effect(CPS, getFnCallDesc('cps', fn, args));
	}
	
	function fork(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  return effect(FORK, getFnCallDesc('fork', fn, args));
	}
	
	function spawn(fn) {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  var eff = fork.apply(undefined, [fn].concat(args));
	  eff[FORK].detached = true;
	  return eff;
	}
	
	var isForkedTask = function isForkedTask(task) {
	  return task[_utils.TASK];
	};
	
	function join(task) {
	  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
	  if (!isForkedTask(task)) {
	    throw new Error('join(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
	  }
	
	  return effect(JOIN, task);
	}
	
	function cancel(task) {
	  (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
	  if (!isForkedTask(task)) {
	    throw new Error('cancel(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
	  }
	
	  return effect(CANCEL, task);
	}
	
	function select(selector) {
	  for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    args[_key5 - 1] = arguments[_key5];
	  }
	
	  if (arguments.length === 0) {
	    selector = _utils.ident;
	  } else {
	    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
	    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
	  }
	  return effect(SELECT, { selector: selector, args: args });
	}
	
	/**
	  channel(pattern, [buffer])    => creates an event channel for store actions
	**/
	function actionChannel(pattern, buffer) {
	  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
	  if (arguments.length > 1) {
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
	  }
	  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
	}
	
	function cancelled() {
	  return effect(CANCELLED, {});
	}
	
	function flush(channel) {
	  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
	  return effect(FLUSH, channel);
	}
	
	var asEffect = exports.asEffect = {
	  take: function take(effect) {
	    return effect && effect[IO] && effect[TAKE];
	  },
	  put: function put(effect) {
	    return effect && effect[IO] && effect[PUT];
	  },
	  race: function race(effect) {
	    return effect && effect[IO] && effect[RACE];
	  },
	  call: function call(effect) {
	    return effect && effect[IO] && effect[CALL];
	  },
	  cps: function cps(effect) {
	    return effect && effect[IO] && effect[CPS];
	  },
	  fork: function fork(effect) {
	    return effect && effect[IO] && effect[FORK];
	  },
	  join: function join(effect) {
	    return effect && effect[IO] && effect[JOIN];
	  },
	  cancel: function cancel(effect) {
	    return effect && effect[IO] && effect[CANCEL];
	  },
	  select: function select(effect) {
	    return effect && effect[IO] && effect[SELECT];
	  },
	  actionChannel: function actionChannel(effect) {
	    return effect && effect[IO] && effect[ACTION_CHANNEL];
	  },
	  cancelled: function cancelled(effect) {
	    return effect && effect[IO] && effect[CANCELLED];
	  },
	  flush: function flush(effect) {
	    return effect && effect[IO] && effect[FLUSH];
	  }
	};

/***/ },
/* 488 */
[4457, 3803],
/* 489 */
[4487, 42, 12, 11, 77],
/* 490 */
[4494, 1653],
/* 491 */
[4502, 42, 12, 11, 1660],
/* 492 */
[4508, 775],
/* 493 */
[4510, 12, 11],
/* 494 */
[4511, 12, 11],
/* 495 */
[4535, 3861],
/* 496 */
[4565, 12, 11],
/* 497 */
[4189, 3981, 3982, 3983, 3984, 3985],
/* 498 */
[4195, 802, 3999, 4000],
/* 499 */
383,
/* 500 */
[4200, 505],
/* 501 */
[4203, 503, 339],
/* 502 */
[4204, 339],
/* 503 */
[4208, 1742],
/* 504 */
[4216, 805, 3978],
/* 505 */
[4222, 1728, 3913, 4006],
/* 506 */
[4234, 338, 3994],
/* 507 */
391,
/* 508 */
392,
/* 509 */
393,
/* 510 */
[4274, 335, 100],
/* 511 */
[4283, 1733, 3951, 3954, 1740, 3957, 812, 3993, 1757, 1758, 164],
/* 512 */
[4289, 4021, 1755, 819],
/* 513 */
[4294, 3979],
/* 514 */
[4297, 1754],
/* 515 */
[4310, 339, 126, 337, 100],
/* 516 */
[4327, 222],
/* 517 */
400,
/* 518 */
[4394, 3909, 83],
/* 519 */
[4396, 126, 83],
/* 520 */
[4399, 506, 223, 518, 49, 126, 340, 338, 521],
/* 521 */
[4409, 3916, 270, 817],
/* 522 */
407,
/* 523 */
[4436, 100, 225],
/* 524 */
[4444, 3932, 116],
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(4081);


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var randomFromSeed = __webpack_require__(4084);
	
	var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
	var alphabet;
	var previousSeed;
	
	var shuffled;
	
	function reset() {
	    shuffled = false;
	}
	
	function setCharacters(_alphabet_) {
	    if (!_alphabet_) {
	        if (alphabet !== ORIGINAL) {
	            alphabet = ORIGINAL;
	            reset();
	        }
	        return;
	    }
	
	    if (_alphabet_ === alphabet) {
	        return;
	    }
	
	    if (_alphabet_.length !== ORIGINAL.length) {
	        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
	    }
	
	    var unique = _alphabet_.split('').filter(function(item, ind, arr){
	       return ind !== arr.lastIndexOf(item);
	    });
	
	    if (unique.length) {
	        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
	    }
	
	    alphabet = _alphabet_;
	    reset();
	}
	
	function characters(_alphabet_) {
	    setCharacters(_alphabet_);
	    return alphabet;
	}
	
	function setSeed(seed) {
	    randomFromSeed.seed(seed);
	    if (previousSeed !== seed) {
	        reset();
	        previousSeed = seed;
	    }
	}
	
	function shuffle() {
	    if (!alphabet) {
	        setCharacters(ORIGINAL);
	    }
	
	    var sourceArray = alphabet.split('');
	    var targetArray = [];
	    var r = randomFromSeed.nextValue();
	    var characterIndex;
	
	    while (sourceArray.length > 0) {
	        r = randomFromSeed.nextValue();
	        characterIndex = Math.floor(r * sourceArray.length);
	        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
	    }
	    return targetArray.join('');
	}
	
	function getShuffled() {
	    if (shuffled) {
	        return shuffled;
	    }
	    shuffled = shuffle();
	    return shuffled;
	}
	
	/**
	 * lookup shuffled letter
	 * @param index
	 * @returns {string}
	 */
	function lookup(index) {
	    var alphabetShuffled = getShuffled();
	    return alphabetShuffled[index];
	}
	
	module.exports = {
	    characters: characters,
	    seed: setSeed,
	    lookup: lookup,
	    shuffled: getShuffled
	};


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
	  function getOwnPropertyDescriptors(obj) {
	    var keys = Object.keys(obj);
	    var descriptors = {};
	    for (var i = 0; i < keys.length; i++) {
	      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
	    }
	    return descriptors;
	  };
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  if (typeof process !== 'undefined' && process.noDeprecation === true) {
	    return fn;
	  }
	
	  // Allow for deprecating things in the process of starting up.
	  if (typeof process === 'undefined') {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(4099);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(4098);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
	
	exports.promisify = function promisify(original) {
	  if (typeof original !== 'function')
	    throw new TypeError('The "original" argument must be of type Function');
	
	  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
	    var fn = original[kCustomPromisifiedSymbol];
	    if (typeof fn !== 'function') {
	      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
	    }
	    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
	      value: fn, enumerable: false, writable: false, configurable: true
	    });
	    return fn;
	  }
	
	  function fn() {
	    var promiseResolve, promiseReject;
	    var promise = new Promise(function (resolve, reject) {
	      promiseResolve = resolve;
	      promiseReject = reject;
	    });
	
	    var args = [];
	    for (var i = 0; i < arguments.length; i++) {
	      args.push(arguments[i]);
	    }
	    args.push(function (err, value) {
	      if (err) {
	        promiseReject(err);
	      } else {
	        promiseResolve(value);
	      }
	    });
	
	    try {
	      original.apply(this, args);
	    } catch (err) {
	      promiseReject(err);
	    }
	
	    return promise;
	  }
	
	  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
	
	  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
	    value: fn, enumerable: false, writable: false, configurable: true
	  });
	  return Object.defineProperties(
	    fn,
	    getOwnPropertyDescriptors(original)
	  );
	}
	
	exports.promisify.custom = kCustomPromisifiedSymbol
	
	function callbackifyOnRejected(reason, cb) {
	  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
	  // Because `null` is a special error value in callbacks which means "no error
	  // occurred", we error-wrap so the callback consumer can distinguish between
	  // "the promise rejected with null" or "the promise fulfilled with undefined".
	  if (!reason) {
	    var newReason = new Error('Promise was rejected with a falsy value');
	    newReason.reason = reason;
	    reason = newReason;
	  }
	  return cb(reason);
	}
	
	function callbackify(original) {
	  if (typeof original !== 'function') {
	    throw new TypeError('The "original" argument must be of type Function');
	  }
	
	  // We DO NOT return the promise as it gives the user a false sense that
	  // the promise is actually somehow related to the callback's execution
	  // and that the callback throwing will reject the promise.
	  function callbackified() {
	    var args = [];
	    for (var i = 0; i < arguments.length; i++) {
	      args.push(arguments[i]);
	    }
	
	    var maybeCb = args.pop();
	    if (typeof maybeCb !== 'function') {
	      throw new TypeError('The last argument must be of type Function');
	    }
	    var self = this;
	    var cb = function() {
	      return maybeCb.apply(self, arguments);
	    };
	    // In true node style we process the callback on `nextTick` with all the
	    // implications (stack, `uncaughtException`, `async_hooks`)
	    original.apply(this, args)
	      .then(function(ret) { process.nextTick(cb, null, ret) },
	            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
	  }
	
	  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
	  Object.defineProperties(callbackified,
	                          getOwnPropertyDescriptors(original));
	  return callbackified;
	}
	exports.callbackify = callbackify;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 528 */
/***/ function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null !== obj && 'object' === typeof obj;
	}
	
	module.exports = isObject;


/***/ },
/* 529 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 530 */
/***/ function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	var Format = {
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};
	
	module.exports = {
	    'default': Format.RFC3986,
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return String(value);
	        }
	    },
	    RFC1738: Format.RFC1738,
	    RFC3986: Format.RFC3986
	};


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	var StorageHandler = __webpack_require__(1845);
	var storage;
	var getStorage = function() {
	  if (!storage) {
	    storage = new StorageHandler();
	  }
	  return storage;
	};
	
	module.exports = {
	  getItem: function(key) {
	    var value = getStorage().getItem(key);
	    try {
	      return JSON.parse(value);
	    } catch (_) {
	      return value;
	    }
	  },
	  removeItem: function(key) {
	    return getStorage().removeItem(key);
	  },
	  setItem: function(key, value, options) {
	    var json = JSON.stringify(value);
	    return getStorage().setItem(key, json, options);
	  }
	};


/***/ },
/* 532 */
/***/ function(module, exports) {

	module.exports = { raw: '9.6.1' };


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(190);
	
	var windowHelper = __webpack_require__(101);
	var objectHelper = __webpack_require__(85);
	var RequestBuilder = __webpack_require__(275);
	var WebMessageHandler = __webpack_require__(853);
	var responseHandler = __webpack_require__(167);
	var storage = __webpack_require__(531);
	var times = __webpack_require__(851);
	
	function CrossOriginAuthentication(webAuth, options) {
	  this.webAuth = webAuth;
	  this.baseOptions = options;
	  this.request = new RequestBuilder(options);
	  this.webMessageHandler = new WebMessageHandler(webAuth);
	}
	
	function getFragment(name) {
	  var theWindow = windowHelper.getWindow();
	  var value = '&' + theWindow.location.hash.substring(1);
	  var parts = value.split('&' + name + '=');
	  if (parts.length === 2) {
	    return parts.pop().split('&').shift();
	  }
	}
	
	function createKey(origin, coId) {
	  return ['co/verifier', encodeURIComponent(origin), encodeURIComponent(coId)].join('/');
	}
	
	/**
	 * Logs in the user with username and password using the cross origin authentication (/co/authenticate) flow. You can use either `username` or `email` to identify the user, but `username` will take precedence over `email`.
	 * Some browsers might not be able to successfully authenticate if 3rd party cookies are disabled in your browser. [See here for more information.]{@link https://auth0.com/docs/cross-origin-authentication}.
	 * After the /co/authenticate call, you'll have to use the {@link parseHash} function at the `redirectUri` specified in the constructor.
	 *
	 * @method login
	 * @param {Object} options options used in the {@link authorize} call after the login_ticket is acquired
	 * @param {String} [options.username] Username (mutually exclusive with email)
	 * @param {String} [options.email] Email  (mutually exclusive with username)
	 * @param {String} options.password Password
	 * @param {String} [options.realm] Realm used to authenticate the user, it can be a realm name or a database connection name
	 * @param {crossOriginLoginCallback} cb Callback function called only when an authentication error, like invalid username or password, occurs. For other types of errors, there will be a redirect to the `redirectUri`.
	 */
	CrossOriginAuthentication.prototype.login = function(options, cb) {
	  var _this = this;
	  var url = urljoin(this.baseOptions.rootUrl, '/co/authenticate');
	  options.username = options.username || options.email;
	  delete options.email;
	
	  var authenticateBody = {
	    client_id: options.clientID || this.baseOptions.clientID,
	    username: options.username
	  };
	  if (options.password) {
	    authenticateBody.password = options.password;
	  }
	  if (options.otp) {
	    authenticateBody.otp = options.otp;
	  }
	  var realm = options.realm || this.baseOptions.realm;
	
	  if (realm) {
	    var credentialType =
	      options.credentialType ||
	      this.baseOptions.credentialType ||
	      'http://auth0.com/oauth/grant-type/password-realm';
	    authenticateBody.realm = realm;
	    authenticateBody.credential_type = credentialType;
	  } else {
	    authenticateBody.credential_type = 'password';
	  }
	  this.request.post(url).withCredentials().send(authenticateBody).end(function(err, data) {
	    if (err) {
	      var errorObject = (err.response && err.response.body) || {
	        error: 'request_error',
	        error_description: JSON.stringify(err)
	      };
	      return responseHandler(cb, { forceLegacyError: true })(errorObject);
	    }
	    var popupMode = options.popup === true;
	    options = objectHelper.blacklist(options, ['password', 'credentialType', 'otp', 'popup']);
	    var authorizeOptions = objectHelper
	      .merge(options)
	      .with({ loginTicket: data.body.login_ticket });
	    var key = createKey(_this.baseOptions.rootUrl, data.body.co_id);
	    storage.setItem(key, data.body.co_verifier, { expires: times.MINUTES_15 });
	    if (popupMode) {
	      _this.webMessageHandler.run(
	        authorizeOptions,
	        responseHandler(cb, { forceLegacyError: true })
	      );
	    } else {
	      _this.webAuth.authorize(authorizeOptions);
	    }
	  });
	};
	
	function tryGetVerifier(theWindow, key) {
	  try {
	    var verifier = storage.getItem(key);
	    storage.removeItem(key);
	    return verifier || '';
	  } catch (e) {
	    return '';
	  }
	}
	
	/**
	 * Runs the callback code for the cross origin authentication call. This method is meant to be called by the cross origin authentication callback url.
	 *
	 * @method callback
	 */
	CrossOriginAuthentication.prototype.callback = function() {
	  var targetOrigin = decodeURIComponent(getFragment('origin'));
	  var theWindow = windowHelper.getWindow();
	
	  theWindow.addEventListener('message', function(evt) {
	    if (evt.data.type !== 'co_verifier_request') {
	      return;
	    }
	    var key = createKey(evt.origin, evt.data.request.id);
	    var verifier = tryGetVerifier(theWindow, key);
	
	    evt.source.postMessage(
	      {
	        type: 'co_verifier_response',
	        response: {
	          verifier: verifier
	        }
	      },
	      evt.origin
	    );
	  });
	
	  theWindow.parent.postMessage({ type: 'ready' }, targetOrigin);
	};
	
	module.exports = CrossOriginAuthentication;


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var random = __webpack_require__(1842);
	var storage = __webpack_require__(531);
	var times = __webpack_require__(851);
	
	var DEFAULT_NAMESPACE = 'com.auth0.auth.';
	
	function TransactionManager(options) {
	  options = options || {};
	  this.namespace = options.namespace || DEFAULT_NAMESPACE;
	  this.keyLength = options.keyLength || 32;
	}
	
	TransactionManager.prototype.process = function(options) {
	  if (!options.responseType) {
	    throw new Error('responseType is required');
	  }
	  var lastUsedConnection = options.realm || options.connection;
	  var responseTypeIncludesIdToken = options.responseType.indexOf('id_token') !== -1;
	
	  var transaction = this.generateTransaction(
	    options.appState,
	    options.state,
	    options.nonce,
	    lastUsedConnection,
	    responseTypeIncludesIdToken
	  );
	  if (!options.state) {
	    options.state = transaction.state;
	  }
	
	  if (responseTypeIncludesIdToken && !options.nonce) {
	    options.nonce = transaction.nonce;
	  }
	
	  return options;
	};
	
	TransactionManager.prototype.generateTransaction = function(
	  appState,
	  state,
	  nonce,
	  lastUsedConnection,
	  generateNonce
	) {
	  state = state || random.randomString(this.keyLength);
	  nonce = nonce || (generateNonce ? random.randomString(this.keyLength) : null);
	
	  storage.setItem(
	    this.namespace + state,
	    {
	      nonce: nonce,
	      appState: appState,
	      state: state,
	      lastUsedConnection: lastUsedConnection
	    },
	    times.MINUTES_30
	  );
	  return {
	    state: state,
	    nonce: nonce
	  };
	};
	
	TransactionManager.prototype.getStoredTransaction = function(state) {
	  var transactionData;
	
	  transactionData = storage.getItem(this.namespace + state);
	  this.clearTransaction(state);
	  return transactionData;
	};
	
	TransactionManager.prototype.clearTransaction = function(state) {
	  storage.removeItem(this.namespace + state);
	};
	
	module.exports = TransactionManager;


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _campaignForm = __webpack_require__(864);
	
	var _campaignForm2 = _interopRequireDefault(_campaignForm);
	
	var _helpLink = __webpack_require__(546);
	
	var _helpLink2 = _interopRequireDefault(_helpLink);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noPadding = {
	  padding: '0'
	};
	
	var imageStyle = {
	  display: 'block',
	  margin: '170px auto 0px auto'
	};
	
	var leftBlockStyle = _extends({}, noPadding, {
	  backgroundColor: '#f7fafa',
	  borderRadius: '4px'
	});
	
	var rightBlockStyle = {
	  padding: '50px'
	};
	
	var linkWrapperStyle = {
	  width: '100%',
	  textAlign: 'center',
	  marginTop: 40
	};
	
	var AddCampaignModal = function AddCampaignModal(props) {
	  var title = props.title,
	      buttonLabel = props.buttonLabel,
	      onClose = props.onClose,
	      addCampaignFormProps = props.addCampaignFormProps,
	      onAddCampaignSubmit = props.onAddCampaignSubmit;
	
	  var _ThemeSelector$theme = _themeSelector2.default.theme(),
	      disableHelpLinks = _ThemeSelector$theme.disableHelpLinks;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      open: true,
	      onClose: onClose
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      { style: noPadding },
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          { style: noPadding },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 8, style: leftBlockStyle },
	            _react2.default.createElement(_semanticUiReact.Image, { src: '/images/add-campaign.svg', style: imageStyle }),
	            !disableHelpLinks && _react2.default.createElement(
	              'div',
	              { style: linkWrapperStyle },
	              _react2.default.createElement(_helpLink2.default, { url: 'https://help.dyzio.co/en/articles/5089448-how-to-create-a-campaign' })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 8, style: rightBlockStyle },
	            _react2.default.createElement(
	              'h3',
	              null,
	              title
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	            _react2.default.createElement(_campaignForm2.default, addCampaignFormProps),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	            _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	              onClick: onAddCampaignSubmit,
	              fluid: true,
	              label: buttonLabel,
	              hasIcon: true,
	              icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'save' }),
	              floated: false
	            }),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	          )
	        )
	      )
	    )
	  );
	};
	
	AddCampaignModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  onAddCampaignSubmit: _propTypes2.default.func.isRequired,
	  addCampaignFormProps: _propTypes2.default.object.isRequired,
	  title: _propTypes2.default.string,
	  buttonLabel: _propTypes2.default.string
	};
	
	AddCampaignModal.defaultProps = {
	  title: 'Add a campaign',
	  buttonLabel: 'Save'
	};
	
	exports.default = AddCampaignModal;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _v = __webpack_require__(1787);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactDatepicker = __webpack_require__(445);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _authService = __webpack_require__(21);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INITIAL_STATE = {
	  success: false,
	  storyDescription: null,
	  assetURL: null,
	  assetType: 'STORY',
	  publishedDate: null,
	  platform: 'INSTAGRAM'
	};
	
	var requiredStyle = {
	  color: '#db2828'
	};
	
	var AddStoryModal = function (_Component) {
	  _inherits(AddStoryModal, _Component);
	
	  function AddStoryModal() {
	    var _this2 = this;
	
	    _classCallCheck(this, AddStoryModal);
	
	    var _this = _possibleConstructorReturn(this, (AddStoryModal.__proto__ || Object.getPrototypeOf(AddStoryModal)).call(this));
	
	    _this.toggler = function () {
	      var popupToggleHandler = _this.props.popupToggleHandler;
	
	      _this.setState(INITIAL_STATE);
	      popupToggleHandler();
	    };
	
	    _this.addStory = function () {
	      var _this$state = _this.state,
	          storyDescription = _this$state.storyDescription,
	          platform = _this$state.platform,
	          publishedDate = _this$state.publishedDate,
	          assetURL = _this$state.assetURL,
	          assetType = _this$state.assetType;
	      var _this$props = _this.props,
	          successHandler = _this$props.successHandler,
	          campaignId = _this$props.campaignId,
	          discussionId = _this$props.discussionId,
	          discussionName = _this$props.discussionName,
	          jsonAPIClient = _this$props.jsonAPIClient;
	
	      var uuid = (0, _v2.default)();
	      var dyzioURL = 'http://app.dyzio.co/assets/' + uuid;
	      var extraData = {
	        text: storyDescription
	      };
	      var trackedAsset = jsonAPIClient.create('trackedAssets');
	      trackedAsset.set('assetId', uuid);
	      trackedAsset.set('assetURL', assetURL || dyzioURL);
	      trackedAsset.set('extraData', extraData);
	      trackedAsset.set('publishedDate', publishedDate);
	      trackedAsset.set('user', {
	        type: 'users',
	        id: _authService.authService.uid()
	      });
	      trackedAsset.set('campaign', {
	        type: 'campaigns',
	        id: campaignId
	      });
	      trackedAsset.set('discussion', {
	        type: 'discussions',
	        id: discussionId
	      });
	
	      trackedAsset.set('discussionName', discussionName);
	      trackedAsset.set('platform', platform);
	      trackedAsset.set('assetType', assetType);
	      trackedAsset.set('createdSource', 'CAMPAIGN');
	
	      return trackedAsset.sync().then(function (response) {
	        var newTrackedAsset = response.toJSON();
	        var mainUrl = '' + ("https://api2.dyzio.co/v1");
	        var relUrl = mainUrl + '/discussions/' + discussionId + '/relationships/trackedAssets';
	        _this.restClient.post(relUrl, {
	          data: {
	            type: 'trackedAssets',
	            id: newTrackedAsset.id
	          }
	        }).then(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  _context.next = 2;
	                  return _this.restClient.patch(mainUrl + '/discussions/' + discussionId, {
	                    data: {
	                      attributes: {
	                        hasPosted: true
	                      }
	                    }
	                  });
	
	                case 2:
	                  successHandler(newTrackedAsset);
	                  _this.toggler();
	
	                case 4:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        })));
	      }).catch(function (e) {
	        console.log('Error', e);
	      });
	    };
	
	    _this.handleChange = function (e, _ref2) {
	      var name = _ref2.name,
	          value = _ref2.value;
	
	      var newState = _defineProperty({}, name, value);
	      if (name === 'platform') {
	        newState.assetType = null;
	      }
	      if (name === 'platform' && value === 'INSTAGRAM') {
	        newState.assetType = 'STORY';
	      }
	      if (name === 'platform' && value === 'BLOG') {
	        newState.assetType = 'TEXT';
	      }
	      _this.setState(newState);
	    };
	
	    _this.handleDateInputChange = function (date, event) {
	      event.preventDefault();
	      var publishedDate = date.set('hour', 15).format();
	      _this.setState({
	        publishedDate: publishedDate
	      });
	    };
	
	    _this.state = INITIAL_STATE;
	
	    _this.restClient = _axios2.default.create({
	      timeout: 5000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(AddStoryModal, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          storyDescription = _state.storyDescription,
	          assetURL = _state.assetURL,
	          platform = _state.platform,
	          publishedDateAsString = _state.publishedDate,
	          assetType = _state.assetType;
	      var popupToggleHandler = this.props.popupToggleHandler;
	
	
	      var saveDisabled = !(storyDescription && publishedDateAsString && assetType);
	
	      if (platform !== 'INSTAGRAM' && platform !== 'SNAPCHAT' && !assetURL) {
	        saveDisabled = true;
	      }
	
	      var publishedDate = publishedDateAsString ? (0, _moment2.default)(publishedDateAsString) : '';
	
	      var options = [{
	        text: 'Instagram Story ',
	        value: 'INSTAGRAM'
	      }, {
	        text: 'Snapchat',
	        value: 'SNAPCHAT',
	        assetTypes: [{ text: 'Video', value: 'VIDEO' }, { text: 'Image', value: 'IMAGE' }]
	      }, {
	        text: 'VK',
	        value: 'VK',
	        assetTypes: [{ text: 'Video', value: 'VIDEO' }, { text: 'Image', value: 'IMAGE' }, { text: 'Text', value: 'TEXT' }]
	      }, {
	        text: 'Blog Post',
	        value: 'BLOG',
	        assetTypes: [{ text: 'Text', value: 'TEXT' }]
	      }];
	
	      var selectedPlatform = _lodash2.default.find(options, ['value', platform]);
	
	      return _react2.default.createElement(
	        _dyzioModal2.default,
	        {
	          onClose: popupToggleHandler,
	          headerText: 'add other posts & stories',
	          headerDescription: 'Manually add posts and data from social networks and content, not yet supported by dyzio.',
	          size: 'small',
	          hasActionButton: true,
	          actionButtonContent: 'Add',
	          actionButtonColor: 'pink',
	          actionButtonIcon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'add' }),
	          onActionButtonClick: this.addStory,
	          shouldDisableActionButton: saveDisabled
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          { textAlign: 'left' },
	          _react2.default.createElement(
	            _semanticUiReact.Form,
	            null,
	            _react2.default.createElement(_semanticUiReact.Form.Select, {
	              label: 'Platform',
	              options: options,
	              value: platform,
	              name: 'platform',
	              onChange: this.handleChange
	            }),
	            selectedPlatform && selectedPlatform.assetTypes && _react2.default.createElement(_semanticUiReact.Form.Select, {
	              required: true,
	              label: 'Asset type',
	              options: selectedPlatform.assetTypes,
	              value: assetType,
	              name: 'assetType',
	              onChange: this.handleChange,
	              placeholder: 'Please select'
	            }),
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              required: true,
	              placeholder: 'a description for reporting',
	              label: 'Description',
	              value: storyDescription,
	              name: 'storyDescription',
	              onChange: this.handleChange
	            }),
	            platform !== 'INSTAGRAM' && platform !== 'SNAPCHAT' && _react2.default.createElement(_semanticUiReact.Form.Input, {
	              required: true,
	              type: 'text',
	              placeholder: 'link to blog post or social post',
	              label: 'Link to post',
	              value: assetURL,
	              name: 'assetURL',
	              onChange: this.handleChange
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'publishedDate' },
	                'Published date ',
	                _react2.default.createElement(
	                  'span',
	                  { style: requiredStyle },
	                  '*'
	                ),
	                _react2.default.createElement(_reactDatepicker2.default, {
	                  onChange: this.handleDateInputChange,
	                  id: 'publishedDate',
	                  placeholderText: 'e.g. ' + (0, _moment2.default)().format('DD/MM/Y'),
	                  selected: publishedDate,
	                  dateFormat: 'DD/MM/Y'
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddStoryModal;
	}(_react.Component);
	
	AddStoryModal.propTypes = {
	  popupToggleHandler: _propTypes2.default.func.isRequired,
	  successHandler: _propTypes2.default.func.isRequired,
	  campaignId: _propTypes2.default.string.isRequired,
	  discussionId: _propTypes2.default.string.isRequired,
	  discussionName: _propTypes2.default.string.isRequired,
	  jsonAPIClient: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasJsonapiClient2.default)(AddStoryModal);

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(37);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _notAvailableComponent = __webpack_require__(242);
	
	var _notAvailableComponent2 = _interopRequireDefault(_notAvailableComponent);
	
	var _recompose = __webpack_require__(15);
	
	var _dyzioIcons = __webpack_require__(92);
	
	var _formatting = __webpack_require__(287);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _uploadModal = __webpack_require__(920);
	
	var _uploadModal2 = _interopRequireDefault(_uploadModal);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _privateDataComponent = __webpack_require__(351);
	
	var _privateDataComponent2 = _interopRequireDefault(_privateDataComponent);
	
	var _facebookImpressions = __webpack_require__(1935);
	
	var _facebookImpressions2 = _interopRequireDefault(_facebookImpressions);
	
	var _youtubeImpressions = __webpack_require__(2039);
	
	var _youtubeImpressions2 = _interopRequireDefault(_youtubeImpressions);
	
	var _instagramImpressions = __webpack_require__(1990);
	
	var _instagramImpressions2 = _interopRequireDefault(_instagramImpressions);
	
	var _facebookInsightsModal = __webpack_require__(1936);
	
	var _facebookInsightsModal2 = _interopRequireDefault(_facebookInsightsModal);
	
	var _youtubeInsightsModal = __webpack_require__(2040);
	
	var _youtubeInsightsModal2 = _interopRequireDefault(_youtubeInsightsModal);
	
	var _instagramInsightsModal = __webpack_require__(1991);
	
	var _instagramInsightsModal2 = _interopRequireDefault(_instagramInsightsModal);
	
	var _instagramStoryModal = __webpack_require__(2165);
	
	var _instagramStoryModal2 = _interopRequireDefault(_instagramStoryModal);
	
	var _deleteAssetDialog = __webpack_require__(1931);
	
	var _deleteAssetDialog2 = _interopRequireDefault(_deleteAssetDialog);
	
	var _favouriteStar = __webpack_require__(347);
	
	var _favouriteStar2 = _interopRequireDefault(_favouriteStar);
	
	var _noAssetsCard = __webpack_require__(2004);
	
	var _noAssetsCard2 = _interopRequireDefault(_noAssetsCard);
	
	var _automationUtils = __webpack_require__(929);
	
	var _hashtagsUtils = __webpack_require__(232);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _vk = __webpack_require__(1889);
	
	var _vk2 = _interopRequireDefault(_vk);
	
	var _snapchat = __webpack_require__(1888);
	
	var _snapchat2 = _interopRequireDefault(_snapchat);
	
	var _blog = __webpack_require__(1887);
	
	var _blog2 = _interopRequireDefault(_blog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TIKTOK_THUMBNAIL_RETRY = 2;
	
	var FETCHING = 'FETCHING';
	
	var PLATFORMS_WITHOUT_ANALYTICS = [_staticConfiguration.BLOG, _staticConfiguration.VK, _staticConfiguration.SNAPCHAT, _staticConfiguration.TIKTOK, _staticConfiguration.TELEGRAM];
	
	var assetTableStyles = {
	  padding: 0
	};
	
	var removeActionStyles = {
	  cursor: 'pointer'
	};
	
	var isGraphQLEmpty = function isGraphQLEmpty(obj) {
	  return obj && obj.length === 1 && obj[0] === null;
	};
	
	var getViews = function getViews(asset) {
	  //
	  if (_lodash2.default.isNil(_lodash2.default.get(asset, 'latestStatistic.viewCount'))) {
	    return _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'views', assetType: 'image' });
	  }
	
	  if (_lodash2.default.get(asset, 'isReel') === true) {
	    return (0, _formatting.sf)(_lodash2.default.get(asset, 'latestStatistic.playCount', 0));
	  }
	
	  return (0, _formatting.sf)(_lodash2.default.get(asset, 'latestStatistic.viewCount', 0));
	};
	
	var fetchingData = function fetchingData() {
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'hourglass empty', color: 'orange' });
	};
	
	var dyzioRedStyle = { color: '#ef3a50' };
	var dyzioOrangeStyle = { color: 'orange' };
	
	var assetErrorRed = function assetErrorRed() {
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning sign', style: dyzioRedStyle });
	};
	
	var assetError = function assetError() {
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning sign', style: dyzioOrangeStyle });
	};
	
	var assetWarning = function assetWarning() {
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'question circle', style: dyzioOrangeStyle });
	};
	
	var FacebookPostType = function FacebookPostType(_ref) {
	  var asset = _ref.asset;
	
	  var pt = void 0;
	  pt = asset.postType;
	
	  if (!pt) {
	    pt = asset.isVideo ? 'video' : 'photo';
	  }
	
	  var types = {
	    video: _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', color: 'blue' }),
	    photo: _react2.default.createElement(_semanticUiReact.Icon, { name: 'image', color: 'blue' }),
	    post: _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment outline', color: 'blue' }),
	    pagepost: _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment outline', color: 'blue' })
	  };
	  return types[pt];
	};
	
	var UploadSupportingFiles = function UploadSupportingFiles(_ref2) {
	  var value = _ref2.value,
	      handler = _ref2.handler;
	  return _react2.default.createElement(_semanticUiReact.Button, {
	    size: 'mini',
	    inverted: true,
	    circular: true,
	    onClick: function onClick() {
	      return handler(value);
	    },
	    icon: 'plus',
	    color: 'green'
	  });
	};
	
	var S3_PREFIX = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production';
	var imageWrapperStyle = {
	  maxHeight: 500,
	  overflowY: 'scroll',
	  marginBottom: 10
	};
	
	var DeleteButton = function DeleteButton(props) {
	  return _react2.default.createElement(_semanticUiReact.Button, {
	    size: 'mini',
	    key: props.value,
	    onClick: props.handler,
	    value: props.value,
	    compact: true,
	    circular: true,
	    icon: 'delete'
	  });
	};
	
	DeleteButton.propTypes = {
	  handler: _propTypes2.default.func.isRequired,
	  value: _propTypes2.default.string.isRequired
	};
	
	var thumbnailStyle = { width: 100, height: 80, objectFit: 'cover' };
	var ribbonStyle = { border: '1px solid #ccc', paddingTop: 2, paddingBottom: 2, fontSize: '95%' };
	
	var getInstagramType = function getInstagramType(a) {
	  if (a.trackedAsset.assetType === 'STORY') {
	    return 'STORY';
	  }
	
	  if (a.isReel) {
	    return 'REEL';
	  }
	
	  if (a.isIGTV) {
	    return 'IGTV';
	  }
	
	  if (a.isVideo) {
	    return 'VIDEO';
	  }
	
	  if (a.isCarousel) {
	    return 'CAROUSEL';
	  }
	
	  return 'IMAGE';
	};
	
	var getFilter = function getFilter(platform) {
	  return { trackedAsset: { platform: platform } };
	};
	
	var AssetTable = function (_React$Component) {
	  _inherits(AssetTable, _React$Component);
	
	  //
	  function AssetTable(props) {
	    _classCallCheck(this, AssetTable);
	
	    var _this = _possibleConstructorReturn(this, (AssetTable.__proto__ || Object.getPrototypeOf(AssetTable)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      assetToBeDeleted: null,
	      deleteDialogVisible: false,
	      selectedAsset: null,
	      selectedInsights: null,
	      newAssets: [],
	      facebookInsightsModalVisible: false,
	      youtubeInsightsModalVisible: false,
	      InstagramInsightsModalVisible: false,
	      selectedStory: false,
	      storyViewModalVisible: false,
	      updatingAssetId: null
	    };
	    return _this;
	  }
	
	  _createClass(AssetTable, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var assets = this.props.assets;
	
	      var numAssets = assets ? assets.length : 0;
	      var hasFacebook = assets && _lodash2.default.filter(assets, getFilter('FACEBOOK')).length > 0;
	      var hasTwitter = assets && _lodash2.default.filter(assets, getFilter('TWITTER')).length > 0;
	      var hasInstagram = assets && _lodash2.default.filter(assets, getFilter('INSTAGRAM')).length > 0;
	      var isInstagramOnly = assets && _lodash2.default.filter(assets, getFilter('INSTAGRAM')).length === numAssets;
	      var hasTiktok = assets && _lodash2.default.filter(assets, { platform: _staticConfiguration.TIKTOK }).length > 0;
	
	      this.setState({
	        hasFacebook: hasFacebook,
	        hasTwitter: hasTwitter,
	        hasInstagram: hasInstagram,
	        isInstagramOnly: isInstagramOnly,
	        hasTiktok: hasTiktok
	      });
	    }
	  }]);
	
	  return AssetTable;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.toggleFavoriteState = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref4) {
	      var assetId = _ref4.assetId,
	          favourite = _ref4.favourite,
	          assetType = _ref4.assetType;
	
	      var _props, restClient, toggleAssetLocalState, url;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _props = _this2.props, restClient = _props.restClient, toggleAssetLocalState = _props.toggleAssetLocalState;
	              url = (assetType === 'stories' ? 'stories' : 'trackedAssets') + '/' + assetId;
	              _context.next = 4;
	              return restClient.patch(url, {
	                data: {
	                  attributes: {
	                    favourite: !favourite
	                  }
	                }
	              });
	
	            case 4:
	              toggleAssetLocalState(assetId, !favourite);
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    return function (_x) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  this.refreshPage = function () {
	    window.location.reload(true);
	  };
	
	  this.removeSupportingData = function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(_ref6) {
	      var id = _ref6.id,
	          type = _ref6.type,
	          supportingData = _ref6.supportingData;
	      var jsonAPIClient;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              jsonAPIClient = _this2.props.jsonAPIClient;
	              return _context3.abrupt('return', jsonAPIClient.get(type, id).then(function () {
	                var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(response) {
	                  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, toBeRemoved;
	
	                  return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                      switch (_context2.prev = _context2.next) {
	                        case 0:
	                          // eslint-disable-next-line no-restricted-syntax
	                          _iteratorNormalCompletion = true;
	                          _didIteratorError = false;
	                          _iteratorError = undefined;
	                          _context2.prev = 3;
	                          _iterator = supportingData[Symbol.iterator]();
	
	                        case 5:
	                          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                            _context2.next = 14;
	                            break;
	                          }
	
	                          data = _step.value;
	                          _context2.next = 9;
	                          return jsonAPIClient.get('supportingData', data.id);
	
	                        case 9:
	                          toBeRemoved = _context2.sent;
	
	                          response.relationships('supportingData').remove(toBeRemoved);
	
	                        case 11:
	                          _iteratorNormalCompletion = true;
	                          _context2.next = 5;
	                          break;
	
	                        case 14:
	                          _context2.next = 20;
	                          break;
	
	                        case 16:
	                          _context2.prev = 16;
	                          _context2.t0 = _context2['catch'](3);
	                          _didIteratorError = true;
	                          _iteratorError = _context2.t0;
	
	                        case 20:
	                          _context2.prev = 20;
	                          _context2.prev = 21;
	
	                          if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                          }
	
	                        case 23:
	                          _context2.prev = 23;
	
	                          if (!_didIteratorError) {
	                            _context2.next = 26;
	                            break;
	                          }
	
	                          throw _iteratorError;
	
	                        case 26:
	                          return _context2.finish(23);
	
	                        case 27:
	                          return _context2.finish(20);
	
	                        case 28:
	                          _context2.next = 30;
	                          return response.sync();
	
	                        case 30:
	                          _this2.refreshPage();
	
	                        case 31:
	                        case 'end':
	                          return _context2.stop();
	                      }
	                    }
	                  }, _callee2, _this2, [[3, 16, 20, 28], [21,, 23, 27]]);
	                }));
	
	                return function (_x3) {
	                  return _ref7.apply(this, arguments);
	                };
	              }()));
	
	            case 2:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    return function (_x2) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  this.SupportingDataCount = function (asset) {
	    var _ref8 = asset.trackedAsset || asset,
	        supportingData = _ref8.supportingData,
	        id = _ref8.id,
	        type = _ref8.type;
	
	    var compacted = _lodash2.default.compact(supportingData);
	    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(compacted, function (o) {
	      return o.createdDate;
	    }));
	
	    if (ordered.length) {
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        {
	          scrolling: true,
	          size: 'small',
	          trigger: _react2.default.createElement(_semanticUiReact.Button, {
	            size: 'mini',
	            inverted: true,
	            circular: true,
	            content: ordered.length,
	            color: 'green'
	          })
	        },
	        _react2.default.createElement(_semanticUiReact.Header, { icon: 'file image outline', content: 'Supporting files' }),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          null,
	          _lodash2.default.map(ordered, function (data, idx) {
	            return _react2.default.createElement(
	              'div',
	              { style: imageWrapperStyle },
	              _react2.default.createElement(_semanticUiReact.Image, {
	                src: S3_PREFIX + '/' + data.filePath,
	                size: 'small',
	                floated: 'left'
	              }),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', rel: 'noopener noreferrer', href: data.assetUrl },
	                    data.assetUrl
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'impressions: ',
	                  data.impressions
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'reach: ',
	                  data.reach
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'views: ',
	                  data.views
	                ),
	                data.clicks && _react2.default.createElement(
	                  'p',
	                  null,
	                  'clicks: ',
	                  data.clicks
	                ),
	                data.shares && _react2.default.createElement(
	                  'p',
	                  null,
	                  'shares: ',
	                  data.shares
	                ),
	                data.saves && _react2.default.createElement(
	                  'p',
	                  null,
	                  'saves: ',
	                  data.saves
	                ),
	                data.stickerTaps && _react2.default.createElement(
	                  'p',
	                  null,
	                  'sticker taps: ',
	                  data.stickerTaps
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '---'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Created By'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  data.createdBy
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  (0, _moment2.default)(data.createdData).format('YYYY-DD-MM')
	                ),
	                idx === 0 && _react2.default.createElement(
	                  'h5',
	                  { style: { color: 'orange', paddingTop: 20 } },
	                  'This is the LATEST supporting data and will be used in the reports'
	                )
	              ),
	              _react2.default.createElement('div', { style: { clear: 'left' } }),
	              _react2.default.createElement(_semanticUiReact.Divider, null)
	            );
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Actions,
	          {
	            style: removeActionStyles,
	            className: 'align-center',
	            onClick: function onClick() {
	              _this2.removeSupportingData({ id: id, type: type, supportingData: supportingData });
	            }
	          },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'remove all supporting data'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Actions,
	          { className: 'align-center' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'press ESCAPE to close'
	          )
	        )
	      );
	    }
	    return null;
	  };
	
	  this.openDeleteDialog = function (asset) {
	    _this2.setState(function (prevState) {
	      return {
	        deleteDialogVisible: !prevState.deleteDialogVisible,
	        assetToBeDeleted: asset
	      };
	    });
	  };
	
	  this.closeDeleteDialog = function () {
	    return _this2.setState({
	      deleteDialogVisible: false
	    });
	  };
	
	  this.toggleUploadModal = function () {
	    var uploadSupportingVisible = _this2.state.uploadSupportingVisible;
	
	    _this2.setState({ uploadSupportingVisible: !uploadSupportingVisible });
	  };
	
	  this.toggleAddStoryModal = function () {
	    var addStoryVisible = _this2.state.addStoryVisible;
	
	    _this2.setState({ addStoryVisible: !addStoryVisible });
	  };
	
	  this.toggleStoryViewModal = function (id) {
	    var inDeleteMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    _this2.setState({
	      selectedStory: id,
	      storyViewModalVisible: true,
	      storyViewModelInDeleteMode: inDeleteMode
	    });
	  };
	
	  this.toggleFacebookInsightsModal = function (insights) {
	    var facebookInsightsModalVisible = _this2.state.facebookInsightsModalVisible;
	
	    _this2.setState({
	      facebookInsightsModalVisible: !facebookInsightsModalVisible,
	      selectedInsights: insights
	    });
	  };
	
	  this.toggleYoutubeInsightsModal = function (insights) {
	    var youtubeInsightsModalVisible = _this2.state.youtubeInsightsModalVisible;
	
	    _this2.setState({
	      youtubeInsightsModalVisible: !youtubeInsightsModalVisible,
	      selectedInsights: insights
	    });
	  };
	
	  this.toggleInstagramInsightsModal = function (insights, post) {
	    var instagramInsightsModalVisible = _this2.state.instagramInsightsModalVisible;
	
	    _this2.setState({
	      instagramInsightsModalVisible: !instagramInsightsModalVisible,
	      selectedInsights: insights,
	      selectedPost: post
	    });
	  };
	
	  this.supportFilesHandler = function (value) {
	    console.log('VA', value);
	    var selectedAsset = value.trackedAsset || value;
	    console.log('VA SELECTED', selectedAsset);
	    // selectedAsset.text = _.get(value, 'text', _.get(value, 'extraData.text', 'No caption'));
	    // const selectedAssetPostType = selectedAsset.postType || selectedAsset.isVideo ? 'video' : 'photo';
	    _this2.setState({
	      selectedAsset: selectedAsset
	      // selectedAssetPostType,
	    }, _this2.toggleUploadModal);
	  };
	
	  this.addSupportingFile = function (result) {
	    var selectedAsset = _this2.state.selectedAsset;
	
	    selectedAsset.supportingData.push(result);
	  };
	
	  this.getCloudFrontUrl = function (rawUrl) {
	    var updatedSavedThumbnailUrl = _lodash2.default.replace(rawUrl, 'https://s3-eu-west-1.amazonaws.com/dyzio-stories/', 'https://ri.dyzio.co/');
	
	    return updatedSavedThumbnailUrl;
	  };
	
	  this.getRow = function (a, deleteHandler, influencer) {
	    var assetPropShape = _extends({}, a, {
	      trackedAsset: a
	    });
	
	    var instagramAuthorised = influencer.instagramAuthorised,
	        youtubeAuthorised = influencer.youtubeAuthorised,
	        facebookAuthorised = influencer.facebookAuthorised;
	
	    if (_lodash2.default.get(a, 'platform') === _staticConfiguration.VK) {
	      return _react2.default.createElement(_vk2.default, {
	        asset: a,
	        favouriteStateHandler: _this2.toggleFavoriteState,
	        uploadSupportingDataComponent: _react2.default.createElement(UploadSupportingFiles, {
	          value: assetPropShape,
	          handler: _this2.supportFilesHandler
	        }),
	        supportingDataComponent: _this2.SupportingDataCount(a)
	      });
	    }
	    if (_lodash2.default.get(a, 'platform') === _staticConfiguration.SNAPCHAT) {
	      return _react2.default.createElement(_snapchat2.default, {
	        asset: a,
	        favouriteStateHandler: _this2.toggleFavoriteState,
	        uploadSupportingDataComponent: _react2.default.createElement(UploadSupportingFiles, {
	          value: assetPropShape,
	          handler: _this2.supportFilesHandler
	        }),
	        supportingDataComponent: _this2.SupportingDataCount(a)
	      });
	    }
	    if (a.platform === 'BLOG') {
	      return _react2.default.createElement(_blog2.default, {
	        asset: a,
	        favouriteStateHandler: _this2.toggleFavoriteState,
	        uploadSupportingDataComponent: _react2.default.createElement(UploadSupportingFiles, {
	          value: assetPropShape,
	          handler: _this2.supportFilesHandler
	        }),
	        supportingDataComponent: _this2.SupportingDataCount(a)
	      });
	    }
	    if (a.platform === _staticConfiguration.TIKTOK) {
	      var initialData = a.initialData,
	          savedThumbnailUrl = a.savedThumbnailUrl,
	          createdDate = a.createdDate;
	
	      var tiktokData = void 0;
	      var tikTokEngs = void 0;
	      if (a.tiktokData) {
	        var tiktokDataByDate = _lodash2.default.sortBy(a.tiktokData, 'createdDate');
	        tiktokData = _lodash2.default.last(tiktokDataByDate);
	        tikTokEngs = tiktokData.shareCount + tiktokData.diggCount + tiktokData.commentCount;
	      }
	      var daysSinceCreated = (0, _moment2.default)().diff(createdDate, 'days');
	      var pendingThumbnail = daysSinceCreated < TIKTOK_THUMBNAIL_RETRY;
	      var imageSrc = savedThumbnailUrl && _this2.getCloudFrontUrl(savedThumbnailUrl);
	      var noImageComponent = function noImageComponent(pending) {
	        return pending ? _react2.default.createElement(
	          'div',
	          { style: { paddingBottom: 3 } },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'hourglass empty', size: 'large', color: 'orange' })
	        ) : _react2.default.createElement(
	          'div',
	          { style: { paddingBottom: 3 } },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'image empty', size: 'large' }),
	          'No image available'
	        );
	      };
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          imageSrc ? _react2.default.createElement('img', { src: imageSrc, style: thumbnailStyle, alt: 'asset thumbnail' }) : noImageComponent(pendingThumbnail),
	          _react2.default.createElement(
	            'h4',
	            { style: ribbonStyle },
	            _react2.default.createElement(_dyzioIcons.TiktokIcon, { size: 'large' }),
	            'TIKTOK'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            a.publishedDate && (0, _moment2.default)(a.publishedDate).format('YYYY-MM-DD')
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { textAlign: 'left' },
	          initialData ? initialData.text || initialData.desc : 'Data and thumbnail being fetched from TikTok'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            'views: ',
	            tiktokData ? (0, _formatting.sf)(tiktokData.playCount) : 'OPEN CR'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'engagements:',
	            tiktokData ? (0, _formatting.sf)(tikTokEngs) : 'OPEN CR'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus', color: 'grey' })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle thin', color: 'grey' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_favouriteStar2.default, { asset: a, onClick: _this2.toggleFavoriteState })
	        ),
	        _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	        _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(DeleteButton, {
	            handler: function handler() {
	              return _this2.openDeleteDialog(_extends({
	                thumbnail: a.savedThumbnailUrl,
	                trackedAsset: a,
	                text: initialData.text
	              }, a));
	            }
	          })
	        )
	      );
	    }
	
	    if (a.platform === _staticConfiguration.TELEGRAM) {
	      console.log(a.initialData);
	
	      if (a.initialData) {
	        var _a$initialData = a.initialData,
	            text = _a$initialData.text,
	            thumbnail = _a$initialData.thumbnail,
	            views = _a$initialData.views,
	            forwards = _a$initialData.forwards,
	            replies = _a$initialData.replies;
	
	        var trimmedText = _lodash2.default.truncate(text, { length: 200, separator: ' ' });
	        var _imageSrc = 'https://pics.dyzio.co/' + thumbnail;
	        return _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement('img', { src: _imageSrc, style: thumbnailStyle, alt: 'asset thumbnail' }),
	            _react2.default.createElement(
	              'h4',
	              { style: ribbonStyle },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram plane', size: 'large', color: 'blue' }),
	              'TELEGRAM'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { textAlign: 'left' },
	            _react2.default.createElement(
	              'p',
	              { style: { height: 70, overFlowY: 'hidden', verticalAlign: 'middle' } },
	              trimmedText
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { textAlign: 'center' } },
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', rel: 'noopener noreferrer', href: a.assetURL },
	                a.assetURL
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              'views: ',
	              (0, _formatting.sf)(views)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'forwards: ',
	              (0, _formatting.sf)(forwards)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'replies: ',
	              (0, _formatting.sf)(replies)
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle thin', color: 'grey' })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(_favouriteStar2.default, { asset: a, onClick: _this2.toggleFavoriteState })
	          ),
	          _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	          _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(DeleteButton, {
	              handler: function handler() {
	                return _this2.openDeleteDialog(_extends({
	                  thumbnail: _imageSrc,
	                  trackedAsset: a,
	                  text: a.initialData.text
	                }, a));
	              }
	            })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { paddingBottom: 3 } },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'hourglass empty', size: 'large', color: 'orange' })
	          ),
	          _react2.default.createElement(
	            'h4',
	            { style: ribbonStyle },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram plane', size: 'large', color: 'blue' }),
	            'TELEGRAM'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { textAlign: 'left' },
	          'loading...'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'loading...'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle thin', color: 'grey' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          '-'
	        ),
	        _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	        _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          '-'
	        )
	      );
	    }
	    if (a.notFound) {
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: _lodash2.default.toLower(a.trackedAsset.platform), color: 'red' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { textAlign: 'left' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'this post has been removed from ',
	            a.trackedAsset.platform
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          assetWarning()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          assetWarning()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          assetWarning()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          assetWarning()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          assetWarning()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(DeleteButton, {
	            handler: function handler() {
	              return _this2.openDeleteDialog(_extends({}, a));
	            }
	          })
	        )
	      );
	    }
	    if (a.withError) {
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: _lodash2.default.toLower(a.trackedAsset.platform), color: 'red' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { textAlign: 'left' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Loading asset... \xA0',
	            _react2.default.createElement(
	              _targetLink2.default,
	              {
	                href: a.trackedAsset.assetURL,
	                renderIf: true
	              },
	              'view asset ',
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'share external' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          assetError()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          assetError()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          assetError()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          assetError()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          assetError()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(DeleteButton, {
	            handler: function handler() {
	              return _this2.openDeleteDialog(_extends({}, a));
	            }
	          })
	        )
	      );
	    }
	    if (a.state === FETCHING) {
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: _lodash2.default.toLower(a.trackedAsset.platform), color: 'orange' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          fetchingData()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          fetchingData()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          fetchingData()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          fetchingData()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          fetchingData()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          fetchingData()
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          fetchingData()
	        )
	      );
	    }
	
	    // MANUALLY ADDED STORY
	    if (a.trackedAsset.assetType === 'STORY') {
	      var impressions = void 0;
	      var engagements = void 0;
	      var _thumbnail = void 0;
	      var supportingData = a.trackedAsset.supportingData;
	
	      if (supportingData && !isGraphQLEmpty(supportingData)) {
	        var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
	        var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
	          return o.createdDate;
	        }));
	        var latestSupportingData = ordered[0];
	        if (latestSupportingData) {
	          impressions = latestSupportingData.impressions;
	          engagements = latestSupportingData.engagements;
	          _thumbnail = S3_PREFIX + '/' + latestSupportingData.filePath;
	        }
	      }
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(
	            'h4',
	            { style: ribbonStyle },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink', size: 'large' }),
	            getInstagramType(a)
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { textAlign: 'left' },
	          a.text
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            'views: ',
	            (0, _formatting.sf)(a.latestStatistic.openCount)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'engagements: ',
	            (0, _formatting.sf)(engagements)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _formatting.sf)(impressions)
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle thin', color: 'grey' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_favouriteStar2.default, { asset: a, onClick: _this2.toggleFavoriteState })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(UploadSupportingFiles, { value: a, handler: _this2.supportFilesHandler })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _this2.SupportingDataCount(a)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(DeleteButton, {
	            handler: function handler() {
	              return _this2.openDeleteDialog(_extends({
	                thumbnail: _thumbnail
	              }, a));
	            }
	          })
	        )
	      );
	    }
	
	    switch (a.trackedAsset.platform) {
	      case 'YOUTUBE':
	        {
	          var latestStatistic = _lodash2.default.last(a.statistics);
	          return _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement('img', { src: a.thumbnail, style: thumbnailStyle, alt: 'asset thumbnail' }),
	              _react2.default.createElement(
	                'h4',
	                { style: ribbonStyle },
	                'YOUTUBE VIDEO'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { textAlign: 'left' },
	              a.title
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                'views: ',
	                (0, _formatting.sf)(latestStatistic.viewCount)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'likes: ',
	                (0, _formatting.sf)(latestStatistic.likeCount)
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { width: 120, margin: '0 auto' } },
	                youtubeAuthorised ? _react2.default.createElement(_youtubeImpressions2.default, {
	                  latestStatistic: a.latestStatistic,
	                  popupToggleHandler: _this2.toggleYoutubeInsightsModal
	                }) : _react2.default.createElement(_privateDataComponent2.default, null)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle thin', color: 'grey' })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_favouriteStar2.default, { asset: a, onClick: _this2.toggleFavoriteState })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(UploadSupportingFiles, { value: a, handler: _this2.supportFilesHandler })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _this2.SupportingDataCount(a)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(DeleteButton, { value: a, handler: function handler() {
	                  return _this2.openDeleteDialog(a);
	                } })
	            )
	          );
	        }
	      case 'INSTAGRAM':
	        {
	          var _impressions = void 0;
	          var _a$trackedAsset = a.trackedAsset,
	              _supportingData = _a$trackedAsset.supportingData,
	              _savedThumbnailUrl = _a$trackedAsset.savedThumbnailUrl,
	              assetId = _a$trackedAsset.assetId;
	
	          if (_supportingData && !isGraphQLEmpty(_supportingData)) {
	            var _filtered = _lodash2.default.filter(_supportingData, 'createdDate'); // remove the GraphQL null at [0]
	            var _ordered = _lodash2.default.reverse(_lodash2.default.sortBy(_filtered, function (o) {
	              return o.createdDate;
	            }));
	            var _latestSupportingData = _ordered[0];
	            if (_latestSupportingData) {
	              _impressions = _latestSupportingData.impressions;
	            }
	          }
	
	          var _imageSrc2 = _savedThumbnailUrl && _this2.getCloudFrontUrl(_savedThumbnailUrl);
	          var imageSrcX = 'https://pics.dyzio.co/' + assetId + '.jpg';
	
	          var _trimmedText = _lodash2.default.truncate(a.text, { length: 200, separator: ' ' });
	
	          return _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _imageSrc2 ? _react2.default.createElement('img', { src: _imageSrc2, style: thumbnailStyle, alt: 'asset thumbnail' }) : _react2.default.createElement('img', { src: imageSrcX, style: thumbnailStyle, alt: 'asset thumbnail' }),
	              _react2.default.createElement(
	                'h4',
	                { style: ribbonStyle },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink', size: 'large' }),
	                getInstagramType(a)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                a.publishedDate && (0, _moment2.default)(a.publishedDate).format('YYYY-MM-DD')
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { textAlign: 'left' },
	              _react2.default.createElement(
	                'p',
	                { style: { height: 70, overFlowY: 'hidden', verticalAlign: 'middle' } },
	                _trimmedText
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: { textAlign: 'center' } },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/asset/post/' + a.trackedAsset.id },
	                  'view full details...'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                'views: ',
	                getViews(a)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'engagements: ',
	                (0, _formatting.sf)(_lodash2.default.add(a.latestStatistic.likeCount, a.latestStatistic.commentCount))
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { width: 120, margin: '0 auto' } },
	                instagramAuthorised && !a.isIGTV && _react2.default.createElement(_instagramImpressions2.default, {
	                  instagramAuthorised: instagramAuthorised,
	                  latestStatistic: a.latestStatistic,
	                  supportingData: a.trackedAsset.supportingData,
	                  popupToggleHandler: _this2.toggleInstagramInsightsModal,
	                  post: a
	                }),
	                !instagramAuthorised && !a.isIGTV && !_impressions && _react2.default.createElement(_privateDataComponent2.default, null),
	                a.isIGTV && _react2.default.createElement(_notAvailableComponent2.default, {
	                  metricName: 'impressions',
	                  platform: 'Instagram',
	                  assetType: 'IGTV'
	                }),
	                !instagramAuthorised && !a.isIGTV && _impressions && (0, _formatting.sf)(_impressions)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              a.linkedAds ? _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', color: 'blue' }),
	                a.linkedAds.length
	              ) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle thin', color: 'grey' })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_favouriteStar2.default, { asset: a, onClick: _this2.toggleFavoriteState })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(UploadSupportingFiles, { value: a, handler: _this2.supportFilesHandler })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _this2.SupportingDataCount(a)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(DeleteButton, { handler: function handler() {
	                  return _this2.openDeleteDialog(a);
	                } })
	            )
	          );
	        }
	      case 'TWITTER':
	        {
	          console.log(a);
	          var tweetMedia = _lodash2.default.get(a, 'entities.media') || [];
	          var mainTweetMedia = _lodash2.default.head(tweetMedia);
	          var tweetThumbnail = _lodash2.default.get(mainTweetMedia, 'media_url');
	          var mediaUrl = _lodash2.default.get(mainTweetMedia, 'expanded_url');
	          var assetType = 'post';
	
	          if (_lodash2.default.includes(mediaUrl, 'video')) {
	            assetType = 'video';
	          }
	          if (_lodash2.default.includes(mediaUrl, 'photo')) {
	            assetType = 'image';
	          }
	          var stat = a.latestStatistic;
	          var _engagements = stat.likeCount + (stat.commentCount || 0);
	          return _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              content: 'Twitter Post', trigger: _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { style: { height: 90 } },
	                tweetThumbnail ? _react2.default.createElement('img', { src: tweetThumbnail, style: thumbnailStyle, alt: 'asset thumbnail' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: _lodash2.default.toLower(a.trackedAsset.platform), color: 'blue' }),
	                _react2.default.createElement(
	                  'h4',
	                  { style: ribbonStyle },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter', color: 'blue', size: 'large' }),
	                  assetType
	                )
	              )
	            }),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { textAlign: 'left' },
	              a.text
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                'views: ',
	                _react2.default.createElement(_privateDataComponent2.default, null)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'engagements: ',
	                (0, _formatting.sf)(_engagements)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_privateDataComponent2.default, null)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle thin', color: 'grey' })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_favouriteStar2.default, { asset: a, onClick: _this2.toggleFavoriteState })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(UploadSupportingFiles, { value: a, handler: _this2.supportFilesHandler })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _this2.SupportingDataCount(a)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(DeleteButton, { value: a, handler: function handler() {
	                  return _this2.openDeleteDialog(a);
	                } })
	            )
	          );
	        }
	      case 'FACEBOOK':
	        return _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: _lodash2.default.toLower(a.trackedAsset.platform), color: 'blue' }),
	            _react2.default.createElement(FacebookPostType, { asset: a })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { textAlign: 'left' },
	            a.text
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              'views: ',
	              (0, _formatting.sf)(a.latestStatistic.viewCount)
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'engagements:',
	              (0, _formatting.sf)(a.latestStatistic.likeCount)
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { width: 120, margin: '0 auto' } },
	              facebookAuthorised ? _react2.default.createElement(_facebookImpressions2.default, {
	                latestStatistic: a.latestStatistic,
	                popupToggleHandler: _this2.toggleFacebookInsightsModal
	              }) : _react2.default.createElement(_privateDataComponent2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle thin', color: 'grey' })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(_favouriteStar2.default, { asset: a, onClick: _this2.toggleFavoriteState })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(UploadSupportingFiles, { value: a, handler: _this2.supportFilesHandler })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _this2.SupportingDataCount(a)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(DeleteButton, { value: a, handler: function handler() {
	                return _this2.openDeleteDialog(a);
	              } })
	          )
	        );
	      default:
	        return null;
	    }
	  };
	
	  this.getStoryRow = function (props) {
	    var deleteAssetConfirmOpen = _this2.state.deleteAssetConfirmOpen;
	
	    if (!props) return null;
	    var supportingData = props.supportingData,
	        savedThumbnailUrl = props.savedThumbnailUrl,
	        publishedDate = props.publishedDate;
	
	    if (!publishedDate) return null;
	    var latestSupportingData = _lodash2.default.last(supportingData);
	    var imageSrc = savedThumbnailUrl && _this2.getCloudFrontUrl(savedThumbnailUrl);
	    var repostedFrom = _lodash2.default.get(props, 'repostedFrom');
	    var storyLinks = _lodash2.default.get(props, 'storyLinks');
	
	    var storyFeedMedia = _lodash2.default.get(props, 'initialData.story_feed_media');
	
	    var isReelsRepost = storyFeedMedia && storyFeedMedia[0].product_type === 'clips';
	
	    return _react2.default.createElement(
	      _semanticUiReact.Table.Row,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        null,
	        imageSrc ? _react2.default.createElement('img', { src: imageSrc, style: thumbnailStyle, alt: 'asset thumbnail' }) : _react2.default.createElement(
	          'div',
	          { style: { paddingBottom: 3 } },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'hourglass empty', size: 'large', color: 'orange' })
	        ),
	        _react2.default.createElement(
	          'h4',
	          { style: ribbonStyle },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink', size: 'large' }),
	          'STORY\xA0',
	          props.assetType === 'VIDEO' ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'video play', color: 'pink' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'image', color: 'pink' }),
	          isReelsRepost && _react2.default.createElement(
	            'span',
	            null,
	            'REELS'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          publishedDate && (0, _moment2.default)(publishedDate).format('YYYY-MM-DD')
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        { textAlign: 'left' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'CAPTION: ',
	          _lodash2.default.get(props, 'caption', '-')
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'HASHTAGS: ',
	          _lodash2.default.get(props, 'hashtags', '-')
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'MENTIONS: ',
	          _lodash2.default.get(props, 'mentions', '-')
	        ),
	        repostedFrom && _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Label,
	            null,
	            'repost from ',
	            repostedFrom
	          )
	        ),
	        storyLinks && _react2.default.createElement(
	          'p',
	          null,
	          'LINK: ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://' + _lodash2.default.head(storyLinks).displayUrl, target: '_blank' },
	            _lodash2.default.head(storyLinks).displayUrl
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { textAlign: 'center' } },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/asset/story/' + props.id },
	            'view full details...'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { width: 120, margin: '0 auto' } },
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            {
	              color: 'pink',
	              labelPosition: 'left',
	              fluid: true,
	              inverted: true,
	              onClick: function onClick() {
	                return _this2.toggleStoryViewModal(props.id);
	              },
	              size: 'small',
	              icon: true
	            },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'pie graph' }),
	            (0, _formatting.sf)(_lodash2.default.get(latestSupportingData, 'views') || _lodash2.default.get(latestSupportingData, 'impressions') || props.latestImpressions)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        null,
	        props.linkedAds ? _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', color: 'blue' }),
	          props.linkedAds.length
	        ) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle thin', color: 'grey' })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        null,
	        _react2.default.createElement(_favouriteStar2.default, { asset: props, onClick: _this2.toggleFavoriteState })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        null,
	        _react2.default.createElement(UploadSupportingFiles, { value: props, handler: _this2.supportFilesHandler })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        null,
	        _this2.SupportingDataCount(props)
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        null,
	        _react2.default.createElement(DeleteButton, {
	          handler: function handler() {
	            return _this2.openDeleteDialog(_extends({
	              thumbnail: props.savedThumbnailUrl,
	              text: props.caption
	            }, props));
	          },
	          value: props.id
	        })
	      )
	    );
	  };
	
	  this.onDeleteDialogConfirmedCallback = function () {
	    var assetToBeDeleted = _this2.state.assetToBeDeleted;
	
	    if ((0, _automationUtils.isAutoAdded)(assetToBeDeleted.createdBy) && (0, _automationUtils.isStory)(assetToBeDeleted.type)) {
	      _this2.props.deleteStoryHandler(assetToBeDeleted.id);
	    } else {
	      console.log(assetToBeDeleted);
	      _this2.props.deleteAssetHandler({}, {
	        value: assetToBeDeleted
	      });
	    }
	    _this2.setState({
	      assetToBeDeleted: null
	    });
	  };
	
	  this.closeViewStoryModal = function () {
	    _this2.setState({
	      selectedStory: null,
	      storyViewModalVisible: false
	    });
	  };
	
	  this.render = function () {
	    var _props2 = _this2.props,
	        assets = _props2.assets,
	        deleteAssetHandler = _props2.deleteAssetHandler,
	        influencer = _props2.influencer,
	        stories = _props2.stories,
	        campaignName = _props2.campaignName,
	        campaignType = _props2.campaignType,
	        hashtags = _props2.hashtags;
	    var _state = _this2.state,
	        selectedAsset = _state.selectedAsset,
	        selectedAssetPostType = _state.selectedAssetPostType,
	        selectedInsights = _state.selectedInsights,
	        selectedPost = _state.selectedPost,
	        uploadSupportingVisible = _state.uploadSupportingVisible,
	        facebookInsightsModalVisible = _state.facebookInsightsModalVisible,
	        youtubeInsightsModalVisible = _state.youtubeInsightsModalVisible,
	        instagramInsightsModalVisible = _state.instagramInsightsModalVisible,
	        newAssets = _state.newAssets,
	        selectedStory = _state.selectedStory,
	        storyViewModalVisible = _state.storyViewModalVisible,
	        storyViewModelInDeleteMode = _state.storyViewModelInDeleteMode,
	        deleteDialogVisible = _state.deleteDialogVisible,
	        assetToBeDeleted = _state.assetToBeDeleted;
	
	
	    var hasNoAnalytics = function hasNoAnalytics(asset) {
	      return _lodash2.default.includes(PLATFORMS_WITHOUT_ANALYTICS, asset.platform);
	    };
	    var trackedAssetsWithoutAnalytics = _lodash2.default.reject(assets, function (asset) {
	      return hasNoAnalytics(asset);
	    });
	    var tiktokAssets = _lodash2.default.filter(assets, ['platform', _staticConfiguration.TIKTOK]);
	    var vkAssets = _lodash2.default.filter(assets, ['platform', _staticConfiguration.VK]);
	    var blogAssets = _lodash2.default.filter(assets, ['platform', _staticConfiguration.BLOG]);
	    var snapChatAssets = _lodash2.default.filter(assets, ['platform', _staticConfiguration.SNAPCHAT]);
	    var telegramAssets = _lodash2.default.filter(assets, ['platform', _staticConfiguration.TELEGRAM]);
	
	    var linkedStories = _lodash2.default.filter(stories, 'publishedDate');
	
	    var assetsWithoutAnalytics = _lodash2.default.uniqBy(_lodash2.default.compact(_lodash2.default.concat(trackedAssetsWithoutAnalytics, newAssets)), '_id');
	    var mergedAssets = _lodash2.default.concat(assetsWithoutAnalytics, tiktokAssets, vkAssets, blogAssets, snapChatAssets, telegramAssets);
	
	    console.log('mergedAssets', mergedAssets);
	
	    console.log('stories', stories);
	
	    var hasAssets = mergedAssets.length > 0 || linkedStories.length > 0;
	
	    var inherit = 'inherit';
	    var isWideCard = true; // campaignType === 'WORKFLOW';
	    var inheritFont = {
	      fontFamily: inherit,
	      fontSize: inherit,
	      fontWeight: inherit
	    };
	
	    var instagramPostsCount = _lodash2.default.filter(mergedAssets, { trackedAsset: { platform: _staticConfiguration.INSTAGRAM } }).length;
	    var tweetsCount = _lodash2.default.filter(mergedAssets, { trackedAsset: { platform: _staticConfiguration.TWITTER } }).length;
	    var youtubeCount = _lodash2.default.filter(mergedAssets, { trackedAsset: { platform: _staticConfiguration.YOUTUBE } }).length;
	    var facebookCount = _lodash2.default.filter(mergedAssets, { trackedAsset: { platform: _staticConfiguration.FACEBOOK } }).length;
	    var tiktokCount = _lodash2.default.filter(mergedAssets, { platform: _staticConfiguration.TIKTOK }).length;
	    var telegramCount = _lodash2.default.filter(mergedAssets, { platform: _staticConfiguration.TELEGRAM }).length;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      hasAssets && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Label,
	            { color: 'pink', basic: true },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', size: 'large' }),
	            'POSTS: ',
	            instagramPostsCount
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Label,
	            { color: 'pink', basic: true },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', size: 'large' }),
	            'STORIES: ',
	            linkedStories.length
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Label,
	            { color: 'black', basic: true },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'music', size: 'large' }),
	            'TIKTOKS: ',
	            tiktokCount
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Label,
	            { color: 'blue', basic: true },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter', size: 'large' }),
	            'TWEETS: ',
	            tweetsCount
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Label,
	            { color: 'red', basic: true },
	            'YOUTUBE: ',
	            youtubeCount
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Label,
	            { color: 'blue', basic: true },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', size: 'large' }),
	            'FACEBOOK: ',
	            facebookCount
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Label,
	            { color: 'blue', basic: true },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram plane', size: 'large' }),
	            'TELEGRAM: ',
	            telegramCount
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { celled: true, fixed: true, basic: 'very', style: assetTableStyles, size: 'small', textAlign: 'center' },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Header,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { width: 2 },
	                isWideCard && 'channel'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { textAlign: 'left' },
	                'title'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { width: 3 },
	                'metrics'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { width: 1 },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'span',
	                    { style: inheritFont },
	                    'Ads'
	                  ),
	                  content: 'Facebook Ads linked to post'
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { width: isWideCard ? 1 : 2 },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'star', disabled: true }),
	                  content: 'Click here to favourite the post - this will add it to the campaign highlights section in your shared reports'
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { width: isWideCard ? 1 : 2 },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'span',
	                    { style: inheritFont },
	                    'add data'
	                  ),
	                  content: 'upload supporting files/manually add insights data.'
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { width: 1 },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'file outline', color: 'grey' }),
	                  content: 'supporting files?'
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { width: 1 },
	                isWideCard && 'remove'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _lodash2.default.map(mergedAssets, function (asset) {
	              return _this2.getRow(asset, deleteAssetHandler, influencer);
	            }),
	            _lodash2.default.map(linkedStories, function (story) {
	              return _this2.getStoryRow(story);
	            })
	          )
	        )
	      ),
	      !hasAssets && _react2.default.createElement(_noAssetsCard2.default, null),
	      uploadSupportingVisible && _react2.default.createElement(_uploadModal2.default, {
	        asset: selectedAsset,
	        popupToggleHandler: _this2.toggleUploadModal,
	        successHandler: _this2.addSupportingFile
	      }),
	      deleteDialogVisible && _react2.default.createElement(_deleteAssetDialog2.default, Object.assign({
	        onClose: _this2.closeDeleteDialog,
	        onDelete: _this2.onDeleteDialogConfirmedCallback,
	        highlighedHashtags: (0, _hashtagsUtils.transformHashtagstIntoArray)(hashtags)
	      }, assetToBeDeleted)),
	      storyViewModalVisible && _react2.default.createElement(_instagramStoryModal2.default, {
	        onClose: _this2.closeViewStoryModal,
	        selectedStory: selectedStory,
	        campaignName: campaignName
	      }),
	      _react2.default.createElement(_facebookInsightsModal2.default, {
	        latestStatistic: selectedInsights,
	        open: facebookInsightsModalVisible,
	        popupToggleHandler: _this2.toggleFacebookInsightsModal
	      }),
	      _react2.default.createElement(_youtubeInsightsModal2.default, {
	        latestStatistic: selectedInsights,
	        open: youtubeInsightsModalVisible,
	        popupToggleHandler: _this2.toggleYoutubeInsightsModal
	      }),
	      _react2.default.createElement(_instagramInsightsModal2.default, {
	        latestStatistic: selectedInsights,
	        open: instagramInsightsModalVisible,
	        popupToggleHandler: _this2.toggleInstagramInsightsModal,
	        post: selectedPost,
	        hashtags: hashtags
	      })
	    );
	  };
	};
	
	AssetTable.propTypes = {
	  assets: _propTypes2.default.object.isRequired,
	  deleteAssetHandler: _propTypes2.default.func.isRequired,
	  influencer: _propTypes2.default.object.isRequired,
	  stories: _propTypes2.default.array,
	  jsonAPIClient: _propTypes2.default.object.isRequired
	};
	
	AssetTable.defaultProps = {
	  stories: [],
	  assets: []
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasJsonapiClient2.default)(AssetTable);

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthorisationButton = function AuthorisationButton(_ref) {
	  var platform = _ref.platform,
	      accessTokens = _ref.accessTokens,
	      handleAuthClick = _ref.handleAuthClick,
	      handleRemoveClick = _ref.handleRemoveClick;
	
	  var isAuthorised = accessTokens && accessTokens[platform];
	  var isYoutube = platform === 'youtube';
	  var iconName = isYoutube ? 'youtube play' : platform;
	
	  if (isAuthorised) {
	    return _react2.default.createElement(
	      _semanticUiReact.Button,
	      { size: 'huge', fluid: true, color: 'red', basic: true, onClick: handleRemoveClick },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: iconName }),
	      'remove access'
	    );
	  }
	
	  if (isYoutube) {
	    return _react2.default.createElement(
	      _semanticUiReact.Button,
	      { size: 'big', fluid: true, color: 'red', basic: true, onClick: handleAuthClick },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: iconName }),
	      'Continue with YouTube'
	    );
	  }
	
	  return _react2.default.createElement(
	    _semanticUiReact.Button,
	    { size: 'big', fluid: true, color: platform, onClick: handleAuthClick },
	    _react2.default.createElement(_semanticUiReact.Icon, { name: iconName }),
	    'Continue with ',
	    _lodash2.default.capitalize(platform)
	  );
	};
	
	AuthorisationButton.propTypes = {
	  platform: _propTypes2.default.string.isRequired,
	  accessTokens: _propTypes2.default.array.isRequired,
	  handleAuthClick: _propTypes2.default.func.isRequired,
	  handleRemoveClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = AuthorisationButton;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _recompose = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _countries = __webpack_require__(93);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formatNumber = function formatNumber(num, numFormat) {
	  if (numFormat) {
	    return (0, _numeral2.default)(num).format(numFormat);
	  }
	  var format = num > 1000 ? '0a' : '0';
	  format = num > 1000000 ? '0.0a' : format;
	  return (0, _numeral2.default)(num).format(format);
	};
	
	var getPercentage = function getPercentage(total, value) {
	  if (total > 0 && value > 0) {
	    return _lodash2.default.round(_lodash2.default.divide(value, total) * 100);
	  }
	  return 0;
	};
	
	var percentageStyle = {
	  fontSize: '10px',
	  opacity: '0.5'
	};
	var processBlockStyles = {
	  backgroundColor: '#FFEFD5'
	};
	var contentBlockStyles = {
	  backgroundColor: '#D2F3EC'
	};
	var performanceBlockStyles = {
	  backgroundColor: '#FFF4F8'
	};
	
	var totalsRowStyles = {
	  fontWeight: 900,
	  backgroundColor: '#D2D1D7'
	};
	var MAX_WEEKS = 12;
	var getCampaignPhase = function getCampaignPhase(fullWeeks) {
	  if (fullWeeks) {
	    if (fullWeeks > MAX_WEEKS) return 'COMPLETE';
	    if (fullWeeks > 6) return 'TRACKING';
	    return 'RECRUITMENT & ORDERING';
	  }
	};
	
	var CampaignReportCard = function (_Component) {
	  _inherits(CampaignReportCard, _Component);
	
	  function CampaignReportCard(props) {
	    _classCallCheck(this, CampaignReportCard);
	
	    var _this = _possibleConstructorReturn(this, (CampaignReportCard.__proto__ || Object.getPrototypeOf(CampaignReportCard)).call(this, props));
	
	    _this.state = {
	      report: null,
	      isLoading: false,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(CampaignReportCard, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          isLoading = _props.isLoading,
	          campaigns = _props.campaigns,
	          showReviewedInfluencers = _props.showReviewedInfluencers,
	          showContactedInfluencers = _props.showContactedInfluencers,
	          onGroupViewToggle = _props.onGroupViewToggle,
	          showCampaignTitle = _props.showCampaignTitle,
	          isReloading = _props.isReloading,
	          month = _props.month,
	          onReload = _props.onReload,
	          showContactedInfluencersValue = _props.showContactedInfluencersValue,
	          showReviewedInfluencersValue = _props.showReviewedInfluencersValue;
	
	
	      var totalInfluencers = _lodash2.default.sumBy(campaigns, 'totalInfluencers');
	      var totalInfluencersReviewed = _lodash2.default.sumBy(campaigns, 'influencersReviewed');
	      var totalInfluencersSignedUp = _lodash2.default.sumBy(campaigns, 'influencers');
	      var totalInfluencersSignedUpPercentage = getPercentage(totalInfluencers, totalInfluencersSignedUp);
	      var totalInfluencersPercentage = getPercentage(totalInfluencersReviewed, totalInfluencers);
	      var totalInfluencersOrdered = _lodash2.default.sumBy(campaigns, 'influencersOrdered');
	      var totalInfluencersOrderedPercentage = getPercentage(totalInfluencersSignedUp, totalInfluencersOrdered);
	      var totalInfluencersPosted = _lodash2.default.sumBy(campaigns, 'influencersPosted');
	      var totalInfluencersPostedPercentage = getPercentage(totalInfluencersOrdered, totalInfluencersPosted);
	      var totalStories = _lodash2.default.sumBy(campaigns, 'stories');
	      var totalGridpost = _lodash2.default.sumBy(campaigns, 'gridpost');
	      var totalReels = _lodash2.default.sumBy(campaigns, 'reels');
	      var totalTiktoks = _lodash2.default.sumBy(campaigns, 'tiktoks');
	      var totalReach = _lodash2.default.sumBy(campaigns, 'reach');
	      var totalImpressions = _lodash2.default.sumBy(campaigns, 'impressions');
	      var totalViews = _lodash2.default.sumBy(campaigns, 'views');
	      var totalEngagements = _lodash2.default.sumBy(campaigns, 'engagements');
	      var totalAssets = totalStories + totalGridpost + totalReels + totalTiktoks;
	
	      var campaign = _lodash2.default.head(campaigns);
	      var brand = _lodash2.default.get(campaign, 'brand');
	
	      var liveDate = campaign && campaign.liveDate;
	
	      var fullWeeks = void 0;
	      if (liveDate) {
	        fullWeeks = (0, _moment2.default)().startOf('week').diff((0, _moment2.default)(liveDate).startOf('week'), 'weeks');
	      }
	
	      var totalCost = totalInfluencersOrdered * 20 + 3000;
	      var totalEmv = (totalImpressions * 10 + totalEngagements * 100) / 1000;
	      var finalRoi = (totalEmv - totalCost) / totalCost;
	
	      var canRenderCalcs = totalCost && totalInfluencersOrdered;
	
	      var campaignPhase = getCampaignPhase(fullWeeks);
	      return _react2.default.createElement(
	        'div',
	        { style: { marginTop: '40px', clear: 'all' } },
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { color: 'green', fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              'table',
	              { width: '100%' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { width: '50%' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    title
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { basic: true, color: 'blue', size: 'large' },
	                    brand || 'NOT SET'
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { width: '20%' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { basic: true, color: 'blue' },
	                    'WEEK ',
	                    fullWeeks,
	                    ' of ',
	                    MAX_WEEKS
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { width: '20%' },
	                  campaignPhase && _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { basic: true, color: 'grey' },
	                    campaignPhase
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { width: '10%' },
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                      circular: true, inverted: true, color: 'green', icon: 'refresh',
	                      onClick: function onClick() {
	                        return isReloading ? null : onReload(month, true);
	                      },
	                      loading: isReloading,
	                      floated: 'right'
	                    }),
	                    content: 'Click here reload report'
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.StatisticGroup,
	              { size: 'tiny', widths: '8' },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                { color: 'pink' },
	                _react2.default.createElement(
	                  _semanticUiReact.StatisticValue,
	                  null,
	                  isLoading ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'hourglass outline', color: 'orange' }) : _react2.default.createElement(
	                    'span',
	                    null,
	                    totalAssets
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.StatisticLabel,
	                  null,
	                  'total assets'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                { color: 'pink' },
	                _react2.default.createElement(
	                  _semanticUiReact.StatisticValue,
	                  null,
	                  isLoading ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'hourglass outline', color: 'orange' }) : _react2.default.createElement(
	                    'span',
	                    null,
	                    totalInfluencersOrdered
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.StatisticLabel,
	                  null,
	                  'total gifts'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.StatisticValue,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'dollar', size: 'small', color: 'green' }),
	                  isLoading ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'hourglass outline', color: 'orange' }) : _react2.default.createElement(
	                    'span',
	                    null,
	                    (0, _numeral2.default)(totalInfluencersOrdered * 20).format('0,0')
	                  )
	                ),
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  content: 'Cost of gift (est $20) times the number of gifts ordered',
	                  trigger: _react2.default.createElement(
	                    _semanticUiReact.StatisticLabel,
	                    null,
	                    'total cost'
	                  )
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.StatisticValue,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'dollar', size: 'small', color: 'green' }),
	                  isLoading ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'hourglass outline', color: 'orange' }) : _react2.default.createElement(
	                    'span',
	                    null,
	                    canRenderCalcs ? (0, _numeral2.default)((totalInfluencersOrdered * 20 + 3000) / totalAssets).format('0.00') : '-'
	                  )
	                ),
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  content: 'Product cost (gifts) plus Shopfluence fee, divided by total assets',
	                  trigger: _react2.default.createElement(
	                    _semanticUiReact.StatisticLabel,
	                    null,
	                    'total CPA'
	                  )
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.StatisticValue,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'dollar', size: 'small', color: 'green' }),
	                  isLoading ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'hourglass outline', color: 'orange' }) : _react2.default.createElement(
	                    'span',
	                    null,
	                    canRenderCalcs ? (0, _numeral2.default)(3000 / totalAssets).format('0.00') : '-'
	                  )
	                ),
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  content: 'Shopfluence monthly fee, divided by total assets',
	                  trigger: _react2.default.createElement(
	                    _semanticUiReact.StatisticLabel,
	                    null,
	                    'CPA (SaaS)'
	                  )
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.StatisticValue,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'dollar', size: 'small', color: 'green' }),
	                  isLoading ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'hourglass outline', color: 'orange' }) : _react2.default.createElement(
	                    'span',
	                    null,
	                    canRenderCalcs ? (0, _numeral2.default)(totalInfluencersOrdered * 20 * 1000 / totalImpressions).format('0.00') : '-'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.StatisticLabel,
	                  null,
	                  'CPM'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.StatisticValue,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'dollar', size: 'small', color: 'green' }),
	                  isLoading ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'hourglass outline', color: 'orange' }) : _react2.default.createElement(
	                    'span',
	                    null,
	                    canRenderCalcs ? (0, _numeral2.default)(totalEmv).format('0,0') : '-'
	                  )
	                ),
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  content: 'Total Impressions * $10 CPM + Total Engagements * $100 CPM',
	                  trigger: _react2.default.createElement(
	                    _semanticUiReact.StatisticLabel,
	                    null,
	                    'EMV'
	                  )
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                { color: 'blue' },
	                _react2.default.createElement(
	                  _semanticUiReact.StatisticValue,
	                  null,
	                  isLoading ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'hourglass outline', color: 'orange' }) : _react2.default.createElement(
	                    'span',
	                    null,
	                    canRenderCalcs ? (0, _numeral2.default)(finalRoi).format('%') : '-'
	                  )
	                ),
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  content: 'Value of media earned against cost of goods + SaaS',
	                  trigger: _react2.default.createElement(
	                    _semanticUiReact.StatisticLabel,
	                    null,
	                    'ROI'
	                  )
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            !isLoading && _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'flex-between', alignItems: 'center' } },
	              onGroupViewToggle && _react2.default.createElement(
	                'div',
	                { style: { marginRight: '10px', display: 'flex', alignItems: 'center' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { marginRight: '8px' } },
	                  'Group reports'
	                ),
	                _react2.default.createElement(_semanticUiReact.Radio, {
	                  toggle: true,
	                  defaultChecked: true,
	                  onChange: onGroupViewToggle
	                })
	              )
	            ),
	            !isLoading && _react2.default.createElement(
	              _semanticUiReact.Table,
	              { celled: true },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Header,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { width: 2 }),
	                  showReviewedInfluencers && _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: processBlockStyles, width: 1 },
	                    'Influencers Reviewed'
	                  ),
	                  showContactedInfluencers && _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: processBlockStyles, width: 1 },
	                    'Influencers Contacted'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: processBlockStyles, width: 1 },
	                    'Influencers Signed-up'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: processBlockStyles, width: 1 },
	                    'Influencers Ordered'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: processBlockStyles, width: 1 },
	                    'Influencers Posted'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: contentBlockStyles, width: 1 },
	                    'Instagram Stories'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: contentBlockStyles, width: 1 },
	                    'Instagram Gridposts'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: contentBlockStyles, width: 1 },
	                    'Instagram Reels'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: contentBlockStyles, width: 1 },
	                    'TikToks'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: performanceBlockStyles, width: 1 },
	                    'Reach'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: performanceBlockStyles, width: 1 },
	                    _react2.default.createElement(_semanticUiReact.Popup, { content: 'Impressions', trigger: _react2.default.createElement(
	                        'span',
	                        null,
	                        'Imps.'
	                      ) })
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: performanceBlockStyles, width: 1 },
	                    'Views'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: performanceBlockStyles, width: 1 },
	                    _react2.default.createElement(_semanticUiReact.Popup, { content: 'Engagements', trigger: _react2.default.createElement(
	                        'span',
	                        null,
	                        'Engs.'
	                      ) })
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center', style: performanceBlockStyles, width: 1 },
	                    _react2.default.createElement(_semanticUiReact.Popup, { content: 'Earned Media Value', trigger: _react2.default.createElement(
	                        'span',
	                        null,
	                        'EMV'
	                      ) })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                _lodash2.default.map(campaigns, function (campaign) {
	                  return _react2.default.createElement(ReportTableRow, {
	                    key: campaign.id,
	                    campaignReport: campaign,
	                    showReviewedInfluencers: showReviewedInfluencers,
	                    showContactedInfluencers: showContactedInfluencers,
	                    showCampaignTitle: showCampaignTitle,
	                    showContactedInfluencersValue: showContactedInfluencersValue,
	                    showReviewedInfluencersValue: showReviewedInfluencersValue
	                  });
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Footer,
	                { fullWidth: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  { style: totalsRowStyles },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles },
	                    'Totals'
	                  ),
	                  showReviewedInfluencers && _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    showReviewedInfluencersValue && formatNumber(totalInfluencersReviewed, '0,0')
	                  ),
	                  showContactedInfluencers && _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    showContactedInfluencersValue && formatNumber(totalInfluencers, '0,0'),
	                    ' ',
	                    ' ',
	                    showContactedInfluencersValue && _react2.default.createElement(
	                      'span',
	                      { style: percentageStyle },
	                      totalInfluencersPercentage,
	                      '%'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalInfluencersSignedUp, '0,0'),
	                    ' ',
	                    ' ',
	                    showContactedInfluencers && _react2.default.createElement(
	                      'span',
	                      { style: percentageStyle },
	                      totalInfluencersSignedUpPercentage,
	                      '%'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalInfluencersOrdered, '0,0'),
	                    ' ',
	                    _react2.default.createElement(
	                      'span',
	                      { style: percentageStyle },
	                      totalInfluencersOrderedPercentage,
	                      '%'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalInfluencersPosted, '0,0'),
	                    ' ',
	                    _react2.default.createElement(
	                      'span',
	                      { style: percentageStyle },
	                      totalInfluencersPostedPercentage,
	                      '% '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalStories, '0,0')
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalGridpost, '0,0')
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalReels, '0,0')
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalTiktoks, '0,0')
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalReach)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalImpressions)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalViews)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalEngagements)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    '$',
	                    (0, _numeral2.default)((totalImpressions * 10 + totalEngagements * 100) / 1000).format('0,0')
	                  )
	                )
	              )
	            ),
	            isLoading && _react2.default.createElement(
	              'p',
	              null,
	              'Loading...'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignReportCard;
	}(_react.Component);
	
	var ReportTableRow = function ReportTableRow(_ref) {
	  var campaignReport = _ref.campaignReport,
	      showContactedInfluencers = _ref.showContactedInfluencers,
	      showReviewedInfluencers = _ref.showReviewedInfluencers,
	      showCampaignTitle = _ref.showCampaignTitle,
	      showContactedInfluencersValue = _ref.showContactedInfluencersValue,
	      showReviewedInfluencersValue = _ref.showReviewedInfluencersValue;
	  var country = campaignReport.country,
	      name = campaignReport.name,
	      influencers = campaignReport.influencers,
	      influencersReviewed = campaignReport.influencersReviewed,
	      totalInfluencers = campaignReport.totalInfluencers,
	      influencersOrdered = campaignReport.influencersOrdered,
	      influencersPosted = campaignReport.influencersPosted,
	      stories = campaignReport.stories,
	      gridpost = campaignReport.gridpost,
	      tiktoks = campaignReport.tiktoks,
	      views = campaignReport.views,
	      engagements = campaignReport.engagements,
	      reach = campaignReport.reach,
	      impressions = campaignReport.impressions,
	      reels = campaignReport.reels,
	      campaignId = campaignReport.id;
	
	  var countryName = _lodash2.default.find(_countries2.default, { key: country }).text;
	  var title = showCampaignTitle ? name : countryName;
	  var orderedPercentage = getPercentage(influencers, influencersOrdered);
	  var postedPercentage = getPercentage(influencersOrdered, influencersPosted);
	  var signedUpPercentage = getPercentage(totalInfluencers, influencers);
	  var totalInfluencersPercentage = getPercentage(influencersReviewed, totalInfluencers);
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: '/campaign/' + campaignId + '/collaborations?fast=true', target: '_blank' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          title
	        )
	      )
	    ),
	    showReviewedInfluencers && _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: processBlockStyles, textAlign: 'right' },
	      showContactedInfluencersValue && formatNumber(influencersReviewed, '0,0')
	    ),
	    showContactedInfluencers && _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: processBlockStyles, textAlign: 'right' },
	      showReviewedInfluencersValue && formatNumber(totalInfluencers, '0,0'),
	      ' ',
	      ' ',
	      showReviewedInfluencersValue && _react2.default.createElement(
	        'span',
	        { style: percentageStyle },
	        totalInfluencersPercentage,
	        '%'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: processBlockStyles, textAlign: 'right' },
	      formatNumber(influencers, '0,0'),
	      ' ',
	      ' ',
	      ' ',
	      showContactedInfluencers && _react2.default.createElement(
	        'span',
	        { style: percentageStyle },
	        signedUpPercentage,
	        '%'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: processBlockStyles, textAlign: 'right' },
	      formatNumber(influencersOrdered, '0,0'),
	      ' ',
	      _react2.default.createElement(
	        'span',
	        { style: percentageStyle },
	        orderedPercentage,
	        '%'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: processBlockStyles, textAlign: 'right' },
	      formatNumber(influencersPosted, '0,0'),
	      ' ',
	      _react2.default.createElement(
	        'span',
	        { style: percentageStyle },
	        postedPercentage,
	        '%'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: contentBlockStyles, textAlign: 'right' },
	      formatNumber(stories, '0,0')
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: contentBlockStyles, textAlign: 'right' },
	      formatNumber(gridpost, '0,0')
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: contentBlockStyles, textAlign: 'right' },
	      formatNumber(reels, '0,0')
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: contentBlockStyles, textAlign: 'right' },
	      formatNumber(tiktoks, '0,0')
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: performanceBlockStyles, textAlign: 'right' },
	      formatNumber(reach)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: performanceBlockStyles, textAlign: 'right' },
	      formatNumber(impressions)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: performanceBlockStyles, textAlign: 'right' },
	      formatNumber(views)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: performanceBlockStyles, textAlign: 'right' },
	      formatNumber(engagements)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: performanceBlockStyles, textAlign: 'right' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://share.dyzio.co/report/' + campaignId + '/emv', target: '_blank' },
	        '$',
	        (0, _numeral2.default)((impressions * 10 + engagements * 100) / 1000).format('0,0')
	      )
	    )
	  );
	};
	
	CampaignReportCard.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  campaigns: _propTypes2.default.array,
	  onReload: _propTypes2.default.func,
	  month: _propTypes2.default.string,
	  isReloading: _propTypes2.default.bool,
	  showReviewedInfluencers: _propTypes2.default.bool,
	  showContactedInfluencers: _propTypes2.default.bool,
	  onGroupViewToggle: _propTypes2.default.func,
	  showCampaignTitle: _propTypes2.default.bool,
	  showContactedInfluencersValue: _propTypes2.default.bool,
	  showReviewedInfluencersValue: _propTypes2.default.bool
	};
	
	CampaignReportCard.defaultProps = {
	  isLoading: false,
	  campaigns: [],
	  onReload: _lodash2.default.noop,
	  month: '',
	  isReloading: false,
	  showReviewedInfluencers: false,
	  showContactedInfluencers: false,
	  onGroupViewToggle: null,
	  showCampaignTitle: true,
	  showContactedInfluencersValue: true,
	  showReviewedInfluencersValue: true
	};
	
	ReportTableRow.propTypes = {
	  campaignReport: _propTypes2.default.object.isRequired,
	  showContactedInfluencers: _propTypes2.default.bool.isRequired,
	  showReviewedInfluencers: _propTypes2.default.bool.isRequired,
	  showCampaignTitle: _propTypes2.default.bool.isRequired,
	  showContactedInfluencersValue: _propTypes2.default.bool,
	  showReviewedInfluencersValue: _propTypes2.default.bool
	};
	
	ReportTableRow.defaultProps = {
	  showContactedInfluencersValue: true,
	  showReviewedInfluencersValue: true
	};
	exports.default = (0, _recompose.compose)(_hasRestClient2.default)(CampaignReportCard);

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _countryData = __webpack_require__(175);
	
	var _uuid = __webpack_require__(832);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _reactRouter = __webpack_require__(37);
	
	var _campaignTypes = __webpack_require__(931);
	
	var _campaignTypes2 = _interopRequireDefault(_campaignTypes);
	
	var _confirmationModal = __webpack_require__(345);
	
	var _confirmationModal2 = _interopRequireDefault(_confirmationModal);
	
	var _campaignStatusComponent = __webpack_require__(1911);
	
	var _campaignStatusComponent2 = _interopRequireDefault(_campaignStatusComponent);
	
	var _recompose = __webpack_require__(15);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasOrganisation = __webpack_require__(106);
	
	var _hasOrganisation2 = _interopRequireDefault(_hasOrganisation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	
	var loadingRowStyle = {
	  height: 350
	};
	
	var shopifyLogoStyle = {
	  height: '1.2em'
	};
	
	var rowStyle = {
	  cursor: 'pointer'
	};
	var labelStyle = {
	  width: '100%'
	};
	
	var brandLabelStyle = {
	  marginLeft: '0',
	  marginTop: '2px'
	};
	
	var renderCurrency = function renderCurrency(code) {
	  var currency = _lodash2.default.find(_countryData.currencies.all, ['code', code]);
	  return currency ? currency.symbol : '';
	};
	
	var renderCountry = function renderCountry(code) {
	  if (!code) return '-';
	  var country = _lodash2.default.find(_countryData.countries.all, ['alpha2', code]);
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Flag, { name: _lodash2.default.toLower(country.alpha2) }),
	    content: country.name
	  });
	};
	
	var LoadingTableRow = function LoadingTableRow() {
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    { style: loadingRowStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { colSpan: 8 },
	      _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: 'centered', content: 'Loading campaigns...' })
	    )
	  );
	};
	
	var handleClick = function handleClick(_ref) {
	  var router = _ref.router,
	      campaignType = _ref.campaignType,
	      campaignId = _ref.campaignId,
	      canLoadFast = _ref.canLoadFast;
	
	  var isACR = campaignType === 'ACR';
	
	  var campUrl = '/campaign/' + campaignId + '/collaborations' + (canLoadFast ? '?fast=true' : '');
	  var campaignUrl = isACR ? '/acr-campaign/' + campaignId : campUrl;
	  router.push(campaignUrl);
	};
	
	var CampaignsTable = function (_React$Component) {
	  _inherits(CampaignsTable, _React$Component);
	
	  function CampaignsTable() {
	    var _this2 = this;
	
	    _classCallCheck(this, CampaignsTable);
	
	    var _this = _possibleConstructorReturn(this, (CampaignsTable.__proto__ || Object.getPrototypeOf(CampaignsTable)).call(this));
	
	    _this.onSuperAdminDelete = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var organisationId, _this$state, campaignToBeDeleted, campaigns, restClient, campaignId, deleteCacheURL;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              organisationId = _this.props.userInfo.organisationId;
	              _this$state = _this.state, campaignToBeDeleted = _this$state.campaignToBeDeleted, campaigns = _this$state.campaigns;
	              restClient = _this.props.restClient;
	              campaignId = campaignToBeDeleted.campaignId;
	
	              console.log('campaignToBeDeleted', campaignToBeDeleted);
	
	              restClient.patch('campaigns/' + campaignId, {
	                data: {
	                  attributes: {
	                    status: 'DELETED'
	                  }
	                }
	              });
	
	              console.log(organisationId);
	
	              deleteCacheURL = '/organisations/' + organisationId + '/cache';
	              _context.next = 10;
	              return restClient({
	                method: 'DELETE',
	                url: deleteCacheURL,
	                baseURL: ("https://dl6gzrmms2.execute-api.eu-west-1.amazonaws.com/production")
	              });
	
	            case 10:
	
	              _this.setState({
	                displayDeleteModal: false,
	                campaignToBeDeleted: null,
	                campaigns: _lodash2.default.reject(campaigns, function (c) {
	                  return c.campaignId === campaignId;
	                })
	              });
	
	            case 11:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.openDeleteModal = function (record) {
	      _this.setState({
	        displayDeleteModal: true,
	        campaignToBeDeleted: record
	      });
	    };
	
	    _this.closeDeleteModal = function () {
	      _this.setState({
	        displayDeleteModal: false,
	        campaignToBeDeleted: null
	      });
	    };
	
	    _this.getWorkflow = function (workflow) {
	      if (workflow === 'ABBLY_V1') return 'UK (global) Store';
	      if (workflow === 'ABBLY_V1_US') return 'US Store';
	      return workflow;
	    };
	
	    _this.state = {
	      displayDeleteModal: false,
	      campaignToBeDeleted: null,
	      campaigns: []
	    };
	    return _this;
	  }
	
	  _createClass(CampaignsTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          records = _props.records,
	          router = _props.router,
	          onDelete = _props.onDelete,
	          onArchive = _props.onArchive,
	          onUnarchive = _props.onUnarchive,
	          listType = _props.listType,
	          isLoadingCampaigns = _props.isLoadingCampaigns,
	          isCompact = _props.isCompact,
	          isUserSuperAdmin = _props.isUserSuperAdmin;
	      var _state = this.state,
	          displayDeleteModal = _state.displayDeleteModal,
	          campaignToBeDeleted = _state.campaignToBeDeleted,
	          campaigns = _state.campaigns;
	
	
	      var displayCampaigns = isCompact || _lodash2.default.isEmpty(campaigns) ? records : campaigns;
	
	      if (!isCompact && _lodash2.default.isEmpty(campaigns)) {
	        this.setState({
	          campaigns: records
	        });
	      }
	
	      console.log('campaigns', displayCampaigns);
	
	      return _react2.default.createElement(
	        _semanticUiReact.Table,
	        { padded: true, selectable: !isLoadingCampaigns, textAlign: 'center' },
	        displayDeleteModal && _react2.default.createElement(_confirmationModal2.default, {
	          headerText: 'Deleting Campaign',
	          bodyText: 'Are you sure you would like to delete the\n        campaign ' + campaignToBeDeleted.campaignName + ' created\n        by ' + campaignToBeDeleted.campaignCreatedBy + '?',
	          onCancel: this.closeDeleteModal,
	          onConfirm: this.onSuperAdminDelete
	        }),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Header,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { textAlign: 'left', width: 'four' },
	              'Name'
	            ),
	            !isCompact && _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'Country'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'Type',
	              _react2.default.createElement('br', null),
	              'Status'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'Budget'
	            ),
	            !isCompact && _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'Allocated budget'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'Assets'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'Influencers'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'TMs'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'Integrations'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'Created'
	            ),
	            listType && _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { textAlign: 'center' },
	              'Actions'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          isLoadingCampaigns && _react2.default.createElement(LoadingTableRow, null),
	          !isLoadingCampaigns && _lodash2.default.map(displayCampaigns, function (record) {
	            var campaignType = record.campaignType,
	                campaignId = record.campaignId,
	                canLoadFast = record.campaignCanLoadFast;
	
	            var isLarge = record.influencersCount > 60;
	            var clf = isLarge && canLoadFast;
	            var onClickListener = function onClickListener() {
	              return handleClick({ router: router, campaignType: campaignType, campaignId: campaignId, canLoadFast: clf });
	            };
	            var withFacebookMarketingIntegration = _lodash2.default.get(record, 'marketingCampaignsCount', 0) > 0;
	            var isShopifyCampaign = _lodash2.default.get(record, 'isShopifyCampaign');
	            var withGoogleIntegration = !_lodash2.default.isEmpty(_lodash2.default.get(record, 'campaignBaseTrackingUrl', ''));
	            var hasIntegrations = withFacebookMarketingIntegration || withGoogleIntegration || isShopifyCampaign;
	            return _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              {
	                style: rowStyle,
	                key: (0, _uuid2.default)(),
	                verticalAlign: 'middle'
	              },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { onClick: onClickListener, textAlign: 'left' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    record.campaignName
	                  )
	                ),
	                record.campaignBrand && _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { style: brandLabelStyle },
	                  'Brand',
	                  _react2.default.createElement(
	                    _semanticUiReact.Label.Detail,
	                    null,
	                    _lodash2.default.toUpper(record.campaignBrand)
	                  )
	                ),
	                record.campaignWorkflow && _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { style: brandLabelStyle, color: 'blue', basic: true },
	                  'Workflow',
	                  _react2.default.createElement(
	                    _semanticUiReact.Label.Detail,
	                    null,
	                    _lodash2.default.toUpper(_this3.getWorkflow(record.campaignWorkflow))
	                  )
	                )
	              ),
	              !isCompact && _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { onClick: onClickListener, singleLine: true },
	                renderCountry(_lodash2.default.get(record, 'campaignCountry'))
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { onClick: onClickListener },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(_semanticUiReact.Label, {
	                    style: labelStyle,
	                    color: _campaignTypes2.default[campaignType].color,
	                    basic: true,
	                    size: 'tiny',
	                    content: _campaignTypes2.default[campaignType].shortName
	                  }),
	                  content: _campaignTypes2.default[campaignType].fullName
	                }),
	                _react2.default.createElement(_campaignStatusComponent2.default, {
	                  endDate: record.campaignEndDate,
	                  liveDate: record.campaignLiveDate
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { onClick: onClickListener, singleLine: true },
	                record.campaignCurrency && renderCurrency(record.campaignCurrency),
	                ' ',
	                cf(record.campaignBudget)
	              ),
	              !isCompact && _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { onClick: onClickListener },
	                record.campaignCurrency && renderCurrency(record.campaignCurrency),
	                ' ',
	                cf(record.allocatedBudget)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { onClick: onClickListener },
	                record.totalAssetsCount
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { onClick: onClickListener },
	                record.influencersCount
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { onClick: onClickListener },
	                record.teamMemberCount
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                !hasIntegrations && _react2.default.createElement(
	                  'span',
	                  null,
	                  'None'
	                ),
	                withFacebookMarketingIntegration && _react2.default.createElement(_semanticUiReact.Popup, {
	                  content: 'Facebook Ads Campaign', trigger: _react2.default.createElement(_semanticUiReact.Icon, { color: 'blue', name: 'facebook' })
	                }),
	                isShopifyCampaign && _react2.default.createElement(_semanticUiReact.Popup, {
	                  content: 'Shopify Campaign', trigger: _react2.default.createElement('img', {
	                    style: shopifyLogoStyle,
	                    src: '/icons/shopify.svg',
	                    alt: 'Shopify'
	                  })
	                }),
	                withGoogleIntegration && _react2.default.createElement(_semanticUiReact.Popup, {
	                  content: 'Google Ads Campaign', trigger: _react2.default.createElement(_semanticUiReact.Icon, { color: 'red', name: 'google' })
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { onClick: onClickListener },
	                record.campaignCreatedBy,
	                ' on ',
	                (0, _moment2.default)(record.campaignCreatedDate).format('DD/MM/YY')
	              ),
	              listType && _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                listType === 'ACTIVE' && isUserSuperAdmin && _react2.default.createElement(_semanticUiReact.Popup, {
	                  content: 'Delete this campaign',
	                  trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                    onClick: function onClick() {
	                      return _this3.openDeleteModal(record);
	                    },
	                    icon: 'x',
	                    circular: true,
	                    inverted: true,
	                    color: 'red'
	                  })
	                }),
	                listType === 'ACTIVE' && !isUserSuperAdmin && _react2.default.createElement(_semanticUiReact.Popup, {
	                  content: 'Archive this campaign',
	                  trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                    onClick: function onClick() {
	                      return onArchive(record.campaignPermissionId);
	                    },
	                    circular: true,
	                    icon: 'archive',
	                    color: 'orange',
	                    inverted: true
	                  })
	                }),
	                listType === 'ARCHIVED' && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    content: 'Unarchive this campaign',
	                    trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                      onClick: function onClick() {
	                        return onUnarchive(record.campaignPermissionId);
	                      },
	                      circular: true,
	                      icon: 'undo',
	                      color: 'green',
	                      inverted: true
	                    })
	                  }),
	                  '\xA0',
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    content: 'Delete this campaign',
	                    trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                      onClick: function onClick() {
	                        return onDelete(record.campaignPermissionId);
	                      },
	                      icon: 'x',
	                      circular: true,
	                      inverted: true,
	                      color: 'red'
	                    })
	                  })
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return CampaignsTable;
	}(_react2.default.Component);
	
	CampaignsTable.propTypes = {
	  records: _propTypes2.default.array.isRequired,
	  router: _propTypes2.default.object.isRequired,
	  onDelete: _propTypes2.default.func,
	  onArchive: _propTypes2.default.func,
	  onUnarchive: _propTypes2.default.func,
	  listType: _propTypes2.default.string,
	  isLoadingCampaigns: _propTypes2.default.bool.isRequired,
	  isCompact: _propTypes2.default.bool,
	  isUserSuperAdmin: _propTypes2.default.bool
	};
	
	CampaignsTable.defaultProps = {
	  onDelete: _lodash2.default.noop,
	  onArchive: _lodash2.default.noop,
	  onUnarchive: _lodash2.default.noop,
	  listType: null
	};
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasOrganisation2.default, _reactRouter.withRouter)(CampaignsTable);

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataFetchError = function DataFetchError(_ref) {
	  var dataDescription = _ref.dataDescription,
	      iconSize = _ref.iconSize,
	      error = _ref.error;
	  return _react2.default.createElement(
	    'div',
	    { style: { textAlign: 'center', border: '1px solid #eee', margin: '5px 0px', padding: '10px' } },
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'meh', size: iconSize, color: 'orange' }),
	    _react2.default.createElement(
	      'p',
	      { className: 'light' },
	      'Ooops... there was some kind of problem fetching the ',
	      dataDescription,
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'light' },
	      'The dyzio team has been notified and it should be fixed soon!'
	    )
	  );
	};
	
	exports.default = DataFetchError;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(76);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
	  paddingTop: 5
	};
	
	var Dropdown = function (_React$Component) {
	  _inherits(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    _classCallCheck(this, Dropdown);
	
	    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props, context));
	
	    _this.feedback = function (_ref) {
	      var action = _ref.action,
	          campaignType = _ref.campaignType;
	
	      if (typeof _this.props.onClick === 'function') {
	        _this.props.onClick({ action: action, campaignType: campaignType });
	      }
	    };
	
	    _this.state = {
	      open: false
	    };
	    return _this;
	  }
	
	  _createClass(Dropdown, [{
	    key: 'toggleDropdown',
	    value: function toggleDropdown() {
	      if (this.state.open) {
	        this.setState({ open: false });
	      } else {
	        this.setState({ open: true });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var clickArea = _reactDom2.default.findDOMNode(this.refs.dropdown);
	      if (this.state.open && clickArea) {
	        var isClickInside = clickArea.contains(event.target);
	        if (!isClickInside) {
	          this.setState({ open: false });
	        }
	      }
	    }
	  }, {
	    key: 'returnClassNames',
	    value: function returnClassNames() {
	      return 'dropdown ' + this.props.align;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('click', this.handleClick.bind(this));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.addEventListener('click', this.handleClick.bind(this));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          align = _props.align,
	          dropdownStyle = _props.dropdownStyle,
	          colour = _props.colour,
	          shouldRenderNodes = _props.shouldRenderNodes,
	          contentNodes = _props.contentNodes;
	
	      var alignName = align && 'open-' + align;
	      var dropdownClassName = (dropdownStyle || 'dropdown') + ' ' + alignName;
	      return _react2.default.createElement(
	        'div',
	        { style: style, className: dropdownClassName, ref: 'dropdown' },
	        _react2.default.createElement(
	          'span',
	          { className: 'dropdown-selector', onClick: this.toggleDropdown.bind(this) },
	          this.props.children
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.open ? 'dropdown-area visible' : 'dropdown-area' },
	          _react2.default.createElement('div', { className: 'arrow' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrapper', onClick: this.toggleDropdown.bind(this) },
	            _react2.default.createElement(
	              'div',
	              { className: 'dropdown-content' },
	              shouldRenderNodes && contentNodes,
	              !shouldRenderNodes && _react2.default.createElement(
	                'ul',
	                null,
	                this.props.content && _react2.default.createElement(
	                  'div',
	                  null,
	                  this.props.content.map(function (item) {
	                    var generatedKey = Math.random() + '-' + item.name;
	                    var name = item.name,
	                        action = item.action,
	                        campaignType = item.campaignType;
	
	                    return _react2.default.createElement(
	                      'span',
	                      { key: generatedKey },
	                      name && action && _react2.default.createElement(
	                        'li',
	                        { className: colour || '', onClick: _lodash2.default.isFunction(item.action) ? item.action : function () {
	                            return _this2.feedback({ action: action, campaignType: campaignType });
	                          } },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          name
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            this.props.buttonText && this.props.buttonLink && _react2.default.createElement(
	              'div',
	              { className: 'dropdown-button' },
	              _react2.default.createElement(
	                'div',
	                { className: 'button-inner', onClick: function onClick() {
	                    return _this2.context.router.push(_this2.props.buttonLink);
	                  } },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'small' },
	                  this.props.buttonText
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Dropdown;
	}(_react2.default.Component);
	
	Dropdown.contextTypes = {
	  router: _react.PropTypes.object
	};
	exports.default = Dropdown;
	
	
	Dropdown.propTypes = {
	  feedback: _react2.default.PropTypes.func
	};

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imgStyle = { margin: '0px auto' };
	var width100 = { width: '100%' };
	
	var instagramStyle = {
	  height: '300px',
	  minHeight: '300px',
	  width: '300px',
	  objectFit: 'cover',
	  display: 'block',
	  margin: '0px auto'
	};
	
	var brandMentionStyle = {
	  height: '150px',
	  minHeight: '150px',
	  width: '150px',
	  objectFit: 'cover',
	  display: 'block',
	  margin: '0px auto'
	};
	
	var getStyle = function getStyle(useInstagramStyle, maxWidth, brandMention) {
	  if (brandMention) return brandMentionStyle;
	  if (useInstagramStyle) return instagramStyle;
	  if (maxWidth) return width100;
	  return imgStyle;
	};
	
	var DyzioInstagramEmbed = function DyzioInstagramEmbed(props) {
	  var maxWidth = props.maxWidth,
	      useInstagramStyle = props.useInstagramStyle,
	      brandMention = props.brandMention,
	      assetId = props.assetId,
	      imageUrl = props.imageUrl;
	
	
	  var derivedStyle = getStyle(useInstagramStyle, maxWidth, brandMention);
	  var imgSrc = imageUrl || 'https://img.dyzio.co/image/' + assetId + '/size/m';
	  return _react2.default.createElement(_semanticUiReact.Image, {
	    size: 'large',
	    style: derivedStyle,
	    src: imgSrc
	  });
	};
	
	DyzioInstagramEmbed.propTypes = {
	  assetId: _propTypes2.default.string.isRequired,
	  useInstagramStyle: _propTypes2.default.string,
	  maxWidth: _propTypes2.default.string,
	  brandMention: _propTypes2.default.bool,
	  imageUrl: _propTypes2.default.string
	};
	
	DyzioInstagramEmbed.defaultProps = {
	  maxWidth: false,
	  useInstagramStyle: false,
	  brandMention: false
	};
	
	exports.default = DyzioInstagramEmbed;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RadioInput(props) {
	  var style = props.disabled ? 'disabled' : '';
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement('input', Object.assign({
	      type: 'radio',
	      id: props.id,
	      className: style,
	      disabled: props.disabled,
	      name: props.name,
	      value: props.value
	    }, props.input)),
	    _react2.default.createElement(
	      'label',
	      { className: style, htmlFor: props.id },
	      _react2.default.createElement('span', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        props.label
	      )
	    ),
	    props.img && _react2.default.createElement('img', { alt: props.name, src: props.img })
	  );
	}
	
	RadioInput.propTypes = {
	  input: _react2.default.PropTypes.object,
	  meta: _react2.default.PropTypes.object
	};
	
	exports.default = RadioInput;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(328);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(2908);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectInput = function (_Component) {
	  _inherits(SelectInput, _Component);
	
	  function SelectInput() {
	    _classCallCheck(this, SelectInput);
	
	    return _possibleConstructorReturn(this, (SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).apply(this, arguments));
	  }
	
	  _createClass(SelectInput, [{
	    key: 'onChange',
	    value: function onChange(event) {
	      if (this.props.input.onChange) {
	        if (this.props.onChangeCallback) {
	          this.props.onChangeCallback(event.value);
	        }
	        // <-- To be aligned with how redux-form publishes its CHANGE action payload. The event received is an object with 2 keys: "value" and "label"
	        this.props.input.onChange(event.value);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form_input_select_container' },
	        this.props.label ? _react2.default.createElement(
	          'label',
	          null,
	          this.props.label
	        ) : '',
	        _react2.default.createElement(_reactSelect2.default, Object.assign({}, this.props, {
	          value: this.props.input.value || '',
	          clearable: false,
	          placeholder: 'Select...',
	          onBlur: function onBlur() {
	            return _this2.props.input.onBlur(_this2.props.input.value);
	          },
	          onChange: this.onChange.bind(this),
	          options: this.props.options // <-- Receive options from the form
	          , searchable: false
	        })),
	        this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	          'p',
	          { className: 'small error' },
	          this.props.meta.error
	        )
	      );
	    }
	  }]);
	
	  return SelectInput;
	}(_react.Component);
	
	exports.default = SelectInput;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpLinkStyle = {
	  color: 'rgb(0, 181, 173)',
	  fontWeight: 'bold'
	};
	
	var HelpLink = function HelpLink(_ref) {
	  var url = _ref.url;
	  return _react2.default.createElement(
	    _semanticUiReact.Label,
	    { as: 'a', color: 'teal', basic: true, onClick: 'blah' },
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'help' }),
	    _react2.default.createElement(
	      'a',
	      {
	        style: helpLinkStyle,
	        target: '_blank',
	        rel: 'noopener noreferrer', href: url
	      },
	      'click here for help'
	    )
	  );
	};
	
	exports.default = HelpLink;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var catLabelStyle = {
	  textTransform: 'uppercase',
	  width: 80
	};
	
	var lowerLimits = {
	  mega: 1000000,
	  xLarge: 500000,
	  large: 100000,
	  medium: 50000,
	  small: 10000
	};
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	
	var categories = {
	  mega: {
	    text: 'mega',
	    description: 'more than ' + cf(lowerLimits.mega) + ' followers'
	  },
	  xLarge: {
	    text: 'x-large',
	    description: 'more than ' + cf(lowerLimits.xLarge) + ' followers, less than ' + cf(lowerLimits.mega) + '.'
	  },
	  large: {
	    text: 'large',
	    description: 'more than ' + cf(lowerLimits.large) + ' followers, less than ' + cf(lowerLimits.xLarge) + '.'
	  },
	  medium: {
	    text: 'medium',
	    description: 'more than ' + cf(lowerLimits.medium) + ' followers, less than ' + cf(lowerLimits.large) + '.'
	  },
	  small: {
	    text: 'small',
	    description: 'more than ' + cf(lowerLimits.small) + ' followers, less than ' + cf(lowerLimits.medium) + '.'
	  },
	  micro: {
	    text: 'micro',
	    description: 'less than ' + cf(lowerLimits.small) + ' followers'
	  }
	};
	
	var getBand = function getBand(largestFollowerCount) {
	  if (largestFollowerCount >= lowerLimits.mega) return 'mega';
	  if (largestFollowerCount >= lowerLimits.xLarge) return 'xLarge';
	  if (largestFollowerCount >= lowerLimits.large) return 'large';
	  if (largestFollowerCount >= lowerLimits.medium) return 'medium';
	  if (largestFollowerCount >= lowerLimits.small) return 'small';
	  return 'micro';
	};
	
	var getInfluencerCategory = function getInfluencerCategory(i) {
	  var largestFollowerCount = _lodash2.default.max([i.youtubeCount, i.twitterCount, i.facebookCount, i.instagramCount]);
	  var band = getBand(largestFollowerCount);
	  return categories[band];
	};
	
	var InfluencerCategoryComponent = function InfluencerCategoryComponent(_ref) {
	  var influencer = _ref.influencer;
	
	  var influencerCategory = getInfluencerCategory(influencer);
	
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(
	      _semanticUiReact.Label,
	      { fluid: true, basic: true, size: 'tiny', style: catLabelStyle },
	      influencerCategory.text
	    ),
	    content: influencerCategory.description
	  });
	};
	
	InfluencerCategoryComponent.propTypes = {
	  influencer: _propTypes2.default.object.isRequired
	};
	
	exports.default = InfluencerCategoryComponent;

/***/ },
/* 548 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ageOptions = exports.ageOptions = [{ key: 'teen', value: 'teen', text: 'Teen (13-19)' }, { key: 'young-adults', value: 'young-adult', text: 'Young Adults (20-35)' }, { key: 'adults', value: 'adult', text: 'Adults (36-55)' }, { key: 'seniors', value: 'senior', text: 'Seniors (55+)' }];
	
	var genderOptions = exports.genderOptions = [{ key: 'male', value: 'male', text: 'Male' }, { key: 'female', value: 'female', text: 'Female' }, { key: 'non-binary', value: 'non-binary', text: 'Non-binary' }, { key: 'genderfluid', value: 'genderfluid', text: 'Gender fluid' }, { key: 'transgender', value: 'transgender', text: 'Transgender' }, { key: 'other', value: 'other', text: 'Other' }];
	
	var ethnicityOptions = exports.ethnicityOptions = [{ key: 'black', value: 'black-caribbean-african', text: 'Black, Caribbean, African' }, { key: 'asian', value: 'asian', text: 'Asian' }, { key: 'hispanic', value: 'hispanic-latino', text: 'Hispanic/Latino' }, { key: 'white', value: 'white-caucasian', text: 'White/Caucasian' }, { key: 'mixed', value: 'mixed-multiracial', text: 'Mixed/Multiracial' }, { key: 'other', value: 'other', text: 'Other' }];

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OPTIONAL_COLUMN_COUNT = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpUrl = 'https://help.dyzio.co/en/articles/5137000-adding-business-units-or-brands';
	
	var helpLinkStyle = {
	  color: 'rgb(32, 196, 158)'
	};
	
	var columns = ['facebook', 'instagram', 'twitter', 'youtube', 'website', 'snapchat', 'telegram', 'twitch', 'tiktok', 'linkedin', 'Instagram Engagement Rate'];
	var OPTIONAL_COLUMN_COUNT = _lodash2.default.keys(columns).length;
	
	var InfluencerTableSettings = function InfluencerTableSettings(props) {
	  var columnsSettings = props.columnsSettings,
	      businessUnits = props.businessUnits,
	      selectedBusinessUnits = props.selectedBusinessUnits,
	      onColumnCheckboxChange = props.onColumnCheckboxChange,
	      onBusinessUnitsChange = props.onBusinessUnitsChange,
	      tab = props.tab;
	
	
	  var ColumnsChooser = function ColumnsChooser() {
	    return _react2.default.createElement(
	      _semanticUiReact.List,
	      { size: 'mini' },
	      _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: true },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Add or remove the columns that appear in the influencer database table.'
	          )
	        )
	      ),
	      _lodash2.default.map(columns, function (column) {
	        return _react2.default.createElement(
	          _semanticUiReact.List.Item,
	          null,
	          _react2.default.createElement(_semanticUiReact.Checkbox, {
	            checked: _lodash2.default.get(columnsSettings, 'columns.' + _lodash2.default.snakeCase(_lodash2.default.lowerCase(column)) + '.displayed', true),
	            label: column,
	            onChange: onColumnCheckboxChange
	          })
	        );
	      })
	    );
	  };
	
	  var BusinessUnitsFilter = function BusinessUnitsFilter() {
	    return _react2.default.createElement(
	      _semanticUiReact.List,
	      { size: 'mini' },
	      _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: true },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Add or remove the Business Units or Brands that you want to filter your My Influencers database by.'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          { extra: true },
	          _react2.default.createElement(
	            _targetLink2.default,
	            { style: helpLinkStyle, href: helpUrl, renderIf: true },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'help', circular: true }),
	            'click here for help'
	          )
	        )
	      ),
	      _lodash2.default.map(businessUnits, function (businessUnit) {
	        return _react2.default.createElement(
	          _semanticUiReact.List.Item,
	          null,
	          _react2.default.createElement(_semanticUiReact.Checkbox, {
	            checked: _lodash2.default.get(selectedBusinessUnits, 'businessUnits.' + _lodash2.default.snakeCase(_lodash2.default.lowerCase(businessUnit.text)) + '.selected', false),
	            label: businessUnit.text,
	            id: businessUnit.key,
	            onChange: onBusinessUnitsChange
	          })
	        );
	      })
	    );
	  };
	
	  var panes = [{ menuItem: 'Columns', render: function render() {
	      return _react2.default.createElement(
	        _semanticUiReact.Tab.Pane,
	        null,
	        _react2.default.createElement(ColumnsChooser, null)
	      );
	    } }, { menuItem: 'Filter Business Units & Brands', render: function render() {
	      return _react2.default.createElement(
	        _semanticUiReact.Tab.Pane,
	        null,
	        _react2.default.createElement(BusinessUnitsFilter, null)
	      );
	    } }];
	
	  var Tabs = function Tabs() {
	    return _react2.default.createElement(_semanticUiReact.Tab, { panes: panes, defaultActiveIndex: tab || 0 });
	  };
	
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    Object.assign({
	      hasActionButton: true,
	      size: 'tiny',
	      actionButtonContent: 'Save Settings',
	      headerText: 'Settings',
	      onActionButtonClick: props.onClose
	    }, props),
	    _react2.default.createElement(Tabs, null)
	  );
	};
	
	InfluencerTableSettings.propTypes = {
	  onColumnCheckboxChange: _propTypes2.default.func.isRequired,
	  onBusinessUnitsChange: _propTypes2.default.func.isRequired,
	  columnsSettings: _propTypes2.default.object.isRequired,
	  selectedBusinessUnits: _propTypes2.default.object.isRequired,
	  businessUnits: _propTypes2.default.object.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  tab: _propTypes2.default.object.isRequired
	};
	
	exports.default = InfluencerTableSettings;
	exports.OPTIONAL_COLUMN_COUNT = OPTIONAL_COLUMN_COUNT;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _newCampaignForm = __webpack_require__(889);
	
	var _newCampaignForm2 = _interopRequireDefault(_newCampaignForm);
	
	var _helpLink = __webpack_require__(546);
	
	var _helpLink2 = _interopRequireDefault(_helpLink);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _newCampaignSteps = __webpack_require__(2002);
	
	var _newCampaignSteps2 = _interopRequireDefault(_newCampaignSteps);
	
	var _campaignTypeButtons = __webpack_require__(2001);
	
	var _campaignTypeButtons2 = _interopRequireDefault(_campaignTypeButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var noPadding = {
	  padding: '0'
	};
	
	var imageStyle = {
	  display: 'block',
	  margin: '170px auto 0px auto'
	};
	
	var leftBlockStyle = _extends({}, noPadding, {
	  backgroundColor: '#f7fafa',
	  borderRadius: '4px'
	});
	
	var modalContentStyle = _extends({}, noPadding);
	
	var rightBlockStyle = {
	  padding: '50px'
	};
	
	var linkWrapperStyle = {
	  width: '100%',
	  textAlign: 'center',
	  marginTop: 40
	};
	
	var NewAddCampaignModal = function (_React$Component) {
	  _inherits(NewAddCampaignModal, _React$Component);
	
	  function NewAddCampaignModal(props) {
	    _classCallCheck(this, NewAddCampaignModal);
	
	    var _this = _possibleConstructorReturn(this, (NewAddCampaignModal.__proto__ || Object.getPrototypeOf(NewAddCampaignModal)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var stepIndex = props.stepIndex,
	        campaignType = props.campaignType;
	
	    _this.state = { stepIndex: stepIndex, campaignType: campaignType };
	    return _this;
	  }
	
	  return NewAddCampaignModal;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onTypeSelected = function (campaignType) {
	    _this2.setState({
	      campaignType: campaignType,
	      stepIndex: 2
	    });
	  };
	
	  this.render = function () {
	    var _props = _this2.props,
	        title = _props.title,
	        onClose = _props.onClose,
	        onAddCampaignSubmit = _props.onAddCampaignSubmit,
	        allowCampaignTypeChange = _props.allowCampaignTypeChange;
	    var _state = _this2.state,
	        stepIndex = _state.stepIndex,
	        campaignType = _state.campaignType;
	
	    var _ThemeSelector$theme = _themeSelector2.default.theme(),
	        disableHelpLinks = _ThemeSelector$theme.disableHelpLinks;
	
	    return _react2.default.createElement(
	      _semanticUiReact.Modal,
	      {
	        open: true,
	        closeOnEscape: true,
	        closeOnDimmerClick: true,
	        onClose: onClose
	      },
	      _react2.default.createElement(
	        _semanticUiReact.Modal.Content,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          allowCampaignTypeChange && _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { style: noPadding },
	            _react2.default.createElement(_newCampaignSteps2.default, {
	              stepIndex: stepIndex,
	              onStepClick: function onStepClick(i) {
	                return _this2.setState({ stepIndex: i });
	              }
	            }),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	          ),
	          (stepIndex === 2 || !allowCampaignTypeChange) && _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { style: modalContentStyle },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 8, style: leftBlockStyle },
	              _react2.default.createElement(_semanticUiReact.Image, { src: '/images/add-campaign.svg', style: imageStyle }),
	              _react2.default.createElement(
	                'div',
	                { style: linkWrapperStyle },
	                !disableHelpLinks && _react2.default.createElement(_helpLink2.default, { url: 'https://help.dyzio.co/en/articles/5089448-how-to-create-a-campaign' })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 8, style: rightBlockStyle },
	              _react2.default.createElement(
	                'h3',
	                null,
	                title
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	              _react2.default.createElement(_newCampaignForm2.default, {
	                onBackClick: function onBackClick() {
	                  return _this2.setState({
	                    stepIndex: 1
	                  });
	                },
	                campaignType: campaignType,
	                onFormSubmit: onAddCampaignSubmit
	              }),
	              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	            )
	          ),
	          stepIndex === 1 && allowCampaignTypeChange && _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { style: modalContentStyle },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 16 },
	              _react2.default.createElement(_campaignTypeButtons2.default, {
	                onTypeSelected: _this2.onTypeSelected
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	};
	
	NewAddCampaignModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  onAddCampaignSubmit: _propTypes2.default.func.isRequired,
	  title: _propTypes2.default.string,
	  campaignType: _propTypes2.default.string,
	  stepIndex: _propTypes2.default.number,
	  allowCampaignTypeChange: _propTypes2.default.bool.isRequired
	};
	
	NewAddCampaignModal.defaultProps = {
	  title: 'Add a campaign',
	  stepIndex: 1,
	  buttonLabel: 'Save',
	  campaignType: null
	};
	
	exports.default = NewAddCampaignModal;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(37);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PublicHeader = function PublicHeader(_ref) {
	  var router = _ref.router;
	
	  var theme = _themeSelector2.default.theme();
	  var headerStyle = theme.headerStyle || {};
	  var logoStyle = {
	    height: theme.headerLogo.size || 40,
	    display: 'block',
	    margin: '0 auto'
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: 'page-navigation-header', style: headerStyle },
	    _react2.default.createElement('img', {
	      onClick: function onClick() {
	        return router.push('/');
	      },
	      className: 'logo',
	      style: logoStyle,
	      src: theme.headerLogo.src,
	      alt: theme.headerLogo.alt
	    })
	  );
	};
	
	PublicHeader.propTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(PublicHeader);

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _recompose = __webpack_require__(15);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _basicReport = __webpack_require__(2585);
	
	var _basicReport2 = _interopRequireDefault(_basicReport);
	
	var _instagramReport = __webpack_require__(2592);
	
	var _instagramReport2 = _interopRequireDefault(_instagramReport);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasOrganisation = __webpack_require__(106);
	
	var _hasOrganisation2 = _interopRequireDefault(_hasOrganisation);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _addAssetForm = __webpack_require__(276);
	
	var _addAssetForm2 = _interopRequireDefault(_addAssetForm);
	
	var _sendLimitsExceededNotifcation = __webpack_require__(365);
	
	var _sendLimitsExceededNotifcation2 = _interopRequireDefault(_sendLimitsExceededNotifcation);
	
	var _authService = __webpack_require__(21);
	
	var _privateDataWhitelist = __webpack_require__(572);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KASPERSKY_ID = 'ec3b6d8e-f9f0-42f4-9c09-294368cbe683';
	var JOHN_LEWIS_ID = 'cfa6155e-0b5e-4ebc-8150-c8715217fdc8';
	var THE_ROOM_ID = '0cc7aa37-af63-4f05-95ac-c42ded273c32';
	
	var currentTheme = _themeSelector2.default.theme();
	
	var daysOptions = [{ label: '30 days', value: 30, id: 30 }, { label: '90 days', value: 90, id: 90 }, { label: '120 days', value: 120, id: 120 }, { label: 'all days', value: -1, id: 'all' }];
	
	var loadingSegmentStyle = { height: 175 };
	var bottomSpace = { height: 100, width: '100%' };
	var shouldReloadOnPeriodFilter = function shouldReloadOnPeriodFilter(arg) {
	  return !_lodash2.default.isNull(arg.start) && !_lodash2.default.isNull(arg.end);
	};
	var REPORT_API_TIMEOUT = 20000;
	
	var DEFAULT_PER_DAYS = 90;
	
	var Report = function (_React$Component) {
	  _inherits(Report, _React$Component);
	
	  function Report() {
	    _classCallCheck(this, Report);
	
	    var _this = _possibleConstructorReturn(this, (Report.__proto__ || Object.getPrototypeOf(Report)).call(this));
	
	    _initialiseProps.call(_this);
	
	    var reportPerDays = _lodash2.default.find(daysOptions, ['value', DEFAULT_PER_DAYS]);
	    _this.state = {
	      type: 'basic',
	      id: null,
	      error: false,
	      loading: true,
	      data: null,
	      copied: false,
	      sort: 'values.totals.followersCount',
	      groupBy: 'influencer',
	      addingAsset: false,
	      newAssetPlatform: null,
	      reportPerDays: reportPerDays,
	      order: {
	        basic: {
	          field: null,
	          value: null
	        }
	      },
	      filter: {
	        basic: {
	          platform: null,
	          discussion: null
	        }
	      },
	      datePeriodFilter: {
	        start: null,
	        end: null
	      }
	    };
	
	    _this.client = _axios2.default.create({
	      baseURL: ("https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production"),
	      timeout: REPORT_API_TIMEOUT
	    });
	
	    _this.restClient = _axios2.default.create({
	      baseURL: ("https://api2.dyzio.co/v1"),
	      timeout: 5000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    _this.jsonClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	      header: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    _this.notifyClient = _axios2.default.create({
	      baseURL: ("https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/notifyaccess"),
	      timeout: 2000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Report, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          id = _props.id,
	          campaignAPIClient = _props.campaignAPIClient,
	          organisationId = _props.userInfo.organisationId;
	      var type = this.state.type;
	
	      this.loadReport(id, type);
	      this.setState({
	        isLoadingTotals: true
	      });
	      var requests = [campaignAPIClient.get('/summary/tracked-assets?organisationId=' + organisationId)];
	
	      return Promise.all(requests).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 1),
	            trackedAssetsCount = _ref2[0].data.data.trackedAssetsCount;
	
	        return _this2.setState({
	          trackedAssetsCount: trackedAssetsCount,
	          isLoadingTotals: false
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          organisation = _props2.organisation,
	          userInfo = _props2.userInfo;
	      var _state = this.state,
	          type = _state.type,
	          data = _state.data,
	          error = _state.error,
	          sort = _state.sort,
	          groupBy = _state.groupBy,
	          filter = _state.filter,
	          order = _state.order,
	          addingAsset = _state.addingAsset,
	          newAssetPlatform = _state.newAssetPlatform,
	          isLoadingTotals = _state.isLoadingTotals,
	          trackedAssetsCount = _state.trackedAssetsCount,
	          reportPerDays = _state.reportPerDays;
	
	      var _ref3 = organisation || {},
	          isFacebookAdsEnabled = _ref3.isFacebookAdsEnabled,
	          isGoogleAnalyticsEnabled = _ref3.isGoogleAnalyticsEnabled,
	          licenseSubscriptionType = _ref3.licenseSubscriptionType;
	
	      var isPremiumAccount = !_lodash2.default.isEqual(licenseSubscriptionType, 'FREE');
	
	      var isKaspersky = _lodash2.default.get(userInfo, 'organisationId', null) === KASPERSKY_ID;
	      var isJL = _lodash2.default.get(userInfo, 'organisationId') === JOHN_LEWIS_ID;
	      var isTheRoom = _lodash2.default.get(userInfo, 'organisationId') === THE_ROOM_ID;
	
	      var campaignType = this.state.loading ? null : _lodash2.default.get(data, 'data.campaignType');
	
	      var isACR = campaignType === 'ACR';
	
	      var loading = this.state.loading || this.props.organisationLoading || this.state.isLoadingTotals;
	
	      var acrOptions = [{
	        onClick: this.switchReport,
	        key: 'basic',
	        icon: 'file text outline',
	        text: 'Campaign report',
	        value: 'campaign',
	        disable: false
	      }, {
	        onClick: this.switchReport,
	        key: 'instagram',
	        icon: 'instagram',
	        text: 'Instagram report',
	        value: 'instagram',
	        disable: false
	      }];
	
	      if (isJL || isTheRoom) {
	        acrOptions.push({
	          onClick: this.switchReport,
	          key: 'instagram-custom',
	          icon: 'instagram',
	          text: 'Custom Instagram Report',
	          value: 'instagram-custom',
	          disable: !isPremiumAccount
	        });
	      }
	
	      var otherOptions = [{
	        onClick: this.switchReport,
	        key: 'insights',
	        icon: 'table',
	        text: 'Insights report',
	        value: 'insights',
	        disable: true
	      }, {
	        onClick: this.switchReport,
	        key: 'authorisation',
	        icon: 'lock',
	        text: 'Authorisation report',
	        value: 'auth',
	        disable: !isPremiumAccount
	      }, {
	        onClick: this.switchReport,
	        key: 'roi',
	        icon: 'dollar',
	        text: 'Influencer ROI report',
	        value: 'roi',
	        disable: false
	      }, {
	        onClick: this.switchReport,
	        key: 'paid',
	        icon: 'money bill alternate outline',
	        text: 'Paid report',
	        value: 'paid',
	        disable: !isFacebookAdsEnabled
	      }, {
	        onClick: this.switchReport,
	        key: 'emv',
	        icon: 'calculator',
	        text: 'Earned Media Value (EMV)',
	        value: 'emv',
	        disable: false
	      }, {
	        onClick: this.switchReport,
	        key: 'gi',
	        icon: 'line graph',
	        text: 'Guaranteed Impression Report',
	        value: 'gi',
	        disable: !isFacebookAdsEnabled
	      }, {
	        onClick: this.switchReport,
	        key: 'ga',
	        icon: 'google',
	        text: 'Google Analytics Report',
	        value: 'ga',
	        disable: !isGoogleAnalyticsEnabled
	      }];
	
	      var options = isACR ? acrOptions : _lodash2.default.concat(acrOptions, otherOptions);
	
	      var assetOptions = [{
	        label: 'facebook post',
	        icon: 'facebook',
	        value: 'facebook',
	        color: 'red',
	        onClick: this.toggleAddAssetPopup
	      }, {
	        label: 'twitter post',
	        icon: 'twitter',
	        value: 'twitter',
	        onClick: this.toggleAddAssetPopup
	      }, {
	        label: 'instagram post',
	        icon: 'instagram',
	        value: 'instagram',
	        onClick: this.toggleAddAssetPopup
	      }, {
	        label: 'youtube video',
	        icon: 'youtube',
	        value: 'youtube',
	        onClick: this.toggleAddAssetPopup
	      }];
	
	      var filterDates = this.state.datePeriodFilter;
	
	      var datePeriodFilterValues = {
	        start: filterDates.start && filterDates.start.format('DD/MM/YYYY'),
	        end: filterDates.end && filterDates.end.format('DD/MM/YYYY')
	      };
	
	      console.log('DO NOT AGGREGATE YOUTUBE');
	      return _react2.default.createElement(
	        'div',
	        null,
	        loading && _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { style: loadingSegmentStyle },
	          _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: true, inverted: true },
	            _react2.default.createElement(
	              _semanticUiReact.Loader,
	              { size: 'big' },
	              'Loading'
	            )
	          )
	        ),
	        !loading && _lodash2.default.lowerCase(type) === 'basic' && _react2.default.createElement(_basicReport2.default, {
	          data: data,
	          sort: sort,
	          reportMode: 'internal',
	          order: order.basic,
	          filter: filter.basic,
	          onFilterChange: this.onFilterChange,
	          onOrderChanged: this.onOrderChanged,
	          rightFilterOptions: _lodash2.default.reject(options, function (o) {
	            return o.disable;
	          }),
	          deleteCallback: this.deleteAssetCallback,
	          hasRightFilterOptions: isKaspersky,
	          assetOptions: assetOptions,
	          onDownloadClick: this.handleDownloadClick,
	          emptyCampaignText: 'You are not tracking any assets. Please go to the Influencer tab and click on each influencer, to add assets manually to your campaign. ',
	          withHeader: false,
	          withDatePeriodFilter: true,
	          withDaysFilter: true,
	          daysOptions: daysOptions,
	          perDaysOption: reportPerDays,
	          onPerDaysChanged: this.onPerDaysChanged,
	          datePeriodFilterValues: datePeriodFilterValues,
	          onDateFilterChange: this.onDateFilterChange,
	          instagramHandleFilter: _lodash2.default.get(this.state, 'filter.instagramHandle')
	        }),
	        !loading && !error && _lodash2.default.lowerCase(type) === 'instagram' && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_instagramReport2.default, {
	            data: data,
	            sort: sort,
	            reportMode: 'internal',
	            groupBy: groupBy,
	            onSortChanged: this.onSortChanged,
	            onGroupByChanged: this.onGroupByChanged,
	            withHeader: false
	          })
	        ),
	        addingAsset && !loading && !isLoadingTotals && _react2.default.createElement(_addAssetForm2.default, {
	          isOpen: addingAsset,
	          isOverLimit: trackedAssetsCount >= organisation.licenseTrackedAssetLimit,
	          platform: newAssetPlatform,
	          popupToggleHandler: this.assetPopupToggleHandler,
	          addAssetHandler: this.addAssetHandler,
	          posts: data
	        }),
	        _react2.default.createElement('div', { style: bottomSpace })
	      );
	    }
	  }]);
	
	  return Report;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onSortChanged = function (event, data) {
	    var value = data.value;
	
	    _this3.setState({
	      sort: value
	    });
	  };
	
	  this.onOrderChanged = function (field, value) {
	    var order = _this3.state.order;
	
	    order.basic = {
	      field: field,
	      value: value
	    };
	    _this3.setState({
	      order: order
	    });
	  };
	
	  this.onGroupByChanged = function (event, data) {
	    var value = data.value;
	
	    _this3.setState({
	      groupBy: value
	    });
	  };
	
	  this.onPerDaysChanged = function (event, option) {
	    _this3.setState({
	      reportPerDays: option
	    }, _this3.loadReport);
	  };
	
	  this.onFilterChange = function (event, data) {
	    var handle = _lodash2.default.get(data, 'children[2]');
	    var filter = _this3.state.filter;
	    var value = data.value;
	
	    var parts = _lodash2.default.split(value, '.');
	    var val = parts.pop();
	    var key = parts.pop();
	    filter.basic[key] = val === 'reset' ? null : val;
	    filter.instagramHandle = val === 'reset' ? undefined : handle;
	    _this3.setState({
	      filter: filter
	    });
	  };
	
	  this.loadReport = function () {
	    var id = _this3.props.id;
	    var _state2 = _this3.state,
	        type = _state2.type,
	        datePeriodFilter = _state2.datePeriodFilter,
	        reportPerDays = _state2.reportPerDays;
	
	    var shouldFilterByDate = shouldReloadOnPeriodFilter(datePeriodFilter);
	    var params = { id: id, type: type };
	    if (reportPerDays && reportPerDays.value !== -1) {
	      params.days = reportPerDays.value;
	    }
	    _this3.setState({
	      loading: true,
	      error: false
	    });
	    var dateParams = _extends({
	      startDate: shouldFilterByDate ? datePeriodFilter.start.format('YYYY-MM-DD') : undefined,
	      endDate: shouldFilterByDate ? datePeriodFilter.end.format('YYYY-MM-DD') : undefined
	    }, params);
	    _this3.client.get('report', {
	      params: shouldFilterByDate ? dateParams : params
	    }).then(function (response) {
	      var data = response.data;
	
	      if (type === 'basic') {
	        var posts = _lodash2.default.filter(data.data.posts, function (post) {
	          return !_lodash2.default.isNull(post) && !_lodash2.default.isUndefined(post.trackedAsset);
	        });
	        var uniqueByUrl = _lodash2.default.uniqBy(posts, 'trackedAsset.assetURL');
	        data.data.posts = uniqueByUrl;
	      }
	      _this3.setState({
	        data: data, id: id, type: type, loading: false, error: false
	      });
	    }).catch(function (e) {
	      console.log(e);
	      _this3.setState({
	        loading: false, error: true
	      });
	    });
	  };
	
	  this.switchReport = function (event, data) {
	    var value = data.value;
	    var id = _this3.state.id;
	
	    window.open(currentTheme.shareSite + '/report/' + id + '/' + value, '_blank');
	  };
	
	  this.copyToClipboard = function () {
	    _this3.setState({
	      copied: true
	    });
	  };
	
	  this.toggleAddAssetPopup = function (event, data) {
	    var hasSentRoadblockNotifcation = _this3.state.hasSentRoadblockNotifcation;
	    var value = data.value;
	
	    if (!hasSentRoadblockNotifcation) {
	      _this3.checkLimitsNotification();
	    }
	    _this3.setState({
	      addingAsset: true,
	      hasSentRoadblockNotifcation: true,
	      newAssetPlatform: value
	    });
	  };
	
	  this.checkLimitsNotification = function () {
	    var _props3 = _this3.props,
	        restClient = _props3.restClient,
	        _props3$userInfo = _props3.userInfo,
	        organisationId = _props3$userInfo.organisationId,
	        name = _props3$userInfo.name,
	        userId = _props3$userInfo.userId,
	        organisation = _props3.organisation;
	    var trackedAssetsCount = _this3.state.trackedAssetsCount;
	
	    if (!trackedAssetsCount || !organisation) return;
	    if (trackedAssetsCount < organisation.licenseTrackedAssetLimit) return;
	    (0, _sendLimitsExceededNotifcation2.default)(restClient, {
	      data: {
	        name: name + ' ',
	        organisationId: organisationId,
	        userId: userId,
	        organisationName: organisation.name + ' ',
	        assetType: 'tracked assets',
	        licenseSubscriptionType: organisation.licenseSubscriptionType,
	        url: window.location.href
	      }
	    });
	  };
	
	  this.assetPopupToggleHandler = function () {
	    _this3.setState({
	      addingAsset: false,
	      newAssetPlatform: null
	    });
	  };
	
	  this.addAssetHandler = function (details) {
	    var REQUEST_TIMEOUT = 2000;
	    var id = _this3.state.id;
	
	    _this3.setState({
	      loading: true
	    });
	    var trackedAsset = _this3.jsonClient.create('trackedAssets');
	    trackedAsset.set('assetId', details.assetId);
	    trackedAsset.set('assetURL', details.assetURL);
	    trackedAsset.set('user', {
	      type: 'users',
	      id: _authService.authService.uid()
	    });
	    trackedAsset.set('campaign', {
	      type: 'campaigns',
	      id: id
	    });
	    trackedAsset.set('platform', details.platform);
	    trackedAsset.set('assetType', details.type);
	    trackedAsset.set('createdSource', 'CAMPAIGN');
	    trackedAsset.sync().then(function () {
	      _this3.jsonClient.get('campaigns', id).then(function (campaign) {
	        campaign.relationships('trackedAssets').add(trackedAsset);
	        campaign.sync().then(function () {
	          _this3.assetPopupToggleHandler();
	          setTimeout(function () {
	            _this3.loadReport();
	          }, REQUEST_TIMEOUT);
	        });
	      });
	    });
	  };
	
	  this.deleteTrackedAsset = function (id, callback) {
	    _this3.jsonClient.get('trackedAssets', id, function (err, asset) {
	      if (asset && !err) {
	        asset.delete(function (error) {
	          if (error) {
	            callback(error);
	            return;
	          }
	          callback(null);
	        });
	      }
	    });
	  };
	
	  this.patchCampaign = function () {
	    var posts = _this3.state.data.data.posts;
	    var id = _this3.props.id;
	
	
	    var patch = _lodash2.default.map(posts, function (post) {
	      return {
	        id: post.trackedAsset.id,
	        type: 'trackedAssets'
	      };
	    });
	
	    return _this3.restClient.patch('/campaigns/' + id + '/relationships/trackedAssets', { data: patch });
	  };
	
	  this.deleteAssetCallback = function (e, button) {
	    var value = button.value;
	    var data = _this3.state.data;
	
	    var posts = _lodash2.default.reject(data.data.posts, ['trackedAsset.id', value]);
	    _this3.setState({
	      data: { data: { posts: posts } }
	    }, function () {
	      _this3.patchCampaign().then(function () {
	        _this3.deleteTrackedAsset(value);
	      });
	    });
	  };
	
	  this.handleDownloadClick = function () {
	    var data = _this3.state.data;
	
	    var profile = _authService.authService.getProfile();
	
	    if (profile) {
	      var campaign = {
	        name: data.data.name
	      };
	      var notification = {
	        data: {
	          profile: profile,
	          campaign: campaign,
	          type: 'DOWNLOAD_CSV'
	        }
	      };
	      _this3.notifyClient.post('/', notification);
	    }
	  };
	
	  this.onDateFilterChange = function (date, dateType) {
	    var datePeriodFilter = _this3.state.datePeriodFilter;
	
	    datePeriodFilter[dateType] = (0, _moment2.default)(date);
	    _this3.setState({
	      datePeriodFilter: datePeriodFilter
	    }, function () {
	      if (shouldReloadOnPeriodFilter(_this3.state.datePeriodFilter)) {
	        _this3.loadReport();
	      }
	    });
	  };
	};
	
	Report.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  organisationLoading: _propTypes2.default.bool.isRequired,
	  organisation: _propTypes2.default.object,
	  userInfo: _propTypes2.default.object.isRequired
	};
	Report.defaultProps = {
	  organisation: null
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasOrganisation2.default)(Report);

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuthorisedIcon = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _tokenStatusModal = __webpack_require__(2220);
	
	var _tokenStatusModal2 = _interopRequireDefault(_tokenStatusModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commaFormat = function commaFormat(num) {
	  return (0, _numeral2.default)(num).format('0a');
	};
	var SHORTLIST_MODE = 'SHORTLIST';
	
	var iconStyle = {
	  height: '24px',
	  width: '24px'
	};
	
	var StatusIconAuthorised = function StatusIconAuthorised(_ref) {
	  var channel = _ref.channel,
	      handle = _ref.handle,
	      mode = _ref.mode;
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle outline', color: 'green', size: 'large' }),
	    content: _lodash2.default.upperFirst(channel) + ' channel ' + handle + ' has been authorised.'
	  });
	};
	
	var StatusIconWarn = function StatusIconWarn(_ref2) {
	  var channel = _ref2.channel,
	      handle = _ref2.handle,
	      influencer = _ref2.influencer;
	
	  //
	  if (channel === 'instagram') {
	    return _react2.default.createElement(_tokenStatusModal2.default, { handle: handle, channel: channel, influencer: influencer });
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning circle', color: 'orange', size: 'large' }),
	    content: 'Something went wrong accessing data from ' + _lodash2.default.upperFirst(channel) + ' channel ' + handle
	  });
	};
	
	var StatusIconNotAuthorised = function StatusIconNotAuthorised(_ref3) {
	  var channel = _ref3.channel,
	      handle = _ref3.handle;
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'grey', size: 'large' }),
	    content: _lodash2.default.upperFirst(channel) + ' channel ' + handle + ' has NOT been authorised.'
	  });
	};
	
	var getYoutubeLink = function getYoutubeLink(influencer) {
	  var youtube = influencer.youtube;
	
	  if (!youtube) return '';
	  var channelIdRegex = /^UC([a-zA-Z0-9_-]{22})$/;
	  return youtube.match(channelIdRegex) ? 'channel/' : 'user/';
	};
	
	var getAuthorisedIcon = exports.getAuthorisedIcon = function getAuthorisedIcon(influencer, channel) {
	  var handle = influencer[channel];
	  var isAuthorised = influencer[channel + 'Authorised'];
	  var isTokenValid = influencer[channel + 'Status'] === 'AUTHORIZED';
	
	  if (!isAuthorised) {
	    return _react2.default.createElement(StatusIconNotAuthorised, { channel: channel, handle: handle });
	  }
	
	  if (isAuthorised && isTokenValid) {
	    return _react2.default.createElement(StatusIconAuthorised, { channel: channel, handle: handle });
	  }
	
	  if (isAuthorised && !isTokenValid) {
	    return _react2.default.createElement(StatusIconWarn, { channel: channel, handle: handle, influencer: influencer });
	  }
	
	  return null;
	};
	
	var getLinkedItem = function getLinkedItem(influencer, channel, mode) {
	  var handle = influencer[channel];
	  var youtubeShim = channel === 'youtube' ? getYoutubeLink(influencer) : '';
	
	  var isShortlistMode = mode === SHORTLIST_MODE;
	
	  var tiktokExtra = channel === 'tiktok' ? '@' : '';
	
	  if (handle) {
	    return _react2.default.createElement(
	      'a',
	      {
	        href: 'https://www.' + channel + '.com/' + youtubeShim + tiktokExtra + handle,
	        target: '_blank',
	        rel: 'noopener noreferrer'
	      },
	      _react2.default.createElement('img', { style: iconStyle, src: '/icons/' + channel + '.svg', alt: channel }),
	      !isShortlistMode && getAuthorisedIcon(influencer, channel),
	      _react2.default.createElement(
	        'p',
	        { className: 'light' },
	        commaFormat(influencer[channel + 'Count'])
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('img', { style: iconStyle, src: '/icons/' + channel + '.svg', alt: channel }),
	    _react2.default.createElement(
	      'p',
	      { className: 'light' },
	      commaFormat(0)
	    )
	  );
	};
	
	var SocialTable = function SocialTable(_ref4) {
	  var influencer = _ref4.influencer,
	      mode = _ref4.mode;
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { fixed: true, textAlign: 'center', basic: 'very' },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          getLinkedItem(influencer, 'instagram', mode)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          getLinkedItem(influencer, 'facebook', mode)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          getLinkedItem(influencer, 'youtube', mode)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          getLinkedItem(influencer, 'tiktok', mode)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          getLinkedItem(influencer, 'twitch', mode)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          getLinkedItem(influencer, 'twitter', mode)
	        )
	      )
	    )
	  );
	};
	
	SocialTable.propTypes = {
	  influencer: _propTypes2.default.object.isRequired
	};
	
	exports.default = SocialTable;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tooltip = function Tooltip(_ref) {
	  var content = _ref.content,
	      children = _ref.children,
	      name = _ref.name,
	      role = _ref.role,
	      email = _ref.email,
	      style = _ref.style;
	  return _react2.default.createElement(
	    'div',
	    { className: style },
	    children,
	    _react2.default.createElement(
	      'div',
	      { className: 'tooltip' },
	      _react2.default.createElement(
	        'div',
	        { className: 'tooltip-profile-inner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'tooltip-content' },
	          content && _react2.default.createElement(
	            'p',
	            { className: 'small' },
	            content
	          ),
	          email && _react2.default.createElement(
	            'p',
	            { className: 'small' },
	            email
	          ),
	          role && _react2.default.createElement(
	            'div',
	            { className: 'role' },
	            _react2.default.createElement(
	              'p',
	              { className: 'small capitalized' },
	              role
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'arrow-outer' }),
	        _react2.default.createElement('div', { className: 'arrow-inner' })
	      )
	    )
	  );
	};
	
	exports.default = Tooltip;

/***/ },
/* 555 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_ASSET_PAGE_BACK_LINK = exports.SET_ASSET_PAGE_BACK_LINK = 'Dyzio/AnalyticsAsset/SET_ASSET_PAGE_BACK_LINK';

/***/ },
/* 556 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_CAMPAIGN_INVITE = exports.LOAD_CAMPAIGN_INVITE = 'Dyzio/CampaignInvite/LOAD_CAMPAIGN_INVITE';
	var LOAD_CAMPAIGN_INVITE_ERROR = exports.LOAD_CAMPAIGN_INVITE_ERROR = 'Dyzio/CampaignInvite/LOAD_CAMPAIGN_INVITE_ERROR';
	
	var SET_SIGNUP_PREFILLED = exports.SET_SIGNUP_PREFILLED = 'Dyzio/CampaignInvite/SET_SIGNUP_PREFILLED';
	var SET_LOGIN_PREFILLED = exports.SET_LOGIN_PREFILLED = 'Dyzio/CampaignInvite/SET_LOGIN_PREFILLED';
	var CLEAR_INVITE_PREFILLED = exports.CLEAR_INVITE_PREFILLED = 'Dyzio/CampaignInvite/CLEAR_INVITE_PREFILLED';

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadingCampaign = loadingCampaign;
	exports.loadCampaignError = loadCampaignError;
	exports.loadingCampaignSuccess = loadingCampaignSuccess;
	
	var _constants = __webpack_require__(280);
	
	function loadingCampaign(campaignId) {
	  var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var fastLoad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  return {
	    type: _constants.LOAD_CAMPAIGN,
	    campaignId: campaignId,
	    silent: silent,
	    fastLoad: fastLoad
	  };
	}
	
	function loadCampaignError(error) {
	  return {
	    type: _constants.LOAD_CAMPAIGN_ERROR,
	    error: error
	  };
	}
	
	function loadingCampaignSuccess(campaign) {
	  return {
	    type: _constants.LOAD_CAMPAIGN_SUCCESS,
	    campaign: campaign
	  };
	}

/***/ },
/* 558 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SUBMIT_DELIVERABLE = exports.SUBMIT_DELIVERABLE = 'Dyzio/DeliverableAdd/SUBMIT_DELIVERABLE';
	
	var SET_INITIAL_DELIVERABLE = exports.SET_INITIAL_DELIVERABLE = 'Dyzio/DeliverableAdd/SET_INITIAL_DELIVERABLE';
	var SET_INITIAL_SUBMIT_TYPE = exports.SET_INITIAL_SUBMIT_TYPE = 'Dyzio/DeliverableAdd/SET_INITIAL_SUBMIT_TYPE';
	var UPDATE_ADD_DELIVERABLE_FORM_OPTIONS = exports.UPDATE_ADD_DELIVERABLE_FORM_OPTIONS = 'Dyzio/DeliverableAdd/UPDATE_ADD_DELIVERABLE_FORM_OPTIONS';

/***/ },
/* 559 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_DELIVERABLE = exports.LOAD_DELIVERABLE = 'Dyzio/Deliverable/LOAD_DELIVERABLE';
	var LOAD_DELIVERABLE_SUCCESS = exports.LOAD_DELIVERABLE_SUCCESS = 'Dyzio/Deliverable/LOAD_DELIVERABLE_SUCCESS';
	var LOAD_DELIVERABLE_ERROR = exports.LOAD_DELIVERABLE_ERROR = 'Dyzio/Deliverable/LOAD_DELIVERABLE_ERROR';
	var CLEAR_DELIVERABLE = exports.CLEAR_DELIVERABLE = 'Dyzio/Deliverable/CLEAR_DELIVERABLE';
	
	var CREATE_COMMENT = exports.CREATE_COMMENT = 'Dyzio/Deliverable/CREATE_COMMENT';
	var CREATE_COMMENT_SUCCESS = exports.CREATE_COMMENT_SUCCESS = 'Dyzio/Deliverable/CREATE_COMMENT_SUCCESS';
	var CREATE_COMMENT_ERROR = exports.CREATE_COMMENT_ERROR = 'Dyzio/Deliverable/CREATE_COMMENT_ERROR';
	
	var APPROVE_DELIVERABLE = exports.APPROVE_DELIVERABLE = 'Dyzio/Deliverable/APPROVE_DELIVERABLE';
	var UPDATE_DELIVERABLE_DOCUMENT_STATE = exports.UPDATE_DELIVERABLE_DOCUMENT_STATE = 'Dyzio/Deliverable/UPDATE_DELIVERABLE_DOCUMENT_STATE';
	
	var CHANGE_SELECT_DOCUMENT_VERSION = exports.CHANGE_SELECT_DOCUMENT_VERSION = 'Dyzio/Deliverable/CHANGE_SELECT_DOCUMENT_VERSION';
	var CHANGE_SELECT_DOCUMENT_VERSION_SUCCESS = exports.CHANGE_SELECT_DOCUMENT_VERSION_SUCCESS = 'Dyzio/Deliverable/CHANGE_SELECT_DOCUMENT_VERSION_SUCCESS';

/***/ },
/* 560 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_INFLUENCERS = exports.LOAD_INFLUENCERS = 'Dyzio/Influencers/LOAD_INFLUENCERS';
	var LOAD_INFLUENCERS_SUCCESS = exports.LOAD_INFLUENCERS_SUCCESS = 'Dyzio/Influencers/LOAD_INFLUENCERS_SUCCESS';
	var LOAD_INFLUENCERS_ERROR = exports.LOAD_INFLUENCERS_ERROR = 'Dyzio/Influencers/LOAD_INFLUENCERS_ERROR';
	
	var LOAD_SINGLE_INFLUENCER = exports.LOAD_SINGLE_INFLUENCER = 'Dyzio/Influencers/LOAD_SINGLE_INFLUENCER';
	var LOAD_SINGLE_INFLUENCER_SUCCESS = exports.LOAD_SINGLE_INFLUENCER_SUCCESS = 'Dyzio/Influencers/LOAD_SINGLE_INFLUENCER_SUCCESS';
	var LOAD_SINGLE_INFLUENCER_ERROR = exports.LOAD_SINGLE_INFLUENCER_ERROR = 'Dyzio/Influencers/LOAD_SINGLE_INFLUENCER_ERROR';
	
	var SEARCH = exports.SEARCH = 'Dyzio/Influencers/SEARCH';
	var SEARCH_ERROR = exports.SEARCH_ERROR = 'Dyzio/Influencers/SEARCH_ERROR';
	var SEARCH_SUCCESS = exports.SEARCH_SUCCESS = 'Dyzio/Influencers/SEARCH_SUCCESS';
	
	var ADD_INFLUENCER = exports.ADD_INFLUENCER = 'Dyzio/Influencers/ADD_INFLUENCER';
	var ADD_INFLUENCER_EROR = exports.ADD_INFLUENCER_EROR = 'Dyzio/Influencers/ADD_INFLUENCER_ERROR';
	var ADD_INFLUENCER_SUCCESS = exports.ADD_INFLUENCER_SUCCESS = 'Dyzio/Influencers/ADD_INFLUENCER_SUCCESS';
	
	var LOAD_ORGANISATION_NAME = exports.LOAD_ORGANISATION_NAME = 'Dyzio/Influencers/LOAD_ORGANISATION_NAME';
	var LOAD_ORGANISATION_NAME_SUCCESS = exports.LOAD_ORGANISATION_NAME_SUCCESS = 'Dyzio/Influencers/LOAD_ORGANISATION_NAME_SUCCESS';
	var LOAD_ORGANISATION_NAME_ERROR = exports.LOAD_ORGANISATION_NAME_ERROR = 'Dyzio/Influencers/LOAD_ORGANISATION_NAME_ERROR';

/***/ },
/* 561 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_PAYMENTS = exports.LOAD_PAYMENTS = 'Dyzio/Payments/LOAD_PAYMENTS';
	var LOAD_PAYMENTS_ERROR = exports.LOAD_PAYMENTS_ERROR = 'Dyzio/Payments/LOAD_PAYMENTS_ERROR';
	var LOAD_PAYMENTS_SUCCESS = exports.LOAD_PAYMENTS_SUCCESS = 'Dyzio/Payments/LOAD_PAYMENTS_SUCCESS';

/***/ },
/* 562 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_STATUS_BAR = exports.SET_STATUS_BAR = 'Dyzio/StatusBar/SET_STATUS_BAR';
	var CLEAR_STATUS_BAR = exports.CLEAR_STATUS_BAR = 'Dyzio/StatusBar/CLEAR_STATUS_BAR';

/***/ },
/* 563 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_USER = exports.GET_USER = 'Dyzio/UserHandler/GET_USER';
	var GET_USER_SUCCESS = exports.GET_USER_SUCCESS = 'Dyzio/UserHandler/GET_USER_SUCCESS';
	var GET_USER_ERROR = exports.GET_USER_ERROR = 'Dyzio/UserHandler/GET_USER_ERROR';

/***/ },
/* 564 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_ONBOARDING_STATE = exports.LOAD_ONBOARDING_STATE = 'Dyzio/UserOnboardingState/LOAD_ONBOARDING_STATE';
	var LOAD_ONBOARDING_STATE_SUCCESS = exports.LOAD_ONBOARDING_STATE_SUCCESS = 'Dyzio/UserOnboardingState/LOAD_ONBOARDING_STATE_SUCCESS';
	var LOAD_ONBOARDING_STATE_ERROR = exports.LOAD_ONBOARDING_STATE_ERROR = 'Dyzio/UserOnboardingState/LOAD_ONBOARDING_STATE_ERROR';
	
	var UPDATE_ONBOARDING_STATE = exports.UPDATE_ONBOARDING_STATE = 'Dyzio/UserOnboardingState/UPDATE_ONBOARDING_STATE';
	var UPDATE_ONBOARDING_STATE_ERROR = exports.UPDATE_ONBOARDING_STATE_ERROR = 'Dyzio/UserOnboardingState/UPDATE_ONBOARDING_STATE_ERROR';

/***/ },
/* 565 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_SETTINGS = exports.LOAD_SETTINGS = 'Dyzio/Settings/LOAD_SETTINGS';
	var LOAD_SETTINGS_SUCCESS = exports.LOAD_SETTINGS_SUCCESS = 'Dyzio/Settings/LOAD_SETTINGS_SUCCESS';
	var LOAD_SETTINGS_ERROR = exports.LOAD_SETTINGS_ERROR = 'Dyzio/Settings/LOAD_SETTINGS_ERROR';
	
	var UPDATE_SETTINGS = exports.UPDATE_SETTINGS = 'Dyzio/Settings/UPDATE_SETTINGS';
	var UPDATE_SETTINGS_SUCCESS = exports.UPDATE_SETTINGS_SUCCESS = 'Dyzio/Settings/UPDATE_SETTINGS_SUCCESS';
	var UPDATE_SETTINGS_ERROR = exports.UPDATE_SETTINGS_ERROR = 'Dyzio/Settings/UPDATE_SETTINGS_ERROR';
	
	var NOTIFY_ACTION = exports.NOTIFY_ACTION = 'Dyzio/Settings/NOTIFY_ACTION';

/***/ },
/* 566 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UPDATE_USER = exports.UPDATE_USER = 'Dyzio/UserWidget/UPDATE_USER';
	var CLEAR_USER = exports.CLEAR_USER = 'Dyzio/UserWidget/UPDATE_USER';

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _adsModal = __webpack_require__(922);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExistingAds = function ExistingAds(_ref) {
	  var ads = _ref.ads,
	      unlinkAd = _ref.unlinkAd;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _lodash2.default.isEmpty(ads) && _react2.default.createElement(
	      'h2',
	      null,
	      'No linked ads yet.'
	    ),
	    _lodash2.default.map(ads, function (ad) {
	      var campaignName = _lodash2.default.get(ad, 'campaignName') || _lodash2.default.get(ad, 'name', '-');
	      var adName = _lodash2.default.get(ad, 'adName', '(not available)');
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: true },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table,
	            { basic: 'very' },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: '2' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', color: 'blue', size: 'large' }),
	                  ' AD'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: '1' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
	                _react2.default.createElement(_semanticUiReact.Icon, { name: (0, _adsModal.getIcon)(_lodash2.default.get(ad, 'objectType')), color: 'pink' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: '1' },
	                _react2.default.createElement(_semanticUiReact.Image, { src: _lodash2.default.get(ad, 'thumbnail'), size: 'mini' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: '3' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'AD Campaign:'
	                ),
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  'AD Name:'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: '7' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  campaignName
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  adName
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: '2' },
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { fluid: true, color: 'pink', icon: true, labelPosition: 'left', onClick: function onClick() {
	                      return unlinkAd(_lodash2.default.get(ad, 'id'));
	                    } },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlinkify' }),
	                  'Unlink'
	                )
	              )
	            )
	          )
	        )
	      );
	    })
	  );
	};
	
	ExistingAds.propTypes = {
	  ads: _propTypes2.default.array.isRequired,
	  unlinkAd: _propTypes2.default.func.isRequired
	};
	
	exports.default = ExistingAds;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tabActionBar = __webpack_require__(194);
	
	var _hasLocalstorageClient = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ViewModeManager = function ViewModeManager() {
	  _classCallCheck(this, ViewModeManager);
	
	  this.getViewMode = function (argument) {
	    if (!argument || !argument.value) {
	      return _tabActionBar.ViewModes.cardsLarge;
	    }
	    return argument.value;
	  };
	
	  this.updateViewMode = function (key, viewMode) {
	    var storage = new _hasLocalstorageClient.DyzioStorage();
	    var record = storage.get(key);
	    record.value = viewMode;
	    storage.set(key, record);
	  };
	};
	
	var hasViewModeManagement = function hasViewModeManagement(WrapperComponent) {
	  return function (_Component) {
	    _inherits(HasViewModeManagement, _Component);
	
	    function HasViewModeManagement() {
	      _classCallCheck(this, HasViewModeManagement);
	
	      return _possibleConstructorReturn(this, (HasViewModeManagement.__proto__ || Object.getPrototypeOf(HasViewModeManagement)).apply(this, arguments));
	    }
	
	    _createClass(HasViewModeManagement, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, { viewModeManager: new ViewModeManager() }));
	      }
	    }]);
	
	    return HasViewModeManagement;
	  }(_react.Component);
	};
	
	exports.default = hasViewModeManagement;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _dyzioevents = __webpack_require__(2374);
	
	var _staticConfiguration = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var CAMPAIGN_VERSION_TWO = 2;
	var CLIENT_BRIEF_URL = 'https://s3-eu-west-1.amazonaws.com/cf-templates-o6s432he4qgr-eu-west-1/2016202Jd5-dyzio-aws-stack.json';
	
	var FREEMIUM = 'FREE';
	var CREATE_CAMPAIGN_API = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/campaigns';
	/*
	  Wouldn't it be nice if this was all in a lambda?
	*/
	
	exports.default = function (_ref) {
	  var name = _ref.name,
	      budget = _ref.budget,
	      liveDate = _ref.liveDate,
	      endDate = _ref.endDate,
	      currency = _ref.currency,
	      hashtags = _ref.hashtags,
	      campaignType = _ref.campaignType,
	      brand = _ref.brand,
	      country = _ref.country,
	      jsonAPIClient = _ref.jsonAPIClient,
	      _ref$userInfo = _ref.userInfo,
	      email = _ref$userInfo.email,
	      userId = _ref$userInfo.userId,
	      organisationId = _ref$userInfo.organisationId,
	      organisation = _ref.organisation,
	      scanUnauthorisedStories = _ref.scanUnauthorisedStories,
	      useEstimatedReachAndImpressions = _ref.useEstimatedReachAndImpressions,
	      shortlistId = _ref.shortlistId;
	
	  var campaign = jsonAPIClient.create('campaigns');
	
	  var fields = {
	    name: name,
	    budget: budget,
	    campaignType: 'AUTOMATED',
	    memberCount: 1,
	    version: CAMPAIGN_VERSION_TWO,
	    clientBrief: CLIENT_BRIEF_URL,
	    currency: currency,
	    hashtags: hashtags,
	    description: 'Description generated at ' + (0, _moment2.default)().toISOString(),
	    approvalStatus: 'PENDING',
	    country: country,
	    scanUnauthorisedStories: scanUnauthorisedStories,
	    useEstimatedReachAndImpressions: useEstimatedReachAndImpressions
	  };
	
	  if (organisation && organisation.licenseSubscriptionType === FREEMIUM) {
	    console.log('blocking premium features');
	    fields.premiumFeaturesBlocked = true;
	  }
	
	  _lodash2.default.forEach(fields, function (value, key) {
	    if (value) {
	      campaign.set(key, value);
	    }
	  });
	
	  if (liveDate) {
	    campaign.set('liveDate', liveDate.toISOString());
	  }
	
	  if (endDate) {
	    campaign.set('endDate', endDate.toISOString());
	  }
	
	  if (shortlistId) {
	    campaign.set('shortlist', { type: 'shortlists', id: shortlistId });
	  }
	
	  var safeBrand = _lodash2.default.trim(brand);
	
	  if (safeBrand) {
	    campaign.set('brand', safeBrand);
	  }
	
	  return campaign.sync().then(function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(response) {
	      var campaignResource, campaignJSON, createUrl, campaignPermission;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              campaignResource = _lodash2.default.clone(response);
	              campaignJSON = response.toJSONTree();
	
	              // if it's a shortlist >> campaign creation, fire request
	
	              if (shortlistId) {
	                createUrl = CREATE_CAMPAIGN_API + '/' + campaignJSON.id + '/shortlists/' + shortlistId;
	
	                console.log(createUrl);
	                _axios2.default.post(createUrl);
	              }
	
	              // Create campaign permission
	              campaignPermission = jsonAPIClient.create('campaignPermission');
	
	              campaignPermission.set('campaign', { type: 'campaigns', id: campaignJSON.id });
	              campaignPermission.set('user', { type: 'users', id: userId });
	              campaignPermission.set('organisation', { type: 'organisations', id: organisationId });
	              campaignPermission.set('email', email);
	              campaignPermission.set('role', _staticConfiguration.CAMPAIGN_OWNER);
	              campaignPermission.set('sendDailyNotifications', true);
	              campaignPermission.set('sendWeeklyNotifications', true);
	              campaignPermission.set('status', 'ACTIVE');
	              return _context.abrupt('return', Promise.all([Promise.resolve(campaignResource), campaignPermission.sync()]));
	
	            case 13:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }()).then(function (_ref3) {
	    var _ref4 = _slicedToArray(_ref3, 2),
	        campaignResource = _ref4[0],
	        campaignPermissionResponse = _ref4[1];
	
	    var campaignPermissionResource = _lodash2.default.clone(campaignPermissionResponse);
	    campaignResource.relationships('members').add(campaignPermissionResource);
	    return campaignResource.sync();
	  }).then(function (response) {
	    var _response$toJSONTree = response.toJSONTree(),
	        id = _response$toJSONTree.id;
	
	    var path = (campaignType === 'ACR' ? '/acr-' : '/') + 'campaign/' + id;
	    window.location = path;
	    return (0, _dyzioevents.createDyzioEvent)({
	      message: 'Campaign was created',
	      organisationId: organisationId,
	      campaignId: id,
	      jsonAPIClient: jsonAPIClient
	    });
	  });
	};

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createTrackedAsset = createTrackedAsset;
	exports.getTrackedAsset = getTrackedAsset;
	exports.getTrackedAssetList = getTrackedAssetList;
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	var _authService = __webpack_require__(21);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTrackedAsset(data) {
	  var client = (0, _jsonapiService2.default)();
	
	  var trackedAsset = client.create('trackedAssets');
	
	  trackedAsset.set('assetId', data.assetId);
	  trackedAsset.set('assetURL', data.assetURL);
	  trackedAsset.set('user', { type: 'users', id: data.userId });
	  trackedAsset.set('platform', data.platform);
	  trackedAsset.set('assetType', data.assetType);
	  if (data.discussionId) {
	    trackedAsset.set('discussion', { type: 'discussions', id: data.discussionId });
	  }
	  if (data.campaignId) {
	    trackedAsset.set('campaign', { type: 'campaigns', id: data.campaignId });
	  }
	  if (data.discussionName) {
	    trackedAsset.set('discussionName', data.discussionName);
	  }
	  trackedAsset.set('createdSource', data.createdSource);
	
	  return trackedAsset.sync().then(function (response) {
	    return response;
	  });
	}
	
	function makeGetTrackedAssetQuery(assetId) {
	  var query = '\n  query TrackedAssets {\n    trackedAssets(assetId: "' + assetId + '") {\n      id\n      assetId\n      assetURL\n      createdSource\n      createdDate\n      discussionName\n      platform\n      campaign {\n        id\n        name\n      }\n      user {\n        id\n        name\n      }\n      discussion {\n        id\n        name\n      }\n    }\n  }\n  ';
	  return query;
	}
	
	function getTrackedAsset(assetId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = makeGetTrackedAssetQuery(assetId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    return response.data.data.trackedAssets;
	  });
	}
	
	function makeGetUserTrackedVideoListQuery(userId) {
	  var query = '\n  query TrackedAssets {\n    trackedAssets(user: "' + userId + '", createdSource: "USER") {\n      id\n      assetId\n      assetURL\n      platform\n      assetType\n      createdSource\n      campaign {\n        id\n        name\n      }\n      user {\n        id\n        name\n      }\n      discussion {\n        id\n        name\n      }\n    }\n  }\n  ';
	  return query;
	}
	
	function getTrackedAssetList(userId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = makeGetUserTrackedVideoListQuery(userId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    return response.data.data.trackedAssets;
	  });
	}

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchUser = fetchUser;
	exports.updateUser = updateUser;
	exports.saveUserSettings = saveUserSettings;
	exports.createUserSettings = createUserSettings;
	exports.updateUserSettings = updateUserSettings;
	exports.updateUserTrackedVideos = updateUserTrackedVideos;
	exports.getUserTrackedVideos = getUserTrackedVideos;
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	var _authService = __webpack_require__(21);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchUser(id) {
	  var client = (0, _jsonapiService2.default)();
	  return client.get('users', id, { include: 'settings' }).then(function (user) {
	    return user;
	  });
	}
	
	function updateUser(id, fields) {
	  var client = (0, _jsonapiService2.default)();
	  var name = fields.name,
	      email = fields.email,
	      viewedOnboardingState = fields.viewedOnboardingState;
	
	  return client.get('users', id).then(function (user) {
	    if (name) user.set('name', name);
	    if (email) user.set('email', email);
	    if (viewedOnboardingState) user.set('viewedOnboardingState', viewedOnboardingState);
	    return user.sync();
	  });
	}
	
	function saveUserSettings(userId, settings) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('users', userId, {}).then(function (user) {
	    user.relationships('settings').set(settings);
	    return user.sync();
	  });
	}
	
	function createUserSettings(settingsData) {
	  var client = (0, _jsonapiService2.default)();
	
	  var settings = client.create('settings');
	
	  if (settingsData.emailType) settings.set('emailType', settingsData.emailType);
	  if (settingsData.emailFrequency) settings.set('emailFrequency', settingsData.emailFrequency);
	
	  return settings.sync().then(function (response) {
	    // Returns a resource not a JSON object
	    return response;
	  });
	}
	
	function updateUserSettings(settingsId, settingsData) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var attributes = {};
	  if (settingsData.emailType) attributes.emailType = settingsData.emailType;
	  if (settingsData.emailFrequency) attributes.emailFrequency = settingsData.emailFrequency;
	
	  return axiosService.patch('/settings/' + settingsId, {
	    data: {
	      id: settingsId,
	      type: 'settings',
	      attributes: attributes
	    }
	  }).then(function (response) {
	    return response.data.data;
	  });
	}
	
	function updateUserTrackedVideos(userId, trackedVideo) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('users', userId, {}).then(function (user) {
	    user.relationships('trackedVideos').add(trackedVideo);
	    return user.sync();
	  });
	}
	
	function makeTrackedVideosQuery(userId) {
	  var query = '\n  query UsersTrackedVideoQuery {\n    users(id: "' + userId + '") {\n      id\n      name\n      trackedVideos {\n        id\n        youtubeId\n        createdBy\n        createdDate\n        user {\n          id\n        }\n        campaign {\n          id\n          name\n        }\n        discussion {\n          id\n          name\n        }\n      }\n    }\n  }\n  ';
	  return query;
	}
	
	function getUserTrackedVideos(userId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = makeTrackedVideosQuery(userId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    return response.data.data.users[0];
	  });
	}

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TD = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';
	var KASPERSKY = 'ec3b6d8e-f9f0-42f4-9c09-294368cbe683';
	
	var isTeam = function isTeam(id, teamId) {
	  return _lodash2.default.eq(id, teamId);
	};
	
	module.exports = {
	  isTeam: isTeam,
	  TD: TD,
	  KASPERSKY: KASPERSKY
	};

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTemporarySignedUrl = getTemporarySignedUrl;
	exports.getUploadUrl = getUploadUrl;
	exports.uploadToS3 = uploadToS3;
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shortid = __webpack_require__(525);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTemporarySignedUrl(key) {
	  var endpoint = ("https://1hweifjj4e.execute-api.eu-west-1.amazonaws.com/production/file") + '/' + key;
	  var payload = {};
	  var headers = {};
	
	  return _axios2.default.get(endpoint, payload, headers).then(function (response) {
	    return response.data.body.signedUrl;
	  }).catch(function (error) {
	    (0, _errorHandlingService.reportError)('GET_TEMPORARY_SIGNED_URL_ERROR', error);
	  });
	}
	
	function getUploadUrl(file, s3Key) {
	  var endpoint = ("https://ikv9l9y8rc.execute-api.eu-west-1.amazonaws.com/production/uploads/reservation");
	  var payload = {
	    data: {
	      filepath: s3Key,
	      contentType: file.type ? file.type : 'text/plain'
	    }
	  };
	  var headers = {};
	
	  return _axios2.default.post(endpoint, payload, headers);
	}
	
	function uploadToS3(acceptedFiles) {
	  var PROCESSED_IDENTIFIER = 'processed';
	
	  var onFileUploaded = function onFileUploaded(key) {
	    var fullKey = PROCESSED_IDENTIFIER + '-' + key;
	
	    return fullKey;
	  };
	
	  var uploadFile = function uploadFile(file) {
	    return new Promise(function (resolve) {
	      var FILE_UPLOAD_PREFIX = 'dz-' + _shortid2.default.generate();
	      var S3_PROCESSING_TIMEOUT = 3000;
	      var key = FILE_UPLOAD_PREFIX + '-' + _lodash2.default.replace(file.name, /(?:[^\w?.]+_*|_+)+/g, '_');
	
	      getUploadUrl(file, key).then(function (response) {
	        return _lodash2.default.get(response, 'data.body.url', null);
	      }).then(function (url) {
	        var options = {
	          headers: {
	            'Content-Type': file.type ? file.type : 'text/plain'
	          }
	        };
	
	        return _axios2.default.put(url, file, options);
	      }).then(function () {
	        setTimeout(function () {
	          return resolve(onFileUploaded(key));
	        }, S3_PROCESSING_TIMEOUT);
	      });
	    });
	  };
	
	  return Promise.all(_lodash2.default.map(acceptedFiles, uploadFile));
	}

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(939);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 575 */
/***/ function(module, exports) {

	module.exports = function (string) {
	  return string.charAt(0).toUpperCase() + string.substring(1);
	}
	
	module.exports.words = function (string) {
	  return string.replace(/(^|[^a-zA-Z\u00C0-\u017F'])([a-zA-Z\u00C0-\u017F])/g, function (m) {
	    return m.toUpperCase()
	  })
	}


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	
	  // Remove event specific arrays for event types that no
	  // one is subscribed for to avoid memory leak.
	  if (callbacks.length === 0) {
	    delete this._callbacks['$' + event];
	  }
	
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	
	  var args = new Array(arguments.length - 1)
	    , callbacks = this._callbacks['$' + event];
	
	  for (var i = 1; i < arguments.length; i++) {
	    args[i - 1] = arguments[i];
	  }
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(290);
	var TAG = __webpack_require__(88)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 578 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(174);
	var document = __webpack_require__(87).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 580 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(370);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(132);
	var dPs = __webpack_require__(2488);
	var enumBugKeys = __webpack_require__(580);
	var IE_PROTO = __webpack_require__(586)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(579)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(944).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(371);
	var createDesc = __webpack_require__(293);
	var toIObject = __webpack_require__(198);
	var toPrimitive = __webpack_require__(590);
	var has = __webpack_require__(196);
	var IE8_DOM_DEFINE = __webpack_require__(945);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(144) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 584 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(121);
	var core = __webpack_require__(64);
	var fails = __webpack_require__(236);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(587)('keys');
	var uid = __webpack_require__(373);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(64);
	var global = __webpack_require__(87);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(291) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 588 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(588);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(174);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(87);
	var core = __webpack_require__(64);
	var LIBRARY = __webpack_require__(291);
	var wksExt = __webpack_require__(592);
	var defineProperty = __webpack_require__(145).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(88);


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(577);
	var ITERATOR = __webpack_require__(88)('iterator');
	var Iterators = __webpack_require__(237);
	module.exports = __webpack_require__(64).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(2515);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var C_algo = C.algo;
	
		    /**
		     * HMAC algorithm.
		     */
		    var HMAC = C_algo.HMAC = Base.extend({
		        /**
		         * Initializes a newly created HMAC.
		         *
		         * @param {Hasher} hasher The hash algorithm to use.
		         * @param {WordArray|string} key The secret key.
		         *
		         * @example
		         *
		         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
		         */
		        init: function (hasher, key) {
		            // Init hasher
		            hasher = this._hasher = new hasher.init();
	
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof key == 'string') {
		                key = Utf8.parse(key);
		            }
	
		            // Shortcuts
		            var hasherBlockSize = hasher.blockSize;
		            var hasherBlockSizeBytes = hasherBlockSize * 4;
	
		            // Allow arbitrary length keys
		            if (key.sigBytes > hasherBlockSizeBytes) {
		                key = hasher.finalize(key);
		            }
	
		            // Clamp excess bits
		            key.clamp();
	
		            // Clone key for inner and outer pads
		            var oKey = this._oKey = key.clone();
		            var iKey = this._iKey = key.clone();
	
		            // Shortcuts
		            var oKeyWords = oKey.words;
		            var iKeyWords = iKey.words;
	
		            // XOR keys with pad constants
		            for (var i = 0; i < hasherBlockSize; i++) {
		                oKeyWords[i] ^= 0x5c5c5c5c;
		                iKeyWords[i] ^= 0x36363636;
		            }
		            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this HMAC to its initial state.
		         *
		         * @example
		         *
		         *     hmacHasher.reset();
		         */
		        reset: function () {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Reset
		            hasher.reset();
		            hasher.update(this._iKey);
		        },
	
		        /**
		         * Updates this HMAC with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {HMAC} This HMAC instance.
		         *
		         * @example
		         *
		         *     hmacHasher.update('message');
		         *     hmacHasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            this._hasher.update(messageUpdate);
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the HMAC computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The HMAC.
		         *
		         * @example
		         *
		         *     var hmac = hmacHasher.finalize();
		         *     var hmac = hmacHasher.finalize('message');
		         *     var hmac = hmacHasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Compute HMAC
		            var innerHash = hasher.finalize(messageUpdate);
		            hasher.reset();
		            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
	
		            return hmac;
		        }
		    });
		}());
	
	
	}));

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-1 hash algorithm.
		     */
		    var SHA1 = C_algo.SHA1 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476,
		                0xc3d2e1f0
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
	
		            // Computation
		            for (var i = 0; i < 80; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
		                    W[i] = (n << 1) | (n >>> 31);
		                }
	
		                var t = ((a << 5) | (a >>> 27)) + e + W[i];
		                if (i < 20) {
		                    t += ((b & c) | (~b & d)) + 0x5a827999;
		                } else if (i < 40) {
		                    t += (b ^ c ^ d) + 0x6ed9eba1;
		                } else if (i < 60) {
		                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
		                } else /* if (i < 80) */ {
		                    t += (b ^ c ^ d) - 0x359d3e2a;
		                }
	
		                e = d;
		                d = c;
		                c = (b << 30) | (b >>> 2);
		                b = a;
		                a = t;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA1('message');
		     *     var hash = CryptoJS.SHA1(wordArray);
		     */
		    C.SHA1 = Hasher._createHelper(SHA1);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA1(message, key);
		     */
		    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
		}());
	
	
		return CryptoJS.SHA1;
	
	}));

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TiktokIcon = exports.InstagramCarouselIcon = exports.InstagramStoryIcon = exports.BlogIcon = exports.TelegramIcon = exports.TwitchIcon = exports.PinterestIcon = exports.TwitterIcon = exports.InstagramIcon = exports.FacebookIcon = exports.YoutubeIcon = undefined;
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tiktok = 'https://app.dyzio.co/logos/tiktok-logo.svg';
	
	var twitterLogoStyle = {
	  color: '#1dcaff'
	};
	
	var facebookLogoStyle = {
	  color: '#3B5998'
	};
	
	var telegramLogoStyle = {
	  color: '#24a4e3'
	};
	
	var YoutubeIcon = exports.YoutubeIcon = function YoutubeIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube', size: size, color: 'red' });
	};
	
	var FacebookIcon = exports.FacebookIcon = function FacebookIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', size: size, style: facebookLogoStyle });
	};
	
	var InstagramIcon = exports.InstagramIcon = function InstagramIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', size: size, color: 'pink' });
	};
	
	var TwitterIcon = exports.TwitterIcon = function TwitterIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter', size: size, style: twitterLogoStyle });
	};
	
	var PinterestIcon = exports.PinterestIcon = function PinterestIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'pinterest', size: size, color: 'red' });
	};
	
	var TwitchIcon = exports.TwitchIcon = function TwitchIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitch', size: size, color: 'purple' });
	};
	
	var TelegramIcon = exports.TelegramIcon = function TelegramIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram', size: size, style: telegramLogoStyle });
	};
	
	var BlogIcon = exports.BlogIcon = function BlogIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'globe', size: size, color: 'blue' });
	};
	
	var InstagramStoryIcon = exports.InstagramStoryIcon = function InstagramStoryIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(InstagramIcon, { size: size }),
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline', size: size, color: 'pink' })
	  );
	};
	
	var InstagramCarouselIcon = exports.InstagramCarouselIcon = function InstagramCarouselIcon(props) {
	  var size = props.size;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(InstagramIcon, { size: size }),
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'clone outline', size: size, color: 'pink' })
	  );
	};
	
	var TiktokIcon = exports.TiktokIcon = function TiktokIcon(_ref) {
	  var additionalStyles = _ref.additionalStyles;
	
	  var style = (0, _extends3.default)({
	    width: 15,
	    height: 15,
	    display: 'inline-block',
	    margin: 5
	  }, additionalStyles);
	  return _react2.default.createElement(_semanticUiReact.Image, { src: Tiktok, style: style });
	};
	
	TiktokIcon.propTypes = {
	  additionalStyles: _propTypes2.default.bool
	};
	
	TiktokIcon.defaultProps = {
	  additionalStyles: {}
	};

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _demographicsLocationTable = __webpack_require__(146);
	
	var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InstagramDemographicsCountriesTable = function InstagramDemographicsCountriesTable(_ref) {
	  var uniqueKey = _ref.uniqueKey,
	      data = _ref.audienceLocations.data;
	  return _react2.default.createElement(_demographicsLocationTable2.default, {
	    uniqueKey: uniqueKey,
	    data: data,
	    metric: 'absolute',
	    metricLabel: 'Followers',
	    itemLabel: 'Country'
	  });
	};
	
	InstagramDemographicsCountriesTable.propTypes = {
	  audienceLocations: _propTypes2.default.object.isRequired
	};
	
	exports.default = InstagramDemographicsCountriesTable;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(574);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(108);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _numeral = __webpack_require__(152);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _reactPlayer = __webpack_require__(410);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _textHighlighter = __webpack_require__(378);
	
	var _textHighlighter2 = _interopRequireDefault(_textHighlighter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	var MAX_UNFILTERED_RECORDS = 7;
	var ROLLUP_FACTOR = 4;
	
	var emptyArray = [];
	
	var highlightStyle = {
	  backgroundColor: '#FDB02B'
	};
	
	var labelStyle = {
	  marginTop: 5
	};
	
	var captionStyle = {
	  maxHeight: 250,
	  display: 'block',
	  overflowY: 'scroll'
	};
	
	var InstagramStory = function (_React$Component) {
	  (0, _inherits3.default)(InstagramStory, _React$Component);
	
	  function InstagramStory(props) {
	    (0, _classCallCheck3.default)(this, InstagramStory);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InstagramStory.__proto__ || (0, _getPrototypeOf2.default)(InstagramStory)).call(this, props));
	
	    _this.getFilteredStoryData = function () {
	      var _this$props = _this.props,
	          storyData = _this$props.storyData,
	          publishedDate = _this$props.publishedDate;
	
	      var safeStoryData = storyData || [];
	      return !_this.shouldFilter() ? safeStoryData : _lodash2.default.filter(safeStoryData, function (record, i) {
	        if (i === storyData.length - 1) return true;
	        var storyAge = (0, _moment2.default)(record.createdDate).diff((0, _moment2.default)(publishedDate), 'hours');
	        return storyAge % ROLLUP_FACTOR === 0;
	      });
	    };
	
	    _this.shouldFilter = function () {
	      if (_this.state.isExpanded) return false;
	      var storyData = _this.props.storyData;
	
	      return storyData && storyData.length > MAX_UNFILTERED_RECORDS;
	    };
	
	    _this.toggleExpand = function () {
	      var isExpanded = _this.state.isExpanded;
	
	      _this.setState({
	        isExpanded: !isExpanded
	      });
	    };
	
	    _this.handleChange = function (e, _ref) {
	      var _this$setState;
	
	      var name = _ref.name,
	          value = _ref.value,
	          storyId = _ref.storyId;
	
	      console.log('hello');
	      console.log(name, value, storyId);
	      _this.setState((_this$setState = {}, (0, _defineProperty3.default)(_this$setState, name, value), (0, _defineProperty3.default)(_this$setState, 'storyId', storyId), (0, _defineProperty3.default)(_this$setState, 'addToCampaignConfirmOpen', true), _this$setState));
	    };
	
	    _this.handleAddConfirm = function () {
	      var onCampaignSelected = _this.props.onCampaignSelected;
	      var _this$state = _this.state,
	          storyId = _this$state.storyId,
	          selectedCampaignId = _this$state.selectedCampaignId;
	
	      _this.setState({
	        addToCampaignConfirmOpen: false
	      }, function () {
	        return onCampaignSelected({ storyId: storyId, selectedCampaignId: selectedCampaignId });
	      });
	    };
	
	    _this.handleAddCancel = function () {
	      return _this.setState({
	        storyId: null,
	        selectedCampaignId: null,
	        addToCampaignConfirmOpen: false
	      });
	    };
	
	    _this.state = {
	      isExpanded: _lodash2.default.get(props, 'expanded', false),
	      selectedCampaignId: null,
	      addToCampaignConfirmOpen: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(InstagramStory, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          assetType = _props.assetType,
	          caption = _props.caption,
	          storyData = _props.storyData,
	          publishedDate = _props.publishedDate,
	          savedThumbnailUrl = _props.savedThumbnailUrl,
	          savedMediaUrl = _props.savedMediaUrl,
	          username = _props.username,
	          status = _props.status,
	          assetURL = _props.assetURL,
	          campaignList = _props.campaignList,
	          campaign = _props.campaign,
	          fluid = _props.fluid,
	          hashtags = _props.hashtags,
	          mentions = _props.mentions,
	          campaignHashtags = _props.campaignHashtags,
	          shouldHighlight = _props.shouldHighlight,
	          handlesCampaignAdd = _props.handlesCampaignAdd;
	      var _state = this.state,
	          isExpanded = _state.isExpanded,
	          selectedCampaignId = _state.selectedCampaignId;
	
	
	      var storyMentions = _lodash2.default.isArray(mentions) ? mentions : _lodash2.default.split(mentions, ',');
	      var storyHashtags = _lodash2.default.isArray(hashtags) ? hashtags : _lodash2.default.split(hashtags, ',');
	
	      var isVideo = assetType === 'VIDEO';
	      var isLive = status === 'LIVE';
	      var imageUrl = savedThumbnailUrl || savedMediaUrl;
	
	      var storyImage = imageUrl ? _react2.default.createElement(_semanticUiReact.Image, { src: imageUrl, size: 'large' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: isVideo ? 'film' : 'image', size: 'massive', color: 'pink' });
	
	      var StoryVideo = function StoryVideo() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _lodash2.default.isNil(savedMediaUrl) && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_semanticUiReact.Image, { src: imageUrl, size: 'large' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Video not available'
	            )
	          ),
	          savedMediaUrl && _react2.default.createElement(_reactPlayer2.default, { url: savedMediaUrl, width: '100%', height: '100%', controls: true })
	        );
	      };
	
	      var storyContent = isVideo ? _react2.default.createElement(StoryVideo, null) : storyImage;
	
	      var statusMessage = _react2.default.createElement(
	        _semanticUiReact.Message,
	        { color: isLive ? 'green' : 'grey' },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: isLive ? 'flag outline' : 'flag checkered' }),
	        'Posted on ',
	        (0, _moment2.default)(publishedDate).format('dddd, MMMM Do YYYY, h:mm:ss a'),
	        '\xA0---\xA0',
	        _react2.default.createElement(
	          'strong',
	          null,
	          '(',
	          status,
	          ')'
	        )
	      );
	
	      var statusMessageLink = _react2.default.createElement(
	        'a',
	        { href: assetURL },
	        statusMessage
	      );
	
	      var mutedStyle = { color: 'rgba(0,0,0,.4)' };
	      var captionElement = caption ? _react2.default.createElement(_textHighlighter2.default, {
	        words: shouldHighlight ? campaignHashtags : emptyArray,
	        text: caption,
	        style: captionStyle
	      }) : _react2.default.createElement(
	        'div',
	        { style: mutedStyle },
	        _react2.default.createElement(
	          _semanticUiReact.Icon.Group,
	          { size: 'large' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'chat' }),
	          _react2.default.createElement(_semanticUiReact.Icon, { corner: true, name: 'delete' })
	        ),
	        _react2.default.createElement('br', null),
	        'No Caption'
	      );
	
	      var leftColumn = isExpanded ? _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { width: 6 },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          storyContent
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: isVideo ? 'film' : 'image', size: 'small', color: 'pink' }),
	          assetType,
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          captionElement,
	          _lodash2.default.map(storyMentions, function (mention) {
	            return _react2.default.createElement(_semanticUiReact.Label, { style: labelStyle, basic: true, color: 'pink', content: _lodash2.default.toLower(mention) });
	          }),
	          _lodash2.default.map(storyHashtags, function (hashtag) {
	            return _react2.default.createElement(_semanticUiReact.Label, { style: labelStyle, basic: true, color: 'green', content: _lodash2.default.toLower(hashtag) });
	          })
	        )
	      ) : _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { width: 6 },
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 8 },
	              storyContent
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 8 },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: isVideo ? 'film' : 'image', size: 'small', color: 'pink' }),
	              assetType,
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              captionElement,
	              _lodash2.default.map(storyMentions, function (mention) {
	                return _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'pink', content: _lodash2.default.toLower(mention) });
	              }),
	              _lodash2.default.map(storyHashtags, function (hashtag) {
	                return _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'green', content: _lodash2.default.toLower(hashtag) });
	              })
	            )
	          )
	        )
	      );
	
	      var selectedCampaign = _lodash2.default.find(campaignList, { key: selectedCampaignId }) || { text: 'no campaign' };
	
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { color: 'pink', fluid: fluid },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            { columns: 3 },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: handlesCampaignAdd ? 10 : 15 },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
	                  username
	                )
	              ),
	              handlesCampaignAdd && _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 5 },
	                campaign ? _react2.default.createElement(_semanticUiReact.Button, { fluid: true, content: campaign.name, color: 'pink', inverted: true, disabled: true }) : _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Dropdown, {
	                    button: true,
	                    className: 'icon',
	                    floating: true,
	                    labeled: true,
	                    icon: 'add',
	                    options: campaignList,
	                    search: true,
	                    fluid: true,
	                    name: 'selectedCampaignId',
	                    text: 'Add to Campaign',
	                    storyId: id,
	                    value: selectedCampaignId,
	                    onChange: this.handleChange
	                  }),
	                  _react2.default.createElement(_semanticUiReact.Confirm, {
	                    header: 'Add to Campaign?',
	                    content: 'Add story to ' + selectedCampaign.text,
	                    open: this.state.addToCampaignConfirmOpen,
	                    onCancel: this.handleAddCancel,
	                    onConfirm: this.handleAddConfirm,
	                    size: 'small'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 1 },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  position: 'right center',
	                  trigger: _react2.default.createElement(
	                    _semanticUiReact.Button,
	                    { circular: true, color: 'pink', inverted: true, onClick: this.toggleExpand, icon: true },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: this.state.isExpanded ? 'angle up' : 'angle down' })
	                  ), content: this.state.isExpanded ? 'See less' : 'See more'
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            { textAlign: 'center', divided: true },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              leftColumn,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 10 },
	                _react2.default.createElement(
	                  _semanticUiReact.Table,
	                  { basic: 'very', compact: 'very', textAlign: 'center', columns: 'seven' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Header,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        null,
	                        'time'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        null,
	                        'reach'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        null,
	                        'impressions'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        null,
	                        'taps forward'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        null,
	                        'taps back'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        null,
	                        'exits'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        null,
	                        'story age (hours)'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Body,
	                    null,
	                    _lodash2.default.map(this.getFilteredStoryData(), function (record) {
	                      var storyAge = (0, _moment2.default)(record.createdDate).diff((0, _moment2.default)(publishedDate), 'hours');
	                      return _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          (0, _moment2.default)(record.createdDate).format('ddd H:mm')
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          cf(record.reach)
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          cf(record.impressions)
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          cf(record.taps_forward)
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          cf(record.taps_back)
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          cf(record.exits)
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          storyAge
	                        )
	                      );
	                    })
	                  )
	                ),
	                isLive ? statusMessageLink : statusMessage
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return InstagramStory;
	}(_react2.default.Component);
	
	InstagramStory.propTypes = {
	  shouldHighlight: _propTypes2.default.bool,
	  campaignHashtags: _propTypes2.default.array,
	  handlesCampaignAdd: _propTypes2.default.bool,
	  expanded: _propTypes2.default.bool
	};
	
	InstagramStory.defaultProps = {
	  shouldHighlight: false,
	  handlesCampaignAdd: true,
	  campaignHashtags: [],
	  expanded: false
	};
	
	exports.default = InstagramStory;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(234);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(233);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(108);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactChartjs = __webpack_require__(207);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var greenText = { color: '#20c49e', fontWeight: 'bold' };
	var redText = { color: 'red', fontWeight: 'bold' };
	
	var leftBlockStyle = {
	  paddingTop: 40
	};
	
	var avatarStyle = {
	  margin: '0 auto',
	  display: 'block'
	};
	
	var GRAPH_DAYS_TO_RENDER = 7;
	
	var getVideosDuration = function getVideosDuration(videos) {
	  //
	  var regex = /([0-9]{1,2}h)?([0-9]{1,2}m)?([0-9]{1,2}(\.[0-9]{1,3})?s)?/i;
	  var durations = _lodash2.default.map(videos, 'duration');
	
	  var result = _lodash2.default.map(durations, function (duration) {
	    var matches = duration.match(regex);
	    return {
	      hours: matches[1],
	      minutes: matches[2],
	      seconds: matches[3]
	    };
	  });
	
	  var duration = _moment2.default.duration();
	
	  _lodash2.default.forEach(result, function (item) {
	    if (item.hours) {
	      duration.add(_lodash2.default.toNumber(_lodash2.default.replace(item.hours, 'h', '')), 'hours');
	    }
	    if (item.hours) {
	      duration.add(_lodash2.default.toNumber(_lodash2.default.replace(item.minutes, 'm', '')), 'minutes');
	    }
	    if (item.hours) {
	      duration.add(_lodash2.default.toNumber(_lodash2.default.replace(item.seconds, 's', '')), 'seconds');
	    }
	  });
	
	  return duration;
	};
	
	var generateChartData = function generateChartData(records, countHistory, meanFollowersCount, lastestFollowersCount) {
	  return {
	    labels: _lodash2.default.times(GRAPH_DAYS_TO_RENDER, function (n) {
	      return (0, _moment2.default)().subtract(n + 1, 'days').format('MMM DD');
	    }).reverse(),
	    datasets: [{
	      label: 'Stream Hours',
	      data: _lodash2.default.times(GRAPH_DAYS_TO_RENDER, function (n) {
	        var date = (0, _moment2.default)().subtract(n + 1, 'days');
	        var videos = _lodash2.default.filter(records, function (record) {
	          return (0, _moment2.default)(record.created_at).isSame(date, 'day');
	        });
	        if (_lodash2.default.isEmpty(videos)) {
	          return 0;
	        }
	        var duration = getVideosDuration(videos);
	        return duration.asHours();
	      }).reverse(),
	      fill: true,
	      backgroundColor: 'rgba(75,192,192,0.2)',
	      borderColor: 'rgba(75,192,192,1)',
	      yAxisID: 'y-axis-1'
	    }, {
	      label: 'Followers',
	      data: _lodash2.default.times(GRAPH_DAYS_TO_RENDER, function (n) {
	        var date = (0, _moment2.default)().subtract(n + 1, 'days');
	        var history = _lodash2.default.find(countHistory, function (record) {
	          return (0, _moment2.default)(record.createdDate).isSame(date, 'day');
	        });
	        return _lodash2.default.get(history, 'twitchCount', meanFollowersCount || lastestFollowersCount);
	      }).reverse(),
	      fill: true,
	      backgroundColor: 'rgba(154, 18, 179, 0.2)',
	      borderColor: 'rgba(154, 18, 179, 1)',
	      yAxisID: 'y-axis-2'
	    }]
	  };
	};
	
	var options = {
	  tooltips: {
	    callbacks: {
	      label: function label(tooltipItem, data) {
	        var shouldRenderHours = _lodash2.default.get(tooltipItem, 'datasetIndex') === 0;
	        return '' + (0, _formatting.sciFormatted)(_lodash2.default.get(tooltipItem, 'yLabel'), '0') + (shouldRenderHours ? 'h' : '');
	      }
	    }
	  },
	  legend: {
	    onClick: function onClick(e) {
	      return e.stopPropagation();
	    }
	  },
	  scales: {
	    yAxes: [{
	      type: 'linear',
	      display: true,
	      position: 'left',
	      id: 'y-axis-1',
	      ticks: {
	        callback: function callback(label) {
	          return (0, _formatting.commaFormatted)(label, 0) + 'h';
	        }
	      }
	    }, {
	      stepSize: 100000,
	      type: 'linear',
	      display: true,
	      position: 'right',
	      id: 'y-axis-2',
	      ticks: {
	        callback: function callback(label) {
	          return (0, _formatting.sciFormatted)(label);
	        }
	      },
	      gridLines: {
	        drawOnArea: false
	      }
	    }]
	  }
	};
	
	var LoadingChart = function LoadingChart() {
	  return _react2.default.createElement(
	    'div',
	    { style: { minHeight: 330 } },
	    _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading Twitch data...' })
	  );
	};
	
	var ErrorChart = function ErrorChart() {
	  return _react2.default.createElement(
	    'div',
	    { style: { minHeight: 330 } },
	    _react2.default.createElement(
	      _semanticUiReact.Message,
	      { color: 'orange' },
	      'Twitch data is unavailable now. Please try again later'
	    )
	  );
	};
	
	var TwitchData = function (_React$Component) {
	  (0, _inherits3.default)(TwitchData, _React$Component);
	
	  function TwitchData(props) {
	    (0, _classCallCheck3.default)(this, TwitchData);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TwitchData.__proto__ || (0, _getPrototypeOf2.default)(TwitchData)).call(this, props));
	
	    _this.state = {
	      loading: true,
	      data: null,
	      failed: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TwitchData, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var handle, response, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                handle = _lodash2.default.get(this.props, 'influencer.twitch');
	
	                if (!handle) {
	                  this.setState({
	                    loading: false
	                  });
	                }
	                _context.next = 4;
	                return _axios2.default.get('https://jniyllb4b5.execute-api.eu-west-1.amazonaws.com/production/twitch-videos/data?handle=' + handle);
	
	              case 4:
	                response = _context.sent;
	
	                if (_lodash2.default.has(response, 'data.videos')) {
	                  data = _lodash2.default.get(response, 'data', {});
	
	                  this.setState({
	                    data: data,
	                    loading: false,
	                    failed: false
	                  });
	                } else {
	                  this.setState({
	                    failed: true,
	                    loading: false
	                  });
	                }
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var influencer = this.props.influencer;
	
	      var username = _lodash2.default.get(influencer, 'twitch');
	
	      if (!username) {
	        return null;
	      }
	
	      var twitchCount = _lodash2.default.get(influencer, 'twitchCount');
	      var countHistory = _lodash2.default.get(influencer, 'countHistory', []);
	
	      var videos = _lodash2.default.get(this.state, 'data.videos', []);
	      var thumbnail = _lodash2.default.get(this.state, 'data.thumbnail');
	      var streamStats = _lodash2.default.get(this.state, 'data.stream_stats');
	      var loading = _lodash2.default.get(this.state, 'loading');
	      var failed = _lodash2.default.get(this.state, 'failed');
	
	      var allDaysPeak = _lodash2.default.max(_lodash2.default.map(videos, 'view_count'));
	
	      var sevenDaysData = _lodash2.default.filter(videos, function (item) {
	        return (0, _moment2.default)(item.created_at).isSameOrAfter((0, _moment2.default)().subtract(6, 'days'), 'day');
	      });
	
	      var sevenDaysDuration = getVideosDuration(sevenDaysData);
	      var allDataDuration = getVideosDuration(videos);
	
	      var sevenDaysPeak = _lodash2.default.max(_lodash2.default.map(sevenDaysData, 'view_count'));
	      var sevenDayAvg = _lodash2.default.mean(_lodash2.default.map(sevenDaysData, 'view_count'));
	
	      var sortedHistory = _lodash2.default.orderBy(countHistory, 'createdDate');
	
	      var meanFollowersCount = _lodash2.default.meanBy(_lodash2.default.filter(sortedHistory, function (history) {
	        return (0, _moment2.default)(_lodash2.default.get(history, 'createdDate')).isSameOrAfter((0, _moment2.default)().subtract(6, 'days'), 'day');
	      }), 'twitchCount');
	
	      var oldestHistoryItem = _lodash2.default.find(sortedHistory, function (item) {
	        return _lodash2.default.has(item, 'twitchCount');
	      });
	      var newestHistoryItem = _lodash2.default.findLast(sortedHistory, function (item) {
	        return _lodash2.default.has(item, 'twitchCount');
	      });
	      var lastestFollowersCount = _lodash2.default.get(newestHistoryItem, 'twitchCount');
	
	      var followersChange = _lodash2.default.subtract(_lodash2.default.get(newestHistoryItem, 'twitchCount', 0), _lodash2.default.get(oldestHistoryItem, 'twitchCount', 0));
	
	      var isPositiveChange = followersChange > 0;
	
	      var chartData = generateChartData(videos, countHistory, meanFollowersCount, lastestFollowersCount);
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { color: 'purple' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitch', color: 'purple' }),
	          ' Twitch'
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            loading && _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: '16' },
	              _react2.default.createElement(LoadingChart, null)
	            ),
	            failed && _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: '16' },
	              _react2.default.createElement(ErrorChart, null)
	            ),
	            !loading && !failed && _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: '3', textAlign: 'center', style: leftBlockStyle },
	              _react2.default.createElement(_semanticUiReact.Image, {
	                className: 'circular',
	                size: 'small',
	                style: avatarStyle,
	                src: thumbnail
	              }),
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { basic: 'very', fluid: true, textAlign: 'center' },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Body,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      username
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      (0, _formatting.commaFormatted)(twitchCount),
	                      ' followers'
	                    )
	                  )
	                )
	              )
	            ),
	            !loading && !failed && _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: '8' },
	              _react2.default.createElement(_reactChartjs.Line, { data: chartData, options: options })
	            ),
	            !loading && !failed && _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: '5' },
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { basic: 'very' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      { colSpan: 2 },
	                      'Last 7 Days'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      'Hours streamed'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      (0, _formatting.commaFormatted)(sevenDaysDuration.asHours()),
	                      ' hours'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      'Average viewers'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      streamStats ? streamStats.sevenDaysAvg : '-'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      'Peak viewers'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      streamStats ? streamStats.sevenDaysPeak : '-'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { basic: 'very' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      { colSpan: 2 },
	                      'Last 30 Days'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      'Follower change'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      { style: isPositiveChange > 0 ? greenText : redText },
	                      ' ',
	                      isPositiveChange ? '+' : '',
	                      followersChange
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      'Peak viewers'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      streamStats ? streamStats.thirtyDaysPeak : '-'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      'Hours streamed'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      (0, _formatting.commaFormatted)(allDataDuration.asHours()),
	                      ' hours'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return TwitchData;
	}(_react2.default.Component);
	
	TwitchData.propTypes = {
	  influencer: _propTypes2.default.object.isRequired
	};
	
	exports.default = TwitchData;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _asaCompliance = __webpack_require__(970);
	
	var _asaCompliance2 = _interopRequireDefault(_asaCompliance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AsaComponent = function AsaComponent(_ref) {
	  var text = _ref.text,
	      _ref$label = _ref.label,
	      label = _ref$label === undefined ? '' : _ref$label;
	
	  if ((0, _asaCompliance2.default)(text)) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'green' }),
	      label
	    );
	  }
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus', color: 'grey' });
	};
	
	AsaComponent.propTypes = {
	  text: _propTypes.PropTypes.string.isRequired,
	  label: _propTypes.PropTypes.string
	};
	
	AsaComponent.defaultProps = {
	  label: ''
	};
	
	exports.default = AsaComponent;

/***/ },
/* 602 */
[4188, 297, 611],
/* 603 */
[4190, 297, 611],
/* 604 */
[4191, 202, 78],
/* 605 */
[4192, 2695, 2696, 2697, 2698, 2699],
/* 606 */
[4196, 381, 2711, 2712, 2713, 2714, 2715],
/* 607 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 608 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 609 */
[4218, 2616, 97],
/* 610 */
[4226, 2623, 79],
/* 611 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 612 */
[4248, 244, 148, 47, 206],
/* 613 */
[4257, 975],
/* 614 */
[4289, 1027, 1014, 622],
/* 615 */
[4292, 1012, 1036],
/* 616 */
/***/ function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ },
/* 617 */
[4299, 977, 1038],
/* 618 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ },
/* 619 */
[4311, 47, 206],
/* 620 */
[4329, 1003],
/* 621 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 622 */
[4335, 2638, 1017],
/* 623 */
[4353, 246],
/* 624 */
[4356, 977, 2615, 95, 47],
/* 625 */
[4400, 610],
/* 626 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 627 */
[4407, 133, 47, 79],
/* 628 */
[4414, 978, 2630, 123],
/* 629 */
[4420, 2634, 614],
/* 630 */
[4427, 980, 95, 2639, 47, 398],
/* 631 */
[4442, 994],
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _props = __webpack_require__(411);
	
	var _utils = __webpack_require__(98);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SEEK_ON_PLAY_EXPIRY = 5000;
	
	var Player = /*#__PURE__*/function (_Component) {
	  _inherits(Player, _Component);
	
	  var _super = _createSuper(Player);
	
	  function Player() {
	    var _this;
	
	    _classCallCheck(this, Player);
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(_args));
	
	    _defineProperty(_assertThisInitialized(_this), "mounted", false);
	
	    _defineProperty(_assertThisInitialized(_this), "isReady", false);
	
	    _defineProperty(_assertThisInitialized(_this), "isPlaying", false);
	
	    _defineProperty(_assertThisInitialized(_this), "isLoading", true);
	
	    _defineProperty(_assertThisInitialized(_this), "loadOnReady", null);
	
	    _defineProperty(_assertThisInitialized(_this), "startOnPlay", true);
	
	    _defineProperty(_assertThisInitialized(_this), "seekOnPlay", null);
	
	    _defineProperty(_assertThisInitialized(_this), "onDurationCalled", false);
	
	    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function (key) {
	      if (!_this.player) return null;
	      return _this.player[key];
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "progress", function () {
	      if (_this.props.url && _this.player && _this.isReady) {
	        var playedSeconds = _this.getCurrentTime() || 0;
	
	        var loadedSeconds = _this.getSecondsLoaded();
	
	        var duration = _this.getDuration();
	
	        if (duration) {
	          var progress = {
	            playedSeconds: playedSeconds,
	            played: playedSeconds / duration
	          };
	
	          if (loadedSeconds !== null) {
	            progress.loadedSeconds = loadedSeconds;
	            progress.loaded = loadedSeconds / duration;
	          } // Only call onProgress if values have changed
	
	
	          if (progress.playedSeconds !== _this.prevPlayed || progress.loadedSeconds !== _this.prevLoaded) {
	            _this.props.onProgress(progress);
	          }
	
	          _this.prevPlayed = progress.playedSeconds;
	          _this.prevLoaded = progress.loadedSeconds;
	        }
	      }
	
	      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
	      if (!_this.mounted) return;
	      _this.isReady = true;
	      _this.isLoading = false;
	      var _this$props = _this.props,
	          onReady = _this$props.onReady,
	          playing = _this$props.playing,
	          volume = _this$props.volume,
	          muted = _this$props.muted;
	      onReady();
	
	      if (!muted && volume !== null) {
	        _this.player.setVolume(volume);
	      }
	
	      if (_this.loadOnReady) {
	        _this.player.load(_this.loadOnReady, true);
	
	        _this.loadOnReady = null;
	      } else if (playing) {
	        _this.player.play();
	      }
	
	      _this.handleDurationCheck();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handlePlay", function () {
	      _this.isPlaying = true;
	      _this.isLoading = false;
	      var _this$props2 = _this.props,
	          onStart = _this$props2.onStart,
	          onPlay = _this$props2.onPlay,
	          playbackRate = _this$props2.playbackRate;
	
	      if (_this.startOnPlay) {
	        if (_this.player.setPlaybackRate && playbackRate !== 1) {
	          _this.player.setPlaybackRate(playbackRate);
	        }
	
	        onStart();
	        _this.startOnPlay = false;
	      }
	
	      onPlay();
	
	      if (_this.seekOnPlay) {
	        _this.seekTo(_this.seekOnPlay);
	
	        _this.seekOnPlay = null;
	      }
	
	      _this.handleDurationCheck();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handlePause", function (e) {
	      _this.isPlaying = false;
	
	      if (!_this.isLoading) {
	        _this.props.onPause(e);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleEnded", function () {
	      var _this$props3 = _this.props,
	          activePlayer = _this$props3.activePlayer,
	          loop = _this$props3.loop,
	          onEnded = _this$props3.onEnded;
	
	      if (activePlayer.loopOnEnded && loop) {
	        _this.seekTo(0);
	      }
	
	      if (!loop) {
	        _this.isPlaying = false;
	        onEnded();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleError", function () {
	      var _this$props4;
	
	      _this.isLoading = false;
	
	      (_this$props4 = _this.props).onError.apply(_this$props4, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDurationCheck", function () {
	      clearTimeout(_this.durationCheckTimeout);
	
	      var duration = _this.getDuration();
	
	      if (duration) {
	        if (!_this.onDurationCalled) {
	          _this.props.onDuration(duration);
	
	          _this.onDurationCalled = true;
	        }
	      } else {
	        _this.durationCheckTimeout = setTimeout(_this.handleDurationCheck, 100);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleLoaded", function () {
	      // Sometimes we know loading has stopped but onReady/onPlay are never called
	      // so this provides a way for players to avoid getting stuck
	      _this.isLoading = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
	      if (player) {
	        _this.player = player;
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(Player, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	      this.player.load(this.props.url);
	      this.progress();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.progressTimeout);
	      clearTimeout(this.durationCheckTimeout);
	
	      if (this.isReady) {
	        this.player.stop();
	      }
	
	      if (this.player.disablePIP) {
	        this.player.disablePIP();
	      }
	
	      this.mounted = false;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      // Invoke player methods based on changed props
	      var _this$props5 = this.props,
	          url = _this$props5.url,
	          playing = _this$props5.playing,
	          volume = _this$props5.volume,
	          muted = _this$props5.muted,
	          playbackRate = _this$props5.playbackRate,
	          pip = _this$props5.pip,
	          loop = _this$props5.loop,
	          activePlayer = _this$props5.activePlayer;
	
	      if (!(0, _utils.isEqual)(prevProps.url, url)) {
	        if (this.isLoading && !activePlayer.forceLoad) {
	          console.warn("ReactPlayer: the attempt to load ".concat(url, " is being deferred until the player has loaded"));
	          this.loadOnReady = url;
	          return;
	        }
	
	        this.isLoading = true;
	        this.startOnPlay = true;
	        this.onDurationCalled = false;
	        this.player.load(url, this.isReady);
	      }
	
	      if (!prevProps.playing && playing && !this.isPlaying) {
	        this.player.play();
	      }
	
	      if (prevProps.playing && !playing && this.isPlaying) {
	        this.player.pause();
	      }
	
	      if (!prevProps.pip && pip && this.player.enablePIP) {
	        this.player.enablePIP();
	      }
	
	      if (prevProps.pip && !pip && this.player.disablePIP) {
	        this.player.disablePIP();
	      }
	
	      if (prevProps.volume !== volume && volume !== null) {
	        this.player.setVolume(volume);
	      }
	
	      if (prevProps.muted !== muted) {
	        if (muted) {
	          this.player.mute();
	        } else {
	          this.player.unmute();
	
	          if (volume !== null) {
	            // Set volume next tick to fix a bug with DailyMotion
	            setTimeout(function () {
	              return _this2.player.setVolume(volume);
	            });
	          }
	        }
	      }
	
	      if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
	        this.player.setPlaybackRate(playbackRate);
	      }
	
	      if (prevProps.loop !== loop && this.player.setLoop) {
	        this.player.setLoop(loop);
	      }
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      if (!this.isReady) return null;
	      return this.player.getDuration();
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      if (!this.isReady) return null;
	      return this.player.getCurrentTime();
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      if (!this.isReady) return null;
	      return this.player.getSecondsLoaded();
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(amount, type) {
	      var _this3 = this;
	
	      // When seeking before player is ready, store value and seek later
	      if (!this.isReady && amount !== 0) {
	        this.seekOnPlay = amount;
	        setTimeout(function () {
	          _this3.seekOnPlay = null;
	        }, SEEK_ON_PLAY_EXPIRY);
	        return;
	      }
	
	      var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';
	
	      if (isFraction) {
	        // Convert fraction to seconds based on duration
	        var duration = this.player.getDuration();
	
	        if (!duration) {
	          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
	          return;
	        }
	
	        this.player.seekTo(duration * amount);
	        return;
	      }
	
	      this.player.seekTo(amount);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var Player = this.props.activePlayer;
	
	      if (!Player) {
	        return null;
	      }
	
	      return /*#__PURE__*/_react["default"].createElement(Player, _extends({}, this.props, {
	        ref: this.ref,
	        onReady: this.handleReady,
	        onPlay: this.handlePlay,
	        onPause: this.handlePause,
	        onEnded: this.handleEnded,
	        onLoaded: this.handleLoaded,
	        onError: this.handleError
	      }));
	    }
	  }]);
	
	  return Player;
	}(_react.Component);
	
	exports["default"] = Player;
	
	_defineProperty(Player, "displayName", 'Player');
	
	_defineProperty(Player, "propTypes", _props.propTypes);
	
	_defineProperty(Player, "defaultProps", _props.defaultProps);

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.DailyMotion = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(98);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(134));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = 'https://api.dmcdn.net/all.js';
	var SDK_GLOBAL = 'DM';
	var SDK_GLOBAL_READY = 'dmAsyncInit';
	var MATCH_URL = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;
	
	var DailyMotion = /*#__PURE__*/function (_Component) {
	  _inherits(DailyMotion, _Component);
	
	  var _super = _createSuper(DailyMotion);
	
	  function DailyMotion() {
	    var _this;
	
	    _classCallCheck(this, DailyMotion);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "onDurationChange", function () {
	      var duration = _this.getDuration();
	
	      _this.props.onDuration(duration);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.callPlayer('setMuted', true);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.callPlayer('setMuted', false);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
	      _this.container = container;
	    });
	
	    return _this;
	  }
	
	  _createClass(DailyMotion, [{
	    key: "load",
	    value: function load(url) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          controls = _this$props.controls,
	          config = _this$props.config,
	          onError = _this$props.onError,
	          playing = _this$props.playing;
	
	      var _url$match = url.match(MATCH_URL),
	          _url$match2 = _slicedToArray(_url$match, 2),
	          id = _url$match2[1];
	
	      if (this.player) {
	        this.player.load(id, {
	          start: (0, _utils.parseStartTime)(url),
	          autoplay: playing
	        });
	        return;
	      }
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
	        return DM.player;
	      }).then(function (DM) {
	        if (!_this2.container) return;
	        var Player = DM.player;
	        _this2.player = new Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          video: id,
	          params: _objectSpread({
	            controls: controls,
	            autoplay: _this2.props.playing,
	            mute: _this2.props.muted,
	            start: (0, _utils.parseStartTime)(url),
	            origin: window.location.origin
	          }, config.dailymotion.params),
	          events: {
	            apiready: _this2.props.onReady,
	            seeked: function seeked() {
	              return _this2.props.onSeek(_this2.player.currentTime);
	            },
	            video_end: _this2.props.onEnded,
	            durationchange: _this2.onDurationChange,
	            pause: _this2.props.onPause,
	            playing: _this2.props.onPlay,
	            waiting: _this2.props.onBuffer,
	            error: function error(event) {
	              return onError(event);
	            }
	          }
	        });
	      }, onError);
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {// Nothing to do
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.player.duration || null;
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.player.currentTime;
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return this.player.bufferedTime;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var display = this.props.display;
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: display
	      };
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        style: style
	      }, /*#__PURE__*/_react["default"].createElement("div", {
	        ref: this.ref
	      }));
	    }
	  }]);
	
	  return DailyMotion;
	}(_react.Component);
	
	exports.DailyMotion = DailyMotion;
	
	_defineProperty(DailyMotion, "displayName", 'DailyMotion');
	
	_defineProperty(DailyMotion, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	_defineProperty(DailyMotion, "loopOnEnded", true);
	
	var _default = (0, _singlePlayer["default"])(DailyMotion);
	
	exports["default"] = _default;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.SoundCloud = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(98);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(134));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = 'https://w.soundcloud.com/player/api.js';
	var SDK_GLOBAL = 'SC';
	var MATCH_URL = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
	
	var SoundCloud = /*#__PURE__*/function (_Component) {
	  _inherits(SoundCloud, _Component);
	
	  var _super = _createSuper(SoundCloud);
	
	  function SoundCloud() {
	    var _this;
	
	    _classCallCheck(this, SoundCloud);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "duration", null);
	
	    _defineProperty(_assertThisInitialized(_this), "currentTime", null);
	
	    _defineProperty(_assertThisInitialized(_this), "fractionLoaded", null);
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.setVolume(0);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      if (_this.props.volume !== null) {
	        _this.setVolume(_this.props.volume);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
	      _this.iframe = iframe;
	    });
	
	    return _this;
	  }
	
	  _createClass(SoundCloud, [{
	    key: "load",
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
	        if (!_this2.iframe) return;
	        var _SC$Widget$Events = SC.Widget.Events,
	            PLAY = _SC$Widget$Events.PLAY,
	            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
	            PAUSE = _SC$Widget$Events.PAUSE,
	            FINISH = _SC$Widget$Events.FINISH,
	            ERROR = _SC$Widget$Events.ERROR;
	
	        if (!isReady) {
	          _this2.player = SC.Widget(_this2.iframe);
	
	          _this2.player.bind(PLAY, _this2.props.onPlay);
	
	          _this2.player.bind(PAUSE, _this2.props.onPause);
	
	          _this2.player.bind(PLAY_PROGRESS, function (e) {
	            _this2.currentTime = e.currentPosition / 1000;
	            _this2.fractionLoaded = e.loadedProgress;
	          });
	
	          _this2.player.bind(FINISH, function () {
	            return _this2.props.onEnded();
	          });
	
	          _this2.player.bind(ERROR, function (e) {
	            return _this2.props.onError(e);
	          });
	        }
	
	        _this2.player.load(url, _objectSpread({}, _this2.props.config.soundcloud.options, {
	          callback: function callback() {
	            _this2.player.getDuration(function (duration) {
	              _this2.duration = duration / 1000;
	
	              _this2.props.onReady();
	            });
	          }
	        }));
	      });
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {// Nothing to do
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('seekTo', seconds * 1000);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return this.fractionLoaded * this.duration;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var display = this.props.display;
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: display
	      };
	      return /*#__PURE__*/_react["default"].createElement("iframe", {
	        ref: this.ref,
	        src: "https://w.soundcloud.com/player/?url=".concat(encodeURIComponent(this.props.url)),
	        style: style,
	        frameBorder: 0,
	        allow: "autoplay"
	      });
	    }
	  }]);
	
	  return SoundCloud;
	}(_react.Component);
	
	exports.SoundCloud = SoundCloud;
	
	_defineProperty(SoundCloud, "displayName", 'SoundCloud');
	
	_defineProperty(SoundCloud, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	_defineProperty(SoundCloud, "loopOnEnded", true);
	
	var _default = (0, _singlePlayer["default"])(SoundCloud);
	
	exports["default"] = _default;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Vimeo = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(98);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(134));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = 'https://player.vimeo.com/api/player.js';
	var SDK_GLOBAL = 'Vimeo';
	var MATCH_URL = /vimeo\.com\/.+/;
	var MATCH_FILE_URL = /vimeo\.com\/external\/[0-9]+\..+/;
	
	var Vimeo = /*#__PURE__*/function (_Component) {
	  _inherits(Vimeo, _Component);
	
	  var _super = _createSuper(Vimeo);
	
	  function Vimeo() {
	    var _this;
	
	    _classCallCheck(this, Vimeo);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "duration", null);
	
	    _defineProperty(_assertThisInitialized(_this), "currentTime", null);
	
	    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.setVolume(0);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      if (_this.props.volume !== null) {
	        _this.setVolume(_this.props.volume);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
	      _this.container = container;
	    });
	
	    return _this;
	  }
	
	  _createClass(Vimeo, [{
	    key: "load",
	    value: function load(url) {
	      var _this2 = this;
	
	      this.duration = null;
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
	        if (!_this2.container) return;
	        _this2.player = new Vimeo.Player(_this2.container, _objectSpread({
	          url: url,
	          autoplay: _this2.props.playing,
	          muted: _this2.props.muted,
	          loop: _this2.props.loop,
	          playsinline: _this2.props.playsinline,
	          controls: _this2.props.controls
	        }, _this2.props.config.vimeo.playerOptions));
	
	        _this2.player.ready().then(function () {
	          var iframe = _this2.container.querySelector('iframe');
	
	          iframe.style.width = '100%';
	          iframe.style.height = '100%';
	        })["catch"](_this2.props.onError);
	
	        _this2.player.on('loaded', function () {
	          _this2.props.onReady();
	
	          _this2.refreshDuration();
	        });
	
	        _this2.player.on('play', function () {
	          _this2.props.onPlay();
	
	          _this2.refreshDuration();
	        });
	
	        _this2.player.on('pause', _this2.props.onPause);
	
	        _this2.player.on('seeked', function (e) {
	          return _this2.props.onSeek(e.seconds);
	        });
	
	        _this2.player.on('ended', _this2.props.onEnded);
	
	        _this2.player.on('error', _this2.props.onError);
	
	        _this2.player.on('timeupdate', function (_ref) {
	          var seconds = _ref.seconds;
	          _this2.currentTime = seconds;
	        });
	
	        _this2.player.on('progress', function (_ref2) {
	          var seconds = _ref2.seconds;
	          _this2.secondsLoaded = seconds;
	        });
	      }, this.props.onError);
	    }
	  }, {
	    key: "refreshDuration",
	    value: function refreshDuration() {
	      var _this3 = this;
	
	      this.player.getDuration().then(function (duration) {
	        _this3.duration = duration;
	      });
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      var promise = this.callPlayer('play');
	
	      if (promise) {
	        promise["catch"](this.props.onError);
	      }
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      this.callPlayer('unload');
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('setCurrentTime', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: "setLoop",
	    value: function setLoop(loop) {
	      this.callPlayer('setLoop', loop);
	    }
	  }, {
	    key: "setPlaybackRate",
	    value: function setPlaybackRate(rate) {
	      this.callPlayer('setPlaybackRate', rate);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return this.secondsLoaded;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var display = this.props.display;
	      var style = {
	        width: '100%',
	        height: '100%',
	        overflow: 'hidden',
	        display: display
	      };
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        key: this.props.url,
	        ref: this.ref,
	        style: style
	      });
	    }
	  }]);
	
	  return Vimeo;
	}(_react.Component);
	
	exports.Vimeo = Vimeo;
	
	_defineProperty(Vimeo, "displayName", 'Vimeo');
	
	_defineProperty(Vimeo, "forceLoad", true);
	
	_defineProperty(Vimeo, "canPlay", function (url) {
	  if (MATCH_FILE_URL.test(url)) {
	    return false;
	  }
	
	  return MATCH_URL.test(url);
	});
	
	var _default = (0, _singlePlayer["default"])(Vimeo);
	
	exports["default"] = _default;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.YouTube = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(98);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(134));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var SDK_URL = 'https://www.youtube.com/iframe_api';
	var SDK_GLOBAL = 'YT';
	var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
	var MATCH_URL = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=/;
	var MATCH_PLAYLIST = /list=([a-zA-Z0-9_-]+)/;
	
	function parsePlaylist(url) {
	  if (MATCH_PLAYLIST.test(url)) {
	    var _url$match = url.match(MATCH_PLAYLIST),
	        _url$match2 = _slicedToArray(_url$match, 2),
	        playlistId = _url$match2[1];
	
	    return {
	      listType: 'playlist',
	      list: playlistId
	    };
	  }
	
	  return {};
	}
	
	var YouTube = /*#__PURE__*/function (_Component) {
	  _inherits(YouTube, _Component);
	
	  var _super = _createSuper(YouTube);
	
	  function YouTube() {
	    var _this;
	
	    _classCallCheck(this, YouTube);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (_ref) {
	      var data = _ref.data;
	      var _this$props = _this.props,
	          onPlay = _this$props.onPlay,
	          onPause = _this$props.onPause,
	          onBuffer = _this$props.onBuffer,
	          onBufferEnd = _this$props.onBufferEnd,
	          onEnded = _this$props.onEnded,
	          onReady = _this$props.onReady,
	          loop = _this$props.loop;
	      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
	          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
	          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
	          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
	          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
	          CUED = _window$SDK_GLOBAL$Pl.CUED;
	
	      if (data === PLAYING) {
	        onPlay();
	        onBufferEnd();
	      }
	
	      if (data === PAUSED) onPause();
	      if (data === BUFFERING) onBuffer();
	
	      if (data === ENDED) {
	        var isPlaylist = !!_this.callPlayer('getPlaylist');
	
	        if (loop && !isPlaylist) {
	          _this.play(); // Only loop manually if not playing a playlist
	
	        }
	
	        onEnded();
	      }
	
	      if (data === CUED) onReady();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.callPlayer('mute');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.callPlayer('unMute');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
	      _this.container = container;
	    });
	
	    return _this;
	  }
	
	  _createClass(YouTube, [{
	    key: "load",
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          playing = _this$props2.playing,
	          muted = _this$props2.muted,
	          playsinline = _this$props2.playsinline,
	          controls = _this$props2.controls,
	          loop = _this$props2.loop,
	          config = _this$props2.config,
	          _onError = _this$props2.onError;
	      var _config$youtube = config.youtube,
	          playerVars = _config$youtube.playerVars,
	          embedOptions = _config$youtube.embedOptions;
	      var id = url && url.match(MATCH_URL)[1];
	
	      if (isReady) {
	        if (MATCH_PLAYLIST.test(url)) {
	          this.player.loadPlaylist(parsePlaylist(url));
	          return;
	        }
	
	        this.player.cueVideoById({
	          videoId: id,
	          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
	          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
	        });
	        return;
	      }
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
	        return YT.loaded;
	      }).then(function (YT) {
	        if (!_this2.container) return;
	        _this2.player = new YT.Player(_this2.container, _objectSpread({
	          width: '100%',
	          height: '100%',
	          videoId: id,
	          playerVars: _objectSpread({
	            autoplay: playing ? 1 : 0,
	            mute: muted ? 1 : 0,
	            controls: controls ? 1 : 0,
	            start: (0, _utils.parseStartTime)(url),
	            end: (0, _utils.parseEndTime)(url),
	            origin: window.location.origin,
	            playsinline: playsinline
	          }, parsePlaylist(url), {}, playerVars),
	          events: {
	            onReady: function onReady() {
	              if (loop) {
	                _this2.player.setLoop(true); // Enable playlist looping
	
	              }
	
	              _this2.props.onReady();
	            },
	            onStateChange: _this2.onStateChange,
	            onError: function onError(event) {
	              return _onError(event.data);
	            }
	          }
	        }, embedOptions));
	      }, _onError);
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('playVideo');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pauseVideo');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      if (!document.body.contains(this.callPlayer('getIframe'))) return;
	      this.callPlayer('stopVideo');
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(amount) {
	      this.callPlayer('seekTo', amount);
	
	      if (!this.props.playing) {
	        this.pause();
	      }
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: "setPlaybackRate",
	    value: function setPlaybackRate(rate) {
	      this.callPlayer('setPlaybackRate', rate);
	    }
	  }, {
	    key: "setLoop",
	    value: function setLoop(loop) {
	      this.callPlayer('setLoop', loop);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentTime');
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var display = this.props.display;
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: display
	      };
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        style: style
	      }, /*#__PURE__*/_react["default"].createElement("div", {
	        ref: this.ref
	      }));
	    }
	  }]);
	
	  return YouTube;
	}(_react.Component);
	
	exports.YouTube = YouTube;
	
	_defineProperty(YouTube, "displayName", 'YouTube');
	
	_defineProperty(YouTube, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	var _default = (0, _singlePlayer["default"])(YouTube);
	
	exports["default"] = _default;

/***/ },
/* 637 */
[4459, 2799],
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A column sub-component for Grid.
	 */
	function GridColumn(props) {
	  var children = props.children,
	      className = props.className,
	      computer = props.computer,
	      color = props.color,
	      floated = props.floated,
	      largeScreen = props.largeScreen,
	      mobile = props.mobile,
	      only = props.only,
	      stretched = props.stretched,
	      tablet = props.tablet,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign,
	      widescreen = props.widescreen,
	      width = props.width;
	
	
	  var classes = (0, _classnames2.default)(color, (0, _lib.useKeyOnly)(stretched, 'stretched'), (0, _lib.useMultipleProp)(only, 'only'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(computer, 'wide computer'), (0, _lib.useWidthProp)(largeScreen, 'wide large screen'), (0, _lib.useWidthProp)(mobile, 'wide mobile'), (0, _lib.useWidthProp)(tablet, 'wide tablet'), (0, _lib.useWidthProp)(widescreen, 'wide widescreen'), (0, _lib.useWidthProp)(width, 'wide'), 'column', className);
	  var rest = (0, _lib.getUnhandledProps)(GridColumn, props);
	  var ElementType = (0, _lib.getElementType)(GridColumn, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	GridColumn.handledProps = ['as', 'children', 'className', 'color', 'computer', 'floated', 'largeScreen', 'mobile', 'only', 'stretched', 'tablet', 'textAlign', 'verticalAlign', 'widescreen', 'width'];
	GridColumn._meta = {
	  name: 'GridColumn',
	  parent: 'Grid',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	GridColumn.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A grid column can be colored. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** A column can specify a width for a computer. */
	  computer: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** A column can sit flush against the left or right edge of a row. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** A column can specify a width for a large screen device. */
	  largeScreen: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** A column can specify a width for a mobile device. */
	  mobile: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** A row can appear only for a specific device, or screen sizes. */
	  only: _lib.customPropTypes.multipleProp(_lib.SUI.VISIBILITY),
	
	  /** A column can stretch its contents to take up the entire grid or row height. */
	  stretched: _propTypes2.default.bool,
	
	  /** A column can specify a width for a tablet device. */
	  tablet: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** A column can specify its text alignment. */
	  textAlign: _propTypes2.default.oneOf(_lib.SUI.TEXT_ALIGNMENTS),
	
	  /** A column can specify its vertical alignment to have all its columns vertically centered. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** A column can specify a width for a wide screen device. */
	  widescreen: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** Represents width of column. */
	  width: _propTypes2.default.oneOf(_lib.SUI.WIDTHS)
	} : {};
	
	GridColumn.create = (0, _lib.createShorthandFactory)(GridColumn, function (children) {
	  return { children: children };
	});
	
	exports.default = GridColumn;

/***/ },
/* 639 */
[4482, 8, 10],
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table can have a header.
	 */
	function TableHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      fullWidth = props.fullWidth;
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(fullWidth, 'full-width'), className);
	  var rest = (0, _lib.getUnhandledProps)(TableHeader, props);
	  var ElementType = (0, _lib.getElementType)(TableHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	TableHeader.handledProps = ['as', 'children', 'className', 'content', 'fullWidth'];
	TableHeader._meta = {
	  name: 'TableHeader',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	TableHeader.defaultProps = {
	  as: 'thead'
	};
	
	TableHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A definition table can have a full width header or footer, filling in the gap left by the first column. */
	  fullWidth: _propTypes2.default.bool
	} : {};
	
	exports.default = TableHeader;

/***/ },
/* 641 */
[4505, 2826],
/* 642 */
[4506, 407, 44, 8, 10, 414, 1219, 1221, 1222],
/* 643 */
[4509, 8, 10, 416, 417],
/* 644 */
[4512, 8, 10, 414],
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StepDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('description', className);
	  var rest = (0, _lib.getUnhandledProps)(StepDescription, props);
	  var ElementType = (0, _lib.getElementType)(StepDescription, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	StepDescription.handledProps = ['as', 'children', 'className', 'content'];
	StepDescription._meta = {
	  name: 'StepDescription',
	  parent: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	StepDescription.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	StepDescription.create = (0, _lib.createShorthandFactory)(StepDescription, function (content) {
	  return { content: content };
	});
	
	exports.default = StepDescription;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A step can contain a title.
	 */
	function StepTitle(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('title', className);
	  var rest = (0, _lib.getUnhandledProps)(StepTitle, props);
	  var ElementType = (0, _lib.getElementType)(StepTitle, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	StepTitle.handledProps = ['as', 'children', 'className', 'content'];
	StepTitle._meta = {
	  name: 'StepTitle',
	  parent: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	StepTitle.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	StepTitle.create = (0, _lib.createShorthandFactory)(StepTitle, function (content) {
	  return { content: content };
	});
	
	exports.default = StepTitle;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(131);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _isNil2 = __webpack_require__(74);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasDocument = (typeof document === 'undefined' ? 'undefined' : (0, _typeof3.default)(document)) === 'object' && document !== null;
	var hasWindow = (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && window !== null && window.self === window;
	
	// eslint-disable-next-line no-confusing-arrow
	var isBrowser = function isBrowser() {
	  return !(0, _isNil3.default)(isBrowser.override) ? isBrowser.override : hasDocument && hasWindow;
	};
	
	exports.default = isBrowser;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.numberToWordMap = undefined;
	
	var _typeof2 = __webpack_require__(131);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.numberToWord = numberToWord;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberToWordMap = exports.numberToWordMap = {
	  1: 'one',
	  2: 'two',
	  3: 'three',
	  4: 'four',
	  5: 'five',
	  6: 'six',
	  7: 'seven',
	  8: 'eight',
	  9: 'nine',
	  10: 'ten',
	  11: 'eleven',
	  12: 'twelve',
	  13: 'thirteen',
	  14: 'fourteen',
	  15: 'fifteen',
	  16: 'sixteen'
	
	  /**
	   * Return the number word for numbers 1-16.
	   * Returns strings or numbers as is if there is no corresponding word.
	   * Returns an empty string if value is not a string or number.
	   * @param {string|number} value The value to convert to a word.
	   * @returns {string}
	   */
	};function numberToWord(value) {
	  var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);
	  if (type === 'string' || type === 'number') {
	    return numberToWordMap[value] || value;
	  }
	
	  return '';
	}

/***/ },
/* 649 */
[4532, 8, 10],
/* 650 */
[4533, 74, 44, 8, 10, 75],
/* 651 */
[4540, 2860],
/* 652 */
[4558, 43, 8, 10],
/* 653 */
[4559, 43, 8, 10],
/* 654 */
[4560, 43, 8, 10],
/* 655 */
[4564, 8, 10, 419, 656, 659, 660],
/* 656 */
[4567, 69, 8, 10],
/* 657 */
[4568, 8, 10, 75],
/* 658 */
[4569, 8, 10, 75],
/* 659 */
[4570, 8, 10, 658],
/* 660 */
[4571, 8, 10, 419, 661],
/* 661 */
[4572, 8, 10],
/* 662 */
[4576, 8, 10],
/* 663 */
[4577, 8, 10],
/* 664 */
[4578, 8, 10],
/* 665 */
[4580, 8, 10],
/* 666 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ },
/* 667 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(2925);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var origSymbol = global.Symbol;
	var hasSymbolSham = __webpack_require__(2926);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 671 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 674 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 675 */
/***/ function(module, exports) {

	module.exports = isPromise;
	module.exports.default = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	/*global exports*/
	var SignStream = __webpack_require__(2955);
	var VerifyStream = __webpack_require__(2956);
	
	var ALGORITHMS = [
	  'HS256', 'HS384', 'HS512',
	  'RS256', 'RS384', 'RS512',
	  'PS256', 'PS384', 'PS512',
	  'ES256', 'ES384', 'ES512'
	];
	
	exports.ALGORITHMS = ALGORITHMS;
	exports.sign = SignStream.sign;
	exports.verify = VerifyStream.verify;
	exports.decode = VerifyStream.decode;
	exports.isValid = VerifyStream.isValid;
	exports.createSign = function createSign(opts) {
	  return new SignStream(opts);
	};
	exports.createVerify = function createVerify(opts) {
	  return new VerifyStream(opts);
	};


/***/ },
/* 677 */
[4395, 1309, 1310],
/* 678 */
96,
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(2997),
	    isObjectLike = __webpack_require__(424);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || objectToString.call(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(3024)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(124);
	var _curry2 = __webpack_require__(13);
	var _reduce = __webpack_require__(112);
	var map = __webpack_require__(99);
	
	
	/**
	 * ap applies a list of functions to a list of values.
	 *
	 * Dispatches to the `ap` method of the second argument, if present. Also
	 * treats curried functions as applicatives.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig [a -> b] -> [a] -> [b]
	 * @sig Apply f => f (a -> b) -> f a -> f b
	 * @param {*} applyF
	 * @param {*} applyX
	 * @return {*}
	 * @example
	 *
	 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
	 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
	 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
	 */
	module.exports = _curry2(function ap(applyF, applyX) {
	  return (
	    typeof applyX['fantasy-land/ap'] === 'function' ?
	      applyX['fantasy-land/ap'](applyF) :
	    typeof applyF.ap === 'function' ?
	      applyF.ap(applyX) :
	    typeof applyF === 'function' ?
	      function(x) { return applyF(x)(applyX(x)); } :
	    // else
	      _reduce(function(acc, f) { return _concat(acc, map(f, applyX)); }, [], applyF)
	  );
	});


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _makeFlat = __webpack_require__(1454);
	var _xchain = __webpack_require__(3119);
	var map = __webpack_require__(99);
	
	
	/**
	 * `chain` maps a function over a list and concatenates the results. `chain`
	 * is also known as `flatMap` in some libraries
	 *
	 * Dispatches to the `chain` method of the second argument, if present,
	 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain m => (a -> m b) -> m a -> m b
	 * @param {Function} fn The function to map with
	 * @param {Array} list The list to map over
	 * @return {Array} The result of flat-mapping `list` with `fn`
	 * @example
	 *
	 *      var duplicate = n => [n, n];
	 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
	 *
	 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
	 */
	module.exports = _curry2(_dispatchable(['fantasy-land/chain', 'chain'], _xchain, function chain(fn, monad) {
	  if (typeof monad === 'function') {
	    return function(x) { return fn(monad(x))(x); };
	  }
	  return _makeFlat(false)(map(fn, monad));
	}));


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	var pipe = __webpack_require__(1472);
	var reverse = __webpack_require__(442);
	
	
	/**
	 * Performs right-to-left function composition. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipe
	 * @example
	 *
	 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
	 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
	 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
	 *
	 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
	 */
	module.exports = function compose() {
	  if (arguments.length === 0) {
	    throw new Error('compose requires at least one argument');
	  }
	  return pipe.apply(this, reverse(arguments));
	};


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _isArray = __webpack_require__(180);
	var _isFunction = __webpack_require__(433);
	var _isString = __webpack_require__(308);
	var toString = __webpack_require__(313);
	
	
	/**
	 * Returns the result of concatenating the given lists or strings.
	 *
	 * Note: `R.concat` expects both arguments to be of the same type,
	 * unlike the native `Array.prototype.concat` method. It will throw
	 * an error if you `concat` an Array with a non-Array value.
	 *
	 * Dispatches to the `concat` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @sig String -> String -> String
	 * @param {Array|String} firstList The first list
	 * @param {Array|String} secondList The second list
	 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
	 * `secondList`.
	 *
	 * @example
	 *
	 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
	 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 *      R.concat([], []); //=> []
	 */
	module.exports = _curry2(function concat(a, b) {
	  if (_isArray(a)) {
	    if (_isArray(b)) {
	      return a.concat(b);
	    }
	    throw new TypeError(toString(b) + ' is not an array');
	  }
	  if (_isString(a)) {
	    if (_isString(b)) {
	      return a + b;
	    }
	    throw new TypeError(toString(b) + ' is not a string');
	  }
	  if (a != null && _isFunction(a['fantasy-land/concat'])) {
	    return a['fantasy-land/concat'](b);
	  }
	  if (a != null && _isFunction(a.concat)) {
	    return a.concat(b);
	  }
	  throw new TypeError(toString(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
	});


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _filter = __webpack_require__(688);
	var _isObject = __webpack_require__(691);
	var _reduce = __webpack_require__(112);
	var _xfilter = __webpack_require__(3124);
	var keys = __webpack_require__(136);
	
	
	/**
	 * Takes a predicate and a `Filterable`, and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate. Filterable objects include plain objects or any object
	 * that has a filter method such as `Array`.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array} Filterable
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(_dispatchable(['filter'], _xfilter, function(pred, filterable) {
	  return (
	    _isObject(filterable) ?
	      _reduce(function(acc, key) {
	        if (pred(filterable[key])) {
	          acc[key] = filterable[key];
	        }
	        return acc;
	      }, {}, keys(filterable)) :
	    // else
	      _filter(pred, filterable)
	  );
	}));


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _identity = __webpack_require__(689);
	
	
	/**
	 * A function that does nothing but return the parameter supplied to it. Good
	 * as a default or placeholder function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x The value to return.
	 * @return {*} The input value, `x`.
	 * @example
	 *
	 *      R.identity(1); //=> 1
	 *
	 *      var obj = {};
	 *      R.identity(obj) === obj; //=> true
	 * @symb R.identity(a) = a
	 */
	module.exports = _curry1(_identity);


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	var _objectAssign = __webpack_require__(3109);
	
	module.exports =
	  typeof Object.assign === 'function' ? Object.assign : _objectAssign;


/***/ },
/* 688 */
/***/ function(module, exports) {

	module.exports = function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 689 */
/***/ function(module, exports) {

	module.exports = function _identity(x) { return x; };


/***/ },
/* 690 */
/***/ function(module, exports) {

	/**
	 * Determine if the passed argument is an integer.
	 *
	 * @private
	 * @param {*} n
	 * @category Type
	 * @return {Boolean}
	 */
	module.exports = Number.isInteger || function _isInteger(n) {
	  return (n << 0) === n;
	};


/***/ },
/* 691 */
/***/ function(module, exports) {

	module.exports = function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	};


/***/ },
/* 692 */
/***/ function(module, exports) {

	module.exports = function _isTransformer(obj) {
	  return typeof obj['@@transducer/step'] === 'function';
	};


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var _has = __webpack_require__(90);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the key
	 * and the values associated with the key in each object, with the result being
	 * used as the value associated with the key in the returned object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeWithKey(concatValues,
	 *                     { a: true, thing: 'foo', values: [10, 20] },
	 *                     { b: true, thing: 'bar', values: [15, 35] });
	 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
	 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
	 */
	module.exports = _curry3(function mergeWithKey(fn, l, r) {
	  var result = {};
	  var k;
	
	  for (k in l) {
	    if (_has(k, l)) {
	      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
	    }
	  }
	
	  for (k in r) {
	    if (_has(k, r) && !(_has(k, result))) {
	      result[k] = r[k];
	    }
	  }
	
	  return result;
	});


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns a function that when supplied an object returns the indicated
	 * property of that object, if it exists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig s -> {s: a} -> a | Undefined
	 * @param {String} p The property name
	 * @param {Object} obj The object to query
	 * @return {*} The value at `obj.p`.
	 * @see R.path
	 * @example
	 *
	 *      R.prop('x', {x: 100}); //=> 100
	 *      R.prop('x', {}); //=> undefined
	 */
	module.exports = _curry2(function prop(p, obj) { return obj[p]; });


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(307);
	var _curry1 = __webpack_require__(29);
	var slice = __webpack_require__(212);
	
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xtake = __webpack_require__(3131);
	var slice = __webpack_require__(212);
	
	
	/**
	 * Returns the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `take` method).
	 *
	 * Dispatches to the `take` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*}
	 * @see R.drop
	 * @example
	 *
	 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(3, 'ramda');               //=> 'ram'
	 *
	 *      var personnel = [
	 *        'Dave Brubeck',
	 *        'Paul Desmond',
	 *        'Eugene Wright',
	 *        'Joe Morello',
	 *        'Gerry Mulligan',
	 *        'Bob Bates',
	 *        'Joe Dodge',
	 *        'Ron Crotty'
	 *      ];
	 *
	 *      var takeFive = R.take(5);
	 *      takeFive(personnel);
	 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
	 * @symb R.take(-1, [a, b]) = [a, b]
	 * @symb R.take(0, [a, b]) = []
	 * @symb R.take(1, [a, b]) = [a]
	 * @symb R.take(2, [a, b]) = [a, b]
	 */
	module.exports = _curry2(_dispatchable(['take'], _xtake, function take(n, xs) {
	  return slice(0, n < 0 ? Infinity : n, xs);
	}));


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Gives a single-word string description of the (native) type of a value,
	 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	 * attempt to distinguish user Object types any further, reporting them all as
	 * 'Object'.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Type
	 * @sig (* -> {*}) -> String
	 * @param {*} val The value to test
	 * @return {String}
	 * @example
	 *
	 *      R.type({}); //=> "Object"
	 *      R.type(1); //=> "Number"
	 *      R.type(false); //=> "Boolean"
	 *      R.type('s'); //=> "String"
	 *      R.type(null); //=> "Null"
	 *      R.type([]); //=> "Array"
	 *      R.type(/[A-z]/); //=> "RegExp"
	 *      R.type(() => {}); //=> "Function"
	 */
	module.exports = _curry1(function type(val) {
	  return val === null      ? 'Null'      :
	         val === undefined ? 'Undefined' :
	         Object.prototype.toString.call(val).slice(8, -1);
	});


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(686);
	var uniqBy = __webpack_require__(1481);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list. [`R.equals`](#equals) is used to determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
	 *      R.uniq([1, '1']);     //=> [1, '1']
	 *      R.uniq([[42], [42]]); //=> [[42]]
	 */
	module.exports = uniqBy(identity);


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(430);
	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied predicate to
	 * two list elements. Prefers the first item if two items compare equal based
	 * on the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      var strEq = R.eqBy(String);
	 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
	 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
	 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
	 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
	 */
	module.exports = _curry2(function uniqWith(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var item;
	  while (idx < len) {
	    item = list[idx];
	    if (!_containsWith(pred, item, result)) {
	      result[result.length] = item;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var adjust = __webpack_require__(1430);
	var always = __webpack_require__(253);
	
	
	/**
	 * Returns a new copy of the array with the element at the provided index
	 * replaced with the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} idx The index to update.
	 * @param {*} x The value to exist at the given index of the returned array.
	 * @param {Array|Arguments} list The source array-like object to be updated.
	 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
	 * @see R.adjust
	 * @example
	 *
	 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
	 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
	 * @symb R.update(-1, a, [b, c]) = [b, a]
	 * @symb R.update(0, a, [b, c]) = [a, c]
	 * @symb R.update(1, a, [b, c]) = [b, a]
	 */
	module.exports = _curry3(function update(idx, x, list) {
	  return adjust(always(x), idx, list);
	});


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(940);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(108);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(443);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _utils = __webpack_require__(314);
	
	var _Gravatar = __webpack_require__(3241);
	
	var _Gravatar2 = _interopRequireDefault(_Gravatar);
	
	var _Facebook = __webpack_require__(3239);
	
	var _Facebook2 = _interopRequireDefault(_Facebook);
	
	var _Vkontakte = __webpack_require__(3247);
	
	var _Vkontakte2 = _interopRequireDefault(_Vkontakte);
	
	var _Twitter = __webpack_require__(3245);
	
	var _Twitter2 = _interopRequireDefault(_Twitter);
	
	var _Google = __webpack_require__(3240);
	
	var _Google2 = _interopRequireDefault(_Google);
	
	var _Skype = __webpack_require__(3243);
	
	var _Skype2 = _interopRequireDefault(_Skype);
	
	var _Value = __webpack_require__(3246);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Src = __webpack_require__(3244);
	
	var _Src2 = _interopRequireDefault(_Src);
	
	var _Icon = __webpack_require__(3242);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SOURCES = [_Facebook2.default, _Google2.default, _Twitter2.default, _Vkontakte2.default, _Skype2.default, _Gravatar2.default, _Src2.default, _Value2.default, _Icon2.default];
	
	var Avatar = function (_React$Component) {
	    (0, _inherits3.default)(Avatar, _React$Component);
	
	    function Avatar(props) {
	        (0, _classCallCheck3.default)(this, Avatar);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Avatar).call(this, props));
	
	        _this.tryNextsource = function (Source, next) {
	
	            var instance = new Source(_this.props);
	
	            if (!instance.isCompatible(_this.props)) return next();
	
	            instance.get(function (state) {
	                var failedBefore = state && state.hasOwnProperty('src') && (0, _utils.hasSourceFailedBefore)(state.src);
	
	                if (!failedBefore && state) {
	                    // console.log(state);
	                    _this.setState(state);
	                } else {
	                    next();
	                }
	            });
	        };
	
	        _this.fetch = function (event) {
	            // If fetch was triggered by img onError
	            // then set state src back to null so render will
	            // automatically switch a text avatar if there is no
	            // other social ID available to try
	            if (event && event.type === 'error') {
	                (0, _utils.cacheFailingSource)(_this.state.src);
	                _this.setState({ src: null });
	            }
	
	            // console.log('## fetch');
	
	            var id = _this._fetchId = _this._fetchId ? _this._fetchId + 1 : 1;
	
	            var tryFetch = function tryFetch() {
	                if (SOURCES.length === _this.state._internal.sourcePointer) return;
	
	                var source = SOURCES[_this.state._internal.sourcePointer];
	
	                var internal = _this.state._internal;
	                internal.sourcePointer++;
	
	                // console.log('## try fetch', id, this._fetchId, internal.sourcePointer-1);
	                _this.setState({
	                    _internal: internal
	                }, function () {
	                    _this.tryNextsource(source, function () {
	                        // console.log('-- next', id, this._fetchId);
	                        if (id === _this._fetchId) {
	                            tryFetch();
	                        }
	                    });
	                });
	            };
	
	            tryFetch();
	        };
	
	        _this.state = {
	            _internal: {
	                sourcePointer: 0
	            },
	            src: null,
	            value: null,
	            color: props.color
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Avatar, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetch();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            var nextState = {};
	            if (newProps.src !== this.props.src) nextState.src = newProps.src;
	
	            if (newProps.name !== this.props.name) nextState.name = newProps.name;
	
	            if (newProps.value !== this.props.value) nextState.value = newProps.value;
	
	            if (newProps.email !== this.props.email) nextState.email = newProps.email;
	
	            if (newProps.md5Email !== this.props.md5Email) nextState.md5Email = newProps.md5Email;
	
	            if (newProps.facebookId !== this.props.facebookId) nextState.facebookId = newProps.facebookId;
	
	            if (newProps.googleId !== this.props.googleId) nextState.googleId = newProps.googleId;
	
	            if (newProps.twitterHandle !== this.props.twitterHandle) nextState.twitterHandle = newProps.twitterHandle;
	
	            if (newProps.vkontakteId !== this.props.vkontakteId) nextState.vkontakteId = newProps.vkontakteId;
	
	            if (newProps.skypeId !== this.props.skypeId) nextState.skypeId = newProps.skypeId;
	
	            if ((0, _keys2.default)(nextState) !== 0) {
	                nextState._internal = this.state._internal;
	                nextState._internal.sourcePointer = 0;
	                this.setState(nextState, this.fetch);
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	        }
	    }, {
	        key: '_renderAsImage',
	        value: function _renderAsImage() {
	            var size = this.props.size;
	            var round = this.props.round;
	            var alt = this.props.name || this.props.value;
	            var imageStyle = {
	                maxWidth: '100%',
	                width: size,
	                height: size,
	                borderRadius: round ? 500 : 0
	            };
	            return _react2.default.createElement('img', { width: this.props.size,
	                height: this.props.size,
	                style: imageStyle,
	                src: this.state.src,
	                alt: alt,
	                onError: this.fetch });
	        }
	    }, {
	        key: '_renderAsText',
	        value: function _renderAsText() {
	            var size = this.props.size;
	            var round = this.props.round;
	            var initialsStyle = {
	                width: size,
	                height: size,
	                font: Math.floor(size / 3) + 'px Helvetica, Arial, sans-serif',
	                lineHeight: size + 'px', // yes, px suffix is needed on lineHeight
	                textAlign: 'center',
	                textTransform: 'uppercase',
	                color: this.props.fgColor,
	                background: this.state.color,
	                borderRadius: round ? '100%' : 0
	            };
	            return _react2.default.createElement(
	                'div',
	                { style: initialsStyle },
	                this.state.value
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var size = this.props.size;
	            var hostStyle = (0, _extends3.default)({
	                display: 'inline-block',
	                width: size,
	                height: size,
	                borderRadius: this.props.round ? 500 : 0
	            }, this.props.style);
	            return _react2.default.createElement(
	                'div',
	                { className: this.props.className,
	                    style: hostStyle },
	                this.state.src ? this._renderAsImage() : this._renderAsText()
	            );
	        }
	    }]);
	    return Avatar;
	}(_react2.default.Component);
	
	Avatar.displayName = 'Avatar';
	Avatar.propTypes = {
	    className: _react2.default.PropTypes.string,
	    fgColor: _react2.default.PropTypes.string,
	    color: _react2.default.PropTypes.string,
	    colors: _react2.default.PropTypes.array,
	    name: _react2.default.PropTypes.string,
	    value: _react2.default.PropTypes.string,
	    email: _react2.default.PropTypes.string,
	    md5Email: _react2.default.PropTypes.string,
	    src: _react2.default.PropTypes.string,
	    facebookId: _react2.default.PropTypes.string,
	    googleId: _react2.default.PropTypes.string,
	    twitterHandle: _react2.default.PropTypes.string,
	    vkontakteId: _react2.default.PropTypes.string,
	    skypeId: _react2.default.PropTypes.string,
	    round: _react2.default.PropTypes.bool,
	    style: _react2.default.PropTypes.object,
	    size: _react2.default.PropTypes.number
	};
	Avatar.defaultProps = {
	    className: 'sb-avatar',
	    fgColor: '#FFF',
	    color: null,
	    name: null,
	    value: null,
	    email: null,
	    md5Email: null,
	    facebookId: null,
	    googleId: null,
	    twitterHandle: null,
	    vkontakteId: null,
	    skypeId: null,
	    round: false,
	    size: 100,
	    style: null
	};
	exports.default = Avatar;
	module.exports = exports['default'];

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		exports.calculateDimension = calculateDimension;
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactAddonsShallowCompare = __webpack_require__(2);
	
		var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
		var _reactDom = __webpack_require__(10);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _OutsideClickHandler = __webpack_require__(28);
	
		var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
		var _CalendarMonthGrid = __webpack_require__(29);
	
		var _CalendarMonthGrid2 = _interopRequireDefault(_CalendarMonthGrid);
	
		var _DayPickerNavigation = __webpack_require__(30);
	
		var _DayPickerNavigation2 = _interopRequireDefault(_DayPickerNavigation);
	
		var _getTransformStyles = __webpack_require__(13);
	
		var _getTransformStyles2 = _interopRequireDefault(_getTransformStyles);
	
		var _OrientationShape = __webpack_require__(8);
	
		var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var CALENDAR_MONTH_WIDTH = 300;
		var DAY_PICKER_PADDING = 9;
		var MONTH_PADDING = 23;
		var PREV_TRANSITION = 'prev';
		var NEXT_TRANSITION = 'next';
	
		var propTypes = {
		  enableOutsideDays: _react.PropTypes.bool,
		  numberOfMonths: _react.PropTypes.number,
		  modifiers: _react.PropTypes.object,
		  orientation: _OrientationShape2['default'],
		  withPortal: _react.PropTypes.bool,
		  hidden: _react.PropTypes.bool,
		  initialVisibleMonth: _react.PropTypes.func,
	
		  navPrev: _react.PropTypes.node,
		  navNext: _react.PropTypes.node,
	
		  onDayClick: _react.PropTypes.func,
		  onDayMouseDown: _react.PropTypes.func,
		  onDayMouseUp: _react.PropTypes.func,
		  onDayMouseEnter: _react.PropTypes.func,
		  onDayMouseLeave: _react.PropTypes.func,
		  onDayTouchStart: _react.PropTypes.func,
		  onDayTouchEnd: _react.PropTypes.func,
		  onDayTouchTap: _react.PropTypes.func,
		  onPrevMonthClick: _react.PropTypes.func,
		  onNextMonthClick: _react.PropTypes.func,
		  onOutsideClick: _react.PropTypes.func,
	
		  // i18n
		  monthFormat: _react.PropTypes.string
		};
	
		var defaultProps = {
		  enableOutsideDays: false,
		  numberOfMonths: 1,
		  modifiers: {},
		  orientation: _constants.HORIZONTAL_ORIENTATION,
		  withPortal: false,
		  hidden: false,
	
		  initialVisibleMonth: function () {
		    function initialVisibleMonth() {
		      return (0, _moment2['default'])();
		    }
	
		    return initialVisibleMonth;
		  }(),
	
		  navPrev: null,
		  navNext: null,
	
		  onDayClick: function () {
		    function onDayClick() {}
	
		    return onDayClick;
		  }(),
		  onDayMouseDown: function () {
		    function onDayMouseDown() {}
	
		    return onDayMouseDown;
		  }(),
		  onDayMouseUp: function () {
		    function onDayMouseUp() {}
	
		    return onDayMouseUp;
		  }(),
		  onDayMouseEnter: function () {
		    function onDayMouseEnter() {}
	
		    return onDayMouseEnter;
		  }(),
		  onDayMouseLeave: function () {
		    function onDayMouseLeave() {}
	
		    return onDayMouseLeave;
		  }(),
		  onDayTouchStart: function () {
		    function onDayTouchStart() {}
	
		    return onDayTouchStart;
		  }(),
		  onDayTouchTap: function () {
		    function onDayTouchTap() {}
	
		    return onDayTouchTap;
		  }(),
		  onDayTouchEnd: function () {
		    function onDayTouchEnd() {}
	
		    return onDayTouchEnd;
		  }(),
		  onPrevMonthClick: function () {
		    function onPrevMonthClick() {}
	
		    return onPrevMonthClick;
		  }(),
		  onNextMonthClick: function () {
		    function onNextMonthClick() {}
	
		    return onNextMonthClick;
		  }(),
		  onOutsideClick: function () {
		    function onOutsideClick() {}
	
		    return onOutsideClick;
		  }(),
	
		  // i18n
		  monthFormat: 'MMMM YYYY'
		};
	
		function applyTransformStyles(el, transform) {
		  var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
		  var transformStyles = (0, _getTransformStyles2['default'])(transform);
		  transformStyles.opacity = opacity;
	
		  Object.keys(transformStyles).forEach(function (styleKey) {
		    // eslint-disable-next-line no-param-reassign
		    el.style[styleKey] = transformStyles[styleKey];
		  });
		}
	
		function calculateDimension(el, axis) {
		  var borderBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
		  var withMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
		  if (!el) {
		    return 0;
		  }
	
		  var axisStart = axis === 'width' ? 'Left' : 'Top';
		  var axisEnd = axis === 'width' ? 'Right' : 'Bottom';
	
		  // Only read styles if we need to
		  var style = !borderBox || withMargin ? window.getComputedStyle(el) : {};
	
		  // Offset includes border and padding
		  var size = axis === 'width' ? el.offsetWidth : el.offsetHeight;
	
		  // Get the inner size
		  if (!borderBox) {
		    size -= parseFloat(style['padding' + axisStart]) + parseFloat(style['padding' + axisEnd]) + parseFloat(style['border' + axisStart + 'Width']) + parseFloat(style['border' + axisEnd + 'Width']);
		  }
	
		  // Apply margin
		  if (withMargin) {
		    size += parseFloat(style['margin' + axisStart]) + parseFloat(style['margin' + axisEnd]);
		  }
	
		  return size;
		}
	
		function getMonthHeight(el) {
		  var caption = el.querySelector('.js-CalendarMonth__caption');
		  var grid = el.querySelector('.js-CalendarMonth__grid');
	
		  // Need to separate out table children for FF
		  // Add an additional +1 for the border
		  return calculateDimension(caption, 'height', true, true) + calculateDimension(grid, 'height') + 1;
		}
	
		var DayPicker = function (_React$Component) {
		  _inherits(DayPicker, _React$Component);
	
		  function DayPicker(props) {
		    _classCallCheck(this, DayPicker);
	
		    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));
	
		    _this.hasSetInitialVisibleMonth = !props.hidden;
		    _this.state = {
		      currentMonth: props.hidden ? (0, _moment2['default'])() : props.initialVisibleMonth(),
		      monthTransition: null,
		      translationValue: 0
		    };
	
		    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
		    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
		    _this.updateStateAfterMonthTransition = _this.updateStateAfterMonthTransition.bind(_this);
		    return _this;
		  }
	
		  _createClass(DayPicker, [{
		    key: 'componentDidMount',
		    value: function () {
		      function componentDidMount() {
		        if (this.isHorizontal()) {
		          this.adjustDayPickerHeight();
		          this.initializeDayPickerWidth();
		        }
		      }
	
		      return componentDidMount;
		    }()
		  }, {
		    key: 'componentWillReceiveProps',
		    value: function () {
		      function componentWillReceiveProps(nextProps) {
		        if (!nextProps.hidden) {
		          if (!this.hasSetInitialVisibleMonth) {
		            this.hasSetInitialVisibleMonth = true;
		            this.setState({
		              currentMonth: nextProps.initialVisibleMonth()
		            });
		          }
	
		          if (!this.dayPickerWidth && this.isHorizontal()) {
		            this.initializeDayPickerWidth();
		            this.adjustDayPickerHeight();
		          }
		        }
		      }
	
		      return componentWillReceiveProps;
		    }()
		  }, {
		    key: 'shouldComponentUpdate',
		    value: function () {
		      function shouldComponentUpdate(nextProps, nextState) {
		        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
		      }
	
		      return shouldComponentUpdate;
		    }()
		  }, {
		    key: 'componentDidUpdate',
		    value: function () {
		      function componentDidUpdate(prevProps, prevState) {
		        if (this.state.monthTransition || !this.state.currentMonth.isSame(prevState.currentMonth)) {
		          if (this.isHorizontal()) {
		            this.adjustDayPickerHeight();
		          }
		        }
		      }
	
		      return componentDidUpdate;
		    }()
		  }, {
		    key: 'onPrevMonthClick',
		    value: function () {
		      function onPrevMonthClick(e) {
		        if (e) e.preventDefault();
	
		        if (this.props.onPrevMonthClick) {
		          this.props.onPrevMonthClick(e);
		        }
	
		        var translationValue = this.isVertical() ? this.getMonthHeightByIndex(0) : this.dayPickerWidth;
	
		        // The first CalendarMonth is always positioned absolute at top: 0 or left: 0
		        // so we need to transform it to the appropriate location before the animation.
		        // This behavior is because we would otherwise need a double-render in order to
		        // adjust the container position once we had the height the first calendar
		        // (ie first draw all the calendar, then in a second render, use the first calendar's
		        // height to position the container). Variable calendar heights, amirite? <3 Maja
		        this.translateFirstDayPickerForAnimation(translationValue);
	
		        this.setState({
		          monthTransition: PREV_TRANSITION,
		          translationValue: translationValue
		        });
		      }
	
		      return onPrevMonthClick;
		    }()
		  }, {
		    key: 'onNextMonthClick',
		    value: function () {
		      function onNextMonthClick(e) {
		        if (e) e.preventDefault();
		        if (this.props.onNextMonthClick) {
		          this.props.onNextMonthClick(e);
		        }
	
		        var translationValue = this.isVertical() ? -this.getMonthHeightByIndex(1) : -this.dayPickerWidth;
	
		        this.setState({
		          monthTransition: NEXT_TRANSITION,
		          translationValue: translationValue
		        });
		      }
	
		      return onNextMonthClick;
		    }()
		  }, {
		    key: 'getMonthHeightByIndex',
		    value: function () {
		      function getMonthHeightByIndex(i) {
		        return getMonthHeight(_reactDom2['default'].findDOMNode(this.refs.transitionContainer).querySelectorAll('.CalendarMonth')[i]);
		      }
	
		      return getMonthHeightByIndex;
		    }()
		  }, {
		    key: 'isHorizontal',
		    value: function () {
		      function isHorizontal() {
		        return this.props.orientation === _constants.HORIZONTAL_ORIENTATION;
		      }
	
		      return isHorizontal;
		    }()
		  }, {
		    key: 'isVertical',
		    value: function () {
		      function isVertical() {
		        return this.props.orientation === _constants.VERTICAL_ORIENTATION;
		      }
	
		      return isVertical;
		    }()
		  }, {
		    key: 'initializeDayPickerWidth',
		    value: function () {
		      function initializeDayPickerWidth() {
		        this.dayPickerWidth = calculateDimension(_reactDom2['default'].findDOMNode(this.refs.calendarMonthGrid).querySelector('.CalendarMonth'), 'width', true);
		      }
	
		      return initializeDayPickerWidth;
		    }()
		  }, {
		    key: 'updateStateAfterMonthTransition',
		    value: function () {
		      function updateStateAfterMonthTransition() {
		        var _state = this.state;
		        var currentMonth = _state.currentMonth;
		        var monthTransition = _state.monthTransition;
	
		        var newMonth = currentMonth;
		        if (monthTransition === PREV_TRANSITION) {
		          newMonth = currentMonth.clone().subtract(1, 'month');
		        } else if (monthTransition === NEXT_TRANSITION) {
		          newMonth = currentMonth.clone().add(1, 'month');
		        }
	
		        // clear the previous transforms
		        applyTransformStyles(_reactDom2['default'].findDOMNode(this.refs.calendarMonthGrid).querySelector('.CalendarMonth'), 'none');
	
		        this.setState({
		          currentMonth: newMonth,
		          monthTransition: null,
		          translationValue: 0
		        });
		      }
	
		      return updateStateAfterMonthTransition;
		    }()
		  }, {
		    key: 'adjustDayPickerHeight',
		    value: function () {
		      function adjustDayPickerHeight() {
		        var transitionContainer = _reactDom2['default'].findDOMNode(this.refs.transitionContainer);
		        var heights = [];
	
		        Array.prototype.forEach.call(transitionContainer.querySelectorAll('.CalendarMonth'), function (el) {
		          if (el.getAttribute('data-visible') === 'true') {
		            heights.push(getMonthHeight(el));
		          }
		        });
	
		        var newMonthHeight = Math.max.apply(Math, heights) + MONTH_PADDING;
	
		        if (newMonthHeight !== calculateDimension(transitionContainer, 'height')) {
		          this.monthHeight = newMonthHeight;
		          transitionContainer.style.height = String(newMonthHeight) + 'px';
		        }
		      }
	
		      return adjustDayPickerHeight;
		    }()
		  }, {
		    key: 'translateFirstDayPickerForAnimation',
		    value: function () {
		      function translateFirstDayPickerForAnimation(translationValue) {
		        var transformType = this.isVertical() ? 'translateY' : 'translateX';
		        var transformValue = transformType + '(-' + String(translationValue) + 'px)';
	
		        applyTransformStyles(_reactDom2['default'].findDOMNode(this.refs.transitionContainer).querySelector('.CalendarMonth'), transformValue, 1);
		      }
	
		      return translateFirstDayPickerForAnimation;
		    }()
		  }, {
		    key: 'renderNavigation',
		    value: function () {
		      function renderNavigation() {
		        var _props = this.props;
		        var navPrev = _props.navPrev;
		        var navNext = _props.navNext;
	
		        return _react2['default'].createElement(_DayPickerNavigation2['default'], {
		          onPrevMonthClick: this.onPrevMonthClick,
		          onNextMonthClick: this.onNextMonthClick,
		          navPrev: navPrev,
		          navNext: navNext,
		          isVertical: this.isVertical()
		        });
		      }
	
		      return renderNavigation;
		    }()
		  }, {
		    key: 'renderWeekHeader',
		    value: function () {
		      function renderWeekHeader(index) {
		        var horizontalStyle = {
		          left: index * CALENDAR_MONTH_WIDTH
		        };
	
		        var style = this.isHorizontal() ? horizontalStyle : {};
	
		        var header = [];
		        for (var i = 0; i < 7; i++) {
		          header.push(_react2['default'].createElement('li', { key: i }, _react2['default'].createElement('small', null, (0, _moment2['default'])().weekday(i).format('dd'))));
		        }
	
		        return _react2['default'].createElement('div', {
		          className: 'DayPicker__week-header',
		          key: 'week-' + String(index),
		          style: style
		        }, _react2['default'].createElement('ul', null, header));
		      }
	
		      return renderWeekHeader;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _state2 = this.state;
		        var currentMonth = _state2.currentMonth;
		        var monthTransition = _state2.monthTransition;
		        var translationValue = _state2.translationValue;
		        var _props2 = this.props;
		        var enableOutsideDays = _props2.enableOutsideDays;
		        var numberOfMonths = _props2.numberOfMonths;
		        var orientation = _props2.orientation;
		        var modifiers = _props2.modifiers;
		        var withPortal = _props2.withPortal;
		        var onDayClick = _props2.onDayClick;
		        var onDayMouseDown = _props2.onDayMouseDown;
		        var onDayMouseUp = _props2.onDayMouseUp;
		        var onDayTouchStart = _props2.onDayTouchStart;
		        var onDayTouchEnd = _props2.onDayTouchEnd;
		        var onDayTouchTap = _props2.onDayTouchTap;
		        var onDayMouseEnter = _props2.onDayMouseEnter;
		        var onDayMouseLeave = _props2.onDayMouseLeave;
		        var onOutsideClick = _props2.onOutsideClick;
		        var monthFormat = _props2.monthFormat;
	
		        var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
		        var weekHeaders = [];
		        for (var i = 0; i < numOfWeekHeaders; i++) {
		          weekHeaders.push(this.renderWeekHeader(i));
		        }
	
		        var firstVisibleMonthIndex = 1;
		        if (monthTransition === PREV_TRANSITION) {
		          firstVisibleMonthIndex -= 1;
		        } else if (monthTransition === NEXT_TRANSITION) {
		          firstVisibleMonthIndex += 1;
		        }
	
		        var dayPickerClassNames = (0, _classnames2['default'])('DayPicker', {
		          'DayPicker--horizontal': this.isHorizontal(),
		          'DayPicker--vertical': this.isVertical(),
		          'DayPicker--portal': withPortal
		        });
	
		        var transitionContainerClasses = (0, _classnames2['default'])('transition-container', {
		          'transition-container--horizontal': this.isHorizontal(),
		          'transition-container--vertical': this.isVertical()
		        });
	
		        var horizontalWidth = CALENDAR_MONTH_WIDTH * numberOfMonths + 2 * DAY_PICKER_PADDING;
	
		        // this is a kind of made-up value that generally looks good. we'll
		        // probably want to let the user set this explicitly.
		        var verticalHeight = 1.75 * CALENDAR_MONTH_WIDTH;
	
		        var dayPickerStyle = {
		          width: this.isHorizontal() && horizontalWidth,
	
		          // These values are to center the datepicker (approximately) on the page
		          marginLeft: this.isHorizontal() && withPortal && -horizontalWidth / 2,
		          marginTop: this.isHorizontal() && withPortal && -CALENDAR_MONTH_WIDTH / 2
		        };
	
		        var transitionContainerStyle = {
		          width: this.isHorizontal() && horizontalWidth,
		          height: this.isVertical() && !withPortal && verticalHeight
		        };
	
		        var isCalendarMonthGridAnimating = monthTransition !== null;
		        var transformType = this.isVertical() ? 'translateY' : 'translateX';
		        var transformValue = transformType + '(' + String(translationValue) + 'px)';
	
		        return _react2['default'].createElement('div', { className: dayPickerClassNames, style: dayPickerStyle }, _react2['default'].createElement(_OutsideClickHandler2['default'], { onOutsideClick: onOutsideClick }, this.renderNavigation(), _react2['default'].createElement('div', { className: 'DayPicker__week-headers' }, weekHeaders), _react2['default'].createElement('div', {
		          className: transitionContainerClasses,
		          ref: 'transitionContainer',
		          style: transitionContainerStyle
		        }, _react2['default'].createElement(_CalendarMonthGrid2['default'], {
		          ref: 'calendarMonthGrid',
		          transformValue: transformValue,
		          enableOutsideDays: enableOutsideDays,
		          firstVisibleMonthIndex: firstVisibleMonthIndex,
		          initialMonth: currentMonth,
		          isAnimating: isCalendarMonthGridAnimating,
		          modifiers: modifiers,
		          orientation: orientation,
		          withPortal: withPortal,
		          numberOfMonths: numberOfMonths,
		          onDayClick: onDayClick,
		          onDayMouseDown: onDayMouseDown,
		          onDayMouseUp: onDayMouseUp,
		          onDayTouchStart: onDayTouchStart,
		          onDayTouchEnd: onDayTouchEnd,
		          onDayTouchTap: onDayTouchTap,
		          onDayMouseEnter: onDayMouseEnter,
		          onDayMouseLeave: onDayMouseLeave,
		          onMonthTransitionEnd: this.updateStateAfterMonthTransition,
		          monthFormat: monthFormat
		        }))));
		      }
	
		      return render;
		    }()
		  }]);
	
		  return DayPicker;
		}(_react2['default'].Component);
	
		exports['default'] = DayPicker;
	
		DayPicker.propTypes = propTypes;
		DayPicker.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(443);
	
	/***/ },
	/* 3 */,
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(7);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(5);
	
	/***/ },
	/* 6 */,
	/* 7 */,
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(256);
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(81);
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(76);
	
	/***/ },
	/* 11 */,
	/* 12 */,
	/* 13 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1501);
	
	/***/ },
	/* 14 */,
	/* 15 */,
	/* 16 */,
	/* 17 */,
	/* 18 */,
	/* 19 */,
	/* 20 */,
	/* 21 */,
	/* 22 */,
	/* 23 */,
	/* 24 */,
	/* 25 */,
	/* 26 */,
	/* 27 */,
	/* 28 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(3257);
	
	/***/ },
	/* 29 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1490);
	
	/***/ },
	/* 30 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(3256);
	
	/***/ }
	/******/ ]);

/***/ },
/* 703 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isTouchDevice;
	function isTouchDevice() {
	  return !!(typeof window !== 'undefined' && 'ontouchstart' in window) || !!(typeof navigator !== 'undefined' && navigator.maxTouchPoints);
	}

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toLocalizedDateString;
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(318);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toLocalizedDateString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.DISPLAY_FORMAT);
	}

/***/ },
/* 705 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDay = formatDay;
	exports.formatMonthTitle = formatMonthTitle;
	exports.formatWeekdayShort = formatWeekdayShort;
	exports.formatWeekdayLong = formatWeekdayLong;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getMonths = getMonths;
	var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	
	var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
	
	var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function formatDay(day) {
	  return day.toDateString();
	}
	
	function formatMonthTitle(d) {
	  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
	}
	
	function formatWeekdayShort(i) {
	  return WEEKDAYS_SHORT[i];
	}
	
	function formatWeekdayLong(i) {
	  return WEEKDAYS_LONG[i];
	}
	
	function getFirstDayOfWeek() {
	  return 0;
	}
	
	function getMonths() {
	  return MONTHS;
	}
	
	exports.default = {
	  formatDay: formatDay,
	  formatMonthTitle: formatMonthTitle,
	  formatWeekdayShort: formatWeekdayShort,
	  formatWeekdayLong: formatWeekdayLong,
	  getFirstDayOfWeek: getFirstDayOfWeek,
	  getMonths: getMonths
	};
	//# sourceMappingURL=LocaleUtils.js.map

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dayMatchesModifier = dayMatchesModifier;
	exports.getModifiersForDay = getModifiersForDay;
	
	var _DateUtils = __webpack_require__(258);
	
	var _Helpers = __webpack_require__(446);
	
	/**
	 * Return `true` if a date matches the specified modifier.
	 *
	 * @export
	 * @param {Date} day
	 * @param {Any} modifier
	 * @return {Boolean}
	 */
	function dayMatchesModifier(day, modifier) {
	  if (!modifier) {
	    return false;
	  }
	  var arr = Array.isArray(modifier) ? modifier : [modifier];
	  return arr.some(function (mod) {
	    if (!mod) {
	      return false;
	    }
	    if (mod instanceof Date) {
	      return (0, _DateUtils.isSameDay)(day, mod);
	    }
	    if ((0, _Helpers.isRangeOfDates)(mod)) {
	      return (0, _DateUtils.isDayInRange)(day, mod);
	    }
	    if (mod.after && mod.before && (0, _DateUtils.isDayAfter)(mod.before, mod.after)) {
	      return (0, _DateUtils.isDayAfter)(day, mod.after) && (0, _DateUtils.isDayBefore)(day, mod.before);
	    }
	    if (mod.after && mod.before && ((0, _DateUtils.isDayAfter)(mod.after, mod.before) || (0, _DateUtils.isSameDay)(mod.after, mod.before))) {
	      return (0, _DateUtils.isDayAfter)(day, mod.after) || (0, _DateUtils.isDayBefore)(day, mod.before);
	    }
	    if (mod.after) {
	      return (0, _DateUtils.isDayAfter)(day, mod.after);
	    }
	    if (mod.before) {
	      return (0, _DateUtils.isDayBefore)(day, mod.before);
	    }
	    if (mod.daysOfWeek) {
	      return mod.daysOfWeek.some(function (dayOfWeek) {
	        return day.getDay() === dayOfWeek;
	      });
	    }
	    if (typeof mod === 'function') {
	      return mod(day);
	    }
	    return false;
	  });
	}
	
	/**
	 * Return the modifiers matching the given day for the given
	 * object of modifiers.
	 *
	 * @export
	 * @param {Date} day
	 * @param {Object} [modifiersObj={}]
	 * @return {Array}
	 */
	function getModifiersForDay(day) {
	  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
	    var value = modifiersObj[modifierName];
	    if (dayMatchesModifier(day, value)) {
	      modifiers.push(modifierName);
	    }
	    return modifiers;
	  }, []);
	}
	
	exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
	//# sourceMappingURL=ModifiersUtils.js.map

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(259);
	var Danger = __webpack_require__(3281);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactInstrumentation = __webpack_require__(113);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(716);
	var setInnerHTML = __webpack_require__(452);
	var setTextContent = __webpack_require__(1529);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 708 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(36);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var ReactErrorUtils = __webpack_require__(714);
	
	var invariant = __webpack_require__(36);
	var warning = __webpack_require__(41);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 711 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var ReactPropTypesSecret = __webpack_require__(3307);
	var propTypesFactory = __webpack_require__(3337);
	
	var React = __webpack_require__(217);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(36);
	var warning = __webpack_require__(41);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(36);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var ReactCurrentOwner = __webpack_require__(159);
	var ReactInstanceMap = __webpack_require__(322);
	var ReactInstrumentation = __webpack_require__(113);
	var ReactUpdates = __webpack_require__(125);
	
	var invariant = __webpack_require__(36);
	var warning = __webpack_require__(41);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 716 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 717 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 718 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 719 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(45);
	
	var ReactCompositeComponent = __webpack_require__(3288);
	var ReactEmptyComponent = __webpack_require__(1513);
	var ReactHostComponent = __webpack_require__(1515);
	
	var getNextDebugID = __webpack_require__(3630);
	var invariant = __webpack_require__(36);
	var warning = __webpack_require__(41);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(89);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 722 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var emptyFunction = __webpack_require__(110);
	var warning = __webpack_require__(41);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var prop_types_1 = __importDefault(__webpack_require__(3352));
	var react_1 = __importDefault(__webpack_require__(1));
	var FileDrop = /** @class */ (function (_super) {
	    __extends(FileDrop, _super);
	    function FileDrop(props) {
	        var _this = _super.call(this, props) || this;
	        _this.resetDragging = function () {
	            _this.frameDragCounter = 0;
	            _this.setState({ draggingOverFrame: false, draggingOverTarget: false });
	        };
	        _this.handleWindowDragOverOrDrop = function (event) {
	            // This prevents the browser from trying to load whatever file the user dropped on the window
	            event.preventDefault();
	        };
	        _this.handleFrameDrag = function (event) {
	            // Only allow dragging of files
	            if (!FileDrop.eventHasFiles(event))
	                return;
	            // We are listening for events on the 'frame', so every time the user drags over any element in the frame's tree,
	            // the event bubbles up to the frame. By keeping count of how many "dragenters" we get, we can tell if they are still
	            // "draggingOverFrame" (b/c you get one "dragenter" initially, and one "dragenter"/one "dragleave" for every bubble)
	            // This is far better than a "dragover" handler, which would be calling `setState` continuously.
	            _this.frameDragCounter += event.type === 'dragenter' ? 1 : -1;
	            if (_this.frameDragCounter === 1) {
	                _this.setState({ draggingOverFrame: true });
	                if (_this.props.onFrameDragEnter)
	                    _this.props.onFrameDragEnter(event);
	                return;
	            }
	            if (_this.frameDragCounter === 0) {
	                _this.setState({ draggingOverFrame: false });
	                if (_this.props.onFrameDragLeave)
	                    _this.props.onFrameDragLeave(event);
	                return;
	            }
	        };
	        _this.handleFrameDrop = function (event) {
	            if (!_this.state.draggingOverTarget) {
	                _this.resetDragging();
	                if (_this.props.onFrameDrop)
	                    _this.props.onFrameDrop(event);
	            }
	        };
	        _this.handleDragOver = function (event) {
	            if (FileDrop.eventHasFiles(event)) {
	                _this.setState({ draggingOverTarget: true });
	                if (!FileDrop.isIE() && _this.props.dropEffect)
	                    event.dataTransfer.dropEffect = _this.props.dropEffect;
	                if (_this.props.onDragOver)
	                    _this.props.onDragOver(event);
	            }
	        };
	        _this.handleDragLeave = function (event) {
	            _this.setState({ draggingOverTarget: false });
	            if (_this.props.onDragLeave)
	                _this.props.onDragLeave(event);
	        };
	        _this.handleDrop = function (event) {
	            if (_this.props.onDrop && FileDrop.eventHasFiles(event)) {
	                var files = event.dataTransfer ? event.dataTransfer.files : null;
	                _this.props.onDrop(files, event);
	            }
	            _this.resetDragging();
	        };
	        _this.handleTargetClick = function (event) {
	            if (_this.props.onTargetClick) {
	                _this.props.onTargetClick(event);
	            }
	            _this.resetDragging();
	        };
	        _this.stopFrameListeners = function (frame) {
	            if (frame) {
	                frame.removeEventListener('dragenter', _this.handleFrameDrag);
	                frame.removeEventListener('dragleave', _this.handleFrameDrag);
	                frame.removeEventListener('drop', _this.handleFrameDrop);
	            }
	        };
	        _this.startFrameListeners = function (frame) {
	            if (frame) {
	                frame.addEventListener('dragenter', _this.handleFrameDrag);
	                frame.addEventListener('dragleave', _this.handleFrameDrag);
	                frame.addEventListener('drop', _this.handleFrameDrop);
	            }
	        };
	        _this.frameDragCounter = 0;
	        _this.state = { draggingOverFrame: false, draggingOverTarget: false };
	        return _this;
	    }
	    FileDrop.prototype.componentDidMount = function () {
	        this.startFrameListeners(this.props.frame);
	        this.resetDragging();
	        window.addEventListener('dragover', this.handleWindowDragOverOrDrop);
	        window.addEventListener('drop', this.handleWindowDragOverOrDrop);
	    };
	    FileDrop.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
	        if (nextProps.frame !== this.props.frame) {
	            this.resetDragging();
	            this.stopFrameListeners(this.props.frame);
	            this.startFrameListeners(nextProps.frame);
	        }
	    };
	    FileDrop.prototype.componentWillUnmount = function () {
	        this.stopFrameListeners(this.props.frame);
	        window.removeEventListener('dragover', this.handleWindowDragOverOrDrop);
	        window.removeEventListener('drop', this.handleWindowDragOverOrDrop);
	    };
	    FileDrop.prototype.render = function () {
	        var _a = this.props, children = _a.children, className = _a.className, targetClassName = _a.targetClassName, draggingOverFrameClassName = _a.draggingOverFrameClassName, draggingOverTargetClassName = _a.draggingOverTargetClassName;
	        var _b = this.state, draggingOverTarget = _b.draggingOverTarget, draggingOverFrame = _b.draggingOverFrame;
	        var fileDropTargetClassName = targetClassName;
	        if (draggingOverFrame)
	            fileDropTargetClassName += " " + draggingOverFrameClassName;
	        if (draggingOverTarget)
	            fileDropTargetClassName += " " + draggingOverTargetClassName;
	        return (react_1.default.createElement("div", { className: className, onDragOver: this.handleDragOver, onDragLeave: this.handleDragLeave, onDrop: this.handleDrop },
	            react_1.default.createElement("div", { className: fileDropTargetClassName, onClick: this.handleTargetClick }, children)));
	    };
	    FileDrop.isIE = function () {
	        return typeof window !== 'undefined' &&
	            (window.navigator.userAgent.indexOf('MSIE') !== -1 ||
	                window.navigator.appVersion.indexOf('Trident/') > 0);
	    };
	    FileDrop.eventHasFiles = function (event) {
	        // In most browsers this is an array, but in IE11 it's an Object :(
	        var hasFiles = false;
	        if (event.dataTransfer) {
	            var types = event.dataTransfer.types;
	            for (var keyOrIndex in types) {
	                if (types[keyOrIndex] === 'Files') {
	                    hasFiles = true;
	                    break;
	                }
	            }
	        }
	        return hasFiles;
	    };
	    FileDrop.propTypes = {
	        className: prop_types_1.default.string,
	        targetClassName: prop_types_1.default.string,
	        draggingOverFrameClassName: prop_types_1.default.string,
	        draggingOverTargetClassName: prop_types_1.default.string,
	        onDragOver: prop_types_1.default.func,
	        onDragLeave: prop_types_1.default.func,
	        onDrop: prop_types_1.default.func,
	        onTargetClick: prop_types_1.default.func,
	        dropEffect: prop_types_1.default.oneOf(['copy', 'move', 'link', 'none']),
	        frame: function (props, propName, componentName) {
	            var prop = props[propName];
	            if (prop == null) {
	                return new Error('Warning: Required prop `' + propName + '` was not specified in `' + componentName + '`');
	            }
	            if (prop !== document && !(prop instanceof HTMLElement)) {
	                return new Error('Warning: Prop `' + propName + '` must be one of the following: document, HTMLElement!');
	            }
	        },
	        onFrameDragEnter: prop_types_1.default.func,
	        onFrameDragLeave: prop_types_1.default.func,
	        onFrameDrop: prop_types_1.default.func,
	    };
	    FileDrop.defaultProps = {
	        dropEffect: 'copy',
	        frame: typeof window === 'undefined' ? undefined : window.document,
	        className: 'file-drop',
	        targetClassName: 'file-drop-target',
	        draggingOverFrameClassName: 'file-drop-dragging-over-frame',
	        draggingOverTargetClassName: 'file-drop-dragging-over-target',
	    };
	    return FileDrop;
	}(react_1.default.PureComponent));
	exports.FileDrop = FileDrop;
	//# sourceMappingURL=FileDrop.js.map

/***/ },
/* 725 */
/***/ function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 726 */
/***/ function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 727 */
/***/ function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ },
/* 728 */
/***/ function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultProps = exports.propTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var string = _react.PropTypes.string,
	    bool = _react.PropTypes.bool,
	    number = _react.PropTypes.number,
	    oneOfType = _react.PropTypes.oneOfType,
	    shape = _react.PropTypes.shape,
	    object = _react.PropTypes.object,
	    func = _react.PropTypes.func;
	var propTypes = exports.propTypes = {
	  url: string,
	  playing: bool,
	  loop: bool,
	  controls: bool,
	  volume: number,
	  playbackRate: number,
	  width: oneOfType([string, number]),
	  height: oneOfType([string, number]),
	  hidden: bool,
	  className: string,
	  style: object,
	  progressFrequency: number,
	  soundcloudConfig: shape({
	    clientId: string,
	    showArtwork: bool
	  }),
	  youtubeConfig: shape({
	    playerVars: object,
	    preload: bool
	  }),
	  vimeoConfig: shape({
	    iframeParams: object,
	    preload: bool
	  }),
	  fileConfig: shape({
	    attributes: object
	  }),
	  onReady: func,
	  onStart: func,
	  onPlay: func,
	  onPause: func,
	  onBuffer: func,
	  onEnded: func,
	  onError: func,
	  onDuration: func,
	  onProgress: func
	};
	
	var defaultProps = exports.defaultProps = {
	  playing: false,
	  loop: false,
	  controls: false,
	  volume: 0.8,
	  playbackRate: 1,
	  width: 640,
	  height: 360,
	  hidden: false,
	  progressFrequency: 1000,
	  soundcloudConfig: {
	    clientId: 'e8b6f84fbcad14c301ca1355cae1dea2',
	    showArtwork: true
	  },
	  youtubeConfig: {
	    playerVars: {},
	    preload: false
	  },
	  vimeoConfig: {
	    iframeParams: {},
	    preload: false
	  },
	  fileConfig: {
	    attributes: {}
	  },
	  onReady: function onReady() {},
	  onStart: function onStart() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onBuffer: function onBuffer() {},
	  onEnded: function onEnded() {},
	  onError: function onError() {},
	  onDuration: function onDuration() {},
	  onProgress: function onProgress() {}
	};

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	/*
	React-Quill v1.0.0
	https://github.com/zenoamaro/react-quill
	*/
	var Quill = __webpack_require__(1429);
	
	module.exports = __webpack_require__(3385);
	module.exports.Quill = Quill;
	module.exports.Mixin = __webpack_require__(1535);
	module.exports.Toolbar = __webpack_require__(3386);


/***/ },
/* 732 */
[4191, 261, 156],
/* 733 */
[4192, 3446, 3447, 3448, 3449, 3450],
/* 734 */
[4226, 3405, 326],
/* 735 */
[4233, 3410, 3411, 3469, 157, 3471],
/* 736 */
301,
/* 737 */
[4311, 157, 463],
/* 738 */
303,
/* 739 */
626,
/* 740 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(466);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(216);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(3505);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(3502);
	
	var _isActive2 = __webpack_require__(3509);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(3506);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(3511);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	var assign = __webpack_require__(45);
	
	var smooth = __webpack_require__(3519);
	
	var easing = smooth.defaultEasing;
	
	var cancelEvents = __webpack_require__(3518);
	
	var events = __webpack_require__(744);
	
	/*
	 * Function helper
	 */
	var functionWrapper = function(value) {
	  return typeof value === 'function' ? value : function() { return value; };
	};
	
	/*
	 * Sets the cancel trigger
	 */
	
	cancelEvents.register(function() {
	  __cancel = true;
	});
	
	/*
	 * Wraps window properties to allow server side rendering
	 */
	var currentWindowProperties = function() {
	  if (typeof window !== 'undefined') {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
	  }
	};
	
	/*
	 * Helper function to never extend 60fps on the webpage.
	 */
	var requestAnimationFrameHelper = (function () {
	  return  currentWindowProperties() ||
	          function (callback, element, delay) {
	              window.setTimeout(callback, delay || (1000/60), new Date().getTime());
	          };
	})();
	
	
	var __currentPositionY  = 0;
	var __startPositionY    = 0;
	var __targetPositionY   = 0;
	var __progress          = 0;
	var __duration          = 0;
	var __cancel            = false;
	
	var __target;
	var __containerElement;
	var __to;
	var __start;
	var __deltaTop;
	var __percent;
	var __delayTimeout;
	
	
	var currentPositionY = function() {
	  if (__containerElement) {
	        return __containerElement.scrollTop;
		} else {
	    var supportPageOffset = window.pageXOffset !== undefined;
	    var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
	    return supportPageOffset ? window.pageYOffset : isCSS1Compat ?
	           document.documentElement.scrollTop : document.body.scrollTop;
	   }
	};
	
	var scrollContainerHeight = function() {
	  if(__containerElement) {
	    return Math.max(
	      __containerElement.scrollHeight,
	      __containerElement.offsetHeight,
	      __containerElement.clientHeight
	    );
	  } else {
	    var body = document.body;
	    var html = document.documentElement;
	
	    return Math.max(
	      body.scrollHeight,
	      body.offsetHeight,
	      html.clientHeight,
	      html.scrollHeight,
	      html.offsetHeight
	    );
	  }
	};
	
	var animateTopScroll = function(timestamp) {
	  // Cancel on specific events
	  if(__cancel) { return };
	
	  __deltaTop = Math.round(__targetPositionY - __startPositionY);
	
	  if (__start === null) {
	    __start = timestamp;
	  }
	
	  __progress = timestamp - __start;
	
	  __percent = (__progress >= __duration ? 1 : easing(__progress/__duration));
	
	  __currentPositionY = __startPositionY + Math.ceil(__deltaTop * __percent);
	
	  if(__containerElement) {
	    __containerElement.scrollTop = __currentPositionY;
	  } else {
	    window.scrollTo(0, __currentPositionY);
	  }
	
	  if(__percent < 1) {
	    requestAnimationFrameHelper.call(window, animateTopScroll);
	    return;
	  }
	
	  if(events.registered['end']) {
	    events.registered['end'](__to, __target, __currentPositionY);
	  }
	
	};
	
	var setContainer = function (options) {
	  if(!options || !options.containerId) {
	    __containerElement = null;
	    return;
	  }
	
	  __containerElement = document.getElementById(options.containerId);
	};
	
	var startAnimateTopScroll = function(y, options, to, target) {
	
	  window.clearTimeout(__delayTimeout);
	
	  setContainer(options);
	
	
	  __start           = null;
	  __cancel          = false;
	  __startPositionY  = currentPositionY();
	  __targetPositionY = options.absolute ? y : y + __startPositionY;
	  __deltaTop        = Math.round(__targetPositionY - __startPositionY);
	
	  __duration        = functionWrapper(options.duration)(__deltaTop);
	  __duration        = isNaN(parseFloat(__duration)) ? 1000 : parseFloat(__duration);
	  __to              = to;
	  __target          = target;
	
	  if(options && options.delay > 0) {
	    __delayTimeout = window.setTimeout(function animate() {
	      requestAnimationFrameHelper.call(window, animateTopScroll);
	    }, options.delay);
	    return;
	  }
	
	  requestAnimationFrameHelper.call(window, animateTopScroll);
	
	};
	
	var scrollToTop = function (options) {
	  startAnimateTopScroll(0, assign(options || {}, { absolute : true }));
	};
	
	var scrollTo = function (toY, options) {
	  startAnimateTopScroll(toY, assign(options || {}, { absolute : true }));
	};
	
	var scrollToBottom = function(options) {
	  setContainer(options);
	  startAnimateTopScroll(scrollContainerHeight(), assign(options || {}, { absolute : true }));
	};
	
	var scrollMore = function(toY, options) {
	  setContainer(options);
	  startAnimateTopScroll(currentPositionY() + toY, assign(options || {}, { absolute : true }));
	};
	
	module.exports = {
	  animateTopScroll: startAnimateTopScroll,
	  scrollToTop: scrollToTop,
	  scrollToBottom: scrollToBottom,
	  scrollTo: scrollTo,
	  scrollMore: scrollMore,
	};


/***/ },
/* 744 */
/***/ function(module, exports) {

	
	var Events = {
		registered : {},
		scrollEvent : {
			register: function(evtName, callback) {
				Events.registered[evtName] = callback;
			},
			remove: function(evtName) {
				Events.registered[evtName] = null;
			}
		}
	};
	
	module.exports = Events;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isEqual = __webpack_require__(3610);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _youtubePlayer = __webpack_require__(3619);
	
	var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Check whether a `props` change should result in the video being updated.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	function shouldUpdateVideo(prevProps, props) {
	  // A changing video should always trigger an update
	  if (prevProps.videoId !== props.videoId) {
	    return true;
	  }
	
	  // Otherwise, a change in the start/end time playerVars also requires a player
	  // update.
	  var prevVars = prevProps.opts.playerVars || {};
	  var vars = props.opts.playerVars || {};
	
	  return prevVars.start !== vars.start || prevVars.end !== vars.end;
	}
	
	/**
	 * Neutralise API options that only require a video update, leaving only options
	 * that require a player reset. The results can then be compared to see if a
	 * player reset is necessary.
	 *
	 * @param {Object} opts
	 */
	function filterResetOptions(opts) {
	  return _extends({}, opts, {
	    playerVars: _extends({}, opts.playerVars, {
	      autoplay: 0,
	      start: 0,
	      end: 0
	    })
	  });
	}
	
	/**
	 * Check whether a `props` change should result in the player being reset.
	 * The player is reset when the `props.opts` change, except if the only change
	 * is in the `start` and `end` playerVars, because a video update can deal with
	 * those.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	function shouldResetPlayer(prevProps, props) {
	  return !(0, _isEqual2.default)(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
	}
	
	/**
	 * Check whether a props change should result in an id or className update.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	function shouldUpdatePlayer(prevProps, props) {
	  return prevProps.id === props.id || prevProps.className === props.className;
	}
	
	var YouTube = function (_React$Component) {
	  _inherits(YouTube, _React$Component);
	
	  function YouTube(props) {
	    _classCallCheck(this, YouTube);
	
	    var _this = _possibleConstructorReturn(this, (YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call(this, props));
	
	    _this.onPlayerReady = function (event) {
	      return _this.props.onReady(event);
	    };
	
	    _this.onPlayerError = function (event) {
	      return _this.props.onError(event);
	    };
	
	    _this.onPlayerStateChange = function (event) {
	      _this.props.onStateChange(event);
	      switch (event.data) {
	
	        case YouTube.PlayerState.ENDED:
	          _this.props.onEnd(event);
	          break;
	
	        case YouTube.PlayerState.PLAYING:
	          _this.props.onPlay(event);
	          break;
	
	        case YouTube.PlayerState.PAUSED:
	          _this.props.onPause(event);
	          break;
	
	        default:
	          return;
	      }
	    };
	
	    _this.onPlayerPlaybackRateChange = function (event) {
	      return _this.props.onPlaybackRateChange(event);
	    };
	
	    _this.onPlayerPlaybackQualityChange = function (event) {
	      return _this.props.onPlaybackQualityChange(event);
	    };
	
	    _this.createPlayer = function () {
	      // do not attempt to create a player server-side, it won't work
	      if (typeof document === 'undefined') return;
	      // create player
	      var playerOpts = _extends({}, _this.props.opts, {
	        // preload the `videoId` video if one is already given
	        videoId: _this.props.videoId
	      });
	      _this.internalPlayer = (0, _youtubePlayer2.default)(_this.container, playerOpts);
	      // attach event handlers
	      _this.internalPlayer.on('ready', _this.onPlayerReady);
	      _this.internalPlayer.on('error', _this.onPlayerError);
	      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
	      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
	      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
	    };
	
	    _this.resetPlayer = function () {
	      return _this.internalPlayer.destroy().then(_this.createPlayer);
	    };
	
	    _this.updatePlayer = function () {
	      _this.internalPlayer.getIframe().then(function (iframe) {
	        iframe.setAttribute('id', _this.props.id);
	        iframe.setAttribute('class', _this.props.className);
	      });
	    };
	
	    _this.updateVideo = function () {
	      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
	        _this.internalPlayer.stopVideo();
	        return;
	      }
	
	      // set queueing options
	      var autoplay = false;
	      var opts = {
	        videoId: _this.props.videoId
	      };
	      if ('playerVars' in _this.props.opts) {
	        autoplay = _this.props.opts.playerVars.autoplay === 1;
	        if ('start' in _this.props.opts.playerVars) {
	          opts.startSeconds = _this.props.opts.playerVars.start;
	        }
	        if ('end' in _this.props.opts.playerVars) {
	          opts.endSeconds = _this.props.opts.playerVars.end;
	        }
	      }
	
	      // if autoplay is enabled loadVideoById
	      if (autoplay) {
	        _this.internalPlayer.loadVideoById(opts);
	        return;
	      }
	      // default behaviour just cues the video
	      _this.internalPlayer.cueVideoById(opts);
	    };
	
	    _this.refContainer = function (container) {
	      _this.container = container;
	    };
	
	    _this.container = null;
	    _this.internalPlayer = null;
	    return _this;
	  }
	
	  /**
	    * Expose PlayerState constants for convenience. These constants can also be
	    * accessed through the global YT object after the YouTube IFrame API is instantiated.
	    * https://developers.google.com/youtube/iframe_api_reference#onStateChange
	    */
	
	
	  _createClass(YouTube, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.createPlayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (shouldUpdatePlayer(prevProps, this.props)) {
	        this.updatePlayer();
	      }
	
	      if (shouldResetPlayer(prevProps, this.props)) {
	        this.resetPlayer();
	      }
	
	      if (shouldUpdateVideo(prevProps, this.props)) {
	        this.updateVideo();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      /**
	       * Note: The `youtube-player` package that is used promisifies all Youtube
	       * Player API calls, which introduces a delay of a tick before it actually
	       * gets destroyed. Since React attempts to remove the element instantly
	       * this method isn't quick enough to reset the container element.
	       */
	      this.internalPlayer.destroy();
	    }
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onReady
	     *
	     * @param {Object} event
	     *   @param {Object} target - player object
	     */
	
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onError
	     *
	     * @param {Object} event
	     *   @param {Integer} data  - error type
	     *   @param {Object} target - player object
	     */
	
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onStateChange
	     *
	     * @param {Object} event
	     *   @param {Integer} data  - status change type
	     *   @param {Object} target - actual YT player
	     */
	
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackRateChange
	     *
	     * @param {Object} event
	     *   @param {Float} data    - playback rate
	     *   @param {Object} target - actual YT player
	     */
	
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackQualityChange
	     *
	     * @param {Object} event
	     *   @param {String} data   - playback quality
	     *   @param {Object} target - actual YT player
	     */
	
	
	    /**
	     * Initialize the Youtube Player API on the container and attach event handlers
	     */
	
	
	    /**
	     * Shorthand for destroying and then re-creating the Youtube Player
	     */
	
	
	    /**
	     * Method to update the id and class of the Youtube Player iframe.
	     * React should update this automatically but since the Youtube Player API
	     * replaced the DIV that is mounted by React we need to do this manually.
	     */
	
	
	    /**
	     * Call Youtube Player API methods to update the currently playing video.
	     * Depeding on the `opts.playerVars.autoplay` this function uses one of two
	     * Youtube Player API methods to update the video.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('div', { id: this.props.id, className: this.props.className, ref: this.refContainer })
	      );
	    }
	  }]);
	
	  return YouTube;
	}(_react2.default.Component);
	
	YouTube.propTypes = {
	  videoId: _propTypes2.default.string,
	
	  // custom ID for player element
	  id: _propTypes2.default.string,
	
	  // custom class name for player element
	  className: _propTypes2.default.string,
	
	  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	  opts: _propTypes2.default.object,
	
	  // event subscriptions
	  onReady: _propTypes2.default.func,
	  onError: _propTypes2.default.func,
	  onPlay: _propTypes2.default.func,
	  onPause: _propTypes2.default.func,
	  onEnd: _propTypes2.default.func,
	  onStateChange: _propTypes2.default.func,
	  onPlaybackRateChange: _propTypes2.default.func,
	  onPlaybackQualityChange: _propTypes2.default.func
	};
	YouTube.defaultProps = {
	  opts: {},
	  onReady: function onReady() {},
	  onError: function onError() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onEnd: function onEnd() {},
	  onStateChange: function onStateChange() {},
	  onPlaybackRateChange: function onPlaybackRateChange() {},
	  onPlaybackQualityChange: function onPlaybackQualityChange() {}
	};
	YouTube.PlayerState = {
	  UNSTARTED: -1,
	  ENDED: 0,
	  PLAYING: 1,
	  PAUSED: 2,
	  BUFFERING: 3,
	  CUED: 5
	};
	exports.default = YouTube;

/***/ },
/* 746 */
[4191, 263, 158],
/* 747 */
[4197, 158],
/* 748 */
47,
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(265);
	
	var ReactNoopUpdateQueue = __webpack_require__(750);
	
	var canDefineProperty = __webpack_require__(1588);
	var emptyObject = __webpack_require__(248);
	var invariant = __webpack_require__(36);
	var warning = __webpack_require__(41);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(41);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 751 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ARRAY_INSERT = exports.ARRAY_INSERT = '@@redux-form/ARRAY_INSERT';
	var ARRAY_MOVE = exports.ARRAY_MOVE = '@@redux-form/ARRAY_MOVE';
	var ARRAY_POP = exports.ARRAY_POP = '@@redux-form/ARRAY_POP';
	var ARRAY_PUSH = exports.ARRAY_PUSH = '@@redux-form/ARRAY_PUSH';
	var ARRAY_REMOVE = exports.ARRAY_REMOVE = '@@redux-form/ARRAY_REMOVE';
	var ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE_ALL = '@@redux-form/ARRAY_REMOVE_ALL';
	var ARRAY_SHIFT = exports.ARRAY_SHIFT = '@@redux-form/ARRAY_SHIFT';
	var ARRAY_SPLICE = exports.ARRAY_SPLICE = '@@redux-form/ARRAY_SPLICE';
	var ARRAY_UNSHIFT = exports.ARRAY_UNSHIFT = '@@redux-form/ARRAY_UNSHIFT';
	var ARRAY_SWAP = exports.ARRAY_SWAP = '@@redux-form/ARRAY_SWAP';
	var AUTOFILL = exports.AUTOFILL = '@@redux-form/AUTOFILL';
	var BLUR = exports.BLUR = '@@redux-form/BLUR';
	var CHANGE = exports.CHANGE = '@@redux-form/CHANGE';
	var CLEAR_SUBMIT = exports.CLEAR_SUBMIT = '@@redux-form/CLEAR_SUBMIT';
	var CLEAR_SUBMIT_ERRORS = exports.CLEAR_SUBMIT_ERRORS = '@@redux-form/CLEAR_SUBMIT_ERRORS';
	var CLEAR_ASYNC_ERROR = exports.CLEAR_ASYNC_ERROR = '@redux-form/CLEAR_ASYNC_ERROR';
	var DESTROY = exports.DESTROY = '@@redux-form/DESTROY';
	var FOCUS = exports.FOCUS = '@@redux-form/FOCUS';
	var INITIALIZE = exports.INITIALIZE = '@@redux-form/INITIALIZE';
	var REGISTER_FIELD = exports.REGISTER_FIELD = '@@redux-form/REGISTER_FIELD';
	var RESET = exports.RESET = '@@redux-form/RESET';
	var SET_SUBMIT_FAILED = exports.SET_SUBMIT_FAILED = '@@redux-form/SET_SUBMIT_FAILED';
	var SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_SUCCEEDED = '@@redux-form/SET_SUBMIT_SUCCEEDED';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = '@@redux-form/START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = '@@redux-form/START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = '@@redux-form/STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = '@@redux-form/STOP_SUBMIT';
	var SUBMIT = exports.SUBMIT = '@@redux-form/SUBMIT';
	var TOUCH = exports.TOUCH = '@@redux-form/TOUCH';
	var UNREGISTER_FIELD = exports.UNREGISTER_FIELD = '@@redux-form/UNREGISTER_FIELD';
	var UNTOUCH = exports.UNTOUCH = '@@redux-form/UNTOUCH';
	var UPDATE_SYNC_ERRORS = exports.UPDATE_SYNC_ERRORS = '@@redux-form/UPDATE_SYNC_ERRORS';
	var UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_WARNINGS = '@@redux-form/UPDATE_SYNC_WARNINGS';

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasError = __webpack_require__(3653);
	
	var _hasError2 = _interopRequireDefault(_hasError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsValid = function createIsValid(structure) {
	  var getIn = structure.getIn,
	      keys = structure.keys;
	
	  var hasError = (0, _hasError2.default)(structure);
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    return function (state) {
	      var formState = getFormState(state);
	      var syncError = getIn(formState, form + '.syncError');
	      if (syncError) {
	        return false;
	      }
	      if (!ignoreSubmitErrors) {
	        var error = getIn(formState, form + '.error');
	        if (error) {
	          return false;
	        }
	      }
	      var syncErrors = getIn(formState, form + '.syncErrors');
	      var asyncErrors = getIn(formState, form + '.asyncErrors');
	      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
	      if (!syncErrors && !asyncErrors && !submitErrors) {
	        return true;
	      }
	
	      var registeredFields = getIn(formState, form + '.registeredFields');
	      if (!registeredFields) {
	        return true;
	      }
	
	      return !keys(registeredFields).filter(function (name) {
	        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
	      }).some(function (name) {
	        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
	      });
	    };
	  };
	};
	
	exports.default = createIsValid;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(764);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
	  // https://lodash.com/docs/4.17.4#isEqualWith
	  if (stack) {
	    // Shallow compares
	    // For 1st level, stack === undefined.
	    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
	    // For 2nd level and up, stack !== undefined.
	    //   -> Compare by === operator
	    return objectValue === otherValue;
	  }
	};
	
	var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
	  return !(0, _isEqualWith3.default)(instance.props, nextProps, customizer) || !(0, _isEqualWith3.default)(instance.state, nextState, customizer);
	};
	
	exports.default = shallowCompare;

/***/ },
/* 754 */
[4191, 218, 138],
/* 755 */
[4192, 3749, 3750, 3751, 3752, 3753],
/* 756 */
[4196, 477, 3766, 3767, 3768, 3769, 3770],
/* 757 */
[4226, 3700, 219],
/* 758 */
301,
/* 759 */
[4311, 139, 484],
/* 760 */
302,
/* 761 */
179,
/* 762 */
[4394, 3699, 219],
/* 763 */
[4398, 138, 3780],
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(757);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ },
/* 765 */
[4402, 266, 184],
/* 766 */
626,
/* 767 */
[4409, 3703, 3717, 3758],
/* 768 */
[4413, 1599, 3705, 483],
/* 769 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 770 */
[4459, 3804],
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A column sub-component for Grid.
	 */
	function GridColumn(props) {
	  var children = props.children,
	      className = props.className,
	      computer = props.computer,
	      color = props.color,
	      floated = props.floated,
	      largeScreen = props.largeScreen,
	      mobile = props.mobile,
	      only = props.only,
	      stretched = props.stretched,
	      tablet = props.tablet,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign,
	      widescreen = props.widescreen,
	      width = props.width;
	
	
	  var classes = (0, _classnames2.default)(color, (0, _lib.useKeyOnly)(stretched, 'stretched'), (0, _lib.useOnlyProp)(only, 'only'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(computer, 'wide computer'), (0, _lib.useWidthProp)(largeScreen, 'wide large screen'), (0, _lib.useWidthProp)(mobile, 'wide mobile'), (0, _lib.useWidthProp)(tablet, 'wide tablet'), (0, _lib.useWidthProp)(widescreen, 'wide widescreen'), (0, _lib.useWidthProp)(width, 'wide'), 'column', className);
	  var rest = (0, _lib.getUnhandledProps)(GridColumn, props);
	  var ElementType = (0, _lib.getElementType)(GridColumn, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	GridColumn.handledProps = ['as', 'children', 'className', 'color', 'computer', 'floated', 'largeScreen', 'mobile', 'only', 'stretched', 'tablet', 'textAlign', 'verticalAlign', 'widescreen', 'width'];
	GridColumn._meta = {
	  name: 'GridColumn',
	  parent: 'Grid',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	GridColumn.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A grid column can be colored. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** A column can specify a width for a computer. */
	  computer: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** A column can sit flush against the left or right edge of a row. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** A column can specify a width for a large screen device. */
	  largeScreen: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** A column can specify a width for a mobile device. */
	  mobile: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** A row can appear only for a specific device, or screen sizes. */
	  only: _lib.customPropTypes.onlyProp(_lib.SUI.VISIBILITY),
	
	  /** A column can stretch its contents to take up the entire grid or row height. */
	  stretched: _propTypes2.default.bool,
	
	  /** A column can specify a width for a tablet device. */
	  tablet: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** A column can specify its text alignment. */
	  textAlign: _propTypes2.default.oneOf(_lib.SUI.TEXT_ALIGNMENTS),
	
	  /** A column can specify its vertical alignment to have all its columns vertically centered. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** A column can specify a width for a wide screen device. */
	  widescreen: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** Represents width of column. */
	  width: _propTypes2.default.oneOf(_lib.SUI.WIDTHS)
	} : {};
	
	GridColumn.create = (0, _lib.createShorthandFactory)(GridColumn, function (children) {
	  return { children: children };
	});
	
	exports.default = GridColumn;

/***/ },
/* 772 */
[4482, 12, 11],
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table can have a header.
	 */
	function TableHeader(props) {
	  var children = props.children,
	      className = props.className,
	      fullWidth = props.fullWidth;
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(fullWidth, 'full-width'), className);
	  var rest = (0, _lib.getUnhandledProps)(TableHeader, props);
	  var ElementType = (0, _lib.getElementType)(TableHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	TableHeader.handledProps = ['as', 'children', 'className', 'fullWidth'];
	TableHeader._meta = {
	  name: 'TableHeader',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	TableHeader.defaultProps = {
	  as: 'thead'
	};
	
	TableHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A definition table can have a full width header or footer, filling in the gap left by the first column. */
	  fullWidth: _propTypes2.default.bool
	} : {};
	
	exports.default = TableHeader;

/***/ },
/* 774 */
[4505, 3828],
/* 775 */
[4506, 522, 48, 12, 11, 491, 1661, 1663, 1664],
/* 776 */
[4509, 12, 11, 493, 494],
/* 777 */
[4512, 12, 11, 491],
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StepDescription(props) {
	  var children = props.children,
	      className = props.className,
	      description = props.description;
	
	  var classes = (0, _classnames2.default)('description', className);
	  var rest = (0, _lib.getUnhandledProps)(StepDescription, props);
	  var ElementType = (0, _lib.getElementType)(StepDescription, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? description : children
	  );
	}
	
	StepDescription.handledProps = ['as', 'children', 'className', 'description'];
	StepDescription._meta = {
	  name: 'StepDescription',
	  parent: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	StepDescription.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  description: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = StepDescription;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A step can contain a title.
	 */
	function StepTitle(props) {
	  var children = props.children,
	      className = props.className,
	      title = props.title;
	
	  var classes = (0, _classnames2.default)('title', className);
	  var rest = (0, _lib.getUnhandledProps)(StepTitle, props);
	  var ElementType = (0, _lib.getElementType)(StepTitle, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? title : children
	  );
	}
	
	StepTitle.handledProps = ['as', 'children', 'className', 'title'];
	StepTitle._meta = {
	  name: 'StepTitle',
	  parent: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	StepTitle.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  title: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = StepTitle;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(131);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasDocument = (typeof document === 'undefined' ? 'undefined' : (0, _typeof3.default)(document)) === 'object' && document !== null;
	var hasWindow = (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && window !== null && window.self === window;
	
	exports.default = hasDocument && hasWindow;

/***/ },
/* 781 */
648,
/* 782 */
[4532, 12, 11],
/* 783 */
[4533, 91, 48, 12, 11, 77],
/* 784 */
[4540, 3863],
/* 785 */
[4558, 42, 12, 11],
/* 786 */
[4559, 42, 12, 11],
/* 787 */
[4560, 42, 12, 11],
/* 788 */
[4564, 12, 11, 496, 789, 792, 793],
/* 789 */
[4567, 72, 12, 11],
/* 790 */
[4568, 12, 11, 77],
/* 791 */
[4569, 12, 11, 77],
/* 792 */
[4570, 12, 11, 791],
/* 793 */
[4571, 12, 11, 496, 794],
/* 794 */
[4572, 12, 11],
/* 795 */
[4576, 12, 11],
/* 796 */
[4577, 12, 11],
/* 797 */
[4578, 12, 11],
/* 798 */
[4580, 12, 11],
/* 799 */
[4188, 335, 809],
/* 800 */
[4190, 335, 809],
/* 801 */
[4191, 222, 82],
/* 802 */
[4192, 3986, 3987, 3988, 3989, 3990],
/* 803 */
[4196, 497, 4001, 4002, 4003, 4004, 4005],
/* 804 */
607,
/* 805 */
608,
/* 806 */
[4209, 803, 334, 501, 1725, 3899, 3936, 509, 3943, 3944, 1745, 1746, 223, 3974, 3975, 3976, 49, 340, 4050, 100, 4051, 116, 825],
/* 807 */
[4218, 3903, 116],
/* 808 */
[4226, 3910, 83],
/* 809 */
611,
/* 810 */
[4248, 269, 162, 49, 225],
/* 811 */
[4257, 1719],
/* 812 */
[4292, 1753, 1774],
/* 813 */
616,
/* 814 */
[4299, 1721, 1778],
/* 815 */
618,
/* 816 */
[4311, 49, 225],
/* 817 */
[4329, 1744],
/* 818 */
621,
/* 819 */
[4335, 3927, 1759],
/* 820 */
[4353, 272],
/* 821 */
[4356, 1721, 3902, 114, 49],
/* 822 */
[4400, 808],
/* 823 */
626,
/* 824 */
[4407, 140, 49, 83],
/* 825 */
[4414, 1722, 3917, 126],
/* 826 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 827 */
[4420, 3922, 512],
/* 828 */
[4427, 1724, 114, 3928, 49, 515],
/* 829 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 830 */
528,
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define('underscore', factory) :
	  (global = global || self, (function () {
	    var current = global._;
	    var exports = global._ = factory();
	    exports.noConflict = function () { global._ = current; return exports; };
	  }()));
	}(this, (function () {
	  //     Underscore.js 1.12.0
	  //     https://underscorejs.org
	  //     (c) 2009-2020 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	  //     Underscore may be freely distributed under the MIT license.
	
	  // Current version.
	  var VERSION = '1.12.0';
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = typeof self == 'object' && self.self === self && self ||
	            typeof global == 'object' && global.global === global && global ||
	            Function('return this')() ||
	            {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // Modern feature detection.
	  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
	      supportsDataView = typeof DataView !== 'undefined';
	
	  // All **ECMAScript 5+** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create,
	      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;
	
	  // Create references to these builtin functions because we override them.
	  var _isNaN = isNaN,
	      _isFinite = isFinite;
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  // The largest integer that can be represented exactly.
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  function restArguments(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  }
	
	  // Is a given variable an object?
	  function isObject(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  }
	
	  // Is a given value equal to null?
	  function isNull(obj) {
	    return obj === null;
	  }
	
	  // Is a given variable undefined?
	  function isUndefined(obj) {
	    return obj === void 0;
	  }
	
	  // Is a given value a boolean?
	  function isBoolean(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  }
	
	  // Is a given value a DOM element?
	  function isElement(obj) {
	    return !!(obj && obj.nodeType === 1);
	  }
	
	  // Internal function for creating a `toString`-based type tester.
	  function tagTester(name) {
	    var tag = '[object ' + name + ']';
	    return function(obj) {
	      return toString.call(obj) === tag;
	    };
	  }
	
	  var isString = tagTester('String');
	
	  var isNumber = tagTester('Number');
	
	  var isDate = tagTester('Date');
	
	  var isRegExp = tagTester('RegExp');
	
	  var isError = tagTester('Error');
	
	  var isSymbol = tagTester('Symbol');
	
	  var isArrayBuffer = tagTester('ArrayBuffer');
	
	  var isFunction = tagTester('Function');
	
	  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
	  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  var isFunction$1 = isFunction;
	
	  var hasObjectTag = tagTester('Object');
	
	  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
	  // In IE 11, the most common among them, this problem also applies to
	  // `Map`, `WeakMap` and `Set`.
	  var hasStringTagBug = (
	        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
	      ),
	      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));
	
	  var isDataView = tagTester('DataView');
	
	  // In IE 10 - Edge 13, we need a different heuristic
	  // to determine whether an object is a `DataView`.
	  function ie10IsDataView(obj) {
	    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
	  }
	
	  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native `Array.isArray`.
	  var isArray = nativeIsArray || tagTester('Array');
	
	  // Internal function to check whether `key` is an own property name of `obj`.
	  function has(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  }
	
	  var isArguments = tagTester('Arguments');
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  (function() {
	    if (!isArguments(arguments)) {
	      isArguments = function(obj) {
	        return has(obj, 'callee');
	      };
	    }
	  }());
	
	  var isArguments$1 = isArguments;
	
	  // Is a given object a finite number?
	  function isFinite$1(obj) {
	    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
	  }
	
	  // Is the given value `NaN`?
	  function isNaN$1(obj) {
	    return isNumber(obj) && _isNaN(obj);
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function constant(value) {
	    return function() {
	      return value;
	    };
	  }
	
	  // Common internal logic for `isArrayLike` and `isBufferLike`.
	  function createSizePropertyCheck(getSizeProperty) {
	    return function(collection) {
	      var sizeProperty = getSizeProperty(collection);
	      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
	    }
	  }
	
	  // Internal helper to generate a function to obtain property `key` from `obj`.
	  function shallowProperty(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  }
	
	  // Internal helper to obtain the `byteLength` property of an object.
	  var getByteLength = shallowProperty('byteLength');
	
	  // Internal helper to determine whether we should spend extensive checks against
	  // `ArrayBuffer` et al.
	  var isBufferLike = createSizePropertyCheck(getByteLength);
	
	  // Is a given value a typed array?
	  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
	  function isTypedArray(obj) {
	    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
	    // Otherwise, fall back on the above regular expression.
	    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
	                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
	  }
	
	  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);
	
	  // Internal helper to obtain the `length` property of an object.
	  var getLength = shallowProperty('length');
	
	  // Internal helper to create a simple lookup structure.
	  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
	  // circular imports. `emulatedSet` is a one-off solution that only works for
	  // arrays of strings.
	  function emulatedSet(keys) {
	    var hash = {};
	    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
	    return {
	      contains: function(key) { return hash[key]; },
	      push: function(key) {
	        hash[key] = true;
	        return keys.push(key);
	      }
	    };
	  }
	
	  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
	  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
	  // needed.
	  function collectNonEnumProps(obj, keys) {
	    keys = emulatedSet(keys);
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = isFunction$1(constructor) && constructor.prototype || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (has(obj, prop) && !keys.contains(prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  function keys(obj) {
	    if (!isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  function isEmpty(obj) {
	    if (obj == null) return true;
	    // Skip the more expensive `toString`-based type checks if `obj` has no
	    // `.length`.
	    var length = getLength(obj);
	    if (typeof length == 'number' && (
	      isArray(obj) || isString(obj) || isArguments$1(obj)
	    )) return length === 0;
	    return getLength(keys(obj)) === 0;
	  }
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  function isMatch(object, attrs) {
	    var _keys = keys(attrs), length = _keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = _keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  }
	
	  // If Underscore is called as a function, it returns a wrapped object that can
	  // be used OO-style. This wrapper holds altered versions of all functions added
	  // through `_.mixin`. Wrapped objects may be chained.
	  function _(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  }
	
	  _.VERSION = VERSION;
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxies for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  // Internal function to wrap or shallow-copy an ArrayBuffer,
	  // typed array or DataView to a new view, reusing the buffer.
	  function toBufferView(bufferSource) {
	    return new Uint8Array(
	      bufferSource.buffer || bufferSource,
	      bufferSource.byteOffset || 0,
	      getByteLength(bufferSource)
	    );
	  }
	
	  // We use this string twice, so give it a name for minification.
	  var tagDataView = '[object DataView]';
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  }
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    // Work around a bug in IE 10 - Edge 13.
	    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
	      if (!isDataView$1(b)) return false;
	      className = tagDataView;
	    }
	    switch (className) {
	      // These types are compared by value.
	      case '[object RegExp]':
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	      case '[object ArrayBuffer]':
	      case tagDataView:
	        // Coerce to typed array so we can fall through.
	        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays && isTypedArray$1(a)) {
	        var byteLength = getByteLength(a);
	        if (byteLength !== getByteLength(b)) return false;
	        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
	        areArrays = true;
	    }
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
	                               isFunction$1(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var _keys = keys(a), key;
	      length = _keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = _keys[length];
	        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  }
	
	  // Perform a deep comparison to check if two objects are equal.
	  function isEqual(a, b) {
	    return eq(a, b);
	  }
	
	  // Retrieve all the enumerable property names of an object.
	  function allKeys(obj) {
	    if (!isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Since the regular `Object.prototype.toString` type tests don't work for
	  // some types in IE 11, we use a fingerprinting heuristic instead, based
	  // on the methods. It's not great, but it's the best we got.
	  // The fingerprint method lists are defined below.
	  function ie11fingerprint(methods) {
	    var length = getLength(methods);
	    return function(obj) {
	      if (obj == null) return false;
	      // `Map`, `WeakMap` and `Set` have no enumerable keys.
	      var keys = allKeys(obj);
	      if (getLength(keys)) return false;
	      for (var i = 0; i < length; i++) {
	        if (!isFunction$1(obj[methods[i]])) return false;
	      }
	      // If we are testing against `WeakMap`, we need to ensure that
	      // `obj` doesn't have a `forEach` method in order to distinguish
	      // it from a regular `Map`.
	      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
	    };
	  }
	
	  // In the interest of compact minification, we write
	  // each string in the fingerprints only once.
	  var forEachName = 'forEach',
	      hasName = 'has',
	      commonInit = ['clear', 'delete'],
	      mapTail = ['get', hasName, 'set'];
	
	  // `Map`, `WeakMap` and `Set` each have slightly different
	  // combinations of the above sublists.
	  var mapMethods = commonInit.concat(forEachName, mapTail),
	      weakMapMethods = commonInit.concat(mapTail),
	      setMethods = ['add'].concat(commonInit, forEachName, hasName);
	
	  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');
	
	  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');
	
	  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');
	
	  var isWeakSet = tagTester('WeakSet');
	
	  // Retrieve the values of an object's properties.
	  function values(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[_keys[i]];
	    }
	    return values;
	  }
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of `_.object` with one argument.
	  function pairs(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [_keys[i], obj[_keys[i]]];
	    }
	    return pairs;
	  }
	
	  // Invert the keys and values of an object. The values must be serializable.
	  function invert(obj) {
	    var result = {};
	    var _keys = keys(obj);
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      result[obj[_keys[i]]] = _keys[i];
	    }
	    return result;
	  }
	
	  // Return a sorted list of the function names available on the object.
	  function functions(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (isFunction$1(obj[key])) names.push(key);
	    }
	    return names.sort();
	  }
	
	  // An internal function for creating assigner functions.
	  function createAssigner(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  }
	
	  // Extend a given object with all the properties in passed-in object(s).
	  var extend = createAssigner(allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in
	  // object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  var extendOwn = createAssigner(keys);
	
	  // Fill in a given object with default properties.
	  var defaults = createAssigner(allKeys, true);
	
	  // Create a naked function reference for surrogate-prototype-swapping.
	  function ctor() {
	    return function(){};
	  }
	
	  // An internal function for creating a new object that inherits from another.
	  function baseCreate(prototype) {
	    if (!isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    var Ctor = ctor();
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  }
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  function create(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) extendOwn(result, props);
	    return result;
	  }
	
	  // Create a (shallow-cloned) duplicate of an object.
	  function clone(obj) {
	    if (!isObject(obj)) return obj;
	    return isArray(obj) ? obj.slice() : extend({}, obj);
	  }
	
	  // Invokes `interceptor` with the `obj` and then returns `obj`.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  function tap(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  }
	
	  // Normalize a (deep) property `path` to array.
	  // Like `_.iteratee`, this function can be customized.
	  function toPath(path) {
	    return isArray(path) ? path : [path];
	  }
	  _.toPath = toPath;
	
	  // Internal wrapper for `_.toPath` to enable minification.
	  // Similar to `cb` for `_.iteratee`.
	  function toPath$1(path) {
	    return _.toPath(path);
	  }
	
	  // Internal function to obtain a nested property in `obj` along `path`.
	  function deepGet(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  }
	
	  // Get the value of the (deep) property on `path` from `object`.
	  // If any property in `path` does not exist or if the value is
	  // `undefined`, return `defaultValue` instead.
	  // The `path` is normalized through `_.toPath`.
	  function get(object, path, defaultValue) {
	    var value = deepGet(object, toPath$1(path));
	    return isUndefined(value) ? defaultValue : value;
	  }
	
	  // Shortcut function for checking if an object has a given property directly on
	  // itself (in other words, not on a prototype). Unlike the internal `has`
	  // function, this public version can also traverse nested properties.
	  function has$1(obj, path) {
	    path = toPath$1(path);
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (!has(obj, key)) return false;
	      obj = obj[key];
	    }
	    return !!length;
	  }
	
	  // Keep the identity function around for default iteratees.
	  function identity(value) {
	    return value;
	  }
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  function matcher(attrs) {
	    attrs = extendOwn({}, attrs);
	    return function(obj) {
	      return isMatch(obj, attrs);
	    };
	  }
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indices.
	  function property(path) {
	    path = toPath$1(path);
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  }
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  function optimizeCb(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  }
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `_.identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  function baseIteratee(value, context, argCount) {
	    if (value == null) return identity;
	    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
	    if (isObject(value) && !isArray(value)) return matcher(value);
	    return property(value);
	  }
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only `argCount` argument.
	  function iteratee(value, context) {
	    return baseIteratee(value, context, Infinity);
	  }
	  _.iteratee = iteratee;
	
	  // The function we call internally to generate a callback. It invokes
	  // `_.iteratee` if overridden, otherwise `baseIteratee`.
	  function cb(value, context, argCount) {
	    if (_.iteratee !== iteratee) return _.iteratee(value, context);
	    return baseIteratee(value, context, argCount);
	  }
	
	  // Returns the results of applying the `iteratee` to each element of `obj`.
	  // In contrast to `_.map` it returns an object.
	  function mapObject(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = keys(obj),
	        length = _keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function noop(){}
	
	  // Generates a function for a given object that returns a given property.
	  function propertyOf(obj) {
	    if (obj == null) return noop;
	    return function(path) {
	      return get(obj, path);
	    };
	  }
	
	  // Run a function **n** times.
	  function times(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  }
	
	  // Return a random integer between `min` and `max` (inclusive).
	  function random(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  }
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  var now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // Internal helper to generate functions for escaping and unescaping strings
	  // to/from HTML interpolation.
	  function createEscaper(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  }
	
	  // Internal list of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	
	  // Function for escaping strings to HTML interpolation.
	  var _escape = createEscaper(escapeMap);
	
	  // Internal list of HTML entities for unescaping.
	  var unescapeMap = invert(escapeMap);
	
	  // Function for unescaping strings from HTML interpolation.
	  var _unescape = createEscaper(unescapeMap);
	
	  // By default, Underscore uses ERB-style template delimiters. Change the
	  // following template settings to use alternative delimiters.
	  var templateSettings = _.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `_.templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  function escapeChar(match) {
	    return '\\' + escapes[match];
	  }
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  function template(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  }
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  function result(obj, path, fallback) {
	    path = toPath$1(path);
	    var length = path.length;
	    if (!length) {
	      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = isFunction$1(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  }
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  function uniqueId(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  }
	
	  // Start chaining a wrapped Underscore object.
	  function chain(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  }
	
	  // Internal function to execute `sourceFunc` bound to `context` with optional
	  // `args`. Determines whether to execute a function as a constructor or as a
	  // normal function.
	  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (isObject(result)) return result;
	    return self;
	  }
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
	  var partial = restArguments(function(func, boundArgs) {
	    var placeholder = partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  partial.placeholder = _;
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally).
	  var bind = restArguments(function(func, context, args) {
	    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Internal helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var isArrayLike = createSizePropertyCheck(getLength);
	
	  // Internal implementation of a recursive `flatten` function.
	  function flatten(input, depth, strict, output) {
	    output = output || [];
	    if (!depth && depth !== 0) {
	      depth = Infinity;
	    } else if (depth <= 0) {
	      return output.concat(input);
	    }
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
	        // Flatten current level of array or arguments object.
	        if (depth > 1) {
	          flatten(value, depth - 1, strict, output);
	          idx = output.length;
	        } else {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  }
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  var bindAll = restArguments(function(obj, keys) {
	    keys = flatten(keys, false, false);
	    var index = keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = keys[index];
	      obj[key] = bind(obj[key], obj);
	    }
	    return obj;
	  });
	
	  // Memoize an expensive function by storing its results.
	  function memoize(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  }
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  var delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  var defer = partial(delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  function throttle(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var _now = now();
	      if (!previous && options.leading === false) previous = _now;
	      var remaining = wait - (_now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = _now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  }
	
	  // When a sequence of calls of the returned function ends, the argument
	  // function is triggered. The end of a sequence is defined by the `wait`
	  // parameter. If `immediate` is passed, the argument function will be
	  // triggered at the beginning of the sequence instead of at the end.
	  function debounce(func, wait, immediate) {
	    var timeout, result;
	
	    var later = function(context, args) {
	      timeout = null;
	      if (args) result = func.apply(context, args);
	    };
	
	    var debounced = restArguments(function(args) {
	      if (timeout) clearTimeout(timeout);
	      if (immediate) {
	        var callNow = !timeout;
	        timeout = setTimeout(later, wait);
	        if (callNow) result = func.apply(this, args);
	      } else {
	        timeout = delay(later, wait, this, args);
	      }
	
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = null;
	    };
	
	    return debounced;
	  }
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  function wrap(func, wrapper) {
	    return partial(wrapper, func);
	  }
	
	  // Returns a negated version of the passed-in predicate.
	  function negate(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  }
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  }
	
	  // Returns a function that will only be executed on and after the Nth call.
	  function after(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  }
	
	  // Returns a function that will only be executed up to (but not including) the
	  // Nth call.
	  function before(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  }
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  var once = partial(before, 2);
	
	  // Returns the first key on an object that passes a truth test.
	  function findKey(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = keys(obj), key;
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      key = _keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  }
	
	  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a truth test.
	  var findIndex = createPredicateIndexFinder(1);
	
	  // Returns the last index on an array-like that passes a truth test.
	  var findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  function sortedIndex(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  }
	
	  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), isNaN$1);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  var indexOf = createIndexFinder(1, findIndex, sortedIndex);
	
	  // Return the position of the last occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  var lastIndexOf = createIndexFinder(-1, findLastIndex);
	
	  // Return the first value which passes a truth test.
	  function find(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  }
	
	  // Convenience version of a common use case of `_.find`: getting the first
	  // object containing specific `key:value` pairs.
	  function findWhere(obj, attrs) {
	    return find(obj, matcher(attrs));
	  }
	
	  // The cornerstone for collection functions, an `each`
	  // implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  function each(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var _keys = keys(obj);
	      for (i = 0, length = _keys.length; i < length; i++) {
	        iteratee(obj[_keys[i]], _keys[i], obj);
	      }
	    }
	    return obj;
	  }
	
	  // Return the results of applying the iteratee to each element.
	  function map(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Internal helper to create a reducing function, iterating left or right.
	  function createReduce(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var _keys = !isArrayLike(obj) && keys(obj),
	          length = (_keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[_keys ? _keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = _keys ? _keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  var reduce = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  var reduceRight = createReduce(-1);
	
	  // Return all the elements that pass a truth test.
	  function filter(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  }
	
	  // Return all the elements for which a truth test fails.
	  function reject(obj, predicate, context) {
	    return filter(obj, negate(cb(predicate)), context);
	  }
	
	  // Determine whether all of the elements pass a truth test.
	  function every(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  }
	
	  // Determine if at least one element in the object passes a truth test.
	  function some(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  }
	
	  // Determine if the array or object contains a given item (using `===`).
	  function contains(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return indexOf(obj, item, fromIndex) >= 0;
	  }
	
	  // Invoke a method (with arguments) on every item in a collection.
	  var invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (isFunction$1(path)) {
	      func = path;
	    } else {
	      path = toPath$1(path);
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `_.map`: fetching a property.
	  function pluck(obj, key) {
	    return map(obj, property(key));
	  }
	
	  // Convenience version of a common use case of `_.filter`: selecting only
	  // objects containing specific `key:value` pairs.
	  function where(obj, attrs) {
	    return filter(obj, matcher(attrs));
	  }
	
	  // Return the maximum element (or element-based computation).
	  function max(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Return the minimum element (or element-based computation).
	  function min(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `_.map`.
	  function sample(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = values(obj);
	      return obj[random(obj.length - 1)];
	    }
	    var sample = isArrayLike(obj) ? clone(obj) : values(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  }
	
	  // Shuffle a collection.
	  function shuffle(obj) {
	    return sample(obj, Infinity);
	  }
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  function sortBy(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return pluck(map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  }
	
	  // An internal function used for aggregate "group by" operations.
	  function group(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  }
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  var groupBy = group(function(result, value, key) {
	    if (has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
	  // when you know that your index values will be unique.
	  var indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  var countBy = group(function(result, value, key) {
	    if (has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Split a collection into two arrays: one whose elements all pass the given
	  // truth test, and one whose elements all do not pass the truth test.
	  var partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Safely create a real, live array from anything iterable.
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  function toArray(obj) {
	    if (!obj) return [];
	    if (isArray(obj)) return slice.call(obj);
	    if (isString(obj)) {
	      // Keep surrogate pair characters together.
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return map(obj, identity);
	    return values(obj);
	  }
	
	  // Return the number of elements in a collection.
	  function size(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : keys(obj).length;
	  }
	
	  // Internal `_.pick` helper function to determine whether `key` is an enumerable
	  // property name of `obj`.
	  function keyInObj(value, key, obj) {
	    return key in obj;
	  }
	
	  // Return a copy of the object only containing the allowed properties.
	  var pick = restArguments(function(obj, keys) {
	    var result = {}, iteratee = keys[0];
	    if (obj == null) return result;
	    if (isFunction$1(iteratee)) {
	      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
	      keys = allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      keys = flatten(keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the disallowed properties.
	  var omit = restArguments(function(obj, keys) {
	    var iteratee = keys[0], context;
	    if (isFunction$1(iteratee)) {
	      iteratee = negate(iteratee);
	      if (keys.length > 1) context = keys[1];
	    } else {
	      keys = map(flatten(keys, false, false), String);
	      iteratee = function(value, key) {
	        return !contains(keys, key);
	      };
	    }
	    return pick(obj, iteratee, context);
	  });
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  function initial(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  }
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  function first(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return initial(array, array.length - n);
	  }
	
	  // Returns everything but the first entry of the `array`. Especially useful on
	  // the `arguments` object. Passing an **n** will return the rest N values in the
	  // `array`.
	  function rest(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  }
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  function last(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return rest(array, Math.max(0, array.length - n));
	  }
	
	  // Trim out all falsy values from an array.
	  function compact(array) {
	    return filter(array, Boolean);
	  }
	
	  // Flatten out an array, either recursively (by default), or up to `depth`.
	  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
	  function flatten$1(array, depth) {
	    return flatten(array, depth, false);
	  }
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  var difference = restArguments(function(array, rest) {
	    rest = flatten(rest, true, true);
	    return filter(array, function(value){
	      return !contains(rest, value);
	    });
	  });
	
	  // Return a version of the array that does not contain the specified value(s).
	  var without = restArguments(function(array, otherArrays) {
	    return difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  function uniq(array, isSorted, iteratee, context) {
	    if (!isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  var union = restArguments(function(arrays) {
	    return uniq(flatten(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  function intersection(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  }
	
	  // Complement of zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  function unzip(array) {
	    var length = array && max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = pluck(array, index);
	    }
	    return result;
	  }
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  var zip = restArguments(unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
	  function object(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  }
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](https://docs.python.org/library/functions.html#range).
	  function range(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  }
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  function chunk(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  }
	
	  // Helper function to continue chaining intermediate results.
	  function chainResult(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  }
	
	  // Add your own custom functions to the Underscore object.
	  function mixin(obj) {
	    each(functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_, args));
	      };
	    });
	    return _;
	  }
	
	  // Add all mutator `Array` functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) {
	        method.apply(obj, arguments);
	        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
	          delete obj[0];
	        }
	      }
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor `Array` functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) obj = method.apply(obj, arguments);
	      return chainResult(this, obj);
	    };
	  });
	
	  // Named Exports
	
	  var allExports = {
	    __proto__: null,
	    VERSION: VERSION,
	    restArguments: restArguments,
	    isObject: isObject,
	    isNull: isNull,
	    isUndefined: isUndefined,
	    isBoolean: isBoolean,
	    isElement: isElement,
	    isString: isString,
	    isNumber: isNumber,
	    isDate: isDate,
	    isRegExp: isRegExp,
	    isError: isError,
	    isSymbol: isSymbol,
	    isArrayBuffer: isArrayBuffer,
	    isDataView: isDataView$1,
	    isArray: isArray,
	    isFunction: isFunction$1,
	    isArguments: isArguments$1,
	    isFinite: isFinite$1,
	    isNaN: isNaN$1,
	    isTypedArray: isTypedArray$1,
	    isEmpty: isEmpty,
	    isMatch: isMatch,
	    isEqual: isEqual,
	    isMap: isMap,
	    isWeakMap: isWeakMap,
	    isSet: isSet,
	    isWeakSet: isWeakSet,
	    keys: keys,
	    allKeys: allKeys,
	    values: values,
	    pairs: pairs,
	    invert: invert,
	    functions: functions,
	    methods: functions,
	    extend: extend,
	    extendOwn: extendOwn,
	    assign: extendOwn,
	    defaults: defaults,
	    create: create,
	    clone: clone,
	    tap: tap,
	    get: get,
	    has: has$1,
	    mapObject: mapObject,
	    identity: identity,
	    constant: constant,
	    noop: noop,
	    toPath: toPath,
	    property: property,
	    propertyOf: propertyOf,
	    matcher: matcher,
	    matches: matcher,
	    times: times,
	    random: random,
	    now: now,
	    escape: _escape,
	    unescape: _unescape,
	    templateSettings: templateSettings,
	    template: template,
	    result: result,
	    uniqueId: uniqueId,
	    chain: chain,
	    iteratee: iteratee,
	    partial: partial,
	    bind: bind,
	    bindAll: bindAll,
	    memoize: memoize,
	    delay: delay,
	    defer: defer,
	    throttle: throttle,
	    debounce: debounce,
	    wrap: wrap,
	    negate: negate,
	    compose: compose,
	    after: after,
	    before: before,
	    once: once,
	    findKey: findKey,
	    findIndex: findIndex,
	    findLastIndex: findLastIndex,
	    sortedIndex: sortedIndex,
	    indexOf: indexOf,
	    lastIndexOf: lastIndexOf,
	    find: find,
	    detect: find,
	    findWhere: findWhere,
	    each: each,
	    forEach: each,
	    map: map,
	    collect: map,
	    reduce: reduce,
	    foldl: reduce,
	    inject: reduce,
	    reduceRight: reduceRight,
	    foldr: reduceRight,
	    filter: filter,
	    select: filter,
	    reject: reject,
	    every: every,
	    all: every,
	    some: some,
	    any: some,
	    contains: contains,
	    includes: contains,
	    include: contains,
	    invoke: invoke,
	    pluck: pluck,
	    where: where,
	    max: max,
	    min: min,
	    shuffle: shuffle,
	    sample: sample,
	    sortBy: sortBy,
	    groupBy: groupBy,
	    indexBy: indexBy,
	    countBy: countBy,
	    partition: partition,
	    toArray: toArray,
	    size: size,
	    pick: pick,
	    omit: omit,
	    first: first,
	    head: first,
	    take: first,
	    initial: initial,
	    last: last,
	    rest: rest,
	    tail: rest,
	    drop: rest,
	    compact: compact,
	    flatten: flatten$1,
	    without: without,
	    uniq: uniq,
	    unique: uniq,
	    union: union,
	    intersection: intersection,
	    difference: difference,
	    unzip: unzip,
	    transpose: unzip,
	    zip: zip,
	    object: object,
	    range: range,
	    chunk: chunk,
	    mixin: mixin,
	    'default': _
	  };
	
	  // Default Export
	
	  // Add all of the Underscore functions to the wrapper object.
	  var _$1 = mixin(allExports);
	  // Legacy Node.js API.
	  _$1._ = _$1;
	
	  return _$1;
	
	})));
	//# sourceMappingURL=underscore.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(1787);
	var v4 = __webpack_require__(4100);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFDQN;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _merge = __webpack_require__(342);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_fqdn_options = {
	  require_tld: true,
	  allow_underscores: false,
	  allow_trailing_dot: false
	};
	
	function isFDQN(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_fqdn_options);
	
	  /* Remove the optional trailing dot before checking validity */
	  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
	    str = str.substring(0, str.length - 1);
	  }
	  var parts = str.split('.');
	  if (options.require_tld) {
	    var tld = parts.pop();
	    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
	      return false;
	    }
	  }
	  for (var part, i = 0; i < parts.length; i++) {
	    part = parts[i];
	    if (options.allow_underscores) {
	      part = part.replace(/_/g, '');
	    }
	    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
	      return false;
	    }
	    if (/[\uff01-\uff5e]/.test(part)) {
	      // disallow full-width chars
	      return false;
	    }
	    if (part[0] === '-' || part[part.length - 1] === '-') {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toDate(date) {
	  (0, _assertString2.default)(date);
	  date = Date.parse(date);
	  return !isNaN(date) ? new Date(date) : null;
	}
	module.exports = exports['default'];

/***/ },
/* 835 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = toString;
	function toString(input) {
	  if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object' && input !== null) {
	    if (typeof input.toString === 'function') {
	      input = input.toString();
	    } else {
	      input = '[object Object]';
	    }
	  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
	    input = '';
	  }
	  return String(input);
	}
	module.exports = exports['default'];

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(227);
	
	/*<replacement>*/
	var util = __webpack_require__(295);
	util.inherits = __webpack_require__(250);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	
	function TransformState(options, stream) {
	  this.afterTransform = function(er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb)
	    return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (!util.isNullOrUndefined(data))
	    stream.push(data);
	
	  if (cb)
	    cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	
	function Transform(options) {
	  if (!(this instanceof Transform))
	    return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(options, this);
	
	  // when the writable side finishes, then flush out anything remaining.
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  this.once('prefinish', function() {
	    if (util.isFunction(this._flush))
	      this._flush(function(er) {
	        done(stream, er);
	      });
	    else
	      done(stream);
	  });
	}
	
	Transform.prototype.push = function(chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function(chunk, encoding, cb) {
	  throw new Error('not implemented');
	};
	
	Transform.prototype._write = function(chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform ||
	        rs.needReadable ||
	        rs.length < rs.highWaterMark)
	      this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function(n) {
	  var ts = this._transformState;
	
	  if (!util.isNull(ts.writechunk) && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	
	function done(stream, er) {
	  if (er)
	    return stream.emit('error', er);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length)
	    throw new Error('calling transform done when ws.length != 0');
	
	  if (ts.transforming)
	    throw new Error('calling transform done when still transforming');
	
	  return stream.push(null);
	}


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, cb), and it'll handle all
	// the drain event emission and buffering.
	
	module.exports = Writable;
	
	/*<replacement>*/
	var Buffer = __webpack_require__(58).Buffer;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	
	/*<replacement>*/
	var util = __webpack_require__(295);
	util.inherits = __webpack_require__(250);
	/*</replacement>*/
	
	var Stream = __webpack_require__(226);
	
	util.inherits(Writable, Stream);
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	}
	
	function WritableState(options, stream) {
	  var Duplex = __webpack_require__(227);
	
	  options = options || {};
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function(er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.buffer = [];
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	}
	
	function Writable(options) {
	  var Duplex = __webpack_require__(227);
	
	  // Writable ctor is applied to Duplexes, though they're not
	  // instanceof Writable, they're instanceof Readable.
	  if (!(this instanceof Writable) && !(this instanceof Duplex))
	    return new Writable(options);
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function() {
	  this.emit('error', new Error('Cannot pipe. Not readable.'));
	};
	
	
	function writeAfterEnd(stream, state, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  process.nextTick(function() {
	    cb(er);
	  });
	}
	
	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    var er = new TypeError('Invalid non-string/buffer chunk');
	    stream.emit('error', er);
	    process.nextTick(function() {
	      cb(er);
	    });
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function(chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	
	  if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  else if (!encoding)
	    encoding = state.defaultEncoding;
	
	  if (!util.isFunction(cb))
	    cb = function() {};
	
	  if (state.ended)
	    writeAfterEnd(this, state, cb);
	  else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function() {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function() {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing &&
	        !state.corked &&
	        !state.finished &&
	        !state.bufferProcessing &&
	        state.buffer.length)
	      clearBuffer(this, state);
	  }
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode &&
	      state.decodeStrings !== false &&
	      util.isString(chunk)) {
	    chunk = new Buffer(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret)
	    state.needDrain = true;
	
	  if (state.writing || state.corked)
	    state.buffer.push(new WriteReq(chunk, encoding, cb));
	  else
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev)
	    stream._writev(chunk, state.onwrite);
	  else
	    stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  if (sync)
	    process.nextTick(function() {
	      state.pendingcb--;
	      cb(er);
	    });
	  else {
	    state.pendingcb--;
	    cb(er);
	  }
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er)
	    onwriteError(stream, state, sync, er, cb);
	  else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(stream, state);
	
	    if (!finished &&
	        !state.corked &&
	        !state.bufferProcessing &&
	        state.buffer.length) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      process.nextTick(function() {
	        afterWrite(stream, state, finished, cb);
	      });
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished)
	    onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	
	  if (stream._writev && state.buffer.length > 1) {
	    // Fast case, write everything using _writev()
	    var cbs = [];
	    for (var c = 0; c < state.buffer.length; c++)
	      cbs.push(state.buffer[c].callback);
	
	    // count the one we are adding, as well.
	    // TODO(isaacs) clean this up
	    state.pendingcb++;
	    doWrite(stream, state, true, state.length, state.buffer, '', function(err) {
	      for (var i = 0; i < cbs.length; i++) {
	        state.pendingcb--;
	        cbs[i](err);
	      }
	    });
	
	    // Clear buffer
	    state.buffer = [];
	  } else {
	    // Slow case, write chunks one-by-one
	    for (var c = 0; c < state.buffer.length; c++) {
	      var entry = state.buffer[c];
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        c++;
	        break;
	      }
	    }
	
	    if (c < state.buffer.length)
	      state.buffer = state.buffer.slice(c);
	    else
	      state.buffer.length = 0;
	  }
	
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function(chunk, encoding, cb) {
	  cb(new Error('not implemented'));
	
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function(chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (util.isFunction(chunk)) {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (!util.isNullOrUndefined(chunk))
	    this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished)
	    endWritable(this, state, cb);
	};
	
	
	function needFinish(stream, state) {
	  return (state.ending &&
	          state.length === 0 &&
	          !state.finished &&
	          !state.writing);
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(stream, state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else
	      prefinish(stream, state);
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished)
	      process.nextTick(cb);
	    else
	      stream.once('finish', cb);
	  }
	  state.ended = true;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 838 */
[4181, 4168, 4167],
/* 839 */
[4175, 1812],
/* 840 */
/***/ function(module, exports) {

	module.exports = noop;
	module.exports.HttpsAgent = noop;
	
	// Noop function for browser since native api's don't use agents.
	function noop () {}


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ToInteger = __webpack_require__(1279);
	var ToLength = __webpack_require__(2890);
	var ToObject = __webpack_require__(2892);
	var SameValueZero = __webpack_require__(2889);
	var $isNaN = __webpack_require__(666);
	var $isFinite = __webpack_require__(1280);
	var GetIntrinsic = __webpack_require__(154);
	var callBound = __webpack_require__(369);
	var isString = __webpack_require__(2941);
	
	var $charAt = callBound('String.prototype.charAt');
	var $indexOf = GetIntrinsic('%Array.prototype.indexOf%'); // TODO: use callBind.apply without breaking IE 8
	
	module.exports = function includes(searchElement) {
		var fromIndex = arguments.length > 1 ? ToInteger(arguments[1]) : 0;
		if ($indexOf && !$isNaN(searchElement) && $isFinite(fromIndex) && typeof searchElement !== 'undefined') {
			return $indexOf.apply(this, arguments) > -1;
		}
	
		var O = ToObject(this);
		var length = ToLength(O.length);
		if (length === 0) {
			return false;
		}
		var k = fromIndex >= 0 ? fromIndex : Math.max(0, length + fromIndex);
		while (k < length) {
			if (SameValueZero(searchElement, isString(O) ? $charAt(O, k) : O[k])) {
				return true;
			}
			k += 1;
		}
		return false;
	};


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(200);
	var RequireObjectCoercible = __webpack_require__(1278);
	var callBind = __webpack_require__(289);
	var callBound = __webpack_require__(369);
	
	var implementation = __webpack_require__(841);
	var getPolyfill = __webpack_require__(843);
	var polyfill = callBind.apply(getPolyfill());
	var shim = __webpack_require__(1822);
	
	var $slice = callBound('Array.prototype.slice');
	
	/* eslint-disable no-unused-vars */
	var boundShim = function includes(array, searchElement) {
	/* eslint-enable no-unused-vars */
		RequireObjectCoercible(array);
		return polyfill(array, $slice(arguments, 1));
	};
	define(boundShim, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = boundShim;


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(841);
	
	module.exports = function getPolyfill() {
		return Array.prototype.includes || implementation;
	};


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	// rawAsap provides everything we need except exception management.
	var rawAsap = __webpack_require__(529);
	// RawTasks are recycled to reduce GC churn.
	var freeTasks = [];
	// We queue errors to ensure they are thrown in right order (FIFO).
	// Array-as-queue is good enough here, since we are just dealing with exceptions.
	var pendingErrors = [];
	var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
	function throwFirstError() {
	    if (pendingErrors.length) {
	        throw pendingErrors.shift();
	    }
	}
	
	/**
	 * Calls a task as soon as possible after returning, in its own event, with priority
	 * over other events like animation, reflow, and repaint. An error thrown from an
	 * event will not interrupt, nor even substantially slow down the processing of
	 * other events, but will be rather postponed to a lower priority event.
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	module.exports = asap;
	function asap(task) {
	    var rawTask;
	    if (freeTasks.length) {
	        rawTask = freeTasks.pop();
	    } else {
	        rawTask = new RawTask();
	    }
	    rawTask.task = task;
	    rawAsap(rawTask);
	}
	
	// We wrap tasks with recyclable task objects.  A task object implements
	// `call`, just like a function.
	function RawTask() {
	    this.task = null;
	}
	
	// The sole purpose of wrapping the task is to catch the exception and recycle
	// the task object after its single use.
	RawTask.prototype.call = function () {
	    try {
	        this.task.call();
	    } catch (error) {
	        if (asap.onerror) {
	            // This hook exists purely for testing purposes.
	            // Its name will be periodically randomized to break any code that
	            // depends on its existence.
	            asap.onerror(error);
	        } else {
	            // In a web browser, exceptions are not fatal. However, to avoid
	            // slowing down the queue of pending tasks, we rethrow the error in a
	            // lower priority turn.
	            pendingErrors.push(error);
	            requestErrorThrow();
	        }
	    } finally {
	        this.task = null;
	        freeTasks[freeTasks.length] = this;
	    }
	};


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var formats = __webpack_require__(530);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    while (queue.length > 1) {
	        var item = queue.pop();
	        var obj = item.obj[item.prop];
	
	        if (isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    /* eslint no-param-reassign: 0 */
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (isArray(target)) {
	            target.push(source);
	        } else if (target && typeof target === 'object') {
	            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (!target || typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (isArray(target) && !isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (isArray(target) && isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                var targetItem = target[i];
	                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
	                    target[i] = merge(targetItem, item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str, decoder, charset) {
	    var strWithoutPlus = str.replace(/\+/g, ' ');
	    if (charset === 'iso-8859-1') {
	        // unescape never throws, no try...catch needed:
	        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
	    }
	    // utf-8
	    try {
	        return decodeURIComponent(strWithoutPlus);
	    } catch (e) {
	        return strWithoutPlus;
	    }
	};
	
	var encode = function encode(str, defaultEncoder, charset, kind, format) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = str;
	    if (typeof str === 'symbol') {
	        string = Symbol.prototype.toString.call(str);
	    } else if (typeof str !== 'string') {
	        string = String(str);
	    }
	
	    if (charset === 'iso-8859-1') {
	        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
	            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
	        });
	    }
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    compactQueue(queue);
	
	    return value;
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (!obj || typeof obj !== 'object') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	var combine = function combine(a, b) {
	    return [].concat(a, b);
	};
	
	var maybeMap = function maybeMap(val, fn) {
	    if (isArray(val)) {
	        var mapped = [];
	        for (var i = 0; i < val.length; i += 1) {
	            mapped.push(fn(val[i]));
	        }
	        return mapped;
	    }
	    return fn(val);
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    combine: combine,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    maybeMap: maybeMap,
	    merge: merge
	};


/***/ },
/* 846 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null !== obj && 'object' === typeof obj;
	}
	
	module.exports = isObject;


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(190);
	var qs = __webpack_require__(274);
	
	var RequestBuilder = __webpack_require__(275);
	var objectHelper = __webpack_require__(85);
	var assert = __webpack_require__(166);
	var ssodata = __webpack_require__(850);
	var windowHelper = __webpack_require__(101);
	var responseHandler = __webpack_require__(167);
	var parametersWhitelist = __webpack_require__(1839);
	var Warn = __webpack_require__(229);
	
	var PasswordlessAuthentication = __webpack_require__(1836);
	var DBConnection = __webpack_require__(1835);
	
	/**
	 * Creates a new Auth0 Authentication API client
	 * @constructor
	 * @param {Object} options
	 * @param {String} options.domain your Auth0 domain
	 * @param {String} options.clientID the Client ID found on your Application settings page
	 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} [options.responseType] type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @see {@link https://auth0.com/docs/api/authentication}
	 */
	function Authentication(auth0, options) {
	  // If we have two arguments, the first one is a WebAuth instance, so we assign that
	  // if not, it's an options object and then we should use that as options instead
	  // this is here because we don't want to break people coming from v8
	  if (arguments.length === 2) {
	    this.auth0 = auth0;
	  } else {
	    options = auth0;
	  }
	
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      domain: { type: 'string', message: 'domain option is required' },
	      clientID: { type: 'string', message: 'clientID option is required' },
	      responseType: { optional: true, type: 'string', message: 'responseType is not valid' },
	      responseMode: { optional: true, type: 'string', message: 'responseMode is not valid' },
	      redirectUri: { optional: true, type: 'string', message: 'redirectUri is not valid' },
	      scope: { optional: true, type: 'string', message: 'scope is not valid' },
	      audience: { optional: true, type: 'string', message: 'audience is not valid' },
	      _disableDeprecationWarnings: {
	        optional: true,
	        type: 'boolean',
	        message: '_disableDeprecationWarnings option is not valid'
	      },
	      _sendTelemetry: {
	        optional: true,
	        type: 'boolean',
	        message: '_sendTelemetry option is not valid'
	      },
	      _telemetryInfo: {
	        optional: true,
	        type: 'object',
	        message: '_telemetryInfo option is not valid'
	      }
	    }
	  );
	  /* eslint-enable */
	
	  this.baseOptions = options;
	  this.baseOptions._sendTelemetry = this.baseOptions._sendTelemetry === false
	    ? this.baseOptions._sendTelemetry
	    : true;
	
	  this.baseOptions.rootUrl = 'https://' + this.baseOptions.domain;
	
	  this.request = new RequestBuilder(this.baseOptions);
	
	  this.passwordless = new PasswordlessAuthentication(this.request, this.baseOptions);
	  this.dbConnection = new DBConnection(this.request, this.baseOptions);
	
	  this.warn = new Warn({
	    disableWarnings: !!options._disableDeprecationWarnings
	  });
	}
	
	/**
	 * Builds and returns the `/authorize` url in order to initialize a new authN/authZ transaction
	 *
	 * @method buildAuthorizeUrl
	 * @param {Object} options
	 * @param {String} [options.domain] your Auth0 domain
	 * @param {String} [options.clientID] the Client ID found on your Application settings page
	 * @param {String} options.redirectUri url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} options.responseType type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
	 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
	 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @see {@link https://auth0.com/docs/api/authentication#authorize-client}
	 * @see {@link https://auth0.com/docs/api/authentication#social}
	 */
	Authentication.prototype.buildAuthorizeUrl = function(options) {
	  var params;
	  var qString;
	
	  assert.check(options, { type: 'object', message: 'options parameter is not valid' });
	
	  params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'responseType',
	      'responseMode',
	      'redirectUri',
	      'scope',
	      'audience'
	    ])
	    .with(options);
	
	  /* eslint-disable */
	  assert.check(
	    params,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      clientID: { type: 'string', message: 'clientID option is required' },
	      redirectUri: { optional: true, type: 'string', message: 'redirectUri option is required' },
	      responseType: { type: 'string', message: 'responseType option is required' },
	      nonce: {
	        type: 'string',
	        message: 'nonce option is required',
	        condition: function(o) {
	          return o.responseType.indexOf('code') === -1 && o.responseType.indexOf('id_token') !== -1;
	        }
	      },
	      scope: { optional: true, type: 'string', message: 'scope option is required' },
	      audience: { optional: true, type: 'string', message: 'audience option is required' }
	    }
	  );
	  /* eslint-enable */
	
	  // eslint-disable-next-line
	  if (this.baseOptions._sendTelemetry) {
	    params.auth0Client = this.request.getTelemetryData();
	  }
	
	  if (params.connection_scope && assert.isArray(params.connection_scope)) {
	    params.connection_scope = params.connection_scope.join(',');
	  }
	
	  params = objectHelper.blacklist(params, [
	    'username',
	    'popupOptions',
	    'domain',
	    'tenant',
	    'timeout'
	  ]);
	  params = objectHelper.toSnakeCase(params, ['auth0Client']);
	  params = parametersWhitelist.oauthAuthorizeParams(this.warn, params);
	
	  qString = qs.stringify(params);
	
	  return urljoin(this.baseOptions.rootUrl, 'authorize', '?' + qString);
	};
	
	/**
	 * Builds and returns the Logout url in order to initialize a new authN/authZ transaction
	 *
	 * If you want to navigate the user to a specific URL after the logout, set that URL at the returnTo parameter. The URL should be included in any the appropriate Allowed Logout URLs list:
	 *
	 * - If the client_id parameter is included, the returnTo URL must be listed in the Allowed Logout URLs set at the Auth0 Application level (see Setting Allowed Logout URLs at the App Level).
	 * - If the client_id parameter is NOT included, the returnTo URL must be listed in the Allowed Logout URLs set at the account level (see Setting Allowed Logout URLs at the Account Level).
	 * @method buildLogoutUrl
	 * @param {Object} options
	 * @param {String} [options.clientID] the Client ID found on your Application settings page
	 * @param {String} [options.returnTo] URL to be redirected after the logout
	 * @param {Boolean} [options.federated] tells Auth0 if it should logout the user also from the IdP.
	 * @see {@link https://auth0.com/docs/api/authentication#logout}
	 */
	Authentication.prototype.buildLogoutUrl = function(options) {
	  var params;
	  var qString;
	
	  assert.check(options, {
	    optional: true,
	    type: 'object',
	    message: 'options parameter is not valid'
	  });
	
	  params = objectHelper.merge(this.baseOptions, ['clientID']).with(options || {});
	
	  // eslint-disable-next-line
	  if (this.baseOptions._sendTelemetry) {
	    params.auth0Client = this.request.getTelemetryData();
	  }
	
	  params = objectHelper.toSnakeCase(params, ['auth0Client', 'returnTo']);
	
	  qString = qs.stringify(objectHelper.blacklist(params, ['federated']));
	  if (
	    options &&
	    options.federated !== undefined &&
	    options.federated !== false &&
	    options.federated !== 'false'
	  ) {
	    qString += '&federated';
	  }
	
	  return urljoin(this.baseOptions.rootUrl, 'v2', 'logout', '?' + qString);
	};
	
	/**
	 * @callback authorizeCallback
	 * @param {Error} [err] error returned by Auth0 with the reason of the Auth failure
	 * @param {Object} [result] result of the Auth request. If there is no token available, this value will be null.
	 * @param {String} [result.accessToken] token that allows access to the specified resource server (identified by the audience parameter or by default Auth0's /userinfo endpoint)
	 * @param {Number} [result.expiresIn] number of seconds until the access token expires
	 * @param {String} [result.idToken] token that identifies the user
	 * @param {String} [result.refreshToken] token that can be used to get new access tokens from Auth0. Note that not all Auth0 Applications can request them or the resource server might not allow them.
	 */
	
	/**
	 * @callback tokenCallback
	 * @param {Error} [err] error returned by Auth0 with the reason of the Auth failure
	 * @param {Object} [result] result of the Auth request
	 * @param {String} result.accessToken token that allows access to the specified resource server (identified by the audience parameter or by default Auth0's /userinfo endpoint)
	 * @param {Number} result.expiresIn number of seconds until the access token expires
	 * @param {String} [result.idToken] token that identifies the user
	 * @param {String} [result.refreshToken] token that can be used to get new access tokens from Auth0. Note that not all Auth0 Applications can request them or the resource server might not allow them.
	 */
	
	/**
	 * Makes a call to the `oauth/token` endpoint with `password` grant type to login to the default directory.
	 *
	 * @method loginWithDefaultDirectory
	 * @param {Object} options
	 * @param {String} options.username email or username of the user that will perform Auth
	 * @param {String} options.password the password of the user that will perform Auth
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @param {tokenCallback} cb function called with the result of the request
	 * @see Requires [`password` grant]{@link https://auth0.com/docs/api-auth/grant/password}. For more information, read {@link https://auth0.com/docs/clients/client-grant-types}.
	 */
	Authentication.prototype.loginWithDefaultDirectory = function(options, cb) {
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      username: { type: 'string', message: 'username option is required' },
	      password: { type: 'string', message: 'password option is required' },
	      scope: { optional: true, type: 'string', message: 'scope option is required' },
	      audience: { optional: true, type: 'string', message: 'audience option is required' }
	    }
	  );
	
	  options.grantType = 'password';
	
	  return this.oauthToken(options, cb);
	};
	
	/**
	 * Makes a call to the `oauth/token` endpoint with `password-realm` grant type
	 *
	 * @method login
	 * @param {Object} options
	 * @param {String} options.username email or username of the user that will perform Auth
	 * @param {String} options.password the password of the user that will perform Auth
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @param {Object} options.realm the HRD domain or the connection name where the user belongs to. e.g. `Username-Password-Authentication`
	 * @param {tokenCallback} cb function called with the result of the request
	 * @see Requires [`http://auth0.com/oauth/grant-type/password-realm` grant]{@link https://auth0.com/docs/api-auth/grant/password#realm-support}. For more information, read {@link https://auth0.com/docs/clients/client-grant-types}.
	 */
	Authentication.prototype.login = function(options, cb) {
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      username: { type: 'string', message: 'username option is required' },
	      password: { type: 'string', message: 'password option is required' },
	      realm: { type: 'string', message: 'realm option is required' },
	      scope: { optional: true, type: 'string', message: 'scope option is required' },
	      audience: { optional: true, type: 'string', message: 'audience option is required' }
	    }
	  );
	
	  options.grantType = 'http://auth0.com/oauth/grant-type/password-realm';
	
	  return this.oauthToken(options, cb);
	};
	
	/**
	 * Makes a call to the `oauth/token` endpoint
	 *
	 * @method oauthToken
	 * @private
	 */
	Authentication.prototype.oauthToken = function(options, cb) {
	  var url;
	  var body;
	
	  assert.check(options, { type: 'object', message: 'options parameter is not valid' });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'oauth', 'token');
	
	  body = objectHelper.merge(this.baseOptions, ['clientID', 'scope', 'audience']).with(options);
	
	  assert.check(
	    body,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      clientID: { type: 'string', message: 'clientID option is required' },
	      grantType: { type: 'string', message: 'grantType option is required' },
	      scope: { optional: true, type: 'string', message: 'scope option is required' },
	      audience: { optional: true, type: 'string', message: 'audience option is required' }
	    }
	  );
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client']);
	  body = parametersWhitelist.oauthTokenParams(this.warn, body);
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	/**
	 * Performs authentication calling `/oauth/ro` endpoint with username
	 * and password for a given connection name.
	 *
	 * This method is not compatible with API Auth so if you need to fetch API tokens with audience
	 * you should use {@link login} or {@link loginWithDefaultDirectory}.
	 *
	 * @method loginWithResourceOwner
	 * @param {Object} options
	 * @param {String} options.username email or username of the user that will perform Auth
	 * @param {String} options.password the password of the user that will perform Auth
	 * @param {Object} options.connection the connection name where the user belongs to. e.g. `Username-Password-Authentication`
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.device] name of the device/browser where the Auth was requested
	 * @param {tokenCallback} cb function called with the result of the request
	 */
	Authentication.prototype.loginWithResourceOwner = function(options, cb) {
	  var url;
	  var body;
	
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      username: { type: 'string', message: 'username option is required' },
	      password: { type: 'string', message: 'password option is required' },
	      connection: { type: 'string', message: 'connection option is required' },
	      scope: { optional: true, type: 'string', message: 'scope option is required' }
	    }
	  );
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'oauth', 'ro');
	
	  body = objectHelper
	    .merge(this.baseOptions, ['clientID', 'scope'])
	    .with(options, ['username', 'password', 'scope', 'connection', 'device']);
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client']);
	
	  body.grant_type = body.grant_type || 'password';
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	/**
	 * Uses {@link checkSession} and localStorage to return data from the last successful authentication request.
	 *
	 * @method getSSOData
	 * @param {Boolean} withActiveDirectories this parameter is not used anymore. It's here to be backward compatible
	 * @param {Function} cb
	 */
	Authentication.prototype.getSSOData = function(withActiveDirectories, cb) {
	  /* istanbul ignore if  */
	  if (!this.auth0) {
	    // we can't import this in the constructor because it'd be a ciclic dependency
	    var WebAuth = __webpack_require__(852); // eslint-disable-line
	    this.auth0 = new WebAuth(this.baseOptions);
	  }
	  var isHostedLoginPage = windowHelper.getWindow().location.host === this.baseOptions.domain;
	  if (isHostedLoginPage) {
	    return this.auth0._universalLogin.getSSOData(withActiveDirectories, cb);
	  }
	  if (typeof withActiveDirectories === 'function') {
	    cb = withActiveDirectories;
	  }
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	  var clientId = this.baseOptions.clientID;
	  var ssodataInformation = ssodata.get() || {};
	
	  this.auth0.checkSession(
	    {
	      responseType: 'token id_token',
	      scope: 'openid profile email',
	      connection: ssodataInformation.lastUsedConnection,
	      timeout: 5000
	    },
	    function(err, result) {
	      if (err) {
	        if (err.error === 'login_required') {
	          return cb(null, { sso: false });
	        }
	        if (err.error === 'consent_required') {
	          err.error_description =
	            'Consent required. When using `getSSOData`, the user has to be authenticated with the following scope: `openid profile email`.';
	        }
	        return cb(err, { sso: false });
	      }
	      if (
	        ssodataInformation.lastUsedSub &&
	        ssodataInformation.lastUsedSub !== result.idTokenPayload.sub
	      ) {
	        return cb(err, { sso: false });
	      }
	      return cb(null, {
	        lastUsedConnection: {
	          name: ssodataInformation.lastUsedConnection
	        },
	        lastUsedUserID: result.idTokenPayload.sub,
	        lastUsedUsername: result.idTokenPayload.email || result.idTokenPayload.name,
	        lastUsedClientID: clientId,
	        sessionClients: [clientId],
	        sso: true
	      });
	    }
	  );
	};
	
	/**
	 * @callback userInfoCallback
	 * @param {Error} [err] error returned by Auth0
	 * @param {Object} [userInfo] user information
	 */
	
	/**
	 * Makes a call to the `/userinfo` endpoint and returns the user profile
	 *
	 * @method userInfo
	 * @param {String} accessToken token issued to a user after Auth
	 * @param {userInfoCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#get-user-info}
	 */
	Authentication.prototype.userInfo = function(accessToken, cb) {
	  var url;
	
	  assert.check(accessToken, { type: 'string', message: 'accessToken parameter is not valid' });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'userinfo');
	
	  return this.request
	    .get(url)
	    .set('Authorization', 'Bearer ' + accessToken)
	    .end(responseHandler(cb, { ignoreCasing: true }));
	};
	
	/**
	 * @callback delegationCallback
	 * @param {Error} [err] error returned by Auth0 with the reason why the delegation failed
	 * @param {Object} [result] result of the delegation request. The payload depends on what ai type was used
	 */
	
	/**
	 * Makes a call to the `/delegation` endpoint with either an `id_token` or `refresh_token`
	 *
	 * @method delegation
	 * @param {Object} options
	  * @param {String} [options.clientID] the Client ID found on your Application settings page
	 * @param {String} options.grantType  grant type used for delegation. The only valid value is `urn:ietf:params:oauth:grant-type:jwt-bearer`
	 * @param {String} [options.idToken] valid token of the user issued after Auth. If no `refresh_token` is provided this parameter is required
	 * @param {String} [options.refreshToken] valid refresh token of the user issued after Auth. If no `id_token` is provided this parameter is required
	 * @param {String} [options.target] the target ClientID of the delegation
	 * @param {String} [options.scope] either `openid` or `openid profile email`
	 * @param {String} [options.apiType] the api to be called
	 * @param {delegationCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#delegation}
	 * @see Requires [http://auth0.com/oauth/grant-type/password-realm]{@link https://auth0.com/docs/api-auth/grant/password#realm-support}. For more information, read {@link https://auth0.com/docs/clients/client-grant-types}.
	 */
	Authentication.prototype.delegation = function(options, cb) {
	  var url;
	  var body;
	
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      grant_type: { type: 'string', message: 'grant_type option is required' }
	    }
	  );
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'delegation');
	
	  body = objectHelper.merge(this.baseOptions, ['clientID']).with(options);
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client']);
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	/**
	 * Fetches the user country based on the ip.
	 *
	 * @method getUserCountry
	 * @private
	 * @param {Function} cb
	 */
	Authentication.prototype.getUserCountry = function(cb) {
	  var url;
	
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'user', 'geoloc', 'country');
	
	  return this.request.get(url).end(responseHandler(cb));
	};
	
	module.exports = Authentication;


/***/ },
/* 848 */
/***/ function(module, exports) {

	function buildResponse(error, description) {
	  return {
	    error: error,
	    errorDescription: description
	  };
	}
	
	function invalidToken(description) {
	  return buildResponse('invalid_token', description);
	}
	
	module.exports = {
	  buildResponse: buildResponse,
	  invalidToken: invalidToken
	};


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	var windowHelper = __webpack_require__(101);
	
	function IframeHandler(options) {
	  this.url = options.url;
	  this.callback = options.callback;
	  this.timeout = options.timeout || 60 * 1000;
	  this.timeoutCallback = options.timeoutCallback || null;
	  this.eventListenerType = options.eventListenerType || 'message';
	  this.iframe = null;
	  this.timeoutHandle = null;
	  this._destroyTimeout = null;
	  this.transientMessageEventListener = null;
	  this.proxyEventListener = null;
	  // If no event identifier specified, set default
	  this.eventValidator = options.eventValidator || {
	    isValid: function() {
	      return true;
	    }
	  };
	
	  if (typeof this.callback !== 'function') {
	    throw new Error('options.callback must be a function');
	  }
	}
	
	IframeHandler.prototype.init = function() {
	  var _this = this;
	  var _window = windowHelper.getWindow();
	
	  this.iframe = _window.document.createElement('iframe');
	  this.iframe.style.display = 'none';
	
	  // Workaround to avoid using bind that does not work in IE8
	  this.proxyEventListener = function(e) {
	    _this.eventListener(e);
	  };
	
	  switch (this.eventListenerType) {
	    case 'message':
	      this.eventSourceObject = _window;
	      break;
	    case 'load':
	      this.eventSourceObject = this.iframe;
	      break;
	    default:
	      throw new Error('Unsupported event listener type: ' + this.eventListenerType);
	  }
	
	  this.eventSourceObject.addEventListener(this.eventListenerType, this.proxyEventListener, false);
	
	  _window.document.body.appendChild(this.iframe);
	  
	  this.iframe.src = this.url;
	  
	  this.timeoutHandle = setTimeout(function() {
	    _this.timeoutHandler();
	  }, this.timeout);
	};
	
	IframeHandler.prototype.eventListener = function(event) {
	  var eventData = { event: event, sourceObject: this.eventSourceObject };
	
	  if (!this.eventValidator.isValid(eventData)) {
	    return;
	  }
	
	  this.destroy();
	  this.callback(eventData);
	};
	
	IframeHandler.prototype.timeoutHandler = function() {
	  this.destroy();
	  if (this.timeoutCallback) {
	    this.timeoutCallback();
	  }
	};
	
	IframeHandler.prototype.destroy = function() {
	  var _this = this;
	  var _window = windowHelper.getWindow();
	
	  clearTimeout(this.timeoutHandle);
	
	  this._destroyTimeout = setTimeout(function() {
	    _this.eventSourceObject.removeEventListener(
	      _this.eventListenerType,
	      _this.proxyEventListener,
	      false
	    );
	    _window.document.body.removeChild(_this.iframe);
	  }, 0);
	};
	
	module.exports = IframeHandler;


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	var storage = __webpack_require__(531);
	
	module.exports = {
	  set: function(connection, sub) {
	    var ssodata = {
	      lastUsedConnection: connection,
	      lastUsedSub: sub
	    };
	    storage.setItem('auth0.ssodata', JSON.stringify(ssodata));
	  },
	  get: function() {
	    var ssodata = storage.getItem('auth0.ssodata');
	    if (!ssodata) {
	      return;
	    }
	    return JSON.parse(ssodata);
	  }
	};


/***/ },
/* 851 */
/***/ function(module, exports) {

	module.exports.MINUTES_15 = 1 / 96;
	module.exports.MINUTES_30 = 1 / 48;


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	var IdTokenVerifier = __webpack_require__(2933);
	
	var assert = __webpack_require__(166);
	var error = __webpack_require__(848);
	var qs = __webpack_require__(274);
	var PluginHandler = __webpack_require__(1840);
	var windowHelper = __webpack_require__(101);
	var objectHelper = __webpack_require__(85);
	var ssodata = __webpack_require__(850);
	var TransactionManager = __webpack_require__(534);
	var Authentication = __webpack_require__(847);
	var Redirect = __webpack_require__(1851);
	var Popup = __webpack_require__(1850);
	var SilentAuthenticationHandler = __webpack_require__(1852);
	var CrossOriginAuthentication = __webpack_require__(533);
	var WebMessageHandler = __webpack_require__(853);
	var HostedPages = __webpack_require__(1849);
	
	/**
	 * Handles all the browser's AuthN/AuthZ flows
	 * @constructor
	 * @param {Object} options
	 * @param {String} options.domain your Auth0 domain
	 * @param {String} options.clientID the Client ID found on your Application settings page
	 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} [options.responseType] type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. The `query` value is only supported when `responseType` is `code`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @param {Array} [options.plugins]
	 * @param {Number} [options._timesToRetryFailedRequests] Number of times to retry a failed request, according to {@link https://github.com/visionmedia/superagent/blob/master/lib/should-retry.js}
	 * @see {@link https://auth0.com/docs/api/authentication}
	 */
	function WebAuth(options) {
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      domain: { type: 'string', message: 'domain option is required' },
	      clientID: { type: 'string', message: 'clientID option is required' },
	      responseType: { optional: true, type: 'string', message: 'responseType is not valid' },
	      responseMode: { optional: true, type: 'string', message: 'responseMode is not valid' },
	      redirectUri: { optional: true, type: 'string', message: 'redirectUri is not valid' },
	      scope: { optional: true, type: 'string', message: 'scope is not valid' },
	      audience: { optional: true, type: 'string', message: 'audience is not valid' },
	      popupOrigin: { optional: true, type: 'string', message: 'popupOrigin is not valid' },
	      leeway: { optional: true, type: 'number', message: 'leeway is not valid' },
	      plugins: { optional: true, type: 'array', message: 'plugins is not valid' },
	      _disableDeprecationWarnings: {
	        optional: true,
	        type: 'boolean',
	        message: '_disableDeprecationWarnings option is not valid'
	      },
	      _sendTelemetry: {
	        optional: true,
	        type: 'boolean',
	        message: '_sendTelemetry option is not valid'
	      },
	      _telemetryInfo: {
	        optional: true,
	        type: 'object',
	        message: '_telemetryInfo option is not valid'
	      },
	      _timesToRetryFailedRequests: {
	        optional: true,
	        type: 'number',
	        message: '_timesToRetryFailedRequests option is not valid'
	      }
	    }
	  );
	
	  if (options.overrides) {
	    assert.check(
	      options.overrides,
	      { type: 'object', message: 'overrides option is not valid' },
	      {
	        __tenant: { optional: true, type: 'string', message: '__tenant option is required' },
	        __token_issuer: {
	          optional: true,
	          type: 'string',
	          message: '__token_issuer option is required'
	        },
	        __jwks_uri: { optional: true, type: 'string', message: '__jwks_uri is required' }
	      }
	    );
	  }
	  /* eslint-enable */
	
	  this.baseOptions = options;
	  this.baseOptions.plugins = new PluginHandler(this, this.baseOptions.plugins || []);
	
	  this.baseOptions._sendTelemetry = this.baseOptions._sendTelemetry === false
	    ? this.baseOptions._sendTelemetry
	    : true;
	
	  this.baseOptions._timesToRetryFailedRequests = options._timesToRetryFailedRequests
	    ? parseInt(options._timesToRetryFailedRequests, 0)
	    : 0;
	
	  this.baseOptions.tenant =
	    (this.baseOptions.overrides && this.baseOptions.overrides.__tenant) ||
	    this.baseOptions.domain.split('.')[0];
	
	  this.baseOptions.token_issuer =
	    (this.baseOptions.overrides && this.baseOptions.overrides.__token_issuer) ||
	    'https://' + this.baseOptions.domain + '/';
	
	  this.baseOptions.jwksURI = this.baseOptions.overrides && this.baseOptions.overrides.__jwks_uri;
	
	  this.transactionManager = new TransactionManager(this.baseOptions.transaction);
	
	  this.client = new Authentication(this.baseOptions);
	  this.redirect = new Redirect(this, this.baseOptions);
	  this.popup = new Popup(this, this.baseOptions);
	  this.crossOriginAuthentication = new CrossOriginAuthentication(this, this.baseOptions);
	  this.webMessageHandler = new WebMessageHandler(this);
	  this._universalLogin = new HostedPages(this, this.baseOptions);
	}
	
	/**
	 * Parse the url hash and extract the Auth response from a Auth flow started with {@link authorize}
	 *
	 * Only validates id_tokens signed by Auth0 using the RS256 algorithm using the public key exposed
	 * by the `/.well-known/jwks.json` endpoint of your account.
	 * Tokens signed with the HS256 algorithm cannot be properly validated.
	 * Instead, a call to {@link userInfo} will be made with the parsed `access_token`.
	 * If the {@link userInfo} call fails, the {@link userInfo} error will be passed to the callback.
	 * Tokens signed with other algorithms will not be accepted.
	 *
	 * @method parseHash
	 * @param {Object} options
	 * @param {String} options.hash the url hash. If not provided it will extract from window.location.hash
	 * @param {String} [options.state] value originally sent in `state` parameter to {@link authorize} to mitigate XSRF
	 * @param {String} [options.nonce] value originally sent in `nonce` parameter to {@link authorize} to prevent replay attacks
	 * @param {String} [options.responseType] type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `token`, `id_token`. For this specific method, we'll only use this value to check if the hash contains the tokens requested in the responseType.
	 * @param {authorizeCallback} cb
	 */
	WebAuth.prototype.parseHash = function(options, cb) {
	  var parsedQs;
	  var err;
	
	  if (!cb && typeof options === 'function') {
	    cb = options;
	    options = {};
	  } else {
	    options = options || {};
	  }
	
	  var _window = windowHelper.getWindow();
	
	  var hashStr = options.hash === undefined ? _window.location.hash : options.hash;
	  hashStr = hashStr.replace(/^#?\/?/, '');
	
	  parsedQs = qs.parse(hashStr);
	
	  if (parsedQs.hasOwnProperty('error')) {
	    err = error.buildResponse(parsedQs.error, parsedQs.error_description);
	
	    if (parsedQs.state) {
	      err.state = parsedQs.state;
	    }
	
	    return cb(err);
	  }
	
	  if (
	    !parsedQs.hasOwnProperty('access_token') &&
	    !parsedQs.hasOwnProperty('id_token') &&
	    !parsedQs.hasOwnProperty('refresh_token')
	  ) {
	    return cb(null, null);
	  }
	  var responseTypes = (this.baseOptions.responseType || options.responseType || '').split(' ');
	  if (
	    responseTypes.length > 0 &&
	    responseTypes.indexOf('token') !== -1 &&
	    !parsedQs.hasOwnProperty('access_token')
	  ) {
	    return cb(
	      error.buildResponse(
	        'invalid_hash',
	        'response_type contains `token`, but the parsed hash does not contain an `access_token` property'
	      )
	    );
	  }
	  if (
	    responseTypes.length > 0 &&
	    responseTypes.indexOf('id_token') !== -1 &&
	    !parsedQs.hasOwnProperty('id_token')
	  ) {
	    return cb(
	      error.buildResponse(
	        'invalid_hash',
	        'response_type contains `id_token`, but the parsed hash does not contain an `id_token` property'
	      )
	    );
	  }
	  return this.validateAuthenticationResponse(options, parsedQs, cb);
	};
	
	/**
	 * Validates an Auth response from a Auth flow started with {@link authorize}
	 *
	 * Only validates id_tokens signed by Auth0 using the RS256 algorithm using the public key exposed
	 * by the `/.well-known/jwks.json` endpoint of your account.
	 * Tokens signed with the HS256 algorithm cannot be properly validated.
	 * Instead, a call to {@link userInfo} will be made with the parsed `access_token`.
	 * If the {@link userInfo} call fails, the {@link userInfo} error will be passed to the callback.
	 * Tokens signed with other algorithms will not be accepted.
	 *
	 * @method validateAuthenticationResponse
	 * @param {Object} options
	 * @param {String} options.hash the url hash. If not provided it will extract from window.location.hash
	 * @param {String} [options.state] value originally sent in `state` parameter to {@link authorize} to mitigate XSRF
	 * @param {String} [options.nonce] value originally sent in `nonce` parameter to {@link authorize} to prevent replay attacks
	 * @param {authorizeCallback} cb
	 */
	WebAuth.prototype.validateAuthenticationResponse = function(options, parsedHash, cb) {
	  var _this = this;
	  options.__enableIdPInitiatedLogin =
	    options.__enableIdPInitiatedLogin || options.__enableImpersonation;
	  var state = parsedHash.state;
	  var transaction = this.transactionManager.getStoredTransaction(state);
	  var transactionState = options.state || (transaction && transaction.state) || null;
	
	  var transactionStateMatchesState = transactionState === state;
	  var shouldBypassStateChecking = !state && !transactionState && options.__enableIdPInitiatedLogin;
	
	  if (!shouldBypassStateChecking && !transactionStateMatchesState) {
	    return cb({
	      error: 'invalid_token',
	      errorDescription: '`state` does not match.'
	    });
	  }
	  var transactionNonce = options.nonce || (transaction && transaction.nonce) || null;
	
	  var appState = options.state || (transaction && transaction.appState) || null;
	
	  var callback = function(err, payload) {
	    if (err) {
	      return cb(err);
	    }
	    if (transaction && transaction.lastUsedConnection) {
	      var sub;
	      if (payload) {
	        sub = payload.sub;
	      }
	      ssodata.set(transaction.lastUsedConnection, sub);
	    }
	    return cb(null, buildParseHashResponse(parsedHash, appState, payload));
	  };
	
	  if (!parsedHash.id_token) {
	    return callback(null, null);
	  }
	  return this.validateToken(parsedHash.id_token, transactionNonce, function(
	    validationError,
	    payload
	  ) {
	    if (!validationError) {
	      if (!parsedHash.access_token) {
	        return callback(null, payload);
	      }
	      // id_token's generated by non-oidc applications don't have at_hash
	      if (!payload.at_hash) {
	        return callback(null, payload);
	      }
	      // here we're absolutely sure that the id_token's alg is RS256
	      // and that the id_token is valid, so we can check the access_token
	      return new IdTokenVerifier().validateAccessToken(
	        parsedHash.access_token,
	        'RS256',
	        payload.at_hash,
	        function(err) {
	          if (err) {
	            return callback(error.invalidToken(err.message));
	          }
	          return callback(null, payload);
	        }
	      );
	    }
	    if (validationError.error !== 'invalid_token') {
	      return callback(validationError);
	    }
	    // if it's an invalid_token error, decode the token
	    var decodedToken = new IdTokenVerifier().decode(parsedHash.id_token);
	    // if the alg is not HS256, return the raw error
	    if (decodedToken.header.alg !== 'HS256') {
	      return callback(validationError);
	    }
	    if (!parsedHash.access_token) {
	      var noAccessTokenError = {
	        error: 'invalid_token',
	        description: 'The id_token cannot be validated because it was signed with the HS256 algorithm and public clients (like a browser) can’t store secrets. Please read the associated doc for possible ways to fix this. Read more: https://auth0.com/docs/errors/libraries/auth0-js/invalid-token#parsing-an-hs256-signed-id-token-without-an-access-token'
	      };
	      return callback(noAccessTokenError);
	    }
	    // if the alg is HS256, use the /userinfo endpoint to build the payload
	    return _this.client.userInfo(parsedHash.access_token, function(errUserInfo, profile) {
	      // if the /userinfo request fails, use the validationError instead
	      if (errUserInfo) {
	        return callback(errUserInfo);
	      }
	      return callback(null, profile);
	    });
	  });
	};
	
	function buildParseHashResponse(qsParams, appState, token) {
	  return {
	    accessToken: qsParams.access_token || null,
	    idToken: qsParams.id_token || null,
	    idTokenPayload: token || null,
	    appState: appState || null,
	    refreshToken: qsParams.refresh_token || null,
	    state: qsParams.state || null,
	    expiresIn: qsParams.expires_in ? parseInt(qsParams.expires_in, 10) : null,
	    tokenType: qsParams.token_type || null,
	    scope: qsParams.scope || null
	  };
	}
	
	/**
	 * @callback validateTokenCallback
	 * @param {Error} [err] error returned by while validating the token
	 * @param {Object} [payload] claims stored in the token
	 */
	
	/**
	 * Decodes the a JWT and verifies its nonce value
	 *
	 * @method validateToken
	 * @private
	 * @param {String} token
	 * @param {String} nonce
	 * @param {validateTokenCallback} cb
	 */
	WebAuth.prototype.validateToken = function(token, nonce, cb) {
	  var verifier = new IdTokenVerifier({
	    issuer: this.baseOptions.token_issuer,
	    jwksURI: this.baseOptions.jwksURI,
	    audience: this.baseOptions.clientID,
	    leeway: this.baseOptions.leeway || 0,
	    __disableExpirationCheck: this.baseOptions.__disableExpirationCheck
	  });
	
	  verifier.verify(token, nonce, function(err, payload) {
	    if (err) {
	      return cb(error.invalidToken(err.message));
	    }
	
	    cb(null, payload);
	  });
	};
	
	/**
	 * Executes a silent authentication transaction under the hood in order to fetch a new tokens for the current session.
	 * This method requires that all Auth is performed with {@link authorize}
	 * Watch out! If you're not using the hosted login page to do social logins, you have to use your own [social connection keys](https://manage.auth0.com/#/connections/social). If you use Auth0's dev keys, you'll always get `login_required` as an error when calling this method.
	 *
	 * @method renewAuth
	 * @param {Object} options
	 * @param {String} [options.domain] your Auth0 domain
	 * @param {String} [options.clientID] the Client ID found on your Application settings page
	 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} [options.responseType] type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. The `query` value is only supported when `responseType` is `code`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
	 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
	 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @param {String} [options.postMessageDataType] identifier data type to look for in postMessage event data, where events are initiated from silent callback urls, before accepting a message event is the event expected. A value of false means any postMessage event will trigger a callback.
	 * @param {String} [options.postMessageOrigin] origin of redirectUri to expect postMessage response from.  Defaults to the origin of the receiving window. Only used if usePostMessage is truthy.
	 * @param {String} [options.timeout] value in milliseconds used to timeout when the `/authorize` call is failing as part of the silent authentication with postmessage enabled due to a configuration.
	 * @param {Boolean} [options.usePostMessage] use postMessage to comunicate between the silent callback and the SPA. When false the SDK will attempt to parse the url hash should ignore the url hash and no extra behaviour is needed
	 * @param {authorizeCallback} cb
	 * @see {@link https://auth0.com/docs/api/authentication#authorize-client}
	 */
	WebAuth.prototype.renewAuth = function(options, cb) {
	  var handler;
	  var usePostMessage = !!options.usePostMessage;
	  var postMessageDataType = options.postMessageDataType || false;
	  var postMessageOrigin = options.postMessageOrigin || windowHelper.getWindow().origin;
	  var timeout = options.timeout;
	  var _this = this;
	
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'redirectUri',
	      'responseType',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options);
	
	  params.responseType = params.responseType || 'token';
	  params.responseMode = params.responseMode || 'fragment';
	  params = this.transactionManager.process(params);
	
	  assert.check(params, { type: 'object', message: 'options parameter is not valid' });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  params.prompt = 'none';
	
	  params = objectHelper.blacklist(params, [
	    'usePostMessage',
	    'tenant',
	    'postMessageDataType',
	    'postMessageOrigin'
	  ]);
	
	  handler = SilentAuthenticationHandler.create({
	    authenticationUrl: this.client.buildAuthorizeUrl(params),
	    postMessageDataType: postMessageDataType,
	    postMessageOrigin: postMessageOrigin,
	    timeout: timeout
	  });
	
	  handler.login(usePostMessage, function(err, hash) {
	    if (typeof hash === 'object') {
	      // hash was already parsed, so we just return it.
	      // it's here to be backwards compatible and should be removed in the next major version.
	      return cb(err, hash);
	    }
	    _this.parseHash({ hash: hash }, cb);
	  });
	};
	
	/**
	 * Renews an existing session on Auth0's servers using `response_mode=web_message`
	 *
	 * @method checkSession
	 * @param {Object} options
	 * @param {String} [options.domain] your Auth0 domain
	 * @param {String} [options.clientID] the Client ID found on your Application settings page
	 * @param {String} [options.responseType] type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
	 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @param {String} [options.timeout] value in milliseconds used to timeout when the `/authorize` call is failing as part of the silent authentication with postmessage enabled due to a configuration.
	 */
	WebAuth.prototype.checkSession = function(options, cb) {
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'responseType',
	      'redirectUri',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options);
	
	  if (params.responseType === 'code') {
	    return cb({ error: 'error', error_description: "responseType can't be `code`" });
	  }
	
	  if (!options.nonce) {
	    params = this.transactionManager.process(params);
	  }
	
	  assert.check(params, { type: 'object', message: 'options parameter is not valid' });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  params = objectHelper.blacklist(params, ['usePostMessage', 'tenant', 'postMessageDataType']);
	  this.webMessageHandler.run(params, cb);
	};
	
	/**
	 * Request an email with instruction to change a user's password
	 *
	 * @method changePassword
	 * @param {Object} options
	 * @param {String} options.email address where the user will receive the change password email. It should match the user's email in Auth0
	 * @param {String} options.connection name of the connection where the user was created
	 * @param {changePasswordCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#change-password}
	 */
	WebAuth.prototype.changePassword = function(options, cb) {
	  return this.client.dbConnection.changePassword(options, cb);
	};
	
	/**
	 * Starts a passwordless authentication transaction.
	 *
	 * @method passwordlessStart
	 * @param {Object} options
	 * @param {String} options.send what will be sent via email which could be `link` or `code`. For SMS `code` is the only one valud
	 * @param {String} [options.phoneNumber] phone number where to send the `code`. This parameter is mutually exclusive with `email`
	 * @param {String} [options.email] email where to send the `code` or `link`. This parameter is mutually exclusive with `phoneNumber`
	 * @param {String} options.connection name of the passwordless connection
	 * @param {Object} [options.authParams] additional Auth parameters when using `link`
	 * @param {Function} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#passwordless}
	 */
	WebAuth.prototype.passwordlessStart = function(options, cb) {
	  var authParams = objectHelper
	    .merge(this.baseOptions, [
	      'responseType',
	      'responseMode',
	      'redirectUri',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options.authParams);
	
	  options.authParams = this.transactionManager.process(authParams);
	  return this.client.passwordless.start(options, cb);
	};
	
	/**
	 * Creates a new user in a Auth0 Database connection
	 *
	 * @method signup
	 * @param {Object} options
	 * @param {String} options.email user email address
	 * @param {String} options.password user password
	 * @param {String} options.connection name of the connection where the user will be created
	 * @param {signUpCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#signup}
	 */
	WebAuth.prototype.signup = function(options, cb) {
	  return this.client.dbConnection.signup(options, cb);
	};
	
	/**
	 * Redirects to the hosted login page (`/authorize`) in order to start a new authN/authZ transaction.
	 * After that, you'll have to use the {@link parseHash} function at the specified `redirectUri`.
	 *
	 * @method authorize
	 * @param {Object} options
	 * @param {String} [options.domain] your Auth0 domain
	 * @param {String} [options.clientID] the Client ID found on your Application settings page
	 * @param {String} options.redirectUri url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} options.responseType type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. The `query` value is only supported when `responseType` is `code`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
	 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
	 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @see {@link https://auth0.com/docs/api/authentication#authorize-client}
	 */
	WebAuth.prototype.authorize = function(options) {
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'responseType',
	      'responseMode',
	      'redirectUri',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options);
	
	  assert.check(
	    params,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      responseType: { type: 'string', message: 'responseType option is required' }
	    }
	  );
	
	  params = this.transactionManager.process(params);
	  params.scope = params.scope || 'openid profile email';
	
	  windowHelper.redirect(this.client.buildAuthorizeUrl(params));
	};
	
	/**
	 * Signs up a new user, automatically logs the user in after the signup and returns the user token.
	 * The login will be done using /oauth/token with password-realm grant type.
	 *
	 * @method signupAndAuthorize
	 * @param {Object} options
	 * @param {String} options.email user email address
	 * @param {String} options.password user password
	 * @param {String} options.connection name of the connection where the user will be created
	 * @param {tokenCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#signup}
	 * @see   {@link https://auth0.com/docs/api-auth/grant/password}
	 */
	WebAuth.prototype.signupAndAuthorize = function(options, cb) {
	  var _this = this;
	
	  return this.client.dbConnection.signup(
	    objectHelper.blacklist(options, ['popupHandler']),
	    function(err) {
	      if (err) {
	        return cb(err);
	      }
	      options.realm = options.connection;
	      if (!options.username) {
	        options.username = options.email;
	      }
	      _this.client.login(options, cb);
	    }
	  );
	};
	
	/**
	 * @callback crossOriginLoginCallback
	 * @param {Error} [err] Authentication error returned by Auth0 with the reason why the request failed
	 */
	
	/**
	 * Logs in the user with username and password using the cross origin authentication (/co/authenticate) flow. You can use either `username` or `email` to identify the user, but `username` will take precedence over `email`.
	 * Some browsers might not be able to successfully authenticate if 3rd party cookies are disabled in your browser. [See here for more information.]{@link https://auth0.com/docs/cross-origin-authentication}.
	 * After the /co/authenticate call, you'll have to use the {@link parseHash} function at the `redirectUri` specified in the constructor.
	 * 
	 * @method login
	 * @see Requires [`Implicit` grant]{@link https://auth0.com/docs/api-auth/grant/implicit}. For more information, read {@link https://auth0.com/docs/clients/client-grant-types}.
	 * @param {Object} options options used in the {@link authorize} call after the login_ticket is acquired
	 * @param {String} [options.username] Username (mutually exclusive with email)
	 * @param {String} [options.email] Email (mutually exclusive with username)
	 * @param {String} options.password Password
	 * @param {String} [options.realm] Realm used to authenticate the user, it can be a realm name or a database connection name
	 * @param {crossOriginLoginCallback} cb Callback function called only when an authentication error, like invalid username or password, occurs. For other types of errors, there will be a redirect to the `redirectUri`.
	 */
	WebAuth.prototype.login = function(options, cb) {
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'responseType',
	      'redirectUri',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options);
	  params = this.transactionManager.process(params);
	
	  var isHostedLoginPage = windowHelper.getWindow().location.host === this.baseOptions.domain;
	  if (isHostedLoginPage) {
	    params.connection = params.realm;
	    delete params.realm;
	    this._universalLogin.login(params, cb);
	  } else {
	    this.crossOriginAuthentication.login(params, cb);
	  }
	};
	
	/**
	 * Logs in the user by verifying the verification code (OTP) using the cross origin authentication (/co/authenticate) flow. You can use either `phoneNumber` or `email` to identify the user.
	 * This only works when 3rd party cookies are enabled in the browser. After the /co/authenticate call, you'll have to use the {@link parseHash} function at the `redirectUri` specified in the constructor.
	 *
	 * @method login
	 * @param {Object} options options used in the {@link authorize} call after the login_ticket is acquired
	 * @param {String} [options.phoneNumber] Phone Number (mutually exclusive with email)
	 * @param {String} [options.email] Email (mutually exclusive with username)
	 * @param {String} options.verificationCode Verification Code (OTP)
	 * @param {String} options.connection Passwordless connection to use. It can either be 'sms' or 'email'.
	 * @param {crossOriginLoginCallback} cb Callback function called only when an authentication error, like invalid username or password, occurs. For other types of errors, there will be a redirect to the `redirectUri`.
	 */
	WebAuth.prototype.passwordlessLogin = function(options, cb) {
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'responseType',
	      'redirectUri',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options);
	  params = this.transactionManager.process(params);
	
	  var isHostedLoginPage = windowHelper.getWindow().location.host === this.baseOptions.domain;
	  if (isHostedLoginPage) {
	    this.passwordlessVerify(params, cb);
	  } else {
	    var crossOriginOptions = objectHelper.extend(
	      {
	        credentialType: 'http://auth0.com/oauth/grant-type/passwordless/otp',
	        realm: params.connection,
	        username: params.email || params.phoneNumber,
	        otp: params.verificationCode
	      },
	      objectHelper.blacklist(params, ['connection', 'email', 'phoneNumber', 'verificationCode'])
	    );
	    this.crossOriginAuthentication.login(crossOriginOptions, cb);
	  }
	};
	
	/**
	 * Runs the callback code for the cross origin authentication call. This method is meant to be called by the cross origin authentication callback url.
	 *
	 * @method crossOriginAuthenticationCallback
	 * @deprecated Use {@link crossOriginVerification} instead.
	 */
	WebAuth.prototype.crossOriginAuthenticationCallback = function() {
	  this.crossOriginVerification();
	};
	
	/**
	 * Runs the callback code for the cross origin authentication call. This method is meant to be called by the cross origin authentication callback url.
	 *
	 * @method crossOriginVerification
	 */
	WebAuth.prototype.crossOriginVerification = function() {
	  this.crossOriginAuthentication.callback();
	};
	
	/**
	 * Redirects to the auth0 logout endpoint
	 *
	 * If you want to navigate the user to a specific URL after the logout, set that URL at the returnTo parameter. The URL should be included in any the appropriate Allowed Logout URLs list:
	 *
	 * - If the client_id parameter is included, the returnTo URL must be listed in the Allowed Logout URLs set at the Auth0 Application level (see Setting Allowed Logout URLs at the App Level).
	 * - If the client_id parameter is NOT included, the returnTo URL must be listed in the Allowed Logout URLs set at the account level (see Setting Allowed Logout URLs at the Account Level).
	 *
	 * @method logout
	 * @param {Object} options
	 * @param {String} [options.clientID] the Client ID found on your Application settings page
	 * @param {String} [options.returnTo] URL to be redirected after the logout
	 * @param {Boolean} [options.federated] tells Auth0 if it should logout the user also from the IdP.
	 * @see   {@link https://auth0.com/docs/api/authentication#logout}
	 */
	WebAuth.prototype.logout = function(options) {
	  windowHelper.redirect(this.client.buildLogoutUrl(options));
	};
	
	/**
	 * Verifies the passwordless TOTP and redirects to finish the passwordless transaction
	 *
	 * @method passwordlessVerify
	 * @param {Object} options
	 * @param {String} options.type `sms` or `email`
	 * @param {String} options.phoneNumber only if type = sms
	 * @param {String} options.email only if type = email
	 * @param {String} options.connection the connection name
	 * @param {String} options.verificationCode the TOTP code
	 * @param {Function} cb
	 */
	WebAuth.prototype.passwordlessVerify = function(options, cb) {
	  var _this = this;
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'responseType',
	      'responseMode',
	      'redirectUri',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options);
	
	  assert.check(
	    params,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      responseType: { type: 'string', message: 'responseType option is required' }
	    }
	  );
	
	  params = this.transactionManager.process(params);
	  return this.client.passwordless.verify(params, function(err) {
	    if (err) {
	      return cb(err);
	    }
	    return windowHelper.redirect(_this.client.passwordless.buildVerifyUrl(params));
	  });
	};
	
	module.exports = WebAuth;


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	var IframeHandler = __webpack_require__(849);
	var objectHelper = __webpack_require__(85);
	var windowHelper = __webpack_require__(101);
	var Warn = __webpack_require__(229);
	
	function runWebMessageFlow(authorizeUrl, options, callback) {
	  var handler = new IframeHandler({
	    url: authorizeUrl,
	    eventListenerType: 'message',
	    callback: function(eventData) {
	      callback(null, eventData);
	    },
	    timeout: options.timeout,
	    eventValidator: {
	      isValid: function(eventData) {
	        return (
	          eventData.event.data.type === 'authorization_response' &&
	          options.state === eventData.event.data.response.state
	        );
	      }
	    },
	    timeoutCallback: function() {
	      callback({
	        error: 'timeout',
	        error_description: 'Timeout during executing web_message communication',
	        state: options.state
	      });
	    }
	  });
	  handler.init();
	}
	
	function WebMessageHandler(webAuth) {
	  this.webAuth = webAuth;
	  this.warn = new Warn(webAuth.baseOptions);
	}
	
	WebMessageHandler.prototype.run = function(options, cb) {
	  var _this = this;
	  options.responseMode = 'web_message';
	  options.prompt = 'none';
	
	  var currentOrigin = windowHelper.getOrigin();
	  var redirectUriOrigin = objectHelper.getOriginFromUrl(options.redirectUri);
	  if (redirectUriOrigin && currentOrigin !== redirectUriOrigin) {
	    return cb({
	      error: 'origin_mismatch',
	      error_description: "The redirectUri's origin (" +
	        redirectUriOrigin +
	        ") should match the window's origin (" +
	        currentOrigin +
	        ').'
	    });
	  }
	
	  runWebMessageFlow(this.webAuth.client.buildAuthorizeUrl(options), options, function(
	    err,
	    eventData
	  ) {
	    var error = err;
	    if (!err && eventData.event.data.response.error) {
	      error = eventData.event.data.response;
	    }
	    if (!error) {
	      var parsedHash = eventData.event.data.response;
	      return _this.webAuth.validateAuthenticationResponse(options, parsedHash, cb);
	    }
	    if (
	      error.error === 'consent_required' &&
	      windowHelper.getWindow().location.hostname === 'localhost'
	    ) {
	      _this.warn.warning(
	        "Consent Required. Consent can't be skipped on localhost. Read more here: https://auth0.com/docs/api-auth/user-consent#skipping-consent-for-first-party-clients"
	      );
	    }
	    _this.webAuth.transactionManager.clearTransaction(error.state);
	    return cb(objectHelper.pick(error, ['error', 'error_description']));
	  });
	};
	
	module.exports = WebMessageHandler;


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(102);
	var settle = __webpack_require__(1860);
	var buildURL = __webpack_require__(1864);
	var parseHeaders = __webpack_require__(1870);
	var isURLSameOrigin = __webpack_require__(1868);
	var createError = __webpack_require__(855);
	var btoa = (typeof window !== 'undefined' && window.btoa) || __webpack_require__(1863);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      if (request.status === 0) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(1866);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(1859);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ },
/* 856 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0a');
	};
	
	var modalTableStyle = {
	  height: 430,
	  display: 'block',
	  overflowY: 'scroll'
	};
	
	var noResultsDivStyle = {
	  width: '100%',
	  height: 430,
	  textAlign: 'center',
	  paddingTop: 120,
	  color: 'gray'
	};
	
	// TODO: MOVE THIS TO A COMPONENT
	var InfluencerSearchTableRow = function InfluencerSearchTableRow(props) {
	  var influencer = props.lookupInfluencer,
	      influencers = props.influencers,
	      onInviteInfluencer = props.onInviteInfluencer;
	
	  var isAlreadyAMember = _lodash2.default.find(influencers, ['id', influencer.id]);
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { collapsing: true },
	      _react2.default.createElement(_semanticUiReact.Image, { src: influencer.thumbnail, avatar: true, size: 'mini' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      influencer.name
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      cf(influencer.facebookCount)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      cf(influencer.instagramCount)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      cf(influencer.twitterCount)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      cf(influencer.youtubeCount)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      influencer.email || 'No email'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Button, {
	        fluid: true,
	        disabled: isAlreadyAMember,
	        color: 'pink',
	        content: isAlreadyAMember ? 'Added' : 'Add',
	        onClick: function onClick() {
	          return onInviteInfluencer(influencer);
	        }
	      })
	    )
	  );
	};
	
	// TODO: MOVE THIS TO A COMPONENT
	var InfluencerSearchResultsTable = function InfluencerSearchResultsTable(props) {
	  var results = props.results,
	      influencers = props.influencers,
	      onInviteInfluencer = props.onInviteInfluencer;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { unstackable: true, fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Header,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { colSpan: 2 },
	          'Influencer'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { textAlign: 'center' },
	          _react2.default.createElement('img', { src: '/icons/facebook.svg', alt: 'Facebook' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { textAlign: 'center' },
	          _react2.default.createElement('img', { src: '/icons/instagram.svg', alt: 'Instagram' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { textAlign: 'center' },
	          _react2.default.createElement('img', { src: '/icons/twitter.svg', alt: 'Twitter' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { textAlign: 'center' },
	          _react2.default.createElement('img', { src: '/icons/youtube.svg', alt: 'YouTube' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { textAlign: 'center' },
	          'Email'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { textAlign: 'center', collapsing: true },
	          'Action'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _lodash2.default.map(results, function (result) {
	        return _react2.default.createElement(InfluencerSearchTableRow, Object.assign({}, result, {
	          influencers: influencers,
	          onInviteInfluencer: onInviteInfluencer
	        }));
	      })
	    )
	  );
	};
	
	var AddInfluencerModal = function AddInfluencerModal(props) {
	  var toggleHandler = props.toggleHandler,
	      isSearching = props.isSearching,
	      onInfluencerQueryChanged = props.onInfluencerQueryChanged,
	      results = props.results,
	      influencers = props.influencers,
	      onInviteInfluencer = props.onInviteInfluencer;
	
	
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      open: true,
	      headerText: 'Add an influencer',
	      onClose: toggleHandler
	    },
	    _react2.default.createElement(_semanticUiReact.Input, { loading: isSearching, onChange: onInfluencerQueryChanged, fluid: true, placeholder: 'Search my influencers...' }),
	    _react2.default.createElement(_semanticUiReact.Divider, null),
	    (!results || _lodash2.default.isEmpty(results)) && _react2.default.createElement(
	      'div',
	      { style: noResultsDivStyle },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'search', size: 'massive' }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Search influencers'
	      )
	    ),
	    results && !_lodash2.default.isEmpty(results) && _react2.default.createElement(
	      'div',
	      { style: modalTableStyle },
	      _react2.default.createElement(InfluencerSearchResultsTable, {
	        results: results,
	        influencers: influencers,
	        onInviteInfluencer: onInviteInfluencer
	      })
	    )
	  );
	};
	
	AddInfluencerModal.propTypes = {
	  toggleHandler: _propTypes2.default.func.isRequired,
	  onInfluencerQueryChanged: _propTypes2.default.func.isRequired,
	  onInviteInfluencer: _propTypes2.default.func.isRequired,
	  isSearching: _propTypes2.default.bool.isRequired,
	  results: _propTypes2.default.array.isRequired,
	  influencers: _propTypes2.default.array.isRequired
	};
	
	exports.default = AddInfluencerModal;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsTooltip = function AnalyticsTooltip(_ref) {
	  var content = _ref.content,
	      children = _ref.children,
	      name = _ref.name,
	      role = _ref.role,
	      email = _ref.email,
	      style = _ref.style;
	  return _react2.default.createElement(
	    "div",
	    { className: style },
	    children,
	    _react2.default.createElement(
	      "div",
	      { className: "tooltip" },
	      _react2.default.createElement(
	        "div",
	        { className: "tooltip-inner" },
	        _react2.default.createElement("div", { className: "arrow-outer" }),
	        _react2.default.createElement("div", { className: "arrow-inner" }),
	        _react2.default.createElement(
	          "div",
	          { className: "tooltip-content" },
	          _react2.default.createElement(
	            "p",
	            { className: "small" },
	            content
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = AnalyticsTooltip;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _withDyzioEventsData = __webpack_require__(284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Link = function Link(_ref) {
	  var href = _ref.href,
	      label = _ref.label;
	  return _react2.default.createElement(
	    'a',
	    {
	      target: '_blank',
	      rel: 'noopener noreferrer',
	      href: href
	    },
	    label
	  );
	};
	
	Link.propTypes = {
	  href: _propTypes2.default.string.isRequired,
	  label: _propTypes2.default.string.isRequired
	};
	
	var INFLUENCER_CREATED = _withDyzioEventsData.EVENT_TYPES.INFLUENCER_CREATED,
	    CAMPAIGN_CREATED = _withDyzioEventsData.EVENT_TYPES.CAMPAIGN_CREATED,
	    SHORTLIST_CREATED = _withDyzioEventsData.EVENT_TYPES.SHORTLIST_CREATED,
	    TRACKED_ASSED_CREATED = _withDyzioEventsData.EVENT_TYPES.TRACKED_ASSED_CREATED;
	
	
	var TableRowLink = function TableRowLink(_ref2) {
	  var eventName = _ref2.eventName,
	      messageData = _ref2.messageData;
	
	  var linkComponents = {};
	  linkComponents[INFLUENCER_CREATED] = _react2.default.createElement(Link, {
	    href: '/influencer/' + _lodash2.default.get(messageData, 'resource.id') + '/latest',
	    label: 'view influencer'
	  });
	  linkComponents[CAMPAIGN_CREATED] = _react2.default.createElement(Link, {
	    href: '/campaign/' + _lodash2.default.get(messageData, 'resource.id'),
	    label: 'view campaign'
	  });
	  linkComponents[SHORTLIST_CREATED] = _react2.default.createElement(Link, {
	    href: '/shortlists/' + _lodash2.default.get(messageData, 'resource.id'),
	    label: 'view shortlist'
	  });
	  linkComponents[TRACKED_ASSED_CREATED] = _react2.default.createElement(Link, {
	    href: _lodash2.default.get(messageData, 'resource.assetURL'),
	    label: _lodash2.default.get(messageData, 'resource.assetURL')
	  });
	  var component = linkComponents[eventName] || null;
	  return component;
	};
	
	var AuditLogTableRow = function AuditLogTableRow(_ref3) {
	  var createdDate = _ref3.createdDate,
	      createdBy = _ref3.createdBy,
	      messageData = _ref3.messageData,
	      eventName = _ref3.eventName,
	      message = _ref3.message;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _moment2.default)(createdDate).utc().format()
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      createdBy
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      message
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _lodash2.default.get(messageData, 'resource.campaignName', '-')
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(TableRowLink, {
	        messageData: messageData,
	        eventName: eventName
	      })
	    )
	  );
	};
	
	AuditLogTableRow.propTypes = {
	  createdDate: _propTypes2.default.string.isRequired,
	  createdBy: _propTypes2.default.string.isRequired,
	  messageData: _propTypes2.default.object.isRequired,
	  eventName: _propTypes2.default.oneOf([].concat(_toConsumableArray(_withDyzioEventsData.EVENT_TYPES))).isRequired,
	  message: _propTypes2.default.string.isRequired
	};
	
	AuditLogTableRow.defaultProps = {
	  message: '-'
	};
	
	exports.default = AuditLogTableRow;

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var boxStyle = {
	  paddingTop: 10,
	  paddingBottom: 10
	};
	
	var BasicHeader = function BasicHeader(_ref) {
	  var title = _ref.title;
	  return _react2.default.createElement(
	    'div',
	    { className: 'influencer-context-bar', style: boxStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      { style: boxStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        { columns: 'two' },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            title
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Grid.Column, null)
	      )
	    )
	  );
	};
	
	BasicHeader.propTypes = {
	  title: _propTypes2.default.string.isRequired
	};
	
	exports.default = BasicHeader;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _currencyInputInline = __webpack_require__(866);
	
	var _currencyInputInline2 = _interopRequireDefault(_currencyInputInline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BudgetReadonly = function BudgetReadonly(_ref) {
	  var budget = _ref.budget,
	      budgetStatus = _ref.budgetStatus,
	      mode = _ref.mode,
	      currency = _ref.currency;
	
	  var collab = mode === 'collaboration';
	  var budgetStyles = {
	    display: 'inline-block',
	    width: '60%'
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: budgetStyles },
	    collab && _react2.default.createElement(
	      'p',
	      { className: 'small light' },
	      'Agreed fee'
	    ),
	    _react2.default.createElement(_currencyInputInline2.default, {
	      id: 'budget',
	      name: 'budget',
	      currency: currency,
	      disabled: true,
	      value: budget,
	      placeholder: 0,
	      status: budgetStatus
	    })
	  );
	};
	
	BudgetReadonly.propTypes = {
	  budget: _propTypes2.default.number.isRequired,
	  budgetStatus: _propTypes2.default.string.isRequired,
	  mode: _propTypes2.default.string.isRequired,
	  currency: _propTypes2.default.string.isRequired
	};
	
	exports.default = BudgetReadonly;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BusinessUnitsSelector = function (_React$Component) {
	  _inherits(BusinessUnitsSelector, _React$Component);
	
	  //
	  function BusinessUnitsSelector(props) {
	    _classCallCheck(this, BusinessUnitsSelector);
	
	    var _this = _possibleConstructorReturn(this, (BusinessUnitsSelector.__proto__ || Object.getPrototypeOf(BusinessUnitsSelector)).call(this, props));
	
	    _this.state = {
	      options: [],
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(BusinessUnitsSelector, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _props, restClient, organisationId, onSelected, response, businessUnits, options;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props, restClient = _props.restClient, organisationId = _props.userInfo.organisationId, onSelected = _props.onSelected;
	                _context.next = 3;
	                return restClient.get('businessUnits?filter[organisation]=' + organisationId);
	
	              case 3:
	                response = _context.sent;
	                businessUnits = _lodash2.default.get(response, 'data.data', []);
	                options = _lodash2.default.map(businessUnits, function (businessUnit) {
	                  return {
	                    key: _lodash2.default.get(businessUnit, 'id'),
	                    value: _lodash2.default.get(businessUnit, 'id'),
	                    text: _lodash2.default.get(businessUnit, 'attributes.value'),
	                    onClick: function onClick() {
	                      return onSelected(_lodash2.default.get(businessUnit, 'id'), businessUnits);
	                    }
	                  };
	                });
	
	                this.setState({
	                  isLoading: false,
	                  options: options
	                });
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          selectedBusinessUnits = _props2.selectedBusinessUnits,
	          onUnselected = _props2.onUnselected;
	      var _state = this.state,
	          options = _state.options,
	          isLoading = _state.isLoading;
	
	      return _react2.default.createElement(_semanticUiReact.Dropdown, {
	        placeholder: 'Select business units and brands',
	        fluid: true,
	        loading: isLoading,
	        search: true,
	        selection: true,
	        multiple: true,
	        options: options,
	        value: selectedBusinessUnits,
	        onLabelClick: function onLabelClick(event, _ref2) {
	          var value = _ref2.value;
	          return onUnselected(value);
	        }
	      });
	    }
	  }]);
	
	  return BusinessUnitsSelector;
	}(_react2.default.Component);
	
	BusinessUnitsSelector.propTypes = {
	  onSelected: _propTypes2.default.func.isRequired,
	  onUnselected: _propTypes2.default.func.isRequired,
	  selectedBusinessUnits: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(BusinessUnitsSelector);

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _capitalize = __webpack_require__(575);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouter = __webpack_require__(37);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _campaignTypes = __webpack_require__(931);
	
	var _campaignTypes2 = _interopRequireDefault(_campaignTypes);
	
	var _countries = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fontSize13 = {
	  fontSize: 13
	};
	
	var labelStyle = {
	  width: '100%',
	  textAlign: 'center',
	  marginTop: '3px'
	};
	
	var STYLES = {
	  fontSizeLarge: {
	    fontSize: '100%'
	  },
	  fontSizeSmall: {
	    fontSize: '90%'
	  },
	  empty: {},
	  noPaddingBottom: {
	    padding: 10
	  },
	  noPadding: {
	    padding: 0
	  },
	  compactVertical: {
	    padding: '5px 14px'
	  },
	  noVerticalPadding: {
	    padding: '0px 14px'
	  },
	  displayBlock: {
	    display: 'block'
	  },
	  fontGreen: {
	    color: '#20c49e',
	    fontSize: '90%',
	    lineHeight: '12px'
	  },
	  fontGrey: {
	    color: 'grey',
	    fontSize: '90%',
	    lineHeight: '12px'
	  }
	};
	
	var getFriendlyRole = function getFriendlyRole(role) {
	  return _capitalize2.default.words(_lodash2.default.toLower(_lodash2.default.replace(role, '_', ' ')));
	};
	
	var smallText = {
	  fontSize: '90%',
	  lineHeight: '12px'
	};
	
	var handleClick = function handleClick(_ref) {
	  var router = _ref.router,
	      campaignType = _ref.campaignType,
	      campaignId = _ref.campaignId,
	      canLoadFast = _ref.canLoadFast;
	
	  var isACR = campaignType === 'ACR';
	
	  var campUrl = '/campaign/' + campaignId + '/collaborations' + (canLoadFast ? '?fast=true' : '');
	  var campaignUrl = isACR ? '/acr-campaign/' + campaignId : campUrl;
	  router.push(campaignUrl);
	};
	
	var tagLabelStyle = {
	  cursor: 'pointer',
	  width: 'min-content',
	  display: 'block'
	};
	
	var CampaignCard = function CampaignCard(props) {
	  var campaignId = props.campaignId,
	      campaignPermissionId = props.campaignPermissionId,
	      campaignName = props.campaignName,
	      campaignType = props.campaignType,
	      campaignCountry = props.campaignCountry,
	      campaignCreatedDate = props.campaignCreatedDate,
	      campaignCreatedBy = props.campaignCreatedBy,
	      influencersCount = props.influencersCount,
	      totalAssetsCount = props.totalAssetsCount,
	      teamMemberCount = props.teamMemberCount,
	      marketingCampaignsCount = props.marketingCampaignsCount,
	      campaignBaseTrackingUrl = props.campaignBaseTrackingUrl,
	      campaignBrand = props.campaignBrand,
	      campaignWorkflow = props.campaignWorkflow,
	      campaignCanLoadFast = props.campaignCanLoadFast,
	      router = props.router,
	      listType = props.listType,
	      onDelete = props.onDelete,
	      onArchive = props.onArchive,
	      onUnarchive = props.onUnarchive,
	      isUserSuperAdmin = props.isUserSuperAdmin;
	
	  var isActiveList = listType === 'ACTIVE';
	  var friendlyDate = (0, _moment2.default)(campaignCreatedDate).format('Do MMM');
	  var hasAssets = totalAssetsCount > 0;
	  var clf = influencersCount > 60 && campaignCanLoadFast;
	  var onClickListener = function onClickListener() {
	    return handleClick({ router: router, campaignType: campaignType, campaignId: campaignId, canLoadFast: clf });
	  };
	  var color = _campaignTypes2.default[campaignType].color;
	  var hasMCs = marketingCampaignsCount ? marketingCampaignsCount > 0 : false;
	  var hasGAIntegrated = !_lodash2.default.isEmpty(campaignBaseTrackingUrl);
	  var integrationsCount = _lodash2.default.add(marketingCampaignsCount || 0, hasGAIntegrated ? 1 : 0);
	  var hasCountry = !_lodash2.default.isNil(campaignCountry);
	
	  var getWorkflow = function getWorkflow(workflow) {
	    if (workflow === 'ABBLY_V1') return 'UK (global) Store';
	    if (workflow === 'ABBLY_V1_US') return 'US Store';
	    return workflow;
	  };
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { onClick: onClickListener, color: color },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 13 },
	              campaignName
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 3 },
	              _react2.default.createElement(
	                _semanticUiReact.Dropdown,
	                {
	                  icon: null,
	                  pointing: 'top right',
	                  floating: true,
	                  trigger: _react2.default.createElement(_semanticUiReact.Button, { icon: 'bars', color: 'pink', inverted: true, size: 'small' })
	                },
	                isActiveList ? _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Menu,
	                  { className: 'left' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Dropdown.Item,
	                    {
	                      disabled: isUserSuperAdmin,
	                      onClick: function onClick() {
	                        return onArchive(campaignPermissionId);
	                      }
	                    },
	                    'Archive'
	                  )
	                ) : _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Menu,
	                  { className: 'left' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Dropdown.Item,
	                    { onClick: function onClick() {
	                        return onUnarchive(campaignPermissionId);
	                      } },
	                    'Unarchive'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Dropdown.Item,
	                    { onClick: function onClick() {
	                        return onDelete(campaignPermissionId);
	                      } },
	                    'Delete'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Description,
	        null,
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very' },
	          campaignBrand && _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(_semanticUiReact.Label, { style: labelStyle, color: 'grey', basic: true, content: campaignBrand })
	          ),
	          campaignWorkflow && _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Label,
	              { style: labelStyle, color: 'blue', basic: true },
	              'Workflow',
	              _react2.default.createElement(
	                _semanticUiReact.Label.Detail,
	                null,
	                _lodash2.default.toUpper(getWorkflow(campaignWorkflow))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: hasCountry ? '14' : '16' },
	              _react2.default.createElement(_semanticUiReact.Label, { style: labelStyle, color: color, basic: true, content: _campaignTypes2.default[campaignType].name })
	            ),
	            hasCountry && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: '2', textAlign: 'center' },
	              _react2.default.createElement(_semanticUiReact.Popup, {
	                trigger: _react2.default.createElement(_semanticUiReact.Flag, {
	                  name: _lodash2.default.lowerCase(campaignCountry)
	                }),
	                content: (0, _countries.renderCountryName)(campaignCountry)
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Meta,
	        null,
	        'Created by ',
	        campaignCreatedBy,
	        ' on ',
	        friendlyDate
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: STYLES.compactVertical },
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very', singleLine: true, fixed: true },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            { style: smallText },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: { padding: 0, paddingRight: '5px' } },
	              _react2.default.createElement(_semanticUiReact.Popup, {
	                trigger: _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { basic: true, style: STYLES.displayBlock },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'user outline', color: 'pink' }),
	                  ' ',
	                  influencersCount
	                ),
	                content: 'Number of influencers added to this campaign'
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: { padding: 0, paddingRight: '5px' } },
	              _react2.default.createElement(_semanticUiReact.Popup, {
	                trigger: _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { basic: true, style: STYLES.displayBlock },
	                  _react2.default.createElement(_semanticUiReact.Icon, { color: 'green', name: 'file outline' }),
	                  ' ',
	                  totalAssetsCount
	                ),
	                content: 'Number of tracked assets on this campaign'
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: { padding: 0 } },
	              _react2.default.createElement(_semanticUiReact.Popup, {
	                trigger: _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { basic: true, style: STYLES.displayBlock },
	                    _react2.default.createElement(_semanticUiReact.Icon, {
	                      color: '' + (teamMemberCount === 1 ? 'orange' : 'green'),
	                      name: 'user outline'
	                    }),
	                    ' ',
	                    teamMemberCount
	                  ),
	                  content: teamMemberCount === 1 ? 'Only you can see this campaign. No-one else has been invited.' : teamMemberCount + ' people can see this campaign.'
	                })
	              })
	            ),
	            (hasMCs || hasGAIntegrated) && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_semanticUiReact.Popup, {
	                trigger: _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { basic: true, style: STYLES.displayBlock },
	                    _react2.default.createElement(_semanticUiReact.Icon, {
	                      color: 'blue',
	                      name: 'linkify'
	                    }),
	                    ' ',
	                    integrationsCount
	                  ),
	                  content: _react2.default.createElement(
	                    'div',
	                    null,
	                    hasMCs && _react2.default.createElement(
	                      'div',
	                      { style: fontSize13 },
	                      _react2.default.createElement(_semanticUiReact.Icon, { color: 'blue', name: 'facebook' }),
	                      'Facebook Ads Campaign'
	                    ),
	                    hasGAIntegrated && _react2.default.createElement(
	                      'div',
	                      { style: fontSize13 },
	                      _react2.default.createElement(_semanticUiReact.Icon, { color: 'red', name: 'google' }),
	                      'Google Analytics Campaign'
	                    )
	                  )
	                })
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	CampaignCard.propTypes = {
	  campaign: _propTypes2.default.object.isRequired,
	  campaignPermission: _propTypes2.default.object.isRequired,
	  router: _propTypes2.default.object.isRequired,
	  listType: _propTypes2.default.string.isRequired,
	  onDelete: _propTypes2.default.func.isRequired,
	  onArchive: _propTypes2.default.func.isRequired,
	  onUnarchive: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(CampaignCard);

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDatepicker = __webpack_require__(445);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _hashtagsInput = __webpack_require__(877);
	
	var _hashtagsInput2 = _interopRequireDefault(_hashtagsInput);
	
	var _currencies = __webpack_require__(128);
	
	var _hashtagsUtils = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currencyDropDownStyle = { marginTop: 8, marginBottom: 8 };
	var requiredLabelStyle = { color: 'red' };
	var RequiredLabel = function RequiredLabel() {
	  return _react2.default.createElement(
	    'span',
	    { style: requiredLabelStyle },
	    '*'
	  );
	};
	var isACR = function isACR(type) {
	  return type === 'ACR';
	};
	
	var CampaignForm = function CampaignForm(props) {
	  var name = props.name,
	      budget = props.budget,
	      campaignType = props.campaignType,
	      liveDate = props.liveDate,
	      hashtags = props.hashtags,
	      currency = props.currency,
	      endDate = props.endDate,
	      onInputChange = props.onInputChange,
	      onFormSubmit = props.onFormSubmit,
	      onCurrencyChange = props.onCurrencyChange,
	      onLiveDateChange = props.onLiveDateChange,
	      onEndDateChange = props.onEndDateChange;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Form,
	    { onSubmit: onFormSubmit },
	    _react2.default.createElement(
	      _semanticUiReact.Form.Field,
	      null,
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'campaign-name' },
	        'Campaign name',
	        _react2.default.createElement(RequiredLabel, null)
	      ),
	      _react2.default.createElement(_semanticUiReact.Form.Input, {
	        onChange: onInputChange,
	        placeholder: 'e.g. Sky Westworld',
	        name: 'name',
	        value: name
	      })
	    ),
	    !isACR(campaignType) && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Form.Field,
	        null,
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'campaign-currencies' },
	          'Currency'
	        ),
	        _react2.default.createElement(_semanticUiReact.Dropdown, {
	          fluid: true,
	          search: true,
	          style: currencyDropDownStyle,
	          onChange: onCurrencyChange,
	          value: currency || _currencies.CURRENCY_GBP,
	          name: 'currency',
	          options: _currencies.DYZIO_CURRENCIES
	        })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Form.Field,
	        null,
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'campaign-budget' },
	          'Total Budget',
	          _react2.default.createElement(RequiredLabel, null)
	        ),
	        _react2.default.createElement(_semanticUiReact.Form.Input, {
	          type: 'number',
	          onChange: onInputChange,
	          placeholder: 'e.g. \xA310,000',
	          name: 'budget',
	          value: budget
	        })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Form.Field,
	        null,
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'campaign-live-date' },
	          'Live Date'
	        ),
	        _react2.default.createElement(_reactDatepicker2.default, {
	          onChange: onLiveDateChange,
	          placeholderText: 'e.g. 01/05/2018',
	          selected: liveDate && liveDate.isValid() ? liveDate.utc() : null,
	          dateFormat: 'MMM Do YYYY'
	        })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Form.Field,
	        null,
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'campaign-end-date' },
	          'End Date'
	        ),
	        _react2.default.createElement(_reactDatepicker2.default, {
	          onChange: onEndDateChange,
	          placeholderText: 'e.g. 20/05/2018',
	          selected: endDate && endDate.isValid() ? endDate.utc() : null,
	          dateFormat: 'MMM Do YYYY'
	        })
	      ),
	      _react2.default.createElement(_hashtagsInput2.default, {
	        hashtags: (0, _hashtagsUtils.transformHashtagstIntoArray)(hashtags),
	        onValueChanged: onInputChange
	      })
	    )
	  );
	};
	
	CampaignForm.propTypes = {
	  name: _propTypes2.default.string,
	  budget: _propTypes2.default.number,
	  liveDate: _propTypes2.default.object,
	  hashtags: _propTypes2.default.string,
	  currency: _propTypes2.default.string,
	  endDate: _propTypes2.default.object,
	  onInputChange: _propTypes2.default.func.isRequired,
	  onFormSubmit: _propTypes2.default.func.isRequired,
	  onCurrencyChange: _propTypes2.default.func.isRequired,
	  onLiveDateChange: _propTypes2.default.func.isRequired,
	  onEndDateChange: _propTypes2.default.func.isRequired
	};
	
	exports.default = CampaignForm;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shouldRenderSocialTableColumn = undefined;
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConditionalTableElement = function ConditionalTableElement(_ref) {
	  var children = _ref.children,
	      shouldRender = _ref.shouldRender;
	
	  if (shouldRender) {
	    return children;
	  }
	  return null;
	};
	
	var shouldRenderSocialTableColumn = exports.shouldRenderSocialTableColumn = function shouldRenderSocialTableColumn(items, platform) {
	  return _lodash2.default.get(items, 'columns.' + platform + '.displayed', true);
	};
	
	exports.default = ConditionalTableElement;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumericInput = __webpack_require__(1533);
	
	var _reactNumericInput2 = _interopRequireDefault(_reactNumericInput);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _countryData = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CurrencyInputInline = function CurrencyInputInline(props) {
	  var currency = _lodash2.default.find(_countryData.currencies.all, ['code', props.currency]);
	  var icon = null;
	  switch (props.status) {
	    case 'PROPOSED':
	      icon = 'pending.svg';
	      break;
	    case 'APPROVED':
	      icon = 'complete.svg';
	      break;
	    case 'REJECTED':
	      icon = 'error-small.svg';
	      break;
	    default:
	      icon = null;
	      break;
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-field number status ' + (props.disabled && 'disabled') + ' ' + (props.editable && 'editable') },
	    _react2.default.createElement(_reactNumericInput2.default, {
	      value: props.value,
	      min: 0,
	      style: false,
	      max: 100000000,
	      id: props.id,
	      name: props.name,
	      disabled: !!props.disabled,
	      placeholder: props.placeholder,
	      onChange: props.onChange,
	      onFocus: props.onFocus
	    }),
	    _react2.default.createElement(
	      'p',
	      { className: 'field-symbol' },
	      currency.symbol
	    ),
	    props.status && props.status !== 'NONE' && _react2.default.createElement('img', { className: 'status-indicator', src: '/icons/' + icon, alt: 'budget indicator' })
	  );
	};
	
	CurrencyInputInline.propTypes = {
	  status: _propTypes2.default.string.isRequired,
	  id: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  disabled: _propTypes2.default.bool.isRequired,
	  placeholder: _propTypes2.default.string.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  onFocus: _propTypes2.default.func.isRequired,
	  editable: _propTypes2.default.bool.isRequired,
	  currency: _propTypes2.default.string
	};
	
	CurrencyInputInline.defaultProps = {
	  currency: 'GBP'
	};
	
	exports.default = CurrencyInputInline;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dataRequestWideCard = __webpack_require__(1929);
	
	var _dataRequestWideCard2 = _interopRequireDefault(_dataRequestWideCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataRequestsListing = function DataRequestsListing(_ref) {
	  var isLoading = _ref.isLoading,
	      isError = _ref.isError,
	      requests = _ref.requests,
	      isInfluencerMode = _ref.isInfluencerMode,
	      onRequestReviewButtonClick = _ref.onRequestReviewButtonClick,
	      onRequestAccepted = _ref.onRequestAccepted,
	      onRequestDeclined = _ref.onRequestDeclined;
	
	  var canRenderRequests = _lodash2.default.size(requests) > 0 && !isError && !isLoading;
	  return _react2.default.createElement(
	    _semanticUiReact.Card.Group,
	    { cardsPerRow: 'one' },
	    canRenderRequests && _lodash2.default.map(requests, function (request) {
	      return _react2.default.createElement(_dataRequestWideCard2.default, Object.assign({}, request, {
	        isInfluencerMode: isInfluencerMode,
	        onRequestReviewButtonClick: onRequestReviewButtonClick,
	        onRequestAccepted: onRequestAccepted,
	        onRequestDeclined: onRequestDeclined
	
	      }));
	    }),
	    !isLoading && isError && _react2.default.createElement(
	      _semanticUiReact.Card,
	      { fluid: true },
	      _react2.default.createElement(_semanticUiReact.Message, { fluid: true, error: true, content: 'Something went wrong. Please try again later.' })
	    ),
	    !isLoading && !isError && !canRenderRequests && _react2.default.createElement(
	      _semanticUiReact.Card,
	      { fluid: true },
	      _react2.default.createElement(_semanticUiReact.Message, { info: true, content: 'No requests yet.' })
	    ),
	    isLoading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading...' })
	  );
	};
	
	DataRequestsListing.propTypes = {
	  isLoading: _propTypes2.default.bool.isRequired,
	  isError: _propTypes2.default.bool.isRequired,
	  requests: _propTypes2.default.array.isRequired,
	  onRequestReviewButtonClick: _propTypes2.default.func,
	  onRequestAccepted: _propTypes2.default.func,
	  onRequestDeclined: _propTypes2.default.func,
	  isInfluencerMode: _propTypes2.default.bool
	};
	
	DataRequestsListing.defaultProps = {
	  isInfluencerMode: false,
	  onRequestReviewButtonClick: _lodash2.default.noop,
	  onRequestDeclined: _lodash2.default.noop,
	  onRequestAccepted: _lodash2.default.noop
	
	};
	
	exports.default = DataRequestsListing;

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shopifyUrl = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/mefitpro/shopify/discountcodes';
	
	var DiscountCodesSelector = function (_React$Component) {
	  _inherits(DiscountCodesSelector, _React$Component);
	
	  function DiscountCodesSelector(props) {
	    _classCallCheck(this, DiscountCodesSelector);
	
	    var _this = _possibleConstructorReturn(this, (DiscountCodesSelector.__proto__ || Object.getPrototypeOf(DiscountCodesSelector)).call(this, props));
	
	    _this.selectedDiscountCode = function (selectedDiscountCode) {
	      var onSelected = _this.props.onSelected;
	
	      onSelected(selectedDiscountCode);
	      _this.setState({ selectedDiscountCode: selectedDiscountCode });
	    };
	
	    _this.state = {
	      options: [],
	      selectedDiscountCode: '',
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(DiscountCodesSelector, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var response, discountcodes, options;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _axios2.default.get(shopifyUrl);
	
	              case 2:
	                response = _context.sent;
	
	                console.log('discount code', response);
	                discountcodes = _lodash2.default.get(response, 'data', []);
	                options = _lodash2.default.map(discountcodes, function (dc) {
	                  return {
	                    key: _lodash2.default.get(dc, 'code'),
	                    value: _lodash2.default.get(dc, 'code'),
	                    text: _lodash2.default.get(dc, 'code'),
	                    onClick: function onClick() {
	                      return _this2.selectedDiscountCode(_lodash2.default.get(dc, 'code'));
	                    }
	                  };
	                });
	
	                this.setState({
	                  isLoading: false,
	                  options: options
	                });
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      // const { onSelected } = this.props;
	      var _state = this.state,
	          options = _state.options,
	          isLoading = _state.isLoading,
	          selectedDiscountCode = _state.selectedDiscountCode;
	
	      return _react2.default.createElement(_semanticUiReact.Dropdown, {
	        text: 'Select Discount Codes',
	        fluid: true,
	        loading: isLoading,
	        search: true,
	        selection: true,
	        multiple: true,
	        options: options,
	        value: selectedDiscountCode
	      });
	    }
	  }]);
	
	  return DiscountCodesSelector;
	}(_react2.default.Component);
	
	DiscountCodesSelector.propTypes = {
	  onSelected: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(DiscountCodesSelector);

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  color: '#20c49e',
	  opacity: 1
	};
	
	var DuplicatedInfluencerError = function DuplicatedInfluencerError(_ref) {
	  var duplicateInfluencerPlatform = _ref.duplicateInfluencerPlatform,
	      platform = _ref.platform,
	      duplicateInfluencerLinkId = _ref.duplicateInfluencerLinkId,
	      duplicateInfluencerHandle = _ref.duplicateInfluencerHandle;
	
	  var shouldRender = _lodash2.default.eq(duplicateInfluencerPlatform, platform);
	  if (!shouldRender) return null;
	  return _react2.default.createElement(
	    _semanticUiReact.Label,
	    { basic: true, color: 'red', pointing: true },
	    'An influencer with this handle(',
	    duplicateInfluencerHandle,
	    ') already exists. Click ',
	    _react2.default.createElement(
	      _targetLink2.default,
	      { style: style, renderIf: true, href: '/influencer/' + duplicateInfluencerLinkId + '/statistics' },
	      'here'
	    ),
	    ' to view ',
	    'influencer\'s',
	    ' page.'
	  );
	};
	
	DuplicatedInfluencerError.propTypes = {
	  duplicateInfluencerPlatform: _propTypes2.default.string,
	  platform: _propTypes2.default.string,
	  duplicateInfluencerLinkId: _propTypes2.default.string,
	  duplicateInfluencerHandle: _propTypes2.default.string
	};
	
	DuplicatedInfluencerError.defaultProps = {
	  duplicateInfluencerPlatform: null,
	  platform: null,
	  duplicateInfluencerLinkId: null,
	  duplicateInfluencerHandle: null
	};
	
	exports.default = DuplicatedInfluencerError;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DyzioMessage = function (_Component) {
	  _inherits(DyzioMessage, _Component);
	
	  function DyzioMessage() {
	    _classCallCheck(this, DyzioMessage);
	
	    var _this = _possibleConstructorReturn(this, (DyzioMessage.__proto__ || Object.getPrototypeOf(DyzioMessage)).call(this));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(DyzioMessage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          reportMethod = _props.reportMethod,
	          reportMessage = _props.reportMessage,
	          reportMessageArgs = _props.reportMessageArgs;
	
	      reportMethod(reportMessage, reportMessageArgs);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_semanticUiReact.Message, this.props);
	    }
	  }]);
	
	  return DyzioMessage;
	}(_react.Component);
	
	DyzioMessage.defaultProps = {
	  reportMessageArgs: {}
	};
	
	DyzioMessage.propTypes = {
	  reportMethod: _propTypes2.default.func.isRequired,
	  reportMessage: _propTypes2.default.func.isRequired,
	  reportMessageArgs: _propTypes2.default.any
	};
	
	var DyzioWarningMessage = function DyzioWarningMessage(props) {
	  return _react2.default.createElement(DyzioMessage, Object.assign({
	    color: 'orange',
	    icon: 'warning',
	    warning: true,
	    reportMethod: props.reportMethod,
	    reportMessage: 'Test warning message'
	  }, props));
	};
	
	var DyzioErrorMessage = function DyzioErrorMessage(props) {
	  return _react2.default.createElement(DyzioMessage, Object.assign({
	    error: true,
	    reportMethod: props.reportMethod,
	    reportMessage: 'Test error message'
	  }, props));
	};
	
	DyzioWarningMessage.propTypes = {
	  reportMethod: _propTypes2.default.func
	};
	
	DyzioErrorMessage.propTypes = {
	  reportMethod: _propTypes2.default.func
	};
	
	DyzioErrorMessage.defaultProps = {
	  reportMethod: _errorHandlingService.reportError
	};
	
	DyzioWarningMessage.defaultProps = {
	  reportMethod: _errorHandlingService.reportWarning
	};
	
	module.exports = {
	  DyzioWarningMessage: DyzioWarningMessage,
	  DyzioErrorMessage: DyzioErrorMessage
	};

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _modal = __webpack_require__(103);
	
	var _staticConfiguration = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EngagementScoreModal = function (_React$Component) {
	  _inherits(EngagementScoreModal, _React$Component);
	
	  function EngagementScoreModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EngagementScoreModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EngagementScoreModal.__proto__ || Object.getPrototypeOf(EngagementScoreModal)).call.apply(_ref, [this].concat(args))), _this), _this.onOutsideClick = function (event) {
	      var isClickInside = _this.refs.modal_content.contains(event.target);
	      if (!isClickInside) {
	        _this.onClearModal();
	      }
	    }, _this.onClearModal = function () {
	      _this.props.onClearModal();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EngagementScoreModal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.onClearModal();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          showModal = _props.showModal,
	          modalLoading = _props.modalLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: showModal === _staticConfiguration.ENGAGEMENT_SCORE ? 'analytics-modal visible' : 'analytics-modal', onClick: this.onOutsideClick },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content', ref: 'modal_content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'top' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              _react2.default.createElement('img', { src: '/icons/engagement-score.svg', alt: 'Engagement score' }),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Dyzio engagement score'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'close' },
	              _react2.default.createElement('img', { src: '/icons/close.svg', alt: 'close', onClick: this.onClearModal })
	            )
	          ),
	          _react2.default.createElement('div', { className: 'break' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'center' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'How it works'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The score is measured using the following criteria:'
	            ),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement('img', { src: '/icons/comment-speech.svg' }),
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Comments'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Score based on number of comments as a percentage of views'
	            ),
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'engagement-labels' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item align-left' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'light' },
	                  '0%'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item align-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'light' },
	                  '0.5%'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item align-right' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'light' },
	                  '1+%'
	                )
	              )
	            ),
	            _react2.default.createElement('img', {
	              className: 'engagement-line',
	              src: '/icons/engagement-line.svg',
	              alt: 'line break'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'engagement-labels' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item align-left' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '0'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item align-center' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '25'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item align-right' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '50'
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement('img', { src: '/icons/thumbs-up.svg' }),
	            _react2.default.createElement('img', { src: '/icons/thumbs-down.svg' }),
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Likes & dislikes'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Score based on likes minus dislikes as a percentage of views'
	            ),
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'engagement-labels' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item align-left' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'light' },
	                  '0%'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item align-center' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'light' },
	                  '2.5%'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item align-right' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'light' },
	                  '5+%'
	                )
	              )
	            ),
	            _react2.default.createElement('img', { className: 'engagement-line', src: '/icons/engagement-line.svg', alt: 'line break' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'engagement-labels' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item align-left' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '0'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item align-center' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '25'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item align-right' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '50'
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(
	              'button',
	              { className: 'medium rose wide', onClick: this.onClearModal },
	              _react2.default.createElement(
	                'p',
	                null,
	                'done'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EngagementScoreModal;
	}(_react2.default.Component);
	
	EngagementScoreModal.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    showModal: state.modal.get('showModal'),
	    modalLoading: state.modal.get('loading'),
	    modalError: state.modal.get('error')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onClearModal: function onClearModal() {
	      return dispatch((0, _modal.clearModal)());
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EngagementScoreModal);

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _facebookConnectedAccount = __webpack_require__(1934);
	
	var _facebookConnectedAccount2 = _interopRequireDefault(_facebookConnectedAccount);
	
	var _facebookConnectAccount = __webpack_require__(1933);
	
	var _facebookConnectAccount2 = _interopRequireDefault(_facebookConnectAccount);
	
	var _facebookMarketingCampaignLinker = __webpack_require__(1938);
	
	var _facebookMarketingCampaignLinker2 = _interopRequireDefault(_facebookMarketingCampaignLinker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FacebookAdsManager = function FacebookAdsManager(_ref) {
	  var account = _ref.account,
	      name = _ref.name,
	      campaignId = _ref.campaignId,
	      canLinkCampaigns = _ref.canLinkCampaigns;
	
	  var isAccountConnected = _lodash2.default.isObject(account) && _lodash2.default.isString(account.id);
	  var id = _lodash2.default.get(account, 'id', null);
	  var hasCampaignId = _lodash2.default.isString(campaignId);
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Linked Facebook Ads Manager Account'
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	    isAccountConnected ? _react2.default.createElement(_facebookConnectedAccount2.default, { id: id, name: name }) : _react2.default.createElement(_facebookConnectAccount2.default, null),
	    canLinkCampaigns && isAccountConnected && hasCampaignId && _react2.default.createElement(_facebookMarketingCampaignLinker2.default, {
	      campaignId: campaignId
	    })
	  );
	};
	
	FacebookAdsManager.propTypes = {
	  account: _propTypes2.default.shape({
	    access_token: _propTypes2.default.string.isRequired,
	    business_name: _propTypes2.default.string.isRequired,
	    id: _propTypes2.default.string.isRequired,
	    name: _propTypes2.default.string.isRequired,
	    owner: _propTypes2.default.string.isRequired
	  }),
	  canLinkCampaigns: _propTypes2.default.bool,
	  name: _propTypes2.default.string.isRequired,
	  campaignId: _propTypes2.default.string
	};
	
	FacebookAdsManager.defaultProps = {
	  account: null,
	  campaignId: null,
	  canLinkCampaigns: true
	};
	
	exports.default = FacebookAdsManager;

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FacebookEmbed = function FacebookEmbed(props) {
	  var dimensions = {
	    smallHeight: 450,
	    height: 500,
	    width: 500
	  };
	
	  if (props.size === 'small') {
	    dimensions = {
	      smallHeight: 300,
	      height: 320,
	      width: 320
	    };
	  }
	
	  var style = _extends({
	    minHeight: 330,
	    height: '100%'
	  }, props.style);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('iframe', {
	      src: 'https://www.facebook.com/plugins/post.php?href=' + props.url + '&height=' + dimensions.smallHeight,
	      width: dimensions.width,
	      scrolling: 'true',
	      frameBorder: '0',
	      allowTransparency: 'true',
	      style: style
	    }),
	    _react2.default.createElement(_semanticUiReact.Divider, null),
	    props.type === 'VIDEO' && _react2.default.createElement(
	      _semanticUiReact.Message,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you cannot see the video above it most likely cannot be embedded off Facebook, but you can still add it to the campaign for tracking'
	      )
	    )
	  );
	};
	
	FacebookEmbed.propTypes = {
	  url: _propTypes2.default.string.isRequired,
	  style: _propTypes2.default.object,
	  size: _propTypes2.default.string,
	  type: _propTypes2.default.string
	};
	
	FacebookEmbed.defaultProps = {
	  style: {},
	  size: 'medium',
	  type: 'POST'
	};
	
	exports.default = FacebookEmbed;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _demographicsAgeGraph = __webpack_require__(241);
	
	var _demographicsAgeGraph2 = _interopRequireDefault(_demographicsAgeGraph);
	
	var _demographicsGenderGraph = __webpack_require__(376);
	
	var _demographicsGenderGraph2 = _interopRequireDefault(_demographicsGenderGraph);
	
	var _followersBarChart = __webpack_require__(176);
	
	var _followersBarChart2 = _interopRequireDefault(_followersBarChart);
	
	var _locationTabs = __webpack_require__(1942);
	
	var _locationTabs2 = _interopRequireDefault(_locationTabs);
	
	var _fullCountryModal = __webpack_require__(1940);
	
	var _fullCountryModal2 = _interopRequireDefault(_fullCountryModal);
	
	var _fullCityModal = __webpack_require__(1939);
	
	var _fullCityModal2 = _interopRequireDefault(_fullCityModal);
	
	var _fullMetricModal = __webpack_require__(1941);
	
	var _fullMetricModal2 = _interopRequireDefault(_fullMetricModal);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noBottomPadding = {
	  paddingBottom: 0
	};
	
	var dividerStyle = {
	  marginTop: 5,
	  marginBottom: 5
	};
	
	var textCenter = {
	  textAlign: 'center'
	};
	
	var MODAL_LINK_STYLE = _extends({
	  cursor: 'pointer'
	}, textCenter);
	
	var DYZIO_APP_ID = '116451675157336';
	
	var FacebookProfileDataLarge = function FacebookProfileDataLarge(props) {
	  var displayAuthorisedData = props.displayAuthorisedData,
	      handle = props.handle,
	      pageMetricModalOpen = props.pageMetricModalOpen,
	      facebookVerified = props.facebookVerified,
	      countHistory = props.countHistory,
	      pageMetrics = props.pageMetrics,
	      facebookCountryDemographicsModalOpen = props.facebookCountryDemographicsModalOpen,
	      facebookCityDemographicsModalOpen = props.facebookCityDemographicsModalOpen,
	      toggleFacebookCountryDemographicsModalState = props.toggleFacebookCountryDemographicsModalState,
	      toggleFacebookCityDemographicsModalState = props.toggleFacebookCityDemographicsModalState,
	      organisationId = props.userInfo.organisationId,
	      onFullPageMetrics = props.onFullPageMetrics;
	
	
	  if (!handle) return null;
	
	  var cleanHandle = _lodash2.default.replace(handle, 'https://www.facebook.com/', '');
	  var facebookHistory = _lodash2.default.filter(countHistory, function (item) {
	    return _lodash2.default.has(item, 'facebookCount');
	  });
	  var lastFBHistoryItem = _lodash2.default.last(facebookHistory);
	
	  var _ref = pageMetrics || { data: {} },
	      _ref$data = _ref.data,
	      engagements = _ref$data.engagements,
	      views = _ref$data.views,
	      impressions = _ref$data.impressions,
	      consumptions = _ref$data.consumptions,
	      videos = _ref$data.videos;
	
	  var usingOldFormat = !!_lodash2.default.last(_lodash2.default.get(engagements, 'values')); /* TODO(Kai): Depricate then remove this line */
	  var graphProps = {
	    label: 'followers',
	    labels: _lodash2.default.map(facebookHistory, function (item) {
	      return (0, _moment2.default)(item.createdDate).format('MMM D');
	    }),
	    values: _lodash2.default.map(facebookHistory, 'facebookCount'),
	    rgbColorCode: '#3B5998'
	  };
	
	  var lastFacebookCount = _lodash2.default.get(lastFBHistoryItem, 'facebookCount', null);
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { color: 'blue' },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 16 },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', color: 'blue' }),
	            'Facebook'
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null)
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 3 },
	          _react2.default.createElement(_semanticUiReact.Image, {
	            src: 'https://graph.facebook.com/v2.11/' + cleanHandle + '/picture?redirect=1&app_id=' + DYZIO_APP_ID,
	            shape: 'circular',
	            centered: true,
	            size: 'small'
	          }),
	          _react2.default.createElement(
	            _semanticUiReact.Table,
	            { basic: 'very', fluid: true, textAlign: 'center' },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Body,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  cleanHandle,
	                  facebookVerified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' })
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  (0, _formatting.commaFormatted)(lastFacebookCount),
	                  ' followers'
	                )
	              ),
	              !facebookVerified && _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'grey', content: 'not verified' }),
	                    content: cleanHandle + ' is not verified by Facebook (blue tick)'
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 8 },
	          _react2.default.createElement(_followersBarChart2.default, Object.assign({}, graphProps, {
	            percentageRange: 0.5
	          }))
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 5 },
	          _react2.default.createElement(
	            'h4',
	            { style: textCenter },
	            'Last 28 days page insights'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table,
	            { basic: 'very', fluid: true },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'total page followers'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                (0, _formatting.commaFormatted)(lastFacebookCount)
	              )
	            ),
	            !usingOldFormat && displayAuthorisedData && engagements && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'span',
	                    null,
	                    'posts engagements ',
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
	                  ),
	                  content: 'The number of times people have engaged with page posts through like, comments and shares and more.'
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                (0, _formatting.commaFormatted)(engagements.value)
	              )
	            ),
	            !usingOldFormat && displayAuthorisedData && views && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'span',
	                    null,
	                    'views ',
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
	                  ),
	                  content: 'Total views count per Page'
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                (0, _formatting.commaFormatted)(views.value)
	              )
	            ),
	            !usingOldFormat && displayAuthorisedData && impressions && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'span',
	                    null,
	                    'impressions ',
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
	                  ),
	                  content: 'The number of times your Page\'s posts entered a person\'s screen. Posts include statuses, photos, links, videos and more. (Total Count)'
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                (0, _formatting.commaFormatted)(impressions.value)
	              )
	            ),
	            !usingOldFormat && displayAuthorisedData && consumptions && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'span',
	                    null,
	                    'consumptions ',
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
	                  ),
	                  content: 'The number of clicks on any of page content. Stories generated without clicks on page content (e.g., liking the page in Timeline) are not included. (Total Count)'
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                (0, _formatting.commaFormatted)(consumptions.value)
	              )
	            ),
	            !usingOldFormat && displayAuthorisedData && videos && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'span',
	                    null,
	                    'videos engagements',
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
	                  ),
	                  content: 'Total number of times videos have been viewed for more than 3 seconds. (Total Count)'
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                (0, _formatting.commaFormatted)(videos.value)
	              )
	            )
	          ),
	          !usingOldFormat && displayAuthorisedData && _react2.default.createElement(
	            'div',
	            { style: textCenter },
	            _react2.default.createElement(
	              'a',
	              { style: MODAL_LINK_STYLE, onClick: onFullPageMetrics },
	              'View full page metric data'
	            )
	          )
	        )
	      ),
	      displayAuthorisedData && props.audienceDemographics && props.audienceLocations && _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        { textAlign: 'center', style: noBottomPadding, divided: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 16 },
	          _react2.default.createElement(_semanticUiReact.Divider, { fitted: true, style: dividerStyle }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Audience Demographics and Regions',
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'orange' }),
	              content: 'Private data collected from Facebook API'
	            })
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, { fitted: true, style: dividerStyle })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 4, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Viewing by Gender'
	          ),
	          _react2.default.createElement(_demographicsGenderGraph2.default, props)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 7, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Channel demographic by gender / age'
	          ),
	          _react2.default.createElement(_demographicsAgeGraph2.default, props)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 5 },
	          _react2.default.createElement(_locationTabs2.default, Object.assign({}, props, {
	            onFullCityClick: toggleFacebookCityDemographicsModalState,
	            onFullCountryClick: toggleFacebookCountryDemographicsModalState
	          }))
	        )
	      ),
	      facebookCountryDemographicsModalOpen && _react2.default.createElement(_fullCountryModal2.default, Object.assign({}, props, { onToggle: toggleFacebookCountryDemographicsModalState })),
	      facebookCityDemographicsModalOpen && _react2.default.createElement(_fullCityModal2.default, Object.assign({}, props, { onToggle: toggleFacebookCityDemographicsModalState })),
	      pageMetricModalOpen && pageMetrics && _react2.default.createElement(_fullMetricModal2.default, Object.assign({}, pageMetrics.data, { username: handle, onToggle: onFullPageMetrics }))
	    )
	  );
	};
	
	FacebookProfileDataLarge.propTypes = {
	  handle: _propTypes2.default.string.isRequired,
	  facebookVerified: _propTypes2.default.bool,
	  countHistory: _propTypes2.default.array.isRequired,
	  audienceLocations: _propTypes2.default.object,
	  audienceDemographics: _propTypes2.default.object,
	  facebookCountryDemographicsModalOpen: _propTypes2.default.bool,
	  toggleFacebookCountryDemographicsModalState: _propTypes2.default.func.isRequired,
	  facebookCityDemographicsModalOpen: _propTypes2.default.bool,
	  toggleFacebookCityDemographicsModalState: _propTypes2.default.func.isRequired,
	  pageMetrics: _propTypes2.default.object,
	  onFullPageMetrics: _propTypes2.default.func.isRequired,
	  pageMetricModalOpen: _propTypes2.default.bool,
	  userInfo: _propTypes2.default.object.isRequired,
	  displayAuthorisedData: _propTypes2.default.bool
	};
	
	FacebookProfileDataLarge.defaultProps = {
	  facebookVerified: false,
	  audienceLocations: null,
	  audienceDemographics: null,
	  pageMetrics: null,
	  facebookCountryDemographicsModalOpen: false,
	  facebookCityDemographicsModalOpen: false,
	  pageMetricModalOpen: false,
	  displayAuthorisedData: false
	};
	
	exports.default = (0, _hasUserInfo2.default)(FacebookProfileDataLarge);

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextareaInput = function (_React$Component) {
	  _inherits(TextareaInput, _React$Component);
	
	  function TextareaInput(props) {
	    _classCallCheck(this, TextareaInput);
	
	    var _this = _possibleConstructorReturn(this, (TextareaInput.__proto__ || Object.getPrototypeOf(TextareaInput)).call(this, props));
	
	    _this.state = { active: false };
	    return _this;
	  }
	
	  _createClass(TextareaInput, [{
	    key: 'makeActive',
	    value: function makeActive() {
	      if (this.state.active === false) {
	        this.setState({
	          active: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      var error = this.props.meta.touched && this.props.meta.error ? 'error' : '';
	      var disabled = this.props.disabled ? 'disabled' : '';
	      var active = this.state.active ? 'active' : '';
	      var errorClass = this.props.className + 'small error';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-field' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: this.props.id },
	          this.props.label
	        ),
	        _react2.default.createElement('textarea', Object.assign({}, this.props.input, {
	          id: this.props.id,
	          name: this.props.name,
	          className: (0, _classnames2.default)(error, active, disabled, ' ' + this.props.className + ' '),
	          disabled: this.props.disabled ? true : false,
	          placeholder: this.props.placeholder,
	          onClick: this.makeActive.bind(this),
	          onFocus: this.props.input.onFocus,
	          onBlur: this.props.input.onBlur,
	          onKeyPress: this.props.onKeyPress
	        })),
	        this.props.meta.touched && this.props.meta.error && _react2.default.createElement(
	          'p',
	          { className: errorClass },
	          this.props.meta.error
	        )
	      );
	    }
	  }]);
	
	  return TextareaInput;
	}(_react2.default.Component);
	
	TextareaInput.propTypes = {
	  onFocus: _react2.default.PropTypes.func,
	  onBlur: _react2.default.PropTypes.func,
	  onClick: _react2.default.PropTypes.func,
	  onKeyPress: _react2.default.PropTypes.func
	};
	
	exports.default = TextareaInput;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ramda = __webpack_require__(252);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputStyle = {
	  marginTop: 10,
	  marginBottom: 10
	};
	
	var scanningProgressDivStyle = {
	  height: 249,
	  width: '100%',
	  textAlign: 'center',
	  paddingTop: 40
	};
	
	var NUMBER_OF_INPUTS = 1;
	
	var isEmptyHashtag = function isEmptyHashtag(arg) {
	  return _lodash2.default.isEmpty(arg) || _lodash2.default.size(_lodash2.default.trim(arg)) < 5;
	};
	
	var getChannelIconColour = function getChannelIconColour(channel) {
	  var colours = {
	    YOUTUBE: 'red',
	    FACEBOOK: 'blue',
	    INSTAGRAM: 'pink',
	    TWITTER: 'blue'
	  };
	  return _lodash2.default.get(colours, channel, 'gray');
	};
	
	var HashtagScannerModal = function HashtagScannerModal(_ref) {
	  var isScanning = _ref.isScanning,
	      currentScannedPlatform = _ref.currentScannedPlatform,
	      scannerResultsCount = _ref.scannerResultsCount,
	      hashtags = _ref.hashtags,
	      hashtagsErrors = _ref.hashtagsErrors,
	      onInputValueChange = _ref.onInputValueChange,
	      onClose = _ref.onClose,
	      onScanHandler = _ref.onScanHandler,
	      isEmptyState = _ref.isEmptyState;
	
	  var withErrors = _lodash2.default.find(hashtagsErrors, ['isError', true]);
	  var hashtagValues = _lodash2.default.map(hashtags, 'value');
	  var noHashTags = _ramda2.default.allPass([isEmptyHashtag])(hashtagValues);
	
	  var _ThemeSelector$theme = _themeSelector2.default.theme(),
	      disableHelpLinks = _ThemeSelector$theme.disableHelpLinks;
	
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      headerText: 'Hashtag Scanner',
	      size: 'tiny',
	      hasActionButton: true,
	      actionButtonContent: 'Scan',
	      actionButtonIcon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'search' }),
	      shouldDisableActionButton: isScanning || noHashTags,
	      onActionButtonClick: onScanHandler,
	      onClose: onClose,
	      hasFeedbackProvider: withErrors,
	      feedbackContent: 'Numbers are allowed in hashtags. However, spaces and special characters, like $ or %, won\u2019t work',
	      feedbackType: 'error'
	    },
	    isEmptyState && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_semanticUiReact.Message, {
	        icon: 'info circle',
	        info: true,
	        header: 'Add some influencers',
	        content: 'Make sure you\'ve added some influencers before running the hashtag scanner.'
	      })
	    ),
	    !isEmptyState && isScanning && _react2.default.createElement(
	      'div',
	      { style: scanningProgressDivStyle },
	      _react2.default.createElement(_semanticUiReact.Icon, {
	        name: currentScannedPlatform ? _lodash2.default.lowerCase(currentScannedPlatform) : 'search',
	        size: 'massive',
	        color: getChannelIconColour(currentScannedPlatform)
	      }),
	      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	      currentScannedPlatform && _react2.default.createElement(
	        'span',
	        null,
	        'Scanned ',
	        currentScannedPlatform,
	        '. Found ',
	        scannerResultsCount,
	        ' posts.'
	      ),
	      !currentScannedPlatform && _react2.default.createElement(
	        'span',
	        null,
	        'Scanning...'
	      )
	    ),
	    !isEmptyState && !isScanning && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Enter tags below, exactly as you want them to be searched i.e. "#specialoffer" or "acme" or "@nike"'
	      ),
	      _lodash2.default.map(_lodash2.default.range(NUMBER_OF_INPUTS), function (position) {
	        var hashtag = _lodash2.default.find(hashtags, ['name', 'hashtag_' + position]);
	        var hashtagErrorState = _lodash2.default.find(hashtagsErrors, ['position', position]);
	        return _react2.default.createElement(_semanticUiReact.Input, {
	          fluid: true,
	          style: inputStyle,
	          error: hashtagErrorState && hashtagErrorState.isError,
	          placeholder: 'enter hashtag here (minimum of 4 letters)',
	          name: 'hashtag_' + position,
	          onChange: onInputValueChange,
	          value: hashtag ? hashtag.value : null
	        });
	      }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can search hashtags, @mentions or any text.'
	      ),
	      !disableHelpLinks && _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          _targetLink2.default,
	          {
	            renderIf: true,
	            href: 'http://help.dyzio.co/campaign-reports/hashtag-scanner'
	          },
	          'click here for help and FAQs'
	        )
	      )
	    )
	  );
	};
	
	HashtagScannerModal.propTypes = {
	  onInputValueChange: _propTypes2.default.func.isRequired,
	  onScanHandler: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  scannerResultsCount: _propTypes2.default.string,
	  isScanning: _propTypes2.default.bool.isRequired,
	  isEmptyState: _propTypes2.default.bool.isRequired,
	  hashtags: _propTypes2.default.array.isRequired,
	  hashtagsErrors: _propTypes2.default.array.isRequired,
	  currentScannedPlatform: _propTypes2.default.oneOf([null, _staticConfiguration.YOUTUBE, _staticConfiguration.FACEBOOK, _staticConfiguration.INSTAGRAM, _staticConfiguration.TWITTER]).isRequired
	};
	
	HashtagScannerModal.defaultProps = {
	  scannerResultsCount: null
	};
	
	exports.default = HashtagScannerModal;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _utils = __webpack_require__(1946);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable lodash/prefer-lodash-method */
	
	
	var inputStyle = { marginBottom: 10 };
	var inputAction = { icon: 'plus' };
	var requiredLabelStyle = { color: 'red' };
	var tagStyles = { marginTop: 4 };
	
	var RequiredLabel = function RequiredLabel() {
	  return _react2.default.createElement(
	    'span',
	    { style: requiredLabelStyle },
	    '*'
	  );
	};
	
	var HelpPopup = function HelpPopup() {
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    content: 'enter hashtags, @mentions or any text you want to use to capture the influencer posts. You can enter multiple entries separated by commas. The system will search the post or story caption and add the post to the campaign if it matches. Hashtags must be more than 2 characters',
	    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'help circle', className: 'circular' })
	  });
	};
	
	var HashtagsInput = function (_Component) {
	  _inherits(HashtagsInput, _Component);
	
	  function HashtagsInput(props) {
	    _classCallCheck(this, HashtagsInput);
	
	    var _this = _possibleConstructorReturn(this, (HashtagsInput.__proto__ || Object.getPrototypeOf(HashtagsInput)).call(this, props));
	
	    _this.onAddHashTagCallback = function (e) {
	      e.preventDefault();
	      var _this$props = _this.props,
	          maxTags = _this$props.maxTags,
	          onValueChanged = _this$props.onValueChanged;
	      var _this$state = _this.state,
	          _this$state$value = _this$state.value,
	          value = _this$state$value === undefined ? '' : _this$state$value,
	          tags = _this$state.tags;
	
	
	      var tagsClone = _lodash2.default.clone(tags);
	      var multipleTags = value.split(',').filter(function (v) {
	        return !_lodash2.default.isEmpty(v);
	      });
	      tagsClone.push.apply(tagsClone, _toConsumableArray(multipleTags));
	
	      if (_lodash2.default.size(tags) + _lodash2.default.size(multipleTags) > maxTags) {
	        _this.setState(function (state) {
	          return _extends({}, state, {
	            error: 'You can add up to ' + maxTags + ' hashtags, mentions, or text entries only.' });
	        });
	        return;
	      }
	
	      _this.setState({
	        tags: tagsClone,
	        value: ''
	      }, function () {
	        onValueChanged(e, {
	          name: 'hashtags',
	          value: _lodash2.default.join(tagsClone, ',')
	        });
	      });
	    };
	
	    _this.onTextInputChange = function (e, _ref) {
	      var value = _ref.value;
	
	      _this.setState({
	        value: _lodash2.default.replace(value, / +/g, '')
	      });
	    };
	
	    _this.resetInputError = function () {
	      _this.setState(function (state) {
	        return _extends({}, state, { error: null });
	      });
	    };
	
	    _this.onDeleteTag = function (tagToRemove) {
	      var tags = _this.state.tags;
	
	      var newTags = _lodash2.default.reject(tags, function (tag) {
	        return tag === tagToRemove;
	      });
	      _this.setState({
	        tags: newTags
	      }, function () {
	        _this.props.onValueChanged({}, {
	          name: 'hashtags',
	          value: _lodash2.default.join(newTags, ',')
	        });
	      });
	    };
	
	    _this.state = {
	      value: '',
	      tags: props.hashtags,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(HashtagsInput, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          maxTags = _props.maxTags,
	          campaignType = _props.campaignType;
	      var _state = this.state,
	          value = _state.value,
	          tags = _state.tags,
	          error = _state.error;
	
	
	      var isAutomated = campaignType === 'AUTOMATED';
	
	      var validationResult = (0, _utils.validateHashtags)(value);
	
	      var isValidInput = validationResult.valid;
	
	      var shouldDisableAddButton = _lodash2.default.toNumber(maxTags) === _lodash2.default.size(tags);
	
	      var actionProps = _extends({
	        onClick: this.onAddHashTagCallback
	      }, inputAction, {
	        disabled: shouldDisableAddButton || !isValidInput
	      });
	
	      return _react2.default.createElement(
	        _semanticUiReact.Form.Field,
	        null,
	        isAutomated && _react2.default.createElement(
	          'label',
	          { htmlFor: 'campaign-hashtags' },
	          'Tracked ',
	          _react2.default.createElement(
	            'i',
	            null,
	            '#hashtag'
	          ),
	          ' or ',
	          _react2.default.createElement(
	            'i',
	            null,
	            '@mention'
	          ),
	          ' (max. ',
	          maxTags,
	          ')',
	          _react2.default.createElement(RequiredLabel, null),
	          '  ',
	          _react2.default.createElement(HelpPopup, null)
	        ),
	        !isAutomated && _react2.default.createElement(
	          'label',
	          { htmlFor: 'campaign-hashtags' },
	          '#Hashtags (max. ',
	          maxTags,
	          ')  ',
	          _react2.default.createElement(HelpPopup, null)
	        ),
	        _react2.default.createElement(_semanticUiReact.Input, {
	          action: actionProps,
	          onChange: this.onTextInputChange,
	          placeholder: shouldDisableAddButton ? 'max tags added' : 'e.g. #nike',
	          value: value,
	          onBlur: this.resetInputError,
	          onFocus: this.resetInputError,
	          style: inputStyle,
	          disabled: shouldDisableAddButton
	        }),
	        error ? _react2.default.createElement(
	          _semanticUiReact.Label,
	          { basic: true, color: 'red', pointing: true },
	          error
	        ) : null,
	        _lodash2.default.map(tags, function (tag) {
	          return _react2.default.createElement(
	            _semanticUiReact.Label,
	            { image: true, size: 'large', basic: true, style: tagStyles },
	            tag,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'delete', color: 'red', onClick: function onClick() {
	                return _this2.onDeleteTag(tag);
	              } })
	          );
	        })
	      );
	    }
	  }]);
	
	  return HashtagsInput;
	}(_react.Component);
	
	exports.default = HashtagsInput;
	
	
	HashtagsInput.propTypes = {
	  maxTags: _propTypes2.default.number,
	  hashtags: _propTypes2.default.array,
	  onValueChanged: _propTypes2.default.func.isRequired,
	  campaignType: _propTypes2.default.string
	};
	
	HashtagsInput.defaultProps = {
	  maxTags: 25,
	  hashtags: [],
	  campaignType: 'MANUAL'
	};

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _influencerFormOptions = __webpack_require__(548);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var resetLink = {
	  cursor: 'pointer',
	  color: '#20c49e'
	};
	
	var noMinWidth = {
	  minWidth: 'unset'
	};
	
	var searchIcon = {
	  name: 'search'
	};
	
	var headerCellStyle = {
	  height: 51
	};
	
	var perPageOptions = [{ key: 25, value: 25, text: '25' }, { key: 50, value: 50, text: '50' }, { key: 100, value: 100, text: '100' }];
	
	var INITIAL_STATE = {
	  term: '',
	  searchType: '',
	  platform: '',
	  min: '',
	  max: '',
	  minInstagramEngagementRate: '',
	  maxInstagramEngagementRate: '',
	  country: '',
	  hasEmail: false,
	  instagramPrivate: false,
	  instagramBusinessAccount: false,
	  ageGroup: '',
	  gender: '',
	  ethnicity: ''
	};
	
	var InfluencerFilter = function (_Component) {
	  _inherits(InfluencerFilter, _Component);
	
	  function InfluencerFilter(props) {
	    _classCallCheck(this, InfluencerFilter);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerFilter.__proto__ || Object.getPrototypeOf(InfluencerFilter)).call(this));
	
	    _this.onValueChanged = function (event, _ref) {
	      var name = _ref.name,
	          value = _ref.value,
	          checked = _ref.checked;
	
	      _this.setState(_defineProperty({}, name, value || checked));
	    };
	
	    _this.onDropdownChange = function (event, _ref2) {
	      var name = _ref2.name,
	          value = _ref2.value;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.onFilterClear = function () {
	      var onSearchFormSubmit = _this.props.onSearchFormSubmit;
	
	      _this.setState(_extends({}, INITIAL_STATE), onSearchFormSubmit(_extends({}, INITIAL_STATE)));
	    };
	
	    _this.onSearchButtonClick = function () {
	      var onSearchFormSubmit = _this.props.onSearchFormSubmit;
	      var _this$state = _this.state,
	          term = _this$state.term,
	          searchType = _this$state.searchType,
	          platform = _this$state.platform,
	          min = _this$state.min,
	          max = _this$state.max,
	          minInstagramEngagementRate = _this$state.minInstagramEngagementRate,
	          maxInstagramEngagementRate = _this$state.maxInstagramEngagementRate,
	          country = _this$state.country,
	          hasEmail = _this$state.hasEmail,
	          instagramPrivate = _this$state.instagramPrivate,
	          instagramBusinessAccount = _this$state.instagramBusinessAccount,
	          ageGroup = _this$state.ageGroup,
	          gender = _this$state.gender,
	          ethnicity = _this$state.ethnicity;
	
	
	      onSearchFormSubmit({
	        term: term,
	        searchType: searchType,
	        platform: platform,
	        min: min,
	        max: max,
	        minInstagramEngagementRate: minInstagramEngagementRate,
	        maxInstagramEngagementRate: maxInstagramEngagementRate,
	        country: country,
	        hasEmail: hasEmail,
	        instagramPrivate: instagramPrivate,
	        instagramBusinessAccount: instagramBusinessAccount,
	        ageGroup: ageGroup,
	        gender: gender,
	        ethnicity: ethnicity
	      });
	    };
	
	    var filter = props.filter,
	        withEmailCheckbox = props.withEmailCheckbox,
	        defaultSearchType = props.defaultSearchType,
	        defaultCountry = props.defaultCountry;
	
	    _this.state = _extends({}, INITIAL_STATE, filter, {
	      hasEmail: withEmailCheckbox,
	      searchType: defaultSearchType,
	      country: defaultCountry || ''
	    });
	    return _this;
	  }
	
	  _createClass(InfluencerFilter, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          term = _state.term,
	          searchType = _state.searchType,
	          min = _state.min,
	          max = _state.max,
	          country = _state.country,
	          platform = _state.platform,
	          hasEmail = _state.hasEmail,
	          minInstagramEngagementRate = _state.minInstagramEngagementRate,
	          maxInstagramEngagementRate = _state.maxInstagramEngagementRate,
	          instagramBusinessAccount = _state.instagramBusinessAccount,
	          instagramPrivate = _state.instagramPrivate,
	          ageGroup = _state.ageGroup,
	          gender = _state.gender,
	          ethnicity = _state.ethnicity;
	      var _props = this.props,
	          countries = _props.countries,
	          platforms = _props.platforms,
	          isLoadingCountries = _props.isLoadingCountries,
	          isLoading = _props.isLoading,
	          reportUrls = _props.reportUrls,
	          onPerPageChange = _props.onPerPageChange,
	          currentPerPage = _props.currentPerPage,
	          withEmailCheckbox = _props.withEmailCheckbox,
	          withInstagramPrivateCheckbox = _props.withInstagramPrivateCheckbox,
	          withBusinessAccountCheckbox = _props.withBusinessAccountCheckbox,
	          withDemographicsFilter = _props.withDemographicsFilter;
	
	
	      var downloadReportLinkAvailable = reportUrls.csv || reportUrls.xlsx;
	
	      var searchTypes = [{
	        key: 'handles',
	        text: 'name/handle',
	        value: 'handles'
	      }, {
	        key: 'email',
	        text: 'email',
	        value: 'email'
	      }, {
	        key: 'hashtags',
	        text: 'hashtags',
	        value: 'instagramHashtags'
	      }];
	
	      return _react2.default.createElement(
	        _semanticUiReact.Table,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Header,
	          { fullWidth: true },
	          _react2.default.createElement(
	            _semanticUiReact.Table.HeaderCell,
	            { width: 8, style: headerCellStyle },
	            'Filters'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.HeaderCell,
	            { width: 8, textAlign: 'right', style: headerCellStyle },
	            _react2.default.createElement(
	              'a',
	              { style: resetLink, onClick: this.onFilterClear },
	              'Clear filter',
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'delete' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: 2 },
	              _react2.default.createElement(
	                _semanticUiReact.Form,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { style: { display: 'flex' } },
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(_semanticUiReact.Form.Input, {
	                      width: 9,
	                      placeholder: 'Search...',
	                      value: term,
	                      name: 'term',
	                      onChange: this.onValueChanged
	                    }),
	                    content: 'Use the Tag Search below to search content tags!'
	                  }),
	                  _react2.default.createElement(_semanticUiReact.Form.Select, {
	                    width: 7,
	                    style: noMinWidth,
	                    placeholder: 'name/handle',
	                    name: 'searchType',
	                    value: searchType,
	                    options: searchTypes,
	                    onChange: this.onValueChanged
	                  })
	                ),
	                withEmailCheckbox && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
	                  label: 'Has email',
	                  name: 'hasEmail',
	                  checked: hasEmail,
	                  onChange: this.onValueChanged
	                }),
	                withInstagramPrivateCheckbox && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
	                  label: 'Instagram Private',
	                  name: 'instagramPrivate',
	                  checked: instagramPrivate,
	                  onChange: this.onValueChanged
	                }),
	                withBusinessAccountCheckbox && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
	                  label: 'Instagram business account',
	                  name: 'instagramBusinessAccount',
	                  checked: instagramBusinessAccount,
	                  onChange: this.onValueChanged
	                }),
	                _react2.default.createElement(_semanticUiReact.Form.Select, {
	                  label: 'channel',
	                  placeholder: 'channel',
	                  name: 'platform',
	                  value: platform,
	                  options: platforms,
	                  onChange: this.onValueChanged
	                }),
	                platform && _react2.default.createElement(
	                  _semanticUiReact.Card,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    null,
	                    'Followers',
	                    _react2.default.createElement(
	                      _semanticUiReact.Form.Group,
	                      null,
	                      _react2.default.createElement(_semanticUiReact.Form.Input, {
	                        type: 'number',
	                        width: 8,
	                        label: 'more than',
	                        name: 'min',
	                        value: min,
	                        placeholder: 'min. followers',
	                        onChange: this.onValueChanged
	                      }),
	                      _react2.default.createElement(_semanticUiReact.Form.Input, {
	                        type: 'number',
	                        width: 8,
	                        label: 'less than',
	                        name: 'max',
	                        value: max,
	                        placeholder: 'max. followers',
	                        onChange: this.onValueChanged
	                      })
	                    )
	                  )
	                ),
	                platform === 'instagram' && _react2.default.createElement(
	                  _semanticUiReact.Card,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    null,
	                    'Engagement Rate',
	                    _react2.default.createElement(
	                      _semanticUiReact.Form.Group,
	                      null,
	                      _react2.default.createElement(_semanticUiReact.Form.Input, {
	                        type: 'number',
	                        width: 8,
	                        label: 'more than',
	                        name: 'minInstagramEngagementRate',
	                        value: minInstagramEngagementRate,
	                        placeholder: 'min. E.R.',
	                        onChange: this.onValueChanged
	                      }),
	                      _react2.default.createElement(_semanticUiReact.Form.Input, {
	                        type: 'number',
	                        width: 8,
	                        label: 'less than',
	                        name: 'maxInstagramEngagementRate',
	                        value: maxInstagramEngagementRate,
	                        placeholder: 'max. E.R.',
	                        onChange: this.onValueChanged
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(_semanticUiReact.Form.Select, {
	                  label: 'country',
	                  placeholder: 'country',
	                  name: 'country',
	                  value: country,
	                  loading: isLoadingCountries,
	                  options: countries,
	                  onChange: this.onValueChanged
	                }),
	                withDemographicsFilter && _react2.default.createElement(
	                  _semanticUiReact.Card,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Form.Select, {
	                      label: 'Age',
	                      placeholder: 'Select age group',
	                      name: 'ageGroup',
	                      value: ageGroup,
	                      options: _influencerFormOptions.ageOptions,
	                      onChange: this.onValueChanged,
	                      clearable: true
	                    }),
	                    _react2.default.createElement(_semanticUiReact.Form.Select, {
	                      label: 'Gender',
	                      placeholder: 'Select gender',
	                      name: 'gender',
	                      value: gender,
	                      options: _influencerFormOptions.genderOptions,
	                      onChange: this.onValueChanged,
	                      clearable: true
	                    }),
	                    _react2.default.createElement(_semanticUiReact.Form.Select, {
	                      label: 'Ethnicity',
	                      placeholder: 'Select ethnicity',
	                      name: 'ethnicity',
	                      value: ethnicity,
	                      options: _influencerFormOptions.ethnicityOptions,
	                      onChange: this.onValueChanged,
	                      clearable: true
	                    })
	                  )
	                ),
	                _react2.default.createElement(_semanticUiReact.Divider, null),
	                _react2.default.createElement(_semanticUiReact.Button, {
	                  content: 'Search',
	                  icon: 'search',
	                  color: 'pink',
	                  fluid: true,
	                  loading: isLoading,
	                  onClick: this.onSearchButtonClick
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: 2 },
	              reportUrls && _react2.default.createElement(
	                _semanticUiReact.Grid,
	                { verticalAlign: 'middle' },
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Row,
	                  null,
	                  downloadReportLinkAvailable && _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 8 },
	                    'Download influencers as'
	                  ),
	                  reportUrls && reportUrls.csv && _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 3 },
	                    _react2.default.createElement(
	                      'a',
	                      { className: 'text', style: resetLink, href: reportUrls.csv },
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'cloud download' }),
	                      'CSV'
	                    )
	                  ),
	                  downloadReportLinkAvailable && reportUrls.xlsx && _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 3 },
	                    _react2.default.createElement(
	                      'a',
	                      { href: reportUrls.xlsx, style: resetLink, className: 'text' },
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'cloud download' }),
	                      'XLSX'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: 2 },
	              _react2.default.createElement(
	                _semanticUiReact.Grid,
	                { verticalAlign: 'middle' },
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { computer: 8, mobile: 16 },
	                    'Influencers per page'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { computer: 8, mobile: 16 },
	                    _react2.default.createElement(_semanticUiReact.Dropdown, {
	                      fluid: true,
	                      selection: true,
	                      value: currentPerPage,
	                      placeholder: 'per page',
	                      onChange: onPerPageChange,
	                      options: perPageOptions
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencerFilter;
	}(_react.Component);
	
	InfluencerFilter.propTypes = {
	  countries: _propTypes2.default.array.isRequired,
	  onSearchFormSubmit: _propTypes2.default.func.isRequired,
	  platforms: _propTypes2.default.array.isRequired,
	  isLoadingCountries: _propTypes2.default.bool.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  reportUrls: _propTypes2.default.object.isRequired,
	  onPerPageChange: _propTypes2.default.func.isRequired,
	  currentPerPage: _propTypes2.default.number.isRequired,
	  withEmailCheckbox: _propTypes2.default.bool,
	  withInstagramPrivateCheckbox: _propTypes2.default.bool,
	  withBusinessAccountCheckbox: _propTypes2.default.bool,
	  defaultSearchType: _propTypes2.default.string,
	  withDemographicsFilter: _propTypes2.default.bool
	};
	InfluencerFilter.defaultProps = {
	  withEmailCheckbox: false,
	  withInstagramPrivateCheckbox: false,
	  withBusinessAccountCheckbox: false,
	  defaultSearchType: '',
	  withDemographicsFilter: false
	};
	exports.default = InfluencerFilter;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _validator = __webpack_require__(84);
	
	var _lodash = __webpack_require__(6);
	
	var _networkHandleInput = __webpack_require__(277);
	
	var _networkHandleInput2 = _interopRequireDefault(_networkHandleInput);
	
	var _countries = __webpack_require__(93);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _getChannelData = __webpack_require__(2375);
	
	var _getChannelData2 = _interopRequireDefault(_getChannelData);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HANDLE_PROMPT = 'Enter the your handle, or copy-paste your profile\'s url';
	var TERMS_LINK = _themeSelector2.default.getInfluencerTermsAndConditionsLink();
	
	var blockDisplayStyle = {
	  display: 'block',
	  width: 100
	};
	
	var isValidEmail = function isValidEmail(email) {
	  return (0, _lodash.isString)(email) && (0, _validator.isEmail)(email);
	};
	
	var toDropdownOptions = function toDropdownOptions(list) {
	  return (0, _lodash.isEmpty)(list) ? [] : (0, _lodash.map)(list, function (value) {
	    return { value: value, text: value };
	  });
	};
	
	var InfluencerSetupForm = function (_React$Component) {
	  _inherits(InfluencerSetupForm, _React$Component);
	
	  function InfluencerSetupForm(_ref) {
	    var influencer = _ref.influencer;
	
	    _classCallCheck(this, InfluencerSetupForm);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerSetupForm.__proto__ || Object.getPrototypeOf(InfluencerSetupForm)).call(this));
	
	    _this.handleSocialChange = function (_, _ref2) {
	      var _this$setState;
	
	      var name = _ref2.name,
	          value = _ref2.value;
	
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, value), _defineProperty(_this$setState, name + 'Loading', true), _defineProperty(_this$setState, name + 'Error', false), _defineProperty(_this$setState, name + 'Count', 0), _this$setState));
	      (0, _getChannelData2.default)(name, value).then(function (args) {
	        var _this$setState2;
	
	        var count = args.count,
	            pageName = args.pageName;
	
	        return _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, name + 'Loading', false), _defineProperty(_this$setState2, name + 'Error', false), _defineProperty(_this$setState2, name + 'Count', (0, _lodash.parseInt)(count)), _defineProperty(_this$setState2, name + 'PageName', pageName), _this$setState2), function () {
	          var onChange = _this.props.onChange;
	
	          onChange(_this.state);
	        });
	      }).catch(function () {
	        var _this$setState3;
	
	        return _this.setState((_this$setState3 = {}, _defineProperty(_this$setState3, name + 'Loading', false), _defineProperty(_this$setState3, name + 'Error', true), _defineProperty(_this$setState3, name + 'Count', 0), _this$setState3), function () {
	          var onChange = _this.props.onChange;
	
	          onChange(_this.state);
	        });
	      });
	    };
	
	    _this.handleToggle = function (name) {
	      _this.setState(function (oldState) {
	        return _defineProperty({}, name, !oldState[name]);
	      }, function () {
	        var onChange = _this.props.onChange;
	
	        onChange(_this.state);
	      });
	    };
	
	    _this.handleChange = function (_, _ref4) {
	      var name = _ref4.name,
	          value = _ref4.value;
	
	      _this.setState(_defineProperty({}, name, value), function () {
	        var onChange = _this.props.onChange;
	
	        onChange(_this.state);
	      });
	    };
	
	    _this.addToContentTagOptions = function (_, _ref5) {
	      var value = _ref5.value;
	      var contentTagOptions = _this.state.contentTagOptions;
	
	      _this.setState({
	        contentTagOptions: [].concat(_toConsumableArray(contentTagOptions), [{ value: value, text: value }])
	      });
	    };
	
	    _this.addToPreviousClientsOptions = function (_, _ref6) {
	      var value = _ref6.value;
	      var previousClientsOptions = _this.state.previousClientsOptions;
	
	      _this.setState({
	        previousClientsOptions: [].concat(_toConsumableArray(previousClientsOptions), [{ value: value, text: value }])
	      });
	    };
	
	    _this.addToWillNotWorkWithOptions = function (_, _ref7) {
	      var value = _ref7.value;
	      var willNotWorkWithOptions = _this.state.willNotWorkWithOptions;
	
	      _this.setState({
	        willNotWorkWithOptions: [].concat(_toConsumableArray(willNotWorkWithOptions), [{ value: value, text: value }])
	      });
	    };
	
	    _this.render = function () {
	      var _this$state = _this.state,
	          name = _this$state.name,
	          country = _this$state.country,
	          countryBlurred = _this$state.countryBlurred,
	          email = _this$state.email,
	          emailBlurred = _this$state.emailBlurred,
	          instagram = _this$state.instagram,
	          instagramCount = _this$state.instagramCount,
	          facebook = _this$state.facebook,
	          facebookError = _this$state.facebookError,
	          facebookLoading = _this$state.facebookLoading,
	          facebookCount = _this$state.facebookCount,
	          twitter = _this$state.twitter,
	          twitterError = _this$state.twitterError,
	          twitterLoading = _this$state.twitterLoading,
	          twitterCount = _this$state.twitterCount,
	          youtube = _this$state.youtube,
	          youtubeError = _this$state.youtubeError,
	          youtubeLoading = _this$state.youtubeLoading,
	          youtubeCount = _this$state.youtubeCount,
	          youtubePageName = _this$state.youtubePageName,
	          web = _this$state.web,
	          contentTags = _this$state.contentTags,
	          contentTagOptions = _this$state.contentTagOptions,
	          previousClients = _this$state.previousClients,
	          previousClientsOptions = _this$state.previousClientsOptions,
	          willNotWorkWith = _this$state.willNotWorkWith,
	          willNotWorkWithOptions = _this$state.willNotWorkWithOptions,
	          agreedToTermsOfUse = _this$state.agreedToTermsOfUse,
	          agreedToShareWithDyzio = _this$state.agreedToShareWithDyzio,
	          setupComplete = _this$state.setupComplete,
	          contactNumber = _this$state.contactNumber,
	          addressLine1 = _this$state.addressLine1,
	          region = _this$state.region,
	          postalCode = _this$state.postalCode,
	          city = _this$state.city;
	
	      var _ThemeSelector$theme = _themeSelector2.default.theme(),
	          captureInfluencerAddressDetails = _ThemeSelector$theme.captureInfluencerAddressDetails,
	          applicationFormInstructions = _ThemeSelector$theme.copy.applicationFormInstructions;
	
	      var nameError = (0, _lodash.isEmpty)(name);
	      var countryError = countryBlurred && (0, _lodash.isEmpty)(country);
	      var emailError = emailBlurred && ((0, _lodash.isEmpty)(email) || !isValidEmail(email));
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          ' Influencer Application Form '
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        applicationFormInstructions,
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        _react2.default.createElement(
	          _semanticUiReact.Form,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Form.Group,
	            { widths: 'equal' },
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              label: 'Name', value: name, name: 'name', onChange: _this.handleChange,
	              error: nameError,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Group,
	            { widths: 'equal' },
	            _react2.default.createElement(_semanticUiReact.Form.Dropdown, {
	              options: _countries2.default,
	              selection: true,
	              error: countryError,
	              search: true,
	              label: 'Country',
	              onBlur: function onBlur() {
	                return _this.handleChange(null, { name: 'countryBlurred', value: true });
	              },
	              value: country,
	              name: 'country',
	              onChange: _this.handleChange,
	              required: true
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Group,
	            { widths: 'equal' },
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              label: 'Email Address', value: email, name: 'email', onChange: _this.handleChange,
	              error: emailError,
	              onBlur: function onBlur() {
	                return _this.handleChange(null, { name: 'emailBlurred', value: true });
	              },
	              placeholder: 'Preferred contact email address',
	              required: true
	            })
	          ),
	          captureInfluencerAddressDetails && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Business Address Details'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              width: 12,
	              label: 'Contact Number',
	              name: 'contactNumber',
	              onChange: _this.handleChange,
	              value: contactNumber
	            }),
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              width: 12,
	              label: 'Address Line One',
	              name: 'addressLine1',
	              onChange: _this.handleChange,
	              value: addressLine1
	            }),
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              width: 12,
	              label: 'City',
	              name: 'city',
	              onChange: _this.handleChange,
	              value: city
	            }),
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              width: 12,
	              label: 'Region',
	              name: 'region',
	              onChange: _this.handleChange,
	              value: region
	            }),
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              width: 12,
	              label: 'Postal Code',
	              name: 'postalCode',
	              onChange: _this.handleChange,
	              value: postalCode
	            })
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Group,
	            { widths: 'equal' },
	            _react2.default.createElement(
	              _semanticUiReact.Form.Field,
	              null,
	              _react2.default.createElement(
	                'span',
	                { style: blockDisplayStyle },
	                'Instagram'
	              ),
	              _react2.default.createElement(_networkHandleInput2.default, {
	                network: 'instagram',
	                readOnly: true,
	                value: instagram,
	                count: instagramCount
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Group,
	            { widths: 'equal' },
	            _react2.default.createElement(
	              _semanticUiReact.Form.Field,
	              { error: facebookError },
	              _react2.default.createElement(_semanticUiReact.Popup, {
	                position: 'left center',
	                trigger: _react2.default.createElement(
	                  'span',
	                  { style: blockDisplayStyle },
	                  'Facebook',
	                  _react2.default.createElement('img', { src: '/icons/info.svg', alt: 'info' })
	                ),
	                content: HANDLE_PROMPT
	              }),
	              _react2.default.createElement(_networkHandleInput2.default, {
	                network: 'facebook',
	                error: facebookError,
	                value: facebook,
	                loading: facebookLoading,
	                onChange: _this.handleSocialChange,
	                count: facebookCount
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Group,
	            { widths: 'equal' },
	            _react2.default.createElement(
	              _semanticUiReact.Form.Field,
	              { error: twitterError },
	              _react2.default.createElement(_semanticUiReact.Popup, {
	                position: 'left center',
	                trigger: _react2.default.createElement(
	                  'span',
	                  { style: blockDisplayStyle },
	                  'Twitter',
	                  _react2.default.createElement('img', { src: '/icons/info.svg', alt: 'info' })
	                ),
	                content: HANDLE_PROMPT
	              }),
	              _react2.default.createElement(_networkHandleInput2.default, {
	                network: 'twitter',
	                error: twitterError,
	                value: twitter,
	                loading: twitterLoading,
	                onChange: _this.handleSocialChange,
	                count: twitterCount
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Group,
	            { widths: 'equal' },
	            _react2.default.createElement(
	              _semanticUiReact.Form.Field,
	              { error: youtubeError },
	              _react2.default.createElement(_semanticUiReact.Popup, {
	                position: 'left center',
	                trigger: _react2.default.createElement(
	                  'span',
	                  { style: blockDisplayStyle },
	                  'YouTube',
	                  _react2.default.createElement('img', { src: '/icons/info.svg', alt: 'info' })
	                ),
	                content: HANDLE_PROMPT
	              }),
	              _react2.default.createElement(_networkHandleInput2.default, {
	                network: 'youtube',
	                error: youtubeError,
	                value: youtube,
	                loading: youtubeLoading,
	                onChange: _this.handleSocialChange,
	                count: youtubeCount
	              })
	            )
	          ),
	          youtubePageName ? _react2.default.createElement(
	            _semanticUiReact.Label,
	            { size: 'large', color: 'green', basic: true },
	            youtubePageName
	          ) : _react2.default.createElement(
	            _semanticUiReact.Label,
	            { size: 'large', color: 'grey', basic: true },
	            youtubeLoading ? 'loading...' : 'Youtube Channel Title'
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Group,
	            { widths: 'equal' },
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              width: 12,
	              label: _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'world', color: 'blue' }),
	                'Website or Blog'
	              ),
	              placeholder: 'Website or Blog',
	              name: 'web',
	              onChange: _this.handleChange,
	              value: web
	            })
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Group,
	            { widths: 'equal' },
	            _react2.default.createElement(_semanticUiReact.Form.Dropdown, {
	              width: 12,
	              label: '\xD75 Content tags that would best describe you and your content',
	              placeholder: 'e.g. football, comedy',
	              name: 'contentTags',
	              noResultsMessage: 'Enter tags that would best describe you',
	              options: contentTagOptions,
	              value: contentTags,
	              onChange: _this.handleChange,
	              onAddItem: _this.addToContentTagOptions,
	              search: true, selection: true, multiple: true, allowAdditions: true
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Group,
	            { widths: 'equal' },
	            _react2.default.createElement(_semanticUiReact.Form.Dropdown, {
	              width: 12,
	              label: '\xD75 Clients you have worked with',
	              placeholder: 'e.g. Audi, American Airlines...',
	              name: 'previousClients',
	              noResultsMessage: 'Enter clients that you have worked with',
	              options: previousClientsOptions,
	              value: previousClients,
	              onChange: _this.handleChange,
	              onAddItem: _this.addToPreviousClientsOptions,
	              search: true, selection: true, multiple: true, allowAdditions: true
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Group,
	            { widths: 'equal' },
	            _react2.default.createElement(_semanticUiReact.Form.Dropdown, {
	              width: 12,
	              label: 'Are there any sectors or brands you will not work this?',
	              placeholder: 'e.g. Alcohol, airlines',
	              name: 'willNotWorkWith',
	              noResultsMessage: 'Enter any clients you would not work with',
	              options: willNotWorkWithOptions,
	              value: willNotWorkWith,
	              color: 'red',
	              onChange: _this.handleChange,
	              onAddItem: _this.addToWillNotWorkWithOptions,
	              search: true, selection: true, multiple: true, allowAdditions: true
	            })
	          ),
	          !setupComplete && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(
	              _semanticUiReact.Form.Group,
	              { widths: 'equal' },
	              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
	                required: true,
	                value: agreedToTermsOfUse,
	                name: 'agreedToTermsOfUse',
	                onChange: function onChange() {
	                  return _this.handleToggle('agreedToTermsOfUse');
	                },
	                label: _react2.default.createElement(
	                  'label',
	                  null,
	                  'I have read and agree to',
	                  _react2.default.createElement(
	                    'a',
	                    { rel: 'noopener noreferrer', target: '_blank', href: TERMS_LINK },
	                    ' the terms of use '
	                  )
	                )
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Form.Group,
	              { widths: 'equal' },
	              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
	                required: true,
	                value: agreedToShareWithDyzio,
	                name: 'agreedToShareWithDyzio',
	                onChange: function onChange() {
	                  return _this.handleToggle('agreedToShareWithDyzio');
	                },
	                label: _react2.default.createElement(
	                  'label',
	                  null,
	                  'I agree for my data to be shared with Dyzio'
	                )
	              })
	            )
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	        )
	      );
	    };
	
	    _this.state = _extends({}, influencer, {
	      contentTags: influencer.contentTags || [],
	      contentTagOptions: toDropdownOptions(influencer.contentTags),
	      previousClients: influencer.previousClients || [],
	      previousClientsOptions: toDropdownOptions(influencer.previousClients),
	      willNotWorkWith: influencer.willNotWorkWith || [],
	      willNotWorkWithOptions: toDropdownOptions(influencer.willNotWorkWith)
	    });
	    return _this;
	  }
	
	  return InfluencerSetupForm;
	}(_react2.default.Component);
	
	exports.default = InfluencerSetupForm;

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var segmentStyle = { height: '100%', border: 'none' };
	var noPadding = { padding: 0 };
	var rowStyle = { border: 'none', boxShadow: 'none' };
	
	var InfluencerTableLoadingRow = function InfluencerTableLoadingRow(props) {
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    { style: rowStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { colSpan: props.colSpan, height: '500', style: noPadding },
	      _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { style: segmentStyle },
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: true, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { indeterminate: true },
	            props.text
	          )
	        )
	      )
	    )
	  );
	};
	
	InfluencerTableLoadingRow.defaultProps = {
	  text: 'Loading...',
	  colSpan: 13
	};
	
	InfluencerTableLoadingRow.propTypes = {
	  text: _propTypes2.default.string,
	  colSpan: _propTypes2.default.number
	};
	
	exports.default = InfluencerTableLoadingRow;

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getFormattedNumber = function getFormattedNumber(number) {
	  var numberFormat = number > 1000000 ? '0.0a' : '0a';
	  return (0, _numeral2.default)(number).format(numberFormat);
	};
	
	var NumberComponent = function NumberComponent(_ref) {
	  var data = _ref.data,
	      count = _ref.count;
	
	  if (data) return _react2.default.createElement(
	    _semanticUiReact.Label,
	    { basic: true, color: 'blue' },
	    getFormattedNumber(count)
	  );
	  return _react2.default.createElement(
	    'span',
	    null,
	    getFormattedNumber(count)
	  );
	};
	
	var InfluencerTableSocialLink = function InfluencerTableSocialLink(props) {
	  if (!props.count) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      '-'
	    );
	  }
	
	  return _react2.default.createElement(
	    _semanticUiReact.Popup,
	    {
	      hoverable: true,
	      trigger: _react2.default.createElement(NumberComponent, { data: props.data, count: props.count })
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Button,
	      {
	        color: props.link.color,
	        onClick: function onClick() {
	          return window.open('' + props.link.href + props.link.handle, '_blank');
	        }
	      },
	      props.link.label
	    )
	  );
	};
	
	InfluencerTableSocialLink.defaultProps = {
	  count: 0,
	  link: {
	    handle: null,
	    color: null,
	    label: null,
	    href: null
	  }
	};
	
	InfluencerTableSocialLink.propTypes = {
	  count: _propTypes2.default.number,
	  link: _propTypes2.default.object,
	  data: _propTypes2.default.object
	};
	
	exports.default = InfluencerTableSocialLink;

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _tagEditor = __webpack_require__(2027);
	
	var _tagEditor2 = _interopRequireDefault(_tagEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfluencerTag = function InfluencerTag(_ref) {
	  var id = _ref.id,
	      value = _ref.attributes.value,
	      onSave = _ref.onSave,
	      onDelete = _ref.onDelete;
	  return _react2.default.createElement(
	    _semanticUiReact.Label,
	    {
	      basic: true,
	      size: 'big'
	    },
	    value,
	    _react2.default.createElement(_semanticUiReact.Popup, {
	      content: _react2.default.createElement(_tagEditor2.default, { value: value, id: id, onSave: onSave, onDelete: onDelete }),
	      on: 'click',
	      position: 'top center',
	      trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'settings' })
	    })
	  );
	};
	
	InfluencerTag.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  attributes: _propTypes2.default.object.isRequired,
	  onSave: _propTypes2.default.func.isRequired,
	  onDelete: _propTypes2.default.func.isRequired
	};
	
	exports.default = InfluencerTag;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _pagination = __webpack_require__(147);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _influencerTableRow = __webpack_require__(1986);
	
	var _influencerTableRow2 = _interopRequireDefault(_influencerTableRow);
	
	var _influencerActions = __webpack_require__(1952);
	
	var _influencerActions2 = _interopRequireDefault(_influencerActions);
	
	var _influencerTableHeaderRow = __webpack_require__(1985);
	
	var _influencerTableHeaderRow2 = _interopRequireDefault(_influencerTableHeaderRow);
	
	var _influencerTableLoadingRow = __webpack_require__(880);
	
	var _influencerTableLoadingRow2 = _interopRequireDefault(_influencerTableLoadingRow);
	
	var _tryAgainView = __webpack_require__(897);
	
	var _tryAgainView2 = _interopRequireDefault(_tryAgainView);
	
	var _countries = __webpack_require__(93);
	
	var countryList = _interopRequireWildcard(_countries);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfluencersTable = function (_React$Component) {
	  _inherits(InfluencersTable, _React$Component);
	
	  function InfluencersTable() {
	    _classCallCheck(this, InfluencersTable);
	
	    var _this = _possibleConstructorReturn(this, (InfluencersTable.__proto__ || Object.getPrototypeOf(InfluencersTable)).call(this));
	
	    _this.state = {
	      createdDate: null
	    };
	    return _this;
	  }
	
	  _createClass(InfluencersTable, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var oldProps = this.props;
	      var state = this.state;
	
	      var selectedChanged = oldProps.selected.length !== nextProps.selected.length;
	      var dataChanged = state.createdDate != null && state.createdDate < nextProps.createdDate;
	      var finishedLoading = oldProps.loading !== nextProps.loading;
	      var columnsChanged = _lodash2.default.isEqual(oldProps.columnsSettings, nextProps.columnsSettings);
	
	      if (finishedLoading || selectedChanged || dataChanged || columnsChanged) {
	        this.setState({
	          createdDate: nextProps.createdDate
	        });
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          withActions = _props.withActions,
	          selected = _props.selected,
	          reportUrls = _props.reportUrls,
	          shortlists = _props.shortlists,
	          loading = _props.loading,
	          sort = _props.sort,
	          errors = _props.errors,
	          totalInfluencers = _props.totalInfluencers,
	          currentPage = _props.currentPage,
	          totalPages = _props.totalPages,
	          links = _props.links,
	          handleCheckAllInfluencers = _props.handleCheckAllInfluencers,
	          handleDeleteInfluencer = _props.handleDeleteInfluencer,
	          handleSaveShortlist = _props.handleSaveShortlist,
	          patchShortlist = _props.patchShortlist,
	          handleSorting = _props.handleSorting,
	          incrementPage = _props.incrementPage,
	          decrementPage = _props.decrementPage,
	          tryAgainCallback = _props.tryAgainCallback,
	          handleDeleteQueue = _props.handleDeleteQueue,
	          handleCheckChange = _props.handleCheckChange,
	          influencerPageRedirect = _props.influencerPageRedirect,
	          columnsSettings = _props.columnsSettings,
	          displayAuthorisedData = _props.displayAuthorisedData;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Table,
	        { fixed: true, sortable: !withActions, selectable: true, singleLine: true },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Header,
	          null,
	          withActions && !loading && _react2.default.createElement(_influencerActions2.default, {
	            reportUrls: reportUrls,
	            count: selected.length,
	            shortlists: shortlists,
	            onCheckAll: handleCheckAllInfluencers,
	            onDelete: handleDeleteInfluencer,
	            onSaveShortlist: handleSaveShortlist,
	            onShortlistPatch: patchShortlist,
	            columnsSettings: columnsSettings
	          }),
	          !withActions && !loading && _react2.default.createElement(_influencerTableHeaderRow2.default, {
	            onCheckAll: handleCheckAllInfluencers,
	            onSort: handleSorting,
	            sorting: sort,
	            columnsSettings: columnsSettings
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          loading && _react2.default.createElement(_influencerTableLoadingRow2.default, { colSpan: 11 }),
	          !loading && errors.search && _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: 16, height: '500', textAlign: 'center' },
	              _react2.default.createElement(_tryAgainView2.default, {
	                onClick: tryAgainCallback
	              })
	            )
	          ),
	          !loading && !errors.search && links && _lodash2.default.map(links, function (link) {
	            return _react2.default.createElement(_influencerTableRow2.default, {
	              displayAuthorisedData: displayAuthorisedData,
	              columnsSettings: columnsSettings,
	              key: link.id,
	              selected: selected,
	              colSpan: 12,
	              link: link,
	              countries: countryList.default,
	              onDeleteQueue: handleDeleteQueue,
	              handleRowClick: influencerPageRedirect,
	              onCheckboxStateUpdated: handleCheckChange
	            });
	          })
	        ),
	        !loading && totalInfluencers > 25 && _react2.default.createElement(
	          _semanticUiReact.Table.Footer,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { colSpan: '10' },
	              _react2.default.createElement(_pagination2.default, {
	                onPageIncrement: incrementPage,
	                onPageDecrement: decrementPage,
	                currentPage: currentPage,
	                totalPages: totalPages
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencersTable;
	}(_react2.default.Component);
	
	InfluencersTable.propTypes = {
	  withActions: _propTypes2.default.bool.isRequired,
	  selected: _propTypes2.default.array.isRequired,
	  shortlists: _propTypes2.default.array.isRequired,
	  links: _propTypes2.default.array,
	  loading: _propTypes2.default.bool.isRequired,
	  sort: _propTypes2.default.object.isRequired,
	  errors: _propTypes2.default.object.isRequired,
	  totalInfluencers: _propTypes2.default.number.isRequired,
	  handleCheckAllInfluencers: _propTypes2.default.func.isRequired,
	  handleDeleteInfluencer: _propTypes2.default.func.isRequired,
	  handleSaveShortlist: _propTypes2.default.func.isRequired,
	  patchShortlist: _propTypes2.default.func.isRequired,
	  handleSorting: _propTypes2.default.func.isRequired,
	  incrementPage: _propTypes2.default.func.isRequired,
	  decrementPage: _propTypes2.default.func.isRequired,
	  tryAgainCallback: _propTypes2.default.func.isRequired,
	  handleDeleteQueue: _propTypes2.default.func.isRequired,
	  handleCheckChange: _propTypes2.default.func.isRequired,
	  influencerPageRedirect: _propTypes2.default.func.isRequired,
	  reportUrls: _propTypes2.default.object.isRequired,
	  columnsSettings: _propTypes2.default.object.isRequired
	};
	
	InfluencersTable.defaultProps = {
	  links: null
	};
	exports.default = InfluencersTable;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _hashtagsUtils = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SIMPLE_FORMAT = 'YYYY-MM-DD';
	
	var inviteImageStyle = {
	  margin: '0 auto',
	  display: 'block'
	};
	
	var textAlignCenter = {
	  textAlign: 'center'
	};
	
	var InviteModal = function (_React$Component) {
	  _inherits(InviteModal, _React$Component);
	
	  function InviteModal() {
	    _classCallCheck(this, InviteModal);
	
	    var _this = _possibleConstructorReturn(this, (InviteModal.__proto__ || Object.getPrototypeOf(InviteModal)).call(this));
	
	    _this.onChange = function (e, _ref) {
	      var name = _ref.name,
	          value = _ref.value,
	          checked = _ref.checked;
	
	      _this.setState(_defineProperty({}, name, value || checked));
	    };
	
	    _this.onSendRequest = function () {
	      var data = _this.state;
	      var sendHandler = _this.props.sendHandler;
	
	
	      sendHandler({ data: data });
	    };
	
	    _this.state = {
	      notes: null
	    };
	    return _this;
	  }
	
	  _createClass(InviteModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          email = _props.email,
	          thumbnail = _props.thumbnail,
	          closeHandler = _props.closeHandler,
	          sendHandler = _props.sendHandler,
	          inviteSentOK = _props.inviteSentOK,
	          name = _props.name,
	          campaignName = _props.campaignName,
	          hashtags = _props.hashtags,
	          campaignStart = _props.campaignStart,
	          campaignEnd = _props.campaignEnd,
	          campaignType = _props.campaignType;
	      var _state = this.state,
	          notes = _state.notes,
	          youtube = _state.youtube,
	          instagram = _state.instagram,
	          twitter = _state.twitter,
	          facebook = _state.facebook;
	
	
	      var startDate = (0, _moment2.default)(campaignStart).format(SIMPLE_FORMAT);
	      var endDate = (0, _moment2.default)(campaignEnd).format(SIMPLE_FORMAT);
	
	      var hashtagArray = (0, _hashtagsUtils.transformHashtagstIntoArray)(hashtags);
	      return _react2.default.createElement(
	        _dyzioModal2.default,
	        {
	          headerText: 'Authorisation Request - ' + name,
	          size: 'small',
	          onClose: closeHandler,
	          hasActionButton: true,
	          actionButtonIcon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'send' }),
	          actionButtonContent: 'Send authorisation request',
	          onActionButtonClick: this.onSendRequest,
	          shouldDisableActionButton: inviteSentOK
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Form,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            { columns: 2 },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 7 },
	                _react2.default.createElement(
	                  'div',
	                  { style: textAlignCenter },
	                  _react2.default.createElement(_semanticUiReact.Image, {
	                    src: thumbnail,
	                    centered: true,
	                    className: 'ui small circular',
	                    style: inviteImageStyle
	                  }),
	                  _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Label,
	                      { basic: true },
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'at' }),
	                      '\xA0',
	                      email,
	                      '\xA0',
	                      _react2.default.createElement(_semanticUiReact.Popup, {
	                        trigger: _react2.default.createElement(_semanticUiReact.Icon, { size: 'large', color: 'green', name: 'edit' }),
	                        content: 'close this window and edit the email on the influencer page if necessary'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Divider, null),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'What channels do you require?'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        _react2.default.createElement(_semanticUiReact.Checkbox, {
	                          name: 'instagram',
	                          label: 'Instagram',
	                          checked: instagram,
	                          onChange: this.onChange
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        _react2.default.createElement(_semanticUiReact.Checkbox, {
	                          name: 'youtube',
	                          label: 'YouTube',
	                          checked: youtube,
	                          onChange: this.onChange
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        _react2.default.createElement(_semanticUiReact.Checkbox, {
	                          name: 'facebook',
	                          label: 'Facebook',
	                          checked: facebook,
	                          onChange: this.onChange
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        _react2.default.createElement(_semanticUiReact.Popup, {
	                          content: 'Sorry, we do not currently authorise Twitter data', trigger: _react2.default.createElement(_semanticUiReact.Checkbox, {
	                            disabled: true,
	                            name: 'twitter',
	                            label: 'Twitter',
	                            checked: twitter,
	                            onChange: this.onChange
	                          })
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 9 },
	                _react2.default.createElement(
	                  'div',
	                  { style: textAlignCenter },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    { celled: true, basic: 'very', style: { padding: 0 } },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Body,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Header,
	                            { as: 'h5', textAlign: 'center' },
	                            'name'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          campaignName
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Header,
	                            { as: 'h5', textAlign: 'center' },
	                            'type'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          campaignType
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Header,
	                            { as: 'h5', textAlign: 'center' },
	                            'tags'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          _lodash2.default.map(hashtagArray, function (h) {
	                            return _react2.default.createElement(_semanticUiReact.Label, { basic: true, content: h });
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Header,
	                            { as: 'h5', textAlign: 'center' },
	                            'dates'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          startDate,
	                          ' to ',
	                          endDate
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Notes for the influencer'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.TextArea, {
	                    style: { marginTop: 10 },
	                    placeholder: 'your notes will be added to the request email',
	                    name: 'notes',
	                    onChange: this.onChange,
	                    value: notes
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InviteModal;
	}(_react2.default.Component);
	
	InviteModal.propTypes = {
	  email: _propTypes2.default.string.isRequired,
	  thumbnail: _propTypes2.default.string.isRequired,
	  closeHandler: _propTypes2.default.func.isRequired,
	  sendHandler: _propTypes2.default.func.isRequired,
	  inviteSentOK: _propTypes2.default.bool.isRequired
	};
	
	exports.default = InviteModal;

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapperStyles = {
	  marginBottom: 30
	};
	
	var pStyles = {
	  textAlign: 'center',
	  margin: '20px 0px',
	  padding: '20px 0px',
	  borderTop: 'solid 1px #d8d8d8',
	  borderBottom: 'solid 1px #d8d8d8'
	};
	
	var buttonOptions = {
	  joined: {
	    color: 'black',
	    text: 'joined'
	  },
	  pending: {
	    color: 'grey',
	    text: 'pending...'
	  }
	};
	
	var getInvitationButton = function getInvitationButton(invitation) {
	  var options = invitation.type === 'campaignPermission' ? buttonOptions.joined : buttonOptions.pending;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Button,
	    { fluid: true, basic: true, disabled: true, color: options.color },
	    options.text
	  );
	};
	
	var getDeleteButton = function getDeleteButton(invitation, deleteHandler) {
	  return _react2.default.createElement(
	    _semanticUiReact.Button,
	    {
	      inverted: true,
	      onClick: function onClick() {
	        return deleteHandler(invitation);
	      },
	      circular: true,
	      color: 'red',
	      size: 'tiny'
	    },
	    'x'
	  );
	};
	var emptyTable = function emptyTable() {
	  return _react2.default.createElement(
	    'div',
	    { style: wrapperStyles },
	    _react2.default.createElement(
	      _semanticUiReact.Header,
	      { as: 'h3', textAlign: 'center' },
	      'Added'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: pStyles },
	      _react2.default.createElement(
	        'p',
	        null,
	        'You haven\'t added anyone yet.'
	      )
	    )
	  );
	};
	
	var emptySubTable = function emptySubTable(text) {
	  return _react2.default.createElement(
	    'div',
	    { style: wrapperStyles },
	    _react2.default.createElement(
	      'div',
	      { style: pStyles },
	      _react2.default.createElement(
	        'p',
	        null,
	        'You haven\'t added ',
	        text,
	        ' yet.'
	      )
	    )
	  );
	};
	
	var tableRow = function tableRow(i, deleteHandler, discussionNames) {
	  var discussionExists = _lodash2.default.includes(discussionNames, i.metadata.socialHandle);
	  var warningStyle = discussionExists ? {} : { backgroundColor: 'red' };
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    { key: i.id, style: warningStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      i.name,
	      '\xA0',
	      i.role === 'INFLUENCER' ? '(' + i.metadata.socialHandle + ')' : ''
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      i.role
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center' },
	      i.email
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { collapsing: true },
	      getInvitationButton(i)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { collapsing: true },
	      getDeleteButton(i, deleteHandler)
	    )
	  );
	};
	
	var getTable = function getTable(people, deleteHandler, discussions) {
	  var discussionNames = _lodash2.default.map(discussions, 'name');
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _lodash2.default.map(people, function (i) {
	        return tableRow(i, deleteHandler, discussionNames);
	      })
	    )
	  );
	};
	
	var InvitedTable = function InvitedTable(_ref) {
	  var campaign = _ref.campaign,
	      deleteHandler = _ref.deleteHandler;
	
	  if (!campaign) {
	    return emptyTable();
	  }
	
	  var combinedArrays = _lodash2.default.concat(campaign.members, campaign.pendingInvitations);
	  var discussions = campaign.discussions;
	
	  if (_lodash2.default.isEmpty(combinedArrays)) {
	    return emptyTable('anyone');
	  }
	
	  var influencers = _lodash2.default.filter(combinedArrays, { role: 'INFLUENCER' });
	  var team = _lodash2.default.filter(combinedArrays, { role: 'TEAM_MEMBER' });
	
	  return _react2.default.createElement(
	    'div',
	    { style: wrapperStyles },
	    _react2.default.createElement(
	      _semanticUiReact.Header,
	      { as: 'h3', textAlign: 'center' },
	      'Added'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Header,
	      { as: 'h4' },
	      'INFLUENCERS (',
	      influencers.length,
	      ')'
	    ),
	    _lodash2.default.isEmpty(influencers) ? emptySubTable('any influencers') : getTable(influencers, deleteHandler, discussions),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      _semanticUiReact.Header,
	      { as: 'h4' },
	      'TEAM MEMBERS'
	    ),
	    _lodash2.default.isEmpty(team) ? emptySubTable('any team members') : getTable(team)
	  );
	};
	
	InvitedTable.propTypes = {
	  campaign: _propTypes2.default.object.isRequired,
	  deleteHandler: _propTypes2.default.func.isRequired
	};
	
	exports.default = InvitedTable;

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(37);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioButtons = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Update semantic-react-ui and use the centered property on the Card.Group
	var FLEX_CENTERED_STYLE = {
	  alignItems: 'center',
	  justifyContent: 'center',
	  textAlign: 'center'
	};
	var buttonStyle = {
	  margin: '0 auto',
	  display: 'block'
	};
	
	var LimitsExceededModal = function LimitsExceededModal(_ref) {
	  var description = _ref.description,
	      assetType = _ref.assetType;
	
	  var text = description || 'Sorry, you have hit the limits of your current plan. Please upgrade your plan to add another ' + assetType + '.';
	  return _react2.default.createElement(
	    _semanticUiReact.Card.Group,
	    { style: FLEX_CENTERED_STYLE },
	    _react2.default.createElement(
	      _semanticUiReact.Card,
	      null,
	      _react2.default.createElement(_semanticUiReact.Card.Content, { header: 'Limits Exceeded' }),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { textAlign: 'center' },
	        _react2.default.createElement('img', { src: '/images/limits.svg', style: { height: '15em' }, alt: 'limits exceeded' })
	      ),
	      _react2.default.createElement(_semanticUiReact.Card.Content, { description: text }),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/team/manage' },
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                inverted: true,
	                color: 'pink',
	                floated: null,
	                style: buttonStyle,
	                fluid: true
	              },
	              'Upgrade now'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = LimitsExceededModal;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _papaparse = __webpack_require__(425);
	
	var _papaparse2 = _interopRequireDefault(_papaparse);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _reactFileDrop = __webpack_require__(724);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var messageStyles = {
	  width: '100%'
	};
	
	var dropZoneStyles = {
	  padding: '40px',
	  display: 'flex',
	  justifyContent: 'center',
	  flexDirection: 'column',
	  alignItems: 'center',
	  borderStyle: 'dashed'
	};
	
	var autoMargin = { margin: 'auto' };
	
	var creatorKeys = ['id', 'name', 'instagram', 'country', 'email', 'instagramId'];
	
	var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	var isValidEmail = function isValidEmail(email) {
	  if (!_lodash2.default.isString(email) || _lodash2.default.isEmpty(email)) {
	    return false;
	  }
	  return EMAIL_REGEX.test(email);
	};
	
	var parseCsv = function parseCsv(file) {
	  return new Promise(function (resolve, reject) {
	    _papaparse2.default.parse(file, {
	      header: true,
	      complete: function complete(results) {
	        var jsonData = results.data;
	        resolve(jsonData);
	      },
	      error: function error(_error) {
	        reject(_error);
	      }
	    });
	  });
	};
	
	var getDropZoneStyles = function getDropZoneStyles(dragOver, error) {
	  var dragOverStyles = dragOver ? { opacity: 0.5 } : {};
	  var backgroundStyles = {
	    borderColor: error ? '#e0b4b4' : '#DFDCDC',
	    backgroundColor: error ? '#fff6f6' : '#F8FAFA'
	  };
	  var textColor = error ? { color: '#9f3a38' } : {};
	  return _extends({}, dropZoneStyles, dragOverStyles, backgroundStyles, textColor);
	};
	
	var MailoutsCreateModal = function (_Component) {
	  _inherits(MailoutsCreateModal, _Component);
	
	  function MailoutsCreateModal(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, MailoutsCreateModal);
	
	    var _this = _possibleConstructorReturn(this, (MailoutsCreateModal.__proto__ || Object.getPrototypeOf(MailoutsCreateModal)).call(this, props));
	
	    _this.setFileInputRef = function (element) {
	      _this.fileInput = element;
	    };
	
	    _this.togglePreviouslyContacted = function () {
	      var _this$state = _this.state,
	          removePreviouslyContacted = _this$state.removePreviouslyContacted,
	          importData = _this$state.importData;
	
	      var creators = _lodash2.default.get(importData, 'creators');
	      _this.setState({ removePreviouslyContacted: !removePreviouslyContacted }, function () {
	        if (!removePreviouslyContacted && !_lodash2.default.isEmpty(creators)) {
	          _this.filterOrganisationInfluencers(creators);
	        }
	      });
	    };
	
	    _this.filterOrganisationInfluencers = function (list) {
	      var organisation = _this.props.organisation;
	
	      var payload = {
	        organisationId: organisation.id,
	        creators: list
	      };
	      _this.setState({
	        isLoading: true
	      });
	      return _this.emailProcessor.post('/mailouts/filter', payload).then(function (_ref) {
	        var data = _ref.data;
	
	        var creators = _lodash2.default.get(data, 'data.creators');
	        _this.setState({ isLoading: false, filteredList: creators });
	        return data;
	      }).catch(function (err) {
	        _this.setState({ filterError: err, filteredList: null });
	      }).finally(function () {
	        _this.setState({
	          isLoading: false
	        });
	      });
	    };
	
	    _this.onInputChanged = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(event, rest) {
	        var file, creators, uniqueCreators, filteredCreators, list, removePreviouslyContacted, name, value, checked;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                file = _lodash2.default.get(event, 'target.files.[0]');
	
	                if (!file) {
	                  _context.next = 16;
	                  break;
	                }
	
	                _context.next = 4;
	                return parseCsv(file);
	
	              case 4:
	                creators = _context.sent;
	
	                _this.setState(function (prev) {
	                  return { errors: _extends({}, prev.errors, { csvFile: null }) };
	                });
	                uniqueCreators = _lodash2.default.uniqBy(creators, 'instagram');
	                filteredCreators = _lodash2.default.filter(uniqueCreators, function (creator) {
	                  return isValidEmail(creator.email);
	                });
	                list = _lodash2.default.map(filteredCreators, function (creator) {
	                  return _lodash2.default.omit(creator, ['instagramHashtags']);
	                });
	                removePreviouslyContacted = _this.state.removePreviouslyContacted;
	
	                if (!removePreviouslyContacted) {
	                  _context.next = 13;
	                  break;
	                }
	
	                _context.next = 13;
	                return _this.filterOrganisationInfluencers(list);
	
	              case 13:
	
	                _this.setState({
	                  importData: {
	                    fileName: file.name,
	                    fileSize: file.size,
	                    creators: list
	                  }
	                });
	                _context.next = 18;
	                break;
	
	              case 16:
	                name = rest.name, value = rest.value, checked = rest.checked;
	
	                _this.setState(_defineProperty({}, name, value || checked));
	
	              case 18:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.clearFileInput = function () {
	      _this.setState({ importData: null, filteredList: null });
	    };
	
	    _this.handleFormSubmit = function (e) {
	      e.preventDefault();
	      var onSubmit = _this.props.onSubmit;
	      var _this$state2 = _this.state,
	          mailoutName = _this$state2.mailoutName,
	          importData = _this$state2.importData,
	          outreachEmailSubject = _this$state2.outreachEmailSubject,
	          outreachEmailTemplate = _this$state2.outreachEmailTemplate,
	          utmSource = _this$state2.utmSource,
	          editMode = _this$state2.editMode,
	          filteredList = _this$state2.filteredList,
	          removePreviouslyContacted = _this$state2.removePreviouslyContacted;
	
	      _this.setState({ errors: { mailoutName: null, csvFile: null, outreachEmailSubject: null, outreachEmailTemplate: null } });
	      var creators = removePreviouslyContacted ? filteredList : _lodash2.default.get(importData, 'creators', []);
	
	      var keyStatus = _lodash2.default.map(creatorKeys, function (key) {
	        return { key: key,
	          valid: _lodash2.default.every(creators, function (creator) {
	            return !_lodash2.default.isEmpty(_lodash2.default.get(creator, key));
	          }) };
	      });
	
	      var isCreatorsListValid = editMode ? true : !_lodash2.default.isEmpty(creators) && _lodash2.default.every(keyStatus, 'valid');
	      var isMailoutNameValid = !_lodash2.default.isEmpty(mailoutName);
	      var isSubjectValid = !_lodash2.default.isEmpty(outreachEmailSubject);
	      var isTemplateValid = !_lodash2.default.isEmpty(outreachEmailTemplate);
	      var isFormValid = isMailoutNameValid && isCreatorsListValid && isSubjectValid && isTemplateValid;
	      if (isFormValid) {
	        var chunks = _lodash2.default.chunk(creators, 200);
	        var payloads = _lodash2.default.map(chunks, function (chunkList, index) {
	          var name = index > 0 ? mailoutName + ' (' + index + ')' : mailoutName;
	          return { mailoutName: name, creators: chunkList, outreachEmailSubject: outreachEmailSubject, outreachEmailTemplate: outreachEmailTemplate, utmSource: utmSource };
	        });
	        var editPayload = { mailoutName: mailoutName, outreachEmailSubject: outreachEmailSubject, outreachEmailTemplate: outreachEmailTemplate, utmSource: utmSource };
	        onSubmit(editMode ? editPayload : payloads);
	      } else {
	        var missingKeys = _lodash2.default.map(_lodash2.default.reject(keyStatus, 'valid'), 'key');
	        var csvFileErrorMessage = _lodash2.default.isEmpty(creators) ? 'Creators list is empty' : 'CSV File is not valid. Missing keys: ' + _lodash2.default.join(missingKeys, ', ');
	        _this.setState({
	          errors: {
	            mailoutName: isMailoutNameValid ? null : 'This field is required',
	            csvFile: isCreatorsListValid ? null : csvFileErrorMessage,
	            outreachEmailTemplate: isTemplateValid ? null : 'This field is required',
	            outreachEmailSubject: isSubjectValid ? null : 'This field is required'
	          }
	        });
	      }
	    };
	
	    _this.onDragOver = function (e) {
	      var dragOver = _this.state.dragOver;
	
	      if (!dragOver) {
	        _this.setState({ dragOver: true });
	      }
	    };
	
	    _this.onDragLeave = function (e) {
	      _this.setState({ dragOver: false });
	    };
	
	    _this.onDrop = function (fileList) {
	      var event = { target: { files: [fileList[0]] } };
	      _this.onInputChanged(event);
	      _this.setState({ dragOver: false });
	    };
	
	    var mailout = _lodash2.default.get(props, 'mailout', {});
	    _this.state = _extends({}, mailout, {
	      editMode: !_lodash2.default.isEmpty(mailout),
	      errors: {},
	      filterError: null,
	      isLoading: false,
	      removePreviouslyContacted: false
	    });
	    var buildRESTClient = _this.props.buildRESTClient;
	
	    _this.emailProcessor = buildRESTClient({
	      baseURL: ("https://hjkv4vhd73.execute-api.eu-west-1.amazonaws.com/production") || '',
	      hasToken: false,
	      timeout: 100000
	    });
	    return _this;
	  }
	
	  _createClass(MailoutsCreateModal, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          onClose = _props.onClose,
	          isSubmitting = _props.isSubmitting,
	          error = _props.error;
	      var _state = this.state,
	          mailoutName = _state.mailoutName,
	          outreachEmailSubject = _state.outreachEmailSubject,
	          outreachEmailTemplate = _state.outreachEmailTemplate,
	          utmSource = _state.utmSource,
	          totalInfluencers = _state.totalInfluencers,
	          importData = _state.importData,
	          dragOver = _state.dragOver,
	          errors = _state.errors,
	          editMode = _state.editMode,
	          removePreviouslyContacted = _state.removePreviouslyContacted,
	          isLoading = _state.isLoading,
	          filterError = _state.filterError,
	          filteredList = _state.filteredList;
	
	
	      var selectedFileName = _lodash2.default.get(importData, 'fileName');
	      var creatorsCount = _lodash2.default.size(_lodash2.default.get(importData, 'creators'));
	      var filteredCreatorsCount = _lodash2.default.size(filteredList);
	      var csvFileError = Boolean(_lodash2.default.get(errors, 'csvFile'));
	      var dropzoneStyle = getDropZoneStyles(dragOver, csvFileError);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _dyzioModal2.default,
	          { headerText: editMode ? 'Edit Mailout' : 'Create Mailout', size: 'small', onClose: onClose },
	          _react2.default.createElement(
	            'div',
	            null,
	            (error || filterError) && _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  display: 'flex',
	                  justifyContent: 'center'
	                }
	              },
	              _react2.default.createElement(_semanticUiReact.Message, {
	                fluid: true,
	                style: messageStyles,
	                icon: 'frown',
	                error: true,
	                header: 'Error',
	                content: 'Something went wrong. Please try again later.'
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Form,
	              { onSubmit: this.handleFormSubmit },
	              _react2.default.createElement(
	                'div',
	                { style: { maxHeight: '70vh', overflow: 'auto', margin: '1.5rem' } },
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'mailoutName' },
	                    'Mailout name'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    placeholder: 'Enter mailout name',
	                    name: 'mailoutName',
	                    id: 'mailoutName',
	                    value: mailoutName,
	                    onChange: this.onInputChanged,
	                    error: Boolean(_lodash2.default.get(errors, 'mailoutName'))
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'outreachEmailSubject' },
	                    'Mailout subject'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    placeholder: 'Enter mailout subject',
	                    name: 'outreachEmailSubject',
	                    id: 'outreachEmailSubject',
	                    value: outreachEmailSubject,
	                    onChange: this.onInputChanged,
	                    error: Boolean(_lodash2.default.get(errors, 'outreachEmailSubject'))
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'outreachEmailSubject' },
	                    'Mailout template'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    placeholder: 'Enter mailout template',
	                    name: 'outreachEmailTemplate',
	                    id: 'outreachEmailTemplate',
	                    value: outreachEmailTemplate,
	                    onChange: this.onInputChanged,
	                    error: Boolean(_lodash2.default.get(errors, 'outreachEmailTemplate'))
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'outreachEmailSubject' },
	                    'UTM Source'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    placeholder: 'Enter utm source',
	                    name: 'utmSource',
	                    id: 'utmSource',
	                    value: utmSource,
	                    onChange: this.onInputChanged,
	                    error: Boolean(_lodash2.default.get(errors, 'utmSource'))
	                  })
	                ),
	                !editMode && _react2.default.createElement(_semanticUiReact.Form.Radio, {
	                  toggle: true,
	                  label: 'Remove any creators who have been previously contacted for this brand?',
	                  name: 'removePreviouslyContacted',
	                  checked: removePreviouslyContacted,
	                  onChange: this.togglePreviouslyContacted
	                }),
	                editMode && _react2.default.createElement(
	                  'h5',
	                  { style: { color: 'rgba(0, 0, 0, 0.4)' } },
	                  'Total Influencers: ',
	                  totalInfluencers,
	                  ' '
	                ),
	                !editMode && _react2.default.createElement(
	                  _reactFileDrop.FileDrop,
	                  {
	                    frame: document,
	                    onDragOver: isLoading ? _lodash2.default.noop : this.onDragOver,
	                    onDragLeave: isLoading ? _lodash2.default.noop : this.onDragLeave,
	                    onDrop: isLoading ? _lodash2.default.noop : this.onDrop,
	                    targetAlwaysVisible: true
	                  },
	                  _react2.default.createElement(
	                    _semanticUiReact.Segment,
	                    { style: dropzoneStyle },
	                    !csvFileError && _react2.default.createElement(
	                      'h2',
	                      null,
	                      'Drop File Here'
	                    ),
	                    csvFileError && _react2.default.createElement(
	                      'div',
	                      { style: { textAlign: 'center' } },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Invalid CSV file'
	                      ),
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        _lodash2.default.get(errors, 'csvFile', 'Please check csv file structure')
	                      )
	                    ),
	                    !selectedFileName && _react2.default.createElement(
	                      'div',
	                      { style: { marginTop: '10px' } },
	                      _react2.default.createElement(
	                        'p',
	                        { style: { color: 'rgba(0,0,0,.4)', fontSize: '14px' } },
	                        'Drag and Drop a csv file or click the button to upload'
	                      )
	                    ),
	                    selectedFileName && _react2.default.createElement(
	                      'div',
	                      { style: { display: 'flex' } },
	                      _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: '10px', textAlign: 'center' } },
	                        _react2.default.createElement(
	                          'p',
	                          { style: { color: 'rgba(0,0,0,.4)', fontSize: '16px' } },
	                          selectedFileName
	                        ),
	                        !removePreviouslyContacted && _react2.default.createElement(
	                          'p',
	                          { style: { color: 'rgba(0,0,0,.4)', fontSize: '12px' } },
	                          creatorsCount,
	                          ' unique creators'
	                        ),
	                        removePreviouslyContacted && !isLoading && _react2.default.createElement(
	                          'p',
	                          { style: { color: 'rgba(0,0,0,.4)', fontSize: '12px' } },
	                          filteredCreatorsCount,
	                          ' unique creators for brand'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement('input', {
	                      ref: this.setFileInputRef,
	                      type: 'file', accept: '.csv', onChange: this.onInputChanged, hidden: true
	                    }),
	                    _react2.default.createElement(
	                      'div',
	                      { style: { marginTop: '20px' } },
	                      _react2.default.createElement(_semanticUiReact.Form.Button, {
	                        color: 'pink',
	                        icon: 'upload',
	                        style: autoMargin,
	                        content: 'Upload',
	                        type: 'button',
	                        loading: isLoading,
	                        onClick: isLoading ? _lodash2.default.noop : function () {
	                          return _this3.fileInput.click();
	                        }
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'flex',
	                  style: {
	                    justifyContent: 'flex-end',
	                    padding: '10px 0px 10px 0px'
	                  }
	                },
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Button,
	                  {
	                    loading: isSubmitting,
	                    disabled: isSubmitting || isLoading,
	                    color: 'pink',
	                    type: 'submit',
	                    size: 'medium'
	                  },
	                  'Submit'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MailoutsCreateModal;
	}(_react.Component);
	
	MailoutsCreateModal.propTypes = {
	  buildRESTClient: _propTypes2.default.func.isRequired,
	  organisation: _propTypes2.default.object.isRequired,
	  onClose: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  isSubmitting: _propTypes2.default.bool,
	  error: _propTypes2.default.any
	};
	MailoutsCreateModal.defaultProps = {
	  onClose: _lodash2.default.noop,
	  onSubmit: _lodash2.default.noop,
	  isSubmitting: false,
	  error: null
	};
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _hasRestClient2.default)(MailoutsCreateModal);

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _immutable = __webpack_require__(34);
	
	var _avatar = __webpack_require__(191);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _actions = __webpack_require__(907);
	
	var _staticConfiguration = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Member = function (_React$Component) {
	  _inherits(Member, _React$Component);
	
	  function Member(props, context) {
	    _classCallCheck(this, Member);
	
	    var _this = _possibleConstructorReturn(this, (Member.__proto__ || Object.getPrototypeOf(Member)).call(this, props, context));
	
	    _this.toggleMeta = function () {
	      if (_this.state.open) {
	        _this.setState({ open: false });
	      } else {
	        _this.setState({ open: true });
	      }
	    };
	
	    _this.state = {
	      open: false
	    };
	    return _this;
	  }
	
	  _createClass(Member, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          member = _props.member,
	          deleteMember = _props.deleteMember,
	          deletable = _props.deletable,
	          removeMemberLoading = _props.removeMemberLoading,
	          removeMemberId = _props.removeMemberId,
	          onShowRemoveModal = _props.onShowRemoveModal,
	          onHideRemoveModal = _props.onHideRemoveModal;
	
	
	      var id = member.get('id');
	      var name = member.get('name');
	      var email = member.get('email');
	      var role = member.get('role');
	      var link = member.get('link');
	
	      // Member role specific information
	      var influencersManaging = member.getIn(['metadata', 'influencersManaging']) || (0, _immutable.fromJS)({});
	      var platforms = member.getIn(['metadata', 'platforms']) || (0, _immutable.fromJS)([]);
	      var socialHandle = member.getIn(['metadata', 'socialHandle']) || '';
	      var company = member.getIn(['metadata', 'company']) || '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-2-6 grid-xl-2-6' },
	        _react2.default.createElement(
	          'div',
	          { className: 'member' },
	          _react2.default.createElement(
	            'div',
	            { className: 'member-data' },
	            _react2.default.createElement(
	              'div',
	              { className: 'left' },
	              _react2.default.createElement(_avatar2.default, { name: name, role: role, email: email, size: 44 })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                name && name.length > 0 ? name : email
	              )
	            ),
	            deletable && _react2.default.createElement(
	              'div',
	              { className: 'right' },
	              _react2.default.createElement('img', {
	                src: '/icons/close.svg',
	                alt: 'close',
	                onClick: function onClick() {
	                  return onShowRemoveModal(id);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'member-meta' },
	            _react2.default.createElement(
	              'div',
	              { className: this.state.open ? 'meta-toggle open' : 'meta-toggle', onClick: this.toggleMeta },
	              _react2.default.createElement(
	                'p',
	                { className: 'small light' },
	                'Show details'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement('img', { src: '/icons/chevron-down.svg', alt: 'show details arrow' })
	              )
	            ),
	            this.state.open && _react2.default.createElement(
	              'div',
	              { className: 'meta-details' },
	              _react2.default.createElement(
	                'p',
	                { className: 'small' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'light' },
	                  'Email:\xA0\xA0'
	                ),
	                email
	              ),
	              link && _react2.default.createElement(
	                'p',
	                { className: 'small' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'light' },
	                  'Invite:\xA0\xA0'
	                ),
	                link
	              ),
	              role === _staticConfiguration.INFLUENCER && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  { className: 'small' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'light' },
	                    'Social Handle:\xA0\xA0'
	                  ),
	                  socialHandle
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'small' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'light' },
	                    'Platforms:\xA0\xA0'
	                  ),
	                  platforms.map(function (socialAccount, index) {
	                    return _react2.default.createElement(
	                      'span',
	                      { key: socialAccount },
	                      socialAccount,
	                      index + 1 < platforms.size ? ', ' : ''
	                    );
	                  })
	                )
	              ),
	              role === _staticConfiguration.TALENT_AGENT && _react2.default.createElement(
	                'p',
	                { className: 'small' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'light' },
	                  'Influencers:\xA0\xA0'
	                ),
	                influencersManaging.map(function (influencer) {
	                  return _react2.default.createElement(
	                    'span',
	                    { key: influencer },
	                    influencer
	                  );
	                }),
	                ' '
	              ),
	              role === _staticConfiguration.PRODUCTION_COMPANY && _react2.default.createElement(
	                'p',
	                { className: 'small' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'light' },
	                  'Company:\xA0\xA0'
	                ),
	                company
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: removeMemberId === id ? 'custom-modal visible' : 'custom-modal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'top' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Are you sure?'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-close' },
	              _react2.default.createElement('img', { src: '/icons/close.svg', alt: 'close', onClick: function onClick() {
	                  return onHideRemoveModal();
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Before you continue, be aware that removing a campaign member cannot be undone.'
	              ),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              removeMemberLoading ? _react2.default.createElement(
	                'button',
	                { className: 'large rose stretch' },
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'dots' },
	                  _react2.default.createElement('li', { id: 'dot1' }),
	                  _react2.default.createElement('li', null),
	                  _react2.default.createElement('li', { id: 'dot2' }),
	                  _react2.default.createElement('li', null),
	                  _react2.default.createElement('li', { id: 'dot3' })
	                )
	              ) : _react2.default.createElement(
	                'button',
	                { className: 'large rose stretch', onClick: function onClick() {
	                    return deleteMember();
	                  } },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Remove member'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Member;
	}(_react2.default.Component);
	
	Member.propTypes = {
	  member: _react2.default.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    removeMemberLoading: state.members.get('removeMemberLoading'),
	    removeMemberError: state.members.get('removeMemberError'),
	    removeMemberId: state.members.get('removeMemberId')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onShowRemoveModal: function onShowRemoveModal(id) {
	      return dispatch((0, _actions.showRemoveModal)(id));
	    },
	    onHideRemoveModal: function onHideRemoveModal() {
	      return dispatch((0, _actions.hideRemoveModal)());
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Member);

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FORM_TYPES = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDatepicker = __webpack_require__(445);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _countryData = __webpack_require__(175);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _hashtagsInput = __webpack_require__(877);
	
	var _hashtagsInput2 = _interopRequireDefault(_hashtagsInput);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _currencies = __webpack_require__(128);
	
	var _hasOrganisation = __webpack_require__(106);
	
	var _hasOrganisation2 = _interopRequireDefault(_hasOrganisation);
	
	var _hashtagsUtils = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var currencyDropDownStyle = { marginTop: 8, marginBottom: 8 };
	var requiredLabelStyle = { color: 'red' };
	var RequiredLabel = function RequiredLabel() {
	  return _react2.default.createElement(
	    'span',
	    { style: requiredLabelStyle },
	    '*'
	  );
	};
	
	var EMV_HELP_LINK = 'https://help.dyzio.co/en/articles/4156487-estimated-earned-media-value-emv-report';
	var MANAGE_ORG_LINK = '/team/manage';
	
	var FEATURE_TOGGLE_STICKERS = true;
	
	var FORM_TYPES = exports.FORM_TYPES = {
	  BASIC: 'BASIC',
	  ADVANCED: 'ADVANCEE'
	};
	
	var dividerStyle = {
	  width: '100%',
	  height: 5
	};
	
	var radioLabelStyle = {
	  'vertical-align': 'super'
	};
	
	var marginBottom10 = {
	  marginBottom: 10
	};
	
	var borderStyle = {
	  marginTop: 20,
	  padding: 10,
	  border: '1px solid'
	};
	
	var cmpStyle = {
	  marginTop: 5
	};
	
	var initialEmptyState = {
	  name: '',
	  budget: '',
	  liveDate: '',
	  endDate: '',
	  hashtags: '',
	  currency: '',
	  impressionsCPM: '',
	  engagementsCPM: '',
	  ieRatio: '',
	  campaignCode: '',
	  sendChaseEmails: undefined,
	  brand: '',
	  country: null,
	  useEstimatedReachAndImpressions: false
	};
	
	var NewCampaignForm = function (_Component) {
	  _inherits(NewCampaignForm, _Component);
	
	  function NewCampaignForm(props) {
	    _classCallCheck(this, NewCampaignForm);
	
	    var _this = _possibleConstructorReturn(this, (NewCampaignForm.__proto__ || Object.getPrototypeOf(NewCampaignForm)).call(this, props));
	
	    _this.onInputChanged = function (event, _ref) {
	      var name = _ref.name,
	          value = _ref.value,
	          checked = _ref.checked;
	
	      _this.setState(_defineProperty({}, name, value || checked));
	    };
	
	    _this.onCurrencyChanged = function (event, _ref2) {
	      var value = _ref2.value;
	
	      _this.onInputChanged(event, { name: 'currency', value: value });
	    };
	
	    _this.onLiveDateChange = function (date) {
	      _this.setState({
	        liveDate: date
	      });
	    };
	
	    _this.onEndDateChange = function (date) {
	      _this.setState({
	        endDate: date
	      });
	    };
	
	    _this.shouldDisableSubmitButton = function () {
	      var campaignType = _this.props.campaignType;
	      var _this$state = _this.state,
	          name = _this$state.name,
	          hashtags = _this$state.hashtags,
	          budget = _this$state.budget,
	          liveDate = _this$state.liveDate,
	          endDate = _this$state.endDate;
	
	      var isNameEmpty = _lodash2.default.isEmpty(name);
	      var noHashtags = _lodash2.default.isEmpty(hashtags);
	      var noBudget = _lodash2.default.isEmpty(_lodash2.default.toString(budget));
	      var noLiveDate = _lodash2.default.isEmpty(liveDate);
	      var noEndDate = _lodash2.default.isEmpty(endDate);
	
	      if (campaignType === 'ACR') {
	        return isNameEmpty;
	      }
	      return isNameEmpty || noHashtags || noBudget || noLiveDate || noEndDate;
	    };
	
	    _this.handleFormSubmit = function () {
	      var _this$state2 = _this.state,
	          name = _this$state2.name,
	          budget = _this$state2.budget,
	          currency = _this$state2.currency,
	          liveDate = _this$state2.liveDate,
	          endDate = _this$state2.endDate,
	          hashtags = _this$state2.hashtags,
	          impressionsCPM = _this$state2.impressionsCPM,
	          engagementsCPM = _this$state2.engagementsCPM,
	          ieRatio = _this$state2.ieRatio,
	          campaignCode = _this$state2.campaignCode,
	          sendChaseEmails = _this$state2.sendChaseEmails,
	          brand = _this$state2.brand,
	          country = _this$state2.country,
	          useEstimatedReachAndImpressions = _this$state2.useEstimatedReachAndImpressions;
	      var _this$props = _this.props,
	          onFormSubmit = _this$props.onFormSubmit,
	          campaignType = _this$props.campaignType,
	          organisation = _this$props.organisation;
	
	      var scanUnauthorisedStories = _lodash2.default.get(organisation, 'isStickerScannerEnabled');
	      onFormSubmit({
	        name: name,
	        budget: budget,
	        currency: currency,
	        liveDate: liveDate,
	        endDate: endDate,
	        campaignType: campaignType,
	        hashtags: hashtags,
	        impressionsCPM: impressionsCPM,
	        engagementsCPM: engagementsCPM,
	        ieRatio: ieRatio,
	        campaignCode: campaignCode,
	        sendChaseEmails: sendChaseEmails,
	        brand: brand,
	        country: country,
	        scanUnauthorisedStories: scanUnauthorisedStories,
	        useEstimatedReachAndImpressions: useEstimatedReachAndImpressions
	      });
	    };
	
	    var inEditMode = props.inEditMode;
	
	    var initialState = inEditMode ? _lodash2.default.pick(props, ['name', 'budget', 'liveDate', 'endDate', 'hashtags', 'currency', 'impressionsCPM', 'engagementsCPM', 'ieRatio', 'campaignCode', 'sendChaseEmails', 'brand', 'country', 'useEstimatedReachAndImpressions']) : initialEmptyState;
	    _this.state = initialState;
	    return _this;
	  }
	
	  _createClass(NewCampaignForm, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          campaignType = _props.campaignType,
	          onBackClick = _props.onBackClick,
	          inEditMode = _props.inEditMode,
	          formType = _props.formType,
	          organisation = _props.organisation;
	      var _state = this.state,
	          name = _state.name,
	          budget = _state.budget,
	          currency = _state.currency,
	          liveDate = _state.liveDate,
	          endDate = _state.endDate,
	          hashtags = _state.hashtags,
	          impressionsCPM = _state.impressionsCPM,
	          engagementsCPM = _state.engagementsCPM,
	          ieRatio = _state.ieRatio,
	          campaignCode = _state.campaignCode,
	          sendChaseEmails = _state.sendChaseEmails,
	          brand = _state.brand,
	          country = _state.country,
	          useEstimatedReachAndImpressions = _state.useEstimatedReachAndImpressions;
	
	
	      var countryOptions = _lodash2.default.map(_lodash2.default.reject(_countryData.countries.all, function (item) {
	        return _lodash2.default.isEmpty(item.emoji);
	      }), function (item) {
	        return {
	          text: item.emoji + ' ' + item.name,
	          key: item.alpha2,
	          value: item.alpha2
	        };
	      });
	
	      countryOptions.unshift({
	        text: '<<< No Country >>>',
	        style: { color: 'gray' },
	        key: 'no-country',
	        value: null
	      });
	
	      var isSubmitButtonDisabled = this.shouldDisableSubmitButton();
	
	      var tags = (0, _hashtagsUtils.transformHashtagstIntoArray)(hashtags);
	
	      var liveDateMoment = liveDate && (0, _moment2.default)(liveDate).isValid() ? (0, _moment2.default)(liveDate) : false;
	      var endDateMoment = endDate && (0, _moment2.default)(endDate).isValid() ? (0, _moment2.default)(endDate) : false;
	
	      var inAdvancedFormMode = formType === FORM_TYPES.ADVANCED;
	      var noPadding = { padding: 0 };
	      var isStickerScannerEnabled = _lodash2.default.get(organisation, 'isStickerScannerEnabled');
	      var isEstimatedReachAndImpressionsEnabled = _lodash2.default.get(organisation, 'isEstimatedReachAndImpressionsEnabled');
	      var upgradePlan = !isStickerScannerEnabled || !isEstimatedReachAndImpressionsEnabled;
	
	      var safeEndDate = endDateMoment ? endDateMoment.set({ hour: 15, minute: 15 }) : null;
	      var safeLiveDate = liveDateMoment ? liveDateMoment.set({ hour: 15, minute: 15 }) : null;
	
	      var startsInThePast = safeLiveDate ? (0, _moment2.default)(safeLiveDate).isBefore((0, _moment2.default)().startOf('day')) : false;
	
	      var liveDateChanged = liveDate !== this.props.liveDate;
	
	      var shouldWarnPastLiveDate = startsInThePast && !inEditMode || inEditMode && liveDateChanged && startsInThePast;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Form,
	        { onSubmit: this.handleFormSubmit },
	        _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { basic: !inAdvancedFormMode, style: inAdvancedFormMode ? null : noPadding },
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'campaign-name' },
	              'Campaign name',
	              _react2.default.createElement(RequiredLabel, null)
	            ),
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              onChange: this.onInputChanged,
	              placeholder: 'e.g. Sky Westworld',
	              name: 'name',
	              value: name
	            })
	          ),
	          campaignType !== 'ACR' && _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'campaign-brand' },
	              'Brand'
	            ),
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              onChange: this.onInputChanged,
	              placeholder: 'e.g. Olay',
	              name: 'brand',
	              value: brand
	            })
	          ),
	          campaignType !== 'ACR' && _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'campaign-currencies' },
	              'Currency'
	            ),
	            _react2.default.createElement(_semanticUiReact.Dropdown, {
	              fluid: true,
	              search: true,
	              style: currencyDropDownStyle,
	              onChange: this.onCurrencyChanged,
	              value: currency || _currencies.CURRENCY_GBP,
	              name: 'currency',
	              options: _currencies.DYZIO_CURRENCIES
	            })
	          ),
	          campaignType !== 'ACR' && _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'campaign-budget' },
	              'Total Budget',
	              _react2.default.createElement(RequiredLabel, null),
	              ' ',
	              _react2.default.createElement(_semanticUiReact.Popup, {
	                content: 'The Total Budget is added to the Influencer Fees section, and is used to calculate the allocated and remaining budget on your campaign. Please add zero if it\'s a free / gifted campaign.',
	                trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'help circle', className: 'circular' })
	              })
	            ),
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              type: 'number',
	              onChange: this.onInputChanged,
	              placeholder: 'e.g. \xA310,000',
	              name: 'budget',
	              value: budget
	            })
	          ),
	          campaignType !== 'ACR' && _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'campaign-live-date' },
	              'Live Date',
	              _react2.default.createElement(RequiredLabel, null)
	            ),
	            _react2.default.createElement(_reactDatepicker2.default, {
	              onChange: this.onLiveDateChange,
	              placeholderText: 'e.g. 01/05/2018',
	              selected: liveDateMoment ? liveDateMoment.set({ hour: 15, minute: 15 }) : null,
	              dateFormat: 'MMM Do YYYY',
	              selectsStart: true,
	              endDate: safeEndDate,
	              maxDate: safeEndDate
	            })
	          ),
	          campaignType !== 'ACR' && _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'campaign-end-date' },
	              'End Date',
	              _react2.default.createElement(RequiredLabel, null)
	            ),
	            _react2.default.createElement(_reactDatepicker2.default, {
	              onChange: this.onEndDateChange,
	              placeholderText: 'e.g. 20/05/2018',
	              selected: endDateMoment ? endDateMoment.set({ hour: 15, minute: 15 }) : null,
	              endDate: safeEndDate,
	              minDate: safeLiveDate,
	              startDate: safeLiveDate,
	              selectsEnd: true,
	              dateFormat: 'MMM Do YYYY'
	
	            })
	          ),
	          campaignType !== 'ACR' && _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'campaign-country' },
	              'Country (optional)'
	            ),
	            _react2.default.createElement(_semanticUiReact.Dropdown, {
	              name: 'country',
	              placeholder: 'e.g United Kingdom',
	              search: true,
	              selection: true,
	              value: country,
	              onChange: this.onInputChanged,
	              options: countryOptions
	            })
	          ),
	          campaignType !== 'ACR' && _react2.default.createElement(_hashtagsInput2.default, {
	            onValueChanged: this.onInputChanged,
	            campaignType: campaignType,
	            hashtags: tags
	          }),
	          inAdvancedFormMode && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Form.Field,
	              null,
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'campaign-code' },
	                'Campaign Code'
	              ),
	              _react2.default.createElement(_semanticUiReact.Form.Input, {
	                onChange: this.onInputChanged,
	                placeholderText: 'e.g. nike2020',
	                name: 'campaignCode',
	                value: campaignCode
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Form.Field,
	              null,
	              _react2.default.createElement(_semanticUiReact.Checkbox, {
	                name: 'sendChaseEmails',
	                onChange: this.onInputChanged,
	                label: 'Send chase email',
	                defaultChecked: sendChaseEmails,
	                checked: sendChaseEmails
	              })
	            )
	          ),
	          FEATURE_TOGGLE_STICKERS && _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            { style: borderStyle },
	            upgradePlan && _react2.default.createElement(
	              'label',
	              { htmlFor: 'story-scanner', style: marginBottom10 },
	              'These features are available on paid plans. Click ',
	              _react2.default.createElement(
	                _targetLink2.default,
	                { href: MANAGE_ORG_LINK, renderIf: true },
	                'here'
	              ),
	              ' to upgrade.'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_semanticUiReact.Radio, {
	                toggle: true, checked: isStickerScannerEnabled,
	                disabled: true
	              }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { style: radioLabelStyle },
	                'Capture Instagram Story Media'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_semanticUiReact.Radio, {
	                toggle: true, checked: useEstimatedReachAndImpressions,
	                disabled: !isEstimatedReachAndImpressionsEnabled,
	                onChange: function onChange() {
	                  _this2.setState({ useEstimatedReachAndImpressions: !useEstimatedReachAndImpressions });
	                }
	              }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { style: radioLabelStyle },
	                'Estimated Reach & Impression'
	              )
	            )
	          )
	        ),
	        inAdvancedFormMode && _react2.default.createElement(
	          _semanticUiReact.Segment,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Report Settings'
	          ),
	          _react2.default.createElement('div', { style: dividerStyle }),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            { inline: true },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'cmp' },
	              'Impressions CPM'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	            _react2.default.createElement(
	              _semanticUiReact.Input,
	              {
	                onChange: this.onInputChanged,
	                name: 'impressionsCPM',
	                value: impressionsCPM,
	                type: 'number',
	                style: cmpStyle,
	                labelPosition: 'left',
	                fluid: true,
	                step: '0.01',
	                min: '0',
	                placeholder: 'Enter CPM...'
	              },
	              _react2.default.createElement(
	                _semanticUiReact.Label,
	                { basic: true },
	                (0, _currencies.renderCurrencySymbol)(currency)
	              ),
	              _react2.default.createElement('input', null)
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Add an impressions CPM in order to create a top level campaign Earned Media Value (EMV) report. Find out more ',
	            _react2.default.createElement(
	              _targetLink2.default,
	              { href: EMV_HELP_LINK, renderIf: true },
	              'here'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            { inline: true },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'cmp' },
	              'Engagements CPM'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	            _react2.default.createElement(
	              _semanticUiReact.Input,
	              {
	                onChange: this.onInputChanged,
	                name: 'engagementsCPM',
	                value: engagementsCPM,
	                type: 'number',
	                style: cmpStyle,
	                labelPosition: 'left',
	                fluid: true,
	                step: '0.01',
	                min: '0',
	                placeholder: 'Enter CPM...'
	              },
	              _react2.default.createElement(
	                _semanticUiReact.Label,
	                { basic: true },
	                (0, _currencies.renderCurrencySymbol)(currency)
	              ),
	              _react2.default.createElement('input', null)
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Add an engagements CPM in order to create a top level campaign Earned Media Value (EMV) report. Find out more ',
	            _react2.default.createElement(
	              _targetLink2.default,
	              { href: EMV_HELP_LINK, renderIf: true },
	              'here'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            { inline: true },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'cmp' },
	              'I/E Ratio'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	            _react2.default.createElement(
	              _semanticUiReact.Input,
	              {
	                onChange: this.onInputChanged,
	                name: 'ieRatio',
	                value: ieRatio,
	                type: 'number',
	                style: cmpStyle,
	                labelPosition: 'left',
	                fluid: true,
	                step: '0.01',
	                min: '0',
	                placeholder: 'Enter CPM...'
	              },
	              _react2.default.createElement(
	                _semanticUiReact.Label,
	                { basic: true },
	                '\u03C6'
	              ),
	              _react2.default.createElement('input', null)
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The ratio of impressions to engagements for an influencer. This is used to estimate impressions for an influencer who has not authorised. A typical value would be around 10. Find out more ',
	            _react2.default.createElement(
	              _targetLink2.default,
	              { href: EMV_HELP_LINK, renderIf: true },
	              'here'
	            ),
	            '.'
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        shouldWarnPastLiveDate && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { negative: true },
	          _react2.default.createElement(
	            _semanticUiReact.MessageHeader,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning circle' }),
	            'Your campaign starts in the past'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Dyzio cannot track stories posted earlier than 24 hours ago'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { stretched: true },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            onBackClick && _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 6 },
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  fluid: true,
	                  type: 'button',
	                  onClick: onBackClick
	                },
	                'Back'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: onBackClick ? 10 : 16 },
	              _react2.default.createElement(
	                _semanticUiReact.Form.Field,
	                null,
	                _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	                  fluid: true,
	                  disabled: isSubmitButtonDisabled,
	                  label: inEditMode ? 'Save campaign' : 'Add campaign',
	                  hasIcon: true,
	                  icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'save' }),
	                  floated: onBackClick ? 'right' : 'left'
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewCampaignForm;
	}(_react.Component);
	
	NewCampaignForm.propTypes = {
	  formType: _propTypes2.default.oneOf(_lodash2.default.values(FORM_TYPES)),
	  inEditMode: _propTypes2.default.bool,
	  onFormSubmit: _propTypes2.default.func.isRequired,
	  campaignType: _propTypes2.default.string.isRequired,
	  onBackClick: _propTypes2.default.func,
	  organisation: _propTypes2.default.object.isRequired
	};
	
	NewCampaignForm.defaultProps = {
	  onBackClick: null,
	  inEditMode: false,
	  formType: FORM_TYPES.BASIC
	};
	
	exports.default = (0, _recompose.compose)(_hasOrganisation2.default)(NewCampaignForm);

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(37);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalStyle = {
	  textAlign: 'center',
	  color: '#777'
	};
	
	var nameStyle = {
	  marginTop: 10,
	  marginBottom: 10,
	  display: 'block'
	};
	
	var redirectTo = function redirectTo(href, router) {
	  // eslint-disable-next-line lodash/prefer-lodash-method
	  router.push('/logout?redirect_uri=' + href);
	};
	
	var OriginBasedLock = function OriginBasedLock(_ref) {
	  var requiredOrigin = _ref.requiredOrigin,
	      organisationName = _ref.organisationName,
	      router = _ref.router;
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      open: true,
	      style: modalStyle,
	      size: 'small'
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Header,
	        { as: 'h2', icon: true },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning sign', color: 'orange' }),
	        _react2.default.createElement(
	          'h2',
	          { style: nameStyle },
	          organisationName
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Header.Subheader,
	          null,
	          'In order for the system to work properly you must login at  ',
	          _react2.default.createElement(
	            _targetLink2.default,
	            { renderIf: true, href: requiredOrigin },
	            requiredOrigin
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { color: 'pink', onClick: function onClick() {
	                return redirectTo(requiredOrigin, router);
	              } },
	            'Go to ',
	            requiredOrigin
	          )
	        )
	      )
	    )
	  );
	};
	
	OriginBasedLock.propTypes = {
	  requiredOrigin: _propTypes2.default.string.isRequired,
	  organisationName: _propTypes2.default.string.isRequired,
	  router: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(OriginBasedLock);

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _uploader = __webpack_require__(353);
	
	var _uploader2 = _interopRequireDefault(_uploader);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _staticConfiguration2 = _interopRequireDefault(_staticConfiguration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var messageStyles = {
	  width: '100%',
	  marginBottom: '10px'
	};
	
	var ReportUploadModal = function (_Component) {
	  _inherits(ReportUploadModal, _Component);
	
	  function ReportUploadModal(props) {
	    _classCallCheck(this, ReportUploadModal);
	
	    var _this = _possibleConstructorReturn(this, (ReportUploadModal.__proto__ || Object.getPrototypeOf(ReportUploadModal)).call(this, props));
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var onSubmit = _this.props.onSubmit;
	      var documentData = _this.state.documentData;
	
	      if (documentData.filePath) {
	        onSubmit(documentData);
	      }
	    };
	
	    _this.updateUploaderState = function (newUploaderState) {
	      var isSubmitting = _this.props.isSubmitting;
	
	      if (!isSubmitting) {
	        _this.setState({ uploaderState: newUploaderState });
	      }
	    };
	
	    _this.uploadDataCallback = function (documentData) {
	      _this.setState({ documentData: documentData });
	    };
	
	    _this.state = { uploaderState: 1, documentData: {} };
	    return _this;
	  }
	
	  _createClass(ReportUploadModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onClose = _props.onClose,
	          isSubmitting = _props.isSubmitting,
	          error = _props.error;
	      var _state = this.state,
	          uploaderState = _state.uploaderState,
	          documentData = _state.documentData;
	
	      console.log('Document data: ', documentData);
	      var submitDisabled = isSubmitting || !documentData.filePath;
	      console.log('Submit Disabled: ', isSubmitting, !documentData.filePath, submitDisabled);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _dyzioModal2.default,
	          { headerText: 'Import', size: 'small', onClose: onClose },
	          _react2.default.createElement(
	            'div',
	            null,
	            error && _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  display: 'flex',
	                  justifyContent: 'center'
	                }
	              },
	              _react2.default.createElement(_semanticUiReact.Message, {
	                fluid: true,
	                style: messageStyles,
	                icon: 'frown',
	                error: true,
	                header: 'Error',
	                content: error
	              })
	            ),
	            isSubmitting && _react2.default.createElement(_semanticUiReact.Message, {
	              fluid: true,
	              style: messageStyles,
	              icon: 'clock outline',
	              color: 'orange',
	              header: 'Importing',
	              content: 'Report is being imported. Please refresh the page after few minutes.'
	            }),
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Upload report'
	            ),
	            _react2.default.createElement(
	              'h5',
	              { style: { color: 'rgba(0,0,0,0.4)' } },
	              'Please select a .xlsx report file'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(_uploader2.default, {
	              uploaderState: uploaderState,
	              updateUploaderState: this.updateUploaderState,
	              docType: _staticConfiguration2.default,
	              uploadDataCallback: this.uploadDataCallback
	            }),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'flex',
	                style: {
	                  justifyContent: 'flex-end',
	                  padding: '10px 0px 10px 0px'
	                }
	              },
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  loading: isSubmitting,
	                  disabled: submitDisabled,
	                  color: 'pink',
	                  type: 'submit',
	                  size: 'medium',
	                  onClick: this.handleSubmit
	                },
	                'Submit'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReportUploadModal;
	}(_react.Component);
	
	ReportUploadModal.propTypes = {
	  onClose: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  isSubmitting: _propTypes2.default.bool,
	  error: _propTypes2.default.any
	};
	ReportUploadModal.defaultProps = {
	  onClose: _lodash2.default.noop,
	  onSubmit: _lodash2.default.noop,
	  isSubmitting: false,
	  error: null
	};
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default)(ReportUploadModal);

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _discountCodesSelector = __webpack_require__(868);
	
	var _discountCodesSelector2 = _interopRequireDefault(_discountCodesSelector);
	
	var _reactCopyToClipboard = __webpack_require__(315);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SHOPIFY_HELP_LINK = 'https://help.shopify.com/en/manual/discounts/create-discount-codes';
	var DISCOUNT_HELP_LINK = 'https://help.dyzio.co/en/articles/5517378-shopify-integration';
	
	var shopifyLogoStyle = {
	  height: '1.2em'
	};
	
	var iconMarginLeftStyle = {
	  marginLeft: 5
	};
	
	var buttonStyles = {
	  width: 'auto'
	};
	
	var ShopifyConfig = function (_Component) {
	  _inherits(ShopifyConfig, _Component);
	
	  function ShopifyConfig(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ShopifyConfig);
	
	    var _this = _possibleConstructorReturn(this, (ShopifyConfig.__proto__ || Object.getPrototypeOf(ShopifyConfig)).call(this, props));
	
	    _this.persistShopifySettings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(shopifySettings) {
	        var discountCode, commission, _this$props, saveShopifySetting, reloadShopifyOrders, isCommissionValid;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                discountCode = shopifySettings.discountCode, commission = shopifySettings.commission;
	                _this$props = _this.props, saveShopifySetting = _this$props.saveShopifySetting, reloadShopifyOrders = _this$props.reloadShopifyOrders;
	
	                if (!(discountCode || _lodash2.default.isEqual(discountCode, ''))) {
	                  _context.next = 7;
	                  break;
	                }
	
	                _context.next = 5;
	                return saveShopifySetting(shopifySettings);
	
	              case 5:
	                reloadShopifyOrders();
	                _this.toggleDiscountCodeInputState();
	
	              case 7:
	                if (!commission) {
	                  _context.next = 14;
	                  break;
	                }
	
	                isCommissionValid = _this.state.isCommissionValid;
	
	                if (!isCommissionValid) {
	                  _context.next = 14;
	                  break;
	                }
	
	                _context.next = 12;
	                return saveShopifySetting(shopifySettings);
	
	              case 12:
	                reloadShopifyOrders();
	                _this.setState({
	                  isCommissionEditing: false
	                });
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onDiscountCodeChange = function (e, _ref2) {
	      var value = _ref2.value;
	      return _this.setState({
	        discountCode: value
	      });
	    };
	
	    _this.onCommisionChange = function (e, _ref3) {
	      var value = _ref3.value;
	      return _this.setState({
	        commission: value,
	        isCommissionValid: _lodash2.default.toNumber(value) <= 100 && _lodash2.default.toNumber(value) >= 0
	      });
	    };
	
	    _this.toggleDiscountCodeInputState = function () {
	      return _this.setState({
	        isDiscountCodeEditing: !_this.state.isDiscountCodeEditing
	      });
	    };
	
	    _this.toggleCommissionInputState = function () {
	      return _this.setState({
	        isCommissionEditing: !_this.state.isCommissionEditing
	      });
	    };
	
	    _this.toggleShopifyConfig = function () {
	      return _this.setState({
	        hideShopifyConfig: !_this.state.hideShopifyConfig
	      });
	    };
	
	    _this.onDiscountCodeSelected = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dc) {
	        var discountCode, discountCodeArray, isDiscountCodeSelected, updatedDiscountCode;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                discountCode = _this.state.discountCode;
	
	
	                console.log(dc);
	
	                discountCodeArray = _lodash2.default.split(discountCode, ',');
	
	
	                console.log(discountCodeArray);
	
	                isDiscountCodeSelected = _lodash2.default.find(discountCodeArray, function (item) {
	                  return _lodash2.default.isEqual(item, dc);
	                });
	
	                console.log(isDiscountCodeSelected);
	
	                updatedDiscountCode = discountCode;
	
	
	                if (!isDiscountCodeSelected) {
	                  if (discountCode) {
	                    updatedDiscountCode = discountCode + ',' + dc;
	                  } else {
	                    updatedDiscountCode = dc;
	                  }
	                }
	
	                _context2.next = 10;
	                return _this.persistShopifySettings({ discountCode: updatedDiscountCode });
	
	              case 10:
	
	                _this.setState({ discountCode: updatedDiscountCode });
	
	              case 11:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.onTagUnselected = function (tagId) {
	      var tags = _this.state.tags;
	
	      var newTags = _lodash2.default.reject(tags, ['id', tagId]);
	      _this.setState({
	        tags: newTags
	      });
	    };
	
	    _this.removeDiscountCode = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(e, _ref6) {
	        var key = _ref6.key,
	            value = _ref6.value;
	        var discountCode, discountCodeArray, updatedDiscountCodeArray, updatedDiscountCode;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                discountCode = _this.state.discountCode;
	
	
	                console.log(key);
	                console.log(value);
	
	                discountCodeArray = _lodash2.default.split(discountCode, ',');
	
	
	                console.log(discountCodeArray);
	
	                updatedDiscountCodeArray = _lodash2.default.reject(discountCodeArray, function (dc) {
	                  return _lodash2.default.isEqual(value, dc);
	                });
	
	
	                console.log(updatedDiscountCodeArray);
	
	                updatedDiscountCode = '';
	
	
	                _lodash2.default.forEach(updatedDiscountCodeArray, function (dc, i) {
	                  updatedDiscountCode += updatedDiscountCodeArray[i] + (i === updatedDiscountCodeArray.length - 1 ? '' : ',');
	                });
	
	                console.log(updatedDiscountCode);
	
	                _context3.next = 12;
	                return _this.persistShopifySettings({ discountCode: updatedDiscountCode });
	
	              case 12:
	
	                _this.setState({ discountCode: updatedDiscountCode });
	
	              case 13:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x3, _x4) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      discountCode: props.discountCode,
	      commission: props.commission,
	      isDiscountCodeEditing: false,
	      isUrlEditing: false,
	      isCommissionEditing: false,
	      hideShopifyConfig: false,
	      isUrlValid: true,
	      isCommissionValid: true
	    };
	    return _this;
	  }
	
	  _createClass(ShopifyConfig, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          discountCode = _state.discountCode,
	          commission = _state.commission,
	          isCommissionEditing = _state.isCommissionEditing,
	          hideShopifyConfig = _state.hideShopifyConfig,
	          isCommissionValid = _state.isCommissionValid;
	      var editable = this.props.editable;
	
	
	      console.log(this.state);
	
	      var commisionInputActionProps = {
	        icon: isCommissionEditing ? 'save' : 'pencil',
	        onClick: isCommissionEditing ? function () {
	          return _this3.persistShopifySettings({ commission: commission });
	        } : this.toggleCommissionInputState,
	        disabled: isCommissionEditing && _lodash2.default.isEmpty(commission),
	        color: isCommissionEditing ? 'pink' : 'green'
	      };
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            { columns: '2' },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { verticalAlign: 'middle' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  _react2.default.createElement('img', {
	                    style: shopifyLogoStyle,
	                    src: '/icons/shopify.svg',
	                    alt: 'Shopify'
	                  }),
	                  ' Shopify configuration',
	                  editable && _react2.default.createElement(
	                    _targetLink2.default,
	                    { href: DISCOUNT_HELP_LINK, renderIf: true },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'green', style: iconMarginLeftStyle })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { textAlign: 'right' },
	                hideShopifyConfig ? _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'chevron down', onClick: this.toggleShopifyConfig, style: buttonStyles }) : _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'chevron up', onClick: this.toggleShopifyConfig, style: buttonStyles })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        editable && !hideShopifyConfig && _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Add a Shopify discount code and / or a shareable URL to this influencer.  These codes can be created and accessed in the \'Discounts\' section of your Shopify account. ',
	            _react2.default.createElement(
	              _targetLink2.default,
	              { href: SHOPIFY_HELP_LINK, renderIf: true },
	              'Click here'
	            ),
	            ' to learn more.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'You can also add a Commission percentage, that will be applied to any sales the influencers makes, via this Shopify URL or discount code. The influencer will be able to see the commission they have earned when they log into Dyzio.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'All Shopify data linked to this code and URL will be available in your Dyzio Shopify report.'
	          )
	        ),
	        !hideShopifyConfig && _react2.default.createElement(
	          _semanticUiReact.Table,
	          null,
	          editable && _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 2 },
	              'Add Discount Code'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 14 },
	              _react2.default.createElement(_discountCodesSelector2.default, {
	                onSelected: this.onDiscountCodeSelected
	              })
	            )
	          ),
	          !editable && _react2.default.createElement(_semanticUiReact.Table.Row, null),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 2 },
	              'Discount Codes:'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 14 },
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { celled: true, fixed: true, singleLine: true, basic: 'very', size: 'small', textAlign: 'center' },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Body,
	                  null,
	                  discountCode && _lodash2.default.map(_lodash2.default.split(discountCode, ','), function (dc) {
	                    if (!_lodash2.default.isEqual(dc, ' ')) {
	                      return _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          { width: 2 },
	                          _react2.default.createElement(
	                            _semanticUiReact.Label,
	                            {
	                              name: dc,
	                              value: dc
	                            },
	                            dc
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          { width: 4 },
	                          'https://mefitpro.myshopify.com/discount/' + dc
	                        ),
	                        editable && _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          { width: 1 },
	                          _react2.default.createElement(_semanticUiReact.Button, {
	                            size: 'mini',
	                            key: dc,
	                            onClick: _this3.removeDiscountCode,
	                            value: dc,
	                            compact: true,
	                            circular: true,
	                            icon: 'delete'
	                          })
	                        ),
	                        !editable && _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          { width: 1 },
	                          _react2.default.createElement(
	                            _reactCopyToClipboard.CopyToClipboard,
	                            {
	                              text: 'https://mefitpro.myshopify.com/discount/' + dc
	                              // onCopy={() => this.setState({ bioCopied: true, storyCopied: false })}
	                            },
	                            _react2.default.createElement(_semanticUiReact.Button, { icon: 'copy', color: 'pink' })
	                          )
	                        )
	                      );
	                    }
	                    return null;
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 2 },
	              'Commission %'
	            ),
	            editable && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 14 },
	              _react2.default.createElement(_semanticUiReact.Input, {
	                fluid: true,
	                type: 'number',
	                onChange: this.onCommisionChange,
	                disabled: !isCommissionEditing,
	                defaultValue: commission,
	                value: commission,
	                action: commisionInputActionProps,
	                error: !isCommissionValid
	              }),
	              !isCommissionValid && commission && _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                { meta: true, textAlign: 'center' },
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { color: 'red', basic: true },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'red' }),
	                  'Must be a percentage between 0 - 100'
	                )
	              )
	            ),
	            !editable && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 14 },
	              _react2.default.createElement(_semanticUiReact.Input, {
	                fluid: true,
	                type: 'number',
	                disabled: !editable,
	                defaultValue: commission,
	                value: commission
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShopifyConfig;
	}(_react.Component);
	
	ShopifyConfig.propTypes = {
	  discountCode: _propTypes2.default.string.isRequired,
	  commission: _propTypes2.default.string.isRequired,
	  editable: _propTypes2.default.bool.isRequired
	};
	
	ShopifyConfig.defaultProps = {
	  editable: false
	};
	
	exports.default = ShopifyConfig;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _formatting = __webpack_require__(287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unescaped-entities */
	
	
	var assetTableStyles = {
	  padding: 0
	};
	
	var loadingShopifyCardStyle = {
	  padding: '120px 0',
	  color: 'gray'
	};
	
	var totalRowStyle = {
	  background: '#EEE'
	};
	
	var boldFontStyle = { fontWeight: 'bold' };
	
	var to2Decimal = function to2Decimal(num) {
	  return _lodash2.default.round(num, 2).toFixed(2);
	};
	
	var LineItems = function LineItems(items) {
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Cell,
	    { width: 2 },
	    _lodash2.default.map(items, function (item) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        item
	      );
	    })
	  );
	};
	
	var TotalsRow = function TotalsRow(orders) {
	  var currency = _lodash2.default.get(_lodash2.default.head(orders), 'orderCurrency', '');
	  var totalOrders = _lodash2.default.sumBy(_lodash2.default.values(orders), function (order) {
	    return _lodash2.default.get(order, 'orderTotal');
	  });
	  var totalCommission = _lodash2.default.sumBy(_lodash2.default.values(orders), function (order) {
	    return _lodash2.default.get(order, 'orderCommission');
	  });
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    { textAlign: 'center', style: boldFontStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(
	        'b',
	        null,
	        'Totals'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: totalRowStyle },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          currency,
	          ' ',
	          (0, _formatting.commaFormatted)(totalOrders)
	        ),
	        content: 'currency: ' + currency
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: totalRowStyle },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          currency,
	          ' ',
	          (0, _formatting.commaFormatted)(totalCommission)
	        ),
	        content: 'currency: ' + currency
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      '-'
	    )
	  );
	};
	
	var ShopifyTable = function (_React$Component) {
	  _inherits(ShopifyTable, _React$Component);
	
	  //
	  function ShopifyTable(props) {
	    _classCallCheck(this, ShopifyTable);
	
	    var _this = _possibleConstructorReturn(this, (ShopifyTable.__proto__ || Object.getPrototypeOf(ShopifyTable)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var _this$props = _this.props,
	        hasDiscountCodes = _this$props.hasDiscountCodes,
	        orders = _this$props.orders;
	
	    _this.state = {
	      shopifyLoading: false,
	      hasDiscountCodes: hasDiscountCodes,
	      orders: orders
	    };
	    return _this;
	  }
	
	  _createClass(ShopifyTable, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }]);
	
	  return ShopifyTable;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.render = function () {
	    var _state = _this2.state,
	        shopifyLoading = _state.shopifyLoading,
	        hasDiscountCodes = _state.hasDiscountCodes,
	        orders = _state.orders;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	
	      // hasAssets &&
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { celled: true, fixed: true, singleLine: true, basic: 'very', style: assetTableStyles, size: 'small', textAlign: 'center' },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Header,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 1 },
	              'Order'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 2 },
	              'Items'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 1 },
	              'Discount Code'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 1 },
	              '$ Total'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 1 },
	              '$ Commission'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 1 },
	              'Order Date'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          !shopifyLoading && hasDiscountCodes && !_lodash2.default.isEmpty(orders) && _lodash2.default.map(orders, function (order) {
	            return _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: 1 },
	                order.name
	              ),
	              LineItems(order.lineItems),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: 1 },
	                order.discountCode
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: 1 },
	                order.orderCurrency,
	                ' ',
	                to2Decimal(order.orderTotal)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: 1 },
	                order.orderCurrency,
	                ' ',
	                to2Decimal(order.orderCommission)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: 1 },
	                _lodash2.default.head(_lodash2.default.split(order.orderDate, 'T'))
	              )
	            );
	          }),
	          !shopifyLoading && hasDiscountCodes && !_lodash2.default.isEmpty(orders) && TotalsRow(orders),
	          !shopifyLoading && hasDiscountCodes && _lodash2.default.isEmpty(orders) && _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: '6' },
	              _react2.default.createElement(
	                _semanticUiReact.Message,
	                null,
	                'No sales during the campaign period'
	              )
	            )
	          ),
	          !shopifyLoading && !hasDiscountCodes && _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: '6' },
	              _react2.default.createElement(
	                _semanticUiReact.Message,
	                null,
	                'Please enter a discount code'
	              )
	            )
	          ),
	          shopifyLoading && _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: '6' },
	              _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                { textAlign: 'center', style: loadingShopifyCardStyle },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', loading: true, size: 'huge' }),
	                _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                'Loading orders'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	};
	
	ShopifyTable.propTypes = {
	  orders: _propTypes2.default.object,
	  hasDiscountCodes: _propTypes2.default.bool
	};
	
	ShopifyTable.defaultProps = {
	  hasDiscountCodes: true,
	  orders: []
	};
	
	exports.default = ShopifyTable;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagsSelector = function (_React$Component) {
	  _inherits(TagsSelector, _React$Component);
	
	  //
	  function TagsSelector(props) {
	    _classCallCheck(this, TagsSelector);
	
	    var _this = _possibleConstructorReturn(this, (TagsSelector.__proto__ || Object.getPrototypeOf(TagsSelector)).call(this, props));
	
	    _this.state = {
	      options: [],
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(TagsSelector, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _props, restClient, organisationId, onSelected, response, tags, options;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props, restClient = _props.restClient, organisationId = _props.userInfo.organisationId, onSelected = _props.onSelected;
	                _context.next = 3;
	                return restClient.get('tags?filter[organisation]=' + organisationId);
	
	              case 3:
	                response = _context.sent;
	                tags = _lodash2.default.get(response, 'data.data', []);
	                options = _lodash2.default.map(tags, function (tag) {
	                  return {
	                    key: _lodash2.default.get(tag, 'id'),
	                    value: _lodash2.default.get(tag, 'id'),
	                    text: _lodash2.default.get(tag, 'attributes.value'),
	                    onClick: function onClick() {
	                      return onSelected(_lodash2.default.get(tag, 'id'), tags);
	                    }
	                  };
	                });
	
	                this.setState({
	                  isLoading: false,
	                  options: options
	                });
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          selectedTags = _props2.selectedTags,
	          onUnselected = _props2.onUnselected;
	      var _state = this.state,
	          options = _state.options,
	          isLoading = _state.isLoading;
	
	      return _react2.default.createElement(_semanticUiReact.Dropdown, {
	        placeholder: 'Select tags',
	        fluid: true,
	        loading: isLoading,
	        search: true,
	        selection: true,
	        multiple: true,
	        options: options,
	        value: selectedTags,
	        onLabelClick: function onLabelClick(event, _ref2) {
	          var value = _ref2.value;
	          return onUnselected(value);
	        }
	      });
	    }
	  }]);
	
	  return TagsSelector;
	}(_react2.default.Component);
	
	TagsSelector.propTypes = {
	  onSelected: _propTypes2.default.func.isRequired,
	  onUnselected: _propTypes2.default.func.isRequired,
	  selectedTags: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(TagsSelector);

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _avatar = __webpack_require__(191);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buttonStyle = {
	  width: '100%'
	};
	
	var TeamMember = function TeamMember(props) {
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { color: props.member.isUserSuperAdmin ? 'green' : 'grey' },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(_avatar2.default, {
	        name: props.member.name,
	        noTooltip: true,
	        size: 40
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        props.member.name
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Meta,
	        null,
	        _.toLower(props.member.email)
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Description,
	        null,
	        props.member.isUserSuperAdmin ? _react2.default.createElement(
	          _semanticUiReact.Label,
	          { basic: true, color: 'green' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'user circle outline' }),
	          'Super Admin'
	        ) : _react2.default.createElement(
	          _semanticUiReact.Label,
	          { basic: true, color: 'grey' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'user circle outline' }),
	          'Team Member'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true },
	      _react2.default.createElement(
	        'div',
	        { className: 'ui buttons', style: buttonStyle },
	        _react2.default.createElement(_semanticUiReact.Button, {
	          color: props.buttonColor,
	          icon: props.buttonIcon,
	          basic: true,
	          content: props.buttonLabel,
	          id: props.member.id,
	          name: props.member.name,
	          onClick: props.buttonClickHandler
	        })
	      )
	    )
	  );
	};
	
	TeamMember.propTypes = {
	  member: _propTypes2.default.object.isRequired,
	  buttonClickHandler: _propTypes2.default.func.isRequired,
	  buttonLabel: _propTypes2.default.string,
	  buttonColor: _propTypes2.default.string,
	  buttonIcon: _propTypes2.default.string
	};
	
	TeamMember.defaultProps = {
	  buttonLabel: 'delete',
	  buttonColor: 'red',
	  buttonIcon: 'delete'
	};
	
	exports.default = TeamMember;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _axiosRetry = __webpack_require__(168);
	
	var _axiosRetry2 = _interopRequireDefault(_axiosRetry);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _followersBarChart = __webpack_require__(176);
	
	var _followersBarChart2 = _interopRequireDefault(_followersBarChart);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iconStyle = {
	  'vertical-align': 'middle',
	  display: 'inline',
	  height: 35
	};
	
	var loadingStyle = {
	  minHeight: 90,
	  marginTop: 30
	};
	
	var textCenterStyle = {
	  textAlign: 'center',
	  width: '100%'
	};
	
	var TiktokProfileDataLarge = function (_React$Component) {
	  _inherits(TiktokProfileDataLarge, _React$Component);
	
	  function TiktokProfileDataLarge() {
	    _classCallCheck(this, TiktokProfileDataLarge);
	
	    var _this = _possibleConstructorReturn(this, (TiktokProfileDataLarge.__proto__ || Object.getPrototypeOf(TiktokProfileDataLarge)).call(this));
	
	    _this.state = {
	      loading: false,
	      profile: {}
	    };
	    _this.restClient = _axios2.default.create({
	      baseURL: ("https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/twitter"),
	      timeout: 5000
	    });
	
	    (0, _axiosRetry2.default)(_this.restClient, {
	      delay: 100,
	      retries: 3
	    });
	    return _this;
	  }
	
	  _createClass(TiktokProfileDataLarge, [{
	    key: 'componentWillMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('data mount');
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentWillMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentWillMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          influencer = _props.influencer,
	          countHistory = _props.countHistory;
	      var _state = this.state,
	          profile = _state.profile,
	          loading = _state.loading;
	      var tiktokProfileData = influencer.tiktokProfileData,
	          tiktokThumbnail = influencer.tiktokThumbnail;
	
	      var _ref2 = tiktokProfileData || {},
	          engagementData = _ref2.engagementData,
	          verified = _ref2.verified,
	          handle = _ref2.username;
	
	      var _ref3 = engagementData || {},
	          postsPerWeek = _ref3.postsPerWeek,
	          likes = _ref3.likes,
	          comments = _ref3.comments,
	          shares = _ref3.shares,
	          engagementRate = _ref3.engagementRate;
	
	      console.log('tiktok profile', profile);
	
	      var tiktokData = _lodash2.default.filter(countHistory, function (item) {
	        return _lodash2.default.has(item, 'tiktokCount');
	      });
	      if (_lodash2.default.isEmpty(tiktokData)) {
	        tiktokData = [{
	          tiktokCount: _lodash2.default.get(influencer, 'tiktokCount'),
	          createdDate: (0, _moment2.default)().format('MMM D')
	        }];
	      }
	      console.log('tiktokData', tiktokData);
	      var graphProps = {
	        label: 'followers',
	        labels: _lodash2.default.map(tiktokData, function (item) {
	          return (0, _moment2.default)(item.createdDate).format('MMM D');
	        }),
	        values: _lodash2.default.map(tiktokData, 'tiktokCount'),
	        rgbColorCode: '#000'
	      };
	      var lastTiktokScan = _lodash2.default.last(tiktokData);
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { color: 'black' },
	        loading && _react2.default.createElement(_semanticUiReact.Loader, {
	          active: true,
	          inline: 'centered',
	          content: 'Loading Tiktok data',
	          style: loadingStyle
	        }),
	        !loading && _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 16 },
	              _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(_semanticUiReact.Image, { src: '/icons/tiktok.svg', alt: 'Tiktok', style: iconStyle }),
	                'Tiktok'
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null)
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { divided: true },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              _react2.default.createElement(_semanticUiReact.Image, {
	                src: tiktokThumbnail,
	                shape: 'circular',
	                centered: true,
	                size: 'small'
	              }),
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { basic: 'very', fluid: true, textAlign: 'center' },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Body,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      handle,
	                      verified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      (0, _formatting.commaFormatted)(lastTiktokScan.tiktokCount),
	                      ' followers'
	                    )
	                  ),
	                  !verified && _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(_semanticUiReact.Popup, {
	                        trigger: _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'grey', content: 'not verified' }),
	                        content: handle + ' is not verified by Tiktok (blue tick)'
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 7 },
	              _react2.default.createElement(_followersBarChart2.default, Object.assign({}, graphProps, { percentageRange: 0.5 }))
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 5 },
	              loading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading...' }),
	              engagementRate && !loading && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  { style: textCenterStyle },
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    null,
	                    (0, _formatting.ierFormat2DP)(engagementRate),
	                    '%'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'engagement rate'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table,
	                  { basic: 'very', fluid: true, compact: true },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Body,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'posts per week'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(postsPerWeek)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'avg. likes per post'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(likes)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'avg. comments per post'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(comments)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'avg. shares per post'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(shares)
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TiktokProfileDataLarge;
	}(_react2.default.Component);
	
	TiktokProfileDataLarge.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  countHistory: _propTypes2.default.array
	};
	
	TiktokProfileDataLarge.defaultProps = {
	  countHistory: []
	};
	
	exports.default = TiktokProfileDataLarge;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buttonStyle = {
	  margin: '20px 0'
	};
	
	var messageStyle = {
	  paddingTop: '30px',
	  display: 'block'
	};
	
	var TryAgainView = function TryAgainView(props) {
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { height: '100', textAlign: 'center' },
	    _react2.default.createElement(
	      'h4',
	      { style: messageStyle },
	      props.errorMessage
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Button,
	      { style: buttonStyle, onClick: props.onClick },
	      props.buttonLabel
	    )
	  );
	};
	
	TryAgainView.propTypes = {
	  buttonLabel: _propTypes2.default.string,
	  errorMessage: _propTypes2.default.string,
	  onClick: _propTypes2.default.func.isRequired
	};
	
	TryAgainView.defaultProps = {
	  errorMessage: 'Something went wrong. Please try again.',
	  buttonLabel: 'Try again'
	};
	
	exports.default = TryAgainView;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _axiosRetry = __webpack_require__(168);
	
	var _axiosRetry2 = _interopRequireDefault(_axiosRetry);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _followersBarChart = __webpack_require__(176);
	
	var _followersBarChart2 = _interopRequireDefault(_followersBarChart);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var loadingStyle = {
	  minHeight: 90,
	  marginTop: 30
	};
	
	var textCenterStyle = {
	  textAlign: 'center',
	  width: '100%'
	};
	
	var TwitterProfileDataLarge = function (_React$Component) {
	  _inherits(TwitterProfileDataLarge, _React$Component);
	
	  function TwitterProfileDataLarge() {
	    var _this2 = this;
	
	    _classCallCheck(this, TwitterProfileDataLarge);
	
	    var _this = _possibleConstructorReturn(this, (TwitterProfileDataLarge.__proto__ || Object.getPrototypeOf(TwitterProfileDataLarge)).call(this));
	
	    _this.loadTwitterProfile = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(handle) {
	        var _ref2, data;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _this.restClient.get('/profile/' + handle);
	
	              case 2:
	                _ref2 = _context.sent;
	                data = _ref2.data;
	
	                console.log('data', data);
	                _this.setState({
	                  profile: data,
	                  loading: false
	                });
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      loading: true,
	      profile: {}
	    };
	    _this.restClient = _axios2.default.create({
	      baseURL: ("https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/twitter"),
	      timeout: 5000
	    });
	
	    (0, _axiosRetry2.default)(_this.restClient, {
	      delay: 100,
	      retries: 3
	    });
	    return _this;
	  }
	
	  _createClass(TwitterProfileDataLarge, [{
	    key: 'componentWillMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var influencer, profile, handle;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                influencer = this.props.influencer;
	                profile = this.state.profile;
	                handle = _lodash2.default.get(influencer, 'twitter');
	
	                console.log('handle', handle);
	
	                if (!(handle && _lodash2.default.isEqual(profile, {}))) {
	                  _context2.next = 7;
	                  break;
	                }
	
	                _context2.next = 7;
	                return this.loadTwitterProfile(handle);
	
	              case 7:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentWillMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentWillMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          influencer = _props.influencer,
	          countHistory = _props.countHistory;
	      var _state = this.state,
	          profile = _state.profile,
	          loading = _state.loading;
	      var user = profile.user,
	          avgLikesPerPost = profile.avgLikesPerPost,
	          avgRetweetsPerPost = profile.avgRetweetsPerPost,
	          avgEngPerPost = profile.avgEngPerPost,
	          postsPerWeek = profile.postsPerWeek,
	          postsPerMonth = profile.postsPerMonth,
	          engagementRate = profile.engagementRate;
	
	
	      console.log('twitter profile', profile);
	
	      var _ref4 = user || {},
	          verified = _ref4.verified,
	          profile_image_url = _ref4.profile_image_url;
	
	      var handle = _lodash2.default.get(influencer, 'twitter');
	      var twitterData = _lodash2.default.filter(countHistory, function (item) {
	        return _lodash2.default.has(item, 'twitterCount');
	      });
	      if (_lodash2.default.isEmpty(twitterData)) {
	        twitterData = [{
	          twitterCount: _lodash2.default.get(profile, 'user.followers_count'),
	          createdDate: (0, _moment2.default)().format('MMM D')
	        }];
	      }
	      console.log('twitterData', twitterData);
	      var graphProps = {
	        label: 'followers',
	        labels: _lodash2.default.map(twitterData, function (item) {
	          return (0, _moment2.default)(item.createdDate).format('MMM D');
	        }),
	        values: _lodash2.default.map(twitterData, 'twitterCount'),
	        rgbColorCode: '#55acee'
	      };
	      var lastTwitterScan = _lodash2.default.last(twitterData);
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { color: 'blue' },
	        loading && _react2.default.createElement(_semanticUiReact.Loader, {
	          active: true,
	          inline: 'centered',
	          content: 'Loading Twitter data',
	          style: loadingStyle
	        }),
	        !loading && _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 16 },
	              _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter', color: 'blue' }),
	                'Twitter'
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null)
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { divided: true },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              _react2.default.createElement(_semanticUiReact.Image, {
	                src: profile_image_url,
	                shape: 'circular',
	                centered: true,
	                size: 'small'
	              }),
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { basic: 'very', fluid: true, textAlign: 'center' },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Body,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      handle,
	                      verified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      (0, _formatting.commaFormatted)(lastTwitterScan.twitterCount),
	                      ' followers'
	                    )
	                  ),
	                  !verified && _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(_semanticUiReact.Popup, {
	                        trigger: _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'grey', content: 'not verified' }),
	                        content: handle + ' is not verified by Twitter (blue tick)'
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 7 },
	              _react2.default.createElement(_followersBarChart2.default, graphProps)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 5 },
	              loading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading...' }),
	              user && engagementRate && !loading && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  { style: textCenterStyle },
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    null,
	                    (0, _formatting.ierFormat2DP)(engagementRate),
	                    '%'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'engagement rate'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table,
	                  { basic: 'very', fluid: true, compact: true },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Body,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'avg. likes per post'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(avgLikesPerPost)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'avg. retweets per post'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(avgRetweetsPerPost)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'avg. engagements per post'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(avgEngPerPost)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'posts per week'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(postsPerWeek)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'posts per month'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(postsPerMonth)
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TwitterProfileDataLarge;
	}(_react2.default.Component);
	
	TwitterProfileDataLarge.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  countHistory: _propTypes2.default.array
	};
	
	TwitterProfileDataLarge.defaultProps = {
	  countHistory: []
	};
	
	exports.default = TwitterProfileDataLarge;

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _validator = __webpack_require__(84);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getFilter = function getFilter(ids) {
	  if (_lodash2.default.size(ids)) {
	    return {
	      filter: {
	        influencer: _lodash2.default.join(ids, ',')
	      },
	      include: ['influencer']
	    };
	  }
	  return {
	    include: ['influencer']
	  };
	};
	
	var errorStyle = {
	  color: '#9f3a38',
	  fontSize: 12
	};
	
	var dividerStyle = {
	  margin: '5px 0'
	};
	
	var getErrorMessage = function getErrorMessage(influencerAlreadyExists, sameEmailAsLoggedInUser, userAlreadyInOrganisation, emailIsValid, email) {
	  if (influencerAlreadyExists) {
	    return 'An influencer from your database is already using this email address.';
	  }
	  if (sameEmailAsLoggedInUser) {
	    return 'You cannot use your own email to log in as an influencer. You are logged in as ' + email;
	  }
	  if (userAlreadyInOrganisation) {
	    return 'Someone in your organisation is already using this email address.';
	  }
	  if (emailIsValid) {
	    return 'This email address is invalid.';
	  }
	  return 'Invalid email';
	};
	
	var ValidatedEmailField = function (_Component) {
	  _inherits(ValidatedEmailField, _Component);
	
	  function ValidatedEmailField(props) {
	    _classCallCheck(this, ValidatedEmailField);
	
	    var _this = _possibleConstructorReturn(this, (ValidatedEmailField.__proto__ || Object.getPrototypeOf(ValidatedEmailField)).call(this, props));
	
	    _this.onChange = function (event, _ref) {
	      var value = _ref.value;
	
	      _this.setState({
	        value: value
	      });
	    };
	
	    _this.onBlur = function () {
	      var value = _this.state.value;
	      var _this$props = _this.props,
	          userInfo = _this$props.userInfo,
	          jsonAPIClient = _this$props.jsonAPIClient,
	          onStateChanged = _this$props.onStateChanged;
	
	      if (_lodash2.default.isEmpty(value)) {
	        _this.setState({
	          isValid: true,
	          errorMessage: null,
	          isLoading: false
	        }, function () {
	          return onStateChanged(true, value);
	        });
	      } else {
	        _this.setState({
	          isLoading: true
	        }, function () {
	          onStateChanged(false, value);
	          var email = userInfo.email,
	              organisationId = userInfo.organisationId;
	
	
	          jsonAPIClient.find('users', {
	            filter: {
	              organisation: organisationId
	            }
	          }, function (error, response) {
	            var userEmails = _lodash2.default.map(response, function (item) {
	              return item.get('email');
	            });
	            jsonAPIClient.find('influencer', {
	              filter: {
	                email: value
	              }
	            }, function (err, res) {
	              var influencerIDS = _lodash2.default.size(res) > 0 ? _lodash2.default.map(res, function (item) {
	                return item.toJSON().id;
	              }) : []; // 66
	              jsonAPIClient.find('influencerLink', getFilter(influencerIDS), function (err, links) {
	                var records = _lodash2.default.map(links, function (link) {
	                  return link.toJSONTree();
	                });
	
	                var influencerAlreadyExists = !_lodash2.default.isUndefined(_lodash2.default.find(records, function (record) {
	                  var influencerEmail = record.influencer.email,
	                      organisation = record.organisation;
	
	                  return influencerEmail === value && organisation.id === organisationId;
	                }));
	
	                var sameEmailAsLoggedInUser = email === value;
	                var userAlreadyInOrganisation = _lodash2.default.includes(userEmails, value);
	                var emailIsValid = _validator2.default.isEmail(value);
	                var isValid = emailIsValid && !influencerAlreadyExists && !sameEmailAsLoggedInUser && !userAlreadyInOrganisation;
	                var message = getErrorMessage(influencerAlreadyExists, sameEmailAsLoggedInUser, userAlreadyInOrganisation, emailIsValid, email);
	
	                _this.setState({
	                  isValid: isValid,
	                  errorMessage: message,
	                  isLoading: false
	                }, function () {
	                  return onStateChanged(isValid, value);
	                });
	              });
	            });
	          });
	        });
	      }
	    };
	
	    _this.state = {
	      value: props.value || null,
	      isLoading: false,
	      isValid: true,
	      errorMessage: ''
	    };
	    return _this;
	  }
	
	  _createClass(ValidatedEmailField, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          isValid = _state.isValid,
	          isLoading = _state.isLoading,
	          errorMessage = _state.errorMessage;
	      var _props = this.props,
	          readOnly = _props.readOnly,
	          hasLabel = _props.hasLabel,
	          fluid = _props.fluid,
	          required = _props.required;
	
	      return _react2.default.createElement(_semanticUiReact.Popup, {
	        position: 'right center',
	        open: !isValid, trigger: _react2.default.createElement(_semanticUiReact.Form.Input, {
	          width: fluid ? 16 : 12,
	          fluid: fluid,
	          readOnly: readOnly,
	          onChange: this.onChange,
	          onBlur: this.onBlur,
	          error: !isValid,
	          loading: isLoading,
	          disabled: isLoading,
	          label: hasLabel ? 'Email' : '',
	          value: value,
	          required: required,
	          onKeyPress: function onKeyPress(e) {
	            e.key === 'Enter' && e.preventDefault();
	          }
	        }),
	        content: _react2.default.createElement(
	          'div',
	          { style: errorStyle },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Invalid e-mail'
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, { fitted: true, style: dividerStyle }),
	          errorMessage
	        )
	      });
	    }
	  }]);
	
	  return ValidatedEmailField;
	}(_react.Component);
	
	ValidatedEmailField.propTypes = {
	  value: _propTypes2.default.any,
	  userInfo: _propTypes2.default.object.isRequired,
	  jsonAPIClient: _propTypes2.default.func.isRequired,
	  onStateChanged: _propTypes2.default.func.isRequired,
	  readOnly: _propTypes2.default.bool.isRequired,
	  hasLabel: _propTypes2.default.bool.isRequired,
	  fluid: _propTypes2.default.bool.isRequired
	};
	
	ValidatedEmailField.defaultProps = {
	  readOnly: false,
	  hasLabel: true,
	  value: null,
	  fluid: false
	};
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _hasJsonapiClient2.default)(ValidatedEmailField);

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(37);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _liveStoriesCounter = __webpack_require__(1995);
	
	var _liveStoriesCounter2 = _interopRequireDefault(_liveStoriesCounter);
	
	var _influencerSocialChannelsTable = __webpack_require__(1983);
	
	var _influencerSocialChannelsTable2 = _interopRequireDefault(_influencerSocialChannelsTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var avatarStyle = {
	  width: 170,
	  height: 170,
	  display: 'block',
	  margin: '20px auto 0 auto'
	};
	
	var cardStyle = {
	  textAlign: 'center',
	  minWidth: 240
	};
	
	var h3Style = {
	  padding: '10px 0'
	};
	
	var VerticalInfluencerBar = function (_React$Component) {
	  _inherits(VerticalInfluencerBar, _React$Component);
	
	  function VerticalInfluencerBar() {
	    var _this2 = this;
	
	    _classCallCheck(this, VerticalInfluencerBar);
	
	    var _this = _possibleConstructorReturn(this, (VerticalInfluencerBar.__proto__ || Object.getPrototypeOf(VerticalInfluencerBar)).call(this));
	
	    _this.influencerRedirectNewTab = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(id, newTab) {
	        var _this$props, organisationId, restClient, router, linkUrl, link, linkId;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props = _this.props, organisationId = _this$props.userInfo.organisationId, restClient = _this$props.restClient, router = _this$props.router;
	                linkUrl = 'influencerLink?filter[influencer]=' + id + '&filter[organisation]=' + organisationId;
	                _context.next = 4;
	                return restClient.get(linkUrl);
	
	              case 4:
	                link = _context.sent;
	
	                if (link) {
	                  linkId = _lodash2.default.get(link, 'data.data[0].id');
	
	                  if (newTab) {
	                    window.open('/influencer/' + linkId + '/statistics');
	                  } else {
	                    router.push('/influencer/' + linkId + '/statistics');
	                  }
	                } else {
	                  console.error('Could not find influencer link.');
	                }
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(VerticalInfluencerBar, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          id = _props.id,
	          name = _props.name,
	          thumbnail = _props.thumbnail,
	          isLoading = _props.isLoading,
	          instagramId = _props.instagramId,
	          isLoadingLiveStoriesCount = _props.isLoadingLiveStoriesCount,
	          liveStoriesCount = _props.liveStoriesCount,
	          onLiveStoriesLabelClick = _props.onLiveStoriesLabelClick,
	          rest = _objectWithoutProperties(_props, ['id', 'name', 'thumbnail', 'isLoading', 'instagramId', 'isLoadingLiveStoriesCount', 'liveStoriesCount', 'onLiveStoriesLabelClick']);
	
	      // the loader doesn't work if this is destructured above.
	      // I guess this takes a copy or something
	
	
	      var instagram = this.props.instagram;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { style: cardStyle, fluid: true },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(_semanticUiReact.Image, {
	            style: avatarStyle,
	            src: thumbnail,
	            centered: true,
	            avatar: true,
	            className: 'circular'
	          }),
	          _react2.default.createElement(
	            'h3',
	            { style: h3Style },
	            name,
	            ' ',
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                circular: true,
	                inverted: true,
	                color: 'green',
	                icon: 'external alternate',
	                onClick: function onClick() {
	                  _this3.influencerRedirectNewTab(id, true);
	                }
	              }),
	              content: 'Open ' + name + ' profile in a new tab.'
	            }),
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                circular: true,
	                inverted: true,
	                color: 'pink',
	                icon: 'arrow alternate circle right',
	                onClick: function onClick() {
	                  _this3.influencerRedirectNewTab(id, false);
	                }
	              }),
	              content: 'Open ' + name + ' profile.'
	            }),
	            _react2.default.createElement(_semanticUiReact.Divider, { fitted: true, hidden: true }),
	            _react2.default.createElement(_liveStoriesCounter2.default, {
	              onClick: onLiveStoriesLabelClick,
	              influencerName: name,
	              loading: isLoadingLiveStoriesCount,
	              count: liveStoriesCount
	            })
	          ),
	          isLoading && _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', loading: true, centered: true }),
	          !isLoading && instagram && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              trigger: _react2.default.createElement(
	                _semanticUiReact.Label,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	                'ID: ',
	                instagramId || 'NO INSTAGRAM ID'
	              ),
	              content: 'Instagram Account ID'
	            })
	          ),
	          !isLoading && _react2.default.createElement(_influencerSocialChannelsTable2.default, rest)
	        )
	      );
	    }
	  }]);
	
	  return VerticalInfluencerBar;
	}(_react2.default.Component);
	
	VerticalInfluencerBar.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	VerticalInfluencerBar.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  thumbnail: _propTypes2.default.string.isRequired,
	  primarySocialHandle: _propTypes2.default.string.isRequired,
	  instagram: _propTypes2.default.string.isRequired,
	  instagramCount: _propTypes2.default.number.isRequired,
	  instagramAuthorised: _propTypes2.default.bool.isRequired,
	  instagramBusinessAccount: _propTypes2.default.bool.isRequired,
	  isFacebookPersonalPage: _propTypes2.default.bool,
	  facebook: _propTypes2.default.string.isRequired,
	  facebookCount: _propTypes2.default.number.isRequired,
	  facebookAuthorised: _propTypes2.default.bool.isRequired,
	  twitter: _propTypes2.default.string.isRequired,
	  twitterCount: _propTypes2.default.number.isRequired,
	  twitterAuthorised: _propTypes2.default.bool.isRequired,
	  youtubeChannelTitle: _propTypes2.default.string.isRequired,
	  youtubeCount: _propTypes2.default.number.isRequired,
	  youtubeAuthorised: _propTypes2.default.bool.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  isLoadingLiveStoriesCount: _propTypes2.default.bool.isRequired,
	  liveStoriesCount: _propTypes2.default.number.isRequired,
	  onLiveStoriesLabelClick: _propTypes2.default.func.isRequired
	};
	
	VerticalInfluencerBar.defaultProps = {
	  isFacebookPersonalPage: false
	};
	
	exports.default = (0, _recompose.compose)(_reactRouter.withRouter, _hasRestClient2.default, _hasUserInfo2.default)(VerticalInfluencerBar);

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _demographicsAgeGraph = __webpack_require__(241);
	
	var _demographicsAgeGraph2 = _interopRequireDefault(_demographicsAgeGraph);
	
	var _demographicsGenderGraph = __webpack_require__(376);
	
	var _demographicsGenderGraph2 = _interopRequireDefault(_demographicsGenderGraph);
	
	var _youtubeDemographicsCountriesTable = __webpack_require__(966);
	
	var _youtubeDemographicsCountriesTable2 = _interopRequireDefault(_youtubeDemographicsCountriesTable);
	
	var _demographicsYoutubeDataTable = __webpack_require__(965);
	
	var _demographicsYoutubeDataTable2 = _interopRequireDefault(_demographicsYoutubeDataTable);
	
	var _followersBarChart = __webpack_require__(176);
	
	var _followersBarChart2 = _interopRequireDefault(_followersBarChart);
	
	var _youtubeDataTabs = __webpack_require__(2041);
	
	var _youtubeDataTabs2 = _interopRequireDefault(_youtubeDataTabs);
	
	var _formatting = __webpack_require__(62);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noBottomPadding = {
	  paddingBottom: 0
	};
	
	var chartWrapperStyles = {
	  width: '100%'
	};
	
	var dividerStyle = {
	  marginTop: 5,
	  marginBottom: 5
	};
	
	var notificationStyle = {
	  paddingTop: 100,
	  paddingBottom: 100
	};
	
	var messageStyle = { color: 'grey', fontSize: 16 };
	
	var modalLinkStyle = {
	  cursor: 'pointer'
	};
	
	var YoutubeProfileDataLarge = function YoutubeProfileDataLarge(props) {
	  var toggleYoutubeDemographicsModalState = props.toggleYoutubeDemographicsModalState,
	      isYouTubeCompliance = props.isYouTubeCompliance,
	      _props$influencer = props.influencer,
	      countHistory = _props$influencer.countHistory,
	      youtube = _props$influencer.youtube,
	      youtubeData = _props$influencer.youtubeData,
	      name = _props$influencer.name,
	      thumbnail = _props$influencer.thumbnail,
	      youtubeDemographicsModalOpen = props.youtubeDemographicsModalOpen,
	      missingAPILink = props.missingAPILink,
	      apiInfluencer = props.apiInfluencer,
	      organisationId = props.userInfo.organisationId,
	      displayAuthorisedData = props.displayAuthorisedData;
	
	
	  var youtubeDataExists = youtubeData && _lodash2.default.size(youtubeData) > 0;
	
	  var hasYoutubeHandle = _lodash2.default.isString(youtube);
	  var lastMonthHistory = _lodash2.default.slice(countHistory, -30);
	
	  var chartProps = {
	    rgbColorCode: '#ff0000',
	    label: 'subscribers',
	    labels: _lodash2.default.map(lastMonthHistory, function (item) {
	      return (0, _moment2.default)(item.createdDate).format('MMM D');
	    }),
	    values: _lodash2.default.map(lastMonthHistory, 'youtubeCount')
	  };
	
	  var percentageChange = void 0;
	  if (lastMonthHistory && lastMonthHistory.length > 10) {
	    var first = _lodash2.default.head(lastMonthHistory).youtubeCount;
	    var last = _lodash2.default.last(lastMonthHistory).youtubeCount;
	    percentageChange = (last - first) / first;
	  }
	
	  var avgComments = void 0;
	  var thirtyDayData = void 0;
	
	  if (apiInfluencer) {
	    var latestVideos = apiInfluencer.latestYoutubeVideos;
	    var sumComments = _lodash2.default.sumBy(latestVideos, function (lv) {
	      return parseInt(lv.statistics.commentCount, 10);
	    });
	    avgComments = sumComments / latestVideos.length;
	
	    var channelStatistics = apiInfluencer.channelStatistics;
	
	    var orderedStats = _lodash2.default.orderBy(channelStatistics, 'collectedDate', 'desc');
	    var latestStat = _lodash2.default.head(orderedStats);
	    var earliestStat = orderedStats[30] || _lodash2.default.last(orderedStats);
	    thirtyDayData = {
	      subscriberChange: latestStat.subscriberCount - earliestStat.subscriberCount,
	      viewChange: latestStat.viewCount - earliestStat.viewCount,
	      videoChange: latestStat.videoCount - earliestStat.videoCount,
	      dayChange: (0, _moment2.default)(latestStat.collectedDate).diff((0, _moment2.default)(earliestStat.collectedDate), 'days')
	    };
	  }
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { loading: props.loading, color: 'red' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      !isYouTubeCompliance && _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube', color: 'red' }),
	      'YouTube'
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, null),
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        { columns: 3, style: noBottomPadding },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 3 },
	          hasYoutubeHandle && apiInfluencer && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_semanticUiReact.Image, {
	              src: thumbnail,
	              shape: 'circular',
	              centered: true,
	              size: 'small'
	            }),
	            _react2.default.createElement(
	              _semanticUiReact.Table,
	              { basic: 'very', fluid: true, textAlign: 'center' },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    apiInfluencer.name,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'grey' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Label, { color: 'blue', basic: true, content: apiInfluencer.category })
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.videoCount),
	                    ' videos'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.subscriberCount),
	                    ' subscribers'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 8 },
	          hasYoutubeHandle && _react2.default.createElement(
	            'div',
	            { className: 'chart-wrapper-print' },
	            _react2.default.createElement(_followersBarChart2.default, Object.assign({}, chartProps, {
	              percentageRange: 0.5
	            }))
	          ),
	          !hasYoutubeHandle && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h2', icon: true, textAlign: 'center', style: notificationStyle },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus', color: 'orange', circular: true }),
	              _react2.default.createElement(
	                _semanticUiReact.Header.Content,
	                { style: messageStyle },
	                'no Youtube channel',
	                _react2.default.createElement('br', null),
	                'for this influencer'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 5 },
	          hasYoutubeHandle && !props.data && !props.loading && props.error && _react2.default.createElement(
	            _semanticUiReact.Message,
	            { error: true },
	            'could not load Youtube data'
	          ),
	          hasYoutubeHandle && !props.data && !props.loading && missingAPILink && _react2.default.createElement(
	            _semanticUiReact.Message,
	            { warning: true },
	            'missing api link'
	          ),
	          hasYoutubeHandle && apiInfluencer && _react2.default.createElement(_youtubeDataTabs2.default, {
	            percentageChange: percentageChange,
	            apiInfluencer: apiInfluencer,
	            avgComments: avgComments,
	            isYouTubeCompliance: isYouTubeCompliance,
	            thirtyDayData: thirtyDayData
	          })
	        )
	      ),
	      displayAuthorisedData && youtubeDataExists && _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        { textAlign: 'center', style: noBottomPadding },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 16 },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Audience Demographics and Regions (last 30 days)',
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'orange' }),
	              content: 'Private data collected from Youtube Insights API'
	            })
	          )
	        )
	      ),
	      displayAuthorisedData && youtubeDataExists && _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        { textAlign: 'center' },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 3 },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Viewing by Gender'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'chart-wrapper-print' },
	            _react2.default.createElement(_demographicsGenderGraph2.default, youtubeData)
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Video View Duration'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table,
	            { singleLine: true, basic: 'very', compact: true },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'Avg. Watch Time:'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                youtubeData && youtubeData.watchTimeMetrics && _react2.default.createElement(
	                  'span',
	                  null,
	                  _moment2.default.utc(youtubeData.watchTimeMetrics.data.averageViewDuration * 1000).format('mm[m] ss[s]')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'Avg. View Percentage:'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                youtubeData && youtubeData.watchTimeMetrics && _react2.default.createElement(
	                  'span',
	                  null,
	                  _lodash2.default.round(youtubeData.watchTimeMetrics.data.averageViewPercentage),
	                  ' %'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 8 },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Channel demographic by gender / age'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'chart-wrapper-print' },
	            _react2.default.createElement(
	              'div',
	              { className: 'chart-wrapper-print' },
	              _react2.default.createElement(_demographicsAgeGraph2.default, youtubeData)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 5 },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Where are they watching?'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'chart-wrapper-print padding-top-on-print' },
	            _react2.default.createElement(_youtubeDemographicsCountriesTable2.default, youtubeData)
	          ),
	          _react2.default.createElement(
	            'a',
	            { style: modalLinkStyle, onClick: toggleYoutubeDemographicsModalState },
	            'View full engagement data'
	          )
	        )
	      )
	    ),
	    youtubeDemographicsModalOpen && _react2.default.createElement(
	      _dyzioModal2.default,
	      {
	        headerText: 'Full Channel Engagement Data (last 30 days)',
	        size: 'fullscreen',
	        onClose: toggleYoutubeDemographicsModalState
	      },
	      _react2.default.createElement(_demographicsYoutubeDataTable2.default, youtubeData)
	    )
	  );
	};
	
	YoutubeProfileDataLarge.defaultProps = {
	  displayAuthorisedData: false
	};
	
	exports.default = (0, _hasUserInfo2.default)(YoutubeProfileDataLarge);

/***/ },
/* 902 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * App constants
	 */
	
	var WINDOW_RESIZE = exports.WINDOW_RESIZE = 'Dyzio/App/WINDOW_RESIZE';

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extractAnalyticsIntoPlatformChannels = undefined;
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadAnalyticsAssetList = loadAnalyticsAssetList;
	exports.sortAnalyticsAssetList = sortAnalyticsAssetList;
	exports.getAndFormatTrackedAssetAnalytics = getAndFormatTrackedAssetAnalytics;
	exports.addTrackedAssetToStateList = addTrackedAssetToStateList;
	exports.filterAnalyticsAssetList = filterAnalyticsAssetList;
	exports.extractAnalyticsTotalData = extractAnalyticsTotalData;
	exports.watchAnalyticsAssetList = watchAnalyticsAssetList;
	exports.watchSortAnalyticsAssetList = watchSortAnalyticsAssetList;
	exports.watchFilterAnalyticsAssetList = watchFilterAnalyticsAssetList;
	exports.watchAddTrackedAssetToStateList = watchAddTrackedAssetToStateList;
	exports.default = analyticsAssetListSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _userSelectors = __webpack_require__(118);
	
	var _campaignPermissions = __webpack_require__(363);
	
	var _trackedAssetsAnalyticsService = __webpack_require__(173);
	
	var _trackedAssets = __webpack_require__(570);
	
	var _analyticsService = __webpack_require__(928);
	
	var _helperFunctions = __webpack_require__(107);
	
	var _trackedAssetHelpers = __webpack_require__(937);
	
	var _analyticsAssetListSelectors = __webpack_require__(2258);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _constants = __webpack_require__(279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadAnalyticsAssetList, sortAnalyticsAssetList, getAndFormatTrackedAssetAnalytics, addTrackedAssetToStateList, filterAnalyticsAssetList, watchAnalyticsAssetList, watchSortAnalyticsAssetList, watchFilterAnalyticsAssetList, watchAddTrackedAssetToStateList, analyticsAssetListSagas].map(_regenerator2.default.mark);
	
	function loadAnalyticsAssetList() {
	  var userId, sortBy, filterByOptions, allTrackedAssetsList, allCampaignsData, campaignTrackedAssets, immutableCampaignAssets, userData, userTrackedAssets, immutableUserAssets, trackedAssetsAnalyticsList, everyTrackedAssetList, youtubeVideos, instagramPosts, facebookPosts, twitterPosts, platformOptions, immutableYoutubeVideoList, immutableInstagramPostList, immutableFacebookPostList, immutableTwitterPostList, hasTrackedDeliverables;
	  return _regenerator2.default.wrap(function loadAnalyticsAssetList$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 3:
	          userId = _context.sent;
	          _context.next = 6;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getSortBy);
	
	        case 6:
	          sortBy = _context.sent;
	          filterByOptions = [{ value: 'allVideos', label: 'all deliverables' }, { value: 'myVideos', label: 'my tracked deliverables' }, { value: 'campaignVideos', label: 'campaign deliverables' }];
	          allTrackedAssetsList = [];
	
	          // Get all campaign trackedAssets
	
	          _context.next = 11;
	          return (0, _effects.call)(_campaignPermissions.getCampaignPermissionTrackedAssets, userId);
	
	        case 11:
	          allCampaignsData = _context.sent;
	          campaignTrackedAssets = {};
	
	          allCampaignsData && allCampaignsData.forEach(function (campaignData) {
	            if (campaignData.campaign.trackedAssets && campaignData.campaign.trackedAssets[0]) {
	              campaignData.campaign.trackedAssets.forEach(function (trackedAsset) {
	                _lodash2.default.set(campaignTrackedAssets, [trackedAsset.assetId], trackedAsset);
	                allTrackedAssetsList.push(trackedAsset);
	              });
	            }
	            filterByOptions.push({ value: campaignData.campaign.id, label: campaignData.campaign.name });
	            campaignData.campaign.discussions.forEach(function (discussion) {
	              if (discussion && discussion.trackedAssets[0]) {
	                discussion.trackedAssets.forEach(function (trackedAsset) {
	                  _lodash2.default.set(campaignTrackedAssets, [trackedAsset.assetId], trackedAsset);
	                  allTrackedAssetsList.push(trackedAsset);
	                });
	              }
	            });
	          });
	          immutableCampaignAssets = (0, _immutable.fromJS)(campaignTrackedAssets);
	
	          // Get all user trackedAssets
	
	          _context.next = 17;
	          return (0, _effects.call)(_trackedAssets.getTrackedAssetList, userId);
	
	        case 17:
	          userData = _context.sent;
	          userTrackedAssets = {};
	
	          userData && userData[0] && userData.forEach(function (trackedAsset) {
	            if (!trackedAsset.campaign) {
	              _lodash2.default.set(userTrackedAssets, [trackedAsset.assetId], trackedAsset);
	              allTrackedAssetsList.push(trackedAsset);
	            }
	          });
	          immutableUserAssets = (0, _immutable.fromJS)(userTrackedAssets);
	
	          // Get the data for all trackedAssets
	
	          _context.next = 23;
	          return (0, _effects.call)(_trackedAssetsAnalyticsService.getTrackedAssetAnalytics, allTrackedAssetsList);
	
	        case 23:
	          trackedAssetsAnalyticsList = _context.sent;
	          everyTrackedAssetList = _extends({}, userTrackedAssets, campaignTrackedAssets);
	          youtubeVideos = {};
	          instagramPosts = {};
	          facebookPosts = {};
	          twitterPosts = {};
	          platformOptions = {
	            YOUTUBE: youtubeVideos,
	            INSTAGRAM: instagramPosts,
	            FACEBOOK: facebookPosts,
	            TWITTER: twitterPosts
	          };
	
	
	          extractAnalyticsIntoPlatformChannels(trackedAssetsAnalyticsList, everyTrackedAssetList, platformOptions);
	
	          immutableYoutubeVideoList = (0, _immutable.fromJS)(youtubeVideos);
	          immutableInstagramPostList = (0, _immutable.fromJS)(instagramPosts);
	          immutableFacebookPostList = (0, _immutable.fromJS)(facebookPosts);
	          immutableTwitterPostList = (0, _immutable.fromJS)(twitterPosts);
	          hasTrackedDeliverables = immutableYoutubeVideoList.size > 0 || immutableInstagramPostList.size > 0 || immutableFacebookPostList.size > 0 || immutableTwitterPostList.size > 0;
	          _context.next = 38;
	          return (0, _effects.put)({
	            type: _constants.LOAD_ANALYTICS_ASSET_LIST_SUCCESS,
	            hasTrackedDeliverables: hasTrackedDeliverables,
	            youtubeVideos: sortAssetList(immutableYoutubeVideoList, sortBy),
	            instagramPosts: sortAssetList(immutableInstagramPostList, sortBy),
	            facebookPosts: sortAssetList(immutableFacebookPostList, sortBy),
	            twitterPosts: sortAssetList(immutableTwitterPostList, sortBy),
	            filterByOptions: filterByOptions,
	            userVideos: immutableUserAssets,
	            campaignVideos: immutableCampaignAssets
	          });
	
	        case 38:
	          _context.next = 45;
	          break;
	
	        case 40:
	          _context.prev = 40;
	          _context.t0 = _context['catch'](0);
	
	          (0, _errorHandlingService.reportError)('LOAD_ANALYTICS_ASSET_LIST_ERROR', _context.t0.message);
	          _context.next = 45;
	          return (0, _effects.put)({ type: _constants.LOAD_ANALYTICS_ASSET_LIST_ERROR, error: _context.t0 });
	
	        case 45:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 40]]);
	}
	
	var extractAnalyticsIntoPlatformChannels = exports.extractAnalyticsIntoPlatformChannels = function extractAnalyticsIntoPlatformChannels(trackedAssetsAnalyticsList, everyTrackedAssetList, platformOptions) {
	  trackedAssetsAnalyticsList && trackedAssetsAnalyticsList.forEach(function (trackedAsset) {
	    var data = trackedAsset.response.data;
	
	    if (data) {
	      var analyticsData = null;
	      if (trackedAsset.platform === _staticConfiguration.YOUTUBE) analyticsData = (0, _trackedAssetHelpers.formatYoutubeVideoAnalytics)(data);
	      if (trackedAsset.platform === _staticConfiguration.INSTAGRAM) analyticsData = (0, _trackedAssetHelpers.formatInstagramAnalytics)(data);
	      if (trackedAsset.platform === _staticConfiguration.FACEBOOK) analyticsData = (0, _trackedAssetHelpers.formatFacebookAnalytics)(data);
	      if (trackedAsset.platform === _staticConfiguration.TWITTER) analyticsData = (0, _trackedAssetHelpers.formatTwitterAnalytics)(data);
	
	      if (analyticsData) {
	        var addedInfo = analyticsData;
	        if (everyTrackedAssetList[trackedAsset.assetId]) {
	          addedInfo = _extends({}, analyticsData, everyTrackedAssetList[trackedAsset.assetId]);
	          _lodash2.default.set(platformOptions[trackedAsset.platform], [trackedAsset.assetId], addedInfo);
	        }
	      }
	    }
	  });
	};
	
	var lowestViews = function lowestViews(trackedAssetList) {
	  return trackedAssetList.sortBy(function (trackedAsset) {
	    return trackedAsset.get('views');
	  });
	};
	var highestViews = function highestViews(trackedAssetList) {
	  return trackedAssetList.sortBy(function (trackedAsset) {
	    return -trackedAsset.get('views');
	  });
	};
	var lowestEngagement = function lowestEngagement(trackedAssetList) {
	  return trackedAssetList.sortBy(function (trackedAsset) {
	    return trackedAsset.get('engagementScore');
	  });
	};
	var highestEngagement = function highestEngagement(trackedAssetList) {
	  return trackedAssetList.sortBy(function (trackedAsset) {
	    return -trackedAsset.get('engagementScore');
	  });
	};
	var oldestLiveDate = function oldestLiveDate(trackedAssetList) {
	  return trackedAssetList.sort(function (a, b) {
	    var aDate = new Date(a.get('publishedDate'));
	    var bDate = new Date(b.get('publishedDate'));
	    if (aDate < bDate) {
	      return -1;
	    }
	    if (aDate > bDate) {
	      return 1;
	    }
	    if (aDate === bDate) {
	      return 0;
	    }
	  });
	};
	
	var latestLiveDate = function latestLiveDate(trackedAssetList) {
	  return trackedAssetList.sort(function (a, b) {
	    var aDate = new Date(a.get('publishedDate'));
	    var bDate = new Date(b.get('publishedDate'));
	    if (aDate > bDate) {
	      return -1;
	    }
	    if (aDate < bDate) {
	      return 1;
	    }
	    if (aDate === bDate) {
	      return 0;
	    }
	  });
	};
	
	function sortAssetList(videoList, sortBy) {
	  var selectAssetList = {
	    highestViews: highestViews,
	    lowestViews: lowestViews,
	    highestEngagement: highestEngagement,
	    lowestEngagement: lowestEngagement,
	    latestLiveDate: latestLiveDate,
	    oldestLiveDate: oldestLiveDate
	  };
	  return selectAssetList[sortBy](videoList);
	}
	
	function sortAnalyticsAssetList(actions) {
	  var sortBy, filteredYoutubeVideos, filteredInstagramPosts, filteredFacebookPosts, filteredTwitterPosts, filterBy;
	  return _regenerator2.default.wrap(function sortAnalyticsAssetList$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          sortBy = actions.data.sortBy;
	          _context2.next = 3;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getFilteredYoutubeVideos);
	
	        case 3:
	          filteredYoutubeVideos = _context2.sent;
	          _context2.next = 6;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getFilteredInstagramPosts);
	
	        case 6:
	          filteredInstagramPosts = _context2.sent;
	          _context2.next = 9;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getFilteredFacebookPosts);
	
	        case 9:
	          filteredFacebookPosts = _context2.sent;
	          _context2.next = 12;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getFilteredTwitterPosts);
	
	        case 12:
	          filteredTwitterPosts = _context2.sent;
	          _context2.next = 15;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getFilterBy);
	
	        case 15:
	          filterBy = _context2.sent;
	          _context2.next = 18;
	          return (0, _effects.put)({
	            type: _constants.UPDATE_ANALYTICS_ASSET_LIST,
	            filteredYoutubeVideos: sortAssetList(filteredYoutubeVideos, sortBy),
	            filteredInstagramPosts: sortAssetList(filteredInstagramPosts, sortBy),
	            filteredFacebookPosts: sortAssetList(filteredFacebookPosts, sortBy),
	            filteredTwitterPosts: sortAssetList(filteredTwitterPosts, sortBy),
	            sortBy: sortBy,
	            filterBy: filterBy
	          });
	
	        case 18:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function getAndFormatTrackedAssetAnalytics(trackedAsset) {
	  var newTrackedAssets, data, analyticsData, updatedTrackedAsset;
	  return _regenerator2.default.wrap(function getAndFormatTrackedAssetAnalytics$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.prev = 0;
	          _context3.next = 3;
	          return (0, _effects.call)(_trackedAssetsAnalyticsService.getTrackedAssetAnalytics, [trackedAsset]);
	
	        case 3:
	          newTrackedAssets = _context3.sent;
	          data = newTrackedAssets[0].response.data;
	
	          if (!data) {
	            _context3.next = 16;
	            break;
	          }
	
	          analyticsData = null;
	
	          if (trackedAsset.platform === _staticConfiguration.YOUTUBE) analyticsData = (0, _trackedAssetHelpers.formatYoutubeVideoAnalytics)(data);
	          if (trackedAsset.platform === _staticConfiguration.INSTAGRAM) analyticsData = (0, _trackedAssetHelpers.formatInstagramAnalytics)(data);
	          if (trackedAsset.platform === _staticConfiguration.FACEBOOK) analyticsData = (0, _trackedAssetHelpers.formatFacebookAnalytics)(data);
	          if (trackedAsset.platform === _staticConfiguration.TWITTER) analyticsData = (0, _trackedAssetHelpers.formatTwitterAnalytics)(data);
	
	          if (!analyticsData) {
	            _context3.next = 15;
	            break;
	          }
	
	          updatedTrackedAsset = _extends({}, analyticsData, trackedAsset);
	
	          if (!trackedAsset.campaign) updatedTrackedAsset.isUserAsset = true;
	          return _context3.abrupt('return', updatedTrackedAsset);
	
	        case 15:
	          return _context3.abrupt('return', null);
	
	        case 16:
	          _context3.next = 23;
	          break;
	
	        case 18:
	          _context3.prev = 18;
	          _context3.t0 = _context3['catch'](0);
	
	          (0, _errorHandlingService.reportError)('GET_NEW_ASSET_ERROR', _context3.t0.message);
	          _context3.next = 23;
	          return (0, _effects.put)({ type: _constants.GET_NEW_ASSET_ERROR, error: _context3.t0 });
	
	        case 23:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this, [[0, 18]]);
	}
	
	function addTrackedAssetToStateList(actions) {
	  var trackedAsset, updatedTrackedAsset, assetList, filterBy;
	  return _regenerator2.default.wrap(function addTrackedAssetToStateList$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.prev = 0;
	          trackedAsset = actions.data.trackedAsset;
	          _context4.next = 4;
	          return (0, _effects.call)(getAndFormatTrackedAssetAnalytics, trackedAsset);
	
	        case 4:
	          updatedTrackedAsset = _context4.sent;
	
	          if (!updatedTrackedAsset) {
	            _context4.next = 18;
	            break;
	          }
	
	          assetList = null;
	
	          if (updatedTrackedAsset.platform === _staticConfiguration.YOUTUBE) assetList = 'youtubeVideos';
	          if (updatedTrackedAsset.platform === _staticConfiguration.INSTAGRAM) assetList = 'instagramPosts';
	          if (updatedTrackedAsset.platform === _staticConfiguration.FACEBOOK) assetList = 'facebookPosts';
	          if (updatedTrackedAsset.platform === _staticConfiguration.TWITTER) assetList = 'twitterPosts';
	
	          _context4.next = 13;
	          return (0, _effects.put)({ type: _constants.ADD_TRACKED_ASSET_TO_LIST, newAsset: (0, _immutable.fromJS)(updatedTrackedAsset), assetId: trackedAsset.assetId, assetList: assetList });
	
	        case 13:
	          _context4.next = 15;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getFilterBy);
	
	        case 15:
	          filterBy = _context4.sent;
	          _context4.next = 18;
	          return (0, _effects.put)({ type: _constants.FILTER_ANALYTICS_ASSET_LIST, data: { filterBy: filterBy } });
	
	        case 18:
	          _context4.next = 25;
	          break;
	
	        case 20:
	          _context4.prev = 20;
	          _context4.t0 = _context4['catch'](0);
	
	          (0, _errorHandlingService.reportError)('ADD_TRACKED_ASSET_TO_ANALYTICS_ERROR', _context4.t0.message);
	          _context4.next = 25;
	          return (0, _effects.put)({ type: _constants.GET_NEW_ASSET_ERROR, error: _context4.t0 });
	
	        case 25:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this, [[0, 20]]);
	}
	
	function filterAnalyticsAssetList(actions) {
	  var filterBy, sortBy, youtubeVideos, instagramPosts, facebookPosts, twitterPosts, filteredYoutubeVideos, filteredInstagramPosts, filteredFacebookPosts, filteredTwitterPosts, analyticsFilteredChannelOptions, analyticsChannelLists, addFilteredTrackedAsset, showAnalyticTotals, userVideos, campaignVideos, _campaignVideos, immutableFilteredYoutubeVideos, immutableFilteredInstagramPosts, immutableFilteredFacebookPosts, immutableFilteredTwitterPosts, youtubeTotals, instagramTotals, facebookTotals, twitterTotals;
	
	  return _regenerator2.default.wrap(function filterAnalyticsAssetList$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          filterBy = actions.data.filterBy;
	          _context5.next = 3;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getSortBy);
	
	        case 3:
	          sortBy = _context5.sent;
	          _context5.next = 6;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getAllYoutubeVideos);
	
	        case 6:
	          youtubeVideos = _context5.sent;
	          _context5.next = 9;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getAllInstagramPosts);
	
	        case 9:
	          instagramPosts = _context5.sent;
	          _context5.next = 12;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getAllFacebookPosts);
	
	        case 12:
	          facebookPosts = _context5.sent;
	          _context5.next = 15;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getAllTwitterPosts);
	
	        case 15:
	          twitterPosts = _context5.sent;
	          filteredYoutubeVideos = {};
	          filteredInstagramPosts = {};
	          filteredFacebookPosts = {};
	          filteredTwitterPosts = {};
	          analyticsFilteredChannelOptions = {
	            YOUTUBE: filteredYoutubeVideos,
	            INSTAGRAM: filteredInstagramPosts,
	            FACEBOOK: filteredFacebookPosts,
	            TWITTER: filteredTwitterPosts
	          };
	          analyticsChannelLists = {
	            YOUTUBE: youtubeVideos,
	            INSTAGRAM: instagramPosts,
	            FACEBOOK: facebookPosts,
	            TWITTER: twitterPosts
	          };
	
	          addFilteredTrackedAsset = function addFilteredTrackedAsset(platform, assetId) {
	            var trackedAsset = analyticsChannelLists[platform].get(assetId);
	            if (trackedAsset) _lodash2.default.set(analyticsFilteredChannelOptions[platform], [assetId], trackedAsset);
	          };
	
	          showAnalyticTotals = filterBy !== 'allVideos';
	
	          if (!(filterBy === 'allVideos')) {
	            _context5.next = 31;
	            break;
	          }
	
	          filteredYoutubeVideos = youtubeVideos;
	          filteredInstagramPosts = instagramPosts;
	          filteredFacebookPosts = facebookPosts;
	          filteredTwitterPosts = twitterPosts;
	          _context5.next = 49;
	          break;
	
	        case 31:
	          if (!(filterBy === 'myVideos')) {
	            _context5.next = 38;
	            break;
	          }
	
	          _context5.next = 34;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getUserVideos);
	
	        case 34:
	          userVideos = _context5.sent;
	
	          userVideos.forEach(function (trackedAsset) {
	            return addFilteredTrackedAsset(trackedAsset.get('platform'), trackedAsset.get('assetId'));
	          });
	          _context5.next = 49;
	          break;
	
	        case 38:
	          if (!(filterBy === 'campaignVideos')) {
	            _context5.next = 45;
	            break;
	          }
	
	          _context5.next = 41;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getCampaignVideos);
	
	        case 41:
	          campaignVideos = _context5.sent;
	
	          campaignVideos.forEach(function (trackedAsset) {
	            return addFilteredTrackedAsset(trackedAsset.get('platform'), trackedAsset.get('assetId'));
	          });
	          _context5.next = 49;
	          break;
	
	        case 45:
	          _context5.next = 47;
	          return (0, _effects.select)(_analyticsAssetListSelectors.getCampaignVideos);
	
	        case 47:
	          _campaignVideos = _context5.sent;
	
	          filterBy && _campaignVideos.forEach(function (trackedAsset) {
	            if (trackedAsset.getIn(['campaign', 'id']) === filterBy) {
	              addFilteredTrackedAsset(trackedAsset.get('platform'), trackedAsset.get('assetId'));
	            }
	          });
	
	        case 49:
	          immutableFilteredYoutubeVideos = (0, _immutable.fromJS)(filteredYoutubeVideos);
	          immutableFilteredInstagramPosts = (0, _immutable.fromJS)(filteredInstagramPosts);
	          immutableFilteredFacebookPosts = (0, _immutable.fromJS)(filteredFacebookPosts);
	          immutableFilteredTwitterPosts = (0, _immutable.fromJS)(filteredTwitterPosts);
	          youtubeTotals = {};
	          instagramTotals = {};
	          facebookTotals = {};
	          twitterTotals = {};
	
	
	          if (showAnalyticTotals) {
	            youtubeTotals = extractAnalyticsTotalData(immutableFilteredYoutubeVideos, _staticConfiguration.YOUTUBE);
	            instagramTotals = extractAnalyticsTotalData(immutableFilteredInstagramPosts, _staticConfiguration.INSTAGRAM);
	            facebookTotals = extractAnalyticsTotalData(immutableFilteredFacebookPosts, _staticConfiguration.FACEBOOK);
	            twitterTotals = extractAnalyticsTotalData(immutableFilteredTwitterPosts, _staticConfiguration.TWITTER);
	          }
	
	          _context5.next = 60;
	          return (0, _effects.put)({
	            type: _constants.UPDATE_ANALYTICS_ASSET_LIST,
	            filteredYoutubeVideos: sortAssetList(immutableFilteredYoutubeVideos, sortBy),
	            filteredInstagramPosts: sortAssetList(immutableFilteredInstagramPosts, sortBy),
	            filteredFacebookPosts: sortAssetList(immutableFilteredFacebookPosts, sortBy),
	            filteredTwitterPosts: sortAssetList(immutableFilteredTwitterPosts, sortBy),
	            showAnalyticTotals: showAnalyticTotals,
	            youtubeTotals: (0, _immutable.fromJS)(youtubeTotals),
	            instagramTotals: (0, _immutable.fromJS)(instagramTotals),
	            facebookTotals: (0, _immutable.fromJS)(facebookTotals),
	            twitterTotals: (0, _immutable.fromJS)(twitterTotals),
	            sortBy: sortBy,
	            filterBy: filterBy
	          });
	
	        case 60:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function extractAnalyticsTotalData(trackedAssetList, platform) {
	
	  var totals = {
	    likes: 0,
	    reactions: 0,
	    dislikes: 0,
	    comments: 0,
	    shares: 0,
	    retweets: 0,
	    views: 0,
	    engagement: 0,
	    followers: 0
	  };
	  var uniqueInfluencers = [];
	
	  var validateNumber = function validateNumber(value) {
	    return value && !isNaN(value) ? value : 0;
	  };
	  trackedAssetList.forEach(function (trackedAsset) {
	    totals.likes += validateNumber(trackedAsset.get('likes'));
	    totals.reactions += validateNumber(trackedAsset.get('reactions'));
	    totals.dislikes += validateNumber(trackedAsset.get('dislikes'));
	    totals.comments += validateNumber(trackedAsset.get('comments'));
	    totals.shares += validateNumber(trackedAsset.get('shares'));
	    totals.retweets += validateNumber(trackedAsset.get('retweets'));
	    totals.views += validateNumber(trackedAsset.get('views'));
	
	    var platformId = trackedAsset.get('platformId');
	    if (platformId) {
	      var influencerExists = _lodash2.default.findIndex(uniqueInfluencers, function (id) {
	        return id === platformId;
	      });
	      if (influencerExists < 0) {
	        uniqueInfluencers.push(platformId);
	        totals.followers += validateNumber(trackedAsset.get('followers'));
	      }
	    }
	  });
	  var denominator = platform === _staticConfiguration.INSTAGRAM ? totals.followers : totals.views;
	  if (denominator) totals.engagement = (0, _helperFunctions.dyzioEngagementScore)(totals.likes, totals.dislikes, totals.comments, denominator);
	
	  return totals;
	}
	
	function watchAnalyticsAssetList() {
	  return _regenerator2.default.wrap(function watchAnalyticsAssetList$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.LOAD_ANALYTICS_ASSET_LIST, loadAnalyticsAssetList);
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}
	
	function watchSortAnalyticsAssetList() {
	  return _regenerator2.default.wrap(function watchSortAnalyticsAssetList$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.SORT_ANALYTICS_ASSET_LIST, sortAnalyticsAssetList);
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}
	
	function watchFilterAnalyticsAssetList() {
	  return _regenerator2.default.wrap(function watchFilterAnalyticsAssetList$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.FILTER_ANALYTICS_ASSET_LIST, filterAnalyticsAssetList);
	
	        case 2:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[7], this);
	}
	
	function watchAddTrackedAssetToStateList() {
	  return _regenerator2.default.wrap(function watchAddTrackedAssetToStateList$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants.GET_NEW_ASSET, addTrackedAssetToStateList);
	
	        case 2:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked[8], this);
	}
	
	function analyticsAssetListSagas() {
	  return _regenerator2.default.wrap(function analyticsAssetListSagas$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          _context10.next = 2;
	          return [(0, _effects.fork)(watchAnalyticsAssetList), (0, _effects.fork)(watchSortAnalyticsAssetList), (0, _effects.fork)(watchAddTrackedAssetToStateList), (0, _effects.fork)(watchFilterAnalyticsAssetList)];
	
	        case 2:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked[9], this);
	}

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadCampaignAnalytics = loadCampaignAnalytics;
	
	var _constants = __webpack_require__(355);
	
	function loadCampaignAnalytics(data) {
	  return {
	    type: _constants.LOAD_CAMPAIGN_ANALYTICS,
	    data: data
	  };
	}

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventFeed = __webpack_require__(230);
	
	var _eventFeed2 = _interopRequireDefault(_eventFeed);
	
	var _static = __webpack_require__(358);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CampaignAuditTrail = function CampaignAuditTrail(props) {
	  return _react2.default.createElement(_eventFeed2.default, Object.assign({}, props, {
	    feedType: _static.FEED_TYPES.CAMPAIGN,
	    viewMode: _static.FEED_VIEW_MODES.TABLE,
	    hasExportFeature: true
	  }));
	};
	
	exports.default = CampaignAuditTrail;

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _emailSettingsComponent = __webpack_require__(2071);
	
	var _emailSettingsComponent2 = _interopRequireDefault(_emailSettingsComponent);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESTRICTED_CORQ_DOMAINS = ['data.corq.studio', 'corq.dyzio.co'];
	
	var CampaignEmailSettings = function (_React$Component) {
	  _inherits(CampaignEmailSettings, _React$Component);
	
	  function CampaignEmailSettings(props) {
	    _classCallCheck(this, CampaignEmailSettings);
	
	    var _this = _possibleConstructorReturn(this, (CampaignEmailSettings.__proto__ || Object.getPrototypeOf(CampaignEmailSettings)).call(this, props));
	
	    _this.onPermissionChange = function (_ref) {
	      var id = _ref.id,
	          key = _ref.key,
	          value = _ref.value;
	      var restClient = _this.props.restClient;
	      var teamMembers = _this.state.teamMembers;
	
	      var newTeamMembers = _lodash2.default.map(teamMembers, function (member) {
	        return member.id === id ? _extends({}, member, _defineProperty({}, key, value)) : member;
	      });
	      restClient.patch('campaignPermission/' + id, {
	        data: {
	          attributes: _defineProperty({}, key, value)
	        }
	      });
	      return _this.setState({ teamMembers: newTeamMembers });
	    };
	
	    _this.render = function () {
	      var host = window.location.host;
	
	      var isCorq = _lodash2.default.includes(RESTRICTED_CORQ_DOMAINS, host);
	
	      return _react2.default.createElement(_emailSettingsComponent2.default, Object.assign({}, _this.props, {
	        showManageLink: !isCorq,
	        onPermissionChange: _this.onPermissionChange
	      }));
	    };
	
	    _this.state = _extends({}, props);
	    return _this;
	  }
	
	  return CampaignEmailSettings;
	}(_react2.default.Component);
	
	exports.default = (0, _hasRestClient2.default)(CampaignEmailSettings);

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeMember = removeMember;
	exports.removePendingMember = removePendingMember;
	exports.showRemoveModal = showRemoveModal;
	exports.hideRemoveModal = hideRemoveModal;
	
	var _constants = __webpack_require__(356);
	
	function removeMember(permissionId, userId) {
	  return {
	    type: _constants.REMOVE_MEMBER,
	    permissionId: permissionId,
	    userId: userId
	  };
	}
	
	function removePendingMember(invitationId) {
	  return {
	    type: _constants.REMOVE_PENDING_MEMBER,
	    invitationId: invitationId
	  };
	}
	
	function showRemoveModal(id) {
	  return {
	    type: _constants.SHOW_REMOVE_MODAL,
	    id: id
	  };
	}
	
	function hideRemoveModal() {
	  return {
	    type: _constants.HIDE_REMOVE_MODAL
	  };
	}

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _immutable = __webpack_require__(71);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _actions = __webpack_require__(911);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	var _authService = __webpack_require__(21);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _actions2 = __webpack_require__(105);
	
	var _formInviteRow = __webpack_require__(1945);
	
	var _formInviteRow2 = _interopRequireDefault(_formInviteRow);
	
	var _formInputValidation = __webpack_require__(286);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _metricAnalyticsService = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CampaignInvite = function (_React$Component) {
	  _inherits(CampaignInvite, _React$Component);
	
	  function CampaignInvite(props, context) {
	    _classCallCheck(this, CampaignInvite);
	
	    var _this = _possibleConstructorReturn(this, (CampaignInvite.__proto__ || Object.getPrototypeOf(CampaignInvite)).call(this, props, context));
	
	    _this.state = {
	      resetStatusBar: false,
	      campaignInviteLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(CampaignInvite, [{
	    key: 'changeAddClientState',
	    value: function changeAddClientState(currentSelect) {
	      this.setState({ addClientState: currentSelect });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.reset(); // Reset form values
	
	      // Reset status bar if required
	      if (this.state.resetStatusBar) {
	        this.props.onClearStatusBar();
	      }
	    }
	  }, {
	    key: 'inviteCollaborators',
	    value: function inviteCollaborators(formData) {
	      var _this2 = this;
	
	      this.setState({ campaignInviteLoading: true });
	
	      var _props = this.props,
	          campaignId = _props.campaignId,
	          campaignName = _props.campaignName;
	
	      var collaboratorInsertList = [];
	
	      formData.forEach(function (collaboratorList) {
	        var collaboratorInsert = {};
	
	        collaboratorList.forEach(function (collaborator) {
	          var email = collaborator.get('email');
	          var role = collaborator.get('role');
	          var name = collaborator.get('name');
	          var origin = window.location.origin;
	
	          collaboratorInsert.link = origin + '/invite/';
	          collaboratorInsert.type = 'campaignInvitation';
	          collaboratorInsert.status = 'sent';
	          collaboratorInsert.campaign = {
	            type: 'campaigns',
	            id: campaignId
	          };
	          collaboratorInsert.campaignName = campaignName;
	          collaboratorInsert.email = email;
	          collaboratorInsert.role = role;
	          collaboratorInsert.name = name;
	
	          if (role === _staticConfiguration.INFLUENCER) {
	            var socialHandle = collaborator.get('socialHandle');
	            var platforms = [];
	            if (collaborator.get('facebook')) platforms.push('facebook');
	            if (collaborator.get('twitter')) platforms.push('twitter');
	            if (collaborator.get('youtube')) platforms.push('youtube');
	            collaboratorInsert.metadata = { socialHandle: socialHandle, platforms: platforms };
	          }
	
	          if (collaboratorInsert.email && collaboratorInsert.role) {
	            collaboratorInsertList.push(_lodash2.default.assign({}, collaboratorInsert));
	
	            var inviteMemberData = { campaignId: campaignId, inviteEmail: email, inviteRole: role };
	            if (name) inviteMemberData.inviteName = name;
	            (0, _metricAnalyticsService.trackEvent)('Invite Member', inviteMemberData);
	          }
	        });
	      });
	
	      var axiosService = new _axiosService2.default(("https://hrrxvfjd6e.execute-api.eu-west-1.amazonaws.com/production/batch"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	      axiosService.post('/' + campaignId, { data: collaboratorInsertList }).then(function () {
	        _this2.props.onSetReloadDiscussions(true);
	        _this2.context.router.push('/campaign/' + campaignId);
	      }).catch(function (error) {
	        (0, _errorHandlingService.reportError)('INVITE_COLLABORATOR_ERROR', error.message);
	        _this2.props.onSetStatusBar(error.message, 'red');
	        _this2.setState({ resetStatusBar: true });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          handleSubmit = _props2.handleSubmit,
	          campaign = _props2.campaign,
	          invalid = _props2.invalid,
	          submitFailed = _props2.submitFailed,
	          collaboratorsForm = _props2.collaboratorsForm;
	      var campaignInviteLoading = this.state.campaignInviteLoading;
	
	
	      var hasClient = !!campaign.get('client');
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit(this.inviteCollaborators.bind(this)) },
	        _react2.default.createElement(_immutable.FieldArray, {
	          name: 'collaborators',
	          form: collaboratorsForm,
	          hasClient: hasClient,
	          component: _formInviteRow2.default
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hero small' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Any people you add will get an email with instructions to join this dyzio campaign.'
	            ),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(
	              'button',
	              { className: 'large rose wide', type: 'submit' },
	              campaignInviteLoading ? _react2.default.createElement(
	                'ul',
	                { className: 'dots' },
	                _react2.default.createElement('li', { id: 'dot1' }),
	                _react2.default.createElement('li', null),
	                _react2.default.createElement('li', { id: 'dot2' }),
	                _react2.default.createElement('li', null),
	                _react2.default.createElement('li', { id: 'dot3' })
	              ) : _react2.default.createElement(
	                'p',
	                null,
	                'invite and continue'
	              )
	            ),
	            invalid && submitFailed && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                { className: 'small error' },
	                'Errors found above. Please correct them and try again.'
	              ),
	              _react2.default.createElement('div', { className: 'spacer' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignInvite;
	}(_react2.default.Component);
	
	CampaignInvite.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	CampaignInvite.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	function validate(values, props) {
	  var errors = {};
	  var collaborators = values.get('collaborators');
	  var collaboratorsListErrors = [];
	  var allEmails = [];
	  var memberEmails = props.memberEmails;
	  var pendingMemberEmails = props.pendingMemberEmails;
	
	  collaborators.forEach(function (collaborator, index) {
	    var email = collaborator.get('email');
	    var role = collaborator.get('role');
	    var collaboratorErrors = {};
	
	    var emailExists = _lodash2.default.find(allEmails, function (existingEmail) {
	      return existingEmail === email;
	    });
	    if (emailExists) {
	      collaboratorErrors.email = 'Emails must be unique';
	      collaboratorsListErrors[index] = collaboratorErrors;
	    }
	    allEmails.push(email);
	
	    var memberExists = _lodash2.default.includes(memberEmails, email);
	    if (memberExists) {
	      collaboratorErrors.email = 'This person is already on this campaign.';
	      collaboratorsListErrors[index] = collaboratorErrors;
	    }
	
	    var pendingMemberExists = _lodash2.default.includes(pendingMemberEmails, email);
	    if (pendingMemberExists) {
	      collaboratorErrors.email = 'This person has already been invited.';
	      collaboratorsListErrors[index] = collaboratorErrors;
	    }
	
	    // If an attempt has been made to fill in the form row validate it
	    if (email || role) {
	      if (!email) {
	        collaboratorErrors.email = 'Please enter a valid email.';
	        collaboratorsListErrors[index] = collaboratorErrors;
	      }
	      if (email && !_formInputValidation.EMAIL_REGULAR_EXPRESSION.test(email)) {
	        collaboratorErrors.email = 'Please enter a valid email.';
	        collaboratorsListErrors[index] = collaboratorErrors;
	      }
	      if (!role) {
	        collaboratorErrors.role = 'Please select a collaborator role.';
	        collaboratorsListErrors[index] = collaboratorErrors;
	      }
	
	      var socialHandle = collaborator.get('socialHandle');
	      var influencer = collaborator.get('influencer');
	      var company = collaborator.get('company');
	
	      if (role === _staticConfiguration.INFLUENCER) {
	        if (!socialHandle) {
	          collaboratorErrors.socialHandle = 'Please enter a social handle.';
	          collaboratorsListErrors[index] = collaboratorErrors;
	        }
	      }
	    }
	
	    if (collaboratorsListErrors.length) {
	      errors.collaborators = collaboratorsListErrors;
	    }
	  });
	
	  return errors;
	}
	
	// Used to map the form state to props to allow for custom form render logic
	var selector = (0, _immutable.formValueSelector)('InviteCampaignForm');
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    campaign: state.campaign.get('campaign'),
	    currentUser: state.userData.get('currentUser'),
	    collaboratorsForm: selector(state, 'collaborators'),
	    initialValues: {
	      collaborators: [{}, {}, {}]
	    }
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onClearStatusBar: function onClearStatusBar() {
	      return dispatch((0, _actions2.clearStatusBar)());
	    },
	    onSetStatusBar: function onSetStatusBar(message, colour) {
	      return dispatch((0, _actions2.setStatusBar)(message, colour));
	    },
	    onSetReloadDiscussions: function onSetReloadDiscussions(reload) {
	      return dispatch((0, _actions.setReloadDiscussions)(reload));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutable.reduxForm)({
	  form: 'InviteCampaignForm',
	  validate: validate
	})(CampaignInvite));

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _influencerContextBar = __webpack_require__(193);
	
	var _influencerContextBar2 = _interopRequireDefault(_influencerContextBar);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _influencerCategory = __webpack_require__(547);
	
	var _influencerCategory2 = _interopRequireDefault(_influencerCategory);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _creatorProfileStats = __webpack_require__(1923);
	
	var _creatorProfileStats2 = _interopRequireDefault(_creatorProfileStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatorPage = function (_Component) {
	  _inherits(CreatorPage, _Component);
	
	  function CreatorPage(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CreatorPage);
	
	    var _this = _possibleConstructorReturn(this, (CreatorPage.__proto__ || Object.getPrototypeOf(CreatorPage)).call(this, props));
	
	    _this.reloadDetails = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var jsonAPIClient, influencerDetails, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              jsonAPIClient = _this.props.jsonAPIClient;
	              influencerDetails = _this.state.influencerDetails;
	              _context.next = 4;
	              return jsonAPIClient.get('influencerDetails', influencerDetails.id, {
	                include: ['tags']
	              });
	
	            case 4:
	              response = _context.sent;
	
	              _this.setState({
	                influencerDetails: response.toJSONTree()
	              });
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.leftButtonCallback = function () {
	      return _this.context.router.push('/dashboard');
	    };
	
	    _this.rightButtonCallback = function () {
	      return _this.context.router.push('/influencer/add');
	    };
	
	    _this.state = {
	      influencer: null,
	      influencerDetails: null,
	      isLoaded: false,
	      isLoading: true,
	      isError: false,
	      adrModalOpen: false,
	      selectedPlatforms: [],
	      dataPermission: null,
	      isLoadingPermission: true
	    };
	    return _this;
	  }
	
	  _createClass(CreatorPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var _props = this.props,
	          params = _props.params,
	          jsonAPIClient = _props.jsonAPIClient,
	          creatorId = _props.creatorId;
	
	      jsonAPIClient.get('creators', creatorId || params.id).then(function (response) {
	        var resource = response.toJSONTree();
	        _this3.setState({
	          organisation: resource.organisation,
	          influencer: resource,
	          influencerDetails: resource,
	          isLoaded: true,
	          isLoading: false,
	          isError: false
	        }, _this3.requestADRPermission);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          influencer = _state.influencer,
	          assessment = _state.assessment,
	          isLoading = _state.isLoading;
	
	
	      var tiktokIconStyle = {
	        width: 15,
	        marginTop: 2
	      };
	
	      var _props2 = this.props,
	          asModal = _props2.asModal,
	          onBackClick = _props2.onBackClick;
	
	      if (!influencer) return null;
	      var name = influencer.name,
	          thumbnail = influencer.thumbnail,
	          primarySocialHandle = influencer.primarySocialHandle,
	          facebookCount = influencer.facebookCount,
	          instagramCount = influencer.instagramCount,
	          twitterCount = influencer.twitterCount,
	          youtubeCount = influencer.youtubeCount,
	          facebook = influencer.facebook,
	          instagram = influencer.instagram,
	          twitter = influencer.twitter,
	          youtube = influencer.youtube,
	          twitch = influencer.twitch,
	          twitchCount = influencer.twitchCount,
	          tiktok = influencer.tiktok,
	          tiktokCount = influencer.tiktokCount,
	          telegramUser = influencer.telegramUser;
	
	
	      var youtubeSlug = void 0;
	      if (youtube) {
	        var idRegEx = /^UC([a-zA-Z0-9_-]{22})$/;
	        var isChannelId = function isChannelId(yt) {
	          return yt.match(idRegEx);
	        };
	        youtubeSlug = isChannelId(youtube) ? 'channel/' + youtube : 'user/' + youtube;
	      }
	
	      var commaFormat = function commaFormat(num) {
	        var format = num > 1000000 ? '0.0a' : '0a';
	        return (0, _numeral2.default)(num).format(format);
	      };
	
	      var proxyInfluencer = {
	        youtubeCount: youtubeCount,
	        facebookCount: facebookCount,
	        instagramCount: instagramCount,
	        twitterCount: twitterCount
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: !asModal ? 'page' : '' },
	        isLoading && _react2.default.createElement(
	          'div',
	          { style: { height: '60vh', width: '100%' } },
	          _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: true, inverted: true },
	            _react2.default.createElement(
	              _semanticUiReact.Loader,
	              { indeterminate: true },
	              'Loading'
	            )
	          )
	        ),
	        _react2.default.createElement(_influencerContextBar2.default, {
	          rightButtonCallback: this.rightButtonCallback,
	          leftButtonCallback: this.leftButtonCallback,
	          leftButtonLabel: 'Create A Campaign',
	          rightButtonLabel: 'Add An Influencer',
	          onBackClick: onBackClick,
	          title: 'Back'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: (!asModal ? 'page-hero' : '') + ' flex no-border' },
	          _react2.default.createElement(
	            'div',
	            { className: 'item' },
	            _react2.default.createElement(_semanticUiReact.Image, { src: thumbnail, alt: name, size: 'tiny', shape: 'circular', spaced: 'right' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'space' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              name,
	              '\xA0\xA0',
	              _react2.default.createElement(
	                'span',
	                { className: 'light' },
	                primarySocialHandle
	              )
	            ),
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(_semanticUiReact.Rating, { icon: 'star', rating: assessment, maxRating: 5, disabled: true })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex' },
	              _react2.default.createElement(
	                'div',
	                { className: 'space align-center' },
	                _react2.default.createElement(
	                  _targetLink2.default,
	                  {
	                    href: 'https://www.facebook.com/' + facebook,
	                    renderIf: Boolean(facebook)
	                  },
	                  _react2.default.createElement('img', { src: '/icons/facebook.svg', alt: 'Facebook' }),
	                  facebook && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    commaFormat(facebookCount)
	                  ),
	                  !facebook && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'space align-center' },
	                _react2.default.createElement(
	                  _targetLink2.default,
	                  {
	                    href: 'https://www.instagram.com/' + instagram,
	                    renderIf: Boolean(instagram)
	                  },
	                  _react2.default.createElement('img', { src: '/icons/instagram.svg', alt: 'Instagram' }),
	                  instagram && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    commaFormat(instagramCount)
	                  ),
	                  !instagram && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'space align-center' },
	                _react2.default.createElement(
	                  _targetLink2.default,
	                  {
	                    href: 'https://www.twitter.com/' + twitter,
	                    renderIf: Boolean(twitter)
	                  },
	                  _react2.default.createElement('img', { src: '/icons/twitter.svg', alt: 'Twitter' }),
	                  twitter && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    commaFormat(twitterCount)
	                  ),
	                  !twitter && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'space align-center' },
	                _react2.default.createElement(
	                  _targetLink2.default,
	                  {
	                    href: 'https://www.youtube.com/' + youtubeSlug,
	                    renderIf: Boolean(youtube)
	                  },
	                  _react2.default.createElement('img', { src: '/icons/youtube.svg', alt: 'YouTube' }),
	                  youtube && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    commaFormat(youtubeCount)
	                  ),
	                  !youtube && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'space align-center' },
	                _react2.default.createElement(
	                  _targetLink2.default,
	                  {
	                    href: 'https://www.twitch.com/' + twitch,
	                    renderIf: Boolean(twitch) && twitchCount
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitch', color: 'purple' }),
	                  twitch && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    commaFormat(twitchCount)
	                  ),
	                  !twitch && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'space align-center' },
	                _react2.default.createElement(
	                  _targetLink2.default,
	                  {
	                    href: 'https://www.tiktok.com/@' + tiktok,
	                    renderIf: Boolean(tiktok)
	                  },
	                  _react2.default.createElement('img', { style: tiktokIconStyle, src: 'https://app.dyzio.co/logos/tiktok-logo.svg', alt: 'Tiktok' }),
	                  tiktok && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    commaFormat(tiktokCount)
	                  ),
	                  !tiktok && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'space align-center' },
	                _react2.default.createElement(
	                  _targetLink2.default,
	                  {
	                    href: 'https://www.facebook.com/' + facebook,
	                    renderIf: false
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram', color: 'blue' }),
	                  telegramUser && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'green' })
	                  ),
	                  !telegramUser && _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'space' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'item align-center' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    'Category'
	                  )
	                ),
	                _react2.default.createElement(_influencerCategory2.default, { influencer: proxyInfluencer })
	              )
	            )
	          )
	        ),
	        influencer && _react2.default.createElement(_creatorProfileStats2.default, { influencer: influencer, asModal: asModal })
	      );
	    }
	  }]);
	
	  return CreatorPage;
	}(_react.Component);
	
	CreatorPage.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	CreatorPage.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  jsonAPIClient: _propTypes2.default.object.isRequired,
	  asModal: _propTypes2.default.bool
	};
	CreatorPage.defaultProps = {
	  asModal: false
	};
	
	exports.default = (0, _recompose.compose)(_hasJsonapiClient2.default, _hasUserInfo2.default)(CreatorPage);

/***/ },
/* 910 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NEW_DELIVERABLE = exports.NEW_DELIVERABLE = 'Dyzio/Deliverable/NEW_DELIVERABLE';
	
	var SHOW_EXISTING_DELIVERABLE = exports.SHOW_EXISTING_DELIVERABLE = 'Dyzio/DeliverableAssign/SHOW_EXISTING_DELIVERABLE';
	var SHOW_EXISTING_DELIVERABLE_SUCCESS = exports.SHOW_EXISTING_DELIVERABLE_SUCCESS = 'Dyzio/DeliverableAssign/SHOW_EXISTING_DELIVERABLE_SUCCESS';
	
	var EDIT_EXISTING_DELIVERABLE = exports.EDIT_EXISTING_DELIVERABLE = 'Dyzio/DeliverableAssign/EDIT_EXISTING_DELIVERABLE';
	var EDIT_EXISTING_DELIVERABLE_SUCCESS = exports.EDIT_EXISTING_DELIVERABLE_SUCCESS = 'Dyzio/DeliverableAssign/EDIT_EXISTING_DELIVERABLE_SUCCESS';
	var EDIT_EXISTING_DELIVERABLE_ERROR = exports.EDIT_EXISTING_DELIVERABLE_ERROR = 'Dyzio/DeliverableAssign/EDIT_EXISTING_DELIVERABLE_ERROR';
	
	var CLEAR_EXISTING_DELIVERABLE = exports.CLEAR_EXISTING_DELIVERABLE = 'Dyzio/DeliverableAssign/CLEAR_EXISTING_DELIVERABLE';

/***/ },
/* 911 */
[4184, 195],
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _axiosRetry = __webpack_require__(168);
	
	var _axiosRetry2 = _interopRequireDefault(_axiosRetry);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _demographicsAgeGraph = __webpack_require__(241);
	
	var _demographicsAgeGraph2 = _interopRequireDefault(_demographicsAgeGraph);
	
	var _demographicsFunctions = __webpack_require__(2372);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const TEAM_DYZIO_ID = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';
	// const DC = 'fdd20559-e10d-4b07-834c-7882c127e82e';
	// const JONPLE = 'f4412f47-6788-47ac-84c9-dae56067a8c1';
	// const HERE_AND_NOW = '15e0ffdb-bd62-4eaf-b8ba-fb242ebc6fd6';
	
	var DEMOGRAPHICS_REFRESH_INTERVAL = 30000;
	
	var notificationStyle = {
	  paddingTop: 20,
	  paddingBottom: 20
	};
	
	var demographicsLoadingStyle = {
	  minHeight: 90,
	  marginTop: 30
	};
	
	var messageStyle = { color: 'grey', fontSize: 16 };
	
	var DyzioDemographics = function (_React$Component) {
	  _inherits(DyzioDemographics, _React$Component);
	
	  function DyzioDemographics() {
	    _classCallCheck(this, DyzioDemographics);
	
	    var _this = _possibleConstructorReturn(this, (DyzioDemographics.__proto__ || Object.getPrototypeOf(DyzioDemographics)).call(this));
	
	    _this.startDemographicsStatusRefresh = function () {
	      if (!_this.state.intervalId) {
	        var intervalId = setInterval(_this.loadDemographics, DEMOGRAPHICS_REFRESH_INTERVAL);
	        _this.setState({ intervalId: intervalId });
	      }
	    };
	
	    _this.stopDemographicsStatusRefresh = function () {
	      clearInterval(_this.state.intervalId);
	    };
	
	    _this.isDemographicsEmpty = function (demographics) {
	      var male65 = _lodash2.default.get(demographics, 'M65-.percentage', null);
	      return male65 === null;
	    };
	
	    _this.loadDemographics = function () {
	      console.log('LOAD AI DEMPGRAPHICS');
	      var profile = _this.props.influencer;
	      var instagram = profile.instagram;
	
	      if (instagram) {
	        _this.setState({
	          demographicsStatus: 'LOADING'
	        });
	        _this.restClient.get('/influencers/demographics/dyzio/' + instagram).then(function (response) {
	          var _response$data = response.data,
	              status = _response$data.status,
	              data = _response$data.data;
	
	          console.log(status, data);
	          if (status === 200) {
	            if (_this.isDemographicsEmpty(data.dyzioDemographics)) {
	              _this.setState({
	                demographicsStatus: 'SENT_FOR_ANALYSIS'
	              });
	              _this.startDemographicsStatusRefresh();
	            } else {
	              _this.setState({
	                demographicsStatus: 'GENERATED_OK',
	                demographicsData: data.dyzioDemographics
	              });
	              console.log('Dyzio AI DEMPGRAPHICS Retrieved');
	              _this.stopDemographicsStatusRefresh();
	            }
	          }
	          if (status === 204) {
	            _this.setState({
	              demographicsStatus: 'NOT_SENT'
	            });
	          }
	        }).catch(function (err) {
	          console.log('err', err);
	          _this.setState({
	            demographicsStatus: 'NOT_SENT'
	          });
	        });
	      }
	      _this.setState({
	        brandMentionsData: null,
	        brandMentionsLoading: false
	      });
	
	      return null;
	    };
	
	    _this.onClick = function () {
	      var _this$props$influence = _this.props.influencer,
	          instagram = _this$props$influence.instagram,
	          instagramId = _this$props$influence.instagramId,
	          id = _this$props$influence.id;
	
	      var instagramUsername = instagram;
	      console.log(instagramUsername, instagramId);
	      _this.setState({
	        demographicsStatus: 'LOADING'
	      });
	      var payload = {
	        data: {
	          forceScan: true,
	          influencer: {
	            username: instagramUsername,
	            instagramId: instagramId,
	            id: id
	          }
	        }
	      };
	      _this.restClient.post('/influencers/process', payload).then(function (response) {
	        console.log(response.data);
	        _this.setState({
	          demographicsStatus: 'SENT_FOR_ANALYSIS'
	        });
	        _this.startDemographicsStatusRefresh();
	      }).catch(function (err) {
	        console.log('err', err);
	        _this.setState({
	          demographicsStatus: 'SENT_FOR_ANALYSIS'
	        });
	        _this.startDemographicsStatusRefresh();
	      });
	    };
	
	    _this.NotSentState = function (instagramUsername) {
	      var organisationId = _this.props.organisationId;
	      console.log('organisationId', organisationId);
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { columns: 3 },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 3 },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Dyzio AI Demographics'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Dyzio uses AI technology, combined with real Instagram demographic data and our own proprietary algorithm to estimate Instagram audience demographics.'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Influencer demographics direct from Instagram, YouTube and Facebook are available via influencer authentication (Premium Feature).'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 13, verticalAlign: 'middle' },
	              _react2.default.createElement(
	                _semanticUiReact.Header,
	                { as: 'h2', icon: true, textAlign: 'center', style: notificationStyle },
	                _react2.default.createElement(
	                  _semanticUiReact.Header.Content,
	                  { style: messageStyle },
	                  instagramUsername,
	                  ' Instagram account has not been analysed yet'
	                ),
	                _react2.default.createElement(_semanticUiReact.Button, {
	                  centre: true,
	                  color: 'pink',
	                  content: 'Analyse AI demographics now',
	                  onClick: _this.onClick
	                  // disabled={organisationId === HERE_AND_NOW}
	                })
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.SentState = function (instagramUsername) {
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { columns: 3 },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 3 },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Dyzio AI Demographics'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Dyzio is currently analysing ',
	                instagramUsername,
	                '\u2019s audience. The page will refresh in a couple of minutes, when the data is available.'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 13, verticalAlign: 'middle' },
	              _react2.default.createElement(
	                _semanticUiReact.Header,
	                { as: 'h2', icon: true, textAlign: 'center', style: notificationStyle },
	                _react2.default.createElement(
	                  _semanticUiReact.Header.Content,
	                  { style: messageStyle },
	                  instagramUsername,
	                  ' is being analysed'
	                ),
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock outline', color: 'orange', circular: true })
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.GeneratedState = function (instagramUsername) {
	      var demographicsData = _this.state.demographicsData;
	
	      var audienceDemographics = { data: demographicsData };
	      console.log('demographicsData', audienceDemographics);
	
	      var _tabulateDemographics = (0, _demographicsFunctions.tabulateDemographics)(audienceDemographics.data),
	          demographicsTable = _tabulateDemographics.demographicsTable,
	          total = _tabulateDemographics.total;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { columns: 3 },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 3 },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Dyzio AI Demographics'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                instagramUsername,
	                '\u2019s Instagram demographic data is estimated using AI technology, combined with real demographic data from Instagram and Dyzio\u2019s own proprietary algorithm.'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Influencer demographics direct from Instagram, YouTube and Facebook are available via influencer authentication (Premium Feature).'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 8, textAlign: 'center' },
	              _react2.default.createElement(
	                'h5',
	                null,
	                'Channel demographic by gender / age'
	              ),
	              _react2.default.createElement(_demographicsAgeGraph2.default, { audienceDemographics: audienceDemographics })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 5 },
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { basic: 'very', columns: 'three', singleLine: true, textAlign: 'center', sortable: 'true' },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Header,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      { textAlign: 'left' },
	                      'Age Group'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      null,
	                      'Male'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      null,
	                      'Female'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      null,
	                      'Total'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Body,
	                  null,
	                  _lodash2.default.map(demographicsTable, function (_ref) {
	                    var _ref2 = _slicedToArray(_ref, 2),
	                        key = _ref2[0],
	                        value = _ref2[1];
	
	                    return _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        { textAlign: 'left' },
	                        key
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        value.M.percentage,
	                        '%'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        value.F.percentage,
	                        '%'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _numeral2.default)(value.M.percentage + value.F.percentage).format('0.0'),
	                        '%'
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      { textAlign: 'left' },
	                      'Total'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Header,
	                        { as: 'b', textAlign: 'center' },
	                        (0, _numeral2.default)(total.M).format('0.0'),
	                        '%'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Header,
	                        { as: 'b', textAlign: 'center' },
	                        (0, _numeral2.default)(total.F).format('0.0'),
	                        '%'
	                      )
	                    ),
	                    _react2.default.createElement(_semanticUiReact.Table.Cell, null)
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.LoadingState = function () {
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { columns: 3 },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 3 },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Dyzio AI Demographics'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Dyzio uses AI technology, combined with real Instagram demographic data and our own proprietary algorithm to estimate Instagram audience demographics.'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Influencer demographics direct from Instagram, YouTube and Facebook are available via influencer authentication (Premium Feature).'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 13, verticalAlign: 'middle' },
	              true && _react2.default.createElement(_semanticUiReact.Loader, {
	                active: true,
	                inline: 'centered',
	                content: 'Loading demographics data',
	                style: demographicsLoadingStyle
	              })
	            )
	          )
	        )
	      );
	    };
	
	    _this.getComponent = function (state, instagramUsername) {
	      var components = {
	        NOT_SENT: _this.NotSentState(instagramUsername),
	        SENT_FOR_ANALYSIS: _this.SentState(instagramUsername),
	        GENERATED_OK: _this.GeneratedState(instagramUsername),
	        LOADING: _this.LoadingState()
	      };
	      var component = components[state];
	      return component;
	    };
	
	    _this.state = {
	      demographicsStatus: 'LOADING',
	      demographicsData: {}
	    };
	    _this.restClient = _axios2.default.create({
	      baseURL: ("https://4v3dktn06a.execute-api.eu-west-1.amazonaws.com/production"),
	      timeout: 5000
	    });
	
	    (0, _axiosRetry2.default)(_this.restClient, {
	      delay: 100,
	      retries: 3
	    });
	    return _this;
	  }
	
	  _createClass(DyzioDemographics, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadDemographics();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      console.log('unmounting');
	      if (this.state.intervalId) {
	        this.stopDemographicsStatusRefresh();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var demographicsStatus = this.state.demographicsStatus;
	      var instagram = this.props.influencer.instagram;
	
	      var instagramUsername = instagram;
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.getComponent(demographicsStatus, instagramUsername)
	      );
	    }
	  }]);
	
	  return DyzioDemographics;
	}(_react2.default.Component);
	
	DyzioDemographics.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  organisationId: _propTypes2.default.string.isRequired
	};
	
	exports.default = DyzioDemographics;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditButton = function EditButton(_ref) {
	  var isClaimed = _ref.isClaimed,
	      onClick = _ref.onClick,
	      content = _ref.content;
	
	  if (isClaimed) {
	    return _react2.default.createElement(_semanticUiReact.Button, {
	      size: 'medium',
	      icon: 'lock',
	      fluid: true,
	      content: 'locked for demo',
	      disabled: true
	    });
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Button, {
	    size: 'medium',
	    basic: true,
	    fluid: true,
	    content: content,
	    onClick: onClick
	  });
	};
	
	EditButton.propTypes = {
	  isClaimed: _propTypes2.default.bool.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  content: _propTypes2.default.string.isRequired
	};
	
	exports.default = EditButton;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _authService = __webpack_require__(21);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _influencerTable = __webpack_require__(1987);
	
	var _influencerTable2 = _interopRequireDefault(_influencerTable);
	
	var _teamTable = __webpack_require__(2029);
	
	var _teamTable2 = _interopRequireDefault(_teamTable);
	
	var _invitedTable = __webpack_require__(885);
	
	var _invitedTable2 = _interopRequireDefault(_invitedTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pStyle = {
	  textAlign: 'center'
	};
	
	var pageStyle = {
	  marginTop: 50
	};
	
	var MY_TEAM = 'My Team';
	var MY_INFLUENCERS = 'My Influencers';
	
	var Invitation = function (_Component) {
	  _inherits(Invitation, _Component);
	
	  function Invitation() {
	    _classCallCheck(this, Invitation);
	
	    var _this = _possibleConstructorReturn(this, (Invitation.__proto__ || Object.getPrototypeOf(Invitation)).call(this));
	
	    _this.getInfluencers = function () {
	      var organisationId = _this.props.organisationId;
	
	      var options = {
	        filter: {
	          organisation: organisationId
	        },
	        include: ['influencer'],
	        'page[limit]': 50,
	        sort: ['createdDate']
	      };
	
	      _this.client.find('influencerLink', options).then(function (links) {
	        var influencers = _lodash2.default.map(links, function (link) {
	          return link.toJSONTree().influencer;
	        });
	        var sortedInfluencers = _lodash2.default.sortBy(influencers, ['name']);
	        return _this.setState({
	          influencers: sortedInfluencers
	        });
	      }).catch(console.log);
	    };
	
	    _this.getTeam = function (searchTerm) {
	      var organisationId = _this.props.organisationId;
	
	
	      console.log('blah');
	
	      var fetchOptions = {
	        filter: {
	          organisation: organisationId
	        },
	        sort: ['name'],
	        'page[limit]': 500
	      };
	
	      if (searchTerm) {
	        fetchOptions.filter.name = '~' + searchTerm;
	      }
	
	      console.log(fetchOptions);
	
	      _this.client.get('organisations', organisationId).then(function (org) {
	        var orgJson = org.toJSON();
	        return orgJson;
	      }).then(function (orgJson) {
	        return _this.client.find('users', fetchOptions).then(function (users) {
	          var userJsons = _lodash2.default.map(users, function (u) {
	            return u.toJSON();
	          });
	          var hostname = window.location.hostname;
	
	
	          var finalTeam = hostname.match(/voxogram/) ? _lodash2.default.reject(userJsons, function (u) {
	            return u.email.match(/dyzio\.co/);
	          }) : userJsons;
	          console.log('TEAM MEMBER COUNT: ' + finalTeam.length);
	          return _this.setState({
	            team: finalTeam,
	            originalTeam: finalTeam,
	            organisationName: orgJson.name
	          });
	        });
	      }).catch(console.log);
	    };
	
	    _this.teamSearch = function (e, _ref) {
	      var value = _ref.value;
	
	      var searchTerm = value;
	      var searchRegex = new RegExp(searchTerm, 'i');
	      var originalTeam = _this.state.originalTeam;
	
	      var filteredTeam = _lodash2.default.filter(originalTeam, function (tm) {
	        return tm.name.match(searchRegex) || tm.email.match(searchRegex);
	      });
	      _this.setState({ team: filteredTeam });
	    };
	
	    _this.handleInvitation = function (invitation) {
	      var campaign = _this.state.campaign;
	      var organisationId = _this.props.organisationId;
	
	      var campaignId = campaign ? campaign.id : _this.props.campaignId;
	      var campaignName = campaign ? campaign.name : _this.props.campaignName;
	
	      var invite = _this.client.create('campaignInvitation');
	
	      invite.set('name', invitation.name);
	      invite.set('campaign', {
	        type: 'campaigns',
	        id: campaignId
	      });
	      invite.set('organisation', {
	        type: 'organisations',
	        id: organisationId
	      });
	      invite.set('campaignName', campaignName);
	      invite.set('role', invitation.role);
	      var status = invitation.status || 'SENT';
	      invite.set('status', status);
	      var origin = window.location.origin;
	
	      invite.set('origin', origin);
	      invite.set('link', origin + '/invite/');
	
	      if (invitation.email) {
	        invite.set('email', invitation.email);
	      }
	
	      if (invitation.role === 'INFLUENCER') {
	        // this is where we would switch to using IDs
	        invite.set('metadata', {
	          instagram: invitation.instagram,
	          socialHandle: invitation.primarySocialHandle,
	          influencerId: invitation.id
	        });
	      }
	
	      _this.setState({
	        processing: true
	      });
	
	      return invite.sync().then(function (ci) {
	        var newInvitation = ci.toJSON();
	        var ax = _axios2.default.create({
	          baseURL: ("https://api2.dyzio.co/v1"),
	          timeout: 2000,
	          headers: {
	            Authorization: 'Bearer ' + _authService.authService.getToken()
	          }
	        });
	        ax.post('/campaigns/' + campaignId + '/relationships/pendingInvitations/', {
	          data: {
	            type: 'campaignInvitation',
	            id: newInvitation.id
	          }
	        }).then(function () {
	          _this.refreshCampaign();
	        });
	      }).catch(function (e) {
	        console.log(e);
	        _this.refreshCampaign();
	      });
	    };
	
	    _this.handleTeamMemberInvitation = function (user) {
	      var campaign = _this.state.campaign;
	      var organisationId = _this.props.organisationId;
	
	      var campaignId = campaign ? campaign.id : _this.props.campaignId;
	      var permission = _this.client.create('campaignPermission');
	
	      permission.set('name', user.name);
	      permission.set('campaign', {
	        type: 'campaigns',
	        id: campaignId
	      });
	      permission.set('organisation', {
	        type: 'organisations',
	        id: organisationId
	      });
	
	      permission.set('user', {
	        type: 'users',
	        id: user.id
	      });
	      permission.set('role', user.role);
	
	      permission.set('email', user.email);
	      permission.set('bypassUserSwitch', true);
	      permission.set('sendDailyNotifications', true);
	      permission.set('sendWeeklyNotifications', true);
	
	      return permission.sync().then(function (ci) {
	        var newPermission = ci.toJSON();
	        console.log(newPermission);
	        var ax = _axios2.default.create({
	          baseURL: ("https://api2.dyzio.co/v1"),
	          timeout: 2000,
	          headers: {
	            Authorization: 'Bearer ' + _authService.authService.getToken()
	          }
	        });
	        ax.post('/campaigns/' + campaignId + '/relationships/members/', {
	          data: {
	            type: 'campaignPermission',
	            id: newPermission.id
	          }
	        }).then(function () {
	          _this.refreshCampaign();
	        });
	      });
	    };
	
	    _this.goToCampaign = function () {
	      var campaign = _this.state.campaign;
	
	      var campaignId = campaign ? campaign.id : _this.props.campaignId;
	
	      if (campaign.campaignType === 'ACR') {
	        _this.context.router.push('/acr-campaign/' + campaignId);
	      } else {
	        _this.context.router.push('/campaign/' + campaignId);
	      }
	    };
	
	    _this.refreshCampaign = function () {
	      var campaign = _this.state.campaign;
	
	      var TIMEOUT = 1500;
	      var campaignId = campaign ? campaign.id : _this.props.campaignId;
	      _lodash2.default.delay(function () {
	        return _this.client.get('campaigns', campaignId, { include: ['members', 'pendingInvitations'] }).then(function (newCampaign) {
	          _this.setState({
	            campaign: newCampaign.toJSONTree(),
	            processing: false
	          });
	        }).catch(function (e) {
	          console.Console.log('refresh campaign failed');
	          console.log(e);
	          _this.setState({
	            campaign: campaign,
	            processing: false
	          });
	        });
	      }, TIMEOUT, {});
	    };
	
	    _this.handleInvitationDelete = function (invitation) {
	      var restClient = _this.props.restClient;
	
	      return restClient.delete('campaignInvitation/' + invitation.id).then(function () {
	        window.location.reload(true);
	      });
	    };
	
	    _this.handleItemClick = function (e, _ref2) {
	      var name = _ref2.name;
	      return _this.setState({ activeItem: name });
	    };
	
	    _this.state = {
	      activeItem: MY_INFLUENCERS,
	      influencers: [],
	      team: [],
	      campaign: null,
	      originalTeam: [],
	      processing: false
	    };
	
	    _this.client = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	      header: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Invitation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var campaign = this.props.campaign;
	
	      this.setState({
	        campaign: campaign
	      });
	
	      this.getInfluencers();
	      this.getTeam();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          activeItem = _state.activeItem,
	          influencers = _state.influencers,
	          team = _state.team,
	          campaign = _state.campaign,
	          organisationName = _state.organisationName,
	          processing = _state.processing;
	      var _props = this.props,
	          organisationId = _props.organisationId,
	          organisation = _props.organisation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: pageStyle },
	        _react2.default.createElement(
	          'h1',
	          { style: pStyle },
	          'Add people to your campaign'
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: pStyle },
	          'Invitation emails can be sent from the next screen'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Menu,
	          { pointing: true, widths: '2', size: 'massive' },
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: MY_INFLUENCERS,
	            active: activeItem === MY_INFLUENCERS,
	            onClick: this.handleItemClick
	          }),
	          _react2.default.createElement(_semanticUiReact.Menu.Item, {
	            name: MY_TEAM,
	            active: activeItem === MY_TEAM,
	            onClick: this.handleItemClick
	          })
	        ),
	        _react2.default.createElement(_influencerTable2.default, {
	          influencers: influencers,
	          organisationId: organisationId,
	          organisation: organisation,
	          campaign: campaign,
	          visible: activeItem === MY_INFLUENCERS,
	          onInvite: this.handleInvitation,
	          processing: processing
	        }),
	        _react2.default.createElement(_teamTable2.default, {
	          team: team,
	          campaign: campaign,
	          visible: activeItem === MY_TEAM,
	          onInvite: this.handleInvitation,
	          onAdd: this.handleTeamMemberInvitation,
	          organisationName: organisationName,
	          onSearchChange: this.teamSearch
	        }),
	        _react2.default.createElement(_invitedTable2.default, { campaign: campaign, deleteHandler: this.handleInvitationDelete }),
	        _react2.default.createElement(
	          'div',
	          { style: pStyle },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'large rose wide', onClick: this.goToCampaign
	            },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Take me to my campaign'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Invitation;
	}(_react.Component);
	
	Invitation.contextTypes = {
	  router: _propTypes2.default.object
	};
	Invitation.propTypes = {
	  organisationId: _propTypes2.default.string.isRequired,
	  campaign: _propTypes2.default.object,
	  campaignId: _propTypes2.default.string,
	  campaignName: _propTypes2.default.string
	};
	Invitation.defaultProps = {
	  campaign: null,
	  campaignId: '',
	  campaignName: ''
	};
	
	
	Invitation.propTypes = {
	  organisation: _propTypes2.default.object.isRequired,
	  restClient: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _hasRestClient2.default)(Invitation);

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.INVENTORY_HELP_LINK = undefined;
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _recompose = __webpack_require__(15);
	
	var _pagination = __webpack_require__(147);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _currencies = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INVENTORY_HELP_LINK = exports.INVENTORY_HELP_LINK = 'https://help.dyzio.co/en/articles/4539130-setting-up-your-inventory';
	
	var PER_PAGE = 30;
	
	var helpLinkStyle = {
	  color: 'rgb(32, 196, 158)'
	};
	
	var headerCellStyle = {
	  textTransform: 'uppercase',
	  fontSize: 13,
	  color: '#808080'
	};
	
	var labelStyle = {
	  fontSize: 11,
	  textTransform: 'uppercase'
	};
	
	var dividerStyle = {
	  marginTop: 10
	};
	
	var addButtonStyle = {
	  marginTop: 20,
	  height: 41
	};
	
	var containerCardStyle = {
	  minHeight: 700,
	  display: 'block'
	};
	
	var rightBorderStyle = {
	  borderRight: '2px solid #808080'
	};
	
	var OrganisationInventory = function (_PureComponent) {
	  _inherits(OrganisationInventory, _PureComponent);
	
	  //
	  function OrganisationInventory() {
	    var _this2 = this;
	
	    _classCallCheck(this, OrganisationInventory);
	
	    var _this = _possibleConstructorReturn(this, (OrganisationInventory.__proto__ || Object.getPrototypeOf(OrganisationInventory)).call(this));
	
	    _this.loadInventoryItems = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var searchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var restClient, organisationId, params, response, data, page;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                restClient = _this.props.restClient;
	                organisationId = _lodash2.default.get(_this.props, 'organisation.id');
	                params = {
	                  'filter[organisation]': organisationId
	                };
	
	
	                if (!_lodash2.default.isEmpty(_lodash2.default.trim(searchTerm))) {
	                  params['filter[value]'] = ':' + searchTerm;
	                  _this.setState({
	                    isSearching: true,
	                    searchTerm: searchTerm
	                  });
	                }
	
	                params['page[offset]'] = _this.state.currentOffset;
	                params['page[limit]'] = PER_PAGE;
	                params.sort = '-createdDate';
	
	                _context.next = 9;
	                return restClient.get('inventoryItems', { params: params }).catch(function () {
	                  return _this.setState({
	                    isError: true,
	                    isSearching: false,
	                    isLoadingItems: false,
	                    totalPages: 1,
	                    items: [],
	                    currentOffset: 1
	                  });
	                });
	
	              case 9:
	                response = _context.sent;
	
	                if (response) {
	                  data = _lodash2.default.get(response, 'data.data', []);
	                  page = _lodash2.default.get(response, 'data.meta.page');
	
	                  _this.setState({
	                    isLoadingItems: false,
	                    items: data,
	                    isSearching: false,
	                    totalPages: _lodash2.default.ceil(_lodash2.default.divide(_lodash2.default.get(page, 'total', 0) / PER_PAGE)),
	                    currentOffset: _lodash2.default.get(page, 'offset', 0)
	                  });
	                }
	
	              case 11:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function () {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onAddNewInventoryItem = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var restClient, _this$state, newItemValue, newMonetaryValue, organisationId, userName, data;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              restClient = _this.props.restClient;
	              _this$state = _this.state, newItemValue = _this$state.newItemValue, newMonetaryValue = _this$state.newMonetaryValue;
	              organisationId = _lodash2.default.get(_this.props, 'organisation.id');
	              userName = _lodash2.default.get(_this.props, 'userInfo.name');
	              data = {
	                attributes: {
	                  value: newItemValue,
	                  monetaryValue: newMonetaryValue,
	                  organisation: {
	                    type: 'organisations',
	                    id: organisationId
	                  },
	                  createdBy: userName
	                }
	              };
	
	              _this.setState({
	                isAddingANewItem: true
	              }, _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        _context2.next = 2;
	                        return restClient.post('inventoryItems', {
	                          data: data
	                        });
	
	                      case 2:
	                        _this.setState({
	                          isAddingANewItem: false,
	                          newItemValue: '',
	                          newMonetaryValue: 0
	                        }, _this.loadInventoryItems);
	
	                      case 3:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, _this2);
	              })));
	
	            case 6:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.onInputChanged = function (event, _ref4) {
	      var name = _ref4.name,
	          value = _ref4.value;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.onSearchValueChanged = _lodash2.default.debounce(function (event, _ref5) {
	      var value = _ref5.value;
	
	      _this.loadInventoryItems(value);
	    }, 500);
	
	    _this.onUpdateItem = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(inventoryItemId) {
	        var restClient, _this$state2, updatedItemValue, updatedMonetaryValue, attributes;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                restClient = _this.props.restClient;
	                _this$state2 = _this.state, updatedItemValue = _this$state2.updatedItemValue, updatedMonetaryValue = _this$state2.updatedMonetaryValue;
	                attributes = {};
	
	                if (updatedItemValue) {
	                  _lodash2.default.set(attributes, 'value', updatedItemValue);
	                }
	                if (updatedMonetaryValue) {
	                  _lodash2.default.set(attributes, 'monetaryValue', updatedMonetaryValue);
	                }
	
	                if (!_lodash2.default.isEmpty(attributes)) {
	                  _context4.next = 7;
	                  break;
	                }
	
	                return _context4.abrupt('return');
	
	              case 7:
	                _context4.next = 9;
	                return restClient.patch('inventoryItems/' + inventoryItemId, {
	                  data: {
	                    attributes: attributes
	                  }
	                });
	
	              case 9:
	                _this.setState({
	                  itemUpdated: true,
	                  updatedItemValue: '',
	                  updatedMonetaryValue: 0
	                }, _this.loadInventoryItems);
	
	              case 10:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.onItemDelete = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(id) {
	        var restClient;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                if (!_lodash2.default.isNil(id)) {
	                  _context5.next = 2;
	                  break;
	                }
	
	                return _context5.abrupt('return');
	
	              case 2:
	                restClient = _this.props.restClient;
	                _context5.next = 5;
	                return restClient.delete('inventoryItems/' + id);
	
	              case 5:
	                _this.loadInventoryItems();
	
	              case 6:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this.onPopupClose = function () {
	      _this.setState({
	        itemUpdated: false
	      });
	    };
	
	    _this.onPageDecrement = function () {
	      var _this$state3 = _this.state,
	          currentOffset = _this$state3.currentOffset,
	          searchTerm = _this$state3.searchTerm;
	
	      if (currentOffset <= 0) return;
	      _this.setState({
	        currentOffset: _lodash2.default.subtract(currentOffset, PER_PAGE)
	      }, function () {
	        return _this.loadInventoryItems(searchTerm);
	      });
	    };
	
	    _this.onPageIncrement = function () {
	      var _this$state4 = _this.state,
	          currentOffset = _this$state4.currentOffset,
	          totalPages = _this$state4.totalPages,
	          searchTerm = _this$state4.searchTerm;
	
	      if (currentOffset > totalPages) return;
	      _this.setState({
	        currentOffset: _lodash2.default.add(currentOffset, PER_PAGE)
	      }, function () {
	        return _this.loadInventoryItems(searchTerm);
	      });
	    };
	
	    _this.state = {
	      searchTerm: '',
	      updatedMonetaryValue: '',
	      updatedItemValue: '',
	      newItemValue: '',
	      newMonetaryValue: 0,
	      isAddingANewItem: false,
	      items: [],
	      isLoadingItems: true,
	      isError: false,
	      itemUpdated: false,
	      isSearching: false,
	      totalPages: null,
	      currentPage: 0
	    };
	    return _this;
	  }
	
	  _createClass(OrganisationInventory, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadInventoryItems();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          newItemValue = _state.newItemValue,
	          newMonetaryValue = _state.newMonetaryValue,
	          isAddingANewItem = _state.isAddingANewItem,
	          items = _state.items,
	          isLoadingItems = _state.isLoadingItems,
	          itemUpdated = _state.itemUpdated,
	          isSearching = _state.isSearching,
	          searchTerm = _state.searchTerm,
	          totalPages = _state.totalPages,
	          currentOffset = _state.currentOffset;
	
	
	      var currency = _lodash2.default.get(this.props, 'organisation.defaultCurrency', 'GBP');
	
	      var addButtonProps = {
	        disabled: _lodash2.default.isEmpty(_lodash2.default.trim(newItemValue)) || _lodash2.default.toNumber(newMonetaryValue) < 1,
	        loading: isAddingANewItem,
	        onClick: this.onAddNewInventoryItem,
	        icon: true,
	        color: 'pink',
	        fluid: true,
	        style: addButtonStyle,
	        labelPosition: 'left'
	      };
	
	      var monetaryLabelProps = { basic: true, content: (0, _currencies.renderCurrencySymbol)(currency), style: { paddingTop: 13 } };
	
	      var currentPage = _lodash2.default.floor(currentOffset / PER_PAGE) + 1;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Add items that your organisations gifts to influencers here.',
	              _react2.default.createElement('br', null),
	              'The system will allow you to assign the items to the influencer in the campaign',
	              _react2.default.createElement('br', null),
	              ' which will allow you to track the cost of the collaboration to your business.',
	              _react2.default.createElement('br', null),
	              'The system will pull the data through into the performance reports such as the ROI report.'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            { extra: true },
	            _react2.default.createElement(
	              _targetLink2.default,
	              { style: helpLinkStyle, renderIf: true, href: INVENTORY_HELP_LINK },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'help', circular: true }),
	              'click here for help'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              { fluid: true },
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 5, style: rightBorderStyle },
	                  _react2.default.createElement(
	                    'label',
	                    { style: headerCellStyle, htmlFor: 'newItemValue' },
	                    'search'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Input, {
	                    onChange: this.onSearchValueChanged,
	                    fluid: true,
	                    icon: _react2.default.createElement(_semanticUiReact.Icon, { name: isSearching ? 'refresh' : 'search', loading: isSearching }),
	                    placeholder: 'Search...'
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 5 },
	                  _react2.default.createElement(
	                    'label',
	                    { style: headerCellStyle, htmlFor: 'newItemValue' },
	                    'title'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Input, {
	                    name: 'newItemValue',
	                    fluid: true,
	                    value: newItemValue,
	                    onChange: this.onInputChanged,
	                    placeholder: 'Add a new iventory item'
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 3 },
	                  _react2.default.createElement(
	                    'label',
	                    { style: headerCellStyle, htmlFor: 'monetaryValue' },
	                    'monetary value'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Input, {
	                    id: 'newMonetaryValue',
	                    name: 'newMonetaryValue',
	                    fluid: true,
	                    step: '1',
	                    label: monetaryLabelProps,
	                    labelPosition: 'right',
	                    type: 'number',
	                    value: newMonetaryValue,
	                    onChange: this.onInputChanged,
	                    placeholder: 'Monetary value'
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 3 },
	                  _react2.default.createElement(
	                    _semanticUiReact.Button,
	                    addButtonProps,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' }),
	                    'Add item'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            { style: containerCardStyle },
	            isLoadingItems && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading items' }),
	            !isLoadingItems && _lodash2.default.isEmpty(items) && _lodash2.default.isEmpty(_lodash2.default.trim(searchTerm)) && _react2.default.createElement(
	              _semanticUiReact.Message,
	              null,
	              'No inventory items created yet'
	            ),
	            !isLoadingItems && _lodash2.default.isEmpty(items) && !_lodash2.default.isEmpty(_lodash2.default.trim(searchTerm)) && _react2.default.createElement(
	              _semanticUiReact.Message,
	              null,
	              'No inventory items found'
	            ),
	            !isLoadingItems && !_lodash2.default.isEmpty(items) && _react2.default.createElement(
	              _semanticUiReact.Table,
	              { basic: 'very', textAlign: 'center' },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Header,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: headerCellStyle, textAlign: 'left' },
	                    'title'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: headerCellStyle },
	                    'created date'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: headerCellStyle },
	                    'monetary value'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: headerCellStyle },
	                    'actions'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                _lodash2.default.map(items, function (item) {
	                  return _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    { key: _lodash2.default.get(item, 'id') },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      { width: 4, textAlign: 'left' },
	                      _lodash2.default.get(item, 'attributes.value')
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      { width: 4 },
	                      (0, _moment2.default)(_lodash2.default.get(item, 'attributes.createdDate')).format('DD/MM/YY')
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      { width: 2 },
	                      (0, _currencies.renderCurrencyQuantity)({
	                        currency: currency,
	                        amount: _lodash2.default.get(item, 'attributes.monetaryValue', 0)
	                      })
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      { width: 4 },
	                      _react2.default.createElement(
	                        _semanticUiReact.List,
	                        { horizontal: true },
	                        _react2.default.createElement(
	                          _semanticUiReact.List.Item,
	                          null,
	                          _react2.default.createElement(_semanticUiReact.Popup, {
	                            onClose: _this3.onPopupClose,
	                            content: _react2.default.createElement(
	                              'div',
	                              null,
	                              itemUpdated && _react2.default.createElement(
	                                _semanticUiReact.Message,
	                                { positive: true, fluid: true },
	                                'Item updated'
	                              ),
	                              _react2.default.createElement(
	                                'label',
	                                { style: labelStyle, htmlFor: 'updatedItemValue' },
	                                'Title'
	                              ),
	                              _react2.default.createElement(_semanticUiReact.Input, {
	                                id: 'updatedItemValue',
	                                onChange: _this3.onInputChanged,
	                                name: 'updatedItemValue',
	                                defaultValue: _lodash2.default.get(item, 'attributes.value')
	                              }),
	                              _react2.default.createElement('div', { style: dividerStyle }),
	                              _react2.default.createElement(
	                                'label',
	                                { style: labelStyle, htmlFor: 'updatedMonetaryValue' },
	                                'Monetary Value'
	                              ),
	                              _react2.default.createElement(_semanticUiReact.Input, {
	                                id: 'updatedMonetaryValue',
	                                onChange: _this3.onInputChanged,
	                                name: 'updatedMonetaryValue',
	                                defaultValue: _lodash2.default.get(item, 'attributes.monetaryValue')
	                              }),
	                              _react2.default.createElement('div', { style: dividerStyle }),
	                              _react2.default.createElement(_semanticUiReact.Button, {
	                                color: 'pink',
	                                inverted: true,
	                                fluid: true,
	                                content: 'Update item',
	                                onClick: function onClick() {
	                                  return _this3.onUpdateItem(_lodash2.default.get(item, 'id'));
	                                }
	                              })
	                            ),
	                            on: 'click',
	                            trigger: _react2.default.createElement(_semanticUiReact.Button, { icon: 'pencil', circular: true, inverted: true, color: 'pink' })
	                          })
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.List.Item,
	                          null,
	                          _react2.default.createElement(_semanticUiReact.Popup, {
	                            content: _react2.default.createElement(
	                              'div',
	                              null,
	                              'Are you sure?',
	                              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	                              _react2.default.createElement(_semanticUiReact.Button, {
	                                inverted: true,
	                                color: 'pink',
	                                fluid: true,
	                                content: 'Yes',
	                                onClick: function onClick() {
	                                  return _this3.onItemDelete(_lodash2.default.get(item, 'id'));
	                                }
	                              })
	                            ),
	                            on: 'click',
	                            pinned: true,
	                            trigger: _react2.default.createElement(_semanticUiReact.Button, { icon: 'trash', circular: true, inverted: true, color: 'pink' })
	                          })
	                        )
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          !_lodash2.default.isEmpty(items) && _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            { extra: true },
	            _react2.default.createElement(_pagination2.default, {
	              onPageIncrement: this.onPageIncrement,
	              onPageDecrement: this.onPageDecrement,
	              totalPages: totalPages,
	              currentPage: currentPage
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrganisationInventory;
	}(_react.PureComponent);
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(OrganisationInventory);

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(28);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _actions = __webpack_require__(2184);
	
	var _currencies = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var commaFormat = function commaFormat(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	
	var summaryRow = {
	  padding: '20px 30px 0px 30px'
	};
	
	var Payments = function (_Component) {
	  _inherits(Payments, _Component);
	
	  function Payments() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Payments);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Payments.__proto__ || Object.getPrototypeOf(Payments)).call.apply(_ref, [this].concat(args))), _this), _this.getBudgetTotal = function (array) {
	      return _lodash2.default.sumBy(array, 'budget');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Payments, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      console.log(this.props);
	      return this.props.onLoadPayments(this.props.params.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          payments = _props.payments,
	          paymentsLoading = _props.paymentsLoading,
	          campaign = _props.campaign;
	
	      var teamDiscussion = payments && payments.teamDiscussion;
	      var clientDiscussion = payments && payments.clientDiscussion;
	
	      var currency = campaign.get('currency');
	
	      var liveDate = campaign.get('liveDate');
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { loading: paymentsLoading, basic: true },
	        _react2.default.createElement(
	          'div',
	          { style: { margin: 10 } },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Fees'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _semanticUiReact.Card,
	            { fluid: true },
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 5, style: summaryRow },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Total influencer budget'
	                  ),
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    (0, _currencies.renderCurrencySymbol)(currency),
	                    ' ',
	                    payments && commaFormat(payments.budget)
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 5, style: summaryRow },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Allocated'
	                  ),
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    (0, _currencies.renderCurrencySymbol)(currency),
	                    payments && payments.discussions && commaFormat(this.getBudgetTotal(payments.discussions))
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'small light' },
	                    'remaining budget ',
	                    (0, _currencies.renderCurrencySymbol)(currency),
	                    payments && payments.discussions && commaFormat(payments.budget - this.getBudgetTotal(payments.discussions))
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 6, style: summaryRow },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Live date'
	                  ),
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    liveDate ? (0, _moment2.default)(liveDate).format('DD MMM YYYY') : _react2.default.createElement(
	                      'p',
	                      { className: 'small light' },
	                      'not set'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 16 },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    { unstackable: true, style: { borderLeft: 0, borderRight: 0 } },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Header,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'Influencer'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          { textAlign: 'center' },
	                          'Fee Agreed?'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          { textAlign: 'center' },
	                          'Influencer Fee'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Body,
	                      null,
	                      payments && payments.discussions && _lodash2.default.map(payments.discussions, function (discussion) {
	                        var isTeamDiscussion = discussion.id === teamDiscussion;
	                        var isClientDiscussion = discussion.id === clientDiscussion;
	                        var influencer = discussion.members && discussion.members[0];
	
	                        var icon = null;
	
	                        switch (discussion.budgetStatus) {
	                          case 'PROPOSED':
	                            icon = 'pending.svg';
	                            break;
	                          case 'APPROVED':
	                            icon = 'complete.svg';
	                            break;
	                          case 'REJECTED':
	                            icon = 'error-small.svg';
	                            break;
	                          default:
	                            icon = 'incomplete.svg';
	                            break;
	                        }
	
	                        if (!isClientDiscussion && !isTeamDiscussion) {
	                          return _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            { key: discussion.id },
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              { verticalAlign: 'middle' },
	                              influencer ? _react2.default.createElement(
	                                'h2',
	                                null,
	                                influencer.name,
	                                '\xA0',
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'small light' },
	                                  discussion.name
	                                )
	                              ) : _react2.default.createElement(
	                                'h2',
	                                null,
	                                discussion.name,
	                                '\xA0',
	                                _react2.default.createElement('span', { className: 'small light', style: { color: 'red' } })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              { textAlign: 'center' },
	                              _react2.default.createElement('img', { src: '/icons/' + icon, alt: discussion.budgetStatus })
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              { collapsing: true, style: { padding: '0 40px' } },
	                              _react2.default.createElement(
	                                'h2',
	                                null,
	                                '\xA0',
	                                (0, _currencies.renderCurrencySymbol)(currency),
	                                commaFormat(discussion.budget),
	                                '\xA0'
	                              )
	                            )
	                          );
	                        }
	                        return null;
	                      }),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        { style: { backgroundColor: '#F9FAFB' } },
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          { colSpan: '2', textAlign: 'right' },
	                          _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Total allocated Fees'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          { style: { padding: '0 40px' } },
	                          _react2.default.createElement(
	                            'h2',
	                            null,
	                            '\xA0',
	                            (0, _currencies.renderCurrencySymbol)(currency),
	                            payments && payments.discussions && commaFormat(this.getBudgetTotal(payments.discussions)),
	                            '\xA0'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Payments;
	}(_react.Component);
	
	Payments.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  onLoadPayments: _propTypes2.default.func.isRequired,
	  payments: _propTypes2.default.object.isRequired,
	  paymentsLoading: _propTypes2.default.bool.isRequired,
	  campaign: _propTypes2.default.object.isRequired
	};
	Payments.defaultProps = {
	  paymentsError: ''
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    campaign: state.campaign.get('campaign'),
	    payments: state.payments.get('payments'),
	    paymentsLoading: state.payments.get('paymentsLoading'),
	    paymentsError: state.payments.get('paymentsError')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onLoadPayments: function onLoadPayments(id) {
	      return dispatch((0, _actions.loadPayments)(id));
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Payments);

/***/ },
/* 917 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SEND_BRIEF_ALL = exports.SEND_BRIEF_ALL = 'Dyzio/SendBriefAll/SEND_BRIEF_ALL';

/***/ },
/* 918 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SEND_DELIVERABLE_ALL = exports.SEND_DELIVERABLE_ALL = 'Dyzio/SendDeliverableAll/SEND_DELIVERABLE_ALL';

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _recompose = __webpack_require__(15);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _influencerTag = __webpack_require__(882);
	
	var _influencerTag2 = _interopRequireDefault(_influencerTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tagsContainerStyle = {
	  minHeight: 50
	};
	
	var errorStyle = {
	  color: '#ef3a50',
	  fontSize: 12,
	  fontWeight: 'bold'
	};
	
	var TagsManager = function (_React$Component) {
	  _inherits(TagsManager, _React$Component);
	
	  //
	  function TagsManager() {
	    var _this2 = this;
	
	    _classCallCheck(this, TagsManager);
	
	    var _this = _possibleConstructorReturn(this, (TagsManager.__proto__ || Object.getPrototypeOf(TagsManager)).call(this));
	
	    _this.onInputChanged = function (event, _ref) {
	      var value = _ref.value;
	
	      _this.setState({
	        newTagValue: value
	      });
	    };
	
	    _this.onLoadTags = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, restClient, organisationId, response, tags;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, restClient = _this$props.restClient, organisationId = _this$props.userInfo.organisationId;
	
	              _this.setState({
	                isLoadingTags: true
	              });
	              _context.next = 4;
	              return restClient.get('tags?filter[organisation]=' + organisationId);
	
	            case 4:
	              response = _context.sent;
	              tags = _lodash2.default.get(response, 'data.data', []);
	
	              _this.setState({
	                tags: tags,
	                isLoadingTags: false,
	                tagsLoaded: true
	              });
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.onTagSelected = function (tagId) {
	      _this.setState({
	        editedTagId: tagId
	      });
	    };
	
	    _this.onAddNewTag = function () {
	      var _this$props2 = _this.props,
	          restClient = _this$props2.restClient,
	          _this$props2$userInfo = _this$props2.userInfo,
	          name = _this$props2$userInfo.name,
	          organisationId = _this$props2$userInfo.organisationId;
	      var newTagValue = _this.state.newTagValue;
	
	      _this.setState({
	        isAddingANewTag: true
	      }, _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var postData;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                postData = {
	                  attributes: {
	                    value: newTagValue,
	                    createdBy: name,
	                    organisation: {
	                      type: 'organisations',
	                      id: organisationId
	                    }
	                  }
	                };
	                _context2.next = 3;
	                return restClient.post('/tags', {
	                  data: postData
	                });
	
	              case 3:
	                _this.setState({
	                  isAddingANewTag: false,
	                  isLoadingTags: true,
	                  newTagValue: ''
	                }, _this.onLoadTags);
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      })));
	    };
	
	    _this.onDeleteTag = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(tagId) {
	        var restClient;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                restClient = _this.props.restClient;
	                _context3.next = 3;
	                return restClient.delete('tags/' + tagId);
	
	              case 3:
	                _context3.next = 5;
	                return _this.onLoadTags();
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.onSaveTag = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(tagId, value) {
	        var restClient;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                restClient = _this.props.restClient;
	                _context4.next = 3;
	                return restClient.patch('tags/' + tagId, {
	                  data: {
	                    attributes: {
	                      value: value
	                    }
	                  }
	                });
	
	              case 3:
	                _context4.next = 5;
	                return _this.onLoadTags();
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x2, _x3) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      tags: [],
	      newTagValue: '',
	      isLoadingTags: true,
	      tagsLoaded: false,
	      isAddingTag: false
	    };
	    return _this;
	  }
	
	  _createClass(TagsManager, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return this.onLoadTags();
	
	              case 2:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          newTagValue = _state.newTagValue,
	          isAddingANewTag = _state.isAddingANewTag,
	          isLoadingTags = _state.isLoadingTags,
	          tags = _state.tags,
	          tagsLoaded = _state.tagsLoaded;
	
	      var duplicateTagToBeAdded = _lodash2.default.some(tags, ['attributes.value', newTagValue]);
	      var actionProps = {
	        disabled: _lodash2.default.isEmpty(_lodash2.default.trim(newTagValue)) || duplicateTagToBeAdded,
	        icon: 'plus',
	        content: 'Add tag',
	        loading: isAddingANewTag,
	        onClick: this.onAddNewTag
	      };
	
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: true },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Tags Manager'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          isLoadingTags && _react2.default.createElement(
	            _semanticUiReact.Segment,
	            {
	              style: tagsContainerStyle,
	              basic: true
	            },
	            _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading new tags...' })
	          ),
	          !isLoadingTags && _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { basic: true, style: tagsContainerStyle },
	            tagsLoaded && _lodash2.default.isEmpty(tags) && _react2.default.createElement(_semanticUiReact.Message, { warning: true, content: 'No tags created yet.' }),
	            _react2.default.createElement(
	              _semanticUiReact.Label.Group,
	              null,
	              _lodash2.default.map(tags, function (tag) {
	                return _react2.default.createElement(_influencerTag2.default, Object.assign({
	                  key: tag.id,
	                  onClick: _this3.onTagSelected,
	                  onSave: _this3.onSaveTag,
	                  onDelete: _this3.onDeleteTag
	                }, tag));
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(_semanticUiReact.Input, {
	            fluid: true,
	            value: newTagValue,
	            action: actionProps,
	            onChange: this.onInputChanged,
	            placeholder: 'Add a new tag'
	          }),
	          duplicateTagToBeAdded && _react2.default.createElement(
	            'span',
	            { style: errorStyle },
	            'This tag already exists'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TagsManager;
	}(_react2.default.Component);
	
	TagsManager.propTypes = {
	  restClient: _propTypes2.default.func.isRequired,
	  userInfo: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(TagsManager);

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactTweetEmbed = __webpack_require__(469);
	
	var _reactTweetEmbed2 = _interopRequireDefault(_reactTweetEmbed);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _reactYoutube = __webpack_require__(745);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	var _reactDatepicker = __webpack_require__(445);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _recompose = __webpack_require__(15);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _facebookEmbed = __webpack_require__(873);
	
	var _facebookEmbed2 = _interopRequireDefault(_facebookEmbed);
	
	var _dyzioInstagramEmbed = __webpack_require__(346);
	
	var _dyzioInstagramEmbed2 = _interopRequireDefault(_dyzioInstagramEmbed);
	
	var _uploader = __webpack_require__(353);
	
	var _uploader2 = _interopRequireDefault(_uploader);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _assetTypeIcon = __webpack_require__(343);
	
	var _assetTypeIcon2 = _interopRequireDefault(_assetTypeIcon);
	
	var _staticConfiguration = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_IMAGE = 'https://s3-eu-west-1.amazonaws.com/dyzio-static-files/images/instagram-story2.png';
	
	var breakWordStyle = {
	  wordBreak: 'break-word'
	};
	
	var centreImgStyle = {
	  margin: 'auto'
	};
	
	var EmbedWrapper = function EmbedWrapper(_ref) {
	  var asset = _ref.asset;
	
	  var youtubeEmbedOpts = {
	    color: 'white',
	    width: '100%',
	    showinfo: 1
	  };
	
	  var EMBEDS = {
	    INSTAGRAM: _react2.default.createElement(_dyzioInstagramEmbed2.default, { assetId: asset.assetId }),
	    TWITTER: _react2.default.createElement(_reactTweetEmbed2.default, { id: asset.assetId }),
	    FACEBOOK: _react2.default.createElement(_facebookEmbed2.default, { url: asset.assetURL, size: 'small' }),
	    YOUTUBE: _react2.default.createElement(_reactYoutube2.default, { videoId: asset.assetId, opts: youtubeEmbedOpts }),
	    SNAPCHAT: _react2.default.createElement(
	      'div',
	      null,
	      'SNAPCHAT asset'
	    ),
	    VK: _react2.default.createElement(
	      'div',
	      null,
	      'VK asset'
	    ),
	    BLOG: _react2.default.createElement(
	      'div',
	      null,
	      'Blog asset'
	    )
	  };
	
	  return EMBEDS[asset.platform];
	};
	
	var INITIAL_STATE = {
	  open: false,
	  uploaderState: 1,
	  documentData: {},
	  success: false,
	  reach: null,
	  impressions: null,
	  engagements: null,
	  publishedDate: null,
	  clicks: null,
	  actions: null,
	  supportingDataId: null,
	  savedOK: false,
	  shouldUpdatePublishedDate: false,
	  callbackData: null
	};
	
	var UploadModal = function (_Component) {
	  _inherits(UploadModal, _Component);
	
	  function UploadModal(props) {
	    _classCallCheck(this, UploadModal);
	
	    var _this = _possibleConstructorReturn(this, (UploadModal.__proto__ || Object.getPrototypeOf(UploadModal)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var publishedDate = props.asset.publishedDate;
	
	    _this.state = _extends({}, INITIAL_STATE, {
	      publishedDate: publishedDate
	    });
	    _this.updateTrackedAssetPublishedDate();
	    return _this;
	  }
	
	  _createClass(UploadModal, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          uploaderState = _state.uploaderState,
	          savedOK = _state.savedOK,
	          documentData = _state.documentData,
	          reach = _state.reach,
	          views = _state.views,
	          impressions = _state.impressions,
	          engagements = _state.engagements,
	          clicks = _state.clicks,
	          actions = _state.actions,
	          likes = _state.likes,
	          comments = _state.comments,
	          publishedDate = _state.publishedDate,
	          shares = _state.shares,
	          saves = _state.saves,
	          stickerTaps = _state.stickerTaps;
	      var _props = this.props,
	          asset = _props.asset,
	          popupToggleHandler = _props.popupToggleHandler;
	
	
	      var isVK = _lodash2.default.get(asset, 'platform') === 'VK';
	      var isBlog = _lodash2.default.get(asset, 'platform') === 'BLOG';
	      var isSnapchat = _lodash2.default.get(asset, 'platform') === 'SNAPCHAT';
	      var isStory = _lodash2.default.get(asset, 'assetType', '') === 'STORY';
	      var isManual = _lodash2.default.get(asset, 'createdSource', '') === 'CAMPAIGN';
	      var assetLink = _lodash2.default.get(asset, 'assetURL');
	      var assetText = _lodash2.default.get(asset, 'extraData.text', '-');
	
	      var datePickerValue = publishedDate ? (0, _moment2.default)(publishedDate) : '';
	
	      var isManualStory = isStory && isManual;
	
	      var reachOrImpressionsAdded = true; // Boolean(reach) || Boolean(impressions);
	
	      return _react2.default.createElement(
	        _dyzioModal2.default,
	        {
	          onClose: popupToggleHandler,
	          headerText: 'Add data and/or Media',
	          size: 'large',
	          hasActionButton: true,
	          actionButtonContent: savedOK ? 'close' : 'save',
	          actionButtonColor: savedOK ? 'green' : 'pink',
	          actionButtonIcon: _react2.default.createElement(_semanticUiReact.Icon, { name: savedOK ? 'checkmark' : 'save' }),
	          onActionButtonClick: savedOK ? this.toggler : this.saveSupportingData,
	          shouldDisableActionButton: !reachOrImpressionsAdded
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { columns: 3, divided: true },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              null,
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Asset '
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(_assetTypeIcon2.default, { asset: asset, renderLabelAsText: true })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  assetText
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  'Published date'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  (0, _moment2.default)(publishedDate).format('lll')
	                )
	              ),
	              !isManualStory && !isSnapchat && _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  'Link to blog or social post'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    'p',
	                    { style: breakWordStyle },
	                    _react2.default.createElement(
	                      _targetLink2.default,
	                      { renderIf: true, href: assetLink },
	                      _lodash2.default.truncate(assetLink, { length: 300 })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              null,
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Media (optional)'
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              documentData.filePath ? _react2.default.createElement(_semanticUiReact.Image, {
	                style: centreImgStyle,
	                src: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/' + documentData.filePath,
	                onError: function onError(i) {
	                  i.target.src = DEFAULT_IMAGE;
	                }
	              }) : _react2.default.createElement(_uploader2.default, {
	                uploaderState: uploaderState,
	                updateUploaderState: this.updateUploaderState,
	                docType: _staticConfiguration.SUPPORTING_FILE,
	                uploadDataCallback: this.uploadDataCallback
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { textAlign: 'left' },
	              _react2.default.createElement(
	                'h4',
	                { style: { textAlign: 'center' } },
	                'Data'
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              isBlog && _react2.default.createElement(
	                _semanticUiReact.Form,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'views',
	                    label: 'views',
	                    placeholder: 'views',
	                    type: 'views',
	                    value: views,
	                    onChange: this.handleFormFieldChange
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'comments',
	                    label: 'comments',
	                    placeholder: 'comments',
	                    type: 'comments',
	                    value: comments,
	                    onChange: this.handleFormFieldChange
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'likes',
	                    label: 'likes',
	                    placeholder: 'likes',
	                    type: 'likes',
	                    value: likes,
	                    onChange: this.handleFormFieldChange
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'clicks',
	                    label: 'clicks',
	                    placeholder: 'clicks',
	                    type: 'clicks',
	                    value: clicks,
	                    onChange: this.handleFormFieldChange
	                  })
	                )
	              ),
	              isVK && _react2.default.createElement(
	                _semanticUiReact.Form,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'views',
	                    label: 'views',
	                    placeholder: 'views',
	                    type: 'views',
	                    value: views,
	                    onChange: this.handleFormFieldChange
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'likes',
	                    label: 'likes',
	                    placeholder: 'likes',
	                    type: 'likes',
	                    value: likes,
	                    onChange: this.handleFormFieldChange
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'comments',
	                    label: 'comments',
	                    placeholder: 'comments',
	                    type: 'comments',
	                    value: comments,
	                    onChange: this.handleFormFieldChange
	                  })
	                )
	              ),
	              isSnapchat && _react2.default.createElement(
	                _semanticUiReact.Form,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'views',
	                    label: 'views',
	                    placeholder: 'views',
	                    type: 'views',
	                    value: views,
	                    onChange: this.handleFormFieldChange
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'shares',
	                    label: 'shares',
	                    placeholder: 'shares',
	                    type: 'shares',
	                    value: shares,
	                    onChange: this.handleFormFieldChange
	                  })
	                )
	              ),
	              !isBlog && !isVK && !isSnapchat && _react2.default.createElement(
	                _semanticUiReact.Form,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Form.Field,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Form.Input, {
	                      name: 'views',
	                      label: 'views',
	                      placeholder: 'views',
	                      type: 'views',
	                      value: views,
	                      onChange: this.handleFormFieldChange
	                    })
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'impressions',
	                    label: 'impressions',
	                    placeholder: 'impressions',
	                    type: 'impressions',
	                    value: impressions,
	                    onChange: this.handleFormFieldChange
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'reach',
	                    label: 'reach',
	                    placeholder: 'reach',
	                    type: 'reach',
	                    value: reach,
	                    onChange: this.handleFormFieldChange
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'clicks',
	                    label: 'clicks',
	                    placeholder: 'clicks',
	                    type: 'clicks',
	                    value: clicks,
	                    onChange: this.handleFormFieldChange
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'shares',
	                    label: 'shares',
	                    placeholder: 'shares',
	                    type: 'shares',
	                    value: shares,
	                    onChange: this.handleFormFieldChange
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'saves',
	                    label: 'saves',
	                    placeholder: 'saves',
	                    type: 'saves',
	                    value: saves,
	                    onChange: this.handleFormFieldChange
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    name: 'stickerTaps',
	                    label: 'sticker taps',
	                    placeholder: 'stickerTaps',
	                    type: 'stickerTaps',
	                    value: stickerTaps,
	                    onChange: this.handleFormFieldChange
	                  })
	                )
	              ),
	              savedOK && _react2.default.createElement(
	                'div',
	                { style: { textAlign: 'center', color: 'pink' } },
	                _react2.default.createElement(_semanticUiReact.Divider, null),
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Saved OK!'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UploadModal;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.show = function (size) {
	    return function () {
	      return _this2.setState({ size: size, open: true });
	    };
	  };
	
	  this.close = function () {
	    return _this2.setState({ open: false });
	  };
	
	  this.updateUploaderState = function (newUploaderState) {
	    _this2.setState({ uploaderState: newUploaderState });
	  };
	
	  this.uploadDataCallback = function (documentData) {
	    _this2.setState({ documentData: documentData, success: true });
	  };
	
	  this.saveSupportingData = function () {
	    var supportingDataId = _this2.state.supportingDataId;
	
	    _this2.setState({ savedOK: false });
	    if (supportingDataId) {
	      return _this2.patchSupportingData(supportingDataId);
	    }
	    return _this2.createSupportingData();
	  };
	
	  this.createSupportingData = function () {
	    var _state2 = _this2.state,
	        documentData = _state2.documentData,
	        reach = _state2.reach,
	        impressions = _state2.impressions,
	        engagements = _state2.engagements,
	        actions = _state2.actions,
	        clicks = _state2.clicks,
	        likes = _state2.likes,
	        comments = _state2.comments,
	        views = _state2.views,
	        shares = _state2.shares,
	        saves = _state2.saves,
	        stickerTaps = _state2.stickerTaps;
	    var _props2 = _this2.props,
	        asset = _props2.asset,
	        successHandler = _props2.successHandler,
	        restClient = _props2.restClient,
	        jsonAPIClient = _props2.jsonAPIClient;
	
	    // create supportingData object
	
	    var supportingData = jsonAPIClient.create('supportingData');
	    supportingData.set('status', 'CREATED');
	    supportingData.set('asset', {
	      type: 'trackedAssets',
	      id: asset.id
	    });
	
	    supportingData.set('assetId', asset.id);
	    supportingData.set('assetUrl', asset.assetURL);
	    supportingData.set('assetPlatform', asset.platform);
	
	    if (documentData && documentData.filePath) {
	      supportingData.set('filePath', documentData.filePath);
	    } else {
	      supportingData.set('filePath', 'no_image_available.png');
	    }
	
	    if (views) {
	      supportingData.set('views', views);
	    }
	
	    if (shares) {
	      supportingData.set('shares', shares);
	    }
	
	    if (saves) {
	      supportingData.set('saves', saves);
	    }
	
	    if (stickerTaps) {
	      supportingData.set('stickerTaps', stickerTaps);
	    }
	
	    if (likes) {
	      supportingData.set('likes', likes);
	    }
	
	    if (comments) {
	      supportingData.set('comments', comments);
	    }
	
	    if (reach) {
	      supportingData.set('reach', reach);
	    }
	
	    if (impressions) {
	      supportingData.set('impressions', impressions);
	    }
	
	    if (engagements) {
	      supportingData.set('engagements', engagements);
	    }
	
	    if (actions) {
	      supportingData.set('actions', actions);
	    }
	
	    if (clicks) {
	      supportingData.set('clicks', clicks);
	    }
	
	    var cbData = null;
	    return supportingData.sync().then(function (sd) {
	      var sdJson = sd.toJSON();
	
	      cbData = sdJson;
	
	      _this2.setState({
	        supportingDataId: sdJson.id,
	        callbackData: cbData
	      });
	
	      return restClient.post('/' + asset.type + '/' + asset.id + '/relationships/supportingData/', {
	        data: {
	          type: 'supportingData',
	          id: sdJson.id
	        }
	      }).then(function (r) {
	        console.log(r);
	        console.log('ASSET UPDATED.');
	        _this2.setState({
	          savedOK: true
	        }, function () {
	          return successHandler(cbData);
	        });
	        return r;
	      });
	    });
	  };
	
	  this.patchSupportingData = function (supportingDataId) {
	    var _state3 = _this2.state,
	        documentData = _state3.documentData,
	        reach = _state3.reach,
	        impressions = _state3.impressions,
	        engagements = _state3.engagements,
	        actions = _state3.actions,
	        clicks = _state3.clicks,
	        likes = _state3.likes,
	        comments = _state3.comments,
	        views = _state3.views,
	        shares = _state3.shares,
	        saves = _state3.saves,
	        stickerTaps = _state3.stickerTaps;
	    var _props3 = _this2.props,
	        successHandler = _props3.successHandler,
	        restClient = _props3.restClient;
	
	
	    var patch = {
	      reach: reach,
	      impressions: impressions,
	      engagements: engagements,
	      actions: actions,
	      clicks: clicks,
	      likes: likes,
	      views: views,
	      comments: comments,
	      shares: shares,
	      saves: saves,
	      stickerTaps: stickerTaps,
	      filePath: documentData.filePath
	    };
	
	    var safePatch = _lodash2.default.omitBy(patch, _lodash2.default.isNil);
	
	    restClient.patch('/supportingData/' + supportingDataId, {
	      data: {
	        type: 'supportingData',
	        id: supportingDataId,
	        attributes: safePatch
	      }
	    }).then(function (sd) {
	      var sdJson = sd.data.data.attributes;
	      var cbData = sdJson;
	      successHandler(cbData);
	      _this2.setState({
	        supportingDataId: sdJson.id,
	        callbackData: cbData,
	        savedOK: true
	      });
	    });
	  };
	
	  this.handleFormFieldChange = function (e, _ref2) {
	    var name = _ref2.name,
	        value = _ref2.value;
	    return _this2.setState(_defineProperty({ savedOK: false }, name, value));
	  };
	
	  this.toggler = function () {
	    var popupToggleHandler = _this2.props.popupToggleHandler;
	
	    _this2.setState(INITIAL_STATE);
	    popupToggleHandler();
	  };
	
	  this.updateTrackedAssetPublishedDate = function () {
	    var publishedDate = _this2.state.publishedDate;
	    var _props$asset = _this2.props.asset,
	        id = _props$asset.id,
	        type = _props$asset.type;
	    var jsonAPIClient = _this2.props.jsonAPIClient;
	
	    return jsonAPIClient.get(type, id).then(function (response) {
	      response.set('publishedDate', publishedDate);
	      return response.sync();
	    });
	  };
	
	  this.onPublishedDateChanged = function (date) {
	    _this2.setState({
	      publishedDate: (0, _moment2.default)(date).set('hour', 15).format()
	    }, function () {
	      return _this2.updateTrackedAssetPublishedDate();
	    });
	  };
	};
	
	UploadModal.propTypes = {
	  asset: _propTypes2.default.object.isRequired,
	  popupToggleHandler: _propTypes2.default.object.isRequired,
	  successHandler: _propTypes2.default.object.isRequired,
	  jsonAPIClient: _propTypes2.default.object.isRequired,
	  restClient: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasJsonapiClient2.default)(UploadModal);

/***/ },
/* 921 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_PROFILE = exports.LOAD_PROFILE = 'Dyzio/Profile/LOAD_PROFILE';

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIcon = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noTopPadding = {
	  marginTop: 0
	};
	
	var getIcon = exports.getIcon = function getIcon(objectType) {
	  if (_lodash2.default.eq(objectType, 'VIDEO')) {
	    return 'youtube play';
	  }
	  return 'image';
	};
	
	var ADSModal = function ADSModal(_ref) {
	  var onClose = _ref.onClose,
	      linkAd = _ref.linkAd,
	      ads = _ref.ads,
	      existingAds = _ref.existingAds,
	      processedAdId = _ref.processedAdId,
	      failedToLoadAds = _ref.failedToLoadAds;
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    { open: true, onClose: onClose },
	    _react2.default.createElement(_dyzioModal.DyzioModalHeader, { headerText: 'Link Facebook Ads', onClose: onClose }),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      { style: noTopPadding },
	      failedToLoadAds && _react2.default.createElement(
	        _semanticUiReact.Message,
	        { negative: true },
	        'Failed to load your Facebook Ads - please contact support for assistance'
	      ),
	      _lodash2.default.isEmpty(_lodash2.default.get(ads, 'ads', [])) && _react2.default.createElement(
	        _semanticUiReact.Message,
	        null,
	        'No Ads to display - please contact support for assistance'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very', textAlign: 'center' },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _lodash2.default.map(_lodash2.default.get(ads, 'ads'), function (ad) {
	            console.log(ad);
	            var alreadyAdded = !_lodash2.default.isNil(_lodash2.default.find(existingAds, ['id', _lodash2.default.get(ad, 'ad.id')]));
	            var inProgress = _lodash2.default.eq(processedAdId, _lodash2.default.get(ad, 'ad.id', ''));
	            return _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
	                _react2.default.createElement(_semanticUiReact.Icon, { name: getIcon(_lodash2.default.get(ad, 'ad.creative.object_type')), color: 'pink' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Image, { src: _lodash2.default.get(ad, 'ad.creative.thumbnail_url') })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { textAlign: 'left' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'campaign: ',
	                  _lodash2.default.get(ad, 'ad.campaign.name')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'ad: ',
	                  _lodash2.default.get(ad, 'ad.name')
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _lodash2.default.get(ad, 'ad.campaign.effective_status')
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    fluid: true,
	                    color: 'pink',
	                    icon: true,
	                    labelPosition: 'left',
	                    onClick: function onClick() {
	                      return linkAd(_lodash2.default.get(ad, 'ad.id'));
	                    },
	                    disabled: alreadyAdded || inProgress
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: alreadyAdded ? 'checkmark' : 'linkify' }),
	                  alreadyAdded ? 'Linked' : 'Link'
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	ADSModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  failedToLoadAds: _propTypes2.default.bool,
	  linkAd: _propTypes2.default.func.isRequired,
	  ads: _propTypes2.default.array,
	  existingAds: _propTypes2.default.array.isRequired,
	  processedAdId: _propTypes2.default.any
	};
	
	ADSModal.defaultProps = {
	  ads: [],
	  processedAdId: null,
	  failedToLoadAds: false
	};
	
	exports.default = ADSModal;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable lodash/prefer-lodash-method */
	
	
	var withInvitationsData = function withInvitationsData(WrapperComponent) {
	  return function (_Component) {
	    _inherits(_class2, _Component);
	
	    function _class2() {
	      _classCallCheck(this, _class2);
	
	      var _this = _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this));
	
	      _this.getPendingInvitationsCountByEmail = function (userEmail) {
	        return _this.jsonAPIClient.find('campaignInvitation', {
	          filter: {
	            email: userEmail,
	            status: 'SENT'
	          }
	        }).then(function (response) {
	          return _lodash2.default.size(response);
	        });
	      };
	
	      _this.getPendingInvitationsByUserEmail = function (userEmail, shouldFetchDeclinedInvitations) {
	        return _this.jsonAPIClient.find('campaignInvitation', {
	          filter: {
	            email: userEmail,
	            status: shouldFetchDeclinedInvitations ? 'SENT,DECLINED' : 'SENT'
	          },
	          include: ['campaign']
	        }).then(function (response) {
	          return _lodash2.default.map(response, function (item) {
	            return item.toJSONTree();
	          });
	        });
	      };
	
	      _this.updateInvitationStatusById = function (invitationId, status) {
	        return _this.jsonAPIClient.get('campaignInvitation', invitationId).then(function (resource) {
	          resource.set('status', status);
	          return resource.sync();
	        });
	      };
	
	      _this.jsonAPIClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	        header: {
	          Authorization: 'Bearer ' + _authService.authService.getToken()
	        }
	      });
	      return _this;
	    }
	
	    _createClass(_class2, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, {
	          getPendingInvitationsByUserEmail: this.getPendingInvitationsByUserEmail,
	          updateInvitationStatusById: this.updateInvitationStatusById,
	          getPendingInvitationsCountByEmail: this.getPendingInvitationsCountByEmail
	        }));
	      }
	    }]);
	
	    return _class2;
	  }(_react.Component);
	};
	
	exports.default = withInvitationsData;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ngxAws = __webpack_require__(3019);
	
	var aws4 = _interopRequireWildcard(_ngxAws);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hasAWS4Signature = function hasAWS4Signature(WrapperComponent) {
	  return function (_Component) {
	    _inherits(_class2, _Component);
	
	    function _class2() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, _class2);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref, [this].concat(args))), _this), _this.signAWS4Request = function (_ref2) {
	        var instagramId = _ref2.instagramId;
	
	        //
	        if (!instagramId) {
	          return null;
	        }
	
	        var requestOptions = {
	          hostname: ("pbgategqv7.execute-api.eu-west-1.amazonaws.com"),
	          path: 'production/influencer/instagram/brands/reports/' + instagramId,
	          region: 'eu-west-1',
	          service: 'execute-api'
	        };
	
	        var credentials = {
	          accessKeyId: ("AKIAZRPENVXSZUBRHKG5"),
	          secretAccessKey: ("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")
	        };
	
	        aws4.sign(requestOptions, credentials);
	
	        return requestOptions;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_class2, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, {
	          signAWS4Request: this.signAWS4Request
	        }));
	      }
	    }]);
	
	    return _class2;
	  }(_react.Component);
	};
	
	exports.default = hasAWS4Signature;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shopifyUrlBase = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production';
	
	var isTugShopifyPath = function isTugShopifyPath(organisationId) {
	  if (organisationId === 'b847c281-d377-4528-a416-303234e382d8') {
	    return '/tugenuff';
	  }
	  return '';
	};
	
	var getShopifyPath = function getShopifyPath(discussionId, discountCode, organisationId) {
	  var discountCodePath = discountCode ? '/' + discountCode : '';
	  return '/discussion/' + discussionId + '/shopify' + isTugShopifyPath(organisationId) + '/sales' + discountCodePath;
	};
	
	var getShopifyOrdersByDiscussionIdUrl = function getShopifyOrdersByDiscussionIdUrl(discussionId, discountCode, organisationId) {
	  return '' + shopifyUrlBase + getShopifyPath(discussionId, discountCode, organisationId);
	};
	
	var getShopifyOrdersByDiscussionId = function getShopifyOrdersByDiscussionId(_ref) {
	  var discussionId = _ref.discussionId,
	      discountCode = _ref.discountCode,
	      organisationId = _ref.organisationId;
	  return _axios2.default.get(getShopifyOrdersByDiscussionIdUrl(discussionId, discountCode, organisationId)).then(function (response) {
	    var data = response.data;
	
	    return data;
	  }).catch(function (err) {
	    (0, _errorHandlingService.reportError)('Unknown error', err);
	    return { data: { orders: [], error: err } };
	  });
	};
	
	module.exports = {
	  getShopifyOrdersByDiscussionId: getShopifyOrdersByDiscussionId
	};

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.loadAuthToken = loadAuthToken;
	
	var _effects = __webpack_require__(54);
	
	var _authService = __webpack_require__(21);
	
	var _helperFunctions = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadAuthToken].map(_regenerator2.default.mark);
	
	function loadAuthToken() {
	  var token;
	  return _regenerator2.default.wrap(function loadAuthToken$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          token = _authService.authService.getToken();
	
	          if (token) {
	            _context.next = 7;
	            break;
	          }
	
	          (0, _helperFunctions.timeout)(1000);
	          _context.next = 5;
	          return (0, _effects.call)(loadAuthToken);
	
	        case 5:
	          _context.next = 8;
	          break;
	
	        case 7:
	          return _context.abrupt('return', token);
	
	        case 8:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}

/***/ },
/* 927 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getIsSendbirdUserLoading = exports.getIsSendbirdUserLoading = function getIsSendbirdUserLoading(state) {
	  return state.sendbird.get('loading');
	};
	var getSendbirdUser = exports.getSendbirdUser = function getSendbirdUser(state) {
	  return state.sendbird.get('sendbirdUser');
	};
	var getSendbirdChannel = exports.getSendbirdChannel = function getSendbirdChannel(state) {
	  return state.sendbird.get('sendbirdChannel');
	};
	var getSendbirdChannelLoading = exports.getSendbirdChannelLoading = function getSendbirdChannelLoading(state) {
	  return state.sendbird.get('channelLoading');
	};
	var getSendbirdChannelURL = exports.getSendbirdChannelURL = function getSendbirdChannelURL(state) {
	  return state.sendbird.get('sendbirdChannelURL');
	};

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVideoListAnalytics = getVideoListAnalytics;
	exports.getVideoHistory = getVideoHistory;
	exports.getInfluencerProfile = getInfluencerProfile;
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CAMPAIGN_API = 'https://influencers.dyzio.co/api/v2/campaign';
	var VIDEO_API = 'https://influencers.dyzio.co/api/v2/video';
	var INFLUENCER_PROFILE_API = 'https://influencers.dyzio.co/influencerprofiles';
	var VIDEOS_API = 'https://influencers.dyzio.co/api/v2/videos';
	
	function getVideoListAnalytics(youtubeVideoIds) {
	
	  var videoListString = '';
	  youtubeVideoIds.forEach(function (id) {
	    return videoListString += id + ',';
	  });
	
	  if (videoListString) {
	    videoListString = videoListString.slice(0, -1); // Remove last comma
	
	    var endpoint = VIDEOS_API + '/' + videoListString;
	    var payload = {
	
	      validateStatus: function validateStatus(status) {
	        return status >= 200 && status < 300 && status !== 404;
	      }
	    };
	    var headers = {};
	
	    return _axios2.default.get(endpoint, payload, headers).then(function (response) {
	      return response.data.videos;
	    });
	  }
	}
	
	function getVideoHistory(videoId) {
	
	  var endpoint = VIDEO_API + '/' + videoId;
	  var payload = {
	
	    validateStatus: function validateStatus(status) {
	      return status >= 200 && status < 300 && status !== 404;
	    }
	  };
	  var headers = {};
	
	  return _axios2.default.get(endpoint, payload, headers).then(function (response) {
	    return response.data.video;
	  });
	}
	
	function getInfluencerProfile(influencerId) {
	
	  var endpoint = INFLUENCER_PROFILE_API + '/' + influencerId;
	  var payload = {};
	  var headers = {};
	
	  return _axios2.default.get(endpoint, payload, headers).then(function (response) {
	    return response.data.influencer;
	  });
	}

/***/ },
/* 929 */
/***/ function(module, exports) {

	'use strict';
	
	var isAutoAdded = function isAutoAdded(createdBy) {
	  return createdBy === 'AUTOMATION SERVICE' || 'dyzio-campaign-automation';
	};
	var isStory = function isStory(type) {
	  return type === 'stories';
	};
	
	module.exports = { isAutoAdded: isAutoAdded, isStory: isStory };

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	var moment = __webpack_require__(7);
	
	var campaignStatus = {
	  LIVE: 'live',
	  FUTURE: 'future',
	  INVALID: 'invlaid',
	  COMPLETED: 'completed'
	};
	
	var getCampaignStatus = function getCampaignStatus(campaign) {
	  var liveDate = _.get(campaign, 'liveDate', null);
	  var endDate = _.get(campaign, 'endDate', null);
	
	  var hasMissingDates = _.isNil(liveDate) || _.isNil(endDate);
	
	  var startMoment = moment(liveDate);
	  var endMoment = moment(endDate);
	  var today = moment();
	
	  var hasStarted = startMoment.isValid() ? today.isSameOrAfter(startMoment) : false;
	  var hasEnded = endMoment.isValid() ? endMoment.isBefore(today) : false;
	
	  if (hasMissingDates) {
	    return campaignStatus.INVALID;
	  }
	  if (!hasStarted) {
	    // NOT STARTED YET
	    return campaignStatus.FUTURE;
	  }
	
	  if (hasStarted && !hasEnded) {
	    // is live
	    return campaignStatus.LIVE;
	  }
	  if (hasEnded) {
	    return campaignStatus.COMPLETED;
	  }
	  return campaignStatus.INVALID;
	};
	
	module.exports = {
	  campaignStatus: campaignStatus,
	  getCampaignStatus: getCampaignStatus
	};

/***/ },
/* 931 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  WORKFLOW: {
	    color: 'green',
	    shortName: 'Manual',
	    name: 'Manual Campaign',
	    fullName: 'Manual Influencer Campaign'
	  },
	  AUTOMATED: {
	    color: 'pink',
	    shortName: 'Automated',
	    name: 'Automated Campaign',
	    fullName: 'Automated Influencer Campaign'
	  },
	  ACR: {
	    color: 'orange',
	    shortName: 'ACR',
	    name: 'Automated Channel Report',
	    fullName: 'Automated Channel Report'
	  }
	
	};

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Compliance = {
	  isAsaCompliant: function isAsaCompliant(text) {
	    var asaTags = ['#ad', '#spon', '#partner', '\\bad\\b'];
	    var asaRegex = new RegExp(_lodash2.default.join(asaTags, '|'), 'ig');
	    var isCompliant = asaRegex.test(text);
	    return isCompliant;
	  }
	};
	
	module.exports = {
	  Compliance: Compliance
	};

/***/ },
/* 933 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var platforms = [{
	  key: 'youtube',
	  text: 'YouTube',
	  value: 'youtube',
	  image: '/icons/youtube.svg'
	}, {
	  key: 'instgram',
	  text: 'Instagram',
	  value: 'instagram',
	  image: '/icons/instagram.svg'
	}, {
	  key: 'twitter',
	  text: 'Twitter',
	  value: 'twitter',
	  image: '/icons/twitter.svg'
	}, {
	  key: 'facebook',
	  text: 'Facebook',
	  value: 'facebook',
	  image: '/icons/facebook.svg'
	}, {
	  key: 'twitch',
	  text: 'Twitch',
	  value: 'twitch',
	  image: '/icons/twitch.svg'
	}, {
	  key: 'tiktok',
	  text: 'Tiktok',
	  value: 'tiktok',
	  image: '/icons/tiktok.svg'
	}, {
	  key: 'shopify',
	  text: 'Shopify',
	  value: 'shopify',
	  image: '/icons/shopify.svg'
	}];
	
	exports.default = platforms;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCampaignInvitation = getCampaignInvitation;
	exports.deleteCampaignInvitation = deleteCampaignInvitation;
	exports.getCampaignInvitationAxios = getCampaignInvitationAxios;
	exports.processCampaignInvitation = processCampaignInvitation;
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	var _authService = __webpack_require__(21);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCampaignInvitation(invitationId) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('campaignInvitation', invitationId, {}).then(function (response) {
	    return response;
	  });
	}
	
	function deleteCampaignInvitation(campaignInvitation) {
	  return campaignInvitation.delete().then(function (response) {
	    return response;
	  });
	}
	
	function getCampaignInvitationAxios(invitationId) {
	  var axiosService = new _axiosService2.default(("https://q08zj8m8wd.execute-api.eu-west-1.amazonaws.com/production/invitations"), ("4000"), {});
	
	  // Get user information from invite table
	  return axiosService.get('/' + invitationId, {}).then(function (response) {
	    return response.data.body;
	  });
	}
	
	function processCampaignInvitation(invitationId) {
	  var axiosService = new _axiosService2.default(("https://n3w4baxvdk.execute-api.eu-west-1.amazonaws.com/production/permissions"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  // Attempt to process campaign invite into permission
	  return axiosService.post('/', {
	    data: {
	      type: 'campaignPermission',
	      attributes: { shortId: invitationId }
	    }
	  }).then(function (response) {
	    return response;
	  });
	}

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createComment = createComment;
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createComment(commentData) {
	
	  var client = (0, _jsonapiService2.default)();
	
	  var comment = client.create('comments');
	
	  comment.set('comment', commentData.comment);
	  if (commentData.documentId) comment.set('document', { type: 'documents', id: commentData.documentId });
	  if (commentData.commentType) comment.set('commentType', commentData.commentType);
	  comment.set('deliverable', { type: 'deliverables', id: commentData.deliverableId });
	  comment.set('user', { type: 'users', id: commentData.userId });
	
	  return comment.sync().then(function (response) {
	    // Returns a resource not a JSON object
	    return response;
	  });
	}

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendbirdSendBriefAll = sendbirdSendBriefAll;
	exports.sendbirdSendDeliverableAll = sendbirdSendDeliverableAll;
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sendbirdSendBriefAll(data) {
	  var endpoint = ("https://mgftih6c92.execute-api.eu-west-1.amazonaws.com/production/sendbird-send-all");
	  var headers = {
	    Authorization: 'Bearer ' + _authService.authService.getToken(),
	    'Content-type': 'application/json'
	  };
	
	  var axiosService = _axios2.default.create({
	    baseURL: endpoint,
	    timeout: 10000,
	    headers: headers
	  });
	
	  var payload = {
	    data: {
	      campaignId: data.campaignId,
	      userId: data.userId,
	      permissionId: data.permissionId,
	      message: data.message,
	      documentData: {
	        name: data.documentData.name,
	        filePath: data.documentData.filePath,
	        fileType: data.documentData.fileType,
	        size: data.documentData.size
	      }
	    }
	  };
	
	  return axiosService.post('/brief', payload).then(function (response) {
	    return response;
	  });
	}
	
	function sendbirdSendDeliverableAll(data) {
	  var endpoint = ("https://mgftih6c92.execute-api.eu-west-1.amazonaws.com/production/sendbird-send-all");
	  var headers = {
	    Authorization: 'Bearer ' + _authService.authService.getToken(),
	    'Content-type': 'application/json'
	  };
	
	  var axiosService = _axios2.default.create({
	    baseURL: endpoint,
	    timeout: 10000,
	    headers: headers
	  });
	
	  var payload = {
	    data: {
	      campaignId: data.campaignId,
	      userId: data.userId,
	      permissionId: data.permissionId,
	      message: data.message,
	      deliverableData: {
	        title: data.deliverableData.title,
	        assetType: data.deliverableData.assetType,
	        channelType: data.deliverableData.channelType,
	        dueDate: data.deliverableData.dueDate,
	        liveDateEnd: data.deliverableData.liveDateEnd,
	        description: data.deliverableData.description
	      }
	    }
	  };
	
	  return axiosService.post('/deliverable', payload).then(function (response) {
	    return response;
	  });
	}

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatTwitterAnalytics = exports.formatFacebookAnalytics = exports.formatInstagramAnalytics = exports.formatYoutubeVideoAnalytics = undefined;
	
	var _helperFunctions = __webpack_require__(107);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var formatYoutubeVideoAnalytics = exports.formatYoutubeVideoAnalytics = function formatYoutubeVideoAnalytics(data) {
	  var trackedAssetAnalytics = {};
	  var stats = data.statistics.slice(-1)[0];
	  var engagementScore = (0, _helperFunctions.dyzioEngagementScore)(stats.likeCount, stats.dislikeCount, stats.commentCount, stats.viewCount);
	
	  trackedAssetAnalytics.likes = stats.likeCount;
	  trackedAssetAnalytics.dislikes = stats.dislikeCount;
	  trackedAssetAnalytics.comments = stats.commentCount;
	  trackedAssetAnalytics.views = stats.viewCount;
	  trackedAssetAnalytics.engagementScore = engagementScore;
	  trackedAssetAnalytics.publishedDate = data.publishedDate;
	  trackedAssetAnalytics.title = data.title || '';
	  trackedAssetAnalytics.channelTitle = data.channelTitle;
	  trackedAssetAnalytics.influencerName = data.influencerName;
	  trackedAssetAnalytics.thumbnail = data.thumbnail;
	  trackedAssetAnalytics.videoUrl = '' + _staticConfiguration.YOUTUBE_WATCH_URL + data.youtubeVideoId;
	  trackedAssetAnalytics.statistics = data.statistics;
	  trackedAssetAnalytics.isVideo = true;
	  trackedAssetAnalytics.platformId = data.channelId;
	  trackedAssetAnalytics.copy = data.description || '';
	
	  return trackedAssetAnalytics;
	};
	
	var formatInstagramAnalytics = exports.formatInstagramAnalytics = function formatInstagramAnalytics(data) {
	  var trackedAssetAnalytics = {};
	  if (!data || !data.latestStatistic || !data.latestStatistic.followerCount) return null;
	  if (data.isVideo && !data.latestStatistic.viewCount) return null;
	
	  trackedAssetAnalytics.likes = data.latestStatistic.likeCount;
	  trackedAssetAnalytics.comments = data.latestStatistic.commentCount;
	  trackedAssetAnalytics.followers = data.latestStatistic.followerCount;
	  if (data.isVideo) trackedAssetAnalytics.views = data.latestStatistic.viewCount;
	  trackedAssetAnalytics.engagementScore = (0, _helperFunctions.dyzioEngagementScore)(trackedAssetAnalytics.likes, 0, trackedAssetAnalytics.comments, trackedAssetAnalytics.followers);
	  trackedAssetAnalytics.publishedDate = data.publishedDate;
	  trackedAssetAnalytics.title = data.text || '';
	  trackedAssetAnalytics.thumbnail = data.thumbnail;
	  trackedAssetAnalytics.channelTitle = data.instagramHandle;
	  trackedAssetAnalytics.influencerName = data.influencerName;
	  trackedAssetAnalytics.videoUrl = data.videoUrl;
	  trackedAssetAnalytics.isVideo = data.isVideo;
	  trackedAssetAnalytics.platformId = data.instagramHandle;
	  trackedAssetAnalytics.copy = data.text || '';
	
	  return trackedAssetAnalytics;
	};
	
	var formatFacebookAnalytics = exports.formatFacebookAnalytics = function formatFacebookAnalytics(data) {
	  var trackedAssetAnalytics = {};
	  if (!data || !data.latestStatistic) return null;
	
	  trackedAssetAnalytics.likes = data.latestStatistic.likeCount;
	  trackedAssetAnalytics.reactions = data.latestStatistic.reactionCount;
	  trackedAssetAnalytics.comments = data.latestStatistic.commentCount;
	  trackedAssetAnalytics.views = data.latestStatistic.viewCount;
	  trackedAssetAnalytics.shares = data.latestStatistic.shareCount;
	  trackedAssetAnalytics.publishedDate = data.createdDate;
	  trackedAssetAnalytics.title = data.text || '';
	  trackedAssetAnalytics.thumbnail = 'https://graph.facebook.com/' + data.facebookId + '/picture';
	  trackedAssetAnalytics.videoUrl = data.videoUrl;
	  trackedAssetAnalytics.channelTitle = data.influencerName;
	  trackedAssetAnalytics.influencerName = data.influencerName;
	  trackedAssetAnalytics.isVideo = data.isVideo;
	  trackedAssetAnalytics.videoUrl = data.signedVideoUrl;
	  trackedAssetAnalytics.platformId = data.facebookHandle;
	  trackedAssetAnalytics.copy = data.text || '';
	
	  /* TODO Add remaining
	  trackedAssetAnalytics.followers = data.latestStatistic.followerCount;
	  if (data.isVideo) trackedAssetAnalytics.views = data.latestStatistic.viewCount;
	  trackedAssetAnalytics.engagementScore = dyzioEngagementScore(trackedAssetAnalytics.likes, 0, trackedAssetAnalytics.comments, trackedAssetAnalytics.followers);
	  */
	
	  return trackedAssetAnalytics;
	};
	
	var formatTwitterAnalytics = exports.formatTwitterAnalytics = function formatTwitterAnalytics(data) {
	  var trackedAssetAnalytics = {};
	  if (!data) return null;
	
	  var ls = data.latestStatistic;
	
	  if (ls) {
	    trackedAssetAnalytics.likes = ls.likeCount;
	    trackedAssetAnalytics.retweets = ls.retweetCount;
	    trackedAssetAnalytics.reach = ls.followerCount;
	  }
	
	  trackedAssetAnalytics.tweetId = data.tweetId;
	  trackedAssetAnalytics.title = data.text;
	  trackedAssetAnalytics.channelTitle = data.twitterHandle;
	
	  trackedAssetAnalytics.influencerName = data.twitterHandle;
	
	  return trackedAssetAnalytics;
	};

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2463), __esModule: true };

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2467), __esModule: true };

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2470), __esModule: true };

/***/ },
/* 941 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 942 */
/***/ function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var cssKeywords = __webpack_require__(2458);
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
		if (cssKeywords.hasOwnProperty(key)) {
			reverseKeywords[cssKeywords[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;
	
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};
	
		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);
	
			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}
	
		return [
			h * 360,
			s * 100,
			v * 100
		];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in cssKeywords) {
			if (cssKeywords.hasOwnProperty(keyword)) {
				var value = cssKeywords[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return cssKeywords[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(87).document;
	module.exports = document && document.documentElement;


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(144) && !__webpack_require__(236)(function () {
	  return Object.defineProperty(__webpack_require__(579)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(290);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(237);
	var ITERATOR = __webpack_require__(88)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(132);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(291);
	var $export = __webpack_require__(121);
	var redefine = __webpack_require__(956);
	var hide = __webpack_require__(197);
	var Iterators = __webpack_require__(237);
	var $iterCreate = __webpack_require__(2483);
	var setToStringTag = __webpack_require__(372);
	var getPrototypeOf = __webpack_require__(952);
	var ITERATOR = __webpack_require__(88)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(88)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(953);
	var hiddenKeys = __webpack_require__(580).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(196);
	var toObject = __webpack_require__(238);
	var IE_PROTO = __webpack_require__(586)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(196);
	var toIObject = __webpack_require__(198);
	var arrayIndexOf = __webpack_require__(2477)(false);
	var IE_PROTO = __webpack_require__(586)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 954 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(132);
	var isObject = __webpack_require__(174);
	var newPromiseCapability = __webpack_require__(581);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(197);


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(132);
	var aFunction = __webpack_require__(370);
	var SPECIES = __webpack_require__(88)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(235);
	var invoke = __webpack_require__(2481);
	var html = __webpack_require__(944);
	var cel = __webpack_require__(579);
	var global = __webpack_require__(87);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(290)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 959 */
/***/ function(module, exports) {



/***/ },
/* 960 */
/***/ function(module, exports) {

	'use strict';
	
	var regions = {};
	
	regions.centralAsia = {
	  name: 'Central Asia',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Central_Asia
	    'KZ', // Kazakhstan
	    'KG', // Kyrgyzstan
	    'TJ', // Tajikistan
	    'TM', // Turkmenistan
	    'UZ', // Uzbekistan
	  ]
	}
	
	regions.southernAsia = {
	  name: 'Southern Asia',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/South_Asia
	    'AF', // Afghanistan
	    'BD', // Bangladesh
	    'BT', // Bhutan
	    'IO', // British Indian Ocean Territory
	    'IN', // India
	    'IR', // Iran
	    'MV', // Maldives
	    'NP', // Nepal
	    'PK', // Pakistan
	    'LK', // Sri Lanka
	  ]
	}
	
	regions.southeastAsia = {
	  name: 'Southeast Asia',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Southeast_Asia
	    'BN', // Brunei
	    'KH', // Cambodia
	    'CX', // Christmas Island
	    'CC', // Cocos (Keeling) Islands
	    'TL', // East Timor
	    'ID', // Indonesia
	    'LA', // Laos
	    'MY', // Malaysia
	    'MM', // Myanmar (Burma)
	    'PH', // Philippines
	    'SG', // Singapore
	    'TH', // Thailand
	    'VN', // Vietnam
	  ]
	}
	
	regions.eastAsia = {
	  name: 'East Asia',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/East_Asia
	    'CN', // China
	    'HK', // Hong Kong
	    'JP', // Japan
	    'KP', // North Korea
	    'KR', // South Korea
	    'MO', // Macao
	    'MN', // Mongolia
	    'TW', // Taiwan
	  ]
	}
	
	regions.westernAsia = {
	  name: 'Western Asia',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Western_Asia
	    'AM', // Armenia
	    'AZ', // Azerbaijan
	    'BH', // Bahrain
	    'IQ', // Iraq
	    'IL', // Israel
	    'JO', // Jordan
	    'KW', // Kuwait
	    'LB', // Lebanon
	    'OM', // Oman
	    'PS', // Palestinian territories
	    'QA', // Qatar
	    'SA', // Saudi Arabia
	    'SY', // Syria
	    'TR', // Turkey
	    'AE', // United Arab Emirates
	    'YE', // Yemen
	  ]
	}
	
	regions.centralAfrica = {
	  name: 'Central Aftrica',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Central_Africa
	    'AO', // Angola
	    'CM', // Cameroon
	    'CF', // Central African Republic
	    'TD', // Chad
	    'CG', // Republic of the Congo
	    'CD', // Democratic Republic of the Congo
	    'GQ', // Equatorial Guinea
	    'GA', // Gabon
	    'ST', // São Tomé and Príncipe
	  ]
	};
	
	regions.northAfrica = {
	  name: 'North Africa',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/North_Africa
	    'DZ', // Algeria
	    'EG', // Egypt
	    'LY', // Libya
	    'MA', // Morocco
	    'SD', // Sudan
	    'TN', // Tunisia
	    'EH', // Western Sahara
	  ]
	};
	
	regions.southernAfrica = {
	  name: 'Southern Africa',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Southern_Africa
	    'BW', // Botswana
	    'LS', // Lesotho
	    'NA', // Namibia
	    'ZA', // South Africa
	    'SZ', // Swaziland
	  ]
	};
	
	regions.eastAfrica = {
	  name: 'East Africa',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/East_Africa
	    'BI', // Burundi
	    'KM', // Comoros
	    'DJ', // Djibouti
	    'ER', // Eritrea
	    'ET', // Ethiopia
	    'KE', // Kenya
	    'MG', // Madagascar
	    'MW', // Malawi
	    'MU', // Mauritius
	    'YT', // Mayotte (France)
	    'MZ', // Mozambique
	    'RE', // Réunion (France)
	    'RW', // Rwanda
	    'SC', // Seychelles
	    'SO', // Somalia
	    'SS', // South Sudan
	    'TZ', // Tanzania
	    'UG', // Uganda
	    'ZM', // Zambia
	    'ZW', // Zimbabwe
	  ]
	};
	
	regions.westAfrica = {
	  name: 'West Africa',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/West_Africa
	    'BJ', // Benin
	    'BF', // Burkina Faso
	    'CV', // Cabo Verde
	    'CI', // Côte d'Ivoire
	    'GM', // Gambia
	    'GH', // Ghana
	    'GN', // Guinea
	    'GW', // Guinea-Bissau
	    'LR', // Liberia
	    'ML', // Mali
	    'MR', // Mauritania
	    'NE', // Niger
	    'NG', // Nigeria
	    'SH', // Saint Helena, Ascension and Tristan da Cunha (United Kingdom)
	    'SN', // Senegal
	    'SL', // Sierra Leone
	    'TG', // Togo
	  ]
	};
	
	regions.centralAmerica = {
	  name: 'Central America',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Central_America
	    'BZ', // Belize
	    'CR', // Costa Rica
	    'SV', // El Salvador
	    'GT', // Guatemala
	    'HN', // Honduras
	    'NI', // Nicaragua
	    'PA', // Panama
	  ]
	}
	
	regions.northernAmerica = {
	  name: 'Northern America',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Northern_America
	    'BM', // Bermuda
	    'CA', // Canada
	    'GL', // Greenland
	    'MX', // Mexico
	    'PM', // Saint Pierre and Miquelon
	    'US', // United States
	  ]
	}
	
	regions.caribbean = {
	  name: 'Caribbean',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Caribbean
	    'AI', // Anguilla
	    'AG', // Antigua and Barbuda
	    'AW', // Aruba
	    'BS', // Bahamas
	    'BB', // Barbados
	    'BQ', // Bonaire, Sint Eustatius & Saba
	    'VG', // British Virgin Islands
	    'KY', // Cayman Islands
	    'CU', // Cuba
	    'CW', // Curaçao
	    'DM', // Dominica
	    'DO', // Dominican Republic
	    'GD', // Grenada
	    'GP', // Guadeloupe
	    'HT', // Haiti
	    'JM', // Jamaica
	    'MQ', // Martinique
	    'MS', // Montserrat
	    'PR', // Puerto Rico
	    'BL', // Saint Barthélemy
	    'KN', // St. Kitts & Nevis
	    'LC', // Saint Lucia
	    'MF', // Saint Martin
	    'VC', // Saint Vincent and the Grenadines
	    'SX', // Sint Maarten
	    'TT', // Trinidad and Tobago
	    'TC', // Turks & Caicos
	    'VI', // United States Virgin Islands
	  ]
	}
	
	regions.southAmerica = {
	  name: 'South America',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/South_America
	    'AR', // Argentina
	    'BO', // Bolivia
	    'BR', // Brazil
	    'CL', // Chile
	    'CO', // Colombia
	    'EC', // Ecuador
	    'FK', // Falkland Islands
	    'GF', // French Guiana
	    'GY', // Guyana
	    'PY', // Paraguay
	    'PE', // Peru
	    'SR', // Suriname
	    'UY', // Uruguay
	    'VE', // Venezuela
	  ]
	}
	
	regions.antartica = {
	  name: 'Antartica',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Antarctica
	    'AQ', // Antarctica
	    'BV', // Bouvet Island
	    'TF', // French Southern Territories
	    'HM', // Heard Island and McDonald Islands
	    'GS', // South Georgia and the South Sandwich Islands
	  ]
	}
	
	regions.northernEurope = {
	  name: 'Northern Europe',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Northern_Europe
	    'AX', // Åland
	    'DK', // Denmark
	    'EE', // Estonia
	    'FO', // Faroe Islands
	    'FI', // Finland
	    'GG', // Guernsey
	    'IS', // Iceland
	    'IE', // Republic of Ireland
	    'JE', // Jersey (UK)
	    'IM', // Isle of Man
	    'LV', // Latvia
	    'LT', // Lithuania
	    'NO', // Norway
	    'SJ', // Svalbard and Jan Mayen
	    'SE', // Sweden
	    'GB', // United Kingdom
	  ]
	}
	
	regions.southernEurope = {
	  name: 'Southern Europe',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Southern_Europe
	    'AL', // Albania
	    'AD', // Andorra
	    'BA', // Bosnia and Herzegovina
	    'HR', // Croatia
	    'CY', // Cyprus
	    'GI', // Gibraltar
	    'GR', // Greece
	    'IT', // Italy
	    'MK', // Republic of Macedonia
	    'VA', // Vatican City
	    'MT', // Malta
	    'ME', // Montenegro
	    'PT', // Portugal
	    'SM', // San Marino
	    'RS', // Serbia
	    'SI', // Slovenia
	    'ES', // Spain
	  ]
	}
	
	regions.easternEurope = {
	  name: 'Eastern Europe',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Eastern_Europe
	    'BY', // Belarus
	    'BG', // Bulgaria
	    'CZ', // Czech Republic
	    'GE', // Georgia
	    'HU', // Hungary
	    'MD', // Moldova
	    'PL', // Poland
	    'RO', // Romania
	    'RU', // Russia
	    'SK', // Slovakia
	    'UA', // Ukraine
	  ]
	}
	
	regions.westernEurope = {
	  name: 'Western Europe',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Western_Europe
	    'AT', // Austria
	    'BE', // Belgium
	    'FR', // France
	    'DE', // Germany
	    'LI', // Liechtenstein
	    'LU', // Luxembourg
	    'MC', // Monaco
	    'NL', // Netherlands
	    'CH', // Switzerland
	  ],
	};
	 
	regions.australia = {
	  name: 'Australia',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Oceania
	    'AU', // Australia
	    'NF', // Norfolk Island
	    'NZ', // New Zealand
	  ]
	};
	
	regions.melanesia = {
	  name: 'Melanesia',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Oceania
	    'FJ', // Fiji
	    'NC', //  New Caledonia
	    'PG', // Papua New Guinea
	    'SB', // Solomon Islands
	    'VU', // Vanuatu
	  ]
	};    
	
	regions.micronesia = {
	  name: 'Micronesia',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Oceania
	    'GU', // Guam
	    'KI', // Kiribati
	    'MH', // Marshall Islands
	    'FM', // Micronesia, Fed. Sts.
	    'NR', // Nauru
	    'MP', // Northern Mariana Islands
	    'PW', // Palau
	    'UM', // United States Minor Outlying Islands
	  ]
	};    
	
	regions.polynesia = {
	  name: 'Polynesia',
	  countries: [
	    // source is http://en.wikipedia.org/wiki/Oceania
	    'AS', // American Samoa
	    'CK', // Cook Islands
	    'PF', // French Polynesia
	    'NU', // Niue
	    'PN', // Pitcairn Islands
	    'WS', // Samoa
	    'TK', // Tokelau
	    'TO', // Tonga
	    'TV', // Tuvalu
	    'WF', // Wallis and Futuna
	  ]
	};
	
	module.exports = regions;


/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Initialization and round constants tables
		    var H = [];
		    var K = [];
	
		    // Compute constants
		    (function () {
		        function isPrime(n) {
		            var sqrtN = Math.sqrt(n);
		            for (var factor = 2; factor <= sqrtN; factor++) {
		                if (!(n % factor)) {
		                    return false;
		                }
		            }
	
		            return true;
		        }
	
		        function getFractionalBits(n) {
		            return ((n - (n | 0)) * 0x100000000) | 0;
		        }
	
		        var n = 2;
		        var nPrime = 0;
		        while (nPrime < 64) {
		            if (isPrime(n)) {
		                if (nPrime < 8) {
		                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
		                }
		                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
		                nPrime++;
		            }
	
		            n++;
		        }
		    }());
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-256 hash algorithm.
		     */
		    var SHA256 = C_algo.SHA256 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init(H.slice(0));
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
		            var f = H[5];
		            var g = H[6];
		            var h = H[7];
	
		            // Computation
		            for (var i = 0; i < 64; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var gamma0x = W[i - 15];
		                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
		                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
		                                   (gamma0x >>> 3);
	
		                    var gamma1x = W[i - 2];
		                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
		                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
		                                   (gamma1x >>> 10);
	
		                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
		                }
	
		                var ch  = (e & f) ^ (~e & g);
		                var maj = (a & b) ^ (a & c) ^ (b & c);
	
		                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
		                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));
	
		                var t1 = h + sigma1 + ch + K[i] + W[i];
		                var t2 = sigma0 + maj;
	
		                h = g;
		                g = f;
		                f = e;
		                e = (d + t1) | 0;
		                d = c;
		                c = b;
		                b = a;
		                a = (t1 + t2) | 0;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		            H[5] = (H[5] + f) | 0;
		            H[6] = (H[6] + g) | 0;
		            H[7] = (H[7] + h) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */
		    C.SHA256 = Hasher._createHelper(SHA256);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */
		    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		}(Math));
	
	
		return CryptoJS.SHA256;
	
	}));

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(375));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Hasher = C_lib.Hasher;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var X64WordArray = C_x64.WordArray;
		    var C_algo = C.algo;
	
		    function X64Word_create() {
		        return X64Word.create.apply(X64Word, arguments);
		    }
	
		    // Constants
		    var K = [
		        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
		        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
		        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
		        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
		        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
		        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
		        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
		        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
		        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
		        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
		        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
		        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
		        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
		        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
		        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
		        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
		        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
		        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
		        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
		        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
		        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
		        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
		        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
		        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
		        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
		        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
		        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
		        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
		        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
		        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
		        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
		        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
		        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
		        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
		        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
		        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
		        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
		        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
		        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
		        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
		    ];
	
		    // Reusable objects
		    var W = [];
		    (function () {
		        for (var i = 0; i < 80; i++) {
		            W[i] = X64Word_create();
		        }
		    }());
	
		    /**
		     * SHA-512 hash algorithm.
		     */
		    var SHA512 = C_algo.SHA512 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new X64WordArray.init([
		                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
		                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
		                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
		                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcuts
		            var H = this._hash.words;
	
		            var H0 = H[0];
		            var H1 = H[1];
		            var H2 = H[2];
		            var H3 = H[3];
		            var H4 = H[4];
		            var H5 = H[5];
		            var H6 = H[6];
		            var H7 = H[7];
	
		            var H0h = H0.high;
		            var H0l = H0.low;
		            var H1h = H1.high;
		            var H1l = H1.low;
		            var H2h = H2.high;
		            var H2l = H2.low;
		            var H3h = H3.high;
		            var H3l = H3.low;
		            var H4h = H4.high;
		            var H4l = H4.low;
		            var H5h = H5.high;
		            var H5l = H5.low;
		            var H6h = H6.high;
		            var H6l = H6.low;
		            var H7h = H7.high;
		            var H7l = H7.low;
	
		            // Working variables
		            var ah = H0h;
		            var al = H0l;
		            var bh = H1h;
		            var bl = H1l;
		            var ch = H2h;
		            var cl = H2l;
		            var dh = H3h;
		            var dl = H3l;
		            var eh = H4h;
		            var el = H4l;
		            var fh = H5h;
		            var fl = H5l;
		            var gh = H6h;
		            var gl = H6l;
		            var hh = H7h;
		            var hl = H7l;
	
		            // Rounds
		            for (var i = 0; i < 80; i++) {
		                // Shortcut
		                var Wi = W[i];
	
		                // Extend message
		                if (i < 16) {
		                    var Wih = Wi.high = M[offset + i * 2]     | 0;
		                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
		                } else {
		                    // Gamma0
		                    var gamma0x  = W[i - 15];
		                    var gamma0xh = gamma0x.high;
		                    var gamma0xl = gamma0x.low;
		                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
		                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));
	
		                    // Gamma1
		                    var gamma1x  = W[i - 2];
		                    var gamma1xh = gamma1x.high;
		                    var gamma1xl = gamma1x.low;
		                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
		                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));
	
		                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
		                    var Wi7  = W[i - 7];
		                    var Wi7h = Wi7.high;
		                    var Wi7l = Wi7.low;
	
		                    var Wi16  = W[i - 16];
		                    var Wi16h = Wi16.high;
		                    var Wi16l = Wi16.low;
	
		                    var Wil = gamma0l + Wi7l;
		                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
		                    var Wil = Wil + gamma1l;
		                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
		                    var Wil = Wil + Wi16l;
		                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);
	
		                    Wi.high = Wih;
		                    Wi.low  = Wil;
		                }
	
		                var chh  = (eh & fh) ^ (~eh & gh);
		                var chl  = (el & fl) ^ (~el & gl);
		                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
		                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);
	
		                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
		                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
		                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
		                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));
	
		                // t1 = h + sigma1 + ch + K[i] + W[i]
		                var Ki  = K[i];
		                var Kih = Ki.high;
		                var Kil = Ki.low;
	
		                var t1l = hl + sigma1l;
		                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
		                var t1l = t1l + chl;
		                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
		                var t1l = t1l + Kil;
		                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
		                var t1l = t1l + Wil;
		                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);
	
		                // t2 = sigma0 + maj
		                var t2l = sigma0l + majl;
		                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);
	
		                // Update working variables
		                hh = gh;
		                hl = gl;
		                gh = fh;
		                gl = fl;
		                fh = eh;
		                fl = el;
		                el = (dl + t1l) | 0;
		                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
		                dh = ch;
		                dl = cl;
		                ch = bh;
		                cl = bl;
		                bh = ah;
		                bl = al;
		                al = (t1l + t2l) | 0;
		                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
		            }
	
		            // Intermediate hash value
		            H0l = H0.low  = (H0l + al);
		            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
		            H1l = H1.low  = (H1l + bl);
		            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
		            H2l = H2.low  = (H2l + cl);
		            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
		            H3l = H3.low  = (H3l + dl);
		            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
		            H4l = H4.low  = (H4l + el);
		            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
		            H5l = H5.low  = (H5l + fl);
		            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
		            H6l = H6.low  = (H6l + gl);
		            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
		            H7l = H7.low  = (H7l + hl);
		            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Convert hash to 32-bit word array before returning
		            var hash = this._hash.toX32();
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        },
	
		        blockSize: 1024/32
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA512('message');
		     *     var hash = CryptoJS.SHA512(wordArray);
		     */
		    C.SHA512 = Hasher._createHelper(SHA512);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA512(message, key);
		     */
		    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
		}());
	
	
		return CryptoJS.SHA512;
	
	}));

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(1421);
	var isArguments = __webpack_require__(2936);
	var is = __webpack_require__(3020);
	var isRegex = __webpack_require__(2939);
	var flags = __webpack_require__(3792);
	var isDate = __webpack_require__(1288);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(234);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(233);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(108);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dyzioInstagramEmbed = __webpack_require__(2554);
	
	var _dyzioInstagramEmbed2 = _interopRequireDefault(_dyzioInstagramEmbed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var avatarStyle = {
	  width: 90,
	  height: 90,
	  float: 'left'
	};
	
	var brandHandleStyle = {
	  marginBottom: '0px'
	};
	
	var brandNameStyle = {
	  color: 'grey',
	  marginTop: '0px'
	};
	
	var leftMargin = {
	  paddingTop: '20px',
	  marginLeft: '100px'
	};
	
	var brandHeaderStyle = {
	  width: '380px',
	  border: '1px solid white',
	  margin: '0px auto'
	};
	
	var plainCardStyle = { boxShadow: 'none', webkitBoxShadow: 'none' };
	var cardGroupStyle = { clear: 'both', paddingTop: '10px' };
	
	var BrandMentionsPostList = function (_Component) {
	  (0, _inherits3.default)(BrandMentionsPostList, _Component);
	
	  function BrandMentionsPostList() {
	    (0, _classCallCheck3.default)(this, BrandMentionsPostList);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (BrandMentionsPostList.__proto__ || (0, _getPrototypeOf2.default)(BrandMentionsPostList)).call(this));
	
	    _this.state = {
	      savedThumbnailUrl: '',
	      error: false,
	      loading: true
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(BrandMentionsPostList, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var brandId, params, _ref2, status, data, _JSON$parse, savedThumbnailUrl;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                brandId = this.props.brandId;
	                _context.prev = 1;
	                params = {
	                  data: {
	                    instagramId: brandId
	                  }
	                };
	                _context.next = 5;
	                return _axios2.default.post('https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/instagram/profile/picture', params);
	
	              case 5:
	                _ref2 = _context.sent;
	                status = _ref2.status;
	                data = _ref2.data;
	
	
	                if (_lodash2.default.isEqual(status, 200)) {
	                  console.log('SUCCESS');
	                  _JSON$parse = JSON.parse(_lodash2.default.get(data, 'body')), savedThumbnailUrl = _JSON$parse.data.savedThumbnailUrl;
	
	                  this.setState({
	                    savedThumbnailUrl: savedThumbnailUrl,
	                    loading: false
	                  });
	                } else {
	                  this.setState({
	                    error: true,
	                    loading: false
	                  });
	                }
	                _context.next = 15;
	                break;
	
	              case 11:
	                _context.prev = 11;
	                _context.t0 = _context['catch'](1);
	
	                console.log(_context.t0);
	                this.setState({
	                  error: true,
	                  loading: false
	                });
	
	              case 15:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[1, 11]]);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          savedThumbnailUrl = _state.savedThumbnailUrl,
	          loading = _state.loading;
	      var _props = this.props,
	          brandName = _props.brandName,
	          brandHandle = _props.brandHandle,
	          shortcodes = _props.shortcodes;
	
	
	      console.log('brand profile image', savedThumbnailUrl);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: brandHeaderStyle },
	          loading && _react2.default.createElement(_semanticUiReact.Message, {
	            header: 'Loading Image'
	          }),
	          savedThumbnailUrl && !loading && _react2.default.createElement(_semanticUiReact.Image, {
	            src: savedThumbnailUrl,
	            className: 'circular',
	            style: avatarStyle
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: leftMargin },
	            _react2.default.createElement(
	              'h3',
	              { style: brandHandleStyle },
	              brandName
	            ),
	            _react2.default.createElement(
	              'h5',
	              { style: brandNameStyle },
	              brandHandle
	            )
	          ),
	          _react2.default.createElement('div', { style: { clear: 'both' } })
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Group,
	          {
	            centered: true,
	            itemsPerRow: shortcodes.length > 2 ? 3 : shortcodes.length,
	            style: cardGroupStyle
	          },
	          _lodash2.default.map(shortcodes, function (code) {
	            return _react2.default.createElement(
	              _semanticUiReact.Card,
	              { key: code, style: plainCardStyle },
	              _react2.default.createElement(_dyzioInstagramEmbed2.default, {
	                assetId: '' + code,
	                maxWidth: true
	              })
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return BrandMentionsPostList;
	}(_react.Component);
	
	BrandMentionsPostList.propTypes = {
	  brandName: _propTypes2.default.string.isRequired,
	  brandId: _propTypes2.default.string.isRequired,
	  brandHandle: _propTypes2.default.string.isRequired,
	  shortcodes: _propTypes2.default.array.isRequired
	};
	
	exports.default = BrandMentionsPostList;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _countryData = __webpack_require__(175);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCountry = function getCountry(code) {
	  return _lodash2.default.find(_countryData.countries.all, ['alpha2', _lodash2.default.upperCase(code)]);
	};
	
	var COUNTRIES_TO_DISPLAY = 20;
	
	var DemographicsYoutubeDataTable = function DemographicsYoutubeDataTable(_ref) {
	  var data = _ref.audienceLocations.data;
	
	  var displayed = _lodash2.default.take(data, COUNTRIES_TO_DISPLAY);
	  var restOfWorld = _lodash2.default.filter(data, function (item) {
	    return !_lodash2.default.find(displayed, ['countryCode', item.countryCode]);
	  });
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { singleLine: true, textAlign: 'center' },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Header,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        { textAlign: 'left' },
	        'country'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        null,
	        'views'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        null,
	        'mins watched'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        null,
	        'likes'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        null,
	        'comments'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        null,
	        'dislikes'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        null,
	        'shares'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        null,
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(
	            'span',
	            null,
	            'subs ',
	            _react2.default.createElement(_semanticUiReact.Icon, { circular: true, name: 'plus', color: 'green' })
	          ),
	          content: _react2.default.createElement(
	            'span',
	            null,
	            'subscribers gained'
	          )
	        })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        null,
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(
	            'span',
	            null,
	            'subs ',
	            _react2.default.createElement(_semanticUiReact.Icon, { circular: true, name: 'minus', color: 'red' })
	          ),
	          content: _react2.default.createElement(
	            'span',
	            null,
	            'subscribers lost'
	          )
	        })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        null,
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(
	            'span',
	            null,
	            'videos ',
	            _react2.default.createElement(_semanticUiReact.Icon, { circular: true, name: 'plus', color: 'green' })
	          ),
	          content: _react2.default.createElement(
	            'span',
	            null,
	            'videos added to playlists'
	          )
	        })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        null,
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(
	            'span',
	            null,
	            'videos ',
	            _react2.default.createElement(_semanticUiReact.Icon, { circular: true, name: 'minus', color: 'red' })
	          ),
	          content: _react2.default.createElement(
	            'span',
	            null,
	            'videos removed from playlists'
	          )
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _lodash2.default.map(displayed, function (row) {
	        var country = getCountry(row.countryCode);
	        return _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { textAlign: 'left' },
	            country.emoji,
	            ' ',
	            country.name
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            (0, _formatting.commaFormatted)(row.views)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            (0, _formatting.commaFormatted)(row.estimatedMinutesWatched)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            (0, _formatting.commaFormatted)(row.likes)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            (0, _formatting.commaFormatted)(row.comments)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            (0, _formatting.commaFormatted)(row.dislikes)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            (0, _formatting.commaFormatted)(row.shares)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            (0, _formatting.commaFormatted)(row.subscribersGained)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            (0, _formatting.commaFormatted)(row.subscribersLost)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            (0, _formatting.commaFormatted)(row.videosAddedToPlaylists)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            (0, _formatting.commaFormatted)(row.videosRemovedFromPlaylists)
	          )
	        );
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { textAlign: 'left' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'globe', color: 'pink' }),
	          ' Rest of World'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'views'))
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'estimatedMinutesWatched'))
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'likes'))
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'comments'))
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'dislikes'))
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'shares'))
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'subscribersGained'))
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'subscribersLost'))
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'videosAddedToPlaylists'))
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'videosRemovedFromPlaylists'))
	        )
	      )
	    )
	  );
	};
	
	DemographicsYoutubeDataTable.propTypes = {
	  audienceLocations: _propTypes2.default.object.isRequired
	};
	
	exports.default = DemographicsYoutubeDataTable;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _demographicsLocationTable = __webpack_require__(146);
	
	var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YoutubeDemographicsCountriesTable = function YoutubeDemographicsCountriesTable(_ref) {
	  var data = _ref.audienceLocations.data;
	  return _react2.default.createElement(_demographicsLocationTable2.default, { data: data, metric: 'views', itemLabel: 'Country' });
	};
	
	YoutubeDemographicsCountriesTable.propTypes = {
	  audienceLocations: _propTypes2.default.object.isRequired
	};
	
	exports.default = YoutubeDemographicsCountriesTable;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactPlayer = __webpack_require__(410);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _assets = __webpack_require__(243);
	
	var _dyzioFacebookThumbnail = __webpack_require__(2553);
	
	var _dyzioFacebookThumbnail2 = _interopRequireDefault(_dyzioFacebookThumbnail);
	
	var _dyzioInstagramThumbnail = __webpack_require__(2555);
	
	var _dyzioInstagramThumbnail2 = _interopRequireDefault(_dyzioInstagramThumbnail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GENERIC_MISSING_IMAGE = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/no_image_available.png';
	var GENERIC_STORY_IMAGE = 'https://s3-eu-west-1.amazonaws.com/dyzio-static-files/images/instagram-story2.png';
	var TEXT_ASSET = 'https://app.dyzio.co/icons/text-asset.svg';
	var bucket = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/';
	
	var imgThumbnail = {
	  width: '100%',
	  height: '50px',
	  objectFit: 'cover',
	  display: 'table-cell',
	  verticalAlign: 'middle',
	  backgroundColor: '#EEEEEE'
	};
	
	var platformIconStyle = {
	  width: '100%',
	  display: 'inline-table',
	  backgroundColor: '#eeeeee',
	  paddingTop: 10,
	  height: 40
	};
	
	var storyImageStyle = {
	  width: 60,
	  height: 40,
	  objectFit: 'cover',
	  cursor: 'pointer'
	};
	
	var TelegramImageStyle = {
	  width: 60,
	  height: 40,
	  objectFit: 'cover',
	  cursor: 'pointer'
	};
	
	var TelegramTextImageStyle = {
	  width: 20,
	  height: 20,
	  opacity: '0.5',
	  oobjectFit: 'cover',
	  cursor: 'pointer'
	};
	
	var shouldRenderSupportingDataImage = function shouldRenderSupportingDataImage(asset) {
	  var isStory = asset.assetType === 'STORY' || _lodash2.default.get(asset, 'trackedAsset.assetType') === 'STORY';
	  var isVK = asset.platform === 'VK';
	  var isBlog = asset.platform === 'BLOG';
	  var isSnapchat = asset.platform === 'SNAPCHAT';
	  return isStory || isVK || isBlog || isSnapchat;
	};
	
	var ImageComponent = function ImageComponent(_ref) {
	  var post = _ref.post;
	
	  if (post.platform === 'TIKTOK') {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(_semanticUiReact.Image, {
	        centered: true,
	        style: storyImageStyle,
	        src: post.savedThumbnailUrl
	      }),
	      content: _react2.default.createElement(_semanticUiReact.Image, {
	        centered: true,
	        src: post.savedThumbnailUrl
	      })
	    });
	  }
	
	  if (post.platform === 'TELEGRAM') {
	    var thumbnail = post.initialData.thumbnail;
	
	    var imageUrl = 'https://pics.dyzio.co/' + thumbnail;
	
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(_semanticUiReact.Image, {
	        centered: true,
	        style: TelegramImageStyle,
	        src: imageUrl,
	        onError: function onError(i) {
	          i.target.src = TEXT_ASSET;
	        }
	      }),
	      content: _react2.default.createElement(_semanticUiReact.Image, {
	        centered: true,
	        src: imageUrl,
	        onError: function onError(i) {
	          i.target.src = TEXT_ASSET;
	        }
	      })
	    });
	  }
	
	  var trackedAsset = _lodash2.default.eq(_lodash2.default.get(post, 'type'), 'trackedAssets') ? post : _lodash2.default.get(post, 'trackedAsset');
	  var supportingData = trackedAsset.supportingData;
	
	
	  var latestSupportingData = void 0;
	
	  if (supportingData && supportingData.length) {
	    var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
	    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
	      return o.createdDate;
	    }));
	    latestSupportingData = ordered[0];
	  }
	
	  var fp = latestSupportingData && latestSupportingData.filePath;
	
	  var imageSrc = fp ? '' + bucket + fp : GENERIC_STORY_IMAGE;
	
	  if (post.postType === 'post') return _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment', size: 'large', color: 'blue' });
	
	  if (shouldRenderSupportingDataImage(post)) {
	    console.log('imageSrc', imageSrc);
	
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: (0, _assets.isVideoUrl)(imageSrc) ? _react2.default.createElement(_reactPlayer2.default, { className: 'videoFrame', url: imageSrc, width: '100%', height: '100%' }) : _react2.default.createElement(_semanticUiReact.Image, {
	        centered: true,
	        style: storyImageStyle,
	        src: fp ? imageSrc : GENERIC_MISSING_IMAGE,
	        onError: function onError(i) {
	          i.target.src = GENERIC_STORY_IMAGE;
	        }
	      }),
	      content: (0, _assets.isVideoUrl)(imageSrc) ? _react2.default.createElement(_reactPlayer2.default, { className: 'videoFrame', url: imageSrc, width: '50%', height: '50%' }) : _react2.default.createElement(_semanticUiReact.Image, {
	        centered: true,
	        style: storyImageStyle,
	        src: fp ? imageSrc : GENERIC_MISSING_IMAGE,
	        onError: function onError(i) {
	          i.target.src = GENERIC_STORY_IMAGE;
	        }
	      })
	    });
	  }
	
	  if (trackedAsset.assetType === 'TEXT' && trackedAsset.imageURL) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'a',
	          { target: '_blank', rel: 'noopener noreferrer', href: trackedAsset.assetURL },
	          _react2.default.createElement(_semanticUiReact.Image, {
	            src: trackedAsset.imageURL,
	            style: imgThumbnail,
	            size: 'mini',
	            floated: 'left'
	          })
	        ),
	        content: 'view post on ' + _lodash2.default.toLower(trackedAsset.platform)
	      })
	    );
	  }
	
	  var tweetMedia = _lodash2.default.get(post, 'entities.media') || [];
	  var mainTweetMedia = _lodash2.default.head(tweetMedia);
	  var tweetThumbnail = _lodash2.default.get(mainTweetMedia, 'media_url');
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(
	        'a',
	        { target: '_blank', rel: 'noopener noreferrer', href: trackedAsset.assetURL },
	        post.facebookId && _react2.default.createElement(_dyzioFacebookThumbnail2.default, { assetId: post.facebookId }),
	        post.instagramId && _react2.default.createElement(_dyzioInstagramThumbnail2.default, {
	          assetId: post.instagramId,
	          savedMediumImageUrl: trackedAsset.savedThumbnailUrl || trackedAsset.savedMediumImageUrl,
	          trackedAssetId: trackedAsset.id
	        }),
	        tweetThumbnail && _react2.default.createElement(_semanticUiReact.Image, {
	          src: tweetThumbnail,
	          style: imgThumbnail,
	          size: 'mini',
	          floated: 'left'
	        }),
	        !post.facebookId && !post.instagramId && !tweetThumbnail && post.thumbnail && _react2.default.createElement(_semanticUiReact.Image, {
	          src: post.thumbnail,
	          style: imgThumbnail,
	          size: 'mini',
	          floated: 'left'
	        }),
	        !post.thumbnail && _react2.default.createElement(
	          'div',
	          { style: platformIconStyle },
	          _react2.default.createElement(_semanticUiReact.Icon, {
	            name: _lodash2.default.toLower(trackedAsset.platform)
	          })
	        )
	      ),
	      content: 'view post on ' + _lodash2.default.toLower(trackedAsset.platform)
	    })
	  );
	};
	
	exports.default = ImageComponent;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTypeIcon = function getTypeIcon(props) {
	  var post = props.post;
	
	  var isStory = _lodash2.default.get(post, 'trackedAsset.assetType', null) === 'STORY';
	  var isIGTV = _lodash2.default.get(post, 'isIGTV', false);
	  var isReel = _lodash2.default.get(post, 'isReel', false);
	  var isVideo = post.isVideo || post.viewCount;
	
	  if (isIGTV) return _react2.default.createElement(_semanticUiReact.Icon, { name: 'tv', color: 'pink' });
	  if (isReel) {
	    return _react2.default.createElement(_semanticUiReact.Image, {
	      src: 'https://app.dyzio.co/images/reels-pink.png',
	      style: { display: 'inline', width: 13, height: 13 }
	    });
	  }
	
	  if (isStory) return _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline', color: 'pink' });
	
	  if (isVideo) return _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', color: 'pink' });
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'clone outline', color: 'pink' });
	};
	
	var InstagramIcon = function InstagramIcon(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
	    getTypeIcon(props)
	  );
	};
	
	InstagramIcon.propTypes = {
	  post: _propTypes2.default.object.isRequired
	};
	
	exports.default = InstagramIcon;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(108);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _reactCopyToClipboard = __webpack_require__(315);
	
	var _countryData = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderCountryName = function renderCountryName(code) {
	  var country = _lodash2.default.find(_countryData.countries.all, ['alpha2', _lodash2.default.toUpper(code)]);
	  return _lodash2.default.get(country, 'name', '-');
	};
	
	var countryCellStyle = { maxWidth: 50 };
	
	var SHAREABLE_LINK = window.location.href;
	
	var ReportHeader = function (_React$Component) {
	  (0, _inherits3.default)(ReportHeader, _React$Component);
	
	  function ReportHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ReportHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReportHeader.__proto__ || (0, _getPrototypeOf2.default)(ReportHeader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      copied: false
	    }, _this.render = function () {
	      var info = _this.props.info;
	      var copied = _this.state.copied;
	
	      var generatedTime = (0, _moment2.default)().format('MMMM Do YYYY, h:mm a');
	      var hashtagsArray = _lodash2.default.split(info.hashtags, ',');
	
	      var hasCountry = _lodash2.default.has(info, 'reportCountry') && !_lodash2.default.isNil(info.reportCountry);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        info.hasLogo && _react2.default.createElement(_semanticUiReact.Image, { src: '/images/afterparty.png', alt: 'Afterparty Studios', height: '60' }),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { fluid: true, celled: true },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: 3 },
	                'CAMPAIGN'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: hasCountry ? 4 : 0, width: 13 },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  info.campaignName
	                )
	              )
	            ),
	            info.influencerName && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'INFLUENCER'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: hasCountry ? 4 : 0 },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  info.influencerName
	                )
	              )
	            ),
	            info.reportDate && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'REPORT UPDATED'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: hasCountry ? 4 : 0 },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  (0, _moment2.default)().format('MMMM Do YYYY')
	                )
	              )
	            ),
	            info.reportType && !info.reportCountry && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'REPORT TYPE'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  info.reportType
	                )
	              )
	            ),
	            info.reportType && info.reportCountry && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'REPORT TYPE'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  info.reportType
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { style: countryCellStyle },
	                'COUNTRY'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Flag, { name: _lodash2.default.toLower(info.reportCountry) }),
	                ' ',
	                renderCountryName(info.reportCountry)
	              )
	            ),
	            info.liveDate && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'Start Date'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: hasCountry ? 4 : 0 },
	                (0, _moment2.default)(info.liveDate).format('MMMM Do YYYY')
	              )
	            ),
	            info.endDate && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'End Date'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: hasCountry ? 4 : 0 },
	                (0, _moment2.default)(info.endDate).format('MMMM Do YYYY')
	              )
	            ),
	            info.hashtags && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'HASHTAGS'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: hasCountry ? 4 : 0 },
	                _lodash2.default.map(hashtagsArray, function (ht) {
	                  return _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'pink', content: _lodash2.default.toLower(ht) });
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'SHAREABLE LINK'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: hasCountry ? 4 : 0 },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  SHAREABLE_LINK
	                ),
	                _react2.default.createElement(
	                  _reactCopyToClipboard.CopyToClipboard,
	                  {
	                    text: SHAREABLE_LINK,
	                    onCopy: function onCopy() {
	                      return _this.setState({ copied: true });
	                    }
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\xA0\xA0',
	                    _react2.default.createElement(_semanticUiReact.Button, { size: 'mini', color: 'green', basic: true, icon: 'copy', content: 'copy link' })
	                  )
	                ),
	                copied ? _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'thumbs outline up' }),
	                  'Copied...'
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'DATA ',
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock', color: 'orange' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: hasCountry ? 4 : 0 },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Report generated at ',
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    generatedTime
	                  ),
	                  '.'
	                )
	              )
	            )
	          )
	        )
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  return ReportHeader;
	}(_react2.default.Component);
	
	ReportHeader.propTypes = {
	  info: _propTypes2.default.object.isRequired
	};
	
	ReportHeader.defaultProps = {
	  info: {
	    hasLogo: true
	  }
	};
	
	exports.default = ReportHeader;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isAsaCompliant = function isAsaCompliant(text) {
	  var asaTags = ['#ad\\b', '\\bad\\b', // standalone "ad" in text
	  '#spon', '#partner', '#pr\\b', // #pr but not #price #pretty
	  '\\bpr\\b', // standalone PR in text
	  '(?:^|\\n)\\s*AD\\s*[\\|\\-\\:–—]', // "AD | ..." at start of line
	  '(?:^|\\n)\\s*PR\\s*[\\|\\-\\:–—]', // "PR | ..." at start of line
	  '#gifted\\b', // #gifted but not #giftedlife
	  '\\bgifted\\b', // standalone "gifted" in text
	  '\\bkindly\\s+gifted\\b', // "kindly gifted"
	  '\\bgifted\\s+by\\b', // "gifted by [brand]"
	  '#giftedproduct', '#gifteditem', '#giftedcollab'];
	  var asaRegex = new RegExp(_lodash2.default.join(asaTags, '|'), 'igm');
	  return asaRegex.test(text);
	};
	
	exports.default = isAsaCompliant;

/***/ },
/* 971 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GENDERS = exports.GENDERS = {
	  F: { text: 'Female', key: 'F' },
	  M: { text: 'Male', key: 'M' },
	  U: { text: 'Unknown', key: 'U' }
	};
	
	var happy = exports.happy = 1;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sayHi = exports.reduceGraphDataByGender = undefined;
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reduceGraphDataByGender = exports.reduceGraphDataByGender = function reduceGraphDataByGender(data) {
	  return _lodash2.default.reduce(data, function (acc, item, key) {
	    var gender = key.charAt(0);
	    acc[gender].push((0, _extends3.default)({}, item, {
	      group: key.substr(1)
	    }));
	    return acc;
	  }, { M: [], F: [], U: [] });
	};
	
	var sayHi = exports.sayHi = function sayHi() {
	  return _lodash2.default.constant('Hi!');
	};

/***/ },
/* 973 */
[4183, 2600],
/* 974 */
[4194, 202, 78],
/* 975 */
[4198, 78],
/* 976 */
[4199, 202, 78],
/* 977 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 978 */
[4201, 993, 402, 47, 304, 301, 406],
/* 979 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 980 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 981 */
[4206, 300, 97],
/* 982 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ },
/* 983 */
[4209, 606, 296, 385, 981, 2612, 2646, 393, 2653, 2654, 1004, 1005, 203, 2683, 2684, 2685, 47, 304, 2762, 96, 2763, 97, 628],
/* 984 */
[4211, 382, 384, 607, 148, 245, 392],
/* 985 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 986 */
[4220, 608, 47],
/* 987 */
[4236, 201, 123],
/* 988 */
[4239, 148, 298, 95, 987, 2640, 245, 2652, 179, 47],
/* 989 */
[4241, 298, 991, 299],
/* 990 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 991 */
[4244, 385, 299, 301, 96, 204],
/* 992 */
[4245, 179, 1012],
/* 993 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 994 */
[4249, 382, 384, 607, 392, 2669, 621],
/* 995 */
[4252, 179],
/* 996 */
[4254, 391],
/* 997 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 998 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 999 */
[4278, 997, 998, 2656, 394, 1000, 616, 2708, 400, 78],
/* 1000 */
[4280, 1009, 1015, 1016],
/* 1001 */
[4285, 202],
/* 1002 */
[4286, 382, 980, 392],
/* 1003 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1004 */
[4290, 986, 617, 97],
/* 1005 */
[4291, 986, 1007, 628],
/* 1006 */
[4293, 2707],
/* 1007 */
[4300, 608, 397, 617, 1038],
/* 1008 */
[4302, 299, 402, 47, 301, 626, 204],
/* 1009 */
[4312, 602, 615, 1006, 2785],
/* 1010 */
[4314, 96],
/* 1011 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 1012 */
[4326, 976],
/* 1013 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 1014 */
[4330, 383],
/* 1015 */
[4334, 992, 1017],
/* 1016 */
[4336, 2676, 2686, 622, 2721],
/* 1017 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 1018 */
[4340, 2609, 618, 2719],
/* 1019 */
[4341, 2701],
/* 1020 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 1021 */
/***/ function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ },
/* 1022 */
[4349, 395],
/* 1023 */
[4350, 2670, 151],
/* 1024 */
[4351, 984, 388, 177, 403],
/* 1025 */
[4357, 2665, 1026],
/* 1026 */
[4358, 985, 95, 150],
/* 1027 */
[4359, 388],
/* 1028 */
[4372, 51, 149, 50],
/* 1029 */
[4378, 51, 69, 50],
/* 1030 */
[4389, 2618, 1008],
/* 1031 */
[4404, 133, 79],
/* 1032 */
[4412, 387, 2657],
/* 1033 */
826,
/* 1034 */
[4416, 387, 609, 95],
/* 1035 */
[4417, 605],
/* 1036 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 1037 */
[4430, 982, 612, 150, 151],
/* 1038 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 1039 */
[4431, 2641, 179],
/* 1040 */
[4433, 993, 995, 150],
/* 1041 */
[4434, 409],
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 1177 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var isJsons = exports.isJsons = function isJsons(array) {
	  return Array.isArray(array) && array.every(function (row) {
	    return (typeof row === 'undefined' ? 'undefined' : _typeof(row)) === 'object' && !(row instanceof Array);
	  });
	};
	
	var isArrays = exports.isArrays = function isArrays(array) {
	  return Array.isArray(array) && array.every(function (row) {
	    return Array.isArray(row);
	  });
	};
	
	var jsonsHeaders = exports.jsonsHeaders = function jsonsHeaders(array) {
	  return Array.from(array.map(function (json) {
	    return Object.keys(json);
	  }).reduce(function (a, b) {
	    return new Set([].concat(_toConsumableArray(a), _toConsumableArray(b)));
	  }, []));
	};
	
	var jsons2arrays = exports.jsons2arrays = function jsons2arrays(jsons, headers) {
	  headers = headers || jsonsHeaders(jsons);
	
	  var headerLabels = headers;
	  var headerKeys = headers;
	  if (isJsons(headers)) {
	    headerLabels = headers.map(function (header) {
	      return header.label;
	    });
	    headerKeys = headers.map(function (header) {
	      return header.key;
	    });
	  }
	
	  var data = jsons.map(function (object) {
	    return headerKeys.map(function (header) {
	      return header in object ? object[header] : '';
	    });
	  });
	  return [headerLabels].concat(_toConsumableArray(data));
	};
	
	var joiner = exports.joiner = function joiner(data) {
	  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
	  return data.map(function (row, index) {
	    return row.map(function (element) {
	      return "\"" + element + "\"";
	    }).join(separator);
	  }).join('\n');
	};
	
	var arrays2csv = exports.arrays2csv = function arrays2csv(data, headers, separator) {
	  return joiner(headers ? [headers].concat(_toConsumableArray(data)) : data, separator);
	};
	
	var jsons2csv = exports.jsons2csv = function jsons2csv(data, headers, separator) {
	  return joiner(jsons2arrays(data, headers), separator);
	};
	
	var string2csv = exports.string2csv = function string2csv(data, headers, separator) {
	  return headers ? headers.join(separator) + '\n' + data : data;
	};
	
	var toCSV = exports.toCSV = function toCSV(data, headers, separator) {
	  if (isJsons(data)) return jsons2csv(data, headers, separator);
	  if (isArrays(data)) return arrays2csv(data, headers, separator);
	  if (typeof data === 'string') return string2csv(data, headers, separator);
	  throw new TypeError('Data should be a "String", "Array of arrays" OR "Array of objects" ');
	};
	
	var buildURI = exports.buildURI = function buildURI(data, uFEFF, headers, separator) {
	  return encodeURI('data:text/csv;charset=utf-8,' + (uFEFF ? '\uFEFF' : '') + toCSV(data, headers, separator));
	};

/***/ },
/* 1178 */
[4454, 8],
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Facebook = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(98);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(134));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
	var SDK_GLOBAL = 'FB';
	var SDK_GLOBAL_READY = 'fbAsyncInit';
	var MATCH_URL = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
	var PLAYER_ID_PREFIX = 'facebook-player-';
	
	var Facebook = /*#__PURE__*/function (_Component) {
	  _inherits(Facebook, _Component);
	
	  var _super = _createSuper(Facebook);
	
	  function Facebook() {
	    var _this;
	
	    _classCallCheck(this, Facebook);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.facebook.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.callPlayer('mute');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.callPlayer('unmute');
	    });
	
	    return _this;
	  }
	
	  _createClass(Facebook, [{
	    key: "load",
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      if (isReady) {
	        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
	          return FB.XFBML.parse();
	        });
	        return;
	      }
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
	        FB.init({
	          appId: _this2.props.config.facebook.appId,
	          xfbml: true,
	          version: _this2.props.config.facebook.version
	        });
	        FB.Event.subscribe('xfbml.render', function (msg) {
	          // Here we know the SDK has loaded, even if onReady/onPlay
	          // is not called due to a video that cannot be embedded
	          _this2.props.onLoaded();
	        });
	        FB.Event.subscribe('xfbml.ready', function (msg) {
	          if (msg.type === 'video' && msg.id === _this2.playerID) {
	            _this2.player = msg.instance;
	
	            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);
	
	            _this2.player.subscribe('paused', _this2.props.onPause);
	
	            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);
	
	            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);
	
	            _this2.player.subscribe('finishedBuffering', _this2.props.onBufferEnd);
	
	            _this2.player.subscribe('error', _this2.props.onError);
	
	            if (!_this2.props.muted) {
	              // Player is muted by default
	              _this2.callPlayer('unmute');
	            }
	
	            _this2.props.onReady(); // For some reason Facebook have added `visibility: hidden`
	            // to the iframe when autoplay fails, so here we set it back
	
	
	            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
	          }
	        });
	      });
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {// Nothing to do
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentPosition');
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        style: style,
	        id: this.playerID,
	        className: "fb-video",
	        "data-href": this.props.url,
	        "data-autoplay": this.props.playing ? 'true' : 'false',
	        "data-allowfullscreen": "true",
	        "data-controls": this.props.controls ? 'true' : 'false'
	      });
	    }
	  }]);
	
	  return Facebook;
	}(_react.Component);
	
	exports.Facebook = Facebook;
	
	_defineProperty(Facebook, "displayName", 'Facebook');
	
	_defineProperty(Facebook, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	_defineProperty(Facebook, "loopOnEnded", true);
	
	var _default = (0, _singlePlayer["default"])(Facebook);
	
	exports["default"] = _default;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.FilePlayer = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(98);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(134));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
	var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
	var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
	var HLS_SDK_URL = 'https://cdn.jsdelivr.net/npm/hls.js@VERSION/dist/hls.min.js';
	var HLS_GLOBAL = 'Hls';
	var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
	var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
	var DASH_GLOBAL = 'dashjs';
	var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;
	
	function canPlay(url) {
	  if (url instanceof Array) {
	    var _iterator = _createForOfIteratorHelper(url),
	        _step;
	
	    try {
	      for (_iterator.s(); !(_step = _iterator.n()).done;) {
	        var item = _step.value;
	
	        if (typeof item === 'string' && canPlay(item)) {
	          return true;
	        }
	
	        if (canPlay(item.src)) {
	          return true;
	        }
	      }
	    } catch (err) {
	      _iterator.e(err);
	    } finally {
	      _iterator.f();
	    }
	
	    return false;
	  }
	
	  if ((0, _utils.isMediaStream)(url)) {
	    return true;
	  }
	
	  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
	}
	
	function supportsWebKitPresentationMode(video) {
	  if (!video) video = document.createElement('video'); // Check if Safari supports PiP, and is not on mobile (other than iPad)
	  // iPhone safari appears to "support" PiP through the check, however PiP does not function
	
	  return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === 'function' && !/iPhone|iPod/.test(navigator.userAgent);
	}
	
	function canEnablePIP(url) {
	  return canPlay(url) && (!!document.pictureInPictureEnabled || supportsWebKitPresentationMode()) && !AUDIO_EXTENSIONS.test(url);
	}
	
	var FilePlayer = /*#__PURE__*/function (_Component) {
	  _inherits(FilePlayer, _Component);
	
	  var _super = _createSuper(FilePlayer);
	
	  function FilePlayer() {
	    var _this;
	
	    _classCallCheck(this, FilePlayer);
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(_args));
	
	    _defineProperty(_assertThisInitialized(_this), "onReady", function () {
	      var _this$props;
	
	      return (_this$props = _this.props).onReady.apply(_this$props, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
	      var _this$props2;
	
	      return (_this$props2 = _this.props).onPlay.apply(_this$props2, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onBuffer", function () {
	      var _this$props3;
	
	      return (_this$props3 = _this.props).onBuffer.apply(_this$props3, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onBufferEnd", function () {
	      var _this$props4;
	
	      return (_this$props4 = _this.props).onBufferEnd.apply(_this$props4, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
	      var _this$props5;
	
	      return (_this$props5 = _this.props).onPause.apply(_this$props5, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
	      var _this$props6;
	
	      return (_this$props6 = _this.props).onEnded.apply(_this$props6, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onError", function () {
	      var _this$props7;
	
	      return (_this$props7 = _this.props).onError.apply(_this$props7, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onEnablePIP", function () {
	      var _this$props8;
	
	      return (_this$props8 = _this.props).onEnablePIP.apply(_this$props8, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDisablePIP", function (e) {
	      var _this$props9 = _this.props,
	          onDisablePIP = _this$props9.onDisablePIP,
	          playing = _this$props9.playing;
	      onDisablePIP(e);
	
	      if (playing) {
	        _this.play();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPresentationModeChange", function (e) {
	      if (_this.player && supportsWebKitPresentationMode(_this.player)) {
	        var webkitPresentationMode = _this.player.webkitPresentationMode;
	
	        if (webkitPresentationMode === 'picture-in-picture') {
	          _this.onEnablePIP(e);
	        } else if (webkitPresentationMode === 'inline') {
	          _this.onDisablePIP(e);
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSeek", function (e) {
	      _this.props.onSeek(e.target.currentTime);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.player.muted = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.player.muted = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderSourceElement", function (source, index) {
	      if (typeof source === 'string') {
	        return /*#__PURE__*/_react["default"].createElement("source", {
	          key: index,
	          src: source
	        });
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("source", _extends({
	        key: index
	      }, source));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderTrack", function (track, index) {
	      return /*#__PURE__*/_react["default"].createElement("track", _extends({
	        key: index
	      }, track));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
	      if (_this.player) {
	        // Store previous player to be used by removeListeners()
	        _this.prevPlayer = _this.player;
	      }
	
	      _this.player = player;
	    });
	
	    return _this;
	  }
	
	  _createClass(FilePlayer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.addListeners(this.player);
	
	      if (IOS) {
	        this.player.load();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
	        this.removeListeners(this.prevPlayer);
	        this.addListeners(this.player);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeListeners(this.player);
	
	      if (this.hls) {
	        this.hls.destroy();
	      }
	    }
	  }, {
	    key: "addListeners",
	    value: function addListeners(player) {
	      var playsinline = this.props.playsinline;
	      player.addEventListener('canplay', this.onReady);
	      player.addEventListener('play', this.onPlay);
	      player.addEventListener('waiting', this.onBuffer);
	      player.addEventListener('playing', this.onBufferEnd);
	      player.addEventListener('pause', this.onPause);
	      player.addEventListener('seeked', this.onSeek);
	      player.addEventListener('ended', this.onEnded);
	      player.addEventListener('error', this.onError);
	      player.addEventListener('enterpictureinpicture', this.onEnablePIP);
	      player.addEventListener('leavepictureinpicture', this.onDisablePIP);
	      player.addEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);
	
	      if (playsinline) {
	        player.setAttribute('playsinline', '');
	        player.setAttribute('webkit-playsinline', '');
	        player.setAttribute('x5-playsinline', '');
	      }
	    }
	  }, {
	    key: "removeListeners",
	    value: function removeListeners(player) {
	      player.removeEventListener('canplay', this.onReady);
	      player.removeEventListener('play', this.onPlay);
	      player.removeEventListener('waiting', this.onBuffer);
	      player.removeEventListener('playing', this.onBufferEnd);
	      player.removeEventListener('pause', this.onPause);
	      player.removeEventListener('seeked', this.onSeek);
	      player.removeEventListener('ended', this.onEnded);
	      player.removeEventListener('error', this.onError);
	      player.removeEventListener('enterpictureinpicture', this.onEnablePIP);
	      player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
	      player.removeEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);
	    } // Proxy methods to prevent listener leaks
	
	  }, {
	    key: "shouldUseAudio",
	    value: function shouldUseAudio(props) {
	      if (props.config.file.forceVideo) {
	        return false;
	      }
	
	      if (props.config.file.attributes.poster) {
	        return false; // Use <video> so that poster is shown
	      }
	
	      return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
	    }
	  }, {
	    key: "shouldUseHLS",
	    value: function shouldUseHLS(url) {
	      return HLS_EXTENSIONS.test(url) && !IOS || this.props.config.file.forceHLS;
	    }
	  }, {
	    key: "shouldUseDASH",
	    value: function shouldUseDASH(url) {
	      return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
	    }
	  }, {
	    key: "load",
	    value: function load(url) {
	      var _this2 = this;
	
	      var _this$props$config$fi = this.props.config.file,
	          hlsVersion = _this$props$config$fi.hlsVersion,
	          dashVersion = _this$props$config$fi.dashVersion;
	
	      if (this.shouldUseHLS(url)) {
	        (0, _utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
	          _this2.hls = new Hls(_this2.props.config.file.hlsOptions);
	
	          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
	            _this2.props.onError(e, data, _this2.hls, Hls);
	          });
	
	          _this2.hls.loadSource(url);
	
	          _this2.hls.attachMedia(_this2.player);
	        });
	      }
	
	      if (this.shouldUseDASH(url)) {
	        (0, _utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
	          _this2.dash = dashjs.MediaPlayer().create();
	
	          _this2.dash.initialize(_this2.player, url, _this2.props.playing);
	
	          _this2.dash.on('error', _this2.props.onError);
	
	          _this2.dash.getDebug().setLogToBrowserConsole(false);
	        });
	      }
	
	      if (url instanceof Array) {
	        // When setting new urls (<source>) on an already loaded video,
	        // HTMLMediaElement.load() is needed to reset the media element
	        // and restart the media resource. Just replacing children source
	        // dom nodes is not enough
	        this.player.load();
	      } else if ((0, _utils.isMediaStream)(url)) {
	        try {
	          this.player.srcObject = url;
	        } catch (e) {
	          this.player.src = window.URL.createObjectURL(url);
	        }
	      }
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      var promise = this.player.play();
	
	      if (promise) {
	        promise["catch"](this.props.onError);
	      }
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.player.pause();
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      this.player.removeAttribute('src');
	
	      if (this.dash) {
	        this.dash.reset();
	      }
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.player.currentTime = seconds;
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.player.volume = fraction;
	    }
	  }, {
	    key: "enablePIP",
	    value: function enablePIP() {
	      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
	        this.player.requestPictureInPicture();
	      } else if (supportsWebKitPresentationMode(this.player) && this.player.webkitPresentationMode !== 'picture-in-picture') {
	        this.player.webkitSetPresentationMode('picture-in-picture');
	      }
	    }
	  }, {
	    key: "disablePIP",
	    value: function disablePIP() {
	      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
	        document.exitPictureInPicture();
	      } else if (supportsWebKitPresentationMode(this.player) && this.player.webkitPresentationMode !== 'inline') {
	        this.player.webkitSetPresentationMode('inline');
	      }
	    }
	  }, {
	    key: "setPlaybackRate",
	    value: function setPlaybackRate(rate) {
	      this.player.playbackRate = rate;
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      if (!this.player) return null;
	      var _this$player = this.player,
	          duration = _this$player.duration,
	          seekable = _this$player.seekable; // on iOS, live streams return Infinity for the duration
	      // so instead we use the end of the seekable timerange
	
	      if (duration === Infinity && seekable.length > 0) {
	        return seekable.end(seekable.length - 1);
	      }
	
	      return duration;
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      if (!this.player) return null;
	      return this.player.currentTime;
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      if (!this.player) return null;
	      var buffered = this.player.buffered;
	
	      if (buffered.length === 0) {
	        return 0;
	      }
	
	      var end = buffered.end(buffered.length - 1);
	      var duration = this.getDuration();
	
	      if (end > duration) {
	        return duration;
	      }
	
	      return end;
	    }
	  }, {
	    key: "getSource",
	    value: function getSource(url) {
	      var useHLS = this.shouldUseHLS(url);
	      var useDASH = this.shouldUseDASH(url);
	
	      if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH) {
	        return undefined;
	      }
	
	      if (MATCH_DROPBOX_URL.test(url)) {
	        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
	      }
	
	      return url;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props10 = this.props,
	          url = _this$props10.url,
	          playing = _this$props10.playing,
	          loop = _this$props10.loop,
	          controls = _this$props10.controls,
	          muted = _this$props10.muted,
	          config = _this$props10.config,
	          width = _this$props10.width,
	          height = _this$props10.height;
	      var useAudio = this.shouldUseAudio(this.props);
	      var Element = useAudio ? 'audio' : 'video';
	      var style = {
	        width: width === 'auto' ? width : '100%',
	        height: height === 'auto' ? height : '100%'
	      };
	      return /*#__PURE__*/_react["default"].createElement(Element, _extends({
	        ref: this.ref,
	        src: this.getSource(url),
	        style: style,
	        preload: "auto",
	        autoPlay: playing || undefined,
	        controls: controls,
	        muted: muted,
	        loop: loop
	      }, config.file.attributes), url instanceof Array && url.map(this.renderSourceElement), config.file.tracks.map(this.renderTrack));
	    }
	  }]);
	
	  return FilePlayer;
	}(_react.Component);
	
	exports.FilePlayer = FilePlayer;
	
	_defineProperty(FilePlayer, "displayName", 'FilePlayer');
	
	_defineProperty(FilePlayer, "canPlay", canPlay);
	
	_defineProperty(FilePlayer, "canEnablePIP", canEnablePIP);
	
	var _default = (0, _singlePlayer["default"])(FilePlayer);
	
	exports["default"] = _default;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Mixcloud = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(98);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(134));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = 'https://widget.mixcloud.com/media/js/widgetApi.js';
	var SDK_GLOBAL = 'Mixcloud';
	var MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;
	
	var Mixcloud = /*#__PURE__*/function (_Component) {
	  _inherits(Mixcloud, _Component);
	
	  var _super = _createSuper(Mixcloud);
	
	  function Mixcloud() {
	    var _this;
	
	    _classCallCheck(this, Mixcloud);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "duration", null);
	
	    _defineProperty(_assertThisInitialized(_this), "currentTime", null);
	
	    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {// No volume support
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {// No volume support
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
	      _this.iframe = iframe;
	    });
	
	    return _this;
	  }
	
	  _createClass(Mixcloud, [{
	    key: "load",
	    value: function load(url) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
	        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);
	
	        _this2.player.ready.then(function () {
	          _this2.player.events.play.on(_this2.props.onPlay);
	
	          _this2.player.events.pause.on(_this2.props.onPause);
	
	          _this2.player.events.ended.on(_this2.props.onEnded);
	
	          _this2.player.events.error.on(_this2.props.error);
	
	          _this2.player.events.progress.on(function (seconds, duration) {
	            _this2.currentTime = seconds;
	            _this2.duration = duration;
	          });
	
	          _this2.props.onReady();
	        });
	      }, this.props.onError);
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {// Nothing to do
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {// No volume support
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          url = _this$props.url,
	          config = _this$props.config;
	      var id = url.match(MATCH_URL)[1];
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      var query = (0, _utils.queryString)(_objectSpread({}, config.mixcloud.options, {
	        feed: "/".concat(id, "/")
	      })); // We have to give the iframe a key here to prevent a
	      // weird dialog appearing when loading a new track
	
	      return /*#__PURE__*/_react["default"].createElement("iframe", {
	        key: id,
	        ref: this.ref,
	        style: style,
	        src: "https://www.mixcloud.com/widget/iframe/?".concat(query),
	        frameBorder: "0"
	      });
	    }
	  }]);
	
	  return Mixcloud;
	}(_react.Component);
	
	exports.Mixcloud = Mixcloud;
	
	_defineProperty(Mixcloud, "displayName", 'Mixcloud');
	
	_defineProperty(Mixcloud, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	_defineProperty(Mixcloud, "loopOnEnded", true);
	
	var _default = (0, _singlePlayer["default"])(Mixcloud);
	
	exports["default"] = _default;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Streamable = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(98);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(134));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
	var SDK_GLOBAL = 'playerjs';
	var MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;
	
	var Streamable = /*#__PURE__*/function (_Component) {
	  _inherits(Streamable, _Component);
	
	  var _super = _createSuper(Streamable);
	
	  function Streamable() {
	    var _this;
	
	    _classCallCheck(this, Streamable);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "duration", null);
	
	    _defineProperty(_assertThisInitialized(_this), "currentTime", null);
	
	    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.callPlayer('mute');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.callPlayer('unmute');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
	      _this.iframe = iframe;
	    });
	
	    return _this;
	  }
	
	  _createClass(Streamable, [{
	    key: "load",
	    value: function load(url) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
	        if (!_this2.iframe) return;
	        _this2.player = new playerjs.Player(_this2.iframe);
	
	        _this2.player.setLoop(_this2.props.loop);
	
	        _this2.player.on('ready', _this2.props.onReady);
	
	        _this2.player.on('play', _this2.props.onPlay);
	
	        _this2.player.on('pause', _this2.props.onPause);
	
	        _this2.player.on('seeked', _this2.props.onSeek);
	
	        _this2.player.on('ended', _this2.props.onEnded);
	
	        _this2.player.on('error', _this2.props.onError);
	
	        _this2.player.on('timeupdate', function (_ref) {
	          var duration = _ref.duration,
	              seconds = _ref.seconds;
	          _this2.duration = duration;
	          _this2.currentTime = seconds;
	        });
	
	        _this2.player.on('buffered', function (_ref2) {
	          var percent = _ref2.percent;
	
	          if (_this2.duration) {
	            _this2.secondsLoaded = _this2.duration * percent;
	          }
	        });
	
	        if (_this2.props.muted) {
	          _this2.player.mute();
	        }
	      }, this.props.onError);
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {// Nothing to do
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('setCurrentTime', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: "setLoop",
	    value: function setLoop(loop) {
	      this.callPlayer('setLoop', loop);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return this.secondsLoaded;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var id = this.props.url.match(MATCH_URL)[1];
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return /*#__PURE__*/_react["default"].createElement("iframe", {
	        ref: this.ref,
	        src: "https://streamable.com/o/".concat(id),
	        frameBorder: "0",
	        scrolling: "no",
	        style: style,
	        allowFullScreen: true
	      });
	    }
	  }]);
	
	  return Streamable;
	}(_react.Component);
	
	exports.Streamable = Streamable;
	
	_defineProperty(Streamable, "displayName", 'Streamable');
	
	_defineProperty(Streamable, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	var _default = (0, _singlePlayer["default"])(Streamable);
	
	exports["default"] = _default;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Twitch = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(98);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(134));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
	var SDK_GLOBAL = 'Twitch';
	var MATCH_VIDEO_URL = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
	var MATCH_CHANNEL_URL = /(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
	var PLAYER_ID_PREFIX = 'twitch-player-';
	
	var Twitch = /*#__PURE__*/function (_Component) {
	  _inherits(Twitch, _Component);
	
	  var _super = _createSuper(Twitch);
	
	  function Twitch() {
	    var _this;
	
	    _classCallCheck(this, Twitch);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.twitch.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.callPlayer('setMuted', true);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.callPlayer('setMuted', false);
	    });
	
	    return _this;
	  }
	
	  _createClass(Twitch, [{
	    key: "load",
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          playsinline = _this$props.playsinline,
	          onError = _this$props.onError,
	          config = _this$props.config,
	          controls = _this$props.controls;
	      var isChannel = MATCH_CHANNEL_URL.test(url);
	      var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];
	
	      if (isReady) {
	        if (isChannel) {
	          this.player.setChannel(id);
	        } else {
	          this.player.setVideo('v' + id);
	        }
	
	        return;
	      }
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
	        _this2.player = new Twitch.Player(_this2.playerID, _objectSpread({
	          video: isChannel ? '' : id,
	          channel: isChannel ? id : '',
	          height: '100%',
	          width: '100%',
	          playsinline: playsinline,
	          autoplay: _this2.props.playing,
	          muted: _this2.props.muted,
	          // https://github.com/CookPete/react-player/issues/733#issuecomment-549085859
	          controls: isChannel ? true : controls
	        }, config.twitch.options));
	        var _Twitch$Player = Twitch.Player,
	            READY = _Twitch$Player.READY,
	            PLAYING = _Twitch$Player.PLAYING,
	            PAUSE = _Twitch$Player.PAUSE,
	            ENDED = _Twitch$Player.ENDED,
	            ONLINE = _Twitch$Player.ONLINE,
	            OFFLINE = _Twitch$Player.OFFLINE;
	
	        _this2.player.addEventListener(READY, _this2.props.onReady);
	
	        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);
	
	        _this2.player.addEventListener(PAUSE, _this2.props.onPause);
	
	        _this2.player.addEventListener(ENDED, _this2.props.onEnded); // Prevent weird isLoading behaviour when streams are offline
	
	
	        _this2.player.addEventListener(ONLINE, _this2.props.onLoaded);
	
	        _this2.player.addEventListener(OFFLINE, _this2.props.onLoaded);
	      }, onError);
	    }
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentTime');
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        style: style,
	        id: this.playerID
	      });
	    }
	  }]);
	
	  return Twitch;
	}(_react.Component);
	
	exports.Twitch = Twitch;
	
	_defineProperty(Twitch, "displayName", 'Twitch');
	
	_defineProperty(Twitch, "canPlay", function (url) {
	  return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
	});
	
	_defineProperty(Twitch, "loopOnEnded", true);
	
	var _default = (0, _singlePlayer["default"])(Twitch);
	
	exports["default"] = _default;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Wistia = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(98);
	
	var _singlePlayer = _interopRequireDefault(__webpack_require__(134));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SDK_URL = 'https://fast.wistia.com/assets/external/E-v1.js';
	var SDK_GLOBAL = 'Wistia';
	var MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;
	
	var Wistia = /*#__PURE__*/function (_Component) {
	  _inherits(Wistia, _Component);
	
	  var _super = _createSuper(Wistia);
	
	  function Wistia() {
	    var _this;
	
	    _classCallCheck(this, Wistia);
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(_args));
	
	    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);
	
	    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
	      var _this$props;
	
	      return (_this$props = _this.props).onPlay.apply(_this$props, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
	      var _this$props2;
	
	      return (_this$props2 = _this.props).onPause.apply(_this$props2, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSeek", function () {
	      var _this$props3;
	
	      return (_this$props3 = _this.props).onSeek.apply(_this$props3, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
	      var _this$props4;
	
	      return (_this$props4 = _this.props).onEnded.apply(_this$props4, arguments);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mute", function () {
	      _this.callPlayer('mute');
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
	      _this.callPlayer('unmute');
	    });
	
	    return _this;
	  }
	
	  _createClass(Wistia, [{
	    key: "getID",
	    value: function getID(url) {
	      return url && url.match(MATCH_URL)[1];
	    }
	  }, {
	    key: "load",
	    value: function load(url) {
	      var _this2 = this;
	
	      var _this$props5 = this.props,
	          playing = _this$props5.playing,
	          muted = _this$props5.muted,
	          controls = _this$props5.controls,
	          _onReady = _this$props5.onReady,
	          config = _this$props5.config,
	          onError = _this$props5.onError;
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
	        window._wq = window._wq || [];
	
	        window._wq.push({
	          id: _this2.getID(url),
	          options: _objectSpread({
	            autoPlay: playing,
	            silentAutoPlay: 'allow',
	            muted: muted,
	            controlsVisibleOnLoad: controls
	          }, config.wistia.options),
	          onReady: function onReady(player) {
	            _this2.player = player;
	
	            _this2.unbind();
	
	            _this2.player.bind('play', _this2.onPlay);
	
	            _this2.player.bind('pause', _this2.onPause);
	
	            _this2.player.bind('seek', _this2.onSeek);
	
	            _this2.player.bind('end', _this2.onEnded);
	
	            _onReady();
	          }
	        });
	      }, onError);
	    }
	  }, {
	    key: "unbind",
	    value: function unbind() {
	      this.player.unbind('play', this.onPlay);
	      this.player.unbind('pause', this.onPause);
	      this.player.unbind('seek', this.onSeek);
	      this.player.unbind('end', this.onEnded);
	    } // Proxy methods to prevent listener leaks
	
	  }, {
	    key: "play",
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: "pause",
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      this.unbind();
	      this.callPlayer('remove');
	    }
	  }, {
	    key: "seekTo",
	    value: function seekTo(seconds) {
	      this.callPlayer('time', seconds);
	    }
	  }, {
	    key: "setVolume",
	    value: function setVolume(fraction) {
	      this.callPlayer('volume', fraction);
	    }
	  }, {
	    key: "setPlaybackRate",
	    value: function setPlaybackRate(rate) {
	      this.callPlayer('playbackRate', rate);
	    }
	  }, {
	    key: "getDuration",
	    value: function getDuration() {
	      return this.callPlayer('duration');
	    }
	  }, {
	    key: "getCurrentTime",
	    value: function getCurrentTime() {
	      return this.callPlayer('time');
	    }
	  }, {
	    key: "getSecondsLoaded",
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var id = this.getID(this.props.url);
	      var className = "wistia_embed wistia_async_".concat(id);
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        key: id,
	        className: className,
	        style: style
	      });
	    }
	  }]);
	
	  return Wistia;
	}(_react.Component);
	
	exports.Wistia = Wistia;
	
	_defineProperty(Wistia, "displayName", 'Wistia');
	
	_defineProperty(Wistia, "canPlay", function (url) {
	  return MATCH_URL.test(url);
	});
	
	_defineProperty(Wistia, "loopOnEnded", true);
	
	var _default = (0, _singlePlayer["default"])(Wistia);
	
	exports["default"] = _default;

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Ref = __webpack_require__(2800);
	
	var _Ref2 = _interopRequireDefault(_Ref);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Ref2.default;

/***/ },
/* 1186 */
[4462, 2803],
/* 1187 */
[4463, 2804],
/* 1188 */
[4466, 74, 8, 10, 75],
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A section sub-component for Breadcrumb component.
	 */
	var BreadcrumbSection = function (_Component) {
	  (0, _inherits3.default)(BreadcrumbSection, _Component);
	
	  function BreadcrumbSection() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BreadcrumbSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BreadcrumbSection.__proto__ || Object.getPrototypeOf(BreadcrumbSection)).call.apply(_ref, [this].concat(args))), _this), _this.computeElementType = function () {
	      var _this$props = _this.props,
	          link = _this$props.link,
	          onClick = _this$props.onClick;
	
	
	      if (link || onClick) return 'a';
	    }, _this.handleClick = function (e) {
	      return (0, _invoke3.default)(_this.props, 'onClick', e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BreadcrumbSection, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content,
	          href = _props.href;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), 'section', className);
	      var rest = (0, _lib.getUnhandledProps)(BreadcrumbSection, this.props);
	      var ElementType = (0, _lib.getElementType)(BreadcrumbSection, this.props, this.computeElementType);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	        _lib.childrenUtils.isNil(children) ? content : children
	      );
	    }
	  }]);
	  return BreadcrumbSection;
	}(_react.Component);
	
	BreadcrumbSection._meta = {
	  name: 'BreadcrumbSection',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Breadcrumb'
	};
	BreadcrumbSection.handledProps = ['active', 'as', 'children', 'className', 'content', 'href', 'link', 'onClick'];
	exports.default = BreadcrumbSection;
	BreadcrumbSection.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Style as the currently active section. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
	  href: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['link']), _propTypes2.default.string]),
	
	  /** Render as an `a` tag instead of a `div`. */
	  link: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['href']), _propTypes2.default.bool]),
	
	  /**
	   * Called on click. When passed, the component will render as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func
	} : {};
	
	
	BreadcrumbSection.create = (0, _lib.createShorthandFactory)(BreadcrumbSection, function (content) {
	  return { content: content, link: true };
	});

/***/ },
/* 1190 */
[4468, 10, 413, 153],
/* 1191 */
[4469, 10, 418, 153],
/* 1192 */
[4470, 10, 651, 153],
/* 1193 */
[4471, 8, 10],
/* 1194 */
[4472, 10, 641, 153],
/* 1195 */
[4473, 10, 637, 153],
/* 1196 */
[4474, 10, 1186, 153],
/* 1197 */
[4475, 10, 1187, 153],
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _GridColumn = __webpack_require__(638);
	
	var _GridColumn2 = _interopRequireDefault(_GridColumn);
	
	var _GridRow = __webpack_require__(1199);
	
	var _GridRow2 = _interopRequireDefault(_GridRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A grid is used to harmonize negative space in a layout.
	 */
	function Grid(props) {
	  var celled = props.celled,
	      centered = props.centered,
	      children = props.children,
	      className = props.className,
	      columns = props.columns,
	      container = props.container,
	      divided = props.divided,
	      doubling = props.doubling,
	      inverted = props.inverted,
	      padded = props.padded,
	      relaxed = props.relaxed,
	      reversed = props.reversed,
	      stackable = props.stackable,
	      stretched = props.stretched,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(container, 'container'), (0, _lib.useKeyOnly)(doubling, 'doubling'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useKeyOnly)(stretched, 'stretched'), (0, _lib.useKeyOrValueAndKey)(celled, 'celled'), (0, _lib.useKeyOrValueAndKey)(divided, 'divided'), (0, _lib.useKeyOrValueAndKey)(padded, 'padded'), (0, _lib.useKeyOrValueAndKey)(relaxed, 'relaxed'), (0, _lib.useMultipleProp)(reversed, 'reversed'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, 'column', true), 'grid', className);
	  var rest = (0, _lib.getUnhandledProps)(Grid, props);
	  var ElementType = (0, _lib.getElementType)(Grid, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Grid.handledProps = ['as', 'celled', 'centered', 'children', 'className', 'columns', 'container', 'divided', 'doubling', 'inverted', 'padded', 'relaxed', 'reversed', 'stackable', 'stretched', 'textAlign', 'verticalAlign'];
	Grid.Column = _GridColumn2.default;
	Grid.Row = _GridRow2.default;
	
	Grid._meta = {
	  name: 'Grid',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	Grid.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A grid can have rows divided into cells. */
	  celled: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['internally'])]),
	
	  /** A grid can have its columns centered. */
	  centered: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Represents column count per row in Grid. */
	  columns: _propTypes2.default.oneOf([].concat((0, _toConsumableArray3.default)(_lib.SUI.WIDTHS), ['equal'])),
	
	  /** A grid can be combined with a container to use the available layout and alignment. */
	  container: _propTypes2.default.bool,
	
	  /** A grid can have dividers between its columns. */
	  divided: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['vertically'])]),
	
	  /** A grid can double its column width on tablet and mobile sizes. */
	  doubling: _propTypes2.default.bool,
	
	  /** A grid's colors can be inverted. */
	  inverted: _propTypes2.default.bool,
	
	  /** A grid can preserve its vertical and horizontal gutters on first and last columns. */
	  padded: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['horizontally', 'vertically'])]),
	
	  /** A grid can increase its gutters to allow for more negative space. */
	  relaxed: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])]),
	
	  /** A grid can specify that its columns should reverse order at different device sizes. */
	  reversed: _lib.customPropTypes.multipleProp(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),
	
	  /** A grid can have its columns stack on-top of each other after reaching mobile breakpoints. */
	  stackable: _propTypes2.default.bool,
	
	  /** A grid can stretch its contents to take up the entire grid height. */
	  stretched: _propTypes2.default.bool,
	
	  /** A grid can specify its text alignment. */
	  textAlign: _propTypes2.default.oneOf(_lib.SUI.TEXT_ALIGNMENTS),
	
	  /** A grid can specify its vertical alignment to have all its columns vertically centered. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	
	exports.default = Grid;

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A row sub-component for Grid.
	 */
	function GridRow(props) {
	  var centered = props.centered,
	      children = props.children,
	      className = props.className,
	      color = props.color,
	      columns = props.columns,
	      divided = props.divided,
	      only = props.only,
	      reversed = props.reversed,
	      stretched = props.stretched,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign;
	
	
	  var classes = (0, _classnames2.default)(color, (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(divided, 'divided'), (0, _lib.useKeyOnly)(stretched, 'stretched'), (0, _lib.useMultipleProp)(only, 'only'), (0, _lib.useMultipleProp)(reversed, 'reversed'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, 'column', true), 'row', className);
	  var rest = (0, _lib.getUnhandledProps)(GridRow, props);
	  var ElementType = (0, _lib.getElementType)(GridRow, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	GridRow.handledProps = ['as', 'centered', 'children', 'className', 'color', 'columns', 'divided', 'only', 'reversed', 'stretched', 'textAlign', 'verticalAlign'];
	GridRow._meta = {
	  name: 'GridRow',
	  parent: 'Grid',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	GridRow.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A row can have its columns centered. */
	  centered: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A grid row can be colored. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Represents column count per line in Row. */
	  columns: _propTypes2.default.oneOf([].concat((0, _toConsumableArray3.default)(_lib.SUI.WIDTHS), ['equal'])),
	
	  /** A row can have dividers between its columns. */
	  divided: _propTypes2.default.bool,
	
	  /** A row can appear only for a specific device, or screen sizes. */
	  only: _lib.customPropTypes.multipleProp(_lib.SUI.VISIBILITY),
	
	  /** A row can specify that its columns should reverse order at different device sizes. */
	  reversed: _lib.customPropTypes.multipleProp(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),
	
	  /** A row can stretch its contents to take up the entire column height. */
	  stretched: _propTypes2.default.bool,
	
	  /** A row can specify its text alignment. */
	  textAlign: _propTypes2.default.oneOf(_lib.SUI.TEXT_ALIGNMENTS),
	
	  /** A row can specify its vertical alignment to have all its columns vertically centered. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	
	exports.default = GridRow;

/***/ },
/* 1200 */
[4478, 69, 44, 43, 8, 10, 1201, 1202, 1203],
/* 1201 */
[4479, 8, 10],
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _startCase2 = __webpack_require__(2776);
	
	var _startCase3 = _interopRequireDefault(_startCase2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Icon = __webpack_require__(75);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A menu can contain an item.
	 */
	var MenuItem = function (_Component) {
	  (0, _inherits3.default)(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var disabled = _this.props.disabled;
	
	
	      if (!disabled) (0, _invoke3.default)(_this.props, 'onClick', e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          content = _props.content,
	          disabled = _props.disabled,
	          fitted = _props.fitted,
	          header = _props.header,
	          icon = _props.icon,
	          link = _props.link,
	          name = _props.name,
	          onClick = _props.onClick,
	          position = _props.position;
	
	
	      var classes = (0, _classnames2.default)(color, position, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(icon === true || icon && !(name || content), 'icon'), (0, _lib.useKeyOnly)(header, 'header'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOrValueAndKey)(fitted, 'fitted'), 'item', className);
	      var ElementType = (0, _lib.getElementType)(MenuItem, this.props, function () {
	        if (onClick) return 'a';
	      });
	      var rest = (0, _lib.getUnhandledProps)(MenuItem, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        _Icon2.default.create(icon),
	        _lib.childrenUtils.isNil(content) ? (0, _startCase3.default)(name) : content
	      );
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	MenuItem._meta = {
	  name: 'MenuItem',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Menu'
	};
	MenuItem.handledProps = ['active', 'as', 'children', 'className', 'color', 'content', 'disabled', 'fitted', 'header', 'icon', 'index', 'link', 'name', 'onClick', 'position'];
	exports.default = MenuItem;
	MenuItem.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A menu item can be active. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Additional colors can be specified. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A menu item can be disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** A menu item or menu can remove element padding, vertically or horizontally. */
	  fitted: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['horizontally', 'vertically'])]),
	
	  /** A menu item may include a header or may itself be a header. */
	  header: _propTypes2.default.bool,
	
	  /** MenuItem can be only icon. */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _lib.customPropTypes.itemShorthand]),
	
	  /** MenuItem index inside Menu. */
	  index: _propTypes2.default.number,
	
	  /** A menu item can be link. */
	  link: _propTypes2.default.bool,
	
	  /** Internal name of the MenuItem. */
	  name: _propTypes2.default.string,
	
	  /**
	   * Called on click. When passed, the component will render as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /** A menu item can take left or right position. */
	  position: _propTypes2.default.oneOf(['left', 'right'])
	} : {};
	
	
	MenuItem.create = (0, _lib.createShorthandFactory)(MenuItem, function (val) {
	  return { content: val, name: val };
	});

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A menu can contain a sub menu.
	 */
	function MenuMenu(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      position = props.position;
	
	
	  var classes = (0, _classnames2.default)(position, 'menu', className);
	  var rest = (0, _lib.getUnhandledProps)(MenuMenu, props);
	  var ElementType = (0, _lib.getElementType)(MenuMenu, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	MenuMenu.handledProps = ['as', 'children', 'className', 'content', 'position'];
	MenuMenu._meta = {
	  name: 'MenuMenu',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Menu'
	};
	
	MenuMenu.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A sub menu can take left or right position. */
	  position: _propTypes2.default.oneOf(['left', 'right'])
	} : {};
	
	exports.default = MenuMenu;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A message can contain a content.
	 */
	function MessageContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageContent, props);
	  var ElementType = (0, _lib.getElementType)(MessageContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	MessageContent.handledProps = ['as', 'children', 'className', 'content'];
	MessageContent._meta = {
	  name: 'MessageContent',
	  parent: 'Message',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	MessageContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = MessageContent;

/***/ },
/* 1205 */
[4481, 8, 10],
/* 1206 */
[4483, 69, 8, 10, 639],
/* 1207 */
[4486, 8, 10],
/* 1208 */
[4488, 10, 640],
/* 1209 */
[4489, 8, 10, 412],
/* 1210 */
[4490, 43, 69, 8, 10, 412],
/* 1211 */
[4492, 44, 74, 8, 10, 414, 642, 1212, 1213, 1214],
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Used in some Button types, such as `animated`.
	 */
	function ButtonContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      hidden = props.hidden,
	      visible = props.visible;
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(visible, 'visible'), (0, _lib.useKeyOnly)(hidden, 'hidden'), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(ButtonContent, props);
	  var ElementType = (0, _lib.getElementType)(ButtonContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ButtonContent.handledProps = ['as', 'children', 'className', 'content', 'hidden', 'visible'];
	ButtonContent._meta = {
	  name: 'ButtonContent',
	  parent: 'Button',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ButtonContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Initially hidden, visible on hover. */
	  hidden: _propTypes2.default.bool,
	
	  /** Initially visible, hidden on hover. */
	  visible: _propTypes2.default.bool
	} : {};
	
	exports.default = ButtonContent;

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Buttons can be grouped.
	 */
	function ButtonGroup(props) {
	  var attached = props.attached,
	      basic = props.basic,
	      children = props.children,
	      className = props.className,
	      color = props.color,
	      compact = props.compact,
	      content = props.content,
	      floated = props.floated,
	      fluid = props.fluid,
	      icon = props.icon,
	      inverted = props.inverted,
	      labeled = props.labeled,
	      negative = props.negative,
	      positive = props.positive,
	      primary = props.primary,
	      secondary = props.secondary,
	      size = props.size,
	      toggle = props.toggle,
	      vertical = props.vertical,
	      widths = props.widths;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(icon, 'icon'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(labeled, 'labeled'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(primary, 'primary'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(toggle, 'toggle'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useWidthProp)(widths), 'buttons', className);
	  var rest = (0, _lib.getUnhandledProps)(ButtonGroup, props);
	  var ElementType = (0, _lib.getElementType)(ButtonGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ButtonGroup.handledProps = ['as', 'attached', 'basic', 'children', 'className', 'color', 'compact', 'content', 'floated', 'fluid', 'icon', 'inverted', 'labeled', 'negative', 'positive', 'primary', 'secondary', 'size', 'toggle', 'vertical', 'widths'];
	ButtonGroup._meta = {
	  name: 'ButtonGroup',
	  parent: 'Button',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ButtonGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Groups can be attached to other content. */
	  attached: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom'])]),
	
	  /** Groups can be less pronounced. */
	  basic: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Groups can have a shared color. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Groups can reduce their padding to fit into tighter spaces. */
	  compact: _propTypes2.default.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Groups can be aligned to the left or right of its container. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** Groups can take the width of their container. */
	  fluid: _propTypes2.default.bool,
	
	  /** Groups can be formatted as icons. */
	  icon: _propTypes2.default.bool,
	
	  /** Groups can be formatted to appear on dark backgrounds. */
	  inverted: _propTypes2.default.bool,
	
	  /** Groups can be formatted as labeled icon buttons. */
	  labeled: _propTypes2.default.bool,
	
	  /** Groups can hint towards a negative consequence. */
	  negative: _propTypes2.default.bool,
	
	  /** Groups can hint towards a positive consequence. */
	  positive: _propTypes2.default.bool,
	
	  /** Groups can be formatted to show different levels of emphasis. */
	  primary: _propTypes2.default.bool,
	
	  /** Groups can be formatted to show different levels of emphasis. */
	  secondary: _propTypes2.default.bool,
	
	  /** Groups can have different sizes. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES),
	
	  /** Groups can be formatted to toggle on and off. */
	  toggle: _propTypes2.default.bool,
	
	  /** Groups can be formatted to appear vertically. */
	  vertical: _propTypes2.default.bool,
	
	  /** Groups can have their widths divided evenly. */
	  widths: _propTypes2.default.oneOf(_lib.SUI.WIDTHS)
	} : {};
	
	exports.default = ButtonGroup;

/***/ },
/* 1214 */
[4493, 8, 10],
/* 1215 */
[4498, 2823],
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Header content wraps the main content when there is an adjacent Icon or Image.
	 */
	function HeaderContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(HeaderContent, props);
	  var ElementType = (0, _lib.getElementType)(HeaderContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	HeaderContent.handledProps = ['as', 'children', 'className', 'content'];
	HeaderContent._meta = {
	  name: 'HeaderContent',
	  parent: 'Header',
	  type: _lib.META.TYPES.VIEW
	};
	
	HeaderContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = HeaderContent;

/***/ },
/* 1217 */
[4500, 8, 10],
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Several icons can be used together as a group.
	 */
	function IconGroup(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      size = props.size;
	
	  var classes = (0, _classnames2.default)(size, 'icons', className);
	  var rest = (0, _lib.getUnhandledProps)(IconGroup, props);
	  var ElementType = (0, _lib.getElementType)(IconGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	IconGroup.handledProps = ['as', 'children', 'className', 'content', 'size'];
	IconGroup._meta = {
	  name: 'IconGroup',
	  parent: 'Icon',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	IconGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Size of the icon group. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : {};
	
	IconGroup.defaultProps = {
	  as: 'i'
	};
	
	exports.default = IconGroup;

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(74);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Dimmer = __webpack_require__(1235);
	
	var _Dimmer2 = _interopRequireDefault(_Dimmer);
	
	var _Label = __webpack_require__(642);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ImageGroup = __webpack_require__(1220);
	
	var _ImageGroup2 = _interopRequireDefault(_ImageGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An image is a graphic representation of something.
	 * @see Icon
	 */
	function Image(props) {
	  var alt = props.alt,
	      avatar = props.avatar,
	      bordered = props.bordered,
	      centered = props.centered,
	      children = props.children,
	      circular = props.circular,
	      className = props.className,
	      content = props.content,
	      dimmer = props.dimmer,
	      disabled = props.disabled,
	      floated = props.floated,
	      fluid = props.fluid,
	      height = props.height,
	      hidden = props.hidden,
	      href = props.href,
	      inline = props.inline,
	      label = props.label,
	      rounded = props.rounded,
	      size = props.size,
	      spaced = props.spaced,
	      src = props.src,
	      verticalAlign = props.verticalAlign,
	      width = props.width,
	      wrapped = props.wrapped,
	      ui = props.ui;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(ui, 'ui'), size, (0, _lib.useKeyOnly)(avatar, 'avatar'), (0, _lib.useKeyOnly)(bordered, 'bordered'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(inline, 'inline'), (0, _lib.useKeyOnly)(rounded, 'rounded'), (0, _lib.useKeyOrValueAndKey)(spaced, 'spaced'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign, 'aligned'), 'image', className);
	  var rest = (0, _lib.getUnhandledProps)(Image, props);
	  var ElementType = (0, _lib.getElementType)(Image, props, function () {
	    if (!(0, _isNil3.default)(dimmer) || !(0, _isNil3.default)(label) || !(0, _isNil3.default)(wrapped) || !_lib.childrenUtils.isNil(children)) return 'div';
	  });
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	  if (!_lib.childrenUtils.isNil(content)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      content
	    );
	  }
	
	  var rootProps = (0, _extends3.default)({}, rest, { className: classes });
	  var imgTagProps = { alt: alt, src: src, height: height, width: width };
	
	  if (ElementType === 'img') return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rootProps, imgTagProps));
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rootProps, { href: href }),
	    _Dimmer2.default.create(dimmer),
	    _Label2.default.create(label),
	    _react2.default.createElement('img', imgTagProps)
	  );
	}
	
	Image.handledProps = ['alt', 'as', 'avatar', 'bordered', 'centered', 'children', 'circular', 'className', 'content', 'dimmer', 'disabled', 'floated', 'fluid', 'height', 'hidden', 'href', 'inline', 'label', 'rounded', 'size', 'spaced', 'src', 'ui', 'verticalAlign', 'width', 'wrapped'];
	Image.Group = _ImageGroup2.default;
	
	Image._meta = {
	  name: 'Image',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Image.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Alternate text for the image specified. */
	  alt: _propTypes2.default.string,
	
	  /** An image may be formatted to appear inline with text as an avatar. */
	  avatar: _propTypes2.default.bool,
	
	  /** An image may include a border to emphasize the edges of white or transparent content. */
	  bordered: _propTypes2.default.bool,
	
	  /** An image can appear centered in a content block. */
	  centered: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** An image may appear circular. */
	  circular: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** An image can show that it is disabled and cannot be selected. */
	  disabled: _propTypes2.default.bool,
	
	  /** Shorthand for Dimmer. */
	  dimmer: _lib.customPropTypes.itemShorthand,
	
	  /** An image can sit to the left or right of other content. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** An image can take up the width of its container. */
	  fluid: _lib.customPropTypes.every([_propTypes2.default.bool, _lib.customPropTypes.disallow(['size'])]),
	
	  /** The img element height attribute. */
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** An image can be hidden. */
	  hidden: _propTypes2.default.bool,
	
	  /** Renders the Image as an <a> tag with this href. */
	  href: _propTypes2.default.string,
	
	  /** An image may appear inline. */
	  inline: _propTypes2.default.bool,
	
	  /** Shorthand for Label. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** An image may appear rounded. */
	  rounded: _propTypes2.default.bool,
	
	  /** An image may appear at different sizes. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES),
	
	  /** An image can specify that it needs an additional spacing to separate it from nearby content. */
	  spaced: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['left', 'right'])]),
	
	  /** Specifies the URL of the image. */
	  src: _propTypes2.default.string,
	
	  /** Whether or not to add the ui className. */
	  ui: _propTypes2.default.bool,
	
	  /** An image can specify its vertical alignment. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** The img element width attribute. */
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  /** An image can render wrapped in a `div.ui.image` as alternative HTML markup. */
	  wrapped: _propTypes2.default.bool
	} : {};
	
	Image.defaultProps = {
	  as: 'img',
	  ui: true
	};
	
	Image.create = (0, _lib.createShorthandFactory)(Image, function (value) {
	  return { src: value };
	});
	
	exports.default = Image;

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of images.
	 */
	function ImageGroup(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      size = props.size;
	
	  var classes = (0, _classnames2.default)('ui', size, className, 'images');
	  var rest = (0, _lib.getUnhandledProps)(ImageGroup, props);
	  var ElementType = (0, _lib.getElementType)(ImageGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ImageGroup.handledProps = ['as', 'children', 'className', 'content', 'size'];
	ImageGroup._meta = {
	  name: 'ImageGroup',
	  parent: 'Image',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ImageGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A group of images can be formatted to have the same size. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES)
	} : {};
	
	exports.default = ImageGroup;

/***/ },
/* 1221 */
[4507, 8, 10],
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A label can be grouped.
	 */
	function LabelGroup(props) {
	  var children = props.children,
	      circular = props.circular,
	      className = props.className,
	      color = props.color,
	      content = props.content,
	      size = props.size,
	      tag = props.tag;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(tag, 'tag'), 'labels', className);
	  var rest = (0, _lib.getUnhandledProps)(LabelGroup, props);
	  var ElementType = (0, _lib.getElementType)(LabelGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	LabelGroup.handledProps = ['as', 'children', 'circular', 'className', 'color', 'content', 'size', 'tag'];
	LabelGroup._meta = {
	  name: 'LabelGroup',
	  parent: 'Label',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	LabelGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Labels can share shapes. */
	  circular: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Label group can share colors together. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Label group can share sizes together. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES),
	
	  /** Label group can share tag formatting. */
	  tag: _propTypes2.default.bool
	} : {};
	
	exports.default = LabelGroup;

/***/ },
/* 1223 */
[4513, 405, 44, 8, 10, 247, 643, 416, 417, 644],
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list can contain a sub list.
	 */
	function ListList(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	
	  var rest = (0, _lib.getUnhandledProps)(ListList, props);
	  var ElementType = (0, _lib.getElementType)(ListList, props);
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(ElementType !== 'ul' && ElementType !== 'ol', 'list'), className);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ListList.handledProps = ['as', 'children', 'className', 'content'];
	ListList._meta = {
	  name: 'ListList',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ListList.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = ListList;

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A content sub-component for the Reveal.
	 */
	function RevealContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      hidden = props.hidden,
	      visible = props.visible;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(visible, 'visible'), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(RevealContent, props);
	  var ElementType = (0, _lib.getElementType)(RevealContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	RevealContent.handledProps = ['as', 'children', 'className', 'content', 'hidden', 'visible'];
	RevealContent._meta = {
	  name: 'RevealContent',
	  parent: 'Reveal',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	RevealContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A reveal may contain content that is visible before interaction. */
	  hidden: _propTypes2.default.bool,
	
	  /** A reveal may contain content that is hidden before user interaction. */
	  visible: _propTypes2.default.bool
	} : {};
	
	exports.default = RevealContent;

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _SegmentGroup = __webpack_require__(1227);
	
	var _SegmentGroup2 = _interopRequireDefault(_SegmentGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A segment is used to create a grouping of related content.
	 */
	function Segment(props) {
	  var attached = props.attached,
	      basic = props.basic,
	      children = props.children,
	      circular = props.circular,
	      className = props.className,
	      clearing = props.clearing,
	      color = props.color,
	      compact = props.compact,
	      content = props.content,
	      disabled = props.disabled,
	      floated = props.floated,
	      inverted = props.inverted,
	      loading = props.loading,
	      padded = props.padded,
	      piled = props.piled,
	      raised = props.raised,
	      secondary = props.secondary,
	      size = props.size,
	      stacked = props.stacked,
	      tertiary = props.tertiary,
	      textAlign = props.textAlign,
	      vertical = props.vertical;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(clearing, 'clearing'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(piled, 'piled'), (0, _lib.useKeyOnly)(raised, 'raised'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(stacked, 'stacked'), (0, _lib.useKeyOnly)(tertiary, 'tertiary'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useKeyOrValueAndKey)(padded, 'padded'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(floated, 'floated'), 'segment', className);
	  var rest = (0, _lib.getUnhandledProps)(Segment, props);
	  var ElementType = (0, _lib.getElementType)(Segment, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	Segment.handledProps = ['as', 'attached', 'basic', 'children', 'circular', 'className', 'clearing', 'color', 'compact', 'content', 'disabled', 'floated', 'inverted', 'loading', 'padded', 'piled', 'raised', 'secondary', 'size', 'stacked', 'tertiary', 'textAlign', 'vertical'];
	Segment.Group = _SegmentGroup2.default;
	
	Segment._meta = {
	  name: 'Segment',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Segment.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Attach segment to other content, like a header. */
	  attached: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['top', 'bottom'])]),
	
	  /** A basic segment has no special formatting. */
	  basic: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** A segment can be circular. */
	  circular: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A segment can clear floated content. */
	  clearing: _propTypes2.default.bool,
	
	  /** Segment can be colored. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** A segment may take up only as much space as is necessary. */
	  compact: _propTypes2.default.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A segment may show its content is disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** Segment content can be floated to the left or right. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** A segment can have its colors inverted for contrast. */
	  inverted: _propTypes2.default.bool,
	
	  /** A segment may show its content is being loaded. */
	  loading: _propTypes2.default.bool,
	
	  /** A segment can increase its padding. */
	  padded: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])]),
	
	  /** Formatted to look like a pile of pages. */
	  piled: _propTypes2.default.bool,
	
	  /** A segment may be formatted to raise above the page. */
	  raised: _propTypes2.default.bool,
	
	  /** A segment can be formatted to appear less noticeable. */
	  secondary: _propTypes2.default.bool,
	
	  /** A segment can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** Formatted to show it contains multiple pages. */
	  stacked: _propTypes2.default.bool,
	
	  /** A segment can be formatted to appear even less noticeable. */
	  tertiary: _propTypes2.default.bool,
	
	  /** Formats content to be aligned as part of a vertical group. */
	  textAlign: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified')),
	
	  /** Formats content to be aligned vertically. */
	  vertical: _propTypes2.default.bool
	} : {};
	
	exports.default = Segment;

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of segments can be formatted to appear together.
	 */
	function SegmentGroup(props) {
	  var children = props.children,
	      className = props.className,
	      compact = props.compact,
	      content = props.content,
	      horizontal = props.horizontal,
	      piled = props.piled,
	      raised = props.raised,
	      size = props.size,
	      stacked = props.stacked;
	
	
	  var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(piled, 'piled'), (0, _lib.useKeyOnly)(raised, 'raised'), (0, _lib.useKeyOnly)(stacked, 'stacked'), 'segments', className);
	  var rest = (0, _lib.getUnhandledProps)(SegmentGroup, props);
	  var ElementType = (0, _lib.getElementType)(SegmentGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	SegmentGroup.handledProps = ['as', 'children', 'className', 'compact', 'content', 'horizontal', 'piled', 'raised', 'size', 'stacked'];
	SegmentGroup._meta = {
	  name: 'SegmentGroup',
	  parent: 'Segment',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	SegmentGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A segment may take up only as much space as is necessary. */
	  compact: _propTypes2.default.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Formats content to be aligned horizontally. */
	  horizontal: _propTypes2.default.bool,
	
	  /** Formatted to look like a pile of pages. */
	  piled: _propTypes2.default.bool,
	
	  /** A segment group may be formatted to raise above the page. */
	  raised: _propTypes2.default.bool,
	
	  /** A segment group can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** Formatted to show it contains multiple pages. */
	  stacked: _propTypes2.default.bool
	} : {};
	
	exports.default = SegmentGroup;

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Icon = __webpack_require__(75);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StepContent = __webpack_require__(1229);
	
	var _StepContent2 = _interopRequireDefault(_StepContent);
	
	var _StepDescription = __webpack_require__(645);
	
	var _StepDescription2 = _interopRequireDefault(_StepDescription);
	
	var _StepGroup = __webpack_require__(1230);
	
	var _StepGroup2 = _interopRequireDefault(_StepGroup);
	
	var _StepTitle = __webpack_require__(646);
	
	var _StepTitle2 = _interopRequireDefault(_StepTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A step shows the completion status of an activity in a series of activities.
	 */
	var Step = function (_Component) {
	  (0, _inherits3.default)(Step, _Component);
	
	  function Step() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Step.__proto__ || Object.getPrototypeOf(Step)).call.apply(_ref, [this].concat(args))), _this), _this.computeElementType = function () {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) return 'a';
	    }, _this.handleClick = function (e) {
	      var disabled = _this.props.disabled;
	
	
	      if (!disabled) (0, _invoke3.default)(_this.props, 'onClick', e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          completed = _props.completed,
	          content = _props.content,
	          description = _props.description,
	          disabled = _props.disabled,
	          href = _props.href,
	          icon = _props.icon,
	          link = _props.link,
	          title = _props.title;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(completed, 'completed'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(link, 'link'), 'step', className);
	      var rest = (0, _lib.getUnhandledProps)(Step, this.props);
	      var ElementType = (0, _lib.getElementType)(Step, this.props, this.computeElementType);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      if (!_lib.childrenUtils.isNil(content)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	          content
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	        _Icon2.default.create(icon),
	        _StepContent2.default.create({ description: description, title: title })
	      );
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	Step._meta = {
	  name: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	Step.Content = _StepContent2.default;
	Step.Description = _StepDescription2.default;
	Step.Group = _StepGroup2.default;
	Step.Title = _StepTitle2.default;
	Step.handledProps = ['active', 'as', 'children', 'className', 'completed', 'content', 'description', 'disabled', 'href', 'icon', 'link', 'onClick', 'ordered', 'title'];
	Step.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A step can be highlighted as active. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A step can show that a user has completed it. */
	  completed: _propTypes2.default.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for StepDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Show that the Loader is inactive. */
	  disabled: _propTypes2.default.bool,
	
	  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
	  href: _propTypes2.default.string,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** A step can be link. */
	  link: _propTypes2.default.bool,
	
	  /**
	   * Called on click. When passed, the component will render as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /** A step can show a ordered sequence of steps. Passed from StepGroup. */
	  ordered: _propTypes2.default.bool,
	
	  /** Shorthand for StepTitle. */
	  title: _lib.customPropTypes.itemShorthand
	} : {};
	
	
	Step.create = (0, _lib.createShorthandFactory)(Step, function (content) {
	  return { content: content };
	});
	
	exports.default = Step;

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _StepDescription = __webpack_require__(645);
	
	var _StepDescription2 = _interopRequireDefault(_StepDescription);
	
	var _StepTitle = __webpack_require__(646);
	
	var _StepTitle2 = _interopRequireDefault(_StepTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A step can contain a content.
	 */
	function StepContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      title = props.title;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(StepContent, props);
	  var ElementType = (0, _lib.getElementType)(StepContent, props);
	
	  if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	  if (!_lib.childrenUtils.isNil(content)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content
	  );
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _StepTitle2.default.create(title),
	    _StepDescription2.default.create(description)
	  );
	}
	
	StepContent.handledProps = ['as', 'children', 'className', 'content', 'description', 'title'];
	StepContent._meta = {
	  name: 'StepContent',
	  parent: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	StepContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for StepDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for StepTitle. */
	  title: _lib.customPropTypes.itemShorthand
	} : {};
	
	StepContent.create = (0, _lib.createShorthandFactory)(StepContent, function (content) {
	  return { content: content };
	});
	
	exports.default = StepContent;

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _values2 = __webpack_require__(305);
	
	var _values3 = _interopRequireDefault(_values2);
	
	var _keys2 = __webpack_require__(97);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(69);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _pickBy2 = __webpack_require__(2769);
	
	var _pickBy3 = _interopRequireDefault(_pickBy2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Step = __webpack_require__(1228);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberMap = (0, _pickBy3.default)(_lib.numberToWordMap, function (val, key) {
	  return key <= 8;
	});
	
	/**
	 * A set of steps.
	 */
	function StepGroup(props) {
	  var attached = props.attached,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      fluid = props.fluid,
	      items = props.items,
	      ordered = props.ordered,
	      size = props.size,
	      stackable = props.stackable,
	      unstackable = props.unstackable,
	      vertical = props.vertical,
	      widths = props.widths;
	
	  var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(ordered, 'ordered'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useValueAndKey)(stackable, 'stackable'), (0, _lib.useWidthProp)(widths), 'steps', className);
	  var rest = (0, _lib.getUnhandledProps)(StepGroup, props);
	  var ElementType = (0, _lib.getElementType)(StepGroup, props);
	
	  if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	  if (!_lib.childrenUtils.isNil(content)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content
	  );
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _map3.default)(items, function (item) {
	      return _Step2.default.create(item);
	    })
	  );
	}
	
	StepGroup.handledProps = ['as', 'attached', 'children', 'className', 'content', 'fluid', 'items', 'ordered', 'size', 'stackable', 'unstackable', 'vertical', 'widths'];
	StepGroup._meta = {
	  name: 'StepGroup',
	  parent: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	StepGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Steps can be attached to other elements. */
	  attached: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['top', 'bottom'])]),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A fluid step takes up the width of its container. */
	  fluid: _propTypes2.default.bool,
	
	  /** Shorthand array of props for Step. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A step can show a ordered sequence of steps. */
	  ordered: _propTypes2.default.bool,
	
	  /** Steps can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** A step can stack vertically only on smaller screens. */
	  stackable: _propTypes2.default.oneOf(['tablet']),
	
	  /** A step can prevent itself from stacking on mobile. */
	  unstackable: _propTypes2.default.bool,
	
	  /** A step can be displayed stacked vertically. */
	  vertical: _propTypes2.default.bool,
	
	  /** Steps can be divided evenly inside their parent. */
	  widths: _propTypes2.default.oneOf([].concat((0, _toConsumableArray3.default)((0, _keys3.default)(numberMap)), (0, _toConsumableArray3.default)((0, _keys3.default)(numberMap).map(Number)), (0, _toConsumableArray3.default)((0, _values3.default)(numberMap))))
	} : {};
	
	exports.default = StepGroup;

/***/ },
/* 1231 */
[4522, 2752, 2741, 2738, 401, 2736, 2740, 1028, 2757],
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copy of sindre's leven, wrapped in dead code elimination for production
	// https://github.com/sindresorhus/leven/blob/master/index.js
	/* eslint-disable complexity, import/no-mutable-exports, no-multi-assign, no-nested-ternary, no-plusplus */
	
	var leven = function leven() {
	  return 0;
	};
	
	if (false) {
	  var arr = [];
	  var charCodeCache = [];
	
	  leven = function leven(a, b) {
	    if (a === b) return 0;
	
	    var aLen = a.length;
	    var bLen = b.length;
	
	    if (aLen === 0) return bLen;
	    if (bLen === 0) return aLen;
	
	    var bCharCode = void 0;
	    var ret = void 0;
	    var tmp = void 0;
	    var tmp2 = void 0;
	    var i = 0;
	    var j = 0;
	
	    while (i < aLen) {
	      charCodeCache[i] = a.charCodeAt(i);
	      arr[i] = ++i;
	    }
	
	    while (j < bLen) {
	      bCharCode = b.charCodeAt(j);
	      tmp = j++;
	      ret = j;
	
	      for (i = 0; i < aLen; i++) {
	        tmp2 = bCharCode === charCodeCache[i] ? tmp : tmp + 1;
	        tmp = arr[i];
	        ret = arr[i] = tmp > ret ? tmp2 > ret ? ret + 1 : tmp2 : tmp2 > tmp ? tmp + 1 : tmp2;
	      }
	    }
	
	    return ret;
	  };
	}
	
	exports.default = leven;

/***/ },
/* 1233 */
[4531, 74, 623, 44, 43, 149, 8, 10, 649, 650],
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A dimmable sub-component for Dimmer.
	 */
	function DimmerDimmable(props) {
	  var blurring = props.blurring,
	      className = props.className,
	      children = props.children,
	      content = props.content,
	      dimmed = props.dimmed;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(blurring, 'blurring'), (0, _lib.useKeyOnly)(dimmed, 'dimmed'), 'dimmable', className);
	  var rest = (0, _lib.getUnhandledProps)(DimmerDimmable, props);
	  var ElementType = (0, _lib.getElementType)(DimmerDimmable, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	DimmerDimmable.handledProps = ['as', 'blurring', 'children', 'className', 'content', 'dimmed'];
	DimmerDimmable._meta = {
	  name: 'DimmerDimmable',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Dimmer'
	};
	
	DimmerDimmable.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A dimmable element can blur its contents. */
	  blurring: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Controls whether or not the dim is displayed. */
	  dimmed: _propTypes2.default.bool
	} : {};
	
	exports.default = DimmerDimmable;

/***/ },
/* 1235 */
[4536, 2859],
/* 1236 */
[4537, 8, 10],
/* 1237 */
[4538, 8, 10, 75],
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(74);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Flag = __webpack_require__(1215);
	
	var _Flag2 = _interopRequireDefault(_Flag);
	
	var _Icon = __webpack_require__(75);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Image = __webpack_require__(247);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Label = __webpack_require__(415);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item sub-component for Dropdown component.
	 */
	var DropdownItem = function (_Component) {
	  (0, _inherits3.default)(DropdownItem, _Component);
	
	  function DropdownItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropdownItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DropdownItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content,
	          disabled = _props.disabled,
	          description = _props.description,
	          flag = _props.flag,
	          icon = _props.icon,
	          image = _props.image,
	          label = _props.label,
	          selected = _props.selected,
	          text = _props.text;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(selected, 'selected'), 'item', className);
	      // add default dropdown icon if item contains another menu
	      var iconName = (0, _isNil3.default)(icon) ? _lib.childrenUtils.someByType(children, 'DropdownMenu') && 'dropdown' : icon;
	      var rest = (0, _lib.getUnhandledProps)(DropdownItem, this.props);
	      var ElementType = (0, _lib.getElementType)(DropdownItem, this.props);
	      var ariaOptions = {
	        role: 'option',
	        'aria-disabled': disabled,
	        'aria-checked': active,
	        'aria-selected': selected
	      };
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, ariaOptions, { className: classes, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      var flagElement = _Flag2.default.create(flag);
	      var iconElement = _Icon2.default.create(iconName);
	      var imageElement = _Image2.default.create(image);
	      var labelElement = _Label2.default.create(label);
	      var descriptionElement = (0, _lib.createShorthand)('span', function (val) {
	        return { children: val };
	      }, description, { defaultProps: { className: 'description' } });
	      var textElement = (0, _lib.createShorthand)('span', function (val) {
	        return { children: val };
	      }, _lib.childrenUtils.isNil(content) ? text : content, { defaultProps: { className: 'text' } });
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, ariaOptions, { className: classes, onClick: this.handleClick }),
	        imageElement,
	        iconElement,
	        flagElement,
	        labelElement,
	        descriptionElement,
	        textElement
	      );
	    }
	  }]);
	  return DropdownItem;
	}(_react.Component);
	
	DropdownItem._meta = {
	  name: 'DropdownItem',
	  parent: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	DropdownItem.handledProps = ['active', 'as', 'children', 'className', 'content', 'description', 'disabled', 'flag', 'icon', 'image', 'label', 'onClick', 'selected', 'text', 'value'];
	DropdownItem.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Style as the currently chosen item. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Additional text with less emphasis. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** A dropdown item can be disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** Shorthand for Flag. */
	  flag: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for Image. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for Label. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * The item currently selected by keyboard shortcut.
	   * This is not the active item.
	   */
	  selected: _propTypes2.default.bool,
	
	  /** Display text. */
	  text: _lib.customPropTypes.contentShorthand,
	
	  /** Stored value. */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	} : {};
	
	
	DropdownItem.create = (0, _lib.createShorthandFactory)(DropdownItem, function (opts) {
	  return opts;
	});
	
	exports.default = DropdownItem;

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A dropdown menu can contain a menu.
	 */
	function DropdownMenu(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      scrolling = props.scrolling;
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(scrolling, 'scrolling'), 'menu transition', className);
	  var rest = (0, _lib.getUnhandledProps)(DropdownMenu, props);
	  var ElementType = (0, _lib.getElementType)(DropdownMenu, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	DropdownMenu.handledProps = ['as', 'children', 'className', 'content', 'scrolling'];
	DropdownMenu._meta = {
	  name: 'DropdownMenu',
	  parent: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	
	DropdownMenu.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A dropdown menu can scroll. */
	  scrolling: _propTypes2.default.bool
	} : {};
	
	exports.default = DropdownMenu;

/***/ },
/* 1240 */
[4539, 44, 109, 8, 10],
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _map2 = __webpack_require__(69);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Button = __webpack_require__(413);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A modal can contain a row of actions.
	 */
	var ModalActions = function (_Component) {
	  (0, _inherits3.default)(ModalActions, _Component);
	
	  function ModalActions() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ModalActions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModalActions.__proto__ || Object.getPrototypeOf(ModalActions)).call.apply(_ref, [this].concat(args))), _this), _this.handleButtonOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e, buttonProps) {
	          (0, _invoke3.default)(predefinedProps, 'onClick', e, buttonProps);
	          (0, _invoke3.default)(_this.props, 'onActionClick', e, buttonProps);
	        }
	      };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ModalActions, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          actions = _props.actions,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content;
	
	      var classes = (0, _classnames2.default)('actions', className);
	      var rest = (0, _lib.getUnhandledProps)(ModalActions, this.props);
	      var ElementType = (0, _lib.getElementType)(ModalActions, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        children
	      );
	      if (!_lib.childrenUtils.isNil(content)) return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        content
	      );
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        (0, _map3.default)(actions, function (action) {
	          return _Button2.default.create(action, { overrideProps: _this2.handleButtonOverrides });
	        })
	      );
	    }
	  }]);
	  return ModalActions;
	}(_react.Component);
	
	ModalActions._meta = {
	  name: 'ModalActions',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Modal'
	};
	ModalActions.handledProps = ['actions', 'as', 'children', 'className', 'content', 'onActionClick'];
	exports.default = ModalActions;
	ModalActions.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Array of shorthand buttons. */
	  actions: _lib.customPropTypes.collectionShorthand,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /**
	   * Action onClick handler when using shorthand `actions`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props from the clicked action.
	   */
	  onActionClick: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes2.default.func])
	} : {};
	
	
	ModalActions.create = (0, _lib.createShorthandFactory)(ModalActions, function (actions) {
	  return { actions: actions };
	});

/***/ },
/* 1242 */
[4542, 8, 10],
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A modal can have a header.
	 */
	function ModalDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('description', className);
	  var rest = (0, _lib.getUnhandledProps)(ModalDescription, props);
	  var ElementType = (0, _lib.getElementType)(ModalDescription, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ModalDescription.handledProps = ['as', 'children', 'className', 'content'];
	ModalDescription._meta = {
	  name: 'ModalDescription',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Modal'
	};
	
	ModalDescription.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = ModalDescription;

/***/ },
/* 1244 */
[4543, 8, 10],
/* 1245 */
[4544, 2863],
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = PopupContent;
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A PopupContent displays the content body of a Popover.
	 */
	function PopupContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(PopupContent, props);
	  var ElementType = (0, _lib.getElementType)(PopupContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	PopupContent.handledProps = ['as', 'children', 'className', 'content'];
	PopupContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** The content of the Popup */
	  children: _propTypes2.default.node,
	
	  /** Classes to add to the Popup content className. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	PopupContent._meta = {
	  name: 'PopupContent',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Popup'
	};
	
	PopupContent.create = (0, _lib.createShorthandFactory)(PopupContent, function (children) {
	  return { children: children };
	});

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = PopupHeader;
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A PopupHeader displays a header in a Popover.
	 */
	function PopupHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(PopupHeader, props);
	  var ElementType = (0, _lib.getElementType)(PopupHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	PopupHeader.handledProps = ['as', 'children', 'className', 'content'];
	PopupHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	PopupHeader._meta = {
	  name: 'PopupHeader',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Popup'
	};
	
	PopupHeader.create = (0, _lib.createShorthandFactory)(PopupHeader, function (children) {
	  return { children: children };
	});

/***/ },
/* 1248 */
[4548, 8, 10],
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SearchCategory(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      renderer = props.renderer;
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), 'category', className);
	  var rest = (0, _lib.getUnhandledProps)(SearchCategory, props);
	  var ElementType = (0, _lib.getElementType)(SearchCategory, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _react2.default.createElement(
	      'div',
	      { className: 'name' },
	      renderer(props)
	    ),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	SearchCategory.handledProps = ['active', 'as', 'children', 'className', 'content', 'name', 'renderer', 'results'];
	SearchCategory._meta = {
	  name: 'SearchCategory',
	  parent: 'Search',
	  type: _lib.META.TYPES.MODULE
	};
	
	SearchCategory.defaultProps = {
	  renderer: function renderer(_ref) {
	    var name = _ref.name;
	    return name;
	  }
	};
	
	SearchCategory.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** The item currently selected by keyboard shortcut. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Display name. */
	  name: _propTypes2.default.string,
	
	  /**
	   * Renders the category contents.
	   *
	   * @param {object} props - The SearchCategory props object.
	   * @returns {*} - Renderable category contents.
	   */
	  renderer: _propTypes2.default.func,
	
	  /** Array of Search.Result props. */
	  results: _propTypes2.default.array
	} : {};
	
	exports.default = SearchCategory;

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Note: You technically only need the 'content' wrapper when there's an
	// image. However, optionally wrapping it makes this function a lot more
	// complicated and harder to read. Since always wrapping it doesn't affect
	// the style in any way let's just do that.
	//
	// Note: To avoid requiring a wrapping div, we return an array here so to
	// prevent rendering issues each node needs a unique key.
	var defaultRenderer = function defaultRenderer(_ref) {
	  var image = _ref.image,
	      price = _ref.price,
	      title = _ref.title,
	      description = _ref.description;
	  return [image && _react2.default.createElement(
	    'div',
	    { key: 'image', className: 'image' },
	    (0, _lib.createHTMLImage)(image)
	  ), _react2.default.createElement(
	    'div',
	    { key: 'content', className: 'content' },
	    price && _react2.default.createElement(
	      'div',
	      { className: 'price' },
	      price
	    ),
	    title && _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      title
	    ),
	    description && _react2.default.createElement(
	      'div',
	      { className: 'description' },
	      description
	    )
	  )];
	};
	
	defaultRenderer.handledProps = [];
	
	var SearchResult = function (_Component) {
	  (0, _inherits3.default)(SearchResult, _Component);
	
	  function SearchResult() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchResult);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = SearchResult.__proto__ || Object.getPrototypeOf(SearchResult)).call.apply(_ref2, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchResult, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          className = _props.className,
	          renderer = _props.renderer;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), 'result', className);
	      var rest = (0, _lib.getUnhandledProps)(SearchResult, this.props);
	      var ElementType = (0, _lib.getElementType)(SearchResult, this.props);
	
	      // Note: You technically only need the 'content' wrapper when there's an
	      // image. However, optionally wrapping it makes this function a lot more
	      // complicated and harder to read. Since always wrapping it doesn't affect
	      // the style in any way let's just do that.
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        renderer(this.props)
	      );
	    }
	  }]);
	  return SearchResult;
	}(_react.Component);
	
	SearchResult.defaultProps = {
	  renderer: defaultRenderer
	};
	SearchResult._meta = {
	  name: 'SearchResult',
	  parent: 'Search',
	  type: _lib.META.TYPES.MODULE
	};
	SearchResult.handledProps = ['active', 'as', 'className', 'content', 'description', 'id', 'image', 'onClick', 'price', 'renderer', 'title'];
	exports.default = SearchResult;
	SearchResult.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** The item currently selected by keyboard shortcut. */
	  active: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Additional text with less emphasis. */
	  description: _propTypes2.default.string,
	
	  /** A unique identifier. */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** Add an image to the item. */
	  image: _propTypes2.default.string,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /** Customized text for price. */
	  price: _propTypes2.default.string,
	
	  /**
	   * Renders the result contents.
	   *
	   * @param {object} props - The SearchResult props object.
	   * @returns {*} - Renderable result contents.
	   */
	  renderer: _propTypes2.default.func,
	
	  /** Display title. */
	  title: _propTypes2.default.string
	} : {};

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SearchResults(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('results transition', className);
	  var rest = (0, _lib.getUnhandledProps)(SearchResults, props);
	  var ElementType = (0, _lib.getElementType)(SearchResults, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	SearchResults.handledProps = ['as', 'children', 'className', 'content'];
	SearchResults._meta = {
	  name: 'SearchResults',
	  parent: 'Search',
	  type: _lib.META.TYPES.MODULE
	};
	
	SearchResults.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = SearchResults;

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A pushable sub-component for Sidebar.
	 */
	function SidebarPushable(props) {
	  var className = props.className,
	      children = props.children,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('pushable', className);
	  var rest = (0, _lib.getUnhandledProps)(SidebarPushable, props);
	  var ElementType = (0, _lib.getElementType)(SidebarPushable, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	SidebarPushable.handledProps = ['as', 'children', 'className', 'content'];
	SidebarPushable._meta = {
	  name: 'SidebarPushable',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Sidebar'
	};
	
	SidebarPushable.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = SidebarPushable;

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A pushable sub-component for Sidebar.
	 */
	function SidebarPusher(props) {
	  var className = props.className,
	      dimmed = props.dimmed,
	      children = props.children,
	      content = props.content;
	
	
	  var classes = (0, _classnames2.default)('pusher', (0, _lib.useKeyOnly)(dimmed, 'dimmed'), className);
	  var rest = (0, _lib.getUnhandledProps)(SidebarPusher, props);
	  var ElementType = (0, _lib.getElementType)(SidebarPusher, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	SidebarPusher.handledProps = ['as', 'children', 'className', 'content', 'dimmed'];
	SidebarPusher._meta = {
	  name: 'SidebarPusher',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Sidebar'
	};
	
	SidebarPusher.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Controls whether or not the dim is displayed. */
	  dimmed: _propTypes2.default.bool
	} : {};
	
	exports.default = SidebarPusher;

/***/ },
/* 1254 */
[4554, 8, 10, 1226],
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _includes2 = __webpack_require__(149);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _get2 = __webpack_require__(109);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _lib = __webpack_require__(10);
	
	var _TransitionGroup = __webpack_require__(1256);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TRANSITION_TYPE = {
	  ENTERING: 'show',
	  EXITING: 'hide'
	
	  /**
	   * A transition is an animation usually used to move content in or out of view.
	   */
	};
	var Transition = function (_Component) {
	  (0, _inherits3.default)(Transition, _Component);
	
	  function Transition() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, Transition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Transition.__proto__ || Object.getPrototypeOf(Transition)).call.apply(_ref, [this].concat(args)));
	
	    _initialiseProps.call(_this);
	
	    var _this$computeInitialS = _this.computeInitialStatuses(),
	        status = _this$computeInitialS.initial,
	        next = _this$computeInitialS.next;
	
	    _this.nextStatus = next;
	    _this.state = { status: status };
	    return _this;
	  }
	
	  // ----------------------------------------
	  // Lifecycle
	  // ----------------------------------------
	
	  (0, _createClass3.default)(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      this.mounted = true;
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _computeStatuses = this.computeStatuses(nextProps),
	          status = _computeStatuses.current,
	          next = _computeStatuses.next;
	
	      this.nextStatus = next;
	      if (status) this.setSafeState({ status: status });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	
	      this.mounted = false;
	    }
	
	    // ----------------------------------------
	    // Callback handling
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Helpers
	    // ----------------------------------------
	
	  }, {
	    key: 'render',
	
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	    value: function render() {
	      var children = this.props.children;
	      var status = this.state.status;
	
	
	      if (status === Transition.UNMOUNTED) return null;
	      return (0, _react.cloneElement)(children, {
	        className: this.computeClasses(),
	        style: this.computeStyle()
	      });
	    }
	  }]);
	  return Transition;
	}(_react.Component);
	
	Transition.defaultProps = {
	  animation: 'fade',
	  duration: 500,
	  visible: true,
	  mountOnShow: true,
	  transitionOnMount: false,
	  unmountOnHide: false
	};
	Transition._meta = {
	  name: 'Transition',
	  type: _lib.META.TYPES.MODULE
	};
	Transition.ENTERED = 'ENTERED';
	Transition.ENTERING = 'ENTERING';
	Transition.EXITED = 'EXITED';
	Transition.EXITING = 'EXITING';
	Transition.UNMOUNTED = 'UNMOUNTED';
	Transition.Group = _TransitionGroup2.default;
	Transition.handledProps = ['animation', 'children', 'duration', 'mountOnShow', 'onComplete', 'onHide', 'onShow', 'onStart', 'reactKey', 'transitionOnMount', 'unmountOnHide', 'visible'];
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.handleStart = function () {
	    var duration = _this2.props.duration;
	
	    var status = _this2.nextStatus;
	
	    _this2.nextStatus = null;
	    _this2.setSafeState({ status: status, animating: true }, function () {
	      (0, _invoke3.default)(_this2.props, 'onStart', null, (0, _extends3.default)({}, _this2.props, { status: status }));
	      setTimeout(_this2.handleComplete, (0, _lib.normalizeTransitionDuration)(duration, 'show'));
	    });
	  };
	
	  this.handleComplete = function () {
	    var current = _this2.state.status;
	
	
	    (0, _invoke3.default)(_this2.props, 'onComplete', null, (0, _extends3.default)({}, _this2.props, { status: current }));
	
	    if (_this2.nextStatus) {
	      _this2.handleStart();
	      return;
	    }
	
	    var status = _this2.computeCompletedStatus();
	    var callback = current === Transition.ENTERING ? 'onShow' : 'onHide';
	
	    _this2.setSafeState({ status: status, animating: false }, function () {
	      (0, _invoke3.default)(_this2.props, callback, null, (0, _extends3.default)({}, _this2.props, { status: status }));
	    });
	  };
	
	  this.updateStatus = function () {
	    var animating = _this2.state.animating;
	
	
	    if (_this2.nextStatus) {
	      _this2.nextStatus = _this2.computeNextStatus();
	      if (!animating) _this2.handleStart();
	    }
	  };
	
	  this.computeClasses = function () {
	    var _props = _this2.props,
	        animation = _props.animation,
	        children = _props.children;
	    var _state = _this2.state,
	        animating = _state.animating,
	        status = _state.status;
	
	
	    var childClasses = (0, _get3.default)(children, 'props.className');
	    var directional = (0, _includes3.default)(_lib.SUI.DIRECTIONAL_TRANSITIONS, animation);
	
	    if (directional) {
	      return (0, _classnames2.default)(animation, childClasses, (0, _lib.useKeyOnly)(animating, 'animating'), (0, _lib.useKeyOnly)(status === Transition.ENTERING, 'in'), (0, _lib.useKeyOnly)(status === Transition.EXITING, 'out'), (0, _lib.useKeyOnly)(status === Transition.EXITED, 'hidden'), (0, _lib.useKeyOnly)(status !== Transition.EXITED, 'visible'), 'transition');
	    }
	
	    return (0, _classnames2.default)(animation, childClasses, (0, _lib.useKeyOnly)(animating, 'animating transition'));
	  };
	
	  this.computeCompletedStatus = function () {
	    var unmountOnHide = _this2.props.unmountOnHide;
	    var status = _this2.state.status;
	
	
	    if (status === Transition.ENTERING) return Transition.ENTERED;
	    return unmountOnHide ? Transition.UNMOUNTED : Transition.EXITED;
	  };
	
	  this.computeInitialStatuses = function () {
	    var _props2 = _this2.props,
	        visible = _props2.visible,
	        mountOnShow = _props2.mountOnShow,
	        transitionOnMount = _props2.transitionOnMount,
	        unmountOnHide = _props2.unmountOnHide;
	
	
	    if (visible) {
	      if (transitionOnMount) {
	        return {
	          initial: Transition.EXITED,
	          next: Transition.ENTERING
	        };
	      }
	      return { initial: Transition.ENTERED };
	    }
	
	    if (mountOnShow || unmountOnHide) return { initial: Transition.UNMOUNTED };
	    return { initial: Transition.EXITED };
	  };
	
	  this.computeNextStatus = function () {
	    var _state2 = _this2.state,
	        animating = _state2.animating,
	        status = _state2.status;
	
	
	    if (animating) return status === Transition.ENTERING ? Transition.EXITING : Transition.ENTERING;
	    return status === Transition.ENTERED ? Transition.EXITING : Transition.ENTERING;
	  };
	
	  this.computeStatuses = function (props) {
	    var status = _this2.state.status;
	    var visible = props.visible;
	
	
	    if (visible) {
	      return {
	        current: status === Transition.UNMOUNTED && Transition.EXITED,
	        next: status !== Transition.ENTERING && status !== Transition.ENTERED && Transition.ENTERING
	      };
	    }
	
	    return {
	      next: (status === Transition.ENTERING || status === Transition.ENTERED) && Transition.EXITING
	    };
	  };
	
	  this.computeStyle = function () {
	    var _props3 = _this2.props,
	        children = _props3.children,
	        duration = _props3.duration;
	    var status = _this2.state.status;
	
	
	    var childStyle = (0, _get3.default)(children, 'props.style');
	    var type = TRANSITION_TYPE[status];
	    var animationDuration = type && (0, _lib.normalizeTransitionDuration)(duration, type) + 'ms';
	
	    return (0, _extends3.default)({}, childStyle, { animationDuration: animationDuration });
	  };
	
	  this.setSafeState = function () {
	    return _this2.mounted && _this2.setState.apply(_this2, arguments);
	  };
	};
	
	exports.default = Transition;
	Transition.propTypes =  false ? {
	  /** Named animation event to used. Must be defined in CSS. */
	  animation: _propTypes2.default.oneOf(_lib.SUI.TRANSITIONS),
	
	  /** Primary content. */
	  children: _propTypes2.default.element.isRequired,
	
	  /** Duration of the CSS transition animation in milliseconds. */
	  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	    hide: _propTypes2.default.number,
	    show: _propTypes2.default.number
	  }), _propTypes2.default.string]),
	
	  /** Show the component; triggers the enter or exit animation. */
	  visible: _propTypes2.default.bool,
	
	  /** Wait until the first "enter" transition to mount the component (add it to the DOM). */
	  mountOnShow: _propTypes2.default.bool,
	
	  /**
	   * Callback on each transition that changes visibility to shown.
	   *
	   * @param {null}
	   * @param {object} data - All props with status.
	   */
	  onComplete: _propTypes2.default.func,
	
	  /**
	   * Callback on each transition that changes visibility to hidden.
	   *
	   * @param {null}
	   * @param {object} data - All props with status.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Callback on each transition that changes visibility to shown.
	   *
	   * @param {null}
	   * @param {object} data - All props with status.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * Callback on animation start.
	   *
	   * @param {null}
	   * @param {object} data - All props with status.
	   */
	  onStart: _propTypes2.default.func,
	
	  /** React's key of the element. */
	  reactKey: _propTypes2.default.string,
	
	  /** Run the enter animation when the component mounts, if it is initially shown. */
	  transitionOnMount: _propTypes2.default.bool,
	
	  /** Unmount the component (remove it from the DOM) when it is not shown. */
	  unmountOnHide: _propTypes2.default.bool
	} : {};

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _values2 = __webpack_require__(305);
	
	var _values3 = _interopRequireDefault(_values2);
	
	var _get2 = __webpack_require__(109);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _has2 = __webpack_require__(178);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _forEach2 = __webpack_require__(246);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	var _mapValues2 = __webpack_require__(1034);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Transition = __webpack_require__(1255);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A Transition.Group animates children as they mount and unmount.
	 */
	var TransitionGroup = function (_React$Component) {
	  (0, _inherits3.default)(TransitionGroup, _React$Component);
	
	  function TransitionGroup() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, TransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransitionGroup.__proto__ || Object.getPrototypeOf(TransitionGroup)).call.apply(_ref, [this].concat(args)));
	
	    _initialiseProps.call(_this);
	
	    var children = _this.props.children;
	
	    _this.state = { children: (0, _mapValues3.default)((0, _lib.getChildMapping)(children), function (child) {
	        return _this.wrapChild(child);
	      }) };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TransitionGroup, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var prevMapping = this.state.children;
	
	      var nextMapping = (0, _lib.getChildMapping)(nextProps.children);
	      var children = (0, _lib.mergeChildMappings)(prevMapping, nextMapping);
	
	      (0, _forEach3.default)(children, function (child, key) {
	        var hasPrev = (0, _has3.default)(prevMapping, key);
	        var hasNext = (0, _has3.default)(nextMapping, key);
	        var prevChild = prevMapping[key];
	
	        var isLeaving = !(0, _get3.default)(prevChild, 'props.visible');
	
	        // Heads up!
	        // An item is new (entering), it will be picked from `nextChildren`, so it should be wrapped
	        if (hasNext && (!hasPrev || isLeaving)) {
	          children[key] = _this2.wrapChild(child, { transitionOnMount: true });
	          return;
	        }
	
	        // Heads up!
	        // An item is old (exiting), it will be picked from `prevChildren`, so it has been already
	        // wrapped, so should be only updated
	        if (!hasNext && hasPrev && !isLeaving) {
	          children[key] = (0, _react.cloneElement)(prevChild, { visible: false });
	          return;
	        }
	
	        // Heads up!
	        // An item item hasn't changed transition states, but it will be picked from `nextChildren`,
	        // so we should wrap it again
	        var _prevChild$props = prevChild.props,
	            visible = _prevChild$props.visible,
	            transitionOnMount = _prevChild$props.transitionOnMount;
	
	
	        children[key] = _this2.wrapChild(child, { transitionOnMount: transitionOnMount, visible: visible });
	      });
	
	      this.setState({ children: children });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.state.children;
	
	      var ElementType = (0, _lib.getElementType)(TransitionGroup, this.props);
	      var rest = (0, _lib.getUnhandledProps)(TransitionGroup, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        rest,
	        (0, _values3.default)(children)
	      );
	    }
	  }]);
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.defaultProps = {
	  animation: 'fade',
	  duration: 500
	};
	TransitionGroup._meta = {
	  name: 'TransitionGroup',
	  parent: 'Transition',
	  type: _lib.META.TYPES.MODULE
	};
	TransitionGroup.handledProps = ['animation', 'as', 'children', 'duration'];
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleOnHide = function (nothing, childProps) {
	    var reactKey = childProps.reactKey;
	
	
	    _this3.setState(function (state) {
	      var children = (0, _extends3.default)({}, state.children);
	      delete children[reactKey];
	
	      return { children: children };
	    });
	  };
	
	  this.wrapChild = function (child) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _props = _this3.props,
	        animation = _props.animation,
	        duration = _props.duration;
	    var key = child.key;
	    var _options$visible = options.visible,
	        visible = _options$visible === undefined ? true : _options$visible,
	        _options$transitionOn = options.transitionOnMount,
	        transitionOnMount = _options$transitionOn === undefined ? false : _options$transitionOn;
	
	
	    return _react2.default.createElement(
	      _Transition2.default,
	      {
	        animation: animation,
	        duration: duration,
	        key: key,
	        onHide: _this3.handleOnHide,
	        reactKey: key,
	        transitionOnMount: transitionOnMount,
	        visible: visible
	      },
	      child
	    );
	  };
	};
	
	exports.default = TransitionGroup;
	TransitionGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Named animation event to used. Must be defined in CSS. */
	  animation: _propTypes2.default.oneOf(_lib.SUI.TRANSITIONS),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Duration of the CSS transition animation in milliseconds. */
	  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	    hide: _propTypes2.default.number.isRequired,
	    show: _propTypes2.default.number.isRequired
	  }), _propTypes2.default.string])
	} : {};

/***/ },
/* 1257 */
[4556, 1255],
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Image = __webpack_require__(247);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _CardContent = __webpack_require__(1259);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	var _CardDescription = __webpack_require__(652);
	
	var _CardDescription2 = _interopRequireDefault(_CardDescription);
	
	var _CardGroup = __webpack_require__(1260);
	
	var _CardGroup2 = _interopRequireDefault(_CardGroup);
	
	var _CardHeader = __webpack_require__(653);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _CardMeta = __webpack_require__(654);
	
	var _CardMeta2 = _interopRequireDefault(_CardMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A card displays site content in a manner similar to a playing card.
	 */
	var Card = function (_Component) {
	  (0, _inherits3.default)(Card, _Component);
	
	  function Card() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Card);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || Object.getPrototypeOf(Card)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Card, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          centered = _props.centered,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          content = _props.content,
	          description = _props.description,
	          extra = _props.extra,
	          fluid = _props.fluid,
	          header = _props.header,
	          href = _props.href,
	          image = _props.image,
	          link = _props.link,
	          meta = _props.meta,
	          onClick = _props.onClick,
	          raised = _props.raised;
	
	
	      var classes = (0, _classnames2.default)('ui', color, (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(raised, 'raised'), 'card', className);
	      var rest = (0, _lib.getUnhandledProps)(Card, this.props);
	      var ElementType = (0, _lib.getElementType)(Card, this.props, function () {
	        if (onClick) return 'a';
	      });
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	          children
	        );
	      }
	      if (!_lib.childrenUtils.isNil(content)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	          content
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	        _Image2.default.create(image),
	        (description || header || meta) && _react2.default.createElement(_CardContent2.default, { description: description, header: header, meta: meta }),
	        extra && _react2.default.createElement(
	          _CardContent2.default,
	          { extra: true },
	          extra
	        )
	      );
	    }
	  }]);
	  return Card;
	}(_react.Component);
	
	Card._meta = {
	  name: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	Card.Content = _CardContent2.default;
	Card.Description = _CardDescription2.default;
	Card.Group = _CardGroup2.default;
	Card.Header = _CardHeader2.default;
	Card.Meta = _CardMeta2.default;
	Card.handledProps = ['as', 'centered', 'children', 'className', 'color', 'content', 'description', 'extra', 'fluid', 'header', 'href', 'image', 'link', 'meta', 'onClick', 'raised'];
	exports.default = Card;
	Card.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A Card can center itself inside its container. */
	  centered: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A Card can be formatted to display different colors. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for CardDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for primary content of CardContent. */
	  extra: _lib.customPropTypes.contentShorthand,
	
	  /** A Card can be formatted to take up the width of its container. */
	  fluid: _propTypes2.default.bool,
	
	  /** Shorthand for CardHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
	  href: _propTypes2.default.string,
	
	  /** A card can contain an Image component. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** A card can be formatted to link to other content. */
	  link: _propTypes2.default.bool,
	
	  /** Shorthand for CardMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /**
	   * Called on click. When passed, the component renders as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /** A Card can be formatted to raise above the page. */
	  raised: _propTypes2.default.bool
	} : {};

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _CardDescription = __webpack_require__(652);
	
	var _CardDescription2 = _interopRequireDefault(_CardDescription);
	
	var _CardHeader = __webpack_require__(653);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _CardMeta = __webpack_require__(654);
	
	var _CardMeta2 = _interopRequireDefault(_CardMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A card can contain blocks of content or extra content meant to be formatted separately from the main content.
	 */
	function CardContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      extra = props.extra,
	      header = props.header,
	      meta = props.meta,
	      textAlign = props.textAlign;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(extra, 'extra'), (0, _lib.useTextAlignProp)(textAlign), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(CardContent, props);
	  var ElementType = (0, _lib.getElementType)(CardContent, props);
	
	  if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	  if (!_lib.childrenUtils.isNil(content)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content
	  );
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_CardHeader2.default, function (val) {
	      return { content: val };
	    }, header),
	    (0, _lib.createShorthand)(_CardMeta2.default, function (val) {
	      return { content: val };
	    }, meta),
	    (0, _lib.createShorthand)(_CardDescription2.default, function (val) {
	      return { content: val };
	    }, description)
	  );
	}
	
	CardContent.handledProps = ['as', 'children', 'className', 'content', 'description', 'extra', 'header', 'meta', 'textAlign'];
	CardContent._meta = {
	  name: 'CardContent',
	  parent: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	
	CardContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for CardDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** A card can contain extra content meant to be formatted separately from the main content. */
	  extra: _propTypes2.default.bool,
	
	  /** Shorthand for CardHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for CardMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /** A card content can adjust its text alignment. */
	  textAlign: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified'))
	} : {};
	
	exports.default = CardContent;

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(69);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Card = __webpack_require__(1258);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of cards.
	 */
	function CardGroup(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      doubling = props.doubling,
	      items = props.items,
	      itemsPerRow = props.itemsPerRow,
	      stackable = props.stackable,
	      textAlign = props.textAlign;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(doubling, 'doubling'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useWidthProp)(itemsPerRow), 'cards', className);
	  var rest = (0, _lib.getUnhandledProps)(CardGroup, props);
	  var ElementType = (0, _lib.getElementType)(CardGroup, props);
	
	  if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	  if (!_lib.childrenUtils.isNil(content)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content
	  );
	
	  var itemsJSX = (0, _map3.default)(items, function (item) {
	    var key = item.key || [item.header, item.description].join('-');
	    return _react2.default.createElement(_Card2.default, (0, _extends3.default)({ key: key }, item));
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    itemsJSX
	  );
	}
	
	CardGroup.handledProps = ['as', 'children', 'className', 'content', 'doubling', 'items', 'itemsPerRow', 'stackable', 'textAlign'];
	CardGroup._meta = {
	  name: 'CardGroup',
	  parent: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	
	CardGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A group of cards can double its column width for mobile. */
	  doubling: _propTypes2.default.bool,
	
	  /** Shorthand array of props for Card. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A group of cards can set how many cards should exist in a row. */
	  itemsPerRow: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** A group of cards can automatically stack rows to a single columns on mobile devices. */
	  stackable: _propTypes2.default.bool,
	
	  /** A card group can adjust its text alignment. */
	  textAlign: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified'))
	} : {};
	
	exports.default = CardGroup;

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain an action.
	 */
	function CommentAction(props) {
	  var active = props.active,
	      className = props.className,
	      children = props.children,
	      content = props.content;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), className);
	  var rest = (0, _lib.getUnhandledProps)(CommentAction, props);
	  var ElementType = (0, _lib.getElementType)(CommentAction, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	CommentAction.handledProps = ['active', 'as', 'children', 'className', 'content'];
	CommentAction._meta = {
	  name: 'CommentAction',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentAction.defaultProps = {
	  as: 'a'
	};
	
	CommentAction.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Style as the currently active action. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = CommentAction;

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain an list of actions a user may perform related to this comment.
	 */
	function CommentActions(props) {
	  var className = props.className,
	      children = props.children,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('actions', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentActions, props);
	  var ElementType = (0, _lib.getElementType)(CommentActions, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	CommentActions.handledProps = ['as', 'children', 'className', 'content'];
	CommentActions._meta = {
	  name: 'CommentActions',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentActions.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = CommentActions;

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain an author.
	 */
	function CommentAuthor(props) {
	  var className = props.className,
	      children = props.children,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('author', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentAuthor, props);
	  var ElementType = (0, _lib.getElementType)(CommentAuthor, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	CommentAuthor.handledProps = ['as', 'children', 'className', 'content'];
	CommentAuthor._meta = {
	  name: 'CommentAuthor',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentAuthor.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = CommentAuthor;

/***/ },
/* 1264 */
[4561, 8, 10],
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain content.
	 */
	function CommentContent(props) {
	  var className = props.className,
	      children = props.children,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)(className, 'content');
	  var rest = (0, _lib.getUnhandledProps)(CommentContent, props);
	  var ElementType = (0, _lib.getElementType)(CommentContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	CommentContent.handledProps = ['as', 'children', 'className', 'content'];
	CommentContent._meta = {
	  name: 'CommentContent',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = CommentContent;

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Comments can be grouped.
	 */
	function CommentGroup(props) {
	  var className = props.className,
	      children = props.children,
	      collapsed = props.collapsed,
	      content = props.content,
	      minimal = props.minimal,
	      size = props.size,
	      threaded = props.threaded;
	
	
	  var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(collapsed, 'collapsed'), (0, _lib.useKeyOnly)(minimal, 'minimal'), (0, _lib.useKeyOnly)(threaded, 'threaded'), 'comments', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentGroup, props);
	  var ElementType = (0, _lib.getElementType)(CommentGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	CommentGroup.handledProps = ['as', 'children', 'className', 'collapsed', 'content', 'minimal', 'size', 'threaded'];
	CommentGroup._meta = {
	  name: 'CommentGroup',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Comments can be collapsed, or hidden from view. */
	  collapsed: _propTypes2.default.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Comments can hide extra information unless a user shows intent to interact with a comment. */
	  minimal: _propTypes2.default.bool,
	
	  /** Comments can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** A comment list can be threaded to showing the relationship between conversations. */
	  threaded: _propTypes2.default.bool
	} : {};
	
	exports.default = CommentGroup;

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain metadata about the comment, an arbitrary amount of metadata may be defined.
	 */
	function CommentMetadata(props) {
	  var className = props.className,
	      children = props.children,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('metadata', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentMetadata, props);
	  var ElementType = (0, _lib.getElementType)(CommentMetadata, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	CommentMetadata.handledProps = ['as', 'children', 'className', 'content'];
	CommentMetadata._meta = {
	  name: 'CommentMetadata',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentMetadata.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = CommentMetadata;

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain text.
	 */
	function CommentText(props) {
	  var className = props.className,
	      children = props.children,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)(className, 'text');
	  var rest = (0, _lib.getUnhandledProps)(CommentText, props);
	  var ElementType = (0, _lib.getElementType)(CommentText, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	CommentText.handledProps = ['as', 'children', 'className', 'content'];
	CommentText._meta = {
	  name: 'CommentText',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentText.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = CommentText;

/***/ },
/* 1269 */
[4566, 8, 10, 655, 657],
/* 1270 */
[4574, 8, 10, 1271, 662, 663, 1272, 664, 1273, 665],
/* 1271 */
[4575, 8, 10, 664, 662, 663, 665],
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(120);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map2 = __webpack_require__(69);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Item = __webpack_require__(1270);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of items.
	 */
	function ItemGroup(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      divided = props.divided,
	      items = props.items,
	      link = props.link,
	      relaxed = props.relaxed,
	      unstackable = props.unstackable;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(divided, 'divided'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useKeyOrValueAndKey)(relaxed, 'relaxed'), 'items', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemGroup, props);
	  var ElementType = (0, _lib.getElementType)(ItemGroup, props);
	
	  if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	  if (!_lib.childrenUtils.isNil(content)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content
	  );
	
	  var itemsJSX = (0, _map3.default)(items, function (item) {
	    var childKey = item.childKey,
	        itemProps = (0, _objectWithoutProperties3.default)(item, ['childKey']);
	
	    var finalKey = childKey || [itemProps.content, itemProps.description, itemProps.header, itemProps.meta].join('-');
	
	    return _react2.default.createElement(_Item2.default, (0, _extends3.default)({}, itemProps, { key: finalKey }));
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    itemsJSX
	  );
	}
	
	ItemGroup.handledProps = ['as', 'children', 'className', 'content', 'divided', 'items', 'link', 'relaxed', 'unstackable'];
	ItemGroup._meta = {
	  name: 'ItemGroup',
	  type: _lib.META.TYPES.VIEW,
	  parent: 'Item'
	};
	
	ItemGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Items can be divided to better distinguish between grouped content. */
	  divided: _propTypes2.default.bool,
	
	  /** Shorthand array of props for Item. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** An item can be formatted so that the entire contents link to another page. */
	  link: _propTypes2.default.bool,
	
	  /** A group of items can relax its padding to provide more negative space. */
	  relaxed: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])]),
	
	  /** Prevent items from stacking on mobile. */
	  unstackable: _propTypes2.default.bool
	} : {};
	
	exports.default = ItemGroup;

/***/ },
/* 1273 */
[4579, 10, 247],
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _StatisticGroup = __webpack_require__(1275);
	
	var _StatisticGroup2 = _interopRequireDefault(_StatisticGroup);
	
	var _StatisticLabel = __webpack_require__(1276);
	
	var _StatisticLabel2 = _interopRequireDefault(_StatisticLabel);
	
	var _StatisticValue = __webpack_require__(1277);
	
	var _StatisticValue2 = _interopRequireDefault(_StatisticValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A statistic emphasizes the current value of an attribute.
	 */
	function Statistic(props) {
	  var children = props.children,
	      className = props.className,
	      color = props.color,
	      content = props.content,
	      floated = props.floated,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      label = props.label,
	      size = props.size,
	      text = props.text,
	      value = props.value;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), 'statistic', className);
	  var rest = (0, _lib.getUnhandledProps)(Statistic, props);
	  var ElementType = (0, _lib.getElementType)(Statistic, props);
	
	  if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	  if (!_lib.childrenUtils.isNil(content)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content
	  );
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _StatisticValue2.default.create(value, {
	      defaultProps: { text: text }
	    }),
	    _StatisticLabel2.default.create(label)
	  );
	}
	
	Statistic.handledProps = ['as', 'children', 'className', 'color', 'content', 'floated', 'horizontal', 'inverted', 'label', 'size', 'text', 'value'];
	Statistic._meta = {
	  name: 'Statistic',
	  type: _lib.META.TYPES.VIEW
	};
	
	Statistic.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A statistic can be formatted to be different colors. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A statistic can sit to the left or right of other content. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** A statistic can present its measurement horizontally. */
	  horizontal: _propTypes2.default.bool,
	
	  /** A statistic can be formatted to fit on a dark background. */
	  inverted: _propTypes2.default.bool,
	
	  /** Label content of the Statistic. */
	  label: _lib.customPropTypes.contentShorthand,
	
	  /** A statistic can vary in size. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'big', 'massive', 'medium')),
	
	  /** Format the StatisticValue with smaller font size to fit nicely beside number values. */
	  text: _propTypes2.default.bool,
	
	  /** Value content of the Statistic. */
	  value: _lib.customPropTypes.contentShorthand
	} : {};
	
	Statistic.Group = _StatisticGroup2.default;
	Statistic.Label = _StatisticLabel2.default;
	Statistic.Value = _StatisticValue2.default;
	
	Statistic.create = (0, _lib.createShorthandFactory)(Statistic, function (content) {
	  return { content: content };
	});
	
	exports.default = Statistic;

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(69);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Statistic = __webpack_require__(1274);
	
	var _Statistic2 = _interopRequireDefault(_Statistic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of statistics.
	 */
	function StatisticGroup(props) {
	  var children = props.children,
	      className = props.className,
	      color = props.color,
	      content = props.content,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      items = props.items,
	      size = props.size,
	      widths = props.widths;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useWidthProp)(widths), 'statistics', className);
	  var rest = (0, _lib.getUnhandledProps)(StatisticGroup, props);
	  var ElementType = (0, _lib.getElementType)(StatisticGroup, props);
	
	  if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	  if (!_lib.childrenUtils.isNil(content)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content
	  );
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _map3.default)(items, function (item) {
	      return _Statistic2.default.create(item);
	    })
	  );
	}
	
	StatisticGroup.handledProps = ['as', 'children', 'className', 'color', 'content', 'horizontal', 'inverted', 'items', 'size', 'widths'];
	StatisticGroup._meta = {
	  name: 'StatisticGroup',
	  type: _lib.META.TYPES.VIEW,
	  parent: 'Statistic'
	};
	
	StatisticGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A statistic group can be formatted to be different colors. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A statistic group can present its measurement horizontally. */
	  horizontal: _propTypes2.default.bool,
	
	  /** A statistic group can be formatted to fit on a dark background. */
	  inverted: _propTypes2.default.bool,
	
	  /** Array of props for Statistic. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A statistic group can vary in size. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'big', 'massive', 'medium')),
	
	  /** A statistic group can have its items divided evenly. */
	  widths: _propTypes2.default.oneOf(_lib.SUI.WIDTHS)
	} : {};
	
	exports.default = StatisticGroup;

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A statistic can contain a label to help provide context for the presented value.
	 */
	function StatisticLabel(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('label', className);
	  var rest = (0, _lib.getUnhandledProps)(StatisticLabel, props);
	  var ElementType = (0, _lib.getElementType)(StatisticLabel, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	StatisticLabel.handledProps = ['as', 'children', 'className', 'content'];
	StatisticLabel._meta = {
	  name: 'StatisticLabel',
	  parent: 'Statistic',
	  type: _lib.META.TYPES.VIEW
	};
	
	StatisticLabel.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	StatisticLabel.create = (0, _lib.createShorthandFactory)(StatisticLabel, function (content) {
	  return { content: content };
	});
	
	exports.default = StatisticLabel;

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A statistic can contain a numeric, icon, image, or text value.
	 */
	function StatisticValue(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      text = props.text;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(text, 'text'), 'value', className);
	  var rest = (0, _lib.getUnhandledProps)(StatisticValue, props);
	  var ElementType = (0, _lib.getElementType)(StatisticValue, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	StatisticValue.handledProps = ['as', 'children', 'className', 'content', 'text'];
	StatisticValue._meta = {
	  name: 'StatisticValue',
	  parent: 'Statistic',
	  type: _lib.META.TYPES.VIEW
	};
	
	StatisticValue.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Format the value with smaller font size to fit nicely beside number values. */
	  text: _propTypes2.default.bool
	} : {};
	
	StatisticValue.create = (0, _lib.createShorthandFactory)(StatisticValue, function (content) {
	  return { content: content };
	});
	
	exports.default = StatisticValue;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2894);


/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES5ToInteger = __webpack_require__(2895);
	
	var ToNumber = __webpack_require__(2891);
	
	// https://ecma-international.org/ecma-262/11.0/#sec-tointeger
	
	module.exports = function ToInteger(value) {
		var number = ToNumber(value);
		if (number !== 0) {
			number = ES5ToInteger(number);
		}
		return number === 0 ? 0 : number;
	};


/***/ },
/* 1280 */
/***/ function(module, exports) {

	'use strict';
	
	var $isNaN = Number.isNaN || function (a) { return a !== a; };
	
	module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(110);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 1282 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 1283 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(420);
	
	var _DOMUtils = __webpack_require__(671);
	
	var _createHistory = __webpack_require__(1286);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(249);
	
	var _PathUtils = __webpack_require__(209);
	
	var _ExecutionEnvironment = __webpack_require__(420);
	
	var _DOMUtils = __webpack_require__(671);
	
	var _DOMStateStorage = __webpack_require__(670);
	
	var _createDOMHistory = __webpack_require__(1284);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(963);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(209);
	
	var _AsyncUtils = __webpack_require__(2928);
	
	var _Actions = __webpack_require__(249);
	
	var _createLocation2 = __webpack_require__(2930);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(673);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(672);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(420);
	
	var _PathUtils = __webpack_require__(209);
	
	var _runTransitionHook = __webpack_require__(673);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(672);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 1288 */
/***/ function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 1289 */
/***/ function(module, exports) {

	'use strict';
	
	var WHITELIST = [
		'ETIMEDOUT',
		'ECONNRESET',
		'EADDRINUSE',
		'ESOCKETTIMEDOUT',
		'ECONNREFUSED',
		'EPIPE',
		'EHOSTUNREACH',
		'EAI_AGAIN'
	];
	
	var BLACKLIST = [
		'ENOTFOUND',
		'ENETUNREACH',
	
		// SSL errors from https://github.com/nodejs/node/blob/ed3d8b13ee9a705d89f9e0397d9e96519e7e47ac/src/node_crypto.cc#L1950
		'UNABLE_TO_GET_ISSUER_CERT',
		'UNABLE_TO_GET_CRL',
		'UNABLE_TO_DECRYPT_CERT_SIGNATURE',
		'UNABLE_TO_DECRYPT_CRL_SIGNATURE',
		'UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY',
		'CERT_SIGNATURE_FAILURE',
		'CRL_SIGNATURE_FAILURE',
		'CERT_NOT_YET_VALID',
		'CERT_HAS_EXPIRED',
		'CRL_NOT_YET_VALID',
		'CRL_HAS_EXPIRED',
		'ERROR_IN_CERT_NOT_BEFORE_FIELD',
		'ERROR_IN_CERT_NOT_AFTER_FIELD',
		'ERROR_IN_CRL_LAST_UPDATE_FIELD',
		'ERROR_IN_CRL_NEXT_UPDATE_FIELD',
		'OUT_OF_MEM',
		'DEPTH_ZERO_SELF_SIGNED_CERT',
		'SELF_SIGNED_CERT_IN_CHAIN',
		'UNABLE_TO_GET_ISSUER_CERT_LOCALLY',
		'UNABLE_TO_VERIFY_LEAF_SIGNATURE',
		'CERT_CHAIN_TOO_LONG',
		'CERT_REVOKED',
		'INVALID_CA',
		'PATH_LENGTH_EXCEEDED',
		'INVALID_PURPOSE',
		'CERT_UNTRUSTED',
		'CERT_REJECTED'
	];
	
	module.exports = function (err) {
		if (!err || !err.code) {
			return true;
		}
	
		if (WHITELIST.indexOf(err.code) !== -1) {
			return true;
		}
	
		if (BLACKLIST.indexOf(err.code) !== -1) {
			return false;
		}
	
		return true;
	};


/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	var jws = __webpack_require__(676);
	
	module.exports = function (jwt, options) {
	  options = options || {};
	  var decoded = jws.decode(jwt, options);
	  if (!decoded) { return null; }
	  var payload = decoded.payload;
	
	  //try parse the payload
	  if(typeof payload === 'string') {
	    try {
	      var obj = JSON.parse(payload);
	      if(obj !== null && typeof obj === 'object') {
	        payload = obj;
	      }
	    } catch (e) { }
	  }
	
	  //return header if `complete` option is enabled.  header includes claims
	  //such as `kid` and `alg` used to select the key within a JWKS needed to
	  //verify the signature
	  if (options.complete === true) {
	    return {
	      header: decoded.header,
	      payload: payload,
	      signature: decoded.signature
	    };
	  }
	  return payload;
	};


/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	var JsonWebTokenError = __webpack_require__(422);
	
	var NotBeforeError = function (message, date) {
	  JsonWebTokenError.call(this, message);
	  this.name = 'NotBeforeError';
	  this.date = date;
	};
	
	NotBeforeError.prototype = Object.create(JsonWebTokenError.prototype);
	
	NotBeforeError.prototype.constructor = NotBeforeError;
	
	module.exports = NotBeforeError;

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	var JsonWebTokenError = __webpack_require__(422);
	
	var TokenExpiredError = function (message, expiredAt) {
	  JsonWebTokenError.call(this, message);
	  this.name = 'TokenExpiredError';
	  this.expiredAt = expiredAt;
	};
	
	TokenExpiredError.prototype = Object.create(JsonWebTokenError.prototype);
	
	TokenExpiredError.prototype.constructor = TokenExpiredError;
	
	module.exports = TokenExpiredError;

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var semver = __webpack_require__(4076);
	
	module.exports = semver.satisfies(process.version, '^6.12.0 || >=8.0.0');
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	var ms = __webpack_require__(2952);
	
	module.exports = function (time, iat) {
	  var timestamp = iat || Math.floor(Date.now() / 1000);
	
	  if (typeof time === 'string') {
	    var milliseconds = ms(time);
	    if (typeof milliseconds === 'undefined') {
	      return;
	    }
	    return Math.floor(timestamp + milliseconds / 1000);
	  } else if (typeof time === 'number') {
	    return timestamp + time;
	  } else {
	    return;
	  }
	
	};

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	var bufferEqual = __webpack_require__(2410);
	var Buffer = __webpack_require__(333).Buffer;
	var crypto = __webpack_require__(4151);
	var formatEcdsa = __webpack_require__(2886);
	var util = __webpack_require__(527);
	
	var MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".'
	var MSG_INVALID_SECRET = 'secret must be a string or buffer';
	var MSG_INVALID_VERIFIER_KEY = 'key must be a string or a buffer';
	var MSG_INVALID_SIGNER_KEY = 'key must be a string, a buffer or an object';
	
	var supportsKeyObjects = typeof crypto.createPublicKey === 'function';
	if (supportsKeyObjects) {
	  MSG_INVALID_VERIFIER_KEY += ' or a KeyObject';
	  MSG_INVALID_SECRET += 'or a KeyObject';
	}
	
	function checkIsPublicKey(key) {
	  if (Buffer.isBuffer(key)) {
	    return;
	  }
	
	  if (typeof key === 'string') {
	    return;
	  }
	
	  if (!supportsKeyObjects) {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	
	  if (typeof key !== 'object') {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	
	  if (typeof key.type !== 'string') {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	
	  if (typeof key.asymmetricKeyType !== 'string') {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	
	  if (typeof key.export !== 'function') {
	    throw typeError(MSG_INVALID_VERIFIER_KEY);
	  }
	};
	
	function checkIsPrivateKey(key) {
	  if (Buffer.isBuffer(key)) {
	    return;
	  }
	
	  if (typeof key === 'string') {
	    return;
	  }
	
	  if (typeof key === 'object') {
	    return;
	  }
	
	  throw typeError(MSG_INVALID_SIGNER_KEY);
	};
	
	function checkIsSecretKey(key) {
	  if (Buffer.isBuffer(key)) {
	    return;
	  }
	
	  if (typeof key === 'string') {
	    return key;
	  }
	
	  if (!supportsKeyObjects) {
	    throw typeError(MSG_INVALID_SECRET);
	  }
	
	  if (typeof key !== 'object') {
	    throw typeError(MSG_INVALID_SECRET);
	  }
	
	  if (key.type !== 'secret') {
	    throw typeError(MSG_INVALID_SECRET);
	  }
	
	  if (typeof key.export !== 'function') {
	    throw typeError(MSG_INVALID_SECRET);
	  }
	}
	
	function fromBase64(base64) {
	  return base64
	    .replace(/=/g, '')
	    .replace(/\+/g, '-')
	    .replace(/\//g, '_');
	}
	
	function toBase64(base64url) {
	  base64url = base64url.toString();
	
	  var padding = 4 - base64url.length % 4;
	  if (padding !== 4) {
	    for (var i = 0; i < padding; ++i) {
	      base64url += '=';
	    }
	  }
	
	  return base64url
	    .replace(/\-/g, '+')
	    .replace(/_/g, '/');
	}
	
	function typeError(template) {
	  var args = [].slice.call(arguments, 1);
	  var errMsg = util.format.bind(util, template).apply(null, args);
	  return new TypeError(errMsg);
	}
	
	function bufferOrString(obj) {
	  return Buffer.isBuffer(obj) || typeof obj === 'string';
	}
	
	function normalizeInput(thing) {
	  if (!bufferOrString(thing))
	    thing = JSON.stringify(thing);
	  return thing;
	}
	
	function createHmacSigner(bits) {
	  return function sign(thing, secret) {
	    checkIsSecretKey(secret);
	    thing = normalizeInput(thing);
	    var hmac = crypto.createHmac('sha' + bits, secret);
	    var sig = (hmac.update(thing), hmac.digest('base64'))
	    return fromBase64(sig);
	  }
	}
	
	function createHmacVerifier(bits) {
	  return function verify(thing, signature, secret) {
	    var computedSig = createHmacSigner(bits)(thing, secret);
	    return bufferEqual(Buffer.from(signature), Buffer.from(computedSig));
	  }
	}
	
	function createKeySigner(bits) {
	 return function sign(thing, privateKey) {
	    checkIsPrivateKey(privateKey);
	    thing = normalizeInput(thing);
	    // Even though we are specifying "RSA" here, this works with ECDSA
	    // keys as well.
	    var signer = crypto.createSign('RSA-SHA' + bits);
	    var sig = (signer.update(thing), signer.sign(privateKey, 'base64'));
	    return fromBase64(sig);
	  }
	}
	
	function createKeyVerifier(bits) {
	  return function verify(thing, signature, publicKey) {
	    checkIsPublicKey(publicKey);
	    thing = normalizeInput(thing);
	    signature = toBase64(signature);
	    var verifier = crypto.createVerify('RSA-SHA' + bits);
	    verifier.update(thing);
	    return verifier.verify(publicKey, signature, 'base64');
	  }
	}
	
	function createPSSKeySigner(bits) {
	  return function sign(thing, privateKey) {
	    checkIsPrivateKey(privateKey);
	    thing = normalizeInput(thing);
	    var signer = crypto.createSign('RSA-SHA' + bits);
	    var sig = (signer.update(thing), signer.sign({
	      key: privateKey,
	      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
	      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
	    }, 'base64'));
	    return fromBase64(sig);
	  }
	}
	
	function createPSSKeyVerifier(bits) {
	  return function verify(thing, signature, publicKey) {
	    checkIsPublicKey(publicKey);
	    thing = normalizeInput(thing);
	    signature = toBase64(signature);
	    var verifier = crypto.createVerify('RSA-SHA' + bits);
	    verifier.update(thing);
	    return verifier.verify({
	      key: publicKey,
	      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
	      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
	    }, signature, 'base64');
	  }
	}
	
	function createECDSASigner(bits) {
	  var inner = createKeySigner(bits);
	  return function sign() {
	    var signature = inner.apply(null, arguments);
	    signature = formatEcdsa.derToJose(signature, 'ES' + bits);
	    return signature;
	  };
	}
	
	function createECDSAVerifer(bits) {
	  var inner = createKeyVerifier(bits);
	  return function verify(thing, signature, publicKey) {
	    signature = formatEcdsa.joseToDer(signature, 'ES' + bits).toString('base64');
	    var result = inner(thing, signature, publicKey);
	    return result;
	  };
	}
	
	function createNoneSigner() {
	  return function sign() {
	    return '';
	  }
	}
	
	function createNoneVerifier() {
	  return function verify(thing, signature) {
	    return signature === '';
	  }
	}
	
	module.exports = function jwa(algorithm) {
	  var signerFactories = {
	    hs: createHmacSigner,
	    rs: createKeySigner,
	    ps: createPSSKeySigner,
	    es: createECDSASigner,
	    none: createNoneSigner,
	  }
	  var verifierFactories = {
	    hs: createHmacVerifier,
	    rs: createKeyVerifier,
	    ps: createPSSKeyVerifier,
	    es: createECDSAVerifer,
	    none: createNoneVerifier,
	  }
	  var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/i);
	  if (!match)
	    throw typeError(MSG_INVALID_ALGORITHM, algorithm);
	  var algo = (match[1] || match[3]).toLowerCase();
	  var bits = match[2];
	
	  return {
	    sign: signerFactories[algo](bits),
	    verify: verifierFactories[algo](bits),
	  }
	};


/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/*global module, process*/
	var Buffer = __webpack_require__(333).Buffer;
	var Stream = __webpack_require__(226);
	var util = __webpack_require__(527);
	
	function DataStream(data) {
	  this.buffer = null;
	  this.writable = true;
	  this.readable = true;
	
	  // No input
	  if (!data) {
	    this.buffer = Buffer.alloc(0);
	    return this;
	  }
	
	  // Stream
	  if (typeof data.pipe === 'function') {
	    this.buffer = Buffer.alloc(0);
	    data.pipe(this);
	    return this;
	  }
	
	  // Buffer or String
	  // or Object (assumedly a passworded key)
	  if (data.length || typeof data === 'object') {
	    this.buffer = data;
	    this.writable = false;
	    process.nextTick(function () {
	      this.emit('end', data);
	      this.readable = false;
	      this.emit('close');
	    }.bind(this));
	    return this;
	  }
	
	  throw new TypeError('Unexpected data type ('+ typeof data + ')');
	}
	util.inherits(DataStream, Stream);
	
	DataStream.prototype.write = function write(data) {
	  this.buffer = Buffer.concat([this.buffer, Buffer.from(data)]);
	  this.emit('data', data);
	};
	
	DataStream.prototype.end = function end(data) {
	  if (data)
	    this.write(data);
	  this.emit('end', data);
	  this.emit('close');
	  this.writable = false;
	  this.readable = false;
	};
	
	module.exports = DataStream;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	/*global module*/
	var Buffer = __webpack_require__(58).Buffer;
	
	module.exports = function toString(obj) {
	  if (typeof obj === 'string')
	    return obj;
	  if (typeof obj === 'number' || Buffer.isBuffer(obj))
	    return obj.toString();
	  return JSON.stringify(obj);
	};


/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64_url_decode = __webpack_require__(2958);
	
	module.exports = function (token,options) {
	  if (typeof token !== 'string') {
	    throw new Error('Invalid token specified');
	  }
	
	  options = options || {};
	  var pos = options.header === true ? 0 : 1;
	  return JSON.parse(base64_url_decode(token.split('.')[pos]));
	};


/***/ },
/* 1299 */
[4203, 1300, 1307],
/* 1300 */
[4208, 1301],
/* 1301 */
[4285, 2996],
/* 1302 */
1003,
/* 1303 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 1304 */
302,
/* 1305 */
1013,
/* 1306 */
[4333, 1302],
/* 1307 */
303,
/* 1308 */
179,
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(678);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 1310 */
626,
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    ordinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    ordinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	    monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    ordinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[I dag kl.] LT',
	        nextDay : '[I morgen kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[I går kl.] LT',
	        lastWeek : '[sidste] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    ordinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	    weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-an de] MMMM, YYYY',
	        LLL : 'D[-an de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'je %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    ordinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چندین ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    ordinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : '');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    ordinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	    weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	    weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'Ah時m分',
	        LTS : 'Ah時m分s秒',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah時m分',
	        LLLL : 'YYYY年M月D日Ah時m分 dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    ordinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის წინ');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის წინ');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h시 m분',
	        LTS : 'A h시 m분 s초',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h시 m분',
	        LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '일분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    ordinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    ordinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    ordinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    ordinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    ordinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    },
	    nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    ordinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah点mm分',
	        LTS : 'Ah点m分s秒',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah点mm分',
	        llll : 'YYYY年MMMD日ddddAh点mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : function () {
	            return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	        },
	        nextDay : function () {
	            return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	        },
	        lastDay : function () {
	            return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	        },
	        nextWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        lastWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        sameElse : 'LL'
	    },
	    ordinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 1419 */
/***/ function(module, exports) {

	'use strict';
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1419);
	
	module.exports = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};


/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(1422);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(3022);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 1422 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 1423 */
[4175, 3030],
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(210);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1425 */
/***/ function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ },
/* 1426 */
/***/ function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	exports.arrayToObject = function (source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	exports.merge = function (target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            target[source] = true;
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = exports.arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = exports.merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (Object.prototype.hasOwnProperty.call(acc, key)) {
	            acc[key] = exports.merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	exports.decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function (str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D || // -
	            c === 0x2E || // .
	            c === 0x5F || // _
	            c === 0x7E || // ~
	            (c >= 0x30 && c <= 0x39) || // 0-9
	            (c >= 0x41 && c <= 0x5A) || // a-z
	            (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)] + hexTable[0x80 | ((c >> 12) & 0x3F)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	exports.compact = function (obj, references) {
	    if (typeof obj !== 'object' || obj === null) {
	        return obj;
	    }
	
	    var refs = references || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0; i < obj.length; ++i) {
	            if (obj[i] && typeof obj[i] === 'object') {
	                compacted.push(exports.compact(obj[i], refs));
	            } else if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    keys.forEach(function (key) {
	        obj[key] = exports.compact(obj[key], refs);
	    });
	
	    return obj;
	};
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	exports.isBuffer = function (obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};


/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(829);
	var objectAssign = __webpack_require__(45);
	var decodeComponent = __webpack_require__(2548);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	function extract(str) {
		var queryStart = str.indexOf('?');
		if (queryStart === -1) {
			return '';
		}
		return str.slice(queryStart + 1);
	}
	
	function parse(str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^[?#&]/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeComponent(val);
	
			formatter(decodeComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	}
	
	exports.extract = extract;
	exports.parse = parse;
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		if (opts.sort === false) {
			opts.sort = function () {};
		}
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};
	
	exports.parseUrl = function (str, opts) {
		return {
			url: str.split('?')[0] || '',
			query: parse(extract(str), opts)
		};
	};


/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(3038);
	exports.encode = exports.stringify = __webpack_require__(3039);


/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * Quill Editor v1.3.7
	 * https://quilljs.com/
	 * Copyright (c) 2014, Jason Chen
	 * Copyright (c) 2013, salesforce.com
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Quill"] = factory();
		else
			root["Quill"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 109);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var format_1 = __webpack_require__(18);
	var leaf_1 = __webpack_require__(19);
	var scroll_1 = __webpack_require__(45);
	var inline_1 = __webpack_require__(46);
	var block_1 = __webpack_require__(47);
	var embed_1 = __webpack_require__(48);
	var text_1 = __webpack_require__(49);
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var store_1 = __webpack_require__(31);
	var Registry = __webpack_require__(1);
	var Parchment = {
	    Scope: Registry.Scope,
	    create: Registry.create,
	    find: Registry.find,
	    query: Registry.query,
	    register: Registry.register,
	    Container: container_1.default,
	    Format: format_1.default,
	    Leaf: leaf_1.default,
	    Embed: embed_1.default,
	    Scroll: scroll_1.default,
	    Block: block_1.default,
	    Inline: inline_1.default,
	    Text: text_1.default,
	    Attributor: {
	        Attribute: attributor_1.default,
	        Class: class_1.default,
	        Style: style_1.default,
	        Store: store_1.default,
	    },
	};
	exports.default = Parchment;
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ParchmentError = /** @class */ (function (_super) {
	    __extends(ParchmentError, _super);
	    function ParchmentError(message) {
	        var _this = this;
	        message = '[Parchment] ' + message;
	        _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _this.constructor.name;
	        return _this;
	    }
	    return ParchmentError;
	}(Error));
	exports.ParchmentError = ParchmentError;
	var attributes = {};
	var classes = {};
	var tags = {};
	var types = {};
	exports.DATA_KEY = '__blot';
	var Scope;
	(function (Scope) {
	    Scope[Scope["TYPE"] = 3] = "TYPE";
	    Scope[Scope["LEVEL"] = 12] = "LEVEL";
	    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
	    Scope[Scope["BLOT"] = 14] = "BLOT";
	    Scope[Scope["INLINE"] = 7] = "INLINE";
	    Scope[Scope["BLOCK"] = 11] = "BLOCK";
	    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
	    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
	    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
	    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
	    Scope[Scope["ANY"] = 15] = "ANY";
	})(Scope = exports.Scope || (exports.Scope = {}));
	function create(input, value) {
	    var match = query(input);
	    if (match == null) {
	        throw new ParchmentError("Unable to create " + input + " blot");
	    }
	    var BlotClass = match;
	    var node = 
	    // @ts-ignore
	    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
	    return new BlotClass(node, value);
	}
	exports.create = create;
	function find(node, bubble) {
	    if (bubble === void 0) { bubble = false; }
	    if (node == null)
	        return null;
	    // @ts-ignore
	    if (node[exports.DATA_KEY] != null)
	        return node[exports.DATA_KEY].blot;
	    if (bubble)
	        return find(node.parentNode, bubble);
	    return null;
	}
	exports.find = find;
	function query(query, scope) {
	    if (scope === void 0) { scope = Scope.ANY; }
	    var match;
	    if (typeof query === 'string') {
	        match = types[query] || attributes[query];
	        // @ts-ignore
	    }
	    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
	        match = types['text'];
	    }
	    else if (typeof query === 'number') {
	        if (query & Scope.LEVEL & Scope.BLOCK) {
	            match = types['block'];
	        }
	        else if (query & Scope.LEVEL & Scope.INLINE) {
	            match = types['inline'];
	        }
	    }
	    else if (query instanceof HTMLElement) {
	        var names = (query.getAttribute('class') || '').split(/\s+/);
	        for (var i in names) {
	            match = classes[names[i]];
	            if (match)
	                break;
	        }
	        match = match || tags[query.tagName];
	    }
	    if (match == null)
	        return null;
	    // @ts-ignore
	    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
	        return match;
	    return null;
	}
	exports.query = query;
	function register() {
	    var Definitions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        Definitions[_i] = arguments[_i];
	    }
	    if (Definitions.length > 1) {
	        return Definitions.map(function (d) {
	            return register(d);
	        });
	    }
	    var Definition = Definitions[0];
	    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
	        throw new ParchmentError('Invalid definition');
	    }
	    else if (Definition.blotName === 'abstract') {
	        throw new ParchmentError('Cannot register abstract class');
	    }
	    types[Definition.blotName || Definition.attrName] = Definition;
	    if (typeof Definition.keyName === 'string') {
	        attributes[Definition.keyName] = Definition;
	    }
	    else {
	        if (Definition.className != null) {
	            classes[Definition.className] = Definition;
	        }
	        if (Definition.tagName != null) {
	            if (Array.isArray(Definition.tagName)) {
	                Definition.tagName = Definition.tagName.map(function (tagName) {
	                    return tagName.toUpperCase();
	                });
	            }
	            else {
	                Definition.tagName = Definition.tagName.toUpperCase();
	            }
	            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
	            tagNames.forEach(function (tag) {
	                if (tags[tag] == null || Definition.className == null) {
	                    tags[tag] = Definition;
	                }
	            });
	        }
	    }
	    return Definition;
	}
	exports.register = register;
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var diff = __webpack_require__(51);
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	var op = __webpack_require__(20);
	
	
	var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()
	
	
	var Delta = function (ops) {
	  // Assume we are given a well formed ops
	  if (Array.isArray(ops)) {
	    this.ops = ops;
	  } else if (ops != null && Array.isArray(ops.ops)) {
	    this.ops = ops.ops;
	  } else {
	    this.ops = [];
	  }
	};
	
	
	Delta.prototype.insert = function (text, attributes) {
	  var newOp = {};
	  if (text.length === 0) return this;
	  newOp.insert = text;
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};
	
	Delta.prototype['delete'] = function (length) {
	  if (length <= 0) return this;
	  return this.push({ 'delete': length });
	};
	
	Delta.prototype.retain = function (length, attributes) {
	  if (length <= 0) return this;
	  var newOp = { retain: length };
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};
	
	Delta.prototype.push = function (newOp) {
	  var index = this.ops.length;
	  var lastOp = this.ops[index - 1];
	  newOp = extend(true, {}, newOp);
	  if (typeof lastOp === 'object') {
	    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
	      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
	      return this;
	    }
	    // Since it does not matter if we insert before or after deleting at the same index,
	    // always prefer to insert first
	    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
	      index -= 1;
	      lastOp = this.ops[index - 1];
	      if (typeof lastOp !== 'object') {
	        this.ops.unshift(newOp);
	        return this;
	      }
	    }
	    if (equal(newOp.attributes, lastOp.attributes)) {
	      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
	        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
	        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      }
	    }
	  }
	  if (index === this.ops.length) {
	    this.ops.push(newOp);
	  } else {
	    this.ops.splice(index, 0, newOp);
	  }
	  return this;
	};
	
	Delta.prototype.chop = function () {
	  var lastOp = this.ops[this.ops.length - 1];
	  if (lastOp && lastOp.retain && !lastOp.attributes) {
	    this.ops.pop();
	  }
	  return this;
	};
	
	Delta.prototype.filter = function (predicate) {
	  return this.ops.filter(predicate);
	};
	
	Delta.prototype.forEach = function (predicate) {
	  this.ops.forEach(predicate);
	};
	
	Delta.prototype.map = function (predicate) {
	  return this.ops.map(predicate);
	};
	
	Delta.prototype.partition = function (predicate) {
	  var passed = [], failed = [];
	  this.forEach(function(op) {
	    var target = predicate(op) ? passed : failed;
	    target.push(op);
	  });
	  return [passed, failed];
	};
	
	Delta.prototype.reduce = function (predicate, initial) {
	  return this.ops.reduce(predicate, initial);
	};
	
	Delta.prototype.changeLength = function () {
	  return this.reduce(function (length, elem) {
	    if (elem.insert) {
	      return length + op.length(elem);
	    } else if (elem.delete) {
	      return length - elem.delete;
	    }
	    return length;
	  }, 0);
	};
	
	Delta.prototype.length = function () {
	  return this.reduce(function (length, elem) {
	    return length + op.length(elem);
	  }, 0);
	};
	
	Delta.prototype.slice = function (start, end) {
	  start = start || 0;
	  if (typeof end !== 'number') end = Infinity;
	  var ops = [];
	  var iter = op.iterator(this.ops);
	  var index = 0;
	  while (index < end && iter.hasNext()) {
	    var nextOp;
	    if (index < start) {
	      nextOp = iter.next(start - index);
	    } else {
	      nextOp = iter.next(end - index);
	      ops.push(nextOp);
	    }
	    index += op.length(nextOp);
	  }
	  return new Delta(ops);
	};
	
	
	Delta.prototype.compose = function (other) {
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var ops = [];
	  var firstOther = otherIter.peek();
	  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
	    var firstLeft = firstOther.retain;
	    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
	      firstLeft -= thisIter.peekLength();
	      ops.push(thisIter.next());
	    }
	    if (firstOther.retain - firstLeft > 0) {
	      otherIter.next(firstOther.retain - firstLeft);
	    }
	  }
	  var delta = new Delta(ops);
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else if (thisIter.peekType() === 'delete') {
	      delta.push(thisIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (typeof otherOp.retain === 'number') {
	        var newOp = {};
	        if (typeof thisOp.retain === 'number') {
	          newOp.retain = length;
	        } else {
	          newOp.insert = thisOp.insert;
	        }
	        // Preserve null when composing with a retain, otherwise remove it for inserts
	        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
	        if (attributes) newOp.attributes = attributes;
	        delta.push(newOp);
	
	        // Optimization if rest of other is just retain
	        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
	          var rest = new Delta(thisIter.rest());
	          return delta.concat(rest).chop();
	        }
	
	      // Other op should be delete, we could be an insert or retain
	      // Insert + delete cancels out
	      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
	        delta.push(otherOp);
	      }
	    }
	  }
	  return delta.chop();
	};
	
	Delta.prototype.concat = function (other) {
	  var delta = new Delta(this.ops.slice());
	  if (other.ops.length > 0) {
	    delta.push(other.ops[0]);
	    delta.ops = delta.ops.concat(other.ops.slice(1));
	  }
	  return delta;
	};
	
	Delta.prototype.diff = function (other, index) {
	  if (this.ops === other.ops) {
	    return new Delta();
	  }
	  var strings = [this, other].map(function (delta) {
	    return delta.map(function (op) {
	      if (op.insert != null) {
	        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
	      }
	      var prep = (delta === other) ? 'on' : 'with';
	      throw new Error('diff() called ' + prep + ' non-document');
	    }).join('');
	  });
	  var delta = new Delta();
	  var diffResult = diff(strings[0], strings[1], index);
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  diffResult.forEach(function (component) {
	    var length = component[1].length;
	    while (length > 0) {
	      var opLength = 0;
	      switch (component[0]) {
	        case diff.INSERT:
	          opLength = Math.min(otherIter.peekLength(), length);
	          delta.push(otherIter.next(opLength));
	          break;
	        case diff.DELETE:
	          opLength = Math.min(length, thisIter.peekLength());
	          thisIter.next(opLength);
	          delta['delete'](opLength);
	          break;
	        case diff.EQUAL:
	          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
	          var thisOp = thisIter.next(opLength);
	          var otherOp = otherIter.next(opLength);
	          if (equal(thisOp.insert, otherOp.insert)) {
	            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
	          } else {
	            delta.push(otherOp)['delete'](opLength);
	          }
	          break;
	      }
	      length -= opLength;
	    }
	  });
	  return delta.chop();
	};
	
	Delta.prototype.eachLine = function (predicate, newline) {
	  newline = newline || '\n';
	  var iter = op.iterator(this.ops);
	  var line = new Delta();
	  var i = 0;
	  while (iter.hasNext()) {
	    if (iter.peekType() !== 'insert') return;
	    var thisOp = iter.peek();
	    var start = op.length(thisOp) - iter.peekLength();
	    var index = typeof thisOp.insert === 'string' ?
	      thisOp.insert.indexOf(newline, start) - start : -1;
	    if (index < 0) {
	      line.push(iter.next());
	    } else if (index > 0) {
	      line.push(iter.next(index));
	    } else {
	      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
	        return;
	      }
	      i += 1;
	      line = new Delta();
	    }
	  }
	  if (line.length() > 0) {
	    predicate(line, {}, i);
	  }
	};
	
	Delta.prototype.transform = function (other, priority) {
	  priority = !!priority;
	  if (typeof other === 'number') {
	    return this.transformPosition(other, priority);
	  }
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var delta = new Delta();
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
	      delta.retain(op.length(thisIter.next()));
	    } else if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (thisOp['delete']) {
	        // Our delete either makes their delete redundant or removes their retain
	        continue;
	      } else if (otherOp['delete']) {
	        delta.push(otherOp);
	      } else {
	        // We retain either their retain or insert
	        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
	      }
	    }
	  }
	  return delta.chop();
	};
	
	Delta.prototype.transformPosition = function (index, priority) {
	  priority = !!priority;
	  var thisIter = op.iterator(this.ops);
	  var offset = 0;
	  while (thisIter.hasNext() && offset <= index) {
	    var length = thisIter.peekLength();
	    var nextType = thisIter.peekType();
	    thisIter.next();
	    if (nextType === 'delete') {
	      index -= Math.min(length, index - offset);
	      continue;
	    } else if (nextType === 'insert' && (offset < index || !priority)) {
	      index += length;
	    }
	    offset += length;
	  }
	  return index;
	};
	
	
	module.exports = Delta;
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}
	
		return obj[name];
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEWLINE_LENGTH = 1;
	
	var BlockEmbed = function (_Parchment$Embed) {
	  _inherits(BlockEmbed, _Parchment$Embed);
	
	  function BlockEmbed() {
	    _classCallCheck(this, BlockEmbed);
	
	    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
	  }
	
	  _createClass(BlockEmbed, [{
	    key: 'attach',
	    value: function attach() {
	      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
	      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
	    }
	  }, {
	    key: 'delta',
	    value: function delta() {
	      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
	      if (attribute != null) {
	        this.attributes.attribute(attribute, value);
	      }
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      this.format(name, value);
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (typeof value === 'string' && value.endsWith('\n')) {
	        var block = _parchment2.default.create(Block.blotName);
	        this.parent.insertBefore(block, index === 0 ? this : this.next);
	        block.insertAt(0, value.slice(0, -1));
	      } else {
	        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	    }
	  }]);
	
	  return BlockEmbed;
	}(_parchment2.default.Embed);
	
	BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
	// It is important for cursor behavior BlockEmbeds use tags that are block level elements
	
	
	var Block = function (_Parchment$Block) {
	  _inherits(Block, _Parchment$Block);
	
	  function Block(domNode) {
	    _classCallCheck(this, Block);
	
	    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));
	
	    _this2.cache = {};
	    return _this2;
	  }
	
	  _createClass(Block, [{
	    key: 'delta',
	    value: function delta() {
	      if (this.cache.delta == null) {
	        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
	          if (leaf.length() === 0) {
	            return delta;
	          } else {
	            return delta.insert(leaf.value(), bubbleFormats(leaf));
	          }
	        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
	      }
	      return this.cache.delta;
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
	      this.cache = {};
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length <= 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	        if (index + length === this.length()) {
	          this.format(name, value);
	        }
	      } else {
	        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
	      if (value.length === 0) return;
	      var lines = value.split('\n');
	      var text = lines.shift();
	      if (text.length > 0) {
	        if (index < this.length() - 1 || this.children.tail == null) {
	          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
	        } else {
	          this.children.tail.insertAt(this.children.tail.length(), text);
	        }
	        this.cache = {};
	      }
	      var block = this;
	      lines.reduce(function (index, line) {
	        block = block.split(index, true);
	        block.insertAt(0, line);
	        return line.length;
	      }, index + text.length);
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      var head = this.children.head;
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
	      if (head instanceof _break2.default) {
	        head.remove();
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      if (this.cache.length == null) {
	        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
	      }
	      return this.cache.length;
	    }
	  }, {
	    key: 'moveChildren',
	    value: function moveChildren(target, ref) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
	      this.cache = {};
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
	      this.cache = {};
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(child) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
	      this.cache = {};
	    }
	  }, {
	    key: 'split',
	    value: function split(index) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
	        var clone = this.clone();
	        if (index === 0) {
	          this.parent.insertBefore(clone, this);
	          return this;
	        } else {
	          this.parent.insertBefore(clone, this.next);
	          return clone;
	        }
	      } else {
	        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
	        this.cache = {};
	        return next;
	      }
	    }
	  }]);
	
	  return Block;
	}(_parchment2.default.Block);
	
	Block.blotName = 'block';
	Block.tagName = 'P';
	Block.defaultChild = 'break';
	Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];
	
	function bubbleFormats(blot) {
	  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (blot == null) return formats;
	  if (typeof blot.formats === 'function') {
	    formats = (0, _extend2.default)(formats, blot.formats());
	  }
	  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
	    return formats;
	  }
	  return bubbleFormats(blot.parent, formats);
	}
	
	exports.bubbleFormats = bubbleFormats;
	exports.BlockEmbed = BlockEmbed;
	exports.default = Block;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.overload = exports.expandConfig = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(50);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _editor = __webpack_require__(14);
	
	var _editor2 = _interopRequireDefault(_editor);
	
	var _emitter3 = __webpack_require__(8);
	
	var _emitter4 = _interopRequireDefault(_emitter3);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _selection = __webpack_require__(15);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _theme = __webpack_require__(34);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var debug = (0, _logger2.default)('quill');
	
	var Quill = function () {
	  _createClass(Quill, null, [{
	    key: 'debug',
	    value: function debug(limit) {
	      if (limit === true) {
	        limit = 'log';
	      }
	      _logger2.default.level(limit);
	    }
	  }, {
	    key: 'find',
	    value: function find(node) {
	      return node.__quill || _parchment2.default.find(node);
	    }
	  }, {
	    key: 'import',
	    value: function _import(name) {
	      if (this.imports[name] == null) {
	        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
	      }
	      return this.imports[name];
	    }
	  }, {
	    key: 'register',
	    value: function register(path, target) {
	      var _this = this;
	
	      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (typeof path !== 'string') {
	        var name = path.attrName || path.blotName;
	        if (typeof name === 'string') {
	          // register(Blot | Attributor, overwrite)
	          this.register('formats/' + name, path, target);
	        } else {
	          Object.keys(path).forEach(function (key) {
	            _this.register(key, path[key], target);
	          });
	        }
	      } else {
	        if (this.imports[path] != null && !overwrite) {
	          debug.warn('Overwriting ' + path + ' with', target);
	        }
	        this.imports[path] = target;
	        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
	          _parchment2.default.register(target);
	        } else if (path.startsWith('modules') && typeof target.register === 'function') {
	          target.register();
	        }
	      }
	    }
	  }]);
	
	  function Quill(container) {
	    var _this2 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Quill);
	
	    this.options = expandConfig(container, options);
	    this.container = this.options.container;
	    if (this.container == null) {
	      return debug.error('Invalid Quill container', container);
	    }
	    if (this.options.debug) {
	      Quill.debug(this.options.debug);
	    }
	    var html = this.container.innerHTML.trim();
	    this.container.classList.add('ql-container');
	    this.container.innerHTML = '';
	    this.container.__quill = this;
	    this.root = this.addContainer('ql-editor');
	    this.root.classList.add('ql-blank');
	    this.root.setAttribute('data-gramm', false);
	    this.scrollingContainer = this.options.scrollingContainer || this.root;
	    this.emitter = new _emitter4.default();
	    this.scroll = _parchment2.default.create(this.root, {
	      emitter: this.emitter,
	      whitelist: this.options.formats
	    });
	    this.editor = new _editor2.default(this.scroll);
	    this.selection = new _selection2.default(this.scroll, this.emitter);
	    this.theme = new this.options.theme(this, this.options);
	    this.keyboard = this.theme.addModule('keyboard');
	    this.clipboard = this.theme.addModule('clipboard');
	    this.history = this.theme.addModule('history');
	    this.theme.init();
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
	      if (type === _emitter4.default.events.TEXT_CHANGE) {
	        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
	      var range = _this2.selection.lastRange;
	      var index = range && range.length === 0 ? range.index : undefined;
	      modify.call(_this2, function () {
	        return _this2.editor.update(null, mutations, index);
	      }, source);
	    });
	    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
	    this.setContents(contents);
	    this.history.clear();
	    if (this.options.placeholder) {
	      this.root.setAttribute('data-placeholder', this.options.placeholder);
	    }
	    if (this.options.readOnly) {
	      this.disable();
	    }
	  }
	
	  _createClass(Quill, [{
	    key: 'addContainer',
	    value: function addContainer(container) {
	      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (typeof container === 'string') {
	        var className = container;
	        container = document.createElement('div');
	        container.classList.add(className);
	      }
	      this.container.insertBefore(container, refNode);
	      return container;
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.selection.setRange(null);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length, source) {
	      var _this3 = this;
	
	      var _overload = overload(index, length, source);
	
	      var _overload2 = _slicedToArray(_overload, 4);
	
	      index = _overload2[0];
	      length = _overload2[1];
	      source = _overload2[3];
	
	      return modify.call(this, function () {
	        return _this3.editor.deleteText(index, length);
	      }, source, index, -1 * length);
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      this.enable(false);
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.scroll.enable(enabled);
	      this.container.classList.toggle('ql-disabled', !enabled);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var scrollTop = this.scrollingContainer.scrollTop;
	      this.selection.focus();
	      this.scrollingContainer.scrollTop = scrollTop;
	      this.scrollIntoView();
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var _this4 = this;
	
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        var range = _this4.getSelection(true);
	        var change = new _quillDelta2.default();
	        if (range == null) {
	          return change;
	        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
	        } else if (range.length === 0) {
	          _this4.selection.format(name, value);
	          return change;
	        } else {
	          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
	        }
	        _this4.setSelection(range, _emitter4.default.sources.SILENT);
	        return change;
	      }, source);
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length, name, value, source) {
	      var _this5 = this;
	
	      var formats = void 0;
	
	      var _overload3 = overload(index, length, name, value, source);
	
	      var _overload4 = _slicedToArray(_overload3, 4);
	
	      index = _overload4[0];
	      length = _overload4[1];
	      formats = _overload4[2];
	      source = _overload4[3];
	
	      return modify.call(this, function () {
	        return _this5.editor.formatLine(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length, name, value, source) {
	      var _this6 = this;
	
	      var formats = void 0;
	
	      var _overload5 = overload(index, length, name, value, source);
	
	      var _overload6 = _slicedToArray(_overload5, 4);
	
	      index = _overload6[0];
	      length = _overload6[1];
	      formats = _overload6[2];
	      source = _overload6[3];
	
	      return modify.call(this, function () {
	        return _this6.editor.formatText(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var bounds = void 0;
	      if (typeof index === 'number') {
	        bounds = this.selection.getBounds(index, length);
	      } else {
	        bounds = this.selection.getBounds(index.index, index.length);
	      }
	      var containerBounds = this.container.getBoundingClientRect();
	      return {
	        bottom: bounds.bottom - containerBounds.top,
	        height: bounds.height,
	        left: bounds.left - containerBounds.left,
	        right: bounds.right - containerBounds.left,
	        top: bounds.top - containerBounds.top,
	        width: bounds.width
	      };
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	
	      var _overload7 = overload(index, length);
	
	      var _overload8 = _slicedToArray(_overload7, 2);
	
	      index = _overload8[0];
	      length = _overload8[1];
	
	      return this.editor.getContents(index, length);
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (typeof index === 'number') {
	        return this.editor.getFormat(index, length);
	      } else {
	        return this.editor.getFormat(index.index, index.length);
	      }
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(blot) {
	      return blot.offset(this.scroll);
	    }
	  }, {
	    key: 'getLength',
	    value: function getLength() {
	      return this.scroll.length();
	    }
	  }, {
	    key: 'getLeaf',
	    value: function getLeaf(index) {
	      return this.scroll.leaf(index);
	    }
	  }, {
	    key: 'getLine',
	    value: function getLine(index) {
	      return this.scroll.line(index);
	    }
	  }, {
	    key: 'getLines',
	    value: function getLines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	
	      if (typeof index !== 'number') {
	        return this.scroll.lines(index.index, index.length);
	      } else {
	        return this.scroll.lines(index, length);
	      }
	    }
	  }, {
	    key: 'getModule',
	    value: function getModule(name) {
	      return this.theme.modules[name];
	    }
	  }, {
	    key: 'getSelection',
	    value: function getSelection() {
	      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (focus) this.focus();
	      this.update(); // Make sure we access getRange with editor in consistent state
	      return this.selection.getRange()[0];
	    }
	  }, {
	    key: 'getText',
	    value: function getText() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	
	      var _overload9 = overload(index, length);
	
	      var _overload10 = _slicedToArray(_overload9, 2);
	
	      index = _overload10[0];
	      length = _overload10[1];
	
	      return this.editor.getText(index, length);
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return this.selection.hasFocus();
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      var _this7 = this;
	
	      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
	
	      return modify.call(this, function () {
	        return _this7.editor.insertEmbed(index, embed, value);
	      }, source, index);
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text, name, value, source) {
	      var _this8 = this;
	
	      var formats = void 0;
	
	      var _overload11 = overload(index, 0, name, value, source);
	
	      var _overload12 = _slicedToArray(_overload11, 4);
	
	      index = _overload12[0];
	      formats = _overload12[2];
	      source = _overload12[3];
	
	      return modify.call(this, function () {
	        return _this8.editor.insertText(index, text, formats);
	      }, source, index, text.length);
	    }
	  }, {
	    key: 'isEnabled',
	    value: function isEnabled() {
	      return !this.container.classList.contains('ql-disabled');
	    }
	  }, {
	    key: 'off',
	    value: function off() {
	      return this.emitter.off.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'on',
	    value: function on() {
	      return this.emitter.on.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'once',
	    value: function once() {
	      return this.emitter.once.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'pasteHTML',
	    value: function pasteHTML(index, html, source) {
	      this.clipboard.dangerouslyPasteHTML(index, html, source);
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length, source) {
	      var _this9 = this;
	
	      var _overload13 = overload(index, length, source);
	
	      var _overload14 = _slicedToArray(_overload13, 4);
	
	      index = _overload14[0];
	      length = _overload14[1];
	      source = _overload14[3];
	
	      return modify.call(this, function () {
	        return _this9.editor.removeFormat(index, length);
	      }, source, index);
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView() {
	      this.selection.scrollIntoView(this.scrollingContainer);
	    }
	  }, {
	    key: 'setContents',
	    value: function setContents(delta) {
	      var _this10 = this;
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        var length = _this10.getLength();
	        var deleted = _this10.editor.deleteText(0, length);
	        var applied = _this10.editor.applyDelta(delta);
	        var lastOp = applied.ops[applied.ops.length - 1];
	        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
	          _this10.editor.deleteText(_this10.getLength() - 1, 1);
	          applied.delete(1);
	        }
	        var ret = deleted.compose(applied);
	        return ret;
	      }, source);
	    }
	  }, {
	    key: 'setSelection',
	    value: function setSelection(index, length, source) {
	      if (index == null) {
	        this.selection.setRange(null, length || Quill.sources.API);
	      } else {
	        var _overload15 = overload(index, length, source);
	
	        var _overload16 = _slicedToArray(_overload15, 4);
	
	        index = _overload16[0];
	        length = _overload16[1];
	        source = _overload16[3];
	
	        this.selection.setRange(new _selection.Range(index, length), source);
	        if (source !== _emitter4.default.sources.SILENT) {
	          this.selection.scrollIntoView(this.scrollingContainer);
	        }
	      }
	    }
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      var delta = new _quillDelta2.default().insert(text);
	      return this.setContents(delta, source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
	
	      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
	      this.selection.update(source);
	      return change;
	    }
	  }, {
	    key: 'updateContents',
	    value: function updateContents(delta) {
	      var _this11 = this;
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        return _this11.editor.applyDelta(delta, source);
	      }, source, true);
	    }
	  }]);
	
	  return Quill;
	}();
	
	Quill.DEFAULTS = {
	  bounds: null,
	  formats: null,
	  modules: {},
	  placeholder: '',
	  readOnly: false,
	  scrollingContainer: null,
	  strict: true,
	  theme: 'default'
	};
	Quill.events = _emitter4.default.events;
	Quill.sources = _emitter4.default.sources;
	// eslint-disable-next-line no-undef
	Quill.version =  false ? 'dev' : "1.3.7";
	
	Quill.imports = {
	  'delta': _quillDelta2.default,
	  'parchment': _parchment2.default,
	  'core/module': _module2.default,
	  'core/theme': _theme2.default
	};
	
	function expandConfig(container, userConfig) {
	  userConfig = (0, _extend2.default)(true, {
	    container: container,
	    modules: {
	      clipboard: true,
	      keyboard: true,
	      history: true
	    }
	  }, userConfig);
	  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
	    userConfig.theme = _theme2.default;
	  } else {
	    userConfig.theme = Quill.import('themes/' + userConfig.theme);
	    if (userConfig.theme == null) {
	      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
	    }
	  }
	  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
	  [themeConfig, userConfig].forEach(function (config) {
	    config.modules = config.modules || {};
	    Object.keys(config.modules).forEach(function (module) {
	      if (config.modules[module] === true) {
	        config.modules[module] = {};
	      }
	    });
	  });
	  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
	  var moduleConfig = moduleNames.reduce(function (config, name) {
	    var moduleClass = Quill.import('modules/' + name);
	    if (moduleClass == null) {
	      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
	    } else {
	      config[name] = moduleClass.DEFAULTS || {};
	    }
	    return config;
	  }, {});
	  // Special case toolbar shorthand
	  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
	    userConfig.modules.toolbar = {
	      container: userConfig.modules.toolbar
	    };
	  }
	  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
	  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
	    if (typeof userConfig[key] === 'string') {
	      userConfig[key] = document.querySelector(userConfig[key]);
	    }
	  });
	  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
	    if (userConfig.modules[name]) {
	      config[name] = userConfig.modules[name];
	    }
	    return config;
	  }, {});
	  return userConfig;
	}
	
	// Handle selection preservation and TEXT_CHANGE emission
	// common to modification APIs
	function modify(modifier, source, index, shift) {
	  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
	    return new _quillDelta2.default();
	  }
	  var range = index == null ? null : this.getSelection();
	  var oldDelta = this.editor.delta;
	  var change = modifier();
	  if (range != null) {
	    if (index === true) index = range.index;
	    if (shift == null) {
	      range = shiftRange(range, change, source);
	    } else if (shift !== 0) {
	      range = shiftRange(range, index, shift, source);
	    }
	    this.setSelection(range, _emitter4.default.sources.SILENT);
	  }
	  if (change.length() > 0) {
	    var _emitter;
	
	    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
	    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	    if (source !== _emitter4.default.sources.SILENT) {
	      var _emitter2;
	
	      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	    }
	  }
	  return change;
	}
	
	function overload(index, length, name, value, source) {
	  var formats = {};
	  if (typeof index.index === 'number' && typeof index.length === 'number') {
	    // Allow for throwaway end (used by insertText/insertEmbed)
	    if (typeof length !== 'number') {
	      source = value, value = name, name = length, length = index.length, index = index.index;
	    } else {
	      length = index.length, index = index.index;
	    }
	  } else if (typeof length !== 'number') {
	    source = value, value = name, name = length, length = 0;
	  }
	  // Handle format being object, two format name/value strings or excluded
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    formats = name;
	    source = value;
	  } else if (typeof name === 'string') {
	    if (value != null) {
	      formats[name] = value;
	    } else {
	      source = name;
	    }
	  }
	  // Handle optional source
	  source = source || _emitter4.default.sources.API;
	  return [index, length, formats, source];
	}
	
	function shiftRange(range, index, length, source) {
	  if (range == null) return null;
	  var start = void 0,
	      end = void 0;
	  if (index instanceof _quillDelta2.default) {
	    var _map = [range.index, range.index + range.length].map(function (pos) {
	      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
	    });
	
	    var _map2 = _slicedToArray(_map, 2);
	
	    start = _map2[0];
	    end = _map2[1];
	  } else {
	    var _map3 = [range.index, range.index + range.length].map(function (pos) {
	      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
	      if (length >= 0) {
	        return pos + length;
	      } else {
	        return Math.max(index, pos + length);
	      }
	    });
	
	    var _map4 = _slicedToArray(_map3, 2);
	
	    start = _map4[0];
	    end = _map4[1];
	  }
	  return new _selection.Range(start, end - start);
	}
	
	exports.expandConfig = expandConfig;
	exports.overload = overload;
	exports.default = Quill;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Inline = function (_Parchment$Inline) {
	  _inherits(Inline, _Parchment$Inline);
	
	  function Inline() {
	    _classCallCheck(this, Inline);
	
	    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
	  }
	
	  _createClass(Inline, [{
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
	        var blot = this.isolate(index, length);
	        if (value) {
	          blot.wrap(name, value);
	        }
	      } else {
	        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
	      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
	        var parent = this.parent.isolate(this.offset(), this.length());
	        this.moveChildren(parent);
	        parent.wrap(this);
	      }
	    }
	  }], [{
	    key: 'compare',
	    value: function compare(self, other) {
	      var selfIndex = Inline.order.indexOf(self);
	      var otherIndex = Inline.order.indexOf(other);
	      if (selfIndex >= 0 || otherIndex >= 0) {
	        return selfIndex - otherIndex;
	      } else if (self === other) {
	        return 0;
	      } else if (self < other) {
	        return -1;
	      } else {
	        return 1;
	      }
	    }
	  }]);
	
	  return Inline;
	}(_parchment2.default.Inline);
	
	Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
	// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
	Inline.order = ['cursor', 'inline', // Must be lower
	'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
	];
	
	exports.default = Inline;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextBlot = function (_Parchment$Text) {
	  _inherits(TextBlot, _Parchment$Text);
	
	  function TextBlot() {
	    _classCallCheck(this, TextBlot);
	
	    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
	  }
	
	  return TextBlot;
	}(_parchment2.default.Text);
	
	exports.default = TextBlot;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _eventemitter = __webpack_require__(54);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:events');
	
	var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];
	
	EVENTS.forEach(function (eventName) {
	  document.addEventListener(eventName, function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
	      // TODO use WeakMap
	      if (node.__quill && node.__quill.emitter) {
	        var _node$__quill$emitter;
	
	        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
	      }
	    });
	  });
	});
	
	var Emitter = function (_EventEmitter) {
	  _inherits(Emitter, _EventEmitter);
	
	  function Emitter() {
	    _classCallCheck(this, Emitter);
	
	    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));
	
	    _this.listeners = {};
	    _this.on('error', debug.error);
	    return _this;
	  }
	
	  _createClass(Emitter, [{
	    key: 'emit',
	    value: function emit() {
	      debug.log.apply(debug, arguments);
	      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
	    }
	  }, {
	    key: 'handleDOM',
	    value: function handleDOM(event) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      (this.listeners[event.type] || []).forEach(function (_ref) {
	        var node = _ref.node,
	            handler = _ref.handler;
	
	        if (event.target === node || node.contains(event.target)) {
	          handler.apply(undefined, [event].concat(args));
	        }
	      });
	    }
	  }, {
	    key: 'listenDOM',
	    value: function listenDOM(eventName, node, handler) {
	      if (!this.listeners[eventName]) {
	        this.listeners[eventName] = [];
	      }
	      this.listeners[eventName].push({ node: node, handler: handler });
	    }
	  }]);
	
	  return Emitter;
	}(_eventemitter2.default);
	
	Emitter.events = {
	  EDITOR_CHANGE: 'editor-change',
	  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
	  SCROLL_OPTIMIZE: 'scroll-optimize',
	  SCROLL_UPDATE: 'scroll-update',
	  SELECTION_CHANGE: 'selection-change',
	  TEXT_CHANGE: 'text-change'
	};
	Emitter.sources = {
	  API: 'api',
	  SILENT: 'silent',
	  USER: 'user'
	};
	
	exports.default = Emitter;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Module = function Module(quill) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  _classCallCheck(this, Module);
	
	  this.quill = quill;
	  this.options = options;
	};
	
	Module.DEFAULTS = {};
	
	exports.default = Module;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var levels = ['error', 'warn', 'log', 'info'];
	var level = 'warn';
	
	function debug(method) {
	  if (levels.indexOf(method) <= levels.indexOf(level)) {
	    var _console;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
	  }
	}
	
	function namespace(ns) {
	  return levels.reduce(function (logger, method) {
	    logger[method] = debug.bind(console, method, ns);
	    return logger;
	  }, {});
	}
	
	debug.level = namespace.level = function (newLevel) {
	  level = newLevel;
	};
	
	exports.default = namespace;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(52);
	var isArguments = __webpack_require__(53);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var Attributor = /** @class */ (function () {
	    function Attributor(attrName, keyName, options) {
	        if (options === void 0) { options = {}; }
	        this.attrName = attrName;
	        this.keyName = keyName;
	        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
	        if (options.scope != null) {
	            // Ignore type bits, force attribute bit
	            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
	        }
	        else {
	            this.scope = Registry.Scope.ATTRIBUTE;
	        }
	        if (options.whitelist != null)
	            this.whitelist = options.whitelist;
	    }
	    Attributor.keys = function (node) {
	        return [].map.call(node.attributes, function (item) {
	            return item.name;
	        });
	    };
	    Attributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        node.setAttribute(this.keyName, value);
	        return true;
	    };
	    Attributor.prototype.canAdd = function (node, value) {
	        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
	        if (match == null)
	            return false;
	        if (this.whitelist == null)
	            return true;
	        if (typeof value === 'string') {
	            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
	        }
	        else {
	            return this.whitelist.indexOf(value) > -1;
	        }
	    };
	    Attributor.prototype.remove = function (node) {
	        node.removeAttribute(this.keyName);
	    };
	    Attributor.prototype.value = function (node) {
	        var value = node.getAttribute(this.keyName);
	        if (this.canAdd(node, value) && value) {
	            return value;
	        }
	        return '';
	    };
	    return Attributor;
	}());
	exports.default = Attributor;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Code = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Code = function (_Inline) {
	  _inherits(Code, _Inline);
	
	  function Code() {
	    _classCallCheck(this, Code);
	
	    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
	  }
	
	  return Code;
	}(_inline2.default);
	
	Code.blotName = 'code';
	Code.tagName = 'CODE';
	
	var CodeBlock = function (_Block) {
	  _inherits(CodeBlock, _Block);
	
	  function CodeBlock() {
	    _classCallCheck(this, CodeBlock);
	
	    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
	  }
	
	  _createClass(CodeBlock, [{
	    key: 'delta',
	    value: function delta() {
	      var _this3 = this;
	
	      var text = this.domNode.textContent;
	      if (text.endsWith('\n')) {
	        // Should always be true
	        text = text.slice(0, -1);
	      }
	      return text.split('\n').reduce(function (delta, frag) {
	        return delta.insert(frag).insert('\n', _this3.formats());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (name === this.statics.blotName && value) return;
	
	      var _descendant = this.descendant(_text2.default, this.length() - 1),
	          _descendant2 = _slicedToArray(_descendant, 1),
	          text = _descendant2[0];
	
	      if (text != null) {
	        text.deleteAt(text.length() - 1, 1);
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length === 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
	        return;
	      }
	      var nextNewline = this.newlineIndex(index);
	      if (nextNewline < 0 || nextNewline >= index + length) return;
	      var prevNewline = this.newlineIndex(index, true) + 1;
	      var isolateLength = nextNewline - prevNewline + 1;
	      var blot = this.isolate(prevNewline, isolateLength);
	      var next = blot.next;
	      blot.format(name, value);
	      if (next instanceof CodeBlock) {
	        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
	      }
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return;
	
	      var _descendant3 = this.descendant(_text2.default, index),
	          _descendant4 = _slicedToArray(_descendant3, 2),
	          text = _descendant4[0],
	          offset = _descendant4[1];
	
	      text.insertAt(offset, value);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      var length = this.domNode.textContent.length;
	      if (!this.domNode.textContent.endsWith('\n')) {
	        return length + 1;
	      }
	      return length;
	    }
	  }, {
	    key: 'newlineIndex',
	    value: function newlineIndex(searchIndex) {
	      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!reverse) {
	        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
	        return offset > -1 ? searchIndex + offset : -1;
	      } else {
	        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      if (!this.domNode.textContent.endsWith('\n')) {
	        this.appendChild(_parchment2.default.create('text', '\n'));
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
	        next.optimize(context);
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
	      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
	        var blot = _parchment2.default.find(node);
	        if (blot == null) {
	          node.parentNode.removeChild(node);
	        } else if (blot instanceof _parchment2.default.Embed) {
	          blot.remove();
	        } else {
	          blot.unwrap();
	        }
	      });
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
	      domNode.setAttribute('spellcheck', false);
	      return domNode;
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);
	
	  return CodeBlock;
	}(_block2.default);
	
	CodeBlock.blotName = 'code-block';
	CodeBlock.tagName = 'PRE';
	CodeBlock.TAB = '  ';
	
	exports.Code = Code;
	exports.default = CodeBlock;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _op = __webpack_require__(20);
	
	var _op2 = _interopRequireDefault(_op);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _cursor = __webpack_require__(24);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ASCII = /^[ -~]*$/;
	
	var Editor = function () {
	  function Editor(scroll) {
	    _classCallCheck(this, Editor);
	
	    this.scroll = scroll;
	    this.delta = this.getDelta();
	  }
	
	  _createClass(Editor, [{
	    key: 'applyDelta',
	    value: function applyDelta(delta) {
	      var _this = this;
	
	      var consumeNextNewline = false;
	      this.scroll.update();
	      var scrollLength = this.scroll.length();
	      this.scroll.batchStart();
	      delta = normalizeDelta(delta);
	      delta.reduce(function (index, op) {
	        var length = op.retain || op.delete || op.insert.length || 1;
	        var attributes = op.attributes || {};
	        if (op.insert != null) {
	          if (typeof op.insert === 'string') {
	            var text = op.insert;
	            if (text.endsWith('\n') && consumeNextNewline) {
	              consumeNextNewline = false;
	              text = text.slice(0, -1);
	            }
	            if (index >= scrollLength && !text.endsWith('\n')) {
	              consumeNextNewline = true;
	            }
	            _this.scroll.insertAt(index, text);
	
	            var _scroll$line = _this.scroll.line(index),
	                _scroll$line2 = _slicedToArray(_scroll$line, 2),
	                line = _scroll$line2[0],
	                offset = _scroll$line2[1];
	
	            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
	            if (line instanceof _block2.default) {
	              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
	                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
	                  leaf = _line$descendant2[0];
	
	              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
	            }
	            attributes = _op2.default.attributes.diff(formats, attributes) || {};
	          } else if (_typeof(op.insert) === 'object') {
	            var key = Object.keys(op.insert)[0]; // There should only be one key
	            if (key == null) return index;
	            _this.scroll.insertAt(index, key, op.insert[key]);
	          }
	          scrollLength += length;
	        }
	        Object.keys(attributes).forEach(function (name) {
	          _this.scroll.formatAt(index, length, name, attributes[name]);
	        });
	        return index + length;
	      }, 0);
	      delta.reduce(function (index, op) {
	        if (typeof op.delete === 'number') {
	          _this.scroll.deleteAt(index, op.delete);
	          return index;
	        }
	        return index + (op.retain || op.insert.length || 1);
	      }, 0);
	      this.scroll.batchEnd();
	      return this.update(delta);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length) {
	      this.scroll.deleteAt(index, length);
	      return this.update(new _quillDelta2.default().retain(index).delete(length));
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length) {
	      var _this2 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      this.scroll.update();
	      Object.keys(formats).forEach(function (format) {
	        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
	        var lines = _this2.scroll.lines(index, Math.max(length, 1));
	        var lengthRemaining = length;
	        lines.forEach(function (line) {
	          var lineLength = line.length();
	          if (!(line instanceof _code2.default)) {
	            line.format(format, formats[format]);
	          } else {
	            var codeIndex = index - line.offset(_this2.scroll);
	            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
	            line.formatAt(codeIndex, codeLength, format, formats[format]);
	          }
	          lengthRemaining -= lineLength;
	        });
	      });
	      this.scroll.optimize();
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length) {
	      var _this3 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      Object.keys(formats).forEach(function (format) {
	        _this3.scroll.formatAt(index, length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents(index, length) {
	      return this.delta.slice(index, index + length);
	    }
	  }, {
	    key: 'getDelta',
	    value: function getDelta() {
	      return this.scroll.lines().reduce(function (delta, line) {
	        return delta.concat(line.delta());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var lines = [],
	          leaves = [];
	      if (length === 0) {
	        this.scroll.path(index).forEach(function (path) {
	          var _path = _slicedToArray(path, 1),
	              blot = _path[0];
	
	          if (blot instanceof _block2.default) {
	            lines.push(blot);
	          } else if (blot instanceof _parchment2.default.Leaf) {
	            leaves.push(blot);
	          }
	        });
	      } else {
	        lines = this.scroll.lines(index, length);
	        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
	      }
	      var formatsArr = [lines, leaves].map(function (blots) {
	        if (blots.length === 0) return {};
	        var formats = (0, _block.bubbleFormats)(blots.shift());
	        while (Object.keys(formats).length > 0) {
	          var blot = blots.shift();
	          if (blot == null) return formats;
	          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
	        }
	        return formats;
	      });
	      return _extend2.default.apply(_extend2.default, formatsArr);
	    }
	  }, {
	    key: 'getText',
	    value: function getText(index, length) {
	      return this.getContents(index, length).filter(function (op) {
	        return typeof op.insert === 'string';
	      }).map(function (op) {
	        return op.insert;
	      }).join('');
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      this.scroll.insertAt(index, embed, value);
	      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text) {
	      var _this4 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      this.scroll.insertAt(index, text);
	      Object.keys(formats).forEach(function (format) {
	        _this4.scroll.formatAt(index, text.length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'isBlank',
	    value: function isBlank() {
	      if (this.scroll.children.length == 0) return true;
	      if (this.scroll.children.length > 1) return false;
	      var block = this.scroll.children.head;
	      if (block.statics.blotName !== _block2.default.blotName) return false;
	      if (block.children.length > 1) return false;
	      return block.children.head instanceof _break2.default;
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length) {
	      var text = this.getText(index, length);
	
	      var _scroll$line3 = this.scroll.line(index + length),
	          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
	          line = _scroll$line4[0],
	          offset = _scroll$line4[1];
	
	      var suffixLength = 0,
	          suffix = new _quillDelta2.default();
	      if (line != null) {
	        if (!(line instanceof _code2.default)) {
	          suffixLength = line.length() - offset;
	        } else {
	          suffixLength = line.newlineIndex(offset) - offset + 1;
	        }
	        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
	      }
	      var contents = this.getContents(index, length + suffixLength);
	      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
	      var delta = new _quillDelta2.default().retain(index).concat(diff);
	      return this.applyDelta(delta);
	    }
	  }, {
	    key: 'update',
	    value: function update(change) {
	      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	      var oldDelta = this.delta;
	      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
	        // Optimization for character changes
	        var textBlot = _parchment2.default.find(mutations[0].target);
	        var formats = (0, _block.bubbleFormats)(textBlot);
	        var index = textBlot.offset(this.scroll);
	        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
	        var oldText = new _quillDelta2.default().insert(oldValue);
	        var newText = new _quillDelta2.default().insert(textBlot.value());
	        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
	        change = diffDelta.reduce(function (delta, op) {
	          if (op.insert) {
	            return delta.insert(op.insert, formats);
	          } else {
	            return delta.push(op);
	          }
	        }, new _quillDelta2.default());
	        this.delta = oldDelta.compose(change);
	      } else {
	        this.delta = this.getDelta();
	        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
	          change = oldDelta.diff(this.delta, cursorIndex);
	        }
	      }
	      return change;
	    }
	  }]);
	
	  return Editor;
	}();
	
	function combineFormats(formats, combined) {
	  return Object.keys(combined).reduce(function (merged, name) {
	    if (formats[name] == null) return merged;
	    if (combined[name] === formats[name]) {
	      merged[name] = combined[name];
	    } else if (Array.isArray(combined[name])) {
	      if (combined[name].indexOf(formats[name]) < 0) {
	        merged[name] = combined[name].concat([formats[name]]);
	      }
	    } else {
	      merged[name] = [combined[name], formats[name]];
	    }
	    return merged;
	  }, {});
	}
	
	function normalizeDelta(delta) {
	  return delta.reduce(function (delta, op) {
	    if (op.insert === 1) {
	      var attributes = (0, _clone2.default)(op.attributes);
	      delete attributes['image'];
	      return delta.insert({ image: op.attributes.image }, attributes);
	    }
	    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
	      op = (0, _clone2.default)(op);
	      if (op.attributes.list) {
	        op.attributes.list = 'ordered';
	      } else {
	        op.attributes.list = 'bullet';
	        delete op.attributes.bullet;
	      }
	    }
	    if (typeof op.insert === 'string') {
	      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      return delta.insert(text, op.attributes);
	    }
	    return delta.push(op);
	  }, new _quillDelta2.default());
	}
	
	exports.default = Editor;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Range = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _emitter3 = __webpack_require__(8);
	
	var _emitter4 = _interopRequireDefault(_emitter3);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var debug = (0, _logger2.default)('quill:selection');
	
	var Range = function Range(index) {
	  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  _classCallCheck(this, Range);
	
	  this.index = index;
	  this.length = length;
	};
	
	var Selection = function () {
	  function Selection(scroll, emitter) {
	    var _this = this;
	
	    _classCallCheck(this, Selection);
	
	    this.emitter = emitter;
	    this.scroll = scroll;
	    this.composing = false;
	    this.mouseDown = false;
	    this.root = this.scroll.domNode;
	    this.cursor = _parchment2.default.create('cursor', this);
	    // savedRange is last non-null range
	    this.lastRange = this.savedRange = new Range(0, 0);
	    this.handleComposition();
	    this.handleDragging();
	    this.emitter.listenDOM('selectionchange', document, function () {
	      if (!_this.mouseDown) {
	        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
	      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
	        _this.update(_emitter4.default.sources.SILENT);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
	      if (!_this.hasFocus()) return;
	      var native = _this.getNativeRange();
	      if (native == null) return;
	      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
	      // TODO unclear if this has negative side effects
	      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
	        try {
	          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
	        } catch (ignored) {}
	      });
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
	      if (context.range) {
	        var _context$range = context.range,
	            startNode = _context$range.startNode,
	            startOffset = _context$range.startOffset,
	            endNode = _context$range.endNode,
	            endOffset = _context$range.endOffset;
	
	        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
	      }
	    });
	    this.update(_emitter4.default.sources.SILENT);
	  }
	
	  _createClass(Selection, [{
	    key: 'handleComposition',
	    value: function handleComposition() {
	      var _this2 = this;
	
	      this.root.addEventListener('compositionstart', function () {
	        _this2.composing = true;
	      });
	      this.root.addEventListener('compositionend', function () {
	        _this2.composing = false;
	        if (_this2.cursor.parent) {
	          var range = _this2.cursor.restore();
	          if (!range) return;
	          setTimeout(function () {
	            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
	          }, 1);
	        }
	      });
	    }
	  }, {
	    key: 'handleDragging',
	    value: function handleDragging() {
	      var _this3 = this;
	
	      this.emitter.listenDOM('mousedown', document.body, function () {
	        _this3.mouseDown = true;
	      });
	      this.emitter.listenDOM('mouseup', document.body, function () {
	        _this3.mouseDown = false;
	        _this3.update(_emitter4.default.sources.USER);
	      });
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.hasFocus()) return;
	      this.root.focus();
	      this.setRange(this.savedRange);
	    }
	  }, {
	    key: 'format',
	    value: function format(_format, value) {
	      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
	      this.scroll.update();
	      var nativeRange = this.getNativeRange();
	      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
	      if (nativeRange.start.node !== this.cursor.textNode) {
	        var blot = _parchment2.default.find(nativeRange.start.node, false);
	        if (blot == null) return;
	        // TODO Give blot ability to not split
	        if (blot instanceof _parchment2.default.Leaf) {
	          var after = blot.split(nativeRange.start.offset);
	          blot.parent.insertBefore(this.cursor, after);
	        } else {
	          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
	        }
	        this.cursor.attach();
	      }
	      this.cursor.format(_format, value);
	      this.scroll.optimize();
	      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
	      this.update();
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var scrollLength = this.scroll.length();
	      index = Math.min(index, scrollLength - 1);
	      length = Math.min(index + length, scrollLength - 1) - index;
	      var node = void 0,
	          _scroll$leaf = this.scroll.leaf(index),
	          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
	          leaf = _scroll$leaf2[0],
	          offset = _scroll$leaf2[1];
	      if (leaf == null) return null;
	
	      var _leaf$position = leaf.position(offset, true);
	
	      var _leaf$position2 = _slicedToArray(_leaf$position, 2);
	
	      node = _leaf$position2[0];
	      offset = _leaf$position2[1];
	
	      var range = document.createRange();
	      if (length > 0) {
	        range.setStart(node, offset);
	
	        var _scroll$leaf3 = this.scroll.leaf(index + length);
	
	        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
	
	        leaf = _scroll$leaf4[0];
	        offset = _scroll$leaf4[1];
	
	        if (leaf == null) return null;
	
	        var _leaf$position3 = leaf.position(offset, true);
	
	        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
	
	        node = _leaf$position4[0];
	        offset = _leaf$position4[1];
	
	        range.setEnd(node, offset);
	        return range.getBoundingClientRect();
	      } else {
	        var side = 'left';
	        var rect = void 0;
	        if (node instanceof Text) {
	          if (offset < node.data.length) {
	            range.setStart(node, offset);
	            range.setEnd(node, offset + 1);
	          } else {
	            range.setStart(node, offset - 1);
	            range.setEnd(node, offset);
	            side = 'right';
	          }
	          rect = range.getBoundingClientRect();
	        } else {
	          rect = leaf.domNode.getBoundingClientRect();
	          if (offset > 0) side = 'right';
	        }
	        return {
	          bottom: rect.top + rect.height,
	          height: rect.height,
	          left: rect[side],
	          right: rect[side],
	          top: rect.top,
	          width: 0
	        };
	      }
	    }
	  }, {
	    key: 'getNativeRange',
	    value: function getNativeRange() {
	      var selection = document.getSelection();
	      if (selection == null || selection.rangeCount <= 0) return null;
	      var nativeRange = selection.getRangeAt(0);
	      if (nativeRange == null) return null;
	      var range = this.normalizeNative(nativeRange);
	      debug.info('getNativeRange', range);
	      return range;
	    }
	  }, {
	    key: 'getRange',
	    value: function getRange() {
	      var normalized = this.getNativeRange();
	      if (normalized == null) return [null, null];
	      var range = this.normalizedToRange(normalized);
	      return [range, normalized];
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return document.activeElement === this.root;
	    }
	  }, {
	    key: 'normalizedToRange',
	    value: function normalizedToRange(range) {
	      var _this4 = this;
	
	      var positions = [[range.start.node, range.start.offset]];
	      if (!range.native.collapsed) {
	        positions.push([range.end.node, range.end.offset]);
	      }
	      var indexes = positions.map(function (position) {
	        var _position = _slicedToArray(position, 2),
	            node = _position[0],
	            offset = _position[1];
	
	        var blot = _parchment2.default.find(node, true);
	        var index = blot.offset(_this4.scroll);
	        if (offset === 0) {
	          return index;
	        } else if (blot instanceof _parchment2.default.Container) {
	          return index + blot.length();
	        } else {
	          return index + blot.index(node, offset);
	        }
	      });
	      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
	      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
	      return new Range(start, end - start);
	    }
	  }, {
	    key: 'normalizeNative',
	    value: function normalizeNative(nativeRange) {
	      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
	        return null;
	      }
	      var range = {
	        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
	        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
	        native: nativeRange
	      };
	      [range.start, range.end].forEach(function (position) {
	        var node = position.node,
	            offset = position.offset;
	        while (!(node instanceof Text) && node.childNodes.length > 0) {
	          if (node.childNodes.length > offset) {
	            node = node.childNodes[offset];
	            offset = 0;
	          } else if (node.childNodes.length === offset) {
	            node = node.lastChild;
	            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
	          } else {
	            break;
	          }
	        }
	        position.node = node, position.offset = offset;
	      });
	      return range;
	    }
	  }, {
	    key: 'rangeToNative',
	    value: function rangeToNative(range) {
	      var _this5 = this;
	
	      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
	      var args = [];
	      var scrollLength = this.scroll.length();
	      indexes.forEach(function (index, i) {
	        index = Math.min(scrollLength - 1, index);
	        var node = void 0,
	            _scroll$leaf5 = _this5.scroll.leaf(index),
	            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
	            leaf = _scroll$leaf6[0],
	            offset = _scroll$leaf6[1];
	        var _leaf$position5 = leaf.position(offset, i !== 0);
	
	        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
	
	        node = _leaf$position6[0];
	        offset = _leaf$position6[1];
	
	        args.push(node, offset);
	      });
	      if (args.length < 2) {
	        args = args.concat(args);
	      }
	      return args;
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView(scrollingContainer) {
	      var range = this.lastRange;
	      if (range == null) return;
	      var bounds = this.getBounds(range.index, range.length);
	      if (bounds == null) return;
	      var limit = this.scroll.length() - 1;
	
	      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
	          _scroll$line2 = _slicedToArray(_scroll$line, 1),
	          first = _scroll$line2[0];
	
	      var last = first;
	      if (range.length > 0) {
	        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
	
	        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
	
	        last = _scroll$line4[0];
	      }
	      if (first == null || last == null) return;
	      var scrollBounds = scrollingContainer.getBoundingClientRect();
	      if (bounds.top < scrollBounds.top) {
	        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
	      } else if (bounds.bottom > scrollBounds.bottom) {
	        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
	      }
	    }
	  }, {
	    key: 'setNativeRange',
	    value: function setNativeRange(startNode, startOffset) {
	      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
	      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
	      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
	      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
	        return;
	      }
	      var selection = document.getSelection();
	      if (selection == null) return;
	      if (startNode != null) {
	        if (!this.hasFocus()) this.root.focus();
	        var native = (this.getNativeRange() || {}).native;
	        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
	
	          if (startNode.tagName == "BR") {
	            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
	            startNode = startNode.parentNode;
	          }
	          if (endNode.tagName == "BR") {
	            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
	            endNode = endNode.parentNode;
	          }
	          var range = document.createRange();
	          range.setStart(startNode, startOffset);
	          range.setEnd(endNode, endOffset);
	          selection.removeAllRanges();
	          selection.addRange(range);
	        }
	      } else {
	        selection.removeAllRanges();
	        this.root.blur();
	        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
	      }
	    }
	  }, {
	    key: 'setRange',
	    value: function setRange(range) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
	
	      if (typeof force === 'string') {
	        source = force;
	        force = false;
	      }
	      debug.info('setRange', range);
	      if (range != null) {
	        var args = this.rangeToNative(range);
	        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
	      } else {
	        this.setNativeRange(null);
	      }
	      this.update(source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
	
	      var oldRange = this.lastRange;
	
	      var _getRange = this.getRange(),
	          _getRange2 = _slicedToArray(_getRange, 2),
	          lastRange = _getRange2[0],
	          nativeRange = _getRange2[1];
	
	      this.lastRange = lastRange;
	      if (this.lastRange != null) {
	        this.savedRange = this.lastRange;
	      }
	      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
	        var _emitter;
	
	        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
	          this.cursor.restore();
	        }
	        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
	        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	        if (source !== _emitter4.default.sources.SILENT) {
	          var _emitter2;
	
	          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	        }
	      }
	    }
	  }]);
	
	  return Selection;
	}();
	
	function contains(parent, descendant) {
	  try {
	    // Firefox inserts inaccessible nodes around video elements
	    descendant.parentNode;
	  } catch (e) {
	    return false;
	  }
	  // IE11 has bug with Text nodes
	  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
	  if (descendant instanceof Text) {
	    descendant = descendant.parentNode;
	  }
	  return parent.contains(descendant);
	}
	
	exports.Range = Range;
	exports.default = Selection;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Break = function (_Parchment$Embed) {
	  _inherits(Break, _Parchment$Embed);
	
	  function Break() {
	    _classCallCheck(this, Break);
	
	    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
	  }
	
	  _createClass(Break, [{
	    key: 'insertInto',
	    value: function insertInto(parent, ref) {
	      if (parent.children.length === 0) {
	        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
	      } else {
	        this.remove();
	      }
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return 0;
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }], [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);
	
	  return Break;
	}(_parchment2.default.Embed);
	
	Break.blotName = 'break';
	Break.tagName = 'BR';
	
	exports.default = Break;
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var linked_list_1 = __webpack_require__(44);
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var ContainerBlot = /** @class */ (function (_super) {
	    __extends(ContainerBlot, _super);
	    function ContainerBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.build();
	        return _this;
	    }
	    ContainerBlot.prototype.appendChild = function (other) {
	        this.insertBefore(other);
	    };
	    ContainerBlot.prototype.attach = function () {
	        _super.prototype.attach.call(this);
	        this.children.forEach(function (child) {
	            child.attach();
	        });
	    };
	    ContainerBlot.prototype.build = function () {
	        var _this = this;
	        this.children = new linked_list_1.default();
	        // Need to be reversed for if DOM nodes already in order
	        [].slice
	            .call(this.domNode.childNodes)
	            .reverse()
	            .forEach(function (node) {
	            try {
	                var child = makeBlot(node);
	                _this.insertBefore(child, _this.children.head || undefined);
	            }
	            catch (err) {
	                if (err instanceof Registry.ParchmentError)
	                    return;
	                else
	                    throw err;
	            }
	        });
	    };
	    ContainerBlot.prototype.deleteAt = function (index, length) {
	        if (index === 0 && length === this.length()) {
	            return this.remove();
	        }
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.deleteAt(offset, length);
	        });
	    };
	    ContainerBlot.prototype.descendant = function (criteria, index) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if ((criteria.blotName == null && criteria(child)) ||
	            (criteria.blotName != null && child instanceof criteria)) {
	            return [child, offset];
	        }
	        else if (child instanceof ContainerBlot) {
	            return child.descendant(criteria, offset);
	        }
	        else {
	            return [null, -1];
	        }
	    };
	    ContainerBlot.prototype.descendants = function (criteria, index, length) {
	        if (index === void 0) { index = 0; }
	        if (length === void 0) { length = Number.MAX_VALUE; }
	        var descendants = [];
	        var lengthLeft = length;
	        this.children.forEachAt(index, length, function (child, index, length) {
	            if ((criteria.blotName == null && criteria(child)) ||
	                (criteria.blotName != null && child instanceof criteria)) {
	                descendants.push(child);
	            }
	            if (child instanceof ContainerBlot) {
	                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
	            }
	            lengthLeft -= length;
	        });
	        return descendants;
	    };
	    ContainerBlot.prototype.detach = function () {
	        this.children.forEach(function (child) {
	            child.detach();
	        });
	        _super.prototype.detach.call(this);
	    };
	    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.formatAt(offset, length, name, value);
	        });
	    };
	    ContainerBlot.prototype.insertAt = function (index, value, def) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if (child) {
	            child.insertAt(offset, value, def);
	        }
	        else {
	            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	            this.appendChild(blot);
	        }
	    };
	    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
	        if (this.statics.allowedChildren != null &&
	            !this.statics.allowedChildren.some(function (child) {
	                return childBlot instanceof child;
	            })) {
	            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
	        }
	        childBlot.insertInto(this, refBlot);
	    };
	    ContainerBlot.prototype.length = function () {
	        return this.children.reduce(function (memo, child) {
	            return memo + child.length();
	        }, 0);
	    };
	    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
	        this.children.forEach(function (child) {
	            targetParent.insertBefore(child, refNode);
	        });
	    };
	    ContainerBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        if (this.children.length === 0) {
	            if (this.statics.defaultChild != null) {
	                var child = Registry.create(this.statics.defaultChild);
	                this.appendChild(child);
	                child.optimize(context);
	            }
	            else {
	                this.remove();
	            }
	        }
	    };
	    ContainerBlot.prototype.path = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
	        var position = [[this, index]];
	        if (child instanceof ContainerBlot) {
	            return position.concat(child.path(offset, inclusive));
	        }
	        else if (child != null) {
	            position.push([child, offset]);
	        }
	        return position;
	    };
	    ContainerBlot.prototype.removeChild = function (child) {
	        this.children.remove(child);
	    };
	    ContainerBlot.prototype.replace = function (target) {
	        if (target instanceof ContainerBlot) {
	            target.moveChildren(this);
	        }
	        _super.prototype.replace.call(this, target);
	    };
	    ContainerBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = this.clone();
	        this.parent.insertBefore(after, this.next);
	        this.children.forEachAt(index, this.length(), function (child, offset, length) {
	            child = child.split(offset, force);
	            after.appendChild(child);
	        });
	        return after;
	    };
	    ContainerBlot.prototype.unwrap = function () {
	        this.moveChildren(this.parent, this.next);
	        this.remove();
	    };
	    ContainerBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        var addedNodes = [];
	        var removedNodes = [];
	        mutations.forEach(function (mutation) {
	            if (mutation.target === _this.domNode && mutation.type === 'childList') {
	                addedNodes.push.apply(addedNodes, mutation.addedNodes);
	                removedNodes.push.apply(removedNodes, mutation.removedNodes);
	            }
	        });
	        removedNodes.forEach(function (node) {
	            // Check node has actually been removed
	            // One exception is Chrome does not immediately remove IFRAMEs
	            // from DOM but MutationRecord is correct in its reported removal
	            if (node.parentNode != null &&
	                // @ts-ignore
	                node.tagName !== 'IFRAME' &&
	                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	                return;
	            }
	            var blot = Registry.find(node);
	            if (blot == null)
	                return;
	            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
	                blot.detach();
	            }
	        });
	        addedNodes
	            .filter(function (node) {
	            return node.parentNode == _this.domNode;
	        })
	            .sort(function (a, b) {
	            if (a === b)
	                return 0;
	            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
	                return 1;
	            }
	            return -1;
	        })
	            .forEach(function (node) {
	            var refBlot = null;
	            if (node.nextSibling != null) {
	                refBlot = Registry.find(node.nextSibling);
	            }
	            var blot = makeBlot(node);
	            if (blot.next != refBlot || blot.next == null) {
	                if (blot.parent != null) {
	                    blot.parent.removeChild(_this);
	                }
	                _this.insertBefore(blot, refBlot || undefined);
	            }
	        });
	    };
	    return ContainerBlot;
	}(shadow_1.default));
	function makeBlot(node) {
	    var blot = Registry.find(node);
	    if (blot == null) {
	        try {
	            blot = Registry.create(node);
	        }
	        catch (e) {
	            blot = Registry.create(Registry.Scope.INLINE);
	            [].slice.call(node.childNodes).forEach(function (child) {
	                // @ts-ignore
	                blot.domNode.appendChild(child);
	            });
	            if (node.parentNode) {
	                node.parentNode.replaceChild(blot.domNode, node);
	            }
	            blot.attach();
	        }
	    }
	    return blot;
	}
	exports.default = ContainerBlot;
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var store_1 = __webpack_require__(31);
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var FormatBlot = /** @class */ (function (_super) {
	    __extends(FormatBlot, _super);
	    function FormatBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.attributes = new store_1.default(_this.domNode);
	        return _this;
	    }
	    FormatBlot.formats = function (domNode) {
	        if (typeof this.tagName === 'string') {
	            return true;
	        }
	        else if (Array.isArray(this.tagName)) {
	            return domNode.tagName.toLowerCase();
	        }
	        return undefined;
	    };
	    FormatBlot.prototype.format = function (name, value) {
	        var format = Registry.query(name);
	        if (format instanceof attributor_1.default) {
	            this.attributes.attribute(format, value);
	        }
	        else if (value) {
	            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
	                this.replaceWith(name, value);
	            }
	        }
	    };
	    FormatBlot.prototype.formats = function () {
	        var formats = this.attributes.values();
	        var format = this.statics.formats(this.domNode);
	        if (format != null) {
	            formats[this.statics.blotName] = format;
	        }
	        return formats;
	    };
	    FormatBlot.prototype.replaceWith = function (name, value) {
	        var replacement = _super.prototype.replaceWith.call(this, name, value);
	        this.attributes.copy(replacement);
	        return replacement;
	    };
	    FormatBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        _super.prototype.update.call(this, mutations, context);
	        if (mutations.some(function (mutation) {
	            return mutation.target === _this.domNode && mutation.type === 'attributes';
	        })) {
	            this.attributes.build();
	        }
	    };
	    FormatBlot.prototype.wrap = function (name, value) {
	        var wrapper = _super.prototype.wrap.call(this, name, value);
	        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
	            this.attributes.move(wrapper);
	        }
	        return wrapper;
	    };
	    return FormatBlot;
	}(container_1.default));
	exports.default = FormatBlot;
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var LeafBlot = /** @class */ (function (_super) {
	    __extends(LeafBlot, _super);
	    function LeafBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LeafBlot.value = function (domNode) {
	        return true;
	    };
	    LeafBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node ||
	            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	            return Math.min(offset, 1);
	        }
	        return -1;
	    };
	    LeafBlot.prototype.position = function (index, inclusive) {
	        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
	        if (index > 0)
	            offset += 1;
	        return [this.parent.domNode, offset];
	    };
	    LeafBlot.prototype.value = function () {
	        var _a;
	        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
	    };
	    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
	    return LeafBlot;
	}(shadow_1.default));
	exports.default = LeafBlot;
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	
	
	var lib = {
	  attributes: {
	    compose: function (a, b, keepNull) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = extend(true, {}, b);
	      if (!keepNull) {
	        attributes = Object.keys(attributes).reduce(function (copy, key) {
	          if (attributes[key] != null) {
	            copy[key] = attributes[key];
	          }
	          return copy;
	        }, {});
	      }
	      for (var key in a) {
	        if (a[key] !== undefined && b[key] === undefined) {
	          attributes[key] = a[key];
	        }
	      }
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },
	
	    diff: function(a, b) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
	        if (!equal(a[key], b[key])) {
	          attributes[key] = b[key] === undefined ? null : b[key];
	        }
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },
	
	    transform: function (a, b, priority) {
	      if (typeof a !== 'object') return b;
	      if (typeof b !== 'object') return undefined;
	      if (!priority) return b;  // b simply overwrites us without priority
	      var attributes = Object.keys(b).reduce(function (attributes, key) {
	        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    }
	  },
	
	  iterator: function (ops) {
	    return new Iterator(ops);
	  },
	
	  length: function (op) {
	    if (typeof op['delete'] === 'number') {
	      return op['delete'];
	    } else if (typeof op.retain === 'number') {
	      return op.retain;
	    } else {
	      return typeof op.insert === 'string' ? op.insert.length : 1;
	    }
	  }
	};
	
	
	function Iterator(ops) {
	  this.ops = ops;
	  this.index = 0;
	  this.offset = 0;
	};
	
	Iterator.prototype.hasNext = function () {
	  return this.peekLength() < Infinity;
	};
	
	Iterator.prototype.next = function (length) {
	  if (!length) length = Infinity;
	  var nextOp = this.ops[this.index];
	  if (nextOp) {
	    var offset = this.offset;
	    var opLength = lib.length(nextOp)
	    if (length >= opLength - offset) {
	      length = opLength - offset;
	      this.index += 1;
	      this.offset = 0;
	    } else {
	      this.offset += length;
	    }
	    if (typeof nextOp['delete'] === 'number') {
	      return { 'delete': length };
	    } else {
	      var retOp = {};
	      if (nextOp.attributes) {
	        retOp.attributes = nextOp.attributes;
	      }
	      if (typeof nextOp.retain === 'number') {
	        retOp.retain = length;
	      } else if (typeof nextOp.insert === 'string') {
	        retOp.insert = nextOp.insert.substr(offset, length);
	      } else {
	        // offset should === 0, length should === 1
	        retOp.insert = nextOp.insert;
	      }
	      return retOp;
	    }
	  } else {
	    return { retain: Infinity };
	  }
	};
	
	Iterator.prototype.peek = function () {
	  return this.ops[this.index];
	};
	
	Iterator.prototype.peekLength = function () {
	  if (this.ops[this.index]) {
	    // Should never return 0 if our index is being managed correctly
	    return lib.length(this.ops[this.index]) - this.offset;
	  } else {
	    return Infinity;
	  }
	};
	
	Iterator.prototype.peekType = function () {
	  if (this.ops[this.index]) {
	    if (typeof this.ops[this.index]['delete'] === 'number') {
	      return 'delete';
	    } else if (typeof this.ops[this.index].retain === 'number') {
	      return 'retain';
	    } else {
	      return 'insert';
	    }
	  }
	  return 'retain';
	};
	
	Iterator.prototype.rest = function () {
	  if (!this.hasNext()) {
	    return [];
	  } else if (this.offset === 0) {
	    return this.ops.slice(this.index);
	  } else {
	    var offset = this.offset;
	    var index = this.index;
	    var next = this.next();
	    var rest = this.ops.slice(this.index);
	    this.offset = offset;
	    this.index = index;
	    return [next].concat(rest);
	  }
	};
	
	
	module.exports = lib;
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	var clone = (function() {
	'use strict';
	
	function _instanceof(obj, type) {
	  return type != null && obj instanceof type;
	}
	
	var nativeMap;
	try {
	  nativeMap = Map;
	} catch(_) {
	  // maybe a reference error because no `Map`. Give it a dummy value that no
	  // value will ever be an instanceof.
	  nativeMap = function() {};
	}
	
	var nativeSet;
	try {
	  nativeSet = Set;
	} catch(_) {
	  nativeSet = function() {};
	}
	
	var nativePromise;
	try {
	  nativePromise = Promise;
	} catch(_) {
	  nativePromise = function() {};
	}
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
	 *    should be cloned as well. Non-enumerable properties on the prototype
	 *    chain will be ignored. (optional - false by default)
	*/
	function clone(parent, circular, depth, prototype, includeNonEnumerable) {
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    includeNonEnumerable = circular.includeNonEnumerable;
	    circular = circular.circular;
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth === 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      child = new nativeMap();
	    } else if (_instanceof(parent, nativeSet)) {
	      child = new nativeSet();
	    } else if (_instanceof(parent, nativePromise)) {
	      child = new nativePromise(function (resolve, reject) {
	        parent.then(function(value) {
	          resolve(_clone(value, depth - 1));
	        }, function(err) {
	          reject(_clone(err, depth - 1));
	        });
	      });
	    } else if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      if (Buffer.allocUnsafe) {
	        // Node.js >= 4.5.0
	        child = Buffer.allocUnsafe(parent.length);
	      } else {
	        // Older Node.js versions
	        child = new Buffer(parent.length);
	      }
	      parent.copy(child);
	      return child;
	    } else if (_instanceof(parent, Error)) {
	      child = Object.create(parent);
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      parent.forEach(function(value, key) {
	        var keyChild = _clone(key, depth - 1);
	        var valueChild = _clone(value, depth - 1);
	        child.set(keyChild, valueChild);
	      });
	    }
	    if (_instanceof(parent, nativeSet)) {
	      parent.forEach(function(value) {
	        var entryChild = _clone(value, depth - 1);
	        child.add(entryChild);
	      });
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(parent);
	      for (var i = 0; i < symbols.length; i++) {
	        // Don't need to worry about cloning a symbol because it is a primitive,
	        // like a number or string.
	        var symbol = symbols[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
	        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
	          continue;
	        }
	        child[symbol] = _clone(parent[symbol], depth - 1);
	        if (!descriptor.enumerable) {
	          Object.defineProperty(child, symbol, {
	            enumerable: false
	          });
	        }
	      }
	    }
	
	    if (includeNonEnumerable) {
	      var allPropertyNames = Object.getOwnPropertyNames(parent);
	      for (var i = 0; i < allPropertyNames.length; i++) {
	        var propertyName = allPropertyNames[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
	        if (descriptor && descriptor.enumerable) {
	          continue;
	        }
	        child[propertyName] = _clone(parent[propertyName], depth - 1);
	        Object.defineProperty(child, propertyName, {
	          enumerable: false
	        });
	      }
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	}
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	}
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	}
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	}
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	}
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isLine(blot) {
	  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
	}
	
	var Scroll = function (_Parchment$Scroll) {
	  _inherits(Scroll, _Parchment$Scroll);
	
	  function Scroll(domNode, config) {
	    _classCallCheck(this, Scroll);
	
	    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));
	
	    _this.emitter = config.emitter;
	    if (Array.isArray(config.whitelist)) {
	      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
	        whitelist[format] = true;
	        return whitelist;
	      }, {});
	    }
	    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
	    _this.domNode.addEventListener('DOMNodeInserted', function () {});
	    _this.optimize();
	    _this.enable();
	    return _this;
	  }
	
	  _createClass(Scroll, [{
	    key: 'batchStart',
	    value: function batchStart() {
	      this.batch = true;
	    }
	  }, {
	    key: 'batchEnd',
	    value: function batchEnd() {
	      this.batch = false;
	      this.optimize();
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      var _line = this.line(index),
	          _line2 = _slicedToArray(_line, 2),
	          first = _line2[0],
	          offset = _line2[1];
	
	      var _line3 = this.line(index + length),
	          _line4 = _slicedToArray(_line3, 1),
	          last = _line4[0];
	
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
	      if (last != null && first !== last && offset > 0) {
	        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
	          this.optimize();
	          return;
	        }
	        if (first instanceof _code2.default) {
	          var newlineIndex = first.newlineIndex(first.length(), true);
	          if (newlineIndex > -1) {
	            first = first.split(newlineIndex + 1);
	            if (first === last) {
	              this.optimize();
	              return;
	            }
	          }
	        } else if (last instanceof _code2.default) {
	          var _newlineIndex = last.newlineIndex(0);
	          if (_newlineIndex > -1) {
	            last.split(_newlineIndex + 1);
	          }
	        }
	        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
	        first.moveChildren(last, ref);
	        first.remove();
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.domNode.setAttribute('contenteditable', enabled);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, format, value) {
	      if (this.whitelist != null && !this.whitelist[format]) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
	      this.optimize();
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
	      if (index >= this.length()) {
	        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
	          var blot = _parchment2.default.create(this.statics.defaultChild);
	          this.appendChild(blot);
	          if (def == null && value.endsWith('\n')) {
	            value = value.slice(0, -1);
	          }
	          blot.insertAt(0, value, def);
	        } else {
	          var embed = _parchment2.default.create(value, def);
	          this.appendChild(embed);
	        }
	      } else {
	        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
	        var wrapper = _parchment2.default.create(this.statics.defaultChild);
	        wrapper.appendChild(blot);
	        blot = wrapper;
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
	    }
	  }, {
	    key: 'leaf',
	    value: function leaf(index) {
	      return this.path(index).pop() || [null, -1];
	    }
	  }, {
	    key: 'line',
	    value: function line(index) {
	      if (index === this.length()) {
	        return this.line(index - 1);
	      }
	      return this.descendant(isLine, index);
	    }
	  }, {
	    key: 'lines',
	    value: function lines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	
	      var getLines = function getLines(blot, index, length) {
	        var lines = [],
	            lengthLeft = length;
	        blot.children.forEachAt(index, length, function (child, index, length) {
	          if (isLine(child)) {
	            lines.push(child);
	          } else if (child instanceof _parchment2.default.Container) {
	            lines = lines.concat(getLines(child, index, lengthLeft));
	          }
	          lengthLeft -= length;
	        });
	        return lines;
	      };
	      return getLines(this, index, length);
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize() {
	      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.batch === true) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
	      }
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations) {
	      if (this.batch === true) return;
	      var source = _emitter2.default.sources.USER;
	      if (typeof mutations === 'string') {
	        source = mutations;
	      }
	      if (!Array.isArray(mutations)) {
	        mutations = this.observer.takeRecords();
	      }
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
	      }
	    }
	  }]);
	
	  return Scroll;
	}(_parchment2.default.Scroll);
	
	Scroll.blotName = 'scroll';
	Scroll.className = 'ql-editor';
	Scroll.tagName = 'DIV';
	Scroll.defaultChild = 'block';
	Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];
	
	exports.default = Scroll;
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SHORTKEY = exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _op = __webpack_require__(20);
	
	var _op2 = _interopRequireDefault(_op);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:keyboard');
	
	var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
	
	var Keyboard = function (_Module) {
	  _inherits(Keyboard, _Module);
	
	  _createClass(Keyboard, null, [{
	    key: 'match',
	    value: function match(evt, binding) {
	      binding = normalize(binding);
	      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
	        return !!binding[key] !== evt[key] && binding[key] !== null;
	      })) {
	        return false;
	      }
	      return binding.key === (evt.which || evt.keyCode);
	    }
	  }]);
	
	  function Keyboard(quill, options) {
	    _classCallCheck(this, Keyboard);
	
	    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));
	
	    _this.bindings = {};
	    Object.keys(_this.options.bindings).forEach(function (name) {
	      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
	        return;
	      }
	      if (_this.options.bindings[name]) {
	        _this.addBinding(_this.options.bindings[name]);
	      }
	    });
	    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
	    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
	    if (/Firefox/i.test(navigator.userAgent)) {
	      // Need to handle delete and backspace for Firefox in the general case #1171
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
	    } else {
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
	    }
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
	    _this.listen();
	    return _this;
	  }
	
	  _createClass(Keyboard, [{
	    key: 'addBinding',
	    value: function addBinding(key) {
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var binding = normalize(key);
	      if (binding == null || binding.key == null) {
	        return debug.warn('Attempted to add invalid keyboard binding', binding);
	      }
	      if (typeof context === 'function') {
	        context = { handler: context };
	      }
	      if (typeof handler === 'function') {
	        handler = { handler: handler };
	      }
	      binding = (0, _extend2.default)(binding, context, handler);
	      this.bindings[binding.key] = this.bindings[binding.key] || [];
	      this.bindings[binding.key].push(binding);
	    }
	  }, {
	    key: 'listen',
	    value: function listen() {
	      var _this2 = this;
	
	      this.quill.root.addEventListener('keydown', function (evt) {
	        if (evt.defaultPrevented) return;
	        var which = evt.which || evt.keyCode;
	        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
	          return Keyboard.match(evt, binding);
	        });
	        if (bindings.length === 0) return;
	        var range = _this2.quill.getSelection();
	        if (range == null || !_this2.quill.hasFocus()) return;
	
	        var _quill$getLine = _this2.quill.getLine(range.index),
	            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
	            line = _quill$getLine2[0],
	            offset = _quill$getLine2[1];
	
	        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
	            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
	            leafStart = _quill$getLeaf2[0],
	            offsetStart = _quill$getLeaf2[1];
	
	        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
	            _ref2 = _slicedToArray(_ref, 2),
	            leafEnd = _ref2[0],
	            offsetEnd = _ref2[1];
	
	        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
	        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
	        var curContext = {
	          collapsed: range.length === 0,
	          empty: range.length === 0 && line.length() <= 1,
	          format: _this2.quill.getFormat(range),
	          offset: offset,
	          prefix: prefixText,
	          suffix: suffixText
	        };
	        var prevented = bindings.some(function (binding) {
	          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
	          if (binding.empty != null && binding.empty !== curContext.empty) return false;
	          if (binding.offset != null && binding.offset !== curContext.offset) return false;
	          if (Array.isArray(binding.format)) {
	            // any format is present
	            if (binding.format.every(function (name) {
	              return curContext.format[name] == null;
	            })) {
	              return false;
	            }
	          } else if (_typeof(binding.format) === 'object') {
	            // all formats must match
	            if (!Object.keys(binding.format).every(function (name) {
	              if (binding.format[name] === true) return curContext.format[name] != null;
	              if (binding.format[name] === false) return curContext.format[name] == null;
	              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
	            })) {
	              return false;
	            }
	          }
	          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
	          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
	          return binding.handler.call(_this2, range, curContext) !== true;
	        });
	        if (prevented) {
	          evt.preventDefault();
	        }
	      });
	    }
	  }]);
	
	  return Keyboard;
	}(_module2.default);
	
	Keyboard.keys = {
	  BACKSPACE: 8,
	  TAB: 9,
	  ENTER: 13,
	  ESCAPE: 27,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46
	};
	
	Keyboard.DEFAULTS = {
	  bindings: {
	    'bold': makeFormatHandler('bold'),
	    'italic': makeFormatHandler('italic'),
	    'underline': makeFormatHandler('underline'),
	    'indent': {
	      // highlight tab or tab at beginning of list, indent or blockquote
	      key: Keyboard.keys.TAB,
	      format: ['blockquote', 'indent', 'list'],
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '+1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      format: ['blockquote', 'indent', 'list'],
	      // highlight tab or tab at beginning of list, indent or blockquote
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '-1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent backspace': {
	      key: Keyboard.keys.BACKSPACE,
	      collapsed: true,
	      shiftKey: null,
	      metaKey: null,
	      ctrlKey: null,
	      altKey: null,
	      format: ['indent', 'list'],
	      offset: 0,
	      handler: function handler(range, context) {
	        if (context.format.indent != null) {
	          this.quill.format('indent', '-1', _quill2.default.sources.USER);
	        } else if (context.format.list != null) {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'indent code-block': makeCodeBlockHandler(true),
	    'outdent code-block': makeCodeBlockHandler(false),
	    'remove tab': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      collapsed: true,
	      prefix: /\t$/,
	      handler: function handler(range) {
	        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
	      }
	    },
	    'tab': {
	      key: Keyboard.keys.TAB,
	      handler: function handler(range) {
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	      }
	    },
	    'list empty enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['list'],
	      empty: true,
	      handler: function handler(range, context) {
	        this.quill.format('list', false, _quill2.default.sources.USER);
	        if (context.format.indent) {
	          this.quill.format('indent', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'checklist enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: { list: 'checked' },
	      handler: function handler(range) {
	        var _quill$getLine3 = this.quill.getLine(range.index),
	            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
	            line = _quill$getLine4[0],
	            offset = _quill$getLine4[1];
	
	        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'header enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['header'],
	      suffix: /^$/,
	      handler: function handler(range, context) {
	        var _quill$getLine5 = this.quill.getLine(range.index),
	            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
	            line = _quill$getLine6[0],
	            offset = _quill$getLine6[1];
	
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'list autofill': {
	      key: ' ',
	      collapsed: true,
	      format: { list: false },
	      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
	      handler: function handler(range, context) {
	        var length = context.prefix.length;
	
	        var _quill$getLine7 = this.quill.getLine(range.index),
	            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
	            line = _quill$getLine8[0],
	            offset = _quill$getLine8[1];
	
	        if (offset > length) return true;
	        var value = void 0;
	        switch (context.prefix.trim()) {
	          case '[]':case '[ ]':
	            value = 'unchecked';
	            break;
	          case '[x]':
	            value = 'checked';
	            break;
	          case '-':case '*':
	            value = 'bullet';
	            break;
	          default:
	            value = 'ordered';
	        }
	        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
	      }
	    },
	    'code exit': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['code-block'],
	      prefix: /\n\n$/,
	      suffix: /^\s+$/,
	      handler: function handler(range) {
	        var _quill$getLine9 = this.quill.getLine(range.index),
	            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
	            line = _quill$getLine10[0],
	            offset = _quill$getLine10[1];
	
	        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	      }
	    },
	    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
	    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
	    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
	    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
	  }
	};
	
	function makeEmbedArrowHandler(key, shiftKey) {
	  var _ref3;
	
	  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
	  return _ref3 = {
	    key: key,
	    shiftKey: shiftKey,
	    altKey: null
	  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
	    var index = range.index;
	    if (key === Keyboard.keys.RIGHT) {
	      index += range.length + 1;
	    }
	
	    var _quill$getLeaf3 = this.quill.getLeaf(index),
	        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
	        leaf = _quill$getLeaf4[0];
	
	    if (!(leaf instanceof _parchment2.default.Embed)) return true;
	    if (key === Keyboard.keys.LEFT) {
	      if (shiftKey) {
	        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
	      }
	    } else {
	      if (shiftKey) {
	        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
	      }
	    }
	    return false;
	  }), _ref3;
	}
	
	function handleBackspace(range, context) {
	  if (range.index === 0 || this.quill.getLength() <= 1) return;
	
	  var _quill$getLine11 = this.quill.getLine(range.index),
	      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
	      line = _quill$getLine12[0];
	
	  var formats = {};
	  if (context.offset === 0) {
	    var _quill$getLine13 = this.quill.getLine(range.index - 1),
	        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
	        prev = _quill$getLine14[0];
	
	    if (prev != null && prev.length() > 1) {
	      var curFormats = line.formats();
	      var prevFormats = this.quill.getFormat(range.index - 1, 1);
	      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
	    }
	  }
	  // Check for astral symbols
	  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
	  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
	  }
	  this.quill.focus();
	}
	
	function handleDelete(range, context) {
	  // Check for astral symbols
	  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
	  if (range.index >= this.quill.getLength() - length) return;
	  var formats = {},
	      nextLength = 0;
	
	  var _quill$getLine15 = this.quill.getLine(range.index),
	      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
	      line = _quill$getLine16[0];
	
	  if (context.offset >= line.length() - 1) {
	    var _quill$getLine17 = this.quill.getLine(range.index + 1),
	        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
	        next = _quill$getLine18[0];
	
	    if (next) {
	      var curFormats = line.formats();
	      var nextFormats = this.quill.getFormat(range.index, 1);
	      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
	      nextLength = next.length();
	    }
	  }
	  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
	  }
	}
	
	function handleDeleteRange(range) {
	  var lines = this.quill.getLines(range);
	  var formats = {};
	  if (lines.length > 1) {
	    var firstFormats = lines[0].formats();
	    var lastFormats = lines[lines.length - 1].formats();
	    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
	  }
	  this.quill.deleteText(range, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
	  }
	  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
	  this.quill.focus();
	}
	
	function handleEnter(range, context) {
	  var _this3 = this;
	
	  if (range.length > 0) {
	    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
	  }
	  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
	    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
	      lineFormats[format] = context.format[format];
	    }
	    return lineFormats;
	  }, {});
	  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
	  // Earlier scroll.deleteAt might have messed up our selection,
	  // so insertText's built in selection preservation is not reliable
	  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	  this.quill.focus();
	  Object.keys(context.format).forEach(function (name) {
	    if (lineFormats[name] != null) return;
	    if (Array.isArray(context.format[name])) return;
	    if (name === 'link') return;
	    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
	  });
	}
	
	function makeCodeBlockHandler(indent) {
	  return {
	    key: Keyboard.keys.TAB,
	    shiftKey: !indent,
	    format: { 'code-block': true },
	    handler: function handler(range) {
	      var CodeBlock = _parchment2.default.query('code-block');
	      var index = range.index,
	          length = range.length;
	
	      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
	          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	          block = _quill$scroll$descend2[0],
	          offset = _quill$scroll$descend2[1];
	
	      if (block == null) return;
	      var scrollIndex = this.quill.getIndex(block);
	      var start = block.newlineIndex(offset, true) + 1;
	      var end = block.newlineIndex(scrollIndex + offset + length);
	      var lines = block.domNode.textContent.slice(start, end).split('\n');
	      offset = 0;
	      lines.forEach(function (line, i) {
	        if (indent) {
	          block.insertAt(start + offset, CodeBlock.TAB);
	          offset += CodeBlock.TAB.length;
	          if (i === 0) {
	            index += CodeBlock.TAB.length;
	          } else {
	            length += CodeBlock.TAB.length;
	          }
	        } else if (line.startsWith(CodeBlock.TAB)) {
	          block.deleteAt(start + offset, CodeBlock.TAB.length);
	          offset -= CodeBlock.TAB.length;
	          if (i === 0) {
	            index -= CodeBlock.TAB.length;
	          } else {
	            length -= CodeBlock.TAB.length;
	          }
	        }
	        offset += line.length + 1;
	      });
	      this.quill.update(_quill2.default.sources.USER);
	      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
	    }
	  };
	}
	
	function makeFormatHandler(format) {
	  return {
	    key: format[0].toUpperCase(),
	    shortKey: true,
	    handler: function handler(range, context) {
	      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
	    }
	  };
	}
	
	function normalize(binding) {
	  if (typeof binding === 'string' || typeof binding === 'number') {
	    return normalize({ key: binding });
	  }
	  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
	    binding = (0, _clone2.default)(binding, false);
	  }
	  if (typeof binding.key === 'string') {
	    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
	      binding.key = Keyboard.keys[binding.key.toUpperCase()];
	    } else if (binding.key.length === 1) {
	      binding.key = binding.key.toUpperCase().charCodeAt(0);
	    } else {
	      return null;
	    }
	  }
	  if (binding.shortKey) {
	    binding[SHORTKEY] = binding.shortKey;
	    delete binding.shortKey;
	  }
	  return binding;
	}
	
	exports.default = Keyboard;
	exports.SHORTKEY = SHORTKEY;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cursor = function (_Parchment$Embed) {
	  _inherits(Cursor, _Parchment$Embed);
	
	  _createClass(Cursor, null, [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);
	
	  function Cursor(domNode, selection) {
	    _classCallCheck(this, Cursor);
	
	    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));
	
	    _this.selection = selection;
	    _this.textNode = document.createTextNode(Cursor.CONTENTS);
	    _this.domNode.appendChild(_this.textNode);
	    _this._length = 0;
	    return _this;
	  }
	
	  _createClass(Cursor, [{
	    key: 'detach',
	    value: function detach() {
	      // super.detach() will also clear domNode.__blot
	      if (this.parent != null) this.parent.removeChild(this);
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (this._length !== 0) {
	        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
	      }
	      var target = this,
	          index = 0;
	      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
	        index += target.offset(target.parent);
	        target = target.parent;
	      }
	      if (target != null) {
	        this._length = Cursor.CONTENTS.length;
	        target.optimize();
	        target.formatAt(index, Cursor.CONTENTS.length, name, value);
	        this._length = 0;
	      }
	    }
	  }, {
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.textNode) return 0;
	      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return this._length;
	    }
	  }, {
	    key: 'position',
	    value: function position() {
	      return [this.textNode, this.textNode.data.length];
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
	      this.parent = null;
	    }
	  }, {
	    key: 'restore',
	    value: function restore() {
	      if (this.selection.composing || this.parent == null) return;
	      var textNode = this.textNode;
	      var range = this.selection.getNativeRange();
	      var restoreText = void 0,
	          start = void 0,
	          end = void 0;
	      if (range != null && range.start.node === textNode && range.end.node === textNode) {
	        var _ref = [textNode, range.start.offset, range.end.offset];
	        restoreText = _ref[0];
	        start = _ref[1];
	        end = _ref[2];
	      }
	      // Link format will insert text outside of anchor tag
	      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
	        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
	      }
	      if (this.textNode.data !== Cursor.CONTENTS) {
	        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
	        if (this.next instanceof _text2.default) {
	          restoreText = this.next.domNode;
	          this.next.insertAt(0, text);
	          this.textNode.data = Cursor.CONTENTS;
	        } else {
	          this.textNode.data = text;
	          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
	          this.textNode = document.createTextNode(Cursor.CONTENTS);
	          this.domNode.appendChild(this.textNode);
	        }
	      }
	      this.remove();
	      if (start != null) {
	        var _map = [start, end].map(function (offset) {
	          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
	        });
	
	        var _map2 = _slicedToArray(_map, 2);
	
	        start = _map2[0];
	        end = _map2[1];
	
	        return {
	          startNode: restoreText,
	          startOffset: start,
	          endNode: restoreText,
	          endOffset: end
	        };
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;
	
	      if (mutations.some(function (mutation) {
	        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
	      })) {
	        var range = this.restore();
	        if (range) context.range = range;
	      }
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }]);
	
	  return Cursor;
	}(_parchment2.default.Embed);
	
	Cursor.blotName = 'cursor';
	Cursor.className = 'ql-cursor';
	Cursor.tagName = 'span';
	Cursor.CONTENTS = '\uFEFF'; // Zero width no break space
	
	
	exports.default = Cursor;
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_Parchment$Container) {
	  _inherits(Container, _Parchment$Container);
	
	  function Container() {
	    _classCallCheck(this, Container);
	
	    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
	  }
	
	  return Container;
	}(_parchment2.default.Container);
	
	Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];
	
	exports.default = Container;
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorAttributor = function (_Parchment$Attributor) {
	  _inherits(ColorAttributor, _Parchment$Attributor);
	
	  function ColorAttributor() {
	    _classCallCheck(this, ColorAttributor);
	
	    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
	  }
	
	  _createClass(ColorAttributor, [{
	    key: 'value',
	    value: function value(domNode) {
	      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
	      if (!value.startsWith('rgb(')) return value;
	      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
	      return '#' + value.split(',').map(function (component) {
	        return ('00' + parseInt(component).toString(16)).slice(-2);
	      }).join('');
	    }
	  }]);
	
	  return ColorAttributor;
	}(_parchment2.default.Attributor.Style);
	
	var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var ColorStyle = new ColorAttributor('color', 'color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	exports.ColorAttributor = ColorAttributor;
	exports.ColorClass = ColorClass;
	exports.ColorStyle = ColorStyle;
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sanitize = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Link = function (_Inline) {
	  _inherits(Link, _Inline);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	  }
	
	  _createClass(Link, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
	      value = this.constructor.sanitize(value);
	      this.domNode.setAttribute('href', value);
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
	      value = this.sanitize(value);
	      node.setAttribute('href', value);
	      node.setAttribute('rel', 'noopener noreferrer');
	      node.setAttribute('target', '_blank');
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.getAttribute('href');
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
	    }
	  }]);
	
	  return Link;
	}(_inline2.default);
	
	Link.blotName = 'link';
	Link.tagName = 'A';
	Link.SANITIZED_URL = 'about:blank';
	Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];
	
	function _sanitize(url, protocols) {
	  var anchor = document.createElement('a');
	  anchor.href = url;
	  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
	  return protocols.indexOf(protocol) > -1;
	}
	
	exports.default = Link;
	exports.sanitize = _sanitize;
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _dropdown = __webpack_require__(107);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var optionsCounter = 0;
	
	function toggleAriaAttribute(element, attribute) {
	  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
	}
	
	var Picker = function () {
	  function Picker(select) {
	    var _this = this;
	
	    _classCallCheck(this, Picker);
	
	    this.select = select;
	    this.container = document.createElement('span');
	    this.buildPicker();
	    this.select.style.display = 'none';
	    this.select.parentNode.insertBefore(this.container, this.select);
	
	    this.label.addEventListener('mousedown', function () {
	      _this.togglePicker();
	    });
	    this.label.addEventListener('keydown', function (event) {
	      switch (event.keyCode) {
	        // Allows the "Enter" key to open the picker
	        case _keyboard2.default.keys.ENTER:
	          _this.togglePicker();
	          break;
	
	        // Allows the "Escape" key to close the picker
	        case _keyboard2.default.keys.ESCAPE:
	          _this.escape();
	          event.preventDefault();
	          break;
	        default:
	      }
	    });
	    this.select.addEventListener('change', this.update.bind(this));
	  }
	
	  _createClass(Picker, [{
	    key: 'togglePicker',
	    value: function togglePicker() {
	      this.container.classList.toggle('ql-expanded');
	      // Toggle aria-expanded and aria-hidden to make the picker accessible
	      toggleAriaAttribute(this.label, 'aria-expanded');
	      toggleAriaAttribute(this.options, 'aria-hidden');
	    }
	  }, {
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var _this2 = this;
	
	      var item = document.createElement('span');
	      item.tabIndex = '0';
	      item.setAttribute('role', 'button');
	
	      item.classList.add('ql-picker-item');
	      if (option.hasAttribute('value')) {
	        item.setAttribute('data-value', option.getAttribute('value'));
	      }
	      if (option.textContent) {
	        item.setAttribute('data-label', option.textContent);
	      }
	      item.addEventListener('click', function () {
	        _this2.selectItem(item, true);
	      });
	      item.addEventListener('keydown', function (event) {
	        switch (event.keyCode) {
	          // Allows the "Enter" key to select an item
	          case _keyboard2.default.keys.ENTER:
	            _this2.selectItem(item, true);
	            event.preventDefault();
	            break;
	
	          // Allows the "Escape" key to close the picker
	          case _keyboard2.default.keys.ESCAPE:
	            _this2.escape();
	            event.preventDefault();
	            break;
	          default:
	        }
	      });
	
	      return item;
	    }
	  }, {
	    key: 'buildLabel',
	    value: function buildLabel() {
	      var label = document.createElement('span');
	      label.classList.add('ql-picker-label');
	      label.innerHTML = _dropdown2.default;
	      label.tabIndex = '0';
	      label.setAttribute('role', 'button');
	      label.setAttribute('aria-expanded', 'false');
	      this.container.appendChild(label);
	      return label;
	    }
	  }, {
	    key: 'buildOptions',
	    value: function buildOptions() {
	      var _this3 = this;
	
	      var options = document.createElement('span');
	      options.classList.add('ql-picker-options');
	
	      // Don't want screen readers to read this until options are visible
	      options.setAttribute('aria-hidden', 'true');
	      options.tabIndex = '-1';
	
	      // Need a unique id for aria-controls
	      options.id = 'ql-picker-options-' + optionsCounter;
	      optionsCounter += 1;
	      this.label.setAttribute('aria-controls', options.id);
	
	      this.options = options;
	
	      [].slice.call(this.select.options).forEach(function (option) {
	        var item = _this3.buildItem(option);
	        options.appendChild(item);
	        if (option.selected === true) {
	          _this3.selectItem(item);
	        }
	      });
	      this.container.appendChild(options);
	    }
	  }, {
	    key: 'buildPicker',
	    value: function buildPicker() {
	      var _this4 = this;
	
	      [].slice.call(this.select.attributes).forEach(function (item) {
	        _this4.container.setAttribute(item.name, item.value);
	      });
	      this.container.classList.add('ql-picker');
	      this.label = this.buildLabel();
	      this.buildOptions();
	    }
	  }, {
	    key: 'escape',
	    value: function escape() {
	      var _this5 = this;
	
	      // Close menu and return focus to trigger label
	      this.close();
	      // Need setTimeout for accessibility to ensure that the browser executes
	      // focus on the next process thread and after any DOM content changes
	      setTimeout(function () {
	        return _this5.label.focus();
	      }, 1);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.container.classList.remove('ql-expanded');
	      this.label.setAttribute('aria-expanded', 'false');
	      this.options.setAttribute('aria-hidden', 'true');
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item) {
	      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var selected = this.container.querySelector('.ql-selected');
	      if (item === selected) return;
	      if (selected != null) {
	        selected.classList.remove('ql-selected');
	      }
	      if (item == null) return;
	      item.classList.add('ql-selected');
	      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
	      if (item.hasAttribute('data-value')) {
	        this.label.setAttribute('data-value', item.getAttribute('data-value'));
	      } else {
	        this.label.removeAttribute('data-value');
	      }
	      if (item.hasAttribute('data-label')) {
	        this.label.setAttribute('data-label', item.getAttribute('data-label'));
	      } else {
	        this.label.removeAttribute('data-label');
	      }
	      if (trigger) {
	        if (typeof Event === 'function') {
	          this.select.dispatchEvent(new Event('change'));
	        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
	          // IE11
	          var event = document.createEvent('Event');
	          event.initEvent('change', true, true);
	          this.select.dispatchEvent(event);
	        }
	        this.close();
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var option = void 0;
	      if (this.select.selectedIndex > -1) {
	        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
	        option = this.select.options[this.select.selectedIndex];
	        this.selectItem(item);
	      } else {
	        this.selectItem(null);
	      }
	      var isActive = option != null && option !== this.select.querySelector('option[selected]');
	      this.label.classList.toggle('ql-active', isActive);
	    }
	  }]);
	
	  return Picker;
	}();
	
	exports.default = Picker;
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _cursor = __webpack_require__(24);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _embed = __webpack_require__(35);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _scroll = __webpack_require__(22);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _clipboard = __webpack_require__(55);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	var _history = __webpack_require__(42);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_quill2.default.register({
	  'blots/block': _block2.default,
	  'blots/block/embed': _block.BlockEmbed,
	  'blots/break': _break2.default,
	  'blots/container': _container2.default,
	  'blots/cursor': _cursor2.default,
	  'blots/embed': _embed2.default,
	  'blots/inline': _inline2.default,
	  'blots/scroll': _scroll2.default,
	  'blots/text': _text2.default,
	
	  'modules/clipboard': _clipboard2.default,
	  'modules/history': _history2.default,
	  'modules/keyboard': _keyboard2.default
	});
	
	_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
	
	exports.default = _quill2.default;
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var ShadowBlot = /** @class */ (function () {
	    function ShadowBlot(domNode) {
	        this.domNode = domNode;
	        // @ts-ignore
	        this.domNode[Registry.DATA_KEY] = { blot: this };
	    }
	    Object.defineProperty(ShadowBlot.prototype, "statics", {
	        // Hack for accessing inherited static methods
	        get: function () {
	            return this.constructor;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ShadowBlot.create = function (value) {
	        if (this.tagName == null) {
	            throw new Registry.ParchmentError('Blot definition missing tagName');
	        }
	        var node;
	        if (Array.isArray(this.tagName)) {
	            if (typeof value === 'string') {
	                value = value.toUpperCase();
	                if (parseInt(value).toString() === value) {
	                    value = parseInt(value);
	                }
	            }
	            if (typeof value === 'number') {
	                node = document.createElement(this.tagName[value - 1]);
	            }
	            else if (this.tagName.indexOf(value) > -1) {
	                node = document.createElement(value);
	            }
	            else {
	                node = document.createElement(this.tagName[0]);
	            }
	        }
	        else {
	            node = document.createElement(this.tagName);
	        }
	        if (this.className) {
	            node.classList.add(this.className);
	        }
	        return node;
	    };
	    ShadowBlot.prototype.attach = function () {
	        if (this.parent != null) {
	            this.scroll = this.parent.scroll;
	        }
	    };
	    ShadowBlot.prototype.clone = function () {
	        var domNode = this.domNode.cloneNode(false);
	        return Registry.create(domNode);
	    };
	    ShadowBlot.prototype.detach = function () {
	        if (this.parent != null)
	            this.parent.removeChild(this);
	        // @ts-ignore
	        delete this.domNode[Registry.DATA_KEY];
	    };
	    ShadowBlot.prototype.deleteAt = function (index, length) {
	        var blot = this.isolate(index, length);
	        blot.remove();
	    };
	    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
	        var blot = this.isolate(index, length);
	        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
	            blot.wrap(name, value);
	        }
	        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
	            var parent = Registry.create(this.statics.scope);
	            blot.wrap(parent);
	            parent.format(name, value);
	        }
	    };
	    ShadowBlot.prototype.insertAt = function (index, value, def) {
	        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	        var ref = this.split(index);
	        this.parent.insertBefore(blot, ref);
	    };
	    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
	        if (refBlot === void 0) { refBlot = null; }
	        if (this.parent != null) {
	            this.parent.children.remove(this);
	        }
	        var refDomNode = null;
	        parentBlot.children.insertBefore(this, refBlot);
	        if (refBlot != null) {
	            refDomNode = refBlot.domNode;
	        }
	        if (this.domNode.parentNode != parentBlot.domNode ||
	            this.domNode.nextSibling != refDomNode) {
	            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
	        }
	        this.parent = parentBlot;
	        this.attach();
	    };
	    ShadowBlot.prototype.isolate = function (index, length) {
	        var target = this.split(index);
	        target.split(length);
	        return target;
	    };
	    ShadowBlot.prototype.length = function () {
	        return 1;
	    };
	    ShadowBlot.prototype.offset = function (root) {
	        if (root === void 0) { root = this.parent; }
	        if (this.parent == null || this == root)
	            return 0;
	        return this.parent.children.offset(this) + this.parent.offset(root);
	    };
	    ShadowBlot.prototype.optimize = function (context) {
	        // TODO clean up once we use WeakMap
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY] != null) {
	            // @ts-ignore
	            delete this.domNode[Registry.DATA_KEY].mutations;
	        }
	    };
	    ShadowBlot.prototype.remove = function () {
	        if (this.domNode.parentNode != null) {
	            this.domNode.parentNode.removeChild(this.domNode);
	        }
	        this.detach();
	    };
	    ShadowBlot.prototype.replace = function (target) {
	        if (target.parent == null)
	            return;
	        target.parent.insertBefore(this, target.next);
	        target.remove();
	    };
	    ShadowBlot.prototype.replaceWith = function (name, value) {
	        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
	        replacement.replace(this);
	        return replacement;
	    };
	    ShadowBlot.prototype.split = function (index, force) {
	        return index === 0 ? this : this.next;
	    };
	    ShadowBlot.prototype.update = function (mutations, context) {
	        // Nothing to do by default
	    };
	    ShadowBlot.prototype.wrap = function (name, value) {
	        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
	        if (this.parent != null) {
	            this.parent.insertBefore(wrapper, this.next);
	        }
	        wrapper.appendChild(this);
	        return wrapper;
	    };
	    ShadowBlot.blotName = 'abstract';
	    return ShadowBlot;
	}());
	exports.default = ShadowBlot;
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var Registry = __webpack_require__(1);
	var AttributorStore = /** @class */ (function () {
	    function AttributorStore(domNode) {
	        this.attributes = {};
	        this.domNode = domNode;
	        this.build();
	    }
	    AttributorStore.prototype.attribute = function (attribute, value) {
	        // verb
	        if (value) {
	            if (attribute.add(this.domNode, value)) {
	                if (attribute.value(this.domNode) != null) {
	                    this.attributes[attribute.attrName] = attribute;
	                }
	                else {
	                    delete this.attributes[attribute.attrName];
	                }
	            }
	        }
	        else {
	            attribute.remove(this.domNode);
	            delete this.attributes[attribute.attrName];
	        }
	    };
	    AttributorStore.prototype.build = function () {
	        var _this = this;
	        this.attributes = {};
	        var attributes = attributor_1.default.keys(this.domNode);
	        var classes = class_1.default.keys(this.domNode);
	        var styles = style_1.default.keys(this.domNode);
	        attributes
	            .concat(classes)
	            .concat(styles)
	            .forEach(function (name) {
	            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
	            if (attr instanceof attributor_1.default) {
	                _this.attributes[attr.attrName] = attr;
	            }
	        });
	    };
	    AttributorStore.prototype.copy = function (target) {
	        var _this = this;
	        Object.keys(this.attributes).forEach(function (key) {
	            var value = _this.attributes[key].value(_this.domNode);
	            target.format(key, value);
	        });
	    };
	    AttributorStore.prototype.move = function (target) {
	        var _this = this;
	        this.copy(target);
	        Object.keys(this.attributes).forEach(function (key) {
	            _this.attributes[key].remove(_this.domNode);
	        });
	        this.attributes = {};
	    };
	    AttributorStore.prototype.values = function () {
	        var _this = this;
	        return Object.keys(this.attributes).reduce(function (attributes, name) {
	            attributes[name] = _this.attributes[name].value(_this.domNode);
	            return attributes;
	        }, {});
	    };
	    return AttributorStore;
	}());
	exports.default = AttributorStore;
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function match(node, prefix) {
	    var className = node.getAttribute('class') || '';
	    return className.split(/\s+/).filter(function (name) {
	        return name.indexOf(prefix + "-") === 0;
	    });
	}
	var ClassAttributor = /** @class */ (function (_super) {
	    __extends(ClassAttributor, _super);
	    function ClassAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ClassAttributor.keys = function (node) {
	        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
	            return name
	                .split('-')
	                .slice(0, -1)
	                .join('-');
	        });
	    };
	    ClassAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        this.remove(node);
	        node.classList.add(this.keyName + "-" + value);
	        return true;
	    };
	    ClassAttributor.prototype.remove = function (node) {
	        var matches = match(node, this.keyName);
	        matches.forEach(function (name) {
	            node.classList.remove(name);
	        });
	        if (node.classList.length === 0) {
	            node.removeAttribute('class');
	        }
	    };
	    ClassAttributor.prototype.value = function (node) {
	        var result = match(node, this.keyName)[0] || '';
	        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
	        return this.canAdd(node, value) ? value : '';
	    };
	    return ClassAttributor;
	}(attributor_1.default));
	exports.default = ClassAttributor;
	
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function camelize(name) {
	    var parts = name.split('-');
	    var rest = parts
	        .slice(1)
	        .map(function (part) {
	        return part[0].toUpperCase() + part.slice(1);
	    })
	        .join('');
	    return parts[0] + rest;
	}
	var StyleAttributor = /** @class */ (function (_super) {
	    __extends(StyleAttributor, _super);
	    function StyleAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    StyleAttributor.keys = function (node) {
	        return (node.getAttribute('style') || '').split(';').map(function (value) {
	            var arr = value.split(':');
	            return arr[0].trim();
	        });
	    };
	    StyleAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = value;
	        return true;
	    };
	    StyleAttributor.prototype.remove = function (node) {
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = '';
	        if (!node.getAttribute('style')) {
	            node.removeAttribute('style');
	        }
	    };
	    StyleAttributor.prototype.value = function (node) {
	        // @ts-ignore
	        var value = node.style[camelize(this.keyName)];
	        return this.canAdd(node, value) ? value : '';
	    };
	    return StyleAttributor;
	}(attributor_1.default));
	exports.default = StyleAttributor;
	
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Theme = function () {
	  function Theme(quill, options) {
	    _classCallCheck(this, Theme);
	
	    this.quill = quill;
	    this.options = options;
	    this.modules = {};
	  }
	
	  _createClass(Theme, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      Object.keys(this.options.modules).forEach(function (name) {
	        if (_this.modules[name] == null) {
	          _this.addModule(name);
	        }
	      });
	    }
	  }, {
	    key: 'addModule',
	    value: function addModule(name) {
	      var moduleClass = this.quill.constructor.import('modules/' + name);
	      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
	      return this.modules[name];
	    }
	  }]);
	
	  return Theme;
	}();
	
	Theme.DEFAULTS = {
	  modules: {}
	};
	Theme.themes = {
	  'default': Theme
	};
	
	exports.default = Theme;
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GUARD_TEXT = '\uFEFF';
	
	var Embed = function (_Parchment$Embed) {
	  _inherits(Embed, _Parchment$Embed);
	
	  function Embed(node) {
	    _classCallCheck(this, Embed);
	
	    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));
	
	    _this.contentNode = document.createElement('span');
	    _this.contentNode.setAttribute('contenteditable', false);
	    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
	      _this.contentNode.appendChild(childNode);
	    });
	    _this.leftGuard = document.createTextNode(GUARD_TEXT);
	    _this.rightGuard = document.createTextNode(GUARD_TEXT);
	    _this.domNode.appendChild(_this.leftGuard);
	    _this.domNode.appendChild(_this.contentNode);
	    _this.domNode.appendChild(_this.rightGuard);
	    return _this;
	  }
	
	  _createClass(Embed, [{
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.leftGuard) return 0;
	      if (node === this.rightGuard) return 1;
	      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'restore',
	    value: function restore(node) {
	      var range = void 0,
	          textNode = void 0;
	      var text = node.data.split(GUARD_TEXT).join('');
	      if (node === this.leftGuard) {
	        if (this.prev instanceof _text2.default) {
	          var prevLength = this.prev.length();
	          this.prev.insertAt(prevLength, text);
	          range = {
	            startNode: this.prev.domNode,
	            startOffset: prevLength + text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      } else if (node === this.rightGuard) {
	        if (this.next instanceof _text2.default) {
	          this.next.insertAt(0, text);
	          range = {
	            startNode: this.next.domNode,
	            startOffset: text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      }
	      node.data = GUARD_TEXT;
	      return range;
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;
	
	      mutations.forEach(function (mutation) {
	        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
	          var range = _this2.restore(mutation.target);
	          if (range) context.range = range;
	        }
	      });
	    }
	  }]);
	
	  return Embed;
	}(_parchment2.default.Embed);
	
	exports.default = Embed;
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['right', 'center', 'justify']
	};
	
	var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
	var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
	var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);
	
	exports.AlignAttribute = AlignAttribute;
	exports.AlignClass = AlignClass;
	exports.AlignStyle = AlignStyle;
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BackgroundStyle = exports.BackgroundClass = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _color = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	exports.BackgroundClass = BackgroundClass;
	exports.BackgroundStyle = BackgroundStyle;
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['rtl']
	};
	
	var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
	var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
	var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);
	
	exports.DirectionAttribute = DirectionAttribute;
	exports.DirectionClass = DirectionClass;
	exports.DirectionStyle = DirectionStyle;
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontClass = exports.FontStyle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['serif', 'monospace']
	};
	
	var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);
	
	var FontStyleAttributor = function (_Parchment$Attributor) {
	  _inherits(FontStyleAttributor, _Parchment$Attributor);
	
	  function FontStyleAttributor() {
	    _classCallCheck(this, FontStyleAttributor);
	
	    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
	  }
	
	  _createClass(FontStyleAttributor, [{
	    key: 'value',
	    value: function value(node) {
	      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
	    }
	  }]);
	
	  return FontStyleAttributor;
	}(_parchment2.default.Attributor.Style);
	
	var FontStyle = new FontStyleAttributor('font', 'font-family', config);
	
	exports.FontStyle = FontStyle;
	exports.FontClass = FontClass;
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SizeStyle = exports.SizeClass = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['small', 'large', 'huge']
	});
	var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['10px', '18px', '32px']
	});
	
	exports.SizeClass = SizeClass;
	exports.SizeStyle = SizeStyle;
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = {
	  'align': {
	    '': __webpack_require__(76),
	    'center': __webpack_require__(77),
	    'right': __webpack_require__(78),
	    'justify': __webpack_require__(79)
	  },
	  'background': __webpack_require__(80),
	  'blockquote': __webpack_require__(81),
	  'bold': __webpack_require__(82),
	  'clean': __webpack_require__(83),
	  'code': __webpack_require__(58),
	  'code-block': __webpack_require__(58),
	  'color': __webpack_require__(84),
	  'direction': {
	    '': __webpack_require__(85),
	    'rtl': __webpack_require__(86)
	  },
	  'float': {
	    'center': __webpack_require__(87),
	    'full': __webpack_require__(88),
	    'left': __webpack_require__(89),
	    'right': __webpack_require__(90)
	  },
	  'formula': __webpack_require__(91),
	  'header': {
	    '1': __webpack_require__(92),
	    '2': __webpack_require__(93)
	  },
	  'italic': __webpack_require__(94),
	  'image': __webpack_require__(95),
	  'indent': {
	    '+1': __webpack_require__(96),
	    '-1': __webpack_require__(97)
	  },
	  'link': __webpack_require__(98),
	  'list': {
	    'ordered': __webpack_require__(99),
	    'bullet': __webpack_require__(100),
	    'check': __webpack_require__(101)
	  },
	  'script': {
	    'sub': __webpack_require__(102),
	    'super': __webpack_require__(103)
	  },
	  'strike': __webpack_require__(104),
	  'underline': __webpack_require__(105),
	  'video': __webpack_require__(106)
	};
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLastChangeIndex = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var History = function (_Module) {
	  _inherits(History, _Module);
	
	  function History(quill, options) {
	    _classCallCheck(this, History);
	
	    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));
	
	    _this.lastRecorded = 0;
	    _this.ignoreChange = false;
	    _this.clear();
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
	      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
	      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
	        _this.record(delta, oldDelta);
	      } else {
	        _this.transform(delta);
	      }
	    });
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
	    if (/Win/i.test(navigator.platform)) {
	      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
	    }
	    return _this;
	  }
	
	  _createClass(History, [{
	    key: 'change',
	    value: function change(source, dest) {
	      if (this.stack[source].length === 0) return;
	      var delta = this.stack[source].pop();
	      this.stack[dest].push(delta);
	      this.lastRecorded = 0;
	      this.ignoreChange = true;
	      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
	      this.ignoreChange = false;
	      var index = getLastChangeIndex(delta[source]);
	      this.quill.setSelection(index);
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.stack = { undo: [], redo: [] };
	    }
	  }, {
	    key: 'cutoff',
	    value: function cutoff() {
	      this.lastRecorded = 0;
	    }
	  }, {
	    key: 'record',
	    value: function record(changeDelta, oldDelta) {
	      if (changeDelta.ops.length === 0) return;
	      this.stack.redo = [];
	      var undoDelta = this.quill.getContents().diff(oldDelta);
	      var timestamp = Date.now();
	      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
	        var delta = this.stack.undo.pop();
	        undoDelta = undoDelta.compose(delta.undo);
	        changeDelta = delta.redo.compose(changeDelta);
	      } else {
	        this.lastRecorded = timestamp;
	      }
	      this.stack.undo.push({
	        redo: changeDelta,
	        undo: undoDelta
	      });
	      if (this.stack.undo.length > this.options.maxStack) {
	        this.stack.undo.shift();
	      }
	    }
	  }, {
	    key: 'redo',
	    value: function redo() {
	      this.change('redo', 'undo');
	    }
	  }, {
	    key: 'transform',
	    value: function transform(delta) {
	      this.stack.undo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	      this.stack.redo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	    }
	  }, {
	    key: 'undo',
	    value: function undo() {
	      this.change('undo', 'redo');
	    }
	  }]);
	
	  return History;
	}(_module2.default);
	
	History.DEFAULTS = {
	  delay: 1000,
	  maxStack: 100,
	  userOnly: false
	};
	
	function endsWithNewlineChange(delta) {
	  var lastOp = delta.ops[delta.ops.length - 1];
	  if (lastOp == null) return false;
	  if (lastOp.insert != null) {
	    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
	  }
	  if (lastOp.attributes != null) {
	    return Object.keys(lastOp.attributes).some(function (attr) {
	      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
	    });
	  }
	  return false;
	}
	
	function getLastChangeIndex(delta) {
	  var deleteLength = delta.reduce(function (length, op) {
	    length += op.delete || 0;
	    return length;
	  }, 0);
	  var changeIndex = delta.length() - deleteLength;
	  if (endsWithNewlineChange(delta)) {
	    changeIndex -= 1;
	  }
	  return changeIndex;
	}
	
	exports.default = History;
	exports.getLastChangeIndex = getLastChangeIndex;
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BaseTooltip = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _theme = __webpack_require__(34);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _colorPicker = __webpack_require__(59);
	
	var _colorPicker2 = _interopRequireDefault(_colorPicker);
	
	var _iconPicker = __webpack_require__(60);
	
	var _iconPicker2 = _interopRequireDefault(_iconPicker);
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	var _tooltip = __webpack_require__(61);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ALIGNS = [false, 'center', 'right', 'justify'];
	
	var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];
	
	var FONTS = [false, 'serif', 'monospace'];
	
	var HEADERS = ['1', '2', '3', false];
	
	var SIZES = ['small', false, 'large', 'huge'];
	
	var BaseTheme = function (_Theme) {
	  _inherits(BaseTheme, _Theme);
	
	  function BaseTheme(quill, options) {
	    _classCallCheck(this, BaseTheme);
	
	    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));
	
	    var listener = function listener(e) {
	      if (!document.body.contains(quill.root)) {
	        return document.body.removeEventListener('click', listener);
	      }
	      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
	        _this.tooltip.hide();
	      }
	      if (_this.pickers != null) {
	        _this.pickers.forEach(function (picker) {
	          if (!picker.container.contains(e.target)) {
	            picker.close();
	          }
	        });
	      }
	    };
	    quill.emitter.listenDOM('click', document.body, listener);
	    return _this;
	  }
	
	  _createClass(BaseTheme, [{
	    key: 'addModule',
	    value: function addModule(name) {
	      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
	      if (name === 'toolbar') {
	        this.extendToolbar(module);
	      }
	      return module;
	    }
	  }, {
	    key: 'buildButtons',
	    value: function buildButtons(buttons, icons) {
	      buttons.forEach(function (button) {
	        var className = button.getAttribute('class') || '';
	        className.split(/\s+/).forEach(function (name) {
	          if (!name.startsWith('ql-')) return;
	          name = name.slice('ql-'.length);
	          if (icons[name] == null) return;
	          if (name === 'direction') {
	            button.innerHTML = icons[name][''] + icons[name]['rtl'];
	          } else if (typeof icons[name] === 'string') {
	            button.innerHTML = icons[name];
	          } else {
	            var value = button.value || '';
	            if (value != null && icons[name][value]) {
	              button.innerHTML = icons[name][value];
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'buildPickers',
	    value: function buildPickers(selects, icons) {
	      var _this2 = this;
	
	      this.pickers = selects.map(function (select) {
	        if (select.classList.contains('ql-align')) {
	          if (select.querySelector('option') == null) {
	            fillSelect(select, ALIGNS);
	          }
	          return new _iconPicker2.default(select, icons.align);
	        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
	          var format = select.classList.contains('ql-background') ? 'background' : 'color';
	          if (select.querySelector('option') == null) {
	            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
	          }
	          return new _colorPicker2.default(select, icons[format]);
	        } else {
	          if (select.querySelector('option') == null) {
	            if (select.classList.contains('ql-font')) {
	              fillSelect(select, FONTS);
	            } else if (select.classList.contains('ql-header')) {
	              fillSelect(select, HEADERS);
	            } else if (select.classList.contains('ql-size')) {
	              fillSelect(select, SIZES);
	            }
	          }
	          return new _picker2.default(select);
	        }
	      });
	      var update = function update() {
	        _this2.pickers.forEach(function (picker) {
	          picker.update();
	        });
	      };
	      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
	    }
	  }]);
	
	  return BaseTheme;
	}(_theme2.default);
	
	BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        formula: function formula() {
	          this.quill.theme.tooltip.edit('formula');
	        },
	        image: function image() {
	          var _this3 = this;
	
	          var fileInput = this.container.querySelector('input.ql-image[type=file]');
	          if (fileInput == null) {
	            fileInput = document.createElement('input');
	            fileInput.setAttribute('type', 'file');
	            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
	            fileInput.classList.add('ql-image');
	            fileInput.addEventListener('change', function () {
	              if (fileInput.files != null && fileInput.files[0] != null) {
	                var reader = new FileReader();
	                reader.onload = function (e) {
	                  var range = _this3.quill.getSelection(true);
	                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
	                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
	                  fileInput.value = "";
	                };
	                reader.readAsDataURL(fileInput.files[0]);
	              }
	            });
	            this.container.appendChild(fileInput);
	          }
	          fileInput.click();
	        },
	        video: function video() {
	          this.quill.theme.tooltip.edit('video');
	        }
	      }
	    }
	  }
	});
	
	var BaseTooltip = function (_Tooltip) {
	  _inherits(BaseTooltip, _Tooltip);
	
	  function BaseTooltip(quill, boundsContainer) {
	    _classCallCheck(this, BaseTooltip);
	
	    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));
	
	    _this4.textbox = _this4.root.querySelector('input[type="text"]');
	    _this4.listen();
	    return _this4;
	  }
	
	  _createClass(BaseTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this5 = this;
	
	      this.textbox.addEventListener('keydown', function (event) {
	        if (_keyboard2.default.match(event, 'enter')) {
	          _this5.save();
	          event.preventDefault();
	        } else if (_keyboard2.default.match(event, 'escape')) {
	          _this5.cancel();
	          event.preventDefault();
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.hide();
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
	      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.root.classList.remove('ql-hidden');
	      this.root.classList.add('ql-editing');
	      if (preview != null) {
	        this.textbox.value = preview;
	      } else if (mode !== this.root.getAttribute('data-mode')) {
	        this.textbox.value = '';
	      }
	      this.position(this.quill.getBounds(this.quill.selection.savedRange));
	      this.textbox.select();
	      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
	      this.root.setAttribute('data-mode', mode);
	    }
	  }, {
	    key: 'restoreFocus',
	    value: function restoreFocus() {
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.quill.focus();
	      this.quill.scrollingContainer.scrollTop = scrollTop;
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var value = this.textbox.value;
	      switch (this.root.getAttribute('data-mode')) {
	        case 'link':
	          {
	            var scrollTop = this.quill.root.scrollTop;
	            if (this.linkRange) {
	              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
	              delete this.linkRange;
	            } else {
	              this.restoreFocus();
	              this.quill.format('link', value, _emitter2.default.sources.USER);
	            }
	            this.quill.root.scrollTop = scrollTop;
	            break;
	          }
	        case 'video':
	          {
	            value = extractVideoUrl(value);
	          } // eslint-disable-next-line no-fallthrough
	        case 'formula':
	          {
	            if (!value) break;
	            var range = this.quill.getSelection(true);
	            if (range != null) {
	              var index = range.index + range.length;
	              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
	              if (this.root.getAttribute('data-mode') === 'formula') {
	                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
	              }
	              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
	            }
	            break;
	          }
	        default:
	      }
	      this.textbox.value = '';
	      this.hide();
	    }
	  }]);
	
	  return BaseTooltip;
	}(_tooltip2.default);
	
	function extractVideoUrl(url) {
	  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
	  if (match) {
	    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
	  }
	  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
	    // eslint-disable-line no-cond-assign
	    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
	  }
	  return url;
	}
	
	function fillSelect(select, values) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value === defaultValue) {
	      option.setAttribute('selected', 'selected');
	    } else {
	      option.setAttribute('value', value);
	    }
	    select.appendChild(option);
	  });
	}
	
	exports.BaseTooltip = BaseTooltip;
	exports.default = BaseTheme;
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var LinkedList = /** @class */ (function () {
	    function LinkedList() {
	        this.head = this.tail = null;
	        this.length = 0;
	    }
	    LinkedList.prototype.append = function () {
	        var nodes = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            nodes[_i] = arguments[_i];
	        }
	        this.insertBefore(nodes[0], null);
	        if (nodes.length > 1) {
	            this.append.apply(this, nodes.slice(1));
	        }
	    };
	    LinkedList.prototype.contains = function (node) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            if (cur === node)
	                return true;
	        }
	        return false;
	    };
	    LinkedList.prototype.insertBefore = function (node, refNode) {
	        if (!node)
	            return;
	        node.next = refNode;
	        if (refNode != null) {
	            node.prev = refNode.prev;
	            if (refNode.prev != null) {
	                refNode.prev.next = node;
	            }
	            refNode.prev = node;
	            if (refNode === this.head) {
	                this.head = node;
	            }
	        }
	        else if (this.tail != null) {
	            this.tail.next = node;
	            node.prev = this.tail;
	            this.tail = node;
	        }
	        else {
	            node.prev = null;
	            this.head = this.tail = node;
	        }
	        this.length += 1;
	    };
	    LinkedList.prototype.offset = function (target) {
	        var index = 0, cur = this.head;
	        while (cur != null) {
	            if (cur === target)
	                return index;
	            index += cur.length();
	            cur = cur.next;
	        }
	        return -1;
	    };
	    LinkedList.prototype.remove = function (node) {
	        if (!this.contains(node))
	            return;
	        if (node.prev != null)
	            node.prev.next = node.next;
	        if (node.next != null)
	            node.next.prev = node.prev;
	        if (node === this.head)
	            this.head = node.next;
	        if (node === this.tail)
	            this.tail = node.prev;
	        this.length -= 1;
	    };
	    LinkedList.prototype.iterator = function (curNode) {
	        if (curNode === void 0) { curNode = this.head; }
	        // TODO use yield when we can
	        return function () {
	            var ret = curNode;
	            if (curNode != null)
	                curNode = curNode.next;
	            return ret;
	        };
	    };
	    LinkedList.prototype.find = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            var length = cur.length();
	            if (index < length ||
	                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
	                return [cur, index];
	            }
	            index -= length;
	        }
	        return [null, 0];
	    };
	    LinkedList.prototype.forEach = function (callback) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            callback(cur);
	        }
	    };
	    LinkedList.prototype.forEachAt = function (index, length, callback) {
	        if (length <= 0)
	            return;
	        var _a = this.find(index), startNode = _a[0], offset = _a[1];
	        var cur, curIndex = index - offset, next = this.iterator(startNode);
	        while ((cur = next()) && curIndex < index + length) {
	            var curLength = cur.length();
	            if (index > curIndex) {
	                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
	            }
	            else {
	                callback(cur, 0, Math.min(curLength, index + length - curIndex));
	            }
	            curIndex += curLength;
	        }
	    };
	    LinkedList.prototype.map = function (callback) {
	        return this.reduce(function (memo, cur) {
	            memo.push(callback(cur));
	            return memo;
	        }, []);
	    };
	    LinkedList.prototype.reduce = function (callback, memo) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            memo = callback(memo, cur);
	        }
	        return memo;
	    };
	    return LinkedList;
	}());
	exports.default = LinkedList;
	
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var OBSERVER_CONFIG = {
	    attributes: true,
	    characterData: true,
	    characterDataOldValue: true,
	    childList: true,
	    subtree: true,
	};
	var MAX_OPTIMIZE_ITERATIONS = 100;
	var ScrollBlot = /** @class */ (function (_super) {
	    __extends(ScrollBlot, _super);
	    function ScrollBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.scroll = _this;
	        _this.observer = new MutationObserver(function (mutations) {
	            _this.update(mutations);
	        });
	        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
	        _this.attach();
	        return _this;
	    }
	    ScrollBlot.prototype.detach = function () {
	        _super.prototype.detach.call(this);
	        this.observer.disconnect();
	    };
	    ScrollBlot.prototype.deleteAt = function (index, length) {
	        this.update();
	        if (index === 0 && length === this.length()) {
	            this.children.forEach(function (child) {
	                child.remove();
	            });
	        }
	        else {
	            _super.prototype.deleteAt.call(this, index, length);
	        }
	    };
	    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
	        this.update();
	        _super.prototype.formatAt.call(this, index, length, name, value);
	    };
	    ScrollBlot.prototype.insertAt = function (index, value, def) {
	        this.update();
	        _super.prototype.insertAt.call(this, index, value, def);
	    };
	    ScrollBlot.prototype.optimize = function (mutations, context) {
	        var _this = this;
	        if (mutations === void 0) { mutations = []; }
	        if (context === void 0) { context = {}; }
	        _super.prototype.optimize.call(this, context);
	        // We must modify mutations directly, cannot make copy and then modify
	        var records = [].slice.call(this.observer.takeRecords());
	        // Array.push currently seems to be implemented by a non-tail recursive function
	        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
	        while (records.length > 0)
	            mutations.push(records.pop());
	        // TODO use WeakMap
	        var mark = function (blot, markParent) {
	            if (markParent === void 0) { markParent = true; }
	            if (blot == null || blot === _this)
	                return;
	            if (blot.domNode.parentNode == null)
	                return;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [];
	            }
	            if (markParent)
	                mark(blot.parent);
	        };
	        var optimize = function (blot) {
	            // Post-order traversal
	            if (
	            // @ts-ignore
	            blot.domNode[Registry.DATA_KEY] == null ||
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations == null) {
	                return;
	            }
	            if (blot instanceof container_1.default) {
	                blot.children.forEach(optimize);
	            }
	            blot.optimize(context);
	        };
	        var remaining = mutations;
	        for (var i = 0; remaining.length > 0; i += 1) {
	            if (i >= MAX_OPTIMIZE_ITERATIONS) {
	                throw new Error('[Parchment] Maximum optimize iterations reached');
	            }
	            remaining.forEach(function (mutation) {
	                var blot = Registry.find(mutation.target, true);
	                if (blot == null)
	                    return;
	                if (blot.domNode === mutation.target) {
	                    if (mutation.type === 'childList') {
	                        mark(Registry.find(mutation.previousSibling, false));
	                        [].forEach.call(mutation.addedNodes, function (node) {
	                            var child = Registry.find(node, false);
	                            mark(child, false);
	                            if (child instanceof container_1.default) {
	                                child.children.forEach(function (grandChild) {
	                                    mark(grandChild, false);
	                                });
	                            }
	                        });
	                    }
	                    else if (mutation.type === 'attributes') {
	                        mark(blot.prev);
	                    }
	                }
	                mark(blot);
	            });
	            this.children.forEach(optimize);
	            remaining = [].slice.call(this.observer.takeRecords());
	            records = remaining.slice();
	            while (records.length > 0)
	                mutations.push(records.pop());
	        }
	    };
	    ScrollBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (context === void 0) { context = {}; }
	        mutations = mutations || this.observer.takeRecords();
	        // TODO use WeakMap
	        mutations
	            .map(function (mutation) {
	            var blot = Registry.find(mutation.target, true);
	            if (blot == null)
	                return null;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
	                return blot;
	            }
	            else {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
	                return null;
	            }
	        })
	            .forEach(function (blot) {
	            if (blot == null ||
	                blot === _this ||
	                //@ts-ignore
	                blot.domNode[Registry.DATA_KEY] == null)
	                return;
	            // @ts-ignore
	            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
	        });
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY].mutations != null) {
	            // @ts-ignore
	            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
	        }
	        this.optimize(mutations, context);
	    };
	    ScrollBlot.blotName = 'scroll';
	    ScrollBlot.defaultChild = 'block';
	    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
	    ScrollBlot.tagName = 'DIV';
	    return ScrollBlot;
	}(container_1.default));
	exports.default = ScrollBlot;
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	// Shallow object comparison
	function isEqual(obj1, obj2) {
	    if (Object.keys(obj1).length !== Object.keys(obj2).length)
	        return false;
	    // @ts-ignore
	    for (var prop in obj1) {
	        // @ts-ignore
	        if (obj1[prop] !== obj2[prop])
	            return false;
	    }
	    return true;
	}
	var InlineBlot = /** @class */ (function (_super) {
	    __extends(InlineBlot, _super);
	    function InlineBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InlineBlot.formats = function (domNode) {
	        if (domNode.tagName === InlineBlot.tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    InlineBlot.prototype.format = function (name, value) {
	        var _this = this;
	        if (name === this.statics.blotName && !value) {
	            this.children.forEach(function (child) {
	                if (!(child instanceof format_1.default)) {
	                    child = child.wrap(InlineBlot.blotName, true);
	                }
	                _this.attributes.copy(child);
	            });
	            this.unwrap();
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    InlineBlot.prototype.formatAt = function (index, length, name, value) {
	        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
	            var blot = this.isolate(index, length);
	            blot.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    InlineBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        var formats = this.formats();
	        if (Object.keys(formats).length === 0) {
	            return this.unwrap(); // unformatted span
	        }
	        var next = this.next;
	        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
	            next.moveChildren(this);
	            next.remove();
	        }
	    };
	    InlineBlot.blotName = 'inline';
	    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
	    InlineBlot.tagName = 'SPAN';
	    return InlineBlot;
	}(format_1.default));
	exports.default = InlineBlot;
	
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	var BlockBlot = /** @class */ (function (_super) {
	    __extends(BlockBlot, _super);
	    function BlockBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BlockBlot.formats = function (domNode) {
	        var tagName = Registry.query(BlockBlot.blotName).tagName;
	        if (domNode.tagName === tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    BlockBlot.prototype.format = function (name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
	            return;
	        }
	        else if (name === this.statics.blotName && !value) {
	            this.replaceWith(BlockBlot.blotName);
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    BlockBlot.prototype.formatAt = function (index, length, name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    BlockBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
	            // Insert text or inline
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	        else {
	            var after = this.split(index);
	            var blot = Registry.create(value, def);
	            after.parent.insertBefore(blot, after);
	        }
	    };
	    BlockBlot.prototype.update = function (mutations, context) {
	        if (navigator.userAgent.match(/Trident/)) {
	            this.build();
	        }
	        else {
	            _super.prototype.update.call(this, mutations, context);
	        }
	    };
	    BlockBlot.blotName = 'block';
	    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
	    BlockBlot.tagName = 'P';
	    return BlockBlot;
	}(format_1.default));
	exports.default = BlockBlot;
	
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var EmbedBlot = /** @class */ (function (_super) {
	    __extends(EmbedBlot, _super);
	    function EmbedBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EmbedBlot.formats = function (domNode) {
	        return undefined;
	    };
	    EmbedBlot.prototype.format = function (name, value) {
	        // super.formatAt wraps, which is what we want in general,
	        // but this allows subclasses to overwrite for formats
	        // that just apply to particular embeds
	        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
	    };
	    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
	        if (index === 0 && length === this.length()) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    EmbedBlot.prototype.formats = function () {
	        return this.statics.formats(this.domNode);
	    };
	    return EmbedBlot;
	}(leaf_1.default));
	exports.default = EmbedBlot;
	
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var Registry = __webpack_require__(1);
	var TextBlot = /** @class */ (function (_super) {
	    __extends(TextBlot, _super);
	    function TextBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.text = _this.statics.value(_this.domNode);
	        return _this;
	    }
	    TextBlot.create = function (value) {
	        return document.createTextNode(value);
	    };
	    TextBlot.value = function (domNode) {
	        var text = domNode.data;
	        // @ts-ignore
	        if (text['normalize'])
	            text = text['normalize']();
	        return text;
	    };
	    TextBlot.prototype.deleteAt = function (index, length) {
	        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
	    };
	    TextBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node) {
	            return offset;
	        }
	        return -1;
	    };
	    TextBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null) {
	            this.text = this.text.slice(0, index) + value + this.text.slice(index);
	            this.domNode.data = this.text;
	        }
	        else {
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	    };
	    TextBlot.prototype.length = function () {
	        return this.text.length;
	    };
	    TextBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        this.text = this.statics.value(this.domNode);
	        if (this.text.length === 0) {
	            this.remove();
	        }
	        else if (this.next instanceof TextBlot && this.next.prev === this) {
	            this.insertAt(this.length(), this.next.value());
	            this.next.remove();
	        }
	    };
	    TextBlot.prototype.position = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        return [this.domNode, index];
	    };
	    TextBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = Registry.create(this.domNode.splitText(index));
	        this.parent.insertBefore(after, this.next);
	        this.text = this.statics.value(this.domNode);
	        return after;
	    };
	    TextBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (mutations.some(function (mutation) {
	            return mutation.type === 'characterData' && mutation.target === _this.domNode;
	        })) {
	            this.text = this.statics.value(this.domNode);
	        }
	    };
	    TextBlot.prototype.value = function () {
	        return this.text;
	    };
	    TextBlot.blotName = 'text';
	    TextBlot.scope = Registry.Scope.INLINE_BLOT;
	    return TextBlot;
	}(leaf_1.default));
	exports.default = TextBlot;
	
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var elem = document.createElement('div');
	elem.classList.toggle('test-class', false);
	if (elem.classList.contains('test-class')) {
	  var _toggle = DOMTokenList.prototype.toggle;
	  DOMTokenList.prototype.toggle = function (token, force) {
	    if (arguments.length > 1 && !this.contains(token) === !force) {
	      return force;
	    } else {
	      return _toggle.call(this, token);
	    }
	  };
	}
	
	if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    position = position || 0;
	    return this.substr(position, searchString.length) === searchString;
	  };
	}
	
	if (!String.prototype.endsWith) {
	  String.prototype.endsWith = function (searchString, position) {
	    var subjectString = this.toString();
	    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
	      position = subjectString.length;
	    }
	    position -= searchString.length;
	    var lastIndex = subjectString.indexOf(searchString, position);
	    return lastIndex !== -1 && lastIndex === position;
	  };
	}
	
	if (!Array.prototype.find) {
	  Object.defineProperty(Array.prototype, "find", {
	    value: function value(predicate) {
	      if (this === null) {
	        throw new TypeError('Array.prototype.find called on null or undefined');
	      }
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	      var list = Object(this);
	      var length = list.length >>> 0;
	      var thisArg = arguments[1];
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return value;
	        }
	      }
	      return undefined;
	    }
	  });
	}
	
	document.addEventListener("DOMContentLoaded", function () {
	  // Disable resizing in Firefox
	  document.execCommand("enableObjectResizing", false, false);
	  // Disable automatic linkifying in IE11
	  document.execCommand("autoUrlDetect", false, false);
	});
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports) {
	
	/**
	 * This library modifies the diff-patch-match library by Neil Fraser
	 * by removing the patch and match functionality and certain advanced
	 * options in the diff function. The original license is as follows:
	 *
	 * ===
	 *
	 * Diff Match and Patch
	 *
	 * Copyright 2006 Google Inc.
	 * http://code.google.com/p/google-diff-match-patch/
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	/**
	 * The data structure representing a diff is an array of tuples:
	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
	 */
	var DIFF_DELETE = -1;
	var DIFF_INSERT = 1;
	var DIFF_EQUAL = 0;
	
	
	/**
	 * Find the differences between two texts.  Simplifies the problem by stripping
	 * any common prefix or suffix off the texts before diffing.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {Int} cursor_pos Expected edit position in text1 (optional)
	 * @return {Array} Array of diff tuples.
	 */
	function diff_main(text1, text2, cursor_pos) {
	  // Check for equality (speedup).
	  if (text1 == text2) {
	    if (text1) {
	      return [[DIFF_EQUAL, text1]];
	    }
	    return [];
	  }
	
	  // Check cursor_pos within bounds
	  if (cursor_pos < 0 || text1.length < cursor_pos) {
	    cursor_pos = null;
	  }
	
	  // Trim off common prefix (speedup).
	  var commonlength = diff_commonPrefix(text1, text2);
	  var commonprefix = text1.substring(0, commonlength);
	  text1 = text1.substring(commonlength);
	  text2 = text2.substring(commonlength);
	
	  // Trim off common suffix (speedup).
	  commonlength = diff_commonSuffix(text1, text2);
	  var commonsuffix = text1.substring(text1.length - commonlength);
	  text1 = text1.substring(0, text1.length - commonlength);
	  text2 = text2.substring(0, text2.length - commonlength);
	
	  // Compute the diff on the middle block.
	  var diffs = diff_compute_(text1, text2);
	
	  // Restore the prefix and suffix.
	  if (commonprefix) {
	    diffs.unshift([DIFF_EQUAL, commonprefix]);
	  }
	  if (commonsuffix) {
	    diffs.push([DIFF_EQUAL, commonsuffix]);
	  }
	  diff_cleanupMerge(diffs);
	  if (cursor_pos != null) {
	    diffs = fix_cursor(diffs, cursor_pos);
	  }
	  diffs = fix_emoji(diffs);
	  return diffs;
	};
	
	
	/**
	 * Find the differences between two texts.  Assumes that the texts do not
	 * have any common prefix or suffix.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_compute_(text1, text2) {
	  var diffs;
	
	  if (!text1) {
	    // Just add some text (speedup).
	    return [[DIFF_INSERT, text2]];
	  }
	
	  if (!text2) {
	    // Just delete some text (speedup).
	    return [[DIFF_DELETE, text1]];
	  }
	
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  var i = longtext.indexOf(shorttext);
	  if (i != -1) {
	    // Shorter text is inside the longer text (speedup).
	    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
	             [DIFF_EQUAL, shorttext],
	             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
	    // Swap insertions for deletions if diff is reversed.
	    if (text1.length > text2.length) {
	      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
	    }
	    return diffs;
	  }
	
	  if (shorttext.length == 1) {
	    // Single character string.
	    // After the previous speedup, the character can't be an equality.
	    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	  }
	
	  // Check to see if the problem can be split in two.
	  var hm = diff_halfMatch_(text1, text2);
	  if (hm) {
	    // A half-match was found, sort out the return data.
	    var text1_a = hm[0];
	    var text1_b = hm[1];
	    var text2_a = hm[2];
	    var text2_b = hm[3];
	    var mid_common = hm[4];
	    // Send both pairs off for separate processing.
	    var diffs_a = diff_main(text1_a, text2_a);
	    var diffs_b = diff_main(text1_b, text2_b);
	    // Merge the results.
	    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
	  }
	
	  return diff_bisect_(text1, text2);
	};
	
	
	/**
	 * Find the 'middle snake' of a diff, split the problem in two
	 * and return the recursively constructed diff.
	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 * @private
	 */
	function diff_bisect_(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  var max_d = Math.ceil((text1_length + text2_length) / 2);
	  var v_offset = max_d;
	  var v_length = 2 * max_d;
	  var v1 = new Array(v_length);
	  var v2 = new Array(v_length);
	  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
	  // integers and undefined.
	  for (var x = 0; x < v_length; x++) {
	    v1[x] = -1;
	    v2[x] = -1;
	  }
	  v1[v_offset + 1] = 0;
	  v2[v_offset + 1] = 0;
	  var delta = text1_length - text2_length;
	  // If the total number of characters is odd, then the front path will collide
	  // with the reverse path.
	  var front = (delta % 2 != 0);
	  // Offsets for start and end of k loop.
	  // Prevents mapping of space beyond the grid.
	  var k1start = 0;
	  var k1end = 0;
	  var k2start = 0;
	  var k2end = 0;
	  for (var d = 0; d < max_d; d++) {
	    // Walk the front path one step.
	    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
	      var k1_offset = v_offset + k1;
	      var x1;
	      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
	        x1 = v1[k1_offset + 1];
	      } else {
	        x1 = v1[k1_offset - 1] + 1;
	      }
	      var y1 = x1 - k1;
	      while (x1 < text1_length && y1 < text2_length &&
	             text1.charAt(x1) == text2.charAt(y1)) {
	        x1++;
	        y1++;
	      }
	      v1[k1_offset] = x1;
	      if (x1 > text1_length) {
	        // Ran off the right of the graph.
	        k1end += 2;
	      } else if (y1 > text2_length) {
	        // Ran off the bottom of the graph.
	        k1start += 2;
	      } else if (front) {
	        var k2_offset = v_offset + delta - k1;
	        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
	          // Mirror x2 onto top-left coordinate system.
	          var x2 = text1_length - v2[k2_offset];
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	
	    // Walk the reverse path one step.
	    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
	      var k2_offset = v_offset + k2;
	      var x2;
	      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
	        x2 = v2[k2_offset + 1];
	      } else {
	        x2 = v2[k2_offset - 1] + 1;
	      }
	      var y2 = x2 - k2;
	      while (x2 < text1_length && y2 < text2_length &&
	             text1.charAt(text1_length - x2 - 1) ==
	             text2.charAt(text2_length - y2 - 1)) {
	        x2++;
	        y2++;
	      }
	      v2[k2_offset] = x2;
	      if (x2 > text1_length) {
	        // Ran off the left of the graph.
	        k2end += 2;
	      } else if (y2 > text2_length) {
	        // Ran off the top of the graph.
	        k2start += 2;
	      } else if (!front) {
	        var k1_offset = v_offset + delta - k2;
	        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
	          var x1 = v1[k1_offset];
	          var y1 = v_offset + x1 - k1_offset;
	          // Mirror x2 onto top-left coordinate system.
	          x2 = text1_length - x2;
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	  }
	  // Diff took too long and hit the deadline or
	  // number of diffs equals number of characters, no commonality at all.
	  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	};
	
	
	/**
	 * Given the location of the 'middle snake', split the diff in two parts
	 * and recurse.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} x Index of split point in text1.
	 * @param {number} y Index of split point in text2.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_bisectSplit_(text1, text2, x, y) {
	  var text1a = text1.substring(0, x);
	  var text2a = text2.substring(0, y);
	  var text1b = text1.substring(x);
	  var text2b = text2.substring(y);
	
	  // Compute both diffs serially.
	  var diffs = diff_main(text1a, text2a);
	  var diffsb = diff_main(text1b, text2b);
	
	  return diffs.concat(diffsb);
	};
	
	
	/**
	 * Determine the common prefix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the start of each
	 *     string.
	 */
	function diff_commonPrefix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerstart = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(pointerstart, pointermid) ==
	        text2.substring(pointerstart, pointermid)) {
	      pointermin = pointermid;
	      pointerstart = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Determine the common suffix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of each string.
	 */
	function diff_commonSuffix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 ||
	      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerend = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
	        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
	      pointermin = pointermid;
	      pointerend = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Do the two texts share a substring which is at least half the length of the
	 * longer text?
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {Array.<string>} Five element Array, containing the prefix of
	 *     text1, the suffix of text1, the prefix of text2, the suffix of
	 *     text2 and the common middle.  Or null if there was no match.
	 */
	function diff_halfMatch_(text1, text2) {
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
	    return null;  // Pointless.
	  }
	
	  /**
	   * Does a substring of shorttext exist within longtext such that the substring
	   * is at least half the length of longtext?
	   * Closure, but does not reference any external variables.
	   * @param {string} longtext Longer string.
	   * @param {string} shorttext Shorter string.
	   * @param {number} i Start index of quarter length substring within longtext.
	   * @return {Array.<string>} Five element Array, containing the prefix of
	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
	   *     of shorttext and the common middle.  Or null if there was no match.
	   * @private
	   */
	  function diff_halfMatchI_(longtext, shorttext, i) {
	    // Start with a 1/4 length substring at position i as a seed.
	    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
	    var j = -1;
	    var best_common = '';
	    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
	    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
	      var prefixLength = diff_commonPrefix(longtext.substring(i),
	                                           shorttext.substring(j));
	      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
	                                           shorttext.substring(0, j));
	      if (best_common.length < suffixLength + prefixLength) {
	        best_common = shorttext.substring(j - suffixLength, j) +
	            shorttext.substring(j, j + prefixLength);
	        best_longtext_a = longtext.substring(0, i - suffixLength);
	        best_longtext_b = longtext.substring(i + prefixLength);
	        best_shorttext_a = shorttext.substring(0, j - suffixLength);
	        best_shorttext_b = shorttext.substring(j + prefixLength);
	      }
	    }
	    if (best_common.length * 2 >= longtext.length) {
	      return [best_longtext_a, best_longtext_b,
	              best_shorttext_a, best_shorttext_b, best_common];
	    } else {
	      return null;
	    }
	  }
	
	  // First check if the second quarter is the seed for a half-match.
	  var hm1 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 4));
	  // Check again based on the third quarter.
	  var hm2 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 2));
	  var hm;
	  if (!hm1 && !hm2) {
	    return null;
	  } else if (!hm2) {
	    hm = hm1;
	  } else if (!hm1) {
	    hm = hm2;
	  } else {
	    // Both matched.  Select the longest.
	    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
	  }
	
	  // A half-match was found, sort out the return data.
	  var text1_a, text1_b, text2_a, text2_b;
	  if (text1.length > text2.length) {
	    text1_a = hm[0];
	    text1_b = hm[1];
	    text2_a = hm[2];
	    text2_b = hm[3];
	  } else {
	    text2_a = hm[0];
	    text2_b = hm[1];
	    text1_a = hm[2];
	    text1_b = hm[3];
	  }
	  var mid_common = hm[4];
	  return [text1_a, text1_b, text2_a, text2_b, mid_common];
	};
	
	
	/**
	 * Reorder and merge like edit sections.  Merge equalities.
	 * Any edit section can move as long as it doesn't cross an equality.
	 * @param {Array} diffs Array of diff tuples.
	 */
	function diff_cleanupMerge(diffs) {
	  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  var commonlength;
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete + count_insert > 1) {
	          if (count_delete !== 0 && count_insert !== 0) {
	            // Factor out any common prefixies.
	            commonlength = diff_commonPrefix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              if ((pointer - count_delete - count_insert) > 0 &&
	                  diffs[pointer - count_delete - count_insert - 1][0] ==
	                  DIFF_EQUAL) {
	                diffs[pointer - count_delete - count_insert - 1][1] +=
	                    text_insert.substring(0, commonlength);
	              } else {
	                diffs.splice(0, 0, [DIFF_EQUAL,
	                                    text_insert.substring(0, commonlength)]);
	                pointer++;
	              }
	              text_insert = text_insert.substring(commonlength);
	              text_delete = text_delete.substring(commonlength);
	            }
	            // Factor out any common suffixies.
	            commonlength = diff_commonSuffix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              diffs[pointer][1] = text_insert.substring(text_insert.length -
	                  commonlength) + diffs[pointer][1];
	              text_insert = text_insert.substring(0, text_insert.length -
	                  commonlength);
	              text_delete = text_delete.substring(0, text_delete.length -
	                  commonlength);
	            }
	          }
	          // Delete the offending records and add the merged ones.
	          if (count_delete === 0) {
	            diffs.splice(pointer - count_insert,
	                count_delete + count_insert, [DIFF_INSERT, text_insert]);
	          } else if (count_insert === 0) {
	            diffs.splice(pointer - count_delete,
	                count_delete + count_insert, [DIFF_DELETE, text_delete]);
	          } else {
	            diffs.splice(pointer - count_delete - count_insert,
	                count_delete + count_insert, [DIFF_DELETE, text_delete],
	                [DIFF_INSERT, text_insert]);
	          }
	          pointer = pointer - count_delete - count_insert +
	                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
	        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
	          // Merge this equality with the previous one.
	          diffs[pointer - 1][1] += diffs[pointer][1];
	          diffs.splice(pointer, 1);
	        } else {
	          pointer++;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	  }
	  if (diffs[diffs.length - 1][1] === '') {
	    diffs.pop();  // Remove the dummy entry at the end.
	  }
	
	  // Second pass: look for single edits surrounded on both sides by equalities
	  // which can be shifted sideways to eliminate an equality.
	  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
	  var changes = false;
	  pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      if (diffs[pointer][1].substring(diffs[pointer][1].length -
	          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
	        // Shift the edit over the previous equality.
	        diffs[pointer][1] = diffs[pointer - 1][1] +
	            diffs[pointer][1].substring(0, diffs[pointer][1].length -
	                                        diffs[pointer - 1][1].length);
	        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
	        diffs.splice(pointer - 1, 1);
	        changes = true;
	      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
	          diffs[pointer + 1][1]) {
	        // Shift the edit over the next equality.
	        diffs[pointer - 1][1] += diffs[pointer + 1][1];
	        diffs[pointer][1] =
	            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
	            diffs[pointer + 1][1];
	        diffs.splice(pointer + 1, 1);
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	  // If shifts were made, the diff needs reordering and another shift sweep.
	  if (changes) {
	    diff_cleanupMerge(diffs);
	  }
	};
	
	
	var diff = diff_main;
	diff.INSERT = DIFF_INSERT;
	diff.DELETE = DIFF_DELETE;
	diff.EQUAL = DIFF_EQUAL;
	
	module.exports = diff;
	
	/*
	 * Modify a diff such that the cursor position points to the start of a change:
	 * E.g.
	 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
	 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
	 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
	 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
	 */
	function cursor_normalize_diff (diffs, cursor_pos) {
	  if (cursor_pos === 0) {
	    return [DIFF_EQUAL, diffs];
	  }
	  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
	    var d = diffs[i];
	    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
	      var next_pos = current_pos + d[1].length;
	      if (cursor_pos === next_pos) {
	        return [i + 1, diffs];
	      } else if (cursor_pos < next_pos) {
	        // copy to prevent side effects
	        diffs = diffs.slice();
	        // split d into two diff changes
	        var split_pos = cursor_pos - current_pos;
	        var d_left = [d[0], d[1].slice(0, split_pos)];
	        var d_right = [d[0], d[1].slice(split_pos)];
	        diffs.splice(i, 1, d_left, d_right);
	        return [i + 1, diffs];
	      } else {
	        current_pos = next_pos;
	      }
	    }
	  }
	  throw new Error('cursor_pos is out of bounds!')
	}
	
	/*
	 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
	 *
	 * Case 1)
	 *   Check if a naive shift is possible:
	 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
	 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
	 * Case 2)
	 *   Check if the following shifts are possible:
	 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
	 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
	 *         ^            ^
	 *         d          d_next
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} Array of diff tuples
	 */
	function fix_cursor (diffs, cursor_pos) {
	  var norm = cursor_normalize_diff(diffs, cursor_pos);
	  var ndiffs = norm[1];
	  var cursor_pointer = norm[0];
	  var d = ndiffs[cursor_pointer];
	  var d_next = ndiffs[cursor_pointer + 1];
	
	  if (d == null) {
	    // Text was deleted from end of original string,
	    // cursor is now out of bounds in new string
	    return diffs;
	  } else if (d[0] !== DIFF_EQUAL) {
	    // A modification happened at the cursor location.
	    // This is the expected outcome, so we can return the original diff.
	    return diffs;
	  } else {
	    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
	      // Case 1)
	      // It is possible to perform a naive shift
	      ndiffs.splice(cursor_pointer, 2, d_next, d)
	      return merge_tuples(ndiffs, cursor_pointer, 2)
	    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
	      // Case 2)
	      // d[1] is a prefix of d_next[1]
	      // We can assume that d_next[0] !== 0, since d[0] === 0
	      // Shift edit locations..
	      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
	      var suffix = d_next[1].slice(d[1].length);
	      if (suffix.length > 0) {
	        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
	      }
	      return merge_tuples(ndiffs, cursor_pointer, 3)
	    } else {
	      // Not possible to perform any modification
	      return diffs;
	    }
	  }
	}
	
	/*
	 * Check diff did not split surrogate pairs.
	 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
	 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @return {Array} Array of diff tuples
	 */
	function fix_emoji (diffs) {
	  var compact = false;
	  var starts_with_pair_end = function(str) {
	    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
	  }
	  var ends_with_pair_start = function(str) {
	    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
	  }
	  for (var i = 2; i < diffs.length; i += 1) {
	    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
	        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
	        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
	      compact = true;
	
	      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
	      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];
	
	      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
	    }
	  }
	  if (!compact) {
	    return diffs;
	  }
	  var fixed_diffs = [];
	  for (var i = 0; i < diffs.length; i += 1) {
	    if (diffs[i][1].length > 0) {
	      fixed_diffs.push(diffs[i]);
	    }
	  }
	  return fixed_diffs;
	}
	
	/*
	 * Try to merge tuples with their neigbors in a given range.
	 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
	 *
	 * @param {Array} diffs Array of diff tuples.
	 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
	 * @param {Int} length Number of consecutive elements to check.
	 * @return {Array} Array of merged diff tuples.
	 */
	function merge_tuples (diffs, start, length) {
	  // Check from (start-1) to (start+length).
	  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
	    if (i + 1 < diffs.length) {
	      var left_d = diffs[i];
	      var right_d = diffs[i+1];
	      if (left_d[0] === right_d[1]) {
	        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
	      }
	    }
	  }
	  return diffs;
	}
	
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports) {
	
	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports) {
	
	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};
	
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports) {
	
	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @api private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {Mixed} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Boolean} exists Only check if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {Mixed} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	         listeners.fn === fn
	      && (!once || listeners.once)
	      && (!context || listeners.context === context)
	    ) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	           listeners[i].fn !== fn
	        || (once && !listeners[i].once)
	        || (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {String|Symbol} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if ('undefined' !== typeof module) {
	  module.exports = EventEmitter;
	}
	
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend2 = __webpack_require__(3);
	
	var _extend3 = _interopRequireDefault(_extend2);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _align = __webpack_require__(36);
	
	var _background = __webpack_require__(37);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _color = __webpack_require__(26);
	
	var _direction = __webpack_require__(38);
	
	var _font = __webpack_require__(39);
	
	var _size = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:clipboard');
	
	var DOM_KEY = '__ql-matcher';
	
	var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];
	
	var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	
	var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	
	var Clipboard = function (_Module) {
	  _inherits(Clipboard, _Module);
	
	  function Clipboard(quill, options) {
	    _classCallCheck(this, Clipboard);
	
	    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));
	
	    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
	    _this.container = _this.quill.addContainer('ql-clipboard');
	    _this.container.setAttribute('contenteditable', true);
	    _this.container.setAttribute('tabindex', -1);
	    _this.matchers = [];
	    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          selector = _ref2[0],
	          matcher = _ref2[1];
	
	      if (!options.matchVisual && matcher === matchSpacing) return;
	      _this.addMatcher(selector, matcher);
	    });
	    return _this;
	  }
	
	  _createClass(Clipboard, [{
	    key: 'addMatcher',
	    value: function addMatcher(selector, matcher) {
	      this.matchers.push([selector, matcher]);
	    }
	  }, {
	    key: 'convert',
	    value: function convert(html) {
	      if (typeof html === 'string') {
	        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
	        return this.convert();
	      }
	      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
	      if (formats[_code2.default.blotName]) {
	        var text = this.container.innerText;
	        this.container.innerHTML = '';
	        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
	      }
	
	      var _prepareMatching = this.prepareMatching(),
	          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
	          elementMatchers = _prepareMatching2[0],
	          textMatchers = _prepareMatching2[1];
	
	      var delta = traverse(this.container, elementMatchers, textMatchers);
	      // Remove trailing newline
	      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
	        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
	      }
	      debug.log('convert', this.container.innerHTML, delta);
	      this.container.innerHTML = '';
	      return delta;
	    }
	  }, {
	    key: 'dangerouslyPasteHTML',
	    value: function dangerouslyPasteHTML(index, html) {
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;
	
	      if (typeof index === 'string') {
	        this.quill.setContents(this.convert(index), html);
	        this.quill.setSelection(0, _quill2.default.sources.SILENT);
	      } else {
	        var paste = this.convert(html);
	        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
	        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
	      }
	    }
	  }, {
	    key: 'onPaste',
	    value: function onPaste(e) {
	      var _this2 = this;
	
	      if (e.defaultPrevented || !this.quill.isEnabled()) return;
	      var range = this.quill.getSelection();
	      var delta = new _quillDelta2.default().retain(range.index);
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.container.focus();
	      this.quill.selection.update(_quill2.default.sources.SILENT);
	      setTimeout(function () {
	        delta = delta.concat(_this2.convert()).delete(range.length);
	        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
	        // range.length contributes to delta.length()
	        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
	        _this2.quill.scrollingContainer.scrollTop = scrollTop;
	        _this2.quill.focus();
	      }, 1);
	    }
	  }, {
	    key: 'prepareMatching',
	    value: function prepareMatching() {
	      var _this3 = this;
	
	      var elementMatchers = [],
	          textMatchers = [];
	      this.matchers.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            selector = _pair[0],
	            matcher = _pair[1];
	
	        switch (selector) {
	          case Node.TEXT_NODE:
	            textMatchers.push(matcher);
	            break;
	          case Node.ELEMENT_NODE:
	            elementMatchers.push(matcher);
	            break;
	          default:
	            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
	              // TODO use weakmap
	              node[DOM_KEY] = node[DOM_KEY] || [];
	              node[DOM_KEY].push(matcher);
	            });
	            break;
	        }
	      });
	      return [elementMatchers, textMatchers];
	    }
	  }]);
	
	  return Clipboard;
	}(_module2.default);
	
	Clipboard.DEFAULTS = {
	  matchers: [],
	  matchVisual: true
	};
	
	function applyFormat(delta, format, value) {
	  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
	    return Object.keys(format).reduce(function (delta, key) {
	      return applyFormat(delta, key, format[key]);
	    }, delta);
	  } else {
	    return delta.reduce(function (delta, op) {
	      if (op.attributes && op.attributes[format]) {
	        return delta.push(op);
	      } else {
	        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
	      }
	    }, new _quillDelta2.default());
	  }
	}
	
	function computeStyle(node) {
	  if (node.nodeType !== Node.ELEMENT_NODE) return {};
	  var DOM_KEY = '__ql-computed-style';
	  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
	}
	
	function deltaEndsWith(delta, text) {
	  var endText = "";
	  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
	    var op = delta.ops[i];
	    if (typeof op.insert !== 'string') break;
	    endText = op.insert + endText;
	  }
	  return endText.slice(-1 * text.length) === text;
	}
	
	function isLine(node) {
	  if (node.childNodes.length === 0) return false; // Exclude embed blocks
	  var style = computeStyle(node);
	  return ['block', 'list-item'].indexOf(style.display) > -1;
	}
	
	function traverse(node, elementMatchers, textMatchers) {
	  // Post-order
	  if (node.nodeType === node.TEXT_NODE) {
	    return textMatchers.reduce(function (delta, matcher) {
	      return matcher(node, delta);
	    }, new _quillDelta2.default());
	  } else if (node.nodeType === node.ELEMENT_NODE) {
	    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
	      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
	      if (childNode.nodeType === node.ELEMENT_NODE) {
	        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	      }
	      return delta.concat(childrenDelta);
	    }, new _quillDelta2.default());
	  } else {
	    return new _quillDelta2.default();
	  }
	}
	
	function matchAlias(format, node, delta) {
	  return applyFormat(delta, format, true);
	}
	
	function matchAttributor(node, delta) {
	  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
	  var classes = _parchment2.default.Attributor.Class.keys(node);
	  var styles = _parchment2.default.Attributor.Style.keys(node);
	  var formats = {};
	  attributes.concat(classes).concat(styles).forEach(function (name) {
	    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
	    if (attr != null) {
	      formats[attr.attrName] = attr.value(node);
	      if (formats[attr.attrName]) return;
	    }
	    attr = ATTRIBUTE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	    attr = STYLE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      attr = STYLE_ATTRIBUTORS[name];
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	  });
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  return delta;
	}
	
	function matchBlot(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null) return delta;
	  if (match.prototype instanceof _parchment2.default.Embed) {
	    var embed = {};
	    var value = match.value(node);
	    if (value != null) {
	      embed[match.blotName] = value;
	      delta = new _quillDelta2.default().insert(embed, match.formats(node));
	    }
	  } else if (typeof match.formats === 'function') {
	    delta = applyFormat(delta, match.blotName, match.formats(node));
	  }
	  return delta;
	}
	
	function matchBreak(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    delta.insert('\n');
	  }
	  return delta;
	}
	
	function matchIgnore() {
	  return new _quillDelta2.default();
	}
	
	function matchIndent(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
	    return delta;
	  }
	  var indent = -1,
	      parent = node.parentNode;
	  while (!parent.classList.contains('ql-clipboard')) {
	    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
	      indent += 1;
	    }
	    parent = parent.parentNode;
	  }
	  if (indent <= 0) return delta;
	  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
	}
	
	function matchNewline(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}
	
	function matchSpacing(node, delta) {
	  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
	    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
	    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}
	
	function matchStyles(node, delta) {
	  var formats = {};
	  var style = node.style || {};
	  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
	    formats.italic = true;
	  }
	  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
	    formats.bold = true;
	  }
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  if (parseFloat(style.textIndent || 0) > 0) {
	    // Could be 0.5in
	    delta = new _quillDelta2.default().insert('\t').concat(delta);
	  }
	  return delta;
	}
	
	function matchText(node, delta) {
	  var text = node.data;
	  // Word represents empty line with <o:p>&nbsp;</o:p>
	  if (node.parentNode.tagName === 'O:P') {
	    return delta.insert(text.trim());
	  }
	  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
	    return delta;
	  }
	  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
	    // eslint-disable-next-line func-style
	    var replacer = function replacer(collapse, match) {
	      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
	      return match.length < 1 && collapse ? ' ' : match;
	    };
	    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
	    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
	    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
	      text = text.replace(/^\s+/, replacer.bind(replacer, false));
	    }
	    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
	      text = text.replace(/\s+$/, replacer.bind(replacer, false));
	    }
	  }
	  return delta.insert(text);
	}
	
	exports.default = Clipboard;
	exports.matchAttributor = matchAttributor;
	exports.matchBlot = matchBlot;
	exports.matchNewline = matchNewline;
	exports.matchSpacing = matchSpacing;
	exports.matchText = matchText;
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bold = function (_Inline) {
	  _inherits(Bold, _Inline);
	
	  function Bold() {
	    _classCallCheck(this, Bold);
	
	    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
	  }
	
	  _createClass(Bold, [{
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
	      if (this.domNode.tagName !== this.statics.tagName[0]) {
	        this.replaceWith(this.statics.blotName);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create() {
	      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);
	
	  return Bold;
	}(_inline2.default);
	
	Bold.blotName = 'bold';
	Bold.tagName = ['STRONG', 'B'];
	
	exports.default = Bold;
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addControls = exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:toolbar');
	
	var Toolbar = function (_Module) {
	  _inherits(Toolbar, _Module);
	
	  function Toolbar(quill, options) {
	    _classCallCheck(this, Toolbar);
	
	    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));
	
	    if (Array.isArray(_this.options.container)) {
	      var container = document.createElement('div');
	      addControls(container, _this.options.container);
	      quill.container.parentNode.insertBefore(container, quill.container);
	      _this.container = container;
	    } else if (typeof _this.options.container === 'string') {
	      _this.container = document.querySelector(_this.options.container);
	    } else {
	      _this.container = _this.options.container;
	    }
	    if (!(_this.container instanceof HTMLElement)) {
	      var _ret;
	
	      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
	    }
	    _this.container.classList.add('ql-toolbar');
	    _this.controls = [];
	    _this.handlers = {};
	    Object.keys(_this.options.handlers).forEach(function (format) {
	      _this.addHandler(format, _this.options.handlers[format]);
	    });
	    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
	      _this.attach(input);
	    });
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
	      if (type === _quill2.default.events.SELECTION_CHANGE) {
	        _this.update(range);
	      }
	    });
	    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      var _this$quill$selection = _this.quill.selection.getRange(),
	          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
	          range = _this$quill$selection2[0]; // quill.getSelection triggers update
	
	
	      _this.update(range);
	    });
	    return _this;
	  }
	
	  _createClass(Toolbar, [{
	    key: 'addHandler',
	    value: function addHandler(format, handler) {
	      this.handlers[format] = handler;
	    }
	  }, {
	    key: 'attach',
	    value: function attach(input) {
	      var _this2 = this;
	
	      var format = [].find.call(input.classList, function (className) {
	        return className.indexOf('ql-') === 0;
	      });
	      if (!format) return;
	      format = format.slice('ql-'.length);
	      if (input.tagName === 'BUTTON') {
	        input.setAttribute('type', 'button');
	      }
	      if (this.handlers[format] == null) {
	        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
	          debug.warn('ignoring attaching to disabled format', format, input);
	          return;
	        }
	        if (_parchment2.default.query(format) == null) {
	          debug.warn('ignoring attaching to nonexistent format', format, input);
	          return;
	        }
	      }
	      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
	      input.addEventListener(eventName, function (e) {
	        var value = void 0;
	        if (input.tagName === 'SELECT') {
	          if (input.selectedIndex < 0) return;
	          var selected = input.options[input.selectedIndex];
	          if (selected.hasAttribute('selected')) {
	            value = false;
	          } else {
	            value = selected.value || false;
	          }
	        } else {
	          if (input.classList.contains('ql-active')) {
	            value = false;
	          } else {
	            value = input.value || !input.hasAttribute('value');
	          }
	          e.preventDefault();
	        }
	        _this2.quill.focus();
	
	        var _quill$selection$getR = _this2.quill.selection.getRange(),
	            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
	            range = _quill$selection$getR2[0];
	
	        if (_this2.handlers[format] != null) {
	          _this2.handlers[format].call(_this2, value);
	        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
	          value = prompt('Enter ' + format);
	          if (!value) return;
	          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
	        } else {
	          _this2.quill.format(format, value, _quill2.default.sources.USER);
	        }
	        _this2.update(range);
	      });
	      // TODO use weakmap
	      this.controls.push([format, input]);
	    }
	  }, {
	    key: 'update',
	    value: function update(range) {
	      var formats = range == null ? {} : this.quill.getFormat(range);
	      this.controls.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            format = _pair[0],
	            input = _pair[1];
	
	        if (input.tagName === 'SELECT') {
	          var option = void 0;
	          if (range == null) {
	            option = null;
	          } else if (formats[format] == null) {
	            option = input.querySelector('option[selected]');
	          } else if (!Array.isArray(formats[format])) {
	            var value = formats[format];
	            if (typeof value === 'string') {
	              value = value.replace(/\"/g, '\\"');
	            }
	            option = input.querySelector('option[value="' + value + '"]');
	          }
	          if (option == null) {
	            input.value = ''; // TODO make configurable?
	            input.selectedIndex = -1;
	          } else {
	            option.selected = true;
	          }
	        } else {
	          if (range == null) {
	            input.classList.remove('ql-active');
	          } else if (input.hasAttribute('value')) {
	            // both being null should match (default values)
	            // '1' should match with 1 (headers)
	            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
	            input.classList.toggle('ql-active', isActive);
	          } else {
	            input.classList.toggle('ql-active', formats[format] != null);
	          }
	        }
	      });
	    }
	  }]);
	
	  return Toolbar;
	}(_module2.default);
	
	Toolbar.DEFAULTS = {};
	
	function addButton(container, format, value) {
	  var input = document.createElement('button');
	  input.setAttribute('type', 'button');
	  input.classList.add('ql-' + format);
	  if (value != null) {
	    input.value = value;
	  }
	  container.appendChild(input);
	}
	
	function addControls(container, groups) {
	  if (!Array.isArray(groups[0])) {
	    groups = [groups];
	  }
	  groups.forEach(function (controls) {
	    var group = document.createElement('span');
	    group.classList.add('ql-formats');
	    controls.forEach(function (control) {
	      if (typeof control === 'string') {
	        addButton(group, control);
	      } else {
	        var format = Object.keys(control)[0];
	        var value = control[format];
	        if (Array.isArray(value)) {
	          addSelect(group, format, value);
	        } else {
	          addButton(group, format, value);
	        }
	      }
	    });
	    container.appendChild(group);
	  });
	}
	
	function addSelect(container, format, values) {
	  var input = document.createElement('select');
	  input.classList.add('ql-' + format);
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value !== false) {
	      option.setAttribute('value', value);
	    } else {
	      option.setAttribute('selected', 'selected');
	    }
	    input.appendChild(option);
	  });
	  container.appendChild(input);
	}
	
	Toolbar.DEFAULTS = {
	  container: null,
	  handlers: {
	    clean: function clean() {
	      var _this3 = this;
	
	      var range = this.quill.getSelection();
	      if (range == null) return;
	      if (range.length == 0) {
	        var formats = this.quill.getFormat();
	        Object.keys(formats).forEach(function (name) {
	          // Clean functionality in existing apps only clean inline formats
	          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
	            _this3.quill.format(name, false);
	          }
	        });
	      } else {
	        this.quill.removeFormat(range, _quill2.default.sources.USER);
	      }
	    },
	    direction: function direction(value) {
	      var align = this.quill.getFormat()['align'];
	      if (value === 'rtl' && align == null) {
	        this.quill.format('align', 'right', _quill2.default.sources.USER);
	      } else if (!value && align === 'right') {
	        this.quill.format('align', false, _quill2.default.sources.USER);
	      }
	      this.quill.format('direction', value, _quill2.default.sources.USER);
	    },
	    indent: function indent(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      var indent = parseInt(formats.indent || 0);
	      if (value === '+1' || value === '-1') {
	        var modifier = value === '+1' ? 1 : -1;
	        if (formats.direction === 'rtl') modifier *= -1;
	        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
	      }
	    },
	    link: function link(value) {
	      if (value === true) {
	        value = prompt('Enter link URL:');
	      }
	      this.quill.format('link', value, _quill2.default.sources.USER);
	    },
	    list: function list(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      if (value === 'check') {
	        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        } else {
	          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
	        }
	      } else {
	        this.quill.format('list', value, _quill2.default.sources.USER);
	      }
	    }
	  }
	};
	
	exports.default = Toolbar;
	exports.addControls = addControls;
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorPicker = function (_Picker) {
	  _inherits(ColorPicker, _Picker);
	
	  function ColorPicker(select, label) {
	    _classCallCheck(this, ColorPicker);
	
	    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));
	
	    _this.label.innerHTML = label;
	    _this.container.classList.add('ql-color-picker');
	    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
	      item.classList.add('ql-primary');
	    });
	    return _this;
	  }
	
	  _createClass(ColorPicker, [{
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
	      item.style.backgroundColor = option.getAttribute('value') || '';
	      return item;
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      var colorLabel = this.label.querySelector('.ql-color-label');
	      var value = item ? item.getAttribute('data-value') || '' : '';
	      if (colorLabel) {
	        if (colorLabel.tagName === 'line') {
	          colorLabel.style.stroke = value;
	        } else {
	          colorLabel.style.fill = value;
	        }
	      }
	    }
	  }]);
	
	  return ColorPicker;
	}(_picker2.default);
	
	exports.default = ColorPicker;
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconPicker = function (_Picker) {
	  _inherits(IconPicker, _Picker);
	
	  function IconPicker(select, icons) {
	    _classCallCheck(this, IconPicker);
	
	    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));
	
	    _this.container.classList.add('ql-icon-picker');
	    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
	      item.innerHTML = icons[item.getAttribute('data-value') || ''];
	    });
	    _this.defaultItem = _this.container.querySelector('.ql-selected');
	    _this.selectItem(_this.defaultItem);
	    return _this;
	  }
	
	  _createClass(IconPicker, [{
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      item = item || this.defaultItem;
	      this.label.innerHTML = item.innerHTML;
	    }
	  }]);
	
	  return IconPicker;
	}(_picker2.default);
	
	exports.default = IconPicker;
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Tooltip = function () {
	  function Tooltip(quill, boundsContainer) {
	    var _this = this;
	
	    _classCallCheck(this, Tooltip);
	
	    this.quill = quill;
	    this.boundsContainer = boundsContainer || document.body;
	    this.root = quill.addContainer('ql-tooltip');
	    this.root.innerHTML = this.constructor.TEMPLATE;
	    if (this.quill.root === this.quill.scrollingContainer) {
	      this.quill.root.addEventListener('scroll', function () {
	        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
	      });
	    }
	    this.hide();
	  }
	
	  _createClass(Tooltip, [{
	    key: 'hide',
	    value: function hide() {
	      this.root.classList.add('ql-hidden');
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
	      // root.scrollTop should be 0 if scrollContainer !== root
	      var top = reference.bottom + this.quill.root.scrollTop;
	      this.root.style.left = left + 'px';
	      this.root.style.top = top + 'px';
	      this.root.classList.remove('ql-flip');
	      var containerBounds = this.boundsContainer.getBoundingClientRect();
	      var rootBounds = this.root.getBoundingClientRect();
	      var shift = 0;
	      if (rootBounds.right > containerBounds.right) {
	        shift = containerBounds.right - rootBounds.right;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.left < containerBounds.left) {
	        shift = containerBounds.left - rootBounds.left;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.bottom > containerBounds.bottom) {
	        var height = rootBounds.bottom - rootBounds.top;
	        var verticalShift = reference.bottom - reference.top + height;
	        this.root.style.top = top - verticalShift + 'px';
	        this.root.classList.add('ql-flip');
	      }
	      return shift;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.root.classList.remove('ql-editing');
	      this.root.classList.remove('ql-hidden');
	    }
	  }]);
	
	  return Tooltip;
	}();
	
	exports.default = Tooltip;
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _base = __webpack_require__(43);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _selection = __webpack_require__(15);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];
	
	var SnowTheme = function (_BaseTheme) {
	  _inherits(SnowTheme, _BaseTheme);
	
	  function SnowTheme(quill, options) {
	    _classCallCheck(this, SnowTheme);
	
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	
	    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));
	
	    _this.quill.container.classList.add('ql-snow');
	    return _this;
	  }
	
	  _createClass(SnowTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      toolbar.container.classList.add('ql-snow');
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
	      if (toolbar.container.querySelector('.ql-link')) {
	        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
	          toolbar.handlers['link'].call(toolbar, !context.format.link);
	        });
	      }
	    }
	  }]);
	
	  return SnowTheme;
	}(_base2.default);
	
	SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (value) {
	            var range = this.quill.getSelection();
	            if (range == null || range.length == 0) return;
	            var preview = this.quill.getText(range);
	            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
	              preview = 'mailto:' + preview;
	            }
	            var tooltip = this.quill.theme.tooltip;
	            tooltip.edit('link', preview);
	          } else {
	            this.quill.format('link', false);
	          }
	        }
	      }
	    }
	  }
	});
	
	var SnowTooltip = function (_BaseTooltip) {
	  _inherits(SnowTooltip, _BaseTooltip);
	
	  function SnowTooltip(quill, bounds) {
	    _classCallCheck(this, SnowTooltip);
	
	    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));
	
	    _this2.preview = _this2.root.querySelector('a.ql-preview');
	    return _this2;
	  }
	
	  _createClass(SnowTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;
	
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
	        if (_this3.root.classList.contains('ql-editing')) {
	          _this3.save();
	        } else {
	          _this3.edit('link', _this3.preview.textContent);
	        }
	        event.preventDefault();
	      });
	      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
	        if (_this3.linkRange != null) {
	          var range = _this3.linkRange;
	          _this3.restoreFocus();
	          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
	          delete _this3.linkRange;
	        }
	        event.preventDefault();
	        _this3.hide();
	      });
	      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
	        if (range == null) return;
	        if (range.length === 0 && source === _emitter2.default.sources.USER) {
	          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
	              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	              link = _quill$scroll$descend2[0],
	              offset = _quill$scroll$descend2[1];
	
	          if (link != null) {
	            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
	            var preview = _link2.default.formats(link.domNode);
	            _this3.preview.textContent = preview;
	            _this3.preview.setAttribute('href', preview);
	            _this3.show();
	            _this3.position(_this3.quill.getBounds(_this3.linkRange));
	            return;
	          }
	        } else {
	          delete _this3.linkRange;
	        }
	        _this3.hide();
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
	      this.root.removeAttribute('data-mode');
	    }
	  }]);
	
	  return SnowTooltip;
	}(_base.BaseTooltip);
	
	SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');
	
	exports.default = SnowTheme;
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(29);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _align = __webpack_require__(36);
	
	var _direction = __webpack_require__(38);
	
	var _indent = __webpack_require__(64);
	
	var _blockquote = __webpack_require__(65);
	
	var _blockquote2 = _interopRequireDefault(_blockquote);
	
	var _header = __webpack_require__(66);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _list = __webpack_require__(67);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _background = __webpack_require__(37);
	
	var _color = __webpack_require__(26);
	
	var _font = __webpack_require__(39);
	
	var _size = __webpack_require__(40);
	
	var _bold = __webpack_require__(56);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	var _italic = __webpack_require__(68);
	
	var _italic2 = _interopRequireDefault(_italic);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _script = __webpack_require__(69);
	
	var _script2 = _interopRequireDefault(_script);
	
	var _strike = __webpack_require__(70);
	
	var _strike2 = _interopRequireDefault(_strike);
	
	var _underline = __webpack_require__(71);
	
	var _underline2 = _interopRequireDefault(_underline);
	
	var _image = __webpack_require__(72);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _video = __webpack_require__(73);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _formula = __webpack_require__(74);
	
	var _formula2 = _interopRequireDefault(_formula);
	
	var _syntax = __webpack_require__(75);
	
	var _syntax2 = _interopRequireDefault(_syntax);
	
	var _toolbar = __webpack_require__(57);
	
	var _toolbar2 = _interopRequireDefault(_toolbar);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	var _colorPicker = __webpack_require__(59);
	
	var _colorPicker2 = _interopRequireDefault(_colorPicker);
	
	var _iconPicker = __webpack_require__(60);
	
	var _iconPicker2 = _interopRequireDefault(_iconPicker);
	
	var _tooltip = __webpack_require__(61);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _bubble = __webpack_require__(108);
	
	var _bubble2 = _interopRequireDefault(_bubble);
	
	var _snow = __webpack_require__(62);
	
	var _snow2 = _interopRequireDefault(_snow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_core2.default.register({
	  'attributors/attribute/direction': _direction.DirectionAttribute,
	
	  'attributors/class/align': _align.AlignClass,
	  'attributors/class/background': _background.BackgroundClass,
	  'attributors/class/color': _color.ColorClass,
	  'attributors/class/direction': _direction.DirectionClass,
	  'attributors/class/font': _font.FontClass,
	  'attributors/class/size': _size.SizeClass,
	
	  'attributors/style/align': _align.AlignStyle,
	  'attributors/style/background': _background.BackgroundStyle,
	  'attributors/style/color': _color.ColorStyle,
	  'attributors/style/direction': _direction.DirectionStyle,
	  'attributors/style/font': _font.FontStyle,
	  'attributors/style/size': _size.SizeStyle
	}, true);
	
	_core2.default.register({
	  'formats/align': _align.AlignClass,
	  'formats/direction': _direction.DirectionClass,
	  'formats/indent': _indent.IndentClass,
	
	  'formats/background': _background.BackgroundStyle,
	  'formats/color': _color.ColorStyle,
	  'formats/font': _font.FontClass,
	  'formats/size': _size.SizeClass,
	
	  'formats/blockquote': _blockquote2.default,
	  'formats/code-block': _code2.default,
	  'formats/header': _header2.default,
	  'formats/list': _list2.default,
	
	  'formats/bold': _bold2.default,
	  'formats/code': _code.Code,
	  'formats/italic': _italic2.default,
	  'formats/link': _link2.default,
	  'formats/script': _script2.default,
	  'formats/strike': _strike2.default,
	  'formats/underline': _underline2.default,
	
	  'formats/image': _image2.default,
	  'formats/video': _video2.default,
	
	  'formats/list/item': _list.ListItem,
	
	  'modules/formula': _formula2.default,
	  'modules/syntax': _syntax2.default,
	  'modules/toolbar': _toolbar2.default,
	
	  'themes/bubble': _bubble2.default,
	  'themes/snow': _snow2.default,
	
	  'ui/icons': _icons2.default,
	  'ui/picker': _picker2.default,
	  'ui/icon-picker': _iconPicker2.default,
	  'ui/color-picker': _colorPicker2.default,
	  'ui/tooltip': _tooltip2.default
	}, true);
	
	exports.default = _core2.default;
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndentClass = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IdentAttributor = function (_Parchment$Attributor) {
	  _inherits(IdentAttributor, _Parchment$Attributor);
	
	  function IdentAttributor() {
	    _classCallCheck(this, IdentAttributor);
	
	    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
	  }
	
	  _createClass(IdentAttributor, [{
	    key: 'add',
	    value: function add(node, value) {
	      if (value === '+1' || value === '-1') {
	        var indent = this.value(node) || 0;
	        value = value === '+1' ? indent + 1 : indent - 1;
	      }
	      if (value === 0) {
	        this.remove(node);
	        return true;
	      } else {
	        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
	      }
	    }
	  }, {
	    key: 'canAdd',
	    value: function canAdd(node, value) {
	      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
	    }
	  }, {
	    key: 'value',
	    value: function value(node) {
	      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
	    }
	  }]);
	
	  return IdentAttributor;
	}(_parchment2.default.Attributor.Class);
	
	var IndentClass = new IdentAttributor('indent', 'ql-indent', {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
	});
	
	exports.IndentClass = IndentClass;
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Blockquote = function (_Block) {
	  _inherits(Blockquote, _Block);
	
	  function Blockquote() {
	    _classCallCheck(this, Blockquote);
	
	    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
	  }
	
	  return Blockquote;
	}(_block2.default);
	
	Blockquote.blotName = 'blockquote';
	Blockquote.tagName = 'blockquote';
	
	exports.default = Blockquote;
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Block) {
	  _inherits(Header, _Block);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	  }
	
	  _createClass(Header, null, [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return this.tagName.indexOf(domNode.tagName) + 1;
	    }
	  }]);
	
	  return Header;
	}(_block2.default);
	
	Header.blotName = 'header';
	Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
	
	exports.default = Header;
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ListItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItem = function (_Block) {
	  _inherits(ListItem, _Block);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  _createClass(ListItem, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name === List.blotName && !value) {
	        this.replaceWith(_parchment2.default.create(this.statics.scope));
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      if (this.prev == null && this.next == null) {
	        this.parent.remove();
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
	      }
	    }
	  }, {
	    key: 'replaceWith',
	    value: function replaceWith(name, value) {
	      this.parent.isolate(this.offset(this.parent), this.length());
	      if (name === this.parent.statics.blotName) {
	        this.parent.replaceWith(name, value);
	        return this;
	      } else {
	        this.parent.unwrap();
	        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
	    }
	  }]);
	
	  return ListItem;
	}(_block2.default);
	
	ListItem.blotName = 'list-item';
	ListItem.tagName = 'LI';
	
	var List = function (_Container) {
	  _inherits(List, _Container);
	
	  _createClass(List, null, [{
	    key: 'create',
	    value: function create(value) {
	      var tagName = value === 'ordered' ? 'OL' : 'UL';
	      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
	      if (value === 'checked' || value === 'unchecked') {
	        node.setAttribute('data-checked', value === 'checked');
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'OL') return 'ordered';
	      if (domNode.tagName === 'UL') {
	        if (domNode.hasAttribute('data-checked')) {
	          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
	        } else {
	          return 'bullet';
	        }
	      }
	      return undefined;
	    }
	  }]);
	
	  function List(domNode) {
	    _classCallCheck(this, List);
	
	    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));
	
	    var listEventHandler = function listEventHandler(e) {
	      if (e.target.parentNode !== domNode) return;
	      var format = _this2.statics.formats(domNode);
	      var blot = _parchment2.default.find(e.target);
	      if (format === 'checked') {
	        blot.format('list', 'unchecked');
	      } else if (format === 'unchecked') {
	        blot.format('list', 'checked');
	      }
	    };
	
	    domNode.addEventListener('touchstart', listEventHandler);
	    domNode.addEventListener('mousedown', listEventHandler);
	    return _this2;
	  }
	
	  _createClass(List, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (this.children.length > 0) {
	        this.children.tail.format(name, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      // We don't inherit from FormatBlot
	      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot instanceof ListItem) {
	        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
	      } else {
	        var index = ref == null ? this.length() : ref.offset(this);
	        var after = this.split(index);
	        after.parent.insertBefore(blot, after);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      if (target.statics.blotName !== this.statics.blotName) {
	        var item = _parchment2.default.create(this.statics.defaultChild);
	        target.moveChildren(item);
	        this.appendChild(item);
	      }
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
	    }
	  }]);
	
	  return List;
	}(_container2.default);
	
	List.blotName = 'list';
	List.scope = _parchment2.default.Scope.BLOCK_BLOT;
	List.tagName = ['OL', 'UL'];
	List.defaultChild = 'list-item';
	List.allowedChildren = [ListItem];
	
	exports.ListItem = ListItem;
	exports.default = List;
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bold = __webpack_require__(56);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Italic = function (_Bold) {
	  _inherits(Italic, _Bold);
	
	  function Italic() {
	    _classCallCheck(this, Italic);
	
	    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
	  }
	
	  return Italic;
	}(_bold2.default);
	
	Italic.blotName = 'italic';
	Italic.tagName = ['EM', 'I'];
	
	exports.default = Italic;
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Script = function (_Inline) {
	  _inherits(Script, _Inline);
	
	  function Script() {
	    _classCallCheck(this, Script);
	
	    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
	  }
	
	  _createClass(Script, null, [{
	    key: 'create',
	    value: function create(value) {
	      if (value === 'super') {
	        return document.createElement('sup');
	      } else if (value === 'sub') {
	        return document.createElement('sub');
	      } else {
	        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'SUB') return 'sub';
	      if (domNode.tagName === 'SUP') return 'super';
	      return undefined;
	    }
	  }]);
	
	  return Script;
	}(_inline2.default);
	
	Script.blotName = 'script';
	Script.tagName = ['SUB', 'SUP'];
	
	exports.default = Script;
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Strike = function (_Inline) {
	  _inherits(Strike, _Inline);
	
	  function Strike() {
	    _classCallCheck(this, Strike);
	
	    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
	  }
	
	  return Strike;
	}(_inline2.default);
	
	Strike.blotName = 'strike';
	Strike.tagName = 'S';
	
	exports.default = Strike;
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Underline = function (_Inline) {
	  _inherits(Underline, _Inline);
	
	  function Underline() {
	    _classCallCheck(this, Underline);
	
	    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
	  }
	
	  return Underline;
	}(_inline2.default);
	
	Underline.blotName = 'underline';
	Underline.tagName = 'U';
	
	exports.default = Underline;
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _link = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['alt', 'height', 'width'];
	
	var Image = function (_Parchment$Embed) {
	  _inherits(Image, _Parchment$Embed);
	
	  function Image() {
	    _classCallCheck(this, Image);
	
	    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
	  }
	
	  _createClass(Image, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        node.setAttribute('src', this.sanitize(value));
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'match',
	    value: function match(url) {
	      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
	      );
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);
	
	  return Image;
	}(_parchment2.default.Embed);
	
	Image.blotName = 'image';
	Image.tagName = 'IMG';
	
	exports.default = Image;
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _block = __webpack_require__(4);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['height', 'width'];
	
	var Video = function (_BlockEmbed) {
	  _inherits(Video, _BlockEmbed);
	
	  function Video() {
	    _classCallCheck(this, Video);
	
	    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
	  }
	
	  _createClass(Video, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
	      node.setAttribute('frameborder', '0');
	      node.setAttribute('allowfullscreen', true);
	      node.setAttribute('src', this.sanitize(value));
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _link2.default.sanitize(url);
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);
	
	  return Video;
	}(_block.BlockEmbed);
	
	Video.blotName = 'video';
	Video.className = 'ql-video';
	Video.tagName = 'IFRAME';
	
	exports.default = Video;
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.FormulaBlot = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _embed = __webpack_require__(35);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormulaBlot = function (_Embed) {
	  _inherits(FormulaBlot, _Embed);
	
	  function FormulaBlot() {
	    _classCallCheck(this, FormulaBlot);
	
	    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
	  }
	
	  _createClass(FormulaBlot, null, [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        window.katex.render(value, node, {
	          throwOnError: false,
	          errorColor: '#f00'
	        });
	        node.setAttribute('data-value', value);
	      }
	      return node;
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('data-value');
	    }
	  }]);
	
	  return FormulaBlot;
	}(_embed2.default);
	
	FormulaBlot.blotName = 'formula';
	FormulaBlot.className = 'ql-formula';
	FormulaBlot.tagName = 'SPAN';
	
	var Formula = function (_Module) {
	  _inherits(Formula, _Module);
	
	  _createClass(Formula, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(FormulaBlot, true);
	    }
	  }]);
	
	  function Formula() {
	    _classCallCheck(this, Formula);
	
	    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));
	
	    if (window.katex == null) {
	      throw new Error('Formula module requires KaTeX.');
	    }
	    return _this2;
	  }
	
	  return Formula;
	}(_module2.default);
	
	exports.FormulaBlot = FormulaBlot;
	exports.default = Formula;
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CodeToken = exports.CodeBlock = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SyntaxCodeBlock = function (_CodeBlock) {
	  _inherits(SyntaxCodeBlock, _CodeBlock);
	
	  function SyntaxCodeBlock() {
	    _classCallCheck(this, SyntaxCodeBlock);
	
	    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
	  }
	
	  _createClass(SyntaxCodeBlock, [{
	    key: 'replaceWith',
	    value: function replaceWith(block) {
	      this.domNode.textContent = this.domNode.textContent;
	      this.attach();
	      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(_highlight) {
	      var text = this.domNode.textContent;
	      if (this.cachedText !== text) {
	        if (text.trim().length > 0 || this.cachedText == null) {
	          this.domNode.innerHTML = _highlight(text);
	          this.domNode.normalize();
	          this.attach();
	        }
	        this.cachedText = text;
	      }
	    }
	  }]);
	
	  return SyntaxCodeBlock;
	}(_code2.default);
	
	SyntaxCodeBlock.className = 'ql-syntax';
	
	var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	var Syntax = function (_Module) {
	  _inherits(Syntax, _Module);
	
	  _createClass(Syntax, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(CodeToken, true);
	      _quill2.default.register(SyntaxCodeBlock, true);
	    }
	  }]);
	
	  function Syntax(quill, options) {
	    _classCallCheck(this, Syntax);
	
	    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));
	
	    if (typeof _this2.options.highlight !== 'function') {
	      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
	    }
	    var timer = null;
	    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      clearTimeout(timer);
	      timer = setTimeout(function () {
	        _this2.highlight();
	        timer = null;
	      }, _this2.options.interval);
	    });
	    _this2.highlight();
	    return _this2;
	  }
	
	  _createClass(Syntax, [{
	    key: 'highlight',
	    value: function highlight() {
	      var _this3 = this;
	
	      if (this.quill.selection.composing) return;
	      this.quill.update(_quill2.default.sources.USER);
	      var range = this.quill.getSelection();
	      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
	        code.highlight(_this3.options.highlight);
	      });
	      this.quill.update(_quill2.default.sources.SILENT);
	      if (range != null) {
	        this.quill.setSelection(range, _quill2.default.sources.SILENT);
	      }
	    }
	  }]);
	
	  return Syntax;
	}(_module2.default);
	
	Syntax.DEFAULTS = {
	  highlight: function () {
	    if (window.hljs == null) return null;
	    return function (text) {
	      var result = window.hljs.highlightAuto(text);
	      return result.value;
	    };
	  }(),
	  interval: 1000
	};
	
	exports.CodeBlock = SyntaxCodeBlock;
	exports.CodeToken = CodeToken;
	exports.default = Syntax;
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 88 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 89 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";
	
	/***/ }),
	/* 92 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";
	
	/***/ }),
	/* 97 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";
	
	/***/ }),
	/* 98 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";
	
	/***/ }),
	/* 99 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";
	
	/***/ }),
	/* 100 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";
	
	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BubbleTooltip = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _base = __webpack_require__(43);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _selection = __webpack_require__(15);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];
	
	var BubbleTheme = function (_BaseTheme) {
	  _inherits(BubbleTheme, _BaseTheme);
	
	  function BubbleTheme(quill, options) {
	    _classCallCheck(this, BubbleTheme);
	
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	
	    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));
	
	    _this.quill.container.classList.add('ql-bubble');
	    return _this;
	  }
	
	  _createClass(BubbleTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
	      this.tooltip.root.appendChild(toolbar.container);
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	    }
	  }]);
	
	  return BubbleTheme;
	}(_base2.default);
	
	BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (!value) {
	            this.quill.format('link', false);
	          } else {
	            this.quill.theme.tooltip.edit();
	          }
	        }
	      }
	    }
	  }
	});
	
	var BubbleTooltip = function (_BaseTooltip) {
	  _inherits(BubbleTooltip, _BaseTooltip);
	
	  function BubbleTooltip(quill, bounds) {
	    _classCallCheck(this, BubbleTooltip);
	
	    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));
	
	    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
	      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
	      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
	        _this2.show();
	        // Lock our width so we will expand beyond our offsetParent boundaries
	        _this2.root.style.left = '0px';
	        _this2.root.style.width = '';
	        _this2.root.style.width = _this2.root.offsetWidth + 'px';
	        var lines = _this2.quill.getLines(range.index, range.length);
	        if (lines.length === 1) {
	          _this2.position(_this2.quill.getBounds(range));
	        } else {
	          var lastLine = lines[lines.length - 1];
	          var index = _this2.quill.getIndex(lastLine);
	          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
	          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
	          _this2.position(_bounds);
	        }
	      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
	        _this2.hide();
	      }
	    });
	    return _this2;
	  }
	
	  _createClass(BubbleTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;
	
	      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('.ql-close').addEventListener('click', function () {
	        _this3.root.classList.remove('ql-editing');
	      });
	      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
	        // Let selection be restored by toolbar handlers before repositioning
	        setTimeout(function () {
	          if (_this3.root.classList.contains('ql-hidden')) return;
	          var range = _this3.quill.getSelection();
	          if (range != null) {
	            _this3.position(_this3.quill.getBounds(range));
	          }
	        }, 1);
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.show();
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
	      var arrow = this.root.querySelector('.ql-tooltip-arrow');
	      arrow.style.marginLeft = '';
	      if (shift === 0) return shift;
	      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
	    }
	  }]);
	
	  return BubbleTooltip;
	}(_base.BaseTooltip);
	
	BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');
	
	exports.BubbleTooltip = BubbleTooltip;
	exports.default = BubbleTheme;
	
	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(63);
	
	
	/***/ })
	/******/ ])["default"];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58).Buffer))

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(124);
	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Applies a function to the value at the given index of an array, returning a
	 * new copy of the array with the element at the given index replaced with the
	 * result of the function application.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a -> a) -> Number -> [a] -> [a]
	 * @param {Function} fn The function to apply.
	 * @param {Number} idx The index.
	 * @param {Array|Arguments} list An array-like object whose value
	 *        at the supplied index will be replaced.
	 * @return {Array} A copy of the supplied array-like object with
	 *         the element at index `idx` replaced with the value
	 *         returned by applying `fn` to the existing element.
	 * @see R.update
	 * @example
	 *
	 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
	 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
	 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
	 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
	 */
	module.exports = _curry3(function adjust(fn, idx, list) {
	  if (idx >= list.length || idx < -list.length) {
	    return list;
	  }
	  var start = idx < 0 ? list.length : 0;
	  var _idx = start + idx;
	  var _list = _concat(list);
	  _list[_idx] = fn(list[_idx]);
	  return _list;
	});


/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns `true` if both arguments are `true`; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if it is falsy, otherwise the second argument.
	 * @see R.both
	 * @example
	 *
	 *      R.and(true, true); //=> true
	 *      R.and(true, false); //=> false
	 *      R.and(false, true); //=> false
	 *      R.and(false, false); //=> false
	 */
	module.exports = _curry2(function and(a, b) {
	  return a && b;
	});


/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xany = __webpack_require__(1455);
	
	
	/**
	 * Returns `true` if at least one of elements of the list match the predicate,
	 * `false` otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
	 *         otherwise.
	 * @see R.all, R.none, R.transduce
	 * @example
	 *
	 *      var lessThan0 = R.flip(R.lt)(0);
	 *      var lessThan2 = R.flip(R.lt)(2);
	 *      R.any(lessThan0)([1, 2]); //=> false
	 *      R.any(lessThan2)([1, 2]); //=> true
	 */
	module.exports = _curry2(_dispatchable(['any'], _xany, function any(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (fn(list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}));


/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Applies function `fn` to the argument list `args`. This is useful for
	 * creating a fixed-arity function from a variadic function. `fn` should be a
	 * bound function if context is significant.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> a) -> [*] -> a
	 * @param {Function} fn The function which will be called with `args`
	 * @param {Array} args The arguments to call `fn` with
	 * @return {*} result The result, equivalent to `fn(...args)`
	 * @see R.call, R.unapply
	 * @example
	 *
	 *      var nums = [1, 2, 3, -99, 42, 6, 7];
	 *      R.apply(Math.max, nums); //=> 42
	 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
	 */
	module.exports = _curry2(function apply(fn, args) {
	  return fn.apply(this, args);
	});


/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var _has = __webpack_require__(90);
	var _isArray = __webpack_require__(180);
	var _isInteger = __webpack_require__(690);
	var assoc = __webpack_require__(427);
	var isNil = __webpack_require__(1459);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the nodes required
	 * to create the given path, and placing the specific value at the tail end of
	 * that path. Note that this copies and flattens prototype properties onto the
	 * new object as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> {a}
	 * @param {Array} path the path to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except along the specified path.
	 * @see R.dissocPath
	 * @example
	 *
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
	 *
	 *      // Any missing or non-object keys in path will be overridden
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
	 */
	module.exports = _curry3(function assocPath(path, val, obj) {
	  if (path.length === 0) {
	    return val;
	  }
	  var idx = path[0];
	  if (path.length > 1) {
	    var nextObj = (!isNil(obj) && _has(idx, obj)) ? obj[idx] : _isInteger(path[1]) ? [] : {};
	    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
	  }
	  if (_isInteger(idx) && _isArray(obj)) {
	    var arr = [].concat(obj);
	    arr[idx] = val;
	    return arr;
	  } else {
	    return assoc(idx, val, obj);
	  }
	});


/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(135);
	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      var log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	module.exports = _curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function() {
	    return fn.apply(thisObj, arguments);
	  });
	});


/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	var chain = __webpack_require__(682);
	var compose = __webpack_require__(683);
	var map = __webpack_require__(99);
	
	
	/**
	 * Returns the right-to-left Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), R.chain(f))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipeK
	 * @example
	 *
	 *       //  get :: String -> Object -> Maybe *
	 *       var get = R.curry((propName, obj) => Maybe(obj[propName]))
	 *
	 *       //  getStateCode :: Maybe String -> Maybe String
	 *       var getStateCode = R.composeK(
	 *         R.compose(Maybe.of, R.toUpper),
	 *         get('state'),
	 *         get('address'),
	 *         get('user'),
	 *       );
	 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
	 *       getStateCode({}); //=> Maybe.Nothing()
	 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
	 */
	module.exports = function composeK() {
	  if (arguments.length === 0) {
	    throw new Error('composeK requires at least one argument');
	  }
	  var init = Array.prototype.slice.call(arguments);
	  var last = init.pop();
	  return compose(compose.apply(this, map(chain, init)), last);
	};


/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var curry = __webpack_require__(428);
	var nAry = __webpack_require__(439);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type. The arity of the function
	 * returned is specified to allow using variadic constructor functions.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Function
	 * @sig Number -> (* -> {*}) -> (* -> {*})
	 * @param {Number} n The arity of the constructor function.
	 * @param {Function} Fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Variadic Constructor function
	 *      function Salad() {
	 *        this.ingredients = arguments;
	 *      };
	 *      Salad.prototype.recipe = function() {
	 *        var instructions = R.map((ingredient) => (
	 *          'Add a whollop of ' + ingredient, this.ingredients)
	 *        )
	 *        return R.join('\n', instructions)
	 *      }
	 *
	 *      var ThreeLayerSalad = R.constructN(3, Salad)
	 *
	 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
	 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup')
	 *      console.log(salad.recipe());
	 *      // Add a whollop of Mayonnaise
	 *      // Add a whollop of Potato Chips
	 *      // Add a whollop of Potato Ketchup
	 */
	module.exports = _curry2(function constructN(n, Fn) {
	  if (n > 10) {
	    throw new Error('Constructor with greater than ten arguments');
	  }
	  if (n === 0) {
	    return function() { return new Fn(); };
	  }
	  return curry(nAry(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
	    switch (arguments.length) {
	      case  1: return new Fn($0);
	      case  2: return new Fn($0, $1);
	      case  3: return new Fn($0, $1, $2);
	      case  4: return new Fn($0, $1, $2, $3);
	      case  5: return new Fn($0, $1, $2, $3, $4);
	      case  6: return new Fn($0, $1, $2, $3, $4, $5);
	      case  7: return new Fn($0, $1, $2, $3, $4, $5, $6);
	      case  8: return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
	      case  9: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
	      case 10: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
	    }
	  }));
	});


/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _map = __webpack_require__(435);
	var curryN = __webpack_require__(80);
	var max = __webpack_require__(254);
	var pluck = __webpack_require__(312);
	var reduce = __webpack_require__(137);
	
	
	/**
	 * Accepts a converging function and a list of branching functions and returns
	 * a new function. When invoked, this new function is applied to some
	 * arguments, each branching function is applied to those same arguments. The
	 * results of each branching function are passed as arguments to the converging
	 * function to produce the return value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.2
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> b -> ... -> x1), (a -> b -> ... -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} after A function. `after` will be invoked with the return values of
	 *        `fn1` and `fn2` as its arguments.
	 * @param {Array} functions A list of functions.
	 * @return {Function} A new function.
	 * @see R.useWith
	 * @example
	 *
	 *      var average = R.converge(R.divide, [R.sum, R.length])
	 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
	 *
	 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
	 *      strangeConcat("Yodel") //=> "YODELyodel"
	 *
	 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
	 */
	module.exports = _curry2(function converge(after, fns) {
	  return curryN(reduce(max, 0, pluck('length', fns)), function() {
	    var args = arguments;
	    var context = this;
	    return after.apply(context, _map(function(fn) {
	      return fn.apply(context, args);
	    }, fns));
	  });
	});


/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
	 * otherwise the first argument is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {a} default The default value.
	 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
	 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
	 * @example
	 *
	 *      var defaultTo42 = R.defaultTo(42);
	 *
	 *      defaultTo42(null);  //=> 42
	 *      defaultTo42(undefined);  //=> 42
	 *      defaultTo42('Ramda');  //=> 'Ramda'
	 *      // parseInt('string') results in NaN
	 *      defaultTo42(parseInt('string')); //=> 42
	 */
	module.exports = _curry2(function defaultTo(d, v) {
	  return v == null || v !== v ? d : v;
	});


/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(211);
	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Objects and Arrays are compared in terms of
	 * value equality, not reference equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
	 * @example
	 *
	 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
	 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
	 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
	 */
	module.exports = _curry2(function difference(first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_contains(first[idx], second) && !_contains(first[idx], out)) {
	      out[out.length] = first[idx];
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(430);
	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      var cmp = (x, y) => x.a === y.a;
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
	 *      var l2 = [{a: 3}, {a: 4}];
	 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
	 */
	module.exports = _curry3(function differenceWith(pred, first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_containsWith(pred, first[idx], second) &&
	        !_containsWith(pred, first[idx], out)) {
	      out.push(first[idx]);
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns a new object that does not contain a `prop` property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Object
	 * @sig String -> {k: v} -> {k: v}
	 * @param {String} prop The name of the property to dissociate
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original but without the specified property
	 * @see R.assoc
	 * @example
	 *
	 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	 */
	module.exports = _curry2(function dissoc(prop, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  delete result[prop];
	  return result;
	});


/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xdrop = __webpack_require__(3120);
	var slice = __webpack_require__(212);
	
	
	/**
	 * Returns all but the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `drop` method).
	 *
	 * Dispatches to the `drop` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*} A copy of list without the first `n` elements
	 * @see R.take, R.transduce, R.dropLast, R.dropWhile
	 * @example
	 *
	 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(3, 'ramda');               //=> 'da'
	 */
	module.exports = _curry2(_dispatchable(['drop'], _xdrop, function drop(n, xs) {
	  return slice(Math.max(0, n), Infinity, xs);
	}));


/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xdropRepeatsWith = __webpack_require__(1456);
	var last = __webpack_require__(1461);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. Equality is
	 * determined by applying the supplied predicate to each pair of consecutive elements. The
	 * first element in a series of equal elements will be preserved.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
	 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
	 */
	module.exports = _curry2(_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
	  var result = [];
	  var idx = 1;
	  var len = list.length;
	  if (len !== 0) {
	    result[0] = list[0];
	    while (idx < len) {
	      if (!pred(last(result), list[idx])) {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	  }
	  return result;
	}));
	


/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _isArguments = __webpack_require__(1452);
	var _isArray = __webpack_require__(180);
	var _isObject = __webpack_require__(691);
	var _isString = __webpack_require__(308);
	
	
	/**
	 * Returns the empty value of its argument's type. Ramda defines the empty
	 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
	 * types are supported if they define `<Type>.empty` and/or
	 * `<Type>.prototype.empty`.
	 *
	 * Dispatches to the `empty` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x
	 * @return {*}
	 * @example
	 *
	 *      R.empty(Just(42));      //=> Nothing()
	 *      R.empty([1, 2, 3]);     //=> []
	 *      R.empty('unicorns');    //=> ''
	 *      R.empty({x: 1, y: 2});  //=> {}
	 */
	module.exports = _curry1(function empty(x) {
	  return (
	    (x != null && typeof x['fantasy-land/empty'] === 'function') ?
	      x['fantasy-land/empty']() :
	    (x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function') ?
	      x.constructor['fantasy-land/empty']() :
	    (x != null && typeof x.empty === 'function') ?
	      x.empty() :
	    (x != null && x.constructor != null && typeof x.constructor.empty === 'function') ?
	      x.constructor.empty() :
	    _isArray(x) ?
	      [] :
	    _isString(x) ?
	      '' :
	    _isObject(x) ?
	      {} :
	    _isArguments(x) ?
	      (function() { return arguments; }()) :
	    // else
	      void 0
	  );
	});


/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns true if its arguments are identical, false otherwise. Values are
	 * identical if they reference the same memory. `NaN` is identical to `NaN`;
	 * `0` and `-0` are not identical.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      var o = {};
	 *      R.identical(o, o); //=> true
	 *      R.identical(1, 1); //=> true
	 *      R.identical(1, '1'); //=> false
	 *      R.identical([], []); //=> false
	 *      R.identical(0, -0); //=> false
	 *      R.identical(NaN, NaN); //=> true
	 */
	module.exports = _curry2(function identical(a, b) {
	  // SameValue algorithm
	  if (a === b) { // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return a !== 0 || 1 / a === 1 / b;
	  } else {
	    // Step 6.a: NaN == NaN
	    return a !== a && b !== b;
	  }
	});


/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(1448);
	var type = __webpack_require__(697);
	
	
	/**
	 * Copies an object.
	 *
	 * @private
	 * @param {*} value The value to be copied
	 * @param {Array} refFrom Array containing the source references
	 * @param {Array} refTo Array containing the copied source references
	 * @param {Boolean} deep Whether or not to perform deep cloning.
	 * @return {*} The copied value.
	 */
	module.exports = function _clone(value, refFrom, refTo, deep) {
	  var copy = function copy(copiedValue) {
	    var len = refFrom.length;
	    var idx = 0;
	    while (idx < len) {
	      if (value === refFrom[idx]) {
	        return refTo[idx];
	      }
	      idx += 1;
	    }
	    refFrom[idx + 1] = value;
	    refTo[idx + 1] = copiedValue;
	    for (var key in value) {
	      copiedValue[key] = deep ?
	        _clone(value[key], refFrom, refTo, true) : value[key];
	    }
	    return copiedValue;
	  };
	  switch (type(value)) {
	    case 'Object':  return copy({});
	    case 'Array':   return copy([]);
	    case 'Date':    return new Date(value.valueOf());
	    case 'RegExp':  return _cloneRegExp(value);
	    default:        return value;
	  }
	};


/***/ },
/* 1448 */
/***/ function(module, exports) {

	module.exports = function _cloneRegExp(pattern) {
	  return new RegExp(pattern.source, (pattern.global     ? 'g' : '') +
	                                    (pattern.ignoreCase ? 'i' : '') +
	                                    (pattern.multiline  ? 'm' : '') +
	                                    (pattern.sticky     ? 'y' : '') +
	                                    (pattern.unicode    ? 'u' : ''));
	};


/***/ },
/* 1449 */
/***/ function(module, exports) {

	module.exports = function _complement(f) {
	  return function() {
	    return !f.apply(this, arguments);
	  };
	};


/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(135);
	var _curry2 = __webpack_require__(13);
	
	
	module.exports = function _createPartialApplicator(concat) {
	  return _curry2(function(fn, args) {
	    return _arity(Math.max(0, fn.length - args.length), function() {
	      return fn.apply(this, concat(args, arguments));
	    });
	  });
	};


/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	var equals = __webpack_require__(111);
	
	
	module.exports = function _indexOf(list, a, idx) {
	  var inf, item;
	  // Array.prototype.indexOf doesn't exist below IE9
	  if (typeof list.indexOf === 'function') {
	    switch (typeof a) {
	      case 'number':
	        if (a === 0) {
	          // manually crawl the list to distinguish between +0 and -0
	          inf = 1 / a;
	          while (idx < list.length) {
	            item = list[idx];
	            if (item === 0 && 1 / item === inf) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        } else if (a !== a) {
	          // NaN
	          while (idx < list.length) {
	            item = list[idx];
	            if (typeof item === 'number' && item !== item) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        }
	        // non-zero numbers can utilise Set
	        return list.indexOf(a, idx);
	
	      // all these types can utilise Set
	      case 'string':
	      case 'boolean':
	      case 'function':
	      case 'undefined':
	        return list.indexOf(a, idx);
	
	      case 'object':
	        if (a === null) {
	          // null can utilise Set
	          return list.indexOf(a, idx);
	        }
	    }
	  }
	  // anything else not covered above, defer to R.equals
	  while (idx < list.length) {
	    if (equals(list[idx], a)) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	};


/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(90);
	
	
	module.exports = (function() {
	  var toString = Object.prototype.toString;
	  return toString.call(arguments) === '[object Arguments]' ?
	    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
	    function _isArguments(x) { return _has('callee', x); };
	}());


/***/ },
/* 1453 */
/***/ function(module, exports) {

	module.exports = function _isNumber(x) {
	  return Object.prototype.toString.call(x) === '[object Number]';
	};


/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	var _isArrayLike = __webpack_require__(432);
	
	
	/**
	 * `_makeFlat` is a helper function that returns a one-level or fully recursive
	 * function based on the flag passed in.
	 *
	 * @private
	 */
	module.exports = function _makeFlat(recursive) {
	  return function flatt(list) {
	    var value, jlen, j;
	    var result = [];
	    var idx = 0;
	    var ilen = list.length;
	
	    while (idx < ilen) {
	      if (_isArrayLike(list[idx])) {
	        value = recursive ? flatt(list[idx]) : list[idx];
	        j = 0;
	        jlen = value.length;
	        while (j < jlen) {
	          result[result.length] = value[j];
	          j += 1;
	        }
	      } else {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	    return result;
	  };
	};


/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _reduced = __webpack_require__(181);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XAny(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.any = false;
	  }
	  XAny.prototype['@@transducer/init'] = _xfBase.init;
	  XAny.prototype['@@transducer/result'] = function(result) {
	    if (!this.any) {
	      result = this.xf['@@transducer/step'](result, false);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAny.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.any = true;
	      result = _reduced(this.xf['@@transducer/step'](result, true));
	    }
	    return result;
	  };
	
	  return _curry2(function _xany(f, xf) { return new XAny(f, xf); });
	}());


/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XDropRepeatsWith(pred, xf) {
	    this.xf = xf;
	    this.pred = pred;
	    this.lastValue = undefined;
	    this.seenFirstValue = false;
	  }
	
	  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
	  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
	  XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
	    var sameAsLast = false;
	    if (!this.seenFirstValue) {
	      this.seenFirstValue = true;
	    } else if (this.pred(this.lastValue, input)) {
	      sameAsLast = true;
	    }
	    this.lastValue = input;
	    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropRepeatsWith(pred, xf) { return new XDropRepeatsWith(pred, xf); });
	}());


/***/ },
/* 1457 */
/***/ function(module, exports) {

	module.exports = (function() {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function() {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
	  XWrap.prototype['@@transducer/step'] = function(acc, x) {
	    return this.f(acc, x);
	  };
	
	  return function _xwrap(fn) { return new XWrap(fn); };
	}());


/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * See if an object (`val`) is an instance of the supplied constructor. This
	 * function will check up the inheritance chain, if any.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Type
	 * @sig (* -> {*}) -> a -> Boolean
	 * @param {Object} ctor A constructor
	 * @param {*} val The value to test
	 * @return {Boolean}
	 * @example
	 *
	 *      R.is(Object, {}); //=> true
	 *      R.is(Number, 1); //=> true
	 *      R.is(Object, 1); //=> false
	 *      R.is(String, 's'); //=> true
	 *      R.is(String, new String('')); //=> true
	 *      R.is(Object, new String('')); //=> true
	 *      R.is(Object, 's'); //=> false
	 *      R.is(Number, {}); //=> false
	 */
	module.exports = _curry2(function is(Ctor, val) {
	  return val != null && val.constructor === Ctor || val instanceof Ctor;
	});


/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Checks if the input value is `null` or `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Type
	 * @sig * -> Boolean
	 * @param {*} x The value to test.
	 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
	 * @example
	 *
	 *      R.isNil(null); //=> true
	 *      R.isNil(undefined); //=> true
	 *      R.isNil(0); //=> false
	 *      R.isNil([]); //=> false
	 */
	module.exports = _curry1(function isNil(x) { return x == null; });


/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var converge = __webpack_require__(1438);
	
	
	/**
	 * juxt applies a list of functions to a list of values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Function
	 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
	 * @param {Array} fns An array of functions
	 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
	 * @see R.applySpec
	 * @example
	 *
	 *      var getRange = R.juxt([Math.min, Math.max]);
	 *      getRange(3, 4, 9, -3); //=> [-3, 9]
	 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
	 */
	module.exports = _curry1(function juxt(fns) {
	  return converge(function() { return Array.prototype.slice.call(arguments, 0); }, fns);
	});


/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(310);
	
	
	/**
	 * Returns the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.init, R.head, R.tail
	 * @example
	 *
	 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
	 *      R.last([]); //=> undefined
	 *
	 *      R.last('abc'); //=> 'c'
	 *      R.last(''); //=> ''
	 */
	module.exports = nth(-1);


/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _isNumber = __webpack_require__(1453);
	
	
	/**
	 * Returns the number of elements in the array by returning `list.length`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [a] -> Number
	 * @param {Array} list The array to inspect.
	 * @return {Number} The length of the array.
	 * @example
	 *
	 *      R.length([]); //=> 0
	 *      R.length([1, 2, 3]); //=> 3
	 */
	module.exports = _curry1(function length(list) {
	  return list != null && _isNumber(list.length) ? list.length : NaN;
	});


/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _reduce = __webpack_require__(112);
	var ap = __webpack_require__(681);
	var curryN = __webpack_require__(80);
	var map = __webpack_require__(99);
	
	
	/**
	 * "lifts" a function to be the specified arity, so that it may "map over" that
	 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig Number -> (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.lift, R.ap
	 * @example
	 *
	 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 */
	module.exports = _curry2(function liftN(arity, fn) {
	  var lifted = curryN(arity, fn);
	  return curryN(arity, function() {
	    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
	  });
	});


/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var sum = __webpack_require__(1478);
	
	
	/**
	 * Returns the mean of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @see R.median
	 * @example
	 *
	 *      R.mean([2, 7, 9]); //=> 6
	 *      R.mean([]); //=> NaN
	 */
	module.exports = _curry1(function mean(list) {
	  return sum(list) / list.length;
	});


/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(135);
	var _curry2 = __webpack_require__(13);
	var _has = __webpack_require__(90);
	
	
	/**
	 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
	 * additional function that will be applied to a given argument set and used to
	 * create the cache key under which the results of the function to be memoized
	 * will be stored. Care must be taken when implementing key generation to avoid
	 * clashes that may overwrite previous entries erroneously.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Function
	 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
	 * @param {Function} fn The function to generate the cache key.
	 * @param {Function} fn The function to memoize.
	 * @return {Function} Memoized version of `fn`.
	 * @see R.memoize
	 * @example
	 *
	 *      let count = 0;
	 *      const factorial = R.memoizeWith(R.identity, n => {
	 *        count += 1;
	 *        return R.product(R.range(1, n + 1));
	 *      });
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      count; //=> 1
	 */
	module.exports = _curry2(function memoizeWith(mFn, fn) {
	  var cache = {};
	  return _arity(fn.length, function() {
	    var key = mFn.apply(this, arguments);
	    if (!_has(key, cache)) {
	      cache[key] = fn.apply(this, arguments);
	    }
	    return cache[key];
	  });
	});


/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Multiplies two numbers. Equivalent to `a * b` but curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a * b`.
	 * @see R.divide
	 * @example
	 *
	 *      var double = R.multiply(2);
	 *      var triple = R.multiply(3);
	 *      double(3);       //=>  6
	 *      triple(4);       //=> 12
	 *      R.multiply(2, 5);  //=> 10
	 */
	module.exports = _curry2(function multiply(a, b) { return a * b; });


/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * A function that returns the `!` of its argument. It will return `true` when
	 * passed false-y value, and `false` when passed a truth-y one.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig * -> Boolean
	 * @param {*} a any value
	 * @return {Boolean} the logical inverse of passed argument.
	 * @see R.complement
	 * @example
	 *
	 *      R.not(true); //=> false
	 *      R.not(false); //=> true
	 *      R.not(0); //=> true
	 *      R.not(1); //=> false
	 */
	module.exports = _curry1(function not(a) {
	  return !a;
	});


/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Creates an object containing a single key:value pair.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @sig String -> a -> {String:a}
	 * @param {String} key
	 * @param {*} val
	 * @return {Object}
	 * @see R.pair
	 * @example
	 *
	 *      var matchPhrases = R.compose(
	 *        R.objOf('must'),
	 *        R.map(R.objOf('match_phrase'))
	 *      );
	 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
	 */
	module.exports = _curry2(function objOf(key, val) {
	  var obj = {};
	  obj[key] = val;
	  return obj;
	});


/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns `true` if one or both of its arguments are `true`. Returns `false`
	 * if both arguments are `false`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if truthy, otherwise the second argument.
	 * @see R.either
	 * @example
	 *
	 *      R.or(true, true); //=> true
	 *      R.or(true, false); //=> true
	 *      R.or(false, true); //=> true
	 *      R.or(false, false); //=> false
	 */
	module.exports = _curry2(function or(a, b) {
	  return a || b;
	});


/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the result of applying the given function to
	 * the focused value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> (a -> a) -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
	 */
	module.exports = (function() {
	  // `Identity` is a functor that holds a single value, where `map` simply
	  // transforms the held value with the provided function.
	  var Identity = function(x) {
	    return {value: x, map: function(f) { return Identity(f(x)); }};
	  };
	
	  return _curry3(function over(lens, f, x) {
	    // The value returned by the getter function is first transformed with `f`,
	    // then set as the value of an `Identity`. This is then mapped over with the
	    // setter function of the lens.
	    return lens(function(y) { return Identity(f(y)); })(x).value;
	  });
	}());


/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Similar to `pick` except that this one includes a `key: undefined` pair for
	 * properties that don't exist.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
	 */
	module.exports = _curry2(function pickAll(names, obj) {
	  var result = {};
	  var idx = 0;
	  var len = names.length;
	  while (idx < len) {
	    var name = names[idx];
	    result[name] = obj[name];
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(135);
	var _pipe = __webpack_require__(3111);
	var reduce = __webpack_require__(137);
	var tail = __webpack_require__(695);
	
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      var f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
	 */
	module.exports = function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipe, arguments[0], tail(arguments)));
	};


/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(135);
	var _pipeP = __webpack_require__(3112);
	var reduce = __webpack_require__(137);
	var tail = __webpack_require__(695);
	
	
	/**
	 * Performs left-to-right composition of one or more Promise-returning
	 * functions. The leftmost function may have any arity; the remaining functions
	 * must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.composeP
	 * @example
	 *
	 *      //  followersForUser :: String -> Promise [User]
	 *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
	 */
	module.exports = function pipeP() {
	  if (arguments.length === 0) {
	    throw new Error('pipeP requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipeP, arguments[0], tail(arguments)));
	};


/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(124);
	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns a new list with the given element at the front, followed by the
	 * contents of the list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The item to add to the head of the output list.
	 * @param {Array} list The array to add to the tail of the output list.
	 * @return {Array} A new array.
	 * @see R.append
	 * @example
	 *
	 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
	 */
	module.exports = _curry2(function prepend(el, list) {
	  return _concat([el], list);
	});


/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * Similar to [`reduce`](#reduce), except moves through the input list from the
	 * right to the left.
	 *
	 * The iterator function receives two values: *(value, acc)*, while the arguments'
	 * order of `reduce`'s iterator function is *(acc, value)*.
	 *
	 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a, b -> b) -> b -> [a] -> b
	 * @param {Function} fn The iterator function. Receives two values, the current element from the array
	 *        and the accumulator.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.addIndex
	 * @example
	 *
	 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
	 *          -               -2
	 *         / \              / \
	 *        1   -            1   3
	 *           / \              / \
	 *          2   -     ==>    2  -1
	 *             / \              / \
	 *            3   -            3   4
	 *               / \              / \
	 *              4   0            4   0
	 *
	 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
	 */
	module.exports = _curry3(function reduceRight(fn, acc, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    acc = fn(list[idx], acc);
	    idx -= 1;
	  }
	  return acc;
	});


/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Removes the sub-list of `list` starting at index `start` and containing
	 * `count` elements. _Note that this is not destructive_: it returns a copy of
	 * the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @param {Number} start The position to start removing elements
	 * @param {Number} count The number of elements to remove
	 * @param {Array} list The list to remove from
	 * @return {Array} A new Array with `count` elements from `start` removed.
	 * @example
	 *
	 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
	 */
	module.exports = _curry3(function remove(start, count, list) {
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(start, count);
	  return result;
	});


/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var ap = __webpack_require__(681);
	var map = __webpack_require__(99);
	var prepend = __webpack_require__(1474);
	var reduceRight = __webpack_require__(1475);
	
	
	/**
	 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
	 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
	 * Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
	 * @param {Function} of
	 * @param {*} traversable
	 * @return {*}
	 * @see R.traverse
	 * @example
	 *
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
	 *
	 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
	 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
	 */
	module.exports = _curry2(function sequence(of, traversable) {
	  return typeof traversable.sequence === 'function' ?
	    traversable.sequence(of) :
	    reduceRight(function(x, acc) { return ap(map(prepend, x), acc); },
	                of([]),
	                traversable);
	});


/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	var add = __webpack_require__(426);
	var reduce = __webpack_require__(137);
	
	
	/**
	 * Adds together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The sum of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.sum([2,4,6,8,100,1]); //=> 121
	 */
	module.exports = reduce(add, 0);


/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var drop = __webpack_require__(1443);
	
	
	/**
	 * Returns a new list containing the last `n` elements of the given list.
	 * If `n > list.length`, returns a list of `list.length` elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements to return.
	 * @param {Array} xs The collection to consider.
	 * @return {Array}
	 * @see R.dropLast
	 * @example
	 *
	 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(3, 'ramda');               //=> 'mda'
	 */
	module.exports = _curry2(function takeLast(n, xs) {
	  return drop(n >= 0 ? xs.length - n : 0, xs);
	});


/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Calls an input function `n` times, returning an array containing the results
	 * of those function calls.
	 *
	 * `fn` is passed one argument: The current value of `n`, which begins at `0`
	 * and is gradually incremented to `n - 1`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.3
	 * @category List
	 * @sig (Number -> a) -> Number -> [a]
	 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
	 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
	 * @return {Array} An array containing the return values of all calls to `fn`.
	 * @see R.repeat
	 * @example
	 *
	 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
	 * @symb R.times(f, 0) = []
	 * @symb R.times(f, 1) = [f(0)]
	 * @symb R.times(f, 2) = [f(0), f(1)]
	 */
	module.exports = _curry2(function times(fn, n) {
	  var len = Number(n);
	  var idx = 0;
	  var list;
	
	  if (len < 0 || isNaN(len)) {
	    throw new RangeError('n must be a non-negative number');
	  }
	  list = new Array(len);
	  while (idx < len) {
	    list[idx] = fn(idx);
	    idx += 1;
	  }
	  return list;
	});


/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	var _Set = __webpack_require__(3099);
	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied function to
	 * each list element. Prefers the first item if the supplied function produces
	 * the same value on two items. [`R.equals`](#equals) is used for comparison.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> b) -> [a] -> [a]
	 * @param {Function} fn A function used to produce a value to use during comparisons.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
	 */
	module.exports = _curry2(function uniqBy(fn, list) {
	  var set = new _Set();
	  var result = [];
	  var idx = 0;
	  var appliedItem, item;
	
	  while (idx < list.length) {
	    item = list[idx];
	    appliedItem = fn(item);
	    if (set.add(appliedItem)) {
	      result.push(item);
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var curryN = __webpack_require__(80);
	
	
	/**
	 * Accepts a function `fn` and a list of transformer functions and returns a
	 * new curried function. When the new function is invoked, it calls the
	 * function `fn` with parameters consisting of the result of calling each
	 * supplied handler on successive arguments to the new function.
	 *
	 * If more arguments are passed to the returned function than transformer
	 * functions, those arguments are passed directly to `fn` as additional
	 * parameters. If you expect additional arguments that don't need to be
	 * transformed, although you can ignore them, it's best to pass an identity
	 * function so that the new function reports the correct arity.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} fn The function to wrap.
	 * @param {Array} transformers A list of transformer functions
	 * @return {Function} The wrapped function.
	 * @see R.converge
	 * @example
	 *
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
	 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
	 */
	module.exports = _curry2(function useWith(fn, transformers) {
	  return curryN(transformers.length, function() {
	    var args = [];
	    var idx = 0;
	    while (idx < transformers.length) {
	      args.push(transformers[idx].call(this, arguments[idx]));
	      idx += 1;
	    }
	    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
	  });
	});


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var keys = __webpack_require__(136);
	
	
	/**
	 * Returns a list of all the enumerable own properties of the supplied object.
	 * Note that the order of the output array is not guaranteed across different
	 * JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own properties.
	 * @see R.valuesIn, R.keys
	 * @example
	 *
	 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
	 */
	module.exports = _curry1(function values(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var vals = [];
	  var idx = 0;
	  while (idx < len) {
	    vals[idx] = obj[props[idx]];
	    idx += 1;
	  }
	  return vals;
	});


/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _has = __webpack_require__(90);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec. Each of the spec's own properties must be a predicate function.
	 * Each predicate is applied to the value of the corresponding property of the
	 * test object. `where` returns true if all the predicates return true, false
	 * otherwise.
	 *
	 * `where` is well suited to declaratively expressing constraints for other
	 * functions such as [`filter`](#filter) and [`find`](#find).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Object
	 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.where({
	 *        a: R.equals('foo'),
	 *        b: R.complement(R.equals('bar')),
	 *        x: R.gt(R.__, 10),
	 *        y: R.lt(R.__, 20)
	 *      });
	 *
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
	 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
	 */
	module.exports = _curry2(function where(spec, testObj) {
	  for (var prop in spec) {
	    if (_has(prop, spec) && !spec[prop](testObj[prop])) {
	      return false;
	    }
	  }
	  return true;
	});


/***/ },
/* 1485 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var isJsons = exports.isJsons = function isJsons(array) {
	  return Array.isArray(array) && array.every(function (row) {
	    return (typeof row === 'undefined' ? 'undefined' : _typeof(row)) === 'object' && !(row instanceof Array);
	  });
	};
	
	var isArrays = exports.isArrays = function isArrays(array) {
	  return Array.isArray(array) && array.every(function (row) {
	    return Array.isArray(row);
	  });
	};
	
	var jsonsHeaders = exports.jsonsHeaders = function jsonsHeaders(array) {
	  return Array.from(array.map(function (json) {
	    return Object.keys(json);
	  }).reduce(function (a, b) {
	    return new Set([].concat(_toConsumableArray(a), _toConsumableArray(b)));
	  }, []));
	};
	
	var jsons2arrays = exports.jsons2arrays = function jsons2arrays(jsons, headers) {
	  headers = headers || jsonsHeaders(jsons);
	
	  var headerLabels = headers;
	  var headerKeys = headers;
	  if (isJsons(headers)) {
	    headerLabels = headers.map(function (header) {
	      return header.label;
	    });
	    headerKeys = headers.map(function (header) {
	      return header.key;
	    });
	  }
	
	  var data = jsons.map(function (object) {
	    return headerKeys.map(function (header) {
	      return header in object ? object[header] : '';
	    });
	  });
	  return [headerLabels].concat(_toConsumableArray(data));
	};
	
	var elementOrEmpty = exports.elementOrEmpty = function elementOrEmpty(element) {
	  return element || element === 0 ? element : '';
	};
	
	var joiner = exports.joiner = function joiner(data) {
	  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
	  return data.map(function (row, index) {
	    return row.map(function (element) {
	      return "\"" + elementOrEmpty(element) + "\"";
	    }).join(separator);
	  }).join('\n');
	};
	
	var arrays2csv = exports.arrays2csv = function arrays2csv(data, headers, separator) {
	  return joiner(headers ? [headers].concat(_toConsumableArray(data)) : data, separator);
	};
	
	var jsons2csv = exports.jsons2csv = function jsons2csv(data, headers, separator) {
	  return joiner(jsons2arrays(data, headers), separator);
	};
	
	var string2csv = exports.string2csv = function string2csv(data, headers, separator) {
	  return headers ? headers.join(separator) + '\n' + data : data;
	};
	
	var toCSV = exports.toCSV = function toCSV(data, headers, separator) {
	  if (isJsons(data)) return jsons2csv(data, headers, separator);
	  if (isArrays(data)) return arrays2csv(data, headers, separator);
	  if (typeof data === 'string') return string2csv(data, headers, separator);
	  throw new TypeError('Data should be a "String", "Array of arrays" OR "Array of objects" ');
	};
	
	var buildURI = exports.buildURI = function buildURI(data, uFEFF, headers, separator) {
	  var csv = toCSV(data, headers, separator);
	  var blob = new Blob([uFEFF ? '\uFEFF' : '', csv], { type: 'text/csv' });
	  var dataURI = 'data:text/csv;charset=utf-8,' + (uFEFF ? '\uFEFF' : '') + csv;
	
	  var URL = window.URL || window.webkitURL;
	
	  return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
	};

/***/ },
/* 1486 */
[4454, 4],
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	var DateRangePicker = __webpack_require__(3255).default;
	var DateRangePickerInput = __webpack_require__(1492).default;
	var DateRangePickerInputController = __webpack_require__(1493).default;
	var SingleDatePicker = __webpack_require__(3258).default;
	var SingleDatePickerInput = __webpack_require__(1495).default;
	var DayPicker = __webpack_require__(702).default;
	var DayPickerRangeController = __webpack_require__(1494).default;
	var CalendarMonthGrid = __webpack_require__(1490).default;
	var CalendarMonth = __webpack_require__(1489).default;
	var CalendarDay = __webpack_require__(1488).default;
	
	var DateRangePickerShape = __webpack_require__(1497).default;
	var SingleDatePickerShape = __webpack_require__(1499).default;
	
	var isInclusivelyAfterDay = __webpack_require__(317).default;
	var isInclusivelyBeforeDay = __webpack_require__(1502).default;
	var isNextDay = __webpack_require__(1503).default;
	var isSameDay = __webpack_require__(257).default;
	
	var toISODateString = __webpack_require__(3261).default;
	var toLocalizedDateString = __webpack_require__(704).default;
	var toMomentObject = __webpack_require__(318).default;
	
	
	module.exports = {
	  DateRangePicker: DateRangePicker,
	  SingleDatePicker: SingleDatePicker,
	
	  DateRangePickerInputController: DateRangePickerInputController,
	  DateRangePickerInput: DateRangePickerInput,
	  SingleDatePickerInput: SingleDatePickerInput,
	  DayPicker: DayPicker,
	  DayPickerRangeController: DayPickerRangeController,
	  CalendarMonthGrid: CalendarMonthGrid,
	  CalendarMonth: CalendarMonth,
	  CalendarDay: CalendarDay,
	
	  DateRangePickerShape: DateRangePickerShape,
	  SingleDatePickerShape: SingleDatePickerShape,
	
	  isInclusivelyAfterDay: isInclusivelyAfterDay,
	  isInclusivelyBeforeDay: isInclusivelyBeforeDay,
	  isNextDay: isNextDay,
	  isSameDay: isSameDay,
	
	  toISODateString: toISODateString,
	  toLocalizedDateString: toLocalizedDateString,
	  toMomentObject: toMomentObject,
	};


/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.TOUCHSTART_TIMEOUT = undefined;
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactAddonsShallowCompare = __webpack_require__(2);
	
		var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
		var _reactMomentProptypes = __webpack_require__(3);
	
		var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var TOUCHSTART_TIMEOUT = exports.TOUCHSTART_TIMEOUT = 200;
	
		var propTypes = {
		  day: _reactMomentProptypes2['default'].momentObj,
		  modifiers: _react.PropTypes.arrayOf(_react.PropTypes.string),
		  onDayClick: _react.PropTypes.func,
		  onDayMouseDown: _react.PropTypes.func,
		  onDayMouseUp: _react.PropTypes.func,
		  onDayMouseEnter: _react.PropTypes.func,
		  onDayMouseLeave: _react.PropTypes.func,
		  onDayTouchStart: _react.PropTypes.func,
		  onDayTouchEnd: _react.PropTypes.func,
		  onDayTouchTap: _react.PropTypes.func
		};
	
		var defaultProps = {
		  day: (0, _moment2['default'])(),
		  modifiers: [],
		  onDayClick: function () {
		    function onDayClick() {}
	
		    return onDayClick;
		  }(),
		  onDayMouseDown: function () {
		    function onDayMouseDown() {}
	
		    return onDayMouseDown;
		  }(),
		  onDayMouseUp: function () {
		    function onDayMouseUp() {}
	
		    return onDayMouseUp;
		  }(),
		  onDayMouseEnter: function () {
		    function onDayMouseEnter() {}
	
		    return onDayMouseEnter;
		  }(),
		  onDayMouseLeave: function () {
		    function onDayMouseLeave() {}
	
		    return onDayMouseLeave;
		  }(),
		  onDayTouchStart: function () {
		    function onDayTouchStart() {}
	
		    return onDayTouchStart;
		  }(),
		  onDayTouchEnd: function () {
		    function onDayTouchEnd() {}
	
		    return onDayTouchEnd;
		  }(),
		  onDayTouchTap: function () {
		    function onDayTouchTap() {}
	
		    return onDayTouchTap;
		  }()
		};
	
		var CalendarDay = function (_React$Component) {
		  _inherits(CalendarDay, _React$Component);
	
		  function CalendarDay(props) {
		    _classCallCheck(this, CalendarDay);
	
		    var _this = _possibleConstructorReturn(this, (CalendarDay.__proto__ || Object.getPrototypeOf(CalendarDay)).call(this, props));
	
		    _this.hasActiveTouchStart = false;
		    return _this;
		  }
	
		  _createClass(CalendarDay, [{
		    key: 'shouldComponentUpdate',
		    value: function () {
		      function shouldComponentUpdate(nextProps, nextState) {
		        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
		      }
	
		      return shouldComponentUpdate;
		    }()
		  }, {
		    key: 'handleDayClick',
		    value: function () {
		      function handleDayClick(day, modifiers, e) {
		        this.props.onDayClick(day, modifiers, e);
		      }
	
		      return handleDayClick;
		    }()
		  }, {
		    key: 'handleDayMouseDown',
		    value: function () {
		      function handleDayMouseDown(day, modifiers, e) {
		        this.props.onDayMouseDown(day, modifiers, e);
		      }
	
		      return handleDayMouseDown;
		    }()
		  }, {
		    key: 'handleDayMouseUp',
		    value: function () {
		      function handleDayMouseUp(day, modifiers, e) {
		        this.props.onDayMouseUp(day, modifiers, e);
		      }
	
		      return handleDayMouseUp;
		    }()
		  }, {
		    key: 'handleDayMouseEnter',
		    value: function () {
		      function handleDayMouseEnter(day, modifiers, e) {
		        this.props.onDayMouseEnter(day, modifiers, e);
		      }
	
		      return handleDayMouseEnter;
		    }()
		  }, {
		    key: 'handleDayMouseLeave',
		    value: function () {
		      function handleDayMouseLeave(day, modifiers, e) {
		        this.props.onDayMouseLeave(day, modifiers, e);
		      }
	
		      return handleDayMouseLeave;
		    }()
		  }, {
		    key: 'handleDayTouchStart',
		    value: function () {
		      function handleDayTouchStart(day, modifiers, e) {
		        var _this2 = this;
	
		        this.hasActiveTouchStart = true;
		        setTimeout(function () {
		          _this2.hasActiveTouchStart = false;
		        }, TOUCHSTART_TIMEOUT);
	
		        this.props.onDayTouchStart(day, modifiers, e);
		      }
	
		      return handleDayTouchStart;
		    }()
		  }, {
		    key: 'handleDayTouchEnd',
		    value: function () {
		      function handleDayTouchEnd(day, modifiers, e) {
		        if (this.hasActiveTouchStart) {
		          this.hasActiveTouchStart = false;
		          this.handleDayTouchTap(day, modifiers, e);
		        }
	
		        this.props.onDayTouchEnd(day, modifiers, e);
		      }
	
		      return handleDayTouchEnd;
		    }()
		  }, {
		    key: 'handleDayTouchTap',
		    value: function () {
		      function handleDayTouchTap(day, modifiers, e) {
		        this.props.onDayTouchTap(day, modifiers, e);
		      }
	
		      return handleDayTouchTap;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _this3 = this;
	
		        var _props = this.props;
		        var day = _props.day;
		        var modifiers = _props.modifiers;
	
		        return _react2['default'].createElement('div', {
		          className: 'CalendarDay',
		          onMouseEnter: function () {
		            function onMouseEnter(e) {
		              _this3.handleDayMouseEnter(day, modifiers, e);
		            }
	
		            return onMouseEnter;
		          }(),
		          onMouseLeave: function () {
		            function onMouseLeave(e) {
		              _this3.handleDayMouseLeave(day, modifiers, e);
		            }
	
		            return onMouseLeave;
		          }(),
		          onMouseDown: function () {
		            function onMouseDown(e) {
		              _this3.handleDayMouseDown(day, modifiers, e);
		            }
	
		            return onMouseDown;
		          }(),
		          onMouseUp: function () {
		            function onMouseUp(e) {
		              _this3.handleDayMouseUp(day, modifiers, e);
		            }
	
		            return onMouseUp;
		          }(),
		          onClick: function () {
		            function onClick(e) {
		              _this3.handleDayClick(day, modifiers, e);
		            }
	
		            return onClick;
		          }(),
		          onTouchStart: function () {
		            function onTouchStart(e) {
		              _this3.handleDayTouchStart(day, modifiers, e);
		            }
	
		            return onTouchStart;
		          }(),
		          onTouchEnd: function () {
		            function onTouchEnd(e) {
		              _this3.handleDayTouchEnd(day, modifiers, e);
		            }
	
		            return onTouchEnd;
		          }()
		        }, _react2['default'].createElement('span', { className: 'CalendarDay__day' }, day.format('D')));
		      }
	
		      return render;
		    }()
		  }]);
	
		  return CalendarDay;
		}(_react2['default'].Component);
	
		exports['default'] = CalendarDay;
	
		CalendarDay.propTypes = propTypes;
		CalendarDay.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(443);
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(215);
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(7);
	
	/***/ }
	/******/ ]);

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getModifiersForDay = getModifiersForDay;
		exports['default'] = CalendarMonth;
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactMomentProptypes = __webpack_require__(3);
	
		var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _CalendarDay = __webpack_require__(6);
	
		var _CalendarDay2 = _interopRequireDefault(_CalendarDay);
	
		var _getCalendarMonthWeeks = __webpack_require__(7);
	
		var _getCalendarMonthWeeks2 = _interopRequireDefault(_getCalendarMonthWeeks);
	
		var _OrientationShape = __webpack_require__(8);
	
		var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		/* eslint react/no-array-index-key: 0 */
	
		var propTypes = {
		  month: _reactMomentProptypes2['default'].momentObj,
		  isVisible: _react.PropTypes.bool,
		  enableOutsideDays: _react.PropTypes.bool,
		  modifiers: _react.PropTypes.object,
		  orientation: _OrientationShape2['default'],
		  onDayClick: _react.PropTypes.func,
		  onDayMouseDown: _react.PropTypes.func,
		  onDayMouseUp: _react.PropTypes.func,
		  onDayMouseEnter: _react.PropTypes.func,
		  onDayMouseLeave: _react.PropTypes.func,
		  onDayTouchStart: _react.PropTypes.func,
		  onDayTouchEnd: _react.PropTypes.func,
		  onDayTouchTap: _react.PropTypes.func,
	
		  // i18n
		  monthFormat: _react.PropTypes.string
		};
	
		var defaultProps = {
		  month: (0, _moment2['default'])(),
		  isVisible: true,
		  enableOutsideDays: false,
		  modifiers: {},
		  orientation: _constants.HORIZONTAL_ORIENTATION,
		  onDayClick: function () {
		    function onDayClick() {}
	
		    return onDayClick;
		  }(),
		  onDayMouseDown: function () {
		    function onDayMouseDown() {}
	
		    return onDayMouseDown;
		  }(),
		  onDayMouseUp: function () {
		    function onDayMouseUp() {}
	
		    return onDayMouseUp;
		  }(),
		  onDayMouseEnter: function () {
		    function onDayMouseEnter() {}
	
		    return onDayMouseEnter;
		  }(),
		  onDayMouseLeave: function () {
		    function onDayMouseLeave() {}
	
		    return onDayMouseLeave;
		  }(),
		  onDayTouchStart: function () {
		    function onDayTouchStart() {}
	
		    return onDayTouchStart;
		  }(),
		  onDayTouchEnd: function () {
		    function onDayTouchEnd() {}
	
		    return onDayTouchEnd;
		  }(),
		  onDayTouchTap: function () {
		    function onDayTouchTap() {}
	
		    return onDayTouchTap;
		  }(),
	
		  // i18n
		  monthFormat: 'MMMM YYYY' };
	
		function getModifiersForDay(modifiers, day) {
		  return day ? Object.keys(modifiers).filter(function (key) {
		    return modifiers[key](day);
		  }) : [];
		}
	
		function CalendarMonth(props) {
		  var month = props.month;
		  var monthFormat = props.monthFormat;
		  var orientation = props.orientation;
		  var isVisible = props.isVisible;
		  var modifiers = props.modifiers;
		  var enableOutsideDays = props.enableOutsideDays;
		  var onDayClick = props.onDayClick;
		  var onDayMouseDown = props.onDayMouseDown;
		  var onDayMouseUp = props.onDayMouseUp;
		  var onDayMouseEnter = props.onDayMouseEnter;
		  var onDayMouseLeave = props.onDayMouseLeave;
		  var onDayTouchStart = props.onDayTouchStart;
		  var onDayTouchEnd = props.onDayTouchEnd;
		  var onDayTouchTap = props.onDayTouchTap;
	
		  var monthTitle = month.format(monthFormat);
	
		  var calendarMonthClasses = (0, _classnames2['default'])('CalendarMonth', {
		    'CalendarMonth--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
		    'CalendarMonth--vertical': orientation === _constants.VERTICAL_ORIENTATION
		  });
	
		  return _react2['default'].createElement('div', { className: calendarMonthClasses, 'data-visible': isVisible }, _react2['default'].createElement('table', null, _react2['default'].createElement('caption', { className: 'CalendarMonth__caption js-CalendarMonth__caption' }, _react2['default'].createElement('strong', null, monthTitle)), _react2['default'].createElement('tbody', { className: 'js-CalendarMonth__grid' }, (0, _getCalendarMonthWeeks2['default'])(month, enableOutsideDays).map(function (week, i) {
		    return _react2['default'].createElement('tr', { key: i }, week.map(function (day, j) {
		      var modifiersForDay = getModifiersForDay(modifiers, day);
		      var className = (0, _classnames2['default'])('CalendarMonth__day', {
		        'CalendarMonth__day--outside': !day || day.month() !== month.month()
		      }, modifiersForDay.map(function (mod) {
		        return 'CalendarMonth__day--' + String(mod);
		      }));
	
		      return _react2['default'].createElement('td', { className: className, key: j }, day && _react2['default'].createElement(_CalendarDay2['default'], {
		        day: day,
		        modifiers: modifiersForDay,
		        onDayMouseEnter: onDayMouseEnter,
		        onDayMouseLeave: onDayMouseLeave,
		        onDayMouseDown: onDayMouseDown,
		        onDayMouseUp: onDayMouseUp,
		        onDayClick: onDayClick,
		        onDayTouchStart: onDayTouchStart,
		        onDayTouchEnd: onDayTouchEnd,
		        onDayTouchTap: onDayTouchTap
		      }));
		    }));
		  }))));
		}
	
		CalendarMonth.propTypes = propTypes;
		CalendarMonth.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */,
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(215);
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(7);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(5);
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1488);
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(3259);
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(256);
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(81);
	
	/***/ }
	/******/ ]);

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(10);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _reactAddonsShallowCompare = __webpack_require__(2);
	
		var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
		var _reactMomentProptypes = __webpack_require__(3);
	
		var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _CalendarMonth = __webpack_require__(11);
	
		var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
		var _isTransitionEndSupported = __webpack_require__(12);
	
		var _isTransitionEndSupported2 = _interopRequireDefault(_isTransitionEndSupported);
	
		var _getTransformStyles = __webpack_require__(13);
	
		var _getTransformStyles2 = _interopRequireDefault(_getTransformStyles);
	
		var _OrientationShape = __webpack_require__(8);
	
		var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = {
		  enableOutsideDays: _react.PropTypes.bool,
		  firstVisibleMonthIndex: _react.PropTypes.number,
		  initialMonth: _reactMomentProptypes2['default'].momentObj,
		  isAnimating: _react.PropTypes.bool,
		  numberOfMonths: _react.PropTypes.number,
		  modifiers: _react.PropTypes.object,
		  orientation: _OrientationShape2['default'],
		  onDayClick: _react.PropTypes.func,
		  onDayMouseDown: _react.PropTypes.func,
		  onDayMouseUp: _react.PropTypes.func,
		  onDayMouseEnter: _react.PropTypes.func,
		  onDayMouseLeave: _react.PropTypes.func,
		  onDayTouchStart: _react.PropTypes.func,
		  onDayTouchEnd: _react.PropTypes.func,
		  onDayTouchTap: _react.PropTypes.func,
		  onMonthTransitionEnd: _react.PropTypes.func,
		  transformValue: _react.PropTypes.string,
	
		  // i18n
		  monthFormat: _react.PropTypes.string
		};
	
		var defaultProps = {
		  enableOutsideDays: false,
		  firstVisibleMonthIndex: 0,
		  initialMonth: (0, _moment2['default'])(),
		  isAnimating: false,
		  numberOfMonths: 1,
		  modifiers: {},
		  orientation: _constants.HORIZONTAL_ORIENTATION,
		  onDayClick: function () {
		    function onDayClick() {}
	
		    return onDayClick;
		  }(),
		  onDayMouseDown: function () {
		    function onDayMouseDown() {}
	
		    return onDayMouseDown;
		  }(),
		  onDayMouseUp: function () {
		    function onDayMouseUp() {}
	
		    return onDayMouseUp;
		  }(),
		  onDayMouseEnter: function () {
		    function onDayMouseEnter() {}
	
		    return onDayMouseEnter;
		  }(),
		  onDayMouseLeave: function () {
		    function onDayMouseLeave() {}
	
		    return onDayMouseLeave;
		  }(),
		  onDayTouchStart: function () {
		    function onDayTouchStart() {}
	
		    return onDayTouchStart;
		  }(),
		  onDayTouchEnd: function () {
		    function onDayTouchEnd() {}
	
		    return onDayTouchEnd;
		  }(),
		  onDayTouchTap: function () {
		    function onDayTouchTap() {}
	
		    return onDayTouchTap;
		  }(),
		  onMonthTransitionEnd: function () {
		    function onMonthTransitionEnd() {}
	
		    return onMonthTransitionEnd;
		  }(),
	
		  transformValue: 'none',
	
		  // i18n
		  monthFormat: 'MMMM YYYY' };
	
		var CalendarMonthGrid = function (_React$Component) {
		  _inherits(CalendarMonthGrid, _React$Component);
	
		  function CalendarMonthGrid(props) {
		    _classCallCheck(this, CalendarMonthGrid);
	
		    var _this = _possibleConstructorReturn(this, (CalendarMonthGrid.__proto__ || Object.getPrototypeOf(CalendarMonthGrid)).call(this, props));
	
		    _this.isTransitionEndSupported = (0, _isTransitionEndSupported2['default'])();
		    _this.onTransitionEnd = _this.onTransitionEnd.bind(_this);
		    return _this;
		  }
	
		  _createClass(CalendarMonthGrid, [{
		    key: 'componentDidMount',
		    value: function () {
		      function componentDidMount() {
		        this.container = _reactDom2['default'].findDOMNode(this.containerRef);
		        this.container.addEventListener('transitionend', this.onTransitionEnd);
		      }
	
		      return componentDidMount;
		    }()
		  }, {
		    key: 'shouldComponentUpdate',
		    value: function () {
		      function shouldComponentUpdate(nextProps, nextState) {
		        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
		      }
	
		      return shouldComponentUpdate;
		    }()
		  }, {
		    key: 'componentDidUpdate',
		    value: function () {
		      function componentDidUpdate() {
		        var _props = this.props;
		        var isAnimating = _props.isAnimating;
		        var onMonthTransitionEnd = _props.onMonthTransitionEnd;
	
		        // For IE9, immediately call onMonthTransitionEnd instead of
		        // waiting for the animation to complete
	
		        if (!this.isTransitionEndSupported && isAnimating) {
		          onMonthTransitionEnd();
		        }
		      }
	
		      return componentDidUpdate;
		    }()
		  }, {
		    key: 'componentWillUnmount',
		    value: function () {
		      function componentWillUnmount() {
		        this.container.removeEventListener('transitionend', this.onTransitionEnd);
		      }
	
		      return componentWillUnmount;
		    }()
		  }, {
		    key: 'onTransitionEnd',
		    value: function () {
		      function onTransitionEnd() {
		        this.props.onMonthTransitionEnd();
		      }
	
		      return onTransitionEnd;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _this2 = this;
	
		        var _props2 = this.props;
		        var enableOutsideDays = _props2.enableOutsideDays;
		        var firstVisibleMonthIndex = _props2.firstVisibleMonthIndex;
		        var initialMonth = _props2.initialMonth;
		        var isAnimating = _props2.isAnimating;
		        var modifiers = _props2.modifiers;
		        var numberOfMonths = _props2.numberOfMonths;
		        var monthFormat = _props2.monthFormat;
		        var orientation = _props2.orientation;
		        var transformValue = _props2.transformValue;
		        var onDayMouseEnter = _props2.onDayMouseEnter;
		        var onDayMouseLeave = _props2.onDayMouseLeave;
		        var onDayMouseDown = _props2.onDayMouseDown;
		        var onDayMouseUp = _props2.onDayMouseUp;
		        var onDayClick = _props2.onDayClick;
		        var onDayTouchStart = _props2.onDayTouchStart;
		        var onDayTouchEnd = _props2.onDayTouchEnd;
		        var onDayTouchTap = _props2.onDayTouchTap;
		        var onMonthTransitionEnd = _props2.onMonthTransitionEnd;
	
		        var month = initialMonth.clone().subtract(1, 'month');
	
		        var months = [];
		        for (var i = 0; i < numberOfMonths + 2; i++) {
		          var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
	
		          months.push(_react2['default'].createElement(_CalendarMonth2['default'], {
		            key: month.format('MM-YY'),
		            month: month,
		            isVisible: isVisible,
		            enableOutsideDays: enableOutsideDays,
		            modifiers: modifiers,
		            monthFormat: monthFormat,
		            orientation: orientation,
		            onDayMouseEnter: onDayMouseEnter,
		            onDayMouseLeave: onDayMouseLeave,
		            onDayMouseDown: onDayMouseDown,
		            onDayMouseUp: onDayMouseUp,
		            onDayClick: onDayClick,
		            onDayTouchStart: onDayTouchStart,
		            onDayTouchEnd: onDayTouchEnd,
		            onDayTouchTap: onDayTouchTap
		          }));
		          month = month.clone().add(1, 'month');
		        }
	
		        var className = (0, _classnames2['default'])('CalendarMonthGrid', {
		          'CalendarMonthGrid--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
		          'CalendarMonthGrid--vertical': orientation === _constants.VERTICAL_ORIENTATION,
		          'CalendarMonthGrid--animating': isAnimating
		        });
	
		        return _react2['default'].createElement('div', {
		          ref: function () {
		            function ref(_ref) {
		              _this2.containerRef = _ref;
		            }
	
		            return ref;
		          }(),
		          className: className,
		          style: (0, _getTransformStyles2['default'])(transformValue),
		          onTransitionEnd: onMonthTransitionEnd
		        }, months);
		      }
	
		      return render;
		    }()
		  }]);
	
		  return CalendarMonthGrid;
		}(_react2['default'].Component);
	
		exports['default'] = CalendarMonthGrid;
	
		CalendarMonthGrid.propTypes = propTypes;
		CalendarMonthGrid.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(443);
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(215);
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(7);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(5);
	
	/***/ },
	/* 6 */,
	/* 7 */,
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(256);
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(81);
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(76);
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1489);
	
	/***/ },
	/* 12 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(3260);
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1501);
	
	/***/ }
	/******/ ]);

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _isTouchDevice = __webpack_require__(14);
	
		var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = {
		  id: _react.PropTypes.string.isRequired,
		  placeholder: _react.PropTypes.string, // also used as label
		  dateValue: _react.PropTypes.string,
		  focused: _react.PropTypes.bool,
		  disabled: _react.PropTypes.bool,
		  required: _react.PropTypes.bool,
		  showCaret: _react.PropTypes.bool,
	
		  onChange: _react.PropTypes.func,
		  onFocus: _react.PropTypes.func,
		  onKeyDownShiftTab: _react.PropTypes.func,
		  onKeyDownTab: _react.PropTypes.func
		};
	
		var defaultProps = {
		  placeholder: 'Select Date',
		  dateValue: '',
		  focused: false,
		  disabled: false,
		  required: false,
		  showCaret: false,
	
		  onChange: function () {
		    function onChange() {}
	
		    return onChange;
		  }(),
		  onFocus: function () {
		    function onFocus() {}
	
		    return onFocus;
		  }(),
		  onKeyDownShiftTab: function () {
		    function onKeyDownShiftTab() {}
	
		    return onKeyDownShiftTab;
		  }(),
		  onKeyDownTab: function () {
		    function onKeyDownTab() {}
	
		    return onKeyDownTab;
		  }()
		};
	
		var DateInput = function (_React$Component) {
		  _inherits(DateInput, _React$Component);
	
		  function DateInput(props) {
		    _classCallCheck(this, DateInput);
	
		    var _this = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props));
	
		    _this.state = {
		      dateString: ''
		    };
	
		    _this.onChange = _this.onChange.bind(_this);
		    _this.onKeyDown = _this.onKeyDown.bind(_this);
	
		    _this.isTouchDevice = (0, _isTouchDevice2['default'])();
		    return _this;
		  }
	
		  _createClass(DateInput, [{
		    key: 'componentWillReceiveProps',
		    value: function () {
		      function componentWillReceiveProps(nextProps) {
		        if (!this.props.dateValue && nextProps.dateValue) {
		          this.setState({
		            dateString: ''
		          });
		        }
		      }
	
		      return componentWillReceiveProps;
		    }()
		  }, {
		    key: 'componentDidUpdate',
		    value: function () {
		      function componentDidUpdate(prevProps) {
		        var focused = this.props.focused;
	
		        if (prevProps.focused === focused) return;
	
		        if (focused) {
		          this.inputRef.focus();
		          this.inputRef.select();
		        } else {
		          this.inputRef.blur();
		        }
		      }
	
		      return componentDidUpdate;
		    }()
		  }, {
		    key: 'onChange',
		    value: function () {
		      function onChange(e) {
		        var dateString = e.target.value;
	
		        this.setState({ dateString: dateString });
		        this.props.onChange(dateString);
		      }
	
		      return onChange;
		    }()
		  }, {
		    key: 'onKeyDown',
		    value: function () {
		      function onKeyDown(e) {
		        var _props = this.props;
		        var onKeyDownShiftTab = _props.onKeyDownShiftTab;
		        var onKeyDownTab = _props.onKeyDownTab;
	
		        if (e.key === 'Tab') {
		          if (e.shiftKey) {
		            onKeyDownShiftTab(e);
		          } else {
		            onKeyDownTab(e);
		          }
		        }
		      }
	
		      return onKeyDown;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _this2 = this;
	
		        var dateString = this.state.dateString;
		        var _props2 = this.props;
		        var id = _props2.id;
		        var placeholder = _props2.placeholder;
		        var dateValue = _props2.dateValue;
		        var focused = _props2.focused;
		        var showCaret = _props2.showCaret;
		        var onFocus = _props2.onFocus;
		        var disabled = _props2.disabled;
		        var required = _props2.required;
	
		        var value = dateValue || dateString;
	
		        return _react2['default'].createElement('div', {
		          className: (0, _classnames2['default'])('DateInput', {
		            'DateInput--with-caret': showCaret && focused,
		            'DateInput--disabled': disabled
		          }),
		          onClick: onFocus
		        }, _react2['default'].createElement('label', { className: 'DateInput__label', htmlFor: id }, placeholder), _react2['default'].createElement('input', {
		          className: 'DateInput__input',
		          type: 'text',
		          id: id,
		          name: id,
		          ref: function () {
		            function ref(_ref) {
		              _this2.inputRef = _ref;
		            }
	
		            return ref;
		          }(),
		          value: value,
		          onChange: this.onChange,
		          onKeyDown: this.onKeyDown,
		          onFocus: onFocus,
		          placeholder: placeholder,
		          autoComplete: 'off',
		          disabled: disabled,
		          readOnly: this.isTouchDevice,
		          required: required
		        }), _react2['default'].createElement('div', {
		          className: (0, _classnames2['default'])('DateInput__display-text', {
		            'DateInput__display-text--has-input': !!value,
		            'DateInput__display-text--focused': focused,
		            'DateInput__display-text--disabled': disabled
		          })
		        }, value || placeholder));
		      }
	
		      return render;
		    }()
		  }]);
	
		  return DateInput;
		}(_react2['default'].Component);
	
		exports['default'] = DateInput;
	
		DateInput.propTypes = propTypes;
		DateInput.defaultProps = defaultProps;
	
	/***/ },
	
	/***/ 1:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	
	/***/ 5:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(5);
	
	/***/ },
	
	/***/ 14:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(703);
	
	/***/ }
	
	/******/ });

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _DateInput = __webpack_require__(22);
	
		var _DateInput2 = _interopRequireDefault(_DateInput);
	
		var _arrowRight = __webpack_require__(23);
	
		var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
		var _close = __webpack_require__(20);
	
		var _close2 = _interopRequireDefault(_close);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = {
		  startDateId: _react.PropTypes.string,
		  startDatePlaceholderText: _react.PropTypes.string,
	
		  endDateId: _react.PropTypes.string,
		  endDatePlaceholderText: _react.PropTypes.string,
	
		  onStartDateFocus: _react.PropTypes.func,
		  onEndDateFocus: _react.PropTypes.func,
		  onStartDateChange: _react.PropTypes.func,
		  onEndDateChange: _react.PropTypes.func,
		  onStartDateShiftTab: _react.PropTypes.func,
		  onEndDateTab: _react.PropTypes.func,
		  onClearDates: _react.PropTypes.func,
	
		  startDate: _react.PropTypes.string,
		  endDate: _react.PropTypes.string,
	
		  isStartDateFocused: _react.PropTypes.bool,
		  isEndDateFocused: _react.PropTypes.bool,
		  showClearDates: _react.PropTypes.bool,
		  disabled: _react.PropTypes.bool,
		  required: _react.PropTypes.bool,
		  showCaret: _react.PropTypes.bool,
	
		  // i18n
		  phrases: _react.PropTypes.shape({
		    clearDates: _react.PropTypes.node
		  })
		};
	
		var defaultProps = {
		  startDateId: _constants.START_DATE,
		  endDateId: _constants.END_DATE,
		  startDatePlaceholderText: 'Start Date',
		  endDatePlaceholderText: 'End Date',
		  onStartDateFocus: function () {
		    function onStartDateFocus() {}
	
		    return onStartDateFocus;
		  }(),
		  onEndDateFocus: function () {
		    function onEndDateFocus() {}
	
		    return onEndDateFocus;
		  }(),
		  onStartDateChange: function () {
		    function onStartDateChange() {}
	
		    return onStartDateChange;
		  }(),
		  onEndDateChange: function () {
		    function onEndDateChange() {}
	
		    return onEndDateChange;
		  }(),
		  onStartDateShiftTab: function () {
		    function onStartDateShiftTab() {}
	
		    return onStartDateShiftTab;
		  }(),
		  onEndDateTab: function () {
		    function onEndDateTab() {}
	
		    return onEndDateTab;
		  }(),
		  onClearDates: function () {
		    function onClearDates() {}
	
		    return onClearDates;
		  }(),
	
		  startDate: '',
		  endDate: '',
	
		  isStartDateFocused: false,
		  isEndDateFocused: false,
		  showClearDates: false,
		  disabled: false,
		  required: false,
		  showCaret: false,
	
		  // i18n
		  phrases: {
		    clearDates: 'Clear Dates'
		  }
		};
	
		var DateRangePickerInput = function (_React$Component) {
		  _inherits(DateRangePickerInput, _React$Component);
	
		  function DateRangePickerInput(props) {
		    _classCallCheck(this, DateRangePickerInput);
	
		    var _this = _possibleConstructorReturn(this, (DateRangePickerInput.__proto__ || Object.getPrototypeOf(DateRangePickerInput)).call(this, props));
	
		    _this.state = {
		      isClearDatesHovered: false
		    };
	
		    _this.onClearDatesMouseEnter = _this.onClearDatesMouseEnter.bind(_this);
		    _this.onClearDatesMouseLeave = _this.onClearDatesMouseLeave.bind(_this);
		    return _this;
		  }
	
		  _createClass(DateRangePickerInput, [{
		    key: 'onClearDatesMouseEnter',
		    value: function () {
		      function onClearDatesMouseEnter() {
		        this.setState({
		          isClearDatesHovered: true
		        });
		      }
	
		      return onClearDatesMouseEnter;
		    }()
		  }, {
		    key: 'onClearDatesMouseLeave',
		    value: function () {
		      function onClearDatesMouseLeave() {
		        this.setState({
		          isClearDatesHovered: false
		        });
		      }
	
		      return onClearDatesMouseLeave;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _state = this.state;
		        var startDateString = _state.startDateString;
		        var endDateString = _state.endDateString;
		        var isClearDatesHovered = _state.isClearDatesHovered;
		        var _props = this.props;
		        var startDate = _props.startDate;
		        var startDateId = _props.startDateId;
		        var startDatePlaceholderText = _props.startDatePlaceholderText;
		        var isStartDateFocused = _props.isStartDateFocused;
		        var onStartDateChange = _props.onStartDateChange;
		        var onStartDateFocus = _props.onStartDateFocus;
		        var onStartDateShiftTab = _props.onStartDateShiftTab;
		        var endDate = _props.endDate;
		        var endDateId = _props.endDateId;
		        var endDatePlaceholderText = _props.endDatePlaceholderText;
		        var isEndDateFocused = _props.isEndDateFocused;
		        var onEndDateChange = _props.onEndDateChange;
		        var onEndDateFocus = _props.onEndDateFocus;
		        var onEndDateTab = _props.onEndDateTab;
		        var onClearDates = _props.onClearDates;
		        var showClearDates = _props.showClearDates;
		        var disabled = _props.disabled;
		        var required = _props.required;
		        var showCaret = _props.showCaret;
		        var phrases = _props.phrases;
	
		        var startDateValue = startDate || startDateString;
		        var endDateValue = endDate || endDateString;
	
		        return _react2['default'].createElement('div', {
		          className: (0, _classnames2['default'])('DateRangePickerInput', {
		            'DateRangePickerInput--disabled': disabled
		          })
		        }, _react2['default'].createElement(_DateInput2['default'], {
		          id: startDateId,
		          placeholder: startDatePlaceholderText,
		          dateValue: startDateValue,
		          focused: isStartDateFocused,
		          disabled: disabled,
		          required: required,
		          showCaret: showCaret,
	
		          onChange: onStartDateChange,
		          onFocus: onStartDateFocus,
		          onKeyDownShiftTab: onStartDateShiftTab
		        }), _react2['default'].createElement('div', { className: 'DateRangePickerInput__arrow' }, _react2['default'].createElement(_arrowRight2['default'], null)), _react2['default'].createElement(_DateInput2['default'], {
		          id: endDateId,
		          placeholder: endDatePlaceholderText,
		          dateValue: endDateValue,
		          focused: isEndDateFocused,
		          disabled: disabled,
		          required: required,
		          showCaret: showCaret,
	
		          onChange: onEndDateChange,
		          onFocus: onEndDateFocus,
		          onKeyDownTab: onEndDateTab
		        }), showClearDates && _react2['default'].createElement('button', {
		          type: 'button',
		          className: (0, _classnames2['default'])('DateRangePickerInput__clear-dates', {
		            'DateRangePickerInput__clear-dates--hide': !(startDateValue || endDateValue),
		            'DateRangePickerInput__clear-dates--hover': isClearDatesHovered
		          }),
		          onMouseEnter: this.onClearDatesMouseEnter,
		          onMouseLeave: this.onClearDatesMouseLeave,
		          onClick: onClearDates
		        }, _react2['default'].createElement('span', { className: 'screen-reader-only' }, phrases.clearDates), _react2['default'].createElement(_close2['default'], null)));
		      }
	
		      return render;
		    }()
		  }]);
	
		  return DateRangePickerInput;
		}(_react2['default'].Component);
	
		exports['default'] = DateRangePickerInput;
	
		DateRangePickerInput.propTypes = propTypes;
		DateRangePickerInput.defaultProps = defaultProps;
	
	/***/ },
	
	/***/ 1:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	
	/***/ 5:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(5);
	
	/***/ },
	
	/***/ 9:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(81);
	
	/***/ },
	
	/***/ 20:
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 12 12" }, this.props),
		          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	
	/***/ 22:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1491);
	
	/***/ },
	
	/***/ 23:
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 1000 1000" }, this.props),
		          _react2["default"].createElement("path", { d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ }
	
	/******/ });

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _reactMomentProptypes = __webpack_require__(3);
	
		var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
		var _DateRangePickerInput = __webpack_require__(24);
	
		var _DateRangePickerInput2 = _interopRequireDefault(_DateRangePickerInput);
	
		var _toMomentObject = __webpack_require__(25);
	
		var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
		var _toLocalizedDateString = __webpack_require__(26);
	
		var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);
	
		var _isInclusivelyAfterDay = __webpack_require__(17);
	
		var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
		var _isInclusivelyBeforeDay = __webpack_require__(27);
	
		var _isInclusivelyBeforeDay2 = _interopRequireDefault(_isInclusivelyBeforeDay);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = {
		  startDate: _reactMomentProptypes2['default'].momentObj,
		  startDateId: _react.PropTypes.string,
		  startDatePlaceholderText: _react.PropTypes.string,
		  isStartDateFocused: _react.PropTypes.bool,
	
		  endDate: _reactMomentProptypes2['default'].momentObj,
		  endDateId: _react.PropTypes.string,
		  endDatePlaceholderText: _react.PropTypes.string,
		  isEndDateFocused: _react.PropTypes.bool,
	
		  showClearDates: _react.PropTypes.bool,
		  showCaret: _react.PropTypes.bool,
		  disabled: _react.PropTypes.bool,
		  required: _react.PropTypes.bool,
	
		  keepOpenOnDateSelect: _react.PropTypes.bool,
		  reopenPickerOnClearDates: _react.PropTypes.bool,
		  withFullScreenPortal: _react.PropTypes.bool,
		  isOutsideRange: _react.PropTypes.func,
		  displayFormat: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	
		  onFocusChange: _react.PropTypes.func,
		  onDatesChange: _react.PropTypes.func,
	
		  // i18n
		  phrases: _react.PropTypes.shape({
		    clearDates: _react.PropTypes.node
		  })
		};
	
		var defaultProps = {
		  startDate: null,
		  startDateId: _constants.START_DATE,
		  startDatePlaceholderText: 'Start Date',
		  isStartDateFocused: false,
	
		  endDate: null,
		  endDateId: _constants.END_DATE,
		  endDatePlaceholderText: 'End Date',
		  isEndDateFocused: false,
	
		  showClearDates: false,
		  showCaret: false,
		  disabled: false,
		  required: false,
	
		  keepOpenOnDateSelect: false,
		  reopenPickerOnClearDates: false,
		  withFullScreenPortal: false,
		  isOutsideRange: function () {
		    function isOutsideRange(day) {
		      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
		    }
	
		    return isOutsideRange;
		  }(),
		  displayFormat: function () {
		    function displayFormat() {
		      return _moment2['default'].localeData().longDateFormat('L');
		    }
	
		    return displayFormat;
		  }(),
	
		  onFocusChange: function () {
		    function onFocusChange() {}
	
		    return onFocusChange;
		  }(),
		  onDatesChange: function () {
		    function onDatesChange() {}
	
		    return onDatesChange;
		  }(),
	
		  // i18n
		  phrases: {
		    clearDates: 'Clear Dates'
		  }
		};
	
		var DateRangePickerInputWithHandlers = function (_React$Component) {
		  _inherits(DateRangePickerInputWithHandlers, _React$Component);
	
		  function DateRangePickerInputWithHandlers(props) {
		    _classCallCheck(this, DateRangePickerInputWithHandlers);
	
		    var _this = _possibleConstructorReturn(this, (DateRangePickerInputWithHandlers.__proto__ || Object.getPrototypeOf(DateRangePickerInputWithHandlers)).call(this, props));
	
		    _this.onClearFocus = _this.onClearFocus.bind(_this);
		    _this.onStartDateChange = _this.onStartDateChange.bind(_this);
		    _this.onStartDateFocus = _this.onStartDateFocus.bind(_this);
		    _this.onEndDateChange = _this.onEndDateChange.bind(_this);
		    _this.onEndDateFocus = _this.onEndDateFocus.bind(_this);
		    _this.clearDates = _this.clearDates.bind(_this);
		    return _this;
		  }
	
		  _createClass(DateRangePickerInputWithHandlers, [{
		    key: 'onClearFocus',
		    value: function () {
		      function onClearFocus() {
		        this.props.onFocusChange(null);
		      }
	
		      return onClearFocus;
		    }()
		  }, {
		    key: 'onEndDateChange',
		    value: function () {
		      function onEndDateChange(endDateString) {
		        var _props = this.props;
		        var startDate = _props.startDate;
		        var isOutsideRange = _props.isOutsideRange;
		        var keepOpenOnDateSelect = _props.keepOpenOnDateSelect;
		        var onDatesChange = _props.onDatesChange;
		        var onFocusChange = _props.onFocusChange;
	
		        var endDate = (0, _toMomentObject2['default'])(endDateString, this.getDisplayFormat());
	
		        var isEndDateValid = endDate && !isOutsideRange(endDate) && !(0, _isInclusivelyBeforeDay2['default'])(endDate, startDate);
		        if (isEndDateValid) {
		          onDatesChange({ startDate: startDate, endDate: endDate });
		          if (!keepOpenOnDateSelect) onFocusChange(null);
		        } else {
		          onDatesChange({
		            startDate: startDate,
		            endDate: null
		          });
		        }
		      }
	
		      return onEndDateChange;
		    }()
		  }, {
		    key: 'onEndDateFocus',
		    value: function () {
		      function onEndDateFocus() {
		        var _props2 = this.props;
		        var startDate = _props2.startDate;
		        var onFocusChange = _props2.onFocusChange;
		        var withFullScreenPortal = _props2.withFullScreenPortal;
		        var disabled = _props2.disabled;
	
		        if (!startDate && withFullScreenPortal && !disabled) {
		          // When the datepicker is full screen, we never want to focus the end date first
		          // because there's no indication that that is the case once the datepicker is open and it
		          // might confuse the user
		          onFocusChange(_constants.START_DATE);
		        } else if (!disabled) {
		          onFocusChange(_constants.END_DATE);
		        }
		      }
	
		      return onEndDateFocus;
		    }()
		  }, {
		    key: 'onStartDateChange',
		    value: function () {
		      function onStartDateChange(startDateString) {
		        var startDate = (0, _toMomentObject2['default'])(startDateString, this.getDisplayFormat());
	
		        var endDate = this.props.endDate;
		        var _props3 = this.props;
		        var isOutsideRange = _props3.isOutsideRange;
		        var onDatesChange = _props3.onDatesChange;
		        var onFocusChange = _props3.onFocusChange;
	
		        var isStartDateValid = startDate && !isOutsideRange(startDate);
		        if (isStartDateValid) {
		          if ((0, _isInclusivelyBeforeDay2['default'])(endDate, startDate)) {
		            endDate = null;
		          }
	
		          onDatesChange({ startDate: startDate, endDate: endDate });
		          onFocusChange(_constants.END_DATE);
		        } else {
		          onDatesChange({
		            startDate: null,
		            endDate: endDate
		          });
		        }
		      }
	
		      return onStartDateChange;
		    }()
		  }, {
		    key: 'onStartDateFocus',
		    value: function () {
		      function onStartDateFocus() {
		        if (!this.props.disabled) {
		          this.props.onFocusChange(_constants.START_DATE);
		        }
		      }
	
		      return onStartDateFocus;
		    }()
		  }, {
		    key: 'getDisplayFormat',
		    value: function () {
		      function getDisplayFormat() {
		        var displayFormat = this.props.displayFormat;
	
		        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
		      }
	
		      return getDisplayFormat;
		    }()
		  }, {
		    key: 'getDateString',
		    value: function () {
		      function getDateString(date) {
		        var displayFormat = this.getDisplayFormat();
		        if (date && displayFormat) {
		          return date && date.format(displayFormat);
		        }
		        return (0, _toLocalizedDateString2['default'])(date);
		      }
	
		      return getDateString;
		    }()
		  }, {
		    key: 'clearDates',
		    value: function () {
		      function clearDates() {
		        var _props4 = this.props;
		        var onDatesChange = _props4.onDatesChange;
		        var reopenPickerOnClearDates = _props4.reopenPickerOnClearDates;
		        var onFocusChange = _props4.onFocusChange;
	
		        onDatesChange({ startDate: null, endDate: null });
		        if (reopenPickerOnClearDates) {
		          onFocusChange(_constants.START_DATE);
		        }
		      }
	
		      return clearDates;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _props5 = this.props;
		        var startDate = _props5.startDate;
		        var startDateId = _props5.startDateId;
		        var startDatePlaceholderText = _props5.startDatePlaceholderText;
		        var isStartDateFocused = _props5.isStartDateFocused;
		        var endDate = _props5.endDate;
		        var endDateId = _props5.endDateId;
		        var endDatePlaceholderText = _props5.endDatePlaceholderText;
		        var isEndDateFocused = _props5.isEndDateFocused;
		        var showClearDates = _props5.showClearDates;
		        var showCaret = _props5.showCaret;
		        var disabled = _props5.disabled;
		        var required = _props5.required;
		        var phrases = _props5.phrases;
	
		        var startDateString = this.getDateString(startDate);
		        var endDateString = this.getDateString(endDate);
	
		        return _react2['default'].createElement(_DateRangePickerInput2['default'], {
		          startDate: startDateString,
		          startDateId: startDateId,
		          startDatePlaceholderText: startDatePlaceholderText,
		          isStartDateFocused: isStartDateFocused,
		          endDate: endDateString,
		          endDateId: endDateId,
		          endDatePlaceholderText: endDatePlaceholderText,
		          isEndDateFocused: isEndDateFocused,
		          disabled: disabled,
		          required: required,
		          showCaret: showCaret,
		          phrases: phrases,
		          onStartDateChange: this.onStartDateChange,
		          onStartDateFocus: this.onStartDateFocus,
		          onStartDateShiftTab: this.onClearFocus,
		          onEndDateChange: this.onEndDateChange,
		          onEndDateFocus: this.onEndDateFocus,
		          onEndDateTab: this.onClearFocus,
		          showClearDates: showClearDates,
		          onClearDates: this.clearDates
		        });
		      }
	
		      return render;
		    }()
		  }]);
	
		  return DateRangePickerInputWithHandlers;
		}(_react2['default'].Component);
	
		exports['default'] = DateRangePickerInputWithHandlers;
	
		DateRangePickerInputWithHandlers.propTypes = propTypes;
		DateRangePickerInputWithHandlers.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */,
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(215);
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(7);
	
	/***/ },
	/* 5 */,
	/* 6 */,
	/* 7 */,
	/* 8 */,
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(81);
	
	/***/ },
	/* 10 */,
	/* 11 */,
	/* 12 */,
	/* 13 */,
	/* 14 */,
	/* 15 */,
	/* 16 */,
	/* 17 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(317);
	
	/***/ },
	/* 18 */,
	/* 19 */,
	/* 20 */,
	/* 21 */,
	/* 22 */,
	/* 23 */,
	/* 24 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1492);
	
	/***/ },
	/* 25 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(318);
	
	/***/ },
	/* 26 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(704);
	
	/***/ },
	/* 27 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1502);
	
	/***/ }
	/******/ ]);

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactMomentProptypes = __webpack_require__(3);
	
		var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _arrayIncludes = __webpack_require__(34);
	
		var _arrayIncludes2 = _interopRequireDefault(_arrayIncludes);
	
		var _isTouchDevice = __webpack_require__(14);
	
		var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
		var _isInclusivelyAfterDay = __webpack_require__(17);
	
		var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
		var _isNextDay = __webpack_require__(35);
	
		var _isNextDay2 = _interopRequireDefault(_isNextDay);
	
		var _isSameDay = __webpack_require__(36);
	
		var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
		var _FocusedInputShape = __webpack_require__(37);
	
		var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);
	
		var _OrientationShape = __webpack_require__(8);
	
		var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
		var _constants = __webpack_require__(9);
	
		var _DayPicker = __webpack_require__(38);
	
		var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = {
		  startDate: _reactMomentProptypes2['default'].momentObj,
		  endDate: _reactMomentProptypes2['default'].momentObj,
		  onDatesChange: _react.PropTypes.func,
	
		  focusedInput: _FocusedInputShape2['default'],
		  onFocusChange: _react.PropTypes.func,
	
		  keepOpenOnDateSelect: _react.PropTypes.bool,
		  minimumNights: _react.PropTypes.number,
		  isOutsideRange: _react.PropTypes.func,
		  isDayBlocked: _react.PropTypes.func,
		  isDayHighlighted: _react.PropTypes.func,
	
		  // DayPicker props
		  enableOutsideDays: _react.PropTypes.bool,
		  numberOfMonths: _react.PropTypes.number,
		  orientation: _OrientationShape2['default'],
		  withPortal: _react.PropTypes.bool,
		  hidden: _react.PropTypes.bool,
		  initialVisibleMonth: _react.PropTypes.func,
	
		  navPrev: _react.PropTypes.node,
		  navNext: _react.PropTypes.node,
	
		  onDayClick: _react.PropTypes.func,
		  onDayMouseDown: _react.PropTypes.func,
		  onDayMouseUp: _react.PropTypes.func,
		  onDayMouseEnter: _react.PropTypes.func,
		  onDayMouseLeave: _react.PropTypes.func,
		  onDayTouchStart: _react.PropTypes.func,
		  onDayTouchEnd: _react.PropTypes.func,
		  onDayTouchTap: _react.PropTypes.func,
		  onPrevMonthClick: _react.PropTypes.func,
		  onNextMonthClick: _react.PropTypes.func,
		  onOutsideClick: _react.PropTypes.func,
	
		  // i18n
		  monthFormat: _react.PropTypes.string
		};
	
		var defaultProps = {
		  startDate: undefined, // TODO: use null
		  endDate: undefined, // TODO: use null
		  onDatesChange: function () {
		    function onDatesChange() {}
	
		    return onDatesChange;
		  }(),
	
		  focusedInput: null,
		  onFocusChange: function () {
		    function onFocusChange() {}
	
		    return onFocusChange;
		  }(),
	
		  keepOpenOnDateSelect: false,
		  minimumNights: 1,
		  isOutsideRange: function () {
		    function isOutsideRange() {}
	
		    return isOutsideRange;
		  }(),
		  isDayBlocked: function () {
		    function isDayBlocked() {}
	
		    return isDayBlocked;
		  }(),
		  isDayHighlighted: function () {
		    function isDayHighlighted() {}
	
		    return isDayHighlighted;
		  }(),
	
		  // DayPicker props
		  enableOutsideDays: false,
		  numberOfMonths: 1,
		  orientation: _constants.HORIZONTAL_ORIENTATION,
		  withPortal: false,
		  hidden: false,
	
		  initialVisibleMonth: function () {
		    function initialVisibleMonth() {
		      return (0, _moment2['default'])();
		    }
	
		    return initialVisibleMonth;
		  }(),
	
		  navPrev: null,
		  navNext: null,
	
		  onDayClick: function () {
		    function onDayClick() {}
	
		    return onDayClick;
		  }(),
		  onDayMouseDown: function () {
		    function onDayMouseDown() {}
	
		    return onDayMouseDown;
		  }(),
		  onDayMouseUp: function () {
		    function onDayMouseUp() {}
	
		    return onDayMouseUp;
		  }(),
		  onDayMouseEnter: function () {
		    function onDayMouseEnter() {}
	
		    return onDayMouseEnter;
		  }(),
		  onDayMouseLeave: function () {
		    function onDayMouseLeave() {}
	
		    return onDayMouseLeave;
		  }(),
		  onDayTouchStart: function () {
		    function onDayTouchStart() {}
	
		    return onDayTouchStart;
		  }(),
		  onDayTouchTap: function () {
		    function onDayTouchTap() {}
	
		    return onDayTouchTap;
		  }(),
		  onDayTouchEnd: function () {
		    function onDayTouchEnd() {}
	
		    return onDayTouchEnd;
		  }(),
		  onPrevMonthClick: function () {
		    function onPrevMonthClick() {}
	
		    return onPrevMonthClick;
		  }(),
		  onNextMonthClick: function () {
		    function onNextMonthClick() {}
	
		    return onNextMonthClick;
		  }(),
		  onOutsideClick: function () {
		    function onOutsideClick() {}
	
		    return onOutsideClick;
		  }(),
	
		  // i18n
		  monthFormat: 'MMMM YYYY'
		};
	
		var DayPickerRangeController = function (_React$Component) {
		  _inherits(DayPickerRangeController, _React$Component);
	
		  function DayPickerRangeController(props) {
		    _classCallCheck(this, DayPickerRangeController);
	
		    var _this = _possibleConstructorReturn(this, (DayPickerRangeController.__proto__ || Object.getPrototypeOf(DayPickerRangeController)).call(this, props));
	
		    _this.state = {
		      hoverDate: null
		    };
	
		    _this.isTouchDevice = (0, _isTouchDevice2['default'])();
		    _this.today = (0, _moment2['default'])();
	
		    _this.onDayClick = _this.onDayClick.bind(_this);
		    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
		    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
		    return _this;
		  }
	
		  _createClass(DayPickerRangeController, [{
		    key: 'componentWillUpdate',
		    value: function () {
		      function componentWillUpdate() {
		        this.today = (0, _moment2['default'])();
		      }
	
		      return componentWillUpdate;
		    }()
		  }, {
		    key: 'onDayClick',
		    value: function () {
		      function onDayClick(day, modifiers, e) {
		        var _props = this.props;
		        var keepOpenOnDateSelect = _props.keepOpenOnDateSelect;
		        var minimumNights = _props.minimumNights;
	
		        if (e) e.preventDefault();
		        if ((0, _arrayIncludes2['default'])(modifiers, 'blocked')) return;
	
		        var focusedInput = this.props.focusedInput;
		        var _props2 = this.props;
		        var startDate = _props2.startDate;
		        var endDate = _props2.endDate;
	
		        if (focusedInput === _constants.START_DATE) {
		          this.props.onFocusChange(_constants.END_DATE);
	
		          startDate = day;
	
		          if ((0, _isInclusivelyAfterDay2['default'])(day, endDate)) {
		            endDate = null;
		          }
		        } else if (focusedInput === _constants.END_DATE) {
		          var firstAllowedEndDate = startDate && startDate.clone().add(minimumNights, 'days');
	
		          if (!startDate) {
		            endDate = day;
		            this.props.onFocusChange(_constants.START_DATE);
		          } else if ((0, _isInclusivelyAfterDay2['default'])(day, firstAllowedEndDate)) {
		            endDate = day;
		            if (!keepOpenOnDateSelect) this.props.onFocusChange(null);
		          } else {
		            startDate = day;
		            endDate = null;
		          }
		        }
	
		        this.props.onDatesChange({ startDate: startDate, endDate: endDate });
		      }
	
		      return onDayClick;
		    }()
		  }, {
		    key: 'onDayMouseEnter',
		    value: function () {
		      function onDayMouseEnter(day) {
		        if (this.isTouchDevice) return;
	
		        this.setState({
		          hoverDate: day
		        });
		      }
	
		      return onDayMouseEnter;
		    }()
		  }, {
		    key: 'onDayMouseLeave',
		    value: function () {
		      function onDayMouseLeave() {
		        if (this.isTouchDevice) return;
	
		        this.setState({
		          hoverDate: null
		        });
		      }
	
		      return onDayMouseLeave;
		    }()
		  }, {
		    key: 'doesNotMeetMinimumNights',
		    value: function () {
		      function doesNotMeetMinimumNights(day) {
		        var _props3 = this.props;
		        var startDate = _props3.startDate;
		        var isOutsideRange = _props3.isOutsideRange;
		        var focusedInput = _props3.focusedInput;
		        var minimumNights = _props3.minimumNights;
	
		        if (focusedInput !== _constants.END_DATE) return false;
	
		        if (startDate) {
		          var dayDiff = day.diff(startDate, 'days');
		          return dayDiff < minimumNights && dayDiff >= 0;
		        }
		        return isOutsideRange((0, _moment2['default'])(day).subtract(minimumNights, 'days'));
		      }
	
		      return doesNotMeetMinimumNights;
		    }()
		  }, {
		    key: 'isDayAfterHoveredStartDate',
		    value: function () {
		      function isDayAfterHoveredStartDate(day) {
		        var _props4 = this.props;
		        var startDate = _props4.startDate;
		        var endDate = _props4.endDate;
		        var minimumNights = _props4.minimumNights;
		        var hoverDate = this.state.hoverDate;
	
		        return !!startDate && !endDate && !this.isBlocked(day) && (0, _isNextDay2['default'])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay2['default'])(hoverDate, startDate);
		      }
	
		      return isDayAfterHoveredStartDate;
		    }()
		  }, {
		    key: 'isEndDate',
		    value: function () {
		      function isEndDate(day) {
		        return (0, _isSameDay2['default'])(day, this.props.endDate);
		      }
	
		      return isEndDate;
		    }()
		  }, {
		    key: 'isHovered',
		    value: function () {
		      function isHovered(day) {
		        return (0, _isSameDay2['default'])(day, this.state.hoverDate);
		      }
	
		      return isHovered;
		    }()
		  }, {
		    key: 'isInHoveredSpan',
		    value: function () {
		      function isInHoveredSpan(day) {
		        var _props5 = this.props;
		        var startDate = _props5.startDate;
		        var endDate = _props5.endDate;
		        var hoverDate = this.state.hoverDate;
	
		        var isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay2['default'])(hoverDate, day));
		        var isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay2['default'])(hoverDate, day));
	
		        var isValidDayHovered = hoverDate && !this.isBlocked(hoverDate);
	
		        return (isForwardRange || isBackwardRange) && isValidDayHovered;
		      }
	
		      return isInHoveredSpan;
		    }()
		  }, {
		    key: 'isInSelectedSpan',
		    value: function () {
		      function isInSelectedSpan(day) {
		        var _props6 = this.props;
		        var startDate = _props6.startDate;
		        var endDate = _props6.endDate;
	
		        return day.isBetween(startDate, endDate);
		      }
	
		      return isInSelectedSpan;
		    }()
		  }, {
		    key: 'isLastInRange',
		    value: function () {
		      function isLastInRange(day) {
		        return this.isInSelectedSpan(day) && (0, _isNextDay2['default'])(day, this.props.endDate);
		      }
	
		      return isLastInRange;
		    }()
		  }, {
		    key: 'isStartDate',
		    value: function () {
		      function isStartDate(day) {
		        return (0, _isSameDay2['default'])(day, this.props.startDate);
		      }
	
		      return isStartDate;
		    }()
		  }, {
		    key: 'isBlocked',
		    value: function () {
		      function isBlocked(day) {
		        var _props7 = this.props;
		        var isDayBlocked = _props7.isDayBlocked;
		        var isOutsideRange = _props7.isOutsideRange;
	
		        return isDayBlocked(day) || isOutsideRange(day) || this.doesNotMeetMinimumNights(day);
		      }
	
		      return isBlocked;
		    }()
		  }, {
		    key: 'isToday',
		    value: function () {
		      function isToday(day) {
		        return (0, _isSameDay2['default'])(day, this.today);
		      }
	
		      return isToday;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _this2 = this;
	
		        var _props8 = this.props;
		        var isDayBlocked = _props8.isDayBlocked;
		        var isDayHighlighted = _props8.isDayHighlighted;
		        var isOutsideRange = _props8.isOutsideRange;
		        var numberOfMonths = _props8.numberOfMonths;
		        var orientation = _props8.orientation;
		        var monthFormat = _props8.monthFormat;
		        var navPrev = _props8.navPrev;
		        var navNext = _props8.navNext;
		        var onOutsideClick = _props8.onOutsideClick;
		        var onPrevMonthClick = _props8.onPrevMonthClick;
		        var onNextMonthClick = _props8.onNextMonthClick;
		        var withPortal = _props8.withPortal;
		        var enableOutsideDays = _props8.enableOutsideDays;
		        var initialVisibleMonth = _props8.initialVisibleMonth;
		        var focusedInput = _props8.focusedInput;
	
		        var modifiers = {
		          today: function () {
		            function today(day) {
		              return _this2.isToday(day);
		            }
	
		            return today;
		          }(),
		          blocked: function () {
		            function blocked(day) {
		              return _this2.isBlocked(day);
		            }
	
		            return blocked;
		          }(),
		          'blocked-calendar': function () {
		            function blockedCalendar(day) {
		              return isDayBlocked(day);
		            }
	
		            return blockedCalendar;
		          }(),
		          'blocked-out-of-range': function () {
		            function blockedOutOfRange(day) {
		              return isOutsideRange(day);
		            }
	
		            return blockedOutOfRange;
		          }(),
		          'blocked-minimum-nights': function () {
		            function blockedMinimumNights(day) {
		              return _this2.doesNotMeetMinimumNights(day);
		            }
	
		            return blockedMinimumNights;
		          }(),
		          'highlighted-calendar': function () {
		            function highlightedCalendar(day) {
		              return isDayHighlighted(day);
		            }
	
		            return highlightedCalendar;
		          }(),
		          valid: function () {
		            function valid(day) {
		              return !_this2.isBlocked(day);
		            }
	
		            return valid;
		          }(),
		          // before anything has been set or after both are set
		          hovered: function () {
		            function hovered(day) {
		              return _this2.isHovered(day);
		            }
	
		            return hovered;
		          }(),
	
		          // while start date has been set, but end date has not been
		          'hovered-span': function () {
		            function hoveredSpan(day) {
		              return _this2.isInHoveredSpan(day);
		            }
	
		            return hoveredSpan;
		          }(),
		          'after-hovered-start': function () {
		            function afterHoveredStart(day) {
		              return _this2.isDayAfterHoveredStartDate(day);
		            }
	
		            return afterHoveredStart;
		          }(),
		          'last-in-range': function () {
		            function lastInRange(day) {
		              return _this2.isLastInRange(day);
		            }
	
		            return lastInRange;
		          }(),
	
		          // once a start date and end date have been set
		          'selected-start': function () {
		            function selectedStart(day) {
		              return _this2.isStartDate(day);
		            }
	
		            return selectedStart;
		          }(),
		          'selected-end': function () {
		            function selectedEnd(day) {
		              return _this2.isEndDate(day);
		            }
	
		            return selectedEnd;
		          }(),
		          'selected-span': function () {
		            function selectedSpan(day) {
		              return _this2.isInSelectedSpan(day);
		            }
	
		            return selectedSpan;
		          }()
		        };
	
		        return _react2['default'].createElement(_DayPicker2['default'], {
		          ref: function () {
		            function ref(_ref) {
		              _this2.dayPicker = _ref;
		            }
	
		            return ref;
		          }(),
		          orientation: orientation,
		          enableOutsideDays: enableOutsideDays,
		          modifiers: modifiers,
		          numberOfMonths: numberOfMonths,
		          onDayMouseEnter: this.onDayMouseEnter,
		          onDayMouseLeave: this.onDayMouseLeave,
		          onDayMouseDown: this.onDayClick,
		          onDayTouchTap: this.onDayClick,
		          onPrevMonthClick: onPrevMonthClick,
		          onNextMonthClick: onNextMonthClick,
		          monthFormat: monthFormat,
		          withPortal: withPortal,
		          hidden: !focusedInput,
		          initialVisibleMonth: initialVisibleMonth,
		          onOutsideClick: onOutsideClick,
		          navPrev: navPrev,
		          navNext: navNext
		        });
		      }
	
		      return render;
		    }()
		  }]);
	
		  return DayPickerRangeController;
		}(_react2['default'].Component);
	
		exports['default'] = DayPickerRangeController;
	
		DayPickerRangeController.propTypes = propTypes;
		DayPickerRangeController.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */,
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(215);
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(7);
	
	/***/ },
	/* 5 */,
	/* 6 */,
	/* 7 */,
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(256);
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(81);
	
	/***/ },
	/* 10 */,
	/* 11 */,
	/* 12 */,
	/* 13 */,
	/* 14 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(703);
	
	/***/ },
	/* 15 */,
	/* 16 */,
	/* 17 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(317);
	
	/***/ },
	/* 18 */,
	/* 19 */,
	/* 20 */,
	/* 21 */,
	/* 22 */,
	/* 23 */,
	/* 24 */,
	/* 25 */,
	/* 26 */,
	/* 27 */,
	/* 28 */,
	/* 29 */,
	/* 30 */,
	/* 31 */,
	/* 32 */,
	/* 33 */,
	/* 34 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(842);
	
	/***/ },
	/* 35 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1503);
	
	/***/ },
	/* 36 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(257);
	
	/***/ },
	/* 37 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1498);
	
	/***/ },
	/* 38 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(702);
	
	/***/ }
	/******/ ]);

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _DateInput = __webpack_require__(22);
	
		var _DateInput2 = _interopRequireDefault(_DateInput);
	
		var _close = __webpack_require__(20);
	
		var _close2 = _interopRequireDefault(_close);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = {
		  id: _react.PropTypes.string.isRequired,
		  placeholder: _react.PropTypes.string, // also used as label
		  dateValue: _react.PropTypes.string,
		  border: _react.PropTypes.bool,
		  focused: _react.PropTypes.bool,
		  disabled: _react.PropTypes.bool,
		  required: _react.PropTypes.bool,
		  showCaret: _react.PropTypes.bool,
		  showClearDate: _react.PropTypes.bool,
	
		  onChange: _react.PropTypes.func,
		  onClearDate: _react.PropTypes.func,
		  onFocus: _react.PropTypes.func,
		  onKeyDownShiftTab: _react.PropTypes.func,
		  onKeyDownTab: _react.PropTypes.func,
	
		  // i18n
		  phrases: _react.PropTypes.shape({
		    clearDate: _react.PropTypes.node
		  })
		};
	
		var defaultProps = {
		  placeholder: 'Select Date',
		  dateValue: '',
		  border: false,
		  focused: false,
		  disabled: false,
		  required: false,
		  showCaret: false,
		  showClearDate: false,
	
		  onChange: function () {
		    function onChange() {}
	
		    return onChange;
		  }(),
		  onClearDate: function () {
		    function onClearDate() {}
	
		    return onClearDate;
		  }(),
		  onFocus: function () {
		    function onFocus() {}
	
		    return onFocus;
		  }(),
		  onKeyDownShiftTab: function () {
		    function onKeyDownShiftTab() {}
	
		    return onKeyDownShiftTab;
		  }(),
		  onKeyDownTab: function () {
		    function onKeyDownTab() {}
	
		    return onKeyDownTab;
		  }(),
	
		  // i18n
		  phrases: {
		    clearDate: 'Clear Date'
		  }
		};
	
		var SingleDatePickerInput = function (_React$Component) {
		  _inherits(SingleDatePickerInput, _React$Component);
	
		  function SingleDatePickerInput(props) {
		    _classCallCheck(this, SingleDatePickerInput);
	
		    var _this = _possibleConstructorReturn(this, (SingleDatePickerInput.__proto__ || Object.getPrototypeOf(SingleDatePickerInput)).call(this, props));
	
		    _this.state = {
		      isClearDateHovered: false
		    };
	
		    _this.onClearDateMouseEnter = _this.onClearDateMouseEnter.bind(_this);
		    _this.onClearDateMouseLeave = _this.onClearDateMouseLeave.bind(_this);
		    return _this;
		  }
	
		  _createClass(SingleDatePickerInput, [{
		    key: 'onClearDateMouseEnter',
		    value: function () {
		      function onClearDateMouseEnter() {
		        this.setState({
		          isClearDateHovered: true
		        });
		      }
	
		      return onClearDateMouseEnter;
		    }()
		  }, {
		    key: 'onClearDateMouseLeave',
		    value: function () {
		      function onClearDateMouseLeave() {
		        this.setState({
		          isClearDateHovered: false
		        });
		      }
	
		      return onClearDateMouseLeave;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var isClearDateHovered = this.state.isClearDateHovered;
		        var _props = this.props;
		        var id = _props.id;
		        var placeholder = _props.placeholder;
		        var dateValue = _props.dateValue;
		        var focused = _props.focused;
		        var disabled = _props.disabled;
		        var required = _props.required;
		        var showCaret = _props.showCaret;
		        var showClearDate = _props.showClearDate;
		        var phrases = _props.phrases;
		        var onClearDate = _props.onClearDate;
		        var onChange = _props.onChange;
		        var onFocus = _props.onFocus;
		        var onKeyDownShiftTab = _props.onKeyDownShiftTab;
		        var onKeyDownTab = _props.onKeyDownTab;
	
		        return _react2['default'].createElement('div', { className: 'SingleDatePickerInput' }, _react2['default'].createElement(_DateInput2['default'], {
		          id: id,
		          placeholder: placeholder // also used as label
		          , dateValue: dateValue,
		          focused: focused,
		          disabled: disabled,
		          required: required,
		          showCaret: showCaret,
	
		          onChange: onChange,
		          onFocus: onFocus,
		          onKeyDownShiftTab: onKeyDownShiftTab,
		          onKeyDownTab: onKeyDownTab
		        }), showClearDate && _react2['default'].createElement('button', {
		          type: 'button',
		          className: (0, _classnames2['default'])('SingleDatePickerInput__clear-date', {
		            'SingleDatePickerInput__clear-date--hide': !dateValue,
		            'SingleDatePickerInput__clear-date--hover': isClearDateHovered
		          }),
		          onMouseEnter: this.onClearDateMouseEnter,
		          onMouseLeave: this.onClearDateMouseLeave,
		          onClick: onClearDate
		        }, _react2['default'].createElement('span', { className: 'screen-reader-only' }, phrases.clearDate), _react2['default'].createElement(_close2['default'], null)));
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SingleDatePickerInput;
		}(_react2['default'].Component);
	
		exports['default'] = SingleDatePickerInput;
	
		SingleDatePickerInput.propTypes = propTypes;
		SingleDatePickerInput.defaultProps = defaultProps;
	
	/***/ },
	
	/***/ 1:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	
	/***/ 5:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(5);
	
	/***/ },
	
	/***/ 20:
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 12 12" }, this.props),
		          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	
	/***/ 22:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1491);
	
	/***/ }
	
	/******/ });

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(81);
	
	exports['default'] = _react.PropTypes.oneOf([_constants.ANCHOR_LEFT, _constants.ANCHOR_RIGHT]);

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactMomentProptypes = __webpack_require__(215);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _FocusedInputShape = __webpack_require__(1498);
	
	var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);
	
	var _OrientationShape = __webpack_require__(256);
	
	var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
	var _AnchorDirectionShape = __webpack_require__(1496);
	
	var _AnchorDirectionShape2 = _interopRequireDefault(_AnchorDirectionShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  startDate: _reactMomentProptypes2['default'].momentObj,
	  endDate: _reactMomentProptypes2['default'].momentObj,
	  focusedInput: _FocusedInputShape2['default'],
	  minimumNights: _react.PropTypes.number,
	  isDayBlocked: _react.PropTypes.func,
	  isOutsideRange: _react.PropTypes.func,
	  enableOutsideDays: _react.PropTypes.bool,
	  reopenPickerOnClearDates: _react.PropTypes.bool,
	  keepOpenOnDateSelect: _react.PropTypes.bool,
	  numberOfMonths: _react.PropTypes.number,
	  showClearDates: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  required: _react.PropTypes.bool,
	
	  orientation: _OrientationShape2['default'],
	  anchorDirection: _AnchorDirectionShape2['default'],
	  horizontalMargin: _react.PropTypes.number,
	  // portal options
	  withPortal: _react.PropTypes.bool,
	  withFullScreenPortal: _react.PropTypes.bool,
	
	  startDateId: _react.PropTypes.string,
	  startDatePlaceholderText: _react.PropTypes.string,
	  endDateId: _react.PropTypes.string,
	  endDatePlaceholderText: _react.PropTypes.string,
	
	  initialVisibleMonth: _react.PropTypes.func,
	  onDatesChange: _react.PropTypes.func,
	  onFocusChange: _react.PropTypes.func,
	  onPrevMonthClick: _react.PropTypes.func,
	  onNextMonthClick: _react.PropTypes.func,
	
	  // i18n
	  displayFormat: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	  monthFormat: _react.PropTypes.string,
	  phrases: _react.PropTypes.shape({
	    closeDatePicker: _react.PropTypes.node,
	    clearDates: _react.PropTypes.node
	  })
	};

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(81);
	
	exports['default'] = _react.PropTypes.oneOf([_constants.START_DATE, _constants.END_DATE]);

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactMomentProptypes = __webpack_require__(215);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _OrientationShape = __webpack_require__(256);
	
	var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
	var _AnchorDirectionShape = __webpack_require__(1496);
	
	var _AnchorDirectionShape2 = _interopRequireDefault(_AnchorDirectionShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  id: _react.PropTypes.string.isRequired,
	  placeholder: _react.PropTypes.string,
	  date: _reactMomentProptypes2['default'].momentObj,
	  focused: _react.PropTypes.bool,
	  showClearDate: _react.PropTypes.bool,
	  reopenPickerOnClearDates: _react.PropTypes.bool,
	  keepOpenOnDateSelect: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  required: _react.PropTypes.bool,
	
	  onDateChange: _react.PropTypes.func,
	  onFocusChange: _react.PropTypes.func,
	
	  isDayBlocked: _react.PropTypes.func,
	  isOutsideRange: _react.PropTypes.func,
	  enableOutsideDays: _react.PropTypes.bool,
	  numberOfMonths: _react.PropTypes.number,
	  orientation: _OrientationShape2['default'],
	  initialVisibleMonth: _react.PropTypes.func,
	  anchorDirection: _AnchorDirectionShape2['default'],
	  horizontalMargin: _react.PropTypes.number,
	
	  navPrev: _react.PropTypes.node,
	  navNext: _react.PropTypes.node,
	
	  // portal options
	  withPortal: _react.PropTypes.bool,
	  withFullScreenPortal: _react.PropTypes.bool,
	
	  onPrevMonthClick: _react.PropTypes.func,
	  onNextMonthClick: _react.PropTypes.func,
	
	  // i18n
	  displayFormat: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	  monthFormat: _react.PropTypes.string,
	  phrases: _react.PropTypes.shape({
	    closeDatePicker: _react.PropTypes.node
	  })
	};

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getResponsiveContainerStyles;
	
	var _constants = __webpack_require__(81);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getResponsiveContainerStyles(anchorDirection, currentOffset, containerEdge, margin) {
	  var windowWidth = typeof window !== 'undefined' && window.innerWidth;
	  var calculatedOffset = anchorDirection === _constants.ANCHOR_LEFT ? windowWidth - containerEdge : containerEdge;
	  var calculatedMargin = margin || 0;
	
	  return _defineProperty({}, anchorDirection, Math.min(currentOffset + calculatedOffset - calculatedMargin, 0));
	}

/***/ },
/* 1501 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getTransformStyles;
	function getTransformStyles(transformValue) {
	  return {
	    transform: transformValue,
	    msTransform: transformValue,
	    MozTransform: transformValue,
	    WebkitTransform: transformValue
	  };
	}

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isInclusivelyBeforeDay;
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isSameDay = __webpack_require__(257);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isInclusivelyBeforeDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return a.isBefore(b) || (0, _isSameDay2['default'])(a, b);
	}

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isNextDay;
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isSameDay = __webpack_require__(257);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isNextDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  var nextDay = (0, _moment2['default'])(a).add(1, 'day');
	  return (0, _isSameDay2['default'])(nextDay, b);
	}

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function(f) {
	  if (true) {
	    module.exports = f(__webpack_require__(1));
	    /* global define */
	  } else if (typeof define === 'function' && define.amd) {
	    define(['react'], f);
	  } else {
	    var g;
	    if (typeof window !== 'undefined') {
	      g = window;
	    } else if (typeof global !== 'undefined') {
	      g = global;
	    } else if (typeof self !== 'undefined') {
	      g = self;
	    } else {
	      g = this;
	    }
	
	    if (typeof g.React === 'undefined') {
	      throw Error('React module should be required before ReactDOMFactories');
	    }
	
	    g.ReactDOMFactories = f(g.React);
	  }
	})(function(React) {
	  /**
	   * Create a factory that creates HTML tag elements.
	   */
	  function createDOMFactory(type) {
	    var factory = React.createElement.bind(null, type);
	    // Expose the type on the factory and the prototype so that it can be
	    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	    // This should not be named `constructor` since this may not be the function
	    // that created the element, and it may not even be a constructor.
	    factory.type = type;
	    return factory;
	  };
	
	  /**
	   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	   */
	  var ReactDOMFactories = {
	    a: createDOMFactory('a'),
	    abbr: createDOMFactory('abbr'),
	    address: createDOMFactory('address'),
	    area: createDOMFactory('area'),
	    article: createDOMFactory('article'),
	    aside: createDOMFactory('aside'),
	    audio: createDOMFactory('audio'),
	    b: createDOMFactory('b'),
	    base: createDOMFactory('base'),
	    bdi: createDOMFactory('bdi'),
	    bdo: createDOMFactory('bdo'),
	    big: createDOMFactory('big'),
	    blockquote: createDOMFactory('blockquote'),
	    body: createDOMFactory('body'),
	    br: createDOMFactory('br'),
	    button: createDOMFactory('button'),
	    canvas: createDOMFactory('canvas'),
	    caption: createDOMFactory('caption'),
	    cite: createDOMFactory('cite'),
	    code: createDOMFactory('code'),
	    col: createDOMFactory('col'),
	    colgroup: createDOMFactory('colgroup'),
	    data: createDOMFactory('data'),
	    datalist: createDOMFactory('datalist'),
	    dd: createDOMFactory('dd'),
	    del: createDOMFactory('del'),
	    details: createDOMFactory('details'),
	    dfn: createDOMFactory('dfn'),
	    dialog: createDOMFactory('dialog'),
	    div: createDOMFactory('div'),
	    dl: createDOMFactory('dl'),
	    dt: createDOMFactory('dt'),
	    em: createDOMFactory('em'),
	    embed: createDOMFactory('embed'),
	    fieldset: createDOMFactory('fieldset'),
	    figcaption: createDOMFactory('figcaption'),
	    figure: createDOMFactory('figure'),
	    footer: createDOMFactory('footer'),
	    form: createDOMFactory('form'),
	    h1: createDOMFactory('h1'),
	    h2: createDOMFactory('h2'),
	    h3: createDOMFactory('h3'),
	    h4: createDOMFactory('h4'),
	    h5: createDOMFactory('h5'),
	    h6: createDOMFactory('h6'),
	    head: createDOMFactory('head'),
	    header: createDOMFactory('header'),
	    hgroup: createDOMFactory('hgroup'),
	    hr: createDOMFactory('hr'),
	    html: createDOMFactory('html'),
	    i: createDOMFactory('i'),
	    iframe: createDOMFactory('iframe'),
	    img: createDOMFactory('img'),
	    input: createDOMFactory('input'),
	    ins: createDOMFactory('ins'),
	    kbd: createDOMFactory('kbd'),
	    keygen: createDOMFactory('keygen'),
	    label: createDOMFactory('label'),
	    legend: createDOMFactory('legend'),
	    li: createDOMFactory('li'),
	    link: createDOMFactory('link'),
	    main: createDOMFactory('main'),
	    map: createDOMFactory('map'),
	    mark: createDOMFactory('mark'),
	    menu: createDOMFactory('menu'),
	    menuitem: createDOMFactory('menuitem'),
	    meta: createDOMFactory('meta'),
	    meter: createDOMFactory('meter'),
	    nav: createDOMFactory('nav'),
	    noscript: createDOMFactory('noscript'),
	    object: createDOMFactory('object'),
	    ol: createDOMFactory('ol'),
	    optgroup: createDOMFactory('optgroup'),
	    option: createDOMFactory('option'),
	    output: createDOMFactory('output'),
	    p: createDOMFactory('p'),
	    param: createDOMFactory('param'),
	    picture: createDOMFactory('picture'),
	    pre: createDOMFactory('pre'),
	    progress: createDOMFactory('progress'),
	    q: createDOMFactory('q'),
	    rp: createDOMFactory('rp'),
	    rt: createDOMFactory('rt'),
	    ruby: createDOMFactory('ruby'),
	    s: createDOMFactory('s'),
	    samp: createDOMFactory('samp'),
	    script: createDOMFactory('script'),
	    section: createDOMFactory('section'),
	    select: createDOMFactory('select'),
	    small: createDOMFactory('small'),
	    source: createDOMFactory('source'),
	    span: createDOMFactory('span'),
	    strong: createDOMFactory('strong'),
	    style: createDOMFactory('style'),
	    sub: createDOMFactory('sub'),
	    summary: createDOMFactory('summary'),
	    sup: createDOMFactory('sup'),
	    table: createDOMFactory('table'),
	    tbody: createDOMFactory('tbody'),
	    td: createDOMFactory('td'),
	    textarea: createDOMFactory('textarea'),
	    tfoot: createDOMFactory('tfoot'),
	    th: createDOMFactory('th'),
	    thead: createDOMFactory('thead'),
	    time: createDOMFactory('time'),
	    title: createDOMFactory('title'),
	    tr: createDOMFactory('tr'),
	    track: createDOMFactory('track'),
	    u: createDOMFactory('u'),
	    ul: createDOMFactory('ul'),
	    var: createDOMFactory('var'),
	    video: createDOMFactory('video'),
	    wbr: createDOMFactory('wbr'),
	
	    // SVG
	    circle: createDOMFactory('circle'),
	    clipPath: createDOMFactory('clipPath'),
	    defs: createDOMFactory('defs'),
	    ellipse: createDOMFactory('ellipse'),
	    g: createDOMFactory('g'),
	    image: createDOMFactory('image'),
	    line: createDOMFactory('line'),
	    linearGradient: createDOMFactory('linearGradient'),
	    mask: createDOMFactory('mask'),
	    path: createDOMFactory('path'),
	    pattern: createDOMFactory('pattern'),
	    polygon: createDOMFactory('polygon'),
	    polyline: createDOMFactory('polyline'),
	    radialGradient: createDOMFactory('radialGradient'),
	    rect: createDOMFactory('rect'),
	    stop: createDOMFactory('stop'),
	    svg: createDOMFactory('svg'),
	    text: createDOMFactory('text'),
	    tspan: createDOMFactory('tspan'),
	  };
	
	  // due to wrapper and conditionals at the top, this will either become
	  // `module.exports ReactDOMFactories` if that is available,
	  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
	  // if that is available,
	  // otherwise it will be defined as global variable.
	  return ReactDOMFactories;
	});
	


/***/ },
/* 1505 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(213);
	
	var invariant = __webpack_require__(36);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(260);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactInstrumentation = __webpack_require__(113);
	
	var quoteAttributeValueForBrowser = __webpack_require__(3334);
	var warning = __webpack_require__(41);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 1508 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(723);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var LinkedValueUtils = __webpack_require__(712);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactUpdates = __webpack_require__(125);
	
	var warning = __webpack_require__(41);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var ReactUpdates = __webpack_require__(125);
	var Transaction = __webpack_require__(450);
	
	var emptyFunction = __webpack_require__(110);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(3276);
	var BeforeInputEventPlugin = __webpack_require__(3278);
	var ChangeEventPlugin = __webpack_require__(3280);
	var DefaultEventPluginOrder = __webpack_require__(3282);
	var EnterLeaveEventPlugin = __webpack_require__(3283);
	var HTMLDOMPropertyConfig = __webpack_require__(3285);
	var ReactComponentBrowserEnvironment = __webpack_require__(3287);
	var ReactDOMComponent = __webpack_require__(3290);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactDOMEmptyComponent = __webpack_require__(3291);
	var ReactDOMTreeTraversal = __webpack_require__(3300);
	var ReactDOMTextComponent = __webpack_require__(3298);
	var ReactDefaultBatchingStrategy = __webpack_require__(1511);
	var ReactEventListener = __webpack_require__(3303);
	var ReactInjection = __webpack_require__(3304);
	var ReactReconcileTransaction = __webpack_require__(3308);
	var SVGDOMPropertyConfig = __webpack_require__(3313);
	var SelectEventPlugin = __webpack_require__(3314);
	var SimpleEventPlugin = __webpack_require__(3315);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 1513 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 1514 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(36);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(3296);
	
	var containsNode = __webpack_require__(2914);
	var focusNode = __webpack_require__(1282);
	var getActiveElement = __webpack_require__(1283);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(3326);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var DOMLazyTree = __webpack_require__(259);
	var DOMProperty = __webpack_require__(260);
	var React = __webpack_require__(217);
	var ReactBrowserEventEmitter = __webpack_require__(448);
	var ReactCurrentOwner = __webpack_require__(159);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactDOMContainerInfo = __webpack_require__(1509);
	var ReactDOMFeatureFlags = __webpack_require__(3292);
	var ReactFeatureFlags = __webpack_require__(1514);
	var ReactInstanceMap = __webpack_require__(322);
	var ReactInstrumentation = __webpack_require__(113);
	var ReactMarkupChecksum = __webpack_require__(1517);
	var ReactReconciler = __webpack_require__(214);
	var ReactUpdateQueue = __webpack_require__(715);
	var ReactUpdates = __webpack_require__(125);
	
	var emptyObject = __webpack_require__(248);
	var instantiateReactComponent = __webpack_require__(720);
	var invariant = __webpack_require__(36);
	var setInnerHTML = __webpack_require__(452);
	var shouldUpdateReactComponent = __webpack_require__(722);
	var warning = __webpack_require__(41);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var React = __webpack_require__(217);
	
	var invariant = __webpack_require__(36);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var PooledClass = __webpack_require__(213);
	var Transaction = __webpack_require__(450);
	var ReactInstrumentation = __webpack_require__(113);
	var ReactServerUpdateQueue = __webpack_require__(3312);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 1521 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.1';

/***/ },
/* 1522 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(36);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 1524 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(1519);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(89);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(60);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  delete inst._wrapperState.valueTracker;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 1528 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(89);
	var escapeTextContentForBrowser = __webpack_require__(451);
	var setInnerHTML = __webpack_require__(452);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var ReactCurrentOwner = __webpack_require__(159);
	var REACT_ELEMENT_TYPE = __webpack_require__(3301);
	
	var getIteratorFn = __webpack_require__(3331);
	var invariant = __webpack_require__(36);
	var KeyEscapeUtils = __webpack_require__(711);
	var warning = __webpack_require__(41);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1531 */
/***/ function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ },
/* 1532 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var KEYCODE_UP = 38;
		var KEYCODE_DOWN = 40;
		var IS_BROWSER = typeof document != 'undefined';
	
		function addClass(element, className) {
		    if (element.classList) {
		        return element.classList.add(className);
		    }
		    if (!element.className.search(new RegExp("\\b" + className + "\\b"))) {
		        element.className = " " + className;
		    }
		}
	
		function removeClass(element, className) {
		    if (element.className) {
		        if (element.classList) {
		            return element.classList.remove(className);
		        }
	
		        element.className = element.className.replace(new RegExp("\\b" + className + "\\b", "g"), "");
		    }
		}
	
		var NumericInput = function (_Component) {
		    _inherits(NumericInput, _Component);
	
		    function NumericInput() {
		        var _Object$getPrototypeO;
	
		        _classCallCheck(this, NumericInput);
	
		        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		        }
	
		        var _this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(NumericInput)).call.apply(_Object$getPrototypeO, [this].concat(args)));
	
		        _this.state = {
		            selectionStart: null,
		            selectionEnd: null,
		            value: "value" in _this.props ? _this.props.value : _this.props.defaultValue,
		            btnDownHover: false,
		            btnDownActive: false,
		            btnUpHover: false,
		            btnUpActive: false,
		            inputFocus: false
		        };
	
		        _this.stop = _this.stop.bind(_this);
		        return _this;
		    }
	
		    _createClass(NumericInput, [{
		        key: "componentWillReceiveProps",
		        value: function componentWillReceiveProps(props) {
		            var _value = String(props.value || props.value === 0 ? props.value : '').replace(/^\s*|\s*$/, "");
	
		            this.setState({
		                value: "value" in props && _value !== '' ? this._parse(_value) : null
		            });
		        }
		    }, {
		        key: "componentWillUpdate",
		        value: function componentWillUpdate() {
		            this.saveSelection();
		        }
		    }, {
		        key: "componentDidUpdate",
		        value: function componentDidUpdate(prevProps, prevState) {
		            if (prevState.value !== this.state.value && (!isNaN(this.state.value) || this.state.value === null)) {
		                this._invokeEventCallback("onChange", this.state.value, this.refs.input.value);
		            }
	
		            if (this.state.inputFocus) {
		                this.refs.input.focus();
	
		                if (this.state.selectionStart || this.state.selectionStart === 0) {
		                    this.refs.input.selectionStart = this.state.selectionStart;
		                }
	
		                if (this.state.selectionEnd || this.state.selectionEnd === 0) {
		                    this.refs.input.selectionEnd = this.state.selectionEnd;
		                }
		            }
	
		            this.checkValidity();
		        }
		    }, {
		        key: "componentWillUnmount",
		        value: function componentWillUnmount() {
		            this.stop();
		        }
		    }, {
		        key: "componentDidMount",
		        value: function componentDidMount() {
		            var _this2 = this;
	
		            this.refs.input.getValueAsNumber = function () {
		                return _this2.state.value || 0;
		            };
	
		            this.refs.input.setValue = function (value) {
		                _this2.setState({
		                    value: _this2._parse(value)
		                });
		            };
	
		            if (!this.state.inputFocus && IS_BROWSER && document.activeElement === this.refs.input) {
		                this.state.inputFocus = true;
		                this.refs.input.focus();
		                this._invokeEventCallback("onFocus", {
		                    target: this.refs.input,
		                    type: "focus"
		                });
		            }
	
		            this.checkValidity();
		        }
		    }, {
		        key: "saveSelection",
		        value: function saveSelection() {
		            this.state.selectionStart = this.refs.input.selectionStart;
		            this.state.selectionEnd = this.refs.input.selectionEnd;
		        }
		    }, {
		        key: "checkValidity",
		        value: function checkValidity() {
		            var valid = undefined,
		                validationError = "";
	
		            var supportsValidation = !!this.refs.input.checkValidity;
	
		            var noValidate = !!(this.props.noValidate && this.props.noValidate != "false");
	
		            this.refs.input.noValidate = noValidate;
	
		            valid = noValidate || !supportsValidation;
	
		            if (valid) {
		                validationError = "";
		            } else {
		                if (this.refs.input.pattern === "") {
		                    this.refs.input.pattern = this.props.required ? ".+" : ".*";
		                }
	
		                if (supportsValidation) {
		                    this.refs.input.checkValidity();
		                    valid = this.refs.input.validity.valid;
	
		                    if (!valid) {
		                        validationError = this.refs.input.validationMessage;
		                    }
		                }
	
		                if (valid && supportsValidation && this.props.maxLength) {
		                    if (this.refs.input.value.length > this.props.maxLength) {
		                        validationError = "This value is too long";
		                    }
		                }
		            }
	
		            validationError = validationError || (valid ? "" : this.refs.input.validationMessage || "Unknown Error");
	
		            var validStateChanged = this._valid !== validationError;
		            this._valid = validationError;
		            if (validationError) {
		                addClass(this.refs.wrapper, "has-error");
		                if (validStateChanged) {
		                    this._invokeEventCallback("onInvalid", validationError, this.state.value, this.refs.input.value);
		                }
		            } else {
		                removeClass(this.refs.wrapper, "has-error");
		                if (validStateChanged) {
		                    this._invokeEventCallback("onValid", this.state.value, this.refs.input.value);
		                }
		            }
		        }
		    }, {
		        key: "_toNumber",
		        value: function _toNumber(x, loose) {
		            loose = loose === undefined ? this.state.inputFocus && !(this.state.btnDownActive || this.state.btnUpActive) : !!loose;
		            var n = parseFloat(x);
		            var q = Math.pow(10, this.props.precision);
		            if (isNaN(n) || !isFinite(n)) {
		                n = 0;
		            }
	
		            if (loose) {
		                return n;
		            }
	
		            n = Math.min(Math.max(n, this.props.min), this.props.max);
		            n = Math.round(n * q) / q;
	
		            return n;
		        }
		    }, {
		        key: "_parse",
		        value: function _parse(x) {
		            if (typeof this.props.parse == 'function') {
		                return parseFloat(this.props.parse(x));
		            }
		            return parseFloat(x);
		        }
		    }, {
		        key: "_format",
		        value: function _format(n) {
		            var _n = this._toNumber(n).toFixed(this.props.precision);
	
		            if (this.props.format) {
		                return this.props.format(_n);
		            }
	
		            return _n;
		        }
		    }, {
		        key: "_step",
		        value: function _step(n, callback) {
		            var _n = this._toNumber((this.state.value || 0) + this.props.step * n, false);
	
		            if (_n !== this.state.value) {
		                this.setState({ value: _n }, callback);
		                return true;
		            }
	
		            return false;
		        }
		    }, {
		        key: "_onChange",
		        value: function _onChange(e) {
		            this.setState({
		                value: this._parse(e.target.value)
		            });
		        }
		    }, {
		        key: "_onKeyDown",
		        value: function _onKeyDown() {
		            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		                args[_key2] = arguments[_key2];
		            }
	
		            args[0].persist();
		            this._invokeEventCallback.apply(this, ["onKeyDown"].concat(args));
		            var e = args[0];
		            if (!e.isDefaultPrevented()) {
		                if (e.keyCode === KEYCODE_UP) {
		                    e.preventDefault();
		                    this._step(e.ctrlKey || e.metaKey ? 0.1 : e.shiftKey ? 10 : 1);
		                } else if (e.keyCode === KEYCODE_DOWN) {
		                    e.preventDefault();
		                    this._step(e.ctrlKey || e.metaKey ? -0.1 : e.shiftKey ? -10 : -1);
		                }
		            }
		        }
		    }, {
		        key: "stop",
		        value: function stop() {
		            if (this._timer) {
		                clearTimeout(this._timer);
		            }
		        }
		    }, {
		        key: "increase",
		        value: function increase() {
		            var _this3 = this;
	
		            var _recursive = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
		            var callback = arguments[1];
	
		            this.stop();
		            this._step(1, callback);
		            if (isNaN(this.state.value) || this.state.value < this.props.max) {
		                this._timer = setTimeout(function () {
		                    _this3.increase(true);
		                }, _recursive ? NumericInput.SPEED : NumericInput.DELAY);
		            }
		        }
		    }, {
		        key: "decrease",
		        value: function decrease() {
		            var _this4 = this;
	
		            var _recursive = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
		            var callback = arguments[1];
	
		            this.stop();
		            this._step(-1, callback);
		            if (isNaN(this.state.value) || this.state.value > this.props.min) {
		                this._timer = setTimeout(function () {
		                    _this4.decrease(true);
		                }, _recursive ? NumericInput.SPEED : NumericInput.DELAY);
		            }
		        }
		    }, {
		        key: "onMouseDown",
		        value: function onMouseDown(dir, callback) {
		            if (dir == 'down') {
		                this.decrease(false, callback);
		            } else if (dir == 'up') {
		                this.increase(false, callback);
		            }
		        }
		    }, {
		        key: "onTouchStart",
		        value: function onTouchStart(dir, e) {
		            e.preventDefault();
		            if (dir == 'down') {
		                this.decrease();
		            } else if (dir == 'up') {
		                this.increase();
		            }
		        }
		    }, {
		        key: "_invokeEventCallback",
		        value: function _invokeEventCallback(callbackName) {
		            if (typeof this.props[callbackName] == "function") {
		                var _props$callbackName;
	
		                for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
		                    args[_key3 - 1] = arguments[_key3];
		                }
	
		                (_props$callbackName = this.props[callbackName]).call.apply(_props$callbackName, [null].concat(args));
		            }
		        }
		    }, {
		        key: "render",
		        value: function render() {
		            var _this5 = this;
	
		            var props = this.props;
		            var state = this.state;
		            var css = {};
	
		            var _props = this.props;
		            var step = _props.step;
		            var min = _props.min;
		            var max = _props.max;
		            var precision = _props.precision;
		            var parse = _props.parse;
		            var format = _props.format;
		            var mobile = _props.mobile;
		            var value = _props.value;
		            var type = _props.type;
		            var style = _props.style;
		            var defaultValue = _props.defaultValue;
		            var onInvalid = _props.onInvalid;
		            var onValid = _props.onValid;
	
		            var rest = _objectWithoutProperties(_props, ["step", "min", "max", "precision", "parse", "format", "mobile", "value", "type", "style", "defaultValue", "onInvalid", "onValid"]);
	
		            for (var x in NumericInput.style) {
		                css[x] = _extends({}, NumericInput.style[x], style ? style[x] || {} : {});
		            }
	
		            var hasFormControl = props.className && /\bform-control\b/.test(props.className);
	
		            if (mobile == 'auto') {
		                mobile = IS_BROWSER && 'ontouchstart' in document;
		            }
	
		            if (typeof mobile == "function") {
		                mobile = mobile.call(this);
		            }
		            mobile = !!mobile;
	
		            var attrs = {
		                wrap: {
		                    style: style === false ? null : css.wrap,
		                    className: 'react-numeric-input',
		                    ref: 'wrapper',
		                    onMouseUp: undefined,
		                    onMouseLeave: undefined
		                },
		                input: _extends({
		                    ref: 'input',
		                    type: 'text',
		                    style: style === false ? null : _extends({}, css.input, !hasFormControl ? css['input:not(.form-control)'] : {}, state.inputFocus ? css['input:focus'] : {})
		                }, rest),
		                btnUp: {
		                    onMouseEnter: undefined,
		                    onMouseDown: undefined,
		                    onMouseUp: undefined,
		                    onMouseLeave: undefined,
		                    onTouchStart: undefined,
		                    onTouchEnd: undefined,
		                    style: style === false ? null : _extends({}, css.btn, css.btnUp, props.disabled ? css['btn:disabled'] : state.btnUpActive ? css['btn:active'] : state.btnUpHover ? css['btn:hover'] : {})
		                },
		                btnDown: {
		                    onMouseEnter: undefined,
		                    onMouseDown: undefined,
		                    onMouseUp: undefined,
		                    onMouseLeave: undefined,
		                    onTouchStart: undefined,
		                    onTouchEnd: undefined,
		                    style: style === false ? null : _extends({}, css.btn, css.btnDown, props.disabled ? css['btn:disabled'] : state.btnDownActive ? css['btn:active'] : state.btnDownHover ? css['btn:hover'] : {})
		                }
		            };
	
		            if (state.value || state.value === 0) {
		                attrs.input.value = this._format(state.value);
		            } else {
		                attrs.input.value = "";
		            }
	
		            if (hasFormControl && style !== false) {
		                _extends(attrs.wrap.style, css['wrap.hasFormControl']);
		            }
	
		            if (mobile && style !== false) {
		                _extends(attrs.input.style, css['input.mobile']);
		                _extends(attrs.btnUp.style, css['btnUp.mobile']);
		                _extends(attrs.btnDown.style, css['btnDown.mobile']);
		            }
	
		            if (!props.disabled) {
		                _extends(attrs.wrap, {
		                    onMouseUp: this.stop,
		                    onMouseLeave: this.stop
		                });
	
		                _extends(attrs.btnUp, {
		                    onTouchStart: this.onTouchStart.bind(this, 'up'),
		                    onTouchEnd: this.stop,
		                    onMouseEnter: function onMouseEnter() {
		                        _this5.setState({
		                            btnUpHover: true
		                        });
		                    },
		                    onMouseLeave: function onMouseLeave() {
		                        _this5.stop();
		                        _this5.setState({
		                            btnUpHover: false,
		                            btnUpActive: false
		                        });
		                    },
		                    onMouseUp: function onMouseUp() {
		                        _this5.setState({
		                            btnUpHover: true,
		                            btnUpActive: false
		                        });
		                    },
		                    onMouseDown: function onMouseDown() {
		                        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		                            args[_key4] = arguments[_key4];
		                        }
	
		                        args[0].preventDefault();
		                        args[0].persist();
		                        _this5.setState({
		                            btnUpHover: true,
		                            btnUpActive: true,
		                            inputFocus: true
		                        }, function () {
		                            _this5._invokeEventCallback.apply(_this5, ["onFocus"].concat(args));
		                        });
		                        _this5.onMouseDown('up');
		                    }
		                });
	
		                _extends(attrs.btnDown, {
		                    onTouchStart: this.onTouchStart.bind(this, 'down'),
		                    onTouchEnd: this.stop,
		                    onMouseEnter: function onMouseEnter() {
		                        _this5.setState({
		                            btnDownHover: true
		                        });
		                    },
		                    onMouseLeave: function onMouseLeave() {
		                        _this5.stop();
		                        _this5.setState({
		                            btnDownHover: false,
		                            btnDownActive: false
		                        });
		                    },
		                    onMouseUp: function onMouseUp() {
		                        _this5.setState({
		                            btnDownHover: true,
		                            btnDownActive: false
		                        });
		                    },
		                    onMouseDown: function onMouseDown() {
		                        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
		                            args[_key5] = arguments[_key5];
		                        }
	
		                        args[0].preventDefault();
		                        args[0].persist();
		                        _this5.setState({
		                            btnDownHover: true,
		                            btnDownActive: true,
		                            inputFocus: true
		                        }, function () {
		                            _this5._invokeEventCallback.apply(_this5, ["onFocus"].concat(args));
		                        });
		                        _this5.onMouseDown('down');
		                    }
		                });
	
		                _extends(attrs.input, {
		                    onChange: function onChange(e) {
		                        var val = _this5._parse(e.target.value);
		                        if (isNaN(val)) {
		                            val = null;
		                        }
		                        _this5.setState({ value: val });
		                    },
		                    onKeyDown: this._onKeyDown.bind(this),
		                    onInput: function onInput() {
		                        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
		                            args[_key6] = arguments[_key6];
		                        }
	
		                        _this5.saveSelection();
		                        _this5._invokeEventCallback.apply(_this5, ["onInput"].concat(args));
		                    },
		                    onSelect: function onSelect() {
		                        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
		                            args[_key7] = arguments[_key7];
		                        }
	
		                        _this5.saveSelection();
		                        _this5._invokeEventCallback.apply(_this5, ["onSelect"].concat(args));
		                    },
		                    onFocus: function onFocus() {
		                        for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
		                            args[_key8] = arguments[_key8];
		                        }
	
		                        args[0].persist();
		                        _this5.setState({ inputFocus: true }, function () {
		                            _this5.setState({
		                                value: _this5._parse(args[0].target.value)
		                            }, function () {
		                                _this5._invokeEventCallback.apply(_this5, ["onFocus"].concat(args));
		                            });
		                        });
		                    },
		                    onBlur: function onBlur() {
		                        for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
		                            args[_key9] = arguments[_key9];
		                        }
	
		                        args[0].persist();
		                        _this5.setState({ inputFocus: false }, function () {
		                            _this5.setState({
		                                value: _this5._parse(args[0].target.value)
		                            }, function () {
		                                _this5._invokeEventCallback.apply(_this5, ["onBlur"].concat(args));
		                            });
		                        });
		                    }
		                });
		            } else {
		                if (style !== false) {
		                    _extends(attrs.input.style, css['input:disabled']);
		                }
		            }
	
		            if (mobile) {
		                return _react2.default.createElement(
		                    "span",
		                    attrs.wrap,
		                    _react2.default.createElement("input", attrs.input),
		                    _react2.default.createElement(
		                        "b",
		                        attrs.btnUp,
		                        _react2.default.createElement("i", { style: style === false ? null : css.minus }),
		                        _react2.default.createElement("i", { style: style === false ? null : css.plus })
		                    ),
		                    _react2.default.createElement(
		                        "b",
		                        attrs.btnDown,
		                        _react2.default.createElement("i", { style: style === false ? null : css.minus })
		                    )
		                );
		            }
	
		            return _react2.default.createElement(
		                "span",
		                attrs.wrap,
		                _react2.default.createElement("input", attrs.input),
		                _react2.default.createElement(
		                    "b",
		                    attrs.btnUp,
		                    _react2.default.createElement("i", { style: style === false ? null : css.arrowUp })
		                ),
		                _react2.default.createElement(
		                    "b",
		                    attrs.btnDown,
		                    _react2.default.createElement("i", { style: style === false ? null : css.arrowDown })
		                )
		            );
		        }
		    }]);
	
		    return NumericInput;
		}(_react.Component);
	
		NumericInput.propTypes = {
		    step: _react.PropTypes.number,
		    min: _react.PropTypes.number,
		    max: _react.PropTypes.number,
		    precision: _react.PropTypes.number,
		    maxLength: _react.PropTypes.number,
		    parse: _react.PropTypes.func,
		    format: _react.PropTypes.func,
		    className: _react.PropTypes.string,
		    disabled: _react.PropTypes.bool,
		    readOnly: _react.PropTypes.bool,
		    required: _react.PropTypes.bool,
		    noValidate: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.string]),
		    style: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.bool]),
		    type: _react.PropTypes.string,
		    pattern: _react.PropTypes.string,
		    onFocus: _react.PropTypes.func,
		    onBlur: _react.PropTypes.func,
		    onKeyDown: _react.PropTypes.func,
		    onChange: _react.PropTypes.func,
		    onInvalid: _react.PropTypes.func,
		    onValid: _react.PropTypes.func,
		    onInput: _react.PropTypes.func,
		    onSelect: _react.PropTypes.func,
		    size: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
		    value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
		    defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
		    mobile: function mobile(props, propName) {
		        var prop = props[propName];
		        if (prop !== true && prop !== false && prop !== 'auto' && typeof prop != 'function') {
		            return new Error('The "mobile" prop must be true, false, "auto" or a function');
		        }
		    }
		};
		NumericInput.defaultProps = {
		    step: 1,
		    min: Number.MIN_SAFE_INTEGER || -9007199254740991,
		    max: Number.MAX_SAFE_INTEGER || 9007199254740991,
		    precision: 0,
		    parse: null,
		    format: null,
		    mobile: 'auto',
		    style: {}
		};
		NumericInput.style = {
		    wrap: {
		        position: 'relative',
		        display: 'inline-block'
		    },
	
		    'wrap.hasFormControl': {
		        display: 'block'
		    },
	
		    arrowUp: {
		        position: 'absolute',
		        top: '50%',
		        left: '50%',
		        width: 0,
		        height: 0,
		        borderWidth: '0 0.6ex 0.6ex 0.6ex',
		        borderColor: 'transparent transparent rgba(0, 0, 0, 0.7)',
		        borderStyle: 'solid',
		        margin: '-0.3ex 0 0 -0.56ex'
		    },
	
		    arrowDown: {
		        position: 'absolute',
		        top: '50%',
		        left: '50%',
		        width: 0,
		        height: 0,
		        borderWidth: '0.6ex 0.6ex 0 0.6ex',
		        borderColor: 'rgba(0, 0, 0, 0.7) transparent transparent',
		        borderStyle: 'solid',
		        margin: '-0.3ex 0 0 -0.56ex'
		    },
	
		    plus: {
		        position: 'absolute',
		        top: '50%',
		        left: '50%',
		        width: 2,
		        height: 10,
		        background: 'rgba(0,0,0,.7)',
		        margin: '-5px 0 0 -1px'
		    },
	
		    minus: {
		        position: 'absolute',
		        top: '50%',
		        left: '50%',
		        width: 10,
		        height: 2,
		        background: 'rgba(0,0,0,.7)',
		        margin: '-1px 0 0 -5px'
		    },
	
		    btn: {
		        position: 'absolute',
		        right: 2,
		        width: '2.26ex',
		        borderColor: 'rgba(0,0,0,.1)',
		        borderStyle: 'solid',
		        textAlign: 'center',
		        cursor: 'default',
		        transition: 'all 0.1s',
		        background: 'rgba(0,0,0,.1)',
		        boxShadow: "-1px -1px 3px rgba(0,0,0,.1) inset,\n                1px 1px 3px rgba(255,255,255,.7) inset"
		    },
	
		    btnUp: {
		        top: 2,
		        bottom: '50%',
		        borderRadius: '2px 2px 0 0',
		        borderWidth: '1px 1px 0 1px'
		    },
	
		    'btnUp.mobile': {
		        width: '3.3ex',
		        bottom: 2,
		        boxShadow: 'none',
		        borderRadius: 2,
		        borderWidth: 1
		    },
	
		    btnDown: {
		        top: '50%',
		        bottom: 2,
		        borderRadius: '0 0 2px 2px',
		        borderWidth: '0 1px 1px 1px'
		    },
	
		    'btnDown.mobile': {
		        width: '3.3ex',
		        bottom: 2,
		        left: 2,
		        top: 2,
		        right: 'auto',
		        boxShadow: 'none',
		        borderRadius: 2,
		        borderWidth: 1
		    },
	
		    'btn:hover': {
		        background: 'rgba(0,0,0,.2)'
		    },
	
		    'btn:active': {
		        background: 'rgba(0,0,0,.3)',
		        boxShadow: "0 1px 3px rgba(0,0,0,.2) inset,\n                -1px -1px 4px rgba(255,255,255,.5) inset"
		    },
	
		    'btn:disabled': {
		        opacity: 0.5,
		        boxShadow: 'none',
		        cursor: 'not-allowed'
		    },
	
		    input: {
		        paddingRight: '3ex',
		        boxSizing: 'border-box'
		    },
	
		    'input:not(.form-control)': {
		        border: '1px solid #ccc',
		        borderRadius: 2,
		        paddingLeft: 4,
		        display: 'block',
		        WebkitAppearance: 'none',
		        lineHeight: 'normal'
		    },
	
		    'input.mobile': {
		        paddingLeft: ' 3.4ex',
		        paddingRight: '3.4ex',
		        textAlign: 'center'
		    },
	
		    'input:focus': {},
	
		    'input:disabled': {
		        color: 'rgba(0, 0, 0, 0.3)',
		        textShadow: '0 1px 0 rgba(255, 255, 255, 0.8)'
		    }
		};
		NumericInput.SPEED = 50;
		NumericInput.DELAY = 500;
	
		module.exports = NumericInput;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ }
	/******/ ]);

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(76);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));
	
	    _this.state = { active: false };
	    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    _this.portal = null;
	    _this.node = null;
	    return _this;
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('mouseup', this.handleOutsideMouseClick);
	        document.addEventListener('touchstart', this.handleOutsideMouseClick);
	      }
	
	      if (this.props.isOpened) {
	        this.openPortal();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      // portal's 'is open' state is handled through the prop isOpened
	      if (typeof newProps.isOpened !== 'undefined') {
	        if (newProps.isOpened) {
	          if (this.state.active) {
	            this.renderPortal(newProps);
	          } else {
	            this.openPortal(newProps);
	          }
	        }
	        if (!newProps.isOpened && this.state.active) {
	          this.closePortal();
	        }
	      }
	
	      // portal handles its own 'is open' state
	      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
	        this.renderPortal(newProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
	        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
	      }
	
	      this.closePortal(true);
	    }
	  }, {
	    key: 'handleWrapperClick',
	    value: function handleWrapperClick(e) {
	      e.preventDefault();
	      e.stopPropagation();
	      if (this.state.active) {
	        return;
	      }
	      this.openPortal();
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      this.setState({ active: true });
	      this.renderPortal(props);
	      this.props.onOpen(this.node);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      var _this2 = this;
	
	      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var resetPortalState = function resetPortalState(overrideIsUnmounted) {
	        if (_this2.node) {
	          _reactDom2.default.unmountComponentAtNode(_this2.node);
	          document.body.removeChild(_this2.node);
	        }
	        _this2.portal = null;
	        _this2.node = null;
	
	        var finalIsUnmounted = overrideIsUnmounted === undefined ? isUnmounted : overrideIsUnmounted;
	
	        if (finalIsUnmounted !== true) {
	          _this2.setState({ active: false });
	        }
	      };
	
	      if (this.state.active) {
	        if (this.props.beforeClose) {
	          this.props.beforeClose(this.node, resetPortalState);
	        } else {
	          resetPortalState();
	        }
	
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	
	      var root = (0, _reactDom.findDOMNode)(this.portal);
	      if (root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	
	      e.stopPropagation();
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.node) {
	        this.node = document.createElement('div');
	        document.body.appendChild(this.node);
	      }
	
	      var children = props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof props.children.type === 'function') {
	        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.openByClickOn) {
	        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
	      }
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.element.isRequired,
	  openByClickOn: _propTypes2.default.element,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  isOpened: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  beforeClose: _propTypes2.default.func,
	  onUpdate: _propTypes2.default.func
	};
	
	Portal.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {},
	  onUpdate: function onUpdate() {}
	};
	module.exports = exports['default'];


/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Quill = __webpack_require__(1429);
	
	var QuillMixin = {
	
		/**
		Creates an editor on the given element. The editor will
		be passed the configuration, have its events bound,
		*/
		createEditor: function($el, config) {
			var editor = new Quill($el, config);
			this.hookEditor(editor);
			return editor;
		},
	
		hookEditor: function(editor) {
			// Expose the editor on change events via a weaker,
			// unprivileged proxy object that does not allow
			// accidentally modifying editor state.
			var unprivilegedEditor = this.makeUnprivilegedEditor(editor);
	
			this.handleTextChange = function(delta, oldDelta, source) {
				if (this.onEditorChangeText) {
					this.onEditorChangeText(
						editor.root.innerHTML, delta, source,
						unprivilegedEditor
					);
					this.onEditorChangeSelection(
						editor.getSelection(), source,
						unprivilegedEditor
					);
				}
			}.bind(this);
	
			this.handleSelectionChange = function(range, oldRange, source) {
				if (this.onEditorChangeSelection) {
					this.onEditorChangeSelection(
						range, source,
						unprivilegedEditor
					);
				}
			}.bind(this);
	
			editor.on('text-change', this.handleTextChange);
			editor.on('selection-change', this.handleSelectionChange);
		},
	
		unhookEditor: function(editor) {
			editor.off('selection-change');
			editor.off('text-change');
		},
	
		setEditorReadOnly: function(editor, value) {
			value? editor.disable()
			     : editor.enable();
		},
	
		/*
		Replace the contents of the editor, but keep
		the previous selection hanging around so that
		the cursor won't move.
		*/
		setEditorContents: function(editor, value) {
			var sel = editor.getSelection();
			
			if (typeof value === 'string') {
				editor.clipboard.dangerouslyPasteHTML(value);
			} else {
				editor.setContents(value);
			}
	
			if (sel) this.setEditorSelection(editor, sel);
		},
	
		setEditorSelection: function(editor, range) {
			if (range) {
				// Validate bounds before applying.
				var length = editor.getLength();
				range.index = Math.max(0, Math.min(range.index, length-1));
				range.length = Math.max(0, Math.min(range.length, (length-1) - range.index));
			}
			editor.setSelection(range);
		},
	
		/*
		Returns an weaker, unprivileged proxy object that only
		exposes read-only accessors found on the editor instance,
		without any state-modificating methods.
		*/
		makeUnprivilegedEditor: function(editor) {
			var e = editor;
			return {
				getLength:    function(){ return e.getLength.apply(e, arguments); },
				getText:      function(){ return e.getText.apply(e, arguments); },
				getHTML:      function(){ return e.root.innerHTML },
				getContents:  function(){ return e.getContents.apply(e, arguments); },
				getSelection: function(){ return e.getSelection.apply(e, arguments); },
				getBounds:    function(){ return e.getBounds.apply(e, arguments); },
			};
		}
	
	};
	
	module.exports = QuillMixin;


/***/ },
/* 1536 */
[4196, 456, 3460, 3461, 3462, 3463, 3464],
/* 1537 */
980,
/* 1538 */
[4219, 1539, 461],
/* 1539 */
[4253, 157, 737, 3465, 3478],
/* 1540 */
[4286, 3391, 1537, 3418],
/* 1541 */
1003,
/* 1542 */
[4314, 325],
/* 1543 */
1011,
/* 1544 */
1020,
/* 1545 */
[4357, 3422, 3466],
/* 1546 */
[4394, 3404, 326],
/* 1547 */
[4398, 156, 3474],
/* 1548 */
[4400, 734],
/* 1549 */
[4402, 324, 325],
/* 1550 */
[4409, 3408, 3417, 3454],
/* 1551 */
[4449, 3479],
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 1553 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 1554 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(1556);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(1554);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(3486);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(3485);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ },
/* 1556 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	
	  var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var type = _ref.type;
	  var payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(741);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(183);
	
	var _PatternUtils = __webpack_require__(262);
	
	var _InternalPropTypes = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(466);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(421);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(1287);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(2931);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(1563);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(466);
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(421);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(1287);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1564 */
/***/ function(module, exports) {

	/*
	 * Tell the browser that the event listener won't prevent a scroll.
	 * Allowing the browser to continue scrolling without having to
	 * to wait for the listener to return.
	 */
	var addPassiveEventListener = function(target, eventName, listener) {
	    var supportsPassiveOption = (function(){
	        var supportsPassiveOption = false;
	        try {
	            var opts = Object.defineProperty({}, 'passive', {
	                get: function() {
	                    supportsPassiveOption = true;
	                }
	            });
	            window.addEventListener('test', null, opts);
	        } catch (e) {}
	        return supportsPassiveOption;
	    })();
	
	    target.addEventListener(eventName, listener, supportsPassiveOption ? {passive: true} : false);
	};
	
	module.exports = addPassiveEventListener;


/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	var addPassiveEventListener = __webpack_require__(1564);
	
	var eventThrottler = function(eventHandler) {
	  var eventHandlerTimeout;
	  return function(event) {
	    // ignore events as long as an eventHandler execution is in the queue
	    if ( !eventHandlerTimeout ) {
	      eventHandlerTimeout = setTimeout(function() {
	        eventHandlerTimeout = null;
	        eventHandler(event);
	        // The eventHandler will execute at a rate of 15fps
	      }, 66);
	    }
	  };
	};
	
	var scrollSpy = {
	
	  spyCallbacks: [],
	  spySetState: [],
	  scrollSpyContainers: [],
	
	  mount: function (scrollSpyContainer) {
	    var t = this;
	    if (scrollSpyContainer) {
	      var eventHandler = eventThrottler(function(event) {
	        t.scrollHandler(scrollSpyContainer);
	      });
	      this.scrollSpyContainers.push(scrollSpyContainer);
	      addPassiveEventListener(scrollSpyContainer, 'scroll', eventHandler);
	    }
	  },
	
	  isMounted: function (scrollSpyContainer) {
	    return this.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
	  },
	
	  currentPositionY: function (scrollSpyContainer) {
	    if(scrollSpyContainer === document) {
	      var supportPageOffset = window.pageXOffset !== undefined;
	      var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
	      return supportPageOffset ? window.pageYOffset : isCSS1Compat ?
	      document.documentElement.scrollTop : document.body.scrollTop;
	    } else {
	      return scrollSpyContainer.scrollTop;
	    }
	  },
	
	  scrollHandler: function (scrollSpyContainer) {
	    var callbacks = this.scrollSpyContainers[this.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks;
	    if (callbacks) {
	      for(var i = 0; i < callbacks.length; i++) {
	        var position =this.currentPositionY(scrollSpyContainer);
	        callbacks[i](this.currentPositionY(scrollSpyContainer));
	      }
	    }
	  },
	
	  addStateHandler: function(handler){
	    this.spySetState.push(handler);
	  },
	
	  addSpyHandler: function(handler, scrollSpyContainer) {
	    var container = this.scrollSpyContainers[this.scrollSpyContainers.indexOf(scrollSpyContainer)];
	    if(!container.spyCallbacks) {
	      container.spyCallbacks = [];
	    }
	    container.spyCallbacks.push(handler);
	  },
	
	  updateStates: function(){
	    var length = this.spySetState.length;
	
	    for(var i = 0; i < length; i++) {
	      this.spySetState[i]();
	    }
	  },
	
	  unmount: function (stateHandler, spyHandler) {
	    for (var i = 0; i < this.scrollSpyContainers.length; i++) {
	      var callbacks = this.scrollSpyContainers[i].spyCallbacks;
	      if(callbacks && callbacks.length) {
	        callbacks.splice(callbacks.indexOf(spyHandler), 1);
	      }
	    }
	
	    if(this.spySetState && this.spySetState.length) {
	      this.spySetState.splice(this.spySetState.indexOf(stateHandler), 1);
	    }
	
	    document.removeEventListener('scroll', this.scrollHandler);
	  },
	
	  update: function() {
	    for (var i = 0; i < this.scrollSpyContainers.length; i++) {
	      this.scrollHandler(this.scrollSpyContainers[i]);
	    }
	  }
	}
	
	module.exports = scrollSpy;


/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	var assign = __webpack_require__(45);
	
	var animateScroll = __webpack_require__(743);
	var events = __webpack_require__(744);
	
	var __mapped = {};
	var __activeLink;
	
	module.exports = {
	
	  unmount: function() {
	    __mapped = {};
	  },
	
	  register: function(name, element){
	    __mapped[name] = element;
	  },
	
	  unregister: function(name) {
	    delete __mapped[name];
	  },
	
	  get: function(name) {
	    return __mapped[name] || document.getElementById(name);
	  },
	
	  setActiveLink: function(link) {
	    __activeLink = link;
	  },
	
	  getActiveLink: function() {
	    return __activeLink;
	  },
	
	  scrollTo: function(to, props) {
	
	     /*
	     * get the mapped DOM element
	     */
	
	      var target = this.get(to);
	
	      if(!target) {
	        console.warn("target Element not found");
	        return;
	      }
	
	      props = assign({}, props, { absolute : false });
	
	
	      if(events.registered['begin']) {
	        events.registered['begin'](to, target);
	      }
	
	      var containerId = props.containerId;
	      var containerElement = containerId ? document.getElementById(containerId) : null;
	
	      var scrollOffset;
	
	      if(containerId && containerElement) {
	        props.absolute = true;
	        if(containerElement !== target.offsetParent) {
	          if(!containerElement.contains(target)) {
	            throw new Error('Container with ID ' + containerId + ' is not a parent of target ' + to);
	          } else {
	            throw new Error('Container with ID ' + containerId + ' is not a positioned element');
	          }
	        }
	
	        scrollOffset = target.offsetTop;
	      } else {
	        var coordinates = target.getBoundingClientRect();
	        scrollOffset = coordinates.top;
	      }
	
	      scrollOffset += (props.offset || 0);
	
	
	      /*
	       * if animate is not provided just scroll into the view
	       */
	      if(!props.smooth) {
	        if(containerId && containerElement) {
	          containerElement.scrollTop = scrollOffset;
	        } else {
	          // window.scrollTo accepts only absolute values so body rectangle needs to be subtracted
	          var bodyRect = document.body.getBoundingClientRect();
	          window.scrollTo(0, scrollOffset - bodyRect.top);
	        }
	
	        if(events.registered['end']) {
	          events.registered['end'](to, target);
	        }
	
	        return;
	      }
	
	      /*
	       * Animate scrolling
	       */
	
	      animateScroll.animateTopScroll(scrollOffset, props, to, target);
	  }
	};


/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stripDiacritics = __webpack_require__(1569);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function filterOptions(options, filterValue, excludeOptions, props) {
		var _this = this;
	
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2['default'])(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
			if (!filterValue) return true;
			var valueTest = String(option[props.valueKey]);
			var labelTest = String(option[props.labelKey]);
			if (props.ignoreAccents) {
				if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
				if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
			}
			if (props.ignoreCase) {
				if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
			return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	}
	
	module.exports = filterOptions;

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption;
		var instancePrefix = _ref.instancePrefix;
		var labelKey = _ref.labelKey;
		var onFocus = _ref.onFocus;
		var onSelect = _ref.onSelect;
		var optionClassName = _ref.optionClassName;
		var optionComponent = _ref.optionComponent;
		var optionRenderer = _ref.optionRenderer;
		var options = _ref.options;
		var valueArray = _ref.valueArray;
		var valueKey = _ref.valueKey;
		var onOptionRef = _ref.onOptionRef;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.indexOf(option) > -1;
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2['default'])(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2['default'].createElement(
				Option,
				{
					className: optionClass,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function (ref) {
						onOptionRef(ref, isFocused);
					}
				},
				optionRenderer(option, i)
			);
		});
	}
	
	module.exports = menuRenderer;

/***/ },
/* 1569 */
/***/ function(module, exports) {

	'use strict';
	
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	module.exports = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toast = exports.ToastContainer = undefined;
	
	var _ToastContainer = __webpack_require__(3540);
	
	var _ToastContainer2 = _interopRequireDefault(_ToastContainer);
	
	var _toastify = __webpack_require__(3541);
	
	var _toastify2 = _interopRequireDefault(_toastify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ToastContainer = _ToastContainer2.default;
	exports.toast = _toastify2.default;

/***/ },
/* 1571 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var eventManager = {
	  eventList: new Map(),
	
	  on: function on(event, callback) {
	    this.eventList.has(event) || this.eventList.set(event, []);
	
	    this.eventList.get(event).push(callback);
	
	    return this;
	  },
	  off: function off() {
	    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    return this.eventList.delete(event);
	  },
	  emit: function emit(event) {
	    var _this = this;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (!this.eventList.has(event)) {
	      /* eslint no-console: 0 */
	      console.warn("<" + event + "> Event is not registered. Did you forgot to bind the event ?");
	      return false;
	    }
	
	    this.eventList.get(event).forEach(function (callback) {
	      return setTimeout(function () {
	        return callback.call.apply(callback, [_this].concat(_toConsumableArray(args)));
	      }, 0);
	    });
	
	    return true;
	  }
	};
	
	exports.default = eventManager;

/***/ },
/* 1572 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (obj) {
	  var values = [];
	  Object.keys(obj).forEach(function (key) {
	    return values.push(obj[key]);
	  });
	  return values;
	};

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.falseOrElement = exports.falseOrNumber = undefined;
	exports.typeOf = typeOf;
	exports.isValidDelay = isValidDelay;
	
	var _react = __webpack_require__(1);
	
	function typeOf(obj) {
	  return Object.prototype.toString.call(obj).slice(8, -1);
	}
	
	function isValidDelay(val) {
	  return typeOf(val) === 'Number' && !isNaN(val) && val > 0;
	}
	
	function withRequired(fn) {
	  fn.isRequired = function (props, propName, componentName) {
	    var prop = props[propName];
	
	    if (typeof prop === 'undefined') {
	      return new Error('The prop ' + propName + ' is marked as required in \n      ' + componentName + ', but its value is undefined.');
	    }
	
	    fn(props, propName, componentName);
	  };
	  return fn;
	}
	
	/**
	 * TODO: Maybe rethink about the name
	 */
	var falseOrNumber = exports.falseOrNumber = withRequired(function (props, propName, componentName) {
	  var prop = props[propName];
	
	  if (prop !== false && !isValidDelay(prop)) {
	    return new Error(componentName + ' expect ' + propName + ' \n      to be a valid Number > 0 or equal to false. ' + prop + ' given.');
	  }
	
	  return null;
	});
	
	var falseOrElement = exports.falseOrElement = withRequired(function (props, propName, componentName) {
	  var prop = props[propName];
	
	  if (prop !== false && !(0, _react.isValidElement)(prop)) {
	    return new Error(componentName + ' expect ' + propName + ' \n      to be a valid react element or equal to false. ' + prop + ' given.');
	  }
	
	  return null;
	});

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ReactTypeformEmbed = __webpack_require__(3545);
	
	Object.defineProperty(exports, 'ReactTypeformEmbed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ReactTypeformEmbed).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1575 */
[4192, 3590, 3591, 3592, 3593, 3594],
/* 1576 */
[4286, 3550, 3557, 3567],
/* 1577 */
1003,
/* 1578 */
1020,
/* 1579 */
303,
/* 1580 */
[4398, 158, 3613],
/* 1581 */
[4402, 472, 1583],
/* 1582 */
626,
/* 1583 */
96,
/* 1584 */
[4409, 3563, 3566, 3597],
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(265);
	
	var ReactCurrentOwner = __webpack_require__(159);
	
	var invariant = __webpack_require__(36);
	var warning = __webpack_require__(41);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 1586 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 1589 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _es6Error = __webpack_require__(2905);
	
	var _es6Error2 = _interopRequireDefault(_es6Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubmissionError = function (_ExtendableError) {
	  _inherits(SubmissionError, _ExtendableError);
	
	  function SubmissionError(errors) {
	    _classCallCheck(this, SubmissionError);
	
	    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));
	
	    _this.errors = errors;
	    return _this;
	  }
	
	  return SubmissionError;
	}(_es6Error2.default);
	
	exports.default = SubmissionError;

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateSyncWarnings = exports.updateSyncErrors = exports.untouch = exports.unregisterField = exports.touch = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearAsyncError = exports.clearSubmitErrors = exports.clearSubmit = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actionTypes = __webpack_require__(751);
	
	var arrayInsert = exports.arrayInsert = function arrayInsert(form, field, index, value) {
	  return { type: _actionTypes.ARRAY_INSERT, meta: { form: form, field: field, index: index }, payload: value };
	};
	
	var arrayMove = exports.arrayMove = function arrayMove(form, field, from, to) {
	  return { type: _actionTypes.ARRAY_MOVE, meta: { form: form, field: field, from: from, to: to } };
	};
	
	var arrayPop = exports.arrayPop = function arrayPop(form, field) {
	  return { type: _actionTypes.ARRAY_POP, meta: { form: form, field: field } };
	};
	
	var arrayPush = exports.arrayPush = function arrayPush(form, field, value) {
	  return { type: _actionTypes.ARRAY_PUSH, meta: { form: form, field: field }, payload: value };
	};
	
	var arrayRemove = exports.arrayRemove = function arrayRemove(form, field, index) {
	  return { type: _actionTypes.ARRAY_REMOVE, meta: { form: form, field: field, index: index } };
	};
	
	var arrayRemoveAll = exports.arrayRemoveAll = function arrayRemoveAll(form, field) {
	  return { type: _actionTypes.ARRAY_REMOVE_ALL, meta: { form: form, field: field } };
	};
	
	var arrayShift = exports.arrayShift = function arrayShift(form, field) {
	  return { type: _actionTypes.ARRAY_SHIFT, meta: { form: form, field: field } };
	};
	
	var arraySplice = exports.arraySplice = function arraySplice(form, field, index, removeNum, value) {
	  var action = {
	    type: _actionTypes.ARRAY_SPLICE,
	    meta: { form: form, field: field, index: index, removeNum: removeNum }
	  };
	  if (value !== undefined) {
	    action.payload = value;
	  }
	  return action;
	};
	
	var arraySwap = exports.arraySwap = function arraySwap(form, field, indexA, indexB) {
	  if (indexA === indexB) {
	    throw new Error('Swap indices cannot be equal');
	  }
	  if (indexA < 0 || indexB < 0) {
	    throw new Error('Swap indices cannot be negative');
	  }
	  return { type: _actionTypes.ARRAY_SWAP, meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
	};
	
	var arrayUnshift = exports.arrayUnshift = function arrayUnshift(form, field, value) {
	  return { type: _actionTypes.ARRAY_UNSHIFT, meta: { form: form, field: field }, payload: value };
	};
	
	var autofill = exports.autofill = function autofill(form, field, value) {
	  return { type: _actionTypes.AUTOFILL, meta: { form: form, field: field }, payload: value };
	};
	
	var blur = exports.blur = function blur(form, field, value, touch) {
	  return { type: _actionTypes.BLUR, meta: { form: form, field: field, touch: touch }, payload: value };
	};
	
	var change = exports.change = function change(form, field, value, touch, persistentSubmitErrors) {
	  return { type: _actionTypes.CHANGE, meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors }, payload: value };
	};
	
	var clearSubmit = exports.clearSubmit = function clearSubmit(form) {
	  return { type: _actionTypes.CLEAR_SUBMIT, meta: { form: form } };
	};
	
	var clearSubmitErrors = exports.clearSubmitErrors = function clearSubmitErrors(form) {
	  return { type: _actionTypes.CLEAR_SUBMIT_ERRORS, meta: { form: form } };
	};
	
	var clearAsyncError = exports.clearAsyncError = function clearAsyncError(form, field) {
	  return { type: _actionTypes.CLEAR_ASYNC_ERROR, meta: { form: form, field: field } };
	};
	
	var destroy = exports.destroy = function destroy() {
	  for (var _len = arguments.length, form = Array(_len), _key = 0; _key < _len; _key++) {
	    form[_key] = arguments[_key];
	  }
	
	  return { type: _actionTypes.DESTROY, meta: { form: form } };
	};
	
	var focus = exports.focus = function focus(form, field) {
	  return { type: _actionTypes.FOCUS, meta: { form: form, field: field } };
	};
	
	var initialize = exports.initialize = function initialize(form, values, keepDirty) {
	  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  if (keepDirty instanceof Object) {
	    otherMeta = keepDirty;
	    keepDirty = false;
	  }
	  return { type: _actionTypes.INITIALIZE, meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta), payload: values };
	};
	
	var registerField = exports.registerField = function registerField(form, name, type) {
	  return { type: _actionTypes.REGISTER_FIELD, meta: { form: form }, payload: { name: name, type: type } };
	};
	
	var reset = exports.reset = function reset(form) {
	  return { type: _actionTypes.RESET, meta: { form: form } };
	};
	
	var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(form, field) {
	  return { type: _actionTypes.START_ASYNC_VALIDATION, meta: { form: form, field: field } };
	};
	
	var startSubmit = exports.startSubmit = function startSubmit(form) {
	  return { type: _actionTypes.START_SUBMIT, meta: { form: form } };
	};
	
	var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(form, errors) {
	  var action = {
	    type: _actionTypes.STOP_ASYNC_VALIDATION,
	    meta: { form: form },
	    payload: errors
	  };
	  if (errors && Object.keys(errors).length) {
	    action.error = true;
	  }
	  return action;
	};
	
	var stopSubmit = exports.stopSubmit = function stopSubmit(form, errors) {
	  var action = {
	    type: _actionTypes.STOP_SUBMIT,
	    meta: { form: form },
	    payload: errors
	  };
	  if (errors && Object.keys(errors).length) {
	    action.error = true;
	  }
	  return action;
	};
	
	var submit = exports.submit = function submit(form) {
	  return { type: _actionTypes.SUBMIT, meta: { form: form } };
	};
	
	var setSubmitFailed = exports.setSubmitFailed = function setSubmitFailed(form) {
	  for (var _len2 = arguments.length, fields = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    fields[_key2 - 1] = arguments[_key2];
	  }
	
	  return { type: _actionTypes.SET_SUBMIT_FAILED, meta: { form: form, fields: fields }, error: true };
	};
	
	var setSubmitSucceeded = exports.setSubmitSucceeded = function setSubmitSucceeded(form) {
	  for (var _len3 = arguments.length, fields = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    fields[_key3 - 1] = arguments[_key3];
	  }
	
	  return { type: _actionTypes.SET_SUBMIT_SUCCEEDED, meta: { form: form, fields: fields }, error: false };
	};
	
	var touch = exports.touch = function touch(form) {
	  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    fields[_key4 - 1] = arguments[_key4];
	  }
	
	  return { type: _actionTypes.TOUCH, meta: { form: form, fields: fields } };
	};
	
	var unregisterField = exports.unregisterField = function unregisterField(form, name) {
	  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  return { type: _actionTypes.UNREGISTER_FIELD, meta: { form: form }, payload: { name: name, destroyOnUnmount: destroyOnUnmount } };
	};
	
	var untouch = exports.untouch = function untouch(form) {
	  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    fields[_key5 - 1] = arguments[_key5];
	  }
	
	  return { type: _actionTypes.UNTOUCH, meta: { form: form, fields: fields } };
	};
	
	var updateSyncErrors = exports.updateSyncErrors = function updateSyncErrors(form) {
	  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var error = arguments[2];
	  return { type: _actionTypes.UPDATE_SYNC_ERRORS, meta: { form: form }, payload: { syncErrors: syncErrors, error: error } };
	};
	
	var updateSyncWarnings = exports.updateSyncWarnings = function updateSyncWarnings(form) {
	  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var warning = arguments[2];
	  return { type: _actionTypes.UPDATE_SYNC_WARNINGS, meta: { form: form }, payload: { syncWarnings: syncWarnings, warning: warning } };
	};

/***/ },
/* 1592 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var processProps = function processProps(type, props, _value) {
	  var value = props.value;
	
	  if (type === 'checkbox') {
	    return _extends({}, props, {
	      checked: !!value
	    });
	  }
	  if (type === 'radio') {
	    return _extends({}, props, {
	      checked: value === _value,
	      value: _value
	    });
	  }
	  if (type === 'select-multiple') {
	    return _extends({}, props, {
	      value: value || []
	    });
	  }
	  if (type === 'file') {
	    return _extends({}, props, {
	      value: value || undefined
	    });
	  }
	  return props;
	};
	
	var createFieldProps = function createFieldProps(_ref2, name, _ref) {
	  var getIn = _ref2.getIn,
	      toJS = _ref2.toJS;
	
	  var asyncError = _ref.asyncError,
	      asyncValidating = _ref.asyncValidating,
	      onBlur = _ref.onBlur,
	      onChange = _ref.onChange,
	      onDrop = _ref.onDrop,
	      onDragStart = _ref.onDragStart,
	      dirty = _ref.dirty,
	      dispatch = _ref.dispatch,
	      onFocus = _ref.onFocus,
	      form = _ref.form,
	      format = _ref.format,
	      parse = _ref.parse,
	      pristine = _ref.pristine,
	      props = _ref.props,
	      state = _ref.state,
	      submitError = _ref.submitError,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      validate = _ref.validate,
	      value = _ref.value,
	      _value = _ref._value,
	      warn = _ref.warn,
	      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	
	  var formatFieldValue = function formatFieldValue(value, format) {
	    if (format === null) {
	      return value;
	    }
	    var defaultFormattedValue = value == null ? '' : value;
	    return format ? format(value, name) : defaultFormattedValue;
	  };
	
	  var formattedFieldValue = formatFieldValue(value, format);
	
	  return {
	    input: processProps(custom.type, {
	      name: name,
	      onBlur: onBlur,
	      onChange: onChange,
	      onDragStart: onDragStart,
	      onDrop: onDrop,
	      onFocus: onFocus,
	      value: formattedFieldValue
	    }, _value),
	    meta: _extends({}, toJS(state), {
	      active: !!(state && getIn(state, 'active')),
	      asyncValidating: asyncValidating,
	      autofilled: !!(state && getIn(state, 'autofilled')),
	      dirty: dirty,
	      dispatch: dispatch,
	      error: error,
	      form: form,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: !!submitting,
	      submitFailed: !!submitFailed,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error,
	      visited: !!(state && getIn(state, 'visited'))
	    }),
	    custom: _extends({}, custom, props)
	  };
	};
	
	exports.default = createFieldProps;

/***/ },
/* 1593 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getValue = __webpack_require__(3648);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _isReactNative = __webpack_require__(3655);
	
	var _isReactNative2 = _interopRequireDefault(_isReactNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onChangeValue = function onChangeValue(event, _ref) {
	  var name = _ref.name,
	      parse = _ref.parse,
	      normalize = _ref.normalize;
	
	  // read value from input
	  var value = (0, _getValue2.default)(event, _isReactNative2.default);
	
	  // parse value if we have a parser
	  if (parse) {
	    value = parse(value, name);
	  }
	
	  // normalize value
	  if (normalize) {
	    value = normalize(name, value);
	  }
	
	  return value;
	};
	
	exports.default = onChangeValue;

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(1593);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	
	exports.default = silenceEvent;

/***/ },
/* 1596 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsPristine = function createIsPristine(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      var initial = getIn(formState, form + '.initial') || empty;
	      var values = getIn(formState, form + '.values') || initial;
	      return deepEqual(initial, values);
	    };
	  };
	};
	
	exports.default = createIsPristine;

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(267);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIn = function getIn(state, field) {
	  if (!state) {
	    return state;
	  }
	
	  var path = (0, _toPath3.default)(field);
	  var length = path.length;
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	  for (var i = 0; i < length && !!result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	exports.default = getIn;

/***/ },
/* 1598 */
[4198, 138],
/* 1599 */
[4201, 3715, 762, 139, 763, 758, 767],
/* 1600 */
148,
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(480),
	    eq = __webpack_require__(331);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 1602 */
[4217, 3725],
/* 1603 */
[4219, 1604, 330],
/* 1604 */
[4253, 139, 759, 1614, 1618],
/* 1605 */
393,
/* 1606 */
[4285, 218],
/* 1607 */
[4286, 3688, 3693, 3718],
/* 1608 */
1003,
/* 1609 */
[4297, 1612],
/* 1610 */
[4314, 184],
/* 1611 */
1011,
/* 1612 */
1013,
/* 1613 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ },
/* 1614 */
[4341, 3755],
/* 1615 */
1020,
/* 1616 */
[4414, 1599, 3706, 483],
/* 1617 */
[4416, 480, 3696, 3704],
/* 1618 */
[4438, 3716],
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _io = __webpack_require__(487);
	
	Object.defineProperty(exports, 'take', {
	  enumerable: true,
	  get: function get() {
	    return _io.take;
	  }
	});
	Object.defineProperty(exports, 'takem', {
	  enumerable: true,
	  get: function get() {
	    return _io.takem;
	  }
	});
	Object.defineProperty(exports, 'put', {
	  enumerable: true,
	  get: function get() {
	    return _io.put;
	  }
	});
	Object.defineProperty(exports, 'race', {
	  enumerable: true,
	  get: function get() {
	    return _io.race;
	  }
	});
	Object.defineProperty(exports, 'call', {
	  enumerable: true,
	  get: function get() {
	    return _io.call;
	  }
	});
	Object.defineProperty(exports, 'apply', {
	  enumerable: true,
	  get: function get() {
	    return _io.apply;
	  }
	});
	Object.defineProperty(exports, 'cps', {
	  enumerable: true,
	  get: function get() {
	    return _io.cps;
	  }
	});
	Object.defineProperty(exports, 'fork', {
	  enumerable: true,
	  get: function get() {
	    return _io.fork;
	  }
	});
	Object.defineProperty(exports, 'spawn', {
	  enumerable: true,
	  get: function get() {
	    return _io.spawn;
	  }
	});
	Object.defineProperty(exports, 'join', {
	  enumerable: true,
	  get: function get() {
	    return _io.join;
	  }
	});
	Object.defineProperty(exports, 'cancel', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancel;
	  }
	});
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _io.select;
	  }
	});
	Object.defineProperty(exports, 'actionChannel', {
	  enumerable: true,
	  get: function get() {
	    return _io.actionChannel;
	  }
	});
	Object.defineProperty(exports, 'cancelled', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancelled;
	  }
	});
	Object.defineProperty(exports, 'flush', {
	  enumerable: true,
	  get: function get() {
	    return _io.flush;
	  }
	});

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
	exports.default = proc;
	
	var _utils = __webpack_require__(160);
	
	var _asap = __webpack_require__(3782);
	
	var _asap2 = _interopRequireDefault(_asap);
	
	var _io = __webpack_require__(487);
	
	var _channel = __webpack_require__(486);
	
	var _buffers = __webpack_require__(485);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isDev = ("production") === 'development';
	
	var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';
	
	var nextEffectId = (0, _utils.autoInc)();
	var CHANNEL_END = exports.CHANNEL_END = {
	  toString: function toString() {
	    return '@@redux-saga/CHANNEL_END';
	  }
	};
	var TASK_CANCEL = exports.TASK_CANCEL = {
	  toString: function toString() {
	    return '@@redux-saga/TASK_CANCEL';
	  }
	};
	
	var matchers = {
	  wildcard: function wildcard() {
	    return _utils.kTrue;
	  },
	  default: function _default(pattern) {
	    return function (input) {
	      return input.type === pattern;
	    };
	  },
	  array: function array(patterns) {
	    return function (input) {
	      return patterns.some(function (p) {
	        return p === input.type;
	      });
	    };
	  },
	  predicate: function predicate(_predicate) {
	    return function (input) {
	      return _predicate(input);
	    };
	  }
	};
	
	function matcher(pattern) {
	  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
	}
	
	/**
	  Used to track a parent task and its forks
	  In the new fork model, forked tasks are attached by default to their parent
	  We model this using the concept of Parent task && main Task
	  main task is the main flow of the current Generator, the parent tasks is the
	  aggregation of the main tasks + all its forked tasks.
	  Thus the whole model represents an execution tree with multiple branches (vs the
	  linear execution tree in sequential (non parallel) programming)
	
	  A parent tasks has the following semantics
	  - It completes iff all its forks either complete or all cancelled
	  - If it's cancelled, all forks are cancelled as well
	  - It aborts if any uncaught error bubbles up from forks
	  - If it completes, the return value is the one returned by the main task
	**/
	function forkQueue(name, mainTask, cb) {
	  var tasks = [],
	      result = void 0,
	      completed = false;
	  addTask(mainTask);
	
	  function abort(err) {
	    cancelAll();
	    cb(err, true);
	  }
	
	  function addTask(task) {
	    tasks.push(task);
	    task.cont = function (res, isErr) {
	      if (completed) {
	        return;
	      }
	
	      (0, _utils.remove)(tasks, task);
	      task.cont = _utils.noop;
	      if (isErr) {
	        abort(res);
	      } else {
	        if (task === mainTask) {
	          result = res;
	        }
	        if (!tasks.length) {
	          completed = true;
	          cb(result);
	        }
	      }
	    };
	    // task.cont.cancel = task.cancel
	  }
	
	  function cancelAll() {
	    if (completed) {
	      return;
	    }
	    completed = true;
	    tasks.forEach(function (t) {
	      t.cont = _utils.noop;
	      t.cancel();
	    });
	    tasks = [];
	  }
	
	  return {
	    addTask: addTask,
	    cancelAll: cancelAll,
	    abort: abort,
	    getTasks: function getTasks() {
	      return tasks;
	    },
	    taskNames: function taskNames() {
	      return tasks.map(function (t) {
	        return t.name;
	      });
	    }
	  };
	}
	
	function createTaskIterator(_ref) {
	  var context = _ref.context;
	  var fn = _ref.fn;
	  var args = _ref.args;
	
	  if (_utils.is.iterator(fn)) {
	    return fn;
	  }
	
	  // catch synchronous failures; see #152 and #441
	  var result = void 0,
	      error = void 0;
	  try {
	    result = fn.apply(context, args);
	  } catch (err) {
	    error = err;
	  }
	
	  // i.e. a generator function returns an iterator
	  if (_utils.is.iterator(result)) {
	    return result;
	  }
	
	  // do not bubble up synchronous failures for detached forks
	  // instead create a failed task. See #152 and #441
	  return error ? (0, _utils.makeIterator)(function () {
	    throw error;
	  }) : (0, _utils.makeIterator)(function () {
	    var pc = void 0;
	    var eff = { done: false, value: result };
	    var ret = function ret(value) {
	      return { done: true, value: value };
	    };
	    return function (arg) {
	      if (!pc) {
	        pc = true;
	        return eff;
	      } else {
	        return ret(arg);
	      }
	    };
	  }());
	}
	
	function wrapHelper(helper) {
	  return {
	    fn: helper
	  };
	}
	
	function proc(iterator) {
	  var subscribe = arguments.length <= 1 || arguments[1] === undefined ? function () {
	    return _utils.noop;
	  } : arguments[1];
	  var dispatch = arguments.length <= 2 || arguments[2] === undefined ? _utils.noop : arguments[2];
	  var getState = arguments.length <= 3 || arguments[3] === undefined ? _utils.noop : arguments[3];
	  var options = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];
	  var parentEffectId = arguments.length <= 5 || arguments[5] === undefined ? 0 : arguments[5];
	  var name = arguments.length <= 6 || arguments[6] === undefined ? 'anonymous' : arguments[6];
	  var cont = arguments[7];
	
	  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);
	
	  var sagaMonitor = options.sagaMonitor;
	  var logger = options.logger;
	  var onError = options.onError;
	
	  var log = logger || _utils.log;
	  var stdChannel = (0, _channel.stdChannel)(subscribe);
	  /**
	    Tracks the current effect cancellation
	    Each time the generator progresses. calling runEffect will set a new value
	    on it. It allows propagating cancellation to child effects
	  **/
	  next.cancel = _utils.noop;
	
	  /**
	    Creates a new task descriptor for this generator, We'll also create a main task
	    to track the main flow (besides other forked tasks)
	  **/
	  var task = newTask(parentEffectId, name, iterator, cont);
	  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
	  var taskQueue = forkQueue(name, mainTask, end);
	
	  /**
	    cancellation of the main task. We'll simply resume the Generator with a Cancel
	  **/
	  function cancelMain() {
	    if (mainTask.isRunning && !mainTask.isCancelled) {
	      mainTask.isCancelled = true;
	      next(TASK_CANCEL);
	    }
	  }
	
	  /**
	    This may be called by a parent generator to trigger/propagate cancellation
	    cancel all pending tasks (including the main task), then end the current task.
	     Cancellation propagates down to the whole execution tree holded by this Parent task
	    It's also propagated to all joiners of this task and their execution tree/joiners
	     Cancellation is noop for terminated/Cancelled tasks tasks
	  **/
	  function cancel() {
	    /**
	      We need to check both Running and Cancelled status
	      Tasks can be Cancelled but still Running
	    **/
	    if (iterator._isRunning && !iterator._isCancelled) {
	      iterator._isCancelled = true;
	      taskQueue.cancelAll();
	      /**
	        Ending with a Never result will propagate the Cancellation to all joiners
	      **/
	      end(TASK_CANCEL);
	    }
	  }
	  /**
	    attaches cancellation logic to this task's continuation
	    this will permit cancellation to propagate down the call chain
	  **/
	  cont && (cont.cancel = cancel);
	
	  // tracks the running status
	  iterator._isRunning = true;
	
	  // kicks up the generator
	  next();
	
	  // then return the task descriptor to the caller
	  return task;
	
	  /**
	    This is the generator driver
	    It's a recursive async/continuation function which calls itself
	    until the generator terminates or throws
	  **/
	  function next(arg, isErr) {
	    // Preventive measure. If we end up here, then there is really something wrong
	    if (!mainTask.isRunning) {
	      throw new Error('Trying to resume an already finished generator');
	    }
	
	    try {
	      var result = void 0;
	      if (isErr) {
	        result = iterator.throw(arg);
	      } else if (arg === TASK_CANCEL) {
	        /**
	          getting TASK_CANCEL autoamtically cancels the main task
	          We can get this value here
	           - By cancelling the parent task manually
	          - By joining a Cancelled task
	        **/
	        mainTask.isCancelled = true;
	        /**
	          Cancels the current effect; this will propagate the cancellation down to any called tasks
	        **/
	        next.cancel();
	        /**
	          If this Generator has a `return` method then invokes it
	          Thill will jump to the finally block
	        **/
	        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
	      } else if (arg === CHANNEL_END) {
	        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
	        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
	      } else {
	        result = iterator.next(arg);
	      }
	
	      if (!result.done) {
	        runEffect(result.value, parentEffectId, '', next);
	      } else {
	        /**
	          This Generator has ended, terminate the main task and notify the fork queue
	        **/
	        mainTask.isMainRunning = false;
	        mainTask.cont && mainTask.cont(result.value);
	      }
	    } catch (error) {
	      if (mainTask.isCancelled) {
	        log('error', 'uncaught at ' + name, error.message);
	      }
	      mainTask.isMainRunning = false;
	      mainTask.cont(error, true);
	    }
	  }
	
	  function end(result, isErr) {
	    iterator._isRunning = false;
	    stdChannel.close();
	    if (!isErr) {
	      if (result === TASK_CANCEL && isDev) {
	        log('info', name + ' has been cancelled', '');
	      }
	      iterator._result = result;
	      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
	    } else {
	      if (result instanceof Error) {
	        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
	      }
	      if (!task.cont) {
	        log('error', 'uncaught', result.sagaStack || result.stack);
	        if (result instanceof Error && onError) {
	          onError(result);
	        }
	      }
	      iterator._error = result;
	      iterator._isAborted = true;
	      iterator._deferredEnd && iterator._deferredEnd.reject(result);
	    }
	    task.cont && task.cont(result, isErr);
	    task.joiners.forEach(function (j) {
	      return j.cb(result, isErr);
	    });
	    task.joiners = null;
	  }
	
	  function runEffect(effect, parentEffectId) {
	    var label = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	    var cb = arguments[3];
	
	    var effectId = nextEffectId();
	    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });
	
	    /**
	      completion callback and cancel callback are mutually exclusive
	      We can't cancel an already completed effect
	      And We can't complete an already cancelled effectId
	    **/
	    var effectSettled = void 0;
	
	    // Completion callback passed to the appropriate effect runner
	    function currCb(res, isErr) {
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      cb.cancel = _utils.noop; // defensive measure
	      if (sagaMonitor) {
	        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
	      }
	
	      cb(res, isErr);
	    }
	    // tracks down the current cancel
	    currCb.cancel = _utils.noop;
	
	    // setup cancellation logic on the parent cb
	    cb.cancel = function () {
	      // prevents cancelling an already completed effect
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      /**
	        propagates cancel downward
	        catch uncaught cancellations errors; since we can no longer call the completion
	        callback, log errors raised during cancellations into the console
	      **/
	      try {
	        currCb.cancel();
	      } catch (err) {
	        log('error', 'uncaught at ' + name, err.message);
	      }
	      currCb.cancel = _utils.noop; // defensive measure
	
	      sagaMonitor && sagaMonitor.effectCancelled(effectId);
	    };
	
	    /**
	      each effect runner must attach its own logic of cancellation to the provided callback
	      it allows this generator to propagate cancellation downward.
	       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
	      And the setup must occur before calling the callback
	       This is a sort of inversion of control: called async functions are responsible
	      of completing the flow by calling the provided continuation; while caller functions
	      are responsible for aborting the current flow by calling the attached cancel function
	       Library users can attach their own cancellation logic to promises by defining a
	      promise[CANCEL] method in their returned promises
	      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
	    **/
	    var data = void 0;
	    return (
	      // Non declarative effect
	      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)
	
	      // declarative effects
	      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : /* anything else returned as is        */currCb(effect)
	    );
	  }
	
	  function resolvePromise(promise, cb) {
	    var cancelPromise = promise[_utils.CANCEL];
	    if (typeof cancelPromise === 'function') {
	      cb.cancel = cancelPromise;
	    }
	    promise.then(cb, function (error) {
	      return cb(error, true);
	    });
	  }
	
	  function resolveIterator(iterator, effectId, name, cb) {
	    proc(iterator, subscribe, dispatch, getState, options, effectId, name, cb);
	  }
	
	  function runTakeEffect(_ref2, cb) {
	    var channel = _ref2.channel;
	    var pattern = _ref2.pattern;
	    var maybe = _ref2.maybe;
	
	    channel = channel || stdChannel;
	    var takeCb = function takeCb(inp) {
	      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
	    };
	    try {
	      channel.take(takeCb, matcher(pattern));
	    } catch (err) {
	      return cb(err, true);
	    }
	    cb.cancel = takeCb.cancel;
	  }
	
	  function runPutEffect(_ref3, cb) {
	    var channel = _ref3.channel;
	    var action = _ref3.action;
	    var sync = _ref3.sync;
	
	    /*
	      Use a reentrant lock `asap` to flatten all nested dispatches
	      If this put cause another Saga to take this action an then immediately
	      put an action that will be taken by this Saga. Then the outer Saga will miss
	      the action from the inner Saga b/c this put has not yet returned.
	    */
	    (0, _asap2.default)(function () {
	      var result = void 0;
	      try {
	        result = (channel ? channel.put : dispatch)(action);
	      } catch (error) {
	        // If we have a channel or `put.sync` was used then bubble up the error.
	        if (channel || sync) return cb(error, true);
	        log('error', 'uncaught at ' + name, error.stack || error.message || error);
	      }
	
	      if (sync && _utils.is.promise(result)) {
	        resolvePromise(result, cb);
	      } else {
	        return cb(result);
	      }
	    });
	    // Put effects are non cancellables
	  }
	
	  function runCallEffect(_ref4, effectId, cb) {
	    var context = _ref4.context;
	    var fn = _ref4.fn;
	    var args = _ref4.args;
	
	    var result = void 0;
	    // catch synchronous failures; see #152
	    try {
	      result = fn.apply(context, args);
	    } catch (error) {
	      return cb(error, true);
	    }
	    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
	  }
	
	  function runCPSEffect(_ref5, cb) {
	    var context = _ref5.context;
	    var fn = _ref5.fn;
	    var args = _ref5.args;
	
	    // CPS (ie node style functions) can define their own cancellation logic
	    // by setting cancel field on the cb
	
	    // catch synchronous failures; see #152
	    try {
	      (function () {
	        var cpsCb = function cpsCb(err, res) {
	          return _utils.is.undef(err) ? cb(res) : cb(err, true);
	        };
	        fn.apply(context, args.concat(cpsCb));
	        if (cpsCb.cancel) {
	          cb.cancel = function () {
	            return cpsCb.cancel();
	          };
	        }
	      })();
	    } catch (error) {
	      return cb(error, true);
	    }
	  }
	
	  function runForkEffect(_ref6, effectId, cb) {
	    var context = _ref6.context;
	    var fn = _ref6.fn;
	    var args = _ref6.args;
	    var detached = _ref6.detached;
	
	    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });
	
	    _asap2.default.suspend();
	    var task = proc(taskIterator, subscribe, dispatch, getState, options, effectId, fn.name, detached ? null : _utils.noop);
	
	    if (detached) {
	      cb(task);
	    } else {
	      if (taskIterator._isRunning) {
	        taskQueue.addTask(task);
	        cb(task);
	      } else if (taskIterator._error) {
	        taskQueue.abort(taskIterator._error);
	      } else {
	        cb(task);
	      }
	    }
	    _asap2.default.flush();
	    // Fork effects are non cancellables
	  }
	
	  function runJoinEffect(t, cb) {
	    if (t.isRunning()) {
	      (function () {
	        var joiner = { task: task, cb: cb };
	        cb.cancel = function () {
	          return (0, _utils.remove)(t.joiners, joiner);
	        };
	        t.joiners.push(joiner);
	      })();
	    } else {
	      t.isAborted() ? cb(t.error(), true) : cb(t.result());
	    }
	  }
	
	  function runCancelEffect(task, cb) {
	    if (task.isRunning()) {
	      task.cancel();
	    }
	    cb();
	    // cancel effects are non cancellables
	  }
	
	  function runParallelEffect(effects, effectId, cb) {
	    if (!effects.length) {
	      return cb([]);
	    }
	
	    var completedCount = 0;
	    var completed = void 0;
	    var results = Array(effects.length);
	
	    function checkEffectEnd() {
	      if (completedCount === results.length) {
	        completed = true;
	        cb(results);
	      }
	    }
	
	    var childCbs = effects.map(function (eff, idx) {
	      var chCbAtIdx = function chCbAtIdx(res, isErr) {
	        if (completed) {
	          return;
	        }
	        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
	          cb.cancel();
	          cb(res, isErr);
	        } else {
	          results[idx] = res;
	          completedCount++;
	          checkEffectEnd();
	        }
	      };
	      chCbAtIdx.cancel = _utils.noop;
	      return chCbAtIdx;
	    });
	
	    cb.cancel = function () {
	      if (!completed) {
	        completed = true;
	        childCbs.forEach(function (chCb) {
	          return chCb.cancel();
	        });
	      }
	    };
	
	    effects.forEach(function (eff, idx) {
	      return runEffect(eff, effectId, idx, childCbs[idx]);
	    });
	  }
	
	  function runRaceEffect(effects, effectId, cb) {
	    var completed = void 0;
	    var keys = Object.keys(effects);
	    var childCbs = {};
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	
	        if (isErr) {
	          // Race Auto cancellation
	          cb.cancel();
	          cb(res, true);
	        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
	          cb.cancel();
	          completed = true;
	          cb(_defineProperty({}, key, res));
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      // prevents unnecessary cancellation
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	    keys.forEach(function (key) {
	      if (completed) {
	        return;
	      }
	      runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runSelectEffect(_ref7, cb) {
	    var selector = _ref7.selector;
	    var args = _ref7.args;
	
	    try {
	      var state = selector.apply(undefined, [getState()].concat(_toConsumableArray(args)));
	      cb(state);
	    } catch (error) {
	      cb(error, true);
	    }
	  }
	
	  function runChannelEffect(_ref8, cb) {
	    var pattern = _ref8.pattern;
	    var buffer = _ref8.buffer;
	
	    var match = matcher(pattern);
	    match.pattern = pattern;
	    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
	  }
	
	  function runCancelledEffect(data, cb) {
	    cb(!!mainTask.isCancelled);
	  }
	
	  function runFlushEffect(channel, cb) {
	    channel.flush(cb);
	  }
	
	  function newTask(id, name, iterator, cont) {
	    var _done, _ref9, _mutatorMap;
	
	    iterator._deferredEnd = null;
	    return _ref9 = {}, _defineProperty(_ref9, _utils.TASK, true), _defineProperty(_ref9, 'id', id), _defineProperty(_ref9, 'name', name), _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
	      if (iterator._deferredEnd) {
	        return iterator._deferredEnd.promise;
	      } else {
	        var def = (0, _utils.deferred)();
	        iterator._deferredEnd = def;
	        if (!iterator._isRunning) {
	          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
	        }
	        return def.promise;
	      }
	    }, _defineProperty(_ref9, 'cont', cont), _defineProperty(_ref9, 'joiners', []), _defineProperty(_ref9, 'cancel', cancel), _defineProperty(_ref9, 'isRunning', function isRunning() {
	      return iterator._isRunning;
	    }), _defineProperty(_ref9, 'isCancelled', function isCancelled() {
	      return iterator._isCancelled;
	    }), _defineProperty(_ref9, 'isAborted', function isAborted() {
	      return iterator._isAborted;
	    }), _defineProperty(_ref9, 'result', function result() {
	      return iterator._result;
	    }), _defineProperty(_ref9, 'error', function error() {
	      return iterator._error;
	    }), _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
	  }
	}

/***/ },
/* 1621 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(679);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1784);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 1623 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 1624 */
/***/ function(module, exports) {

	'use strict';
	
	var $Object = Object;
	var $TypeError = TypeError;
	
	module.exports = function flags() {
		if (this != null && this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	};


/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1624);
	
	var supportsDescriptors = __webpack_require__(200).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	var $TypeError = TypeError;
	
	module.exports = function getPolyfill() {
		if (!supportsDescriptors) {
			throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		if ((/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
				return descriptor.get;
			}
		}
		return implementation;
	};


/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.rollbar=e():t.rollbar=e()}(this,function(){return function(t){function e(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return t[n].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var r={};return e.m=t,e.c=r,e.p="",e(0)}([function(t,e,r){t.exports=r(1)},function(t,e,r){"use strict";var n=r(2),o="undefined"!=typeof window&&window._rollbarConfig,i=o&&o.globalAlias||"Rollbar",a="undefined"!=typeof window&&window[i]&&"function"==typeof window[i].shimId&&void 0!==window[i].shimId();if("undefined"==typeof window||window._rollbarStartTime||(window._rollbarStartTime=(new Date).getTime()),!a&&o){var s=new n(o);window[i]=s}else"undefined"!=typeof window?(window.rollbar=n,window._rollbarDidLoad=!0):"undefined"!=typeof self&&(self.rollbar=n,self._rollbarDidLoad=!0);t.exports=n},function(t,e,r){"use strict";function n(t,e){this.options=c.handleOptions(x,t);var r=new l(this.options,h,d);this.client=e||new u(this.options,r,p,"browser");var n="undefined"!=typeof window&&window||"undefined"!=typeof self&&self,o="undefined"!=typeof document&&document;i(this.client.notifier,n),a(this.client.queue),(this.options.captureUncaught||this.options.handleUncaughtExceptions)&&(f.captureUncaughtExceptions(n,this),f.wrapGlobals(n,this)),(this.options.captureUnhandledRejections||this.options.handleUnhandledRejections)&&f.captureUnhandledRejections(n,this),this.instrumenter=new w(this.options,this.client.telemeter,this,n,o),this.instrumenter.instrument()}function o(t){var e="Rollbar is not initialized";p.error(e),t&&t(new Error(e))}function i(t,e){t.addTransform(m.handleItemWithError).addTransform(m.ensureItemHasSomethingToSay).addTransform(m.addBaseInfo).addTransform(m.addRequestInfo(e)).addTransform(m.addClientInfo(e)).addTransform(m.addPluginInfo(e)).addTransform(m.addBody).addTransform(g.addMessageWithError).addTransform(g.addTelemetryData).addTransform(g.addConfigToPayload).addTransform(m.scrubPayload).addTransform(g.userTransform(p)).addTransform(g.itemToPayload)}function a(t){t.addPredicate(y.checkLevel).addPredicate(v.checkIgnore).addPredicate(y.userCheckIgnore(p)).addPredicate(y.urlIsNotBlacklisted(p)).addPredicate(y.urlIsWhitelisted(p)).addPredicate(y.messageIsIgnored(p))}function s(t){for(var e=0,r=t.length;e<r;++e)if(c.isFunction(t[e]))return t[e]}var u=r(3),c=r(5),l=r(11),p=r(13),f=r(16),h=r(17),d=r(19),m=r(20),g=r(24),v=r(25),y=r(26),b=r(21),w=r(27),_=null;n.init=function(t,e){return _?_.global(t).configure(t):_=new n(t,e)},n.prototype.global=function(t){return this.client.global(t),this},n.global=function(t){return _?_.global(t):void o()},n.prototype.configure=function(t,e){var r=this.options,n={};return e&&(n={payload:e}),this.options=c.handleOptions(r,t,n),this.client.configure(this.options,e),this.instrumenter.configure(this.options),this},n.configure=function(t,e){return _?_.configure(t,e):void o()},n.prototype.lastError=function(){return this.client.lastError},n.lastError=function(){return _?_.lastError():void o()},n.prototype.log=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.log(t),{uuid:e}},n.log=function(){if(_)return _.log.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.debug=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.debug(t),{uuid:e}},n.debug=function(){if(_)return _.debug.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.info=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.info(t),{uuid:e}},n.info=function(){if(_)return _.info.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.warn=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.warn(t),{uuid:e}},n.warn=function(){if(_)return _.warn.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.warning=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.warning(t),{uuid:e}},n.warning=function(){if(_)return _.warning.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.error=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.error(t),{uuid:e}},n.error=function(){if(_)return _.error.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.critical=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.critical(t),{uuid:e}},n.critical=function(){if(_)return _.critical.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.handleUncaughtException=function(t,e,r,n,o,i){var a,s=c.makeUnhandledStackInfo(t,e,r,n,o,"onerror","uncaught exception",b);c.isError(o)?(a=this._createItem([t,o,i]),a._unhandledStackInfo=s):c.isError(e)?(a=this._createItem([t,e,i]),a._unhandledStackInfo=s):(a=this._createItem([t,i]),a.stackInfo=s),a.level=this.options.uncaughtErrorLevel,a._isUncaught=!0,this.client.log(a)},n.prototype.handleUnhandledRejection=function(t,e){var r="unhandled rejection was null or undefined!";if(t)if(t.message)r=t.message;else{var n=c.stringify(t);n.value&&(r=n.value)}var o,i=t&&t._rollbarContext||e&&e._rollbarContext;c.isError(t)?o=this._createItem([r,t,i]):(o=this._createItem([r,t,i]),o.stackInfo=c.makeUnhandledStackInfo(r,"",0,0,null,"unhandledrejection","",b)),o.level=this.options.uncaughtErrorLevel,o._isUncaught=!0,o._originalArgs=o._originalArgs||[],o._originalArgs.push(e),this.client.log(o)},n.prototype.wrap=function(t,e,r){try{var n;if(n=c.isFunction(e)?e:function(){return e||{}},!c.isFunction(t))return t;if(t._isWrap)return t;if(!t._rollbar_wrapped&&(t._rollbar_wrapped=function(){r&&c.isFunction(r)&&r.apply(this,arguments);try{return t.apply(this,arguments)}catch(r){var e=r;throw e&&window._rollbarWrappedError!==e&&(c.isType(e,"string")&&(e=new String(e)),e._rollbarContext=n()||{},e._rollbarContext._wrappedSource=t.toString(),window._rollbarWrappedError=e),e}},t._rollbar_wrapped._isWrap=!0,t.hasOwnProperty))for(var o in t)t.hasOwnProperty(o)&&"_rollbar_wrapped"!==o&&(t._rollbar_wrapped[o]=t[o]);return t._rollbar_wrapped}catch(e){return t}},n.wrap=function(t,e){return _?_.wrap(t,e):void o()},n.prototype.captureEvent=function(){var t=c.createTelemetryEvent(arguments);return this.client.captureEvent(t.type,t.metadata,t.level)},n.captureEvent=function(){return _?_.captureEvent.apply(_,arguments):void o()},n.prototype.captureDomContentLoaded=function(t,e){return e||(e=new Date),this.client.captureDomContentLoaded(e)},n.prototype.captureLoad=function(t,e){return e||(e=new Date),this.client.captureLoad(e)},n.prototype._createItem=function(t){return c.createItem(t,p,this)};var x={version:"2.5.5",scrubFields:["pw","pass","passwd","password","secret","confirm_password","confirmPassword","password_confirmation","passwordConfirmation","access_token","accessToken","secret_key","secretKey","secretToken","cc-number","card number","cardnumber","cardnum","ccnum","ccnumber","cc num","creditcardnumber","credit card number","newcreditcardnumber","new credit card","creditcardno","credit card no","card#","card #","cc-csc","cvc2","cvv2","ccv2","security code","card verification","name on credit card","name on card","nameoncard","cardholder","card holder","name des karteninhabers","card type","cardtype","cc type","cctype","payment type","expiration date","expirationdate","expdate","cc-exp"],logLevel:"debug",reportLevel:"debug",uncaughtErrorLevel:"error",endpoint:"api.rollbar.com/api/1/item/",verbose:!1,enabled:!0,sendConfig:!1,includeItemsInTelemetry:!0,captureIp:!0};t.exports=n},function(t,e,r){"use strict";function n(t,e,r,o){this.options=c.merge(t),this.logger=r,n.rateLimiter.configureGlobal(this.options),n.rateLimiter.setPlatformOptions(o,this.options),this.queue=new a(n.rateLimiter,e,r,this.options),this.notifier=new s(this.queue,this.options),this.telemeter=new u(this.options),this.lastError=null,this.lastErrorHash="none"}function o(t){var e=t.message||"",r=(t.err||{}).stack||String(t.err);return e+"::"+r}var i=r(4),a=r(8),s=r(9),u=r(10),c=r(5),l={maxItems:0,itemsPerMinute:60};n.rateLimiter=new i(l),n.prototype.global=function(t){return n.rateLimiter.configureGlobal(t),this},n.prototype.configure=function(t,e){var r=this.options,n={};return e&&(n={payload:e}),this.options=c.merge(r,t,n),this.notifier&&this.notifier.configure(this.options),this.telemeter&&this.telemeter.configure(this.options),this.global(this.options),this},n.prototype.log=function(t){var e=this._defaultLogLevel();return this._log(e,t)},n.prototype.debug=function(t){this._log("debug",t)},n.prototype.info=function(t){this._log("info",t)},n.prototype.warn=function(t){this._log("warning",t)},n.prototype.warning=function(t){this._log("warning",t)},n.prototype.error=function(t){this._log("error",t)},n.prototype.critical=function(t){this._log("critical",t)},n.prototype.wait=function(t){this.queue.wait(t)},n.prototype.captureEvent=function(t,e,r){return this.telemeter.captureEvent(t,e,r)},n.prototype.captureDomContentLoaded=function(t){return this.telemeter.captureDomContentLoaded(t)},n.prototype.captureLoad=function(t){return this.telemeter.captureLoad(t)},n.prototype._log=function(t,e){var r;if(e.callback&&(r=e.callback,delete e.callback),this._sameAsLastError(e)){if(r){var n=new Error("ignored identical item");n.item=e,r(n)}}else try{e.level=e.level||t,this.telemeter._captureRollbarItem(e),e.telemetryEvents=this.telemeter.copyEvents(),this.notifier.log(e,r)}catch(t){this.logger.error(t)}},n.prototype._defaultLogLevel=function(){return this.options.logLevel||"debug"},n.prototype._sameAsLastError=function(t){if(!t._isUncaught)return!1;var e=o(t);return this.lastErrorHash===e||(this.lastError=t.err,this.lastErrorHash=e,!1)},t.exports=n},function(t,e,r){"use strict";function n(t){this.startTime=s.now(),this.counter=0,this.perMinCounter=0,this.platform=null,this.platformOptions={},this.configureGlobal(t)}function o(t,e,r){return!t.ignoreRateLimit&&e>=1&&r>e}function i(t,e,r,n,o,i,s){var u=null;return r&&(r=new Error(r)),r||n||(u=a(t,e,o,i,s)),{error:r,shouldSend:n,payload:u}}function a(t,e,r,n,o){var i,a=e.environment||e.payload&&e.payload.environment;i=o?"item per minute limit reached, ignoring errors until timeout":"maxItems has been hit, ignoring errors until reset.";var s={body:{message:{body:i,extra:{maxItems:r,itemsPerMinute:n}}},language:"javascript",environment:a,notifier:{version:e.notifier&&e.notifier.version||e.version}};return"browser"===t?(s.platform="browser",s.framework="browser-js",s.notifier.name="rollbar-browser-js"):"server"===t?(s.framework=e.framework||"node-js",s.notifier.name=e.notifier.name):"react-native"===t&&(s.framework=e.framework||"react-native",s.notifier.name=e.notifier.name),s}var s=r(5);n.globalSettings={startTime:s.now(),maxItems:void 0,itemsPerMinute:void 0},n.prototype.configureGlobal=function(t){void 0!==t.startTime&&(n.globalSettings.startTime=t.startTime),void 0!==t.maxItems&&(n.globalSettings.maxItems=t.maxItems),void 0!==t.itemsPerMinute&&(n.globalSettings.itemsPerMinute=t.itemsPerMinute)},n.prototype.shouldSend=function(t,e){e=e||s.now();var r=e-this.startTime;(r<0||r>=6e4)&&(this.startTime=e,this.perMinCounter=0);var a=n.globalSettings.maxItems,u=n.globalSettings.itemsPerMinute;if(o(t,a,this.counter))return i(this.platform,this.platformOptions,a+" max items reached",!1);if(o(t,u,this.perMinCounter))return i(this.platform,this.platformOptions,u+" items per minute reached",!1);this.counter++,this.perMinCounter++;var c=!o(t,a,this.counter),l=c;return c=c&&!o(t,u,this.perMinCounter),i(this.platform,this.platformOptions,null,c,a,u,l)},n.prototype.setPlatformOptions=function(t,e){this.platform=t,this.platformOptions=e},t.exports=n},function(t,e,r){"use strict";function n(){if(!P&&(P=!0,c(JSON)&&(s(JSON.stringify)&&(q.stringify=JSON.stringify),s(JSON.parse)&&(q.parse=JSON.parse)),!a(q.stringify)||!a(q.parse))){var t=r(7);t(q)}}function o(t,e){return e===i(t)}function i(t){var e=typeof t;return"object"!==e?e:t?t instanceof Error?"error":{}.toString.call(t).match(/\s([a-zA-Z]+)/)[1].toLowerCase():"null"}function a(t){return o(t,"function")}function s(t){var e=/[\\^$.*+?()[\]{}|]/g,r=Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(e,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?"),n=RegExp("^"+r+"$");return u(t)&&n.test(t)}function u(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}function c(t){return!o(t,"undefined")}function l(t){var e=i(t);return"object"===e||"array"===e}function p(t){return o(t,"error")||o(t,"exception")}function f(t,e,r){var n,i,a,s=o(t,"object"),u=o(t,"array"),c=[];if(s&&r.indexOf(t)!==-1)return t;if(r.push(t),s)for(n in t)Object.prototype.hasOwnProperty.call(t,n)&&c.push(n);else if(u)for(a=0;a<t.length;++a)c.push(a);var l=s?{}:[],p=!0;for(a=0;a<c.length;++a)n=c[a],i=t[n],l[n]=e(n,i,r),p=p&&l[n]===t[n];return 0==c.length||p?t:l}function h(){return"********"}function d(){var t=j(),e="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var r=(t+16*Math.random())%16|0;return t=Math.floor(t/16),("x"===e?r:7&r|8).toString(16)});return e}function m(t){var e=g(t);return e?(""===e.anchor&&(e.source=e.source.replace("#","")),t=e.source.replace("?"+e.query,"")):"(unknown)"}function g(t){if(o(t,"string")){for(var e=M,r=e.parser[e.strictMode?"strict":"loose"].exec(t),n={},i=0,a=e.key.length;i<a;++i)n[e.key[i]]=r[i]||"";return n[e.q.name]={},n[e.key[12]].replace(e.q.parser,function(t,r,o){r&&(n[e.q.name][r]=o)}),n}}function v(t,e,r){r=r||{},r.access_token=t;var n,o=[];for(n in r)Object.prototype.hasOwnProperty.call(r,n)&&o.push([n,r[n]].join("="));var i="?"+o.sort().join("&");e=e||{},e.path=e.path||"";var a,s=e.path.indexOf("?"),u=e.path.indexOf("#");s!==-1&&(u===-1||u>s)?(a=e.path,e.path=a.substring(0,s)+i+"&"+a.substring(s+1)):u!==-1?(a=e.path,e.path=a.substring(0,u)+i+a.substring(u)):e.path=e.path+i}function y(t,e){if(e=e||t.protocol,!e&&t.port&&(80===t.port?e="http:":443===t.port&&(e="https:")),e=e||"https:",!t.hostname)return null;var r=e+"//"+t.hostname;return t.port&&(r=r+":"+t.port),t.path&&(r+=t.path),r}function b(t,e){var r,n;try{r=q.stringify(t)}catch(o){if(e&&a(e))try{r=e(t)}catch(t){n=t}else n=o}return{error:n,value:r}}function w(t){var e,r;try{e=q.parse(t)}catch(t){r=t}return{error:r,value:e}}function _(t,e,r,n,o,i,a,s){var u={url:e||"",line:r,column:n};u.func=s.guessFunctionName(u.url,u.line),u.context=s.gatherContext(u.url,u.line);var c=document&&document.location&&document.location.href,l=window&&window.navigator&&window.navigator.userAgent;return{mode:i,message:o?String(o):t||a,url:c,stack:[u],useragent:l}}function x(t,e){return function(r,n){try{e(r,n)}catch(e){t.error(e)}}}function k(t,e,r,n,o){for(var a,s,u,c,l,p,f=[],h=0,m=t.length;h<m;++h){p=t[h];var g=i(p);switch(g){case"undefined":break;case"string":a?f.push(p):a=p;break;case"function":c=x(e,p);break;case"date":f.push(p);break;case"error":case"domexception":case"exception":s?f.push(p):s=p;break;case"object":case"array":if(p instanceof Error||"undefined"!=typeof DOMException&&p instanceof DOMException){s?f.push(p):s=p;break}if(n&&"object"===g&&!l){for(var v=0,y=n.length;v<y;++v)if(void 0!==p[n[v]]){l=p;break}if(l)break}u?f.push(p):u=p;break;default:if(p instanceof Error||"undefined"!=typeof DOMException&&p instanceof DOMException){s?f.push(p):s=p;break}f.push(p)}}f.length>0&&(u=F(u),u.extraArgs=f);var b={message:a,err:s,custom:u,timestamp:j(),callback:c,uuid:d()};return u&&void 0!==u.level&&(b.level=u.level,delete u.level),n&&l&&(b.request=l),o&&(b.lambdaContext=o),b._originalArgs=t,b}function E(t,e){for(var r=0;r<t.length;++r)if(t[r]===e)return!0;return!1}function I(t){for(var e,r,n,o,a=0,s=t.length;a<s;++a){o=t[a];var u=i(o);switch(u){case"string":E(U,o)?e=o:E(H,o)&&(n=o);break;case"object":r=o}}var c={type:e||"manual",metadata:r||{},level:n};return c}function T(t,e){if(t){var r=e.split("."),n=t;try{for(var o=0,i=r.length;o<i;++o)n=n[r[o]]}catch(t){n=void 0}return n}}function S(t,e,r){if(t){var n=e.split("."),o=n.length;if(!(o<1)){if(1===o)return void(t[n[0]]=r);try{for(var i=t[n[0]]||{},a=i,s=1;s<o-1;++s)i[n[s]]=i[n[s]]||{},i=i[n[s]];i[n[o-1]]=r,t[n[0]]=a}catch(t){return}}}}function O(t,e){function r(t,e){return e+h()}function n(t){var e;if(o(t,"string"))for(e=0;e<u.length;++e)t=t.replace(u[e],r);return t}function i(t,e){var r;for(r=0;r<s.length;++r)if(s[r].test(t)){e=h();break}return e}function a(t,e,r){var s=i(t,e);return s===e?o(e,"object")||o(e,"array")?f(e,a,r):n(s):s}e=e||[];var s=L(e),u=N(e);return f(t,a,[])}function L(t){for(var e,r=[],n=0;n<t.length;++n)e="^\\[?(%5[bB])?"+t[n]+"\\[?(%5[bB])?\\]?(%5[dD])?$",r.push(new RegExp(e,"i"));return r}function N(t){for(var e,r=[],n=0;n<t.length;++n)e="\\[?(%5[bB])?"+t[n]+"\\[?(%5[bB])?\\]?(%5[dD])?",r.push(new RegExp("("+e+"=)([^&\\n]+)","igm"));return r}function C(t){var e,r,n,o=[];for(e=0,r=t.length;e<r;++e){switch(n=t[e],i(n)){case"object":n=b(n),n=n.error||n.value,n.length>500&&(n=n.substr(0,497)+"...");break;case"null":n="null";break;case"undefined":n="undefined";break;case"symbol":n=n.toString()}o.push(n)}return o.join(" ")}function j(){return Date.now?+Date.now():+new Date}function R(t,e){if(t&&t.user_ip&&e!==!0){var r=t.user_ip;if(e)try{var n;if(r.indexOf(".")!==-1)n=r.split("."),n.pop(),n.push("0"),r=n.join(".");else if(r.indexOf(":")!==-1){if(n=r.split(":"),n.length>2){var o=n.slice(0,3),i=o[2].indexOf("/");i!==-1&&(o[2]=o[2].substring(0,i));var a="0000:0000:0000:0000:0000";r=o.concat(a).join(":")}}else r=null}catch(t){r=null}else r=null;t.user_ip=r}}function A(t,e,r){var n=F(t,e,r);return!e||e.overwriteScrubFields?n:(e.scrubFields&&(n.scrubFields=(t.scrubFields||[]).concat(e.scrubFields)),n)}var F=r(6),q={},P=!1;n();var D={debug:0,info:1,warning:2,error:3,critical:4},M={strictMode:!1,key:["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],q:{name:"queryKey",parser:/(?:^|&)([^&=]*)=?([^&]*)/g},parser:{strict:/^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,loose:/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/}},U=["log","network","dom","navigation","error","manual"],H=["critical","error","warning","info","debug"];t.exports={addParamsAndAccessTokenToPath:v,createItem:k,createTelemetryEvent:I,filterIp:R,formatArgsAsString:C,formatUrl:y,get:T,handleOptions:A,isError:p,isFunction:a,isIterable:l,isNativeFunction:s,isType:o,jsonParse:w,LEVELS:D,makeUnhandledStackInfo:_,merge:F,now:j,redact:h,sanitizeUrl:m,scrub:O,set:S,stringify:b,traverse:f,typeName:i,uuid4:d}},function(t,e){"use strict";function r(){var t,e,n,o,a,s={},u=null,c=arguments.length;for(t=0;t<c;t++)if(u=arguments[t],null!=u)for(a in u)e=s[a],n=u[a],s!==n&&(n&&i(n)?(o=e&&i(e)?e:{},s[a]=r(o,n)):"undefined"!=typeof n&&(s[a]=n));return s}var n=Object.prototype.hasOwnProperty,o=Object.prototype.toString,i=function(t){if(!t||"[object Object]"!==o.call(t))return!1;var e=n.call(t,"constructor"),r=t.constructor&&t.constructor.prototype&&n.call(t.constructor.prototype,"isPrototypeOf");if(t.constructor&&!e&&!r)return!1;var i;for(i in t);return"undefined"==typeof i||n.call(t,i)};t.exports=r},function(t,e){var r=function(t){function e(t){return t<10?"0"+t:t}function r(){return this.valueOf()}function n(t){return i.lastIndex=0,i.test(t)?'"'+t.replace(i,function(t){var e=u[t];return"string"==typeof e?e:"\\u"+("0000"+t.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+t+'"'}function o(t,e){var r,i,u,l,p,f=a,h=e[t];switch(h&&"object"==typeof h&&"function"==typeof h.toJSON&&(h=h.toJSON(t)),"function"==typeof c&&(h=c.call(e,t,h)),typeof h){case"string":return n(h);case"number":return isFinite(h)?String(h):"null";case"boolean":case"null":return String(h);case"object":if(!h)return"null";if(a+=s,p=[],"[object Array]"===Object.prototype.toString.apply(h)){for(l=h.length,r=0;r<l;r+=1)p[r]=o(r,h)||"null";return u=0===p.length?"[]":a?"[\n"+a+p.join(",\n"+a)+"\n"+f+"]":"["+p.join(",")+"]",a=f,u}if(c&&"object"==typeof c)for(l=c.length,r=0;r<l;r+=1)"string"==typeof c[r]&&(i=c[r],u=o(i,h),u&&p.push(n(i)+(a?": ":":")+u));else for(i in h)Object.prototype.hasOwnProperty.call(h,i)&&(u=o(i,h),u&&p.push(n(i)+(a?": ":":")+u));return u=0===p.length?"{}":a?"{\n"+a+p.join(",\n"+a)+"\n"+f+"}":"{"+p.join(",")+"}",a=f,u}}var i=/[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;"function"!=typeof Date.prototype.toJSON&&(Date.prototype.toJSON=function(){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+e(this.getUTCMonth()+1)+"-"+e(this.getUTCDate())+"T"+e(this.getUTCHours())+":"+e(this.getUTCMinutes())+":"+e(this.getUTCSeconds())+"Z":null},Boolean.prototype.toJSON=r,Number.prototype.toJSON=r,String.prototype.toJSON=r);var a,s,u,c;"function"!=typeof t.stringify&&(u={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},t.stringify=function(t,e,r){var n;if(a="",s="","number"==typeof r)for(n=0;n<r;n+=1)s+=" ";else"string"==typeof r&&(s=r);if(c=e,e&&"function"!=typeof e&&("object"!=typeof e||"number"!=typeof e.length))throw new Error("JSON.stringify");return o("",{"":t})}),"function"!=typeof t.parse&&(t.parse=function(){function t(t){return t.replace(/\\(?:u(.{4})|([^u]))/g,function(t,e,r){return e?String.fromCharCode(parseInt(e,16)):a[r]})}var e,r,n,o,i,a={"\\":"\\",'"':'"',"/":"/",t:"\t",n:"\n",r:"\r",f:"\f",b:"\b"},s={go:function(){e="ok"},firstokey:function(){o=i,e="colon"},okey:function(){o=i,e="colon"},ovalue:function(){e="ocomma"},firstavalue:function(){e="acomma"},avalue:function(){e="acomma"}},u={go:function(){e="ok"},ovalue:function(){e="ocomma"},firstavalue:function(){e="acomma"},avalue:function(){e="acomma"}},c={"{":{go:function(){r.push({state:"ok"}),n={},e="firstokey"},ovalue:function(){r.push({container:n,state:"ocomma",key:o}),n={},e="firstokey"},firstavalue:function(){r.push({container:n,state:"acomma"}),n={},e="firstokey"},avalue:function(){r.push({container:n,state:"acomma"}),n={},e="firstokey"}},"}":{firstokey:function(){var t=r.pop();i=n,n=t.container,o=t.key,e=t.state},ocomma:function(){var t=r.pop();n[o]=i,i=n,n=t.container,o=t.key,e=t.state}},"[":{go:function(){r.push({state:"ok"}),n=[],e="firstavalue"},ovalue:function(){r.push({container:n,state:"ocomma",key:o}),n=[],e="firstavalue"},firstavalue:function(){r.push({container:n,state:"acomma"}),n=[],e="firstavalue"},avalue:function(){r.push({container:n,state:"acomma"}),n=[],e="firstavalue"}},"]":{firstavalue:function(){var t=r.pop();i=n,n=t.container,o=t.key,e=t.state},acomma:function(){var t=r.pop();n.push(i),i=n,n=t.container,o=t.key,e=t.state}},":":{colon:function(){if(Object.hasOwnProperty.call(n,o))throw new SyntaxError("Duplicate key '"+o+'"');e="ovalue"}},",":{ocomma:function(){n[o]=i,e="okey"},acomma:function(){n.push(i),e="avalue"}},true:{go:function(){i=!0,e="ok"},ovalue:function(){i=!0,e="ocomma"},firstavalue:function(){i=!0,e="acomma"},avalue:function(){i=!0,e="acomma"}},false:{go:function(){i=!1,e="ok"},ovalue:function(){i=!1,e="ocomma"},firstavalue:function(){i=!1,e="acomma"},avalue:function(){i=!1,e="acomma"}},null:{go:function(){i=null,e="ok"},ovalue:function(){i=null,e="ocomma"},firstavalue:function(){i=null,e="acomma"},avalue:function(){i=null,e="acomma"}}};return function(n,o){var a,l=/^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;e="go",r=[];try{for(;;){if(a=l.exec(n),!a)break;a[1]?c[a[1]][e]():a[2]?(i=+a[2],u[e]()):(i=t(a[3]),s[e]()),n=n.slice(a[0].length)}}catch(t){e=t}if("ok"!==e||/[^\u0020\t\n\r]/.test(n))throw e instanceof SyntaxError?e:new SyntaxError("JSON");return"function"==typeof o?function t(e,r){var n,a,s=e[r];if(s&&"object"==typeof s)for(n in i)Object.prototype.hasOwnProperty.call(s,n)&&(a=t(s,n),void 0!==a?s[n]=a:delete s[n]);return o.call(e,r,s)}({"":i},""):i}}())};t.exports=r},function(t,e,r){"use strict";function n(t,e,r,n){this.rateLimiter=t,this.api=e,this.logger=r,this.options=n,this.predicates=[],this.pendingItems=[],this.pendingRequests=[],this.retryQueue=[],this.retryHandle=null,this.waitCallback=null,this.waitIntervalID=null}var o=r(5);n.prototype.configure=function(t){this.api&&this.api.configure(t);var e=this.options;return this.options=o.merge(e,t),this},n.prototype.addPredicate=function(t){return o.isFunction(t)&&this.predicates.push(t),this},n.prototype.addPendingItem=function(t){this.pendingItems.push(t)},n.prototype.removePendingItem=function(t){var e=this.pendingItems.indexOf(t);e!==-1&&this.pendingItems.splice(e,1)},n.prototype.addItem=function(t,e,r,n){e&&o.isFunction(e)||(e=function(){});var i=this._applyPredicates(t);if(i.stop)return this.removePendingItem(n),void e(i.err);this._maybeLog(t,r),this.removePendingItem(n),this.pendingRequests.push(t);try{this._makeApiRequest(t,function(r,n){this._dequeuePendingRequest(t),e(r,n)}.bind(this))}catch(r){this._dequeuePendingRequest(t),e(r)}},n.prototype.wait=function(t){o.isFunction(t)&&(this.waitCallback=t,this._maybeCallWait()||(this.waitIntervalID&&(this.waitIntervalID=clearInterval(this.waitIntervalID)),this.waitIntervalID=setInterval(function(){this._maybeCallWait()}.bind(this),500)))},n.prototype._applyPredicates=function(t){for(var e=null,r=0,n=this.predicates.length;r<n;r++)if(e=this.predicates[r](t,this.options),!e||void 0!==e.err)return{stop:!0,err:e.err};return{stop:!1,err:null}},n.prototype._makeApiRequest=function(t,e){var r=this.rateLimiter.shouldSend(t);r.shouldSend?this.api.postItem(t,function(r,n){r?this._maybeRetry(r,t,e):e(r,n)}.bind(this)):r.error?e(r.error):this.api.postItem(r.payload,e)};var i=["ECONNRESET","ENOTFOUND","ESOCKETTIMEDOUT","ETIMEDOUT","ECONNREFUSED","EHOSTUNREACH","EPIPE","EAI_AGAIN"];n.prototype._maybeRetry=function(t,e,r){var n=!1;if(this.options.retryInterval)for(var o=0,a=i.length;o<a;o++)if(t.code===i[o]){n=!0;break}n?this._retryApiRequest(e,r):r(t)},n.prototype._retryApiRequest=function(t,e){this.retryQueue.push({item:t,callback:e}),this.retryHandle||(this.retryHandle=setInterval(function(){for(;this.retryQueue.length;){var t=this.retryQueue.shift();this._makeApiRequest(t.item,t.callback)}}.bind(this),this.options.retryInterval))},n.prototype._dequeuePendingRequest=function(t){var e=this.pendingRequests.indexOf(t);e!==-1&&(this.pendingRequests.splice(e,1),this._maybeCallWait())},n.prototype._maybeLog=function(t,e){if(this.logger&&this.options.verbose){var r=e;if(r=r||o.get(t,"body.trace.exception.message"),r=r||o.get(t,"body.trace_chain.0.exception.message"))return void this.logger.error(r);r=o.get(t,"body.message.body"),r&&this.logger.log(r)}},n.prototype._maybeCallWait=function(){return!(!o.isFunction(this.waitCallback)||0!==this.pendingItems.length||0!==this.pendingRequests.length)&&(this.waitIntervalID&&(this.waitIntervalID=clearInterval(this.waitIntervalID)),this.waitCallback(),!0)},t.exports=n},function(t,e,r){"use strict";function n(t,e){this.queue=t,this.options=e,this.transforms=[]}var o=r(5);n.prototype.configure=function(t){this.queue&&this.queue.configure(t);var e=this.options;return this.options=o.merge(e,t),this},n.prototype.addTransform=function(t){return o.isFunction(t)&&this.transforms.push(t),this},n.prototype.log=function(t,e){if(e&&o.isFunction(e)||(e=function(){}),!this.options.enabled)return e(new Error("Rollbar is not enabled"));this.queue.addPendingItem(t);var r=t.err;this._applyTransforms(t,function(n,o){return n?(this.queue.removePendingItem(t),e(n,null)):void this.queue.addItem(o,e,r,t)}.bind(this))},n.prototype._applyTransforms=function(t,e){var r=-1,n=this.transforms.length,o=this.transforms,i=this.options,a=function(t,s){return t?void e(t,null):(r++,r===n?void e(null,s):void o[r](s,i,a))};a(null,t)},t.exports=n},function(t,e,r){"use strict";function n(t){this.queue=[],this.options=i.merge(t);var e=this.options.maxTelemetryEvents||a;this.maxQueueSize=Math.max(0,Math.min(e,a))}function o(t,e){if(e)return e;var r={error:"error",manual:"info"};return r[t]||"info"}var i=r(5),a=100;n.prototype.configure=function(t){var e=this.options;this.options=i.merge(e,t);var r=this.options.maxTelemetryEvents||a,n=Math.max(0,Math.min(r,a)),o=0;this.maxQueueSize>n&&(o=this.maxQueueSize-n),this.maxQueueSize=n,this.queue.splice(0,o)},n.prototype.copyEvents=function(){var t=Array.prototype.slice.call(this.queue,0);if(i.isFunction(this.options.filterTelemetry))try{for(var e=t.length;e--;)this.options.filterTelemetry(t[e])&&t.splice(e,1)}catch(t){this.options.filterTelemetry=null}return t},n.prototype.capture=function(t,e,r,n,a){var s={level:o(t,r),type:t,timestamp_ms:a||i.now(),body:e,source:"client"};n&&(s.uuid=n);try{if(i.isFunction(this.options.filterTelemetry)&&this.options.filterTelemetry(s))return!1}catch(t){this.options.filterTelemetry=null}return this.push(s),s},n.prototype.captureEvent=function(t,e,r,n){return this.capture(t,e,r,n)},n.prototype.captureError=function(t,e,r,n){var o={message:t.message||String(t)};return t.stack&&(o.stack=t.stack),this.capture("error",o,e,r,n)},n.prototype.captureLog=function(t,e,r,n){return this.capture("log",{message:t},e,r,n)},n.prototype.captureNetwork=function(t,e,r,n){e=e||"xhr",t.subtype=t.subtype||e,n&&(t.request=n);var o=this.levelFromStatus(t.status_code);return this.capture("network",t,o,r)},n.prototype.levelFromStatus=function(t){return t>=200&&t<400?"info":0===t||t>=400?"error":"info"},n.prototype.captureDom=function(t,e,r,n,o){var i={subtype:t,element:e};return void 0!==r&&(i.value=r),void 0!==n&&(i.checked=n),this.capture("dom",i,"info",o)},n.prototype.captureNavigation=function(t,e,r){return this.capture("navigation",{from:t,to:e},"info",r)},n.prototype.captureDomContentLoaded=function(t){return this.capture("navigation",{subtype:"DOMContentLoaded"},"info",void 0,t&&t.getTime())},n.prototype.captureLoad=function(t){return this.capture("navigation",{subtype:"load"},"info",void 0,t&&t.getTime())},n.prototype.captureConnectivityChange=function(t,e){return this.captureNetwork({change:t},"connectivity",e)},n.prototype._captureRollbarItem=function(t){if(this.options.includeItemsInTelemetry)return t.err?this.captureError(t.err,t.level,t.uuid,t.timestamp):t.message?this.captureLog(t.message,t.level,t.uuid,t.timestamp):t.custom?this.capture("log",t.custom,t.level,t.uuid,t.timestamp):void 0},n.prototype.push=function(t){this.queue.push(t),this.queue.length>this.maxQueueSize&&this.queue.shift()},t.exports=n},function(t,e,r){"use strict";function n(t,e,r,n){this.options=t,this.transport=e,this.url=r,this.jsonBackup=n,this.accessToken=t.accessToken,this.transportOptions=o(t,r)}function o(t,e){return a.getTransportFromOptions(t,s,e)}var i=r(5),a=r(12),s={hostname:"api.rollbar.com",path:"/api/1/item/",search:null,version:"1",protocol:"https:",port:443};n.prototype.postItem=function(t,e){var r=a.transportOptions(this.transportOptions,"POST"),n=a.buildPayload(this.accessToken,t,this.jsonBackup);this.transport.post(this.accessToken,r,n,e)},n.prototype.configure=function(t){var e=this.oldOptions;return this.options=i.merge(e,t),this.transportOptions=o(this.options,this.url),void 0!==this.options.accessToken&&(this.accessToken=this.options.accessToken),this},t.exports=n},function(t,e,r){"use strict";function n(t,e,r){if(!s.isType(e.context,"string")){var n=s.stringify(e.context,r);n.error?e.context="Error: could not serialize 'context'":e.context=n.value||"",e.context.length>255&&(e.context=e.context.substr(0,255))}return{access_token:t,data:e}}function o(t,e,r){var n=e.hostname,o=e.protocol,i=e.port,a=e.path,s=e.search,u=t.proxy;if(t.endpoint){var c=r.parse(t.endpoint);n=c.hostname,o=c.protocol,i=c.port,a=c.pathname,s=c.search}return{hostname:n,protocol:o,port:i,path:a,search:s,proxy:u}}function i(t,e){var r=t.protocol||"https:",n=t.port||("http:"===r?80:"https:"===r?443:void 0),o=t.hostname,i=t.path;
	return t.search&&(i+=t.search),t.proxy&&(i=r+"//"+o+i,o=t.proxy.host||t.proxy.hostname,n=t.proxy.port,r=t.proxy.protocol||r),{protocol:r,hostname:o,path:i,port:n,method:e}}function a(t,e){var r=/\/$/.test(t),n=/^\//.test(e);return r&&n?e=e.substring(1):r||n||(e="/"+e),t+e}var s=r(5);t.exports={buildPayload:n,getTransportFromOptions:o,transportOptions:i,appendPathToPath:a}},function(t,e,r){"use strict";function n(){var t=Array.prototype.slice.call(arguments,0);t.unshift("Rollbar:"),a.ieVersion()<=8?console.error(s.formatArgsAsString(t)):console.error.apply(console,t)}function o(){var t=Array.prototype.slice.call(arguments,0);t.unshift("Rollbar:"),a.ieVersion()<=8?console.info(s.formatArgsAsString(t)):console.info.apply(console,t)}function i(){var t=Array.prototype.slice.call(arguments,0);t.unshift("Rollbar:"),a.ieVersion()<=8?console.log(s.formatArgsAsString(t)):console.log.apply(console,t)}r(14);var a=r(15),s=r(5);t.exports={error:n,info:o,log:i}},function(t,e){!function(t){"use strict";t.console||(t.console={});for(var e,r,n=t.console,o=function(){},i=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=i.pop();)n[e]||(n[e]={});for(;r=a.pop();)n[r]||(n[r]=o)}("undefined"==typeof window?this:window)},function(t,e){"use strict";function r(){var t;if(!document)return t;for(var e=3,r=document.createElement("div"),n=r.getElementsByTagName("i");r.innerHTML="<!--[if gt IE "+ ++e+"]><i></i><![endif]-->",n[0];);return e>4?e:t}var n={ieVersion:r};t.exports=n},function(t,e){"use strict";function r(t,e,r){if(t){var o;if("function"==typeof e._rollbarOldOnError)o=e._rollbarOldOnError;else if(t.onerror){for(o=t.onerror;o._rollbarOldOnError;)o=o._rollbarOldOnError;e._rollbarOldOnError=o}var i=function(){var r=Array.prototype.slice.call(arguments,0);n(t,e,o,r)};r&&(i._rollbarOldOnError=o),t.onerror=i}}function n(t,e,r,n){t._rollbarWrappedError&&(n[4]||(n[4]=t._rollbarWrappedError),n[5]||(n[5]=t._rollbarWrappedError._rollbarContext),t._rollbarWrappedError=null),e.handleUncaughtException.apply(e,n),r&&r.apply(t,n)}function o(t,e,r){if(t){"function"==typeof t._rollbarURH&&t._rollbarURH.belongsToShim&&t.removeEventListener("unhandledrejection",t._rollbarURH);var n=function(t){var r,n,o;try{r=t.reason}catch(t){r=void 0}try{n=t.promise}catch(t){n="[unhandledrejection] error getting `promise` from event"}try{o=t.detail,!r&&o&&(r=o.reason,n=o.promise)}catch(t){}r||(r="[unhandledrejection] error getting `reason` from event"),e&&e.handleUnhandledRejection&&e.handleUnhandledRejection(r,n)};n.belongsToShim=r,t._rollbarURH=n,t.addEventListener("unhandledrejection",n)}}function i(t,e,r){if(t){var n,o,i="EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");for(n=0;n<i.length;++n)o=i[n],t[o]&&t[o].prototype&&a(e,t[o].prototype,r)}}function a(t,e,r){if(e.hasOwnProperty&&e.hasOwnProperty("addEventListener")){for(var n=e.addEventListener;n._rollbarOldAdd&&n.belongsToShim;)n=n._rollbarOldAdd;var o=function(e,r,o){n.call(this,e,t.wrap(r),o)};o._rollbarOldAdd=n,o.belongsToShim=r,e.addEventListener=o;for(var i=e.removeEventListener;i._rollbarOldRemove&&i.belongsToShim;)i=i._rollbarOldRemove;var a=function(t,e,r){i.call(this,t,e&&e._rollbar_wrapped||e,r)};a._rollbarOldRemove=i,a.belongsToShim=r,e.removeEventListener=a}}t.exports={captureUncaughtExceptions:r,captureUnhandledRejections:o,wrapGlobals:i}},function(t,e,r){"use strict";function n(t,e,r,n,o){n&&p.isFunction(n)||(n=function(){}),p.addParamsAndAccessTokenToPath(t,e,r);var a="GET",s=p.formatUrl(e);i(t,s,a,null,n,o)}function o(t,e,r,n,o){if(n&&p.isFunction(n)||(n=function(){}),!r)return n(new Error("Cannot send empty request"));var a=f.truncate(r);if(a.error)return n(a.error);var s=a.value,u="POST",c=p.formatUrl(e);i(t,c,u,s,n,o)}function i(t,e,r,n,o,i){var s="undefined"!=typeof window&&window||"undefined"!=typeof self&&self,u=s&&s.Zone&&s.Zone.current;if(u&&"angular"===u._name){var c=u._parent;c.run(function(){a(t,e,r,n,o,i)})}else a(t,e,r,n,o,i)}function a(t,e,r,n,o,i){var a;if(a=i?i():s(),!a)return o(new Error("No way to send a request"));try{try{var f=function(){try{if(f&&4===a.readyState){f=void 0;var t=p.jsonParse(a.responseText);if(u(a))return void o(t.error,t.value);if(c(a)){if(403===a.status){var e=t.value&&t.value.message;h.error(e)}o(new Error(String(a.status)))}else{var r="XHR response had no status code (likely connection failure)";o(l(r))}}}catch(t){var n;n=t&&t.stack?t:new Error(t),o(n)}};a.open(r,e,!0),a.setRequestHeader&&(a.setRequestHeader("Content-Type","application/json"),a.setRequestHeader("X-Rollbar-Access-Token",t)),a.onreadystatechange=f,a.send(n)}catch(t){if("undefined"!=typeof XDomainRequest){if(!window||!window.location)return o(new Error("No window available during request, unknown environment"));"http:"===window.location.href.substring(0,5)&&"https"===e.substring(0,5)&&(e="http"+e.substring(5));var d=new XDomainRequest;d.onprogress=function(){},d.ontimeout=function(){var t="Request timed out",e="ETIMEDOUT";o(l(t,e))},d.onerror=function(){o(new Error("Error during request"))},d.onload=function(){var t=p.jsonParse(d.responseText);o(t.error,t.value)},d.open(r,e,!0),d.send(n)}else o(new Error("Cannot find a method to transport a request"))}}catch(t){o(t)}}function s(){var t,e,r=[function(){return new XMLHttpRequest},function(){return new ActiveXObject("Msxml2.XMLHTTP")},function(){return new ActiveXObject("Msxml3.XMLHTTP")},function(){return new ActiveXObject("Microsoft.XMLHTTP")}],n=r.length;for(e=0;e<n;e++)try{t=r[e]();break}catch(t){}return t}function u(t){return t&&t.status&&200===t.status}function c(t){return t&&p.isType(t.status,"number")&&t.status>=400&&t.status<600}function l(t,e){var r=new Error(t);return r.code=e||"ENOTFOUND",r}var p=r(5),f=r(18),h=r(13);t.exports={get:n,post:o}},function(t,e,r){"use strict";function n(t,e){return[t,f.stringify(t,e)]}function o(t,e){var r=t.length;return r>2*e?t.slice(0,e).concat(t.slice(r-e)):t}function i(t,e,r){r="undefined"==typeof r?30:r;var n,i=t.data.body;if(i.trace_chain)for(var a=i.trace_chain,s=0;s<a.length;s++)n=a[s].frames,n=o(n,r),a[s].frames=n;else i.trace&&(n=i.trace.frames,n=o(n,r),i.trace.frames=n);return[t,f.stringify(t,e)]}function a(t,e){return e&&e.length>t?e.slice(0,t-3).concat("..."):e}function s(t,e,r){function n(e,r,o){switch(f.typeName(r)){case"string":return a(t,r);case"object":case"array":return f.traverse(r,n,o);default:return r}}return e=f.traverse(e,n,[]),[e,f.stringify(e,r)]}function u(t){return t.exception&&(delete t.exception.description,t.exception.message=a(255,t.exception.message)),t.frames=o(t.frames,1),t}function c(t,e){var r=t.data.body;if(r.trace_chain)for(var n=r.trace_chain,o=0;o<n.length;o++)n[o]=u(n[o]);else r.trace&&(r.trace=u(r.trace));return[t,f.stringify(t,e)]}function l(t,e){return t.length>e}function p(t,e,r){r="undefined"==typeof r?524288:r;for(var o,a,u,p=[n,i,s.bind(null,1024),s.bind(null,512),s.bind(null,256),c];o=p.shift();)if(a=o(t,e),t=a[0],u=a[1],u.error||!l(u.value,r))return u;return u}var f=r(5);t.exports={truncate:p,raw:n,truncateFrames:i,truncateStrings:s,maybeTruncateValue:a}},function(t,e){"use strict";function r(t){var e,r,n={protocol:null,auth:null,host:null,path:null,hash:null,href:t,hostname:null,port:null,pathname:null,search:null,query:null};if(e=t.indexOf("//"),e!==-1?(n.protocol=t.substring(0,e),r=e+2):r=0,e=t.indexOf("@",r),e!==-1&&(n.auth=t.substring(r,e),r=e+1),e=t.indexOf("/",r),e===-1){if(e=t.indexOf("?",r),e===-1)return e=t.indexOf("#",r),e===-1?n.host=t.substring(r):(n.host=t.substring(r,e),n.hash=t.substring(e)),n.hostname=n.host.split(":")[0],n.port=n.host.split(":")[1],n.port&&(n.port=parseInt(n.port,10)),n;n.host=t.substring(r,e),n.hostname=n.host.split(":")[0],n.port=n.host.split(":")[1],n.port&&(n.port=parseInt(n.port,10)),r=e}else n.host=t.substring(r,e),n.hostname=n.host.split(":")[0],n.port=n.host.split(":")[1],n.port&&(n.port=parseInt(n.port,10)),r=e;if(e=t.indexOf("#",r),e===-1?n.path=t.substring(r):(n.path=t.substring(r,e),n.hash=t.substring(e)),n.path){var o=n.path.split("?");n.pathname=o[0],n.query=o[1],n.search=n.query?"?"+n.query:null}return n}t.exports={parse:r}},function(t,e,r){"use strict";function n(t,e,r){if(t.data=t.data||{},t.err)try{t.stackInfo=t.err._savedStackTrace||d.parse(t.err)}catch(e){m.error("Error while parsing the error object.",e);try{t.message=t.err.message||t.err.description||t.message||String(t.err)}catch(e){t.message=String(t.err)||String(e)}delete t.err}r(null,t)}function o(t,e,r){t.message||t.stackInfo||t.custom||r(new Error("No message, stack info, or custom data"),null),r(null,t)}function i(t,e,r){var n=e.payload&&e.payload.environment||e.environment;t.data=h.merge(t.data,{environment:n,level:t.level,endpoint:e.endpoint,platform:"browser",framework:"browser-js",language:"javascript",server:{},uuid:t.uuid,notifier:{name:"rollbar-browser-js",version:e.version}}),r(null,t)}function a(t){return function(e,r,n){if(!t||!t.location)return n(null,e);var o="$remote_ip";r.captureIp?r.captureIp!==!0&&(o+="_anonymize"):o=null,h.set(e,"data.request",{url:t.location.href,query_string:t.location.search,user_ip:o}),n(null,e)}}function s(t){return function(e,r,n){if(!t)return n(null,e);var o=t.navigator||{},i=t.screen||{};h.set(e,"data.client",{runtime_ms:e.timestamp-t._rollbarStartTime,timestamp:Math.round(e.timestamp/1e3),javascript:{browser:o.userAgent,language:o.language,cookie_enabled:o.cookieEnabled,screen:{width:i.width,height:i.height}}}),n(null,e)}}function u(t){return function(e,r,n){if(!t||!t.navigator)return n(null,e);for(var o,i=[],a=t.navigator.plugins||[],s=0,u=a.length;s<u;++s)o=a[s],i.push({name:o.name,description:o.description});h.set(e,"data.client.javascript.plugins",i),n(null,e)}}function c(t,e,r){t.stackInfo?p(t,e,r):l(t,e,r)}function l(t,e,r){var n=t.message,o=t.custom;if(!n)if(o){var i=e.scrubFields,a=h.stringify(h.scrub(o,i));n=a.error||a.value||""}else n="";var s={body:n};o&&(s.extra=h.merge(o)),h.set(t,"data.body",{message:s}),r(null,t)}function p(t,e,r){var n=t.data.description,o=t.stackInfo,i=t.custom,a=d.guessErrorClass(o.message),s=o.name||a[0],u=a[1],c={exception:{class:s,message:u}};n&&(c.exception.description=n);var p=o.stack;if(p&&0===p.length&&t._unhandledStackInfo&&t._unhandledStackInfo.stack&&(p=t._unhandledStackInfo.stack),p){0===p.length&&(c.exception.stack=o.rawStack,c.exception.raw=String(o.rawException));var f,m,g,v,y,b,w,_;for(c.frames=[],w=0;w<p.length;++w)f=p[w],m={filename:f.url?h.sanitizeUrl(f.url):"(unknown)",lineno:f.line||null,method:f.func&&"?"!==f.func?f.func:"[anonymous]",colno:f.column},e.sendFrameUrl&&(m.url=f.url),m.method&&m.method.endsWith&&m.method.endsWith("_rollbar_wrapped")||(g=v=y=null,b=f.context?f.context.length:0,b&&(_=Math.floor(b/2),v=f.context.slice(0,_),g=f.context[_],y=f.context.slice(_)),g&&(m.code=g),(v||y)&&(m.context={},v&&v.length&&(m.context.pre=v),y&&y.length&&(m.context.post=y)),f.args&&(m.args=f.args),c.frames.push(m));c.frames.reverse(),i&&(c.extra=h.merge(i)),h.set(t,"data.body",{trace:c}),r(null,t)}else t.message=s+": "+u,l(t,e,r)}function f(t,e,r){var n=e.scrubFields;t.data=h.scrub(t.data,n),r(null,t)}var h=r(5),d=r(21),m=r(13);t.exports={handleItemWithError:n,ensureItemHasSomethingToSay:o,addBaseInfo:i,addRequestInfo:a,addClientInfo:s,addPluginInfo:u,addBody:c,scrubPayload:f}},function(t,e,r){"use strict";function n(){return l}function o(){return null}function i(t){var e={};return e._stackFrame=t,e.url=t.fileName,e.line=t.lineNumber,e.func=t.functionName,e.column=t.columnNumber,e.args=t.args,e.context=o(),e}function a(t){function e(){var e,r=[];if(t.stack)e=t;else try{throw t}catch(t){e=t}try{r=c.parse(e)}catch(t){r=[]}for(var n=[],o=0;o<r.length;o++)n.push(new i(r[o]));return n}var r=t.constructor&&t.constructor.name;return(!r||!r.length||r.length<3)&&(r=t.name),{stack:e(),message:t.message,name:r,rawStack:t.stack,rawException:t}}function s(t){return new a(t)}function u(t){if(!t||!t.match)return["Unknown error. There was no error message to display.",""];var e=t.match(p),r="(unknown)";return e&&(r=e[e.length-1],t=t.replace((e[e.length-2]||"")+r+":",""),t=t.replace(/(^[\s]+|[\s]+$)/g,"")),[r,t]}var c=r(22),l="?",p=new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");t.exports={guessFunctionName:n,guessErrorClass:u,gatherContext:o,parse:s,Stack:a,Frame:i}},function(t,e,r){var n,o,i;!function(a,s){"use strict";o=[r(23)],n=s,i="function"==typeof n?n.apply(e,o):n,!(void 0!==i&&(t.exports=i))}(this,function(t){"use strict";function e(t,e,r){if("function"==typeof Array.prototype.map)return t.map(e,r);for(var n=new Array(t.length),o=0;o<t.length;o++)n[o]=e.call(r,t[o]);return n}function r(t,e,r){if("function"==typeof Array.prototype.filter)return t.filter(e,r);for(var n=[],o=0;o<t.length;o++)e.call(r,t[o])&&n.push(t[o]);return n}var n=/(^|@)\S+\:\d+/,o=/^\s*at .*(\S+\:\d+|\(native\))/m,i=/^(eval@)?(\[native code\])?$/;return{parse:function(t){if("undefined"!=typeof t.stacktrace||"undefined"!=typeof t["opera#sourceloc"])return this.parseOpera(t);if(t.stack&&t.stack.match(o))return this.parseV8OrIE(t);if(t.stack)return this.parseFFOrSafari(t);throw new Error("Cannot parse given Error object")},extractLocation:function(t){if(t.indexOf(":")===-1)return[t];var e=t.replace(/[\(\)\s]/g,"").split(":"),r=e.pop(),n=e[e.length-1];if(!isNaN(parseFloat(n))&&isFinite(n)){var o=e.pop();return[e.join(":"),o,r]}return[e.join(":"),r,void 0]},parseV8OrIE:function(n){var i=r(n.stack.split("\n"),function(t){return!!t.match(o)},this);return e(i,function(e){e.indexOf("(eval ")>-1&&(e=e.replace(/eval code/g,"eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g,""));var r=e.replace(/^\s+/,"").replace(/\(eval code/g,"(").split(/\s+/).slice(1),n=this.extractLocation(r.pop()),o=r.join(" ")||void 0,i="eval"===n[0]?void 0:n[0];return new t(o,void 0,i,n[1],n[2],e)},this)},parseFFOrSafari:function(n){var o=r(n.stack.split("\n"),function(t){return!t.match(i)},this);return e(o,function(e){if(e.indexOf(" > eval")>-1&&(e=e.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g,":$1")),e.indexOf("@")===-1&&e.indexOf(":")===-1)return new t(e);var r=e.split("@"),n=this.extractLocation(r.pop()),o=r.shift()||void 0;return new t(o,void 0,n[0],n[1],n[2],e)},this)},parseOpera:function(t){return!t.stacktrace||t.message.indexOf("\n")>-1&&t.message.split("\n").length>t.stacktrace.split("\n").length?this.parseOpera9(t):t.stack?this.parseOpera11(t):this.parseOpera10(t)},parseOpera9:function(e){for(var r=/Line (\d+).*script (?:in )?(\S+)/i,n=e.message.split("\n"),o=[],i=2,a=n.length;i<a;i+=2){var s=r.exec(n[i]);s&&o.push(new t(void 0,void 0,s[2],s[1],void 0,n[i]))}return o},parseOpera10:function(e){for(var r=/Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i,n=e.stacktrace.split("\n"),o=[],i=0,a=n.length;i<a;i+=2){var s=r.exec(n[i]);s&&o.push(new t(s[3]||void 0,void 0,s[2],s[1],void 0,n[i]))}return o},parseOpera11:function(o){var i=r(o.stack.split("\n"),function(t){return!!t.match(n)&&!t.match(/^Error created at/)},this);return e(i,function(e){var r,n=e.split("@"),o=this.extractLocation(n.pop()),i=n.shift()||"",a=i.replace(/<anonymous function(: (\w+))?>/,"$2").replace(/\([^\)]*\)/g,"")||void 0;i.match(/\(([^\)]*)\)/)&&(r=i.replace(/^[^\(]+\(([^\)]*)\)$/,"$1"));var s=void 0===r||"[arguments not available]"===r?void 0:r.split(",");return new t(a,s,o[0],o[1],o[2],e)},this)}}})},function(t,e,r){var n,o,i;!function(r,a){"use strict";o=[],n=a,i="function"==typeof n?n.apply(e,o):n,!(void 0!==i&&(t.exports=i))}(this,function(){"use strict";function t(t){return!isNaN(parseFloat(t))&&isFinite(t)}function e(t,e,r,n,o,i){void 0!==t&&this.setFunctionName(t),void 0!==e&&this.setArgs(e),void 0!==r&&this.setFileName(r),void 0!==n&&this.setLineNumber(n),void 0!==o&&this.setColumnNumber(o),void 0!==i&&this.setSource(i)}return e.prototype={getFunctionName:function(){return this.functionName},setFunctionName:function(t){this.functionName=String(t)},getArgs:function(){return this.args},setArgs:function(t){if("[object Array]"!==Object.prototype.toString.call(t))throw new TypeError("Args must be an Array");this.args=t},getFileName:function(){return this.fileName},setFileName:function(t){this.fileName=String(t)},getLineNumber:function(){return this.lineNumber},setLineNumber:function(e){if(!t(e))throw new TypeError("Line Number must be a Number");this.lineNumber=Number(e)},getColumnNumber:function(){return this.columnNumber},setColumnNumber:function(e){if(!t(e))throw new TypeError("Column Number must be a Number");this.columnNumber=Number(e)},getSource:function(){return this.source},setSource:function(t){this.source=String(t)},toString:function(){var e=this.getFunctionName()||"{anonymous}",r="("+(this.getArgs()||[]).join(",")+")",n=this.getFileName()?"@"+this.getFileName():"",o=t(this.getLineNumber())?":"+this.getLineNumber():"",i=t(this.getColumnNumber())?":"+this.getColumnNumber():"";return e+r+n+o+i}},e})},function(t,e,r){"use strict";function n(t,e,r){var n=e.payload||{};n.body&&delete n.body;var o=u.merge(t.data,n);t._isUncaught&&(o._isUncaught=!0),t._originalArgs&&(o._originalArgs=t._originalArgs),r(null,o)}function o(t,e,r){t.telemetryEvents&&u.set(t,"data.body.telemetry",t.telemetryEvents),r(null,t)}function i(t,e,r){if(!t.message)return void r(null,t);var n="data.body.trace_chain.0",o=u.get(t,n);if(o||(n="data.body.trace",o=u.get(t,n)),o){if(!o.exception||!o.exception.description)return u.set(t,n+".exception.description",t.message),void r(null,t);var i=u.get(t,n+".extra")||{},a=u.merge(i,{message:t.message});u.set(t,n+".extra",a)}r(null,t)}function a(t){return function(e,r,n){var o=u.merge(e);try{u.isFunction(r.transform)&&r.transform(o.data,e)}catch(o){return r.transform=null,t.error("Error while calling custom transform() function. Removing custom transform().",o),void n(null,e)}n(null,o)}}function s(t,e,r){if(!e.sendConfig)return r(null,t);var n="_rollbarConfig",o=u.get(t,"data.custom")||{};o[n]=e,t.data.custom=o,r(null,t)}var u=r(5);t.exports={itemToPayload:n,addTelemetryData:o,addMessageWithError:i,userTransform:a,addConfigToPayload:s}},function(t,e,r){"use strict";function n(t,e){return!o.get(e,"plugins.jquery.ignoreAjaxErrors")||!o.get(t,"body.message.extra.isAjax")}var o=r(5);t.exports={checkIgnore:n}},function(t,e,r){"use strict";function n(t,e){var r=t.level,n=c.LEVELS[r]||0,o=e.reportLevel,i=c.LEVELS[o]||0;return!(n<i)}function o(t){return function(e,r){var n=!!e._isUncaught;delete e._isUncaught;var o=e._originalArgs;delete e._originalArgs;try{c.isFunction(r.onSendCallback)&&r.onSendCallback(n,o,e)}catch(e){r.onSendCallback=null,t.error("Error while calling onSendCallback, removing",e)}try{if(c.isFunction(r.checkIgnore)&&r.checkIgnore(n,o,e))return!1}catch(e){r.checkIgnore=null,t.error("Error while calling custom checkIgnore(), removing",e)}return!0}}function i(t){return function(e,r){return!s(e,r,"blacklist",t)}}function a(t){return function(e,r){return s(e,r,"whitelist",t)}}function s(t,e,r,n){var o=!1;"blacklist"===r&&(o=!0);var i,a,s,u,l,p,f,h,d,m;try{if(i=o?e.hostBlackList:e.hostWhiteList,f=i&&i.length,a=c.get(t,"body.trace"),!i||0===f)return!o;if(!a||!a.frames||0===a.frames.length)return!o;for(l=a.frames.length,d=0;d<l;d++){if(s=a.frames[d],u=s.filename,!c.isType(u,"string"))return!o;for(m=0;m<f;m++)if(p=i[m],h=new RegExp(p),h.test(u))return!0}}catch(t){o?e.hostBlackList=null:e.hostWhiteList=null;var g=o?"hostBlackList":"hostWhiteList";return n.error("Error while reading your configuration's "+g+" option. Removing custom "+g+".",t),!o}return!1}function u(t){return function(e,r){var n,o,i,a,s,u,l,p,f;try{if(s=!1,i=r.ignoredMessages,!i||0===i.length)return!0;if(l=e.body,p=c.get(l,"trace.exception.message"),f=c.get(l,"message.body"),n=p||f,!n)return!0;for(a=i.length,o=0;o<a&&(u=new RegExp(i[o],"gi"),!(s=u.test(n)));o++);}catch(e){r.ignoredMessages=null,t.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.")}return!s}}var c=r(5);t.exports={checkLevel:n,userCheckIgnore:o,urlIsNotBlacklisted:i,urlIsWhitelisted:a,messageIsIgnored:u}},function(t,e,r){"use strict";function n(t,e,r,n,o){var i=t[e];t[e]=r(i),n&&n[o].push([t,e,i])}function o(t,e){for(var r;t[e].length;)r=t[e].shift(),r[0][r[1]]=r[2]}function i(t){if(!t||!t.attributes)return null;for(var e=t.attributes,r=0;r<e.length;++r)if("name"===e[r].key)return e[r].value;return null}function a(t){for(var e=[],r=0;r<t.length;++r)e.push(new RegExp(t[r],"i"));return function(t){var r=i(t);if(!r)return!1;for(var n=0;n<e.length;++n)if(e[n].test(r))return!0;return!1}}function s(t,e,r,n,o){var i=t.autoInstrument;t.enabled===!1||i===!1?this.autoInstrument={}:(u.isType(i,"object")||(i=p),this.autoInstrument=u.merge(p,i)),this.scrubTelemetryInputs=!!t.scrubTelemetryInputs,this.telemetryScrubber=t.telemetryScrubber,this.defaultValueScrubber=a(t.scrubFields),this.telemeter=e,this.rollbar=r,this._window=n||{},this._document=o||{},this.replacements={network:[],log:[],navigation:[],connectivity:[]},this.eventRemovers={dom:[],connectivity:[]},this._location=this._window.location,this._lastHref=this._location&&this._location.href}var u=r(5),c=r(19),l=r(28),p={network:!0,networkResponseHeaders:!1,networkResponseBody:!1,networkRequestBody:!1,log:!0,dom:!0,navigation:!0,connectivity:!0};s.prototype.configure=function(t){var e=t.autoInstrument,r=u.merge(this.autoInstrument);t.enabled===!1||e===!1?this.autoInstrument={}:(u.isType(e,"object")||(e=p),this.autoInstrument=u.merge(p,e)),this.instrument(r),void 0!==t.scrubTelemetryInputs&&(this.scrubTelemetryInputs=!!t.scrubTelemetryInputs),void 0!==t.telemetryScrubber&&(this.telemetryScrubber=t.telemetryScrubber)},s.prototype.instrument=function(t){!this.autoInstrument.network||t&&t.network?!this.autoInstrument.network&&t&&t.network&&this.deinstrumentNetwork():this.instrumentNetwork(),!this.autoInstrument.log||t&&t.log?!this.autoInstrument.log&&t&&t.log&&this.deinstrumentConsole():this.instrumentConsole(),!this.autoInstrument.dom||t&&t.dom?!this.autoInstrument.dom&&t&&t.dom&&this.deinstrumentDom():this.instrumentDom(),!this.autoInstrument.navigation||t&&t.navigation?!this.autoInstrument.navigation&&t&&t.navigation&&this.deinstrumentNavigation():this.instrumentNavigation(),!this.autoInstrument.connectivity||t&&t.connectivity?!this.autoInstrument.connectivity&&t&&t.connectivity&&this.deinstrumentConnectivity():this.instrumentConnectivity()},s.prototype.deinstrumentNetwork=function(){o(this.replacements,"network")},s.prototype.instrumentNetwork=function(){function t(t,r){t in r&&u.isFunction(r[t])&&n(r,t,function(t){return e.rollbar.wrap(t)})}var e=this;if("XMLHttpRequest"in this._window){var r=this._window.XMLHttpRequest.prototype;n(r,"open",function(t){return function(e,r){return u.isType(r,"string")&&(this.__rollbar_xhr={method:e,url:r,status_code:null,start_time_ms:u.now(),end_time_ms:null}),t.apply(this,arguments)}},this.replacements,"network"),n(r,"send",function(r){return function(o){function i(){if(a.__rollbar_xhr){if(null===a.__rollbar_xhr.status_code){a.__rollbar_xhr.status_code=0;var t=null;e.autoInstrument.networkRequestBody&&(t=o),a.__rollbar_event=e.telemeter.captureNetwork(a.__rollbar_xhr,"xhr",void 0,t)}if(a.readyState<2&&(a.__rollbar_xhr.start_time_ms=u.now()),a.readyState>3){a.__rollbar_xhr.end_time_ms=u.now();var r=null;if(e.autoInstrument.networkResponseHeaders){var n=e.autoInstrument.networkResponseHeaders;r={};try{var i,s;if(n===!0){var c=a.getAllResponseHeaders();if(c){var l,p,f=c.trim().split(/[\r\n]+/);for(s=0;s<f.length;s++)l=f[s].split(": "),i=l.shift(),p=l.join(": "),r[i]=p}}else for(s=0;s<n.length;s++)i=n[s],r[i]=a.getResponseHeader(i)}catch(t){}}var h=null;if(e.autoInstrument.networkResponseBody)try{h=a.responseText}catch(t){}var d=null;(h||r)&&(d={},h&&(d.body=h),r&&(d.headers=r)),d&&(a.__rollbar_xhr.response=d);try{var m=a.status;m=1223===m?204:m,a.__rollbar_xhr.status_code=m,a.__rollbar_event.level=e.telemeter.levelFromStatus(m)}catch(t){}}}}var a=this;return t("onload",a),t("onerror",a),t("onprogress",a),"onreadystatechange"in a&&u.isFunction(a.onreadystatechange)?n(a,"onreadystatechange",function(t){return e.rollbar.wrap(t,void 0,i)}):a.onreadystatechange=i,r.apply(this,arguments)}},this.replacements,"network")}"fetch"in this._window&&n(this._window,"fetch",function(t){return function(r,n){for(var o=new Array(arguments.length),i=0,a=o.length;i<a;i++)o[i]=arguments[i];var s,c=o[0],l="GET";u.isType(c,"string")?s=c:c&&(s=c.url,c.method&&(l=c.method)),o[1]&&o[1].method&&(l=o[1].method);var p={method:l,url:s,status_code:null,start_time_ms:u.now(),end_time_ms:null},f=null;return e.autoInstrument.networkRequestBody&&(o[1]&&o[1].body?f=o[1].body:o[0]&&!u.isType(o[0],"string")&&o[0].body&&(f=o[0].body)),e.telemeter.captureNetwork(p,"fetch",void 0,f),t.apply(this,o).then(function(t){p.end_time_ms=u.now(),p.status_code=t.status;var r=null;if(e.autoInstrument.networkResponseHeaders){var n=e.autoInstrument.networkResponseHeaders;r={};try{if(n===!0);else for(var o=0;o<n.length;o++){var i=n[o];r[i]=t.headers.get(i)}}catch(t){}}var a=null;return r&&(a={headers:r}),a&&(p.response=a),t})}},this.replacements,"network")},s.prototype.deinstrumentConsole=function(){if("console"in this._window&&this._window.console.log)for(var t;this.replacements.log.length;)t=this.replacements.log.shift(),this._window.console[t[0]]=t[1]},s.prototype.instrumentConsole=function(){function t(t){var n=r[t],o=r,i="warn"===t?"warning":t;r[t]=function(){var t=Array.prototype.slice.call(arguments),r=u.formatArgsAsString(t);e.telemeter.captureLog(r,i),n&&Function.prototype.apply.call(n,o,t)},e.replacements.log.push([t,n])}if("console"in this._window&&this._window.console.log)for(var e=this,r=this._window.console,n=["debug","info","warn","error","log"],o=0,i=n.length;o<i;o++)t(n[o])},s.prototype.deinstrumentDom=function(){("addEventListener"in this._window||"attachEvent"in this._window)&&this.removeListeners("dom")},s.prototype.instrumentDom=function(){if("addEventListener"in this._window||"attachEvent"in this._window){var t=this.handleClick.bind(this),e=this.handleBlur.bind(this);this.addListener("dom",this._window,"click","onclick",t,!0),this.addListener("dom",this._window,"blur","onfocusout",e,!0)}},s.prototype.handleClick=function(t){try{var e=l.getElementFromEvent(t,this._document),r=e&&e.tagName,n=l.isDescribedElement(e,"a")||l.isDescribedElement(e,"button");r&&(n||l.isDescribedElement(e,"input",["button","submit"]))?this.captureDomEvent("click",e):l.isDescribedElement(e,"input",["checkbox","radio"])&&this.captureDomEvent("input",e,e.value,e.checked)}catch(t){}},s.prototype.handleBlur=function(t){try{var e=l.getElementFromEvent(t,this._document);e&&e.tagName&&(l.isDescribedElement(e,"textarea")?this.captureDomEvent("input",e,e.value):l.isDescribedElement(e,"select")&&e.options&&e.options.length?this.handleSelectInputChanged(e):l.isDescribedElement(e,"input")&&!l.isDescribedElement(e,"input",["button","submit","hidden","checkbox","radio"])&&this.captureDomEvent("input",e,e.value))}catch(t){}},s.prototype.handleSelectInputChanged=function(t){if(t.multiple)for(var e=0;e<t.options.length;e++)t.options[e].selected&&this.captureDomEvent("input",t,t.options[e].value);else t.selectedIndex>=0&&t.options[t.selectedIndex]&&this.captureDomEvent("input",t,t.options[t.selectedIndex].value)},s.prototype.captureDomEvent=function(t,e,r,n){if(void 0!==r)if(this.scrubTelemetryInputs||"password"===l.getElementType(e))r="[scrubbed]";else{var o=l.describeElement(e);this.telemetryScrubber?this.telemetryScrubber(o)&&(r="[scrubbed]"):this.defaultValueScrubber(o)&&(r="[scrubbed]")}var i=l.elementArrayToString(l.treeToArray(e));this.telemeter.captureDom(t,i,r,n)},s.prototype.deinstrumentNavigation=function(){var t=this._window.chrome,e=t&&t.app&&t.app.runtime,r=!e&&this._window.history&&this._window.history.pushState;r&&o(this.replacements,"navigation")},s.prototype.instrumentNavigation=function(){var t=this._window.chrome,e=t&&t.app&&t.app.runtime,r=!e&&this._window.history&&this._window.history.pushState;if(r){var o=this;n(this._window,"onpopstate",function(t){return function(){var e=o._location.href;o.handleUrlChange(o._lastHref,e),t&&t.apply(this,arguments)}},this.replacements,"navigation"),n(this._window.history,"pushState",function(t){return function(){var e=arguments.length>2?arguments[2]:void 0;return e&&o.handleUrlChange(o._lastHref,e+""),t.apply(this,arguments)}},this.replacements,"navigation")}},s.prototype.handleUrlChange=function(t,e){var r=c.parse(this._location.href),n=c.parse(e),o=c.parse(t);this._lastHref=e,r.protocol===n.protocol&&r.host===n.host&&(e=n.path+(n.hash||"")),r.protocol===o.protocol&&r.host===o.host&&(t=o.path+(o.hash||"")),this.telemeter.captureNavigation(t,e)},s.prototype.deinstrumentConnectivity=function(){("addEventListener"in this._window||"body"in this._document)&&(this._window.addEventListener?this.removeListeners("connectivity"):o(this.replacements,"connectivity"))},s.prototype.instrumentConnectivity=function(){if("addEventListener"in this._window||"body"in this._document)if(this._window.addEventListener)this.addListener("connectivity",this._window,"online",void 0,function(){this.telemeter.captureConnectivityChange("online")}.bind(this),!0),this.addListener("connectivity",this._window,"offline",void 0,function(){this.telemeter.captureConnectivityChange("offline")}.bind(this),!0);else{var t=this;n(this._document.body,"ononline",function(e){return function(){t.telemeter.captureConnectivityChange("online"),e&&e.apply(this,arguments)}},this.replacements,"connectivity"),n(this._document.body,"onoffline",function(e){return function(){t.telemeter.captureConnectivityChange("offline"),e&&e.apply(this,arguments)}},this.replacements,"connectivity")}},s.prototype.addListener=function(t,e,r,n,o,i){e.addEventListener?(e.addEventListener(r,o,i),this.eventRemovers[t].push(function(){e.removeEventListener(r,o,i)})):n&&(e.attachEvent(n,o),this.eventRemovers[t].push(function(){e.detachEvent(n,o)}))},s.prototype.removeListeners=function(t){for(var e;this.eventRemovers[t].length;)(e=this.eventRemovers[t].shift())()},t.exports=s},function(t,e){"use strict";function r(t){return(t.getAttribute("type")||"").toLowerCase()}function n(t,e,n){if(t.tagName.toLowerCase()!==e.toLowerCase())return!1;if(!n)return!0;t=r(t);for(var o=0;o<n.length;o++)if(n[o]===t)return!0;return!1}function o(t,e){return t.target?t.target:e&&e.elementFromPoint?e.elementFromPoint(t.clientX,t.clientY):void 0}function i(t){for(var e,r=5,n=[],o=0;t&&o<r&&(e=u(t),"html"!==e.tagName);o++)n.unshift(e),t=t.parentNode;return n}function a(t){for(var e,r,n=80,o=" > ",i=o.length,a=[],u=0,c=t.length-1;c>=0;c--){if(e=s(t[c]),r=u+a.length*i+e.length,c<t.length-1&&r>=n+3){a.unshift("...");break}a.unshift(e),u+=e.length}return a.join(o)}function s(t){if(!t||!t.tagName)return"";var e=[t.tagName];t.id&&e.push("#"+t.id),t.classes&&e.push("."+t.classes.join("."));for(var r=0;r<t.attributes.length;r++)e.push("["+t.attributes[r].key+'="'+t.attributes[r].value+'"]');return e.join("")}function u(t){if(!t||!t.tagName)return null;var e,r,n,o,i={};i.tagName=t.tagName.toLowerCase(),t.id&&(i.id=t.id),e=t.className,e&&"string"==typeof e&&(i.classes=e.split(/\s+/));var a=["type","name","title","alt"];for(i.attributes=[],o=0;o<a.length;o++)r=a[o],n=t.getAttribute(r),n&&i.attributes.push({key:r,value:n});return i}t.exports={describeElement:u,descriptionToString:s,elementArrayToString:a,treeToArray:i,getElementFromEvent:o,isDescribedElement:n,getElementType:r}}])});
	//# sourceMappingURL=rollbar.umd.min.js.map

/***/ },
/* 1627 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1628 */
[4462, 3807],
/* 1629 */
[4463, 3808],
/* 1630 */
[4466, 91, 12, 11, 77],
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A section sub-component for Breadcrumb component.
	 */
	var BreadcrumbSection = function (_Component) {
	  (0, _inherits3.default)(BreadcrumbSection, _Component);
	
	  function BreadcrumbSection() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BreadcrumbSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BreadcrumbSection.__proto__ || Object.getPrototypeOf(BreadcrumbSection)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BreadcrumbSection, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content,
	          href = _props.href,
	          link = _props.link,
	          onClick = _props.onClick;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), 'section', className);
	      var rest = (0, _lib.getUnhandledProps)(BreadcrumbSection, this.props);
	      var ElementType = (0, _lib.getElementType)(BreadcrumbSection, this.props, function () {
	        if (link || onClick) return 'a';
	      });
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	        _lib.childrenUtils.isNil(children) ? content : children
	      );
	    }
	  }]);
	  return BreadcrumbSection;
	}(_react.Component);
	
	BreadcrumbSection._meta = {
	  name: 'BreadcrumbSection',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Breadcrumb'
	};
	BreadcrumbSection.handledProps = ['active', 'as', 'children', 'className', 'content', 'href', 'link', 'onClick'];
	exports.default = BreadcrumbSection;
	BreadcrumbSection.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Style as the currently active section. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
	  href: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['link']), _propTypes2.default.string]),
	
	  /** Render as an `a` tag instead of a `div`. */
	  link: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['href']), _propTypes2.default.bool]),
	
	  /**
	   * Called on click. When passed, the component will render as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func
	} : {};
	
	
	BreadcrumbSection.create = (0, _lib.createShorthandFactory)(BreadcrumbSection, function (content) {
	  return { content: content, link: true };
	});

/***/ },
/* 1632 */
[4468, 11, 490, 161],
/* 1633 */
[4469, 11, 495, 161],
/* 1634 */
[4470, 11, 784, 161],
/* 1635 */
[4471, 12, 11],
/* 1636 */
[4472, 11, 774, 161],
/* 1637 */
[4473, 11, 770, 161],
/* 1638 */
[4474, 11, 1628, 161],
/* 1639 */
[4475, 11, 1629, 161],
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _GridColumn = __webpack_require__(771);
	
	var _GridColumn2 = _interopRequireDefault(_GridColumn);
	
	var _GridRow = __webpack_require__(1641);
	
	var _GridRow2 = _interopRequireDefault(_GridRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A grid is used to harmonize negative space in a layout.
	 */
	function Grid(props) {
	  var celled = props.celled,
	      centered = props.centered,
	      children = props.children,
	      className = props.className,
	      columns = props.columns,
	      container = props.container,
	      divided = props.divided,
	      doubling = props.doubling,
	      inverted = props.inverted,
	      padded = props.padded,
	      relaxed = props.relaxed,
	      reversed = props.reversed,
	      stackable = props.stackable,
	      stretched = props.stretched,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(container, 'container'), (0, _lib.useKeyOnly)(doubling, 'doubling'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useKeyOnly)(stretched, 'stretched'), (0, _lib.useKeyOrValueAndKey)(celled, 'celled'), (0, _lib.useKeyOrValueAndKey)(divided, 'divided'), (0, _lib.useKeyOrValueAndKey)(padded, 'padded'), (0, _lib.useKeyOrValueAndKey)(relaxed, 'relaxed'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(reversed, 'reversed'), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, 'column', true), 'grid', className);
	  var rest = (0, _lib.getUnhandledProps)(Grid, props);
	  var ElementType = (0, _lib.getElementType)(Grid, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Grid.handledProps = ['as', 'celled', 'centered', 'children', 'className', 'columns', 'container', 'divided', 'doubling', 'inverted', 'padded', 'relaxed', 'reversed', 'stackable', 'stretched', 'textAlign', 'verticalAlign'];
	Grid.Column = _GridColumn2.default;
	Grid.Row = _GridRow2.default;
	
	Grid._meta = {
	  name: 'Grid',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	Grid.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A grid can have rows divided into cells. */
	  celled: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['internally'])]),
	
	  /** A grid can have its columns centered. */
	  centered: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Represents column count per row in Grid. */
	  columns: _propTypes2.default.oneOf([].concat((0, _toConsumableArray3.default)(_lib.SUI.WIDTHS), ['equal'])),
	
	  /** A grid can be combined with a container to use the available layout and alignment. */
	  container: _propTypes2.default.bool,
	
	  /** A grid can have dividers between its columns. */
	  divided: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['vertically'])]),
	
	  /** A grid can double its column width on tablet and mobile sizes. */
	  doubling: _propTypes2.default.bool,
	
	  /** A grid's colors can be inverted. */
	  inverted: _propTypes2.default.bool,
	
	  /** A grid can preserve its vertical and horizontal gutters on first and last columns. */
	  padded: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['horizontally', 'vertically'])]),
	
	  /** A grid can increase its gutters to allow for more negative space. */
	  relaxed: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])]),
	
	  /** A grid can specify that its columns should reverse order at different device sizes. */
	  reversed: _propTypes2.default.oneOf(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),
	
	  /** A grid can have its columns stack on-top of each other after reaching mobile breakpoints. */
	  stackable: _propTypes2.default.bool,
	
	  /** A grid can stretch its contents to take up the entire grid height. */
	  stretched: _propTypes2.default.bool,
	
	  /** A grid can specify its text alignment. */
	  textAlign: _propTypes2.default.oneOf(_lib.SUI.TEXT_ALIGNMENTS),
	
	  /** A grid can specify its vertical alignment to have all its columns vertically centered. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	
	exports.default = Grid;

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A row sub-component for Grid.
	 */
	function GridRow(props) {
	  var centered = props.centered,
	      children = props.children,
	      className = props.className,
	      color = props.color,
	      columns = props.columns,
	      divided = props.divided,
	      only = props.only,
	      reversed = props.reversed,
	      stretched = props.stretched,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign;
	
	
	  var classes = (0, _classnames2.default)(color, (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(divided, 'divided'), (0, _lib.useKeyOnly)(stretched, 'stretched'), (0, _lib.useOnlyProp)(only), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(reversed, 'reversed'), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, 'column', true), 'row', className);
	  var rest = (0, _lib.getUnhandledProps)(GridRow, props);
	  var ElementType = (0, _lib.getElementType)(GridRow, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	GridRow.handledProps = ['as', 'centered', 'children', 'className', 'color', 'columns', 'divided', 'only', 'reversed', 'stretched', 'textAlign', 'verticalAlign'];
	GridRow._meta = {
	  name: 'GridRow',
	  parent: 'Grid',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	GridRow.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A row can have its columns centered. */
	  centered: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A grid row can be colored. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Represents column count per line in Row. */
	  columns: _propTypes2.default.oneOf([].concat((0, _toConsumableArray3.default)(_lib.SUI.WIDTHS), ['equal'])),
	
	  /** A row can have dividers between its columns. */
	  divided: _propTypes2.default.bool,
	
	  /** A row can appear only for a specific device, or screen sizes. */
	  only: _lib.customPropTypes.onlyProp(_lib.SUI.VISIBILITY),
	
	  /** A row can specify that its columns should reverse order at different device sizes. */
	  reversed: _propTypes2.default.oneOf(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),
	
	  /** A row can stretch its contents to take up the entire column height. */
	  stretched: _propTypes2.default.bool,
	
	  /** A row can specify its text alignment. */
	  textAlign: _propTypes2.default.oneOf(_lib.SUI.TEXT_ALIGNMENTS),
	
	  /** A row can specify its vertical alignment to have all its columns vertically centered. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	
	exports.default = GridRow;

/***/ },
/* 1642 */
[4478, 72, 48, 42, 12, 11, 1643, 1644, 1645],
/* 1643 */
[4479, 12, 11],
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _startCase2 = __webpack_require__(4064);
	
	var _startCase3 = _interopRequireDefault(_startCase2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Icon = __webpack_require__(77);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A menu can contain an item.
	 */
	var MenuItem = function (_Component) {
	  (0, _inherits3.default)(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var disabled = _this.props.disabled;
	
	
	      if (!disabled) (0, _invoke3.default)(_this.props, 'onClick', e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          content = _props.content,
	          disabled = _props.disabled,
	          fitted = _props.fitted,
	          header = _props.header,
	          icon = _props.icon,
	          link = _props.link,
	          name = _props.name,
	          onClick = _props.onClick,
	          position = _props.position;
	
	
	      var classes = (0, _classnames2.default)(color, position, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(icon === true || icon && !(name || content), 'icon'), (0, _lib.useKeyOnly)(header, 'header'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOrValueAndKey)(fitted, 'fitted'), 'item', className);
	      var ElementType = (0, _lib.getElementType)(MenuItem, this.props, function () {
	        if (onClick) return 'a';
	      });
	      var rest = (0, _lib.getUnhandledProps)(MenuItem, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        _Icon2.default.create(icon),
	        content || (0, _startCase3.default)(name)
	      );
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	MenuItem._meta = {
	  name: 'MenuItem',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Menu'
	};
	MenuItem.handledProps = ['active', 'as', 'children', 'className', 'color', 'content', 'disabled', 'fitted', 'header', 'icon', 'index', 'link', 'name', 'onClick', 'position'];
	exports.default = MenuItem;
	MenuItem.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A menu item can be active. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Additional colors can be specified. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A menu item can be disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** A menu item or menu can remove element padding, vertically or horizontally. */
	  fitted: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['horizontally', 'vertically'])]),
	
	  /** A menu item may include a header or may itself be a header. */
	  header: _propTypes2.default.bool,
	
	  /** MenuItem can be only icon. */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _lib.customPropTypes.itemShorthand]),
	
	  /** MenuItem index inside Menu. */
	  index: _propTypes2.default.number,
	
	  /** A menu item can be link. */
	  link: _propTypes2.default.bool,
	
	  /** Internal name of the MenuItem. */
	  name: _propTypes2.default.string,
	
	  /**
	   * Called on click. When passed, the component will render as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /** A menu item can take left or right position. */
	  position: _propTypes2.default.oneOf(['left', 'right'])
	} : {};
	
	
	MenuItem.create = (0, _lib.createShorthandFactory)(MenuItem, function (val) {
	  return { content: val, name: val };
	});

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A menu can contain a sub menu.
	 */
	function MenuMenu(props) {
	  var children = props.children,
	      className = props.className,
	      position = props.position;
	
	
	  var classes = (0, _classnames2.default)(position, 'menu', className);
	  var rest = (0, _lib.getUnhandledProps)(MenuMenu, props);
	  var ElementType = (0, _lib.getElementType)(MenuMenu, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	MenuMenu.handledProps = ['as', 'children', 'className', 'position'];
	MenuMenu._meta = {
	  name: 'MenuMenu',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Menu'
	};
	
	MenuMenu.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A sub menu can take left or right position. */
	  position: _propTypes2.default.oneOf(['left', 'right'])
	} : {};
	
	exports.default = MenuMenu;

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A message can contain a content.
	 */
	function MessageContent(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageContent, props);
	  var ElementType = (0, _lib.getElementType)(MessageContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	MessageContent.handledProps = ['as', 'children', 'className'];
	MessageContent._meta = {
	  name: 'MessageContent',
	  parent: 'Message',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	MessageContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = MessageContent;

/***/ },
/* 1647 */
[4481, 12, 11],
/* 1648 */
[4483, 72, 12, 11, 772],
/* 1649 */
[4486, 12, 11],
/* 1650 */
[4488, 11, 773],
/* 1651 */
[4489, 12, 11, 489],
/* 1652 */
[4490, 42, 72, 12, 11, 489],
/* 1653 */
[4492, 48, 91, 12, 11, 491, 775, 1654, 1655, 1656],
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Used in some Button types, such as `animated`.
	 */
	function ButtonContent(props) {
	  var children = props.children,
	      className = props.className,
	      hidden = props.hidden,
	      visible = props.visible;
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(visible, 'visible'), (0, _lib.useKeyOnly)(hidden, 'hidden'), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(ButtonContent, props);
	  var ElementType = (0, _lib.getElementType)(ButtonContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	ButtonContent.handledProps = ['as', 'children', 'className', 'hidden', 'visible'];
	ButtonContent._meta = {
	  name: 'ButtonContent',
	  parent: 'Button',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ButtonContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Initially hidden, visible on hover. */
	  hidden: _propTypes2.default.bool,
	
	  /** Initially visible, hidden on hover. */
	  visible: _propTypes2.default.bool
	} : {};
	
	exports.default = ButtonContent;

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Buttons can be grouped.
	 */
	function ButtonGroup(props) {
	  var attached = props.attached,
	      basic = props.basic,
	      children = props.children,
	      className = props.className,
	      color = props.color,
	      compact = props.compact,
	      floated = props.floated,
	      fluid = props.fluid,
	      icon = props.icon,
	      inverted = props.inverted,
	      labeled = props.labeled,
	      negative = props.negative,
	      positive = props.positive,
	      primary = props.primary,
	      secondary = props.secondary,
	      size = props.size,
	      toggle = props.toggle,
	      vertical = props.vertical,
	      widths = props.widths;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(icon, 'icon'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(labeled, 'labeled'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(primary, 'primary'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(toggle, 'toggle'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useWidthProp)(widths), 'buttons', className);
	  var rest = (0, _lib.getUnhandledProps)(ButtonGroup, props);
	  var ElementType = (0, _lib.getElementType)(ButtonGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	ButtonGroup.handledProps = ['as', 'attached', 'basic', 'children', 'className', 'color', 'compact', 'floated', 'fluid', 'icon', 'inverted', 'labeled', 'negative', 'positive', 'primary', 'secondary', 'size', 'toggle', 'vertical', 'widths'];
	ButtonGroup._meta = {
	  name: 'ButtonGroup',
	  parent: 'Button',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ButtonGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Groups can be attached to other content. */
	  attached: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom'])]),
	
	  /** Groups can be less pronounced. */
	  basic: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Groups can have a shared color. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Groups can reduce their padding to fit into tighter spaces. */
	  compact: _propTypes2.default.bool,
	
	  /** Groups can be aligned to the left or right of its container. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** Groups can take the width of their container. */
	  fluid: _propTypes2.default.bool,
	
	  /** Groups can be formatted as icons. */
	  icon: _propTypes2.default.bool,
	
	  /** Groups can be formatted to appear on dark backgrounds. */
	  inverted: _propTypes2.default.bool,
	
	  /** Groups can be formatted as labeled icon buttons. */
	  labeled: _propTypes2.default.bool,
	
	  /** Groups can hint towards a negative consequence. */
	  negative: _propTypes2.default.bool,
	
	  /** Groups can hint towards a positive consequence. */
	  positive: _propTypes2.default.bool,
	
	  /** Groups can be formatted to show different levels of emphasis. */
	  primary: _propTypes2.default.bool,
	
	  /** Groups can be formatted to show different levels of emphasis. */
	  secondary: _propTypes2.default.bool,
	
	  /** Groups can have different sizes. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES),
	
	  /** Groups can be formatted to toggle on and off. */
	  toggle: _propTypes2.default.bool,
	
	  /** Groups can be formatted to appear vertically. */
	  vertical: _propTypes2.default.bool,
	
	  /** Groups can have their widths divided evenly. */
	  widths: _propTypes2.default.oneOf(_lib.SUI.WIDTHS)
	} : {};
	
	exports.default = ButtonGroup;

/***/ },
/* 1656 */
[4493, 12, 11],
/* 1657 */
[4498, 3825],
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Header content wraps the main content when there is an adjacent Icon or Image.
	 */
	function HeaderContent(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(HeaderContent, props);
	  var ElementType = (0, _lib.getElementType)(HeaderContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	HeaderContent.handledProps = ['as', 'children', 'className'];
	HeaderContent._meta = {
	  name: 'HeaderContent',
	  parent: 'Header',
	  type: _lib.META.TYPES.VIEW
	};
	
	HeaderContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = HeaderContent;

/***/ },
/* 1659 */
[4500, 12, 11],
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Several icons can be used together as a group.
	 */
	function IconGroup(props) {
	  var children = props.children,
	      className = props.className,
	      size = props.size;
	
	  var classes = (0, _classnames2.default)(size, 'icons', className);
	  var rest = (0, _lib.getUnhandledProps)(IconGroup, props);
	  var ElementType = (0, _lib.getElementType)(IconGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	IconGroup.handledProps = ['as', 'children', 'className', 'size'];
	IconGroup._meta = {
	  name: 'IconGroup',
	  parent: 'Icon',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	IconGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Size of the icon group. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : {};
	
	IconGroup.defaultProps = {
	  as: 'i'
	};
	
	exports.default = IconGroup;

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(91);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Dimmer = __webpack_require__(1676);
	
	var _Dimmer2 = _interopRequireDefault(_Dimmer);
	
	var _Label = __webpack_require__(775);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ImageGroup = __webpack_require__(1662);
	
	var _ImageGroup2 = _interopRequireDefault(_ImageGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An image is a graphic representation of something.
	 * @see Icon
	 */
	function Image(props) {
	  var alt = props.alt,
	      avatar = props.avatar,
	      bordered = props.bordered,
	      centered = props.centered,
	      children = props.children,
	      className = props.className,
	      dimmer = props.dimmer,
	      disabled = props.disabled,
	      floated = props.floated,
	      fluid = props.fluid,
	      height = props.height,
	      hidden = props.hidden,
	      href = props.href,
	      inline = props.inline,
	      label = props.label,
	      shape = props.shape,
	      size = props.size,
	      spaced = props.spaced,
	      src = props.src,
	      verticalAlign = props.verticalAlign,
	      width = props.width,
	      wrapped = props.wrapped,
	      ui = props.ui;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(ui, 'ui'), size, shape, (0, _lib.useKeyOnly)(avatar, 'avatar'), (0, _lib.useKeyOnly)(bordered, 'bordered'), (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(inline, 'inline'), (0, _lib.useKeyOrValueAndKey)(spaced, 'spaced'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign, 'aligned'), 'image', className);
	  var rest = (0, _lib.getUnhandledProps)(Image, props);
	  var ElementType = (0, _lib.getElementType)(Image, props, function () {
	    if (!(0, _isNil3.default)(dimmer) || !(0, _isNil3.default)(label) || !(0, _isNil3.default)(wrapped) || !_lib.childrenUtils.isNil(children)) return 'div';
	  });
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var rootProps = (0, _extends3.default)({}, rest, { className: classes });
	  var imgTagProps = { alt: alt, src: src, height: height, width: width };
	
	  if (ElementType === 'img') return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rootProps, imgTagProps));
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rootProps, { href: href }),
	    _Dimmer2.default.create(dimmer),
	    _Label2.default.create(label),
	    _react2.default.createElement('img', imgTagProps)
	  );
	}
	
	Image.handledProps = ['alt', 'as', 'avatar', 'bordered', 'centered', 'children', 'className', 'dimmer', 'disabled', 'floated', 'fluid', 'height', 'hidden', 'href', 'inline', 'label', 'shape', 'size', 'spaced', 'src', 'ui', 'verticalAlign', 'width', 'wrapped'];
	Image.Group = _ImageGroup2.default;
	
	Image._meta = {
	  name: 'Image',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Image.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Alternate text for the image specified. */
	  alt: _propTypes2.default.string,
	
	  /** An image may be formatted to appear inline with text as an avatar. */
	  avatar: _propTypes2.default.bool,
	
	  /** An image may include a border to emphasize the edges of white or transparent content. */
	  bordered: _propTypes2.default.bool,
	
	  /** An image can appear centered in a content block. */
	  centered: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** An image can show that it is disabled and cannot be selected. */
	  disabled: _propTypes2.default.bool,
	
	  /** Shorthand for Dimmer. */
	  dimmer: _lib.customPropTypes.itemShorthand,
	
	  /** An image can sit to the left or right of other content. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** An image can take up the width of its container. */
	  fluid: _lib.customPropTypes.every([_propTypes2.default.bool, _lib.customPropTypes.disallow(['size'])]),
	
	  /** The img element height attribute. */
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** An image can be hidden. */
	  hidden: _propTypes2.default.bool,
	
	  /** Renders the Image as an <a> tag with this href. */
	  href: _propTypes2.default.string,
	
	  /** An image may appear inline. */
	  inline: _propTypes2.default.bool,
	
	  /** Shorthand for Label. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** An image may appear rounded or circular. */
	  shape: _propTypes2.default.oneOf(['rounded', 'circular']),
	
	  /** An image may appear at different sizes. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES),
	
	  /** An image can specify that it needs an additional spacing to separate it from nearby content. */
	  spaced: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['left', 'right'])]),
	
	  /** Specifies the URL of the image. */
	  src: _propTypes2.default.string,
	
	  /** Whether or not to add the ui className. */
	  ui: _propTypes2.default.bool,
	
	  /** An image can specify its vertical alignment. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** The img element width attribute. */
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  /** An image can render wrapped in a `div.ui.image` as alternative HTML markup. */
	  wrapped: _propTypes2.default.bool
	} : {};
	
	Image.defaultProps = {
	  as: 'img',
	  ui: true
	};
	
	Image.create = (0, _lib.createShorthandFactory)(Image, function (value) {
	  return { src: value };
	});
	
	exports.default = Image;

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of images.
	 */
	function ImageGroup(props) {
	  var children = props.children,
	      className = props.className,
	      size = props.size;
	
	  var classes = (0, _classnames2.default)('ui', size, className, 'images');
	  var rest = (0, _lib.getUnhandledProps)(ImageGroup, props);
	  var ElementType = (0, _lib.getElementType)(ImageGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	ImageGroup.handledProps = ['as', 'children', 'className', 'size'];
	ImageGroup._meta = {
	  name: 'ImageGroup',
	  parent: 'Image',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ImageGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A group of images can be formatted to have the same size. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES)
	} : {};
	
	exports.default = ImageGroup;

/***/ },
/* 1663 */
[4507, 12, 11],
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A label can be grouped.
	 */
	function LabelGroup(props) {
	  var children = props.children,
	      circular = props.circular,
	      className = props.className,
	      color = props.color,
	      size = props.size,
	      tag = props.tag;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(tag, 'tag'), 'labels', className);
	  var rest = (0, _lib.getUnhandledProps)(LabelGroup, props);
	  var ElementType = (0, _lib.getElementType)(LabelGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	LabelGroup.handledProps = ['as', 'children', 'circular', 'className', 'color', 'size', 'tag'];
	LabelGroup._meta = {
	  name: 'LabelGroup',
	  parent: 'Label',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	LabelGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Labels can share shapes. */
	  circular: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Label group can share colors together. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Label group can share sizes together. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES),
	
	  /** Label group can share tag formatting. */
	  tag: _propTypes2.default.bool
	} : {};
	
	exports.default = LabelGroup;

/***/ },
/* 1665 */
[4513, 341, 48, 12, 11, 268, 776, 493, 494, 777],
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list can contain a sub list.
	 */
	function ListList(props) {
	  var children = props.children,
	      className = props.className;
	
	
	  var rest = (0, _lib.getUnhandledProps)(ListList, props);
	  var ElementType = (0, _lib.getElementType)(ListList, props);
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(ElementType !== 'ul' && ElementType !== 'ol', 'list'), className);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	ListList.handledProps = ['as', 'children', 'className'];
	ListList._meta = {
	  name: 'ListList',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ListList.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = ListList;

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A content sub-component for the Reveal.
	 */
	function RevealContent(props) {
	  var children = props.children,
	      className = props.className,
	      hidden = props.hidden,
	      visible = props.visible;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(visible, 'visible'), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(RevealContent, props);
	  var ElementType = (0, _lib.getElementType)(RevealContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	RevealContent.handledProps = ['as', 'children', 'className', 'hidden', 'visible'];
	RevealContent._meta = {
	  name: 'RevealContent',
	  parent: 'Reveal',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	RevealContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A reveal may contain content that is visible before interaction. */
	  hidden: _propTypes2.default.bool,
	
	  /** A reveal may contain content that is hidden before user interaction. */
	  visible: _propTypes2.default.bool
	} : {};
	
	exports.default = RevealContent;

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _SegmentGroup = __webpack_require__(1669);
	
	var _SegmentGroup2 = _interopRequireDefault(_SegmentGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A segment is used to create a grouping of related content.
	 */
	function Segment(props) {
	  var attached = props.attached,
	      basic = props.basic,
	      children = props.children,
	      circular = props.circular,
	      className = props.className,
	      clearing = props.clearing,
	      color = props.color,
	      compact = props.compact,
	      disabled = props.disabled,
	      floated = props.floated,
	      inverted = props.inverted,
	      loading = props.loading,
	      padded = props.padded,
	      piled = props.piled,
	      raised = props.raised,
	      secondary = props.secondary,
	      size = props.size,
	      stacked = props.stacked,
	      tertiary = props.tertiary,
	      textAlign = props.textAlign,
	      vertical = props.vertical;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(clearing, 'clearing'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(piled, 'piled'), (0, _lib.useKeyOnly)(raised, 'raised'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(stacked, 'stacked'), (0, _lib.useKeyOnly)(tertiary, 'tertiary'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useKeyOrValueAndKey)(padded, 'padded'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(floated, 'floated'), 'segment', className);
	  var rest = (0, _lib.getUnhandledProps)(Segment, props);
	  var ElementType = (0, _lib.getElementType)(Segment, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Segment.handledProps = ['as', 'attached', 'basic', 'children', 'circular', 'className', 'clearing', 'color', 'compact', 'disabled', 'floated', 'inverted', 'loading', 'padded', 'piled', 'raised', 'secondary', 'size', 'stacked', 'tertiary', 'textAlign', 'vertical'];
	Segment.Group = _SegmentGroup2.default;
	
	Segment._meta = {
	  name: 'Segment',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Segment.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Attach segment to other content, like a header. */
	  attached: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['top', 'bottom'])]),
	
	  /** A basic segment has no special formatting. */
	  basic: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** A segment can be circular. */
	  circular: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A segment can clear floated content. */
	  clearing: _propTypes2.default.bool,
	
	  /** Segment can be colored. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** A segment may take up only as much space as is necessary. */
	  compact: _propTypes2.default.bool,
	
	  /** A segment may show its content is disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** Segment content can be floated to the left or right. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** A segment can have its colors inverted for contrast. */
	  inverted: _propTypes2.default.bool,
	
	  /** A segment may show its content is being loaded. */
	  loading: _propTypes2.default.bool,
	
	  /** A segment can increase its padding. */
	  padded: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])]),
	
	  /** Formatted to look like a pile of pages. */
	  piled: _propTypes2.default.bool,
	
	  /** A segment may be formatted to raise above the page. */
	  raised: _propTypes2.default.bool,
	
	  /** A segment can be formatted to appear less noticeable. */
	  secondary: _propTypes2.default.bool,
	
	  /** A segment can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** Formatted to show it contains multiple pages. */
	  stacked: _propTypes2.default.bool,
	
	  /** A segment can be formatted to appear even less noticeable. */
	  tertiary: _propTypes2.default.bool,
	
	  /** Formats content to be aligned as part of a vertical group. */
	  textAlign: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified')),
	
	  /** Formats content to be aligned vertically. */
	  vertical: _propTypes2.default.bool
	} : {};
	
	exports.default = Segment;

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of segments can be formatted to appear together.
	 */
	function SegmentGroup(props) {
	  var children = props.children,
	      className = props.className,
	      compact = props.compact,
	      horizontal = props.horizontal,
	      piled = props.piled,
	      raised = props.raised,
	      size = props.size,
	      stacked = props.stacked;
	
	
	  var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(piled, 'piled'), (0, _lib.useKeyOnly)(raised, 'raised'), (0, _lib.useKeyOnly)(stacked, 'stacked'), 'segments', className);
	  var rest = (0, _lib.getUnhandledProps)(SegmentGroup, props);
	  var ElementType = (0, _lib.getElementType)(SegmentGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	SegmentGroup.handledProps = ['as', 'children', 'className', 'compact', 'horizontal', 'piled', 'raised', 'size', 'stacked'];
	SegmentGroup._meta = {
	  name: 'SegmentGroup',
	  parent: 'Segment',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	SegmentGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A segment may take up only as much space as is necessary. */
	  compact: _propTypes2.default.bool,
	
	  /** Formats content to be aligned horizontally. */
	  horizontal: _propTypes2.default.bool,
	
	  /** Formatted to look like a pile of pages. */
	  piled: _propTypes2.default.bool,
	
	  /** A segment group may be formatted to raise above the page. */
	  raised: _propTypes2.default.bool,
	
	  /** A segment group can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** Formatted to show it contains multiple pages. */
	  stacked: _propTypes2.default.bool
	} : {};
	
	exports.default = SegmentGroup;

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Icon = __webpack_require__(77);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StepContent = __webpack_require__(1671);
	
	var _StepContent2 = _interopRequireDefault(_StepContent);
	
	var _StepDescription = __webpack_require__(778);
	
	var _StepDescription2 = _interopRequireDefault(_StepDescription);
	
	var _StepGroup = __webpack_require__(1672);
	
	var _StepGroup2 = _interopRequireDefault(_StepGroup);
	
	var _StepTitle = __webpack_require__(779);
	
	var _StepTitle2 = _interopRequireDefault(_StepTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A step shows the completion status of an activity in a series of activities.
	 */
	var Step = function (_Component) {
	  (0, _inherits3.default)(Step, _Component);
	
	  function Step() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Step.__proto__ || Object.getPrototypeOf(Step)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var disabled = _this.props.disabled;
	
	
	      if (!disabled) (0, _invoke3.default)(_this.props, 'onClick', e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          completed = _props.completed,
	          description = _props.description,
	          disabled = _props.disabled,
	          href = _props.href,
	          icon = _props.icon,
	          link = _props.link,
	          onClick = _props.onClick,
	          title = _props.title;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(completed, 'completed'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(link, 'link'), 'step', className);
	      var rest = (0, _lib.getUnhandledProps)(Step, this.props);
	      var ElementType = (0, _lib.getElementType)(Step, this.props, function () {
	        if (onClick) return 'a';
	      });
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	        _Icon2.default.create(icon),
	        _react2.default.createElement(_StepContent2.default, { description: description, title: title })
	      );
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	Step._meta = {
	  name: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	Step.Content = _StepContent2.default;
	Step.Description = _StepDescription2.default;
	Step.Group = _StepGroup2.default;
	Step.Title = _StepTitle2.default;
	Step.handledProps = ['active', 'as', 'children', 'className', 'completed', 'description', 'disabled', 'href', 'icon', 'link', 'onClick', 'ordered', 'title'];
	exports.default = Step;
	Step.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A step can be highlighted as active. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A step can show that a user has completed it. */
	  completed: _propTypes2.default.bool,
	
	  /** Shorthand for StepDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Show that the Loader is inactive. */
	  disabled: _propTypes2.default.bool,
	
	  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
	  href: _propTypes2.default.string,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** A step can be link. */
	  link: _propTypes2.default.bool,
	
	  /**
	   * Called on click. When passed, the component will render as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /** A step can show a ordered sequence of steps. Passed from StepGroup. */
	  ordered: _propTypes2.default.bool,
	
	  /** Shorthand for StepTitle. */
	  title: _lib.customPropTypes.itemShorthand
	} : {};

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _StepDescription = __webpack_require__(778);
	
	var _StepDescription2 = _interopRequireDefault(_StepDescription);
	
	var _StepTitle = __webpack_require__(779);
	
	var _StepTitle2 = _interopRequireDefault(_StepTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A step can contain a content.
	 */
	function StepContent(props) {
	  var children = props.children,
	      className = props.className,
	      description = props.description,
	      title = props.title;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(StepContent, props);
	  var ElementType = (0, _lib.getElementType)(StepContent, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_StepTitle2.default, function (val) {
	      return { title: val };
	    }, title),
	    (0, _lib.createShorthand)(_StepDescription2.default, function (val) {
	      return { description: val };
	    }, description)
	  );
	}
	
	StepContent.handledProps = ['as', 'children', 'className', 'description', 'title'];
	StepContent._meta = {
	  name: 'StepContent',
	  parent: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	StepContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for StepDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for StepTitle. */
	  title: _lib.customPropTypes.itemShorthand
	} : {};
	
	exports.default = StepContent;

/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(72);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Step = __webpack_require__(1670);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A set of steps.
	 */
	function StepGroup(props) {
	  var children = props.children,
	      className = props.className,
	      fluid = props.fluid,
	      items = props.items,
	      ordered = props.ordered,
	      size = props.size,
	      stackable = props.stackable,
	      unstackable = props.unstackable,
	      vertical = props.vertical;
	
	  var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(ordered, 'ordered'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useValueAndKey)(stackable, 'stackable'), 'steps', className);
	  var rest = (0, _lib.getUnhandledProps)(StepGroup, props);
	  var ElementType = (0, _lib.getElementType)(StepGroup, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var content = (0, _map3.default)(items, function (item) {
	    var key = item.key || [item.title, item.description].join('-');
	    return _react2.default.createElement(_Step2.default, (0, _extends3.default)({ key: key }, item));
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content
	  );
	}
	
	StepGroup.handledProps = ['as', 'children', 'className', 'fluid', 'items', 'ordered', 'size', 'stackable', 'unstackable', 'vertical'];
	StepGroup._meta = {
	  name: 'StepGroup',
	  parent: 'Step',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	StepGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A fluid step takes up the width of its container. */
	  fluid: _propTypes2.default.bool,
	
	  /** Shorthand array of props for Step. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A step can show a ordered sequence of steps. */
	  ordered: _propTypes2.default.bool,
	
	  /** Steps can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** A step can stack vertically only on smaller screens. */
	  stackable: _propTypes2.default.oneOf(['tablet']),
	
	  /** A step can prevent itself from stacking on mobile. */
	  unstackable: _propTypes2.default.bool,
	
	  /** A step can be displayed stacked vertically. */
	  vertical: _propTypes2.default.bool
	} : {};
	
	exports.default = StepGroup;

/***/ },
/* 1673 */
1232,
/* 1674 */
[4531, 91, 820, 48, 42, 189, 12, 11, 782, 783],
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A dimmable sub-component for Dimmer.
	 */
	function DimmerDimmable(props) {
	  var blurring = props.blurring,
	      className = props.className,
	      children = props.children,
	      dimmed = props.dimmed;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(blurring, 'blurring'), (0, _lib.useKeyOnly)(dimmed, 'dimmed'), 'dimmable', className);
	  var rest = (0, _lib.getUnhandledProps)(DimmerDimmable, props);
	  var ElementType = (0, _lib.getElementType)(DimmerDimmable, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	DimmerDimmable.handledProps = ['as', 'blurring', 'children', 'className', 'dimmed'];
	DimmerDimmable._meta = {
	  name: 'DimmerDimmable',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Dimmer'
	};
	
	DimmerDimmable.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A dimmable element can blur its contents. */
	  blurring: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Controls whether or not the dim is displayed. */
	  dimmed: _propTypes2.default.bool
	} : {};
	
	exports.default = DimmerDimmable;

/***/ },
/* 1676 */
[4536, 3862],
/* 1677 */
[4537, 12, 11],
/* 1678 */
[4538, 12, 11, 77],
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(91);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Flag = __webpack_require__(1657);
	
	var _Flag2 = _interopRequireDefault(_Flag);
	
	var _Icon = __webpack_require__(77);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Image = __webpack_require__(268);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Label = __webpack_require__(492);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item sub-component for Dropdown component.
	 */
	var DropdownItem = function (_Component) {
	  (0, _inherits3.default)(DropdownItem, _Component);
	
	  function DropdownItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropdownItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DropdownItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content,
	          disabled = _props.disabled,
	          description = _props.description,
	          flag = _props.flag,
	          icon = _props.icon,
	          image = _props.image,
	          label = _props.label,
	          selected = _props.selected,
	          text = _props.text;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(selected, 'selected'), 'item', className);
	      // add default dropdown icon if item contains another menu
	      var iconName = (0, _isNil3.default)(icon) ? _lib.childrenUtils.someByType(children, 'DropdownMenu') && 'dropdown' : icon;
	      var rest = (0, _lib.getUnhandledProps)(DropdownItem, this.props);
	      var ElementType = (0, _lib.getElementType)(DropdownItem, this.props);
	      var ariaOptions = {
	        role: 'option',
	        'aria-disabled': disabled,
	        'aria-checked': active,
	        'aria-selected': selected
	      };
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, ariaOptions, { className: classes, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      var flagElement = _Flag2.default.create(flag);
	      var iconElement = _Icon2.default.create(iconName);
	      var imageElement = _Image2.default.create(image);
	      var labelElement = _Label2.default.create(label);
	      var descriptionElement = (0, _lib.createShorthand)('span', function (val) {
	        return { children: val };
	      }, description, { defaultProps: { className: 'description' } });
	      var textElement = (0, _lib.createShorthand)('span', function (val) {
	        return { children: val };
	      }, content || text, { defaultProps: { className: 'text' } });
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, ariaOptions, { className: classes, onClick: this.handleClick }),
	        imageElement,
	        iconElement,
	        flagElement,
	        labelElement,
	        descriptionElement,
	        textElement
	      );
	    }
	  }]);
	  return DropdownItem;
	}(_react.Component);
	
	DropdownItem._meta = {
	  name: 'DropdownItem',
	  parent: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	DropdownItem.handledProps = ['active', 'as', 'children', 'className', 'content', 'description', 'disabled', 'flag', 'icon', 'image', 'label', 'onClick', 'selected', 'text', 'value'];
	DropdownItem.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Style as the currently chosen item. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Additional text with less emphasis. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** A dropdown item can be disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** Shorthand for Flag. */
	  flag: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for Image. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for Label. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * The item currently selected by keyboard shortcut.
	   * This is not the active item.
	   */
	  selected: _propTypes2.default.bool,
	
	  /** Display text. */
	  text: _lib.customPropTypes.contentShorthand,
	
	  /** Stored value. */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	} : {};
	
	
	DropdownItem.create = (0, _lib.createShorthandFactory)(DropdownItem, function (opts) {
	  return opts;
	});
	
	exports.default = DropdownItem;

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A dropdown menu can contain a menu.
	 */
	function DropdownMenu(props) {
	  var children = props.children,
	      className = props.className,
	      scrolling = props.scrolling;
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(scrolling, 'scrolling'), 'menu transition', className);
	  var rest = (0, _lib.getUnhandledProps)(DropdownMenu, props);
	  var ElementType = (0, _lib.getElementType)(DropdownMenu, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	DropdownMenu.handledProps = ['as', 'children', 'className', 'scrolling'];
	DropdownMenu._meta = {
	  name: 'DropdownMenu',
	  parent: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	
	DropdownMenu.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A dropdown menu can scroll. */
	  scrolling: _propTypes2.default.bool
	} : {};
	
	exports.default = DropdownMenu;

/***/ },
/* 1681 */
[4539, 48, 115, 12, 11],
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _map2 = __webpack_require__(72);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Button = __webpack_require__(490);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A modal can contain a row of actions.
	 */
	var ModalActions = function (_Component) {
	  (0, _inherits3.default)(ModalActions, _Component);
	
	  function ModalActions() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ModalActions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModalActions.__proto__ || Object.getPrototypeOf(ModalActions)).call.apply(_ref, [this].concat(args))), _this), _this.handleButtonOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e, buttonProps) {
	          (0, _invoke3.default)(predefinedProps, 'onClick', e, buttonProps);
	          (0, _invoke3.default)(_this.props, 'onActionClick', e, buttonProps);
	        }
	      };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ModalActions, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          actions = _props.actions,
	          children = _props.children,
	          className = _props.className;
	
	      var classes = (0, _classnames2.default)('actions', className);
	      var rest = (0, _lib.getUnhandledProps)(ModalActions, this.props);
	      var ElementType = (0, _lib.getElementType)(ModalActions, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        children
	      );
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        (0, _map3.default)(actions, function (action) {
	          return _Button2.default.create(action, { overrideProps: _this2.handleButtonOverrides });
	        })
	      );
	    }
	  }]);
	  return ModalActions;
	}(_react.Component);
	
	ModalActions._meta = {
	  name: 'ModalActions',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Modal'
	};
	ModalActions.handledProps = ['actions', 'as', 'children', 'className', 'onActionClick'];
	exports.default = ModalActions;
	ModalActions.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Array of shorthand buttons. */
	  actions: _lib.customPropTypes.collectionShorthand,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /**
	   * Action onClick handler when using shorthand `actions`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props from the clicked action.
	   */
	  onActionClick: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes2.default.func])
	} : {};
	
	
	ModalActions.create = (0, _lib.createShorthandFactory)(ModalActions, function (actions) {
	  return { actions: actions };
	});

/***/ },
/* 1683 */
[4542, 12, 11],
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A modal can have a header.
	 */
	function ModalDescription(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)('description', className);
	  var rest = (0, _lib.getUnhandledProps)(ModalDescription, props);
	  var ElementType = (0, _lib.getElementType)(ModalDescription, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	ModalDescription.handledProps = ['as', 'children', 'className'];
	ModalDescription._meta = {
	  name: 'ModalDescription',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Modal'
	};
	
	ModalDescription.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = ModalDescription;

/***/ },
/* 1685 */
[4543, 12, 11],
/* 1686 */
[4544, 3866],
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = PopupContent;
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A PopupContent displays the content body of a Popover.
	 */
	function PopupContent(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(PopupContent, props);
	  var ElementType = (0, _lib.getElementType)(PopupContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	PopupContent.handledProps = ['as', 'children', 'className'];
	PopupContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** The content of the Popup */
	  children: _propTypes2.default.node,
	
	  /** Classes to add to the Popup content className. */
	  className: _propTypes2.default.string
	} : {};
	
	PopupContent._meta = {
	  name: 'PopupContent',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Popup'
	};
	
	PopupContent.create = (0, _lib.createShorthandFactory)(PopupContent, function (children) {
	  return { children: children };
	});

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = PopupHeader;
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A PopupHeader displays a header in a Popover.
	 */
	function PopupHeader(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(PopupHeader, props);
	  var ElementType = (0, _lib.getElementType)(PopupHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	PopupHeader.handledProps = ['as', 'children', 'className'];
	PopupHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	PopupHeader._meta = {
	  name: 'PopupHeader',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Popup'
	};
	
	PopupHeader.create = (0, _lib.createShorthandFactory)(PopupHeader, function (children) {
	  return { children: children };
	});

/***/ },
/* 1689 */
[4548, 12, 11],
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SearchCategory(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      renderer = props.renderer;
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), 'category', className);
	  var rest = (0, _lib.getUnhandledProps)(SearchCategory, props);
	  var ElementType = (0, _lib.getElementType)(SearchCategory, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _react2.default.createElement(
	      'div',
	      { className: 'name' },
	      renderer(props)
	    ),
	    children
	  );
	}
	
	SearchCategory.handledProps = ['active', 'as', 'children', 'className', 'name', 'renderer', 'results'];
	SearchCategory._meta = {
	  name: 'SearchCategory',
	  parent: 'Search',
	  type: _lib.META.TYPES.MODULE
	};
	
	SearchCategory.defaultProps = {
	  renderer: function renderer(_ref) {
	    var name = _ref.name;
	    return name;
	  }
	};
	
	SearchCategory.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** The item currently selected by keyboard shortcut. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Display name. */
	  name: _propTypes2.default.string,
	
	  /**
	   * Renders the category contents.
	   *
	   * @param {object} props - The SearchCategory props object.
	   * @returns {*} - Renderable category contents.
	   */
	  renderer: _propTypes2.default.func,
	
	  /** Array of Search.Result props. */
	  results: _propTypes2.default.array
	} : {};
	
	exports.default = SearchCategory;

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Note: You technically only need the 'content' wrapper when there's an
	// image. However, optionally wrapping it makes this function a lot more
	// complicated and harder to read. Since always wrapping it doesn't affect
	// the style in any way let's just do that.
	//
	// Note: To avoid requiring a wrapping div, we return an array here so to
	// prevent rendering issues each node needs a unique key.
	var defaultRenderer = function defaultRenderer(_ref) {
	  var image = _ref.image,
	      price = _ref.price,
	      title = _ref.title,
	      description = _ref.description;
	  return [image && _react2.default.createElement(
	    'div',
	    { key: 'image', className: 'image' },
	    (0, _lib.createHTMLImage)(image)
	  ), _react2.default.createElement(
	    'div',
	    { key: 'content', className: 'content' },
	    price && _react2.default.createElement(
	      'div',
	      { className: 'price' },
	      price
	    ),
	    title && _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      title
	    ),
	    description && _react2.default.createElement(
	      'div',
	      { className: 'description' },
	      description
	    )
	  )];
	};
	
	defaultRenderer.handledProps = [];
	
	var SearchResult = function (_Component) {
	  (0, _inherits3.default)(SearchResult, _Component);
	
	  function SearchResult() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchResult);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = SearchResult.__proto__ || Object.getPrototypeOf(SearchResult)).call.apply(_ref2, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchResult, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          className = _props.className,
	          renderer = _props.renderer;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), 'result', className);
	      var rest = (0, _lib.getUnhandledProps)(SearchResult, this.props);
	      var ElementType = (0, _lib.getElementType)(SearchResult, this.props);
	
	      // Note: You technically only need the 'content' wrapper when there's an
	      // image. However, optionally wrapping it makes this function a lot more
	      // complicated and harder to read. Since always wrapping it doesn't affect
	      // the style in any way let's just do that.
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        renderer(this.props)
	      );
	    }
	  }]);
	  return SearchResult;
	}(_react.Component);
	
	SearchResult.defaultProps = {
	  renderer: defaultRenderer
	};
	SearchResult._meta = {
	  name: 'SearchResult',
	  parent: 'Search',
	  type: _lib.META.TYPES.MODULE
	};
	SearchResult.handledProps = ['active', 'as', 'className', 'description', 'id', 'image', 'onClick', 'price', 'renderer', 'title'];
	exports.default = SearchResult;
	SearchResult.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** The item currently selected by keyboard shortcut. */
	  active: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Additional text with less emphasis. */
	  description: _propTypes2.default.string,
	
	  /** A unique identifier. */
	  id: _propTypes2.default.number,
	
	  /** Add an image to the item. */
	  image: _propTypes2.default.string,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /** Customized text for price. */
	  price: _propTypes2.default.string,
	
	  /**
	   * Renders the result contents.
	   *
	   * @param {object} props - The SearchResult props object.
	   * @returns {*} - Renderable result contents.
	   */
	  renderer: _propTypes2.default.func,
	
	  /** Display title. */
	  title: _propTypes2.default.string
	} : {};

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SearchResults(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)('results transition', className);
	  var rest = (0, _lib.getUnhandledProps)(SearchResults, props);
	  var ElementType = (0, _lib.getElementType)(SearchResults, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	SearchResults.handledProps = ['as', 'children', 'className'];
	SearchResults._meta = {
	  name: 'SearchResults',
	  parent: 'Search',
	  type: _lib.META.TYPES.MODULE
	};
	
	SearchResults.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = SearchResults;

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A pushable sub-component for Sidebar.
	 */
	function SidebarPushable(props) {
	  var className = props.className,
	      children = props.children;
	
	  var classes = (0, _classnames2.default)('pushable', className);
	  var rest = (0, _lib.getUnhandledProps)(SidebarPushable, props);
	  var ElementType = (0, _lib.getElementType)(SidebarPushable, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	SidebarPushable.handledProps = ['as', 'children', 'className'];
	SidebarPushable._meta = {
	  name: 'SidebarPushable',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Sidebar'
	};
	
	SidebarPushable.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = SidebarPushable;

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A pushable sub-component for Sidebar.
	 */
	function SidebarPusher(props) {
	  var className = props.className,
	      dimmed = props.dimmed,
	      children = props.children;
	
	
	  var classes = (0, _classnames2.default)('pusher', (0, _lib.useKeyOnly)(dimmed, 'dimmed'), className);
	  var rest = (0, _lib.getUnhandledProps)(SidebarPusher, props);
	  var ElementType = (0, _lib.getElementType)(SidebarPusher, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	SidebarPusher.handledProps = ['as', 'children', 'className', 'dimmed'];
	SidebarPusher._meta = {
	  name: 'SidebarPusher',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Sidebar'
	};
	
	SidebarPusher.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Controls whether or not the dim is displayed. */
	  dimmed: _propTypes2.default.bool
	} : {};
	
	exports.default = SidebarPusher;

/***/ },
/* 1695 */
[4554, 12, 11, 1668],
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _includes2 = __webpack_require__(189);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _get2 = __webpack_require__(115);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _lib = __webpack_require__(11);
	
	var _TransitionGroup = __webpack_require__(1697);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TRANSITION_TYPE = {
	  ENTERING: 'show',
	  EXITING: 'hide'
	
	  /**
	   * A transition is an animation usually used to move content in or out of view.
	   */
	};
	var Transition = function (_Component) {
	  (0, _inherits3.default)(Transition, _Component);
	
	  function Transition() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, Transition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Transition.__proto__ || Object.getPrototypeOf(Transition)).call.apply(_ref, [this].concat(args)));
	
	    _initialiseProps.call(_this);
	
	    var _this$computeInitialS = _this.computeInitialStatuses(),
	        status = _this$computeInitialS.initial,
	        next = _this$computeInitialS.next;
	
	    _this.nextStatus = next;
	    _this.state = { status: status };
	    return _this;
	  }
	
	  // ----------------------------------------
	  // Lifecycle
	  // ----------------------------------------
	
	  (0, _createClass3.default)(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _computeStatuses = this.computeStatuses(nextProps),
	          status = _computeStatuses.current,
	          next = _computeStatuses.next;
	
	      this.nextStatus = next;
	      if (status) this.setState({ status: status });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	
	    // ----------------------------------------
	    // Callback handling
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Helpers
	    // ----------------------------------------
	
	  }, {
	    key: 'render',
	
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	    value: function render() {
	      var children = this.props.children;
	      var status = this.state.status;
	
	
	      if (status === Transition.UNMOUNTED) return null;
	      return (0, _react.cloneElement)(children, {
	        className: this.computeClasses(),
	        style: this.computeStyle()
	      });
	    }
	  }]);
	  return Transition;
	}(_react.Component);
	
	Transition.defaultProps = {
	  animation: 'fade',
	  duration: 500,
	  visible: true,
	  mountOnShow: true,
	  transitionOnMount: false,
	  unmountOnHide: false
	};
	Transition._meta = {
	  name: 'Transition',
	  type: _lib.META.TYPES.MODULE
	};
	Transition.ENTERED = 'ENTERED';
	Transition.ENTERING = 'ENTERING';
	Transition.EXITED = 'EXITED';
	Transition.EXITING = 'EXITING';
	Transition.UNMOUNTED = 'UNMOUNTED';
	Transition.Group = _TransitionGroup2.default;
	Transition.handledProps = ['animation', 'children', 'duration', 'mountOnShow', 'onComplete', 'onHide', 'onShow', 'onStart', 'reactKey', 'transitionOnMount', 'unmountOnHide', 'visible'];
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.handleStart = function () {
	    var duration = _this2.props.duration;
	
	    var status = _this2.nextStatus;
	
	    _this2.nextStatus = null;
	    _this2.setState({ status: status, animating: true }, function () {
	      (0, _invoke3.default)(_this2.props, 'onStart', null, (0, _extends3.default)({}, _this2.props, { status: status }));
	      setTimeout(_this2.handleComplete, (0, _lib.normalizeTransitionDuration)(duration, 'show'));
	    });
	  };
	
	  this.handleComplete = function () {
	    var current = _this2.state.status;
	
	
	    (0, _invoke3.default)(_this2.props, 'onComplete', null, (0, _extends3.default)({}, _this2.props, { status: current }));
	
	    if (_this2.nextStatus) {
	      _this2.handleStart();
	      return;
	    }
	
	    var status = _this2.computeCompletedStatus();
	    var callback = current === Transition.ENTERING ? 'onShow' : 'onHide';
	
	    _this2.setState({ status: status, animating: false }, function () {
	      (0, _invoke3.default)(_this2.props, callback, null, (0, _extends3.default)({}, _this2.props, { status: status }));
	    });
	  };
	
	  this.updateStatus = function () {
	    var animating = _this2.state.animating;
	
	
	    if (_this2.nextStatus) {
	      _this2.nextStatus = _this2.computeNextStatus();
	      if (!animating) _this2.handleStart();
	    }
	  };
	
	  this.computeClasses = function () {
	    var _props = _this2.props,
	        animation = _props.animation,
	        children = _props.children;
	    var _state = _this2.state,
	        animating = _state.animating,
	        status = _state.status;
	
	
	    var childClasses = (0, _get3.default)(children, 'props.className');
	    var directional = (0, _includes3.default)(_lib.SUI.DIRECTIONAL_TRANSITIONS, animation);
	
	    if (directional) {
	      return (0, _classnames2.default)(animation, childClasses, (0, _lib.useKeyOnly)(animating, 'animating'), (0, _lib.useKeyOnly)(status === Transition.ENTERING, 'in'), (0, _lib.useKeyOnly)(status === Transition.EXITING, 'out'), (0, _lib.useKeyOnly)(status === Transition.EXITED, 'hidden'), (0, _lib.useKeyOnly)(status !== Transition.EXITED, 'visible'), 'transition');
	    }
	
	    return (0, _classnames2.default)(animation, childClasses, (0, _lib.useKeyOnly)(animating, 'animating transition'));
	  };
	
	  this.computeCompletedStatus = function () {
	    var unmountOnHide = _this2.props.unmountOnHide;
	    var status = _this2.state.status;
	
	
	    if (status === Transition.ENTERING) return Transition.ENTERED;
	    return unmountOnHide ? Transition.UNMOUNTED : Transition.EXITED;
	  };
	
	  this.computeInitialStatuses = function () {
	    var _props2 = _this2.props,
	        visible = _props2.visible,
	        mountOnShow = _props2.mountOnShow,
	        transitionOnMount = _props2.transitionOnMount,
	        unmountOnHide = _props2.unmountOnHide;
	
	
	    if (visible) {
	      if (transitionOnMount) {
	        return {
	          initial: Transition.EXITED,
	          next: Transition.ENTERING
	        };
	      }
	      return { initial: Transition.ENTERED };
	    }
	
	    if (mountOnShow || unmountOnHide) return { initial: Transition.UNMOUNTED };
	    return { initial: Transition.EXITED };
	  };
	
	  this.computeNextStatus = function () {
	    var _state2 = _this2.state,
	        animating = _state2.animating,
	        status = _state2.status;
	
	
	    if (animating) return status === Transition.ENTERING ? Transition.EXITING : Transition.ENTERING;
	    return status === Transition.ENTERED ? Transition.EXITING : Transition.ENTERING;
	  };
	
	  this.computeStatuses = function (props) {
	    var status = _this2.state.status;
	    var visible = props.visible;
	
	
	    if (visible) {
	      return {
	        current: status === Transition.UNMOUNTED && Transition.EXITED,
	        next: status !== Transition.ENTERING && status !== Transition.ENTERED && Transition.ENTERING
	      };
	    }
	
	    return {
	      next: (status === Transition.ENTERING || status === Transition.ENTERED) && Transition.EXITING
	    };
	  };
	
	  this.computeStyle = function () {
	    var _props3 = _this2.props,
	        children = _props3.children,
	        duration = _props3.duration;
	    var status = _this2.state.status;
	
	
	    var childStyle = (0, _get3.default)(children, 'props.style');
	    var type = TRANSITION_TYPE[status];
	    var animationDuration = type && (0, _lib.normalizeTransitionDuration)(duration, type) + 'ms';
	
	    return (0, _extends3.default)({}, childStyle, { animationDuration: animationDuration });
	  };
	};
	
	exports.default = Transition;
	Transition.propTypes =  false ? {
	  /** Named animation event to used. Must be defined in CSS. */
	  animation: _propTypes2.default.oneOf(_lib.SUI.TRANSITIONS),
	
	  /** Primary content. */
	  children: _propTypes2.default.element.isRequired,
	
	  /** Duration of the CSS transition animation in milliseconds. */
	  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	    hide: _propTypes2.default.number,
	    show: _propTypes2.default.number
	  }), _propTypes2.default.string]),
	
	  /** Show the component; triggers the enter or exit animation. */
	  visible: _propTypes2.default.bool,
	
	  /** Wait until the first "enter" transition to mount the component (add it to the DOM). */
	  mountOnShow: _propTypes2.default.bool,
	
	  /**
	   * Callback on each transition that changes visibility to shown.
	   *
	   * @param {null}
	   * @param {object} data - All props with status.
	   */
	  onComplete: _propTypes2.default.func,
	
	  /**
	   * Callback on each transition that changes visibility to hidden.
	   *
	   * @param {null}
	   * @param {object} data - All props with status.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Callback on each transition that changes visibility to shown.
	   *
	   * @param {null}
	   * @param {object} data - All props with status.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * Callback on animation start.
	   *
	   * @param {null}
	   * @param {object} data - All props with status.
	   */
	  onStart: _propTypes2.default.func,
	
	  /** React's key of the element. */
	  reactKey: _propTypes2.default.string,
	
	  /** Run the enter animation when the component mounts, if it is initially shown. */
	  transitionOnMount: _propTypes2.default.bool,
	
	  /** Unmount the component (remove it from the DOM) when it is not shown. */
	  unmountOnHide: _propTypes2.default.bool
	} : {};

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _values2 = __webpack_require__(524);
	
	var _values3 = _interopRequireDefault(_values2);
	
	var _get2 = __webpack_require__(115);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _has2 = __webpack_require__(187);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _forEach2 = __webpack_require__(272);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	var _mapValues2 = __webpack_require__(1773);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Transition = __webpack_require__(1696);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A Transition.Group animates children as they mount and unmount.
	 */
	var TransitionGroup = function (_React$Component) {
	  (0, _inherits3.default)(TransitionGroup, _React$Component);
	
	  function TransitionGroup() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, TransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransitionGroup.__proto__ || Object.getPrototypeOf(TransitionGroup)).call.apply(_ref, [this].concat(args)));
	
	    _initialiseProps.call(_this);
	
	    var children = _this.props.children;
	
	    _this.state = { children: (0, _mapValues3.default)((0, _lib.getChildMapping)(children), function (child) {
	        return _this.wrapChild(child);
	      }) };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TransitionGroup, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var prevMapping = this.state.children;
	
	      var nextMapping = (0, _lib.getChildMapping)(nextProps.children);
	      var children = (0, _lib.mergeChildMappings)(prevMapping, nextMapping);
	
	      (0, _forEach3.default)(children, function (child, key) {
	        var hasPrev = (0, _has3.default)(prevMapping, key);
	        var hasNext = (0, _has3.default)(nextMapping, key);
	        var prevChild = prevMapping[key];
	
	        var isLeaving = !(0, _get3.default)(prevChild, 'props.visible');
	
	        // item is new (entering), should be wrapped
	        if (hasNext && (!hasPrev || isLeaving)) {
	          children[key] = _this2.wrapChild(child, true);
	          return;
	        }
	
	        // item is old (exiting), should be updated
	        if (!hasNext && hasPrev && !isLeaving) {
	          children[key] = (0, _react.cloneElement)(prevChild, { visible: false });
	          return;
	        }
	
	        // item hasn't changed transition states, copy over the last transition props;
	        var _prevChild$props = prevChild.props,
	            visible = _prevChild$props.visible,
	            transitionOnMount = _prevChild$props.transitionOnMount;
	
	
	        children[key] = (0, _react.cloneElement)(child, { visible: visible, transitionOnMount: transitionOnMount });
	      });
	
	      this.setState({ children: children });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.state.children;
	
	      var ElementType = (0, _lib.getElementType)(TransitionGroup, this.props);
	      var rest = (0, _lib.getUnhandledProps)(TransitionGroup, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        rest,
	        (0, _values3.default)(children)
	      );
	    }
	  }]);
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.defaultProps = {
	  animation: 'fade',
	  duration: 500
	};
	TransitionGroup._meta = {
	  name: 'TransitionGroup',
	  parent: 'Transition',
	  type: _lib.META.TYPES.MODULE
	};
	TransitionGroup.handledProps = ['animation', 'as', 'children', 'duration'];
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleOnHide = function (nothing, childProps) {
	    var reactKey = childProps.reactKey;
	
	
	    _this3.setState(function (state) {
	      var children = (0, _extends3.default)({}, state.children);
	      delete children[reactKey];
	
	      return { children: children };
	    });
	  };
	
	  this.wrapChild = function (child) {
	    var transitionOnMount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var _props = _this3.props,
	        animation = _props.animation,
	        duration = _props.duration;
	    var key = child.key;
	
	
	    return _react2.default.createElement(
	      _Transition2.default,
	      {
	        animation: animation,
	        duration: duration,
	        key: key,
	        onHide: _this3.handleOnHide,
	        reactKey: key,
	        transitionOnMount: transitionOnMount
	      },
	      child
	    );
	  };
	};
	
	exports.default = TransitionGroup;
	TransitionGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Named animation event to used. Must be defined in CSS. */
	  animation: _propTypes2.default.oneOf(_lib.SUI.TRANSITIONS),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Duration of the CSS transition animation in milliseconds. */
	  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	    hide: _propTypes2.default.number.isRequired,
	    show: _propTypes2.default.number.isRequired
	  }), _propTypes2.default.string])
	} : {};

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Image = __webpack_require__(268);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _CardContent = __webpack_require__(1699);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	var _CardDescription = __webpack_require__(785);
	
	var _CardDescription2 = _interopRequireDefault(_CardDescription);
	
	var _CardGroup = __webpack_require__(1700);
	
	var _CardGroup2 = _interopRequireDefault(_CardGroup);
	
	var _CardHeader = __webpack_require__(786);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _CardMeta = __webpack_require__(787);
	
	var _CardMeta2 = _interopRequireDefault(_CardMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A card displays site content in a manner similar to a playing card.
	 */
	var Card = function (_Component) {
	  (0, _inherits3.default)(Card, _Component);
	
	  function Card() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Card);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || Object.getPrototypeOf(Card)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Card, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          centered = _props.centered,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          description = _props.description,
	          extra = _props.extra,
	          fluid = _props.fluid,
	          header = _props.header,
	          href = _props.href,
	          image = _props.image,
	          link = _props.link,
	          meta = _props.meta,
	          onClick = _props.onClick,
	          raised = _props.raised;
	
	
	      var classes = (0, _classnames2.default)('ui', color, (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(raised, 'raised'), 'card', className);
	      var rest = (0, _lib.getUnhandledProps)(Card, this.props);
	      var ElementType = (0, _lib.getElementType)(Card, this.props, function () {
	        if (onClick) return 'a';
	      });
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, href: href, onClick: this.handleClick }),
	        _Image2.default.create(image),
	        (description || header || meta) && _react2.default.createElement(_CardContent2.default, { description: description, header: header, meta: meta }),
	        extra && _react2.default.createElement(
	          _CardContent2.default,
	          { extra: true },
	          extra
	        )
	      );
	    }
	  }]);
	  return Card;
	}(_react.Component);
	
	Card._meta = {
	  name: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	Card.Content = _CardContent2.default;
	Card.Description = _CardDescription2.default;
	Card.Group = _CardGroup2.default;
	Card.Header = _CardHeader2.default;
	Card.Meta = _CardMeta2.default;
	Card.handledProps = ['as', 'centered', 'children', 'className', 'color', 'description', 'extra', 'fluid', 'header', 'href', 'image', 'link', 'meta', 'onClick', 'raised'];
	exports.default = Card;
	Card.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A Card can center itself inside its container. */
	  centered: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A Card can be formatted to display different colors. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for CardDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for primary content of CardContent. */
	  extra: _lib.customPropTypes.contentShorthand,
	
	  /** A Card can be formatted to take up the width of its container. */
	  fluid: _propTypes2.default.bool,
	
	  /** Shorthand for CardHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
	  href: _propTypes2.default.string,
	
	  /** A card can contain an Image component. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** A card can be formatted to link to other content. */
	  link: _propTypes2.default.bool,
	
	  /** Shorthand for CardMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /**
	   * Called on click. When passed, the component renders as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /** A Card can be formatted to raise above the page. */
	  raised: _propTypes2.default.bool
	} : {};

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _CardDescription = __webpack_require__(785);
	
	var _CardDescription2 = _interopRequireDefault(_CardDescription);
	
	var _CardHeader = __webpack_require__(786);
	
	var _CardHeader2 = _interopRequireDefault(_CardHeader);
	
	var _CardMeta = __webpack_require__(787);
	
	var _CardMeta2 = _interopRequireDefault(_CardMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A card can contain blocks of content or extra content meant to be formatted separately from the main content.
	 */
	function CardContent(props) {
	  var children = props.children,
	      className = props.className,
	      description = props.description,
	      extra = props.extra,
	      header = props.header,
	      meta = props.meta,
	      textAlign = props.textAlign;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(extra, 'extra'), (0, _lib.useTextAlignProp)(textAlign), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(CardContent, props);
	  var ElementType = (0, _lib.getElementType)(CardContent, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_CardHeader2.default, function (val) {
	      return { content: val };
	    }, header),
	    (0, _lib.createShorthand)(_CardMeta2.default, function (val) {
	      return { content: val };
	    }, meta),
	    (0, _lib.createShorthand)(_CardDescription2.default, function (val) {
	      return { content: val };
	    }, description)
	  );
	}
	
	CardContent.handledProps = ['as', 'children', 'className', 'description', 'extra', 'header', 'meta', 'textAlign'];
	CardContent._meta = {
	  name: 'CardContent',
	  parent: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	
	CardContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for CardDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** A card can contain extra content meant to be formatted separately from the main content. */
	  extra: _propTypes2.default.bool,
	
	  /** Shorthand for CardHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for CardMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /** A card content can adjust its text alignment. */
	  textAlign: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified'))
	} : {};
	
	exports.default = CardContent;

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(72);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Card = __webpack_require__(1698);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of cards.
	 */
	function CardGroup(props) {
	  var children = props.children,
	      className = props.className,
	      doubling = props.doubling,
	      items = props.items,
	      itemsPerRow = props.itemsPerRow,
	      stackable = props.stackable,
	      textAlign = props.textAlign;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(doubling, 'doubling'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useWidthProp)(itemsPerRow), 'cards', className);
	  var rest = (0, _lib.getUnhandledProps)(CardGroup, props);
	  var ElementType = (0, _lib.getElementType)(CardGroup, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var content = (0, _map3.default)(items, function (item) {
	    var key = item.key || [item.header, item.description].join('-');
	    return _react2.default.createElement(_Card2.default, (0, _extends3.default)({ key: key }, item));
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content
	  );
	}
	
	CardGroup.handledProps = ['as', 'children', 'className', 'doubling', 'items', 'itemsPerRow', 'stackable', 'textAlign'];
	CardGroup._meta = {
	  name: 'CardGroup',
	  parent: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	
	CardGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A group of cards can double its column width for mobile. */
	  doubling: _propTypes2.default.bool,
	
	  /** Shorthand array of props for Card. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A group of cards can set how many cards should exist in a row. */
	  itemsPerRow: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** A group of cards can automatically stack rows to a single columns on mobile devices. */
	  stackable: _propTypes2.default.bool,
	
	  /** A card group can adjust its text alignment. */
	  textAlign: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified'))
	} : {};
	
	exports.default = CardGroup;

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain an action.
	 */
	function CommentAction(props) {
	  var active = props.active,
	      className = props.className,
	      children = props.children;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), className);
	  var rest = (0, _lib.getUnhandledProps)(CommentAction, props);
	  var ElementType = (0, _lib.getElementType)(CommentAction, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentAction.handledProps = ['active', 'as', 'children', 'className'];
	CommentAction._meta = {
	  name: 'CommentAction',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentAction.defaultProps = {
	  as: 'a'
	};
	
	CommentAction.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Style as the currently active action. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = CommentAction;

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain an list of actions a user may perform related to this comment.
	 */
	function CommentActions(props) {
	  var className = props.className,
	      children = props.children;
	
	  var classes = (0, _classnames2.default)('actions', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentActions, props);
	  var ElementType = (0, _lib.getElementType)(CommentActions, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentActions.handledProps = ['as', 'children', 'className'];
	CommentActions._meta = {
	  name: 'CommentActions',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentActions.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = CommentActions;

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain an author.
	 */
	function CommentAuthor(props) {
	  var className = props.className,
	      children = props.children;
	
	  var classes = (0, _classnames2.default)('author', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentAuthor, props);
	  var ElementType = (0, _lib.getElementType)(CommentAuthor, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentAuthor.handledProps = ['as', 'children', 'className'];
	CommentAuthor._meta = {
	  name: 'CommentAuthor',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentAuthor.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = CommentAuthor;

/***/ },
/* 1704 */
[4561, 12, 11],
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain content.
	 */
	function CommentContent(props) {
	  var className = props.className,
	      children = props.children;
	
	  var classes = (0, _classnames2.default)(className, 'content');
	  var rest = (0, _lib.getUnhandledProps)(CommentContent, props);
	  var ElementType = (0, _lib.getElementType)(CommentContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentContent.handledProps = ['as', 'children', 'className'];
	CommentContent._meta = {
	  name: 'CommentContent',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = CommentContent;

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Comments can be grouped.
	 */
	function CommentGroup(props) {
	  var className = props.className,
	      children = props.children,
	      collapsed = props.collapsed,
	      minimal = props.minimal,
	      size = props.size,
	      threaded = props.threaded;
	
	
	  var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(collapsed, 'collapsed'), (0, _lib.useKeyOnly)(minimal, 'minimal'), (0, _lib.useKeyOnly)(threaded, 'threaded'), 'comments', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentGroup, props);
	  var ElementType = (0, _lib.getElementType)(CommentGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentGroup.handledProps = ['as', 'children', 'className', 'collapsed', 'minimal', 'size', 'threaded'];
	CommentGroup._meta = {
	  name: 'CommentGroup',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Comments can be collapsed, or hidden from view. */
	  collapsed: _propTypes2.default.bool,
	
	  /** Comments can hide extra information unless a user shows intent to interact with a comment. */
	  minimal: _propTypes2.default.bool,
	
	  /** Comments can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** A comment list can be threaded to showing the relationship between conversations. */
	  threaded: _propTypes2.default.bool
	} : {};
	
	exports.default = CommentGroup;

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain metadata about the comment, an arbitrary amount of metadata may be defined.
	 */
	function CommentMetadata(props) {
	  var className = props.className,
	      children = props.children;
	
	  var classes = (0, _classnames2.default)('metadata', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentMetadata, props);
	  var ElementType = (0, _lib.getElementType)(CommentMetadata, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentMetadata.handledProps = ['as', 'children', 'className'];
	CommentMetadata._meta = {
	  name: 'CommentMetadata',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentMetadata.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = CommentMetadata;

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain text.
	 */
	function CommentText(props) {
	  var className = props.className,
	      children = props.children;
	
	  var classes = (0, _classnames2.default)(className, 'text');
	  var rest = (0, _lib.getUnhandledProps)(CommentText, props);
	  var ElementType = (0, _lib.getElementType)(CommentText, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	CommentText.handledProps = ['as', 'children', 'className'];
	CommentText._meta = {
	  name: 'CommentText',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentText.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = CommentText;

/***/ },
/* 1709 */
[4566, 12, 11, 788, 790],
/* 1710 */
[4574, 12, 11, 1711, 795, 796, 1712, 797, 1713, 798],
/* 1711 */
[4575, 12, 11, 797, 795, 796, 798],
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(120);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map2 = __webpack_require__(72);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Item = __webpack_require__(1710);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of items.
	 */
	function ItemGroup(props) {
	  var children = props.children,
	      className = props.className,
	      divided = props.divided,
	      items = props.items,
	      link = props.link,
	      relaxed = props.relaxed,
	      unstackable = props.unstackable;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(divided, 'divided'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useKeyOrValueAndKey)(relaxed, 'relaxed'), 'items', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemGroup, props);
	  var ElementType = (0, _lib.getElementType)(ItemGroup, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var itemsJSX = (0, _map3.default)(items, function (item) {
	    var childKey = item.childKey,
	        itemProps = (0, _objectWithoutProperties3.default)(item, ['childKey']);
	
	    var finalKey = childKey || [itemProps.content, itemProps.description, itemProps.header, itemProps.meta].join('-');
	
	    return _react2.default.createElement(_Item2.default, (0, _extends3.default)({}, itemProps, { key: finalKey }));
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    itemsJSX
	  );
	}
	
	ItemGroup.handledProps = ['as', 'children', 'className', 'divided', 'items', 'link', 'relaxed', 'unstackable'];
	ItemGroup._meta = {
	  name: 'ItemGroup',
	  type: _lib.META.TYPES.VIEW,
	  parent: 'Item'
	};
	
	ItemGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Items can be divided to better distinguish between grouped content. */
	  divided: _propTypes2.default.bool,
	
	  /** Shorthand array of props for Item. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** An item can be formatted so that the entire contents link to another page. */
	  link: _propTypes2.default.bool,
	
	  /** A group of items can relax its padding to provide more negative space. */
	  relaxed: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])]),
	
	  /** Prevent items from stacking on mobile. */
	  unstackable: _propTypes2.default.bool
	} : {};
	
	exports.default = ItemGroup;

/***/ },
/* 1713 */
[4579, 11, 268],
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _StatisticGroup = __webpack_require__(1715);
	
	var _StatisticGroup2 = _interopRequireDefault(_StatisticGroup);
	
	var _StatisticLabel = __webpack_require__(1716);
	
	var _StatisticLabel2 = _interopRequireDefault(_StatisticLabel);
	
	var _StatisticValue = __webpack_require__(1717);
	
	var _StatisticValue2 = _interopRequireDefault(_StatisticValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A statistic emphasizes the current value of an attribute.
	 */
	function Statistic(props) {
	  var children = props.children,
	      className = props.className,
	      color = props.color,
	      floated = props.floated,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      label = props.label,
	      size = props.size,
	      text = props.text,
	      value = props.value;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), 'statistic', className);
	  var rest = (0, _lib.getUnhandledProps)(Statistic, props);
	  var ElementType = (0, _lib.getElementType)(Statistic, props);
	
	  if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _react2.default.createElement(_StatisticValue2.default, { text: text, value: value }),
	    _react2.default.createElement(_StatisticLabel2.default, { label: label })
	  );
	}
	
	Statistic.handledProps = ['as', 'children', 'className', 'color', 'floated', 'horizontal', 'inverted', 'label', 'size', 'text', 'value'];
	Statistic._meta = {
	  name: 'Statistic',
	  type: _lib.META.TYPES.VIEW
	};
	
	Statistic.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A statistic can be formatted to be different colors. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** A statistic can sit to the left or right of other content. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** A statistic can present its measurement horizontally. */
	  horizontal: _propTypes2.default.bool,
	
	  /** A statistic can be formatted to fit on a dark background. */
	  inverted: _propTypes2.default.bool,
	
	  /** Label content of the Statistic. */
	  label: _lib.customPropTypes.contentShorthand,
	
	  /** A statistic can vary in size. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'big', 'massive', 'medium')),
	
	  /** Format the StatisticValue with smaller font size to fit nicely beside number values. */
	  text: _propTypes2.default.bool,
	
	  /** Value content of the Statistic. */
	  value: _lib.customPropTypes.contentShorthand
	} : {};
	
	Statistic.Group = _StatisticGroup2.default;
	Statistic.Label = _StatisticLabel2.default;
	Statistic.Value = _StatisticValue2.default;
	
	exports.default = Statistic;

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(72);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Statistic = __webpack_require__(1714);
	
	var _Statistic2 = _interopRequireDefault(_Statistic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A group of statistics.
	 */
	function StatisticGroup(props) {
	  var children = props.children,
	      className = props.className,
	      color = props.color,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      items = props.items,
	      size = props.size,
	      widths = props.widths;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useWidthProp)(widths), 'statistics', className);
	  var rest = (0, _lib.getUnhandledProps)(StatisticGroup, props);
	  var ElementType = (0, _lib.getElementType)(StatisticGroup, props);
	
	  if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	
	  var itemsJSX = (0, _map3.default)(items, function (item) {
	    return _react2.default.createElement(_Statistic2.default, (0, _extends3.default)({ key: item.childKey || [item.label, item.title].join('-') }, item));
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    itemsJSX
	  );
	}
	
	StatisticGroup.handledProps = ['as', 'children', 'className', 'color', 'horizontal', 'inverted', 'items', 'size', 'widths'];
	StatisticGroup._meta = {
	  name: 'StatisticGroup',
	  type: _lib.META.TYPES.VIEW,
	  parent: 'Statistic'
	};
	
	StatisticGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A statistic group can be formatted to be different colors. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** A statistic group can present its measurement horizontally. */
	  horizontal: _propTypes2.default.bool,
	
	  /** A statistic group can be formatted to fit on a dark background. */
	  inverted: _propTypes2.default.bool,
	
	  /** Array of props for Statistic. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A statistic group can vary in size. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'big', 'massive', 'medium')),
	
	  /** A statistic group can have its items divided evenly. */
	  widths: _propTypes2.default.oneOf(_lib.SUI.WIDTHS)
	} : {};
	
	exports.default = StatisticGroup;

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A statistic can contain a label to help provide context for the presented value.
	 */
	function StatisticLabel(props) {
	  var children = props.children,
	      className = props.className,
	      label = props.label;
	
	  var classes = (0, _classnames2.default)('label', className);
	  var rest = (0, _lib.getUnhandledProps)(StatisticLabel, props);
	  var ElementType = (0, _lib.getElementType)(StatisticLabel, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? label : children
	  );
	}
	
	StatisticLabel.handledProps = ['as', 'children', 'className', 'label'];
	StatisticLabel._meta = {
	  name: 'StatisticLabel',
	  parent: 'Statistic',
	  type: _lib.META.TYPES.VIEW
	};
	
	StatisticLabel.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  label: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = StatisticLabel;

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A statistic can contain a numeric, icon, image, or text value.
	 */
	function StatisticValue(props) {
	  var children = props.children,
	      className = props.className,
	      text = props.text,
	      value = props.value;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(text, 'text'), 'value', className);
	  var rest = (0, _lib.getUnhandledProps)(StatisticValue, props);
	  var ElementType = (0, _lib.getElementType)(StatisticValue, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? value : children
	  );
	}
	
	StatisticValue.handledProps = ['as', 'children', 'className', 'text', 'value'];
	StatisticValue._meta = {
	  name: 'StatisticValue',
	  parent: 'Statistic',
	  type: _lib.META.TYPES.VIEW
	};
	
	StatisticValue.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Format the value with smaller font size to fit nicely beside number values. */
	  text: _propTypes2.default.bool,
	
	  /** Primary content of the StatisticValue. Mutually exclusive with the children prop. */
	  value: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = StatisticValue;

/***/ },
/* 1718 */
[4194, 222, 82],
/* 1719 */
[4198, 82],
/* 1720 */
[4199, 222, 82],
/* 1721 */
977,
/* 1722 */
[4201, 1734, 518, 49, 340, 337, 521],
/* 1723 */
979,
/* 1724 */
980,
/* 1725 */
[4206, 271, 116],
/* 1726 */
982,
/* 1727 */
[4211, 498, 500, 804, 162, 270, 508],
/* 1728 */
985,
/* 1729 */
[4220, 805, 49],
/* 1730 */
[4236, 220, 126],
/* 1731 */
990,
/* 1732 */
[4244, 501, 221, 337, 100, 186],
/* 1733 */
[4245, 188, 1753],
/* 1734 */
993,
/* 1735 */
[4249, 498, 500, 804, 508, 3959, 818],
/* 1736 */
[4252, 188],
/* 1737 */
[4254, 507],
/* 1738 */
997,
/* 1739 */
998,
/* 1740 */
[4278, 1738, 1739, 3946, 510, 1741, 813, 3998, 517, 82],
/* 1741 */
[4280, 1750, 1757, 1758],
/* 1742 */
[4285, 222],
/* 1743 */
[4286, 498, 1724, 508],
/* 1744 */
1003,
/* 1745 */
[4290, 1729, 814, 116],
/* 1746 */
[4291, 1729, 1748, 825],
/* 1747 */
[4293, 3997],
/* 1748 */
[4300, 805, 514, 814, 1778],
/* 1749 */
[4302, 221, 518, 49, 337, 823, 186],
/* 1750 */
[4312, 799, 812, 1747, 4073],
/* 1751 */
[4314, 100],
/* 1752 */
1011,
/* 1753 */
[4326, 1720],
/* 1754 */
1013,
/* 1755 */
[4330, 499],
/* 1756 */
[4331, 336, 507],
/* 1757 */
[4334, 1733, 1759],
/* 1758 */
[4336, 3967, 3977, 819, 4011],
/* 1759 */
1017,
/* 1760 */
[4340, 3896, 815, 4009],
/* 1761 */
[4341, 3992],
/* 1762 */
1020,
/* 1763 */
1021,
/* 1764 */
[4349, 511],
/* 1765 */
[4350, 3961, 165],
/* 1766 */
[4351, 1727, 504, 185, 519],
/* 1767 */
[4357, 3955, 1768],
/* 1768 */
[4358, 1728, 114, 164],
/* 1769 */
[4369, 57, 4022, 56],
/* 1770 */
[4372, 57, 189, 56],
/* 1771 */
[4389, 3905, 1749],
/* 1772 */
[4404, 140, 83],
/* 1773 */
[4416, 503, 807, 114],
/* 1774 */
1036,
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(162),
	    baseClone = __webpack_require__(806),
	    baseUnset = __webpack_require__(3931),
	    castPath = __webpack_require__(221),
	    copyObject = __webpack_require__(271),
	    customOmitClone = __webpack_require__(3960),
	    flatRest = __webpack_require__(512),
	    getAllKeysIn = __webpack_require__(1746);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 1776 */
[4423, 1723, 220, 114, 3926, 49],
/* 1777 */
[4430, 1726, 810, 164, 165],
/* 1778 */
1038,
/* 1779 */
[4431, 3930, 188],
/* 1780 */
[4433, 1734, 1736, 164],
/* 1781 */
[4434, 523],
/* 1782 */
[4442, 1735],
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var randomByte = __webpack_require__(4083);
	
	function encode(lookup, number) {
	    var loopCounter = 0;
	    var done;
	
	    var str = '';
	
	    while (!done) {
	        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
	        done = number < (Math.pow(16, loopCounter + 1 ) );
	        loopCounter++;
	    }
	    return str;
	}
	
	module.exports = encode;


/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(4094);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(53)(module)))

/***/ },
/* 1785 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  return  bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 1786 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	var rng;
	
	var crypto = global.crypto || global.msCrypto; // for IE 11
	if (crypto && crypto.getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16);
	  rng = function whatwgRNG() {
	    crypto.getRandomValues(rnds8);
	    return rnds8;
	  };
	}
	
	if (!rng) {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var  rnds = new Array(16);
	  rng = function() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}
	
	module.exports = rng;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	// Unique ID creation requires a high quality random # generator.  We feature
	// detect to determine the best RNG source, normalizing to a function that
	// returns 128-bits of randomness, since that's what's usually required
	var rng = __webpack_require__(1786);
	var bytesToUuid = __webpack_require__(1785);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	// random #'s we need to init node and clockseq
	var _seedBytes = rng();
	
	// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	var _nodeId = [
	  _seedBytes[0] | 0x01,
	  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	];
	
	// Per 4.2.2, randomize (14 bit) clockseq
	var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	// Previous uuid creation time
	var _lastMSecs = 0, _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  var node = options.node || _nodeId;
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ },
/* 1788 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var alpha = exports.alpha = {
	  'en-US': /^[A-Z]+$/i,
	  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[A-ZÆØÅ]+$/i,
	  'de-DE': /^[A-ZÄÖÜß]+$/i,
	  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'nl-NL': /^[A-ZÉËÏÓÖÜ]+$/i,
	  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[А-ЯЁ]+$/i,
	  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
	  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[А-ЯЄIЇҐ]+$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	
	var alphanumeric = exports.alphanumeric = {
	  'en-US': /^[0-9A-Z]+$/i,
	  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[0-9A-ZÆØÅ]$/i,
	  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
	  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'nl-NL': /^[0-9A-ZÉËÏÓÖÜ]+$/i,
	  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[0-9А-ЯЁ]+$/i,
	  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
	  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[0-9А-ЯЄIЇҐ]+$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	
	var englishLocales = exports.englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
	
	for (var locale, i = 0; i < englishLocales.length; i++) {
	  locale = 'en-' + englishLocales[i];
	  alpha[locale] = alpha['en-US'];
	  alphanumeric[locale] = alphanumeric['en-US'];
	}
	
	alpha['pt-BR'] = alpha['pt-PT'];
	alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
	
	// Source: http://www.localeplanet.com/java/
	var arabicLocales = exports.arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
	
	for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
	  _locale = 'ar-' + arabicLocales[_i];
	  alpha[_locale] = alpha.ar;
	  alphanumeric[_locale] = alphanumeric.ar;
	}

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = blacklist;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function blacklist(str, chars) {
	  (0, _assertString2.default)(str);
	  return str.replace(new RegExp('[' + chars + ']+', 'g'), '');
	}
	module.exports = exports['default'];

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isByteLength;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isByteLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isByteLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var len = encodeURI(str).split(/%..|./).length - 1;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmail;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _merge = __webpack_require__(342);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _isByteLength = __webpack_require__(1790);
	
	var _isByteLength2 = _interopRequireDefault(_isByteLength);
	
	var _isFQDN = __webpack_require__(833);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_email_options = {
	  allow_display_name: false,
	  require_display_name: false,
	  allow_utf8_local_part: true,
	  require_tld: true
	};
	
	/* eslint-disable max-len */
	/* eslint-disable no-control-regex */
	var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
	var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
	var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
	var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
	var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
	/* eslint-enable max-len */
	/* eslint-enable no-control-regex */
	
	function isEmail(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_email_options);
	
	  if (options.require_display_name || options.allow_display_name) {
	    var display_email = str.match(displayName);
	    if (display_email) {
	      str = display_email[1];
	    } else if (options.require_display_name) {
	      return false;
	    }
	  }
	
	  var parts = str.split('@');
	  var domain = parts.pop();
	  var user = parts.join('@');
	
	  var lower_domain = domain.toLowerCase();
	  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
	    user = user.replace(/\./g, '').toLowerCase();
	  }
	
	  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 256 })) {
	    return false;
	  }
	
	  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
	    return false;
	  }
	
	  if (user[0] === '"') {
	    user = user.slice(1, user.length - 1);
	    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
	  }
	
	  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
	
	  var user_parts = user.split('.');
	  for (var i = 0; i < user_parts.length; i++) {
	    if (!pattern.test(user_parts[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fullWidth = undefined;
	exports.default = isFullWidth;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fullWidth = exports.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	
	function isFullWidth(str) {
	  (0, _assertString2.default)(str);
	  return fullWidth.test(str);
	}

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.halfWidth = undefined;
	exports.default = isHalfWidth;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var halfWidth = exports.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	
	function isHalfWidth(str) {
	  (0, _assertString2.default)(str);
	  return halfWidth.test(str);
	}

/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexadecimal;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexadecimal = /^[0-9A-F]+$/i;
	
	function isHexadecimal(str) {
	  (0, _assertString2.default)(str);
	  return hexadecimal.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIP;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
	var ipv6Block = /^[0-9A-F]{1,4}$/i;
	
	function isIP(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  (0, _assertString2.default)(str);
	  version = String(version);
	  if (!version) {
	    return isIP(str, 4) || isIP(str, 6);
	  } else if (version === '4') {
	    if (!ipv4Maybe.test(str)) {
	      return false;
	    }
	    var parts = str.split('.').sort(function (a, b) {
	      return a - b;
	    });
	    return parts[3] <= 255;
	  } else if (version === '6') {
	    var blocks = str.split(':');
	    var foundOmissionBlock = false; // marker to indicate ::
	
	    // At least some OS accept the last 32 bits of an IPv6 address
	    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
	    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
	    // and '::a.b.c.d' is deprecated, but also valid.
	    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
	    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;
	
	    if (blocks.length > expectedNumberOfBlocks) {
	      return false;
	    }
	    // initial or final ::
	    if (str === '::') {
	      return true;
	    } else if (str.substr(0, 2) === '::') {
	      blocks.shift();
	      blocks.shift();
	      foundOmissionBlock = true;
	    } else if (str.substr(str.length - 2) === '::') {
	      blocks.pop();
	      blocks.pop();
	      foundOmissionBlock = true;
	    }
	
	    for (var i = 0; i < blocks.length; ++i) {
	      // test for a :: which can not be at the string start/end
	      // since those cases have been handled above
	      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
	        if (foundOmissionBlock) {
	          return false; // multiple :: in address
	        }
	        foundOmissionBlock = true;
	      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {
	        // it has been checked before that the last
	        // block is a valid IPv4 address
	      } else if (!ipv6Block.test(blocks[i])) {
	        return false;
	      }
	    }
	    if (foundOmissionBlock) {
	      return blocks.length >= 1;
	    }
	    return blocks.length === expectedNumberOfBlocks;
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ltrim;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ltrim(str, chars) {
	  (0, _assertString2.default)(str);
	  var pattern = chars ? new RegExp('^[' + chars + ']+', 'g') : /^\s+/g;
	  return str.replace(pattern, '');
	}
	module.exports = exports['default'];

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rtrim;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rtrim(str, chars) {
	  (0, _assertString2.default)(str);
	  var pattern = chars ? new RegExp('[' + chars + ']') : /\s/;
	
	  var idx = str.length - 1;
	  while (idx >= 0 && pattern.test(str[idx])) {
	    idx--;
	  }
	
	  return idx < str.length ? str.substr(0, idx + 1) : str;
	}
	module.exports = exports['default'];

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toFloat;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toFloat(str) {
	  (0, _assertString2.default)(str);
	  return parseFloat(str);
	}
	module.exports = exports['default'];

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(4158)
	
	var md5 = toConstructor(__webpack_require__(4152))
	var rmd160 = toConstructor(__webpack_require__(4156))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58).Buffer))

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(836);
	
	/*<replacement>*/
	var util = __webpack_require__(295);
	util.inherits = __webpack_require__(250);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough))
	    return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function(chunk, encoding, cb) {
	  cb(null, chunk);
	};


/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(4155);
	/*</replacement>*/
	
	
	/*<replacement>*/
	var Buffer = __webpack_require__(58).Buffer;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	var EE = __webpack_require__(667).EventEmitter;
	
	/*<replacement>*/
	if (!EE.listenerCount) EE.listenerCount = function(emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	var Stream = __webpack_require__(226);
	
	/*<replacement>*/
	var util = __webpack_require__(295);
	util.inherits = __webpack_require__(250);
	/*</replacement>*/
	
	var StringDecoder;
	
	
	/*<replacement>*/
	var debug = __webpack_require__(4174);
	if (debug && debug.debuglog) {
	  debug = debug.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	
	util.inherits(Readable, Stream);
	
	function ReadableState(options, stream) {
	  var Duplex = __webpack_require__(227);
	
	  options = options || {};
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.buffer = [];
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder)
	      StringDecoder = __webpack_require__(1802).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  var Duplex = __webpack_require__(227);
	
	  if (!(this instanceof Readable))
	    return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function(chunk, encoding) {
	  var state = this._readableState;
	
	  if (util.isString(chunk) && !state.objectMode) {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = new Buffer(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function(chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (util.isNullOrUndefined(chunk)) {
	    state.reading = false;
	    if (!state.ended)
	      onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var e = new Error('stream.unshift() after end event');
	      stream.emit('error', e);
	    } else {
	      if (state.decoder && !addToFront && !encoding)
	        chunk = state.decoder.write(chunk);
	
	      if (!addToFront)
	        state.reading = false;
	
	      // if we want the data now, just emit it.
	      if (state.flowing && state.length === 0 && !state.sync) {
	        stream.emit('data', chunk);
	        stream.read(0);
	      } else {
	        // update the buffer info.
	        state.length += state.objectMode ? 1 : chunk.length;
	        if (addToFront)
	          state.buffer.unshift(chunk);
	        else
	          state.buffer.push(chunk);
	
	        if (state.needReadable)
	          emitReadable(stream);
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended &&
	         (state.needReadable ||
	          state.length < state.highWaterMark ||
	          state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function(enc) {
	  if (!StringDecoder)
	    StringDecoder = __webpack_require__(1802).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 128MB
	var MAX_HWM = 0x800000;
	function roundUpToNextPowerOf2(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2
	    n--;
	    for (var p = 1; p < 32; p <<= 1) n |= n >> p;
	    n++;
	  }
	  return n;
	}
	
	function howMuchToRead(n, state) {
	  if (state.length === 0 && state.ended)
	    return 0;
	
	  if (state.objectMode)
	    return n === 0 ? 0 : 1;
	
	  if (isNaN(n) || util.isNull(n)) {
	    // only flow one buffer at a time
	    if (state.flowing && state.buffer.length)
	      return state.buffer[0].length;
	    else
	      return state.length;
	  }
	
	  if (n <= 0)
	    return 0;
	
	  // If we're asking for more than the target buffer level,
	  // then raise the water mark.  Bump up to the next highest
	  // power of 2, to prevent increasing it excessively in tiny
	  // amounts.
	  if (n > state.highWaterMark)
	    state.highWaterMark = roundUpToNextPowerOf2(n);
	
	  // don't have that much.  return null, unless we've ended.
	  if (n > state.length) {
	    if (!state.ended) {
	      state.needReadable = true;
	      return 0;
	    } else
	      return state.length;
	  }
	
	  return n;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function(n) {
	  debug('read', n);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (!util.isNumber(n) || n > 0)
	    state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 &&
	      state.needReadable &&
	      (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended)
	      endReadable(this);
	    else
	      emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0)
	      endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  }
	
	  if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0)
	      state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	  }
	
	  // If _read pushed data synchronously, then `reading` will be false,
	  // and we need to re-evaluate how much data we can return to the user.
	  if (doRead && !state.reading)
	    n = howMuchToRead(nOrig, state);
	
	  var ret;
	  if (n > 0)
	    ret = fromList(n, state);
	  else
	    ret = null;
	
	  if (util.isNull(ret)) {
	    state.needReadable = true;
	    n = 0;
	  }
	
	  state.length -= n;
	
	  // If we have nothing in the buffer, then we want to know
	  // as soon as we *do* get something into the buffer.
	  if (state.length === 0 && !state.ended)
	    state.needReadable = true;
	
	  // If we tried to read() past the EOF, then emit end on the next tick.
	  if (nOrig !== n && state.ended && state.length === 0)
	    endReadable(this);
	
	  if (!util.isNull(ret))
	    this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	
	function onEofChunk(stream, state) {
	  if (state.decoder && !state.ended) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync)
	      process.nextTick(function() {
	        emitReadable_(stream);
	      });
	    else
	      emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    process.nextTick(function() {
	      maybeReadMore_(stream, state);
	    });
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended &&
	         state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;
	    else
	      len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function(n) {
	  this.emit('error', new Error('not implemented'));
	};
	
	Readable.prototype.pipe = function(dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
	              dest !== process.stdout &&
	              dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted)
	    process.nextTick(endFn);
	  else
	    src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain &&
	        (!dest._writableState || dest._writableState.needDrain))
	      ondrain();
	  }
	
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    var ret = dest.write(chunk);
	    if (false === ret) {
	      debug('false write response, pause',
	            src._readableState.awaitDrain);
	      src._readableState.awaitDrain++;
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EE.listenerCount(dest, 'error') === 0)
	      dest.emit('error', er);
	  }
	  // This is a brutally ugly hack to make sure that our error handler
	  // is attached before any userland ones.  NEVER DO THIS.
	  if (!dest._events || !dest._events.error)
	    dest.on('error', onerror);
	  else if (isArray(dest._events.error))
	    dest._events.error.unshift(onerror);
	  else
	    dest._events.error = [onerror, dest._events.error];
	
	
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function() {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain)
	      state.awaitDrain--;
	    if (state.awaitDrain === 0 && EE.listenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	
	Readable.prototype.unpipe = function(dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0)
	    return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes)
	      return this;
	
	    if (!dest)
	      dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest)
	      dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++)
	      dests[i].emit('unpipe', this);
	    return this;
	  }
	
	  // try to find the right one.
	  var i = indexOf(state.pipes, dest);
	  if (i === -1)
	    return this;
	
	  state.pipes.splice(i, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1)
	    state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function(ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  // If listening to data, and it has not explicitly been paused,
	  // then call resume to start the flow of data on the next tick.
	  if (ev === 'data' && false !== this._readableState.flowing) {
	    this.resume();
	  }
	
	  if (ev === 'readable' && this.readable) {
	    var state = this._readableState;
	    if (!state.readableListening) {
	      state.readableListening = true;
	      state.emittedReadable = false;
	      state.needReadable = true;
	      if (!state.reading) {
	        var self = this;
	        process.nextTick(function() {
	          debug('readable nexttick read 0');
	          self.read(0);
	        });
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function() {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    if (!state.reading) {
	      debug('resume read 0');
	      this.read(0);
	    }
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    process.nextTick(function() {
	      resume_(stream, state);
	    });
	  }
	}
	
	function resume_(stream, state) {
	  state.resumeScheduled = false;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading)
	    stream.read(0);
	}
	
	Readable.prototype.pause = function() {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  if (state.flowing) {
	    do {
	      var chunk = stream.read();
	    } while (null !== chunk && state.flowing);
	  }
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function(stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function() {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length)
	        self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function(chunk) {
	    debug('wrapped data');
	    if (state.decoder)
	      chunk = state.decoder.write(chunk);
	    if (!chunk || !state.objectMode && !chunk.length)
	      return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (util.isFunction(stream[i]) && util.isUndefined(this[i])) {
	      this[i] = function(method) { return function() {
	        return stream[method].apply(stream, arguments);
	      }}(i);
	    }
	  }
	
	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function(ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function(n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	function fromList(n, state) {
	  var list = state.buffer;
	  var length = state.length;
	  var stringMode = !!state.decoder;
	  var objectMode = !!state.objectMode;
	  var ret;
	
	  // nothing in the list, definitely empty.
	  if (list.length === 0)
	    return null;
	
	  if (length === 0)
	    ret = null;
	  else if (objectMode)
	    ret = list.shift();
	  else if (!n || n >= length) {
	    // read it all, truncate the array.
	    if (stringMode)
	      ret = list.join('');
	    else
	      ret = Buffer.concat(list, length);
	    list.length = 0;
	  } else {
	    // read just some of it.
	    if (n < list[0].length) {
	      // just take a part of the first list item.
	      // slice is the same for buffers and strings.
	      var buf = list[0];
	      ret = buf.slice(0, n);
	      list[0] = buf.slice(n);
	    } else if (n === list[0].length) {
	      // first list is a perfect match
	      ret = list.shift();
	    } else {
	      // complex case.
	      // we have enough to cover it, but it spans past the first buffer.
	      if (stringMode)
	        ret = '';
	      else
	        ret = new Buffer(n);
	
	      var c = 0;
	      for (var i = 0, l = list.length; i < l && c < n; i++) {
	        var buf = list[0];
	        var cpy = Math.min(n - c, buf.length);
	
	        if (stringMode)
	          ret += buf.slice(0, cpy);
	        else
	          buf.copy(ret, c, 0, cpy);
	
	        if (cpy < buf.length)
	          list[0] = buf.slice(cpy);
	        else
	          list.shift();
	
	        c += cpy;
	      }
	    }
	  }
	
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0)
	    throw new Error('endReadable called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    process.nextTick(function() {
	      // Check that we didn't get one last unshift.
	      if (!state.endEmitted && state.length === 0) {
	        state.endEmitted = true;
	        stream.readable = false;
	        stream.emit('end');
	      }
	    });
	  }
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf (xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(58).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}


/***/ },
/* 1803 */
/***/ function(module, exports) {

	var WinChan = (function() {
	  var RELAY_FRAME_NAME = "__winchan_relay_frame";
	  var CLOSE_CMD = "die";
	
	  // a portable addListener implementation
	  function addListener(w, event, cb) {
	    if(w.attachEvent) w.attachEvent('on' + event, cb);
	    else if (w.addEventListener) w.addEventListener(event, cb, false);
	  }
	
	  // a portable removeListener implementation
	  function removeListener(w, event, cb) {
	    if(w.detachEvent) w.detachEvent('on' + event, cb);
	    else if (w.removeEventListener) w.removeEventListener(event, cb, false);
	  }
	
	
	  // checking for IE8 or above
	  function isInternetExplorer() {
	    if (typeof navigator === 'undefined') {
	      return false;
	    }
	
	    var rv = -1; // Return value assumes failure.
	    var ua = navigator.userAgent;
	    if (navigator.appName === 'Microsoft Internet Explorer') {
	      var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
	      if (re.exec(ua) != null)
	        rv = parseFloat(RegExp.$1);
	    }
	    // IE > 11
	    else if (ua.indexOf("Trident") > -1) {
	      var re = new RegExp("rv:([0-9]{2,2}[\.0-9]{0,})");
	      if (re.exec(ua) !== null) {
	        rv = parseFloat(RegExp.$1);
	      }
	    }
	
	    return rv >= 8;
	  }
	
	  // checking Mobile Firefox (Fennec)
	  function isFennec() {
	    try {
	      // We must check for both XUL and Java versions of Fennec.  Both have
	      // distinct UA strings.
	      var userAgent = navigator.userAgent;
	      return (userAgent.indexOf('Fennec/') != -1) ||  // XUL
	             (userAgent.indexOf('Firefox/') != -1 && userAgent.indexOf('Android') != -1);   // Java
	    } catch(e) {}
	    return false;
	  }
	
	  // feature checking to see if this platform is supported at all
	  function isSupported() {
	    return (typeof window !== 'undefined' && window.JSON && window.JSON.stringify &&
	            window.JSON.parse && window.postMessage);
	  }
	
	  // given a URL, extract the origin. Taken from: https://github.com/firebase/firebase-simple-login/blob/d2cb95b9f812d8488bdbfba51c3a7c153ba1a074/js/src/simple-login/transports/WinChan.js#L25-L30
	  function extractOrigin(url) {
	    if (!/^https?:\/\//.test(url)) url = window.location.href;
	    var m = /^(https?:\/\/[\-_a-zA-Z\.0-9:]+)/.exec(url);
	    if (m) return m[1];
	    return url;
	  }
	
	  // find the relay iframe in the opener
	  function findRelay() {
	    var loc = window.location;
	    var frames = window.opener.frames;
	    for (var i = frames.length - 1; i >= 0; i--) {
	      try {
	        if (frames[i].location.protocol === window.location.protocol &&
	            frames[i].location.host === window.location.host &&
	            frames[i].name === RELAY_FRAME_NAME)
	        {
	          return frames[i];
	        }
	      } catch(e) { }
	    }
	    return;
	  }
	
	  var isIE = isInternetExplorer();
	
	  if (isSupported()) {
	    /*  General flow:
	     *                  0. user clicks
	     *  (IE SPECIFIC)   1. caller adds relay iframe (served from trusted domain) to DOM
	     *                  2. caller opens window (with content from trusted domain)
	     *                  3. window on opening adds a listener to 'message'
	     *  (IE SPECIFIC)   4. window on opening finds iframe
	     *                  5. window checks if iframe is "loaded" - has a 'doPost' function yet
	     *  (IE SPECIFIC5)  5a. if iframe.doPost exists, window uses it to send ready event to caller
	     *  (IE SPECIFIC5)  5b. if iframe.doPost doesn't exist, window waits for frame ready
	     *  (IE SPECIFIC5)  5bi. once ready, window calls iframe.doPost to send ready event
	     *                  6. caller upon reciept of 'ready', sends args
	     */
	    return {
	      open: function(opts, cb) {
	        if (!cb) throw "missing required callback argument";
	
	        // test required options
	        var err;
	        if (!opts.url) err = "missing required 'url' parameter";
	        if (!opts.relay_url) err = "missing required 'relay_url' parameter";
	        if (err) setTimeout(function() { cb(err); }, 0);
	
	        // supply default options
	        if (!opts.window_name) opts.window_name = null;
	        if (!opts.window_features || isFennec()) opts.window_features = undefined;
	
	        // opts.params may be undefined
	
	        var iframe;
	
	        // sanity check, are url and relay_url the same origin?
	        var origin = opts.origin || extractOrigin(opts.url);
	        if (origin !== extractOrigin(opts.relay_url)) {
	          return setTimeout(function() {
	            cb('invalid arguments: origin of url and relay_url must match');
	          }, 0);
	        }
	
	        var messageTarget;
	
	        if (isIE) {
	          // first we need to add a "relay" iframe to the document that's served
	          // from the target domain.  We can postmessage into a iframe, but not a
	          // window
	          iframe = document.createElement("iframe");
	          // iframe.setAttribute('name', framename);
	          iframe.setAttribute('src', opts.relay_url);
	          iframe.style.display = "none";
	          iframe.setAttribute('name', RELAY_FRAME_NAME);
	          document.body.appendChild(iframe);
	          messageTarget = iframe.contentWindow;
	        }
	
	        var w = opts.popup || window.open(opts.url, opts.window_name, opts.window_features);
	        if (opts.popup) {
	          w.location.href = opts.url;
	        }
	
	        if (!messageTarget) messageTarget = w;
	
	        // lets listen in case the window blows up before telling us
	        var closeInterval = setInterval(function() {
	          if (w && w.closed) {
	            cleanup();
	            if (cb) {
	              cb('User closed the popup window');
	              cb = null;
	            }
	          }
	        }, 500);
	
	        var req = JSON.stringify({a: 'request', d: opts.params});
	
	        // cleanup on unload
	        function cleanup() {
	          if (iframe) document.body.removeChild(iframe);
	          iframe = undefined;
	          if (closeInterval) closeInterval = clearInterval(closeInterval);
	          removeListener(window, 'message', onMessage);
	          removeListener(window, 'unload', cleanup);
	          if (w) {
	            try {
	              w.close();
	            } catch (securityViolation) {
	              // This happens in Opera 12 sometimes
	              // see https://github.com/mozilla/browserid/issues/1844
	              messageTarget.postMessage(CLOSE_CMD, origin);
	            }
	          }
	          w = messageTarget = undefined;
	        }
	
	        addListener(window, 'unload', cleanup);
	
	        function onMessage(e) {
	          if (e.origin !== origin) { return; }
	          try {
	            var d = JSON.parse(e.data);
	          } catch(err) {
	            if (cb) {
	              return cb(err);
	            } else {
	              throw err;
	            }
	          }
	
	          if (d.a === 'ready') {
	            messageTarget.postMessage(req, origin);
	          } else if (d.a === 'error') {
	            cleanup();
	            if (cb) {
	              cb(d.d);
	              cb = null;
	            }
	          } else if (d.a === 'response') {
	            cleanup();
	            if (cb) {
	              cb(null, d.d);
	              cb = null;
	            }
	          }
	        }
	
	        addListener(window, 'message', onMessage);
	
	        return {
	          originalPopup: w,
	          close: cleanup,
	          focus: function() {
	            if (w) {
	              try {
	                w.focus();
	              } catch (e) {
	                // IE7 blows up here, do nothing
	              }
	            }
	          }
	        };
	      },
	      onOpen: function(cb) {
	        var o = "*";
	        var msgTarget = isIE ? findRelay() : window.opener;
	        if (!msgTarget) throw "can't find relay frame";
	        function doPost(msg) {
	          msg = JSON.stringify(msg);
	          if (isIE) msgTarget.doPost(msg, o);
	          else msgTarget.postMessage(msg, o);
	        }
	
	        function onMessage(e) {
	          // only one message gets through, but let's make sure it's actually
	          // the message we're looking for (other code may be using
	          // postmessage) - we do this by ensuring the payload can
	          // be parsed, and it's got an 'a' (action) value of 'request'.
	          var d;
	          try {
	            d = JSON.parse(e.data);
	          } catch(err) { }
	          if (!d || d.a !== 'request') return;
	          removeListener(window, 'message', onMessage);
	          o = e.origin;
	          if (cb) {
	            // this setTimeout is critically important for IE8 -
	            // in ie8 sometimes addListener for 'message' can synchronously
	            // cause your callback to be invoked.  awesome.
	            setTimeout(function() {
	              cb(o, d.d, function(r) {
	                cb = undefined;
	                doPost({a: 'response', d: r});
	              });
	            }, 0);
	          }
	        }
	
	        function onDie(e) {
	          if (e.data === CLOSE_CMD) {
	            try { window.close(); } catch (o_O) {}
	          }
	        }
	        addListener(isIE ? msgTarget : window, 'message', onMessage);
	        addListener(isIE ? msgTarget : window, 'message', onDie);
	
	        // we cannot post to our parent that we're ready before the iframe
	        // is loaded. (IE specific possible failure)
	        try {
	          doPost({a: "ready"});
	        } catch(e) {
	          // this code should never be exectued outside IE
	          addListener(msgTarget, 'load', function(e) {
	            doPost({a: "ready"});
	          });
	        }
	
	        // if window is unloaded and the client hasn't called cb, it's an error
	        var onUnload = function() {
	          try {
	            // IE8 doesn't like this...
	            removeListener(isIE ? msgTarget : window, 'message', onDie);
	          } catch (ohWell) { }
	          if (cb) doPost({ a: 'error', d: 'client closed window' });
	          cb = undefined;
	          // explicitly close the window, in case the client is trying to reload or nav
	          try { window.close(); } catch (e) { }
	        };
	        addListener(window, 'unload', onUnload);
	        return {
	          detach: function() {
	            removeListener(window, 'unload', onUnload);
	          }
	        };
	      }
	    };
	  } else {
	    return {
	      open: function(url, winopts, arg, cb) {
	        setTimeout(function() { cb("unsupported browser"); }, 0);
	      },
	      onOpen: function(cb) {
	        setTimeout(function() { cb("unsupported browser"); }, 0);
	      }
	    };
	  }
	})();
	
	if (typeof module !== 'undefined' && module.exports) {
	  module.exports = WinChan;
	}


/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(3032).enable();
	  window.Promise = __webpack_require__(1424);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(4171);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(45);


/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	/* @flow weak */
	"use strict";
	var Resource = module.exports = function(rawResource, client) {
	  rawResource = rawResource || { };
	  return this._construct(rawResource, client);
	};
	
	var Promise = __webpack_require__(839);
	// Promise.denodeify = function(a) { return a; };
	var assign = __webpack_require__(1808);
	
	function getMeta(obj) {
	  var metaDefaults = { relation: "primary" };
	  return obj.meta || metaDefaults;
	}
	
	Resource.prototype._construct = function(rawResource, client) {
	  this._raw = rawResource;
	  this._base = {
	    id: rawResource.id,
	    type: rawResource.type
	  };
	  this._client = client;
	  this._changed = [ ];
	
	  if (!this._base.id) return this;
	
	  var fromCache = client._resourceCache.get(this);
	  if (fromCache) return fromCache;
	
	  client._resourceCache.set(this);
	  return this;
	};
	
	Resource.prototype._checkIsResource = function(resource) {
	  if (resource instanceof Resource) {
	    if (!resource._base.id) throw new Error("Resource has not been created remotely, it can't be assigned to a relationship!");
	    return;
	  }
	
	
	  var type = typeof resource;
	  if (resource.constructor) type = resource.constructor.name;
	
	  throw new Error("Expected Resource, got " + type);
	};
	
	Resource.prototype._getBase = function() {
	  return this._base;
	};
	
	Resource.prototype._getRaw = function() {
	  return this._raw;
	};
	
	Resource.prototype._getDelta = function() {
	  var primaryRelations = { };
	  var relationships = this._getRaw().relationships;
	  Object.keys(relationships).forEach(function(i) {
	    if (getMeta(relationships[i]).relation === "foreign") return;
	    primaryRelations[i] = relationships[i];
	  });
	
	  return {
	    id: this._base.id,
	    type: this._base.type,
	    attributes: this._getRaw().attributes,
	    relationships: primaryRelations
	  };
	};
	
	Resource.prototype._getUid = function() {
	  return this._base.id;
	};
	
	Resource.prototype._getUidString = function() {
	  return this._base.id + "/" + this._base.type;
	};
	
	Resource.prototype._getPathFor = function(relation) {
	  return this._getRaw().relationships[relation].links.related;
	};
	
	Resource.prototype._matches = function(other) {
	  return (this._base.id === other.id) && (this._base.type === other.type);
	};
	
	Resource.prototype._associateWithAll = function(resources) {
	  var self = this;
	  resources.forEach(function(resource) {
	    self._associateWith(resource);
	    resource._associateWith(self);
	  });
	};
	
	Resource.prototype._relationHasResource = function(relationName, resource) {
	  var relation = this[relationName];
	
	  if (relation instanceof Array) {
	    relation = relation.filter(function(i) {
	      return (i._base === resource._base);
	    }).pop();
	  }
	
	  return !!relation;
	};
	
	Resource._rawRelationHasMany = function(rawRelation) {
	  var meta = getMeta(rawRelation);
	  if (meta.relation === "primary") return (rawRelation.data instanceof Array);
	  return meta.many;
	};
	
	Resource.prototype._associateWith = function(resource) {
	  var self = this;
	  var relationships = self._getRaw().relationships;
	  if (!relationships) return;
	  Object.keys(relationships).forEach(function(relationName) {
	    var rawRelation = relationships[relationName];
	    var otherRelation = resource;
	    var rawRelationData = rawRelation.data;
	    var rawRelationMeta = getMeta(rawRelation);
	    if (rawRelationMeta.relation === "foreign") {
	      if (rawRelationMeta.belongsTo !== resource._getBase().type) {
	        return;
	      }
	      otherRelation = self;
	      rawRelationData = resource._getRaw().relationships[rawRelationMeta.as].data;
	    }
	
	    var match = !![].concat(rawRelationData).filter(function(dataItem) {
	      // should null ever get here?
	      return dataItem && otherRelation._matches(dataItem);
	    }).pop();
	    if (!match) return;
	
	    if (Resource._rawRelationHasMany(rawRelation)) {
	      if (self._relationHasResource(relationName, resource)) return;
	      self[relationName] = self[relationName] || [ ];
	      self[relationName].push(resource);
	    } else {
	      self[relationName] = resource;
	    }
	  });
	};
	
	Resource.prototype.relationships = function(relationName) {
	  var self = this;
	  var rawRelation = this._raw.relationships[relationName];
	
	  if (!self._base.id) {
	    rawRelation = this._raw.relationships[relationName] = {
	      meta: { _trust: true },
	      links: { },
	      data: null
	    };
	  }
	
	  if (!rawRelation) {
	    throw new Error("Relationship " + relationName + " on " + this._raw.type + " does not exist!");
	  }
	
	  if (getMeta(rawRelation).relation === "foreign") {
	    throw new Error("Relationship " + relationName + " on " + this._raw.type + " is a foreign relation and cannot be updated from here!");
	  }
	
	  return {
	    add: function(resource) {
	      return self._addRelation(relationName, rawRelation, resource);
	    },
	    set: function(resource) {
	      return self._setRelation(relationName, rawRelation, resource);
	    },
	    remove: function(resource) {
	      return self._removeRelation(relationName, rawRelation, resource);
	    }
	  };
	};
	Resource.prototype._addRelation = function(relationName, rawRelation, resource) {
	  this._checkIsResource(resource);
	  if (rawRelation.meta && rawRelation.meta._trust) {
	    delete rawRelation.meta;
	    rawRelation.data = [ ];
	  }
	  if (!Resource._rawRelationHasMany(rawRelation)) {
	    throw new Error("Relationship " + relationName + " on " + this._raw.type + " is a not a MANY relationship and cannot be added to!");
	  }
	  if (this._relationHasResource(relationName, resource)) return this;
	  rawRelation.data.push(resource._getBase());
	  this[relationName] = this[relationName] || [];
	  this[relationName].push(resource);
	  resource._tweakLinksTo("add", this);
	  return this;
	};
	Resource.prototype._removeRelation = function(relationName, rawRelation, resource) {
	  this._checkIsResource(resource);
	  if (rawRelation.meta && rawRelation.meta._trust) {
	    delete rawRelation.meta;
	    rawRelation.data = [ ];
	  }
	  if (Resource._rawRelationHasMany(rawRelation)) {
	    rawRelation.data = rawRelation.data.filter(function(id) {
	      return !resource._matches(id);
	    });
	    this[relationName] = this[relationName].filter(function(id) {
	      return !resource._matches(id);
	    });
	    resource._tweakLinksTo("remove", this);
	  } else {
	    rawRelation.data = undefined;
	    this[relationName] = undefined;
	  }
	  resource._tweakLinksTo("remove", this);
	  return this;
	};
	Resource.prototype._setRelation = function(relationName, rawRelation, resource) {
	  this._checkIsResource(resource);
	  rawRelation.data = resource._getBase();
	  this[relationName] = resource;
	  resource._tweakLinksTo("add", this);
	  return this;
	};
	
	Resource.prototype.toJSON = function() {
	  var theirs = this._raw;
	  var theirResource = assign({
	    id: theirs.id,
	    type: theirs.type
	  }, theirs.attributes);
	  for (var i in theirs.relationships) {
	    theirResource[i] = theirs.relationships[i].data;
	  }
	  return theirResource;
	};
	
	Resource.prototype.toJSONTree = function(seen) {
	  seen = seen || [ ];
	  if (seen.indexOf(this) !== -1) return "[Circular]";
	  seen.push(this);
	  var theirs = this._raw;
	  var theirResource = assign({
	    id: theirs.id,
	    type: theirs.type
	  }, theirs.attributes);
	  for (var i in theirs.relationships) {
	    if (this[i] instanceof Array) {
	      theirResource[i] = this[i].map(function(j) { // eslint-disable-line
	        return j.toJSONTree(seen);
	      });
	    } else if (this[i] instanceof Resource) {
	      theirResource[i] = this[i].toJSONTree(seen);
	    } else {
	      theirResource[i] = theirs.relationships[i].data || null;
	    }
	  }
	  return theirResource;
	};
	
	Resource.prototype.get = function(attibuteName) {
	  return this._raw.attributes[attibuteName];
	};
	
	Resource.prototype.set = function(attributeName, value) {
	  this._raw.attributes[attributeName] = value;
	  this._changed.push(attributeName);
	  return this;
	};
	
	Resource.prototype.fetch = Promise.denodeify(function(relationName, options, callback) {
	  var self = this;
	
	  if (typeof options === "function") {
	    callback = options;
	    options = { };
	  }
	
	  self._client._getRelated(this, relationName, options, function(err, newResources) {
	    if (!newResources) return callback("No related resources found");
	
	    if (!(newResources instanceof Array)) {
	      self._raw.relationships[relationName].data = newResources._getBase();
	      return callback(err, newResources);
	    }
	
	    self._raw.relationships[relationName].data = newResources.map(function(someResource) {
	      return someResource._getBase();
	    });
	
	    return callback(err, newResources);
	  });
	});
	
	Resource.prototype.sync = Promise.denodeify(function(callback) {
	  var self = this;
	  var target = self._client._update;
	  if (!self._getBase().id) {
	    target = self._client._remoteCreate;
	  }
	
	  target.call(self._client, self, function(err, rawResponse, rawResource) {
	    if (err) return callback(err);
	    self._construct(rawResource, self._client);
	    return callback(null, self);
	  });
	});
	
	Resource.prototype.delete = Promise.denodeify(function(callback) {
	  var self = this;
	  self._client._delete(self, function(err) {
	    if (err) return callback(err);
	
	    self._client._resourceCache.removeFromCache(self);
	    self._getBase().id = null;
	    self._getRaw().id = null;
	
	    return callback();
	  });
	});
	
	Resource.prototype._tweakLinksTo = function(method, resource) {
	  var self = this;
	  if (!self._raw.relationships) return;
	  Object.keys(self._raw.relationships).forEach(function(i) {
	    var someRawRelationship = self._raw.relationships[i];
	    var someRawRelationshipMeta = getMeta(someRawRelationship);
	    if (someRawRelationshipMeta.relation !== "foreign") return;
	    if (someRawRelationshipMeta.belongsTo !== resource._raw.type) return;
	
	    self["_" + method + "LinksTo"](i, resource, someRawRelationshipMeta.many);
	  });
	};
	
	Resource.prototype._removeLinksTo = function(i, resource) {
	  if (this[i] instanceof Array) {
	    this[i] = this[i].filter(function(j) {
	      return j !== resource;
	    });
	  } else {
	    if (this[i] === resource) {
	      this[i] = undefined;
	    }
	  }
	};
	
	Resource.prototype._addLinksTo = function(i, resource, many) {
	  if (this[i] instanceof Array) {
	    this[i].push(resource);
	  } else {
	    if (many) {
	      this[i] = [resource];
	    } else {
	      this[i] = resource;
	    }
	  }
	};


/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	/* @flow weak */
	"use strict";
	var Transport = module.exports = function(path, auth) {
	  auth = auth || { };
	  this._construct(path, auth);
	};
	
	var request = __webpack_require__(1815);
	var qs = __webpack_require__(251);
	
	Transport.prototype._construct = function(path, auth) {
	  this._path = path;
	  this._auth = {
	    cookie: auth.cookie,
	    header: auth.header
	  };
	};
	
	Transport.prototype._attachAuthToRequest = function(someRequest) {
	  if (this._auth.cookie) {
	    var cookieName = Object.keys(this._auth.cookie)[0];
	    someRequest.set("Cookie", cookieName + "=" + this._auth.cookie[cookieName]);
	  }
	
	  if (this._auth.header) {
	    var headerName = Object.keys(this._auth.header)[0];
	    someRequest.set(headerName, this._auth.header[headerName]);
	  }
	};
	
	Transport._defaultError = function(response) {
	  return {
	    status: "500",
	    code: "EUNKNOWN",
	    title: "An unknown error has occured",
	    detail: response
	  };
	};
	
	Transport.prototype._action = function(method, url, data, callback) {
	  // console.log(method, url, JSON.stringify(data, null, 2));
	  var someRequest = request[method](url);
	  someRequest.set("Content-Type", "application/vnd.api+json");
	  this._attachAuthToRequest(someRequest);
	  if (method === "get") {
	    someRequest = someRequest.query(qs.stringify(data));
	  } else {
	    someRequest = someRequest.send(data || {});
	  }
	  someRequest.end(function(err, payload) {
	    // console.log("=>", err, payload);
	    if (err) {
	      // console.log(err.response.text);
	      if (err.status === 401) {
	        return callback(new Error("401 Unauthorized"));
	      }
	
	      var response;
	      try {
	        response = JSON.parse(err.response.text);
	      } catch(e) {
	        console.error("Transport Error: " + JSON.stringify(err));
	        return callback(Transport._defaultError(response));
	      }
	
	      if (!Array.isArray(response.errors)) {
	        console.error("Invalid Error payload!", response);
	        return callback(Transport._defaultError(response));
	      }
	
	      var realErrors = response.errors.map(function(apiError) {
	        var someError = new Error(JSON.stringify(apiError.detail));
	        someError.name = apiError.title;
	        // $FlowFixMe: Technically "status" isn't a field on Error
	        someError.status = apiError.status;
	        // $FlowFixMe: Technically "code" isn't a field on Error
	        someError.code = apiError.code;
	
	        return someError;
	      });
	
	      return callback(realErrors[0]);
	    }
	
	    if (!payload.body) {
	      try {
	        payload.body = JSON.parse(payload.text);
	      } catch(e) {
	        return callback(Transport._defaultError(payload));
	      }
	    }
	
	    if (!payload.body) {
	      return callback(Transport._defaultError(payload));
	    }
	
	    return callback(null, payload.body, payload.body.data, payload.body.included);
	  });
	};
	
	Transport.prototype.search = function(type, options, callback) {
	  var url = this._path + "/" + type;
	  this._action("get", url, options, callback);
	};
	
	Transport.prototype.find = function(type, id, options, callback) {
	  var url = this._path + "/" + type + "/" + id;
	  this._action("get", url, options, callback);
	};
	
	Transport.prototype.fetch = function(resource, relation, options, callback) {
	  var url = resource._getPathFor(relation);
	  this._action("get", url, options, callback);
	};
	
	Transport.prototype.create = function(resource, callback) {
	  var url = this._path + "/" + resource._getBase().type;
	  var postData = resource._getRaw();
	  delete postData.id;
	  this._action("post", url, {
	    data: resource._getRaw()
	  }, callback);
	};
	
	Transport.prototype.update = function(resource, callback) {
	  var url = this._path + "/" + resource._getBase().type + "/" + resource._getBase().id;
	  this._action("patch", url, {
	    data: resource._getDelta()
	  }, callback);
	};
	
	Transport.prototype.delete = function(resource, callback) {
	  var url = this._path + "/" + resource._getBase().type + "/" + resource._getBase().id;
	  this._action("del", url, null, callback);
	};


/***/ },
/* 1807 */
/***/ function(module, exports) {

	/* @flow weak */
	"use strict";
	module.exports = function createResourceCache(options) {
	  options = options || { };
	  var resourceCache = {};
	
	  resourceCache._cacheDuration = options.cacheDuration || 5000;
	
	  if (typeof module === undefined) {
	    resourceCache._cacheDuration = null;
	  }
	  resourceCache._cache = { };
	  resourceCache._cacheList = [ ];
	
	  resourceCache.get = function(someResource) {
	    var key = someResource._getUidString();
	    return resourceCache._cache[key];
	  };
	
	  resourceCache.set = function(someResource) {
	    someResource._associateWithAll(resourceCache._cacheList);
	
	    var key = someResource._getUidString();
	    resourceCache._cache[key] = someResource;
	    resourceCache._cacheList.push(someResource);
	
	    if (!resourceCache._cacheDuration) return;
	
	    setTimeout(function() {
	      resourceCache.removeFromCache(someResource);
	    }, resourceCache._cacheDuration);
	  };
	
	  resourceCache.removeFromCache = function(someResource) {
	    var key = someResource._getUidString();
	    resourceCache._cache[key] = undefined;
	    var i = resourceCache._cacheList.indexOf(someResource);
	    resourceCache._cacheList.splice(i, 1);
	  };
	
	  return resourceCache;
	};


/***/ },
/* 1808 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 1809 */
[4176, 228],
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(228);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._44);
	  p._83 = 1;
	  p._18 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._83 === 3) {
	            val = val._18;
	          }
	          if (val._83 === 1) return res(i, val._18);
	          if (val._83 === 2) reject(val._18);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1811 */
[4177, 228],
/* 1812 */
[4178, 228, 1809, 1811, 1810, 1813, 1814],
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// This file contains then/promise specific extensions that are only useful
	// for node.js interop
	
	var Promise = __webpack_require__(228);
	var asap = __webpack_require__(844);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	Promise.denodeify = function (fn, argumentCount) {
	  if (
	    typeof argumentCount === 'number' && argumentCount !== Infinity
	  ) {
	    return denodeifyWithCount(fn, argumentCount);
	  } else {
	    return denodeifyWithoutCount(fn);
	  }
	};
	
	var callbackFn = (
	  'function (err, res) {' +
	  'if (err) { rj(err); } else { rs(res); }' +
	  '}'
	);
	function denodeifyWithCount(fn, argumentCount) {
	  var args = [];
	  for (var i = 0; i < argumentCount; i++) {
	    args.push('a' + i);
	  }
	  var body = [
	    'return function (' + args.join(',') + ') {',
	    'var self = this;',
	    'return new Promise(function (rs, rj) {',
	    'var res = fn.call(',
	    ['self'].concat(args).concat([callbackFn]).join(','),
	    ');',
	    'if (res &&',
	    '(typeof res === "object" || typeof res === "function") &&',
	    'typeof res.then === "function"',
	    ') {rs(res);}',
	    '});',
	    '};'
	  ].join('');
	  return Function(['Promise', 'fn'], body)(Promise, fn);
	}
	function denodeifyWithoutCount(fn) {
	  var fnLength = Math.max(fn.length - 1, 3);
	  var args = [];
	  for (var i = 0; i < fnLength; i++) {
	    args.push('a' + i);
	  }
	  var body = [
	    'return function (' + args.join(',') + ') {',
	    'var self = this;',
	    'var args;',
	    'var argLength = arguments.length;',
	    'if (arguments.length > ' + fnLength + ') {',
	    'args = new Array(arguments.length + 1);',
	    'for (var i = 0; i < arguments.length; i++) {',
	    'args[i] = arguments[i];',
	    '}',
	    '}',
	    'return new Promise(function (rs, rj) {',
	    'var cb = ' + callbackFn + ';',
	    'var res;',
	    'switch (argLength) {',
	    args.concat(['extra']).map(function (_, index) {
	      return (
	        'case ' + (index) + ':' +
	        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
	        'break;'
	      );
	    }).join(''),
	    'default:',
	    'args[argLength] = cb;',
	    'res = fn.apply(self, args);',
	    '}',
	    
	    'if (res &&',
	    '(typeof res === "object" || typeof res === "function") &&',
	    'typeof res.then === "function"',
	    ') {rs(res);}',
	    '});',
	    '};'
	  ].join('');
	
	  return Function(
	    ['Promise', 'fn'],
	    body
	  )(Promise, fn);
	}
	
	Promise.nodeify = function (fn) {
	  return function () {
	    var args = Array.prototype.slice.call(arguments);
	    var callback =
	      typeof args[args.length - 1] === 'function' ? args.pop() : null;
	    var ctx = this;
	    try {
	      return fn.apply(this, arguments).nodeify(callback, ctx);
	    } catch (ex) {
	      if (callback === null || typeof callback == 'undefined') {
	        return new Promise(function (resolve, reject) {
	          reject(ex);
	        });
	      } else {
	        asap(function () {
	          callback.call(ctx, ex);
	        })
	      }
	    }
	  }
	};
	
	Promise.prototype.nodeify = function (callback, ctx) {
	  if (typeof callback != 'function') return this;
	
	  this.then(function (value) {
	    asap(function () {
	      callback.call(ctx, null, value);
	    });
	  }, function (err) {
	    asap(function () {
	      callback.call(ctx, err);
	    });
	  });
	};


/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(228);
	
	module.exports = Promise;
	Promise.enableSynchronous = function () {
	  Promise.prototype.isPending = function() {
	    return this.getState() == 0;
	  };
	
	  Promise.prototype.isFulfilled = function() {
	    return this.getState() == 1;
	  };
	
	  Promise.prototype.isRejected = function() {
	    return this.getState() == 2;
	  };
	
	  Promise.prototype.getValue = function () {
	    if (this._83 === 3) {
	      return this._18.getValue();
	    }
	
	    if (!this.isFulfilled()) {
	      throw new Error('Cannot get a value of an unfulfilled promise.');
	    }
	
	    return this._18;
	  };
	
	  Promise.prototype.getReason = function () {
	    if (this._83 === 3) {
	      return this._18.getReason();
	    }
	
	    if (!this.isRejected()) {
	      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
	    }
	
	    return this._18;
	  };
	
	  Promise.prototype.getState = function () {
	    if (this._83 === 3) {
	      return this._18.getState();
	    }
	    if (this._83 === -1 || this._83 === -2) {
	      return 0;
	    }
	
	    return this._83;
	  };
	};
	
	Promise.disableSynchronous = function() {
	  Promise.prototype.isPending = undefined;
	  Promise.prototype.isFulfilled = undefined;
	  Promise.prototype.isRejected = undefined;
	  Promise.prototype.getValue = undefined;
	  Promise.prototype.getReason = undefined;
	  Promise.prototype.getState = undefined;
	};


/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(576);
	var RequestBase = __webpack_require__(1817);
	var isObject = __webpack_require__(528);
	var isFunction = __webpack_require__(1816);
	var ResponseBase = __webpack_require__(1818);
	var shouldRetry = __webpack_require__(1819);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = exports = module.exports = function(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new exports.Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new exports.Request('GET', method);
	  }
	
	  return new exports.Request(method, url);
	}
	
	exports.Request = Request;
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only verison of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req) {
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  var status = this.xhr.status;
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	      status = 204;
	  }
	  this._setStatusProperties(status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	
	  if (null === this.text && req._responseType) {
	    this.body = this.xhr.response;
	  } else {
	    this.body = this.req.method != 'HEAD'
	      ? this._parseBody(this.text ? this.text : this.xhr.response)
	      : null;
	  }
	}
	
	ResponseBase(Response.prototype);
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str){
	  var parse = request.parse[this.type];
	  if(this.req._parser) {
	    return this.req._parser(this, str);
	  }
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      if (self.xhr) {
	        // ie9 doesn't have 'response' property
	        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
	        // issue #876: return the http status code if the response parsing fails
	        err.status = self.xhr.status ? self.xhr.status : null;
	        err.statusCode = err.status; // backwards-compat only
	      } else {
	        err.rawResponse = null;
	        err.status = null;
	      }
	
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (!self._isResponseOK(res)) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	        new_err.original = err;
	        new_err.response = res;
	        new_err.status = res.status;
	      }
	    } catch(e) {
	      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `RequestBase`.
	 */
	
	Emitter(Request.prototype);
	RequestBase(Request.prototype);
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} [pass] optional in case of using 'bearer' as type
	 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (typeof pass === 'object' && pass !== null) { // pass is optional and can substitute for options
	    options = pass;
	  }
	  if (!options) {
	    options = {
	      type: 'function' === typeof btoa ? 'basic' : 'auto',
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      this.set('Authorization', 'Basic ' + btoa(user + ':' + pass));
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	      
	    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
	      this.set('Authorization', 'Bearer ' + user);
	    break;  
	  }
	  return this;
	};
	
	/**
	 * Add query-string `val`.
	 *
	 * Examples:
	 *
	 *   request.get('/shoes')
	 *     .query('size=10')
	 *     .query({ color: 'blue' })
	 *
	 * @param {Object|String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `options` (or filename).
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String|Object} options
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, options){
	  if (file) {
	    if (this._data) {
	      throw Error("superagent can't mix .send() and .attach()");
	    }
	
	    this._getFormData().append(field, file, options || file.name);
	  }
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  // console.log(this._retries, this._maxRetries)
	  if (this._maxRetries && this._retries++ < this._maxRetries && shouldRetry(err, res)) {
	    return this._retry();
	  }
	
	  var fn = this._callback;
	  this.clearTimeout();
	
	  if (err) {
	    if (this._maxRetries) err.retries = this._retries - 1;
	    this.emit('error', err);
	  }
	
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	// This only warns, because the request is still likely to work
	Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
	  console.warn("This is not supported in browser version of superagent");
	  return this;
	};
	
	// This throws, because it can't send/receive data as expected
	Request.prototype.pipe = Request.prototype.write = function(){
	  throw Error("Streaming is not supported in browser version of superagent");
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	
	Request.prototype._appendQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
	  }
	
	  if (this._sort) {
	    var index = this.url.indexOf('?');
	    if (index >= 0) {
	      var queryArr = this.url.substring(index + 1).split('&');
	      if (isFunction(this._sort)) {
	        queryArr.sort(this._sort);
	      } else {
	        queryArr.sort();
	      }
	      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
	    }
	  }
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	Request.prototype._isHost = function _isHost(obj) {
	  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
	  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
	}
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  if (this._endCalled) {
	    console.warn("Warning: .end() was called twice. This is not supported in superagent");
	  }
	  this._endCalled = true;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // querystring
	  this._appendQueryString();
	
	  return this._end();
	};
	
	Request.prototype._end = function() {
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var data = this._formData || this._data;
	
	  this._setTimeouts();
	
	  // state change
	  xhr.onreadystatechange = function(){
	    var readyState = xhr.readyState;
	    if (readyState >= 2 && self._responseTimeoutTimer) {
	      clearTimeout(self._responseTimeoutTimer);
	    }
	    if (4 != readyState) {
	      return;
	    }
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (!status) {
	      if (self.timedout || self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(direction, e) {
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = direction;
	    self.emit('progress', e);
	  }
	  if (this.hasListeners('progress')) {
	    try {
	      xhr.onprogress = handleProgress.bind(null, 'download');
	      if (xhr.upload) {
	        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
	      }
	    } catch(e) {
	      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	      // Reported here:
	      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	    }
	  }
	
	  // initiate request
	  try {
	    if (this.username && this.password) {
	      xhr.open(this.method, this.url, true, this.username, this.password);
	    } else {
	      xhr.open(this.method, this.url, true);
	    }
	  } catch (err) {
	    // see #1149
	    return this.callback(err);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) {
	      serialize = request.serialize['application/json'];
	    }
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	
	    if (this.header.hasOwnProperty(field))
	      xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn){
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, data, fn){
	  var req = request('DELETE', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ },
/* 1816 */
[4179, 528],
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(528);
	
	/**
	 * Expose `RequestBase`.
	 */
	
	module.exports = RequestBase;
	
	/**
	 * Initialize a new `RequestBase`.
	 *
	 * @api public
	 */
	
	function RequestBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in RequestBase.prototype) {
	    obj[key] = RequestBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.clearTimeout = function _clearTimeout(){
	  clearTimeout(this._timer);
	  clearTimeout(this._responseTimeoutTimer);
	  delete this._timer;
	  delete this._responseTimeoutTimer;
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set format of binary response body.
	 * In browser valid formats are 'blob' and 'arraybuffer',
	 * which return Blob and ArrayBuffer, respectively.
	 *
	 * In Node all values result in Buffer.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeouts.
	 *
	 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
	 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
	 *
	 * Value of 0 or false means no timeout.
	 *
	 * @param {Number|Object} ms or {response, read, deadline}
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.timeout = function timeout(options){
	  if (!options || 'object' !== typeof options) {
	    this._timeout = options;
	    this._responseTimeout = 0;
	    return this;
	  }
	
	  for(var option in options) {
	    switch(option) {
	      case 'deadline':
	        this._timeout = options.deadline;
	        break;
	      case 'response':
	        this._responseTimeout = options.response;
	        break;
	      default:
	        console.warn("Unknown timeout option", option);
	    }
	  }
	  return this;
	};
	
	/**
	 * Set number of retry attempts on error.
	 *
	 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
	 *
	 * @param {Number} count
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.retry = function retry(count){
	  // Default to 1 if no count passed or true
	  if (arguments.length === 0 || count === true) count = 1;
	  if (count <= 0) count = 0;
	  this._maxRetries = count;
	  this._retries = 0;
	  return this;
	};
	
	/**
	 * Retry request
	 *
	 * @return {Request} for chaining
	 * @api private
	 */
	
	RequestBase.prototype._retry = function() {
	  this.clearTimeout();
	
	  // node
	  if (this.req) {
	    this.req = null;
	    this.req = this.request();
	  }
	
	  this._aborted = false;
	  this.timedout = false;
	
	  return this._end();
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} [reject]
	 * @return {Request}
	 */
	
	RequestBase.prototype.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    if (this._endCalled) {
	      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
	    }
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
	      self.end(function(err, res){
	        if (err) innerReject(err); else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	}
	
	RequestBase.prototype.catch = function(cb) {
	  return this.then(undefined, cb);
	};
	
	/**
	 * Allow for extension
	 */
	
	RequestBase.prototype.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	RequestBase.prototype.ok = function(cb) {
	  if ('function' !== typeof cb) throw Error("Callback required");
	  this._okCallback = cb;
	  return this;
	};
	
	RequestBase.prototype._isResponseOK = function(res) {
	  if (!res) {
	    return false;
	  }
	
	  if (this._okCallback) {
	    return this._okCallback(res);
	  }
	
	  return res.status >= 200 && res.status < 300;
	};
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	RequestBase.prototype.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	RequestBase.prototype.getHeader = RequestBase.prototype.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	RequestBase.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val`, or multiple fields with one object
	 * for "multipart/form-data" request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 *
	 * request.post('/upload')
	 *   .field({ foo: 'bar', baz: 'qux' })
	 *   .end(callback);
	 * ```
	 *
	 * @param {String|Object} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	RequestBase.prototype.field = function(name, val) {
	
	  // name should be either a string or an object.
	  if (null === name ||  undefined === name) {
	    throw new Error('.field(name, val) name can not be empty');
	  }
	
	  if (this._data) {
	    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObject(name)) {
	    for (var key in name) {
	      this.field(key, name[key]);
	    }
	    return this;
	  }
	
	  if (Array.isArray(val)) {
	    for (var i in val) {
	      this.field(name, val[i]);
	    }
	    return this;
	  }
	
	  // val should be defined now
	  if (null === val || undefined === val) {
	    throw new Error('.field(name, val) val can not be empty');
	  }
	  if ('boolean' === typeof val) {
	    val = '' + val;
	  }
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	RequestBase.prototype.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	RequestBase.prototype.withCredentials = function(on){
	  // This is browser-only functionality. Node side is no-op.
	  if(on==undefined) on = true;
	  this._withCredentials = on;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	RequestBase.prototype.toJSON = function(){
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header
	  };
	};
	
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.send = function(data){
	  var isObj = isObject(data);
	  var type = this._header['content-type'];
	
	  if (this._formData) {
	    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObj && !this._data) {
	    if (Array.isArray(data)) {
	      this._data = [];
	    } else if (!this._isHost(data)) {
	      this._data = {};
	    }
	  } else if (data && this._data && this._isHost(this._data)) {
	    throw Error("Can't merge these send calls");
	  }
	
	  // merge
	  if (isObj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!isObj || this._isHost(data)) {
	    return this;
	  }
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};
	
	
	/**
	 * Sort `querystring` by the sort function
	 *
	 *
	 * Examples:
	 *
	 *       // default order
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery()
	 *         .end(callback)
	 *
	 *       // customized sort function
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery(function(a, b){
	 *           return a.length - b.length;
	 *         })
	 *         .end(callback)
	 *
	 *
	 * @param {Function} sort
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.sortQuery = function(sort) {
	  // _sort default to true but otherwise can be a function or boolean
	  this._sort = typeof sort === 'undefined' ? true : sort;
	  return this;
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	RequestBase.prototype._timeoutError = function(reason, timeout, errno){
	  if (this._aborted) {
	    return;
	  }
	  var err = new Error(reason + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  err.code = 'ECONNABORTED';
	  err.errno = errno;
	  this.timedout = true;
	  this.abort();
	  this.callback(err);
	};
	
	RequestBase.prototype._setTimeouts = function() {
	  var self = this;
	
	  // deadline
	  if (this._timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
	    }, this._timeout);
	  }
	  // response timeout
	  if (this._responseTimeout && !this._responseTimeoutTimer) {
	    this._responseTimeoutTimer = setTimeout(function(){
	      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
	    }, this._responseTimeout);
	  }
	}


/***/ },
/* 1818 */
[4180, 1820],
/* 1819 */
/***/ function(module, exports) {

	var ERROR_CODES = [
	  'ECONNRESET',
	  'ETIMEDOUT',
	  'EADDRINFO',
	  'ESOCKETTIMEDOUT'
	];
	
	/**
	 * Determine if a request should be retried.
	 * (Borrowed from segmentio/superagent-retry)
	 *
	 * @param {Error} err
	 * @param {Response} [res]
	 * @returns {Boolean}
	 */
	module.exports = function shouldRetry(err, res) {
	  if (err && err.code && ~ERROR_CODES.indexOf(err.code)) return true;
	  if (res && res.status && res.status >= 500) return true;
	  // Superagent timeout
	  if (err && 'timeout' in err && err.code == 'ECONNABORTED') return true;
	  if (err && 'crossDomain' in err) return true;
	  return false;
	};


/***/ },
/* 1820 */
/***/ function(module, exports) {

	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	exports.type = function(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.params = function(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */);
	    var key = parts.shift();
	    var val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Parse Link header fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.parseLinks = function(str){
	  return str.split(/ *, */).reduce(function(obj, str){
	    var parts = str.split(/ *; */);
	    var url = parts[0].slice(1, -1);
	    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
	    obj[rel] = url;
	    return obj;
	  }, {});
	};
	
	/**
	 * Strip content related fields from `header`.
	 *
	 * @param {Object} header
	 * @return {Object} header
	 * @api private
	 */
	
	exports.cleanHeader = function(header, shouldStripCookie){
	  delete header['content-type'];
	  delete header['content-length'];
	  delete header['transfer-encoding'];
	  delete header['host'];
	  if (shouldStripCookie) {
	    delete header['cookie'];
	  }
	  return header;
	};

/***/ },
/* 1821 */
/***/ function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 71);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	module.exports = typeof window == 'object' && window && window.Math == Math ? window
	  : typeof self == 'object' && self && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var store = __webpack_require__(20)('wks');
	var uid = __webpack_require__(56);
	var Symbol = __webpack_require__(0).Symbol;
	var NATIVE_SYMBOL = __webpack_require__(113);
	
	module.exports = function (name) {
	  return store[name] || (store[name] = NATIVE_SYMBOL && Symbol[name]
	    || (NATIVE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPortal", function() { return createPortal; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_batchedUpdates", function() { return unstable_batchedUpdates; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(79);
	
	
	
	
	var version = '15.1.0'; // trick libraries to think we are react
	
	var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');
	
	var REACT_ELEMENT_TYPE = (typeof Symbol!=='undefined' && Symbol.for && Symbol.for('react.element')) || 0xeac7;
	
	var COMPONENT_WRAPPER_KEY = (typeof Symbol!=='undefined' && Symbol.for) ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';
	
	// don't autobind these methods since they already have guaranteed context.
	var AUTOBIND_BLACKLIST = {
		constructor: 1,
		render: 1,
		shouldComponentUpdate: 1,
		componentWillReceiveProps: 1,
		componentWillUpdate: 1,
		componentDidUpdate: 1,
		componentWillMount: 1,
		componentDidMount: 1,
		componentWillUnmount: 1,
		componentDidUnmount: 1
	};
	
	
	var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;
	
	
	var BYPASS_HOOK = {};
	
	/*global process*/
	var DEV = false;
	try {
		DEV = process.env.NODE_ENV!=='production';
	}
	catch (e) {}
	
	// a component that renders nothing. Used to replace components for unmountComponentAtNode.
	function EmptyComponent() { return null; }
	
	
	
	// make react think we're react.
	var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])('a', null).constructor;
	VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
	VNode.prototype.preactCompatUpgraded = false;
	VNode.prototype.preactCompatNormalized = false;
	
	Object.defineProperty(VNode.prototype, 'type', {
		get: function() { return this.nodeName; },
		set: function(v) { this.nodeName = v; },
		configurable:true
	});
	
	Object.defineProperty(VNode.prototype, 'props', {
		get: function() { return this.attributes; },
		set: function(v) { this.attributes = v; },
		configurable:true
	});
	
	
	
	var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].event;
	__WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].event = function (e) {
		if (oldEventHook) { e = oldEventHook(e); }
		e.persist = Object;
		e.nativeEvent = e;
		return e;
	};
	
	
	var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].vnode;
	__WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].vnode = function (vnode) {
		if (!vnode.preactCompatUpgraded) {
			vnode.preactCompatUpgraded = true;
	
			var tag = vnode.nodeName,
				attrs = vnode.attributes = vnode.attributes==null ? {} : extend({}, vnode.attributes);
	
			if (typeof tag==='function') {
				if (tag[COMPONENT_WRAPPER_KEY]===true || (tag.prototype && 'isReactComponent' in tag.prototype)) {
					if (vnode.children && String(vnode.children)==='') { vnode.children = undefined; }
					if (vnode.children) { attrs.children = vnode.children; }
	
					if (!vnode.preactCompatNormalized) {
						normalizeVNode(vnode);
					}
					handleComponentVNode(vnode);
				}
			}
			else {
				if (vnode.children && String(vnode.children)==='') { vnode.children = undefined; }
				if (vnode.children) { attrs.children = vnode.children; }
	
				if (attrs.defaultValue) {
					if (!attrs.value && attrs.value!==0) {
						attrs.value = attrs.defaultValue;
					}
					delete attrs.defaultValue;
				}
	
				handleElementVNode(vnode, attrs);
			}
		}
	
		if (oldVnodeHook) { oldVnodeHook(vnode); }
	};
	
	function handleComponentVNode(vnode) {
		var tag = vnode.nodeName,
			a = vnode.attributes;
	
		vnode.attributes = {};
		if (tag.defaultProps) { extend(vnode.attributes, tag.defaultProps); }
		if (a) { extend(vnode.attributes, a); }
	}
	
	function handleElementVNode(vnode, a) {
		var shouldSanitize, attrs, i;
		if (a) {
			for (i in a) { if ((shouldSanitize = CAMEL_PROPS.test(i))) { break; } }
			if (shouldSanitize) {
				attrs = vnode.attributes = {};
				for (i in a) {
					if (a.hasOwnProperty(i)) {
						attrs[ CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i ] = a[i];
					}
				}
			}
		}
	}
	
	
	
	// proxy render() since React returns a Component reference.
	function render$1(vnode, parent, callback) {
		var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;
	
		// ignore impossible previous renders
		if (prev && prev.parentNode!==parent) { prev = null; }
	
		// default to first Element child
		if (!prev && parent) { prev = parent.firstElementChild; }
	
		// remove unaffected siblings
		for (var i=parent.childNodes.length; i--; ) {
			if (parent.childNodes[i]!==prev) {
				parent.removeChild(parent.childNodes[i]);
			}
		}
	
		var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["e" /* render */])(vnode, parent, prev);
		if (parent) { parent._preactCompatRendered = out && (out._component || { base: out }); }
		if (typeof callback==='function') { callback(); }
		return out && out._component || out;
	}
	
	
	var ContextProvider = function () {};
	
	ContextProvider.prototype.getChildContext = function () {
		return this.props.context;
	};
	ContextProvider.prototype.render = function (props) {
		return props.children[0];
	};
	
	function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
		var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(ContextProvider, { context: parentComponent.context }, vnode);
		var renderContainer = render$1(wrap, container);
		var component = renderContainer._component || renderContainer.base;
		if (callback) { callback.call(component, renderContainer); }
		return component;
	}
	
	function Portal(props) {
		renderSubtreeIntoContainer(this, props.vnode, props.container);
	}
	
	function createPortal(vnode, container) {
		return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(Portal, { vnode: vnode, container: container });
	}
	
	
	function unmountComponentAtNode(container) {
		var existing = container._preactCompatRendered && container._preactCompatRendered.base;
		if (existing && existing.parentNode===container) {
			Object(__WEBPACK_IMPORTED_MODULE_1_preact__["e" /* render */])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(EmptyComponent), container, existing);
			return true;
		}
		return false;
	}
	
	
	
	var ARR = [];
	
	// This API is completely unnecessary for Preact, so it's basically passthrough.
	var Children = {
		map: function(children, fn, ctx) {
			if (children == null) { return null; }
			children = Children.toArray(children);
			if (ctx && ctx!==children) { fn = fn.bind(ctx); }
			return children.map(fn);
		},
		forEach: function(children, fn, ctx) {
			if (children == null) { return null; }
			children = Children.toArray(children);
			if (ctx && ctx!==children) { fn = fn.bind(ctx); }
			children.forEach(fn);
		},
		count: function(children) {
			return children && children.length || 0;
		},
		only: function(children) {
			children = Children.toArray(children);
			if (children.length!==1) { throw new Error('Children.only() expects only one child.'); }
			return children[0];
		},
		toArray: function(children) {
			if (children == null) { return []; }
			return ARR.concat(children);
		}
	};
	
	
	/** Track current render() component for ref assignment */
	var currentComponent;
	
	
	function createFactory(type) {
		return createElement.bind(null, type);
	}
	
	
	var DOM = {};
	for (var i=ELEMENTS.length; i--; ) {
		DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
	}
	
	function upgradeToVNodes(arr, offset) {
		for (var i=offset || 0; i<arr.length; i++) {
			var obj = arr[i];
			if (Array.isArray(obj)) {
				upgradeToVNodes(obj);
			}
			else if (obj && typeof obj==='object' && !isValidElement(obj) && ((obj.props && obj.type) || (obj.attributes && obj.nodeName) || obj.children)) {
				arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
			}
		}
	}
	
	function isStatelessComponent(c) {
		return typeof c==='function' && !(c.prototype && c.prototype.render);
	}
	
	
	// wraps stateless functional components in a PropTypes validator
	function wrapStatelessComponent(WrappedComponent) {
		return createClass({
			displayName: WrappedComponent.displayName || WrappedComponent.name,
			render: function() {
				return WrappedComponent(this.props, this.context);
			}
		});
	}
	
	
	function statelessComponentHook(Ctor) {
		var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
		if (Wrapped) { return Wrapped===true ? Ctor : Wrapped; }
	
		Wrapped = wrapStatelessComponent(Ctor);
	
		Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable:true, value:true });
		Wrapped.displayName = Ctor.displayName;
		Wrapped.propTypes = Ctor.propTypes;
		Wrapped.defaultProps = Ctor.defaultProps;
	
		Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable:true, value:Wrapped });
	
		return Wrapped;
	}
	
	
	function createElement() {
		var args = [], len = arguments.length;
		while ( len-- ) args[ len ] = arguments[ len ];
	
		upgradeToVNodes(args, 2);
		return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */].apply(void 0, args));
	}
	
	
	function normalizeVNode(vnode) {
		vnode.preactCompatNormalized = true;
	
		applyClassName(vnode);
	
		if (isStatelessComponent(vnode.nodeName)) {
			vnode.nodeName = statelessComponentHook(vnode.nodeName);
		}
	
		var ref = vnode.attributes.ref,
			type = ref && typeof ref;
		if (currentComponent && (type==='string' || type==='number')) {
			vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
		}
	
		applyEventNormalization(vnode);
	
		return vnode;
	}
	
	
	function cloneElement$1(element, props) {
		var children = [], len = arguments.length - 2;
		while ( len-- > 0 ) children[ len ] = arguments[ len + 2 ];
	
		if (!isValidElement(element)) { return element; }
		var elementProps = element.attributes || element.props;
		var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(
			element.nodeName || element.type,
			extend({}, elementProps),
			element.children || elementProps && elementProps.children
		);
		// Only provide the 3rd argument if needed.
		// Arguments 3+ overwrite element.children in preactCloneElement
		var cloneArgs = [node, props];
		if (children && children.length) {
			cloneArgs.push(children);
		}
		else if (props && props.children) {
			cloneArgs.push(props.children);
		}
		return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* cloneElement */].apply(void 0, cloneArgs));
	}
	
	
	function isValidElement(element) {
		return element && ((element instanceof VNode) || element.$$typeof===REACT_ELEMENT_TYPE);
	}
	
	
	function createStringRefProxy(name, component) {
		return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
			if (component && component.refs) {
				component.refs[name] = resolved;
				if (resolved===null) {
					delete component._refProxies[name];
					component = null;
				}
			}
		});
	}
	
	
	function applyEventNormalization(ref) {
		var nodeName = ref.nodeName;
		var attributes = ref.attributes;
	
		if (!attributes || typeof nodeName!=='string') { return; }
		var props = {};
		for (var i in attributes) {
			props[i.toLowerCase()] = i;
		}
		if (props.ondoubleclick) {
			attributes.ondblclick = attributes[props.ondoubleclick];
			delete attributes[props.ondoubleclick];
		}
		// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
		if (props.onchange && (nodeName==='textarea' || (nodeName.toLowerCase()==='input' && !/^fil|che|rad/i.test(attributes.type)))) {
			var normalized = props.oninput || 'oninput';
			if (!attributes[normalized]) {
				attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
				delete attributes[props.onchange];
			}
		}
	}
	
	
	function applyClassName(vnode) {
		var a = vnode.attributes || (vnode.attributes = {});
		classNameDescriptor.enumerable = 'className' in a;
		if (a.className) { a.class = a.className; }
		Object.defineProperty(a, 'className', classNameDescriptor);
	}
	
	
	var classNameDescriptor = {
		configurable: true,
		get: function() { return this.class; },
		set: function(v) { this.class = v; }
	};
	
	function extend(base, props) {
		var arguments$1 = arguments;
	
		for (var i=1, obj = (void 0); i<arguments.length; i++) {
			if ((obj = arguments$1[i])) {
				for (var key in obj) {
					if (obj.hasOwnProperty(key)) {
						base[key] = obj[key];
					}
				}
			}
		}
		return base;
	}
	
	
	function shallowDiffers(a, b) {
		for (var i in a) { if (!(i in b)) { return true; } }
		for (var i$1 in b) { if (a[i$1]!==b[i$1]) { return true; } }
		return false;
	}
	
	
	function findDOMNode(component) {
		return component && (component.base || component.nodeType === 1 && component) || null;
	}
	
	
	function F(){}
	
	function createClass(obj) {
		function cl(props, context) {
			bindAll(this);
			Component$1.call(this, props, context, BYPASS_HOOK);
			newComponentHook.call(this, props, context);
		}
	
		obj = extend({ constructor: cl }, obj);
	
		// We need to apply mixins here so that getDefaultProps is correctly mixed
		if (obj.mixins) {
			applyMixins(obj, collateMixins(obj.mixins));
		}
		if (obj.statics) {
			extend(cl, obj.statics);
		}
		if (obj.propTypes) {
			cl.propTypes = obj.propTypes;
		}
		if (obj.defaultProps) {
			cl.defaultProps = obj.defaultProps;
		}
		if (obj.getDefaultProps) {
			cl.defaultProps = obj.getDefaultProps.call(cl);
		}
	
		F.prototype = Component$1.prototype;
		cl.prototype = extend(new F(), obj);
	
		cl.displayName = obj.displayName || 'Component';
	
		return cl;
	}
	
	
	// Flatten an Array of mixins to a map of method name to mixin implementations
	function collateMixins(mixins) {
		var keyed = {};
		for (var i=0; i<mixins.length; i++) {
			var mixin = mixins[i];
			for (var key in mixin) {
				if (mixin.hasOwnProperty(key) && typeof mixin[key]==='function') {
					(keyed[key] || (keyed[key]=[])).push(mixin[key]);
				}
			}
		}
		return keyed;
	}
	
	
	// apply a mapping of Arrays of mixin methods to a component prototype
	function applyMixins(proto, mixins) {
		for (var key in mixins) { if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(
				mixins[key].concat(proto[key] || ARR),
				key==='getDefaultProps' || key==='getInitialState' || key==='getChildContext'
			);
		} }
	}
	
	
	function bindAll(ctx) {
		for (var i in ctx) {
			var v = ctx[i];
			if (typeof v==='function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
				(ctx[i] = v.bind(ctx)).__bound = true;
			}
		}
	}
	
	
	function callMethod(ctx, m, args) {
		if (typeof m==='string') {
			m = ctx.constructor.prototype[m];
		}
		if (typeof m==='function') {
			return m.apply(ctx, args);
		}
	}
	
	function multihook(hooks, skipDuplicates) {
		return function() {
			var arguments$1 = arguments;
			var this$1 = this;
	
			var ret;
			for (var i=0; i<hooks.length; i++) {
				var r = callMethod(this$1, hooks[i], arguments$1);
	
				if (skipDuplicates && r!=null) {
					if (!ret) { ret = {}; }
					for (var key in r) { if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					} }
				}
				else if (typeof r!=='undefined') { ret = r; }
			}
			return ret;
		};
	}
	
	
	function newComponentHook(props, context) {
		propsHook.call(this, props, context);
		this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
		this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
	}
	
	
	function propsHook(props, context) {
		if (!props) { return; }
	
		// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
		var c = props.children;
		if (c && Array.isArray(c) && c.length===1 && (typeof c[0]==='string' || typeof c[0]==='function' || c[0] instanceof VNode)) {
			props.children = c[0];
	
			// but its totally still going to be an Array.
			if (props.children && typeof props.children==='object') {
				props.children.length = 1;
				props.children[0] = props.children;
			}
		}
	
		// add proptype checking
		if (DEV) {
			var ctor = typeof this==='function' ? this : this.constructor,
				propTypes = this.propTypes || ctor.propTypes;
			var displayName = this.displayName || ctor.name;
	
			if (propTypes) {
				__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
			}
		}
	}
	
	
	function beforeRender(props) {
		currentComponent = this;
	}
	
	function afterRender() {
		if (currentComponent===this) {
			currentComponent = null;
		}
	}
	
	
	
	function Component$1(props, context, opts) {
		__WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */].call(this, props, context);
		this.state = this.getInitialState ? this.getInitialState() : {};
		this.refs = {};
		this._refProxies = {};
		if (opts!==BYPASS_HOOK) {
			newComponentHook.call(this, props, context);
		}
	}
	extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */](), {
		constructor: Component$1,
	
		isReactComponent: {},
	
		replaceState: function(state, callback) {
			var this$1 = this;
	
			this.setState(state, callback);
			for (var i in this$1.state) {
				if (!(i in state)) {
					delete this$1.state[i];
				}
			}
		},
	
		getDOMNode: function() {
			return this.base;
		},
	
		isMounted: function() {
			return !!this.base;
		}
	});
	
	
	
	function PureComponent(props, context) {
		Component$1.call(this, props, context);
	}
	F.prototype = Component$1.prototype;
	PureComponent.prototype = new F();
	PureComponent.prototype.isPureReactComponent = true;
	PureComponent.prototype.shouldComponentUpdate = function(props, state) {
		return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
	};
	
	function unstable_batchedUpdates(callback) {
		callback();
	}
	
	var index = {
		version: version,
		DOM: DOM,
		PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
		Children: Children,
		render: render$1,
		createClass: createClass,
		createPortal: createPortal,
		createFactory: createFactory,
		createElement: createElement,
		cloneElement: cloneElement$1,
		isValidElement: isValidElement,
		findDOMNode: findDOMNode,
		unmountComponentAtNode: unmountComponentAtNode,
		Component: Component$1,
		PureComponent: PureComponent,
		unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
		unstable_batchedUpdates: unstable_batchedUpdates,
		__spread: extend
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (index);
	
	//# sourceMappingURL=preact-compat.es.js.map
	
	/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var ReactIs = __webpack_require__(42);
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(75)(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(78)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(5);
	
	module.exports = function (it) {
	  if (!isObject(it)) {
	    throw TypeError(String(it) + ' is not an object');
	  } return it;
	};
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	var hasOwnProperty = {}.hasOwnProperty;
	
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var definePropertyModule = __webpack_require__(14);
	var createPropertyDescriptor = __webpack_require__(35);
	
	module.exports = __webpack_require__(13) ? function (object, key, value) {
	  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.redirectAfterSubmit = exports.omit = exports.noop = exports.applyIOSIframeResizeHack = exports.applyIOSFooterHack = exports.debounce = exports.fixSafariScroll = exports.isElementInViewport = exports.onMessage = exports.ensureMetaViewport = exports.replaceExistingKeys = exports.appendParamsToUrl = exports.updateQueryStringParameter = exports.randomString = exports.DOMAIN = undefined;
	
	var _customEvent = __webpack_require__(80);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	var _isUrl = __webpack_require__(81);
	
	var _isUrl2 = _interopRequireDefault(_isUrl);
	
	var _urlParse = __webpack_require__(43);
	
	var _urlParse2 = _interopRequireDefault(_urlParse);
	
	var _isobject = __webpack_require__(84);
	
	var _isobject2 = _interopRequireDefault(_isobject);
	
	var _mobileDetection = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DOMAIN_REGEXP = /(\.typeform)\.(com|io)$/;
	var DOMAIN = exports.DOMAIN = 'admin.typeform.com';
	
	var randomString = exports.randomString = function randomString() {
	  return Math.random().toString(36).substr(2, 5);
	};
	
	var updateQueryStringParameter = exports.updateQueryStringParameter = function updateQueryStringParameter(key, value, uri) {
	  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
	  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
	  if (uri.match(re)) {
	    return uri.replace(re, '$1' + key + '=' + value + '$2');
	  }
	
	  return uri + separator + key + '=' + value;
	};
	
	var appendParamsToUrl = exports.appendParamsToUrl = function appendParamsToUrl(url, params) {
	  var queryParameters = [];
	
	  var _UrlParse = (0, _urlParse2.default)(url, true),
	      query = _UrlParse.query,
	      origin = _UrlParse.origin,
	      pathname = _UrlParse.pathname;
	
	  var path = pathname.replace(/\/$/, ''); // remove trailing slash
	  var parameters = Object.assign({}, query, params);
	
	  Object.keys(parameters).forEach(function (key) {
	    queryParameters.push(encodeURIComponent(key) + '=' + encodeURIComponent(parameters[key]));
	  });
	
	  return '' + origin + path + '?' + queryParameters.join('&');
	};
	
	var replaceExistingKeys = exports.replaceExistingKeys = function replaceExistingKeys(obj, replacer) {
	  return Object.keys(replacer).reduce(function (acc, oldKey) {
	    var newKey = replacer[oldKey];
	    if (newKey != null && obj[oldKey] != null && obj[oldKey] !== false) {
	      acc[newKey] = obj[oldKey];
	    }
	
	    return acc;
	  }, {});
	};
	
	var ensureMetaViewport = exports.ensureMetaViewport = function ensureMetaViewport() {
	  if (!document.querySelector) {
	    return;
	  }
	
	  var viewport = document.querySelector('meta[name=viewport]');
	  var viewportContent = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0';
	
	  if (viewport) {
	    viewport.setAttribute('content', viewportContent);
	  } else {
	    var metaTag = document.createElement('meta');
	    metaTag.content = viewportContent;
	    metaTag.name = 'viewport';
	    document.head.appendChild(metaTag);
	  }
	};
	
	var acceptMessageOrigin = function acceptMessageOrigin(e) {
	  if (process.env.NODE_ENV === 'development') {
	    return true;
	  }
	
	  // deal with polymorphistic legacy: some events come from jQuery, other Vanilla JS
	  var re = new RegExp('^(?:f|ht)tp(?:s)?://([^/]+)', 'im');
	  var matches = e.origin.match(re);
	  if (matches && matches.length > 1) {
	    var domain = matches[1].toString();
	
	    // to test this in local you will need to whitelist your local domain
	    if (!DOMAIN_REGEXP.test(domain)) {
	      return false;
	    }
	  } else {
	    return false;
	  }
	
	  return true;
	};
	
	var onMessage = exports.onMessage = function onMessage(e) {
	  e = e.originalEvent || e;
	  if (!acceptMessageOrigin(e)) {
	    return false;
	  }
	
	  if ((0, _isUrl2.default)(e.data)) {
	    window.location.href = e.data;
	    return;
	  }
	
	  if ((0, _isobject2.default)(e.data) && e.data.hasOwnProperty('type')) {
	    window.dispatchEvent(new _customEvent2.default(e.data.type, {
	      detail: e.data
	    }));
	    return;
	  }
	
	  window.dispatchEvent(new _customEvent2.default(e.data));
	};
	
	var isElementInViewport = exports.isElementInViewport = function isElementInViewport(el) {
	  // If it's a nested iframe, don't try to calculate if is insideViewport
	  if (window.top !== window) {
	    return false;
	  }
	
	  var rect = el.getBoundingClientRect();
	
	  var margin = rect.height * 0.2; // 20% of margin
	  var docWidth = window.innerWidth || document.documentElement.clientWidth;
	  var docHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  return rect.top >= -margin && rect.left >= -margin && rect.bottom <= docHeight + margin && rect.right <= docWidth + margin;
	};
	
	// RD-712
	var fixSafariScroll = exports.fixSafariScroll = function fixSafariScroll(iframe) {
	  if ((0, _mobileDetection.isMobile)(navigator.userAgent) || !(0, _mobileDetection.isSafari)(navigator.userAgent)) {
	    return;
	  }
	
	  iframe.addEventListener('load', function () {
	    return setTimeout(function () {
	      var originalHeight = window.getComputedStyle(iframe).height;
	      iframe.setAttribute('height', iframe.offsetHeight + 1 + 'px');
	      return setTimeout(function () {
	        iframe.setAttribute('height', originalHeight);
	      }, 1);
	    }, 1000);
	  });
	};
	
	var debounce = exports.debounce = function debounce(func, wait, context) {
	  var timeout = void 0;
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var debounced = function debounced() {
	      timeout = null;
	      func.call.apply(func, [context].concat(args));
	    };
	
	    clearTimeout(timeout);
	    timeout = setTimeout(debounced, wait);
	  };
	};
	
	// Fix RD-731, footer not fully visible on iOS devices
	var applyIOSFooterHack = exports.applyIOSFooterHack = function applyIOSFooterHack(element) {
	  if (!(0, _mobileDetection.isIOSDevice)(navigator.userAgent)) {
	    return;
	  }
	
	  element.setAttribute('scrolling', 'no');
	  element.style.height = '1px';
	  element.style.minHeight = '100%';
	};
	
	var applyIOSIframeResizeHack = exports.applyIOSIframeResizeHack = function applyIOSIframeResizeHack(element) {
	  if (!(0, _mobileDetection.isIOSDevice)(navigator.userAgent)) {
	    return;
	  }
	
	  element.style.maxHeight = '100%';
	  element.style.maxWidth = '100%';
	  element.style.minHeight = '100%';
	  element.style.minWidth = '100%';
	  element.style.width = 0;
	};
	
	var noop = exports.noop = function noop() {
	  return null;
	};
	
	var omit = function omit(key, object) {
	  var deletedKey = object[key],
	      otherKeys = _objectWithoutProperties(object, [key]);
	
	  return otherKeys;
	};
	
	exports.omit = omit;
	var redirectAfterSubmit = exports.redirectAfterSubmit = function redirectAfterSubmit(event) {
	  var url = event.detail.url;
	
	
	  try {
	    var anchor = document.createElement('a');
	
	    anchor.href = url;
	
	    document.body.appendChild(anchor);
	    anchor.click();
	    document.body.removeChild(anchor);
	  } catch (e) {}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(0);
	var getOwnPropertyDescriptor = __webpack_require__(34).f;
	var hide = __webpack_require__(8);
	var redefine = __webpack_require__(19);
	var setGlobal = __webpack_require__(37);
	var copyConstructorProperties = __webpack_require__(106);
	var isForced = __webpack_require__(57);
	
	/*
	  options.target      - name of the target object
	  options.global      - target is the global object
	  options.stat        - export as static methods of target
	  options.proto       - export as prototype methods of target
	  options.real        - real prototype method for the `pure` version
	  options.forced      - export even if the native feature is available
	  options.bind        - bind methods to the target, required for the `pure` version
	  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
	  options.sham        - add a flag to not completely full polyfills
	  options.enumerable  - export as enumerable property
	  options.noTargetGet - prevent calling a getter on target
	*/
	module.exports = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = global;
	  } else if (STATIC) {
	    target = global[TARGET] || setGlobal(TARGET, {});
	  } else {
	    target = (global[TARGET] || {}).prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.noTargetGet) {
	      descriptor = getOwnPropertyDescriptor(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty === typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || (targetProperty && targetProperty.sham)) {
	      hide(sourceProperty, 'sham', true);
	    }
	    // extend global
	    redefine(target, key, sourceProperty, options);
	  }
	};
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(10)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var DESCRIPTORS = __webpack_require__(13);
	var IE8_DOM_DEFINE = __webpack_require__(54);
	var anObject = __webpack_require__(6);
	var toPrimitive = __webpack_require__(53);
	var nativeDefineProperty = Object.defineProperty;
	
	exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return nativeDefineProperty(O, P, Attributes);
	  } catch (error) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	module.exports = {};
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isScreenBig = exports.isScreenBig = function isScreenBig() {
	  return window.screen.width >= 1024 && window.screen.height >= 768;
	};
	
	var isMobile = exports.isMobile = function isMobile(ua) {
	  return (/mobile|tablet|android/i.test(ua.toLowerCase())
	  );
	};
	
	var isSafari = exports.isSafari = function isSafari(ua) {
	  return (/^((?!chrome|android).)*safari/i.test(ua.toLowerCase())
	  );
	};
	
	var isIOSDevice = exports.isIOSDevice = function isIOSDevice(ua) {
	  return (/ip(hone|od|ad)/i.test(ua.toLowerCase())
	  );
	};
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.keyframes = exports.injectGlobal = exports.css = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createEmotion = __webpack_require__(86);
	
	var _createEmotion2 = _interopRequireDefault(_createEmotion);
	
	var _createEmotionStyled = __webpack_require__(91);
	
	var _createEmotionStyled2 = _interopRequireDefault(_createEmotionStyled);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var context = typeof global !== 'undefined' ? global : {};
	
	var emotion = (0, _createEmotion2.default)(context);
	
	var css = exports.css = emotion.css;
	var injectGlobal = exports.injectGlobal = emotion.injectGlobal;
	var keyframes = exports.keyframes = emotion.keyframes;
	exports.default = (0, _createEmotionStyled2.default)(emotion, _react2.default);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// toObject with fallback for non-array-like ES3 strings
	var IndexedObject = __webpack_require__(27);
	var requireObjectCoercible = __webpack_require__(28);
	
	module.exports = function (it) {
	  return IndexedObject(requireObjectCoercible(it));
	};
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(0);
	var hide = __webpack_require__(8);
	var has = __webpack_require__(7);
	var setGlobal = __webpack_require__(37);
	var nativeFunctionToString = __webpack_require__(55);
	var InternalStateModule = __webpack_require__(22);
	var getInternalState = InternalStateModule.get;
	var enforceInternalState = InternalStateModule.enforce;
	var TEMPLATE = String(nativeFunctionToString).split('toString');
	
	__webpack_require__(20)('inspectSource', function (it) {
	  return nativeFunctionToString.call(it);
	});
	
	(module.exports = function (O, key, value, options) {
	  var unsafe = options ? !!options.unsafe : false;
	  var simple = options ? !!options.enumerable : false;
	  var noTargetGet = options ? !!options.noTargetGet : false;
	  if (typeof value == 'function') {
	    if (typeof key == 'string' && !has(value, 'name')) hide(value, 'name', key);
	    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
	  }
	  if (O === global) {
	    if (simple) O[key] = value;
	    else setGlobal(key, value);
	    return;
	  } else if (!unsafe) {
	    delete O[key];
	  } else if (!noTargetGet && O[key]) {
	    simple = true;
	  }
	  if (simple) O[key] = value;
	  else hide(O, key, value);
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, 'toString', function toString() {
	  return typeof this == 'function' && getInternalState(this).source || nativeFunctionToString.call(this);
	});
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(0);
	var setGlobal = __webpack_require__(37);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || setGlobal(SHARED, {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.0.1',
	  mode: __webpack_require__(21) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	module.exports = false;
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var NATIVE_WEAK_MAP = __webpack_require__(105);
	var isObject = __webpack_require__(5);
	var hide = __webpack_require__(8);
	var objectHas = __webpack_require__(7);
	var sharedKey = __webpack_require__(38);
	var hiddenKeys = __webpack_require__(31);
	var WeakMap = __webpack_require__(0).WeakMap;
	var set, get, has;
	
	var enforce = function (it) {
	  return has(it) ? get(it) : set(it, {});
	};
	
	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject(it) || (state = get(it)).type !== TYPE) {
	      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
	    } return state;
	  };
	};
	
	if (NATIVE_WEAK_MAP) {
	  var store = new WeakMap();
	  var wmget = store.get;
	  var wmhas = store.has;
	  var wmset = store.set;
	  set = function (it, metadata) {
	    wmset.call(store, it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return wmget.call(store, it) || {};
	  };
	  has = function (it) {
	    return wmhas.call(store, it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys[STATE] = true;
	  set = function (it, metadata) {
	    hide(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return objectHas(it, STATE) ? it[STATE] : {};
	  };
	  has = function (it) {
	    return objectHas(it, STATE);
	  };
	}
	
	module.exports = {
	  set: set,
	  get: get,
	  has: has,
	  enforce: enforce,
	  getterFor: getterFor
	};
	
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  if (typeof it != 'function') {
	    throw TypeError(String(it) + ' is not a function');
	  } return it;
	};
	
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports) {
	
	var g;
	
	// This works in non-strict mode
	g = (function() {
		return this;
	})();
	
	try {
		// This works if eval is allowed (see CSP)
		g = g || Function("return this")() || (1,eval)("this");
	} catch(e) {
		// This works if the window reference is available
		if(typeof window === "object")
			g = window;
	}
	
	// g can still be undefined, but nothing to do about it...
	// We return undefined, instead of nothing here, so it's
	// easier to handle this case. if(!global) { ...}
	
	module.exports = g;
	
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Iframe = function (_Component) {
	  _inherits(Iframe, _Component);
	
	  function Iframe(props) {
	    _classCallCheck(this, Iframe);
	
	    var _this = _possibleConstructorReturn(this, (Iframe.__proto__ || Object.getPrototypeOf(Iframe)).call(this, props));
	
	    _this.iframeRef = null;
	    _this.loadHandler = _this.loadHandler.bind(_this);
	    return _this;
	  }
	
	  // Fixes scroll not responding in renderer v1
	
	
	  _createClass(Iframe, [{
	    key: 'loadHandler',
	    value: function loadHandler() {
	      var _this2 = this;
	
	      this.iframeRef.style.height = this.iframeRef.offsetHeight + 1 + 'px';
	      setTimeout(function () {
	        _this2.iframeRef.style.height = '';
	        (0, _utils.applyIOSFooterHack)(_this2.iframeRef);
	        (0, _utils.applyIOSIframeResizeHack)(_this2.iframeRef);
	
	        _this2.props.onLoad && _this2.props.onLoad(_this2.iframeRef);
	      }, 1);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.src !== this.props.src;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          rest = _objectWithoutProperties(_props, ['style']);
	
	      return _react2.default.createElement('iframe', _extends({}, rest, {
	        'data-qa': 'iframe',
	        frameBorder: '0',
	        height: '100%',
	        onLoad: this.loadHandler,
	        ref: function ref(node) {
	          _this3.iframeRef = node;
	        },
	        src: this.props.src,
	        style: _extends({ border: 0 }, style),
	        width: '100%'
	      }));
	    }
	  }]);
	
	  return Iframe;
	}(_react.Component);
	
	Iframe.propTypes = {
	  src: _propTypes2.default.string.isRequired,
	  onLoad: _propTypes2.default.func,
	  style: _propTypes2.default.object
	};
	
	exports.default = Iframe;
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var fails = __webpack_require__(10);
	var classof = __webpack_require__(11);
	var split = ''.split;
	
	module.exports = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins
	  return !Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof(it) == 'String' ? split.call(it, '') : Object(it);
	} : Object;
	
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports) {
	
	// `RequireObjectCoercible` abstract operation
	// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on " + it);
	  return it;
	};
	
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var toInteger = __webpack_require__(30);
	var min = Math.min;
	
	// `ToLength` abstract operation
	// https://tc39.github.io/ecma262/#sec-tolength
	module.exports = function (argument) {
	  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};
	
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports) {
	
	var ceil = Math.ceil;
	var floor = Math.floor;
	
	// `ToInteger` abstract operation
	// https://tc39.github.io/ecma262/#sec-tointeger
	module.exports = function (argument) {
	  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
	};
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports) {
	
	module.exports = {};
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports) {
	
	// IE8- don't enum bug keys
	module.exports = [
	  'constructor',
	  'hasOwnProperty',
	  'isPrototypeOf',
	  'propertyIsEnumerable',
	  'toLocaleString',
	  'toString',
	  'valueOf'
	];
	
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var requireObjectCoercible = __webpack_require__(28);
	
	// `ToObject` abstract operation
	// https://tc39.github.io/ecma262/#sec-toobject
	module.exports = function (argument) {
	  return Object(requireObjectCoercible(argument));
	};
	
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var DESCRIPTORS = __webpack_require__(13);
	var propertyIsEnumerableModule = __webpack_require__(52);
	var createPropertyDescriptor = __webpack_require__(35);
	var toIndexedObject = __webpack_require__(18);
	var toPrimitive = __webpack_require__(53);
	var has = __webpack_require__(7);
	var IE8_DOM_DEFINE = __webpack_require__(54);
	var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return nativeGetOwnPropertyDescriptor(O, P);
	  } catch (error) { /* empty */ }
	  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
	};
	
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports) {
	
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(5);
	var document = __webpack_require__(0).document;
	// typeof document.createElement is 'object' in old IE
	var exist = isObject(document) && isObject(document.createElement);
	
	module.exports = function (it) {
	  return exist ? document.createElement(it) : {};
	};
	
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(0);
	var hide = __webpack_require__(8);
	
	module.exports = function (key, value) {
	  try {
	    hide(global, key, value);
	  } catch (error) {
	    global[key] = value;
	  } return value;
	};
	
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var shared = __webpack_require__(20)('keys');
	var uid = __webpack_require__(56);
	
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};
	
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var aFunction = __webpack_require__(23);
	
	// optional / simple context binding
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 0: return function () {
	      return fn.call(that);
	    };
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};
	
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var defineProperty = __webpack_require__(14).f;
	var has = __webpack_require__(7);
	var TO_STRING_TAG = __webpack_require__(1)('toStringTag');
	
	module.exports = function (it, TAG, STATIC) {
	  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
	    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
	  }
	};
	
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(0);
	
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	if (process.env.NODE_ENV === 'production') {
	  module.exports = __webpack_require__(73);
	} else {
	  module.exports = __webpack_require__(74);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {
	
	var required = __webpack_require__(82)
	  , qs = __webpack_require__(83)
	  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
	  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;
	
	/**
	 * These are the parse rules for the URL parser, it informs the parser
	 * about:
	 *
	 * 0. The char it Needs to parse, if it's a string it should be done using
	 *    indexOf, RegExp using exec and NaN means set as current value.
	 * 1. The property we should set when parsing this value.
	 * 2. Indication if it's backwards or forward parsing, when set as number it's
	 *    the value of extra chars that should be split off.
	 * 3. Inherit from location if non existing in the parser.
	 * 4. `toLowerCase` the resulting value.
	 */
	var rules = [
	  ['#', 'hash'],                        // Extract from the back.
	  ['?', 'query'],                       // Extract from the back.
	  function sanitize(address) {          // Sanitize what is left of the address
	    return address.replace('\\', '/');
	  },
	  ['/', 'pathname'],                    // Extract from the back.
	  ['@', 'auth', 1],                     // Extract from the front.
	  [NaN, 'host', undefined, 1, 1],       // Set left over value.
	  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
	  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
	];
	
	/**
	 * These properties should not be copied or inherited from. This is only needed
	 * for all non blob URL's as a blob URL does not include a hash, only the
	 * origin.
	 *
	 * @type {Object}
	 * @private
	 */
	var ignore = { hash: 1, query: 1 };
	
	/**
	 * The location object differs when your code is loaded through a normal page,
	 * Worker or through a worker using a blob. And with the blobble begins the
	 * trouble as the location object will contain the URL of the blob, not the
	 * location of the page where our code is loaded in. The actual origin is
	 * encoded in the `pathname` so we can thankfully generate a good "default"
	 * location from it so we can generate proper relative URL's again.
	 *
	 * @param {Object|String} loc Optional default location object.
	 * @returns {Object} lolcation object.
	 * @public
	 */
	function lolcation(loc) {
	  var globalVar;
	
	  if (typeof window !== 'undefined') globalVar = window;
	  else if (typeof global !== 'undefined') globalVar = global;
	  else if (typeof self !== 'undefined') globalVar = self;
	  else globalVar = {};
	
	  var location = globalVar.location || {};
	  loc = loc || location;
	
	  var finaldestination = {}
	    , type = typeof loc
	    , key;
	
	  if ('blob:' === loc.protocol) {
	    finaldestination = new Url(unescape(loc.pathname), {});
	  } else if ('string' === type) {
	    finaldestination = new Url(loc, {});
	    for (key in ignore) delete finaldestination[key];
	  } else if ('object' === type) {
	    for (key in loc) {
	      if (key in ignore) continue;
	      finaldestination[key] = loc[key];
	    }
	
	    if (finaldestination.slashes === undefined) {
	      finaldestination.slashes = slashes.test(loc.href);
	    }
	  }
	
	  return finaldestination;
	}
	
	/**
	 * @typedef ProtocolExtract
	 * @type Object
	 * @property {String} protocol Protocol matched in the URL, in lowercase.
	 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
	 * @property {String} rest Rest of the URL that is not part of the protocol.
	 */
	
	/**
	 * Extract protocol information from a URL with/without double slash ("//").
	 *
	 * @param {String} address URL we want to extract from.
	 * @return {ProtocolExtract} Extracted information.
	 * @private
	 */
	function extractProtocol(address) {
	  var match = protocolre.exec(address);
	
	  return {
	    protocol: match[1] ? match[1].toLowerCase() : '',
	    slashes: !!match[2],
	    rest: match[3]
	  };
	}
	
	/**
	 * Resolve a relative URL pathname against a base URL pathname.
	 *
	 * @param {String} relative Pathname of the relative URL.
	 * @param {String} base Pathname of the base URL.
	 * @return {String} Resolved pathname.
	 * @private
	 */
	function resolve(relative, base) {
	  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
	    , i = path.length
	    , last = path[i - 1]
	    , unshift = false
	    , up = 0;
	
	  while (i--) {
	    if (path[i] === '.') {
	      path.splice(i, 1);
	    } else if (path[i] === '..') {
	      path.splice(i, 1);
	      up++;
	    } else if (up) {
	      if (i === 0) unshift = true;
	      path.splice(i, 1);
	      up--;
	    }
	  }
	
	  if (unshift) path.unshift('');
	  if (last === '.' || last === '..') path.push('');
	
	  return path.join('/');
	}
	
	/**
	 * The actual URL instance. Instead of returning an object we've opted-in to
	 * create an actual constructor as it's much more memory efficient and
	 * faster and it pleases my OCD.
	 *
	 * It is worth noting that we should not use `URL` as class name to prevent
	 * clashes with the global URL instance that got introduced in browsers.
	 *
	 * @constructor
	 * @param {String} address URL we want to parse.
	 * @param {Object|String} [location] Location defaults for relative paths.
	 * @param {Boolean|Function} [parser] Parser for the query string.
	 * @private
	 */
	function Url(address, location, parser) {
	  if (!(this instanceof Url)) {
	    return new Url(address, location, parser);
	  }
	
	  var relative, extracted, parse, instruction, index, key
	    , instructions = rules.slice()
	    , type = typeof location
	    , url = this
	    , i = 0;
	
	  //
	  // The following if statements allows this module two have compatibility with
	  // 2 different API:
	  //
	  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
	  //    where the boolean indicates that the query string should also be parsed.
	  //
	  // 2. The `URL` interface of the browser which accepts a URL, object as
	  //    arguments. The supplied object will be used as default values / fall-back
	  //    for relative paths.
	  //
	  if ('object' !== type && 'string' !== type) {
	    parser = location;
	    location = null;
	  }
	
	  if (parser && 'function' !== typeof parser) parser = qs.parse;
	
	  location = lolcation(location);
	
	  //
	  // Extract protocol information before running the instructions.
	  //
	  extracted = extractProtocol(address || '');
	  relative = !extracted.protocol && !extracted.slashes;
	  url.slashes = extracted.slashes || relative && location.slashes;
	  url.protocol = extracted.protocol || location.protocol || '';
	  address = extracted.rest;
	
	  //
	  // When the authority component is absent the URL starts with a path
	  // component.
	  //
	  if (!extracted.slashes) instructions[3] = [/(.*)/, 'pathname'];
	
	  for (; i < instructions.length; i++) {
	    instruction = instructions[i];
	
	    if (typeof instruction === 'function') {
	      address = instruction(address);
	      continue;
	    }
	
	    parse = instruction[0];
	    key = instruction[1];
	
	    if (parse !== parse) {
	      url[key] = address;
	    } else if ('string' === typeof parse) {
	      if (~(index = address.indexOf(parse))) {
	        if ('number' === typeof instruction[2]) {
	          url[key] = address.slice(0, index);
	          address = address.slice(index + instruction[2]);
	        } else {
	          url[key] = address.slice(index);
	          address = address.slice(0, index);
	        }
	      }
	    } else if ((index = parse.exec(address))) {
	      url[key] = index[1];
	      address = address.slice(0, index.index);
	    }
	
	    url[key] = url[key] || (
	      relative && instruction[3] ? location[key] || '' : ''
	    );
	
	    //
	    // Hostname, host and protocol should be lowercased so they can be used to
	    // create a proper `origin`.
	    //
	    if (instruction[4]) url[key] = url[key].toLowerCase();
	  }
	
	  //
	  // Also parse the supplied query string in to an object. If we're supplied
	  // with a custom parser as function use that instead of the default build-in
	  // parser.
	  //
	  if (parser) url.query = parser(url.query);
	
	  //
	  // If the URL is relative, resolve the pathname against the base URL.
	  //
	  if (
	      relative
	    && location.slashes
	    && url.pathname.charAt(0) !== '/'
	    && (url.pathname !== '' || location.pathname !== '')
	  ) {
	    url.pathname = resolve(url.pathname, location.pathname);
	  }
	
	  //
	  // We should not add port numbers if they are already the default port number
	  // for a given protocol. As the host also contains the port number we're going
	  // override it with the hostname which contains no port number.
	  //
	  if (!required(url.port, url.protocol)) {
	    url.host = url.hostname;
	    url.port = '';
	  }
	
	  //
	  // Parse down the `auth` for the username and password.
	  //
	  url.username = url.password = '';
	  if (url.auth) {
	    instruction = url.auth.split(':');
	    url.username = instruction[0] || '';
	    url.password = instruction[1] || '';
	  }
	
	  url.origin = url.protocol && url.host && url.protocol !== 'file:'
	    ? url.protocol +'//'+ url.host
	    : 'null';
	
	  //
	  // The href is just the compiled result.
	  //
	  url.href = url.toString();
	}
	
	/**
	 * This is convenience method for changing properties in the URL instance to
	 * insure that they all propagate correctly.
	 *
	 * @param {String} part          Property we need to adjust.
	 * @param {Mixed} value          The newly assigned value.
	 * @param {Boolean|Function} fn  When setting the query, it will be the function
	 *                               used to parse the query.
	 *                               When setting the protocol, double slash will be
	 *                               removed from the final url if it is true.
	 * @returns {URL} URL instance for chaining.
	 * @public
	 */
	function set(part, value, fn) {
	  var url = this;
	
	  switch (part) {
	    case 'query':
	      if ('string' === typeof value && value.length) {
	        value = (fn || qs.parse)(value);
	      }
	
	      url[part] = value;
	      break;
	
	    case 'port':
	      url[part] = value;
	
	      if (!required(value, url.protocol)) {
	        url.host = url.hostname;
	        url[part] = '';
	      } else if (value) {
	        url.host = url.hostname +':'+ value;
	      }
	
	      break;
	
	    case 'hostname':
	      url[part] = value;
	
	      if (url.port) value += ':'+ url.port;
	      url.host = value;
	      break;
	
	    case 'host':
	      url[part] = value;
	
	      if (/:\d+$/.test(value)) {
	        value = value.split(':');
	        url.port = value.pop();
	        url.hostname = value.join(':');
	      } else {
	        url.hostname = value;
	        url.port = '';
	      }
	
	      break;
	
	    case 'protocol':
	      url.protocol = value.toLowerCase();
	      url.slashes = !fn;
	      break;
	
	    case 'pathname':
	    case 'hash':
	      if (value) {
	        var char = part === 'pathname' ? '/' : '#';
	        url[part] = value.charAt(0) !== char ? char + value : value;
	      } else {
	        url[part] = value;
	      }
	      break;
	
	    default:
	      url[part] = value;
	  }
	
	  for (var i = 0; i < rules.length; i++) {
	    var ins = rules[i];
	
	    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
	  }
	
	  url.origin = url.protocol && url.host && url.protocol !== 'file:'
	    ? url.protocol +'//'+ url.host
	    : 'null';
	
	  url.href = url.toString();
	
	  return url;
	}
	
	/**
	 * Transform the properties back in to a valid and full URL string.
	 *
	 * @param {Function} stringify Optional query stringify function.
	 * @returns {String} Compiled version of the URL.
	 * @public
	 */
	function toString(stringify) {
	  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;
	
	  var query
	    , url = this
	    , protocol = url.protocol;
	
	  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
	
	  var result = protocol + (url.slashes ? '//' : '');
	
	  if (url.username) {
	    result += url.username;
	    if (url.password) result += ':'+ url.password;
	    result += '@';
	  }
	
	  result += url.host + url.pathname;
	
	  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
	  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;
	
	  if (url.hash) result += url.hash;
	
	  return result;
	}
	
	Url.prototype = { set: set, toString: toString };
	
	//
	// Expose the URL parser and some additional properties that might be useful for
	// others or testing.
	//
	Url.extractProtocol = extractProtocol;
	Url.location = lolcation;
	Url.qs = qs;
	
	module.exports = Url;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.POPUP_MODES = exports.DRAWER_RIGHT = exports.DRAWER = exports.POPUP = exports.DEFAULT_AUTOCLOSE_TIMEOUT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _POPUP_MODES;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _scrollbarWidth = __webpack_require__(85);
	
	var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);
	
	var _styles = __webpack_require__(17);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _iframe = __webpack_require__(26);
	
	var _iframe2 = _interopRequireDefault(_iframe);
	
	var _spinner = __webpack_require__(93);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _utils = __webpack_require__(9);
	
	var _close = __webpack_require__(95);
	
	var _close2 = _interopRequireDefault(_close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ESC_KEY_CODE = 27;
	var CLOSE_BUTTON_WIDTH = 30;
	
	var DEFAULT_AUTOCLOSE_TIMEOUT = exports.DEFAULT_AUTOCLOSE_TIMEOUT = 5;
	var POPUP = exports.POPUP = 'popup';
	var DRAWER = exports.DRAWER = 'drawer_left';
	var DRAWER_RIGHT = exports.DRAWER_RIGHT = 'drawer_right';
	var POPUP_MODES = exports.POPUP_MODES = (_POPUP_MODES = {}, _defineProperty(_POPUP_MODES, POPUP, 'popup-blank'), _defineProperty(_POPUP_MODES, DRAWER, 'popup-classic'), _defineProperty(_POPUP_MODES, DRAWER_RIGHT, 'popup-drawer'), _POPUP_MODES);
	
	var BaseWrapper = /*#__PURE__*/(0, _styles2.default)('div', {
	  target: 'e1o3ysfi0'
	})('visibility:', function (p) {
	  return p.open ? 'visible' : 'hidden';
	}, ';opacity:', function (p) {
	  return p.open ? 1 : 0;
	}, ';position:', function (p) {
	  return p.isContained ? 'absolute' : 'fixed';
	}, ';max-width:100%;z-index:10001;');
	
	var Overlay = /*#__PURE__*/(0, _styles2.default)('div', {
	  target: 'e1o3ysfi1'
	})('visibility:', function (p) {
	  return p.appearing ? 'hidden' : 'visible';
	}, ';opacity:', function (p) {
	  return p.appearing ? 0 : 1;
	}, ';transition:opacity 200ms ease,visibility 0s linear ', function (p) {
	  return p.appearing ? '200ms' : '0s';
	}, ';background:rgba(0,0,0,0.85);position:', function (p) {
	  return p.isContained ? 'absolute' : 'fixed';
	}, ';overflow:', function (p) {
	  return p.isContained ? 'hidden' : 'auto';
	}, ';left:0;top:0;right:0;bottom:0;z-index:10000;min-height:100%;');
	
	var popupWrapper = /*#__PURE__*/(0, _styles2.default)(BaseWrapper, {
	  target: 'e1o3ysfi2'
	})('width:', function (p) {
	  return p.isContained ? 'calc(100% - 80px)' : 'calc(100vw - 80px)';
	}, ';height:', function (p) {
	  return p.isContained ? 'calc(100% - 80px)' : 'calc(100vh - 80px)';
	}, ';top:40px;left:40px;transition:all 300ms ease-out;');
	
	var drawerWrapper = /*#__PURE__*/(0, _styles2.default)(BaseWrapper, {
	  target: 'e1o3ysfi3'
	})('transition:all 400ms ease-out;width:', function (p) {
	  return p.width;
	}, 'px;height:100%;top:0;');
	
	var drawerLeftWrapper = /*#__PURE__*/(0, _styles2.default)(drawerWrapper, {
	  target: 'e1o3ysfi4'
	})('left:', function (p) {
	  return !p.open ? -(p.width - CLOSE_BUTTON_WIDTH) : 0;
	}, 'px;');
	
	var drawerRightWrapper = /*#__PURE__*/(0, _styles2.default)(drawerWrapper, {
	  target: 'e1o3ysfi5'
	})('right:', function (p) {
	  return !p.open ? -(p.width - CLOSE_BUTTON_WIDTH) : 0;
	}, 'px;');
	
	var BaseCloseImage = /*#__PURE__*/(0, _styles2.default)('img', {
	  target: 'e1o3ysfi6'
	})('position:absolute;padding:8px;cursor:pointer;width:initial;max-width:initial;');
	
	var closeImagePopup = /*#__PURE__*/(0, _styles2.default)(BaseCloseImage, {
	  target: 'e1o3ysfi7'
	})('top:-34px;right:-34px;');
	
	var closeImageLeft = /*#__PURE__*/(0, _styles2.default)(BaseCloseImage, {
	  target: 'e1o3ysfi8'
	})('top:12px;right:-38px;');
	
	var closeImageRight = /*#__PURE__*/(0, _styles2.default)(BaseCloseImage, {
	  target: 'e1o3ysfi9'
	})('top:12px;left:-38px;right:auto;');
	
	var Popup = function (_Component) {
	  _inherits(Popup, _Component);
	
	  function Popup(props) {
	    _classCallCheck(this, Popup);
	
	    var _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));
	
	    _this.state = {
	      frameAnimate: false,
	      iframeLoaded: false,
	      popupAnimate: true,
	      transitionEnded: false
	    };
	
	    _this.handleIframeLoad = _this.handleIframeLoad.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.onAutoClose = _this.onAutoClose.bind(_this);
	    _this.animateBeforeClose = _this.animateBeforeClose.bind(_this);
	    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_this);
	    _this.onFormSubmit = _this.onFormSubmit.bind(_this);
	    _this.getWrapperRef = _this.getWrapperRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(Popup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.addEventListener('message', _utils.onMessage);
	      window.addEventListener('keydown', this.onKeyDown);
	      window.addEventListener('form-close', this.animateBeforeClose);
	      window.addEventListener('ESC', this.animateBeforeClose);
	      window.addEventListener('embed-auto-close-popup', this.onAutoClose);
	      window.addEventListener('form-submit', this.onFormSubmit);
	      window.addEventListener('redirect-after-submit', _utils.redirectAfterSubmit);
	
	      setTimeout(function () {
	        _this2.setState({
	          popupAnimate: false
	        });
	      }, 100);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('message', _utils.onMessage);
	      window.removeEventListener('keydown', this.onKeyDown);
	      window.removeEventListener('form-close', this.animateBeforeClose);
	      window.removeEventListener('ESC', this.animateBeforeClose);
	      window.removeEventListener('embed-auto-close-popup', this.onAutoClose);
	      window.removeEventListener('form-submit', this.onFormSubmit);
	      window.removeEventListener('redirect-after-submit', _utils.redirectAfterSubmit);
	    }
	  }, {
	    key: 'getWrapperComponent',
	    value: function getWrapperComponent(mode) {
	      if (mode === DRAWER_RIGHT) return drawerRightWrapper;
	      if (mode === DRAWER) return drawerLeftWrapper;
	      return popupWrapper;
	    }
	  }, {
	    key: 'getCloseImage',
	    value: function getCloseImage(mode) {
	      if (mode === DRAWER_RIGHT) return closeImageRight;
	      if (mode === DRAWER) return closeImageLeft;
	      return closeImagePopup;
	    }
	  }, {
	    key: 'getWrapperRef',
	    value: function getWrapperRef(node) {
	      this.wrapper = node;
	    }
	  }, {
	    key: 'handleIframeLoad',
	    value: function handleIframeLoad(iframeRef) {
	      var _this3 = this;
	
	      this.setState({ iframeLoaded: true }, function () {
	        setTimeout(function () {
	          _this3.setState({ frameAnimate: true });
	          if (iframeRef && iframeRef.contentWindow) {
	            iframeRef.contentWindow.focus();
	          }
	        }, 500);
	      });
	    }
	  }, {
	    key: 'animateBeforeClose',
	    value: function animateBeforeClose() {
	      var _this4 = this;
	
	      this.setState({ frameAnimate: false, popupAnimate: false }, function () {
	        setTimeout(function () {
	          _this4.setState({ popupAnimate: true }, function () {
	            setTimeout(_this4.props.onClose, 400);
	          });
	        }, 400);
	      });
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      var key = document.all ? e.keyCode : e.which;
	      if (key === ESC_KEY_CODE) {
	        this.animateBeforeClose();
	      }
	    }
	  }, {
	    key: 'onAutoClose',
	    value: function onAutoClose(e) {
	      var _this5 = this;
	
	      var _e$detail$canSetAutoc = e.detail.canSetAutocloseDelay,
	          canSetAutocloseDelay = _e$detail$canSetAutoc === undefined ? true : _e$detail$canSetAutoc;
	      var _props$options = this.props.options,
	          isAutoCloseEnabled = _props$options.isAutoCloseEnabled,
	          _props$options$autoCl = _props$options.autoClose,
	          autoClose = _props$options$autoCl === undefined ? DEFAULT_AUTOCLOSE_TIMEOUT : _props$options$autoCl;
	
	
	      var timeout = (canSetAutocloseDelay ? autoClose : DEFAULT_AUTOCLOSE_TIMEOUT) * 1000;
	
	      if (isAutoCloseEnabled) {
	        setTimeout(function () {
	          _this5.animateBeforeClose();
	        }, timeout);
	      }
	    }
	  }, {
	    key: 'handleTransitionEnd',
	    value: function handleTransitionEnd(event) {
	      if (event.target === this.wrapper) {
	        this.setState({
	          transitionEnded: this.state.frameAnimate
	        });
	      }
	    }
	  }, {
	    key: 'onFormSubmit',
	    value: function onFormSubmit() {
	      var onSubmit = this.props.options.onSubmit;
	
	      onSubmit();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var iframeStyles = null;
	      var options = this.props.options;
	      var drawerWidth = options.drawerWidth,
	          hideScrollbars = options.hideScrollbars,
	          isContained = options.isContained,
	          mode = options.mode;
	
	
	      if (hideScrollbars) {
	        iframeStyles = {
	          width: 'calc(100% + ' + (0, _scrollbarWidth2.default)() + 'px)'
	        };
	      }
	
	      if (mode === POPUP) {
	        iframeStyles = _extends({}, iframeStyles, {
	          WebkitMaskImage: '-webkit-radial-gradient(circle, white, black)',
	          WebkitTransform: 'translateZ(0)'
	        });
	      }
	
	      var Wrapper = this.getWrapperComponent(mode);
	      var CloseImage = this.getCloseImage(mode);
	
	      return _react2.default.createElement(
	        Overlay,
	        { appearing: this.state.popupAnimate, isContained: isContained },
	        _react2.default.createElement(_spinner2.default, { stopped: this.state.iframeLoaded }),
	        _react2.default.createElement(
	          Wrapper,
	          {
	            'data-qa': 'popup-mode-' + mode,
	            innerRef: this.getWrapperRef,
	            isContained: isContained,
	            mode: mode,
	            onTransitionEnd: this.handleTransitionEnd,
	            open: this.state.frameAnimate,
	            width: drawerWidth
	          },
	          this.state.iframeLoaded && _react2.default.createElement(CloseImage, {
	            alt: 'close-typeform',
	            'data-qa': 'popup-close-button',
	            mode: mode,
	            onClick: this.animateBeforeClose,
	            src: _close2.default
	          }),
	          _react2.default.createElement(_iframe2.default, {
	            onLoad: this.handleIframeLoad,
	            src: this.props.url,
	            style: iframeStyles
	          })
	        )
	      );
	    }
	  }]);
	
	  return Popup;
	}(_react.Component);
	
	Popup.propTypes = {
	  url: _propTypes2.default.string.isRequired,
	  options: _propTypes2.default.object.isRequired,
	  onClose: _propTypes2.default.func,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	};
	
	exports.default = Popup;
	
	/***/ }),
	/* 45 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	/* harmony default export */ __webpack_exports__["a"] = (memoize);
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(17);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _closeIcon = __webpack_require__(96);
	
	var _closeIcon2 = _interopRequireDefault(_closeIcon);
	
	var _iframe = __webpack_require__(26);
	
	var _iframe2 = _interopRequireDefault(_iframe);
	
	var _dataService = __webpack_require__(47);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _store = __webpack_require__(48);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _utils = __webpack_require__(9);
	
	var _popup = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DOMAIN = 'admin.typeform.com';
	var TYPE = 'popup';
	
	var Wrapper = /*#__PURE__*/(0, _styles2.default)('div', {
	  target: 'e4550h40'
	})('visibility:', function (p) {
	  return p.open ? 'visible' : 'hidden';
	}, ';opacity:', function (p) {
	  return p.open ? 1 : 0;
	}, ';background-color:', function (p) {
	  return p.backgroundColor;
	}, ';position:fixed !important;z-index:1000;left:0 !important;right:0 !important;top:0 !important;bottom:0 !important;overflow:hidden !important;height:100%;transition:all 400ms ease ', function (props) {
	  return props.openDelay;
	}, 's;');
	
	(0, _styles.injectGlobal)('.__typeform-embed-mobile-modal-open{overflow:hidden !important;position:fixed !important;top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;}');
	
	var MobileModal = function (_Component) {
	  _inherits(MobileModal, _Component);
	
	  function MobileModal(props) {
	    _classCallCheck(this, MobileModal);
	
	    var _this = _possibleConstructorReturn(this, (MobileModal.__proto__ || Object.getPrototypeOf(MobileModal)).call(this, props));
	
	    _this.state = {
	      backgroundColor: 'transparent',
	      buttonColor: '#FFF'
	    };
	
	    _this.onAutoClose = _this.onAutoClose.bind(_this);
	    _this.onFormSubmit = _this.onFormSubmit.bind(_this);
	    _this.close = _this.close.bind(_this);
	    return _this;
	  }
	
	  _createClass(MobileModal, [{
	    key: 'onAutoClose',
	    value: function onAutoClose(e) {
	      var _this2 = this;
	
	      var _e$detail$canSetAutoc = e.detail.canSetAutocloseDelay,
	          canSetAutocloseDelay = _e$detail$canSetAutoc === undefined ? true : _e$detail$canSetAutoc;
	      var _props = this.props,
	          isAutoCloseEnabled = _props.isAutoCloseEnabled,
	          autoClose = _props.autoClose;
	
	      var timeout = (canSetAutocloseDelay ? autoClose : _popup.DEFAULT_AUTOCLOSE_TIMEOUT) * 1000;
	
	      if (isAutoCloseEnabled) {
	        setTimeout(function () {
	          _this2.close();
	        }, timeout);
	      }
	    }
	  }, {
	    key: 'onFormSubmit',
	    value: function onFormSubmit() {
	      var onSubmit = this.props.onSubmit;
	
	      onSubmit && onSubmit();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      var uid = _dataService2.default.getUidFromURL(this.props.url);
	
	      _dataService2.default.getFormData(uid, DOMAIN).then(function (data) {
	        return (0, _store2.default)(uid, TYPE, _this3.props.url, _this3.props.buttonText, data);
	      }).then(function (_ref) {
	        var form = _ref.form;
	
	        _this3.setState({
	          backgroundColor: '#' + form['background-color'],
	          buttonColor: '#' + form['button-color']
	        });
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('message', _utils.onMessage);
	      window.addEventListener('embed-auto-close-popup', this.onAutoClose);
	      window.addEventListener('form-submit', this.onFormSubmit);
	
	      if (this.props.open) {
	        this.open();
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var _this4 = this;
	
	      setTimeout(function () {
	        _this4.originalBodyScrollTop = window.document.body.scrollTop;
	        document.body.classList.add('__typeform-embed-mobile-modal-open');
	      }, this.props.openDelay * 1000 + 500);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!prevProps.open && this.props.open) {
	        this.open();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('message', _utils.onMessage);
	      window.removeEventListener('embed-auto-close-popup', this.onAutoClose);
	      window.removeEventListener('form-submit', this.onFormSubmit);
	
	      document.body.classList.remove('__typeform-embed-mobile-modal-open');
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      var _this5 = this;
	
	      document.body.classList.remove('__typeform-embed-mobile-modal-open');
	      setTimeout(function () {
	        window.document.body.scrollTop = _this5.originalBodyScrollTop;
	      }, 40);
	
	      if (this.props.onClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          url = _props2.url,
	          open = _props2.open;
	      var _state = this.state,
	          backgroundColor = _state.backgroundColor,
	          buttonColor = _state.buttonColor;
	
	
	      return _react2.default.createElement(
	        Wrapper,
	        {
	          backgroundColor: backgroundColor,
	          'data-qa': 'mobile-modal',
	          open: open,
	          openDelay: this.props.openDelay
	        },
	        open && _react2.default.createElement(_iframe2.default, { src: url }),
	        _react2.default.createElement(_closeIcon2.default, {
	          color: buttonColor,
	          dataQa: 'close-button-mobile',
	          onClick: this.close
	        })
	      );
	    }
	  }]);
	
	  return MobileModal;
	}(_react.Component);
	
	MobileModal.propTypes = {
	  url: _propTypes2.default.string,
	  open: _propTypes2.default.bool,
	  isAutoCloseEnabled: _propTypes2.default.bool,
	  buttonText: _propTypes2.default.string,
	  onClose: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  autoClose: _propTypes2.default.number,
	  openDelay: _propTypes2.default.number
	};
	
	MobileModal.defaultProps = {
	  open: false,
	  openDelay: 0,
	  autoClose: null
	};
	
	exports.default = MobileModal;
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fetchJsonp = __webpack_require__(97);
	
	var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);
	
	var _urlParse = __webpack_require__(43);
	
	var _urlParse2 = _interopRequireDefault(_urlParse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataService = {
	  generateURL: function generateURL(uid, domain) {
	    return 'https://' + domain + '/app/embed/' + uid + '?jsoncallback=?';
	  },
	  getFormData: function getFormData(uid, domain) {
	    var url = this.generateURL(uid, domain);
	    return (0, _fetchJsonp2.default)(url, { jsonpCallback: 'jsoncallback' }).then(function (res) {
	      return res.json();
	    });
	  },
	  getAccountFromURL: function getAccountFromURL(url) {
	    return url.split('/')[2].split('.')[0];
	  },
	  getUidFromURL: function getUidFromURL(url) {
	    var _UrlParse = (0, _urlParse2.default)(url, true),
	        pathname = _UrlParse.pathname,
	        query = _UrlParse.query;
	
	    var path = pathname.replace(/\/$/, ''); // remove trailing slash
	    var uid = path.replace(/\/to\/(.+)$/, '$1');
	
	    if (uid === '/renderer') {
	      return query.uid;
	    }
	
	    return uid;
	  },
	  getDomainFromUrl: function getDomainFromUrl(url) {
	    return url.split('/')[2];
	  },
	  getDOMElementData: function getDOMElementData($element) {
	    return {
	      url: $element.data('url'),
	      text: $element.data('text')
	    };
	  }
	};
	
	exports.default = DataService;
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobileDetection = __webpack_require__(16);
	
	var defaultData = {
	  'account-name': 'admin',
	  name: 'Typeform',
	  'welcome-image': '',
	  'font-google': '',
	  'primary-color': '#222',
	  'background-image': '',
	  'background-color': '#DDD',
	  'background-repeat': '',
	  'background-brightness': '',
	  'button-color': '#AAA'
	};
	
	var store = function store(uid, type, url, buttonText) {
	  var data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : defaultData;
	
	  return {
	    isMobile: (0, _mobileDetection.isMobile)(navigator.userAgent),
	    'account-name': data['account-name'] || 'admin',
	    type: type,
	    form: {
	      uid: uid,
	      url: url,
	      ready: false, // not implemented
	      buttonText: buttonText,
	      name: data['name'] || '',
	      'welcome-image': data['welcome-image'],
	      'font-google': data['font-google'],
	      'primary-color': data['primary-color'],
	      'background-image': data['background-image'],
	      'background-color': data['background-color'],
	      'background-repeat': data['background-repeat'],
	      'background-brightness': data['background-brightness'],
	      'button-color': data['button-color']
	    }
	  };
	};
	
	exports.default = store;
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var internalObjectKeys = __webpack_require__(50);
	var enumBugKeys = __webpack_require__(32);
	
	module.exports = Object.keys || function keys(O) {
	  return internalObjectKeys(O, enumBugKeys);
	};
	
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var has = __webpack_require__(7);
	var toIndexedObject = __webpack_require__(18);
	var arrayIndexOf = __webpack_require__(103)(false);
	var hiddenKeys = __webpack_require__(31);
	
	module.exports = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};
	
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports) {
	
	exports.f = Object.getOwnPropertySymbols;
	
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
	var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = nativeGetOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);
	
	exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = nativeGetOwnPropertyDescriptor(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : nativePropertyIsEnumerable;
	
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(5);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(13) && !__webpack_require__(10)(function () {
	  return Object.defineProperty(__webpack_require__(36)('div'), 'a', {
	    get: function () { return 7; }
	  }).a != 7;
	});
	
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(20)('native-function-to-string', Function.toString);
	
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports) {
	
	var id = 0;
	var postfix = Math.random();
	
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + postfix).toString(36));
	};
	
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var fails = __webpack_require__(10);
	var replacement = /#|\.prototype\./;
	
	var isForced = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value == POLYFILL ? true
	    : value == NATIVE ? false
	    : typeof detection == 'function' ? fails(detection)
	    : !!detection;
	};
	
	var normalize = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};
	
	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';
	
	module.exports = isForced;
	
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var UNSCOPABLES = __webpack_require__(1)('unscopables');
	var create = __webpack_require__(59);
	var hide = __webpack_require__(8);
	var ArrayPrototype = Array.prototype;
	
	// Array.prototype[@@unscopables]
	// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
	if (ArrayPrototype[UNSCOPABLES] == undefined) {
	  hide(ArrayPrototype, UNSCOPABLES, create(null));
	}
	
	// add a key to Array.prototype[@@unscopables]
	module.exports = function (key) {
	  ArrayPrototype[UNSCOPABLES][key] = true;
	};
	
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(6);
	var defineProperties = __webpack_require__(114);
	var enumBugKeys = __webpack_require__(32);
	var html = __webpack_require__(60);
	var documentCreateElement = __webpack_require__(36);
	var IE_PROTO = __webpack_require__(38)('IE_PROTO');
	var PROTOTYPE = 'prototype';
	var Empty = function () { /* empty */ };
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var length = enumBugKeys.length;
	  var lt = '<';
	  var script = 'script';
	  var gt = '>';
	  var js = 'java' + script + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  iframe.src = String(js);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : defineProperties(result, Properties);
	};
	
	__webpack_require__(31)[IE_PROTO] = true;
	
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var document = __webpack_require__(0).document;
	
	module.exports = document && document.documentElement;
	
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var classofRaw = __webpack_require__(11);
	var TO_STRING_TAG = __webpack_require__(1)('toStringTag');
	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) { /* empty */ }
	};
	
	// getting tag from ES6+ `Object.prototype.toString`
	module.exports = function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
	    // builtinTag case
	    : CORRECT_ARGUMENTS ? classofRaw(O)
	    // ES3 arguments fallback
	    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
	};
	
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var $export = __webpack_require__(12);
	var createIteratorConstructor = __webpack_require__(122);
	var getPrototypeOf = __webpack_require__(64);
	var setPrototypeOf = __webpack_require__(124);
	var setToStringTag = __webpack_require__(40);
	var hide = __webpack_require__(8);
	var redefine = __webpack_require__(19);
	var IS_PURE = __webpack_require__(21);
	var ITERATOR = __webpack_require__(1)('iterator');
	var Iterators = __webpack_require__(15);
	var IteratorsCore = __webpack_require__(63);
	var IteratorPrototype = IteratorsCore.IteratorPrototype;
	var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
	var KEYS = 'keys';
	var VALUES = 'values';
	var ENTRIES = 'entries';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
	  createIteratorConstructor(IteratorConstructor, NAME, next);
	
	  var getIterationMethod = function (KIND) {
	    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
	    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
	    switch (KIND) {
	      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
	      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
	      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
	    } return function () { return new IteratorConstructor(this); };
	  };
	
	  var TO_STRING_TAG = NAME + ' Iterator';
	  var INCORRECT_VALUES_NAME = false;
	  var IterablePrototype = Iterable.prototype;
	  var nativeIterator = IterablePrototype[ITERATOR]
	    || IterablePrototype['@@iterator']
	    || DEFAULT && IterablePrototype[DEFAULT];
	  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
	  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
	  var CurrentIteratorPrototype, methods, KEY;
	
	  // fix native
	  if (anyNativeIterator) {
	    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
	    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
	      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
	        if (setPrototypeOf) {
	          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
	        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
	          hide(CurrentIteratorPrototype, ITERATOR, returnThis);
	        }
	      }
	      // Set @@toStringTag to native iterators
	      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
	      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
	    }
	  }
	
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
	    INCORRECT_VALUES_NAME = true;
	    defaultIterator = function values() { return nativeIterator.call(this); };
	  }
	
	  // define iterator
	  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
	    hide(IterablePrototype, ITERATOR, defaultIterator);
	  }
	  Iterators[NAME] = defaultIterator;
	
	  // export additional methods
	  if (DEFAULT) {
	    methods = {
	      values: getIterationMethod(VALUES),
	      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
	      entries: getIterationMethod(ENTRIES)
	    };
	    if (FORCED) for (KEY in methods) {
	      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
	        redefine(IterablePrototype, KEY, methods[KEY]);
	      }
	    } else $export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
	  }
	
	  return methods;
	};
	
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var getPrototypeOf = __webpack_require__(64);
	var hide = __webpack_require__(8);
	var has = __webpack_require__(7);
	var IS_PURE = __webpack_require__(21);
	var ITERATOR = __webpack_require__(1)('iterator');
	var BUGGY_SAFARI_ITERATORS = false;
	
	var returnThis = function () { return this; };
	
	// `%IteratorPrototype%` object
	// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
	var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
	
	if ([].keys) {
	  arrayIterator = [].keys();
	  // Safari 8 has buggy iterators w/o `next`
	  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
	  else {
	    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
	    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
	  }
	}
	
	if (IteratorPrototype == undefined) IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	
	module.exports = {
	  IteratorPrototype: IteratorPrototype,
	  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
	};
	
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(7);
	var toObject = __webpack_require__(33);
	var IE_PROTO = __webpack_require__(38)('IE_PROTO');
	var CORRECT_PROTOTYPE_GETTER = __webpack_require__(123);
	var ObjectPrototype = Object.prototype;
	
	module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectPrototype : null;
	};
	
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var anObject = __webpack_require__(6);
	var aFunction = __webpack_require__(23);
	var SPECIES = __webpack_require__(1)('species');
	
	// `SpeciesConstructor` abstract operation
	// https://tc39.github.io/ecma262/#sec-speciesconstructor
	module.exports = function (O, defaultConstructor) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
	};
	
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(0);
	var classof = __webpack_require__(11);
	var bind = __webpack_require__(39);
	var html = __webpack_require__(60);
	var createElement = __webpack_require__(36);
	var set = global.setImmediate;
	var clear = global.clearImmediate;
	var process = global.process;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	
	var listener = function (event) {
	  run.call(event.data);
	};
	
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!set || !clear) {
	  set = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clear = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (classof(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(bind(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(bind(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = bind(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in createElement('script')) {
	    defer = function (id) {
	      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(bind(run, id, 1), 0);
	    };
	  }
	}
	
	module.exports = {
	  set: set,
	  clear: clear
	};
	
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(0);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';
	
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(5);
	var newPromiseCapability = __webpack_require__(69);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};
	
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(23);
	
	var PromiseCapability = function (C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	};
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};
	
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var path = __webpack_require__(41);
	var global = __webpack_require__(0);
	
	var aFunction = function (variable) {
	  return typeof variable == 'function' ? variable : undefined;
	};
	
	module.exports = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
	    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
	};
	
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeFullScreen = exports.makeWidget = exports.makePopup = undefined;
	
	var _makePopup = __webpack_require__(72);
	
	var _makePopup2 = _interopRequireDefault(_makePopup);
	
	var _makeWidget = __webpack_require__(98);
	
	var _makeWidget2 = _interopRequireDefault(_makeWidget);
	
	var _makeFullScreen = __webpack_require__(100);
	
	var _makeFullScreen2 = _interopRequireDefault(_makeFullScreen);
	
	__webpack_require__(101);
	
	__webpack_require__(109);
	
	__webpack_require__(115);
	
	__webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.makePopup = _makePopup2.default;
	exports.makeWidget = _makeWidget2.default;
	exports.makeFullScreen = _makeFullScreen2.default;
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makePopup;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(2);
	
	var _utils = __webpack_require__(9);
	
	var _mobileDetection = __webpack_require__(16);
	
	var _popup = __webpack_require__(44);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _mobileModal = __webpack_require__(46);
	
	var _mobileModal2 = _interopRequireDefault(_mobileModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_DRAWER_WIDTH = 800;
	
	var defaultOptions = {
	  mode: _popup.POPUP,
	  autoOpen: false,
	  isModalOpen: false,
	  autoClose: _popup.DEFAULT_AUTOCLOSE_TIMEOUT,
	  hideFooter: false,
	  hideHeaders: false,
	  hideScrollbars: false,
	  disableTracking: false,
	  drawerWidth: DEFAULT_DRAWER_WIDTH,
	  onSubmit: _utils.noop
	};
	
	var queryStringKeys = {
	  embedType: 'typeform-embed',
	  hideFooter: 'embed-hide-footer',
	  hideHeaders: 'embed-hide-headers',
	  disableTracking: 'disable-tracking'
	};
	
	var renderComponent = function renderComponent(url, domNode, options, onClose) {
	  var urlWithQueryString = (0, _utils.appendParamsToUrl)(url, (0, _utils.replaceExistingKeys)(options, queryStringKeys));
	  if (!(0, _mobileDetection.isMobile)(navigator.userAgent) && (0, _mobileDetection.isScreenBig)()) {
	    (0, _reactDom.render)(_react2.default.createElement(_popup2.default, { onClose: onClose, options: options, url: urlWithQueryString }), domNode);
	  } else {
	    (0, _utils.ensureMetaViewport)();
	    (0, _reactDom.render)(_react2.default.createElement(_mobileModal2.default, {
	      autoClose: options.autoClose,
	      buttonText: options.buttonText,
	      isAutoCloseEnabled: options.isAutoCloseEnabled,
	      onClose: onClose,
	      onSubmit: options.onSubmit,
	      open: true,
	      url: urlWithQueryString
	    }), domNode);
	  }
	};
	
	function makePopup(url, options) {
	  options = _extends({}, defaultOptions, options, {
	    isAutoCloseEnabled: options.autoClose !== undefined,
	    embedType: _popup.POPUP_MODES[options.mode]
	  });
	
	  if (!Number.isSafeInteger(options.drawerWidth)) {
	    throw new Error('Whoops! You provided an invalid \'drawerWidth\' option: "' + options.drawerWidth + '". It must be a number.');
	  }
	
	  var domNode = document.createElement('div');
	  options.isContained = options.container !== undefined;
	  options.container = options.container || document.body;
	  options.container.appendChild(domNode);
	
	  var popup = {
	    open: function open() {
	      renderComponent(url, domNode, options, this.close);
	    },
	    close: function close() {
	      window.postMessage('form-close', '*');
	      (0, _reactDom.unmountComponentAtNode)(domNode);
	    }
	  };
	
	  if (options.autoOpen) {
	    popup.open();
	  }
	
	  return popup;
	}
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/** @license React v16.8.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};
	
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/** @license React v16.8.1
	 * react-is.development.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	
	
	if (process.env.NODE_ENV !== "production") {
	  (function() {
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	
	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' ||
	  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
	}
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	{
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	var lowPriorityWarning$1 = lowPriorityWarning;
	
	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;
	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;
	
	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;
	          default:
	            var $$typeofType = type && type.$$typeof;
	
	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;
	              default:
	                return $$typeof;
	            }
	        }
	      case REACT_LAZY_TYPE:
	      case REACT_MEMO_TYPE:
	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }
	
	  return undefined;
	}
	
	// AsyncMode is deprecated along with isAsyncMode
	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	
	// AsyncMode should be deprecated
	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true;
	      lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }
	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}
	
	exports.typeOf = typeOf;
	exports.AsyncMode = AsyncMode;
	exports.ConcurrentMode = ConcurrentMode;
	exports.ContextConsumer = ContextConsumer;
	exports.ContextProvider = ContextProvider;
	exports.Element = Element;
	exports.ForwardRef = ForwardRef;
	exports.Fragment = Fragment;
	exports.Lazy = Lazy;
	exports.Memo = Memo;
	exports.Portal = Portal;
	exports.Profiler = Profiler;
	exports.StrictMode = StrictMode;
	exports.Suspense = Suspense;
	exports.isValidElementType = isValidElementType;
	exports.isAsyncMode = isAsyncMode;
	exports.isConcurrentMode = isConcurrentMode;
	exports.isContextConsumer = isContextConsumer;
	exports.isContextProvider = isContextProvider;
	exports.isElement = isElement;
	exports.isForwardRef = isForwardRef;
	exports.isFragment = isFragment;
	exports.isLazy = isLazy;
	exports.isMemo = isMemo;
	exports.isPortal = isPortal;
	exports.isProfiler = isProfiler;
	exports.isStrictMode = isStrictMode;
	exports.isSuspense = isSuspense;
	  })();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var ReactIs = __webpack_require__(42);
	var assign = __webpack_require__(76);
	
	var ReactPropTypesSecret = __webpack_require__(24);
	var checkPropTypes = __webpack_require__(77);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        if (getPropType(value) === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var printWarning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = __webpack_require__(24);
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var ReactPropTypesSecret = __webpack_require__(24);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	
	/***/ }),
	/* 79 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return h; });
	/* unused harmony export createElement */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cloneElement; });
	/* unused harmony export createRef */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return render; });
	/* unused harmony export rerender */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return options; });
	var VNode = function VNode() {};
	
	var options = {};
	
	var stack = [];
	
	var EMPTY_CHILDREN = [];
	
	function h(nodeName, attributes) {
		var children = EMPTY_CHILDREN,
		    lastSimple,
		    child,
		    simple,
		    i;
		for (i = arguments.length; i-- > 2;) {
			stack.push(arguments[i]);
		}
		if (attributes && attributes.children != null) {
			if (!stack.length) stack.push(attributes.children);
			delete attributes.children;
		}
		while (stack.length) {
			if ((child = stack.pop()) && child.pop !== undefined) {
				for (i = child.length; i--;) {
					stack.push(child[i]);
				}
			} else {
				if (typeof child === 'boolean') child = null;
	
				if (simple = typeof nodeName !== 'function') {
					if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
				}
	
				if (simple && lastSimple) {
					children[children.length - 1] += child;
				} else if (children === EMPTY_CHILDREN) {
					children = [child];
				} else {
					children.push(child);
				}
	
				lastSimple = simple;
			}
		}
	
		var p = new VNode();
		p.nodeName = nodeName;
		p.children = children;
		p.attributes = attributes == null ? undefined : attributes;
		p.key = attributes == null ? undefined : attributes.key;
	
		if (options.vnode !== undefined) options.vnode(p);
	
		return p;
	}
	
	function extend(obj, props) {
	  for (var i in props) {
	    obj[i] = props[i];
	  }return obj;
	}
	
	function applyRef(ref, value) {
	  if (ref != null) {
	    if (typeof ref == 'function') ref(value);else ref.current = value;
	  }
	}
	
	var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;
	
	function cloneElement(vnode, props) {
	  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
	}
	
	var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;
	
	var items = [];
	
	function enqueueRender(component) {
		if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
			(options.debounceRendering || defer)(rerender);
		}
	}
	
	function rerender() {
		var p;
		while (p = items.pop()) {
			if (p._dirty) renderComponent(p);
		}
	}
	
	function isSameNodeType(node, vnode, hydrating) {
		if (typeof vnode === 'string' || typeof vnode === 'number') {
			return node.splitText !== undefined;
		}
		if (typeof vnode.nodeName === 'string') {
			return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
		}
		return hydrating || node._componentConstructor === vnode.nodeName;
	}
	
	function isNamedNode(node, nodeName) {
		return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
	}
	
	function getNodeProps(vnode) {
		var props = extend({}, vnode.attributes);
		props.children = vnode.children;
	
		var defaultProps = vnode.nodeName.defaultProps;
		if (defaultProps !== undefined) {
			for (var i in defaultProps) {
				if (props[i] === undefined) {
					props[i] = defaultProps[i];
				}
			}
		}
	
		return props;
	}
	
	function createNode(nodeName, isSvg) {
		var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
		node.normalizedNodeName = nodeName;
		return node;
	}
	
	function removeNode(node) {
		var parentNode = node.parentNode;
		if (parentNode) parentNode.removeChild(node);
	}
	
	function setAccessor(node, name, old, value, isSvg) {
		if (name === 'className') name = 'class';
	
		if (name === 'key') {} else if (name === 'ref') {
			applyRef(old, null);
			applyRef(value, node);
		} else if (name === 'class' && !isSvg) {
			node.className = value || '';
		} else if (name === 'style') {
			if (!value || typeof value === 'string' || typeof old === 'string') {
				node.style.cssText = value || '';
			}
			if (value && typeof value === 'object') {
				if (typeof old !== 'string') {
					for (var i in old) {
						if (!(i in value)) node.style[i] = '';
					}
				}
				for (var i in value) {
					node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
				}
			}
		} else if (name === 'dangerouslySetInnerHTML') {
			if (value) node.innerHTML = value.__html || '';
		} else if (name[0] == 'o' && name[1] == 'n') {
			var useCapture = name !== (name = name.replace(/Capture$/, ''));
			name = name.toLowerCase().substring(2);
			if (value) {
				if (!old) node.addEventListener(name, eventProxy, useCapture);
			} else {
				node.removeEventListener(name, eventProxy, useCapture);
			}
			(node._listeners || (node._listeners = {}))[name] = value;
		} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
			try {
				node[name] = value == null ? '' : value;
			} catch (e) {}
			if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
		} else {
			var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));
	
			if (value == null || value === false) {
				if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
			} else if (typeof value !== 'function') {
				if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
			}
		}
	}
	
	function eventProxy(e) {
		return this._listeners[e.type](options.event && options.event(e) || e);
	}
	
	var mounts = [];
	
	var diffLevel = 0;
	
	var isSvgMode = false;
	
	var hydrating = false;
	
	function flushMounts() {
		var c;
		while (c = mounts.shift()) {
			if (options.afterMount) options.afterMount(c);
			if (c.componentDidMount) c.componentDidMount();
		}
	}
	
	function diff(dom, vnode, context, mountAll, parent, componentRoot) {
		if (!diffLevel++) {
			isSvgMode = parent != null && parent.ownerSVGElement !== undefined;
	
			hydrating = dom != null && !('__preactattr_' in dom);
		}
	
		var ret = idiff(dom, vnode, context, mountAll, componentRoot);
	
		if (parent && ret.parentNode !== parent) parent.appendChild(ret);
	
		if (! --diffLevel) {
			hydrating = false;
	
			if (!componentRoot) flushMounts();
		}
	
		return ret;
	}
	
	function idiff(dom, vnode, context, mountAll, componentRoot) {
		var out = dom,
		    prevSvgMode = isSvgMode;
	
		if (vnode == null || typeof vnode === 'boolean') vnode = '';
	
		if (typeof vnode === 'string' || typeof vnode === 'number') {
			if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
				if (dom.nodeValue != vnode) {
					dom.nodeValue = vnode;
				}
			} else {
				out = document.createTextNode(vnode);
				if (dom) {
					if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
					recollectNodeTree(dom, true);
				}
			}
	
			out['__preactattr_'] = true;
	
			return out;
		}
	
		var vnodeName = vnode.nodeName;
		if (typeof vnodeName === 'function') {
			return buildComponentFromVNode(dom, vnode, context, mountAll);
		}
	
		isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;
	
		vnodeName = String(vnodeName);
		if (!dom || !isNamedNode(dom, vnodeName)) {
			out = createNode(vnodeName, isSvgMode);
	
			if (dom) {
				while (dom.firstChild) {
					out.appendChild(dom.firstChild);
				}
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
	
				recollectNodeTree(dom, true);
			}
		}
	
		var fc = out.firstChild,
		    props = out['__preactattr_'],
		    vchildren = vnode.children;
	
		if (props == null) {
			props = out['__preactattr_'] = {};
			for (var a = out.attributes, i = a.length; i--;) {
				props[a[i].name] = a[i].value;
			}
		}
	
		if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
			if (fc.nodeValue != vchildren[0]) {
				fc.nodeValue = vchildren[0];
			}
		} else if (vchildren && vchildren.length || fc != null) {
				innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
			}
	
		diffAttributes(out, vnode.attributes, props);
	
		isSvgMode = prevSvgMode;
	
		return out;
	}
	
	function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
		var originalChildren = dom.childNodes,
		    children = [],
		    keyed = {},
		    keyedLen = 0,
		    min = 0,
		    len = originalChildren.length,
		    childrenLen = 0,
		    vlen = vchildren ? vchildren.length : 0,
		    j,
		    c,
		    f,
		    vchild,
		    child;
	
		if (len !== 0) {
			for (var i = 0; i < len; i++) {
				var _child = originalChildren[i],
				    props = _child['__preactattr_'],
				    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
				if (key != null) {
					keyedLen++;
					keyed[key] = _child;
				} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
					children[childrenLen++] = _child;
				}
			}
		}
	
		if (vlen !== 0) {
			for (var i = 0; i < vlen; i++) {
				vchild = vchildren[i];
				child = null;
	
				var key = vchild.key;
				if (key != null) {
					if (keyedLen && keyed[key] !== undefined) {
						child = keyed[key];
						keyed[key] = undefined;
						keyedLen--;
					}
				} else if (min < childrenLen) {
						for (j = min; j < childrenLen; j++) {
							if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
								child = c;
								children[j] = undefined;
								if (j === childrenLen - 1) childrenLen--;
								if (j === min) min++;
								break;
							}
						}
					}
	
				child = idiff(child, vchild, context, mountAll);
	
				f = originalChildren[i];
				if (child && child !== dom && child !== f) {
					if (f == null) {
						dom.appendChild(child);
					} else if (child === f.nextSibling) {
						removeNode(f);
					} else {
						dom.insertBefore(child, f);
					}
				}
			}
		}
	
		if (keyedLen) {
			for (var i in keyed) {
				if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
			}
		}
	
		while (min <= childrenLen) {
			if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
		}
	}
	
	function recollectNodeTree(node, unmountOnly) {
		var component = node._component;
		if (component) {
			unmountComponent(component);
		} else {
			if (node['__preactattr_'] != null) applyRef(node['__preactattr_'].ref, null);
	
			if (unmountOnly === false || node['__preactattr_'] == null) {
				removeNode(node);
			}
	
			removeChildren(node);
		}
	}
	
	function removeChildren(node) {
		node = node.lastChild;
		while (node) {
			var next = node.previousSibling;
			recollectNodeTree(node, true);
			node = next;
		}
	}
	
	function diffAttributes(dom, attrs, old) {
		var name;
	
		for (name in old) {
			if (!(attrs && attrs[name] != null) && old[name] != null) {
				setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
			}
		}
	
		for (name in attrs) {
			if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
				setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
			}
		}
	}
	
	var recyclerComponents = [];
	
	function createComponent(Ctor, props, context) {
		var inst,
		    i = recyclerComponents.length;
	
		if (Ctor.prototype && Ctor.prototype.render) {
			inst = new Ctor(props, context);
			Component.call(inst, props, context);
		} else {
			inst = new Component(props, context);
			inst.constructor = Ctor;
			inst.render = doRender;
		}
	
		while (i--) {
			if (recyclerComponents[i].constructor === Ctor) {
				inst.nextBase = recyclerComponents[i].nextBase;
				recyclerComponents.splice(i, 1);
				return inst;
			}
		}
	
		return inst;
	}
	
	function doRender(props, state, context) {
		return this.constructor(props, context);
	}
	
	function setComponentProps(component, props, renderMode, context, mountAll) {
		if (component._disable) return;
		component._disable = true;
	
		component.__ref = props.ref;
		component.__key = props.key;
		delete props.ref;
		delete props.key;
	
		if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
			if (!component.base || mountAll) {
				if (component.componentWillMount) component.componentWillMount();
			} else if (component.componentWillReceiveProps) {
				component.componentWillReceiveProps(props, context);
			}
		}
	
		if (context && context !== component.context) {
			if (!component.prevContext) component.prevContext = component.context;
			component.context = context;
		}
	
		if (!component.prevProps) component.prevProps = component.props;
		component.props = props;
	
		component._disable = false;
	
		if (renderMode !== 0) {
			if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
				renderComponent(component, 1, mountAll);
			} else {
				enqueueRender(component);
			}
		}
	
		applyRef(component.__ref, component);
	}
	
	function renderComponent(component, renderMode, mountAll, isChild) {
		if (component._disable) return;
	
		var props = component.props,
		    state = component.state,
		    context = component.context,
		    previousProps = component.prevProps || props,
		    previousState = component.prevState || state,
		    previousContext = component.prevContext || context,
		    isUpdate = component.base,
		    nextBase = component.nextBase,
		    initialBase = isUpdate || nextBase,
		    initialChildComponent = component._component,
		    skip = false,
		    snapshot = previousContext,
		    rendered,
		    inst,
		    cbase;
	
		if (component.constructor.getDerivedStateFromProps) {
			state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
			component.state = state;
		}
	
		if (isUpdate) {
			component.props = previousProps;
			component.state = previousState;
			component.context = previousContext;
			if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
				skip = true;
			} else if (component.componentWillUpdate) {
				component.componentWillUpdate(props, state, context);
			}
			component.props = props;
			component.state = state;
			component.context = context;
		}
	
		component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
		component._dirty = false;
	
		if (!skip) {
			rendered = component.render(props, state, context);
	
			if (component.getChildContext) {
				context = extend(extend({}, context), component.getChildContext());
			}
	
			if (isUpdate && component.getSnapshotBeforeUpdate) {
				snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
			}
	
			var childComponent = rendered && rendered.nodeName,
			    toUnmount,
			    base;
	
			if (typeof childComponent === 'function') {
	
				var childProps = getNodeProps(rendered);
				inst = initialChildComponent;
	
				if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
					setComponentProps(inst, childProps, 1, context, false);
				} else {
					toUnmount = inst;
	
					component._component = inst = createComponent(childComponent, childProps, context);
					inst.nextBase = inst.nextBase || nextBase;
					inst._parentComponent = component;
					setComponentProps(inst, childProps, 0, context, false);
					renderComponent(inst, 1, mountAll, true);
				}
	
				base = inst.base;
			} else {
				cbase = initialBase;
	
				toUnmount = initialChildComponent;
				if (toUnmount) {
					cbase = component._component = null;
				}
	
				if (initialBase || renderMode === 1) {
					if (cbase) cbase._component = null;
					base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
				}
			}
	
			if (initialBase && base !== initialBase && inst !== initialChildComponent) {
				var baseParent = initialBase.parentNode;
				if (baseParent && base !== baseParent) {
					baseParent.replaceChild(base, initialBase);
	
					if (!toUnmount) {
						initialBase._component = null;
						recollectNodeTree(initialBase, false);
					}
				}
			}
	
			if (toUnmount) {
				unmountComponent(toUnmount);
			}
	
			component.base = base;
			if (base && !isChild) {
				var componentRef = component,
				    t = component;
				while (t = t._parentComponent) {
					(componentRef = t).base = base;
				}
				base._component = componentRef;
				base._componentConstructor = componentRef.constructor;
			}
		}
	
		if (!isUpdate || mountAll) {
			mounts.push(component);
		} else if (!skip) {
	
			if (component.componentDidUpdate) {
				component.componentDidUpdate(previousProps, previousState, snapshot);
			}
			if (options.afterUpdate) options.afterUpdate(component);
		}
	
		while (component._renderCallbacks.length) {
			component._renderCallbacks.pop().call(component);
		}if (!diffLevel && !isChild) flushMounts();
	}
	
	function buildComponentFromVNode(dom, vnode, context, mountAll) {
		var c = dom && dom._component,
		    originalComponent = c,
		    oldDom = dom,
		    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
		    isOwner = isDirectOwner,
		    props = getNodeProps(vnode);
		while (c && !isOwner && (c = c._parentComponent)) {
			isOwner = c.constructor === vnode.nodeName;
		}
	
		if (c && isOwner && (!mountAll || c._component)) {
			setComponentProps(c, props, 3, context, mountAll);
			dom = c.base;
		} else {
			if (originalComponent && !isDirectOwner) {
				unmountComponent(originalComponent);
				dom = oldDom = null;
			}
	
			c = createComponent(vnode.nodeName, props, context);
			if (dom && !c.nextBase) {
				c.nextBase = dom;
	
				oldDom = null;
			}
			setComponentProps(c, props, 1, context, mountAll);
			dom = c.base;
	
			if (oldDom && dom !== oldDom) {
				oldDom._component = null;
				recollectNodeTree(oldDom, false);
			}
		}
	
		return dom;
	}
	
	function unmountComponent(component) {
		if (options.beforeUnmount) options.beforeUnmount(component);
	
		var base = component.base;
	
		component._disable = true;
	
		if (component.componentWillUnmount) component.componentWillUnmount();
	
		component.base = null;
	
		var inner = component._component;
		if (inner) {
			unmountComponent(inner);
		} else if (base) {
			if (base['__preactattr_'] != null) applyRef(base['__preactattr_'].ref, null);
	
			component.nextBase = base;
	
			removeNode(base);
			recyclerComponents.push(component);
	
			removeChildren(base);
		}
	
		applyRef(component.__ref, null);
	}
	
	function Component(props, context) {
		this._dirty = true;
	
		this.context = context;
	
		this.props = props;
	
		this.state = this.state || {};
	
		this._renderCallbacks = [];
	}
	
	extend(Component.prototype, {
		setState: function setState(state, callback) {
			if (!this.prevState) this.prevState = this.state;
			this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
			if (callback) this._renderCallbacks.push(callback);
			enqueueRender(this);
		},
		forceUpdate: function forceUpdate(callback) {
			if (callback) this._renderCallbacks.push(callback);
			renderComponent(this, 2);
		},
		render: function render() {}
	});
	
	function render(vnode, parent, merge) {
	  return diff(merge, vnode, {}, false, parent, false);
	}
	
	function createRef() {
		return {};
	}
	
	var preact = {
		h: h,
		createElement: h,
		cloneElement: cloneElement,
		createRef: createRef,
		Component: Component,
		render: render,
		rerender: rerender,
		options: options
	};
	
	/* unused harmony default export */ var _unused_webpack_default_export = (preact);
	
	//# sourceMappingURL=preact.mjs.map
	
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(global) {
	var NativeCustomEvent = global.CustomEvent;
	
	function useNative () {
	  try {
	    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
	    return  'cat' === p.type && 'bar' === p.detail.foo;
	  } catch (e) {
	  }
	  return false;
	}
	
	/**
	 * Cross-browser `CustomEvent` constructor.
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
	 *
	 * @public
	 */
	
	module.exports = useNative() ? NativeCustomEvent :
	
	// IE >= 9
	'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent (type, params) {
	  var e = document.createEvent('CustomEvent');
	  if (params) {
	    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
	  } else {
	    e.initCustomEvent(type, false, false, void 0);
	  }
	  return e;
	} :
	
	// IE <= 8
	function CustomEvent (type, params) {
	  var e = document.createEventObject();
	  e.type = type;
	  if (params) {
	    e.bubbles = Boolean(params.bubbles);
	    e.cancelable = Boolean(params.cancelable);
	    e.detail = params.detail;
	  } else {
	    e.bubbles = false;
	    e.cancelable = false;
	    e.detail = void 0;
	  }
	  return e;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports) {
	
	
	/**
	 * Expose `isUrl`.
	 */
	
	module.exports = isUrl;
	
	/**
	 * RegExps.
	 * A URL must match #1 and then at least one of #2/#3.
	 * Use two levels of REs to avoid REDOS.
	 */
	
	var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
	
	var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/
	var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
	
	/**
	 * Loosely validate a URL `string`.
	 *
	 * @param {String} string
	 * @return {Boolean}
	 */
	
	function isUrl(string){
	  if (typeof string !== 'string') {
	    return false;
	  }
	
	  var match = string.match(protocolAndDomainRE);
	  if (!match) {
	    return false;
	  }
	
	  var everythingAfterProtocol = match[1];
	  if (!everythingAfterProtocol) {
	    return false;
	  }
	
	  if (localhostDomainRE.test(everythingAfterProtocol) ||
	      nonLocalhostDomainRE.test(everythingAfterProtocol)) {
	    return true;
	  }
	
	  return false;
	}
	
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Check if we're required to add a port number.
	 *
	 * @see https://url.spec.whatwg.org/#default-port
	 * @param {Number|String} port Port number we need to check
	 * @param {String} protocol Protocol we need to check against.
	 * @returns {Boolean} Is it a default port for the given protocol
	 * @api private
	 */
	module.exports = function required(port, protocol) {
	  protocol = protocol.split(':')[0];
	  port = +port;
	
	  if (!port) return false;
	
	  switch (protocol) {
	    case 'http':
	    case 'ws':
	    return port !== 80;
	
	    case 'https':
	    case 'wss':
	    return port !== 443;
	
	    case 'ftp':
	    return port !== 21;
	
	    case 'gopher':
	    return port !== 70;
	
	    case 'file':
	    return false;
	  }
	
	  return port !== 0;
	};
	
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var has = Object.prototype.hasOwnProperty
	  , undef;
	
	/**
	 * Decode a URI encoded string.
	 *
	 * @param {String} input The URI encoded string.
	 * @returns {String} The decoded string.
	 * @api private
	 */
	function decode(input) {
	  return decodeURIComponent(input.replace(/\+/g, ' '));
	}
	
	/**
	 * Simple query string parser.
	 *
	 * @param {String} query The query string that needs to be parsed.
	 * @returns {Object}
	 * @api public
	 */
	function querystring(query) {
	  var parser = /([^=?&]+)=?([^&]*)/g
	    , result = {}
	    , part;
	
	  while (part = parser.exec(query)) {
	    var key = decode(part[1])
	      , value = decode(part[2]);
	
	    //
	    // Prevent overriding of existing properties. This ensures that build-in
	    // methods like `toString` or __proto__ are not overriden by malicious
	    // querystrings.
	    //
	    if (key in result) continue;
	    result[key] = value;
	  }
	
	  return result;
	}
	
	/**
	 * Transform a query string to an object.
	 *
	 * @param {Object} obj Object that should be transformed.
	 * @param {String} prefix Optional prefix.
	 * @returns {String}
	 * @api public
	 */
	function querystringify(obj, prefix) {
	  prefix = prefix || '';
	
	  var pairs = []
	    , value
	    , key;
	
	  //
	  // Optionally prefix with a '?' if needed
	  //
	  if ('string' !== typeof prefix) prefix = '?';
	
	  for (key in obj) {
	    if (has.call(obj, key)) {
	      value = obj[key];
	
	      //
	      // Edge cases where we actually want to encode the value to an empty
	      // string instead of the stringified value.
	      //
	      if (!value && (value === null || value === undef || isNaN(value))) {
	        value = '';
	      }
	
	      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(value));
	    }
	  }
	
	  return pairs.length ? prefix + pairs.join('&') : '';
	}
	
	//
	// Expose the module.
	//
	exports.stringify = querystringify;
	exports.parse = querystring;
	
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};
	
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Generated by CoffeeScript 1.9.1
	(function() {
	  'use strict';
	  var getScrollbarWidth, scrollbarWidth;
	
	  scrollbarWidth = null;
	
	  getScrollbarWidth = function(recalculate) {
	    var div1, div2;
	    if (recalculate == null) {
	      recalculate = false;
	    }
	    if ((scrollbarWidth != null) && !recalculate) {
	      return scrollbarWidth;
	    }
	    if (document.readyState === 'loading') {
	      return null;
	    }
	    div1 = document.createElement('div');
	    div2 = document.createElement('div');
	    div1.style.width = div2.style.width = div1.style.height = div2.style.height = '100px';
	    div1.style.overflow = 'scroll';
	    div2.style.overflow = 'hidden';
	    document.body.appendChild(div1);
	    document.body.appendChild(div2);
	    scrollbarWidth = Math.abs(div1.scrollHeight - div2.scrollHeight);
	    document.body.removeChild(div1);
	    document.body.removeChild(div2);
	    return scrollbarWidth;
	  };
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
	      return getScrollbarWidth;
	    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined') {
	    module.exports = getScrollbarWidth;
	  } else {
	    this.getScrollbarWidth = getScrollbarWidth;
	  }
	
	}).call(this);
	
	
	/***/ }),
	/* 86 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(45);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(87);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(88);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(90);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);
	
	
	
	
	
	
	var hyphenateRegex = /[A-Z]|^ms/g;
	var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
	  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
	  !isNaN(value) && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (process.env.NODE_ENV !== 'production') {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    return oldProcessStyleValue(key, value);
	  };
	}
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'function':
	        if (process.env.NODE_ENV !== 'production') {
	          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
	        }
	
	        toAdd = classnames([arg()]);
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	var isBrowser = typeof document !== 'undefined';
	
	/*
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject()
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function makeStyleTag(opts) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', opts.key || '');
	
	  if (opts.nonce !== undefined) {
	    tag.setAttribute('nonce', opts.nonce);
	  }
	
	  tag.appendChild(document.createTextNode('')) // $FlowFixMe
	  ;
	  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = process.env.NODE_ENV === 'production'; // the big drawback here is that the css won't be editable in devtools
	
	    this.tags = [];
	    this.ctr = 0;
	    this.opts = options;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.inject = function inject() {
	    if (this.injected) {
	      throw new Error('already injected!');
	    }
	
	    this.tags[0] = makeStyleTag(this.opts);
	    this.injected = true;
	  };
	
	  _proto.speedy = function speedy(bool) {
	    if (this.ctr !== 0) {
	      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
	      throw new Error("cannot change speedy now");
	    }
	
	    this.isSpeedy = !!bool;
	  };
	
	  _proto.insert = function insert(rule, sourceMap) {
	    // this is the ultrafast version, works across browsers
	    if (this.isSpeedy) {
	      var tag = this.tags[this.tags.length - 1];
	      var sheet = sheetForTag(tag);
	
	      try {
	        sheet.insertRule(rule, sheet.cssRules.length);
	      } catch (e) {
	        if (process.env.NODE_ENV !== 'production') {
	          console.warn('illegal rule', rule); // eslint-disable-line no-console
	        }
	      }
	    } else {
	      var _tag = makeStyleTag(this.opts);
	
	      this.tags.push(_tag);
	
	      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
	    }
	
	    this.ctr++;
	
	    if (this.ctr % 65000 === 0) {
	      this.tags.push(makeStyleTag(this.opts));
	    }
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0; // todo - look for remnants in document.styleSheets
	
	    this.injected = false;
	  };
	
	  return StyleSheet;
	}();
	
	function createEmotion(context, options) {
	  if (context.__SECRET_EMOTION__ !== undefined) {
	    return context.__SECRET_EMOTION__;
	  }
	
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	
	  if (process.env.NODE_ENV !== 'production') {
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var current;
	
	  function insertRule(rule) {
	    current += rule;
	
	    if (isBrowser) {
	      sheet.insert(rule, currentSourceMap);
	    }
	  }
	
	  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var caches = {
	    registered: {},
	    inserted: {},
	    nonce: options.nonce,
	    key: key
	  };
	  var sheet = new StyleSheet(options);
	
	  if (isBrowser) {
	    // 🚀
	    sheet.inject();
	  }
	
	  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
	  stylis.use(options.stylisPlugins)(insertionPlugin);
	  var currentSourceMap = '';
	
	  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
	    if (interpolation == null) {
	      return '';
	    }
	
	    switch (typeof interpolation) {
	      case 'boolean':
	        return '';
	
	      case 'function':
	        if (interpolation.__emotion_styles !== undefined) {
	          var selector = interpolation.toString();
	
	          if (selector === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
	            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	          }
	
	          return selector;
	        }
	
	        if (this === undefined && process.env.NODE_ENV !== 'production') {
	          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
	        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);
	
	      case 'object':
	        return createStringFromObject.call(this, interpolation);
	
	      default:
	        var cached = caches.registered[interpolation];
	        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
	    }
	  }
	
	  var objectToStringCache = new WeakMap();
	
	  function createStringFromObject(obj) {
	    if (objectToStringCache.has(obj)) {
	      // $FlowFixMe
	      return objectToStringCache.get(obj);
	    }
	
	    var string = '';
	
	    if (Array.isArray(obj)) {
	      obj.forEach(function (interpolation) {
	        string += handleInterpolation.call(this, interpolation, false);
	      }, this);
	    } else {
	      Object.keys(obj).forEach(function (key) {
	        if (typeof obj[key] !== 'object') {
	          if (caches.registered[obj[key]] !== undefined) {
	            string += key + "{" + caches.registered[obj[key]] + "}";
	          } else {
	            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
	          }
	        } else {
	          if (key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
	            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	          }
	
	          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
	            obj[key].forEach(function (value) {
	              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
	            });
	          } else {
	            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
	          }
	        }
	      }, this);
	    }
	
	    objectToStringCache.set(obj, string);
	    return string;
	  }
	
	  var name;
	  var stylesWithLabel;
	  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	
	  var createClassName = function createClassName(styles, identifierName) {
	    return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
	  };
	
	  if (process.env.NODE_ENV !== 'production') {
	    var oldCreateClassName = createClassName;
	    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
	
	    createClassName = function createClassName(styles, identifierName) {
	      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
	        currentSourceMap = sourceMap;
	        return '';
	      }), identifierName);
	    };
	  }
	
	  var createStyles = function createStyles(strings) {
	    var stringMode = true;
	    var styles = '';
	    var identifierName = '';
	
	    if (strings == null || strings.raw === undefined) {
	      stringMode = false;
	      styles += handleInterpolation.call(this, strings, false);
	    } else {
	      styles += strings[0];
	    }
	
	    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    interpolations.forEach(function (interpolation, i) {
	      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
	      );
	
	      if (stringMode === true && strings[i + 1] !== undefined) {
	        styles += strings[i + 1];
	      }
	    }, this);
	    stylesWithLabel = styles;
	    styles = styles.replace(labelPattern, function (match, p1) {
	      identifierName += "-" + p1;
	      return '';
	    });
	    name = createClassName(styles, identifierName);
	    return styles;
	  };
	
	  if (process.env.NODE_ENV !== 'production') {
	    var oldStylis = stylis;
	
	    stylis = function stylis(selector, styles) {
	      oldStylis(selector, styles);
	      currentSourceMap = '';
	    };
	  }
	
	  function insert(scope, styles) {
	    if (caches.inserted[name] === undefined) {
	      current = '';
	      stylis(scope, styles);
	      caches.inserted[name] = current;
	    }
	  }
	
	  var css = function css() {
	    var styles = createStyles.apply(this, arguments);
	    var selector = key + "-" + name;
	
	    if (caches.registered[selector] === undefined) {
	      caches.registered[selector] = stylesWithLabel;
	    }
	
	    insert("." + selector, styles);
	    return selector;
	  };
	
	  var keyframes = function keyframes() {
	    var styles = createStyles.apply(this, arguments);
	    var animation = "animation-" + name;
	    insert('', "@keyframes " + animation + "{" + styles + "}");
	    return animation;
	  };
	
	  var injectGlobal = function injectGlobal() {
	    var styles = createStyles.apply(this, arguments);
	    insert('', styles);
	  };
	
	  function getRegisteredStyles(registeredStyles, classNames) {
	    var rawClassName = '';
	    classNames.split(' ').forEach(function (className) {
	      if (caches.registered[className] !== undefined) {
	        registeredStyles.push(className);
	      } else {
	        rawClassName += className + " ";
	      }
	    });
	    return rawClassName;
	  }
	
	  function merge(className, sourceMap) {
	    var registeredStyles = [];
	    var rawClassName = getRegisteredStyles(registeredStyles, className);
	
	    if (registeredStyles.length < 2) {
	      return className;
	    }
	
	    return rawClassName + css(registeredStyles, sourceMap);
	  }
	
	  function cx() {
	    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      classNames[_key2] = arguments[_key2];
	    }
	
	    return merge(classnames(classNames));
	  }
	
	  function hydrateSingleId(id) {
	    caches.inserted[id] = true;
	  }
	
	  function hydrate(ids) {
	    ids.forEach(hydrateSingleId);
	  }
	
	  function flush() {
	    if (isBrowser) {
	      sheet.flush();
	      sheet.inject();
	    }
	
	    caches.inserted = {};
	    caches.registered = {};
	  }
	
	  if (isBrowser) {
	    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(chunks, function (node) {
	      // $FlowFixMe
	      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe
	
	      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
	    });
	  }
	
	  var emotion = {
	    flush: flush,
	    hydrate: hydrate,
	    cx: cx,
	    merge: merge,
	    getRegisteredStyles: getRegisteredStyles,
	    injectGlobal: injectGlobal,
	    keyframes: keyframes,
	    css: css,
	    sheet: sheet,
	    caches: caches
	  };
	  context.__SECRET_EMOTION__ = emotion;
	  return emotion;
	}
	
	/* harmony default export */ __webpack_exports__["default"] = (createEmotion);
	
	/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))
	
	/***/ }),
	/* 87 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);
	
	
	/***/ }),
	/* 88 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash2_32_gc(str) {
	  var l = str.length,
	      h = l ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return (h >>> 0).toString(36);
	}
	
	/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);
	
	
	/***/ }),
	/* 89 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e, m).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        switch (d.constructor) {
	          case Array:
	            for (var c = 0, e = d.length; c < e; ++c) {
	              T(d[c]);
	            }
	
	            break;
	
	          case Function:
	            S[A++] = d;
	            break;
	
	          case Boolean:
	            Y = !!d | 0;
	        }
	
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	/* harmony default export */ __webpack_exports__["a"] = (stylis_min);
	
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports, __webpack_require__) {
	
	(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	
	/***/ }),
	/* 91 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_is_prop_valid__ = __webpack_require__(92);
	
	
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var channel = '__EMOTION_THEMING__';
	
	// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js
	
	var _contextTypes;
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object, _contextTypes);
	
	function setTheme(theme) {
	  this.setState({
	    theme: theme
	  });
	}
	var testPickPropsOnStringTag = __WEBPACK_IMPORTED_MODULE_1__emotion_is_prop_valid__["a" /* default */];
	var testPickPropsOnComponent = function testPickPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	var testAlwaysTrue = function testAlwaysTrue() {
	  return true;
	};
	var pickAssign = function pickAssign(testFn, target) {
	  var i = 2;
	  var length = arguments.length;
	
	  for (; i < length; i++) {
	    var source = arguments[i];
	
	    var _key = void 0;
	
	    for (_key in source) {
	      if (testFn(_key)) {
	        target[_key] = source[_key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var warnedAboutExtractStatic = false;
	
	function createEmotionStyled(emotion, view) {
	  var _createStyled = function createStyled(tag, options) {
	    if (process.env.NODE_ENV !== 'production') {
	      if (tag === undefined) {
	        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	      }
	    }
	
	    var staticClassName;
	    var identifierName;
	    var stableClassName;
	    var shouldForwardProp;
	
	    if (options !== undefined) {
	      staticClassName = options.e;
	      identifierName = options.label;
	      stableClassName = options.target;
	      shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
	        return tag.__emotion_forwardProp(propName) && // $FlowFixMe
	        options.shouldForwardProp(propName);
	      } : options.shouldForwardProp;
	    }
	
	    var isReal = tag.__emotion_real === tag;
	    var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;
	
	    if (typeof shouldForwardProp !== 'function') {
	      shouldForwardProp = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testPickPropsOnStringTag : testPickPropsOnComponent;
	    }
	
	    return function () {
	      var args = arguments;
	      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
	
	      if (identifierName !== undefined) {
	        styles.push("label:" + identifierName + ";");
	      }
	
	      if (staticClassName === undefined) {
	        if (args[0] == null || args[0].raw === undefined) {
	          styles.push.apply(styles, args);
	        } else {
	          styles.push(args[0][0]);
	          var len = args.length;
	          var i = 1;
	
	          for (; i < len; i++) {
	            styles.push(args[i], args[0][i]);
	          }
	        }
	      } else if (process.env.NODE_ENV !== 'production' && !warnedAboutExtractStatic) {
	        console.warn('extractStatic is deprecated and will be removed in emotion@10. We recommend disabling extractStatic or using other libraries like linaria or css-literal-loader');
	        warnedAboutExtractStatic = true;
	      }
	
	      var Styled =
	      /*#__PURE__*/
	      function (_view$Component) {
	        _inheritsLoose(Styled, _view$Component);
	
	        function Styled() {
	          return _view$Component.apply(this, arguments) || this;
	        }
	
	        var _proto = Styled.prototype;
	
	        _proto.componentWillMount = function componentWillMount() {
	          if (this.context[channel] !== undefined) {
	            this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
	          }
	        };
	
	        _proto.componentWillUnmount = function componentWillUnmount() {
	          if (this.unsubscribe !== undefined) {
	            this.context[channel].unsubscribe(this.unsubscribe);
	          }
	        };
	
	        _proto.render = function render() {
	          var props = this.props,
	              state = this.state;
	          this.mergedProps = pickAssign(testAlwaysTrue, {}, props, {
	            theme: state !== null && state.theme || props.theme || {}
	          });
	          var className = '';
	          var classInterpolations = [];
	
	          if (props.className) {
	            if (staticClassName === undefined) {
	              className += emotion.getRegisteredStyles(classInterpolations, props.className);
	            } else {
	              className += props.className + " ";
	            }
	          }
	
	          if (staticClassName === undefined) {
	            className += emotion.css.apply(this, styles.concat(classInterpolations));
	          } else {
	            className += staticClassName;
	          }
	
	          if (stableClassName !== undefined) {
	            className += " " + stableClassName;
	          }
	
	          return view.createElement(baseTag, // $FlowFixMe
	          pickAssign(shouldForwardProp, {}, props, {
	            className: className,
	            ref: props.innerRef
	          }));
	        };
	
	        return Styled;
	      }(view.Component);
	
	      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	
	      if (tag.defaultProps !== undefined) {
	        // $FlowFixMe
	        Styled.defaultProps = tag.defaultProps;
	      }
	
	      Styled.contextTypes = contextTypes;
	      Styled.__emotion_styles = styles;
	      Styled.__emotion_base = baseTag;
	      Styled.__emotion_real = Styled;
	      Styled.__emotion_forwardProp = shouldForwardProp;
	      Object.defineProperty(Styled, 'toString', {
	        value: function value() {
	          if (process.env.NODE_ENV !== 'production' && stableClassName === undefined) {
	            return 'NO_COMPONENT_SELECTOR';
	          } // $FlowFixMe
	
	
	          return "." + stableClassName;
	        }
	      });
	
	      Styled.withComponent = function (nextTag, nextOptions) {
	        return _createStyled(nextTag, nextOptions !== undefined ? // $FlowFixMe
	        pickAssign(testAlwaysTrue, {}, options, nextOptions) : options).apply(void 0, styles);
	      };
	
	      return Styled;
	    };
	  };
	
	  if (process.env.NODE_ENV !== 'production' && typeof Proxy !== 'undefined') {
	    _createStyled = new Proxy(_createStyled, {
	      get: function get(target, property) {
	        switch (property) {
	          // react-hot-loader tries to access this stuff
	          case '__proto__':
	          case 'name':
	          case 'prototype':
	          case 'displayName':
	            {
	              return target[property];
	            }
	
	          default:
	            {
	              throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion." + ("\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + property + "')` instead of `styled." + property + "`)"));
	            }
	        }
	      }
	    });
	  }
	
	  return _createStyled;
	}
	
	/* harmony default export */ __webpack_exports__["default"] = (createEmotionStyled);
	
	/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))
	
	/***/ }),
	/* 92 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(45);
	
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class)|(on[A-Z].*)|((data|aria|x)-.*))$/i;
	var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(reactPropsRegex.test.bind(reactPropsRegex));
	
	/* harmony default export */ __webpack_exports__["a"] = (index);
	
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spin = __webpack_require__(94);
	
	var _spin2 = _interopRequireDefault(_spin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultConfig = {
	  lines: 16,
	  length: 3,
	  width: 3,
	  radius: 14,
	  color: '#FFFFFF',
	  speed: 2.1,
	  trail: 60,
	  shadow: false,
	  hwaccel: false,
	  top: '50%',
	  left: '50%',
	  position: 'absolute',
	  zIndex: 999
	};
	
	var Spinner = function (_Component) {
	  _inherits(Spinner, _Component);
	
	  function Spinner() {
	    _classCallCheck(this, Spinner);
	
	    return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
	  }
	
	  _createClass(Spinner, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.instantiateSpinner(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.config.color !== this.props.config.color) {
	        this.spinner.stop();
	        // the Spinner API doesn't provide a method to change its options after instantiation,
	        // so the only way to do so is to reinstantiate the spinner ¯\_(ツ)_/¯
	        this.instantiateSpinner(newProps);
	      } else {
	        if (newProps.stopped === true && !this.props.stopped) {
	          this.spinner.stop();
	        } else if (!newProps.stopped && this.props.stopped === true) {
	          this.spinner.spin(this.container);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.spinner.stop();
	    }
	  }, {
	    key: 'instantiateSpinner',
	    value: function instantiateSpinner(props) {
	      this.spinner = new _spin2.default(_extends({}, defaultConfig, props.config));
	      if (!props.stopped) {
	        this.spinner.spin(this.container);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('div', { ref: function ref(node) {
	          _this2.container = node;
	        } });
	    }
	  }]);
	
	  return Spinner;
	}(_react.Component);
	
	Spinner.propTypes = {
	  config: _propTypes2.default.object,
	  stopped: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object
	};
	
	Spinner.defaultProps = {
	  config: defaultConfig,
	  className: '',
	  style: {}
	};
	
	exports.default = Spinner;
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Copyright (c) 2011-2014 Felix Gnass
	 * Licensed under the MIT license
	 * http://spin.js.org/
	 *
	 * Example:
	    var opts = {
	      lines: 12             // The number of lines to draw
	    , length: 7             // The length of each line
	    , width: 5              // The line thickness
	    , radius: 10            // The radius of the inner circle
	    , scale: 1.0            // Scales overall size of the spinner
	    , corners: 1            // Roundness (0..1)
	    , color: '#000'         // #rgb or #rrggbb
	    , opacity: 1/4          // Opacity of the lines
	    , rotate: 0             // Rotation offset
	    , direction: 1          // 1: clockwise, -1: counterclockwise
	    , speed: 1              // Rounds per second
	    , trail: 100            // Afterglow percentage
	    , fps: 20               // Frames per second when using setTimeout()
	    , zIndex: 2e9           // Use a high z-index by default
	    , className: 'spinner'  // CSS class to assign to the element
	    , top: '50%'            // center vertically
	    , left: '50%'           // center horizontally
	    , shadow: false         // Whether to render a shadow
	    , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
	    , position: 'absolute'  // Element positioning
	    }
	    var target = document.getElementById('foo')
	    var spinner = new Spinner(opts).spin(target)
	 */
	;(function (root, factory) {
	
	  /* CommonJS */
	  if (typeof module == 'object' && module.exports) module.exports = factory()
	
	  /* AMD module */
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
					__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
					(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
					__WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	
	  /* Browser global */
	  else root.Spinner = factory()
	}(this, function () {
	  "use strict"
	
	  var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
	    , animations = {} /* Animation rules keyed by their name */
	    , useCssAnimations /* Whether to use CSS animations or setTimeout */
	    , sheet /* A stylesheet to hold the @keyframe or VML rules. */
	
	  /**
	   * Utility function to create elements. If no tag name is given,
	   * a DIV is created. Optionally properties can be passed.
	   */
	  function createEl (tag, prop) {
	    var el = document.createElement(tag || 'div')
	      , n
	
	    for (n in prop) el[n] = prop[n]
	    return el
	  }
	
	  /**
	   * Appends children and returns the parent.
	   */
	  function ins (parent /* child1, child2, ...*/) {
	    for (var i = 1, n = arguments.length; i < n; i++) {
	      parent.appendChild(arguments[i])
	    }
	
	    return parent
	  }
	
	  /**
	   * Creates an opacity keyframe animation rule and returns its name.
	   * Since most mobile Webkits have timing issues with animation-delay,
	   * we create separate rules for each line/segment.
	   */
	  function addAnimation (alpha, trail, i, lines) {
	    var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-')
	      , start = 0.01 + i/lines * 100
	      , z = Math.max(1 - (1-alpha) / trail * (100-start), alpha)
	      , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
	      , pre = prefix && '-' + prefix + '-' || ''
	
	    if (!animations[name]) {
	      sheet.insertRule(
	        '@' + pre + 'keyframes ' + name + '{' +
	        '0%{opacity:' + z + '}' +
	        start + '%{opacity:' + alpha + '}' +
	        (start+0.01) + '%{opacity:1}' +
	        (start+trail) % 100 + '%{opacity:' + alpha + '}' +
	        '100%{opacity:' + z + '}' +
	        '}', sheet.cssRules.length)
	
	      animations[name] = 1
	    }
	
	    return name
	  }
	
	  /**
	   * Tries various vendor prefixes and returns the first supported property.
	   */
	  function vendor (el, prop) {
	    var s = el.style
	      , pp
	      , i
	
	    prop = prop.charAt(0).toUpperCase() + prop.slice(1)
	    if (s[prop] !== undefined) return prop
	    for (i = 0; i < prefixes.length; i++) {
	      pp = prefixes[i]+prop
	      if (s[pp] !== undefined) return pp
	    }
	  }
	
	  /**
	   * Sets multiple style properties at once.
	   */
	  function css (el, prop) {
	    for (var n in prop) {
	      el.style[vendor(el, n) || n] = prop[n]
	    }
	
	    return el
	  }
	
	  /**
	   * Fills in default values.
	   */
	  function merge (obj) {
	    for (var i = 1; i < arguments.length; i++) {
	      var def = arguments[i]
	      for (var n in def) {
	        if (obj[n] === undefined) obj[n] = def[n]
	      }
	    }
	    return obj
	  }
	
	  /**
	   * Returns the line color from the given string or array.
	   */
	  function getColor (color, idx) {
	    return typeof color == 'string' ? color : color[idx % color.length]
	  }
	
	  // Built-in defaults
	
	  var defaults = {
	    lines: 12             // The number of lines to draw
	  , length: 7             // The length of each line
	  , width: 5              // The line thickness
	  , radius: 10            // The radius of the inner circle
	  , scale: 1.0            // Scales overall size of the spinner
	  , corners: 1            // Roundness (0..1)
	  , color: '#000'         // #rgb or #rrggbb
	  , opacity: 1/4          // Opacity of the lines
	  , rotate: 0             // Rotation offset
	  , direction: 1          // 1: clockwise, -1: counterclockwise
	  , speed: 1              // Rounds per second
	  , trail: 100            // Afterglow percentage
	  , fps: 20               // Frames per second when using setTimeout()
	  , zIndex: 2e9           // Use a high z-index by default
	  , className: 'spinner'  // CSS class to assign to the element
	  , top: '50%'            // center vertically
	  , left: '50%'           // center horizontally
	  , shadow: false         // Whether to render a shadow
	  , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
	  , position: 'absolute'  // Element positioning
	  }
	
	  /** The constructor */
	  function Spinner (o) {
	    this.opts = merge(o || {}, Spinner.defaults, defaults)
	  }
	
	  // Global defaults that override the built-ins:
	  Spinner.defaults = {}
	
	  merge(Spinner.prototype, {
	    /**
	     * Adds the spinner to the given target element. If this instance is already
	     * spinning, it is automatically removed from its previous target b calling
	     * stop() internally.
	     */
	    spin: function (target) {
	      this.stop()
	
	      var self = this
	        , o = self.opts
	        , el = self.el = createEl(null, {className: o.className})
	
	      css(el, {
	        position: o.position
	      , width: 0
	      , zIndex: o.zIndex
	      , left: o.left
	      , top: o.top
	      })
	
	      if (target) {
	        target.insertBefore(el, target.firstChild || null)
	      }
	
	      el.setAttribute('role', 'progressbar')
	      self.lines(el, self.opts)
	
	      if (!useCssAnimations) {
	        // No CSS animation support, use setTimeout() instead
	        var i = 0
	          , start = (o.lines - 1) * (1 - o.direction) / 2
	          , alpha
	          , fps = o.fps
	          , f = fps / o.speed
	          , ostep = (1 - o.opacity) / (f * o.trail / 100)
	          , astep = f / o.lines
	
	        ;(function anim () {
	          i++
	          for (var j = 0; j < o.lines; j++) {
	            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)
	
	            self.opacity(el, j * o.direction + start, alpha, o)
	          }
	          self.timeout = self.el && setTimeout(anim, ~~(1000 / fps))
	        })()
	      }
	      return self
	    }
	
	    /**
	     * Stops and removes the Spinner.
	     */
	  , stop: function () {
	      var el = this.el
	      if (el) {
	        clearTimeout(this.timeout)
	        if (el.parentNode) el.parentNode.removeChild(el)
	        this.el = undefined
	      }
	      return this
	    }
	
	    /**
	     * Internal method that draws the individual lines. Will be overwritten
	     * in VML fallback mode below.
	     */
	  , lines: function (el, o) {
	      var i = 0
	        , start = (o.lines - 1) * (1 - o.direction) / 2
	        , seg
	
	      function fill (color, shadow) {
	        return css(createEl(), {
	          position: 'absolute'
	        , width: o.scale * (o.length + o.width) + 'px'
	        , height: o.scale * o.width + 'px'
	        , background: color
	        , boxShadow: shadow
	        , transformOrigin: 'left'
	        , transform: 'rotate(' + ~~(360/o.lines*i + o.rotate) + 'deg) translate(' + o.scale*o.radius + 'px' + ',0)'
	        , borderRadius: (o.corners * o.scale * o.width >> 1) + 'px'
	        })
	      }
	
	      for (; i < o.lines; i++) {
	        seg = css(createEl(), {
	          position: 'absolute'
	        , top: 1 + ~(o.scale * o.width / 2) + 'px'
	        , transform: o.hwaccel ? 'translate3d(0,0,0)' : ''
	        , opacity: o.opacity
	        , animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
	        })
	
	        if (o.shadow) ins(seg, css(fill('#000', '0 0 4px #000'), {top: '2px'}))
	        ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
	      }
	      return el
	    }
	
	    /**
	     * Internal method that adjusts the opacity of a single line.
	     * Will be overwritten in VML fallback mode below.
	     */
	  , opacity: function (el, i, val) {
	      if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
	    }
	
	  })
	
	
	  function initVML () {
	
	    /* Utility function to create a VML tag */
	    function vml (tag, attr) {
	      return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
	    }
	
	    // No CSS transforms but VML support, add a CSS rule for VML elements:
	    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')
	
	    Spinner.prototype.lines = function (el, o) {
	      var r = o.scale * (o.length + o.width)
	        , s = o.scale * 2 * r
	
	      function grp () {
	        return css(
	          vml('group', {
	            coordsize: s + ' ' + s
	          , coordorigin: -r + ' ' + -r
	          })
	        , { width: s, height: s }
	        )
	      }
	
	      var margin = -(o.width + o.length) * o.scale * 2 + 'px'
	        , g = css(grp(), {position: 'absolute', top: margin, left: margin})
	        , i
	
	      function seg (i, dx, filter) {
	        ins(
	          g
	        , ins(
	            css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx})
	          , ins(
	              css(
	                vml('roundrect', {arcsize: o.corners})
	              , { width: r
	                , height: o.scale * o.width
	                , left: o.scale * o.radius
	                , top: -o.scale * o.width >> 1
	                , filter: filter
	                }
	              )
	            , vml('fill', {color: getColor(o.color, i), opacity: o.opacity})
	            , vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
	            )
	          )
	        )
	      }
	
	      if (o.shadow)
	        for (i = 1; i <= o.lines; i++) {
	          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')
	        }
	
	      for (i = 1; i <= o.lines; i++) seg(i)
	      return ins(el, g)
	    }
	
	    Spinner.prototype.opacity = function (el, i, val, o) {
	      var c = el.firstChild
	      o = o.shadow && o.lines || 0
	      if (c && i + o < c.childNodes.length) {
	        c = c.childNodes[i + o]; c = c && c.firstChild; c = c && c.firstChild
	        if (c) c.opacity = val
	      }
	    }
	  }
	
	  if (typeof document !== 'undefined') {
	    sheet = (function () {
	      var el = createEl('style', {type : 'text/css'})
	      ins(document.getElementsByTagName('head')[0], el)
	      return el.sheet || el.styleSheet
	    }())
	
	    var probe = css(createEl('group'), {behavior: 'url(#default#VML)'})
	
	    if (!vendor(probe, 'transform') && probe.adj) initVML()
	    else useCssAnimations = vendor(probe, 'animation')
	  }
	
	  return Spinner
	
	}));
	
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports) {
	
	module.exports = "data:image/gif;base64,R0lGODlhEQARAIAAAODn7P///yH5BAEHAAEALAAAAAARABEAAAIqBIKpab3v3EMyVHWtWZluf0za0XFNKDJfCq5i5JpomdUxqKLQVmInqyoAADs="
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(17);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Root = /*#__PURE__*/(0, _styles2.default)('div', {
	  target: 'e1m9xwad0'
	})('position:absolute;z-index:1001;top:0;right:0;font-size:20px;font-family:sans-serif;width:50px;height:50px;');
	
	var closeArrow = /*#__PURE__*/(0, _styles.css)('border-radius:0;display:block;height:2px;width:25px;position:absolute;right:6px;top:6px;');
	
	var ArrowLeft = /*#__PURE__*/(0, _styles2.default)('span', {
	  target: 'e1m9xwad1'
	})(closeArrow, ' background-color:', function (p) {
	  return p.backgroundColor;
	}, ';transform:translate(0,13px) rotate3d(0,0,1,-135deg);');
	
	var ArrowRight = /*#__PURE__*/(0, _styles2.default)('span', {
	  target: 'e1m9xwad2'
	})(closeArrow, ' background-color:', function (p) {
	  return p.backgroundColor;
	}, ';transform:translate(0,13px) rotate3d(0,0,1,-45deg);');
	
	var CloseIcon = function CloseIcon(_ref) {
	  var color = _ref.color,
	      onClick = _ref.onClick,
	      dataQa = _ref.dataQa;
	  return _react2.default.createElement(
	    Root,
	    { 'data-qa': dataQa, onClick: onClick },
	    _react2.default.createElement(ArrowLeft, { backgroundColor: color }),
	    _react2.default.createElement(ArrowRight, { backgroundColor: color })
	  );
	};
	
	CloseIcon.propTypes = {
	  color: _propTypes2.default.string,
	  dataQa: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	
	exports.default = CloseIcon;
	
	/***/ }),
	/* 97 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
					__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
					(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
	    factory(exports, module);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, mod);
	    global.fetchJsonp = mod.exports;
	  }
	})(this, function (exports, module) {
	  'use strict';
	
	  var defaultOptions = {
	    timeout: 5000,
	    jsonpCallback: 'callback',
	    jsonpCallbackFunction: null
	  };
	
	  function generateCallbackFunction() {
	    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
	  }
	
	  function clearFunction(functionName) {
	    // IE8 throws an exception when you try to delete a property on window
	    // http://stackoverflow.com/a/1824228/751089
	    try {
	      delete window[functionName];
	    } catch (e) {
	      window[functionName] = undefined;
	    }
	  }
	
	  function removeScript(scriptId) {
	    var script = document.getElementById(scriptId);
	    if (script) {
	      document.getElementsByTagName('head')[0].removeChild(script);
	    }
	  }
	
	  function fetchJsonp(_url) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    // to avoid param reassign
	    var url = _url;
	    var timeout = options.timeout || defaultOptions.timeout;
	    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;
	
	    var timeoutId = undefined;
	
	    return new Promise(function (resolve, reject) {
	      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
	      var scriptId = jsonpCallback + '_' + callbackFunction;
	
	      window[callbackFunction] = function (response) {
	        resolve({
	          ok: true,
	          // keep consistent with fetch API
	          json: function json() {
	            return Promise.resolve(response);
	          }
	        });
	
	        if (timeoutId) clearTimeout(timeoutId);
	
	        removeScript(scriptId);
	
	        clearFunction(callbackFunction);
	      };
	
	      // Check if the user set their own params, and if not add a ? to start a list of params
	      url += url.indexOf('?') === -1 ? '?' : '&';
	
	      var jsonpScript = document.createElement('script');
	      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
	      if (options.charset) {
	        jsonpScript.setAttribute('charset', options.charset);
	      }
	      jsonpScript.id = scriptId;
	      document.getElementsByTagName('head')[0].appendChild(jsonpScript);
	
	      timeoutId = setTimeout(function () {
	        reject(new Error('JSONP request to ' + _url + ' timed out'));
	
	        clearFunction(callbackFunction);
	        removeScript(scriptId);
	        window[callbackFunction] = function () {
	          clearFunction(callbackFunction);
	        };
	      }, timeout);
	
	      // Caught if got 404/500
	      jsonpScript.onerror = function () {
	        reject(new Error('JSONP request to ' + _url + ' failed'));
	
	        clearFunction(callbackFunction);
	        removeScript(scriptId);
	        if (timeoutId) clearTimeout(timeoutId);
	      };
	    });
	  }
	
	  // export as global function
	  /*
	  let local;
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	  local.fetchJsonp = fetchJsonp;
	  */
	
	  module.exports = fetchJsonp;
	});
	
	/***/ }),
	/* 98 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeWidget;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(2);
	
	var _utils = __webpack_require__(9);
	
	var _mobileDetection = __webpack_require__(16);
	
	var _widget = __webpack_require__(99);
	
	var _widget2 = _interopRequireDefault(_widget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultOptions = {
	  mode: 'embed-widget',
	  hideFooter: false,
	  hideHeaders: false,
	  hideScrollbars: false,
	  disableTracking: false,
	  onSubmit: _utils.noop
	};
	
	var queryStringKeys = {
	  mode: 'typeform-embed',
	  hideFooter: 'embed-hide-footer',
	  hideHeaders: 'embed-hide-headers',
	  opacity: 'embed-opacity',
	  disableTracking: 'disable-tracking'
	};
	
	function makeWidget(element, url, options) {
	  options = _extends({}, defaultOptions, options);
	
	  var enabledFullscreen = (0, _mobileDetection.isMobile)(navigator.userAgent);
	
	  var queryStrings = (0, _utils.replaceExistingKeys)(options, queryStringKeys);
	
	  if (enabledFullscreen) {
	    queryStrings = _extends({}, (0, _utils.omit)('embed-opacity', queryStrings), {
	      'add-placeholder-ws': true
	    });
	  }
	
	  var urlWithQueryString = (0, _utils.appendParamsToUrl)(url, queryStrings);
	
	  var embedId = (0, _utils.randomString)();
	
	  (0, _reactDom.render)(_react2.default.createElement(_widget2.default, {
	    embedId: embedId,
	    enabledFullscreen: enabledFullscreen,
	    options: options,
	    url: urlWithQueryString
	  }), element);
	}
	
	/***/ }),
	/* 99 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(17);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _mobileModal = __webpack_require__(46);
	
	var _mobileModal2 = _interopRequireDefault(_mobileModal);
	
	var _utils = __webpack_require__(9);
	
	var _iframe = __webpack_require__(26);
	
	var _iframe2 = _interopRequireDefault(_iframe);
	
	var _dataService = __webpack_require__(47);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _store = __webpack_require__(48);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEBOUNCE_WAIT = 200;
	
	var WidgetWrapper = /*#__PURE__*/(0, _styles2.default)('div', {
	  target: 'e12baen60'
	})('height:100%;position:relative;');
	
	var checkEmbedHash = function checkEmbedHash(embedId, event) {
	  return event.detail && event.detail.embedId === embedId;
	};
	
	var PlaceholderAnimationAppear = /*#__PURE__*/(0, _styles.keyframes)('10%{opacity:1;}25%{top:0;left:0;width:100%;height:100%;opacity:1;}70%{top:0;left:0;width:100%;height:100%;opacity:1;}100%{top:0;left:0;width:100%;height:100%;opacity:0;}');
	
	var PlaceholderAnimationDisappear = /*#__PURE__*/(0, _styles.keyframes)('100%{opacity:0;}75%{opacity:1;}25%{opacity:1;}0%{opacity:0;}');
	
	var Placeholder = /*#__PURE__*/(0, _styles2.default)('div', {
	  target: 'e12baen61'
	})('position:fixed;top:', function (props) {
	  return props.top;
	}, 'px;left:', function (props) {
	  return props.left;
	}, 'px;height:', function (props) {
	  return props.height ? props.height + 'px' : '100%';
	}, ';width:', function (props) {
	  return props.width ? props.width + 'px' : '100%';
	}, ';animation:', function (props) {
	  return props.open ? PlaceholderAnimationAppear : PlaceholderAnimationDisappear;
	}, ' 1.5s ease;visibility:', function (props) {
	  return props.visible ? 'visible' : 'hidden';
	}, ';background:', function (props) {
	  return props.backgroundColor;
	}, ';opacity:0;pointer-events:none;');
	
	var IframeWrapper = /*#__PURE__*/(0, _styles2.default)('div', {
	  target: 'e12baen62'
	})('height:100%;width:100%;overflow:hidden;background:', function (props) {
	  return props.backgroundColor;
	}, ';');
	
	var Widget = function (_Component) {
	  _inherits(Widget, _Component);
	
	  function Widget(props) {
	    _classCallCheck(this, Widget);
	
	    var _this = _possibleConstructorReturn(this, (Widget.__proto__ || Object.getPrototypeOf(Widget)).call(this, props));
	
	    _this.state = {
	      isFormReady: false,
	      isIframeFocused: false,
	      isFullscreen: false,
	      closeIconColor: 'black',
	      backgroundColor: 'transparent'
	    };
	
	    _this.onFormReady = _this.onFormReady.bind(_this);
	    _this.focusIframe = _this.focusIframe.bind(_this);
	    _this.onFormSubmit = _this.onFormSubmit.bind(_this);
	    _this.goFullScreen = _this.goFullScreen.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	    _this.reloadIframe = _this.reloadIframe.bind(_this);
	    _this.debouncedScroll = (0, _utils.debounce)(_this.focusIframe, DEBOUNCE_WAIT, _this);
	    return _this;
	  }
	
	  _createClass(Widget, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.addEventListener('message', _utils.onMessage);
	      window.addEventListener('form-ready', this.onFormReady);
	      window.addEventListener('scroll', this.debouncedScroll);
	      window.addEventListener('form-submit', this.onFormSubmit);
	      window.addEventListener('welcome-screen-hidden', this.goFullScreen);
	      window.addEventListener('redirect-after-submit', _utils.redirectAfterSubmit);
	
	      var uid = _dataService2.default.getUidFromURL(this.props.url);
	
	      _dataService2.default.getFormData(uid, _utils.DOMAIN).then(function (resp) {
	        return (0, _store2.default)(uid, '', _this2.props.url, '', resp);
	      }).then(function (data) {
	        _this2.setState({
	          closeIconColor: '#' + data.form['button-color'],
	          backgroundColor: '#' + data.form['background-color']
	        });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('message', _utils.onMessage);
	      window.removeEventListener('form-ready', this.onFormReady);
	      window.removeEventListener('scroll', this.debouncedScroll);
	      window.removeEventListener('form-submit', this.onFormSubmit);
	      window.removeEventListener('welcome-screen-hidden', this.goFullScreen);
	      window.addEventListener('redirect-after-submit', _utils.redirectAfterSubmit);
	    }
	  }, {
	    key: 'goFullScreen',
	    value: function goFullScreen(event) {
	      if (!checkEmbedHash(this.props.embedId, event)) {
	        return;
	      }
	
	      if (this.props.enabledFullscreen) {
	        this.setState({ isFullscreen: true });
	
	        setTimeout(this.reloadIframe, 3000);
	      }
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      this.setState({ isFullscreen: false });
	    }
	  }, {
	    key: 'onFormReady',
	    value: function onFormReady() {
	      var _this3 = this;
	
	      this.setState({
	        isFormReady: true
	      }, function () {
	        _this3.focusIframe();
	      });
	    }
	  }, {
	    key: 'reloadIframe',
	    value: function reloadIframe() {
	      // Re-assign the source of the iframe, makes it reload cross-browser
	      this.iframe.iframeRef.src = this.iframe.iframeRef.src;
	    }
	  }, {
	    key: 'onFormSubmit',
	    value: function onFormSubmit() {
	      var options = this.props.options;
	
	      options.onSubmit && options.onSubmit();
	    }
	  }, {
	    key: 'focusIframe',
	    value: function focusIframe() {
	      if (this.props.enabledFullscreen) return;
	
	      var iframeRef = this.iframe.iframeRef;
	
	
	      if (!iframeRef || !iframeRef.contentWindow) {
	        return;
	      }
	
	      var isIframeInViewport = (0, _utils.isElementInViewport)(iframeRef);
	      var canPostMessage = this.state.isFormReady && !this.state.isIframeFocused && isIframeInViewport && iframeRef.contentWindow != null;
	
	      if (canPostMessage) {
	        iframeRef.contentWindow.postMessage('embed-focus', '*');
	        this.setState({
	          isIframeFocused: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          isFullscreen = _state.isFullscreen,
	          closeIconColor = _state.closeIconColor,
	          backgroundColor = _state.backgroundColor,
	          isFormReady = _state.isFormReady;
	      var enabledFullscreen = this.props.enabledFullscreen;
	
	
	      var iframePosition = this.iframe && this.iframe.iframeRef.getBoundingClientRect();
	
	      var inlineIframeUrl = (0, _utils.updateQueryStringParameter)('typeform-embed-id', this.props.embedId, this.props.url);
	
	      if (enabledFullscreen) {
	        inlineIframeUrl = (0, _utils.updateQueryStringParameter)('disable-tracking', 'true', inlineIframeUrl);
	      }
	
	      var fullscreenIframeUrl = (0, _utils.updateQueryStringParameter)('typeform-welcome', '0', this.props.url);
	
	      return _react2.default.createElement(
	        WidgetWrapper,
	        null,
	        _react2.default.createElement(
	          IframeWrapper,
	          {
	            backgroundColor: enabledFullscreen ? backgroundColor : 'transparent'
	          },
	          _react2.default.createElement(_iframe2.default, {
	            frameBorder: '0',
	            height: '100%',
	            ref: function ref(node) {
	              _this4.iframe = node;
	            },
	            src: inlineIframeUrl,
	            width: '100%'
	          })
	        ),
	        enabledFullscreen && _react2.default.createElement(Placeholder, {
	          backgroundColor: backgroundColor,
	          bottom: iframePosition && iframePosition.bottom,
	          height: iframePosition && iframePosition.height,
	          left: iframePosition && iframePosition.left,
	          open: isFullscreen,
	          right: iframePosition && iframePosition.right,
	          top: iframePosition && iframePosition.top,
	          visible: isFormReady,
	          width: iframePosition && iframePosition.width
	        }),
	        enabledFullscreen && _react2.default.createElement(_mobileModal2.default, {
	          backgroundColor: backgroundColor,
	          buttonColor: closeIconColor,
	          onClose: this.handleClose,
	          open: isFullscreen,
	          openDelay: 0.3,
	          url: fullscreenIframeUrl
	        })
	      );
	    }
	  }]);
	
	  return Widget;
	}(_react.Component);
	
	Widget.propTypes = {
	  url: _propTypes2.default.string,
	  options: _propTypes2.default.object.isRequired,
	  enabledFullscreen: _propTypes2.default.bool,
	  embedId: _propTypes2.default.string
	};
	
	Widget.defaultProps = {
	  options: {},
	  enabledFullscreen: false
	};
	
	exports.default = Widget;
	
	/***/ }),
	/* 100 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeFullScreen;
	
	var _utils = __webpack_require__(9);
	
	var defaultOptions = {
	  mode: 'embed-fullpage',
	  disableTracking: false,
	  onSubmit: _utils.noop
	};
	
	var queryStringKeys = {
	  mode: 'typeform-embed',
	  disableTracking: 'disable-tracking'
	};
	
	function makeFullScreen(iframe, url, options) {
	  options = _extends({}, defaultOptions, options);
	
	  iframe.src = (0, _utils.appendParamsToUrl)(url, (0, _utils.replaceExistingKeys)(options, queryStringKeys));
	
	  var onFormSubmit = function onFormSubmit() {
	    options.onSubmit();
	  };
	
	  (0, _utils.ensureMetaViewport)();
	
	  // Fix scroll inside the iframe (renderer v1)
	  iframe.onload = function () {
	    setTimeout(function () {
	      iframe.style.height = '';
	      (0, _utils.applyIOSFooterHack)(iframe);
	      (0, _utils.applyIOSIframeResizeHack)(iframe);
	    }, 1);
	
	    iframe.contentWindow.focus();
	  };
	
	  window.addEventListener('message', _utils.onMessage);
	  window.addEventListener('form-submit', onFormSubmit);
	}
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var assign = __webpack_require__(102);
	
	// `Object.assign` method
	// https://tc39.github.io/ecma262/#sec-object.assign
	__webpack_require__(12)({ target: 'Object', stat: true, forced: Object.assign !== assign }, { assign: assign });
	
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// 19.1.2.1 Object.assign(target, source, ...)
	var objectKeys = __webpack_require__(49);
	var getOwnPropertySymbolsModule = __webpack_require__(51);
	var propertyIsEnumerableModule = __webpack_require__(52);
	var toObject = __webpack_require__(33);
	var IndexedObject = __webpack_require__(27);
	var nativeAssign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !nativeAssign || __webpack_require__(10)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var symbol = Symbol();
	  var alphabet = 'abcdefghijklmnopqrst';
	  A[symbol] = 7;
	  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
	  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var argumentsLength = arguments.length;
	  var index = 1;
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  var propertyIsEnumerable = propertyIsEnumerableModule.f;
	  while (argumentsLength > index) {
	    var S = IndexedObject(arguments[index++]);
	    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (propertyIsEnumerable.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : nativeAssign;
	
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var toIndexedObject = __webpack_require__(18);
	var toLength = __webpack_require__(29);
	var toAbsoluteIndex = __webpack_require__(104);
	
	// `Array.prototype.{ indexOf, includes }` methods implementation
	// false -> Array#indexOf
	// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
	// true  -> Array#includes
	// https://tc39.github.io/ecma262/#sec-array.prototype.includes
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var toInteger = __webpack_require__(30);
	var max = Math.max;
	var min = Math.min;
	
	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
	module.exports = function (index, length) {
	  var integer = toInteger(index);
	  return integer < 0 ? max(integer + length, 0) : min(integer, length);
	};
	
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var nativeFunctionToString = __webpack_require__(55);
	var WeakMap = __webpack_require__(0).WeakMap;
	
	module.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));
	
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var has = __webpack_require__(7);
	var ownKeys = __webpack_require__(107);
	var getOwnPropertyDescriptorModule = __webpack_require__(34);
	var definePropertyModule = __webpack_require__(14);
	
	module.exports = function (target, source) {
	  var keys = ownKeys(source);
	  var defineProperty = definePropertyModule.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	  }
	};
	
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var getOwnPropertyNamesModule = __webpack_require__(108);
	var getOwnPropertySymbolsModule = __webpack_require__(51);
	var anObject = __webpack_require__(6);
	var Reflect = __webpack_require__(0).Reflect;
	
	// all object keys, includes non-enumerable and symbols
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
	};
	
	
	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var internalObjectKeys = __webpack_require__(50);
	var hiddenKeys = __webpack_require__(32).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys(O, hiddenKeys);
	};
	
	
	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var internalFind = __webpack_require__(110)(5);
	var FIND = 'find';
	var SKIPS_HOLES = true;
	
	// Shouldn't skip holes
	if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });
	
	// `Array.prototype.find` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.find
	__webpack_require__(12)({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
	  find: function find(callbackfn /* , that = undefined */) {
	    return internalFind(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
	__webpack_require__(58)(FIND);
	
	
	/***/ }),
	/* 110 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var bind = __webpack_require__(39);
	var IndexedObject = __webpack_require__(27);
	var toObject = __webpack_require__(33);
	var toLength = __webpack_require__(29);
	var arraySpeciesCreate = __webpack_require__(111);
	
	// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
	// 0 -> Array#forEach
	// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
	// 1 -> Array#map
	// https://tc39.github.io/ecma262/#sec-array.prototype.map
	// 2 -> Array#filter
	// https://tc39.github.io/ecma262/#sec-array.prototype.filter
	// 3 -> Array#some
	// https://tc39.github.io/ecma262/#sec-array.prototype.some
	// 4 -> Array#every
	// https://tc39.github.io/ecma262/#sec-array.prototype.every
	// 5 -> Array#find
	// https://tc39.github.io/ecma262/#sec-array.prototype.find
	// 6 -> Array#findIndex
	// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
	module.exports = function (TYPE, specificCreate) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = specificCreate || arraySpeciesCreate;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IndexedObject(O);
	    var boundFunction = bind(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var value, result;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	          case 3: return true;              // some
	          case 5: return value;             // find
	          case 6: return index;             // findIndex
	          case 2: target.push(value);       // filter
	        } else if (IS_EVERY) return false;  // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};
	
	
	/***/ }),
	/* 111 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(5);
	var isArray = __webpack_require__(112);
	var SPECIES = __webpack_require__(1)('species');
	
	// `ArraySpeciesCreate` abstract operation
	// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
	module.exports = function (originalArray, length) {
	  var C;
	  if (isArray(originalArray)) {
	    C = originalArray.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    else if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
	};
	
	
	/***/ }),
	/* 112 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var classof = __webpack_require__(11);
	
	// `IsArray` abstract operation
	// https://tc39.github.io/ecma262/#sec-isarray
	module.exports = Array.isArray || function isArray(arg) {
	  return classof(arg) == 'Array';
	};
	
	
	/***/ }),
	/* 113 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Chrome 38 Symbol has incorrect toString conversion
	module.exports = !__webpack_require__(10)(function () {
	  // eslint-disable-next-line no-undef
	  return !String(Symbol());
	});
	
	
	/***/ }),
	/* 114 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var DESCRIPTORS = __webpack_require__(13);
	var definePropertyModule = __webpack_require__(14);
	var anObject = __webpack_require__(6);
	var objectKeys = __webpack_require__(49);
	
	module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var key;
	  while (length > i) definePropertyModule.f(O, key = keys[i++], Properties[key]);
	  return O;
	};
	
	
	/***/ }),
	/* 115 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isInteger = __webpack_require__(116);
	var abs = Math.abs;
	
	// `Number.isSafeInteger` method
	// https://tc39.github.io/ecma262/#sec-number.issafeinteger
	__webpack_require__(12)({ target: 'Number', stat: true }, {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
	  }
	});
	
	
	/***/ }),
	/* 116 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(5);
	var floor = Math.floor;
	
	// `Number.isInteger` method implementation
	// https://tc39.github.io/ecma262/#sec-number.isinteger
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};
	
	
	/***/ }),
	/* 117 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(118);
	__webpack_require__(120);
	__webpack_require__(126);
	__webpack_require__(129);
	__webpack_require__(141);
	
	module.exports = __webpack_require__(41).Promise;
	
	
	/***/ }),
	/* 118 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var toString = __webpack_require__(119);
	var ObjectPrototype = Object.prototype;
	
	// `Object.prototype.toString` method
	// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
	if (toString !== ObjectPrototype.toString) {
	  __webpack_require__(19)(ObjectPrototype, 'toString', toString, { unsafe: true });
	}
	
	
	/***/ }),
	/* 119 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var classof = __webpack_require__(61);
	var TO_STRING_TAG = __webpack_require__(1)('toStringTag');
	var test = {};
	
	test[TO_STRING_TAG] = 'z';
	
	// `Object.prototype.toString` method implementation
	// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
	module.exports = String(test) !== '[object z]' ? function toString() {
	  return '[object ' + classof(this) + ']';
	} : test.toString;
	
	
	/***/ }),
	/* 120 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var codePointAt = __webpack_require__(121);
	var InternalStateModule = __webpack_require__(22);
	var defineIterator = __webpack_require__(62);
	var STRING_ITERATOR = 'String Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
	
	// `String.prototype[@@iterator]` method
	// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
	defineIterator(String, 'String', function (iterated) {
	  setInternalState(this, {
	    type: STRING_ITERATOR,
	    string: String(iterated),
	    index: 0
	  });
	// `%StringIteratorPrototype%.next` method
	// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
	}, function next() {
	  var state = getInternalState(this);
	  var string = state.string;
	  var index = state.index;
	  var point;
	  if (index >= string.length) return { value: undefined, done: true };
	  point = codePointAt(string, index, true);
	  state.index += point.length;
	  return { value: point, done: false };
	});
	
	
	/***/ }),
	/* 121 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var toInteger = __webpack_require__(30);
	var requireObjectCoercible = __webpack_require__(28);
	// CONVERT_TO_STRING: true  -> String#at
	// CONVERT_TO_STRING: false -> String#codePointAt
	module.exports = function (that, pos, CONVERT_TO_STRING) {
	  var S = String(requireObjectCoercible(that));
	  var position = toInteger(pos);
	  var size = S.length;
	  var first, second;
	  if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	  first = S.charCodeAt(position);
	  return first < 0xD800 || first > 0xDBFF || position + 1 === size
	    || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
	      ? CONVERT_TO_STRING ? S.charAt(position) : first
	      : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	};
	
	
	/***/ }),
	/* 122 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var IteratorPrototype = __webpack_require__(63).IteratorPrototype;
	var create = __webpack_require__(59);
	var createPropertyDescriptor = __webpack_require__(35);
	var setToStringTag = __webpack_require__(40);
	var Iterators = __webpack_require__(15);
	
	var returnThis = function () { return this; };
	
	module.exports = function (IteratorConstructor, NAME, next) {
	  var TO_STRING_TAG = NAME + ' Iterator';
	  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
	  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
	  Iterators[TO_STRING_TAG] = returnThis;
	  return IteratorConstructor;
	};
	
	
	/***/ }),
	/* 123 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = !__webpack_require__(10)(function () {
	  function F() { /* empty */ }
	  F.prototype.constructor = null;
	  return Object.getPrototypeOf(new F()) !== F.prototype;
	});
	
	
	/***/ }),
	/* 124 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var validateSetPrototypeOfArguments = __webpack_require__(125);
	
	module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var correctSetter = false;
	  var test = {};
	  var setter;
	  try {
	    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
	    setter.call(test, []);
	    correctSetter = test instanceof Array;
	  } catch (error) { /* empty */ }
	  return function setPrototypeOf(O, proto) {
	    validateSetPrototypeOfArguments(O, proto);
	    if (correctSetter) setter.call(O, proto);
	    else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);
	
	
	/***/ }),
	/* 125 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(5);
	var anObject = __webpack_require__(6);
	
	module.exports = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) {
	    throw TypeError("Can't set " + String(proto) + ' as a prototype');
	  }
	};
	
	
	/***/ }),
	/* 126 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var DOMIterables = __webpack_require__(127);
	var ArrayIteratorMethods = __webpack_require__(128);
	var global = __webpack_require__(0);
	var hide = __webpack_require__(8);
	var wellKnownSymbol = __webpack_require__(1);
	var ITERATOR = wellKnownSymbol('iterator');
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var ArrayValues = ArrayIteratorMethods.values;
	
	for (var COLLECTION_NAME in DOMIterables) {
	  var Collection = global[COLLECTION_NAME];
	  var CollectionPrototype = Collection && Collection.prototype;
	  if (CollectionPrototype) {
	    // some Chrome versions have non-configurable methods on DOMTokenList
	    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
	      hide(CollectionPrototype, ITERATOR, ArrayValues);
	    } catch (error) {
	      CollectionPrototype[ITERATOR] = ArrayValues;
	    }
	    if (!CollectionPrototype[TO_STRING_TAG]) hide(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
	    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
	      // some Chrome versions have non-configurable methods on DOMTokenList
	      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
	        hide(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
	      } catch (error) {
	        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
	      }
	    }
	  }
	}
	
	
	/***/ }),
	/* 127 */
	/***/ (function(module, exports) {
	
	// iterable DOM collections
	// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
	module.exports = {
	  CSSRuleList: 0,
	  CSSStyleDeclaration: 0,
	  CSSValueList: 0,
	  ClientRectList: 0,
	  DOMRectList: 0,
	  DOMStringList: 0,
	  DOMTokenList: 1,
	  DataTransferItemList: 0,
	  FileList: 0,
	  HTMLAllCollection: 0,
	  HTMLCollection: 0,
	  HTMLFormElement: 0,
	  HTMLSelectElement: 0,
	  MediaList: 0,
	  MimeTypeArray: 0,
	  NamedNodeMap: 0,
	  NodeList: 1,
	  PaintRequestList: 0,
	  Plugin: 0,
	  PluginArray: 0,
	  SVGLengthList: 0,
	  SVGNumberList: 0,
	  SVGPathSegList: 0,
	  SVGPointList: 0,
	  SVGStringList: 0,
	  SVGTransformList: 0,
	  SourceBufferList: 0,
	  StyleSheetList: 0,
	  TextTrackCueList: 0,
	  TextTrackList: 0,
	  TouchList: 0
	};
	
	
	/***/ }),
	/* 128 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var toIndexedObject = __webpack_require__(18);
	var addToUnscopables = __webpack_require__(58);
	var Iterators = __webpack_require__(15);
	var InternalStateModule = __webpack_require__(22);
	var defineIterator = __webpack_require__(62);
	var ARRAY_ITERATOR = 'Array Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
	
	// `Array.prototype.entries` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.entries
	// `Array.prototype.keys` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.keys
	// `Array.prototype.values` method
	// https://tc39.github.io/ecma262/#sec-array.prototype.values
	// `Array.prototype[@@iterator]` method
	// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
	// `CreateArrayIterator` internal method
	// https://tc39.github.io/ecma262/#sec-createarrayiterator
	module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
	  setInternalState(this, {
	    type: ARRAY_ITERATOR,
	    target: toIndexedObject(iterated), // target
	    index: 0,                          // next index
	    kind: kind                         // kind
	  });
	// `%ArrayIteratorPrototype%.next` method
	// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
	}, function () {
	  var state = getInternalState(this);
	  var target = state.target;
	  var kind = state.kind;
	  var index = state.index++;
	  if (!target || index >= target.length) {
	    state.target = undefined;
	    return { value: undefined, done: true };
	  }
	  if (kind == 'keys') return { value: index, done: false };
	  if (kind == 'values') return { value: target[index], done: false };
	  return { value: [index, target[index]], done: false };
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values%
	// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
	// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
	Iterators.Arguments = Iterators.Array;
	
	// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');
	
	
	/***/ }),
	/* 129 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var PROMISE = 'Promise';
	var IS_PURE = __webpack_require__(21);
	var global = __webpack_require__(0);
	var $export = __webpack_require__(12);
	var isObject = __webpack_require__(5);
	var aFunction = __webpack_require__(23);
	var anInstance = __webpack_require__(130);
	var classof = __webpack_require__(11);
	var iterate = __webpack_require__(131);
	var checkCorrectnessOfIteration = __webpack_require__(135);
	var speciesConstructor = __webpack_require__(65);
	var task = __webpack_require__(66).set;
	var microtask = __webpack_require__(136);
	var promiseResolve = __webpack_require__(68);
	var hostReportErrors = __webpack_require__(137);
	var newPromiseCapabilityModule = __webpack_require__(69);
	var perform = __webpack_require__(138);
	var userAgent = __webpack_require__(67);
	var SPECIES = __webpack_require__(1)('species');
	var InternalStateModule = __webpack_require__(22);
	var isForced = __webpack_require__(57);
	var getInternalState = InternalStateModule.get;
	var setInternalState = InternalStateModule.set;
	var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
	var PromiseConstructor = global[PROMISE];
	var TypeError = global.TypeError;
	var document = global.document;
	var process = global.process;
	var $fetch = global.fetch;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var newPromiseCapability = newPromiseCapabilityModule.f;
	var newGenericPromiseCapability = newPromiseCapability;
	var IS_NODE = classof(process) == 'process';
	var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
	var UNHANDLED_REJECTION = 'unhandledrejection';
	var REJECTION_HANDLED = 'rejectionhandled';
	var PENDING = 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	var HANDLED = 1;
	var UNHANDLED = 2;
	var Internal, OwnPromiseCapability, PromiseWrapper;
	
	var FORCED = isForced(PROMISE, function () {
	  // correct subclassing with @@species support
	  var promise = PromiseConstructor.resolve(1);
	  var empty = function () { /* empty */ };
	  var FakePromise = (promise.constructor = {})[SPECIES] = function (exec) {
	    exec(empty, empty);
	  };
	  // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	  return !((IS_NODE || typeof PromiseRejectionEvent == 'function')
	    && (!IS_PURE || promise['finally'])
	    && promise.then(empty) instanceof FakePromise
	    // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	    // we can't detect it synchronously, so just check versions
	    && v8.indexOf('6.6') !== 0
	    && userAgent.indexOf('Chrome/66') === -1);
	});
	
	var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
	  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
	});
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	
	var notify = function (promise, state, isReject) {
	  if (state.notified) return;
	  state.notified = true;
	  var chain = state.reactions;
	  microtask(function () {
	    var value = state.value;
	    var ok = state.state == FULFILLED;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
	            state.rejection = HANDLED;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (error) {
	        if (domain && !exited) domain.exit();
	        reject(error);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    state.reactions = [];
	    state.notified = false;
	    if (isReject && !state.rejection) onUnhandled(promise, state);
	  });
	};
	
	var dispatchEvent = function (name, promise, reason) {
	  var event, handler;
	  if (DISPATCH_EVENT) {
	    event = document.createEvent('Event');
	    event.promise = promise;
	    event.reason = reason;
	    event.initEvent(name, false, true);
	    global.dispatchEvent(event);
	  } else event = { promise: promise, reason: reason };
	  if (handler = global['on' + name]) handler(event);
	  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
	};
	
	var onUnhandled = function (promise, state) {
	  task.call(global, function () {
	    var value = state.value;
	    var IS_UNHANDLED = isUnhandled(state);
	    var result;
	    if (IS_UNHANDLED) {
	      result = perform(function () {
	        if (IS_NODE) {
	          process.emit('unhandledRejection', value, promise);
	        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
	      if (result.error) throw result.value;
	    }
	  });
	};
	
	var isUnhandled = function (state) {
	  return state.rejection !== HANDLED && !state.parent;
	};
	
	var onHandleUnhandled = function (promise, state) {
	  task.call(global, function () {
	    if (IS_NODE) {
	      process.emit('rejectionHandled', promise);
	    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
	  });
	};
	
	var bind = function (fn, promise, state, unwrap) {
	  return function (value) {
	    fn(promise, state, value, unwrap);
	  };
	};
	
	var internalReject = function (promise, state, value, unwrap) {
	  if (state.done) return;
	  state.done = true;
	  if (unwrap) state = unwrap;
	  state.value = value;
	  state.state = REJECTED;
	  notify(promise, state, true);
	};
	
	var internalResolve = function (promise, state, value, unwrap) {
	  if (state.done) return;
	  state.done = true;
	  if (unwrap) state = unwrap;
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    var then = isThenable(value);
	    if (then) {
	      microtask(function () {
	        var wrapper = { done: false };
	        try {
	          then.call(value,
	            bind(internalResolve, promise, wrapper, state),
	            bind(internalReject, promise, wrapper, state)
	          );
	        } catch (error) {
	          internalReject(promise, wrapper, error, state);
	        }
	      });
	    } else {
	      state.value = value;
	      state.state = FULFILLED;
	      notify(promise, state, false);
	    }
	  } catch (error) {
	    internalReject(promise, { done: false }, error, state);
	  }
	};
	
	// constructor polyfill
	if (FORCED) {
	  // 25.4.3.1 Promise(executor)
	  PromiseConstructor = function Promise(executor) {
	    anInstance(this, PromiseConstructor, PROMISE);
	    aFunction(executor);
	    Internal.call(this);
	    var state = getInternalState(this);
	    try {
	      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
	    } catch (error) {
	      internalReject(this, state, error);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    setInternalState(this, {
	      type: PROMISE,
	      done: false,
	      notified: false,
	      parent: false,
	      reactions: [],
	      rejection: false,
	      state: PENDING,
	      value: undefined
	    });
	  };
	  Internal.prototype = __webpack_require__(139)(PromiseConstructor.prototype, {
	    // `Promise.prototype.then` method
	    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
	    then: function then(onFulfilled, onRejected) {
	      var state = getInternalPromiseState(this);
	      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = IS_NODE ? process.domain : undefined;
	      state.parent = true;
	      state.reactions.push(reaction);
	      if (state.state != PENDING) notify(this, state, false);
	      return reaction.promise;
	    },
	    // `Promise.prototype.catch` method
	    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    var state = getInternalState(promise);
	    this.promise = promise;
	    this.resolve = bind(internalResolve, promise, state);
	    this.reject = bind(internalReject, promise, state);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === PromiseConstructor || C === PromiseWrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	
	  // wrap fetch result
	  if (!IS_PURE && typeof $fetch == 'function') $export({ global: true, enumerable: true, forced: true }, {
	    // eslint-disable-next-line no-unused-vars
	    fetch: function fetch(input) {
	      return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
	    }
	  });
	}
	
	$export({ global: true, wrap: true, forced: FORCED }, { Promise: PromiseConstructor });
	
	__webpack_require__(40)(PromiseConstructor, PROMISE, false, true);
	__webpack_require__(140)(PROMISE);
	
	PromiseWrapper = __webpack_require__(41)[PROMISE];
	
	// statics
	$export({ target: PROMISE, stat: true, forced: FORCED }, {
	  // `Promise.reject` method
	  // https://tc39.github.io/ecma262/#sec-promise.reject
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    capability.reject.call(undefined, r);
	    return capability.promise;
	  }
	});
	
	$export({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
	  // `Promise.resolve` method
	  // https://tc39.github.io/ecma262/#sec-promise.resolve
	  resolve: function resolve(x) {
	    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
	  }
	});
	
	$export({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
	  // `Promise.all` method
	  // https://tc39.github.io/ecma262/#sec-promise.all
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var counter = 0;
	      var remaining = 1;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  },
	  // `Promise.race` method
	  // https://tc39.github.io/ecma262/#sec-promise.race
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      iterate(iterable, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});
	
	
	/***/ }),
	/* 130 */
	/***/ (function(module, exports) {
	
	module.exports = function (it, Constructor, name) {
	  if (!(it instanceof Constructor)) {
	    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
	  } return it;
	};
	
	
	/***/ }),
	/* 131 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var anObject = __webpack_require__(6);
	var isArrayIteratorMethod = __webpack_require__(132);
	var toLength = __webpack_require__(29);
	var bind = __webpack_require__(39);
	var getIteratorMethod = __webpack_require__(133);
	var callWithSafeIterationClosing = __webpack_require__(134);
	var BREAK = {};
	
	var exports = module.exports = function (iterable, fn, that, ENTRIES, ITERATOR) {
	  var boundFunction = bind(fn, that, ENTRIES ? 2 : 1);
	  var iterator, iterFn, index, length, result, step;
	
	  if (ITERATOR) {
	    iterator = iterable;
	  } else {
	    iterFn = getIteratorMethod(iterable);
	    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
	    // optimisation for array iterators
	    if (isArrayIteratorMethod(iterFn)) {
	      for (index = 0, length = toLength(iterable.length); length > index; index++) {
	        result = ENTRIES ? boundFunction(anObject(step = iterable[index])[0], step[1]) : boundFunction(iterable[index]);
	        if (result === BREAK) return BREAK;
	      } return;
	    }
	    iterator = iterFn.call(iterable);
	  }
	
	  while (!(step = iterator.next()).done) {
	    if (callWithSafeIterationClosing(iterator, boundFunction, step.value, ENTRIES) === BREAK) return BREAK;
	  }
	};
	
	exports.BREAK = BREAK;
	
	
	/***/ }),
	/* 132 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// check on default Array iterator
	var Iterators = __webpack_require__(15);
	var ITERATOR = __webpack_require__(1)('iterator');
	var ArrayPrototype = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
	};
	
	
	/***/ }),
	/* 133 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var classof = __webpack_require__(61);
	var ITERATOR = __webpack_require__(1)('iterator');
	var Iterators = __webpack_require__(15);
	
	module.exports = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};
	
	
	/***/ }),
	/* 134 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var anObject = __webpack_require__(6);
	
	// call something on iterator step with safe closing on error
	module.exports = function (iterator, fn, value, ENTRIES) {
	  try {
	    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (error) {
	    var returnMethod = iterator['return'];
	    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
	    throw error;
	  }
	};
	
	
	/***/ }),
	/* 135 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var ITERATOR = __webpack_require__(1)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var called = 0;
	  var iteratorWithReturn = {
	    next: function () {
	      return { done: !!called++ };
	    },
	    'return': function () {
	      SAFE_CLOSING = true;
	    }
	  };
	  iteratorWithReturn[ITERATOR] = function () {
	    return this;
	  };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(iteratorWithReturn, function () { throw 2; });
	} catch (error) { /* empty */ }
	
	module.exports = function (exec, SKIP_CLOSING) {
	  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
	  var ITERATION_SUPPORT = false;
	  try {
	    var object = {};
	    object[ITERATOR] = function () {
	      return {
	        next: function () {
	          return { done: ITERATION_SUPPORT = true };
	        }
	      };
	    };
	    exec(object);
	  } catch (error) { /* empty */ }
	  return ITERATION_SUPPORT;
	};
	
	
	/***/ }),
	/* 136 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(0);
	var getOwnPropertyDescriptor = __webpack_require__(34).f;
	var classof = __webpack_require__(11);
	var macrotask = __webpack_require__(66).set;
	var userAgent = __webpack_require__(67);
	var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var IS_NODE = classof(process) == 'process';
	// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
	var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
	var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
	
	var flush, head, last, notify, toggle, node, promise;
	
	// modern engines have queueMicrotask method
	if (!queueMicrotask) {
	  flush = function () {
	    var parent, fn;
	    if (IS_NODE && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (error) {
	        if (head) notify();
	        else last = undefined;
	        throw error;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (IS_NODE) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
	  } else if (MutationObserver && !/(iPhone|iPod|iPad).*AppleWebKit/i.test(userAgent)) {
	    toggle = true;
	    node = document.createTextNode('');
	    new MutationObserver(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	}
	
	module.exports = queueMicrotask || function (fn) {
	  var task = { fn: fn, next: undefined };
	  if (last) last.next = task;
	  if (!head) {
	    head = task;
	    notify();
	  } last = task;
	};
	
	
	/***/ }),
	/* 137 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(0);
	
	module.exports = function (a, b) {
	  var console = global.console;
	  if (console && console.error) {
	    arguments.length === 1 ? console.error(a) : console.error(a, b);
	  }
	};
	
	
	/***/ }),
	/* 138 */
	/***/ (function(module, exports) {
	
	module.exports = function (exec) {
	  try {
	    return { error: false, value: exec() };
	  } catch (error) {
	    return { error: true, value: error };
	  }
	};
	
	
	/***/ }),
	/* 139 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var redefine = __webpack_require__(19);
	
	module.exports = function (target, src, options) {
	  for (var key in src) redefine(target, key, src[key], options);
	  return target;
	};
	
	
	/***/ }),
	/* 140 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var getBuiltIn = __webpack_require__(70);
	var definePropertyModule = __webpack_require__(14);
	var DESCRIPTORS = __webpack_require__(13);
	var SPECIES = __webpack_require__(1)('species');
	
	module.exports = function (CONSTRUCTOR_NAME) {
	  var C = getBuiltIn(CONSTRUCTOR_NAME);
	  var defineProperty = definePropertyModule.f;
	  if (DESCRIPTORS && C && !C[SPECIES]) defineProperty(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};
	
	
	/***/ }),
	/* 141 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var getBuiltIn = __webpack_require__(70);
	var speciesConstructor = __webpack_require__(65);
	var promiseResolve = __webpack_require__(68);
	
	// `Promise.prototype.finally` method
	// https://tc39.github.io/ecma262/#sec-promise.prototype.finally
	__webpack_require__(12)({ target: 'Promise', proto: true, real: true }, {
	  'finally': function (onFinally) {
	    var C = speciesConstructor(this, getBuiltIn('Promise'));
	    var isFunction = typeof onFinally == 'function';
	    return this.then(
	      isFunction ? function (x) {
	        return promiseResolve(C, onFinally()).then(function () { return x; });
	      } : onFinally,
	      isFunction ? function (e) {
	        return promiseResolve(C, onFinally()).then(function () { throw e; });
	      } : onFinally
	    );
	  }
	});
	
	
	/***/ })
	/******/ ]);

/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(200);
	var getPolyfill = __webpack_require__(843);
	
	module.exports = function shimArrayPrototypeIncludes() {
		var polyfill = getPolyfill();
		define(
			Array.prototype,
			{ includes: polyfill },
			{ includes: function () { return Array.prototype.includes !== polyfill; } }
		);
		return polyfill;
	};


/***/ },
/* 1823 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (arr) {
		if (!Array.isArray(arr)) {
			throw new TypeError('Expected Array, got ' + typeof arr);
		}
	
		var rand;
		var tmp;
		var len = arr.length;
		var ret = arr.slice();
	
		while (len) {
			rand = Math.floor(Math.random() * len--);
			tmp = ret[len];
			ret[len] = ret[rand];
			ret[rand] = tmp;
		}
	
		return ret;
	};


/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(1827);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1825 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 1826 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 1827 */
[4181, 1826, 1825],
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(845);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    comma: false,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    ignoreQueryPrefix: false,
	    interpretNumericEntities: false,
	    parameterLimit: 1000,
	    parseArrays: true,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var interpretNumericEntities = function (str) {
	    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
	        return String.fromCharCode(parseInt(numberStr, 10));
	    });
	};
	
	var parseArrayValue = function (val, options) {
	    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
	        return val.split(',');
	    }
	
	    return val;
	};
	
	// This is what browsers will submit when the ✓ character occurs in an
	// application/x-www-form-urlencoded body and the encoding of the page containing
	// the form is iso-8859-1, or when the submitted form has an accept-charset
	// attribute of iso-8859-1. Presumably also with other charsets that do not contain
	// the ✓ character, such as us-ascii.
	var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
	
	// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
	var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
	    var i;
	
	    var charset = options.charset;
	    if (options.charsetSentinel) {
	        for (i = 0; i < parts.length; ++i) {
	            if (parts[i].indexOf('utf8=') === 0) {
	                if (parts[i] === charsetSentinel) {
	                    charset = 'utf-8';
	                } else if (parts[i] === isoSentinel) {
	                    charset = 'iso-8859-1';
	                }
	                skipIndex = i;
	                i = parts.length; // The eslint settings do not allow break;
	            }
	        }
	    }
	
	    for (i = 0; i < parts.length; ++i) {
	        if (i === skipIndex) {
	            continue;
	        }
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder, charset, 'key');
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
	            val = utils.maybeMap(
	                parseArrayValue(part.slice(pos + 1), options),
	                function (encodedVal) {
	                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
	                }
	            );
	        }
	
	        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
	            val = interpretNumericEntities(val);
	        }
	
	        if (part.indexOf('[]=') > -1) {
	            val = isArray(val) ? [val] : val;
	        }
	
	        if (has.call(obj, key)) {
	            obj[key] = utils.combine(obj[key], val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options, valuesParsed) {
	    var leaf = valuesParsed ? val : parseArrayValue(val, options);
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]' && options.parseArrays) {
	            obj = [].concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (!options.parseArrays && cleanRoot === '') {
	                obj = { 0: leaf };
	            } else if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = options.depth > 0 && brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options, valuesParsed);
	};
	
	var normalizeParseOptions = function normalizeParseOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
	
	    return {
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
	        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
	        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
	        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
	        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
	        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
	        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
	        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
	        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
	        parseArrays: opts.parseArrays !== false,
	        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (str, opts) {
	    var options = normalizeParseOptions(opts);
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(845);
	var formats = __webpack_require__(530);
	var has = Object.prototype.hasOwnProperty;
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    comma: 'comma',
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaultFormat = formats['default'];
	var defaults = {
	    addQueryPrefix: false,
	    allowDots: false,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    format: defaultFormat,
	    formatter: formats.formatters[defaultFormat],
	    // deprecated
	    indices: false,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
	    return typeof v === 'string'
	        || typeof v === 'number'
	        || typeof v === 'boolean'
	        || typeof v === 'symbol'
	        || typeof v === 'bigint';
	};
	
	var stringify = function stringify(
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    format,
	    formatter,
	    encodeValuesOnly,
	    charset
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        obj = utils.maybeMap(obj, function (value) {
	            if (value instanceof Date) {
	                return serializeDate(value);
	            }
	            return value;
	        });
	    }
	
	    if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        // we need to join elements in
	        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : undefined }];
	    } else if (isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	        var value = typeof key === 'object' && key.value !== undefined ? key.value : obj[key];
	
	        if (skipNulls && value === null) {
	            continue;
	        }
	
	        var keyPrefix = isArray(obj)
	            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
	            : prefix + (allowDots ? '.' + key : '[' + key + ']');
	
	        pushToArray(values, stringify(
	            value,
	            keyPrefix,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encoder,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            format,
	            formatter,
	            encodeValuesOnly,
	            charset
	        ));
	    }
	
	    return values;
	};
	
	var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var charset = opts.charset || defaults.charset;
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	
	    var format = formats['default'];
	    if (typeof opts.format !== 'undefined') {
	        if (!has.call(formats.formatters, opts.format)) {
	            throw new TypeError('Unknown format option provided.');
	        }
	        format = opts.format;
	    }
	    var formatter = formats.formatters[format];
	
	    var filter = defaults.filter;
	    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
	        filter = opts.filter;
	    }
	
	    return {
	        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
	        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
	        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
	        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
	        filter: filter,
	        format: format,
	        formatter: formatter,
	        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
	        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
	        sort: typeof opts.sort === 'function' ? opts.sort : null,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = normalizeStringifyOptions(opts);
	
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = opts.arrayFormat;
	    } else if (opts && 'indices' in opts) {
	        arrayFormat = opts.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (options.sort) {
	        objKeys.sort(options.sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (options.skipNulls && obj[key] === null) {
	            continue;
	        }
	        pushToArray(keys, stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            options.strictNullHandling,
	            options.skipNulls,
	            options.encode ? options.encoder : null,
	            options.filter,
	            options.sort,
	            options.allowDots,
	            options.serializeDate,
	            options.format,
	            options.formatter,
	            options.encodeValuesOnly,
	            options.charset
	        ));
	    }
	
	    var joined = keys.join(options.delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    if (options.charsetSentinel) {
	        if (options.charset === 'iso-8859-1') {
	            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
	            prefix += 'utf8=%26%2310003%3B&';
	        } else {
	            // encodeURIComponent('✓')
	            prefix += 'utf8=%E2%9C%93&';
	        }
	    }
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ },
/* 1830 */
/***/ function(module, exports) {

	function Agent() {
	  this._defaults = [];
	}
	
	["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
	 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
	  /** Default setting for all requests from this agent */
	  Agent.prototype[fn] = function(/*varargs*/) {
	    this._defaults.push({fn:fn, arguments:arguments});
	    return this;
	  }
	});
	
	Agent.prototype._setDefaults = function(req) {
	    this._defaults.forEach(function(def) {
	      req[def.fn].apply(req, def.arguments);
	    });
	};
	
	module.exports = Agent;


/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(576);
	var RequestBase = __webpack_require__(1832);
	var isObject = __webpack_require__(846);
	var ResponseBase = __webpack_require__(1833);
	var Agent = __webpack_require__(1830);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = exports = module.exports = function(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new exports.Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new exports.Request('GET', method);
	  }
	
	  return new exports.Request(method, url);
	}
	
	exports.Request = Request;
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only version of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	request.serializeObject = serialize;
	
	/**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'text/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	request.serialize = {
	  'application/x-www-form-urlencoded': serialize,
	  'application/json': JSON.stringify
	};
	
	/**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    if (index === -1) { // could be empty line, just skip it
	      continue;
	    }
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  // should match /json or +json
	  // but not /json-seq
	  return /[\/+]json($|[^-\w])/.test(mime);
	}
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req) {
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  var status = this.xhr.status;
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	  this._setStatusProperties(status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	
	  if (null === this.text && req._responseType) {
	    this.body = this.xhr.response;
	  } else {
	    this.body = this.req.method != 'HEAD'
	      ? this._parseBody(this.text ? this.text : this.xhr.response)
	      : null;
	  }
	}
	
	ResponseBase(Response.prototype);
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str) {
	  var parse = request.parse[this.type];
	  if (this.req._parser) {
	    return this.req._parser(this, str);
	  }
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      if (self.xhr) {
	        // ie9 doesn't have 'response' property
	        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
	        // issue #876: return the http status code if the response parsing fails
	        err.status = self.xhr.status ? self.xhr.status : null;
	        err.statusCode = err.status; // backwards-compat only
	      } else {
	        err.rawResponse = null;
	        err.status = null;
	      }
	
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (!self._isResponseOK(res)) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	      }
	    } catch(custom_err) {
	      new_err = custom_err; // ok() callback can throw
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      new_err.original = err;
	      new_err.response = res;
	      new_err.status = res.status;
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `RequestBase`.
	 */
	
	Emitter(Request.prototype);
	RequestBase(Request.prototype);
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} [pass] optional in case of using 'bearer' as type
	 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (1 === arguments.length) pass = '';
	  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
	    options = pass;
	    pass = '';
	  }
	  if (!options) {
	    options = {
	      type: 'function' === typeof btoa ? 'basic' : 'auto',
	    };
	  }
	
	  var encoder = function(string) {
	    if ('function' === typeof btoa) {
	      return btoa(string);
	    }
	    throw new Error('Cannot use basic auth, btoa is not a function');
	  };
	
	  return this._auth(user, pass, options, encoder);
	};
	
	/**
	 * Add query-string `val`.
	 *
	 * Examples:
	 *
	 *   request.get('/shoes')
	 *     .query('size=10')
	 *     .query({ color: 'blue' })
	 *
	 * @param {Object|String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `options` (or filename).
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String|Object} options
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, options){
	  if (file) {
	    if (this._data) {
	      throw Error("superagent can't mix .send() and .attach()");
	    }
	
	    this._getFormData().append(field, file, options || file.name);
	  }
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  if (this._shouldRetry(err, res)) {
	    return this._retry();
	  }
	
	  var fn = this._callback;
	  this.clearTimeout();
	
	  if (err) {
	    if (this._maxRetries) err.retries = this._retries - 1;
	    this.emit('error', err);
	  }
	
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	// This only warns, because the request is still likely to work
	Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
	  console.warn("This is not supported in browser version of superagent");
	  return this;
	};
	
	// This throws, because it can't send/receive data as expected
	Request.prototype.pipe = Request.prototype.write = function(){
	  throw Error("Streaming is not supported in browser version of superagent");
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	Request.prototype._isHost = function _isHost(obj) {
	  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
	  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
	}
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  if (this._endCalled) {
	    console.warn("Warning: .end() was called twice. This is not supported in superagent");
	  }
	  this._endCalled = true;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // querystring
	  this._finalizeQueryString();
	
	  return this._end();
	};
	
	Request.prototype._end = function() {
	  var self = this;
	  var xhr = (this.xhr = request.getXHR());
	  var data = this._formData || this._data;
	
	  this._setTimeouts();
	
	  // state change
	  xhr.onreadystatechange = function(){
	    var readyState = xhr.readyState;
	    if (readyState >= 2 && self._responseTimeoutTimer) {
	      clearTimeout(self._responseTimeoutTimer);
	    }
	    if (4 != readyState) {
	      return;
	    }
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (!status) {
	      if (self.timedout || self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(direction, e) {
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = direction;
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    try {
	      xhr.onprogress = handleProgress.bind(null, 'download');
	      if (xhr.upload) {
	        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
	      }
	    } catch(e) {
	      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	      // Reported here:
	      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	    }
	  }
	
	  // initiate request
	  try {
	    if (this.username && this.password) {
	      xhr.open(this.method, this.url, true, this.username, this.password);
	    } else {
	      xhr.open(this.method, this.url, true);
	    }
	  } catch (err) {
	    // see #1149
	    return this.callback(err);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) {
	      serialize = request.serialize['application/json'];
	    }
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	
	    if (this.header.hasOwnProperty(field))
	      xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	request.agent = function() {
	  return new Agent();
	};
	
	["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
	  Agent.prototype[method.toLowerCase()] = function(url, fn) {
	    var req = new request.Request(method, url);
	    this._setDefaults(req);
	    if (fn) {
	      req.end(fn);
	    }
	    return req;
	  };
	});
	
	Agent.prototype.del = Agent.prototype['delete'];
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn) {
	  var req = request('GET', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn) {
	  var req = request('HEAD', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn) {
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, data, fn) {
	  var req = request('DELETE', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	}
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn) {
	  var req = request('PATCH', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn) {
	  var req = request('POST', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn) {
	  var req = request('PUT', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(846);
	
	/**
	 * Expose `RequestBase`.
	 */
	
	module.exports = RequestBase;
	
	/**
	 * Initialize a new `RequestBase`.
	 *
	 * @api public
	 */
	
	function RequestBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in RequestBase.prototype) {
	    obj[key] = RequestBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.clearTimeout = function _clearTimeout(){
	  clearTimeout(this._timer);
	  clearTimeout(this._responseTimeoutTimer);
	  delete this._timer;
	  delete this._responseTimeoutTimer;
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set format of binary response body.
	 * In browser valid formats are 'blob' and 'arraybuffer',
	 * which return Blob and ArrayBuffer, respectively.
	 *
	 * In Node all values result in Buffer.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeouts.
	 *
	 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
	 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
	 *
	 * Value of 0 or false means no timeout.
	 *
	 * @param {Number|Object} ms or {response, deadline}
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.timeout = function timeout(options){
	  if (!options || 'object' !== typeof options) {
	    this._timeout = options;
	    this._responseTimeout = 0;
	    return this;
	  }
	
	  for(var option in options) {
	    switch(option) {
	      case 'deadline':
	        this._timeout = options.deadline;
	        break;
	      case 'response':
	        this._responseTimeout = options.response;
	        break;
	      default:
	        console.warn("Unknown timeout option", option);
	    }
	  }
	  return this;
	};
	
	/**
	 * Set number of retry attempts on error.
	 *
	 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
	 *
	 * @param {Number} count
	 * @param {Function} [fn]
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.retry = function retry(count, fn){
	  // Default to 1 if no count passed or true
	  if (arguments.length === 0 || count === true) count = 1;
	  if (count <= 0) count = 0;
	  this._maxRetries = count;
	  this._retries = 0;
	  this._retryCallback = fn;
	  return this;
	};
	
	var ERROR_CODES = [
	  'ECONNRESET',
	  'ETIMEDOUT',
	  'EADDRINFO',
	  'ESOCKETTIMEDOUT'
	];
	
	/**
	 * Determine if a request should be retried.
	 * (Borrowed from segmentio/superagent-retry)
	 *
	 * @param {Error} err
	 * @param {Response} [res]
	 * @returns {Boolean}
	 */
	RequestBase.prototype._shouldRetry = function(err, res) {
	  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
	    return false;
	  }
	  if (this._retryCallback) {
	    try {
	      var override = this._retryCallback(err, res);
	      if (override === true) return true;
	      if (override === false) return false;
	      // undefined falls back to defaults
	    } catch(e) {
	      console.error(e);
	    }
	  }
	  if (res && res.status && res.status >= 500 && res.status != 501) return true;
	  if (err) {
	    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
	    // Superagent timeout
	    if (err.timeout && err.code == 'ECONNABORTED') return true;
	    if (err.crossDomain) return true;
	  }
	  return false;
	};
	
	/**
	 * Retry request
	 *
	 * @return {Request} for chaining
	 * @api private
	 */
	
	RequestBase.prototype._retry = function() {
	
	  this.clearTimeout();
	
	  // node
	  if (this.req) {
	    this.req = null;
	    this.req = this.request();
	  }
	
	  this._aborted = false;
	  this.timedout = false;
	
	  return this._end();
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} [reject]
	 * @return {Request}
	 */
	
	RequestBase.prototype.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    if (this._endCalled) {
	      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
	    }
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
	      self.end(function(err, res) {
	        if (err) innerReject(err);
	        else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	};
	
	RequestBase.prototype['catch'] = function(cb) {
	  return this.then(undefined, cb);
	};
	
	/**
	 * Allow for extension
	 */
	
	RequestBase.prototype.use = function use(fn) {
	  fn(this);
	  return this;
	};
	
	RequestBase.prototype.ok = function(cb) {
	  if ('function' !== typeof cb) throw Error("Callback required");
	  this._okCallback = cb;
	  return this;
	};
	
	RequestBase.prototype._isResponseOK = function(res) {
	  if (!res) {
	    return false;
	  }
	
	  if (this._okCallback) {
	    return this._okCallback(res);
	  }
	
	  return res.status >= 200 && res.status < 300;
	};
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	RequestBase.prototype.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	RequestBase.prototype.getHeader = RequestBase.prototype.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	RequestBase.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val`, or multiple fields with one object
	 * for "multipart/form-data" request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 *
	 * request.post('/upload')
	 *   .field({ foo: 'bar', baz: 'qux' })
	 *   .end(callback);
	 * ```
	 *
	 * @param {String|Object} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	RequestBase.prototype.field = function(name, val) {
	  // name should be either a string or an object.
	  if (null === name || undefined === name) {
	    throw new Error('.field(name, val) name can not be empty');
	  }
	
	  if (this._data) {
	    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObject(name)) {
	    for (var key in name) {
	      this.field(key, name[key]);
	    }
	    return this;
	  }
	
	  if (Array.isArray(val)) {
	    for (var i in val) {
	      this.field(name, val[i]);
	    }
	    return this;
	  }
	
	  // val should be defined now
	  if (null === val || undefined === val) {
	    throw new Error('.field(name, val) val can not be empty');
	  }
	  if ('boolean' === typeof val) {
	    val = '' + val;
	  }
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	RequestBase.prototype.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
	  switch (options.type) {
	    case 'basic':
	      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
	      break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	      break;
	
	    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
	      this.set('Authorization', 'Bearer ' + user);
	      break;
	  }
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	RequestBase.prototype.withCredentials = function(on) {
	  // This is browser-only functionality. Node side is no-op.
	  if (on == undefined) on = true;
	  this._withCredentials = on;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
	 * Default 200MB.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 */
	RequestBase.prototype.maxResponseSize = function(n){
	  if ('number' !== typeof n) {
	    throw TypeError("Invalid argument");
	  }
	  this._maxResponseSize = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	RequestBase.prototype.toJSON = function() {
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header,
	  };
	};
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.send = function(data){
	  var isObj = isObject(data);
	  var type = this._header['content-type'];
	
	  if (this._formData) {
	    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObj && !this._data) {
	    if (Array.isArray(data)) {
	      this._data = [];
	    } else if (!this._isHost(data)) {
	      this._data = {};
	    }
	  } else if (data && this._data && this._isHost(this._data)) {
	    throw Error("Can't merge these send calls");
	  }
	
	  // merge
	  if (isObj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!isObj || this._isHost(data)) {
	    return this;
	  }
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * Sort `querystring` by the sort function
	 *
	 *
	 * Examples:
	 *
	 *       // default order
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery()
	 *         .end(callback)
	 *
	 *       // customized sort function
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery(function(a, b){
	 *           return a.length - b.length;
	 *         })
	 *         .end(callback)
	 *
	 *
	 * @param {Function} sort
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.sortQuery = function(sort) {
	  // _sort default to true but otherwise can be a function or boolean
	  this._sort = typeof sort === 'undefined' ? true : sort;
	  return this;
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	RequestBase.prototype._finalizeQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
	  }
	  this._query.length = 0; // Makes the call idempotent
	
	  if (this._sort) {
	    var index = this.url.indexOf('?');
	    if (index >= 0) {
	      var queryArr = this.url.substring(index + 1).split('&');
	      if ('function' === typeof this._sort) {
	        queryArr.sort(this._sort);
	      } else {
	        queryArr.sort();
	      }
	      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
	    }
	  }
	};
	
	// For backwards compat only
	RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	RequestBase.prototype._timeoutError = function(reason, timeout, errno){
	  if (this._aborted) {
	    return;
	  }
	  var err = new Error(reason + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  err.code = 'ECONNABORTED';
	  err.errno = errno;
	  this.timedout = true;
	  this.abort();
	  this.callback(err);
	};
	
	RequestBase.prototype._setTimeouts = function() {
	  var self = this;
	
	  // deadline
	  if (this._timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
	    }, this._timeout);
	  }
	  // response timeout
	  if (this._responseTimeout && !this._responseTimeoutTimer) {
	    this._responseTimeoutTimer = setTimeout(function(){
	      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
	    }, this._responseTimeout);
	  }
	};


/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	
	var utils = __webpack_require__(1834);
	
	/**
	 * Expose `ResponseBase`.
	 */
	
	module.exports = ResponseBase;
	
	/**
	 * Initialize a new `ResponseBase`.
	 *
	 * @api public
	 */
	
	function ResponseBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in ResponseBase.prototype) {
	    obj[key] = ResponseBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	ResponseBase.prototype.get = function(field) {
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	ResponseBase.prototype._setHeaderProperties = function(header){
	    // TODO: moar!
	    // TODO: make this a util
	
	    // content-type
	    var ct = header['content-type'] || '';
	    this.type = utils.type(ct);
	
	    // params
	    var params = utils.params(ct);
	    for (var key in params) this[key] = params[key];
	
	    this.links = {};
	
	    // links
	    try {
	        if (header.link) {
	            this.links = utils.parseLinks(header.link);
	        }
	    } catch (err) {
	        // ignore
	    }
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	ResponseBase.prototype._setStatusProperties = function(status){
	    var type = status / 100 | 0;
	
	    // status / class
	    this.status = this.statusCode = status;
	    this.statusType = type;
	
	    // basics
	    this.info = 1 == type;
	    this.ok = 2 == type;
	    this.redirect = 3 == type;
	    this.clientError = 4 == type;
	    this.serverError = 5 == type;
	    this.error = (4 == type || 5 == type)
	        ? this.toError()
	        : false;
	
	    // sugar
	    this.created = 201 == status;
	    this.accepted = 202 == status;
	    this.noContent = 204 == status;
	    this.badRequest = 400 == status;
	    this.unauthorized = 401 == status;
	    this.notAcceptable = 406 == status;
	    this.forbidden = 403 == status;
	    this.notFound = 404 == status;
	    this.unprocessableEntity = 422 == status;
	};


/***/ },
/* 1834 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	exports.type = function(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.params = function(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */);
	    var key = parts.shift();
	    var val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Parse Link header fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.parseLinks = function(str){
	  return str.split(/ *, */).reduce(function(obj, str){
	    var parts = str.split(/ *; */);
	    var url = parts[0].slice(1, -1);
	    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
	    obj[rel] = url;
	    return obj;
	  }, {});
	};
	
	/**
	 * Strip content related fields from `header`.
	 *
	 * @param {Object} header
	 * @return {Object} header
	 * @api private
	 */
	
	exports.cleanHeader = function(header, changesOrigin){
	  delete header['content-type'];
	  delete header['content-length'];
	  delete header['transfer-encoding'];
	  delete header['host'];
	  // secuirty
	  if (changesOrigin) {
	    delete header['authorization'];
	    delete header['cookie'];
	  }
	  return header;
	};


/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(190);
	
	var objectHelper = __webpack_require__(85);
	var assert = __webpack_require__(166);
	var responseHandler = __webpack_require__(167);
	
	function DBConnection(request, options) {
	  this.baseOptions = options;
	  this.request = request;
	}
	
	/**
	 * @callback signUpCallback
	 * @param {Error} [err] error returned by Auth0 with the reason why the signup failed
	 * @param {Object} [result] result of the signup request
	 * @param {Object} result.email user's email
	 * @param {Object} result.emailVerified if the user's email was verified
	 */
	
	/**
	 * Creates a new user in a Auth0 Database connection
	 *
	 * @method signup
	 * @param {Object} options
	 * @param {String} options.email user email address
	 * @param {String} options.password user password
	 * @param {String} options.connection name of the connection where the user will be created
	 * @param {Object} [options.userMetadata] additional signup attributes used for creating the user. Will be stored in `user_metadata`
	 * @param {signUpCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#signup}
	 */
	DBConnection.prototype.signup = function(options, cb) {
	  var url;
	  var body;
	  var metadata;
	
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      connection: { type: 'string', message: 'connection option is required' },
	      email: { type: 'string', message: 'email option is required' },
	      password: { type: 'string', message: 'password option is required' }
	    }
	  );
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'dbconnections', 'signup');
	
	  body = objectHelper.merge(this.baseOptions, ['clientID']).with(options);
	
	  metadata = body.user_metadata || body.userMetadata;
	
	  body = objectHelper.blacklist(body, ['scope', 'userMetadata', 'user_metadata']);
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client']);
	
	  if (metadata) {
	    body.user_metadata = metadata;
	  }
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	/**
	 * @callback changePasswordCallback
	 * @param {Error} [err] error returned by Auth0 with the reason why the request failed
	 */
	
	/**
	 * Request an email with instruction to change a user's password
	 *
	 * @method changePassword
	 * @param {Object} options
	 * @param {String} options.email address where the user will receive the change password email. It should match the user's email in Auth0
	 * @param {String} options.connection name of the connection where the user was created
	 * @param {changePasswordCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#change-password}
	 */
	DBConnection.prototype.changePassword = function(options, cb) {
	  var url;
	  var body;
	
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      connection: { type: 'string', message: 'connection option is required' },
	      email: { type: 'string', message: 'email option is required' }
	    }
	  );
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'dbconnections', 'change_password');
	
	  body = objectHelper.merge(this.baseOptions, ['clientID']).with(options, ['email', 'connection']);
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client']);
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	module.exports = DBConnection;


/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(190);
	
	var objectHelper = __webpack_require__(85);
	var assert = __webpack_require__(166);
	var qs = __webpack_require__(274);
	var responseHandler = __webpack_require__(167);
	
	function PasswordlessAuthentication(request, options) {
	  this.baseOptions = options;
	  this.request = request;
	}
	
	PasswordlessAuthentication.prototype.buildVerifyUrl = function(options) {
	  var params;
	  var qString;
	
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      connection: { type: 'string', message: 'connection option is required' },
	      verificationCode: { type: 'string', message: 'verificationCode option is required' },
	      phoneNumber: {
	        optional: false,
	        type: 'string',
	        message: 'phoneNumber option is required',
	        condition: function(o) {
	          return !o.email;
	        }
	      },
	      email: {
	        optional: false,
	        type: 'string',
	        message: 'email option is required',
	        condition: function(o) {
	          return !o.phoneNumber;
	        }
	      }
	    }
	  );
	  /* eslint-enable */
	
	  params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'responseType',
	      'responseMode',
	      'redirectUri',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'protocol',
	      'nonce'
	    ])
	    .with(options);
	
	  // eslint-disable-next-line
	  if (this.baseOptions._sendTelemetry) {
	    params.auth0Client = this.request.getTelemetryData();
	  }
	
	  params = objectHelper.toSnakeCase(params, ['auth0Client']);
	
	  qString = qs.stringify(params);
	
	  return urljoin(this.baseOptions.rootUrl, 'passwordless', 'verify_redirect', '?' + qString);
	};
	
	PasswordlessAuthentication.prototype.start = function(options, cb) {
	  var url;
	  var body;
	
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      connection: { type: 'string', message: 'connection option is required' },
	      send: {
	        type: 'string',
	        message: 'send option is required',
	        values: ['link', 'code'],
	        value_message: 'send is not valid ([link, code])'
	      },
	      phoneNumber: {
	        optional: true,
	        type: 'string',
	        message: 'phoneNumber option is required',
	        condition: function(o) {
	          return o.send === 'code' || !o.email;
	        }
	      },
	      email: {
	        optional: true,
	        type: 'string',
	        message: 'email option is required',
	        condition: function(o) {
	          return o.send === 'link' || !o.phoneNumber;
	        }
	      },
	      authParams: { optional: true, type: 'object', message: 'authParams option is required' }
	    }
	  );
	  /* eslint-enable */
	
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'passwordless', 'start');
	
	  body = objectHelper
	    .merge(this.baseOptions, ['clientID', 'responseType', 'redirectUri', 'scope'])
	    .with(options);
	
	  if (body.scope) {
	    body.authParams = body.authParams || {};
	    body.authParams.scope = body.scope;
	  }
	
	  if (body.redirectUri) {
	    body.authParams = body.authParams || {};
	    body.authParams.redirect_uri = body.redirectUri;
	  }
	
	  if (body.responseType) {
	    body.authParams = body.authParams || {};
	    body.authParams.response_type = body.responseType;
	  }
	
	  delete body.redirectUri;
	  delete body.responseType;
	  delete body.scope;
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client', 'authParams']);
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	PasswordlessAuthentication.prototype.verify = function(options, cb) {
	  var url;
	  var cleanOption;
	
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      connection: { type: 'string', message: 'connection option is required' },
	      verificationCode: { type: 'string', message: 'verificationCode option is required' },
	      phoneNumber: {
	        optional: false,
	        type: 'string',
	        message: 'phoneNumber option is required',
	        condition: function(o) {
	          return !o.email;
	        }
	      },
	      email: {
	        optional: false,
	        type: 'string',
	        message: 'email option is required',
	        condition: function(o) {
	          return !o.phoneNumber;
	        }
	      }
	    }
	  );
	  /* eslint-enable */
	
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  cleanOption = objectHelper.pick(options, [
	    'connection',
	    'verificationCode',
	    'phoneNumber',
	    'email',
	    'auth0Client'
	  ]);
	  cleanOption = objectHelper.toSnakeCase(cleanOption, ['auth0Client']);
	
	  url = urljoin(this.baseOptions.rootUrl, 'passwordless', 'verify');
	
	  return this.request.post(url).send(cleanOption).end(responseHandler(cb));
	};
	
	module.exports = PasswordlessAuthentication;


/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	var base64 = __webpack_require__(941);
	
	function padding(str) {
	  var mod = str.length % 4;
	  var pad = 4 - mod;
	
	  if (mod === 0) {
	    return str;
	  }
	
	  return str + new Array(1 + pad).join('=');
	}
	
	function stringToByteArray(str) {
	  var arr = new Array(str.length);
	  for (var a = 0; a < str.length; a++) {
	    arr[a] = str.charCodeAt(a);
	  }
	  return arr;
	}
	
	function byteArrayToString(array) {
	  var result = '';
	  for (var i = 0; i < array.length; i++) {
	    result += String.fromCharCode(array[i]);
	  }
	  return result;
	}
	
	function encode(str) {
	  return base64
	    .fromByteArray(stringToByteArray(str))
	    .replace(/\+/g, '-') // Convert '+' to '-'
	    .replace(/\//g, '_'); // Convert '/' to '_'
	}
	
	function decode(str) {
	  str = padding(str)
	    .replace(/-/g, '+') // Convert '-' to '+'
	    .replace(/_/g, '/'); // Convert '_' to '/'
	
	  return byteArrayToString(base64.toByteArray(str));
	}
	
	module.exports = {
	  encode: encode,
	  decode: decode
	};


/***/ },
/* 1838 */
/***/ function(module, exports) {

	/* eslint-disable no-continue */
	
	function get() {
	  if (!Object.assign) {
	    return objectAssignPolyfill;
	  }
	
	  return Object.assign;
	}
	
	function objectAssignPolyfill(target) {
	  'use strict';
	  if (target === undefined || target === null) {
	    throw new TypeError('Cannot convert first argument to object');
	  }
	
	  var to = Object(target);
	  for (var i = 1; i < arguments.length; i++) {
	    var nextSource = arguments[i];
	    if (nextSource === undefined || nextSource === null) {
	      continue;
	    }
	
	    var keysArray = Object.keys(Object(nextSource));
	    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	      var nextKey = keysArray[nextIndex];
	      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	      if (desc !== undefined && desc.enumerable) {
	        to[nextKey] = nextSource[nextKey];
	      }
	    }
	  }
	  return to;
	}
	
	module.exports = {
	  get: get,
	  objectAssignPolyfill: objectAssignPolyfill
	};


/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	// For future reference:,
	// The only parameters that should be whitelisted are parameters
	// defined by the specification, or existing parameters that we
	// need for compatibility
	
	var objectHelper = __webpack_require__(85);
	
	var tokenParams = [
	  // auth0
	  'realm',
	  'audience',
	  // oauth2
	  'client_id',
	  'client_secret',
	  'redirect_uri',
	  'scope',
	  'code',
	  'grant_type',
	  'username',
	  'password',
	  'refresh_token',
	  'assertion',
	  'client_assertion',
	  'client_assertion_type',
	  'code_verifier'
	];
	
	var authorizeParams = [
	  // auth0
	  'connection',
	  'connection_scope',
	  'auth0Client',
	  'owp',
	  'device',
	  'realm',
	
	  'protocol',
	  '_csrf',
	  '_intstate',
	  'login_ticket',
	
	  // oauth2
	  'client_id',
	  'response_type',
	  'response_mode',
	  'redirect_uri',
	  'audience',
	  'scope',
	  'state',
	  'nonce',
	  'display',
	  'prompt',
	  'max_age',
	  'ui_locales',
	  'claims_locales',
	  'id_token_hint',
	  'login_hint',
	  'acr_values',
	  'claims',
	  'registration',
	  'request',
	  'request_uri',
	  'code_challenge',
	  'code_challenge_method',
	  
	  // ADDITIONAL_PARAMETERS:
	  // https://auth0.com/docs/api/authentication?javascript#social
	  'access_type',
	  'display'
	];
	
	function oauthAuthorizeParams(warn, params) {
	  var notAllowed = objectHelper.getKeysNotIn(params, authorizeParams);
	
	  if (notAllowed.length > 0) {
	    warn.warning(
	      'Following parameters are not allowed on the `/authorize` endpoint: [' +
	        notAllowed.join(',') +
	        ']'
	    );
	  }
	
	  return params;
	}
	
	function oauthTokenParams(warn, params) {
	  return objectHelper.pick(params, tokenParams);
	}
	
	module.exports = {
	  oauthTokenParams: oauthTokenParams,
	  oauthAuthorizeParams: oauthAuthorizeParams
	};


/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	var version = __webpack_require__(532);
	
	function PluginHandler(webAuth, plugins) {
	  this.plugins = plugins;
	
	  for (var a = 0; a < this.plugins.length; a++) {
	    if (this.plugins[a].version !== version.raw) {
	      var pluginName = '';
	
	      if (this.plugins[a].constructor && this.plugins[a].constructor.name) {
	        pluginName = this.plugins[a].constructor.name;
	      }
	
	      throw new Error(
	        'Plugin ' +
	          pluginName +
	          ' version (' +
	          this.plugins[a].version +
	          ') ' +
	          'is not compatible with the SDK version (' +
	          version.raw +
	          ')'
	      );
	    }
	
	    this.plugins[a].setWebAuth(webAuth);
	  }
	}
	
	PluginHandler.prototype.get = function(extensibilityPoint) {
	  for (var a = 0; a < this.plugins.length; a++) {
	    if (this.plugins[a].supports(extensibilityPoint)) {
	      return this.plugins[a].init();
	    }
	  }
	
	  return null;
	};
	
	module.exports = PluginHandler;


/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable no-restricted-syntax */
	/* eslint-disable guard-for-in */
	var WinChan = __webpack_require__(1803);
	
	var windowHandler = __webpack_require__(101);
	var objectHelper = __webpack_require__(85);
	var qs = __webpack_require__(274);
	
	function PopupHandler() {
	  this._current_popup = null;
	}
	
	PopupHandler.prototype.calculatePosition = function(options) {
	  var width = options.width || 500;
	  var height = options.height || 600;
	  var _window = windowHandler.getWindow();
	
	  var screenX = typeof _window.screenX !== 'undefined' ? _window.screenX : _window.screenLeft;
	  var screenY = typeof _window.screenY !== 'undefined' ? _window.screenY : _window.screenTop;
	
	  var outerWidth = typeof _window.outerWidth !== 'undefined'
	    ? _window.outerWidth
	    : _window.document.body.clientWidth;
	
	  var outerHeight = typeof _window.outerHeight !== 'undefined'
	    ? _window.outerHeight
	    : _window.document.body.clientHeight;
	
	  var left = (outerWidth - width) / 2;
	  var top = (outerHeight - height) / 2;
	
	  return { width: width, height: height, left: screenX + left, top: screenY + top };
	};
	
	PopupHandler.prototype.preload = function(options) {
	  var _this = this;
	  var _window = windowHandler.getWindow();
	  var popupPosition = this.calculatePosition(options.popupOptions || {});
	  var popupOptions = objectHelper.merge(popupPosition).with(options.popupOptions);
	  var url = options.url || 'about:blank';
	  var windowFeatures = qs.stringify(popupOptions, {
	    encode: false,
	    delimiter: ','
	  });
	
	  if (this._current_popup && !this._current_popup.closed) {
	    return this._current_popup;
	  }
	
	  this._current_popup = _window.open(url, 'auth0_signup_popup', windowFeatures);
	
	  this._current_popup.kill = function() {
	    this.close();
	    _this._current_popup = null;
	  };
	
	  return this._current_popup;
	};
	
	PopupHandler.prototype.load = function(url, relayUrl, options, cb) {
	  var _this = this;
	  var popupPosition = this.calculatePosition(options.popupOptions || {});
	  var popupOptions = objectHelper.merge(popupPosition).with(options.popupOptions);
	
	  var winchanOptions = objectHelper
	    .merge({
	      url: url,
	      relay_url: relayUrl,
	      window_features: qs.stringify(popupOptions, {
	        delimiter: ',',
	        encode: false
	      }),
	      popup: this._current_popup
	    })
	    .with(options);
	
	  var popup = WinChan.open(winchanOptions, function(err, data) {
	    _this._current_popup = null;
	    return cb(err, data);
	  });
	
	  popup.focus();
	
	  return popup;
	};
	
	module.exports = PopupHandler;


/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	var windowHelper = __webpack_require__(101);
	
	function randomString(length) {
	  // eslint-disable-next-line
	  var bytes = new Uint8Array(length);
	  var result = [];
	  var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
	
	  var cryptoObj = windowHelper.getWindow().crypto || windowHelper.getWindow().msCrypto;
	  if (!cryptoObj) {
	    return null;
	  }
	
	  var random = cryptoObj.getRandomValues(bytes);
	
	  for (var a = 0; a < random.length; a++) {
	    result.push(charset[random[a] % charset.length]);
	  }
	
	  return result.join('');
	}
	
	module.exports = {
	  randomString: randomString
	};


/***/ },
/* 1843 */
/***/ function(module, exports, __webpack_require__) {

	var Cookie = __webpack_require__(2944);
	var objectHelper = __webpack_require__(85);
	function CookieStorage() {}
	
	CookieStorage.prototype.getItem = function(key) {
	  return Cookie.get(key);
	};
	
	CookieStorage.prototype.removeItem = function(key) {
	  Cookie.remove(key);
	};
	
	CookieStorage.prototype.setItem = function(key, value, options) {
	  var params = objectHelper.extend(
	    {
	      expires: 1 // 1 day
	    },
	    options
	  );
	  Cookie.set(key, value, params);
	};
	
	module.exports = CookieStorage;


/***/ },
/* 1844 */
/***/ function(module, exports) {

	function DummyStorage() {}
	
	DummyStorage.prototype.getItem = function() {
	  return null;
	};
	
	DummyStorage.prototype.removeItem = function() {};
	
	DummyStorage.prototype.setItem = function() {};
	
	module.exports = DummyStorage;


/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	var windowHandler = __webpack_require__(101);
	var DummyStorage = __webpack_require__(1844);
	var CookieStorage = __webpack_require__(1843);
	var Warn = __webpack_require__(229);
	
	function StorageHandler() {
	  this.warn = new Warn({});
	  this.storage = new CookieStorage();
	  try {
	    // some browsers throw an error when trying to access localStorage
	    // when localStorage is disabled.
	    var localStorage = windowHandler.getWindow().localStorage;
	    if (localStorage) {
	      this.storage = localStorage;
	    }
	  } catch (e) {
	    this.warn.warning(e);
	    this.warn.warning("Can't use localStorage. Using CookieStorage instead.");
	  }
	}
	
	StorageHandler.prototype.failover = function() {
	  if (this.storage instanceof DummyStorage) {
	    this.warn.warning('DummyStorage: ignore failover');
	    return;
	  } else if (this.storage instanceof CookieStorage) {
	    this.warn.warning('CookieStorage: failing over DummyStorage');
	    this.storage = new DummyStorage();
	  } else {
	    this.warn.warning('LocalStorage: failing over CookieStorage');
	    this.storage = new CookieStorage();
	  }
	};
	
	StorageHandler.prototype.getItem = function(key) {
	  try {
	    return this.storage.getItem(key);
	  } catch (e) {
	    this.warn.warning(e);
	    this.failover();
	    return this.getItem(key);
	  }
	};
	
	StorageHandler.prototype.removeItem = function(key) {
	  try {
	    return this.storage.removeItem(key);
	  } catch (e) {
	    this.warn.warning(e);
	    this.failover();
	    return this.removeItem(key);
	  }
	};
	
	StorageHandler.prototype.setItem = function(key, value, options) {
	  try {
	    return this.storage.setItem(key, value, options);
	  } catch (e) {
	    this.warn.warning(e);
	    this.failover();
	    return this.setItem(key, value, options);
	  }
	};
	
	module.exports = StorageHandler;


/***/ },
/* 1846 */
/***/ function(module, exports) {

	// given a URL, extract the origin. Taken from: https://github.com/firebase/firebase-simple-login/blob/d2cb95b9f812d8488bdbfba51c3a7c153ba1a074/js/src/simple-login/transports/WinChan.js#L25-L30
	function extractOrigin(url) {
	  if (!/^https?:\/\//.test(url)) url = window.location.href;
	  var m = /^(https?:\/\/[-_a-zA-Z.0-9:]+)/.exec(url);
	  if (m) return m[1];
	  return url;
	}
	
	module.exports = {
	  extractOrigin: extractOrigin
	};


/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	var Authentication = __webpack_require__(847);
	var Management = __webpack_require__(1848);
	var WebAuth = __webpack_require__(852);
	var version = __webpack_require__(532);
	
	module.exports = {
	  Authentication: Authentication,
	  Management: Management,
	  WebAuth: WebAuth,
	  version: version.raw
	};


/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(190);
	
	var RequestBuilder = __webpack_require__(275);
	var assert = __webpack_require__(166);
	var responseHandler = __webpack_require__(167);
	
	/**
	 * Auth0 Management API Client (methods allowed to be called from the browser only)
	 * @constructor
	 * @param {Object} options
	 * @param {Object} options.domain your Auth0 acount domain
	 * @param {Object} options.token a valid API token
	 */
	function Management(options) {
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      domain: { type: 'string', message: 'domain option is required' },
	      token: { type: 'string', message: 'token option is required' },
	      _sendTelemetry: {
	        optional: true,
	        type: 'boolean',
	        message: '_sendTelemetry option is not valid'
	      },
	      _telemetryInfo: {
	        optional: true,
	        type: 'object',
	        message: '_telemetryInfo option is not valid'
	      }
	    }
	  );
	  /* eslint-enable */
	
	  this.baseOptions = options;
	
	  this.baseOptions.headers = { Authorization: 'Bearer ' + this.baseOptions.token };
	
	  this.request = new RequestBuilder(this.baseOptions);
	  this.baseOptions.rootUrl = urljoin('https://' + this.baseOptions.domain, 'api', 'v2');
	}
	
	/**
	 * @callback userCallback
	 * @param {Error} [err] failure reason for the failed request to Management API
	 * @param {Object} [result] user profile
	 */
	
	/**
	 * Returns the user profile
	 *
	 * @method getUser
	 * @param {String} userId identifier of the user to retrieve
	 * @param {userCallback} cb
	 * @see https://auth0.com/docs/api/management/v2#!/Users/get_users_by_id
	 */
	Management.prototype.getUser = function(userId, cb) {
	  var url;
	
	  assert.check(userId, { type: 'string', message: 'userId parameter is not valid' });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'users', userId);
	
	  return this.request.get(url).end(responseHandler(cb, { ignoreCasing: true }));
	};
	
	/**
	 * Updates the user metdata. It will patch the user metdata with the attributes sent.
	 *
	 *
	 * @method patchUserMetadata
	 * @param {String} userId
	 * @param {Object} userMetadata
	 * @param {userCallback} cb
	 * @see   {@link https://auth0.com/docs/api/management/v2#!/Users/patch_users_by_id}
	 */
	Management.prototype.patchUserMetadata = function(userId, userMetadata, cb) {
	  var url;
	
	  assert.check(userId, { type: 'string', message: 'userId parameter is not valid' });
	  assert.check(userMetadata, { type: 'object', message: 'userMetadata parameter is not valid' });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'users', userId);
	
	  return this.request
	    .patch(url)
	    .send({ user_metadata: userMetadata })
	    .end(responseHandler(cb, { ignoreCasing: true }));
	};
	
	/**
	 * Link two users
	 *
	 * @method linkUser
	 * @param {String} userId
	 * @param {String} secondaryUserToken
	 * @param {userCallback} cb
	 * @see   {@link https://auth0.com/docs/api/management/v2#!/Users/post_identities}
	 */
	Management.prototype.linkUser = function(userId, secondaryUserToken, cb) {
	  var url;
	  /* eslint-disable */
	  assert.check(userId, { type: 'string', message: 'userId parameter is not valid' });
	  assert.check(secondaryUserToken, {
	    type: 'string',
	    message: 'secondaryUserToken parameter is not valid'
	  });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	  /* eslint-enable */
	
	  url = urljoin(this.baseOptions.rootUrl, 'users', userId, 'identities');
	
	  return this.request
	    .post(url)
	    .send({ link_with: secondaryUserToken })
	    .end(responseHandler(cb, { ignoreCasing: true }));
	};
	
	module.exports = Management;


/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(190);
	var qs = __webpack_require__(274);
	
	var UsernamePassword = __webpack_require__(1853);
	var RequestBuilder = __webpack_require__(275);
	var responseHandler = __webpack_require__(167);
	var objectHelper = __webpack_require__(85);
	var windowHelper = __webpack_require__(101);
	var Warn = __webpack_require__(229);
	var assert = __webpack_require__(166);
	
	function HostedPages(client, options) {
	  this.baseOptions = options;
	  this.client = client;
	  this.request = new RequestBuilder(this.baseOptions);
	
	  this.warn = new Warn({
	    disableWarnings: !!options._disableDeprecationWarnings
	  });
	}
	
	/**
	 * @callback credentialsCallback
	 * @param {Error} [err] error returned by Auth0 with the reason of the Auth failure
	 * @param {Object} [result] result of the AuthN request
	 * @param {String} result.accessToken token that can be used with {@link userinfo}
	 * @param {String} [result.idToken] token that identifies the user
	 * @param {String} [result.refreshToken] token that can be used to get new access tokens from Auth0. Note that not all Auth0 Applications can request them or the resource server might not allow them.
	 */
	
	/**
	 * Performs authentication with username/email and password with a database connection
	 *
	 * This method is not compatible with API Auth so if you need to fetch API tokens with audience
	 * you should use {@link authorize} or {@link login}.
	 *
	 * @method loginWithCredentials
	 * @param {Object} options
	 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} [options.responseType] type of the response used. It can be any of the values `code` and `token`
	 * @param {String} [options.responseMode] how the AuthN response is encoded and redirected back to the client. Supported values are `query` and `fragment`
	 * @param {String} [options.scope] scopes to be requested during AuthN. e.g. `openid email`
	 * @param {credentialsCallback} cb
	 */
	HostedPages.prototype.login = function(options, cb) {
	  if (windowHelper.getWindow().location.host !== this.baseOptions.domain) {
	    throw new Error('This method is meant to be used only inside the Universal Login Page.');
	  }
	  var usernamePassword;
	
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'redirectUri',
	      'tenant',
	      'responseType',
	      'responseMode',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options);
	
	  assert.check(
	    params,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      responseType: { type: 'string', message: 'responseType option is required' }
	    }
	  );
	
	  usernamePassword = new UsernamePassword(this.baseOptions);
	  return usernamePassword.login(params, function(err, data) {
	    if (err) {
	      return cb(err);
	    }
	    return usernamePassword.callback(data);
	  });
	};
	
	/**
	 * Signs up a new user and automatically logs the user in after the signup.
	 *
	 * @method signupAndLogin
	 * @param {Object} options
	 * @param {String} options.email user email address
	 * @param {String} options.password user password
	 * @param {String} options.connection name of the connection where the user will be created
	 * @param {credentialsCallback} cb
	 */
	HostedPages.prototype.signupAndLogin = function(options, cb) {
	  var _this = this;
	  return _this.client.client.dbConnection.signup(options, function(err) {
	    if (err) {
	      return cb(err);
	    }
	    return _this.login(options, cb);
	  });
	};
	
	HostedPages.prototype.getSSOData = function(withActiveDirectories, cb) {
	  var url;
	  var params = '';
	
	  if (typeof withActiveDirectories === 'function') {
	    cb = withActiveDirectories;
	    withActiveDirectories = false;
	  }
	
	  assert.check(withActiveDirectories, {
	    type: 'boolean',
	    message: 'withActiveDirectories parameter is not valid'
	  });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  if (withActiveDirectories) {
	    params =
	      '?' +
	      qs.stringify({
	        ldaps: 1,
	        client_id: this.baseOptions.clientID
	      });
	  }
	
	  url = urljoin(this.baseOptions.rootUrl, 'user', 'ssodata', params);
	
	  return this.request.get(url, { noHeaders: true }).withCredentials().end(responseHandler(cb));
	};
	
	module.exports = HostedPages;


/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(190);
	var WinChan = __webpack_require__(1803);
	
	var urlHelper = __webpack_require__(1846);
	var assert = __webpack_require__(166);
	var responseHandler = __webpack_require__(167);
	var PopupHandler = __webpack_require__(1841);
	var objectHelper = __webpack_require__(85);
	var windowHelper = __webpack_require__(101);
	var Warn = __webpack_require__(229);
	var TransactionManager = __webpack_require__(534);
	var CrossOriginAuthentication = __webpack_require__(533);
	
	function Popup(webAuth, options) {
	  this.baseOptions = options;
	  this.baseOptions.popupOrigin = options.popupOrigin;
	  this.client = webAuth.client;
	  this.webAuth = webAuth;
	
	  this.transactionManager = new TransactionManager(this.baseOptions.transaction);
	  this.crossOriginAuthentication = new CrossOriginAuthentication(webAuth, this.baseOptions);
	  this.warn = new Warn({
	    disableWarnings: !!options._disableDeprecationWarnings
	  });
	}
	
	/**
	 * Returns a new instance of the popup handler
	 *
	 * @method buildPopupHandler
	 * @private
	 */
	Popup.prototype.buildPopupHandler = function() {
	  var pluginHandler = this.baseOptions.plugins.get('popup.getPopupHandler');
	
	  if (pluginHandler) {
	    return pluginHandler.getPopupHandler();
	  }
	
	  return new PopupHandler();
	};
	
	/**
	 * Initializes the popup window and returns the instance to be used later in order to avoid being blocked by the browser.
	 *
	 * @method preload
	 * @param {Object} options receives the window height and width and any other window feature to be sent to window.open
	 */
	Popup.prototype.preload = function(options) {
	  options = options || {};
	
	  var popup = this.buildPopupHandler();
	
	  popup.preload(options);
	  return popup;
	};
	
	/**
	 * Internal use.
	 *
	 * @method getPopupHandler
	 * @private
	 */
	Popup.prototype.getPopupHandler = function(options, preload) {
	  if (options.popupHandler) {
	    return options.popupHandler;
	  }
	
	  if (preload) {
	    return this.preload(options);
	  }
	
	  return this.buildPopupHandler();
	};
	
	/**
	 * Handles the popup logic for the callback page.
	 *
	 * @method callback
	 * @param {Object} options
	 * @param {String} options.hash the url hash. If not provided it will extract from window.location.hash
	 * @param {String} [options.state] value originally sent in `state` parameter to {@link authorize} to mitigate XSRF
	 * @param {String} [options.nonce] value originally sent in `nonce` parameter to {@link authorize} to prevent replay attacks
	 * @see   {@link parseHash}
	 */
	Popup.prototype.callback = function(options) {
	  var _this = this;
	  var theWindow = windowHelper.getWindow();
	  options = options || {};
	  var originUrl = options.popupOrigin || this.baseOptions.popupOrigin || windowHelper.getOrigin();
	
	  /*
	    in IE 11, there's a bug that makes window.opener return undefined.
	    The callback page will still call `popup.callback()` which will run this method
	    in the relay page. WinChan expects the relay page to have a global `doPost` function,
	    which will be called with the response.
	
	    IE11 Bug: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/110920/
	   */
	  if (!theWindow.opener) {
	    theWindow.doPost = function(msg) {
	      if (theWindow.parent) {
	        theWindow.parent.postMessage(msg, originUrl);
	      }
	    };
	    return;
	  }
	
	  WinChan.onOpen(function(popupOrigin, r, cb) {
	    if (popupOrigin !== originUrl) {
	      return cb({
	        error: 'origin_mismatch',
	        error_description: "The popup's origin (" +
	          popupOrigin +
	          ') should match the `popupOrigin` parameter (' +
	          originUrl +
	          ').'
	      });
	    }
	    _this.webAuth.parseHash(options || {}, function(err, data) {
	      return cb(err || data);
	    });
	  });
	};
	
	/**
	 * Shows inside a new window the hosted login page (`/authorize`) in order to start a new authN/authZ transaction and post its result using `postMessage`.
	 *
	 * @method authorize
	 * @param {Object} options
	 * @param {String} [options.domain] your Auth0 domain
	 * @param {String} [options.clientID] the Client ID found on your Application settings page
	 * @param {String} options.redirectUri url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} options.responseType type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. The `query` value is only supported when `responseType` is `code`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
	 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
	 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @param {Boolean} [options.owp] determines if Auth0 should render the relay page or not and the caller is responsible of handling the response.
	 * @param {authorizeCallback} cb
	 * @see {@link https://auth0.com/docs/api/authentication#authorize-client}
	 */
	Popup.prototype.authorize = function(options, cb) {
	  var popup;
	  var url;
	  var relayUrl;
	  var popOpts = {};
	
	  var pluginHandler = this.baseOptions.plugins.get('popup.authorize');
	
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'scope',
	      'domain',
	      'audience',
	      'tenant',
	      'responseType',
	      'redirectUri',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(objectHelper.blacklist(options, ['popupHandler']));
	
	  assert.check(
	    params,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      responseType: { type: 'string', message: 'responseType option is required' }
	    }
	  );
	
	  // the relay page should not be necessary as long it happens in the same domain
	  // (a redirectUri shoul be provided). It is necessary when using OWP
	  relayUrl = urljoin(this.baseOptions.rootUrl, 'relay.html');
	
	  // if a owp is enabled, it should use the owp flag
	  if (options.owp) {
	    // used by server to render the relay page instead of sending the chunk in the
	    // url to the callback
	    params.owp = true;
	  } else {
	    popOpts.origin = urlHelper.extractOrigin(params.redirectUri);
	    relayUrl = params.redirectUri;
	  }
	
	  if (options.popupOptions) {
	    popOpts.popupOptions = objectHelper.pick(options.popupOptions, ['width', 'height']);
	  }
	
	  if (pluginHandler) {
	    params = pluginHandler.processParams(params);
	  }
	
	  params = this.transactionManager.process(params);
	  params.scope = params.scope || 'openid profile email';
	  delete params.domain;
	
	  url = this.client.buildAuthorizeUrl(params);
	
	  popup = this.getPopupHandler(options);
	
	  return popup.load(url, relayUrl, popOpts, responseHandler(cb));
	};
	
	/**
	 * Performs authentication with username/email and password with a database connection inside a new window
	 *
	 * This method is not compatible with API Auth so if you need to fetch API tokens with audience
	 * you should use {@link authorize} or {@link login}.
	 *
	 * @method loginWithCredentials
	 * @param {Object} options
	 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} [options.responseType] type of the response used. It can be any of the values `code` and `token`
	 * @param {String} [options.responseMode] how the AuthN response is encoded and redirected back to the client. Supported values are `query` and `fragment`. The `query` value is only supported when `responseType` is `code`.
	 * @param {String} [options.scope] scopes to be requested during AuthN. e.g. `openid email`
	 * @param {credentialsCallback} cb
	 */
	Popup.prototype.loginWithCredentials = function(options, cb) {
	  options.realm = options.realm || options.connection;
	  options.popup = true;
	  options = objectHelper
	    .merge(this.baseOptions, ['redirectUri', 'responseType', 'state', 'nonce'])
	    .with(objectHelper.blacklist(options, ['popupHandler', 'connection']));
	  options = this.transactionManager.process(options);
	  this.crossOriginAuthentication.login(options, cb);
	};
	
	/**
	 * Verifies the passwordless TOTP and redirects to finish the passwordless transaction
	 *
	 * @method passwordlessVerify
	 * @param {Object} options
	 * @param {String} options.type `sms` or `email`
	 * @param {String} options.phoneNumber only if type = sms
	 * @param {String} options.email only if type = email
	 * @param {String} options.connection the connection name
	 * @param {String} options.verificationCode the TOTP code
	 * @param {Function} cb
	 */
	Popup.prototype.passwordlessVerify = function(options, cb) {
	  var _this = this;
	  return this.client.passwordless.verify(
	    objectHelper.blacklist(options, ['popupHandler']),
	    function(err) {
	      if (err) {
	        return cb(err);
	      }
	
	      options.username = options.phoneNumber || options.email;
	      options.password = options.verificationCode;
	
	      delete options.email;
	      delete options.phoneNumber;
	      delete options.verificationCode;
	      delete options.type;
	
	      _this.client.loginWithResourceOwner(options, cb);
	    }
	  );
	};
	
	/**
	 * Signs up a new user and automatically logs the user in after the signup.
	 *
	 * This method is not compatible with API Auth so if you need to fetch API tokens with audience
	 * you should use {@link authorize} or {@link signupAndAuthorize}.
	 *
	 * @method signupAndLogin
	 * @param {Object} options
	 * @param {String} options.email user email address
	 * @param {String} options.password user password
	 * @param {String} options.connection name of the connection where the user will be created
	 * @param {credentialsCallback} cb
	 */
	Popup.prototype.signupAndLogin = function(options, cb) {
	  var _this = this;
	
	  // Preload popup to avoid the browser to block it since the login happens later
	  var popupHandler = this.getPopupHandler(options, true);
	  options.popupHandler = popupHandler;
	
	  return this.client.dbConnection.signup(
	    objectHelper.blacklist(options, ['popupHandler']),
	    function(err) {
	      if (err) {
	        if (popupHandler._current_popup) {
	          popupHandler._current_popup.kill();
	        }
	        return cb(err);
	      }
	      _this.loginWithCredentials(options, cb);
	    }
	  );
	};
	
	module.exports = Popup;


/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	var CrossOriginAuthentication = __webpack_require__(533);
	var Warn = __webpack_require__(229);
	
	function Redirect(auth0, options) {
	  this.webAuth = auth0;
	  this.baseOptions = options;
	  this.crossOriginAuthentication = new CrossOriginAuthentication(auth0, this.baseOptions);
	
	  this.warn = new Warn({
	    disableWarnings: !!options._disableDeprecationWarnings
	  });
	}
	
	/**
	 * Logs in the user with username and password using the cross origin authentication (/co/authenticate) flow. You can use either `username` or `email` to identify the user, but `username` will take precedence over `email`.
	 * Some browsers might not be able to successfully authenticate if 3rd party cookies are disabled in your browser. [See here for more information.]{@link https://auth0.com/docs/cross-origin-authentication}.
	 * After the /co/authenticate call, you'll have to use the {@link parseHash} function at the `redirectUri` specified in the constructor.
	 *
	 * @method loginWithCredentials
	 * @deprecated This method will be released in the next major version. Use `webAuth.login` instead.
	 * @param {Object} options options used in the {@link authorize} call after the login_ticket is acquired
	 * @param {String} [options.username] Username (mutually exclusive with email)
	 * @param {String} [options.email] Email (mutually exclusive with username)
	 * @param {String} options.password Password
	 * @param {String} [options.connection] Connection used to authenticate the user, it can be a realm name or a database connection name
	 * @param {crossOriginLoginCallback} cb Callback function called only when an authentication error, like invalid username or password, occurs. For other types of errors, there will be a redirect to the `redirectUri`.
	 */
	Redirect.prototype.loginWithCredentials = function(options, cb) {
	  options.realm = options.realm || options.connection;
	  delete options.connection;
	  this.crossOriginAuthentication.login(options, cb);
	};
	
	/**
	 * Signs up a new user and automatically logs the user in after the signup.
	 *
	 * @method signupAndLogin
	 * @param {Object} options
	 * @param {String} options.email user email address
	 * @param {String} options.password user password
	 * @param {String} options.connection name of the connection where the user will be created
	 * @param {crossOriginLoginCallback} cb
	 */
	Redirect.prototype.signupAndLogin = function(options, cb) {
	  var _this = this;
	  return this.webAuth.client.dbConnection.signup(options, function(err) {
	    if (err) {
	      return cb(err);
	    }
	    options.realm = options.realm || options.connection;
	    delete options.connection;
	    return _this.webAuth.login(options, cb);
	  });
	};
	
	module.exports = Redirect;


/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	var IframeHandler = __webpack_require__(849);
	var windowHelper = __webpack_require__(101);
	
	function SilentAuthenticationHandler(options) {
	  this.authenticationUrl = options.authenticationUrl;
	  this.timeout = options.timeout || 60 * 1000;
	  this.handler = null;
	  this.postMessageDataType = options.postMessageDataType || false;
	
	  // prefer origin from options, fallback to origin from browser, and some browsers (for example MS Edge) don't support origin; fallback to construct origin manually
	  this.postMessageOrigin =
	    options.postMessageOrigin ||
	    windowHelper.getWindow().location.origin ||
	    windowHelper.getWindow().location.protocol + '//' + windowHelper.getWindow().location.hostname
	      + (windowHelper.getWindow().location.port ? ':' + windowHelper.getWindow().location.port : '');
	}
	
	SilentAuthenticationHandler.create = function(options) {
	  return new SilentAuthenticationHandler(options);
	};
	
	SilentAuthenticationHandler.prototype.login = function(usePostMessage, callback) {
	  this.handler = new IframeHandler({
	    auth0: this.auth0,
	    url: this.authenticationUrl,
	    eventListenerType: usePostMessage ? 'message' : 'load',
	    callback: this.getCallbackHandler(callback, usePostMessage),
	    timeout: this.timeout,
	    eventValidator: this.getEventValidator(),
	    timeoutCallback: function() {
	      callback(null, '#error=timeout&error_description=Timeout+during+authentication+renew.');
	    },
	    usePostMessage: usePostMessage || false
	  });
	
	  this.handler.init();
	};
	
	SilentAuthenticationHandler.prototype.getEventValidator = function() {
	  var _this = this;
	  return {
	    isValid: function(eventData) {
	      switch (eventData.event.type) {
	        case 'message':
	          // Message must come from the expected origin and iframe window.
	          if (
	            eventData.event.origin !== _this.postMessageOrigin ||
	            eventData.event.source !== _this.handler.iframe.contentWindow
	          ) {
	            return false;
	          }
	
	          // Default behaviour, return all message events from the iframe.
	          if (_this.postMessageDataType === false) {
	            return true;
	          }
	
	          return (
	            eventData.event.data.type && eventData.event.data.type === _this.postMessageDataType
	          );
	
	        case 'load':
	          if (eventData.sourceObject.contentWindow.location.protocol === 'about:') {
	            // Chrome is automatically loading the about:blank page, we ignore this.
	            return false;
	          }
	        // Fall through to default
	        default:
	          return true;
	      }
	    }
	  };
	};
	
	SilentAuthenticationHandler.prototype.getCallbackHandler = function(callback, usePostMessage) {
	  return function(eventData) {
	    var callbackValue;
	    if (!usePostMessage) {
	      callbackValue = eventData.sourceObject.contentWindow.location.hash;
	    } else if (typeof eventData.event.data === 'object' && eventData.event.data.hash) {
	      callbackValue = eventData.event.data.hash;
	    } else {
	      callbackValue = eventData.event.data;
	    }
	    callback(null, callbackValue);
	  };
	};
	
	module.exports = SilentAuthenticationHandler;


/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(190);
	
	var objectHelper = __webpack_require__(85);
	var RequestBuilder = __webpack_require__(275);
	var responseHandler = __webpack_require__(167);
	var windowHelper = __webpack_require__(101);
	var TransactionManager = __webpack_require__(534);
	
	function UsernamePassword(options) {
	  this.baseOptions = options;
	  this.request = new RequestBuilder(options);
	  this.transactionManager = new TransactionManager(this.baseOptions.transaction);
	}
	
	UsernamePassword.prototype.login = function(options, cb) {
	  var url;
	  var body;
	
	  url = urljoin(this.baseOptions.rootUrl, 'usernamepassword', 'login');
	
	  options.username = options.username || options.email; // eslint-disable-line
	
	  options = objectHelper.blacklist(options, ['email']); // eslint-disable-line
	
	  body = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'redirectUri',
	      'tenant',
	      'responseType',
	      'responseMode',
	      'scope',
	      'audience'
	    ])
	    .with(options);
	  body = this.transactionManager.process(body);
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client']);
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	UsernamePassword.prototype.callback = function(formHtml) {
	  var div;
	  var form;
	  var _document = windowHelper.getDocument();
	
	  div = _document.createElement('div');
	  div.innerHTML = formHtml;
	  form = _document.body.appendChild(div).children[0];
	
	  form.submit();
	};
	
	module.exports = UsernamePassword;


/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isNetworkError = isNetworkError;
	exports.default = axiosRetry;
	
	var _isRetryAllowed = __webpack_require__(1289);
	
	var _isRetryAllowed2 = _interopRequireDefault(_isRetryAllowed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var namespace = 'axios-retry';
	
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	function isNetworkError(error) {
	  return !error.response;
	}
	
	/**
	 * Initializes and returns the retry state for the given request/config
	 * @param  {AxiosRequestConfig} config
	 * @return {Object}
	 */
	function getCurrentState(config) {
	  var currentState = config[namespace] || {};
	  currentState.retryCount = currentState.retryCount || 0;
	  config[namespace] = currentState;
	  return currentState;
	}
	
	/**
	 * Returns the axios-retry options for the current request
	 * @param  {AxiosRequestConfig} config
	 * @param  {AxiosRetryConfig} defaultOptions
	 * @return {AxiosRetryConfig}
	 */
	function getRequestOptions(config, defaultOptions) {
	  return Object.assign({}, defaultOptions, config[namespace]);
	}
	
	/**
	 * @param  {Axios} axios
	 * @param  {AxiosRequestConfig} config
	 */
	function fixConfig(axios, config) {
	  if (axios.defaults.agent === config.agent) {
	    delete config.agent;
	  }
	  if (axios.defaults.httpAgent === config.httpAgent) {
	    delete config.httpAgent;
	  }
	  if (axios.defaults.httpsAgent === config.httpsAgent) {
	    delete config.httpsAgent;
	  }
	}
	
	/**
	 * Adds response interceptors to an axios instance to retry requests failed due to network issues
	 *
	 * @example
	 *
	 * import axios from 'axios';
	 *
	 * axiosRetry(axios, { retries: 3 });
	 *
	 * axios.get('http://example.com/test') // The first request fails and the second returns 'ok'
	 *   .then(result => {
	 *     result.data; // 'ok'
	 *   });
	 *
	 * // Also works with custom axios instances
	 * const client = axios.create({ baseURL: 'http://example.com' });
	 * axiosRetry(client, { retries: 3 });
	 *
	 * client.get('/test') // The first request fails and the second returns 'ok'
	 *   .then(result => {
	 *     result.data; // 'ok'
	 *   });
	 *
	 * // Allows request-specific configuration
	 * client
	 *   .get('/test', {
	 *     'axios-retry': {
	 *       retries: 0
	 *     }
	 *   })
	 *   .catch(error => { // The first request fails
	 *     error !== undefined
	 *   });
	 *
	 * @param {Axios} axios An axios instance (the axios object or one created from axios.create)
	 * @param {Object} [defaultOptions]
	 * @param {number} [defaultOptions.retries=3] Number of retries
	 * @param {number} [defaultOptions.retryCondition=isNetworkError] Number of retries
	 */
	function axiosRetry(axios, defaultOptions) {
	  axios.interceptors.response.use(null, function (error) {
	    var config = error.config;
	
	    // If we have no information to retry the request
	    if (!config) {
	      return Promise.reject(error);
	    }
	
	    var _getRequestOptions = getRequestOptions(config, defaultOptions),
	        _getRequestOptions$re = _getRequestOptions.retries,
	        retries = _getRequestOptions$re === undefined ? 3 : _getRequestOptions$re,
	        _getRequestOptions$re2 = _getRequestOptions.retryCondition,
	        retryCondition = _getRequestOptions$re2 === undefined ? isNetworkError : _getRequestOptions$re2;
	
	    var currentState = getCurrentState(config);
	
	    var shouldRetry = retryCondition(error) && error.code !== 'ECONNABORTED' && currentState.retryCount < retries && (0, _isRetryAllowed2.default)(error);
	
	    if (shouldRetry) {
	      currentState.retryCount++;
	
	      // Axios fails merging this configuration to the default configuration because it has an issue
	      // with circular structures: https://github.com/mzabriskie/axios/issues/370
	      fixConfig(axios, config);
	
	      var now = Date.now();
	      if (config.timeout && currentState.lastRequestTime) {
	        config.timeout -= now - currentState.lastRequestTime;
	      }
	      currentState.lastRequestTime = now;
	
	      return axios(config);
	    }
	
	    return Promise.reject(error);
	  });
	}
	//# sourceMappingURL=index.js.map

/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(102);
	var bind = __webpack_require__(856);
	var Axios = __webpack_require__(1856);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance();
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(defaultConfig) {
	  return createInstance(defaultConfig);
	};
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(1871);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(1862);
	var utils = __webpack_require__(102);
	var InterceptorManager = __webpack_require__(1857);
	var dispatchRequest = __webpack_require__(1858);
	var isAbsoluteURL = __webpack_require__(1867);
	var combineURLs = __webpack_require__(1865);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 */
	function Axios(defaultConfig) {
	  this.defaults = utils.merge(defaults, defaultConfig);
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(102);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(102);
	var transformData = __webpack_require__(1861);
	
	/**
	 * Dispatch a request to the server using whichever adapter
	 * is supported by the current environment.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter;
	
	  if (typeof config.adapter === 'function') {
	    // For custom adapter support
	    adapter = config.adapter;
	  } else if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(854);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(854);
	  }
	
	  return Promise.resolve(config)
	    // Wrap synchronous adapter errors and pass configuration
	    .then(adapter)
	    .then(function onFulfilled(response) {
	      // Transform response data
	      response.data = transformData(
	        response.data,
	        response.headers,
	        config.transformResponse
	      );
	
	      return response;
	    }, function onRejected(error) {
	      // Transform response data
	      if (error && error.response) {
	        error.response.data = transformData(
	          error.response.data,
	          error.response.headers,
	          config.transformResponse
	        );
	      }
	
	      return Promise.reject(error);
	    });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 1859 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(855);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(102);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(102);
	var normalizeHeaderName = __webpack_require__(1869);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	module.exports = {
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    },
	    patch: utils.merge(DEFAULT_CONTENT_TYPE),
	    post: utils.merge(DEFAULT_CONTENT_TYPE),
	    put: utils.merge(DEFAULT_CONTENT_TYPE)
	  },
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};


/***/ },
/* 1863 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(102);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 1865 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(102);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 1867 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(102);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(102);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(102);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 1871 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.windowResize = windowResize;
	
	var _constants = __webpack_require__(902);
	
	function windowResize(windowSizing) {
	  return {
	    type: _constants.WINDOW_RESIZE,
	    windowWidth: windowSizing.windowWidth,
	    windowHeight: windowSizing.windowHeight
	  };
	} /*
	   * App actions
	   */

/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(28);
	
	var _reactDimensions = __webpack_require__(3275);
	
	var _reactDimensions2 = _interopRequireDefault(_reactDimensions);
	
	var _bowser = __webpack_require__(368);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	var _actions = __webpack_require__(1872);
	
	var _mobileLock = __webpack_require__(2000);
	
	var _mobileLock2 = _interopRequireDefault(_mobileLock);
	
	var _checkLocalStorage = __webpack_require__(2094);
	
	var _checkLocalStorage2 = _interopRequireDefault(_checkLocalStorage);
	
	var _safeLocalstorage = __webpack_require__(2392);
	
	var _safeLocalstorage2 = _interopRequireDefault(_safeLocalstorage);
	
	var _onlineChecker = __webpack_require__(2180);
	
	var _onlineChecker2 = _interopRequireDefault(_onlineChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App(props, context) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props, context));
	
	    var newWindowSizing = {
	      windowHeight: props.containerHeight,
	      windowWidth: props.containerWidth
	    };
	
	    _this.props.onWindowResize(newWindowSizing);
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var newWindowSizing = {
	        windowHeight: nextProps.containerHeight,
	        windowWidth: nextProps.containerWidth
	      };
	
	      this.props.onWindowResize(newWindowSizing);
	    }
	  }, {
	    key: 'renderBasedOnBrowser',
	    value: function renderBasedOnBrowser() {
	      var isLocalStorageAvailable = _safeLocalstorage2.default.check();
	      var isMobileAllowed = _lodash2.default.get(this.props, 'children.props.route.mobileAllowed');
	      if (_bowser2.default.mobile && !isMobileAllowed) return _react2.default.createElement(_mobileLock2.default, null);
	      if (isLocalStorageAvailable) return _react2.default.createElement(
	        'div',
	        null,
	        this.props.children
	      );
	      return _react2.default.createElement(_checkLocalStorage2.default, null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_onlineChecker2.default, null),
	        this.renderBasedOnBrowser()
	      );
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	App.propTypes = {
	  onWindowResize: _react2.default.PropTypes.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    windowWidth: state.windowSize.get('windowWidth')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onWindowResize: function onWindowResize(resizeData) {
	      return dispatch((0, _actions.windowResize)(resizeData));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactDimensions2.default)()(App));

/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rollbar = __webpack_require__(1626);
	
	var _rollbar2 = _interopRequireDefault(_rollbar);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactBrowserDetection = __webpack_require__(255);
	
	var _reactBrowserDetection2 = _interopRequireDefault(_reactBrowserDetection);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _browserHandler = __webpack_require__(231);
	
	var _browserHandler2 = _interopRequireDefault(_browserHandler);
	
	var _poweredByDyzio = __webpack_require__(278);
	
	var _poweredByDyzio2 = _interopRequireDefault(_poweredByDyzio);
	
	var _withGuestIntercom = __webpack_require__(360);
	
	var _withGuestIntercom2 = _interopRequireDefault(_withGuestIntercom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = _themeSelector2.default.theme();
	
	var AccessDenied = function AccessDenied() {
	  var parsedHash = new URLSearchParams(window.location.hash.substr(1));
	  var error = decodeURIComponent(parsedHash.get('error'));
	
	  var errorDescription = decodeURIComponent(parsedHash.get('error_description'));
	
	  if (errorDescription.match(/Object/)) {
	    errorDescription = 'We could not find a user with your email address in our database.';
	  }
	
	  var rollbar = new _rollbar2.default({
	    accessToken: '3affd941e3d0437ea5f446c0a2769419',
	    captureUncaught: true,
	    payload: {
	      environment: window.location.hostname,
	      person: {
	        id: 401,
	        username: 'Erroneous Bosch',
	        email: 'x@y.com'
	      },
	      client: {
	        javascript: {
	          source_map_enabled: true,
	          code_version: 'latest',
	          guess_uncaught_frames: true
	        }
	      }
	    }
	  });
	
	  rollbar.error('ACCESS_DENIED_ERROR-' + error, errorDescription);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'page-centered' },
	    _react2.default.createElement(
	      'div',
	      { className: 'center-outer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'center-inner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'center-logo' },
	          _react2.default.createElement(
	            'a',
	            { href: '/' },
	            _react2.default.createElement('img', { src: theme.darkLogo.src, alt: theme.darkLogo.alt })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'center-content' },
	          _react2.default.createElement('div', { className: 'spacer small' }),
	          _react2.default.createElement(
	            'h1',
	            { style: { textAlign: 'center' } },
	            'Sorry...',
	            _react2.default.createElement('br', null),
	            'We had a problem signing you in ',
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'frown', color: 'red' })
	          ),
	          _react2.default.createElement('div', { className: 'spacer' }),
	          _react2.default.createElement(
	            'p',
	            { className: 'info' },
	            'Our support team has been notified and will be in touch shortly.'
	          ),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'p',
	            { className: 'info' },
	            'You can also use the chat button in the bottom right of your screen to contact us directly.'
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	          _react2.default.createElement(_semanticUiReact.Message, {
	            warning: true,
	            header: error,
	            content: errorDescription
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'browser-detect', style: { textAlign: 'center', paddingTop: 50 } },
	        _react2.default.createElement(_poweredByDyzio2.default, null),
	        _react2.default.createElement(
	          _reactBrowserDetection2.default,
	          null,
	          _browserHandler2.default.handle
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _recompose.compose)(_withGuestIntercom2.default)(AccessDenied);

/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouter = __webpack_require__(37);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HEADER_STYLE = { textAlign: 'center' };
	var PRIMARY_PINK = _extends({ color: '#fc4085' }, HEADER_STYLE);
	var PRIMARY_GREEN = _extends({ color: '#20c49e' }, HEADER_STYLE);
	var PRIMARY_ORANGE = _extends({ color: '#fdb02b' }, HEADER_STYLE);
	var DESC_STYLE = { textAlign: 'center', color: 'rgba(0,0,0,.4)' };
	var CARD_GROUP_STYLE = { margin: 14 };
	var NO_MARGIN = { margin: 0 };
	
	var ACRSetup = function ACRSetup(_ref) {
	  var campaignId = _ref.campaignId,
	      router = _ref.router,
	      acrScanLoading = _ref.acrScanLoading,
	      handleACRScan = _ref.handleACRScan,
	      addChannelDisabled = _ref.addChannelDisabled,
	      channelAdded = _ref.channelAdded,
	      acrScanDisabled = _ref.acrScanDisabled;
	
	  var platformName = _themeSelector2.default.theme().platformName || 'dyzio';
	  var items = [{
	    header: _react2.default.createElement(
	      'h3',
	      { style: PRIMARY_PINK },
	      '1. Add Channel'
	    ),
	    color: 'pink',
	    meta: _react2.default.createElement(_semanticUiReact.Divider, null),
	    style: channelAdded ? { opacity: 0.6 } : {},
	    description: _react2.default.createElement(
	      'div',
	      { style: DESC_STYLE },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Select the influencer or Instagram channel from your My Influencers database.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        ' Only one channel can be automatically tracked.'
	      )
	    ),
	    extra: _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(_semanticUiReact.Button, {
	        color: 'pink',
	        inverted: true,
	        icon: channelAdded ? 'check' : 'plus',
	        content: channelAdded ? 'Channel Added' : 'Add Channel',
	        disabled: addChannelDisabled,
	        onClick: function onClick() {
	          return router.push('/acr-campaign/' + campaignId + '/invite');
	        }
	      })
	    )
	  }, {
	    header: _react2.default.createElement(
	      'h3',
	      { style: PRIMARY_GREEN },
	      '2. Request Authorisation'
	    ),
	    color: 'green',
	    meta: _react2.default.createElement(_semanticUiReact.Divider, null),
	    style: !channelAdded ? { opacity: 0.6 } : {},
	    description: _react2.default.createElement(
	      'div',
	      { style: DESC_STYLE },
	      _react2.default.createElement(
	        'p',
	        null,
	        'To automatically track Instagram Post impressions and reach plus'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Instagram Stories data the channel needs to be authenticated to ' + platformName + '.'
	      )
	    ),
	    extra: _react2.default.createElement(
	      'div',
	      { style: DESC_STYLE },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Use the pink hamburger button ',
	        '(',
	        _react2.default.createElement(_semanticUiReact.Icon, { style: NO_MARGIN, name: 'bars' }),
	        ')',
	        ' on the'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'influencer card to send an authorisation request.'
	      )
	    )
	  }, {
	    header: _react2.default.createElement(
	      'h3',
	      { style: PRIMARY_ORANGE },
	      '3. View Dashboard'
	    ),
	    color: 'orange',
	    meta: _react2.default.createElement(_semanticUiReact.Divider, null),
	    description: _react2.default.createElement(
	      'div',
	      { style: DESC_STYLE },
	      _react2.default.createElement(
	        'p',
	        null,
	        'All new Posts and Stories, from the selected channel, will be added to the dashboard daily.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can also scan the latest posts, click below.'
	      )
	    ),
	    style: !channelAdded ? { opacity: 0.6 } : {},
	    extra: _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(_semanticUiReact.Button, {
	        loading: acrScanLoading,
	        disabled: acrScanDisabled,
	        onClick: handleACRScan,
	        color: 'orange',
	        inverted: true,
	        icon: 'search',
	        content: 'Scan for latest posts'
	      })
	    )
	  }];
	  return _react2.default.createElement(
	    'div',
	    { style: CARD_GROUP_STYLE },
	    _react2.default.createElement(
	      'div',
	      { style: CARD_GROUP_STYLE },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Automated Channel Report Set-up'
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: { color: 'rgba(0,0,0,.4)' } },
	        'To learn how Automated Channel Reports work ',
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://help.dyzio.co/articles/3085024-automated-campaign-report',
	            target: '_blank',
	            rel: 'noopener noreferrer'
	          },
	          'click here'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Group,
	      { itemsPerRow: items.length, centered: true },
	      _lodash2.default.map(items, function (card) {
	        return _react2.default.createElement(_semanticUiReact.Card, card);
	      })
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	  );
	};
	
	ACRSetup.propTypes = {
	  campaignId: _propTypes2.default.string.isRequired,
	  history: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(ACRSetup);

/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var closeModalIconStyle = {
	  float: 'right',
	  cursor: 'pointer'
	};
	
	var noPadding = {
	  padding: 0
	};
	
	var labelStyle = {
	  fontSize: '16px'
	};
	
	var AddTeamMemberForm = function AddTeamMemberForm(props) {
	  var errors = props.errors,
	      user = props.user,
	      addingUser = props.addingUser,
	      formChangeHandler = props.formChangeHandler,
	      addUserHandler = props.addUserHandler,
	      popupToggleHandler = props.popupToggleHandler;
	  var name = user.name,
	      email = user.email;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      open: true, size: 'tiny',
	      onClose: popupToggleHandler,
	      closeOnEscape: true
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Header,
	      { className: 'align-center' },
	      'Add a new team member',
	      _react2.default.createElement(_semanticUiReact.Icon, {
	        name: 'delete',
	        style: closeModalIconStyle,
	        onClick: popupToggleHandler
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      errors && (errors.name || errors.email) && _react2.default.createElement(_semanticUiReact.Message, {
	        error: true,
	        header: 'There were some errors with your submission',
	        list: _lodash2.default.values(errors)
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Form,
	        { onSubmit: addUserHandler, onChange: formChangeHandler },
	        _react2.default.createElement(
	          _semanticUiReact.Form.Group,
	          { inline: true },
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            { width: 4 },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'name', style: labelStyle },
	              'Name'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            { error: errors.name, inline: true, width: 12, style: noPadding },
	            _react2.default.createElement(_semanticUiReact.Input, { id: 'name', name: 'name', value: name, style: noPadding, onChange: formChangeHandler })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Form.Group,
	          { inline: true },
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            { width: 4 },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'email', style: labelStyle },
	              'Email'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            { error: errors.email, inline: true, width: 12, style: noPadding },
	            _react2.default.createElement(_semanticUiReact.Input, { id: 'email', name: 'email', value: email, onChange: formChangeHandler })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Form.Group,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Form.Field,
	            { width: 16 },
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                loading: addingUser,
	                disabled: addingUser,
	                fluid: true,
	                color: 'pink'
	              },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' }),
	              ' Add team member'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	AddTeamMemberForm.propTypes = {
	  errors: _propTypes2.default.array.isRequired,
	  user: _propTypes2.default.object.isRequired,
	  addingUser: _propTypes2.default.bool.isRequired,
	  addUserHandler: _propTypes2.default.func.isRequired,
	  formChangeHandler: _propTypes2.default.func.isRequired,
	  popupToggleHandler: _propTypes2.default.func.isRequired
	};
	
	exports.default = AddTeamMemberForm;

/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _analyticsTooltip = __webpack_require__(858);
	
	var _analyticsTooltip2 = _interopRequireDefault(_analyticsTooltip);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _resourceDelete = __webpack_require__(2193);
	
	var _resourceDelete2 = _interopRequireDefault(_resourceDelete);
	
	var _removable = __webpack_require__(2019);
	
	var _removable2 = _interopRequireDefault(_removable);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YOUTUBE_COMPLIANT = false;
	
	var renderText = function renderText(text) {
	  return _react2.default.createElement(
	    'p',
	    null,
	    text
	  );
	};
	var renderTooltip = function renderTooltip(description, main, percentage) {
	  return _react2.default.createElement(
	    _analyticsTooltip2.default,
	    { content: description, style: 'analytics-small-frame' },
	    _react2.default.createElement(
	      'p',
	      { className: 'small' },
	      main
	    ),
	    YOUTUBE_COMPLIANT && _react2.default.createElement(
	      'p',
	      { className: 'small light' },
	      percentage
	    )
	  );
	};
	
	var AssetListContent = function AssetListContent(_ref) {
	  var data = _ref.data,
	      viewVideo = _ref.viewVideo,
	      openEngagementScoreModal = _ref.openEngagementScoreModal,
	      filterBy = _ref.filterBy;
	
	  if (!data) return null;
	
	  var title = data.get('title');
	  var id = data.get('id');
	  var type = data.get('type') || 'trackedAssets';
	  var assetId = data.get('assetId');
	  var thumbnail = data.get('thumbnail');
	  var influencerName = data.get('influencerName');
	  var engagementScore = data.get('engagementScore');
	  var likes = data.get('likes');
	  var reactions = data.get('reactions') || 0;
	  var shares = data.get('shares') || 0;
	  var reach = data.get('reach') || 0;
	  var dislikes = data.get('dislikes') || null;
	  var comments = data.get('comments') || 0;
	  var followers = data.get('followers') || 0;
	  var views = data.get('views');
	  var campaignName = data.getIn(['campaign', 'name']);
	  var discussionName = data.getIn(['discussion', 'name']);
	  var channelTitle = data.get('channelTitle');
	  var publishedDate = data.get('publishedDate');
	  var isUserAsset = data.get('campaign') ? false : true;
	  var platform = data.get('platform');
	  var assetType = data.get('assetType');
	  var isVideo = data.get('isVideo');
	  var retweets = data.get('retweets');
	  var addExtraInfo = platform === _staticConfiguration.FACEBOOK || platform === _staticConfiguration.INSTAGRAM ? true : false;
	  var extraTitleInfo = isVideo ? ' (video)' : ' (image)';
	
	  var facebookContent = {
	    first: renderText((0, _formatting.scientificFormat)(shares)), // shares
	    second: renderText((0, _formatting.scientificFormat)(likes)),
	    third: renderText((0, _formatting.scientificFormat)(reactions)),
	    fourth: renderText((0, _formatting.scientificFormat)(comments)),
	    fifth: renderText((0, _formatting.scientificFormat)(views))
	  };
	
	  var twitterContent = {
	    first: renderText((0, _formatting.scientificFormat)(retweets)),
	    second: renderText((0, _formatting.scientificFormat)(likes)),
	    third: renderText('-'),
	    fourth: renderText((0, _formatting.scientificFormat)(reach)),
	    fifth: renderText('-')
	  };
	
	  var instagramContent = {
	    first: renderTooltip('Number of likes as a percentage of followers.', (0, _formatting.scientificFormat)(likes), (0, _formatting.formatNumberWithPercentage)(likes, followers)),
	    second: renderTooltip('Number of comments as a percentage of followers.', (0, _formatting.scientificFormat)(comments), (0, _formatting.formatNumberWithPercentage)(comments, followers)),
	    third: renderText((0, _formatting.scientificFormat)(followers)),
	    fourth: isVideo ? renderText((0, _formatting.scientificFormat)(views)) : renderText('N/A'),
	    fifth: renderText(engagementScore)
	  };
	
	  var youtubeContent = {
	    first: renderTooltip('Number of likes as a percentage of views.', (0, _formatting.scientificFormat)(likes), (0, _formatting.formatNumberWithPercentage)(likes, views)),
	    second: renderTooltip('Number of dislikes as a percentage of views.', (0, _formatting.scientificFormat)(dislikes), (0, _formatting.formatNumberWithPercentage)(dislikes, views)),
	    third: renderTooltip('Number of comments as a percentage of views.', (0, _formatting.scientificFormat)(comments), (0, _formatting.formatNumberWithPercentage)(comments, views)),
	    fourth: renderText((0, _formatting.scientificFormat)(views)),
	    fifth: renderText('-'),
	    fifthReal: renderText(engagementScore)
	  };
	
	  var contentOptions = {
	    FACEBOOK: facebookContent,
	    INSTAGRAM: instagramContent,
	    YOUTUBE: youtubeContent,
	    TWITTER: twitterContent
	  };
	
	  var localStyles = {
	    textAlign: 'center'
	  };
	
	  return _react2.default.createElement(
	    _removable2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'asset-card' },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-item' },
	        thumbnail && _react2.default.createElement('img', { onClick: viewVideo, className: 'thumbnail', src: thumbnail, alt: title }),
	        !thumbnail && _react2.default.createElement(
	          'p',
	          { style: localStyles },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter', color: 'grey', size: 'large' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-spacer' },
	        channelTitle && _react2.default.createElement(
	          'p',
	          { className: 'small' },
	          channelTitle
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'small' },
	          _react2.default.createElement(
	            'a',
	            { onClick: viewVideo },
	            title.slice(0, 50).trim(),
	            title.length > 50 ? '...' : '',
	            addExtraInfo ? extraTitleInfo : ''
	          )
	        ),
	        filterBy !== 'myVideos' && campaignName && discussionName && _react2.default.createElement(
	          'p',
	          { className: 'tiny' },
	          campaignName,
	          ' \xA0>\xA0 ',
	          discussionName
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-item stat' },
	        contentOptions[platform].first
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-item stat' },
	        contentOptions[platform].second
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-item stat' },
	        contentOptions[platform].third
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-item stat' },
	        contentOptions[platform].fourth
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-item stat' },
	        contentOptions[platform].fifth
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-item-small actionX' },
	        _react2.default.createElement(_resourceDelete2.default, { resourceId: id, resourceType: type, visible: isUserAsset })
	      )
	    )
	  );
	};
	
	AssetListContent.propTypes = {
	  openEngagementScoreModal: _react2.default.PropTypes.func.isRequired
	};
	
	exports.default = AssetListContent;

/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _staticConfiguration = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsAssetListHeader = function AnalyticsAssetListHeader(_ref) {
	  var listName = _ref.listName,
	      listSize = _ref.listSize,
	      openEngagementScoreModal = _ref.openEngagementScoreModal;
	
	  if (!listName) return null;
	
	  var youtubeHeaders = {
	    first: { name: 'likes' },
	    second: { name: 'dislikes' },
	    third: { name: 'comments' },
	    fourth: { name: 'views' },
	    fifth: { name: 'engagement', showEngagementIcon: true }
	  };
	
	  var facebookHeaders = {
	    first: { name: 'shares' },
	    second: { name: 'likes' },
	    third: { name: 'reactions' },
	    fourth: { name: 'comments' },
	    fifth: { name: 'views', showEngagementIcon: false }
	  };
	
	  var instagramHeaders = {
	    first: { name: 'likes' },
	    second: { name: 'comments' },
	    third: { name: 'followers' },
	    fourth: { name: 'views' },
	    fifth: { name: 'engagement', showEngagementIcon: true }
	  };
	
	  var twitterHeaders = {
	    first: { name: 'retweets' },
	    second: { name: 'likes' },
	    third: { name: 'replies' },
	    fourth: { name: 'reach' },
	    fifth: { name: 'engagement', showEngagementIcon: true }
	  };
	
	  var headerOptions = {
	    YOUTUBE: youtubeHeaders,
	    FACEBOOK: facebookHeaders,
	    INSTAGRAM: instagramHeaders,
	    TWITTER: twitterHeaders
	  };
	
	  var header = headerOptions[listName];
	  var first = header.first,
	      second = header.second,
	      third = header.third,
	      fourth = header.fourth,
	      fifth = header.fifth;
	
	  var renderListName = listName.toLowerCase();
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'asset-list-header' },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-spacer' },
	      _react2.default.createElement('img', { src: '/icons/' + renderListName + '-round.svg', alt: renderListName }),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\xA0',
	        '' + renderListName.charAt(0).toUpperCase() + renderListName.slice(1) + ' (' + listSize + ')'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item stat' },
	      _react2.default.createElement(
	        'p',
	        null,
	        first.name
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item stat' },
	      _react2.default.createElement(
	        'p',
	        null,
	        second.name
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item stat' },
	      _react2.default.createElement(
	        'p',
	        null,
	        third.name
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item stat' },
	      _react2.default.createElement(
	        'p',
	        null,
	        fourth.name
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item stat' },
	      _react2.default.createElement(
	        'div',
	        { className: 'info-hover-wrapper' },
	        _react2.default.createElement(
	          'p',
	          null,
	          fifth.name
	        ),
	        fifth.showEngagementIcon && _react2.default.createElement('div', { className: 'info-hover-icon', onClick: openEngagementScoreModal })
	      )
	    ),
	    _react2.default.createElement('div', { className: 'flex-item-small' })
	  );
	};
	
	exports.default = AnalyticsAssetListHeader;

/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsAssetListFooter = function AnalyticsAssetListFooter(_ref) {
	  var listName = _ref.listName,
	      totals = _ref.totals,
	      openEngagementScoreModal = _ref.openEngagementScoreModal;
	
	  if (!listName) return null;
	
	  var likes = (0, _formatting.scientificFormat)(totals.get('likes'));
	  var dislikes = (0, _formatting.scientificFormat)(totals.get('dislikes'));
	  var comments = (0, _formatting.scientificFormat)(totals.get('comments'));
	  var views = (0, _formatting.scientificFormat)(totals.get('views'));
	  var engagement = (0, _formatting.scientificFormat)(totals.get('engagement'));
	  var shares = (0, _formatting.scientificFormat)(totals.get('shares'));
	  var reach = (0, _formatting.scientificFormat)(totals.get('reach'));
	  var retweets = (0, _formatting.scientificFormat)(totals.get('retweets'));
	  var reactions = (0, _formatting.scientificFormat)(totals.get('reactions'));
	  var followers = (0, _formatting.scientificFormat)(totals.get('followers'));
	
	  var youtubeTotals = {
	    first: likes,
	    second: dislikes,
	    third: comments,
	    fourth: views,
	    fifth: engagement
	  };
	
	  var facebookTotals = {
	    first: shares, // shares
	    second: likes,
	    third: reactions,
	    fourth: comments,
	    fifth: views //engage
	  };
	
	  var twitterTotals = {
	    first: retweets,
	    second: likes,
	    third: comments,
	    fourth: reach,
	    fifth: ''
	  };
	
	  var instagramTotals = {
	    first: likes,
	    second: comments,
	    third: followers,
	    fourth: views,
	    fifth: engagement
	  };
	
	  var footerOptions = {
	    YOUTUBE: youtubeTotals,
	    FACEBOOK: facebookTotals,
	    INSTAGRAM: instagramTotals,
	    TWITTER: twitterTotals
	  };
	
	  var footerTotals = footerOptions[listName];
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'asset-list-totals' },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-spacer' },
	      _react2.default.createElement(
	        'h4',
	        null,
	        '\xA0\xA0\xA0TOTALS'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item stat' },
	      _react2.default.createElement(
	        'p',
	        { className: 'large' },
	        footerTotals.first
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item stat' },
	      _react2.default.createElement(
	        'p',
	        { className: 'large' },
	        footerTotals.second
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item stat' },
	      _react2.default.createElement(
	        'p',
	        { className: 'large' },
	        footerTotals.third
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item stat' },
	      _react2.default.createElement(
	        'p',
	        { className: 'large' },
	        footerTotals.fourth
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item stat' },
	      _react2.default.createElement(
	        'p',
	        { className: 'large' },
	        footerTotals.fifth
	      )
	    ),
	    _react2.default.createElement('div', { className: 'flex-item-small' })
	  );
	};
	
	exports.default = AnalyticsAssetListFooter;

/***/ },
/* 1880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAvatar = __webpack_require__(701);
	
	var _reactAvatar2 = _interopRequireDefault(_reactAvatar);
	
	var _socialBar = __webpack_require__(2026);
	
	var _socialBar2 = _interopRequireDefault(_socialBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsInfluencerCard = function AnalyticsInfluencerCard(_ref) {
	  var trackedAsset = _ref.trackedAsset,
	      influencerProfile = _ref.influencerProfile;
	
	  if (!trackedAsset || !influencerProfile) return null;
	  var youtubeCount = influencerProfile.aggregateYoutubeChannelStatistics ? influencerProfile.aggregateYoutubeChannelStatistics.subscriberCount : 0;
	  var facebookCount = influencerProfile.facebookStatistics ? influencerProfile.facebookStatistics.likes : 0;
	  var twitterCount = influencerProfile.twitterStatistics ? influencerProfile.twitterStatistics.followersCount : 0;
	  var instagramCount = 0;
	  return _react2.default.createElement(
	    'div',
	    { className: 'influencer-card' },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item' },
	      _react2.default.createElement(_reactAvatar2.default, { name: trackedAsset.influencerName, round: true, size: 100, src: influencerProfile.thumbnail })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        trackedAsset.influencerName
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'light' },
	        influencerProfile.countryCode
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-spacer' },
	      _react2.default.createElement(_socialBar2.default, {
	        influencerId: influencerProfile.id,
	        data: [{
	          channel: 'youtube',
	          count: youtubeCount
	        }, {
	          channel: 'facebook',
	          count: facebookCount
	        }, {
	          channel: 'instagram',
	          count: instagramCount
	        }, {
	          channel: 'twitter',
	          count: twitterCount
	        }],
	        dataTotal: youtubeCount + facebookCount + instagramCount + twitterCount
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-item' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        influencerProfile.totalSocialReach.toLocaleString()
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'light' },
	        'Total reach'
	      )
	    )
	  );
	};
	
	exports.default = AnalyticsInfluencerCard;

/***/ },
/* 1881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlayer = __webpack_require__(453);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactFacebookPlayer = __webpack_require__(3350);
	
	var _reactFacebookPlayer2 = _interopRequireDefault(_reactFacebookPlayer);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _helperFunctions = __webpack_require__(107);
	
	var _formatting = __webpack_require__(62);
	
	var _analyticsTooltip = __webpack_require__(858);
	
	var _analyticsTooltip2 = _interopRequireDefault(_analyticsTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderVideo = function renderVideo(videoUrl, wrapperStyle) {
	  if (!videoUrl) return null;
	  return _react2.default.createElement(
	    'div',
	    { className: wrapperStyle },
	    _react2.default.createElement(_reactPlayer2.default, { url: videoUrl, width: '100%', height: '100%', controls: true })
	  );
	};
	
	var renderFacebookVideo = function renderFacebookVideo(videoId) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'facebook-wrapper' },
	    _react2.default.createElement(_reactFacebookPlayer2.default, {
	      videoId: videoId,
	      appId: ("307083449705342"),
	      width: 400
	    })
	  );
	};
	
	var renderImage = function renderImage(thumbnail) {
	  if (!thumbnail) return null;
	  return _react2.default.createElement(
	    'div',
	    { className: 'instagram-wrapper' },
	    _react2.default.createElement('img', { src: thumbnail })
	  );
	};
	
	var YOUTUBE_COMPLIANT = false;
	
	var renderTooltip = function renderTooltip(description, title, value, denominator) {
	  return _react2.default.createElement(
	    _analyticsTooltip2.default,
	    { content: description, style: 'analytics-frame' },
	    renderStatsItem(title, value, denominator)
	  );
	};
	
	var renderStatsItem = function renderStatsItem(title, value, denominator) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'stats' },
	    _react2.default.createElement(
	      'p',
	      { className: 'bold' },
	      title
	    ),
	    _react2.default.createElement('div', { className: 'spacer small' }),
	    _react2.default.createElement(
	      'h4',
	      null,
	      (0, _formatting.scientificFormat)(value)
	    ),
	    YOUTUBE_COMPLIANT && value > 0 && denominator > 0 ? _react2.default.createElement(
	      'p',
	      { className: 'light' },
	      (0, _formatting.formatNumberWithPercentage)(value, denominator)
	    ) : null
	  );
	};
	
	var AnalyticsVideoInfoCard = function AnalyticsVideoInfoCard(_ref) {
	  var trackedAsset = _ref.trackedAsset,
	      budget = _ref.budget,
	      onBudgetChange = _ref.onBudgetChange,
	      openEngagementScoreModal = _ref.openEngagementScoreModal;
	
	  if (!trackedAsset || !trackedAsset.assetId) return null;
	
	  var denominator = trackedAsset.isVideo ? { value: trackedAsset.views, name: 'views' } : { value: trackedAsset.followers, name: 'followers' };
	  var platform = trackedAsset.platform;
	
	  var youtubeInfo = {
	    asset: renderVideo(trackedAsset.videoUrl, 'asset-wrapper'),
	    first: renderTooltip('Number of likes as a percentage of views.', 'likes', trackedAsset.likes, denominator.value),
	    second: renderTooltip('Number of dislikes as a percentage of views.', 'dislikes', trackedAsset.dislikes, denominator.value),
	    third: renderTooltip('Number of comment as a percentage of views.', 'comments', trackedAsset.comments, denominator.value),
	    fourth: renderStatsItem('dyzio score', trackedAsset.engagementScore),
	    fifth: renderStatsItem(denominator.name, denominator.value),
	    showCostPerView: true
	  };
	
	  var instagramInfo = {
	    asset: trackedAsset.isVideo ? renderVideo(trackedAsset.videoUrl) : renderImage(trackedAsset.thumbnail, 'instagram-wrapper'),
	    first: renderTooltip('Number of likes as a percentage of views.', 'likes', trackedAsset.likes, denominator.value),
	    second: renderTooltip('Number of comment as a percentage of views.', 'comments', trackedAsset.comments, denominator.value),
	    third: renderStatsItem('engagement', trackedAsset.engagementScore),
	    fourth: trackedAsset.isVideo ? renderStatsItem(denominator.name, denominator.value) : null,
	    fifth: renderStatsItem('followers', trackedAsset.followers),
	    showCostPerView: trackedAsset.isVideo
	  };
	
	  var facebookInfo = {
	    asset: trackedAsset.isVideo ? renderFacebookVideo(trackedAsset.assetId) : renderImage(trackedAsset.thumbnail, 'instagram-wrapper'),
	    first: renderStatsItem('shares', trackedAsset.shares),
	    second: renderStatsItem('likes', trackedAsset.likes),
	    third: renderStatsItem('reactions', trackedAsset.reactions),
	    fourth: renderStatsItem('comments', trackedAsset.comments),
	    fifth: renderStatsItem('views', trackedAsset.views)
	  };
	
	  var infoOptions = {
	    YOUTUBE: youtubeInfo,
	    INSTAGRAM: instagramInfo,
	    FACEBOOK: facebookInfo
	  };
	
	  var analyticsInfo = infoOptions[platform];
	
	  var wordBreak = { wordBreak: 'break-word' };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'info-card' },
	    _react2.default.createElement(
	      'div',
	      { className: 'info-left' },
	      analyticsInfo.asset
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'info-right' },
	      _react2.default.createElement(
	        'div',
	        { className: 'column-item' },
	        trackedAsset.publishedDate && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'p',
	            { className: 'bold' },
	            'Live date: '
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            (0, _moment2.default)(trackedAsset.publishedDate).format('Do MMM')
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'column-item' },
	        trackedAsset.copy && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('div', { className: 'spacer small' }),
	          _react2.default.createElement(
	            'p',
	            { className: 'bold' },
	            'Copy: '
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: wordBreak },
	            trackedAsset.copy
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'column-item' },
	        analyticsInfo.first && _react2.default.createElement(
	          'div',
	          { className: 'video-card' },
	          analyticsInfo.first && _react2.default.createElement(
	            'div',
	            { className: 'flex-item' },
	            analyticsInfo.first
	          ),
	          analyticsInfo.second && _react2.default.createElement(
	            'div',
	            { className: 'flex-item' },
	            analyticsInfo.second
	          ),
	          analyticsInfo.third && _react2.default.createElement(
	            'div',
	            { className: 'flex-item' },
	            analyticsInfo.third
	          ),
	          analyticsInfo.fourth && _react2.default.createElement(
	            'div',
	            { className: 'flex-item' },
	            analyticsInfo.fourth
	          ),
	          analyticsInfo.fifth && _react2.default.createElement(
	            'div',
	            { className: 'flex-item' },
	            analyticsInfo.fifth
	          ),
	          analyticsInfo.sixth && _react2.default.createElement(
	            'div',
	            { className: 'flex-item' },
	            analyticsInfo.sixth
	          )
	        )
	      ),
	      analyticsInfo.showCostPerView && _react2.default.createElement(
	        'div',
	        { className: 'column-item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'calculator' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Cost per view?'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'small' },
	            'Add the budget for this video to get the cost per view'
	          ),
	          _react2.default.createElement('div', { className: 'spacer' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'calculator-input' },
	            _react2.default.createElement('input', { name: 'budget', id: 'budget', type: 'number', value: budget, onChange: onBudgetChange, placeholder: '0.00', step: 'any', min: '0' }),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'budget' },
	              _react2.default.createElement(
	                'span',
	                { className: 'small' },
	                '\xA3'
	              )
	            ),
	            trackedAsset && budget && _react2.default.createElement(
	              'p',
	              { className: 'result' },
	              '\xA3',
	              (0, _helperFunctions.roundNumberToSmallestDecimal)(budget / trackedAsset.views, 0)
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	AnalyticsVideoInfoCard.propTypes = {
	  onBudgetChange: _react2.default.PropTypes.func.isRequired,
	  openEngagementScoreModal: _react2.default.PropTypes.func
	};
	
	exports.default = AnalyticsVideoInfoCard;

/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = _themeSelector2.default.theme();
	
	var logoStyle = {
	  display: 'block',
	  margin: '50px auto 30px auto',
	  maxWidth: '100%'
	};
	
	var TokenThanks = function TokenThanks() {
	  if (theme.tokenThanksRedirectUrl) {
	    console.log('TokenThanks', theme.tokenThanksRedirectUrl);
	    window.location = theme.tokenThanksRedirectUrl;
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'page' },
	    _react2.default.createElement(
	      'div',
	      { className: 'page-content' },
	      _react2.default.createElement(
	        'a',
	        { href: '/' },
	        _react2.default.createElement('img', { style: logoStyle, src: theme.darkLogo.src, alt: theme.darkLogo.alt, height: '100' })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { container: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer', computer: '3' }),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { computer: '10', mobile: '16' },
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { textAlign: 'center', size: 'small' },
	              !theme.tokenThanksMessage && _react2.default.createElement(
	                'h1',
	                { style: { textAlign: 'center' } },
	                'Thanks for applying!',
	                _react2.default.createElement('br', null),
	                'We will send your discount code ASAP...'
	              ),
	              theme.tokenThanksMessage && _react2.default.createElement(
	                'h1',
	                { style: { textAlign: 'center' } },
	                theme.tokenThanksMessage
	              ),
	              !theme.tokenThanksMessage && _react2.default.createElement(_semanticUiReact.Divider, null),
	              !theme.tokenThanksMessage && _react2.default.createElement(
	                'p',
	                { className: 'info' },
	                'Our support team will be in touch if there are any issues.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer', computer: '3' })
	      )
	    )
	  );
	};
	
	exports.default = (0, _recompose.compose)()(TokenThanks);

/***/ },
/* 1883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ApprovalCountDetailsTable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ApprovalCountDetailsTable(_ref) {
	  var data = _ref.data;
	
	  var getData = function getData(countryCode, periodData) {
	    var countries = _lodash2.default.get(periodData, 'countries', []);
	    var country = _lodash2.default.find(countries, ['country', countryCode]);
	    var statusCounts = _lodash2.default.get(country, 'statusCounts', []);
	    var rejected = _lodash2.default.find(statusCounts, ['status', 'REJECTED']);
	    var approved = _lodash2.default.find(statusCounts, ['status', 'APPROVED']);
	    return { rejected: _lodash2.default.get(rejected, 'count', '-'), approved: _lodash2.default.get(approved, 'count', '-') };
	  };
	  var countryFilters = [{ code: 'DE', name: 'Germany' }, { code: 'FR', name: 'France' }, { code: 'IT', name: 'Italy' }, { code: 'ES', name: 'Spain' }];
	
	  var getTotals = function getTotals(itemsData, countryCode) {
	    var allCountries = _lodash2.default.map(itemsData, 'countries');
	    var groupedByCountry = _lodash2.default.groupBy(_lodash2.default.flatten(allCountries), 'country');
	    var statusCounts = _lodash2.default.map(groupedByCountry, function (group) {
	      var totalApproved = _lodash2.default.sumBy(group, function (g) {
	        var approved = _lodash2.default.find(g.statusCounts, ['status', 'APPROVED']);
	        return _lodash2.default.get(approved, 'count', 0);
	      });
	      var totalRejected = _lodash2.default.sumBy(group, function (g) {
	        var rejected = _lodash2.default.find(g.statusCounts, ['status', 'REJECTED']);
	        return _lodash2.default.get(rejected, 'count', 0);
	      });
	      var approved = totalApproved;
	      var rejected = totalRejected;
	      return { country: _lodash2.default.get(group, '[0].country', '-'), approved: approved, rejected: rejected };
	    });
	
	    return _lodash2.default.find(statusCounts, ['country', countryCode]);
	  };
	
	  var itemDate = function itemDate(item) {
	    return (0, _moment2.default)(item.date);
	  };
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { celled: true },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Header,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Date'
	        ),
	        _lodash2.default.map(countryFilters, function (country) {
	          return _react2.default.createElement(
	            _semanticUiReact.Table.HeaderCell,
	            { key: country.code, colSpan: '2' },
	            country.name
	          );
	        })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Approved'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Rejected'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Approved'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Rejected'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Approved'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Rejected'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Approved'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Rejected'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      !_lodash2.default.isEmpty(data) && _lodash2.default.map(_lodash2.default.orderBy(data, itemDate, ['desc']), function (item) {
	        return _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          { key: item.date },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            item.date
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            getData('DE', item).approved
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            getData('DE', item).rejected
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            getData('FR', item).approved
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            getData('FR', item).rejected
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            getData('IT', item).approved
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            getData('IT', item).rejected
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            getData('ES', item).approved
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            getData('ES', item).rejected
	          )
	        );
	      })
	    ),
	    !_lodash2.default.isEmpty(data) && _react2.default.createElement(
	      _semanticUiReact.Table.Footer,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Total'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          _lodash2.default.get(getTotals(data, 'DE'), 'approved', '-')
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          _lodash2.default.get(getTotals(data, 'DE'), 'rejected', '-')
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          _lodash2.default.get(getTotals(data, 'FR'), 'approved', '-')
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          _lodash2.default.get(getTotals(data, 'FR'), 'rejected', '-')
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          _lodash2.default.get(getTotals(data, 'IT'), 'approved', '-')
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          _lodash2.default.get(getTotals(data, 'IT'), 'rejected', '-')
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          _lodash2.default.get(getTotals(data, 'ES'), 'approved', '-')
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          _lodash2.default.get(getTotals(data, 'ES'), 'rejected', '-')
	        )
	      )
	    )
	  );
	}
	
	ApprovalCountDetailsTable.propTypes = {
	  data: _propTypes2.default.array
	};
	ApprovalCountDetailsTable.defaultProps = {
	  data: []
	};

/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ApprovalsCountTable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ApprovalsCountTable(_ref) {
	  var isLoading = _ref.isLoading,
	      isRefetching = _ref.isRefetching,
	      items = _ref.items,
	      targets = _ref.targets,
	      onRefetch = _ref.onRefetch,
	      title = _ref.title,
	      onClick = _ref.onClick;
	
	  var getProcessedData = function getProcessedData(itemsData) {
	    var allCountries = _lodash2.default.map(itemsData, 'countries');
	    var groupedByCountry = _lodash2.default.groupBy(_lodash2.default.flatten(allCountries), 'country');
	    var statusCounts = _lodash2.default.map(groupedByCountry, function (group) {
	      var totalApproved = _lodash2.default.sumBy(group, function (g) {
	        var approved = _lodash2.default.find(g.statusCounts, ['status', 'APPROVED']);
	        return _lodash2.default.get(approved, 'count', 0);
	      });
	      var totalRejected = _lodash2.default.sumBy(group, function (g) {
	        var rejected = _lodash2.default.find(g.statusCounts, ['status', 'REJECTED']);
	        return _lodash2.default.get(rejected, 'count', 0);
	      });
	      var approved = totalApproved;
	      var rejected = totalRejected;
	      return { country: _lodash2.default.get(group, '[0].country', '-'), approved: approved, rejected: rejected };
	    });
	    var countryFilters = [{ code: 'DE', name: 'Germany' }, { code: 'FR', name: 'France' }, { code: 'IT', name: 'Italy' }, { code: 'ES', name: 'Spain' }];
	
	    return _lodash2.default.map(countryFilters, function (country) {
	      var data = _lodash2.default.find(statusCounts, ['country', country.code]);
	      return {
	        country: country.name,
	        countryCode: country.code,
	        approved: _lodash2.default.get(data, 'approved', '-'),
	        rejected: _lodash2.default.get(data, 'rejected', '-')
	      };
	    });
	  };
	  var titleStyles = {
	    cursor: onClick ? 'pointer' : 'default'
	  };
	  var infoIconStyles = {
	    marginLeft: '5px',
	    fontSize: '18'
	  };
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { celled: true },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Header,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        onClick && _react2.default.createElement(_semanticUiReact.Popup, {
	          content: 'Open details by date',
	          position: 'top center',
	          trigger: _react2.default.createElement(
	            _semanticUiReact.Table.HeaderCell,
	            { style: titleStyles, onClick: onClick, colSpan: 4, textAlign: 'center' },
	            title,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', style: infoIconStyles })
	          )
	        }),
	        !onClick && _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { style: titleStyles, onClick: onClick, colSpan: 4, textAlign: 'center' },
	          title
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Country'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Approved'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Rejected'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Target'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      isLoading && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { colSpan: 4, textAlign: 'center' },
	          'Loading...'
	        )
	      ),
	      !_lodash2.default.isEmpty(items) && _lodash2.default.map(getProcessedData(items), function (item) {
	        return _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          { key: item.country },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            item.country
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            item.approved
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            item.rejected
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _lodash2.default.get(targets, '' + item.countryCode, '-')
	          )
	        );
	      }),
	      !_lodash2.default.isEmpty(items) && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { colSpan: 4, textAlign: 'center' },
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { disabled: isRefetching, loading: isRefetching, color: 'pink', onClick: onRefetch },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh' }),
	            'Refresh data'
	          )
	        )
	      ),
	      _lodash2.default.isEmpty(items) && !isRefetching && !isLoading && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { colSpan: 4, textAlign: 'center' },
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: '10px' } },
	            'There is no data'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { disabled: isRefetching, loading: isRefetching, color: 'pink', onClick: onRefetch },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh' }),
	            'Refresh data'
	          )
	        )
	      )
	    )
	  );
	}
	
	ApprovalsCountTable.propTypes = {
	  isLoading: _propTypes2.default.bool,
	  isRefetching: _propTypes2.default.bool,
	  items: _propTypes2.default.array,
	  onRefetch: _propTypes2.default.func,
	  title: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  targets: _propTypes2.default.object
	};
	
	ApprovalsCountTable.defaultProps = {
	  isLoading: false,
	  isRefetching: false,
	  items: [],
	  onRefetch: _lodash2.default.noop,
	  title: '',
	  onClick: null,
	  targets: {}
	};

/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ApprovalFilter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerCellStyle = {
	  height: 51
	};
	var contentStyles = { paddingTop: '20px' };
	var btnStyles = { border: 'none', width: '80%' };
	var dropdownStyles = { display: 'flex', alignItems: 'center' };
	
	var countryFilters = [{ code: 'DE', name: 'Germany' }, { code: 'FR', name: 'France' }, { code: 'IT', name: 'Italy' }, { code: 'ES', name: 'Spain' }];
	
	var statusOptions = [{ key: 'approved', text: 'Approved', value: 'approved' }, { key: 'rejected', text: 'Rejected', value: 'rejected' }];
	
	var activeColor = '#fc4085';
	var defaultColor = '#1d1937';
	function ApprovalFilter(_ref) {
	  var onFilterChanged = _ref.onFilterChanged,
	      selectedFilter = _ref.selectedFilter;
	
	  var getGroupStyles = function getGroupStyles(value) {
	    var isActive = value === _lodash2.default.get(selectedFilter, 'country', '');
	    return isActive ? {
	      color: activeColor,
	      border: '2px solid ' + activeColor,
	      fontWeight: 600,
	      width: '100%'
	    } : {
	      color: defaultColor,
	      border: '2px solid ' + defaultColor,
	      fontWeight: 600,
	      width: '100%'
	    };
	  };
	  var getButtonTitle = function getButtonTitle(country) {
	    var isActive = country.code === _lodash2.default.get(selectedFilter, 'country', '');
	    var showStatus = isActive && selectedFilter.status;
	    return _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', flexDirection: 'column', color: isActive ? activeColor : defaultColor } },
	      _react2.default.createElement(
	        'span',
	        null,
	        country.name
	      ),
	      showStatus && _react2.default.createElement(
	        'span',
	        { style: { fontSize: '12px', color: 'rgba(0, 0, 0, 0.4)' } },
	        '(',
	        selectedFilter.status,
	        ')'
	      )
	    );
	  };
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Header,
	      { fullWidth: true },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { width: 8, style: headerCellStyle },
	          'Filter by country'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { colSpan: 2 },
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            { padded: true, style: contentStyles },
	            _lodash2.default.map(countryFilters, function (country) {
	              return _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                { key: country.code },
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.ButtonGroup,
	                    { basic: true, style: getGroupStyles(country.code), compact: true },
	                    _react2.default.createElement(
	                      _semanticUiReact.Button,
	                      {
	                        style: btnStyles,
	                        onClick: function onClick() {
	                          return onFilterChanged({ country: country.code, status: null });
	                        },
	                        size: 'large'
	                      },
	                      getButtonTitle(country)
	                    ),
	                    _react2.default.createElement(_semanticUiReact.Dropdown, {
	                      className: 'button icon',
	                      style: dropdownStyles,
	                      options: statusOptions,
	                      floating: true,
	                      onChange: function onChange(e, data) {
	                        onFilterChanged({ country: country.code, status: data.value });
	                      },
	                      trigger: _react2.default.createElement('div', null)
	                    })
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	ApprovalFilter.propTypes = {
	  onFilterChanged: _propTypes2.default.func,
	  selectedFilter: _propTypes2.default.object
	};
	ApprovalFilter.defaultProps = {
	  onFilterChanged: _lodash2.default.noop,
	  selectedFilter: {}
	};

/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PLATFORMS = {
	  twitter: {
	    color: 'blue',
	    name: 'twitter'
	  },
	  instagram: {
	    color: 'pink',
	    name: 'instagram'
	  },
	  facebook: {
	    color: 'pink',
	    name: 'facebook'
	  },
	  youtube: {
	    color: 'red',
	    name: 'youtube'
	  }
	};
	
	var imageStyleSmall = {
	  height: '180px',
	  width: '180px',
	  objectFit: 'cover',
	  display: 'block',
	  margin: '0px auto'
	};
	
	var imageStyleLarge = {
	  height: '300px',
	  width: '306px',
	  objectFit: 'cover',
	  display: 'block',
	  margin: '0px auto'
	};
	
	var divStyleSmall = {
	  height: '150px',
	  padding: '15px',
	  overflow: 'hidden'
	};
	
	var divStyleLarge = {
	  height: '300px',
	  padding: '15px',
	  overflow: 'hidden'
	};
	
	var overflowEllipsis = {
	  whiteSpace: 'nowrap',
	  overflow: 'hidden',
	  textOverflow: 'ellipsis'
	};
	
	var STORY_IMAGE = 'https://s3-eu-west-1.amazonaws.com/dyzio-static-files/images/instagram-story2.png';
	
	var STYLES = {
	  fontSizeLarge: {
	    fontSize: '100%'
	  },
	  fontSizeSmall: {
	    fontSize: '90%'
	  },
	  empty: {},
	  noPaddingBottom: {
	    padding: 10
	  },
	  noPadding: {
	    padding: 0
	  },
	  compactVertical: {
	    padding: '5px 14px'
	  },
	  noVerticalPadding: {
	    padding: '0px 14px'
	  },
	  displayBlock: {
	    display: 'block'
	  },
	  fontGreen: {
	    color: '#20c49e',
	    fontSize: '90%',
	    lineHeight: '12px'
	  },
	  fontGrey: {
	    color: 'grey',
	    fontSize: '90%',
	    lineHeight: '12px'
	  }
	};
	
	var smallText = {
	  fontSize: '90%',
	  lineHeight: '12px'
	};
	
	var DIVIDER = 'DIVIDER';
	
	var LargeCardHeader = function LargeCardHeader(_ref) {
	  var data = _ref.data,
	      displayName = _ref.displayName,
	      lightAsset = _ref.lightAsset,
	      hamburgerOptions = _ref.hamburgerOptions;
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { basic: 'very', singleLine: true, verticalAlign: 'middle' },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        { style: smallText },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { collapsing: true, style: { padding: 0, paddingRight: '5px' } },
	          _react2.default.createElement(_semanticUiReact.Image, {
	            src: data.profilePic,
	            className: 'circular',
	            size: 'mini'
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { style: { padding: 0, paddingRight: '5px' } },
	          _react2.default.createElement(
	            'div',
	            { style: overflowEllipsis },
	            _react2.default.createElement(
	              'div',
	              { style: { color: '#000', fontSize: '90%', lineHeight: '14px' } },
	              _react2.default.createElement(
	                'b',
	                null,
	                displayName
	              ),
	              '\xA0',
	              data.isVerified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue', size: 'small' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { fontSize: '80%', lineHeight: '14px' } },
	              _react2.default.createElement(
	                _targetLink2.default,
	                {
	                  renderIf: true,
	                  href: data.platformPage
	                },
	                '@',
	                data.handle
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { collapsing: true, style: { padding: 0 } },
	          _react2.default.createElement(
	            _semanticUiReact.Dropdown,
	            {
	              icon: null,
	              pointing: 'top right',
	              floating: true,
	              trigger: _react2.default.createElement(_semanticUiReact.Button, { inverted: true, icon: 'bars', color: 'pink', size: 'mini' })
	            },
	            _react2.default.createElement(
	              _semanticUiReact.Dropdown.Menu,
	              null,
	              _lodash2.default.map(hamburgerOptions, function (opt) {
	                if (opt.type === DIVIDER) {
	                  return _react2.default.createElement(_semanticUiReact.Dropdown.Divider, null);
	                }
	
	                if (opt.disabled && opt.popupText) {
	                  return _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(
	                      _semanticUiReact.Dropdown.Item,
	                      {
	                        onClick: _lodash2.default.noop(),
	                        value: opt.value
	                      },
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: opt.icon }),
	                      opt.label
	                    ),
	                    content: opt.popupText
	                  });
	                }
	
	                return _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  {
	                    disabled: opt.disabled,
	                    onClick: function onClick() {
	                      return opt.onClick(lightAsset);
	                    },
	                    value: opt.value
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: opt.icon }),
	                  opt.label
	                );
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var SmallCardHeader = function SmallCardHeader(_ref2) {
	  var displayName = _ref2.displayName,
	      data = _ref2.data;
	  return _react2.default.createElement(
	    'div',
	    { style: { color: '#000' } },
	    _react2.default.createElement(
	      'b',
	      null,
	      displayName
	    ),
	    '\xA0',
	    data.isVerified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue', size: 'small' })
	  );
	};
	
	var hasSupportingData = function hasSupportingData(asset) {
	  var hasData = false;
	  if (asset.localState && asset.localState.supportingFileAdded) {
	    hasData = true;
	  }
	  if (asset.relationships.supportingData.data.length > 0) hasData = true;
	  return hasData;
	};
	
	var isAssetVisible = function isAssetVisible(asset) {
	  var isVisible = true;
	  if (asset.localState && asset.localState.isAssetDeleted) {
	    isVisible = false;
	  }
	  return isVisible;
	};
	
	var BrokenAssetCard = function BrokenAssetCard(_ref3) {
	  var attributes = _ref3.attributes;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'red' }),
	        'Broken Asset'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'red', size: 'huge' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: overflowEllipsis },
	      _react2.default.createElement(
	        'pre',
	        null,
	        attributes.assetURL
	      )
	    )
	  );
	};
	
	var AssetCard = function AssetCard(_ref4) {
	  var asset = _ref4.asset,
	      viewMode = _ref4.viewMode,
	      hamburgerOptions = _ref4.hamburgerOptions;
	
	  var data = {};
	  var atts = asset.attributes;
	  if (atts.assetType === 'STORY') {
	    data = {
	      profilePic: STORY_IMAGE,
	      text: atts.extraData.text,
	      engagements: atts.extraData.opens,
	      mainImageSrc: STORY_IMAGE,
	      displayName: atts.discussionName
	    };
	  } else {
	    if (!atts.initialData) {
	      return _react2.default.createElement(BrokenAssetCard, { attributes: atts });
	    }
	
	    data = atts.initialData.standardFormat;
	  }
	
	  data.extraData = atts.extraData;
	  data.hasSupportingData = hasSupportingData(asset);
	  data.isAssetVisible = isAssetVisible(asset);
	
	  var lightAsset = {
	    type: asset.type,
	    id: asset.id,
	    assetId: asset.attributes.assetId,
	    assetURL: asset.attributes.assetURL,
	    platform: asset.attributes.platform,
	    assetType: asset.attributes.assetType
	  };
	
	  var platform = PLATFORMS[_lodash2.default.lowerCase(asset.attributes.platform)];
	  var largeCard = viewMode === 'cards.large';
	  var imageStyle = largeCard ? imageStyleLarge : imageStyleSmall;
	  var divStyle = largeCard ? divStyleLarge : divStyleSmall;
	
	  var displayName = viewMode === 'cards.large' ? data.displayName : _lodash2.default.truncate(data.displayName, { length: 22, separator: '' });
	
	  return _react2.default.createElement(
	    _semanticUiReact.Transition,
	    { visible: data.isAssetVisible, animation: 'scale', duration: 500, unmountOnHide: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card,
	      { color: platform.color, style: STYLES.fontSizeSmall, key: asset.id },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { style: largeCard ? STYLES.noPaddingBottom : STYLES.empty },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Header,
	          { style: largeCard ? STYLES.fontSizeLarge : STYLES.fontSizeSmall },
	          largeCard ? _react2.default.createElement(LargeCardHeader, {
	            data: data,
	            lightAsset: lightAsset,
	            hamburgerOptions: hamburgerOptions,
	            displayName: displayName
	          }) : _react2.default.createElement(SmallCardHeader, { data: data, displayName: displayName })
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { style: STYLES.noPadding },
	        _react2.default.createElement(
	          _targetLink2.default,
	          {
	            renderIf: true,
	            href: data.assetURL
	          },
	          data.mainImageSrc ? _react2.default.createElement(_semanticUiReact.Image, {
	            src: data.mainImageSrc,
	            style: imageStyle
	          }) : _react2.default.createElement(
	            'div',
	            { style: divStyle },
	            data.text
	          )
	        )
	      ),
	      largeCard && _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { style: STYLES.compactVertical },
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(
	            'span',
	            { style: { fontSize: '90%' } },
	            _lodash2.default.truncate(data.text, { length: 38, separator: '' })
	          ),
	          content: data.text
	        })
	      ),
	      !largeCard && _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { extra: true, style: STYLES.compactVertical },
	        _react2.default.createElement(
	          'div',
	          { style: overflowEllipsis },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: platform.name, color: platform.color }),
	          ' ',
	          (0, _formatting.scientificFormat)(data.engagements),
	          ' engagements'
	        )
	      ),
	      largeCard && _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { style: STYLES.compactVertical },
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very', singleLine: true, fixed: true },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              { style: smallText },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { style: { padding: 0, paddingRight: '5px' } },
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { basic: true, style: STYLES.displayBlock },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'thumbs outline up' }),
	                  ' ',
	                  (0, _formatting.scientificFormat)(data.likes)
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { style: { padding: 0, paddingRight: '5px' } },
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { basic: true, style: STYLES.displayBlock },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'comments outline' }),
	                  ' ',
	                  (0, _formatting.scientificFormat)(data.comments)
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { style: { padding: 0 } },
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { basic: true, style: STYLES.displayBlock },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'share' }),
	                  ' ',
	                  (0, _formatting.scientificFormat)(data.shares)
	                )
	              )
	            )
	          )
	        )
	      ),
	      largeCard && _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { textAlign: 'center' },
	        _react2.default.createElement(
	          'span',
	          { style: data.hasSupportingData ? STYLES.fontGreen : STYLES.fontGrey },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'upload' }),
	          'this indicates manual data'
	        )
	      ),
	      largeCard && _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { style: STYLES.compactVertical, extra: true },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'calendar' }),
	        '\xA0',
	        (0, _moment2.default)(data.publishedDate).format('Do MMM YYYY')
	      )
	    )
	  );
	};
	
	AssetCard.propTypes = {
	  asset: _propTypes2.default.object.isRequired,
	  viewMode: _propTypes2.default.string.isRequired
	};
	
	exports.default = AssetCard;

/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _favouriteStar = __webpack_require__(347);
	
	var _favouriteStar2 = _interopRequireDefault(_favouriteStar);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _assetTypeIcon = __webpack_require__(343);
	
	var _assetTypeIcon2 = _interopRequireDefault(_assetTypeIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogAsset = function BlogAsset(_ref) {
	  var asset = _ref.asset,
	      favouriteStateHandler = _ref.favouriteStateHandler,
	      supportingDataComponent = _ref.supportingDataComponent,
	      uploadSupportingDataComponent = _ref.uploadSupportingDataComponent;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_assetTypeIcon2.default, { asset: asset })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'left' },
	      _react2.default.createElement(
	        _targetLink2.default,
	        { renderIf: true, href: _lodash2.default.get(asset, 'assetURL') },
	        _lodash2.default.get(asset, 'extraData.text', '-')
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus', color: 'grey' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle thin', color: 'grey' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_favouriteStar2.default, { asset: asset, onClick: favouriteStateHandler })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      uploadSupportingDataComponent
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      supportingDataComponent
	    ),
	    _react2.default.createElement(_semanticUiReact.Table.Cell, null)
	  );
	};
	
	BlogAsset.propTypes = {
	  asset: _propTypes2.default.object.isRequired,
	  favouriteStateHandler: _propTypes2.default.func.isRequired
	};
	
	exports.default = BlogAsset;

/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _favouriteStar = __webpack_require__(347);
	
	var _favouriteStar2 = _interopRequireDefault(_favouriteStar);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _assetTypeIcon = __webpack_require__(343);
	
	var _assetTypeIcon2 = _interopRequireDefault(_assetTypeIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeleteButton = function DeleteButton(props) {
	  return _react2.default.createElement(_semanticUiReact.Button, {
	    size: 'mini',
	    onClick: props.handler,
	    compact: true,
	    circular: true,
	    icon: 'delete'
	  });
	};
	
	var deleteAsset = function deleteAsset(asset, restClient) {
	  var deleteUrl = 'trackedAssets/' + asset.id;
	  console.log(deleteUrl);
	  return restClient.delete(deleteUrl).then(function () {
	    return window.location.reload(true);
	  });
	};
	var SnapChatAsset = function SnapChatAsset(_ref) {
	  var asset = _ref.asset,
	      favouriteStateHandler = _ref.favouriteStateHandler,
	      uploadSupportingDataComponent = _ref.uploadSupportingDataComponent,
	      supportingDataComponent = _ref.supportingDataComponent,
	      restClient = _ref.restClient;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        content: _react2.default.createElement(
	          'span',
	          null,
	          'Snapchat ',
	          _lodash2.default.capitalize(_lodash2.default.get(asset, 'assetType', 'post'))
	        ),
	        trigger: _react2.default.createElement(_assetTypeIcon2.default, { asset: asset })
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'left' },
	      _react2.default.createElement(
	        _targetLink2.default,
	        { renderIf: true, href: _lodash2.default.get(asset, 'assetURL') },
	        _lodash2.default.get(asset, 'extraData.text', '-')
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle thin', color: 'grey' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus', color: 'grey' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_favouriteStar2.default, { asset: asset, onClick: favouriteStateHandler })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      uploadSupportingDataComponent
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      supportingDataComponent
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(DeleteButton, {
	        handler: function handler() {
	          return deleteAsset(asset, restClient);
	        }
	      })
	    )
	  );
	};
	
	SnapChatAsset.propTypes = {
	  asset: _propTypes2.default.object.isRequired,
	  uploadSupportingDataComponent: _propTypes2.default.object.isRequired,
	  supportingDataComponent: _propTypes2.default.object.isRequired,
	  favouriteStateHandler: _propTypes2.default.func.isRequired,
	  restClient: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _hasRestClient2.default)(SnapChatAsset);

/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _favouriteStar = __webpack_require__(347);
	
	var _favouriteStar2 = _interopRequireDefault(_favouriteStar);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _assetTypeIcon = __webpack_require__(343);
	
	var _assetTypeIcon2 = _interopRequireDefault(_assetTypeIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VKAsset = function VKAsset(_ref) {
	  var asset = _ref.asset,
	      favouriteStateHandler = _ref.favouriteStateHandler,
	      uploadSupportingDataComponent = _ref.uploadSupportingDataComponent,
	      supportingDataComponent = _ref.supportingDataComponent;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        content: _react2.default.createElement(
	          'span',
	          null,
	          'VK ',
	          _lodash2.default.capitalize(_lodash2.default.get(asset, 'assetType', 'post'))
	        ),
	        trigger: _react2.default.createElement(_assetTypeIcon2.default, { asset: asset })
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'left' },
	      _react2.default.createElement(
	        _targetLink2.default,
	        { renderIf: true, href: _lodash2.default.get(asset, 'assetURL') },
	        _lodash2.default.get(asset, 'extraData.text', '-')
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle thin', color: 'grey' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus', color: 'grey' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_favouriteStar2.default, { asset: asset, onClick: favouriteStateHandler })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      uploadSupportingDataComponent
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      supportingDataComponent
	    ),
	    _react2.default.createElement(_semanticUiReact.Table.Cell, null)
	  );
	};
	
	VKAsset.propTypes = {
	  asset: _propTypes2.default.object.isRequired,
	  favouriteStateHandler: _propTypes2.default.func.isRequired
	};
	
	exports.default = VKAsset;

/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nameSpanStyle = {
	  fontSize: 20,
	  fontWeight: 600,
	  width: '100%'
	};
	
	var AudienceDataRequestHandlingModal = function AudienceDataRequestHandlingModal(_ref) {
	  var onClose = _ref.onClose,
	      createdBy = _ref.createdBy,
	      agency = _ref.agency,
	      channels = _ref.channels,
	      onRequestAccepted = _ref.onRequestAccepted,
	      onRequestDeclined = _ref.onRequestDeclined;
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      headerText: 'Audience Data Request',
	      onClose: onClose,
	      size: 'small'
	    },
	    _react2.default.createElement(
	      'span',
	      null,
	      createdBy,
	      ' from ',
	      agency.name,
	      ' would like to view your audience data from the channels below. This will allowe her agency to view your channel demographics and audience size etc.'
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 4, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Agency'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 12, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'b',
	              { style: nameSpanStyle },
	              agency.name
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 4, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Channels'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 12, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            _semanticUiReact.List,
	            null,
	            _lodash2.default.map(channels, function (channel) {
	              return _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid,
	                  { verticalAlign: 'middle' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Grid.Column,
	                      { width: 1 },
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: channel.channel, size: 'large' })
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Grid.Column,
	                      { width: 6 },
	                      _lodash2.default.upperFirst(channel.handle)
	                    )
	                  )
	                )
	              );
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        { columns: 'two' },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          null,
	          _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	            label: 'Decline',
	            fluid: true,
	            onClick: onRequestDeclined,
	            color: 'pink',
	            hasIcon: true,
	            icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'x' })
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          null,
	          _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	            label: 'Accept',
	            fluid: true,
	            onClick: onRequestAccepted,
	            color: 'green',
	            hasIcon: true,
	            icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' })
	          })
	        )
	      )
	    )
	  );
	};
	
	AudienceDataRequestHandlingModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  createdBy: _propTypes2.default.string.isRequired,
	  agency: _propTypes2.default.object.isRequired,
	  channels: _propTypes2.default.array.isRequired,
	  onRequestAccepted: _propTypes2.default.func.isRequired,
	  onRequestDeclined: _propTypes2.default.func.isRequired
	};
	
	exports.default = AudienceDataRequestHandlingModal;

/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nameSpanStyle = {
	  fontSize: 20,
	  fontWeight: 600,
	  width: '100%'
	};
	
	var AudienceDataRequestModal = function AudienceDataRequestModal(_ref) {
	  var onClose = _ref.onClose,
	      influencer = _ref.influencer,
	      onPlatformSelected = _ref.onPlatformSelected,
	      onSendADRRequestButtonClick = _ref.onSendADRRequestButtonClick;
	  var name = influencer.name,
	      thumbnail = influencer.thumbnail,
	      primarySocialHandle = influencer.primarySocialHandle,
	      instagram = influencer.instagram,
	      facebook = influencer.facebook,
	      youtube = influencer.youtube,
	      email = influencer.email;
	
	  var channels = [{ key: 'instagram', value: instagram }, { key: 'youtube', value: youtube }, { key: 'facebook', value: facebook }];
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      headerText: 'Audience Data Request',
	      onClose: onClose,
	      size: 'small',
	      hasActionButton: true,
	      actionButtonContent: 'Send',
	      onActionButtonClick: onSendADRRequestButtonClick
	    },
	    _react2.default.createElement(
	      'span',
	      null,
	      'Send an audience data request to your influencer. This will allow you to see their audience demographics on Instagram, Facebook and Youtube. (Twitter coming soon).'
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 4, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Influencer'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 12, verticalAlign: 'middle' },
	          _react2.default.createElement(_semanticUiReact.Image, { src: thumbnail, avatar: true, size: 'tiny' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'b',
	              { style: nameSpanStyle },
	              name
	            ),
	            ' @',
	            primarySocialHandle
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 4, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Channels'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 12, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            _semanticUiReact.List,
	            null,
	            _lodash2.default.map(channels, function (channel) {
	              return _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid,
	                  { verticalAlign: 'middle' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Grid.Column,
	                      { width: 3 },
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: channel.key, size: 'large' })
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Grid.Column,
	                      { width: 6 },
	                      _lodash2.default.upperFirst(channel.value)
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Grid.Column,
	                      { width: 3 },
	                      _react2.default.createElement(_semanticUiReact.Checkbox, { toggle: true, value: channel.key, name: channel.key, onChange: onPlatformSelected })
	                    )
	                  )
	                )
	              );
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 4, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Email'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 12, verticalAlign: 'middle' },
	          email
	        )
	      )
	    )
	  );
	};
	
	AudienceDataRequestModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  influencer: _propTypes2.default.object.isRequired,
	  onPlatformSelected: _propTypes2.default.func.isRequired,
	  onSendADRRequestButtonClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = AudienceDataRequestModal;

/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _auditLogTableRow = __webpack_require__(859);
	
	var _auditLogTableRow2 = _interopRequireDefault(_auditLogTableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerCells = ['Time', 'User', 'Action', 'Campaign', 'Link'];
	
	var loadingTableRowStyle = {
	  height: 549
	};
	
	var downloadCsvLinkStyle = {
	  color: '#c71f7e',
	  border: '1px solid #c71f7e',
	  padding: '5px 15px',
	  borderRadius: 6
	};
	
	var tableStyle = {
	  width: '100%'
	};
	
	var textCenteredStyle = {
	  textAlign: 'center'
	};
	
	var paginationStyle = {
	  marginBottom: 20
	};
	
	var TablePagination = function TablePagination(_ref) {
	  var onPageDecrement = _ref.onPageDecrement,
	      onPageIncrement = _ref.onPageIncrement,
	      currentOffset = _ref.currentOffset,
	      shouldDisableNextButton = _ref.shouldDisableNextButton;
	  return _react2.default.createElement(
	    _semanticUiReact.Menu,
	    { compact: true, floated: 'right', style: paginationStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      { as: 'a', onClick: onPageDecrement, disabled: currentOffset === 0 },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'angle left' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Menu.Item,
	      { as: 'a', disabled: shouldDisableNextButton, onClick: onPageIncrement },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'angle right' })
	    )
	  );
	};
	
	TablePagination.propTypes = {
	  onPageDecrement: _propTypes2.default.func.isRequired,
	  onPageIncrement: _propTypes2.default.func.isRequired,
	  currentOffset: _propTypes2.default.number.isRequired,
	  shouldDisableNextButton: _propTypes2.default.bool.isRequired
	};
	
	var TableBodyLoader = function TableBodyLoader() {
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Body,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Row,
	      { style: loadingTableRowStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        { colSpan: 5 },
	        _react2.default.createElement(_semanticUiReact.Loader, {
	          active: true,
	          content: 'Loading feed...',
	          inline: 'centered'
	        })
	      )
	    )
	  );
	};
	
	var TableEmptyState = function TableEmptyState() {
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Body,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Row,
	      { style: loadingTableRowStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        { colSpan: 5, style: textCenteredStyle },
	        _react2.default.createElement(
	          _semanticUiReact.Header,
	          { icon: true, size: 'large' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'wait outline', color: 'orange' }),
	          'No events yet',
	          _react2.default.createElement(
	            _semanticUiReact.Header.Subheader,
	            null,
	            'Please try again later'
	          )
	        )
	      )
	    )
	  );
	};
	
	var AuditLogTable = function AuditLogTable(_ref2) {
	  var shouldRenderLoader = _ref2.shouldRenderLoader,
	      isLoaded = _ref2.isLoaded,
	      events = _ref2.events,
	      currentOffset = _ref2.currentOffset,
	      shouldDisableNextButton = _ref2.shouldDisableNextButton,
	      onPageIncrement = _ref2.onPageIncrement,
	      onPageDecrement = _ref2.onPageDecrement;
	
	  var shouldRenderEmptyState = !shouldRenderLoader && _lodash2.default.isEmpty(events);
	  var shouldRenderTable = isLoaded && !shouldRenderLoader && !shouldRenderEmptyState;
	
	  var paginationProps = {
	    onPageDecrement: onPageDecrement,
	    onPageIncrement: onPageIncrement,
	    currentOffset: currentOffset,
	    shouldDisableNextButton: shouldDisableNextButton
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table,
	      { celled: true, style: tableStyle },
	      shouldRenderTable && _react2.default.createElement(
	        _semanticUiReact.Table.Header,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _lodash2.default.map(headerCells, function (cell) {
	            return _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              cell
	            );
	          })
	        )
	      ),
	      shouldRenderTable && _react2.default.createElement(
	        _semanticUiReact.Table.Body,
	        null,
	        _lodash2.default.map(events, function (event) {
	          return _react2.default.createElement(_auditLogTableRow2.default, event);
	        })
	      ),
	      shouldRenderLoader && _react2.default.createElement(TableBodyLoader, null),
	      shouldRenderEmptyState && _react2.default.createElement(TableEmptyState, null)
	    ),
	    shouldRenderTable && _react2.default.createElement(TablePagination, paginationProps)
	  );
	};
	
	AuditLogTable.propTypes = {
	  isLoaded: _propTypes2.default.bool.isRequired,
	  shouldRenderLoader: _propTypes2.default.bool.isRequired,
	  shouldDisableNextButton: _propTypes2.default.bool.isRequired,
	  events: _propTypes2.default.array.isRequired,
	  onPageDecrement: _propTypes2.default.func.isRequired,
	  onPageIncrement: _propTypes2.default.func.isRequired,
	  currentOffset: _propTypes2.default.number.isRequired,
	  hasExportFeature: _propTypes2.default.bool,
	  organisationName: _propTypes2.default.string.isRequired
	};
	
	AuditLogTable.defaultProps = {
	  hasExportFeature: true
	};
	
	exports.default = AuditLogTable;

/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textStyle = {
	  color: '#e6683c',
	  fontSize: 16,
	  textAlign: 'center'
	};
	
	var upgradeButtonStyle = {
	  margin: '0 auto',
	  display: 'block'
	};
	
	var BlockedInvitationStatus = function BlockedInvitationStatus(_ref) {
	  var router = _ref.router;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Invitation Status'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        'p',
	        { style: textStyle },
	        'You must upgrade your subscription to invite influencers to this campaign.'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(_semanticUiReact.Button, {
	        style: upgradeButtonStyle,
	        color: 'pink',
	        inverted: true,
	        content: 'Upgrade now',
	        fluid: true,
	        onClick: function onClick() {
	          return router.push('/team/manage');
	        }
	      })
	    )
	  );
	};
	
	BlockedInvitationStatus.propTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(BlockedInvitationStatus);

/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var keys = {
	  web: 'URL',
	  blogUniqueUsers: 'Unique Users',
	  blogPageViews: 'Page Views',
	  blogDomainAuthority: 'Domain Authority',
	  blogPostFrequency: 'Post Frequency'
	};
	
	var BlogosphereBlogDetails = function BlogosphereBlogDetails(_ref) {
	  var details = _ref.details;
	
	  var previous = _lodash2.default.split(details.previousBrandCollaborations, '|');
	
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        'Blog Details'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very', celled: true, fluid: true },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _lodash2.default.map(keys, function (v, k) {
	            return _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                v
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                details[k]
	              )
	            );
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        'Previous brand collaborations'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _lodash2.default.map(previous, function (p) {
	        return _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _targetLink2.default,
	            { renderIf: true, href: p },
	            p
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = BlogosphereBlogDetails;

/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogosphereCollaborationTypes = function BlogosphereCollaborationTypes(props) {
	  var _props$details = props.details,
	      complimentaryPressTrips = _props$details.complimentaryPressTrips,
	      paidForPressTrips = _props$details.paidForPressTrips,
	      sponsoredPosts = _props$details.sponsoredPosts,
	      productSamples = _props$details.productSamples;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        'Types of collaboration'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { columns: 2 },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Checkbox, { label: 'Product Samples', checked: _lodash2.default.isString(productSamples) })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Checkbox, { checked: _lodash2.default.isString(complimentaryPressTrips), label: 'Complimentary Press Trips' })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Checkbox, { label: 'Sponsored Posts', checked: _lodash2.default.isString(sponsoredPosts) })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Checkbox, { label: 'Paid For Press Trips', checked: _lodash2.default.isString(paidForPressTrips) })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = BlogosphereCollaborationTypes;

/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactMaskedinput = __webpack_require__(3362);
	
	var _reactMaskedinput2 = _interopRequireDefault(_reactMaskedinput);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var genderOptions = [{ text: 'Male', value: 'male' }, { text: 'Female', value: 'female' }, { text: 'Other', value: 'other' }];
	
	var BlogosphereDetails = function BlogosphereDetails(props) {
	  var details = props.details;
	  var ethnicity = details.ethnicity,
	      dob = details.dob,
	      gender = details.gender,
	      camera = details.camera,
	      phone = details.phone,
	      photoLink = details.photoLink,
	      mediaKitLink = details.mediaKitLink,
	      blogosphereSubscriber = details.blogosphereSubscriber;
	
	  var isBlogosphereSubscibed = _lodash2.default.lowerCase(blogosphereSubscriber) === 'yes';
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        'Blogosphere Details'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Form,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { verticalAlign: 'middle' },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              'Date of birth'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 12 },
	              _react2.default.createElement(_reactMaskedinput2.default, { mask: '1111-11-11', name: 'card', size: '20', value: dob })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              'Gender'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 12 },
	              _react2.default.createElement(_semanticUiReact.Dropdown, { placeholder: 'Select gender', value: _lodash2.default.lowerCase(gender), fluid: true, selection: true, options: genderOptions })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              'Ethnicity'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 12 },
	              _react2.default.createElement(_semanticUiReact.Input, { fluid: true, placeholder: 'British', value: ethnicity })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              'Camera'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 12 },
	              _react2.default.createElement(_semanticUiReact.Input, { fluid: true, placeholder: 'Canon EOS', value: camera })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              'Phone'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 12 },
	              _react2.default.createElement(_semanticUiReact.Input, { fluid: true, placeholder: 'Apple iPhone X', value: phone })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              'Subscribed to blogosphere?'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 12 },
	              _react2.default.createElement(_semanticUiReact.Checkbox, { label: 'Yes', checked: isBlogosphereSubscibed })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              'Blogosphere Pic'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 12 },
	              _react2.default.createElement(_semanticUiReact.Image, { size: 'small', src: photoLink })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              'Download media kit'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 12 },
	              _react2.default.createElement(
	                _targetLink2.default,
	                { renderIf: true, href: mediaKitLink },
	                'Media kit link'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	BlogosphereDetails.propTypes = {
	  details: _propTypes2.default.object.isRequired
	};
	
	exports.default = BlogosphereDetails;

/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioIcons = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PLATFORMS = {
	  blog: 'blog',
	  youtube: 'youtube',
	  twitter: 'twitter',
	  instagram: 'instagram',
	  facebook: 'facebook',
	  pinterest: 'pinterest'
	};
	
	var getRates = function getRates(details, platform) {
	  var rates = [];
	  if (!details) return null;
	
	  var range = _lodash2.default.range(1, 12);
	  _lodash2.default.forEach(range, function (v) {
	    var key = platform + 'Rate' + v;
	    var value = details[key];
	    if (value) {
	      rates.push(value);
	    }
	  });
	  return rates;
	};
	
	var Rates = function Rates(props) {
	  var items = props.items,
	      icon = props.icon;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { width: 3, textAlign: 'center' },
	      icon
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { width: 13 },
	      _lodash2.default.map(items, function (item) {
	        return _react2.default.createElement(
	          _semanticUiReact.Label,
	          { basic: true, color: 'pink', size: 'large', horizontal: true },
	          item
	        );
	      })
	    )
	  );
	};
	
	var BlogosphereRateCard = function BlogosphereRateCard(props) {
	  var details = props.details;
	
	  var twitterRates = getRates(details, PLATFORMS.twitter);
	  var facebookRates = getRates(details, PLATFORMS.facebook);
	  var instagramRates = getRates(details, PLATFORMS.instagram);
	  var youtubeRates = getRates(details, PLATFORMS.youtube);
	  var blogRates = getRates(details, PLATFORMS.blog);
	  var pinterestRates = getRates(details, PLATFORMS.pinterest);
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        'Rate Card (fee per post)'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: { margin: 0, padding: 0 } },
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very' },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          youtubeRates && _react2.default.createElement(Rates, { items: youtubeRates, icon: _react2.default.createElement(_dyzioIcons.YoutubeIcon, { size: 'big' }) }),
	          instagramRates && _react2.default.createElement(Rates, { items: instagramRates, icon: _react2.default.createElement(_dyzioIcons.InstagramIcon, { size: 'big' }) }),
	          facebookRates && _react2.default.createElement(Rates, { items: facebookRates, icon: _react2.default.createElement(_dyzioIcons.FacebookIcon, { size: 'big' }) }),
	          twitterRates && _react2.default.createElement(Rates, { items: twitterRates, icon: _react2.default.createElement(_dyzioIcons.TwitterIcon, { size: 'big' }) }),
	          pinterestRates && _react2.default.createElement(Rates, { items: pinterestRates, icon: _react2.default.createElement(_dyzioIcons.PinterestIcon, { size: 'big' }) }),
	          blogRates && _react2.default.createElement(Rates, { items: blogRates, icon: _react2.default.createElement(_dyzioIcons.BlogIcon, { size: 'big' }) })
	        )
	      )
	    )
	  );
	};
	
	BlogosphereRateCard.propTypes = {
	  details: _propTypes2.default.object.isRequired
	};
	
	exports.default = BlogosphereRateCard;

/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogosphereRawData = function (_Component) {
	  _inherits(BlogosphereRawData, _Component);
	
	  function BlogosphereRawData() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BlogosphereRawData);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BlogosphereRawData.__proto__ || Object.getPrototypeOf(BlogosphereRawData)).call.apply(_ref, [this].concat(args))), _this), _this.state = { activeIndex: -1 }, _this.handleClick = function (e, titleProps) {
	      var index = titleProps.index;
	      var activeIndex = _this.state.activeIndex;
	
	      var newIndex = activeIndex === index ? -1 : index;
	
	      _this.setState({ activeIndex: newIndex });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BlogosphereRawData, [{
	    key: 'render',
	    value: function render() {
	      var activeIndex = this.state.activeIndex;
	      var details = this.props.details;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Accordion,
	        { fluid: true, styled: true },
	        _react2.default.createElement(
	          _semanticUiReact.Accordion.Title,
	          { active: activeIndex === 0, index: 0, onClick: this.handleClick },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'dropdown' }),
	          'Blogosphere raw data'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Accordion.Content,
	          { active: activeIndex === 0 },
	          _react2.default.createElement(
	            'pre',
	            null,
	            JSON.stringify(details, null, 2)
	          )
	        )
	      );
	    }
	  }]);
	
	  return BlogosphereRawData;
	}(_react.Component);
	
	exports.default = BlogosphereRawData;

/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _currencies = __webpack_require__(128);
	
	var _currencyInputInline = __webpack_require__(866);
	
	var _currencyInputInline2 = _interopRequireDefault(_currencyInputInline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var wrapperStyle = {
	  borderLeft: '1px solid #ddd'
	};
	
	var CampaignBudget = function (_Component) {
	  _inherits(CampaignBudget, _Component);
	
	  function CampaignBudget(props) {
	    _classCallCheck(this, CampaignBudget);
	
	    var _this = _possibleConstructorReturn(this, (CampaignBudget.__proto__ || Object.getPrototypeOf(CampaignBudget)).call(this, props));
	
	    _this.changeBudget = function (value) {
	      _this.setState({ budget: value });
	    };
	
	    _this.updateBudget = function () {
	      _this.setState({
	        budgetPersistent: _this.state.budget,
	        editing: false
	      });
	      _this.props.updateBudget(_this.state.budget);
	    };
	
	    _this.resetBudget = function () {
	      _this.setState({
	        budget: _this.state.budgetPersistent,
	        editing: false
	      });
	    };
	
	    _this.setEditing = function () {
	      _this.setState({ editing: true });
	    };
	
	    _this.state = {
	      budget: _this.props.budget,
	      budgetPersistent: _this.props.budget,
	      editing: false
	    };
	    return _this;
	  }
	
	  _createClass(CampaignBudget, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          allocated = _props.allocated,
	          updated = _props.updated,
	          handleSubmit = _props.handleSubmit,
	          currency = _props.currency;
	      var _state = this.state,
	          budget = _state.budget,
	          budgetPersistent = _state.budgetPersistent,
	          editing = _state.editing;
	
	      var remainder = budget - allocated || 0;
	
	      return _react2.default.createElement(
	        'div',
	        { style: wrapperStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement('div', { className: 'flex-spacer' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-item' },
	            _react2.default.createElement(
	              'p',
	              { className: 'input-label' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Total budget:'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-item' },
	            _react2.default.createElement(_currencyInputInline2.default, {
	              id: 'budget',
	              name: 'budget',
	              currency: currency,
	              disabled: !editing,
	              value: budget,
	              onChange: this.changeBudget,
	              onFocus: function onFocus() {
	                return _this2.setState({ editing: true });
	              },
	              placeholder: 0,
	              editable: true
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-item', style: { whiteSpace: 'nowrap' } },
	            editing ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: 'medium grey-icon', onClick: this.updateBudget },
	                _react2.default.createElement('img', { src: '/icons/tick-seagreen.svg', alt: 'save' })
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'medium grey-icon', onClick: this.resetBudget },
	                _react2.default.createElement('img', { src: '/icons/close-red.svg', alt: 'cancel' })
	              )
	            ) : _react2.default.createElement(
	              'button',
	              { className: 'medium grey-icon', onClick: this.setEditing },
	              _react2.default.createElement('img', { src: '/icons/edit.svg', alt: 'edit' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-item' },
	            _react2.default.createElement(
	              'p',
	              { className: 'input-label' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Allocated:'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-item' },
	            _react2.default.createElement(_currencyInputInline2.default, {
	              id: 'allocated',
	              name: 'allocated',
	              value: allocated,
	              currency: currency,
	              placeholder: 0,
	              disabled: true
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignBudget;
	}(_react.Component);
	
	CampaignBudget.propTypes = {
	  updateBudget: _propTypes2.default.func.isRequired
	};
	
	exports.default = CampaignBudget;

/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerStyle = { fontSize: '90%', textAlign: 'center' };
	var normalSize = { fontSize: '100%' };
	
	var EmptyAssets = function EmptyAssets(_ref) {
	  var ctaHandler = _ref.ctaHandler;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { centered: true, style: headerStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        'Add an Asset!'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        'p',
	        { style: normalSize },
	        'Hello! ',
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'smile', color: 'pink' })
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: normalSize },
	        'There are no assets in your campaign yet. Use the button below, or the button top right to add your first asset.'
	      ),
	      _react2.default.createElement(_semanticUiReact.Divider, null),
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        { icon: true, labelPosition: 'left', color: 'pink', size: 'large', fluid: true, onClick: ctaHandler },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' }),
	        'Add an asset...'
	      )
	    )
	  );
	};
	
	exports.default = EmptyAssets;

/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _emptyAssets = __webpack_require__(1900);
	
	var _emptyAssets2 = _interopRequireDefault(_emptyAssets);
	
	var _assetCard = __webpack_require__(1886);
	
	var _assetCard2 = _interopRequireDefault(_assetCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CampaignDashboardLoadingCard = function CampaignDashboardLoadingCard() {
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: true, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { size: 'small' },
	        'Loading'
	      )
	    )
	  );
	};
	
	var CampaignDashboardCards = function CampaignDashboardCards(props) {
	  var assets = props.assets,
	      viewMode = props.viewMode,
	      groupBy = props.groupBy,
	      isAddingNewCard = props.isAddingNewCard,
	      toggleAddAssetModalState = props.toggleAddAssetModalState,
	      isLoading = props.isLoading,
	      isLoaded = props.isLoaded,
	      hamburgerOptions = props.hamburgerOptions;
	
	
	  var shouldGroupByPlatform = groupBy === 'platform';
	  var itemsPerRow = viewMode === 'cards.small' ? 6 : 4;
	
	  var noAssets = assets.length === 0;
	
	  if (shouldGroupByPlatform) {
	    var groupedAssets = _lodash2.default.groupBy(assets, 'attributes.platform');
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook' }),
	        'Facebook'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Group,
	        { itemsPerRow: itemsPerRow },
	        groupedAssets && _lodash2.default.map(groupedAssets[_staticConfiguration.FACEBOOK], function (asset) {
	          return _react2.default.createElement(_assetCard2.default, {
	            key: asset.id,
	            asset: asset.attributes.initialData.standardFormat,
	            viewMode: viewMode
	          });
	        })
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter' }),
	        'Twitter'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Group,
	        { itemsPerRow: itemsPerRow },
	        groupedAssets && _lodash2.default.map(groupedAssets[_staticConfiguration.TWITTER], function (asset) {
	          return _react2.default.createElement(_assetCard2.default, {
	            key: asset.id,
	            asset: asset.attributes.initialData.standardFormat,
	            viewMode: viewMode
	          });
	        })
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	        'Instagram'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Group,
	        { itemsPerRow: itemsPerRow },
	        groupedAssets && _lodash2.default.map(groupedAssets[_staticConfiguration.INSTAGRAM], function (asset) {
	          return _react2.default.createElement(_assetCard2.default, {
	            key: asset.id,
	            asset: asset.attributes.initialData.standardFormat,
	            viewMode: viewMode
	          });
	        })
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube' }),
	        'Youtube'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Group,
	        { itemsPerRow: itemsPerRow },
	        groupedAssets && _lodash2.default.map(groupedAssets[_staticConfiguration.YOUTUBE], function (asset) {
	          return _react2.default.createElement(_assetCard2.default, {
	            key: asset.id,
	            asset: asset.attributes.initialData.standardFormat,
	            viewMode: viewMode
	          });
	        })
	      )
	    );
	  }
	
	  if (isLoaded && noAssets) return _react2.default.createElement(_emptyAssets2.default, { ctaHandler: toggleAddAssetModalState });
	
	  return _react2.default.createElement(
	    _semanticUiReact.Card.Group,
	    { itemsPerRow: itemsPerRow },
	    assets && _lodash2.default.map(assets, function (asset) {
	      return _react2.default.createElement(_assetCard2.default, {
	        asset: asset,
	        viewMode: viewMode,
	        hamburgerOptions: hamburgerOptions
	      });
	    }),
	    isAddingNewCard && _react2.default.createElement(CampaignDashboardLoadingCard, null)
	  );
	};
	
	exports.default = CampaignDashboardCards;

/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _assetTable = __webpack_require__(537);
	
	var _assetTable2 = _interopRequireDefault(_assetTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CampaignDashboardTable = function CampaignDashboardTable(props) {
	  var assets = props.assets;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    null,
	    _react2.default.createElement(_assetTable2.default, { assets: assets })
	  );
	};
	
	CampaignDashboardTable.propTypes = {
	  assets: _propTypes2.default.array.isRequired
	};
	
	exports.default = CampaignDashboardTable;

/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var messageStyles = {
	  width: '100%'
	};
	
	var CampaignEcommerceModal = function (_Component) {
	  _inherits(CampaignEcommerceModal, _Component);
	
	  function CampaignEcommerceModal(props) {
	    _classCallCheck(this, CampaignEcommerceModal);
	
	    var _this = _possibleConstructorReturn(this, (CampaignEcommerceModal.__proto__ || Object.getPrototypeOf(CampaignEcommerceModal)).call(this, props));
	
	    _this.onInputChanged = function (event, _ref) {
	      var name = _ref.name,
	          value = _ref.value,
	          checked = _ref.checked;
	
	      _this.setState(_defineProperty({}, name, value || checked));
	    };
	
	    _this.handleFormSubmit = function (e) {
	      e.preventDefault();
	      var onSubmit = _this.props.onSubmit;
	
	
	      _this.setState({ error: null });
	      var _this$state = _this.state,
	          shopifyAccessToken = _this$state.shopifyAccessToken,
	          shopifyShopUrl = _this$state.shopifyShopUrl,
	          freeProductPriceRule = _this$state.freeProductPriceRule,
	          freeShippingPriceRule = _this$state.freeShippingPriceRule,
	          emailSubject = _this$state.emailSubject,
	          emailTemplate = _this$state.emailTemplate,
	          discountCodeStem = _this$state.discountCodeStem,
	          freeShippingCodeStem = _this$state.freeShippingCodeStem,
	          brandName = _this$state.brandName,
	          shopifyStoreLink = _this$state.shopifyStoreLink,
	          productOrderText = _this$state.productOrderText,
	          fromEmail = _this$state.fromEmail,
	          contentChaseEmailSubject = _this$state.contentChaseEmailSubject,
	          contentChaseEmailTemplate = _this$state.contentChaseEmailTemplate;
	
	
	      var payload = {
	        shopifyAccessToken: shopifyAccessToken,
	        shopifyShopUrl: shopifyShopUrl,
	        freeProductPriceRule: freeProductPriceRule,
	        freeShippingPriceRule: freeShippingPriceRule,
	        emailSubject: emailSubject,
	        emailTemplate: emailTemplate,
	        discountCodeStem: discountCodeStem,
	        freeShippingCodeStem: freeShippingCodeStem,
	        brandName: brandName,
	        shopifyStoreLink: shopifyStoreLink,
	        productOrderText: productOrderText,
	        fromEmail: fromEmail,
	        contentChaseEmail: {
	          subject: contentChaseEmailSubject,
	          template: contentChaseEmailTemplate
	        }
	      };
	
	      var errors = _lodash2.default.reduce(_lodash2.default.keys(payload), function (acc, key) {
	        var value = payload[key];
	        var isValid = !_lodash2.default.isEmpty(value); // TODO: Implement validation
	        if (!isValid) {
	          acc[key] = 'Field is required';
	        }
	        return acc;
	      }, {});
	      _this.setState({ errors: errors });
	
	      var isValid = _lodash2.default.isEmpty(errors);
	      if (isValid) {
	        onSubmit(payload);
	      }
	    };
	
	    _this.state = _extends({
	      errors: {}
	    }, _lodash2.default.get(props, 'ecommerceSettings', {}), {
	      contentChaseEmailSubject: _lodash2.default.get(props, 'ecommerceSettings.contentChaseEmail.subject', ''),
	      contentChaseEmailTemplate: _lodash2.default.get(props, 'ecommerceSettings.contentChaseEmail.template', '')
	    });
	    return _this;
	  }
	
	  _createClass(CampaignEcommerceModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onClose = _props.onClose,
	          isSubmitting = _props.isSubmitting,
	          error = _props.error;
	      var _state = this.state,
	          shopifyAccessToken = _state.shopifyAccessToken,
	          shopifyShopUrl = _state.shopifyShopUrl,
	          freeProductPriceRule = _state.freeProductPriceRule,
	          freeShippingPriceRule = _state.freeShippingPriceRule,
	          emailSubject = _state.emailSubject,
	          emailTemplate = _state.emailTemplate,
	          discountCodeStem = _state.discountCodeStem,
	          freeShippingCodeStem = _state.freeShippingCodeStem,
	          brandName = _state.brandName,
	          shopifyStoreLink = _state.shopifyStoreLink,
	          productOrderText = _state.productOrderText,
	          fromEmail = _state.fromEmail,
	          contentChaseEmailSubject = _state.contentChaseEmailSubject,
	          contentChaseEmailTemplate = _state.contentChaseEmailTemplate,
	          errors = _state.errors;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _dyzioModal2.default,
	          { headerText: 'Ecommerce Settings', size: 'small', onClose: onClose },
	          _react2.default.createElement(
	            'div',
	            null,
	            error && _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  display: 'flex',
	                  justifyContent: 'center'
	                  // margin: '20px',
	                }
	              },
	              _react2.default.createElement(_semanticUiReact.Message, {
	                fluid: true,
	                style: messageStyles,
	                icon: 'frown',
	                error: true,
	                header: 'Error',
	                content: 'Something went wrong. Please try again later.'
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Form,
	              { onSubmit: this.handleFormSubmit },
	              _react2.default.createElement(
	                'div',
	                { style: { maxHeight: '70vh', overflow: 'auto', margin: '1.5rem' } },
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  { disabled: true },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'shopifyAccessToken' },
	                    'Access Token'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'shopifyAccessToken')),
	                    placeholder: 'Shopify Access Token',
	                    name: 'shopifyAccessToken',
	                    id: 'shopifyAccessToken',
	                    value: shopifyAccessToken
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  { disabled: true },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'shopifyShopUrl' },
	                    'Shop Url'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'shopifyShopUrl')),
	                    placeholder: 'Shopify Shop Url',
	                    id: 'shopifyShopUrl',
	                    name: 'shopifyShopUrl',
	                    value: shopifyShopUrl
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'freeProductPriceRule' },
	                    'Free product price rule'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'freeProductPriceRule')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Free product price rule',
	                    id: 'freeProductPriceRule',
	                    name: 'freeProductPriceRule',
	                    value: freeProductPriceRule
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'freeShippingPriceRule' },
	                    'Free shipping price rule'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'freeShippingPriceRule')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Free shipping price rule',
	                    id: 'freeShippingPriceRule',
	                    name: 'freeShippingPriceRule',
	                    value: freeShippingPriceRule
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'emailSubject' },
	                    'Email subject'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'emailSubject')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Email subject',
	                    id: 'emailSubject',
	                    name: 'emailSubject',
	                    value: emailSubject
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'emailTemplate' },
	                    'Email template'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'emailTemplate')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Email template',
	                    id: 'emailTemplate',
	                    name: 'emailTemplate',
	                    value: emailTemplate
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'discountCodeStem' },
	                    'Discount Code Stem'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'discountCodeStem')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Discount Code Stem',
	                    id: 'discountCodeStem',
	                    name: 'discountCodeStem',
	                    value: discountCodeStem
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'freeShippingCodeStem' },
	                    'Free shipping code stem'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'freeShippingCodeStem')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Free shipping code stem',
	                    id: 'freeShippingCodeStem',
	                    name: 'freeShippingCodeStem',
	                    value: freeShippingCodeStem
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'brandName' },
	                    'Brand name'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'brandName')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Brand name',
	                    id: 'brandName',
	                    name: 'brandName',
	                    value: brandName
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'shopifyStoreLink' },
	                    'Shopify Store Link'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'shopifyStoreLink')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Shopify Store Link',
	                    id: 'shopifyStoreLink',
	                    name: 'shopifyStoreLink',
	                    value: shopifyStoreLink
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'productOrderText' },
	                    'Product order text'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'productOrderText')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Product order text',
	                    id: 'productOrderText',
	                    name: 'productOrderText',
	                    value: productOrderText
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'fromEmail' },
	                    'From email'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'fromEmail')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'From email',
	                    id: 'fromEmail',
	                    name: 'fromEmail',
	                    value: fromEmail
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'contentChaseEmailSubject' },
	                    'Content chase email subject'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'contentChaseEmailSubject')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Content chase email subject',
	                    id: 'contentChaseEmailSubject',
	                    name: 'contentChaseEmailSubject',
	                    value: contentChaseEmailSubject
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'contentChaseEmailTemplate' },
	                    'Content chase email template'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'contentChaseEmailTemplate')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Content chase email template',
	                    id: 'contentChaseEmailTemplate',
	                    name: 'contentChaseEmailTemplate',
	                    value: contentChaseEmailTemplate
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'flex',
	                  style: {
	                    justifyContent: 'flex-end',
	                    padding: '10px 0px 10px 0px'
	                  }
	                },
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Button,
	                  {
	                    loading: isSubmitting,
	                    disabled: isSubmitting,
	                    color: 'pink',
	                    type: 'submit',
	                    size: 'medium'
	                  },
	                  'Submit'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignEcommerceModal;
	}(_react.Component);
	
	CampaignEcommerceModal.propTypes = {
	  onClose: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  isSubmitting: _propTypes2.default.bool,
	  error: _propTypes2.default.any
	};
	CampaignEcommerceModal.defaultProps = {
	  onClose: _lodash2.default.noop,
	  onSubmit: _lodash2.default.noop,
	  isSubmitting: false,
	  error: null
	};
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default)(CampaignEcommerceModal);

/***/ },
/* 1904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _campaignEcommerceModal = __webpack_require__(1903);
	
	var _campaignEcommerceModal2 = _interopRequireDefault(_campaignEcommerceModal);
	
	var _hasOrganisation = __webpack_require__(106);
	
	var _hasOrganisation2 = _interopRequireDefault(_hasOrganisation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var btnStyle = { marginTop: '10px' };
	
	var CampaignEcommerceSettings = function (_React$Component) {
	  _inherits(CampaignEcommerceSettings, _React$Component);
	
	  function CampaignEcommerceSettings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CampaignEcommerceSettings);
	
	    var _this = _possibleConstructorReturn(this, (CampaignEcommerceSettings.__proto__ || Object.getPrototypeOf(CampaignEcommerceSettings)).call(this, props));
	
	    _this.fetchCampaign = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, restClient, campaignId, response, campaign;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, restClient = _this$props.restClient, campaignId = _this$props.campaignId;
	
	              _this.setState({ isLoading: true });
	              _context.next = 4;
	              return restClient.get('campaigns/' + campaignId);
	
	            case 4:
	              response = _context.sent;
	              campaign = _lodash2.default.get(response, 'data.data.attributes', {});
	
	              _this.setState({
	                campaign: campaign,
	                isLoading: false
	              });
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.componentDidMount = function () {
	      _this.fetchCampaign();
	    };
	
	    _this.onSubmit = function (values) {
	      var _this$props2 = _this.props,
	          restClient = _this$props2.restClient,
	          campaignId = _this$props2.campaignId;
	
	      _this.setState({ isSubmitting: true });
	      var payload = {
	        data: {
	          attributes: {
	            ecommerceSettings: values
	          }
	        }
	      };
	      restClient.patch('campaigns/' + campaignId, payload).then(function (r) {
	        _this.setState({ isSubmitting: false, patchError: r.data ? null : true });
	        _this.closeModal();
	        _this.fetchCampaign();
	        return r.data;
	      }).catch(function (err) {
	        _this.setState({ isSubmitting: false, patchError: err });
	      });
	    };
	
	    _this.closeModal = function () {
	      _this.setState({ modalOpened: false });
	    };
	
	    _this.openModal = function () {
	      _this.setState({ modalOpened: true });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CampaignEcommerceSettings, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          campaign = _state.campaign,
	          modalOpened = _state.modalOpened,
	          isSubmitting = _state.isSubmitting,
	          patchError = _state.patchError,
	          isLoading = _state.isLoading;
	      var organisation = this.props.organisation;
	
	      var _ref2 = organisation && organisation.ecommerceSettings ? organisation.ecommerceSettings : {},
	          shopifyAccessToken = _ref2.shopifyAccessToken,
	          shopifyShopUrl = _ref2.shopifyShopUrl;
	
	      var ecommerceSettings = _extends({}, _lodash2.default.get(campaign, 'ecommerceSettings', {}), { shopifyAccessToken: shopifyAccessToken, shopifyShopUrl: shopifyShopUrl });
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        modalOpened && _react2.default.createElement(_campaignEcommerceModal2.default, {
	          onSubmit: this.onSubmit,
	          onClose: this.closeModal,
	          ecommerceSettings: ecommerceSettings,
	          isSubmitting: isSubmitting,
	          error: patchError
	        }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Shopfluence Settings'
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	        _react2.default.createElement(_semanticUiReact.Button, {
	          loading: isLoading,
	          disabled: isLoading,
	          style: btnStyle,
	          color: 'pink',
	          icon: 'edit',
	          fluid: true,
	          onClick: this.openModal,
	          labelPosition: 'left',
	          content: 'Edit shopfluence settings'
	        })
	      );
	    }
	  }]);
	
	  return CampaignEcommerceSettings;
	}(_react2.default.Component);
	
	CampaignEcommerceSettings.propTypes = {
	  restClient: _propTypes2.default.func.isRequired,
	  campaignId: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasOrganisation2.default)(CampaignEcommerceSettings);

/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _recompose = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var inputStyle = {
	  marginTop: 10,
	  marginBottom: 10
	};
	
	var CampaignGoogleLinkTracking = function (_Component) {
	  _inherits(CampaignGoogleLinkTracking, _Component);
	
	  function CampaignGoogleLinkTracking(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CampaignGoogleLinkTracking);
	
	    var _this = _possibleConstructorReturn(this, (CampaignGoogleLinkTracking.__proto__ || Object.getPrototypeOf(CampaignGoogleLinkTracking)).call(this, props));
	
	    _this.onInputValueChanged = function (event, _ref) {
	      var value = _ref.value;
	
	      _this.setState({
	        value: value
	      });
	    };
	
	    _this.onSaveButtonClick = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var value, _this$props, campaignId, jsonAPIClient, response;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              value = _this.state.value;
	              _this$props = _this.props, campaignId = _this$props.campaignId, jsonAPIClient = _this$props.jsonAPIClient;
	              _context.next = 4;
	              return jsonAPIClient.get('campaigns', campaignId);
	
	            case 4:
	              response = _context.sent;
	
	              response.set('baseTrackingUrl', value);
	              _context.next = 8;
	              return response.sync();
	
	            case 8:
	              _this.setState({
	                savedOK: true
	              });
	
	            case 9:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      value: props.baseTrackingUrl,
	      savedOK: false
	    };
	    return _this;
	  }
	
	  _createClass(CampaignGoogleLinkTracking, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          savedOK = _state.savedOK;
	
	      var shouldDisableSubmitButton = _lodash2.default.isEmpty(_lodash2.default.trim(value));
	      var isValidURL = _lodash2.default.startsWith(value, 'https://') || _lodash2.default.startsWith(value, 'http://');
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Google Analytics'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Set up your google link tracking here. Enter the base URL for your campaign and dyzio will generate all your tracking links for you.'
	        ),
	        _react2.default.createElement(_semanticUiReact.Input, {
	          value: value,
	          onChange: this.onInputValueChanged,
	          style: inputStyle,
	          fluid: true,
	          placeholder: 'Enter your tracking base URL for the campaign.'
	        }),
	        _react2.default.createElement(
	          'small',
	          null,
	          'e.g. https://dyzio.co/pricing'
	        ),
	        _react2.default.createElement(_semanticUiReact.Button, {
	          disabled: shouldDisableSubmitButton || !isValidURL,
	          style: inputStyle,
	          color: 'pink',
	          icon: 'google',
	          value: value,
	          fluid: true,
	          labelPosition: 'left',
	          content: 'Authorise Google Analytics',
	          onClick: this.onSaveButtonClick
	        }),
	        savedOK && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { positive: true },
	          'Saved'
	        )
	      );
	    }
	  }]);
	
	  return CampaignGoogleLinkTracking;
	}(_react.Component);
	
	exports.default = (0, _recompose.compose)(_hasJsonapiClient2.default)(CampaignGoogleLinkTracking);

/***/ },
/* 1906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(37);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _campaignStatus = __webpack_require__(930);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OnLabel = function OnLabel() {
	  return _react2.default.createElement(
	    _semanticUiReact.Label,
	    { color: 'green', basic: true },
	    'ON'
	  );
	};
	var OffLabel = function OffLabel() {
	  return _react2.default.createElement(
	    _semanticUiReact.Label,
	    { color: 'grey', basic: true },
	    'OFF'
	  );
	};
	
	var MicroSettings = function MicroSettings(_ref) {
	  var isStickerScannerOn = _ref.isStickerScannerOn,
	      useEstimatedReachAndImpressions = _ref.useEstimatedReachAndImpressions;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { style: { textAlign: 'right', paddingBottom: '5px' } },
	      'capture stories: ',
	      isStickerScannerOn ? _react2.default.createElement(OnLabel, null) : _react2.default.createElement(OffLabel, null)
	    ),
	    _react2.default.createElement(
	      'p',
	      { style: { textAlign: 'right' } },
	      'estimate R&I: ',
	      useEstimatedReachAndImpressions ? _react2.default.createElement(OnLabel, null) : _react2.default.createElement(OffLabel, null)
	    )
	  );
	};
	
	var CampaignLiveStatus = function CampaignLiveStatus(_ref2) {
	  var campaign = _ref2.campaign;
	
	  //
	  var campaignId = _lodash2.default.get(campaign, 'id');
	
	  var liveDate = _lodash2.default.get(campaign, 'liveDate', null);
	  var endDate = _lodash2.default.get(campaign, 'endDate', null);
	
	  var isStickerScannerOn = _lodash2.default.get(campaign, 'scanUnauthorisedStories', false);
	  var useEstimatedReachAndImpressions = _lodash2.default.get(campaign, 'useEstimatedReachAndImpressions', false);
	
	  var captureAllStories = _lodash2.default.get(campaign, 'captureAllStories', false);
	  var captureAllStoriesWhenMatched = _lodash2.default.get(campaign, 'captureAllStoriesWhenMatched', false);
	
	  var startMoment = (0, _moment2.default)(liveDate);
	  var endMoment = (0, _moment2.default)(endDate);
	
	  var status = (0, _campaignStatus.getCampaignStatus)(campaign);
	
	  if (status === _campaignStatus.campaignStatus.INVALID) {
	    return _react2.default.createElement(_semanticUiReact.Message, {
	      color: 'orange',
	      icon: 'warning circle',
	      header: 'Campaign is not tracking.',
	      content: _react2.default.createElement(
	        'div',
	        null,
	        _lodash2.default.isNil(liveDate) ? 'Live date' : 'End date',
	        ' is not set.\xA0',
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'dyzio-green-link', to: '/campaign/' + campaignId + '/settings' },
	          'Click here to edit dates.'
	        )
	      )
	    });
	  }
	  if (status === _campaignStatus.campaignStatus.FUTURE) {
	    // NOT STARTED YET
	    return _react2.default.createElement(
	      'table',
	      { width: '100%' },
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_semanticUiReact.Message, {
	            color: 'orange',
	            icon: 'wait',
	            header: 'This campaign has NOT STARTED yet',
	            content: _react2.default.createElement(
	              'div',
	              null,
	              'Start date: ',
	              startMoment.format('LL'),
	              '.\xA0',
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'dyzio-green-link', to: '/campaign/' + campaignId + '/settings' },
	                'Click here to edit dates.'
	              )
	            )
	          })
	        ),
	        _react2.default.createElement(
	          'td',
	          { width: '200' },
	          _react2.default.createElement(MicroSettings, {
	            useEstimatedReachAndImpressions: useEstimatedReachAndImpressions,
	            isStickerScannerOn: isStickerScannerOn
	          })
	        )
	      ),
	      captureAllStories && _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        _react2.default.createElement(_semanticUiReact.Message, {
	          color: 'red',
	          icon: 'lightning',
	          header: 'CAPTURE ALL STORIES IS ON',
	          content: _react2.default.createElement(
	            'div',
	            null,
	            'All stories will be captured for this campaign. This will create a lot of data, which will require processing.'
	          )
	        })
	      )
	    );
	  }
	
	  if (status === _campaignStatus.campaignStatus.LIVE) {
	    // is live
	    return _react2.default.createElement(
	      'table',
	      { width: '100%' },
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_semanticUiReact.Message, {
	            success: true,
	            icon: 'play circle outline',
	            header: 'This campaign is LIVE',
	            content: _react2.default.createElement(
	              'div',
	              null,
	              'End date: ',
	              endMoment.format('LL'),
	              '.\xA0',
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'dyzio-green-link', to: '/campaign/' + campaignId + '/settings' },
	                'Click here to edit dates.'
	              )
	            )
	          })
	        ),
	        _react2.default.createElement(
	          'td',
	          { width: '200' },
	          _react2.default.createElement(MicroSettings, {
	            useEstimatedReachAndImpressions: useEstimatedReachAndImpressions,
	            isStickerScannerOn: isStickerScannerOn
	          })
	        )
	      ),
	      captureAllStories && _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        _react2.default.createElement(_semanticUiReact.Message, {
	          color: 'red',
	          icon: 'lightning',
	          header: 'CAPTURE ALL STORIES IS ON',
	          content: _react2.default.createElement(
	            'div',
	            null,
	            'All stories will be captured for this campaign. This will create a lot of data, which will require processing.'
	          )
	        })
	      )
	    );
	  }
	  if (status === _campaignStatus.campaignStatus.COMPLETED) {
	    return _react2.default.createElement(_semanticUiReact.Message, {
	      color: 'orange',
	      icon: 'flag',
	      header: 'This campaign is COMPLETE',
	      content: _react2.default.createElement(
	        'div',
	        null,
	        'End date: ',
	        endMoment.format('LL'),
	        '.\xA0',
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'dyzio-green-link', to: '/campaign/' + campaignId + '/settings' },
	          'Click here to edit dates.'
	        )
	      )
	    });
	  }
	  return null;
	};
	
	CampaignLiveStatus.propTypes = {
	  campaign: _propTypes2.default.object.isRequired
	};
	
	exports.default = CampaignLiveStatus;

/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _eventFeed = __webpack_require__(230);
	
	var _eventFeed2 = _interopRequireDefault(_eventFeed);
	
	var _static = __webpack_require__(358);
	
	var _campaignEmailSettings = __webpack_require__(906);
	
	var _campaignEmailSettings2 = _interopRequireDefault(_campaignEmailSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isEmailRecipient = function isEmailRecipient(member) {
	  return _lodash2.default.includes(['TEAM_MEMBER', 'CAMPAIGN_OWNER'], member.role);
	};
	
	var CampaignNotificationsTab = function CampaignNotificationsTab(_ref) {
	  var campaignId = _ref.campaignId,
	      campaignJSON = _ref.campaignJSON;
	
	  var teamMembers = _lodash2.default.filter(campaignJSON.members, function (member) {
	    return isEmailRecipient(member);
	  });
	  return _react2.default.createElement(
	    'div',
	    { style: { margin: 30 } },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      { fluid: true },
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 8 },
	          _react2.default.createElement(
	            _semanticUiReact.Card,
	            { color: 'green', fluid: true },
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Email Settings'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { style: { color: 'rgba(0,0,0,.4)' } },
	                    'manage the automated campaign summary emails.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(_campaignEmailSettings2.default, { campaignId: campaignId, teamMembers: teamMembers })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 8 },
	          _react2.default.createElement(_eventFeed2.default, {
	            cardColour: 'pink',
	            campaignId: campaignId,
	            feedType: _static.FEED_TYPES.CAMPAIGN
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = CampaignNotificationsTab;

/***/ },
/* 1908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouter = __webpack_require__(37);
	
	var _recompose = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _eventFeed = __webpack_require__(230);
	
	var _eventFeed2 = _interopRequireDefault(_eventFeed);
	
	var _static = __webpack_require__(358);
	
	var _campaignEmailSettings = __webpack_require__(906);
	
	var _campaignEmailSettings2 = _interopRequireDefault(_campaignEmailSettings);
	
	var _mailoutsCreateModal = __webpack_require__(887);
	
	var _mailoutsCreateModal2 = _interopRequireDefault(_mailoutsCreateModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmailRecipient = function isEmailRecipient(member) {
	  return _lodash2.default.includes(['TEAM_MEMBER', 'CAMPAIGN_OWNER'], member.role);
	};
	
	var delay = function delay(ms) {
	  return new Promise(function (resolve, reject) {
	    return setTimeout(resolve, ms);
	  });
	};
	var textRight = { textAlign: 'right' };
	
	var CampaignNotificationsTab = function (_Component) {
	  _inherits(CampaignNotificationsTab, _Component);
	
	  function CampaignNotificationsTab(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CampaignNotificationsTab);
	
	    var _this = _possibleConstructorReturn(this, (CampaignNotificationsTab.__proto__ || Object.getPrototypeOf(CampaignNotificationsTab)).call(this, props));
	
	    _this.toggleMailoutsModal = function () {
	      _this.setState(function (prev) {
	        return {
	          modalOpened: !prev.modalOpened,
	          isSubmitting: !prev.modalOpened ? false : prev.isSubmitting,
	          submitError: false
	        };
	      });
	    };
	
	    _this.postMailout = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(mailout) {
	        var _this$props, restClient, campaign, campaignJson, postResponse, mailer, relationship, relationshipDto, relationshipResponse;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props = _this.props, restClient = _this$props.restClient, campaign = _this$props.campaign;
	                campaignJson = campaign.toJSON();
	                _context.next = 4;
	                return restClient.post('mailouts', mailout).catch(function (err) {
	                  console.log('Error creating mailout: ', err);
	                });
	
	              case 4:
	                postResponse = _context.sent;
	                mailer = _lodash2.default.get(postResponse, 'data.data');
	
	                if (!mailer) {
	                  _context.next = 13;
	                  break;
	                }
	
	                relationship = { type: 'mailouts', id: mailer.id };
	                relationshipDto = {
	                  data: relationship
	                };
	                _context.next = 11;
	                return restClient.post('campaigns/' + campaignJson.id + '/relationships/mailouts', relationshipDto).catch(function (err) {
	                  console.log('Error creating mailout relationship: ', err);
	                });
	
	              case 11:
	                relationshipResponse = _context.sent;
	                return _context.abrupt('return', !_lodash2.default.isNil(relationshipResponse) && relationshipResponse.status === 201);
	
	              case 13:
	                return _context.abrupt('return', false);
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.submitMailout = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(payloads) {
	        var _this$props2, campaign, userInfo, responses, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, payload, creators, name, outreachEmailTemplate, outreachEmailSubject, utmSource, campaignJson, mailout, response, submittedSuccessfully;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$props2 = _this.props, campaign = _this$props2.campaign, userInfo = _this$props2.userInfo;
	
	
	                _this.setState({ isSubmitting: true });
	
	                responses = [];
	                // eslint-disable-next-line no-restricted-syntax
	
	                _iteratorNormalCompletion = true;
	                _didIteratorError = false;
	                _iteratorError = undefined;
	                _context2.prev = 6;
	                _iterator = payloads[Symbol.iterator]();
	
	              case 8:
	                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                  _context2.next = 22;
	                  break;
	                }
	
	                payload = _step.value;
	                creators = payload.creators, name = payload.mailoutName, outreachEmailTemplate = payload.outreachEmailTemplate, outreachEmailSubject = payload.outreachEmailSubject, utmSource = payload.utmSource;
	                campaignJson = campaign.toJSON();
	                mailout = {
	                  data: {
	                    attributes: {
	                      name: name,
	                      outreachEmailTemplate: outreachEmailTemplate,
	                      influencers: creators,
	                      outreachEmailSubject: outreachEmailSubject,
	                      utmSource: utmSource,
	                      createdBy: userInfo.name,
	                      createdDate: new Date(),
	                      campaign: {
	                        type: 'campaigns',
	                        id: campaignJson.id
	                      }
	                    }
	                  }
	                };
	                // eslint-disable-next-line no-await-in-loop
	
	                _context2.next = 15;
	                return _this.postMailout(mailout);
	
	              case 15:
	                response = _context2.sent;
	                _context2.next = 18;
	                return delay(200);
	
	              case 18:
	                responses.push(response);
	
	              case 19:
	                _iteratorNormalCompletion = true;
	                _context2.next = 8;
	                break;
	
	              case 22:
	                _context2.next = 28;
	                break;
	
	              case 24:
	                _context2.prev = 24;
	                _context2.t0 = _context2['catch'](6);
	                _didIteratorError = true;
	                _iteratorError = _context2.t0;
	
	              case 28:
	                _context2.prev = 28;
	                _context2.prev = 29;
	
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	
	              case 31:
	                _context2.prev = 31;
	
	                if (!_didIteratorError) {
	                  _context2.next = 34;
	                  break;
	                }
	
	                throw _iteratorError;
	
	              case 34:
	                return _context2.finish(31);
	
	              case 35:
	                return _context2.finish(28);
	
	              case 36:
	                submittedSuccessfully = _lodash2.default.every(responses);
	
	                _this.setState({
	                  isSubmitting: false,
	                  submitError: !submittedSuccessfully,
	                  modalOpened: !submittedSuccessfully
	                });
	                _this.fetchMailouts();
	
	              case 39:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[6, 24, 28, 36], [29,, 31, 35]]);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.getLastSentDate = function (mailout) {
	      var lastSentDate = _lodash2.default.get(mailout, 'lastSentDate');
	      return lastSentDate ? (0, _moment2.default)(lastSentDate).format('YYYY-MM-DD, h:mm') : null;
	    };
	
	    _this.getFormattedNumber = function (num) {
	      return (0, _numeral2.default)(num).format('0,0');
	    };
	
	    _this.state = {
	      modalOpened: false
	    };
	    return _this;
	  }
	
	  _createClass(CampaignNotificationsTab, [{
	    key: 'fetchMailouts',
	    value: function fetchMailouts() {
	      var _this3 = this;
	
	      this.setState({ isLoading: true });
	
	      var _props = this.props,
	          restClient = _props.restClient,
	          campaign = _props.campaign;
	
	      var campaignJson = campaign.toJSON();
	      restClient.get('campaigns/' + campaignJson.id + '?include=mailouts').then(function (response) {
	        var mailouts = _lodash2.default.map(_lodash2.default.get(response, 'data.included'), function (mailout) {
	          return _extends({ id: mailout.id }, mailout.attributes);
	        });
	        _this3.setState({
	          isLoading: false,
	          mailouts: mailouts
	        });
	      }).catch(function (err) {
	        _this3.setState({ isLoading: false, error: err });
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchMailouts();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          modalOpened = _state.modalOpened,
	          stateMailouts = _state.mailouts,
	          isSubmitting = _state.isSubmitting,
	          submitError = _state.submitError;
	      var campaign = this.props.campaign;
	
	
	      var campaignJSON = campaign.toJSON();
	      var teamMembers = _lodash2.default.filter(campaignJSON.members, function (member) {
	        return isEmailRecipient(member);
	      });
	      var shortlist = campaignJSON.shortlist,
	          owner = campaignJSON.owner;
	
	      var hasShortlist = !_lodash2.default.isNil(shortlist);
	      var shortlistName = hasShortlist && shortlist.name;
	
	      var campaignMailouts = campaignJSON.mailouts;
	
	      var mailouts = _lodash2.default.compact(stateMailouts || campaignMailouts);
	
	      return _react2.default.createElement(
	        'div',
	        { style: { margin: 30 } },
	        modalOpened && _react2.default.createElement(_mailoutsCreateModal2.default, {
	          onClose: this.toggleMailoutsModal,
	          onSubmit: this.submitMailout,
	          isSubmitting: isSubmitting,
	          error: submitError,
	          organisation: owner
	        }),
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { fluid: true },
	          hasShortlist && _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 8 },
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { color: 'blue', fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    'table',
	                    { style: { width: '100%' } },
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                          'h4',
	                          null,
	                          'Campaign created from SHORTLIST'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { to: '/shortlists/' + shortlist.id },
	                          _react2.default.createElement(
	                            _semanticUiReact.Label,
	                            { color: 'blue', basic: true },
	                            shortlistName
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 8 },
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { color: 'green', fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Email Settings'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { style: { color: 'rgba(0,0,0,.4)' } },
	                        'manage the automated campaign summary emails.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Card,
	                    { fluid: true },
	                    _react2.default.createElement(
	                      _semanticUiReact.Card.Content,
	                      null,
	                      _react2.default.createElement(_campaignEmailSettings2.default, { campaignId: campaign.get('id'), teamMembers: teamMembers })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { color: 'green', fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Grid,
	                      { cols: true },
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { width: 14 },
	                        _react2.default.createElement(
	                          'h2',
	                          null,
	                          'Influencer Mailouts'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { style: { color: 'rgba(0,0,0,.4)' } },
	                          'manage the outreach emails for the campaign'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { width: 2 },
	                        _react2.default.createElement(_semanticUiReact.Popup, {
	                          trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                            circular: true, inverted: true, color: 'green', icon: 'add',
	                            onClick: this.toggleMailoutsModal
	                          }),
	                          content: 'Click here to create mailouts'
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Card,
	                    { fluid: true },
	                    _react2.default.createElement(
	                      _semanticUiReact.Card.Content,
	                      null,
	                      _lodash2.default.isEmpty(mailouts) && _react2.default.createElement(
	                        'p',
	                        { style: { color: 'rgba(0,0,0,.4)', fontSize: '14px' } },
	                        'There are no mailouts yet'
	                      ),
	                      !_lodash2.default.isEmpty(mailouts) && _react2.default.createElement(
	                        _semanticUiReact.Table,
	                        { basic: 'very' },
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Header,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            null,
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.HeaderCell,
	                              { singleLine: true },
	                              'Mailout'
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.HeaderCell,
	                              { collapsing: true },
	                              'Influencers'
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.HeaderCell,
	                              { style: textRight },
	                              _react2.default.createElement(_semanticUiReact.Popup, {
	                                trigger: _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  'Sent'
	                                ),
	                                content: 'How many times the mailout has been sent'
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Body,
	                          null,
	                          _lodash2.default.map(mailouts, function (m) {
	                            var lastSentDate = _this4.getLastSentDate(m);
	                            return _react2.default.createElement(
	                              _semanticUiReact.Table.Row,
	                              { key: m.id },
	                              _react2.default.createElement(
	                                _semanticUiReact.Table.Cell,
	                                null,
	                                _react2.default.createElement(
	                                  'div',
	                                  { style: { display: 'flex', flexDirection: 'column', color: 'rgba(0,0,0,.4)' } },
	                                  _react2.default.createElement(
	                                    'a',
	                                    {
	                                      style: { color: '#4183c4' },
	                                      href: '/mailouts/' + m.id,
	                                      target: '_blank',
	                                      rel: 'noopener noreferrer'
	                                    },
	                                    m.name
	                                  ),
	                                  lastSentDate && _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Last Sent: ',
	                                    lastSentDate
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _semanticUiReact.Table.Cell,
	                                { textAlign: 'right' },
	                                _lodash2.default.size(m.influencers)
	                              ),
	                              _react2.default.createElement(
	                                _semanticUiReact.Table.Cell,
	                                { textAlign: 'right' },
	                                _lodash2.default.size(m.outreachHistory)
	                              )
	                            );
	                          })
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Footer,
	                          { fullWidth: true },
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            null,
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.HeaderCell,
	                              null,
	                              _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Total'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.HeaderCell,
	                              { textAlign: 'right' },
	                              _react2.default.createElement(
	                                'h4',
	                                null,
	                                this.getFormattedNumber(_lodash2.default.sumBy(mailouts, function (m) {
	                                  return _lodash2.default.size(m.influencers);
	                                }))
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.HeaderCell,
	                              { textAlign: 'right' },
	                              _react2.default.createElement(
	                                'h4',
	                                null,
	                                this.getFormattedNumber(_lodash2.default.sumBy(mailouts, function (m) {
	                                  return _lodash2.default.size(m.outreachHistory);
	                                }))
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 8 },
	              _react2.default.createElement(_eventFeed2.default, {
	                cardColour: 'pink',
	                campaignId: campaign.get('id'),
	                feedType: _static.FEED_TYPES.CAMPAIGN
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignNotificationsTab;
	}(_react.Component);
	
	CampaignNotificationsTab.propTypes = {
	  campaign: _propTypes2.default.object.isRequired,
	  restClient: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default)(CampaignNotificationsTab);

/***/ },
/* 1909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _formatting = __webpack_require__(287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formatNumber = function formatNumber(num, numFormat) {
	  if (numFormat) {
	    return (0, _numeral2.default)(num).format(numFormat);
	  }
	  var format = num > 1000 ? '0.00a' : '0';
	  format = num > 1000000 ? '0.00a' : format;
	  return (0, _numeral2.default)(num).format(format);
	};
	
	var performanceBlockStyles = {
	  backgroundColor: '#FFEFD5'
	};
	
	var totalsRowStyles = {
	  fontWeight: 900,
	  backgroundColor: '#D2D1D7'
	};
	
	var CampaignSummary = function (_Component) {
	  _inherits(CampaignSummary, _Component);
	
	  function CampaignSummary(props) {
	    _classCallCheck(this, CampaignSummary);
	
	    var _this = _possibleConstructorReturn(this, (CampaignSummary.__proto__ || Object.getPrototypeOf(CampaignSummary)).call(this, props));
	
	    _this.state = {
	      report: null,
	      isLoading: props.isLoading,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(CampaignSummary, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          isLoading = _props.isLoading,
	          campaigns = _props.campaigns;
	
	
	      var totalReach = _lodash2.default.sumBy(campaigns, 'reachTotal');
	      var totalImpressions = _lodash2.default.sumBy(campaigns, 'impressionsTotal');
	      var overallAveER = _lodash2.default.sumBy(campaigns, 'aveER') / _lodash2.default.size(campaigns);
	      var impsEMVTotal = _lodash2.default.sumBy(campaigns, 'impsEMVTotal');
	      var engsEMVTotal = _lodash2.default.sumBy(campaigns, 'engsEMVTotal');
	
	      return _react2.default.createElement(
	        'div',
	        { style: { marginTop: '40px', clear: 'all' } },
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { color: 'green', fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              'table',
	              { width: '100%' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { width: '50%' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    title
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            !isLoading && _react2.default.createElement(
	              _semanticUiReact.Table,
	              { celled: true },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Header,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { textAlign: 'right', width: 1 }),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'right', style: performanceBlockStyles, width: 1 },
	                    'Reach'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'right', style: performanceBlockStyles, width: 1 },
	                    _react2.default.createElement(_semanticUiReact.Popup, { content: 'Impressions', trigger: _react2.default.createElement(
	                        'span',
	                        null,
	                        'Imps.'
	                      ) })
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'right', style: performanceBlockStyles, width: 1 },
	                    'Avg ER %'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'right', style: performanceBlockStyles, width: 1 },
	                    _react2.default.createElement(_semanticUiReact.Popup, { content: 'Engagements', trigger: _react2.default.createElement(
	                        'span',
	                        null,
	                        'EMV Impressions'
	                      ) })
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'right', style: performanceBlockStyles, width: 1 },
	                    _react2.default.createElement(_semanticUiReact.Popup, { content: 'Earned Media Value', trigger: _react2.default.createElement(
	                        'span',
	                        null,
	                        'EMV Engagements'
	                      ) })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                _lodash2.default.map(campaigns, function (campaign) {
	                  return _react2.default.createElement(ReportTableRow, {
	                    key: campaign.id,
	                    campaignReport: campaign
	                  });
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Footer,
	                { fullWidth: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  { style: totalsRowStyles },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles },
	                    'Totals'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalReach)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    formatNumber(totalImpressions)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    (0, _formatting.percentFormatted)(overallAveER),
	                    '%'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    '$',
	                    formatNumber(impsEMVTotal)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { style: totalsRowStyles, textAlign: 'right' },
	                    '$',
	                    formatNumber(engsEMVTotal)
	                  )
	                )
	              )
	            ),
	            isLoading && _react2.default.createElement(
	              'p',
	              null,
	              'Loading...'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignSummary;
	}(_react.Component);
	
	var ReportTableRow = function ReportTableRow(_ref) {
	  var campaignReport = _ref.campaignReport;
	  var campaignName = campaignReport.campaignName,
	      impsEMVTotal = campaignReport.impsEMVTotal,
	      engsEMVTotal = campaignReport.engsEMVTotal,
	      reachTotal = campaignReport.reachTotal,
	      impressionsTotal = campaignReport.impressionsTotal,
	      campaignId = campaignReport.id,
	      aveER = campaignReport.aveER;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: 'https://share.dyzio.co/report/' + campaignId + '/emv', target: '_blank' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          campaignName
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: performanceBlockStyles, textAlign: 'right' },
	      formatNumber(reachTotal)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: performanceBlockStyles, textAlign: 'right' },
	      formatNumber(impressionsTotal)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: performanceBlockStyles, textAlign: 'right' },
	      (0, _formatting.percentFormatted)(aveER),
	      '%'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: performanceBlockStyles, textAlign: 'right' },
	      '$',
	      formatNumber(impsEMVTotal)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: performanceBlockStyles, textAlign: 'right' },
	      '$',
	      formatNumber(engsEMVTotal)
	    )
	  );
	};
	
	CampaignSummary.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  campaigns: _propTypes2.default.array
	};
	
	CampaignSummary.defaultProps = {
	  isLoading: false,
	  campaigns: [],
	  showCampaignTitle: true
	};
	
	ReportTableRow.propTypes = {
	  campaignReport: _propTypes2.default.object.isRequired
	};
	
	ReportTableRow.defaultProps = {
	  showContactedInfluencersValue: true,
	  showReviewedInfluencersValue: true
	};
	exports.default = (0, _recompose.compose)(_hasRestClient2.default)(CampaignSummary);

/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CampaignTypeLabel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCampaignLabelColor = function getCampaignLabelColor(type) {
	  switch (type) {
	    case 'ACR':
	      return 'orange';
	    case 'AUTOMATED_CAMPAIGN':
	      return 'pink';
	    default:
	      return 'green';
	  }
	};
	
	function CampaignTypeLabel(_ref) {
	  var campaignType = _ref.campaignType;
	
	  var color = getCampaignLabelColor(campaignType);
	  return _react2.default.createElement(
	    _semanticUiReact.Label,
	    { size: 'mini', basic: true, color: color },
	    _lodash2.default.upperCase(campaignType)
	  );
	}
	
	CampaignTypeLabel.propTypes = {
	  campaignType: _propTypes2.default.string.isRequired
	};

/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _campaignStatus = __webpack_require__(930);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var labelStyle = {
	  width: '100%'
	};
	var BASIC_DATA_FORMAT = 'll';
	
	var CampaignStatusComponent = function CampaignStatusComponent(campaign) {
	  var liveDate = _lodash2.default.get(campaign, 'liveDate', null);
	  var endDate = _lodash2.default.get(campaign, 'endDate', null);
	
	  var liveMoment = (0, _moment2.default)(liveDate);
	  var endMoment = (0, _moment2.default)(endDate);
	  var status = void 0;
	
	  var cStatus = (0, _campaignStatus.getCampaignStatus)(campaign);
	
	  if (cStatus === _campaignStatus.campaignStatus.INVALID) return _react2.default.createElement('div', null);
	
	  if (cStatus === _campaignStatus.campaignStatus.FUTURE) {
	    status = {
	      color: 'blue',
	      text: 'future',
	      content: 'Campaign will start on ' + liveMoment.format(BASIC_DATA_FORMAT)
	    };
	  }
	
	  if (cStatus === _campaignStatus.campaignStatus.LIVE) {
	    status = {
	      color: 'green',
	      text: 'LIVE',
	      icon: 'play circle outline',
	      content: 'Campaign will end on ' + endMoment.format(BASIC_DATA_FORMAT)
	    };
	  }
	
	  if (cStatus === _campaignStatus.campaignStatus.COMPLETED) {
	    status = {
	      color: 'orange',
	      text: 'complete',
	      content: 'Campaign completed on ' + endMoment.format(BASIC_DATA_FORMAT)
	    };
	  }
	
	  return status ? _react2.default.createElement(
	    'div',
	    { style: { paddingTop: '3px' } },
	    _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(
	        _semanticUiReact.Label,
	        { size: 'tiny', basic: true, color: status.color, style: labelStyle },
	        status.text,
	        ' ',
	        status.icon && _react2.default.createElement(_semanticUiReact.Icon, { name: status.icon, size: 'large' })
	      ),
	      content: status.content
	    })
	  ) : _react2.default.createElement('div', null);
	};
	
	CampaignStatusComponent.propTypes = {
	  liveDate: _propTypes2.default.string.isRequired,
	  endDate: _propTypes2.default.string.isRequired
	};
	
	exports.default = CampaignStatusComponent;

/***/ },
/* 1912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(444);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactChartjs.defaults.global.defaultFontStyle = 'bold';
	_reactChartjs.defaults.global.defaultFontFamily = '"Varela Round", "Arial Rounded MT", "Arial", "sans-serif"';
	_reactChartjs.defaults.global.defaultFontSize = 14;
	
	var sf = function sf(num) {
	  return (0, _numeral2.default)(num).format('0.0a');
	};
	
	function getChartdataFromAnalytics(trackedAsset) {
	  var latest = trackedAsset.statistics.slice(-20);
	  var latestViews = latest.map(function (s) {
	    return {
	      x: Date.parse(s.createdDate),
	      y: s.viewCount
	    };
	  });
	  return latestViews;
	}
	
	var AnalyticsChart = function AnalyticsChart(_ref) {
	  var trackedAsset = _ref.trackedAsset;
	
	  if (!trackedAsset || !trackedAsset.statistics) return null;
	  var analyticsData = getChartdataFromAnalytics(trackedAsset);
	  var data = {
	    datasets: [{
	      fill: false,
	      fillColor: 'rgba(38,228,184,0.05)',
	      backgroundColor: 'rgba(38,228,184,0.05)',
	      borderColor: 'rgba(38,228,184,1)',
	      pointBorderColor: 'rgba(38,228,184,1)',
	      pointBackgroundColor: '#fff',
	      pointHoverBackgroundColor: 'rgba(38,228,184,1)',
	      pointHoverBorderColor: 'rgba(38,228,184,1)',
	      label: trackedAsset.title,
	      data: analyticsData
	    }]
	  };
	
	  var chartOptions = {
	    responsive: true,
	    maintainAspectRatio: true,
	    tooltips: {
	      mode: 'index',
	      intersect: false
	    },
	    title: {
	      display: false,
	      text: 'Total Viewing',
	      padding: 10,
	      fontSize: 18
	    },
	    legend: {
	      display: false
	    },
	    elements: {
	      line: {
	        tension: 0
	      }
	    },
	    layout: {
	      padding: 20,
	      fullWidth: false
	    },
	    hover: {
	      mode: 'nearest',
	      intersect: true
	    },
	    scales: {
	      xAxes: [{
	        type: 'time',
	        ticks: {
	          maxRotation: 0,
	          autoSkip: true,
	          maxTicksLimit: 5
	          // callback: function(value) {
	          //     return (new Date(value).getDate() % 5 == 0) ? value : null;
	          // },
	        },
	        time: {
	          displayFormats: {
	            day: 'ddd DD MMM'
	          }
	        }
	      }],
	      yAxes: [{
	        ticks: {
	          callback: function callback(label, index, labels) {
	            return sf(label);
	          }
	        },
	        scaleLabel: {
	          display: false
	        }
	      }]
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'analytics-chart' },
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Total Viewing'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'chartsubtitle' },
	      _react2.default.createElement(
	        'p',
	        { className: 'small light' },
	        'LAST 20 DAYS'
	      )
	    ),
	    _react2.default.createElement(_reactChartjs.Line, { data: data, options: chartOptions })
	  );
	};
	
	exports.default = AnalyticsChart;

/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSuccessMessage = undefined;
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var grayStyle = {
	  color: '#333'
	};
	
	var textAlignCenter = {
	  textAlign: 'center'
	};
	
	var getSuccessMessage = exports.getSuccessMessage = function getSuccessMessage() {
	  var processedInvitations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var names = _lodash2.default.map(processedInvitations.invitations, 'attributes.name');
	  if (_lodash2.default.isEmpty(names)) {
	    return 'no emails sent';
	  }
	  if (_lodash2.default.size(names) === 1) {
	    return 'email sent to ' + _lodash2.default.head(names);
	  }
	  if (_lodash2.default.size(names) === 2) {
	    return 'emails sent to ' + _lodash2.default.nth(names, 0) + ' and ' + _lodash2.default.nth(names, 1);
	  }
	  return 'emails sent to ' + _lodash2.default.nth(names, 0) + ', ' + _lodash2.default.nth(names, 1) + ' and ' + (_lodash2.default.size(names) - 2) + ' more';
	};
	
	var ChaseEmailSendModal = function (_Component) {
	  _inherits(ChaseEmailSendModal, _Component);
	
	  function ChaseEmailSendModal(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ChaseEmailSendModal);
	
	    var _this = _possibleConstructorReturn(this, (ChaseEmailSendModal.__proto__ || Object.getPrototypeOf(ChaseEmailSendModal)).call(this, props));
	
	    _this.handleClick = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var campaignId, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              campaignId = _this.props.campaignId;
	
	              _this.setState({
	                requestRunning: true
	              });
	              _context.next = 4;
	              return _this.apiClient.post('campaign/chase', {
	                data: {
	                  campaign: {
	                    id: campaignId
	                  }
	                }
	              }).catch(function () {
	                _this.setState({
	                  sentOK: false,
	                  requestRunning: false,
	                  requestFailed: true
	                });
	              });
	
	            case 4:
	              response = _context.sent;
	
	              if (response) {
	                _this.setState({
	                  sentOK: true,
	                  requestRunning: false,
	                  requestFailed: false,
	                  processedInvitations: _lodash2.default.get(response, 'data.data', [])
	                });
	              }
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    var buildRESTClient = props.buildRESTClient;
	
	    _this.state = {
	      sentOK: false,
	      requestRunning: false,
	      requestFailed: false
	    };
	    _this.apiClient = buildRESTClient({
	      baseURL: ("https://bahhjuaz6d.execute-api.eu-west-1.amazonaws.com/production")
	    });
	    return _this;
	  }
	
	  _createClass(ChaseEmailSendModal, [{
	    key: 'render',
	    value: function render() {
	      var onClose = this.props.onClose;
	      var _state = this.state,
	          requestRunning = _state.requestRunning,
	          requestFailed = _state.requestFailed,
	          sentOK = _state.sentOK,
	          processedInvitations = _state.processedInvitations;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        {
	          open: true,
	          size: 'tiny',
	          closeOnEscape: true,
	          closeOnDimmerClick: true,
	          onClose: onClose
	        },
	        _react2.default.createElement(_dyzioModal.DyzioModalHeader, { onClose: onClose, headerText: 'Send chase email' }),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          { style: textAlignCenter },
	          _react2.default.createElement(_semanticUiReact.Icon, {
	            name: requestRunning ? 'spinner' : 'send',
	            active: requestRunning,
	            color: sentOK ? 'green' : 'orange',
	            size: 'huge'
	          }),
	          _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, clearing: true }),
	          sentOK && _react2.default.createElement(
	            'h3',
	            null,
	            getSuccessMessage(processedInvitations)
	          ),
	          !sentOK && !requestFailed && _react2.default.createElement(
	            'h3',
	            { style: grayStyle },
	            'do you really want to send chase emails ',
	            _react2.default.createElement('br', null),
	            'to all influencers from this campaign?'
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { icon: true, labelPosition: 'left', color: 'pink', fluid: true, onClick: sentOK || requestFailed ? onClose : this.handleClick },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
	            sentOK ? 'OK' : 'Send'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChaseEmailSendModal;
	}(_react.Component);
	
	ChaseEmailSendModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  campaignId: _propTypes2.default.string.isRequired,
	  buildRESTClient: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _hasRestClient2.default)(ChaseEmailSendModal);

/***/ },
/* 1914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputProps = {
	  placeholder: 'Organisation name'
	};
	
	var CloneShortlistModal = function CloneShortlistModal(props) {
	  var visible = props.visible,
	      selected = props.selected,
	      closeHandler = props.closeHandler,
	      searchHandler = props.searchHandler,
	      selectedHandler = props.selectedHandler,
	      options = props.options,
	      loading = props.loading,
	      searched = props.searched,
	      yepButtonHandler = props.yepButtonHandler;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    { size: 'small', open: visible },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Header,
	      null,
	      'Clone shortlist'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      _react2.default.createElement(_semanticUiReact.Search, {
	        fluid: true,
	        className: 'full-width',
	        input: inputProps,
	        loading: loading,
	        showNoResults: searched,
	        minCharacters: 3,
	        results: options,
	        onSearchChange: searchHandler,
	        onResultSelect: selectedHandler
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        selected && 'Clone shortlist to ' + selected.title || 'Please choose target organisation'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Actions,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        { color: 'pink', onClick: closeHandler },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
	        'Cancel'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        { color: 'green', disabled: !selected, onClick: yepButtonHandler },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
	        'Yep'
	      )
	    )
	  );
	};
	
	CloneShortlistModal.propTypes = {
	  visible: _propTypes2.default.bool.isRequired,
	  loading: _propTypes2.default.bool.isRequired,
	  selected: _propTypes2.default.object.isRequired,
	  closeHandler: _propTypes2.default.func.isRequired,
	  searchHandler: _propTypes2.default.func.isRequired,
	  yepButtonHandler: _propTypes2.default.func.isRequired,
	  options: _propTypes2.default.array.isRequired,
	  selectedHandler: _propTypes2.default.func.isRequired,
	  searched: _propTypes2.default.bool.isRequired
	};
	
	exports.default = CloneShortlistModal;

/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _recompose = __webpack_require__(15);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _currencies = __webpack_require__(128);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _organisationInventory = __webpack_require__(915);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var currencyLabelStyle = {
	  paddingTop: 13
	};
	
	var deleteIconStyle = {
	  float: 'right'
	};
	
	var assignedItemStyle = {
	  width: '100%',
	  marginBottom: 8,
	  lineHeight: '26px'
	};
	
	var dropdownStyle = {
	  marginTop: 5
	};
	
	var iconMarginLeftStyle = {
	  marginLeft: 5
	};
	
	var CollaborationBudget = function (_Component) {
	  _inherits(CollaborationBudget, _Component);
	
	  function CollaborationBudget(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CollaborationBudget);
	
	    var _this = _possibleConstructorReturn(this, (CollaborationBudget.__proto__ || Object.getPrototypeOf(CollaborationBudget)).call(this, props));
	
	    _this.loadInventoryItems = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, restClient, organisationId, discussionId, response, discussionResponse, selectedInventoryItems, inventoryItems;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, restClient = _this$props.restClient, organisationId = _this$props.userInfo.organisationId, discussionId = _this$props.discussionId;
	              _context.next = 3;
	              return restClient('inventoryItems?filter[organisation]=' + organisationId);
	
	            case 3:
	              response = _context.sent;
	              _context.next = 6;
	              return restClient.get('discussions/' + discussionId);
	
	            case 6:
	              discussionResponse = _context.sent;
	              selectedInventoryItems = _lodash2.default.get(discussionResponse, 'data.data.relationships.inventoryItems.data', []);
	              inventoryItems = _lodash2.default.get(response, 'data.data', []);
	
	              _this.setState({
	                inventoryItems: inventoryItems,
	                selectedInventoryItems: selectedInventoryItems,
	                isLoadingInventoryItems: false
	              });
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.onChange = function (e, _ref2) {
	      var value = _ref2.value;
	      return _this.setState({
	        value: value
	      });
	    };
	
	    _this.toggleInventoryAddBlockVisibility = function () {
	      return _this.setState({
	        isAddingInventoryItems: true
	      });
	    };
	
	    _this.onDeleteInventoryItem = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(inventoryItemId) {
	        var _this$props2, restClient, discussionId, data;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$props2 = _this.props, restClient = _this$props2.restClient, discussionId = _this$props2.discussionId;
	                data = _lodash2.default.reject(_this.state.selectedInventoryItems, ['id', inventoryItemId]);
	                _context2.next = 4;
	                return restClient.patch('discussions/' + discussionId + '/relationships/inventoryItems', {
	                  data: data
	                });
	
	              case 4:
	                _this.setState({
	                  selectedInventoryItems: data
	                });
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.onInventoryItemSelected = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(event, _ref5) {
	        var value = _ref5.value;
	
	        var _this$props3, restClient, discussionId, data;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this$props3 = _this.props, restClient = _this$props3.restClient, discussionId = _this$props3.discussionId;
	                data = _lodash2.default.get(_this.state, 'selectedInventoryItems', []);
	
	                data.push({
	                  id: value,
	                  type: 'inventoryItems'
	                });
	                _context3.next = 5;
	                return restClient.patch('discussions/' + discussionId + '/relationships/inventoryItems', {
	                  data: data
	                });
	
	              case 5:
	                _this.setState({
	                  isAddingInventoryItems: false,
	                  selectedInventoryItems: data
	                });
	
	              case 6:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2, _x3) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleInputState = function () {
	      return _this.setState({
	        isEditing: !_this.state.isEditing
	      });
	    };
	
	    _this.persistBudget = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(fee) {
	        var saveNewBudget;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                saveNewBudget = _this.props.saveNewBudget;
	                _context4.next = 3;
	                return saveNewBudget(fee);
	
	              case 3:
	                _this.setState({
	                  value: fee,
	                  isEditing: false
	                });
	
	              case 4:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      isAddingInventoryItems: false,
	      isLoadingInventoryItems: false,
	      inventoryItems: [],
	      selectedInventoryItems: [],
	      value: props.budget || 0,
	      isEditing: false
	    };
	    return _this;
	  }
	
	  _createClass(CollaborationBudget, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return this.loadInventoryItems();
	
	              case 2:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref7.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var campaignCurrency = this.props.campaignCurrency;
	      var _state = this.state,
	          value = _state.value,
	          isEditing = _state.isEditing,
	          inventoryItems = _state.inventoryItems,
	          isAddingInventoryItems = _state.isAddingInventoryItems;
	
	
	      var labelProps = {
	        content: (0, _currencies.renderCurrencySymbol)(campaignCurrency),
	        basic: true,
	        style: currencyLabelStyle
	      };
	
	      var inputActionProps = {
	        icon: isEditing ? 'save' : 'pencil',
	        onClick: isEditing ? function () {
	          return _this3.persistBudget(value);
	        } : this.toggleInputState,
	        disabled: isEditing && _lodash2.default.isEmpty(value),
	        color: isEditing ? 'pink' : 'green'
	      };
	
	      var options = _lodash2.default.map(inventoryItems, function (item) {
	        return {
	          key: _lodash2.default.get(item, 'attributes.value'),
	          value: _lodash2.default.get(item, 'id'),
	          text: _lodash2.default.get(item, 'attributes.value') + ' -  ' + (0, _currencies.renderCurrencySymbol)(campaignCurrency) + ' ' + _lodash2.default.get(item, 'attributes.monetaryValue') + ' '
	        };
	      });
	
	      var availableOptions = _lodash2.default.filter(options, function (option) {
	        var foundItem = _lodash2.default.find(_lodash2.default.get(_this3.state, 'selectedInventoryItems'), ['id', _lodash2.default.get(option, 'value')]);
	        return _lodash2.default.isNil(foundItem);
	      });
	
	      var existingInventoryItems = _lodash2.default.map(this.state.selectedInventoryItems, function (item) {
	        return _lodash2.default.find(_this3.state.inventoryItems, ['id', _lodash2.default.get(item, 'id')]);
	      });
	
	      var hasAvailableOptions = !_lodash2.default.isEmpty(availableOptions);
	
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: true },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Fee: Paid to influencer'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(_semanticUiReact.Input, {
	            fluid: true,
	            type: 'number',
	            onChange: this.onChange,
	            disabled: !isEditing,
	            label: labelProps,
	            defaultValue: value,
	            value: value,
	            action: inputActionProps
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Gift: Value of gifts provided',
	            _react2.default.createElement(
	              _targetLink2.default,
	              { href: _organisationInventory.INVENTORY_HELP_LINK, renderIf: true },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'green', style: iconMarginLeftStyle })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _lodash2.default.isEmpty(existingInventoryItems) && _react2.default.createElement(
	            'span',
	            null,
	            'No assigned gifts.'
	          ),
	          !_lodash2.default.isEmpty(existingInventoryItems) && _lodash2.default.map(existingInventoryItems, function (item) {
	            return _react2.default.createElement(
	              _semanticUiReact.Label,
	              { key: _lodash2.default.get(item, 'id'), basic: true, size: 'large', style: assignedItemStyle },
	              _lodash2.default.get(item, 'attributes.value'),
	              ' (',
	              (0, _currencies.renderCurrencySymbol)(campaignCurrency),
	              ' ',
	              _lodash2.default.get(item, 'attributes.monetaryValue'),
	              ')',
	              _react2.default.createElement(_semanticUiReact.Icon, { onClick: function onClick() {
	                  return _this3.onDeleteInventoryItem(_lodash2.default.get(item, 'id'));
	                }, name: 'delete', style: deleteIconStyle, circular: true })
	            );
	          }),
	          isAddingInventoryItems && _react2.default.createElement(_semanticUiReact.Dropdown, {
	            style: dropdownStyle,
	            placeholder: 'Select inventory item',
	            fluid: true,
	            search: true,
	            selection: true,
	            onChange: this.onInventoryItemSelected,
	            options: availableOptions
	          })
	        ),
	        !isAddingInventoryItems && hasAvailableOptions && _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(_semanticUiReact.Button, {
	            style: dropdownStyle,
	            fluid: true,
	            floated: 'right',
	            content: 'Assign gift item',
	            color: 'green',
	            onClick: this.toggleInventoryAddBlockVisibility
	          })
	        )
	      );
	    }
	  }]);
	
	  return CollaborationBudget;
	}(_react.Component);
	
	CollaborationBudget.propTypes = {
	  budget: _propTypes2.default.any.isRequired,
	  campaignCurrency: _propTypes2.default.string.isRequired,
	  saveNewBudget: _propTypes2.default.func.isRequired,
	  discussionId: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(CollaborationBudget);

/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _validator = __webpack_require__(84);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollaborationEmail = function (_Component) {
	  _inherits(CollaborationEmail, _Component);
	
	  function CollaborationEmail(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CollaborationEmail);
	
	    var _this = _possibleConstructorReturn(this, (CollaborationEmail.__proto__ || Object.getPrototypeOf(CollaborationEmail)).call(this, props));
	
	    _this.onChange = function (e, _ref) {
	      var value = _ref.value;
	      return _this.setState({
	        value: value,
	        isInvalid: !_validator2.default.isEmail(value)
	      });
	    };
	
	    _this.toggleInputState = function () {
	      return _this.setState({
	        isEditing: !_this.state.isEditing
	      });
	    };
	
	    _this.refreshPage = function () {
	      window.location.reload(true);
	    };
	
	    _this.persistEmail = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(email) {
	        var saveNewEmail;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!_validator2.default.isEmail(email)) {
	                  _context.next = 8;
	                  break;
	                }
	
	                saveNewEmail = _this.props.saveNewEmail;
	                _context.next = 4;
	                return saveNewEmail(email);
	
	              case 4:
	                _this.setState({
	                  value: email,
	                  isEditing: false
	                });
	                _this.refreshPage();
	                _context.next = 9;
	                break;
	
	              case 8:
	                _this.setState({
	                  value: email,
	                  isInvalid: true
	                });
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      value: props.email || '',
	      isEditing: false,
	      isInvalid: false
	    };
	    return _this;
	  }
	
	  _createClass(CollaborationEmail, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          value = _state.value,
	          isEditing = _state.isEditing,
	          isInvalid = _state.isInvalid;
	
	
	      var inputActionProps = {
	        icon: isEditing ? 'save' : 'pencil',
	        onClick: isEditing ? function () {
	          return _this3.persistEmail(value);
	        } : this.toggleInputState,
	        disabled: isEditing && _lodash2.default.isEmpty(value),
	        color: isEditing ? 'pink' : 'green'
	      };
	
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: true },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Email'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(_semanticUiReact.Input, {
	            fluid: true,
	            onChange: this.onChange,
	            disabled: !isEditing,
	            defaultValue: value,
	            value: value,
	            action: inputActionProps,
	            error: isInvalid
	          })
	        ),
	        (isInvalid || !value) && _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          { meta: true, textAlign: 'center' },
	          _react2.default.createElement(
	            _semanticUiReact.Label,
	            { color: 'red', basic: true },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'red' }),
	            'Invalid email'
	          )
	        )
	      );
	    }
	  }]);
	
	  return CollaborationEmail;
	}(_react.Component);
	
	CollaborationEmail.propTypes = {
	  email: _propTypes2.default.string.isRequired,
	  saveNewEmail: _propTypes2.default.func.isRequired
	};
	
	exports.default = CollaborationEmail;

/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollaborationFeedItem = function CollaborationFeedItem(_ref) {
	  var createdDate = _ref.createdDate,
	      message = _ref.message;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _moment2.default)(createdDate).format('MMM DD [at] LT')
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      message
	    )
	  );
	};
	
	CollaborationFeedItem.propTypes = {
	  createdDate: _propTypes2.default.string.isRequired,
	  message: _propTypes2.default.string.isRequired
	};
	
	exports.default = CollaborationFeedItem;

/***/ },
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComingSoonText = function ComingSoonText() {
	  return _react2.default.createElement(
	    "div",
	    { className: "coming-soon-wrapper" },
	    _react2.default.createElement(
	      "p",
	      null,
	      "Coming soon..."
	    )
	  );
	};
	
	exports.default = ComingSoonText;

/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textStyle = {
	  marginTop: 70,
	  fontSize: 18
	};
	
	var buttonStyle = {
	  minWidth: 120
	};
	
	var hintStyle = {
	  color: 'gray',
	  fontSize: 11
	};
	
	var explanationStyle = {
	  paddingTop: 25
	};
	
	var doneThatButtonStyle = _extends({
	  margin: '0 auto',
	  display: 'block'
	}, buttonStyle);
	
	var ConfirmationQuestion = function ConfirmationQuestion(_ref) {
	  var question = _ref.question,
	      onPositive = _ref.onPositive,
	      onNegative = _ref.onNegative,
	      onReset = _ref.onReset,
	      shouldRenderExplanation = _ref.shouldRenderExplanation,
	      explanation = _ref.explanation,
	      explanationButtonText = _ref.explanationButtonText;
	
	  if (shouldRenderExplanation) {
	    return _react2.default.createElement(
	      'div',
	      { style: explanationStyle },
	      explanation,
	      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        { onClick: onReset, style: doneThatButtonStyle, color: 'pink' },
	        explanationButtonText
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: textStyle },
	      question
	    ),
	    _react2.default.createElement(
	      'i',
	      { style: hintStyle },
	      'click no for further info'
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	    _react2.default.createElement(
	      _semanticUiReact.Button,
	      { style: buttonStyle, onClick: onPositive, color: 'pink' },
	      'Yes'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Button,
	      { style: buttonStyle, onClick: onNegative, color: 'gray' },
	      'No'
	    )
	  );
	};
	
	ConfirmationQuestion.defaultProps = {
	  explanationButtonText: 'Done that!'
	};
	
	ConfirmationQuestion.propTypes = {
	  question: _propTypes2.default.node.isRequired,
	  onPositive: _propTypes2.default.func.isRequired,
	  onNegative: _propTypes2.default.func.isRequired,
	  onReset: _propTypes2.default.func.isRequired,
	  shouldRenderExplanation: _propTypes2.default.bool.isRequired,
	  explanation: _propTypes2.default.node.isRequired,
	  explanationButtonText: _propTypes2.default.string
	};
	
	exports.default = ConfirmationQuestion;

/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _influencerCategory = __webpack_require__(547);
	
	var _influencerCategory2 = _interopRequireDefault(_influencerCategory);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var messageStyles = {
	  width: 'max-content'
	};
	
	var rejectReasons = [{ key: 'sexual-content', text: 'Sexual content', value: 'Sexual content' }, { key: 'low-quality', text: 'Low quality content', value: 'Low quality content' }, { key: 'selfies-only', text: 'Only selfies', value: 'Only selfies' }, { key: 'few-posts', text: 'Not many posts', value: 'Not many posts' }, { key: 'no-reels', text: 'No reels', value: 'No reels' }, { key: 'low-quality-product', text: 'Low quality product reviewer', value: 'Low quality product reviewer' }, { key: 'no-face', text: 'Does not show face', value: 'Does not show face' }, { key: 'beauty-company-owner', text: 'Beauty company owner', value: 'Beauty company owner' }, { key: 'not-relevant', text: 'Not relevant', value: 'Not relevant' }, { key: 'wrong-country', text: 'Wrong country', value: 'Wrong country' }, { key: 'too-family-oriented', text: 'Too family oriented', value: 'Too family oriented' }, { key: 'another-beauty-service', text: 'Another beauty service', value: 'Another beauty service' }, { key: 'strong-focus-on-other-topic', text: 'Strong focus on other topic', value: 'Strong focus on other topic' }];
	
	var dropdownStyles = {
	  color: '#1d1937 !important',
	  border: '2px solid #1d1937',
	  fontWeight: 600,
	  height: '46px',
	  display: 'flex',
	  justifyContent: 'center',
	  alignItems: 'center'
	};
	
	var CreatorApprovalModal = function (_Component) {
	  _inherits(CreatorApprovalModal, _Component);
	
	  function CreatorApprovalModal(props) {
	    _classCallCheck(this, CreatorApprovalModal);
	
	    var _this = _possibleConstructorReturn(this, (CreatorApprovalModal.__proto__ || Object.getPrototypeOf(CreatorApprovalModal)).call(this, props));
	
	    _this.fetchCreator = function () {
	      var _this$props = _this.props,
	          influencerId = _this$props.influencerId,
	          jsonAPIClient = _this$props.jsonAPIClient;
	
	      _this.setState({ isLoading: true });
	      jsonAPIClient.get('creators', influencerId).then(function (response) {
	        var resource = response.toJSONTree();
	        _this.setState({
	          influencer: resource,
	          influencerDetails: resource,
	          isLoaded: true,
	          isLoading: false,
	          isError: false
	        });
	      });
	    };
	
	    _this.getApprovalsCount = function (country) {
	      var processedCreatorsData = _this.state.processedCreatorsData;
	
	      var data = _lodash2.default.find(processedCreatorsData, ['country', country]);
	      return _lodash2.default.get(data, 'count', '-');
	    };
	
	    _this.state = {
	      influencer: null,
	      influencerDetails: null,
	      isLoaded: false,
	      isLoading: true,
	      isError: false,
	      adrModalOpen: false,
	      selectedPlatforms: [],
	      dataPermission: null,
	      isLoadingPermission: true
	    };
	    return _this;
	  }
	
	  _createClass(CreatorApprovalModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchCreator();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.influencerId !== prevProps.influencerId) {
	        this.fetchCreator();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          influencer = _state.influencer,
	          assessment = _state.assessment,
	          isLoading = _state.isLoading;
	      var _props = this.props,
	          onClose = _props.onClose,
	          onApprove = _props.onApprove,
	          onSkip = _props.onSkip,
	          onReject = _props.onReject,
	          influencerId = _props.influencerId,
	          isPatchingCreator = _props.isPatchingCreator,
	          error = _props.error;
	
	      var _ref = influencer || {},
	          name = _ref.name,
	          thumbnail = _ref.thumbnail,
	          primarySocialHandle = _ref.primarySocialHandle,
	          facebookCount = _ref.facebookCount,
	          instagramCount = _ref.instagramCount,
	          twitterCount = _ref.twitterCount,
	          youtubeCount = _ref.youtubeCount,
	          facebook = _ref.facebook,
	          instagram = _ref.instagram,
	          twitter = _ref.twitter,
	          youtube = _ref.youtube,
	          twitch = _ref.twitch,
	          twitchCount = _ref.twitchCount,
	          tiktok = _ref.tiktok,
	          tiktokCount = _ref.tiktokCount,
	          telegramUser = _ref.telegramUser,
	          instagramLocations = _ref.instagramLocations;
	
	      var youtubeSlug = void 0;
	      if (youtube) {
	        var idRegEx = /^UC([a-zA-Z0-9_-]{22})$/;
	        var isChannelId = function isChannelId(yt) {
	          return yt.match(idRegEx);
	        };
	        youtubeSlug = isChannelId(youtube) ? 'channel/' + youtube : 'user/' + youtube;
	      }
	      var commaFormat = function commaFormat(num) {
	        var format = num > 1000000 ? '0.0a' : '0a';
	        return (0, _numeral2.default)(num).format(format);
	      };
	
	      var proxyInfluencer = {
	        youtubeCount: youtubeCount,
	        facebookCount: facebookCount,
	        instagramCount: instagramCount,
	        twitterCount: twitterCount
	      };
	
	      var tiktokIconStyle = {
	        width: 15,
	        marginTop: 2
	      };
	
	      var IG_CONTENT_TYPES = ['REELS', 'CAROUSEL', 'IMAGE', 'VIDEO', 'IGTV'];
	      var mappedLocations = null;
	      if (instagramLocations) {
	        var groupedLocations = _lodash2.default.groupBy(instagramLocations, 'name');
	        mappedLocations = _lodash2.default.map(groupedLocations, function (v, k) {
	          return {
	            name: k,
	            id: _lodash2.default.head(v).id,
	            count: v.length
	          };
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _dyzioModal2.default,
	          { headerText: 'Creator Details', onClose: onClose },
	          _react2.default.createElement(
	            'div',
	            { style: isLoading ? { height: '60vh', overflowY: 'auto' } : {} },
	            isLoading && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: true, inverted: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Loader,
	                  { indeterminate: true },
	                  'Loading'
	                )
	              )
	            ),
	            error && _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  display: 'flex',
	                  justifyContent: 'center',
	                  margin: '20px'
	                }
	              },
	              _react2.default.createElement(_semanticUiReact.Message, {
	                style: messageStyles,
	                icon: 'frown',
	                error: true,
	                header: 'Error',
	                content: 'Something went wrong. Please try again later.'
	              })
	            ),
	            influencer && _react2.default.createElement(
	              'div',
	              { className: 'flex no-border' },
	              _react2.default.createElement(
	                'div',
	                { className: 'item' },
	                _react2.default.createElement(_semanticUiReact.Image, {
	                  src: thumbnail,
	                  alt: name,
	                  size: 'tiny',
	                  shape: 'circular',
	                  spaced: 'right'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'space' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  name,
	                  '\xA0\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'light' },
	                    primarySocialHandle
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(_semanticUiReact.Rating, {
	                  icon: 'star',
	                  rating: assessment,
	                  maxRating: 5,
	                  disabled: true
	                }),
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  influencer.instagramBio
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'item' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'space align-center' },
	                    _react2.default.createElement(
	                      _targetLink2.default,
	                      {
	                        href: 'https://www.facebook.com/' + facebook,
	                        renderIf: Boolean(facebook)
	                      },
	                      _react2.default.createElement('img', { src: '/icons/facebook.svg', alt: 'Facebook' }),
	                      facebook && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        commaFormat(facebookCount)
	                      ),
	                      !facebook && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'space align-center' },
	                    _react2.default.createElement(
	                      _targetLink2.default,
	                      {
	                        href: 'https://www.instagram.com/' + instagram,
	                        renderIf: Boolean(instagram)
	                      },
	                      _react2.default.createElement('img', { src: '/icons/instagram.svg', alt: 'Instagram' }),
	                      instagram && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        commaFormat(instagramCount)
	                      ),
	                      !instagram && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'space align-center' },
	                    _react2.default.createElement(
	                      _targetLink2.default,
	                      {
	                        href: 'https://www.twitter.com/' + twitter,
	                        renderIf: Boolean(twitter)
	                      },
	                      _react2.default.createElement('img', { src: '/icons/twitter.svg', alt: 'Twitter' }),
	                      twitter && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        commaFormat(twitterCount)
	                      ),
	                      !twitter && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'space align-center' },
	                    _react2.default.createElement(
	                      _targetLink2.default,
	                      {
	                        href: 'https://www.youtube.com/' + youtubeSlug,
	                        renderIf: Boolean(youtube)
	                      },
	                      _react2.default.createElement('img', { src: '/icons/youtube.svg', alt: 'YouTube' }),
	                      youtube && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        commaFormat(youtubeCount)
	                      ),
	                      !youtube && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'space align-center' },
	                    _react2.default.createElement(
	                      _targetLink2.default,
	                      {
	                        href: 'https://www.twitch.com/' + twitch,
	                        renderIf: Boolean(twitch) && twitchCount
	                      },
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitch', color: 'purple' }),
	                      twitch && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        commaFormat(twitchCount)
	                      ),
	                      !twitch && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'space align-center' },
	                    _react2.default.createElement(
	                      _targetLink2.default,
	                      {
	                        href: 'https://www.tiktok.com/@' + tiktok,
	                        renderIf: Boolean(tiktok)
	                      },
	                      _react2.default.createElement('img', {
	                        style: tiktokIconStyle,
	                        src: 'https://app.dyzio.co/logos/tiktok-logo.svg',
	                        alt: 'Tiktok'
	                      }),
	                      tiktok && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        commaFormat(tiktokCount)
	                      ),
	                      !tiktok && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'space align-center' },
	                    _react2.default.createElement(
	                      _targetLink2.default,
	                      {
	                        href: 'https://www.facebook.com/' + facebook,
	                        renderIf: false
	                      },
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram', color: 'blue' }),
	                      telegramUser && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'green' })
	                      ),
	                      !telegramUser && _react2.default.createElement(
	                        'p',
	                        { className: 'light' },
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement('div', { className: 'space' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'item align-center' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Category'
	                      )
	                    ),
	                    _react2.default.createElement(_influencerCategory2.default, {
	                      influencer: proxyInfluencer
	                    })
	                  )
	                )
	              )
	            ),
	            influencer && _react2.default.createElement(
	              _semanticUiReact.Segment,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid,
	                { columns: 3 },
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 5 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Influencer Locations'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table,
	                      { celled: true },
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Header,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.HeaderCell,
	                            null,
	                            'Location'
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.HeaderCell,
	                            null,
	                            'Count'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Body,
	                        null,
	                        mappedLocations ? _lodash2.default.map(_lodash2.default.orderBy(mappedLocations, ['count'], ['desc']), function (h) {
	                          return _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            { key: h.id },
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              _react2.default.createElement(
	                                'a',
	                                {
	                                  target: '_blank',
	                                  rel: 'noopener noreferrer',
	                                  href: 'https://www.instagram.com/explore/locations/' + h.id + '/'
	                                },
	                                h.name
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              h.count
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'no locations tagged...'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 6 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Content Analysis (Last 12 posts)'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table,
	                      { celled: true },
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Header,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.HeaderCell,
	                            null,
	                            'content type'
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.HeaderCell,
	                            null,
	                            'count'
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.HeaderCell,
	                            null,
	                            'Eng. Rate'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Body,
	                        null,
	                        influencer.instagramBenchmarks ? _lodash2.default.map(IG_CONTENT_TYPES, function (ct) {
	                          return _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            { key: ct },
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              ct
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              _lodash2.default.get(influencer.instagramBenchmarks[ct], 'count', 0)
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              _lodash2.default.get(influencer.instagramBenchmarks[ct], 'engagementRate', '-'),
	                              '%'
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'not scanned yet...'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 5 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Hashtags (Top 10)'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table,
	                      { celled: true },
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Header,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.HeaderCell,
	                            null,
	                            'Hashtag'
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.HeaderCell,
	                            null,
	                            'Count'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Body,
	                        null,
	                        influencer.instagramHashtags ? _lodash2.default.map(_lodash2.default.take(influencer.instagramHashtags, 10), function (h) {
	                          return _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            { key: h.hashtag },
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              h.hashtag
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              h.count
	                            )
	                          );
	                        }) : _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'not scanned yet...'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            influencer && _react2.default.createElement(
	              'div',
	              {
	                className: 'flex',
	                style: {
	                  justifyContent: 'space-between',
	                  padding: '10px 0px 10px 0px'
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                null,
	                influencer.elemisApprovalStatus && _react2.default.createElement(
	                  'div',
	                  null,
	                  'Status: ',
	                  influencer.elemisApprovalStatus
	                ),
	                influencer.rejectionReason && _react2.default.createElement(
	                  'div',
	                  { style: { color: 'rgba(0,0,0,0.4)' } },
	                  'Reason: ',
	                  influencer.rejectionReason
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex' },
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    loading: isPatchingCreator,
	                    disabled: isPatchingCreator,
	                    basic: true,
	                    size: 'medium',
	                    onClick: function onClick() {
	                      return onSkip(influencerId);
	                    }
	                  },
	                  'Skip'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown,
	                  {
	                    text: 'Reject',
	                    loading: isPatchingCreator,
	                    disabled: isPatchingCreator,
	                    basic: true,
	                    style: dropdownStyles,
	                    button: true,
	                    upward: true
	                  },
	                  _react2.default.createElement(
	                    _semanticUiReact.Dropdown.Menu,
	                    null,
	                    _lodash2.default.map(rejectReasons, function (reason) {
	                      return _react2.default.createElement(_semanticUiReact.Dropdown.Item, Object.assign({}, reason, { onClick: function onClick() {
	                          onReject(influencerId, reason.value);
	                        }
	                      }));
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    loading: isPatchingCreator,
	                    disabled: isPatchingCreator,
	                    color: 'pink',
	                    size: 'medium',
	                    onClick: function onClick() {
	                      return onApprove(influencerId);
	                    }
	                  },
	                  'Approve'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreatorApprovalModal;
	}(_react.Component);
	
	CreatorApprovalModal.propTypes = {
	  influencerId: _propTypes2.default.string.isRequired,
	  jsonAPIClient: _propTypes2.default.object.isRequired,
	  onClose: _propTypes2.default.func,
	  onApprove: _propTypes2.default.func,
	  onReject: _propTypes2.default.func,
	  onSkip: _propTypes2.default.func,
	  isPatchingCreator: _propTypes2.default.bool,
	  error: _propTypes2.default.any
	};
	CreatorApprovalModal.defaultProps = {
	  onClose: _lodash2.default.noop,
	  onApprove: _lodash2.default.noop,
	  onReject: _lodash2.default.noop,
	  onSkip: _lodash2.default.noop,
	  isPatchingCreator: false,
	  error: null
	};
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasJsonapiClient2.default, _hasUserInfo2.default)(CreatorApprovalModal);

/***/ },
/* 1921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactCopyToClipboard = __webpack_require__(315);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var marginTop10 = {
	  marginTop: 10
	};
	
	var spacerStyle = {
	  paddingTop: 15
	};
	
	var CreatorLinkGenerator = function (_Component) {
	  _inherits(CreatorLinkGenerator, _Component);
	
	  function CreatorLinkGenerator() {
	    _classCallCheck(this, CreatorLinkGenerator);
	
	    var _this = _possibleConstructorReturn(this, (CreatorLinkGenerator.__proto__ || Object.getPrototypeOf(CreatorLinkGenerator)).call(this));
	
	    _this.state = {
	      copied: false
	    };
	    return _this;
	  }
	
	  _createClass(CreatorLinkGenerator, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var id = this.props.id;
	
	      var origin = _lodash2.default.get(window, 'origin', 'https://app.dyzio.co');
	      var url = origin + '/creator/' + id;
	      var copied = this.state.copied;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Authorisation Link'
	        ),
	        _react2.default.createElement('div', { style: spacerStyle }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Copy the authorisation link and simply email it to the influencer for them to authorise.'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Label,
	          { fluid: true, style: marginTop10 },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkify' }),
	          ' ',
	          url
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	        _react2.default.createElement(
	          _reactCopyToClipboard.CopyToClipboard,
	          {
	            text: url,
	            onCopy: function onCopy() {
	              return _this2.setState({ copied: true });
	            }
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { color: 'pink', icon: true, labelPosition: 'left', style: marginTop10 },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: copied ? 'checkmark' : 'copy' }),
	            copied ? 'Copied ' : 'Copy Authorisation link'
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreatorLinkGenerator;
	}(_react.Component);
	
	CreatorLinkGenerator.propTypes = {
	  id: _propTypes2.default.string.isRequired
	};
	
	exports.default = CreatorLinkGenerator;

/***/ },
/* 1922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _networkHandleInput = __webpack_require__(277);
	
	var _networkHandleInput2 = _interopRequireDefault(_networkHandleInput);
	
	var _countries = __webpack_require__(93);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _validatedEmailField = __webpack_require__(899);
	
	var _validatedEmailField2 = _interopRequireDefault(_validatedEmailField);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var currentTheme = _themeSelector2.default.theme();
	var gridStyle = {
	  marginTop: 25,
	  textAlign: 'center'
	};
	
	var imageStyle = {
	  margin: '0 auto',
	  display: 'block'
	  // boxShadow: '0 0 10px #777',
	};
	
	var nameStyle = {
	  padding: 10
	};
	
	var descriptionStyle = {
	  color: '#999'
	};
	
	var cardStyle = {
	  paddingTop: 25,
	  minHeight: 530
	};
	
	var errorStyle = {
	  paddingTop: 170,
	  color: 'gray'
	};
	
	var DUMMY_THUMBNAIL = '/images/instagram-dummy-image.jpg';
	
	var CreatorNewCard = function (_Component) {
	  _inherits(CreatorNewCard, _Component);
	
	  function CreatorNewCard(props) {
	    _classCallCheck(this, CreatorNewCard);
	
	    var _this = _possibleConstructorReturn(this, (CreatorNewCard.__proto__ || Object.getPrototypeOf(CreatorNewCard)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CreatorNewCard, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isError = _props.isError,
	          isLoading = _props.isLoading,
	          instagramLoading = _props.instagramLoading,
	          instagramLoaded = _props.instagramLoaded,
	          name = _props.name,
	          nameError = _props.nameError,
	          primarySocialHandle = _props.primarySocialHandle,
	          thumbnail = _props.thumbnail,
	          country = _props.country,
	          countryError = _props.countryError,
	          displayName = _props.displayName,
	          email = _props.email,
	          emailError = _props.emailError,
	          isFormSubmitted = _props.isFormSubmitted;
	
	
	      var displayThumbnail = thumbnail || DUMMY_THUMBNAIL;
	      var instagramError = '';
	      var instagramCount = 1000;
	
	      var isInstagramLoaded = primarySocialHandle !== null;
	      var isSignUpSetup = currentTheme.organisationId;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { container: true, style: gridStyle },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(_semanticUiReact.Grid.Column, { computer: 5, only: 'computer' }),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { computer: 6, mobile: 16 },
	            _react2.default.createElement(
	              _semanticUiReact.Card,
	              { fluid: true, style: cardStyle },
	              isLoading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading...' }),
	              isError && _react2.default.createElement(
	                _semanticUiReact.Header,
	                { as: 'h4', icon: true, style: errorStyle },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'frown' }),
	                'Something went wrong. Please try again later.'
	              ),
	              !isSignUpSetup && _react2.default.createElement(
	                _semanticUiReact.Header,
	                { as: 'h4', icon: true, style: errorStyle },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'frown' }),
	                'Sign Up is not Set up correct on this account.'
	              ),
	              !isLoading && !isError && isSignUpSetup && _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { style: { height: 200 } },
	                  instagramLoading && _react2.default.createElement(
	                    'div',
	                    { style: { paddingTop: 20 } },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle notched', loading: true, size: 'massive', color: 'blue' }),
	                    _react2.default.createElement(
	                      'p',
	                      { style: { color: 'grey', padding: 5, fontSize: '80%' } },
	                      'please wait while we find you...'
	                    )
	                  ),
	                  !instagramLoading && _react2.default.createElement(_semanticUiReact.Image, {
	                    style: imageStyle,
	                    className: 'circular',
	                    size: 'small',
	                    src: displayThumbnail
	                  })
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { style: nameStyle },
	                  displayName
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { style: descriptionStyle },
	                  primarySocialHandle || '-'
	                ),
	                _react2.default.createElement(_semanticUiReact.Divider, null),
	                _react2.default.createElement(
	                  'p',
	                  { style: { paddingBottom: 10 } },
	                  'Add your instagram handle/url below'
	                ),
	                _react2.default.createElement(_networkHandleInput2.default, {
	                  network: 'instagram',
	                  error: instagramError,
	                  value: primarySocialHandle,
	                  loading: instagramLoading,
	                  onChange: this.props.handleSocialChange,
	                  count: instagramCount,
	                  fluid: true
	                })
	              ),
	              instagramLoaded && _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                { style: { textAlign: 'left' } },
	                _react2.default.createElement(
	                  'p',
	                  { style: { textAlign: 'center', paddingBottom: 10 } },
	                  'Great! Please fill in some basic details...'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form,
	                  { error: true, onSubmit: this.props.onSubmit },
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    fluid: true,
	                    label: 'Name',
	                    placeholder: 'Your real name',
	                    name: 'name',
	                    onChange: this.props.handleInputChange,
	                    value: name,
	                    required: true,
	                    error: nameError
	                  }),
	                  _react2.default.createElement(_semanticUiReact.Form.Dropdown, {
	                    search: true,
	                    selection: true,
	                    label: 'Country',
	                    value: country,
	                    name: 'country',
	                    options: _countries2.default,
	                    error: countryError,
	                    onChange: this.props.handleInputChange,
	                    required: true
	                  }),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    label: 'Email Address',
	                    value: email,
	                    name: 'email',
	                    onChange: this.props.handleEmailChanged,
	                    error: emailError,
	                    placeholder: 'Preferred contact email address',
	                    required: true
	                  }),
	                  _react2.default.createElement(_semanticUiReact.Divider, null),
	                  _react2.default.createElement(
	                    _semanticUiReact.Form.Button,
	                    { disabled: isFormSubmitted, loading: isFormSubmitted, fluid: true, color: 'flyt' },
	                    'Create Account'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_semanticUiReact.Grid.Column, { computer: 5, only: 'computer' })
	        )
	      );
	    }
	  }]);
	
	  return CreatorNewCard;
	}(_react.Component);
	
	CreatorNewCard.propTypes = {
	  isLoading: _propTypes2.default.bool.isRequired,
	  isError: _propTypes2.default.bool.isRequired
	};
	
	exports.default = CreatorNewCard;

/***/ },
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _axiosRetry = __webpack_require__(168);
	
	var _axiosRetry2 = _interopRequireDefault(_axiosRetry);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _recompose = __webpack_require__(15);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _instagramProfileData = __webpack_require__(377);
	
	var _instagramProfileData2 = _interopRequireDefault(_instagramProfileData);
	
	var _brandMentionsPostList = __webpack_require__(964);
	
	var _brandMentionsPostList2 = _interopRequireDefault(_brandMentionsPostList);
	
	var _twitchData = __webpack_require__(600);
	
	var _twitchData2 = _interopRequireDefault(_twitchData);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _dyzioDemographics = __webpack_require__(912);
	
	var _dyzioDemographics2 = _interopRequireDefault(_dyzioDemographics);
	
	var _dyzioInstagramEmbed = __webpack_require__(543);
	
	var _dyzioInstagramEmbed2 = _interopRequireDefault(_dyzioInstagramEmbed);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasAws4Signature = __webpack_require__(924);
	
	var _hasAws4Signature2 = _interopRequireDefault(_hasAws4Signature);
	
	var _youtubeProfileDataLarge = __webpack_require__(901);
	
	var _youtubeProfileDataLarge2 = _interopRequireDefault(_youtubeProfileDataLarge);
	
	var _facebookProfileDataLarge = __webpack_require__(874);
	
	var _facebookProfileDataLarge2 = _interopRequireDefault(_facebookProfileDataLarge);
	
	var _twitterProfileDataLarge = __webpack_require__(898);
	
	var _twitterProfileDataLarge2 = _interopRequireDefault(_twitterProfileDataLarge);
	
	var _tiktokProfileDataLarge = __webpack_require__(896);
	
	var _tiktokProfileDataLarge2 = _interopRequireDefault(_tiktokProfileDataLarge);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react-perf/jsx-no-new-object-as-prop */
	
	
	var INSTAGRAM_POST_URL = 'https://www.instagram.com/p';
	
	var brandMentionsLoadingStyle = {
	  minHeight: 90,
	  marginTop: 30
	};
	
	var emptyDataStyle = {
	  marginTop: 14
	};
	
	var modalPadding = {
	  padding: '24px 0'
	};
	var overflowEllipsis = {
	  whiteSpace: 'nowrap',
	  overflow: 'hidden',
	  textOverflow: 'ellipsis',
	  width: '600px'
	};
	
	var sf = function sf(num) {
	  if (num) return num > 1000 ? (0, _numeral2.default)(num).format('0.0a') : num;
	  return '-';
	};
	var brandMentionCardStyles = { display: 'flex', flexDirection: 'row', width: '90%' };
	
	var CreatorProfileStats = function (_React$Component) {
	  _inherits(CreatorProfileStats, _React$Component);
	
	  function CreatorProfileStats() {
	    _classCallCheck(this, CreatorProfileStats);
	
	    var _this = _possibleConstructorReturn(this, (CreatorProfileStats.__proto__ || Object.getPrototypeOf(CreatorProfileStats)).call(this));
	
	    _this.toggleYoutubeDemographicsModalState = function () {
	      var youtubeDemographicsModalOpen = _this.state.youtubeDemographicsModalOpen;
	
	      _this.setState({
	        youtubeDemographicsModalOpen: !youtubeDemographicsModalOpen
	      });
	    };
	
	    _this.toggleFacebookCountryDemographicsModalState = function () {
	      var facebookCountryDemographicsModalOpen = _this.state.facebookCountryDemographicsModalOpen;
	
	      _this.setState({
	        facebookCountryDemographicsModalOpen: !facebookCountryDemographicsModalOpen
	      });
	    };
	
	    _this.toggleFacebookCityDemographicsModalState = function () {
	      var facebookCityDemographicsModalOpen = _this.state.facebookCityDemographicsModalOpen;
	
	      _this.setState({
	        facebookCityDemographicsModalOpen: !facebookCityDemographicsModalOpen
	      });
	    };
	
	    _this.togglePageMetricModalState = function () {
	      var pageMetricModalOpen = _this.state.pageMetricModalOpen;
	
	      _this.setState({
	        pageMetricModalOpen: !pageMetricModalOpen
	      });
	    };
	
	    _this.loadCampaignHistory = function () {
	      var profile = _this.props.influencer;
	      var id = profile.id;
	
	      // load brand mentions in parallel
	
	      _this.loadBrandMentions();
	
	      _this.restClient.get(("https://kdpylba5ej.execute-api.eu-west-1.amazonaws.com/production") + '/influencer/campaings', {
	        params: { id: id }
	      }).then(function (response) {
	        var data = response.data;
	
	        return _this.setState({
	          history: data,
	          loadingHistory: false
	        });
	      }).catch(function () {
	        _this.setState({
	          history: null,
	          loadingHistory: false
	        });
	      });
	    };
	
	    _this.loadBrandMentions = function () {
	      var profile = _this.props.influencer;
	      var instagramId = profile.instagramId,
	          id = profile.id;
	
	
	      if (instagramId) {
	        var brandURLBase = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production';
	        var url = brandURLBase + '/instagram/posts/' + id + '?rapid=true';
	        return _axios2.default.get(url).then(function (res) {
	          var posts = _lodash2.default.get(res, 'data.data.formattedNodes');
	          var adPosts = _lodash2.default.filter(posts, function (post) {
	            return post.isAd;
	          });
	          var sortByDateAdPosts = _lodash2.default.reverse(_lodash2.default.sortBy(adPosts, 'publishedDate'));
	          console.log('adPosts', adPosts);
	          _this.setState({
	            brandMentionsData: _lodash2.default.take(adPosts, 12),
	            brandMentionsLoading: false
	          });
	        }).catch(function (e) {
	          console.log(e);
	          _this.setState({
	            brandMentionsLoading: false
	          });
	        });
	      }
	      _this.setState({
	        brandMentionsLoading: false,
	        brandMentionsData: null
	      });
	
	      return null;
	    };
	
	    _this.handleBrandMentionsRowClick = function (item) {
	      console.log(item);
	      _this.setState({
	        brandCollaborationData: item,
	        showBrandCollaborationModal: true
	      });
	    };
	
	    _this.popupToggleHandler = function () {
	      _this.setState({
	        showBrandCollaborationModal: false
	      });
	    };
	
	    _this.getBrandCollabModalSize = function (brandCollaborationData) {
	      if (!brandCollaborationData) return null;
	      var postCount = brandCollaborationData.engagementFigures.relatedPosts.length;
	      var size = void 0;
	      switch (postCount) {
	        case 1:
	          size = 'tiny';
	          break;
	        case 2:
	          size = 'small';
	          break;
	        default:
	          size = 'large';
	      }
	      return size;
	    };
	
	    _this.state = {
	      loading: true,
	      missingAPILink: false,
	      error: false,
	      statistics: {},
	      youtubeDemographicsModalOpen: false,
	      data: {
	        youtube: null,
	        instagram: null,
	        twitter: null
	      },
	      history: null,
	      loadingHistory: true,
	      brandMentionsLoading: true,
	      brandMentionsData: null,
	      brandMentionsStatus: null
	    };
	
	    _this.restClient = _axios2.default.create({
	      timeout: 5000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    _this.jsonClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	      header: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    (0, _axiosRetry2.default)(_this.restClient, {
	      delay: 100,
	      retries: 3
	    });
	    return _this;
	  }
	
	  _createClass(CreatorProfileStats, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var profile = this.props.influencer;
	      var statistics = profile.statistics;
	      var link = profile.influencerApiLink;
	
	      if (link && link.url) {
	        this.restClient.get(link.url).then(function (response) {
	          var influencer = response.data.influencer;
	
	          var youtube = influencer.aggregateYoutubeChannelStatistics;
	          var instagram = influencer.instagramStatistics;
	          var twitter = influencer.twitterStatistics;
	          var facebook = influencer.facebookStatistics;
	
	          var data = {
	            youtube: youtube,
	            instagram: instagram,
	            twitter: twitter,
	            facebook: facebook,
	            apiInfluencer: influencer
	          };
	
	          return _this2.setState({
	            statistics: statistics,
	            data: data,
	            loading: false
	          }, _this2.loadCampaignHistory);
	        }).catch(function () {
	          _this2.setState({
	            error: true,
	            loading: false
	          }, _this2.loadCampaignHistory);
	        });
	      } else {
	        this.setState({
	          missingAPILink: true,
	          loading: false
	        }, this.loadCampaignHistory);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          data = _state.data,
	          loading = _state.loading,
	          error = _state.error,
	          statistics = _state.statistics,
	          missingAPILink = _state.missingAPILink,
	          youtubeDemographicsModalOpen = _state.youtubeDemographicsModalOpen,
	          facebookCountryDemographicsModalOpen = _state.facebookCountryDemographicsModalOpen,
	          facebookCityDemographicsModalOpen = _state.facebookCityDemographicsModalOpen,
	          pageMetricModalOpen = _state.pageMetricModalOpen,
	          brandMentionsData = _state.brandMentionsData,
	          brandMentionsStatus = _state.brandMentionsStatus,
	          brandMentionsLoading = _state.brandMentionsLoading,
	          showBrandCollaborationModal = _state.showBrandCollaborationModal,
	          brandCollaborationData = _state.brandCollaborationData;
	
	
	      var brandCollabModalSize = this.getBrandCollabModalSize(brandCollaborationData);
	
	      var _props = this.props,
	          influencer = _props.influencer,
	          asModal = _props.asModal;
	      var organisation = influencer.organisation;
	
	      var organisationId = organisation;
	
	      var isYouTubeCompliance = organisationId === 'ea9ed959-9566-4851-b69c-55b699832cff';
	      var displayAuthorisedData = _lodash2.default.get(organisation, 'displayAuthorisedData', false);
	
	      var canViewData = true;
	      var canViewInstagram = _lodash2.default.has(influencer, 'instagram');
	      var canViewFacebook = _lodash2.default.has(influencer, 'facebook');
	      var canViewTwitter = _lodash2.default.has(influencer, 'twitter');
	      var canViewYoutube = _lodash2.default.has(influencer, 'youtube');
	      var canViewTwitch = _lodash2.default.has(influencer, 'twitch');
	      var canViewTiktok = _lodash2.default.has(influencer, 'tiktok');
	
	      var facebook = influencer.facebook,
	          facebookData = influencer.facebookData,
	          facebookVerified = influencer.facebookVerified,
	          countHistory = influencer.countHistory;
	
	
	      var hasDemographicsData = _lodash2.default.has(influencer, 'instagramData.audienceDemographics.data');
	
	      var IG_CONTENT_TYPES = ['REELS', 'CAROUSEL', 'IMAGE', 'VIDEO', 'IGTV'];
	
	      var mappedLocations = null;
	
	      if (influencer.instagramLocations) {
	        var groupedLocations = _lodash2.default.groupBy(influencer.instagramLocations, 'name');
	        mappedLocations = _lodash2.default.map(groupedLocations, function (v, k) {
	          return { name: k, id: _lodash2.default.head(v).id, count: v.length };
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        { style: asModal ? modalPadding : {}, className: asModal ? '' : 'page-content' },
	        !canViewData && _react2.default.createElement(_semanticUiReact.Message, {
	          info: true,
	          content: 'No permissions. Please use "Send ADR request" button to get permissions for viewing data.'
	        }),
	        canViewInstagram && _react2.default.createElement(_instagramProfileData2.default, {
	          displayAuthorisedData: displayAuthorisedData,
	          loading: loading,
	          influencer: influencer,
	          stats: statistics,
	          data: data.instagram,
	          error: error,
	          organisationId: organisationId
	        }),
	        canViewInstagram && (!hasDemographicsData || !displayAuthorisedData) && _react2.default.createElement(_dyzioDemographics2.default, { influencer: influencer, organisationId: organisationId }),
	        canViewInstagram && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              { columns: 2 },
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 4 },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Brand Collaborations'
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'dyzio tracks any #Ads, Paid Partnerships or sponsored content your influencer posts on their Instagram feed.'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 12 },
	                  brandMentionsLoading && _react2.default.createElement(_semanticUiReact.Loader, {
	                    active: true,
	                    inline: 'centered',
	                    content: 'Loading brand mentions data',
	                    style: brandMentionsLoadingStyle
	                  }),
	                  !brandMentionsLoading && _lodash2.default.isEmpty(brandMentionsData) && _react2.default.createElement(
	                    _semanticUiReact.Message,
	                    { icon: true, info: true, style: emptyDataStyle },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline' }),
	                    _react2.default.createElement(
	                      _semanticUiReact.Message.Content,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Message.Header,
	                        null,
	                        'No brand mentions yet'
	                      ),
	                      'No brand mentions were found in their last 50 instagram posts'
	                    )
	                  ),
	                  brandMentionsData && brandMentionsData.length > 0 && _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', flexDirection: 'column', flexWrap: 'wrap' } },
	                    _lodash2.default.map(brandMentionsData, function (brandMention) {
	                      return _react2.default.createElement(
	                        _semanticUiReact.Card,
	                        { style: brandMentionCardStyles },
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            style: { margin: 5 },
	                            title: 'open on Instagram',
	                            target: '_blank',
	                            rel: 'noopener noreferrer',
	                            href: INSTAGRAM_POST_URL + '/' + brandMention.shortcode
	                          },
	                          _react2.default.createElement(_dyzioInstagramEmbed2.default, {
	                            assetId: brandMention.shortcode,
	                            brandMention: true
	                          })
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table,
	                          { singleLine: true, style: { margin: 0 } },
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            null,
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'like outline' }),
	                              ' ',
	                              brandMention.likeCount < 0 ? 'hidden' : sf(brandMention.likeCount)
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'comments outline' }),
	                              ' ',
	                              sf(brandMention.commentCount)
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye' }),
	                              ' ',
	                              sf(brandMention.viewCount)
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            null,
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              { colSpan: '3' },
	                              _react2.default.createElement(
	                                'div',
	                                { style: overflowEllipsis },
	                                brandMention.text || '-'
	                              )
	                            )
	                          ),
	                          brandMention.sponsor && _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            null,
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              { colSpan: '3' },
	                              _react2.default.createElement(_semanticUiReact.Popup, {
	                                content: brandMention.sponsor,
	                                trigger: _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'money', color: 'pink' }),
	                                  _react2.default.createElement(
	                                    _semanticUiReact.Label,
	                                    null,
	                                    brandMention.sponsor.username
	                                  )
	                                )
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            null,
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              { colSpan: '3' },
	                              _react2.default.createElement(_semanticUiReact.Popup, {
	                                content: _lodash2.default.join(brandMention.hashtags, ', '),
	                                trigger: _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  _lodash2.default.map(_lodash2.default.take(_lodash2.default.uniq(brandMention.mentions, 5)), function (m) {
	                                    return _react2.default.createElement(
	                                      _semanticUiReact.Label,
	                                      null,
	                                      _lodash2.default.toLower(m)
	                                    );
	                                  }),
	                                  _lodash2.default.map(_lodash2.default.take(_lodash2.default.uniq(brandMention.hashtags, 5)), function (h) {
	                                    return _react2.default.createElement(
	                                      _semanticUiReact.Label,
	                                      null,
	                                      _lodash2.default.toLower(h)
	                                    );
	                                  })
	                                )
	                              })
	                            )
	                          )
	                        )
	                      );
	                    })
	                  ),
	                  !brandMentionsLoading && !brandMentionsData && _react2.default.createElement(
	                    _semanticUiReact.Message,
	                    { icon: true, info: true, style: emptyDataStyle },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline' }),
	                    _react2.default.createElement(
	                      _semanticUiReact.Message.Content,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Message.Header,
	                        null,
	                        'No brand mentions yet'
	                      ),
	                      'No brand mentions were found in their last 50 instagram posts'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              { columns: 3 },
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 5 },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Influencer Locations'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    { celled: true },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Header,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'Location'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'Count'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Body,
	                      null,
	                      mappedLocations ? _lodash2.default.map(_lodash2.default.orderBy(mappedLocations, ['count'], ['desc']), function (h) {
	                        return _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { target: '_blank', href: 'https://www.instagram.com/explore/locations/' + h.id + '/' },
	                              h.name
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            h.count
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'no locations tagged...'
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 6 },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Content Analysis (Last 12 posts)'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    { celled: true },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Header,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'content type'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'count'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'Eng. Rate'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Body,
	                      null,
	                      influencer.instagramBenchmarks ? _lodash2.default.map(IG_CONTENT_TYPES, function (ct) {
	                        return _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            ct
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            _lodash2.default.get(influencer.instagramBenchmarks[ct], 'count', 0)
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            _lodash2.default.get(influencer.instagramBenchmarks[ct], 'engagementRate', '-'),
	                            '%'
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'not scanned yet...'
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 5 },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Hashtags (Top 10)'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    { celled: true },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Header,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'Hashtag'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'Count'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Body,
	                      null,
	                      influencer.instagramHashtags ? _lodash2.default.map(_lodash2.default.take(influencer.instagramHashtags, 10), function (h) {
	                        return _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            h.hashtag
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            h.count
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'not scanned yet...'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        canViewYoutube && _react2.default.createElement(_youtubeProfileDataLarge2.default, {
	          displayAuthorisedData: displayAuthorisedData,
	          loading: loading,
	          influencer: influencer,
	          apiInfluencer: data.apiInfluencer,
	          data: data.youtube,
	          error: error,
	          missingAPILink: missingAPILink,
	          isYouTubeCompliance: isYouTubeCompliance,
	          youtubeDemographicsModalOpen: youtubeDemographicsModalOpen,
	          toggleYoutubeDemographicsModalState: this.toggleYoutubeDemographicsModalState
	        }),
	        canViewFacebook && _react2.default.createElement(_facebookProfileDataLarge2.default, Object.assign({
	          displayAuthorisedData: displayAuthorisedData
	        }, facebookData, {
	          handle: facebook,
	          facebookVerified: facebookVerified,
	          countHistory: countHistory,
	          facebookCountryDemographicsModalOpen: facebookCountryDemographicsModalOpen,
	          toggleFacebookCountryDemographicsModalState: this.toggleFacebookCountryDemographicsModalState,
	          facebookCityDemographicsModalOpen: facebookCityDemographicsModalOpen,
	          toggleFacebookCityDemographicsModalState: this.toggleFacebookCityDemographicsModalState,
	          onFullPageMetrics: this.togglePageMetricModalState,
	          pageMetricModalOpen: pageMetricModalOpen
	        })),
	        canViewTwitter && _react2.default.createElement(_twitterProfileDataLarge2.default, {
	          influencer: influencer,
	          countHistory: countHistory
	        }),
	        canViewTiktok && _react2.default.createElement(_tiktokProfileDataLarge2.default, {
	          influencer: influencer,
	          countHistory: countHistory
	        }),
	        canViewTwitch && _react2.default.createElement(_twitchData2.default, { influencer: influencer }),
	        showBrandCollaborationModal && _react2.default.createElement(
	          _dyzioModal2.default,
	          {
	            onClose: this.popupToggleHandler,
	            headerText: 'Brand Collaboration',
	            size: brandCollabModalSize
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Content,
	            null,
	            _react2.default.createElement(_brandMentionsPostList2.default, {
	              brandName: brandCollaborationData.brand,
	              brandId: brandCollaborationData.id,
	              brandHandle: brandCollaborationData.handle,
	              brandProfilePic: brandCollaborationData.profilePicUrl,
	              shortcodes: brandCollaborationData.engagementFigures.relatedPosts
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreatorProfileStats;
	}(_react2.default.Component);
	
	CreatorProfileStats.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  asModal: _propTypes2.default.bool
	};
	CreatorProfileStats.defaultProps = {
	  asModal: false
	};
	
	exports.default = (0, _recompose.compose)(_hasAws4Signature2.default, _hasUserInfo2.default)(CreatorProfileStats);

/***/ },
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _papaparse = __webpack_require__(425);
	
	var _papaparse2 = _interopRequireDefault(_papaparse);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _instagramUtils = __webpack_require__(1925);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_INFLUENCERS_PER_CAMPAIGN = 150;
	
	var CsvInfluencerUploadModal = function (_Component) {
	  _inherits(CsvInfluencerUploadModal, _Component);
	
	  function CsvInfluencerUploadModal(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CsvInfluencerUploadModal);
	
	    var _this = _possibleConstructorReturn(this, (CsvInfluencerUploadModal.__proto__ || Object.getPrototypeOf(CsvInfluencerUploadModal)).call(this, props));
	
	    _this.handleFileChange = function (event) {
	      var file = _lodash2.default.get(event, 'target.files[0]');
	      if (!file) return;
	
	      // Clear any previous errors
	      _this.setState({ error: null });
	
	      if (!_lodash2.default.endsWith(_lodash2.default.toLower(file.name), '.csv')) {
	        _this.setState({
	          error: 'Please select a CSV file',
	          step: 'upload'
	        });
	        // Clear the file input
	        event.target.value = '';
	        return;
	      }
	
	      _this.setState({
	        csvFile: file,
	        step: 'processing',
	        error: null
	      });
	
	      _papaparse2.default.parse(file, {
	        header: true,
	        dynamicTyping: true,
	        skipEmptyLines: true,
	        delimiter: '', // Let Papa Parse auto-detect, but don't error on warnings
	        complete: function complete(results) {
	          // Only error on actual parsing errors, not delimiter detection warnings
	          var realErrors = results.errors.filter(function (error) {
	            return error.type !== 'Delimiter' && error.type !== 'FieldMismatch';
	          });
	          if (realErrors.length > 0) {
	            _this.setState({
	              step: 'upload',
	              error: 'CSV parsing error: ' + _lodash2.default.get(realErrors, '[0].message', 'Unknown error')
	            });
	            return;
	          }
	
	          if (!results.data || _lodash2.default.size(results.data) === 0) {
	            _this.setState({
	              step: 'upload',
	              error: 'CSV file appears to be empty'
	            });
	            return;
	          }
	
	          var _this$props = _this.props,
	              currentInfluencerCount = _this$props.currentInfluencerCount,
	              existingCampaignHandles = _this$props.existingCampaignHandles;
	
	          var processedData = (0, _instagramUtils.processInfluencerCSV)(results.data, currentInfluencerCount, MAX_INFLUENCERS_PER_CAMPAIGN, existingCampaignHandles || []);
	
	          _this.setState({
	            rawData: results.data,
	            processedData: processedData,
	            step: 'preview',
	            error: null
	          });
	        },
	        error: function error(_error) {
	          _this.setState({
	            step: 'upload',
	            error: 'Error reading file: ' + _lodash2.default.get(_error, 'message', 'Unknown error')
	          });
	        }
	      });
	    };
	
	    _this.generateStandardizedCSV = function (validInfluencers) {
	      var campaignId = _this.props.campaignId;
	      // Remove duplicates first, then take only first MAX_INFLUENCERS_PER_CAMPAIGN
	
	      var uniqueInfluencers = _lodash2.default.uniqBy(validInfluencers, 'instagramHandle');
	      var limitedInfluencers = _lodash2.default.take(uniqueInfluencers, MAX_INFLUENCERS_PER_CAMPAIGN);
	
	      // Create standardized CSV data with canonical Instagram URLs
	      var csvData = _lodash2.default.map(limitedInfluencers, function (influencer) {
	        return {
	          instagramUrl: 'https://instagram.com/' + influencer.instagramHandle
	        };
	      });
	
	      // Convert to CSV string
	      var csv = _papaparse2.default.unparse(csvData, {
	        header: true,
	        columns: ['instagramUrl']
	      });
	
	      // Create blob for upload with timestamp in filename
	      var timestamp = Date.now();
	      var fileName = campaignId + '-influencers-' + timestamp + '.csv';
	      var blob = new Blob([csv], { type: 'text/csv' });
	      var file = new File([blob], fileName, { type: 'text/csv' });
	
	      return { csvString: csv, file: file, data: csvData, fileName: fileName };
	    };
	
	    _this.uploadToS3 = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(file, fileName) {
	        var s3Url;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                s3Url = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/' + fileName;
	                _context.next = 4;
	                return _axios2.default.put(s3Url, file, {
	                  headers: {
	                    'Content-Type': 'text/csv'
	                  },
	                  onUploadProgress: function onUploadProgress(progressEvent) {
	                    var progress = Math.round(progressEvent.loaded * 100 / progressEvent.total);
	                    _this.setState({ uploadProgress: progress });
	                  }
	                });
	
	              case 4:
	                return _context.abrupt('return', {
	                  url: s3Url,
	                  fileName: fileName
	                });
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context['catch'](0);
	                throw new Error('S3 upload failed: ' + _context.t0.message);
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[0, 7]]);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.processInfluencersOnServer = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(s3Url) {
	        var _this$props2, campaignId, userEmail, userInfo, response;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$props2 = _this.props, campaignId = _this$props2.campaignId, userEmail = _this$props2.userEmail, userInfo = _this$props2.userInfo;
	                _context2.prev = 1;
	                _context2.next = 4;
	                return _axios2.default.post('https://papi.dyzio.co/papi/secure/campaign/' + campaignId + '/csv', {
	                  data: {
	                    filename: s3Url,
	                    userEmail: userEmail,
	                    userInfo: userInfo
	                  }
	                }, {
	                  headers: {
	                    'Content-Type': 'application/json'
	                  }
	                });
	
	              case 4:
	                response = _context2.sent;
	                return _context2.abrupt('return', response.data);
	
	              case 8:
	                _context2.prev = 8;
	                _context2.t0 = _context2['catch'](1);
	                throw new Error('Server processing failed: ' + _context2.t0.message);
	
	              case 11:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[1, 8]]);
	      }));
	
	      return function (_x3) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.handleUploadToS3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var processedData, _this$props3, campaignCsvUploads, restClient, campaignId, toUpload, standardizedCsv, uploadResult, campaign, currentCsvFiles;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              processedData = _this.state.processedData;
	              _this$props3 = _this.props, campaignCsvUploads = _this$props3.campaignCsvUploads, restClient = _this$props3.restClient, campaignId = _this$props3.campaignId;
	
	              if (!(!processedData || processedData.summary.newToUpload === 0)) {
	                _context3.next = 4;
	                break;
	              }
	
	              return _context3.abrupt('return');
	
	            case 4:
	              toUpload = _lodash2.default.take(processedData.uniqueNewInfluencers, processedData.summary.availableSlots);
	              standardizedCsv = _this.generateStandardizedCSV(toUpload);
	
	
	              _this.setState({
	                step: 'uploading',
	                standardizedCsv: standardizedCsv,
	                uploadProgress: 0
	              });
	
	              _context3.prev = 7;
	              _context3.next = 10;
	              return _this.uploadToS3(standardizedCsv.file, standardizedCsv.fileName);
	
	            case 10:
	              uploadResult = _context3.sent;
	
	
	              _this.setState({
	                uploadedFileUrl: uploadResult.url,
	                step: 'processing-server'
	              });
	
	              // Step 2: Patch campaign's "csvFileUploads"  field
	              _context3.next = 14;
	              return restClient.get('/campaigns/' + campaignId + '?fields[campaigns]=csvFileUploads');
	
	            case 14:
	              campaign = _context3.sent;
	              currentCsvFiles = _lodash2.default.get(campaign, 'data.data.attributes.csvFileUploads', []);
	              _context3.next = 18;
	              return restClient.patch('campaigns/' + campaignId, {
	                data: {
	                  attributes: {
	                    csvFileUploads: [].concat(_toConsumableArray(currentCsvFiles), [uploadResult.fileName])
	                  }
	                }
	              });
	
	            case 18:
	
	              // Step 3: Fire and forget - start server processing but don't wait
	              _this.processInfluencersOnServer(uploadResult.url).catch(function (error) {
	                console.error('Server processing error (expected timeout):', error);
	              });
	
	              // Immediately show completion
	              _this.setState({
	                step: 'complete'
	              });
	              _context3.next = 25;
	              break;
	
	            case 22:
	              _context3.prev = 22;
	              _context3.t0 = _context3['catch'](7);
	
	              _this.setState({
	                step: 'preview',
	                error: 'Upload failed: ' + _context3.t0.message
	              });
	
	            case 25:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2, [[7, 22]]);
	    }));
	
	    _this.resetUpload = function () {
	      _this.setState({
	        step: 'upload',
	        csvFile: null,
	        rawData: null,
	        processedData: null,
	        standardizedCsv: null,
	        uploadProgress: 0,
	        uploadedFileUrl: null,
	        error: null
	      });
	    };
	
	    _this.renderUploadStep = function () {
	      var currentInfluencerCount = _this.props.currentInfluencerCount;
	
	      var availableSlots = Math.max(0, MAX_INFLUENCERS_PER_CAMPAIGN - currentInfluencerCount);
	      var isAtCapacity = availableSlots === 0;
	
	      var textStyle = { margin: '0 0 8px 0' };
	      var buttonStyle = { marginTop: '10px' };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Header,
	          { as: 'h3' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'upload' }),
	          'Upload Influencer CSV'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Upload a CSV file containing influencer data. The system will automatically detect and validate Instagram handles from various formats.'
	        ),
	        isAtCapacity && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { negative: true },
	          _react2.default.createElement(
	            _semanticUiReact.Message.Header,
	            null,
	            'Campaign at Maximum Capacity'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'This campaign already has ',
	            currentInfluencerCount,
	            ' influencers, which is the maximum allowed (',
	            MAX_INFLUENCERS_PER_CAMPAIGN,
	            '). You cannot add more influencers to this campaign.'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { placeholder: true, textAlign: 'center' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { icon: true },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'users' }),
	              'Add Influencers'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: textStyle },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Current:'
	              ),
	              ' ',
	              currentInfluencerCount,
	              ' • ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Maximum:'
	              ),
	              ' ',
	              MAX_INFLUENCERS_PER_CAMPAIGN,
	              ' • ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Available:'
	              ),
	              ' ',
	              availableSlots
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                primary: true,
	                as: 'label',
	                htmlFor: 'csv-file-input',
	                disabled: isAtCapacity,
	                size: 'large',
	                style: buttonStyle
	              },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'upload' }),
	              'Select CSV File'
	            ),
	            _react2.default.createElement('input', {
	              id: 'csv-file-input',
	              key: _this.state.step,
	              type: 'file',
	              accept: '.csv',
	              onChange: _this.handleFileChange,
	              style: { display: 'none' },
	              disabled: isAtCapacity
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Message,
	          { info: true },
	          _react2.default.createElement(
	            _semanticUiReact.Message.Header,
	            null,
	            'CSV Format Requirements'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.List,
	            { bulleted: true },
	            _react2.default.createElement(
	              _semanticUiReact.List.Item,
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Limit:'
	              ),
	              ' Maximum of ',
	              MAX_INFLUENCERS_PER_CAMPAIGN,
	              ' Instagram influencers per campaign.'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.List.Item,
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Single column:'
	              ),
	              ' One column with Instagram handles or URLs'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.List.Item,
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Header:'
	              ),
	              ' Any header name (will be ignored)'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.List.Item,
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Data:'
	              ),
	              ' One Instagram handle per row starting from row 2'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Message,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Message.Header,
	            null,
	            'Supported Instagram Formats'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.List,
	            { bulleted: true },
	            _react2.default.createElement(
	              _semanticUiReact.List.Item,
	              null,
	              'Simple handles: ',
	              _react2.default.createElement(
	                'code',
	                null,
	                'kimkardashian'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.List.Item,
	              null,
	              'With @ symbol: ',
	              _react2.default.createElement(
	                'code',
	                null,
	                '@kimkardashian'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.List.Item,
	              null,
	              'Full URLs: ',
	              _react2.default.createElement(
	                'code',
	                null,
	                'https://instagram.com/kimkardashian'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.List.Item,
	              null,
	              'Short URLs: ',
	              _react2.default.createElement(
	                'code',
	                null,
	                'instagram.com/kimkardashian'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderProcessingStep = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Header,
	          { as: 'h3' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'cog', loading: true }),
	          'Processing CSV Data'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Progress,
	          { percent: 50, indicating: true },
	          'Extracting and validating Instagram handles...'
	        )
	      );
	    };
	
	    _this.renderPreviewStep = function () {
	      var processedData = _this.state.processedData;
	
	
	      if (!processedData) return null;
	
	      var results = processedData.results,
	          summary = processedData.summary;
	
	      var validResults = _lodash2.default.filter(results, 'isValid');
	      var invalidResults = _lodash2.default.reject(results, 'isValid');
	      var sampleValid = _lodash2.default.take(validResults, 5);
	      var sampleInvalid = _lodash2.default.take(invalidResults, 3);
	
	      // If over limit, show only the error message
	      if (summary.overLimit) {
	        var headerStyle = { fontSize: '18px', marginBottom: '15px' };
	        var textStyle = { fontSize: '15px', lineHeight: '1.6' };
	        var actionStyle = { fontSize: '15px', marginTop: '15px' };
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Message,
	            { negative: true, size: 'large' },
	            _react2.default.createElement(
	              _semanticUiReact.Message.Header,
	              { style: headerStyle },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'exclamation triangle' }),
	              'Campaign Limit Exceeded'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: textStyle },
	              'This campaign currently has ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                summary.currentInfluencerCount
	              ),
	              ' influencers. Your CSV contains ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                summary.validAfterDedup
	              ),
	              ' new influencers. Adding them would bring the total to ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                summary.totalAfterUpload
	              ),
	              ', which exceeds the maximum of ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                summary.maxInfluencers
	              ),
	              '.'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(
	              'p',
	              { style: actionStyle },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'lightbulb' }),
	              _react2.default.createElement(
	                'strong',
	                null,
	                'You can add up to ',
	                summary.availableSlots,
	                ' more influencer(s).'
	              ),
	              ' ',
	              'Please reduce your CSV and try again.'
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Header,
	          { as: 'h3' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'chart bar' }),
	          'Validation Results'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { columns: summary.alreadyInCampaign > 0 ? 5 : 4, divided: true },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Statistic,
	              { color: 'green', size: 'small' },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Value,
	                null,
	                summary.valid
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Label,
	                null,
	                'Valid'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Statistic,
	              { color: 'red', size: 'small' },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Value,
	                null,
	                summary.invalid
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Label,
	                null,
	                'Invalid'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Statistic,
	              { color: 'orange', size: 'small' },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Value,
	                null,
	                summary.withWarnings
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Label,
	                null,
	                'Warnings'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Statistic,
	              { color: 'purple', size: 'small' },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Value,
	                null,
	                summary.duplicates
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Label,
	                null,
	                'Duplicates'
	              )
	            )
	          ),
	          summary.alreadyInCampaign > 0 && _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Statistic,
	              { size: 'small' },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Value,
	                null,
	                summary.alreadyInCampaign
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Label,
	                null,
	                'Already in campaign'
	              )
	            )
	          )
	        ),
	        summary.alreadyInCampaign > 0 && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { info: true },
	          _react2.default.createElement(
	            'p',
	            null,
	            summary.alreadyInCampaign,
	            ' handle(s) in this CSV are already on the campaign and will be skipped. Only ',
	            summary.newToUpload,
	            ' new handle(s) will be uploaded.'
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        summary.valid > 0 && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Header,
	            { as: 'h4', color: 'green' },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle' }),
	            'Valid Influencers (showing first 5)'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table,
	            { celled: true, compact: true },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Header,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  null,
	                  'Row'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  null,
	                  'Original Input'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  null,
	                  'Instagram Handle'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  null,
	                  'Warnings'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Body,
	              null,
	              _lodash2.default.map(sampleValid, function (row, index) {
	                return _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  { key: index },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    row.originalRow
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      row.originalInstagramInput
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Label,
	                      { color: 'green' },
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	                      '@',
	                      row.instagramHandle
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _lodash2.default.map(row.validationWarnings || [], function (warning, i) {
	                      return _react2.default.createElement(
	                        _semanticUiReact.Label,
	                        { key: i, color: 'orange', size: 'tiny' },
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning' }),
	                        warning
	                      );
	                    })
	                  )
	                );
	              })
	            )
	          ),
	          _lodash2.default.size(validResults) > 5 && _react2.default.createElement(
	            _semanticUiReact.Message,
	            { info: true },
	            _react2.default.createElement(
	              'p',
	              null,
	              '... and ',
	              _lodash2.default.size(validResults) - 5,
	              ' more valid influencers'
	            )
	          )
	        ),
	        summary.invalid > 0 && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Header,
	            { as: 'h4', color: 'red' },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'x circle' }),
	            'Invalid Rows (showing first 3)'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table,
	            { celled: true, compact: true },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Header,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  null,
	                  'Row'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  null,
	                  'Input'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  null,
	                  'Error'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Body,
	              null,
	              _lodash2.default.map(sampleInvalid, function (row, index) {
	                return _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  { key: index },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    row.originalRow
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    row.originalInstagramInput || 'No Instagram data'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    { style: { color: 'red' } },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'x' }),
	                    row.validationError
	                  )
	                );
	              })
	            )
	          ),
	          _lodash2.default.size(invalidResults) > 3 && _react2.default.createElement(
	            _semanticUiReact.Message,
	            { warning: true },
	            _react2.default.createElement(
	              'p',
	              null,
	              '... and ',
	              _lodash2.default.size(invalidResults) - 3,
	              ' more invalid rows'
	            )
	          )
	        ),
	        summary.valid === 0 && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { negative: true },
	          _react2.default.createElement(
	            _semanticUiReact.Message.Header,
	            null,
	            'No valid influencers found'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Please check your CSV format and try again. Make sure you have a column with Instagram handles or URLs.'
	          )
	        ),
	        summary.valid > 0 && summary.newToUpload === 0 && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { info: true },
	          _react2.default.createElement(
	            _semanticUiReact.Message.Header,
	            null,
	            'All handles already on campaign'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'All handles in this CSV are already on the campaign. Nothing to upload.'
	          )
	        ),
	        summary.newToUpload > 0 && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            _semanticUiReact.Header,
	            { as: 'h4' },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'file text' }),
	            'Standardized Output Preview'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Message,
	            { info: true },
	            _react2.default.createElement(
	              'p',
	              null,
	              'The following standardized CSV will be uploaded (',
	              _lodash2.default.min([summary.newToUpload, summary.availableSlots]),
	              ' new influencer(s)):'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            null,
	            _react2.default.createElement(
	              'pre',
	              { style: { fontSize: '12px', overflow: 'auto', maxHeight: '200px' } },
	              _this.generateStandardizedCSV(_lodash2.default.take(processedData.uniqueNewInfluencers, summary.availableSlots)).csvString
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderUploadingStep = function () {
	      var _this$state = _this.state,
	          standardizedCsv = _this$state.standardizedCsv,
	          uploadProgress = _this$state.uploadProgress;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Header,
	          { as: 'h3' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'cloud upload', color: 'blue' }),
	          'Uploading Standardized CSV'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Progress,
	          { percent: uploadProgress, indicating: true, active: true },
	          'Uploading to S3... ',
	          uploadProgress,
	          '%'
	        ),
	        standardizedCsv && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { info: true },
	          _react2.default.createElement(
	            _semanticUiReact.Message.Header,
	            null,
	            'Uploading directly to S3'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Converting ',
	            _lodash2.default.size(standardizedCsv.data),
	            ' valid influencers to canonical Instagram URLs.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'File:'
	            ),
	            ' ',
	            standardizedCsv.fileName
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Size:'
	            ),
	            ' ',
	            Math.round(standardizedCsv.file.size / 1024),
	            ' KB'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'S3 Bucket:'
	            ),
	            ' discussions-uploads-production'
	          )
	        )
	      );
	    };
	
	    _this.renderProcessingServerStep = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Header,
	          { as: 'h3' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'server', color: 'blue' }),
	          'Starting Processing'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Progress,
	          { percent: 95, indicating: true, active: true },
	          'Initiating server processing...'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Message,
	          { info: true },
	          _react2.default.createElement(
	            _semanticUiReact.Message.Header,
	            null,
	            'Starting background processing'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Your CSV has been uploaded successfully. Starting the processing job now...'
	          )
	        )
	      );
	    };
	
	    _this.renderCompleteStep = function () {
	      var uploadedFileUrl = _this.state.uploadedFileUrl;
	      var userEmail = _this.props.userEmail;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Header,
	          { as: 'h3' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'green' }),
	          'Upload Complete'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Progress,
	          { percent: 100, color: 'green' },
	          'Upload successful!'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Message,
	          { success: true },
	          _react2.default.createElement(
	            _semanticUiReact.Message.Header,
	            null,
	            'Upload successful'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Your influencers are being processed now.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'There can still be errors if handles cannot be found. You will be emailed a detailed status report at ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              userEmail
	            ),
	            '.'
	          ),
	          uploadedFileUrl && _react2.default.createElement(
	            'p',
	            { style: { fontSize: '12px', color: '#666', marginTop: '10px' } },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'File uploaded:'
	            ),
	            ' ',
	            uploadedFileUrl.split('/').pop()
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      step: 'upload', // 'upload', 'processing', 'preview', 'uploading', 'processing-server', 'complete'
	      csvFile: null,
	      rawData: null,
	      processedData: null,
	      standardizedCsv: null,
	      uploadProgress: 0,
	      uploadedFileUrl: null,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(CsvInfluencerUploadModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onClose = _props.onClose,
	          isSubmitting = _props.isSubmitting;
	      var _state = this.state,
	          step = _state.step,
	          processedData = _state.processedData,
	          error = _state.error;
	
	
	      var isOverLimit = _lodash2.default.get(processedData, 'summary.overLimit', false);
	      var canImport = processedData && _lodash2.default.get(processedData, 'summary.newToUpload', 0) > 0 && !isOverLimit;
	
	      return _react2.default.createElement(
	        _dyzioModal2.default,
	        {
	          headerText: 'Import Influencers from CSV',
	          size: 'large',
	          onClose: onClose
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          error && _react2.default.createElement(
	            _semanticUiReact.Message,
	            { negative: true },
	            _react2.default.createElement(
	              _semanticUiReact.Message.Header,
	              null,
	              'Error'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              error
	            )
	          ),
	          step === 'upload' && this.renderUploadStep(),
	          step === 'processing' && this.renderProcessingStep(),
	          step === 'preview' && this.renderPreviewStep(),
	          step === 'uploading' && this.renderUploadingStep(),
	          step === 'processing-server' && this.renderProcessingServerStep(),
	          step === 'complete' && this.renderCompleteStep(),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
	            step === 'preview' && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                onClick: this.resetUpload,
	                disabled: isSubmitting
	              },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'arrow left' }),
	              'Upload Different File'
	            ),
	            step !== 'preview' && step !== 'complete' && _react2.default.createElement('div', null),
	            step === 'preview' && !isOverLimit && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                color: 'pink',
	                disabled: !canImport || isSubmitting,
	                loading: isSubmitting,
	                onClick: this.handleUploadToS3,
	                size: 'medium'
	              },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'cloud upload' }),
	              'Upload ',
	              _lodash2.default.min([_lodash2.default.get(processedData, 'summary.newToUpload', 0), _lodash2.default.get(processedData, 'summary.availableSlots', 0)]),
	              ' new influencers to S3'
	            ),
	            step === 'preview' && isOverLimit && _react2.default.createElement('div', null),
	            step === 'complete' && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                color: 'green',
	                onClick: onClose,
	                size: 'medium',
	                style: { margin: '0 auto' }
	              },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'check' }),
	              'OK'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CsvInfluencerUploadModal;
	}(_react.Component);
	
	CsvInfluencerUploadModal.propTypes = {
	  onClose: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  isSubmitting: _propTypes2.default.bool,
	  campaignId: _propTypes2.default.string,
	  userEmail: _propTypes2.default.string,
	  currentInfluencerCount: _propTypes2.default.number,
	  existingCampaignHandles: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	CsvInfluencerUploadModal.defaultProps = {
	  onClose: _lodash2.default.noop,
	  onSubmit: _lodash2.default.noop,
	  isSubmitting: false,
	  currentInfluencerCount: 0,
	  existingCampaignHandles: []
	};
	
	exports.default = (0, _hasRestClient2.default)(CsvInfluencerUploadModal);

/***/ },
/* 1925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testInstagramHandleExtraction = exports.processInfluencerCSV = exports.validateInstagramHandle = exports.extractInstagramHandle = undefined;
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Extracts Instagram handle from various input formats
	 * @param {string} input - Instagram handle, URL, or @ mention
	 * @returns {string|null} - Clean Instagram handle or null if invalid
	 */
	var extractInstagramHandle = exports.extractInstagramHandle = function extractInstagramHandle(input) {
	  if (!input || !_lodash2.default.isString(input)) {
	    return null;
	  }
	
	  var trimmed = _lodash2.default.trim(input);
	
	  // Check if it looks like a URL (contains protocol or instagram.com)
	  var looksLikeUrl = trimmed.includes('://') || trimmed.includes('instagram.com') || trimmed.includes('www.');
	
	  // If it doesn't look like a URL, treat it as a plain handle
	  if (!looksLikeUrl) {
	    // Only remove @ prefix - nothing else
	    var candidate = trimmed.startsWith('@') ? trimmed.slice(1) : trimmed;
	    var validation = validateInstagramHandle(candidate);
	    return validation.isValid ? validation.handle : null;
	  }
	
	  try {
	    // Add protocol if missing for URL parsing
	    var urlString = trimmed;
	    if (!urlString.match(/^https?:\/\//)) {
	      urlString = 'https://' + urlString;
	    }
	
	    var url = new URL(urlString);
	
	    // Check if it's an Instagram domain
	    if (!_lodash2.default.includes(url.hostname, 'instagram.com')) {
	      // If it's not Instagram, treat as plain handle - only remove @ prefix
	      var _candidate = trimmed.startsWith('@') ? trimmed.slice(1) : trimmed;
	      var _validation = validateInstagramHandle(_candidate);
	      return _validation.isValid ? _validation.handle : null;
	    }
	
	    // Extract handle from Instagram URL path
	    var pathParts = _lodash2.default.filter(_lodash2.default.split(url.pathname, '/'), function (part) {
	      return _lodash2.default.size(part) > 0;
	    });
	
	    if (_lodash2.default.size(pathParts) > 0) {
	      var _candidate2 = _lodash2.default.head(pathParts);
	      var _validation2 = validateInstagramHandle(_candidate2);
	      return _validation2.isValid ? _validation2.handle : null;
	    }
	
	    return null;
	  } catch (error) {
	    // If URL parsing fails, treat as plain handle - only remove @ prefix
	    var _candidate3 = trimmed.startsWith('@') ? trimmed.slice(1) : trimmed;
	    var _validation3 = validateInstagramHandle(_candidate3);
	    return _validation3.isValid ? _validation3.handle : null;
	  }
	};
	
	/**
	 * Validates Instagram handle against official Instagram rules
	 * @param {string} handle - Instagram handle to validate
	 * @returns {object} - Validation result with isValid, error, handle, warnings
	 */
	var validateInstagramHandle = exports.validateInstagramHandle = function validateInstagramHandle(handle) {
	  if (!handle || !_lodash2.default.isString(handle)) {
	    return {
	      isValid: false,
	      error: 'Handle is required',
	      handle: null
	    };
	  }
	
	  var cleaned = _lodash2.default.toLower(_lodash2.default.trim(handle));
	
	  var validation = {
	    isValid: true,
	    error: null,
	    handle: cleaned,
	    warnings: []
	  };
	
	  // Length check (1-30 characters)
	  if (_lodash2.default.size(cleaned) < 1) {
	    validation.isValid = false;
	    validation.error = 'Username cannot be empty';
	    return validation;
	  }
	
	  if (_lodash2.default.size(cleaned) > 30) {
	    validation.isValid = false;
	    validation.error = 'Username cannot be longer than 30 characters';
	    return validation;
	  }
	
	  // Character validation - only letters, numbers, periods, and underscores
	  var validCharRegex = /^[a-z0-9._]+$/;
	  if (!validCharRegex.test(cleaned)) {
	    validation.isValid = false;
	    validation.error = 'Username can only contain letters, numbers, periods, and underscores';
	    return validation;
	  }
	
	  // Cannot start or end with period
	  if (_lodash2.default.startsWith(cleaned, '.') || _lodash2.default.endsWith(cleaned, '.')) {
	    validation.isValid = false;
	    validation.error = 'Username cannot start or end with a period';
	    return validation;
	  }
	
	  // Warnings for potentially problematic handles
	  if (_lodash2.default.includes(cleaned, '__')) {
	    validation.warnings.push('Multiple consecutive underscores may look unprofessional');
	  }
	
	  if (_lodash2.default.size(_lodash2.default.split(cleaned, '.')) > 3) {
	    validation.warnings.push('Many periods in username may be confusing');
	  }
	
	  return validation;
	};
	
	/**
	 * Processes single-column CSV data and extracts/validates Instagram handles
	 * @param {Array} csvData - Array of CSV row objects (single column)
	 * @param {number} currentInfluencerCount - Current number of influencers in campaign
	 * @param {number} maxInfluencers - Maximum allowed influencers per campaign
	 * @param {string[]} existingCampaignHandles - Lowercase Instagram handles already on the campaign
	 * @returns {object} - Processed results with validation summary
	 */
	var processInfluencerCSV = exports.processInfluencerCSV = function processInfluencerCSV(csvData) {
	  var currentInfluencerCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var maxInfluencers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
	  var existingCampaignHandles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	  var results = _lodash2.default.map(csvData, function (row, index) {
	    var result = { originalRow: index + 1 };
	
	    // Get the first (and only) column value
	    var firstKey = _lodash2.default.head(_lodash2.default.keys(row));
	    var instagramInput = firstKey ? _lodash2.default.get(row, firstKey) : null;
	
	    if (instagramInput && _lodash2.default.trim(String(instagramInput))) {
	      var cleanInput = _lodash2.default.trim(String(instagramInput));
	      var extractedHandle = extractInstagramHandle(cleanInput);
	
	      if (extractedHandle) {
	        var validation = validateInstagramHandle(extractedHandle);
	
	        result.instagramHandle = validation.isValid ? validation.handle : null;
	        result.originalInstagramInput = cleanInput;
	        result.extractedHandle = extractedHandle;
	        result.isValid = validation.isValid;
	        result.validationError = validation.error;
	        result.validationWarnings = validation.warnings || [];
	      } else {
	        result.isValid = false;
	        result.validationError = 'Could not extract handle from: "' + cleanInput + '"';
	        result.originalInstagramInput = cleanInput;
	      }
	    } else {
	      result.isValid = false;
	      result.validationError = 'Empty or missing Instagram data';
	    }
	
	    return result;
	  });
	
	  // Check for duplicates
	  var validResults = _lodash2.default.filter(results, 'isValid');
	  var handleCounts = _lodash2.default.countBy(validResults, 'instagramHandle');
	  var duplicates = _lodash2.default.keys(_lodash2.default.pickBy(handleCounts, function (count) {
	    return count > 1;
	  }));
	
	  _lodash2.default.forEach(results, function (result) {
	    if (result.isValid && _lodash2.default.includes(duplicates, result.instagramHandle)) {
	      result.validationWarnings.push('Duplicate handle in this CSV');
	    }
	  });
	
	  // Mark handles that are already on the campaign (handles are already lowercase from validateInstagramHandle)
	  var existingSet = _lodash2.default.isEmpty(existingCampaignHandles) ? [] : existingCampaignHandles;
	  _lodash2.default.forEach(results, function (result) {
	    if (result.isValid && result.instagramHandle) {
	      result.alreadyInCampaign = existingSet.indexOf(result.instagramHandle) !== -1;
	    }
	  });
	
	  var uniqueValidInfluencers = _lodash2.default.uniqBy(_lodash2.default.filter(results, 'isValid'), 'instagramHandle');
	  var uniqueNewInfluencers = _lodash2.default.reject(uniqueValidInfluencers, function (r) {
	    return r.alreadyInCampaign;
	  });
	  var newToUploadCount = _lodash2.default.size(uniqueNewInfluencers);
	  var totalAfterUpload = currentInfluencerCount + newToUploadCount;
	  var availableSlots = Math.max(0, maxInfluencers - currentInfluencerCount);
	
	  var summary = {
	    total: _lodash2.default.size(csvData),
	    valid: _lodash2.default.size(_lodash2.default.filter(results, 'isValid')),
	    invalid: _lodash2.default.size(_lodash2.default.filter(results, function (r) {
	      return !r.isValid;
	    })),
	    withWarnings: _lodash2.default.size(_lodash2.default.filter(results, function (r) {
	      return _lodash2.default.get(r, 'validationWarnings.length', 0) > 0;
	    })),
	    duplicates: _lodash2.default.size(duplicates),
	    overLimit: false,
	    currentInfluencerCount: currentInfluencerCount,
	    maxInfluencers: maxInfluencers,
	    availableSlots: availableSlots,
	    alreadyInCampaign: _lodash2.default.size(_lodash2.default.filter(results, function (r) {
	      return r.isValid && r.alreadyInCampaign;
	    })),
	    newToUpload: newToUploadCount
	  };
	
	  if (totalAfterUpload > maxInfluencers) {
	    summary.overLimit = true;
	    summary.validAfterDedup = newToUploadCount;
	    summary.totalAfterUpload = totalAfterUpload;
	  }
	
	  return { results: results, summary: summary, duplicates: duplicates, uniqueValidInfluencers: uniqueValidInfluencers, uniqueNewInfluencers: uniqueNewInfluencers };
	};
	
	/**
	 * Test cases for Instagram handle extraction and validation
	 */
	var testInstagramHandleExtraction = exports.testInstagramHandleExtraction = function testInstagramHandleExtraction() {
	  var testCases = ['kimkardashian', '@kimkardashian', 'bob.smith', // This should now work correctly
	  '@bob.smith', 'user_name', 'https://instagram.com/kimkardashian?igsh=N3FzdmJrOHBzejhh', 'https://instagram.com/kimkardashian/', 'https://www.instagram.com/kimkardashian?igsh=N3FzdmJrOHBzejhh', 'instagram.com/kimkardashian', 'www.instagram.com/kimkardashian', 'https://instagram.com/kimkardashian/p/somepost/', 'invalid input', '', null];
	
	  console.log('Instagram Handle Extraction Tests:');
	  _lodash2.default.forEach(testCases, function (test) {
	    var extracted = extractInstagramHandle(test);
	    var validation = extracted ? validateInstagramHandle(extracted) : { isValid: false };
	    console.log('"' + test + '" -> "' + extracted + '" (valid: ' + validation.isValid + ')');
	  });
	};

/***/ },
/* 1926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _papaparse = __webpack_require__(425);
	
	var _papaparse2 = _interopRequireDefault(_papaparse);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var SUMMARY_SEGMENT_STYLE = { flexShrink: 0 };
	var CONTROLS_SEGMENT_STYLE = { flexShrink: 0 };
	var CONTROLS_WRAPPER_STYLE = {
	  display: 'flex',
	  flexWrap: 'wrap',
	  alignItems: 'center',
	  gap: '1rem',
	  justifyContent: 'space-between'
	};
	var SEARCH_INPUT_STYLE = { flex: '1 1 260px' };
	var STATUS_DROPDOWN_STYLE = { minWidth: '180px' };
	var MODAL_CONTENT_STYLE = {
	  minHeight: '600px',
	  maxHeight: '600px',
	  display: 'flex',
	  flexDirection: 'column',
	  gap: '0.75rem'
	};
	var TABLE_SEGMENT_STYLE = {
	  flex: 1,
	  display: 'flex',
	  flexDirection: 'column',
	  minHeight: 0,
	  overflow: 'hidden'
	};
	var TABLE_SCROLL_WRAPPER_STYLE = {
	  flex: 1,
	  overflowY: 'auto',
	  paddingRight: '0.25rem'
	};
	var LOADER_SEGMENT_STYLE = {
	  flex: 1,
	  display: 'flex',
	  alignItems: 'center',
	  justifyContent: 'center'
	};
	var SUMMARY_CONTAINER_STYLE = {
	  padding: '8px',
	  borderRadius: '6px',
	  backgroundColor: '#f9fafb',
	  border: '1px solid #e3e6eb'
	};
	
	function getFullS3FilePath(key) {
	  return 'https://discussions-uploads-production.s3.eu-west-1.amazonaws.com/' + key;
	}
	
	var parseMultipleS3Files = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(filesNames) {
	    var parsePromises, settled, fulfilled;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            parsePromises = filesNames.map(function (fileKey) {
	              return new Promise(function (resolve, reject) {
	                _papaparse2.default.parse(getFullS3FilePath(fileKey), {
	                  download: true,
	                  header: true,
	                  dynamicTyping: true,
	                  skipEmptyLines: true,
	                  complete: function complete(results) {
	                    return resolve(results);
	                  },
	                  error: function error(err) {
	                    return reject(err);
	                  }
	                });
	              });
	            });
	
	            // Wait for all to finish (some may fail)
	
	            _context.next = 3;
	            return Promise.allSettled(parsePromises);
	
	          case 3:
	            settled = _context.sent;
	
	
	            // Keep only the fulfilled results
	            // eslint-disable-next-line lodash/chain-style, lodash/chaining
	            fulfilled = _lodash2.default.chain(settled).filter({ status: 'fulfilled' }).map('value').value();
	            return _context.abrupt('return', fulfilled);
	
	          case 6:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function parseMultipleS3Files(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	// eslint-disable-next-line lodash/chain-style, lodash/chaining
	var buildHandlesList = function buildHandlesList(results) {
	  return _lodash2.default.chain(results).flatMap('data') // merge all `data` arrays
	  .map('instagramUrl') // extract instagramUrl from each object
	  .compact() // remove undefined/null
	  .map(function (url) {
	    return _lodash2.default.last(url.split('/').filter(Boolean));
	  }) // get last non-empty segment
	  .uniq() // remove duplicates
	  .value();
	};
	
	var CsvUploadStatusModal = function (_Component) {
	  _inherits(CsvUploadStatusModal, _Component);
	
	  function CsvUploadStatusModal(props) {
	    _classCallCheck(this, CsvUploadStatusModal);
	
	    var _this = _possibleConstructorReturn(this, (CsvUploadStatusModal.__proto__ || Object.getPrototypeOf(CsvUploadStatusModal)).call(this, props));
	
	    _this.getHandleStatus = function (handle) {
	      var igHandles = _this.props.igHandles;
	
	      var isOnCampaign = _lodash2.default.includes(igHandles, handle);
	
	      return isOnCampaign ? 'on-campaign' : 'missing';
	    };
	
	    _this.renderHandleStatus = function (handle) {
	      var status = _this.getHandleStatus(handle);
	
	      if (status === 'on-campaign') {
	        return _react2.default.createElement(
	          _semanticUiReact.Label,
	          { color: 'green', horizontal: true },
	          'On Campaign'
	        );
	      }
	
	      return _react2.default.createElement(
	        _semanticUiReact.Label,
	        { color: 'red', horizontal: true },
	        'Missing'
	      );
	    };
	
	    _this.state = {
	      rows: [],
	      isLoading: true,
	      isLoaded: false,
	      isError: false,
	      searchQuery: '',
	      statusFilter: 'all'
	    };
	    return _this;
	  }
	
	  _createClass(CsvUploadStatusModal, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _props, restClient, campaignId, campaign, csvFileUploads, results;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _props = this.props, restClient = _props.restClient, campaignId = _props.campaignId;
	
	                this.setState({ isLoading: true, isError: false });
	
	                _context2.prev = 2;
	                _context2.next = 5;
	                return restClient.get('/campaigns/' + campaignId + '?fields[campaigns]=csvFileUploads');
	
	              case 5:
	                campaign = _context2.sent;
	                csvFileUploads = _lodash2.default.get(campaign, 'data.data.attributes.csvFileUploads', []);
	
	                if (csvFileUploads.length) {
	                  _context2.next = 10;
	                  break;
	                }
	
	                this.setState({
	                  isLoaded: true,
	                  isError: false,
	                  isLoading: false,
	                  rows: []
	                });
	                return _context2.abrupt('return');
	
	              case 10:
	                _context2.next = 12;
	                return parseMultipleS3Files(csvFileUploads);
	
	              case 12:
	                results = _context2.sent;
	
	
	                this.setState({
	                  rows: buildHandlesList(results) || [],
	                  isLoading: false,
	                  isLoaded: true,
	                  isError: false
	                });
	                _context2.next = 20;
	                break;
	
	              case 16:
	                _context2.prev = 16;
	                _context2.t0 = _context2['catch'](2);
	
	                this.setState({
	                  isError: true,
	                  isLoading: false,
	                  isLoaded: false,
	                  rows: []
	                });
	                // eslint-disable-next-line no-console
	                console.error('Failed to load CSV upload status', _context2.t0);
	
	              case 20:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[2, 16]]);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          isError = _state.isError,
	          _state$rows = _state.rows,
	          rows = _state$rows === undefined ? [] : _state$rows,
	          searchQuery = _state.searchQuery,
	          statusFilter = _state.statusFilter;
	      var onClose = this.props.onClose;
	
	
	      var normalizedQuery = _lodash2.default.toLower(_lodash2.default.trim(searchQuery));
	      var filteredRows = normalizedQuery ? rows.filter(function (handle) {
	        return _lodash2.default.includes(_lodash2.default.toLower(handle), normalizedQuery);
	      }) : rows;
	      var filteredByStatus = statusFilter === 'all' ? filteredRows : filteredRows.filter(function (handle) {
	        var status = _this2.getHandleStatus(handle);
	        if (statusFilter === 'on-campaign') return status === 'on-campaign';
	        if (statusFilter === 'missing') return status === 'missing';
	        return true;
	      });
	      var hasRows = !_lodash2.default.isEmpty(filteredByStatus);
	      var showData = !isLoading && !isError && rows.length > 0;
	      var totalCount = rows.length;
	      var onCampaignCount = rows.filter(function (handle) {
	        return _this2.getHandleStatus(handle) === 'on-campaign';
	      }).length;
	      var missingCount = rows.filter(function (handle) {
	        return _this2.getHandleStatus(handle) === 'missing';
	      }).length;
	      var statusOptions = [{ key: 'all', value: 'all', text: 'All statuses' }, { key: 'on-campaign', value: 'on-campaign', text: 'On campaign' }, { key: 'missing', value: 'missing', text: 'Missing' }];
	
	      return _react2.default.createElement(
	        _dyzioModal2.default,
	        {
	          headerText: 'CSV Import Status',
	          size: 'large',
	          onClose: onClose
	        },
	        _react2.default.createElement(
	          'div',
	          { style: MODAL_CONTENT_STYLE },
	          isLoading && _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { basic: true, style: LOADER_SEGMENT_STYLE },
	            _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: 'centered', content: 'Loading CSV uploads...' })
	          ),
	          !isLoading && isError && _react2.default.createElement(
	            _semanticUiReact.Message,
	            { negative: true },
	            _react2.default.createElement(
	              _semanticUiReact.Message.Header,
	              null,
	              'Failed to load CSV uploads'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Please try again in a moment.'
	            )
	          ),
	          !isLoading && !isError && rows.length === 0 && _react2.default.createElement(
	            _semanticUiReact.Message,
	            { info: true },
	            _react2.default.createElement(
	              _semanticUiReact.Message.Header,
	              null,
	              'No CSV uploads found for this campaign'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Upload a CSV to see the latest statuses here.'
	            )
	          ),
	          showData && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { basic: true, style: SUMMARY_CONTAINER_STYLE },
	              _react2.default.createElement(
	                'div',
	                { style: SUMMARY_SEGMENT_STYLE },
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Group,
	                  { widths: 'three', size: 'tiny' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic,
	                    { horizontal: true, size: 'tiny' },
	                    _react2.default.createElement(
	                      _semanticUiReact.Statistic.Value,
	                      null,
	                      totalCount
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Statistic.Label,
	                      null,
	                      'Total'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic,
	                    { horizontal: true, size: 'tiny', color: 'green' },
	                    _react2.default.createElement(
	                      _semanticUiReact.Statistic.Value,
	                      null,
	                      onCampaignCount
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Statistic.Label,
	                      null,
	                      'On Campaign'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic,
	                    { horizontal: true, size: 'tiny', color: 'red' },
	                    _react2.default.createElement(
	                      _semanticUiReact.Statistic.Value,
	                      null,
	                      missingCount
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Statistic.Label,
	                      null,
	                      'Missing'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, null)
	          ),
	          showData && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { style: CONTROLS_SEGMENT_STYLE },
	              _react2.default.createElement(
	                'div',
	                { style: CONTROLS_WRAPPER_STYLE },
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  icon: 'search',
	                  placeholder: 'Search handles...',
	                  value: searchQuery,
	                  onChange: function onChange(event, _ref3) {
	                    var value = _ref3.value;
	                    return _this2.setState({ searchQuery: value });
	                  },
	                  style: SEARCH_INPUT_STYLE
	                }),
	                _react2.default.createElement(_semanticUiReact.Dropdown, {
	                  selection: true,
	                  options: statusOptions,
	                  value: statusFilter,
	                  onChange: function onChange(event, _ref4) {
	                    var value = _ref4.value;
	                    return _this2.setState({ statusFilter: value });
	                  },
	                  'aria-label': 'Filter handles by status',
	                  style: STATUS_DROPDOWN_STYLE
	                })
	              )
	            ),
	            hasRows && _react2.default.createElement(_semanticUiReact.Divider, null)
	          ),
	          !isLoading && !isError && rows.length > 0 && !hasRows && _react2.default.createElement(
	            _semanticUiReact.Message,
	            { warning: true },
	            _react2.default.createElement(
	              _semanticUiReact.Message.Header,
	              null,
	              'No handles match your filters'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Adjust the search text or status filter to see handles in the table.'
	            )
	          ),
	          hasRows && _react2.default.createElement(
	            'div',
	            { style: TABLE_SEGMENT_STYLE },
	            _react2.default.createElement(
	              'div',
	              { style: TABLE_SCROLL_WRAPPER_STYLE },
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { celled: true, striped: true, compact: 'very', size: 'small', stackable: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Header,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      { collapsing: true },
	                      '#'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      null,
	                      'Handle'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      { collapsing: true },
	                      'Status'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Body,
	                  null,
	                  filteredByStatus.map(function (handle, index) {
	                    var rowStatus = _this2.getHandleStatus(handle);
	                    return _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      {
	                        key: 'handle-' + handle,
	                        positive: rowStatus === 'on-campaign',
	                        negative: rowStatus === 'missing'
	                      },
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        index + 1
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        handle
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        _this2.renderHandleStatus(handle)
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CsvUploadStatusModal;
	}(_react.Component);
	
	exports.default = (0, _hasRestClient2.default)(CsvUploadStatusModal);

/***/ },
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textCentered = {
	  textAlign: 'center'
	};
	
	var DashboardCampaignsEmptyState = function DashboardCampaignsEmptyState() {
	  return _react2.default.createElement(
	    'div',
	    { style: textCentered },
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'You have nothing added as yet!'
	    ),
	    _react2.default.createElement(_semanticUiReact.Image, { centered: true, src: '/images/nothing-added-yet.svg' }),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Choose to start building a campaign, or you can start adding your influencers immediately.'
	    )
	  );
	};
	
	exports.default = DashboardCampaignsEmptyState;

/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _recompose = __webpack_require__(15);
	
	var _reactRouter = __webpack_require__(37);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ThemeSelector$theme = _themeSelector2.default.theme(),
	    isFullWhiteLabel = _ThemeSelector$theme.isFullWhiteLabel;
	
	var DYZIO_CAMPAINGS_LINK = 'http://help.dyzio.co/campaigns/a-guide-to-dyzio-campaigns';
	var KEY_FEATURES_LINK = 'http://help.dyzio.co/dyzio-key-features/dyzio-key-features';
	var INFLUENCER_DB_LINK = 'http://help.dyzio.co/my-influencers-database/your-private-influencer-database';
	
	var centeredText = {
	  textAlign: 'center'
	};
	
	var loadingContentStyle = {
	  height: 105,
	  paddingTop: 34
	};
	
	var DashboardCard = function DashboardCard(_ref) {
	  var image = _ref.image,
	      color = _ref.color,
	      value = _ref.value,
	      label = _ref.label,
	      onButtonClick = _ref.onButtonClick,
	      buttonText = _ref.buttonText,
	      buttonIcon = _ref.buttonIcon,
	      isLoading = _ref.isLoading,
	      onCardClick = _ref.onCardClick,
	      subtext = _ref.subtext;
	
	  var handleButtonClick = function handleButtonClick(event) {
	    event.stopPropagation();
	    onButtonClick();
	  };
	  var subtextStyle = {
	    fontSize: '80%',
	    opacity: '0.6'
	  };
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { color: color, onClick: onCardClick, style: centeredText, raised: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      image
	    ),
	    isLoading && _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: loadingContentStyle },
	      _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: 'centered' })
	    ),
	    !isLoading && _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Statistic,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Statistic.Value,
	          null,
	          value
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Statistic.Label,
	          null,
	          label
	        ),
	        subtext && _react2.default.createElement(
	          _semanticUiReact.Statistic.Label,
	          { style: subtextStyle },
	          subtext
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	        onClick: handleButtonClick,
	        color: color,
	        hasIcon: true,
	        disabled: isLoading,
	        icon: buttonIcon,
	        label: buttonText,
	        floated: null
	      })
	    )
	  );
	};
	
	var GettingStartingCard = function GettingStartingCard() {
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Getting started with dyzio?'
	      ),
	      _react2.default.createElement(_semanticUiReact.Divider, null),
	      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	      _react2.default.createElement(
	        _semanticUiReact.List,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.List.Item,
	          null,
	          _react2.default.createElement(
	            _targetLink2.default,
	            { renderIf: true, href: KEY_FEATURES_LINK },
	            'Dyzio Key features'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.List.Item,
	          null,
	          _react2.default.createElement(
	            _targetLink2.default,
	            { renderIf: true, href: INFLUENCER_DB_LINK },
	            'Your private influencer database'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.List.Item,
	          null,
	          _react2.default.createElement(
	            _targetLink2.default,
	            { renderIf: true, href: DYZIO_CAMPAINGS_LINK },
	            'A guide to Dyzio campaigns'
	          )
	        )
	      )
	    )
	  );
	};
	
	DashboardCard.propTypes = {
	  color: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.node.isRequired,
	  value: _propTypes2.default.number.isRequired,
	  label: _propTypes2.default.string.isRequired,
	  subtext: _propTypes2.default.string,
	  onButtonClick: _propTypes2.default.func.isRequired,
	  onCardClick: _propTypes2.default.func.isRequired,
	  buttonText: _propTypes2.default.string.isRequired,
	  buttonIcon: _propTypes2.default.node.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired
	};
	
	DashboardCard.defaultProps = {
	  subtext: null
	};
	
	var getCards = function getCards(props) {
	  var router = props.router,
	      onToggleAddCampaignModalState = props.onToggleAddCampaignModalState,
	      totals = props.totals,
	      visibleCampaigns = props.visibleCampaigns,
	      isLoadingTotals = props.isLoadingTotals,
	      organisation = props.organisation;
	
	  var _ref2 = organisation || {},
	      licenseTrackedAssetLimit = _ref2.licenseTrackedAssetLimit,
	      licenseInfluencerLimit = _ref2.licenseInfluencerLimit;
	
	  return [{
	    image: _react2.default.createElement(_semanticUiReact.Image, { src: '/icons/my-influencers.svg', size: 'tiny', className: 'cta' }),
	    color: 'pink',
	    value: _lodash2.default.get(totals, 'totalInfluencers', '-'),
	    label: 'influencers',
	    onButtonClick: function onButtonClick() {
	      return router.push('/influencer/add');
	    },
	    onCardClick: function onCardClick() {
	      return router.push('/influencers');
	    },
	    subtext: 'Limit: ' + (isFullWhiteLabel ? 'Unlimited' : licenseInfluencerLimit),
	    buttonText: 'Add an influencer',
	    buttonIcon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'add' }),
	    isLoading: isLoadingTotals || organisation === null
	  }, {
	    image: _react2.default.createElement(_semanticUiReact.Image, { src: '/icons/campaign-management.svg', size: 'tiny', className: 'cta' }),
	    color: 'green',
	    value: _lodash2.default.get(totals, 'totalCampaigns', '-'),
	    subtext: 'You can see ' + (visibleCampaigns || '-'),
	    label: 'campaigns',
	    onButtonClick: onToggleAddCampaignModalState,
	    onCardClick: function onCardClick() {
	      return router.push('/dashboard');
	    },
	    buttonText: 'Add a Campaign',
	    buttonIcon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'add' }),
	    isLoading: isLoadingTotals
	  }, {
	    image: _react2.default.createElement(_semanticUiReact.Image, { src: '/icons/live-analytics.svg', size: 'tiny', className: 'cta' }),
	    color: 'orange',
	    label: 'tracked assets',
	    value: _lodash2.default.get(totals, 'trackedAssetsCount', '-'),
	    subtext: 'Limit: ' + (isFullWhiteLabel ? 'Unlimited' : licenseTrackedAssetLimit),
	    onButtonClick: function onButtonClick() {
	      return router.push('/dashboard');
	    },
	    onCardClick: function onCardClick() {
	      return router.push('/dashboard');
	    },
	    buttonText: 'View campaigns',
	    buttonIcon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'add' }),
	    isLoading: isLoadingTotals || organisation === null
	  }, {
	    image: _react2.default.createElement(_semanticUiReact.Image, { src: '/icons/users.svg', size: 'tiny', bordered: true, shape: 'circular', className: 'cta' }),
	    color: 'blue',
	    value: _lodash2.default.get(totals, 'totalTeamMembers', '-'),
	    label: 'team members',
	    subtext: 'Limit: Unlimited',
	    onButtonClick: function onButtonClick() {
	      return router.push('/team/manage');
	    },
	    onCardClick: function onCardClick() {
	      return router.push('/team/manage');
	    },
	    buttonText: 'Add a team member',
	    buttonIcon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'add' }),
	    isLoading: isLoadingTotals
	  }];
	};
	
	var DashboardCardGroup = function DashboardCardGroup(props) {
	  var _ThemeSelector$theme2 = _themeSelector2.default.theme(),
	      disableHelpLinks = _ThemeSelector$theme2.disableHelpLinks;
	
	  var organisation = props.organisation;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Organisation Overview',
	      ' ',
	      !isFullWhiteLabel && organisation && _react2.default.createElement(
	        _semanticUiReact.Label,
	        null,
	        organisation.licenseSubscriptionType + ' PLAN'
	      )
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Group,
	      { itemsPerRow: disableHelpLinks ? 4 : 4 },
	      _lodash2.default.map(getCards(props), function (cardProps) {
	        return _react2.default.createElement(DashboardCard, cardProps);
	      })
	    )
	  );
	};
	
	DashboardCardGroup.propTypes = {
	  organisation: _propTypes2.default.object
	};
	
	DashboardCardGroup.defaultProps = {
	  organisation: null
	};
	
	exports.default = (0, _recompose.compose)(_reactRouter.withRouter)(DashboardCardGroup);

/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tableHeaderStyle = {
	  textTransform: 'uppercase',
	  fontWeight: 600
	};
	
	var statusColours = {
	  PENDING: 'orange',
	  APPROVED: 'green',
	  DECLINED: 'red'
	};
	
	var statusLabels = {
	  PENDING: 'Pending',
	  APPROVED: 'Approved',
	  DECLINED: 'Declined'
	};
	
	var DataRequestWideCard = function DataRequestWideCard(_ref) {
	  var id = _ref.id,
	      channels = _ref.channels,
	      requestStatus = _ref.requestStatus,
	      influencer = _ref.influencer,
	      agency = _ref.agency,
	      createdBy = _ref.createdBy,
	      createdAt = _ref.createdAt,
	      requestType = _ref.requestType,
	      onRequestReviewButtonClick = _ref.onRequestReviewButtonClick,
	      isInfluencerMode = _ref.isInfluencerMode;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Label,
	        { as: 'a', color: _lodash2.default.get(statusColours, requestStatus, 'grey'), ribbon: true },
	        _lodash2.default.get(statusLabels, requestStatus, 'Unknown')
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: true, columns: 8 },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Header,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            !isInfluencerMode && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: tableHeaderStyle },
	              'Influencer'
	            ),
	            isInfluencerMode && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: tableHeaderStyle },
	              'Requested by'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: tableHeaderStyle },
	              'Requested platforms'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: tableHeaderStyle },
	              'Request type'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: tableHeaderStyle },
	              'Created'
	            ),
	            isInfluencerMode && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: tableHeaderStyle },
	              'Actions'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            !isInfluencerMode && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_semanticUiReact.Image, { src: influencer.thumbnail, avatar: true }),
	              _react2.default.createElement(
	                'span',
	                null,
	                influencer.name
	              )
	            ),
	            isInfluencerMode && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                createdBy,
	                ' @ ',
	                agency.name
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.List,
	                null,
	                _lodash2.default.map(channels, function (channel) {
	                  return _react2.default.createElement(
	                    _semanticUiReact.List.Item,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: channel.channel }),
	                    channel.handle
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              requestType
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              (0, _moment2.default)(createdAt).format('MMMM Do YYYY, h:mm:ss a')
	            ),
	            isInfluencerMode && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_semanticUiReact.Button, { id: id, content: 'Review', icon: 'eye', onClick: onRequestReviewButtonClick })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	DataRequestWideCard.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  influencer: _propTypes2.default.object.isRequired,
	  agency: _propTypes2.default.object.isRequired,
	  requestStatus: _propTypes2.default.object.isRequired,
	  onRequestReviewButtonClick: _propTypes2.default.func,
	  createdBy: _propTypes2.default.string.isRequired,
	  channels: _propTypes2.default.array.isRequired,
	  createdAt: _propTypes2.default.instanceOf(Date).isRequired,
	  requestType: _propTypes2.default.string.isRequired,
	  isInfluencerMode: _propTypes2.default.bool
	};
	
	DataRequestWideCard.defaultProps = {
	  isInfluencerMode: false,
	  onRequestReviewButtonClick: _lodash2.default.noop
	};
	
	exports.default = DataRequestWideCard;

/***/ },
/* 1930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddedBy = function AddedBy(_ref) {
	  var isAutoAdded = _ref.isAutoAdded,
	      createdBy = _ref.createdBy;
	
	  if (isAutoAdded) {
	    return _react2.default.createElement(
	      _semanticUiReact.Label,
	      { basic: true, color: 'green' },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'cogs' }),
	      'system'
	    );
	  }
	
	  return _react2.default.createElement(
	    _semanticUiReact.Label,
	    { basic: true, color: 'grey' },
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'user' }),
	    createdBy
	  );
	};
	
	AddedBy.propTypes = {
	  isAutoAdded: _propTypes2.default.bool.isRequired,
	  createdBy: _propTypes2.default.string.isRequired
	};
	
	exports.default = AddedBy;

/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _textHighlighter = __webpack_require__(378);
	
	var _textHighlighter2 = _interopRequireDefault(_textHighlighter);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _automationUtils = __webpack_require__(929);
	
	var _addedBy = __webpack_require__(1930);
	
	var _addedBy2 = _interopRequireDefault(_addedBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageStyle = {
	  display: 'block',
	  margin: '0 auto',
	  maxHeight: 250
	};
	
	var actionsStyle = {
	  textAlign: 'center'
	};
	
	var buttonStyle = {
	  width: 200
	};
	
	var noImageWrapper = {
	  textAlign: 'center'
	};
	
	var tableStyle = {
	  minHeight: 300,
	  margin: 0,
	  padding: 0
	};
	
	var modalContactStyle = { padding: 5 };
	var smallFont = { fontSize: '80%', border: 0, color: '#444' };
	var paddedCell = { padding: 30 };
	
	var DeleteAssetDialog = function DeleteAssetDialog(_ref) {
	  var onDelete = _ref.onDelete,
	      thumbnail = _ref.thumbnail,
	      text = _ref.text,
	      onClose = _ref.onClose,
	      headerText = _ref.headerText,
	      highlighedHashtags = _ref.highlighedHashtags,
	      createdBy = _ref.createdBy,
	      createdDate = _ref.createdDate,
	      trackedAssetCreatedBy = _ref.trackedAsset.createdBy;
	
	  var isPostAutoAdded = (0, _automationUtils.isAutoAdded)(createdBy) || (0, _automationUtils.isAutoAdded)(trackedAssetCreatedBy);
	  var derivedCreatedBy = createdBy || trackedAssetCreatedBy;
	  var friendlyDate = (0, _moment2.default)(createdDate).format('lll');
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      open: true,
	      onClose: onClose,
	      closeOnDimmerClick: true,
	      closeOnDocumentClick: true
	    },
	    _react2.default.createElement(_dyzioModal.DyzioModalHeader, { headerText: headerText, onClose: onClose }),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      { style: modalContactStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { columns: 'two', basic: 'very', fixed: true, textAlign: 'center', style: tableStyle },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            thumbnail && _react2.default.createElement(_semanticUiReact.Image, { style: imageStyle, src: thumbnail }),
	            !thumbnail && _react2.default.createElement(
	              'div',
	              { style: noImageWrapper },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'image', size: 'huge' }),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'No image available'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { style: paddedCell },
	            _react2.default.createElement(_textHighlighter2.default, { text: text, words: highlighedHashtags })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(_semanticUiReact.Table.Cell, { style: smallFont }),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { style: smallFont },
	            'added by ',
	            _react2.default.createElement(_addedBy2.default, { isAutoAdded: isPostAutoAdded, createdBy: derivedCreatedBy }),
	            '\xA0',
	            friendlyDate
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Actions,
	      { style: actionsStyle },
	      _react2.default.createElement(_semanticUiReact.Button, {
	        icon: 'trash',
	        style: buttonStyle,
	        color: 'red',
	        content: 'delete asset',
	        onClick: function onClick() {
	          onDelete();onClose();
	        }
	      }),
	      _react2.default.createElement(_semanticUiReact.Button, {
	        onClick: onClose,
	        icon: 'close',
	        style: buttonStyle,
	        content: 'cancel'
	      })
	    )
	  );
	};
	
	DeleteAssetDialog.propTypes = {
	  text: _propTypes2.default.string,
	  thumbnail: _propTypes2.default.string.isRequired,
	  onDelete: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  headerText: _propTypes2.default.string,
	  highlighedHashtags: _propTypes2.default.array,
	  createdBy: _propTypes2.default.string.isRequired,
	  createdDate: _propTypes2.default.string.isRequired,
	  trackedAsset: _propTypes2.default.object
	};
	
	DeleteAssetDialog.defaultProps = {
	  headerText: 'Confirm delete',
	  highlighedHashtags: [],
	  text: 'No caption',
	  trackedAsset: {}
	};
	
	exports.default = DeleteAssetDialog;

/***/ },
/* 1932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _howToCloseModal = __webpack_require__(1949);
	
	var _howToCloseModal2 = _interopRequireDefault(_howToCloseModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapperStyle = {
	  textAlign: 'center'
	};
	
	var DeleteInfluencerModal = function DeleteInfluencerModal(_ref) {
	  var onClose = _ref.onClose,
	      campaignName = _ref.campaignName,
	      onConfirm = _ref.onConfirm,
	      _ref$influencer = _ref.influencer,
	      thumbnail = _ref$influencer.thumbnail,
	      influencerName = _ref$influencer.influencerName;
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      headerText: 'Remove Influencer',
	      size: 'small',
	      onClose: onClose,
	      hasActionButton: true,
	      actionButtonColor: 'red',
	      actionButtonContent: 'Delete',
	      actionButtonIcon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash' }),
	      onActionButtonClick: onConfirm
	    },
	    _react2.default.createElement(
	      'div',
	      { style: wrapperStyle },
	      _react2.default.createElement(_semanticUiReact.Image, { src: thumbnail, centered: true, className: 'circular', size: 'small' }),
	      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Are you sure you want to remove ',
	        influencerName,
	        ' from campaign ',
	        campaignName,
	        '?'
	      ),
	      _react2.default.createElement(_howToCloseModal2.default, null)
	    )
	  );
	};
	
	DeleteInfluencerModal.propTypes = {
	  onConfirm: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  influencer: _propTypes2.default.object.isRequired,
	  campaignName: _propTypes2.default.string.isRequired
	};
	
	exports.default = DeleteInfluencerModal;

/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HELP_URL = 'https://dyzio.co/track-paid-campaign-data';
	
	var ConnectAccount = function (_React$Component) {
	  _inherits(ConnectAccount, _React$Component);
	
	  function ConnectAccount() {
	    _classCallCheck(this, ConnectAccount);
	
	    var _this = _possibleConstructorReturn(this, (ConnectAccount.__proto__ || Object.getPrototypeOf(ConnectAccount)).call(this));
	
	    _this.toggleModalState = function () {
	      return _this.setState({
	        modalOpen: !_this.state.modalOpen
	      });
	    };
	
	    _this.state = {
	      modalOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(ConnectAccount, [{
	    key: 'render',
	    value: function render() {
	      var modalOpen = this.state.modalOpen;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'You have not linked a facebook ads manager account. Click ',
	          _react2.default.createElement(
	            'a',
	            { onClick: this.toggleModalState },
	            'here'
	          ),
	          ' to link your account. This will enable you to create Paid & organic reports for your campaigns. This is a premium feature - find out more ',
	          _react2.default.createElement(
	            _targetLink2.default,
	            { renderIf: true, href: HELP_URL },
	            'here'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          { onClick: this.toggleModalState, inverted: true, fluid: true, icon: true, labelPosition: 'left', color: 'pink' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkify' }),
	          'Link my account'
	        ),
	        modalOpen && _react2.default.createElement(
	          _dyzioModal2.default,
	          {
	            size: 'tiny',
	            onClose: this.toggleModalState,
	            headerText: 'Linking Facebook Ads Manager Account',
	            hasActionButton: true,
	            actionButtonContent: 'OK',
	            onActionButtonClick: this.toggleModalState
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'This is a premium feature - find out more ',
	            _react2.default.createElement(
	              _targetLink2.default,
	              { renderIf: true, href: HELP_URL },
	              'here'
	            ),
	            '. Contact a member of our sales team using the chat tool in the bottom right to get set up.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ConnectAccount;
	}(_react2.default.Component);
	
	exports.default = ConnectAccount;

/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var labelStyle = {
	  marginTop: 10,
	  marginBottom: 10
	};
	
	var ConnectedAccount = function ConnectedAccount(_ref) {
	  var name = _ref.name,
	      id = _ref.id;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      name,
	      ' is linked to this Ads Manager account.'
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	    _react2.default.createElement(
	      _semanticUiReact.Label,
	      { size: 'large', style: labelStyle },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', color: 'blue' }),
	      _lodash2.default.upperCase(id),
	      _react2.default.createElement(
	        _semanticUiReact.Label.Detail,
	        null,
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'green' })
	      )
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, null),
	    _react2.default.createElement(
	      _semanticUiReact.Button,
	      { disabled: true, inverted: true, fluid: true, icon: true, labelPosition: 'left', color: 'red' },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlinkify' }),
	      'Unlink my account'
	    )
	  );
	};
	
	ConnectedAccount.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  id: _propTypes2.default.string.isRequired
	};
	
	exports.default = ConnectedAccount;

/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _privateDataComponent = __webpack_require__(351);
	
	var _privateDataComponent2 = _interopRequireDefault(_privateDataComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sf = function sf(num) {
	  return (0, _numeral2.default)(num).format('0a');
	};
	
	var FacebookImpressions = function FacebookImpressions(_ref) {
	  var latestStatistic = _ref.latestStatistic,
	      popupToggleHandler = _ref.popupToggleHandler;
	
	  var insights = latestStatistic.insights;
	  if (insights) {
	    return _react2.default.createElement(_semanticUiReact.Button, {
	      color: 'blue',
	      inverted: true,
	      icon: 'pie graph',
	      labelPosition: 'left',
	      fluid: true,
	      content: sf(insights.totalVideoImpressions),
	      onClick: function onClick() {
	        return popupToggleHandler(latestStatistic);
	      },
	      size: 'small'
	    });
	  }
	  return _react2.default.createElement(_privateDataComponent2.default, null);
	};
	
	exports.default = FacebookImpressions;

/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactChartjs = __webpack_require__(444);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	var pf = function pf(num) {
	  return (0, _numeral2.default)(num).format('0.0%');
	};
	var df = function df(num) {
	  return (0, _numeral2.default)(num).format('0.0');
	};
	
	var dyzioPalette = {
	  pink: '#fc4085',
	  bgPink: '#ffecf3',
	  green: '#20c49e',
	  bgGreen: '#d4faf1',
	  amber: '#fdb02b',
	  bgAmber: '#fff1d5',
	  blue: '#9ad2ff',
	  bgBlue: '#323299'
	};
	
	var barOptions = {
	  tooltips: {
	    mode: 'index',
	    intersect: false
	  },
	  responsive: true,
	  showScale: false,
	  scales: {
	    xAxes: [{
	      stacked: true
	    }],
	    yAxes: [{
	      stacked: true
	    }]
	  }
	};
	
	var getDemographics = function getDemographics(data, gender) {
	  var labels = ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'];
	  var demos = _lodash2.default.map(labels, function (label) {
	    var derivedLabel = '' + gender + label;
	    return data[derivedLabel];
	  });
	  return demos;
	};
	
	var FacebookInsightsModal = function FacebookInsightsModal(_ref) {
	  var latestStatistic = _ref.latestStatistic,
	      popupToggleHandler = _ref.popupToggleHandler,
	      open = _ref.open;
	
	
	  if (!latestStatistic) return null;
	  var insights = latestStatistic.insights;
	
	
	  if (!open) return null;
	
	  var demographics = insights.totalVideoViewTimeByAgeBucketAndGender;
	  var demoPercentages = _lodash2.default.mapValues(demographics, function (v) {
	    return df(v * 100 / insights.totalVideoViewTotalTime);
	  });
	  var reactions = insights.totalVideoReactionsByTypeTotal;
	
	  console.log(insights);
	
	  var barData = {
	    labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'],
	    datasets: [{
	      label: 'male %',
	      backgroundColor: dyzioPalette.blue,
	      borderColor: dyzioPalette.bgBlue,
	      borderWidth: 1,
	      data: getDemographics(demoPercentages, 'M')
	    }, {
	      label: 'female %',
	      backgroundColor: dyzioPalette.bgPink,
	      borderColor: dyzioPalette.pink,
	      borderWidth: 1,
	      data: getDemographics(demoPercentages, 'F')
	    }, {
	      label: 'unidentified %',
	      backgroundColor: dyzioPalette.bgGreen,
	      borderColor: dyzioPalette.green,
	      borderWidth: 1,
	      data: getDemographics(demoPercentages, 'U')
	    }]
	  };
	
	  var reactionTypes = ['like', 'love', 'wow', 'haha', 'sad', 'angry'];
	
	  var fbH4 = {
	    padding: 5,
	    border: '1px solid #ccc',
	    backgroundColor: '#eee'
	  };
	
	  var collectedDate = (0, _moment2.default)(latestStatistic.createdDate).format('MMMM Do YYYY, h:mm:ss a');
	
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      open: open,
	      onClose: popupToggleHandler,
	      size: 'small'
	    },
	    _react2.default.createElement(_semanticUiReact.Header, { icon: 'pie graph', content: 'Facebook Video Insights' }),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      _react2.default.createElement(
	        'h4',
	        { style: fbH4 },
	        'Impressions and Views'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very', celled: true, fluid: true, small: true, style: { padding: 5 } },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            { key: 'totalVideoImpressions' },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Total Video Impressions'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              cf(insights.totalVideoImpressions)
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            { key: 'totalVideoViews' },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Total Video Views'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              cf(insights.totalVideoViews)
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            { key: 'totalVideoViewsOrganic' },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Total Video Views Organic'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              cf(insights.totalVideoViewsOrganic)
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            { key: 'totalVideoViewsPaid' },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Total Video Views Paid'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              cf(insights.totalVideoViewsPaid)
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            { key: 'totalVideoImpressionsUnique' },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Lifetime Video Total Reach'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              cf(insights.totalVideoImpressionsUnique)
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            { key: 'ctr' },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(
	                'b',
	                { style: { color: "blue" } },
	                'Click Through Rate'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              pf(insights.totalVideoViews / insights.totalVideoImpressions)
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h4',
	        { style: fbH4 },
	        'Audience Demographics (by total video view time)'
	      ),
	      _react2.default.createElement(_reactChartjs.HorizontalBar, { data: barData, options: barOptions }),
	      reactions && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'h4',
	          { style: fbH4 },
	          'Audience Reactions'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very', celled: true, fluid: true, small: true, textAlign: 'center' },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              { key: 'totalVideoImpressions' },
	              _lodash2.default.map(reactionTypes, function (rt) {
	                return _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Image, {
	                    src: '/icons/facebook-' + rt + '.png',
	                    alt: '' + rt,
	                    size: 'tiny',
	                    centered: true
	                  })
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              { key: 'totalVideoImpressionsxx' },
	              _lodash2.default.map(reactionTypes, function (rt) {
	                return _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  cf(reactions[rt])
	                );
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { className: 'centered' },
	        _react2.default.createElement(_semanticUiReact.Label, { centered: true, icon: 'clock', color: 'grey', basic: true, content: 'data collected ' + collectedDate })
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Actions,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        { color: 'green', onClick: popupToggleHandler, inverted: true },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
	        ' Got it'
	      )
	    )
	  );
	};
	
	exports.default = FacebookInsightsModal;

/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headingStyle = {
	  paddingTop: 7,
	  float: 'left',
	  fontSize: 18
	};
	
	var buttonStyle = {
	  marginTop: 20
	};
	
	var isValidDate = function isValidDate(value) {
	  return (0, _moment2.default)(value, _moment2.default.ISO_8601, true).isValid();
	};
	
	var FacebookLinkedMC = function FacebookLinkedMC(_ref) {
	  var id = _ref.id,
	      name = _ref.name,
	      createdAt = _ref.created_time,
	      onUnlink = _ref.onUnlink;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { wide: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: headingStyle },
	          _react2.default.createElement(
	            _semanticUiReact.Icon.Group,
	            { size: 'large' },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', color: 'blue', className: 'circular', inverted: true }),
	            _react2.default.createElement(_semanticUiReact.Icon, { corner: true, name: 'linkify', color: 'green' })
	          ),
	          ' ',
	          name
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          {
	            icon: true,
	            className: 'circular',
	            floated: 'right',
	            inverted: true,
	            color: 'pink',
	            labelPosition: 'left',
	            style: buttonStyle,
	            onClick: function onClick() {
	              return onUnlink(id);
	            }
	          },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlinkify' }),
	          'Unlink'
	        )
	      )
	    ),
	    isValidDate(createdAt) && _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true },
	      'created on ',
	      (0, _moment2.default)(createdAt).format('DD MMM YYYY')
	    )
	  );
	};
	
	FacebookLinkedMC.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  created_time: _propTypes2.default.string.isRequired,
	  onUnlink: _propTypes2.default.func.isRequired
	};
	
	exports.default = FacebookLinkedMC;

/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _facebookLinkedMc = __webpack_require__(1937);
	
	var _facebookLinkedMc2 = _interopRequireDefault(_facebookLinkedMc);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var marginTop10 = {
	  marginTop: 10
	};
	
	var FacebookMarketingCampaignLinker = function (_Component) {
	  _inherits(FacebookMarketingCampaignLinker, _Component);
	
	  function FacebookMarketingCampaignLinker() {
	    var _this2 = this;
	
	    _classCallCheck(this, FacebookMarketingCampaignLinker);
	
	    var _this = _possibleConstructorReturn(this, (FacebookMarketingCampaignLinker.__proto__ || Object.getPrototypeOf(FacebookMarketingCampaignLinker)).call(this));
	
	    _this.handleAPIError = function () {
	      _this.setState({
	        loading: false,
	        failedToFetch: true
	      });
	    };
	
	    _this.onSearchChange = function (event, _ref) {
	      var value = _ref.value;
	
	      _this.setState({
	        inputValue: value
	      });
	    };
	
	    _this.link = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(event, _ref3) {
	        var id = _ref3.result.id;
	
	        var _this$props, restClient, campaignId, _this$state, marketingCampaigns, existingCampaigns, selectedMarketingCampaign, newCampaigns;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props = _this.props, restClient = _this$props.restClient, campaignId = _this$props.campaignId;
	                _this$state = _this.state, marketingCampaigns = _this$state.marketingCampaigns, existingCampaigns = _this$state.existingCampaigns;
	                selectedMarketingCampaign = _lodash2.default.find(marketingCampaigns, ['id', id]);
	                newCampaigns = _lodash2.default.concat(existingCampaigns, [selectedMarketingCampaign]);
	                _context.next = 6;
	                return restClient.patch('campaigns/' + campaignId, {
	                  data: {
	                    attributes: {
	                      marketingCampaigns: newCampaigns
	                    }
	                  }
	                });
	
	              case 6:
	                _this.setState({
	                  inputValue: '',
	                  existingCampaigns: newCampaigns,
	                  marketingCampaigns: _lodash2.default.reject(marketingCampaigns, ['id', selectedMarketingCampaign.id])
	                });
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.unlink = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(mcId) {
	        var _this$props2, restClient, campaignId, _this$state2, existingCampaigns, marketingCampaigns, unlinkedCampaign, newExistingCampaigns, newMarketingCampaigns;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$props2 = _this.props, restClient = _this$props2.restClient, campaignId = _this$props2.campaignId;
	                _this$state2 = _this.state, existingCampaigns = _this$state2.existingCampaigns, marketingCampaigns = _this$state2.marketingCampaigns;
	                unlinkedCampaign = _lodash2.default.find(existingCampaigns, ['id', mcId]);
	                newExistingCampaigns = _lodash2.default.reject(existingCampaigns, ['id', mcId]);
	                newMarketingCampaigns = _lodash2.default.concat(marketingCampaigns, [unlinkedCampaign]);
	                _context2.next = 7;
	                return restClient.patch('campaigns/' + campaignId, {
	                  data: {
	                    attributes: {
	                      marketingCampaigns: newExistingCampaigns
	                    }
	                  }
	                });
	
	              case 7:
	                _this.setState({
	                  existingCampaigns: newExistingCampaigns,
	                  marketingCampaigns: newMarketingCampaigns
	                });
	
	              case 8:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      noCampaignsOnFacebook: false,
	      marketingCampaigns: [],
	      existingCampaigns: [],
	      loading: true,
	      inputValue: '',
	      failedToFetch: false
	    };
	    return _this;
	  }
	
	  _createClass(FacebookMarketingCampaignLinker, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _props, restClient, buildRESTClient, organisationId, campaignId, shareAPIClient, campaignResponse, response, existingCampaigns, marketingCampaigns, filteredMarketingCampaigns;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _props = this.props, restClient = _props.restClient, buildRESTClient = _props.buildRESTClient, organisationId = _props.userInfo.organisationId, campaignId = _props.campaignId;
	                shareAPIClient = buildRESTClient({
	                  baseURL: ("https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production"),
	                  hasToken: true,
	                  timeout: 20000
	                });
	                _context3.next = 4;
	                return restClient.get('campaigns/' + campaignId).catch(this.handleAPIError);
	
	              case 4:
	                campaignResponse = _context3.sent;
	                _context3.next = 7;
	                return shareAPIClient.get('/marketing/organisation-mcs/by-id/' + organisationId).catch(this.handleAPIError);
	
	              case 7:
	                response = _context3.sent;
	
	                if (!(!campaignResponse || !response)) {
	                  _context3.next = 10;
	                  break;
	                }
	
	                return _context3.abrupt('return');
	
	              case 10:
	                existingCampaigns = _lodash2.default.get(campaignResponse, 'data.data.attributes.marketingCampaigns', []);
	                marketingCampaigns = _lodash2.default.get(response, 'data.data.marketingCampaigns', []);
	                filteredMarketingCampaigns = _lodash2.default.filter(marketingCampaigns, function (mc) {
	                  return _lodash2.default.isUndefined(_lodash2.default.find(existingCampaigns, ['id', mc.id]));
	                });
	
	
	                this.setState({
	                  marketingCampaigns: filteredMarketingCampaigns,
	                  existingCampaigns: existingCampaigns,
	                  loading: false,
	                  noCampaignsOnFacebook: _lodash2.default.isEmpty(marketingCampaigns)
	                });
	
	              case 14:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          loading = _state.loading,
	          marketingCampaigns = _state.marketingCampaigns,
	          inputValue = _state.inputValue,
	          failedToFetch = _state.failedToFetch,
	          existingCampaigns = _state.existingCampaigns,
	          noCampaignsOnFacebook = _state.noCampaignsOnFacebook;
	
	
	      var canRenderCampaigns = !loading && !failedToFetch;
	      var noCampaignsYet = !loading && !failedToFetch && _lodash2.default.isEmpty(existingCampaigns);
	
	      var allOptions = _lodash2.default.map(marketingCampaigns, function (item) {
	        return {
	          id: item.id,
	          title: item.name
	        };
	      });
	
	      var options = _lodash2.default.filter(allOptions, function (option) {
	        return _lodash2.default.includes(_lodash2.default.lowerCase(option.title), _lodash2.default.lowerCase(inputValue));
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: marginTop10 },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Link a Facebook Ad Campaign'
	        ),
	        loading && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_semanticUiReact.Loader, { inline: true, active: true })
	        ),
	        failedToFetch && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { warning: true },
	          'Something went wrong ',
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'frown' }),
	          ' ',
	          _react2.default.createElement('br', null),
	          'Please try again later.'
	        ),
	        canRenderCampaigns && _react2.default.createElement(
	          'div',
	          null,
	          noCampaignsOnFacebook ? _react2.default.createElement(
	            'div',
	            null,
	            'no ad campaigns linked to this account'
	          ) : _react2.default.createElement(_semanticUiReact.Search, {
	            fluid: true,
	            input: _react2.default.createElement(_semanticUiReact.Input, { fluid: true }),
	            placeholder: 'search for facebook ad campaign...',
	            results: options,
	            style: marginTop10,
	            loading: loading,
	            disabled: loading || failedToFetch,
	            value: inputValue,
	            onResultSelect: this.link,
	            onSearchChange: this.onSearchChange
	          }),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Linked Campaigns'
	          ),
	          noCampaignsYet && _react2.default.createElement(
	            'p',
	            null,
	            'no linked campaigns yet.'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Group,
	            { style: marginTop10, itemsPerRow: 'one' },
	            _lodash2.default.map(existingCampaigns, function (item) {
	              return _react2.default.createElement(_facebookLinkedMc2.default, Object.assign({ onUnlink: _this3.unlink, key: item.id }, item));
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return FacebookMarketingCampaignLinker;
	}(_react.Component);
	
	FacebookMarketingCampaignLinker.propTypes = {
	  campaignId: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(FacebookMarketingCampaignLinker);

/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _demographicsLocationTable = __webpack_require__(146);
	
	var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullCityModal = function FullCityModal(_ref) {
	  var onToggle = _ref.onToggle,
	      audienceCities = _ref.audienceCities;
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      headerText: 'Fans by City',
	      size: 'small',
	      onClose: onToggle,
	      hasCloseButton: true
	    },
	    _react2.default.createElement(_demographicsLocationTable2.default, {
	      data: audienceCities.data,
	      metric: 'absolute',
	      metricLabel: 'Followers',
	      itemLabel: 'City',
	      rowsToShow: -1
	    })
	  );
	};
	
	FullCityModal.propTypes = {
	  onToggle: _propTypes2.default.func.isRequired,
	  audienceCities: _propTypes2.default.object.isRequired
	};
	
	exports.default = FullCityModal;

/***/ },
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _demographicsLocationTable = __webpack_require__(146);
	
	var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullCountryModal = function FullCountryModal(_ref) {
	  var onToggle = _ref.onToggle,
	      audienceLocations = _ref.audienceLocations;
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      headerText: 'Fans by Country',
	      size: 'small',
	      onClose: onToggle,
	      hasCloseButton: true
	    },
	    _react2.default.createElement(_demographicsLocationTable2.default, {
	      data: audienceLocations.data,
	      metric: 'absolute',
	      metricLabel: 'Fans',
	      itemLabel: 'Country',
	      rowsToShow: -1
	    })
	  );
	};
	
	FullCountryModal.propTypes = {
	  onToggle: _propTypes2.default.func.isRequired,
	  audienceLocations: _propTypes2.default.object.isRequired
	};
	
	exports.default = FullCountryModal;

/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactCsv = __webpack_require__(316);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var VALUE_CELL_STYLE = { width: '50%', textAlign: 'right' };
	
	var objToRows = function objToRows(obj) {
	  return _lodash2.default.map(_lodash2.default.toPairs(obj), function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        metric = _ref2[0],
	        metricValue = _ref2[1];
	
	    var value = metricValue.value || metricValue;
	    if (value === undefined || _lodash2.default.isObject(value) && _lodash2.default.isEmpty(value)) return null;
	    var description = _lodash2.default.get(obj, metric + '.description');
	    var formattedValue = _lodash2.default.isObject(value) ? _react2.default.createElement(
	      _semanticUiReact.Table,
	      { compact: 'very' },
	      objToRows(value)
	    ) : value;
	    return _react2.default.createElement(
	      _semanticUiReact.Table.Row,
	      { key: metric },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        null,
	        description && _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(
	            'span',
	            null,
	            _lodash2.default.startCase(metric),
	            ' ',
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
	          ),
	          content: description
	        }),
	        !description && _lodash2.default.startCase(metric)
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        { style: VALUE_CELL_STYLE },
	        (0, _formatting.commaFormatted)(formattedValue)
	      )
	    );
	  });
	};
	
	var splitByGroup = function splitByGroup(metrics) {
	  return [{
	    title: 'Basic',
	    group: _lodash2.default.pickBy(metrics, function (value, key) {
	      return _lodash2.default.split(key, '_').length === 1;
	    })
	  }, {
	    title: 'Page Video Views',
	    group: _lodash2.default.pickBy(metrics, function (value, key) {
	      return _lodash2.default.includes(key, 'page_video');
	    })
	  }, {
	    title: 'Page Engagement',
	    group: _lodash2.default.pickBy(metrics, function (value, key) {
	      return _lodash2.default.includes(key, 'page_consumptions') || _lodash2.default.includes(key, 'page_engaged');
	    })
	  }];
	};
	
	var FullMetricModal = function FullMetricModal(_ref3) {
	  var onToggle = _ref3.onToggle,
	      username = _ref3.username,
	      metrics = _objectWithoutProperties(_ref3, ['onToggle', 'username']);
	
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      headerText: 'All Facebook Page Metrics',
	      size: 'small',
	      onClose: onToggle,
	      hasCloseButton: true
	    },
	    _lodash2.default.map(splitByGroup(metrics), function (_ref4) {
	      var title = _ref4.title,
	          group = _ref4.group;
	      return _react2.default.createElement(
	        'div',
	        { key: title },
	        _react2.default.createElement(
	          'h3',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { striped: true },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Header,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'Metric'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { style: VALUE_CELL_STYLE },
	                'Value'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            objToRows(group)
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, null)
	      );
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'right' } },
	      _react2.default.createElement(
	        _semanticUiReact.Label,
	        { basic: true, size: 'large', inverted: true, color: 'teal' },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
	        _react2.default.createElement(
	          _reactCsv.CSVLink,
	          {
	            data: _lodash2.default.map(_lodash2.default.toPairs(metrics), function (_ref5) {
	              var _ref6 = _slicedToArray(_ref5, 2),
	                  metric = _ref6[0],
	                  value = _ref6[1].value;
	
	              return { metric: metric, value: value };
	            }),
	            filename: 'facebook-metrics-' + username + '.csv'
	          },
	          'Download Metrics'
	        )
	      )
	    )
	  );
	};
	
	FullMetricModal.propTypes = {
	  onToggle: _propTypes2.default.func.isRequired,
	  username: _propTypes2.default.string.isRequired
	};
	
	exports.default = FullMetricModal;

/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _instagramDemographicsCountriesTable = __webpack_require__(598);
	
	var _instagramDemographicsCountriesTable2 = _interopRequireDefault(_instagramDemographicsCountriesTable);
	
	var _demographicsLocationTable = __webpack_require__(146);
	
	var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB_STYLES = {
	  marginBottom: 4
	};
	var MODAL_LINK_STYLE = {
	  cursor: 'pointer'
	};
	
	var getPanes = function getPanes(props) {
	  var audienceCities = props.audienceCities,
	      onFullCountryClick = props.onFullCountryClick,
	      onFullCityClick = props.onFullCityClick;
	
	  var panes = [{
	    menuItem: { content: 'Fans by Country', key: 'country', icon: 'globe' },
	    render: function render() {
	      return _react2.default.createElement(
	        _semanticUiReact.Tab.Pane,
	        null,
	        _react2.default.createElement(_instagramDemographicsCountriesTable2.default, props),
	        _react2.default.createElement(
	          'a',
	          { style: MODAL_LINK_STYLE, onClick: onFullCountryClick },
	          'View full engagement data'
	        )
	      );
	    }
	  }, {
	    menuItem: { content: 'Fans by City', key: 'last12posts', icon: 'building outline' },
	    render: function render() {
	      return _react2.default.createElement(
	        _semanticUiReact.Tab.Pane,
	        null,
	        _react2.default.createElement(_demographicsLocationTable2.default, {
	          data: audienceCities.data,
	          metric: 'absolute',
	          metricLabel: 'Followers',
	          itemLabel: 'City'
	        }),
	        _react2.default.createElement(
	          'a',
	          { style: MODAL_LINK_STYLE, onClick: onFullCityClick },
	          'View full engagement data'
	        )
	      );
	    }
	  }];
	  return panes;
	};
	
	var InstagramTabs = function InstagramTabs(props) {
	  var audienceCities = props.audienceCities;
	
	  if (audienceCities) {
	    return _react2.default.createElement(_semanticUiReact.Tab, { style: TAB_STYLES, panes: getPanes(props) });
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h5',
	      null,
	      'Fans by Country'
	    ),
	    _react2.default.createElement(_instagramDemographicsCountriesTable2.default, props)
	  );
	};
	
	InstagramTabs.propTypes = {
	  audienceCities: _propTypes2.default.Object
	};
	InstagramTabs.defaultProps = {
	  audienceCities: undefined
	};
	
	exports.default = InstagramTabs;

/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CheckboxInput(props) {
	  return _react2.default.createElement(
	    "span",
	    null,
	    _react2.default.createElement("input", Object.assign({ type: "checkbox", id: props.checkboxName, name: props.checkboxName }, props.input)),
	    _react2.default.createElement(
	      "label",
	      { htmlFor: props.checkboxName },
	      _react2.default.createElement("span", null),
	      _react2.default.createElement(
	        "p",
	        null,
	        props.label
	      )
	    ),
	    props.img && _react2.default.createElement("img", { alt: props.id, src: props.img }),
	    props.meta.touched && props.meta.error && _react2.default.createElement(
	      "p",
	      { className: "small error" },
	      props.meta.error
	    )
	  );
	}
	
	CheckboxInput.propTypes = {
	  input: _react2.default.PropTypes.object,
	  meta: _react2.default.PropTypes.object
	};
	
	exports.default = CheckboxInput;

/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactNumericInput = __webpack_require__(1533);
	
	var _reactNumericInput2 = _interopRequireDefault(_reactNumericInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CurrencyInput = function CurrencyInput(props) {
	  var error = props.meta.touched && props.meta.error ? 'error' : '';
	  var disabled = props.disabled ? 'disabled' : '';
	  var errorClass = props.className + ' small error';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-field number' },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: props.id },
	      props.label
	    ),
	    _react2.default.createElement(_reactNumericInput2.default, Object.assign({}, props.input, {
	      style: false,
	      min: 0,
	      max: 10000000,
	      id: props.id,
	      name: props.name,
	      className: (0, _classnames2.default)(error, disabled, props.className),
	      disabled: props.disabled ? true : false,
	      placeholder: props.placeholder
	    })),
	    _react2.default.createElement(
	      'p',
	      { className: 'field-symbol' },
	      '\xA3'
	    ),
	    props.meta.touched && props.meta.error && _react2.default.createElement(
	      'p',
	      { className: errorClass },
	      props.meta.error
	    )
	  );
	};
	
	CurrencyInput.propTypes = {
	  input: _react2.default.PropTypes.object,
	  meta: _react2.default.PropTypes.object
	};
	
	exports.default = CurrencyInput;

/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(71);
	
	var _immutable2 = __webpack_require__(34);
	
	var _formInputText = __webpack_require__(104);
	
	var _formInputText2 = _interopRequireDefault(_formInputText);
	
	var _formInputSelect = __webpack_require__(545);
	
	var _formInputSelect2 = _interopRequireDefault(_formInputSelect);
	
	var _staticConfiguration = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormInviteRow = function (_React$Component) {
	  _inherits(FormInviteRow, _React$Component);
	
	  function FormInviteRow() {
	    _classCallCheck(this, FormInviteRow);
	
	    return _possibleConstructorReturn(this, (FormInviteRow.__proto__ || Object.getPrototypeOf(FormInviteRow)).apply(this, arguments));
	  }
	
	  _createClass(FormInviteRow, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          fields = _props.fields,
	          touched = _props.touched,
	          error = _props.error,
	          form = _props.form,
	          hasClient = _props.hasClient;
	
	
	      var options = [{ value: _staticConfiguration.TEAM_MEMBER, label: 'Team member' }];
	      if (hasClient) {
	        options.push({ value: _staticConfiguration.CLIENT, label: 'Client' });
	      }
	      options.push({ value: _staticConfiguration.INFLUENCER, label: 'Influencer' });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        fields.map(function (collaborator, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-2-6 grid-xl-2-6' },
	              _react2.default.createElement(_immutable.Field, {
	                name: collaborator + '.role',
	                component: function component(props) {
	                  return _react2.default.createElement(_formInputSelect2.default, Object.assign({
	                    name: collaborator + '.role',
	                    label: index === 0 ? 'Who is this person?' : '',
	                    className: 'stacked'
	                  }, props, {
	                    options: options
	                  }));
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-2-6 grid-xl-2-6' },
	              _react2.default.createElement(_immutable.Field, {
	                name: collaborator + '.email',
	                className: 'stacked',
	                id: 'email-1',
	                type: 'text',
	                label: index === 0 ? 'Email address' : '',
	                component: _formInputText2.default,
	                placeholder: 'email@example.com'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-2-6 grid-xl-2-6' },
	              _react2.default.createElement(_immutable.Field, {
	                name: collaborator + '.name',
	                className: 'stacked',
	                type: 'text',
	                id: 'name-1',
	                label: index === 0 ? 'Full name (optional)' : '',
	                component: _formInputText2.default,
	                placeholder: ''
	              })
	            ),
	            form && form.getIn([index, 'role']) && form.getIn([index, 'role']) === _staticConfiguration.INFLUENCER && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('div', { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-2-6 grid-xl-2-6' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-4-6 grid-xl-4-6' },
	                _react2.default.createElement(_immutable.Field, {
	                  name: collaborator + '.socialHandle',
	                  type: 'text',
	                  className: 'stacked',
	                  label: 'Social handle',
	                  component: _formInputText2.default,
	                  placeholder: 'e.g. Zoella'
	                }),
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'small light' },
	                  'Use the social handle they are most known by. This will be the name used when collaborating with them.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement('div', { className: 'break' })
	              )
	            )
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hero small' },
	            _react2.default.createElement(
	              'button',
	              { className: 'medium wide icon', type: 'button', onClick: function onClick() {
	                  return fields.push((0, _immutable2.fromJS)({}));
	                } },
	              _react2.default.createElement(
	                'p',
	                null,
	                'add another'
	              ),
	              _react2.default.createElement('img', { src: '/icons/add-person.svg', alt: 'add another' })
	            ),
	            touched && error && _react2.default.createElement(
	              'span',
	              null,
	              error
	            ),
	            _react2.default.createElement('div', { className: 'spacer' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormInviteRow;
	}(_react2.default.Component);
	
	exports.default = FormInviteRow;
	
	
	FormInviteRow.propTypes = {};

/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateHashtags = validateHashtags;
	
	var _lodash = __webpack_require__(6);
	
	function validateHashtags(input) {
	  var cleaned = input.replace(/,+$/, '');
	  var tags = cleaned.replace(/,+$/, '').split(',').map(function (t) {
	    return t.trim();
	  });
	
	  var validationRegex = /^([#|@|$])?[\u0600-\u06FF\u3000\u3400-\u4DBF\u4E00-\u9FFFA-zÀ-úа-яА-Я.0-9]{2,}$/;
	
	  var invalid = tags.filter(function (tag) {
	    // Reject empty, all dots, all commas, all spaces
	    if (!tag || /^[.,\s]+$/.test(tag)) return true;
	    return !validationRegex.test(tag);
	  });
	
	  if (invalid.length > 0) {
	    return { valid: false, invalidTags: invalid.filter(function (element) {
	        return !(0, _lodash.isEmpty)(element);
	      }) };
	  }
	  return { valid: true, tags: tags };
	} /* eslint-disable import/prefer-default-export */
	/* eslint-disable lodash/prefer-lodash-method */

/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  marginBottom: 5
	};
	
	var Hashtags = function Hashtags(_ref) {
	  var value = _ref.value;
	
	  var hashtags = _lodash2.default.isArray(value) ? value : _lodash2.default.split(value || '', ',');
	  if (_lodash2.default.isEmpty(hashtags)) return null;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _lodash2.default.map(hashtags, function (hashtag) {
	      return _react2.default.createElement(
	        _semanticUiReact.Label,
	        { key: hashtag, basic: true, style: style },
	        hashtag
	      );
	    })
	  );
	};
	
	Hashtags.propTypes = {
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]).isRequired
	};
	
	exports.default = Hashtags;

/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(37);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tiktokIconStyle = {
	  width: 20,
	  margin: '2px 0.25rem 0 0'
	};
	
	var cardStyle = {
	  color: 'black'
	};
	
	var thumbnailStyles = {
	  height: '50px',
	  display: 'block',
	  margin: '0 auto',
	  width: '50px'
	};
	
	var fadedStyle = {
	  opacity: 0.4
	};
	
	var assetCountH4Style = {
	  color: '#fc4085'
	};
	
	var STATUS = {
	  AUTHORIZED: 'AUTHORIZED',
	  WARN: 'WARN'
	};
	
	var getDerivedColor = function getDerivedColor(status, instagramPrivate) {
	  if (status === STATUS.AUTHORIZED) return { style: null, color: 'green' };
	  if (status === STATUS.WARN || instagramPrivate) return { style: null, color: 'orange' };
	  return { style: fadedStyle, color: 'grey' };
	};
	
	var AuthorisationRow = function AuthorisationRow(_ref) {
	  var platform = _ref.platform,
	      status = _ref.status;
	
	  var isAuthorised = status === STATUS.AUTHORIZED;
	  var derivedColor = getDerivedColor(status);
	
	  var isYouTube = platform === 'youtube';
	  var derivedPlatform = platform;
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    content: platform + ' ' + (isAuthorised ? 'is' : 'is not') + ' authorised', trigger: isYouTube ? _react2.default.createElement(
	      _semanticUiReact.Label,
	      null,
	      'YOUTUBE'
	    ) : _react2.default.createElement(_semanticUiReact.Icon, {
	      size: 'large',
	      name: derivedPlatform,
	      style: derivedColor.style,
	      color: derivedColor.color
	    })
	  });
	};
	
	AuthorisationRow.propTypes = {
	  platform: _propTypes2.default.string.isRequired,
	  status: _propTypes2.default.string.isRequired
	};
	
	var INVITATION_STATUS = {
	  deferred: 'DEFERRED',
	  sent: 'SENT',
	  accepted: 'ACCEPTED'
	};
	
	var getInvitationStatusIcon = function getInvitationStatusIcon(step, status) {
	  var isAccepted = status === INVITATION_STATUS.accepted;
	  var isSent = status === INVITATION_STATUS.sent;
	
	  if (step === 'invited' && (isAccepted || isSent)) {
	    return _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'green' });
	  }
	
	  if (step === 'joined' && status === INVITATION_STATUS.accepted) {
	    return _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'green' });
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'gray' });
	};
	
	var instagramPrivateWarning = {
	  paddingBottom: '5px',
	  paddingLeft: '5px'
	};
	
	var noPadding = {
	  margin: 0, border: 0
	};
	
	var scanWarningStyle = {
	  paddingRight: 35,
	  paddingBottom: 3,
	  paddingTop: 3,
	  borderTop: '1px solid #EEE',
	  color: 'gray',
	  textAlign: 'right'
	};
	
	var MAX_INSTA_SCAN_FAILS = 3;
	
	var HorizontalCollaborationCard = function HorizontalCollaborationCard(_ref2) {
	  var discussionId = _ref2.discussionId,
	      campaignId = _ref2.campaignId,
	      influencerName = _ref2.influencerName,
	      thumbnail = _ref2.thumbnail,
	      primarySocialHandle = _ref2.primarySocialHandle,
	      email = _ref2.email,
	      isEmailValid = _ref2.isEmailValid,
	      totalAssets = _ref2.totalAssets,
	      totalStories = _ref2.totalStories,
	      invitationStatus = _ref2.invitationStatus,
	      router = _ref2.router,
	      instagramStatus = _ref2.instagramStatus,
	      facebookStatus = _ref2.facebookStatus,
	      twitterStatus = _ref2.twitterStatus,
	      youtubeStatus = _ref2.youtubeStatus,
	      instagramPrivate = _ref2.instagramPrivate,
	      lastScannedDate = _ref2.lastScannedDate,
	      lastSuccessfulStoryScan = _ref2.lastSuccessfulStoryScan,
	      isLiveCampaign = _ref2.isLiveCampaign,
	      campaignWorkflow = _ref2.campaignWorkflow,
	      internalDiscountCode = _ref2.internalDiscountCode,
	      workflowStatus = _ref2.workflowStatus,
	      userInfo = _ref2.userInfo,
	      facebook = _ref2.facebook,
	      instagram = _ref2.instagram,
	      youtube = _ref2.youtube,
	      twitter = _ref2.twitter,
	      tiktok = _ref2.tiktok,
	      telegramChannels = _ref2.telegramChannels,
	      instagramScanFailures = _ref2.instagramScanFailures,
	      hasPosted = _ref2.hasPosted,
	      isScanningCompleted = _ref2.isScanningCompleted,
	      usageRightsGranted = _ref2.usageRightsGranted,
	      rollfwdCampaign = _ref2.rollfwdCampaign,
	      reviewMode = _ref2.reviewMode,
	      discountCode = _ref2.discountCode;
	
	  var routerState = {
	    influencer: { influencerName: influencerName, thumbnail: thumbnail, primarySocialHandle: primarySocialHandle, email: email },
	    discussionId: discussionId,
	    isEmailValid: isEmailValid,
	    invitationStatus: invitationStatus,
	    rollfwdCampaign: rollfwdCampaign
	  };
	
	  var now = (0, _moment2.default)();
	  var lastScanHours = Math.round(_moment2.default.duration(now.diff((0, _moment2.default)(lastScannedDate))).asHours());
	  var lastStoryScanHours = Math.round(_moment2.default.duration(now.diff((0, _moment2.default)(lastSuccessfulStoryScan))).asHours());
	  var isScanWarning = lastScanHours > 20;
	  var isStoryScanWarning = lastStoryScanHours > 10;
	
	  var derivedColor = getDerivedColor(instagramStatus, instagramPrivate);
	  var isWarn = instagramStatus === STATUS.WARN || instagramPrivate || isScanWarning;
	
	  var isScanFailureError = instagramScanFailures > MAX_INSTA_SCAN_FAILS;
	
	  if (reviewMode && isScanningCompleted) {
	    return null;
	  }
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    {
	      onClick: function onClick() {
	        return router.push({
	          pathname: '/campaign/' + campaignId + '/collaboration/' + discussionId,
	          state: routerState
	        });
	      },
	      style: cardStyle,
	      color: isWarn ? derivedColor.color : ''
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Table,
	      { padded: false, className: 'influencer-cards-table', style: noPadding },
	      _react2.default.createElement(
	        'tbody',
	        { style: { backgroundColor: isScanFailureError ? 'white' : 'white' } },
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { width: 1, textAlign: 'center' },
	            _react2.default.createElement(_semanticUiReact.Image, { src: thumbnail, className: 'circular', style: thumbnailStyles })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { width: 4 },
	            _react2.default.createElement(
	              'h4',
	              null,
	              influencerName
	            ),
	            _react2.default.createElement(
	              'h5',
	              { style: { color: 'gray' } },
	              primarySocialHandle
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { width: 10, textAlign: 'center' },
	            _react2.default.createElement(
	              _semanticUiReact.Table,
	              { basic: 'very', textAlign: 'center' },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    'invited'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    'joined'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    'platforms'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    'posts'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    'stories'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    'status'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  getInvitationStatusIcon('invited', invitationStatus)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  getInvitationStatusIcon('joined', invitationStatus)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  { textAlign: 'center' },
	                  instagram && _react2.default.createElement(AuthorisationRow, { platform: 'instagram', status: instagramStatus }),
	                  youtube && _react2.default.createElement(AuthorisationRow, { platform: 'youtube', status: youtubeStatus }),
	                  facebook && _react2.default.createElement(AuthorisationRow, { platform: 'facebook', status: facebookStatus }),
	                  twitter && _react2.default.createElement(AuthorisationRow, { platform: 'twitter', status: twitterStatus }),
	                  tiktok && _react2.default.createElement('img', { style: tiktokIconStyle, src: '/logos/tiktok-logo-grey.svg', alt: 'Tiktok' }),
	                  _lodash2.default.head(telegramChannels) && _react2.default.createElement(_semanticUiReact.Icon, {
	                    size: 'large',
	                    name: 'telegram',
	                    style: fadedStyle,
	                    color: 'grey'
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  { textAlign: 'center' },
	                  _react2.default.createElement(
	                    'h4',
	                    { style: assetCountH4Style },
	                    totalAssets
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  { textAlign: 'center' },
	                  _react2.default.createElement(
	                    'h4',
	                    { style: assetCountH4Style },
	                    totalStories
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  { textAlign: 'center' },
	                  isScanningCompleted ? _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle outline' }),
	                    content: 'This collaboration has been marked complete'
	                  }) : _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline', color: 'green' }),
	                    content: 'This collaboration is still scanning'
	                  }),
	                  usageRightsGranted ? _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'registered outline', color: 'pink' }),
	                    content: influencerName + ' has granted usage rights to their content.'
	                  }) : _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'registered outline', color: 'grey' }),
	                    content: influencerName + ' has NOT granted usage rights to their content.'
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    instagramPrivate && _react2.default.createElement(
	      'div',
	      { style: instagramPrivateWarning },
	      _react2.default.createElement(
	        _semanticUiReact.Label,
	        { color: 'orange', basic: true },
	        '\xA0Instagram account is private\xA0',
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock' }),
	        '- The system cannot scan it.'
	      )
	    ),
	    isLiveCampaign && userInfo.isDyzioUser && !isScanningCompleted && _react2.default.createElement(
	      'div',
	      { style: scanWarningStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Label,
	        { basic: true, color: isScanWarning ? 'red' : 'grey' },
	        'last GRID scan:\xA0',
	        isScanWarning && _react2.default.createElement(_semanticUiReact.Icon, { color: 'red', name: 'warning circle' }),
	        lastScanHours,
	        ' hours ago'
	      ),
	      instagram && _react2.default.createElement(
	        _semanticUiReact.Label,
	        { basic: true, color: isStoryScanWarning ? 'red' : 'grey' },
	        'last STORY scan:\xA0',
	        isStoryScanWarning && _react2.default.createElement(_semanticUiReact.Icon, { color: 'red', name: 'warning circle' }),
	        lastStoryScanHours,
	        ' hours ago'
	      )
	    ),
	    campaignWorkflow && _react2.default.createElement(
	      'div',
	      { style: scanWarningStyle },
	      discountCode && _react2.default.createElement(
	        _semanticUiReact.Label,
	        { basic: true, color: 'blue', style: { width: '200px' } },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'code' }),
	        _lodash2.default.toUpper(discountCode)
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Label,
	        { basic: true, color: 'pink', style: { width: '250px' } },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle outline' }),
	        workflowStatus
	      )
	    )
	  );
	};
	
	HorizontalCollaborationCard.propTypes = {
	  discussionId: _propTypes2.default.string.isRequired,
	  instagramStatus: _propTypes2.default.string.isRequired,
	  facebookStatus: _propTypes2.default.string.isRequired,
	  twitterStatus: _propTypes2.default.string.isRequired,
	  youtubeStatus: _propTypes2.default.string.isRequired,
	  campaignId: _propTypes2.default.string.isRequired,
	  influencerName: _propTypes2.default.string.isRequired,
	  totalAssets: _propTypes2.default.number.isRequired,
	  totalStories: _propTypes2.default.number.isRequired,
	  thumbnail: _propTypes2.default.string.isRequired,
	  primarySocialHandle: _propTypes2.default.string.isRequired,
	  invitationStatus: _propTypes2.default.string.isRequired,
	  email: _propTypes2.default.string.isRequired,
	  isEmailValid: _propTypes2.default.bool.isRequired,
	  isLiveCampaign: _propTypes2.default.bool.isRequired,
	  instagramPrivate: _propTypes2.default.bool.isRequired,
	  router: _propTypes2.default.object.isRequired,
	  lastScannedDate: _propTypes2.default.string.isRequired,
	  lastSuccessfulStoryScan: _propTypes2.default.string.isRequired,
	  userInfo: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_reactRouter.withRouter, _hasUserInfo2.default)(HorizontalCollaborationCard);

/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = { color: 'gray' };
	
	var HowToCloseModal = function HowToCloseModal() {
	  return _react2.default.createElement(
	    'p',
	    { style: style },
	    'press escape or click the x to cancel'
	  );
	};
	
	exports.default = HowToCloseModal;

/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageModal = function (_React$Component) {
	  _inherits(ImageModal, _React$Component);
	
	  function ImageModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ImageModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageModal.__proto__ || Object.getPrototypeOf(ImageModal)).call.apply(_ref, [this].concat(args))), _this), _this.onOutsideClick = function (event) {
	      var isClickInside = _this.refs.image_modal_content.contains(event.target);
	      if (!isClickInside) {
	        _this.props.onClear();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ImageModal, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          url = _props.url,
	          alt = _props.alt;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "image-modal", onClick: this.onOutsideClick },
	        _react2.default.createElement("img", { src: url, alt: alt, ref: "image_modal_content" })
	      );
	    }
	  }]);
	
	  return ImageModal;
	}(_react2.default.Component);
	
	ImageModal.propTypes = {
	  onClear: _react2.default.PropTypes.func.isRequired,
	  url: _react2.default.PropTypes.string.isRequired,
	  alt: _react2.default.PropTypes.string.isRequired
	};
	
	exports.default = ImageModal;

/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Image = function (_Component) {
	  _inherits(Image, _Component);
	
	  function Image(props) {
	    _classCallCheck(this, Image);
	
	    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));
	
	    _this.state = {
	      imageStatus: 'loading',
	      imageUrl: _this.props.imageUrl
	    };
	    return _this;
	  }
	
	  _createClass(Image, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.imageUrl !== this.state.imageUrl) {
	        this.setState({
	          loaded: false,
	          imageUrl: nextProps.imageUrl
	        });
	      }
	    }
	  }, {
	    key: 'handleImageLoaded',
	    value: function handleImageLoaded() {
	      this.setState({ loaded: true });
	    }
	  }, {
	    key: 'handleImageErrored',
	    value: function handleImageErrored() {
	      this.setState({ loaded: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var imageUrl = this.props.imageUrl;
	      var loaded = this.state.loaded;
	
	
	      return _react2.default.createElement('img', {
	        className: 'image-component ' + (loaded && 'loaded'),
	        src: imageUrl,
	        onLoad: this.handleImageLoaded.bind(this),
	        onError: this.handleImageErrored.bind(this)
	      });
	    }
	  }]);
	
	  return Image;
	}(_react.Component);
	
	exports.default = Image;

/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _influencerTableSettings = __webpack_require__(549);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var greenLinkStyle = {
	  color: '#20c49e',
	  cursor: 'pointer'
	};
	
	var redLinkStyle = {
	  color: '#ef3a50',
	  cursor: 'pointer'
	};
	
	var greyLinkStyle = {
	  color: 'grey',
	  cursor: 'not-allowed'
	};
	
	var clippedDropdownFix = {
	  overflow: 'visible'
	};
	
	var PER_PAGE = 25;
	var ALWAYS_VISIBLE_COLUMNS = 5;
	
	var InfluencerActions = function InfluencerActions(props) {
	  var reportUrls = props.reportUrls,
	      shortlists = props.shortlists,
	      count = props.count,
	      onCheckAll = props.onCheckAll,
	      onDelete = props.onDelete,
	      onSaveShortlist = props.onSaveShortlist,
	      onShortlistPatch = props.onShortlistPatch,
	      columns = props.columnsSettings.columns;
	
	  var _ThemeSelector$theme = _themeSelector2.default.theme(),
	      hideInfluencerImportExport = _ThemeSelector$theme.hideInfluencerImportExport;
	
	  var exportLinkStyle = reportUrls && reportUrls.xlsx ? greenLinkStyle : greyLinkStyle;
	  var displayedColumns = ALWAYS_VISIBLE_COLUMNS + _influencerTableSettings.OPTIONAL_COLUMN_COUNT - _lodash2.default.filter(_lodash2.default.values(columns), function (_ref) {
	    var displayed = _ref.displayed;
	    return !displayed;
	  }).length;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { verticalAlign: 'middle', textAlign: 'center', width: 1, colSpan: 1 },
	      _react2.default.createElement(_semanticUiReact.Checkbox, { checked: PER_PAGE === count, onChange: onCheckAll })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { width: 4, colSpan: 1 },
	      count,
	      ' selected'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { width: 11, colSpan: displayedColumns - 2, style: clippedDropdownFix },
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 4 },
	          _react2.default.createElement(
	            _semanticUiReact.Dropdown,
	            {
	              text: 'shortlists',
	              labeled: true,
	              button: true,
	              icon: 'clipboard',
	              fluid: true,
	              className: 'icon tiny pink ui button'
	            },
	            _react2.default.createElement(
	              _semanticUiReact.Dropdown.Menu,
	              null,
	              _react2.default.createElement(_semanticUiReact.Dropdown.Item, {
	                content: 'new shortlist...',
	                icon: 'plus',
	                onClick: onSaveShortlist
	              }),
	              _react2.default.createElement(_semanticUiReact.Dropdown.Divider, null),
	              _react2.default.createElement(_semanticUiReact.Dropdown.Header, { icon: 'clipboard', content: 'existing shortlist' }),
	              _react2.default.createElement(
	                _semanticUiReact.Dropdown.Menu,
	                { scrolling: true },
	                _lodash2.default.map(shortlists, function (list) {
	                  return _react2.default.createElement(_semanticUiReact.Dropdown.Item, {
	                    key: list.id,
	                    text: list.name,
	                    value: list.id,
	                    onClick: onShortlistPatch,
	                    icon: 'clipboard'
	                  });
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 4, textAlign: 'center' },
	          !hideInfluencerImportExport && _react2.default.createElement(
	            'a',
	            {
	              href: reportUrls && reportUrls.xlsx ? reportUrls.xlsx : '#',
	              style: exportLinkStyle
	            },
	            _react2.default.createElement(
	              _semanticUiReact.Icon.Group,
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'cloud download' }),
	              'export'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 4, textAlign: 'center' },
	          !hideInfluencerImportExport && _react2.default.createElement(
	            'a',
	            {
	              rel: 'noopener noreferrer',
	              target: '_blank',
	              style: greenLinkStyle,
	              href: 'https://dyzio.co/adding-your-influencers-by-spreadsheet'
	            },
	            _react2.default.createElement(
	              _semanticUiReact.Icon.Group,
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'cloud upload' }),
	              'import'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 4, textAlign: 'right' },
	          _react2.default.createElement(
	            'a',
	            {
	              style: redLinkStyle,
	              onClick: onDelete
	            },
	            _react2.default.createElement(
	              _semanticUiReact.Icon.Group,
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'delete' }),
	              'delete'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	InfluencerActions.propTypes = {
	  onDelete: _propTypes2.default.func.isRequired,
	  onCheckAll: _propTypes2.default.func.isRequired,
	  count: _propTypes2.default.number.isRequired,
	  shortlists: _propTypes2.default.array.isRequired,
	  onSaveShortlist: _propTypes2.default.func.isRequired,
	  onShortlistPatch: _propTypes2.default.func.isRequired,
	  reportUrls: _propTypes2.default.object.isRequired,
	  columnsSettings: _propTypes2.default.object.isRequired
	};
	
	exports.default = InfluencerActions;

/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var atMentionRegex = /(@\w+\b)/g;
	
	var GridLayout = function GridLayout(_ref) {
	  var items = _ref.items;
	  return _react2.default.createElement(
	    _semanticUiReact.Feed,
	    { style: { maxHeight: '600px', overflowY: 'scroll' } },
	    _lodash2.default.map(items, function (item) {
	      var post = item.postData;
	      // if (!post || !item.isAd) return null;
	
	      var relativeTime = post && (0, _moment2.default)(post.date * 1000).fromNow();
	      var atMatches = post && _lodash2.default.uniqBy(post.caption.match(atMentionRegex));
	
	      if (!item.isAd) return null;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Feed.Event,
	        { style: { border: '1px solid #eee', margin: '5px 0px', padding: '10px' } },
	        _react2.default.createElement(
	          _semanticUiReact.Feed.Label,
	          null,
	          _react2.default.createElement(_semanticUiReact.Image, { src: post && post.display_src })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Feed.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Feed.Summary,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Feed.User,
	              null,
	              item.handle
	            ),
	            ' added a new sponsored post on INSTAGRAM!',
	            _react2.default.createElement(
	              _semanticUiReact.Feed.Date,
	              null,
	              relativeTime
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  ref: 'noreferrer noopener',
	                  target: '_blank',
	                  href: 'https://www.instagram.com/p/' + item.instagramCode + '/'
	                },
	                'https://www.instagram.com/p/' + item.instagramCode + '/'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Feed.Extra,
	            { text: true },
	            _react2.default.createElement(
	              'p',
	              null,
	              item.isAd && _react2.default.createElement(_semanticUiReact.Icon, { name: 'money', color: 'pink', size: 'large' })
	            ),
	            post && _lodash2.default.truncate(post.caption, { length: 200, separator: ' ' })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Feed.Meta,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Feed.Like,
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'heart' }),
	              post && post.likes.count
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Feed.Like,
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment' }),
	              post && post.comments.count
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Feed.Extra,
	            { text: true },
	            atMatches && _lodash2.default.map(atMatches, function (handle) {
	              return _react2.default.createElement(_semanticUiReact.Label, { color: 'pink', basic: true, content: handle });
	            })
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = GridLayout;

/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dataFetchError = __webpack_require__(541);
	
	var _dataFetchError2 = _interopRequireDefault(_dataFetchError);
	
	var _authService = __webpack_require__(21);
	
	var _gridLayout = __webpack_require__(1953);
	
	var _gridLayout2 = _interopRequireDefault(_gridLayout);
	
	var _listLayout = __webpack_require__(1955);
	
	var _listLayout2 = _interopRequireDefault(_listLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfluencerAdPosts = function (_React$Component) {
	  _inherits(InfluencerAdPosts, _React$Component);
	
	  function InfluencerAdPosts() {
	    _classCallCheck(this, InfluencerAdPosts);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerAdPosts.__proto__ || Object.getPrototypeOf(InfluencerAdPosts)).call(this));
	
	    _this.state = { items: [], loading: true, layout: 'list', allPosts: false, smallImages: true };
	
	    _this.getSaturationLevel = function (saturation) {
	      if (saturation < 0.25) return 'green';
	      if (saturation < 0.5) return 'orange';
	      return 'red';
	    };
	
	    var token = _authService.authService.getToken();
	    var newsfeedApi = ("https://b7o8doqzfb.execute-api.eu-west-1.amazonaws.com/production");
	    _this.api = _axios2.default.create({
	      baseURL: newsfeedApi,
	      timeout: 5000,
	      headers: {
	        Authorization: 'Bearer ' + token
	      }
	    });
	    return _this;
	  }
	
	  _createClass(InfluencerAdPosts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var influencer = this.props.influencer;
	
	      var handle = influencer.instagram;
	      this.api.get('/handle/' + handle).then(function (response) {
	        var items = response.data.data.items;
	
	        _this2.setState({
	          items: items,
	          loading: false
	        });
	      }).catch(function (error) {
	        _this2.setState({
	          error: error,
	          loading: false
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          layout = _state.layout,
	          allPosts = _state.allPosts,
	          smallImages = _state.smallImages;
	      var _state2 = this.state,
	          items = _state2.items,
	          loading = _state2.loading,
	          error = _state2.error;
	
	
	      var totalPosts = items.length;
	      var numberOfAds = _lodash2.default.filter(items, function (item) {
	        return item.isAd;
	      }).length;
	      var saturation = numberOfAds / totalPosts;
	      var saturationFormatted = (0, _numeral2.default)(saturation).format('0.0%');
	      var saturationLevel = this.getSaturationLevel(saturation);
	
	      var imageSizeContent = 'Currently showing posts with ' + (smallImages ? 'small' : 'large') + ' images';
	      var adPostsContent = 'Currently showing ' + (allPosts ? 'all' : 'only #ad') + ' posts';
	
	      var SaturationInfo = function SaturationInfo() {
	        return _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'help circle outline', color: 'blue' }),
	          content: '#ad saturation is calculated by dividing number of #ad posts by total number of posts'
	        });
	      };
	
	      var pLeft = {
	        fontSize: '90%',
	        fontWeight: 'bold',
	        display: 'inline-block',
	        width: '365px'
	      };
	
	      var pCenter = _lodash2.default.assign({
	        textAlign: 'center'
	      }, pLeft);
	
	      var pRight = _lodash2.default.assign({
	        textAlign: 'right'
	      }, pLeft);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-content' },
	        _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { basic: true, loading: loading },
	          _react2.default.createElement(
	            _semanticUiReact.Card,
	            { fluid: true },
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Button.Group,
	                { floated: 'right' },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    _semanticUiReact.Button,
	                    {
	                      toggle: true,
	                      active: smallImages,
	                      icon: true,
	                      onClick: function onClick() {
	                        return _this3.setState({ smallImages: !smallImages });
	                      }
	                    },
	                    smallImages ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'list layout' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'image' })
	                  ),
	                  content: imageSizeContent
	                }),
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    _semanticUiReact.Button,
	                    { toggle: true, active: !allPosts, icon: true, onClick: function onClick() {
	                        return _this3.setState({ allPosts: !allPosts });
	                      } },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'money' })
	                  ),
	                  content: adPostsContent
	                })
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: pLeft },
	                'Out of the last ',
	                totalPosts,
	                ' Instagram posts, ',
	                numberOfAds,
	                ' were tagged #ad.'
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: pCenter },
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { basic: true, color: 'grey' },
	                  '#ad saturation\xA0',
	                  _react2.default.createElement(SaturationInfo, null)
	                ),
	                ' = ',
	                _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: saturationLevel, content: saturationFormatted })
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: pRight },
	                'Toggle to view all posts and adjust view settings ',
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right' })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              layout === 'grid' && _react2.default.createElement(_gridLayout2.default, { items: items }),
	              layout === 'list' && _react2.default.createElement(_listLayout2.default, { items: items, allPosts: allPosts, smallImages: smallImages }),
	              error && _react2.default.createElement(_dataFetchError2.default, { dataDescription: 'newsfeed data', iconSize: 'massive', error: error })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencerAdPosts;
	}(_react2.default.Component);
	
	exports.default = InfluencerAdPosts;

/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _instagram = __webpack_require__(2378);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	var atMentionRegex = /(@\w+\b)/g;
	
	var ListLayout = function ListLayout(_ref) {
	  var items = _ref.items,
	      allPosts = _ref.allPosts,
	      smallImages = _ref.smallImages;
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { celled: true, fluid: true, basic: 'very', textAlign: 'center' },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Header,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Platform'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          '#ad?'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Post'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { textAlign: 'left' },
	          'Text'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Published'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Likes'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Comments'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Brand'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _lodash2.default.map(items, function (item) {
	        var post = (0, _instagram.mapPostData)(item.postData);
	        if (!allPosts && !item.isAd) return null;
	
	        var relativeTime = post && (0, _moment2.default)(post.date * 1000).fromNow();
	        var atMatches = post && _lodash2.default.uniqBy(post.caption.match(atMentionRegex));
	
	        var imageSize = smallImages ? 'tiny' : 'medium';
	        var captionLength = smallImages ? 500 : 1000;
	
	        return _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink', size: 'big' })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            item.isAd && _react2.default.createElement(_semanticUiReact.Icon, { name: 'money', color: 'green', size: 'big' })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.instagram.com/p/' + item.instagramCode + '/',
	                target: '_blank',
	                rel: 'noopener noreferrer'
	              },
	              _react2.default.createElement(_semanticUiReact.Image, { size: imageSize, src: post && post.display_src })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { textAlign: 'left' },
	            post && _lodash2.default.truncate(post.caption, { length: captionLength, separator: ' ' })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            relativeTime
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            post && cf(post.likes.count)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            post && cf(post.comments.count)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            atMatches && _lodash2.default.map(atMatches, function (handle) {
	              return _react2.default.createElement(_semanticUiReact.Label, { color: 'pink', basic: true, content: handle });
	            })
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = ListLayout;

/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFacebookAuthorisationLink = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _formatting = __webpack_require__(62);
	
	var _confirmationQuestion = __webpack_require__(1919);
	
	var _confirmationQuestion2 = _interopRequireDefault(_confirmationQuestion);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ANALYTICS_USERS = ['d9013d29-506a-4ee7-b178-652fab37318e', '518f7135-6720-4e72-ae6a-23ad7e9074b2', '8fed9f11-f240-4101-b558-47deaf28a422', '31557883-9d94-40d6-aadf-a6b2acfcc349', 'b5ea5d47-8e4a-445a-9c17-8f0a69bfa90d'];
	
	var gridStyle = {
	  marginTop: 25,
	  textAlign: 'center'
	};
	
	var imageStyle = {
	  margin: '0 auto',
	  display: 'block',
	  boxShadow: '0 0 10px #777'
	};
	
	var nameStyle = {
	  padding: 10
	};
	
	var descriptionStyle = {
	  color: '#999'
	};
	
	var cardStyle = {
	  paddingTop: 25,
	  minHeight: 530
	};
	
	var platformColors = {
	  facebook: 'blue',
	  youtube: 'red',
	  twitter: 'blue',
	  instagram: 'pink'
	};
	
	var errorStyle = {
	  paddingTop: 170,
	  color: 'gray'
	};
	
	var SCOPES = {
	  facebook: ['manage_pages', 'instagram_manage_insights', 'instagram_basic', 'read_insights']
	};
	
	var COMMUNITY_PAGE_HELP_LINK = 'http://help.dyzio.co/en/articles/4063438-how-to-create-a-facebook-community-page-and-connect-it-to-instagram';
	var LINK_ACCOUNT_HELP_LINK = 'http://help.dyzio.co/en/articles/4044324-how-to-link-your-instagram-account-to-your-facebook-fan-page';
	
	var CONFIRMATION_STATES = {
	  NO_CONFIRMATION_NEEDED: 'NO_CONFIRMATION_NEEDED',
	  FAN_PAGE_UNKNOWN: 'FAN_PAGE_UNKNOWN',
	  FAN_PAGE_UNCONFIRMED: 'FAN_PAGE_UNCONFIRMED',
	  ACCOUNT_CONNECTED_UNKNOWN: 'ACCOUNT_CONNECTED_UNKNOWN',
	  ACCOUNT_CONNECTED_UNCONFIRMED: 'ACCOUNT_CONNECTED_UNCONFIRMED',
	  READY_TO_BE_SENT_TO_FACEBOOK: 'READY_TO_BE_SENT_TO_FACEBOOK'
	};
	
	var getFacebookAuthorisationLink = exports.getFacebookAuthorisationLink = function getFacebookAuthorisationLink(_ref) {
	  var platform = _ref.platform,
	      id = _ref.id,
	      callbackUrl = _ref.callbackUrl;
	
	  var state = '{"influencerId":"' + id + '","callbackURL":"' + callbackUrl + '","platform":"' + platform + '"}';
	  var encodedState = encodeURIComponent(state);
	  var BASE_URL = 'https://www.facebook.com/v3.3/dialog/oauth';
	
	  var fields = {
	    client_id: 307083449705342,
	    response_type: 'code',
	    redirect_uri: 'https://uiqcrs8dhb.execute-api.eu-west-1.amazonaws.com/production/callback/facebook',
	    scope: _lodash2.default.join(SCOPES.facebook, ','),
	    auth_type: 'rerequest',
	    state: encodedState
	  };
	
	  return BASE_URL + '?client_id=' + fields.client_id + '&response_type=' + fields.response_type + '&redirect_uri=' + fields.redirect_uri + '&scope=' + fields.scope + '&auth_type=rerequest&state=' + encodedState;
	};
	
	var authorisePlatform = function authorisePlatform(_ref2) {
	  var platform = _ref2.platform,
	      id = _ref2.id;
	
	  var host = _lodash2.default.get(window, 'origin', 'https://app.dyzio.co');
	  switch (platform) {
	    case 'facebook':
	    case 'instagram':
	      window.location.href = getFacebookAuthorisationLink({ platform: platform, id: id, callbackUrl: host + '/token-thanks' });
	      break;
	    default:
	      break;
	  }
	};
	
	var InfluencerAuthorisationCard = function (_Component) {
	  _inherits(InfluencerAuthorisationCard, _Component);
	
	  function InfluencerAuthorisationCard(props) {
	    _classCallCheck(this, InfluencerAuthorisationCard);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerAuthorisationCard.__proto__ || Object.getPrototypeOf(InfluencerAuthorisationCard)).call(this, props));
	
	    _this.onAuthoriseButtonClick = function (_ref3) {
	      var platform = _ref3.platform,
	          id = _ref3.id;
	
	      var shouldConfirm = _lodash2.default.includes(['facebook', 'instagram'], platform);
	      if (!shouldConfirm) {
	        authorisePlatform({ platform: platform, id: id });
	      } else {
	        _this.setState({
	          confirmationState: CONFIRMATION_STATES.FAN_PAGE_UNKNOWN,
	          platform: platform,
	          id: id
	        });
	      }
	    };
	
	    _this.handleConfirmation = function () {
	      var _this$state = _this.state,
	          platform = _this$state.platform,
	          id = _this$state.id;
	
	      authorisePlatform({ platform: platform, id: id });
	    };
	
	    _this.authoriseAnalytics = function () {
	      var influencerId = _this.props.id;
	      var origin = window.location.origin;
	
	      var callbackURL = origin + '/token-thanks';
	      _axios2.default.post('https://uiqcrs8dhb.execute-api.eu-west-1.amazonaws.com/production/oauth/analytics/url', {
	        data: {
	          influencerId: influencerId,
	          callbackURL: callbackURL
	        }
	      }).then(function (r) {
	        window.location.href = r.data.headers.Location;
	      });
	    };
	
	    _this.authoriseYoutube = function (influencerId) {
	      var host = _lodash2.default.get(window, 'origin', 'https://app.dyzio.co');
	
	      _axios2.default.post('https://uiqcrs8dhb.execute-api.eu-west-1.amazonaws.com/production/oauth/youtube/url', {
	        data: {
	          influencerId: influencerId,
	          callbackURL: host + '/token-thanks'
	        }
	      }).then(function (r) {
	        window.location.href = r.data.headers.Location;
	      });
	    };
	
	    _this.state = {
	      confirmationState: CONFIRMATION_STATES.NO_CONFIRMATION_NEEDED
	    };
	    return _this;
	  }
	
	  _createClass(InfluencerAuthorisationCard, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          influencerId = _props.id,
	          name = _props.name,
	          primarySocialHandle = _props.primarySocialHandle,
	          thumbnail = _props.thumbnail,
	          youtube = _props.youtube,
	          facebook = _props.facebook,
	          instagram = _props.instagram,
	          twitter = _props.twitter,
	          facebookCount = _props.facebookCount,
	          twitterCount = _props.twitterCount,
	          instagramCount = _props.instagramCount,
	          youtubeCount = _props.youtubeCount,
	          isLoading = _props.isLoading,
	          isFacebookPersonalPage = _props.isFacebookPersonalPage,
	          isError = _props.isError;
	      var confirmationState = this.state.confirmationState;
	
	
	      var shouldRenderChannelsList = _lodash2.default.eq(CONFIRMATION_STATES.NO_CONFIRMATION_NEEDED, confirmationState);
	
	      var shouldRenderFanPageConfirmation = _lodash2.default.includes([CONFIRMATION_STATES.FAN_PAGE_UNKNOWN, CONFIRMATION_STATES.FAN_PAGE_UNCONFIRMED], confirmationState);
	
	      var shouldRenderAccountConnected = _lodash2.default.includes([CONFIRMATION_STATES.ACCOUNT_CONNECTED_UNKNOWN, CONFIRMATION_STATES.ACCOUNT_CONNECTED_UNCONFIRMED], confirmationState);
	
	      var shouldRenderFacebookMessage = _lodash2.default.includes([CONFIRMATION_STATES.READY_TO_BE_SENT_TO_FACEBOOK], confirmationState);
	
	      var isFanPageNotConfirmed = _lodash2.default.eq(CONFIRMATION_STATES.FAN_PAGE_UNCONFIRMED, confirmationState);
	      var isAccountNotConnected = _lodash2.default.eq(CONFIRMATION_STATES.ACCOUNT_CONNECTED_UNCONFIRMED, confirmationState);
	
	      var channels = [{ handle: facebook, platform: 'facebook', count: facebookCount, color: 'blue', id: influencerId }, { handle: twitter, platform: 'twitter', count: twitterCount, color: 'blue', id: influencerId }, { handle: instagram, platform: 'instagram', count: instagramCount, color: 'purple', id: influencerId }, { handle: youtube, platform: 'youtube', count: youtubeCount, color: 'red', id: influencerId }];
	
	      var isAnalyticsUser = _lodash2.default.includes(ANALYTICS_USERS, influencerId);
	
	      return _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { container: true, style: gridStyle },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(_semanticUiReact.Grid.Column, { computer: 5, only: 'computer' }),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { computer: 6, mobile: 16 },
	            _react2.default.createElement(
	              _semanticUiReact.Card,
	              { fluid: true, style: cardStyle },
	              isLoading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading...' }),
	              isError && _react2.default.createElement(
	                _semanticUiReact.Header,
	                { as: 'h4', icon: true, style: errorStyle },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'frown' }),
	                'Something went wrong. Please try again later.'
	              ),
	              !isLoading && !isError && _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                null,
	                _react2.default.createElement(_semanticUiReact.Image, {
	                  style: imageStyle,
	                  className: 'circular',
	                  size: 'small',
	                  src: thumbnail
	                }),
	                _react2.default.createElement(
	                  'h3',
	                  { style: nameStyle },
	                  name
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { style: descriptionStyle },
	                  primarySocialHandle || '-'
	                ),
	                _react2.default.createElement(_semanticUiReact.Divider, null),
	                shouldRenderFacebookMessage && _react2.default.createElement(_confirmationQuestion2.default, {
	                  onReset: function onReset() {
	                    return _this2.handleConfirmation();
	                  },
	                  onPositive: _lodash2.default.noop,
	                  onNegative: _lodash2.default.noop,
	                  question: '',
	                  explanationButtonText: 'Authorise',
	                  shouldRenderExplanation: true,
	                  explanation: _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'You will now be sent to Facebook to authorise access to your account. '
	                    ),
	                    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'The access is readonly. Please do not remove any of the permissions or it will not work.'
	                    )
	                  )
	                }),
	                shouldRenderAccountConnected && _react2.default.createElement(_confirmationQuestion2.default, {
	                  onNegative: function onNegative() {
	                    return _this2.setState({
	                      confirmationState: CONFIRMATION_STATES.ACCOUNT_CONNECTED_UNCONFIRMED
	                    });
	                  },
	                  onReset: function onReset() {
	                    return _this2.setState({
	                      confirmationState: CONFIRMATION_STATES.ACCOUNT_CONNECTED_UNKNOWN
	                    });
	                  },
	                  onPositive: function onPositive() {
	                    return _this2.setState({
	                      confirmationState: CONFIRMATION_STATES.READY_TO_BE_SENT_TO_FACEBOOK
	                    });
	                  },
	                  question: _react2.default.createElement(
	                    'span',
	                    null,
	                    'Is your Instagram account',
	                    _react2.default.createElement('br', null),
	                    ' linked to it?'
	                  ),
	                  explanation: _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Your Instagram account must be linked to your Community Page.'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Click ',
	                      _react2.default.createElement(
	                        _targetLink2.default,
	                        { renderIf: true, href: LINK_ACCOUNT_HELP_LINK },
	                        'here'
	                      ),
	                      ' to find out more.'
	                    )
	                  ),
	                  shouldRenderExplanation: isAccountNotConnected
	                }),
	                shouldRenderFanPageConfirmation && _react2.default.createElement(_confirmationQuestion2.default, {
	                  onNegative: function onNegative() {
	                    return _this2.setState({
	                      confirmationState: CONFIRMATION_STATES.FAN_PAGE_UNCONFIRMED
	                    });
	                  },
	                  onReset: function onReset() {
	                    return _this2.setState({
	                      confirmationState: CONFIRMATION_STATES.FAN_PAGE_UNKNOWN
	                    });
	                  },
	                  onPositive: function onPositive() {
	                    return _this2.setState({
	                      confirmationState: CONFIRMATION_STATES.ACCOUNT_CONNECTED_UNKNOWN
	                    });
	                  },
	                  question: _react2.default.createElement(
	                    'span',
	                    null,
	                    'Do you have a ',
	                    _react2.default.createElement('br', null),
	                    'Facebook Community Page?'
	                  ),
	                  explanation: _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'You must have a Facebook Community page to authorise the system to fetch your Instagram Insights data.'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Use this ',
	                      _react2.default.createElement(
	                        _targetLink2.default,
	                        { href: COMMUNITY_PAGE_HELP_LINK, renderIf: true },
	                        'link'
	                      ),
	                      ' to find out how to set one up. ',
	                      _react2.default.createElement('br', null),
	                      'It',
	                      '\'',
	                      's a good thing!'
	                    )
	                  ),
	                  shouldRenderExplanation: isFanPageNotConfirmed
	                }),
	                shouldRenderChannelsList && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    { singleLine: true, unstackable: true },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Body,
	                      null,
	                      _lodash2.default.map(channels, function (_ref4) {
	                        var handle = _ref4.handle,
	                            platform = _ref4.platform,
	                            count = _ref4.count;
	                        return _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          { key: platform },
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            _react2.default.createElement(_semanticUiReact.Icon, { name: platform, color: platformColors[platform] })
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            handle
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            { textAlign: 'center' },
	                            (0, _formatting.countFormat)(count)
	                          ),
	                          isFacebookPersonalPage && _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            { textAlign: 'right' },
	                            platform === 'facebook' && _react2.default.createElement(_semanticUiReact.Popup, {
	                              content: 'This is a personal page. Your instagram account must be linked to a Community page.',
	                              trigger: _react2.default.createElement(_semanticUiReact.Icon, {
	                                size: 'small',
	                                className: 'circular',
	                                color: 'red',
	                                name: 'warning',
	                                inverted: true
	                              })
	                            })
	                          )
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Divider, null),
	                  _react2.default.createElement(
	                    _semanticUiReact.List,
	                    { verticalAlign: 'middle' },
	                    _lodash2.default.map(_lodash2.default.filter(channels, ['platform', 'instagram']), function (_ref5) {
	                      var platform = _ref5.platform,
	                          id = _ref5.id,
	                          color = _ref5.color;
	                      return _react2.default.createElement(
	                        _semanticUiReact.List.Item,
	                        { key: platform + '-' + id },
	                        _react2.default.createElement(
	                          _semanticUiReact.Button,
	                          {
	                            fluid: true,
	                            icon: true,
	                            onClick: function onClick() {
	                              return _this2.onAuthoriseButtonClick({ platform: platform, id: id });
	                            },
	                            color: color,
	                            labelPosition: 'left'
	                          },
	                          _react2.default.createElement(_semanticUiReact.Icon, { name: platform }),
	                          ' Authorise ',
	                          _lodash2.default.upperFirst(platform),
	                          ' (readonly)'
	                        )
	                      );
	                    }),
	                    youtube && _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement('hr', null),
	                      _react2.default.createElement(
	                        _semanticUiReact.Button,
	                        {
	                          fluid: true,
	                          icon: true,
	                          onClick: function onClick() {
	                            return _this2.authoriseYoutube(influencerId);
	                          },
	                          color: 'red',
	                          labelPosition: 'left'
	                        },
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube' }),
	                        ' Authorise YouTube (readonly)'
	                      )
	                    ),
	                    isAnalyticsUser && _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement('hr', null),
	                      _react2.default.createElement(
	                        _semanticUiReact.Button,
	                        {
	                          fluid: true,
	                          icon: true,
	                          onClick: this.authoriseAnalytics,
	                          color: 'red',
	                          labelPosition: 'left'
	                        },
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'google' }),
	                        ' Authorise Google Analytics (readonly)'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_semanticUiReact.Grid.Column, { computer: 5, only: 'computer' })
	        )
	      );
	    }
	  }]);
	
	  return InfluencerAuthorisationCard;
	}(_react.Component);
	
	InfluencerAuthorisationCard.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  primarySocialHandle: _propTypes2.default.string.isRequired,
	  thumbnail: _propTypes2.default.string.isRequired,
	  youtube: _propTypes2.default.string.isRequired,
	  facebook: _propTypes2.default.string.isRequired,
	  instagram: _propTypes2.default.string.isRequired,
	  twitter: _propTypes2.default.string.isRequired,
	  facebookCount: _propTypes2.default.string.isRequired,
	  twitterCount: _propTypes2.default.string.isRequired,
	  instagramCount: _propTypes2.default.string.isRequired,
	  youtubeCount: _propTypes2.default.string.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  isError: _propTypes2.default.bool.isRequired,
	  isFacebookPersonalPage: _propTypes2.default.bool
	};
	
	InfluencerAuthorisationCard.defaultProps = {
	  isFacebookPersonalPage: false
	};
	
	exports.default = InfluencerAuthorisationCard;

/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _blogosphereDetails = __webpack_require__(1896);
	
	var _blogosphereDetails2 = _interopRequireDefault(_blogosphereDetails);
	
	var _blogosphereRateCard = __webpack_require__(1897);
	
	var _blogosphereRateCard2 = _interopRequireDefault(_blogosphereRateCard);
	
	var _blogosphereCollaborationsTypes = __webpack_require__(1895);
	
	var _blogosphereCollaborationsTypes2 = _interopRequireDefault(_blogosphereCollaborationsTypes);
	
	var _blogosphereRawData = __webpack_require__(1898);
	
	var _blogosphereRawData2 = _interopRequireDefault(_blogosphereRawData);
	
	var _blogosphereBlogDetails = __webpack_require__(1894);
	
	var _blogosphereBlogDetails2 = _interopRequireDefault(_blogosphereBlogDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfluencerBlogosphere = function (_Component) {
	  _inherits(InfluencerBlogosphere, _Component);
	
	  function InfluencerBlogosphere() {
	    _classCallCheck(this, InfluencerBlogosphere);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerBlogosphere.__proto__ || Object.getPrototypeOf(InfluencerBlogosphere)).call(this));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(InfluencerBlogosphere, [{
	    key: 'render',
	    value: function render() {
	      var blogosphereData = this.props.influencerDetails.blogosphereData;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-content' },
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { columns: 2, equal: true },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              null,
	              _react2.default.createElement(_blogosphereDetails2.default, { details: blogosphereData })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              null,
	              _react2.default.createElement(_blogosphereRateCard2.default, { details: blogosphereData }),
	              _react2.default.createElement(_blogosphereCollaborationsTypes2.default, { details: blogosphereData }),
	              _react2.default.createElement(_blogosphereBlogDetails2.default, { details: blogosphereData })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              null,
	              _react2.default.createElement(_blogosphereRawData2.default, { details: blogosphereData })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencerBlogosphere;
	}(_react.Component);
	
	InfluencerBlogosphere.propTypes = {
	  influencerDetails: _propTypes2.default.object.isRequired
	};
	
	exports.default = InfluencerBlogosphere;

/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _campaignTypeLabel = __webpack_require__(1910);
	
	var _campaignTypeLabel2 = _interopRequireDefault(_campaignTypeLabel);
	
	var _hashtags = __webpack_require__(1947);
	
	var _hashtags2 = _interopRequireDefault(_hashtags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatDate = function formatDate(date) {
	  return (0, _moment2.default)(date).format('DD/MM/Y');
	};
	var getFriendlyDate = function getFriendlyDate(date) {
	  return (0, _moment2.default)(date).format('Do MMM');
	};
	
	var InfluencerCampaignCard = function InfluencerCampaignCard(_ref) {
	  var _ref$campaign = _ref.campaign,
	      id = _ref$campaign.id,
	      name = _ref$campaign.name,
	      campaignType = _ref$campaign.campaignType,
	      hashtags = _ref$campaign.hashtags,
	      liveDate = _ref$campaign.liveDate,
	      endDate = _ref$campaign.endDate,
	      createdBy = _ref$campaign.createdBy,
	      createdDate = _ref$campaign.createdDate,
	      owner = _ref$campaign.owner,
	      _onClick = _ref.onClick;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { onClick: function onClick() {
	        return _onClick(id);
	      }, color: 'green' },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        name
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Meta,
	        null,
	        owner.name
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very' },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { textAlign: 'right' },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline', size: 'small' })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              'campaign type'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_campaignTypeLabel2.default, { campaignType: campaignType })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { textAlign: 'right' },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'tags', size: 'small' })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              'hashtags'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_hashtags2.default, { value: hashtags })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { textAlign: 'right' },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'calendar', size: 'small' })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              'posted between'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              formatDate(liveDate),
	              ' to ',
	              formatDate(endDate)
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'user' }),
	      'Created by ',
	      createdBy,
	      ' on ',
	      getFriendlyDate(createdDate)
	    )
	  );
	};
	
	InfluencerCampaignCard.propTypes = {
	  campaign: _propTypes2.default.object.isRequired,
	  onClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = InfluencerCampaignCard;

/***/ },
/* 1959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentTheme = _themeSelector2.default.theme();
	
	var hasNoAssets = function hasNoAssets(array) {
	  return _lodash2.default.isUndefined(_lodash2.default.find(array, function (i) {
	    return i > 0;
	  }));
	};
	var renderCurrency = function renderCurrency() {
	  return _lodash2.default.constant('USD');
	};
	var priceFormatted = function priceFormatted(number) {
	  return (0, _numeral2.default)(number).format('0,0[.]00');
	};
	var commaFormatted = function commaFormatted(number) {
	  var de = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	  return number ? (0, _numeral2.default)(number).format('0,0') : de;
	};
	
	var getGrade = function getGrade(percentile) {
	  if (percentile <= 0.1) return 'A+';
	  if (percentile <= 0.2) return 'A';
	  if (percentile <= 0.4) return 'B';
	  if (percentile <= 0.6) return 'C';
	  if (percentile <= 0.8) return 'D';
	  return 'E';
	};
	
	var avatarStyle = {
	  width: 100,
	  height: 100
	};
	
	var influencerNameStyle = {
	  fontSize: 16,
	  marginLeft: 8,
	  marginBottom: -4,
	  marginTop: 4,
	  width: '150px'
	};
	
	var influnecerHandleStyle = {
	  marginLeft: 8,
	  marginTop: 3,
	  color: 'gray'
	};
	
	var influnecerHandleStyle2 = {
	  marginLeft: 8,
	  marginTop: 3,
	  color: 'gray'
	};
	
	var textBoldStyle = {
	  fontWeight: 'bold'
	};
	
	var centeredText = null;
	var SHOW_INFLUENCER_FEE = false;
	
	var ReportTableHeader = function ReportTableHeader(_ref) {
	  var productDetails = _ref.productDetails;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Header,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      null,
	      productDetails ? 'product details' : 'influencer'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      null,
	      'assets'
	    ),
	    SHOW_INFLUENCER_FEE && _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { style: centeredText },
	      'influencer ',
	      _react2.default.createElement('br', null),
	      'fee'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { style: centeredText },
	      'total ',
	      _react2.default.createElement('br', null),
	      'reach'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { style: centeredText },
	      _react2.default.createElement(
	        'span',
	        null,
	        'total ',
	        _react2.default.createElement('br', null),
	        'imps'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { style: centeredText },
	      'video ',
	      _react2.default.createElement('br', null),
	      'views'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { style: centeredText },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          'total ',
	          _react2.default.createElement('br', null),
	          'engs'
	        ),
	        content: _react2.default.createElement(
	          'span',
	          null,
	          'total engagements:',
	          _react2.default.createElement('br', null),
	          ' likes + comments'
	        )
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { style: centeredText },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          'CQS'
	        ),
	        content: 'Content Quantity Score'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { style: centeredText },
	      'ENG RATE%'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { style: centeredText },
	      'RANK'
	    )
	  );
	};
	
	var RowAssets = function RowAssets(_ref2) {
	  var facebook = _ref2.facebook,
	      twitter = _ref2.twitter,
	      instagram = _ref2.instagram,
	      youtube = _ref2.youtube,
	      tiktok = _ref2.tiktok,
	      telegram = _ref2.telegram,
	      discussionId = _ref2.discussionId;
	
	  var noAssets = hasNoAssets([facebook.count, instagram.images, instagram.videos, instagram.stories, instagram.carousels, instagram.igtvs, instagram.reels, twitter.count, youtube.count, tiktok.count]);
	  var telegramCount = _lodash2.default.get(telegram, 'count', 0);
	  var noContent = noAssets && telegramCount === 0;
	  return _react2.default.createElement(
	    _semanticUiReact.List,
	    null,
	    noContent && _react2.default.createElement(
	      _semanticUiReact.List.Item,
	      null,
	      _react2.default.createElement(
	        'span',
	        { style: { color: 'gray' } },
	        'NO CONTENT YET'
	      )
	    ),
	    facebook && facebook.count > 0 && _react2.default.createElement(
	      _semanticUiReact.List.Item,
	      null,
	      facebook.count,
	      ' x ',
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook' }),
	      ' POST '
	    ),
	    instagram && instagram.images > 0 && _react2.default.createElement(
	      _semanticUiReact.List.Item,
	      null,
	      instagram.images,
	      ' x ',
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	      ' POST '
	    ),
	    instagram && instagram.videos > 0 && _react2.default.createElement(
	      _semanticUiReact.List.Item,
	      null,
	      instagram.videos,
	      ' x ',
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	      ' VIDEO '
	    ),
	    instagram && instagram.stories > 0 && _react2.default.createElement(
	      _semanticUiReact.List.Item,
	      null,
	      instagram.stories,
	      ' x ',
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	      ' STORY '
	    ),
	    instagram && instagram.carousels > 0 && _react2.default.createElement(
	      _semanticUiReact.List.Item,
	      null,
	      instagram.carousels,
	      ' x ',
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	      ' CAROUSEL '
	    ),
	    instagram && instagram.igtvs > 0 && _react2.default.createElement(
	      _semanticUiReact.List.Item,
	      null,
	      instagram.igtvs,
	      ' x ',
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	      ' IGTV '
	    ),
	    instagram && instagram.reels > 0 && _react2.default.createElement(
	      _semanticUiReact.List.Item,
	      null,
	      instagram.reels,
	      ' x ',
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	      ' REEL '
	    ),
	    twitter && twitter.count > 0 && _react2.default.createElement(
	      _semanticUiReact.List.Item,
	      null,
	      twitter.count,
	      ' x ',
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter' }),
	      ' TWEET '
	    ),
	    youtube && youtube.count > 0 && _react2.default.createElement(
	      _semanticUiReact.List.Item,
	      null,
	      youtube.count,
	      ' x ',
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube' }),
	      ' VIDEO '
	    ),
	    tiktok && tiktok.count > 0 && _react2.default.createElement(
	      _semanticUiReact.List.Item,
	      null,
	      tiktok.count,
	      ' x TT VIDEO '
	    ),
	    telegram && telegram.count > 0 && _react2.default.createElement(
	      _semanticUiReact.List.Item,
	      null,
	      telegram.count,
	      ' x ',
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram plane' }),
	      ' TELEGRAM'
	    ),
	    !noContent && _react2.default.createElement(
	      'a',
	      {
	        rel: 'noopener noreferrer',
	        href: currentTheme.shareSite + '/collab/' + discussionId + '/campaign',
	        target: '_blank'
	      },
	      'view content...'
	    )
	  );
	};
	
	var ReportRow = function ReportRow(_ref3) {
	  var id = _ref3.id,
	      name = _ref3.name,
	      thumbnail = _ref3.thumbnail,
	      influencerName = _ref3.influencerName,
	      instagramCount = _ref3.instagramCount,
	      budget = _ref3.budget,
	      derivedFee = _ref3.derivedFee,
	      _ref3$inventoryItems = _ref3.inventoryItems,
	      inventoryItems = _ref3$inventoryItems === undefined ? [] : _ref3$inventoryItems,
	      currency = _ref3.currency,
	      _ref3$totals = _ref3.totals,
	      reach = _ref3$totals.reach,
	      impressions = _ref3$totals.impressions,
	      engagements = _ref3$totals.engagements,
	      videoViews = _ref3$totals.videoViews,
	      _ref3$costs = _ref3.costs,
	      costPerEngagement = _ref3$costs.costPerEngagement,
	      impressionsCPM = _ref3$costs.impressionsCPM,
	      reachCPM = _ref3$costs.reachCPM,
	      viewsCPM = _ref3$costs.viewsCPM,
	      engsCPM = _ref3$costs.engsCPM,
	      trackedAssetsStats = _ref3.trackedAssetsStats,
	      contentQuantityRank = _ref3.contentQuantityRank,
	      contentQuantityScore = _ref3.contentQuantityScore,
	      totalInfluencers = _ref3.totalInfluencers,
	      productDetails = _ref3.productDetails,
	      discussionId = _ref3.discussionId;
	
	  var percentile = contentQuantityRank / totalInfluencers;
	  var grade = getGrade(percentile);
	
	  var instagram = trackedAssetsStats.instagram;
	
	
	  var engageableContentCount = _lodash2.default.sum([instagram.reels, instagram.igtvs, instagram.videos, instagram.carousels, instagram.images]);
	
	  var imageUrl = void 0;
	  if (productDetails) {
	    imageUrl = productDetails.imageUrl;
	  } else {
	    imageUrl = thumbnail;
	  }
	  var engagementRate = engagements / (engageableContentCount * instagramCount) * 100;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    { key: id },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: { backgroundColor: '#EEE' }, width: '4' },
	      _react2.default.createElement(
	        'table',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_semanticUiReact.Image, {
	              src: imageUrl,
	              className: 'circular',
	              style: avatarStyle,
	              size: 'large'
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'div',
	              { style: influencerNameStyle },
	              productDetails ? productDetails.name : influencerName
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { style: influnecerHandleStyle },
	              productDetails ? 'Gift RRP: ' + productDetails.retailPrice : name
	            ),
	            productDetails && false && _react2.default.createElement(
	              'div',
	              { style: influnecerHandleStyle2 },
	              'Gift Value: ',
	              productDetails.internalPrice
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { width: '3' },
	      _react2.default.createElement(RowAssets, Object.assign({}, trackedAssetsStats, { discussionId: discussionId }))
	    ),
	    SHOW_INFLUENCER_FEE && _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center' },
	      _lodash2.default.isEmpty(inventoryItems) && budget > 0 && _react2.default.createElement(
	        'span',
	        null,
	        renderCurrency(currency) + ' ' + priceFormatted(budget)
	      ),
	      _lodash2.default.isEmpty(inventoryItems) && !budget && '-',
	      !_lodash2.default.isEmpty(inventoryItems) && _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very', collapsing: true },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            'Fee'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            renderCurrency(currency),
	            ' ',
	            priceFormatted(budget)
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            'Gifts'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.List,
	              { textAlign: 'left' },
	              _lodash2.default.map(inventoryItems, function (item) {
	                return _react2.default.createElement(
	                  _semanticUiReact.List.Item,
	                  null,
	                  _lodash2.default.get(item, 'value'),
	                  ' (',
	                  renderCurrency(currency),
	                  ' ',
	                  _lodash2.default.get(item, 'monetaryValue'),
	                  ')'
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { style: textBoldStyle },
	            'Total'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { style: textBoldStyle },
	            renderCurrency(currency),
	            ' ',
	            derivedFee
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center', width: '1' },
	      reach ? commaFormatted(reach) : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center', width: '1' },
	      impressions ? commaFormatted(impressions) : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center', width: '1' },
	      videoViews ? commaFormatted(videoViews) : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center', width: '1' },
	      engagements ? commaFormatted(engagements) : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center', width: '1' },
	      _react2.default.createElement(
	        _semanticUiReact.Label,
	        { circular: true, color: 'pink' },
	        contentQuantityScore
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center', width: '1' },
	      engagementRate ? engagementRate.toFixed(2) + '%' : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center', width: '1' },
	      _react2.default.createElement(
	        'p',
	        null,
	        contentQuantityRank,
	        '/',
	        totalInfluencers
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Label,
	          null,
	          grade
	        )
	      )
	    )
	  );
	};
	
	var NoSummaryCard = function NoSummaryCard(_ref4) {
	  var name = _ref4.name,
	      id = _ref4.id,
	      createdBy = _ref4.createdBy,
	      liveDateString = _ref4.liveDateString,
	      endDateString = _ref4.endDateString,
	      router = _ref4.router;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        'table',
	        { width: '100%' },
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              name
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { color: 'grey' } },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'campaign owner: '
	              ),
	              ' ',
	              createdBy
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            { style: { color: 'gray' } },
	            _react2.default.createElement(
	              'p',
	              null,
	              'live date: ',
	              liveDateString
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'end date: ',
	              endDateString
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                floated: 'right',
	                circular: true,
	                inverted: true,
	                color: 'green',
	                icon: 'external alternate',
	                onClick: function onClick() {
	                  return window.open('/campaign/' + id + '/collaborations', '_blank');
	                }
	              }),
	              content: 'Open the ' + name + ' campaign in a new tab.'
	            }),
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                floated: 'right',
	                circular: true,
	                inverted: true,
	                color: 'pink',
	                icon: 'arrow alternate circle right',
	                onClick: function onClick() {
	                  return router.push('/campaign/' + id + '/collaborations');
	                }
	              }),
	              content: 'Open the ' + name + ' campaign.'
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        'No content summary available'
	      )
	    )
	  );
	};
	module.exports = {
	  ReportRow: ReportRow,
	  ReportTableHeader: ReportTableHeader,
	  NoSummaryCard: NoSummaryCard
	};

/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(37);
	
	var _uuid = __webpack_require__(832);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(1961);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _components = __webpack_require__(1959);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JOINED_FORMAT = 'MMMM Do YYYY, h:mm:ss a';
	
	var InfluencerCampaigns = function (_Component) {
	  _inherits(InfluencerCampaigns, _Component);
	
	  function InfluencerCampaigns(props) {
	    _classCallCheck(this, InfluencerCampaigns);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerCampaigns.__proto__ || Object.getPrototypeOf(InfluencerCampaigns)).call(this, props));
	
	    _this.getCampaignDateString = function (campaignDate) {
	      return campaignDate ? (0, _moment2.default)(campaignDate).format('ll') : 'error fetching date';
	    };
	
	    _this.state = {
	      loading: true,
	      error: '',
	      success: '',
	      invitations: [],
	      permissions: [],
	      discussions: []
	    };
	    return _this;
	  }
	
	  _createClass(InfluencerCampaigns, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({ success: '' });
	      var _props = this.props,
	          influencer = _props.influencer,
	          userInfo = _props.userInfo;
	
	
	      if (influencer && influencer.primarySocialHandle) {
	        (0, _utils.getDiscussions)(influencer.primarySocialHandle, userInfo).then(function (discussions) {
	          var loading = false;
	          _this2.setState({
	            loading: loading,
	            discussions: discussions
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          discussions = _state.discussions,
	          loading = _state.loading;
	      var _props2 = this.props,
	          influencer = _props2.influencer,
	          router = _props2.router;
	
	
	      var sortedDiscussions = _lodash2.default.orderBy(discussions, 'campaign.liveDate', 'desc');
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-content' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Influencer Campaign History'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { marginTop: 30, minHeight: 400 } },
	          loading && _react2.default.createElement(
	            'div',
	            { style: { marginTop: 50, color: 'gray' } },
	            _react2.default.createElement(
	              _semanticUiReact.Loader,
	              { active: true, inline: 'centered', size: 'massive' },
	              'Loading ',
	              influencer.name,
	              '\'s campaign history...'
	            )
	          ),
	          !loading && _lodash2.default.isEmpty(discussions) && _react2.default.createElement(
	            'h3',
	            { style: { textAlign: 'center', color: 'grey' } },
	            'No campaigns yet...'
	          ),
	          !loading && _lodash2.default.map(sortedDiscussions, function (d) {
	            var liveDateString = _this3.getCampaignDateString(_lodash2.default.get(d.campaign, 'liveDate', null));
	            var endDateString = _this3.getCampaignDateString(_lodash2.default.get(d.campaign, 'endDate', null));
	
	            if (!d.contentSummary) {
	              return _react2.default.createElement(_components.NoSummaryCard, {
	                name: d.campaign.name,
	                id: d.campaign.id,
	                createdBy: d.campaign.createdBy,
	                liveDateString: liveDateString,
	                endDateString: endDateString,
	                router: router
	              });
	            }
	
	            var campaignName = d.campaign.name || d.contentSummary.campaignName;
	            var productDetails = _lodash2.default.get(d.campaign, 'ecommerceSettings.productDetails');
	            return _react2.default.createElement(
	              _semanticUiReact.Card,
	              { fluid: true, color: 'pink' },
	              _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                null,
	                _react2.default.createElement(
	                  'table',
	                  { width: '100%' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        campaignName
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { style: { color: 'grey' } },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          'campaign owner: '
	                        ),
	                        ' ',
	                        d.campaign.createdBy
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { color: 'gray' } },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'live date: ',
	                        liveDateString
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'end date: ',
	                        endDateString
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(_semanticUiReact.Popup, {
	                        trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                          floated: 'right',
	                          circular: true,
	                          inverted: true,
	                          color: 'green',
	                          icon: 'external alternate',
	                          onClick: function onClick() {
	                            return window.open('/campaign/' + d.campaign.id + '/collaborations', '_blank');
	                          }
	                        }),
	                        content: 'Open the ' + d.campaign.name + ' campaign in a new tab.'
	                      }),
	                      _react2.default.createElement(_semanticUiReact.Popup, {
	                        trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                          floated: 'right',
	                          circular: true,
	                          inverted: true,
	                          color: 'pink',
	                          icon: 'arrow alternate circle right',
	                          onClick: function onClick() {
	                            return router.push('/campaign/' + d.campaign.id + '/collaborations');
	                          }
	                        }),
	                        content: 'Open the ' + d.campaign.name + ' campaign.'
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                null,
	                d.contentSummary ? _react2.default.createElement(
	                  _semanticUiReact.Table,
	                  { celled: true },
	                  _react2.default.createElement(_components.ReportTableHeader, { productDetails: productDetails }),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Body,
	                    null,
	                    _react2.default.createElement(_components.ReportRow, Object.assign({
	                      key: (0, _uuid2.default)()
	                    }, d.contentSummary, {
	                      discussionId: d.id,
	                      productDetails: productDetails
	                    }))
	                  )
	                ) : _react2.default.createElement(
	                  'div',
	                  null,
	                  'CAMPAIGN ',
	                  d.campaign.id,
	                  ' NOT PROCESSED YET'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                { extra: true },
	                'last analysis: ',
	                (0, _moment2.default)(d.contentSummary.analysisDate).format(JOINED_FORMAT)
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return InfluencerCampaigns;
	}(_react.Component);
	
	InfluencerCampaigns.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  influencerDetails: _propTypes2.default.object.isRequired
	};
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _reactRouter.withRouter)(InfluencerCampaigns);

/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var client = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	  header: {
	    Authorization: 'Bearer ' + _authService.authService.getToken()
	  }
	});
	
	var CAMPAIGN = 'campaign';
	var INVITATIONS = 'campaignInvitation';
	var PERMISSIONS = 'campaignPermission';
	var DISCUSSIONS = 'discussions';
	
	var getCampaignInvitations = function getCampaignInvitations(email, userInfo) {
	  var options = { filter: { email: email }, include: [CAMPAIGN] };
	  // eslint-disable-next-line
	  return client.find(INVITATIONS, options).then(function (invitations) {
	    var invites = _lodash2.default.invokeMap(invitations, 'toJSONTree');
	    var filteredInvites = _lodash2.default.filter(invites, { campaign: {
	        owner: {
	          id: userInfo.organisationId
	        }
	      } });
	    return filteredInvites;
	  });
	};
	
	var getCampaignPermissions = function getCampaignPermissions(email, userInfo) {
	  var options = { filter: { email: email }, include: [CAMPAIGN] };
	  // eslint-disable-next-line
	  return client.find(PERMISSIONS, options).then(function (perms) {
	    var ps = _lodash2.default.invokeMap(perms, 'toJSONTree');
	    var filteredPerms = _lodash2.default.filter(ps, { campaign: {
	        owner: {
	          id: userInfo.organisationId
	        }
	      } });
	    return filteredPerms;
	  });
	};
	
	var getDiscussions = function getDiscussions(discussionName, userInfo) {
	  // we could filter on influencer organisation here
	  var options = {
	    filter: {
	      name: discussionName
	    },
	    include: [CAMPAIGN],
	    sort: ['-lastScannedDate']
	  };
	
	  // eslint-disable-next-line
	  return client.find(DISCUSSIONS, options).then(function (perms) {
	    var ps = _lodash2.default.invokeMap(perms, 'toJSONTree');
	    var filteredPerms = _lodash2.default.filter(ps, function (p) {
	      var organisations = p.organisations;
	
	      var q = { id: userInfo.organisationId };
	      return _lodash2.default.find(organisations, q);
	    });
	
	    return filteredPerms;
	  });
	};
	
	module.exports = {
	  getCampaignInvitations: getCampaignInvitations,
	  getCampaignPermissions: getCampaignPermissions,
	  getDiscussions: getDiscussions
	};

/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _currencies = __webpack_require__(128);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HELP_URL = 'https://help.dyzio.co/campaign-reports/roi-report';
	
	var icon = _react2.default.createElement(_semanticUiReact.Icon, { name: 'save' });
	
	var textCenter = {
	  textAlign: 'center'
	};
	
	var InfluencerFeeModal = function (_Component) {
	  _inherits(InfluencerFeeModal, _Component);
	
	  function InfluencerFeeModal(props) {
	    _classCallCheck(this, InfluencerFeeModal);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerFeeModal.__proto__ || Object.getPrototypeOf(InfluencerFeeModal)).call(this, props));
	
	    _this.onInputValueChanged = function (event, _ref) {
	      var value = _ref.value;
	
	      _this.setState({
	        value: value
	      });
	    };
	
	    _this.state = {
	      value: props.budget || ''
	    };
	    return _this;
	  }
	
	  _createClass(InfluencerFeeModal, [{
	    key: 'render',
	    value: function render() {
	      var value = this.state.value;
	
	      var hasInvalidValue = _lodash2.default.isEmpty(value) || _lodash2.default.isNaN(_lodash2.default.toNumber(value));
	      var _props = this.props,
	          onClose = _props.onClose,
	          currency = _props.currency,
	          influencer = _props.influencer,
	          onSubmit = _props.onSubmit;
	
	      var _ThemeSelector$theme = _themeSelector2.default.theme(),
	          disableHelpLinks = _ThemeSelector$theme.disableHelpLinks;
	
	      return _react2.default.createElement(
	        _dyzioModal2.default,
	        {
	          headerText: 'Influencer Fee',
	          onClose: onClose,
	          size: 'tiny',
	          hasActionButton: true,
	          actionButtonContent: 'Save',
	          actionButtonIcon: icon,
	          shouldDisableActionButton: hasInvalidValue,
	          onActionButtonClick: function onActionButtonClick() {
	            return onSubmit(value);
	          }
	        },
	        _react2.default.createElement(_semanticUiReact.Image, { centered: true, src: influencer.thumbnail, className: 'circular', size: 'small' }),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	        _react2.default.createElement(
	          'h3',
	          { style: textCenter },
	          influencer.name
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Enter the fee paid to the influencer in the box below. This fee will flow through to the ROI report on the dashboard.'
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        _react2.default.createElement(_semanticUiReact.Input, {
	          onChange: this.onInputValueChanged,
	          value: value,
	          type: 'number',
	          label: (0, _currencies.renderCurrencySymbol)(currency),
	          placeholder: 'Influencer fee',
	          fluid: true
	        }),
	        _react2.default.createElement(
	          'small',
	          null,
	          '*only numbers allowed'
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        !disableHelpLinks && _react2.default.createElement(
	          _targetLink2.default,
	          { href: HELP_URL, renderIf: true },
	          'click here for help and FAQs'
	        )
	      );
	    }
	  }]);
	
	  return InfluencerFeeModal;
	}(_react.Component);
	
	InfluencerFeeModal.propTypes = {
	  currency: _propTypes2.default.string.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  influencer: _propTypes2.default.object.isRequired,
	  budget: _propTypes2.default.any.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired
	};
	
	exports.default = InfluencerFeeModal;

/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _bowser = __webpack_require__(368);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	var _validator = __webpack_require__(84);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRedux = __webpack_require__(28);
	
	var _reactStepWizard = __webpack_require__(3527);
	
	var _reactStepWizard2 = _interopRequireDefault(_reactStepWizard);
	
	var _countries = __webpack_require__(93);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _influencerCardPreview = __webpack_require__(349);
	
	var _influencerCardPreview2 = _interopRequireDefault(_influencerCardPreview);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasOrganisation = __webpack_require__(106);
	
	var _hasOrganisation2 = _interopRequireDefault(_hasOrganisation);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _networkHandleInput = __webpack_require__(277);
	
	var _networkHandleInput2 = _interopRequireDefault(_networkHandleInput);
	
	var _duplicatedInfluencerError = __webpack_require__(869);
	
	var _duplicatedInfluencerError2 = _interopRequireDefault(_duplicatedInfluencerError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INF_CREATE_API = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/signup/influencer';
	var EMAIL_API = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/email/gifta/welcome';
	var SHOPFLUENCE_EMAIL_API = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/email/shopfluence/welcome';
	var INF_UPDATE_API = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer/update';
	var HANDLE_PROMPT = 'Enter your handle, or copy-paste your profile\'s url';
	
	var SHOW_TELEGRAM = false;
	
	var currentTheme = _themeSelector2.default.theme();
	
	var submissionLoaderStyle = {
	  height: '30vh'
	};
	
	var checkboxStyle = {
	  'margin-bottom': '25px',
	  display: 'flex',
	  width: '100%',
	  'justify-content': 'center'
	};
	
	var blockDisplayStyle = {
	  display: 'block'
	};
	
	var tagButtonStyle = {
	  margin: 5
	};
	
	var middleVertAlign = {
	  'vertical-align': 'middle'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center',
	  marginBottom: '15px'
	};
	
	var containerStyle = {
	  'max-width': '600px',
	  margin: 'auto',
	  padding: '24px 12px'
	};
	
	var blockDisplayFullWidthStyle = {
	  display: 'block',
	  width: '100%'
	};
	
	var grey75TextStyle = {
	  color: '#939393',
	  'font-size': '0.75rem'
	};
	
	var instagramErrorStyle = {
	  color: '#20c49e',
	  opacity: 1
	};
	
	var youtubeHelpUrl = 'http://help.dyzio.co/en/articles/5543117-adding-an-influencer-s-youtube-channel';
	
	var isLocalhost = function isLocalhost() {
	  var hostname = window.location.hostname;
	  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '';
	};
	
	var ELEMIS_DOMAINS = ['creators.elemis.com'];
	
	var preventKeyPressToNext = function preventKeyPressToNext(event, name, country, email) {
	  if (event.keyCode === 13 && (!name || !country || !email || !_validator2.default.isEmail(email))) {
	    event.preventDefault();
	    console.log('prevent next on enter key press');
	  }
	};
	
	var InfluencerDetails = function InfluencerDetails(handleChange, name, dob, country, email, contactNumber, SW, sweatcoin, preLoaded) {
	  var host = window.location.host;
	
	  var isElemis = _lodash2.default.includes(ELEMIS_DOMAINS, host);
	  var ELEMIS_PRIORITY_CODES = ['FR', 'DE', 'IT', 'PL', 'AT', 'ES', 'BE', 'NL', 'LU'];
	  var elemisCountries = _lodash2.default.filter(_countries2.default, function (c) {
	    return _lodash2.default.includes(ELEMIS_PRIORITY_CODES, c.value);
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    currentTheme.personalDetailHtmlTitle && currentTheme.personalDetailHtmlTitle(),
	    !currentTheme.personalDetailHtmlTitle && currentTheme.formTitle && currentTheme.formTitle(),
	    !currentTheme.formTitle && !currentTheme.personalDetailHtmlTitle && _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    ),
	    _react2.default.createElement('br', null),
	    preLoaded && _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      _react2.default.createElement(
	        _semanticUiReact.Label,
	        { as: 'p', basic: true, color: 'blue' },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle' }),
	        ' We\'ve pre-filled some of your details from your Instagram profile'
	      ),
	      _react2.default.createElement('br', null)
	    ),
	    currentTheme.personalDetailHtmlTop && currentTheme.personalDetailHtmlTop(),
	    _react2.default.createElement(
	      _semanticUiReact.Form,
	      null,
	      currentTheme.organisationId === '8cfa2645-50bc-4700-a548-b9bd6e826ec5' && _react2.default.createElement(
	        _semanticUiReact.Form.Field,
	        null,
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          position: 'left center',
	          trigger: _react2.default.createElement(
	            'span',
	            null,
	            'Sweatcoin username',
	            _react2.default.createElement('img', {
	              style: middleVertAlign,
	              src: '/icons/info.svg', alt: 'info'
	            })
	          ),
	          content: 'e.g. runner123'
	        }),
	        _react2.default.createElement(_semanticUiReact.Input, {
	          width: 16,
	          label: '@',
	          placeholder: 'Your sweatcoin username',
	          name: 'sweatcoin',
	          onChange: handleChange,
	          onKeyDown: function onKeyDown(e) {
	            return preventKeyPressToNext(e, name, dob, country, email);
	          },
	          value: sweatcoin,
	          required: true
	        })
	      ),
	      currentTheme.organisationId === '8cfa2645-50bc-4700-a548-b9bd6e826ec5' && _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(_semanticUiReact.Form.Input, {
	        width: 16,
	        label: 'Name',
	        placeholder: 'Your name',
	        name: 'name',
	        onChange: handleChange,
	        onKeyDown: function onKeyDown(e) {
	          return preventKeyPressToNext(e, name, dob, country, email);
	        },
	        value: name,
	        required: true
	      }),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      currentTheme.dobRequired && _react2.default.createElement(_semanticUiReact.Form.Input, {
	        width: 16,
	        label: currentTheme.dobLabel || 'D.O.B',
	        placeholder: 'e.g. 01/05/2000',
	        name: 'dob',
	        onChange: handleChange,
	        onKeyDown: function onKeyDown(e) {
	          return preventKeyPressToNext(e, name, dob, country, email);
	        },
	        value: dob,
	        type: 'date',
	        required: true
	      }),
	      currentTheme.dobRequired && _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        _semanticUiReact.Form.Field,
	        { required: true },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'country' },
	          'Country'
	        ),
	        _react2.default.createElement(_semanticUiReact.Form.Dropdown, {
	          search: true,
	          selection: true,
	          width: 16,
	          value: country,
	          name: 'country',
	          options: isElemis ? elemisCountries : _countries2.default,
	          onChange: handleChange,
	          onKeyDown: function onKeyDown(e) {
	            return preventKeyPressToNext(e, name, dob, country, email);
	          },
	          required: true
	        }),
	        isElemis && _react2.default.createElement(
	          'div',
	          { style: { display: 'flex' } },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle' }),
	          _react2.default.createElement(
	            'span',
	            { style: { color: 'rgba(0,0,0,0.4)', marginLeft: '2px' } },
	            'Please note: this campaign is only open to creators based in ',
	            _react2.default.createElement('br', null),
	            'France, Germany, Italy, Poland, Austria, Spain, Belgium, the Netherlands, or Luxembourg.'
	          )
	        )
	      ),
	      _react2.default.createElement(_semanticUiReact.Form.Input, {
	        width: 16,
	        label: 'Email',
	        name: 'email',
	        onChange: handleChange,
	        value: email,
	        onKeyDown: function onKeyDown(e) {
	          return preventKeyPressToNext(e, name, dob, country, email);
	        },
	        required: true,
	        type: 'email'
	      }),
	      email && !_validator2.default.isEmail(email) && _react2.default.createElement(
	        'div',
	        { style: { color: 'red', margin: '1px 2px' } },
	        'invalid email'
	      ),
	      _react2.default.createElement(_semanticUiReact.Form.Input, {
	        width: 16,
	        label: 'Contact Number',
	        name: 'contactNumber',
	        onChange: handleChange,
	        value: contactNumber,
	        onKeyDown: function onKeyDown(e) {
	          return preventKeyPressToNext(e, name, dob, country, email);
	        }
	      })
	    ),
	    currentTheme.personalDetailHtmlBottom && currentTheme.personalDetailHtmlBottom(),
	    _react2.default.createElement(_semanticUiReact.Divider, null),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          display: 'flow-root',
	          width: '100%' }
	      },
	      SW && _react2.default.createElement(
	        _semanticUiReact.Button,
	        {
	          basic: !currentTheme.secondaryButtonColorStyle,
	          style: currentTheme.secondaryButtonColorStyle ? currentTheme.secondaryButtonColorStyle : null,
	          color: currentTheme.secondaryButtonColorStyle ? null : 'black',
	          onClick: SW.previousStep,
	          size: 'medium',
	          floated: 'left'
	        },
	        '\u2190 back'
	      ),
	      SW && _react2.default.createElement(
	        _semanticUiReact.Button,
	        {
	          style: currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null,
	          color: currentTheme.primaryButtonColorStyle ? null : 'pink',
	          size: 'medium',
	          onClick: SW.nextStep,
	          floated: 'right'
	          // eslint-disable-next-line max-len
	          , disabled: !name || !dob || !country || !email || !_validator2.default.isEmail(email) || currentTheme.organisationId === '8cfa2645-50bc-4700-a548-b9bd6e826ec5' && !sweatcoin
	        },
	        'next \u2192'
	      )
	    )
	  );
	};
	
	var InfluencerFormExternal = function (_Component) {
	  _inherits(InfluencerFormExternal, _Component);
	
	  function InfluencerFormExternal() {
	    var _this2 = this;
	
	    _classCallCheck(this, InfluencerFormExternal);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerFormExternal.__proto__ || Object.getPrototypeOf(InfluencerFormExternal)).call(this));
	
	    _this.onSubmit = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	        var urlParams, signupSource, _this$state, name, dob, sweatcoin, email, contactNumber, facebook, facebookCount, instagram, instagramId, instagramCount, twitter, twitterCount, youtube, youtubeCount, instagramBusinessAccount, instagramPrivate, instagramProfessionalAccount, instagramCategory, country, twitch, twitchCount, tiktokUserId, thumbnail, tiktok, tiktokCount, newsletter, tagsDropDown, selectedTags, tags, foundCreator, cleanFoundCreator, data, cleanData, emailParams;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                e.preventDefault();
	
	                urlParams = new URLSearchParams(window.location.search);
	                signupSource = urlParams.get('source') || urlParams.get('utm_source');
	
	
	                console.log('signupSource', signupSource);
	
	                _this$state = _this.state, name = _this$state.name, dob = _this$state.dob, sweatcoin = _this$state.sweatcoin, email = _this$state.email, contactNumber = _this$state.contactNumber, facebook = _this$state.facebook, facebookCount = _this$state.facebookCount, instagram = _this$state.instagram, instagramId = _this$state.instagramId, instagramCount = _this$state.instagramCount, twitter = _this$state.twitter, twitterCount = _this$state.twitterCount, youtube = _this$state.youtube, youtubeCount = _this$state.youtubeCount, instagramBusinessAccount = _this$state.instagramBusinessAccount, instagramPrivate = _this$state.instagramPrivate, instagramProfessionalAccount = _this$state.instagramProfessionalAccount, instagramCategory = _this$state.instagramCategory, country = _this$state.country, twitch = _this$state.twitch, twitchCount = _this$state.twitchCount, tiktokUserId = _this$state.tiktokUserId, thumbnail = _this$state.thumbnail, tiktok = _this$state.tiktok, tiktokCount = _this$state.tiktokCount, newsletter = _this$state.newsletter, tagsDropDown = _this$state.tagsDropDown;
	                selectedTags = _lodash2.default.filter(tagsDropDown, function (t) {
	                  return t.selected;
	                });
	                tags = _lodash2.default.map(selectedTags, function (st) {
	                  return {
	                    id: st.id,
	                    type: st.type
	                  };
	                });
	                foundCreator = {
	                  full_name: '',
	                  contactNumber: contactNumber,
	                  tiktokUserId: tiktokUserId,
	                  thumbnail: thumbnail,
	                  instagramId: instagramId,
	                  followerCount: instagramCount,
	                  username: instagram,
	                  tiktok: tiktok,
	                  tiktokCount: tiktokCount,
	                  twitter: twitter,
	                  twitterCount: twitterCount,
	                  youtube: youtube,
	                  youtubeCount: youtubeCount,
	                  facebook: facebook,
	                  facebookCount: facebookCount,
	                  twitch: twitch,
	                  twitchCount: twitchCount,
	                  tags: tags,
	                  isVerified: true,
	                  instagramBusinessAccount: instagramBusinessAccount,
	                  instagramProfessionalAccount: instagramProfessionalAccount,
	                  instagramCategory: instagramCategory,
	                  isPrivate: instagramPrivate,
	                  id: instagramId,
	                  usageRightsGranted: !!newsletter,
	                  signupSource: signupSource
	                };
	
	
	                console.log(foundCreator);
	                cleanFoundCreator = _lodash2.default.pickBy(foundCreator);
	
	
	                console.log(cleanFoundCreator);
	
	                data = {
	                  country: country,
	                  email: email,
	                  name: name,
	                  dob: dob,
	                  sweatcoin: sweatcoin,
	                  tags: tags,
	                  foundCreator: cleanFoundCreator,
	                  organisationId: currentTheme.organisationId || 'efcb872a-50d9-417c-b6a5-ba427dba4c84',
	                  organisationName: currentTheme.title,
	                  device: _bowser2.default.mobile ? 'mobile' : 'desktop',
	                  deviceSource: _bowser2.default
	                };
	
	
	                console.log(data);
	
	                cleanData = _lodash2.default.pickBy(data);
	
	
	                console.log(cleanData);
	
	                emailParams = {
	                  recipient: email,
	                  name: name
	                };
	
	
	                _this.setState({
	                  submitting: true
	                });
	
	                return _context2.abrupt('return', _axios2.default.post(INF_CREATE_API, { data: cleanData }).then(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(r) {
	                    var shopfluenceParams, status, _r$data, body, statusCode, _JSON$parse, _JSON$parse$data, influencer, exists, _this$state2, ig, tt, n, th, ph, c;
	
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            if (!(currentTheme.organisationId === '2beaa438-af69-46f1-b639-f7ae1f374241')) {
	                              _context.next = 3;
	                              break;
	                            }
	
	                            _context.next = 3;
	                            return _axios2.default.post(EMAIL_API, emailParams).then(function (res) {
	                              console.log('email', res);
	                            }).catch(function (err) {
	                              console.log(err);
	                            });
	
	                          case 3:
	                            shopfluenceParams = {
	                              email: email,
	                              name: name,
	                              organisationId: currentTheme.organisationId
	                            };
	                            _context.next = 6;
	                            return _axios2.default.post(SHOPFLUENCE_EMAIL_API, shopfluenceParams).then(function (res) {
	                              console.log('email', res);
	                            }).catch(function (err) {
	                              console.log(err);
	                            });
	
	                          case 6:
	                            status = r.status, _r$data = r.data, body = _r$data.body, statusCode = _r$data.statusCode;
	
	                            console.log(status);
	                            console.log(body);
	
	                            _JSON$parse = JSON.parse(body), _JSON$parse$data = _JSON$parse.data, influencer = _JSON$parse$data.influencer, exists = _JSON$parse$data.exists;
	
	                            console.log(influencer);
	                            if (_lodash2.default.isEqual(statusCode, 201)) {
	                              console.log('created');
	
	                              if (window.gtag && !isLocalhost()) {
	                                window.gtag('event', 'form_submit_success', {
	                                  form_type: 'creator_signup',
	                                  domain: window.location.hostname,
	                                  is_preloaded: _this.state.preLoaded || false,
	                                  instagram_handle: _this.state.instagram
	                                });
	                              }
	
	                              _this$state2 = _this.state, ig = _this$state2.instagram, tt = _this$state2.tiktok, n = _this$state2.name, th = _this$state2.thumbnail, ph = _this$state2.primarySocialHandle, c = _this$state2.country;
	
	                              _this.setState({
	                                confirmed: true,
	                                status: 'created',
	                                newInfluencer: influencer,
	                                secondaryNetwork: ig && !tt ? 'tiktok' : !ig && tt ? 'instagram' : null,
	                                savedProfileSnapshot: { name: n, thumbnail: th, primarySocialHandle: ph, country: c }
	                              });
	                            } else {
	                              console.log('NOT created');
	                              _this.setState({
	                                confirmed: true,
	                                status: exists ? 'exist' : 'failed'
	                              });
	                            }
	
	                          case 12:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }()));
	
	              case 18:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.handleSecondarySocialChange = function (e, v) {
	      var value = _lodash2.default.replace(_lodash2.default.get(v, 'value'), /\s/g, '');
	      _this.setState(_defineProperty({}, v.name, value));
	      _this.getChannelData(v.name, value).then(function () {
	        var savedProfileSnapshot = _this.state.savedProfileSnapshot;
	
	        if (savedProfileSnapshot) {
	          _this.setState(savedProfileSnapshot);
	        }
	      });
	    };
	
	    _this.onSecondaryHandleSubmit = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state3, newInfluencer, tiktok, instagram, secondaryNetwork, payload;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$state3 = _this.state, newInfluencer = _this$state3.newInfluencer, tiktok = _this$state3.tiktok, instagram = _this$state3.instagram, secondaryNetwork = _this$state3.secondaryNetwork;
	
	              if (!(!newInfluencer || !newInfluencer.id || !secondaryNetwork)) {
	                _context3.next = 3;
	                break;
	              }
	
	              return _context3.abrupt('return');
	
	            case 3:
	              payload = { data: { influencerId: newInfluencer.id } };
	
	              if (secondaryNetwork === 'tiktok' && tiktok) payload.data.tiktok = tiktok;
	              if (secondaryNetwork === 'instagram' && instagram) payload.data.instagram = instagram;
	
	              _this.setState({ secondaryHandleSubmitting: true, secondaryHandleError: false });
	
	              _context3.prev = 7;
	              _context3.next = 10;
	              return _axios2.default.patch(INF_UPDATE_API, payload);
	
	            case 10:
	              _this.setState({ secondaryHandleSubmitting: false, secondaryHandleSubmitted: true });
	              _context3.next = 17;
	              break;
	
	            case 13:
	              _context3.prev = 13;
	              _context3.t0 = _context3['catch'](7);
	
	              console.log('secondary handle update error', _context3.t0);
	              _this.setState({ secondaryHandleSubmitting: false, secondaryHandleError: true });
	
	            case 17:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2, [[7, 13]]);
	    }));
	
	    _this.revertDuplicateHandleChannelError = function (channel) {
	      var duplicateInfluencerPlatform = _this.state.duplicateInfluencerPlatform;
	
	      if (_lodash2.default.eq(channel, duplicateInfluencerPlatform)) {
	        _this.setState({
	          duplicateInfluencerHandle: null,
	          duplicateInfluencerPlatform: null,
	          duplicateInfluencerLinkId: null
	        });
	      }
	    };
	
	    _this.getChannelData = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(channel, handle) {
	        var count, loading, error, thumbnail, options, _details, details;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                count = channel + 'Count';
	                loading = channel + 'Loading';
	                error = channel + 'Error';
	                thumbnail = channel + 'Thumbnail';
	
	                _this.revertDuplicateHandleChannelError(channel);
	
	                if (channel === 'instagram') {
	                  _this.setState(_defineProperty({
	                    instagramError: false,
	                    instagramErrorCode: '',
	                    name: '',
	                    thumbnail: null,
	                    primarySocialHandle: null
	                  }, count, ''));
	                }
	
	                options = {
	                  data: {
	                    platform: channel,
	                    name: _lodash2.default.trimStart(handle, '@')
	                  }
	                };
	
	
	                _this.setState(_defineProperty({}, loading, true));
	
	                if (!(handle.length === 0)) {
	                  _context4.next = 42;
	                  break;
	                }
	
	                details = (_details = {}, _defineProperty(_details, loading, false), _defineProperty(_details, count, 0), _defineProperty(_details, error, false), _defineProperty(_details, thumbnail, ''), _details);
	                _context4.t0 = channel;
	                _context4.next = _context4.t0 === 'facebook' ? 13 : _context4.t0 === 'instagram' ? 17 : _context4.t0 === 'twitter' ? 21 : _context4.t0 === 'youtube' ? 25 : _context4.t0 === 'twitch' ? 29 : _context4.t0 === 'tiktok' ? 33 : _context4.t0 === 'telegram' ? 36 : 40;
	                break;
	
	              case 13:
	                details.facebookPageName = null;
	                details.facebookUserName = null;
	                details.facebookVerified = false;
	                return _context4.abrupt('break', 41);
	
	              case 17:
	                details.instagramFullName = null;
	                details.instagramUserName = null;
	                details.instagramVerified = false;
	                return _context4.abrupt('break', 41);
	
	              case 21:
	                details.twitterPageName = null;
	                details.twitterUserName = null;
	                details.twitterVerified = false;
	                return _context4.abrupt('break', 41);
	
	              case 25:
	                details.youtubeChannelTitle = null;
	                details.youtubeChannelUserName = null;
	                details.youtubeVerified = false;
	                return _context4.abrupt('break', 41);
	
	              case 29:
	                details.name = null;
	                details.twitchChannelTitle = null;
	                details.twitchUserId = null;
	                return _context4.abrupt('break', 41);
	
	              case 33:
	                details.tiktokName = null;
	                details.tiktokVerified = false;
	                return _context4.abrupt('break', 41);
	
	              case 36:
	                details.telegramUser = null;
	                details.telegramFound = 0;
	                details.telegramObj = {};
	                return _context4.abrupt('break', 41);
	
	              case 40:
	                return _context4.abrupt('break', 41);
	
	              case 41:
	                return _context4.abrupt('return', _this.setState(_extends({}, details)));
	
	              case 42:
	                return _context4.abrupt('return', _axios2.default.post(("https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer"), options).then(function (response) {
	                  var _this$setState4;
	
	                  if (_lodash2.default.isEqual(channel, 'instagram') && response.data.statusCode === 500) {
	                    _this.setState({
	                      instagramErrorCode: 'NO_MATCH'
	                    });
	                  }
	
	                  _this.setState((_this$setState4 = {}, _defineProperty(_this$setState4, loading, false), _defineProperty(_this$setState4, count, response.data.body.data.followerCount), _defineProperty(_this$setState4, error, false), _defineProperty(_this$setState4, thumbnail, response.data.body.data.thumbnail), _this$setState4));
	
	                  var country = response.data.body.data.location;
	
	                  var details = {};
	                  switch (channel) {
	                    case 'facebook':
	                      details.facebookPageName = response.data.body.data.pagename;
	                      details.facebookUserName = response.data.body.data.username;
	                      details.facebookVerified = response.data.body.data.verified;
	                      details.isFacebookPersonalPage = response.data.body.data.isPersonalPage;
	                      _this.revertDuplicateHandleChannelError('facebook');
	                      break;
	                    case 'instagram':
	                      // details.name = response.data.body.data.full_name;
	                      details.instagramFullName = response.data.body.data.full_name;
	                      details.instagramUserName = response.data.body.data.username;
	                      details.instagramVerified = response.data.body.data.isVerified;
	                      details.instagramBusinessAccount = response.data.body.data.instagramBusinessAccount;
	                      details.instagramPrivate = response.data.body.data.isPrivate;
	                      details.instagramProfessionalAccount = response.data.body.data.instagramProfessionalAccount;
	                      if (response.data.body.data.instagramCategory) {
	                        details.instagramCategory = response.data.body.data.instagramCategory;
	                      }
	                      details.instagramId = response.data.body.data.id;
	                      _this.revertDuplicateHandleChannelError('instagram');
	                      break;
	                    case 'twitter':
	                      details.twitterUserName = response.data.body.data.screen_name;
	                      details.twitterVerified = response.data.body.data.verified;
	                      _this.revertDuplicateHandleChannelError('twitter');
	                      break;
	                    case 'youtube':
	                      details.youtubeChannelTitle = response.data.body.data.channelTitle;
	                      details.youtubeChannelUserName = response.data.body.data.username;
	                      details.youtubeVerified = response.data.body.data.verified;
	                      _this.revertDuplicateHandleChannelError('youtube');
	                      break;
	                    case 'twitch':
	                      details.twitchChannelTitle = response.data.body.data.name;
	                      details.twitchUserId = response.data.body.data.userId;
	                      _this.revertDuplicateHandleChannelError('twitch');
	                      break;
	                    case 'tiktok':
	                      details.tiktokName = response.data.body.data.name;
	                      details.tiktokVerified = response.data.body.data.verified;
	                      details.tiktokThumbnail = response.data.body.data.thumbnail;
	                      details.tiktokProfileData = response.data.body.data;
	                      details.tiktokUserId = response.data.body.data.id;
	                      _this.revertDuplicateHandleChannelError('tiktok');
	                      break;
	                    default:
	                      break;
	                  }
	
	                  var newState = _lodash2.default.assign({
	                    country: country,
	                    shouldRenderSocialHandlesBlock: true
	                  }, details);
	
	                  if (channel === 'instagram' || channel === 'tiktok') {
	                    newState.thumbnail = response.data.body.data.thumbnail;
	                    newState.primarySocialHandle = '@' + response.data.body.data.username;
	                  }
	
	                  _this.setState(newState);
	
	                  var _this$state4 = _this.state,
	                      handles = _this$state4.handles,
	                      youtubeChannelTitle = _this$state4.youtubeChannelTitle;
	
	                  var o = {
	                    key: channel,
	                    value: channel,
	                    text: channel === 'youtube' ? youtubeChannelTitle + ' (' + channel + ')' : handle + ' (' + channel + ')'
	                  };
	                  var a = handles.filter(function (obj) {
	                    return obj.key !== channel;
	                  });
	                  a.push(o);
	                  _this.setState({ handles: a });
	                }).catch(function (e) {
	                  var _this$setState5;
	
	                  // if instagramErrorCode not set to NO_MATCH then it is a genuine error
	                  console.log(e);
	                  var instagramErrorCode = _this.state.instagramErrorCode;
	
	                  if (!instagramErrorCode) {
	                    if (_lodash2.default.isEqual(channel, 'instagram')) {
	                      _this.setState({
	                        instagramErrorCode: 'ERROR'
	                      });
	                    }
	                  }
	                  _this.setState((_this$setState5 = {}, _defineProperty(_this$setState5, loading, false), _defineProperty(_this$setState5, error, true), _this$setState5));
	                }));
	
	              case 43:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x3, _x4) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var urlParams, instagramId, email, country, influencerApi, payload, response, inf;
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              console.log('componentDidMount');
	
	              urlParams = new URLSearchParams(window.location.search);
	              instagramId = urlParams.get('iid');
	              email = urlParams.get('email');
	              country = urlParams.get('country');
	
	
	              if (instagramId) {
	                _this.setState({ isPreLoading: true });
	              }
	
	              influencerApi = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer';
	              payload = { data: { platform: 'instagram', name: instagramId } };
	              _context5.next = 10;
	              return _axios2.default.post(influencerApi, payload).catch(function (err) {
	                return console.log(err.message);
	              });
	
	            case 10:
	              response = _context5.sent;
	
	
	              if (response && _lodash2.default.get(response, 'data.body.data')) {
	                inf = _lodash2.default.get(response, 'data.body.data');
	
	
	                _this.setState({
	                  email: email,
	                  thumbnail: inf.thumbnail,
	                  country: country,
	                  instagram: inf.username,
	                  instagramCount: inf.followerCount,
	                  instagramId: inf.id,
	                  primarySocialHandle: inf.username,
	                  preLoaded: true,
	                  instagramLoading: false,
	                  instagramError: false,
	                  // name: inf.full_name,
	                  isPreLoading: false
	                }, function () {
	                  // Track after state update completes
	                  if (window.gtag && !isLocalhost()) {
	                    window.gtag('event', 'form_view', {
	                      form_type: 'creator_signup',
	                      domain: window.location.hostname,
	                      is_preloaded: true,
	                      preloaded_instagram: inf.username,
	                      preloaded_email: email,
	                      preloaded_country: country
	                    });
	                  }
	                });
	              } else {
	                _this.setState({ isPreLoading: false });
	
	                if (window.gtag && !isLocalhost()) {
	                  // Track for non-preloaded users
	                  window.gtag('event', 'form_view', {
	                    form_type: 'creator_signup',
	                    domain: window.location.hostname,
	                    is_preloaded: false,
	                    preloaded_instagram: null,
	                    preloaded_email: null,
	                    preloaded_country: null
	                  });
	                }
	              }
	
	            case 12:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	
	    _this.componentWillUnmount = function () {
	      var confirmed = _this.state.confirmed;
	
	      if (!confirmed && window.gtag && !isLocalhost()) {
	        window.gtag('event', 'form_abandon', {
	          form_type: 'creator_signup',
	          domain: window.location.hostname,
	          is_preloaded: _this.state.preLoaded || false
	        });
	      }
	    };
	
	    _this.componentWillReceiveProps = function (newProps, oldProps) {
	      if (newProps.organisation && newProps.userInfo && _lodash2.default.get(newProps, 'organisation.name') !== _lodash2.default.get(oldProps, 'organisation.name')) {
	        _this.checkLimitsNotification();
	      }
	    };
	
	    _this.checkboxChange = function (e, v) {
	      var name = v.name,
	          value = v.value;
	
	      _this.setState(_defineProperty({}, name, !value));
	    };
	
	    _this.handleChange = function (e, v) {
	      _this.setState(_defineProperty({}, v.name, v.value));
	    };
	
	    _this.handleTagChange = function (e, v) {
	      var name = v.name,
	          value = v.value;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.onInfluencerEmailStateChanged = function (isValid, value) {
	      _this.setState({
	        isEmailFieldValid: isValid,
	        email: value
	      });
	    };
	
	    _this.handleBasicSocialChange = function (e, v) {
	      var name = v.name,
	          value = v.value;
	
	      _this.setState(_defineProperty({}, name, _lodash2.default.replace(value, /\s/g, '')));
	    };
	
	    _this.handleSocialChange = function (e, v) {
	      var value = _lodash2.default.replace(_lodash2.default.get(v, 'value'), /\s/g, '');
	      _this.setState(_defineProperty({}, v.name, value));
	      _this.getChannelData(v.name, value);
	    };
	
	    _this.retryInstagramHandle = function () {
	      var instagram = _this.state.instagram;
	
	      console.log('retry search for instagram handle', instagram);
	      _this.getChannelData('instagram', instagram);
	    };
	
	    _this.handleChannelAdd = function () {
	      var _this$state5 = _this.state,
	          newChannelName = _this$state5.newChannelName,
	          newChannelHandle = _this$state5.newChannelHandle,
	          otherChannels = _this$state5.otherChannels;
	
	      var obj = {
	        name: newChannelName,
	        handle: newChannelHandle
	      };
	      otherChannels.push(obj);
	      _this.setState({ otherChannels: otherChannels, newChannelName: '', newChannelHandle: '' });
	    };
	
	    _this.handleChannelRemove = function (name, handle) {
	      var otherChannels = _this.state.otherChannels;
	
	      var a = otherChannels.filter(function (o) {
	        return o.name !== name;
	      });
	      _this.setState({ otherChannels: a });
	    };
	
	    _this.onTagSelected = function (tagId) {
	      var selectedTags = _this.state.tags;
	
	      var tags = _lodash2.default.concat(selectedTags, [tagId]);
	      _this.setState({
	        tags: tags
	      });
	    };
	
	    _this.onUnselected = function (tagId) {
	      var selectedTags = _this.state.tags;
	
	      var tags = _lodash2.default.reject(selectedTags, function (tag) {
	        return tag === tagId;
	      });
	      _this.setState({
	        tags: tags
	      });
	    };
	
	    _this.setInstance = function (SW) {
	      return _this.setState({
	        SW: SW
	      });
	    };
	
	    _this.handleStepChange = function (x, y) {
	      console.log(x, y);
	
	      if (window.gtag && !isLocalhost()) {
	        var newState = _lodash2.default.omit(_this.state, 'SW');
	        console.log(newState);
	        window.gtag('event', 'form_step_change', {
	          step_number: x.activeStep,
	          step_name: 'step_' + x.activeStep,
	          domain: window.location.hostname,
	          is_preloaded: _this.state.preLoaded || false,
	          form_data: JSON.stringify(newState)
	        });
	      }
	    };
	
	    _this.state = {
	      name: '',
	      dob: null,
	      sweatcoin: null,
	      email: '',
	      contactNumber: '',
	      thumbnail: '',
	      primarySocialHandle: '',
	      facebook: '',
	      facebookPageName: '',
	      facebookUserName: '',
	      facebookCount: '',
	      facebookLoading: false,
	      facebookError: false,
	      instagram: '',
	      instagramUsername: '',
	      instagramId: '',
	      instagramFullName: '',
	      instagramCount: '',
	      instagramLoading: false,
	      instagramError: false,
	      instagramErrorCode: '',
	      instagramBusinessAccount: false,
	      instagramProfessionalAccount: false,
	      instagramCategory: '',
	      isFacebookPersonalPage: false,
	      instagramPrivate: false,
	      twitter: '',
	      twitterCount: '',
	      twitterLoading: false,
	      twitterError: false,
	      twitch: '',
	      twitchCount: '',
	      twitchLoading: false,
	      twitchError: false,
	      tiktok: '',
	      tiktokCount: '',
	      tiktokUserId: '',
	      tiktokName: '',
	      tiktokLoading: false,
	      tiktokError: false,
	      tiktokVerified: false,
	      tiktokThumbnail: '',
	      tiktokProfileData: {},
	      youtube: '',
	      twitchUserId: '',
	      youtubeCount: '',
	      youtubeErorr: false,
	      youtubeLoading: false,
	      youtubeChannelTitle: '',
	      primarySocialHandleYoutube: false,
	      otherChannels: [],
	      addChannel: false,
	      newChannelName: '',
	      newChannelHandle: '',
	      handles: [],
	      agent: false,
	      agentName: '',
	      agentEmail: '',
	      agentContactNumber: '',
	      associated: true,
	      contentTags: [],
	      brandTags: [],
	      addressLine1: '',
	      city: '',
	      region: '',
	      postalCode: '',
	      country: '',
	      description: '',
	      timeout: null,
	      web: '',
	      snapchat: '',
	      linkedin: '',
	      tags: [],
	      businessUnits: [],
	      telegramUser: '',
	      telegramFound: '',
	      telegramObj: {},
	      telegramLoading: false,
	      telegramError: false,
	
	      facebookVerified: false,
	      twitterVerified: false,
	      youtubeVerified: false,
	      instagramVerified: false,
	
	      isEmailFieldValid: true,
	
	      duplicateInfluencerHandle: '',
	      duplicateInfluencerPlatform: '',
	      duplicateInfluencerLinkId: '',
	
	      activeIndex: -1,
	
	      SW: null,
	      confirmed: false,
	      status: null,
	      tagsDropDown: currentTheme.tagsJson ? currentTheme.tagsJson : [],
	
	      tcs: false,
	      privacy: false,
	      newsletter: false,
	
	      submitting: false,
	      newInfluencer: {},
	      preLoaded: false,
	      isPreLoading: false,
	      secondaryNetwork: null,
	      secondaryHandleSubmitting: false,
	      secondaryHandleSubmitted: false,
	      secondaryHandleSkipped: false,
	      secondaryHandleError: false
	    };
	    return _this;
	  }
	
	  _createClass(InfluencerFormExternal, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          name = _state.name,
	          dob = _state.dob,
	          sweatcoin = _state.sweatcoin,
	          email = _state.email,
	          thumbnail = _state.thumbnail,
	          contactNumber = _state.contactNumber,
	          country = _state.country,
	          primarySocialHandle = _state.primarySocialHandle,
	          facebook = _state.facebook,
	          facebookCount = _state.facebookCount,
	          facebookLoading = _state.facebookLoading,
	          facebookError = _state.facebookError,
	          instagram = _state.instagram,
	          instagramCount = _state.instagramCount,
	          instagramLoading = _state.instagramLoading,
	          instagramError = _state.instagramError,
	          instagramErrorCode = _state.instagramErrorCode,
	          twitter = _state.twitter,
	          twitterCount = _state.twitterCount,
	          twitterLoading = _state.twitterLoading,
	          twitterError = _state.twitterError,
	          youtube = _state.youtube,
	          youtubeChannelTitle = _state.youtubeChannelTitle,
	          youtubeCount = _state.youtubeCount,
	          youtubeLoading = _state.youtubeLoading,
	          youtubeError = _state.youtubeError,
	          primarySocialHandleYoutube = _state.primarySocialHandleYoutube,
	          isFacebookPersonalPage = _state.isFacebookPersonalPage,
	          twitch = _state.twitch,
	          twitchCount = _state.twitchCount,
	          twitchError = _state.twitchError,
	          twitchLoading = _state.twitchLoading,
	          tiktok = _state.tiktok,
	          tiktokCount = _state.tiktokCount,
	          tiktokLoading = _state.tiktokLoading,
	          tiktokError = _state.tiktokError,
	          telegramUser = _state.telegramUser,
	          telegramFound = _state.telegramFound,
	          telegramError = _state.telegramError,
	          telegramLoading = _state.telegramLoading,
	          duplicateInfluencerHandle = _state.duplicateInfluencerHandle,
	          duplicateInfluencerPlatform = _state.duplicateInfluencerPlatform,
	          duplicateInfluencerLinkId = _state.duplicateInfluencerLinkId,
	          SW = _state.SW,
	          confirmed = _state.confirmed,
	          status = _state.status,
	          tcs = _state.tcs,
	          privacy = _state.privacy,
	          newsletter = _state.newsletter,
	          submitting = _state.submitting,
	          newInfluencer = _state.newInfluencer,
	          preLoaded = _state.preLoaded,
	          isPreLoading = _state.isPreLoading,
	          secondaryNetwork = _state.secondaryNetwork,
	          secondaryHandleSubmitting = _state.secondaryHandleSubmitting,
	          secondaryHandleSubmitted = _state.secondaryHandleSubmitted,
	          secondaryHandleSkipped = _state.secondaryHandleSkipped,
	          secondaryHandleError = _state.secondaryHandleError;
	
	
	      var duplicateErrorProps = {
	        duplicateInfluencerHandle: duplicateInfluencerHandle,
	        duplicateInfluencerPlatform: duplicateInfluencerPlatform,
	        duplicateInfluencerLinkId: duplicateInfluencerLinkId
	      };
	
	      var disableActionButtons1 = facebookLoading || twitterLoading || tiktokLoading || facebookError || twitterError || tiktokError;
	
	      var disableActionButtons2 = twitchLoading || youtubeLoading || twitchError || youtubeError;
	
	      var Welcome = function Welcome() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          currentTheme.formTitle && currentTheme.formTitle(),
	          !currentTheme.formTitle && _react2.default.createElement(
	            'h3',
	            { style: textAlignCentre },
	            'Create your profile'
	          ),
	          _react2.default.createElement('br', null),
	          currentTheme.welcomeHtml && currentTheme.welcomeHtml(),
	          !currentTheme.welcomeHtml && _react2.default.createElement(
	            'div',
	            { style: minHeight200 },
	            _react2.default.createElement(
	              'p',
	              { style: textAlignCentre },
	              'welcome to ',
	              currentTheme.title,
	              '.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              { style: textAlignCentre50p },
	              'Join our creator network and we will review your profile and feed and work to partner you with brands who are looking for influencers.'
	            ),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                display: 'flow-root',
	                width: '100%' }
	            },
	            SW && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                style: currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null,
	                color: currentTheme.primaryButtonColorStyle ? null : 'pink',
	                size: 'medium',
	                onClick: SW.nextStep,
	                floated: 'right'
	              },
	              'next \u2192'
	            )
	          )
	        );
	      };
	
	      var Instagram = function Instagram() {
	        var isInstagramReady = instagram && !instagramLoading && !instagramError;
	        var isTikTokReady = tiktok && !tiktokLoading && !tiktokError;
	
	        var shouldEnableNextButton = currentTheme.tiktokOnFrontPage ? isTikTokReady || isInstagramReady : isInstagramReady;
	
	        console.log({ isInstagramReady: isInstagramReady, isTikTokReady: isTikTokReady, shouldEnableNextButton: shouldEnableNextButton });
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          currentTheme.socialHandle1HtmlTitle && currentTheme.socialHandle1HtmlTitle(preLoaded),
	          !currentTheme.socialHandle1HtmlTitle && currentTheme.formTitle && currentTheme.formTitle(),
	          !currentTheme.formTitle && !currentTheme.socialHandle1HtmlTitle && _react2.default.createElement(
	            'h3',
	            { style: textAlignCentre },
	            'Create your profile'
	          ),
	          _react2.default.createElement('br', null),
	          currentTheme.socialHandle1HtmlTop && currentTheme.socialHandle1HtmlTop(preLoaded),
	          _react2.default.createElement(
	            'div',
	            { style: minHeight200 },
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              position: 'left center',
	              trigger: _react2.default.createElement(
	                'span',
	                { style: blockDisplayStyle },
	                currentTheme.instagramLabel || 'Instagram',
	                _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	              ),
	              content: HANDLE_PROMPT
	            }),
	            _react2.default.createElement(
	              _semanticUiReact.Form,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Form.Group,
	                { widths: 'equal' },
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  { error: instagramError },
	                  _react2.default.createElement(_networkHandleInput2.default, {
	                    fromComponent: 'signup',
	                    network: 'instagram',
	                    error: instagramError,
	                    value: instagram,
	                    loading: instagramLoading,
	                    onChange: _this3.handleSocialChange,
	                    count: instagramCount,
	                    placeholder: currentTheme.instagramPlaceholder || null,
	                    loadState: preLoaded ? 'PRELOADED' : null
	                  }),
	                  _lodash2.default.isEqual(instagramErrorCode, 'ERROR') && _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { basic: true, color: 'red', pointing: true },
	                    'Sorry\u2026 the search failed,',
	                    ' ',
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        style: instagramErrorStyle,
	                        onClick: _this3.retryInstagramHandle
	                      },
	                      'click here'
	                    ),
	                    ' ',
	                    'to try again!'
	                  ),
	                  _lodash2.default.isEqual(instagramErrorCode, 'NO_MATCH') && _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { basic: true, color: 'red', pointing: true },
	                    'Sorry we could not find that username, please check it and try again!'
	                  ),
	                  _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'instagram' })),
	                  preLoaded && instagram && instagramCount && _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { basic: true, color: 'green', pointing: true },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle' }),
	                    ' ',
	                    'We found and loaded your profile: @',
	                    instagram,
	                    ' ',
	                    '(',
	                    instagramCount.toLocaleString(),
	                    ' followers)'
	                  )
	                )
	              ),
	              instagramLoading && _react2.default.createElement(
	                'div',
	                { style: textAlignCentre },
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { as: 'p', basic: true, color: 'teal' },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'search' }),
	                  ' Searching...'
	                ),
	                _react2.default.createElement('br', null)
	              ),
	              currentTheme.tiktokOnFrontPage && !preLoaded && _react2.default.createElement(_semanticUiReact.Popup, {
	                position: 'left center',
	                trigger: _react2.default.createElement(
	                  'span',
	                  { style: blockDisplayStyle },
	                  currentTheme.tiktokLabel || 'Tiktok',
	                  _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	                ),
	                content: HANDLE_PROMPT
	              }),
	              currentTheme.tiktokOnFrontPage && !preLoaded && _react2.default.createElement(
	                _semanticUiReact.Form.Group,
	                { widths: 'equal' },
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  { error: tiktokError },
	                  _react2.default.createElement(_networkHandleInput2.default, {
	                    fromComponent: 'signup',
	                    network: 'tiktok',
	                    error: tiktokError,
	                    value: tiktok,
	                    loading: tiktokLoading,
	                    onChange: _this3.handleSocialChange,
	                    count: tiktokCount,
	                    placeholder: currentTheme.tiktokPlaceholder || null
	                  }),
	                  _lodash2.default.isEqual(tiktokError, 'NO_MATCH') && _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { basic: true, color: 'red', pointing: true },
	                    'Sorry we could not find that username, please check it and try again!'
	                  ),
	                  _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'tiktok' }))
	                )
	              ),
	              currentTheme.tiktokOnFrontPage && !preLoaded && !tiktokLoading && !tiktokError && tiktok && tiktokCount && _react2.default.createElement(
	                'div',
	                { style: textAlignCentre },
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { as: 'p', basic: true, color: 'blue' },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'check' }),
	                  ' Found ',
	                  tiktok
	                ),
	                _react2.default.createElement('br', null)
	              ),
	              currentTheme.tiktokOnFrontPage && !preLoaded && tiktokLoading && _react2.default.createElement(
	                'div',
	                { style: textAlignCentre },
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { as: 'p', basic: true, color: 'teal' },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'search' }),
	                  ' Searching...'
	                ),
	                _react2.default.createElement('br', null)
	              )
	            )
	          ),
	          currentTheme.socialHandle1HtmlBottom && currentTheme.socialHandle1HtmlBottom(),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                display: 'flow-root',
	                width: '100%' }
	            },
	            SW && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                style: currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null,
	                color: currentTheme.primaryButtonColorStyle ? null : 'pink',
	                size: 'medium',
	                onClick: SW.nextStep,
	                floated: 'right',
	                disabled: !shouldEnableNextButton
	              },
	              'next \u2192'
	            )
	          )
	        );
	      };
	
	      var toggleTag = function toggleTag(tagId) {
	        var tagsDropDown = _this3.state.tagsDropDown;
	
	        console.log(tagId);
	        _lodash2.default.forEach(tagsDropDown, function (t) {
	          if (t.id === tagId) {
	            t.selected = !t.selected;
	          }
	        });
	        _this3.setState({
	          tagsDropDown: tagsDropDown
	        });
	      };
	
	      var Tags = function Tags() {
	        var tagsDropDown = _this3.state.tagsDropDown;
	
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          currentTheme.tagsTitle && currentTheme.tagsTitle(),
	          !currentTheme.tagsTitle && currentTheme.formTitle && currentTheme.formTitle(),
	          !currentTheme.formTitle && !currentTheme.tagsTitle && _react2.default.createElement(
	            'h3',
	            { style: textAlignCentre },
	            'Create your profile'
	          ),
	          currentTheme.tagsHtmlTop && currentTheme.tagsHtmlTop(),
	          _lodash2.default.map(tagsDropDown, function (tag) {
	            return _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                size: 'small',
	                style: tagButtonStyle,
	                color: currentTheme.tagButtonColor ? currentTheme.tagButtonColor : 'pink',
	                inverted: !tag.selected,
	                onClick: function onClick() {
	                  return toggleTag(tag.id);
	                },
	                onKeyDown: function onKeyDown(e) {
	                  return preventKeyPressToNext(e);
	                }
	              },
	              _lodash2.default.get(tag, 'attributes.value')
	            );
	          }),
	          currentTheme.tagsHtmlBottom && currentTheme.tagsHtmlBottom(),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                display: 'flow-root',
	                width: '100%' }
	            },
	            SW && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                basic: !currentTheme.secondaryButtonColorStyle,
	                style: currentTheme.secondaryButtonColorStyle ? currentTheme.secondaryButtonColorStyle : null,
	                color: currentTheme.secondaryButtonColorStyle ? null : 'black',
	                onClick: SW.previousStep,
	                size: 'medium',
	                floated: 'left'
	              },
	              '\u2190 back'
	            ),
	            SW && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                style: currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null,
	                color: currentTheme.primaryButtonColorStyle ? null : 'pink',
	                size: 'medium',
	                onClick: SW.nextStep,
	                floated: 'right'
	              },
	              'next &rarr'
	            )
	          )
	        );
	      };
	
	      var SocialHandles = function SocialHandles() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          currentTheme.socialHandle2HtmlTitle && currentTheme.socialHandle2HtmlTitle(),
	          !currentTheme.socialHandle2HtmlTitle && currentTheme.formTitle && currentTheme.formTitle(),
	          !currentTheme.formTitle && !currentTheme.socialHandle2HtmlTitle && _react2.default.createElement(
	            'h3',
	            { style: textAlignCentre },
	            'Create your profile'
	          ),
	          _react2.default.createElement('br', null),
	          currentTheme.socialHandle2HtmlTop && currentTheme.socialHandle2HtmlTop(),
	          _react2.default.createElement(_semanticUiReact.Popup, {
	            position: 'left center',
	            trigger: _react2.default.createElement(
	              'span',
	              { style: blockDisplayStyle },
	              'Facebook',
	              _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	            ),
	            content: HANDLE_PROMPT
	          }),
	          _react2.default.createElement(
	            _semanticUiReact.Form,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Form.Group,
	              { widths: 'equal' },
	              _react2.default.createElement(
	                _semanticUiReact.Form.Field,
	                { error: facebookError },
	                _react2.default.createElement(_networkHandleInput2.default, {
	                  fromComponent: 'signup',
	                  network: 'facebook',
	                  error: facebookError,
	                  value: facebook,
	                  loading: facebookLoading,
	                  onChange: _this3.handleSocialChange,
	                  count: facebookCount,
	                  isPersonalPage: isFacebookPersonalPage
	                }),
	                _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'facebook' }))
	              )
	            ),
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              position: 'left center',
	              trigger: _react2.default.createElement(
	                'span',
	                { style: blockDisplayStyle },
	                'Twitter',
	                _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	              ),
	              content: HANDLE_PROMPT
	            }),
	            _react2.default.createElement(
	              _semanticUiReact.Form.Group,
	              { widths: 'equal' },
	              _react2.default.createElement(
	                _semanticUiReact.Form.Field,
	                { error: twitterError },
	                _react2.default.createElement(_networkHandleInput2.default, {
	                  fromComponent: 'signup',
	                  network: 'twitter',
	                  error: twitterError,
	                  value: twitter,
	                  loading: twitterLoading,
	                  onChange: _this3.handleSocialChange,
	                  count: twitterCount
	                }),
	                _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'twitter' }))
	              )
	            ),
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              position: 'left center',
	              trigger: _react2.default.createElement(
	                'span',
	                { style: blockDisplayStyle },
	                currentTheme.tiktokLabel || 'Tiktok',
	                _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	              ),
	              content: HANDLE_PROMPT
	            }),
	            _react2.default.createElement(
	              _semanticUiReact.Form.Group,
	              { widths: 'equal' },
	              _react2.default.createElement(
	                _semanticUiReact.Form.Field,
	                { error: tiktokError },
	                _react2.default.createElement(_networkHandleInput2.default, {
	                  fromComponent: 'signup',
	                  network: 'tiktok',
	                  error: tiktokError,
	                  value: tiktok,
	                  loading: tiktokLoading,
	                  onChange: _this3.handleSocialChange,
	                  count: tiktokCount
	                }),
	                _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'tiktok' }))
	              )
	            )
	          ),
	          currentTheme.socialHandle2HtmlBottom && currentTheme.socialHandle2HtmlBottom(),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                display: 'flow-root',
	                width: '100%' }
	            },
	            SW && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                basic: !currentTheme.secondaryButtonColorStyle,
	                style: currentTheme.secondaryButtonColorStyle ? currentTheme.secondaryButtonColorStyle : null,
	                color: currentTheme.secondaryButtonColorStyle ? null : 'black',
	                onClick: SW.previousStep,
	                size: 'medium',
	                floated: 'left'
	              },
	              '\u2190 back'
	            ),
	            SW && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                style: currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null,
	                color: currentTheme.primaryButtonColorStyle ? null : 'pink',
	                size: 'medium',
	                onClick: SW.nextStep,
	                floated: 'right',
	                disabled: disableActionButtons1
	              },
	              'next \u2192'
	            )
	          )
	        );
	      };
	
	      var MoreSocialHandles = function MoreSocialHandles() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          currentTheme.socialHandle3HtmlTitle && currentTheme.socialHandle3HtmlTitle(),
	          !currentTheme.socialHandle3HtmlTitle && currentTheme.formTitle && currentTheme.formTitle(),
	          !currentTheme.formTitle && !currentTheme.socialHandle3HtmlTitle && _react2.default.createElement(
	            'h3',
	            { style: textAlignCentre },
	            'Create your profile'
	          ),
	          _react2.default.createElement('br', null),
	          currentTheme.socialHandle3HtmlTop && currentTheme.socialHandle3HtmlTop(),
	          _react2.default.createElement(_semanticUiReact.Popup, {
	            position: 'left center',
	            trigger: _react2.default.createElement(
	              'span',
	              { style: blockDisplayStyle },
	              'Twitch',
	              _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	            ),
	            content: HANDLE_PROMPT
	          }),
	          _react2.default.createElement(
	            _semanticUiReact.Form,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Form.Group,
	              { widths: 'equal' },
	              _react2.default.createElement(
	                _semanticUiReact.Form.Field,
	                { error: twitchError },
	                _react2.default.createElement(_networkHandleInput2.default, {
	                  fromComponent: 'signup',
	                  network: 'twitch',
	                  error: twitchError,
	                  value: twitch,
	                  loading: twitchLoading,
	                  onChange: _this3.handleSocialChange,
	                  count: twitchCount
	                }),
	                _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'twitch' }))
	              )
	            ),
	            currentTheme.organisationId !== '0aff8cfc-4b27-4c18-9806-87cb83f2b01c' && _react2.default.createElement(
	              'span',
	              { style: blockDisplayFullWidthStyle },
	              'YouTube -',
	              _react2.default.createElement(
	                'span',
	                { style: grey75TextStyle },
	                'Please use Channel ID or Handle, username is not accepted.'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: youtubeHelpUrl, target: 'blank' },
	                _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	              )
	            ),
	            currentTheme.organisationId !== '0aff8cfc-4b27-4c18-9806-87cb83f2b01c' && _react2.default.createElement(
	              _semanticUiReact.Form.Group,
	              { widths: 'equal' },
	              _react2.default.createElement(
	                _semanticUiReact.Form.Field,
	                { error: youtubeError },
	                _react2.default.createElement(_networkHandleInput2.default, {
	                  fromComponent: 'signup',
	                  network: 'youtube',
	                  error: youtubeError,
	                  value: youtube,
	                  loading: youtubeLoading,
	                  onChange: _this3.handleSocialChange,
	                  count: youtubeCount
	                }),
	                _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'youtube' }))
	              )
	            ),
	            currentTheme.organisationId !== '0aff8cfc-4b27-4c18-9806-87cb83f2b01c' && youtubeChannelTitle && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Label,
	                { size: 'large', color: 'green', basic: true },
	                youtubeChannelTitle
	              )
	            ),
	            currentTheme.organisationId !== '0aff8cfc-4b27-4c18-9806-87cb83f2b01c' && !youtubeChannelTitle && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Label,
	                { size: 'large', color: 'grey', basic: true },
	                youtubeLoading ? 'loading...' : 'Youtube Channel Title'
	              )
	            ),
	            _react2.default.createElement('br', null)
	          ),
	          currentTheme.socialHandle3HtmlBottom && currentTheme.socialHandle3HtmlBottom(),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                display: 'flow-root',
	                width: '100%' }
	            },
	            SW && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                basic: !currentTheme.secondaryButtonColorStyle,
	                style: currentTheme.secondaryButtonColorStyle ? currentTheme.secondaryButtonColorStyle : null,
	                color: currentTheme.secondaryButtonColorStyle ? null : 'black',
	                onClick: SW.previousStep,
	                size: 'medium',
	                floated: 'left'
	              },
	              'back'
	            ),
	            SW && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                style: currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null,
	                color: currentTheme.primaryButtonColorStyle ? null : 'pink',
	                size: 'medium',
	                onClick: SW.nextStep,
	                floated: 'right',
	                disabled: disableActionButtons2
	              },
	              'next \u2192'
	            )
	          )
	        );
	      };
	
	      var SignUpMessage = function SignUpMessage() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          currentTheme.signUpTitle && currentTheme.signUpTitle(),
	          !currentTheme.signUpTitle && currentTheme.formTitle && currentTheme.formTitle(),
	          !currentTheme.formTitle && !currentTheme.signUpTitle && _react2.default.createElement(
	            'h3',
	            { style: textAlignCentre },
	            'Create your profile'
	          ),
	          _react2.default.createElement('br', null),
	          currentTheme.signUpHtml && currentTheme.signUpHtml(),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                display: 'flow-root',
	                width: '100%' }
	            },
	            SW && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                basic: !currentTheme.secondaryButtonColorStyle,
	                style: currentTheme.secondaryButtonColorStyle ? currentTheme.secondaryButtonColorStyle : null,
	                color: currentTheme.secondaryButtonColorStyle ? null : 'black',
	                onClick: SW.previousStep,
	                size: 'medium',
	                floated: 'left'
	              },
	              'back'
	            ),
	            SW && _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                style: currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null,
	                color: currentTheme.primaryButtonColorStyle ? null : 'pink',
	                size: 'medium',
	                onClick: SW.nextStep,
	                floated: 'right'
	              },
	              'next \u2192'
	            )
	          )
	        );
	      };
	
	      var Confirmation = function Confirmation() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          !submitting && _react2.default.createElement(
	            'div',
	            null,
	            currentTheme.confirmationTitle && currentTheme.confirmationTitle(),
	            !currentTheme.confirmationTitle && currentTheme.formTitle && currentTheme.formTitle(),
	            !currentTheme.formTitle && !currentTheme.confirmationTitle && _react2.default.createElement(
	              'h3',
	              { style: textAlignCentre },
	              'Create your profile'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { style: checkboxStyle },
	              _react2.default.createElement(_semanticUiReact.Checkbox
	              // label={}
	              , { name: 'tcs',
	                value: tcs,
	                checked: tcs,
	                onChange: _this3.checkboxChange
	              }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { style: { marginLeft: 10 } },
	                'I accept ',
	                currentTheme.shopfluenceTitle || currentTheme.title,
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: currentTheme.tAndCUrl || 'https://shopfluence.app/terms-and-conditions/'
	                  },
	                  'T&Cs'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: checkboxStyle },
	              _react2.default.createElement(_semanticUiReact.Checkbox
	              // label={}
	              , { name: 'privacy',
	                value: privacy,
	                checked: privacy,
	                onChange: _this3.checkboxChange
	              }),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { style: { marginLeft: 10 } },
	                'I accept ',
	                currentTheme.shopfluenceTitle || currentTheme.title,
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: currentTheme.ppUrl || 'https://shopfluence.app/privacy-policy/'
	                  },
	                  'Privacy Policy'
	                )
	              )
	            ),
	            !currentTheme.hideLastCheckbox && _react2.default.createElement(
	              'div',
	              { style: checkboxStyle },
	              _react2.default.createElement(_semanticUiReact.Checkbox, {
	                name: 'newsletter',
	                value: newsletter,
	                checked: newsletter,
	                onChange: _this3.checkboxChange
	              }),
	              ' ',
	              currentTheme.extraCheckboxHtml ? currentTheme.extraCheckboxHtml() : 'Sign me up to ' + currentTheme.title + ' influencer newsletter'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  display: 'flow-root',
	                  width: '100%' }
	              },
	              SW && _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  basic: !currentTheme.secondaryButtonColorStyle,
	                  style: currentTheme.secondaryButtonColorStyle ? currentTheme.secondaryButtonColorStyle : null,
	                  color: currentTheme.secondaryButtonColorStyle ? null : 'black',
	                  onClick: SW.previousStep,
	                  size: 'medium',
	                  floated: 'left'
	                },
	                'back'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  style: currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null,
	                  color: currentTheme.primaryButtonColorStyle ? null : 'pink',
	                  size: 'medium',
	                  onClick: _this3.onSubmit,
	                  disabled: !tcs || !privacy,
	                  floated: 'right'
	                },
	                'Submit'
	              )
	            )
	          ),
	          submitting && _react2.default.createElement(
	            'div',
	            null,
	            currentTheme.formTitle && currentTheme.formTitle(),
	            !currentTheme.formTitle && _react2.default.createElement(
	              'h3',
	              { style: textAlignCentre },
	              'Create your profile'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { style: submissionLoaderStyle },
	              _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: true, inverted: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Loader,
	                  { inverted: true, size: 'large' },
	                  'Your application is being submitted'
	                )
	              )
	            )
	          )
	        );
	      };
	
	      var secondaryNetworkLabel = secondaryNetwork === 'tiktok' ? 'TikTok' : 'Instagram';
	      var secondaryValue = secondaryNetwork === 'tiktok' ? tiktok : instagram;
	      var secondaryLoading = secondaryNetwork === 'tiktok' ? tiktokLoading : instagramLoading;
	      var secondaryError = secondaryNetwork === 'tiktok' ? tiktokError : instagramError;
	      var secondaryCount = secondaryNetwork === 'tiktok' ? tiktokCount : instagramCount;
	
	      var Finished = function Finished() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            { style: textAlignCentre },
	            '\uD83C\uDF89 All done!'
	          ),
	          _react2.default.createElement('br', null),
	          currentTheme.finishedHtml && currentTheme.finishedHtml(newInfluencer),
	          newInfluencer && currentTheme.typeForm && currentTheme.typeForm(newInfluencer),
	          secondaryNetwork && !secondaryHandleSubmitted && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(
	              'h4',
	              { style: textAlignCentre },
	              'Do you also have a ',
	              secondaryNetworkLabel,
	              ' account?'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { textAlign: 'center', color: '#939393', fontSize: '0.9rem', padding: '0.75em 0' } },
	              'Optional \u2014 add your ',
	              secondaryNetworkLabel,
	              ' to strengthen your profile'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Form,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Form.Group,
	                { widths: 'equal' },
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  { error: secondaryError },
	                  _react2.default.createElement(_networkHandleInput2.default, {
	                    fromComponent: 'signup',
	                    network: secondaryNetwork,
	                    error: secondaryError,
	                    value: secondaryValue,
	                    loading: secondaryLoading,
	                    onChange: _this3.handleSecondarySocialChange,
	                    count: secondaryCount
	                  }),
	                  _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, {
	                    platform: secondaryNetwork
	                  }))
	                )
	              ),
	              secondaryLoading && _react2.default.createElement(
	                'div',
	                { style: textAlignCentre },
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { as: 'p', basic: true, color: 'teal' },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'search' }),
	                  ' Searching...'
	                )
	              )
	            ),
	            secondaryHandleError && _react2.default.createElement(
	              'div',
	              { style: { marginTop: '0.5em' } },
	              _react2.default.createElement(
	                _semanticUiReact.Label,
	                { basic: true, color: 'red' },
	                'Something went wrong, please try again.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'center', gap: '1em', marginTop: '1.5em', alignItems: 'center' } },
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  color: 'grey',
	                  size: 'medium',
	                  style: { minWidth: '150px', margin: 0 },
	                  onClick: function onClick() {
	                    return _this3.setState({ secondaryHandleSubmitted: true, secondaryHandleSkipped: true });
	                  }
	                },
	                'No thanks'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  style: Object.assign({ minWidth: '150px', margin: 0 }, currentTheme.primaryButtonColorStyle || {}),
	                  size: 'medium',
	                  onClick: _this3.onSecondaryHandleSubmit,
	                  disabled: !secondaryValue || secondaryLoading || !!secondaryError || secondaryHandleSubmitting,
	                  loading: secondaryHandleSubmitting
	                },
	                'Add ',
	                secondaryNetworkLabel
	              )
	            )
	          ),
	          secondaryHandleSubmitted && !secondaryHandleSkipped && _react2.default.createElement(
	            'div',
	            { style: { marginTop: '1.5em', textAlign: 'center' } },
	            _react2.default.createElement(
	              _semanticUiReact.Label,
	              { basic: true, color: 'green', size: 'large' },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle' }),
	              ' ',
	              secondaryNetworkLabel,
	              ' added successfully!'
	            )
	          )
	        );
	      };
	
	      var Failed = function Failed() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          currentTheme.formTitle && currentTheme.formTitle(),
	          !currentTheme.formTitle && _react2.default.createElement(
	            'h3',
	            { style: textAlignCentre },
	            'Create your profile'
	          ),
	          _react2.default.createElement('br', null),
	          status === 'exist' && _react2.default.createElement(
	            'div',
	            { style: minHeight200 },
	            _react2.default.createElement(
	              'p',
	              { style: textAlignCentre },
	              'You have already signed up.'
	            ),
	            _react2.default.createElement('br', null)
	          ),
	          status === 'failed' && _react2.default.createElement(
	            'div',
	            { style: minHeight200 },
	            _react2.default.createElement(
	              'p',
	              { style: textAlignCentre },
	              'A problem has occured during your sign up, please try again.'
	            ),
	            _react2.default.createElement('br', null)
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { style: containerStyle },
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                null,
	                _react2.default.createElement(_influencerCardPreview2.default, {
	                  primarySocialHandleYoutube: primarySocialHandleYoutube,
	                  youtubeChannelTitle: youtubeChannelTitle,
	                  name: name,
	                  thumbnail: thumbnail,
	                  facebookCount: facebookCount,
	                  twitterCount: twitterCount,
	                  youtubeCount: youtubeCount,
	                  instagramCount: instagramCount,
	                  tiktokCount: tiktokCount,
	                  telegramFound: telegramFound,
	                  primarySocialHandle: primarySocialHandle,
	                  showTelegram: SHOW_TELEGRAM,
	                  instagramLoading: instagramLoading,
	                  brandLogo: currentTheme.useLogoOnPreview ? currentTheme.headerLogo : null
	                }),
	                _react2.default.createElement(
	                  _semanticUiReact.Segment,
	                  null,
	                  isPreLoading && _react2.default.createElement(
	                    'div',
	                    null,
	                    currentTheme.formTitle && currentTheme.formTitle(),
	                    !currentTheme.formTitle && _react2.default.createElement(
	                      'h3',
	                      { style: textAlignCentre },
	                      'Create your profile'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      _semanticUiReact.Segment,
	                      { style: submissionLoaderStyle },
	                      _react2.default.createElement(
	                        _semanticUiReact.Dimmer,
	                        { active: true, inverted: true },
	                        _react2.default.createElement(
	                          _semanticUiReact.Loader,
	                          { inverted: true, size: 'large' },
	                          'Loading your profile...'
	                        )
	                      )
	                    )
	                  ),
	                  !isPreLoading && !confirmed && _react2.default.createElement(
	                    _reactStepWizard2.default,
	                    {
	                      onStepChange: this.handleStepChange,
	                      instance: this.setInstance
	                    },
	                    _react2.default.createElement(Welcome, null),
	                    _react2.default.createElement(Instagram, null),
	                    InfluencerDetails(this.handleChange, name, dob, country, email, contactNumber, SW, sweatcoin, preLoaded),
	                    currentTheme.tagsJson && _react2.default.createElement(Tags, null),
	                    !currentTheme.skipMainHandles && _react2.default.createElement(SocialHandles, null),
	                    !currentTheme.skipAdditionalHandles && _react2.default.createElement(MoreSocialHandles, null),
	                    currentTheme.signUpHtml && _react2.default.createElement(SignUpMessage, null),
	                    _react2.default.createElement(Confirmation, null)
	                  ),
	                  !isPreLoading && confirmed && status === 'created' && _react2.default.createElement(Finished, null),
	                  !isPreLoading && confirmed && status !== 'created' && _react2.default.createElement(Failed, null)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencerFormExternal;
	}(_react.Component);
	
	InfluencerFormExternal.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user.user
	  };
	};
	
	exports.default = (0, _hasUserInfo2.default)((0, _hasRestClient2.default)((0, _hasOrganisation2.default)((0, _reactRedux.connect)(mapStateToProps)(InfluencerFormExternal))));

/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _shortid = __webpack_require__(525);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _reactRedux = __webpack_require__(28);
	
	var _countries = __webpack_require__(93);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _influencerCardPreview = __webpack_require__(349);
	
	var _influencerCardPreview2 = _interopRequireDefault(_influencerCardPreview);
	
	var _influencerContextBar = __webpack_require__(193);
	
	var _influencerContextBar2 = _interopRequireDefault(_influencerContextBar);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _tagsSelector = __webpack_require__(894);
	
	var _tagsSelector2 = _interopRequireDefault(_tagsSelector);
	
	var _businessUnitsSelector = __webpack_require__(862);
	
	var _businessUnitsSelector2 = _interopRequireDefault(_businessUnitsSelector);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasOrganisation = __webpack_require__(106);
	
	var _hasOrganisation2 = _interopRequireDefault(_hasOrganisation);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _validatedEmailField = __webpack_require__(899);
	
	var _validatedEmailField2 = _interopRequireDefault(_validatedEmailField);
	
	var _networkHandleInput = __webpack_require__(277);
	
	var _networkHandleInput2 = _interopRequireDefault(_networkHandleInput);
	
	var _limitsExceededModal = __webpack_require__(886);
	
	var _limitsExceededModal2 = _interopRequireDefault(_limitsExceededModal);
	
	var _duplicatedInfluencerError = __webpack_require__(869);
	
	var _duplicatedInfluencerError2 = _interopRequireDefault(_duplicatedInfluencerError);
	
	var _sendLimitsExceededNotifcation = __webpack_require__(365);
	
	var _sendLimitsExceededNotifcation2 = _interopRequireDefault(_sendLimitsExceededNotifcation);
	
	var _influencerFormOptions = __webpack_require__(548);
	
	var _dyzioIcons = __webpack_require__(92);
	
	var _reduxSaga = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var TELEGRAM_API_BASE_URL = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production';
	var TELEGRAM_CHANNEL_API = TELEGRAM_API_BASE_URL + '/telegram/channel';
	var TELEGRAM_BASE_URL = 'https://t.me/';
	
	var HANDLE_PROMPT = 'Enter the influencers handle, or copy-paste their profile\'s url';
	var INITIAL_DEMOGRAPHICS_LIMIT = 25;
	
	var blockDisplayStyle = {
	  display: 'block',
	  width: 100
	};
	
	var middleVertAlign = {
	  'vertical-align': 'middle'
	};
	
	var blockDisplayFullWidthStyle = {
	  display: 'block',
	  width: '100%'
	};
	
	var grey75TextStyle = {
	  color: '#939393',
	  'font-size': '0.75rem'
	};
	
	var instagramErrorStyle = {
	  color: '#20c49e',
	  opacity: 1
	};
	
	var buttonStyles = {
	  width: '150px'
	};
	
	var businessUnitsHelpUrl = 'https://help.dyzio.co/en/articles/5137000-adding-business-units-or-brands';
	var tagsHelpUrl = 'https://help.dyzio.co/en/articles/4865489-global-tag-manager';
	var youtubeHelpUrl = 'http://help.dyzio.co/en/articles/5543117-adding-an-influencer-s-youtube-channel';
	
	var SocialNetworkIcon = function SocialNetworkIcon(_ref) {
	  var icon = _ref.icon,
	      isBusinessAccount = _ref.isBusinessAccount,
	      isPrivateAccount = _ref.isPrivateAccount;
	
	  if (isBusinessAccount || isPrivateAccount) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(
	        _semanticUiReact.Icon.Group,
	        { size: 'large' },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
	        _react2.default.createElement(_semanticUiReact.Icon, { corner: true, name: isBusinessAccount ? 'briefcase' : 'lock', color: 'pink' })
	      ),
	      content: isBusinessAccount ? 'Business Account' : 'This account is private'
	    });
	  }
	
	  return icon;
	};
	
	var SocialChannelInfo = function SocialChannelInfo(props) {
	  var username = props.username,
	      fullName = props.fullName,
	      icon = props.icon,
	      isVerified = props.isVerified,
	      isBusinessAccount = props.isBusinessAccount,
	      isPrivateAccount = props.isPrivateAccount;
	
	  if (!username) return null;
	  var socialIconProps = { icon: icon, isBusinessAccount: isBusinessAccount, isPrivateAccount: isPrivateAccount };
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(SocialNetworkIcon, socialIconProps)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      username || '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      fullName || '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: isVerified ? 'blue' : 'gray' })
	    )
	  );
	};
	
	var searchTelegramChannel = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(telegram) {
	    var lowerValue, channelUrl, searchUrl, response, data;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            console.log('searchTelegramChannel');
	            lowerValue = _lodash2.default.toLower(telegram);
	            channelUrl = _lodash2.default.replace(lowerValue, TELEGRAM_BASE_URL, '');
	            searchUrl = TELEGRAM_CHANNEL_API + '/' + channelUrl;
	
	            console.log(searchUrl);
	
	            _context.next = 7;
	            return _axios2.default.get(searchUrl);
	
	          case 7:
	            response = _context.sent;
	            data = response.data.data;
	
	            console.log(data);
	            return _context.abrupt('return', data);
	
	          case 11:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function searchTelegramChannel(_x) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var getTelegramAddChannelUrl = function getTelegramAddChannelUrl() {
	  var url = TELEGRAM_API_BASE_URL + '/influencer/telegram/channels';
	  return url;
	};
	
	var addTelegramChannel = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(channelData, userInfo) {
	    var addChannelUrl, payload, response, data;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            console.log('addTelegramChannel');
	
	            addChannelUrl = getTelegramAddChannelUrl();
	            payload = {
	              channelData: channelData,
	              userInfo: userInfo
	            };
	            _context2.next = 5;
	            return _axios2.default.post(addChannelUrl, payload).then(function (r) {
	              return r.data.data;
	            });
	
	          case 5:
	            response = _context2.sent;
	
	            console.log(response);
	            data = response.data;
	            return _context2.abrupt('return', _lodash2.default.get(data, 'id'));
	
	          case 9:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function addTelegramChannel(_x2, _x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	SocialChannelInfo.defaultProps = {
	  isBusinessAccount: false
	};
	
	var InfluencerForm = function (_Component) {
	  _inherits(InfluencerForm, _Component);
	
	  function InfluencerForm() {
	    var _this2 = this;
	
	    _classCallCheck(this, InfluencerForm);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerForm.__proto__ || Object.getPrototypeOf(InfluencerForm)).call(this));
	
	    _this.onSubmit = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(e) {
	        var _this$props, jsonAPIClient, user, userInfo, _this$state, name, email, contactNumber, thumbnail, primarySocialHandle, facebook, facebookCount, instagram, instagramId, instagramCount, twitter, twitterCount, youtube, youtubeCount, youtubeChannelTitle, youtubeData, instagramBusinessAccount, instagramPrivate, instagramProfessionalAccount, instagramCategory, isFacebookPersonalPage, otherChannels, agentName, agentEmail, agentContactNumber, associated, contentTags, brandTags, addressLine1, city, region, postalCode, country, description, web, snapchat, linkedin, pinterest, twitch, twitchCount, twitchUserId, tiktok, tiktokCount, tiktokThumbnail, tiktokProfileData, telegramUser, telegramObj, telegramFound, tags, businessUnits, ageGroup, gender, ethnicity, totalSocialReach, trimmedEmail, data, details, fields, influencer, youtubeChannelId, channelData, dyizTelegramUserId, telegramUserObj;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                e.preventDefault();
	
	                _this$props = _this.props, jsonAPIClient = _this$props.jsonAPIClient, user = _this$props.user, userInfo = _this$props.userInfo;
	                _this$state = _this.state, name = _this$state.name, email = _this$state.email, contactNumber = _this$state.contactNumber, thumbnail = _this$state.thumbnail, primarySocialHandle = _this$state.primarySocialHandle, facebook = _this$state.facebook, facebookCount = _this$state.facebookCount, instagram = _this$state.instagram, instagramId = _this$state.instagramId, instagramCount = _this$state.instagramCount, twitter = _this$state.twitter, twitterCount = _this$state.twitterCount, youtube = _this$state.youtube, youtubeCount = _this$state.youtubeCount, youtubeChannelTitle = _this$state.youtubeChannelTitle, youtubeData = _this$state.youtubeData, instagramBusinessAccount = _this$state.instagramBusinessAccount, instagramPrivate = _this$state.instagramPrivate, instagramProfessionalAccount = _this$state.instagramProfessionalAccount, instagramCategory = _this$state.instagramCategory, isFacebookPersonalPage = _this$state.isFacebookPersonalPage, otherChannels = _this$state.otherChannels, agentName = _this$state.agentName, agentEmail = _this$state.agentEmail, agentContactNumber = _this$state.agentContactNumber, associated = _this$state.associated, contentTags = _this$state.contentTags, brandTags = _this$state.brandTags, addressLine1 = _this$state.addressLine1, city = _this$state.city, region = _this$state.region, postalCode = _this$state.postalCode, country = _this$state.country, description = _this$state.description, web = _this$state.web, snapchat = _this$state.snapchat, linkedin = _this$state.linkedin, pinterest = _this$state.pinterest, twitch = _this$state.twitch, twitchCount = _this$state.twitchCount, twitchUserId = _this$state.twitchUserId, tiktok = _this$state.tiktok, tiktokCount = _this$state.tiktokCount, tiktokThumbnail = _this$state.tiktokThumbnail, tiktokProfileData = _this$state.tiktokProfileData, telegramUser = _this$state.telegramUser, telegramObj = _this$state.telegramObj, telegramFound = _this$state.telegramFound, tags = _this$state.tags, businessUnits = _this$state.businessUnits, ageGroup = _this$state.ageGroup, gender = _this$state.gender, ethnicity = _this$state.ethnicity;
	                totalSocialReach = (parseFloat(facebookCount) || 0) + (parseFloat(instagramCount) || 0) + (parseFloat(twitterCount) || 0) + (parseFloat(twitchCount) || 0) + (parseFloat(tiktokCount) || 0) + (parseFloat(youtubeCount) || 0);
	                trimmedEmail = _lodash2.default.trim(email);
	                data = {
	                  name: name,
	                  email: trimmedEmail,
	                  contactNumber: contactNumber,
	                  thumbnail: thumbnail,
	                  primarySocialHandle: primarySocialHandle,
	                  facebook: facebook,
	                  facebookCount: facebookCount,
	                  instagram: instagram,
	                  instagramCount: instagramCount,
	                  twitter: twitter,
	                  twitterCount: twitterCount,
	                  youtube: youtube,
	                  youtubeCount: youtubeCount,
	                  youtubeChannelTitle: youtubeChannelTitle,
	                  youtubeData: youtubeData,
	                  otherChannels: otherChannels,
	                  totalSocialReach: totalSocialReach,
	                  agentName: agentName,
	                  agentEmail: agentEmail,
	                  agentContactNumber: agentContactNumber,
	                  addressLine1: addressLine1,
	                  city: city,
	                  region: region,
	                  postalCode: postalCode,
	                  country: country,
	                  pinterest: pinterest,
	                  web: web,
	                  snapchat: snapchat,
	                  linkedin: linkedin,
	                  instagramBusinessAccount: instagramBusinessAccount,
	                  instagramProfessionalAccount: instagramProfessionalAccount,
	                  instagramCategory: instagramCategory,
	                  instagramPrivate: instagramPrivate,
	                  isFacebookPersonalPage: isFacebookPersonalPage,
	                  twitch: twitch,
	                  twitchCount: twitchCount,
	                  twitchUserId: twitchUserId,
	                  tiktok: tiktok,
	                  tiktokCount: tiktokCount,
	                  tiktokThumbnail: tiktokThumbnail,
	                  tiktokProfileData: tiktokProfileData,
	                  telegramUser: telegramUser,
	                  telegramObj: telegramObj,
	                  telegramFound: telegramFound,
	                  ageBracket: ageGroup,
	                  gender: gender,
	                  ethnicity: ethnicity
	                };
	                details = {
	                  email: trimmedEmail,
	                  associated: associated,
	                  contentTags: _lodash2.default.split(contentTags, ','),
	                  brandTags: _lodash2.default.split(brandTags, ','),
	                  description: description
	                };
	                fields = ['email', 'contactNumber', 'instagramBusinessAccount', 'instagramProfessionalAccount', 'instagramCategory', 'instagramPrivate', 'thumbnail', 'facebook', 'instagram', 'pinterest', 'twitter', 'youtube', 'agentName', 'agentContactNumber', 'addressLine1', 'city', 'region', 'postalCode', 'country', 'youtubeChannelTitle', 'twitch', 'tiktok', 'tiktokThumbnail', 'tiktokProfileData', 'snapchat', 'linkedin', 'web', 'ageBracket', 'gender', 'ethnicity'];
	
	                // create the influencer
	
	                influencer = jsonAPIClient.create('influencer');
	
	                influencer.set('name', data.name);
	                influencer.set('primarySocialHandle', data.primarySocialHandle);
	                influencer.set('facebookCount', data.facebookCount || 0);
	                influencer.set('instagramCount', data.instagramCount || 0);
	                influencer.set('twitterCount', data.twitterCount || 0);
	                influencer.set('youtubeCount', data.youtubeCount || 0);
	                influencer.set('twitchCount', data.twitchCount || 0);
	                influencer.set('tiktokCount', data.tiktokCount || 0);
	                influencer.set('otherChannels', data.otherChannels);
	                influencer.set('totalSocialReach', data.totalSocialReach);
	                influencer.set('isFacebookPersonalPage', data.isFacebookPersonalPage || false);
	
	                youtubeChannelId = _lodash2.default.get(data, 'youtubeData.id', null);
	
	                if (youtubeChannelId) {
	                  influencer.set('youtubeChannelId', youtubeChannelId);
	                }
	
	                if (data.tiktokProfileData) {
	                  influencer.set('tiktokId', data.tiktokProfileData.id);
	                }
	
	                if (!(telegramFound && telegramUser)) {
	                  _context4.next = 32;
	                  break;
	                }
	
	                // const channelData = await searchTelegramChannel(telegramUser);
	                channelData = data.telegramObj;
	
	
	                console.log('channelData', channelData);
	
	                _context4.next = 28;
	                return addTelegramChannel(channelData, userInfo);
	
	              case 28:
	                dyizTelegramUserId = _context4.sent;
	
	                console.log('dyizTelegramUserId', dyizTelegramUserId);
	
	                telegramUserObj = {
	                  type: 'telegramChannels',
	                  id: dyizTelegramUserId
	                };
	
	                influencer.set('telegramUser', telegramUserObj);
	
	              case 32:
	
	                if (twitchUserId) {
	                  influencer.set('twitchId', _lodash2.default.toNumber(twitchUserId));
	                }
	                if (instagramId) {
	                  influencer.set('instagramId', instagramId);
	                }
	
	                _lodash2.default.forEach(fields, function (field) {
	                  var value = data[field];
	                  if (!_lodash2.default.isNil(value) && !_lodash2.default.isEqual(value, '')) {
	                    influencer.set(field, value);
	                  }
	                });
	
	                influencer.sync().then(function (influencerResponse) {
	                  var flatInfluencer = influencerResponse.toJSON();
	                  var influencerDetails = jsonAPIClient.create('influencerDetails');
	                  influencerDetails.set('associated', details.associated);
	                  influencerDetails.set('contentTags', details.contentTags);
	                  influencerDetails.set('brandTags', details.brandTags);
	                  influencerDetails.set('description', details.description);
	
	                  if (!_lodash2.default.isEmpty(tags)) {
	                    var influencerTags = _lodash2.default.map(tags, function (tag) {
	                      return {
	                        id: tag,
	                        type: 'tags'
	                      };
	                    });
	                    influencerDetails.set('tags', influencerTags);
	                  }
	
	                  if (!_lodash2.default.isEmpty(businessUnits)) {
	                    var influencerbBusinessUnits = _lodash2.default.map(businessUnits, function (businessUnit) {
	                      return {
	                        id: businessUnit,
	                        type: 'businessUnits'
	                      };
	                    });
	                    influencerDetails.set('businessUnits', influencerbBusinessUnits);
	                  }
	
	                  if (details.email) {
	                    influencerDetails.set('email', details.email);
	                  }
	
	                  influencerDetails.sync().then(function () {
	                    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(detailsResponse) {
	                      var influencerLink, instagramHandleInput, cachebuster;
	                      return _regenerator2.default.wrap(function _callee3$(_context3) {
	                        while (1) {
	                          switch (_context3.prev = _context3.next) {
	                            case 0:
	                              influencerLink = jsonAPIClient.create('influencerLink');
	
	                              influencerLink.set('organisation', { type: 'organisations', id: user.organisation.id });
	                              influencerLink.set('influencer', { type: 'influencer', id: flatInfluencer.id });
	                              influencerLink.set('influencerDetails', { type: 'influencerDetails', id: detailsResponse.toJSON().id });
	                              influencerLink.sync();
	
	                              instagramHandleInput = _lodash2.default.get(data, 'instagram');
	
	                              console.log('adding instagram', instagramHandleInput);
	                              console.log('instagram id', instagramId);
	
	                              if (!(instagramHandleInput && _this.state.numberOfProcessedInfluencers < INITIAL_DEMOGRAPHICS_LIMIT && _this.state.numberOfProcessedInfluencers !== -1)) {
	                                _context3.next = 12;
	                                break;
	                              }
	
	                              console.log('sending demographics', instagramHandleInput);
	                              _context3.next = 12;
	                              return _this.sendForDemographics(instagramHandleInput, flatInfluencer.id, instagramId);
	
	                            case 12:
	                              cachebuster = _shortid2.default.generate();
	
	                              _this.context.router.push('/influencers?cb=' + cachebuster);
	
	                            case 14:
	                            case 'end':
	                              return _context3.stop();
	                          }
	                        }
	                      }, _callee3, _this2);
	                    }));
	
	                    return function (_x5) {
	                      return _ref5.apply(this, arguments);
	                    };
	                  }());
	                });
	
	              case 36:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x4) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.leftButtonCallback = function () {
	      return _this.context.router.push('/dashboard');
	    };
	
	    _this.rightButtonCallback = function () {
	      return _this.context.router.push('/influencer/add');
	    };
	
	    _this.loadDemographicsStats = function () {
	      var _this$props2 = _this.props,
	          buildRESTClient = _this$props2.buildRESTClient,
	          organisationId = _this$props2.userInfo.organisationId;
	
	      var influencerFilterApiClient = buildRESTClient({
	        baseURL: ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production")
	      });
	      // const demographicsStatsURl = '/organisation/15e0ffdb-bd62-4eaf-b8ba-fb242ebc6fd6/demographics-stats';
	      var demographicsStatsURl = '/organisation/' + organisationId + '/demographics-stats';
	      influencerFilterApiClient.get(demographicsStatsURl).then(function (response) {
	        var _response$data = response.data,
	            numberOfInfluencers = _response$data.numberOfInfluencers,
	            numberOfProcessedInfluencers = _response$data.numberOfProcessedInfluencers;
	
	        console.log('Demographics Stats fetched', numberOfProcessedInfluencers + '/' + numberOfInfluencers);
	        if (!numberOfProcessedInfluencers && numberOfProcessedInfluencers !== 0) {
	          _this.setState({
	            numberOfInfluencers: -1,
	            numberOfProcessedInfluencers: -1
	          });
	        } else {
	          _this.setState({
	            numberOfInfluencers: numberOfInfluencers,
	            numberOfProcessedInfluencers: numberOfProcessedInfluencers
	          });
	        }
	        console.log('Demographics Stats set', _this.state.numberOfProcessedInfluencers + '/' + _this.state.numberOfInfluencers);
	      }).catch(function (err) {
	        console.log('err', err);
	        _this.setState({
	          numberOfInfluencers: 0,
	          numberOfProcessedInfluencers: 0
	        });
	      });
	      return null;
	    };
	
	    _this.sendForDemographics = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(instagramUsername, id, instagramId) {
	        var payload, buildRESTClient, demographicsAPI;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                console.log(instagramUsername, id);
	                payload = {
	                  data: {
	                    forceScan: true,
	                    influencer: {
	                      username: instagramUsername,
	                      instagramId: instagramId,
	                      id: id
	                    }
	                  }
	                };
	                buildRESTClient = _this.props.buildRESTClient;
	                demographicsAPI = buildRESTClient({
	                  baseURL: ("https://4v3dktn06a.execute-api.eu-west-1.amazonaws.com/production")
	                });
	                _context5.next = 6;
	                return demographicsAPI.post('/production/influencers/process', payload).then(function (response) {
	                  console.log(response.data);
	                }).catch(function (err) {
	                  console.log('err', err);
	                });
	
	              case 6:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x6, _x7, _x8) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.getInstagramFollowerCount = function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(id, followerCount) {
	        var buildRESTClient, instagramFollowerCountApiClient;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                console.log('fetching follower count for instagram ID - ' + id);
	                console.log(("https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/instagram/followers/"));
	                buildRESTClient = _this.props.buildRESTClient;
	                instagramFollowerCountApiClient = buildRESTClient({
	                  baseURL: ("https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/instagram/followers/")
	                });
	
	                instagramFollowerCountApiClient.get(id).then(function (response) {
	                  console.log(response);
	                  var data = response.data;
	
	                  var count = data.data.followerCount;
	                  console.log('IG Follower Count', count);
	                  _this.setState({
	                    instagramCount: count
	                  });
	                }).catch(function (err) {
	                  console.log('err', err);
	                  _this.setState({
	                    instagramCount: followerCount
	                  });
	                });
	
	              case 5:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this2);
	      }));
	
	      return function (_x9, _x10) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    _this.revertDuplicateHandleChannelError = function (channel) {
	      var duplicateInfluencerPlatform = _this.state.duplicateInfluencerPlatform;
	
	      if (_lodash2.default.eq(channel, duplicateInfluencerPlatform)) {
	        _this.setState({
	          duplicateInfluencerHandle: null,
	          duplicateInfluencerPlatform: null,
	          duplicateInfluencerLinkId: null
	        });
	      }
	    };
	
	    _this.getChannelData = function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(channel, handle) {
	        var count, loading, error, thumbnail, options, _details, details, _this$props3, buildRESTClient, organisationId, influencerFilterApiClient, duplicateCheck, exists, dupID, _this$setState2;
	
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                count = channel + 'Count';
	                loading = channel + 'Loading';
	                error = channel + 'Error';
	                thumbnail = channel + 'Thumbnail';
	
	                _this.revertDuplicateHandleChannelError(channel);
	
	                if (channel === 'instagram') {
	                  _this.setState({
	                    instagramError: false,
	                    instagramErrorCode: ''
	                  });
	                }
	
	                options = {
	                  data: {
	                    platform: channel,
	                    name: _lodash2.default.trimStart(handle, '@')
	                  }
	                };
	
	
	                _this.setState(_defineProperty({}, loading, true));
	
	                if (!(handle.length === 0)) {
	                  _context7.next = 43;
	                  break;
	                }
	
	                details = (_details = {}, _defineProperty(_details, loading, false), _defineProperty(_details, count, 0), _defineProperty(_details, error, false), _defineProperty(_details, thumbnail, ''), _details);
	                _context7.t0 = channel;
	                _context7.next = _context7.t0 === 'facebook' ? 13 : _context7.t0 === 'instagram' ? 17 : _context7.t0 === 'twitter' ? 21 : _context7.t0 === 'youtube' ? 25 : _context7.t0 === 'twitch' ? 30 : _context7.t0 === 'tiktok' ? 34 : _context7.t0 === 'telegram' ? 37 : 41;
	                break;
	
	              case 13:
	                details.facebookPageName = null;
	                details.facebookUserName = null;
	                details.facebookVerified = false;
	                return _context7.abrupt('break', 42);
	
	              case 17:
	                details.instagramFullName = null;
	                details.instagramUserName = null;
	                details.instagramVerified = false;
	                return _context7.abrupt('break', 42);
	
	              case 21:
	                details.twitterPageName = null;
	                details.twitterUserName = null;
	                details.twitterVerified = false;
	                return _context7.abrupt('break', 42);
	
	              case 25:
	                details.youtubeChannelTitle = null;
	                details.youtubeChannelUserName = null;
	                details.youtubeVerified = false;
	                details.youtubeData = null;
	                return _context7.abrupt('break', 42);
	
	              case 30:
	                details.name = null;
	                details.twitchChannelTitle = null;
	                details.twitchUserId = null;
	                return _context7.abrupt('break', 42);
	
	              case 34:
	                details.tiktokName = null;
	                details.tiktokVerified = false;
	                return _context7.abrupt('break', 42);
	
	              case 37:
	                details.telegramUser = null;
	                details.telegramFound = 0;
	                details.telegramObj = {};
	                return _context7.abrupt('break', 42);
	
	              case 41:
	                return _context7.abrupt('break', 42);
	
	              case 42:
	                return _context7.abrupt('return', _this.setState(_extends({}, details)));
	
	              case 43:
	                _this$props3 = _this.props, buildRESTClient = _this$props3.buildRESTClient, organisationId = _this$props3.userInfo.organisationId;
	                influencerFilterApiClient = buildRESTClient({
	                  baseURL: ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production")
	                });
	                _context7.next = 47;
	                return influencerFilterApiClient.get('influencer/influencer-duplicate-check', {
	                  params: {
	                    organisationId: organisationId,
	                    platform: channel,
	                    handle: handle
	                  }
	                }).catch(function (err) {
	                  return console.error(err);
	                });
	
	              case 47:
	                duplicateCheck = _context7.sent;
	                exists = _lodash2.default.get(duplicateCheck, 'data.data.exists', false);
	                dupID = _lodash2.default.head(_lodash2.default.get(duplicateCheck, 'data.data.ids', []));
	
	                if (!exists) {
	                  _context7.next = 53;
	                  break;
	                }
	
	                _this.setState((_this$setState2 = {
	                  duplicateInfluencerHandle: handle,
	                  duplicateInfluencerPlatform: channel,
	                  duplicateInfluencerLinkId: dupID
	                }, _defineProperty(_this$setState2, loading, false), _defineProperty(_this$setState2, error, true), _defineProperty(_this$setState2, channel, null), _this$setState2));
	                return _context7.abrupt('return', null);
	
	              case 53:
	                return _context7.abrupt('return', _axios2.default.post(("https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer"), options).then(function (response) {
	                  var _this$setState3;
	
	                  if (_lodash2.default.isEqual(channel, 'instagram') && response.data.statusCode === 500) {
	                    _this.setState({
	                      instagramErrorCode: 'NO_MATCH'
	                    });
	                  }
	
	                  _this.setState((_this$setState3 = {}, _defineProperty(_this$setState3, loading, false), _defineProperty(_this$setState3, count, response.data.body.data.followerCount), _defineProperty(_this$setState3, error, false), _defineProperty(_this$setState3, thumbnail, response.data.body.data.thumbnail), _this$setState3));
	
	                  var country = response.data.body.data.location;
	
	                  var details = {};
	                  switch (channel) {
	                    case 'facebook':
	                      details.name = response.data.body.data.pagename;
	                      details.facebookPageName = response.data.body.data.pagename;
	                      details.facebookUserName = response.data.body.data.username;
	                      details.facebookVerified = response.data.body.data.verified;
	                      details.isFacebookPersonalPage = response.data.body.data.isPersonalPage;
	                      _this.revertDuplicateHandleChannelError('facebook');
	                      break;
	                    case 'instagram':
	                      details.name = response.data.body.data.full_name;
	                      details.instagramFullName = response.data.body.data.full_name;
	                      details.instagramUserName = response.data.body.data.username;
	                      details.instagramVerified = response.data.body.data.isVerified;
	                      details.instagramBusinessAccount = response.data.body.data.instagramBusinessAccount;
	                      details.instagramPrivate = response.data.body.data.isPrivate;
	                      details.instagramProfessionalAccount = response.data.body.data.instagramProfessionalAccount;
	                      if (response.data.body.data.instagramCategory) {
	                        details.instagramCategory = response.data.body.data.instagramCategory;
	                      }
	                      details.instagramId = response.data.body.data.id;
	                      _this.getInstagramFollowerCount(details.instagramId, response.data.body.data.followerCount);
	                      _this.revertDuplicateHandleChannelError('instagram');
	                      break;
	                    case 'twitter':
	                      details.twitterPageName = response.data.body.data.name;
	                      details.name = response.data.body.data.name;
	                      details.twitterUserName = response.data.body.data.screen_name;
	                      details.twitterVerified = response.data.body.data.verified;
	                      _this.revertDuplicateHandleChannelError('twitter');
	                      break;
	                    case 'youtube':
	                      details.youtubeChannelTitle = response.data.body.data.channelTitle;
	                      details.name = response.data.body.data.channelTitle;
	                      details.youtubeChannelUserName = response.data.body.data.username;
	                      details.youtubeVerified = response.data.body.data.verified;
	                      details.youtubeData = response.data.body.data;
	                      _this.revertDuplicateHandleChannelError('youtube');
	                      break;
	                    case 'twitch':
	                      details.name = response.data.body.data.name;
	                      details.twitchChannelTitle = response.data.body.data.name;
	                      details.twitchUserId = response.data.body.data.userId;
	                      _this.revertDuplicateHandleChannelError('twitch');
	                      break;
	                    case 'tiktok':
	                      details.tiktokName = response.data.body.data.name;
	                      details.tiktokVerified = response.data.body.data.verified;
	                      details.tiktokThumbnail = response.data.body.data.thumbnail;
	                      details.tiktokProfileData = response.data.body.data;
	                      _this.revertDuplicateHandleChannelError('tiktok');
	                      break;
	                    default:
	                      break;
	                  }
	
	                  if (channel === 'telegram') {
	                    var telegramData = response.data.body.data;
	                    var type = telegramData.typeInfo.type,
	                        ogResponse = telegramData.ogResponse;
	
	                    console.log('get telegram user data');
	                    console.log(telegramData);
	                    console.log(type === 'USER');
	
	                    if (type !== 'USER') {
	                      details.telegramError = true;
	                    } else {
	                      details.telegramUser = handle;
	                      details.telegramObj = response.data.body.data;
	                      details.telegramFound = 1;
	                      var telegramThumbnail = _lodash2.default.get(ogResponse, 'openGraph.image.url');
	                      details.name = _lodash2.default.get(ogResponse, 'openGraph.title');
	                      if (telegramThumbnail) {
	                        details.thumbnail = telegramThumbnail;
	                      }
	                    }
	                    // this.revertDuplicateHandleChannelError('telegram');
	                  }
	
	                  var newState = _lodash2.default.assign({
	                    thumbnail: response.data.body.data.thumbnail,
	                    country: country,
	                    shouldRenderSocialHandlesBlock: true
	                  }, details);
	
	                  _this.setState(newState);
	
	                  var _this$state2 = _this.state,
	                      handles = _this$state2.handles,
	                      youtubeChannelTitle = _this$state2.youtubeChannelTitle;
	
	                  var o = {
	                    key: channel,
	                    value: channel,
	                    text: channel === 'youtube' ? youtubeChannelTitle + ' (' + channel + ')' : handle + ' (' + channel + ')'
	                  };
	                  var a = handles.filter(function (obj) {
	                    return obj.key !== channel;
	                  });
	                  a.push(o);
	                  _this.setState({ handles: a });
	                }).catch(function (e) {
	                  var _this$setState4;
	
	                  // if instagramErrorCode not set to NO_MATCH then it is a genuine error
	                  console.log(e);
	                  var instagramErrorCode = _this.state.instagramErrorCode;
	
	                  if (!instagramErrorCode) {
	                    if (_lodash2.default.isEqual(channel, 'instagram')) {
	                      _this.setState({
	                        instagramErrorCode: 'ERROR'
	                      });
	                    }
	                  }
	                  _this.setState((_this$setState4 = {}, _defineProperty(_this$setState4, loading, false), _defineProperty(_this$setState4, error, true), _this$setState4));
	                }));
	
	              case 54:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x11, _x12) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    _this.componentDidMount = function () {
	      var _this$props4 = _this.props,
	          campaignAPIClient = _this$props4.campaignAPIClient,
	          restClient = _this$props4.restClient,
	          _this$props4$userInfo = _this$props4.userInfo,
	          organisationId = _this$props4$userInfo.organisationId,
	          name = _this$props4$userInfo.name,
	          id = _this$props4$userInfo.id,
	          organisation = _this$props4.organisation;
	
	      _this.setState({
	        isLoadingTotals: true
	      });
	
	      var requests = [campaignAPIClient.get('/summary/influencers?organisationId=' + organisationId)];
	
	      _this.loadDemographicsStats();
	
	      return Promise.all(requests).then(function (_ref9) {
	        var _ref10 = _slicedToArray(_ref9, 1),
	            totalInfluencers = _ref10[0].data.data.totalInfluencers;
	
	        return _this.setState({
	          totalInfluencers: totalInfluencers,
	          isLoadingTotals: false
	        }, _this.checkLimitsNotification);
	      });
	    };
	
	    _this.componentWillReceiveProps = function (newProps, oldProps) {
	      if (newProps.organisation && newProps.userInfo && _lodash2.default.get(newProps, 'organisation.name') !== _lodash2.default.get(oldProps, 'organisation.name')) {
	        _this.checkLimitsNotification();
	      }
	    };
	
	    _this.checkLimitsNotification = function () {
	      var _this$props5 = _this.props,
	          restClient = _this$props5.restClient,
	          _this$props5$userInfo = _this$props5.userInfo,
	          organisationId = _this$props5$userInfo.organisationId,
	          name = _this$props5$userInfo.name,
	          userId = _this$props5$userInfo.userId,
	          organisation = _this$props5.organisation;
	      var totalInfluencers = _this.state.totalInfluencers;
	
	      if (!totalInfluencers || !organisation) return;
	      if (totalInfluencers < organisation.licenseInfluencerLimit) return;
	      (0, _sendLimitsExceededNotifcation2.default)(restClient, {
	        data: {
	          name: name + ' ',
	          organisationId: organisationId,
	          userId: userId,
	          organisationName: organisation.name + ' ',
	          assetType: 'influencers',
	          licenseSubscriptionType: organisation.licenseSubscriptionType,
	          url: window.location.href
	        }
	      });
	    };
	
	    _this.getPrimaryHandleOptions = function () {
	      var _this$state3 = _this.state,
	          facebook = _this$state3.facebook,
	          facebookCount = _this$state3.facebookCount,
	          instagram = _this$state3.instagram,
	          instagramCount = _this$state3.instagramCount,
	          twitter = _this$state3.twitter,
	          twitterCount = _this$state3.twitterCount,
	          youtube = _this$state3.youtube,
	          youtubeCount = _this$state3.youtubeCount,
	          telegramUser = _this$state3.telegramUser,
	          telegramFound = _this$state3.telegramFound;
	
	      var optionsArray = [];
	      if (facebookCount) {
	        var option = {
	          key: 'a',
	          text: facebook,
	          value: 'facebook'
	        };
	        optionsArray.push(option);
	      }
	
	      if (instagramCount) {
	        var _option = {
	          key: 'b',
	          text: instagram,
	          value: 'instagram'
	        };
	        optionsArray.push(_option);
	      }
	
	      if (twitterCount) {
	        var _option2 = {
	          key: 'c',
	          text: twitter,
	          value: 'twitter'
	        };
	        optionsArray.push(_option2);
	      }
	
	      if (youtubeCount) {
	        var _option3 = {
	          key: 'd',
	          text: youtube,
	          value: 'youtube'
	        };
	        optionsArray.push(_option3);
	      }
	
	      if (telegramFound) {
	        var _option4 = {
	          key: 'e',
	          text: telegramUser,
	          value: 'telegram'
	        };
	        optionsArray.push(_option4);
	      }
	
	      return optionsArray;
	    };
	
	    _this.handleChange = function (e, v) {
	      _this.setState(_defineProperty({}, v.name, v.value));
	    };
	
	    _this.handlePrimarySocialHandleChange = function (e, v) {
	      var _this$state4 = _this.state,
	          facebook = _this$state4.facebook,
	          facebookThumbnail = _this$state4.facebookThumbnail,
	          facebookPageName = _this$state4.facebookPageName,
	          instagram = _this$state4.instagram,
	          instagramFullName = _this$state4.instagramFullName,
	          instagramThumbnail = _this$state4.instagramThumbnail,
	          twitter = _this$state4.twitter,
	          twitterPageName = _this$state4.twitterPageName,
	          twitterThumbnail = _this$state4.twitterThumbnail,
	          youtube = _this$state4.youtube,
	          youtubeChannelTitle = _this$state4.youtubeChannelTitle,
	          youtubeThumbnail = _this$state4.youtubeThumbnail,
	          twitch = _this$state4.twitch,
	          twitchThumbnail = _this$state4.twitchThumbnail,
	          tiktok = _this$state4.tiktok,
	          tiktokName = _this$state4.tiktokName,
	          tiktokThumbnail = _this$state4.tiktokThumbnail,
	          telegramUser = _this$state4.telegramUser,
	          telegramObj = _this$state4.telegramObj;
	
	
	      if (v.value === 'telegram') {
	        _this.setState({
	          thumbnail: _lodash2.default.get(telegramObj, 'ogResponse.openGraph.image.url'),
	          name: _lodash2.default.get(telegramObj, 'ogResponse.openGraph.title'),
	          primarySocialHandle: telegramUser,
	          primarySocialHandleYoutube: false
	        });
	      }
	
	      if (v.value === 'tiktok') {
	        _this.setState({
	          thumbnail: tiktokThumbnail,
	          name: tiktokName,
	          primarySocialHandle: tiktok,
	          primarySocialHandleYoutube: false
	        });
	      }
	
	      if (v.value === 'twitch') {
	        _this.setState({
	          thumbnail: twitchThumbnail,
	          primarySocialHandle: twitch,
	          primarySocialHandleYoutube: false
	        });
	      }
	
	      if (v.value === 'facebook') {
	        _this.setState({
	          thumbnail: facebookThumbnail,
	          name: facebookPageName,
	          primarySocialHandle: facebook,
	          primarySocialHandleYoutube: false
	        });
	      }
	      if (v.value === 'instagram') {
	        _this.setState({
	          thumbnail: instagramThumbnail,
	          name: instagramFullName,
	          primarySocialHandle: instagram,
	          primarySocialHandleYoutube: false
	        });
	      }
	      if (v.value === 'twitter') {
	        _this.setState({
	          thumbnail: twitterThumbnail,
	          name: twitterPageName,
	          primarySocialHandle: twitter,
	          primarySocialHandleYoutube: false
	        });
	      }
	      if (v.value === 'youtube') {
	        _this.setState({
	          thumbnail: youtubeThumbnail,
	          name: youtubeChannelTitle,
	          primarySocialHandle: youtube,
	          primarySocialHandleYoutube: true
	        });
	      }
	    };
	
	    _this.handleTagChange = function (e, v) {
	      var name = v.name,
	          value = v.value;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.onInfluencerEmailStateChanged = function (isValid, value) {
	      _this.setState({
	        isEmailFieldValid: isValid,
	        email: value
	      });
	    };
	
	    _this.handleBasicSocialChange = function (e, v) {
	      var name = v.name,
	          value = v.value;
	
	      _this.setState(_defineProperty({}, name, _lodash2.default.replace(value, /\s/g, '')));
	    };
	
	    _this.handleSocialChange = function (e, v) {
	      var value = _lodash2.default.replace(_lodash2.default.get(v, 'value'), /\s/g, '');
	      _this.setState(_defineProperty({}, v.name, value));
	      var timeout = _this.state.timeout;
	      clearTimeout(timeout);
	      timeout = setTimeout(function () {
	        return _this.getChannelData(v.name, value);
	      }, 500);
	      _this.setState({ timeout: timeout });
	    };
	
	    _this.retryInstagramHandle = function () {
	      var instagram = _this.state.instagram;
	
	      console.log('retry search for instagram handle', instagram);
	      _this.getChannelData('instagram', instagram);
	    };
	
	    _this.handleChannelAdd = function () {
	      var _this$state5 = _this.state,
	          newChannelName = _this$state5.newChannelName,
	          newChannelHandle = _this$state5.newChannelHandle,
	          otherChannels = _this$state5.otherChannels;
	
	      var obj = {
	        name: newChannelName,
	        handle: newChannelHandle
	      };
	      otherChannels.push(obj);
	      _this.setState({ otherChannels: otherChannels, newChannelName: '', newChannelHandle: '' });
	    };
	
	    _this.handleChannelRemove = function (name, handle) {
	      var otherChannels = _this.state.otherChannels;
	
	      var a = otherChannels.filter(function (o) {
	        return o.name !== name;
	      });
	      _this.setState({ otherChannels: a });
	    };
	
	    _this.findIcon = function (c, e) {
	      if (e) {
	        return 'close';
	      }
	      return c > 0 ? 'check' : 'search';
	    };
	
	    _this.onTagSelected = function (tagId) {
	      var selectedTags = _this.state.tags;
	
	      var tags = _lodash2.default.concat(selectedTags, [tagId]);
	      _this.setState({
	        tags: tags
	      });
	    };
	
	    _this.onUnselected = function (tagId) {
	      var selectedTags = _this.state.tags;
	
	      var tags = _lodash2.default.reject(selectedTags, function (tag) {
	        return tag === tagId;
	      });
	      _this.setState({
	        tags: tags
	      });
	    };
	
	    _this.onBusinessUnitSelected = function (businessUnitId) {
	      var selectedBusinessUnits = _this.state.businessUnits;
	
	      var businessUnits = _lodash2.default.concat(selectedBusinessUnits, [businessUnitId]);
	      _this.setState({
	        businessUnits: businessUnits
	      });
	    };
	
	    _this.onUnselectedBusinessUnit = function (businessUnitId) {
	      var selectedBusinessUnits = _this.state.businessUnits;
	
	      var businessUnits = _lodash2.default.reject(selectedBusinessUnits, function (businessUnit) {
	        return businessUnit === businessUnitId;
	      });
	      _this.setState({
	        businessUnits: businessUnits
	      });
	    };
	
	    _this.toggleOptionalInfo = function (e, titleProps) {
	      var index = titleProps.index;
	      var activeIndex = _this.state.activeIndex;
	
	      var newIndex = activeIndex === index ? -1 : index;
	
	      _this.setState({ activeIndex: newIndex });
	    };
	
	    _this.state = {
	      name: '',
	      email: '',
	      contactNumber: '',
	      thumbnail: '',
	      primarySocialHandle: '',
	      facebook: '',
	      facebookPageName: '',
	      facebookUserName: '',
	      facebookCount: '',
	      facebookLoading: false,
	      facebookError: false,
	      instagram: '',
	      instagramUsername: '',
	      instagramId: '',
	      instagramFullName: '',
	      instagramCount: '',
	      instagramLoading: false,
	      instagramError: false,
	      instagramErrorCode: '',
	      instagramBusinessAccount: false,
	      instagramProfessionalAccount: false,
	      instagramCategory: '',
	      isFacebookPersonalPage: false,
	      instagramPrivate: false,
	      twitter: '',
	      twitterCount: '',
	      twitterLoading: false,
	      twitterError: false,
	      twitch: '',
	      twitchCount: '',
	      twitchLoading: false,
	      twitchError: false,
	      tiktok: '',
	      tiktokCount: '',
	      tiktokUserId: '',
	      tiktokName: '',
	      tiktokLoading: false,
	      tiktokError: false,
	      tiktokVerified: false,
	      tiktokThumbnail: '',
	      tiktokProfileData: {},
	      youtube: '',
	      twitchUserId: '',
	      youtubeCount: '',
	      youtubeErorr: false,
	      youtubeLoading: false,
	      youtubeChannelTitle: '',
	      primarySocialHandleYoutube: false,
	      otherChannels: [],
	      addChannel: false,
	      newChannelName: '',
	      newChannelHandle: '',
	      handles: [],
	      agent: false,
	      agentName: '',
	      agentEmail: '',
	      agentContactNumber: '',
	      associated: true,
	      contentTags: [],
	      brandTags: [],
	      addressLine1: '',
	      city: '',
	      region: '',
	      postalCode: '',
	      country: '',
	      description: '',
	      timeout: null,
	      web: '',
	      snapchat: '',
	      linkedin: '',
	      tags: [],
	      businessUnits: [],
	      telegramUser: '',
	      telegramFound: '',
	      telegramObj: {},
	      telegramLoading: false,
	      telegramError: false,
	
	      facebookVerified: false,
	      twitterVerified: false,
	      youtubeVerified: false,
	      instagramVerified: false,
	
	      isEmailFieldValid: true,
	
	      duplicateInfluencerHandle: '',
	      duplicateInfluencerPlatform: '',
	      duplicateInfluencerLinkId: '',
	
	      activeIndex: -1
	    };
	    return _this;
	  }
	
	  _createClass(InfluencerForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          organisation = _props.organisation,
	          organisationLoading = _props.organisationLoading;
	      var _state = this.state,
	          name = _state.name,
	          email = _state.email,
	          contactNumber = _state.contactNumber,
	          thumbnail = _state.thumbnail,
	          country = _state.country,
	          primarySocialHandle = _state.primarySocialHandle,
	          facebook = _state.facebook,
	          facebookCount = _state.facebookCount,
	          facebookLoading = _state.facebookLoading,
	          facebookError = _state.facebookError,
	          instagram = _state.instagram,
	          instagramCount = _state.instagramCount,
	          instagramLoading = _state.instagramLoading,
	          instagramError = _state.instagramError,
	          instagramErrorCode = _state.instagramErrorCode,
	          twitter = _state.twitter,
	          twitterCount = _state.twitterCount,
	          twitterLoading = _state.twitterLoading,
	          twitterError = _state.twitterError,
	          youtube = _state.youtube,
	          youtubeChannelTitle = _state.youtubeChannelTitle,
	          youtubeCount = _state.youtubeCount,
	          youtubeLoading = _state.youtubeLoading,
	          youtubeError = _state.youtubeError,
	          otherChannels = _state.otherChannels,
	          addChannel = _state.addChannel,
	          newChannelName = _state.newChannelName,
	          newChannelHandle = _state.newChannelHandle,
	          handles = _state.handles,
	          agent = _state.agent,
	          agentName = _state.agentName,
	          agentEmail = _state.agentEmail,
	          agentContactNumber = _state.agentContactNumber,
	          associated = _state.associated,
	          contentTags = _state.contentTags,
	          brandTags = _state.brandTags,
	          addressLine1 = _state.addressLine1,
	          city = _state.city,
	          region = _state.region,
	          postalCode = _state.postalCode,
	          description = _state.description,
	          primarySocialHandleYoutube = _state.primarySocialHandleYoutube,
	          web = _state.web,
	          snapchat = _state.snapchat,
	          linkedin = _state.linkedin,
	          pinterest = _state.pinterest,
	          facebookPageName = _state.facebookPageName,
	          facebookUserName = _state.facebookUserName,
	          instagramFullName = _state.instagramFullName,
	          instagramUserName = _state.instagramUserName,
	          twitterUserName = _state.twitterUserName,
	          twitterPageName = _state.twitterPageName,
	          youtubeChannelUserName = _state.youtubeChannelUserName,
	          facebookVerified = _state.facebookVerified,
	          twitterVerified = _state.twitterVerified,
	          instagramVerified = _state.instagramVerified,
	          youtubeVerified = _state.youtubeVerified,
	          instagramBusinessAccount = _state.instagramBusinessAccount,
	          instagramPrivate = _state.instagramPrivate,
	          isEmailFieldValid = _state.isEmailFieldValid,
	          isFacebookPersonalPage = _state.isFacebookPersonalPage,
	          isLoadingTotals = _state.isLoadingTotals,
	          totalInfluencers = _state.totalInfluencers,
	          twitch = _state.twitch,
	          twitchCount = _state.twitchCount,
	          twitchError = _state.twitchError,
	          twitchLoading = _state.twitchLoading,
	          twitchChannelTitle = _state.twitchChannelTitle,
	          tiktok = _state.tiktok,
	          tiktokCount = _state.tiktokCount,
	          tiktokLoading = _state.tiktokLoading,
	          tiktokName = _state.tiktokName,
	          tiktokError = _state.tiktokError,
	          tiktokVerified = _state.tiktokVerified,
	          telegramUser = _state.telegramUser,
	          telegramFound = _state.telegramFound,
	          telegramError = _state.telegramError,
	          telegramLoading = _state.telegramLoading,
	          duplicateInfluencerHandle = _state.duplicateInfluencerHandle,
	          duplicateInfluencerPlatform = _state.duplicateInfluencerPlatform,
	          duplicateInfluencerLinkId = _state.duplicateInfluencerLinkId,
	          tags = _state.tags,
	          businessUnits = _state.businessUnits,
	          activeIndex = _state.activeIndex,
	          ageGroup = _state.ageGroup,
	          gender = _state.gender,
	          ethnicity = _state.ethnicity;
	
	
	      var duplicateErrorProps = {
	        duplicateInfluencerHandle: duplicateInfluencerHandle,
	        duplicateInfluencerPlatform: duplicateInfluencerPlatform,
	        duplicateInfluencerLinkId: duplicateInfluencerLinkId
	      };
	
	      var addInfluencerLinkStyles = {
	        color: '#1db08e',
	        textWeight: 'bold'
	      };
	
	      var sheetIconStyle = {
	        marginTop: 20,
	        marginBottom: 25,
	        color: '#1db08e'
	      };
	
	      var shouldDisableSubmitForm = !name || !primarySocialHandle || facebookLoading || instagramLoading || twitterLoading || !isEmailFieldValid || youtubeLoading || telegramLoading;
	
	      var isFullWhiteLabel = _themeSelector2.default.isFullWhiteLabel();
	
	      if (organisationLoading || isLoadingTotals) {
	        return _react2.default.createElement(
	          'h1',
	          null,
	          ' Loading... '
	        );
	      }
	
	      var licenseInfluencerLimit = organisation.licenseInfluencerLimit;
	
	
	      if (totalInfluencers >= licenseInfluencerLimit) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'page' },
	          _react2.default.createElement(_influencerContextBar2.default, {
	            rightButtonCallback: this.rightButtonCallback,
	            leftButtonCallback: this.leftButtonCallback,
	            leftButtonLabel: 'Create A Campaign',
	            rightButtonLabel: 'Add An Influencer',
	            title: 'Back'
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'page-content' },
	            _react2.default.createElement(_limitsExceededModal2.default, { assetType: 'influencer' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_influencerContextBar2.default, {
	          rightButtonCallback: this.rightButtonCallback,
	          leftButtonCallback: this.leftButtonCallback,
	          leftButtonLabel: 'Create A Campaign',
	          rightButtonLabel: 'Add An Influencer',
	          title: 'Back'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                null,
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'Add an Influencer'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: '10' },
	                _react2.default.createElement(
	                  _semanticUiReact.Segment,
	                  { padded: true },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Social info'
	                  ),
	                  _react2.default.createElement('div', { className: 'spacer small' }),
	                  _react2.default.createElement(
	                    _semanticUiReact.Form,
	                    { error: true, onSubmit: this.onSubmit },
	                    _react2.default.createElement(_semanticUiReact.Popup, {
	                      position: 'left center',
	                      trigger: _react2.default.createElement(
	                        'span',
	                        { style: blockDisplayStyle },
	                        'Facebook',
	                        _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	                      ),
	                      content: HANDLE_PROMPT
	                    }),
	                    _react2.default.createElement(
	                      _semanticUiReact.Form.Group,
	                      { widths: 'equal' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Form.Field,
	                        { error: facebookError },
	                        _react2.default.createElement(_networkHandleInput2.default, {
	                          network: 'facebook',
	                          error: facebookError,
	                          value: facebook,
	                          loading: facebookLoading,
	                          onChange: this.handleSocialChange,
	                          count: facebookCount,
	                          isPersonalPage: isFacebookPersonalPage
	                        }),
	                        _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'facebook' }))
	                      )
	                    ),
	                    _react2.default.createElement(_semanticUiReact.Popup, {
	                      position: 'left center',
	                      trigger: _react2.default.createElement(
	                        'span',
	                        { style: blockDisplayStyle },
	                        'Instagram',
	                        _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	                      ),
	                      content: HANDLE_PROMPT
	                    }),
	                    _react2.default.createElement(
	                      _semanticUiReact.Form.Group,
	                      { widths: 'equal' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Form.Field,
	                        { error: instagramError },
	                        _react2.default.createElement(_networkHandleInput2.default, {
	                          network: 'instagram',
	                          error: instagramError,
	                          value: instagram,
	                          loading: instagramLoading,
	                          onChange: this.handleSocialChange,
	                          count: instagramCount
	                        }),
	                        _lodash2.default.isEqual(instagramErrorCode, 'ERROR') && _react2.default.createElement(
	                          _semanticUiReact.Label,
	                          { basic: true, color: 'red', pointing: true },
	                          'Sorry\u2026 the search failed, ',
	                          _react2.default.createElement(
	                            'a',
	                            { style: instagramErrorStyle, onClick: this.retryInstagramHandle },
	                            'click here'
	                          ),
	                          ' to try again!'
	                        ),
	                        _lodash2.default.isEqual(instagramErrorCode, 'NO_MATCH') && _react2.default.createElement(
	                          _semanticUiReact.Label,
	                          { basic: true, color: 'red', pointing: true },
	                          'Sorry we could not find that username, please check it and try again!'
	                        ),
	                        _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'instagram' }))
	                      )
	                    ),
	                    _react2.default.createElement(_semanticUiReact.Popup, {
	                      position: 'left center',
	                      trigger: _react2.default.createElement(
	                        'span',
	                        { style: blockDisplayStyle },
	                        'Twitter',
	                        _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	                      ),
	                      content: HANDLE_PROMPT
	                    }),
	                    _react2.default.createElement(
	                      _semanticUiReact.Form.Group,
	                      { widths: 'equal' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Form.Field,
	                        { error: twitterError },
	                        _react2.default.createElement(_networkHandleInput2.default, {
	                          network: 'twitter',
	                          error: twitterError,
	                          value: twitter,
	                          loading: twitterLoading,
	                          onChange: this.handleSocialChange,
	                          count: twitterCount
	                        }),
	                        _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'twitter' }))
	                      )
	                    ),
	                    _react2.default.createElement(_semanticUiReact.Popup, {
	                      position: 'left center',
	                      trigger: _react2.default.createElement(
	                        'span',
	                        { style: blockDisplayStyle },
	                        'TikTok',
	                        _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	                      ),
	                      content: HANDLE_PROMPT
	                    }),
	                    _react2.default.createElement(
	                      _semanticUiReact.Form.Group,
	                      { widths: 'equal' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Form.Field,
	                        { error: tiktokError },
	                        _react2.default.createElement(_networkHandleInput2.default, {
	                          network: 'tiktok',
	                          error: tiktokError,
	                          value: tiktok,
	                          loading: tiktokLoading,
	                          onChange: this.handleSocialChange,
	                          count: tiktokCount
	                        }),
	                        _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'tiktok' }))
	                      )
	                    ),
	                    _react2.default.createElement(_semanticUiReact.Popup, {
	                      position: 'left center',
	                      trigger: _react2.default.createElement(
	                        'span',
	                        { style: blockDisplayStyle },
	                        'Twitch',
	                        _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	                      ),
	                      content: HANDLE_PROMPT
	                    }),
	                    _react2.default.createElement(
	                      _semanticUiReact.Form.Group,
	                      { widths: 'equal' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Form.Field,
	                        { error: twitchError },
	                        _react2.default.createElement(_networkHandleInput2.default, {
	                          network: 'twitch',
	                          error: twitchError,
	                          value: twitch,
	                          loading: twitchLoading,
	                          onChange: this.handleSocialChange,
	                          count: twitchCount
	                        }),
	                        _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'twitch' }))
	                      )
	                    ),
	                    _react2.default.createElement(_semanticUiReact.Popup, {
	                      position: 'left center',
	                      trigger: _react2.default.createElement(
	                        'span',
	                        { style: blockDisplayStyle },
	                        'Telegram',
	                        _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	                      ),
	                      content: HANDLE_PROMPT
	                    }),
	                    _react2.default.createElement(
	                      _semanticUiReact.Form.Group,
	                      { widths: 'equal' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Form.Field,
	                        { error: telegramError },
	                        _react2.default.createElement(_networkHandleInput2.default, {
	                          network: 'telegram',
	                          error: telegramError,
	                          value: telegramUser,
	                          loading: telegramLoading,
	                          onChange: this.handleSocialChange,
	                          count: telegramFound
	                        }),
	                        telegramError && _react2.default.createElement(
	                          _semanticUiReact.Label,
	                          { basic: true, color: 'red', pointing: true },
	                          'We can only accept a valid Telegram user handle (channels and groups are not accepted)'
	                        ),
	                        _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'telegram' }))
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { style: blockDisplayFullWidthStyle },
	                      'YouTube -',
	                      _react2.default.createElement(
	                        'span',
	                        { style: grey75TextStyle },
	                        'Please use Channel ID, Handle, or Username'
	                      ),
	                      _react2.default.createElement(
	                        'a',
	                        { href: youtubeHelpUrl, target: 'blank' },
	                        _react2.default.createElement('img', { style: middleVertAlign, src: '/icons/info.svg', alt: 'info' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Form.Group,
	                      { widths: 'equal' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Form.Field,
	                        { error: youtubeError },
	                        _react2.default.createElement(_networkHandleInput2.default, {
	                          network: 'youtube',
	                          error: youtubeError,
	                          value: youtube,
	                          loading: youtubeLoading,
	                          onChange: this.handleSocialChange,
	                          count: youtubeCount
	                        }),
	                        _react2.default.createElement(_duplicatedInfluencerError2.default, Object.assign({}, duplicateErrorProps, { platform: 'youtube' }))
	                      )
	                    ),
	                    youtubeChannelTitle ? _react2.default.createElement(
	                      _semanticUiReact.Label,
	                      { size: 'large', color: 'green', basic: true },
	                      youtubeChannelTitle
	                    ) : _react2.default.createElement(
	                      _semanticUiReact.Label,
	                      { size: 'large', color: 'grey', basic: true },
	                      youtubeLoading ? 'loading...' : 'Youtube Channel Title'
	                    ),
	                    _react2.default.createElement(_semanticUiReact.Divider, null),
	                    _react2.default.createElement(_semanticUiReact.Form.Dropdown, {
	                      name: 'primarySocialHandle',
	                      label: 'What are they most known by?',
	                      width: 12,
	                      selection: true,
	                      options: handles,
	                      onChange: this.handlePrimarySocialHandleChange,
	                      placeholder: 'Select...',
	                      required: true,
	                      disabled: !facebook && !instagram && !twitterCount && !youtubeCount && !twitchCount && !tiktokCount && !telegramUser
	                    }),
	                    _react2.default.createElement('div', { className: 'spacer small' }),
	                    _react2.default.createElement(_semanticUiReact.Form.Input, {
	                      width: 12,
	                      label: 'Name',
	                      placeholder: 'Influencer\'s real name',
	                      name: 'name',
	                      onChange: this.handleChange,
	                      value: name,
	                      required: true
	                    }),
	                    _react2.default.createElement('div', { className: 'spacer small' }),
	                    _react2.default.createElement(_semanticUiReact.Form.Dropdown, {
	                      search: true,
	                      selection: true,
	                      width: 12,
	                      label: 'Country',
	                      value: country,
	                      name: 'country',
	                      options: _countries2.default,
	                      onChange: this.handleChange,
	                      required: true
	                    }),
	                    _react2.default.createElement(_semanticUiReact.Form.Select, {
	                      label: 'Age',
	                      width: 12,
	                      placeholder: 'Select age group',
	                      name: 'ageGroup',
	                      value: ageGroup,
	                      options: _influencerFormOptions.ageOptions,
	                      onChange: this.handleChange,
	                      clearable: true
	                    }),
	                    _react2.default.createElement(_semanticUiReact.Form.Select, {
	                      label: 'Gender',
	                      width: 12,
	                      placeholder: 'Select gender',
	                      name: 'gender',
	                      value: gender,
	                      options: _influencerFormOptions.genderOptions,
	                      onChange: this.handleChange,
	                      clearable: true
	                    }),
	                    _react2.default.createElement(_semanticUiReact.Form.Select, {
	                      label: 'Ethnicity',
	                      width: 12,
	                      placeholder: 'Select ethnicity',
	                      name: 'ethnicity',
	                      value: ethnicity,
	                      options: _influencerFormOptions.ethnicityOptions,
	                      onChange: this.handleChange,
	                      clearable: true
	                    }),
	                    _react2.default.createElement('div', { className: 'spacer' }),
	                    _react2.default.createElement(_semanticUiReact.Divider, null),
	                    _react2.default.createElement('div', { className: 'spacer' }),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Contact details'
	                    ),
	                    _react2.default.createElement('div', { className: 'spacer small' }),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Add the influencer\'s personal email address, if you plan to invite them to authenticate their social accounts for campaign tracking.'
	                    ),
	                    _react2.default.createElement('div', { className: 'spacer small' }),
	                    _react2.default.createElement(_validatedEmailField2.default, {
	                      onStateChanged: this.onInfluencerEmailStateChanged
	                    }),
	                    _react2.default.createElement('div', { className: 'spacer' }),
	                    _react2.default.createElement(_semanticUiReact.Divider, null),
	                    _react2.default.createElement('div', { className: 'spacer' }),
	                    _react2.default.createElement(
	                      _semanticUiReact.Accordion,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Accordion.Title,
	                        {
	                          active: activeIndex === 0,
	                          index: 0,
	                          onClick: this.toggleOptionalInfo
	                        },
	                        activeIndex !== 0 ? _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'toggle down', basic: true, content: 'expand all', onClick: this.toggleCardView, style: buttonStyles }) : _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'toggle up', basic: true, content: 'collapse all', onClick: this.toggleCardView, style: buttonStyles })
	                      ),
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Optional Information (tags & business units)'
	                      ),
	                      _react2.default.createElement('div', { className: 'spacer small' }),
	                      _react2.default.createElement(
	                        _semanticUiReact.Accordion.Content,
	                        { active: activeIndex === 0 },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          'Tags'
	                        ),
	                        _react2.default.createElement('div', { className: 'spacer small' }),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Add tags to your influencer helps you filter your database. To learn how to set-up and manage your global tags ',
	                          _react2.default.createElement(
	                            _targetLink2.default,
	                            { href: tagsHelpUrl, renderIf: true },
	                            'click here'
	                          )
	                        ),
	                        _react2.default.createElement('div', { className: 'spacer small' }),
	                        _react2.default.createElement(_tagsSelector2.default, {
	                          selectedTags: tags,
	                          onSelected: this.onTagSelected,
	                          onUnselected: this.onUnselected
	                        }),
	                        _react2.default.createElement('div', { className: 'spacer small' }),
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          'Business Units & Brands'
	                        ),
	                        _react2.default.createElement('div', { className: 'spacer small' }),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Add the business unit or brand that this influencer belongs to. To learn how to add new business units of brands ',
	                          _react2.default.createElement(
	                            _targetLink2.default,
	                            { href: businessUnitsHelpUrl, renderIf: true },
	                            'click here'
	                          )
	                        ),
	                        _react2.default.createElement('div', { className: 'spacer small' }),
	                        _react2.default.createElement(_businessUnitsSelector2.default, {
	                          selectedBusinessUnits: businessUnits,
	                          onSelected: this.onBusinessUnitSelected,
	                          onUnselected: this.onUnselectedBusinessUnit
	                        })
	                      )
	                    ),
	                    _react2.default.createElement('div', { className: 'spacer small' }),
	                    _react2.default.createElement(_semanticUiReact.Divider, null),
	                    _react2.default.createElement('div', { className: 'spacer' }),
	                    _react2.default.createElement(
	                      _semanticUiReact.Form.Button,
	                      { disabled: shouldDisableSubmitForm, width: 12, fluid: true, color: 'pink', size: 'large' },
	                      'Add Influencer'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: '6' },
	                _react2.default.createElement(_influencerCardPreview2.default, {
	                  primarySocialHandleYoutube: primarySocialHandleYoutube,
	                  youtubeChannelTitle: youtubeChannelTitle,
	                  name: name,
	                  thumbnail: thumbnail,
	                  facebookCount: facebookCount,
	                  twitterCount: twitterCount,
	                  youtubeCount: youtubeCount,
	                  instagramCount: instagramCount,
	                  tiktokCount: tiktokCount,
	                  telegramFound: telegramFound,
	                  primarySocialHandle: primarySocialHandle
	                }),
	                (youtubeChannelTitle || instagramUserName || facebookPageName || twitch || tiktok || twitterUserName || telegramUser) && _react2.default.createElement(
	                  _semanticUiReact.Table,
	                  { singleLine: true, textAlign: 'center', verticalAlign: 'middle' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Header,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        null,
	                        'platform'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        null,
	                        'handle'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        null,
	                        'display name'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        null,
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'grey' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Body,
	                    null,
	                    _react2.default.createElement(SocialChannelInfo, {
	                      isVerified: twitterVerified,
	                      username: twitterUserName,
	                      fullName: twitterPageName,
	                      icon: _react2.default.createElement(_dyzioIcons.TwitterIcon, { size: 'large' })
	                    }),
	                    _react2.default.createElement(SocialChannelInfo, {
	                      isVerified: facebookVerified,
	                      username: facebookUserName,
	                      fullName: facebookPageName,
	                      icon: _react2.default.createElement(_dyzioIcons.FacebookIcon, { size: 'large' })
	                    }),
	                    _react2.default.createElement(SocialChannelInfo, {
	                      isVerified: instagramVerified,
	                      username: instagramUserName,
	                      fullName: instagramFullName,
	                      icon: _react2.default.createElement(_dyzioIcons.InstagramIcon, { size: 'large' }),
	                      isBusinessAccount: instagramBusinessAccount,
	                      isPrivateAccount: instagramPrivate
	                    }),
	                    _react2.default.createElement(SocialChannelInfo, {
	                      isVerified: youtubeVerified,
	                      username: youtubeChannelUserName,
	                      fullName: youtubeChannelTitle,
	                      icon: _react2.default.createElement(_dyzioIcons.YoutubeIcon, { size: 'large' })
	                    }),
	                    _react2.default.createElement(SocialChannelInfo, {
	                      isVerified: tiktokVerified,
	                      username: tiktok,
	                      fullName: tiktokName,
	                      icon: _react2.default.createElement(_dyzioIcons.TiktokIcon, { size: 'large' })
	                    }),
	                    _react2.default.createElement(SocialChannelInfo, {
	                      isVerified: false,
	                      username: twitch,
	                      fullName: twitchChannelTitle,
	                      icon: _react2.default.createElement(_dyzioIcons.TwitchIcon, { size: 'large' })
	                    }),
	                    _react2.default.createElement(SocialChannelInfo, {
	                      isVerified: false,
	                      username: telegramUser,
	                      fullName: telegramUser,
	                      icon: _react2.default.createElement(_dyzioIcons.TelegramIcon, { size: 'large' })
	                    })
	                  )
	                ),
	                !isFullWhiteLabel && _react2.default.createElement(
	                  _semanticUiReact.Segment,
	                  { textAlign: 'center' },
	                  _react2.default.createElement(_semanticUiReact.Icon, { style: sheetIconStyle, name: 'file excel outline', size: 'huge' }),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Already have a spreadsheet of your influencers?'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        {
	                          rel: 'noopener noreferrer',
	                          target: '_blank',
	                          style: addInfluencerLinkStyles,
	                          href: 'https://help.dyzio.co/my-influencers-private-database/import-your-influencers-by-spreadsheet'
	                        },
	                        ' Add them to dyzio'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencerForm;
	}(_react.Component);
	
	InfluencerForm.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user.user
	  };
	};
	
	exports.default = (0, _hasUserInfo2.default)((0, _hasRestClient2.default)((0, _hasOrganisation2.default)((0, _reactRedux.connect)(mapStateToProps)(InfluencerForm))));

/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _validator = __webpack_require__(84);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _horizontalCollaborationCard = __webpack_require__(1948);
	
	var _horizontalCollaborationCard2 = _interopRequireDefault(_horizontalCollaborationCard);
	
	var _helperFunctions = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var h5DescriptionStyle = {
	  paddingBottom: 15
	};
	
	var groupStyle = {
	  marginBottom: 15
	};
	
	var messageStyle = { margin: '0px 10px' };
	var HIDE_BROKEN_INFLUENCERS = true;
	
	var InfluencerGroupByStatus = function InfluencerGroupByStatus(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      discussions = _ref.discussions,
	      emptyText = _ref.emptyText,
	      campaign = _ref.campaign,
	      getInvitationStatus = _ref.getInvitationStatus,
	      reviewMode = _ref.reviewMode;
	
	  var liveDate = campaign.get('liveDate');
	  var endDate = campaign.get('endDate');
	
	  var startMoment = (0, _moment2.default)(liveDate);
	  var endMoment = (0, _moment2.default)(endDate);
	  var today = (0, _moment2.default)();
	
	  var hasStarted = startMoment.isValid() ? today.isSameOrAfter(startMoment) : false;
	  var hasEnded = endMoment.isValid() ? endMoment.isBefore(today) : false;
	
	  var isLiveCampaign = hasStarted && !hasEnded;
	
	  return _react2.default.createElement(
	    'div',
	    { style: groupStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      { fluid: true },
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 3 },
	          _react2.default.createElement(
	            'h3',
	            null,
	            title
	          ),
	          _react2.default.createElement(
	            'h5',
	            { style: h5DescriptionStyle },
	            description
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 13, verticalAlign: 'middle' },
	          _lodash2.default.isEmpty(discussions) && _react2.default.createElement(
	            _semanticUiReact.Message,
	            { fluid: true, style: messageStyle },
	            _react2.default.createElement(
	              'p',
	              null,
	              emptyText
	            )
	          ),
	          !_lodash2.default.isEmpty(discussions) && _react2.default.createElement(
	            _semanticUiReact.Card.Group,
	            { itemsPerRow: 'one' },
	            _lodash2.default.map(discussions, function (discussion) {
	              var influencer = discussion.influencer || (0, _helperFunctions.getInfluencerFromOrganisations)(discussion.organisations);
	
	              var isEmailValid = _validator2.default.isEmail(influencer && influencer.email ? influencer.email : '');
	              var invitationStatus = getInvitationStatus({ discussion: discussion });
	              var discussionName = discussion.name;
	
	              var assets = _lodash2.default.compact(_lodash2.default.get(discussion, 'trackedAssets', []));
	              var manualStories = _lodash2.default.size(_lodash2.default.filter(assets, ['assetType', 'STORY']));
	
	              var stories = _lodash2.default.size(_lodash2.default.compact(_lodash2.default.get(discussion, 'stories', [])));
	
	              var totalStories = _lodash2.default.add(stories, manualStories);
	              var totalAssets = _lodash2.default.size(_lodash2.default.uniqBy(_lodash2.default.reject(assets, ['assetType', 'STORY']), 'assetId'));
	
	              var campaignJSON = campaign.toJSON();
	              var rollfwdCampaign = campaignJSON.rollfwdCampaign;
	
	              var influencerProps = _lodash2.default.pick(influencer, ['email', 'primarySocialHandle', 'thumbnail', 'instagramStatus', 'facebookStatus', 'twitterStatus', 'youtubeStatus', 'instagramPrivate', 'facebook', 'instagram', 'youtube', 'twitter', 'tiktok', 'telegramChannels', 'usageRightsGranted', 'discountCode']);
	
	              var derivedProps = _extends({
	                discussionId: discussion.id,
	                discussionName: discussionName,
	                campaignId: campaign.get('id'),
	                campaignWorkflow: campaign.get('workflow'),
	                influencerName: _lodash2.default.get(influencer, 'name', ''),
	                rollfwdCampaign: rollfwdCampaign,
	                reviewMode: reviewMode,
	                isEmailValid: isEmailValid,
	                invitationStatus: invitationStatus,
	                totalAssets: totalAssets,
	                totalStories: totalStories
	              }, influencerProps, {
	                lastScannedDate: discussion.lastScannedDate,
	                lastSuccessfulStoryScan: discussion.lastSuccessfulStoryScan,
	                isLiveCampaign: isLiveCampaign,
	                hasPosted: _lodash2.default.get(discussion, 'hasPosted', false),
	                instagramScanFailures: _lodash2.default.get(discussion, 'instagramScanFailures', 0),
	                isScanningCompleted: _lodash2.default.get(discussion, 'isScanningCompleted'),
	                internalDiscountCode: _lodash2.default.get(discussion, 'internalDiscountCode'),
	                workflowStatus: _lodash2.default.get(discussion, 'workflowStatus')
	              });
	
	              if (influencer) {
	                return _react2.default.createElement(_horizontalCollaborationCard2.default, derivedProps);
	              }
	
	              if (!HIDE_BROKEN_INFLUENCERS) {
	                return _react2.default.createElement(
	                  _semanticUiReact.Card,
	                  { color: 'red' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    null,
	                    _react2.default.createElement(
	                      'table',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'td',
	                          { style: { width: 50, textAlign: 'center' } },
	                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning circle', color: 'red', size: 'big' })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Broken Influencer'
	                          ),
	                          _react2.default.createElement(
	                            'h5',
	                            { style: { color: 'grey' } },
	                            derivedProps.discussionName
	                          )
	                        )
	                      )
	                    )
	                  )
	                );
	              }
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, null)
	  );
	};
	
	InfluencerGroupByStatus.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string.isRequired,
	  campaign: _propTypes2.default.object.isRequired,
	  emptyText: _propTypes2.default.string.isRequired,
	  getInvitationStatus: _propTypes2.default.func.isRequired,
	  discussions: _propTypes2.default.array
	};
	
	InfluencerGroupByStatus.defaultProps = {
	  discussions: []
	};
	
	exports.default = InfluencerGroupByStatus;

/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfluencerIcon = function InfluencerIcon(props) {
	  return _react2.default.createElement(_semanticUiReact.Image, Object.assign({}, props, { src: '/icons/my-influencers.svg' }));
	};
	
	exports.default = InfluencerIcon;

/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(37);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _influencerCategory = __webpack_require__(547);
	
	var _influencerCategory2 = _interopRequireDefault(_influencerCategory);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TEAM_DYZIO_ID = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';
	var ALLOWED_ORGS = [];
	
	var dyzioPinkStyle = {
	  color: '#fc4085'
	};
	
	var tiktokIconStyle = {
	  width: 15,
	  marginTop: 2
	};
	
	var activeLinkStyle = {
	  color: 'black',
	  opacity: 1,
	  display: 'block',
	  borderBottom: '4px solid black',
	  padding: '4px 0'
	};
	
	var simpleLinkStyle = {
	  color: 'black',
	  opacity: '0.5',
	  display: 'block',
	  borderBottom: '4px solid white',
	  padding: '4px 0'
	};
	
	var tabStyle = {
	  borderBottom: 'none',
	  padding: 0,
	  opacity: 1
	};
	
	var ABBOTTLYON = '6b7ed405-e8ef-4b8d-9515-f09108e9e367';
	
	var getMediaCardBaseURL = function getMediaCardBaseURL() {
	  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  if (host.match(/theinfluencer/i)) {
	    return 'https://share.theinfluencer.es';
	  }
	  if (host.match(/influxer/i)) {
	    return 'https://brands.influxer.co.uk';
	  }
	  return 'https://app.dyzio.co';
	};
	
	var MediaKitLauncher = function MediaKitLauncher(_ref) {
	  var influencer = _ref.influencer,
	      mediaKitUrl = _ref.mediaKitUrl;
	
	  var safeUrl = mediaKitUrl ? _lodash2.default.trimEnd(mediaKitUrl, '/') : getMediaCardBaseURL(window.origin);
	
	  var url = safeUrl + '/media-kit/' + influencer.id;
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Icon, {
	      link: true,
	      onClick: function onClick() {
	        return window.open(url, '_blank');
	      },
	      name: 'address card outline',
	      size: 'huge',
	      style: dyzioPinkStyle
	    }),
	    content: 'Open Media Kit for ' + influencer.name + ' (in a new window).'
	  });
	};
	
	MediaKitLauncher.defaultProps = {
	  mediaKitUrl: 'https://app.dyzio.co'
	};
	
	var InfluencerInfoBar = function InfluencerInfoBar(props) {
	  var influencer = props.influencer,
	      influencerDetails = props.influencerDetails,
	      id = props.id,
	      withBlogosphereTab = props.withBlogosphereTab,
	      onADRModalStateChanged = props.onADRModalStateChanged,
	      organisationId = props.organisationId,
	      organisation = props.organisation;
	
	
	  if (!influencer) return null;
	  var name = influencer.name,
	      thumbnail = influencer.thumbnail,
	      primarySocialHandle = influencer.primarySocialHandle,
	      facebookCount = influencer.facebookCount,
	      instagramCount = influencer.instagramCount,
	      twitterCount = influencer.twitterCount,
	      youtubeCount = influencer.youtubeCount,
	      facebook = influencer.facebook,
	      instagram = influencer.instagram,
	      twitter = influencer.twitter,
	      youtube = influencer.youtube,
	      twitch = influencer.twitch,
	      twitchCount = influencer.twitchCount,
	      tiktok = influencer.tiktok,
	      tiktokCount = influencer.tiktokCount,
	      telegramUser = influencer.telegramUser;
	  var assessment = influencerDetails.assessment;
	
	
	  var youtubeSlug = void 0;
	  if (youtube) {
	    var idRegEx = /^UC([a-zA-Z0-9_-]{22})$/;
	    var isChannelId = function isChannelId(yt) {
	      return yt.match(idRegEx);
	    };
	    youtubeSlug = isChannelId(youtube) ? 'channel/' + youtube : '@' + youtube;
	  }
	
	  var commaFormat = function commaFormat(num) {
	    var format = num > 1000000 ? '0.0a' : '0a';
	    return (0, _numeral2.default)(num).format(format);
	  };
	
	  var dataPermission = props.dataPermission,
	      isLoadingPermission = props.isLoadingPermission;
	
	  var adrStatus = dataPermission && dataPermission.requestStatus;
	
	  var proxyInfluencer = {
	    youtubeCount: youtubeCount,
	    facebookCount: facebookCount,
	    instagramCount: instagramCount,
	    twitterCount: twitterCount
	  };
	
	  var ADR_BUTTON_STATES = {
	    APPROVED: {
	      label: 'Approved',
	      icon: 'checkmark',
	      colour: 'green',
	      disabled: true
	    },
	    PENDING: {
	      label: 'Pending',
	      icon: 'clock',
	      colour: 'orange',
	      disabled: true
	    }
	  };
	
	  var displayAuthorisedData = _lodash2.default.get(organisation, 'displayAuthorisedData', false);
	
	  var canOrgDisplay = _lodash2.default.includes(ALLOWED_ORGS, organisationId);
	  var shouldRenderStories = displayAuthorisedData;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'page-hero flex no-border' },
	      _react2.default.createElement(
	        'div',
	        { className: 'item' },
	        _react2.default.createElement(_semanticUiReact.Image, { src: thumbnail, alt: name, size: 'tiny', shape: 'circular', spaced: 'right' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'space' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          name,
	          '\xA0\xA0',
	          _react2.default.createElement(
	            'span',
	            { className: 'light' },
	            primarySocialHandle
	          )
	        ),
	        _react2.default.createElement('div', { className: 'spacer small' }),
	        _react2.default.createElement(_semanticUiReact.Rating, { icon: 'star', rating: assessment, maxRating: 5, disabled: true })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'space' },
	        !isLoadingPermission && canOrgDisplay && _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	          label: _lodash2.default.get(ADR_BUTTON_STATES, adrStatus + '.label', 'Send ADR request'),
	          color: _lodash2.default.get(ADR_BUTTON_STATES, adrStatus + '.colour', 'pink'),
	          hasIcon: true,
	          disabled: _lodash2.default.get(ADR_BUTTON_STATES, adrStatus + '.disabled', false),
	          onClick: onADRModalStateChanged,
	          icon: _react2.default.createElement(_semanticUiReact.Icon, { name: _lodash2.default.get(ADR_BUTTON_STATES, adrStatus + '.icon', 'send') })
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex' },
	          _react2.default.createElement(
	            'div',
	            { className: 'space align-center' },
	            _react2.default.createElement(
	              _targetLink2.default,
	              {
	                href: 'https://www.facebook.com/' + facebook,
	                renderIf: facebook
	              },
	              _react2.default.createElement('img', { src: '/icons/facebook.svg', alt: 'Facebook' }),
	              facebook && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                commaFormat(facebookCount)
	              ),
	              !facebook && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'space align-center' },
	            _react2.default.createElement(
	              _targetLink2.default,
	              {
	                href: 'https://www.instagram.com/' + instagram,
	                renderIf: instagram
	              },
	              _react2.default.createElement('img', { src: '/icons/instagram.svg', alt: 'Instagram' }),
	              instagram && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                commaFormat(instagramCount)
	              ),
	              !instagram && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'space align-center' },
	            _react2.default.createElement(
	              _targetLink2.default,
	              {
	                href: 'https://www.twitter.com/' + twitter,
	                renderIf: twitter
	              },
	              _react2.default.createElement('img', { src: '/icons/twitter.svg', alt: 'Twitter' }),
	              twitter && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                commaFormat(twitterCount)
	              ),
	              !twitter && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'space align-center' },
	            _react2.default.createElement(
	              _targetLink2.default,
	              {
	                href: 'https://www.youtube.com/' + youtubeSlug,
	                renderIf: youtube
	              },
	              _react2.default.createElement('img', { src: '/icons/youtube.svg', alt: 'YouTube' }),
	              youtube && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                commaFormat(youtubeCount)
	              ),
	              !youtube && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'space align-center' },
	            _react2.default.createElement(
	              _targetLink2.default,
	              {
	                href: 'https://www.twitch.com/' + twitch,
	                renderIf: twitch && twitchCount
	              },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitch', color: 'purple' }),
	              twitch && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                commaFormat(twitchCount)
	              ),
	              !twitch && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'space align-center' },
	            _react2.default.createElement(
	              _targetLink2.default,
	              {
	                href: 'https://www.tiktok.com/@' + tiktok,
	                renderIf: tiktok
	              },
	              _react2.default.createElement('img', { style: tiktokIconStyle, src: 'https://app.dyzio.co/logos/tiktok-logo.svg', alt: 'Tiktok' }),
	              tiktok && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                commaFormat(tiktokCount)
	              ),
	              !tiktok && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'space align-center' },
	            _react2.default.createElement(
	              _targetLink2.default,
	              {
	                href: 'https://www.facebook.com/' + facebook,
	                renderIf: false
	              },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram', color: 'blue' }),
	              telegramUser && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'green' })
	              ),
	              !telegramUser && _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'space' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'item align-center' },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Category'
	              )
	            ),
	            _react2.default.createElement(_influencerCategory2.default, { influencer: proxyInfluencer })
	          ),
	          _react2.default.createElement('div', { className: 'space' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'item align-center' },
	            _react2.default.createElement(MediaKitLauncher, { influencer: influencer, mediaKitUrl: organisation && organisation.mediaKitUrl })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-tabs' },
	      _react2.default.createElement(
	        'div',
	        { className: 'tab', style: tabStyle },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: simpleLinkStyle, to: '/influencer/' + id + '/statistics', activeStyle: activeLinkStyle },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Statistics'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'tab', style: tabStyle },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: simpleLinkStyle, to: '/influencer/' + id + '/latest', activeStyle: activeLinkStyle },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Latest Posts'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'tab', style: tabStyle },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: simpleLinkStyle, to: '/influencer/' + id + '/campaigns', activeStyle: activeLinkStyle },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Campaigns'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'tab', style: tabStyle },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: simpleLinkStyle, to: '/influencer/' + id + '/profile', activeStyle: activeLinkStyle },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Profile'
	            )
	          )
	        )
	      ),
	      instagram && shouldRenderStories && _react2.default.createElement(
	        'div',
	        { className: 'tab', style: tabStyle },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: simpleLinkStyle, to: '/influencer/' + id + '/stories', activeStyle: activeLinkStyle },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Stories'
	            )
	          )
	        )
	      ),
	      withBlogosphereTab && _react2.default.createElement(
	        'div',
	        { className: 'tab', style: tabStyle },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: simpleLinkStyle, to: '/influencer/' + id + '/blogosphere', activeStyle: activeLinkStyle },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Blogosphere'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'tab', style: tabStyle },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: simpleLinkStyle, to: '/influencer/' + id + '/rates', activeStyle: activeLinkStyle },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Rates'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'tab', style: tabStyle },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: simpleLinkStyle, to: '/influencer/' + id + '/reviews', activeStyle: activeLinkStyle },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Notes & Reviews'
	            )
	          )
	        )
	      ),
	      organisationId === ABBOTTLYON && _react2.default.createElement(
	        'div',
	        { className: 'tab', style: tabStyle },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: simpleLinkStyle, to: '/influencer/' + id + '/questionnaire', activeStyle: activeLinkStyle },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Questionnaire'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	InfluencerInfoBar.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  id: _propTypes2.default.string.isRequired,
	  router: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(InfluencerInfoBar);

/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _profileLatestTweets = __webpack_require__(1971);
	
	var _profileLatestTweets2 = _interopRequireDefault(_profileLatestTweets);
	
	var _profileLatestYoutubeVideos = __webpack_require__(1972);
	
	var _profileLatestYoutubeVideos2 = _interopRequireDefault(_profileLatestYoutubeVideos);
	
	var _profileLatestInstagrams = __webpack_require__(1969);
	
	var _profileLatestInstagrams2 = _interopRequireDefault(_profileLatestInstagrams);
	
	var _profileLatestTiktoks = __webpack_require__(1970);
	
	var _profileLatestTiktoks2 = _interopRequireDefault(_profileLatestTiktoks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfluencerLatest = function (_Component) {
	  _inherits(InfluencerLatest, _Component);
	
	  function InfluencerLatest() {
	    _classCallCheck(this, InfluencerLatest);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerLatest.__proto__ || Object.getPrototypeOf(InfluencerLatest)).call(this));
	
	    _this.state = {
	      instagramData: null,
	      twitterData: null,
	      youtubeData: null,
	      tiktokProfileData: null,
	      tiktok: null,
	      loading: false,
	      tiktokLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(InfluencerLatest, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props$influencer = this.props.influencer,
	          instagramId = _props$influencer.instagramId,
	          twitter = _props$influencer.twitter,
	          youtube = _props$influencer.youtube,
	          tiktokProfileData = _props$influencer.tiktokProfileData,
	          tiktok = _props$influencer.tiktok,
	          statisticsUpdatedDate = _props$influencer.statisticsUpdatedDate;
	
	
	      if (tiktokProfileData) {
	        tiktokProfileData.statisticsUpdatedDate = statisticsUpdatedDate;
	        this.setState({
	          tiktokProfileData: tiktokProfileData,
	          tiktok: tiktok,
	          tiktokLoading: true
	        });
	      }
	
	      this.setState({
	        loading: true
	      });
	
	      (0, _axios2.default)({
	        method: 'post',
	        url: ("https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer/latest"),
	        data: {
	          instagramId: instagramId,
	          twitter: twitter,
	          youtube: youtube
	        }
	      }).then(function (response) {
	        _this2.setState({
	          instagramData: response.data.body.instagram,
	          twitterData: response.data.body.twitter,
	          youtubeData: response.data.body.youtube,
	          loading: false
	        });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	
	      (0, _axios2.default)({
	        method: 'get',
	        url: 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/tiktok/rapid/posts/user/' + tiktok
	      }).then(function (response) {
	        console.log(response.data);
	        _this2.setState({
	          tiktokProfileData: response.data,
	          tiktokLoading: false
	        });
	      }).catch(function (error) {
	        return console.log(error);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          instagramData = _state.instagramData,
	          twitterData = _state.twitterData,
	          youtubeData = _state.youtubeData,
	          tiktokProfileData = _state.tiktokProfileData,
	          tiktok = _state.tiktok,
	          loading = _state.loading,
	          tiktokLoading = _state.tiktokLoading;
	
	
	      if (loading) {
	        return _react2.default.createElement(
	          'h2',
	          { className: 'page-content' },
	          'Loading...'
	        );
	      }
	
	      var influencer = this.props.influencer;
	
	
	      if (_lodash2.default.eq(_lodash2.default.get(influencer, 'instagramPrivate', false), true)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(_semanticUiReact.Message, {
	            warning: true,
	            icon: 'lock',
	            header: 'Private account',
	            content: 'This Instagram account is private'
	          })
	        );
	      }
	
	      if (instagramData || twitterData || youtubeData || tiktokProfileData) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          youtubeData && youtubeData.length > 0 && _react2.default.createElement(_profileLatestYoutubeVideos2.default, { youtubeVideos: youtubeData }),
	          _lodash2.default.get(instagramData, 'data') && instagramData.data.length > 0 && _react2.default.createElement(_profileLatestInstagrams2.default, { instagrams: instagramData, influencer: this.props.influencer }),
	          tiktok && tiktokProfileData && _react2.default.createElement(_profileLatestTiktoks2.default, { tiktokProfileData: tiktokProfileData, tiktokLoading: tiktokLoading }),
	          twitterData && twitterData.length > 0 && _react2.default.createElement(_profileLatestTweets2.default, { tweets: twitterData })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-content' },
	        _react2.default.createElement(
	          _semanticUiReact.Message,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'We couldn\u2019t load any recent posts from this influencer.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencerLatest;
	}(_react.Component);
	
	InfluencerLatest.propTypes = {
	  influencer: _propTypes2.default.object
	};
	InfluencerLatest.defaultProps = {
	  influencer: {}
	};
	exports.default = InfluencerLatest;

/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioInstagramEmbed = __webpack_require__(543);
	
	var _dyzioInstagramEmbed2 = _interopRequireDefault(_dyzioInstagramEmbed);
	
	var _compliance = __webpack_require__(932);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sf = function sf(num) {
	  if (num) return num > 1000 ? (0, _numeral2.default)(num).format('0.0a') : num;
	  return '-';
	};
	var NUM_COLUMNS = 4;
	var INSTAGRAM_POST_URL = 'https://www.instagram.com/p';
	var orangeColor = { color: 'orange' };
	var smallMargin = { marginTop: 3 };
	
	var REACH_FACTOR = 11;
	var IMPRESSION_FACTOR = 12.3;
	
	var ProfileLatestInstagrams = function ProfileLatestInstagrams(props) {
	  var instagramPosts = props.instagrams.data;
	  var adPosts = _lodash2.default.filter(instagramPosts, function (p) {
	    return _compliance.Compliance.isAsaCompliant(p.caption);
	  });
	
	  var adPercentage = Math.round(adPosts.length / instagramPosts.length * 100);
	
	  var chunks = _lodash2.default.chunk(instagramPosts, NUM_COLUMNS);
	  var dataCollectedDate = (0, _moment2.default)();
	
	  var followerCount = props.influencer.instagramCount;
	
	  console.log('INSTAGRAM USER', followerCount);
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { padded: true, color: 'pink' },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 16 },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
	            ' Latest Instagram posts\xA0',
	            _react2.default.createElement(
	              'span',
	              { style: { color: 'grey' } },
	              '(data collected ',
	              dataCollectedDate.fromNow(),
	              ')'
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { float: 'right' } },
	              _react2.default.createElement(
	                _semanticUiReact.Label,
	                { color: 'pink' },
	                adPercentage,
	                '% #AD'
	              )
	            )
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null)
	        )
	      ),
	      _lodash2.default.map(chunks, function (chunk) {
	        return _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          { columns: NUM_COLUMNS },
	          _lodash2.default.map(chunk, function (post) {
	            var engagements = (post.totalLikes || 0) + (post.comments || 0);
	            var engagementRate = engagements / followerCount * 100;
	            var isAd = _compliance.Compliance.isAsaCompliant(post.caption);
	
	            var estimatedReach = Math.round(engagements * REACH_FACTOR);
	            var estimatedImpressions = Math.round(engagements * IMPRESSION_FACTOR);
	
	            var isHiddenLikes = post.totalLikes === -1;
	
	            return _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { key: post.code },
	              _react2.default.createElement(
	                'a',
	                {
	                  title: 'open on Instagram',
	                  target: '_blank',
	                  rel: 'noopener noreferrer',
	                  href: INSTAGRAM_POST_URL + '/' + post.code
	                },
	                _react2.default.createElement(_dyzioInstagramEmbed2.default, {
	                  assetId: post.code,
	                  useInstagramStyle: true,
	                  imageUrl: post.corsImageUrl
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { singleLine: true, style: smallMargin },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'like outline' }),
	                    ' ',
	                    isHiddenLikes ? 'hidden' : sf(post.totalLikes)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'comments outline' }),
	                    ' ',
	                    sf(post.comments)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye' }),
	                    ' ',
	                    sf(post.views)
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    { colSpan: '2' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'percent', color: 'pink' }),
	                    isHiddenLikes ? 'hidden likes' : (0, _numeral2.default)(engagementRate).format('0.00') + ' ENG. RATE'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    { style: { textAlign: 'center' } },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      isAd ? _react2.default.createElement(
	                        _semanticUiReact.Label,
	                        { color: 'pink' },
	                        '#AD'
	                      ) : _react2.default.createElement(
	                        _semanticUiReact.Label,
	                        null,
	                        'ORGANIC'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    { colSpan: '3' },
	                    _react2.default.createElement(_semanticUiReact.Popup, {
	                      content: _lodash2.default.join(post.mentions, ', '),
	                      trigger: _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'at', color: 'pink' }),
	                        _lodash2.default.map(_lodash2.default.take(post.mentions, 2), function (m) {
	                          return _react2.default.createElement(
	                            _semanticUiReact.Label,
	                            null,
	                            _lodash2.default.toLower(m)
	                          );
	                        })
	                      )
	                    })
	                  )
	                ),
	                false && post.likes !== post.totalLikes && _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    { style: orangeColor, colSpan: '3' },
	                    _react2.default.createElement(_semanticUiReact.Popup, {
	                      content: 'Total likes - Organic + Paid',
	                      trigger: _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'like outline' }),
	                        ' ',
	                        sf(post.totalLikes),
	                        ' TOTAL LIKES'
	                      )
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    { colSpan: '3' },
	                    _react2.default.createElement(_semanticUiReact.Popup, {
	                      content: 'Estimated Reach & Impressions',
	                      trigger: _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye', color: 'blue' }),
	                        _react2.default.createElement(
	                          _semanticUiReact.Label,
	                          { basic: true },
	                          '\xA0',
	                          sf(estimatedReach),
	                          ' REACH'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Label,
	                          { basic: true },
	                          '\xA0',
	                          sf(estimatedImpressions),
	                          ' IMPS'
	                        )
	                      )
	                    })
	                  )
	                )
	              )
	            );
	          })
	        );
	      })
	    )
	  );
	};
	
	ProfileLatestInstagrams.propTypes = {
	  instagrams: _propTypes2.default.array.isRequired
	};
	
	exports.default = ProfileLatestInstagrams;

/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _compliance = __webpack_require__(932);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sf = function sf(num) {
	  if (num) return num > 1000 ? (0, _numeral2.default)(num).format('0.0a') : num;
	  return '-';
	};
	var NUM_COLUMNS = 4;
	var NUM_LATEST = 12;
	// const INSTAGRAM_POST_URL = 'https://www.instagram.com/p';
	var smallMargin = { marginTop: 3 };
	
	var imgStyle = {
	  height: '300px',
	  minHeight: '300px',
	  width: '300px',
	  objectFit: 'cover',
	  display: 'block',
	  margin: '0px auto'
	};
	
	var iconStyle = {
	  'vertical-align': 'middle',
	  display: 'inline',
	  height: 35
	};
	
	var ProfileLatestTiktoks = function ProfileLatestTiktoks(props) {
	  var _props$tiktokProfileD = props.tiktokProfileData,
	      username = _props$tiktokProfileD.username,
	      followerCount = _props$tiktokProfileD.followerCount,
	      posts = _props$tiktokProfileD.posts,
	      statisticsUpdatedDate = _props$tiktokProfileD.statisticsUpdatedDate;
	
	
	  var latestTiktoks = _lodash2.default.take(posts, NUM_LATEST);
	  var chunks = _lodash2.default.chunk(latestTiktoks, NUM_COLUMNS);
	
	  var dataCollectedDate = (0, _moment2.default)(statisticsUpdatedDate);
	
	  console.log('TIKTOK USER - ' + username, followerCount);
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { padded: true, color: 'black' },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 16 },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(_semanticUiReact.Image, { src: '/icons/tiktok.svg', alt: 'Tiktok', style: iconStyle }),
	            ' Latest Tiktok posts\xA0',
	            _react2.default.createElement(
	              'span',
	              { style: { color: 'grey' } },
	              '(data collected ',
	              dataCollectedDate.fromNow(),
	              ')'
	            )
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null)
	        )
	      ),
	      _lodash2.default.map(chunks, function (chunk) {
	        return _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          { divided: true, columns: NUM_COLUMNS },
	          _lodash2.default.map(chunk, function (post) {
	            var diggCount = post.diggCount,
	                commentCount = post.commentCount,
	                playCount = post.playCount,
	                text = post.text,
	                covers = post.covers;
	
	            var engagements = diggCount + commentCount;
	            var engagementRate = engagements / followerCount * 100;
	            var isAd = _compliance.Compliance.isAsaCompliant(text);
	
	            return _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { key: post.id },
	              _react2.default.createElement(
	                'a',
	                {
	                  title: 'open on Tiktok',
	                  target: '_blank',
	                  rel: 'noopener noreferrer',
	                  href: 'https://www.tiktok.com/@' + username + '/video/' + post.id
	                },
	                props.tiktokLoading ? _react2.default.createElement(
	                  'div',
	                  { style: imgStyle },
	                  _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading...' })
	                ) : _react2.default.createElement(_semanticUiReact.Image, { style: imgStyle, src: _lodash2.default.get(covers, 'default') })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { singleLine: true, style: smallMargin },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'like outline' }),
	                    ' ',
	                    sf(diggCount)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'comments outline' }),
	                    ' ',
	                    sf(commentCount)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye' }),
	                    ' ',
	                    sf(playCount)
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    { colSpan: '2' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'percent', color: 'pink' }),
	                    ' ',
	                    (0, _numeral2.default)(engagementRate).format('0.00'),
	                    ' ENG. RATE'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    { style: { textAlign: 'center' } },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      isAd ? _react2.default.createElement(
	                        _semanticUiReact.Label,
	                        { color: 'pink' },
	                        '#AD'
	                      ) : '-'
	                    )
	                  )
	                )
	              )
	            );
	          })
	        );
	      })
	    )
	  );
	};
	
	ProfileLatestTiktoks.propTypes = {
	  tiktokProfileData: _propTypes2.default.array.isRequired,
	  tiktokLoading: _propTypes2.default.bool.isRequired
	};
	
	ProfileLatestTiktoks.defaultProps = {
	  tiktokLoading: true
	};
	
	exports.default = ProfileLatestTiktoks;

/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactTweetEmbed = __webpack_require__(469);
	
	var _reactTweetEmbed2 = _interopRequireDefault(_reactTweetEmbed);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var twitterEmbedOptions = { conversation: 'none', cards: 'hidden' };
	
	var ProfileLatestTweets = function ProfileLatestTweets(_ref) {
	  var _ref$tweets = _ref.tweets,
	      tweets = _ref$tweets === undefined ? [] : _ref$tweets;
	
	  var chunks = _lodash2.default.chunk(tweets, 3);
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { padded: true, color: 'blue' },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 16 },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter', color: 'blue' }),
	            ' Latest tweets'
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null)
	        )
	      ),
	      _lodash2.default.map(chunks, function (chunk) {
	        return _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          { divided: true, columns: 3 },
	          _lodash2.default.map(chunk, function (tweet) {
	            return _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { key: tweet.id },
	              _react2.default.createElement(_reactTweetEmbed2.default, {
	                options: twitterEmbedOptions,
	                id: tweet.id
	              })
	            );
	          })
	        );
	      })
	    )
	  );
	};
	
	ProfileLatestTweets.propTypes = {
	  tweets: _propTypes2.default.array.isRequired
	};
	
	exports.default = ProfileLatestTweets;

/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlayer = __webpack_require__(453);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smallText = {
	  fontSize: 12
	};
	
	var ProfileLatestYoutubeVideos = function ProfileLatestYoutubeVideos(_ref) {
	  var youtubeVideos = _ref.youtubeVideos;
	
	  var chunks = _lodash2.default.chunk(youtubeVideos, 3);
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { padded: true, color: 'red' },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 16 },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube', color: 'red' }),
	            ' Latest Youtube videos'
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null)
	        )
	      ),
	      _lodash2.default.map(chunks, function (chunk) {
	        return _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          { divided: true, columns: 3 },
	          _lodash2.default.map(chunk, function (video) {
	            return _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { key: video.id },
	              _react2.default.createElement(_reactPlayer2.default, {
	                height: '202px',
	                width: '100%',
	                url: 'https://www.youtube.com/watch?v=' + video.id
	              }),
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { singleLine: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'like outline' }),
	                    (0, _numeral2.default)(video.statistics.likeCount).format('0a')
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'dislike outline' }),
	                    (0, _numeral2.default)(video.statistics.dislikeCount).format('0a')
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'comments outline' }),
	                    (0, _numeral2.default)(video.statistics.commentCount).format('0a')
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play' }),
	                    (0, _numeral2.default)(video.statistics.viewCount).format('0a')
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    { colSpan: 4, textAlign: 'center', style: smallText },
	                    'Published on ',
	                    (0, _moment2.default)(video.publishedAt).format('MMMM Do YYYY, h:mm:ss a')
	                  )
	                )
	              )
	            );
	          })
	        );
	      })
	    )
	  );
	};
	
	ProfileLatestYoutubeVideos.propTypes = {
	  youtubeVideos: _react2.default.PropTypes.array.isRequired
	};
	
	exports.default = ProfileLatestYoutubeVideos;

/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TELEGRAM_API_BASE_URL = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production';
	var TELEGRAM_CHATS_API = TELEGRAM_API_BASE_URL + '/telegram/chats';
	
	var noPadding = {
	  padding: 0
	};
	
	var noBorder = {
	  border: 'none',
	  'box-shadow': 'none'
	};
	
	var marginAuto = {
	  margin: 'auto'
	};
	
	var previewBlockStyle = {
	  color: '#666666',
	  minHeight: 350,
	  height: 'auto'
	};
	
	var previewIconStyle = {
	  marginTop: 150
	};
	
	var modalSizeStyle = {
	  height: 500
	};
	
	var tableSizeStyle = {
	  maxHeight: 200,
	  overflow: 'scroll'
	};
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	
	var TelegramChannelAddModal = function (_React$Component) {
	  _inherits(TelegramChannelAddModal, _React$Component);
	
	  function TelegramChannelAddModal() {
	    _classCallCheck(this, TelegramChannelAddModal);
	
	    var _this = _possibleConstructorReturn(this, (TelegramChannelAddModal.__proto__ || Object.getPrototypeOf(TelegramChannelAddModal)).call(this));
	
	    _this.togglePublic = function () {
	      var isPublic = _this.state.isPublic;
	
	      var newValue = !isPublic;
	      _this.setState({
	        isPublic: newValue
	      });
	    };
	
	    _this.switchMode = function (mode) {
	      _this.setState({
	        mode: mode
	      });
	    };
	
	    _this.state = {
	      isPublic: true,
	      telegramChats: [],
	      mode: 'public'
	    };
	    return _this;
	  }
	
	  _createClass(TelegramChannelAddModal, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var chatsUrl, response, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('get all telegram chats');
	                chatsUrl = '' + TELEGRAM_CHATS_API;
	
	                console.log(chatsUrl);
	                _context.next = 5;
	                return _axios2.default.get(chatsUrl);
	
	              case 5:
	                response = _context.sent;
	                data = response.data.data;
	                _context.next = 9;
	                return this.setState({
	                  telegramChats: _lodash2.default.get(data, 'formattedChats')
	                });
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onClose = _props.onClose,
	          isLoading = _props.isLoading,
	          isAddingChannel = _props.isAddingChannel,
	          handleAddChannel = _props.handleAddChannel,
	          handleAddPrivateChannel = _props.handleAddPrivateChannel,
	          isDuplicateChannel = _props.isDuplicateChannel,
	          telegramUrl = _props.telegramUrl,
	          searchTelegramChannel = _props.searchTelegramChannel,
	          hasError = _props.hasError,
	          channelData = _props.channelData,
	          type = _props.type;
	      var _state = this.state,
	          mode = _state.mode,
	          telegramChats = _state.telegramChats;
	
	
	      var openGraph = _lodash2.default.get(channelData, 'ogResponse.openGraph');
	      var typeInfo = _lodash2.default.get(channelData, 'typeInfo');
	      console.log(openGraph);
	      console.log(channelData);
	      console.log(type);
	      console.log(typeInfo);
	      console.log(mode);
	      var actionButtonIcon = isAddingChannel ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'spinner', loading: true }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'add' });
	
	      var channelAdded = true;
	
	      var mismatch = type === 'USER' && _lodash2.default.get(typeInfo, 'type') && _lodash2.default.get(typeInfo, 'type') !== type || type !== 'USER' && _lodash2.default.get(typeInfo, 'type') === 'USER';
	
	      return _react2.default.createElement(
	        _dyzioModal2.default,
	        {
	          onClose: onClose,
	          onActionButtonClick: handleAddChannel,
	          hasActionButton: true,
	          actionButtonContent: 'Add Telegram ' + _lodash2.default.capitalize(type),
	          actionButtonIcon: actionButtonIcon,
	          shouldDisableActionButton: mismatch || isAddingChannel || isLoading,
	          headerText: 'Add a new Telegram ' + _lodash2.default.capitalize(type),
	          size: 'small',
	          style: modalSizeStyle
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true, style: noBorder },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            { style: marginAuto },
	            _react2.default.createElement(
	              _semanticUiReact.Button.Group,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                { onClick: function onClick() {
	                    return _this2.setState({ mode: 'public' });
	                  }, positive: mode === 'public' },
	                'Public'
	              ),
	              _react2.default.createElement(_semanticUiReact.Button.Or, null),
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                { onClick: function onClick() {
	                    return _this2.setState({ mode: 'private' });
	                  }, positive: mode === 'private' },
	                'Private'
	              )
	            )
	          )
	        ),
	        isDuplicateChannel && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { fluid: true, error: true },
	          'This asset has already been added to the campaign.'
	        ),
	        mismatch && _react2.default.createElement(_semanticUiReact.Message, {
	          error: true,
	          header: 'Telegram type mismatch',
	          content: (type === 'USER' ? '' : 'Non-') + 'User is expected'
	        }),
	        mode === 'public' && _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true, style: noBorder },
	          _react2.default.createElement(
	            _semanticUiReact.Form,
	            { onSubmit: handleAddChannel },
	            _react2.default.createElement(
	              _semanticUiReact.Form.Field,
	              null,
	              _react2.default.createElement(_semanticUiReact.Input, {
	                fluid: true,
	                value: telegramUrl,
	                label: 'URL',
	                labelPosition: 'left',
	                style: noPadding,
	                onChange: searchTelegramChannel
	              })
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(
	              _semanticUiReact.Form.Field,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Container,
	                { textAlign: 'center', style: previewBlockStyle },
	                hasError && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus circle', size: 'huge', style: previewIconStyle }),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'invalid url.'
	                    )
	                  )
	                ),
	                !channelData && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, {
	                    loading: isLoading,
	                    name: 'arrow alternate circle up outline', size: 'huge', style: previewIconStyle
	                  }),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      isLoading ? 'please wait...' : 'paste Telegram Channel url above'
	                    )
	                  )
	                ),
	                openGraph && _react2.default.createElement(
	                  _semanticUiReact.Card.Group,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Card,
	                    { centered: true },
	                    _react2.default.createElement(
	                      _semanticUiReact.Card.Content,
	                      null,
	                      _react2.default.createElement(_semanticUiReact.Image, {
	                        size: 'small',
	                        src: openGraph.image.url,
	                        className: 'circular'
	                      }),
	                      _react2.default.createElement(_semanticUiReact.Divider, null),
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        openGraph.title
	                      ),
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Label,
	                          { basic: true, color: 'blue' },
	                          typeInfo.type
	                        )
	                      ),
	                      typeInfo.followers && _react2.default.createElement(
	                        'h3',
	                        { style: { padding: 10 } },
	                        cf(typeInfo.followers),
	                        ' ',
	                        typeInfo.type.match(/GROUP/) ? 'members' : 'subscribers'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        openGraph.description
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { style: { paddingBottom: 10 } },
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            href: 'https://t.me' + '/' + channelData.channelUrl,
	                            target: '_blank',
	                            rel: 'noopener noreferrer'
	                          },
	                          channelData.channelUrl
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        mode === 'private' && _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true, style: noBorder },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Header,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'System Account'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    'moonboots_socials'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            'choose private group/channel from the list below. If the group/channel is not in the list then ask your KOL to invite @moonboots_socials to the group. help link.'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table,
	              { style: tableSizeStyle },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Header,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'Name'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'Username'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'Header'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                _lodash2.default.map(telegramChats, function (chat) {
	                  var title = chat.title,
	                      username = chat.username;
	
	                  return _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Label,
	                        null,
	                        title
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      username
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(_semanticUiReact.Button, {
	                        color: 'pink',
	                        inverted: true,
	                        icon: 'plus',
	                        content: 'Add Channel',
	                        onClick: function onClick() {
	                          return handleAddPrivateChannel(chat);
	                        }
	                      })
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TelegramChannelAddModal;
	}(_react2.default.Component);
	
	TelegramChannelAddModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  isAddingChannel: _propTypes2.default.bool.isRequired,
	  isDuplicateChannel: _propTypes2.default.bool.isRequired,
	  handleAddChannel: _propTypes2.default.func.isRequired,
	  handleAddPrivateChannel: _propTypes2.default.func.isRequired,
	  telegramUrl: _propTypes2.default.string.isRequired,
	  searchTelegramChannel: _propTypes2.default.func.isRequired,
	  hasError: _propTypes2.default.bool.isRequired,
	  channelData: _propTypes2.default.object.isRequired,
	  type: _propTypes2.default.string.isRequired
	};
	
	exports.default = TelegramChannelAddModal;

/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _recompose = __webpack_require__(15);
	
	var _telegramChannelAdd = __webpack_require__(1973);
	
	var _telegramChannelAdd2 = _interopRequireDefault(_telegramChannelAdd);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _reactRedux = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	var TELEGRAM_API_BASE_URL = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production';
	var TELEGRAM_CHANNEL_API = TELEGRAM_API_BASE_URL + '/telegram/channel';
	var TELEGRAM_CHATS_API = TELEGRAM_API_BASE_URL + '/telegram/chats';
	var TELEGRAM_BASE_URL = 'https://t.me/';
	
	var DeleteButton = function DeleteButton(props) {
	  return _react2.default.createElement(_semanticUiReact.Button, {
	    size: 'mini',
	    onClick: props.handler,
	    compact: true,
	    circular: true,
	    floated: props.floated,
	    icon: 'delete'
	  });
	};
	
	DeleteButton.propTypes = {
	  handler: _propTypes2.default.func.isRequired,
	  floated: _propTypes2.default.string.isRequired
	};
	
	var centered = {
	  textAlign: 'center'
	};
	
	var TelegramChannels = function (_React$Component) {
	  _inherits(TelegramChannels, _React$Component);
	
	  function TelegramChannels() {
	    var _this2 = this;
	
	    _classCallCheck(this, TelegramChannels);
	
	    var _this = _possibleConstructorReturn(this, (TelegramChannels.__proto__ || Object.getPrototypeOf(TelegramChannels)).call(this));
	
	    _this.closeAddModal = function () {
	      console.log('close');
	      _this.setState({
	        showAddModal: false
	      });
	    };
	
	    _this.toggleAddUserModal = function () {
	      console.log('user');
	      var showAddModal = _this.state.showAddModal;
	
	
	      var newValue = !showAddModal;
	      _this.setState({
	        showAddModal: newValue,
	        channelData: null,
	        addType: 'USER'
	      });
	    };
	
	    _this.toggleAddChannelModal = function () {
	      var showAddModal = _this.state.showAddModal;
	
	
	      var newValue = !showAddModal;
	      _this.setState({
	        showAddModal: newValue,
	        channelData: null,
	        addType: 'CHANNEL'
	      });
	    };
	
	    _this.getTelegramAddChannelUrl = function (influencerId) {
	      var url = TELEGRAM_API_BASE_URL + '/influencer/' + influencerId + '/telegram/channels';
	      return url;
	    };
	
	    _this.getPrivateTelegramAddChannelUrl = function (influencerId) {
	      var url = TELEGRAM_API_BASE_URL + '/influencer/' + influencerId + '/telegram/privateChannels';
	      return url;
	    };
	
	    _this.getTelegramRemoveChannelUrl = function (influencerId, channelId) {
	      var url = TELEGRAM_API_BASE_URL + '/influencer/' + influencerId + '/telegram/channels/' + channelId;
	      return url;
	    };
	
	    _this.searchTelegramChannel = _lodash2.default.debounce(function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(event, _ref2) {
	        var value = _ref2.value;
	        var lowerValue, channelUrl, searchUrl, response, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('searchTelegramChannel');
	                lowerValue = _lodash2.default.toLower(value);
	                channelUrl = _lodash2.default.replace(lowerValue, TELEGRAM_BASE_URL, '');
	                searchUrl = TELEGRAM_CHANNEL_API + '/' + channelUrl;
	
	                console.log(searchUrl);
	                _context.next = 7;
	                return _this.setState({
	                  channelData: null,
	                  isSearching: true
	                });
	
	              case 7:
	                _context.next = 9;
	                return _axios2.default.get(searchUrl);
	
	              case 9:
	                response = _context.sent;
	                data = response.data.data;
	
	                console.log(data);
	                _context.next = 14;
	                return _this.setState({
	                  channelData: data,
	                  isSearching: false
	                });
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }(), 1000);
	
	    _this.addPrivateTelegramChannel = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(data) {
	        var _this$state, channelData, addedChannels, addType, _this$props, influencer, userInfo, addPrivateChannelUrl, payload, response, channel, chan;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.log('addPrivateTelegramChannel');
	                _this$state = _this.state, channelData = _this$state.channelData, addedChannels = _this$state.addedChannels, addType = _this$state.addType;
	                _this$props = _this.props, influencer = _this$props.influencer, userInfo = _this$props.userInfo;
	                addPrivateChannelUrl = _this.getPrivateTelegramAddChannelUrl(influencer.id);
	                payload = {
	                  title: data.title,
	                  createdBy: _lodash2.default.get(userInfo, 'name'),
	                  accessHash: data.accessHash ? _lodash2.default.toString(data.accessHash) : 'no_accessHash',
	                  id: _lodash2.default.toString(data.id),
	                  username: data.username || 'no_username'
	                };
	
	
	                payload.createdBy = _lodash2.default.get(userInfo, 'name');
	
	                console.log(userInfo);
	                console.log(payload);
	
	                _context2.next = 10;
	                return _this.setState({
	                  isSearching: true
	                });
	
	              case 10:
	                _context2.next = 12;
	                return _axios2.default.post(addPrivateChannelUrl, payload).then(function (r) {
	                  return r.data.data;
	                });
	
	              case 12:
	                response = _context2.sent;
	                channel = response.channel;
	
	                console.log(channel);
	                chan = channel.attributes;
	
	                chan.id = channel.id;
	
	                addedChannels.push(chan);
	                _context2.next = 20;
	                return _this.setState({
	                  showAddModal: false,
	                  isSearching: false,
	                  error: false,
	                  addedChannels: addedChannels
	                });
	
	              case 20:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.addTelegramChannel = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$state2, channelData, addedChannels, addType, typeInfo, _this$props2, influencer, userInfo, addChannelUrl, payload, response, channel, chan;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              console.log('addTelegramChannel');
	              _this$state2 = _this.state, channelData = _this$state2.channelData, addedChannels = _this$state2.addedChannels, addType = _this$state2.addType;
	              typeInfo = channelData.typeInfo;
	              _this$props2 = _this.props, influencer = _this$props2.influencer, userInfo = _this$props2.userInfo;
	              addChannelUrl = _this.getTelegramAddChannelUrl(influencer.id);
	              payload = {
	                channelData: channelData,
	                userInfo: userInfo
	              };
	              _context3.next = 8;
	              return _this.setState({
	                isSearching: true
	              });
	
	            case 8:
	              _context3.next = 10;
	              return _axios2.default.post(addChannelUrl, payload).then(function (r) {
	                return r.data.data;
	              });
	
	            case 10:
	              response = _context3.sent;
	              channel = response.channel;
	              chan = channel.attributes;
	
	              chan.id = channel.id;
	
	              if (!(_lodash2.default.get(typeInfo, 'type') === 'USER')) {
	                _context3.next = 19;
	                break;
	              }
	
	              _context3.next = 17;
	              return _this.setState({
	                showAddModal: false,
	                isSearching: false,
	                newUser: chan,
	                error: false
	              });
	
	            case 17:
	              _context3.next = 22;
	              break;
	
	            case 19:
	              addedChannels.push(chan);
	              _context3.next = 22;
	              return _this.setState({
	                showAddModal: false,
	                isSearching: false,
	                error: false,
	                addedChannels: addedChannels
	              });
	
	            case 22:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.deleteTelegramChannel = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(influencerId, channelId) {
	        var removedChannels, url, response;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                removedChannels = _this.state.removedChannels;
	
	                console.log('delete channel ' + channelId + ' from influencer ' + influencerId);
	                url = _this.getTelegramRemoveChannelUrl(influencerId, channelId);
	                _context4.next = 5;
	                return _axios2.default.delete(url);
	
	              case 5:
	                response = _context4.sent;
	
	                console.log(response);
	                removedChannels.push(channelId);
	                _context4.next = 10;
	                return _this.setState({
	                  removedChannels: removedChannels
	                });
	
	              case 10:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x4, _x5) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.deleteTelegramUser = function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(influencerId, channelId) {
	        var removedChannels, url, response;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                removedChannels = _this.state.removedChannels;
	
	                console.log('delete channel ' + channelId + ' from influencer ' + influencerId);
	                url = _this.getTelegramRemoveChannelUrl(influencerId, channelId);
	                _context5.next = 5;
	                return _axios2.default.delete(url);
	
	              case 5:
	                response = _context5.sent;
	
	                console.log(response);
	                removedChannels.push(channelId);
	                _context5.next = 10;
	                return _this.setState({
	                  newUser: { id: 'xxx' }
	                });
	
	              case 10:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2);
	      }));
	
	      return function (_x6, _x7) {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      showAddModal: false,
	      isSearching: false,
	      isSearchError: false,
	      channelData: null,
	      addedChannels: [],
	      removedChannels: [],
	      newUser: null,
	      addType: 'USER'
	    };
	    return _this;
	  }
	
	  _createClass(TelegramChannels, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          channels = _props.channels,
	          influencer = _props.influencer,
	          user = _props.user;
	      var _state = this.state,
	          showAddModal = _state.showAddModal,
	          isSearching = _state.isSearching,
	          channelData = _state.channelData,
	          addedChannels = _state.addedChannels,
	          removedChannels = _state.removedChannels,
	          newUser = _state.newUser,
	          addType = _state.addType;
	
	      var displayUser = newUser || user;
	      console.log('TelegramChannels');
	      console.log(channels);
	      console.log(user);
	      var resultingChannels = _lodash2.default.concat(channels, addedChannels);
	      // reject channels that have been removed
	      resultingChannels = _lodash2.default.reject(resultingChannels, function (rc) {
	        return _lodash2.default.includes(removedChannels, rc.id);
	      });
	      // const users = _.filter(resultingChannels, rc => _.isEqual(rc.channelType, 'USER'));
	      var availableChannels = _lodash2.default.filter(resultingChannels, function (rc) {
	        return _lodash2.default.get(rc, 'channelType');
	      });
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { color: 'blue' },
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 16 },
	              _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram', size: 'large', color: 'blue' }),
	                'TELEGRAM'
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null)
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { divided: true },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              _react2.default.createElement(
	                _semanticUiReact.Card.Group,
	                null,
	                displayUser && _lodash2.default.isEqual(displayUser.channelType, 'USER') && _react2.default.createElement(
	                  _semanticUiReact.Card,
	                  { style: centered },
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Image, {
	                      size: 'small',
	                      src: displayUser.thumbnail,
	                      className: 'circular'
	                    }),
	                    _react2.default.createElement(_semanticUiReact.Divider, null),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      displayUser.displayName
	                    ),
	                    _react2.default.createElement(
	                      'h5',
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Label,
	                        { basic: true, color: 'blue' },
	                        displayUser.channelType
	                      )
	                    ),
	                    displayUser.followerCount && _react2.default.createElement(
	                      'h6',
	                      { style: { padding: 10 } },
	                      cf(displayUser.followerCount),
	                      ' ',
	                      displayUser.channelType.match(/GROUP/) ? 'members' : 'subscribers'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { style: { fontSize: '80%' } },
	                      _lodash2.default.truncate(displayUser.bio, { length: 100 })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    { extra: true },
	                    _react2.default.createElement(DeleteButton, {
	                      displayName: displayUser.displayName,
	                      influencerName: influencer.name,
	                      handler: function handler() {
	                        return _this3.deleteTelegramUser(influencer.id, displayUser.id);
	                      },
	                      floated: 'right'
	                    }),
	                    _react2.default.createElement(_semanticUiReact.Button, {
	                      circular: true,
	                      compact: true,
	                      size: 'mini',
	                      icon: 'edit',
	                      floated: 'right',
	                      onClick: this.toggleAddUserModal
	                    }),
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        href: 'https://t.me/' + user.channelUrl,
	                        target: '_blank',
	                        rel: 'noopener noreferrer'
	                      },
	                      user.channelUrl
	                    )
	                  )
	                ),
	                (!displayUser || !_lodash2.default.isEqual(displayUser.channelType, 'USER')) && _react2.default.createElement(
	                  _semanticUiReact.Card,
	                  { style: centered },
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { style: { minHeight: 300, paddingTop: 100 } },
	                      _react2.default.createElement(_semanticUiReact.Button, { circular: true, icon: 'add', color: 'blue', size: 'massive', inverted: true, onClick: this.toggleAddUserModal }),
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        '\xA0'
	                      ),
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'ADD User'
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 12 },
	              _react2.default.createElement(
	                _semanticUiReact.Card.Group,
	                null,
	                _lodash2.default.map(availableChannels, function (c) {
	                  return _react2.default.createElement(
	                    _semanticUiReact.Card,
	                    { style: centered },
	                    _react2.default.createElement(
	                      _semanticUiReact.Card.Content,
	                      null,
	                      _react2.default.createElement(_semanticUiReact.Image, {
	                        size: 'small',
	                        src: c.thumbnail,
	                        className: 'circular'
	                      }),
	                      _react2.default.createElement(_semanticUiReact.Divider, null),
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        c.displayName
	                      ),
	                      _react2.default.createElement(
	                        'h5',
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Label,
	                          { basic: true, color: 'blue' },
	                          c.channelType
	                        )
	                      ),
	                      c.followerCount && _react2.default.createElement(
	                        'h6',
	                        { style: { padding: 10 } },
	                        cf(c.followerCount),
	                        ' ',
	                        c.channelType.match(/GROUP/) ? 'members' : 'subscribers'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { style: { fontSize: '80%' } },
	                        _lodash2.default.truncate(c.bio, { length: 100 })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Card.Content,
	                      { extra: true },
	                      _react2.default.createElement(DeleteButton, {
	                        displayName: c.displayName,
	                        influencerName: influencer.name,
	                        handler: function handler() {
	                          return _this3.deleteTelegramChannel(influencer.id, c.id);
	                        },
	                        floated: 'right'
	                      }),
	                      _react2.default.createElement(
	                        'a',
	                        {
	                          href: 'https://t.me/' + c.channelUrl,
	                          target: '_blank',
	                          rel: 'noopener noreferrer'
	                        },
	                        c.channelUrl
	                      )
	                    )
	                  );
	                }),
	                _react2.default.createElement(
	                  _semanticUiReact.Card,
	                  { style: centered },
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { style: { minHeight: 300, paddingTop: 100 } },
	                      _react2.default.createElement(_semanticUiReact.Button, { circular: true, icon: 'add', color: 'blue', size: 'massive', inverted: true, onClick: this.toggleAddChannelModal }),
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        '\xA0'
	                      ),
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'ADD CHANNEL'
	                      )
	                    )
	                  )
	                )
	              ),
	              showAddModal && _react2.default.createElement(_telegramChannelAdd2.default, {
	                onClose: this.closeAddModal,
	                searchTelegramChannel: this.searchTelegramChannel,
	                isLoading: isSearching,
	                channelData: channelData,
	                handleAddChannel: this.addTelegramChannel,
	                handleAddPrivateChannel: this.addPrivateTelegramChannel,
	                type: addType
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TelegramChannels;
	}(_react2.default.Component);
	
	TelegramChannels.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  channels: _propTypes2.default.array.isRequired,
	  user: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default)(TelegramChannels);

/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _axiosRetry = __webpack_require__(168);
	
	var _axiosRetry2 = _interopRequireDefault(_axiosRetry);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _recompose = __webpack_require__(15);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _instagramProfileData = __webpack_require__(377);
	
	var _instagramProfileData2 = _interopRequireDefault(_instagramProfileData);
	
	var _brandMentionsTable = __webpack_require__(2550);
	
	var _brandMentionsTable2 = _interopRequireDefault(_brandMentionsTable);
	
	var _brandMentionsPostList = __webpack_require__(964);
	
	var _brandMentionsPostList2 = _interopRequireDefault(_brandMentionsPostList);
	
	var _twitchData = __webpack_require__(600);
	
	var _twitchData2 = _interopRequireDefault(_twitchData);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _dyzioDemographics = __webpack_require__(912);
	
	var _dyzioDemographics2 = _interopRequireDefault(_dyzioDemographics);
	
	var _dyzioInstagramEmbed = __webpack_require__(543);
	
	var _dyzioInstagramEmbed2 = _interopRequireDefault(_dyzioInstagramEmbed);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasAws4Signature = __webpack_require__(924);
	
	var _hasAws4Signature2 = _interopRequireDefault(_hasAws4Signature);
	
	var _youtubeProfileDataLarge = __webpack_require__(901);
	
	var _youtubeProfileDataLarge2 = _interopRequireDefault(_youtubeProfileDataLarge);
	
	var _facebookProfileDataLarge = __webpack_require__(874);
	
	var _facebookProfileDataLarge2 = _interopRequireDefault(_facebookProfileDataLarge);
	
	var _twitterProfileDataLarge = __webpack_require__(898);
	
	var _twitterProfileDataLarge2 = _interopRequireDefault(_twitterProfileDataLarge);
	
	var _tiktokProfileDataLarge = __webpack_require__(896);
	
	var _tiktokProfileDataLarge2 = _interopRequireDefault(_tiktokProfileDataLarge);
	
	var _telegramChannels = __webpack_require__(1974);
	
	var _telegramChannels2 = _interopRequireDefault(_telegramChannels);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const TEAM_DYZIO_ID = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';
	// const DC = 'fdd20559-e10d-4b07-834c-7882c127e82e';
	// const JONPLE = 'f4412f47-6788-47ac-84c9-dae56067a8c1';
	// const HERE_AND_NOW = '15e0ffdb-bd62-4eaf-b8ba-fb242ebc6fd6';
	
	// const DEMOGRAPHICS_ALLOWED_ORGS = [TEAM_DYZIO_ID, HERE_AND_NOW, JONPLE, DC];
	
	var INSTAGRAM_POST_URL = 'https://www.instagram.com/p';
	
	var brandMentionsLoadingStyle = {
	  minHeight: 90,
	  marginTop: 30
	};
	
	var emptyDataStyle = {
	  marginTop: 14
	};
	
	var overflowEllipsis = {
	  whiteSpace: 'nowrap',
	  overflow: 'hidden',
	  textOverflow: 'ellipsis',
	  width: "600px"
	};
	
	var sf = function sf(num) {
	  if (num) return num > 1000 ? (0, _numeral2.default)(num).format('0.0a') : num;
	  return '-';
	};
	
	var InfluencerProfileStats = function (_React$Component) {
	  _inherits(InfluencerProfileStats, _React$Component);
	
	  function InfluencerProfileStats() {
	    _classCallCheck(this, InfluencerProfileStats);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerProfileStats.__proto__ || Object.getPrototypeOf(InfluencerProfileStats)).call(this));
	
	    _this.toggleYoutubeDemographicsModalState = function () {
	      var youtubeDemographicsModalOpen = _this.state.youtubeDemographicsModalOpen;
	
	      _this.setState({
	        youtubeDemographicsModalOpen: !youtubeDemographicsModalOpen
	      });
	    };
	
	    _this.toggleFacebookCountryDemographicsModalState = function () {
	      var facebookCountryDemographicsModalOpen = _this.state.facebookCountryDemographicsModalOpen;
	
	      _this.setState({
	        facebookCountryDemographicsModalOpen: !facebookCountryDemographicsModalOpen
	      });
	    };
	
	    _this.toggleFacebookCityDemographicsModalState = function () {
	      var facebookCityDemographicsModalOpen = _this.state.facebookCityDemographicsModalOpen;
	
	      _this.setState({
	        facebookCityDemographicsModalOpen: !facebookCityDemographicsModalOpen
	      });
	    };
	
	    _this.togglePageMetricModalState = function () {
	      var pageMetricModalOpen = _this.state.pageMetricModalOpen;
	
	      _this.setState({
	        pageMetricModalOpen: !pageMetricModalOpen
	      });
	    };
	
	    _this.loadCampaignHistory = function () {
	      var profile = _this.props.influencer;
	      var id = profile.id;
	
	      // load brand mentions in parallel
	
	      _this.loadBrandMentions();
	
	      _this.restClient.get(("https://kdpylba5ej.execute-api.eu-west-1.amazonaws.com/production") + '/influencer/campaings', {
	        params: { id: id }
	      }).then(function (response) {
	        var data = response.data;
	
	        return _this.setState({
	          history: data,
	          loadingHistory: false
	        });
	      }).catch(function () {
	        _this.setState({
	          history: null,
	          loadingHistory: false
	        });
	      });
	    };
	
	    _this.loadBrandMentions = function () {
	      var profile = _this.props.influencer;
	      var instagramId = profile.instagramId,
	          id = profile.id;
	
	
	      if (instagramId) {
	        var brandURLBase = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production';
	        var url = brandURLBase + '/instagram/posts/' + id + '?rapid=true';
	        return _axios2.default.get(url).then(function (res) {
	          var posts = _lodash2.default.get(res, 'data.data.formattedNodes');
	          var adPosts = _lodash2.default.filter(posts, function (post) {
	            return post.isAd;
	          });
	          var sortByDateAdPosts = _lodash2.default.reverse(_lodash2.default.sortBy(adPosts, 'publishedDate'));
	          console.log('adPosts', adPosts);
	          _this.setState({
	            brandMentionsData: _lodash2.default.take(adPosts, 12),
	            brandMentionsLoading: false
	          });
	        }).catch(function (e) {
	          console.log(e);
	          _this.setState({
	            brandMentionsLoading: false
	          });
	        });
	      }
	      _this.setState({
	        brandMentionsLoading: false,
	        brandMentionsData: null
	      });
	
	      return null;
	    };
	
	    _this.handleBrandMentionsRowClick = function (item) {
	      console.log(item);
	      _this.setState({
	        brandCollaborationData: item,
	        showBrandCollaborationModal: true
	      });
	    };
	
	    _this.popupToggleHandler = function () {
	      _this.setState({
	        showBrandCollaborationModal: false
	      });
	    };
	
	    _this.getBrandCollabModalSize = function (brandCollaborationData) {
	      if (!brandCollaborationData) return null;
	      var postCount = brandCollaborationData.engagementFigures.relatedPosts.length;
	      var size = void 0;
	      switch (postCount) {
	        case 1:
	          size = 'tiny';
	          break;
	        case 2:
	          size = 'small';
	          break;
	        default:
	          size = 'large';
	      }
	      return size;
	    };
	
	    _this.state = {
	      loading: true,
	      missingAPILink: false,
	      error: false,
	      statistics: {},
	      youtubeDemographicsModalOpen: false,
	      data: {
	        youtube: null,
	        instagram: null,
	        twitter: null
	      },
	      history: null,
	      loadingHistory: true,
	      brandMentionsLoading: true,
	      brandMentionsData: null,
	      brandMentionsStatus: null
	    };
	
	    _this.restClient = _axios2.default.create({
	      timeout: 5000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    _this.jsonClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	      header: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    (0, _axiosRetry2.default)(_this.restClient, {
	      delay: 100,
	      retries: 3
	    });
	    return _this;
	  }
	
	  _createClass(InfluencerProfileStats, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var profile = this.props.influencer;
	      var statistics = profile.statistics;
	      var link = profile.influencerApiLink;
	
	      if (link && link.url) {
	        this.restClient.get(link.url).then(function (response) {
	          var influencer = response.data.influencer;
	
	          var youtube = influencer.aggregateYoutubeChannelStatistics;
	          var instagram = influencer.instagramStatistics;
	          var twitter = influencer.twitterStatistics;
	          var facebook = influencer.facebookStatistics;
	
	          var data = {
	            youtube: youtube,
	            instagram: instagram,
	            twitter: twitter,
	            facebook: facebook,
	            apiInfluencer: influencer
	          };
	
	          return _this2.setState({
	            statistics: statistics,
	            data: data,
	            loading: false
	          }, _this2.loadCampaignHistory);
	        }).catch(function () {
	          _this2.setState({
	            error: true,
	            loading: false
	          }, _this2.loadCampaignHistory);
	        });
	      } else {
	        this.setState({
	          missingAPILink: true,
	          loading: false
	        }, this.loadCampaignHistory);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          data = _state.data,
	          loading = _state.loading,
	          error = _state.error,
	          statistics = _state.statistics,
	          missingAPILink = _state.missingAPILink,
	          youtubeDemographicsModalOpen = _state.youtubeDemographicsModalOpen,
	          facebookCountryDemographicsModalOpen = _state.facebookCountryDemographicsModalOpen,
	          facebookCityDemographicsModalOpen = _state.facebookCityDemographicsModalOpen,
	          pageMetricModalOpen = _state.pageMetricModalOpen,
	          brandMentionsData = _state.brandMentionsData,
	          brandMentionsStatus = _state.brandMentionsStatus,
	          brandMentionsLoading = _state.brandMentionsLoading,
	          showBrandCollaborationModal = _state.showBrandCollaborationModal,
	          brandCollaborationData = _state.brandCollaborationData;
	
	
	      var brandCollabModalSize = this.getBrandCollabModalSize(brandCollaborationData);
	
	      var _props = this.props,
	          influencer = _props.influencer,
	          organisationId = _props.userInfo.organisationId,
	          organisation = _props.organisation;
	
	      var isYouTubeCompliance = organisationId === 'ea9ed959-9566-4851-b69c-55b699832cff';
	      var displayAuthorisedData = _lodash2.default.get(organisation, 'displayAuthorisedData', false);
	      // const canOrgDisplayDemographics = _.includes(DEMOGRAPHICS_ALLOWED_ORGS, organisationId);
	
	      // const canViewData = dataPermission && dataPermission.requestStatus === REQUEST_STATUS_APPROVED;
	      // const canViewInstagram = canViewData && _.find(dataPermission.channels, ['channel', 'instagram']);
	      // const canViewFacebook = canViewData && _.find(dataPermission.channels, ['channel', 'facebook']);
	      // const canViewYoutube = canViewData && _.find(dataPermission.channels, ['channel', 'youtube']);
	
	      var canViewData = true;
	      var canViewInstagram = _lodash2.default.has(influencer, 'instagram');
	      var canViewFacebook = _lodash2.default.has(influencer, 'facebook');
	      var canViewTwitter = _lodash2.default.has(influencer, 'twitter');
	      var canViewYoutube = _lodash2.default.has(influencer, 'youtube');
	      var canViewTwitch = _lodash2.default.has(influencer, 'twitch');
	      var canViewTiktok = _lodash2.default.has(influencer, 'tiktok');
	
	      var facebook = influencer.facebook,
	          facebookData = influencer.facebookData,
	          facebookVerified = influencer.facebookVerified,
	          countHistory = influencer.countHistory;
	
	
	      var hasDemographicsData = _lodash2.default.has(influencer, 'instagramData.audienceDemographics.data');
	
	      var IG_CONTENT_TYPES = ['REELS', 'CAROUSEL', 'IMAGE', 'VIDEO', 'IGTV'];
	
	      var mappedLocations = null;
	
	      if (influencer.instagramLocations) {
	        var groupedLocations = _lodash2.default.groupBy(influencer.instagramLocations, 'name');
	        mappedLocations = _lodash2.default.map(groupedLocations, function (v, k) {
	          return { name: k, id: _lodash2.default.head(v).id, count: v.length };
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-content' },
	        !canViewData && _react2.default.createElement(_semanticUiReact.Message, {
	          info: true,
	          content: 'No permissions. Please use "Send ADR request" button to get permissions for viewing data.'
	        }),
	        canViewInstagram && _react2.default.createElement(_instagramProfileData2.default, {
	          displayAuthorisedData: displayAuthorisedData,
	          loading: loading,
	          influencer: influencer,
	          stats: statistics,
	          data: data.instagram,
	          error: error,
	          organisationId: organisationId
	        }),
	        canViewInstagram && (!hasDemographicsData || !displayAuthorisedData) && _react2.default.createElement(_dyzioDemographics2.default, { influencer: influencer, organisationId: organisationId }),
	        canViewInstagram && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              { columns: 2 },
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 4 },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Brand Collaborations'
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'dyzio tracks any #Ads, Paid Partnerships or sponsored content your influencer posts on their Instagram feed.'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 12 },
	                  brandMentionsLoading && _react2.default.createElement(_semanticUiReact.Loader, {
	                    active: true,
	                    inline: 'centered',
	                    content: 'Loading brand mentions data',
	                    style: brandMentionsLoadingStyle
	                  }),
	                  !brandMentionsLoading && _lodash2.default.isEmpty(brandMentionsData) && _react2.default.createElement(
	                    _semanticUiReact.Message,
	                    { icon: true, info: true, style: emptyDataStyle },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline' }),
	                    _react2.default.createElement(
	                      _semanticUiReact.Message.Content,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Message.Header,
	                        null,
	                        'No brand mentions yet'
	                      ),
	                      'No brand mentions were found in their last 50 instagram posts'
	                    )
	                  ),
	                  brandMentionsData && brandMentionsData.length > 0 && _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', flexDirection: 'column', flexWrap: 'wrap' } },
	                    _lodash2.default.map(brandMentionsData, function (brandMention) {
	                      return _react2.default.createElement(
	                        _semanticUiReact.Card,
	                        { style: { display: 'flex', flexDirection: 'row', width: "90%" } },
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            style: { margin: 5 },
	                            title: 'open on Instagram',
	                            target: '_blank',
	                            rel: 'noopener noreferrer',
	                            href: INSTAGRAM_POST_URL + '/' + brandMention.shortcode
	                          },
	                          _react2.default.createElement(_dyzioInstagramEmbed2.default, {
	                            assetId: brandMention.shortcode,
	                            brandMention: true
	                          })
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table,
	                          { singleLine: true, style: { margin: 0 } },
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            null,
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'like outline' }),
	                              ' ',
	                              brandMention.likeCount < 0 ? 'hidden' : sf(brandMention.likeCount)
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'comments outline' }),
	                              ' ',
	                              sf(brandMention.commentCount)
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              null,
	                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye' }),
	                              ' ',
	                              sf(brandMention.viewCount)
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            null,
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              { colSpan: '3' },
	                              _react2.default.createElement(
	                                'div',
	                                { style: overflowEllipsis },
	                                brandMention.text || '-'
	                              )
	                            )
	                          ),
	                          brandMention.sponsor && _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            null,
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              { colSpan: '3' },
	                              _react2.default.createElement(_semanticUiReact.Popup, {
	                                content: brandMention.sponsor,
	                                trigger: _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'money', color: 'pink' }),
	                                  _react2.default.createElement(
	                                    _semanticUiReact.Label,
	                                    null,
	                                    brandMention.sponsor.username
	                                  )
	                                )
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            null,
	                            _react2.default.createElement(
	                              _semanticUiReact.Table.Cell,
	                              { colSpan: '3' },
	                              _react2.default.createElement(_semanticUiReact.Popup, {
	                                content: _lodash2.default.join(brandMention.hashtags, ', '),
	                                trigger: _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  _lodash2.default.map(_lodash2.default.take(_lodash2.default.uniq(brandMention.mentions, 5)), function (m) {
	                                    return _react2.default.createElement(
	                                      _semanticUiReact.Label,
	                                      null,
	                                      _lodash2.default.toLower(m)
	                                    );
	                                  }),
	                                  _lodash2.default.map(_lodash2.default.take(_lodash2.default.uniq(brandMention.hashtags, 5)), function (h) {
	                                    return _react2.default.createElement(
	                                      _semanticUiReact.Label,
	                                      null,
	                                      _lodash2.default.toLower(h)
	                                    );
	                                  })
	                                )
	                              })
	                            )
	                          )
	                        )
	                      );
	                    })
	                  ),
	                  !brandMentionsLoading && !brandMentionsData && _react2.default.createElement(
	                    _semanticUiReact.Message,
	                    { icon: true, info: true, style: emptyDataStyle },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline' }),
	                    _react2.default.createElement(
	                      _semanticUiReact.Message.Content,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Message.Header,
	                        null,
	                        'No brand mentions yet'
	                      ),
	                      'No brand mentions were found in their last 50 instagram posts'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              { columns: 3 },
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 5 },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Influencer Locations'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    { celled: true },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Header,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'Location'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'Count'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Body,
	                      null,
	                      mappedLocations ? _lodash2.default.map(_lodash2.default.orderBy(mappedLocations, ['count'], ['desc']), function (h) {
	                        return _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { target: '_blank', href: 'https://www.instagram.com/explore/locations/' + h.id + '/' },
	                              h.name
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            h.count
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'no locations tagged...'
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 6 },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Content Analysis (Last 12 posts)'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    { celled: true },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Header,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'content type'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'count'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'Eng. Rate'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Body,
	                      null,
	                      influencer.instagramBenchmarks ? _lodash2.default.map(IG_CONTENT_TYPES, function (ct) {
	                        return _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            ct
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            _lodash2.default.get(influencer.instagramBenchmarks[ct], 'count', 0)
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            _lodash2.default.get(influencer.instagramBenchmarks[ct], 'engagementRate', '-'),
	                            '%'
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'not scanned yet...'
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 5 },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Hashtags (Top 10)'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    { celled: true },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Header,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'Hashtag'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.HeaderCell,
	                          null,
	                          'Count'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Body,
	                      null,
	                      influencer.instagramHashtags ? _lodash2.default.map(_lodash2.default.take(influencer.instagramHashtags, 10), function (h) {
	                        return _react2.default.createElement(
	                          _semanticUiReact.Table.Row,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            h.hashtag
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.Table.Cell,
	                            null,
	                            h.count
	                          )
	                        );
	                      }) : _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'not scanned yet...'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        canViewYoutube && _react2.default.createElement(_youtubeProfileDataLarge2.default, {
	          displayAuthorisedData: displayAuthorisedData,
	          loading: loading,
	          influencer: influencer,
	          apiInfluencer: data.apiInfluencer,
	          data: data.youtube,
	          error: error,
	          missingAPILink: missingAPILink,
	          isYouTubeCompliance: isYouTubeCompliance,
	          youtubeDemographicsModalOpen: youtubeDemographicsModalOpen,
	          toggleYoutubeDemographicsModalState: this.toggleYoutubeDemographicsModalState
	        }),
	        canViewFacebook && _react2.default.createElement(_facebookProfileDataLarge2.default, Object.assign({
	          displayAuthorisedData: displayAuthorisedData
	        }, facebookData, {
	          handle: facebook,
	          facebookVerified: facebookVerified,
	          countHistory: countHistory,
	          facebookCountryDemographicsModalOpen: facebookCountryDemographicsModalOpen,
	          toggleFacebookCountryDemographicsModalState: this.toggleFacebookCountryDemographicsModalState,
	          facebookCityDemographicsModalOpen: facebookCityDemographicsModalOpen,
	          toggleFacebookCityDemographicsModalState: this.toggleFacebookCityDemographicsModalState,
	          onFullPageMetrics: this.togglePageMetricModalState,
	          pageMetricModalOpen: pageMetricModalOpen
	        })),
	        canViewTwitter && _react2.default.createElement(_twitterProfileDataLarge2.default, {
	          influencer: influencer,
	          countHistory: countHistory
	        }),
	        canViewTiktok && _react2.default.createElement(_tiktokProfileDataLarge2.default, {
	          influencer: influencer,
	          countHistory: countHistory
	        }),
	        canViewTwitch && _react2.default.createElement(_twitchData2.default, { influencer: influencer }),
	        _react2.default.createElement(_telegramChannels2.default, {
	          influencer: influencer,
	          channels: influencer.telegramChannels,
	          user: influencer.telegramUser
	        }),
	        showBrandCollaborationModal && _react2.default.createElement(
	          _dyzioModal2.default,
	          {
	            onClose: this.popupToggleHandler,
	            headerText: 'Brand Collaboration',
	            size: brandCollabModalSize
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Content,
	            null,
	            _react2.default.createElement(_brandMentionsPostList2.default, {
	              brandName: brandCollaborationData.brand,
	              brandId: brandCollaborationData.id,
	              brandHandle: brandCollaborationData.handle,
	              brandProfilePic: brandCollaborationData.profilePicUrl,
	              shortcodes: brandCollaborationData.engagementFigures.relatedPosts
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencerProfileStats;
	}(_react2.default.Component);
	
	InfluencerProfileStats.propTypes = {
	  organisation: _propTypes2.default.object.isRequired,
	  influencer: _propTypes2.default.object.isRequired,
	  userInfo: _propTypes2.default.object.isRequired,
	  signAWS4Request: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasAws4Signature2.default, _hasUserInfo2.default)(InfluencerProfileStats);

/***/ },
/* 1976 */
913,
/* 1977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _influencerRatesTable = __webpack_require__(1978);
	
	var _influencerRatesTable2 = _interopRequireDefault(_influencerRatesTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfluencerRatesTable = function (_Component) {
	  _inherits(InfluencerRatesTable, _Component);
	
	  function InfluencerRatesTable(props) {
	    _classCallCheck(this, InfluencerRatesTable);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerRatesTable.__proto__ || Object.getPrototypeOf(InfluencerRatesTable)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var facebook = props.facebook,
	        facebookCount = props.facebookCount,
	        facebookRates = props.facebookRates,
	        instagram = props.instagram,
	        instagramCount = props.instagramCount,
	        instagramRates = props.instagramRates,
	        twitter = props.twitter,
	        twitterCount = props.twitterCount,
	        twitterRates = props.twitterRates,
	        youtube = props.youtube,
	        youtubeCount = props.youtubeCount,
	        youtubeChannelTitle = props.youtubeChannelTitle,
	        youtubeRates = props.youtubeRates,
	        web = props.web,
	        webRates = props.webRates,
	        pinterest = props.pinterest,
	        pinterestRates = props.pinterestRates,
	        currency = props.currency,
	        tiktok = props.tiktok,
	        tiktokCount = props.tiktokCount,
	        tiktokRates = props.tiktokRates,
	        twitch = props.twitch,
	        twitchCount = props.twitchCount,
	        twitchRates = props.twitchRates,
	        snapchat = props.snapchat,
	        snapchatRates = props.snapchatRates,
	        telegram = props.telegram,
	        telegramRates = props.telegramRates,
	        others = props.others,
	        othersRates = props.othersRates;
	
	    _this.state = {
	      facebook: facebook,
	      facebookCount: facebookCount,
	      facebookRates: facebookRates,
	      instagram: instagram,
	      instagramCount: instagramCount,
	      instagramRates: instagramRates,
	      twitter: twitter,
	      twitterCount: twitterCount,
	      twitterRates: twitterRates,
	      youtube: youtube,
	      youtubeCount: youtubeCount,
	      youtubeChannelTitle: youtubeChannelTitle,
	      youtubeRates: youtubeRates,
	      web: web,
	      webRates: webRates,
	      pinterest: pinterest,
	      pinterestRates: pinterestRates,
	      currency: currency,
	      tiktok: tiktok,
	      tiktokCount: tiktokCount,
	      tiktokRates: tiktokRates,
	      twitch: twitch,
	      twitchCount: twitchCount,
	      twitchRates: twitchRates,
	      snapchat: snapchat,
	      snapchatRates: snapchatRates,
	      telegram: telegram,
	      telegramRates: telegramRates,
	      others: others,
	      othersRates: othersRates
	    };
	    return _this;
	  }
	
	  return InfluencerRatesTable;
	}(_react.Component);
	
	InfluencerRatesTable.propTypes = {};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.handleEdit = function () {
	    _this2.setState({
	      editing: true
	    });
	  };
	
	  this.handleSave = function () {
	    var onSave = _this2.props.onSave;
	
	    _this2.setState({
	      editing: false
	    }, function () {
	      return onSave(_this2.state);
	    });
	  };
	
	  this.handleCancel = function () {
	    _this2.setState({
	      editing: false
	    });
	  };
	
	  this.handleChange = function (e, _ref) {
	    var name = _ref.name,
	        value = _ref.value;
	
	    _this2.setState((0, _lodash.set)(_extends({}, _this2.state), name, value));
	  };
	
	  this.render = function () {
	    var _state = _this2.state,
	        editing = _state.editing,
	        facebook = _state.facebook,
	        facebookCount = _state.facebookCount,
	        facebookRates = _state.facebookRates,
	        instagram = _state.instagram,
	        instagramCount = _state.instagramCount,
	        instagramRates = _state.instagramRates,
	        twitter = _state.twitter,
	        twitterCount = _state.twitterCount,
	        twitterRates = _state.twitterRates,
	        youtube = _state.youtube,
	        youtubeCount = _state.youtubeCount,
	        youtubeChannelTitle = _state.youtubeChannelTitle,
	        youtubeRates = _state.youtubeRates,
	        web = _state.web,
	        webRates = _state.webRates,
	        pinterest = _state.pinterest,
	        pinterestRates = _state.pinterestRates,
	        currency = _state.currency,
	        tiktok = _state.tiktok,
	        tiktokCount = _state.tiktokCount,
	        tiktokRates = _state.tiktokRates,
	        twitch = _state.twitch,
	        twitchCount = _state.twitchCount,
	        twitchRates = _state.twitchRates,
	        snapchat = _state.snapchat,
	        snapchatRates = _state.snapchatRates,
	        telegram = _state.telegram,
	        telegramRates = _state.telegramRates,
	        others = _state.others,
	        othersRates = _state.othersRates;
	
	    return _react2.default.createElement(_influencerRatesTable2.default, {
	      editing: editing,
	      facebook: facebook,
	      facebookCount: facebookCount,
	      facebookRates: facebookRates,
	      instagram: instagram,
	      instagramCount: instagramCount,
	      instagramRates: instagramRates,
	      twitter: twitter,
	      twitterCount: twitterCount,
	      twitterRates: twitterRates,
	      youtube: youtube,
	      youtubeCount: youtubeCount,
	      youtubeChannelTitle: youtubeChannelTitle,
	      youtubeRates: youtubeRates,
	      web: web,
	      webRates: webRates,
	      pinterest: pinterest,
	      pinterestRates: pinterestRates,
	      tiktok: tiktok,
	      tiktokCount: tiktokCount,
	      tiktokRates: tiktokRates,
	      twitchCount: twitchCount,
	      twitch: twitch,
	      twitchRates: twitchRates,
	      snapchat: snapchat,
	      snapchatRates: snapchatRates,
	      telegram: telegram,
	      telegramRates: telegramRates,
	      onEdit: _this2.handleEdit,
	      onCancel: _this2.handleCancel,
	      onSave: _this2.handleSave,
	      onChange: _this2.handleChange,
	      currency: currency,
	      others: others,
	      othersRates: othersRates
	    });
	  };
	};
	
	exports.default = InfluencerRatesTable;

/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(37);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _editButton = __webpack_require__(1976);
	
	var _editButton2 = _interopRequireDefault(_editButton);
	
	var _socialRatesFields = __webpack_require__(1979);
	
	var _socialRatesFields2 = _interopRequireDefault(_socialRatesFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfluencerRatesTable = function InfluencerRatesTable(_ref) {
	  var editing = _ref.editing,
	      facebook = _ref.facebook,
	      facebookCount = _ref.facebookCount,
	      facebookRates = _ref.facebookRates,
	      instagram = _ref.instagram,
	      instagramCount = _ref.instagramCount,
	      instagramRates = _ref.instagramRates,
	      twitter = _ref.twitter,
	      twitterCount = _ref.twitterCount,
	      twitterRates = _ref.twitterRates,
	      youtubeChannelTitle = _ref.youtubeChannelTitle,
	      youtubeCount = _ref.youtubeCount,
	      youtubeRates = _ref.youtubeRates,
	      tiktok = _ref.tiktok,
	      tiktokCount = _ref.tiktokCount,
	      tiktokRates = _ref.tiktokRates,
	      twitch = _ref.twitch,
	      twitchCount = _ref.twitchCount,
	      twitchRates = _ref.twitchRates,
	      snapchat = _ref.snapchat,
	      snapchatRates = _ref.snapchatRates,
	      telegram = _ref.telegram,
	      telegramRates = _ref.telegramRates,
	      currency = _ref.currency,
	      onEdit = _ref.onEdit,
	      onCancel = _ref.onCancel,
	      onSave = _ref.onSave,
	      onChange = _ref.onChange,
	      othersRates = _ref.othersRates;
	
	  var socialRatesFieldsSharedProps = {
	    readOnly: !editing,
	    currency: currency,
	    onChange: onChange
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        'Rate Card'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { textAlign: 'center' },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Header,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { textAlign: 'left' },
	              'Social Network'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'Followers'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'Image (',
	              currency,
	              ')'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'Video (',
	              currency,
	              ')'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              null,
	              'Story (',
	              currency,
	              ')'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _react2.default.createElement(_socialRatesFields2.default, Object.assign({
	            value: facebook,
	            network: 'facebook',
	            followers: facebookCount,
	            rates: facebookRates
	          }, socialRatesFieldsSharedProps)),
	          _react2.default.createElement(_socialRatesFields2.default, Object.assign({
	            value: instagram,
	            network: 'instagram',
	            followers: instagramCount,
	            rates: instagramRates
	          }, socialRatesFieldsSharedProps)),
	          _react2.default.createElement(_socialRatesFields2.default, Object.assign({
	            value: twitter,
	            network: 'twitter',
	            followers: twitterCount,
	            rates: twitterRates
	          }, socialRatesFieldsSharedProps)),
	          _react2.default.createElement(_socialRatesFields2.default, Object.assign({
	            value: youtubeChannelTitle,
	            network: 'youtube',
	            followers: youtubeCount,
	            rates: youtubeRates
	          }, socialRatesFieldsSharedProps)),
	          _react2.default.createElement(_socialRatesFields2.default, Object.assign({
	            value: tiktok,
	            network: 'tiktok',
	            followers: tiktokCount,
	            rates: tiktokRates
	          }, socialRatesFieldsSharedProps)),
	          _react2.default.createElement(_socialRatesFields2.default, Object.assign({
	            value: twitch,
	            network: 'twitch',
	            followers: twitchCount,
	            rates: twitchRates
	          }, socialRatesFieldsSharedProps)),
	          _react2.default.createElement(_socialRatesFields2.default, Object.assign({
	            value: snapchat,
	            network: 'snapchat',
	            rates: snapchatRates
	          }, socialRatesFieldsSharedProps)),
	          _react2.default.createElement(_socialRatesFields2.default, Object.assign({
	            value: telegram,
	            network: 'telegram',
	            rates: telegramRates
	          }, socialRatesFieldsSharedProps)),
	          _react2.default.createElement(_socialRatesFields2.default, Object.assign({
	            value: 'others',
	            network: 'others',
	            rates: othersRates
	          }, socialRatesFieldsSharedProps)),
	          editing ? _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: 2 },
	              _react2.default.createElement('div', { className: 'spacer small' }),
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                { size: 'medium', basic: true, fluid: true, onClick: onCancel },
	                'Cancel'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: 4 },
	              _react2.default.createElement('div', { className: 'spacer small' }),
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  size: 'medium',
	                  fluid: true,
	                  color: 'pink',
	                  onClick: onSave
	                },
	                'Save Changes'
	              )
	            )
	          ) : _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: 6 },
	              _react2.default.createElement('div', { className: 'spacer small' }),
	              _react2.default.createElement(_editButton2.default, {
	                content: 'Edit Post Rates',
	                onClick: onEdit
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { meta: true },
	      'The influencer rate currency is set in your ',
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/team/manage' },
	        'organisation settings'
	      )
	    )
	  );
	};
	
	InfluencerRatesTable.propTypes = {
	  editing: _propTypes2.default.bool,
	  facebook: _propTypes2.default.string,
	  facebookRates: _propTypes2.default.object,
	  instagram: _propTypes2.default.string,
	  instagramRates: _propTypes2.default.object,
	  twitter: _propTypes2.default.string,
	  twitterRates: _propTypes2.default.object,
	  youtube: _propTypes2.default.string,
	  youtubeRates: _propTypes2.default.object,
	  tiktok: _propTypes2.default.string,
	  tiktokRates: _propTypes2.default.object,
	  twitch: _propTypes2.default.string,
	  twitchRates: _propTypes2.default.object,
	  snapchat: _propTypes2.default.string,
	  snapchatRates: _propTypes2.default.object,
	  telegram: _propTypes2.default.string,
	  telegramRates: _propTypes2.default.object,
	  othersRates: _propTypes2.default.object,
	
	  currency: _propTypes2.default.string.isRequired,
	  onEdit: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func.isRequired,
	  onSave: _propTypes2.default.func.isRequired,
	  onChange: _propTypes2.default.func.isRequired
	};
	InfluencerRatesTable.defaultProps = {
	  editing: false,
	  facebook: undefined,
	  facebookRates: undefined,
	  instagram: undefined,
	  instagramRates: undefined,
	  twitter: undefined,
	  twitterRates: undefined,
	  youtube: undefined,
	  youtubeRates: undefined,
	  tiktok: undefined,
	  tiktokRates: undefined,
	  twitch: undefined,
	  twitchRates: undefined,
	  snapchat: undefined,
	  snapchatRates: undefined,
	  telegram: undefined,
	  telegramRates: undefined,
	  others: undefined,
	  othersRates: undefined
	};
	
	exports.default = InfluencerRatesTable;

/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _currencies = __webpack_require__(128);
	
	var _dyzioIcons = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultNetworks = ['facebook', 'twitter', 'instagram', 'pinterest', 'tiktok', 'snapchat', 'telegram', 'youtube', 'twitch'];
	var hasImages = ['facebook', 'twitter', 'instagram', 'pinterest', 'tiktok', 'snapchat', 'telegram', 'web'];
	var hasVideos = ['facebook', 'twitter', 'instagram', 'youtube', 'twitch', 'tiktok', 'snapchat', 'telegram', 'web'];
	var hasStories = ['facebook', 'instagram'];
	var NaLabel = _react2.default.createElement(
	  _semanticUiReact.Label,
	  null,
	  'N/A'
	);
	
	var UNDEFINED_READONLY_STYLE = {
	  color: '#888'
	};
	
	var findSocialIcon = function findSocialIcon(network) {
	  switch (network) {
	    case 'facebook':
	      return _react2.default.createElement(_dyzioIcons.FacebookIcon, null);
	    case 'instagram':
	      return _react2.default.createElement(_dyzioIcons.InstagramIcon, null);
	    case 'twitter':
	      return _react2.default.createElement(_dyzioIcons.TwitterIcon, null);
	    case 'youtube':
	      return _react2.default.createElement(_dyzioIcons.YoutubeIcon, null);
	    case 'pinterest':
	      return _react2.default.createElement(_dyzioIcons.PinterestIcon, null);
	    case 'tiktok':
	      return _react2.default.createElement(_dyzioIcons.TiktokIcon, null);
	    case 'twitch':
	      return _react2.default.createElement(_dyzioIcons.TwitchIcon, null);
	    case 'snapchat':
	      return _react2.default.createElement(_semanticUiReact.Icon, { name: 'snapchat ghost', color: 'yellow' });
	    case 'telegram':
	      return _react2.default.createElement(_dyzioIcons.TelegramIcon, null);
	    case 'web':
	      return _react2.default.createElement(_dyzioIcons.BlogIcon, null);
	    default:
	      return _react2.default.createElement(_dyzioIcons.BlogIcon, null);
	  }
	};
	
	var SocialRatesFields = function SocialRatesFields(_ref) {
	  var network = _ref.network,
	      currency = _ref.currency,
	      rates = _ref.rates,
	      readOnly = _ref.readOnly,
	      onChange = _ref.onChange,
	      value = _ref.value,
	      followers = _ref.followers;
	
	  var _ref2 = rates || {},
	      imageRate = _ref2.imageRate,
	      videoRate = _ref2.videoRate,
	      storyRate = _ref2.storyRate,
	      networkName = _ref2.networkName;
	
	  var isCustom = !(0, _lodash.includes)(defaultNetworks, network);
	
	  var socialIcon = findSocialIcon(network);
	
	  var handleText = value ? '' + value : _react2.default.createElement(
	    'span',
	    { style: UNDEFINED_READONLY_STYLE },
	    (0, _lodash.startCase)(network)
	  );
	
	  var followersText = followers ? (0, _numeral2.default)(followers).format('0.0a') : null;
	
	  var readOnlyImageRate = imageRate ? '' + (0, _currencies.renderCurrencyQuantity)({ amount: imageRate, currency: currency }) : _react2.default.createElement(
	    'span',
	    { style: UNDEFINED_READONLY_STYLE },
	    'Image Rate'
	  );
	  var readOnlyVideoRate = videoRate ? '' + (0, _currencies.renderCurrencyQuantity)({ amount: videoRate, currency: currency }) : _react2.default.createElement(
	    'span',
	    { style: UNDEFINED_READONLY_STYLE },
	    'Video Rate'
	  );
	  var readOnlyStoryRate = storyRate ? '' + (0, _currencies.renderCurrencyQuantity)({ amount: storyRate, currency: currency }) : _react2.default.createElement(
	    'span',
	    { style: UNDEFINED_READONLY_STYLE },
	    'Story Rate'
	  );
	
	  var currencyInputProps = {
	    label: (0, _currencies.renderCurrencySymbol)(currency),
	    onChange: onChange,
	    fluid: true,
	    type: 'number',
	    readOnly: readOnly
	  };
	
	  var nameInputProps = {
	    onChange: onChange,
	    fluid: true,
	    readOnly: readOnly
	  };
	
	  var imageRateDisplay = readOnly ? readOnlyImageRate : _react2.default.createElement(_semanticUiReact.Input, Object.assign({
	    name: network + 'Rates.imageRate',
	    value: imageRate,
	    placeholder: 'Image Rate'
	  }, currencyInputProps));
	
	  var videoRateDisplay = readOnly ? readOnlyVideoRate : _react2.default.createElement(_semanticUiReact.Input, Object.assign({
	    name: network + 'Rates.videoRate',
	    value: videoRate,
	    placeholder: 'Video Rate'
	  }, currencyInputProps));
	
	  var networkNameInput = readOnly ? networkName + ' (custom)' : _react2.default.createElement(_semanticUiReact.Input, Object.assign({
	    name: 'othersRates.networkName',
	    value: networkName,
	    placeholder: 'Network Name'
	  }, nameInputProps));
	
	  var storyRateDisplay = readOnly ? readOnlyStoryRate : _react2.default.createElement(_semanticUiReact.Input, Object.assign({
	    name: network + 'Rates.storyRate',
	    value: storyRate,
	    placeholder: 'Story Rate'
	  }, currencyInputProps));
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'left' },
	      socialIcon,
	      isCustom ? networkNameInput : handleText
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { collapsing: true },
	      followersText
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { colSpan: 1 },
	      (0, _lodash.includes)(hasImages, network) || isCustom ? imageRateDisplay : NaLabel
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { colSpan: 1 },
	      (0, _lodash.includes)(hasVideos, network) || isCustom ? videoRateDisplay : NaLabel
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { colSpan: 1 },
	      (0, _lodash.includes)(hasStories, network) || isCustom ? storyRateDisplay : NaLabel
	    )
	  );
	};
	
	SocialRatesFields.propTypes = {
	  network: _propTypes2.default.string,
	  currency: _propTypes2.default.string,
	  rates: _propTypes2.default.object,
	  readOnly: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  value: _propTypes2.default.string,
	  followers: _propTypes2.default.number
	};
	
	exports.default = SocialRatesFields;

/***/ },
/* 1980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _utils = __webpack_require__(1981);
	
	var _avatar = __webpack_require__(191);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _authService = __webpack_require__(21);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfluencerReviews = function (_Component) {
	  _inherits(InfluencerReviews, _Component);
	
	  function InfluencerReviews(props) {
	    _classCallCheck(this, InfluencerReviews);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerReviews.__proto__ || Object.getPrototypeOf(InfluencerReviews)).call(this, props));
	
	    _this.onSubmitReview = function (event) {
	      event.preventDefault();
	      var _this$state = _this.state,
	          rating = _this$state.rating,
	          content = _this$state.content;
	      var _this$props = _this.props,
	          influencer = _this$props.influencer,
	          userInfo = _this$props.userInfo;
	      var organisationId = userInfo.organisationId;
	
	
	      var data = {
	        rating: rating,
	        content: content,
	        organisation: organisationId,
	        influencer: influencer.id,
	        user: _authService.authService.uid()
	      };
	
	      return (0, _utils.setReview)(data).then(function (response) {
	        return (0, _utils.updateInfluencerDetails)(_this.props.influencerDetails.id, response);
	      }).then(function () {
	        _this.setState({
	          rating: 0,
	          content: '',
	          error: '',
	          success: 'Your review has been successfully posted.'
	        });
	        return _this.loadReviews();
	      }).catch(function () {
	        return _this.setState({ error: 'There was an error posting your review.', success: '' });
	      });
	    };
	
	    _this.loadReviews = function () {
	      var _this$props2 = _this.props,
	          influencer = _this$props2.influencer,
	          userInfo = _this$props2.userInfo;
	      var organisationId = userInfo.organisationId;
	
	      (0, _utils.getReviews)(influencer.id, organisationId).then(function (reviews) {
	        var reviewArray = [];
	        _lodash2.default.forEach(reviews, function (review) {
	          var formattedReview = review.toJSONTree();
	          reviewArray.push(formattedReview);
	        });
	
	        return _this.setState({
	          loading: false,
	          error: '',
	          reviews: reviewArray.reverse()
	        });
	      }).catch(function () {
	        return _this.setState({
	          loading: false,
	          error: 'There was an error loading the reviews for this influencer.',
	          reviews: []
	        });
	      });
	    };
	
	    _this.state = {
	      loading: true,
	      error: '',
	      success: '',
	      reviews: [],
	      rating: 0,
	      content: ''
	    };
	    return _this;
	  }
	
	  _createClass(InfluencerReviews, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ success: '' });
	      this.loadReviews();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          error = _state.error,
	          success = _state.success,
	          reviews = _state.reviews,
	          rating = _state.rating,
	          content = _state.content;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-content' },
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 9 },
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              null,
	              _react2.default.createElement('div', { className: 'spacer small' }),
	              reviews.length > 0 && _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  reviews.length === 1 ? '1 review' : reviews.length + ' reviews'
	                )
	              ),
	              _lodash2.default.map(reviews, function (review) {
	                return _react2.default.createElement(
	                  'div',
	                  { key: review.id, className: 'simple-message' },
	                  _react2.default.createElement(_semanticUiReact.Divider, null),
	                  _react2.default.createElement('div', { className: 'spacer small' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'top' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'avatar' },
	                      _react2.default.createElement(_avatar2.default, { name: review.createdBy.name, size: 36, plain: true })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'user-info' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        review.createdBy.name,
	                        '\xA0\xA0',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'light' },
	                          (0, _moment2.default)(review.createdDate).format('ddd D MMM hh:mm')
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'content-container' },
	                    _react2.default.createElement(_semanticUiReact.Rating, { icon: 'star', rating: review.rating, maxRating: 5, disabled: true }),
	                    _react2.default.createElement('div', { className: 'spacer small' }),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      review.content
	                    ),
	                    _react2.default.createElement('div', { className: 'spacer small' })
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 7 },
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { padded: true },
	              _react2.default.createElement(
	                'p',
	                { className: 'light' },
	                'Your notes and reviews are only available internally to your organisation'
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Rate this influencer ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'light' },
	                    '(optional)'
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'spacer small' }),
	              _react2.default.createElement(_semanticUiReact.Rating, {
	                icon: 'star',
	                rating: rating,
	                maxRating: 5,
	                onRate: function onRate(e, v) {
	                  return _this2.setState({ rating: v.rating });
	                },
	                size: 'large'
	              }),
	              _react2.default.createElement('div', { className: 'spacer small' }),
	              _react2.default.createElement(
	                _semanticUiReact.Form,
	                { onSubmit: this.onSubmitReview },
	                _react2.default.createElement(_semanticUiReact.Form.TextArea, {
	                  placeholder: 'Tell us more',
	                  onChange: function onChange(e, v) {
	                    return _this2.setState({ content: v.value });
	                  },
	                  value: content,
	                  label: 'Your Comment',
	                  required: true
	                }),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { size: 'medium', fluid: true, color: 'pink' },
	                  'Add Note or Review'
	                )
	              ),
	              error && _react2.default.createElement(
	                _semanticUiReact.Message,
	                { negative: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  error
	                )
	              ),
	              success && _react2.default.createElement(
	                _semanticUiReact.Message,
	                { positive: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  success
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencerReviews;
	}(_react.Component);
	
	InfluencerReviews.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  influencerDetails: _propTypes2.default.object.isRequired
	};
	
	
	InfluencerReviews.propTypes = {
	  userInfo: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default)(InfluencerReviews);

/***/ },
/* 1981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getReviews = getReviews;
	exports.setReview = setReview;
	exports.updateInfluencerDetails = updateInfluencerDetails;
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var client = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	  header: {
	    Authorization: 'Bearer ' + _authService.authService.getToken()
	  }
	});
	
	function getReviews(influencerID, organisationID) {
	  return client.find('review', { filter: { influencer: influencerID, organisation: organisationID }, include: ['createdBy'], sort: ['createdDate'] });
	}
	
	function setReview(data) {
	  var review = client.create('review');
	  var date = new Date();
	
	  review.set('rating', data.rating);
	  review.set('content', data.content);
	  review.set('organisation', { type: 'organisations', id: data.organisation });
	  review.set('influencer', { type: 'influencer', id: data.influencer });
	  review.set('createdBy', { type: 'users', id: data.user });
	  review.set('createdDate', date);
	
	  return review.sync();
	}
	
	function updateInfluencerDetails(influencerDetails, review) {
	  return client.get('influencerDetails', influencerDetails, { include: ['reviews'] }).then(function (response) {
	    var length = response.toJSONTree().reviews.length + 1;
	    var total = review.toJSONTree().rating;
	    response.toJSONTree().reviews.forEach(function (r) {
	      total += r.rating;
	    });
	    var avg = Math.round(total / length);
	    response.set('assessment', avg);
	    response.relationships('reviews').add(review);
	    return response.sync();
	  });
	}

/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactQuill = __webpack_require__(731);
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _socialTable = __webpack_require__(553);
	
	var _socialTable2 = _interopRequireDefault(_socialTable);
	
	var _countries = __webpack_require__(93);
	
	var countryList = _interopRequireWildcard(_countries);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cardStyles = {
	  margin: '20px auto'
	};
	
	var cardContent = {
	  paddingBottom: 0
	};
	
	var noPadding = {
	  padding: 0,
	  marginBottom: 0,
	  border: 0
	};
	
	var thumbnailStyles = {
	  height: '50px',
	  width: '50px'
	};
	
	var influencerBioStyles = {
	  height: '150px'
	};
	
	var buttonStyles = {
	  width: '150px'
	};
	
	var InfluencerShortlistEditableCard = function (_React$PureComponent) {
	  _inherits(InfluencerShortlistEditableCard, _React$PureComponent);
	
	  function InfluencerShortlistEditableCard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InfluencerShortlistEditableCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InfluencerShortlistEditableCard.__proto__ || Object.getPrototypeOf(InfluencerShortlistEditableCard)).call.apply(_ref, [this].concat(args))), _this), _this.getMediaLink = function () {
	      var _this$props = _this.props,
	          influencer = _this$props.influencer,
	          organisation = _this$props.organisation;
	
	      return _lodash2.default.get(organisation, 'mediaKitUrl') + '/media-kit/' + influencer.id;
	    }, _this.hasMediaKit = function () {
	      var organisation = _this.props.organisation;
	
	      console.log('organisation', organisation);
	      return _lodash2.default.get(organisation, 'mediaKitUrl');
	    }, _this.render = function () {
	      var _this$props2 = _this.props,
	          influencer = _this$props2.influencer,
	          dataNode = _this$props2.dataNode,
	          _onChange = _this$props2.onChange,
	          onSave = _this$props2.onSave,
	          onRemove = _this$props2.onRemove,
	          compact = _this$props2.compact,
	          description = _this$props2.description;
	
	      var country = _lodash2.default.find(countryList.default, ['key', influencer.country]);
	      var countryName = country && country.text || influencer.country;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        {
	          fluid: true,
	          style: cardStyles
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          { style: cardContent, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            { padded: 'horizontally' },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              { verticalAlign: 'middle' },
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 6, style: noPadding },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Image, {
	                    src: influencer.thumbnail,
	                    style: thumbnailStyles,
	                    floated: 'left', size: 'tiny', shape: 'circular'
	                  }),
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    influencer.name
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'small light' },
	                    influencer.primarySocialHandle
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 4 },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  countryName || ''
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 6, style: noPadding },
	                _react2.default.createElement(_socialTable2.default, { influencer: influencer, mode: 'SHORTLIST' })
	              )
	            )
	          )
	        ),
	        !compact && _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Influencer Bio'
	          ),
	          _react2.default.createElement(_reactQuill2.default, {
	            value: dataNode ? dataNode.description : description,
	            onChange: function onChange(e, v) {
	              _onChange(influencer.id, e, v);
	            }
	          })
	        ),
	        _this.hasMediaKit() && _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Influencer Media Card'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: _this.getMediaLink(), target: '_blank', rel: 'noopener noreferrer' },
	              'Click here to view the influencers demographics'
	            )
	          )
	        ),
	        !compact && _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(_semanticUiReact.Button, { content: 'save', icon: 'save', floated: 'right', style: buttonStyles, onClick: onSave }),
	          _react2.default.createElement(_semanticUiReact.Button, {
	            content: 'remove',
	            icon: 'minus circle',
	            color: 'orange',
	            style: buttonStyles,
	            onClick: function onClick() {
	              onRemove(influencer.id);
	            }
	          })
	        ),
	        !compact && dataNode && dataNode.approvals && _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _lodash2.default.map(dataNode.approvals, function (approval) {
	            return _react2.default.createElement(
	              'p',
	              null,
	              approval.message,
	              '\xA0',
	              approval.type === 'APPROVE' ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'thumbs outline up', color: 'green' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'thumbs outline down', color: 'red' })
	            );
	          })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return InfluencerShortlistEditableCard;
	}(_react2.default.PureComponent);
	
	exports.default = InfluencerShortlistEditableCard;

/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _socialTable = __webpack_require__(553);
	
	var _telegramChannels = __webpack_require__(1984);
	
	var _telegramChannels2 = _interopRequireDefault(_telegramChannels);
	
	var _dyzioIcons = __webpack_require__(92);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tableStyle = {
	  fontSize: 12
	};
	
	var redbackgroundStyle = {
	  background: 'rgb(239,58,80, .2)'
	};
	
	var getYoutubeLink = function getYoutubeLink(handle) {
	  if (!handle) return '';
	  var channelIdRegex = /^UC([a-zA-Z0-9_-]{22})$/;
	  return handle.match(channelIdRegex) ? 'channel/' : 'user/';
	};
	
	var Username = function Username(_ref) {
	  var handle = _ref.handle,
	      handleLength = _ref.handleLength;
	
	  var maxLength = handleLength || 13;
	  var isBigUsername = _lodash2.default.size(handle) > maxLength;
	  if (isBigUsername) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      content: handle, trigger: _react2.default.createElement(
	        'span',
	        null,
	        _lodash2.default.truncate(handle, { length: maxLength }) || '-'
	      )
	    });
	  }
	  return _react2.default.createElement(
	    'span',
	    null,
	    handle
	  );
	};
	
	var SocialExternalLink = function SocialExternalLink(_ref2) {
	  var platform = _ref2.platform,
	      handle = _ref2.handle,
	      influencer = _ref2.influencer;
	
	  var isYoutube = platform === 'youtube';
	  var youtubePath = isYoutube ? '/channel/' + (influencer.youtubeChannelId || influencer.youtubeChannelTitle || influencer.youtube) : '';
	  var isTiktok = platform === 'tiktok';
	  var tiktokNotation = isTiktok ? '@' : '';
	  return _react2.default.createElement(
	    'a',
	    {
	      href: 'https://www.' + platform + '.com/' + youtubePath + tiktokNotation + (isYoutube ? '' : handle),
	      target: '_blank',
	      rel: 'noopener noreferrer'
	    },
	    _react2.default.createElement(Username, { handle: handle })
	  );
	};
	
	var SocialChannelInfo = function SocialChannelInfo(props) {
	  var isBusinessAccount = props.isBusinessAccount,
	      icon = props.icon,
	      platform = props.platform,
	      username = props.username,
	      count = props.count,
	      influencer = props.influencer,
	      isFacebookPersonalPage = props.isFacebookPersonalPage;
	
	  var isFacebook = platform === 'facebook';
	  console.log(influencer);
	  console.log(influencer.telegramChannels);
	  if (!username) return null;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    { style: isFacebook && isFacebookPersonalPage ? redbackgroundStyle : {} },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      isBusinessAccount ? _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          _semanticUiReact.Icon.Group,
	          { size: 'large' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
	          _react2.default.createElement(_semanticUiReact.Icon, { corner: true, name: 'briefcase', color: 'pink' })
	        ),
	        content: 'Business Account'
	      }) : icon
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(SocialExternalLink, { handle: username, platform: platform, influencer: influencer })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.scientificFormat)(count) || '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      !isFacebookPersonalPage && (0, _socialTable.getAuthorisedIcon)(influencer, platform),
	      isFacebook && isFacebookPersonalPage && _react2.default.createElement(_semanticUiReact.Popup, {
	        content: 'This is a personal page. This instagram account must be linked to a Community page.',
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, {
	          size: 'small',
	          className: 'circular',
	          color: 'red',
	          name: 'warning',
	          inverted: true
	        })
	      })
	    )
	  );
	};
	
	var hasTelegramChannels = function hasTelegramChannels(telegramChannelsArray) {
	  return !_lodash2.default.isEmpty(telegramChannelsArray);
	};
	
	var InfluencerSocialChannelsTable = function InfluencerSocialChannelsTable(influencer) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table,
	      {
	        style: tableStyle,
	        stackable: true,
	        basic: 'very',
	        textAlign: 'center',
	        verticalAlign: 'middle'
	      },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Body,
	        null,
	        _react2.default.createElement(SocialChannelInfo, {
	          influencer: influencer,
	          isAuthorised: influencer.instagramAuthorised,
	          username: influencer.instagram,
	          platform: 'instagram',
	          count: influencer.instagramCount,
	          icon: _react2.default.createElement(_dyzioIcons.InstagramIcon, { size: 'large' }),
	          instagramBusinessAccount: influencer.instagramBusinessAccount
	        }),
	        _react2.default.createElement(SocialChannelInfo, {
	          influencer: influencer,
	          isAuthorised: influencer.facebookAuthorised,
	          username: influencer.facebook,
	          platform: 'facebook',
	          isFacebookPersonalPage: influencer.isFacebookPersonalPage,
	          count: influencer.facebookCount,
	          icon: _react2.default.createElement(_dyzioIcons.FacebookIcon, { size: 'large' })
	        }),
	        _react2.default.createElement(SocialChannelInfo, {
	          influencer: influencer,
	          isAuthorised: influencer.twitterAuthorised,
	          username: influencer.twitter,
	          platform: 'twitter',
	          count: influencer.twitterCount,
	          icon: _react2.default.createElement(_dyzioIcons.TwitterIcon, { size: 'large' })
	        }),
	        _react2.default.createElement(SocialChannelInfo, {
	          influencer: influencer,
	          isAuthorised: influencer.youtubeAuthorised,
	          username: influencer.youtubeChannelTitle || influencer.youtube,
	          count: influencer.youtubeCount,
	          platform: 'youtube',
	          icon: _react2.default.createElement(
	            _semanticUiReact.Label,
	            null,
	            'YOUTUBE'
	          )
	        }),
	        _react2.default.createElement(SocialChannelInfo, {
	          influencer: influencer,
	          username: influencer.tiktok,
	          count: influencer.tiktokCount,
	          platform: 'tiktok',
	          icon: _react2.default.createElement(_dyzioIcons.TiktokIcon, { size: 'large' })
	        }),
	        _react2.default.createElement(SocialChannelInfo, {
	          influencer: influencer,
	          username: influencer.twitch,
	          count: influencer.twitchCount,
	          platform: 'twitch',
	          icon: _react2.default.createElement(_dyzioIcons.TwitchIcon, { size: 'large' })
	        })
	      )
	    ),
	    hasTelegramChannels(influencer.telegramChannels) && _react2.default.createElement(_telegramChannels2.default, influencer)
	  );
	};
	
	SocialChannelInfo.propTypes = {
	  isBusinessAccount: _propTypes2.default.bool,
	  icon: _propTypes2.default.node.isRequired,
	  username: _propTypes2.default.string.isRequired,
	  count: _propTypes2.default.number.isRequired
	};
	
	SocialChannelInfo.defaultProps = {
	  isBusinessAccount: false
	};
	
	exports.default = InfluencerSocialChannelsTable;

/***/ },
/* 1984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TELEGRAM_HANDLE_LENGTH = 20;
	
	var tableStyle = {
	  fontSize: 12
	};
	
	var Username = function Username(_ref) {
	  var handle = _ref.handle;
	
	  var maxLength = TELEGRAM_HANDLE_LENGTH;
	  var isBigUsername = _lodash2.default.size(handle) > maxLength;
	  if (isBigUsername) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      content: handle, trigger: _react2.default.createElement(
	        'span',
	        null,
	        _lodash2.default.truncate(handle, { length: maxLength }) || '-'
	      )
	    });
	  }
	  return _react2.default.createElement(
	    'span',
	    null,
	    handle
	  );
	};
	
	Username.propTypes = {
	  handle: _propTypes2.default.string.isRequired
	};
	
	var TelegramExternalLink = function TelegramExternalLink(_ref2) {
	  var handle = _ref2.handle;
	  return _react2.default.createElement(
	    'a',
	    {
	      href: 'https://t.me/' + handle,
	      target: '_blank',
	      rel: 'noopener noreferrer'
	    },
	    _react2.default.createElement(Username, { handle: handle })
	  );
	};
	
	var telegramChannelsType = {
	  CHANNEL: 'C',
	  USER: 'U',
	  GROUP: 'G',
	  SUPERGROUP: 'SG'
	};
	
	TelegramExternalLink.propTypes = {
	  handle: _propTypes2.default.string.isRequired
	};
	
	var TelegramChannelInfo = function TelegramChannelInfo(props) {
	  console.log(props);
	  var channelType = props.channelType,
	      followerCount = props.followerCount,
	      username = props.username,
	      thumbnail = props.thumbnail;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { width: 1, textAlign: 'left' },
	      _react2.default.createElement(_semanticUiReact.Image, { src: thumbnail, avatar: true, size: 'mini' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { width: 9, textAlign: 'left' },
	      _react2.default.createElement(TelegramExternalLink, { handle: username, platform: 'telegram' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { width: 1 },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        content: _lodash2.default.capitalize(channelType),
	        trigger: _react2.default.createElement(
	          _semanticUiReact.Label,
	          { basic: true, circular: true, color: 'blue', key: 'blue' },
	          telegramChannelsType[channelType] || '-'
	        )
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { width: 1 },
	      (0, _formatting.scientificFormat)(followerCount) || '-'
	    )
	  );
	};
	
	var TelegramChannelsTable = function TelegramChannelsTable(influencer) {
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram', size: 'medium', color: 'blue' }),
	      'Telegram',
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        {
	          style: tableStyle,
	          stackable: true,
	          basic: 'very',
	          textAlign: 'center',
	          verticalAlign: 'middle'
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _lodash2.default.map(influencer.telegramChannels, function (telegram) {
	            return _react2.default.createElement(TelegramChannelInfo, telegram);
	          })
	        )
	      )
	    )
	  );
	};
	
	TelegramChannelInfo.propTypes = {
	  channelType: _propTypes2.default.string.isRequired,
	  followerCount: _propTypes2.default.number.isRequired,
	  username: _propTypes2.default.string.isRequired,
	  thumbnail: _propTypes2.default.string.isRequired
	};
	
	TelegramChannelInfo.defaultProps = {
	  followerCount: null
	};
	
	exports.default = TelegramChannelsTable;

/***/ },
/* 1985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _index = __webpack_require__(865);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _dyzioIcons = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchSorting = function matchSorting(s) {
	  return _lodash2.default.lowerCase(s).concat('ending');
	};
	
	var InfluencerTableHeaderRow = function InfluencerTableHeaderRow(props) {
	  var columnsSettings = props.columnsSettings,
	      sorting = props.sorting;
	  var field = sorting.field,
	      order = sorting.order;
	
	
	  var sortedName = field === 'name' ? matchSorting(order) : null;
	  var sortedCountry = field === 'country' ? matchSorting(order) : null;
	  var sortedFacebook = field === 'facebookCount' ? matchSorting(order) : null;
	  var sortedYoutube = field === 'youtubeCount' ? matchSorting(order) : null;
	  var sortedInstagram = field === 'instagramCount' ? matchSorting(order) : null;
	  var sortedTwitter = field === 'twitterCount' ? matchSorting(order) : null;
	  var sortedCreatedDate = field === 'createdDate' ? matchSorting(order) : null;
	  var sortedTwitch = field === 'twitchCount' ? matchSorting(order) : null;
	  var sortedTiktok = field === 'tiktokCount' ? matchSorting(order) : null;
	  var instagramEngagementRateSorted = field === 'instagramEngagementRate' ? matchSorting(order) : null;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      {
	        verticalAlign: 'middle',
	        textAlign: 'center',
	        width: 1
	      },
	      _react2.default.createElement(_semanticUiReact.Checkbox, { onChange: props.onCheckAll })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      {
	        width: 4,
	        onClick: function onClick() {
	          return props.onSort('name', sortedName);
	        },
	        sorted: sortedName
	      },
	      'Influencer'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      {
	        width: 1,
	        onClick: function onClick() {
	          return props.onSort('country', sortedCountry);
	        },
	        sorted: sortedCountry,
	        textAlign: 'center'
	      },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'flag outline' }),
	        content: 'Influencer country'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      {
	        width: 1,
	        textAlign: 'center'
	      },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'briefcase' }),
	        content: 'is Instagram Business Account?'
	      })
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'instagram_engagement_rate') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        {
	          textAlign: 'center',
	          width: 1,
	          onClick: function onClick() {
	            return props.onSort('instagramEngagementRate', instagramEngagementRateSorted);
	          },
	          sorted: instagramEngagementRateSorted
	        },
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'percent', color: 'pink' }),
	          content: 'Instagram Engagement Rate'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'facebook') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        {
	          textAlign: 'center',
	          width: 1,
	          onClick: function onClick() {
	            return props.onSort('facebookCount', sortedFacebook);
	          },
	          sorted: sortedFacebook
	        },
	        _react2.default.createElement('img', { src: '/icons/facebook.svg', alt: 'Facebook' })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'instagram') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        {
	          width: 1,
	          textAlign: 'center',
	          onClick: function onClick() {
	            return props.onSort('instagramCount', sortedInstagram);
	          },
	          sorted: sortedInstagram
	        },
	        _react2.default.createElement('img', { src: '/icons/instagram.svg', alt: 'Instagram' })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'twitter') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        {
	          textAlign: 'center',
	          width: 1,
	          onClick: function onClick() {
	            return props.onSort('twitterCount', sortedTwitter);
	          },
	          sorted: sortedTwitter
	        },
	        _react2.default.createElement('img', { src: '/icons/twitter.svg', alt: 'Twitter' })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'youtube') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        {
	          textAlign: 'center',
	          width: 1,
	          onClick: function onClick() {
	            return props.onSort('youtubeCount', sortedYoutube);
	          },
	          sorted: sortedYoutube
	        },
	        _react2.default.createElement('img', { src: '/icons/youtube.svg', alt: 'YouTube' })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'website') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        {
	          width: 1,
	          textAlign: 'center'
	        },
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'world', color: 'blue' }),
	          content: 'Website or blog URL'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'snapchat') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        {
	          width: 1,
	          textAlign: 'center'
	        },
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'snapchat ghost', color: 'yellow' }),
	          content: 'Snapchat handle'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'telegram') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        {
	          width: 1,
	          textAlign: 'center'
	        },
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram', size: 'large', color: 'blue' }),
	          content: 'Telegram User (channel counts)'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'twitch') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        {
	          width: 1,
	          onClick: function onClick() {
	            return props.onSort('twitchCount', sortedTwitch);
	          },
	          sorted: sortedTwitch,
	          textAlign: 'center'
	        },
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitch', color: 'purple' }),
	          content: 'Twitch follower count'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'tiktok') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        {
	          width: 1,
	          onClick: function onClick() {
	            return props.onSort('tiktokCount', sortedTiktok);
	          },
	          sorted: sortedTiktok,
	          textAlign: 'center'
	        },
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(_dyzioIcons.TiktokIcon, null),
	          content: 'Tiktok follower count'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'linkedin') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.HeaderCell,
	        {
	          width: 1.5,
	          textAlign: 'center'
	        },
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkedin', color: 'blue' }),
	          content: 'Linkedin handle'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      {
	        onClick: function onClick() {
	          return props.onSort('createdDate', sortedCreatedDate);
	        },
	        width: 2,
	        sorted: sortedCreatedDate,
	        textAlign: 'center'
	      },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'checked calendar' }),
	        content: 'The date the influencer was added to your database.'
	      })
	    )
	  );
	};
	
	InfluencerTableHeaderRow.propTypes = {
	  onCheckAll: _propTypes2.default.func.isRequired,
	  onSort: _propTypes2.default.func.isRequired,
	  sorting: _propTypes2.default.object.isRequired,
	  columnsSettings: _propTypes2.default.object.isRequired
	};
	
	exports.default = InfluencerTableHeaderRow;

/***/ },
/* 1986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _influencerTableSocialLink = __webpack_require__(881);
	
	var _influencerTableSocialLink2 = _interopRequireDefault(_influencerTableSocialLink);
	
	var _instagramAccountType = __webpack_require__(1988);
	
	var _instagramAccountType2 = _interopRequireDefault(_instagramAccountType);
	
	var _index = __webpack_require__(865);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_IMAGE = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/no_image_available.png';
	
	var badgeStyle = {
	  display: 'flex',
	  alignItems: 'center'
	};
	
	var avatarStyle = {
	  marginRight: '10px'
	};
	
	var rowPadding = {
	  padding: 8
	};
	var influencerCellStyle = _extends({}, rowPadding);
	
	var InfluencerTableRow = function InfluencerTableRow(props) {
	  var link = props.link,
	      columnsSettings = props.columnsSettings,
	      displayAuthorisedData = props.displayAuthorisedData;
	
	  var id = _lodash2.default.get(link, 'link.id') || link.id;
	  var linkCreatedDate = link.createdDate || link.lookupInfluencer.createdDate;
	  var linkCreatedBy = link.createdBy || link.lookupInfluencer.createdBy;
	  var tokenIsBad = _lodash2.default.get(link, 'lookupInfluencer.instagramStatus') === 'WARN';
	  var shouldRenderTokenWarning = tokenIsBad && displayAuthorisedData;
	
	  var influencerCreatedBy = link.lookupDetails.createdBy;
	  var influencerSignupSource = link.lookupInfluencer.signupSource;
	
	  var influencer = link.lookupInfluencer;
	  var countries = props.countries;
	  var name = influencer.name,
	      thumbnail = influencer.thumbnail,
	      primarySocialHandle = influencer.primarySocialHandle,
	      youtube = influencer.youtube,
	      youtubeCount = influencer.youtubeCount,
	      instagram = influencer.instagram,
	      instagramCount = influencer.instagramCount,
	      facebook = influencer.facebook,
	      facebookCount = influencer.facebookCount,
	      twitter = influencer.twitter,
	      twitterCount = influencer.twitterCount,
	      twitch = influencer.twitch,
	      twitchCount = influencer.twitchCount,
	      tiktok = influencer.tiktok,
	      tiktokCount = influencer.tiktokCount,
	      web = influencer.web,
	      snapchat = influencer.snapchat,
	      linkedin = influencer.linkedin,
	      country = influencer.country,
	      status = influencer.status,
	      instagramBusinessAccount = influencer.instagramBusinessAccount,
	      instagramProfessionalAccount = influencer.instagramProfessionalAccount,
	      instagramRestrictedProfile = influencer.instagramRestrictedProfile,
	      instagramRestrictedProfileText = influencer.instagramRestrictedProfileText,
	      instagramEngagementRate = influencer.instagramEngagementRate,
	      instagramPrivate = influencer.instagramPrivate;
	
	
	  var withDemoTag = status === 'CLAIMED';
	
	  var instagramLink = {
	    href: 'https://instagram.com/',
	    label: 'view on instagram',
	    handle: instagram,
	    color: 'pink'
	  };
	
	  var twitterLink = {
	    href: 'https://twitter.com/',
	    label: 'view on twitter',
	    handle: twitter,
	    color: 'blue'
	  };
	
	  var facebookLink = {
	    href: 'https://facebook.com/',
	    label: 'view on facebook',
	    handle: facebook,
	    color: 'blue'
	  };
	
	  var youtubeLink = {
	    href: 'https://youtube.com/results?search_query=',
	    label: 'view on youtube',
	    handle: youtube,
	    color: 'red'
	  };
	
	  var twitchLink = {
	    href: 'https://twitch.tv/',
	    label: 'view on twitch',
	    handle: twitch,
	    color: 'purple'
	  };
	
	  var tiktokLink = {
	    href: 'https://www.tiktok.com/',
	    label: 'view on tiktok',
	    handle: tiktok,
	    color: 'purple'
	  };
	
	  var rowStyle = { cursor: 'pointer' };
	
	  var warningRowStyle = _extends({}, rowStyle, {
	    background: '#FFDEAD'
	  });
	
	  var checkBoxValue = {
	    id: influencer.id,
	    linkId: id,
	    name: name,
	    thumbnail: thumbnail,
	    primarySocialHandle: primarySocialHandle
	  };
	
	  var isSelected = _lodash2.default.some(props.selected, { id: influencer.id });
	
	  var mapping = _lodash2.default.find(countries, ['key', country]);
	  var countryName = mapping && mapping.text || '-';
	
	  var getWebLink = function getWebLink(url) {
	    var httpRegEx = /^http(s?):\/\/(.*)$/i;
	    var match = url.match(httpRegEx);
	    var webLink = match ? url : 'https://' + url;
	    return webLink;
	  };
	
	  var font90 = {
	    fontSize: '90%',
	    color: 'grey'
	  };
	
	  var font70 = {
	    fontSize: '70%',
	    color: 'grey'
	  };
	
	  var dateString = (0, _moment2.default)(linkCreatedDate).format('DD/MM/YYYY');
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    { key: id, style: shouldRenderTokenWarning ? warningRowStyle : rowStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center', style: rowPadding },
	      _react2.default.createElement(_semanticUiReact.Checkbox, {
	        checked: isSelected,
	        onChange: props.onCheckboxStateUpdated,
	        value: checkBoxValue
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      {
	        verticalAlign: 'middle',
	        onClick: function onClick() {
	          return props.handleRowClick(id);
	        },
	        style: influencerCellStyle
	      },
	      _react2.default.createElement(
	        'div',
	        { style: badgeStyle },
	        _react2.default.createElement(
	          'div',
	          { style: avatarStyle },
	          _react2.default.createElement(_semanticUiReact.Image, {
	            avatar: true,
	            src: thumbnail || 'no thumbnails',
	            onError: function onError(i) {
	              i.target.src = DEFAULT_IMAGE;
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              primarySocialHandle
	            )
	          ),
	          !withDemoTag && _react2.default.createElement(
	            'div',
	            { className: 'light', style: font90 },
	            name
	          ),
	          withDemoTag && _react2.default.createElement(
	            _semanticUiReact.Label,
	            {
	              size: 'mini',
	              color: 'pink',
	              basic: true
	            },
	            'DEMO'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center', onClick: function onClick() {
	          return props.handleRowClick(id);
	        }, style: rowPadding },
	      country && _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Flag, { name: _lodash2.default.toLower(country) }),
	        content: countryName
	      }),
	      !country && '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center', onClick: function onClick() {
	          return props.handleRowClick(id);
	        }, style: rowPadding },
	      _react2.default.createElement(_instagramAccountType2.default, {
	        instagram: instagram,
	        isProfessional: instagramProfessionalAccount,
	        isBusiness: instagramBusinessAccount,
	        isRestricted: instagramRestrictedProfile,
	        restrictedText: instagramRestrictedProfileText,
	        isPrivate: instagramPrivate
	      })
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      {
	        shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'instagram_engagement_rate')
	      },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        { textAlign: 'center', onClick: function onClick() {
	            return props.handleRowClick(id);
	          }, style: rowPadding },
	        instagramEngagementRate ? (0, _formatting.ierFormat)(instagramEngagementRate) : '-'
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'facebook') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        {
	          collapsing: true, textAlign: 'center', onClick: function onClick() {
	            return props.handleRowClick(id);
	          }, style: rowPadding
	        },
	        _react2.default.createElement(_influencerTableSocialLink2.default, {
	          count: facebookCount,
	          link: facebookLink,
	          data: influencer.facebookData
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'instagram') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        {
	          collapsing: true, textAlign: 'center', onClick: function onClick() {
	            return props.handleRowClick(id);
	          }, style: rowPadding
	        },
	        _react2.default.createElement(_influencerTableSocialLink2.default, {
	          count: instagramCount,
	          link: instagramLink,
	          data: influencer.instagramData
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'twitter') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        {
	          collapsing: true, textAlign: 'center', onClick: function onClick() {
	            return props.handleRowClick(id);
	          }, style: rowPadding
	        },
	        _react2.default.createElement(_influencerTableSocialLink2.default, {
	          count: twitterCount,
	          link: twitterLink
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'youtube') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        {
	          collapsing: true, textAlign: 'center', onClick: function onClick() {
	            return props.handleRowClick(id);
	          }, style: rowPadding
	        },
	        _react2.default.createElement(_influencerTableSocialLink2.default, {
	          count: youtubeCount,
	          link: youtubeLink,
	          data: influencer.youtubeData
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'website') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        {
	          collapsing: true, textAlign: 'center', onClick: function onClick() {
	            return props.handleRowClick(id);
	          }, style: rowPadding
	        },
	        web ? _react2.default.createElement(_semanticUiReact.Popup, {
	          hoverable: true,
	          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'world', color: 'pink' }),
	          content: _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'world', color: 'pink' }),
	            _react2.default.createElement(
	              'a',
	              { href: getWebLink(web), rel: 'noopener noreferrer', target: '_blank' },
	              web
	            )
	          )
	        }) : _react2.default.createElement(
	          'span',
	          null,
	          '-'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'snapchat') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        {
	          collapsing: true, textAlign: 'center', onClick: function onClick() {
	            return props.handleRowClick(id);
	          }, style: rowPadding
	        },
	        snapchat ? _react2.default.createElement(_semanticUiReact.Popup, {
	          hoverable: true,
	          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'snapchat', color: 'pink' }),
	          content: _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'snapchat ghost', color: 'yellow' }),
	            _react2.default.createElement(
	              'b',
	              null,
	              snapchat
	            )
	          )
	        }) : _react2.default.createElement(
	          'span',
	          null,
	          '-'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'telegram') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        {
	          collapsing: true, textAlign: 'center', onClick: function onClick() {
	            return props.handleRowClick(id);
	          }, style: rowPadding
	        },
	        _lodash2.default.get(influencer, 'telegramUser') ? _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'green' })
	        ) : _react2.default.createElement(
	          'span',
	          null,
	          '-'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'twitch') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        {
	          collapsing: true, textAlign: 'center', onClick: function onClick() {
	            return props.handleRowClick(id);
	          }, style: rowPadding
	        },
	        _react2.default.createElement(_influencerTableSocialLink2.default, {
	          count: twitchCount,
	          link: twitchLink
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'tiktok') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        {
	          collapsing: true, textAlign: 'center', onClick: function onClick() {
	            return props.handleRowClick(id);
	          }, style: rowPadding
	        },
	        _react2.default.createElement(_influencerTableSocialLink2.default, {
	          count: tiktokCount,
	          link: tiktokLink
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _index2.default,
	      { shouldRender: (0, _index.shouldRenderSocialTableColumn)(columnsSettings, 'linkedin') },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        {
	          collapsing: true, textAlign: 'center', onClick: function onClick() {
	            return props.handleRowClick(id);
	          }, style: rowPadding
	        },
	        linkedin ? _react2.default.createElement(_semanticUiReact.Popup, {
	          hoverable: true,
	          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkedin', color: 'pink' }),
	          content: _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkedin', color: 'blue' }),
	            _react2.default.createElement(
	              'b',
	              null,
	              linkedin
	            )
	          )
	        }) : _react2.default.createElement(
	          'span',
	          null,
	          '-'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center' },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          { className: 'small light', style: font90 },
	          dateString
	        ),
	        content: 'Influencer added by ' + (influencerCreatedBy || linkCreatedBy) + ' on ' + dateString + '.'
	      }),
	      linkCreatedBy && _react2.default.createElement(
	        'div',
	        { className: 'small light', style: font70 },
	        linkCreatedBy,
	        influencerSignupSource ? ' (' + influencerSignupSource + ')' : ''
	      )
	    )
	  );
	};
	
	InfluencerTableRow.propTypes = {
	  onCheckboxStateUpdated: _propTypes2.default.func.isRequired,
	  handleRowClick: _propTypes2.default.func.isRequired,
	  link: _propTypes2.default.object.isRequired,
	  selected: _propTypes2.default.array.isRequired,
	  displayAuthorisedData: _propTypes2.default.bool.isRequired,
	  countries: _propTypes2.default.array.isRequired,
	  columnsSettings: _propTypes2.default.object.isRequired
	};
	
	exports.default = InfluencerTableRow;

/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(37);
	
	var _validator = __webpack_require__(84);
	
	var _recompose = __webpack_require__(15);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var wrapperStyles = {
	  marginBottom: 30
	};
	
	var tableStyles = {
	  height: '400px',
	  overflow: 'scroll',
	  borderBottom: 'solid 1px #d8d8d8'
	};
	
	var socialHandle = {
	  foregroundColor: 'grey',
	  fontSize: 'smaller'
	};
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0a');
	};
	
	var ChannelAddedComponent = function ChannelAddedComponent(_ref) {
	  var channel = _ref.channel;
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { fluid: true, textAlign: 'center', style: { height: 300, padding: 30 } },
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle outline', color: 'green', size: 'huge' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Channel Added!'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Label,
	        { basic: true, color: 'pink', size: 'huge' },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	        channel.metadata.instagram
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'An ACR only works with one Instagram channel.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Use the list in ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'My Team'
	      ),
	      ' to add team members.'
	    )
	  );
	};
	
	var InfluencerTable = function (_Component) {
	  _inherits(InfluencerTable, _Component);
	
	  function InfluencerTable() {
	    var _this2 = this;
	
	    _classCallCheck(this, InfluencerTable);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerTable.__proto__ || Object.getPrototypeOf(InfluencerTable)).call(this));
	
	    _this.componentDidMount = function () {
	      _this.fetch();
	    };
	
	    _this.localAdd = function (e, v) {
	      _this.setState({
	        invitingInfluencer: v.value.id
	      });
	      var added = _this.state.added;
	      var addition = _this.getCampaignInvitationFromInput(v.value);
	      addition.status = 'DEFERRED';
	      added.push(addition);
	      _this.setState({
	        added: added
	      });
	      _this.props.onInvite(addition);
	    };
	
	    _this.fixInfluencerRedirect = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(id) {
	        var _this$props, organisationId, restClient, linkUrl, link, linkId;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props = _this.props, organisationId = _this$props.organisationId, restClient = _this$props.restClient;
	                linkUrl = 'influencerLink?filter[influencer]=' + id + '&filter[organisation]=' + organisationId;
	                _context.next = 4;
	                return restClient.get(linkUrl);
	
	              case 4:
	                link = _context.sent;
	
	                if (link) {
	                  linkId = _lodash2.default.get(link, 'data.data[0].id');
	
	                  window.open('/influencer/' + linkId + '/profile');
	                } else {
	                  console.error('Could not find influencer link.');
	                }
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.getInvitationButton = function (members, pending, influencer) {
	      var invited = _this.state.invited;
	      var invitedEmails = _lodash2.default.map(invited, 'email');
	      var membersAndPendingAndInvited = _lodash2.default.concat(members, pending, invitedEmails);
	
	      if (!influencer.email) {
	        return _react2.default.createElement(
	          'p',
	          { className: 'small light' },
	          'no email'
	        );
	      }
	
	      if (_lodash2.default.includes(membersAndPendingAndInvited, influencer.email)) {
	        return _react2.default.createElement(
	          _semanticUiReact.Button,
	          { fluid: true, basic: true, disabled: true, color: 'green' },
	          'invited'
	        );
	      }
	
	      return _react2.default.createElement(_semanticUiReact.Button, {
	        size: 'small',
	        color: 'green',
	        onClick: _this.localInvite,
	        value: influencer,
	        icon: 'mail outline',
	        iconPosition: 'left',
	        content: 'invite'
	      });
	    };
	
	    _this.getAddButton = function (members, pending, influencer) {
	      var invited = _this.state.invited;
	
	      var invitingInfluencer = _this.state.invitingInfluencer;
	
	      var invitedEmails = _lodash2.default.map(invited, 'email');
	      var membersAndPendingAndInvited = _lodash2.default.concat(members, pending, invitedEmails);
	
	      if (_lodash2.default.includes(membersAndPendingAndInvited, influencer.email)) {
	        return _react2.default.createElement(
	          _semanticUiReact.Button,
	          { fluid: true, disabled: true, color: 'pink' },
	          'added'
	        );
	      }
	
	      var _this$props2 = _this.props,
	          organisation = _this$props2.organisation,
	          processing = _this$props2.processing;
	
	      var emailRequired = _lodash2.default.get(organisation, 'influencerEmailRequired', false);
	      var isEmailBad = _lodash2.default.isEmpty(influencer.email) || !(0, _validator.isEmail)(_lodash2.default.get(influencer, 'email')) || influencer.email.match(/info\+\w{8}@/);
	
	      if (emailRequired && isEmailBad) {
	        return _react2.default.createElement(_semanticUiReact.Popup, {
	          content: 'Missing or invalid email. You will be redirected to influencer\'s page.',
	          trigger: _react2.default.createElement(_semanticUiReact.Button, {
	            size: 'small',
	            color: 'orange',
	            onClick: function onClick() {
	              return _this.fixInfluencerRedirect(influencer.id);
	            },
	            value: influencer,
	            fluid: true,
	            icon: 'settings outline',
	            iconPosition: 'left',
	            content: 'fix'
	          })
	        });
	      }
	
	      return _react2.default.createElement(_semanticUiReact.Button, {
	        size: 'small',
	        color: 'pink',
	        fluid: true,
	        disabled: influencer.id === invitingInfluencer || processing,
	        onClick: _this.localAdd,
	        value: influencer,
	        icon: 'plus square outline',
	        iconPosition: 'left',
	        content: 'add'
	      });
	    };
	
	    _this.getCampaignInvitationFromInput = function (input) {
	      return {
	        email: input.email,
	        name: input.name,
	        role: 'INFLUENCER',
	        id: input.id,
	        primarySocialHandle: input.primarySocialHandle,
	        instagram: input.instagram
	      };
	    };
	
	    _this.handleSearchChange = function (e, _ref3) {
	      var value = _ref3.value;
	
	      _this.setState({
	        filter: value
	      }, _this.fetchIf);
	    };
	
	    _this.fetchIf = _lodash2.default.debounce(function () {
	      var filter = _this.state.filter;
	
	
	      if (filter.length >= 3) {
	        _this.fetch();
	      }
	    }, 1000);
	
	    _this.fetch = function () {
	      _this.setState({
	        loading: true
	      });
	
	      var filter = _this.state.filter;
	      var organisationId = _this.props.organisationId;
	
	
	      var search = {};
	      search.searchTerm = filter;
	
	      var request = {
	        data: {
	          organisationId: organisationId,
	          perPage: 100,
	          currentPage: 1,
	          search: search
	        }
	      };
	
	      var searchURI = encodeURIComponent(JSON.stringify(request));
	      console.log('FETCHING >>>> ' + JSON.stringify(request, null, 2));
	
	      var url = ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production") + '/filter/' + searchURI;
	
	      var isVoxogram = window.location.hostname === 'app.voxogram.com';
	
	      _this.searchClient.get(url).then(function (r) {
	        var influencerLinks = r.data.body.data.data;
	        var resultsWithEmails = _lodash2.default.map(influencerLinks, function (link) {
	          var influencer = link.lookupInfluencer;
	          var shortId = _lodash2.default.split(influencer.id, '-')[0];
	          var fakeEmail = 'info+' + shortId + '@' + (isVoxogram ? 'voxogram.com' : 'dyzio.co');
	          var derivedEmail = influencer.email || fakeEmail;
	          influencer.email = derivedEmail;
	          return link;
	        });
	        _this.setState({
	          influencers: resultsWithEmails,
	          loading: false,
	          error: false
	        });
	      }).catch(function (e) {
	        console.log('Error', e);
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      });
	    };
	
	    _this.localInvite = function (e, v) {
	      var invited = _this.state.invited;
	      var invitation = _this.getCampaignInvitationFromInput(v.value);
	      invited.push(invitation);
	      _this.setState({
	        invited: invited
	      });
	      _this.props.onInvite(invitation);
	    };
	
	    _this.getLoadingRow = function () {
	      var loaderStyles = {
	        height: '100%'
	      };
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { colSpan: 8, height: '400' },
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { style: loaderStyles },
	            _react2.default.createElement(
	              _semanticUiReact.Dimmer,
	              { active: true, inverted: true },
	              _react2.default.createElement(
	                _semanticUiReact.Loader,
	                { indeterminate: true },
	                'Loading Influencers...'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.getErrorRow = function () {
	      var errorStyles = {
	        height: '100%',
	        'padding-top': '100px',
	        'text-align': 'center'
	      };
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { colSpan: 8, height: '400' },
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { style: errorStyles },
	            'Error searching database, please try again.'
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      invited: [],
	      added: [],
	      filter: null,
	      loading: false,
	      error: false,
	      invitingInfluencer: null
	    };
	
	    _this.searchClient = _axios2.default.create({
	      baseURL: ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production") + '/filter',
	      timeout: 30000
	    });
	    return _this;
	  }
	
	  _createClass(InfluencerTable, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          campaign = _props.campaign,
	          visible = _props.visible;
	      var _state = this.state,
	          influencers = _state.influencers,
	          loading = _state.loading,
	          error = _state.error;
	
	
	      if (!campaign) return null;
	      var memberEmails = campaign ? _lodash2.default.map(campaign.members, 'email') : [];
	      var pendingEmails = campaign ? _lodash2.default.map(campaign.pendingInvitations, 'email') : [];
	
	      var displayStyle = visible ? {} : { display: 'none' };
	
	      var systemEmailRegEx = /^info\+(.{8})@(voxogram.com|dyzio.co)$/i;
	
	      var combinedArrays = _lodash2.default.concat(campaign.members, campaign.pendingInvitations);
	      var invitedInfluencers = _lodash2.default.filter(combinedArrays, { role: 'INFLUENCER' });
	
	      var campaignType = campaign.campaignType;
	
	      var isAcrLoaded = campaignType === 'ACR' && !_lodash2.default.isEmpty(invitedInfluencers);
	
	      var channel = _lodash2.default.head(invitedInfluencers);
	
	      return _react2.default.createElement(
	        'div',
	        { style: displayStyle },
	        _react2.default.createElement(
	          'div',
	          { style: wrapperStyles },
	          isAcrLoaded ? _react2.default.createElement(ChannelAddedComponent, { channel: channel }) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_semanticUiReact.Input, {
	              fluid: true,
	              icon: 'search',
	              placeholder: 'Search My Influencers',
	              iconPosition: 'left',
	              onChange: this.handleSearchChange
	            }),
	            _react2.default.createElement(
	              'div',
	              { style: tableStyles },
	              visible && _react2.default.createElement(
	                _semanticUiReact.Table,
	                { unstackable: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Header,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      { colSpan: 2 },
	                      'Influencer'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      { textAlign: 'center' },
	                      _react2.default.createElement('img', { src: '/icons/facebook.svg', alt: 'Facebook' })
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      { textAlign: 'center' },
	                      _react2.default.createElement('img', { src: '/icons/instagram.svg', alt: 'Instagram' })
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      { textAlign: 'center' },
	                      _react2.default.createElement('img', { src: '/icons/twitter.svg', alt: 'Twitter' })
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      { textAlign: 'center' },
	                      _react2.default.createElement('img', { src: '/icons/youtube.svg', alt: 'YouTube' })
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      { textAlign: 'center' },
	                      'Email'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.HeaderCell,
	                      { textAlign: 'center', collapsing: true },
	                      'Action'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Body,
	                  null,
	                  loading && this.getLoadingRow(),
	                  !loading && error && this.getErrorRow(),
	                  !loading && !error && influencers && _lodash2.default.map(influencers, function (influencerLink) {
	                    var influencer = influencerLink.lookupInfluencer;
	                    return _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      { key: influencer.id },
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        { collapsing: true },
	                        _react2.default.createElement(_semanticUiReact.Image, { src: influencer.thumbnail, avatar: true, size: 'mini' })
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        influencer.name,
	                        '\xA0',
	                        _react2.default.createElement(
	                          'span',
	                          { style: socialHandle },
	                          influencer.primarySocialHandle
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        { textAlign: 'center' },
	                        cf(influencer.facebookCount)
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        { textAlign: 'center' },
	                        cf(influencer.instagramCount)
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        { textAlign: 'center' },
	                        cf(influencer.twitterCount)
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        { textAlign: 'center' },
	                        cf(influencer.youtubeCount)
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        { textAlign: 'center' },
	                        influencer.email.match(systemEmailRegEx) ? _react2.default.createElement(
	                          _semanticUiReact.Label,
	                          { basic: true, color: 'red' },
	                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban' }),
	                          'no email'
	                        ) : influencer.email
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        { collapsing: true, textAlign: 'center' },
	                        _this3.getAddButton(memberEmails, pendingEmails, influencer)
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencerTable;
	}(_react.Component);
	
	InfluencerTable.propTypes = {
	  onInvite: _propTypes2.default.func.isRequired,
	  campaign: _propTypes2.default.object,
	  visible: _propTypes2.default.bool.isRequired,
	  processing: _propTypes2.default.bool.isRequired
	};
	InfluencerTable.defaultProps = {
	  campaign: null
	};
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _reactRouter.withRouter)(InfluencerTable);

/***/ },
/* 1988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InstagramAccountType = function InstagramAccountType(_ref) {
	  var instagram = _ref.instagram,
	      isProfessional = _ref.isProfessional,
	      isBusiness = _ref.isBusiness,
	      isRestricted = _ref.isRestricted,
	      isPrivate = _ref.isPrivate,
	      restrictedText = _ref.restrictedText;
	
	  if (!instagram) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      '-'
	    );
	  }
	
	  if (isRestricted) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'orange' }),
	      content: 'Instagram RESTRICTED account: ' + restrictedText
	    });
	  }
	
	  if (isProfessional) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'briefcase', color: 'pink' }),
	      content: 'Instagram CREATOR account'
	    });
	  }
	
	  if (isBusiness) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'briefcase', color: 'blue' }),
	      content: 'Instagram BUSINESS account'
	    });
	  }
	
	  if (isPrivate) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'orange' }),
	      content: 'Instagram PRIVATE account'
	    });
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'user circle', color: 'grey' }),
	    content: 'Instagram PERSONAL account'
	  });
	};
	
	InstagramAccountType.propTypes = {
	  instagram: _propTypes2.default.object.isRequired,
	  isProfessional: _propTypes2.default.bool.isRequired,
	  isBusiness: _propTypes2.default.bool.isRequired,
	  isRestricted: _propTypes2.default.bool.isRequired,
	  isPrivate: _propTypes2.default.bool.isRequired,
	  restrictedText: _propTypes2.default.string.isRequired
	};
	
	exports.default = InstagramAccountType;

/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ACCOUNT_STEP = 'account';
	var LINK_STEP = 'link';
	var AUTHORISE_STEP = 'authorise';
	
	var segmentContentStyle = {
	  paddingBottom: 25
	};
	
	var segmentStyle = {
	  border: 'none',
	  margin: 0,
	  width: '100%',
	  minHeight: 240,
	  paddingTop: 15
	};
	
	var textAlignCenter = {
	  textAlign: 'center'
	};
	
	var dyzioRedStyle = { color: '#ef3a50' };
	
	var shouldRenderStep = function shouldRenderStep(activeStep, step) {
	  return activeStep === step;
	};
	
	var InstagramAuthModal = function (_Component) {
	  _inherits(InstagramAuthModal, _Component);
	
	  function InstagramAuthModal(props) {
	    _classCallCheck(this, InstagramAuthModal);
	
	    var _this = _possibleConstructorReturn(this, (InstagramAuthModal.__proto__ || Object.getPrototypeOf(InstagramAuthModal)).call(this, props));
	
	    _this.moveToStep = function (step) {
	      return _this.setState({
	        activeStep: step
	      });
	    };
	
	    _this.state = {
	      activeStep: ACCOUNT_STEP
	    };
	    return _this;
	  }
	
	  _createClass(InstagramAuthModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onContinueButtonClick = _props.onContinueButtonClick,
	          onClose = _props.onClose;
	      var activeStep = this.state.activeStep;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        {
	          open: true,
	          closeOnEscape: true,
	          closeOnDimmerClick: true,
	          onClose: onClose,
	          size: 'small'
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Step.Group,
	          { attached: 'top', fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Step,
	            {
	              active: shouldRenderStep(activeStep, ACCOUNT_STEP)
	            },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
	            _react2.default.createElement(
	              _semanticUiReact.Step.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Step.Title,
	                null,
	                'Instagram Account'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Step.Description,
	                null,
	                'Creator or Business?'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Step,
	            {
	              disabled: shouldRenderStep(activeStep, ACCOUNT_STEP),
	              active: shouldRenderStep(activeStep, LINK_STEP)
	            },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'chain', color: 'green' }),
	            _react2.default.createElement(
	              _semanticUiReact.Step.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Step.Title,
	                null,
	                'Facebook Link'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Step.Description,
	                null,
	                'Link to Facebook'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Step,
	            {
	              disabled: !shouldRenderStep(activeStep, AUTHORISE_STEP),
	              active: shouldRenderStep(activeStep, AUTHORISE_STEP)
	            },
	            _react2.default.createElement(_semanticUiReact.Icon, { color: 'orange', name: 'unlock' }),
	            _react2.default.createElement(
	              _semanticUiReact.Step.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Step.Title,
	                null,
	                'Authorise'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Step.Description,
	                null,
	                'Let\'s do this!'
	              )
	            )
	          )
	        ),
	        shouldRenderStep(activeStep, ACCOUNT_STEP) && _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { attached: true, textAlign: 'center', style: segmentStyle },
	          _react2.default.createElement(
	            'div',
	            { style: segmentContentStyle },
	            _react2.default.createElement(
	              'p',
	              null,
	              'You must have either a '
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Label,
	                { basic: true, color: 'blue', size: 'large' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	                'Business Account'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' or a '
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Label,
	                { basic: true, color: 'pink', size: 'large' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	                'Creator Account'
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'How do I convert to a ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://help.instagram.com/2358103564437429', target: '_blank' },
	                'Creator Account?'
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { style: dyzioRedStyle },
	              _react2.default.createElement(
	                'p',
	                null,
	                'The authorisation won\'t work'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'if your account is not correct!'
	              )
	            )
	          )
	        ),
	        shouldRenderStep(activeStep, LINK_STEP) && _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { attached: true, textAlign: 'center', style: segmentStyle },
	          _react2.default.createElement(
	            'div',
	            { style: segmentContentStyle },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Your Instagram account must be linked to your Facebook page.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Instagram marketing data such as Reach and Impressions'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'is provided by the Facebook Instagram API (Facebook own Instagram).'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'In order to fetch data your accounts must be linked.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'How do I ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://help.instagram.com/356902681064399', target: '_blank' },
	                'link my accounts?'
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { style: dyzioRedStyle },
	              _react2.default.createElement(
	                'p',
	                null,
	                'The authorisation won\'t work'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'if your accounts are not linked!'
	              )
	            )
	          )
	        ),
	        shouldRenderStep(activeStep, AUTHORISE_STEP) && _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { attached: true, textAlign: 'center', style: segmentStyle },
	          _react2.default.createElement(
	            'div',
	            { style: segmentContentStyle },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Let\'s do this!'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Great, you have the right account and it\'s linked. Let\'s go!'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'PLEASE NOTE: Required Permissions'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'NEED'
	              ),
	              ' all of the following permissions to fetch the data for your posts'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { style: { color: 'cornflowerblue' } },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'manage_pages'
	              ),
	              _react2.default.createElement(
	                'h4',
	                null,
	                'instagram_basic'
	              ),
	              _react2.default.createElement(
	                'h4',
	                null,
	                'instagram_manage_insights'
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { style: { color: 'cornflowerblue' } },
	                'manage_pages'
	              ),
	              ' is required for us to generate a secure access token'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'without this permission the token will not work!'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Actions,
	          { style: textAlignCenter },
	          shouldRenderStep(activeStep, ACCOUNT_STEP) && _react2.default.createElement(_semanticUiReact.Button, {
	            onClick: function onClick() {
	              return _this2.moveToStep(LINK_STEP);
	            },
	            inverted: true,
	            color: 'pink',
	            icon: 'check',
	            content: 'I have the right account'
	          }),
	          shouldRenderStep(activeStep, LINK_STEP) && _react2.default.createElement(_semanticUiReact.Button, {
	            onClick: function onClick() {
	              return _this2.moveToStep(AUTHORISE_STEP);
	            },
	            inverted: true,
	            color: 'pink',
	            icon: 'check',
	            content: 'My account is linked to my Facebook Page'
	          }),
	          shouldRenderStep(activeStep, AUTHORISE_STEP) && _react2.default.createElement(_semanticUiReact.Button, {
	            content: 'Continue with Instagram',
	            icon: 'instagram',
	            color: 'instagram',
	            onClick: onContinueButtonClick
	          })
	        )
	      );
	    }
	  }]);
	
	  return InstagramAuthModal;
	}(_react.Component);
	
	exports.default = InstagramAuthModal;

/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _privateDataComponent = __webpack_require__(351);
	
	var _privateDataComponent2 = _interopRequireDefault(_privateDataComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sf = function sf(num) {
	  return (0, _numeral2.default)(num).format('0a');
	};
	var isGraphQLEmpty = function isGraphQLEmpty(obj) {
	  return obj && obj.length === 1 && obj[0] === null;
	};
	
	var InstagramImpressions = function InstagramImpressions(_ref) {
	  var latestStatistic = _ref.latestStatistic,
	      popupToggleHandler = _ref.popupToggleHandler,
	      supportingData = _ref.supportingData,
	      instagramAuthorised = _ref.instagramAuthorised,
	      post = _ref.post;
	
	  var insights = latestStatistic.insights;
	
	  if (insights && insights.error) {
	    var error = insights.error;
	
	    return _react2.default.createElement(
	      _semanticUiReact.Popup,
	      {
	        trigger: _react2.default.createElement(_semanticUiReact.Button, {
	          color: 'orange',
	          inverted: true,
	          icon: 'warning',
	          fluid: true,
	          size: 'small',
	          content: 'ooops',
	          labelPosition: 'left',
	          onClick: _lodash2.default.noop
	        })
	      },
	      _react2.default.createElement(
	        _semanticUiReact.Popup.Header,
	        null,
	        error.error_user_title
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Popup.Content,
	        null,
	        error.error_user_msg
	      )
	    );
	  }
	
	  if (insights) {
	    return _react2.default.createElement(_semanticUiReact.Button, {
	      color: 'pink',
	      inverted: true,
	      icon: 'pie graph',
	      labelPosition: 'left',
	      fluid: true,
	      content: instagramAuthorised ? sf(insights.impressions) : 'insights',
	      onClick: function onClick() {
	        return popupToggleHandler(latestStatistic, post);
	      },
	      size: 'small'
	    });
	  }
	
	  if (supportingData && supportingData.length && !isGraphQLEmpty(supportingData)) {
	    var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
	    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
	      return o.createdDate;
	    }));
	    var latestSupportingData = ordered[0];
	    var impressions = latestSupportingData.impressions;
	    return _react2.default.createElement(_semanticUiReact.Button, {
	      color: 'pink',
	      inverted: true,
	      icon: 'pie graph',
	      labelPosition: 'left',
	      fluid: true,
	      content: instagramAuthorised ? sf(impressions) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'orange' }),
	      disabled: true,
	      size: 'small'
	    });
	  }
	
	  return _react2.default.createElement(_privateDataComponent2.default, null);
	};
	
	InstagramImpressions.propTypes = {
	  latestStatistic: _propTypes2.default.object.isRequired,
	  popupToggleHandler: _propTypes2.default.func.isRequired,
	  supportingData: _propTypes2.default.object.isRequired,
	  instagramAuthorised: _propTypes2.default.any
	};
	
	InstagramImpressions.defaultProps = {
	  instagramAuthorised: false
	};
	
	exports.default = InstagramImpressions;

/***/ },
/* 1991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dyzioInstagramEmbed = __webpack_require__(346);
	
	var _dyzioInstagramEmbed2 = _interopRequireDefault(_dyzioInstagramEmbed);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _textHighlighter = __webpack_require__(378);
	
	var _textHighlighter2 = _interopRequireDefault(_textHighlighter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	
	var tableStyle = { padding: 5 };
	
	var InstagramInsightsModal = function InstagramInsightsModal(_ref) {
	  var latestStatistic = _ref.latestStatistic,
	      popupToggleHandler = _ref.popupToggleHandler,
	      open = _ref.open,
	      post = _ref.post,
	      hashtags = _ref.hashtags;
	
	  if (!latestStatistic) return null;
	  var insights = latestStatistic.insights;
	
	  if (!open) return null;
	
	  var collectedDate = (0, _moment2.default)(latestStatistic.createdDate).format('MMMM Do YYYY, h:mm:ss a');
	  var publishedDate = (0, _moment2.default)(post.publishedDate).format('MMMM Do YYYY, h:mm:ss a');
	
	  console.log(hashtags);
	  var highlighedHashtags = hashtags ? _lodash2.default.split(hashtags, ',') : [];
	
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      headerText: 'Instagram Post Insights',
	      onClose: popupToggleHandler
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        { columns: 'two' },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          null,
	          _react2.default.createElement(_dyzioInstagramEmbed2.default, {
	            assetId: latestStatistic.instagramId
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Card,
	            { fluid: true, color: 'pink' },
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Card.Header,
	                null,
	                'Instagram Insights'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { basic: 'very', celled: true, fluid: true, small: true, style: tableStyle },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Body,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Reach'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      cf(insights.reach)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Impressions'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      cf(insights.impressions)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Engagement'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      cf(insights.engagement)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(
	                        'b',
	                        null,
	                        'Saved'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      cf(insights.saved)
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'centered' },
	                _react2.default.createElement(_semanticUiReact.Label, { centered: true, icon: 'clock', color: 'grey', basic: true, content: 'post published ' + publishedDate })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { height: 5 } },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'centered' },
	                _react2.default.createElement(_semanticUiReact.Label, { centered: true, icon: 'clock', color: 'grey', basic: true, content: 'data collected ' + collectedDate })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card,
	            { fluid: true, color: 'blue' },
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Card.Header,
	                null,
	                'Caption'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card.Meta,
	                null,
	                'highlighted text shows hashtag matches'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(_textHighlighter2.default, { text: post.text, words: highlighedHashtags })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = InstagramInsightsModal;

/***/ },
/* 1992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INVITATION_STATUS = {
	  deferred: 'DEFERRED',
	  sent: 'SENT',
	  accepted: 'ACCEPTED'
	};
	
	var InvitationStatus = function InvitationStatus(_ref) {
	  var status = _ref.status;
	
	  if (status === INVITATION_STATUS.accepted) {
	    return _react2.default.createElement(_semanticUiReact.Label, { size: 'large', basic: true, color: 'blue', content: 'JOINED' });
	  }
	
	  if (status === INVITATION_STATUS.sent) {
	    return _react2.default.createElement(_semanticUiReact.Label, { size: 'large', basic: true, content: 'INVITED', color: 'orange' });
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Label, { size: 'large', basic: true, content: 'NOT INVITED', color: 'grey' });
	};
	
	InvitationStatus.propTypes = {
	  status: _propTypes2.default.string.isRequired
	};
	
	exports.default = InvitationStatus;

/***/ },
/* 1993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inviteBlockStyle = {
	  textAlign: 'center'
	};
	
	var inviteImageStyle = {
	  margin: '0 auto',
	  display: 'block'
	};
	
	var negativeButtonStyle = {
	  backgroundColor: '#ee3a50'
	};
	
	var positiveButtonStyle = {
	  backgroundColor: '#20c49e'
	};
	
	var okIconStyle = {
	  color: '#20c49e'
	};
	
	var textAlignCenter = {
	  textAlign: 'center'
	};
	
	var InviteModal = function InviteModal(props) {
	  var email = props.email,
	      thumbnail = props.thumbnail,
	      closeHandler = props.closeHandler,
	      sendHandler = props.sendHandler,
	      inviteSentOK = props.inviteSentOK;
	
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      headerText: 'New Invitation',
	      size: 'tiny',
	      onClose: closeHandler,
	      hasActionButton: true,
	      actionButtonIcon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'send' }),
	      actionButtonContent: 'Send invitation',
	      onActionButtonClick: sendHandler,
	      shouldDisableActionButton: inviteSentOK
	    },
	    _react2.default.createElement(
	      'div',
	      { style: textAlignCenter },
	      inviteSentOK && _react2.default.createElement(_semanticUiReact.Icon, { style: okIconStyle, centered: true, name: 'checkmark', circular: true, size: 'huge' }),
	      !inviteSentOK && _react2.default.createElement(_semanticUiReact.Image, {
	        src: thumbnail,
	        centered: true,
	        className: 'ui small circular',
	        style: inviteImageStyle
	      }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        !inviteSentOK && 'do you really want to send an invitation to ' + email + '?',
	        inviteSentOK && 'Invite sent!'
	      )
	    )
	  );
	};
	
	InviteModal.propTypes = {
	  email: _propTypes2.default.string.isRequired,
	  thumbnail: _propTypes2.default.string.isRequired,
	  closeHandler: _propTypes2.default.func.isRequired,
	  sendHandler: _propTypes2.default.func.isRequired,
	  inviteSentOK: _propTypes2.default.bool.isRequired
	};
	
	exports.default = InviteModal;

/***/ },
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _qs = __webpack_require__(251);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _reactCopyToClipboard = __webpack_require__(315);
	
	var _getTrackingLinks = __webpack_require__(2376);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var inputStyle = {
	  fontSize: 11
	};
	
	var LinkTracking = function (_Component) {
	  _inherits(LinkTracking, _Component);
	
	  function LinkTracking() {
	    _classCallCheck(this, LinkTracking);
	
	    var _this = _possibleConstructorReturn(this, (LinkTracking.__proto__ || Object.getPrototypeOf(LinkTracking)).call(this));
	
	    _this.state = {
	      bioCopied: false,
	      storyCopied: false
	    };
	    return _this;
	  }
	
	  _createClass(LinkTracking, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          baseTrackingUrl = _props.baseTrackingUrl,
	          campaignId = _props.campaignId,
	          hashtags = _props.hashtags,
	          instagram = _props.instagram;
	      var _state = this.state,
	          bioCopied = _state.bioCopied,
	          storyCopied = _state.storyCopied;
	
	
	      var bioParams = (0, _getTrackingLinks.getTrackingBioLink)({
	        campaignId: campaignId,
	        hashtags: hashtags,
	        instagram: instagram
	      });
	
	      var storyParams = (0, _getTrackingLinks.getTrackingStoryLink)({
	        campaignId: campaignId,
	        hashtags: hashtags,
	        instagram: instagram
	      });
	
	      var bioLink = baseTrackingUrl + '?' + bioParams;
	      var storyLink = baseTrackingUrl + '?' + storyParams;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Link tracking'
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 2 },
	              'Bio Link'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 14 },
	              _react2.default.createElement(_semanticUiReact.Input, {
	                labelPosition: 'right',
	                label: _react2.default.createElement(
	                  _reactCopyToClipboard.CopyToClipboard,
	                  {
	                    text: bioLink,
	                    onCopy: function onCopy() {
	                      return _this2.setState({ bioCopied: true, storyCopied: false });
	                    }
	                  },
	                  _react2.default.createElement(_semanticUiReact.Button, { icon: bioCopied ? 'checkmark' : 'copy', color: 'pink' })
	                ),
	                fluid: true,
	                value: bioLink
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 2 },
	              'Story Link'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 14 },
	              _react2.default.createElement(_semanticUiReact.Input, {
	                as: 'div',
	                labelPosition: 'right',
	                label: _react2.default.createElement(
	                  _reactCopyToClipboard.CopyToClipboard,
	                  {
	                    text: storyLink,
	                    onCopy: function onCopy() {
	                      return _this2.setState({ bioCopied: false, storyCopied: true });
	                    }
	                  },
	                  _react2.default.createElement(_semanticUiReact.Button, { icon: storyCopied ? 'checkmark' : 'copy', color: 'pink' })
	                ),
	                fluid: true,
	                value: storyLink
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LinkTracking;
	}(_react.Component);
	
	LinkTracking.propTypes = {
	  baseTrackingUrl: _propTypes2.default.string.isRequired,
	  campaignId: _propTypes2.default.string.isRequired,
	  hashtags: _propTypes2.default.string.isRequired
	};
	
	exports.default = LinkTracking;

/***/ },
/* 1995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loadingStyle = {
	  color: '#777'
	};
	
	var LiveStoriesCounter = function LiveStoriesCounter(_ref) {
	  var loading = _ref.loading,
	      count = _ref.count,
	      onClick = _ref.onClick;
	
	  if (loading) {
	    return _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', loading: true, style: loadingStyle });
	  }
	  if (!loading && count > 0) {
	    return _react2.default.createElement(
	      _semanticUiReact.Button,
	      {
	        fluid: true,
	        inverted: true,
	        color: 'pink',
	        onClick: onClick
	      },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle', size: 'small' }),
	      ' ',
	      count,
	      ' live stories'
	    );
	  }
	  return null;
	};
	
	LiveStoriesCounter.propTypes = {
	  loading: _propTypes2.default.bool.isRequired,
	  count: _propTypes2.default.number.isRequired,
	  onClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = LiveStoriesCounter;

/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginProblemNotification = function LoginProblemNotification() {
	  return _react2.default.createElement(
	    "div",
	    { className: "hero" },
	    _react2.default.createElement(
	      "h1",
	      { className: "info" },
	      "Apologies..."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "It is not currently possible to login using Google, this should be fixed very soon... message posted ",
	      _react2.default.createElement(
	        "i",
	        null,
	        "6pm Weds 30th"
	      ),
	      "."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Please email us at ",
	      _react2.default.createElement(
	        "a",
	        { href: "mailto:info@dyzio.co?Subject=login-problems" },
	        "info@dyzio.co"
	      ),
	      "if you need urgent assistance."
	    )
	  );
	};
	
	exports.default = LoginProblemNotification;

/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = MailoutInfluencerTableRow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _influencerTableSocialLink = __webpack_require__(881);
	
	var _influencerTableSocialLink2 = _interopRequireDefault(_influencerTableSocialLink);
	
	var _countries = __webpack_require__(93);
	
	var countryList = _interopRequireWildcard(_countries);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_IMAGE = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/no_image_available.png';
	
	var badgeStyle = {
	  display: 'flex',
	  alignItems: 'center'
	};
	
	var avatarStyle = {
	  marginRight: '10px'
	};
	
	var rowPadding = {
	  padding: 8
	};
	var influencerCellStyle = _extends({}, rowPadding);
	var font90 = {
	  fontSize: '90%',
	  color: 'grey'
	};
	
	var marginAuto = { margin: 'auto' };
	var marginZero = { margin: 0 };
	
	var getCountryTrigger = function getCountryTrigger(country) {
	  var mapping = _lodash2.default.find(countryList.default, ['key', country]);
	  var isGlobal = _lodash2.default.get(mapping, 'value') === 'ZZ';
	  var flagName = _lodash2.default.get(mapping, 'flag', _lodash2.default.toLower(country));
	  return isGlobal ? _react2.default.createElement(_semanticUiReact.Image, { style: marginAuto, src: mapping.image.src }) : _react2.default.createElement(_semanticUiReact.Flag, { style: marginZero, name: flagName });
	};
	function MailoutInfluencerTableRow(_ref) {
	  var influencer = _ref.influencer,
	      onDelete = _ref.onDelete,
	      isDeleting = _ref.isDeleting;
	  var name = influencer.name,
	      instagramEngagementRate = influencer.instagramEngagementRate,
	      instagram = influencer.instagram,
	      instagramCount = influencer.instagramCount,
	      country = influencer.country,
	      email = influencer.email,
	      instagramId = influencer.instagramId,
	      thumbnail = influencer.thumbnail;
	
	
	  var thumb = thumbnail || 'https://pics.dyzio.co/' + instagramId + '.jpg';
	  var isCountryValid = !_lodash2.default.isNil(country) && !_lodash2.default.isEmpty(country) && !_lodash2.default.isEqual(country, 'undefined');
	  var mapping = _lodash2.default.find(countryList.default, ['key', country]);
	  var countryName = mapping && mapping.text || '-';
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Button, { onClick: function onClick() {
	          return onDelete(instagramId);
	        }, icon: 'delete', circular: true, loading: isDeleting, disabled: isDeleting })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      {
	        verticalAlign: 'middle',
	        style: influencerCellStyle
	      },
	      _react2.default.createElement(
	        'div',
	        { style: badgeStyle },
	        _react2.default.createElement(
	          'div',
	          { style: avatarStyle },
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://instagram.com/' + influencer.instagram,
	              target: '_blank',
	              rel: 'noopener noreferrer'
	            },
	            _react2.default.createElement(_semanticUiReact.Image, {
	              avatar: true,
	              src: thumb,
	              size: 'tiny'
	              // eslint-disable-next-line no-param-reassign
	              , onError: function onError(i) {
	                i.target.src = DEFAULT_IMAGE;
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            instagram
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'light', style: font90 },
	            name
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: rowPadding },
	      email
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center', style: rowPadding },
	      isCountryValid && _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: getCountryTrigger(country),
	        content: countryName
	      }),
	      !isCountryValid && '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center', style: rowPadding },
	      instagramEngagementRate ? (0, _formatting.ierFormat)(instagramEngagementRate) : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      {
	        collapsing: true, textAlign: 'center', style: rowPadding
	      },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.instagram.com/' + instagram, target: '_blank', rel: 'noopener noreferrer' },
	        _react2.default.createElement(_influencerTableSocialLink2.default, {
	          count: instagramCount
	        })
	      )
	    )
	  );
	}
	
	MailoutInfluencerTableRow.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  onDelete: _propTypes2.default.func,
	  isDeleting: _propTypes2.default.bool
	};
	
	MailoutInfluencerTableRow.defaultProps = {
	  onDelete: _lodash2.default.noop,
	  isDeleting: false
	};

/***/ },
/* 1998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var messageStyles = {
	  width: '100%'
	};
	
	var MailoutSendModal = function (_Component) {
	  _inherits(MailoutSendModal, _Component);
	
	  function MailoutSendModal(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, MailoutSendModal);
	
	    var _this = _possibleConstructorReturn(this, (MailoutSendModal.__proto__ || Object.getPrototypeOf(MailoutSendModal)).call(this, props));
	
	    _this.onInputChanged = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(event, rest) {
	        var name, value, checked;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                name = rest.name, value = rest.value, checked = rest.checked;
	
	                _this.setState(_defineProperty({}, name, value || checked));
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.handleFormSubmit = function (e) {
	      e.preventDefault();
	      var onSubmit = _this.props.onSubmit;
	      var _this$state = _this.state,
	          outreachEmailSubject = _this$state.outreachEmailSubject,
	          outreachEmailTemplate = _this$state.outreachEmailTemplate;
	
	      _this.setState({ error: null });
	      if (outreachEmailSubject && outreachEmailTemplate) {
	        onSubmit();
	      }
	    };
	
	    var mailout = _lodash2.default.get(props, 'mailout', {});
	    _this.state = _extends({}, mailout);
	    return _this;
	  }
	
	  _createClass(MailoutSendModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onClose = _props.onClose,
	          isSubmitting = _props.isSubmitting,
	          error = _props.error,
	          successMessage = _props.successMessage;
	      var _state = this.state,
	          mailoutName = _state.mailoutName,
	          outreachEmailSubject = _state.outreachEmailSubject,
	          outreachEmailTemplate = _state.outreachEmailTemplate,
	          utmSource = _state.utmSource,
	          totalInfluencers = _state.totalInfluencers,
	          lastSentDate = _state.lastSentDate;
	
	
	      var lastSentDateLabel = lastSentDate ? (0, _moment2.default)(lastSentDate).format('DD-MM-YYYY, h:mm') : 'Not sent yet';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _dyzioModal2.default,
	          { headerText: 'Send Mailout', size: 'small', onClose: onClose },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  display: 'flex',
	                  justifyContent: 'center'
	
	                }
	              },
	              _react2.default.createElement(
	                'h3',
	                null,
	                mailoutName,
	                ' '
	              )
	            ),
	            error && _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  display: 'flex',
	                  justifyContent: 'center'
	                }
	              },
	              _react2.default.createElement(_semanticUiReact.Message, {
	                fluid: true,
	                style: messageStyles,
	                icon: 'frown',
	                error: true,
	                header: 'Error',
	                content: error
	              })
	            ),
	            successMessage && _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  display: 'flex',
	                  justifyContent: 'center'
	                }
	              },
	              _react2.default.createElement(_semanticUiReact.Message, {
	                success: true,
	                fluid: true,
	                style: messageStyles,
	                icon: 'check circle outline',
	                header: 'Mailout sent successfully!',
	                content: successMessage
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Form,
	              { onSubmit: this.handleFormSubmit },
	              _react2.default.createElement(
	                'div',
	                { style: { maxHeight: '70vh', overflow: 'auto', margin: '1.5rem' } },
	                _react2.default.createElement(
	                  _semanticUiReact.Segment,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { style: { paddingTop: '10px', paddingBottom: '10px' } },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Email Subject'
	                    ),
	                    _react2.default.createElement(
	                      'h5',
	                      { style: { color: 'rgba(0,0,0,.4)' } },
	                      outreachEmailSubject || '-'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { paddingTop: '10px', paddingBottom: '10px' } },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Email Template'
	                    ),
	                    _react2.default.createElement(
	                      'h5',
	                      { style: { color: 'rgba(0,0,0,.4)' } },
	                      outreachEmailTemplate || '-'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { paddingTop: '10px', paddingBottom: '10px' } },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'UTM Source'
	                    ),
	                    _react2.default.createElement(
	                      'h5',
	                      { style: { color: 'rgba(0,0,0,.4)' } },
	                      utmSource || '-'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { paddingTop: '10px', paddingBottom: '10px' } },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Total Influencers: ',
	                      totalInfluencers
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { paddingTop: '10px', paddingBottom: '10px' } },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Last sent date'
	                    ),
	                    _react2.default.createElement(
	                      'h5',
	                      { style: { color: 'rgba(0,0,0,.4)' } },
	                      lastSentDateLabel
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'flex',
	                  style: {
	                    justifyContent: 'flex-end',
	                    padding: '10px 0px 10px 0px'
	                  }
	                },
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Button,
	                  {
	                    loading: isSubmitting,
	                    disabled: isSubmitting || error || successMessage,
	                    color: 'pink',
	                    type: 'submit',
	                    size: 'medium'
	                  },
	                  'Submit'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MailoutSendModal;
	}(_react.Component);
	
	MailoutSendModal.propTypes = {
	  onClose: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  isSubmitting: _propTypes2.default.bool,
	  error: _propTypes2.default.any,
	  successMessage: _propTypes2.default.any
	};
	MailoutSendModal.defaultProps = {
	  onClose: _lodash2.default.noop,
	  onSubmit: _lodash2.default.noop,
	  isSubmitting: false,
	  error: null,
	  successMessage: null
	};
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default)(MailoutSendModal);

/***/ },
/* 1999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var messageStyles = {
	  width: '100%'
	};
	
	var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	
	var isValidEmail = function isValidEmail(email) {
	  if (!_lodash2.default.isString(email) || _lodash2.default.isEmpty(email)) {
	    return false;
	  }
	  return EMAIL_REGEX.test(email);
	};
	
	var MailoutTestModal = function (_Component) {
	  _inherits(MailoutTestModal, _Component);
	
	  function MailoutTestModal(props) {
	    _classCallCheck(this, MailoutTestModal);
	
	    var _this = _possibleConstructorReturn(this, (MailoutTestModal.__proto__ || Object.getPrototypeOf(MailoutTestModal)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var mailout = _lodash2.default.get(props, 'mailout', {});
	    var email = _lodash2.default.get(props, 'userInfo.email', '');
	    var name = _lodash2.default.get(props, 'userInfo.name', '');
	    _this.state = _extends({ email: email, name: name, errors: {} }, mailout);
	    return _this;
	  }
	
	  _createClass(MailoutTestModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onClose = _props.onClose,
	          isSubmitting = _props.isSubmitting,
	          error = _props.error,
	          mailoutTestSuccess = _props.mailoutTestSuccess;
	      var _state = this.state,
	          email = _state.email,
	          name = _state.name,
	          errors = _state.errors,
	          outreachEmailSubject = _state.outreachEmailSubject,
	          outreachEmailTemplate = _state.outreachEmailTemplate,
	          utmSource = _state.utmSource;
	
	
	      var isMailoutValid = !_lodash2.default.isEmpty(outreachEmailTemplate) && !_lodash2.default.isEmpty(outreachEmailTemplate);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _dyzioModal2.default,
	          { headerText: 'Test Mailout', size: 'small', onClose: onClose },
	          _react2.default.createElement(
	            'div',
	            null,
	            error && _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  display: 'flex',
	                  justifyContent: 'center'
	                }
	              },
	              _react2.default.createElement(_semanticUiReact.Message, {
	                fluid: true,
	                style: messageStyles,
	                icon: 'frown',
	                error: true,
	                header: 'Error',
	                content: error
	              })
	            ),
	            mailoutTestSuccess && _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  display: 'flex',
	                  justifyContent: 'center'
	                }
	              },
	              _react2.default.createElement(_semanticUiReact.Message, {
	                success: true,
	                fluid: true,
	                style: messageStyles,
	                icon: 'check circle outline',
	                header: 'Success',
	                content: 'Mailout sent successfully. Please check your email'
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Form,
	              { onSubmit: this.handleFormSubmit },
	              _react2.default.createElement(
	                'div',
	                { style: { maxHeight: '70vh', overflow: 'auto', margin: '1.5rem' } },
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'email' },
	                    'Email'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    placeholder: 'Enter email',
	                    name: 'email',
	                    id: 'email',
	                    value: email,
	                    onChange: this.onInputChanged,
	                    error: Boolean(_lodash2.default.get(errors, 'email'))
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'name' },
	                    'Name'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    placeholder: 'Name',
	                    name: 'name',
	                    id: 'name',
	                    value: name,
	                    onChange: this.onInputChanged,
	                    error: Boolean(_lodash2.default.get(errors, 'name'))
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  {
	                    disabled: true, error: _lodash2.default.isEmpty(outreachEmailTemplate)
	                  },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'emailSubject' },
	                    'Email Subject'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    placeholder: 'Missing email subject',
	                    name: 'emailSubject',
	                    id: 'emailSubject',
	                    value: outreachEmailSubject || ''
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  {
	                    disabled: true, error: _lodash2.default.isEmpty(outreachEmailTemplate)
	                  },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'emailTemplate' },
	                    'Email Template'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    placeholder: 'Missing email template',
	                    name: 'emailTemplate',
	                    id: 'emailTemplate',
	                    value: outreachEmailTemplate || ''
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  {
	                    disabled: true, error: _lodash2.default.isEmpty(outreachEmailTemplate)
	                  },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'utmSource' },
	                    'UTM Source'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    placeholder: 'Missing utm source',
	                    name: 'utmSource',
	                    id: 'utmSource',
	                    value: utmSource || ''
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'flex',
	                  style: {
	                    justifyContent: 'flex-end',
	                    padding: '10px 0px 10px 0px'
	                  }
	                },
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Button,
	                  {
	                    loading: isSubmitting,
	                    disabled: isSubmitting || !isMailoutValid,
	                    color: 'pink',
	                    type: 'submit',
	                    size: 'medium'
	                  },
	                  'Submit'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MailoutTestModal;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onInputChanged = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(event, rest) {
	      var name, value, checked;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              name = rest.name, value = rest.value, checked = rest.checked;
	
	              _this2.setState(_defineProperty({}, name, value || checked));
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  this.handleFormSubmit = function (e) {
	    e.preventDefault();
	    var onSubmit = _this2.props.onSubmit;
	    var _state2 = _this2.state,
	        email = _state2.email,
	        name = _state2.name,
	        outreachEmailSubject = _state2.outreachEmailSubject,
	        outreachEmailTemplate = _state2.outreachEmailTemplate;
	
	    _this2.setState({ errors: { name: null, email: null } });
	    var isEmailValid = isValidEmail(email);
	    var isNameValid = !_lodash2.default.isEmpty(name);
	    if (isEmailValid && isNameValid) {
	      onSubmit({ email: email, name: name, outreachEmailSubject: outreachEmailSubject, outreachEmailTemplate: outreachEmailTemplate });
	    } else {
	      _this2.setState({
	        errors: {
	          email: isEmailValid ? null : 'Email is required',
	          name: isNameValid ? null : 'Name is required'
	        }
	      });
	    }
	  };
	};
	
	MailoutTestModal.propTypes = {
	  onClose: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  isSubmitting: _propTypes2.default.bool,
	  error: _propTypes2.default.any,
	  mailoutTestSuccess: _propTypes2.default.bool
	};
	MailoutTestModal.defaultProps = {
	  onClose: _lodash2.default.noop,
	  onSubmit: _lodash2.default.noop,
	  isSubmitting: false,
	  error: null,
	  mailoutTestSuccess: false
	};
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default)(MailoutTestModal);

/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _authService = __webpack_require__(21);
	
	var _header = __webpack_require__(348);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = _themeSelector2.default.theme();
	
	var authCheck = function authCheck() {
	  return _authService.authService.loggedIn();
	};
	
	var MobileLock = function MobileLock() {
	  var href = theme.mobileRedirectLink || 'www.dyzio.co';
	  var title = theme.title || 'dyzio';
	  return _react2.default.createElement(
	    'div',
	    { className: 'page' },
	    authCheck() ? _react2.default.createElement(_header2.default, null) : _react2.default.createElement(
	      'div',
	      { className: 'logo-container' },
	      _react2.default.createElement(
	        'a',
	        { href: '/' },
	        _react2.default.createElement('img', { src: theme.darkLogo.src, alt: theme.darkLogo.alt })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: authCheck() ? 'mobile-lock' : 'mobile-lock no-header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'mobile-highlight' },
	        _react2.default.createElement('img', { src: '/icons/computer.svg', alt: 'computer' })
	      ),
	      _react2.default.createElement('div', { className: 'spacer' }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Ciao! ',
	        title,
	        ' can only be accessed on large screen devices at the moment, so make sure you log in using a computer or tablet.'
	      ),
	      _react2.default.createElement('div', { className: 'spacer' }),
	      _react2.default.createElement(
	        'p',
	        { className: 'small' },
	        _react2.default.createElement(
	          'a',
	          { href: href },
	          'Back to ',
	          href
	        )
	      )
	    )
	  );
	};
	
	exports.default = MobileLock;

/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ThemeSelector$theme = _themeSelector2.default.theme(),
	    platformName = _ThemeSelector$theme.platformName;
	
	var LIST_STYLE = {
	  paddingLeft: '1em'
	};
	
	var TypeButton = function TypeButton(_ref) {
	  var last = _ref.last,
	      children = _ref.children,
	      name = _ref.name,
	      onClick = _ref.onClick,
	      backgroundColor = _ref.backgroundColor;
	  return _react2.default.createElement(
	    _semanticUiReact.Grid,
	    { width: 16 },
	    _react2.default.createElement(
	      _semanticUiReact.Grid.Row,
	      null,
	      _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 1 }),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { verticalAlign: 'middle', textAlign: 'center', width: 6 },
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          {
	            style: { backgroundColor: backgroundColor, color: !onClick ? 'rgba(255,255,255,0.5)' : 'white' },
	            onClick: onClick,
	            disabled: !onClick,
	            size: 'large',
	            fluid: true
	          },
	          name
	        )
	      ),
	      _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 1 }),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { width: 8 },
	        _react2.default.createElement(
	          'h3',
	          null,
	          ' ',
	          name
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { color: 'gray' } },
	          children
	        )
	      )
	    ),
	    !last && _react2.default.createElement(
	      _semanticUiReact.Grid.Row,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { width: 16 },
	        _react2.default.createElement(
	          _semanticUiReact.Divider,
	          { horizontal: true },
	          'Or'
	        )
	      )
	    )
	  );
	};
	
	TypeButton.propTypes = {
	  last: _propTypes2.default.bool,
	  children: _propTypes2.default.object.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  backgroundColor: _propTypes2.default.string
	};
	
	TypeButton.defaultProps = {
	  last: false,
	  backgroundColor: null
	};
	
	var STYLE = { paddingTop: 5, fontSize: '90%' };
	
	var CampaignTypeButtons = function CampaignTypeButtons(_ref2) {
	  var onTypeSelected = _ref2.onTypeSelected;
	  return _react2.default.createElement(
	    'div',
	    { style: STYLE },
	    _react2.default.createElement(
	      TypeButton,
	      {
	        backgroundColor: '#fc4085',
	        name: 'Influencer Tracking Campaign',
	        onClick: function onClick() {
	          return onTypeSelected('AUTOMATED');
	        }
	      },
	      _react2.default.createElement(
	        'ul',
	        { style: LIST_STYLE },
	        _react2.default.createElement(
	          'li',
	          null,
	          'Set the campaign ',
	          _react2.default.createElement(
	            'i',
	            null,
	            '#tag'
	          ),
	          ' or ',
	          _react2.default.createElement(
	            'i',
	            null,
	            '@mention'
	          ),
	          ' you want to track'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Add influencers from your database'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          platformName,
	          ' scans the influencer',
	          '\'',
	          's channels and automatically finds and tracks your posts and stories'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Or add your posts manually using the URL'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Request influencer authentication to track reach, impressions & stories data'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      TypeButton,
	      {
	        backgroundColor: '#fdb02b',
	        last: true,
	        name: 'Instagram Channel Report',
	        onClick: function onClick() {
	          return onTypeSelected('ACR');
	        }
	      },
	      _react2.default.createElement(
	        'ul',
	        { style: LIST_STYLE },
	        _react2.default.createElement(
	          'li',
	          null,
	          'Add a single Instagram Account (Creator, Business or Personal)'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Automatically track data from all posts added to this account'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Request account authorisation, via an influencer or brand'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'If the account is authorised, ',
	          platformName,
	          ' reports all impression, reach and stories data, from every post'
	        )
	      )
	    )
	  );
	};
	
	CampaignTypeButtons.propTypes = {
	  onTypeSelected: _propTypes2.default.func.isRequired
	};
	
	exports.default = CampaignTypeButtons;

/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewCampaignSteps = function NewCampaignSteps(_ref) {
	  var stepIndex = _ref.stepIndex,
	      onStepClick = _ref.onStepClick;
	  return _react2.default.createElement(
	    _semanticUiReact.Step.Group,
	    { fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Step,
	      { active: stepIndex === 1, onClick: stepIndex > 1 && function () {
	          return onStepClick(1);
	        } },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'folder' }),
	      _react2.default.createElement(
	        _semanticUiReact.Step.Content,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Step.Title,
	          null,
	          'Campaign Type'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Step.Description,
	          null,
	          'Choose your campaign type'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Step,
	      { active: stepIndex === 2, disabled: stepIndex < 2 },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'list' }),
	      _react2.default.createElement(
	        _semanticUiReact.Step.Content,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Step.Title,
	          null,
	          'Campaign Details'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Step.Description,
	          null,
	          'Complete your setup'
	        )
	      )
	    )
	  );
	};
	
	NewCampaignSteps.propTypes = {
	  stepIndex: _propTypes2.default.number.isRequired,
	  onStepClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = NewCampaignSteps;

/***/ },
/* 2003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactYoutube = __webpack_require__(745);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var youtubeEmbedOpts = {
	  color: 'white',
	  width: '100%',
	  showinfo: 1
	};
	
	var NewInfluencerTabModal = function NewInfluencerTabModal(_ref) {
	  var onClose = _ref.onClose,
	      onDontShowAgain = _ref.onDontShowAgain;
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      onClose: onClose,
	      size: 'large',
	      hasActionButton: true,
	      actionButtonContent: 'don\'t show this message again',
	      headerText: 'The Influencer tab has changed!',
	      onActionButtonClick: onDontShowAgain
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Table,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Body,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { width: 8 },
	            _react2.default.createElement(_reactYoutube2.default, { videoId: 'US8HPFi6zOQ', opts: youtubeEmbedOpts })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            { width: 8 },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Hello, we have changed the way the Influencer tab works... We no longer display the Influencer posts on this tab directly. You now have to click on the influencer\'s card to view or add posts.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This change will make the Influencer tab faster to load for large campaigns and also allow us to add more functionality to the new Influencer page. If you have any questions or comments please contact us using the chat button in the bottom right of your screen.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'All the funcionality that was on the Influencer card such as Add Post, Send Invitation etc is now found on the new Influencer page.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Click the button below to dismiss this window permanently.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	NewInfluencerTabModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  onDontShowAgain: _propTypes2.default.func.isRequired
	};
	
	exports.default = NewInfluencerTabModal;

/***/ },
/* 2004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardStyle = {
	  textAlign: 'center',
	  boxShadow: 'none'
	};
	
	var hrStyle = {
	  borderTop: '1px dashed #',
	  marginTop: 20,
	  marginBottom: 20
	};
	
	var NoAssetsCard = function NoAssetsCard() {
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true, style: cardStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        'No posts yet!'
	      ),
	      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	      _react2.default.createElement(_semanticUiReact.Image, { src: '/images/empty-campaigns.svg' }),
	      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	      _react2.default.createElement(
	        'span',
	        null,
	        'you can add them manually using the '
	      ),
	      _react2.default.createElement(_semanticUiReact.Label, { content: 'Add Post', color: 'pink', icon: 'plus', basic: true }),
	      ' ',
	      _react2.default.createElement(
	        'span',
	        null,
	        'button above ',
	        _react2.default.createElement('br', null),
	        'or wait for them to be found automatically'
	      )
	    )
	  );
	};
	
	exports.default = NoAssetsCard;

/***/ },
/* 2005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var theme = _themeSelector2.default.theme();
	
	var NotFound = function (_React$Component) {
	  _inherits(NotFound, _React$Component);
	
	  function NotFound() {
	    _classCallCheck(this, NotFound);
	
	    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
	  }
	
	  _createClass(NotFound, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-centered' },
	        _react2.default.createElement(
	          'div',
	          { className: 'center-outer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'center-inner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'center-logo' },
	              _react2.default.createElement(
	                'a',
	                { href: '/' },
	                _react2.default.createElement('img', { src: theme.darkLogo.src, alt: theme.darkLogo.alt })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'center-content' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'info' },
	                '404 - Not Found'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'info' },
	                'We couldn\u2019t find anything here, that\u2019s all we know.'
	              ),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              _react2.default.createElement(
	                'button',
	                { className: 'large rose stretch', onClick: function onClick() {
	                    return _this2.context.router.push('/');
	                  } },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Go Home'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NotFound;
	}(_react2.default.Component);
	
	NotFound.contextTypes = {
	  router: _react.PropTypes.object
	};
	exports.default = NotFound;

/***/ },
/* 2006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dataFetchError = __webpack_require__(541);
	
	var _dataFetchError2 = _interopRequireDefault(_dataFetchError);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var noMarginNoPadding = {
	  margin: 0,
	  padding: 0
	};
	
	var noMargin = {
	  margin: 0
	};
	
	var labelStyle = {
	  cursor: 'pointer',
	  margin: 3
	};
	
	var cloudfrontTagsApi = ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production");
	
	var OldOrganisationTags = function (_React$Component) {
	  _inherits(OldOrganisationTags, _React$Component);
	
	  function OldOrganisationTags() {
	    _classCallCheck(this, OldOrganisationTags);
	
	    var _this = _possibleConstructorReturn(this, (OldOrganisationTags.__proto__ || Object.getPrototypeOf(OldOrganisationTags)).call(this));
	
	    _this.state = {
	      tags: [],
	      loading: true,
	      selectedTag: null
	    };
	
	    _this.handleTagClick = function (e, _ref) {
	      var value = _ref.value;
	      var handleClick = _this.props.handleClick;
	
	      var tag = value;
	      _this.setState({
	        selectedTag: tag
	      }, handleClick({
	        tag: tag
	      }));
	    };
	
	    var token = _authService.authService.getToken();
	    var tagsApi = cloudfrontTagsApi;
	    _this.api = _axios2.default.create({
	      baseURL: tagsApi,
	      timeout: 10000,
	      headers: {
	        Authorization: 'Bearer ' + token
	      }
	    });
	    return _this;
	  }
	
	  _createClass(OldOrganisationTags, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var organisationId = this.props.organisationId;
	
	      if (organisationId) {
	        this.api.get('/tags/' + organisationId).then(function (r) {
	          var data = r.data;
	
	          _this2.setState({
	            tags: data.data,
	            loading: false
	          });
	        }).catch(function (error) {
	          _this2.setState({
	            tags: [],
	            error: error,
	            loading: false
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          tags = _state.tags,
	          loading = _state.loading,
	          selectedTag = _state.selectedTag,
	          error = _state.error;
	
	      var tagCount = loading ? 'loading' : tags.length;
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: true, color: 'blue', style: noMargin },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Card.Header,
	            null,
	            'Tag Search'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Meta,
	            null,
	            _react2.default.createElement('br', null),
	            'This will search influencers tags directly.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'i',
	              null,
	              'NOT'
	            ),
	            ' their handles, description or bios.',
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            'The tag search will bring back ',
	            _react2.default.createElement(
	              'i',
	              null,
	              'all'
	            ),
	            ' matching influencers.'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          { textAlign: 'center' },
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { basic: true, loading: loading, style: noMarginNoPadding },
	            _lodash2.default.map(tags, function (tag) {
	              return _react2.default.createElement(_semanticUiReact.Label, {
	                content: tag,
	                color: tag === selectedTag ? 'pink' : 'grey',
	                basic: tag !== selectedTag,
	                style: labelStyle,
	                value: tag,
	                onClick: _this3.handleTagClick
	              });
	            }),
	            error && _react2.default.createElement(_dataFetchError2.default, { dataDescription: 'influencer tags', iconSize: 'huge', error: error })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          { extra: true, textAlign: 'center' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'tags' }),
	          tagCount,
	          ' tags'
	        )
	      );
	    }
	  }]);
	
	  return OldOrganisationTags;
	}(_react2.default.Component);
	
	exports.default = OldOrganisationTags;

/***/ },
/* 2007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _tabs = __webpack_require__(352);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _actions = __webpack_require__(2231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Onboarding = function (_React$Component) {
	  _inherits(Onboarding, _React$Component);
	
	  function Onboarding() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Onboarding);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Onboarding.__proto__ || Object.getPrototypeOf(Onboarding)).call.apply(_ref, [this].concat(args))), _this), _this.updateOnboardingState = function () {
	      _this.props.onUpdateOnboardingState({ page: 'dashboard', onboardingState: 'overview', callback: _this.changeUrlPath('/') });
	    }, _this.changeUrlPath = function (path) {
	      return function () {
	        return _this.context.router.push(path);
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Onboarding, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_tabs2.default, { title: 'My Campaigns', tabsStyle: 'tabs', hideTabs: true }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'box centered' },
	              _react2.default.createElement(
	                'div',
	                { className: 'box-content-one' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-content-two' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-content-three' },
	                    _react2.default.createElement('div', { className: 'spacer' }),
	                    _react2.default.createElement(
	                      'h2',
	                      null,
	                      'What are we waiting for?',
	                      _react2.default.createElement('br', null),
	                      'Let\u2019s get started!'
	                    ),
	                    _react2.default.createElement('div', { className: 'spacer large' }),
	                    _react2.default.createElement('img', { src: '/loudspeaker.svg', alt: 'let\'s get started' }),
	                    _react2.default.createElement('div', { className: 'spacer large' }),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Add a campaign to begin working on campaigns and inviting people to collaborate with you on Dyzio.'
	                    ),
	                    _react2.default.createElement('div', { className: 'spacer' }),
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'large rose wide' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Create a campaign!'
	                      )
	                    ),
	                    _react2.default.createElement('div', { className: 'spacer' })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'onboarding-modal' },
	            _react2.default.createElement(
	              'div',
	              { className: 'onboarding-content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex' },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  'Get started'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box' },
	                  _react2.default.createElement('img', { src: '/icons/rocket-seagreen.svg', alt: 'rocket' }),
	                  _react2.default.createElement('div', { className: 'spacer small' }),
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Create a campaign'
	                  ),
	                  _react2.default.createElement('div', { className: 'spacer small' }),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'small' },
	                    'Run your campaigns through dyzio'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'link' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'small' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: '/dashboard' },
	                        'Get started'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box' },
	                  _react2.default.createElement('img', { src: '/icons/tracking.svg', alt: 'rocket' }),
	                  _react2.default.createElement('div', { className: 'spacer small' }),
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Track live video'
	                  ),
	                  _react2.default.createElement('div', { className: 'spacer small' }),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'small' },
	                    'Get live analytics on influencer videos',
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'link' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'small' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: '/analytics' },
	                        'Get started'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box' },
	                  _react2.default.createElement('img', { src: '/icons/group.svg', alt: 'rocket' }),
	                  _react2.default.createElement('div', { className: 'spacer small' }),
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'light' },
	                    'Build your influencer database'
	                  ),
	                  _react2.default.createElement('div', { className: 'spacer small' }),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'small light' },
	                    'Record the details of the influencers you work with for you and your team'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'link' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'small' },
	                      'Coming soon...'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex' },
	                _react2.default.createElement(
	                  'button',
	                  { onClick: this.updateOnboardingState, className: 'medium wide' },
	                  'skip'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Onboarding;
	}(_react2.default.Component);
	
	Onboarding.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {};
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onUpdateOnboardingState: function onUpdateOnboardingState(data) {
	      return dispatch((0, _actions.updateOnboardingState)(data));
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Onboarding);

/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(37);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalStyle = {
	  textAlign: 'center',
	  color: '#777'
	};
	
	var nameStyle = {
	  marginTop: 10,
	  marginBottom: 10,
	  display: 'block'
	};
	
	var OrganisationBlock = function OrganisationBlock(_ref) {
	  var organisationName = _ref.organisationName;
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      open: true,
	      style: modalStyle,
	      size: 'small'
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Header,
	        { as: 'h2', icon: true },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning sign', color: 'orange' }),
	        _react2.default.createElement(
	          'h2',
	          { style: nameStyle },
	          organisationName
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Header.Subheader,
	          null,
	          'Your subscription has expired. Please contact our Sales team to arrange access. You can use the support button in the bottom right of the screen or email us at ',
	          _react2.default.createElement(
	            _targetLink2.default,
	            { renderIf: true, href: 'mailto:sales@dyzio.co' },
	            'sales@dyzio.co'
	          ),
	          '.',
	          _react2.default.createElement(_semanticUiReact.Divider, null)
	        )
	      )
	    )
	  );
	};
	
	OrganisationBlock.propTypes = {
	  organisationName: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(OrganisationBlock);

/***/ },
/* 2009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dataFetchError = __webpack_require__(541);
	
	var _dataFetchError2 = _interopRequireDefault(_dataFetchError);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var noMarginNoPadding = {
	  margin: 0,
	  padding: 0
	};
	
	var VerticalMargin1rem = {
	  margin: '1rem 0'
	};
	
	var labelStyle = {
	  cursor: 'pointer',
	  margin: 3
	};
	
	var cloudfrontTagsApi = ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production");
	
	var OrganisationBrandTags = function (_React$Component) {
	  _inherits(OrganisationBrandTags, _React$Component);
	
	  function OrganisationBrandTags() {
	    _classCallCheck(this, OrganisationBrandTags);
	
	    var _this = _possibleConstructorReturn(this, (OrganisationBrandTags.__proto__ || Object.getPrototypeOf(OrganisationBrandTags)).call(this));
	
	    _this.state = {
	      tags: [],
	      loading: true,
	      selectedTag: null
	    };
	
	    _this.handleTagClick = function (e, _ref) {
	      var value = _ref.value;
	      var handleClick = _this.props.handleClick;
	
	      var tag = value;
	      _this.setState({
	        selectedTag: tag
	      }, handleClick({
	        brandTag: tag
	      }));
	    };
	
	    var token = _authService.authService.getToken();
	    var tagsApi = cloudfrontTagsApi;
	    _this.api = _axios2.default.create({
	      baseURL: tagsApi,
	      timeout: 30000,
	      headers: {
	        Authorization: 'Bearer ' + token
	      }
	    });
	    return _this;
	  }
	
	  _createClass(OrganisationBrandTags, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var organisationId = this.props.organisationId;
	
	      if (organisationId) {
	        this.api.get('/brand/tags/' + organisationId).then(function (r) {
	          var data = r.data;
	
	          _this2.setState({
	            tags: data.data,
	            loading: false
	          });
	        }).catch(function (error) {
	          _this2.setState({
	            tags: [],
	            error: error,
	            loading: false
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          tags = _state.tags,
	          loading = _state.loading,
	          selectedTag = _state.selectedTag,
	          error = _state.error;
	
	      var tagCount = loading ? 'loading' : tags.length;
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: true, color: 'blue', style: VerticalMargin1rem },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Card.Header,
	            null,
	            'Brand Tag Search'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Meta,
	            null,
	            _react2.default.createElement('br', null),
	            'This will search brand tags directly.',
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            'The brand tag search will bring back ',
	            _react2.default.createElement(
	              'i',
	              null,
	              'all'
	            ),
	            ' influencers with matching brand tag.'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          { textAlign: 'center' },
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { basic: true, loading: loading, style: noMarginNoPadding },
	            _lodash2.default.map(tags, function (tag) {
	              return _react2.default.createElement(_semanticUiReact.Label, {
	                content: tag,
	                color: tag === selectedTag ? 'pink' : 'grey',
	                basic: tag !== selectedTag,
	                style: labelStyle,
	                value: tag,
	                onClick: _this3.handleTagClick
	              });
	            }),
	            error && _react2.default.createElement(_dataFetchError2.default, { dataDescription: 'influencer tags', iconSize: 'huge', error: error })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          { extra: true, textAlign: 'center' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'tags' }),
	          tagCount,
	          ' tags'
	        )
	      );
	    }
	  }]);
	
	  return OrganisationBrandTags;
	}(_react2.default.Component);
	
	exports.default = OrganisationBrandTags;

/***/ },
/* 2010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _facebookAdsManager = __webpack_require__(872);
	
	var _facebookAdsManager2 = _interopRequireDefault(_facebookAdsManager);
	
	var _currencies = __webpack_require__(128);
	
	var _shopifyConnectionSettings = __webpack_require__(2024);
	
	var _shopifyConnectionSettings2 = _interopRequireDefault(_shopifyConnectionSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrganisationSettings = function OrganisationSettings(_ref) {
	  var organisation = _ref.organisation,
	      onChange = _ref.onChange,
	      fetchOrganisation = _ref.fetchOrganisation;
	  var name = organisation.name,
	      defaultCurrency = organisation.defaultCurrency,
	      adsManagerAccount = organisation.adsManagerAccount,
	      usesGlobalTags = organisation.usesGlobalTags;
	
	  var handleCheckboxChange = function handleCheckboxChange(event, _ref2) {
	    var checked = _ref2.checked;
	
	    onChange(event, { name: 'usesGlobalTags', value: checked });
	  };
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true },
	    _react2.default.createElement(_semanticUiReact.Card.Content, { header: 'Organisation Settings' }),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Form,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { columns: 3 },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              null,
	              _react2.default.createElement(_semanticUiReact.Form.Field, {
	                control: _semanticUiReact.Select,
	                label: 'Default Currency (for campaign budgets etc)',
	                fluid: true,
	                search: true,
	                onChange: onChange,
	                value: defaultCurrency,
	                name: 'defaultCurrency',
	                options: _currencies.DYZIO_CURRENCIES
	              }),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              _react2.default.createElement(_semanticUiReact.Checkbox, {
	                checked: usesGlobalTags,
	                label: 'Use global tags',
	                name: 'usesGlobalTags',
	                onChange: handleCheckboxChange
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              null,
	              _react2.default.createElement(_facebookAdsManager2.default, {
	                canLinkCampaigns: false,
	                name: name,
	                account: adsManagerAccount
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              null,
	              _react2.default.createElement(_shopifyConnectionSettings2.default, { organisation: organisation, fetchOrganisation: fetchOrganisation })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	OrganisationSettings.propTypes = {
	  organisation: _propTypes2.default.object.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  fetchOrganisation: _propTypes2.default.func.isRequired
	};
	
	exports.default = OrganisationSettings;

/***/ },
/* 2011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _recompose = __webpack_require__(15);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var labelStyle = {
	  cursor: 'pointer',
	  margin: 5
	};
	
	var titleStyle = {
	  display: 'block',
	  float: 'left'
	};
	
	var resetLinkStyle = {
	  display: 'block',
	  fontSize: 14,
	  float: 'right',
	  color: 'rgb(32, 196, 158)'
	};
	
	var OrganisationTags = function (_React$Component) {
	  _inherits(OrganisationTags, _React$Component);
	
	  //
	  function OrganisationTags(props) {
	    _classCallCheck(this, OrganisationTags);
	
	    var _this = _possibleConstructorReturn(this, (OrganisationTags.__proto__ || Object.getPrototypeOf(OrganisationTags)).call(this, props));
	
	    _this.onToggle = function () {
	      var onSwitchToggle = _this.props.onSwitchToggle;
	
	      _this.setState(function (prev) {
	        return {
	          mustMatchAllTags: !prev.mustMatchAllTags
	        };
	      }, function () {
	        onSwitchToggle(_this.state.mustMatchAllTags);
	      });
	    };
	
	    var mustMatchAllTags = props.mustMatchAllTags;
	
	    _this.state = {
	      isLoading: true,
	      failedToLoadTags: false,
	      mustMatchAllTags: mustMatchAllTags,
	      tags: []
	    };
	    return _this;
	  }
	
	  _createClass(OrganisationTags, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var _props, restClient, organisationId, response, tags;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props, restClient = _props.restClient, organisationId = _props.organisationId;
	                _context.next = 3;
	                return restClient.get('tags?filter[organisation]=' + organisationId).catch(function (error) {
	                  _this2.setState({
	                    isLoading: false,
	                    failedToLoadTags: false,
	                    tags: []
	                  });
	                });
	
	              case 3:
	                response = _context.sent;
	
	                if (response) {
	                  _context.next = 7;
	                  break;
	                }
	
	                this.setState({
	                  isLoading: false
	                });
	                return _context.abrupt('return');
	
	              case 7:
	                tags = _lodash2.default.get(response, 'data.data', []);
	
	                this.setState({
	                  tags: tags,
	                  isLoading: false,
	                  failedToLoadTags: false
	                });
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          tags = _state.tags,
	          mustMatchAllTags = _state.mustMatchAllTags;
	      var _props2 = this.props,
	          onTagSelected = _props2.onTagSelected,
	          selectedTags = _props2.selectedTags;
	
	      var isSelected = function isSelected(id) {
	        return _lodash2.default.some(selectedTags, function (tg) {
	          return _lodash2.default.eq(tg, id);
	        });
	      };
	      var canSelect = function canSelect(id) {
	        return _lodash2.default.size(selectedTags) < 10 || isSelected(id);
	      };
	      var tagStyles = function tagStyles(id) {
	        return canSelect(id) ? labelStyle : _extends({}, labelStyle, { cursor: 'not-allowed' });
	      };
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: true, color: 'blue' },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Card.Header,
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: titleStyle },
	              'Tag Search'
	            ),
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return onTagSelected(null);
	                }, style: resetLinkStyle },
	              'Clear filter ',
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'x' })
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, { clearing: true, fitted: true, hidden: true })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Meta,
	            null,
	            _react2.default.createElement('br', null),
	            'This will search influencers tags directly.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'i',
	              null,
	              'NOT'
	            ),
	            ' their handles, description or bios.',
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The tag search will bring back ',
	              _react2.default.createElement(
	                'i',
	                null,
	                'all'
	              ),
	              ' matching influencers. You can ',
	              _react2.default.createElement(
	                _targetLink2.default,
	                { target: '_self', renderIf: true, href: '/team/tags' },
	                'manage tags here'
	              ),
	              '.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.GridColumn,
	              { width: 12 },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Must match all selected tags'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.GridColumn,
	              { width: 4 },
	              _react2.default.createElement(_semanticUiReact.Radio, {
	                toggle: true,
	                checked: mustMatchAllTags,
	                onChange: this.onToggle
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          { textAlign: 'center' },
	          isLoading && _react2.default.createElement(
	            _semanticUiReact.Segment,
	            null,
	            _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading tags' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            !isLoading && _lodash2.default.map(tags, function (tag) {
	              return _react2.default.createElement(
	                _semanticUiReact.Label,
	                {
	                  basic: !isSelected(_lodash2.default.get(tag, 'id')),
	                  inverted: true,
	                  onClick: function onClick() {
	                    return canSelect(_lodash2.default.get(tag, 'id')) ? onTagSelected(_lodash2.default.get(tag, 'id'), mustMatchAllTags) : _lodash2.default.noop();
	                  },
	                  style: tagStyles(_lodash2.default.get(tag, 'id')),
	                  color: isSelected(_lodash2.default.get(tag, 'id')) ? 'pink' : null,
	                  key: _lodash2.default.get(tag, 'id')
	                },
	                _lodash2.default.get(tag, 'attributes.value')
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrganisationTags;
	}(_react2.default.Component);
	
	OrganisationTags.propTypes = {
	  onTagSelected: _propTypes2.default.func.isRequired,
	  organisationId: _propTypes2.default.string.isRequired,
	  selectedTags: _propTypes2.default.array,
	  onSwitchToggle: _propTypes2.default.func,
	  mustMatchAllTags: _propTypes2.default.bool
	};
	
	OrganisationTags.defaultProps = {
	  selectedTags: [],
	  onSwitchToggle: _lodash2.default.noop,
	  mustMatchAllTags: true
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default)(OrganisationTags);

/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dyzioButtons = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDeclined = function isDeclined(status) {
	  return status === 'DECLINED';
	};
	
	var bottomBlockStyle = {
	  lineHeight: '47px'
	};
	
	var descriptionBlockStyle = {
	  height: '40px'
	};
	
	var buttonsStyle = {
	  width: '45%'
	};
	
	var PendingInvitation = function PendingInvitation(_ref) {
	  var id = _ref.id,
	      campaignName = _ref.campaign.name,
	      createdDate = _ref.createdDate,
	      createdBy = _ref.createdBy,
	      onInvitationAccepted = _ref.onInvitationAccepted,
	      onInvitationDeclined = _ref.onInvitationDeclined,
	      status = _ref.status;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        campaignName
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Meta,
	        null,
	        'created ',
	        (0, _moment2.default)(createdDate).format('Do MMM Y')
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Description,
	        { style: descriptionBlockStyle },
	        createdBy,
	        ' invited you to join ',
	        campaignName,
	        ' campaign'
	      )
	    ),
	    isDeclined(status) && _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true, style: bottomBlockStyle },
	      'This invitation is declined.'
	    ),
	    !isDeclined(status) && _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true, style: bottomBlockStyle },
	      _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	        hasIcon: true,
	        style: buttonsStyle,
	        color: 'red',
	        icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'close' }),
	        label: 'Decline',
	        onClick: function onClick() {
	          return onInvitationDeclined(id);
	        }
	      }),
	      _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	        hasIcon: true,
	        style: buttonsStyle,
	        floated: 'right',
	        color: 'green',
	        icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'check' }),
	        label: 'Accept',
	        onClick: function onClick() {
	          return onInvitationAccepted(id);
	        }
	      })
	    )
	  );
	};
	
	PendingInvitation.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  campaign: _propTypes2.default.object.isRequired,
	  createdDate: _propTypes2.default.string.isRequired,
	  status: _propTypes2.default.string.isRequired,
	  createdBy: _propTypes2.default.string.isRequired,
	  onInvitationAccepted: _propTypes2.default.func.isRequired,
	  onInvitationDeclined: _propTypes2.default.func.isRequired
	};
	
	exports.default = PendingInvitation;

/***/ },
/* 2013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _pendingInvitation = __webpack_require__(2012);
	
	var _pendingInvitation2 = _interopRequireDefault(_pendingInvitation);
	
	var _states = __webpack_require__(2014);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PendingInvitationsList = function PendingInvitationsList(_ref) {
	  var isLoading = _ref.isLoading,
	      isError = _ref.isError,
	      invitations = _ref.invitations,
	      onInvitationAccepted = _ref.onInvitationAccepted,
	      onInvitationDeclined = _ref.onInvitationDeclined,
	      shouldFetchDeclinedInvitations = _ref.shouldFetchDeclinedInvitations,
	      onShowDeclinedInvitationsToggleChanged = _ref.onShowDeclinedInvitationsToggleChanged;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_semanticUiReact.Checkbox, {
	      toggle: true,
	      checked: shouldFetchDeclinedInvitations,
	      label: 'Show declined invitations',
	      onClick: onShowDeclinedInvitationsToggleChanged
	    }),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, clearing: true }),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Group,
	      { fluid: true, itemsPerRow: 'three' },
	      isLoading && _react2.default.createElement(_states.LoadingState, null),
	      !isLoading && !isError && _lodash2.default.isEmpty(invitations) && _react2.default.createElement(_states.EmptyState, null),
	      !isLoading && !isError && _lodash2.default.map(invitations, function (invitation) {
	        return _react2.default.createElement(_pendingInvitation2.default, Object.assign({}, invitation, {
	          onInvitationAccepted: onInvitationAccepted,
	          onInvitationDeclined: onInvitationDeclined
	        }));
	      })
	    )
	  );
	};
	
	PendingInvitationsList.propTypes = {
	  isLoading: _propTypes2.default.bool.isRequired,
	  isError: _propTypes2.default.bool.isRequired,
	  shouldFetchDeclinedInvitations: _propTypes2.default.bool.isRequired,
	  invitations: _propTypes2.default.array.isRequired,
	  onInvitationAccepted: _propTypes2.default.func.isRequired,
	  onInvitationDeclined: _propTypes2.default.func.isRequired,
	  onShowDeclinedInvitationsToggleChanged: _propTypes2.default.func.isRequired
	};
	
	exports.default = PendingInvitationsList;

/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoadingState = exports.EmptyState = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var segmentStyle = {
	  width: '100%',
	  paddingTop: 75,
	  paddingBottom: 75,
	  background: 'transparent',
	  border: 'none',
	  boxShadow: 'none'
	};
	
	var EmptyState = exports.EmptyState = function EmptyState() {
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { style: segmentStyle, padded: true, textAlign: 'center' },
	    _react2.default.createElement(
	      _semanticUiReact.Header,
	      { as: 'h2', icon: true, size: 'medium' },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning circle', color: 'orange' }),
	      'No pending invitations',
	      _react2.default.createElement(
	        _semanticUiReact.Header.Subheader,
	        null,
	        'Please try again later'
	      )
	    )
	  );
	};
	
	var LoadingState = exports.LoadingState = function LoadingState() {
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { style: segmentStyle, padded: true, textAlign: 'center' },
	    _react2.default.createElement(
	      _semanticUiReact.Header,
	      { as: 'h2', icon: true, size: 'medium' },
	      _react2.default.createElement(_semanticUiReact.Icon, {
	        name: 'refresh',
	        loading: true
	      }),
	      'Loading invitations..'
	    )
	  );
	};

/***/ },
/* 2015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _discountCodesSelector = __webpack_require__(868);
	
	var _discountCodesSelector2 = _interopRequireDefault(_discountCodesSelector);
	
	var _reactCopyToClipboard = __webpack_require__(315);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SHOPIFY_HELP_LINK = 'https://help.prestaShop.com/en/manual/discounts/create-discount-codes';
	var DISCOUNT_HELP_LINK = 'https://help.dyzio.co/en/articles/5517378-prestaShop-integration';
	
	var prestaShopLogoStyle = {
	  height: '1.2em'
	};
	
	var iconMarginLeftStyle = {
	  marginLeft: 5
	};
	
	var buttonStyles = {
	  width: 'auto'
	};
	
	var PrestaShopConfig = function (_Component) {
	  _inherits(PrestaShopConfig, _Component);
	
	  function PrestaShopConfig(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, PrestaShopConfig);
	
	    var _this = _possibleConstructorReturn(this, (PrestaShopConfig.__proto__ || Object.getPrototypeOf(PrestaShopConfig)).call(this, props));
	
	    _this.persistPrestaShopSettings = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(prestaShopSettings) {
	        var discountCode, commission, _this$props, savePrestaShopSetting, reloadPrestaShopOrders, isCommissionValid;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                discountCode = prestaShopSettings.discountCode, commission = prestaShopSettings.commission;
	                _this$props = _this.props, savePrestaShopSetting = _this$props.savePrestaShopSetting, reloadPrestaShopOrders = _this$props.reloadPrestaShopOrders;
	
	                if (!(discountCode || _lodash2.default.isEqual(discountCode, ''))) {
	                  _context.next = 7;
	                  break;
	                }
	
	                _context.next = 5;
	                return savePrestaShopSetting(prestaShopSettings);
	
	              case 5:
	                reloadPrestaShopOrders();
	                _this.toggleDiscountCodeInputState();
	
	              case 7:
	                if (!commission) {
	                  _context.next = 14;
	                  break;
	                }
	
	                isCommissionValid = _this.state.isCommissionValid;
	
	                if (!isCommissionValid) {
	                  _context.next = 14;
	                  break;
	                }
	
	                _context.next = 12;
	                return savePrestaShopSetting(prestaShopSettings);
	
	              case 12:
	                reloadPrestaShopOrders();
	                _this.setState({
	                  isCommissionEditing: false
	                });
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onDiscountCodeChange = function (e, _ref2) {
	      var value = _ref2.value;
	      return _this.setState({
	        discountCode: value
	      });
	    };
	
	    _this.onCommisionChange = function (e, _ref3) {
	      var value = _ref3.value;
	      return _this.setState({
	        commission: value,
	        isCommissionValid: _lodash2.default.toNumber(value) <= 100 && _lodash2.default.toNumber(value) >= 0
	      });
	    };
	
	    _this.toggleDiscountCodeInputState = function () {
	      return _this.setState({
	        isDiscountCodeEditing: !_this.state.isDiscountCodeEditing
	      });
	    };
	
	    _this.toggleCommissionInputState = function () {
	      return _this.setState({
	        isCommissionEditing: !_this.state.isCommissionEditing
	      });
	    };
	
	    _this.togglePrestaShopConfig = function () {
	      return _this.setState({
	        hidePrestaShopConfig: !_this.state.hidePrestaShopConfig
	      });
	    };
	
	    _this.onDiscountCodeSelected = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dc) {
	        var discountCode, discountCodeArray, isDiscountCodeSelected, updatedDiscountCode;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                discountCode = _this.state.discountCode;
	
	
	                console.log(dc);
	
	                discountCodeArray = _lodash2.default.split(discountCode, ',');
	
	
	                console.log(discountCodeArray);
	
	                isDiscountCodeSelected = _lodash2.default.find(discountCodeArray, function (item) {
	                  return _lodash2.default.isEqual(item, dc);
	                });
	
	                console.log(isDiscountCodeSelected);
	
	                updatedDiscountCode = discountCode;
	
	
	                if (!isDiscountCodeSelected) {
	                  if (discountCode) {
	                    updatedDiscountCode = discountCode + ',' + dc;
	                  } else {
	                    updatedDiscountCode = dc;
	                  }
	                }
	
	                _context2.next = 10;
	                return _this.persistPrestaShopSettings({ discountCode: updatedDiscountCode });
	
	              case 10:
	
	                _this.setState({ discountCode: updatedDiscountCode });
	
	              case 11:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.onTagUnselected = function (tagId) {
	      var tags = _this.state.tags;
	
	      var newTags = _lodash2.default.reject(tags, ['id', tagId]);
	      _this.setState({
	        tags: newTags
	      });
	    };
	
	    _this.state = {
	      discountCode: props.discountCode,
	      commission: props.commission,
	      isDiscountCodeEditing: false,
	      isUrlEditing: false,
	      isCommissionEditing: false,
	      hidePrestaShopConfig: false,
	      isUrlValid: true,
	      isCommissionValid: true
	    };
	    return _this;
	  }
	
	  _createClass(PrestaShopConfig, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          discountCode = _state.discountCode,
	          isDiscountCodeEditing = _state.isDiscountCodeEditing,
	          commission = _state.commission,
	          isCommissionEditing = _state.isCommissionEditing,
	          hidePrestaShopConfig = _state.hidePrestaShopConfig,
	          isCommissionValid = _state.isCommissionValid;
	      var editable = this.props.editable;
	
	
	      console.log(this.state);
	
	      var commisionInputActionProps = {
	        icon: isCommissionEditing ? 'save' : 'pencil',
	        onClick: isCommissionEditing ? function () {
	          return _this3.persistPrestaShopSettings({ commission: commission });
	        } : this.toggleCommissionInputState,
	        disabled: isCommissionEditing && _lodash2.default.isEmpty(commission),
	        color: isCommissionEditing ? 'pink' : 'green'
	      };
	
	      var discountCodeInputActionProps = {
	        icon: isDiscountCodeEditing ? 'save' : 'pencil',
	        onClick: isDiscountCodeEditing ? function () {
	          return _this3.persistPrestaShopSettings({ discountCode: discountCode });
	        } : this.toggleDiscountCodeInputState,
	        disabled: isDiscountCodeEditing && _lodash2.default.isEmpty(discountCode),
	        color: isDiscountCodeEditing ? 'pink' : 'green'
	      };
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            { columns: '2' },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { verticalAlign: 'middle' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  _react2.default.createElement('img', {
	                    style: prestaShopLogoStyle,
	                    src: '/icons/prestashop.svg',
	                    alt: 'PrestaShop'
	                  }),
	                  ' PrestaShop configuration',
	                  editable && _react2.default.createElement(
	                    _targetLink2.default,
	                    { href: DISCOUNT_HELP_LINK, renderIf: true },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'green', style: iconMarginLeftStyle })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { textAlign: 'right' },
	                hidePrestaShopConfig ? _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'chevron down', onClick: this.togglePrestaShopConfig, style: buttonStyles }) : _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'chevron up', onClick: this.togglePrestaShopConfig, style: buttonStyles })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, null),
	        editable && !hidePrestaShopConfig && _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Add a PrestaShop discount code and / or a shareable URL to this influencer.  These codes can be created and accessed in the \'Discounts\' section of your PrestaShop account. ',
	            _react2.default.createElement(
	              _targetLink2.default,
	              { href: SHOPIFY_HELP_LINK, renderIf: true },
	              'Click here'
	            ),
	            ' to learn more.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'You can also add a Commission percentage, that will be applied to any sales the influencers makes, via this PrestaShop URL or discount code. The influencer will be able to see the commission they have earned when they log into Dyzio.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'All PrestaShop data linked to this code and URL will be available in your Dyzio PrestaShop report.'
	          )
	        ),
	        !hidePrestaShopConfig && _react2.default.createElement(
	          _semanticUiReact.Table,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 2 },
	              'Discount Code'
	            ),
	            editable && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 14 },
	              _react2.default.createElement(_semanticUiReact.Input, {
	                fluid: true,
	                type: 'string',
	                onChange: this.onDiscountCodeChange,
	                disabled: !isDiscountCodeEditing,
	                defaultValue: discountCode,
	                value: discountCode,
	                action: discountCodeInputActionProps
	              })
	            ),
	            !editable && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 14 },
	              _react2.default.createElement(_semanticUiReact.Input, {
	                fluid: true,
	                type: 'string',
	                disabled: !editable,
	                defaultValue: discountCode,
	                value: discountCode
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 2 },
	              'Commission %'
	            ),
	            editable && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 14 },
	              _react2.default.createElement(_semanticUiReact.Input, {
	                fluid: true,
	                type: 'number',
	                onChange: this.onCommisionChange,
	                disabled: !isCommissionEditing,
	                defaultValue: commission,
	                value: commission,
	                action: commisionInputActionProps,
	                error: !isCommissionValid
	              }),
	              !isCommissionValid && commission && _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                { meta: true, textAlign: 'center' },
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { color: 'red', basic: true },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'red' }),
	                  'Must be a percentage between 0 - 100'
	                )
	              )
	            ),
	            !editable && _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 14 },
	              _react2.default.createElement(_semanticUiReact.Input, {
	                fluid: true,
	                type: 'number',
	                disabled: !editable,
	                defaultValue: commission,
	                value: commission
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PrestaShopConfig;
	}(_react.Component);
	
	PrestaShopConfig.propTypes = {
	  discountCode: _propTypes2.default.string.isRequired,
	  commission: _propTypes2.default.string.isRequired,
	  editable: _propTypes2.default.bool.isRequired
	};
	
	PrestaShopConfig.defaultProps = {
	  editable: false
	};
	
	exports.default = PrestaShopConfig;

/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _formatting = __webpack_require__(287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unescaped-entities */
	
	
	var assetTableStyles = {
	  padding: 0
	};
	
	var loadingPrestaShopCardStyle = {
	  padding: '120px 0',
	  color: 'gray'
	};
	
	var totalRowStyle = {
	  background: '#EEE'
	};
	
	var boldFontStyle = { fontWeight: 'bold' };
	
	var to2Decimal = function to2Decimal(num) {
	  return _lodash2.default.round(num, 2).toFixed(2);
	};
	
	var LineItems = function LineItems(items) {
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Cell,
	    { width: 2 },
	    _lodash2.default.map(items, function (item) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        item
	      );
	    })
	  );
	};
	
	var TotalsRow = function TotalsRow(orders) {
	  var currency = _lodash2.default.get(_lodash2.default.head(orders), 'orderCurrency', '€');
	  var totalOrders = _lodash2.default.sumBy(_lodash2.default.values(orders), function (order) {
	    return _lodash2.default.get(order, 'orderTotal');
	  });
	  var totalCommission = _lodash2.default.sumBy(_lodash2.default.values(orders), function (order) {
	    return _lodash2.default.get(order, 'orderCommission');
	  });
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    { textAlign: 'center', style: boldFontStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(
	        'b',
	        null,
	        'Totals'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: totalRowStyle },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          currency,
	          ' ',
	          (0, _formatting.commaFormatted)(totalOrders)
	        ),
	        content: 'currency: ' + currency
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { style: totalRowStyle },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          currency,
	          ' ',
	          (0, _formatting.commaFormatted)(totalCommission)
	        ),
	        content: 'currency: ' + currency
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      '-'
	    )
	  );
	};
	
	var PrestaShopTable = function (_React$Component) {
	  _inherits(PrestaShopTable, _React$Component);
	
	  //
	  function PrestaShopTable(props) {
	    _classCallCheck(this, PrestaShopTable);
	
	    var _this = _possibleConstructorReturn(this, (PrestaShopTable.__proto__ || Object.getPrototypeOf(PrestaShopTable)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var _this$props = _this.props,
	        hasDiscountCodes = _this$props.hasDiscountCodes,
	        orders = _this$props.orders;
	
	    _this.state = {
	      prestaShopLoading: false,
	      hasDiscountCodes: hasDiscountCodes,
	      orders: orders
	    };
	    return _this;
	  }
	
	  _createClass(PrestaShopTable, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }]);
	
	  return PrestaShopTable;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.render = function () {
	    var _state = _this2.state,
	        prestaShopLoading = _state.prestaShopLoading,
	        hasDiscountCodes = _state.hasDiscountCodes,
	        orders = _state.orders;
	
	
	    var currency = _lodash2.default.get(_lodash2.default.head(orders), 'orderCurrency', '€');
	
	    return _react2.default.createElement(
	      'div',
	      null,
	
	      // hasAssets &&
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { celled: true, fixed: true, singleLine: true, basic: 'very', style: assetTableStyles, size: 'small', textAlign: 'center' },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Header,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 1 },
	              'Order'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 1 },
	              'Discount Code'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 1 },
	              '(',
	              currency,
	              ') Total'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 1 },
	              '(',
	              currency,
	              ') Commission'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 1 },
	              'Order Date'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          !prestaShopLoading && hasDiscountCodes && !_lodash2.default.isEmpty(orders) && _lodash2.default.map(orders, function (order) {
	            return _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: 1 },
	                order.orderId
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: 1 },
	                order.discountCode
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: 1 },
	                order.orderCurrency,
	                ' ',
	                to2Decimal(order.orderTotal)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: 1 },
	                order.orderCurrency,
	                ' ',
	                to2Decimal(order.orderCommission)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: 1 },
	                _lodash2.default.head(_lodash2.default.split(order.orderDate, 'T'))
	              )
	            );
	          }),
	          !prestaShopLoading && hasDiscountCodes && !_lodash2.default.isEmpty(orders) && TotalsRow(orders),
	          !prestaShopLoading && hasDiscountCodes && _lodash2.default.isEmpty(orders) && _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: '6' },
	              _react2.default.createElement(
	                _semanticUiReact.Message,
	                null,
	                'No sales during the campaign period'
	              )
	            )
	          ),
	          !prestaShopLoading && !hasDiscountCodes && _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: '6' },
	              _react2.default.createElement(
	                _semanticUiReact.Message,
	                null,
	                'Please enter a discount code'
	              )
	            )
	          ),
	          prestaShopLoading && _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { colSpan: '6' },
	              _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                { textAlign: 'center', style: loadingPrestaShopCardStyle },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', loading: true, size: 'huge' }),
	                _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                'Loading orders'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	};
	
	PrestaShopTable.propTypes = {
	  orders: _propTypes2.default.object,
	  hasDiscountCodes: _propTypes2.default.bool
	};
	
	PrestaShopTable.defaultProps = {
	  hasDiscountCodes: true,
	  orders: []
	};
	
	exports.default = PrestaShopTable;

/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UpgradeButton = function UpgradeButton(_ref) {
	  var onButtonClick = _ref.onButtonClick;
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Button, {
	      fluid: true,
	      content: 'upgrade now!',
	      inverted: true,
	      icon: 'external',
	      labelPosition: 'left',
	      color: 'pink',
	      onClick: onButtonClick
	    }),
	    content: 'Clicking here will open a new window to our subscription provider Reepay.'
	  });
	};
	
	var AlreadyOnThisPlanButton = function AlreadyOnThisPlanButton() {
	  return _react2.default.createElement(_semanticUiReact.Button, {
	    fluid: true,
	    content: 'Already on this plan!',
	    inverted: true,
	    icon: 'heart',
	    labelPosition: 'left',
	    color: 'pink',
	    disabled: true
	  });
	};
	
	UpgradeButton.propTypes = {
	  onButtonClick: _propTypes2.default.func.isRequired
	};
	
	var ReepayCard = function ReepayCard(_ref2) {
	  var _onButtonClick = _ref2.onButtonClick,
	      licenseSubscriptionType = _ref2.licenseSubscriptionType,
	      toggleCancelModal = _ref2.toggleCancelModal;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        'Subscription Info'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'You are currently on our ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          licenseSubscriptionType,
	          ' PLAN'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Group,
	        { textAlign: 'center', itemsPerRow: 3 },
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { color: 'blue' },
	          _react2.default.createElement(_semanticUiReact.Card.Content, { header: 'PREMIUM' }),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              '$299'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'USD per month'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'rolling monthly contract'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            licenseSubscriptionType === 'PREMIUM' ? _react2.default.createElement(AlreadyOnThisPlanButton, null) : _react2.default.createElement(UpgradeButton, { onButtonClick: function onButtonClick() {
	                return _onButtonClick('premium');
	              } })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            { extra: true },
	            licenseSubscriptionType === 'PREMIUM' ? _react2.default.createElement(
	              'p',
	              null,
	              'click ',
	              _react2.default.createElement(
	                'a',
	                { href: '#cancel', onClick: toggleCancelModal },
	                ' here'
	              ),
	              '\xA0to cancel this plan'
	            ) : _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { color: 'green' },
	          _react2.default.createElement(_semanticUiReact.Card.Content, { header: 'PRO TEAM' }),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              '$499'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'USD per month'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'rolling monthly contract'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            licenseSubscriptionType === 'PROTEAM' ? _react2.default.createElement(AlreadyOnThisPlanButton, null) : _react2.default.createElement(UpgradeButton, { onButtonClick: function onButtonClick() {
	                return _onButtonClick('proteam');
	              } })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            { extra: true },
	            licenseSubscriptionType === 'PROTEAM' ? _react2.default.createElement(
	              'p',
	              null,
	              'click ',
	              _react2.default.createElement(
	                'a',
	                { href: '#cancel', onClick: toggleCancelModal },
	                ' here'
	              ),
	              '\xA0to cancel this plan'
	            ) : _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { color: 'pink' },
	          _react2.default.createElement(_semanticUiReact.Card.Content, { header: 'ENTERPRISE' }),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'POA'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'whitelabel available'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'contact us for pricing'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(_semanticUiReact.Button, {
	              icon: 'comment outline',
	              labelPosition: 'left',
	              fluid: true,
	              content: 'contact us...',
	              disabled: true,
	              inverted: true,
	              color: 'pink'
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            { extra: true },
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true },
	      _react2.default.createElement(
	        'p',
	        null,
	        'click ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://dyzio.co/pricing', rel: 'noopener noreferrer', target: '_blank' },
	          'here'
	        ),
	        '\xA0for full pricing breakdown'
	      )
	    )
	  );
	};
	
	ReepayCard.propTypes = {
	  onButtonClick: _propTypes2.default.func.isRequired,
	  licenseSubscriptionType: _propTypes2.default.string.isRequired,
	  toggleCancelModal: _propTypes2.default.func.isRequired
	};
	
	exports.default = ReepayCard;

/***/ },
/* 2018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _qs = __webpack_require__(251);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = _themeSelector2.default.theme();
	
	var logoStyle = {
	  display: 'block',
	  margin: '50px auto 30px auto',
	  maxWidth: '100%'
	};
	
	var RegisterThanks = function RegisterThanks() {
	  console.log(window.location.search);
	  if (theme.tokenThanksRedirectUrl) {
	    console.log('TokenThanks', theme.tokenThanksRedirectUrl);
	    window.location = theme.tokenThanksRedirectUrl;
	  }
	
	  var qs = window.location.search;
	  var parsed = _qs2.default.parse(_lodash2.default.replace(qs, '?', ''));
	  var name = parsed.name,
	      email = parsed.email,
	      handle = parsed.handle;
	
	
	  var payload = {
	    data: {
	      profile: {
	        name: name,
	        email: email,
	        handle: handle
	      },
	      qs: qs
	    }
	  };
	  var client = _axios2.default.create({
	    baseURL: 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/notifyaccess2',
	    timeout: 2000,
	    headers: {
	      Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfbWV0YWRhdGEiOnsicm9sZXMiOlsidXNlciJdLCJkeXppbyI6eyJ1X2lkIjoiZGVhNDVhMmMtYWQ0MS00OGQ2LWIxYjQtOGFlZjQ1NjZjNGZiIiwibmFtZSI6IkRhbiBDYW50aXIiLCJlbWFpbCI6ImRhbi5jYW50aXJAYXRvbWF0ZS5uZXQiLCJvX2lkIjoiZjE0ZDM5MzEtMGU2YS00MmU4LWFkM2MtYWUyZmYwN2UzZDk2Iiwicm9sZSI6IlRFQU1fTUVNQkVSIiwidmVyc2lvbiI6MX19LCJpc3MiOiJodHRwczovL2R5emlvLmV1LmF1dGgwLmNvbS8iLCJzdWIiOiJhdXRoMHw1OGI1NmMxYmIzM2M1NTQ2Nzg3YWE0NTYiLCJhdWQiOiJNeHVFWmthWHF1Wm5sSmVMOW9FOFFoeVF6aE10amZUcCIsImlhdCI6MTUwOTcwNzU2NCwiZXhwIjoxNTA5NzQzNTY0fQ.sIKlNtois5uMAKWrGD4tsfiNtT7JsqSnamFVRmRFXmg'
	    }
	  });
	
	  client.post('/', payload).catch(function (err) {
	    return console.log(err.message);
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'page' },
	    _react2.default.createElement(
	      'div',
	      { className: 'page-content' },
	      _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: 'red', width: '90%', margin: 'auto', borderRadius: '10px' } },
	        _react2.default.createElement(
	          'a',
	          { href: '/' },
	          _react2.default.createElement('img', { style: logoStyle, src: 'https://caffeinebullet.com/cdn/shop/files/Caffeine-Bullet-Landscape-White-Logo.png?v=1694455373', alt: theme.darkLogo.alt })
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { container: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer', computer: '3' }),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { computer: '10', mobile: '16' },
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { textAlign: 'center', size: '' },
	              !theme.tokenThanksMessage && _react2.default.createElement(
	                'h1',
	                { style: { textAlign: 'center' } },
	                name && _react2.default.createElement(
	                  'div',
	                  null,
	                  'Hi ',
	                  name,
	                  '!'
	                ),
	                'Thanks for getting back to us!'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We can\'t wait to get started...'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We will send out an email (to the address below) with your free gift code in the next couple of days.'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { basic: true, color: 'red' },
	                  email
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Please keep an eye out for emails from ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'caffeinebullet@shopfluence.app'
	                ),
	                '.'
	              ),
	              theme.tokenThanksMessage && _react2.default.createElement(
	                'h1',
	                { style: { textAlign: 'center' } },
	                theme.tokenThanksMessage
	              ),
	              !theme.tokenThanksMessage && _react2.default.createElement(_semanticUiReact.Divider, null),
	              !theme.tokenThanksMessage && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  { className: 'info' },
	                  'Our support team will be in touch if there are any issues.'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'info' },
	                  'Or you can get in touch by email at ',
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'at', color: 'red' }),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:caffeinebullet@shopfluence.app' },
	                    'caffeinebullet@shopfluence.app'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer', computer: '3' })
	      )
	    )
	  );
	};
	
	exports.default = (0, _recompose.compose)()(RegisterThanks);

/***/ },
/* 2019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Removable = function (_React$Component) {
	  _inherits(Removable, _React$Component);
	
	  function Removable(props) {
	    _classCallCheck(this, Removable);
	
	    var _this = _possibleConstructorReturn(this, (Removable.__proto__ || Object.getPrototypeOf(Removable)).call(this, props));
	
	    _this.handleAllClickEvents = function (e) {
	      if (e.resourceDeleteEvent) {
	        _this.remove();
	      }
	    };
	
	    _this.state = {
	      className: 'removable-initial'
	    };
	    return _this;
	  }
	
	  _createClass(Removable, [{
	    key: 'remove',
	    value: function remove() {
	      var _this2 = this;
	
	      this.setState({
	        className: 'removable-removing'
	      });
	
	      setTimeout(function () {
	        _this2.setState({ className: 'removable-removed' });
	      }, 1500);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.state.className, onClick: this.handleAllClickEvents },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Removable;
	}(_react2.default.Component);
	
	Removable.propTypes = {
	  children: _propTypes2.default.element.isRequired
	};
	
	exports.default = Removable;

/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputProps = {
	  placeholder: 'New campaign...'
	};
	var centerText = {
	  textAlign: 'center'
	};
	var RollForwardModal = function RollForwardModal(_ref) {
	  var onClose = _ref.onClose,
	      selected = _ref.selected,
	      searchHandler = _ref.searchHandler,
	      selectedHandler = _ref.selectedHandler,
	      options = _ref.options,
	      loading = _ref.loading,
	      searched = _ref.searched,
	      yepButtonHandler = _ref.yepButtonHandler,
	      isRolling = _ref.isRolling;
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    { open: true, onClose: onClose, size: 'small' },
	    _react2.default.createElement(_dyzioModal.DyzioModalHeader, { headerText: 'Influencer Roll Forward', onClose: onClose }),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      { style: centerText },
	      _react2.default.createElement(_semanticUiReact.Search, {
	        fluid: true,
	        className: 'full-width',
	        input: inputProps,
	        loading: loading,
	        showNoResults: searched,
	        minCharacters: 3,
	        results: options,
	        onSearchChange: searchHandler,
	        onResultSelect: selectedHandler
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Message,
	        null,
	        selected && 'Roll influencer forward to ' + selected.title || 'Please choose new campaign above'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Actions,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        { color: 'pink', onClick: onClose },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
	        'Cancel'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        { color: 'green', disabled: !selected, onClick: yepButtonHandler, loading: isRolling },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
	        'Yep'
	      )
	    )
	  );
	};
	
	RollForwardModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  loading: _propTypes2.default.bool.isRequired,
	  selected: _propTypes2.default.object.isRequired,
	  searchHandler: _propTypes2.default.func.isRequired,
	  yepButtonHandler: _propTypes2.default.func.isRequired,
	  options: _propTypes2.default.array.isRequired,
	  selectedHandler: _propTypes2.default.func.isRequired,
	  searched: _propTypes2.default.bool.isRequired,
	  isRolling: _propTypes2.default.bool.isRequired
	};
	
	exports.default = RollForwardModal;

/***/ },
/* 2021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _eventFeed = __webpack_require__(230);
	
	var _eventFeed2 = _interopRequireDefault(_eventFeed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScanHistoryModal = function ScanHistoryModal(_ref) {
	  var discussionId = _ref.discussionId,
	      onClose = _ref.onClose;
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    { open: true, onClose: onClose },
	    _react2.default.createElement(_dyzioModal.DyzioModalHeader, { headerText: 'Scan history', onClose: onClose }),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      _react2.default.createElement(_eventFeed2.default, {
	        title: 'Feed',
	        description: 'collaboration events',
	        feedType: 'COLLABORATION',
	        discussionId: discussionId,
	        viewMode: 'TABLE',
	        isCompact: true
	      })
	    )
	  );
	};
	
	ScanHistoryModal.propTypes = {
	  discussionId: _propTypes2.default.string.isRequired,
	  onClose: _propTypes2.default.func.isRequired
	};
	
	exports.default = ScanHistoryModal;

/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScanNowModal = function ScanNowModal(_ref) {
	  var onClose = _ref.onClose;
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    { open: true, onClose: onClose, size: 'small' },
	    _react2.default.createElement(_dyzioModal.DyzioModalHeader, { headerText: 'Scanning Now...', onClose: onClose }),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'h5',
	        null,
	        'The system is scanning all channels now, It takes about 30 seconds!'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { padding: 30 } },
	        _react2.default.createElement(_semanticUiReact.Icon, { size: 'massive', name: 'circle notched', loading: true, color: 'blue' })
	      ),
	      _react2.default.createElement(
	        'h5',
	        null,
	        'Thanks for your patience!'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'This window will close when the scan is complete.'
	      )
	    )
	  );
	};
	
	ScanNowModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired
	};
	
	exports.default = ScanNowModal;

/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var messageStyles = {
	  width: '100%'
	};
	
	var ShopifyConnectionModal = function (_Component) {
	  _inherits(ShopifyConnectionModal, _Component);
	
	  function ShopifyConnectionModal(props) {
	    _classCallCheck(this, ShopifyConnectionModal);
	
	    var _this = _possibleConstructorReturn(this, (ShopifyConnectionModal.__proto__ || Object.getPrototypeOf(ShopifyConnectionModal)).call(this, props));
	
	    _this.onInputChanged = function (event, _ref) {
	      var name = _ref.name,
	          value = _ref.value,
	          checked = _ref.checked;
	
	      _this.setState(_defineProperty({}, name, value || checked));
	    };
	
	    _this.handleFormSubmit = function (e) {
	      e.preventDefault();
	      var onSubmit = _this.props.onSubmit;
	
	
	      _this.setState({ error: null });
	      var _this$state = _this.state,
	          shopifyAccessToken = _this$state.shopifyAccessToken,
	          shopifyShopUrl = _this$state.shopifyShopUrl;
	
	
	      var payload = {
	        shopifyAccessToken: shopifyAccessToken,
	        shopifyShopUrl: shopifyShopUrl
	      };
	
	      var errors = _lodash2.default.reduce(_lodash2.default.keys(payload), function (acc, key) {
	        var value = payload[key];
	        var isValid = !_lodash2.default.isEmpty(value); // TODO: Implement validation
	        if (!isValid) {
	          acc[key] = 'Field is required';
	        }
	        return acc;
	      }, {});
	      _this.setState({ errors: errors });
	
	      var isValid = _lodash2.default.isEmpty(errors);
	      if (isValid) {
	        onSubmit(payload);
	      }
	    };
	
	    _this.state = _extends({
	      errors: {}
	    }, _lodash2.default.get(props, 'connection', {}));
	    return _this;
	  }
	
	  _createClass(ShopifyConnectionModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onClose = _props.onClose,
	          isSubmitting = _props.isSubmitting,
	          error = _props.error;
	      var _state = this.state,
	          shopifyAccessToken = _state.shopifyAccessToken,
	          shopifyShopUrl = _state.shopifyShopUrl,
	          errors = _state.errors;
	
	      var errorMessage = !_lodash2.default.isEmpty(error) && _lodash2.default.isString(error) ? error : 'Something went wrong. Please try again later.';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _dyzioModal2.default,
	          { headerText: 'Shopify connection', size: 'small', onClose: onClose },
	          _react2.default.createElement(
	            'div',
	            null,
	            error && _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  display: 'flex',
	                  justifyContent: 'center'
	                }
	              },
	              _react2.default.createElement(_semanticUiReact.Message, {
	                fluid: true,
	                style: messageStyles,
	                icon: 'frown',
	                error: true,
	                header: 'Error',
	                content: errorMessage
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Form,
	              { onSubmit: this.handleFormSubmit },
	              _react2.default.createElement(
	                'div',
	                { style: { maxHeight: '70vh', overflow: 'auto', margin: '1.5rem' } },
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'shopifyAccessToken' },
	                    'Access Token'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'shopifyAccessToken')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Shopify Access Token',
	                    name: 'shopifyAccessToken',
	                    id: 'shopifyAccessToken',
	                    value: shopifyAccessToken || ''
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Field,
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'shopifyShopUrl' },
	                    'Shop Url'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Form.Input, {
	                    error: Boolean(_lodash2.default.get(errors, 'shopifyShopUrl')),
	                    onChange: this.onInputChanged,
	                    placeholder: 'Shopify Shop Url',
	                    id: 'shopifyShopUrl',
	                    name: 'shopifyShopUrl',
	                    value: shopifyShopUrl || ''
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'flex',
	                  style: {
	                    justifyContent: 'flex-end',
	                    padding: '10px 0px 10px 0px'
	                  }
	                },
	                _react2.default.createElement(
	                  _semanticUiReact.Form.Button,
	                  {
	                    loading: isSubmitting,
	                    disabled: isSubmitting,
	                    color: 'pink',
	                    type: 'submit',
	                    size: 'medium'
	                  },
	                  'Submit'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShopifyConnectionModal;
	}(_react.Component);
	
	ShopifyConnectionModal.propTypes = {
	  onClose: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  isSubmitting: _propTypes2.default.bool,
	  error: _propTypes2.default.any
	};
	ShopifyConnectionModal.defaultProps = {
	  onClose: _lodash2.default.noop,
	  onSubmit: _lodash2.default.noop,
	  isSubmitting: false,
	  error: null
	};
	exports.default = ShopifyConnectionModal;

/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _shopifyConnectionModal = __webpack_require__(2023);
	
	var _shopifyConnectionModal2 = _interopRequireDefault(_shopifyConnectionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var btnStyle = { marginTop: '10px' };
	var labelStyle = { marginTop: '10px', marginBottom: '10px' };
	
	var ShopifyConnectionSettings = function (_Component) {
	  _inherits(ShopifyConnectionSettings, _Component);
	
	  function ShopifyConnectionSettings(props) {
	    _classCallCheck(this, ShopifyConnectionSettings);
	
	    var _this = _possibleConstructorReturn(this, (ShopifyConnectionSettings.__proto__ || Object.getPrototypeOf(ShopifyConnectionSettings)).call(this, props));
	
	    _this.openModal = function () {
	      _this.setState({ modalOpen: true });
	    };
	
	    _this.closeModal = function () {
	      _this.setState({ modalOpen: false, error: null });
	    };
	
	    _this.onConnect = function (payload) {
	      _this.setState({ isSubmitting: true });
	
	      var organisation = _this.props.organisation;
	
	
	      _this.client.post('/organisations/' + organisation.id + '/ecommerceSettings', {
	        ecommerceSettings: payload
	      }).then(function (_ref) {
	        var data = _ref.data;
	        return data;
	      }).then(function (response) {
	        var isError = _lodash2.default.get(response, 'statusCode') !== 200;
	        var errorMessage = _lodash2.default.get(response, 'data.message');
	        _this.setState(function (prev) {
	          return { error: isError ? errorMessage : null, modalOpen: isError ? prev.modalOpen : false };
	        });
	        if (!isError) {
	          var fetchOrganisation = _this.props.fetchOrganisation;
	
	          fetchOrganisation();
	        }
	      }).catch(function (error) {
	        _this.setState({ error: error });
	      }).finally(function () {
	        _this.setState({ isSubmitting: false });
	      });
	    };
	
	    _this.onDisconnect = function () {
	      _this.setState({ isSubmitting: true });
	      var organisation = _this.props.organisation;
	
	      _this.client.delete('/organisations/' + organisation.id + '/ecommerceSettings').then(function () {
	        var fetchOrganisation = _this.props.fetchOrganisation;
	
	        fetchOrganisation();
	      }).catch(function (error) {
	        _this.setState({ error: error });
	      }).finally(function () {
	        _this.setState({ isSubmitting: false });
	      });
	    };
	
	    _this.state = {
	      modalOpen: false,
	      isSubmitting: false
	    };
	
	    _this.client = _axios2.default.create({
	      baseURL: ("https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production")
	    });
	    return _this;
	  }
	
	  _createClass(ShopifyConnectionSettings, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          modalOpen = _state.modalOpen,
	          isSubmitting = _state.isSubmitting,
	          error = _state.error;
	      var organisation = this.props.organisation;
	
	      var ecommerceSettings = _lodash2.default.get(organisation, 'ecommerceSettings');
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: true },
	        _react2.default.createElement(_semanticUiReact.Card.Content, { header: 'Ecommerce Settings' }),
	        modalOpen && _react2.default.createElement(_shopifyConnectionModal2.default, {
	          onClose: this.closeModal,
	          onSubmit: this.onConnect,
	          isSubmitting: isSubmitting,
	          error: error
	        }),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          !ecommerceSettings && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h5',
	              null,
	              ' There is no connection yet'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(_semanticUiReact.Button, {
	              loading: isSubmitting,
	              disabled: isSubmitting,
	              style: btnStyle,
	              color: 'pink',
	              icon: 'edit',
	              fluid: true,
	              onClick: this.openModal,
	              labelPosition: 'left',
	              content: 'Add connection'
	            })
	          ),
	          ecommerceSettings && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _lodash2.default.get(organisation, 'name', ''),
	              ' is linked to this Ads Manager account.'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	            _react2.default.createElement(
	              _semanticUiReact.Label,
	              { size: 'large', style: labelStyle },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'shopping bag', color: 'green' }),
	              ecommerceSettings.shopifyShopUrl,
	              _react2.default.createElement(
	                _semanticUiReact.Label.Detail,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'green' })
	              )
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(_semanticUiReact.Button, {
	              loading: isSubmitting,
	              disabled: isSubmitting,
	              style: btnStyle,
	              color: 'orange',
	              icon: 'trash',
	              fluid: true,
	              inverted: true,
	              onClick: this.onDisconnect,
	              labelPosition: 'left',
	              content: 'Disconnect'
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShopifyConnectionSettings;
	}(_react.Component);
	
	ShopifyConnectionSettings.propTypes = {
	  organisation: _propTypes2.default.object.isRequired,
	  fetchOrganisation: _propTypes2.default.func.isRequired
	};
	
	exports.default = ShopifyConnectionSettings;

/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioIcons = __webpack_require__(92);
	
	var _formatting = __webpack_require__(287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var iconStyle = {
	  height: '0.75em',
	  margin: '0 5px'
	};
	
	var ShortlistSummary = function ShortlistSummary(_ref) {
	  var influencerCount = _ref.influencerCount,
	      totalTwitter = _ref.totalTwitter,
	      totalInstagram = _ref.totalInstagram,
	      totalYoutube = _ref.totalYoutube,
	      totalFacebook = _ref.totalFacebook,
	      totalTwitch = _ref.totalTwitch,
	      totalTiktok = _ref.totalTiktok;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true, color: 'pink' },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        'Shortlist Summary'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Statistic.Group,
	        { widths: 7, size: 'tiny' },
	        _react2.default.createElement(
	          _semanticUiReact.Statistic,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Value,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'user', size: 'small', color: 'pink' }),
	            '\xA0',
	            (0, _formatting.sciFormatted)(influencerCount)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Label,
	            null,
	            'influencer' + (influencerCount === 1 ? '' : 's')
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Statistic,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Value,
	            null,
	            _react2.default.createElement(_dyzioIcons.InstagramIcon, { size: 'small', style: iconStyle }),
	            '\xA0',
	            (0, _formatting.sciFormatted)(totalInstagram)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Label,
	            null,
	            'Followers'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Statistic,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Value,
	            null,
	            _react2.default.createElement(_dyzioIcons.YoutubeIcon, { size: 'small', style: iconStyle }),
	            '\xA0',
	            (0, _formatting.sciFormatted)(totalYoutube)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Label,
	            null,
	            'Subscribers'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Statistic,
	          { color: '#3B5998' },
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Value,
	            null,
	            _react2.default.createElement(_dyzioIcons.FacebookIcon, { size: 'small', style: iconStyle }),
	            '\xA0',
	            (0, _formatting.sciFormatted)(totalFacebook)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Label,
	            null,
	            'Followers'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Statistic,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Value,
	            null,
	            _react2.default.createElement(_dyzioIcons.TwitterIcon, { size: 'small', style: iconStyle }),
	            (0, _formatting.sciFormatted)(totalTwitter)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Label,
	            null,
	            'Followers'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Statistic,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Value,
	            null,
	            _react2.default.createElement('img', { style: iconStyle, src: '/icons/tik-tok.svg', alt: 'Tiktok' }),
	            (0, _formatting.sciFormatted)(totalTiktok)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Label,
	            null,
	            'Followers'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Statistic,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Value,
	            null,
	            _react2.default.createElement(_dyzioIcons.TwitchIcon, { size: 'small', style: iconStyle }),
	            (0, _formatting.sciFormatted)(totalTwitch)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Label,
	            null,
	            'Followers'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true },
	      'showing total counts for all influencers across each platform'
	    )
	  );
	};
	
	ShortlistSummary.propTypes = {
	  influencerCount: _propTypes2.default.number.isRequired,
	  totalTwitter: _propTypes2.default.number.isRequired,
	  totalInstagram: _propTypes2.default.number.isRequired,
	  totalYoutube: _propTypes2.default.number.isRequired,
	  totalFacebook: _propTypes2.default.number.isRequired,
	  totalTwitch: _propTypes2.default.number.isRequired,
	  totalTiktok: _propTypes2.default.number.isRequired
	};
	
	exports.default = ShortlistSummary;

/***/ },
/* 2026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialBar = function SocialBar(_ref) {
	  var influencerId = _ref.influencerId,
	      data = _ref.data,
	      dataTotal = _ref.dataTotal;
	
	  var computeWidth = function computeWidth(dataItem) {
	    var amount = dataItem / dataTotal * 100;
	    return amount + '%';
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'social-bar' },
	      data.map(function (item) {
	        return _react2.default.createElement('div', {
	          className: 'line-item ' + item.channel,
	          style: { width: computeWidth(item.count) },
	          key: item.channel
	        });
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'social-bar-labels' },
	      data.map(function (item) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'label', key: item.channel },
	          _react2.default.createElement('img', { src: '/icons/' + item.channel + '.svg', alt: item.channel }),
	          _react2.default.createElement(
	            'p',
	            { className: 'small light' },
	            item.count > 0 ? (0, _numeral2.default)(item.count).format('0a') : '-'
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = SocialBar;

/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dividerStyle = {
	  height: 10,
	  width: '100%',
	  display: 'block'
	};
	
	var editorStyle = {
	  minWidth: 200,
	  padding: 5
	};
	
	var TagEditor = function (_React$Component) {
	  _inherits(TagEditor, _React$Component);
	
	  //
	  function TagEditor(props) {
	    _classCallCheck(this, TagEditor);
	
	    var _this = _possibleConstructorReturn(this, (TagEditor.__proto__ || Object.getPrototypeOf(TagEditor)).call(this, props));
	
	    _this.onInputChanged = function (event, _ref) {
	      var value = _ref.value;
	      return _this.setState({
	        value: value
	      });
	    };
	
	    _this.state = {
	      initialValue: props.value,
	      value: props.value
	    };
	    return _this;
	  }
	
	  _createClass(TagEditor, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          initialValue = _state.initialValue;
	      var _props = this.props,
	          onSave = _props.onSave,
	          onDelete = _props.onDelete,
	          id = _props.id;
	
	      var isDisabled = _lodash2.default.isEmpty(_lodash2.default.trim(value)) || _lodash2.default.eq(initialValue, value);
	      return _react2.default.createElement(
	        'div',
	        { style: editorStyle },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Edit tag'
	        ),
	        _react2.default.createElement('div', { style: dividerStyle }),
	        _react2.default.createElement(_semanticUiReact.Input, { fluid: true, value: value, onChange: this.onInputChanged }),
	        _react2.default.createElement('div', { style: dividerStyle }),
	        _react2.default.createElement(
	          _semanticUiReact.Button.Group,
	          { widths: 'two' },
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { color: 'grey', onClick: function onClick() {
	                return onDelete(id);
	              } },
	            'Delete'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            {
	              disabled: isDisabled,
	              color: 'pink',
	              onClick: function onClick() {
	                return onSave(id, value);
	              }
	            },
	            'Save'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TagEditor;
	}(_react2.default.Component);
	
	TagEditor.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.string.isRequired,
	  onSave: _propTypes2.default.func.isRequired,
	  onDelete: _propTypes2.default.func.isRequired
	};
	
	exports.default = TagEditor;

/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keywordExtractor = __webpack_require__(2959);
	
	var _keywordExtractor2 = _interopRequireDefault(_keywordExtractor);
	
	var _reactTagcloud = __webpack_require__(3531);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _badWords = __webpack_require__(2405);
	
	var _badWords2 = _interopRequireDefault(_badWords);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tags = function (_React$Component) {
	  _inherits(Tags, _React$Component);
	
	  function Tags(props, context) {
	    _classCallCheck(this, Tags);
	
	    var _this = _possibleConstructorReturn(this, (Tags.__proto__ || Object.getPrototypeOf(Tags)).call(this, props, context));
	
	    _this.occurenceCount = function (resultArray) {
	      resultArray.sort();
	      var countResult = [];
	      var current = null;
	      var count = 0;
	      for (var i = 0; i < resultArray.length; i++) {
	        if (resultArray[i] != current) {
	          if (count > 0) {
	            var result = {
	              value: current,
	              count: count
	            };
	            countResult.push(result);
	          }
	          current = resultArray[i];
	          count = 1;
	        } else {
	          count++;
	        }
	      }
	      if (count > 0) {
	        var _result = {
	          value: current,
	          count: count
	        };
	        countResult.push(_result);
	      }
	      return countResult;
	    };
	
	    _this.extractionResult = function (comments) {
	      var resultArray = [];
	      var profanityFilter = new _badWords2.default({ placeHolder: '/' });
	
	      for (var i = 0, itemsLength = comments.items.length; i < itemsLength; i++) {
	        var extractedItems = _keywordExtractor2.default.extract(comments.items[i].snippet.topLevelComment.snippet.textOriginal, {
	          language: 'english',
	          remove_digits: true,
	          return_changed_case: true,
	          remove_duplicates: false
	        });
	
	        for (var t = 0, extractedLength = extractedItems.length; t < extractedLength; t++) {
	          var item = extractedItems[t];
	          var itemCleaned = profanityFilter.clean(item);
	          var itemDecluttered = itemCleaned.replace(/[^A-Za-z;]/g, '');
	
	          if (itemDecluttered.length > 3 && itemDecluttered.length < 30) {
	            resultArray.push(itemDecluttered);
	          }
	        }
	      }
	      var tagArray = _this.occurenceCount(resultArray);
	      var sortedArray = tagArray.sort(function (a, b) {
	        return b.count > b.count ? 1 : a.count > b.count ? -1 : 0;
	      });
	      _this.setState({ tags: tagArray.slice(0, 40) });
	    };
	
	    _this.state = {
	      tags: []
	    };
	    return _this;
	  }
	
	  _createClass(Tags, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _axios2.default.get('https://www.googleapis.com/youtube/v3/commentThreads', {
	        params: {
	          part: 'snippet',
	          videoId: this.props.youtubeVideoId,
	          maxResults: 100,
	          key: ("AIzaSyDICIztgMz-QFiL9BrPTOW5ISDSbcDQEUc")
	        }
	      }).then(function (response) {
	        var comments = response.data;
	        _this2.extractionResult(comments);
	      }).catch(function (error) {
	        (0, _errorHandlingService.reportError)('LOAD_TAG_CLOUD_ERROR', error.message);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.state.tags;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.tags.length > 0 && _react2.default.createElement(_reactTagcloud.TagCloud, {
	          minSize: 16,
	          maxSize: 36,
	          tags: data,
	          className: 'tag-cloud'
	        })
	      );
	    }
	  }]);
	
	  return Tags;
	}(_react2.default.Component);
	
	exports.default = Tags;

/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _avatar = __webpack_require__(191);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var wrapperStyles = {
	  marginBottom: 30
	};
	
	var tableStyles = {
	  height: '400px',
	  overflow: 'scroll',
	  borderBottom: 'solid 1px #d8d8d8'
	};
	
	var TeamTable = function (_Component) {
	  _inherits(TeamTable, _Component);
	
	  function TeamTable() {
	    _classCallCheck(this, TeamTable);
	
	    var _this = _possibleConstructorReturn(this, (TeamTable.__proto__ || Object.getPrototypeOf(TeamTable)).call(this));
	
	    _this.getInvitationButton = function (members, pending, influencer) {
	      var invited = _this.state.invited;
	      var invitedEmails = _lodash2.default.map(invited, 'email');
	      var membersAndPendingAndInvited = _lodash2.default.concat(members, pending, invitedEmails);
	
	      if (_lodash2.default.includes(membersAndPendingAndInvited, influencer.email)) {
	        return _react2.default.createElement(
	          _semanticUiReact.Button,
	          { fluid: true, basic: true, disabled: true, color: 'green' },
	          'invited'
	        );
	      }
	
	      return _react2.default.createElement(
	        _semanticUiReact.Button,
	        { fluid: true, color: 'green', onClick: _this.localInvite, value: influencer },
	        'invite'
	      );
	    };
	
	    _this.getAddButton = function (members, pending, influencer) {
	      var invited = _this.state.invited;
	      var invitedEmails = _lodash2.default.map(invited, 'email');
	      var membersAndPendingAndInvited = _lodash2.default.concat(members, pending, invitedEmails);
	
	      if (_lodash2.default.includes(membersAndPendingAndInvited, influencer.email)) {
	        return _react2.default.createElement(
	          _semanticUiReact.Button,
	          { fluid: true, basic: true, disabled: true, color: 'blue' },
	          'added'
	        );
	      }
	
	      return _react2.default.createElement(
	        _semanticUiReact.Button,
	        { color: 'blue', fluid: true, onClick: _this.localAdd, value: influencer },
	        'add'
	      );
	    };
	
	    _this.getCampaignInvitationFromInput = function (input) {
	      return {
	        email: input.email,
	        name: input.name,
	        role: 'TEAM_MEMBER',
	        id: input.id
	      };
	    };
	
	    _this.localInvite = function (e, _ref) {
	      var name = _ref.name,
	          value = _ref.value;
	
	      var invited = _this.state.invited;
	      var invitation = _this.getCampaignInvitationFromInput(value);
	      invited.push(invitation);
	      _this.setState({
	        invited: invited
	      });
	      _this.props.onInvite(invitation);
	    };
	
	    _this.localAdd = function (e, _ref2) {
	      var name = _ref2.name,
	          value = _ref2.value;
	
	      var invited = _this.state.invited;
	      var invitation = _this.getCampaignInvitationFromInput(value);
	      invited.push(invitation);
	      _this.setState({
	        invited: invited
	      });
	      _this.props.onAdd(invitation);
	    };
	
	    _this.state = {
	      invited: []
	    };
	    return _this;
	  }
	
	  _createClass(TeamTable, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          campaign = _props.campaign,
	          team = _props.team,
	          visible = _props.visible,
	          organisationName = _props.organisationName,
	          onSearchChange = _props.onSearchChange;
	      var invited = this.state.invited;
	
	      var displayStyle = visible ? {} : { display: 'none' };
	
	      var memberEmails = campaign ? _lodash2.default.map(campaign.members, 'email') : [];
	      var pendingEmails = campaign ? _lodash2.default.map(campaign.pendingInvitations, 'email') : [];
	
	      return _react2.default.createElement(
	        'div',
	        { style: displayStyle },
	        _react2.default.createElement(
	          'div',
	          { style: wrapperStyles },
	          _react2.default.createElement(
	            _semanticUiReact.Card,
	            { fluid: true },
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Use add to add your Team Member directly - no email notification will be sent.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Use invite to send an email invitation (which they must accept).'
	              )
	            )
	          ),
	          _react2.default.createElement(_semanticUiReact.Input, {
	            fluid: true,
	            icon: 'search',
	            placeholder: 'Search My Team',
	            iconPosition: 'left',
	            onChange: onSearchChange
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: tableStyles },
	            visible && _react2.default.createElement(
	              _semanticUiReact.Table,
	              { unstackable: true },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Header,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { colSpan: 2 },
	                    'Name'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'Organisation'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'Email'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center' },
	                    'Action'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { textAlign: 'center' },
	                    'Action'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                team && _lodash2.default.map(team, function (member) {
	                  return _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    { key: member.id },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      { collapsing: true },
	                      _react2.default.createElement(_avatar2.default, { plain: true, name: member.name, size: 44 })
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      member.name
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      organisationName
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      member.email
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      { collapsing: true },
	                      _this2.getAddButton(memberEmails, pendingEmails, member)
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      { collapsing: true },
	                      _this2.getInvitationButton(memberEmails, pendingEmails, member)
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamTable;
	}(_react.Component);
	
	exports.default = TeamTable;

/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _modal = __webpack_require__(103);
	
	var _staticConfiguration = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Timeline = function (_React$Component) {
	  _inherits(Timeline, _React$Component);
	
	  function Timeline(props, context) {
	    _classCallCheck(this, Timeline);
	
	    var _this = _possibleConstructorReturn(this, (Timeline.__proto__ || Object.getPrototypeOf(Timeline)).call(this, props, context));
	
	    _this.onShowModal = function (docType) {
	      return function () {
	        _this.props.onSetModal(docType);
	      };
	    };
	
	    _this.onToggleAnalytics = function () {
	      _this.setState({ analyticsVisible: !_this.state.analyticsVisible });
	    };
	
	    _this.state = {
	      vertical: _this.props.vertical,
	      analyticsVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Timeline, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          deliverableStatus = _props.deliverableStatus,
	          docsStatus = _props.docsStatus,
	          isUserTeamMember = _props.isUserTeamMember,
	          setMainView = _props.setMainView,
	          analyticsHack = _props.analyticsHack,
	          myUserRole = _props.myUserRole,
	          campaignId = _props.campaignId;
	
	
	      var briefStateImages = {
	        incomplete: isUserTeamMember ? _react2.default.createElement('img', { src: '/icons/incomplete.svg', alt: 'incomplete' }) : _react2.default.createElement('img', { src: '/icons/pending.svg', alt: 'pending' }),
	        pending: _react2.default.createElement('img', { src: '/icons/added.svg', alt: 'added' }),
	        complete: _react2.default.createElement('img', { src: '/icons/complete.svg', alt: 'complete' })
	      };
	
	      var contractStateImages = {
	        incomplete: isUserTeamMember || docsStatus.brief !== 'complete' ? _react2.default.createElement('img', { src: '/icons/incomplete.svg', alt: 'incomplete' }) : _react2.default.createElement('img', { src: '/icons/pending.svg', alt: 'pending' }),
	        pending: _react2.default.createElement('img', { src: '/icons/added.svg', alt: 'added' }),
	        complete: _react2.default.createElement('img', { src: '/icons/complete.svg', alt: 'complete' })
	      };
	
	      var deliverableSetStateImages = {
	        incomplete: isUserTeamMember || docsStatus.contract !== 'complete' ? _react2.default.createElement('img', { src: '/icons/incomplete.svg', alt: 'incomplete' }) : _react2.default.createElement('img', { src: '/icons/pending.svg', alt: 'pending' }),
	        pending: _react2.default.createElement('img', { src: '/icons/arrow.svg', alt: 'arrow' }),
	        complete: _react2.default.createElement('img', { src: '/icons/arrow-seagreen.svg', alt: 'complete' })
	      };
	
	      var deliverableAddedStateImages = {
	        incomplete: _react2.default.createElement('img', { src: '/icons/incomplete.svg', alt: 'incomplete' }),
	        pending: isUserTeamMember || !deliverableStatus.set ? _react2.default.createElement('img', { src: '/icons/added.svg', alt: 'added' }) : _react2.default.createElement('img', { src: '/icons/incomplete.svg', alt: 'incomplete' }),
	        complete: deliverableStatus.added === deliverableStatus.approved ? _react2.default.createElement('img', { src: '/icons/added-seagreen.svg', alt: 'complete' }) : _react2.default.createElement('img', { src: '/icons/added.svg', alt: 'added' })
	      };
	
	      var deliverableApprovedStateImages = {
	        incomplete: _react2.default.createElement('img', { src: '/icons/incomplete.svg', alt: 'incomplete' }),
	        pending: isUserTeamMember || !deliverableStatus.added ? _react2.default.createElement('img', { src: '/icons/incomplete.svg', alt: 'incomplete' }) : _react2.default.createElement('img', { src: '/icons/pending.svg', alt: 'pending' }),
	        complete: _react2.default.createElement('img', { src: '/icons/arrow-seagreen.svg', alt: 'complete' })
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.vertical && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'table',
	            { className: 'timeline vertical' },
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'fixed' },
	                  briefStateImages[docsStatus.brief]
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'timeline-item-wrapper' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'bold' },
	                      'Brief '
	                    ),
	                    docsStatus.brief !== 'incomplete' && _react2.default.createElement(
	                      'button',
	                      { className: 'small', onClick: setMainView('brief') },
	                      'view'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'line fixed' },
	                  _react2.default.createElement('div', { className: 'timeline-line short' })
	                ),
	                _react2.default.createElement('td', null)
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'fixed' },
	                  contractStateImages[docsStatus.contract]
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'timeline-item-wrapper' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'bold' },
	                      'Contract '
	                    ),
	                    docsStatus.contract === 'complete' && _react2.default.createElement(
	                      'button',
	                      { className: 'small', onClick: setMainView('contract') },
	                      'view'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'line fixed' },
	                  _react2.default.createElement('div', { className: 'timeline-line short' })
	                ),
	                _react2.default.createElement('td', null)
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'fixed' },
	                  deliverableSetStateImages[deliverableStatus.setStatus]
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'timeline-item-wrapper' },
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'bold' },
	                        'Deliverables (',
	                        deliverableStatus.set,
	                        ')'
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'small', onClick: setMainView('deliverables') },
	                        'view'
	                      )
	                    )
	                  )
	                )
	              ),
	              deliverableStatus.set > 0 && _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'line fixed' },
	                  deliverableStatus.approved > 0 && isUserTeamMember && _react2.default.createElement('div', { className: 'timeline-line long' })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement('div', { className: 'spacer small' }),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'small light' },
	                    'Added (',
	                    deliverableStatus.added,
	                    ')\xA0\xA0Approved (',
	                    deliverableStatus.approved,
	                    ')'
	                  )
	                )
	              ),
	              deliverableStatus.approved > 0 && isUserTeamMember && _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { className: 'fixed' },
	                  _react2.default.createElement('img', { src: '/icons/lightning-blue.svg', alt: 'live' })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'timeline-item-wrapper' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'bold' },
	                      'Live'
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'small', onClick: function onClick() {
	                          return _this2.context.router.push('/campaign/' + campaignId + '?analytics');
	                        } },
	                      'view'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        !this.state.vertical && _react2.default.createElement(
	          'div',
	          { className: 'timeline' },
	          _react2.default.createElement(
	            'div',
	            { className: 'item' },
	            briefStateImages[docsStatus.brief],
	            _react2.default.createElement(
	              'span',
	              null,
	              '\xA0Brief\xA0'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item' },
	            contractStateImages[docsStatus.contract],
	            _react2.default.createElement(
	              'span',
	              null,
	              '\xA0Contract\xA0'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item' },
	            deliverableSetStateImages[deliverableStatus.setStatus],
	            _react2.default.createElement(
	              'span',
	              null,
	              '\xA0Deliverables\xA0'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Timeline;
	}(_react2.default.Component);
	
	Timeline.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	Timeline.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onSetModal: function onSetModal(modalName) {
	      return dispatch((0, _modal.setModal)(modalName));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Timeline);

/***/ },
/* 2031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var extraStyle = {
	  color: '#c71f7e'
	};
	
	var textCentered = {
	  textAlign: 'center'
	};
	
	var Account = function Account(_ref) {
	  var id = _ref.id,
	      name = _ref.name,
	      username = _ref.username,
	      profilePictureUrl = _ref.profile_picture_url,
	      followersCount = _ref.followers_count,
	      _onClick = _ref.onClick;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { style: textCentered, onClick: function onClick() {
	        return _onClick(id);
	      } },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(_semanticUiReact.Image, { src: profilePictureUrl, size: 'small', className: 'circular' }),
	      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        name
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Meta,
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          '@',
	          username
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true },
	      _react2.default.createElement(
	        'a',
	        { style: extraStyle },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'user' }),
	        (0, _formatting.commaFormatted)(followersCount),
	        ' followers'
	      )
	    )
	  );
	};
	
	Account.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  username: _propTypes2.default.string.isRequired,
	  profile_picture_url: _propTypes2.default.string.isRequired,
	  followers_count: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = Account;

/***/ },
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var textCenter = {
	  textAlign: 'center'
	};
	
	var noShadowStyle = {
	  boxShadow: 'none'
	};
	
	var loadingStyle = {
	  minHeight: 212,
	  textAlign: 'center',
	  paddingTop: 61,
	  color: 'gray'
	};
	
	var buttonStyle = {
	  minWidth: 220,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var ITEMS_PER_ROW = 3;
	
	var TokenMediaModal = function (_Component) {
	  _inherits(TokenMediaModal, _Component);
	
	  function TokenMediaModal() {
	    _classCallCheck(this, TokenMediaModal);
	
	    var _this = _possibleConstructorReturn(this, (TokenMediaModal.__proto__ || Object.getPrototypeOf(TokenMediaModal)).call(this));
	
	    _this.state = {
	      isLoading: true,
	      media: [],
	      isError: false
	    };
	    // this.axiosCancelSource = axios.CancelToken.source();
	    return _this;
	  }
	
	  _createClass(TokenMediaModal, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _props, oauthResponseId, accountId, oauthTokenAPIClient, response, data;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props, oauthResponseId = _props.oauthResponseId, accountId = _props.accountId, oauthTokenAPIClient = _props.oauthTokenAPIClient;
	                _context.next = 3;
	                return oauthTokenAPIClient.get('oauthresponse/media/' + oauthResponseId + '/' + accountId).catch(function (err) {
	                  console.log(err);
	                });
	
	              case 3:
	                response = _context.sent;
	
	
	                if (response) {
	                  data = response.data;
	
	                  console.log(data);
	                  this.setState({
	                    isLoading: false,
	                    media: data,
	                    isError: false
	                  });
	                }
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // todo TEST THE DEMOGRAPHICS
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          onClose = _props2.onClose,
	          onConfirm = _props2.onConfirm,
	          accountId = _props2.accountId,
	          oauthResponseId = _props2.oauthResponseId,
	          tokenConfirmationInProgress = _props2.tokenConfirmationInProgress;
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          isError = _state.isError,
	          media = _state.media;
	
	      var modalStyle = { minHeight: 450 };
	      var noMedia = _lodash2.default.isEmpty(media);
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        {
	          open: true,
	          onClose: onClose,
	          closeOnDimmerClick: true,
	          size: 'large',
	          closeOnDocumentClick: true
	        },
	        _react2.default.createElement(_dyzioModal.DyzioModalHeader, { headerText: 'Your last 3 posts...' }),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          { style: modalStyle },
	          isLoading && _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { style: loadingStyle },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', loading: true, size: 'huge' }),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Loading'
	            )
	          ),
	          !isLoading && noMedia && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Message,
	              { warning: true, style: textCenter },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'frown', size: 'huge' }),
	              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	              'Something does not look right\u2026',
	              _react2.default.createElement('br', null),
	              'we could not load any media for this account.'
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              { style: buttonStyle, onClick: onClose },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'close' }),
	              'Close'
	            )
	          ),
	          !isLoading && !isError && !_lodash2.default.isEmpty(media) && _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center' } },
	            _react2.default.createElement(
	              _semanticUiReact.Card.Group,
	              { itemsPerRow: ITEMS_PER_ROW },
	              _lodash2.default.map(_lodash2.default.take(media, ITEMS_PER_ROW), function (item) {
	                return _react2.default.createElement(
	                  _semanticUiReact.Card,
	                  { style: noShadowStyle },
	                  _react2.default.createElement(_semanticUiReact.Image, {
	                    src: item.media_url
	                  })
	                );
	              })
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	              disabled: tokenConfirmationInProgress,
	              onClick: function onClick() {
	                return onConfirm({
	                  accountId: accountId,
	                  oauthResponseId: oauthResponseId
	                });
	              },
	              size: 'large',
	              label: 'Confirm Account',
	              hasIcon: true,
	              icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'check' }),
	              floated: false
	            })
	          ),
	          !isLoading && isError && _react2.default.createElement(
	            'div',
	            null,
	            'bad token'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TokenMediaModal;
	}(_react.Component);
	
	TokenMediaModal.propTypes = {
	  accountId: _propTypes2.default.string.isRequired,
	  oauthResponseId: _propTypes2.default.string.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  onConfirm: _propTypes2.default.func.isRequired,
	  tokenConfirmationInProgress: _propTypes2.default.bool.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default)(TokenMediaModal);

/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _withGuestIntercom = __webpack_require__(360);
	
	var _withGuestIntercom2 = _interopRequireDefault(_withGuestIntercom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = _themeSelector2.default.theme();
	
	var logoStyle = {
	  display: 'block',
	  margin: '50px auto 30px auto',
	  maxWidth: '100%'
	};
	
	var TokenThanks = function TokenThanks() {
	  if (theme.tokenThanksRedirectUrl) {
	    console.log('TokenThanks', theme.tokenThanksRedirectUrl);
	    window.location = theme.tokenThanksRedirectUrl;
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'page' },
	    _react2.default.createElement(
	      'div',
	      { className: 'page-content' },
	      _react2.default.createElement(
	        'a',
	        { href: '/' },
	        _react2.default.createElement('img', { style: logoStyle, src: theme.darkLogo.src, alt: theme.darkLogo.alt })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { container: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer', computer: '3' }),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { computer: '10', mobile: '16' },
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { textAlign: 'center', size: 'small' },
	              !theme.tokenThanksMessage && _react2.default.createElement(
	                'h1',
	                { style: { textAlign: 'center' } },
	                'Thanks!',
	                _react2.default.createElement('br', null),
	                'We will process your token directly...'
	              ),
	              theme.tokenThanksMessage && _react2.default.createElement(
	                'h1',
	                { style: { textAlign: 'center' } },
	                theme.tokenThanksMessage
	              ),
	              !theme.tokenThanksMessage && _react2.default.createElement(_semanticUiReact.Divider, null),
	              !theme.tokenThanksMessage && _react2.default.createElement(
	                'p',
	                { className: 'info' },
	                'Our support team will be in touch if there are any issues.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer', computer: '3' })
	      )
	    )
	  );
	};
	
	exports.default = (0, _recompose.compose)(_withGuestIntercom2.default)(TokenThanks);

/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TrialExpiredModal = function (_Component) {
	  _inherits(TrialExpiredModal, _Component);
	
	  function TrialExpiredModal() {
	    _classCallCheck(this, TrialExpiredModal);
	
	    return _possibleConstructorReturn(this, (TrialExpiredModal.__proto__ || Object.getPrototypeOf(TrialExpiredModal)).apply(this, arguments));
	  }
	
	  _createClass(TrialExpiredModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          username = _props.username;
	
	      var centered = {
	        textAlign: 'center'
	      };
	      var buttonStyle = { width: 300 };
	
	      var firstName = _lodash2.default.split(username, ' ')[0];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Modal,
	          {
	            open: open,
	            closeOnEscape: false,
	            closeOnRootNodeClick: false,
	            onClose: this.close,
	            size: 'tiny'
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Header,
	            null,
	            _react2.default.createElement(_semanticUiReact.Image, {
	              src: '/dyzio-logo-large.png',
	              size: 'small',
	              alt: 'dyzio',
	              centered: true
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Content,
	            { style: centered },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Hi ',
	              firstName,
	              '! Your free trial has expired ',
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'frown' })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Use the green intercom button at the bottom right of your screen to contact our live support team or click ',
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:sales@dyzio.co?subject=dyzio%20license' },
	                'here'
	              ),
	              ' to send an email to our sales team'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Actions,
	            { style: centered },
	            _react2.default.createElement(_semanticUiReact.Button, {
	              centered: true,
	              icon: 'log out',
	              style: buttonStyle,
	              color: 'green',
	              size: 'large',
	              content: 'log out',
	              onClick: function onClick() {
	                window.location = '/logout';
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TrialExpiredModal;
	}(_react.Component);
	
	exports.default = TrialExpiredModal;

/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UnprocessedApprovalsCount;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UnprocessedApprovalsCount(_ref) {
	  var isLoading = _ref.isLoading,
	      isRefetching = _ref.isRefetching,
	      items = _ref.items,
	      onRefetch = _ref.onRefetch,
	      title = _ref.title;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { celled: true },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Header,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { colSpan: 4, textAlign: 'center' },
	          title
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Country'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Total'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      isLoading && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { colSpan: 4, textAlign: 'center' },
	          'Loading...'
	        )
	      ),
	      !_lodash2.default.isEmpty(items) && _lodash2.default.map(items, function (item) {
	        return _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          { key: item.country },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            item.country
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _lodash2.default.get(item, 'count', '-')
	          )
	        );
	      }),
	      !_lodash2.default.isEmpty(items) && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { colSpan: 4, textAlign: 'center' },
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { disabled: isRefetching, loading: isRefetching, color: 'pink', onClick: onRefetch },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh' }),
	            'Refresh data'
	          )
	        )
	      ),
	      _lodash2.default.isEmpty(items) && !isRefetching && !isLoading && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { colSpan: 4, textAlign: 'center' },
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: '10px' } },
	            'There is no data'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Button,
	            { disabled: isRefetching, loading: isRefetching, color: 'pink', onClick: onRefetch },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh' }),
	            'Refresh data'
	          )
	        )
	      )
	    )
	  );
	}
	
	UnprocessedApprovalsCount.propTypes = {
	  isLoading: _propTypes2.default.bool,
	  isRefetching: _propTypes2.default.bool,
	  items: _propTypes2.default.array,
	  onRefetch: _propTypes2.default.func,
	  title: _propTypes2.default.string
	};
	
	UnprocessedApprovalsCount.defaultProps = {
	  isLoading: false,
	  isRefetching: false,
	  items: [],
	  onRefetch: _lodash2.default.noop,
	  title: ''
	};

/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textCenter = {
	  textAlign: 'center'
	};
	
	var UpgradeModal = function UpgradeModal(_ref) {
	  var onClose = _ref.onClose,
	      value = _ref.value;
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      onClose: onClose,
	      size: 'tiny',
	      hasActionButton: true,
	      actionButtonContent: 'maybe later!',
	      headerText: 'Great Work! You\'ve added ' + value + ' influencers'
	    },
	    _react2.default.createElement(
	      'div',
	      { style: textCenter },
	      _react2.default.createElement(
	        _semanticUiReact.Statistic,
	        { size: 'large' },
	        _react2.default.createElement(
	          _semanticUiReact.Statistic.Value,
	          null,
	          value
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Statistic.Label,
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'user outline', color: 'pink' }),
	          'influencers'
	        )
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To add more than 50 influencers to your private My Influencers database contact our sales team using the Intercom button in the bottom right hand corner of the screen. Check out our pricing options ',
	      _react2.default.createElement(
	        _targetLink2.default,
	        { renderIf: true, href: 'https://dyzio.co/pricing' },
	        'here'
	      ),
	      '.'
	    )
	  );
	};
	
	UpgradeModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  value: _propTypes2.default.number.isRequired
	};
	
	exports.default = UpgradeModal;

/***/ },
/* 2037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _whatsNew = __webpack_require__(2393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origin = window.location.origin;
	
	var NOTHING_NEW = origin.match(/theinfluencer/);
	var WhatsNew = function WhatsNew() {
	  var link = _whatsNew.WHATS_NEW.link,
	      text = _whatsNew.WHATS_NEW.text;
	
	  if (NOTHING_NEW) return null;
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { raised: true },
	    _react2.default.createElement(
	      _semanticUiReact.Label,
	      { as: 'span', color: 'pink', ribbon: true },
	      'What\u2019s new in Dyzio!'
	    ),
	    text,
	    '... ',
	    _react2.default.createElement(
	      _targetLink2.default,
	      { renderIf: true, href: link },
	      'click here'
	    )
	  );
	};
	
	exports.default = WhatsNew;

/***/ },
/* 2038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _capitalize = __webpack_require__(575);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _reactRouter = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bottomRowStyle = { fontSize: '80%', color: 'grey' };
	var compactCardStyle = { padding: '5px 15px' };
	
	var getFriendlyRole = function getFriendlyRole(role) {
	  return _capitalize2.default.words(_lodash2.default.toLower(_lodash2.default.replace(role, '_', ' ')));
	};
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	
	var WideCampaignCard = function WideCampaignCard(props) {
	  var campaign = props.campaign,
	      campaignPermission = props.campaignPermission,
	      trackedAssetsCount = props.trackedAssetsCount,
	      router = props.router,
	      influencersCount = props.influencersCount;
	
	  var onClickListener = function onClickListener() {
	    return router.push('/campaign/' + campaign.id);
	  };
	  var friendlyRole = getFriendlyRole(campaignPermission.role);
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { onClick: onClickListener },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: compactCardStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { fixed: true, basic: 'very', singleLine: true, compact: 'very' },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.HeaderCell,
	              { width: 4 },
	              campaign.name
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: _lodash2.default.lowerCase(campaign.currency) }),
	              cf(campaign.budget)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'copy outline', color: 'orange' }),
	              campaign.totalAssets
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'users', color: 'orange' }),
	              campaign.totalInfluencers
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              friendlyRole
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              campaign.createdBy
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              (0, _moment2.default)(campaign.createdDate).format('Do MMM YYYY')
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 1, rowSpan: 2, textAlign: 'right' },
	              _react2.default.createElement(_semanticUiReact.Button, { icon: 'x', color: 'red', inverted: true, size: 'mini' })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            { style: bottomRowStyle },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              'NAME'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'money bill alternate outline', color: 'orange' }),
	              ' BUDGET'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              'ASSETS'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              'INFLUENCERS'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              'ROLE'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              'CREATED BY'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              'CREATED DATE'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	WideCampaignCard.propTypes = {
	  campaign: _propTypes2.default.object.isRequired,
	  campaignPermission: _propTypes2.default.object.isRequired,
	  trackedAssetsCount: _propTypes2.default.number.isRequired,
	  influencersCount: _propTypes2.default.number.isRequired,
	  router: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(WideCampaignCard);

/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _privateDataComponent = __webpack_require__(351);
	
	var _privateDataComponent2 = _interopRequireDefault(_privateDataComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YoutubeImpressions = function YoutubeImpressions(_ref) {
	  var latestStatistic = _ref.latestStatistic,
	      popupToggleHandler = _ref.popupToggleHandler;
	
	  var insights = latestStatistic.insights;
	  if (insights) {
	    return _react2.default.createElement(_semanticUiReact.Button, {
	      color: 'red',
	      inverted: true,
	      labelPosition: 'left',
	      icon: 'pie graph',
	      fluid: true,
	      content: 'view',
	      onClick: function onClick() {
	        return popupToggleHandler(latestStatistic);
	      },
	      size: 'small'
	    });
	  }
	  return _react2.default.createElement(_privateDataComponent2.default, null);
	};
	
	exports.default = YoutubeImpressions;

/***/ },
/* 2040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactChartjs = __webpack_require__(444);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	var pf = function pf(num) {
	  return (0, _numeral2.default)(num).format('0.0%');
	};
	var df = function df(num) {
	  return (0, _numeral2.default)(num).format('0.0');
	};
	
	var dyzioPalette = {
	  pink: '#fc4085',
	  bgPink: '#ffecf3',
	  green: '#20c49e',
	  bgGreen: '#d4faf1',
	  amber: '#fdb02b',
	  bgAmber: '#fff1d5',
	  blue: '#9ad2ff',
	  bgBlue: '#323299'
	};
	
	var barOptions = {
	  tooltips: {
	    mode: 'index',
	    intersect: false
	  },
	  responsive: true,
	  showScale: false,
	  scales: {
	    xAxes: [{
	      stacked: true
	    }],
	    yAxes: [{
	      stacked: true
	    }]
	  }
	};
	
	var fbH4 = {
	  padding: 5,
	  border: '1px solid #ccc',
	  backgroundColor: '#eee'
	};
	
	var getDemographics = function getDemographics(data, gender) {
	  if (!data) return null;
	
	  var labels = ['age13-17', 'age18-24', 'age25-34', 'age35-44', 'age45-54', 'age55-64', 'age65-'];
	  var demos = _lodash2.default.map(labels, function (label) {
	    var dp = _lodash2.default.find(data, function (d) {
	      if (d[0] === gender && d[1] === label) {
	        return d ? d[2] : 0;
	      }
	    });
	    return dp;
	  });
	
	  var xxx = _lodash2.default.map(demos, function (d) {
	    return d ? d[2] : 0;
	  });
	  return xxx;
	};
	
	var YoutubeInsightsModal = function YoutubeInsightsModal(_ref) {
	  var latestStatistic = _ref.latestStatistic,
	      popupToggleHandler = _ref.popupToggleHandler,
	      open = _ref.open;
	
	  if (!latestStatistic) return null;
	  var insights = latestStatistic.insights;
	
	  if (!open) return null;
	
	  var collectedDate = (0, _moment2.default)(latestStatistic.createdDate).format('MMMM Do YYYY, h:mm:ss a');
	
	  var headers = ['Country', 'Views', 'Mins Watched', 'Likes', 'Comments', 'Dislikes', 'Shares', 'Subs +', 'Subs -'];
	
	  var top10Countries = _lodash2.default.take(insights.viewingByCountry, 10);
	  var demoPercentages = insights.audienceDemographics;
	
	  var barData = {
	    labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'],
	    datasets: [{
	      label: 'male %',
	      backgroundColor: dyzioPalette.blue,
	      borderColor: dyzioPalette.bgBlue,
	      borderWidth: 1,
	      data: getDemographics(demoPercentages, 'male')
	    }, {
	      label: 'female %',
	      backgroundColor: dyzioPalette.bgPink,
	      borderColor: dyzioPalette.pink,
	      borderWidth: 1,
	      data: getDemographics(demoPercentages, 'female')
	    }]
	  };
	
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      open: open,
	      onClose: popupToggleHandler,
	      size: 'small'
	    },
	    _react2.default.createElement(_semanticUiReact.Header, { icon: 'pie graph', content: 'Youtube Video Insights' }),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      _react2.default.createElement(
	        'h4',
	        { style: fbH4 },
	        'Viewing by Country (Top 10)'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very', celled: true, fluid: true, small: true, textAlign: 'center', style: { padding: 5 } },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _lodash2.default.map(headers, function (m) {
	              return _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                m
	              );
	            })
	          ),
	          _lodash2.default.map(top10Countries, function (c) {
	            return _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _lodash2.default.map(headers, function (m, idx) {
	                return _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  idx === 0 ? _react2.default.createElement(
	                    'b',
	                    null,
	                    c[idx]
	                  ) : cf(c[idx])
	                );
	              })
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'h4',
	        { style: fbH4 },
	        'Audience Demographics'
	      ),
	      demoPercentages ? _react2.default.createElement(_reactChartjs.HorizontalBar, { data: barData, options: barOptions }) : _react2.default.createElement(
	        _semanticUiReact.Message,
	        { warning: true },
	        _react2.default.createElement(
	          _semanticUiReact.Message.Header,
	          null,
	          'Insufficent Data!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Youtube did not provide enough data for the audience demographics report.'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { className: 'centered' },
	        _react2.default.createElement(_semanticUiReact.Label, { centered: true, icon: 'clock', color: 'grey', basic: true, content: 'data collected ' + collectedDate })
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Actions,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        { color: 'green', onClick: popupToggleHandler, inverted: true },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
	        ' Got it'
	      )
	    )
	  );
	};
	
	exports.default = YoutubeInsightsModal;

/***/ },
/* 2041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _formatting = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllTimeDataTable = function AllTimeDataTable(_ref) {
	  var apiInfluencer = _ref.apiInfluencer,
	      avgComments = _ref.avgComments,
	      isYouTubeCompliance = _ref.isYouTubeCompliance;
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { basic: 'very', fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'videos'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.videoCount)
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'subscribers'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.subscriberCount)
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'views'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.viewCount)
	        )
	      ),
	      !isYouTubeCompliance && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'views per video'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.viewCount / apiInfluencer.aggregateYoutubeChannelStatistics.videoCount)
	        )
	      ),
	      !isYouTubeCompliance && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'comments per video'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(avgComments)
	        )
	      ),
	      !isYouTubeCompliance && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'avg. daily viewing'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.averageDailyViews)
	        )
	      ),
	      !isYouTubeCompliance && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'avg. monthly viewing'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.averageMonthlyViews)
	        )
	      )
	    )
	  );
	};
	
	var LastThirtyDaysTable = function LastThirtyDaysTable(_ref2) {
	  var thirtyDayData = _ref2.thirtyDayData,
	      percentageChange = _ref2.percentageChange;
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { basic: 'very', fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          '30 day trend'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Label, {
	            basic: true,
	            color: percentageChange > 0 ? 'green' : 'red',
	            content: (0, _numeral2.default)(percentageChange).format('+0.0%')
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'videos'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(thirtyDayData.videoChange)
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'subscribers'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Label, {
	            color: percentageChange > 0 ? 'green' : 'red',
	            basic: true,
	            content: '' + (percentageChange > 0 ? '+' : '') + (0, _formatting.commaFormatted)(thirtyDayData.subscriberChange)
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'views'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(thirtyDayData.viewChange)
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'avg. daily viewing'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(thirtyDayData.viewChange / thirtyDayData.dayChange)
	        )
	      )
	    )
	  );
	};
	
	var YoutubeDataTabs = function YoutubeDataTabs(_ref3) {
	  var percentageChange = _ref3.percentageChange,
	      apiInfluencer = _ref3.apiInfluencer,
	      avgComments = _ref3.avgComments,
	      isYouTubeCompliance = _ref3.isYouTubeCompliance,
	      thirtyDayData = _ref3.thirtyDayData;
	
	  var panes = [{ menuItem: { content: 'Last 30 days', key: 'last30', icon: 'calendar alternate outline' },
	    render: function render() {
	      return _react2.default.createElement(LastThirtyDaysTable, {
	        thirtyDayData: thirtyDayData,
	        percentageChange: percentageChange
	      });
	    }
	  }, { menuItem: { key: 'alltime', icon: 'history', content: 'All time' },
	    render: function render() {
	      return _react2.default.createElement(AllTimeDataTable, {
	        apiInfluencer: apiInfluencer,
	        avgComments: avgComments,
	        isYouTubeCompliance: isYouTubeCompliance
	      });
	    }
	  }];
	
	  return _react2.default.createElement(_semanticUiReact.Tab, { panes: panes });
	};
	
	YoutubeDataTabs.propTypes = {
	  percentageChange: _propTypes2.default.number.isRequired,
	  apiInfluencer: _propTypes2.default.object.isRequired,
	  avgComments: _propTypes2.default.number.isRequired,
	  isYouTubeCompliance: _propTypes2.default.bool.isRequired,
	  thirtyDayData: _propTypes2.default.object.isRequired
	};
	
	exports.default = YoutubeDataTabs;

/***/ },
/* 2042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _campaignReportCard = __webpack_require__(539);
	
	var _campaignReportCard2 = _interopRequireDefault(_campaignReportCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var delay = function delay(ms) {
	  return new Promise(function (resolve, reject) {
	    return setTimeout(resolve, ms);
	  });
	};
	
	var reportsMonths = ['AUGUST'];
	
	var boxStyle = {
	  paddingTop: 19,
	  paddingBottom: 19
	};
	
	var STATS_API = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com';
	var LINK_STATS_API = STATS_API + '/production/abbottlyon/short.io/stats/clicks';
	var CAMPAIGN_STATS_API = STATS_API + '/production/abbottlyon/short.io/stats/campaigns';
	
	var AbbottLyonDashboard = function (_Component) {
	  _inherits(AbbottLyonDashboard, _Component);
	
	  function AbbottLyonDashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, AbbottLyonDashboard);
	
	    var _this = _possibleConstructorReturn(this, (AbbottLyonDashboard.__proto__ || Object.getPrototypeOf(AbbottLyonDashboard)).call(this, props));
	
	    _this.toggleGroupView = function () {
	      _this.setState(function (prev) {
	        return { groupView: !prev.groupView };
	      });
	    };
	
	    _this.groupReports = function (reports) {
	      var groupped = _lodash2.default.groupBy(reports, 'name');
	      return _lodash2.default.reduce(_lodash2.default.values(groupped), function (acc, group) {
	        var result = {};
	        var first = group[0];
	        _lodash2.default.forEach(_lodash2.default.keys(first), function (key) {
	          result[key] = _lodash2.default.isNumber(first[key]) ? _lodash2.default.sumBy(group, key) : first[key];
	        });
	        acc.push(result);
	        return acc;
	      }, []);
	    };
	
	    _this.fetchReportForMonth = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(month) {
	        var reloading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var loadingStateKey, organisationId, params;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                loadingStateKey = reloading ? _lodash2.default.toLower(month) + 'IsReloading' : _lodash2.default.toLower(month) + 'IsLoading';
	
	                _this.setState(_defineProperty({}, loadingStateKey, true));
	                organisationId = _this.props.userInfo.organisationId;
	                params = reloading ? { clearCache: true } : {};
	                _context.next = 6;
	                return _this.reportImportClient.get('/organisation/' + organisationId + '/report/' + month, { params: params }).then(function (response) {
	                  var _this$setState2;
	
	                  var reports = _lodash2.default.get(response, 'data.data.data.reports', []);
	
	                  var groupedReports = _this.groupReports(reports);
	                  _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, _lodash2.default.toLower(month) + 'Reports', _lodash2.default.sortBy(reports, 'name')), _defineProperty(_this$setState2, _lodash2.default.toLower(month) + 'ReportsGrouped', _lodash2.default.sortBy(groupedReports, 'name')), _defineProperty(_this$setState2, loadingStateKey, false), _this$setState2));
	                }).catch(function (err) {
	                  var _this$setState3;
	
	                  _this.setState((_this$setState3 = {}, _defineProperty(_this$setState3, _lodash2.default.toLower(month) + 'Reports', []), _defineProperty(_this$setState3, _lodash2.default.toLower(month) + 'ReportsGrouped', []), _defineProperty(_this$setState3, loadingStateKey, false), _this$setState3));
	                });
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.fetchReports = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, month;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this.setState({
	                augustIsLoading: true
	              });
	              // eslint-disable-next-line no-restricted-syntax
	              _iteratorNormalCompletion = true;
	              _didIteratorError = false;
	              _iteratorError = undefined;
	              _context2.prev = 4;
	              _iterator = reportsMonths[Symbol.iterator]();
	
	            case 6:
	              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                _context2.next = 14;
	                break;
	              }
	
	              month = _step.value;
	              _context2.next = 10;
	              return _this.fetchReportForMonth(month);
	
	            case 10:
	              delay(500);
	
	            case 11:
	              _iteratorNormalCompletion = true;
	              _context2.next = 6;
	              break;
	
	            case 14:
	              _context2.next = 20;
	              break;
	
	            case 16:
	              _context2.prev = 16;
	              _context2.t0 = _context2['catch'](4);
	              _didIteratorError = true;
	              _iteratorError = _context2.t0;
	
	            case 20:
	              _context2.prev = 20;
	              _context2.prev = 21;
	
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	
	            case 23:
	              _context2.prev = 23;
	
	              if (!_didIteratorError) {
	                _context2.next = 26;
	                break;
	              }
	
	              throw _iteratorError;
	
	            case 26:
	              return _context2.finish(23);
	
	            case 27:
	              return _context2.finish(20);
	
	            case 28:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[4, 16, 20, 28], [21,, 23, 27]]);
	    }));
	    _this.fetchLinkStats = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var period, response, _response$data, pathData, campaignData, orderedCampaigns, ordered;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              period = 'last7';
	              _context3.next = 3;
	              return _axios2.default.get(LINK_STATS_API + '/' + period);
	
	            case 3:
	              response = _context3.sent;
	              _response$data = response.data, pathData = _response$data.pathData, campaignData = _response$data.campaignData;
	              orderedCampaigns = _lodash2.default.map(campaignData, function (v, k) {
	                return { campaign: k, clicks: v.count };
	              });
	
	
	              console.log(orderedCampaigns);
	
	              ordered = _lodash2.default.orderBy(pathData, 'clicks');
	
	
	              _lodash2.default.forEach(ordered, function (o) {
	                if (_lodash2.default.startsWith(o.path, '/tt/')) {
	                  var handle = _lodash2.default.replace(o.path, '/tt/', '');
	                  o.handle = handle;
	                  o.href = 'https://tiktok.com/@' + handle;
	                } else {
	                  var _handle = _lodash2.default.replace(o.path, '/ig/', '');
	                  o.handle = _handle;
	                  o.href = 'https://instagram.com/' + _handle;
	                }
	              });
	              _this.setState({
	                linkStats: _lodash2.default.reverse(ordered),
	                campaignStats: _lodash2.default.reverse(_lodash2.default.orderBy(orderedCampaigns, 'clicks'))
	              });
	
	            case 10:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	    _this.fetchCampaignStats = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var period, response, rawData, filtered;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              period = 'last7';
	              _context4.next = 3;
	              return _axios2.default.get(CAMPAIGN_STATS_API + '/' + period);
	
	            case 3:
	              response = _context4.sent;
	              rawData = response.data;
	              filtered = _lodash2.default.filter(rawData, function (d) {
	                return d.displayName.length > 1;
	              });
	
	              _this.setState({
	                campaignStats: filtered
	              });
	
	            case 7:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.state = {
	      augustReports: [],
	      augustIsLoading: false,
	      augustIsReloading: false,
	      groupView: true,
	      linkStats: null,
	      campaignStats: null
	    };
	    var buildRESTClient = _this.props.buildRESTClient;
	
	    _this.reportImportClient = buildRESTClient({
	      baseURL: ("https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production") || '',
	      hasToken: false,
	      timeout: 100000
	    });
	    return _this;
	  }
	
	  _createClass(AbbottLyonDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchReports();
	      this.fetchLinkStats();
	      //    this.fetchCampaignStats();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          augustReports = _state.augustReports,
	          augustReportsGrouped = _state.augustReportsGrouped,
	          augustIsLoading = _state.augustIsLoading,
	          augustIsReloading = _state.augustIsReloading,
	          groupView = _state.groupView,
	          linkStats = _state.linkStats,
	          campaignStats = _state.campaignStats;
	
	
	      console.log(linkStats);
	
	      var totals = {};
	
	      if (augustReports) {
	        totals.ukInsta = _lodash2.default.sumBy(augustReports, function (ar) {
	          if (ar.country === 'GB' && ar.name.match(/instagram/i)) return ar.influencers;
	          return 0;
	        });
	        totals.linksUkInsta = _lodash2.default.sumBy(linkStats, function (ls) {
	          if (ls.campaign.match(/^UK-INSTAGRAM/i)) return 1;
	          return 0;
	        });
	        totals.ukTikTok = _lodash2.default.sumBy(augustReports, function (ar) {
	          if (ar.country === 'GB' && ar.name.match(/tiktok/i)) return ar.influencers;
	          return 0;
	        });
	        totals.linksUkTikTok = _lodash2.default.sumBy(linkStats, function (ls) {
	          if (ls.campaign.match(/^UK-TIKTOK/i)) return 1;
	          return 0;
	        });
	        totals.usTikTok = _lodash2.default.sumBy(augustReports, function (ar) {
	          if (ar.country === 'US' && ar.name.match(/tiktok/i)) return ar.influencers;
	          return 0;
	        });
	        totals.linksUsTikTok = _lodash2.default.sumBy(linkStats, function (ls) {
	          if (ls.campaign.match(/^US-TIKTOK/i)) return 1;
	          return 0;
	        });
	        totals.usInsta = _lodash2.default.sumBy(augustReports, function (ar) {
	          if (ar.country === 'US' && ar.name.match(/instagram/i)) return ar.influencers;
	          return 0;
	        });
	        totals.linksUsInsta = _lodash2.default.sumBy(linkStats, function (ls) {
	          if (ls.campaign.match(/^US-INSTAGRAM/i)) return 1;
	          return 0;
	        });
	      }
	
	      console.log(totals);
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'influencer-context-bar', style: boxStyle },
	          _react2.default.createElement('div', { className: 'spacer small' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Dashboard'
	              )
	            ),
	            _react2.default.createElement('div', { className: 'space' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'light' },
	                'Abbott Lyon'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement('div', { className: 'horizontal-spacer' })
	            ),
	            _react2.default.createElement('div', { className: 'space' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_campaignReportCard2.default, {
	              campaigns: groupView ? augustReportsGrouped : augustReports,
	              title: 'August',
	              month: 'AUGUST',
	              isLoading: augustIsLoading,
	              onReload: this.fetchReportForMonth,
	              isReloading: augustIsReloading,
	              onGroupViewToggle: this.toggleGroupView
	            }),
	            _react2.default.createElement(
	              _semanticUiReact.Card,
	              { fluid: true },
	              _react2.default.createElement(
	                _semanticUiReact.CardContent,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.CardHeader,
	                  null,
	                  'Affiliate Link Clicks (last 7 days)'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.CardContent,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.CardGroup,
	                  { itemsPerRow: '2' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Card,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.CardContent,
	                      { header: true },
	                      _react2.default.createElement(
	                        'h3',
	                        { style: { textAlign: 'center' } },
	                        _react2.default.createElement(_semanticUiReact.Flag, { name: 'gb' }),
	                        'UK CAMPAIGNS'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Card.Content,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.StatisticGroup,
	                        { size: 'large', widths: '2' },
	                        _react2.default.createElement(
	                          _semanticUiReact.Statistic,
	                          { color: 'blue' },
	                          _react2.default.createElement(
	                            _semanticUiReact.StatisticValue,
	                            null,
	                            _react2.default.createElement(_semanticUiReact.Icon, { name: 'camera retro', size: 'tiny' }),
	                            '\xA0',
	                            totals ? Math.round(totals.linksUkInsta / totals.ukInsta * 100) + '%' : '...'
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.StatisticLabel,
	                            null,
	                            'UK INSTAGRAM'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Statistic,
	                          { color: 'blue' },
	                          _react2.default.createElement(
	                            _semanticUiReact.StatisticValue,
	                            null,
	                            _react2.default.createElement(_semanticUiReact.Icon, { name: 'music', size: 'tiny' }),
	                            '\xA0',
	                            totals ? Math.round(totals.linksUkTikTok / totals.ukTikTok * 100) + '%' : '...'
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.StatisticLabel,
	                            null,
	                            'UK TIKTOK'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Card.Content,
	                      null,
	                      _react2.default.createElement(
	                        'table',
	                        { width: '100%', style: { textAlign: 'center' } },
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { width: '50%' },
	                            totals.linksUkInsta,
	                            ' of ',
	                            totals.ukInsta
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            { width: '50%' },
	                            totals.linksUkTikTok,
	                            ' of ',
	                            totals.ukTikTok
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Card,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.CardContent,
	                      { header: true },
	                      _react2.default.createElement(
	                        'h3',
	                        { style: { textAlign: 'center' } },
	                        _react2.default.createElement(_semanticUiReact.Flag, { name: 'us' }),
	                        'US CAMPAIGNS'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Card.Content,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.StatisticGroup,
	                        { size: 'large', widths: '2' },
	                        _react2.default.createElement(
	                          _semanticUiReact.Statistic,
	                          { color: 'pink' },
	                          _react2.default.createElement(
	                            _semanticUiReact.StatisticValue,
	                            null,
	                            _react2.default.createElement(_semanticUiReact.Icon, { name: 'camera retro', size: 'tiny' }),
	                            '\xA0',
	                            totals ? Math.round(totals.linksUsInsta / totals.usInsta * 100) + '%' : '...'
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.StatisticLabel,
	                            null,
	                            'US INSTAGRAM'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Statistic,
	                          { color: 'pink' },
	                          _react2.default.createElement(
	                            _semanticUiReact.StatisticValue,
	                            null,
	                            _react2.default.createElement(_semanticUiReact.Icon, { name: 'music', size: 'tiny' }),
	                            '\xA0',
	                            totals ? Math.round(totals.linksUsTikTok / totals.usTikTok * 100) + '%' : '...'
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.StatisticLabel,
	                            null,
	                            'US TIKTOK'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Card.Content,
	                      null,
	                      _react2.default.createElement(
	                        'table',
	                        { width: '100%', style: { textAlign: 'center' } },
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { width: '50%' },
	                            totals.linksUsInsta,
	                            ' of ',
	                            totals.usInsta
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            { width: '50%' },
	                            totals.linksUsTikTok,
	                            ' of ',
	                            totals.usTikTok
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid,
	                  { columns: 2 },
	                  _react2.default.createElement(
	                    _semanticUiReact.GridRow,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.GridColumn,
	                      null,
	                      linkStats && _react2.default.createElement(
	                        _semanticUiReact.Table,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.TableHeader,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.TableRow,
	                            null,
	                            _react2.default.createElement(
	                              _semanticUiReact.TableHeaderCell,
	                              null,
	                              'Link'
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.TableHeaderCell,
	                              null,
	                              'Campaign'
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.TableHeaderCell,
	                              null,
	                              'Clicks'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableBody,
	                          null,
	                          _lodash2.default.map(linkStats, function (ls) {
	                            return _react2.default.createElement(
	                              _semanticUiReact.TableRow,
	                              null,
	                              _react2.default.createElement(
	                                _semanticUiReact.TableCell,
	                                null,
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: ls.href, target: '_blank' },
	                                  ' ',
	                                  ls.path
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _semanticUiReact.TableCell,
	                                null,
	                                ls.campaign
	                              ),
	                              _react2.default.createElement(
	                                _semanticUiReact.TableCell,
	                                null,
	                                ls.clicks
	                              )
	                            );
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.GridColumn,
	                      null,
	                      campaignStats && _react2.default.createElement(
	                        _semanticUiReact.Table,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.TableHeader,
	                          null,
	                          _react2.default.createElement(
	                            _semanticUiReact.TableRow,
	                            null,
	                            _react2.default.createElement(
	                              _semanticUiReact.TableHeaderCell,
	                              null,
	                              'Campaign'
	                            ),
	                            _react2.default.createElement(
	                              _semanticUiReact.TableHeaderCell,
	                              null,
	                              'Clicks'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableBody,
	                          null,
	                          _lodash2.default.map(campaignStats, function (cs) {
	                            return _react2.default.createElement(
	                              _semanticUiReact.TableRow,
	                              null,
	                              _react2.default.createElement(
	                                _semanticUiReact.TableCell,
	                                null,
	                                cs.campaign
	                              ),
	                              _react2.default.createElement(
	                                _semanticUiReact.TableCell,
	                                null,
	                                cs.clicks
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AbbottLyonDashboard;
	}(_react.Component);
	
	AbbottLyonDashboard.propTypes = {
	  buildRESTClient: _propTypes2.default.func.isRequired
	};
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(AbbottLyonDashboard);

/***/ },
/* 2043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadingCampaign = loadingCampaign;
	exports.loadCampaignError = loadCampaignError;
	exports.loadingCampaignSuccess = loadingCampaignSuccess;
	
	var _constants = __webpack_require__(2044);
	
	function loadingCampaign(campaignId) {
	  var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  return {
	    type: _constants.LOAD_CAMPAIGN,
	    campaignId: campaignId,
	    silent: silent
	  };
	}
	
	function loadCampaignError(error) {
	  return {
	    type: _constants.LOAD_CAMPAIGN_ERROR,
	    error: error
	  };
	}
	
	function loadingCampaignSuccess(campaign) {
	  return {
	    type: _constants.LOAD_CAMPAIGN_SUCCESS,
	    campaign: campaign
	  };
	}

/***/ },
/* 2044 */
280,
/* 2045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _ramda = __webpack_require__(252);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _reactRouter = __webpack_require__(37);
	
	var _recompose = __webpack_require__(15);
	
	var _campaignAuditTrail = __webpack_require__(905);
	
	var _campaignAuditTrail2 = _interopRequireDefault(_campaignAuditTrail);
	
	var _statusBar = __webpack_require__(170);
	
	var _statusBar2 = _interopRequireDefault(_statusBar);
	
	var _hashtagScannerModal = __webpack_require__(876);
	
	var _hashtagScannerModal2 = _interopRequireDefault(_hashtagScannerModal);
	
	var _addCampaignModal = __webpack_require__(535);
	
	var _addCampaignModal2 = _interopRequireDefault(_addCampaignModal);
	
	var _report = __webpack_require__(552);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _actions = __webpack_require__(2043);
	
	var _actions2 = __webpack_require__(904);
	
	var _dropdown = __webpack_require__(542);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _acrSetup = __webpack_require__(1875);
	
	var _acrSetup2 = _interopRequireDefault(_acrSetup);
	
	var _actions3 = __webpack_require__(105);
	
	var _authService = __webpack_require__(21);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasOrganisation = __webpack_require__(106);
	
	var _hasOrganisation2 = _interopRequireDefault(_hasOrganisation);
	
	var _privateDataWhitelist = __webpack_require__(572);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _discussionList = __webpack_require__(2116);
	
	var _discussionList2 = _interopRequireDefault(_discussionList);
	
	var _roleService = __webpack_require__(143);
	
	var _campaigns = __webpack_require__(129);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _campaignBudget = __webpack_require__(1899);
	
	var _campaignBudget2 = _interopRequireDefault(_campaignBudget);
	
	var _campaignNotificationsTab = __webpack_require__(1907);
	
	var _campaignNotificationsTab2 = _interopRequireDefault(_campaignNotificationsTab);
	
	var _payments = __webpack_require__(916);
	
	var _payments2 = _interopRequireDefault(_payments);
	
	var _modal = __webpack_require__(103);
	
	var _sendBriefAllModal = __webpack_require__(2197);
	
	var _sendBriefAllModal2 = _interopRequireDefault(_sendBriefAllModal);
	
	var _sendDeliverableAllModal = __webpack_require__(2200);
	
	var _sendDeliverableAllModal2 = _interopRequireDefault(_sendDeliverableAllModal);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEBOUNCE_TIMEOUT = 800;
	
	var currentTheme = _themeSelector2.default.theme();
	
	var cardStyles = {
	  width: '98%',
	  margin: '20px auto'
	};
	
	var INITIAL_HASHTAG_SCANNER_STATE = {
	  hashtagScannerModalOpen: false,
	  isScanning: false,
	  validHashtags: true,
	  hashtagsErrors: [],
	  currentScannedPlatform: null,
	  scannerResultsCount: null,
	  hashtags: []
	};
	
	var APPROVED_OPTIONS = {
	  color: 'pink',
	  text: 'Your ACR is approved and will collect data now',
	  icon: 'check'
	};
	
	var PENDING_OPTIONS = {
	  color: 'orange',
	  text: 'Your ACR is awaiting approval, please use the chat tool (bottom right) to contact us if necessary',
	  icon: 'clock outline'
	};
	
	var ApprovalStatusLabel = function ApprovalStatusLabel(_ref) {
	  var approvalStatus = _ref.approvalStatus;
	
	  var options = approvalStatus === 'APPROVED' ? APPROVED_OPTIONS : PENDING_OPTIONS;
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(
	      _semanticUiReact.Label,
	      {
	        size: 'large',
	        color: options.color,
	        basic: true
	      },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: options.icon }),
	      approvalStatus
	    ),
	    content: options.text
	  });
	};
	
	var Campaign = function (_React$Component) {
	  _inherits(Campaign, _React$Component);
	
	  function Campaign(props, context) {
	    var _this3 = this;
	
	    _classCallCheck(this, Campaign);
	
	    var _this = _possibleConstructorReturn(this, (Campaign.__proto__ || Object.getPrototypeOf(Campaign)).call(this, props, context));
	
	    _this.setActiveTab = function (activeTab) {
	      return function () {
	        if (activeTab === _staticConfiguration.COLLABORATIONS && !_this.props.location.query.hasOwnProperty('collaborations')) {
	          _this.context.router.push(_this.props.location.pathname + '?collaborations');
	        }
	        if (activeTab === _staticConfiguration.GROUP_CHATS && !_this.props.location.query.hasOwnProperty('groupchats')) {
	          _this.context.router.push(_this.props.location.pathname + '?groupchats');
	        }
	        if (activeTab === _staticConfiguration.ANALYTICS && !_this.props.location.query.hasOwnProperty('analytics')) {
	          _this.context.router.push(_this.props.location.pathname + '?analytics');
	        }
	        if (activeTab === _staticConfiguration.PAYMENTS && !_this.props.location.query.hasOwnProperty('payments')) {
	          _this.context.router.push(_this.props.location.pathname + '?payments');
	        }
	        if (activeTab === _staticConfiguration.AUDIT_TRAIL && !_this.props.location.query.hasOwnProperty('audit-trail')) {
	          _this.context.router.push(_this.props.location.pathname + '?audit-trail');
	        }
	        if (activeTab === _staticConfiguration.NOTIFICATIONS && !_this.props.location.query.hasOwnProperty('notifications')) {
	          _this.context.router.push(_this.props.location.pathname + '?notifications');
	        }
	        _this.setState({ activeTab: activeTab });
	      };
	    };
	
	    _this.setModal = function (modalName) {
	      return _this.props.onSetModal(modalName);
	    };
	
	    _this.feedback = function (action) {
	      return _this.context.router.push(action);
	    };
	
	    _this.openReport = function (type) {
	      var campaignId = _this.state.campaignId;
	
	      window.open(currentTheme.shareSite + '/report/' + campaignId + '/' + type);
	    };
	
	    _this.handleHashtagInputsChange = function (e, _ref2) {
	      var name = _ref2.name,
	          value = _ref2.value;
	      var stateHashtags = _this.state.hashtags;
	
	      var hashtags = _lodash2.default.clone(stateHashtags);
	      var existing = _lodash2.default.find(hashtags, ['name', name]);
	      if (existing) {
	        existing.value = value;
	      } else {
	        hashtags.push({
	          name: name,
	          value: value
	        });
	      }
	
	      _this.setState({
	        hashtags: hashtags
	      });
	    };
	
	    _this.handleHashtagScannerState = function () {
	      var hashtagScannerModalOpen = _this.state.hashtagScannerModalOpen;
	
	      _this.setState({
	        hashtagScannerModalOpen: !hashtagScannerModalOpen
	      });
	    };
	
	    _this.scan = _regenerator2.default.mark(function scan() {
	      var _this2 = this;
	
	      var campaign, hashtags, campaignId, query;
	      return _regenerator2.default.wrap(function scan$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              campaign = this.props.campaign;
	              hashtags = this.state.hashtags;
	              campaignId = campaign.get('id');
	
	              query = function query(platform) {
	                return _this2.hashtagScannerAPI.post('/scan', {
	                  data: {
	                    campaignId: campaignId,
	                    platform: _lodash2.default.lowerCase(platform),
	                    hashtags: _lodash2.default.map(hashtags, function (hashtag) {
	                      return _lodash2.default.trim(hashtag.value);
	                    })
	                  }
	                });
	              };
	              // yield query(YOUTUBE);
	
	
	              _context.next = 6;
	              return query(_staticConfiguration.INSTAGRAM);
	
	            case 6:
	              _context.next = 8;
	              return query(_staticConfiguration.TWITTER);
	
	            case 8:
	              _context.next = 10;
	              return query(_staticConfiguration.FACEBOOK);
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, scan, this);
	    });
	
	    _this.getHashtagsErrors = function () {
	      var REGEX = /^(#|@?)\S{3,}$/g; // allow wide chars in hashtags
	      var hashtags = _this.state.hashtags;
	
	      var values = _lodash2.default.map(hashtags, function (hashtag) {
	        return _lodash2.default.trim(hashtag.value);
	      });
	      var matches = _lodash2.default.map(values, function (value) {
	        return value.match(REGEX);
	      });
	      var errors = _lodash2.default.map(matches, function (value, index) {
	        return { isError: _lodash2.default.isNull(value), position: index };
	      });
	      return errors;
	    };
	
	    _this.scanHashtags = function () {
	      var campaign = _this.props.campaign;
	
	      var TIMEOUT = 2200;
	      var generator = _this.scan();
	      var channels = [_staticConfiguration.INSTAGRAM, _staticConfiguration.TWITTER, _staticConfiguration.FACEBOOK];
	      _lodash2.default.forEach(channels, function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(channel, index) {
	          var isFacebook;
	          return _regenerator2.default.wrap(function _callee2$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  isFacebook = channel === _staticConfiguration.FACEBOOK;
	
	                  setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                    var _ref5, data, state;
	
	                    return _regenerator2.default.wrap(function _callee$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            _context2.next = 2;
	                            return generator.next().value;
	
	                          case 2:
	                            _ref5 = _context2.sent;
	                            data = _ref5.data.data;
	                            state = {
	                              currentScannedPlatform: channel,
	                              scannerResultsCount: _lodash2.default.sumBy(data, function (item) {
	                                return item.trackedAssets.length || 0;
	                              })
	                            };
	
	                            _this.setState(_extends({}, state), function () {
	                              if (isFacebook) {
	                                _lodash2.default.delay(function () {
	                                  return _this.setState(_extends({}, INITIAL_HASHTAG_SCANNER_STATE), function () {
	                                    return _this.props.onLoadingCampaign(campaign.get('id'));
	                                  });
	                                }, TIMEOUT);
	                              }
	                            });
	
	                          case 6:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee, _this3);
	                  })), TIMEOUT * _ramda2.default.inc(index));
	
	                case 2:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee2, _this3);
	        }));
	
	        return function (_x, _x2) {
	          return _ref3.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.toggleEditCampaignModalState = function () {
	      _this.setState(function (prevState) {
	        return {
	          editCampaignModalOpen: !prevState.editCampaignModalOpen
	        };
	      });
	    };
	
	    _this.handleScanButtonClick = function () {
	      var hashtagsErrors = _this.getHashtagsErrors();
	      var hasError = _lodash2.default.find(hashtagsErrors, ['isError', true]);
	      if (!hasError) {
	        _this.setState({
	          isScanning: true,
	          hashtagsErrors: []
	        }, _this.scanHashtags);
	      } else {
	        _this.setState({
	          hashtagsErrors: hashtagsErrors
	        });
	      }
	    };
	
	    _this.onHashtagScannerModalClose = function () {
	      _this.setState(_extends({}, INITIAL_HASHTAG_SCANNER_STATE));
	    };
	
	    _this.onFilterDiscussionListByTermChanged = _lodash2.default.debounce(function (event, data) {
	      var value = data.value;
	
	      _this.setState({
	        filterDiscussionListByTerm: value
	      });
	    }, DEBOUNCE_TIMEOUT);
	
	    _this.onEditCampaignTextField = function (event, _ref6) {
	      var name = _ref6.name,
	          value = _ref6.value;
	      var campaignUpdatedFields = _this.state.campaignUpdatedFields;
	
	      _lodash2.default.set(campaignUpdatedFields, name, value);
	      _this.setState({
	        campaignUpdatedFields: campaignUpdatedFields
	      });
	    };
	
	    _this.onLiveDateChange = function (date) {
	      var value = date.format();
	      _this.onEditCampaignTextField(null, { name: 'liveDate', value: value });
	    };
	
	    _this.onEndDateChange = function (date) {
	      var value = date.format();
	      _this.onEditCampaignTextField(null, { name: 'endDate', value: value });
	    };
	
	    _this.onCampaignCurrencyChanged = function (event, _ref7) {
	      var value = _ref7.value;
	
	      _this.onEditCampaignTextField(null, { name: 'currency', value: value });
	    };
	
	    _this.onSubmitEditCampaignForm = function () {
	      var campaignUpdatedFields = _this.state.campaignUpdatedFields;
	      var name = campaignUpdatedFields.name,
	          budget = campaignUpdatedFields.budget,
	          id = campaignUpdatedFields.id,
	          currency = campaignUpdatedFields.currency,
	          endDate = campaignUpdatedFields.endDate,
	          liveDate = campaignUpdatedFields.liveDate,
	          hashtags = campaignUpdatedFields.hashtags;
	      var restClient = _this.props.restClient;
	
	      var attributes = {
	        name: name,
	        budget: budget,
	        currency: currency,
	        liveDate: liveDate,
	        endDate: endDate,
	        hashtags: hashtags
	      };
	      restClient.patch('campaigns/' + id, {
	        data: {
	          attributes: _lodash2.default.pickBy(attributes)
	        }
	      }).then(function () {
	        _this.setState({
	          editCampaignModalOpen: false
	        }, function () {
	          return _this.props.onLoadingCampaign(id);
	        });
	      });
	    };
	
	    _this.onSettingsDropdownItemClick = function (value) {
	      if (value === 'campaign-settings') {
	        var campaign = _this.props.campaign;
	
	        var campaignJSON = campaign.toJSON();
	        var name = campaignJSON.name,
	            budget = campaignJSON.budget,
	            currency = campaignJSON.currency,
	            liveDate = campaignJSON.liveDate,
	            endDate = campaignJSON.endDate,
	            hashtags = campaignJSON.hashtags;
	
	        _this.setState({
	          editCampaignModalOpen: true,
	          campaignUpdatedFields: {
	            name: name, budget: budget, currency: currency, liveDate: liveDate, endDate: endDate, hashtags: hashtags, id: campaign.get('id')
	          }
	        });
	      } else {
	        _this.context.router.push(value);
	      }
	    };
	
	    _this.handleACRScan = function () {
	      var campaignId = _this.state.campaignId;
	
	      _this.setState({
	        automationScanLoading: true
	      });
	      _this.automationrAPI.post('/run-acr-scan/' + campaignId).then(function () {
	        return _this.setState({
	          automationScanLoading: false
	        });
	      }).then(function () {
	        return _this.setState({ campaignId: campaignId, activeTab: _staticConfiguration.ANALYTICS });
	      }).catch(function (e) {
	        return (0, _errorHandlingService.reportError)('ACR_ERROR', e);
	      });
	    };
	
	    _this.handleAutomatedCampaignScan = function () {
	      var campaignId = _this.state.campaignId;
	
	      _this.setState({
	        automationScanLoading: true
	      });
	      _this.automationrAPI.post('/run-automated-scan/' + campaignId).then(function () {
	        return _this.setState({
	          automationScanLoading: false
	        });
	      }).then(function () {
	        return _this.setState({ campaignId: campaignId, activeTab: _staticConfiguration.ANALYTICS });
	      }).catch(function (e) {
	        return (0, _errorHandlingService.reportError)('AUTO_CAMPAIGN_ERROR', e);
	      });
	    };
	
	    _this.state = _extends({
	      campaignId: null,
	      budgetAllocated: 'Waiting...',
	      activeTab: _staticConfiguration.COLLABORATIONS,
	      filterDiscussionListByTerm: null,
	      editCampaignModalOpen: false,
	      campaignUpdatedFields: {}
	    }, INITIAL_HASHTAG_SCANNER_STATE);
	
	    _this.updateCampaign = _this.updateCampaign.bind(_this);
	
	    _this.hashtagScannerAPI = _axios2.default.create({
	      baseURL: 'https://b7o8doqzfb.execute-api.eu-west-1.amazonaws.com/production/hashtags',
	      timeout: 20000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    _this.automationrAPI = _axios2.default.create({
	      baseURL: ("https://bahhjuaz6d.execute-api.eu-west-1.amazonaws.com/production"),
	      timeout: 20000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Campaign, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      var _props = this.props,
	          campaignAPIClient = _props.campaignAPIClient,
	          organisationId = _props.userInfo.organisationId;
	
	      var myUserRole = this.props.myUserRole;
	      if (myUserRole === _staticConfiguration.CLIENT || myUserRole === _staticConfiguration.PARTNER_AGENCY) {
	        this.context.router.push('/dashboard');
	      }
	      var campaignId = this.props.routeParams ? this.props.routeParams.id : '';
	
	      var query = this.props.location.query;
	      if (query.hasOwnProperty('collaborations')) {
	        this.setState({ campaignId: campaignId, activeTab: _staticConfiguration.COLLABORATIONS });
	      } else if (query.hasOwnProperty('groupchats')) {
	        this.setState({ campaignId: campaignId, activeTab: _staticConfiguration.GROUP_CHATS });
	      } else if (query.hasOwnProperty('analytics')) {
	        this.setState({ campaignId: campaignId, activeTab: _staticConfiguration.ANALYTICS });
	      } else if (query.hasOwnProperty('payments')) {
	        this.setState({ campaignId: campaignId, activeTab: _staticConfiguration.PAYMENTS });
	      } else if (query.hasOwnProperty('notifications')) {
	        this.setState({ campaignId: campaignId, activeTab: _staticConfiguration.NOTIFICATIONS });
	      } else if (query.hasOwnProperty('audit-trail')) {
	        this.setState({ campaignId: campaignId, activeTab: _staticConfiguration.AUDIT_TRAIL });
	      } else {
	        this.setState({ campaignId: campaignId, activeTab: _staticConfiguration.COLLABORATIONS });
	        this.context.router.push(this.props.location.pathname + '?collaborations');
	      }
	
	      this.props.onLoadingCampaign(campaignId);
	      this.setState({
	        isLoadingTotals: true
	      });
	      var requests = [campaignAPIClient.get('/summary/tracked-assets?organisationId=' + organisationId)];
	      return Promise.all(requests).then(function (_ref8) {
	        var _ref9 = _slicedToArray(_ref8, 1),
	            trackedAssetsCount = _ref9[0].data.data.trackedAssetsCount;
	
	        return _this4.setState({
	          trackedAssetsCount: trackedAssetsCount,
	          isLoadingTotals: false
	        });
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var newCampaignId = this.props.routeParams ? this.props.routeParams.id : '';
	      if (this.state.campaignId !== newCampaignId) {
	        this.setState({ campaignId: newCampaignId, activeTab: _staticConfiguration.COLLABORATIONS });
	        this.context.router.push('/acr-campaign/' + newCampaignId + '?collaborations');
	        // this.props.onClearDiscussions();
	        this.props.onLoadingCampaign(newCampaignId);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // this.props.onClearStatusBar();
	      // this.props.onClearDiscussions();
	    }
	  }, {
	    key: 'updateCampaign',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(budget) {
	        var id, oldBudget;
	        return _regenerator2.default.wrap(function _callee3$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                id = this.props.campaign.get('id');
	                oldBudget = this.props.campaign.get('budget');
	
	
	                try {
	                  (0, _campaigns.updateCampaign)(id, budget);
	                } catch (error) {
	                  (0, _errorHandlingService.reportError)('UPDATE_CAMPAIGN_ERROR', error.message);
	                  this.props.onSetStatusBar(error.message, 'red');
	                }
	
	              case 3:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function updateCampaign(_x3) {
	        return _ref10.apply(this, arguments);
	      }
	
	      return updateCampaign;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props2 = this.props,
	          myUserRole = _props2.myUserRole,
	          campaign = _props2.campaign,
	          campaignLoading = _props2.campaignLoading,
	          campaignLoadError = _props2.campaignLoadError,
	          members = _props2.members,
	          showModal = _props2.showModal,
	          userInfo = _props2.userInfo,
	          organisation = _props2.organisation;
	      var organisationId = userInfo.organisationId;
	      var isUserSuperAdmin = userInfo.isUserSuperAdmin;
	
	
	      var isDyzioTeam = (0, _privateDataWhitelist.isTeam)(organisationId, _privateDataWhitelist.TD);
	      var isKaspersky = (0, _privateDataWhitelist.isTeam)(organisationId, _privateDataWhitelist.KASPERSKY);
	      var shouldRenderAuditTrail = isDyzioTeam || isKaspersky && isUserSuperAdmin;
	
	      var _state = this.state,
	          activeTab = _state.activeTab,
	          campaignId = _state.campaignId,
	          hashtagScannerModalOpen = _state.hashtagScannerModalOpen,
	          isScanning = _state.isScanning,
	          currentScannedPlatform = _state.currentScannedPlatform,
	          scannerResultsCount = _state.scannerResultsCount,
	          hashtags = _state.hashtags,
	          hashtagsErrors = _state.hashtagsErrors,
	          campaignUpdatedFields = _state.campaignUpdatedFields,
	          filterDiscussionListByTerm = _state.filterDiscussionListByTerm,
	          editCampaignModalOpen = _state.editCampaignModalOpen,
	          trackedAssetsCount = _state.trackedAssetsCount,
	          automationScanLoading = _state.automationScanLoading;
	
	
	      if (!campaignId) return null;
	
	      var campaignName = campaign && campaign.get('name');
	      var budget = campaign.get('budget') || 0;
	      var currency = campaignUpdatedFields && campaignUpdatedFields.currency;
	      var liveDate = campaignUpdatedFields && (0, _moment2.default)(campaignUpdatedFields.liveDate);
	      var endDate = campaignUpdatedFields && (0, _moment2.default)(campaignUpdatedFields.endDate);
	
	      var campaignCurrency = campaign.get('currency');
	      var campaignJSON = campaign.toJSON();
	      var campaignType = campaignJSON.campaignType,
	          approvalStatus = campaignJSON.approvalStatus;
	
	
	      var campaignFormProps = {
	        name: campaignUpdatedFields.name,
	        budget: campaignUpdatedFields.budget,
	        currency: currency,
	        liveDate: liveDate,
	        endDate: endDate,
	        campaignType: campaignType,
	        hashtags: campaignUpdatedFields.hashtags,
	        onInputChange: this.onEditCampaignTextField,
	        onLiveDateChange: this.onLiveDateChange,
	        onEndDateChange: this.onEndDateChange,
	        onCurrencyChange: this.onCampaignCurrencyChanged
	      };
	
	      var teamMembers = [];
	      var clientMembers = [];
	      var creatorMembers = [];
	
	      if (members) {
	        members.forEach(function (member) {
	          var role = member.get('role');
	          if (role === _staticConfiguration.TEAM_MEMBER || role === _staticConfiguration.CAMPAIGN_OWNER || role === _staticConfiguration.CAMPAIGN_ADMIN) teamMembers.push(member);
	          if (role === _staticConfiguration.CLIENT) clientMembers.push(member);
	          if (role === _staticConfiguration.PRODUCTION_COMPANY || role === _staticConfiguration.INFLUENCER || role === _staticConfiguration.TALENT_AGENT) creatorMembers.push(member);
	        });
	      }
	
	      var noDiscussions = _lodash2.default.isEmpty(campaignJSON.discussions);
	
	      var isManual = campaignType === 'WORKFLOW';
	      var isACR = campaignType === 'ACR';
	      var isAutomatedCampaign = campaignType === 'AUTOMATED';
	      var isAuto = isACR || isAutomatedCampaign;
	      var hasEvents = isACR || isAutomatedCampaign;
	      var hasInfluencers = creatorMembers.length > 0 || campaign && (campaignJSON.pendingInvitations || []).length > 0;
	      var isUserTeamMember = isUserSuperAdmin || (0, _roleService.checkUserIsTeamMember)(myUserRole);
	      var isUserAnAdmin = isUserSuperAdmin || (0, _roleService.checkUserHasAdminRights)(myUserRole);
	      var allocatedBudget = _lodash2.default.reduce(campaignJSON.discussions, function (sum, discussion) {
	        return sum + (discussion.budget || 0);
	      }, 0);
	
	      var hashtagsArray = _lodash2.default.split(campaignJSON.hashtags, ',');
	
	      var menuOptions = [{
	        key: 'invite',
	        text: 'Invite people to this campaign',
	        onClick: function onClick() {
	          return _this5.onSettingsDropdownItemClick('/acr-campaign/' + campaignId + '/invite');
	        }
	      }];
	
	      if (isUserAnAdmin) {
	        menuOptions.push({
	          key: 'manage',
	          text: 'Manage people on this campaign',
	          onClick: function onClick() {
	            return _this5.onSettingsDropdownItemClick('/acr-campaign/' + campaignId + '/manage');
	          }
	        });
	      }
	
	      menuOptions.push({
	        key: 'campaign-settings',
	        text: 'Edit campaign details',
	        value: 'campaign-settings',
	        onClick: function onClick() {
	          return _this5.onSettingsDropdownItemClick('campaign-settings');
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        showModal === _staticConfiguration.SEND_BRIEF_ALL && _react2.default.createElement(_sendBriefAllModal2.default, null),
	        showModal === _staticConfiguration.SEND_DELIVERABLE_ALL && _react2.default.createElement(_sendDeliverableAllModal2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'white-header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row large' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-spacer' },
	              !campaignLoading && _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/dashboard' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'angle left' }),
	                'back'
	              ),
	              _react2.default.createElement(
	                'h1',
	                null,
	                campaignName,
	                ' ',
	                isAutomatedCampaign && _lodash2.default.map(hashtagsArray, function (ht) {
	                  return _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { basic: true, color: 'grey' },
	                    ht
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-item' },
	              isUserTeamMember && _react2.default.createElement(
	                _semanticUiReact.Menu,
	                null,
	                _react2.default.createElement(_semanticUiReact.Dropdown, {
	                  text: 'Settings \xA0',
	                  icon: 'settings',
	                  options: menuOptions,
	                  pointing: 'right top',
	                  item: true
	                })
	              )
	            )
	          ),
	          !campaignLoading && isUserTeamMember ? _react2.default.createElement(
	            'div',
	            { className: 'row no-bottom-padding' },
	            _react2.default.createElement(
	              'div',
	              { className: 'large-tabs' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'flex-item ' + (activeTab === _staticConfiguration.COLLABORATIONS ? 'active' : ''),
	                  onClick: this.setActiveTab(_staticConfiguration.COLLABORATIONS)
	                },
	                isACR ? _react2.default.createElement(_semanticUiReact.Popup, { trigger: _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Setup'
	                  ), content: 'Set up your automated channel report' }) : _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Influencers'
	                  ),
	                  content: 'Manage your campaign influencers. Add, invite and request Authorization.'
	                })
	              ),
	              isAuto && _react2.default.createElement(
	                'div',
	                {
	                  className: 'flex-item ' + (activeTab === _staticConfiguration.NOTIFICATIONS ? 'active' : ''),
	                  onClick: this.setActiveTab(_staticConfiguration.NOTIFICATIONS)
	                },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(
	                      'nobr',
	                      null,
	                      'Notifications ',
	                      _react2.default.createElement(_semanticUiReact.Icon, { color: 'pink', name: 'star outline' })
	                    )
	                  ),
	                  content: 'View campaign history and automated email settings'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'flex-item ' + (activeTab === _staticConfiguration.ANALYTICS ? 'active' : ''),
	                  onClick: this.setActiveTab(_staticConfiguration.ANALYTICS)
	                },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Dashboard'
	                  ),
	                  content: 'View your campaign performance and share reports'
	                })
	              ),
	              !isACR && _react2.default.createElement(
	                'div',
	                {
	                  className: 'flex-item ' + (activeTab === _staticConfiguration.PAYMENTS ? 'active' : ''),
	                  onClick: this.setActiveTab(_staticConfiguration.PAYMENTS)
	                },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(
	                      'nobr',
	                      null,
	                      'Influencer fees'
	                    )
	                  ),
	                  content: 'Keep track of your campaign budget and individual influencer fees'
	                })
	              ),
	              shouldRenderAuditTrail && isManual && _react2.default.createElement(
	                'div',
	                {
	                  className: 'flex-item ' + (activeTab === _staticConfiguration.AUDIT_TRAIL ? 'active' : ''),
	                  onClick: this.setActiveTab(_staticConfiguration.AUDIT_TRAIL)
	                },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Audit trail'
	                  ),
	                  content: 'Audit trail description'
	                })
	              )
	            )
	          ) : _react2.default.createElement('div', { className: 'spacer large' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          activeTab === _staticConfiguration.AUDIT_TRAIL && shouldRenderAuditTrail && _react2.default.createElement(_campaignAuditTrail2.default, { campaignId: campaignId, csvFileName: campaignName }),
	          (activeTab === _staticConfiguration.COLLABORATIONS || activeTab === _staticConfiguration.GROUP_CHATS) && _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            !campaignLoading && isUserTeamMember && isACR && _react2.default.createElement(_acrSetup2.default, {
	              campaignId: campaignId,
	              acrScanLoading: automationScanLoading,
	              addChannelDisabled: !noDiscussions,
	              acrScanDisabled: noDiscussions || automationScanLoading,
	              channelAdded: !noDiscussions,
	              handleACRScan: this.handleACRScan
	            }),
	            !campaignLoading && isUserTeamMember && !isACR && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'budget-col-header' },
	                _react2.default.createElement(
	                  _semanticUiReact.Segment,
	                  { style: cardStyles },
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Grid.Row,
	                      null,
	                      isManual && _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { width: 3, verticalAlign: 'middle' },
	                        _react2.default.createElement(_semanticUiReact.Input, {
	                          icon: 'search',
	                          placeholder: 'Search collaboration...',
	                          onChange: this.onFilterDiscussionListByTermChanged,
	                          fluid: true
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { width: isManual ? 3 : 5, verticalAlign: 'middle', textAlign: 'center' },
	                        isManual && _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	                          label: '#HASHTAG Scannner',
	                          hasIcon: true,
	                          fluid: true,
	                          labelPosition: 'right',
	                          icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'search' }),
	                          onClick: this.handleHashtagScannerState
	                        }),
	                        isAutomatedCampaign && _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Hashtag(s): '
	                          ),
	                          _lodash2.default.map(hashtagsArray, function (ht) {
	                            return _react2.default.createElement(_semanticUiReact.Label, {
	                              color: 'pink',
	                              basic: true,
	                              content: ht
	                            });
	                          }),
	                          _react2.default.createElement(_semanticUiReact.Button, {
	                            icon: 'cogs',
	                            size: 'tiny',
	                            onClick: function onClick() {
	                              return _this5.onSettingsDropdownItemClick('campaign-settings');
	                            }
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { width: isManual ? 3 : 4, style: { borderLeft: '1px solid #ddd' }, verticalAlign: 'middle' },
	                        isAutomatedCampaign && _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	                            label: 'Scan latest posts',
	                            hasIcon: true,
	                            fluid: true,
	                            labelPosition: 'right',
	                            icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'search' }),
	                            loading: automationScanLoading,
	                            disabled: !campaignJSON.hashtags || automationScanLoading || noDiscussions,
	                            onClick: this.handleAutomatedCampaignScan
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { width: 7, textAlign: 'right', verticalAlign: 'middle' },
	                        _react2.default.createElement(_campaignBudget2.default, {
	                          budget: budget,
	                          allocated: allocatedBudget,
	                          updateBudget: this.updateCampaign,
	                          currency: campaignCurrency
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            campaignLoading && _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Loading...'
	              )
	            ),
	            campaignLoadError && _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'hero left' },
	                _react2.default.createElement(
	                  _semanticUiReact.Message,
	                  { color: 'red' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'There was a problem loading the campaign: ',
	                    campaignLoadError,
	                    '. Please check you are connected to the internet and try again.'
	                  )
	                )
	              )
	            ),
	            campaign.size > 0 && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid,
	                { style: { margin: 14 } },
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    null,
	                    _react2.default.createElement(_statusBar2.default, null),
	                    isACR && isUserTeamMember && _react2.default.createElement(
	                      'div',
	                      { style: { margin: 28 } },
	                      _react2.default.createElement(
	                        'table',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(
	                              'h2',
	                              null,
	                              'Tracked Channel'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { style: { color: 'rgba(0,0,0,.4)' } },
	                              'Instagram data will be automatically tracked from this channel daily'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            { style: { paddingLeft: 300 } },
	                            _react2.default.createElement(ApprovalStatusLabel, { approvalStatus: approvalStatus })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(_discussionList2.default, {
	                      organisation: organisation,
	                      trackedAssetsCount: trackedAssetsCount,
	                      currency: campaignCurrency,
	                      campaignId: campaignId,
	                      onUpdateAllocated: this.onUpdateAllocated,
	                      showCollaborationType: activeTab,
	                      filterDiscussionListByTerm: filterDiscussionListByTerm,
	                      reload: function reload() {
	                        _this5.props.onLoadingCampaign(campaignId);
	                      }
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          isUserTeamMember && activeTab === _staticConfiguration.ANALYTICS && _react2.default.createElement(_report2.default, { id: campaignId }),
	          isUserTeamMember && activeTab === _staticConfiguration.PAYMENTS && _react2.default.createElement(_payments2.default, { id: campaignId }),
	          isUserTeamMember && activeTab === _staticConfiguration.NOTIFICATIONS && _react2.default.createElement(_campaignNotificationsTab2.default, { campaignId: campaignId, campaignJSON: campaignJSON })
	        ),
	        hashtagScannerModalOpen && _react2.default.createElement(_hashtagScannerModal2.default, {
	          isEmptyState: !hasInfluencers,
	          isScanning: isScanning,
	          currentScannedPlatform: currentScannedPlatform,
	          onClose: this.handleHashtagScannerState,
	          onInputValueChange: this.handleHashtagInputsChange,
	          onScanHandler: this.handleScanButtonClick,
	          scannerResultsCount: scannerResultsCount,
	          hashtags: hashtags,
	          hashtagsErrors: hashtagsErrors
	        }),
	        editCampaignModalOpen && campaign && _react2.default.createElement(_addCampaignModal2.default, {
	          title: 'Edit campaign details',
	          buttonLabel: 'Save',
	          addCampaignFormProps: campaignFormProps,
	          onClose: this.toggleEditCampaignModalState,
	          onAddCampaignSubmit: this.onSubmitEditCampaignForm
	        })
	      );
	    }
	  }]);
	
	  return Campaign;
	}(_react2.default.Component);
	
	Campaign.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	Campaign.propTypes = {
	  routeParams: _propTypes2.default.object.isRequired
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    campaign: state.campaign.get('campaign'),
	    myUserRole: state.campaign.get('myUserRole'),
	    members: state.members.get('members'),
	    showModal: state.modal.get('showModal'),
	    campaignLoadError: state.campaign.get('campaignLoadError'),
	    campaignLoading: state.campaign.get('campaignLoading')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onClearStatusBar: function onClearStatusBar() {
	      return dispatch((0, _actions3.clearStatusBar)());
	    },
	    onLoadingCampaign: function onLoadingCampaign(campaignId) {
	      return dispatch((0, _actions.loadingCampaign)(campaignId));
	    },
	    onLoadCampaignAnalytics: function onLoadCampaignAnalytics(data) {
	      return dispatch((0, _actions2.loadCampaignAnalytics)(data));
	    },
	    onSetModal: function onSetModal(modalName) {
	      return dispatch((0, _modal.setModal)(modalName));
	    }
	  };
	}
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _hasOrganisation2.default, _hasRestClient2.default)(Campaign);

/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EmptyState;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  width: '100%',
	  paddingTop: 20,
	  paddingBottom: 20,
	  color: 'gray'
	};
	
	function EmptyState(_ref) {
	  var name = _ref.name;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Header,
	    { as: 'h4', icon: true, style: style },
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock', color: 'orange' }),
	    'channel demographics for ',
	    name,
	    _react2.default.createElement('br', null),
	    ' will appear once the campaign is approved ',
	    _react2.default.createElement('br', null),
	    'and the influencer has authorised their data'
	  );
	}
	
	EmptyState.propTypes = {
	  name: _propTypes2.default.string.isRequired
	};

/***/ },
/* 2047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _emptyState = __webpack_require__(2046);
	
	var _emptyState2 = _interopRequireDefault(_emptyState);
	
	var _instagramProfileData = __webpack_require__(377);
	
	var _instagramProfileData2 = _interopRequireDefault(_instagramProfileData);
	
	var _withInfluencerData = __webpack_require__(2248);
	
	var _withInfluencerData2 = _interopRequireDefault(_withInfluencerData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS_APPROVED = 'APPROVED';
	
	var ACRDemographicsWrapper = function (_Component) {
	  _inherits(ACRDemographicsWrapper, _Component);
	
	  function ACRDemographicsWrapper(props) {
	    _classCallCheck(this, ACRDemographicsWrapper);
	
	    var _this = _possibleConstructorReturn(this, (ACRDemographicsWrapper.__proto__ || Object.getPrototypeOf(ACRDemographicsWrapper)).call(this, props));
	
	    _this.state = {
	      influencer: null,
	      isLoading: true,
	      isError: false
	    };
	    return _this;
	  }
	
	  _createClass(ACRDemographicsWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          influencer = _props.influencer,
	          userInfo = _props.userInfo,
	          getInfluencerById = _props.getInfluencerById,
	          campaign = _props.campaign;
	
	      getInfluencerById(influencer.id).then(function (influencer) {
	        _this2.setState({
	          influencer: influencer,
	          isLoading: false
	        });
	        return influencer;
	      }).catch(function () {
	        _this2.setState({
	          isError: true,
	          isLoading: false
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          influencer = _state.influencer;
	      var _props2 = this.props,
	          userInfo = _props2.userInfo,
	          campaign = _props2.campaign;
	      var approvalStatus = campaign.approvalStatus;
	
	      var isCampaignApproved = approvalStatus === STATUS_APPROVED;
	      var props = { influencer: influencer, userInfo: userInfo };
	      return _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        !isLoading && isCampaignApproved && influencer.instagramAuthorised && _react2.default.createElement(_instagramProfileData2.default, Object.assign({}, props, {
	          disableBorders: true,
	          usedByACRCampaign: true
	        })),
	        !isLoading && (!isCampaignApproved || !influencer.instagramAuthorised) && _react2.default.createElement(_emptyState2.default, { name: influencer.name })
	      );
	    }
	  }]);
	
	  return ACRDemographicsWrapper;
	}(_react.Component);
	
	exports.default = (0, _recompose.compose)(_withInfluencerData2.default)(ACRDemographicsWrapper);

/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _campaignDashboardHeader = __webpack_require__(344);
	
	var _campaignDashboardHeader2 = _interopRequireDefault(_campaignDashboardHeader);
	
	var _tabActionBar = __webpack_require__(194);
	
	var _tabActionBar2 = _interopRequireDefault(_tabActionBar);
	
	var _dataRequestsListing = __webpack_require__(867);
	
	var _dataRequestsListing2 = _interopRequireDefault(_dataRequestsListing);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _resources = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AgencyInfluencerRequests = function (_Component) {
	  _inherits(AgencyInfluencerRequests, _Component);
	
	  function AgencyInfluencerRequests() {
	    _classCallCheck(this, AgencyInfluencerRequests);
	
	    var _this = _possibleConstructorReturn(this, (AgencyInfluencerRequests.__proto__ || Object.getPrototypeOf(AgencyInfluencerRequests)).call(this));
	
	    _this.onViewModeChanged = function () {
	      console.log('view mode changed');
	    };
	
	    _this.state = {
	      isLoading: true,
	      isError: false,
	      requests: []
	    };
	    return _this;
	  }
	
	  _createClass(AgencyInfluencerRequests, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          jsonAPIClient = _props.jsonAPIClient,
	          userInfo = _props.userInfo;
	      var organisationId = userInfo.organisationId;
	
	
	      jsonAPIClient.find(_resources.DATA_REQUESTS_RESOURCE, { // eslint-disable-line lodash/prefer-lodash-method
	        include: ['agency', 'influencer'],
	        filter: {
	          agency: organisationId
	        }
	      }).then(function (response) {
	        var json = _lodash2.default.map(response, function (item) {
	          return item.toJSONTree();
	        });
	        _this2.setState({
	          requests: json,
	          isLoading: false,
	          isError: false
	        });
	      }).catch(function () {
	        _this2.setState({
	          isLoading: false,
	          isError: true,
	          requests: []
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          isError = _state.isError,
	          requests = _state.requests;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_campaignDashboardHeader2.default, {
	          name: 'My Requests'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(_tabActionBar2.default, {
	            onViewModeChanged: this.onViewModeChanged
	          }),
	          _react2.default.createElement(_dataRequestsListing2.default, {
	            isLoading: isLoading,
	            isError: isError,
	            requests: requests
	          })
	        )
	      );
	    }
	  }]);
	
	  return AgencyInfluencerRequests;
	}(_react.Component);
	
	AgencyInfluencerRequests.propTypes = {
	  userInfo: _propTypes2.default.object.isRequired,
	  jsonAPIClient: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasJsonapiClient2.default, _hasUserInfo2.default)(AgencyInfluencerRequests);

/***/ },
/* 2049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadAnalyticsAssetList = loadAnalyticsAssetList;
	exports.sortAnalyticsAssetList = sortAnalyticsAssetList;
	exports.filterAnalyticsAssetList = filterAnalyticsAssetList;
	exports.addTrackedAssetToList = addTrackedAssetToList;
	
	var _constants = __webpack_require__(279);
	
	function loadAnalyticsAssetList() {
	  return {
	    type: _constants.LOAD_ANALYTICS_ASSET_LIST
	  };
	}
	
	function sortAnalyticsAssetList(data) {
	  return {
	    type: _constants.SORT_ANALYTICS_ASSET_LIST,
	    data: data
	  };
	}
	
	function filterAnalyticsAssetList(data) {
	  return {
	    type: _constants.FILTER_ANALYTICS_ASSET_LIST,
	    data: data
	  };
	}
	
	function addTrackedAssetToList(data) {
	  return {
	    type: _constants.ADD_TRACKED_ASSET_TO_LIST,
	    data: data
	  };
	}

/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactSelect = __webpack_require__(328);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _recompose = __webpack_require__(15);
	
	var _actions = __webpack_require__(2049);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _modal = __webpack_require__(103);
	
	var _engagementScoreModal = __webpack_require__(871);
	
	var _engagementScoreModal2 = _interopRequireDefault(_engagementScoreModal);
	
	var _analyticsAssetListHeader = __webpack_require__(1878);
	
	var _analyticsAssetListHeader2 = _interopRequireDefault(_analyticsAssetListHeader);
	
	var _analyticsAssetListTotals = __webpack_require__(1879);
	
	var _analyticsAssetListTotals2 = _interopRequireDefault(_analyticsAssetListTotals);
	
	var _analyticsAssetListContent = __webpack_require__(1877);
	
	var _analyticsAssetListContent2 = _interopRequireDefault(_analyticsAssetListContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnalyticsAssetList = function (_React$Component) {
	  _inherits(AnalyticsAssetList, _React$Component);
	
	  function AnalyticsAssetList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AnalyticsAssetList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnalyticsAssetList.__proto__ || Object.getPrototypeOf(AnalyticsAssetList)).call.apply(_ref, [this].concat(args))), _this), _this.openAssetPage = function (assetId) {
	      return function () {
	        return _this.context.router.push('/analytics/' + assetId);
	      };
	    }, _this.sortAssetList = function (sortBy) {
	      return _this.props.onSortAnalyticsAssetList({ sortBy: sortBy.value });
	    }, _this.filterAssetList = function (filterBy) {
	      return _this.props.onFilterAnalyticsAssetList({ filterBy: filterBy.value });
	    }, _this.showModal = function (docType) {
	      return function () {
	        return _this.props.onSetModal(docType);
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AnalyticsAssetList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onLoadAnalyticsAssetList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          hasTrackedDeliverables = _props.hasTrackedDeliverables,
	          filteredYoutubeVideos = _props.filteredYoutubeVideos,
	          filteredInstagramPosts = _props.filteredInstagramPosts,
	          filteredFacebookPosts = _props.filteredFacebookPosts,
	          filteredTwitterPosts = _props.filteredTwitterPosts,
	          sortBy = _props.sortBy,
	          filterBy = _props.filterBy,
	          filterByOptions = _props.filterByOptions,
	          loading = _props.loading,
	          showAnalyticTotals = _props.showAnalyticTotals,
	          youtubeTotals = _props.youtubeTotals,
	          instagramTotals = _props.instagramTotals,
	          facebookTotals = _props.facebookTotals,
	          twitterTotals = _props.twitterTotals;
	
	
	      var sortByOptions = [{ value: 'highestViews', label: 'views (highest)' }, { value: 'lowestViews', label: 'views (lowest)' }, { value: 'highestEngagement', label: 'engagement (highest)' }, { value: 'lowestEngagement', label: 'engagement (lowest)' }, { value: 'latestLiveDate', label: 'live date (latest)' }, { value: 'oldestLiveDate', label: 'live date (oldest)' }];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'analytics-asset-list' },
	        loading && _react2.default.createElement(
	          'div',
	          { className: 'discussion-preloader' },
	          _react2.default.createElement('img', { src: '/icons/dyzio-icon.svg', alt: 'Loading...' })
	        ),
	        hasTrackedDeliverables && !loading && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'video-list-filtering-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'filter-by' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Filter videos'
	              ),
	              _react2.default.createElement(_reactSelect2.default, {
	                name: 'filterBy',
	                label: '',
	                value: filterBy,
	                className: 'select',
	                options: filterByOptions,
	                onChange: this.filterAssetList,
	                clearable: false
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sort-by' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Sort by'
	              ),
	              _react2.default.createElement(_reactSelect2.default, {
	                name: 'sortBy',
	                label: '',
	                value: sortBy,
	                className: 'select',
	                options: sortByOptions,
	                onChange: this.sortAssetList,
	                clearable: false
	              })
	            )
	          ),
	          _react2.default.createElement('div', { className: 'spacer small' }),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Tracked deliverables'
	          ),
	          filteredYoutubeVideos.size > 0 && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(_analyticsAssetListHeader2.default, { listName: _staticConfiguration.YOUTUBE, listSize: filteredYoutubeVideos.size, showAnalyticTotals: showAnalyticTotals, openEngagementScoreModal: this.showModal(_staticConfiguration.ENGAGEMENT_SCORE) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'asset-list' },
	              filteredYoutubeVideos.map(function (trackedAsset) {
	                return _react2.default.createElement(_analyticsAssetListContent2.default, { key: trackedAsset.get('id'), data: trackedAsset, filterBy: filterBy, viewVideo: _this2.openAssetPage(trackedAsset.get('assetId')), openEngagementScoreModal: _this2.showModal(_staticConfiguration.ENGAGEMENT_SCORE) });
	              })
	            ),
	            showAnalyticTotals && _react2.default.createElement(_analyticsAssetListTotals2.default, { listName: _staticConfiguration.YOUTUBE, listSize: filteredYoutubeVideos.size, totals: youtubeTotals, openEngagementScoreModal: this.showModal(_staticConfiguration.ENGAGEMENT_SCORE) })
	          ),
	          filteredInstagramPosts.size > 0 && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(_analyticsAssetListHeader2.default, { listName: _staticConfiguration.INSTAGRAM, listSize: filteredInstagramPosts.size, showAnalyticTotals: showAnalyticTotals, openEngagementScoreModal: this.showModal(_staticConfiguration.ENGAGEMENT_SCORE) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'asset-list' },
	              filteredInstagramPosts.map(function (trackedAsset) {
	                return _react2.default.createElement(_analyticsAssetListContent2.default, { key: trackedAsset.get('id'), data: trackedAsset, filterBy: filterBy, viewVideo: _this2.openAssetPage(trackedAsset.get('assetId')), openEngagementScoreModal: _this2.showModal(_staticConfiguration.ENGAGEMENT_SCORE) });
	              })
	            ),
	            showAnalyticTotals && _react2.default.createElement(_analyticsAssetListTotals2.default, { listName: _staticConfiguration.INSTAGRAM, listSize: filteredInstagramPosts.size, totals: instagramTotals, openEngagementScoreModal: this.showModal(_staticConfiguration.ENGAGEMENT_SCORE) })
	          ),
	          filteredFacebookPosts.size > 0 && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(_analyticsAssetListHeader2.default, { listName: _staticConfiguration.FACEBOOK, listSize: filteredFacebookPosts.size, showAnalyticTotals: showAnalyticTotals, openEngagementScoreModal: this.showModal(_staticConfiguration.ENGAGEMENT_SCORE) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'asset-list' },
	              filteredFacebookPosts.map(function (trackedAsset) {
	                return _react2.default.createElement(_analyticsAssetListContent2.default, { key: trackedAsset.get('id'), data: trackedAsset, filterBy: filterBy, viewVideo: _this2.openAssetPage(trackedAsset.get('assetId')), openEngagementScoreModal: _this2.showModal(_staticConfiguration.ENGAGEMENT_SCORE) });
	              })
	            ),
	            showAnalyticTotals && _react2.default.createElement(_analyticsAssetListTotals2.default, { listName: _staticConfiguration.FACEBOOK, listSize: filteredFacebookPosts.size, totals: facebookTotals, openEngagementScoreModal: this.showModal(_staticConfiguration.ENGAGEMENT_SCORE) })
	          ),
	          filteredTwitterPosts && filteredTwitterPosts.size > 0 && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(_analyticsAssetListHeader2.default, { listName: _staticConfiguration.TWITTER, listSize: filteredTwitterPosts.size, showAnalyticTotals: showAnalyticTotals, openEngagementScoreModal: this.showModal(_staticConfiguration.ENGAGEMENT_SCORE) }),
	            _react2.default.createElement(
	              'div',
	              { className: 'asset-list' },
	              filteredTwitterPosts.map(function (trackedAsset) {
	                return _react2.default.createElement(_analyticsAssetListContent2.default, {
	                  key: trackedAsset.get('id'),
	                  data: trackedAsset,
	                  filterBy: filterBy,
	                  viewVideo: _this2.openAssetPage(trackedAsset.get('assetId')),
	                  openEngagementScoreModal: _this2.showModal(_staticConfiguration.ENGAGEMENT_SCORE)
	                });
	              })
	            ),
	            showAnalyticTotals && _react2.default.createElement(_analyticsAssetListTotals2.default, { listName: _staticConfiguration.TWITTER, listSize: filteredTwitterPosts.size, totals: twitterTotals, openEngagementScoreModal: this.showModal(_staticConfiguration.ENGAGEMENT_SCORE) })
	          ),
	          _react2.default.createElement(_engagementScoreModal2.default, null)
	        ),
	        !hasTrackedDeliverables && !loading && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('div', { className: 'spacer' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'box centered' },
	            _react2.default.createElement(
	              'div',
	              { className: 'box-content-one' },
	              _react2.default.createElement(
	                'div',
	                { className: 'box-content-two' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-content-three' },
	                  _react2.default.createElement('div', { className: 'spacer' }),
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    'You\u2019re not tracking any live deliverables yet.',
	                    _react2.default.createElement('br', null),
	                    'Let\u2019s get started!'
	                  ),
	                  _react2.default.createElement('div', { className: 'spacer large' }),
	                  _react2.default.createElement('img', { src: '/graph.svg', alt: 'let\'s get started' }),
	                  _react2.default.createElement('div', { className: 'spacer large' }),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'You can currently track Youtube, Facebook and Instagram deliverables. Twitter coming soon!'
	                  ),
	                  _react2.default.createElement('div', { className: 'spacer' }),
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'large rose wide', onClick: this.showModal(_staticConfiguration.TRACKED_ASSET) },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Track a deliverable'
	                    )
	                  ),
	                  _react2.default.createElement('div', { className: 'spacer' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AnalyticsAssetList;
	}(_react2.default.Component);
	
	AnalyticsAssetList.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    userData: state.userData.get('userData'),
	    loading: state.analyticsAssetList.get('loading'),
	    sortBy: state.analyticsAssetList.get('sortBy'),
	    filterBy: state.analyticsAssetList.get('filterBy'),
	    filteredYoutubeVideos: state.analyticsAssetList.get('filteredYoutubeVideos'),
	    filteredInstagramPosts: state.analyticsAssetList.get('filteredInstagramPosts'),
	    filteredFacebookPosts: state.analyticsAssetList.get('filteredFacebookPosts'),
	    filteredTwitterPosts: state.analyticsAssetList.get('filteredTwitterPosts'),
	    hasTrackedDeliverables: state.analyticsAssetList.get('hasTrackedDeliverables'),
	    filterByOptions: state.analyticsAssetList.get('filterByOptions'),
	    showAnalyticTotals: state.analyticsAssetList.get('showAnalyticTotals'),
	    youtubeTotals: state.analyticsAssetList.get('youtubeTotals'),
	    instagramTotals: state.analyticsAssetList.get('instagramTotals'),
	    facebookTotals: state.analyticsAssetList.get('facebookTotals')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onSetModal: function onSetModal(modalName) {
	      return dispatch((0, _modal.setModal)(modalName));
	    },
	    onLoadAnalyticsAssetList: function onLoadAnalyticsAssetList() {
	      return dispatch((0, _actions.loadAnalyticsAssetList)());
	    },
	    onSortAnalyticsAssetList: function onSortAnalyticsAssetList(data) {
	      return dispatch((0, _actions.sortAnalyticsAssetList)(data));
	    },
	    onFilterAnalyticsAssetList: function onFilterAnalyticsAssetList(data) {
	      return dispatch((0, _actions.filterAnalyticsAssetList)(data));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AnalyticsAssetList);

/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(279);
	
	var initialState = (0, _immutable.fromJS)({
	  youtubeVideos: {},
	  filteredYoutubeVideos: {},
	  instagramPosts: {},
	  filteredInstagramPosts: {},
	  facebookPosts: {},
	  filteredFacebookPosts: {},
	  twitterPosts: {},
	  filteredTwitterPosts: {},
	  campaignVideos: {},
	  userVideos: {},
	  filterByOptions: [],
	  hasTrackedDeliverables: false,
	  loading: false,
	  error: null,
	  sortBy: 'highestViews',
	  filterBy: 'allVideos',
	  showAnalyticTotals: false,
	  youtubeTotals: {},
	  instagramTotals: {},
	  facebookTotals: {}
	});
	
	function analyticsAssetListReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.LOAD_ANALYTICS_ASSET_LIST:
	      return state.set('youtubeVideos', (0, _immutable.fromJS)({})).set('filteredYoutubeVideos', (0, _immutable.fromJS)({})).set('instagramPosts', (0, _immutable.fromJS)({})).set('filteredInstagramPosts', (0, _immutable.fromJS)({})).set('facebookPosts', (0, _immutable.fromJS)({})).set('filteredFacebookPosts', (0, _immutable.fromJS)({})).set('twitterPosts', (0, _immutable.fromJS)({})).set('filteredTwitterPosts', (0, _immutable.fromJS)({})).set('hasTrackedDeliverables', false).set('loading', true).set('error', null);
	    case _constants.LOAD_ANALYTICS_ASSET_LIST_SUCCESS:
	      return state.set('youtubeVideos', action.youtubeVideos).set('filteredYoutubeVideos', action.youtubeVideos).set('instagramPosts', action.instagramPosts).set('filteredInstagramPosts', action.instagramPosts).set('facebookPosts', action.facebookPosts).set('filteredFacebookPosts', action.facebookPosts).set('twitterPosts', action.twitterPosts).set('filteredTwitterPosts', action.twitterPosts).set('userVideos', action.userVideos).set('campaignVideos', action.campaignVideos).set('filterByOptions', action.filterByOptions).set('hasTrackedDeliverables', action.hasTrackedDeliverables).set('loading', false).set('error', null);
	    case _constants.LOAD_ANALYTICS_ASSET_LIST_ERROR:
	      return state.set('loading', false).set('error', action.error);
	    case _constants.UPDATE_ANALYTICS_ASSET_LIST:
	      return state.set('filteredYoutubeVideos', action.filteredYoutubeVideos).set('filteredInstagramPosts', action.filteredInstagramPosts).set('filteredFacebookPosts', action.filteredFacebookPosts).set('filteredTwitterPosts', action.filteredTwitterPosts).set('hasTrackedDeliverables', true).set('sortBy', action.sortBy).set('filterBy', action.filterBy).set('showAnalyticTotals', action.showAnalyticTotals).set('youtubeTotals', action.youtubeTotals).set('instagramTotals', action.instagramTotals).set('facebookTotals', action.facebookTotals);
	    case _constants.ADD_TRACKED_ASSET_TO_LIST:
	      {
	        var updatedState = void 0;
	        if (!state.getIn([action.assetList, action.assetId])) updatedState = state.setIn([action.assetList, action.assetId], action.newAsset);
	        return updatedState.setIn(['userVideos', action.assetId], action.newAsset).set('sortBy', initialState.get('sortBy')).set('filterBy', initialState.get('filterBy'));
	      }
	    case _constants.GET_NEW_ASSET_ERROR:
	      return state.set('error', action.error).set('loading', false);
	    default:
	      return state;
	  }
	}
	
	exports.default = analyticsAssetListReducer;

/***/ },
/* 2052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setAssetPageBackLink = setAssetPageBackLink;
	
	var _constants = __webpack_require__(555);
	
	function setAssetPageBackLink(data) {
	  return {
	    type: _constants.SET_ASSET_PAGE_BACK_LINK,
	    data: data
	  };
	}

/***/ },
/* 2053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _reactTweetEmbed = __webpack_require__(469);
	
	var _reactTweetEmbed2 = _interopRequireDefault(_reactTweetEmbed);
	
	var _analyticsService = __webpack_require__(928);
	
	var _actions = __webpack_require__(2052);
	
	var _analyticsVideoInfoCard = __webpack_require__(1881);
	
	var _analyticsVideoInfoCard2 = _interopRequireDefault(_analyticsVideoInfoCard);
	
	var _analyticsInfluencerCard = __webpack_require__(1880);
	
	var _analyticsInfluencerCard2 = _interopRequireDefault(_analyticsInfluencerCard);
	
	var _trackedAssets = __webpack_require__(570);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _modal = __webpack_require__(103);
	
	var _engagementScoreModal = __webpack_require__(871);
	
	var _engagementScoreModal2 = _interopRequireDefault(_engagementScoreModal);
	
	var _chart = __webpack_require__(1912);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _tags = __webpack_require__(2028);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _trackedAssetHelpers = __webpack_require__(937);
	
	var _trackedAssetsAnalyticsService = __webpack_require__(173);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnalyticsAsset = function (_React$Component) {
	  _inherits(AnalyticsAsset, _React$Component);
	
	  function AnalyticsAsset(props, context) {
	    _classCallCheck(this, AnalyticsAsset);
	
	    var _this = _possibleConstructorReturn(this, (AnalyticsAsset.__proto__ || Object.getPrototypeOf(AnalyticsAsset)).call(this, props, context));
	
	    _this.handleBudgetChange = function (event) {
	      _this.setState({ budget: event.target.value });
	    };
	
	    _this.setBackLink = function (backLink) {
	      _this.props.onSetAssetPageBackLink({ backLink: backLink });
	    };
	
	    _this.navigateBack = function () {
	      _this.context.router.goBack();
	    };
	
	    _this.showModal = function (docType) {
	      return function () {
	        return _this.props.onSetModal(docType);
	      };
	    };
	
	    _this.state = {
	      trackedAsset: {},
	      campaignTrackedAsset: null,
	      budget: '',
	      loading: false,
	      error: null,
	      campaignError: null,
	      influencerProfile: null
	    };
	    return _this;
	  }
	
	  _createClass(AnalyticsAsset, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var assetId = this.props.routeParams.id;
	      this.getTrackedAsset(assetId);
	    }
	  }, {
	    key: 'getTrackedAsset',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(assetId) {
	        var trackedAssets, trackedAsset, campaignTrackedAsset, trackedAssetAnalytics, analyticsData, updatedTrackedAsset, data, influencerProfile;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	
	                this.setState({ loading: true });
	
	                _context.next = 4;
	                return (0, _trackedAssets.getTrackedAsset)(assetId);
	
	              case 4:
	                trackedAssets = _context.sent;
	                trackedAsset = trackedAssets[0];
	                campaignTrackedAsset = trackedAssets.find(function (trackedAsset) {
	                  return trackedAsset.campaign && trackedAsset.campaign.id && trackedAsset.discussion && trackedAsset.discussion.id;
	                });
	
	                this.setState({ campaignTrackedAsset: campaignTrackedAsset });
	
	                _context.next = 10;
	                return (0, _trackedAssetsAnalyticsService.getTrackedAssetAnalytics)([trackedAssets[0]]);
	
	              case 10:
	                trackedAssetAnalytics = _context.sent;
	
	
	                if (trackedAsset.platform === _staticConfiguration.TWITTER) {
	                  this.setState({ tweet: trackedAsset });
	                }
	
	                analyticsData = null;
	                updatedTrackedAsset = null;
	                data = trackedAssetAnalytics[0].response.data;
	
	                if (data) {
	                  if (trackedAsset.platform === _staticConfiguration.YOUTUBE) analyticsData = (0, _trackedAssetHelpers.formatYoutubeVideoAnalytics)(data);
	                  if (trackedAsset.platform === _staticConfiguration.INSTAGRAM) analyticsData = (0, _trackedAssetHelpers.formatInstagramAnalytics)(data);
	                  if (trackedAsset.platform === _staticConfiguration.FACEBOOK) analyticsData = (0, _trackedAssetHelpers.formatFacebookAnalytics)(data);
	
	                  if (analyticsData) {
	                    updatedTrackedAsset = _extends({}, analyticsData, trackedAsset);
	                    if (!updatedTrackedAsset.campaign && !updatedTrackedAsset.discussion) updatedTrackedAsset.isUserAsset = true;
	                    this.setState({ trackedAsset: updatedTrackedAsset });
	                  }
	                }
	
	                if (!data.influencerId) {
	                  _context.next = 22;
	                  break;
	                }
	
	                _context.next = 19;
	                return (0, _analyticsService.getInfluencerProfile)(data.influencerId);
	
	              case 19:
	                _context.t0 = _context.sent;
	                _context.next = 23;
	                break;
	
	              case 22:
	                _context.t0 = null;
	
	              case 23:
	                influencerProfile = _context.t0;
	
	                this.setState({ influencerProfile: influencerProfile, loading: false, error: null });
	                _context.next = 31;
	                break;
	
	              case 27:
	                _context.prev = 27;
	                _context.t1 = _context['catch'](0);
	
	                (0, _errorHandlingService.reportError)('GET_CAMPAIGN_TRACKED_ASSET_ERROR', _context.t1.message);
	                this.setState({ campaignError: _context.t1, loading: false });
	
	              case 31:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[0, 27]]);
	      }));
	
	      function getTrackedAsset(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getTrackedAsset;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var backLink = this.props.backLink;
	      var _state = this.state,
	          trackedAsset = _state.trackedAsset,
	          budget = _state.budget,
	          influencerProfile = _state.influencerProfile,
	          loading = _state.loading,
	          error = _state.error,
	          campaignTrackedAsset = _state.campaignTrackedAsset,
	          tweet = _state.tweet;
	
	      if (!trackedAsset) return null;
	
	      var tweetWrapper = {
	        backgroundColor: 'white',
	        paddingTop: 50,
	        paddingBottom: 50,
	        marginTop: 50
	      };
	
	      var platformIconOptions = {
	        YOUTUBE: '/icons/youtube-round.svg',
	        FACEBOOK: '/icons/facebook-round.svg',
	        INSTAGRAM: '/icons/instagram-round.svg',
	        SNAPCHAT: '/icons/snapchat-round.svg',
	        TWITTER: '/icons/twitter-round.svg'
	      };
	
	      if (tweet) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'page' },
	          _react2.default.createElement(
	            'div',
	            { className: 'page-content' },
	            _react2.default.createElement(_engagementScoreModal2.default, null),
	            !loading && !error && _react2.default.createElement(
	              'div',
	              { className: 'grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'breadcrumb-bar' },
	                  _react2.default.createElement('img', { src: '/icons/chevron-left.svg', alt: 'back to analytics', onClick: function onClick() {
	                      return _this2.context.router.push('/analytics');
	                    } }),
	                  _react2.default.createElement(
	                    'h3',
	                    { onClick: this.navigateBack },
	                    'Back to Dashboard'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'asset-page-header' },
	                  _react2.default.createElement('img', { src: platformIconOptions[tweet.platform] }),
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Tweet'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { key: tweet.id, style: tweetWrapper },
	                  _react2.default.createElement(_reactTweetEmbed2.default, {
	                    options: {
	                      align: 'center'
	                    },
	                    id: tweet.assetId
	                  })
	                )
	              )
	            ),
	            !loading && error && _react2.default.createElement(
	              'p',
	              null,
	              'Error: ',
	              error
	            ),
	            loading && _react2.default.createElement(
	              'div',
	              { className: 'discussion-preloader' },
	              _react2.default.createElement('img', { src: '/icons/dyzio-icon.svg', alt: 'Loading...' })
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(_engagementScoreModal2.default, null),
	          !loading && !error && _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'breadcrumb-bar' },
	                _react2.default.createElement('img', { src: '/icons/chevron-left.svg', alt: 'back to analytics', onClick: function onClick() {
	                    return _this2.context.router.push('/analytics');
	                  } }),
	                _react2.default.createElement(
	                  'h3',
	                  { onClick: this.navigateBack },
	                  'Back to Dashboard'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'asset-page-header' },
	                _react2.default.createElement('img', { src: platformIconOptions[trackedAsset.platform] }),
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  trackedAsset.title ? trackedAsset.title.slice(0, 25) + '...' : 'No title'
	                )
	              ),
	              campaignTrackedAsset && _react2.default.createElement(
	                'h2',
	                null,
	                'Campaign: ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'normal', onClick: function onClick() {
	                      return _this2.context.router.push('/campaign/' + campaignTrackedAsset.campaign.id);
	                    } },
	                  campaignTrackedAsset.campaign.name
	                ),
	                ' > ',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'normal', onClick: function onClick() {
	                      return _this2.context.router.push('/campaign/discussion/' + campaignTrackedAsset.discussion.id);
	                    } },
	                  campaignTrackedAsset.discussion.name
	                )
	              )
	            ),
	            trackedAsset && influencerProfile && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'light' },
	                    'INFLUENCER PROFILE'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(_analyticsInfluencerCard2.default, { trackedAsset: trackedAsset, influencerProfile: influencerProfile })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              _react2.default.createElement(
	                'h5',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'light' },
	                  'BASIC INFO'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              trackedAsset && _react2.default.createElement(_analyticsVideoInfoCard2.default, { trackedAsset: trackedAsset, budget: budget, onBudgetChange: this.handleBudgetChange, openEngagementScoreModal: this.showModal(_staticConfiguration.ENGAGEMENT_SCORE) })
	            ),
	            trackedAsset && trackedAsset.platform === _staticConfiguration.YOUTUBE && _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              _react2.default.createElement(
	                'h5',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'light' },
	                  'DETAILED BREAKDOWN'
	                )
	              )
	            ),
	            trackedAsset && trackedAsset.platform === _staticConfiguration.YOUTUBE && _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              _react2.default.createElement(_chart2.default, { trackedAsset: trackedAsset })
	            ),
	            trackedAsset && trackedAsset.platform === 'YOUTUBE_COMPLIANCE_CHECK' && _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              _react2.default.createElement(
	                'h5',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'light' },
	                  'TOP KEYWORDS'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'small light' },
	                'this tag cloud shows the top keywords in the videos comments'
	              )
	            ),
	            trackedAsset && trackedAsset.platform === 'YOUTUBE_COMPLIANCE_CHECK' && _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              _react2.default.createElement(_tags2.default, { youtubeVideoId: trackedAsset.assetId })
	            )
	          ),
	          !loading && error && _react2.default.createElement(
	            'p',
	            null,
	            'Error: ',
	            error
	          ),
	          loading && _react2.default.createElement(
	            'div',
	            { className: 'discussion-preloader' },
	            _react2.default.createElement('img', { src: '/icons/dyzio-icon.svg', alt: 'Loading...' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AnalyticsAsset;
	}(_react2.default.Component);
	
	AnalyticsAsset.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    backLink: state.analyticsAsset.get('backLink')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onSetModal: function onSetModal(modalName) {
	      return dispatch((0, _modal.setModal)(modalName));
	    },
	    onSetAssetPageBackLink: function onSetAssetPageBackLink(data) {
	      return dispatch((0, _actions.setAssetPageBackLink)(data));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AnalyticsAsset);

/***/ },
/* 2054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(555);
	
	var initialState = (0, _immutable.fromJS)({
	  backLink: null
	});
	
	function analyticsAssetReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_ASSET_PAGE_BACK_LINK:
	      return state.set('backLink', action.backLink);
	    default:
	      return state;
	  }
	}
	
	exports.default = analyticsAssetReducer;

/***/ },
/* 2055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _analyticsAssetList = __webpack_require__(2050);
	
	var _analyticsAssetList2 = _interopRequireDefault(_analyticsAssetList);
	
	var _trackAssetModal = __webpack_require__(2222);
	
	var _trackAssetModal2 = _interopRequireDefault(_trackAssetModal);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _modal = __webpack_require__(103);
	
	var _plainHeader = __webpack_require__(350);
	
	var _plainHeader2 = _interopRequireDefault(_plainHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Analytics = function (_Component) {
	  _inherits(Analytics, _Component);
	
	  function Analytics() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Analytics);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Analytics.__proto__ || Object.getPrototypeOf(Analytics)).call.apply(_ref, [this].concat(args))), _this), _this.showModal = function (docType) {
	      return function () {
	        return _this.props.onSetModal(docType);
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Analytics, [{
	    key: 'render',
	    value: function render() {
	      var hasTrackedDeliverables = this.props.hasTrackedDeliverables;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        hasTrackedDeliverables && _react2.default.createElement(
	          'div',
	          { className: 'white-header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row large' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-spacer' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Live analytics'
	              )
	            ),
	            _react2.default.createElement('div', { className: 'flex-item' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-item' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'You can track Youtube, Facebook and Instagram deliverables. Twitter coming soon!'
	              )
	            ),
	            _react2.default.createElement('div', { className: 'flex-spacer' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-item' },
	              _react2.default.createElement(
	                'div',
	                { className: 'text-button-container' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.showModal(_staticConfiguration.TRACKED_ASSET) },
	                    'track a new deliverable '
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'medium rose add-button', onClick: this.showModal(_staticConfiguration.TRACKED_ASSET) },
	                  _react2.default.createElement('img', { className: 'image', src: '/icons/add.svg' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'spacer' })
	        ),
	        !hasTrackedDeliverables && _react2.default.createElement(
	          'div',
	          { className: 'padded-content' },
	          _react2.default.createElement(_plainHeader2.default, { title: 'Live analytics' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(_analyticsAssetList2.default, null)
	        ),
	        _react2.default.createElement(_trackAssetModal2.default, null)
	      );
	    }
	  }]);
	
	  return Analytics;
	}(_react.Component);
	
	Analytics.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    hasTrackedDeliverables: state.analyticsAssetList.get('hasTrackedDeliverables')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onSetModal: function onSetModal(modalName) {
	      return dispatch((0, _modal.setModal)(modalName));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Analytics);

/***/ },
/* 2056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _recompose = __webpack_require__(15);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _influencerTag = __webpack_require__(882);
	
	var _influencerTag2 = _interopRequireDefault(_influencerTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var helpUrl = 'https://help.dyzio.co/en/articles/5137000-adding-business-units-or-brands';
	
	var helpLinkStyle = {
	  color: 'rgb(32, 196, 158)'
	};
	
	var businessUnitsContainerStyle = {
	  minHeight: 50
	};
	
	var errorStyle = {
	  color: '#ef3a50',
	  fontSize: 12,
	  fontWeight: 'bold'
	};
	
	var BusinessUnitsManager = function (_React$Component) {
	  _inherits(BusinessUnitsManager, _React$Component);
	
	  //
	  function BusinessUnitsManager() {
	    var _this2 = this;
	
	    _classCallCheck(this, BusinessUnitsManager);
	
	    var _this = _possibleConstructorReturn(this, (BusinessUnitsManager.__proto__ || Object.getPrototypeOf(BusinessUnitsManager)).call(this));
	
	    _this.onInputChanged = function (event, _ref) {
	      var value = _ref.value;
	
	      _this.setState({
	        newBusinessUnitValue: value
	      });
	    };
	
	    _this.onLoadBusinessUnits = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, restClient, organisationId, response, businessUnits;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, restClient = _this$props.restClient, organisationId = _this$props.userInfo.organisationId;
	
	              _this.setState({
	                isLoadingBusinessUnits: true
	              });
	              _context.next = 4;
	              return restClient.get('businessUnits?filter[organisation]=' + organisationId);
	
	            case 4:
	              response = _context.sent;
	              businessUnits = _lodash2.default.get(response, 'data.data', []);
	
	              _this.setState({
	                businessUnits: businessUnits,
	                isLoadingBusinessUnits: false,
	                businessUnitsLoaded: true
	              });
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.onBusinessUnitSelected = function (businessUnitId) {
	      _this.setState({
	        editedBusinessUnitId: businessUnitId
	      });
	    };
	
	    _this.onAddNewBusinessUnit = function () {
	      var _this$props2 = _this.props,
	          restClient = _this$props2.restClient,
	          _this$props2$userInfo = _this$props2.userInfo,
	          name = _this$props2$userInfo.name,
	          organisationId = _this$props2$userInfo.organisationId;
	      var newBusinessUnitValue = _this.state.newBusinessUnitValue;
	
	      _this.setState({
	        isAddingANewBusinessUnit: true
	      }, _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var postData;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                postData = {
	                  attributes: {
	                    value: newBusinessUnitValue,
	                    createdBy: name,
	                    organisation: {
	                      type: 'organisations',
	                      id: organisationId
	                    }
	                  }
	                };
	                _context2.next = 3;
	                return restClient.post('/businessUnits', {
	                  data: postData
	                });
	
	              case 3:
	                _this.setState({
	                  isAddingANewBusinessUnit: false,
	                  isLoadingBusinessUnits: true,
	                  newBusinessUnitValue: ''
	                }, _this.onLoadBusinessUnits);
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      })));
	    };
	
	    _this.onDeleteBusinessUnit = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(businessUnitId) {
	        var restClient;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                restClient = _this.props.restClient;
	                _context3.next = 3;
	                return restClient.delete('businessUnits/' + businessUnitId);
	
	              case 3:
	                _context3.next = 5;
	                return _this.onLoadBusinessUnits();
	
	              case 5:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.onSaveBusinessUnit = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(businessUnitId, value) {
	        var restClient;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                restClient = _this.props.restClient;
	                _context4.next = 3;
	                return restClient.patch('businessUnits/' + businessUnitId, {
	                  data: {
	                    attributes: {
	                      value: value
	                    }
	                  }
	                });
	
	              case 3:
	                _context4.next = 5;
	                return _this.onLoadBusinessUnits();
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x2, _x3) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      businessUnits: [],
	      newBusinessUnitValue: '',
	      isLoadingBusinessUnits: true,
	      businessUnitsLoaded: false,
	      isAddingBusinessUnit: false
	    };
	    return _this;
	  }
	
	  _createClass(BusinessUnitsManager, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return this.onLoadBusinessUnits();
	
	              case 2:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          newBusinessUnitValue = _state.newBusinessUnitValue,
	          isAddingANewBusinessUnit = _state.isAddingANewBusinessUnit,
	          isLoadingBusinessUnits = _state.isLoadingBusinessUnits,
	          businessUnits = _state.businessUnits,
	          businessUnitsLoaded = _state.businessUnitsLoaded;
	
	      var duplicateBusinessUnitToBeAdded = _lodash2.default.some(businessUnits, ['attributes.value', newBusinessUnitValue]);
	      var actionProps = {
	        disabled: _lodash2.default.isEmpty(_lodash2.default.trim(newBusinessUnitValue)) || duplicateBusinessUnitToBeAdded,
	        icon: 'plus',
	        content: 'Add business unit or brand',
	        loading: isAddingANewBusinessUnit,
	        onClick: this.onAddNewBusinessUnit
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Add and manage a list of business units or brands that your organisation supports.',
	              _react2.default.createElement('br', null),
	              'Once this list is created, you can add multiple business units or brands to each of the influencers in your database.',
	              _react2.default.createElement('br', null),
	              'This enables you to filter your database, based on the business unit - so you will only see the relevant influencers.'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            { extra: true },
	            _react2.default.createElement(
	              _targetLink2.default,
	              { style: helpLinkStyle, href: helpUrl, renderIf: true },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'help', circular: true }),
	              'click here for help'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Business Units or Brand Name'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Add, edit or delete your business units or brands'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            isLoadingBusinessUnits && _react2.default.createElement(
	              _semanticUiReact.Segment,
	              {
	                style: businessUnitsContainerStyle,
	                basic: true
	              },
	              _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading new business units...' })
	            ),
	            !isLoadingBusinessUnits && _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { basic: true, style: businessUnitsContainerStyle },
	              businessUnitsLoaded && _lodash2.default.isEmpty(businessUnits) && _react2.default.createElement(_semanticUiReact.Message, { warning: true, content: 'No business units created yet.' }),
	              _react2.default.createElement(
	                _semanticUiReact.Label.Group,
	                null,
	                _lodash2.default.map(businessUnits, function (businessUnit) {
	                  return _react2.default.createElement(_influencerTag2.default, Object.assign({
	                    key: businessUnit.id,
	                    onClick: _this3.onBusinessUnitSelected,
	                    onSave: _this3.onSaveBusinessUnit,
	                    onDelete: _this3.onDeleteBusinessUnit
	                  }, businessUnit));
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(_semanticUiReact.Input, {
	              fluid: true,
	              value: newBusinessUnitValue,
	              action: actionProps,
	              onChange: this.onInputChanged,
	              placeholder: 'Add a new business unit or brand name'
	            }),
	            duplicateBusinessUnitToBeAdded && _react2.default.createElement(
	              'span',
	              { style: errorStyle },
	              'This business unit already exists'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BusinessUnitsManager;
	}(_react2.default.Component);
	
	BusinessUnitsManager.propTypes = {
	  restClient: _propTypes2.default.func.isRequired,
	  userInfo: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(BusinessUnitsManager);

/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(355);
	
	var initialState = (0, _immutable.fromJS)({
	  youtubeVideos: {},
	  facebookPosts: {},
	  twitterPosts: {},
	  instagramPosts: {},
	  hasTrackedDeliverables: false,
	  youtubeTotals: {},
	  instagramTotals: {},
	  facebookTotals: {},
	  twitterTotals: {},
	  loading: false,
	  error: null
	});
	
	function campaignAnalyticsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.LOAD_CAMPAIGN_ANALYTICS:
	      return state.set('youtubeVideos', (0, _immutable.fromJS)({})).set('facebookPosts', (0, _immutable.fromJS)({})).set('twitterPosts', (0, _immutable.fromJS)({})).set('instagramPosts', (0, _immutable.fromJS)({})).set('youtubeTotals', (0, _immutable.fromJS)({})).set('instagramTotals', (0, _immutable.fromJS)({})).set('twitterTotals', (0, _immutable.fromJS)({})).set('hasTrackedDeliverables', false).set('error', null);
	    case _constants.LOAD_CAMPAIGN_ANALYTICS_SET_LOADING:
	      return state.set('loading', action.loading);
	    case _constants.LOAD_CAMPAIGN_ANALYTICS_SUCCESS:
	      return state.set('loading', false).set('youtubeVideos', action.youtubeVideos).set('facebookPosts', action.facebookPosts).set('twitterPosts', action.twitterPosts).set('instagramPosts', action.instagramPosts).set('youtubeTotals', action.youtubeTotals).set('instagramTotals', action.instagramTotals).set('facebookTotals', action.facebookTotals).set('twitterTotals', action.twitterTotals).set('hasTrackedDeliverables', action.hasTrackedDeliverables);
	    case _constants.LOAD_CAMPAIGN_ANALYTICS_ERROR:
	      return state.set('loading', false).set('error', action.error);
	    case _constants.UPDATE_CAMPAIGN_ANALYTICS:
	      return state.set('hasTrackedDeliverables', true).setIn([action.assetList, action.assetId], action.newAsset);
	    case _constants.UPDATE_CAMPAIGN_ANALYTICS_TOTALS:
	      return state.set('youtubeTotals', action.youtubeTotals).set('instagramTotals', action.instagramTotals).set('facebookTotals', action.facebookTotals).set('twitterTotals', action.twitterTotals);
	    default:
	      return state;
	  }
	}
	
	exports.default = campaignAnalyticsReducer;

/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.loadCampaignAnalytics = loadCampaignAnalytics;
	exports.addTrackedAssetToStateList = addTrackedAssetToStateList;
	exports.watchLoadCampaignAnalytics = watchLoadCampaignAnalytics;
	exports.watchGetNewCampaignTrackedAsset = watchGetNewCampaignTrackedAsset;
	exports.default = campaignAnalyticsSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _campaigns = __webpack_require__(129);
	
	var _trackedAssetsAnalyticsService = __webpack_require__(173);
	
	var _campaignAnalyticsSelectors = __webpack_require__(2259);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _sagas = __webpack_require__(903);
	
	var _constants = __webpack_require__(279);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _constants2 = __webpack_require__(555);
	
	var _constants3 = __webpack_require__(355);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadCampaignAnalytics, addTrackedAssetToStateList, watchLoadCampaignAnalytics, watchGetNewCampaignTrackedAsset, campaignAnalyticsSagas].map(_regenerator2.default.mark);
	
	function loadCampaignAnalytics(actions) {
	  var analyticsLoading, campaignId, trackedAssetsList, formattedTrackedAssetList, trackedAssetsAnalyticsList, youtubeVideos, instagramPosts, facebookPosts, twitterPosts, platformOptions, immutableYoutubeVideoList, immutableInstagramPostList, immutableFacebookPostList, immutableTwitterPostList, hasTrackedDeliverables, youtubeTotals, instagramTotals, facebookTotals, twitterTotals;
	  return _regenerator2.default.wrap(function loadCampaignAnalytics$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.select)(_campaignAnalyticsSelectors.isLoading);
	
	        case 3:
	          analyticsLoading = _context.sent;
	
	          if (analyticsLoading) {
	            _context.next = 35;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.put)({ type: _constants3.LOAD_CAMPAIGN_ANALYTICS_SET_LOADING, loading: true });
	
	        case 7:
	          campaignId = actions.data.campaignId;
	          _context.next = 10;
	          return (0, _effects.call)(_campaigns.getCampaignTrackedAssets, campaignId);
	
	        case 10:
	          trackedAssetsList = _context.sent;
	          formattedTrackedAssetList = {};
	
	          trackedAssetsList.forEach(function (trackedAsset) {
	            return _lodash2.default.set(formattedTrackedAssetList, [trackedAsset.assetId], trackedAsset);
	          });
	
	          // Get the data for all trackedAssets
	          _context.next = 15;
	          return (0, _effects.call)(_trackedAssetsAnalyticsService.getTrackedAssetAnalytics, trackedAssetsList);
	
	        case 15:
	          trackedAssetsAnalyticsList = _context.sent;
	          youtubeVideos = {};
	          instagramPosts = {};
	          facebookPosts = {};
	          twitterPosts = {};
	          platformOptions = {
	            YOUTUBE: youtubeVideos,
	            INSTAGRAM: instagramPosts,
	            FACEBOOK: facebookPosts,
	            TWITTER: twitterPosts
	          };
	
	
	          (0, _sagas.extractAnalyticsIntoPlatformChannels)(trackedAssetsAnalyticsList, formattedTrackedAssetList, platformOptions);
	
	          immutableYoutubeVideoList = (0, _immutable.fromJS)(youtubeVideos);
	          immutableInstagramPostList = (0, _immutable.fromJS)(instagramPosts);
	          immutableFacebookPostList = (0, _immutable.fromJS)(facebookPosts);
	          immutableTwitterPostList = (0, _immutable.fromJS)(twitterPosts);
	          hasTrackedDeliverables = immutableYoutubeVideoList.size > 0 || immutableInstagramPostList.size > 0 || immutableFacebookPostList.size > 0 || immutableTwitterPostList.size > 0;
	          youtubeTotals = (0, _sagas.extractAnalyticsTotalData)(immutableYoutubeVideoList, _staticConfiguration.YOUTUBE);
	          instagramTotals = (0, _sagas.extractAnalyticsTotalData)(immutableInstagramPostList, _staticConfiguration.INSTAGRAM);
	          facebookTotals = (0, _sagas.extractAnalyticsTotalData)(immutableFacebookPostList, _staticConfiguration.FACEBOOK);
	          twitterTotals = (0, _sagas.extractAnalyticsTotalData)(immutableTwitterPostList, _staticConfiguration.TWITTER);
	          _context.next = 33;
	          return (0, _effects.put)({
	            type: _constants3.LOAD_CAMPAIGN_ANALYTICS_SUCCESS,
	            youtubeVideos: immutableYoutubeVideoList,
	            instagramPosts: immutableInstagramPostList,
	            facebookPosts: immutableFacebookPostList,
	            twitterPosts: immutableTwitterPostList,
	            hasTrackedDeliverables: hasTrackedDeliverables,
	            youtubeTotals: (0, _immutable.fromJS)(youtubeTotals),
	            instagramTotals: (0, _immutable.fromJS)(instagramTotals),
	            facebookTotals: (0, _immutable.fromJS)(facebookTotals),
	            twitterTotals: (0, _immutable.fromJS)(twitterTotals)
	          });
	
	        case 33:
	          _context.next = 35;
	          return (0, _effects.put)({ type: _constants2.SET_ASSET_PAGE_BACK_LINK, backLink: '/campaign/' + campaignId + '?analytics' });
	
	        case 35:
	          _context.next = 42;
	          break;
	
	        case 37:
	          _context.prev = 37;
	          _context.t0 = _context['catch'](0);
	
	          (0, _errorHandlingService.reportError)('LOAD_CAMPAIGN_ANALYTICS_ERROR', _context.t0.message);
	          _context.next = 42;
	          return (0, _effects.put)({ type: _constants3.LOAD_CAMPAIGN_ANALYTICS_ERROR, error: _context.t0.message });
	
	        case 42:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 37]]);
	}
	
	function addTrackedAssetToStateList(actions) {
	  var trackedAsset, updatedTrackedAsset, assetList, youtubeVideos, instagramPosts, facebookPosts, twitterPosts, youtubeTotals, instagramTotals, facebookTotals, twitterTotals;
	  return _regenerator2.default.wrap(function addTrackedAssetToStateList$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          trackedAsset = actions.data.trackedAsset;
	          _context2.next = 4;
	          return (0, _effects.call)(_sagas.getAndFormatTrackedAssetAnalytics, trackedAsset);
	
	        case 4:
	          updatedTrackedAsset = _context2.sent;
	
	          if (!updatedTrackedAsset) {
	            _context2.next = 31;
	            break;
	          }
	
	          assetList = null;
	
	          if (updatedTrackedAsset.platform === _staticConfiguration.YOUTUBE) assetList = 'youtubeVideos';
	          if (updatedTrackedAsset.platform === _staticConfiguration.INSTAGRAM) assetList = 'instagramPosts';
	          if (updatedTrackedAsset.platform === _staticConfiguration.FACEBOOK) assetList = 'facebookPosts';
	          if (updatedTrackedAsset.platform === _staticConfiguration.TWITTER) assetList = 'twitterPosts';
	
	          _context2.next = 13;
	          return (0, _effects.put)({
	            type: _constants3.UPDATE_CAMPAIGN_ANALYTICS,
	            newAsset: (0, _immutable.fromJS)(updatedTrackedAsset),
	            assetId: trackedAsset.assetId,
	            assetList: assetList
	          });
	
	        case 13:
	          _context2.next = 15;
	          return (0, _effects.select)(_campaignAnalyticsSelectors.getYoutubeVideos);
	
	        case 15:
	          youtubeVideos = _context2.sent;
	          _context2.next = 18;
	          return (0, _effects.select)(_campaignAnalyticsSelectors.getInstagramPosts);
	
	        case 18:
	          instagramPosts = _context2.sent;
	          _context2.next = 21;
	          return (0, _effects.select)(_campaignAnalyticsSelectors.getFacebookPosts);
	
	        case 21:
	          facebookPosts = _context2.sent;
	          _context2.next = 24;
	          return (0, _effects.select)(_campaignAnalyticsSelectors.getTwitterPosts);
	
	        case 24:
	          twitterPosts = _context2.sent;
	          youtubeTotals = (0, _sagas.extractAnalyticsTotalData)(youtubeVideos, _staticConfiguration.YOUTUBE);
	          instagramTotals = (0, _sagas.extractAnalyticsTotalData)(instagramPosts, _staticConfiguration.INSTAGRAM);
	          facebookTotals = (0, _sagas.extractAnalyticsTotalData)(facebookPosts, _staticConfiguration.FACEBOOK);
	          twitterTotals = (0, _sagas.extractAnalyticsTotalData)(twitterPosts, _staticConfiguration.TWITTER);
	          _context2.next = 31;
	          return (0, _effects.put)({
	            type: _constants3.UPDATE_CAMPAIGN_ANALYTICS_TOTALS,
	            youtubeTotals: (0, _immutable.fromJS)(youtubeTotals),
	            instagramTotals: (0, _immutable.fromJS)(instagramTotals),
	            facebookTotals: (0, _immutable.fromJS)(facebookTotals),
	            twitterTotals: (0, _immutable.fromJS)(twitterTotals)
	          });
	
	        case 31:
	          _context2.next = 38;
	          break;
	
	        case 33:
	          _context2.prev = 33;
	          _context2.t0 = _context2['catch'](0);
	
	          (0, _errorHandlingService.reportError)('ADD_TRACKED_ASSET_TO_CAMPAIGN_ERROR', _context2.t0.message);
	          _context2.next = 38;
	          return (0, _effects.put)({ type: _constants.GET_NEW_ASSET_ERROR, error: _context2.t0 });
	
	        case 38:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 33]]);
	}
	
	function watchLoadCampaignAnalytics() {
	  return _regenerator2.default.wrap(function watchLoadCampaignAnalytics$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants3.LOAD_CAMPAIGN_ANALYTICS, loadCampaignAnalytics);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function watchGetNewCampaignTrackedAsset() {
	  return _regenerator2.default.wrap(function watchGetNewCampaignTrackedAsset$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants3.GET_NEW_CAMPAIGN_ANALYTICS, addTrackedAssetToStateList);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function campaignAnalyticsSagas() {
	  return _regenerator2.default.wrap(function campaignAnalyticsSagas$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(watchLoadCampaignAnalytics), (0, _effects.fork)(watchGetNewCampaignTrackedAsset)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _campaignDashboardCards = __webpack_require__(1901);
	
	var _campaignDashboardCards2 = _interopRequireDefault(_campaignDashboardCards);
	
	var _campaignDashboardTable = __webpack_require__(1902);
	
	var _campaignDashboardTable2 = _interopRequireDefault(_campaignDashboardTable);
	
	var _dyzioEmptyState = __webpack_require__(192);
	
	var _dyzioEmptyState2 = _interopRequireDefault(_dyzioEmptyState);
	
	var _tabActionBar = __webpack_require__(194);
	
	var _tabActionBar2 = _interopRequireDefault(_tabActionBar);
	
	var _uploadModal = __webpack_require__(920);
	
	var _uploadModal2 = _interopRequireDefault(_uploadModal);
	
	var _addAssetForm = __webpack_require__(276);
	
	var _addAssetForm2 = _interopRequireDefault(_addAssetForm);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasLocalstorageClient = __webpack_require__(127);
	
	var _hasLocalstorageClient2 = _interopRequireDefault(_hasLocalstorageClient);
	
	var _authService = __webpack_require__(21);
	
	var _trackedAssetsAnalyticsService = __webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var groupByOptions = [{ key: 'none', text: 'None', value: 'none' }, { key: 'platform', text: 'Platform', value: 'platform' }];
	
	var sortByOptions = [{ key: 'createdDateAsc', text: 'Created date (ASC)', value: 'createdDate' }, { key: 'createdDateDesc', text: 'Created date (DESC)', value: '-createdDate' }, { key: 'publishedDateAsc', text: 'Published date (ASC)', value: 'publishedDate' }, { key: 'publishedDateDesc', text: 'Published date (DESC)', value: '-publishedDate' }, { key: 'engagementsAsc', text: 'Engagements (ASC)', value: 'engagements' }, { key: 'engagementsDesc', text: 'Engagements (DESC)', value: '-engagements' }];
	
	var BEGIN_LOAD_STATE = {
	  isLoading: true,
	  isLoaded: false,
	  isFailed: false
	};
	
	var getViewMode = function getViewMode(campaignSettings) {
	  if (!campaignSettings) return _tabActionBar.ViewModes.cardsLarge;
	  var assetsViewMode = campaignSettings.assetsViewMode;
	
	  return assetsViewMode || _tabActionBar.ViewModes.cardsLarge;
	};
	
	var ASSETS_PER_PAGE = 200;
	
	var HELP_PAGE_URL = 'http://help.dyzio.co/dyzio-contextual-help/campaign-assets';
	
	var CampaignDashboardAssets = function (_Component) {
	  _inherits(CampaignDashboardAssets, _Component);
	
	  function CampaignDashboardAssets(props) {
	    _classCallCheck(this, CampaignDashboardAssets);
	
	    var _this = _possibleConstructorReturn(this, (CampaignDashboardAssets.__proto__ || Object.getPrototypeOf(CampaignDashboardAssets)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var campaignSettings = props.dyzioStorage.getCampaignSettings({
	      campaignId: props.params.id,
	      key: props.dyzioStorage.KEYS.CAMPAIGN_VIEW_MODE
	    });
	    _this.state = _extends({
	      trackedAssets: [],
	      tableViewTrackedAssets: [],
	      viewMode: getViewMode(campaignSettings),
	      groupBy: 'none',
	      sortBy: 'createdDate',
	      uploadSupportingVisible: false,
	      assetModalOpen: false
	    }, BEGIN_LOAD_STATE);
	    return _this;
	  }
	
	  _createClass(CampaignDashboardAssets, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.requestTrackedAssets(true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          viewMode = _state.viewMode,
	          groupBy = _state.groupBy,
	          selectedAsset = _state.selectedAsset,
	          uploadSupportingVisible = _state.uploadSupportingVisible,
	          assetModalOpen = _state.assetModalOpen,
	          trackedAssets = _state.trackedAssets,
	          isLoading = _state.isLoading,
	          isLoaded = _state.isLoaded,
	          tableViewTrackedAssets = _state.tableViewTrackedAssets;
	
	
	      var isSmallCards = viewMode === _tabActionBar.ViewModes.cardsSmall;
	      var isLargeCards = viewMode === _tabActionBar.ViewModes.cardsLarge;
	      var isTableView = viewMode === _tabActionBar.ViewModes.table;
	      var isCardsView = isSmallCards || isLargeCards;
	
	      var noTrackedAssets = _lodash2.default.isEmpty(trackedAssets);
	
	      var actionButtonProps = {
	        content: 'Add an asset...',
	        onClick: this.toggleAddAssetModalState
	      };
	
	      var hamburgerOptions = this.getCardHamburgerOptions();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_tabActionBar2.default, {
	          hasActionButton: true,
	          actionButtonProps: actionButtonProps,
	          isSmallCards: isSmallCards,
	          isLargeCards: isLargeCards,
	          isTableView: isTableView,
	          onViewModeChanged: this.onViewModeChanged,
	          groupByOptions: groupByOptions,
	          onGroupByChanged: this.onGroupByChanged,
	          sortByOptions: sortByOptions,
	          onSortByChanged: this.onSortByChanged,
	          helpPageUrl: HELP_PAGE_URL,
	          shouldDisableButtons: noTrackedAssets
	        }),
	        isLoading && _react2.default.createElement(_semanticUiReact.Loader, {
	          active: true,
	          size: 'big',
	          content: 'Loading tracked assets'
	        }),
	        isLoaded && noTrackedAssets && _react2.default.createElement(CampaignDashboardEmptyState, {
	          buttonLabel: 'Add an asset...',
	          content: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'There are no assets in your campaign yet.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Use the button below to add your first asset.'
	            )
	          ),
	          onClick: this.toggleAddAssetModalState
	        }),
	        isLoaded && isCardsView && !noTrackedAssets && _react2.default.createElement(_campaignDashboardCards2.default, {
	          isDone: isLoaded,
	          isLoading: isLoading,
	          assets: trackedAssets,
	          viewMode: viewMode,
	          groupBy: groupBy,
	          hamburgerOptions: hamburgerOptions
	        }),
	        isLoaded && isTableView && !noTrackedAssets && _react2.default.createElement(_campaignDashboardTable2.default, {
	          assets: tableViewTrackedAssets
	        }),
	        uploadSupportingVisible && _react2.default.createElement(_uploadModal2.default, {
	          asset: selectedAsset,
	          open: uploadSupportingVisible,
	          popupToggleHandler: this.toggleUploadModal,
	          successHandler: this.addSupportingFile
	        }),
	        assetModalOpen && _react2.default.createElement(_addAssetForm2.default, {
	          isOpen: true,
	          platform: 'external',
	          popupToggleHandler: this.toggleAddAssetModalState,
	          addAssetHandler: this.addAssetHandler
	        })
	      );
	    }
	  }]);
	
	  return CampaignDashboardAssets;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.addSupportingFile = function (result) {
	    var _state2 = _this2.state,
	        selectedAsset = _state2.selectedAsset,
	        trackedAssets = _state2.trackedAssets;
	
	    var updatedAsset = _lodash2.default.find(trackedAssets, { id: selectedAsset.id });
	    if (!updatedAsset.localState) updatedAsset.localState = {};
	    updatedAsset.localState.supportingFileAdded = true;
	    _this2.setState({
	      trackedAssets: trackedAssets
	    });
	  };
	
	  this.onViewModeChanged = function (event, data) {
	    var name = data.name;
	    var _props = _this2.props,
	        campaignId = _props.params.id,
	        dyzioStorage = _props.dyzioStorage;
	
	    _this2.setState({
	      viewMode: name
	    }, function () {
	      var campaignSettings = dyzioStorage.getCampaignSettings({
	        campaignId: campaignId,
	        key: dyzioStorage.KEYS.CAMPAIGN_VIEW_MODE
	      });
	      var campaignUpdateOpts = {
	        campaignId: campaignId,
	        key: dyzioStorage.KEYS.CAMPAIGN_VIEW_MODE,
	        value: _lodash2.default.set(campaignSettings, 'assetsViewMode', name)
	      };
	      dyzioStorage.updateCampaignSettings(campaignUpdateOpts);
	    });
	  };
	
	  this.onGroupByChanged = function (event, data) {
	    var value = data.value;
	
	    _this2.setState({
	      groupBy: value
	    });
	  };
	
	  this.onSortByChanged = function (event, data) {
	    var value = data.value;
	    var viewMode = _this2.state.viewMode;
	
	    var isTableView = viewMode === _tabActionBar.ViewModes.table;
	    _this2.setState({
	      sortBy: value
	    }, function () {
	      _this2.requestTrackedAssets(isTableView);
	    });
	  };
	
	  this.toggleAddAssetModalState = function () {
	    var assetModalOpen = _this2.state.assetModalOpen;
	
	    _this2.setState({
	      assetModalOpen: !assetModalOpen
	    });
	  };
	
	  this.toggleUploadModal = function () {
	    var uploadSupportingVisible = _this2.state.uploadSupportingVisible;
	
	    _this2.setState({ uploadSupportingVisible: !uploadSupportingVisible });
	  };
	
	  this.addAssetHandler = function (details) {
	    _this2.setState({
	      isAddingNewCard: true
	    });
	    var _props2 = _this2.props,
	        params = _props2.params,
	        jsonAPIClient = _props2.jsonAPIClient;
	    var id = params.id;
	    var origin = window.location.origin;
	
	    var trackedAsset = jsonAPIClient.create('trackedAssets');
	    trackedAsset.set('assetId', details.assetId);
	    trackedAsset.set('assetURL', details.assetURL);
	    trackedAsset.set('user', {
	      type: 'users',
	      id: _authService.authService.uid()
	    });
	    trackedAsset.set('campaign', {
	      type: 'campaigns',
	      id: id
	    });
	    trackedAsset.set('platform', details.platform);
	    trackedAsset.set('assetType', details.type);
	    trackedAsset.set('origin', origin);
	    trackedAsset.set('createdSource', 'CAMPAIGN');
	    trackedAsset.sync().then(function () {
	      jsonAPIClient.get('campaigns', id).then(function (campaign) {
	        campaign.relationships('trackedAssets').add(trackedAsset);
	        campaign.sync(function () {
	          _this2.toggleAddAssetModalState();
	          setTimeout(function () {
	            _this2.requestTrackedAssets(true);
	          }, 1000);
	        });
	      });
	    });
	  };
	
	  this.requestTrackedAssets = function () {
	    var shouldQueryAssetsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var _props3 = _this2.props,
	        id = _props3.params.id,
	        restClient = _props3.restClient;
	    var sortBy = _this2.state.sortBy;
	
	    _this2.setState(BEGIN_LOAD_STATE, function () {
	      restClient.get('trackedAssets?filter[campaign]=' + id + '&sort=' + sortBy + '&page[limit]=' + ASSETS_PER_PAGE).then(function (response) {
	        var data = response.data.data;
	
	        _this2.setState({
	          trackedAssets: data,
	          isLoaded: true,
	          isLoading: false,
	          isFailed: false
	        }, function () {
	          if (shouldQueryAssetsData) {
	            var tableViewDataRequest = _lodash2.default.map(data, 'attributes');
	            (0, _trackedAssetsAnalyticsService.getTrackedAssetAnalytics)(tableViewDataRequest).then(function (rsp) {
	              var tableViewTrackedAssets = _lodash2.default.map(rsp, 'response.data');
	              _this2.setState({
	                tableViewTrackedAssets: tableViewTrackedAssets
	              });
	            });
	          }
	        });
	      }).catch(function () {
	        _this2.setState({
	          trackedAssets: [],
	          isLoaded: true,
	          isLoading: false,
	          isFailed: true
	        });
	      });
	    });
	  };
	
	  this.toggleAssetModal = function (asset) {
	    _this2.setState({
	      selectedAsset: asset,
	      uploadSupportingVisible: true
	    });
	  };
	
	  this.removeAssetFromList = function (asset) {
	    var trackedAssets = _this2.state.trackedAssets;
	
	    var deletedAsset = _lodash2.default.find(trackedAssets, { id: asset.id });
	    if (!deletedAsset.localState) deletedAsset.localState = {};
	    deletedAsset.localState.isAssetDeleted = true;
	    _this2.setState({
	      trackedAssets: trackedAssets
	    });
	  };
	
	  this.removeAssetFromServer = function (asset) {
	    var restClient = _this2.props.restClient;
	
	    return restClient.delete('trackedAssets/' + asset.id);
	  };
	
	  this.removeAsset = function (asset) {
	    _this2.removeAssetFromServer(asset).then(_this2.removeAssetFromList(asset)).catch(function (e) {
	      return console.log(e);
	    });
	  };
	
	  this.getCardHamburgerOptions = function () {
	    return [{
	      label: 'add data manually',
	      icon: 'upload',
	      value: 'upload',
	      onClick: _this2.toggleAssetModal
	    }, {
	      label: 'remove asset',
	      icon: 'delete',
	      value: 'delete',
	      onClick: _this2.removeAsset
	    }];
	  };
	
	  this.toggleUploadModal = function () {
	    var uploadSupportingVisible = _this2.state.uploadSupportingVisible;
	
	    _this2.setState({ uploadSupportingVisible: !uploadSupportingVisible });
	  };
	};
	
	CampaignDashboardAssets.propTypes = {
	  jsonAPIClient: _propTypes2.default.object.isRequired,
	  restClient: _propTypes2.default.func.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  dyzioStorage: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasJsonapiClient2.default, _hasRestClient2.default, _hasLocalstorageClient2.default)(CampaignDashboardAssets);

/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var restClient = _axios2.default.create({
	  baseURL: ("https://api2.dyzio.co/v1"),
	  timeout: 2000,
	  headers: {
	    Authorization: 'Bearer ' + _authService.authService.getToken()
	  }
	});
	
	var updateCampaignTemporaryInfluencers = function updateCampaignTemporaryInfluencers(campaignId, influencer) {
	  var campaignUrl = 'campaigns/' + campaignId;
	  return restClient.get(campaignUrl).then(function (response) {
	    var attributes = response.data.data.attributes;
	    var temporaryInfluencers = attributes.temporaryInfluencers;
	
	    console.log(temporaryInfluencers);
	    var updatedInfluencers = _lodash2.default.reject(temporaryInfluencers, { instagram: influencer.instagram });
	    console.log(updatedInfluencers);
	    return updatedInfluencers;
	  }).then(function (updatedInfluencers) {
	    var dto = {
	      data: {
	        attributes: {
	          temporaryInfluencers: updatedInfluencers
	        }
	      }
	    };
	    return restClient.patch(campaignUrl, dto);
	  }).then(function (response) {
	    var attributes = response.data.data.attributes;
	    var temporaryInfluencers = attributes.temporaryInfluencers;
	
	    console.log(temporaryInfluencers);
	    return temporaryInfluencers;
	  });
	};
	
	var postInfluencerToDyzio = function postInfluencerToDyzio(influencer) {
	  var origin = window.location.origin;
	
	  var _authService$getProfi = _authService.authService.getProfile(),
	      organisationId = _authService$getProfi.app_metadata.dyzio.o_id;
	
	  var dto = {
	    data: {
	      domain: origin,
	      organisationId: organisationId,
	      influencer: influencer
	    }
	  };
	
	  console.log(dto);
	  return _axios2.default.post('https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer/create', dto);
	};
	
	var createCampaignInvitation = function createCampaignInvitation(params) {
	  return restClient.post('campaignInvitation', params).then(function (response) {
	    var data = response.data.data;
	    var id = data.id,
	        type = data.type;
	
	    console.log(params);
	    return restClient.post('/campaigns/' + params.data.attributes.campaign.id + '/relationships/pendingInvitations/', {
	      data: { type: type, id: id }
	    });
	  });
	};
	
	module.exports = {
	  postInfluencerToDyzio: postInfluencerToDyzio,
	  updateCampaignTemporaryInfluencers: updateCampaignTemporaryInfluencers,
	  createCampaignInvitation: createCampaignInvitation
	};

/***/ },
/* 2061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _dataAccess = __webpack_require__(2060);
	
	var _dataAccess2 = _interopRequireDefault(_dataAccess);
	
	var _authService = __webpack_require__(21);
	
	var _tabActionBar = __webpack_require__(194);
	
	var _tabActionBar2 = _interopRequireDefault(_tabActionBar);
	
	var _campaigns = __webpack_require__(129);
	
	var _largeCard = __webpack_require__(2062);
	
	var _largeCard2 = _interopRequireDefault(_largeCard);
	
	var _smallCard = __webpack_require__(2063);
	
	var _smallCard2 = _interopRequireDefault(_smallCard);
	
	var _temporaryInfluencerCard = __webpack_require__(2064);
	
	var _temporaryInfluencerCard2 = _interopRequireDefault(_temporaryInfluencerCard);
	
	var _addStoryModal = __webpack_require__(536);
	
	var _addStoryModal2 = _interopRequireDefault(_addStoryModal);
	
	var _addInfluencerModal = __webpack_require__(857);
	
	var _addInfluencerModal2 = _interopRequireDefault(_addInfluencerModal);
	
	var _dyzioEmptyState = __webpack_require__(192);
	
	var _dyzioEmptyState2 = _interopRequireDefault(_dyzioEmptyState);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasLocalstorageClient = __webpack_require__(127);
	
	var _hasLocalstorageClient2 = _interopRequireDefault(_hasLocalstorageClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIVIDER = 'divider';
	var INFLUENCER_SEARCH_CHANGED_DEBOUNCE_TIME = 800; // The number of milliseconds to delay.
	
	var getViewMode = function getViewMode(campaignSettings) {
	  if (!campaignSettings) return _tabActionBar.ViewModes.cardsLarge;
	  var influencersViewMode = campaignSettings.influencersViewMode;
	
	  return influencersViewMode || _tabActionBar.ViewModes.cardsLarge;
	};
	
	var HELP_PAGE_URL = 'http://help.dyzio.co/dyzio-contextual-help/campaign-influencers';
	
	var CampaignDashboardInfluencers = function (_Component) {
	  _inherits(CampaignDashboardInfluencers, _Component);
	
	  function CampaignDashboardInfluencers(props) {
	    _classCallCheck(this, CampaignDashboardInfluencers);
	
	    var _this = _possibleConstructorReturn(this, (CampaignDashboardInfluencers.__proto__ || Object.getPrototypeOf(CampaignDashboardInfluencers)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var campaignSettings = props.dyzioStorage.getCampaignSettings({
	      campaignId: props.params.id,
	      key: props.dyzioStorage.KEYS.CAMPAIGN_VIEW_MODE
	    });
	    _this.state = {
	      isLoading: true,
	      hasFailed: false,
	      influencers: [],
	      viewMode: getViewMode(campaignSettings),
	      temporaryInfluencers: [],
	      addStoryVisible: false,
	
	      addInfluencerModalVisible: false,
	      isSearchingInfluencers: false,
	      searchHasFailed: false,
	      searchResults: [],
	
	      discussionId: '',
	      discussionName: ''
	    };
	    return _this;
	  }
	
	  _createClass(CampaignDashboardInfluencers, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          influencers = _state.influencers,
	          viewMode = _state.viewMode,
	          addStoryVisible = _state.addStoryVisible,
	          addInfluencerModalVisible = _state.addInfluencerModalVisible,
	          isSearchingInfluencers = _state.isSearchingInfluencers,
	          searchResults = _state.searchResults,
	          campaignId = _state.campaignId,
	          discussionId = _state.discussionId,
	          discussionName = _state.discussionName,
	          temporaryInfluencers = _state.temporaryInfluencers;
	
	
	      if (isLoading) {
	        return _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { active: true, size: 'big' },
	          'Loading campaign influencers'
	        );
	      }
	
	      var actionButtonProps = {
	        content: 'Add an influencer...',
	        onClick: this.toggleAddInfluencerModal
	      };
	
	      var noInfluencers = _lodash2.default.isEmpty(influencers);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_tabActionBar2.default, {
	          hasActionButton: true,
	          actionButtonProps: actionButtonProps,
	          isSmallCards: viewMode === _tabActionBar.ViewModes.cardsSmall,
	          isLargeCards: viewMode === _tabActionBar.ViewModes.cardsLarge,
	          onViewModeChanged: this.onViewModeChanged,
	          helpPageUrl: HELP_PAGE_URL,
	          shouldDisableButtons: noInfluencers
	        }),
	        temporaryInfluencers && temporaryInfluencers.length > 0 && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Card.Group,
	            { itemsPerRow: viewMode === _tabActionBar.ViewModes.cardsLarge ? 4 : 6 },
	            _lodash2.default.map(temporaryInfluencers, function (ti) {
	              return _react2.default.createElement(_temporaryInfluencerCard2.default, {
	                influencer: ti,
	                viewMode: viewMode,
	                onAddInfluencer: _this2.handleTemporaryInfluencerAddClick
	              });
	            })
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Group,
	          { itemsPerRow: viewMode === _tabActionBar.ViewModes.cardsLarge ? 4 : 6 },
	          _lodash2.default.map(influencers, function (influencer) {
	            var dropdownOptions = _this2.getDropdownOptions(influencer);
	            return viewMode === _tabActionBar.ViewModes.cardsLarge ? _react2.default.createElement(_largeCard2.default, { influencer: influencer, dropdownOptions: dropdownOptions }) : _react2.default.createElement(_smallCard2.default, { influencer: influencer });
	          })
	        ),
	        noInfluencers && _react2.default.createElement(_dyzioEmptyState2.default, {
	          content: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'There are no influencers in your campaign yet.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Use the button below to add your first influencer.'
	            )
	          ),
	          buttonLabel: 'Add an influencer...',
	          onClick: this.toggleAddInfluencerModal
	        }),
	        _react2.default.createElement(_addStoryModal2.default, {
	          open: addStoryVisible,
	          popupToggleHandler: this.toggleAddStoryModal,
	          successHandler: this.addStory,
	          campaignId: campaignId,
	          discussionId: discussionId,
	          discussionName: discussionName
	        }),
	        addInfluencerModalVisible && _react2.default.createElement(_addInfluencerModal2.default, {
	          open: true,
	          toggleHandler: this.toggleAddInfluencerModal,
	          onInfluencerQueryChanged: this.onInfluencerQueryChanged,
	          isSearching: isSearchingInfluencers,
	          results: searchResults,
	          influencers: influencers,
	          onInviteInfluencer: this.handleInfluencerInvite
	        })
	      );
	    }
	  }]);
	
	  return CampaignDashboardInfluencers;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.componentDidMount = function () {
	    _this3.loadDiscussions();
	    _this3.getTemporaryInfluencers();
	  };
	
	  this.toggleAddStoryModal = function (discussionId, discussionName) {
	    var addStoryVisible = _this3.state.addStoryVisible;
	
	    _this3.setState({
	      addStoryVisible: !addStoryVisible,
	      discussionId: discussionId,
	      discussionName: discussionName
	    });
	  };
	
	  this.loadDiscussions = function () {
	    var campaignId = _this3.props.params.id;
	
	    (0, _campaigns.getCampaignDiscussions)(campaignId).then(function (discussions) {
	      var influencers = [];
	      _lodash2.default.forEach(discussions, function (discussion) {
	        var organisations = discussion.organisations;
	
	        _lodash2.default.forEach(organisations, function (org) {
	          if (org.influencer) {
	            influencers.push(_extends({
	              discussionId: discussion.id,
	              discussionName: discussion.name
	            }, org.influencer));
	          }
	        });
	      });
	      _this3.setState({
	        influencers: influencers,
	        isLoading: false,
	        hasFailed: false
	      });
	    }).catch(function () {
	      _this3.setState({
	        influencers: [],
	        isLoading: false,
	        hasFailed: true
	      });
	    });
	  };
	
	  this.addStory = function (asset) {
	    console.log('[addStory]');
	    console.log(JSON.stringify(asset, null, 2));
	  };
	
	  this.getTemporaryInfluencers = function () {
	    var _props = _this3.props,
	        params = _props.params,
	        restClient = _props.restClient;
	
	    var campaignId = params.id;
	    var url = '/campaigns/' + campaignId;
	    restClient.get(url).then(function (response) {
	      var campaign = response.data.data.attributes;
	      _this3.setState({
	        temporaryInfluencers: campaign.temporaryInfluencers
	      });
	    }).catch(function (e) {
	      console.log(e);
	    });
	  };
	
	  this.onViewModeChanged = function (event, data) {
	    var name = data.name;
	    var _props2 = _this3.props,
	        campaignId = _props2.params.id,
	        dyzioStorage = _props2.dyzioStorage;
	
	    _this3.setState({ viewMode: name }, function () {
	      var campaignSettings = dyzioStorage.getCampaignSettings({
	        campaignId: campaignId,
	        key: dyzioStorage.KEYS.CAMPAIGN_VIEW_MODE
	      });
	      var campaignUpdateOpts = {
	        campaignId: campaignId,
	        key: dyzioStorage.KEYS.CAMPAIGN_VIEW_MODE,
	        value: _lodash2.default.set(campaignSettings, 'influencersViewMode', name)
	      };
	      dyzioStorage.updateCampaignSettings(campaignUpdateOpts);
	    });
	  };
	
	  this.getDropdownOptions = function (influencer) {
	    return [{
	      label: 'add story',
	      icon: 'circle outline',
	      value: 'story',
	      onClick: function onClick() {
	        return _this3.toggleAddStoryModal(influencer.discussionId, influencer.discussionName);
	      }
	    }, {
	      type: DIVIDER
	    }, {
	      label: 'send invite',
	      icon: 'mail outline',
	      value: influencer.id,
	      onClick: _this3.toggleSendInviteModal,
	      disabled: !_lodash2.default.isString(influencer.email),
	      popupText: influencer.name + ' does not have an email address.\n        Update the influencer in My Influencers and try again.'
	    }];
	  };
	
	  this.onInfluencerQueryChanged = _lodash2.default.debounce(function (event, data) {
	    var value = data.value;
	
	    _this3.setState({
	      isSearchingInfluencers: true
	    }, function () {
	      _this3.searchInfluencers(value);
	    });
	  }, INFLUENCER_SEARCH_CHANGED_DEBOUNCE_TIME);
	
	  this.searchInfluencers = function (searchTerm) {
	    var restClient = _this3.props.restClient;
	
	    var _authService$getProfi = _authService.authService.getProfile(),
	        organisationId = _authService$getProfi.app_metadata.dyzio.o_id;
	
	    var request = {
	      data: {
	        organisationId: organisationId,
	        perPage: 200,
	        currentPage: 1,
	        search: {
	          searchTerm: searchTerm
	        },
	        sort: {
	          field: 'name',
	          order: 'DESC'
	        }
	      }
	    };
	    var searchUrl = encodeURIComponent(JSON.stringify(request));
	    var url = 'filter/' + searchUrl;
	    restClient({
	      method: 'get',
	      url: url,
	      baseURL: ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production")
	    }).then(function (response) {
	      var data = response.data.body.data.data;
	
	      _this3.setState({
	        isSearchingInfluencers: false,
	        searchResults: data,
	        searchHasFailed: false
	      });
	    });
	  };
	
	  this.toggleAddInfluencerModal = function () {
	    var addInfluencerModalVisible = _this3.state.addInfluencerModalVisible;
	
	    _this3.setState({
	      addInfluencerModalVisible: !addInfluencerModalVisible,
	      searchResults: []
	    });
	  };
	
	  this.handleInfluencerInvite = function (influencer) {
	    var _props3 = _this3.props,
	        campaign = _props3.campaign,
	        campaignId = _props3.params.id;
	
	
	    var invitation = {
	      data: {
	        type: 'campaignInvitation',
	        attributes: {
	          name: influencer.name,
	          role: 'INFLUENCER',
	          campaignName: campaign.name,
	          email: influencer.email,
	          status: 'DEFERRED',
	          link: window.location.origin + '/invite/',
	          influencer: {
	            type: 'influencer',
	            id: influencer.id
	          },
	          campaign: {
	            type: 'campaigns',
	            id: campaignId
	          },
	          metadata: {
	            socialHandle: influencer.primarySocialHandle,
	            influencerId: influencer.id
	          }
	        }
	      }
	    };
	
	    _dataAccess2.default.createCampaignInvitation(invitation).then(function () {
	      _this3.loadDiscussions();
	    });
	  };
	
	  this.handleTemporaryInfluencerAddClick = function (event, _ref) {
	    var influencer = _ref.value;
	    var campaignId = _this3.props.params.id;
	
	    _dataAccess2.default.postInfluencerToDyzio(influencer).then(function () {
	      _dataAccess2.default.updateCampaignTemporaryInfluencers(campaignId, influencer).then(function (temporaryInfluencers) {
	        _this3.setState({
	          temporaryInfluencers: temporaryInfluencers
	        });
	      });
	    }).catch(function (e) {
	      return console.log(e);
	    });
	  };
	};
	
	CampaignDashboardInfluencers.propTypes = {
	  restClient: _propTypes2.default.func.isRequired,
	  dyzioStorage: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  campaign: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasJsonapiClient2.default, _hasLocalstorageClient2.default)(CampaignDashboardInfluencers);

/***/ },
/* 2062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _formatting = __webpack_require__(62);
	
	var _dyzioIcons = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DIVIDER = 'divider';
	
	var smallText = {
	  fontSize: '80%',
	  lineHeight: '10px'
	};
	
	var LargeCard = function LargeCard(_ref) {
	  var influencer = _ref.influencer,
	      dropdownOptions = _ref.dropdownOptions;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { key: influencer.id },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very', fluid: true, singleLine: true, compact: true },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { style: { padding: 0 } },
	                influencer.name
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true, style: { padding: 0 } },
	                _react2.default.createElement(
	                  _semanticUiReact.Dropdown,
	                  {
	                    icon: null,
	                    pointing: 'top right',
	                    floating: true,
	                    trigger: _react2.default.createElement(_semanticUiReact.Button, { icon: 'bars', color: 'pink', floated: 'right', size: 'mini' })
	                  },
	                  _react2.default.createElement(
	                    _semanticUiReact.Dropdown.Menu,
	                    null,
	                    _.map(dropdownOptions, function (opt) {
	                      if (opt.type === DIVIDER) {
	                        return _react2.default.createElement(_semanticUiReact.Dropdown.Divider, null);
	                      }
	
	                      if (opt.disabled && opt.popupText) {
	                        return _react2.default.createElement(_semanticUiReact.Popup, {
	                          trigger: _react2.default.createElement(
	                            _semanticUiReact.Dropdown.Item,
	                            {
	                              onClick: _.noop(),
	                              value: opt.value
	                            },
	                            _react2.default.createElement(_semanticUiReact.Icon, { name: opt.icon }),
	                            opt.label
	                          ),
	                          content: opt.popupText
	                        });
	                      }
	
	                      return _react2.default.createElement(
	                        _semanticUiReact.Dropdown.Item,
	                        {
	                          disabled: opt.disabled,
	                          onClick: opt.onClick,
	                          value: opt.value
	                        },
	                        _react2.default.createElement(_semanticUiReact.Icon, { name: opt.icon }),
	                        opt.label
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(_semanticUiReact.Image, {
	        src: influencer.thumbnail,
	        size: 'small',
	        centered: true,
	        shape: 'circular',
	        style: { display: 'block' }
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: { padding: '5px 10px' } },
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very', fluid: true, singleLine: true, compact: true },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: { padding: 0 } },
	              _react2.default.createElement(_dyzioIcons.YoutubeIcon, null)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: smallText },
	              influencer.youtubeChannelTitle
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: smallText },
	              (0, _formatting.scientificFormat)(influencer.youtubeCount)
	            ),
	            _react2.default.createElement(_semanticUiReact.Table.Cell, { collapsing: true, style: smallText })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: { padding: 0 } },
	              _react2.default.createElement(_dyzioIcons.InstagramIcon, null)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: smallText },
	              influencer.instagram
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: smallText },
	              (0, _formatting.scientificFormat)(influencer.instagramCount)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: smallText },
	              influencer.instagramVerified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: { padding: 0 } },
	              _react2.default.createElement(_dyzioIcons.TwitterIcon, null)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: smallText },
	              influencer.twitter
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: smallText },
	              (0, _formatting.scientificFormat)(influencer.twitterCount)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: smallText },
	              influencer.twitterVerified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: { padding: 0 } },
	              _react2.default.createElement(_dyzioIcons.FacebookIcon, null)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: smallText },
	              influencer.facebook
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: smallText },
	              (0, _formatting.scientificFormat)(influencer.facebookCount)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: smallText },
	              influencer.facebookVerified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = LargeCard;

/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioIcons = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STYLES = {
	  smallFont: {
	    fontSize: '80%'
	  },
	  displayBlock: {
	    display: 'block'
	  },
	  noVerticalPadding: {
	    padding: '0px 14px'
	  }
	};
	
	var SmallCard = function SmallCard(_ref) {
	  var influencer = _ref.influencer;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { key: influencer.id },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { textAlign: 'center' },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        { style: STYLES.smallFont },
	        influencer.name
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(_semanticUiReact.Image, {
	        src: influencer.thumbnail,
	        size: 'tiny',
	        centered: true,
	        shape: 'circular',
	        style: STYLES.displayBlock
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: STYLES.noVerticalPadding },
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very', singleLine: true, compact: true, textAlign: 'center' },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_dyzioIcons.YoutubeIcon, null)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_dyzioIcons.InstagramIcon, null)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_dyzioIcons.FacebookIcon, null)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              null,
	              _react2.default.createElement(_dyzioIcons.TwitterIcon, null)
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	SmallCard.propTypes = {
	  influencer: _propTypes2.default.object.isRequired
	};
	
	exports.default = SmallCard;

/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _formatting = __webpack_require__(62);
	
	var _dyzioIcons = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CL = 'cards.large';
	
	var STYLES = {
	  smallFont: {
	    fontSize: '80%'
	  },
	  displayBlock: {
	    display: 'block'
	  },
	  noVerticalPadding: {
	    padding: '0px 14px'
	  },
	  empty: {},
	  overflowEllipsis: {
	    whiteSpace: 'nowrap',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis'
	  },
	  smallText: {
	    fontSize: '80%',
	    lineHeight: '10px'
	  },
	  lightBackground: {
	    backgroundColor: '#eee'
	  },
	  noPadding: {
	    padding: 0
	  },
	  smallVerticalPadding: {
	    padding: '5px 14px'
	  }
	};
	
	var TemporaryInfluencerCard = function TemporaryInfluencerCard(_ref) {
	  var influencer = _ref.influencer,
	      viewMode = _ref.viewMode,
	      onAddInfluencer = _ref.onAddInfluencer;
	
	  var largeCards = viewMode === CL;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { key: influencer.handle },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { textAlign: 'center', style: STYLES.lightBackground },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        { style: largeCards ? STYLES.empty : STYLES.smallFont },
	        _react2.default.createElement(
	          'div',
	          { style: STYLES.overflowEllipsis },
	          influencer.name,
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: STYLES.overflowEllipsis },
	          influencer.instagram,
	          '\xA0'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(_semanticUiReact.Image, {
	        src: influencer.thumbnail,
	        size: largeCards ? 'small' : 'tiny',
	        centered: true,
	        shape: 'circular',
	        style: STYLES.displayBlock
	      })
	    ),
	    viewMode === CL && _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: STYLES.smallVerticalPadding },
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very', fluid: true, singleLine: true, compact: true },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: STYLES.noPadding },
	              _react2.default.createElement(_dyzioIcons.InstagramIcon, null)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { style: STYLES.smallText },
	              influencer.instagram
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: STYLES.smallText },
	              (0, _formatting.scientificFormat)(influencer.instagramCount)
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { collapsing: true, style: STYLES.smallText },
	              influencer.instagramVerified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true },
	      _react2.default.createElement(
	        _semanticUiReact.Button,
	        {
	          inverted: true,
	          fluid: true,
	          icon: true,
	          labelPosition: 'left',
	          color: 'green',
	          value: influencer,
	          onClick: onAddInfluencer
	        },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' }),
	        'Add' + (viewMode === CL ? ' to My Influencers' : '')
	      )
	    )
	  );
	};
	
	TemporaryInfluencerCard.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  viewMode: _propTypes2.default.string.isRequired,
	  onAddInfluencer: _propTypes2.default.func.isRequired
	};
	
	exports.default = TemporaryInfluencerCard;

/***/ },
/* 2065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactChartjs = __webpack_require__(444);
	
	var _recompose = __webpack_require__(15);
	
	var _formatting = __webpack_require__(62);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultDatasetProps = {
	  fill: false,
	  lineTension: 0.1,
	  backgroundColor: 'rgba(75,192,192,0.4)',
	  borderColor: 'rgba(75,192,192,1)',
	  borderCapStyle: 'butt',
	  borderDash: [],
	  borderDashOffset: 0.0,
	  borderJoinStyle: 'miter',
	  pointBorderColor: 'rgba(75,192,192,1)',
	  pointBackgroundColor: '#fff',
	  pointBorderWidth: 1,
	  pointHoverRadius: 5,
	  pointHoverBackgroundColor: 'rgba(75,192,192,1)',
	  pointHoverBorderColor: 'rgba(220,220,220,1)',
	  pointHoverBorderWidth: 2,
	  pointRadius: 1,
	  pointHitRadius: 10
	};
	
	var CampaignDashboardOverview = function (_Component) {
	  _inherits(CampaignDashboardOverview, _Component);
	
	  function CampaignDashboardOverview() {
	    _classCallCheck(this, CampaignDashboardOverview);
	
	    var _this = _possibleConstructorReturn(this, (CampaignDashboardOverview.__proto__ || Object.getPrototypeOf(CampaignDashboardOverview)).call(this));
	
	    _this.requestOverview = function () {
	      var _this$props = _this.props,
	          restClient = _this$props.restClient,
	          id = _this$props.params.id;
	
	      restClient({
	        method: 'post',
	        url: '/campaign/overview',
	        data: {
	          data: { id: id }
	        },
	        timeout: 10000,
	        baseURL: ("https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production")
	      }).then(function (response) {
	        var overview = response.data;
	
	        _this.setState({
	          overview: overview,
	          isLoaded: true,
	          isLoading: false,
	          hasFailed: false
	        });
	      }).catch(function () {
	        _this.setState({
	          overview: null,
	          isLoaded: true,
	          isLoading: false,
	          hasFailed: true
	        });
	      });
	    };
	
	    _this.generateGraphData = function (items) {
	      return {
	        labels: _.map(items, function (item) {
	          return (0, _moment2.default)(item.createdDate).format('MMMM Do YYYY');
	        }),
	        datasets: [_extends({
	          label: 'engagements',
	          data: _.map(items, 'engagementsTotal')
	        }, defaultDatasetProps)]
	      };
	    };
	
	    _this.state = {
	      isLoading: true,
	      isLoaded: false,
	      hasFailed: false,
	      overview: null
	    };
	    return _this;
	  }
	
	  _createClass(CampaignDashboardOverview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.requestOverview();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          overview = _state.overview,
	          isLoaded = _state.isLoaded,
	          isLoading = _state.isLoading,
	          hasFailed = _state.hasFailed;
	      var campaign = this.props.campaign;
	      var overviewHistory = campaign.overviewHistory;
	
	      var graphData = this.generateGraphData(overviewHistory || []);
	      return _react2.default.createElement(
	        'div',
	        null,
	        isLoading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, size: 'large', content: 'Loading overview data...' }),
	        isLoaded && hasFailed && _react2.default.createElement(_semanticUiReact.Message, { icon: 'frown', error: true, content: 'Something went wrong. Please try again' }),
	        isLoaded && !hasFailed && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Card,
	            { fluid: true, color: 'blue' },
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              { textAlign: 'center' },
	              _react2.default.createElement(
	                _semanticUiReact.Card.Header,
	                null,
	                overview.name
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Group,
	                { widths: 'five' },
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    null,
	                    overview.trackedAssetCount
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'Assets'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    null,
	                    (0, _formatting.scientificFormat)(overview.engagementsTotal)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'engagements'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  { color: 'pink' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'user' }),
	                    overview.influencerCount
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'influencers'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  { color: 'blue' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'user' }),
	                    overview.newInfluencerCount
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'new influencers'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    null,
	                    overview.membersCount
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'Team Members'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              { extra: true, textAlign: 'center' },
	              'campaign data processed: ',
	              _moment2.default.utc(overview.createdDate).calendar()
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card,
	            { fluid: true },
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Card.Header,
	                { textAlign: 'center' },
	                'Total viewing for the last 10 days'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(_reactChartjs.Line, { data: graphData })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              { extra: true },
	              'this explains the graph in some more detail'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignDashboardOverview;
	}(_react.Component);
	
	CampaignDashboardOverview.propTypes = {
	  restClient: _propTypes2.default.func.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  campaign: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasJsonapiClient2.default)(CampaignDashboardOverview);

/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(15);
	
	var _report = __webpack_require__(552);
	
	var _report2 = _interopRequireDefault(_report);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CampaignReport = function (_Component) {
	  _inherits(CampaignReport, _Component);
	
	  function CampaignReport(props) {
	    _classCallCheck(this, CampaignReport);
	
	    var _this = _possibleConstructorReturn(this, (CampaignReport.__proto__ || Object.getPrototypeOf(CampaignReport)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CampaignReport, [{
	    key: 'render',
	    value: function render() {
	      var params = this.props.params;
	
	      return _react2.default.createElement(_report2.default, { id: params.id, type: 'basic' });
	    }
	  }]);
	
	  return CampaignReport;
	}(_react.Component);
	
	exports.default = CampaignReport;

/***/ },
/* 2067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _campaignForm = __webpack_require__(864);
	
	var _campaignForm2 = _interopRequireDefault(_campaignForm);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STYLES = {
	  active: {
	    background: 'rgba(0,0,0,.05)'
	  }
	};
	
	var CampaignDashboardSettings = function (_Component) {
	  _inherits(CampaignDashboardSettings, _Component);
	
	  function CampaignDashboardSettings() {
	    _classCallCheck(this, CampaignDashboardSettings);
	
	    var _this = _possibleConstructorReturn(this, (CampaignDashboardSettings.__proto__ || Object.getPrototypeOf(CampaignDashboardSettings)).call(this));
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var _nextProps$campaign = nextProps.campaign,
	          name = _nextProps$campaign.name,
	          budget = _nextProps$campaign.budget,
	          liveDate = _nextProps$campaign.liveDate,
	          endDate = _nextProps$campaign.endDate,
	          hashtags = _nextProps$campaign.hashtags,
	          currency = _nextProps$campaign.currency,
	          version = _nextProps$campaign.version;
	
	      _this.setState({
	        name: name,
	        budget: budget,
	        liveDate: (0, _moment2.default)(liveDate),
	        endDate: (0, _moment2.default)(endDate),
	        hashtags: hashtags,
	        currency: currency,
	        version: version
	      });
	    };
	
	    _this.onInputChange = function (event, _ref) {
	      var _this$setState;
	
	      var name = _ref.name,
	          value = _ref.value;
	
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, value), _defineProperty(_this$setState, 'hasChanged', true), _defineProperty(_this$setState, 'savedOk', false), _this$setState));
	    };
	
	    _this.onLiveDateChange = function (date) {
	      _this.setState({
	        liveDate: date,
	        hasChanged: true,
	        savedOk: false
	      });
	    };
	
	    _this.onEndDateChange = function (date) {
	      _this.setState({
	        endDate: date,
	        hasChanged: true,
	        savedOk: false
	      });
	    };
	
	    _this.onCurrencyChange = function (event, data) {
	      var value = data.value;
	
	      _this.setState({
	        currency: value,
	        hasChanged: true,
	        savedOk: false
	      });
	    };
	
	    _this.onFormSubmit = function () {
	      var _this$props = _this.props,
	          jsonAPIClient = _this$props.jsonAPIClient,
	          params = _this$props.params;
	      var _this$state = _this.state,
	          name = _this$state.name,
	          budget = _this$state.budget,
	          liveDate = _this$state.liveDate,
	          endDate = _this$state.endDate,
	          currency = _this$state.currency,
	          hashtags = _this$state.hashtags;
	
	      _this.setState({
	        isSaving: true
	      });
	      jsonAPIClient.get('campaigns', params.id, {}, function (err, campaign) {
	        campaign.set('name', name);
	        campaign.set('budget', budget);
	        campaign.set('hashtags', hashtags);
	        campaign.set('currency', currency);
	
	        if (liveDate && liveDate.isValid()) {
	          campaign.set('liveDate', liveDate.format());
	        }
	
	        if (endDate && endDate.isValid()) {
	          campaign.set('endDate', endDate.format());
	        }
	
	        campaign.sync().then(_this.setState({ isSaving: false, hasChanged: false, savedOk: true }, _this.props.children.fetchCampaign));
	      });
	    };
	
	    _this.state = {
	      name: null,
	      budget: null,
	      liveDate: null,
	      endDate: null,
	      hashtags: null,
	      hasChanged: false,
	      isSaving: false,
	      savedOk: false,
	      version: 1
	    };
	    return _this;
	  }
	
	  _createClass(CampaignDashboardSettings, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props$campaign = this.props.campaign,
	          name = _props$campaign.name,
	          budget = _props$campaign.budget,
	          liveDate = _props$campaign.liveDate,
	          endDate = _props$campaign.endDate,
	          hashtags = _props$campaign.hashtags,
	          currency = _props$campaign.currency;
	
	      this.setState({
	        name: name,
	        budget: budget,
	        liveDate: (0, _moment2.default)(liveDate),
	        endDate: (0, _moment2.default)(endDate),
	        hashtags: hashtags,
	        currency: currency
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          name = _state.name,
	          budget = _state.budget,
	          hashtags = _state.hashtags,
	          liveDate = _state.liveDate,
	          endDate = _state.endDate,
	          currency = _state.currency,
	          hasChanged = _state.hasChanged,
	          savedOk = _state.savedOk;
	
	
	      var campaignFormProps = {
	        name: name,
	        budget: budget,
	        hashtags: hashtags,
	        liveDate: liveDate,
	        endDate: endDate,
	        currency: currency,
	        onInputChange: this.onInputChange,
	        onLiveDateChange: this.onLiveDateChange,
	        onEndDateChange: this.onEndDateChange,
	        onCurrencyChange: this.onCurrencyChange
	      };
	
	      var shouldDisableSubmitButton = savedOk || !hasChanged;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Card.Group,
	          { itemsPerRow: 2 },
	          _react2.default.createElement(
	            _semanticUiReact.Card,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              { style: STYLES.active },
	              _react2.default.createElement(
	                _semanticUiReact.Card.Header,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'settings' }),
	                '\xA0Campaign Settings'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(_campaignForm2.default, campaignFormProps),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              _react2.default.createElement(DyzioPrimaryButton, {
	                fluid: true,
	                label: 'Save',
	                hasIcon: true,
	                disabled: shouldDisableSubmitButton,
	                onClick: this.onFormSubmit,
	                icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'save' })
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignDashboardSettings;
	}(_react.Component);
	
	CampaignDashboardSettings.propTypes = {
	  campaign: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasJsonapiClient2.default)(CampaignDashboardSettings);

/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shortid = __webpack_require__(525);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _teamMember = __webpack_require__(895);
	
	var _teamMember2 = _interopRequireDefault(_teamMember);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cardGroupStyle = {
	  marginTop: 10,
	  marginBottom: 10
	};
	
	var CampaignDashboardTeam = function (_Component) {
	  _inherits(CampaignDashboardTeam, _Component);
	
	  function CampaignDashboardTeam(props) {
	    _classCallCheck(this, CampaignDashboardTeam);
	
	    var _this = _possibleConstructorReturn(this, (CampaignDashboardTeam.__proto__ || Object.getPrototypeOf(CampaignDashboardTeam)).call(this, props));
	
	    _this.loadTeam = function () {
	      var _this$props = _this.props,
	          jsonAPIClient = _this$props.jsonAPIClient,
	          restClient = _this$props.restClient,
	          id = _this$props.params.id;
	
	      var _authService$getProfi = _authService.authService.getProfile(),
	          organisationId = _authService$getProfi.app_metadata.dyzio.o_id;
	
	      jsonAPIClient.get('campaigns', id, {
	        include: ['members', 'pendingInvitations']
	      }, function (error, response) {
	        var campaign = response.toJSONTree();
	        var members = campaign.members,
	            pendingInvitations = campaign.pendingInvitations;
	        // Load users
	
	        jsonAPIClient.find('users', { filter: { organisation: organisationId } }, function (err, users) {
	          var team = _lodash2.default.map(users, function (user) {
	            return user.toJSONTree();
	          });
	          var notInvitedUsers = _lodash2.default.filter(team, function (user) {
	            var isMember = _lodash2.default.find(members, ['user.id', user.id]);
	            var isPending = _lodash2.default.find(pendingInvitations, ['email', user.email]);
	            return _lodash2.default.isUndefined(isMember) && _lodash2.default.isUndefined(isPending);
	          });
	          _this.setState({
	            users: notInvitedUsers,
	            members: _lodash2.default.reject(members, ['role', 'INFLUENCER']),
	            pendingInvitations: _lodash2.default.reject(pendingInvitations, ['role', 'INFLUENCER']),
	            isLoading: false,
	            isLoaded: true
	          });
	        });
	      });
	    };
	
	    _this.deleteMember = function () {
	      return _lodash2.default.noop();
	    };
	
	    _this.inviteMember = function (event, data) {
	      var users = _this.state.users;
	      var userId = data.id;
	      var _this$props2 = _this.props,
	          restClient = _this$props2.restClient,
	          jsonAPIClient = _this$props2.jsonAPIClient,
	          campaignId = _this$props2.params.id,
	          campaign = _this$props2.campaign;
	
	      var _authService$getProfi2 = _authService.authService.getProfile(),
	          organisationId = _authService$getProfi2.app_metadata.dyzio.o_id;
	
	      var invitedMember = _lodash2.default.find(users, ['id', userId]);
	
	      var invite = jsonAPIClient.create('campaignInvitation');
	      invite.set('name', invitedMember.name);
	      invite.set('campaign', {
	        type: 'campaigns',
	        id: campaignId
	      });
	      invite.set('campaignName', campaign.name);
	      invite.set('role', invitedMember.role);
	      invite.set('status', 'SENT');
	      var origin = window.location.origin;
	
	      invite.set('link', origin + '/invite/');
	
	      if (invitedMember.email) {
	        invite.set('email', invitedMember.email);
	      }
	
	      if (invitedMember.role === 'INFLUENCER') {
	        // this is where we would switch to using IDs
	        invite.set('metadata', {
	          socialHandle: invitedMember.primarySocialHandle,
	          influencerId: invitedMember.id
	        });
	      }
	
	      invite.sync().then(function (ci) {
	        var newInvitation = ci.toJSON();
	        restClient.post('/campaigns/' + campaignId + '/relationships/pendingInvitations/', {
	          data: {
	            type: 'campaignInvitation',
	            id: newInvitation.id
	          }
	        }).then(function () {
	          _this.loadTeam();
	        });
	      });
	    };
	
	    _this.state = {
	      isLoading: true,
	      isLoaded: false,
	      pendingInvitations: [],
	      members: [],
	      users: []
	    };
	    return _this;
	  }
	
	  _createClass(CampaignDashboardTeam, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadTeam();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          isLoaded = _state.isLoaded,
	          members = _state.members,
	          pendingInvitations = _state.pendingInvitations,
	          users = _state.users;
	      // console.log(users);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        isLoading && _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { active: true, size: 'big' },
	          'Loading team...'
	        ),
	        isLoaded && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Joined'
	          ),
	          _lodash2.default.isEmpty(members) && _react2.default.createElement(_semanticUiReact.Message, { content: 'No records yet.' }),
	          !_lodash2.default.isEmpty(members) && _react2.default.createElement(
	            _semanticUiReact.Card.Group,
	            { itemsPerRow: 4, style: cardGroupStyle },
	            _lodash2.default.map(members, function (member) {
	              return _react2.default.createElement(_teamMember2.default, {
	                buttonClickHandler: _this2.deleteMember,
	                key: _shortid2.default.generate(),
	                member: member
	              });
	            })
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Pending'
	          ),
	          _lodash2.default.isEmpty(pendingInvitations) && _react2.default.createElement(_semanticUiReact.Message, { content: 'No records yet.' }),
	          !_lodash2.default.isEmpty(pendingInvitations) && _react2.default.createElement(
	            _semanticUiReact.Card.Group,
	            { itemsPerRow: 4, style: cardGroupStyle },
	            _lodash2.default.map(pendingInvitations, function (pendingInvitation) {
	              return _react2.default.createElement(_teamMember2.default, { buttonClickHandler: _this2.deleteMember, key: _shortid2.default.generate(), member: pendingInvitation });
	            })
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Not Invited'
	          ),
	          _lodash2.default.isEmpty(users) && _react2.default.createElement(_semanticUiReact.Message, { content: 'No records yet.' }),
	          !_lodash2.default.isEmpty(users) && _react2.default.createElement(
	            _semanticUiReact.Card.Group,
	            { itemsPerRow: 4, style: cardGroupStyle },
	            _lodash2.default.map(users, function (user) {
	              return _react2.default.createElement(_teamMember2.default, {
	                buttonClickHandler: _this2.inviteMember,
	                key: _shortid2.default.generate(),
	                buttonLabel: 'invite',
	                buttonColor: 'green',
	                buttonIcon: 'user add',
	                member: user
	              });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignDashboardTeam;
	}(_react.Component);
	
	exports.default = (0, _recompose.compose)(_hasJsonapiClient2.default, _hasRestClient2.default)(CampaignDashboardTeam);

/***/ },
/* 2069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _recompose = __webpack_require__(15);
	
	var _campaignDashboardHeader = __webpack_require__(344);
	
	var _campaignDashboardHeader2 = _interopRequireDefault(_campaignDashboardHeader);
	
	var _addAssetForm = __webpack_require__(276);
	
	var _addAssetForm2 = _interopRequireDefault(_addAssetForm);
	
	var _addInfluencerModal = __webpack_require__(857);
	
	var _addInfluencerModal2 = _interopRequireDefault(_addInfluencerModal);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _trackedAssetsAnalyticsService = __webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ASSETS_PER_PAGE = 200;
	
	var DashboardMenu = function DashboardMenu(_ref) {
	  var menuOptions = _ref.menuOptions,
	      clickHandler = _ref.clickHandler;
	  return _react2.default.createElement(
	    _semanticUiReact.Menu,
	    { fluid: true, vertical: true },
	    _lodash2.default.map(menuOptions, function (option) {
	      return _react2.default.createElement(_semanticUiReact.Menu.Item, {
	        key: option.name,
	        active: option.active,
	        name: option.name,
	        className: 'dyzio-tab',
	        icon: option.icon,
	        onClick: clickHandler
	      });
	    })
	  );
	};
	
	var CampaignDashboardV2 = function (_Component) {
	  _inherits(CampaignDashboardV2, _Component);
	
	  function CampaignDashboardV2(props) {
	    _classCallCheck(this, CampaignDashboardV2);
	
	    var _this = _possibleConstructorReturn(this, (CampaignDashboardV2.__proto__ || Object.getPrototypeOf(CampaignDashboardV2)).call(this, props));
	
	    _this.fetchCampaign = function () {
	      var _this$props = _this.props,
	          restClient = _this$props.restClient,
	          params = _this$props.params;
	
	      restClient.get('/campaigns/' + params.id).then(function (response) {
	        var attributes = response.data.data.attributes;
	
	        _this.setState({
	          campaign: attributes
	        });
	      }).catch(function () {
	        _this.setState({
	          isAddingNewCard: false
	        });
	      });
	    };
	
	    _this.onAssetsSortByChanged = function (event, data, shouldReloadAssetsData) {
	      var value = data.value;
	
	      _this.setState({
	        sortBy: value
	      }, function () {
	        return _this.fetchTrackedAssets(shouldReloadAssetsData);
	      });
	    };
	
	    _this.fetchTrackedAssets = function (shouldReloadAssetsData) {
	      var _this$props2 = _this.props,
	          id = _this$props2.routeParams.id,
	          restClient = _this$props2.restClient;
	      var sortBy = _this.state.sortBy;
	
	      restClient.get('trackedAssets?filter[campaign]=' + id + '&sort=' + sortBy + '&page[limit]=' + ASSETS_PER_PAGE).then(function (response) {
	        var data = response.data.data;
	
	        _this.setState({
	          trackedAssets: data,
	          isLoadingTrackedAssets: false,
	          hasLoadedTrackedAssets: true,
	          hasFailedToLoadTrackedAssets: false,
	          isAddingNewCard: false
	        }, function () {
	          if (shouldReloadAssetsData) {
	            var tableViewDataRequest = _lodash2.default.map(data, 'attributes');
	            (0, _trackedAssetsAnalyticsService.getTrackedAssetAnalytics)(tableViewDataRequest).then(function (rsp) {
	              var tableViewTrackedAssets = _lodash2.default.map(rsp, 'response.data');
	              _this.setState({
	                tableViewTrackedAssets: tableViewTrackedAssets
	              });
	            });
	          }
	        });
	      }).catch(function () {
	        _this.setState({
	          hasFailedToLoadTrackedAssets: true,
	          isLoadingTrackedAssets: false,
	          hasLoadedTrackedAssets: false,
	          isAddingNewCard: false
	        });
	      });
	    };
	
	    _this.toggleAddAssetModalState = function () {
	      var assetModalOpen = _this.state.assetModalOpen;
	
	      _this.setState({
	        assetModalOpen: !assetModalOpen
	      });
	    };
	
	    _this.handleMenuItemClick = function (event, data) {
	      var name = data.name;
	      var params = _this.props.params;
	
	      _this.context.router.push('/campaign/v2/' + params.id + '/' + name);
	    };
	
	    _this.isActiveRoute = function (name) {
	      var routes = _this.props.routes;
	
	      var active = _lodash2.default.last(routes);
	      return active && active.path === name;
	    };
	
	    _this.toggleAddInfluencerModalState = function () {
	      var influencerModalOpen = _this.state.influencerModalOpen;
	
	      _this.setState({
	        influencerModalOpen: !influencerModalOpen
	      });
	    };
	
	    _this.state = {
	      campaign: null,
	      overview: null,
	      trackedAssets: [],
	      tableViewTrackedAssets: [],
	      assetModalOpen: false,
	      influencerModalOpen: false,
	      sortBy: 'createdBy',
	      isAddingNewCard: false,
	      isLoadingTrackedAssets: true,
	      hasLoadedTrackedAssets: false,
	      hasFailedToLoadTrackedAssets: false
	    };
	    return _this;
	  }
	
	  _createClass(CampaignDashboardV2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchCampaign();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state = this.state,
	          campaign = _state.campaign,
	          influencerModalOpen = _state.influencerModalOpen,
	          assetModalOpen = _state.assetModalOpen;
	
	
	      var props = _lodash2.default.assign({
	        fetchCampaign: this.fetchCampaign,
	        toggleAddAssetModalState: this.toggleAddAssetModalState,
	        onAssetsSortByChanged: this.onAssetsSortByChanged
	      }, this.props);
	
	      var menuOptions = [{ name: 'assets', icon: 'clone outline', active: this.isActiveRoute('assets') }, { name: 'overview', icon: 'eye', active: this.isActiveRoute('overview') }, { name: 'influencers', icon: 'users', active: this.isActiveRoute('influencers') }, { name: 'report', icon: 'bar graph', active: this.isActiveRoute('report') }, { name: 'team', icon: 'add user', active: this.isActiveRoute('team') }, { name: 'settings', icon: 'settings', active: this.isActiveRoute('settings') }];
	
	      var menuPaddingStyle = { padding: '15px 0px' };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        campaign && _react2.default.createElement(
	          'div',
	          { className: 'page' },
	          _react2.default.createElement(_campaignDashboardHeader2.default, {
	            name: campaign.name || 'Something went wrong',
	            addAssetActionHandler: this.toggleAddAssetModalState,
	            addInfluencerActionHandler: this.toggleAddInfluencerModalState
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'page-content' },
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 2, style: menuPaddingStyle },
	                _react2.default.createElement(DashboardMenu, { menuOptions: menuOptions, clickHandler: this.handleMenuItemClick })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { stretched: true, width: 14 },
	                children && _react2.default.cloneElement(children, this.state, props)
	              )
	            )
	          )
	        ),
	        assetModalOpen && _react2.default.createElement(_addAssetForm2.default, {
	          platform: 'external',
	          popupToggleHandler: this.toggleAddAssetModalState,
	          addAssetHandler: this.addAssetHandler
	        }),
	        influencerModalOpen && _react2.default.createElement(_addInfluencerModal2.default, {
	          toggleHandler: this.toggleAddInfluencerModalState
	        })
	      );
	    }
	  }]);
	
	  return CampaignDashboardV2;
	}(_react.Component);
	
	CampaignDashboardV2.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	CampaignDashboardV2.propTypes = {
	  restClient: _propTypes2.default.func.isRequired,
	  jsonAPIClient: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasJsonapiClient2.default)(CampaignDashboardV2);

/***/ },
/* 2070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _report = __webpack_require__(552);
	
	var _report2 = _interopRequireDefault(_report);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CampaignDashboard = function (_Component) {
	  _inherits(CampaignDashboard, _Component);
	
	  function CampaignDashboard() {
	    _classCallCheck(this, CampaignDashboard);
	
	    var _this = _possibleConstructorReturn(this, (CampaignDashboard.__proto__ || Object.getPrototypeOf(CampaignDashboard)).call(this));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CampaignDashboard, [{
	    key: 'render',
	    value: function render() {
	      var campaignId = this.props.params.id;
	
	      return _react2.default.createElement(_report2.default, Object.assign({}, this.props, { id: campaignId }));
	    }
	  }]);
	
	  return CampaignDashboard;
	}(_react.Component);
	
	exports.default = CampaignDashboard;
	
	
	CampaignDashboard.propTypes = {
	  params: _propTypes2.default.object.isRequired
	};

/***/ },
/* 2071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmailSettingsRow = function EmailSettingsRow(_ref) {
	  var name = _ref.name,
	      email = _ref.email,
	      id = _ref.id,
	      sendDailyNotifications = _ref.sendDailyNotifications,
	      sendWeeklyNotifications = _ref.sendWeeklyNotifications,
	      onPermissionChange = _ref.onPermissionChange;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Header,
	        { as: 'h4' },
	        _react2.default.createElement(
	          _semanticUiReact.Header.Content,
	          null,
	          name,
	          _react2.default.createElement(
	            _semanticUiReact.Header.Subheader,
	            null,
	            email
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center' },
	      _react2.default.createElement(_semanticUiReact.Checkbox, {
	        value: sendDailyNotifications,
	        defaultChecked: sendDailyNotifications,
	        onClick: function onClick() {
	          return onPermissionChange({ id: id, key: 'sendDailyNotifications', value: !sendDailyNotifications });
	        }
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'center' },
	      _react2.default.createElement(_semanticUiReact.Checkbox, {
	        value: sendWeeklyNotifications,
	        defaultChecked: sendWeeklyNotifications,
	        onClick: function onClick() {
	          return onPermissionChange({ id: id, key: 'sendWeeklyNotifications', value: !sendWeeklyNotifications });
	        }
	      })
	    )
	  );
	};
	
	var EmailSettingsComponent = function EmailSettingsComponent(_ref2) {
	  var teamMembers = _ref2.teamMembers,
	      campaignId = _ref2.campaignId,
	      onPermissionChange = _ref2.onPermissionChange,
	      showManageLink = _ref2.showManageLink;
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { basic: 'very' },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Header,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { singleLine: true },
	          'Team Member'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { collapsing: true },
	          'Daily Summary'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { collapsing: true },
	          'Weeky Summary'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _lodash2.default.map(teamMembers, function (member) {
	        return _react2.default.createElement(EmailSettingsRow, Object.assign({}, member, { onPermissionChange: onPermissionChange }));
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Footer,
	      { fullWidth: true },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          { colSpan: 3, textAlign: 'center' },
	          showManageLink && _react2.default.createElement(
	            'a',
	            { href: '/campaign/' + campaignId + '/invite' },
	            'Manage team members'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = EmailSettingsComponent;

/***/ },
/* 2072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _statusBar = __webpack_require__(170);
	
	var _statusBar2 = _interopRequireDefault(_statusBar);
	
	var _actions = __webpack_require__(105);
	
	var _invitation = __webpack_require__(914);
	
	var _invitation2 = _interopRequireDefault(_invitation);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pStyle = {
	  textAlign: 'center'
	};
	
	var pageStyle = {
	  marginTop: 50
	};
	
	var CampaignInviteMore = function (_React$Component) {
	  _inherits(CampaignInviteMore, _React$Component);
	
	  function CampaignInviteMore() {
	    _classCallCheck(this, CampaignInviteMore);
	
	    var _this = _possibleConstructorReturn(this, (CampaignInviteMore.__proto__ || Object.getPrototypeOf(CampaignInviteMore)).call(this));
	
	    _this.getProfile = function () {
	      // Retrieves the profile data from localStorage
	      var profile = localStorage.getItem('profile');
	      return profile ? JSON.parse(localStorage.profile) : {};
	    };
	
	    _this.componentDidMount = function () {
	      var campaignId = _this.props.routeParams.id;
	      _this.client.get('campaigns', campaignId, { include: ['members', 'pendingInvitations', 'discussions'] }).then(function (newCampaign) {
	        _this.setState({
	          campaign: newCampaign.toJSONTree()
	        });
	      });
	    };
	
	    _this.goToCampaign = function () {
	      var campaignId = _this.props.routeParams.id;
	      _this.context.router.push('/campaign/' + campaignId);
	    };
	
	    _this.state = {
	      campaign: null
	    };
	
	    _this.client = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	      header: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(CampaignInviteMore, [{
	    key: 'render',
	    value: function render() {
	      var campaign = this.state.campaign;
	
	      var profile = this.getProfile();
	      var organisationId = profile.app_metadata.dyzio.o_id;
	
	      var organisation = _lodash2.default.get(this.props, 'user.user.organisation', {});
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            _react2.default.createElement(
	              'div',
	              { style: pageStyle },
	              _react2.default.createElement(_statusBar2.default, null),
	              campaign && _react2.default.createElement(_invitation2.default, {
	                campaign: campaign,
	                organisationId: organisationId,
	                organisation: organisation
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignInviteMore;
	}(_react2.default.Component);
	
	CampaignInviteMore.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	CampaignInviteMore.propTypes = {
	  routeParams: _propTypes2.default.object.isRequired
	};
	
	
	CampaignInviteMore.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentUser: state.userData.get('currentUser'),
	    user: state.user
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onSetStatusBar: function onSetStatusBar(message, colour) {
	      return dispatch((0, _actions.setStatusBar)(message, colour));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CampaignInviteMore);

/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setSignupPrefilled = setSignupPrefilled;
	exports.setLoginPrefilled = setLoginPrefilled;
	exports.clearInvitePrefilled = clearInvitePrefilled;
	exports.loadCampaignInvite = loadCampaignInvite;
	
	var _constants = __webpack_require__(556);
	
	function setSignupPrefilled(shortId, name, email) {
	  return {
	    type: _constants.SET_SIGNUP_PREFILLED,
	    shortId: shortId,
	    name: name,
	    email: email
	  };
	}
	
	function setLoginPrefilled(email) {
	  return {
	    type: _constants.SET_LOGIN_PREFILLED,
	    email: email
	  };
	}
	
	function clearInvitePrefilled() {
	  return {
	    type: _constants.CLEAR_INVITE_PREFILLED
	  };
	}
	
	function loadCampaignInvite(data) {
	  return {
	    type: _constants.LOAD_CAMPAIGN_INVITE,
	    data: data
	  };
	}

/***/ },
/* 2074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(28);
	
	var _recompose = __webpack_require__(15);
	
	var _bowser = __webpack_require__(368);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _actions = __webpack_require__(2073);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var theme = _themeSelector2.default.theme();
	var CORQ_DOMAIN = 'data.corq.studio';
	
	var CampaignInvite = function (_React$Component) {
	  _inherits(CampaignInvite, _React$Component);
	
	  function CampaignInvite() {
	    _classCallCheck(this, CampaignInvite);
	
	    var _this = _possibleConstructorReturn(this, (CampaignInvite.__proto__ || Object.getPrototypeOf(CampaignInvite)).call(this));
	
	    _this.isBannedBrowser = function () {
	      return _bowser2.default.msie;
	    };
	
	    _this.changeUrlPath = function (path) {
	      return _this.context.router.push(path);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CampaignInvite, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var hostname = window.location.hostname;
	
	
	      var urlInviteId = this.props.routeParams && this.props.routeParams.inviteid ? this.props.routeParams.inviteid : false;
	
	      if (hostname === CORQ_DOMAIN) {
	        // TEMPORARILY RE_RUOTE INFLUENCERS TO DYZIO SITE
	        window.location = 'https://corq.dyzio.co/invite/' + urlInviteId;
	      }
	
	      // if SAFARI cancel the process and ask them to use chrome
	      var isBannedBrowser = this.isBannedBrowser();
	
	      if (!isBannedBrowser) {
	        this.props.onLoadCampaignInvite({ changeUrlCallback: this.changeUrlPath, urlInviteId: urlInviteId });
	      } else {
	        this.setState({ isBanned: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          error = _props.error,
	          loading = _props.loading,
	          userInfo = _props.userInfo;
	
	
	      var is401 = error && error.match(/401/);
	      var isBanned = this.state.isBanned;
	
	
	      var isBannedBrowser = this.isBannedBrowser();
	      var url = window.location.href;
	
	      var email = userInfo.email;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-centered' },
	        _react2.default.createElement(
	          'div',
	          { className: 'center-outer' },
	          error && !loading && _react2.default.createElement(
	            'div',
	            { className: 'center-inner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'center-logo' },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this2.context.router.push('/');
	                  } },
	                _react2.default.createElement('img', { src: theme.darkLogo.src, alt: theme.darkLogo.alt })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'center-content' },
	              _react2.default.createElement(
	                'p',
	                { className: 'info' },
	                'There was an error processing your invitation: ',
	                error
	              ),
	              is401 && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_semanticUiReact.Divider, null),
	                _react2.default.createElement(
	                  'h3',
	                  { style: { textAlign: 'center' } },
	                  'It looks like you might be testing the invitations...',
	                  _react2.default.createElement('br', null),
	                  'You MUST open the invitation in a DIFFERENT browser!'
	                ),
	                _react2.default.createElement(_semanticUiReact.Divider, null),
	                _react2.default.createElement(
	                  'p',
	                  { style: { textAlign: 'center' } },
	                  'You are currently logged in as ',
	                  email
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                { className: 'info' },
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return _this2.context.router.push('/');
	                    } },
	                  'continue to the website...'
	                )
	              )
	            )
	          ),
	          !isBanned && loading && _react2.default.createElement(
	            'div',
	            { className: 'preloader' },
	            _react2.default.createElement('img', { src: '/icons/dyzio-icon.svg', alt: 'Loading...' })
	          ),
	          isBannedBrowser && _react2.default.createElement(
	            'div',
	            { className: 'page-centered' },
	            _react2.default.createElement(
	              'div',
	              { className: 'center-outer' },
	              _react2.default.createElement(
	                'div',
	                { className: 'center-inner' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'center-logo' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/' },
	                    _react2.default.createElement('img', { src: theme.darkLogo.src, alt: theme.darkLogo.alt })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'center-content' },
	                  _react2.default.createElement('div', { className: 'spacer small' }),
	                  _react2.default.createElement(
	                    'h1',
	                    { style: { textAlign: 'center' } },
	                    'Sorry...',
	                    _react2.default.createElement('br', null),
	                    'We do not support ',
	                    _bowser2.default.name,
	                    ' ',
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'frown', color: 'red' })
	                  ),
	                  _react2.default.createElement('div', { className: 'spacer' }),
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'info', style: { textAlign: 'center' } },
	                    'Please open the invitation in a different browser',
	                    _react2.default.createElement('br', null),
	                    'like Chrome or Firefox.'
	                  ),
	                  _react2.default.createElement('hr', null),
	                  _react2.default.createElement(
	                    'p',
	                    { style: { textAlign: 'center' } },
	                    url
	                  ),
	                  _react2.default.createElement('hr', null),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'info' },
	                    'You can also use the chat button in the bottom right of your screen to contact us directly.'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                  _react2.default.createElement(_semanticUiReact.Message, {
	                    warning: true,
	                    header: 'This browser will not work',
	                    content: 'Sorry we do not support Safari or IE, please try chrome or firefox. We are working to resolve this!'
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignInvite;
	}(_react2.default.Component);
	
	CampaignInvite.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    error: state.invite.get('error'),
	    loading: state.invite.get('loading')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onLoadCampaignInvite: function onLoadCampaignInvite(data) {
	      return dispatch((0, _actions.loadCampaignInvite)(data));
	    }
	  };
	}
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _hasUserInfo2.default)(CampaignInvite);

/***/ },
/* 2075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(556);
	
	var initialState = (0, _immutable.fromJS)({
	  shortId: null,
	  name: null,
	  email: null,
	  error: null,
	  loading: true
	});
	
	function campaignInviteReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_SIGNUP_PREFILLED:
	      return state.set('shortId', action.shortId).set('name', action.name).set('email', action.email);
	    case _constants.SET_LOGIN_PREFILLED:
	      return state.set('email', action.email);
	    case _constants.LOAD_CAMPAIGN_INVITE:
	      return state.set('loading', true).set('error', null);
	    case _constants.LOAD_CAMPAIGN_INVITE_ERROR:
	      return state.set('loading', false).set('error', action.error);
	    case _constants.CLEAR_INVITE_PREFILLED:
	      return initialState;
	    default:
	      return state;
	  }
	}
	
	exports.default = campaignInviteReducer;

/***/ },
/* 2076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.redirectUser = redirectUser;
	exports.loadCampaignInvite = loadCampaignInvite;
	exports.watchLoadCampaignInviteSagas = watchLoadCampaignInviteSagas;
	exports.default = loadCampaignInviteSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _authService = __webpack_require__(21);
	
	var _campaignInvitations = __webpack_require__(934);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _constants = __webpack_require__(556);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [processInvites, loadCampaignInvite, watchLoadCampaignInviteSagas, loadCampaignInviteSagas].map(_regenerator2.default.mark);
	
	function processInvites(invites) {
	  return _regenerator2.default.wrap(function processInvites$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return invites.map(function (inviteId) {
	            return (0, _effects.call)(_campaignInvitations.processCampaignInvitation, inviteId);
	          });
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function redirectUser(changeUrlCallback) {
	  var path = localStorage.getItem('path');
	  if (path) {
	    changeUrlCallback(path);
	    localStorage.removeItem('path');
	  } else {
	    changeUrlCallback('/');
	  }
	}
	
	function loadCampaignInvite(action) {
	  var _action$data, changeUrlCallback, urlInviteId, loggedIn, campaignInvites, campaignInvitesArray, campaignInvitation, name, email, newUser, _campaignInvites, _campaignInvitesArray, idExists;
	
	  return _regenerator2.default.wrap(function loadCampaignInvite$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _action$data = action.data, changeUrlCallback = _action$data.changeUrlCallback, urlInviteId = _action$data.urlInviteId;
	          loggedIn = _authService.authService.loggedIn();
	          _context2.prev = 2;
	
	          // Nothing to process, redirect to homepage
	          if (!loggedIn && !urlInviteId) {
	            changeUrlCallback('/');
	          }
	
	          // Process logged in user with invite ID
	
	          if (!(loggedIn && urlInviteId)) {
	            _context2.next = 8;
	            break;
	          }
	
	          _context2.next = 7;
	          return (0, _effects.call)(_campaignInvitations.processCampaignInvitation, urlInviteId);
	
	        case 7:
	          changeUrlCallback('/');
	
	        case 8:
	          if (!(loggedIn && !urlInviteId)) {
	            _context2.next = 22;
	            break;
	          }
	
	          campaignInvites = localStorage.getItem('campaignInvitesToProcess');
	
	          if (!campaignInvites) {
	            _context2.next = 21;
	            break;
	          }
	
	          campaignInvitesArray = JSON.parse(campaignInvites);
	          _context2.prev = 12;
	          _context2.next = 15;
	          return (0, _effects.call)(processInvites, campaignInvitesArray);
	
	        case 15:
	          _context2.next = 20;
	          break;
	
	        case 17:
	          _context2.prev = 17;
	          _context2.t0 = _context2['catch'](12);
	
	          (0, _errorHandlingService.reportError)('CREATE_CAMPAIGN_PERMISSION_ERROR', _context2.t0.message);
	
	        case 20:
	          localStorage.removeItem('campaignInvitesToProcess');
	
	        case 21:
	          redirectUser(changeUrlCallback);
	
	        case 22:
	          if (!(!loggedIn && urlInviteId)) {
	            _context2.next = 38;
	            break;
	          }
	
	          _context2.next = 25;
	          return (0, _effects.call)(_campaignInvitations.getCampaignInvitationAxios, urlInviteId);
	
	        case 25:
	          campaignInvitation = _context2.sent;
	          name = campaignInvitation.name, email = campaignInvitation.email, newUser = campaignInvitation.newUser;
	          _campaignInvites = localStorage.getItem('campaignInvitesToProcess');
	
	
	          if (!_campaignInvites) {
	            localStorage.setItem('campaignInvitesToProcess', JSON.stringify([urlInviteId]));
	          } else {
	            _campaignInvitesArray = JSON.parse(_campaignInvites);
	            idExists = _campaignInvitesArray.find(function (inviteId) {
	              return inviteId === urlInviteId;
	            });
	
	            if (!idExists) _campaignInvitesArray.push(urlInviteId);
	            localStorage.setItem('campaignInvitesToProcess', JSON.stringify(_campaignInvitesArray));
	          }
	
	          if (!newUser) {
	            _context2.next = 35;
	            break;
	          }
	
	          _context2.next = 32;
	          return (0, _effects.put)({ type: _constants.SET_SIGNUP_PREFILLED, shortId: urlInviteId, name: name, email: email });
	
	        case 32:
	          changeUrlCallback('/signup');
	          _context2.next = 38;
	          break;
	
	        case 35:
	          _context2.next = 37;
	          return (0, _effects.put)({ type: _constants.SET_LOGIN_PREFILLED, email: email });
	
	        case 37:
	          changeUrlCallback('/login');
	
	        case 38:
	          _context2.next = 45;
	          break;
	
	        case 40:
	          _context2.prev = 40;
	          _context2.t1 = _context2['catch'](2);
	
	          (0, _errorHandlingService.reportError)('CREATE_CAMPAIGN_PERMISSION_ERROR', _context2.t1.message);
	
	          _context2.next = 45;
	          return (0, _effects.put)({ type: _constants.LOAD_CAMPAIGN_INVITE_ERROR, error: _context2.t1.message });
	
	        case 45:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[2, 40], [12, 17]]);
	}
	
	function watchLoadCampaignInviteSagas() {
	  return _regenerator2.default.wrap(function watchLoadCampaignInviteSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.LOAD_CAMPAIGN_INVITE, loadCampaignInvite);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function loadCampaignInviteSagas() {
	  return _regenerator2.default.wrap(function loadCampaignInviteSagas$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return [(0, _effects.fork)(watchLoadCampaignInviteSagas)];
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}

/***/ },
/* 2077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _uuid = __webpack_require__(832);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _pagination = __webpack_require__(147);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _createNewCampaign = __webpack_require__(569);
	
	var _createNewCampaign2 = _interopRequireDefault(_createNewCampaign);
	
	var _campaignsTable = __webpack_require__(540);
	
	var _campaignsTable2 = _interopRequireDefault(_campaignsTable);
	
	var _tabActionBar = __webpack_require__(194);
	
	var _tabActionBar2 = _interopRequireDefault(_tabActionBar);
	
	var _campaignCard = __webpack_require__(863);
	
	var _campaignCard2 = _interopRequireDefault(_campaignCard);
	
	var _dyzioEmptyState = __webpack_require__(192);
	
	var _dyzioEmptyState2 = _interopRequireDefault(_dyzioEmptyState);
	
	var _newAddCampaignModal = __webpack_require__(550);
	
	var _newAddCampaignModal2 = _interopRequireDefault(_newAddCampaignModal);
	
	var _dyzioMessages = __webpack_require__(870);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasLocalstorageClient = __webpack_require__(127);
	
	var _hasLocalstorageClient2 = _interopRequireDefault(_hasLocalstorageClient);
	
	var _hasViewmodeManagement = __webpack_require__(568);
	
	var _hasViewmodeManagement2 = _interopRequireDefault(_hasViewmodeManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CAMPAIGN_VERSION_TWO = 2;
	var DEFAULT_PER_PAGE = 8;
	var HELP_PAGE_URL = 'https://help.dyzio.co/campaigns/campaign-list';
	
	var perPageOptions = [{ key: '10', text: '10', value: 10 }, { key: '20', text: '20', value: 20 }, { key: '50', text: '50', value: 50 }];
	
	var campaignTypesOptions = [{
	  value: 'AUTOMATED',
	  text: 'Automated Campaign',
	  key: 'AUTOMATED'
	}, {
	  value: 'ACR',
	  text: 'Automated Channel Report',
	  key: 'ACR'
	}, {
	  value: 'WORKFLOW',
	  text: 'Manual',
	  key: 'WORKFLOW'
	}, {
	  value: 'all',
	  text: 'All',
	  key: 'ALL'
	}];
	
	var campaignStates = [{ key: 'ACTIVE', text: 'Active', value: 'ACTIVE' }, { key: 'ARCHIVED', text: 'Archived', value: 'ARCHIVED' }];
	
	var sortByOptions = [{ key: 'assetsCountAsc', text: 'Assets count (ASC)', value: { field: 'totalAssetsCount', order: 'ASC' } }, { key: 'assetsCountDesc', text: 'Assets count (DESC)', value: { field: 'totalAssetsCount', order: 'DESC' } }, {
	  key: 'createdDateAsc',
	  text: 'Created date (ASC)',
	  value: {
	    field: 'campaignCreatedDate',
	    order: 'ASC'
	  }
	}, {
	  key: 'createdDateDesc',
	  text: 'Created date (DESC)',
	  value: {
	    field: 'campaignCreatedDate',
	    order: 'DESC'
	  }
	}, { key: 'nameAsc', text: 'Name (ASC)', value: { field: 'campaignName', order: 'ASC' } }, { key: 'nameDesc', text: 'Name (DESC)', value: { field: 'campaignName', order: 'DESC' } }];
	
	var INITIAL_FORM_STATE_FIELDS = {
	  name: null,
	  budget: null,
	  liveDate: null,
	  hashtags: null,
	  endDate: null,
	  version: 2,
	  hasChanged: false,
	  savedOk: false,
	  isValidBudget: true
	};
	
	var CampaignsList = function (_React$Component) {
	  _inherits(CampaignsList, _React$Component);
	
	  function CampaignsList(props) {
	    _classCallCheck(this, CampaignsList);
	
	    var _this = _possibleConstructorReturn(this, (CampaignsList.__proto__ || Object.getPrototypeOf(CampaignsList)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    console.log('CampaignsList constructor');
	    var savedViewMode = props.dyzioStorage.get(props.dyzioStorage.KEYS.CAMPAGINS_LIST_VIEW_MODE);
	    var perPage = props.dyzioStorage.get(props.dyzioStorage.KEYS.CAMPAIGNS_LIST_PER_PAGE);
	    var sortBy = props.dyzioStorage.get(props.dyzioStorage.KEYS.CAMPAIGNS_LIST_SORT_BY);
	    var campaignFilter = props.dyzioStorage.get(props.dyzioStorage.KEYS.CAMPAIGNS_LIST_FILTER);
	    _this.state = _extends({
	      isLoadingCampaigns: true,
	      isLoading: true,
	      isFailed: false,
	      isLoaded: false,
	      isTimeoutError: false,
	      records: [],
	      totalRecords: 0,
	      campaignFilter: campaignFilter.value || 'ACTIVE',
	      viewMode: props.viewModeManager.getViewMode(savedViewMode),
	      currentPage: 1,
	      search: {},
	      perPage: perPage.value || DEFAULT_PER_PAGE,
	      addCampaignModalVisible: false,
	      sort: sortBy.value || {
	        field: 'campaignCreatedDate',
	        order: 'DESC'
	      },
	      filter: {
	        version: CAMPAIGN_VERSION_TWO,
	        campaignType: 'all'
	      }
	    }, INITIAL_FORM_STATE_FIELDS);
	    return _this;
	  }
	
	  _createClass(CampaignsList, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var actionButtonProps = {
	        onClick: this.toggleAddNewCampaignModalState,
	        content: 'Add a campaign'
	      };
	
	      var _props$userInfo = this.props.userInfo,
	          email = _props$userInfo.email,
	          userName = _props$userInfo.name,
	          userId = _props$userInfo.userId,
	          isUserSuperAdmin = _props$userInfo.isUserSuperAdmin;
	
	
	      var messageProps = {
	        email: email, userName: userName, userId: userId
	      };
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          isLoaded = _state.isLoaded,
	          isFailed = _state.isFailed,
	          records = _state.records,
	          viewMode = _state.viewMode,
	          addCampaignModalVisible = _state.addCampaignModalVisible,
	          currentPage = _state.currentPage,
	          perPage = _state.perPage,
	          totalRecords = _state.totalRecords,
	          sort = _state.sort,
	          campaignFilter = _state.campaignFilter,
	          isLoadingCampaigns = _state.isLoadingCampaigns,
	          searchTerm = _state.search.searchTerm,
	          isTimeoutError = _state.isTimeoutError;
	
	
	      var totalPages = _lodash2.default.ceil(totalRecords / perPage);
	      var isSearchContext = searchTerm && searchTerm.length > 0;
	
	      var isLargeCardsViewMode = viewMode === _tabActionBar.ViewModes.cardsLarge;
	      var isSmallCardsViewMode = viewMode === _tabActionBar.ViewModes.cardsSmall;
	      var isTableView = viewMode === _tabActionBar.ViewModes.table;
	      var isCardsViewMode = isLargeCardsViewMode || isSmallCardsViewMode;
	      var noCampaignPermissions = _lodash2.default.isEmpty(records);
	      var isLoadSuccess = isLoaded && !isFailed && !noCampaignPermissions;
	      var isLoadEmptyData = isLoaded && !isFailed && noCampaignPermissions;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_tabActionBar2.default, {
	          hasSmallCardsView: false,
	          hasSearchBox: true,
	          hasCampaignTypeFilter: true,
	          hasCampaignFilter: true,
	          hasActionButton: true,
	          hasPerPageSelector: true,
	          actionButtonProps: actionButtonProps,
	          onViewModeChanged: this.onViewModeChanged,
	          shouldDisableButtons: isLoading || noCampaignPermissions,
	          isLargeCards: isLargeCardsViewMode,
	          isSmallCards: isSmallCardsViewMode,
	          isTableView: isTableView,
	          sortByOptions: sortByOptions,
	          campaignTypesOptions: campaignTypesOptions,
	          sort: sort,
	          onCamapignTypeFilterChanged: this.onCamapignTypeFilterChanged,
	          onSortByChanged: this.onSortByChanged,
	          onPerPageValueChanged: this.onPerPageValueChanged,
	          onSearchInputSubmit: this.onSearchInputSubmit,
	          onSearchCleared: this.onSearchCleared,
	          onCampaignFilterChanged: this.onCampaignFilterChanged,
	          perPage: perPage,
	          helpPageUrl: HELP_PAGE_URL,
	          perPageOptions: perPageOptions,
	          campaignFilterOptions: campaignStates,
	          campaignFilter: campaignFilter
	        }),
	        isLoading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading campaigns...' }),
	        isTimeoutError && _react2.default.createElement(_dyzioMessages.DyzioWarningMessage, {
	          header: 'Sorry... Your request timed out!',
	          content: 'Our tech team has been informed and will look into the issue for you.',
	          reportMessage: 'Loading campaigns timeout',
	          reportMessageArgs: messageProps
	        }),
	        isLoadEmptyData && _react2.default.createElement(_dyzioEmptyState2.default, {
	          isSearchContext: isSearchContext,
	          buttonLabel: 'Add a campaign',
	          helpUrl: 'https://help.dyzio.co/en/articles/5089448-how-to-create-a-campaign',
	          context: 'CAMPAIGNS',
	          onClick: this.toggleAddNewCampaignModalState,
	          content: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              !isSearchContext ? 'You have no ' + this.getCampaignTypeFilterMessage() + ' campaigns.' : 'No search results!'
	            ),
	            !isSearchContext && _react2.default.createElement(
	              'p',
	              null,
	              'Use the button below to start your first ',
	              this.getCampaignTypeFilterMessage(),
	              ' campaign.'
	            )
	          )
	        }),
	        isLoadSuccess && isCardsViewMode && _react2.default.createElement(
	          _semanticUiReact.Card.Group,
	          { itemsPerRow: isLargeCardsViewMode ? 4 : 6 },
	          _lodash2.default.map(records, function (record) {
	            return _react2.default.createElement(_campaignCard2.default, Object.assign({
	              listType: campaignFilter,
	              key: (0, _uuid2.default)()
	            }, record, {
	              onDelete: _this2.onDeleteCampaign,
	              onArchive: _this2.onArchiveCampaign,
	              onUnarchive: _this2.onUnarchiveCampaign,
	              isUserSuperAdmin: isUserSuperAdmin
	            }));
	          })
	        ),
	        isLoadSuccess && isTableView && _react2.default.createElement(_campaignsTable2.default, {
	          records: records,
	          isLoadingCampaigns: isLoadingCampaigns,
	          onDelete: this.onDeleteCampaign,
	          onArchive: this.onArchiveCampaign,
	          onUnarchive: this.onUnarchiveCampaign,
	          listType: campaignFilter,
	          isUserSuperAdmin: isUserSuperAdmin
	        }),
	        isLoadSuccess && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(_pagination2.default, {
	            onPageIncrement: this.onPageIncrement,
	            onPageDecrement: this.onPageDecrement,
	            currentPage: currentPage,
	            totalPages: totalPages
	          })
	        ),
	        addCampaignModalVisible && _react2.default.createElement(_newAddCampaignModal2.default, {
	          onClose: this.toggleAddNewCampaignModalState,
	          onAddCampaignSubmit: this.onAddCampaignSubmit,
	          allowCampaignTypeChange: true
	        })
	      );
	    }
	  }]);
	
	  return CampaignsList;
	}(_react2.default.Component);
	
	CampaignsList.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.componentDidMount = function () {
	    console.log('CampaignsList componentDidMount');
	    _this3.requestData();
	  };
	
	  this.onSortByChanged = function (event, data) {
	    var value = data.value;
	    var _props = _this3.props,
	        dyzioStorage = _props.dyzioStorage,
	        viewModeManager = _props.viewModeManager;
	
	    _this3.setState({
	      sort: value
	    }, function () {
	      viewModeManager.updateViewMode(dyzioStorage.KEYS.CAMPAIGNS_LIST_SORT_BY, value);
	      _this3.requestData();
	    });
	  };
	
	  this.onViewModeChanged = function (event, data) {
	    var name = data.name;
	    var _props2 = _this3.props,
	        dyzioStorage = _props2.dyzioStorage,
	        viewModeManager = _props2.viewModeManager;
	
	    _this3.setState({
	      viewMode: name
	    }, function () {
	      viewModeManager.updateViewMode(dyzioStorage.KEYS.CAMPAGINS_LIST_VIEW_MODE, name);
	    });
	  };
	
	  this.onInputChange = function (event, _ref) {
	    var _this3$setState;
	
	    var name = _ref.name,
	        value = _ref.value;
	
	    _this3.setState((_this3$setState = {}, _defineProperty(_this3$setState, name, value), _defineProperty(_this3$setState, 'hasChanged', true), _defineProperty(_this3$setState, 'savedOk', false), _this3$setState));
	  };
	
	  this.onLiveDateChange = function (date) {
	    _this3.setState({
	      liveDate: date,
	      hasChanged: true,
	      savedOk: false
	    });
	  };
	
	  this.onEndDateChange = function (date) {
	    _this3.setState({
	      endDate: date,
	      hasChanged: true,
	      savedOk: false
	    });
	  };
	
	  this.onDeleteCampaign = function (id) {
	    if (id) {
	      _this3.updateCampaign(id, {
	        attributes: {
	          status: 'DELETED'
	        }
	      });
	    }
	  };
	
	  this.onArchiveCampaign = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(id) {
	      var _props3, restClient, organisationId;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!id) {
	                _context.next = 5;
	                break;
	              }
	
	              _props3 = _this3.props, restClient = _props3.restClient, organisationId = _props3.userInfo.organisationId;
	              _context.next = 4;
	              return restClient({
	                method: 'DELETE',
	                url: '/organisations/' + organisationId + '/cache',
	                baseURL: ("https://dl6gzrmms2.execute-api.eu-west-1.amazonaws.com/production")
	              });
	
	            case 4:
	              _this3.updateCampaign(id, {
	                attributes: {
	                  status: 'ARCHIVED'
	                }
	              });
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this3);
	    }));
	
	    return function (_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  this.onUnarchiveCampaign = function (id) {
	    if (id) {
	      _this3.updateCampaign(id, {
	        attributes: {
	          status: 'ACTIVE'
	        }
	      });
	    }
	  };
	
	  this.onCurrencyChange = function (event, data) {
	    var value = data.value;
	
	    _this3.setState({
	      currency: value
	    });
	  };
	
	  this.onPageIncrement = function () {
	    _this3.setState(function (prevState) {
	      return {
	        currentPage: prevState.currentPage + 1
	      };
	    }, _this3.requestData);
	  };
	
	  this.onPageDecrement = function () {
	    _this3.setState(function (prevState) {
	      return {
	        currentPage: prevState.currentPage - 1
	      };
	    }, _this3.requestData);
	  };
	
	  this.onPerPageValueChanged = function (event, _ref3) {
	    var value = _ref3.value;
	    var _props4 = _this3.props,
	        dyzioStorage = _props4.dyzioStorage,
	        viewModeManager = _props4.viewModeManager;
	
	    _this3.setState({
	      perPage: value
	    }, function () {
	      viewModeManager.updateViewMode(dyzioStorage.KEYS.CAMPAIGNS_LIST_PER_PAGE, value);
	      _this3.requestData();
	    });
	  };
	
	  this.onSearchInputSubmit = function (value) {
	    _this3.setState({
	      search: {
	        searchTerm: value
	      }
	    }, _this3.requestData);
	  };
	
	  this.onSearchCleared = function () {
	    _this3.setState({
	      search: {}
	    }, _this3.requestData);
	  };
	
	  this.toggleAddNewCampaignModalState = function () {
	    var addCampaignModalVisible = _this3.state.addCampaignModalVisible;
	
	    var updatedState = {
	      addCampaignModalVisible: !addCampaignModalVisible
	    };
	    if (addCampaignModalVisible) {
	      _lodash2.default.assign(updatedState, INITIAL_FORM_STATE_FIELDS);
	    }
	    _this3.setState(updatedState);
	  };
	
	  this.requestData = function () {
	    var _props5 = _this3.props,
	        restClient = _props5.restClient,
	        userInfo = _props5.userInfo;
	    var userId = userInfo.userId,
	        organisationId = userInfo.organisationId,
	        isUserSuperAdmin = userInfo.isUserSuperAdmin;
	    var _state2 = _this3.state,
	        sort = _state2.sort,
	        currentPage = _state2.currentPage,
	        perPage = _state2.perPage,
	        search = _state2.search,
	        campaignFilter = _state2.campaignFilter,
	        filter = _state2.filter;
	
	
	    var campaignType = _lodash2.default.get(filter, 'campaignType', null);
	
	    var options = {
	      perPage: perPage,
	      currentPage: currentPage,
	      search: search,
	      sort: sort,
	      filter: {
	        campaignPermissionStatus: campaignFilter,
	        campaignType: campaignType && campaignType !== 'all' ? campaignType : undefined
	      }
	    };
	
	    // if there is a search then force the results page back to the start
	    // should use setState here or disable the pagination controls on a search
	    if (search.searchTerm) options.currentPage = 1;
	
	    var campaignQueryUrl = void 0;
	
	    if (isUserSuperAdmin) {
	      campaignQueryUrl = '/organisations/' + organisationId + '/campaigns?q=';
	    } else {
	      options = _lodash2.default.assignIn(options, { userId: userId });
	      campaignQueryUrl = '/campaigns/query?q=';
	    }
	
	    var queryParams = encodeURIComponent(JSON.stringify(options));
	    _this3.setState({
	      isLoaded: false,
	      isFailed: false,
	      isLoading: true
	    }, function () {
	      var restRequest = restClient({
	        method: 'get',
	        url: '' + campaignQueryUrl + queryParams,
	        baseURL: ("https://dl6gzrmms2.execute-api.eu-west-1.amazonaws.com/production")
	      }).then(function (response) {
	        var _response$data$data = response.data.data,
	            data = _response$data$data.data,
	            results = _response$data$data.results;
	
	        return _this3.setState({
	          records: data,
	          isLoadingCampaigns: false,
	          totalRecords: results
	        });
	      });
	
	      var orgPromise = restClient.get('organisations/' + organisationId).then(function (organisationResource) {
	        var attributes = organisationResource.data.data.attributes;
	        var defaultCurrency = attributes.defaultCurrency;
	
	        return _this3.setState({ organisation: attributes, defaultCurrency: defaultCurrency, currency: defaultCurrency });
	      });
	
	      Promise.all([restRequest, orgPromise]).then(function () {
	        return _this3.setState({
	          isLoaded: true,
	          isFailed: false,
	          isLoading: false
	        });
	      }).catch(function (error) {
	        _this3.setState({
	          isLoadingCampaigns: false,
	          isLoaded: true,
	          isTimeoutError: error && _lodash2.default.includes(error.toString(), 'timeout'),
	          isFailed: true,
	          isLoading: false
	        });
	      });
	    });
	  };
	
	  this.onCampaignFilterChanged = function (event, _ref4) {
	    var value = _ref4.value;
	    var _props6 = _this3.props,
	        dyzioStorage = _props6.dyzioStorage,
	        viewModeManager = _props6.viewModeManager;
	
	    _this3.setState({
	      campaignFilter: value
	    }, function () {
	      viewModeManager.updateViewMode(dyzioStorage.KEYS.CAMPAIGNS_LIST_FILTER, value);
	      _this3.requestData();
	    });
	  };
	
	  this.updateCampaign = function (id, data) {
	    var restClient = _this3.props.restClient;
	
	    restClient.patch('/campaignPermission/' + id, {
	      data: data
	    }).then(function () {
	      _this3.requestData();
	    });
	  };
	
	  this.onAddCampaignSubmit = function (values) {
	    var organisation = _this3.state.organisation;
	    var _props7 = _this3.props,
	        jsonAPIClient = _props7.jsonAPIClient,
	        userInfo = _props7.userInfo;
	
	
	    return (0, _createNewCampaign2.default)(_extends({}, values, {
	      jsonAPIClient: jsonAPIClient,
	      userInfo: userInfo,
	      organisation: organisation
	    }));
	  };
	
	  this.onCamapignTypeFilterChanged = function (event, _ref5) {
	    var value = _ref5.value;
	    var filter = _this3.state.filter;
	
	    var newFilter = _extends({}, filter, { campaignType: value });
	    _this3.setState({
	      filter: newFilter
	    }, _this3.requestData);
	  };
	
	  this.getCampaignTypeFilterMessage = function () {
	    var filter = _this3.state.filter;
	
	    if (filter.campaignType && filter.campaignType !== 'all') {
	      var option = _lodash2.default.find(campaignTypesOptions, ['value', filter.campaignType]);
	      return _lodash2.default.get(option, 'text', '');
	    }
	    return '';
	  };
	};
	
	CampaignsList.propTypes = {
	  dyzioStorage: _propTypes2.default.object.isRequired,
	  viewModeManager: _propTypes2.default.object.isRequired,
	  userInfo: _propTypes2.default.object.isRequired,
	  jsonAPIClient: _propTypes2.default.object.isRequired,
	  restClient: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasJsonapiClient2.default, _hasUserInfo2.default, _hasLocalstorageClient2.default, _hasViewmodeManagement2.default)(CampaignsList);

/***/ },
/* 2078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _statusBar = __webpack_require__(170);
	
	var _statusBar2 = _interopRequireDefault(_statusBar);
	
	var _actions = __webpack_require__(105);
	
	var _invitedTable = __webpack_require__(885);
	
	var _invitedTable2 = _interopRequireDefault(_invitedTable);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pStyle = {
	  textAlign: 'center'
	};
	
	var pageStyle = {
	  marginTop: 50
	};
	
	var CampaignManage = function (_React$Component) {
	  _inherits(CampaignManage, _React$Component);
	
	  function CampaignManage() {
	    _classCallCheck(this, CampaignManage);
	
	    var _this = _possibleConstructorReturn(this, (CampaignManage.__proto__ || Object.getPrototypeOf(CampaignManage)).call(this));
	
	    _this.getProfile = function () {
	      // Retrieves the profile data from localStorage
	      var profile = localStorage.getItem('profile');
	      return profile ? JSON.parse(localStorage.profile) : {};
	    };
	
	    _this.componentDidMount = function () {
	      var campaignId = _this.props.routeParams.id;
	      _this.client.get('campaigns', campaignId, { include: ['members', 'pendingInvitations'] }).then(function (newCampaign) {
	        _this.setState({
	          campaign: newCampaign.toJSONTree()
	        });
	      });
	    };
	
	    _this.goToCampaign = function () {
	      var campaignId = _this.props.routeParams.id;
	      var campaign = _this.state.campaign;
	
	
	      var isACR = campaign.campaignType === 'ACR';
	      _this.context.router.push('/' + (isACR ? 'acr-' : '') + 'campaign/' + campaignId);
	    };
	
	    _this.state = {
	      campaign: null
	    };
	
	    _this.client = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	      header: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(CampaignManage, [{
	    key: 'render',
	    value: function render() {
	      var campaign = this.state.campaign;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            _react2.default.createElement(
	              'div',
	              { style: pageStyle },
	              _react2.default.createElement(_statusBar2.default, null),
	              _react2.default.createElement(
	                'h1',
	                { style: pStyle },
	                'Manage people on your campaign'
	              ),
	              campaign && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'h2',
	                  { style: pStyle },
	                  campaign.name
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_invitedTable2.default, { campaign: campaign })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: pStyle },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'large rose wide', onClick: this.goToCampaign
	                  },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Take me back to my campaign'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignManage;
	}(_react2.default.Component);
	
	CampaignManage.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	CampaignManage.propTypes = {
	  routeParams: _propTypes2.default.object.isRequired
	};
	
	
	CampaignManage.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentUser: state.userData.get('currentUser')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onSetStatusBar: function onSetStatusBar(message, colour) {
	      return dispatch((0, _actions.setStatusBar)(message, colour));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CampaignManage);

/***/ },
/* 2079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _roleService = __webpack_require__(143);
	
	var _actions = __webpack_require__(907);
	
	var _member = __webpack_require__(888);
	
	var _member2 = _interopRequireDefault(_member);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CampaignMembersManage = function (_React$Component) {
	  _inherits(CampaignMembersManage, _React$Component);
	
	  function CampaignMembersManage() {
	    _classCallCheck(this, CampaignMembersManage);
	
	    return _possibleConstructorReturn(this, (CampaignMembersManage.__proto__ || Object.getPrototypeOf(CampaignMembersManage)).apply(this, arguments));
	  }
	
	  _createClass(CampaignMembersManage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Users must navigate to this page from a valid campaign
	      var campaignExist = this.props.campaign.size > 0;
	      if (!campaignExist) {
	        this.context.router.push('/');
	      }
	
	      if (!(0, _roleService.checkUserHasAdminRights)(this.props.myUserRole)) {
	        this.context.router.push('/');
	      }
	    }
	  }, {
	    key: 'deleteMember',
	    value: function deleteMember(member) {
	      var permissionId = member.get('id');
	      var userId = member.getIn(['user', 'id']);
	      var role = member.get('role');
	
	      // Campaign owners cant be deleted
	      if (role === _staticConfiguration.CAMPAIGN_OWNER) {
	        return null;
	      }
	
	      this.props.onRemoveMember(permissionId, userId);
	    }
	  }, {
	    key: 'deletePendingMember',
	    value: function deletePendingMember(member) {
	      var invitationId = member.get('id');
	
	      this.props.onRemovePendingMember(invitationId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          campaign = _props.campaign,
	          members = _props.members,
	          pendingInvitations = _props.pendingInvitations;
	
	
	      var campaignName = campaign.get('name');
	      var campaignString = '/campaign/' + campaign.get('id');
	
	      var teamMembers = [];
	      var clientMembers = [];
	      var influencerMembers = [];
	
	      if (members) {
	        members.forEach(function (member) {
	          var role = member.get('role');
	
	          if (role === _staticConfiguration.TEAM_MEMBER || role === _staticConfiguration.CAMPAIGN_OWNER || role === _staticConfiguration.CAMPAIGN_ADMIN) teamMembers.push(member);
	          if (role === _staticConfiguration.CLIENT) clientMembers.push(member);
	          if (role === _staticConfiguration.INFLUENCER) influencerMembers.push(member);
	        });
	      }
	
	      var totalPendingInvitations = 0;
	      pendingInvitations.forEach(function (organisation) {
	        return totalPendingInvitations += organisation.size;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'breadcrumb-bar' },
	                _react2.default.createElement('img', { src: '/icons/chevron-left.svg', alt: 'back to campaign', onClick: function onClick() {
	                    return _this2.context.router.push('' + campaignString);
	                  } }),
	                _react2.default.createElement(
	                  'h3',
	                  { onClick: function onClick() {
	                      return _this2.context.router.push('' + campaignString);
	                    } },
	                  campaignName
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-3-6 grid-xl-3-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'hero left' },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  'Manage people'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-3-6 grid-xl-3-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'hero action right' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'medium icon', onClick: function onClick() {
	                      return _this2.context.router.push('/campaign/members');
	                    } },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Invite people'
	                  ),
	                  _react2.default.createElement('img', { src: '/icons/add-person.svg', alt: 'Invite people' })
	                )
	              )
	            ),
	            teamMembers.length > 0 && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Team (',
	                  teamMembers.length,
	                  ')'
	                )
	              ),
	              teamMembers.map(function (member) {
	                var teamMemberRole = member.get('role');
	
	                return _react2.default.createElement(_member2.default, {
	                  key: member.get('id'),
	                  deleteMember: _this2.deleteMember.bind(_this2, member),
	                  member: member,
	                  deletable: teamMemberRole !== _staticConfiguration.CAMPAIGN_OWNER
	                });
	              })
	            ),
	            clientMembers.length > 0 && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement('div', { className: 'spacer' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Clients (',
	                  clientMembers.length,
	                  ')'
	                )
	              ),
	              clientMembers.map(function (member) {
	                return _react2.default.createElement(_member2.default, {
	                  key: member.get('id'),
	                  deleteMember: _this2.deleteMember.bind(_this2, member),
	                  member: member,
	                  deletable: true
	                });
	              })
	            ),
	            influencerMembers.length > 0 && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement('div', { className: 'spacer' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Influencers (',
	                  influencerMembers.length,
	                  ')'
	                )
	              ),
	              influencerMembers.map(function (member) {
	                return _react2.default.createElement(_member2.default, {
	                  key: member.get('id'),
	                  deleteMember: _this2.deleteMember.bind(_this2, member),
	                  member: member,
	                  deletable: true
	                });
	              })
	            ),
	            pendingInvitations.size > 0 && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement('div', { className: 'spacer' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Pending invites (',
	                  totalPendingInvitations,
	                  ')'
	                )
	              ),
	              pendingInvitations.map(function (organisation) {
	                return organisation.map(function (member) {
	                  return _react2.default.createElement(_member2.default, {
	                    key: member.get('id'),
	                    deleteMember: _this2.deletePendingMember.bind(_this2, member),
	                    member: member,
	                    pendingInvites: true,
	                    deletable: true
	                  });
	                });
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignMembersManage;
	}(_react2.default.Component);
	
	CampaignMembersManage.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	CampaignMembersManage.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    campaign: state.campaign.get('campaign'),
	    myUserRole: state.campaign.get('myUserRole'),
	    members: state.members.get('members'),
	    pendingInvitations: state.members.get('pendingInvitations'),
	    removeMemberLoading: state.members.get('removeMemberLoading'),
	    removeMemberError: state.members.get('removeMemberError')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onRemoveMember: function onRemoveMember(permissionId, userId) {
	      return dispatch((0, _actions.removeMember)(permissionId, userId));
	    },
	    onRemovePendingMember: function onRemovePendingMember(invitationId) {
	      return dispatch((0, _actions.removePendingMember)(invitationId));
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CampaignMembersManage);

/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(356);
	
	var initialState = (0, _immutable.fromJS)({
	  members: {},
	  pendingInvitations: {},
	  removeMemberLoading: false,
	  removeMemberError: null,
	  removeMemberId: null
	});
	
	function updatePendingInvitations(pendingInvitations, invitationId, organisationId) {
	  var newPendingInvitations = pendingInvitations.updateIn([organisationId], function (pendingInvites) {
	    return pendingInvites.filter(function (pendingInvite) {
	      return pendingInvite.get('id') !== invitationId;
	    });
	  });
	  if (!newPendingInvitations.get(organisationId).size > 0) {
	    return newPendingInvitations.delete(organisationId);
	  }
	  return newPendingInvitations;
	}
	
	function campaignMembersReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.LOAD_MEMBERS_SUCCESS:
	      return state.set('members', action.members).set('pendingInvitations', action.pendingInvitations);
	    case _constants.REMOVE_MEMBER:
	      return state.set('removeMemberId', action.permissionId).set('removeMemberLoading', true).set('removeMemberError', null);
	    case _constants.REMOVE_PENDING_MEMBER:
	      return state.set('removeMemberId', action.invitationId).set('removeMemberLoading', true).set('removeMemberError', null);
	    case _constants.REMOVE_MEMBER_SUCCESS:
	      return state.set('removeMemberId', null).set('members', state.get('members').delete(action.permissionId)).set('removeMemberLoading', false).set('removeMemberError', null);
	    case _constants.REMOVE_PENDING_MEMBER_SUCCESS:
	      return state.set('removeMemberId', null).set('pendingInvitations', updatePendingInvitations(state.get('pendingInvitations'), action.invitationId, action.organisationId)).set('removeMemberLoading', false).set('removeMemberError', null);
	    case _constants.REMOVE_MEMBER_ERROR:
	      return state.set('removeMemberId', null).set('removeMemberLoading', false).set('removeMemberError', action.error);
	    case _constants.SHOW_REMOVE_MODAL:
	      return state.set('removeMemberId', action.id);
	    case _constants.HIDE_REMOVE_MODAL:
	      return state.set('removeMemberId', null);
	    default:
	      return state;
	  }
	}
	
	exports.default = campaignMembersReducer;

/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.removePendingMember = removePendingMember;
	exports.removeMember = removeMember;
	exports.removeMemberFromChannel = removeMemberFromChannel;
	exports.watchRemoveMemberFromCampaign = watchRemoveMemberFromCampaign;
	exports.watchRemovePendingMemberFromCampaign = watchRemovePendingMemberFromCampaign;
	exports.default = campaignMemberManageSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	var _campaignSelectors = __webpack_require__(117);
	
	var _campaignPermissions = __webpack_require__(363);
	
	var _campaigns = __webpack_require__(129);
	
	var _discussions = __webpack_require__(172);
	
	var _campaignInvitations = __webpack_require__(934);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _constants = __webpack_require__(356);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [removePendingMember, removeMember, watchRemoveMemberFromCampaign, watchRemovePendingMemberFromCampaign, campaignMemberManageSagas].map(_regenerator2.default.mark);
	
	function removePendingMember(action) {
	  var invitationId, campaignId, campaignInvitation, campaignInvitationJSON;
	  return _regenerator2.default.wrap(function removePendingMember$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          invitationId = action.invitationId;
	          _context.next = 3;
	          return (0, _effects.select)(_campaignSelectors.getCampaignId);
	
	        case 3:
	          campaignId = _context.sent;
	          _context.prev = 4;
	          _context.next = 7;
	          return (0, _effects.call)(_campaignInvitations.getCampaignInvitation, invitationId);
	
	        case 7:
	          campaignInvitation = _context.sent;
	          campaignInvitationJSON = campaignInvitation.toJSONTree();
	          _context.next = 11;
	          return (0, _effects.call)(_campaigns.removePendingInviationFromCampaign, campaignId, campaignInvitation);
	
	        case 11:
	          _context.next = 13;
	          return (0, _effects.call)(_campaignInvitations.deleteCampaignInvitation, campaignInvitation);
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.put)({
	            type: _constants.REMOVE_PENDING_MEMBER_SUCCESS,
	            organisationId: campaignInvitationJSON.organisation.id,
	            invitationId: campaignInvitationJSON.id
	          });
	
	        case 15:
	          _context.next = 22;
	          break;
	
	        case 17:
	          _context.prev = 17;
	          _context.t0 = _context['catch'](4);
	
	          (0, _errorHandlingService.reportError)('REMOVE_CAMPAIGN_INVITATION_ERROR', _context.t0.message);
	          _context.next = 22;
	          return (0, _effects.put)({ type: _constants.REMOVE_MEMBER_ERROR, error: _context.t0 });
	
	        case 22:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[4, 17]]);
	}
	
	function removeMember(action) {
	  var permissionId, userId, campaignId, discussions, filteredDiscussions, campaignPermission, x, sendbirdChannelURL, id;
	  return _regenerator2.default.wrap(function removeMember$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          permissionId = action.permissionId;
	          userId = action.userId;
	          _context2.prev = 2;
	          _context2.next = 5;
	          return (0, _effects.select)(_campaignSelectors.getCampaignId);
	
	        case 5:
	          campaignId = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.call)(_campaigns.getCampaignDiscussions, campaignId);
	
	        case 8:
	          discussions = _context2.sent;
	          filteredDiscussions = [];
	
	
	          if (discussions) {
	            discussions.forEach(function (discussion) {
	              var discussionMembers = discussion.members;
	              var userIsMember = _lodash2.default.find(discussionMembers, function (discussionMember) {
	                return discussionMember.id === permissionId;
	              });
	              if (userIsMember) filteredDiscussions.push(discussion);
	            });
	          }
	
	          _context2.next = 13;
	          return (0, _effects.call)(_campaignPermissions.getCampaignPermission, permissionId);
	
	        case 13:
	          campaignPermission = _context2.sent;
	          x = 0;
	
	        case 15:
	          if (!(x < filteredDiscussions.length)) {
	            _context2.next = 25;
	            break;
	          }
	
	          sendbirdChannelURL = filteredDiscussions[x].channelURL;
	          id = filteredDiscussions[x].id;
	
	          // Remove user from channel
	
	          _context2.next = 20;
	          return (0, _effects.call)(removeMemberFromChannel, sendbirdChannelURL, userId);
	
	        case 20:
	          _context2.next = 22;
	          return (0, _effects.call)(_discussions.removeMemberFromDiscussion, id, campaignPermission);
	
	        case 22:
	          x++;
	          _context2.next = 15;
	          break;
	
	        case 25:
	          _context2.next = 27;
	          return (0, _effects.call)(_campaigns.removeCampaignPermissionFromCampaign, campaignId, campaignPermission);
	
	        case 27:
	          _context2.next = 29;
	          return (0, _effects.call)(_campaignPermissions.deleteCampaignPermission, campaignPermission);
	
	        case 29:
	          _context2.next = 31;
	          return (0, _effects.put)({ type: _constants.REMOVE_MEMBER_SUCCESS, permissionId: permissionId });
	
	        case 31:
	          _context2.next = 38;
	          break;
	
	        case 33:
	          _context2.prev = 33;
	          _context2.t0 = _context2['catch'](2);
	
	          (0, _errorHandlingService.reportError)('REMOVE_CAMPAIGN_MEMBER_ERROR', _context2.t0.message);
	          _context2.next = 38;
	          return (0, _effects.put)({ type: _constants.REMOVE_MEMBER_ERROR, error: _context2.t0 });
	
	        case 38:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[2, 33]]);
	}
	
	function removeMemberFromChannel(channelURL, userId) {
	  var axiosService = new _axiosService2.default('https://api.sendbird.com/v3', 3000, { 'Api-Token': ("76d121b106a181d02ec5d1cb059bbd2d76e383f2") });
	
	  return axiosService.put('/group_channels/' + channelURL + '/leave', { user_ids: [userId] }).then(function (response) {
	    return response;
	  });
	}
	
	function watchRemoveMemberFromCampaign() {
	  return _regenerator2.default.wrap(function watchRemoveMemberFromCampaign$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.REMOVE_MEMBER, removeMember);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function watchRemovePendingMemberFromCampaign() {
	  return _regenerator2.default.wrap(function watchRemovePendingMemberFromCampaign$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.REMOVE_PENDING_MEMBER, removePendingMember);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function campaignMemberManageSagas() {
	  return _regenerator2.default.wrap(function campaignMemberManageSagas$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(watchRemoveMemberFromCampaign), (0, _effects.fork)(watchRemovePendingMemberFromCampaign)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _actions = __webpack_require__(105);
	
	var _roleService = __webpack_require__(143);
	
	var _campaignInvite = __webpack_require__(908);
	
	var _campaignInvite2 = _interopRequireDefault(_campaignInvite);
	
	var _member = __webpack_require__(888);
	
	var _member2 = _interopRequireDefault(_member);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CampaignMembers = function (_React$Component) {
	  _inherits(CampaignMembers, _React$Component);
	
	  function CampaignMembers() {
	    _classCallCheck(this, CampaignMembers);
	
	    return _possibleConstructorReturn(this, (CampaignMembers.__proto__ || Object.getPrototypeOf(CampaignMembers)).apply(this, arguments));
	  }
	
	  _createClass(CampaignMembers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Users must navigate to this page from a valid campaign
	      var campaignExist = this.props.campaign.size > 0;
	      if (!campaignExist) {
	        this.context.router.push('/');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Reset status bar
	      this.props.onClearStatusBar();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          myUserRole = _props.myUserRole,
	          campaign = _props.campaign,
	          members = _props.members,
	          pendingInvitations = _props.pendingInvitations;
	
	
	      var campaignName = campaign.get('name');
	      var campaignId = campaign.get('id');
	
	      var teamMembers = [];
	      var clientMembers = [];
	      var influencerMembers = [];
	      var memberEmails = [];
	      var pendingMemberEmails = [];
	
	      if (members) {
	        members.forEach(function (member) {
	          var email = member.get('email');
	          var role = member.get('role');
	
	          memberEmails.push(email);
	          if (role === _staticConfiguration.TEAM_MEMBER || role === _staticConfiguration.CAMPAIGN_OWNER || role === _staticConfiguration.CAMPAIGN_ADMIN) teamMembers.push(member);
	          if (role === _staticConfiguration.CLIENT) clientMembers.push(member);
	          if (role === _staticConfiguration.INFLUENCER) influencerMembers.push(member);
	        });
	      }
	
	      if (pendingInvitations.size > 0) {
	        pendingInvitations.forEach(function (organisation) {
	          return organisation.forEach(function (member) {
	            var email = member.get('email');
	            pendingMemberEmails.push(email);
	          });
	        });
	      }
	
	      var isUserTeamMember = (0, _roleService.checkUserIsTeamMember)(myUserRole);
	      var isUserAnAdmin = (0, _roleService.checkUserHasAdminRights)(myUserRole);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'breadcrumb-bar' },
	                _react2.default.createElement('img', { src: '/icons/chevron-left.svg', alt: 'back to campaign', onClick: function onClick() {
	                    return _this2.context.router.push('/campaign/' + campaignId);
	                  } }),
	                _react2.default.createElement(
	                  'h3',
	                  { onClick: function onClick() {
	                      return _this2.context.router.push('/campaign/' + campaignId);
	                    } },
	                  campaignName
	                )
	              )
	            ),
	            isUserTeamMember && _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-3-6 grid-xl-3-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'hero left' },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  'Invite people'
	                )
	              )
	            ),
	            isUserAnAdmin && _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-3-6 grid-xl-3-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'hero action right' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'medium icon', onClick: function onClick() {
	                      return _this2.context.router.push('/campaign/members/manage');
	                    } },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Manage people'
	                  ),
	                  _react2.default.createElement('img', { src: '/icons/settings.svg', alt: 'Manage people' })
	                )
	              )
	            ),
	            isUserTeamMember && _react2.default.createElement(_campaignInvite2.default, {
	              campaignId: campaignId,
	              campaignName: campaignName,
	              memberEmails: memberEmails,
	              pendingMemberEmails: pendingMemberEmails
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	              isUserTeamMember && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { className: 'spacer' }),
	                _react2.default.createElement('div', { className: 'break' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'hero left' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'On this campaign'
	                )
	              )
	            ),
	            teamMembers.length > 0 && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Team (',
	                  teamMembers.length,
	                  ')'
	                )
	              ),
	              teamMembers.map(function (member) {
	                return _react2.default.createElement(_member2.default, {
	                  key: member.get('id'),
	                  member: member,
	                  deletable: false
	                });
	              })
	            ),
	            clientMembers.length > 0 && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement('div', { className: 'spacer' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Clients (',
	                  clientMembers.length,
	                  ')'
	                )
	              ),
	              clientMembers.map(function (member) {
	                return _react2.default.createElement(_member2.default, {
	                  key: member.get('id'),
	                  member: member,
	                  deletable: false
	                });
	              })
	            ),
	            influencerMembers.length > 0 && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement('div', { className: 'spacer' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Influencers (',
	                  influencerMembers.length,
	                  ')'
	                )
	              ),
	              influencerMembers.map(function (member) {
	                return _react2.default.createElement(_member2.default, { key: member.get('id'), member: member, deletable: false });
	              })
	            ),
	            pendingInvitations.size > 0 && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement('div', { className: 'spacer' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Pending invites (',
	                  pendingInvitations.size,
	                  ')'
	                )
	              ),
	              pendingInvitations.map(function (organisation) {
	                return organisation.map(function (member) {
	                  return _react2.default.createElement(_member2.default, { key: member.get('id'), member: member, pendingInvites: true, deletable: false, pendingInviteUrl: member.get('link') });
	                });
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignMembers;
	}(_react2.default.Component);
	
	CampaignMembers.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	CampaignMembers.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    campaign: state.campaign.get('campaign'),
	    members: state.members.get('members'),
	    pendingInvitations: state.members.get('pendingInvitations'),
	    myUserRole: state.campaign.get('myUserRole')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onSetStatusBar: function onSetStatusBar(message, colour) {
	      return dispatch((0, _actions.setStatusBar)(message, colour));
	    },
	    onClearStatusBar: function onClearStatusBar() {
	      return dispatch((0, _actions.clearStatusBar)());
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CampaignMembers);

/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _immutable = __webpack_require__(71);
	
	var _reactDates = __webpack_require__(1487);
	
	var _actions = __webpack_require__(557);
	
	var _actions2 = __webpack_require__(359);
	
	var _formInputText = __webpack_require__(104);
	
	var _formInputText2 = _interopRequireDefault(_formInputText);
	
	var _formInputCurrency = __webpack_require__(1944);
	
	var _formInputCurrency2 = _interopRequireDefault(_formInputCurrency);
	
	var _actions3 = __webpack_require__(105);
	
	var _sendbirdService = __webpack_require__(366);
	
	var _organisations = __webpack_require__(2386);
	
	var _campaigns = __webpack_require__(129);
	
	var _campaignPermissions = __webpack_require__(363);
	
	var _discussions = __webpack_require__(172);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _metricAnalyticsService = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CampaignCreate = function (_React$Component) {
	  _inherits(CampaignCreate, _React$Component);
	
	  function CampaignCreate(props, context) {
	    _classCallCheck(this, CampaignCreate);
	
	    var _this = _possibleConstructorReturn(this, (CampaignCreate.__proto__ || Object.getPrototypeOf(CampaignCreate)).call(this, props, context));
	
	    _this.state = {
	      createCampaignLoading: false,
	      liveDateFocused: false
	    };
	    return _this;
	  }
	
	  _createClass(CampaignCreate, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.reset(); // Reset form values
	    }
	  }, {
	    key: 'createCampaign',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(formData) {
	        var campaignName, campaignBudget, liveDate, userId, organisationId, email, campaignData, campaign, campaignJSON, campaignPermissionData, campaignPermission, campaignPermissionJSON, ownerPermissionId, createTeamDiscussion, teamDiscussion, campaignCreateData;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.setState({ createCampaignLoading: true });
	
	                campaignName = formData.get('campaignName');
	                campaignBudget = formData.get('campaignBudget') || 0;
	                liveDate = formData.get('liveDate') ? formData.get('liveDate').toISOString() : null;
	                userId = this.props.userData.get('id');
	                organisationId = this.props.userData.get('organisationId');
	                email = this.props.userData.get('email');
	                _context.prev = 7;
	                campaignData = {
	                  name: campaignName,
	                  budget: campaignBudget,
	                  campaignType: 'WORKFLOW',
	                  liveDate: liveDate
	                };
	                _context.next = 11;
	                return (0, _campaigns.createCampaign)(campaignData, 'no');
	
	              case 11:
	                campaign = _context.sent;
	                campaignJSON = campaign.toJSONTree();
	                campaignPermissionData = {
	                  campaignId: campaignJSON.id,
	                  userId: userId,
	                  email: email,
	                  role: _staticConfiguration.CAMPAIGN_OWNER,
	                  organisationId: organisationId
	                };
	                _context.next = 16;
	                return (0, _campaignPermissions.createCampaignPermission)(campaignPermissionData);
	
	              case 16:
	                campaignPermission = _context.sent;
	                campaignPermissionJSON = campaignPermission.toJSONTree();
	
	                console.log(campaignPermissionJSON);
	                // Login user
	                _context.next = 21;
	                return _sendbirdService.sendBirdService.connectSendbirdUser(userId);
	
	              case 21:
	                console.log('sendbird user connected');
	
	                // Make both client and team member discussion and add them as relationships
	                ownerPermissionId = campaignPermission.toJSON().id;
	                createTeamDiscussion = false; // we have switched off team discussion at the minute.
	
	                if (!createTeamDiscussion) {
	                  _context.next = 33;
	                  break;
	                }
	
	                console.log('creating team discussion');
	                _context.next = 28;
	                return this.createDiscussion('Team', campaignJSON.id, userId, ownerPermissionId, [campaignJSON.owner.id]);
	
	              case 28:
	                teamDiscussion = _context.sent;
	                _context.next = 31;
	                return (0, _campaigns.addChatDiscussionToCamapign)(campaign, 'teamDiscussion', teamDiscussion);
	
	              case 31:
	                _context.next = 34;
	                break;
	
	              case 33:
	                console.log('NOT creating team discussion!');
	
	              case 34:
	                _context.next = 36;
	                return (0, _campaigns.addCampaignPermission)(campaign, campaignPermission);
	
	              case 36:
	                campaignCreateData = {
	                  campaignId: campaignJSON.id,
	                  campaignName: campaignName,
	                  campaignBudget: campaignBudget,
	                  includesClient: false
	                };
	
	
	                (0, _metricAnalyticsService.trackEvent)('Create Campaign', campaignCreateData);
	                console.log('about to set props');
	
	                this.props.setCampaignData(campaignJSON.id, campaignName);
	                this.props.setCampaignCreated(true);
	                this.props.onSetCampaignPermission(campaignPermissionJSON);
	                this.props.onLoadingCampaign(campaignJSON.id);
	                console.log('finished');
	                _context.next = 50;
	                break;
	
	              case 46:
	                _context.prev = 46;
	                _context.t0 = _context['catch'](7);
	
	                (0, _errorHandlingService.reportError)('CREATE_CAMPAIGN_ERROR', _context.t0.message);
	                this.props.onSetStatusBar(_context.t0.message, 'red');
	
	              case 50:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[7, 46]]);
	      }));
	
	      function createCampaign(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return createCampaign;
	    }()
	  }, {
	    key: 'createDiscussion',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(discussionName, campaignId, ownerId, ownerPermissionId, organisationIds) {
	        var sendbirdMembers, channelURL, discussionMembers, organisationsList, discussionData, discussion;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                sendbirdMembers = [ownerId];
	                channelURL = void 0;
	                _context2.prev = 2;
	                _context2.next = 5;
	                return _sendbirdService.sendBirdService.createSendbirdChannel(sendbirdMembers, discussionName);
	
	              case 5:
	                channelURL = _context2.sent;
	                _context2.next = 12;
	                break;
	
	              case 8:
	                _context2.prev = 8;
	                _context2.t0 = _context2['catch'](2);
	
	                (0, _errorHandlingService.reportError)('CREATE_SENDBIRD_CHANNEL_ERROR', _context2.t0.message);
	                this.props.onSetStatusBar('Error setting up collaborations: ' + _context2.t0.message, 'red');
	
	              case 12:
	                discussionMembers = [{ type: 'campaignPermission', id: ownerPermissionId }];
	                organisationsList = [];
	
	                organisationIds.forEach(function (organisation) {
	                  return organisationsList.push({ type: 'organisations', id: organisation });
	                });
	
	                discussionData = {
	                  name: discussionName,
	                  members: discussionMembers,
	                  channelURL: channelURL,
	                  campaignId: campaignId,
	                  organisationsList: organisationsList
	                };
	                _context2.prev = 16;
	                _context2.next = 19;
	                return (0, _discussions.createDiscussion)(discussionData);
	
	              case 19:
	                discussion = _context2.sent;
	                return _context2.abrupt('return', discussion);
	
	              case 23:
	                _context2.prev = 23;
	                _context2.t1 = _context2['catch'](16);
	
	                (0, _errorHandlingService.reportError)('CREATE_DISCUSSION_ERROR', _context2.t1.message);
	                this.props.onSetStatusBar(_context2.t1.message, 'red');
	
	              case 27:
	                return _context2.abrupt('return', null);
	
	              case 28:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[2, 8], [16, 23]]);
	      }));
	
	      function createDiscussion(_x2, _x3, _x4, _x5, _x6) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return createDiscussion;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var handleSubmit = this.props.handleSubmit;
	      var createCampaignLoading = this.state.createCampaignLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hero' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Create a campaign'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.createCampaign.bind(this)) },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Name your campaign'
	            ),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Make sure it\u2019s nice and descriptive. This is what people will see when you add them to the campaign.'
	            ),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(_immutable.Field, { name: 'campaignName', type: 'text', label: '', component: _formInputText2.default, placeholder: 'Silver Spoon Company Q3 Campaign' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-4-6 grid-xl-4-6' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Influencer budget ',
	              _react2.default.createElement(
	                'span',
	                { className: 'light' },
	                '(optional)'
	              )
	            ),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The total campaign budget will be visible to your team members only. You can use this to decide how much money to budget for each influencer and to make secure payments to them.'
	            ),
	            _react2.default.createElement(_immutable.Field, { name: 'campaignBudget', component: _formInputCurrency2.default, placeholder: 0 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-4-6 grid-xl-4-6' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Live date'
	            ),
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This will be the default live date for deliverables created on this campaign.'
	            ),
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(_immutable.Field, {
	              name: 'liveDate',
	              component: function component(props) {
	                var _props$input = props.input,
	                    value = _props$input.value,
	                    onChange = _props$input.onChange;
	
	                return _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_reactDates.SingleDatePicker, Object.assign({
	                    id: 'liveDate'
	                  }, props, {
	                    date: value || null,
	                    focused: _this2.state.liveDateFocused,
	                    numberOfMonths: 1,
	                    displayFormat: 'DD/MM/YYYY',
	                    placeholder: 'Select a date',
	                    onDateChange: function onDateChange(date) {
	                      return onChange(date);
	                    },
	                    onFocusChange: function onFocusChange(_ref3) {
	                      var focused = _ref3.focused;
	                      return _this2.setState({ liveDateFocused: focused });
	                    }
	                  })),
	                  props.meta.touched && props.meta.error && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('div', { className: 'spacer small' }),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'small error' },
	                      props.meta.error
	                    )
	                  )
	                );
	              }
	            })
	          ),
	          _react2.default.createElement('div', { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-2-6 grid-xl-2-6' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	            _react2.default.createElement(
	              'div',
	              { className: 'hero' },
	              _react2.default.createElement(
	                'button',
	                { className: 'large rose wide', type: 'submit' },
	                createCampaignLoading ? _react2.default.createElement(
	                  'ul',
	                  { className: 'dots' },
	                  _react2.default.createElement('li', { id: 'dot1' }),
	                  _react2.default.createElement('li', null),
	                  _react2.default.createElement('li', { id: 'dot2' }),
	                  _react2.default.createElement('li', null),
	                  _react2.default.createElement('li', { id: 'dot3' })
	                ) : _react2.default.createElement(
	                  'p',
	                  null,
	                  'create campaign'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignCreate;
	}(_react2.default.Component);
	
	CampaignCreate.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	CampaignCreate.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	function validate(values) {
	  var errors = {};
	
	  var campaignName = values.get('campaignName');
	  var liveDate = values.get('liveDate');
	
	  if (!campaignName) errors.campaignName = 'Enter a campaign name.';
	  if (!liveDate) errors.liveDate = 'Enter the date the campaign goes live.';
	
	  return errors;
	}
	
	var selector = (0, _immutable.formValueSelector)('NewCampaignForm');
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentUser: state.userData.get('currentUser'),
	    userData: state.userData.get('userData'),
	    hasClient: 'no',
	    campaignBrief: selector(state, 'campaignBrief'),
	    initialValues: {
	      hasClient: 'no'
	    }
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onSetStatusBar: function onSetStatusBar(message, colour) {
	      return dispatch((0, _actions3.setStatusBar)(message, colour));
	    },
	    onLoadingCampaign: function onLoadingCampaign(campaignId) {
	      return dispatch((0, _actions.loadingCampaign)(campaignId));
	    },
	    onSetCampaignPermission: function onSetCampaignPermission(campaignPermission) {
	      return dispatch((0, _actions2.setCampaignPermission)(campaignPermission));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutable.reduxForm)({
	  form: 'NewCampaignForm',
	  validate: validate
	})(CampaignCreate));

/***/ },
/* 2084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _statusBar = __webpack_require__(170);
	
	var _statusBar2 = _interopRequireDefault(_statusBar);
	
	var _actions = __webpack_require__(105);
	
	var _campaignCreate = __webpack_require__(2083);
	
	var _campaignCreate2 = _interopRequireDefault(_campaignCreate);
	
	var _campaignInvite = __webpack_require__(908);
	
	var _campaignInvite2 = _interopRequireDefault(_campaignInvite);
	
	var _invitation = __webpack_require__(914);
	
	var _invitation2 = _interopRequireDefault(_invitation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scroll = __webpack_require__(327);
	
	var scroll = Scroll.animateScroll;
	
	var CampaignNew = function (_React$Component) {
	  _inherits(CampaignNew, _React$Component);
	
	  function CampaignNew() {
	    _classCallCheck(this, CampaignNew);
	
	    var _this = _possibleConstructorReturn(this, (CampaignNew.__proto__ || Object.getPrototypeOf(CampaignNew)).call(this));
	
	    _this.state = {
	      campaignCreated: false,
	      campaignId: null
	    };
	    return _this;
	  }
	
	  _createClass(CampaignNew, [{
	    key: 'setCampaignCreated',
	    value: function setCampaignCreated(bool) {
	      this.setState({ campaignCreated: bool });
	      if (bool) scroll.scrollToTop();
	    }
	  }, {
	    key: 'setCampaignData',
	    value: function setCampaignData(campaignId, campaignName) {
	      this.setState({ campaignId: campaignId, campaignName: campaignName });
	    }
	  }, {
	    key: 'getProfile',
	    value: function getProfile() {
	      // Retrieves the profile data from localStorage
	      var profile = localStorage.getItem('profile');
	      return profile ? JSON.parse(localStorage.profile) : {};
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          campaignCreated = _state.campaignCreated,
	          campaignId = _state.campaignId,
	          campaignName = _state.campaignName;
	
	      var profile = this.getProfile();
	      var organisationId = profile.app_metadata.dyzio.o_id;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            _react2.default.createElement(_statusBar2.default, null),
	            !campaignCreated ? _react2.default.createElement(_campaignCreate2.default, {
	              setCampaignCreated: function setCampaignCreated(bool) {
	                return _this2.setCampaignCreated(bool);
	              },
	              setCampaignData: function setCampaignData(campaignId, campaignName) {
	                return _this2.setCampaignData(campaignId, campaignName);
	              }
	            }) : _react2.default.createElement(_invitation2.default, { campaignId: campaignId, campaignName: campaignName, organisationId: organisationId })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignNew;
	}(_react2.default.Component);
	
	CampaignNew.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	CampaignNew.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentUser: state.userData.get('currentUser')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onSetStatusBar: function onSetStatusBar(message, colour) {
	      return dispatch((0, _actions.setStatusBar)(message, colour));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CampaignNew);

/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFileDrop = __webpack_require__(724);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactQuill = __webpack_require__(731);
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	var _s3Service = __webpack_require__(573);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var quillStyle = {
	  minHeight: 100
	};
	
	var uploadFileBlock = {
	  width: '100%',
	  height: 70,
	  marginTop: 10,
	  border: '1px solid #777',
	  textAlign: 'center',
	  paddingTop: 25,
	  textTransform: 'uppercase',
	  borderRadius: 5
	};
	
	var titleStyle = {
	  paddingBottom: 5,
	  display: 'block'
	};
	
	var hiddenStyle = {
	  display: 'none'
	};
	
	var checkboxStyle = {
	  marginTop: 10,
	  marginBottom: 10
	};
	
	var CampaignOverviewSettings = function (_React$Component) {
	  _inherits(CampaignOverviewSettings, _React$Component);
	
	  //
	  function CampaignOverviewSettings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CampaignOverviewSettings);
	
	    var _this = _possibleConstructorReturn(this, (CampaignOverviewSettings.__proto__ || Object.getPrototypeOf(CampaignOverviewSettings)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, restClient, campaignId, response, overview, documents;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, restClient = _this$props.restClient, campaignId = _this$props.campaignId;
	              _context.next = 3;
	              return restClient.get('campaigns/' + campaignId + '?include=documents');
	
	            case 3:
	              response = _context.sent;
	              overview = _lodash2.default.get(response, 'data.data.attributes.overview', {});
	              documents = _lodash2.default.get(response, 'data.included', []);
	
	              _this.setState({
	                overview: overview,
	                documents: documents
	              });
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.onTargetClick = function () {
	      _this.fileRef.click();
	    };
	
	    _this.onDrop = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(files) {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _this.processCampaignDocuments(files);
	
	              case 2:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.onFileInputChanged = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(event) {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return _this.processCampaignDocuments(_lodash2.default.get(event, 'target.files', []));
	
	              case 2:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.deleteFile = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(documentId) {
	        var _this$props2, restClient, campaignId, documents, updatedDocuments, payload;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this$props2 = _this.props, restClient = _this$props2.restClient, campaignId = _this$props2.campaignId;
	                documents = _this.state.documents;
	                updatedDocuments = _lodash2.default.reject(documents, ['id', documentId]);
	                payload = _lodash2.default.map(updatedDocuments, function (document) {
	                  return _lodash2.default.pick(document, ['id', 'type']);
	                });
	                _context4.next = 6;
	                return restClient.patch('campaigns/' + campaignId + '/relationships/documents', {
	                  data: payload
	                });
	
	              case 6:
	                _context4.next = 8;
	                return restClient.delete('documents/' + documentId);
	
	              case 8:
	                _this.setState({
	                  documents: updatedDocuments
	                });
	
	              case 9:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.processCampaignDocuments = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        var _this$props3, campaignId, restClient, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, fileToBeUploaded, uploadedFilePath, attributes, createdDocument, existingDocuments;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                if (!_lodash2.default.isEmpty(files)) {
	                  _context5.next = 2;
	                  break;
	                }
	
	                return _context5.abrupt('return');
	
	              case 2:
	                _this$props3 = _this.props, campaignId = _this$props3.campaignId, restClient = _this$props3.restClient;
	
	                _this.setState({
	                  isUploading: true
	                });
	                // eslint-disable-next-line no-restricted-syntax
	                _iteratorNormalCompletion = true;
	                _didIteratorError = false;
	                _iteratorError = undefined;
	                _context5.prev = 7;
	                _iterator = files[Symbol.iterator]();
	
	              case 9:
	                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                  _context5.next = 24;
	                  break;
	                }
	
	                fileToBeUploaded = _step.value;
	                _context5.next = 13;
	                return (0, _s3Service.uploadToS3)([fileToBeUploaded]);
	
	              case 13:
	                uploadedFilePath = _context5.sent;
	                attributes = {
	                  campaign: {
	                    id: campaignId,
	                    type: 'campaigns'
	                  },
	                  name: _lodash2.default.get(fileToBeUploaded, 'name'),
	                  fileType: _lodash2.default.get(fileToBeUploaded, 'type'),
	                  filePath: _lodash2.default.last(uploadedFilePath)
	                };
	                // eslint-disable-next-line no-await-in-loop
	
	                _context5.next = 17;
	                return restClient.post('documents', {
	                  data: { attributes: attributes }
	                });
	
	              case 17:
	                createdDocument = _context5.sent;
	                existingDocuments = _lodash2.default.clone(_this.state.documents);
	
	                existingDocuments.push(_lodash2.default.get(createdDocument, 'data.data'));
	                _this.setState({
	                  documents: existingDocuments
	                }, _this.onSaveButtonClick);
	
	              case 21:
	                _iteratorNormalCompletion = true;
	                _context5.next = 9;
	                break;
	
	              case 24:
	                _context5.next = 30;
	                break;
	
	              case 26:
	                _context5.prev = 26;
	                _context5.t0 = _context5['catch'](7);
	                _didIteratorError = true;
	                _iteratorError = _context5.t0;
	
	              case 30:
	                _context5.prev = 30;
	                _context5.prev = 31;
	
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	
	              case 33:
	                _context5.prev = 33;
	
	                if (!_didIteratorError) {
	                  _context5.next = 36;
	                  break;
	                }
	
	                throw _iteratorError;
	
	              case 36:
	                return _context5.finish(33);
	
	              case 37:
	                return _context5.finish(30);
	
	              case 38:
	                _this.setState({
	                  isUploading: false
	                });
	
	              case 39:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this2, [[7, 26, 30, 38], [31,, 33, 37]]);
	      }));
	
	      return function () {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.onQuillValueChanged = function (value) {
	      var overview = _lodash2.default.clone(_this.state.overview);
	      overview.text = value;
	      _this.setState({
	        overview: overview
	      });
	    };
	
	    _this.onSaveButtonClick = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var _this$props4, campaignId, restClient, _this$state, documents, overview, documentsPatch;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _this$props4 = _this.props, campaignId = _this$props4.campaignId, restClient = _this$props4.restClient;
	              _this$state = _this.state, documents = _this$state.documents, overview = _this$state.overview;
	              documentsPatch = _lodash2.default.map(documents, function (document) {
	                return _lodash2.default.pick(document, ['type', 'id']);
	              });
	              _context6.next = 5;
	              return restClient.patch('campaigns/' + campaignId, {
	                data: {
	                  attributes: {
	                    overview: overview,
	                    documents: documentsPatch
	                  }
	                }
	              });
	
	            case 5:
	              _this.setState({
	                savedOk: true
	              });
	
	            case 6:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	
	    _this.toggleCheckbox = function (event, _ref7) {
	      var checked = _ref7.checked;
	
	      var overview = _lodash2.default.clone(_this.state.overview);
	      overview.shouldRender = checked;
	      _this.setState({
	        overview: overview
	      });
	    };
	
	    _this.state = {
	      savedOk: false,
	      isUploading: false,
	      documents: [],
	      overview: {}
	    };
	    _this.fileRef = null;
	    return _this;
	  }
	
	  _createClass(CampaignOverviewSettings, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      //
	      var _state = this.state,
	          documents = _state.documents,
	          overview = _state.overview,
	          isUploading = _state.isUploading,
	          savedOk = _state.savedOk;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          'h3',
	          { style: titleStyle },
	          'Campaign Overview'
	        ),
	        _react2.default.createElement(_reactQuill2.default, {
	          placeholder: 'campaign overview...',
	          style: quillStyle,
	          value: _lodash2.default.get(overview, 'text', ''),
	          onChange: this.onQuillValueChanged
	        }),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        _react2.default.createElement(
	          'h3',
	          { style: titleStyle },
	          'Supporting Documents'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.List,
	          { verticalAlign: 'middle', relaxed: true, fluid: true },
	          _lodash2.default.map(documents, function (document) {
	            return _react2.default.createElement(
	              _semanticUiReact.List.Item,
	              null,
	              _react2.default.createElement(_semanticUiReact.List.Icon, { name: 'file pdf outline' }),
	              _react2.default.createElement(
	                _semanticUiReact.List.Content,
	                null,
	                _lodash2.default.get(document, 'attributes.name', '-'),
	                _react2.default.createElement(_semanticUiReact.Icon, {
	                  link: true,
	                  name: 'delete',
	                  color: 'red',
	                  onClick: function onClick() {
	                    return _this3.deleteFile(_lodash2.default.get(document, 'id'));
	                  }
	                })
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          _reactFileDrop.FileDrop,
	          {
	            onTargetClick: this.onTargetClick,
	            onDrop: this.onDrop,
	            targetAlwaysVisible: true
	          },
	          _react2.default.createElement(
	            'div',
	            { style: uploadFileBlock },
	            isUploading && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', loading: true }),
	              ' Uploading... Please wait'
	            ),
	            !isUploading && _react2.default.createElement(
	              'div',
	              null,
	              'drag files or click here'
	            )
	          )
	        ),
	        _react2.default.createElement('input', {
	          accept: 'application/pdf',
	          onChange: this.onFileInputChanged,
	          ref: function ref(input) {
	            _this3.fileRef = input;
	          },
	          type: 'file',
	          style: hiddenStyle
	        }),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	        savedOk && _react2.default.createElement(
	          _semanticUiReact.Message,
	          { success: true },
	          'Changes saved'
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	        _react2.default.createElement(_semanticUiReact.Checkbox, {
	          checked: _lodash2.default.get(overview, 'shouldRender', false),
	          onChange: this.toggleCheckbox,
	          label: 'display overview on client reports',
	          style: checkboxStyle
	        }),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	        _react2.default.createElement(
	          _semanticUiReact.Button,
	          { onClick: this.onSaveButtonClick, color: 'pink' },
	          'Save'
	        )
	      );
	    }
	  }]);
	
	  return CampaignOverviewSettings;
	}(_react2.default.Component);
	
	CampaignOverviewSettings.propTypes = {
	  restClient: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _hasRestClient2.default)(CampaignOverviewSettings);

/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var radioLabelStyle = {
	  'vertical-align': 'super'
	};
	
	var titleStyle = {
	  paddingBottom: 5,
	  display: 'block'
	};
	
	var CampaignScanningSettings = function (_React$Component) {
	  _inherits(CampaignScanningSettings, _React$Component);
	
	  function CampaignScanningSettings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CampaignScanningSettings);
	
	    var _this = _possibleConstructorReturn(this, (CampaignScanningSettings.__proto__ || Object.getPrototypeOf(CampaignScanningSettings)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, restClient, campaignId, response, campaign;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, restClient = _this$props.restClient, campaignId = _this$props.campaignId;
	              _context.next = 3;
	              return restClient.get('campaigns/' + campaignId);
	
	            case 3:
	              response = _context.sent;
	              campaign = _lodash2.default.get(response, 'data.data.attributes', {});
	
	              _this.setState({
	                campaign: campaign
	              });
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.toggleCheckbox = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(event, _ref3) {
	        var name = _ref3.name,
	            checked = _ref3.checked;
	
	        var _this$props2, restClient, campaignId, payload, campaignResponse, campaign;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this$props2 = _this.props, restClient = _this$props2.restClient, campaignId = _this$props2.campaignId;
	                payload = {
	                  data: {
	                    attributes: _defineProperty({}, name, checked)
	                  }
	                };
	                _context2.next = 4;
	                return restClient.patch('campaigns/' + campaignId, payload);
	
	              case 4:
	                campaignResponse = _context2.sent;
	                campaign = campaignResponse.data.data;
	
	                _this.setState({
	                  campaign: campaign.attributes
	                });
	
	              case 7:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CampaignScanningSettings, [{
	    key: 'render',
	    value: function render() {
	      //
	      var campaign = this.state.campaign;
	
	
	      var scanInstagram = campaign && campaign.scanInstagram;
	      var scanTiktok = campaign && campaign.scanTiktok;
	      var scanTelegram = campaign && campaign.scanTelegram;
	      var scanFacebook = campaign && campaign.scanFacebook;
	      var scanTwitter = campaign && campaign.scanTwitter;
	      var scanYoutube = campaign && campaign.scanYoutube;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          'h3',
	          { style: titleStyle },
	          'Campaign Scanning Options'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Choose which social platforms you want to scan.'
	        ),
	        campaign && _react2.default.createElement(
	          'div',
	          { style: { padding: 30 } },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'table',
	              { width: '100%' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Radio, {
	                    toggle: true,
	                    name: 'scanInstagram',
	                    checked: scanInstagram !== false,
	                    onChange: this.toggleCheckbox
	                  }),
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    { style: radioLabelStyle },
	                    '\xA0Instagram'
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Radio, {
	                    toggle: true,
	                    name: 'scanTiktok',
	                    checked: scanTiktok !== false,
	                    onChange: this.toggleCheckbox
	                  }),
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    { style: radioLabelStyle },
	                    '\xA0TikTok'
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Radio, {
	                    toggle: true, checked: scanFacebook,
	                    name: 'scanFacebook',
	                    onChange: this.toggleCheckbox
	                  }),
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    { style: radioLabelStyle },
	                    '\xA0Facebook'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  '\xA0'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Radio, {
	                    toggle: true, checked: scanYoutube,
	                    name: 'scanYoutube',
	                    onChange: this.toggleCheckbox
	                  }),
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    { style: radioLabelStyle },
	                    '\xA0YouTube'
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Radio, {
	                    toggle: true, checked: scanTwitter,
	                    name: 'scanTwitter',
	                    onChange: this.toggleCheckbox
	                  }),
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    { style: radioLabelStyle },
	                    '\xA0Twitter'
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Radio, {
	                    toggle: true, checked: scanTelegram !== false,
	                    name: 'scanTelegram',
	                    onChange: this.toggleCheckbox
	                  }),
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    { style: radioLabelStyle },
	                    '\xA0Telegram'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignScanningSettings;
	}(_react2.default.Component);
	
	CampaignScanningSettings.propTypes = {
	  restClient: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _hasRestClient2.default)(CampaignScanningSettings);

/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _newCampaignForm = __webpack_require__(889);
	
	var _newCampaignForm2 = _interopRequireDefault(_newCampaignForm);
	
	var _facebookAdsManager = __webpack_require__(872);
	
	var _facebookAdsManager2 = _interopRequireDefault(_facebookAdsManager);
	
	var _campaignGoogleLinkTracking = __webpack_require__(1905);
	
	var _campaignGoogleLinkTracking2 = _interopRequireDefault(_campaignGoogleLinkTracking);
	
	var _campaignOverviewSettings = __webpack_require__(2085);
	
	var _campaignOverviewSettings2 = _interopRequireDefault(_campaignOverviewSettings);
	
	var _campaignScanningSettings = __webpack_require__(2086);
	
	var _campaignScanningSettings2 = _interopRequireDefault(_campaignScanningSettings);
	
	var _campaignEcommerceSettings = __webpack_require__(1904);
	
	var _campaignEcommerceSettings2 = _interopRequireDefault(_campaignEcommerceSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CampaignSettings = function (_React$Component) {
	  _inherits(CampaignSettings, _React$Component);
	
	  function CampaignSettings(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CampaignSettings);
	
	    var _this = _possibleConstructorReturn(this, (CampaignSettings.__proto__ || Object.getPrototypeOf(CampaignSettings)).call(this, props));
	
	    _this.updateCampaign = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref2) {
	        var name = _ref2.name,
	            budget = _ref2.budget,
	            currency = _ref2.currency,
	            country = _ref2.country,
	            hashtags = _ref2.hashtags,
	            liveDate = _ref2.liveDate,
	            endDate = _ref2.endDate,
	            impressionsCPM = _ref2.impressionsCPM,
	            engagementsCPM = _ref2.engagementsCPM,
	            ieRatio = _ref2.ieRatio,
	            campaignCode = _ref2.campaignCode,
	            sendChaseEmails = _ref2.sendChaseEmails,
	            brand = _ref2.brand,
	            scanUnauthorisedStories = _ref2.scanUnauthorisedStories,
	            useEstimatedReachAndImpressions = _ref2.useEstimatedReachAndImpressions;
	
	        var _this$props, jsonAPIClient, campaignId, organisation, restClient, resource, currencyValue, safeBrand, deleteCacheURL;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props = _this.props, jsonAPIClient = _this$props.jsonAPIClient, campaignId = _this$props.params.id, organisation = _this$props.organisation, restClient = _this$props.restClient;
	                _context.next = 3;
	                return jsonAPIClient.get('campaigns', campaignId);
	
	              case 3:
	                resource = _context.sent;
	                currencyValue = _lodash2.default.isNil(currency) ? _lodash2.default.get(organisation, 'defaultCurrency', 'GBP') : currency;
	
	
	                if (resource.get('campaignType') === 'AUTOMATED') {
	                  resource.set('budget', budget);
	                  resource.set('hashtags', hashtags);
	                  resource.set('currency', currencyValue);
	                  resource.set('impressionsCPM', impressionsCPM || null);
	                  resource.set('engagementsCPM', engagementsCPM || null);
	                  resource.set('ieRatio', ieRatio || null);
	                  resource.set('sendChaseEmails', sendChaseEmails || false);
	                  resource.set('country', country || null);
	                  resource.set('scanUnauthorisedStories', scanUnauthorisedStories || false);
	                  resource.set('useEstimatedReachAndImpressions', useEstimatedReachAndImpressions || false);
	
	                  if (liveDate) {
	                    resource.set('liveDate', liveDate);
	                  }
	                  if (endDate) {
	                    resource.set('endDate', endDate);
	                  }
	                  if (campaignCode) {
	                    resource.set('campaignCode', campaignCode);
	                  }
	                  safeBrand = _lodash2.default.trim(brand);
	
	                  if (brand) {
	                    resource.set('brand', safeBrand);
	                  }
	                }
	
	                resource.set('name', name);
	                _context.next = 9;
	                return resource.sync();
	
	              case 9:
	                deleteCacheURL = '/organisations/' + _lodash2.default.get(organisation, 'id') + '/cache';
	                _context.next = 12;
	                return restClient({
	                  method: 'DELETE',
	                  url: deleteCacheURL,
	                  baseURL: ("https://dl6gzrmms2.execute-api.eu-west-1.amazonaws.com/production")
	                });
	
	              case 12:
	
	                _this.setState({
	                  updatedOK: true
	                });
	
	                _this.props.onLoadingCampaign(campaignId, true);
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      updatedOK: false
	    };
	    return _this;
	  }
	
	  _createClass(CampaignSettings, [{
	    key: 'render',
	    value: function render() {
	      var updatedOK = this.state.updatedOK;
	      var _props = this.props,
	          campaignJSImmutable = _props.campaign,
	          organisation = _props.organisation;
	
	      var campaign = campaignJSImmutable ? campaignJSImmutable.toJSON() : null;
	      var campaignType = _lodash2.default.get(campaign, 'campaignType', null);
	      var campaignId = _lodash2.default.get(campaign, 'id', null);
	      var campaignOverview = _lodash2.default.get(campaign, 'overview', {});
	      var organisationName = _lodash2.default.get(organisation, 'name', null);
	      var baseTrackingUrl = _lodash2.default.get(campaign, 'baseTrackingUrl', '');
	      var account = _lodash2.default.get(organisation, 'adsManagerAccount', null);
	
	      var overviewSettingsProps = {
	        campaignOverview: campaignOverview
	      };
	
	      return _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { divided: true },
	        updatedOK && _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { widht: '16' },
	            _react2.default.createElement(
	              _semanticUiReact.Message,
	              { success: true, icon: true },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle' }),
	              'Campaign has been updated.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: '6' },
	            campaign && _react2.default.createElement(_newCampaignForm2.default, Object.assign({
	              inEditMode: true,
	              formType: _newCampaignForm.FORM_TYPES.ADVANCED,
	              campaignType: campaignType,
	              onFormSubmit: this.updateCampaign
	            }, campaign))
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: '10' },
	            _react2.default.createElement(_campaignScanningSettings2.default, Object.assign({ campaignId: campaignId }, overviewSettingsProps)),
	            _react2.default.createElement(_campaignOverviewSettings2.default, Object.assign({ campaignId: campaignId }, overviewSettingsProps)),
	            _react2.default.createElement(_facebookAdsManager2.default, { campaignId: campaignId, name: organisationName, account: account }),
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(_campaignGoogleLinkTracking2.default, { baseTrackingUrl: baseTrackingUrl, campaignId: campaignId }),
	            _react2.default.createElement(_campaignEcommerceSettings2.default, { campaignId: campaignId })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignSettings;
	}(_react2.default.Component);
	
	CampaignSettings.propTypes = {
	  campaign: _propTypes2.default.object.isRequired,
	  organisation: _propTypes2.default.object.isRequired,
	  onLoadingCampaign: _propTypes2.default.func.isRequired
	};
	
	exports.default = CampaignSettings;

/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(71);
	
	var _authService = __webpack_require__(21);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	var _formInputText = __webpack_require__(104);
	
	var _formInputText2 = _interopRequireDefault(_formInputText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * CampaignUpdate container
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// TODO Needs completing once it has been designed out
	var CampaignNew = function (_React$Component) {
	  _inherits(CampaignNew, _React$Component);
	
	  function CampaignNew() {
	    _classCallCheck(this, CampaignNew);
	
	    return _possibleConstructorReturn(this, (CampaignNew.__proto__ || Object.getPrototypeOf(CampaignNew)).apply(this, arguments));
	  }
	
	  _createClass(CampaignNew, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var context = this;
	
	      var routeParam = this.props.routeParams ? this.props.routeParams.id : '';
	
	      var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), ("4000"), { Authorization: 'Bearer ' + _authService.authService.getToken() });
	      context.setState({ axiosService: axiosService });
	
	      axiosService.get('campaigns/' + routeParam, {}).then(function (response) {
	        // TODO Update this when campaign isn't an array
	        context.setState({
	          campaign: response.data
	        });
	        context.handleInitialise(response.data);
	      }).catch(function () {
	        // TODO Handle errors
	        context.setState({
	          campaign: null
	        });
	      });
	    }
	  }, {
	    key: 'handleInitialise',
	    value: function handleInitialise(campaign) {
	      var name = campaign.name,
	          description = campaign.description,
	          client = campaign.client,
	          budget = campaign.budget;
	
	
	      var initData = {
	        campaignName: name,
	        campaignDescription: description,
	        campaignClient: client,
	        campaignBudget: budget
	      };
	
	      this.props.initialize(initData);
	    }
	  }, {
	    key: 'updateCampaign',
	    value: function updateCampaign(formData) {
	      var _this2 = this;
	
	      // TODO The members, companyID and owners need to be inserted
	      var companyId = '57ebe2dbb0be59ed84c63222';
	      var owners = ['57ebe2dbb0be59ed84c63333'];
	      var members = ['57ebe2dbb0be59ed84c63444'];
	
	      var insertParams = {
	        name: formData.campaignName,
	        description: formData.campaignDescription,
	        client: formData.campaignClient,
	        budget: formData.campaignBudget,
	        companyId: companyId,
	        owners: owners,
	        members: members,
	        createdDate: this.state.campaign.createdDate,
	        liveDate: this.state.campaign.liveDate
	      };
	
	      this.state.axiosService.put('v1/campaigns/' + this.state.campaign.id, insertParams).then(function () {
	        _this2.context.router.push('/campaign/' + _this2.state.campaign.id);
	      }).catch(function () {
	        // TODO Handle errors
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var handleSubmit = this.props.handleSubmit;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'body_container' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'margin20' },
	          ' Update Campaign '
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'campaign_members_form_container' },
	          _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit(this.updateCampaign.bind(this)) },
	            _react2.default.createElement(_immutable.Field, {
	              name: 'campaignName',
	              type: 'text',
	              component: _formInputText2.default,
	              label: 'Campaign name'
	            }),
	            _react2.default.createElement(_immutable.Field, {
	              name: 'campaignDescription',
	              type: 'text',
	              component: _formInputText2.default,
	              label: 'Description'
	            }),
	            _react2.default.createElement(_immutable.Field, {
	              name: 'campaignClient',
	              type: 'text',
	              component: _formInputText2.default,
	              label: 'Client'
	            }),
	            _react2.default.createElement(_immutable.Field, {
	              name: 'campaignBudget',
	              type: 'number',
	              component: _formInputText2.default,
	              label: 'Budget'
	            }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  bsStyle: 'primary',
	                  block: true,
	                  bsClass: 'btn btn-block large_primary_button blue_button margintop20',
	                  type: 'submit'
	                },
	                'update campaign'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignNew;
	}(_react2.default.Component);
	
	CampaignNew.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	CampaignNew.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	function validate(values) {
	  var errors = {};
	
	  if (!values.campaignName) {
	    errors.campaignName = 'Enter a campaign name.';
	  }
	  if (!values.campaignDescription) {
	    errors.campaignDescription = 'Enter a campaign description.';
	  }
	  if (!values.campaignClient) {
	    errors.campaignClient = 'Enter a clientID.';
	  }
	  if (!values.campaignBudget) {
	    errors.campaignBudget = 'Enter a campaign budget.';
	  }
	
	  // TODO Do the rest of the validation
	  return errors;
	}
	
	exports.default = (0, _immutable.reduxForm)({
	  form: 'UpdateCampaignForm',
	  validate: validate
	})(CampaignNew);

/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _ramda = __webpack_require__(252);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(37);
	
	var _recompose = __webpack_require__(15);
	
	var _hashtagScannerModal = __webpack_require__(876);
	
	var _hashtagScannerModal2 = _interopRequireDefault(_hashtagScannerModal);
	
	var _addCampaignModal = __webpack_require__(535);
	
	var _addCampaignModal2 = _interopRequireDefault(_addCampaignModal);
	
	var _chaseEmailSendModal = __webpack_require__(1913);
	
	var _chaseEmailSendModal2 = _interopRequireDefault(_chaseEmailSendModal);
	
	var _actions = __webpack_require__(557);
	
	var _actions2 = __webpack_require__(904);
	
	var _actions3 = __webpack_require__(105);
	
	var _authService = __webpack_require__(21);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasOrganisation = __webpack_require__(106);
	
	var _hasOrganisation2 = _interopRequireDefault(_hasOrganisation);
	
	var _privateDataWhitelist = __webpack_require__(572);
	
	var _hashtagsUtils = __webpack_require__(232);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _roleService = __webpack_require__(143);
	
	var _campaigns = __webpack_require__(129);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _modal = __webpack_require__(103);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var blackColorLink = { color: 'black' };
	
	var DEBOUNCE_TIMEOUT = 800;
	
	var currentTheme = _themeSelector2.default.theme();
	
	var RESTRICTED_CORQ_DOMAINS = ['data.corq.studio', 'corq.dyzio.co'];
	
	var INITIAL_HASHTAG_SCANNER_STATE = {
	  hashtagScannerModalOpen: false,
	  isScanning: false,
	  validHashtags: true,
	  hashtagsErrors: [],
	  currentScannedPlatform: null,
	  scannerResultsCount: null,
	  hashtags: []
	};
	
	var Campaign = function (_React$Component) {
	  _inherits(Campaign, _React$Component);
	
	  function Campaign(props, context) {
	    var _this3 = this;
	
	    _classCallCheck(this, Campaign);
	
	    var _this = _possibleConstructorReturn(this, (Campaign.__proto__ || Object.getPrototypeOf(Campaign)).call(this, props, context));
	
	    _this.setModal = function (modalName) {
	      return _this.props.onSetModal(modalName);
	    };
	
	    _this.feedback = function (action) {
	      return _this.context.router.push(action);
	    };
	
	    _this.openReport = function (type) {
	      var campaignId = _this.state.campaignId;
	
	      window.open(currentTheme.shareSite + '/report/' + campaignId + '/' + type);
	    };
	
	    _this.handleHashtagInputsChange = function (e, _ref) {
	      var name = _ref.name,
	          value = _ref.value;
	      var stateHashtags = _this.state.hashtags;
	
	      var hashtags = _lodash2.default.clone(stateHashtags);
	      var existing = _lodash2.default.find(hashtags, ['name', name]);
	      if (existing) {
	        existing.value = value;
	      } else {
	        hashtags.push({
	          name: name,
	          value: value
	        });
	      }
	
	      _this.setState({
	        hashtags: hashtags
	      });
	    };
	
	    _this.handleHashtagScannerState = function () {
	      var hashtagScannerModalOpen = _this.state.hashtagScannerModalOpen;
	
	      _this.setState({
	        hashtagScannerModalOpen: !hashtagScannerModalOpen
	      });
	    };
	
	    _this.scan = _regenerator2.default.mark(function scan() {
	      var _this2 = this;
	
	      var campaign, hashtags, campaignId, query;
	      return _regenerator2.default.wrap(function scan$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              campaign = this.props.campaign;
	              hashtags = this.state.hashtags;
	              campaignId = campaign.get('id');
	
	              query = function query(platform) {
	                return _this2.hashtagScannerAPI.post('/scan', {
	                  data: {
	                    campaignId: campaignId,
	                    platform: _lodash2.default.lowerCase(platform),
	                    hashtags: _lodash2.default.map(hashtags, function (hashtag) {
	                      return _lodash2.default.trim(hashtag.value);
	                    })
	                  }
	                });
	              };
	              // yield query(YOUTUBE);
	
	
	              _context.next = 6;
	              return query(_staticConfiguration.INSTAGRAM);
	
	            case 6:
	              _context.next = 8;
	              return query(_staticConfiguration.TWITTER);
	
	            case 8:
	              _context.next = 10;
	              return query(_staticConfiguration.FACEBOOK);
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, scan, this);
	    });
	
	    _this.getHashtagsErrors = function () {
	      var REGEX = /^(#|@?)\S{3,}$/g; // allow wide chars in hashtags
	      var hashtags = _this.state.hashtags;
	
	      var values = _lodash2.default.map(hashtags, function (hashtag) {
	        return _lodash2.default.trim(hashtag.value);
	      });
	      var matches = _lodash2.default.map(values, function (value) {
	        return value.match(REGEX);
	      });
	      var errors = _lodash2.default.map(matches, function (value, index) {
	        return { isError: _lodash2.default.isNull(value), position: index };
	      });
	      return errors;
	    };
	
	    _this.scanHashtags = function () {
	      var campaign = _this.props.campaign;
	
	      var TIMEOUT = 2200;
	      var generator = _this.scan();
	      var channels = [_staticConfiguration.INSTAGRAM, _staticConfiguration.TWITTER, _staticConfiguration.FACEBOOK];
	      _lodash2.default.forEach(channels, function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(channel, index) {
	          var isFacebook;
	          return _regenerator2.default.wrap(function _callee2$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  isFacebook = channel === _staticConfiguration.FACEBOOK;
	
	                  setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                    var _ref4, data, state;
	
	                    return _regenerator2.default.wrap(function _callee$(_context2) {
	                      while (1) {
	                        switch (_context2.prev = _context2.next) {
	                          case 0:
	                            _context2.next = 2;
	                            return generator.next().value;
	
	                          case 2:
	                            _ref4 = _context2.sent;
	                            data = _ref4.data.data;
	                            state = {
	                              currentScannedPlatform: channel,
	                              scannerResultsCount: _lodash2.default.sumBy(data, function (item) {
	                                return item.trackedAssets.length || 0;
	                              })
	                            };
	
	                            _this.setState(_extends({}, state), function () {
	                              if (isFacebook) {
	                                _lodash2.default.delay(function () {
	                                  return _this.setState(_extends({}, INITIAL_HASHTAG_SCANNER_STATE), function () {
	                                    return _this.props.onLoadingCampaign(campaign.get('id'));
	                                  });
	                                }, TIMEOUT);
	                              }
	                            });
	
	                          case 6:
	                          case 'end':
	                            return _context2.stop();
	                        }
	                      }
	                    }, _callee, _this3);
	                  })), TIMEOUT * _ramda2.default.inc(index));
	
	                case 2:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee2, _this3);
	        }));
	
	        return function (_x, _x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }());
	    };
	
	    _this.toggleEditCampaignModalState = function () {
	      _this.setState(function (prevState) {
	        return {
	          editCampaignModalOpen: !prevState.editCampaignModalOpen
	        };
	      });
	    };
	
	    _this.handleScanButtonClick = function () {
	      var hashtagsErrors = _this.getHashtagsErrors();
	      var hasError = _lodash2.default.find(hashtagsErrors, ['isError', true]);
	      if (!hasError) {
	        _this.setState({
	          isScanning: true,
	          hashtagsErrors: []
	        }, _this.scanHashtags);
	      } else {
	        _this.setState({
	          hashtagsErrors: hashtagsErrors
	        });
	      }
	    };
	
	    _this.onHashtagScannerModalClose = function () {
	      _this.setState(_extends({}, INITIAL_HASHTAG_SCANNER_STATE));
	    };
	
	    _this.onFilterDiscussionListByTermChanged = _lodash2.default.debounce(function (event, data) {
	      var value = data.value;
	
	      _this.setState({
	        filterDiscussionListByTerm: value
	      });
	    }, DEBOUNCE_TIMEOUT);
	
	    _this.onEditCampaignTextField = function (event, _ref5) {
	      var name = _ref5.name,
	          value = _ref5.value;
	      var campaignUpdatedFields = _this.state.campaignUpdatedFields;
	
	      _lodash2.default.set(campaignUpdatedFields, name, value);
	      _this.setState({
	        campaignUpdatedFields: campaignUpdatedFields
	      });
	    };
	
	    _this.onLiveDateChange = function (date) {
	      var value = date.format();
	      _this.onEditCampaignTextField(null, { name: 'liveDate', value: value });
	    };
	
	    _this.onEndDateChange = function (date) {
	      var value = date.format();
	      _this.onEditCampaignTextField(null, { name: 'endDate', value: value });
	    };
	
	    _this.onCampaignCurrencyChanged = function (event, _ref6) {
	      var value = _ref6.value;
	
	      _this.onEditCampaignTextField(null, { name: 'currency', value: value });
	    };
	
	    _this.onSubmitEditCampaignForm = function () {
	      var campaignUpdatedFields = _this.state.campaignUpdatedFields;
	      var name = campaignUpdatedFields.name,
	          budget = campaignUpdatedFields.budget,
	          id = campaignUpdatedFields.id,
	          currency = campaignUpdatedFields.currency,
	          endDate = campaignUpdatedFields.endDate,
	          liveDate = campaignUpdatedFields.liveDate,
	          hashtags = campaignUpdatedFields.hashtags;
	      var restClient = _this.props.restClient;
	
	      var attributes = {
	        name: name,
	        budget: budget,
	        currency: currency,
	        liveDate: liveDate,
	        endDate: endDate,
	        hashtags: hashtags
	      };
	      restClient.patch('campaigns/' + id, {
	        data: {
	          attributes: _lodash2.default.pickBy(attributes)
	        }
	      }).then(function () {
	        _this.setState({
	          editCampaignModalOpen: false
	        }, function () {
	          return _this.props.onLoadingCampaign(id);
	        });
	      });
	    };
	
	    _this.onSettingsDropdownItemClick = function (value) {
	      if (value === 'campaign-settings') {
	        var campaign = _this.props.campaign;
	
	        var campaignJSON = campaign.toJSON();
	        var name = campaignJSON.name,
	            budget = campaignJSON.budget,
	            currency = campaignJSON.currency,
	            liveDate = campaignJSON.liveDate,
	            endDate = campaignJSON.endDate,
	            hashtags = campaignJSON.hashtags;
	
	        _this.setState({
	          editCampaignModalOpen: true,
	          campaignUpdatedFields: {
	            name: name, budget: budget, currency: currency, liveDate: liveDate, endDate: endDate, hashtags: hashtags, id: campaign.get('id')
	          }
	        });
	      } else {
	        _this.context.router.push(value);
	      }
	    };
	
	    _this.toggleChaseEmailModal = function () {
	      return _this.setState(function (prevState) {
	        return {
	          chaseModalOpen: !prevState.chaseModalOpen
	        };
	      });
	    };
	
	    _this.handleACRScan = function () {
	      var campaignId = _this.state.campaignId;
	
	      _this.setState({
	        automationScanLoading: true
	      });
	      _this.automationrAPI.post('/run-acr-scan/' + campaignId).then(function () {
	        return _this.setState({
	          automationScanLoading: false
	        });
	      }).then(function () {
	        return _this.setState({ campaignId: campaignId, activeTab: _staticConfiguration.ANALYTICS });
	      }).catch(function (e) {
	        return (0, _errorHandlingService.reportError)('ACR_ERROR', e);
	      });
	    };
	
	    _this.handleAutomatedCampaignScan = function () {
	      var campaignId = _this.state.campaignId;
	
	      _this.setState({
	        automationScanLoading: true
	      });
	      _this.automationrAPI.post('/run-automated-scan/' + campaignId).then(function () {
	        return _this.setState({
	          automationScanLoading: false
	        });
	      }).then(function () {
	        return _this.setState({ campaignId: campaignId, activeTab: _staticConfiguration.ANALYTICS });
	      }).catch(function (e) {
	        return (0, _errorHandlingService.reportError)('AUTO_CAMPAIGN_ERROR', e);
	      });
	    };
	
	    _this.handleToggleStoriesTracking = function () {
	      var _this$props = _this.props,
	          campaign = _this$props.campaign,
	          restClient = _this$props.restClient;
	
	      var campaignId = campaign.get('id');
	      var currentValue = campaign.get('captureAllStories') || false;
	
	      restClient.patch('campaigns/' + campaignId, {
	        data: {
	          attributes: { captureAllStories: !currentValue }
	        }
	      }).then(function () {
	        _this.props.onLoadingCampaign(campaignId);
	      }).catch(function (e) {
	        return (0, _errorHandlingService.reportError)('TOGGLE_STORIES_TRACKING_ERROR', e);
	      });
	    };
	
	    _this.state = _extends({
	      campaignName: null,
	      hashtags: null,
	      campaignId: null,
	      budgetAllocated: 'Waiting...',
	      filterDiscussionListByTerm: null,
	      editCampaignModalOpen: false,
	      campaignUpdatedFields: {},
	      chaseModalOpen: false
	    }, INITIAL_HASHTAG_SCANNER_STATE);
	
	    _this.updateCampaign = _this.updateCampaign.bind(_this);
	
	    _this.hashtagScannerAPI = _axios2.default.create({
	      baseURL: 'https://b7o8doqzfb.execute-api.eu-west-1.amazonaws.com/production/hashtags',
	      timeout: 20000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    _this.automationrAPI = _axios2.default.create({
	      baseURL: ("https://bahhjuaz6d.execute-api.eu-west-1.amazonaws.com/production"),
	      timeout: 20000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Campaign, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      var _props = this.props,
	          organisationId = _props.userInfo.organisationId,
	          restClient = _props.restClient;
	
	
	      var myUserRole = this.props.myUserRole;
	      if (myUserRole === _staticConfiguration.CLIENT || myUserRole === _staticConfiguration.PARTNER_AGENCY) {
	        this.context.router.push('/dashboard');
	      }
	      var campaignId = this.props.params ? this.props.params.id : '';
	      var fastLoad = this.props.location.query.fast ? this.props.location.query.fast === 'true' : false;
	
	      var reviewMode = this.props.location.query.rm ? this.props.location.query.rm === 'true' : false;
	
	      console.log(this.props);
	      this.setState({ campaignId: campaignId, isLoadingTotals: true });
	
	      restClient.get('/campaigns/' + campaignId).then(function (response) {
	        var _response$data$data$a = response.data.data.attributes,
	            campaignName = _response$data$data$a.name,
	            hashtags = _response$data$data$a.hashtags,
	            campaignType = _response$data$data$a.campaignType;
	
	        _this4.setState({
	          campaignName: campaignName,
	          hashtags: hashtags,
	          campaignType: campaignType
	        });
	      });
	
	      this.props.onLoadingCampaign(campaignId, null, fastLoad);
	    }
	  }, {
	    key: 'updateCampaign',
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(budget) {
	        var id, oldBudget;
	        return _regenerator2.default.wrap(function _callee3$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                id = this.props.campaign.get('id');
	                oldBudget = this.props.campaign.get('budget');
	
	
	                try {
	                  (0, _campaigns.updateCampaign)(id, budget);
	                } catch (error) {
	                  (0, _errorHandlingService.reportError)('UPDATE_CAMPAIGN_ERROR', error.message);
	                  this.props.onSetStatusBar(error.message, 'red');
	                }
	
	              case 3:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function updateCampaign(_x3) {
	        return _ref7.apply(this, arguments);
	      }
	
	      return updateCampaign;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props2 = this.props,
	          myUserRole = _props2.myUserRole,
	          campaign = _props2.campaign,
	          campaignLoading = _props2.campaignLoading,
	          campaignLoadError = _props2.campaignLoadError,
	          members = _props2.members,
	          showModal = _props2.showModal,
	          userInfo = _props2.userInfo;
	      var organisationId = userInfo.organisationId,
	          isUserSuperAdmin = userInfo.isUserSuperAdmin;
	      var host = window.location.host;
	
	
	      var isCorq = _lodash2.default.includes(RESTRICTED_CORQ_DOMAINS, host);
	      var isDyzioTeam = (0, _privateDataWhitelist.isTeam)(organisationId, _privateDataWhitelist.TD);
	      var isKaspersky = (0, _privateDataWhitelist.isTeam)(organisationId, _privateDataWhitelist.KASPERSKY);
	      var shouldRenderAuditTrail = isDyzioTeam || isKaspersky && isUserSuperAdmin;
	
	      var _state = this.state,
	          campaignId = _state.campaignId,
	          hashtagScannerModalOpen = _state.hashtagScannerModalOpen,
	          isScanning = _state.isScanning,
	          currentScannedPlatform = _state.currentScannedPlatform,
	          scannerResultsCount = _state.scannerResultsCount,
	          hashtagsErrors = _state.hashtagsErrors,
	          campaignUpdatedFields = _state.campaignUpdatedFields,
	          editCampaignModalOpen = _state.editCampaignModalOpen,
	          campaignType = _state.campaignType,
	          chaseModalOpen = _state.chaseModalOpen;
	
	
	      if (!campaignId) return null;
	
	      var currency = campaignUpdatedFields && campaignUpdatedFields.currency;
	      var liveDate = campaignUpdatedFields && (0, _moment2.default)(campaignUpdatedFields.liveDate);
	      var endDate = campaignUpdatedFields && (0, _moment2.default)(campaignUpdatedFields.endDate);
	      var campaignJSON = campaign.toJSON();
	
	      var name = _lodash2.default.get(campaignJSON, 'name', this.state.campaignName);
	      var brand = _lodash2.default.get(campaignJSON, 'brand', null);
	      var hashtags = _lodash2.default.get(campaignJSON, 'hashtags', this.state.hashtags);
	
	      var campaignFormProps = {
	        name: campaignUpdatedFields.name,
	        budget: campaignUpdatedFields.budget,
	        currency: currency,
	        liveDate: liveDate,
	        endDate: endDate,
	        campaignType: campaignType,
	        hashtags: campaignUpdatedFields.hashtags,
	        onInputChange: this.onEditCampaignTextField,
	        onLiveDateChange: this.onLiveDateChange,
	        onEndDateChange: this.onEndDateChange,
	        onCurrencyChange: this.onCampaignCurrencyChanged
	      };
	
	      var creatorMembers = [];
	
	      var isManual = campaignType === 'WORKFLOW';
	      var isACR = campaignType === 'ACR';
	      var isAutomatedCampaign = campaignType === 'AUTOMATED';
	      var isAuto = isACR || isAutomatedCampaign;
	      var hasInfluencers = creatorMembers.length > 0 || campaign && (campaignJSON.pendingInvitations || []).length > 0;
	      var isUserTeamMember = isUserSuperAdmin || (0, _roleService.checkUserIsTeamMember)(myUserRole);
	      var isUserAnAdmin = isUserSuperAdmin || (0, _roleService.checkUserHasAdminRights)(myUserRole);
	
	      var hashtagsArray = (0, _hashtagsUtils.transformHashtagstIntoArray)(hashtags);
	
	      var isTrackingAllStories = campaign.get('captureAllStories') || false;
	      var isDyzioCoUser = _lodash2.default.endsWith(_lodash2.default.get(userInfo, 'email', ''), '@dyzio.co');
	      var menuOptions = [];
	
	      if (!isCorq) {
	        menuOptions.push({
	          key: 'invite',
	          text: 'Invite people to this campaign',
	          onClick: function onClick() {
	            return _this5.onSettingsDropdownItemClick('/campaign/' + campaignId + '/invite');
	          }
	        });
	
	        if (isUserAnAdmin) {
	          menuOptions.push({
	            key: 'manage',
	            text: 'Manage people on this campaign',
	            onClick: function onClick() {
	              return _this5.onSettingsDropdownItemClick('/campaign/' + campaignId + '/manage');
	            }
	          });
	        }
	      }
	
	      menuOptions.push({
	        key: 'chase email',
	        text: 'Send chase email',
	        onClick: this.toggleChaseEmailModal
	      });
	
	      menuOptions.push({
	        key: 'scan-now',
	        text: 'Scan for posts now...',
	        value: 'scan-now',
	        onClick: function onClick() {
	          return _this5.handleAutomatedCampaignScan();
	        }
	      });
	
	      if (isDyzioCoUser) {
	        menuOptions.push({
	          key: 'switch-stories-tracking',
	          text: (isTrackingAllStories ? 'Disable' : 'Enable') + ' tracking for all stories',
	          value: 'switch-stories-tracking',
	          onClick: this.handleToggleStoriesTracking
	        });
	      }
	
	      var isCollaborationRoute = _lodash2.default.has(this.props.params, 'collabId');
	
	      var SHOW_SETUP_TAB = false;
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: isCollaborationRoute ? 'white-header collab' : 'white-header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row large' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-spacer' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                name,
	                ' ',
	                isAutomatedCampaign && _lodash2.default.map(hashtagsArray, function () {
	                  var ht = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	                  var isHandle = ht.startsWith('@');
	                  return isHandle ? _react2.default.createElement(
	                    'a',
	                    {
	                      href: 'https://www.instagram.com/' + ht.substring(1),
	                      target: '_blank',
	                      rel: 'noopener noreferrer'
	                    },
	                    _react2.default.createElement(
	                      _semanticUiReact.Label,
	                      { basic: true, color: 'blue', style: { textDecoration: 'underline' } },
	                      ht
	                    )
	                  ) : _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { basic: true, color: 'grey' },
	                    ht
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'h2',
	                null,
	                brand && _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { basic: true, color: 'blue', size: 'large' },
	                  brand
	                ),
	                '\xA0'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-item' },
	              isUserTeamMember && _react2.default.createElement(
	                _semanticUiReact.Menu,
	                null,
	                _react2.default.createElement(_semanticUiReact.Dropdown, {
	                  text: 'Quick Links \xA0',
	                  icon: 'settings',
	                  options: menuOptions,
	                  pointing: 'right top',
	                  item: true
	                })
	              )
	            )
	          ),
	          isUserTeamMember && !isCollaborationRoute ? _react2.default.createElement(
	            'div',
	            { className: 'row no-bottom-padding' },
	            _react2.default.createElement(
	              'div',
	              { className: 'large-tabs' },
	              !isACR && SHOW_SETUP_TAB && _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  as: 'div', to: '/campaign/' + campaignId + '/setup',
	                  className: 'flex-item',
	                  activeClassName: 'active',
	                  style: blackColorLink
	                },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(
	                    'nobr',
	                    null,
	                    'Setup'
	                  )
	                )
	              ),
	              isACR && _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  as: 'div', to: '/campaign/' + campaignId + '/acr-setup',
	                  className: 'flex-item',
	                  activeClassName: 'active',
	                  style: blackColorLink
	                },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(
	                      'nobr',
	                      null,
	                      'Setup'
	                    )
	                  ),
	                  content: 'Set up your automated channel report'
	                })
	              ),
	              !isACR && _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  as: 'div', to: '/campaign/' + campaignId + '/collaborations',
	                  className: 'flex-item',
	                  activeClassName: 'active',
	                  style: blackColorLink
	                },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(
	                      'nobr',
	                      null,
	                      'Influencers'
	                    )
	                  ),
	                  content: 'Manage your campaign influencers. Add, invite and request Authorization.'
	                })
	              ),
	              isAuto && _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  as: 'div', to: '/campaign/' + campaignId + '/notifications',
	                  className: 'flex-item',
	                  activeClassName: 'active',
	                  style: blackColorLink
	                },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(
	                    'nobr',
	                    null,
	                    'Notifications'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  as: 'div', to: '/campaign/' + campaignId + '/analytics',
	                  className: 'flex-item',
	                  activeClassName: 'active',
	                  style: blackColorLink
	                },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(
	                    'nobr',
	                    null,
	                    'Dashboard'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  as: 'div', to: '/campaign/' + campaignId + '/reports',
	                  className: 'flex-item',
	                  activeClassName: 'active',
	                  style: blackColorLink
	                },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(
	                    'nobr',
	                    null,
	                    'Reports'
	                  )
	                )
	              ),
	              shouldRenderAuditTrail && isManual && _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  as: 'div', to: '/campaign/' + campaignId + '/audit-trail',
	                  className: 'flex-item',
	                  activeClassName: 'active',
	                  style: blackColorLink
	                },
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'nobr',
	                    null,
	                    'Audit trail'
	                  ),
	                  content: 'Audit trail description'
	                })
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  as: 'div', to: '/campaign/' + campaignId + '/settings',
	                  className: 'flex-item',
	                  activeClassName: 'active',
	                  style: blackColorLink
	                },
	                'Settings'
	              )
	            )
	          ) : _react2.default.createElement('div', { className: 'spacer large' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          campaignLoading && _react2.default.createElement(
	            'div',
	            { className: 'discussion-preloader' },
	            _react2.default.createElement('img', { src: '/icons/dyzio-icon.svg', alt: 'Loading...' })
	          ),
	          !campaignLoading && !campaignLoadError && this.props.children && _react2.default.cloneElement(this.props.children, this.props)
	        ),
	        hashtagScannerModalOpen && _react2.default.createElement(_hashtagScannerModal2.default, {
	          isEmptyState: !hasInfluencers,
	          isScanning: isScanning,
	          currentScannedPlatform: currentScannedPlatform,
	          onClose: this.handleHashtagScannerState,
	          onInputValueChange: this.handleHashtagInputsChange,
	          onScanHandler: this.handleScanButtonClick,
	          scannerResultsCount: scannerResultsCount,
	          hashtags: hashtags,
	          hashtagsErrors: hashtagsErrors
	        }),
	        editCampaignModalOpen && campaign && _react2.default.createElement(_addCampaignModal2.default, {
	          title: 'Edit campaign details',
	          buttonLabel: 'Save',
	          addCampaignFormProps: campaignFormProps,
	          onClose: this.toggleEditCampaignModalState,
	          onAddCampaignSubmit: this.onSubmitEditCampaignForm
	        }),
	        chaseModalOpen && _react2.default.createElement(_chaseEmailSendModal2.default, { campaignId: campaignId, onClose: this.toggleChaseEmailModal })
	      );
	    }
	  }]);
	
	  return Campaign;
	}(_react2.default.Component);
	
	Campaign.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	Campaign.propTypes = {
	  params: _propTypes2.default.object.isRequired
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    campaign: state.campaign.get('campaign'),
	    myUserRole: state.campaign.get('myUserRole'),
	    members: state.members.get('members'),
	    showModal: state.modal.get('showModal'),
	    campaignLoadError: state.campaign.get('campaignLoadError'),
	    campaignLoading: state.campaign.get('campaignLoading')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onClearStatusBar: function onClearStatusBar() {
	      return dispatch((0, _actions3.clearStatusBar)());
	    },
	    onLoadingCampaign: function onLoadingCampaign(campaignId, silent, fastLoad) {
	      return dispatch((0, _actions.loadingCampaign)(campaignId, silent, fastLoad));
	    },
	    onLoadCampaignAnalytics: function onLoadCampaignAnalytics(data) {
	      return dispatch((0, _actions2.loadCampaignAnalytics)(data));
	    },
	    onSetModal: function onSetModal(modalName) {
	      return dispatch((0, _modal.setModal)(modalName));
	    }
	  };
	}
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _hasOrganisation2.default, _hasRestClient2.default)(Campaign);

/***/ },
/* 2090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(280);
	
	var initialState = (0, _immutable.fromJS)({
	  campaign: {},
	  campaignId: null,
	  teamDiscussionId: null,
	  clientDiscussionId: null,
	  partnerAgencyDiscussionId: null,
	  teamOrganisationId: null,
	  campaignLoadError: null,
	  campaignLoading: false,
	  myUserRole: null,
	  myPermissionId: null,
	  myPermissionName: null,
	  myCampaignOrganisationId: null
	});
	
	function campaignReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.LOAD_CAMPAIGN:
	      return state.set('campaign', (0, _immutable.fromJS)({})).set('campaignLoadError', null).set('partnerAgencyDiscussionId', null).set('teamDiscussionId', null).set('clientDiscussionId', null).set('campaignId', action.campaignId);
	    case _constants.LOADING_CAMPAIGN:
	      return state.set('campaignLoading', true);
	    case _constants.LOAD_CAMPAIGN_SUCCESS:
	      return state.set('campaign', action.campaign).set('partnerAgencyDiscussionId', action.campaign.get('partnerAgencyDiscussion')).set('teamDiscussionId', action.campaign.get('teamDiscussion')).set('clientDiscussionId', action.campaign.get('clientDiscussion')).set('teamOrganisationId', action.campaign.getIn(['owner', 'id'])).set('campaignLoadError', null).set('campaignLoading', false);
	    case _constants.LOAD_CAMPAIGN_ERROR:
	      return state.set('campaignLoadError', action.error).set('campaignLoading', false);
	    case _constants.SET_MY_PERMISSION_INFO:
	      return state.set('myUserRole', action.role).set('myPermissionId', action.id).set('myPermissionName', action.name).set('myCampaignOrganisationId', action.organisationId);
	    default:
	      return state;
	  }
	}
	
	exports.default = campaignReducer;

/***/ },
/* 2091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.loadCampaign = loadCampaign;
	exports.watchCampaign = watchCampaign;
	exports.default = campaignSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _campaigns = __webpack_require__(2383);
	
	var _campaignPermissionSelectors = __webpack_require__(285);
	
	var _campaignSelectors = __webpack_require__(117);
	
	var _authToken = __webpack_require__(926);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _constants = __webpack_require__(280);
	
	var _constants2 = __webpack_require__(282);
	
	var _constants3 = __webpack_require__(356);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadCampaign, watchCampaign, campaignSagas].map(_regenerator2.default.mark);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function loadCampaign(actions) {
	  var campaignId, fastLoad, campaignLoading, campaign, campaignPermissionLoading, myCampaignOrganisationId, myPermissionId, myCampaignRole, myPermissionName, members, pendingMembers;
	  return _regenerator2.default.wrap(function loadCampaign$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          campaignId = actions.campaignId, fastLoad = actions.fastLoad;
	          _context.prev = 1;
	          _context.next = 4;
	          return (0, _effects.call)(_authToken.loadAuthToken);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.select)(_campaignSelectors.getCampaignLoading);
	
	        case 6:
	          campaignLoading = _context.sent;
	
	          if (campaignLoading) {
	            _context.next = 51;
	            break;
	          }
	
	          if (actions.silent) {
	            _context.next = 11;
	            break;
	          }
	
	          _context.next = 11;
	          return (0, _effects.put)({ type: _constants.LOADING_CAMPAIGN });
	
	        case 11:
	          if (!fastLoad) {
	            _context.next = 17;
	            break;
	          }
	
	          _context.next = 14;
	          return (0, _effects.call)(_campaigns.getFastLoadCampaign, campaignId);
	
	        case 14:
	          _context.t0 = _context.sent;
	          _context.next = 20;
	          break;
	
	        case 17:
	          _context.next = 19;
	          return (0, _effects.call)(_campaigns.getCampaign, campaignId);
	
	        case 19:
	          _context.t0 = _context.sent;
	
	        case 20:
	          campaign = _context.t0;
	          _context.next = 23;
	          return (0, _effects.select)(_campaignPermissionSelectors.getPermissionListLoading);
	
	        case 23:
	          campaignPermissionLoading = _context.sent;
	
	          if (!campaignPermissionLoading) {
	            _context.next = 27;
	            break;
	          }
	
	          _context.next = 27;
	          return (0, _effects.take)(_constants2.LOAD_CAMPAIGNS_SUCCESS);
	
	        case 27:
	          _context.next = 29;
	          return (0, _effects.select)(_campaignPermissionSelectors.getCampaignPermissionOrganisationId, campaignId);
	
	        case 29:
	          myCampaignOrganisationId = _context.sent;
	          _context.next = 32;
	          return (0, _effects.select)(_campaignPermissionSelectors.getCampaignPermissionId, campaignId);
	
	        case 32:
	          myPermissionId = _context.sent;
	          _context.next = 35;
	          return (0, _effects.select)(_campaignPermissionSelectors.getCampaignPermissionRole, campaignId);
	
	        case 35:
	          myCampaignRole = _context.sent;
	          _context.next = 38;
	          return (0, _effects.select)(_campaignPermissionSelectors.getCampaignPermissionName, campaignId);
	
	        case 38:
	          myPermissionName = _context.sent;
	
	
	          campaign.members = campaign.members || [];
	          members = {};
	          pendingMembers = {};
	
	          campaign.members.forEach(function (member) {
	            if (!member) return;
	            members[member.id] = member;
	          });
	
	          campaign.pendingInvitations = campaign.pendingInvitations || [];
	
	          // TODO This could be improved massively by simply storing the pending list as invidation IDs in the discussions
	          campaign.pendingInvitations.forEach(function (pendingMember) {
	            if (!pendingMember) return;
	            var role = pendingMember.role;
	            if (role === _staticConfiguration.TEAM_MEMBER) {
	              if (pendingMembers[campaign.owner.id]) {
	                pendingMembers[campaign.owner.id] = [].concat(_toConsumableArray(pendingMembers[campaign.owner.id]), [pendingMember]);
	              } else {
	                pendingMembers[campaign.owner.id] = [pendingMember];
	              }
	            }
	
	            if (pendingMember.organisation && (role === _staticConfiguration.INFLUENCER || role === _staticConfiguration.TALENT_AGENT || role === _staticConfiguration.PRODUCTION_COMPANY)) {
	              if (pendingMembers[pendingMember.organisation.id]) {
	                pendingMembers[pendingMember.organisation.id] = [].concat(_toConsumableArray(pendingMembers[pendingMember.organisation.id]), [pendingMember]);
	              } else {
	                pendingMembers[pendingMember.organisation.id] = [pendingMember];
	              }
	            }
	          });
	
	          _context.next = 47;
	          return (0, _effects.put)({
	            type: _constants.SET_MY_PERMISSION_INFO,
	            role: myCampaignRole,
	            id: myPermissionId,
	            name: myPermissionName,
	            organisationId: myCampaignOrganisationId
	          });
	
	        case 47:
	          _context.next = 49;
	          return (0, _effects.put)({ type: _constants.LOAD_CAMPAIGN_SUCCESS, campaign: (0, _immutable.fromJS)(campaign) });
	
	        case 49:
	          _context.next = 51;
	          return (0, _effects.put)({
	            type: _constants3.LOAD_MEMBERS_SUCCESS,
	            members: (0, _immutable.fromJS)(members),
	            pendingInvitations: (0, _immutable.fromJS)(pendingMembers)
	          });
	
	        case 51:
	          _context.next = 59;
	          break;
	
	        case 53:
	          _context.prev = 53;
	          _context.t1 = _context['catch'](1);
	
	          console.error(_context.t1);
	          (0, _errorHandlingService.reportError)('LOAD_CAMPAIGN_ERROR', _context.t1.message);
	          _context.next = 59;
	          return (0, _effects.put)({ type: _constants.LOAD_CAMPAIGN_ERROR, error: _context.t1.message });
	
	        case 59:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[1, 53]]);
	}
	
	function watchCampaign() {
	  return _regenerator2.default.wrap(function watchCampaign$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.LOAD_CAMPAIGN, loadCampaign);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function campaignSagas() {
	  return _regenerator2.default.wrap(function campaignSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(watchCampaign)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 2092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ramda = __webpack_require__(252);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _wideCampaignCard = __webpack_require__(2038);
	
	var _wideCampaignCard2 = _interopRequireDefault(_wideCampaignCard);
	
	var _campaignDashboardHeader = __webpack_require__(344);
	
	var _campaignDashboardHeader2 = _interopRequireDefault(_campaignDashboardHeader);
	
	var _tabActionBar = __webpack_require__(194);
	
	var _tabActionBar2 = _interopRequireDefault(_tabActionBar);
	
	var _campaignCard = __webpack_require__(863);
	
	var _campaignCard2 = _interopRequireDefault(_campaignCard);
	
	var _dyzioEmptyState = __webpack_require__(192);
	
	var _dyzioEmptyState2 = _interopRequireDefault(_dyzioEmptyState);
	
	var _addCampaignModal = __webpack_require__(535);
	
	var _addCampaignModal2 = _interopRequireDefault(_addCampaignModal);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasLocalstorageClient = __webpack_require__(127);
	
	var _hasLocalstorageClient2 = _interopRequireDefault(_hasLocalstorageClient);
	
	var _hasViewmodeManagement = __webpack_require__(568);
	
	var _hasViewmodeManagement2 = _interopRequireDefault(_hasViewmodeManagement);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _currencies = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CAMPAIGN_VERSION_TWO = 2;
	var CAMPAIGN_PER_PAGE = 100;
	var CAMPAIGN_TYPE_WORKFLOW = 'WORKFLOW';
	var CLIENT_BRIEF_URL = 'https://s3-eu-west-1.amazonaws.com/cf-templates-o6s432he4qgr-eu-west-1/2016202Jd5-dyzio-aws-stack.json';
	
	var sortByOptions = [{ key: 'assetsCountAsc', text: 'Assets count (ASC)', value: { field: 'trackedAssetsCount', order: 'ASC' } }, { key: 'assetsCountDesc', text: 'Assets date (DESC)', value: { field: 'trackedAssetsCount', order: 'DESC' } }, { key: 'createdDateAsc', text: 'Created date (ASC)', value: { field: 'campaignPermission.createdDate', order: 'ASC' } }, { key: 'createdDateDesc', text: 'Created date (DESC)', value: { field: 'campaignPermission.createdDate', order: 'DESC' } }, { key: 'nameAsc', text: 'Name (ASC)', value: { field: 'campaign.name', order: 'ASC' } }, { key: 'nameDesc', text: 'Name (DESC)', value: { field: 'campaign.name', order: 'DESC' } }];
	
	var INITIAL_FORM_STATE_FIELDS = {
	  name: null,
	  budget: null,
	  liveDate: null,
	  hashtags: null,
	  currency: _currencies.CURRENCY_GBP,
	  endDate: null,
	  version: 2,
	  hasChanged: false,
	  savedOk: false,
	  isValidBudget: true
	};
	
	var CampaignsV2 = function (_React$Component) {
	  _inherits(CampaignsV2, _React$Component);
	
	  function CampaignsV2(props) {
	    _classCallCheck(this, CampaignsV2);
	
	    var _this = _possibleConstructorReturn(this, (CampaignsV2.__proto__ || Object.getPrototypeOf(CampaignsV2)).call(this, props));
	
	    _this.requestData = function () {
	      var _this$props = _this.props,
	          restClient = _this$props.restClient,
	          userInfo = _this$props.userInfo;
	      var userId = userInfo.userId;
	      var _this$state = _this.state,
	          sort = _this$state.sort,
	          filter = _this$state.filter;
	
	      restClient({
	        method: 'post',
	        url: '/campaigns/query',
	        baseURL: ("https://dl6gzrmms2.execute-api.eu-west-1.amazonaws.com/production"),
	        data: {
	          data: {
	            userId: userId,
	            perPage: CAMPAIGN_PER_PAGE,
	            search: {},
	            sort: sort,
	            filter: filter
	          }
	        }
	      }).then(function (response) {
	        var data = response.data.data.data;
	
	        _this.setState({
	          records: data,
	          isLoaded: true,
	          isFailed: false,
	          isLoading: false
	        });
	      }).catch(function () {
	        _this.setState({
	          isLoaded: true,
	          isFailed: true,
	          isLoading: false
	        });
	      });
	    };
	
	    _this.componentDidMount = function () {
	      _this.requestData();
	    };
	
	    _this.onSortByChanged = function (event, data) {
	      var value = data.value;
	
	      _this.setState({
	        sort: value
	      }, _this.requestData);
	    };
	
	    _this.onViewModeChanged = function (event, data) {
	      var name = data.name;
	      var _this$props2 = _this.props,
	          dyzioStorage = _this$props2.dyzioStorage,
	          viewModeManager = _this$props2.viewModeManager;
	
	      _this.setState({
	        viewMode: name
	      }, function () {
	        viewModeManager.updateViewMode(dyzioStorage.KEYS.CAMPAGINS_LIST_VIEW_MODE, name);
	      });
	    };
	
	    _this.toggleAddNewCampaignModalState = function () {
	      var addCampaignModalVisible = _this.state.addCampaignModalVisible;
	
	      var updatedState = {
	        addCampaignModalVisible: !addCampaignModalVisible
	      };
	      if (addCampaignModalVisible) {
	        _lodash2.default.assign(updatedState, INITIAL_FORM_STATE_FIELDS);
	      }
	      _this.setState(updatedState);
	    };
	
	    _this.onAddNewCampaignSubmit = function () {
	      var _this$props3 = _this.props,
	          jsonAPIClient = _this$props3.jsonAPIClient,
	          _this$props3$userInfo = _this$props3.userInfo,
	          organisationId = _this$props3$userInfo.organisationId,
	          userId = _this$props3$userInfo.userId,
	          email = _this$props3$userInfo.email;
	      var _this$state2 = _this.state,
	          name = _this$state2.name,
	          budget = _this$state2.budget,
	          liveDate = _this$state2.liveDate,
	          endDate = _this$state2.endDate,
	          currency = _this$state2.currency,
	          hashtags = _this$state2.hashtags;
	
	      // validate budget being a valid number
	
	      var isValidBudget = !_lodash2.default.isNaN(_lodash2.default.toNumber(budget));
	
	      if (!isValidBudget) {
	        _this.setState({ isValidBudget: isValidBudget });
	        return;
	      }
	
	      var campaign = jsonAPIClient.create('campaigns');
	
	      var fields = {
	        name: name,
	        budget: budget,
	        campaignType: CAMPAIGN_TYPE_WORKFLOW,
	        memberCount: 1,
	        version: CAMPAIGN_VERSION_TWO,
	        clientBrief: CLIENT_BRIEF_URL,
	        currency: currency,
	        hashtags: hashtags,
	        description: 'Description generated at ' + (0, _moment2.default)().toISOString()
	      };
	
	      _lodash2.default.forEach(fields, function (value, key) {
	        if (value) {
	          campaign.set(key, value);
	        }
	      });
	
	      if (liveDate) {
	        campaign.set('liveDate', liveDate.toISOString());
	      }
	
	      if (endDate) {
	        campaign.set('endDate', endDate.toISOString());
	      }
	
	      campaign.sync().then(function (response) {
	        var campaignResource = _lodash2.default.clone(response);
	        var campaignJSON = response.toJSONTree();
	        // Create campaign permission
	        var campaignPermission = jsonAPIClient.create('campaignPermission');
	        campaignPermission.set('campaign', { type: 'campaigns', id: campaignJSON.id });
	        campaignPermission.set('user', { type: 'users', id: userId });
	        campaignPermission.set('organisation', { type: 'organisations', id: organisationId });
	        campaignPermission.set('email', email);
	        campaignPermission.set('role', _staticConfiguration.CAMPAIGN_OWNER);
	        campaignPermission.sync().then(function (campaignPermissionResponse) {
	          var campaignPermissionResource = _lodash2.default.clone(campaignPermissionResponse);
	          campaignResource.relationships('members').add(campaignPermissionResource);
	          campaignResource.sync().then(function (resource) {
	            var createdCampaign = resource.toJSON();
	            _this.setState(_extends({
	              addCampaignModalVisible: false,
	              isLoading: true,
	              isFailed: false,
	              isLoaded: false
	            }, INITIAL_FORM_STATE_FIELDS), function () {
	              _this.context.router.push('/campaign/v2/' + createdCampaign.id + '/assets');
	            });
	          });
	        });
	      });
	    };
	
	    _this.onInputChange = function (event, _ref) {
	      var _this$setState;
	
	      var name = _ref.name,
	          value = _ref.value;
	
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, value), _defineProperty(_this$setState, 'hasChanged', true), _defineProperty(_this$setState, 'savedOk', false), _this$setState));
	    };
	
	    _this.onLiveDateChange = function (date) {
	      _this.setState({
	        liveDate: date,
	        hasChanged: true,
	        savedOk: false
	      });
	    };
	
	    _this.onEndDateChange = function (date) {
	      _this.setState({
	        endDate: date,
	        hasChanged: true,
	        savedOk: false
	      });
	    };
	
	    _this.onCurrencyChange = function (event, data) {
	      var value = data.value;
	
	      _this.setState({
	        currency: value
	      });
	    };
	
	    var savedViewMode = props.dyzioStorage.get(props.dyzioStorage.KEYS.CAMPAGINS_LIST_VIEW_MODE);
	    _this.state = _extends({
	      isLoading: true,
	      isFailed: false,
	      isLoaded: false,
	      records: [],
	      viewMode: props.viewModeManager.getViewMode(savedViewMode),
	      addCampaignModalVisible: false,
	      sort: {
	        field: 'trackedAssetsCount',
	        order: 'DESC'
	      },
	      filter: {
	        version: CAMPAIGN_VERSION_TWO
	      }
	    }, INITIAL_FORM_STATE_FIELDS);
	    return _this;
	  }
	
	  _createClass(CampaignsV2, [{
	    key: 'render',
	    value: function render() {
	      var actionButtonProps = {
	        onClick: this.toggleAddNewCampaignModalState,
	        content: 'Add a campaign'
	      };
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          isLoaded = _state.isLoaded,
	          isFailed = _state.isFailed,
	          records = _state.records,
	          viewMode = _state.viewMode,
	          addCampaignModalVisible = _state.addCampaignModalVisible,
	          name = _state.name,
	          budget = _state.budget,
	          liveDate = _state.liveDate,
	          endDate = _state.endDate,
	          currency = _state.currency,
	          hashtags = _state.hashtags,
	          hasChanged = _state.hasChanged,
	          isValidBudget = _state.isValidBudget,
	          savedOk = _state.savedOk;
	
	
	      var addCampaignFormProps = {
	        name: name,
	        budget: budget,
	        liveDate: liveDate,
	        endDate: endDate,
	        currency: currency,
	        hashtags: hashtags,
	        hasChanged: hasChanged,
	        savedOk: savedOk,
	        onLiveDateChange: this.onLiveDateChange,
	        onInputChange: this.onInputChange,
	        onEndDateChange: this.onEndDateChange,
	        onCurrencyChange: this.onCurrencyChange
	      };
	
	      var newCampaignNameProvided = _lodash2.default.isString(name) && _lodash2.default.size(name) > 0;
	      var budgetProvided = _lodash2.default.isString(budget);
	      var liveDateProvided = _lodash2.default.isObject(liveDate);
	
	      var canSubmitForm = _ramda2.default.all(function (arg) {
	        return arg === true;
	      }, [newCampaignNameProvided, budgetProvided, liveDateProvided]);
	
	      var isLargeCardsViewMode = viewMode === _tabActionBar.ViewModes.cardsLarge;
	      var isSmallCardsViewMode = viewMode === _tabActionBar.ViewModes.cardsSmall;
	      var isTableView = viewMode === _tabActionBar.ViewModes.table;
	      var isCardsViewMode = isLargeCardsViewMode || isSmallCardsViewMode;
	      var noCampaignPermissions = _lodash2.default.isEmpty(records);
	      var isLoadSuccess = isLoaded && !isFailed && !noCampaignPermissions;
	      var isLoadEmptyData = isLoaded && !isFailed && noCampaignPermissions;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'page' },
	          _react2.default.createElement(_campaignDashboardHeader2.default, {
	            name: 'My Campaigns'
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'page-content' },
	            _react2.default.createElement(_tabActionBar2.default, {
	              hasActionButton: true,
	              actionButtonProps: actionButtonProps,
	              onViewModeChanged: this.onViewModeChanged,
	              shouldDisableButtons: isLoading || noCampaignPermissions,
	              isLargeCards: isLargeCardsViewMode,
	              isSmallCards: isSmallCardsViewMode,
	              isTableView: isTableView,
	              sortByOptions: sortByOptions,
	              onSortByChanged: this.onSortByChanged
	            }),
	            isLoading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading campaigns...' }),
	            isLoadEmptyData && _react2.default.createElement(_dyzioEmptyState2.default, {
	              buttonLabel: 'Add a campaign',
	              onClick: this.toggleAddNewCampaignModalState,
	              content: _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'There are no campaigns yet.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Use the button below to create a new campaign.'
	                )
	              )
	            }),
	            isLoadSuccess && isCardsViewMode && _react2.default.createElement(
	              _semanticUiReact.Card.Group,
	              { itemsPerRow: isLargeCardsViewMode ? 4 : 6 },
	              _lodash2.default.map(records, function (record) {
	                return _react2.default.createElement(_campaignCard2.default, record);
	              })
	            ),
	            isLoadSuccess && isTableView && _react2.default.createElement(
	              _semanticUiReact.Card.Group,
	              { itemsPerRow: 1 },
	              _lodash2.default.map(records, function (record) {
	                return _react2.default.createElement(_wideCampaignCard2.default, record);
	              })
	            ),
	            addCampaignModalVisible && _react2.default.createElement(_addCampaignModal2.default, {
	              onClose: this.toggleAddNewCampaignModalState,
	              addCampaignFormProps: addCampaignFormProps,
	              onAddCampaignSubmit: this.onAddNewCampaignSubmit,
	              shouldDisableActionButton: !canSubmitForm,
	              isValidBudget: isValidBudget
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CampaignsV2;
	}(_react2.default.Component);
	
	CampaignsV2.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	CampaignsV2.propTypes = {
	  dyzioStorage: _propTypes2.default.object.isRequired,
	  viewModeManager: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasJsonapiClient2.default, _hasUserInfo2.default, _hasLocalstorageClient2.default, _hasViewmodeManagement2.default)(CampaignsV2);

/***/ },
/* 2093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chat = function Chat() {
	  return _react2.default.createElement(
	    _semanticUiReact.Grid,
	    { style: { margin: 30 }, divided: true },
	    _react2.default.createElement(
	      _semanticUiReact.Grid.Column,
	      { width: 6 },
	      _react2.default.createElement(
	        'p',
	        null,
	        'applications go here'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Grid.Column,
	      { stretched: true, width: 10, style: { border: '1px solid pink' } },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'chat goes here'
	      ),
	      _react2.default.createElement('iframe', { width: '100%;', height: '100%', src: 'https://chat.dyzio.co/blah?layout=embedded' })
	    )
	  );
	};
	
	exports.default = Chat;

/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBrowserDetection = __webpack_require__(255);
	
	var _reactBrowserDetection2 = _interopRequireDefault(_reactBrowserDetection);
	
	var _browserHandler = __webpack_require__(231);
	
	var _browserHandler2 = _interopRequireDefault(_browserHandler);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var theme = _themeSelector2.default.theme();
	
	var CheckLocalStorage = function (_Component) {
	  _inherits(CheckLocalStorage, _Component);
	
	  function CheckLocalStorage() {
	    _classCallCheck(this, CheckLocalStorage);
	
	    return _possibleConstructorReturn(this, (CheckLocalStorage.__proto__ || Object.getPrototypeOf(CheckLocalStorage)).apply(this, arguments));
	  }
	
	  _createClass(CheckLocalStorage, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-centered' },
	        _react2.default.createElement(
	          'div',
	          { className: 'center-outer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'center-inner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'center-logo' },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this2.context.router.push('/');
	                  } },
	                _react2.default.createElement('img', { src: theme.darkLogo.src, alt: theme.darkLogo.alt })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'browser-detect' },
	              _react2.default.createElement(
	                'div',
	                { className: 'browser-warning' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'info' },
	                  'Oops... we need to use local storage.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'info' },
	                  'If you are using Safari please switch off Private Mode.'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _reactBrowserDetection2.default,
	                  null,
	                  _browserHandler2.default.handle
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CheckLocalStorage;
	}(_react.Component);
	
	exports.default = CheckLocalStorage;

/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _validator = __webpack_require__(84);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _reactRouter = __webpack_require__(37);
	
	var _reactRedux = __webpack_require__(28);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _authService = __webpack_require__(21);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _roleService = __webpack_require__(143);
	
	var _trackedAssetsAnalyticsService = __webpack_require__(173);
	
	var _budgetReadonly = __webpack_require__(861);
	
	var _budgetReadonly2 = _interopRequireDefault(_budgetReadonly);
	
	var _acrDemographicsWrapper = __webpack_require__(2047);
	
	var _acrDemographicsWrapper2 = _interopRequireDefault(_acrDemographicsWrapper);
	
	var _socialTable = __webpack_require__(553);
	
	var _socialTable2 = _interopRequireDefault(_socialTable);
	
	var _addAssetForm = __webpack_require__(276);
	
	var _addAssetForm2 = _interopRequireDefault(_addAssetForm);
	
	var _assetTable = __webpack_require__(537);
	
	var _assetTable2 = _interopRequireDefault(_assetTable);
	
	var _inviteModal = __webpack_require__(1993);
	
	var _inviteModal2 = _interopRequireDefault(_inviteModal);
	
	var _addStoryModal = __webpack_require__(536);
	
	var _addStoryModal2 = _interopRequireDefault(_addStoryModal);
	
	var _influencerFeeModal = __webpack_require__(1962);
	
	var _influencerFeeModal2 = _interopRequireDefault(_influencerFeeModal);
	
	var _sendLimitsExceededNotifcation = __webpack_require__(365);
	
	var _sendLimitsExceededNotifcation2 = _interopRequireDefault(_sendLimitsExceededNotifcation);
	
	var _shopifyTable = __webpack_require__(893);
	
	var _shopifyTable2 = _interopRequireDefault(_shopifyTable);
	
	var _shopifyConfig = __webpack_require__(892);
	
	var _shopifyConfig2 = _interopRequireDefault(_shopifyConfig);
	
	var _hasShopify = __webpack_require__(925);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INVITATION_STATUS = {
	  deferred: 'DEFERRED',
	  sent: 'SENT',
	  accepted: 'ACCEPTED'
	};
	
	var ASSET_API_TIMEOUT = 2500;
	
	var dropdownStyle = {
	  marginBottom: 1
	};
	
	var INFLUENCER_LIMIT = 200;
	var SHOW_SHOPIFY = true;
	
	var InvitationSentComponent = function InvitationSentComponent(_ref) {
	  var influencer = _ref.influencer;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning', color: 'orange' }),
	    '\xA0',
	    influencer.name,
	    ' has been invited, but has not accepted yet.'
	  );
	};
	
	var NoEmailComponent = function NoEmailComponent(_ref2) {
	  var influencer = _ref2.influencer;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning', color: 'orange' }),
	    '\xA0No email address for ',
	    influencer.name,
	    '. Please update in My Influencers.'
	  );
	};
	
	var InvitationDeferredComponent = function InvitationDeferredComponent(_ref3) {
	  var influencer = _ref3.influencer;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'info', color: 'green' }),
	    '\xA0',
	    influencer.name,
	    ' has not been invited yet. Use the pink button to send an invitation.'
	  );
	};
	
	var InvitationJoinedComponent = function InvitationJoinedComponent(_ref4) {
	  var influencer = _ref4.influencer;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'handshake outline', color: 'blue' }),
	    '\xA0',
	    influencer.name,
	    ' has joined the campaign.'
	  );
	};
	
	var CollaborationCard = function (_React$Component) {
	  _inherits(CollaborationCard, _React$Component);
	
	  function CollaborationCard() {
	    var _this2 = this;
	
	    _classCallCheck(this, CollaborationCard);
	
	    var _this = _possibleConstructorReturn(this, (CollaborationCard.__proto__ || Object.getPrototypeOf(CollaborationCard)).call(this));
	
	    _this.loadShopify = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee(discussionId) {
	        var _ref6, orders;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.setState({ shopifyLoading: true });
	                _context.next = 3;
	                return (0, _hasShopify.getShopifyOrdersByDiscussionId)({ discussionId: discussionId });
	
	              case 3:
	                _ref6 = _context.sent;
	                orders = _ref6.orders;
	
	                _this.setState({ shopifyLoading: false, shopifyOrders: orders });
	                console.log('shopifyOrders', orders);
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.onNewFeeSubmit = function (fee) {
	      var discussionId = _this.props.discussion.get('id');
	      _this.jsonClient.get('discussions', discussionId, {}, function (err, resource) {
	        resource.set('budget', fee);
	        resource.set('budgetStatus', 'APPROVED');
	        resource.sync().then(function () {
	          _this.setState({
	            feeModalOpen: false
	          }, _this.props.refreshPageHandler);
	        });
	      });
	    };
	
	    _this.loadAsset = function (asset) {
	      (0, _trackedAssetsAnalyticsService.getTrackedAssetAnalytics)([asset]).then(function (response) {
	        var newAssetDetails = _lodash2.default.map(response, 'response.data')[0];
	        console.log(newAssetDetails);
	        if (newAssetDetails) {
	          newAssetDetails.trackedAsset = asset; // set the tracked asset to this one associated with the campaign
	          var assetsDetails = _this.state.assetsDetails;
	
	          assetsDetails.pop(); // get rid of the last entry (fetching place holder)
	          var placeHolder = {
	            trackedAsset: {
	              id: response[0].id
	            },
	            withError: true
	          };
	          assetsDetails.push(newAssetDetails || placeHolder);
	          return _this.setState({
	            assetsDetails: assetsDetails
	          });
	        }
	      });
	    };
	
	    _this.toggleAddStoryModal = function () {
	      console.log('[showAddStoryModal]');
	      var addStoryVisible = _this.state.addStoryVisible;
	
	      _this.setState({ addStoryVisible: !addStoryVisible });
	    };
	
	    _this.addStory = function (asset) {
	      var assetsDetails = _this.state.assetsDetails;
	
	      assetsDetails.push({
	        text: 'fetching data...',
	        state: 'FETCHING',
	        trackedAsset: asset
	      });
	
	      _this.setState({
	        assetsDetails: assetsDetails
	      });
	
	      setTimeout(function () {
	        _this.loadAsset(asset);
	      }, ASSET_API_TIMEOUT);
	    };
	
	    _this.viewDiscussion = function (discussion) {
	      return function () {
	        _this.context.router.push('/campaign/discussion/' + discussion.get('id'));
	      };
	    };
	
	    _this.deleteDiscussionRelationship = function (discussionId) {
	      var campaign = _this.props.campaign;
	
	      var campaignId = campaign.get('id');
	
	      var token = _authService.authService.getToken();
	
	      var ax = _axios2.default.create({
	        baseURL: ("https://api2.dyzio.co/v1"),
	        timeout: 1000,
	        headers: {
	          Authorization: 'Bearer ' + token
	        }
	      });
	
	      var campaignUrl = '/campaigns/' + campaignId;
	      return ax.get(campaignUrl).then(function (r) {
	        var relationships = r.data.data.relationships;
	
	        return relationships.discussions.data;
	      }).then(function (discussions) {
	        var newDiscussions = _lodash2.default.reject(discussions, { id: discussionId });
	        return { data: { attributes: { discussions: newDiscussions } } };
	      }).then(function (payload) {
	        return ax.patch(campaignUrl, payload);
	      });
	    };
	
	    _this.removeCollaboration = function (discussionId, invitationId) {
	      console.log('d: ' + discussionId);
	      console.log('i: ' + invitationId);
	
	      var collaborationDeleteUrl = '/discussions/' + discussionId;
	      var invitationDeleteUrl = '/campaignInvitation/' + invitationId;
	
	      var token = _authService.authService.getToken();
	
	      var ax = _axios2.default.create({
	        baseURL: ("https://api2.dyzio.co/v1"),
	        timeout: 1000,
	        headers: {
	          Authorization: 'Bearer ' + token
	        }
	      });
	
	      return ax.delete(collaborationDeleteUrl).then(function () {
	        return _this.deleteDiscussionRelationship(discussionId);
	      }).then(function () {
	        if (invitationId) {
	          console.log('deleting invitation ' + invitationId);
	          return ax.delete(invitationDeleteUrl);
	        }
	        return Promise.resolve();
	      }).then(function () {
	        return _this.remove();
	      });
	    };
	
	    _this.toggleAddAssetPopup = function (e, data) {
	      var _this$state = _this.state,
	          asset = _this$state.asset,
	          hasCheckedLimitNotification = _this$state.hasCheckedLimitNotification;
	
	      asset.adding = !asset.adding;
	      asset.platform = _lodash2.default.isUndefined(data) ? null : data.value;
	      if (!hasCheckedLimitNotification) {
	        _this.checkLimitsNotification();
	      }
	      _this.setState({
	        asset: asset,
	        hasCheckedLimitNotification: true
	      });
	    };
	
	    _this.checkLimitsNotification = function () {
	      var _this$props = _this.props,
	          restClient = _this$props.restClient,
	          trackedAssetsCount = _this$props.trackedAssetsCount,
	          _this$props$userInfo = _this$props.userInfo,
	          organisationId = _this$props$userInfo.organisationId,
	          name = _this$props$userInfo.name,
	          userId = _this$props$userInfo.userId,
	          organisation = _this$props.organisation;
	
	      if (!trackedAssetsCount || !organisation) return;
	      if (trackedAssetsCount < organisation.licenseTrackedAssetLimit) return;
	      (0, _sendLimitsExceededNotifcation2.default)(restClient, {
	        data: {
	          name: name + ' ',
	          organisationId: organisationId,
	          userId: userId,
	          organisationName: organisation.name + ' ',
	          assetType: 'tracked assets',
	          licenseSubscriptionType: organisation.licenseSubscriptionType,
	          url: window.location.href
	        }
	      });
	    };
	
	    _this.assetFormSubmitHandler = function (details) {
	      var _this$props2 = _this.props,
	          discussion = _this$props2.discussion,
	          campaign = _this$props2.campaign,
	          refreshPageHandler = _this$props2.refreshPageHandler,
	          organisationId = _this$props2.userInfo.organisationId;
	      var asset = _this.state.asset;
	
	
	      var discussionId = discussion.get('id');
	      var discussionName = discussion.get('name');
	      var campaignName = campaign.get('name');
	
	      if (details) {
	        var trackedAsset = _this.jsonClient.create('trackedAssets');
	        trackedAsset.set('assetId', details.assetId);
	        trackedAsset.set('assetURL', details.assetURL);
	        trackedAsset.set('user', {
	          type: 'users',
	          id: _authService.authService.uid()
	        });
	        trackedAsset.set('campaign', {
	          type: 'campaigns',
	          id: campaign.get('id')
	        });
	        trackedAsset.set('discussion', {
	          type: 'discussions',
	          id: discussionId
	        });
	        trackedAsset.set('organisation', {
	          type: 'organisations',
	          id: organisationId
	        });
	        trackedAsset.set('discussionName', discussionName);
	        trackedAsset.set('campaignName', campaignName);
	        trackedAsset.set('platform', details.platform);
	        trackedAsset.set('assetType', details.assetType);
	        trackedAsset.set('createdSource', 'CAMPAIGN');
	        trackedAsset.sync().then(function (response) {
	          var newTrackedAsset = response.toJSON();
	          return {
	            data: {
	              type: 'trackedAssets',
	              id: newTrackedAsset.id
	            }
	          };
	        }).then(function (payload) {
	          var mainUrl = '' + ("https://api2.dyzio.co/v1");
	          var relUrl = mainUrl + '/discussions/' + discussionId + '/relationships/trackedAssets';
	          return _this.restClient.post(relUrl, payload);
	        }).then(function () {
	          asset.adding = false;
	          asset.platform = null;
	          var assetsDetails = _this.state.assetsDetails;
	
	          assetsDetails.push({
	            text: 'fetching data...',
	            state: 'FETCHING',
	            trackedAsset: trackedAsset.toJSON()
	          });
	          return _this.setState({
	            assetsDetails: assetsDetails
	          });
	        }).then(function () {
	          setTimeout(function () {
	            _this.loadAsset(trackedAsset.toJSON());
	          }, ASSET_API_TIMEOUT);
	          return { finished: true };
	        }).catch(function (err) {
	          console.log(err);
	          asset.errors.url = true;
	        });
	      }
	    };
	
	    _this.patchDiscussionTrackedAssets = function (patch, removedId) {
	      var discussionId = _this.props.discussion.get('id');
	      var mainUrl = '' + ("https://api2.dyzio.co/v1");
	      var relUrl = mainUrl + '/discussions/' + discussionId + '/relationships/trackedAssets';
	      _this.restClient.patch(relUrl, { data: patch }).then(function () {
	        var assetsDetails = _this.state.assetsDetails;
	
	        var updated = _lodash2.default.filter(assetsDetails, function (row) {
	          return row.trackedAsset.id !== removedId;
	        });
	        _this.setState({
	          assetsDetails: updated,
	          loading: false,
	          deleting: false
	        });
	      }).catch(function () {
	        _this.setState({
	          deleting: false, loading: false
	        });
	      });
	    };
	
	    _this.removeAsset = function (event, _ref7) {
	      var value = _ref7.value;
	
	      var id = value.trackedAsset.id;
	
	      var assetsDetails = _this.state.assetsDetails;
	
	
	      _this.setState({
	        deleting: true,
	        loading: true
	      });
	
	      if (assetsDetails) {
	        var updated = _lodash2.default.reject(assetsDetails, ['trackedAsset.id', id]);
	        var patch = _lodash2.default.map(updated, function (row) {
	          return {
	            id: row.trackedAsset.id,
	            type: 'trackedAssets'
	          };
	        });
	        _this.jsonClient.get('trackedAssets', id, function (err, asset) {
	          _this.patchDiscussionTrackedAssets(patch, id);
	          if (asset && !err) {
	            asset.delete(function (error) {
	              if (error) {
	                console.error(error);
	              }
	            });
	          }
	        });
	      }
	    };
	
	    _this.toggleSendInviteModal = function () {
	      var sendingInvite = _this.state.sendingInvite;
	      var _this$props3 = _this.props,
	          campaign = _this$props3.campaign,
	          influencer = _this$props3.influencer;
	
	      var _campaign$toJSON = campaign.toJSON(),
	          id = _campaign$toJSON.id;
	
	      var query = '?filter[campaign]=' + id + '&page[limit]=' + INFLUENCER_LIMIT;
	      var url = ("https://api2.dyzio.co/v1") + '/campaignInvitation' + query;
	
	      return _this.restClient.get(url).then(function (response) {
	        return response.data.data;
	      }).then(function (invitations) {
	        var modalInvitation = _lodash2.default.find(invitations, ['attributes.metadata.influencerId', influencer.id]);
	        if (modalInvitation) {
	          return _this.setState({
	            modalInvitation: modalInvitation,
	            sendingInvite: true,
	            sendingError: false,
	            invitationSent: true
	          });
	        }
	        return Promise.reject('could not find invitation');
	      });
	    };
	
	    _this.closeInviteModal = function () {
	      _this.setState({
	        modalInvitation: null,
	        sendingInvite: false,
	        sendingError: false,
	        inviteSentOK: false
	      });
	    };
	
	    _this.getUserIdFromInvitation = function (invitation) {
	      var user = invitation.relationships.user;
	
	      return user && user.data ? user.data.id : null;
	    };
	
	    _this.sendInviteToInfluencer = function () {
	      var modalInvitation = _this.state.modalInvitation;
	      var influencer = _this.props.influencer;
	
	      var userId = _this.getUserIdFromInvitation(modalInvitation);
	
	      if (userId) {
	        _this.patchUser({ influencer: influencer, userId: userId }).then(function () {
	          _this.patchCampaignInvitation({ modalInvitation: modalInvitation, influencer: influencer });
	        });
	      } else {
	        _this.patchCampaignInvitation({ modalInvitation: modalInvitation, influencer: influencer });
	      }
	    };
	
	    _this.patchUser = function (params) {
	      var influencer = params.influencer,
	          userId = params.userId;
	
	      var patch = {
	        data: {
	          type: 'users',
	          id: userId,
	          attributes: {
	            email: influencer.email
	          }
	        }
	      };
	      var url = ("https://api2.dyzio.co/v1") + '/users/' + userId;
	      return _this.restClient.patch(url, patch);
	    };
	
	    _this.patchCampaignInvitation = function (params) {
	      var modalInvitation = params.modalInvitation,
	          influencer = params.influencer;
	      var _this$props4 = _this.props,
	          name = _this$props4.userInfo.name,
	          organisation = _this$props4.organisation;
	
	
	      var patch = {
	        data: {
	          type: 'campaignInvitation',
	          id: modalInvitation.id,
	          attributes: {
	            status: 'SENT',
	            email: influencer.email,
	            sentBy: name,
	            sentDate: new Date(),
	            organisationName: organisation.name
	          }
	        }
	      };
	      var url = ("https://api2.dyzio.co/v1") + '/campaignInvitation/' + modalInvitation.id;
	      return _this.restClient.patch(url, patch).then(function () {
	        return _this.setState({
	          sendingError: false,
	          modalInvitation: null,
	          inviteSentOK: true
	        });
	      }).catch(function (error) {
	        return _this.setState({
	          updatingInvitationStatusError: error,
	          sendingInvite: false,
	          sendingError: false,
	          inviteSentOK: false,
	          modalInvitation: null
	        });
	      });
	    };
	
	    _this.toggleFeeModalState = function () {
	      _this.setState(function (prevState) {
	        return {
	          feeModalOpen: !prevState.feeModalOpen
	        };
	      });
	    };
	
	    _this.state = {
	      loading: true,
	      deleting: false,
	      sendingInvite: false,
	      feeModalOpen: false,
	      inviteSentOK: false,
	      modalInvitation: null,
	      invitationSent: false,
	      status: 'initial',
	      className: 'removable-initial',
	      addStoryVisible: false,
	      assetsDetails: [],
	      asset: {
	        adding: false,
	        platform: null,
	        url: null,
	        errors: {
	          url: false
	        }
	      },
	      shopifyLoading: true,
	      shopifyOrders: []
	    };
	
	    _this.jsonClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	      header: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    _this.restClient = _axios2.default.create({
	      timeout: 5000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(CollaborationCard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var discussion = this.props.discussion.toJSON();
	      var discussionId = this.props.discussion.get('id');
	      var channelURL = this.props.discussion.get('channelURL');
	      var userId = this.props.userData.get('id');
	
	      this.loadShopify(discussionId);
	
	      var trackedAssets = this.props.discussion.get('trackedAssets');
	
	      var trackedAssetsArray = trackedAssets.toJS();
	
	      var nonAnalyticsPlatforms = ['TIKTOK', 'SNAPCHAT', 'VK', 'BLOG'];
	
	      var trackedAssetsForAnalytics = _lodash2.default.reject(trackedAssetsArray, function (asset) {
	        return _lodash2.default.includes(nonAnalyticsPlatforms, asset.platform) || asset.fetchStatus === 'NOT_FOUND';
	      });
	      var trackedAssetsWithoutAnalytics = _lodash2.default.filter(trackedAssetsArray, function (asset) {
	        return _lodash2.default.includes(nonAnalyticsPlatforms, asset.platform);
	      });
	
	      console.log(trackedAssetsWithoutAnalytics);
	
	      // TODO need to pass in the real asset list here as well.
	      // The embedded trackedAsset cannot be trusted!!
	      var collabAssets = _lodash2.default.compact(_lodash2.default.concat(trackedAssetsForAnalytics));
	      if (collabAssets && collabAssets.length) {
	        (0, _trackedAssetsAnalyticsService.getTrackedAssetAnalytics)(collabAssets).then(function (response) {
	          var assetsDetails = _lodash2.default.map(response, function (row) {
	            var data = row.response.data;
	            if (!data || !data.trackedAsset) {
	              return {
	                trackedAsset: row,
	                withError: true
	              };
	            }
	            data.trackedAsset = _lodash2.default.find(collabAssets, { assetId: data.trackedAsset.assetId });
	            return data;
	          });
	          return _this3.setState({
	            assetsDetails: _lodash2.default.concat(trackedAssetsWithoutAnalytics, assetsDetails),
	            loading: false
	          });
	        }).catch(function (e) {
	          return (0, _errorHandlingService.reportError)('TRACKED_ASSET_ANALYTICS', e);
	        });
	      } else {
	        return this.setState({
	          loading: false
	        });
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      var _this4 = this;
	
	      this.setState({
	        className: 'removable-removing'
	      });
	
	      setTimeout(function () {
	        _this4.setState({ className: 'removable-removed' });
	      }, 1500);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props,
	          discussion = _props.discussion,
	          myUserRole = _props.myUserRole,
	          influencer = _props.influencer,
	          campaign = _props.campaign,
	          currency = _props.currency,
	          organisation = _props.organisation,
	          trackedAssetsCount = _props.trackedAssetsCount,
	          router = _props.router,
	          userInfo = _props.userInfo;
	
	
	      var stories = _lodash2.default.compact(discussion.get('stories').toJSON());
	      var isUserSuperAdmin = userInfo.isUserSuperAdmin;
	      var _state = this.state,
	          asset = _state.asset,
	          assetsDetails = _state.assetsDetails,
	          loading = _state.loading,
	          sendingInvite = _state.sendingInvite,
	          inviteSentOK = _state.inviteSentOK,
	          invitationSent = _state.invitationSent,
	          addStoryVisible = _state.addStoryVisible,
	          feeModalOpen = _state.feeModalOpen,
	          shopifyLoading = _state.shopifyLoading,
	          shopifyOrders = _state.shopifyOrders;
	
	
	      var DIVIDER = 'divider';
	      var REPORTING = 'REPORTING';
	
	      console.log('discussion', discussion.toJSON());
	
	      var invite = discussion.get('invitations').toJS()[0];
	      var discussionId = discussion.get('id');
	      var shopifyDiscountCode = discussion.get('discountCode');
	      var shopifyCommission = discussion.get('commission');
	      var invitationId = invite ? invite.id : null;
	      var campaignId = campaign.get('id');
	      var campaignName = campaign.get('name');
	      var campaignType = campaign.get('campaignType');
	      var hasShopifyData = !!shopifyDiscountCode;
	      var discussionName = discussion.get('name');
	
	      var isACR = campaignType === 'ACR';
	
	      var allDropdownOptions = [{
	        label: 'add facebook post',
	        icon: 'facebook',
	        value: 'facebook',
	        color: 'red',
	        onClick: this.toggleAddAssetPopup,
	        show: !isACR
	      }, {
	        label: 'add twitter post',
	        icon: 'twitter',
	        value: 'twitter',
	        onClick: this.toggleAddAssetPopup,
	        show: !isACR
	      }, {
	        label: 'add instagram post',
	        icon: 'instagram',
	        value: 'instagram',
	        onClick: this.toggleAddAssetPopup,
	        show: !isACR
	      }, {
	        label: 'add youtube video',
	        icon: 'youtube',
	        value: 'youtube',
	        onClick: this.toggleAddAssetPopup,
	        show: !isACR
	      }, {
	        label: 'add story',
	        icon: 'circle outline',
	        value: 'story',
	        onClick: this.toggleAddStoryModal,
	        show: !isACR
	      }, {
	        type: DIVIDER,
	        show: !isACR
	      }, {
	        label: 'set influencer fee',
	        icon: 'dollar',
	        value: 'fee',
	        onClick: this.toggleFeeModalState,
	        show: !isACR
	      }, {
	        type: DIVIDER,
	        show: !isACR
	      }, {
	        label: 'send invite',
	        icon: 'mail outline',
	        value: influencer.id,
	        onClick: this.toggleSendInviteModal,
	        disabled: !_lodash2.default.isString(influencer.email),
	        popupText: influencer.name + ' does not have an email address.\n        Update the influencer in My Influencers and try again.',
	        show: true
	      }, {
	        label: 'remove collaboration',
	        icon: 'remove circle outline',
	        onClick: function onClick() {
	          return _this5.removeCollaboration(discussionId, invitationId);
	        },
	        show: true
	      }];
	
	      var dropdownOptions = _lodash2.default.filter(allDropdownOptions, 'show');
	
	      var cardStyles = {
	        width: '98%',
	        margin: '20px auto'
	      };
	
	      var cardContent = {
	        paddingBottom: 11
	      };
	
	      var noPadding = {
	        padding: 0,
	        marginBottom: 0,
	        border: 0
	      };
	
	      var thumbnailStyles = {
	        height: '50px',
	        width: '50px'
	      };
	
	      var textStyles = {
	        color: '#000'
	      };
	
	      // eslint-disable-next-line max-len
	      var currentBrief = discussion.get('currentBrief') ? discussion.getIn(['documents', discussion.get('currentBrief')]) : null;
	      // eslint-disable-next-line max-len
	      var currentContract = discussion.get('currentContract') ? discussion.getIn(['documents', discussion.get('currentContract')]) : null;
	      // eslint-disable-next-line max-len
	      var signedContract = discussion.get('signedContract') ? discussion.getIn(['documents', discussion.get('signedContract')]) : null;
	
	      var deliverable = discussion.get('deliverables') || null;
	      var budget = discussion.get('budget');
	      var budgetStatus = discussion.get('budgetStatus');
	      var discussionType = discussion.get('discussionType');
	
	      var isUserTeamMember = isUserSuperAdmin || (0, _roleService.checkUserIsTeamMember)(myUserRole);
	      var unreadMessageCount = discussion.get('unreadMessageCount');
	      var influencerJoined = invite === undefined;
	      var derivedSent = invite ? invite.status === INVITATION_STATUS.sent || invitationSent : false;
	
	      var isEmailValid = _validator2.default.isEmail(influencer.email || '');
	
	      var getContent = function getContent(emailAddress, isEmailValid) {
	        if (isEmailValid) return influencer.email + ' is a valid email.';
	        return emailAddress ? influencer.email + ' is not a valid email.' : 'no email address in database';
	      };
	
	      var getCardExtra = function getCardExtra(joined) {
	        if (!influencer.email) {
	          return _react2.default.createElement(
	            'p',
	            { className: 'small' },
	            _react2.default.createElement(NoEmailComponent, { influencer: influencer })
	          );
	        }
	        if (joined) {
	          return _react2.default.createElement(
	            'p',
	            { className: 'small' },
	            _react2.default.createElement(InvitationJoinedComponent, { influencer: influencer })
	          );
	        }
	
	        return _react2.default.createElement(
	          'p',
	          { className: 'small' },
	          derivedSent ? _react2.default.createElement(InvitationSentComponent, { influencer: influencer }) : _react2.default.createElement(InvitationDeferredComponent, { influencer: influencer })
	        );
	      };
	
	      var isOverLimit = !organisation || trackedAssetsCount >= organisation.licenseTrackedAssetLimit;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.state.className },
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          {
	            fluid: true,
	            style: cardStyles,
	            color: discussionType === REPORTING ? 'pink' : 'grey'
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            { style: cardContent, verticalAlign: 'middle' },
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              { padded: 'horizontally' },
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                { verticalAlign: 'middle' },
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: isACR ? 6 : 4, style: noPadding },
	                  _react2.default.createElement(
	                    'div',
	                    { style: textStyles },
	                    _react2.default.createElement(_semanticUiReact.Image, {
	                      src: influencer.thumbnail,
	                      style: thumbnailStyles,
	                      floated: 'left', size: 'tiny', shape: 'circular'
	                    }),
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      influencer.name,
	                      '\xA0',
	                      _react2.default.createElement(_semanticUiReact.Popup, {
	                        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'mail', color: isEmailValid ? 'grey' : 'red' }),
	                        content: getContent(influencer.email, isEmailValid)
	                      }),
	                      '\xA0',
	                      _react2.default.createElement(_semanticUiReact.Popup, {
	                        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'briefcase', color: influencer.instagramBusinessAccount ? 'pink' : 'grey' }),
	                        content: (influencer.instagramBusinessAccount ? '' : 'NOT an ') + 'Instagram Business Account'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'small light' },
	                      discussion.get('name')
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 1 },
	                  unreadMessageCount > 0 && _react2.default.createElement(
	                    'div',
	                    { className: 'unread-message' },
	                    _react2.default.createElement('img', { src: '/icons/unread.svg', alt: 'Unread messages' }),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'small' },
	                      unreadMessageCount
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: isACR ? 8 : 6, style: noPadding },
	                  _react2.default.createElement(_socialTable2.default, { influencer: influencer })
	                ),
	                !isACR && _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 4, style: noPadding, textAlign: 'right' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'Fee:\xA0'
	                    ),
	                    _react2.default.createElement(_budgetReadonly2.default, {
	                      currency: currency,
	                      budget: budget,
	                      budgetStatus: budgetStatus,
	                      mode: ''
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 1, style: noPadding, verticalAlign: 'top', textAlign: 'right' },
	                  isUserTeamMember && _react2.default.createElement(
	                    _semanticUiReact.Dropdown,
	                    {
	                      icon: null,
	                      pointing: 'top right',
	                      floating: true,
	                      style: dropdownStyle,
	                      trigger: _react2.default.createElement(_semanticUiReact.Button, { icon: 'bars', color: 'pink' })
	                    },
	                    _react2.default.createElement(
	                      _semanticUiReact.Dropdown.Menu,
	                      null,
	                      _lodash2.default.map(dropdownOptions, function (opt) {
	                        if (opt.type === DIVIDER) {
	                          return _react2.default.createElement(_semanticUiReact.Dropdown.Divider, null);
	                        }
	
	                        if (opt.disabled && opt.popupText) {
	                          return _react2.default.createElement(_semanticUiReact.Popup, {
	                            trigger: _react2.default.createElement(
	                              _semanticUiReact.Dropdown.Item,
	                              {
	                                onClick: _lodash2.default.noop(),
	                                value: opt.value
	                              },
	                              _react2.default.createElement(_semanticUiReact.Icon, { name: opt.icon }),
	                              opt.label
	                            ),
	                            content: opt.popupText
	                          });
	                        }
	
	                        return _react2.default.createElement(
	                          _semanticUiReact.Dropdown.Item,
	                          {
	                            disabled: opt.disabled,
	                            onClick: opt.onClick,
	                            value: opt.value
	                          },
	                          _react2.default.createElement(_semanticUiReact.Icon, { name: opt.icon }),
	                          opt.label
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          (assetsDetails && assetsDetails.length > 0 || stories && stories.length > 0) && !isACR && _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            { extra: true, style: noPadding },
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { basic: true, loading: loading, style: { padding: 10 } },
	              _react2.default.createElement(_assetTable2.default, {
	                campaignName: campaignName,
	                stories: stories,
	                influencer: influencer,
	                assets: assetsDetails,
	                deleteAssetHandler: this.removeAsset,
	                campaignType: campaignType
	              })
	            )
	          ),
	          isACR && _react2.default.createElement(_acrDemographicsWrapper2.default, {
	            campaign: campaign.toJSON(),
	            influencer: influencer,
	            userInfo: userInfo
	          }),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            { extra: true, textAlign: 'center' },
	            getCardExtra(influencerJoined)
	          )
	        ),
	        hasShopifyData && shopifyDiscountCode && SHOW_SHOPIFY && _react2.default.createElement(
	          _semanticUiReact.Card,
	          {
	            fluid: true,
	            style: cardStyles
	          },
	          _react2.default.createElement(_shopifyConfig2.default, {
	            discountCode: shopifyDiscountCode,
	            commission: shopifyCommission,
	            editable: false
	          })
	        ),
	        !shopifyLoading && hasShopifyData && SHOW_SHOPIFY && _react2.default.createElement(
	          _semanticUiReact.Card,
	          {
	            fluid: true,
	            style: cardStyles
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              { columns: '2' },
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { verticalAlign: 'middle' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    _react2.default.createElement('img', {
	                      src: '/icons/shopify.svg',
	                      alt: 'Shopify'
	                    }),
	                    ' Shopify Total Sales'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data will appear in the table below, once the Shopify code or URL have been used by one of your customers.'
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null)
	            ),
	            _react2.default.createElement(_shopifyTable2.default, {
	              orders: shopifyOrders
	            })
	          )
	        ),
	        asset.adding && _react2.default.createElement(_addAssetForm2.default, {
	          isOverLimit: isOverLimit,
	          isOpen: asset.adding,
	          platform: asset.platform,
	          errors: asset.errors,
	          popupToggleHandler: this.toggleAddAssetPopup,
	          addAssetHandler: this.assetFormSubmitHandler
	        }),
	        sendingInvite && _react2.default.createElement(_inviteModal2.default, {
	          thumbnail: influencer.thumbnail,
	          closeHandler: this.closeInviteModal,
	          sendHandler: this.sendInviteToInfluencer,
	          email: influencer.email,
	          inviteSentOK: inviteSentOK
	        }),
	        feeModalOpen && _react2.default.createElement(_influencerFeeModal2.default, {
	          influencer: influencer,
	          currency: currency,
	          budget: budget,
	          onClose: this.toggleFeeModalState,
	          onSubmit: this.onNewFeeSubmit
	        }),
	        addStoryVisible && _react2.default.createElement(_addStoryModal2.default, {
	          popupToggleHandler: this.toggleAddStoryModal,
	          successHandler: this.addStory,
	          campaignId: campaignId,
	          discussionId: discussionId,
	          discussionName: discussionName
	        })
	      );
	    }
	  }]);
	
	  return CollaborationCard;
	}(_react2.default.Component);
	
	CollaborationCard.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    campaign: state.campaign.get('campaign'),
	    members: state.members.get('members'),
	    userData: state.userData.get('userData'),
	    myUserRole: state.campaign.get('myUserRole')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    // onSetUnreadMessageCount: (discussionId, unreadMessageCount) =>
	    //   dispatch(setUnreadMessageCount(discussionId, unreadMessageCount)),
	    dispatch: dispatch
	  };
	}
	
	CollaborationCard.propTypes = {
	  discussion: _propTypes2.default.object.isRequired,
	  userData: _propTypes2.default.object.isRequired,
	  organisation: _propTypes2.default.object.isRequired,
	  trackedAssetsCount: _propTypes2.default.number.isRequired,
	  myUserRole: _propTypes2.default.string.isRequired,
	  influencer: _propTypes2.default.object.isRequired,
	  restClient: _propTypes2.default.func.isRequired,
	  userInfo: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(CollaborationCard);

/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _recompose = __webpack_require__(15);
	
	var _reactRouter = __webpack_require__(37);
	
	var _reactRedux = __webpack_require__(28);
	
	var _validator = __webpack_require__(84);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _authService = __webpack_require__(21);
	
	var _hasShopify = __webpack_require__(925);
	
	var _hasPrestaShop = __webpack_require__(2251);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _actions = __webpack_require__(557);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _withTrackedAssetsData = __webpack_require__(2250);
	
	var _withTrackedAssetsData2 = _interopRequireDefault(_withTrackedAssetsData);
	
	var _verticalInfluencerBar = __webpack_require__(900);
	
	var _verticalInfluencerBar2 = _interopRequireDefault(_verticalInfluencerBar);
	
	var _roleService = __webpack_require__(143);
	
	var _trackedAssetsAnalyticsService = __webpack_require__(173);
	
	var _addAssetForm = __webpack_require__(276);
	
	var _addAssetForm2 = _interopRequireDefault(_addAssetForm);
	
	var _assetTable = __webpack_require__(537);
	
	var _assetTable2 = _interopRequireDefault(_assetTable);
	
	var _shopifyTable = __webpack_require__(893);
	
	var _shopifyTable2 = _interopRequireDefault(_shopifyTable);
	
	var _deleteInfluencerModal = __webpack_require__(1932);
	
	var _deleteInfluencerModal2 = _interopRequireDefault(_deleteInfluencerModal);
	
	var _inviteModal = __webpack_require__(884);
	
	var _inviteModal2 = _interopRequireDefault(_inviteModal);
	
	var _addStoryModal = __webpack_require__(536);
	
	var _addStoryModal2 = _interopRequireDefault(_addStoryModal);
	
	var _sendLimitsExceededNotifcation = __webpack_require__(365);
	
	var _sendLimitsExceededNotifcation2 = _interopRequireDefault(_sendLimitsExceededNotifcation);
	
	var _invitationStatus = __webpack_require__(1992);
	
	var _invitationStatus2 = _interopRequireDefault(_invitationStatus);
	
	var _collaborationBudget = __webpack_require__(1915);
	
	var _collaborationBudget2 = _interopRequireDefault(_collaborationBudget);
	
	var _collaborationEmail = __webpack_require__(1916);
	
	var _collaborationEmail2 = _interopRequireDefault(_collaborationEmail);
	
	var _blockedInvitationStatus = __webpack_require__(1893);
	
	var _blockedInvitationStatus2 = _interopRequireDefault(_blockedInvitationStatus);
	
	var _linkTracking = __webpack_require__(1994);
	
	var _linkTracking2 = _interopRequireDefault(_linkTracking);
	
	var _shopifyConfig = __webpack_require__(892);
	
	var _shopifyConfig2 = _interopRequireDefault(_shopifyConfig);
	
	var _prestaShopConfig = __webpack_require__(2015);
	
	var _prestaShopConfig2 = _interopRequireDefault(_prestaShopConfig);
	
	var _prestaShopTable = __webpack_require__(2016);
	
	var _prestaShopTable2 = _interopRequireDefault(_prestaShopTable);
	
	var _storyPickerModal = __webpack_require__(2208);
	
	var _storyPickerModal2 = _interopRequireDefault(_storyPickerModal);
	
	var _scanHistoryModal = __webpack_require__(2021);
	
	var _scanHistoryModal2 = _interopRequireDefault(_scanHistoryModal);
	
	var _scanNowModal = __webpack_require__(2022);
	
	var _scanNowModal2 = _interopRequireDefault(_scanNowModal);
	
	var _rollForwardModal = __webpack_require__(2020);
	
	var _rollForwardModal2 = _interopRequireDefault(_rollForwardModal);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var currentTheme = _themeSelector2.default.theme();
	
	var ENFORCE_LIMITS = false;
	var INFLUENCER_LIMIT = 200;
	
	var WAIT_FOR = 2000;
	var ASSET_API_TIMEOUT = 3500;
	
	var tiktokIconStyle = {
	  width: 15,
	  marginTop: 2
	};
	
	var loadingAssetsCardStyle = {
	  padding: '120px 0',
	  color: 'gray'
	};
	
	var backButtonStyle = {
	  border: '0px solid #1d1937'
	};
	
	var buttonStyles = {
	  width: 'auto'
	};
	
	var smallPrint = {
	  'font-size': '0.75em'
	};
	
	var assetInitialState = {
	  adding: false,
	  platform: null,
	  url: null,
	  errors: {
	    url: false
	  }
	};
	
	var Collaboration = function (_React$Component) {
	  _inherits(Collaboration, _React$Component);
	
	  function Collaboration(props) {
	    _classCallCheck(this, Collaboration);
	
	    var _this = _possibleConstructorReturn(this, (Collaboration.__proto__ || Object.getPrototypeOf(Collaboration)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var rollfwdCampaign = _lodash2.default.get(props, 'location.state.rollfwdCampaign', null);
	
	    var rollForwardModal = void 0;
	    if (rollfwdCampaign) {
	      rollForwardModal = {
	        visible: false,
	        selected: {
	          id: rollfwdCampaign.id,
	          title: rollfwdCampaign.name
	        },
	        options: [],
	        isSearching: false,
	        searched: false
	      };
	    } else {
	      rollForwardModal = {
	        visible: false,
	        selected: null,
	        options: [],
	        isSearching: false,
	        searched: false
	      };
	    }
	
	    _this.state = {
	      isLoadingLiveStoriesCount: true,
	      liveStoriesCount: 0,
	      isLoadingCollaboration: true,
	      collaboration: null,
	      notes: null,
	      isLoadingAssets: true,
	      isDeletingInfluencer: false,
	      deleting: false,
	      sendingInvite: false,
	      feeModalOpen: false,
	      inviteSentOK: false,
	      viewLiveStoriesModalOpen: false,
	      modalInvitation: null,
	      invitationSent: false,
	      status: 'initial',
	      localInvitatinStatus: null,
	      addStoryVisible: false,
	      assetsDetails: [],
	      asset: _lodash2.default.clone(assetInitialState),
	      requiresCampaignReload: false,
	      newEmail: null,
	      temporaryAsset: null,
	      isAddingStoryToCollab: false,
	      scanHistoryModalOpen: false,
	      scanNowModalOpen: false,
	      rollForwardModalOpen: false,
	      hasRolledForward: false,
	      nextDiscussionId: null,
	      previousDiscussionId: null,
	      isRolling: false,
	      rollForwardModal: rollForwardModal,
	      shopifyOrders: [],
	      prestaSHopOrders: [],
	      shopifyLoading: true,
	      isClientDiscussion: false,
	      isScanningCompleted: false,
	      createDiscountDisabled: false,
	      createDiscountLoading: false,
	      newShortLink: null
	    };
	    return _this;
	  }
	
	  _createClass(Collaboration, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var influencer = _lodash2.default.get(this.props, 'location.state.influencer', null);
	      var invitationStatus = _lodash2.default.get(this.props, 'location.state.invitationStatus', null);
	      var rollfwdCampaign = _lodash2.default.get(this.props, 'location.state.rollfwdCampaign', null);
	      var _props = this.props,
	          campaign = _props.campaign,
	          _props$userInfo = _props.userInfo,
	          role = _props$userInfo.role,
	          isUserSuperAdmin = _props$userInfo.isUserSuperAdmin,
	          organisationId = _props$userInfo.organisationId,
	          isDyzioUser = _props$userInfo.isDyzioUser,
	          collabId = _props.params.collabId;
	      var _state = this.state,
	          isLoadingCollaboration = _state.isLoadingCollaboration,
	          collaboration = _state.collaboration,
	          fullInfluencer = _state.influencer,
	          assetsDetails = _state.assetsDetails,
	          isLoadingAssets = _state.isLoadingAssets,
	          asset = _state.asset,
	          addStoryVisible = _state.addStoryVisible,
	          sendingInvite = _state.sendingInvite,
	          inviteSentOK = _state.inviteSentOK,
	          isDeletingInfluencer = _state.isDeletingInfluencer,
	          localInvitatinStatus = _state.localInvitatinStatus,
	          newEmail = _state.newEmail,
	          viewLiveStoriesModalOpen = _state.viewLiveStoriesModalOpen,
	          isAddingStoryToCollab = _state.isAddingStoryToCollab,
	          isLoadingLiveStoriesCount = _state.isLoadingLiveStoriesCount,
	          liveStoriesCount = _state.liveStoriesCount,
	          scanHistoryModalOpen = _state.scanHistoryModalOpen,
	          scanNowModalOpen = _state.scanNowModalOpen,
	          rollForwardModalOpen = _state.rollForwardModalOpen,
	          rollForwardModal = _state.rollForwardModal,
	          hideAssetTable = _state.hideAssetTable,
	          hideShopifyTable = _state.hideShopifyTable,
	          shopifyOrders = _state.shopifyOrders,
	          prestaSHopOrders = _state.prestaSHopOrders,
	          shopifyLoading = _state.shopifyLoading,
	          isClientDiscussion = _state.isClientDiscussion,
	          isScanningCompleted = _state.isScanningCompleted,
	          hasRolledForward = _state.hasRolledForward,
	          nextDiscussionId = _state.nextDiscussionId,
	          previousDiscussionId = _state.previousDiscussionId,
	          isRolling = _state.isRolling,
	          createDiscountDisabled = _state.createDiscountDisabled,
	          createDiscountLoading = _state.createDiscountLoading,
	          newShortLink = _state.newShortLink;
	
	      var isOverLimit = false;
	      var campaignId = campaign.get('id');
	      var campaignName = campaign.get('name');
	      var campaignType = campaign.get('campaignType');
	      var baseTrackingUrl = campaign.get('baseTrackingUrl');
	      var hasBaseTrackingUrl = !_lodash2.default.isEmpty(baseTrackingUrl);
	      var campaignCurrency = campaign.get('currency');
	      var hashtags = campaign.get('hashtags');
	      var campaignStart = campaign.get('liveDate');
	      var campaignEnd = campaign.get('endDate');
	      var isACR = campaign.get('campaignType') === 'ACR';
	      var premiumFeaturesBlocked = campaign.get('premiumFeaturesBlocked');
	      var isShopifyCampaign = campaign.get('isShopifyCampaign');
	      var isPrestaShopCampaign = campaign.get('isPrestaShopCampaign');
	
	      console.log('isShopifyCampaign', isShopifyCampaign);
	
	      var linkTrackingProps = {
	        campaignId: campaignId,
	        campaignName: campaignName,
	        hashtags: hashtags,
	        baseTrackingUrl: baseTrackingUrl,
	        instagram: _lodash2.default.get(fullInfluencer, 'instagram', null)
	      };
	
	      var isUserTeamMember = isUserSuperAdmin || (0, _roleService.checkUserIsTeamMember)(role);
	
	      var stories = _lodash2.default.get(collaboration, 'stories', []);
	      var lastScannedDate = _lodash2.default.get(collaboration, 'lastScannedDate', null);
	      var internalDiscountCode = _lodash2.default.get(collaboration, 'internalDiscountCode', null);
	      var productOrderedDate = _lodash2.default.get(collaboration, 'productOrderedDate', null);
	      var shortDiscountLink = _lodash2.default.get(collaboration, 'shortDiscountLink', null);
	      var workflowStatus = _lodash2.default.get(collaboration, 'workflowStatus', null);
	      var internalOrders = _lodash2.default.get(collaboration, 'internalOrders', null);
	      var lastSuccessfulStoryScan = _lodash2.default.get(collaboration, 'lastSuccessfulStoryScan', null);
	      var collaborationId = _lodash2.default.get(collaboration, 'id');
	      var bioLinkUrl = _lodash2.default.get(collaboration, 'bioLinkUrl');
	
	      var order = _lodash2.default.head(internalOrders);
	
	      var orderDate = void 0;
	
	      if (order && order.created_at) {
	        orderDate = (0, _moment2.default)(order.created_at).format('YYYY-MM-DD');
	      } else if (productOrderedDate) {
	        orderDate = (0, _moment2.default)(productOrderedDate).format('YYYY-MM-DD');
	      }
	
	      var DIVIDER = 'divider';
	      var allDropdownOptions = [{
	        label: 'add facebook post',
	        icon: 'facebook',
	        value: 'facebook',
	        color: 'red',
	        onClick: this.toggleAddAssetPopup,
	        show: !isACR
	      }, {
	        label: 'add twitter post',
	        icon: 'twitter',
	        value: 'twitter',
	        onClick: this.toggleAddAssetPopup,
	        show: !isACR
	      }, {
	        label: 'add instagram post',
	        icon: 'instagram',
	        value: 'instagram',
	        onClick: this.toggleAddAssetPopup,
	        show: !isACR
	      }, {
	        label: 'add youtube video',
	        icon: 'youtube play',
	        value: 'youtube',
	        onClick: this.toggleAddAssetPopup,
	        show: !isACR
	      }, {
	        label: 'add tiktok video',
	        icon: 'tiktok',
	        value: 'tiktok',
	        onClick: this.toggleAddAssetPopup,
	        show: !isACR
	      }, {
	        label: 'add telegram post',
	        icon: 'telegram plane',
	        value: 'telegram',
	        onClick: this.toggleAddAssetPopup,
	        show: !isACR
	      }, {
	        label: 'add other posts & stories',
	        icon: 'circle outline',
	        value: 'story',
	        onClick: this.toggleAddStoryModal,
	        show: !isACR
	      }, {
	        label: 'view live stories',
	        icon: 'eye outline',
	        value: 'live-stories',
	        onClick: this.toggleViewLiveStoriesModal,
	        show: !isACR
	      }, {
	        label: 'view scan history',
	        icon: 'list',
	        value: 'scan-history',
	        onClick: this.toggleScanHistoryModal,
	        show: !isACR
	      }, {
	        label: 'ADMIN: mark authorised',
	        icon: 'user secret',
	        value: 'mark-authorised',
	        onClick: this.markAuthorised,
	        show: isDyzioUser
	      }, {
	        label: 'SCAN NOW!',
	        icon: 'lightning',
	        value: 'scan-now',
	        onClick: this.scanNow,
	        show: !isACR
	      }, {
	        label: 'capture all live stories',
	        icon: 'circle',
	        value: 'capture-all-stories',
	        onClick: this.captureAllStories,
	        show: !isACR
	      }];
	
	      var dropdownOptions = _lodash2.default.filter(allDropdownOptions, 'show');
	
	      var budgetProps = isLoadingCollaboration ? { budget: 0 } : {
	        budget: collaboration.budget,
	        discussionId: collaboration.id,
	        saveNewBudget: this.onNewFeeSubmit,
	        campaignCurrency: campaignCurrency
	      };
	
	      var shopifyProps = isLoadingCollaboration ? { discountCode: null, commission: 0 } : {
	        discountCode: _lodash2.default.get(collaboration, 'discountCode', null),
	        commission: _lodash2.default.get(collaboration, 'commission', 0),
	        editable: true,
	        saveShopifySetting: this.onShopifySubmit,
	        savePrestaShopSetting: this.onShopifySubmit,
	        reloadShopifyOrders: this.loadShopify,
	        reloadPrestaShopOrders: this.loadShopify
	      };
	
	      var emailProps = isLoadingCollaboration ? { email: '' } : {
	        email: fullInfluencer.email,
	        saveNewEmail: this.onNewEmailSubmit
	      };
	
	      var toggleAssetTable = function toggleAssetTable() {
	        _this2.setState({
	          hideAssetTable: !hideAssetTable
	        });
	      };
	
	      var toggleShopifyTable = function toggleShopifyTable() {
	        _this2.setState({
	          hideShopifyTable: !hideShopifyTable
	        });
	      };
	
	      var emailToTest = newEmail || _lodash2.default.get(fullInfluencer, 'email', '');
	      var isEmailValid = _validator2.default.isEmail(emailToTest);
	
	      var instagramId = _lodash2.default.get(fullInfluencer, 'instagramId', '');
	      var existingStoriesIDs = _lodash2.default.map(stories, 'assetId');
	
	      var isNTW = organisationId === 'fbc5c905-2084-40dd-b966-7e127db073c8';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: '4' },
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(_dyzioButtons.DyzioSecondaryButton, {
	                    label: 'back to campaign',
	                    icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'arrow left' }),
	                    style: backButtonStyle,
	                    hasIcon: true,
	                    onClick: this.returnToCampaign,
	                    fluid: true
	                  })
	                )
	              ),
	              _react2.default.createElement(_verticalInfluencerBar2.default, Object.assign({}, influencer, fullInfluencer, {
	                isLoading: isLoadingCollaboration,
	                isLoadingLiveStoriesCount: isLoadingLiveStoriesCount,
	                liveStoriesCount: liveStoriesCount,
	                onLiveStoriesLabelClick: this.toggleViewLiveStoriesModal
	              })),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { textAlign: 'center' },
	                  _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	                    label: nextDiscussionId || hasRolledForward ? 'already rolled' : 'Roll Forward',
	                    icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'arrow alternate circle right' }),
	                    style: backButtonStyle,
	                    hasIcon: true,
	                    onClick: this.toggleRollForwardModal,
	                    fluid: true,
	                    disabled: nextDiscussionId || hasRolledForward
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { extra: true, textAlign: 'center' },
	                  _react2.default.createElement(
	                    'p',
	                    { style: smallPrint },
	                    'Roll the Influencer forward',
	                    _react2.default.createElement('br', null),
	                    'into the next campaign.'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { extra: true, textAlign: 'center' },
	                  _react2.default.createElement(
	                    'p',
	                    { style: smallPrint },
	                    'This Influencer was ' + (previousDiscussionId ? 'ROLLED FORWARD' : 'ADDED MANUALLY')
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { textAlign: 'center' },
	                  _react2.default.createElement(_semanticUiReact.Radio, {
	                    toggle: true,
	                    label: 'is Completed?',
	                    name: 'isScanningCompleted',
	                    value: isScanningCompleted,
	                    checked: isScanningCompleted,
	                    onChange: this.toggleIsScanningCompleted
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { extra: true, textAlign: 'center' },
	                  _react2.default.createElement(
	                    'p',
	                    { style: smallPrint },
	                    'Checking this option will stop the system',
	                    _react2.default.createElement('br', null),
	                    'from scanning this influencer.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { textAlign: 'center' },
	                  _react2.default.createElement(_semanticUiReact.Radio, {
	                    toggle: true,
	                    label: 'is Client Discussion',
	                    name: 'isClientDiscussion',
	                    value: isClientDiscussion,
	                    checked: isClientDiscussion,
	                    onChange: this.toggleIsClientDiscussion
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { extra: true, textAlign: 'center' },
	                  _react2.default.createElement(
	                    'p',
	                    { style: smallPrint },
	                    'Checking this option will exclude assets from this disccusion from the reports.'
	                  )
	                )
	              ),
	              !isLoadingCollaboration && _react2.default.createElement(_collaborationEmail2.default, emailProps),
	              premiumFeaturesBlocked && _react2.default.createElement(_blockedInvitationStatus2.default, null),
	              !premiumFeaturesBlocked && _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Invitation Status'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { textAlign: 'center' },
	                  isEmailValid ? _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	                    label: 'Send Invitation',
	                    icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'mail outine' }),
	                    style: backButtonStyle,
	                    hasIcon: true,
	                    onClick: this.toggleSendInviteModal,
	                    fluid: true
	                  }) : _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { basic: true, color: 'red' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'red' }),
	                    'set email above'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { textAlign: 'center' },
	                  _react2.default.createElement(_invitationStatus2.default, { status: localInvitatinStatus || invitationStatus })
	                )
	              ),
	              !isLoadingCollaboration && _react2.default.createElement(_collaborationBudget2.default, budgetProps),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Remove Influencer'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(_dyzioButtons.DyzioDeleteButton, {
	                    fluid: true,
	                    onClick: this.toggleInfluencerDeleteModal
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: '12', style: { paddingLeft: 0 } },
	              hasBaseTrackingUrl && _react2.default.createElement(_linkTracking2.default, linkTrackingProps),
	              !isLoadingCollaboration && isShopifyCampaign && organisationId !== 'b847c281-d377-4528-a416-303234e382d8' && _react2.default.createElement(_shopifyConfig2.default, shopifyProps),
	              !isLoadingCollaboration && isPrestaShopCampaign && _react2.default.createElement(_prestaShopConfig2.default, shopifyProps),
	              !isLoadingCollaboration && isShopifyCampaign && _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid,
	                    { columns: '2' },
	                    _react2.default.createElement(
	                      _semanticUiReact.Grid.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { verticalAlign: 'middle' },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _react2.default.createElement('img', {
	                            src: '/icons/shopify.svg',
	                            alt: 'Shopify'
	                          }),
	                          ' Shopify Total Sales'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { textAlign: 'right' },
	                        hideShopifyTable ? _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'chevron down', onClick: toggleShopifyTable, style: buttonStyles }) : _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'chevron up', onClick: toggleShopifyTable, style: buttonStyles })
	                      )
	                    )
	                  )
	                ),
	                !isLoadingCollaboration && !hideShopifyTable && !shopifyLoading && _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Data will appear in the table below, once the Shopify code or URL have been used by one of your customers.'
	                    ),
	                    _react2.default.createElement(_semanticUiReact.Divider, null)
	                  ),
	                  _react2.default.createElement(_shopifyTable2.default, {
	                    orders: shopifyOrders,
	                    hasDiscountCodes: !!_lodash2.default.get(collaboration, 'discountCode') || _lodash2.default.get(fullInfluencer, 'discountCodes')
	                  })
	                ),
	                shopifyLoading && _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { textAlign: 'center', style: loadingAssetsCardStyle },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', loading: true, size: 'huge' }),
	                  _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                  'Loading Shopify Orders'
	                )
	              ),
	              !isLoadingCollaboration && isPrestaShopCampaign && _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid,
	                    { columns: '2' },
	                    _react2.default.createElement(
	                      _semanticUiReact.Grid.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { verticalAlign: 'middle' },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          _react2.default.createElement('img', {
	                            src: '/icons/prestashop.svg',
	                            alt: 'PrestaShop'
	                          }),
	                          ' PrestaShop Total Sales'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { textAlign: 'right' },
	                        hideShopifyTable ? _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'chevron down', onClick: toggleShopifyTable, style: buttonStyles }) : _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'chevron up', onClick: toggleShopifyTable, style: buttonStyles })
	                      )
	                    )
	                  )
	                ),
	                !isLoadingCollaboration && !hideShopifyTable && !shopifyLoading && isPrestaShopCampaign && _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Data will appear in the table below, once the PrestaShop code or URL have been used by one of your customers.'
	                    ),
	                    _react2.default.createElement(_semanticUiReact.Divider, null)
	                  ),
	                  _react2.default.createElement(_prestaShopTable2.default, {
	                    orders: prestaSHopOrders,
	                    hasDiscountCodes: !!_lodash2.default.get(collaboration, 'discountCode') || _lodash2.default.get(fullInfluencer, 'discountCodes')
	                  })
	                ),
	                shopifyLoading && isPrestaShopCampaign && _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { textAlign: 'center', style: loadingAssetsCardStyle },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', loading: true, size: 'huge' }),
	                  _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                  'Loading PrestaShop Orders'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                !isACR && !isLoadingAssets && isUserTeamMember && _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid,
	                    { columns: '3' },
	                    _react2.default.createElement(
	                      _semanticUiReact.Grid.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { verticalAlign: 'middle' },
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          'Campaign posts'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: '80%', color: 'grey' } },
	                          'last GRID scan: ',
	                          lastScannedDate ? (0, _moment2.default)(lastScannedDate).fromNow() : 'not scanned yet',
	                          '\xA0',
	                          _react2.default.createElement(
	                            'a',
	                            {
	                              rel: 'noopener noreferrer',
	                              href: currentTheme.shareSite + '/collab/' + collaborationId + '/campaign',
	                              target: '_blank'
	                            },
	                            'open collaboration report...'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: '80%', color: 'grey' } },
	                          'last STORY scan: ',
	                          lastSuccessfulStoryScan ? (0, _moment2.default)(lastSuccessfulStoryScan).fromNow() : 'not scanned yet'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { style: { textAlign: 'center' } },
	                        _react2.default.createElement(_semanticUiReact.Popup, {
	                          content: 'This will force the system to scan all platforms NOW for any live content that matches the search criteria.',
	                          trigger: _react2.default.createElement(
	                            _semanticUiReact.Button,
	                            {
	                              onClick: this.scanNow,
	                              inverted: true, color: 'blue',
	                              icon: true,
	                              labelPosition: 'left'
	
	                            },
	                            _react2.default.createElement(_semanticUiReact.Icon, { name: 'binoculars' }),
	                            'SCAN NOW'
	                          )
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { textAlign: 'right' },
	                        _react2.default.createElement(
	                          _semanticUiReact.Dropdown,
	                          {
	                            icon: null,
	                            pointing: 'top right',
	                            floating: true,
	                            trigger: _react2.default.createElement(
	                              _semanticUiReact.Button,
	                              {
	                                inverted: true,
	                                color: 'pink',
	                                icon: true,
	                                labelPosition: 'left'
	                              },
	                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' }),
	                              'Add post'
	                            )
	                          },
	                          _react2.default.createElement(
	                            _semanticUiReact.Dropdown.Menu,
	                            null,
	                            _lodash2.default.map(dropdownOptions, function (opt) {
	                              if (opt.type === DIVIDER) {
	                                return _react2.default.createElement(_semanticUiReact.Dropdown.Divider, null);
	                              }
	
	                              if (opt.disabled && opt.popupText) {
	                                return _react2.default.createElement(_semanticUiReact.Popup, {
	                                  trigger: _react2.default.createElement(
	                                    _semanticUiReact.Dropdown.Item,
	                                    {
	                                      onClick: _lodash2.default.noop(),
	                                      value: opt.value
	                                    },
	                                    _react2.default.createElement(_semanticUiReact.Icon, { name: opt.icon }),
	                                    opt.label
	                                  ),
	                                  content: opt.popupText
	                                });
	                              }
	
	                              return _react2.default.createElement(
	                                _semanticUiReact.Dropdown.Item,
	                                {
	                                  disabled: opt.disabled,
	                                  onClick: opt.onClick,
	                                  value: opt.value
	                                },
	                                opt.icon === 'tiktok' && _react2.default.createElement('img', { style: tiktokIconStyle, src: 'https://app.dyzio.co/logos/tiktok-logo.svg', alt: 'Tiktok' }),
	                                opt.icon !== 'tiktok' && _react2.default.createElement(_semanticUiReact.Icon, { name: opt.icon }),
	                                opt.label
	                              );
	                            })
	                          )
	                        ),
	                        hideAssetTable ? _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'chevron down', onClick: toggleAssetTable, style: buttonStyles }) : _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'chevron up', onClick: toggleAssetTable, style: buttonStyles })
	                      )
	                    ),
	                    internalDiscountCode && _react2.default.createElement(
	                      _semanticUiReact.Grid.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { verticalAlign: 'middle' },
	                        _react2.default.createElement(
	                          'h4',
	                          null,
	                          'Discount Code ',
	                          _react2.default.createElement(
	                            _semanticUiReact.Label,
	                            null,
	                            internalDiscountCode
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { textAlign: 'center' },
	                        workflowStatus && _react2.default.createElement(
	                          _semanticUiReact.Label,
	                          { basic: true, color: 'pink' },
	                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle outline' }),
	                          workflowStatus
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { verticalAlign: 'right' },
	                        order && _react2.default.createElement(
	                          _semanticUiReact.Label,
	                          { basic: true },
	                          _lodash2.default.head(order.line_items).title,
	                          _react2.default.createElement('br', null),
	                          _react2.default.createElement(
	                            'span',
	                            { style: { color: 'grey' } },
	                            'order date: ',
	                            orderDate || 'UNKNOWN'
	                          )
	                        )
	                      )
	                    ),
	                    bioLinkUrl && _react2.default.createElement(
	                      _semanticUiReact.Grid.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { verticalAlign: 'middle', width: 12 },
	                        _react2.default.createElement(
	                          'h4',
	                          null,
	                          'Bio Link URL ',
	                          _react2.default.createElement(
	                            _semanticUiReact.Label,
	                            null,
	                            bioLinkUrl
	                          ),
	                          '\xA0',
	                          _react2.default.createElement(_semanticUiReact.Popup, {
	                            trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                              circular: true,
	                              icon: 'copy',
	                              onClick: function onClick() {
	                                navigator.clipboard.writeText(bioLinkUrl);
	                              }
	                            }), content: 'Copy Bio Link URL to clipboard'
	                          })
	                        )
	                      )
	                    ),
	                    isNTW && internalDiscountCode && _react2.default.createElement(
	                      _semanticUiReact.Grid.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { verticalAlign: 'middle' },
	                        newShortLink || shortDiscountLink ? _react2.default.createElement(
	                          'h4',
	                          null,
	                          'LINK ',
	                          _react2.default.createElement(
	                            _semanticUiReact.Label,
	                            { color: 'blue' },
	                            newShortLink || shortDiscountLink
	                          ),
	                          '\xA0',
	                          _react2.default.createElement(_semanticUiReact.Popup, {
	                            trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                              circular: true,
	                              icon: 'copy',
	                              onClick: function onClick() {
	                                navigator.clipboard.writeText(newShortLink || shortDiscountLink);
	                              }
	                            }), content: 'Copy link to clipboard'
	                          })
	                        ) : _react2.default.createElement(
	                          _semanticUiReact.Button,
	                          {
	                            onClick: this.createDiscountLink,
	                            disable: createDiscountDisabled,
	                            loading: createDiscountLoading
	                          },
	                          'Create Discount Link'
	                        )
	                      ),
	                      _react2.default.createElement(_semanticUiReact.Grid.Column, { textAlign: 'center' }),
	                      _react2.default.createElement(
	                        _semanticUiReact.Grid.Column,
	                        { verticalAlign: 'right' },
	                        '\xA0'
	                      )
	                    )
	                  )
	                ),
	                !isACR && isLoadingAssets && !hideAssetTable && _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { textAlign: 'center', style: loadingAssetsCardStyle },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', loading: true, size: 'huge' }),
	                  _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                  'Loading assets'
	                ),
	                !isACR && !isLoadingAssets && !hideAssetTable && _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(_assetTable2.default, _defineProperty({
	                    toggleAssetLocalState: this.toggleAssetLocalState,
	                    campaignName: campaignName,
	                    hashtags: hashtags,
	                    stories: stories,
	                    influencer: fullInfluencer,
	                    assets: assetsDetails,
	                    deleteAssetHandler: this.removeAsset,
	                    campaignType: campaignType,
	                    deleteStoryHandler: this.removeStory
	                  }, 'hashtags', campaign && campaign.get('hashtags') || []))
	                )
	              )
	            )
	          )
	        ),
	        asset.adding && _react2.default.createElement(_addAssetForm2.default, {
	          isOverLimit: isOverLimit,
	          isOpen: asset.adding,
	          platform: asset.platform,
	          errors: asset.errors,
	          popupToggleHandler: this.toggleAddAssetPopup,
	          addAssetHandler: this.assetFormSubmitHandler
	        }),
	        sendingInvite && _react2.default.createElement(_inviteModal2.default, {
	          thumbnail: influencer.thumbnail,
	          closeHandler: this.closeInviteModal,
	          sendHandler: this.sendInviteToInfluencer,
	          email: emailToTest,
	          inviteSentOK: inviteSentOK,
	          name: fullInfluencer.name || '',
	          campaignName: campaignName,
	          hashtags: hashtags,
	          campaignType: campaignType,
	          campaignStart: campaignStart,
	          campaignEnd: campaignEnd
	        }),
	        addStoryVisible && _react2.default.createElement(_addStoryModal2.default, {
	          popupToggleHandler: this.toggleAddStoryModal,
	          successHandler: this.addStory,
	          campaignId: campaign.get('id'),
	          discussionId: collaboration.id,
	          discussionName: collaboration.name
	        }),
	        isDeletingInfluencer && _react2.default.createElement(_deleteInfluencerModal2.default, {
	          influencer: influencer,
	          campaignName: campaignName,
	          onClose: this.toggleInfluencerDeleteModal,
	          onConfirm: this.removeCollaboration
	        }),
	        viewLiveStoriesModalOpen && _react2.default.createElement(_storyPickerModal2.default, {
	          onAddStoryToCollaboration: this.addStoryToCollaboration,
	          onClose: this.toggleViewLiveStoriesModal,
	          influencerId: _lodash2.default.get(fullInfluencer, 'id'),
	          existingStoriesIDs: existingStoriesIDs,
	          isAddingStoryToCollab: isAddingStoryToCollab
	        }),
	        scanHistoryModalOpen && _react2.default.createElement(_scanHistoryModal2.default, {
	          discussionId: collabId,
	          onClose: this.toggleScanHistoryModal
	        }),
	        scanNowModalOpen && _react2.default.createElement(_scanNowModal2.default, {
	          onClose: function onClose() {
	            console.log('close me');
	          }
	        }),
	        rollForwardModalOpen && _react2.default.createElement(_rollForwardModal2.default, {
	          onClose: this.toggleRollForwardModal,
	          loading: rollForwardModal.isSearching,
	          visible: rollForwardModal.visible,
	          selected: rollForwardModal.selected,
	          searchHandler: this.handleRollForwardModalSearch,
	          selectedHandler: this.handleOptionsSelected,
	          searched: rollForwardModal.searched,
	          yepButtonHandler: this.handleRollForwardButton,
	          options: rollForwardModal.options,
	          isRolling: isRolling
	        })
	      );
	    }
	  }]);
	
	  return Collaboration;
	}(_react2.default.Component);
	
	Collaboration.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	    var collaboration, notes, influencerOrganisation, buildRESTClient, influencerId, restClient, response, stories;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _this3.loadCollaboration();
	
	          case 2:
	            collaboration = _context.sent;
	            notes = collaboration.notes;
	            influencerOrganisation = _lodash2.default.find(collaboration.organisations, function (org) {
	              return _lodash2.default.eq(org.orgType, 'INFLUENCER');
	            });
	
	            _this3.setState({
	              collaboration: collaboration,
	              isClientDiscussion: _lodash2.default.get(collaboration, 'isClientDiscussion', false),
	              isScanningCompleted: _lodash2.default.get(collaboration, 'isScanningCompleted', false),
	              nextDiscussionId: _lodash2.default.get(collaboration, 'nextDiscussion.id', null),
	              previousDiscussionId: _lodash2.default.get(collaboration, 'previousDiscussion.id', null),
	              notes: notes,
	              influencer: influencerOrganisation.influencer,
	              isLoadingCollaboration: false,
	              asset: _lodash2.default.clone(assetInitialState)
	            }, _this3.fetchTrackedAssetsData);
	
	            buildRESTClient = _this3.props.buildRESTClient;
	            influencerId = influencerOrganisation.influencer.id;
	
	
	            _this3.loadShopify();
	
	            if (!influencerId) {
	              _context.next = 15;
	              break;
	            }
	
	            restClient = buildRESTClient({
	              baseURL: ("https://se8yaarvy6.execute-api.eu-west-3.amazonaws.com/production")
	            });
	            _context.next = 13;
	            return restClient.get('stories/by-influencer/' + influencerId);
	
	          case 13:
	            response = _context.sent;
	
	            if (response) {
	              stories = _lodash2.default.get(response, 'data.data', []);
	
	              _this3.setState({
	                liveStoriesCount: _lodash2.default.size(stories),
	                isLoadingLiveStoriesCount: false
	              });
	            }
	
	          case 15:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this3);
	  }));
	  this.loadCollaboration = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var _props2, jsonAPIClient, collabId, response;
	
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _props2 = _this3.props, jsonAPIClient = _props2.jsonAPIClient, collabId = _props2.params.collabId;
	            _context2.next = 3;
	            return jsonAPIClient.get('discussions', collabId, {
	              include: ['inventoryItems', 'trackedAssets', 'trackedAssets.supportingData', 'stories', 'stories.supportingData', 'organisations', 'organisations.influencer', 'organisations.influencer.telegramChannels', 'organisations.influencer.telegramUser', 'nextDiscussion', 'previousDiscussion']
	            });
	
	          case 3:
	            response = _context2.sent;
	            return _context2.abrupt('return', response.toJSONTree());
	
	          case 5:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, _this3);
	  }));
	  this.loadShopify = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	    var _props3, collabId, organisationId, influencer, discountCode, _ref4, orders, prestaShop;
	
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _props3 = _this3.props, collabId = _props3.params.collabId, organisationId = _props3.userInfo.organisationId;
	            influencer = _this3.state.influencer;
	
	            _this3.setState({ shopifyLoading: true });
	            discountCode = _lodash2.default.get(influencer, 'discountCode');
	            _context3.next = 6;
	            return (0, _hasShopify.getShopifyOrdersByDiscussionId)({ discussionId: collabId, discountCode: discountCode, organisationId: organisationId });
	
	          case 6:
	            _ref4 = _context3.sent;
	            orders = _ref4.orders;
	            _context3.next = 10;
	            return (0, _hasPrestaShop.getPrestaShopOrdersByDiscussionId)({ discussionId: collabId, discountCode: discountCode, organisationId: organisationId });
	
	          case 10:
	            prestaShop = _context3.sent;
	
	            _this3.setState({ shopifyLoading: false, shopifyOrders: orders, prestaSHopOrders: _lodash2.default.get(prestaShop, 'orders') });
	            console.log('shopifyOrders', orders);
	
	          case 13:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, _this3);
	  }));
	
	  this.addStoryToCollaboration = function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(story) {
	      var _props4, _props4$params, campaignId, discussionId, buildRESTClient, restClient, collaboration;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this3.setState({
	                isAddingStoryToCollab: true
	              });
	              _props4 = _this3.props, _props4$params = _props4.params, campaignId = _props4$params.id, discussionId = _props4$params.collabId, buildRESTClient = _props4.buildRESTClient;
	              restClient = buildRESTClient({
	                baseURL: ("https://bahhjuaz6d.execute-api.eu-west-1.amazonaws.com/production")
	              });
	              _context4.next = 5;
	              return restClient.post('campaign/' + campaignId + '/discussion/' + discussionId + '/story', {
	                data: story
	              });
	
	            case 5:
	              _context4.next = 7;
	              return _this3.loadCollaboration();
	
	            case 7:
	              collaboration = _context4.sent;
	
	              _this3.setState({
	                collaboration: collaboration,
	                isAddingStoryToCollab: false
	              });
	
	            case 9:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this3);
	    }));
	
	    return function (_x) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  this.fetchTrackedAssetsData = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	    var _state2, trackedAssets, temporaryAsset, noAnalyticsPlatforms, NOT_FOUND, isNoAnalyticsPlatform, isNotViable, goodAssets, trackedAssetsForAnalytics, trackedAssetsWithoutAnalytics, trackedAssetsNotFound, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, asset;
	
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _state2 = _this3.state, trackedAssets = _state2.collaboration.trackedAssets, temporaryAsset = _state2.temporaryAsset;
	
	
	            if (temporaryAsset && temporaryAsset.id) {
	              trackedAssets.push(temporaryAsset);
	            }
	
	            noAnalyticsPlatforms = [_staticConfiguration.TIKTOK, 'SNAPCHAT', 'VK', 'BLOG', 'TELEGRAM'];
	            NOT_FOUND = 'NOT_FOUND';
	
	            isNoAnalyticsPlatform = function isNoAnalyticsPlatform(asset) {
	              return _lodash2.default.includes(noAnalyticsPlatforms, asset.platform);
	            };
	
	            isNotViable = function isNotViable(asset) {
	              return isNoAnalyticsPlatform(asset) || asset.fetchStatus === NOT_FOUND;
	            };
	
	            goodAssets = _lodash2.default.filter(trackedAssets, 'platform');
	            trackedAssetsForAnalytics = _lodash2.default.reject(goodAssets, function (asset) {
	              return isNotViable(asset);
	            });
	            trackedAssetsWithoutAnalytics = _lodash2.default.filter(goodAssets, function (asset) {
	              return isNoAnalyticsPlatform(asset);
	            });
	            trackedAssetsNotFound = _lodash2.default.filter(goodAssets, { fetchStatus: NOT_FOUND });
	
	            if (!(trackedAssetsNotFound && trackedAssetsNotFound.length)) {
	              _context5.next = 30;
	              break;
	            }
	
	            // eslint-disable-next-line no-restricted-syntax
	            _iteratorNormalCompletion = true;
	            _didIteratorError = false;
	            _iteratorError = undefined;
	            _context5.prev = 14;
	            for (_iterator = trackedAssetsNotFound[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              asset = _step.value;
	
	              trackedAssetsWithoutAnalytics.push({
	                trackedAsset: {
	                  id: asset.id,
	                  assetURL: asset.assetURL || '',
	                  platform: asset.platform
	                },
	                notFound: true
	              });
	            }
	            _context5.next = 22;
	            break;
	
	          case 18:
	            _context5.prev = 18;
	            _context5.t0 = _context5['catch'](14);
	            _didIteratorError = true;
	            _iteratorError = _context5.t0;
	
	          case 22:
	            _context5.prev = 22;
	            _context5.prev = 23;
	
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	
	          case 25:
	            _context5.prev = 25;
	
	            if (!_didIteratorError) {
	              _context5.next = 28;
	              break;
	            }
	
	            throw _iteratorError;
	
	          case 28:
	            return _context5.finish(25);
	
	          case 29:
	            return _context5.finish(22);
	
	          case 30:
	            if (!(trackedAssetsForAnalytics && trackedAssetsForAnalytics.length)) {
	              _context5.next = 34;
	              break;
	            }
	
	            (0, _trackedAssetsAnalyticsService.getTrackedAssetAnalytics)(trackedAssetsForAnalytics).then(function (response) {
	              var assetsDetails = _lodash2.default.map(response, function (row) {
	                var data = row.response.data;
	                if (!data || !data.trackedAsset) {
	                  return {
	                    trackedAsset: {
	                      id: row.id,
	                      assetURL: row.assetURL || ''
	                    },
	                    withError: true
	                  };
	                }
	                data.trackedAsset = _lodash2.default.find(trackedAssetsForAnalytics, { assetId: data.trackedAsset.assetId });
	                return data;
	              });
	              return _this3.setState({
	                assetsDetails: _lodash2.default.concat(trackedAssetsWithoutAnalytics, assetsDetails),
	                isLoadingAssets: false,
	                temporaryAsset: null
	              });
	            });
	            _context5.next = 35;
	            break;
	
	          case 34:
	            return _context5.abrupt('return', _this3.setState({
	              assetsDetails: trackedAssetsWithoutAnalytics,
	              isLoadingAssets: false,
	              temporaryAsset: null
	            }));
	
	          case 35:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, _this3, [[14, 18, 22, 30], [23,, 25, 29]]);
	  }));
	
	  this.toggleInfluencerDeleteModal = function () {
	    _this3.setState({
	      isDeletingInfluencer: !_this3.state.isDeletingInfluencer
	    });
	  };
	
	  this.onNewFeeSubmit = function () {
	    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(fee) {
	      var _props5, jsonAPIClient, collabId, collaboration;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _props5 = _this3.props, jsonAPIClient = _props5.jsonAPIClient, collabId = _props5.params.collabId;
	              _context6.next = 3;
	              return jsonAPIClient.get('discussions', collabId);
	
	            case 3:
	              collaboration = _context6.sent;
	
	              collaboration.set('budget', fee);
	              collaboration.set('budgetStatus', 'APPROVED');
	              return _context6.abrupt('return', collaboration.sync());
	
	            case 7:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this3);
	    }));
	
	    return function (_x2) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	
	  this.onNewEmailSubmit = function () {
	    var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(email) {
	      var fullInfluencer, jsonAPIClient, influencer;
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              fullInfluencer = _this3.state.influencer;
	              jsonAPIClient = _this3.props.jsonAPIClient;
	              _context7.next = 4;
	              return jsonAPIClient.get('influencer', fullInfluencer.id);
	
	            case 4:
	              influencer = _context7.sent;
	
	              influencer.set('email', email);
	
	              _this3.setState({
	                newEmail: email
	              });
	              return _context7.abrupt('return', influencer.sync());
	
	            case 8:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this3);
	    }));
	
	    return function (_x3) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	
	  this.toggleIsClientDiscussion = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	    var _props6, jsonAPIClient, collabId, collaboration, isClientDiscussion;
	
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            _props6 = _this3.props, jsonAPIClient = _props6.jsonAPIClient, collabId = _props6.params.collabId;
	            _context8.next = 3;
	            return jsonAPIClient.get('discussions', collabId);
	
	          case 3:
	            collaboration = _context8.sent;
	            isClientDiscussion = _this3.state.isClientDiscussion;
	
	            collaboration.set('isClientDiscussion', !isClientDiscussion);
	
	            _this3.setState({
	              isClientDiscussion: !isClientDiscussion
	            });
	
	            console.log('isClientDiscussion', _this3.state.isClientDiscussion);
	
	            return _context8.abrupt('return', collaboration.sync());
	
	          case 9:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, _this3);
	  }));
	  this.toggleIsScanningCompleted = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	    var _props7, jsonAPIClient, collabId, collaboration, isScanningCompleted;
	
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            _props7 = _this3.props, jsonAPIClient = _props7.jsonAPIClient, collabId = _props7.params.collabId;
	            _context9.next = 3;
	            return jsonAPIClient.get('discussions', collabId);
	
	          case 3:
	            collaboration = _context9.sent;
	            isScanningCompleted = _this3.state.isScanningCompleted;
	
	            collaboration.set('isScanningCompleted', !isScanningCompleted);
	
	            _this3.setState({
	              requiresCampaignReload: true,
	              isScanningCompleted: !isScanningCompleted
	            });
	
	            console.log('isScanningCompleted', _this3.state.isScanningCompleted);
	
	            return _context9.abrupt('return', collaboration.sync());
	
	          case 9:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, _this3);
	  }));
	
	  this.onShopifySubmit = function () {
	    var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(shopifySettings) {
	      var _props8, jsonAPIClient, collabId, collaboration, discountCode, commission;
	
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              console.log('shopifySettings', shopifySettings);
	              _props8 = _this3.props, jsonAPIClient = _props8.jsonAPIClient, collabId = _props8.params.collabId;
	              _context10.next = 4;
	              return jsonAPIClient.get('discussions', collabId);
	
	            case 4:
	              collaboration = _context10.sent;
	              discountCode = shopifySettings.discountCode, commission = shopifySettings.commission;
	
	              if (discountCode) {
	                collaboration.set('discountCode', discountCode);
	              } else if (_lodash2.default.isEqual(discountCode, '')) {
	                collaboration.set('discountCode', ' ');
	              }
	              if (commission) {
	                collaboration.set('commission', commission);
	              }
	              return _context10.abrupt('return', collaboration.sync());
	
	            case 9:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, _this3);
	    }));
	
	    return function (_x4) {
	      return _ref11.apply(this, arguments);
	    };
	  }();
	
	  this.toggleAddStoryModal = function () {
	    var addStoryVisible = _this3.state.addStoryVisible;
	
	    _this3.setState({ addStoryVisible: !addStoryVisible });
	  };
	
	  this.toggleScanHistoryModal = function () {
	    _this3.setState(function (prevState) {
	      return {
	        scanHistoryModalOpen: !prevState.scanHistoryModalOpen
	      };
	    });
	  };
	
	  this.addStory = function (asset) {
	    var assetsDetails = _this3.state.assetsDetails;
	
	    assetsDetails.push({
	      text: 'fetching data...',
	      state: 'FETCHING',
	      trackedAsset: asset
	    });
	
	    _this3.setState({
	      assetsDetails: assetsDetails,
	      requiresCampaignReload: true,
	      temporaryAsset: asset
	    });
	
	    setTimeout(function () {
	      _this3.fetchTrackedAssetsData();
	    }, ASSET_API_TIMEOUT);
	  };
	
	  this.viewDiscussion = function (discussion) {
	    return function () {
	      _this3.context.router.push('/campaign/discussion/' + discussion.get('id'));
	    };
	  };
	
	  this.removeCollaboration = _asyncToGenerator(_regenerator2.default.mark(function _callee11() {
	    var jsonAPIClient, collaboration, collaborationId, invitations, members, campaignId, invite, hasJoined, membership, campaign, discussion, permissionId, permission, invitationId, invitation;
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            jsonAPIClient = _this3.props.jsonAPIClient;
	            collaboration = _this3.state.collaboration;
	            collaborationId = collaboration.id, invitations = collaboration.invitations, members = collaboration.members, campaignId = collaboration.campaign.id;
	            invite = _lodash2.default.head(invitations);
	            hasJoined = !_lodash2.default.isEmpty(members);
	            membership = _lodash2.default.head(members);
	            _context11.next = 8;
	            return jsonAPIClient.get('campaigns', campaignId);
	
	          case 8:
	            campaign = _context11.sent;
	            _context11.next = 11;
	            return jsonAPIClient.get('discussions', collaborationId);
	
	          case 11:
	            discussion = _context11.sent;
	
	            campaign.relationships('discussions').remove(discussion);
	
	            _context11.next = 15;
	            return campaign.sync();
	
	          case 15:
	            _context11.next = 17;
	            return discussion.delete();
	
	          case 17:
	            if (!hasJoined) {
	              _context11.next = 26;
	              break;
	            }
	
	            permissionId = membership.id;
	            _context11.next = 21;
	            return jsonAPIClient.get('campaignPermission', permissionId);
	
	          case 21:
	            permission = _context11.sent;
	            _context11.next = 24;
	            return permission.delete();
	
	          case 24:
	            _context11.next = 32;
	            break;
	
	          case 26:
	            invitationId = invite.id;
	            _context11.next = 29;
	            return jsonAPIClient.get('campaignInvitation', invitationId);
	
	          case 29:
	            invitation = _context11.sent;
	            _context11.next = 32;
	            return invitation.delete();
	
	          case 32:
	
	            window.open('/campaign/' + campaignId + '/collaborations', '_self');
	
	          case 33:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, _this3);
	  }));
	
	  this.toggleAddAssetPopup = function (e, data) {
	    var _state3 = _this3.state,
	        asset = _state3.asset,
	        hasCheckedLimitNotification = _state3.hasCheckedLimitNotification;
	
	    asset.adding = !asset.adding;
	    asset.platform = _lodash2.default.isUndefined(data) ? null : data.value;
	    if (!hasCheckedLimitNotification) {
	      _this3.checkLimitsNotification();
	    }
	    _this3.setState({
	      asset: asset,
	      hasCheckedLimitNotification: true
	    });
	  };
	
	  this.checkLimitsNotification = function () {
	    if (ENFORCE_LIMITS) {
	      var _props9 = _this3.props,
	          restClient = _props9.restClient,
	          _props9$userInfo = _props9.userInfo,
	          organisationId = _props9$userInfo.organisationId,
	          name = _props9$userInfo.name,
	          userId = _props9$userInfo.userId,
	          organisation = _props9.organisation;
	
	      if (!trackedAssetsCount || !organisation) return;
	      if (trackedAssetsCount < organisation.licenseTrackedAssetLimit) return;
	      (0, _sendLimitsExceededNotifcation2.default)(restClient, {
	        data: {
	          name: name + ' ',
	          organisationId: organisationId,
	          userId: userId,
	          organisationName: organisation.name + ' ',
	          assetType: 'tracked assets',
	          licenseSubscriptionType: organisation.licenseSubscriptionType,
	          url: window.location.href
	        }
	      });
	    }
	  };
	
	  this.toggleViewLiveStoriesModal = function () {
	    return _this3.setState({
	      viewLiveStoriesModalOpen: !_this3.state.viewLiveStoriesModalOpen
	    });
	  };
	
	  this.assetFormSubmitHandler = function () {
	    var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(asset) {
	      var _state4, collaboration, influencer, instagramAccountId, _props10, createTrackedAsset, syncTrackedAssetAndDiscussion, campaign, data, newTrackedAsset, trackedAssetId, assetsDetails, collaborationClone;
	
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              _state4 = _this3.state, collaboration = _state4.collaboration, influencer = _state4.influencer;
	              instagramAccountId = influencer.instagramId;
	              _props10 = _this3.props, createTrackedAsset = _props10.createTrackedAsset, syncTrackedAssetAndDiscussion = _props10.syncTrackedAssetAndDiscussion, campaign = _props10.campaign;
	              data = _extends({
	                campaignId: campaign.get('id'),
	                discussionId: collaboration.id,
	                discussionName: collaboration.name,
	                instagramAccountId: instagramAccountId
	              }, asset);
	              _context12.next = 6;
	              return createTrackedAsset(data);
	
	            case 6:
	              newTrackedAsset = _context12.sent;
	              trackedAssetId = newTrackedAsset.id;
	              _context12.next = 10;
	              return syncTrackedAssetAndDiscussion({
	                discussionId: collaboration.id,
	                trackedAssetId: trackedAssetId
	              });
	
	            case 10:
	
	              // close the modal before waiting
	
	              assetsDetails = _this3.state.assetsDetails;
	
	              assetsDetails.push({
	                text: 'fetching data...',
	                state: 'FETCHING',
	                trackedAsset: asset
	              });
	
	              collaborationClone = _lodash2.default.clone(collaboration);
	
	              collaborationClone.trackedAssets.push(newTrackedAsset);
	              _this3.setState({
	                collaboration: collaboration,
	                assetsDetails: assetsDetails,
	                requiresCampaignReload: true,
	                asset: {
	                  adding: false,
	                  platform: null
	                }
	              }, function () {
	                setTimeout(_this3.fetchTrackedAssetsData, WAIT_FOR);
	              });
	
	            case 15:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this3);
	    }));
	
	    return function (_x5) {
	      return _ref13.apply(this, arguments);
	    };
	  }();
	
	  this.removeAsset = function () {
	    var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(event, _ref15) {
	      var value = _ref15.value;
	
	      var _props11, removeTrackedAssetById, removeTrackedAssetFromDiscussionById, collaboration, discussionId, trackedAssetId, collaborationClone, updatedTrackedAssets;
	
	      return _regenerator2.default.wrap(function _callee13$(_context13) {
	        while (1) {
	          switch (_context13.prev = _context13.next) {
	            case 0:
	              _props11 = _this3.props, removeTrackedAssetById = _props11.removeTrackedAssetById, removeTrackedAssetFromDiscussionById = _props11.removeTrackedAssetFromDiscussionById;
	              collaboration = _this3.state.collaboration;
	              discussionId = collaboration.id;
	              trackedAssetId = value.trackedAsset.id;
	              _context13.next = 6;
	              return removeTrackedAssetFromDiscussionById({
	                discussionId: discussionId,
	                trackedAssetId: trackedAssetId
	              });
	
	            case 6:
	              _context13.next = 8;
	              return removeTrackedAssetById(trackedAssetId);
	
	            case 8:
	              collaborationClone = _lodash2.default.clone(collaboration);
	              updatedTrackedAssets = _lodash2.default.reject(collaborationClone.trackedAssets, ['id', trackedAssetId]);
	
	              collaborationClone.trackedAssets = updatedTrackedAssets;
	              _this3.setState({
	                collaboration: collaborationClone,
	                requiresCampaignReload: true
	              }, _this3.fetchTrackedAssetsData);
	
	            case 12:
	            case 'end':
	              return _context13.stop();
	          }
	        }
	      }, _callee13, _this3);
	    }));
	
	    return function (_x6, _x7) {
	      return _ref14.apply(this, arguments);
	    };
	  }();
	
	  this.removeStory = function () {
	    var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(storyId) {
	      var restClient, collaboration, stories, updatedStories;
	      return _regenerator2.default.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              restClient = _this3.props.restClient;
	              collaboration = _this3.state.collaboration;
	              stories = collaboration.stories;
	              updatedStories = _lodash2.default.reject(stories, ['id', storyId]);
	              _context14.next = 6;
	              return restClient.patch('discussions/' + collaboration.id + '/relationships/stories', {
	                data: _lodash2.default.map(updatedStories, function (story) {
	                  return { type: 'stories', id: story.id };
	                })
	              });
	
	            case 6:
	              _context14.next = 8;
	              return restClient.patch('stories/' + storyId, {
	                data: {
	                  type: 'stories',
	                  id: storyId,
	                  attributes: {
	                    discussion: null,
	                    campaign: null
	                  }
	                }
	              });
	
	            case 8:
	              collaboration.stories = updatedStories;
	              _this3.setState({
	                collaboration: collaboration
	              });
	
	            case 10:
	            case 'end':
	              return _context14.stop();
	          }
	        }
	      }, _callee14, _this3);
	    }));
	
	    return function (_x8) {
	      return _ref16.apply(this, arguments);
	    };
	  }();
	
	  this.toggleSendInviteModal = function () {
	    var fullInfluencer = _this3.state.influencer;
	    var _props12 = _this3.props,
	        campaign = _props12.campaign,
	        restClient = _props12.restClient;
	
	    var _campaign$toJSON = campaign.toJSON(),
	        id = _campaign$toJSON.id;
	
	    var query = '?filter[campaign]=' + id + '&page[limit]=' + INFLUENCER_LIMIT;
	    var url = ("https://api2.dyzio.co/v1") + '/campaignInvitation' + query;
	
	    return restClient.get(url).then(function (response) {
	      return response.data.data;
	    }).then(function (invitations) {
	      var modalInvitation = _lodash2.default.find(invitations, ['attributes.metadata.influencerId', fullInfluencer.id]);
	
	      if (modalInvitation) {
	        _this3.setState({
	          modalInvitation: modalInvitation,
	          sendingInvite: true,
	          sendingError: false,
	          invitationSent: true,
	          requiresCampaignReload: true
	        });
	      }
	    });
	  };
	
	  this.closeInviteModal = function () {
	    _this3.setState({
	      modalInvitation: null,
	      sendingInvite: false,
	      sendingError: false,
	      inviteSentOK: false
	    });
	  };
	
	  this.getUserIdFromInvitation = function (invitation) {
	    var user = invitation.relationships.user;
	
	    return user && user.data ? user.data.id : null;
	  };
	
	  this.sendInviteToInfluencer = function () {
	    var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(_ref18) {
	      var data = _ref18.data;
	
	      var _state5, modalInvitation, influencer, userId;
	
	      return _regenerator2.default.wrap(function _callee15$(_context15) {
	        while (1) {
	          switch (_context15.prev = _context15.next) {
	            case 0:
	              _state5 = _this3.state, modalInvitation = _state5.modalInvitation, influencer = _state5.influencer;
	              userId = _this3.getUserIdFromInvitation(modalInvitation);
	
	              if (!userId) {
	                _context15.next = 5;
	                break;
	              }
	
	              _context15.next = 5;
	              return _this3.patchUser({ influencer: influencer, userId: userId });
	
	            case 5:
	              _context15.next = 7;
	              return _this3.patchCampaignInvitation({ modalInvitation: modalInvitation, influencer: influencer, data: data });
	
	            case 7:
	              _this3.closeInviteModal();
	
	            case 8:
	            case 'end':
	              return _context15.stop();
	          }
	        }
	      }, _callee15, _this3);
	    }));
	
	    return function (_x9) {
	      return _ref17.apply(this, arguments);
	    };
	  }();
	
	  this.patchUser = function (params) {
	    var influencer = params.influencer,
	        userId = params.userId;
	    var restClient = _this3.props.restClient;
	
	    var patch = {
	      data: {
	        type: 'users',
	        id: userId,
	        attributes: {
	          email: influencer.email
	        }
	      }
	    };
	    var url = ("https://api2.dyzio.co/v1") + '/users/' + userId;
	    return restClient.patch(url, patch);
	  };
	
	  this.patchCampaignInvitation = function (params) {
	    var modalInvitation = params.modalInvitation,
	        influencer = params.influencer,
	        data = params.data;
	    var _props13 = _this3.props,
	        restClient = _props13.restClient,
	        onLoadingCampaign = _props13.onLoadingCampaign;
	    var _props14 = _this3.props,
	        campaign = _props14.campaign,
	        name = _props14.userInfo.name;
	    var campaignId = _this3.state.collaboration.campaign.id;
	    var origin = window.location.origin;
	
	    var campaignName = campaign.get('name');
	    var shortId = modalInvitation.attributes.shortId;
	
	    var link = origin + '/invite/' + shortId;
	
	    var anyAttributes = {
	      status: 'SENT',
	      email: influencer.email,
	      origin: origin,
	      notes: data.notes,
	      extraData: data,
	      name: _lodash2.default.trim(influencer.name),
	      campaignName: campaignName,
	      link: link,
	      createdBy: name,
	      sentCount: 1
	    };
	
	    var attributes = _lodash2.default.pickBy(anyAttributes);
	    var patch = {
	      data: {
	        type: 'campaignInvitation',
	        id: modalInvitation.id,
	        attributes: attributes
	      }
	    };
	
	    var url = ("https://api2.dyzio.co/v1") + '/campaignInvitation/' + modalInvitation.id;
	    restClient.patch(url, patch).then(function () {
	      _this3.setState({
	        sendingError: false,
	        modalInvitation: null,
	        inviteSentOK: true
	      }, function () {
	        _this3.setState({
	          localInvitatinStatus: 'SENT',
	          requiresCampaignReload: true
	        }, function () {
	          return onLoadingCampaign(campaignId, true);
	        });
	      });
	    }).catch(function (error) {
	      _this3.setState({
	        updatingInvitationStatusError: error,
	        sendingInvite: false,
	        sendingError: false,
	        inviteSentOK: false,
	        modalInvitation: null,
	        hideAssetTable: false,
	        hideShopifyTable: false
	      });
	    });
	  };
	
	  this.toggleFeeModalState = function () {
	    _this3.setState(function (prevState) {
	      return {
	        feeModalOpen: !prevState.feeModalOpen
	      };
	    });
	  };
	
	  this.returnToCampaign = function () {
	    var _props15 = _this3.props,
	        router = _props15.router,
	        onLoadingCampaign = _props15.onLoadingCampaign;
	    var _state6 = _this3.state,
	        requiresCampaignReload = _state6.requiresCampaignReload,
	        campaignId = _state6.collaboration.campaign.id;
	
	
	    if (requiresCampaignReload) {
	      onLoadingCampaign(campaignId, true);
	    }
	    router.goBack();
	  };
	
	  this.toggleAssetLocalState = function (assetId, value) {
	    var _state7 = _this3.state,
	        assetsDetails = _state7.assetsDetails,
	        collaboration = _state7.collaboration;
	
	    var updatedAssetsDetails = _lodash2.default.map(assetsDetails, function (asset) {
	      if (_lodash2.default.get(asset, 'trackedAsset.id') === assetId) {
	        _lodash2.default.set(asset, 'trackedAsset.favourite', value);
	      }
	      if (_lodash2.default.get(asset, 'id') === assetId) {
	        _lodash2.default.set(asset, 'favourite', value);
	      }
	      return asset;
	    });
	    var updatedStories = _lodash2.default.map(_lodash2.default.get(collaboration, 'stories', []), function (story) {
	      if (_lodash2.default.get(story, 'id') === assetId) {
	        _lodash2.default.set(story, 'favourite', value);
	      }
	      return story;
	    });
	
	    var updatedCollaboration = _lodash2.default.clone(collaboration);
	    updatedCollaboration.stories = updatedStories;
	
	    _this3.setState({
	      collaboration: updatedCollaboration,
	      assetsDetails: updatedAssetsDetails
	    });
	  };
	
	  this.markAuthorised = function () {
	    var influencer = _this3.state.influencer;
	    var restClient = _this3.props.restClient;
	
	
	    var patch = {
	      data: {
	        attributes: {
	          instagramStatus: 'AUTHORIZED',
	          instagramAuthorised: true
	        }
	      }
	    };
	
	    var url = ("https://api2.dyzio.co/v1") + '/influencer/' + influencer.id;
	    return restClient.patch(url, patch).then(function () {
	      window.location.reload(true);
	    });
	  };
	
	  this.reloadPage = function () {
	    return window.location.reload();
	  };
	
	  this.scanNow = function () {
	    var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(_ref20) {
	      var captureAll = _ref20.captureAll;
	
	      var _props16, campaign, collabId, campaignId, ax, scanUrl;
	
	      return _regenerator2.default.wrap(function _callee16$(_context16) {
	        while (1) {
	          switch (_context16.prev = _context16.next) {
	            case 0:
	              _props16 = _this3.props, campaign = _props16.campaign, collabId = _props16.params.collabId;
	              _context16.next = 3;
	              return _this3.setState({ scanNowModalOpen: true });
	
	            case 3:
	              campaignId = campaign.get('id');
	
	
	              console.log('SCAN IT NOW');
	              console.log(campaignId);
	              console.log(collabId);
	              ax = _axios2.default.create({
	                baseURL: ("https://bahhjuaz6d.execute-api.eu-west-1.amazonaws.com/production"),
	                timeout: 30000,
	                headers: {
	                  Authorization: 'Bearer ' + _authService.authService.getToken()
	                }
	              });
	              scanUrl = '/run-automated-scan/' + campaignId + '/discussion/' + collabId;
	
	              if (captureAll) scanUrl += '?cas=true';
	              return _context16.abrupt('return', ax.post(scanUrl).then(function () {
	                return _this3.setState({
	                  scanNowModalOpen: false
	                }, _this3.reloadPage);
	              }).catch(function (e) {
	                console.log(e.message);
	                return _this3.reloadPage();
	              }));
	
	            case 11:
	            case 'end':
	              return _context16.stop();
	          }
	        }
	      }, _callee16, _this3);
	    }));
	
	    return function (_x10) {
	      return _ref19.apply(this, arguments);
	    };
	  }();
	
	  this.toggleRollForwardModal = function () {
	    var hasRolledForward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var rollForwardModalOpen = _this3.state.rollForwardModalOpen;
	
	
	    _this3.setState({
	      rollForwardModalOpen: !rollForwardModalOpen,
	      hasRolledForward: hasRolledForward
	    });
	  };
	
	  this.captureAllStories = _asyncToGenerator(_regenerator2.default.mark(function _callee17() {
	    var captureAll;
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            captureAll = true;
	            _context17.next = 3;
	            return _this3.scanNow({ captureAll: captureAll });
	
	          case 3:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, _this3);
	  }));
	  this.handleRollForwardModalSearch = _lodash2.default.debounce(function (event, data) {
	    var value = data.value;
	    var cloneModal = _this3.state.cloneModal;
	
	
	    if (!value) {
	      var _cloneModalUpdated = _lodash2.default.assign(cloneModal, { isSearching: false, searched: false });
	      _this3.setState({ cloneModal: _cloneModalUpdated });
	      return;
	    }
	
	    var cloneModalUpdated = _lodash2.default.assign(cloneModal, { isSearching: true });
	
	    _this3.setState({
	      cloneModal: cloneModalUpdated
	    }, function () {
	      return _this3.searchCampaigns(value);
	    });
	  }, 1000);
	
	  this.searchCampaigns = function (value) {
	    var _props17 = _this3.props,
	        restClient = _props17.restClient,
	        organisationId = _props17.userInfo.organisationId;
	
	    var encodedValue = encodeURI(value);
	    var searchUrl = '/campaigns?filter[name]=:' + encodedValue + '&filter[owner]=' + organisationId;
	    restClient.get(searchUrl).then(function (response) {
	      var data = response.data.data;
	
	      var options = _lodash2.default.map(data, function (campaign) {
	        return {
	          title: campaign.attributes.name + ' [' + campaign.attributes.brand + ']',
	          id: campaign.id
	        };
	      });
	      var rollForwardModal = _this3.state.rollForwardModal;
	
	      var updated = _lodash2.default.assign(rollForwardModal, {
	        options: options,
	        isSearching: false,
	        searched: true
	      });
	      _this3.setState({
	        rollForwardModal: updated
	      });
	    }).catch(function (error) {
	      console.log(error);
	    });
	  };
	
	  this.handleOptionsSelected = function (event, data) {
	    var result = data.result;
	    var rollForwardModal = _this3.state.rollForwardModal;
	
	    var updated = _lodash2.default.assign(rollForwardModal, { selected: result });
	    _this3.setState({
	      rollForwardModal: updated
	    });
	  };
	
	  this.handleRollForwardButton = function () {
	    var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(event, data) {
	      var _state8, rollForwardModal, collaboration, influencer, influencerFields, rollForwardPayload, ax, hasRolledForward;
	
	      return _regenerator2.default.wrap(function _callee18$(_context18) {
	        while (1) {
	          switch (_context18.prev = _context18.next) {
	            case 0:
	              _state8 = _this3.state, rollForwardModal = _state8.rollForwardModal, collaboration = _state8.collaboration, influencer = _state8.influencer;
	
	
	              _this3.setState({
	                isRolling: true,
	                requiresCampaignReload: true
	              });
	
	              console.log(rollForwardModal.selected);
	              influencerFields = ['id', 'instagram', 'instagramId', 'tiktok', 'tiktokId', 'email', 'name'];
	              rollForwardPayload = {
	                data: {
	                  campaign: rollForwardModal.selected,
	                  discussion: {
	                    id: collaboration.id
	                  },
	                  influencer: _lodash2.default.pick(influencer, influencerFields)
	                }
	              };
	
	
	              console.log(rollForwardPayload);
	
	              ax = _axios2.default.create({
	                baseURL: 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/influencer',
	                timeout: 30000,
	                headers: {
	                  Authorization: 'Bearer ' + _authService.authService.getToken()
	                }
	              });
	              _context18.next = 9;
	              return ax.post('rollfwd', rollForwardPayload);
	
	            case 9:
	              hasRolledForward = true;
	
	              _this3.toggleRollForwardModal(hasRolledForward);
	
	            case 11:
	            case 'end':
	              return _context18.stop();
	          }
	        }
	      }, _callee18, _this3);
	    }));
	
	    return function (_x12, _x13) {
	      return _ref22.apply(this, arguments);
	    };
	  }();
	
	  this.createDiscountLink = _asyncToGenerator(_regenerator2.default.mark(function _callee19() {
	    var _props18, campaign, collabId, campaignId, shortLinkApi, response;
	
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            _this3.setState({
	              createDiscountDisabled: true,
	              createDiscountLoading: true
	            });
	
	            _props18 = _this3.props, campaign = _props18.campaign, collabId = _props18.params.collabId;
	            campaignId = campaign.get('id');
	            shortLinkApi = 'https://bahhjuaz6d.execute-api.eu-west-1.amazonaws.com/production';
	
	            shortLinkApi += '/shortlink/' + campaignId + '/discussion/' + collabId;
	            console.log(shortLinkApi);
	            _context19.next = 8;
	            return _axios2.default.post(shortLinkApi);
	
	          case 8:
	            response = _context19.sent;
	
	
	            console.log(response.data.shortLink);
	            _this3.setState({
	              createDiscountDisabled: false,
	              createDiscountLoading: false,
	              newShortLink: response.data.shortLink
	            });
	
	          case 11:
	          case 'end':
	            return _context19.stop();
	        }
	      }
	    }, _callee19, _this3);
	  }));
	};
	
	Collaboration.propTypes = {
	  location: _propTypes2.default.func.isRequired,
	  campaign: _propTypes2.default.object.isRequired,
	  router: _propTypes2.default.object.isRequired,
	  restClient: _propTypes2.default.object.isRequired,
	  userInfo: _propTypes2.default.object.isRequired,
	  onLoadingCampaign: _propTypes2.default.func.isRequired,
	  params: _propTypes2.default.object.isRequired
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onLoadingCampaign: function onLoadingCampaign(campaignId, silent) {
	      return dispatch((0, _actions.loadingCampaign)(campaignId, silent));
	    }
	  };
	}
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _reactRouter.withRouter, _hasJsonapiClient2.default, _hasRestClient2.default, _withTrackedAssetsData2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(Collaboration);

/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _immutable = __webpack_require__(71);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _all = __webpack_require__(2949);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _authService = __webpack_require__(21);
	
	var _withGuestIntercom = __webpack_require__(360);
	
	var _withGuestIntercom2 = _interopRequireDefault(_withGuestIntercom);
	
	var _formInputText = __webpack_require__(104);
	
	var _formInputText2 = _interopRequireDefault(_formInputText);
	
	var _formInputValidation = __webpack_require__(286);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _metricAnalyticsService = __webpack_require__(119);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TERMS_LINK = _themeSelector2.default.getTermsAndConditionsLink();
	
	var SCREENING_API = 'https://pzdckebtqf.execute-api.eu-west-1.amazonaws.com/production/signup/user/screen';
	
	var Signup = function (_React$Component) {
	  _inherits(Signup, _React$Component);
	
	  function Signup(props, context) {
	    _classCallCheck(this, Signup);
	
	    var _this = _possibleConstructorReturn(this, (Signup.__proto__ || Object.getPrototypeOf(Signup)).call(this, props, context));
	
	    _this.getAuthParams = function (data) {
	      var splitFullname = data.get('fullname').trim().split(/\s+/);
	
	      return {
	        connection: 'Username-Password-Authentication',
	        responseType: 'token',
	        email: data.get('email'),
	        password: data.get('password'),
	        scope: 'openid app_metadata',
	        user_metadata: {
	          firstname: splitFullname[0],
	          lastname: splitFullname.slice(1, splitFullname.length).join(' '),
	          companyname: data.get('companyname')
	        }
	      };
	    };
	
	    _this.acceptModal = function () {
	      _this.setState({ modal: false });
	      _this.googleSignup();
	    };
	
	    _this.showModal = function () {
	      return _this.setState({ modal: true });
	    };
	
	    _this.hideModal = function () {
	      return _this.setState({ modal: false });
	    };
	
	    _this.signUp = function (suData) {
	      var signUpData = {
	        name: suData.get('fullname'),
	        email: suData.get('email'),
	        signupType: 'emailPassword',
	        companyname: suData.get('companyname')
	      };
	      (0, _metricAnalyticsService.trackEvent)('Sign Up', signUpData);
	
	      _this.restClient.post(SCREENING_API, { data: _extends({}, signUpData) }).then(function (response) {
	        var data = response.data.data;
	
	        console.log(data);
	        if (data.error) {
	          (0, _errorHandlingService.reportError)('SIGNUP_ERROR', data.error.message);
	          _this.setState({ signupError: data.error.message });
	        } else {
	          _authService.authService.signup(_this.getAuthParams(suData), function (error) {
	            if (error) {
	              (0, _errorHandlingService.reportError)('SIGNUP_ERROR', error.message);
	              _this.setState({ signupError: error.message });
	            }
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      signupError: false,
	      modal: false,
	      checked: false
	    };
	
	    _this.restClient = _axios2.default.create({
	      timeout: 10000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Signup, [{
	    key: 'googleSignupValidate',
	    value: function googleSignupValidate() {
	      if (this.props.email) {
	        this.showModal();
	      } else {
	        this.googleSignup();
	      }
	    }
	  }, {
	    key: 'googleSignup',
	    value: function googleSignup() {
	      var context = this;
	
	      (0, _metricAnalyticsService.trackEvent)('Sign Up', { signupType: 'google' });
	
	      _authService.authService.login({
	        connection: 'google-oauth2',
	        responseType: 'token',
	        scope: 'openid app_metadata'
	      }, function (error) {
	        if (error) {
	          (0, _errorHandlingService.reportError)('GOOGLE_SIGNUP_ERROR', error.message);
	          context.setState({ signupError: error.message });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          email = _props.email,
	          invalid = _props.invalid;
	      var signupError = this.state.signupError;
	
	
	      var viewportStyles = {
	        backgroundColor: '#f7fafa',
	        height: 'auto',
	        minHeight: '100vh',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        padding: '64px 24px'
	      };
	
	      var signupBoxStyle = {
	        background: 'white',
	        border: '1px solid #e8e8e8',
	        borderRadius: '4px',
	        padding: '24px',
	        maxWidth: '960px',
	        margin: '0 auto'
	      };
	
	      var quoteImageStyle = {
	        margin: '10px 16px 0 24px'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: viewportStyles },
	        _react2.default.createElement(
	          'div',
	          { className: 'align-center' },
	          _react2.default.createElement('img', { src: '/dyzio-logo.png', alt: 'dyzio' }),
	          _react2.default.createElement('div', { className: 'spacer' }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Agencies and brands, sign up for free'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'No credit card required. All features included.'
	          ),
	          _react2.default.createElement('div', { className: 'spacer large' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex top', style: signupBoxStyle },
	            _react2.default.createElement(
	              'div',
	              { className: 'equal align-left' },
	              signupError && _lodash2.default.includes(signupError, 'already exist') ? _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  { className: 'info' },
	                  'It looks like you already have an account with us.'
	                ),
	                _react2.default.createElement('div', { className: 'spacer' }),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'large rose stretch',
	                    onClick: function onClick() {
	                      return _this2.context.router.push('/login');
	                    }
	                  },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Log In'
	                  )
	                )
	              ) : _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit(this.signUp) },
	                _react2.default.createElement(_immutable.Field, {
	                  name: 'fullname',
	                  type: 'text',
	                  component: _formInputText2.default,
	                  img: '/icons/user.svg',
	                  placeholder: 'Full name'
	                }),
	                _react2.default.createElement(_immutable.Field, {
	                  name: 'companyname',
	                  type: 'text',
	                  component: _formInputText2.default,
	                  img: '/icons/suitcase.svg',
	                  placeholder: 'Company name'
	                }),
	                _react2.default.createElement(_immutable.Field, {
	                  name: 'email',
	                  type: 'text',
	                  component: _formInputText2.default,
	                  img: '/icons/email.svg',
	                  disabled: email,
	                  placeholder: 'Email address'
	                }),
	                _react2.default.createElement(_immutable.Field, {
	                  name: 'password',
	                  type: 'password',
	                  component: _formInputText2.default,
	                  img: '/icons/password.svg',
	                  placeholder: 'Choose a password'
	                }),
	                signupError && _react2.default.createElement(_semanticUiReact.Message, {
	                  error: true,
	                  icon: 'thumbs down outline',
	                  header: 'Sorry, we can\'t sign you up automatically',
	                  content: signupError
	                }),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    type: 'submit',
	                    fluid: true,
	                    icon: true,
	                    labelPosition: 'left',
	                    color: 'pink',
	                    size: 'huge',
	                    disabled: invalid
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'signup' }),
	                  'Sign Up!'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'caption align-center' },
	                  'By signing up you agree to our',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: TERMS_LINK,
	                      target: '_blank',
	                      rel: 'noopener noreferrer'
	                    },
	                    'terms of service'
	                  ),
	                  '.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'equal' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Why you need dyzio!'
	              ),
	              _react2.default.createElement('div', { className: 'spacer small' }),
	              _react2.default.createElement(
	                'ul',
	                { className: 'align-left' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Build and manage your own private influencer database'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Share influencer shortlists with your clients'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Collaborate on influencer campaigns on any social network'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Generate and distribute professional daily reports from one place'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Identify and understand campaign success metrics'
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex top' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement('img', { style: quoteImageStyle, src: '/images/katie.png', alt: 'Katie Nelson, We Are Delightful' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'space align-left' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'light' },
	                    '\u201CDyzio has made keeping track of my influencers and selecting the right ones for my campaigns a breeze. And running campaigns has never been easier!\u201D'
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'Katie Nelson, We Are Delightful'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Signup;
	}(_react2.default.Component);
	
	Signup.contextTypes = {
	  router: _propTypes2.default.object
	};
	Signup.propTypes = {
	  email: _propTypes2.default.string,
	  handleSubmit: _propTypes2.default.func.isRequired
	};
	Signup.defaultProps = {
	  email: null
	};
	
	
	function validate(values) {
	  var errors = {};
	
	  var fullname = values.get('fullname');
	  var companyname = values.get('companyname');
	  var email = values.get('email');
	  var password = values.get('password');
	
	  if (!fullname) errors.fullname = 'Enter your full name.';
	  if (!companyname) errors.companyname = 'Enter your company name.';
	  if (fullname && fullname.trim().split(/\s+/).length < 2) {
	    errors.fullname = 'Enter both your first and last name.';
	  }
	
	  if (!email) errors.email = 'Enter your email address.';
	
	  if (email) {
	    var isValidEmail = _formInputValidation.EMAIL_REGULAR_EXPRESSION.test(email);
	    if (!isValidEmail) errors.email = 'Enter a valid email address.';
	    if (isValidEmail) {
	      var emailDomain = _lodash2.default.split(email, '@')[1];
	      if (_lodash2.default.includes(_all2.default, emailDomain)) {
	        errors.email = 'We do not allow signups from your email provider [' + emailDomain + ']. Please use a company email.';
	      }
	    }
	  }
	
	  if (!password) errors.password = 'Enter a new password.';
	  if (password && (password.length < 8 || !password.match(/\d+/g))) {
	    errors.password = 'Password must have atleast 8 characters and contain 1 number.';
	  }
	
	  return errors;
	}
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    shortId: state.invite.get('shortId'),
	    email: state.invite.get('email'),
	    initialValues: {
	      fullname: state.invite.get('name'),
	      email: state.invite.get('email')
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)(_withGuestIntercom2.default, (0, _reactRedux.connect)(mapStateToProps, null), (0, _immutable.reduxForm)({
	  form: 'SignupForm',
	  validate: validate
	}))(Signup);

/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _influencerFormExternal = __webpack_require__(1963);
	
	var _influencerFormExternal2 = _interopRequireDefault(_influencerFormExternal);
	
	var _publicHeader = __webpack_require__(551);
	
	var _publicHeader2 = _interopRequireDefault(_publicHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatorSignUp = function (_Component) {
	  _inherits(CreatorSignUp, _Component);
	
	  function CreatorSignUp(props) {
	    _classCallCheck(this, CreatorSignUp);
	
	    var _this = _possibleConstructorReturn(this, (CreatorSignUp.__proto__ || Object.getPrototypeOf(CreatorSignUp)).call(this, props));
	
	    _this.state = {
	      isLoading: false,
	      isError: false,
	      influencer: null,
	      instagramLoading: false,
	      thumbnail: null,
	      primarySocialHandle: null,
	      displayName: null,
	      email: null,
	      emailerror: null,
	      instagramLoaded: false,
	      isFormSubmitted: false,
	      organisationId: null,
	      openModal: false
	    };
	    return _this;
	  }
	
	  _createClass(CreatorSignUp, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { paddingTop: 10 } },
	        _react2.default.createElement(_publicHeader2.default, null),
	        _react2.default.createElement(_influencerFormExternal2.default, null)
	      );
	    }
	  }]);
	
	  return CreatorSignUp;
	}(_react.Component);
	
	exports.default = CreatorSignUp;

/***/ },
/* 2099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(37);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _validator = __webpack_require__(84);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _publicHeader = __webpack_require__(551);
	
	var _publicHeader2 = _interopRequireDefault(_publicHeader);
	
	var _creatorNewCard = __webpack_require__(1922);
	
	var _creatorNewCard2 = _interopRequireDefault(_creatorNewCard);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var currentTheme = _themeSelector2.default.theme();
	var MOI_ID = 'efcb872a-50d9-417c-b6a5-ba427dba4c84';
	
	var INF_DATA_API = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer';
	var INF_CREATE_API = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/flyt/influencer';
	
	var modalStyle = {
	  textAlign: 'center',
	  color: '#777'
	};
	
	var nameStyle = {
	  marginTop: 10,
	  marginBottom: 10,
	  display: 'block'
	};
	
	var CreatorNew = function (_Component) {
	  _inherits(CreatorNew, _Component);
	
	  function CreatorNew(props) {
	    _classCallCheck(this, CreatorNew);
	
	    var _this = _possibleConstructorReturn(this, (CreatorNew.__proto__ || Object.getPrototypeOf(CreatorNew)).call(this, props));
	
	    _this.handleSocialChange = function (e, v) {
	      _this.setState({ instagramLoading: true, primarySocialHandle: null, thumbnail: null });
	      var value = _lodash2.default.replace(_lodash2.default.get(v, 'value'), /\s/g, '');
	      _this.setState(_defineProperty({}, v.name, value));
	      var handle = value;
	
	      var payload = { data: { platform: 'instagram', name: handle } };
	
	      var start = (0, _moment2.default)();
	      return _axios2.default.post(INF_DATA_API, payload).then(function (r) {
	        var end = (0, _moment2.default)();
	        var loadTime = end.diff(start);
	
	        var foundCreator = r.data.body.data;
	
	        console.log(loadTime);
	        console.log(foundCreator);
	        console.log('organisationId', currentTheme.organisationId);
	
	        _this.setState({
	          primarySocialHandle: foundCreator.username,
	          instagramLoading: false,
	          thumbnail: foundCreator.thumbnail,
	          displayName: foundCreator.full_name,
	          name: foundCreator.full_name,
	          foundCreator: foundCreator,
	          instagramLoaded: true,
	          organisationId: currentTheme.organisationId
	        });
	      });
	    };
	
	    _this.getIsValid = function (name, value) {
	      if (name === 'country') return value.length && value.length === 2;
	      if (name === 'name') return value.length && value.length > 3;
	      if (name === 'email') return value.length && (0, _validator.isEmail)(value);
	      return false;
	    };
	
	    _this.handleInputChange = function (e, _ref) {
	      var _this$setState2;
	
	      var name = _ref.name,
	          value = _ref.value;
	
	      var isValid = _this.getIsValid(name, value);
	      _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, name, value), _defineProperty(_this$setState2, name + 'Error', !isValid), _this$setState2));
	    };
	
	    _this.handleEmailChanged = function (e, _ref2) {
	      var _this$setState3;
	
	      var name = _ref2.name,
	          value = _ref2.value;
	
	      console.log(value);
	      var isValid = _this.getIsValid(name, value);
	      _this.setState((_this$setState3 = {}, _defineProperty(_this$setState3, name, value), _defineProperty(_this$setState3, name + 'Error', !isValid), _this$setState3));
	    };
	
	    _this.validateInput = function () {
	      console.log('validating input');
	      var _this$state = _this.state,
	          country = _this$state.country,
	          email = _this$state.email,
	          name = _this$state.name;
	
	      console.log({ country: country, email: email, name: name });
	      var combinedError = {};
	      // check country
	      if (!country) {
	        _lodash2.default.assignIn(combinedError, { countryError: true });
	      }
	
	      if (name.length < 3) {
	        _lodash2.default.assignIn(combinedError, { nameError: true });
	      }
	
	      if (!(0, _validator.isEmail)(email)) {
	        _lodash2.default.assignIn(combinedError, { emailError: true });
	      }
	
	      console.log(combinedError);
	
	      if (_lodash2.default.keys(combinedError).length) {
	        _this.setState(combinedError);
	        return false;
	      }
	      return true;
	    };
	
	    _this.createAccount = function () {
	      if (_this.validateInput()) {
	        var _this$state2 = _this.state,
	            country = _this$state2.country,
	            email = _this$state2.email,
	            name = _this$state2.name,
	            foundCreator = _this$state2.foundCreator,
	            organisationId = _this$state2.organisationId;
	
	        console.log('creating account');
	
	        var payload = {
	          data: {
	            country: country, email: email, name: name, foundCreator: foundCreator, organisationId: organisationId
	          }
	        };
	
	        console.log(payload);
	
	        _this.setState({
	          isFormSubmitted: true
	        });
	
	        return _axios2.default.post(INF_CREATE_API, payload).then(function (r) {
	          var status = r.status,
	              _r$data = r.data,
	              body = _r$data.body,
	              statusCode = _r$data.statusCode;
	
	          console.log(status);
	          console.log(body);
	
	          var _JSON$parse = JSON.parse(body),
	              influencer = _JSON$parse.data.influencer;
	
	          console.log(influencer);
	          if (_lodash2.default.isEqual(statusCode, 200)) {
	            if (_lodash2.default.isEqual(organisationId, MOI_ID)) {
	              _this.setState({
	                openModal: true
	              });
	            } else {
	              _this.props.history.push('/creator/' + influencer.id);
	            }
	          } else {
	            _this.props.history.push('/creator/' + influencer.id);
	          }
	        });
	      }
	      return null;
	    };
	
	    _this.state = {
	      isLoading: false,
	      isError: false,
	      influencer: null,
	      instagramLoading: false,
	      thumbnail: null,
	      primarySocialHandle: null,
	      displayName: null,
	      email: null,
	      emailerror: null,
	      instagramLoaded: false,
	      isFormSubmitted: false,
	      organisationId: null,
	      openModal: false
	    };
	    return _this;
	  }
	
	  _createClass(CreatorNew, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          influencer = _state.influencer,
	          isLoading = _state.isLoading,
	          isError = _state.isError,
	          instagramLoading = _state.instagramLoading,
	          instagramLoaded = _state.instagramLoaded,
	          primarySocialHandle = _state.primarySocialHandle,
	          thumbnail = _state.thumbnail,
	          displayName = _state.displayName,
	          name = _state.name,
	          nameError = _state.nameError,
	          email = _state.email,
	          emailError = _state.emailError,
	          country = _state.country,
	          countryError = _state.countryError,
	          isFormSubmitted = _state.isFormSubmitted,
	          openModal = _state.openModal;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: { paddingTop: 10 } },
	        _react2.default.createElement(_publicHeader2.default, null),
	        _react2.default.createElement(_creatorNewCard2.default, Object.assign({
	          isLoading: isLoading,
	          instagramLoading: instagramLoading,
	          instagramLoaded: instagramLoaded,
	          isError: isError,
	          handleSocialChange: this.handleSocialChange,
	          primarySocialHandle: primarySocialHandle,
	          thumbnail: thumbnail,
	          displayName: displayName,
	          handleInputChange: this.handleInputChange,
	          handleEmailChanged: this.handleEmailChanged,
	          name: name,
	          nameError: nameError,
	          country: country,
	          countryError: countryError,
	          email: email,
	          emailError: emailError,
	          isFormSubmitted: isFormSubmitted,
	          onSubmit: this.createAccount
	        }, influencer)),
	        _react2.default.createElement(
	          _semanticUiReact.Modal,
	          {
	            open: openModal,
	            style: modalStyle,
	            size: 'small'
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Modal.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h2', icon: true },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'signup', color: 'green' }),
	              _react2.default.createElement(
	                'h2',
	                { style: nameStyle },
	                primarySocialHandle
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Header.Subheader,
	                null,
	                'The Instagram handle you have entered is already registered, please DM @moi.digital.hk on Instagram for enquiries or to verify we have the correct contact details.',
	                _react2.default.createElement(_semanticUiReact.Divider, null),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { color: 'grey', onClick: function onClick() {
	                      return _this2.setState({ openModal: false, isFormSubmitted: false });
	                    } },
	                  'close'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreatorNew;
	}(_react.Component);
	
	exports.default = (0, _recompose.compose)(_reactRouter.withRouter, _hasRestClient2.default)(CreatorNew);

/***/ },
/* 2100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axiosRetry = __webpack_require__(168);
	
	var _axiosRetry2 = _interopRequireDefault(_axiosRetry);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(37);
	
	var _reactCsv = __webpack_require__(316);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ramda = __webpack_require__(252);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _recompose = __webpack_require__(15);
	
	var _pagination = __webpack_require__(147);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _influencerTableSettings = __webpack_require__(549);
	
	var _influencerTableSettings2 = _interopRequireDefault(_influencerTableSettings);
	
	var _hasLocalstorageClient = __webpack_require__(127);
	
	var _hasLocalstorageClient2 = _interopRequireDefault(_hasLocalstorageClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _dyzioEmptyState = __webpack_require__(192);
	
	var _dyzioEmptyState2 = _interopRequireDefault(_dyzioEmptyState);
	
	var _approvalCountTable = __webpack_require__(1884);
	
	var _approvalCountTable2 = _interopRequireDefault(_approvalCountTable);
	
	var _approvalCountDetailsTable = __webpack_require__(1883);
	
	var _approvalCountDetailsTable2 = _interopRequireDefault(_approvalCountDetailsTable);
	
	var _unprocessedApprovalsCount = __webpack_require__(2035);
	
	var _unprocessedApprovalsCount2 = _interopRequireDefault(_unprocessedApprovalsCount);
	
	var _influencersTable = __webpack_require__(883);
	
	var _influencersTable2 = _interopRequireDefault(_influencersTable);
	
	var _influencerFilter = __webpack_require__(878);
	
	var _influencerFilter2 = _interopRequireDefault(_influencerFilter);
	
	var _creatorApprovalModal = __webpack_require__(1920);
	
	var _creatorApprovalModal2 = _interopRequireDefault(_creatorApprovalModal);
	
	var _approvalFilter = __webpack_require__(1885);
	
	var _approvalFilter2 = _interopRequireDefault(_approvalFilter);
	
	var _countries = __webpack_require__(93);
	
	var countryList = _interopRequireWildcard(_countries);
	
	var _platforms = __webpack_require__(933);
	
	var _platforms2 = _interopRequireDefault(_platforms);
	
	var _authService = __webpack_require__(21);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _creatorPage = __webpack_require__(909);
	
	var _creatorPage2 = _interopRequireDefault(_creatorPage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HELP_URL = 'https://help.dyzio.co/my-influencers-database/adding-an-influencer-to-your-my-influencers-database';
	
	var businessUnitLabelStyle = {
	  marginLeft: '5px'
	};
	
	var CreatorTable = function (_Component) {
	  _inherits(CreatorTable, _Component);
	
	  function CreatorTable(props) {
	    _classCallCheck(this, CreatorTable);
	
	    var _this = _possibleConstructorReturn(this, (CreatorTable.__proto__ || Object.getPrototypeOf(CreatorTable)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var storedPerPage = localStorage.getItem('' + _staticConfiguration.LS_PER_PAGE_KEY + _authService.authService.uid());
	    var dyzioStorage = props.dyzioStorage,
	        userId = props.userInfo.userId,
	        searchParams = props.searchParams;
	
	    var injectedSearchParams = _lodash2.default.pick(searchParams, ['filter', 'sort', 'currentPage']);
	    var columnsSettings = dyzioStorage.getTableColumnsSettings({ userId: userId });
	
	    _this.state = _extends({
	      term: '',
	      toBeDeleted: null,
	      confirmOpen: false,
	      selected: [],
	      loading: false,
	      loadingCountries: true,
	      links: null,
	      approvalList: [],
	      totalInfluencers: '-',
	      perPage: _lodash2.default.toSafeInteger(storedPerPage) || 25,
	      timeout: null,
	      shortlists: [],
	      countries: [],
	      currentPage: 1,
	      sliderValue: { min: 100000, max: 300000 },
	      clearTags: false,
	      filter: {
	        platform: '',
	        min: '',
	        max: '',
	        country: '',
	        maxInstagramEngagementRate: '',
	        minInstagramEngagementRate: '',
	        hasEmail: true,
	        instagramBusinessAccount: false,
	        instagramPrivate: false
	      },
	      selectedTag: null,
	      sort: {
	        field: 'growth.relative7',
	        order: 'DESC'
	      },
	      errors: {
	        platform: false,
	        slider: false,
	        search: false
	      },
	      filtered: false,
	      name: 'My new shortlist',
	      notes: 'add some notes',
	      createdDate: null,
	      reportUrls: {
	        loading: true,
	        csv: null,
	        xlsx: null
	      },
	      columnsChooseModalVisible: false,
	      columnsSettings: columnsSettings,
	      businessUnits: [],
	      selectedBusinessUnits: JSON.parse(localStorage.getItem('selectedBusinessUnits')) || {},
	      triggerBusinessUnitsFilter: false,
	      settingTab: 0,
	      creatorModalId: null,
	      approvalModeEnabled: _this.props.defaultApprovalModeEnabled,
	      approvalCountry: null,
	      approvalListLoading: false,
	      isPatchingCreator: false
	    }, injectedSearchParams);
	    _this.restClient = _axios2.default.create({
	      timeout: 30000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    _this.jsonClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	      header: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    _this.publicAccessClient = props.buildRESTClient({
	      baseURL: ("https://u0f13udpl7.execute-api.eu-west-3.amazonaws.com/production"),
	      hasToken: true,
	      timeout: 30000
	    });
	    (0, _axiosRetry2.default)(_this.restClient, {
	      retries: 3,
	      delay: 100
	    });
	    return _this;
	  }
	
	  _createClass(CreatorTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var organisationId = this.props.organisationId;
	
	
	      var onPrivateLinkClickons = {
	        filter: {
	          organisation: organisationId
	        },
	        sort: '-createdDate'
	      };
	
	      var options = {
	        filter: {
	          organisation: organisationId
	        },
	        sort: '-createdDate'
	      };
	
	      this.jsonClient.find('shortlists', options) // eslint-disable-line lodash/prefer-lodash-method
	      .then(function (lists) {
	        var listsJson = _lodash2.default.map(lists, function (list) {
	          return list.toJSONTree();
	        });
	        _this2.setState({
	          shortlists: listsJson
	        });
	      });
	
	      var countriesBaseUrl = ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production");
	      var countriesEndpoint = '/countries/' + organisationId;
	      var countriesFullUrl = countriesBaseUrl.concat(countriesEndpoint);
	
	      this.restClient.get(countriesFullUrl).then(function (response) {
	        var rows = response.data.data;
	        var countries = _lodash2.default.flatMap(rows, _this2.formatCountries);
	
	        _this2.setState({
	          countries: countries,
	          loadingCountries: false
	        });
	      }).catch(function (e) {
	        (0, _errorHandlingService.reportError)('could not fetch countries', e);
	      });
	
	      this.restClient.get(("https://api2.dyzio.co/v1") + '/businessUnits?filter[organisation]=' + organisationId).then(function (response) {
	        var data = _lodash2.default.get(response, 'data.data', []);
	        var businessUnits = _lodash2.default.map(data, function (businessUnit) {
	          return {
	            key: _lodash2.default.get(businessUnit, 'id'),
	            value: _lodash2.default.get(businessUnit, 'id'),
	            text: _lodash2.default.get(businessUnit, 'attributes.value')
	          };
	        });
	        _this2.setState({
	          businessUnits: businessUnits
	        });
	      }).catch(function (e) {
	        (0, _errorHandlingService.reportError)('could not fetch business units', e);
	      });
	
	      this.fetchReportUrls();
	      this.fetchApprovalList();
	      this.fetchApprovalCount();
	      this.fetchLastWeekApprovalCount();
	      this.fetchUnprocessedApprovalsCount();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          sort = _state.sort,
	          mainListLoading = _state.loading,
	          approvalListLoading = _state.approvalListLoading,
	          loadingCountries = _state.loadingCountries,
	          countries = _state.countries,
	          links = _state.links,
	          perPage = _state.perPage,
	          totalInfluencers = _state.totalInfluencers,
	          currentPage = _state.currentPage,
	          filtered = _state.filtered,
	          shortlists = _state.shortlists,
	          errors = _state.errors,
	          selected = _state.selected,
	          confirmOpen = _state.confirmOpen,
	          createdDate = _state.createdDate,
	          reportUrls = _state.reportUrls,
	          columnsChooseModalVisible = _state.columnsChooseModalVisible,
	          columnsSettings = _state.columnsSettings,
	          selectedTag = _state.selectedTag,
	          businessUnits = _state.businessUnits,
	          selectedBusinessUnits = _state.selectedBusinessUnits,
	          settingTab = _state.settingTab,
	          creatorModalId = _state.creatorModalId,
	          approvalModeEnabled = _state.approvalModeEnabled,
	          approvalCountry = _state.approvalCountry,
	          approvalList = _state.approvalList,
	          isPatchingCreator = _state.isPatchingCreator,
	          patchError = _state.patchError,
	          isLoadingCountData = _state.isLoadingCountData,
	          processedCreatorsData = _state.processedCreatorsData,
	          lastWeekCreatorsData = _state.lastWeekCreatorsData,
	          isLoadingLastWeekData = _state.isLoadingLastWeekData,
	          unprocessedData = _state.unprocessedData,
	          isLoadingUnprocessedData = _state.isLoadingUnprocessedData,
	          showPeriodDetailsData = _state.showPeriodDetailsData,
	          creatorDetailsId = _state.creatorDetailsId,
	          isExportingData = _state.isExportingData,
	          exportData = _state.exportData,
	          creatorsFetched = _state.creatorsFetched;
	      var _props = this.props,
	          organisationId = _props.organisationId,
	          searchParams = _props.searchParams,
	          usesGlobalTags = _props.usesGlobalTags,
	          displayAuthorisedData = _props.displayAuthorisedData;
	
	
	      var injectedSearchParams = _lodash2.default.pick(searchParams, ['filter', 'sort', 'currentPage']);
	
	      var from = (currentPage - 1) * perPage + 1;
	      var to = links ? from - 1 + links.length : perPage;
	
	      var totalPages = _lodash2.default.isFinite(totalInfluencers) && !approvalModeEnabled ? Math.ceil(totalInfluencers / perPage) : 1;
	      var noInfluencers = approvalModeEnabled ? _lodash2.default.isEmpty(approvalList) : totalInfluencers === 0;
	      var withActions = selected.length > 0;
	
	      var isSearchContext = !_lodash2.default.isEmpty(_lodash2.default.pickBy(_lodash2.default.get(injectedSearchParams, 'filter', {}), _lodash2.default.identity)) || !_lodash2.default.isNil(selectedTag);
	
	      var organisation = {
	        id: this.props.organisationId,
	        slug: this.props.organisationSlug
	      };
	
	      var emptyStateWrapper = {
	        marginTop: 120
	      };
	
	      var businessUnitsFiltered = !_lodash2.default.isEmpty(_lodash2.default.filter(_lodash2.default.get(selectedBusinessUnits, 'businessUnits'), function (bu) {
	        return bu.selected;
	      }));
	
	      var loading = approvalModeEnabled ? approvalListLoading : mainListLoading;
	      var showApprovalModeEmptyMessage = !approvalCountry && approvalModeEnabled;
	
	      var isRefetchingCountData = isLoadingCountData && !_lodash2.default.isEmpty(processedCreatorsData);
	      var isRefetchingLastWeekData = isLoadingLastWeekData && !_lodash2.default.isEmpty(lastWeekCreatorsData);
	      var isRefetchingUnprocessedData = isLoadingUnprocessedData && !_lodash2.default.isEmpty(unprocessedData);
	
	      var showNoDataFetchedMessage = !loading && !approvalModeEnabled && !creatorsFetched;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 12, verticalAlign: 'middle', textAlign: 'right' },
	                  approvalModeEnabled && _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Found ',
	                    _lodash2.default.size(approvalList),
	                    ' creators'
	                  ),
	                  !approvalModeEnabled && _react2.default.createElement(
	                    'h3',
	                    null,
	                    filtered ? 'showing matching influencers' : from + ' - ' + to + ' of ' + totalInfluencers + ' creators'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 3, textAlign: 'right' },
	                  _react2.default.createElement(_pagination2.default, {
	                    onPageIncrement: this.incrementPage,
	                    onPageDecrement: this.decrementPage,
	                    currentPage: currentPage,
	                    totalPages: totalPages
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 1, textAlign: 'center', verticalAlign: 'middle' },
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                      circular: true, inverted: true, color: 'green', icon: 'settings', onClick: this.toggleColumnChooserModal
	                    }),
	                    content: 'Click here to show/hide table columns...'
	                  })
	                )
	              ),
	              businessUnitsFiltered && _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                { className: 'padding5' },
	                _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 4 }),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 12, verticalAlign: 'middle', textAlign: 'left' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Segment,
	                    { className: 'padding5' },
	                    _react2.default.createElement(
	                      'table',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          { style: { backgroundColor: '#eee', border: '1px solid #ddd', padding: '10px' } },
	                          'Business Unit / Brand'
	                        ),
	                        _lodash2.default.map(_lodash2.default.get(selectedBusinessUnits, 'businessUnits'), function (businessUnit) {
	                          if (businessUnit.selected) {
	                            return _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(_semanticUiReact.Popup, {
	                                trigger: _react2.default.createElement(_semanticUiReact.Label, {
	                                  style: businessUnitLabelStyle,
	                                  color: 'pink',
	                                  basic: true,
	                                  content: businessUnit.text
	                                }),
	                                content: 'use the settings screen too remove the filter'
	                              })
	                            );
	                          }
	                          return '';
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 4 },
	                  _react2.default.createElement(_semanticUiReact.Radio, {
	                    toggle: true,
	                    defaultChecked: approvalModeEnabled,
	                    label: 'Approval mode',
	                    onChange: this.toggleApprovalMode
	                  }),
	                  !approvalModeEnabled && _react2.default.createElement(_influencerFilter2.default, Object.assign({
	                    reportUrls: reportUrls,
	                    currentPerPage: perPage,
	                    onSearchFormSubmit: this.handleSearchButtonClick,
	                    onPerPageChange: this.handlePerPageChange,
	                    isLoadingCountries: loadingCountries,
	                    isLoading: loading,
	                    countries: countries,
	                    platforms: _platforms2.default,
	                    defaultSearchType: 'instagramHashtags',
	                    withEmailCheckbox: true,
	                    withInstagramPrivateCheckbox: true,
	                    withBusinessAccountCheckbox: true
	                  }, injectedSearchParams)),
	                  approvalModeEnabled && _react2.default.createElement(_approvalFilter2.default, { selectedFilter: approvalCountry, onFilterChanged: this.onApprovalCountryChanged }),
	                  approvalModeEnabled && _react2.default.createElement(_approvalCountTable2.default, {
	                    items: _lodash2.default.get(processedCreatorsData, 'items'),
	                    targets: _lodash2.default.get(processedCreatorsData, 'targets'),
	                    isLoading: isLoadingCountData && !isRefetchingCountData,
	                    isRefetching: isRefetchingCountData,
	                    onRefetch: this.fetchApprovalCount,
	                    title: 'Today'
	                  }),
	                  approvalModeEnabled && _react2.default.createElement(_approvalCountTable2.default, {
	                    items: _lodash2.default.get(lastWeekCreatorsData, 'items'),
	                    targets: _lodash2.default.get(lastWeekCreatorsData, 'targets'),
	                    isLoading: isLoadingLastWeekData && !isRefetchingLastWeekData,
	                    isRefetching: isRefetchingLastWeekData,
	                    onRefetch: this.fetchLastWeekApprovalCount,
	                    title: 'Last Week',
	                    onClick: this.togglePeriodDetailsModal
	                  }),
	                  approvalModeEnabled && _react2.default.createElement(_unprocessedApprovalsCount2.default, {
	                    items: unprocessedData,
	                    isLoading: isLoadingUnprocessedData && !isRefetchingUnprocessedData,
	                    isRefetching: isRefetchingUnprocessedData,
	                    onRefetch: this.fetchUnprocessedApprovalsCount,
	                    title: 'Pipeline'
	                  }),
	                  !approvalModeEnabled && _react2.default.createElement(
	                    _semanticUiReact.Segment,
	                    { textAlign: 'center' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkify' }),
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/my-requests' },
	                      'My requests'
	                    )
	                  ),
	                  !approvalModeEnabled && !_lodash2.default.isEmpty(exportData) && _react2.default.createElement(
	                    _semanticUiReact.Segment,
	                    { textAlign: 'center' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'download' }),
	                    _react2.default.createElement(_semanticUiReact.Popup, {
	                      trigger: isExportingData ? _react2.default.createElement(
	                        'span',
	                        null,
	                        'Loading...'
	                      ) : _react2.default.createElement(
	                        _reactCsv.CSVLink,
	                        {
	                          data: this.getCreatorsExportData(),
	                          filename: 'creators-' + currentPage + '.csv'
	                        },
	                        isExportingData ? 'Loading...' : 'Export creators CSV'
	                      ),
	                      content: 'Click here to export creators in CSV'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 12 },
	                  !loading && noInfluencers && _react2.default.createElement(
	                    'div',
	                    { style: emptyStateWrapper },
	                    _react2.default.createElement(_dyzioEmptyState2.default, {
	                      context: 'INFLUENCER',
	                      buttonLabel: 'Add a creator',
	                      onClick: _lodash2.default.noop,
	                      helpUrl: HELP_URL,
	                      content: _react2.default.createElement(
	                        'div',
	                        null,
	                        showApprovalModeEmptyMessage && _react2.default.createElement(
	                          'p',
	                          null,
	                          'There is no country selected, please select a country in order to get the list of creators'
	                        ),
	                        !showApprovalModeEmptyMessage && _react2.default.createElement(
	                          'p',
	                          null,
	                          !isSearchContext && !businessUnitsFiltered ? 'You have not saved any influencers!' : 'No search results!'
	                        ),
	                        !isSearchContext && !showApprovalModeEmptyMessage && _react2.default.createElement(
	                          'p',
	                          null,
	                          'Use the button below to add your first.'
	                        )
	                      )
	                    })
	                  ),
	                  showNoDataFetchedMessage && _react2.default.createElement(
	                    'div',
	                    { style: emptyStateWrapper },
	                    _react2.default.createElement(_dyzioEmptyState2.default, {
	                      context: 'INFLUENCER',
	                      buttonLabel: 'Add a creator',
	                      onClick: _lodash2.default.noop,
	                      helpUrl: HELP_URL,
	                      content: _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Please press search for fetching creators'
	                        ),
	                        !isSearchContext && !showApprovalModeEmptyMessage && _react2.default.createElement(
	                          'p',
	                          null,
	                          'Use the button below to add your first.'
	                        )
	                      )
	                    })
	                  ),
	                  (!noInfluencers || loading) && !showNoDataFetchedMessage && _react2.default.createElement(_influencersTable2.default, {
	                    displayAuthorisedData: displayAuthorisedData,
	                    columnsSettings: columnsSettings,
	                    createdDate: createdDate,
	                    withActions: withActions,
	                    organisation: organisation,
	                    selected: selected,
	                    links: approvalModeEnabled ? approvalList : links,
	                    errors: errors,
	                    loading: loading,
	                    sort: sort,
	                    shortlists: shortlists,
	                    handleCheckAllInfluencers: this.handleCheckAllInfluencers,
	                    handleDeleteInfluencer: this.handleDeleteInfluencer,
	                    handleSaveShortlist: this.handleSaveShortlist,
	                    patchShortlist: this.patchShortlist,
	                    incrementPage: this.incrementPage,
	                    decrementPage: this.decrementPage,
	                    handleDeleteQueue: this.handleDeleteQueue,
	                    handleSorting: this.handleSorting,
	                    handlePageRedirect: this.handlePageRedirect,
	                    handleCheckChange: this.handleCheckChange,
	                    influencerPageRedirect: this.handleRedirectToInfluencerProfile,
	                    tryAgainCallback: this.fetchIf,
	                    reportUrls: reportUrls
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Modal,
	            {
	              size: 'tiny',
	              open: confirmOpen,
	              onClose: this.popupToggleHandler,
	              closeOnEscape: true
	            },
	            _react2.default.createElement(
	              _semanticUiReact.Modal.Content,
	              null,
	              _react2.default.createElement(
	                'h5',
	                { className: 'align-center' },
	                'Are you sure you want to delete',
	                ' ',
	                selected.length === 1 ? 'this influencer' : 'these influencers',
	                '?'
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              _react2.default.createElement(
	                _semanticUiReact.List,
	                { divided: true, relaxed: true },
	                _lodash2.default.map(selected, function (influencer) {
	                  return _react2.default.createElement(
	                    _semanticUiReact.List.Item,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Image, { src: influencer.thumbnail, avatar: true }),
	                    _react2.default.createElement(
	                      _semanticUiReact.List.Content,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.List.Header,
	                        null,
	                        influencer.name
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.List.Description,
	                        { as: 'span' },
	                        '@' + influencer.primarySocialHandle
	                      )
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              _react2.default.createElement(
	                'div',
	                { className: 'align-right' },
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { onClick: this.popupToggleHandler, color: 'grey' },
	                  'Nope'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { color: 'pink', onClick: this.deleteSelectedInfluencers },
	                  'Do it!'
	                )
	              )
	            )
	          ),
	          columnsChooseModalVisible && _react2.default.createElement(_influencerTableSettings2.default, {
	            onClose: this.toggleColumnChooserModal,
	            onColumnCheckboxChange: this.onColumnCheckboxChange,
	            onBusinessUnitsChange: this.onBusinessUnitsChange,
	            columnsSettings: columnsSettings,
	            selectedBusinessUnits: selectedBusinessUnits,
	            businessUnits: businessUnits,
	            tab: settingTab
	          }),
	          creatorModalId && _react2.default.createElement(_creatorApprovalModal2.default, {
	            influencerId: creatorModalId,
	            onClose: function onClose() {
	              _this3.setState({ creatorModalId: null });
	            },
	            onApprove: this.onCreatorApprove,
	            onReject: this.onCreatorReject,
	            error: patchError,
	            onSkip: this.onCreatorSkip,
	            isPatchingCreator: isPatchingCreator
	          }),
	          showPeriodDetailsData && lastWeekCreatorsData && _react2.default.createElement(
	            _dyzioModal2.default,
	            { headerText: 'Processed creators by date', onClose: this.togglePeriodDetailsModal },
	            _react2.default.createElement(_approvalCountDetailsTable2.default, { data: lastWeekCreatorsData.items })
	          ),
	          creatorDetailsId && _react2.default.createElement(
	            _semanticUiReact.Modal,
	            {
	              size: 'fullscreen',
	              open: true,
	              onClose: this.closeCreatorDetailsModal,
	              closeOnEscape: true
	            },
	            _react2.default.createElement(
	              _semanticUiReact.Modal.Content,
	              null,
	              _react2.default.createElement(_creatorPage2.default, { creatorId: creatorDetailsId, asModal: true, onBackClick: this.closeCreatorDetailsModal })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreatorTable;
	}(_react.Component);
	
	CreatorTable.contextTypes = {
	  router: _propTypes2.default.object
	};
	CreatorTable.propTypes = {
	  organisationId: _propTypes2.default.string.isRequired,
	  organisationSlug: _propTypes2.default.string.isRequired,
	  usesGlobalTags: _propTypes2.default.bool.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.onColumnCheckboxChange = function (e, data) {
	    var platform = data.label,
	        displayed = data.checked;
	    var columnsSettings = _this4.state.columnsSettings;
	
	    _lodash2.default.set(columnsSettings, 'columns.' + _lodash2.default.snakeCase(_lodash2.default.lowerCase(platform)) + '.displayed', displayed);
	    _this4.setState({
	      columnsSettings: columnsSettings,
	      settingTab: 0
	    });
	  };
	
	  this.onBusinessUnitsChange = function (e, data) {
	    var businessUnit = data.label,
	        selected = data.checked,
	        id = data.id;
	    var selectedBusinessUnits = _this4.state.selectedBusinessUnits;
	
	    _lodash2.default.set(selectedBusinessUnits, 'businessUnits.' + _lodash2.default.snakeCase(_lodash2.default.lowerCase(businessUnit)) + '.selected', selected);
	    _lodash2.default.set(selectedBusinessUnits, 'businessUnits.' + _lodash2.default.snakeCase(_lodash2.default.lowerCase(businessUnit)) + '.text', businessUnit);
	    _lodash2.default.set(selectedBusinessUnits, 'businessUnits.' + _lodash2.default.snakeCase(_lodash2.default.lowerCase(businessUnit)) + '.id', id);
	    localStorage.setItem('selectedBusinessUnits', JSON.stringify(selectedBusinessUnits));
	
	    _this4.setState({
	      selectedBusinessUnits: selectedBusinessUnits,
	      settingTab: 1,
	      triggerBusinessUnitsFilter: true
	    });
	  };
	
	  this.getFilterText = function (filter, term) {
	    var text = '';
	    text += term ? '<p>search term: ' + term + '</p>' : '';
	    text += filter.country ? '<p>country: ' + filter.country + '</p>' : '';
	    text += filter.platform ? '<p>channel: ' + filter.platform + '</p>' : '';
	    text += filter.min ? '<p>more than: ' + filter.min + ' followers</p>' : '';
	    text += filter.max ? '<p>less than: ' + filter.max + ' followers</p>' : '';
	    return text;
	  };
	
	  this.setPage = function (step) {
	    var currentPage = _this4.state.currentPage;
	    var onSearchParamsChange = _this4.props.onSearchParamsChange;
	
	    currentPage += step;
	    _this4.setState({ currentPage: currentPage }, _this4.fetch);
	    onSearchParamsChange({ currentPage: currentPage });
	  };
	
	  this.patchShortlist = function (event, data) {
	    var shortlistId = data.value;
	    var _state2 = _this4.state,
	        shortlists = _state2.shortlists,
	        selected = _state2.selected;
	
	    var shortlist = _lodash2.default.find(shortlists, { id: shortlistId });
	    var oldInfluencers = shortlist.influencers;
	    var oldLinks = shortlist.influencerLinks;
	
	    var newInfluencers = _lodash2.default.map(selected, function (influencer) {
	      return { type: 'influencer', id: influencer.id };
	    });
	    var newLinks = _lodash2.default.map(selected, function (row) {
	      return { type: 'influencerLink', id: row.linkId };
	    });
	
	    var union = _lodash2.default.union(oldInfluencers, newInfluencers);
	    var linksUnion = _lodash2.default.union(oldLinks, newLinks);
	
	    var patch = {
	      data: {
	        type: 'shortlists',
	        attributes: {
	          influencers: _lodash2.default.uniqBy(union, 'id'),
	          influencerLinks: _lodash2.default.uniqBy(linksUnion, 'id')
	        }
	      }
	    };
	
	    _this4.restClient.patch(("https://api2.dyzio.co/v1") + '/shortlists/' + shortlistId, patch).then(_this4.context.router.push('/shortlists/' + shortlistId)).catch(function (e) {
	      (0, _errorHandlingService.reportError)('could not patch shortlist', e);
	    });
	  };
	
	  this.handleDeleteQueue = function (e, _ref) {
	    var value = _ref.value;
	
	    _this4.setState({
	      toBeDeleted: value.id,
	      confirmOpen: true,
	      influencerName: value.name
	    });
	  };
	
	  this.checkReportFilePresence = function (fileName, fileType) {
	    var reportUrls = _this4.state.reportUrls;
	
	    _this4.restClient.get(("https://1hweifjj4e.execute-api.eu-west-1.amazonaws.com/production/report") + '/' + fileName).then(function (response) {
	      var signedUrl = response.data.body.signedUrl;
	
	      reportUrls[fileType] = signedUrl;
	      reportUrls.loading = false;
	      _this4.setState({
	        reportUrls: reportUrls
	      });
	    }).catch(function () {
	      reportUrls[fileType] = null;
	      reportUrls.loading = false;
	      _this4.setState({
	        reportUrls: reportUrls
	      });
	    });
	  };
	
	  this.setCreatorAttribute = function (id, attribute, rejectionReason) {
	    var restClient = _this4.props.restClient;
	
	    _this4.setState({ isPatchingCreator: true });
	    var attributes = {
	      elemisApprovalStatus: attribute,
	      elemisApprovalDate: new Date()
	    };
	    if (rejectionReason) {
	      attributes.rejectionReason = rejectionReason;
	    }
	    var payload = {
	      data: {
	        attributes: attributes
	      }
	    };
	    return restClient.patch('/creators/' + id, payload).then(function (r) {
	      _this4.setState({ isPatchingCreator: false, patchError: r.data ? null : true });
	      return r.data;
	    }).catch(function (err) {
	      _this4.setState({ isPatchingCreator: false, patchError: err });
	    });
	  };
	
	  this.loadNexCreator = function (removeCurrent) {
	    _this4.setState(function (prev) {
	      var approvalList = prev.approvalList,
	          creatorModalId = prev.creatorModalId;
	
	      var creatorIndex = _lodash2.default.findIndex(approvalList, ['id', creatorModalId]);
	      var nextCreatorId = _lodash2.default.get(approvalList, '[' + (creatorIndex + 1) + '].id');
	      var list = [].concat(_toConsumableArray(approvalList));
	      if (removeCurrent) {
	        _lodash2.default.pullAt(list, creatorIndex);
	      }
	      return { approvalList: list, creatorModalId: nextCreatorId, patchError: null };
	    });
	  };
	
	  this.onCreatorApprove = function (id) {
	    _this4.setCreatorAttribute(id, 'APPROVED').then(function (data) {
	      if (data) {
	        _this4.loadNexCreator(true);
	      }
	    });
	  };
	
	  this.onCreatorReject = function (id, reason) {
	    _this4.setCreatorAttribute(id, 'REJECTED', reason).then(function (data) {
	      if (data) {
	        _this4.loadNexCreator(true);
	      }
	    });
	  };
	
	  this.onCreatorSkip = function () {
	    _this4.loadNexCreator(false);
	  };
	
	  this.fetch = function (searchParams) {
	    _this4.setState({
	      loading: true
	    });
	
	    var MIN_SEARCH_LENGTH = 2;
	    var _state3 = _this4.state,
	        perPage = _state3.perPage,
	        currentPage = _state3.currentPage,
	        filter = _state3.filter,
	        sort = _state3.sort,
	        selectedBusinessUnits = _state3.selectedBusinessUnits;
	    var term = filter.term,
	        searchType = filter.searchType;
	    var _props2 = _this4.props,
	        organisationId = _props2.organisationId,
	        cacheBuster = _props2.cacheBuster;
	    var clearTags = _this4.state.clearTags;
	
	
	    var search = {};
	    if (searchParams) {
	      if (searchParams.brandTag) {
	        search.brandTag = searchParams.brandTag;
	      } else {
	        var tag = searchParams.tag;
	
	        search.searchTerm = tag;
	        search.tagSearch = true;
	      }
	    } else {
	      if (term && term.length >= MIN_SEARCH_LENGTH) {
	        search[searchType || 'handles'] = term;
	      }
	      search.hasEmail = filter.hasEmail;
	      search.instagramBusinessAccount = filter.instagramBusinessAccount;
	      search.instagramPrivate = filter.instagramPrivate;
	      if (filter.platform) {
	        if (_lodash2.default.isEqual(filter.platform, 'instagram')) {
	          if (filter.minInstagramEngagementRate > 0) {
	            search.minInstagramEngagementRate = _lodash2.default.toNumber(filter.minInstagramEngagementRate);
	          }
	          if (filter.maxInstagramEngagementRate > 0) {
	            search.maxInstagramEngagementRate = _lodash2.default.toNumber(filter.maxInstagramEngagementRate);
	          }
	        }
	
	        if (filter.min > 0) {
	          search.moreThan = _lodash2.default.parseInt(filter.min);
	          search.platform = filter.platform;
	        }
	        if (filter.max > 0) {
	          search.lessThan = _lodash2.default.parseInt(filter.max);
	          search.platform = filter.platform;
	        }
	      }
	
	      if (filter.country) {
	        search.country = '' + filter.country;
	      }
	
	      clearTags = true;
	    }
	
	    var selectedNewTag = _lodash2.default.get(_this4.state, 'selectedTag');
	
	    if (selectedNewTag) {
	      search.tagIds = selectedNewTag;
	    }
	
	    var businessUnitsFilter = _lodash2.default.filter(_lodash2.default.get(selectedBusinessUnits, 'businessUnits'), function (bu) {
	      return bu.selected;
	    });
	
	    if (!_lodash2.default.isEmpty(businessUnitsFilter)) {
	      search.businessUnitIds = _lodash2.default.map(businessUnitsFilter, function (bu) {
	        return bu.id;
	      });
	    }
	
	    // ADD business Units Param to search
	
	    if (_lodash2.default.isEmpty(search)) {
	      _this4.setState({ filtered: false });
	    } else {
	      _this4.setState({ filtered: true });
	    }
	
	    if (cacheBuster.cb) {
	      // remove the CB
	      var loc = window.location;
	      var barePath = '' + loc.origin + loc.pathname;
	      _reactRouter.browserHistory.push(barePath);
	      sort.field = 'createdDate';
	      sort.order = 'DESC';
	    }
	
	    var request = {
	      data: {
	        organisationId: organisationId,
	        perPage: perPage,
	        currentPage: currentPage,
	        search: search,
	        sort: sort,
	        cacheBuster: cacheBuster
	      }
	    };
	
	    _this4.fetchExportData({ data: _extends({}, request.data, { perPage: 1000 }) });
	    var searchURI = encodeURIComponent(JSON.stringify(request));
	
	    var errors = _this4.state.errors;
	
	    var url = ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production") + '/creators/filter/' + searchURI;
	
	    _this4.restClient.get(url).then(function (r) {
	      var totalInfluencers = _lodash2.default.get(r, 'data.body.data.metadata.total', 0);
	      var results = _lodash2.default.filter(r.data.body.data.data || [], _this4.filterInfluencers);
	
	      var mappedResults = _lodash2.default.map(results, function (item) {
	        return _extends({}, item, { lookupInfluencer: _extends({}, item) });
	      });
	      errors.search = false;
	      _this4.setState({
	        links: mappedResults,
	        loading: false,
	        loadingInfluencerFailed: false,
	        totalInfluencers: totalInfluencers,
	        errors: errors,
	        createdDate: _moment2.default.now(),
	        clearTags: clearTags,
	        creatorsFetched: true
	      });
	    }).catch(function (ex) {
	      errors.search = true;
	      _this4.setState({
	        errors: errors,
	        loading: false,
	        clearTags: clearTags,
	        creatorsFetched: true
	      });
	    });
	  };
	
	  this.fetchApprovalList = function () {
	    var approvalCountry = _this4.state.approvalCountry;
	
	
	    if (!approvalCountry || _lodash2.default.isEmpty(approvalCountry)) {
	      return;
	    }
	    _this4.setState({
	      approvalListLoading: true
	    });
	
	    var ITALY_SPAIN_FLOOR = 2000;
	    var organisationId = _this4.props.organisationId;
	
	    var instagramCountFilter = _lodash2.default.includes(['IT', 'ES'], approvalCountry.country) ? { moreThan: ITALY_SPAIN_FLOOR } : {};
	    var request = {
	      data: {
	        organisationId: organisationId,
	        search: _extends({ country: approvalCountry.country }, instagramCountFilter)
	      }
	    };
	
	    var searchURI = encodeURIComponent(JSON.stringify(request));
	
	    var errors = _this4.state.errors;
	
	    var url = ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production") + '/creators/v2/filter/approval/' + searchURI;
	
	    _this4.restClient.get(url).then(function (r) {
	      var results = _lodash2.default.filter(r.data.body.data.data || [], _this4.filterInfluencers);
	      var mappedResults = _lodash2.default.map(results, function (item) {
	        return _extends({}, item, { lookupInfluencer: _extends({}, item), lookupDetails: _extends({}, item) });
	      });
	      errors.search = false;
	
	      _this4.setState({
	        approvalList: mappedResults,
	        approvalListLoading: false,
	        loadingInfluencerFailed: false,
	        errors: errors,
	        createdDate: _moment2.default.now()
	      });
	    }).catch(function (ex) {
	      errors.search = true;
	      console.log('Error: ', ex);
	      _this4.setState({
	        errors: errors,
	        approvalListLoading: false
	      });
	    });
	  };
	
	  this.fetchLatestProcessedList = function () {
	    var organisationId = _this4.props.organisationId;
	    var approvalCountry = _this4.state.approvalCountry;
	
	    if (!_lodash2.default.get(approvalCountry, 'status')) {
	      return;
	    }
	    _this4.setState({
	      approvalListLoading: true
	    });
	    var request = {
	      data: {
	        organisationId: organisationId,
	        country: approvalCountry.country,
	        approvalStatus: _lodash2.default.toUpper(approvalCountry.status)
	      }
	    };
	    var searchURI = encodeURIComponent(JSON.stringify(request));
	
	    var errors = _this4.state.errors;
	
	    var url = ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production") + '/creators/approval/latest/' + searchURI;
	
	    _this4.restClient.get(url).then(function (r) {
	      var results = _lodash2.default.filter(r.data.body.data.data || [], _this4.filterInfluencers);
	      var mappedResults = _lodash2.default.map(results, function (item) {
	        return _extends({}, item, { lookupInfluencer: _extends({}, item), lookupDetails: _extends({}, item) });
	      });
	      errors.search = false;
	
	      _this4.setState({
	        approvalList: mappedResults,
	        approvalListLoading: false,
	        loadingInfluencerFailed: false,
	        errors: errors,
	        createdDate: _moment2.default.now()
	      });
	    }).catch(function (ex) {
	      errors.search = true;
	      console.log('Error: ', ex);
	      _this4.setState({
	        errors: errors,
	        approvalListLoading: false
	      });
	    });
	  };
	
	  this.fetchUnprocessedApprovalsCount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	    var response, results;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _this4.setState({ isLoadingUnprocessedData: true });
	            _context.next = 3;
	            return _this4.publicAccessClient.get('/creators/elemis/count').catch(function () {
	              _this4.setState({
	                isLoadingUnprocessedData: false
	              });
	            });
	
	          case 3:
	            response = _context.sent;
	
	            if (response) {
	              _context.next = 7;
	              break;
	            }
	
	            _this4.setState({
	              isLoadingUnprocessedData: false
	            });
	            return _context.abrupt('return');
	
	          case 7:
	            results = _lodash2.default.get(response, 'data.data', []);
	
	            _this4.setState({
	              isLoadingUnprocessedData: false,
	              unprocessedData: results
	            });
	
	          case 9:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this4);
	  }));
	
	  this.fetchApprovalCount = function () {
	    var restClient = _this4.props.restClient;
	
	    var request = {
	      data: {
	        search: { startDate: new Date() }
	      }
	    };
	
	    var searchURI = encodeURIComponent(JSON.stringify(request));
	    var url = ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production") + '/creators/approval/count/' + searchURI;
	    _this4.setState({ isLoadingCountData: true });
	    restClient.get(url).then(function (r) {
	      var results = r.data.body.data;
	      _this4.setState({
	        processedCreatorsData: results,
	        isLoadingCountData: false
	      });
	    }).catch(function (err) {
	      _this4.setState({
	        isLoadingCountData: false
	      });
	    });
	  };
	
	  this.fetchLastWeekApprovalCount = function () {
	    var restClient = _this4.props.restClient;
	
	    var request = {
	      data: {
	        search: { startDate: (0, _moment2.default)().subtract(1, 'week').toDate() }
	      }
	    };
	    var searchURI = encodeURIComponent(JSON.stringify(request));
	    var url = ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production") + '/creators/approval/count/' + searchURI;
	    _this4.setState({ isLoadingLastWeekData: true });
	    restClient.get(url).then(function (r) {
	      var results = r.data.body.data;
	      _this4.setState({
	        lastWeekCreatorsData: results,
	        isLoadingLastWeekData: false
	      });
	    }).catch(function (err) {
	      _this4.setState({
	        isLoadingLastWeekData: false
	      });
	    });
	  };
	
	  this.filterInfluencers = function (influencer) {
	    var term = _this4.state.term;
	    var contentTags = influencer.contentTags,
	        brandTags = influencer.brandTags;
	
	    var tags = _lodash2.default.concat(contentTags || [], brandTags || []).join(',');
	    var conditions = [_lodash2.default.includes(influencer.name, term), _lodash2.default.includes(influencer.primarySocialHandle, term), _lodash2.default.includes(tags, term)];
	    return _ramda2.default.anyPass(conditions);
	  };
	
	  this.handleSaveShortlist = function () {
	    var _state4 = _this4.state,
	        name = _state4.name,
	        selected = _state4.selected,
	        filter = _state4.filter,
	        term = _state4.term;
	    var organisationId = _this4.props.organisationId;
	
	
	    var filterText = _this4.getFilterText(filter, term);
	
	    var shortlist = _this4.jsonClient.create('shortlists');
	    shortlist.set('name', name);
	    shortlist.set('notes', filterText || 'notes for the shortlist...');
	    shortlist.set('organisation', {
	      type: 'organisations',
	      id: organisationId
	    });
	    shortlist.set('dataMap', {});
	    shortlist.set('selectedPlatforms', { instagram: true });
	    var influencers = _lodash2.default.map(selected, function (row) {
	      return { type: 'influencer', id: row.id };
	    });
	    var links = _lodash2.default.map(selected, function (row) {
	      return { type: 'influencerLink', id: row.linkId };
	    });
	
	    shortlist.set('influencers', _lodash2.default.uniqBy(influencers, 'id'));
	    shortlist.set('influencerLinks', _lodash2.default.uniqBy(links, 'id'));
	
	    shortlist.sync().then(function (list) {
	      var listJson = list.toJSON();
	      _this4.context.router.push('/shortlists/' + listJson.id);
	    });
	  };
	
	  this.handleCheckChange = function (e, _ref3) {
	    var checked = _ref3.checked,
	        value = _ref3.value;
	    var selected = _this4.state.selected;
	
	    var newSelected = _lodash2.default.clone(selected);
	    if (checked) {
	      newSelected.push(value);
	    } else {
	      _lodash2.default.remove(newSelected, { id: value.id });
	    }
	
	    _this4.setState({
	      selected: newSelected
	    });
	  };
	
	  this.incrementPage = function () {
	    _this4.setPage(1);
	  };
	
	  this.decrementPage = function () {
	    _this4.setPage(-1);
	  };
	
	  this.handleRedirectToInfluencerProfile = function (id) {
	    var approvalModeEnabled = _this4.state.approvalModeEnabled;
	
	    if (approvalModeEnabled) {
	      _this4.setState({ creatorModalId: id });
	    } else {
	      _this4.setState({ creatorDetailsId: id });
	    }
	  };
	
	  this.closeCreatorDetailsModal = function () {
	    _this4.setState({ creatorDetailsId: null });
	  };
	
	  this.handleSearchKeywordChange = function (e, _ref4) {
	    var value = _ref4.value;
	    var _state5 = _this4.state,
	        filter = _state5.filter,
	        errors = _state5.errors;
	
	
	    var sliderHasValues = filter.min || filter.max;
	    var hasPlatform = filter.platform;
	
	    errors.platform = _ramda2.default.and(!hasPlatform, sliderHasValues);
	    errors.slider = _ramda2.default.and(hasPlatform, !sliderHasValues);
	
	    if (_ramda2.default.or(errors.platform, errors.slider)) {
	      _this4.setState({ errors: errors });
	    } else {
	      _this4.setState({ term: value, errors: errors });
	    }
	  };
	
	  this.handleSearchButtonClick = function (filter) {
	    var term = filter.term,
	        searchType = filter.searchType,
	        min = filter.min,
	        max = filter.max,
	        platform = filter.platform,
	        country = filter.country,
	        minInstagramEngagementRate = filter.minInstagramEngagementRate,
	        maxInstagramEngagementRate = filter.maxInstagramEngagementRate,
	        hasEmail = filter.hasEmail,
	        instagramBusinessAccount = filter.instagramBusinessAccount,
	        instagramPrivate = filter.instagramPrivate;
	    var onSearchParamsChange = _this4.props.onSearchParamsChange;
	
	    var currentPage = 1;
	    onSearchParamsChange({ filter: filter, currentPage: currentPage });
	    _this4.setState({
	      currentPage: currentPage,
	      filter: {
	        term: term,
	        searchType: searchType,
	        min: min,
	        max: max,
	        platform: platform,
	        country: country,
	        minInstagramEngagementRate: minInstagramEngagementRate,
	        maxInstagramEngagementRate: maxInstagramEngagementRate,
	        hasEmail: hasEmail,
	        instagramBusinessAccount: instagramBusinessAccount,
	        instagramPrivate: instagramPrivate
	      }
	    }, _this4.fetch);
	  };
	
	  this.handlePageRedirect = function (e, _ref5) {
	    var value = _ref5.value;
	
	    _this4.context.router.push('/influencers/' + value + '/latest');
	  };
	
	  this.handlePerPageChange = function (e, option) {
	    _this4.setState({ perPage: option.value }, function () {
	      _this4.fetch();
	      localStorage.setItem('' + _staticConfiguration.LS_PER_PAGE_KEY + _authService.authService.uid(), option.value);
	    });
	  };
	
	  this.handleSorting = function (field, current) {
	    var _state6 = _this4.state,
	        sort = _state6.sort,
	        links = _state6.links,
	        perPage = _state6.perPage,
	        totalInfluencers = _state6.totalInfluencers;
	    var onSearchParamsChange = _this4.props.onSearchParamsChange;
	
	    if (!links) return;
	
	    sort.field = field;
	    sort.order = !current || current === 'ascending' ? 'DESC' : 'ASC';
	
	    onSearchParamsChange({ sort: sort });
	
	    _this4.setState({
	      sort: sort
	    }, _this4.fetch);
	  };
	
	  this.deleteLink = function () {
	    var value = _this4.state.toBeDeleted;
	    var url = ("https://api2.dyzio.co/v1") + '/influencerLink/' + value;
	    _this4.restClient.delete(url).then(function () {
	      var links = _this4.state.links;
	
	      _lodash2.default.remove(links, {
	        id: value
	      });
	
	      _this4.setState({
	        confirmOpen: false,
	        links: links
	      });
	    });
	  };
	
	  this.handleCancel = function () {
	    _this4.setState({
	      toBeDeleted: null,
	      confirmOpen: false
	    });
	  };
	
	  this.fetchIf = _lodash2.default.debounce(function () {
	    var term = _this4.state.term;
	
	    var alwaysSearch = true; // take this out with a delay
	    if (term && term.length >= 3 || alwaysSearch) {
	      _this4.fetch();
	    }
	  }, 500);
	
	  this.handleCheckAllInfluencers = function (e, checkbox) {
	    var links = _this4.state.links;
	
	    if (checkbox.checked) {
	      var selected = _lodash2.default.map(links, function (link) {
	        var details = link.lookupInfluencer;
	        var id = details.id,
	            name = details.name,
	            thumbnail = details.thumbnail,
	            primarySocialHandle = details.primarySocialHandle;
	
	        return {
	          id: id,
	          name: name,
	          thumbnail: thumbnail,
	          primarySocialHandle: primarySocialHandle,
	          linkId: link.id
	        };
	      });
	      _this4.setState({
	        selected: selected
	      });
	    } else {
	      _this4.setState({
	        selected: []
	      });
	    }
	  };
	
	  this.handleDeleteInfluencer = function () {
	    _this4.setState({
	      confirmOpen: true
	    });
	  };
	
	  this.formatCountries = function (row) {
	    var mapping = _lodash2.default.find(countryList.default, ['key', row.isoCode]);
	    return mapping ? {
	      key: row.isoCode,
	      value: row.isoCode,
	      count: row.influencerCount,
	      text: mapping.text
	    } : [];
	  };
	
	  this.deleteSelectedInfluencers = function () {
	    var _state7 = _this4.state,
	        selected = _state7.selected,
	        links = _state7.links;
	
	    var ids = _lodash2.default.map(selected, 'linkId');
	    var requests = _lodash2.default.map(ids, function (value) {
	      return _this4.restClient.delete(("https://api2.dyzio.co/v1") + '/influencerLink/' + value);
	    });
	
	    _axios2.default.all(requests).then(function () {
	      var newLinks = _lodash2.default.filter(links, function (link) {
	        return !_lodash2.default.includes(ids, link.id);
	      });
	      _this4.setState({
	        selected: [],
	        links: newLinks,
	        confirmOpen: false
	      });
	    });
	  };
	
	  this.popupToggleHandler = function () {
	    _this4.setState({
	      confirmOpen: false
	    });
	  };
	
	  this.fetchReportUrls = function () {
	    var _props3 = _this4.props,
	        organisationId = _props3.organisationId,
	        organisationSlug = _props3.organisationSlug;
	
	    var fileExtensions = ['csv', 'xlsx'];
	    _lodash2.default.forEach(fileExtensions, function (extension) {
	      var fileName = organisationSlug + '-' + organisationId + '/' + organisationSlug + '-influencers.' + extension;
	      _this4.checkReportFilePresence(fileName, extension);
	    });
	  };
	
	  this.toggleColumnChooserModal = function () {
	    var _props4 = _this4.props,
	        userId = _props4.userInfo.userId,
	        dyzioStorage = _props4.dyzioStorage;
	    var _state8 = _this4.state,
	        columnsSettings = _state8.columnsSettings,
	        triggerBusinessUnitsFilter = _state8.triggerBusinessUnitsFilter;
	
	    dyzioStorage.updateTableColumnSettings({
	      userId: userId,
	      settings: columnsSettings
	    });
	    // trigger BU api filtering
	    if (triggerBusinessUnitsFilter) {
	      _this4.fetch();
	      _this4.setState({
	        triggerBusinessUnitsFilter: false
	      });
	    }
	    _this4.setState(function (prevState) {
	      return {
	        columnsChooseModalVisible: !prevState.columnsChooseModalVisible
	      };
	    });
	  };
	
	  this.redirectToAddInfluencer = function () {
	    _this4.context.router.push('/influencer/add');
	  };
	
	  this.onNewTagSelected = function (tagId) {
	    _this4.setState({
	      selectedTag: tagId
	    }, _this4.fetch);
	  };
	
	  this.toggleApprovalMode = function () {
	    _this4.setState(function (prev) {
	      return { approvalModeEnabled: !prev.approvalModeEnabled };
	    });
	  };
	
	  this.onApprovalCountryChanged = function (approvalFilter) {
	    _this4.setState({
	      approvalCountry: approvalFilter
	    }, function () {
	      var fetchFunction = _lodash2.default.get(approvalFilter, 'status') ? _this4.fetchLatestProcessedList : _this4.fetchApprovalList;
	      fetchFunction();
	    });
	  };
	
	  this.fetchExportData = function (request) {
	    var isExportingData = _this4.state.isExportingData;
	
	    if (isExportingData) {
	      return;
	    }
	    _this4.setState({ isExportingData: true });
	    var searchURI = encodeURIComponent(JSON.stringify(request));
	    var url = ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production") + '/creators/filter/' + searchURI;
	    _this4.restClient.get(url).then(function (r) {
	      var results = _lodash2.default.filter(r.data.body.data.data || [], _this4.filterInfluencers);
	      _this4.setState({ exportData: results, isExportingData: false });
	    }).catch(function (ex) {
	      _this4.setState({ exportData: [], isExportingData: false });
	    });
	  };
	
	  this.getCreatorsExportData = function () {
	    var exportData = _this4.state.exportData;
	
	    return _lodash2.default.map(exportData, function (item) {
	      var instagramHashtags = _lodash2.default.map(item.instagramHashtags, 'hashtag');
	      var instagramUrl = item.instagram ? 'https://instagram.com/' + item.instagram : null;
	      var tiktokUrl = item.tiktok ? 'https://www.tiktok.com/@' + item.tiktok : null;
	      var fields = ['id', 'name', 'primarySocialHandle', 'thumbnail', 'instagram', 'instagramId', 'country', 'email', 'instagramEngagementRate', 'instagramStatus', 'status', 'createdBy', 'createdDate', 'instagramBusinessAccount'];
	      return _extends({}, _lodash2.default.pick(item, fields), { instagramUrl: instagramUrl, tiktokUrl: tiktokUrl, instagramHashtags: instagramHashtags });
	    });
	  };
	
	  this.togglePeriodDetailsModal = function () {
	    _this4.setState(function (prev) {
	      return { showPeriodDetailsData: !prev.showPeriodDetailsData };
	    });
	  };
	};
	
	CreatorTable.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	CreatorTable.propTypes = {
	  restClient: _propTypes2.default.func.isRequired,
	  userInfo: _propTypes2.default.object.isRequired,
	  dyzioStorage: _propTypes2.default.object.isRequired,
	  searchParams: _propTypes2.default.object.isRequired,
	  onSearchParamsChange: _propTypes2.default.func.isRequired,
	  defaultApprovalModeEnabled: _propTypes2.default.bool
	};
	CreatorTable.defaultProps = {
	  defaultApprovalModeEnabled: false
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasLocalstorageClient2.default, _hasUserInfo2.default, _reactRouter.withRouter)(CreatorTable);

/***/ },
/* 2101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(37);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _publicHeader = __webpack_require__(551);
	
	var _publicHeader2 = _interopRequireDefault(_publicHeader);
	
	var _influencerAuthorisationCard = __webpack_require__(1956);
	
	var _influencerAuthorisationCard2 = _interopRequireDefault(_influencerAuthorisationCard);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Creator = function (_Component) {
	  _inherits(Creator, _Component);
	
	  function Creator(props) {
	    _classCallCheck(this, Creator);
	
	    var _this = _possibleConstructorReturn(this, (Creator.__proto__ || Object.getPrototypeOf(Creator)).call(this, props));
	
	    _this.state = {
	      isLoading: true,
	      isError: false,
	      influencer: null
	    };
	    return _this;
	  }
	
	  _createClass(Creator, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var _props, buildRESTClient, id, client, response, influencer;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props, buildRESTClient = _props.buildRESTClient, id = _props.params.id;
	                client = buildRESTClient({
	                  baseURL: ("https://u0f13udpl7.execute-api.eu-west-3.amazonaws.com/production"),
	                  hasToken: false
	                });
	                _context.next = 4;
	                return client.get('influencers/' + id).catch(function () {
	                  _this2.setState({
	                    isLoading: false,
	                    isError: true
	                  });
	                });
	
	              case 4:
	                response = _context.sent;
	
	                if (response) {
	                  _context.next = 7;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 7:
	                influencer = _lodash2.default.get(response, 'data.data.influencer', {});
	
	                this.setState({
	                  influencer: influencer,
	                  isLoading: false,
	                  isError: false
	                });
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          influencer = _state.influencer,
	          isLoading = _state.isLoading,
	          isError = _state.isError;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_publicHeader2.default, null),
	        _react2.default.createElement(_influencerAuthorisationCard2.default, Object.assign({
	          isLoading: isLoading,
	          isError: isError
	        }, influencer))
	      );
	    }
	  }]);
	
	  return Creator;
	}(_react.Component);
	
	exports.default = (0, _recompose.compose)(_reactRouter.withRouter, _hasRestClient2.default)(Creator);

/***/ },
/* 2102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _recompose = __webpack_require__(15);
	
	var _tabs = __webpack_require__(352);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _campaignList = __webpack_require__(2077);
	
	var _campaignList2 = _interopRequireDefault(_campaignList);
	
	var _influencersCampaignList = __webpack_require__(2159);
	
	var _influencersCampaignList2 = _interopRequireDefault(_influencersCampaignList);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _actions = __webpack_require__(359);
	
	var _actions2 = __webpack_require__(105);
	
	var _statusBar = __webpack_require__(170);
	
	var _statusBar2 = _interopRequireDefault(_statusBar);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dashboard = function (_React$Component) {
	  _inherits(Dashboard, _React$Component);
	
	  function Dashboard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Dashboard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call.apply(_ref, [this].concat(args))), _this), _this.changeUrlPath = function (path) {
	      return _this.context.router.push(path);
	    }, _this.updateShowCampaignList = function (showCampaignList) {
	      return function (event) {
	        event.preventDefault();
	        _this.props.onUpdateShowCampaignsList(showCampaignList);
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Dashboard, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onClearStatusBar();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          campaignsList = _props.campaignsList,
	          showCampaignsList = _props.showCampaignsList,
	          viewedOnboarding = _props.viewedOnboarding;
	
	      var hideTabs = !(campaignsList.size > 0);
	      var tabsStyle = !hideTabs ? 'white border-bottom' : '';
	      var panes = [_staticConfiguration.ACTIVE, _staticConfiguration.ARCHIVED];
	      var role = this.props.userInfo.role;
	
	
	      var theme = _themeSelector2.default.theme();
	      var hideCampaigns = theme.hideHomepage || false;
	
	      var isInfluencer = role === 'INFLUENCER';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_statusBar2.default, null),
	        !hideCampaigns && _react2.default.createElement(_tabs2.default, {
	          title: 'My Campaigns',
	          headerStyle: 'padded-content ' + tabsStyle,
	          tabsStyle: 'tabs',
	          hideTabs: true,
	          active: showCampaignsList,
	          onClick: this.updateShowCampaignList
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          isInfluencer && _react2.default.createElement(_influencersCampaignList2.default, { active: showCampaignsList }),
	          !isInfluencer && _react2.default.createElement(_campaignList2.default, { active: showCampaignsList })
	        )
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react2.default.Component);
	
	Dashboard.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    campaignsList: state.campaignList.get('campaigns'),
	    showCampaignsList: state.campaignList.get('showCampaignsList'),
	    viewedOnboarding: state.userOnboarding.get('viewedOnboarding')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onUpdateShowCampaignsList: function onUpdateShowCampaignsList(campaignStatus) {
	      return dispatch((0, _actions.updateShowCampaignsList)(campaignStatus));
	    },
	    onSetStatusBar: function onSetStatusBar(message, colour) {
	      return dispatch((0, _actions2.setStatusBar)(message, colour));
	    },
	    onClearStatusBar: function onClearStatusBar() {
	      return dispatch((0, _actions2.clearStatusBar)());
	    }
	  };
	}
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _hasUserInfo2.default)(Dashboard);

/***/ },
/* 2103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(910);
	
	var initialState = (0, _immutable.fromJS)({
	  isUpdatingDeliverable: false,
	  deliverable: {}
	});
	
	function deliverableAssignReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SHOW_EXISTING_DELIVERABLE_SUCCESS:
	      return state.set('deliverable', action.deliverable).set('isUpdatingDeliverable', true);
	    case _constants.CLEAR_EXISTING_DELIVERABLE:
	      return initialState;
	    default:
	      return state;
	  }
	}
	
	exports.default = deliverableAssignReducer;

/***/ },
/* 2104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.createNewDeliverable = createNewDeliverable;
	exports.showExistingDeliverable = showExistingDeliverable;
	exports.editExistingDeliverable = editExistingDeliverable;
	exports.watchEditExistingDeliverable = watchEditExistingDeliverable;
	exports.watchShowExistingDeliverable = watchShowExistingDeliverable;
	exports.watchCreateDeliverable = watchCreateDeliverable;
	exports.default = deliverableSaga;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _deliverables = __webpack_require__(288);
	
	var _deliverableAssignSelectors = __webpack_require__(2260);
	
	var _discussions = __webpack_require__(172);
	
	var _discussionSelectors = __webpack_require__(361);
	
	var _campaignSelectors = __webpack_require__(117);
	
	var _modal = __webpack_require__(169);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _metricAnalyticsService = __webpack_require__(119);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _helperFunctions = __webpack_require__(107);
	
	var _constants = __webpack_require__(142);
	
	var _constants2 = __webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [createNewDeliverable, showExistingDeliverable, editExistingDeliverable, watchEditExistingDeliverable, watchShowExistingDeliverable, watchCreateDeliverable, deliverableSaga].map(_regenerator2.default.mark);
	
	function createNewDeliverable(action) {
	  var deliverableData, createDeliverableCallback, discussionId, newDeliverable, newDeliverableJSON, myPermissionId, message, metaData, campaignId, discussionName, assignDeliverableData, messageData;
	  return _regenerator2.default.wrap(function createNewDeliverable$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          deliverableData = action.deliverableData;
	          createDeliverableCallback = action.createDeliverableCallback;
	          _context.next = 4;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionId);
	
	        case 4:
	          discussionId = _context.sent;
	
	          deliverableData.discussionId = discussionId;
	
	          _context.prev = 6;
	          _context.next = 9;
	          return (0, _effects.put)({ type: _modal.MODAL_LOADING, loading: true });
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.call)(_deliverables.createDeliverable, deliverableData);
	
	        case 11:
	          newDeliverable = _context.sent;
	          _context.next = 14;
	          return (0, _effects.call)(_discussions.updateDiscussionDeliverables, discussionId, newDeliverable);
	
	        case 14:
	          newDeliverableJSON = newDeliverable.toJSONTree();
	
	          newDeliverableJSON.assetType = newDeliverableJSON.assetType.join(',');
	          newDeliverableJSON.documents = {};
	          _context.next = 19;
	          return (0, _effects.select)(_campaignSelectors.getPermissionId);
	
	        case 19:
	          myPermissionId = _context.sent;
	          _context.next = 22;
	          return (0, _effects.put)({
	            type: _constants.UPDATE_DELIVERABLES,
	            deliverableData: (0, _immutable.fromJS)(newDeliverableJSON)
	          });
	
	        case 22:
	          message = newDeliverableJSON.title;
	          metaData = {
	            messageType: 'deliverable',
	            permissionId: myPermissionId,
	            discussionId: discussionId,
	            deliverableId: newDeliverableJSON.id,
	            deliverableStatus: 'added'
	          };
	          _context.next = 26;
	          return (0, _effects.select)(_campaignSelectors.getCampaignId);
	
	        case 26:
	          campaignId = _context.sent;
	          _context.next = 29;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionName);
	
	        case 29:
	          discussionName = _context.sent;
	          assignDeliverableData = {
	            campaignId: campaignId,
	            collaborationId: discussionId,
	            collaborationName: discussionName,
	            deliverableId: newDeliverableJSON.id,
	            deliverableName: newDeliverableJSON.title
	          };
	
	          (0, _metricAnalyticsService.trackEvent)('Assign Deliverable', assignDeliverableData);
	
	          // Sends sendbird deliverable message
	          messageData = {
	            message: message,
	            metaData: metaData,
	            page: _staticConfiguration.DISCUSSION_PAGE
	          };
	          _context.next = 35;
	          return (0, _effects.put)({ type: _constants.SEND_MESSAGE, data: messageData });
	
	        case 35:
	          _context.next = 37;
	          return (0, _effects.call)(createDeliverableCallback);
	
	        case 37:
	          _context.next = 39;
	          return (0, _effects.put)({ type: _modal.MODAL_CLEAR });
	
	        case 39:
	          _context.next = 46;
	          break;
	
	        case 41:
	          _context.prev = 41;
	          _context.t0 = _context['catch'](6);
	
	          (0, _errorHandlingService.reportError)('SET_NEW_DELIVERABLE_ERROR', _context.t0.message);
	          _context.next = 46;
	          return (0, _effects.put)({ type: _modal.MODAL_ERROR, error: _context.t0 });
	
	        case 46:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[6, 41]]);
	}
	
	function showExistingDeliverable(action) {
	  var deliverable;
	  return _regenerator2.default.wrap(function showExistingDeliverable$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          deliverable = action.data.deliverable;
	          _context2.next = 3;
	          return (0, _effects.put)({ type: _constants2.SHOW_EXISTING_DELIVERABLE_SUCCESS, deliverable: deliverable });
	
	        case 3:
	          _context2.next = 5;
	          return (0, _effects.put)({ type: _modal.MODAL_SET, modalName: _staticConfiguration.DELIVERABLE_SET });
	
	        case 5:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function getUpdatedItems(stateDeliverable, newDeliverableData) {
	  var updatedItems = [];
	  if (stateDeliverable.get('title') !== newDeliverableData.title) updatedItems.push('title');
	  if (stateDeliverable.get('channelType') !== newDeliverableData.channelType) updatedItems.push('channel type');
	  if (stateDeliverable.get('assetType') !== newDeliverableData.assetType[0]) updatedItems.push('asset type');
	  if (stateDeliverable.get('dueDate') !== newDeliverableData.dueDate) updatedItems.push('due date');
	  if (stateDeliverable.get('liveDateEnd') !== newDeliverableData.liveDateEnd) updatedItems.push('live date');
	  if (newDeliverableData.description && stateDeliverable.get('description') !== newDeliverableData.description) updatedItems.push('requirements');
	  return updatedItems;
	}
	
	function createUpdateMessage(updatedItems) {
	  var updatedMessage = '';
	  var numberOfChanges = updatedItems.length;
	  for (var i = 0; i < numberOfChanges; i++) {
	    var item = updatedItems[i];
	    var adjustedItem = i < numberOfChanges - 2 ? item + ', ' : item + ' ';
	    if (numberOfChanges > 1 && i + 1 === numberOfChanges) adjustedItem = 'and ' + adjustedItem;
	    updatedMessage += adjustedItem;
	  }
	  return 'The ' + updatedMessage + (numberOfChanges > 1 ? 'were' : 'was') + ' updated.';
	}
	
	function editExistingDeliverable(action) {
	  var deliverableData, deliverableId, deliverable, updatedItems, updateMessage, updatedDeliverableJSON, discussionId, myPermissionId, message, metaData, messageData;
	  return _regenerator2.default.wrap(function editExistingDeliverable$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.prev = 0;
	          _context3.next = 3;
	          return (0, _effects.put)({ type: _modal.MODAL_LOADING, loading: true });
	
	        case 3:
	          deliverableData = action.data.deliverableData;
	          _context3.next = 6;
	          return (0, _effects.select)(_deliverableAssignSelectors.getDeliverableId);
	
	        case 6:
	          deliverableId = _context3.sent;
	          _context3.next = 9;
	          return (0, _effects.select)(_deliverableAssignSelectors.getAssignDeliverable);
	
	        case 9:
	          deliverable = _context3.sent;
	          updatedItems = getUpdatedItems(deliverable, deliverableData);
	
	          if (!updatedItems.length) {
	            _context3.next = 34;
	            break;
	          }
	
	          updateMessage = createUpdateMessage(updatedItems);
	          _context3.next = 15;
	          return (0, _effects.call)(_deliverables.updateDeliverableInfo, deliverableId, deliverableData);
	
	        case 15:
	          _context3.next = 17;
	          return (0, _effects.call)(_deliverables.getDeliverable, deliverableId);
	
	        case 17:
	          updatedDeliverableJSON = _context3.sent;
	
	          updatedDeliverableJSON.assetType = typeof updatedDeliverableJSON.assetType === 'string' ? updatedDeliverableJSON.assetType : updatedDeliverableJSON.assetType.join(',');
	          updatedDeliverableJSON.mostRecentDocument = (0, _helperFunctions.getMostRecentDocument)(updatedDeliverableJSON);
	
	          // Updates state with the updated deliverable info
	          _context3.next = 22;
	          return (0, _effects.put)({ type: _constants.UPDATE_DELIVERABLES, deliverableData: (0, _immutable.fromJS)(updatedDeliverableJSON) });
	
	        case 22:
	          _context3.next = 24;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionId);
	
	        case 24:
	          discussionId = _context3.sent;
	          _context3.next = 27;
	          return (0, _effects.select)(_campaignSelectors.getPermissionId);
	
	        case 27:
	          myPermissionId = _context3.sent;
	          message = updatedDeliverableJSON.title;
	          metaData = {
	            messageType: 'deliverable',
	            permissionId: myPermissionId,
	            discussionId: discussionId,
	            deliverableId: updatedDeliverableJSON.id,
	            deliverableStatus: 'updated',
	            updateMessage: updateMessage
	          };
	
	          if (updatedDeliverableJSON.mostRecentDocument) metaData.docId = updatedDeliverableJSON.mostRecentDocument.id;
	
	          // Sends sendbird deliverable message
	          messageData = {
	            message: message,
	            metaData: metaData,
	            page: _staticConfiguration.DISCUSSION_PAGE
	          };
	          _context3.next = 34;
	          return (0, _effects.put)({ type: _constants.SEND_MESSAGE, data: messageData });
	
	        case 34:
	          _context3.next = 36;
	          return (0, _effects.put)({ type: _modal.MODAL_CLEAR });
	
	        case 36:
	          _context3.next = 43;
	          break;
	
	        case 38:
	          _context3.prev = 38;
	          _context3.t0 = _context3['catch'](0);
	
	          (0, _errorHandlingService.reportError)('UPDATE_DELIVERABLE_ERROR', _context3.t0.message);
	          _context3.next = 43;
	          return (0, _effects.put)({ type: _modal.MODAL_ERROR, error: _context3.t0 });
	
	        case 43:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this, [[0, 38]]);
	}
	
	function watchEditExistingDeliverable() {
	  return _regenerator2.default.wrap(function watchEditExistingDeliverable$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants2.EDIT_EXISTING_DELIVERABLE, editExistingDeliverable);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function watchShowExistingDeliverable() {
	  return _regenerator2.default.wrap(function watchShowExistingDeliverable$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants2.SHOW_EXISTING_DELIVERABLE, showExistingDeliverable);
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function watchCreateDeliverable() {
	  return _regenerator2.default.wrap(function watchCreateDeliverable$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants2.NEW_DELIVERABLE, createNewDeliverable);
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}
	
	function deliverableSaga() {
	  return _regenerator2.default.wrap(function deliverableSaga$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return [(0, _effects.fork)(watchCreateDeliverable), (0, _effects.fork)(watchShowExistingDeliverable), (0, _effects.fork)(watchEditExistingDeliverable)];
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}

/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submitDeliverable = submitDeliverable;
	exports.setInitialSubmitType = setInitialSubmitType;
	exports.updateAddDeliverableForm = updateAddDeliverableForm;
	exports.setInitialDeliverable = setInitialDeliverable;
	
	var _constants = __webpack_require__(558);
	
	function submitDeliverable(deliverableData, submitType, submitDeliverableCallback) {
	  return {
	    type: _constants.SUBMIT_DELIVERABLE,
	    deliverableData: deliverableData,
	    submitType: submitType,
	    submitDeliverableCallback: submitDeliverableCallback
	  };
	}
	
	function setInitialSubmitType(data) {
	  return {
	    type: _constants.SET_INITIAL_SUBMIT_TYPE,
	    data: data
	  };
	}
	
	function updateAddDeliverableForm(deliverableId, callback) {
	  return {
	    type: _constants.UPDATE_ADD_DELIVERABLE_FORM_OPTIONS,
	    deliverableId: deliverableId,
	    callback: callback
	  };
	}
	
	function setInitialDeliverable(data) {
	  return {
	    type: _constants.SET_INITIAL_DELIVERABLE,
	    data: data
	  };
	}

/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _immutable = __webpack_require__(71);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _formInputSelect = __webpack_require__(545);
	
	var _formInputSelect2 = _interopRequireDefault(_formInputSelect);
	
	var _formInputText = __webpack_require__(104);
	
	var _formInputText2 = _interopRequireDefault(_formInputText);
	
	var _formInputRadio = __webpack_require__(544);
	
	var _formInputRadio2 = _interopRequireDefault(_formInputRadio);
	
	var _actions = __webpack_require__(2105);
	
	var _uploader = __webpack_require__(353);
	
	var _uploader2 = _interopRequireDefault(_uploader);
	
	var _modal = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeliverableSubmit = function (_React$Component) {
	  _inherits(DeliverableSubmit, _React$Component);
	
	  function DeliverableSubmit(props, context) {
	    _classCallCheck(this, DeliverableSubmit);
	
	    var _this = _possibleConstructorReturn(this, (DeliverableSubmit.__proto__ || Object.getPrototypeOf(DeliverableSubmit)).call(this, props, context));
	
	    _this.uploadDataCallback = function (documentData) {
	      _this.setState({ documentData: documentData });
	    };
	
	    _this.updateUploaderState = function (newUploaderState) {
	      _this.setState({ uploaderState: newUploaderState });
	    };
	
	    _this.resetForm = function () {
	      _this.setState({ uploaderState: 1 });
	      _this.props.reset();
	    };
	
	    _this.changeSubmitTypeCallback = function (submitType) {
	      return _this.props.change('submitType', submitType);
	    };
	
	    _this.updateSubmitDeliverableOptions = function (deliverableId) {
	      _this.props.onUpdateAddDeliverableForm(deliverableId, _this.changeSubmitTypeCallback);
	    };
	
	    _this.state = {
	      uploaderState: 1,
	      documentData: {}
	    };
	    return _this;
	  }
	
	  _createClass(DeliverableSubmit, [{
	    key: 'clearModal',
	    value: function clearModal() {
	      this.setState({ uploaderState: 1, documentData: {} });
	      this.props.reset();
	    }
	  }, {
	    key: 'submitExistingDeliverable',
	    value: function submitExistingDeliverable(formData) {
	      var submitType = formData.get('submitType');
	      var deliverableId = formData.get('selectedDeliverable');
	      var title = this.props.deliverables.getIn([deliverableId, 'title']);
	      var version = this.props.deliverables.getIn([deliverableId, 'version']);
	
	      var filePath = void 0,
	          message = void 0,
	          size = void 0,
	          name = null;
	      if (submitType === 'url') {
	        message = formData.get('submitMessage');
	        filePath = formData.get('deliverableUrl');
	        if (filePath.indexOf('http://') === -1 && filePath.indexOf('https://') === -1) filePath = 'http://' + filePath;
	      }
	      if (submitType === 'upload') {
	        message = formData.get('submitDocumentMessage');
	        name = this.state.documentData.name;
	        filePath = this.state.documentData.filePath;
	        size = this.state.documentData.size;
	      }
	      if (submitType === 'text') {
	        filePath = formData.get('copyText');
	      }
	
	      var deliverableData = {
	        id: deliverableId,
	        message: message,
	        filePath: filePath,
	        title: title,
	        name: name,
	        fileType: submitType,
	        size: size,
	        version: version
	      };
	
	      this.props.onSubmitDeliverable(deliverableData, submitType, this.resetForm);
	    }
	  }, {
	    key: 'onOutsideClick',
	    value: function onOutsideClick(event) {
	      var isClickInside = this.refs.modal_content.contains(event.target);
	      if (!isClickInside) this.props.onClearModal();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.resetForm();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var selectedDeliverable = this.props.selectedDeliverable;
	      if (selectedDeliverable) this.updateSubmitDeliverableOptions(selectedDeliverable);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          uploaderState = _state.uploaderState,
	          documentData = _state.documentData;
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          deliverables = _props.deliverables,
	          showModal = _props.showModal,
	          modalLoading = _props.modalLoading,
	          submitType = _props.submitType,
	          isUploadActive = _props.isUploadActive,
	          isUrlActive = _props.isUrlActive,
	          isTextActive = _props.isTextActive,
	          assetType = _props.assetType,
	          selectedDeliverable = _props.selectedDeliverable;
	
	
	      var deliverableOptions = [];
	      deliverables.forEach(function (deliverable) {
	        if (!deliverable.get('live')) {
	          var id = deliverable.get('id');
	          var title = deliverable.get('title');
	          var _assetType = deliverable.get('assetType');
	          var adjustedAssetType = _assetType ? _assetType.split(',')[0].toLowerCase() : null;
	          var label = title + ' (' + adjustedAssetType + ')';
	          var documentsList = deliverable.get('documents');
	          if (documentsList && documentsList.first()) {
	            var deliverableApproved = documentsList.find(function (document) {
	              return document.get('approved') === true;
	            });
	            if (!deliverableApproved) deliverableOptions.push({ value: id, label: label });
	          } else if (!deliverable.getIn(['document', 'approved'])) {
	            deliverableOptions.push({ value: id, label: label });
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: showModal === _staticConfiguration.DELIVERABLE_SUBMIT ? 'custom-modal visible' : 'custom-modal', onClick: this.onOutsideClick.bind(this) },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.submitExistingDeliverable.bind(this)) },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content', ref: 'modal_content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'top' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Add a deliverable'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-close' },
	              _react2.default.createElement('img', { src: '/icons/close.svg', alt: 'close', onClick: function onClick() {
	                  return _this2.props.onClearModal();
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement(
	                'table',
	                null,
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { width: '150px' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Select deliverable'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(_immutable.Field, {
	                        name: 'selectedDeliverable',
	                        component: function component(props) {
	                          return _react2.default.createElement(_formInputSelect2.default, Object.assign({
	                            name: 'selectedDeliverable',
	                            label: '',
	                            className: 'stacked',
	                            onChangeCallback: function onChangeCallback(deliverableId) {
	                              return _this2.updateSubmitDeliverableOptions(deliverableId);
	                            }
	                          }, props, {
	                            options: deliverableOptions
	                          }));
	                        }
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { width: '180px' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Add deliverable by'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement('div', { className: 'spacer small' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'radio-row' },
	                        _react2.default.createElement(_immutable.Field, {
	                          id: 'url',
	                          type: 'radio',
	                          component: _formInputRadio2.default,
	                          name: 'submitType',
	                          value: 'url',
	                          label: 'URL',
	                          disabled: isUrlActive ? false : true
	                        }),
	                        _react2.default.createElement(_immutable.Field, {
	                          id: 'upload',
	                          type: 'radio',
	                          component: _formInputRadio2.default,
	                          name: 'submitType',
	                          value: 'upload',
	                          label: 'upload',
	                          disabled: isUploadActive ? false : true
	                        }),
	                        _react2.default.createElement(_immutable.Field, {
	                          id: 'text',
	                          type: 'radio',
	                          component: _formInputRadio2.default,
	                          name: 'submitType',
	                          value: 'text',
	                          label: 'write',
	                          disabled: isTextActive ? false : true
	                        })
	                      )
	                    )
	                  ),
	                  submitType === 'url' && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: 2 },
	                      _react2.default.createElement(_immutable.Field, {
	                        name: 'deliverableUrl',
	                        type: 'text',
	                        label: '',
	                        component: _formInputText2.default,
	                        placeholder: assetType === _staticConfiguration.VIDEO ? 'Youtube URL or other video link' : 'URL link to your draft post'
	                      })
	                    )
	                  ),
	                  submitType === 'url' && assetType !== _staticConfiguration.BLOG && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: 2 },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Include the copy for your post if applicable'
	                      )
	                    )
	                  ),
	                  submitType === 'url' && assetType !== _staticConfiguration.BLOG && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: 2 },
	                      _react2.default.createElement(_immutable.Field, {
	                        name: 'submitMessage',
	                        component: 'textarea',
	                        placeholder: 'write your copy here'
	                      })
	                    )
	                  ),
	                  submitType === 'upload' && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: 2 },
	                      _react2.default.createElement(_uploader2.default, {
	                        uploaderState: uploaderState,
	                        updateUploaderState: this.updateUploaderState,
	                        docType: _staticConfiguration.DELIVERABLE,
	                        uploadDataCallback: this.uploadDataCallback
	                      })
	                    )
	                  ),
	                  submitType === 'upload' && uploaderState === 6 && assetType !== _staticConfiguration.BLOG && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: 2 },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Include the copy for your post if applicable'
	                      )
	                    )
	                  ),
	                  submitType === 'upload' && uploaderState === 6 && assetType !== _staticConfiguration.BLOG && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: 2 },
	                      _react2.default.createElement(_immutable.Field, {
	                        name: 'submitDocumentMessage',
	                        component: 'textarea',
	                        placeholder: 'write your copy here'
	                      })
	                    )
	                  ),
	                  submitType === 'text' && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '2' },
	                      _react2.default.createElement(_immutable.Field, {
	                        name: 'copyText',
	                        component: 'textarea',
	                        placeholder: 'write your copy here'
	                      })
	                    )
	                  ),
	                  (submitType === 'upload' && documentData.filePath || submitType === 'url' || submitType === 'text') && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '2' },
	                      _react2.default.createElement('div', { className: 'spacer' }),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'medium rose stretch', type: 'submit' },
	                        modalLoading ? _react2.default.createElement(
	                          'ul',
	                          { className: 'dots' },
	                          _react2.default.createElement('li', { id: 'dot1' }),
	                          _react2.default.createElement('li', null),
	                          _react2.default.createElement('li', { id: 'dot2' }),
	                          _react2.default.createElement('li', null),
	                          _react2.default.createElement('li', { id: 'dot3' })
	                        ) : _react2.default.createElement(
	                          'span',
	                          null,
	                          'Add deliverable'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DeliverableSubmit;
	}(_react2.default.Component);
	
	DeliverableSubmit.contextTypes = {
	  router: _react.PropTypes.object
	};
	DeliverableSubmit.propTypes = _extends({}, _immutable.propTypes);
	
	
	DeliverableSubmit.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	function validate(values) {
	  var errors = {};
	
	  // No validation done on deliverables for now
	  var selectedDeliverable = values.get('selectedDeliverable');
	  var submitType = values.get('submitType');
	  var deliverableUrl = values.get('deliverableUrl');
	  var copyText = values.get('copyText');
	
	  if (!selectedDeliverable) {
	    errors.selectedDeliverable = 'Please select a deliverable';
	  }
	  if (submitType === 'url') {
	    if (!deliverableUrl) errors.deliverableUrl = 'Please include a URL to the deliverable';
	  }
	  if (submitType === 'text') {
	    if (!copyText) errors.copyText = 'Please add the copy text for the deliverable';
	  }
	
	  return errors;
	}
	
	// Used to map the form state to props to allow for custom form render logic
	var selector = (0, _immutable.formValueSelector)('DeliverableSubmitForm');
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    deliverables: state.discussion.get('deliverables'),
	    discussionId: state.discussion.get('discussionId'),
	    showModal: state.modal.get('showModal'),
	    modalLoading: state.modal.get('loading'),
	    modalError: state.modal.get('error'),
	    submitType: selector(state, 'submitType'),
	    isUploadActive: state.deliverableSubmit.get('isUploadActive'),
	    isUrlActive: state.deliverableSubmit.get('isUrlActive'),
	    isTextActive: state.deliverableSubmit.get('isTextActive'),
	    assetType: state.deliverableSubmit.get('assetType'),
	    selectedDeliverable: state.deliverableSubmit.get('selectedDeliverable'),
	    initialValues: {
	      submitType: state.deliverableSubmit.get('initialSubmitType'),
	      selectedDeliverable: state.deliverableSubmit.get('selectedDeliverable')
	    }
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onSubmitDeliverable: function onSubmitDeliverable(deliverableData, submitType, submitDeliverableCallback) {
	      return dispatch((0, _actions.submitDeliverable)(deliverableData, submitType, submitDeliverableCallback));
	    },
	    onSetInitialSubmitType: function onSetInitialSubmitType(data) {
	      return dispatch((0, _actions.setInitialSubmitType)(data));
	    },
	    onUpdateAddDeliverableForm: function onUpdateAddDeliverableForm(deliverableId, callback) {
	      return dispatch((0, _actions.updateAddDeliverableForm)(deliverableId, callback));
	    },
	    onClearModal: function onClearModal() {
	      return dispatch((0, _modal.clearModal)());
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutable.reduxForm)({
	  form: 'DeliverableSubmitForm',
	  validate: validate
	})(DeliverableSubmit));

/***/ },
/* 2107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(558);
	
	var initialState = (0, _immutable.fromJS)({
	  initialSubmitType: 'url',
	  selectedDeliverable: null,
	  assetType: null,
	  isUploadActive: true,
	  isUrlActive: true,
	  isTextActive: true
	});
	
	function deliverableSubmitReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_INITIAL_SUBMIT_TYPE:
	      return state.set('initialSubmitType', action.data.submitType).set('assetType', action.data.assetType).set('isUploadActive', action.data.isUploadActive).set('isUrlActive', action.data.isUrlActive).set('isTextActive', action.data.isTextActive);
	    case _constants.SET_INITIAL_DELIVERABLE:
	      return state.set('selectedDeliverable', action.data.deliverableId);
	    default:
	      return state;
	  }
	}
	
	exports.default = deliverableSubmitReducer;

/***/ },
/* 2108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.submitExistingDeliverable = submitExistingDeliverable;
	exports.updateAddDeliverableFormOptions = updateAddDeliverableFormOptions;
	exports.watchSubmitDeliverable = watchSubmitDeliverable;
	exports.watchUpdateAddDeliverableFormOptions = watchUpdateAddDeliverableFormOptions;
	exports.default = deliverableSubmitSaga;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _deliverables = __webpack_require__(288);
	
	var _discussions = __webpack_require__(172);
	
	var _documents = __webpack_require__(364);
	
	var _comments = __webpack_require__(935);
	
	var _discussionSelectors = __webpack_require__(361);
	
	var _campaignSelectors = __webpack_require__(117);
	
	var _userSelectors = __webpack_require__(118);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _modal = __webpack_require__(169);
	
	var _constants = __webpack_require__(558);
	
	var _constants2 = __webpack_require__(142);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _metricAnalyticsService = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [submitExistingDeliverable, updateAddDeliverableFormOptions, watchSubmitDeliverable, watchUpdateAddDeliverableFormOptions, deliverableSubmitSaga].map(_regenerator2.default.mark);
	
	function submitExistingDeliverable(action) {
	  var deliverableData, deliverableId, version, submitDeliverableCallback, discussionId, userId, documentData, newDocument, newDocumentJSON, commentsList, versionComment, commentData, insertDeliverableData, updatedDeliverable, updatedDeliverableJSON, myPermissionId, message, metaData, campaignId, discussionName, addDeliverableData, messageData;
	  return _regenerator2.default.wrap(function submitExistingDeliverable$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          deliverableData = action.deliverableData;
	          deliverableId = deliverableData.id;
	          version = deliverableData.version + 1;
	          submitDeliverableCallback = action.submitDeliverableCallback;
	          _context.next = 7;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionId);
	
	        case 7:
	          discussionId = _context.sent;
	          _context.next = 10;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 10:
	          userId = _context.sent;
	          _context.next = 13;
	          return (0, _effects.put)({ type: _modal.MODAL_LOADING, loading: true });
	
	        case 13:
	
	          // Deliverable message submits are treated as documents
	          documentData = {
	            name: deliverableData.fileType === 'upload' ? deliverableData.name : deliverableData.title,
	            filePath: deliverableData.filePath,
	            docType: _staticConfiguration.DELIVERABLE,
	            fileType: deliverableData.fileType,
	            size: deliverableData.fileType === 'upload' ? deliverableData.size : 1,
	            message: deliverableData.message,
	            discussionId: discussionId,
	            approved: false,
	            version: version
	          };
	          _context.next = 16;
	          return (0, _effects.call)(_documents.createDocument, documentData);
	
	        case 16:
	          newDocument = _context.sent;
	          newDocumentJSON = newDocument.toJSONTree();
	          commentsList = [];
	
	          // Create version comment
	
	          versionComment = void 0;
	
	          if (!(version > 1)) {
	            _context.next = 26;
	            break;
	          }
	
	          commentData = {
	            comment: 'VERSION ' + version + ' added',
	            commentType: 'VERSION',
	            deliverableId: deliverableId,
	            documentId: newDocumentJSON.id,
	            userId: userId
	          };
	          _context.next = 24;
	          return (0, _effects.call)(_comments.createComment, commentData);
	
	        case 24:
	          versionComment = _context.sent;
	
	          commentsList.push(versionComment);
	
	        case 26:
	
	          // Update deliverable
	          insertDeliverableData = {
	            document: newDocument,
	            version: version
	          };
	
	          if (commentsList.length > 0) insertDeliverableData.comments = commentsList;
	
	          _context.next = 30;
	          return (0, _effects.call)(_deliverables.updateDeliverableData, deliverableId, insertDeliverableData);
	
	        case 30:
	          _context.next = 32;
	          return (0, _effects.call)(_deliverables.getDeliverable, deliverableId);
	
	        case 32:
	          updatedDeliverable = _context.sent;
	          updatedDeliverableJSON = updatedDeliverable;
	
	          // Update discussion with new document
	
	          _context.next = 36;
	          return (0, _effects.call)(_discussions.addDiscussionDocument, discussionId, newDocument);
	
	        case 36:
	          _context.next = 38;
	          return (0, _effects.put)({ type: _constants2.UPDATE_DOCUMENTS, documentData: (0, _immutable.fromJS)(newDocumentJSON) });
	
	        case 38:
	          updatedDeliverableJSON.mostRecentDocument = newDocumentJSON;
	          _context.next = 41;
	          return (0, _effects.put)({ type: _constants2.UPDATE_DELIVERABLES, deliverableData: (0, _immutable.fromJS)(updatedDeliverableJSON) });
	
	        case 41:
	          _context.next = 43;
	          return (0, _effects.select)(_campaignSelectors.getPermissionId);
	
	        case 43:
	          myPermissionId = _context.sent;
	          message = updatedDeliverableJSON.title;
	          metaData = {
	            messageType: 'deliverable',
	            permissionId: myPermissionId,
	            discussionId: discussionId,
	            deliverableId: updatedDeliverableJSON.id,
	            docId: newDocumentJSON.id,
	            deliverableStatus: 'submitted'
	          };
	          _context.next = 48;
	          return (0, _effects.select)(_campaignSelectors.getCampaignId);
	
	        case 48:
	          campaignId = _context.sent;
	          _context.next = 51;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionName);
	
	        case 51:
	          discussionName = _context.sent;
	          addDeliverableData = {
	            campaignId: campaignId,
	            collaborationId: discussionId,
	            collaborationName: discussionName,
	            deliverableId: updatedDeliverableJSON.id,
	            deliverableName: updatedDeliverableJSON.title
	          };
	
	          (0, _metricAnalyticsService.trackEvent)('Add Deliverable', addDeliverableData);
	
	          messageData = {
	            message: message,
	            metaData: metaData,
	            page: _staticConfiguration.DISCUSSION_PAGE
	          };
	          _context.next = 57;
	          return (0, _effects.put)({ type: _constants2.SEND_MESSAGE, data: messageData });
	
	        case 57:
	          _context.next = 59;
	          return (0, _effects.call)(submitDeliverableCallback);
	
	        case 59:
	          _context.next = 61;
	          return (0, _effects.put)({ type: _modal.MODAL_CLEAR });
	
	        case 61:
	          _context.next = 68;
	          break;
	
	        case 63:
	          _context.prev = 63;
	          _context.t0 = _context['catch'](0);
	
	          (0, _errorHandlingService.reportError)('ADD_DELIVERABLE_ERROR', _context.t0.message);
	          _context.next = 68;
	          return (0, _effects.put)({ type: _modal.MODAL_ERROR, error: _context.t0 });
	
	        case 68:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 63]]);
	}
	
	function getAvailableSubmitTypes(assetType) {
	  var initialSubmitType = {
	    VIDEO: 'url',
	    IMAGE: 'upload',
	    BLOG: 'url',
	    TEXT: 'text'
	  };
	
	  var data = {
	    submitType: initialSubmitType[assetType],
	    isUploadActive: assetType !== _staticConfiguration.TEXT,
	    isUrlActive: assetType === _staticConfiguration.VIDEO || assetType === _staticConfiguration.BLOG,
	    isTextActive: assetType === _staticConfiguration.TEXT
	  };
	  return data;
	}
	
	function updateAddDeliverableFormOptions(action) {
	  var deliverableId, updateSubmitTypeCallback, selectedDeliverable, assetType, data;
	  return _regenerator2.default.wrap(function updateAddDeliverableFormOptions$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          deliverableId = action.deliverableId;
	          updateSubmitTypeCallback = action.callback;
	          _context2.next = 4;
	          return (0, _effects.select)(_discussionSelectors.getDeliverableObject, deliverableId);
	
	        case 4:
	          selectedDeliverable = _context2.sent;
	
	          if (!selectedDeliverable) {
	            _context2.next = 12;
	            break;
	          }
	
	          assetType = selectedDeliverable.get('assetType').toUpperCase();
	          data = void 0;
	
	          if (assetType === _staticConfiguration.VIDEO || assetType === _staticConfiguration.IMAGE || assetType === _staticConfiguration.TEXT || assetType === _staticConfiguration.BLOG) {
	            data = getAvailableSubmitTypes(assetType);
	            data.selectedDeliverable = deliverableId;
	            data.assetType = assetType;
	          } else {
	            data = {
	              selectedDeliverable: deliverableId,
	              assetType: assetType,
	              submitType: 'url',
	              isUploadActive: true,
	              isUrlActive: true,
	              isTextActive: true
	            };
	          }
	          updateSubmitTypeCallback(data.submitType);
	          _context2.next = 12;
	          return (0, _effects.put)({ type: _constants.SET_INITIAL_SUBMIT_TYPE, data: data });
	
	        case 12:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function watchSubmitDeliverable() {
	  return _regenerator2.default.wrap(function watchSubmitDeliverable$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.SUBMIT_DELIVERABLE, submitExistingDeliverable);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function watchUpdateAddDeliverableFormOptions() {
	  return _regenerator2.default.wrap(function watchUpdateAddDeliverableFormOptions$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.UPDATE_ADD_DELIVERABLE_FORM_OPTIONS, updateAddDeliverableFormOptions);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function deliverableSubmitSaga() {
	  return _regenerator2.default.wrap(function deliverableSubmitSaga$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(watchSubmitDeliverable), (0, _effects.fork)(watchUpdateAddDeliverableFormOptions)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 2109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadDeliverable = loadDeliverable;
	exports.setLoadingDeliverable = setLoadingDeliverable;
	exports.createComment = createComment;
	exports.clearDeliverable = clearDeliverable;
	exports.approveDeliverable = approveDeliverable;
	exports.changeSelectedDocumentVersion = changeSelectedDocumentVersion;
	
	var _constants = __webpack_require__(559);
	
	function loadDeliverable(deliverableId) {
	  return {
	    type: _constants.LOAD_DELIVERABLE,
	    deliverableId: deliverableId
	  };
	}
	
	function setLoadingDeliverable() {
	  return {
	    type: _constants.SET_LOADING_DELIVERABLE
	  };
	}
	
	function createComment(data) {
	  return {
	    type: _constants.CREATE_COMMENT,
	    data: data
	  };
	}
	
	function clearDeliverable() {
	  return {
	    type: _constants.CLEAR_DELIVERABLE
	  };
	}
	
	function approveDeliverable() {
	  return {
	    type: _constants.APPROVE_DELIVERABLE
	  };
	}
	
	function changeSelectedDocumentVersion(data) {
	  return {
	    type: _constants.CHANGE_SELECT_DOCUMENT_VERSION,
	    data: data
	  };
	}

/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactPlayer = __webpack_require__(453);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _immutable = __webpack_require__(71);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _s3Service = __webpack_require__(573);
	
	var _actions = __webpack_require__(2109);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _deliverableSubmitModal = __webpack_require__(2106);
	
	var _deliverableSubmitModal2 = _interopRequireDefault(_deliverableSubmitModal);
	
	var _modal = __webpack_require__(103);
	
	var _formInputTextarea = __webpack_require__(875);
	
	var _formInputTextarea2 = _interopRequireDefault(_formInputTextarea);
	
	var _dropdown = __webpack_require__(542);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _roleService = __webpack_require__(143);
	
	var _image = __webpack_require__(1951);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _helperFunctions = __webpack_require__(107);
	
	var _avatar = __webpack_require__(191);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _imageModal = __webpack_require__(1950);
	
	var _imageModal2 = _interopRequireDefault(_imageModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Deliverable = function (_React$Component) {
	  _inherits(Deliverable, _React$Component);
	
	  function Deliverable(props, context) {
	    var _this2 = this;
	
	    _classCallCheck(this, Deliverable);
	
	    var _this = _possibleConstructorReturn(this, (Deliverable.__proto__ || Object.getPrototypeOf(Deliverable)).call(this, props, context));
	
	    _this.handleScroll = function (event) {
	      var scrollTop = window.pageYOffset || window.pageOffsetY || 0;
	      var fixed = _this.state.fixed;
	
	
	      if (scrollTop > 60 && !fixed) {
	        _this.setState({ fixed: true });
	      }
	      if (scrollTop <= 60 && fixed) {
	        _this.setState({ fixed: false });
	      }
	    };
	
	    _this.downloadFile = function (filePath) {
	      return function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	          var downloadFileURL;
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  e.preventDefault();
	                  _context.next = 3;
	                  return (0, _s3Service.getTemporarySignedUrl)(filePath);
	
	                case 3:
	                  downloadFileURL = _context.sent;
	
	                case 4:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }();
	    };
	
	    _this.settingsFeedback = function (action) {
	      _this.context.router.push(action);
	    };
	
	    _this.showModal = function (docType) {
	      return function () {
	        return _this.props.onSetModal(docType);
	      };
	    };
	
	    _this.updateDeliverableApproved = function () {
	      return _this.props.onApproveDeliverable();
	    };
	
	    _this.submitComment = function (formData) {
	      var comment = formData.get('newComment');
	      var deliverable = _this.props.deliverable;
	
	      // Ignore empty comments
	
	      if (!comment || comment && !comment.trim()) {
	        _this.props.reset();
	        return null;
	      }
	
	      var data = {
	        comment: comment,
	        deliverableId: deliverable.get('id'),
	        documentId: deliverable.get('document') ? deliverable.getIn(['document', 'id']) : null
	      };
	
	      _this.props.onCreateComment(data);
	      _this.props.reset();
	    };
	
	    _this.toggleImageModal = function (url) {
	      _this.setState({ imageModal: _this.state.imageModal ? null : url });
	    };
	
	    _this.openFileURL = function (url) {
	      return function () {
	        return window.open(url, '_self');
	      };
	    };
	
	    _this.openExternalURL = function (url) {
	      return function () {
	        var externalURL = url;
	        if (externalURL.indexOf('http://') === -1 && externalURL.indexOf('https://') === -1) externalURL = 'http://' + externalURL;
	        window.open(externalURL, '_blank');
	      };
	    };
	
	    _this.renderDeliverable = function (document) {
	      if (!document) return null;
	
	      var filePath = document.get('filePath') || null;
	      var contentType = document.get('contentType') || null;
	      var downloadURL = document.get('downloadURL') || null;
	      var externalURL = document.get('externalURL') || null;
	      var fileType = document.get('fileType') || null;
	      var name = document.get('name') || '';
	      var size = document.get('size') || 0;
	      var formattedSize = (0, _numeral2.default)(size).format('0.0 b').replace('.0', '');
	
	      var fileIconOptions = {
	        DOC_URL: '/icons/word-document.svg',
	        PDF_URL: '/icons/pdf-document.svg',
	        FILE_URL: '/icons/generic-document.svg',
	        EXTERNAL_URL: '/icons/link.svg'
	      };
	
	      if (fileType === 'text') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'text-callout' },
	          _react2.default.createElement(
	            'div',
	            { className: 'text-container' },
	            _react2.default.createElement(
	              'p',
	              null,
	              filePath
	            )
	          )
	        );
	      }
	      if (contentType === _staticConfiguration.YOUTUBE_URL) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cinema-callout' },
	          _react2.default.createElement(_reactPlayer2.default, {
	            url: filePath,
	            width: '100%',
	            height: '500px',
	            controls: true
	          })
	        );
	      } else if (contentType === _staticConfiguration.IMAGE_URL) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'image-callout', onClick: function onClick() {
	              return _this.toggleImageModal(downloadURL);
	            } },
	          _react2.default.createElement(_image2.default, { width: '100%', height: '400px', imageUrl: downloadURL })
	        );
	      } else if (downloadURL && (contentType === _staticConfiguration.DOC_URL || contentType === _staticConfiguration.PDF_URL || contentType === _staticConfiguration.FILE_URL)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'document-callout', onClick: _this.openFileURL(downloadURL) },
	          _react2.default.createElement('img', { src: fileIconOptions[contentType], alt: 'doc file' }),
	          _react2.default.createElement(
	            'p',
	            { className: 'document-name' },
	            name
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'small light document-size' },
	            formattedSize,
	            ' - click to download'
	          )
	        );
	      }
	      if (externalURL) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'document-callout', onClick: _this.openExternalURL(externalURL) },
	          _react2.default.createElement('img', { src: fileIconOptions[contentType], alt: 'external url' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            externalURL
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'small light' },
	            'click to open in a new tab'
	          )
	        );
	      }
	    };
	
	    _this.onSelectDocumentDropdown = function (action) {
	      _this.props.onChangeSelectedDocumentVersion({ version: action.version });
	    };
	
	    _this.state = {
	      fixed: false,
	      imageUrl: null,
	      imageModal: null
	    };
	    return _this;
	  }
	
	  _createClass(Deliverable, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var deliverableId = this.props.routeParams ? this.props.routeParams.id : null;
	      if (!deliverableId) this.context.router.push('/');
	      this.props.onLoadDeliverable(deliverableId);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onClearDeliverable();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          loading = _props.loading,
	          deliverable = _props.deliverable,
	          error = _props.error,
	          handleSubmit = _props.handleSubmit,
	          myUserRole = _props.myUserRole,
	          document = _props.document,
	          mostRecentDocument = _props.mostRecentDocument,
	          documentVersionOptions = _props.documentVersionOptions,
	          selectedVersion = _props.selectedVersion;
	      var _state = this.state,
	          fixed = _state.fixed,
	          imageModal = _state.imageModal;
	
	      var title = deliverable ? deliverable.get('title') : null;
	      var dueDate = deliverable ? new Date(deliverable.get('dueDate')) : null;
	      var liveDateEnd = deliverable ? new Date(deliverable.get('liveDateEnd')) : null;
	      var assetType = deliverable ? deliverable.get('assetType') + ',' : null;
	      var assetTypeFormatted = assetType ? assetType.split(',') : null;
	
	      var filePath = document ? document.get('filePath') : null;
	      var getImageUrl = this.downloadFile(filePath);
	      var comments = deliverable ? deliverable.get('comments') : null;
	      var discussionId = deliverable ? deliverable.getIn(['discussion', 'id']) : null;
	      var discussionName = deliverable ? deliverable.getIn(['discussion', 'name']) : null;
	      var description = deliverable ? deliverable.get('description') : null;
	      var deliverableVersion = deliverable ? deliverable.get('version') : null;
	      var documentVersion = document ? document.get('version') : null;
	      var copyRequirements = document.get('message') || null;
	
	      var isUserTeamMember = (0, _roleService.checkUserIsTeamMember)(myUserRole);
	      var isUserAnAdmin = (0, _roleService.checkUserHasAdminRights)(myUserRole);
	
	      var channelType = deliverable ? deliverable.get('channelType') : null;
	
	      var deliverableAdded = mostRecentDocument && mostRecentDocument.size > 0;
	      var deliverableApproved = mostRecentDocument ? mostRecentDocument.get('approved') : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        error && !loading && _react2.default.createElement(
	          'p',
	          null,
	          error
	        ),
	        loading && _react2.default.createElement(
	          'div',
	          { className: 'preloader' },
	          _react2.default.createElement('img', { src: '/icons/dyzio-icon.svg', alt: 'Loading...' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cinema-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'discussion-header ' + fixed },
	            _react2.default.createElement(
	              'div',
	              { onClick: function onClick() {
	                  return _this3.context.router.push('/campaign/discussion/' + discussionId);
	                }, className: 'one' },
	              _react2.default.createElement('img', { src: '/icons/chevron-left.svg', alt: 'back to discussion' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'two', onClick: function onClick() {
	                  return _this3.context.router.push('/campaign/discussion/' + discussionId);
	                } },
	              loading ? _react2.default.createElement(
	                'h3',
	                null,
	                'Loading...'
	              ) : _react2.default.createElement(
	                'h3',
	                null,
	                discussionName
	              )
	            ),
	            _react2.default.createElement('div', { className: 'three' }),
	            _react2.default.createElement('div', { className: 'flex-spacer' }),
	            _react2.default.createElement('div', { className: 'four' })
	          ),
	          !loading && deliverable && document && this.renderDeliverable(document),
	          !loading && copyRequirements && _react2.default.createElement(
	            'div',
	            { className: 'deliverable-copy-text' },
	            _react2.default.createElement(
	              'p',
	              null,
	              copyRequirements
	            )
	          )
	        ),
	        !loading && deliverable && _react2.default.createElement(
	          'div',
	          { className: 'deliverable' },
	          _react2.default.createElement(
	            'div',
	            { className: 'right' },
	            deliverableAdded && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Approval'
	              ),
	              _react2.default.createElement('div', { className: 'spacer small' }),
	              _react2.default.createElement(
	                'p',
	                { className: 'small' },
	                isUserTeamMember ? 'Once approved the influencer will be instructed to set it live on the live date' : 'Once approved please set it live on the live date stated'
	              ),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              !deliverableApproved && isUserTeamMember && _react2.default.createElement(
	                'button',
	                { onClick: this.updateDeliverableApproved, className: 'large seagreen stretch' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'approve'
	                )
	              ),
	              !deliverableApproved && !isUserTeamMember && _react2.default.createElement(
	                'button',
	                { className: 'large stretch disabled' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'await approval...'
	                )
	              ),
	              deliverableApproved && _react2.default.createElement(
	                'button',
	                { className: 'large stretch outline-seagreen' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'approved'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'left' },
	            deliverableVersion > 1 && _react2.default.createElement(
	              _dropdown2.default,
	              {
	                align: 'right',
	                onClick: this.onSelectDocumentDropdown,
	                content: documentVersionOptions
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'clickable' },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  'VERSION ',
	                  selectedVersion,
	                  '\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'light small' },
	                    deliverableVersion === documentVersion ? '(LATEST)' : ''
	                  ),
	                  '\xA0',
	                  _react2.default.createElement('img', { src: '/icons/chevron-down.svg', alt: 'document-version' })
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              'h1',
	              null,
	              title
	            ),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              assetTypeFormatted.map(function (asset) {
	                if (asset && asset.length) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'flex-item', key: asset },
	                    _react2.default.createElement('img', { src: '/icons/' + asset.toLowerCase() + '-asset.svg', alt: asset })
	                  );
	                }
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item' },
	                channelType === _staticConfiguration.YOUTUBE || channelType === _staticConfiguration.FACEBOOK || channelType === _staticConfiguration.INSTAGRAM || channelType === _staticConfiguration.TWITTER || channelType === _staticConfiguration.SNAPCHAT ? _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement('img', { src: '/icons/' + channelType.toLowerCase() + '-round.svg', alt: channelType }),
	                  '\xA0\xA0\xA0'
	                ) : _react2.default.createElement(
	                  'p',
	                  { className: 'channel-type-text' },
	                  channelType
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Due date: '
	                  ),
	                  (0, _moment2.default)(dueDate).format('ddd D MMM')
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Live date: '
	                  ),
	                  (0, _moment2.default)(liveDateEnd).format('ddd D MMM')
	                )
	              )
	            ),
	            description && _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Requirements: '
	                  ),
	                  description
	                )
	              ),
	              _react2.default.createElement('div', { className: 'flex-spacer' })
	            ),
	            _react2.default.createElement('div', { className: 'spacer large' }),
	            _react2.default.createElement('div', { className: 'break' }),
	            _react2.default.createElement('div', { className: 'spacer' }),
	            _react2.default.createElement(
	              'h4',
	              { className: 'image-heading' },
	              _react2.default.createElement('img', { src: '/icons/comment.svg', alt: 'comments' }),
	              'Comments'
	            ),
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              'form',
	              { onSubmit: handleSubmit(this.submitComment) },
	              _react2.default.createElement(_immutable.Field, { component: _formInputTextarea2.default, name: 'newComment', placeholder: '' }),
	              _react2.default.createElement('div', { className: 'spacer small' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'align-right' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', className: 'medium rose small-image' },
	                  'Add comment\xA0\xA0\xA0',
	                  _react2.default.createElement('img', { src: '/icons/send-white.svg', alt: 'send comment' })
	                )
	              )
	            ),
	            comments.size > 0 && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h4',
	                null,
	                comments.size + ' ' + (comments.size === 1 ? 'comment' : 'comments')
	              ),
	              _react2.default.createElement('div', { className: 'spacer small' }),
	              _react2.default.createElement('div', { className: 'break' }),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              comments.map(function (commentData) {
	                var id = commentData.get('id');
	                var senderName = commentData.get('createdBy');
	                var dateSent = new Date(commentData.get('createdDate'));
	                var dateFormatted = (0, _helperFunctions.getDate)(dateSent);
	                var comment = commentData.get('comment');
	                var commentType = commentData.get('commentType');
	                return _react2.default.createElement(
	                  'div',
	                  { key: id, className: 'simple-message' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'top' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'avatar' },
	                      _react2.default.createElement(_avatar2.default, { name: senderName, size: 36, plain: true })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'user-info' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        senderName,
	                        '\xA0\xA0',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'light' },
	                          (0, _moment2.default)(dateSent).format('ddd D MMM hh:mm')
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'content-container' },
	                    _react2.default.createElement('div', { className: 'spacer small' }),
	                    commentType === 'VERSION' ? _react2.default.createElement(
	                      'div',
	                      { className: 'version-container' },
	                      _react2.default.createElement('img', { src: '/icons/added.svg' }),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        comment
	                      )
	                    ) : _react2.default.createElement(
	                      'p',
	                      null,
	                      comment
	                    ),
	                    _react2.default.createElement('div', { className: 'spacer' })
	                  )
	                );
	              })
	            )
	          ),
	          imageModal && _react2.default.createElement(_imageModal2.default, {
	            url: imageModal,
	            alt: 'image-deliverable',
	            onClear: this.toggleImageModal
	          })
	        ),
	        _react2.default.createElement(_deliverableSubmitModal2.default, null)
	      );
	    }
	  }]);
	
	  return Deliverable;
	}(_react2.default.Component);
	
	Deliverable.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	Deliverable.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    myUserRole: state.campaign.get('myUserRole'),
	    loading: state.deliverable.get('loading'),
	    deliverable: state.deliverable.get('data'),
	    document: state.deliverable.get('selectedDocument'),
	    mostRecentDocument: state.deliverable.get('mostRecentDocument'),
	    documentVersionOptions: state.deliverable.get('documentVersionOptions'),
	    selectedVersion: state.deliverable.get('selectedVersion'),
	    error: state.deliverable.get('error')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onLoadDeliverable: function onLoadDeliverable(deliverableId) {
	      return dispatch((0, _actions.loadDeliverable)(deliverableId));
	    },
	    setLoadingDeliverable: function setLoadingDeliverable() {
	      return dispatch(loadingDeliverable());
	    },
	    onCreateComment: function onCreateComment(data) {
	      return dispatch((0, _actions.createComment)(data));
	    },
	    onClearDeliverable: function onClearDeliverable() {
	      return dispatch((0, _actions.clearDeliverable)());
	    },
	    onApproveDeliverable: function onApproveDeliverable() {
	      return dispatch((0, _actions.approveDeliverable)());
	    },
	    onSetModal: function onSetModal(modalName) {
	      return dispatch((0, _modal.setModal)(modalName));
	    },
	    onChangeSelectedDocumentVersion: function onChangeSelectedDocumentVersion(data) {
	      return dispatch((0, _actions.changeSelectedDocumentVersion)(data));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutable.reduxForm)({
	  form: 'DeliverableComment'
	})(Deliverable));

/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(559);
	
	var initialState = (0, _immutable.fromJS)({
	  loading: false,
	  data: null,
	  error: null,
	  selectedDocument: {},
	  mostRecentDocument: {},
	  selectedVersion: 1,
	  documentVersionOptions: [],
	  commentError: null
	});
	
	function deliverableReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.LOAD_DELIVERABLE:
	      return state.set('data', null).set('paginatedComments', (0, _immutable.fromJS)([])).set('loading', true);
	    case _constants.LOAD_DELIVERABLE_SUCCESS:
	      return state.set('data', action.data).set('selectedDocument', action.selectedDocument).set('documentVersionOptions', action.documentVersionOptions).set('selectedVersion', action.selectedVersion).set('mostRecentDocument', action.mostRecentDocument).set('error', null).set('loading', false);
	    case _constants.LOAD_DELIVERABLE_ERROR:
	      return state.set('loading', false).set('error', action.data);
	    case _constants.CREATE_COMMENT_SUCCESS:
	      return state.setIn(['data', 'comments'], action.comments).set('commentError', null);
	    case _constants.CREATE_COMMENT_ERROR:
	      return state.set('commentError', action.error);
	    case _constants.UPDATE_DELIVERABLE_DOCUMENT_STATE:
	      return state.setIn(['data', 'document'], action.document).setIn(['data', 'documents', action.document.get('version')], action.document).set('mostRecentDocument', action.document);
	    case _constants.CHANGE_SELECT_DOCUMENT_VERSION_SUCCESS:
	      return state.set('selectedDocument', action.selectedDocument).set('selectedVersion', action.selectedVersion);
	    case _constants.CLEAR_DELIVERABLE:
	      return initialState;
	    default:
	      return state;
	  }
	}
	
	exports.default = deliverableReducer;

/***/ },
/* 2112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.loadDeliverableData = loadDeliverableData;
	exports.createNewComment = createNewComment;
	exports.initiateDeliverableApproved = initiateDeliverableApproved;
	exports.watchInitiateDeliverableApproved = watchInitiateDeliverableApproved;
	exports.watchLoadDeliverableRequests = watchLoadDeliverableRequests;
	exports.watchCreateComments = watchCreateComments;
	exports.watchChangeSelectedDocumentVersion = watchChangeSelectedDocumentVersion;
	exports.default = deliverableSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _validator = __webpack_require__(84);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _deliverables = __webpack_require__(288);
	
	var _comments = __webpack_require__(935);
	
	var _deliverableSelectors = __webpack_require__(2261);
	
	var _userSelectors = __webpack_require__(118);
	
	var _campaignPermissionSelectors = __webpack_require__(285);
	
	var _documents = __webpack_require__(364);
	
	var _constants = __webpack_require__(280);
	
	var _campaignSelectors = __webpack_require__(117);
	
	var _metricAnalyticsService = __webpack_require__(119);
	
	var _constants2 = __webpack_require__(283);
	
	var _helperFunctions = __webpack_require__(107);
	
	var _s3Service = __webpack_require__(573);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _constants3 = __webpack_require__(142);
	
	var _constants4 = __webpack_require__(282);
	
	var _sendbird = __webpack_require__(354);
	
	var _constants5 = __webpack_require__(559);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadDeliverableData, changeSelectedDocumentVersion, setupDocument, getDownloadFile, createNewComment, initiateDeliverableApproved, watchInitiateDeliverableApproved, watchLoadDeliverableRequests, watchCreateComments, watchChangeSelectedDocumentVersion, deliverableSagas].map(_regenerator2.default.mark);
	
	function loadDeliverableData(action) {
	  var deliverableData, selectedDocument, documentVersionOptions, currentHighestVersion, latestDocument, documentsMap, campaignPermissionLoading, campaignId, myCampaignOrganisationId, myPermissionId, myCampaignRole, myPermissionName, sendbirdChannelURL;
	  return _regenerator2.default.wrap(function loadDeliverableData$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.call)(_deliverables.getDeliverable, action.deliverableId);
	
	        case 3:
	          deliverableData = _context.sent;
	
	
	          if (deliverableData.comments && deliverableData.comments[0]) {
	            deliverableData.comments.reverse();
	          } else {
	            deliverableData.comments = [];
	          }
	          selectedDocument = (0, _immutable.fromJS)({});
	          documentVersionOptions = [];
	          currentHighestVersion = 1;
	
	          if (!(deliverableData.documents && deliverableData.documents[0])) {
	            _context.next = 18;
	            break;
	          }
	
	          latestDocument = void 0;
	          documentsMap = {};
	
	          _lodash2.default.forEach(deliverableData.documents, function (document) {
	            if (document.version >= currentHighestVersion) {
	              currentHighestVersion = document.version;
	              latestDocument = document;
	            }
	            documentsMap[document.version] = document;
	            documentVersionOptions.push({
	              value: document.version,
	              name: 'VERSION ' + document.version,
	              action: { version: document.version },
	              label: 'VERSION ' + document.version
	            });
	          });
	          _context.next = 14;
	          return (0, _effects.call)(setupDocument, (0, _immutable.fromJS)(latestDocument));
	
	        case 14:
	          selectedDocument = _context.sent;
	
	          deliverableData.documents = documentsMap;
	          _context.next = 22;
	          break;
	
	        case 18:
	          if (!deliverableData.document) {
	            _context.next = 22;
	            break;
	          }
	
	          _context.next = 21;
	          return (0, _effects.call)(setupDocument, (0, _immutable.fromJS)(deliverableData.document));
	
	        case 21:
	          selectedDocument = _context.sent;
	
	        case 22:
	          documentVersionOptions.sort(function (a, b) {
	            return b.value - a.value;
	          });
	
	          // If the permissions list isn't loaded yet then wait for it to finish
	          _context.next = 25;
	          return (0, _effects.select)(_campaignPermissionSelectors.getPermissionListLoading);
	
	        case 25:
	          campaignPermissionLoading = _context.sent;
	
	          if (!campaignPermissionLoading) {
	            _context.next = 29;
	            break;
	          }
	
	          _context.next = 29;
	          return (0, _effects.take)(_constants4.LOAD_CAMPAIGNS_SUCCESS);
	
	        case 29:
	          campaignId = deliverableData.discussion.campaign.id;
	          _context.next = 32;
	          return (0, _effects.select)(_campaignPermissionSelectors.getCampaignPermissionOrganisationId, campaignId);
	
	        case 32:
	          myCampaignOrganisationId = _context.sent;
	          _context.next = 35;
	          return (0, _effects.select)(_campaignPermissionSelectors.getCampaignPermissionId, campaignId);
	
	        case 35:
	          myPermissionId = _context.sent;
	          _context.next = 38;
	          return (0, _effects.select)(_campaignPermissionSelectors.getCampaignPermissionRole, campaignId);
	
	        case 38:
	          myCampaignRole = _context.sent;
	          _context.next = 41;
	          return (0, _effects.select)(_campaignPermissionSelectors.getCampaignPermissionName, campaignId);
	
	        case 41:
	          myPermissionName = _context.sent;
	          _context.next = 44;
	          return (0, _effects.put)({
	            type: _constants.SET_MY_PERMISSION_INFO,
	            role: myCampaignRole,
	            id: myPermissionId,
	            name: myPermissionName,
	            organisationId: myCampaignOrganisationId
	          });
	
	        case 44:
	          sendbirdChannelURL = deliverableData.discussion ? deliverableData.discussion.channelURL : null;
	          _context.next = 47;
	          return (0, _effects.put)({ type: _sendbird.SET_SENDBIRD_CHANNEL_URL, sendbirdChannelURL: sendbirdChannelURL });
	
	        case 47:
	          _context.next = 49;
	          return (0, _effects.put)({
	            type: _constants5.LOAD_DELIVERABLE_SUCCESS,
	            data: (0, _immutable.fromJS)(deliverableData),
	            selectedDocument: selectedDocument,
	            documentVersionOptions: documentVersionOptions,
	            selectedVersion: currentHighestVersion,
	            mostRecentDocument: selectedDocument
	          });
	
	        case 49:
	          _context.next = 56;
	          break;
	
	        case 51:
	          _context.prev = 51;
	          _context.t0 = _context['catch'](0);
	
	          (0, _errorHandlingService.reportError)('LOAD_DELIVERABLE_ERROR', _context.t0.message);
	          _context.next = 56;
	          return (0, _effects.put)({
	            type: _constants5.LOAD_DELIVERABLE_ERROR,
	            data: _context.t0.message
	          });
	
	        case 56:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 51]]);
	}
	
	function changeSelectedDocumentVersion(action) {
	  var version, selectedDocument, setupSelectedDocument;
	  return _regenerator2.default.wrap(function changeSelectedDocumentVersion$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          version = action.data.version;
	          _context2.next = 3;
	          return (0, _effects.select)(_deliverableSelectors.getDocumentByVersion, version);
	
	        case 3:
	          selectedDocument = _context2.sent;
	          _context2.next = 6;
	          return (0, _effects.call)(setupDocument, selectedDocument);
	
	        case 6:
	          setupSelectedDocument = _context2.sent;
	          _context2.next = 9;
	          return (0, _effects.put)({
	            type: _constants5.CHANGE_SELECT_DOCUMENT_VERSION_SUCCESS,
	            selectedDocument: setupSelectedDocument,
	            selectedVersion: version
	          });
	
	        case 9:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function setupDocument(document) {
	  var filePath, fileType, contentType, updatedDocument, downloadURL;
	  return _regenerator2.default.wrap(function setupDocument$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          if (document) {
	            _context3.next = 2;
	            break;
	          }
	
	          return _context3.abrupt('return', null);
	
	        case 2:
	          filePath = document.get('filePath');
	          fileType = document.get('fileType');
	          contentType = (0, _helperFunctions.getFileType)(filePath);
	          updatedDocument = document.set('contentType', contentType);
	
	          if (!(contentType !== _staticConfiguration.YOUTUBE_URL && fileType !== 'url' && fileType !== 'text')) {
	            _context3.next = 13;
	            break;
	          }
	
	          _context3.next = 9;
	          return (0, _effects.call)(getDownloadFile, filePath);
	
	        case 9:
	          downloadURL = _context3.sent;
	
	          if (downloadURL) {
	            updatedDocument = updatedDocument.set('downloadURL', downloadURL);
	          }
	          _context3.next = 14;
	          break;
	
	        case 13:
	          updatedDocument = updatedDocument.set('externalURL', filePath);
	
	        case 14:
	          if (contentType !== _staticConfiguration.YOUTUBE_URL && fileType !== 'upload' && fileType !== 'text') {
	            updatedDocument = updatedDocument.set('contentType', _staticConfiguration.EXTERNAL_URL);
	          }
	          return _context3.abrupt('return', updatedDocument);
	
	        case 16:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function getDownloadFile(filePath) {
	  var fileURL;
	  return _regenerator2.default.wrap(function getDownloadFile$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.prev = 0;
	          _context4.next = 3;
	          return (0, _effects.call)(_s3Service.getTemporarySignedUrl, filePath);
	
	        case 3:
	          fileURL = _context4.sent;
	          return _context4.abrupt('return', fileURL);
	
	        case 7:
	          _context4.prev = 7;
	          _context4.t0 = _context4['catch'](0);
	          return _context4.abrupt('return', false);
	
	        case 10:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this, [[0, 7]]);
	}
	
	function createNewComment(action) {
	  var _action$data, comment, deliverableId, documentId, userId, data, newComment, immutableComment, updatedDeliverable, comments, updatedComments;
	
	  return _regenerator2.default.wrap(function createNewComment$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.prev = 0;
	          _action$data = action.data, comment = _action$data.comment, deliverableId = _action$data.deliverableId, documentId = _action$data.documentId;
	          _context5.next = 4;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 4:
	          userId = _context5.sent;
	          data = {
	            comment: comment,
	            deliverableId: deliverableId,
	            documentId: documentId,
	            userId: userId
	          };
	          _context5.next = 8;
	          return (0, _effects.call)(_comments.createComment, data);
	
	        case 8:
	          newComment = _context5.sent;
	          immutableComment = (0, _immutable.fromJS)(newComment.toJSONTree());
	          _context5.next = 12;
	          return (0, _effects.call)(_deliverables.updateDeliverableComments, deliverableId, newComment);
	
	        case 12:
	          updatedDeliverable = _context5.sent;
	          _context5.next = 15;
	          return (0, _effects.select)(_deliverableSelectors.getDeliverableComments);
	
	        case 15:
	          comments = _context5.sent;
	          updatedComments = comments.unshift(immutableComment);
	          _context5.next = 19;
	          return (0, _effects.put)({ type: _constants5.CREATE_COMMENT_SUCCESS, comments: updatedComments });
	
	        case 19:
	          _context5.next = 26;
	          break;
	
	        case 21:
	          _context5.prev = 21;
	          _context5.t0 = _context5['catch'](0);
	
	          (0, _errorHandlingService.reportError)('CREATE_COMMENT_ERROR', _context5.t0.message);
	          _context5.next = 26;
	          return (0, _effects.put)({ type: _constants5.CREATE_COMMENT_ERROR, data: _context5.t0.message });
	
	        case 26:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this, [[0, 21]]);
	}
	
	function initiateDeliverableApproved(actions) {
	  var deliverableId, documentId, approved, userName, updatedApproved, approvedData, newDocument, immutableDocument, permissionId, discussionId, message, metaData, campaignId, campaignName, discussionName, deliverableName, approveDeliverableData, messageData;
	  return _regenerator2.default.wrap(function initiateDeliverableApproved$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.prev = 0;
	          _context6.next = 3;
	          return (0, _effects.select)(_deliverableSelectors.getDeliverableId);
	
	        case 3:
	          deliverableId = _context6.sent;
	          _context6.next = 6;
	          return (0, _effects.select)(_deliverableSelectors.getDocumentId);
	
	        case 6:
	          documentId = _context6.sent;
	          _context6.next = 9;
	          return (0, _effects.select)(_deliverableSelectors.getDocumentApproved);
	
	        case 9:
	          approved = _context6.sent;
	          _context6.next = 12;
	          return (0, _effects.select)(_userSelectors.getUserName);
	
	        case 12:
	          userName = _context6.sent;
	
	
	          // Swap approval
	          updatedApproved = !approved;
	          approvedData = {
	            approved: updatedApproved,
	            approvedBy: userName,
	            approvalDate: new Date()
	          };
	          _context6.next = 17;
	          return (0, _effects.call)(_documents.updateDocumentApproved, documentId, approvedData);
	
	        case 17:
	          newDocument = _context6.sent;
	          immutableDocument = (0, _immutable.fromJS)(newDocument);
	          _context6.next = 21;
	          return (0, _effects.select)(_campaignSelectors.getPermissionId);
	
	        case 21:
	          permissionId = _context6.sent;
	          _context6.next = 24;
	          return (0, _effects.select)(_deliverableSelectors.getDiscussionId);
	
	        case 24:
	          discussionId = _context6.sent;
	          message = 'deliverable';
	          metaData = {
	            messageType: 'deliverable',
	            discussionId: discussionId,
	            permissionId: permissionId,
	            docId: newDocument.id,
	            deliverableId: deliverableId,
	            deliverableStatus: approvedData.approved ? 'approved' : 'submitted'
	          };
	          _context6.next = 29;
	          return (0, _effects.select)(_deliverableSelectors.getCampaignId);
	
	        case 29:
	          campaignId = _context6.sent;
	          _context6.next = 32;
	          return (0, _effects.select)(_deliverableSelectors.getCampaignName);
	
	        case 32:
	          campaignName = _context6.sent;
	          _context6.next = 35;
	          return (0, _effects.select)(_deliverableSelectors.getDiscussionName);
	
	        case 35:
	          discussionName = _context6.sent;
	          _context6.next = 38;
	          return (0, _effects.select)(_deliverableSelectors.getDeliverableName);
	
	        case 38:
	          deliverableName = _context6.sent;
	          approveDeliverableData = {
	            campaignId: campaignId,
	            collaborationId: discussionId,
	            collaborationName: discussionName,
	            deliverableId: deliverableId,
	            deliverableName: deliverableName
	          };
	
	          (0, _metricAnalyticsService.trackEvent)('Approve Deliverable', approveDeliverableData);
	
	          messageData = {
	            message: message,
	            metaData: metaData,
	            page: _staticConfiguration.DELIVERABLE_PAGE
	          };
	          _context6.next = 44;
	          return (0, _effects.put)({ type: _constants3.SEND_MESSAGE, data: messageData });
	
	        case 44:
	          _context6.next = 46;
	          return (0, _effects.put)({
	            type: _constants5.UPDATE_DELIVERABLE_DOCUMENT_STATE,
	            document: immutableDocument
	          });
	
	        case 46:
	          _context6.next = 51;
	          break;
	
	        case 48:
	          _context6.prev = 48;
	          _context6.t0 = _context6['catch'](0);
	
	          (0, _errorHandlingService.reportError)('UPDATE_DELIVERABLE_APPROVED_ERROR', _context6.t0.message);
	
	        case 51:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this, [[0, 48]]);
	}
	
	function watchInitiateDeliverableApproved() {
	  return _regenerator2.default.wrap(function watchInitiateDeliverableApproved$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants5.APPROVE_DELIVERABLE, initiateDeliverableApproved);
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}
	
	function watchLoadDeliverableRequests() {
	  return _regenerator2.default.wrap(function watchLoadDeliverableRequests$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants5.LOAD_DELIVERABLE, loadDeliverableData);
	
	        case 2:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[7], this);
	}
	
	function watchCreateComments() {
	  return _regenerator2.default.wrap(function watchCreateComments$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants5.CREATE_COMMENT, createNewComment);
	
	        case 2:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked[8], this);
	}
	
	function watchChangeSelectedDocumentVersion() {
	  return _regenerator2.default.wrap(function watchChangeSelectedDocumentVersion$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          _context10.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants5.CHANGE_SELECT_DOCUMENT_VERSION, changeSelectedDocumentVersion);
	
	        case 2:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked[9], this);
	}
	
	function deliverableSagas() {
	  return _regenerator2.default.wrap(function deliverableSagas$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          _context11.next = 2;
	          return [(0, _effects.fork)(watchLoadDeliverableRequests), (0, _effects.fork)(watchCreateComments), (0, _effects.fork)(watchInitiateDeliverableApproved), (0, _effects.fork)(watchChangeSelectedDocumentVersion)];
	
	        case 2:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked[10], this);
	}

/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setUnreadMessageCount = setUnreadMessageCount;
	
	var _constants = __webpack_require__(195);
	
	function setUnreadMessageCount(discussionId, unreadMessageCount) {
	  return {
	    type: _constants.SET_UNREAD_MESSAGE_COUNT,
	    discussionId: discussionId,
	    unreadMessageCount: unreadMessageCount
	  };
	}

/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _avatar = __webpack_require__(191);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _roleService = __webpack_require__(143);
	
	var _timeline = __webpack_require__(2030);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _actions = __webpack_require__(2113);
	
	var _documentStatusFunctions = __webpack_require__(2373);
	
	var _deliverableStatusFunctions = __webpack_require__(2371);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _budgetReadonly = __webpack_require__(861);
	
	var _budgetReadonly2 = _interopRequireDefault(_budgetReadonly);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiscussionCard = function (_React$Component) {
	  _inherits(DiscussionCard, _React$Component);
	
	  function DiscussionCard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DiscussionCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiscussionCard.__proto__ || Object.getPrototypeOf(DiscussionCard)).call.apply(_ref, [this].concat(args))), _this), _this.viewDiscussion = function (discussion) {
	      return function () {
	        _this.context.router.push('/campaign/discussion/' + discussion.get('id'));
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DiscussionCard, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          campaign = _props.campaign,
	          members = _props.members,
	          pendingInvitations = _props.pendingInvitations,
	          discussion = _props.discussion,
	          size = _props.size,
	          isCreatorDiscussion = _props.isCreatorDiscussion,
	          myUserRole = _props.myUserRole,
	          influencer = _props.influencer;
	
	
	      var currentBrief = discussion.get('currentBrief') ? discussion.getIn(['documents', discussion.get('currentBrief')]) : null;
	      var currentContract = discussion.get('currentContract') ? discussion.getIn(['documents', discussion.get('currentContract')]) : null;
	      var signedContract = discussion.get('signedContract') ? discussion.getIn(['documents', discussion.get('signedContract')]) : null;
	      var deliverable = discussion.get('deliverables') || null;
	
	      var budget = discussion.get('budget');
	      var budgetStatus = discussion.get('budgetStatus');
	
	      var docsStatus = {
	        brief: (0, _documentStatusFunctions.getBriefStatus)(currentBrief),
	        contract: (0, _documentStatusFunctions.getContractStatus)(currentContract, signedContract)
	      };
	
	      var deliverableStatus = (0, _deliverableStatusFunctions.getDeliverablesStatus)(deliverable);
	
	      var isUserTeamMember = (0, _roleService.checkUserIsTeamMember)(myUserRole);
	
	      var unreadMessageCount = discussion.get('unreadMessageCount');
	      var organisations = discussion.get('organisations') || [];
	
	      var influencers = {
	        laurieb: {
	          name: 'Laurie Bantin',
	          thumbnail: 'https://scontent.cdninstagram.com/t51.2885-19/s320x320/14515731_1860820994152776_4329187327671795712_a.jpg',
	          youtubeCount: 1000,
	          instagramCount: 1000,
	          facebookCount: 1000,
	          twitterCount: 1000,
	          totalSocialReach: 4000
	        },
	        fleurdeforce: {
	          name: 'Fleur Bell',
	          thumbnail: 'https://yt3.ggpht.com/-l2_MNdgQUkk/AAAAAAAAAAI/AAAAAAAAAAA/fZvKNfxvW3I/s240-c-k-no-rj-c0xffffff/photo.jpg',
	          youtubeCount: 1000000,
	          instagramCount: 793000,
	          facebookCount: 134000,
	          twitterCount: 324000,
	          totalSocialReach: 3000000
	        },
	        amelialiana: {
	          name: 'Amelia Liana',
	          thumbnail: 'https://yt3.ggpht.com/-Uuolk7bSoiI/AAAAAAAAAAI/AAAAAAAAAAA/SV_4_QOQToc/s240-c-k-no-rj-c0xffffff/photo.jpg',
	          youtubeCount: 457000,
	          instagramCount: 303000,
	          facebookCount: 0,
	          twitterCount: 113000,
	          totalSocialReach: 874000
	        },
	        'patricia bright': {
	          name: 'Patricia Bright',
	          thumbnail: 'https://yt3.ggpht.com/-whml5kuDoP8/AAAAAAAAAAI/AAAAAAAAAAA/qUiBGxo3l1U/s240-c-k-no-rj-c0xffffff/photo.jpg',
	          youtubeCount: 1000000,
	          instagramCount: 473000,
	          facebookCount: 0,
	          twitterCount: 77000,
	          totalSocialReach: 1600000
	        },
	        zoella: {
	          name: 'Zoe Sugg',
	          thumbnail: 'https://yt3.ggpht.com/-n8WEOU4tnok/AAAAAAAAAAI/AAAAAAAAAAA/-8oUr21Iido/s240-c-k-no-rj-c0xffffff/photo.jpg',
	          youtubeCount: 16400000,
	          instagramCount: 7900000,
	          facebookCount: 2700000,
	          twitterCount: 8100000,
	          totalSocialReach: 35100000
	        },
	        funforlouis: {
	          name: 'Louis Cole',
	          thumbnail: 'https://yt3.ggpht.com/-wmWCuxokuSY/AAAAAAAAAAI/AAAAAAAAAAA/xuzLxJLwT5M/s240-c-k-no-rj-c0xffffff/photo.jpg',
	          youtubeCount: 1900000,
	          instagramCount: 1400000,
	          facebookCount: 421000,
	          twitterCount: 866000,
	          totalSocialReach: 4600000
	        },
	        callux: {
	          name: 'Callum McGinley',
	          thumbnail: 'https://yt3.ggpht.com/-V-5kI2sfpd8/AAAAAAAAAAI/AAAAAAAAAAA/2ocZdYE0fpI/s240-c-k-no-rj-c0xffffff/photo.jpg',
	          youtubeCount: 2200000,
	          instagramCount: 556000,
	          facebookCount: 19000,
	          twitterCount: 627000,
	          totalSocialReach: 3400000
	        },
	        stevebooker: {
	          name: 'Steve Booker',
	          thumbnail: 'https://yt3.ggpht.com/-qjiv0wmxYec/AAAAAAAAAAI/AAAAAAAAAAA/jUi52wI5IBU/s240-c-k-no-mo-rj-c0xffffff/photo.jpg'
	        },
	        mrbenbrown: {
	          name: 'Ben Brown',
	          thumbnail: 'https://yt3.ggpht.com/-4Jjs_8d231s/AAAAAAAAAAI/AAAAAAAAAAA/EnEH_q1MEbQ/s240-c-k-no-rj-c0xffffff/photo.jpg'
	        },
	        soniatravels: {
	          name: 'Sonia Wright',
	          thumbnail: 'https://yt3.ggpht.com/-KIdCZCo7-mM/AAAAAAAAAAI/AAAAAAAAAAA/anL0kIA_J64/s240-c-k-no-rj-c0xffffff/photo.jpg'
	        },
	        'hey nadine': {
	          name: 'Nadine Smith',
	          thumbnail: 'https://yt3.ggpht.com/-IE9zWKgAAIA/AAAAAAAAAAI/AAAAAAAAAAA/MgaQTBTMi-0/s240-c-k-no-rj-c0xffffff/photo.jpg'
	        }
	      };
	
	      var localInfluencer = influencer || influencers[_lodash2.default.toLower(discussion.get('name'))];
	
	      var localStyles = {
	        borderBottom: '1px solid #eee',
	        paddingBottom: '10px'
	      };
	
	      var budgetStyles = {
	        float: 'right',
	        width: '200px'
	      };
	
	      var bc1Styles = {
	        paddingTop: 0,
	        paddingBottom: 6
	      };
	
	      var pendingStyle = {
	        backgroundColor: '#ddd',
	        padding: '10px 0',
	        textAlign: 'center'
	      };
	
	      var dataWrapper = {
	        width: '300px !important'
	      };
	      var commaFormat = function commaFormat(num) {
	        return (0, _numeral2.default)(num).format('0a');
	      };
	      var isInfluencerMember = function isInfluencerMember(joined) {
	        return joined.find(function (member) {
	          return member.get('role') === 'INFLUENCER';
	        });
	      };
	      var influencerJoined = isInfluencerMember(members);
	
	      return _react2.default.createElement(
	        'div',
	        { className: size === 'large' ? 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' : 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-3-6 grid-xl-3-6' },
	        _react2.default.createElement(
	          'div',
	          { className: 'box wide clickable' },
	          _react2.default.createElement(
	            'div',
	            { className: 'box-content-one' },
	            _react2.default.createElement(
	              'div',
	              { className: 'title-row', style: localStyles },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-spacer' },
	                _react2.default.createElement(
	                  'table',
	                  { width: '100%' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        isCreatorDiscussion && localInfluencer && _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(_semanticUiReact.Image, { src: localInfluencer.thumbnail, size: 'tiny', shape: 'circular', inline: true, spaced: true }),
	                          localInfluencer.name,
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'small light' },
	                            '\xA0',
	                            discussion.get('name')
	                          )
	                        ),
	                        !(isCreatorDiscussion && localInfluencer) && _react2.default.createElement(
	                          'div',
	                          null,
	                          discussion.get('name')
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      isCreatorDiscussion && localInfluencer && _react2.default.createElement(
	                        'div',
	                        { className: 'flex', styles: dataWrapper },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'space align-center' },
	                          _react2.default.createElement('img', { src: '/icons/facebook.svg', alt: 'Facebook' }),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'light' },
	                            commaFormat(localInfluencer.facebookCount)
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'space align-center' },
	                          _react2.default.createElement('img', { src: '/icons/instagram.svg', alt: 'Instagram' }),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'light' },
	                            commaFormat(localInfluencer.instagramCount)
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'space align-center' },
	                          _react2.default.createElement('img', { src: '/icons/twitter.svg', alt: 'Twitter' }),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'light' },
	                            commaFormat(localInfluencer.twitterCount)
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'space align-center' },
	                          _react2.default.createElement('img', { src: '/icons/youtube.svg', alt: 'YouTube' }),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'light' },
	                            commaFormat(localInfluencer.youtubeCount)
	                          )
	                        ),
	                        _react2.default.createElement('div', { className: 'space' }),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'item align-center' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'b',
	                              null,
	                              'Total Reach'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'light' },
	                            commaFormat(localInfluencer.totalSocialReach)
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-item' },
	                unreadMessageCount > 0 && _react2.default.createElement(
	                  'div',
	                  { className: 'unread-message' },
	                  _react2.default.createElement('img', { src: '/icons/unread.svg', alt: 'Unread messages' }),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'small' },
	                    unreadMessageCount
	                  )
	                )
	              )
	            )
	          ),
	          !isCreatorDiscussion && _react2.default.createElement(
	            'div',
	            { className: 'box-content-one' },
	            _react2.default.createElement(
	              'div',
	              { className: 'profile-row' },
	              _react2.default.createElement(
	                'ul',
	                null,
	                members.map(function (member) {
	                  var memberId = member.get('id');
	                  var name = member.get('name');
	                  // TODO This really shouldn't be done via organisation ID
	                  var role = member.get('role');
	                  var email = member.get('email');
	                  var organisationId = null;
	                  // Avoids circular issue in data tree
	                  if ((0, _roleService.checkUserIsTeamMember)(role)) {
	                    organisationId = campaign.getIn(['owner', 'id']);
	                  } else {
	                    organisationId = member.getIn(['organisation', 'id']);
	                  }
	
	                  var userPartOfDiscussion = organisations.find(function (organisation) {
	                    return organisationId === organisation.get('id');
	                  });
	
	                  if (userPartOfDiscussion) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: memberId },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'clickable', onClick: _this2.viewDiscussion.bind(_this2, discussion) },
	                        'joined: ',
	                        _react2.default.createElement(_avatar2.default, { name: name, role: role, email: email, size: 44, className: 'clickable' })
	                      )
	                    );
	                  }
	                  return '';
	                }),
	                organisations.map(function (organisation) {
	                  var organisationId = organisation.get('id');
	                  var pendingInvitationsList = pendingInvitations.get(organisationId);
	                  return _react2.default.createElement(
	                    'span',
	                    { key: organisationId },
	                    pendingInvitationsList && pendingInvitationsList.map(function (member) {
	                      var memberId = member.get('id');
	                      var name = member.get('name');
	                      var role = member.get('role');
	                      var email = member.get('email');
	
	                      return _react2.default.createElement(
	                        'li',
	                        { key: memberId },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'clickable', onClick: _this2.viewDiscussion.bind(_this2, discussion) },
	                          'pending: ',
	                          _react2.default.createElement(_avatar2.default, { name: name, role: role, email: email, pending: true, size: 44, className: 'clickable' })
	                        )
	                      );
	                    })
	                  );
	                })
	              )
	            )
	          ),
	          isCreatorDiscussion && _react2.default.createElement(
	            'div',
	            { className: 'box-content-one', style: bc1Styles },
	            influencerJoined ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { style: budgetStyles },
	                _react2.default.createElement(_budgetReadonly2.default, { budget: budget, budgetStatus: budgetStatus })
	              ),
	              _react2.default.createElement(_timeline2.default, {
	                vertical: false,
	                docsStatus: docsStatus,
	                deliverableStatus: deliverableStatus,
	                isUserTeamMember: isUserTeamMember
	              })
	            ) : _react2.default.createElement(
	              'div',
	              { style: pendingStyle },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Invitation still pending...'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DiscussionCard;
	}(_react2.default.Component);
	
	DiscussionCard.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    campaign: state.campaign.get('campaign'),
	    members: state.members.get('members'),
	    pendingInvitations: state.members.get('pendingInvitations'),
	    userData: state.userData.get('userData'),
	    myUserRole: state.campaign.get('myUserRole')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onSetUnreadMessageCount: function onSetUnreadMessageCount(discussionId, unreadMessageCount) {
	      return dispatch((0, _actions.setUnreadMessageCount)(discussionId, unreadMessageCount));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DiscussionCard);

/***/ },
/* 2115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _immutable = __webpack_require__(71);
	
	var _formInputText = __webpack_require__(104);
	
	var _formInputText2 = _interopRequireDefault(_formInputText);
	
	var _sendbirdService = __webpack_require__(366);
	
	var _formInputCheckbox = __webpack_require__(1943);
	
	var _formInputCheckbox2 = _interopRequireDefault(_formInputCheckbox);
	
	var _actions = __webpack_require__(2122);
	
	var _campaignSelectors = __webpack_require__(117);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _discussions = __webpack_require__(172);
	
	var _campaigns = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderMembers = function renderMembers(_ref) {
	  var members = _ref.members,
	      fields = _ref.fields;
	  return _react2.default.createElement(
	    'div',
	    null,
	    fields.map(function (member, index) {
	      return _react2.default.createElement(
	        'div',
	        { key: index },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Member #',
	          index
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Permission id: ',
	          members[index].permissionId
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Name: ',
	          members[index].name
	        ),
	        _react2.default.createElement(_immutable.Field, {
	          name: member + '.addMember',
	          type: 'checkbox',
	          component: _formInputCheckbox2.default,
	          label: 'name'
	        })
	      );
	    })
	  );
	};
	
	var DiscussionCreate = function (_React$Component) {
	  _inherits(DiscussionCreate, _React$Component);
	
	  function DiscussionCreate() {
	    _classCallCheck(this, DiscussionCreate);
	
	    return _possibleConstructorReturn(this, (DiscussionCreate.__proto__ || Object.getPrototypeOf(DiscussionCreate)).apply(this, arguments));
	  }
	
	  _createClass(DiscussionCreate, [{
	    key: 'extractAddedMembers',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(addedMembersList, sendbirdMembers, formDataList) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                formDataList.forEach(function (addableMember) {
	                  var addMember = addableMember.get('addMember');
	
	                  if (addMember) {
	                    addedMembersList.push({ type: 'campaignPermission', id: addableMember.get('permissionId') });
	                    sendbirdMembers.push(addableMember.get('userId'));
	                  }
	                });
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function extractAddedMembers(_x, _x2, _x3) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return extractAddedMembers;
	    }()
	  }, {
	    key: 'postDiscussion',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(formData) {
	        var discussionName, addedTeamMembers, addedClientMembers, addedInfluencerMembers, addedTalentManagerMembers, addedProductionCompanyMembers, sendbirdMembers, addedMembersList, organisationIds, myPermissionId, myUserId, myOrganisationId, campaignId, channelURL, discussionData, discussion;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                discussionName = formData.get('discussionName');
	                addedTeamMembers = formData.get('addableTeamMembers');
	                addedClientMembers = formData.get('addableClientMembers');
	                addedInfluencerMembers = formData.get('addableInfluencerMembers');
	                addedTalentManagerMembers = formData.get('addableTalentManagerMembers');
	                addedProductionCompanyMembers = formData.get('addableProductionCompanyMembers');
	                sendbirdMembers = [];
	                addedMembersList = [];
	                organisationIds = [];
	
	                // Add the user creating to the discussion to the members list
	
	                myPermissionId = this.props.myPermissionId;
	                myUserId = this.props.userData.get('id');
	                myOrganisationId = this.props.userData.get('organisationId');
	
	
	                addedMembersList.push({ type: 'campaignPermission', id: myPermissionId });
	                sendbirdMembers.push(myUserId);
	                organisationIds.push(myOrganisationId);
	
	                this.extractAddedMembers(addedMembersList, sendbirdMembers, addedTeamMembers, organisationIds);
	                this.extractAddedMembers(addedMembersList, sendbirdMembers, addedClientMembers, organisationIds);
	                this.extractAddedMembers(addedMembersList, sendbirdMembers, addedInfluencerMembers, organisationIds);
	                this.extractAddedMembers(addedMembersList, sendbirdMembers, addedTalentManagerMembers, organisationIds);
	                this.extractAddedMembers(addedMembersList, sendbirdMembers, addedProductionCompanyMembers, organisationIds);
	
	                campaignId = this.props.campaign.get('id');
	                _context2.prev = 21;
	                _context2.next = 24;
	                return _sendbirdService.sendBirdService.connectSendbirdUser(myUserId);
	
	              case 24:
	                _context2.next = 26;
	                return _sendbirdService.sendBirdService.createSendbirdChannel(sendbirdMembers);
	
	              case 26:
	                channelURL = _context2.sent;
	
	
	                // TODO OrganisationIDs list is not currently being completed.
	                discussionData = {
	                  discussionName: discussionName,
	                  addedMembersList: addedMembersList,
	                  channelURL: channelURL,
	                  campaignId: campaignId,
	                  organisationIds: organisationIds
	                };
	                _context2.next = 30;
	                return (0, _discussions.createDiscussion)(discussionData);
	
	              case 30:
	                discussion = _context2.sent;
	                _context2.next = 33;
	                return (0, _campaigns.addDiscussionToCampaign)(campaignId, discussion);
	
	              case 33:
	
	                this.context.router.push('/campaign/' + campaignId);
	                _context2.next = 38;
	                break;
	
	              case 36:
	                _context2.prev = 36;
	                _context2.t0 = _context2['catch'](21);
	
	              case 38:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[21, 36]]);
	      }));
	
	      function postDiscussion(_x4) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return postDiscussion;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          members = _props.members,
	          userData = _props.userData,
	          teamMembers = _props.teamMembers,
	          clientMembers = _props.clientMembers,
	          influencerMembers = _props.influencerMembers,
	          talentManagerMembers = _props.talentManagerMembers,
	          productionCompanyMembers = _props.productionCompanyMembers;
	
	      var userId = userData.get('id');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          members.map(function (member) {
	            /* Users creating the discussion must be included. */
	            if (userId === member.getIn(['user', 'id'])) return '';
	            return _react2.default.createElement(
	              'p',
	              null,
	              'name: ',
	              member.get('name'),
	              ', role: ',
	              member.get('role')
	            );
	          }),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit(this.postDiscussion.bind(this)) },
	            _react2.default.createElement(
	              'div',
	              { className: 'hero left' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Create a discussion'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-4-6' },
	                _react2.default.createElement(_immutable.Field, {
	                  name: 'discussionName',
	                  type: 'text',
	                  label: 'Discussion title',
	                  component: _formInputText2.default,
	                  placeholder: 'Discussion name'
	                }),
	                _react2.default.createElement('div', { className: 'spacer' }),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Team members'
	                ),
	                _react2.default.createElement(_immutable.FieldArray, {
	                  name: 'addableTeamMembers',
	                  members: teamMembers,
	                  component: renderMembers
	                }),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Clients'
	                ),
	                _react2.default.createElement(_immutable.FieldArray, {
	                  name: 'addableClientMembers',
	                  members: clientMembers,
	                  component: renderMembers
	                }),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Influencers'
	                ),
	                _react2.default.createElement(_immutable.FieldArray, {
	                  name: 'addableInfluencerMembers',
	                  members: influencerMembers,
	                  component: renderMembers
	                }),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Talent managers'
	                ),
	                _react2.default.createElement(_immutable.FieldArray, {
	                  name: 'addableTalentManagerMembers',
	                  members: talentManagerMembers,
	                  component: renderMembers
	                }),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Production companies'
	                ),
	                _react2.default.createElement(_immutable.FieldArray, {
	                  name: 'addableProductionCompanyMembers',
	                  members: productionCompanyMembers,
	                  component: renderMembers
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'hero' },
	              _react2.default.createElement(
	                'button',
	                { className: 'large rose wide', type: 'submit' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Create discussion'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DiscussionCreate;
	}(_react2.default.Component);
	
	DiscussionCreate.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	DiscussionCreate.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	function validate(values) {
	  var errors = {};
	
	  var message = values.get('message');
	  if (!message) errors.message = 'Please enter a message';
	
	  // TODO Do the rest of the validation
	  return errors;
	}
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    campaign: state.campaign.get('campaign'),
	    members: state.members.get('members'),
	    userData: state.userData.get('userData'),
	    myPermissionId: state.campaign.get('myPermissionId'),
	    loading: state.discussion.get('loading'),
	    myUserRole: state.campaign.get('myUserRole'),
	    teamMembers: (0, _campaignSelectors.getRoleMembers)(state, [_staticConfiguration.TEAM_MEMBER, _staticConfiguration.CAMPAIGN_OWNER, _staticConfiguration.CAMPAIGN_ADMIN]),
	    clientMembers: (0, _campaignSelectors.getRoleMembers)(state, [_staticConfiguration.CLIENT]),
	    influencerMembers: (0, _campaignSelectors.getRoleMembers)(state, [_staticConfiguration.INFLUENCER]),
	    talentManagerMembers: (0, _campaignSelectors.getRoleMembers)(state, [_staticConfiguration.TALENT_AGENT]),
	    productionCompanyMembers: (0, _campaignSelectors.getRoleMembers)(state, [_staticConfiguration.PRODUCTION_COMPANY]),
	    initialValues: {
	      addableTeamMembers: (0, _campaignSelectors.getRoleMembers)(state, [_staticConfiguration.TEAM_MEMBER, _staticConfiguration.CAMPAIGN_OWNER, _staticConfiguration.CAMPAIGN_ADMIN]),
	      addableClientMembers: (0, _campaignSelectors.getRoleMembers)(state, [_staticConfiguration.CLIENT]),
	      addableInfluencerMembers: (0, _campaignSelectors.getRoleMembers)(state, [_staticConfiguration.INFLUENCER]),
	      addableTalentManagerMembers: (0, _campaignSelectors.getRoleMembers)(state, [_staticConfiguration.TALENT_AGENT]),
	      addableProductionCompanyMembers: (0, _campaignSelectors.getRoleMembers)(state, [_staticConfiguration.PRODUCTION_COMPANY])
	    }
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onSetSendbirdChannel: function onSetSendbirdChannel(channelURL) {
	      return dispatch((0, _actions.setSendbirdChannel)(channelURL));
	    },
	    onSetCurrentDisccusion: function onSetCurrentDisccusion(discussionId) {
	      return dispatch((0, _actions.setCurrentDisccusion)(discussionId));
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutable.reduxForm)({
	  form: 'DiscussionMessages',
	  validate: validate
	})(DiscussionCreate));

/***/ },
/* 2116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _actions = __webpack_require__(911);
	
	var _roleService = __webpack_require__(143);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _discussionCard = __webpack_require__(2114);
	
	var _discussionCard2 = _interopRequireDefault(_discussionCard);
	
	var _collaborationCard = __webpack_require__(2095);
	
	var _collaborationCard2 = _interopRequireDefault(_collaborationCard);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var currentTheme = _themeSelector2.default.theme();
	
	var CORQ_DOMAIN = 'data.corq.studio';
	
	var DiscussionList = function (_React$Component) {
	  _inherits(DiscussionList, _React$Component);
	
	  function DiscussionList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DiscussionList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiscussionList.__proto__ || Object.getPrototypeOf(DiscussionList)).call.apply(_ref, [this].concat(args))), _this), _this.getInfluencerFromOrganisations = function (organisations, discussionName) {
	      if (organisations) {
	        var isDiscussionOrganisation = function isDiscussionOrganisation(organisation) {
	          return organisation.influencer !== null;
	        };
	        var discussionOrganisation = _lodash2.default.find(organisations.toJS(), isDiscussionOrganisation);
	        var influencer = discussionOrganisation && discussionOrganisation.influencer;
	        return influencer;
	      }
	      return null;
	    }, _this.refreshPage = function () {
	      _this.props.reload();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DiscussionList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.reloadDiscussions) {
	        setTimeout(function () {
	          _this2.props.onReloadDiscussions({
	            campaignId: _this2.props.campaignId });
	        }, 4000);
	      } else {
	        this.props.onLoadingDiscussions(this.props.campaignId);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          myUserRole = _props.myUserRole,
	          discussions = _props.discussions,
	          campaign = _props.campaign,
	          error = _props.error,
	          loading = _props.loading,
	          reloadDiscussions = _props.reloadDiscussions,
	          showCollaborationType = _props.showCollaborationType,
	          campaignId = _props.campaignId,
	          filterDiscussionListByTerm = _props.filterDiscussionListByTerm,
	          currency = _props.currency,
	          organisation = _props.organisation,
	          trackedAssetsCount = _props.trackedAssetsCount,
	          restClient = _props.restClient,
	          userInfo = _props.userInfo;
	      var isUserSuperAdmin = userInfo.isUserSuperAdmin;
	
	
	      var clientDiscussionId = campaign.get('clientDiscussion');
	      var clientDiscussion = clientDiscussionId ? discussions.get(clientDiscussionId) : null;
	      var teamDiscussionId = campaign.get('teamDiscussion');
	      var teamDiscussion = teamDiscussionId ? discussions.get(teamDiscussionId) : null;
	      var partnerAgencyDiscussionId = campaign.get('partnerAgencyDiscussion');
	      var partnerAgencyDiscussion = partnerAgencyDiscussionId ? discussions.get(partnerAgencyDiscussionId) : null;
	      var campaignOwner = campaign.get('createdBy');
	      var isUserTeamMember = isUserSuperAdmin || (0, _roleService.checkUserIsTeamMember)(myUserRole);
	
	      var sortedDiscussions = discussions.sortBy(function (d) {
	        return _lodash2.default.toLower(d.get('name'));
	      });
	      var isLoading = loading; // taken out to test || reloadDiscussions;
	
	      var hostname = window.location.hostname;
	
	
	      var isCORQ = hostname === CORQ_DOMAIN;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        isLoading && _react2.default.createElement(
	          'div',
	          { className: 'discussion-preloader' },
	          _react2.default.createElement('img', { src: '/icons/dyzio-icon.svg', alt: 'Loading...' })
	        ),
	        !isLoading && error && _react2.default.createElement(
	          'div',
	          { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hero left' },
	            _react2.default.createElement(
	              _semanticUiReact.Message,
	              { color: 'red' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'There was a problem loading the collaborations: ',
	                error,
	                '. Please check you are connected to the internet and try again.'
	              )
	            )
	          )
	        ),
	        showCollaborationType === _staticConfiguration.GROUP_CHATS && !isLoading && !error && (teamDiscussion || clientDiscussion) && _react2.default.createElement(
	          'div',
	          { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Group Chats'
	          )
	        ),
	        showCollaborationType === _staticConfiguration.GROUP_CHATS && !isLoading && !error && teamDiscussion && isUserTeamMember && _react2.default.createElement(_discussionCard2.default, {
	          discussion: teamDiscussion,
	          size: 'medium',
	          isCreatorDiscussion: false
	        }),
	        showCollaborationType === _staticConfiguration.GROUP_CHATS && !isLoading && !error && clientDiscussion && (isUserTeamMember || myUserRole === _staticConfiguration.CLIENT) && _react2.default.createElement(_discussionCard2.default, {
	          discussion: clientDiscussion,
	          size: 'medium',
	          isCreatorDiscussion: false
	        }),
	        showCollaborationType === _staticConfiguration.GROUP_CHATS && !isLoading && !error && partnerAgencyDiscussion && (myUserRole === _staticConfiguration.PARTNER_AGENCY || isUserTeamMember) && _react2.default.createElement(_discussionCard2.default, {
	          discussion: partnerAgencyDiscussion,
	          size: 'medium',
	          isCreatorDiscussion: false
	        }),
	        showCollaborationType === _staticConfiguration.COLLABORATIONS && !isLoading && sortedDiscussions.size === 0 && !isUserTeamMember && _react2.default.createElement(
	          'div',
	          { style: { width: 1000, margin: '50px auto' } },
	          _react2.default.createElement(_semanticUiReact.Message, {
	            icon: 'ban',
	            error: true,
	            header: 'Sorry... You do not have access to this campaign',
	            content: 'Ask the campaign owner, ' + campaignOwner + ', to invite you.'
	          })
	        ),
	        showCollaborationType === _staticConfiguration.COLLABORATIONS && !isLoading && sortedDiscussions.size > 0
	        // eslint-disable-next-line lodash/prefer-lodash-method
	        && sortedDiscussions.map(function (discussion) {
	          var id = discussion.get('id');
	          var discussionName = discussion.get('name');
	          // Don't show the team or client discussions
	          if (id === clientDiscussionId || id === teamDiscussionId || id === partnerAgencyDiscussionId) {
	            return null;
	          }
	
	          var primarySocialHandle = discussion.get('influencerName');
	          var hasSearchTerm = filterDiscussionListByTerm && _lodash2.default.size(filterDiscussionListByTerm) > 0;
	
	          var term = _lodash2.default.lowerCase(_lodash2.default.trim(filterDiscussionListByTerm));
	
	          var nameMatchValue = _lodash2.default.lowerCase(_lodash2.default.trim(discussionName));
	          var handleMatchValue = _lodash2.default.lowerCase(_lodash2.default.trim(primarySocialHandle));
	
	          var matchesByName = _lodash2.default.includes(nameMatchValue, term);
	          var matchesByPrimaryHandle = _lodash2.default.includes(handleMatchValue, term);
	          if (hasSearchTerm && !matchesByName && !matchesByPrimaryHandle) {
	            return null;
	          }
	
	          var discussionOrganisations = discussion.get('organisations');
	          var influencer = _this3.getInfluencerFromOrganisations(discussionOrganisations, discussionName);
	
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { style: { padding: 15, marginBottom: 15, height: 50 } },
	              _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	                onClick: function onClick() {
	                  return window.open(currentTheme.shareSite + '/collab/' + id + '/campaign');
	                },
	                label: 'open collaboration report...',
	                hasIcon: true,
	                icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'file alternate outline' }),
	                floated: 'right'
	              })
	            ),
	            influencer ? _react2.default.createElement(_collaborationCard2.default, {
	              organisation: organisation,
	              trackedAssetsCount: trackedAssetsCount,
	              discussion: discussion,
	              influencer: influencer,
	              campaign: campaign,
	              currency: currency,
	              restClient: restClient,
	              refreshPageHandler: _this3.refreshPage
	            }) : _react2.default.createElement(_discussionCard2.default, {
	              discussion: discussion,
	              influencer: influencer,
	              size: 'large',
	              isCreatorDiscussion: true
	            })
	          );
	        }),
	        (campaign.get('campaignType') !== 'ACR' || sortedDiscussions.size === 0) && showCollaborationType === _staticConfiguration.COLLABORATIONS && !isLoading && !error && isUserTeamMember && !isCORQ && _react2.default.createElement(
	          'div',
	          { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'box centered small clickable',
	              onClick: function onClick() {
	                return _this3.context.router.push('/campaign/' + campaignId + '/invite');
	              }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'box-content-one' },
	              _react2.default.createElement(
	                'div',
	                { className: 'box-content-two' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-content-three' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'large rose wide' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Add an Influencer or Team Member'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DiscussionList;
	}(_react2.default.Component);
	
	DiscussionList.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	DiscussionList.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    discussions: state.discussionList.get('discussions'),
	    myUserRole: state.campaign.get('myUserRole'),
	    error: state.discussionList.get('error'),
	    loading: state.discussionList.get('loading'),
	    reloadDiscussions: state.discussionList.get('reloadDiscussions'),
	    campaign: state.campaign.get('campaign')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onLoadingDiscussions: function onLoadingDiscussions(campaignId) {
	      return dispatch((0, _actions.loadingDiscussions)(campaignId));
	    },
	    onReloadDiscussions: function onReloadDiscussions(data) {
	      return dispatch((0, _actions.reloadDiscussions)(data));
	    }
	  };
	}
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _hasRestClient2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(DiscussionList);

/***/ },
/* 2117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(195);
	
	var initialState = (0, _immutable.fromJS)({
	  campaignId: null,
	  error: null,
	  loading: false,
	  discussions: {},
	  reloadDiscussions: false
	});
	
	function discussionListReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.LOAD_DISCUSSIONS:
	      return state.set('discussions', (0, _immutable.fromJS)({})).set('error', null).set('loading', true).set('campaignId', action.campaignId);
	    case _constants.CLEAR_DISCUSSIONS:
	      return initialState;
	    case _constants.LOAD_DISCUSSIONS_SUCCESS:
	      return state.set('discussions', action.discussions).set('error', null).set('loading', false);
	    case _constants.LOAD_DISCUSSIONS_ERROR:
	      return state.set('error', action.error).set('loading', false);
	    case _constants.RELOAD_DISCUSSIONS:
	      return state.set('reloadDiscussions', true);
	    case _constants.RELOAD_DISCUSSIONS_SUCCESS:
	      return state.set('reloadDiscussions', false);
	    case _constants.SET_UNREAD_MESSAGE_COUNT:
	      return state.setIn(['discussions', action.discussionId, 'unreadMessageCount'], action.unreadMessageCount);
	    case _constants.INCREMENT_UNREAD_MESSAGE_COUNT:
	      {
	        var unreadMessageCount = state.getIn(['discussions', action.discussionId, 'unreadMessageCount']);
	        return state.setIn(['discussions', action.discussionId, 'unreadMessageCount'], unreadMessageCount++);
	      }
	    default:
	      return state;
	  }
	}
	
	exports.default = discussionListReducer;

/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.filterDiscussionsByOrganisationId = filterDiscussionsByOrganisationId;
	exports.filterDiscussionsByPermissionId = filterDiscussionsByPermissionId;
	exports.loadDiscussions = loadDiscussions;
	exports.reloadDiscussions = reloadDiscussions;
	exports.watchReloadDiscussions = watchReloadDiscussions;
	exports.watchDiscussions = watchDiscussions;
	exports.default = discussionsListSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _campaignPermissionSelectors = __webpack_require__(285);
	
	var _campaigns = __webpack_require__(129);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _helperFunctions = __webpack_require__(107);
	
	var _constants = __webpack_require__(195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadDiscussions, reloadDiscussions, watchReloadDiscussions, watchDiscussions, discussionsListSagas].map(_regenerator2.default.mark);
	
	var UNKNOWN_INFLUENCER_NAME = '[Unknown influencer]';
	
	var getOrganisationIdFromProfile = function getOrganisationIdFromProfile() {
	  // Retrieves the profile data from localStorage
	  var profile = localStorage.getItem('profile');
	  return profile ? JSON.parse(localStorage.profile).app_metadata.dyzio.o_id : null;
	};
	
	var getIsUserSuperAdminFromProfile = function getIsUserSuperAdminFromProfile() {
	  // Retrieves the profile data from localStorage
	  var profile = localStorage.getItem('profile');
	  return profile && JSON.parse(localStorage.profile).app_metadata.dyzio.isUserSuperAdmin;
	};
	
	function filterDiscussionsByOrganisationId(discussions, organisationId) {
	  // TODO Filtering discussions by organisation ID should be happening on the backend rather than the front.
	  var isUserSuperAdmin = getIsUserSuperAdminFromProfile();
	
	  var filteredDiscussions = {};
	  if (discussions) {
	    discussions.forEach(function (discussion) {
	      var orgId = organisationId || getOrganisationIdFromProfile();
	      console.log('ORG ID: ' + organisationId, orgId);
	      var userHasDiscussion = isUserSuperAdmin || _lodash2.default.find(discussion.organisations, function (discussionOrganisation) {
	        return discussionOrganisation.id === organisationId;
	      });
	      if (userHasDiscussion) {
	        filteredDiscussions[discussion.id] = discussion;
	        if (!discussion.deliverables[0]) {
	          discussion.deliverables = {};
	        } else {
	          var temp = {};
	          discussion.deliverables.forEach(function (deliverable) {
	            temp[deliverable.id] = deliverable;
	            // discussion.deliverables[deliverable.id] = deliverable;
	          });
	          discussion.deliverables = temp;
	        }
	        if (!discussion.documents[0]) {
	          discussion.documents = {};
	        } else {
	          var _temp = {};
	          discussion.documents.forEach(function (document) {
	            _temp[document.id] = document;
	          });
	          discussion.documents = _temp;
	        }
	      }
	    });
	  }
	  return filteredDiscussions;
	}
	
	function filterDiscussionsByPermissionId(discussions, filteredDiscussions, permissionId) {
	  // TODO Filtering discussions by permission ID should be happening on the backend rather than the front.
	  if (discussions) {
	    discussions.forEach(function (discussion) {
	      var userIsMember = _lodash2.default.find(discussion.members, function (discussionMember) {
	        return discussionMember.id === permissionId;
	      });
	      if (userIsMember) {
	        filteredDiscussions[discussion.id] = discussion;
	      }
	    });
	  }
	}
	
	function loadDiscussions(actions) {
	  var campaignId, discussionsJSON, campaignPermissionOrganisationId, discussionList, discussionsWithHandle;
	  return _regenerator2.default.wrap(function loadDiscussions$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          campaignId = actions.campaignId;
	          _context.next = 4;
	          return (0, _effects.call)(_campaigns.getCampaignDiscussions, campaignId);
	
	        case 4:
	          discussionsJSON = _context.sent;
	          _context.next = 7;
	          return (0, _effects.select)(_campaignPermissionSelectors.getCampaignPermissionOrganisationId, campaignId);
	
	        case 7:
	          campaignPermissionOrganisationId = _context.sent;
	          _context.next = 10;
	          return (0, _effects.call)(filterDiscussionsByOrganisationId, discussionsJSON, campaignPermissionOrganisationId);
	
	        case 10:
	          discussionList = _context.sent;
	          discussionsWithHandle = _lodash2.default.map(discussionList, function (discussion) {
	            var influencerOrganisation = _lodash2.default.find(discussion.organisations, function (organisation) {
	              return organisation.influencer !== null;
	            });
	            discussion.influencerName = _lodash2.default.get(influencerOrganisation, 'influencer.name', UNKNOWN_INFLUENCER_NAME);
	            return discussion;
	          });
	          _context.next = 14;
	          return (0, _effects.put)({ type: _constants.LOAD_DISCUSSIONS_SUCCESS, discussions: (0, _immutable.fromJS)(discussionsWithHandle) });
	
	        case 14:
	          _context.next = 22;
	          break;
	
	        case 16:
	          _context.prev = 16;
	          _context.t0 = _context['catch'](0);
	
	          console.error(_context.t0);
	          (0, _errorHandlingService.reportError)('LOAD_DISCUSSIONS_LIST_ERROR', _context.t0.message);
	          _context.next = 22;
	          return (0, _effects.put)({ type: _constants.LOAD_DISCUSSIONS_ERROR, error: _context.t0.message });
	
	        case 22:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 16]]);
	}
	
	function reloadDiscussions(actions) {
	  var campaignId;
	  return _regenerator2.default.wrap(function reloadDiscussions$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          campaignId = actions.data.campaignId;
	          _context2.next = 4;
	          return (0, _effects.call)(loadDiscussions, { campaignId: campaignId });
	
	        case 4:
	          _context2.next = 6;
	          return (0, _effects.call)(_helperFunctions.timeout, 2000);
	
	        case 6:
	          _context2.next = 8;
	          return (0, _effects.put)({ type: _constants.RELOAD_DISCUSSIONS_SUCCESS });
	
	        case 8:
	          _context2.next = 15;
	          break;
	
	        case 10:
	          _context2.prev = 10;
	          _context2.t0 = _context2['catch'](0);
	
	          (0, _errorHandlingService.reportError)('RELOAD_DISCUSSIONS_LIST_ERROR', _context2.t0.message);
	          _context2.next = 15;
	          return (0, _effects.put)({ type: _constants.LOAD_DISCUSSIONS_ERROR, error: _context2.t0.message });
	
	        case 15:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 10]]);
	}
	
	function watchReloadDiscussions() {
	  return _regenerator2.default.wrap(function watchReloadDiscussions$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.RELOAD_DISCUSSIONS, reloadDiscussions);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function watchDiscussions() {
	  return _regenerator2.default.wrap(function watchDiscussions$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.LOAD_DISCUSSIONS, loadDiscussions);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function discussionsListSagas() {
	  return _regenerator2.default.wrap(function discussionsListSagas$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(watchDiscussions), (0, _effects.fork)(watchReloadDiscussions)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 2119 */
[4184, 2120],
/* 2120 */
195,
/* 2121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _recompose = __webpack_require__(15);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactCsv = __webpack_require__(316);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _actions = __webpack_require__(2119);
	
	var _influencerGroup = __webpack_require__(1965);
	
	var _influencerGroup2 = _interopRequireDefault(_influencerGroup);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasLocalstorageClient = __webpack_require__(127);
	
	var _hasLocalstorageClient2 = _interopRequireDefault(_hasLocalstorageClient);
	
	var _helperFunctions = __webpack_require__(107);
	
	var _newInfluencerTabModal = __webpack_require__(2003);
	
	var _newInfluencerTabModal2 = _interopRequireDefault(_newInfluencerTabModal);
	
	var _campaignLiveStatus = __webpack_require__(1906);
	
	var _campaignLiveStatus2 = _interopRequireDefault(_campaignLiveStatus);
	
	var _csvUploadModal = __webpack_require__(1924);
	
	var _csvUploadModal2 = _interopRequireDefault(_csvUploadModal);
	
	var _statusModal = __webpack_require__(1926);
	
	var _statusModal2 = _interopRequireDefault(_statusModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESTRICTED_CORQ_DOMAINS = ['data.corq.studio', 'corq.dyzio.co'];
	
	var mountStart = void 0;
	
	var listStyle = {
	  paddingTop: 20,
	  padding: '0px 30px'
	};
	
	var INVITATION_STATUS = {
	  deferred: 'DEFERRED',
	  sent: 'SENT',
	  accepted: 'ACCEPTED'
	};
	
	var FILTER_TYPES = {
	  posted: 'posted',
	  not_posted: 'not_posted',
	  errors: 'errors'
	};
	
	var buttonsStyles = {
	  container: {
	    display: 'flex'
	  }
	};
	
	var DiscussionList = function (_React$Component) {
	  _inherits(DiscussionList, _React$Component);
	
	  function DiscussionList() {
	    _classCallCheck(this, DiscussionList);
	
	    var _this = _possibleConstructorReturn(this, (DiscussionList.__proto__ || Object.getPrototypeOf(DiscussionList)).call(this));
	
	    _this.componentWillMount = function () {
	      mountStart = (0, _moment2.default)();
	    };
	
	    _this.componentDidMount = function () {
	      var mountFinish = (0, _moment2.default)();
	      var diff = mountFinish.diff(mountStart);
	    };
	
	    _this.onFilterDiscussionListByTermChanged = _lodash2.default.debounce(function (event, data) {
	      var filterTerm = data.value;
	
	      _this.setState({
	        filterTerm: filterTerm
	      });
	    }, 800);
	
	    _this.onFilterTypeChanged = function (e, v) {
	      console.log('filtering to ' + v.value);
	      var filterType = _this.state.filterType;
	
	      if (filterType === v.value) {
	        e.target.blur();
	        return _this.setState({
	          filterType: null
	        });
	      }
	      return _this.setState({
	        filterType: v.value
	      });
	    };
	
	    _this.getInvitationStatus = function (_ref) {
	      var discussion = _ref.discussion;
	
	      if (!discussion.invitations) return INVITATION_STATUS.deferred;
	      var invite = discussion.invitations[0];
	      var influencerJoined = invite === undefined;
	      var derivedSent = invite ? invite.status === INVITATION_STATUS.sent : false;
	
	      if (influencerJoined) {
	        return INVITATION_STATUS.accepted;
	      }
	
	      if (derivedSent) {
	        return INVITATION_STATUS.sent;
	      }
	
	      return INVITATION_STATUS.deferred;
	    };
	
	    _this.isSearchMatch = function (_ref2) {
	      var discussion = _ref2.discussion,
	          influencer = _ref2.influencer,
	          searchTerm = _ref2.searchTerm;
	
	      if (!influencer) return true;
	      var primarySocialHandle = influencer.primarySocialHandle,
	          name = influencer.name;
	
	      var hasSearchTerm = searchTerm && _lodash2.default.size(searchTerm) > 0;
	      if (!hasSearchTerm) return true;
	      var discussionName = discussion && discussion.name ? discussion.name : '';
	
	      var term = _lodash2.default.trim(searchTerm);
	      var regEx = new RegExp(term, 'i');
	
	      var matchesByName = discussionName.match(regEx);
	      var matchesByInfluencerName = name.match(regEx);
	      var matchesByPrimaryHandle = primarySocialHandle.match(regEx);
	
	      if (hasSearchTerm && !matchesByName && !matchesByPrimaryHandle && !matchesByInfluencerName) {
	        return false;
	      }
	
	      return true;
	    };
	
	    _this.getTotalAssetCount = function (_ref3) {
	      var discussion = _ref3.discussion;
	
	      var assets = _lodash2.default.compact(discussion.trackedAssets);
	      var stories = _lodash2.default.compact(discussion.stories);
	
	      var count = _lodash2.default.get(stories, 'length', 0) + _lodash2.default.get(assets, 'length', 0);
	      return count;
	    };
	
	    _this.dismissModal = function () {
	      _this.setState({
	        isModalDismissed: true
	      });
	    };
	
	    _this.dontShowAgain = function () {
	      var dyzioStorage = _this.props.dyzioStorage;
	
	      dyzioStorage.set(dyzioStorage.KEYS.SHOW_NEW_INFLUENCER_TAB_MODAL, false);
	      _this.setState({
	        isModalDismissed: true
	      });
	    };
	
	    _this.shouldShowModal = function () {
	      var dyzioStorage = _this.props.dyzioStorage;
	
	      return false;
	      var isModalDismissed = _this.state.isModalDismissed;
	      var origin = window.location.origin;
	
	      if (!origin.match(/dyzio/)) {
	        console.log('not showing modal on ' + origin);
	        return false;
	      }
	      var storageValue = dyzioStorage.get(dyzioStorage.KEYS.SHOW_NEW_INFLUENCER_TAB_MODAL);
	      if (storageValue === false) return false;
	      if (isModalDismissed) return false;
	      return true;
	    };
	
	    _this.toggleUploadModal = function () {
	      _this.setState(function (prev) {
	        return { showUploadModal: !prev.showUploadModal };
	      });
	    };
	
	    _this.toggleUploadStatusModal = function () {
	      _this.setState(function (prev) {
	        return { showUploadStatusModal: !prev.showUploadStatusModal };
	      });
	    };
	
	    _this.buildCSVData = function (discussions) {
	      var discussionFields = ['createdDate', 'name', 'internalDiscountCode', 'bioLinkUrl', 'shortDiscountLink', 'workflowStatus', 'hasPosted'];
	
	      var influencerFields = ['instagram', 'tiktok', 'email', 'instagramId', 'instagramCount', 'tiktokId', 'tiktokCount', 'usageRightsGranted', 'discountCode'];
	
	      var flatDiscussions = _lodash2.default.map(discussions, function (d) {
	        var flat = _lodash2.default.pick(d, discussionFields);
	
	        var influencer = d.influencer;
	
	        if (!influencer) {
	          var influencerOrgs = _lodash2.default.filter(d.organisations, { orgType: 'INFLUENCER' });
	          var influencerOrg = _lodash2.default.head(influencerOrgs);
	          influencer = _lodash2.default.get(influencerOrg, 'influencer');
	        }
	
	        if (influencer) {
	          var influencerLight = _lodash2.default.pick(influencer, influencerFields);
	          _lodash2.default.assignIn(flat, influencerLight);
	        }
	
	        return flat;
	      });
	
	      return flatDiscussions;
	    };
	
	    _this.getCSVFileName = function (campaignName) {
	      return _lodash2.default.kebabCase(campaignName) + '-influencers-' + (0, _moment2.default)().utc().format() + '.csv';
	    };
	
	    _this.state = {
	      filterTerm: '',
	      filterType: null,
	      isModalDismissed: false,
	      showUploadModal: false,
	      showUploadStatusModal: false,
	      isImporting: false
	    };
	    return _this;
	  }
	
	  _createClass(DiscussionList, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          myUserRole = _props.myUserRole,
	          campaign = _props.campaign,
	          error = _props.error,
	          loading = _props.loading,
	          userInfo = _props.userInfo,
	          campaignLoading = _props.campaignLoading,
	          automationScanLoading = _props.automationScanLoading,
	          dyzioStorage = _props.dyzioStorage;
	      var _state = this.state,
	          showUploadModal = _state.showUploadModal,
	          isImporting = _state.isImporting;
	
	
	      var ADDED_EMPTY_TEXT = 'No influencers added to this campaign yet. Use the pink add influencer button above to add one!';
	      var INVITED_EMPTY_TEXT = 'No pending invitations.';
	      var JOINED_EMPTY_TEXT = 'No influencers have joined this campaign yet.';
	      var JOINED_WITH_AUTHORISED = 'No influencers are currently in the joined (but not authorised) status.';
	      var AUTHORISED_EMPTY_TEXT = 'No influencers have authorised yet.';
	
	      var LAUNCH = '4a6b0ee0-6c1a-423b-984f-49a7cb849d1e';
	      var ELEVEN_MEADOW = '2434ffc0-b36a-4b07-84ac-7ec04069c4c9';
	      var CORQ_AGENCY = 'ab31b8b8-6549-472f-87e1-b4732cfa9faf';
	      var DYZIO_ORG_ID = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';
	
	      var ALLOWED_ORGS = [LAUNCH, ELEVEN_MEADOW, CORQ_AGENCY, DYZIO_ORG_ID];
	
	      var isLaunch = _lodash2.default.includes(ALLOWED_ORGS, userInfo.organisationId);
	      var MAX_INSTA_SCAN_FAILS = 3;
	
	      var _state2 = this.state,
	          filterTerm = _state2.filterTerm,
	          filterType = _state2.filterType,
	          showUploadStatusModal = _state2.showUploadStatusModal;
	      var isUserSuperAdmin = userInfo.isUserSuperAdmin;
	      var host = window.location.host;
	
	
	      var isCorq = _lodash2.default.includes(RESTRICTED_CORQ_DOMAINS, host);
	      var isAbbottLyon = _lodash2.default.includes('collaborators.abbottlyon.com', host);
	
	      var campaignName = campaign.get('name');
	      var campaignId = campaign.get('id');
	      var isACR = campaign.get('campaignType') === 'ACR';
	
	      var campaignOwner = campaign.get('createdBy');
	      var campaignWorkflow = campaign.get('workflow');
	      var isInfluencer = userInfo.role === 'INFLUENCER';
	      var isUserTeamMember = isUserSuperAdmin || !isInfluencer;
	
	      var campaignJSON = campaign.toJSON();
	      var discussions = campaignJSON.discussions;
	
	
	      var sortedDiscussions = _lodash2.default.sortBy(discussions, 'lastScannedDate');
	      var isLoading = loading;
	
	      var noDiscussions = _lodash2.default.size(discussions) === 0;
	
	      var shouldRenderAddMoreButton = !isCorq && !isACR && isUserTeamMember;
	      var shouldShowModal = this.shouldShowModal();
	
	      var filteredDiscussions = _lodash2.default.filter(sortedDiscussions, function (discussion) {
	        var influencer = discussion.influencer || (0, _helperFunctions.getInfluencerFromOrganisations)(discussion.organisations);
	        return _this2.isSearchMatch({ discussion: discussion, influencer: influencer, searchTerm: filterTerm });
	      });
	
	      var x = _lodash2.default.groupBy(discussions, 'name');
	
	      var y = _lodash2.default.map(x, function (occurences, name) {
	        return {
	          name: name,
	          count: occurences.length
	        };
	      });
	
	      var duplicates = _lodash2.default.filter(y, function (x1) {
	        return x1.count > 1;
	      });
	      console.log({ duplicates: duplicates });
	
	      var igHandles = sortedDiscussions.map(function (discussion) {
	        var influencer = _lodash2.default.get(discussion, 'influencer') || (0, _helperFunctions.getInfluencerFromOrganisations)(_lodash2.default.get(discussion, 'organisations'));
	        return _lodash2.default.get(influencer, 'instagram');
	      }).filter(Boolean);
	
	      var existingCampaignHandles = _lodash2.default.map(igHandles, function (h) {
	        return (h || '').toLowerCase();
	      }).filter(Boolean);
	
	      var igCounts = _lodash2.default.map(discussions, function (d) {
	        return _lodash2.default.get(d, 'influencer.instagramCount', 0);
	      });
	      var meanInstagram = Math.round(_lodash2.default.mean(igCounts));
	      var totalInstagram = _lodash2.default.sum(igCounts);
	      console.log({ meanInstagram: meanInstagram, totalInstagram: totalInstagram });
	
	      var ttCounts = _lodash2.default.map(discussions, function (d) {
	        return _lodash2.default.get(d, 'influencer.tiktokCount', 0);
	      });
	      var meanTikTok = Math.round(_lodash2.default.mean(ttCounts));
	      var totalTikTok = _lodash2.default.sum(ttCounts);
	      console.log({ meanTikTok: meanTikTok, totalTikTok: totalTikTok });
	
	      var discountSent = _lodash2.default.filter(sortedDiscussions, 'internalDiscountCode');
	      var uploadContent = _lodash2.default.filter(sortedDiscussions, function (sd) {
	        return sd.workflowStatus.match(/PRODUCT_ORDERED/) || sd.workflowStatus.match(/UPLOAD_CONTENT/);
	      });
	
	      var productOrdered = _lodash2.default.filter(sortedDiscussions, 'productOrderedDate');
	
	      var totalProductOrdered = productOrdered.length;
	      var hasPosted = _lodash2.default.filter(sortedDiscussions, 'hasPosted');
	
	      if (filterType) {
	        switch (filterType) {
	          case FILTER_TYPES.posted:
	            filteredDiscussions = _lodash2.default.filter(sortedDiscussions, 'hasPosted');
	            break;
	          case FILTER_TYPES.not_posted:
	            filteredDiscussions = _lodash2.default.reject(sortedDiscussions, 'hasPosted');
	            break;
	          case FILTER_TYPES.errors:
	            filteredDiscussions = _lodash2.default.filter(sortedDiscussions, function (d) {
	              return d.instagramScanFailures > MAX_INSTA_SCAN_FAILS;
	            });
	            break;
	          default:
	            break;
	        }
	      }
	
	      var reviewMode = this.props.location.query.rm ? this.props.location.query.rm === 'true' : false;
	
	      var groupedInfluencers = _lodash2.default.groupBy(filteredDiscussions, function (discussion) {
	        var invitationStatus = _this2.getInvitationStatus({ discussion: discussion });
	        var influencer = discussion.influencer || (0, _helperFunctions.getInfluencerFromOrganisations)(discussion.organisations);
	        var authFields = ['instagramStatus', 'facebookStatus', 'youtubeStatus', 'twitterStatus'];
	        var isAuthorised = _lodash2.default.some(authFields, function (field) {
	          return _lodash2.default.get(influencer, field) === 'AUTHORIZED';
	        });
	        return isAuthorised ? 'AUTHORIZED' : invitationStatus;
	      });
	
	      var addedExists = groupedInfluencers.DEFERRED && groupedInfluencers.DEFERRED.length > 0;
	      var addedLength = groupedInfluencers.DEFERRED ? groupedInfluencers.DEFERRED.length : 0;
	
	      var sentExists = groupedInfluencers.SENT && groupedInfluencers.SENT.length > 0;
	      var sentLength = groupedInfluencers.SENT ? groupedInfluencers.SENT.length : 0;
	
	      var joinedExists = groupedInfluencers.ACCEPTED && groupedInfluencers.ACCEPTED.length > 0;
	      var joinedLength = groupedInfluencers.ACCEPTED ? groupedInfluencers.ACCEPTED.length : 0;
	
	      var authorisedExists = groupedInfluencers.AUTHORIZED && groupedInfluencers.AUTHORIZED.length > 0;
	      var authorisedLength = groupedInfluencers.AUTHORIZED ? groupedInfluencers.AUTHORIZED.length : 0;
	
	      var creationStatus = campaign.get('creationStatus');
	
	      var reviewList = _lodash2.default.reject(sortedDiscussions, 'isScanningCompleted');
	
	      var groups = [{
	        title: '1. Added [' + addedLength + ']',
	        description: 'Click on the influencer to invite them to your campaign.',
	        emptyText: ADDED_EMPTY_TEXT,
	        discussions: groupedInfluencers.DEFERRED,
	        shouldDisplay: addedExists || !(sentExists || joinedExists || authorisedExists)
	      }, {
	        title: '2. Invited [' + sentLength + ']',
	        description: 'These influencers have been invited to your campaign.',
	        emptyText: INVITED_EMPTY_TEXT,
	        discussions: groupedInfluencers.SENT,
	        shouldDisplay: sentExists || addedExists || !(joinedExists || authorisedExists)
	      }, {
	        title: '3. Joined [' + joinedLength + ']',
	        description: 'These influencers have joined your campaign but not auth\'d yet.',
	        emptyText: authorisedExists ? JOINED_WITH_AUTHORISED : JOINED_EMPTY_TEXT,
	        discussions: groupedInfluencers.ACCEPTED,
	        shouldDisplay: joinedExists || sentExists || addedExists || !authorisedExists
	      }, {
	        title: '4. Authorised [' + authorisedLength + ']',
	        description: 'These influencers have authorised the system to collect their data.',
	        emptyText: AUTHORISED_EMPTY_TEXT,
	        discussions: groupedInfluencers.AUTHORIZED,
	        shouldDisplay: true // (joinedExists || sentExists || addedExists || authorisedExists),
	      }];
	      var csvData = this.buildCSVData(sortedDiscussions);
	      var csvFileName = this.getCSVFileName(campaignName);
	      var exportHeaders = [{ label: 'createdDate', key: 'createdDate' }, { label: 'name', key: 'name' }, { label: 'internalDiscountCode', key: 'internalDiscountCode' }, { label: 'discountCode', key: 'discountCode' }, { label: 'bioLinkUrl', key: 'bioLinkUrl' }, { label: 'shortDiscountLink', key: 'shortDiscountLink' }, { label: 'workflowStatus', key: 'workflowStatus' }, { label: 'instagram', key: 'instagram' }, { label: 'instagramCount', key: 'instagramCount' }, { label: 'tiktok', key: 'tiktok' }, { label: 'tiktokCount', key: 'tiktokCount' }, { label: 'email', key: 'email' }, { label: 'instagramId', key: 'instagramId' }, { label: 'tiktokId', key: 'tiktokId' }, { label: 'usageRightsGranted', key: 'usageRightsGranted' }, { label: 'hasPosted', key: 'hasPosted' }];
	      return _react2.default.createElement(
	        'div',
	        null,
	        showUploadModal && _react2.default.createElement(_csvUploadModal2.default, {
	          onClose: this.toggleUploadModal,
	          userEmail: userInfo.email,
	          userInfo: userInfo,
	          campaignId: campaignId,
	          isSubmitting: isImporting,
	          currentInfluencerCount: discussions.length,
	          existingCampaignHandles: existingCampaignHandles
	        }),
	        showUploadStatusModal && _react2.default.createElement(_statusModal2.default, {
	          onClose: this.toggleUploadStatusModal,
	          campaignId: campaignId,
	          igHandles: igHandles
	        }),
	        !isLoading && error && _react2.default.createElement(
	          'div',
	          { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hero left' },
	            _react2.default.createElement(
	              _semanticUiReact.Message,
	              { color: 'red' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'There was a problem loading the campaign: ',
	                error,
	                '. Please check you are connected to the internet and try again.'
	              )
	            )
	          )
	        ),
	        !isUserTeamMember && noDiscussions && _react2.default.createElement(
	          'div',
	          { style: { width: 1000, margin: '50px auto' } },
	          _react2.default.createElement(_semanticUiReact.Message, {
	            icon: 'ban',
	            error: true,
	            header: 'Sorry... You do not have access to this campaign',
	            content: 'Ask the campaign owner, ' + campaignOwner + ', to invite you.'
	          })
	        ),
	        shouldShowModal && _react2.default.createElement(_newInfluencerTabModal2.default, { onClose: this.dismissModal, onDontShowAgain: this.dontShowAgain }),
	        isUserTeamMember && !isACR && _react2.default.createElement(
	          'div',
	          { style: { margin: '0px 30px' } },
	          _react2.default.createElement(_campaignLiveStatus2.default, { campaign: campaignJSON }),
	          _react2.default.createElement(
	            _semanticUiReact.Table,
	            { fluid: true, basic: 'very' },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: shouldRenderAddMoreButton ? 10 : 16 },
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  icon: 'search',
	                  size: 'large',
	                  placeholder: 'Search influencers...',
	                  onChange: this.onFilterDiscussionListByTermChanged,
	                  fluid: true
	                })
	              ),
	              shouldRenderAddMoreButton && _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { width: isLaunch ? 6 : 3 },
	                _react2.default.createElement(
	                  'div',
	                  { style: buttonsStyles.container },
	                  _react2.default.createElement(
	                    _semanticUiReact.Button,
	                    {
	                      icon: true,
	                      inverted: true,
	                      fluid: !isLaunch,
	                      labelPosition: 'left',
	                      color: 'pink',
	                      onClick: function onClick() {
	                        return _this2.context.router.push('/campaign/' + campaignId + '/invite');
	                      }
	                    },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' }),
	                    'Add Influencer'
	                  ),
	                  isLaunch && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Button,
	                      {
	                        icon: true,
	                        inverted: true,
	                        labelPosition: 'left',
	                        color: 'pink',
	                        onClick: this.toggleUploadModal
	                      },
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'upload' }),
	                      'Upload CSV'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Button,
	                      {
	                        icon: true,
	                        inverted: true,
	                        disabled: _lodash2.default.isEmpty(igHandles),
	                        labelPosition: 'left',
	                        color: 'pink',
	                        onClick: this.toggleUploadStatusModal
	                      },
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel' }),
	                      'Status'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        !isLoading && campaign && _react2.default.createElement(
	          'div',
	          { style: listStyle },
	          creationStatus === 'CREATING' && _react2.default.createElement(
	            _semanticUiReact.Message,
	            { color: 'orange', size: 'large', icon: true },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle notched', loading: true }),
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Your campaign is currently being created!'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\xA0\xA0This message will disappear when it has completed. Refresh your page to update.'
	            )
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            'table',
	            { width: '100%' },
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    toggle: true,
	                    active: filterType === FILTER_TYPES.posted,
	                    onClick: this.onFilterTypeChanged,
	                    value: FILTER_TYPES.posted,
	                    icon: true, labelPosition: 'left', inverted: true, color: 'blue'
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'check', color: 'green' }),
	                  'Posted'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    toggle: true,
	                    active: filterType === FILTER_TYPES.not_posted,
	                    onClick: this.onFilterTypeChanged,
	                    value: FILTER_TYPES.not_posted,
	                    icon: true, labelPosition: 'left', inverted: true, color: 'blue'
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'orange' }),
	                  'NOT Posted'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    toggle: true,
	                    active: filterType === FILTER_TYPES.errors,
	                    onClick: this.onFilterTypeChanged,
	                    value: FILTER_TYPES.errors,
	                    icon: true, labelPosition: 'left', inverted: true, color: 'blue'
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'exclamation circle', color: 'red' }),
	                  'Errors'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  null,
	                  'Use these buttons to filter the influencers. Click again to remove filter.'
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                { width: '200', style: { textAlign: 'right' } },
	                _react2.default.createElement(
	                  _reactCsv.CSVLink,
	                  {
	                    filename: csvFileName,
	                    headers: exportHeaders,
	                    data: csvData
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'cloud download', color: 'green' }),
	                  'export',
	                  _react2.default.createElement('br', null),
	                  'influencer list'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('p', null),
	          isAbbottLyon && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                null,
	                _react2.default.createElement(
	                  'table',
	                  { width: '100%' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'average instagram followers:'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      (0, _numeral2.default)(meanInstagram).format('0,0')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'total instagram followers:'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      (0, _numeral2.default)(totalInstagram).format('0,0')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'average tiktok followers:'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      (0, _numeral2.default)(meanTikTok).format('0,0')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'total tiktok followers:'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      (0, _numeral2.default)(totalTikTok).format('0,0')
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          campaignWorkflow && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Label,
	              { basic: true },
	              'DISCOUNT SENT ',
	              discountSent.length
	            ),
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'arrow circle right outline', size: 'large' }),
	            _react2.default.createElement(
	              _semanticUiReact.Label,
	              { basic: true, color: 'green' },
	              'PRODUCT ORDERED - ',
	              totalProductOrdered
	            ),
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'arrow circle right outline', size: 'large' }),
	            _react2.default.createElement(
	              _semanticUiReact.Label,
	              { basic: true, color: 'blue' },
	              'WAITING FOR CONTENT - ',
	              uploadContent.length
	            ),
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'arrow circle right outline', size: 'large' }),
	            _react2.default.createElement(
	              _semanticUiReact.Label,
	              { basic: true, color: 'pink' },
	              'CONTENT FOUND - ',
	              hasPosted.length
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, null)
	          ),
	          reviewMode && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'table',
	              { width: '100%' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  { width: '90%' },
	                  _react2.default.createElement(_semanticUiReact.Message, {
	                    color: 'teal',
	                    icon: 'warning',
	                    header: 'REVIEW MODE',
	                    content: 'The list is only displaying creators who have not been rolled forward'
	                  })
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { width: '10%', style: { textAlign: 'center' } },
	                  _react2.default.createElement(
	                    'p',
	                    { style: { fontSize: '80%' } },
	                    'remaining'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Label,
	                    { circular: true, basic: true, color: 'teal', size: 'massive' },
	                    reviewList.length
	                  )
	                )
	              )
	            ),
	            '\xA0'
	          ),
	          !_lodash2.default.isEmpty(duplicates) && _react2.default.createElement(
	            _semanticUiReact.Segment,
	            null,
	            _lodash2.default.map(duplicates, function (d) {
	              return _react2.default.createElement(
	                _semanticUiReact.Message,
	                { negative: true, icon: true },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'clone outline' }),
	                _react2.default.createElement(
	                  _semanticUiReact.MessageContent,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.MessageHeader,
	                    null,
	                    'Duplicate collaborations found'
	                  ),
	                  'There are ',
	                  d.count,
	                  ' collaborations named ',
	                  d.name,
	                  '. Please delete the duplicate(s).'
	                )
	              );
	            })
	          ),
	          _lodash2.default.map(groups, function (_ref4) {
	            var title = _ref4.title,
	                description = _ref4.description,
	                emptyText = _ref4.emptyText,
	                disc = _ref4.discussions,
	                shouldDisplay = _ref4.shouldDisplay;
	
	            if (shouldDisplay) {
	              return _react2.default.createElement(_influencerGroup2.default, {
	                title: title,
	                campaign: campaign,
	                description: description,
	                emptyText: emptyText,
	                discussions: disc,
	                getInvitationStatus: _this2.getInvitationStatus,
	                isSearchMatch: _this2.isSearchMatch,
	                reviewMode: reviewMode
	              });
	            }
	            return null;
	          })
	        )
	      );
	    }
	  }]);
	
	  return DiscussionList;
	}(_react2.default.Component);
	
	DiscussionList.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    discussions: state.discussionList.get('discussions'),
	    myUserRole: state.campaign.get('myUserRole'),
	    error: state.discussionList.get('error'),
	    loading: state.discussionList.get('loading'),
	    reloadDiscussions: state.discussionList.get('reloadDiscussions'),
	    campaign: state.campaign.get('campaign')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onLoadingDiscussions: function onLoadingDiscussions(campaignId) {
	      return dispatch((0, _actions.loadingDiscussions)(campaignId));
	    },
	    onReloadDiscussions: function onReloadDiscussions(data) {
	      return dispatch((0, _actions.reloadDiscussions)(data));
	    }
	  };
	}
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _hasRestClient2.default, _hasLocalstorageClient2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(DiscussionList);

/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.approveDocument = approveDocument;
	exports.unapproveDocument = unapproveDocument;
	exports.updateDeliverableApproved = updateDeliverableApproved;
	exports.loadDiscussion = loadDiscussion;
	exports.sendMessage = sendMessage;
	exports.deleteMessage = deleteMessage;
	exports.receiveMessage = receiveMessage;
	exports.updateDocuments = updateDocuments;
	exports.updateBudget = updateBudget;
	exports.loadMoreMessages = loadMoreMessages;
	exports.clearDiscussion = clearDiscussion;
	
	var _constants = __webpack_require__(142);
	
	function approveDocument(documentId, approvedData) {
	  return {
	    type: _constants.APPROVE_DOCUMENT,
	    documentId: documentId,
	    approvedData: approvedData
	  };
	}
	
	function unapproveDocument(documentId, docType) {
	  return {
	    type: _constants.UNAPPROVE_DOCUMENT,
	    documentId: documentId,
	    docType: docType
	  };
	}
	
	function updateDeliverableApproved(data) {
	  return {
	    type: _constants.UPDATE_DELIVERABLE_APPROVED,
	    data: data
	  };
	}
	
	function loadDiscussion(discussionId, receiveMessageCallback) {
	  return {
	    type: _constants.LOAD_DISCUSSION,
	    discussionId: discussionId,
	    receiveMessageCallback: receiveMessageCallback
	  };
	}
	
	function sendMessage(data) {
	  return {
	    type: _constants.SEND_MESSAGE,
	    data: data
	  };
	}
	
	function deleteMessage(messageId) {
	  return {
	    type: _constants.DELETE_MESSAGE,
	    messageId: messageId
	  };
	}
	
	function receiveMessage(message) {
	  return {
	    type: _constants.RECEIVE_MESSAGE,
	    message: message
	  };
	}
	
	function updateDocuments(documentData) {
	  return {
	    type: _constants.NEW_DOCUMENT,
	    documentData: documentData
	  };
	}
	
	function updateBudget(budget, status) {
	  return {
	    type: _constants.UPDATE_BUDGET,
	    budget: budget,
	    status: status
	  };
	}
	
	function loadMoreMessages() {
	  return {
	    type: _constants.LOAD_MORE_MESSAGES
	  };
	}
	
	function clearDiscussion() {
	  return {
	    type: _constants.CLEAR_DISCUSSION
	  };
	}

/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(142);
	
	var initialState = (0, _immutable.fromJS)({
	  discussionId: null,
	  discussionType: null,
	  name: null,
	  organisations: null,
	  loading: false,
	  error: null,
	  messages: [],
	  documents: {},
	  deliverables: {},
	  currentBrief: null,
	  currentContract: null,
	  signedContract: null,
	  docsStatus: {},
	  deliverablesStatus: {},
	  messagesLoading: false,
	  trackedAssets: {},
	  updatingDeliverableApprovalLoading: false,
	  updatingDeliverableApprovalError: null
	});
	
	function discussionsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.LOAD_DISCUSSION:
	      return state.set('loading', true).set('error', null);
	    case _constants.LOAD_DISCUSSION_ERROR:
	      return state.set('loading', false).set('error', action.error);
	    case _constants.LOAD_DISCUSSION_SUCCESS:
	      return state.set('loading', false).set('error', null);
	    case _constants.LOAD_SENDBIRD_MESSAGES:
	      return state.set('messages', action.messages.concat(state.get('messages'))).set('loading', false).set('loadChannelError', false).set('messagesLoading', false);
	    case _constants.LOAD_MORE_MESSAGES:
	      return state.set('messagesLoading', true);
	    case _constants.UPDATE_MESSAGES:
	      return state.set('messages', state.get('messages').concat(action.message));
	    case _constants.UPDATE_DOCUMENTS:
	      return state.set('documents', state.get('documents').set(action.documentData.get('id'), action.documentData));
	    case _constants.REMOVE_DOCUMENT:
	      return state.setIn(['documents', action.documentId, 'removed'], true).setIn(['documents', action.documentId, 'filePath'], 'removed').setIn(['documents', action.documentId, 'approved'], false);
	    case _constants.UPDATE_DELIVERABLE_APPROVED:
	      return state.set('updatingDeliverableApprovalError', null).set('updatingDeliverableApprovalLoading', true);
	    case _constants.UPDATE_DELIVERABLE_APPROVED_SUCCESS:
	      return state.set('updatingDeliverableApprovalLoading', false);
	    case _constants.UPDATE_DELIVERABLE_APPROVED_ERROR:
	      return state.set('updatingDeliverableApprovalLoading', false).set('updatingDeliverableApprovalError', action.error);
	    case _constants.UPDATE_DELIVERABLES:
	      return state.setIn(['deliverables', action.deliverableData.get('id')], action.deliverableData);
	    case _constants.UPDATE_DELIVERABLE_IS_LIVE:
	      return state.setIn(['deliverables', action.deliverableId, 'live'], action.live);
	    case _constants.UPDATE_BUDGET_SUCCESS:
	      return state.set('budget', action.budget).set('budgetStatus', action.status);
	    case _constants.UPDATE_BUDGET_ERROR:
	      return state.set('budgetError', action.error);
	    case _constants.UPDATE_DELIVERABLE_DOCUMENT:
	      return state.setIn(['deliverables', action.deliverableId, 'document'], action.documentData).setIn(['deliverables', action.deliverableId, 'documents', action.documentData.get('version')], action.documentData).setIn(['deliverables', action.deliverableId, 'mostRecentDocument'], action.documentData);
	    case _constants.UPDATE_CURRENT_BRIEF:
	      return state.set('currentBrief', action.currentBrief);
	    case _constants.UPDATE_CURRENT_CONTRACT:
	      return state.set('currentContract', action.currentContract);
	    case _constants.UPDATE_SIGNED_CONTRACT:
	      return state.set('signedContract', action.signedContract);
	    case _constants.SET_DISCUSSION:
	      return state.set('discussionId', action.discussionId).set('name', action.name).set('documents', action.documents).set('organisations', action.organisations).set('deliverables', action.deliverables).set('currentBrief', action.currentBrief).set('currentContract', action.currentContract).set('signedContract', action.signedContract).set('docsStatus', action.docsStatus).set('deliverablesStatus', action.deliverablesStatus).set('trackedAssets', action.trackedAssets).set('budget', action.budget).set('budgetStatus', action.budgetStatus).set('organisations', action.organisations);
	    case _constants.CLEAR_DISCUSSION:
	      return initialState;
	    case _constants.SET_DISCUSSION_TYPE:
	      return state.set('discussionType', action.discussionType);
	    case _constants.UPDATE_TRACKED_ASSETS:
	      return state.setIn(['trackedAssets', action.trackedAsset.get('assetId')], action.trackedAsset);
	    default:
	      return state;
	  }
	}
	
	exports.default = discussionsReducer;

/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.sendNewSendbirdMessage = sendNewSendbirdMessage;
	exports.loadMoreMessages = loadMoreMessages;
	exports.loadDiscussion = loadDiscussion;
	exports.loadSendbirdMessages = loadSendbirdMessages;
	exports.markMessagesAsRead = markMessagesAsRead;
	exports.addMessageReceivedChannelHandler = addMessageReceivedChannelHandler;
	exports.loadSendbirdData = loadSendbirdData;
	exports.formatDiscussionData = formatDiscussionData;
	exports.updateDocuments = updateDocuments;
	exports.updateBudget = updateBudget;
	exports.approveDocument = approveDocument;
	exports.unapproveDocument = unapproveDocument;
	exports.updateDeliverableApprovedStatus = updateDeliverableApprovedStatus;
	exports.receiveMessage = receiveMessage;
	exports.watchLoadMoreMessages = watchLoadMoreMessages;
	exports.watchSendbirdMessages = watchSendbirdMessages;
	exports.watchRecieveMessages = watchRecieveMessages;
	exports.watchLoadDiscussion = watchLoadDiscussion;
	exports.watchUpdateDocument = watchUpdateDocument;
	exports.watchUpdateBudget = watchUpdateBudget;
	exports.watchApproveDocument = watchApproveDocument;
	exports.watchUnapproveDocument = watchUnapproveDocument;
	exports.watchUpdateDeliverableApproved = watchUpdateDeliverableApproved;
	exports.default = discussionsSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _assetUrlHelperService = __webpack_require__(362);
	
	var _userSelectors = __webpack_require__(118);
	
	var _discussionSelectors = __webpack_require__(361);
	
	var _discussionListSelectors = __webpack_require__(2262);
	
	var _campaignSelectors = __webpack_require__(117);
	
	var _campaignPermissionSelectors = __webpack_require__(285);
	
	var _sendbirdService = __webpack_require__(366);
	
	var _documents = __webpack_require__(364);
	
	var _discussions = __webpack_require__(172);
	
	var _deliverables = __webpack_require__(288);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _notificationsService = __webpack_require__(2389);
	
	var _authToken = __webpack_require__(926);
	
	var _sendbirdSelectors = __webpack_require__(927);
	
	var _sendbird = __webpack_require__(2257);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _metricAnalyticsService = __webpack_require__(119);
	
	var _constants = __webpack_require__(283);
	
	var _constants2 = __webpack_require__(280);
	
	var _constants3 = __webpack_require__(195);
	
	var _sendbird2 = __webpack_require__(354);
	
	var _constants4 = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [sendNewSendbirdMessage, loadMoreMessages, loadDiscussion, loadSendbirdMessages, markMessagesAsRead, loadSendbirdData, formatDiscussionData, updateDocuments, updateBudget, approveDocument, unapproveDocument, updateDeliverableApprovedStatus, receiveMessage, watchLoadMoreMessages, watchSendbirdMessages, watchRecieveMessages, watchLoadDiscussion, watchUpdateDocument, watchUpdateBudget, watchApproveDocument, watchUnapproveDocument, watchUpdateDeliverableApproved, discussionsSagas].map(_regenerator2.default.mark);
	
	var Scroll = __webpack_require__(327);
	
	var scroll = Scroll.animateScroll;
	
	function sendNewSendbirdMessage(action) {
	  var channel, _action$data, message, metaData, page, messageResponse, campaignId, discussionName, sendMessageData;
	
	  return _regenerator2.default.wrap(function sendNewSendbirdMessage$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(_sendbird.checkSendbirdUserIsSetup);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.select)(_sendbirdSelectors.getSendbirdChannel);
	
	        case 4:
	          channel = _context.sent;
	
	          if (channel) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 8;
	          return (0, _effects.call)(_sendbird.loadSendbirdChannel);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.take)(_sendbird2.LOAD_SENDBIRD_CHANNEL_SUCCESS);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.select)(_sendbirdSelectors.getSendbirdChannel);
	
	        case 12:
	          channel = _context.sent;
	
	        case 13:
	          _action$data = action.data, message = _action$data.message, metaData = _action$data.metaData, page = _action$data.page;
	          _context.prev = 14;
	
	          if (!channel) {
	            _context.next = 31;
	            break;
	          }
	
	          _context.next = 18;
	          return (0, _effects.call)(_sendbirdService.sendBirdService.sendSendbirdMessage, channel, message, metaData);
	
	        case 18:
	          messageResponse = _context.sent;
	          _context.next = 21;
	          return (0, _effects.put)({ type: _constants4.UPDATE_MESSAGES, message: (0, _immutable.fromJS)([messageResponse]) });
	
	        case 21:
	          if (!(metaData.messageType === 'message')) {
	            _context.next = 30;
	            break;
	          }
	
	          _context.next = 24;
	          return (0, _effects.select)(_campaignSelectors.getCampaignId);
	
	        case 24:
	          campaignId = _context.sent;
	          _context.next = 27;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionName);
	
	        case 27:
	          discussionName = _context.sent;
	          sendMessageData = {
	            campaignId: campaignId,
	            collaborationId: metaData.discussionId,
	            collaborationName: discussionName
	          };
	
	          (0, _metricAnalyticsService.trackEvent)('Send Message', sendMessageData);
	
	        case 30:
	
	          if (page === _staticConfiguration.DISCUSSION_PAGE) scroll.scrollToBottom({ duration: 0 });
	
	        case 31:
	          _context.next = 36;
	          break;
	
	        case 33:
	          _context.prev = 33;
	          _context.t0 = _context['catch'](14);
	
	          (0, _errorHandlingService.reportError)('SEND_SENDBIRD_MESSAGE_ERROR', _context.t0.message);
	
	        case 36:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[14, 33]]);
	}
	
	function loadMoreMessages() {
	  var channel, messageListQuery, messages;
	  return _regenerator2.default.wrap(function loadMoreMessages$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_sendbirdSelectors.getSendbirdChannel);
	
	        case 2:
	          channel = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.select)(_discussionSelectors.getMessageListQuery);
	
	        case 5:
	          messageListQuery = _context2.sent;
	
	          if (!(channel && messageListQuery)) {
	            _context2.next = 12;
	            break;
	          }
	
	          _context2.next = 9;
	          return (0, _effects.call)(_sendbirdService.sendBirdService.loadSendbirdMessages, messageListQuery, channel);
	
	        case 9:
	          messages = _context2.sent;
	          _context2.next = 12;
	          return (0, _effects.put)({ type: _constants4.LOAD_SENDBIRD_MESSAGES, messages: (0, _immutable.fromJS)(messages) });
	
	        case 12:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function getBriefStatus(isBriefActive, isBriefApproved) {
	  if (!isBriefActive && !isBriefApproved) return 'incomplete';
	  if (isBriefActive && !isBriefApproved) return 'pending';
	  if (isBriefActive && isBriefApproved) return 'complete';
	}
	
	function getContractStatus(isContractActive, isSignedContractActive) {
	  if (!isContractActive) return 'incomplete';
	  if (isContractActive && !isSignedContractActive) return 'pending';
	  if (isContractActive && isSignedContractActive) return 'complete';
	}
	
	function getDeliverableStatus(first, second, third) {
	  var status = 'incomplete';
	  if (first < second) status = 'pending';
	  if (first === second) status = 'complete';
	  if (third) {
	    if (first === second && first !== third) status = 'pending';
	  }
	  return status;
	}
	
	function getDeliverablesInfo(deliverables) {
	  var deliverablesStatus = {};
	  if (deliverables.size === 0) return deliverablesStatus;
	
	  var setDeliverables = 0;
	  var addedDeliverables = 0;
	  var approvedDeliverables = 0;
	  var liveDeliverables = 0;
	
	  deliverables.forEach(function (deliverable) {
	    setDeliverables++;
	    if (deliverable.get('document')) {
	      addedDeliverables++;
	      if (deliverable.getIn(['document', 'approved'])) approvedDeliverables++;
	    }
	    if (deliverable.get('live')) liveDeliverables++;
	  });
	  deliverablesStatus.set = setDeliverables;
	  deliverablesStatus.added = addedDeliverables;
	  deliverablesStatus.approved = approvedDeliverables;
	  deliverablesStatus.live = liveDeliverables;
	  deliverablesStatus.setStatus = getDeliverableStatus(liveDeliverables, setDeliverables);
	  deliverablesStatus.addedStatus = getDeliverableStatus(addedDeliverables, setDeliverables);
	  deliverablesStatus.approvedStatus = getDeliverableStatus(approvedDeliverables, addedDeliverables, setDeliverables);
	  deliverablesStatus.liveStatus = getDeliverableStatus(liveDeliverables, approvedDeliverables);
	
	  return deliverablesStatus;
	}
	
	function loadDiscussion(action) {
	  var discussionId, receiveMessageCallback, discussion, channelURL, viewCollaborationData;
	  return _regenerator2.default.wrap(function loadDiscussion$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.call)(_authToken.loadAuthToken);
	
	        case 2:
	          discussionId = action.discussionId;
	          receiveMessageCallback = action.receiveMessageCallback;
	          _context3.prev = 4;
	          _context3.next = 7;
	          return (0, _effects.call)(_discussions.getDiscussion, discussionId);
	
	        case 7:
	          discussion = _context3.sent;
	          channelURL = discussion.channelURL;
	          _context3.next = 11;
	          return (0, _effects.put)({ type: _sendbird2.SET_SENDBIRD_CHANNEL_URL, sendbirdChannelURL: channelURL });
	
	        case 11:
	          viewCollaborationData = {
	            campaignId: discussion.campaign.id,
	            collaborationId: discussionId,
	            collaborationName: discussion.name
	          };
	
	          (0, _metricAnalyticsService.trackEvent)('View Collaboration', viewCollaborationData);
	
	          // Effects will get executed in parallel
	          _context3.next = 15;
	          return [(0, _effects.call)(loadSendbirdData, discussionId, channelURL, receiveMessageCallback), (0, _effects.call)(formatDiscussionData, discussion)];
	
	        case 15:
	          _context3.next = 17;
	          return (0, _effects.put)({ type: _constants4.LOAD_DISCUSSION_SUCCESS });
	
	        case 17:
	          _context3.next = 24;
	          break;
	
	        case 19:
	          _context3.prev = 19;
	          _context3.t0 = _context3['catch'](4);
	
	          (0, _errorHandlingService.reportError)('LOAD_DISCUSSION_DATA_ERROR', _context3.t0.message);
	          _context3.next = 24;
	          return (0, _effects.put)({ type: _constants4.LOAD_DISCUSSION_ERROR, error: _context3.t0.message });
	
	        case 24:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this, [[4, 19]]);
	}
	
	function loadSendbirdMessages() {
	  var isSendbirdChannelLoading, channel, messageListQuery, messages;
	  return _regenerator2.default.wrap(function loadSendbirdMessages$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.prev = 0;
	          _context4.next = 3;
	          return (0, _effects.call)(_sendbird.loadSendbirdChannel);
	
	        case 3:
	          _context4.next = 5;
	          return (0, _effects.select)(_sendbirdSelectors.getSendbirdChannelLoading);
	
	        case 5:
	          isSendbirdChannelLoading = _context4.sent;
	
	          if (!isSendbirdChannelLoading) {
	            _context4.next = 9;
	            break;
	          }
	
	          _context4.next = 9;
	          return (0, _effects.take)(_sendbird2.LOAD_SENDBIRD_CHANNEL_SUCCESS);
	
	        case 9:
	          _context4.next = 11;
	          return (0, _effects.select)(_sendbirdSelectors.getSendbirdChannel);
	
	        case 11:
	          channel = _context4.sent;
	          messageListQuery = channel.createPreviousMessageListQuery();
	          _context4.next = 15;
	          return (0, _effects.put)({ type: _sendbird2.SET_MESSAGE_LIST_QUERY, messageListQuery: messageListQuery });
	
	        case 15:
	          _context4.next = 17;
	          return (0, _effects.call)(_sendbirdService.sendBirdService.loadSendbirdMessages, messageListQuery, channel);
	
	        case 17:
	          messages = _context4.sent;
	          _context4.next = 20;
	          return (0, _effects.put)({ type: _constants4.LOAD_SENDBIRD_MESSAGES, messages: (0, _immutable.fromJS)(messages) });
	
	        case 20:
	
	          scroll.scrollToBottom({ duration: 0 });
	          _context4.next = 28;
	          break;
	
	        case 23:
	          _context4.prev = 23;
	          _context4.t0 = _context4['catch'](0);
	
	          (0, _errorHandlingService.reportError)('LOAD_SENDBIRD_MESSAGES_ERROR', _context4.t0.message);
	          _context4.next = 28;
	          return (0, _effects.put)({ type: _constants4.LOAD_DISCUSSION_ERROR, error: _context4.t0.message });
	
	        case 28:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this, [[0, 23]]);
	}
	
	function markMessagesAsRead(discussionId, channelURL, userId) {
	  var options, discussionLoaded;
	  return _regenerator2.default.wrap(function markMessagesAsRead$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.prev = 0;
	          options = {
	            sendbirdApiToken: ("76d121b106a181d02ec5d1cb059bbd2d76e383f2"),
	            channelURL: channelURL,
	            userId: userId
	          };
	          _context5.next = 4;
	          return (0, _effects.select)(_discussionListSelectors.getDiscussionIsLoaded, discussionId);
	
	        case 4:
	          discussionLoaded = _context5.sent;
	
	          if (!discussionLoaded) {
	            _context5.next = 8;
	            break;
	          }
	
	          _context5.next = 8;
	          return (0, _effects.put)({
	            type: _constants3.SET_UNREAD_MESSAGE_COUNT,
	            discussionId: discussionId,
	            unreadMessageCount: 0
	          });
	
	        case 8:
	          _context5.next = 15;
	          break;
	
	        case 10:
	          _context5.prev = 10;
	          _context5.t0 = _context5['catch'](0);
	
	          (0, _errorHandlingService.reportError)('MARK_MESSAGE_AS_READ_ERROR', _context5.t0.message);
	          _context5.next = 15;
	          return (0, _effects.put)({ type: _constants4.LOAD_DISCUSSION_ERROR, error: _context5.t0.message });
	
	        case 15:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this, [[0, 10]]);
	}
	
	function addMessageReceivedChannelHandler(discussionId, receiveMessageCallback) {
	  var sendBird = _sendbirdService.sendBirdService.getSendbirdService();
	  var ChannelHandler = new sendBird.ChannelHandler();
	
	  ChannelHandler.onMessageReceived = function (channel, message) {
	    receiveMessageCallback(message);
	    scroll.scrollToBottom({ duration: 0 });
	  };
	
	  sendBird.addChannelHandler(discussionId, ChannelHandler);
	}
	
	function loadSendbirdData(discussionId, channelURL, receiveMessageCallback) {
	  var userId;
	  return _regenerator2.default.wrap(function loadSendbirdData$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.prev = 0;
	          _context6.next = 3;
	          return (0, _effects.call)(_sendbird.checkSendbirdUserIsSetup);
	
	        case 3:
	          _context6.next = 5;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 5:
	          userId = _context6.sent;
	          _context6.next = 8;
	          return [(0, _effects.call)(loadSendbirdMessages, channelURL), (0, _effects.call)(markMessagesAsRead, discussionId, channelURL, userId), (0, _effects.call)(addMessageReceivedChannelHandler, discussionId, receiveMessageCallback)];
	
	        case 8:
	          _context6.next = 15;
	          break;
	
	        case 10:
	          _context6.prev = 10;
	          _context6.t0 = _context6['catch'](0);
	
	          (0, _errorHandlingService.reportError)('LOAD_SENDBIRD_DATA_ERROR', _context6.t0.message);
	          _context6.next = 15;
	          return (0, _effects.put)({ type: _constants4.LOAD_DISCUSSION_ERROR, error: _context6.t0.message });
	
	        case 15:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this, [[0, 10]]);
	}
	
	function formatDiscussionData(discussion) {
	  var discussionId, name, campaignId, channelURL, currentBrief, currentContract, signedContract, trackedAssets, budget, budgetStatus, discussionType, documents, immutableDocuments, deliverables, immutableDeliverables, organisations, immutableOrganisations, currentCampaignId, teamDiscussionId, clientDiscussionId, partnerAgencyDiscussionId, isBriefActive, isBriefApproved, isContractActive, isSignedContractActive, docsStatus, deliverablesStatus, trackedAssetsList, immutableTrackedAssets;
	  return _regenerator2.default.wrap(function formatDiscussionData$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.prev = 0;
	          discussionId = discussion.id;
	          name = discussion.name;
	          campaignId = discussion.campaign ? discussion.campaign.id : null;
	          channelURL = discussion.channelURL;
	          currentBrief = discussion.currentBrief;
	          currentContract = discussion.currentContract;
	          signedContract = discussion.signedContract;
	          trackedAssets = discussion.trackedAssets;
	          budget = discussion.budget;
	          budgetStatus = discussion.budgetStatus;
	          discussionType = discussion.discussionType;
	          documents = {};
	
	          discussion.documents.forEach(function (documentFile) {
	            if (!documentFile) return;
	            documents[documentFile.id] = documentFile;
	          });
	          immutableDocuments = (0, _immutable.fromJS)(documents);
	          deliverables = {};
	
	          discussion.deliverables.forEach(function (deliverable) {
	            if (!deliverable) return;
	            deliverables[deliverable.id] = deliverable;
	            var deliverableDocuments = {};
	            var highestVersionDocument = null;
	            var currentHighestVersion = 0;
	            if (deliverable.documents && deliverable.documents[0]) {
	              deliverable.documents.forEach(function (document) {
	                deliverableDocuments[document.version] = document;
	                if (document.version > currentHighestVersion) {
	                  highestVersionDocument = document;
	                  currentHighestVersion = document.version;
	                }
	              });
	            }
	            deliverable.documents = deliverableDocuments;
	            deliverable.mostRecentDocument = highestVersionDocument || deliverable.document;
	          });
	          immutableDeliverables = (0, _immutable.fromJS)(deliverables);
	          organisations = {};
	
	          discussion.organisations.forEach(function (organisation) {
	            if (!organisation) return;
	            organisations[organisation.id] = organisation;
	          });
	          immutableOrganisations = (0, _immutable.fromJS)(organisations);
	          _context7.next = 23;
	          return (0, _effects.select)(_campaignSelectors.getCampaignId);
	
	        case 23:
	          currentCampaignId = _context7.sent;
	
	          if (!(campaignId && campaignId !== currentCampaignId)) {
	            _context7.next = 29;
	            break;
	          }
	
	          _context7.next = 27;
	          return (0, _effects.put)({ type: _constants2.LOAD_CAMPAIGN, campaignId: campaignId });
	
	        case 27:
	          _context7.next = 29;
	          return (0, _effects.take)(_constants2.LOAD_CAMPAIGN_SUCCESS);
	
	        case 29:
	          _context7.next = 31;
	          return (0, _effects.select)(_campaignSelectors.getTeamDiscussionId);
	
	        case 31:
	          teamDiscussionId = _context7.sent;
	          _context7.next = 34;
	          return (0, _effects.select)(_campaignSelectors.getClientDiscussionId);
	
	        case 34:
	          clientDiscussionId = _context7.sent;
	          _context7.next = 37;
	          return (0, _effects.select)(_campaignSelectors.getPartnerAgencyDiscussionId);
	
	        case 37:
	          partnerAgencyDiscussionId = _context7.sent;
	
	          if (!(discussionId === teamDiscussionId || discussionId === clientDiscussionId || discussionId === partnerAgencyDiscussionId)) {
	            _context7.next = 43;
	            break;
	          }
	
	          _context7.next = 41;
	          return (0, _effects.put)({ type: _constants4.SET_DISCUSSION_TYPE, discussionType: 'chat' });
	
	        case 41:
	          _context7.next = 45;
	          break;
	
	        case 43:
	          _context7.next = 45;
	          return (0, _effects.put)({ type: _constants4.SET_DISCUSSION_TYPE, discussionType: 'collaboration' });
	
	        case 45:
	
	          // Work out documents status
	          isBriefActive = !!(currentBrief && !currentBrief.removed);
	          isBriefApproved = !!(currentBrief && currentBrief.approved);
	          isContractActive = !!(currentContract && !currentContract.removed);
	          isSignedContractActive = !!(signedContract && !signedContract.removed);
	          docsStatus = {
	            brief: getBriefStatus(isBriefActive, isBriefApproved),
	            contract: getContractStatus(isContractActive, isSignedContractActive)
	          };
	          deliverablesStatus = getDeliverablesInfo(immutableDeliverables);
	          trackedAssetsList = {};
	
	          trackedAssets && trackedAssets.forEach(function (trackedAsset) {
	            if (!trackedAsset) return;
	            trackedAssetsList[trackedAsset.assetId] = trackedAsset;
	          });
	          immutableTrackedAssets = trackedAssets && trackedAssets[0] ? (0, _immutable.fromJS)(trackedAssetsList) : (0, _immutable.fromJS)({});
	          _context7.next = 56;
	          return (0, _effects.put)({
	            type: _constants4.SET_DISCUSSION,
	            documents: immutableDocuments,
	            deliverables: immutableDeliverables,
	            discussionId: discussionId,
	            name: name,
	            organisations: immutableOrganisations,
	            currentBrief: currentBrief,
	            currentContract: currentContract,
	            signedContract: signedContract,
	            docsStatus: docsStatus,
	            deliverablesStatus: deliverablesStatus,
	            trackedAssets: immutableTrackedAssets,
	            budget: budget,
	            budgetStatus: budgetStatus,
	            discussionType: discussionType
	          });
	
	        case 56:
	          _context7.next = 63;
	          break;
	
	        case 58:
	          _context7.prev = 58;
	          _context7.t0 = _context7['catch'](0);
	
	          (0, _errorHandlingService.reportError)('FORMAT_DISCUSSION_DATA_ERROR', _context7.t0.message);
	          _context7.next = 63;
	          return (0, _effects.put)({ type: _constants4.LOAD_DISCUSSION_ERROR, error: _context7.t0.message });
	
	        case 63:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this, [[0, 58]]);
	}
	
	function updateDocuments(action) {
	  var documentData;
	  return _regenerator2.default.wrap(function updateDocuments$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          documentData = action.documentData;
	          _context8.next = 3;
	          return (0, _effects.put)({ type: _constants4.UPDATE_DOCUMENTS, documentData: (0, _immutable.fromJS)(documentData) });
	
	        case 3:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[7], this);
	}
	
	function updateBudget(action) {
	  var budget, status, d;
	  return _regenerator2.default.wrap(function updateBudget$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          budget = action.budget, status = action.status;
	          _context9.next = 3;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionId);
	
	        case 3:
	          d = _context9.sent;
	          _context9.prev = 4;
	          _context9.next = 7;
	          return (0, _effects.call)(_discussions.updateBudgetServer, budget, status, d);
	
	        case 7:
	          _context9.next = 9;
	          return (0, _effects.put)({
	            type: _constants4.UPDATE_BUDGET_SUCCESS,
	            budget: budget,
	            status: status
	          });
	
	        case 9:
	          _context9.next = 14;
	          break;
	
	        case 11:
	          _context9.prev = 11;
	          _context9.t0 = _context9['catch'](4);
	
	          (0, _errorHandlingService.reportError)('UPDATE_BUDGET_ERROR', _context9.t0.message);
	
	        case 14:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked[8], this, [[4, 11]]);
	}
	
	function approveDocument(action) {
	  var documentId, approvedData, newDocumentJSON, permissionId, campaignId, discussionId, discussionName, messageType, message, metaData, approveDocumentData, messageData;
	  return _regenerator2.default.wrap(function approveDocument$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          documentId = action.documentId;
	          approvedData = action.approvedData;
	          _context10.prev = 2;
	          _context10.next = 5;
	          return (0, _effects.call)(_documents.updateDocumentApproved, documentId, approvedData);
	
	        case 5:
	          newDocumentJSON = _context10.sent;
	          _context10.next = 8;
	          return (0, _effects.select)(_campaignSelectors.getPermissionId);
	
	        case 8:
	          permissionId = _context10.sent;
	          _context10.next = 11;
	          return (0, _effects.select)(_campaignSelectors.getCampaignId);
	
	        case 11:
	          campaignId = _context10.sent;
	          _context10.next = 14;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionId);
	
	        case 14:
	          discussionId = _context10.sent;
	          _context10.next = 17;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionName);
	
	        case 17:
	          discussionName = _context10.sent;
	          messageType = newDocumentJSON.docType.toLowerCase();
	          message = messageType;
	          metaData = {
	            messageType: messageType,
	            discussionId: discussionId,
	            permissionId: permissionId,
	            docId: newDocumentJSON.id,
	            docStatus: 'approved'
	          };
	
	
	          if (newDocumentJSON.docType === _staticConfiguration.BRIEF) {
	            approveDocumentData = {
	              campaignId: campaignId,
	              collaborationId: discussionId,
	              collaborationName: discussionName,
	              docId: newDocumentJSON.id
	            };
	
	            (0, _metricAnalyticsService.trackEvent)('Approve Brief', approveDocumentData);
	          }
	
	          messageData = {
	            message: message,
	            metaData: metaData,
	            page: _staticConfiguration.DISCUSSION_PAGE
	          };
	          _context10.next = 25;
	          return (0, _effects.put)({ type: _constants4.SEND_MESSAGE, data: messageData });
	
	        case 25:
	          _context10.next = 27;
	          return (0, _effects.put)({
	            type: _constants4.UPDATE_DOCUMENTS,
	            documentData: (0, _immutable.fromJS)(newDocumentJSON)
	          });
	
	        case 27:
	          _context10.next = 32;
	          break;
	
	        case 29:
	          _context10.prev = 29;
	          _context10.t0 = _context10['catch'](2);
	
	          (0, _errorHandlingService.reportError)('APPROVE_DOCUMENT_ERROR', _context10.t0.message);
	
	        case 32:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked[9], this, [[2, 29]]);
	}
	
	function unapproveDocument(action) {
	  var documentId, docType, messageType, permissionId, discussionId, message, metaData, messageData;
	  return _regenerator2.default.wrap(function unapproveDocument$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          documentId = action.documentId;
	          docType = action.docType;
	          messageType = docType.toLowerCase();
	          _context11.prev = 3;
	          _context11.next = 6;
	          return (0, _effects.select)(_campaignSelectors.getPermissionId);
	
	        case 6:
	          permissionId = _context11.sent;
	          _context11.next = 9;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionId);
	
	        case 9:
	          discussionId = _context11.sent;
	          message = messageType;
	          metaData = {
	            messageType: messageType,
	            discussionId: discussionId,
	            permissionId: permissionId,
	            docId: documentId,
	            docStatus: 'removed'
	          };
	          _context11.next = 14;
	          return (0, _effects.call)(_documents.removeDocument, documentId);
	
	        case 14:
	          messageData = {
	            message: message,
	            metaData: metaData,
	            page: _staticConfiguration.DISCUSSION_PAGE
	          };
	          _context11.next = 17;
	          return (0, _effects.put)({ type: _constants4.SEND_MESSAGE, data: messageData });
	
	        case 17:
	          _context11.next = 19;
	          return (0, _effects.put)({ type: _constants4.REMOVE_DOCUMENT, documentId: documentId });
	
	        case 19:
	          _context11.next = 24;
	          break;
	
	        case 21:
	          _context11.prev = 21;
	          _context11.t0 = _context11['catch'](3);
	
	          (0, _errorHandlingService.reportError)('UNAPPROVE_DOCUMENT_ERROR', _context11.t0.message);
	
	        case 24:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked[10], this, [[3, 21]]);
	}
	
	function updateDeliverableApprovedStatus(action) {
	  var _action$data2, approved, documentId, deliverableId, userName, updatedApproved, approvedData, newDocument, immutableDocument, permissionId, discussionId, message, metaData, campaignId, campaignName, discussionName, deliverableName, approveDeliverableData, messageData;
	
	  return _regenerator2.default.wrap(function updateDeliverableApprovedStatus$(_context12) {
	    while (1) {
	      switch (_context12.prev = _context12.next) {
	        case 0:
	          _context12.prev = 0;
	          _action$data2 = action.data, approved = _action$data2.approved, documentId = _action$data2.documentId, deliverableId = _action$data2.deliverableId;
	          _context12.next = 4;
	          return (0, _effects.select)(_userSelectors.getUserName);
	
	        case 4:
	          userName = _context12.sent;
	
	
	          // Swap approval
	          updatedApproved = !approved;
	          approvedData = {
	            approved: updatedApproved,
	            approvedBy: userName,
	            approvalDate: new Date()
	          };
	          _context12.next = 9;
	          return (0, _effects.call)(_documents.updateDocumentApproved, documentId, approvedData);
	
	        case 9:
	          newDocument = _context12.sent;
	          immutableDocument = (0, _immutable.fromJS)(newDocument);
	          _context12.next = 13;
	          return (0, _effects.select)(_campaignSelectors.getPermissionId);
	
	        case 13:
	          permissionId = _context12.sent;
	          _context12.next = 16;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionId);
	
	        case 16:
	          discussionId = _context12.sent;
	          message = 'deliverable';
	          metaData = {
	            messageType: 'deliverable',
	            discussionId: discussionId,
	            permissionId: permissionId,
	            docId: newDocument.id,
	            deliverableId: deliverableId,
	            deliverableStatus: approvedData.approved ? 'approved' : 'submitted'
	          };
	          _context12.next = 21;
	          return (0, _effects.select)(_campaignSelectors.getCampaignId);
	
	        case 21:
	          campaignId = _context12.sent;
	          _context12.next = 24;
	          return (0, _effects.select)(_campaignSelectors.getCampaignName);
	
	        case 24:
	          campaignName = _context12.sent;
	          _context12.next = 27;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionName);
	
	        case 27:
	          discussionName = _context12.sent;
	          _context12.next = 30;
	          return (0, _effects.select)(_discussionSelectors.getDeliverableName, deliverableId);
	
	        case 30:
	          deliverableName = _context12.sent;
	          approveDeliverableData = {
	            campaignId: campaignId,
	            collaborationId: discussionId,
	            collaborationName: discussionName,
	            deliverableId: deliverableId,
	            deliverableName: deliverableName
	          };
	
	          (0, _metricAnalyticsService.trackEvent)('Approve Deliverable', approveDeliverableData);
	
	          messageData = {
	            message: message,
	            metaData: metaData,
	            page: _staticConfiguration.DISCUSSION_PAGE
	          };
	          _context12.next = 36;
	          return (0, _effects.put)({ type: _constants4.SEND_MESSAGE, data: messageData });
	
	        case 36:
	          _context12.next = 38;
	          return (0, _effects.put)({ type: _constants4.UPDATE_DOCUMENTS, documentData: immutableDocument });
	
	        case 38:
	          _context12.next = 40;
	          return (0, _effects.put)({ type: _constants4.UPDATE_DELIVERABLE_DOCUMENT, deliverableId: deliverableId, documentData: immutableDocument });
	
	        case 40:
	          _context12.next = 42;
	          return (0, _effects.put)({ type: _constants4.UPDATE_DELIVERABLE_APPROVED_SUCCESS });
	
	        case 42:
	          _context12.next = 49;
	          break;
	
	        case 44:
	          _context12.prev = 44;
	          _context12.t0 = _context12['catch'](0);
	          _context12.next = 48;
	          return (0, _effects.put)({ type: _constants4.UPDATE_DELIVERABLE_APPROVED_ERROR, error: _context12.t0.message });
	
	        case 48:
	          (0, _errorHandlingService.reportError)('UPDATE_DELIVERABLE_APPROVED_ERROR', _context12.t0.message);
	
	        case 49:
	        case 'end':
	          return _context12.stop();
	      }
	    }
	  }, _marked[11], this, [[0, 44]]);
	}
	
	function receiveMessage(action) {
	  var messageObject, data, discussionId, currentChannelURL, messageChannelURL, userId, isMyCampaignPermission, currentBrief, currentContract, signedContract, documentDataJSON, documentData, deliverableData, options, budget, status, discussionLoaded, discussion, campaignId, unreadMessageCount, notificationMessageOptions, title, notificationMessage, _options;
	
	  return _regenerator2.default.wrap(function receiveMessage$(_context13) {
	    while (1) {
	      switch (_context13.prev = _context13.next) {
	        case 0:
	          messageObject = action.message;
	          data = JSON.parse(messageObject.data);
	          discussionId = data.discussionId;
	          _context13.next = 5;
	          return (0, _effects.select)(_sendbirdSelectors.getSendbirdChannelURL);
	
	        case 5:
	          currentChannelURL = _context13.sent;
	          messageChannelURL = messageObject.channelUrl;
	          _context13.next = 9;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 9:
	          userId = _context13.sent;
	          _context13.next = 12;
	          return (0, _effects.select)(_campaignPermissionSelectors.getIsMyCampaignPermission, data.permissionId);
	
	        case 12:
	          isMyCampaignPermission = _context13.sent;
	
	          if (!(currentChannelURL === messageChannelURL)) {
	            _context13.next = 72;
	            break;
	          }
	
	          _context13.prev = 14;
	          _context13.next = 17;
	          return (0, _effects.select)(_discussionSelectors.getCurrentBrief);
	
	        case 17:
	          currentBrief = _context13.sent;
	          _context13.next = 20;
	          return (0, _effects.select)(_discussionSelectors.getCurrentContract);
	
	        case 20:
	          currentContract = _context13.sent;
	          _context13.next = 23;
	          return (0, _effects.select)(_discussionSelectors.getSignedContract);
	
	        case 23:
	          signedContract = _context13.sent;
	
	
	          // If the message has a document then load it into state
	          documentDataJSON = void 0;
	
	          if (!data.docId) {
	            _context13.next = 41;
	            break;
	          }
	
	          _context13.next = 28;
	          return (0, _effects.call)(_documents.getDocument, data.docId);
	
	        case 28:
	          documentData = _context13.sent;
	
	          documentDataJSON = documentData.toJSONTree();
	
	          if (!(documentDataJSON.docType === _staticConfiguration.BRIEF && documentDataJSON.id !== currentBrief)) {
	            _context13.next = 33;
	            break;
	          }
	
	          _context13.next = 33;
	          return (0, _effects.put)({ type: _constants4.UPDATE_CURRENT_BRIEF, currentBrief: documentDataJSON.id });
	
	        case 33:
	          if (!(documentDataJSON.docType === _staticConfiguration.CONTRACT && documentDataJSON.id !== currentContract)) {
	            _context13.next = 36;
	            break;
	          }
	
	          _context13.next = 36;
	          return (0, _effects.put)({ type: _constants4.UPDATE_CURRENT_CONTRACT, currentContract: documentDataJSON.id });
	
	        case 36:
	          if (!(documentDataJSON.docType === _staticConfiguration.SIGNED_CONTRACT && documentDataJSON.id !== signedContract)) {
	            _context13.next = 39;
	            break;
	          }
	
	          _context13.next = 39;
	          return (0, _effects.put)({ type: _constants4.UPDATE_SIGNED_CONTRACT, signedContract: documentDataJSON.id });
	
	        case 39:
	          _context13.next = 41;
	          return (0, _effects.put)({ type: _constants4.UPDATE_DOCUMENTS, documentData: (0, _immutable.fromJS)(documentDataJSON) });
	
	        case 41:
	          if (!data.deliverableId) {
	            _context13.next = 51;
	            break;
	          }
	
	          _context13.next = 44;
	          return (0, _effects.call)(_deliverables.getDeliverable, data.deliverableId);
	
	        case 44:
	          deliverableData = _context13.sent;
	
	          if (documentDataJSON) deliverableData.mostRecentDocument = documentDataJSON;
	          _context13.next = 48;
	          return (0, _effects.put)({ type: _constants4.UPDATE_DELIVERABLES, deliverableData: (0, _immutable.fromJS)(deliverableData) });
	
	        case 48:
	          if (!deliverableData.document) {
	            _context13.next = 51;
	            break;
	          }
	
	          _context13.next = 51;
	          return (0, _effects.put)({ type: _constants4.UPDATE_DOCUMENTS, documentData: (0, _immutable.fromJS)(deliverableData.document) });
	
	        case 51:
	          options = {
	            sendbirdApiToken: ("76d121b106a181d02ec5d1cb059bbd2d76e383f2"),
	            channelURL: currentChannelURL,
	            userId: userId
	          };
	
	          if (!(data.messageType && data.messageType === 'budget')) {
	            _context13.next = 56;
	            break;
	          }
	
	          budget = data.budget, status = data.status;
	          _context13.next = 56;
	          return (0, _effects.put)({ type: _constants4.UPDATE_BUDGET, budget: budget, status: status });
	
	        case 56:
	          _context13.next = 58;
	          return (0, _effects.select)(_discussionListSelectors.getDiscussionIsLoaded, discussionId);
	
	        case 58:
	          discussionLoaded = _context13.sent;
	
	          if (!discussionLoaded) {
	            _context13.next = 62;
	            break;
	          }
	
	          _context13.next = 62;
	          return (0, _effects.put)({ type: _constants3.SET_UNREAD_MESSAGE_COUNT, discussionId: discussionId, unreadMessageCount: 0 });
	
	        case 62:
	          _context13.next = 64;
	          return (0, _effects.put)({ type: _constants4.UPDATE_MESSAGES, message: messageObject });
	
	        case 64:
	          scroll.scrollToBottom({ duration: 0 });
	          _context13.next = 70;
	          break;
	
	        case 67:
	          _context13.prev = 67;
	          _context13.t0 = _context13['catch'](14);
	
	          (0, _errorHandlingService.reportError)('RECEIVE_MESSAGE_ERROR', _context13.t0.message);
	
	        case 70:
	          _context13.next = 92;
	          break;
	
	        case 72:
	          _context13.prev = 72;
	
	          if (isMyCampaignPermission) {
	            _context13.next = 87;
	            break;
	          }
	
	          _context13.next = 76;
	          return (0, _effects.call)(_discussions.getReceiveMessageDiscussion, discussionId);
	
	        case 76:
	          discussion = _context13.sent;
	          _context13.next = 79;
	          return (0, _effects.select)(_campaignSelectors.getCampaignId);
	
	        case 79:
	          campaignId = _context13.sent;
	          _context13.next = 82;
	          return (0, _effects.select)(_discussionListSelectors.getDiscussionUnreadMessageCount, discussionId);
	
	        case 82:
	          unreadMessageCount = _context13.sent;
	
	          if (!(campaignId === discussion.campaign.id)) {
	            _context13.next = 86;
	            break;
	          }
	
	          _context13.next = 86;
	          return (0, _effects.put)({ type: _constants3.SET_UNREAD_MESSAGE_COUNT, discussionId: discussionId, unreadMessageCount: unreadMessageCount + 1 });
	
	        case 86:
	
	          if ((0, _notificationsService.checkDesktopNotificationPermissions)()) {
	            notificationMessageOptions = {
	              deliverable_added: 'Deliverable assigned:',
	              deliverable_submitted: 'Deliverable added:',
	              deliverable_approved: 'Deliverable approved:',
	              brief_added: 'Brief added:',
	              brief_approved: 'Brief approved:',
	              contract_added: 'Contract added:',
	              signed_contract_added: 'Contract signed:',
	              document_added: 'Document added:'
	            };
	            title = discussion.campaign.name + ', ' + discussion.name;
	            notificationMessage = messageObject.message;
	
	            if (notificationMessageOptions[data.messageType + '_' + data.deliverableStatus]) {
	              notificationMessage = notificationMessageOptions[data.messageType + '_' + data.deliverableStatus] + ' ' + messageObject.message;
	            } else if (notificationMessageOptions[data.messageType + '_' + data.docStatus]) {
	              notificationMessage = notificationMessageOptions[data.messageType + '_' + data.docStatus] + ' ' + messageObject.message;
	            }
	
	            _options = {
	              body: notificationMessage,
	              icon: '/small-dyzio-logomark.png'
	            };
	
	
	            (0, _notificationsService.sendDesktopNotification)(title, _options, openDiscussionCallback.bind(this, discussionId));
	          }
	
	        case 87:
	          _context13.next = 92;
	          break;
	
	        case 89:
	          _context13.prev = 89;
	          _context13.t1 = _context13['catch'](72);
	
	          (0, _errorHandlingService.reportError)('RECEIVE_NOTIFICATION_ERROR', _context13.t1.message);
	
	        case 92:
	        case 'end':
	          return _context13.stop();
	      }
	    }
	  }, _marked[12], this, [[14, 67], [72, 89]]);
	}
	
	function openDiscussionCallback(discussionId) {
	  var origin = window.location.origin;
	
	  window.open(origin + '/campaign/discussion/' + discussionId, '_blank');
	}
	
	function watchLoadMoreMessages() {
	  return _regenerator2.default.wrap(function watchLoadMoreMessages$(_context14) {
	    while (1) {
	      switch (_context14.prev = _context14.next) {
	        case 0:
	          _context14.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants4.LOAD_MORE_MESSAGES, loadMoreMessages);
	
	        case 2:
	        case 'end':
	          return _context14.stop();
	      }
	    }
	  }, _marked[13], this);
	}
	
	function watchSendbirdMessages() {
	  return _regenerator2.default.wrap(function watchSendbirdMessages$(_context15) {
	    while (1) {
	      switch (_context15.prev = _context15.next) {
	        case 0:
	          _context15.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants4.SEND_MESSAGE, sendNewSendbirdMessage);
	
	        case 2:
	        case 'end':
	          return _context15.stop();
	      }
	    }
	  }, _marked[14], this);
	}
	
	function watchRecieveMessages() {
	  return _regenerator2.default.wrap(function watchRecieveMessages$(_context16) {
	    while (1) {
	      switch (_context16.prev = _context16.next) {
	        case 0:
	          _context16.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants4.RECEIVE_MESSAGE, receiveMessage);
	
	        case 2:
	        case 'end':
	          return _context16.stop();
	      }
	    }
	  }, _marked[15], this);
	}
	
	function watchLoadDiscussion() {
	  return _regenerator2.default.wrap(function watchLoadDiscussion$(_context17) {
	    while (1) {
	      switch (_context17.prev = _context17.next) {
	        case 0:
	          _context17.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants4.LOAD_DISCUSSION, loadDiscussion);
	
	        case 2:
	        case 'end':
	          return _context17.stop();
	      }
	    }
	  }, _marked[16], this);
	}
	
	function watchUpdateDocument() {
	  return _regenerator2.default.wrap(function watchUpdateDocument$(_context18) {
	    while (1) {
	      switch (_context18.prev = _context18.next) {
	        case 0:
	          _context18.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants4.NEW_DOCUMENT, updateDocuments);
	
	        case 2:
	        case 'end':
	          return _context18.stop();
	      }
	    }
	  }, _marked[17], this);
	}
	
	function watchUpdateBudget() {
	  return _regenerator2.default.wrap(function watchUpdateBudget$(_context19) {
	    while (1) {
	      switch (_context19.prev = _context19.next) {
	        case 0:
	          _context19.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants4.UPDATE_BUDGET, updateBudget);
	
	        case 2:
	        case 'end':
	          return _context19.stop();
	      }
	    }
	  }, _marked[18], this);
	}
	
	function watchApproveDocument() {
	  return _regenerator2.default.wrap(function watchApproveDocument$(_context20) {
	    while (1) {
	      switch (_context20.prev = _context20.next) {
	        case 0:
	          _context20.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants4.APPROVE_DOCUMENT, approveDocument);
	
	        case 2:
	        case 'end':
	          return _context20.stop();
	      }
	    }
	  }, _marked[19], this);
	}
	
	function watchUnapproveDocument() {
	  return _regenerator2.default.wrap(function watchUnapproveDocument$(_context21) {
	    while (1) {
	      switch (_context21.prev = _context21.next) {
	        case 0:
	          _context21.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants4.UNAPPROVE_DOCUMENT, unapproveDocument);
	
	        case 2:
	        case 'end':
	          return _context21.stop();
	      }
	    }
	  }, _marked[20], this);
	}
	
	function watchUpdateDeliverableApproved() {
	  return _regenerator2.default.wrap(function watchUpdateDeliverableApproved$(_context22) {
	    while (1) {
	      switch (_context22.prev = _context22.next) {
	        case 0:
	          _context22.next = 2;
	          return (0, _reduxSaga.takeEvery)(_constants4.UPDATE_DELIVERABLE_APPROVED, updateDeliverableApprovedStatus);
	
	        case 2:
	        case 'end':
	          return _context22.stop();
	      }
	    }
	  }, _marked[21], this);
	}
	
	function discussionsSagas() {
	  return _regenerator2.default.wrap(function discussionsSagas$(_context23) {
	    while (1) {
	      switch (_context23.prev = _context23.next) {
	        case 0:
	          _context23.next = 2;
	          return [(0, _effects.fork)(watchSendbirdMessages), (0, _effects.fork)(watchRecieveMessages), (0, _effects.fork)(watchLoadMoreMessages), (0, _effects.fork)(watchLoadDiscussion), (0, _effects.fork)(watchUpdateDocument), (0, _effects.fork)(watchUnapproveDocument), (0, _effects.fork)(watchApproveDocument), (0, _effects.fork)(watchUpdateDeliverableApproved), (0, _effects.fork)(watchUpdateBudget)];
	
	        case 2:
	        case 'end':
	          return _context23.stop();
	      }
	    }
	  }, _marked[22], this);
	}

/***/ },
/* 2125 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CREATE_DOCUMENT = exports.CREATE_DOCUMENT = 'Dyzio/DocumentUpload/CREATE_DOCUMENT';

/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.createNewDocument = createNewDocument;
	exports.watchCreateDocument = watchCreateDocument;
	exports.default = documentUploadSaga;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _discussions = __webpack_require__(172);
	
	var _documents = __webpack_require__(364);
	
	var _campaignSelectors = __webpack_require__(117);
	
	var _discussionSelectors = __webpack_require__(361);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _metricAnalyticsService = __webpack_require__(119);
	
	var _constants = __webpack_require__(2125);
	
	var _modal = __webpack_require__(169);
	
	var _constants2 = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [createNewDocument, watchCreateDocument, documentUploadSaga].map(_regenerator2.default.mark);
	
	function createNewDocument(action) {
	  var documentData, createDocumentCallback, discussionId, newDocument, newDocumentJSON, docType, docId, discussionName, campaignId, uploadDocumentData, myPermissionId, messageType, message, metaData, messageData;
	  return _regenerator2.default.wrap(function createNewDocument$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          documentData = action.documentData;
	          createDocumentCallback = action.createDocumentCallback;
	          _context.next = 4;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionId);
	
	        case 4:
	          discussionId = _context.sent;
	
	          documentData.discussionId = discussionId;
	
	          _context.prev = 6;
	          _context.next = 9;
	          return (0, _effects.put)({ type: _modal.MODAL_LOADING, loading: true });
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.call)(_documents.createDocument, documentData);
	
	        case 11:
	          newDocument = _context.sent;
	          newDocumentJSON = newDocument.toJSONTree();
	          docType = newDocumentJSON.docType;
	          docId = newDocumentJSON.id;
	          _context.next = 17;
	          return (0, _effects.select)(_discussionSelectors.getDiscussionName);
	
	        case 17:
	          discussionName = _context.sent;
	          _context.next = 20;
	          return (0, _effects.select)(_campaignSelectors.getCampaignId);
	
	        case 20:
	          campaignId = _context.sent;
	          _context.next = 23;
	          return (0, _effects.call)(_discussions.addDiscussionDocument, discussionId, newDocument);
	
	        case 23:
	          uploadDocumentData = {
	            campaignId: campaignId,
	            collaborationId: discussionId,
	            collaborationName: discussionName,
	            docId: docId
	          };
	
	          // Update document and deliverable local state
	
	          _context.next = 26;
	          return (0, _effects.put)({ type: _constants2.UPDATE_DOCUMENTS, documentData: (0, _immutable.fromJS)(newDocumentJSON) });
	
	        case 26:
	          if (!(docType === _staticConfiguration.BRIEF)) {
	            _context.next = 32;
	            break;
	          }
	
	          _context.next = 29;
	          return (0, _effects.put)({ type: _constants2.UPDATE_CURRENT_BRIEF, currentBrief: docId });
	
	        case 29:
	          (0, _metricAnalyticsService.trackEvent)('Upload Brief', uploadDocumentData);
	          _context.next = 45;
	          break;
	
	        case 32:
	          if (!(docType === _staticConfiguration.CONTRACT)) {
	            _context.next = 38;
	            break;
	          }
	
	          _context.next = 35;
	          return (0, _effects.put)({ type: _constants2.UPDATE_CURRENT_CONTRACT, currentContract: docId });
	
	        case 35:
	          (0, _metricAnalyticsService.trackEvent)('Upload Contract', uploadDocumentData);
	          _context.next = 45;
	          break;
	
	        case 38:
	          if (!(docType === _staticConfiguration.SIGNED_CONTRACT)) {
	            _context.next = 44;
	            break;
	          }
	
	          _context.next = 41;
	          return (0, _effects.put)({ type: _constants2.UPDATE_SIGNED_CONTRACT, signedContract: docId });
	
	        case 41:
	          (0, _metricAnalyticsService.trackEvent)('Upload Signed Contract', uploadDocumentData);
	          _context.next = 45;
	          break;
	
	        case 44:
	          if (docType === _staticConfiguration.DOCUMENT) {
	            (0, _metricAnalyticsService.trackEvent)('Upload File', uploadDocumentData);
	          }
	
	        case 45:
	          _context.next = 47;
	          return (0, _effects.select)(_campaignSelectors.getPermissionId);
	
	        case 47:
	          myPermissionId = _context.sent;
	          messageType = docType.toLowerCase();
	          message = newDocumentJSON.name;
	          metaData = {
	            messageType: messageType,
	            discussionId: discussionId,
	            permissionId: myPermissionId,
	            docId: newDocumentJSON.id,
	            docStatus: 'added'
	          };
	          messageData = {
	            message: message,
	            metaData: metaData,
	            page: _staticConfiguration.DISCUSSION_PAGE
	          };
	          _context.next = 54;
	          return (0, _effects.put)({ type: _constants2.SEND_MESSAGE, data: messageData });
	
	        case 54:
	          _context.next = 56;
	          return (0, _effects.call)(createDocumentCallback);
	
	        case 56:
	          _context.next = 58;
	          return (0, _effects.put)({ type: _modal.MODAL_CLEAR });
	
	        case 58:
	          _context.next = 65;
	          break;
	
	        case 60:
	          _context.prev = 60;
	          _context.t0 = _context['catch'](6);
	
	          (0, _errorHandlingService.reportError)('CREATE_DOCUMENT_ERROR', _context.t0.message);
	          _context.next = 65;
	          return (0, _effects.put)({ type: _modal.MODAL_ERROR, error: _context.t0 });
	
	        case 65:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[6, 60]]);
	}
	
	function watchCreateDocument() {
	  return _regenerator2.default.wrap(function watchCreateDocument$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.CREATE_DOCUMENT, createNewDocument);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function documentUploadSaga() {
	  return _regenerator2.default.wrap(function documentUploadSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(watchCreateDocument)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _campaignSummary = __webpack_require__(1909);
	
	var _campaignSummary2 = _interopRequireDefault(_campaignSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var delay = function delay(ms) {
	  return new Promise(function (resolve, reject) {
	    return setTimeout(resolve, ms);
	  });
	};
	
	var reportsMonths = ['MATTER_OF_FACT_2025'];
	
	var getTotals = function getTotals(rows) {
	  var totalPosts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var isEMV = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var reachTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
	    return _lodash2.default.get(row, 'totals.reach');
	  });
	  var impressionsTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
	    var value = _lodash2.default.get(row, 'totals.impressions');
	    if (!isEMV || value > 0) {
	      return value;
	    }
	    return _lodash2.default.get(row, 'emv.estimatedImpressions', 0);
	  });
	  var engagementsTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
	    return _lodash2.default.get(row, 'totals.engagements');
	  });
	  var videoViewsTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
	    return _lodash2.default.get(row, 'totals.videoViews');
	  });
	  var impsEMVTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
	    var value = _lodash2.default.get(row, 'emv.impressionsEMV');
	    if (!isEMV || value > 0) {
	      return value;
	    }
	    return _lodash2.default.get(row, 'emv.estimatedImpressionsEMV', 0);
	  });
	  var engsEMVTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
	    return _lodash2.default.get(row, 'emv.engagementsEMV');
	  });
	  var impressionsCPM = _lodash2.default.meanBy(_lodash2.default.values(rows), function (row) {
	    return _lodash2.default.get(row, 'costs.impressionsCPM', 0);
	  });
	  var engagementsCPM = _lodash2.default.meanBy(_lodash2.default.values(rows), function (row) {
	    return _lodash2.default.get(row, 'costs.engsCPM', 0);
	  });
	  var viewsCPM = _lodash2.default.meanBy(_lodash2.default.values(rows), function (row) {
	    return _lodash2.default.get(row, 'costs.viewsCPM', 0);
	  });
	
	  var engagedPosts = _lodash2.default.filter(rows, function (row) {
	    return _lodash2.default.get(row, 'totals.engagements') > 0;
	  });
	
	  var aveER = _lodash2.default.meanBy(_lodash2.default.values(engagedPosts), function (row) {
	    if (_lodash2.default.get(row, 'totals.engagements') > 0) {
	      return _lodash2.default.get(row, 'totals.engagements') / _lodash2.default.get(row, 'instagramCount', 1) / _lodash2.default.get(row, 'trackedAssetsStats.totalAssets', 1) * 100;
	    }
	    return 0;
	  });
	
	  return {
	    reachTotal: reachTotal,
	    impressionsTotal: impressionsTotal,
	    engagementsTotal: engagementsTotal,
	    videoViewsTotal: videoViewsTotal,
	    impsEMVTotal: impsEMVTotal,
	    engsEMVTotal: engsEMVTotal,
	    impressionsCPM: impressionsCPM,
	    engagementsCPM: engagementsCPM,
	    viewsCPM: viewsCPM,
	    aveER: aveER
	  };
	};
	
	var ElevenMeadowDashboard = function (_Component) {
	  _inherits(ElevenMeadowDashboard, _Component);
	
	  function ElevenMeadowDashboard(props) {
	    var _this2 = this,
	        _this$state;
	
	    _classCallCheck(this, ElevenMeadowDashboard);
	
	    var _this = _possibleConstructorReturn(this, (ElevenMeadowDashboard.__proto__ || Object.getPrototypeOf(ElevenMeadowDashboard)).call(this, props));
	
	    _this.fetchReportForMonth = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(month) {
	        var reloading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var reportsData, organisationId, params;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                reportsData = _this.state.reportsData;
	                organisationId = _this.props.userInfo.organisationId;
	                params = reloading ? { clearCache: true } : {};
	                _context.next = 5;
	                return _this.reportImportClient.get('/organisation/' + organisationId + '/report/' + month, { params: params }).then(function (response) {
	                  var reports = _lodash2.default.get(response, 'data.data.data.reports', []);
	                  console.log('reports get', reports);
	
	                  var rData = [];
	
	                  var _iteratorNormalCompletion = true;
	                  var _didIteratorError = false;
	                  var _iteratorError = undefined;
	
	                  try {
	                    for (var _iterator = reports[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                      var report = _step.value;
	
	
	                      var cData = getTotals(_lodash2.default.get(report, 'emvData.reportData'));
	                      cData.campaignName = _lodash2.default.get(report, 'name');
	                      cData.id = _lodash2.default.get(report, 'id');
	
	                      rData.push(cData);
	                    }
	                  } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                      }
	                    } finally {
	                      if (_didIteratorError) {
	                        throw _iteratorError;
	                      }
	                    }
	                  }
	
	                  reportsData.push({
	                    campaignName: _lodash2.default.replace(month, '_', ' '),
	                    campaignsData: rData
	                  });
	
	                  _this.setState({
	                    reportsData: reportsData,
	                    isLoading: false
	                  });
	                }).catch(function (err) {
	                  console.log(err);
	                });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.fetchReports = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, month;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this.setState({
	                augustIsLoading: true
	              });
	              // eslint-disable-next-line no-restricted-syntax
	              _iteratorNormalCompletion2 = true;
	              _didIteratorError2 = false;
	              _iteratorError2 = undefined;
	              _context2.prev = 4;
	              _iterator2 = reportsMonths[Symbol.iterator]();
	
	            case 6:
	              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
	                _context2.next = 14;
	                break;
	              }
	
	              month = _step2.value;
	              _context2.next = 10;
	              return _this.fetchReportForMonth(month);
	
	            case 10:
	              delay(500);
	
	            case 11:
	              _iteratorNormalCompletion2 = true;
	              _context2.next = 6;
	              break;
	
	            case 14:
	              _context2.next = 20;
	              break;
	
	            case 16:
	              _context2.prev = 16;
	              _context2.t0 = _context2['catch'](4);
	              _didIteratorError2 = true;
	              _iteratorError2 = _context2.t0;
	
	            case 20:
	              _context2.prev = 20;
	              _context2.prev = 21;
	
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	
	            case 23:
	              _context2.prev = 23;
	
	              if (!_didIteratorError2) {
	                _context2.next = 26;
	                break;
	              }
	
	              throw _iteratorError2;
	
	            case 26:
	              return _context2.finish(23);
	
	            case 27:
	              return _context2.finish(20);
	
	            case 28:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[4, 16, 20, 28], [21,, 23, 27]]);
	    }));
	
	    _this.state = (_this$state = {
	      currentPage: 1,
	      reportsData: []
	    }, _defineProperty(_this$state, 'reportsData', []), _defineProperty(_this$state, 'isLoading', true), _this$state);
	    var buildRESTClient = _this.props.buildRESTClient;
	
	    _this.reportImportClient = buildRESTClient({
	      baseURL: ("https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production") || '',
	      hasToken: false,
	      timeout: 100000
	    });
	    return _this;
	  }
	
	  _createClass(ElevenMeadowDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchReports();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          reportsData = _state.reportsData,
	          isLoading = _state.isLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _lodash2.default.map(reportsData, function (campaign, i) {
	              return _react2.default.createElement(_campaignSummary2.default, {
	                key: _lodash2.default.get(campaign, 'campaignName') + ' - ' + i,
	                campaigns: _lodash2.default.get(campaign, 'campaignsData'),
	                title: _lodash2.default.get(campaign, 'campaignName'),
	                isLoading: isLoading
	              });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ElevenMeadowDashboard;
	}(_react.Component);
	
	ElevenMeadowDashboard.propTypes = {
	  buildRESTClient: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(ElevenMeadowDashboard);

/***/ },
/* 2128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactTypeformEmbed = __webpack_require__(1574);
	
	var _recompose = __webpack_require__(15);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasOrganisation = __webpack_require__(106);
	
	var _hasOrganisation2 = _interopRequireDefault(_hasOrganisation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPEFORM_URL = 'https://8i5i40bh5gd.typeform.com/to/uTvp2XTe';
	
	var centerStyle = {
	  width: 600, margin: '200px auto'
	};
	
	var EntrySurvey = function EntrySurvey(_ref) {
	  var userInfo = _ref.userInfo,
	      organisation = _ref.organisation;
	
	  var specificTypeFormUrl = void 0;
	
	  if (userInfo && organisation) {
	    var name = encodeURIComponent(userInfo.name);
	    var email = encodeURIComponent(userInfo.email);
	    var orgName = encodeURIComponent(organisation.name);
	    specificTypeFormUrl = TYPEFORM_URL + '?user_name=' + name + '&user_email=' + email + '&organisation_name=' + orgName;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'page' },
	    _react2.default.createElement(
	      'div',
	      { className: 'page-content' },
	      _react2.default.createElement(
	        _semanticUiReact.Message,
	        { icon: true, info: true, style: centerStyle },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle notched', loading: true }),
	        _react2.default.createElement(
	          _semanticUiReact.Message.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Message.Header,
	            null,
	            'loading entry survey'
	          ),
	          'please wait while we prepare our short survey...'
	        )
	      ),
	      userInfo && organisation && _react2.default.createElement(_reactTypeformEmbed.ReactTypeformEmbed, { url: specificTypeFormUrl })
	    )
	  );
	};
	
	EntrySurvey.propTypes = {
	  userInfo: _propTypes2.default.object.isRequired,
	  organisation: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _hasOrganisation2.default)(EntrySurvey);

/***/ },
/* 2129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var feedItemStyles = {
	  borderBottom: '1px dashed #eee'
	};
	
	var feedSummaryStyle = {
	  color: 'rgba(0,0,0, 0.7)'
	};
	
	var iconStyle = {
	  marginTop: 5
	};
	
	var ACRCampaignScannedEvent = function ACRCampaignScannedEvent(_ref) {
	  var createdDate = _ref.createdDate,
	      assetCount = _ref.assetCount;
	  return _react2.default.createElement(
	    _semanticUiReact.Feed.Event,
	    { style: feedItemStyles },
	    _react2.default.createElement(
	      _semanticUiReact.Feed.Label,
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { style: iconStyle, name: 'search', color: 'green' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Feed.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Feed.Date,
	        null,
	        createdDate && (0, _moment2.default)(createdDate).fromNow()
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Feed.Summary,
	        { style: feedSummaryStyle },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Channel scan. Found ',
	          assetCount,
	          ' posts.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = ACRCampaignScannedEvent;

/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _feedEvent = __webpack_require__(357);
	
	var _feedEvent2 = _interopRequireDefault(_feedEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCampaignLabel = function getCampaignLabel(type) {
	  switch (type) {
	    case 'ACR':
	      return _react2.default.createElement(
	        _semanticUiReact.Label,
	        { size: 'mini', basic: true, color: 'orange' },
	        'ACR'
	      );
	    case 'AUTOMATED':
	      return _react2.default.createElement(
	        _semanticUiReact.Label,
	        { size: 'mini', basic: true, color: 'pink' },
	        'AUTOMATED'
	      );
	    default:
	      return _react2.default.createElement(
	        _semanticUiReact.Label,
	        { size: 'mini', basic: true, color: 'green' },
	        'MANUAL'
	      );
	  }
	};
	
	var CampaignCreatedEvent = function CampaignCreatedEvent(_ref) {
	  var createdDate = _ref.createdDate,
	      _ref$messageData$reso = _ref.messageData.resource,
	      id = _ref$messageData$reso.id,
	      createdBy = _ref$messageData$reso.createdBy,
	      name = _ref$messageData$reso.name,
	      campaignType = _ref$messageData$reso.campaignType,
	      isCompact = _ref.isCompact;
	  return _react2.default.createElement(
	    _feedEvent2.default,
	    {
	      isCompact: isCompact,
	      actionText: 'added a new campaign',
	      createdBy: createdBy,
	      createdDate: createdDate
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Card,
	      {
	        fluid: true,
	        onClick: function onClick() {
	          return window.open('/campaign/' + id + '/collaborations', '_blank');
	        }
	      },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        _react2.default.createElement(_feedEvent.FeedLeftImage, {
	          src: '/icons/campaign-management.svg'
	        }),
	        _react2.default.createElement(_feedEvent.FeedTitleAndDescription, {
	          title: name,
	          description: getCampaignLabel(campaignType),
	          isCampaign: true
	        })
	      )
	    )
	  );
	};
	
	CampaignCreatedEvent.propTypes = {
	  messageData: _propTypes2.default.object.isRequired,
	  createdDate: _propTypes2.default.string.isRequired,
	  isCompact: _propTypes2.default.bool.isRequired
	};
	
	exports.default = CampaignCreatedEvent;

/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _feedEvent = __webpack_require__(357);
	
	var _feedEvent2 = _interopRequireDefault(_feedEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfluencerAddedEvent = function InfluencerAddedEvent(_ref) {
	  var isCompact = _ref.isCompact,
	      _ref$messageData = _ref.messageData,
	      _ref$messageData$reso = _ref$messageData.resource,
	      id = _ref$messageData$reso.id,
	      createdBy = _ref$messageData$reso.createdBy,
	      createdDate = _ref$messageData$reso.createdDate,
	      _ref$messageData$infl = _ref$messageData.influencer.attributes,
	      name = _ref$messageData$infl.name,
	      thumbnail = _ref$messageData$infl.thumbnail,
	      primarySocialHandle = _ref$messageData$infl.primarySocialHandle;
	  return _react2.default.createElement(
	    _feedEvent2.default,
	    {
	      isCompact: isCompact,
	      actionText: 'added a new influencer',
	      createdBy: createdBy,
	      createdDate: createdDate
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Card,
	      {
	        fluid: true,
	        onClick: function onClick() {
	          return window.open('/influencer/' + id + '/statistics', '_blank');
	        }
	      },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        _react2.default.createElement(_feedEvent.FeedLeftImage, {
	          src: thumbnail
	        }),
	        _react2.default.createElement(_feedEvent.FeedTitleAndDescription, {
	          title: name,
	          description: primarySocialHandle
	        })
	      )
	    )
	  );
	};
	
	InfluencerAddedEvent.propTypes = {
	  messageData: _propTypes2.default.object.isRequired,
	  isCompact: _propTypes2.default.bool.isRequired
	};
	
	exports.default = InfluencerAddedEvent;

/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _feedEvent = __webpack_require__(357);
	
	var _feedEvent2 = _interopRequireDefault(_feedEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var iconStyle = {
	  width: 50,
	  height: 50,
	  float: 'left',
	  marginRight: 20
	};
	
	var ShortlistCreatedEvent = function ShortlistCreatedEvent(_ref) {
	  var isCompact = _ref.isCompact,
	      _ref$messageData$reso = _ref.messageData.resource,
	      id = _ref$messageData$reso.id,
	      createdBy = _ref$messageData$reso.createdBy,
	      createdDate = _ref$messageData$reso.createdDate,
	      name = _ref$messageData$reso.name,
	      notes = _ref$messageData$reso.notes;
	  return _react2.default.createElement(
	    _feedEvent2.default,
	    {
	      isCompact: isCompact,
	      actionText: 'added a new shortlist',
	      createdBy: createdBy,
	      createdDate: createdDate
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Card,
	      {
	        fluid: true,
	        onClick: function onClick() {
	          return window.open('/shortlists/' + id, '_blank');
	        }
	      },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        _react2.default.createElement(_semanticUiReact.Icon, {
	          name: 'list alternate outline',
	          style: iconStyle,
	          size: 'big',
	          circular: true
	        }),
	        _react2.default.createElement(_feedEvent.FeedTitleAndDescription, {
	          title: name,
	          description: notes
	        })
	      )
	    )
	  );
	};
	
	ShortlistCreatedEvent.propTypes = {
	  messageData: _propTypes2.default.object.isRequired,
	  isCompact: _propTypes2.default.bool.isRequired
	};
	
	exports.default = ShortlistCreatedEvent;

/***/ },
/* 2133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactAvatar = __webpack_require__(701);
	
	var _reactAvatar2 = _interopRequireDefault(_reactAvatar);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _feedEvent = __webpack_require__(357);
	
	var _feedEvent2 = _interopRequireDefault(_feedEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var avatarStyle = {
	  float: 'left',
	  marginRight: 20
	};
	
	var UserAddedEvent = function UserAddedEvent(_ref) {
	  var isCompact = _ref.isCompact,
	      _ref$messageData$reso = _ref.messageData.resource,
	      createdBy = _ref$messageData$reso.createdBy,
	      createdDate = _ref$messageData$reso.createdDate,
	      name = _ref$messageData$reso.name,
	      role = _ref$messageData$reso.role;
	  return _react2.default.createElement(
	    _feedEvent2.default,
	    {
	      isCompact: isCompact,
	      actionText: 'added a new user',
	      createdBy: createdBy,
	      createdDate: createdDate
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Card,
	      { fluid: true },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        _react2.default.createElement(_reactAvatar2.default, {
	          round: true,
	          name: name,
	          size: 50,
	          style: avatarStyle
	        }),
	        _react2.default.createElement(_feedEvent.FeedTitleAndDescription, {
	          title: name,
	          description: _lodash2.default.startCase(_lodash2.default.lowerCase(role))
	        })
	      )
	    )
	  );
	};
	
	UserAddedEvent.propTypes = {
	  messageData: _propTypes2.default.object.isRequired,
	  isCompact: _propTypes2.default.bool.isRequired
	};
	
	exports.default = UserAddedEvent;

/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _influencerAddedEvent = __webpack_require__(2131);
	
	var _influencerAddedEvent2 = _interopRequireDefault(_influencerAddedEvent);
	
	var _campaignCreatedEvent = __webpack_require__(2130);
	
	var _campaignCreatedEvent2 = _interopRequireDefault(_campaignCreatedEvent);
	
	var _userAddedEvent = __webpack_require__(2133);
	
	var _userAddedEvent2 = _interopRequireDefault(_userAddedEvent);
	
	var _shortlistCreatedEvent = __webpack_require__(2132);
	
	var _shortlistCreatedEvent2 = _interopRequireDefault(_shortlistCreatedEvent);
	
	var _acrCampaignScannedEvent = __webpack_require__(2129);
	
	var _acrCampaignScannedEvent2 = _interopRequireDefault(_acrCampaignScannedEvent);
	
	var _withDyzioEventsData = __webpack_require__(284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var feedItemStyles = {
	  borderBottom: '1px dashed #eee'
	};
	
	var feedSummaryStyle = {
	  color: 'rgba(0,0,0, 0.7)'
	};
	
	var iconStyle = {
	  marginTop: 5
	};
	
	var Event = function Event(_ref) {
	  var icon = _ref.icon,
	      color = _ref.color,
	      createdDate = _ref.createdDate,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _semanticUiReact.Feed.Event,
	    { style: feedItemStyles },
	    _react2.default.createElement(
	      _semanticUiReact.Feed.Label,
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { style: iconStyle, name: icon, color: color })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Feed.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Feed.Date,
	        null,
	        createdDate && (0, _moment2.default)(createdDate).fromNow()
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Feed.Summary,
	        { style: feedSummaryStyle },
	        children
	      )
	    )
	  );
	};
	
	Event.propTypes = {
	  icon: _propTypes2.default.string.isRequired,
	  color: _propTypes2.default.string.isRequired,
	  createdDate: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.any.isRequired
	};
	
	var AutoCampaignScanEvent = function AutoCampaignScanEvent(_ref2) {
	  var _ref2$messageData = _ref2.messageData,
	      assetCount = _ref2$messageData.assetCount,
	      hashtags = _ref2$messageData.hashtags,
	      createdDate = _ref2.createdDate;
	
	  var HASHTAG_STYLE = { fontStyle: 'italic', color: 'black' };
	  return _react2.default.createElement(
	    Event,
	    { icon: 'search', color: assetCount ? 'pink' : 'green', createdDate: createdDate },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Scanned for posts containing',
	      _react2.default.createElement(
	        'span',
	        { style: HASHTAG_STYLE },
	        ' ' + hashtags
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Found ',
	      assetCount,
	      ' posts.'
	    )
	  );
	};
	
	var EventFeedItem = function EventFeedItem(_ref3) {
	  var message = _ref3.message,
	      eventName = _ref3.eventName,
	      rest = _objectWithoutProperties(_ref3, ['message', 'eventName']);
	
	  switch (eventName) {
	    case _withDyzioEventsData.EVENT_TYPES.INFLUENCER_CREATED:
	      return _react2.default.createElement(_influencerAddedEvent2.default, rest);
	    case _withDyzioEventsData.EVENT_TYPES.CAMPAIGN_CREATED:
	      return _react2.default.createElement(_campaignCreatedEvent2.default, rest);
	    case _withDyzioEventsData.EVENT_TYPES.USER_CREATED:
	      return _react2.default.createElement(_userAddedEvent2.default, rest);
	    case _withDyzioEventsData.EVENT_TYPES.SHORTLIST_CREATED:
	      return _react2.default.createElement(_shortlistCreatedEvent2.default, rest);
	    case _withDyzioEventsData.EVENT_TYPES.CAMPAIGN_SCANNED:
	      return _react2.default.createElement(_acrCampaignScannedEvent2.default, rest);
	    default:
	  }
	
	  if (message.match(/Campaign was created/)) {
	    return _react2.default.createElement(
	      Event,
	      Object.assign({ color: 'pink', icon: 'sun' }, rest),
	      'Campaign was created'
	    );
	  }
	  if (message.match(/Automated Campaign scan executed/)) {
	    return _react2.default.createElement(AutoCampaignScanEvent, rest);
	  }
	  if (message.match('')) {
	    return null;
	  }
	};
	
	EventFeedItem.propTypes = {
	  messageData: _propTypes2.default.object.isRequired,
	  message: _propTypes2.default.string.isRequired,
	  eventName: _propTypes2.default.string.isRequired,
	  createdDate: _propTypes2.default.string.isRequired
	};
	
	exports.default = EventFeedItem;

/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FeedTypeCards;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _eventSearchInput = __webpack_require__(2137);
	
	var _eventSearchInput2 = _interopRequireDefault(_eventSearchInput);
	
	var _loadingMoreIndicator = __webpack_require__(2138);
	
	var _loadingMoreIndicator2 = _interopRequireDefault(_loadingMoreIndicator);
	
	var _eventCardItem = __webpack_require__(2134);
	
	var _eventCardItem2 = _interopRequireDefault(_eventCardItem);
	
	var _withDyzioEventsData = __webpack_require__(284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var containerCardStyles = {
	  minHeight: 208,
	  maxHeight: 708,
	  width: '100%',
	  overflowY: 'auto'
	};
	
	var emptyStateStyle = {
	  marginTop: 25
	};
	
	var EmptyState = function EmptyState() {
	  return _react2.default.createElement(
	    _semanticUiReact.Header,
	    { icon: true, style: emptyStateStyle },
	    _react2.default.createElement(_semanticUiReact.Icon, { name: 'wait outline' }),
	    'No events yet'
	  );
	};
	
	var eventTypes = [{
	  key: _withDyzioEventsData.EVENT_TYPES.ALL,
	  text: 'all events',
	  value: _withDyzioEventsData.EVENT_TYPES.ALL
	}, {
	  key: _withDyzioEventsData.EVENT_TYPES.USER_CREATED,
	  text: 'user added',
	  value: _withDyzioEventsData.EVENT_TYPES.USER_CREATED
	}, {
	  key: _withDyzioEventsData.EVENT_TYPES.SHORTLIST_CREATED,
	  text: 'shortlist created',
	  value: _withDyzioEventsData.EVENT_TYPES.SHORTLIST_CREATED
	}, {
	  key: _withDyzioEventsData.EVENT_TYPES.INFLUENCER_CREATED,
	  text: 'influencer added',
	  value: _withDyzioEventsData.EVENT_TYPES.INFLUENCER_CREATED
	}, {
	  key: _withDyzioEventsData.EVENT_TYPES.CAMPAIGN_CREATED,
	  text: 'campaign created',
	  value: _withDyzioEventsData.EVENT_TYPES.CAMPAIGN_CREATED
	}];
	
	var descriptionStyle = { color: 'rgba(0,0,0,.4)' };
	var filtersGridStyle = { paddingLeft: 10, paddingRight: 10, paddingBottom: 10 };
	
	function FeedTypeCards(_ref) {
	  var title = _ref.title,
	      isCompact = _ref.isCompact,
	      shouldRenderFilters = _ref.shouldRenderFilters,
	      description = _ref.description,
	      cardColour = _ref.cardColour,
	      onEventTypeFilterChanged = _ref.onEventTypeFilterChanged,
	      onSearch = _ref.onSearch,
	      events = _ref.events,
	      onClearSearch = _ref.onClearSearch,
	      eventTypeFilter = _ref.eventTypeFilter,
	      canLoadMore = _ref.canLoadMore,
	      isLoadingMore = _ref.isLoadingMore,
	      onFeedBodyScroll = _ref.onFeedBodyScroll,
	      noEvents = _ref.noEvents,
	      isLoading = _ref.isLoading;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true, color: cardColour },
	    !isCompact && _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: descriptionStyle },
	          description
	        )
	      )
	    ),
	    shouldRenderFilters && _react2.default.createElement(
	      _semanticUiReact.Grid,
	      { columns: 'two', style: filtersGridStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          null,
	          _react2.default.createElement(_eventSearchInput2.default, {
	            onSearch: onSearch,
	            onClearSearch: onClearSearch
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          null,
	          _react2.default.createElement(_semanticUiReact.Dropdown, {
	            onChange: onEventTypeFilterChanged,
	            placeholder: 'Event type',
	            options: eventTypes,
	            selection: true,
	            fluid: true,
	            value: eventTypeFilter
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      {
	        style: containerCardStyles, onScroll: function onScroll(e) {
	          onFeedBodyScroll({
	            scrollHeight: e.target.scrollHeight,
	            scrollTop: e.target.scrollTop,
	            clientHeight: e.target.clientHeight
	          });
	        }
	      },
	      isLoading && _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: true, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          null,
	          'Loading events...'
	        )
	      ),
	      noEvents && !isLoading && _react2.default.createElement(EmptyState, null),
	      !isLoading && !noEvents && _react2.default.createElement(
	        _semanticUiReact.Feed,
	        null,
	        _lodash2.default.map(events, function (event) {
	          return _react2.default.createElement(_eventCardItem2.default, Object.assign({ key: event.id }, event, { isCompact: isCompact }));
	        })
	      )
	    ),
	    _react2.default.createElement(_loadingMoreIndicator2.default, {
	      canLoadMore: canLoadMore,
	      isLoadingMore: isLoadingMore,
	      shownEventsCount: _lodash2.default.size(events)
	    })
	  );
	}
	
	FeedTypeCards.propTypes = {
	  isCompact: _propTypes2.default.bool,
	  shouldRenderFilters: _propTypes2.default.bool,
	  onEventTypeFilterChanged: _propTypes2.default.func.isRequired,
	  onSearch: _propTypes2.default.func.isRequired,
	  onClearSearch: _propTypes2.default.func.isRequired,
	  eventTypeFilter: _propTypes2.default.oneOf([].concat(_toConsumableArray(_withDyzioEventsData.EVENT_TYPES))).isRequired,
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string.isRequired,
	  cardColour: _propTypes2.default.string.isRequired,
	  events: _propTypes2.default.array.isRequired,
	  canLoadMore: _propTypes2.default.bool.isRequired,
	  isLoadingMore: _propTypes2.default.bool.isRequired,
	  onFeedBodyScroll: _propTypes2.default.func.isRequired,
	  noEvents: _propTypes2.default.bool.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired
	};
	
	FeedTypeCards.defaultProps = {
	  isCompact: true,
	  shouldRenderFilters: false
	};

/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactCsv = __webpack_require__(316);
	
	var _auditLogTableRow = __webpack_require__(859);
	
	var _auditLogTableRow2 = _interopRequireDefault(_auditLogTableRow);
	
	var _collaborationFeedItem = __webpack_require__(1917);
	
	var _collaborationFeedItem2 = _interopRequireDefault(_collaborationFeedItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var tableStyle = {
	  width: '100%'
	};
	
	var downloadCsvLinkStyle = {
	  color: '#c71f7e',
	  border: '1px solid #c71f7e',
	  padding: '5px 15px',
	  borderRadius: 6
	};
	
	var loadingTableRowStyle = {
	  height: 550
	};
	
	var textCenteredStyle = {
	  textAlign: 'center'
	};
	
	var buildCSVData = function buildCSVData(events) {
	  var csvFields = ['time', 'user', 'action', 'assetUrl'];
	  var data = _lodash2.default.map(events, function (event) {
	    return [event.createdDate, event.createdBy, 'added a new asset', event.messageData.resource ? event.messageData.resource.assetURL : '-'];
	  });
	  return [csvFields].concat(_toConsumableArray(data));
	};
	
	var getCSVFileName = function getCSVFileName(csvFileName) {
	  return _lodash2.default.kebabCase(csvFileName) + '-audit-' + (0, _moment2.default)().utc().format() + '.csv';
	};
	
	var EmptyState = function EmptyState() {
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Body,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Row,
	      { style: loadingTableRowStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        { colSpan: 5, style: textCenteredStyle },
	        _react2.default.createElement(
	          _semanticUiReact.Header,
	          { icon: true },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'wait outline', color: 'orange' }),
	          'No events yet'
	        )
	      )
	    )
	  );
	};
	
	var LoadingTableBody = function LoadingTableBody() {
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Body,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Row,
	      { style: loadingTableRowStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Cell,
	        { colSpan: 5 },
	        _react2.default.createElement(_semanticUiReact.Loader, {
	          active: true,
	          content: 'Loading feed...',
	          inline: 'centered'
	        })
	      )
	    )
	  );
	};
	
	var FeedTypeTable = function FeedTypeTable(_ref) {
	  var events = _ref.events,
	      hasExportFeature = _ref.hasExportFeature,
	      csvFileName = _ref.csvFileName,
	      isLoading = _ref.isLoading,
	      isCollaborationMode = _ref.isCollaborationMode;
	
	  var csvData = buildCSVData(events);
	  return _react2.default.createElement(
	    'div',
	    null,
	    hasExportFeature && !isLoading && !_lodash2.default.isEmpty(events) && _react2.default.createElement(
	      _semanticUiReact.Menu,
	      { pointing: true },
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Menu,
	        { position: 'right' },
	        _react2.default.createElement(
	          _semanticUiReact.Menu.Item,
	          null,
	          _react2.default.createElement(
	            _reactCsv.CSVLink,
	            {
	              style: downloadCsvLinkStyle,
	              filename: getCSVFileName(csvFileName),
	              data: csvData
	            },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
	            ' export as csv'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table,
	      { celled: true, style: tableStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Header,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.HeaderCell,
	            null,
	            'Time'
	          ),
	          !isCollaborationMode && _react2.default.createElement(
	            _semanticUiReact.Table.HeaderCell,
	            null,
	            'User'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.HeaderCell,
	            null,
	            'Action'
	          ),
	          !isCollaborationMode && _react2.default.createElement(
	            _semanticUiReact.Table.HeaderCell,
	            null,
	            'Campaign'
	          ),
	          !isCollaborationMode && _react2.default.createElement(
	            _semanticUiReact.Table.HeaderCell,
	            null,
	            'Link'
	          )
	        )
	      ),
	      isLoading && _react2.default.createElement(LoadingTableBody, null),
	      !isLoading && _react2.default.createElement(
	        _semanticUiReact.Table.Body,
	        null,
	        _lodash2.default.map(events, function (event) {
	          return isCollaborationMode ? _react2.default.createElement(_collaborationFeedItem2.default, event) : _react2.default.createElement(_auditLogTableRow2.default, event);
	        })
	      ),
	      !isLoading && _lodash2.default.isEmpty(events) && _react2.default.createElement(EmptyState, null)
	    )
	  );
	};
	
	FeedTypeTable.propTypes = {
	  isLoading: _propTypes2.default.bool.isRequired,
	  events: _propTypes2.default.array.isRequired,
	  hasExportFeature: _propTypes2.default.bool,
	  csvFileName: _propTypes2.default.string,
	  isCollaborationMode: _propTypes2.default.bool
	};
	
	FeedTypeTable.defaultProps = {
	  hasExportFeature: false,
	  isCollaborationMode: false,
	  csvFileName: 'audit'
	};
	
	exports.default = FeedTypeTable;

/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var searchStyle = { height: 37 };
	
	var ENTER_KEY_CODE = 13;
	var BACKSPACE_KEY_CODE = 8;
	
	var EventSearchInput = function (_Component) {
	  _inherits(EventSearchInput, _Component);
	
	  function EventSearchInput(props) {
	    _classCallCheck(this, EventSearchInput);
	
	    var _this = _possibleConstructorReturn(this, (EventSearchInput.__proto__ || Object.getPrototypeOf(EventSearchInput)).call(this, props));
	
	    _this.onChange = function (e, _ref) {
	      var value = _ref.value;
	      return _this.setState({ value: value });
	    };
	
	    _this.onKeyDown = function (event) {
	      var keyCode = event.keyCode;
	
	      if (ENTER_KEY_CODE === keyCode && !_lodash2.default.isEmpty(_this.state.value)) {
	        _this.props.onSearch(_this.state.value);
	      }
	    };
	
	    _this.onKeyUp = function (event) {
	      var keyCode = event.keyCode;
	
	      if (BACKSPACE_KEY_CODE === keyCode && _lodash2.default.isEmpty(_this.state.value)) {
	        _this.props.onClearSearch();
	      }
	    };
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(EventSearchInput, [{
	    key: 'render',
	    value: function render() {
	      var term = this.state.term;
	
	      return _react2.default.createElement(_semanticUiReact.Input, {
	        placeholder: 'Search...',
	        value: term,
	        style: searchStyle,
	        onChange: this.onChange,
	        onKeyDown: this.onKeyDown,
	        onKeyUp: this.onKeyUp
	      });
	    }
	  }]);
	
	  return EventSearchInput;
	}(_react.Component);
	
	exports.default = EventSearchInput;
	
	
	EventSearchInput.propTypes = {
	  onSearch: _propTypes2.default.func.isRequired,
	  onClearSearch: _propTypes2.default.func.isRequired
	};

/***/ },
/* 2138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hintTextStyle = { float: 'left', marginTop: 1 };
	var iconStyle = { float: 'right', marginTop: 1 };
	
	var LoadingMoreIndicator = function LoadingMoreIndicator(_ref) {
	  var shownEventsCount = _ref.shownEventsCount,
	      isLoadingMore = _ref.isLoadingMore,
	      canLoadMore = _ref.canLoadMore;
	  return _react2.default.createElement(
	    _semanticUiReact.Card.Content,
	    { extra: true },
	    _react2.default.createElement(
	      'span',
	      {
	        style: hintTextStyle
	      },
	      'showing ',
	      canLoadMore ? 'last ' + shownEventsCount : 'all',
	      ' events'
	    ),
	    _react2.default.createElement(
	      'span',
	      {
	        style: iconStyle
	      },
	      isLoadingMore && _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle notched', loading: true })
	    )
	  );
	};
	
	LoadingMoreIndicator.propTypes = {
	  shownEventsCount: _propTypes2.default.number.isRequired,
	  isLoadingMore: _propTypes2.default.bool.isRequired,
	  canLoadMore: _propTypes2.default.bool.isRequired
	};
	
	exports.default = LoadingMoreIndicator;

/***/ },
/* 2139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _recompose = __webpack_require__(15);
	
	var _reactRouter = __webpack_require__(37);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _basicHeader = __webpack_require__(860);
	
	var _basicHeader2 = _interopRequireDefault(_basicHeader);
	
	var _dashboardCardGroup = __webpack_require__(1928);
	
	var _dashboardCardGroup2 = _interopRequireDefault(_dashboardCardGroup);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasLocalstorageClient = __webpack_require__(127);
	
	var _hasLocalstorageClient2 = _interopRequireDefault(_hasLocalstorageClient);
	
	var _campaignsTable = __webpack_require__(540);
	
	var _campaignsTable2 = _interopRequireDefault(_campaignsTable);
	
	var _whatsNew = __webpack_require__(2037);
	
	var _whatsNew2 = _interopRequireDefault(_whatsNew);
	
	var _hasOrganisation = __webpack_require__(106);
	
	var _hasOrganisation2 = _interopRequireDefault(_hasOrganisation);
	
	var _newAddCampaignModal = __webpack_require__(550);
	
	var _newAddCampaignModal2 = _interopRequireDefault(_newAddCampaignModal);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _upgradeModal = __webpack_require__(2036);
	
	var _upgradeModal2 = _interopRequireDefault(_upgradeModal);
	
	var _dashboardCampaignsEmptyState = __webpack_require__(1927);
	
	var _dashboardCampaignsEmptyState2 = _interopRequireDefault(_dashboardCampaignsEmptyState);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _createNewCampaign = __webpack_require__(569);
	
	var _createNewCampaign2 = _interopRequireDefault(_createNewCampaign);
	
	var _eventFeed = __webpack_require__(230);
	
	var _eventFeed2 = _interopRequireDefault(_eventFeed);
	
	var _originBasedLock = __webpack_require__(890);
	
	var _originBasedLock2 = _interopRequireDefault(_originBasedLock);
	
	var _organisationBlock = __webpack_require__(2008);
	
	var _organisationBlock2 = _interopRequireDefault(_organisationBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UPGRADE_MODAL_THRESHOLD = 48;
	var KASPERSKY_ORG_ID = 'ec3b6d8e-f9f0-42f4-9c09-294368cbe683';
	var BDSMKTG = '63f49a4d-11bb-4942-9268-952771dedf92';
	
	var TEAM_DYZIO_ID = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';
	var TEAM_TI = '0cc7aa37-af63-4f05-95ac-c42ded273c32';
	var STYLIST = '8fefff6d-345b-4e74-a96f-e90f7b8651ef';
	var IMPERSONATION_ORIGIN = 'https://imp.dyzio.co';
	
	var mustBlockBasedOnOrigin = function mustBlockBasedOnOrigin(_ref) {
	  var requiredOrigin = _ref.requiredOrigin,
	      actualOrigin = _ref.actualOrigin,
	      organisationId = _ref.organisationId,
	      enforceDomainLogin = _ref.enforceDomainLogin;
	
	  var lockedOrgs = [TEAM_TI, STYLIST, BDSMKTG];
	
	  var canBeLocked = _lodash2.default.includes(lockedOrgs, organisationId) && _lodash2.default.isString(requiredOrigin);
	  var mustLock = _lodash2.default.eq(requiredOrigin, actualOrigin) === false;
	  var isImpersonationSite = actualOrigin === IMPERSONATION_ORIGIN;
	  return isImpersonationSite ? false : (enforceDomainLogin || canBeLocked) && mustLock;
	};
	
	var rightTextAlign = {
	  textAlign: 'right'
	};
	
	var HomePage = function (_Component) {
	  _inherits(HomePage, _Component);
	
	  function HomePage(props) {
	    _classCallCheck(this, HomePage);
	
	    var _this = _possibleConstructorReturn(this, (HomePage.__proto__ || Object.getPrototypeOf(HomePage)).call(this, props));
	
	    _this.componentDidMount = function () {
	      if (window.gtag) {
	        window.gtag('event', 'conversion', { send_to: 'AW-933427904/PziqCNz3mIQBEMD1i70D' });
	      }
	      _this.fetchCampaignList();
	      _this.fetchTotals();
	    };
	
	    _this.onArchive = function (id) {
	      var restClient = _this.props.restClient;
	
	      return restClient.patch('/campaignPermission/' + id, {
	        data: {
	          attributes: {
	            status: 'ARCHIVED'
	          }
	        }
	      }).then(function () {
	        return _this.fetchCampaignList();
	      });
	    };
	
	    _this.onAddCampaignSubmit = function (values) {
	      var _this$props = _this.props,
	          jsonAPIClient = _this$props.jsonAPIClient,
	          userInfo = _this$props.userInfo;
	
	
	      return (0, _createNewCampaign2.default)(_extends({}, values, {
	        jsonAPIClient: jsonAPIClient,
	        userInfo: userInfo
	      }));
	    };
	
	    _this.fetchTotals = function () {
	      var _this$props2 = _this.props,
	          campaignAPIClient = _this$props2.campaignAPIClient,
	          _this$props2$userInfo = _this$props2.userInfo,
	          organisationId = _this$props2$userInfo.organisationId,
	          name = _this$props2$userInfo.name,
	          dyzioStorage = _this$props2.dyzioStorage;
	
	      _this.setState({
	        isLoadingTotals: true
	      }, function () {
	        var requests = [campaignAPIClient.get('/summary/influencers?organisationId=' + organisationId), campaignAPIClient.get('/summary/campaigns?organisationId=' + organisationId), campaignAPIClient.get('/summary/team-members?organisationId=' + organisationId), campaignAPIClient.get('/summary/tracked-assets?organisationId=' + organisationId)];
	
	        return Promise.all(requests).then(function (responses) {
	          var values = _lodash2.default.map(responses, 'data.data');
	          console.log(values);
	          var totals = {};
	          _lodash2.default.forEach(values, function (value) {
	            return _lodash2.default.assign(totals, value);
	          });
	          var temporaryBlock = true;
	          var modalShownState = dyzioStorage.get(dyzioStorage.KEYS.UPGRADE_MODAL_KEY);
	          var shouldShowUpgradeModal = _lodash2.default.get(totals, 'totalInfluencers', 0) > UPGRADE_MODAL_THRESHOLD;
	          var willShowModal = !temporaryBlock && !modalShownState.shown && shouldShowUpgradeModal;
	          if (willShowModal) {
	            (0, _errorHandlingService.reportWarning)('Upgrade modal displayed to ' + name + ' from ' + organisationId, 'Upgrade modal');
	          }
	          _this.setState({
	            totals: totals,
	            upgradeModalOpen: willShowModal,
	            isLoadingTotals: false
	          });
	          return {};
	        });
	      });
	    };
	
	    _this.fetchCampaignList = function () {
	      var _this$props3 = _this.props,
	          restClient = _this$props3.restClient,
	          userId = _this$props3.userInfo.userId;
	
	
	      var queryString = encodeURIComponent(JSON.stringify({
	        userId: userId,
	        search: {},
	        sort: {
	          field: 'campaignCreatedDate',
	          order: 'DESC'
	        },
	        perPage: 5
	      }));
	
	      restClient({
	        method: 'get',
	        url: '/campaigns/query?q=' + queryString,
	        baseURL: ("https://dl6gzrmms2.execute-api.eu-west-1.amazonaws.com/production")
	      }).then(function (response) {
	        var data = response.data.data;
	
	        _this.setState({
	          isLoadingCampaigns: false,
	          campaignList: data.data,
	          visibleCampaigns: data.results
	        });
	        return data;
	      }).catch(function () {
	        _this.setState({
	          isLoadingCampaigns: false
	        });
	      });
	    };
	
	    _this.toggleAddCampaignModalState = function () {
	      _this.setState(function (prevState) {
	        return {
	          addCampaignModalOpen: !prevState.addCampaignModalOpen
	        };
	      });
	    };
	
	    _this.toggleUpgradeModalState = function () {
	      var dyzioStorage = _this.props.dyzioStorage;
	
	      dyzioStorage.set(dyzioStorage.KEYS.UPGRADE_MODAL_KEY, { shown: true });
	      _this.setState({
	        upgradeModalOpen: false
	      });
	    };
	
	    _this.state = {
	      addCampaignModalOpen: false,
	      upgradeModalOpen: false,
	      isLoadingCampaigns: true,
	      isLoadingTotals: true,
	      campaignList: []
	    };
	    return _this;
	  }
	
	  _createClass(HomePage, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          user = _props.user,
	          organisation = _props.organisation;
	      var _state = this.state,
	          isLoadingCampaigns = _state.isLoadingCampaigns,
	          campaignList = _state.campaignList,
	          addCampaignModalOpen = _state.addCampaignModalOpen,
	          upgradeModalOpen = _state.upgradeModalOpen,
	          totals = _state.totals,
	          isLoadingTotals = _state.isLoadingTotals,
	          visibleCampaigns = _state.visibleCampaigns;
	
	      var organisationName = user ? user.organisation.name : '';
	
	      var isFullWhiteLabel = _themeSelector2.default.isFullWhiteLabel();
	      var isWhiteLabel = _themeSelector2.default.isWhiteLabel();
	
	      var _window = window,
	          mixpanel = _window.mixpanel;
	
	
	      if (mixpanel && organisationName) {
	        mixpanel.identify(user.id);
	        mixpanel.people.set_once({ organisation: organisationName });
	      }
	
	      var isEmptyState = !isLoadingCampaigns && _lodash2.default.size(campaignList) === 0;
	      var influencersNumbers = _lodash2.default.get(totals, 'totalInfluencers', 0);
	
	      if (!(user && organisation)) return null;
	      var isFeedVisible = true;
	      if (user && organisation) {
	        var isKaspersky = organisation.id === KASPERSKY_ORG_ID;
	        if (isKaspersky) {
	          isFeedVisible = user.isUserSuperAdmin;
	        }
	      }
	
	      var requiredOrigin = _lodash2.default.get(organisation, 'origin', null);
	      var actualOrigin = _lodash2.default.get(window, 'origin');
	      var organisationId = _lodash2.default.get(organisation, 'id', null);
	      var enforceDomainLogin = _lodash2.default.get(organisation, 'enforceDomainLogin', null);
	      var licenseSubscriptionType = _lodash2.default.get(organisation, 'licenseSubscriptionType', null);
	
	      var isBlocked = mustBlockBasedOnOrigin({
	        requiredOrigin: requiredOrigin,
	        actualOrigin: actualOrigin,
	        organisationId: organisationId,
	        enforceDomainLogin: enforceDomainLogin
	      });
	
	      var shouldRenderBlocker = organisationName && isBlocked;
	
	      var lockProps = {
	        requiredOrigin: requiredOrigin,
	        actualOrigin: actualOrigin,
	        organisationName: organisationName
	      };
	
	      var blockProps = {
	        organisationName: organisationName
	      };
	
	      console.log('licenseSubscriptionType', licenseSubscriptionType);
	
	      var islapsed = _lodash2.default.isEqual(_lodash2.default.toLower(licenseSubscriptionType), 'lapsed');
	
	      if (islapsed) {
	        return _react2.default.createElement(_organisationBlock2.default, blockProps);
	      }
	
	      if (shouldRenderBlocker) {
	        return _react2.default.createElement(_originBasedLock2.default, lockProps);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        !isWhiteLabel && _react2.default.createElement(_basicHeader2.default, { title: organisationName }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            { fluid: 'fluid', columns: 2 },
	            !isFullWhiteLabel && _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 16 },
	                _react2.default.createElement(_whatsNew2.default, null)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: isFeedVisible ? 11 : 16 },
	                _react2.default.createElement(_dashboardCardGroup2.default, {
	                  organisation: organisation,
	                  totals: totals,
	                  visibleCampaigns: visibleCampaigns,
	                  isLoadingTotals: isLoadingTotals,
	                  onToggleAddCampaignModalState: this.toggleAddCampaignModalState
	                }),
	                _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                _react2.default.createElement(
	                  'table',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Active Campaigns'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        'p',
	                        { style: { padding: '0px 20px' } },
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { to: '/dashboard' },
	                          'View all active campaigns'
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                !isEmptyState && _react2.default.createElement(
	                  'div',
	                  { style: rightTextAlign },
	                  _react2.default.createElement(_campaignsTable2.default, {
	                    isLoadingCampaigns: isLoadingCampaigns,
	                    records: campaignList,
	                    isCompact: true
	                  })
	                ),
	                isEmptyState && _react2.default.createElement(_dashboardCampaignsEmptyState2.default, null)
	              ),
	              isFeedVisible && _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 5 },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Organisation Activity'
	                  )
	                ),
	                _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                organisation && _react2.default.createElement(_eventFeed2.default, {
	                  title: 'Organisation Activity',
	                  description: 'view the event history for your organisation',
	                  feedType: 'ORGANISATION',
	                  organisationId: organisation.id,
	                  isCompact: true
	                })
	              )
	            )
	          )
	        ),
	        addCampaignModalOpen && _react2.default.createElement(_newAddCampaignModal2.default, {
	          onClose: this.toggleAddCampaignModalState,
	          onAddCampaignSubmit: this.onAddCampaignSubmit,
	          allowCampaignTypeChange: true
	        }),
	        upgradeModalOpen && _react2.default.createElement(_upgradeModal2.default, {
	          value: influencersNumbers,
	          onClose: this.toggleUpgradeModalState
	        })
	      );
	    }
	  }]);
	
	  return HomePage;
	}(_react.Component);
	
	HomePage.propTypes = {
	  user: _propTypes2.default.object
	};
	HomePage.defaultProps = {
	  user: null
	};
	
	
	HomePage.propTypes = {
	  restClient: _propTypes2.default.func.isRequired,
	  campaignAPIClient: _propTypes2.default.object.isRequired,
	  userInfo: _propTypes2.default.object.isRequired,
	  jsonAPIClient: _propTypes2.default.func.isRequired,
	  dyzioStorage: _propTypes2.default.object.isRequired,
	  organisation: _propTypes2.default.object
	};
	
	HomePage.defaultProps = {
	  organisation: null
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return { user: state.user.user };
	};
	
	exports.default = (0, _recompose.compose)(_reactRouter.withRouter, _hasLocalstorageClient2.default, _hasRestClient2.default, _hasOrganisation2.default, (0, _reactRedux.connect)(mapStateToProps))(HomePage);

/***/ },
/* 2140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(3369);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBrowserDetection = __webpack_require__(255);
	
	var _reactBrowserDetection2 = _interopRequireDefault(_reactBrowserDetection);
	
	var _browserHandler = __webpack_require__(231);
	
	var _browserHandler2 = _interopRequireDefault(_browserHandler);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _poweredByDyzio = __webpack_require__(278);
	
	var _poweredByDyzio2 = _interopRequireDefault(_poweredByDyzio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CORQ_DOMAIN = 'data.corq.studio';
	
	var HomePage = function (_React$Component) {
	  _inherits(HomePage, _React$Component);
	
	  function HomePage(props, context) {
	    _classCallCheck(this, HomePage);
	
	    var _this = _possibleConstructorReturn(this, (HomePage.__proto__ || Object.getPrototypeOf(HomePage)).call(this, props, context));
	
	    _this.state = {
	      items: []
	    };
	    return _this;
	  }
	
	  _createClass(HomePage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        items: [{ key: 'a', opacity: 1 }]
	      });
	    }
	  }, {
	    key: 'willEnter',
	    value: function willEnter() {
	      return { opacity: 0 };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var theme = _themeSelector2.default.theme();
	      var isWhiteLabel = _themeSelector2.default.isWhiteLabel();
	      var hostname = window.location.hostname;
	
	      var isDyzio = _lodash2.default.eq(_lodash2.default.get(window, 'origin'), 'https://app.dyzio.co');
	
	      var isCORQ = hostname === CORQ_DOMAIN;
	
	      var imageStyle = theme.darkLogo.size ? { height: theme.darkLogo.size } : null;
	
	      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !isDyzio;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-centered' },
	        _react2.default.createElement(
	          'div',
	          { className: 'center-outer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'center-inner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'center-logo' },
	              _react2.default.createElement('img', { src: theme.darkLogo.src, alt: theme.darkLogo.alt, style: imageStyle })
	            ),
	            _react2.default.createElement(
	              _reactBrowserDetection2.default,
	              null,
	              _browserHandler2.default.safariHandle
	            ),
	            isCORQ ? _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { placeholder: true, textAlign: 'center' },
	              _react2.default.createElement(
	                _semanticUiReact.Header,
	                { icon: true },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock' }),
	                'You have been logged out...'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Head back to ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://test.corq.studio' },
	                  'CORQ Studio'
	                ),
	                ' to log in.'
	              )
	            ) : _react2.default.createElement(
	              _reactMotion.TransitionMotion,
	              {
	                willEnter: this.willEnter,
	                defaultStyles: this.state.items.map(function (item) {
	                  return { key: item.key, style: { opacity: 0 } };
	                }),
	                styles: this.state.items.map(function (item) {
	                  return {
	                    key: item.key,
	                    style: { opacity: (0, _reactMotion.spring)(item.opacity, { stiffness: 240, damping: 40 }) }
	                  };
	                })
	              },
	              function (interpolatedStyles) {
	                return _react2.default.createElement(
	                  'div',
	                  null,
	                  interpolatedStyles.map(function (config) {
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'center-content', key: config.key, style: _extends({}, config.style) },
	                      _react2.default.createElement(
	                        'button',
	                        { disabled: isSafari, className: 'large rose stretch', onClick: function onClick() {
	                            return _this2.context.router.push('/login');
	                          } },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'Log In'
	                        )
	                      ),
	                      !theme.hideSignup && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'option-separator' },
	                          _react2.default.createElement('div', { className: 'left' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'center' },
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              'OR'
	                            )
	                          ),
	                          _react2.default.createElement('div', { className: 'right' })
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          { disabled: isSafari, className: 'large rose stretch', onClick: function onClick() {
	                              return _this2.context.router.push('/company/signup');
	                            } },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Sign Up'
	                          )
	                        )
	                      )
	                    );
	                  })
	                );
	              }
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'browser-detect' },
	              _react2.default.createElement(_poweredByDyzio2.default, null),
	              _react2.default.createElement(
	                _reactBrowserDetection2.default,
	                null,
	                _browserHandler2.default.handle
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HomePage;
	}(_react2.default.Component);
	
	HomePage.contextTypes = {
	  router: _react.PropTypes.object
	};
	exports.default = HomePage;

/***/ },
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioIcons = __webpack_require__(92);
	
	var _authService = __webpack_require__(21);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _instagramAuthModal = __webpack_require__(1989);
	
	var _instagramAuthModal2 = _interopRequireDefault(_instagramAuthModal);
	
	var _authorisationButton = __webpack_require__(538);
	
	var _authorisationButton2 = _interopRequireDefault(_authorisationButton);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var THEME = _themeSelector2.default.theme();
	
	var cf = function cf(num) {
	  return num ? (0, _numeral2.default)(num).format('0,0') : '-';
	};
	
	var FACEBOOK_OPTIONS = {
	  clientId: '307083449705342'
	};
	
	var getFacebookOptions = function getFacebookOptions() {
	  var clientId = THEME.facebookClientId;
	  return clientId ? { clientId: clientId } : FACEBOOK_OPTIONS;
	};
	
	var facebookCallbackUrl = 'https://uiqcrs8dhb.execute-api.eu-west-1.amazonaws.com/production/callback/facebook';
	
	var AuthorisationStatus = function AuthorisationStatus(_ref) {
	  var platform = _ref.platform,
	      accessTokens = _ref.accessTokens;
	
	  var isAuthorised = accessTokens && accessTokens[platform];
	  if (isAuthorised) {
	    return _react2.default.createElement(_semanticUiReact.Popup, { trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'check', color: 'green', size: 'big' }), content: 'channel authorised!' });
	  }
	  return _react2.default.createElement(_semanticUiReact.Popup, { trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'x', color: 'grey', size: 'big' }), content: 'not authorised' });
	};
	
	var getHandle = function getHandle(influencer, platform) {
	  var handle = influencer[platform];
	  if (!handle) return '-';
	  return platform === 'youtube' ? influencer.youtubeChannelTitle : influencer[platform];
	};
	
	var isTokenMatch = function isTokenMatch(_ref2) {
	  var token = _ref2.token,
	      username = _ref2.username,
	      platform = _ref2.platform;
	
	  var usernameRegExp = new RegExp(username, 'i');
	  var safePlatform = _lodash2.default.toUpper(platform);
	  return token.username.match(usernameRegExp) && token.platform === safePlatform;
	};
	
	var PlatformIcons = {
	  youtube: _react2.default.createElement(_dyzioIcons.YoutubeIcon, { size: 'big' }),
	  instagram: _react2.default.createElement(_dyzioIcons.InstagramIcon, { size: 'big' }),
	  facebook: _react2.default.createElement(_dyzioIcons.FacebookIcon, { size: 'big' })
	};
	
	var AuthRow = function AuthRow(_ref3) {
	  var influencer = _ref3.influencer,
	      platform = _ref3.platform,
	      handleAuthClick = _ref3.handleAuthClick,
	      _handleRemoveClick = _ref3.handleRemoveClick,
	      tokens = _ref3.tokens;
	
	  if (!influencer[platform]) return null; // do not render a row if there is no handle for the platform
	
	  var username = influencer[platform];
	
	  var accessTokens = influencer.accessTokens;
	
	  var tokenExists = accessTokens && accessTokens[platform];
	  var isAuthorised = false;
	
	  if (_lodash2.default.find(tokens, function (token) {
	    return isTokenMatch({ token: token, username: username, platform: platform });
	  })) {
	    console.log('found the token');
	    isAuthorised = true;
	  }
	
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    { key: platform },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      PlatformIcons[platform]
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      getHandle(influencer, platform)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      cf(influencer[platform + 'Count']),
	      '\xA0\xA0',
	      platform === 'instagram' && _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'briefcase', color: influencer.instagramBusinessAccount ? 'pink' : 'grey', size: 'large' }),
	        content: (influencer.instagramBusinessAccount ? '' : 'NOT an ') + 'Instagram Business Account'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_authorisationButton2.default, {
	        platform: platform,
	        disabled: !_lodash2.default.isString(influencer[platform]),
	        accessTokens: influencer.accessTokens,
	        handleAuthClick: handleAuthClick,
	        handleRemoveClick: function handleRemoveClick() {
	          return _handleRemoveClick(influencer.id, platform);
	        }
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(AuthorisationStatus, { platform: platform, accessTokens: influencer.accessTokens })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      tokenExists && isAuthorised && _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'smile', size: 'big', color: 'green' }),
	        content: 'Authorisation succeeded for ' + getHandle(influencer, platform) + ' on ' + _lodash2.default.toUpper(platform) + '.'
	      }),
	      tokenExists && !isAuthorised && _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'frown', size: 'big', color: 'orange' }),
	        content: 'Authorisation failed for ' + getHandle(influencer, platform) + ' on ' + _lodash2.default.toUpper(platform) + '.'
	      })
	    )
	  );
	};
	
	var InfluencerAuthorisation = function (_React$Component) {
	  _inherits(InfluencerAuthorisation, _React$Component);
	
	  function InfluencerAuthorisation() {
	    _classCallCheck(this, InfluencerAuthorisation);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerAuthorisation.__proto__ || Object.getPrototypeOf(InfluencerAuthorisation)).call(this));
	
	    _this.loadTokens = function (influencerId) {
	      // todo create proxyServerClient
	      var tokenUrl = 'https://1nfoz04muh.execute-api.eu-west-1.amazonaws.com/production/tokens/' + influencerId;
	      return _axios2.default.get(tokenUrl).then(function (response) {
	        var tokens = response.data.data.tokens;
	
	        console.log(tokens);
	        return tokens;
	      }).catch(function (e) {
	        console.log(e);
	      });
	    };
	
	    _this.loadInfluencer = function (organisationId) {
	      var jsonAPIClient = _this.props.jsonAPIClient;
	
	      jsonAPIClient.get('organisations', organisationId, { include: ['influencer'] }).then(function (organisation) {
	        return organisation.toJSONTree();
	      }).then(function (org) {
	        _this.loadTokens(org.influencer.id).then(function (tokens) {
	          _this.setState({
	            influencer: org.influencer,
	            loading: false,
	            tokens: tokens
	          });
	        });
	      }).catch(function (e) {
	        console.log(e);
	      });
	    };
	
	    _this.authoriseInstagram = function () {
	      var instagramScopes = ['manage_pages', 'instagram_manage_insights', 'instagram_basic'];
	      _this.authorise('instagram', instagramScopes);
	    };
	
	    _this.removeAuthorisation = function (influencerId, platform) {
	      var dto = {
	        data: {
	          influencerId: influencerId,
	          platform: platform
	        }
	      };
	
	      _axios2.default.post('https://uiqcrs8dhb.execute-api.eu-west-1.amazonaws.com/production/auth/remove', dto).then(function (response) {
	        var updatedInfluencer = response.data.data;
	        updatedInfluencer.id = influencerId;
	        console.log(updatedInfluencer);
	        _this.setState({
	          influencer: updatedInfluencer
	        });
	      }).catch(function (err) {
	        return console.log(err);
	      });
	    };
	
	    _this.authorise = function (platform, scopeList) {
	      var isInstagram = platform === 'instagram';
	      var influencer = _this.state.influencer;
	      var _window$location = window.location,
	          hostname = _window$location.hostname,
	          origin = _window$location.origin;
	
	      var windowLocation = window.location.href;
	      var influencerId = influencer.id;
	      var callbackURL = isInstagram ? origin + '/token/generate' : windowLocation;
	      var scopes = _lodash2.default.join(scopeList, ',');
	      var version = 2;
	
	      var state = encodeURIComponent(JSON.stringify({
	        influencerId: influencerId,
	        callbackURL: callbackURL,
	        platform: platform,
	        hostname: hostname,
	        version: version
	      }));
	
	      var facebookOptions = getFacebookOptions();
	      console.log('Facebook Opts => ' + JSON.stringify(facebookOptions, null, 2));
	      var opts = ['https://www.facebook.com/v2.11/dialog/oauth', '?client_id=' + facebookOptions.clientId, '&response_type=code', '&redirect_uri=' + facebookCallbackUrl, '&scope=' + scopes, '&auth_type=rerequest', '&state=' + state];
	      window.location.href = _lodash2.default.join(opts, '');
	    };
	
	    _this.authoriseFacebook = function () {
	      var facebookScopes = ['manage_pages', 'read_insights'];
	      _this.authorise('facebook', facebookScopes);
	    };
	
	    _this.authoriseYoutube = function () {
	      var influencer = _this.state.influencer;
	
	      var windowLocation = window.location.href;
	
	      _axios2.default.post('https://uiqcrs8dhb.execute-api.eu-west-1.amazonaws.com/production/oauth/youtube/url', {
	        data: {
	          influencerId: influencer.id,
	          callbackURL: windowLocation
	        }
	      }).then(function (r) {
	        window.location.href = r.data.headers.Location;
	      });
	    };
	
	    _this.triggerInstagramAuthorisationModal = function () {
	      return _this.setState({
	        instagramAuthModalVisible: !_this.state.instagramAuthModalVisible
	      });
	    };
	
	    _this.state = {
	      loading: true,
	      instagramAuthModalVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(InfluencerAuthorisation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _authService$getProfi = _authService.authService.getProfile(),
	          organisationId = _authService$getProfi.app_metadata.dyzio.o_id;
	
	      this.loadInfluencer(organisationId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loading = _state.loading,
	          influencer = _state.influencer,
	          tokens = _state.tokens,
	          instagramAuthModalVisible = _state.instagramAuthModalVisible;
	
	
	      var authChannels = [{
	        platform: 'youtube',
	        onAuthClick: this.authoriseYoutube
	      }, {
	        platform: 'instagram',
	        onAuthClick: this.triggerInstagramAuthorisationModal
	      }, {
	        platform: 'facebook',
	        onAuthClick: this.authoriseFacebook
	      }];
	
	      var isAuthorised = false;
	
	      console.log(tokens);
	
	      var isVoxogram = window.location.hostname === 'app.voxogram.com';
	      var platformName = isVoxogram ? 'voxogram' : 'dyzio';
	
	      if (influencer) {
	        var accessTokens = influencer.accessTokens;
	
	        _lodash2.default.forEach(authChannels, function (chan) {
	          var username = influencer[chan.platform];
	          var findParams = { username: username, platform: _lodash2.default.toUpper(chan.platform) };
	          console.log(findParams);
	          if (_lodash2.default.find(tokens, findParams)) {
	            console.log('found the token');
	            isAuthorised = true;
	          }
	          // if (accessTokens && accessTokens[chan.platform])
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { style: { height: 140, backgroundColor: '#FFF', borderBottom: '1px solid #EEE' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'page-hero' },
	            _react2.default.createElement(
	              'h1',
	              { style: { paddingTop: 40 } },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'orange' }),
	              'Authorisation'
	            ),
	            _react2.default.createElement(
	              'h4',
	              { className: 'light' },
	              'Authorise your social media channels'
	            ),
	            !isVoxogram && _react2.default.createElement(
	              'p',
	              { style: { textAlign: 'right ' } },
	              'for help click here \xA0',
	              _react2.default.createElement(
	                _targetLink2.default,
	                {
	                  renderIf: true,
	                  href: 'https://help.dyzio.co/influencer-authentication/authorising-your-social-channels-to-dyzio'
	                },
	                'Influencer Authorisation',
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'help' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'page-content' },
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { loading: loading, basic: 'very', style: { padding: 0 } },
	              influencer && _react2.default.createElement(
	                _semanticUiReact.Segment,
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Use the buttons below to grant and remove authorisation to your social channels. You can remove the access by clicking the button again.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'When your channel is authorised the ',
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'x', color: 'grey' }),
	                  ' will turn to a ',
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'check', color: 'green' }),
	                  '.'
	                ),
	                _react2.default.createElement(_semanticUiReact.Divider, null),
	                _react2.default.createElement(_semanticUiReact.Message, {
	                  info: true,
	                  icon: 'shield',
	                  header: platformName + ' only ever requests READ ACCESS to your social channels. We CANNOT edit, post or delete anything.',
	                  content: _react2.default.createElement(
	                    'p',
	                    null,
	                    'This allows us to request insights data (e.g. reach, impressions) from the platform and share it with your client.'
	                  )
	                }),
	                _react2.default.createElement(_semanticUiReact.Divider, null),
	                _react2.default.createElement(_semanticUiReact.Message, {
	                  warning: true,
	                  icon: 'instagram',
	                  header: 'Instagram requirements.',
	                  content: _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      'Please make sure your Facebook account is set up properly (it must be confirmed).'
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      'Please also make sure your Instagram account is linked to your main Facebook page.'
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      'You must have either an Instagram\xA0',
	                      _react2.default.createElement(
	                        _targetLink2.default,
	                        {
	                          renderIf: true,
	                          href: 'https://business.instagram.com/getting-started'
	                        },
	                        'Business Account'
	                      ),
	                      '\xA0or a\xA0',
	                      _react2.default.createElement(
	                        _targetLink2.default,
	                        {
	                          renderIf: true,
	                          href: 'https://help.instagram.com/2358103564437429'
	                        },
	                        'Creator Account'
	                      ),
	                      '.'
	                    )
	                  )
	                }),
	                _react2.default.createElement(_semanticUiReact.Divider, null),
	                _react2.default.createElement(
	                  _semanticUiReact.Table,
	                  { celled: true, textAlign: 'center', fixed: true },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Header,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        { width: 2 },
	                        'Platform'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        { width: 3 },
	                        'Handle'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        { width: 3 },
	                        'Followers'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        { width: 4 },
	                        'Authorise'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        { width: 2 },
	                        'Token Saved'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.HeaderCell,
	                        { width: 2 },
	                        'Token Status'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Body,
	                    null,
	                    _lodash2.default.map(authChannels, function (chan) {
	                      return _react2.default.createElement(AuthRow, {
	                        influencer: influencer,
	                        platform: chan.platform,
	                        handleAuthClick: chan.onAuthClick,
	                        handleRemoveClick: _this2.removeAuthorisation,
	                        tokens: tokens
	                      });
	                    })
	                  )
	                ),
	                isAuthorised && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Divider, null),
	                  _react2.default.createElement(_semanticUiReact.Message, {
	                    positive: true,
	                    icon: 'smile outline',
	                    header: 'Thanks for authorising your channel!',
	                    content: platformName + ' will process your token now and check that it works. We may need to contact you if there has been a problem. Please DO NOT revoke access until the campaign has finished.'
	                  })
	                )
	              )
	            )
	          )
	        ),
	        instagramAuthModalVisible && _react2.default.createElement(_instagramAuthModal2.default, {
	          onClose: this.triggerInstagramAuthorisationModal,
	          onContinueButtonClick: this.authoriseInstagram
	        })
	      );
	    }
	  }]);
	
	  return InfluencerAuthorisation;
	}(_react2.default.Component);
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasJsonapiClient2.default)(InfluencerAuthorisation);

/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _instagramStoryMenu = __webpack_require__(2563);
	
	var _instagramStoryMenu2 = _interopRequireDefault(_instagramStoryMenu);
	
	var _instagramStories = __webpack_require__(2562);
	
	var _instagramStories2 = _interopRequireDefault(_instagramStories);
	
	var _pagination = __webpack_require__(147);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESULTS_PER_PAGE = 5;
	
	var InstagramStoriesTab = function (_Component) {
	  _inherits(InstagramStoriesTab, _Component);
	
	  function InstagramStoriesTab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InstagramStoriesTab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InstagramStoriesTab.__proto__ || Object.getPrototypeOf(InstagramStoriesTab)).call.apply(_ref, [this].concat(args))), _this), _this.onPageIncrement = function () {
	      var _this$state = _this.state,
	          currentPage = _this$state.currentPage,
	          totalPages = _this$state.totalPages;
	
	      if (currentPage === totalPages) return;
	      _this.setState({
	        currentPage: currentPage + 1
	      }, _this.getStories);
	    }, _this.onPageDecrement = function () {
	      var currentPage = _this.state.currentPage;
	
	      if (currentPage === 1) return;
	      _this.setState({
	        currentPage: currentPage - 1
	      }, _this.getStories);
	    }, _this.onSearch = function (newSearch) {
	      _this.setState({
	        searchTerm: newSearch,
	        currentPage: 1
	      }, _this.getStories);
	    }, _this.getCampaigns = function () {
	      var _this$props = _this.props,
	          jsonAPIClient = _this$props.jsonAPIClient,
	          userInfo = _this$props.userInfo;
	      var userId = userInfo.userId;
	
	
	      jsonAPIClient.find('campaignPermission', { filter: { user: userId }, include: ['campaign'], sort: '-createdDate' }).then(function (permissions) {
	        var campaignList = _lodash2.default.map(permissions, function (p) {
	          var campaign = p.toJSONTree().campaign;
	          return {
	            key: campaign.id,
	            text: campaign.name,
	            value: campaign.id
	          };
	        });
	        // console.log(JSON.stringify(campaignList, null, 2));
	        _this.setState({
	          campaignList: campaignList
	        });
	      });
	    }, _this.handleAddStoryToCampaign = function (_ref2) {
	      var storyId = _ref2.storyId,
	          selectedCampaignId = _ref2.selectedCampaignId;
	
	      console.log('patch story ' + storyId + ' with C: ' + selectedCampaignId);
	      var restClient = _this.props.restClient;
	
	      var patch = {
	        data: {
	          attributes: {
	            campaign: {
	              type: 'campaigns',
	              id: selectedCampaignId
	            }
	          }
	        }
	      };
	      restClient.patch('/stories/' + storyId, patch).then(function () {
	        console.log('patched real good');
	        _this.getStories();
	      });
	    }, _this.getStoryUrl = function (_ref3) {
	      var username = _ref3.username,
	          searchFilter = _ref3.searchFilter,
	          offset = _ref3.offset;
	
	      var url = '/stories?' + ('filter[username]=' + username) + ('&' + searchFilter) + '&sort=-publishedDate' + ('&page[limit]=' + RESULTS_PER_PAGE + '&page[offset]=' + offset) + '&include=campaign';
	
	      return url;
	    }, _this.getStoryData = function (_ref4) {
	      var sortedData = _ref4.sortedData,
	          included = _ref4.included;
	      return _lodash2.default.map(sortedData, function (d) {
	        var includedCampaign = d.relationships.campaign.data;
	
	        var campaign = void 0;
	        if (includedCampaign) {
	          var c = _lodash2.default.find(included, { id: includedCampaign.id });
	          campaign = {
	            id: c.id,
	            name: c.attributes.name
	          };
	        }
	
	        return _extends({
	          id: d.id
	        }, d.attributes, {
	          campaign: campaign
	        });
	      });
	    }, _this.getStories = function () {
	      var _this$props2 = _this.props,
	          influencer = _this$props2.influencer,
	          restClient = _this$props2.restClient;
	      var _this$state2 = _this.state,
	          currentPage = _this$state2.currentPage,
	          searchTerm = _this$state2.searchTerm;
	
	      var username = influencer.instagram;
	      _this.setState({
	        isLoading: true,
	        storyData: []
	      }, function () {
	        var offset = (currentPage - 1) * RESULTS_PER_PAGE;
	        var searchFilter = searchTerm === '' ? '' : 'filter[caption]=:' + searchTerm;
	
	        // TODO - get campaign name into this list of stories
	        var storyUrl = _this.getStoryUrl({ username: username, searchFilter: searchFilter, offset: offset });
	
	        restClient.get(storyUrl).then(function (response) {
	          var _response$data = response.data,
	              data = _response$data.data,
	              meta = _response$data.meta,
	              included = _response$data.included;
	
	          console.log(included);
	          var sortedData = _lodash2.default.orderBy(data, 'attributes.publishedDate', 'desc');
	
	          var storyData = _this.getStoryData({ sortedData: sortedData, included: included });
	          _this.setState({
	            isLoading: false,
	            hasFailed: false,
	            totalPages: Math.ceil(meta.page.total / RESULTS_PER_PAGE),
	            storyData: storyData
	          });
	        }).catch(function () {
	          _this.setState({
	            isLoading: false,
	            hasFailed: true,
	            storyData: [],
	            totalPages: 1
	          });
	        });
	      });
	    }, _this.getEmptyMessageText = function () {
	      var influencer = _this.props.influencer;
	      var searchTerm = _this.state.searchTerm;
	
	      var username = influencer.instagram;
	      return searchTerm ? 'No search results for "' + searchTerm + '"' : 'Dyzio is not capturing stories for ' + username;
	    }, _this.handleChange = function (e, _ref5) {
	      var name = _ref5.name,
	          value = _ref5.value;
	      return _this.setState(_defineProperty({}, name, value));
	    }, _this.handleSubmit = function () {
	      return _this.setState({ email: '', name: '' });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InstagramStoriesTab, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        currentPage: 1,
	        totalPages: 1,
	        storyData: [],
	        searchTerm: '',
	        loading: true
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getStories();
	      this.getCampaigns();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          totalPages = _state.totalPages,
	          storyData = _state.storyData,
	          isLoading = _state.isLoading,
	          campaignList = _state.campaignList;
	
	      var footerStyle = { minHeight: '5em', marginBottom: '5em' };
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-content' },
	        _react2.default.createElement(_instagramStoryMenu2.default, {
	          currentPage: currentPage,
	          totalPages: totalPages,
	          onPageIncrement: this.onPageIncrement,
	          onPageDecrement: this.onPageDecrement,
	          onSearch: this.onSearch,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_instagramStories2.default, {
	          stories: storyData,
	          isLoading: isLoading,
	          emptyMessageText: this.getEmptyMessageText(),
	          campaignList: campaignList,
	          onCampaignSelected: this.handleAddStoryToCampaign
	        }),
	        isLoading || storyData.length === 0 ? _react2.default.createElement('span', null) : _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { style: footerStyle },
	          _react2.default.createElement(_pagination2.default, {
	            currentPage: currentPage,
	            totalPages: totalPages,
	            onPageIncrement: this.onPageIncrement,
	            onPageDecrement: this.onPageDecrement
	          })
	        )
	      );
	    }
	  }]);
	
	  return InstagramStoriesTab;
	}(_react.Component);
	
	InstagramStoriesTab.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  restClient: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasJsonapiClient2.default, _hasUserInfo2.default)(InstagramStoriesTab);

/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _influencerContextBar = __webpack_require__(193);
	
	var _influencerContextBar2 = _interopRequireDefault(_influencerContextBar);
	
	var _influencerInfoBar = __webpack_require__(1967);
	
	var _influencerInfoBar2 = _interopRequireDefault(_influencerInfoBar);
	
	var _audienceDataRequestModal = __webpack_require__(1891);
	
	var _audienceDataRequestModal2 = _interopRequireDefault(_audienceDataRequestModal);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _resources = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AUDIENCE_TYPE = 'AUDIENCE';
	var STATUS_PENDING = 'PENDING';
	
	var InfluencerPage = function (_Component) {
	  _inherits(InfluencerPage, _Component);
	
	  function InfluencerPage(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, InfluencerPage);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerPage.__proto__ || Object.getPrototypeOf(InfluencerPage)).call(this, props));
	
	    _this.reloadDetails = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var jsonAPIClient, influencerDetails, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              jsonAPIClient = _this.props.jsonAPIClient;
	              influencerDetails = _this.state.influencerDetails;
	              _context.next = 4;
	              return jsonAPIClient.get('influencerDetails', influencerDetails.id, {
	                include: ['tags']
	              });
	
	            case 4:
	              response = _context.sent;
	
	              _this.setState({
	                influencerDetails: response.toJSONTree()
	              });
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.onADRModalStateChanged = function () {
	      _this.setState(function (prevState) {
	        return {
	          adrModalOpen: !prevState.adrModalOpen
	        };
	      });
	    };
	
	    _this.onADRPlatformSelected = function (event, _ref2) {
	      var name = _ref2.name,
	          checked = _ref2.checked;
	      var selectedPlatforms = _this.state.selectedPlatforms;
	
	      var platforms = _lodash2.default.clone(selectedPlatforms);
	      if (!checked && _lodash2.default.includes(platforms, name)) {
	        platforms = _lodash2.default.filter(platforms, function (platform) {
	          return platform !== name;
	        });
	      } else {
	        platforms.push(name);
	      }
	      _this.setState({
	        selectedPlatforms: platforms
	      });
	    };
	
	    _this.onSendADRRequestButtonClick = function () {
	      var _this$state = _this.state,
	          selectedPlatforms = _this$state.selectedPlatforms,
	          influencer = _this$state.influencer;
	      var _this$props = _this.props,
	          jsonAPIClient = _this$props.jsonAPIClient,
	          organisationId = _this$props.userInfo.organisationId;
	
	      var channels = _lodash2.default.map(selectedPlatforms, function (platform) {
	        return {
	          channel: platform,
	          handle: _lodash2.default.get(influencer, platform)
	        };
	      });
	      var dataRequest = jsonAPIClient.create(_resources.DATA_REQUESTS_RESOURCE);
	      dataRequest.set('requestType', AUDIENCE_TYPE);
	      dataRequest.set('requestStatus', STATUS_PENDING);
	      dataRequest.set('influencer', {
	        type: _resources.INFLUENCER_RESOURCE,
	        id: influencer.id
	      });
	      dataRequest.set('agency', {
	        type: _resources.ORGANISATION_RESOURCE,
	        id: organisationId
	      });
	      dataRequest.set('channels', channels);
	      dataRequest.sync().then(function () {
	        _this.setState({
	          adrModalOpen: false,
	          selectedPlatforms: []
	        });
	      });
	    };
	
	    _this.requestADRPermission = function () {
	      var _this$props2 = _this.props,
	          jsonAPIClient = _this$props2.jsonAPIClient,
	          organisationId = _this$props2.userInfo.organisationId;
	      var influencerId = _this.state.influencer.id;
	
	      jsonAPIClient.find(_resources.DATA_REQUESTS_RESOURCE, { // eslint-disable-line lodash/prefer-lodash-method
	        filter: {
	          agency: organisationId,
	          influencer: influencerId
	        }
	      }).then(function (response) {
	        var permission = response.length > 0 && _lodash2.default.head(response);
	        if (permission) {
	          _this.setState({
	            dataPermission: permission.toJSON(),
	            isLoadingPermission: false
	          });
	        } else {
	          _this.setState({
	            isLoadingPermission: false
	          });
	        }
	      }).catch(function () {
	        _this.setState({
	          isLoadingPermission: false
	        });
	      });
	    };
	
	    _this.leftButtonCallback = function () {
	      return _this.context.router.push('/dashboard');
	    };
	
	    _this.rightButtonCallback = function () {
	      return _this.context.router.push('/influencer/add');
	    };
	
	    _this.state = {
	      influencer: null,
	      influencerDetails: null,
	      isLoaded: false,
	      isLoading: true,
	      isError: false,
	      adrModalOpen: false,
	      selectedPlatforms: [],
	      dataPermission: null,
	      isLoadingPermission: true
	    };
	    return _this;
	  }
	
	  _createClass(InfluencerPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var _props = this.props,
	          params = _props.params,
	          jsonAPIClient = _props.jsonAPIClient;
	
	
	      var resourcesToLoad = ['organisation', 'influencer', 'influencer.telegramChannels', 'influencer.telegramUser', 'influencerDetails', 'influencer.statistics', 'influencerDetails.tags', 'influencerDetails.businessUnits'];
	
	      jsonAPIClient.get('influencerLink', params.id, {
	        include: resourcesToLoad
	      }).then(function (response) {
	        var resource = response.toJSONTree();
	        _this3.setState({
	          organisation: resource.organisation,
	          influencer: resource.influencer,
	          influencerDetails: resource.influencerDetails,
	          isLoaded: true,
	          isLoading: false,
	          isError: false
	        }, _this3.requestADRPermission);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          influencer = _state.influencer,
	          influencerDetails = _state.influencerDetails,
	          isLoaded = _state.isLoaded,
	          adrModalOpen = _state.adrModalOpen,
	          isLoadingPermission = _state.isLoadingPermission,
	          dataPermission = _state.dataPermission,
	          organisation = _state.organisation;
	      var _props2 = this.props,
	          children = _props2.children,
	          id = _props2.params.id,
	          _props2$userInfo = _props2.userInfo,
	          role = _props2$userInfo.role,
	          organisationId = _props2$userInfo.organisationId;
	
	      var isInfluencer = role === 'INFLUENCER';
	      var otherProps = {
	        onReloadDetails: this.reloadDetails
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_influencerContextBar2.default, {
	          rightButtonCallback: this.rightButtonCallback,
	          leftButtonCallback: this.leftButtonCallback,
	          leftButtonLabel: 'Create A Campaign',
	          rightButtonLabel: 'Add An Influencer',
	          title: 'Back'
	        }),
	        influencer && isLoaded && _react2.default.createElement(_influencerInfoBar2.default, {
	          influencer: influencer,
	          influencerDetails: influencerDetails,
	          withBlogosphereTab: influencerDetails.blogosphereData,
	          onADRModalStateChanged: this.onADRModalStateChanged,
	          id: id,
	          isLoadingPermission: isLoadingPermission,
	          dataPermission: dataPermission,
	          organisationId: organisationId,
	          organisation: organisation
	        }),
	        adrModalOpen && !isInfluencer && _react2.default.createElement(_audienceDataRequestModal2.default, {
	          onClose: this.onADRModalStateChanged,
	          onPlatformSelected: this.onADRPlatformSelected,
	          onSendADRRequestButtonClick: this.onSendADRRequestButtonClick,
	          influencer: influencer
	        }),
	        influencer && isLoaded && children && _react2.default.cloneElement(children, this.state, _extends({}, otherProps, this.props))
	      );
	    }
	  }]);
	
	  return InfluencerPage;
	}(_react.Component);
	
	InfluencerPage.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	InfluencerPage.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  jsonAPIClient: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.any.isRequired,
	  userInfo: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasJsonapiClient2.default, _hasUserInfo2.default)(InfluencerPage);

/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _resources = __webpack_require__(171);
	
	var _influencerRatesTable = __webpack_require__(1977);
	
	var _influencerRatesTable2 = _interopRequireDefault(_influencerRatesTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfluencerPostRates = function (_Component) {
	  _inherits(InfluencerPostRates, _Component);
	
	  function InfluencerPostRates() {
	    _classCallCheck(this, InfluencerPostRates);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerPostRates.__proto__ || Object.getPrototypeOf(InfluencerPostRates)).call(this));
	
	    _this.componentWillMount = function () {
	      var _this$props = _this.props,
	          organisationId = _this$props.userInfo.organisationId,
	          restClient = _this$props.restClient;
	
	
	      _this.setState({
	        loading: true
	      });
	      restClient.get('organisations/' + organisationId).then(function (organisationResource) {
	        var attributes = organisationResource.data.data.attributes;
	
	        return _this.setState({ organisation: attributes, loading: false });
	      }).catch(function (err) {
	        _this.setState({
	          loading: false,
	          error: err
	        });
	      });
	    };
	
	    _this.handleSave = function (data) {
	      var facebook = data.facebook,
	          instagram = data.instagram,
	          twitter = data.twitter,
	          youtube = data.youtube,
	          tiktok = data.tiktok,
	          twitch = data.twitch,
	          snapchat = data.snapchat,
	          telegram = data.telegram,
	          facebookRates = data.facebookRates,
	          instagramRates = data.instagramRates,
	          twitterRates = data.twitterRates,
	          youtubeRates = data.youtubeRates,
	          tiktokRates = data.tiktokRates,
	          twitchRates = data.twitchRates,
	          snapchatRates = data.snapchatRates,
	          telegramRates = data.telegramRates,
	          othersRates = data.othersRates;
	
	      var influencerPatch = _this.patchInfluencer({
	        facebook: facebook,
	        instagram: instagram,
	        twitter: twitter,
	        youtube: youtube,
	        tiktok: tiktok,
	        twitch: twitch,
	        snapchat: snapchat,
	        telegram: telegram
	      });
	
	      var networkRates = [_extends({ network: 'facebook' }, facebookRates), _extends({ network: 'instagram' }, instagramRates), _extends({ network: 'twitter' }, twitterRates), _extends({ network: 'youtube' }, youtubeRates), _extends({ network: 'tiktok' }, tiktokRates), _extends({ network: 'twitch' }, twitchRates), _extends({ network: 'snapchat' }, snapchatRates), _extends({ network: 'telegram' }, telegramRates), _extends({ network: 'others' }, othersRates)];
	      var influencerDetailsPatch = _this.patchInfluencerDetails({
	        networkRates: networkRates
	      });
	
	      return Promise.all([influencerPatch, influencerDetailsPatch]);
	    };
	
	    _this.patchInfluencer = function (patch) {
	      var _this$props2 = _this.props,
	          id = _this$props2.influencer.id,
	          restClient = _this$props2.restClient;
	
	
	      var requestData = {
	        data: {
	          attributes: patch
	        }
	      };
	      return restClient.patch('/influencer/' + id, requestData).then(function (r) {
	        return r.data;
	      });
	    };
	
	    _this.patchInfluencerDetails = function (patch) {
	      var _this$props3 = _this.props,
	          id = _this$props3.influencerDetails.id,
	          restClient = _this$props3.restClient;
	
	      var requestData = {
	        data: {
	          attributes: patch
	        }
	      };
	      return restClient.patch('/influencerDetails/' + id, requestData);
	    };
	
	    _this.state = { loading: true };
	    return _this;
	  }
	
	  _createClass(InfluencerPostRates, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          influencer = _props.influencer,
	          influencerDetails = _props.influencerDetails;
	      var _state = this.state,
	          loading = _state.loading,
	          organisation = _state.organisation,
	          error = _state.error;
	
	      var _ref = organisation || {},
	          defaultCurrency = _ref.defaultCurrency;
	
	      var _ref2 = influencer || {},
	          facebook = _ref2.facebook,
	          youtube = _ref2.youtube,
	          instagram = _ref2.instagram,
	          twitter = _ref2.twitter,
	          tiktok = _ref2.tiktok,
	          twitch = _ref2.twitch,
	          snapchat = _ref2.snapchat,
	          telegramUser = _ref2.telegramUser,
	          facebookCount = _ref2.facebookCount,
	          instagramCount = _ref2.instagramCount,
	          twitterCount = _ref2.twitterCount,
	          youtubeCount = _ref2.youtubeCount,
	          tiktokCount = _ref2.tiktokCount,
	          twitchCount = _ref2.twitchCount,
	          youtubeChannelTitle = _ref2.youtubeChannelTitle;
	
	      var _ref3 = influencerDetails || {},
	          networkRates = _ref3.networkRates;
	
	      var facebookRates = _lodash2.default.find(networkRates, ['network', 'facebook']);
	      var instagramRates = _lodash2.default.find(networkRates, ['network', 'instagram']);
	      var youtubeRates = _lodash2.default.find(networkRates, ['network', 'youtube']);
	      var twitterRates = _lodash2.default.find(networkRates, ['network', 'twitter']);
	      var tiktokRates = _lodash2.default.find(networkRates, ['network', 'tiktok']);
	      var twitchRates = _lodash2.default.find(networkRates, ['network', 'twitch']);
	      var snapchatRates = _lodash2.default.find(networkRates, ['network', 'snapchat']);
	      var telegramRates = _lodash2.default.find(networkRates, ['network', 'telegram']);
	      var othersRates = _lodash2.default.find(networkRates, ['network', 'others']);
	      if (loading) return null;
	      if (error) return _react2.default.createElement(
	        'pre',
	        null,
	        JSON.stringify(error)
	      );
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-content' },
	        _react2.default.createElement(_influencerRatesTable2.default, {
	          currency: defaultCurrency,
	          facebook: facebook, facebookCount: facebookCount, facebookRates: facebookRates,
	          youtube: youtube, youtubeCount: youtubeCount, youtubeRates: youtubeRates,
	          youtubeChannelTitle: youtubeChannelTitle,
	          instagram: instagram, instagramCount: instagramCount, instagramRates: instagramRates,
	          twitter: twitter, twitterCount: twitterCount, twitterRates: twitterRates,
	          tiktok: tiktok, tiktokCount: tiktokCount, tiktokRates: tiktokRates,
	          twitch: twitch, twitchCount: twitchCount, twitchRates: twitchRates,
	          snapchat: snapchat, snapchatRates: snapchatRates,
	          telegram: twitter, telegramRates: telegramRates,
	          others: 'others', othersRates: othersRates,
	
	          onSave: this.handleSave
	        })
	      );
	    }
	  }]);
	
	  return InfluencerPostRates;
	}(_react.Component);
	
	InfluencerPostRates.propTypes = {};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(InfluencerPostRates);

/***/ },
/* 2145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRedux = __webpack_require__(28);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _profileContactDetails = __webpack_require__(2149);
	
	var _profileContactDetails2 = _interopRequireDefault(_profileContactDetails);
	
	var _profilePayments = __webpack_require__(2152);
	
	var _profilePayments2 = _interopRequireDefault(_profilePayments);
	
	var _profileApiData = __webpack_require__(2146);
	
	var _profileApiData2 = _interopRequireDefault(_profileApiData);
	
	var _profileBios = __webpack_require__(2147);
	
	var _profileBios2 = _interopRequireDefault(_profileBios);
	
	var _profileSocialDetails = __webpack_require__(2154);
	
	var _profileSocialDetails2 = _interopRequireDefault(_profileSocialDetails);
	
	var _profileTags = __webpack_require__(2155);
	
	var _profileTags2 = _interopRequireDefault(_profileTags);
	
	var _profileBusinessUnits = __webpack_require__(2148);
	
	var _profileBusinessUnits2 = _interopRequireDefault(_profileBusinessUnits);
	
	var _profilePlatformData = __webpack_require__(2153);
	
	var _profilePlatformData2 = _interopRequireDefault(_profilePlatformData);
	
	var _profileDescription = __webpack_require__(2151);
	
	var _profileDescription2 = _interopRequireDefault(_profileDescription);
	
	var _profileDemographics = __webpack_require__(2150);
	
	var _profileDemographics2 = _interopRequireDefault(_profileDemographics);
	
	var _actions = __webpack_require__(2162);
	
	var _authService = __webpack_require__(21);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _creatorLinkGenerator = __webpack_require__(1921);
	
	var _creatorLinkGenerator2 = _interopRequireDefault(_creatorLinkGenerator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfluencerProfile = function (_Component) {
	  _inherits(InfluencerProfile, _Component);
	
	  function InfluencerProfile() {
	    _classCallCheck(this, InfluencerProfile);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerProfile.__proto__ || Object.getPrototypeOf(InfluencerProfile)).call(this));
	
	    _this.onInfluencerPatch = function (id, patch) {
	      var requestData = { data: { attributes: patch } };
	      _this.restClient.patch('/influencer/' + id, requestData).then(function (r) {
	        return r.data;
	      }).catch(function (e) {
	        (0, _errorHandlingService.reportError)('Can not patch influencer', e);
	      });
	    };
	
	    _this.restClient = _axios2.default.create({
	      baseURL: ("https://api2.dyzio.co/v1"),
	      timeout: 5000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(InfluencerProfile, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          influencer = _props.influencer,
	          influencerDetails = _props.influencerDetails,
	          onReloadDetails = _props.children.onReloadDetails;
	      var influencerApiLink = influencer.influencerApiLink;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        influencer && _react2.default.createElement(
	          _semanticUiReact.Dimmer.Dimmable,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'page-content' },
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 8 },
	                  _react2.default.createElement(_profileContactDetails2.default, {
	                    influencer: influencer,
	                    onInfluencerPatch: this.onInfluencerPatch,
	                    afterUpdate: this.loadInfluencer
	                  }),
	                  _react2.default.createElement(_profileDemographics2.default, { influencer: influencer }),
	                  _react2.default.createElement(_profilePayments2.default, {
	                    influencer: influencer
	                  }),
	                  _react2.default.createElement(_profileDescription2.default, { influencerDetails: influencerDetails }),
	                  _react2.default.createElement(_creatorLinkGenerator2.default, influencer)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 8 },
	                  _react2.default.createElement(_profileSocialDetails2.default, { influencer: influencer }),
	                  _react2.default.createElement(_profileTags2.default, { onReloadDetails: onReloadDetails, influencer: influencer, details: influencerDetails }),
	                  _react2.default.createElement(_profileBusinessUnits2.default, { onReloadDetails: onReloadDetails, influencer: influencer, details: influencerDetails }),
	                  _react2.default.createElement(_profilePlatformData2.default, { influencer: influencer })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencerProfile;
	}(_react.Component);
	
	InfluencerProfile.contextTypes = {
	  router: _propTypes2.default.object
	};
	InfluencerProfile.propTypes = {
	  onLoadSingleInfluencer: _propTypes2.default.func.isRequired,
	  influencer: _propTypes2.default.object,
	  loading: _propTypes2.default.bool.isRequired
	};
	InfluencerProfile.defaultProps = {
	  influencer: {},
	  organisationName: ''
	};
	function mapDispatchToProps(dispatch) {
	  return {
	    onLoadSingleInfluencer: function onLoadSingleInfluencer(id) {
	      return dispatch((0, _actions.loadSingleInfluencer)(id));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = InfluencerProfile;

/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _axiosRetry = __webpack_require__(168);
	
	var _axiosRetry2 = _interopRequireDefault(_axiosRetry);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileApiData = function (_Component) {
	  _inherits(ProfileApiData, _Component);
	
	  function ProfileApiData() {
	    _classCallCheck(this, ProfileApiData);
	
	    var _this = _possibleConstructorReturn(this, (ProfileApiData.__proto__ || Object.getPrototypeOf(ProfileApiData)).call(this));
	
	    _this.componentDidMount = function () {
	      var immutableApiLink = _this.props.influencerApiLink;
	      var jsLink = immutableApiLink.toJS();
	
	      _this.restClient.get(jsLink.url).then(function (response) {
	        var apiInfluencer = response.data.influencer;
	        _this.setState({
	          loading: false,
	          apiInfluencer: apiInfluencer
	        });
	      }).catch(function (e) {
	        _this.setState({
	          error: e
	        });
	      });
	    };
	
	    _this.render = function () {
	      var _this$state = _this.state,
	          apiInfluencer = _this$state.apiInfluencer,
	          loading = _this$state.loading,
	          error = _this$state.error;
	
	      var cf = function cf(num) {
	        return (0, _numeral2.default)(num).format('0,0');
	      };
	      var stats = apiInfluencer && apiInfluencer.aggregateYoutubeChannelStatistics;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { padded: true, loading: loading },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Youtube Data'
	        ),
	        apiInfluencer && _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very', fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'channels'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                stats.channelCount
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'videos'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                cf(stats.videoCount)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'subscribers'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                cf(stats.subscriberCount)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'views'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                cf(stats.viewCount)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'comments'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                cf(stats.commentCount)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'avg. views per video'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                cf(stats.viewCount / stats.videoCount)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'avg. comments per video'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                cf(stats.commentCount / stats.videoCount)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'avg. daily viewing'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                cf(stats.averageDailyViews)
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'avg. monthly viewing'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                cf(stats.averageMonthlyViews)
	              )
	            )
	          )
	        ),
	        error && error.message
	      );
	    };
	
	    _this.state = {
	      apiInfluencer: null,
	      loading: true,
	      error: null
	    };
	
	    _this.restClient = _axios2.default.create({
	      timeout: 1000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    (0, _axiosRetry2.default)(_this.restClient, {
	      retries: 3
	    });
	    return _this;
	  }
	
	  return ProfileApiData;
	}(_react.Component);
	
	ProfileApiData.propTypes = {
	  influencerApiLink: _propTypes2.default.object.isRequired
	};
	
	exports.default = ProfileApiData;

/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfileBios = function ProfileBios(_ref) {
	  var influencer = _ref.influencer;
	
	  var instagramBio = influencer.instagramBio;
	  var twitterBio = influencer.twitterBio;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { padded: true },
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Social Bios'
	    ),
	    _react2.default.createElement('div', { className: 'spacer' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex' },
	      _react2.default.createElement(
	        'div',
	        { className: 'item' },
	        _react2.default.createElement(_semanticUiReact.Image, { src: '/icons/instagram.svg', alt: 'instagram' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'space' },
	        _react2.default.createElement(
	          'p',
	          null,
	          instagramBio
	        )
	      )
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex' },
	      _react2.default.createElement(
	        'div',
	        { className: 'item' },
	        _react2.default.createElement(_semanticUiReact.Image, { src: '/icons/twitter.svg', alt: 'twitter', floated: 'left' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'space' },
	        _react2.default.createElement(
	          'p',
	          null,
	          twitterBio
	        )
	      )
	    )
	  );
	};
	
	ProfileBios.propTypes = {
	  influencer: _propTypes2.default.object.isRequired
	};
	
	exports.default = ProfileBios;

/***/ },
/* 2148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _businessUnitsSelector = __webpack_require__(862);
	
	var _businessUnitsSelector2 = _interopRequireDefault(_businessUnitsSelector);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileBusinessUnits = function (_Component) {
	  _inherits(ProfileBusinessUnits, _Component);
	
	  function ProfileBusinessUnits(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ProfileBusinessUnits);
	
	    var _this = _possibleConstructorReturn(this, (ProfileBusinessUnits.__proto__ || Object.getPrototypeOf(ProfileBusinessUnits)).call(this, props));
	
	    _this.handleChange = function (e, v) {
	      _this.setState(_defineProperty({}, v.name, v.value));
	    };
	
	    _this.updateBusinessUnits = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var businessUnits, _this$props, restClient, id, payload;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              businessUnits = _this.state.businessUnits;
	              _this$props = _this.props, restClient = _this$props.restClient, id = _this$props.details.id;
	              payload = _lodash2.default.map(businessUnits, function (businessUnit) {
	                return {
	                  id: businessUnit.id,
	                  type: 'businessUnits'
	                };
	              });
	              _context.next = 5;
	              return restClient.patch('influencerDetails/' + id, {
	                data: {
	                  attributes: {
	                    businessUnits: payload
	                  }
	                }
	              });
	
	            case 5:
	              _context.next = 7;
	              return _this.props.onReloadDetails();
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.onBusinessUnitSelected = function (businessUnitId, tags) {
	      var selected = _lodash2.default.find(tags, ['id', businessUnitId]);
	      var stateTags = _this.state.businessUnits;
	
	      var newBusinessUnits = _lodash2.default.concat(stateTags, [{
	        id: selected.id,
	        value: _lodash2.default.get(selected, 'attributes.value')
	      }]);
	      _this.setState({
	        businessUnits: newBusinessUnits
	      });
	    };
	
	    _this.onBusinessUnitUnselected = function (businessUnitId) {
	      var businessUnits = _this.state.businessUnits;
	
	      var newBusinessUnits = _lodash2.default.reject(businessUnits, ['id', businessUnitId]);
	      _this.setState({
	        businessUnits: newBusinessUnits
	      });
	    };
	
	    console.log(props);
	    _this.state = {
	      editing: false,
	      businessUnits: _lodash2.default.get(props, 'details.businessUnits', [])
	    };
	    return _this;
	  }
	
	  _createClass(ProfileBusinessUnits, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          editing = _state.editing,
	          businessUnits = _state.businessUnits;
	
	      var selectedBusinessUnitsIds = _lodash2.default.map(businessUnits, 'id');
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { padded: true },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Business Units'
	        ),
	        editing && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('div', { className: 'spacer small' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Enter tags, separated by commas'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very' },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Business Units'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                editing ? _react2.default.createElement(_businessUnitsSelector2.default, {
	                  onSelected: this.onBusinessUnitSelected,
	                  onUnselected: this.onBusinessUnitUnselected,
	                  selectedBusinessUnits: selectedBusinessUnitsIds
	                }) : _react2.default.createElement(
	                  _semanticUiReact.Label.Group,
	                  null,
	                  _lodash2.default.map(businessUnits, function (businessUnit) {
	                    return _react2.default.createElement(
	                      _semanticUiReact.Label,
	                      null,
	                      businessUnit.value
	                    );
	                  })
	                )
	              )
	            ),
	            editing ? _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { size: 'medium', basic: true, fluid: true, onClick: function onClick() {
	                      return _this3.setState({ editing: false });
	                    } },
	                  'Cancel'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    fluid: true,
	                    color: 'pink',
	                    size: 'medium',
	                    onClick: function onClick() {
	                      _this3.setState({ editing: false });
	                      _this3.updateBusinessUnits();
	                    }
	                  },
	                  'Save Changes'
	                )
	              )
	            ) : _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 2 },
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { size: 'medium', basic: true, fluid: true, onClick: function onClick() {
	                      return _this3.setState({ editing: true });
	                    } },
	                  'Edit Business Units'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfileBusinessUnits;
	}(_react.Component);
	
	ProfileBusinessUnits.propTypes = {
	  details: _propTypes2.default.object.isRequired
	};
	exports.default = (0, _hasRestClient2.default)(ProfileBusinessUnits);

/***/ },
/* 2149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _editButton = __webpack_require__(913);
	
	var _editButton2 = _interopRequireDefault(_editButton);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _countries = __webpack_require__(93);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _influencerEmail = __webpack_require__(2377);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var errorStyle = {
	  color: '#9f3a38',
	  fontSize: 12
	};
	
	var dividerStyle = {
	  margin: '5px 0'
	};
	
	var ProfileContactDetails = function (_Component) {
	  _inherits(ProfileContactDetails, _Component);
	
	  function ProfileContactDetails(props) {
	    _classCallCheck(this, ProfileContactDetails);
	
	    var _this = _possibleConstructorReturn(this, (ProfileContactDetails.__proto__ || Object.getPrototypeOf(ProfileContactDetails)).call(this, props));
	
	    _this.onEditClicked = function () {
	      var organisationEmails = _this.state.organisationEmails;
	      var _this$props = _this.props,
	          userInfo = _this$props.userInfo,
	          jsonAPIClient = _this$props.jsonAPIClient;
	
	      _this.setState({ editing: true });
	      if (_lodash2.default.isEmpty(organisationEmails)) {
	        _this.setState({ loading: true });
	        (0, _influencerEmail.fetchOrganizationEmails)({
	          userInfo: userInfo,
	          jsonAPIClient: jsonAPIClient
	        }).then(function (emails) {
	          return _this.setState({
	            organisationEmails: emails,
	            loading: false
	          }, _this.validateInfluencerEmail);
	        }).catch(function (e) {
	          (0, _errorHandlingService.reportError)('INFLUENCER_FETCH_ERROR', e);
	        });
	      }
	    };
	
	    _this.validateInfluencerEmail = _lodash2.default.debounce(function () {
	      var _this$state = _this.state,
	          email = _this$state.email,
	          organisationEmails = _this$state.organisationEmails;
	      var _this$props2 = _this.props,
	          userInfo = _this$props2.userInfo,
	          jsonAPIClient = _this$props2.jsonAPIClient;
	
	      var influencerId = _this.props.influencer.id;
	      _this.setState({
	        emailValidating: true
	      });
	      (0, _influencerEmail.validateEmail)({
	        value: email,
	        organisationEmails: organisationEmails,
	        userInfo: userInfo,
	        jsonAPIClient: jsonAPIClient,
	        influencerId: influencerId
	      }).then(function (_ref) {
	        var isValid = _ref.isValid,
	            message = _ref.message;
	        return _this.setState({
	          emailValid: isValid,
	          emailMessage: message,
	          emailValidating: false
	        });
	      }).catch(function (e) {
	        console.error(e);
	        (0, _errorHandlingService.reportError)('EMAIL_VALIDATION_ERROR', e);
	      });
	    }, 300);
	
	    _this.handleEmailChange = function (e, _ref2) {
	      var name = _ref2.name,
	          value = _ref2.value;
	
	      _this.handleChange(e, { name: name, value: value });
	      _this.setState({
	        emailValidating: true
	      });
	      _this.validateInfluencerEmail();
	    };
	
	    _this.processUpdate = function () {
	      var influencerID = _this.props.influencer.id;
	
	      var _this$state2 = _this.state,
	          name = _this$state2.name,
	          dob = _this$state2.dob,
	          sweatcoin = _this$state2.sweatcoin,
	          email = _this$state2.email,
	          contactNumber = _this$state2.contactNumber,
	          addressLine1 = _this$state2.addressLine1,
	          city = _this$state2.city,
	          region = _this$state2.region,
	          postalCode = _this$state2.postalCode,
	          country = _this$state2.country,
	          agentName = _this$state2.agentName,
	          agentEmail = _this$state2.agentEmail,
	          agentContactNumber = _this$state2.agentContactNumber;
	
	
	      var patch = {
	        name: name,
	        dob: dob,
	        sweatcoin: sweatcoin,
	        email: email,
	        contactNumber: contactNumber,
	        addressLine1: addressLine1,
	        city: city,
	        region: region,
	        postalCode: postalCode,
	        country: country,
	        agentName: agentName,
	        agentEmail: agentEmail,
	        agentContactNumber: agentContactNumber
	      };
	
	      var patchParams = _lodash2.default.pickBy(patch);
	
	      console.log(patchParams);
	
	      var trimmedPatch = _lodash2.default.fromPairs(_lodash2.default.map(patchParams, function (value, key) {
	        return [key, _lodash2.default.trim(value)];
	      }));
	      _this.props.onInfluencerPatch(influencerID, trimmedPatch);
	
	      _this.setState({
	        editing: false
	      }, _this.props.afterUpdate);
	    };
	
	    _this.handleChange = function (e, v) {
	      return _this.setState(_defineProperty({}, v.name, v.value));
	    };
	
	    _this.reset = function () {
	      return _this.setState({
	        editing: false,
	        name: _this.props.influencer.name,
	        dob: _this.props.influencer.dob,
	        sweatcoin: _this.props.influencer.sweatcoin,
	        email: _this.props.influencer.email,
	        emailMessage: null,
	        emailValid: true,
	        emailValidating: false,
	        contactNumber: _this.props.influencer.contactNumber,
	        addressLine1: _this.props.influencer.addressLine1,
	        city: _this.props.influencer.city,
	        region: _this.props.influencer.region,
	        postalCode: _this.props.influencer.postalCode,
	        country: _this.props.influencer.country,
	        agentName: _this.props.influencer.agentName,
	        agentEmail: _this.props.influencer.agentEmail,
	        agentContactNumber: _this.props.influencer.agentContactNumber
	      });
	    };
	
	    _this.state = {
	      editing: false,
	      loading: false,
	      name: props.influencer.name,
	      dob: props.influencer.dob,
	      sweatcoin: props.influencer.sweatcoin,
	      email: props.influencer.email,
	      emailValid: true,
	      contactNumber: props.influencer.contactNumber,
	      addressLine1: props.influencer.addressLine1,
	      city: props.influencer.city,
	      region: props.influencer.region,
	      postalCode: props.influencer.postalCode,
	      country: props.influencer.country,
	      agentName: props.influencer.agentName,
	      agentEmail: props.influencer.agentEmail,
	      agentContactNumber: props.influencer.agentContactNumber
	    };
	    return _this;
	  }
	
	  _createClass(ProfileContactDetails, [{
	    key: 'render',
	    value: function render() {
	      var status = this.props.influencer.status;
	      var isClaimed = status === 'CLAIMED';
	      var _state = this.state,
	          name = _state.name,
	          dob = _state.dob,
	          sweatcoin = _state.sweatcoin,
	          email = _state.email,
	          editing = _state.editing,
	          contactNumber = _state.contactNumber,
	          addressLine1 = _state.addressLine1,
	          city = _state.city,
	          region = _state.region,
	          postalCode = _state.postalCode,
	          country = _state.country,
	          agentName = _state.agentName,
	          agentEmail = _state.agentEmail,
	          agentContactNumber = _state.agentContactNumber,
	          loading = _state.loading,
	          emailValid = _state.emailValid,
	          emailValidating = _state.emailValidating,
	          emailMessage = _state.emailMessage;
	
	
	      var dobDisplay = dob ? (0, _moment2.default)(dob).format('DD/MM/Y') + ' -- (age ' + (0, _moment2.default)().diff(dob, 'years') + ')' : '-';
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { padded: true },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Contact Details'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very' },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Name'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Input, { name: 'name', value: name, onChange: this.handleChange, fluid: true, readOnly: !editing })
	              )
	            ),
	            sweatcoin && _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Sweatcoin username'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  name: 'sweatcoin',
	                  readOnly: !editing,
	                  value: sweatcoin,
	                  onChange: this.handleChange,
	                  fluid: true
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'D.O.B.'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                !editing && _react2.default.createElement(_semanticUiReact.Input, { name: 'name', value: dobDisplay, fluid: true, readOnly: true }),
	                editing && _react2.default.createElement(_semanticUiReact.Input, {
	                  width: 16,
	                  label: 'D.O.B',
	                  placeholder: 'e.g. 01/05/2000',
	                  name: 'dob',
	                  onChange: this.handleChange,
	                  value: dob,
	                  type: 'date'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Email address'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  position: 'right center',
	                  open: !emailValid, trigger: _react2.default.createElement(_semanticUiReact.Input, {
	                    readOnly: !editing,
	                    hasLabel: false,
	                    fluid: true,
	                    value: email,
	                    error: !emailValid,
	                    loading: emailValidating,
	                    name: 'email',
	                    onBlur: this.validateInfluencerEmail,
	                    onChange: this.handleEmailChange
	                  }),
	                  content: _react2.default.createElement(
	                    'div',
	                    { style: errorStyle },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Invalid e-mail'
	                    ),
	                    _react2.default.createElement(_semanticUiReact.Divider, { fitted: true, style: dividerStyle }),
	                    emailMessage
	                  )
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Contact Number'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  name: 'contactNumber',
	                  readOnly: !editing,
	                  value: contactNumber,
	                  onChange: this.handleChange,
	                  fluid: true
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { verticalAlign: 'top', collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Address'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  fluid: true,
	                  name: 'addressLine1',
	                  readOnly: !editing,
	                  value: addressLine1,
	                  placeholder: 'Address Line One',
	                  onChange: this.handleChange
	                }),
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  name: 'city',
	                  readOnly: !editing,
	                  value: city,
	                  placeholder: 'City',
	                  onChange: this.handleChange,
	                  fluid: true
	                }),
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  name: 'region',
	                  readOnly: !editing,
	                  value: region,
	                  placeholder: 'Region',
	                  onChange: this.handleChange,
	                  fluid: true
	                }),
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  name: 'postalCode',
	                  readOnly: !editing,
	                  value: postalCode,
	                  placeholder: 'Post Code',
	                  onChange: this.handleChange,
	                  fluid: true
	                }),
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(_semanticUiReact.Select, {
	                  fluid: true,
	                  name: 'country',
	                  value: country,
	                  options: _countries2.default,
	                  onChange: this.handleChange,
	                  required: true,
	                  disabled: !editing
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Agent Name'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Input, { name: 'agentName', readOnly: !editing, value: agentName, onChange: this.handleChange, fluid: true })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Agent Email'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Input, { name: 'agentEmail', readOnly: !editing, value: agentEmail, onChange: this.handleChange, fluid: true })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Agent Contact Number'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  fluid: true,
	                  name: 'agentContactNumber',
	                  readOnly: !editing,
	                  value: agentContactNumber,
	                  onChange: this.handleChange
	                })
	              )
	            ),
	            editing ? _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { size: 'medium', basic: true, fluid: true, onClick: this.reset },
	                  'Cancel'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    size: 'medium',
	                    fluid: true,
	                    color: 'pink',
	                    disabled: loading || !emailValid || emailValidating,
	                    loading: loading || emailValidating,
	                    onClick: this.processUpdate
	                  },
	                  'Save Changes'
	                )
	              )
	            ) : _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 2 },
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(_editButton2.default, {
	                  isClaimed: isClaimed,
	                  content: 'Edit Contact Details',
	                  onClick: this.onEditClicked
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfileContactDetails;
	}(_react.Component);
	
	ProfileContactDetails.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  onInfluencerPatch: _propTypes2.default.func.isRequired,
	  afterUpdate: _propTypes2.default.func.isRequired
	};
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _hasJsonapiClient2.default)(ProfileContactDetails);

/***/ },
/* 2150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _influencerFormOptions = __webpack_require__(548);
	
	var _utils = __webpack_require__(281);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileDemographics = function (_React$Component) {
	  _inherits(ProfileDemographics, _React$Component);
	
	  function ProfileDemographics(props) {
	    _classCallCheck(this, ProfileDemographics);
	
	    var _this = _possibleConstructorReturn(this, (ProfileDemographics.__proto__ || Object.getPrototypeOf(ProfileDemographics)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var _props$influencer = props.influencer,
	        gender = _props$influencer.gender,
	        ageBracket = _props$influencer.ageBracket,
	        ethnicity = _props$influencer.ethnicity;
	
	    _this.state = {
	      gender: gender,
	      ageBracket: ageBracket,
	      ethnicity: ethnicity,
	      editing: false
	    };
	    return _this;
	  }
	
	  _createClass(ProfileDemographics, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          gender = _state.gender,
	          ageBracket = _state.ageBracket,
	          ethnicity = _state.ethnicity,
	          editing = _state.editing;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { padded: true },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Demographics'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very' },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Age bracket'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(InputSelect, {
	                  name: 'ageBracket',
	                  value: ageBracket,
	                  editing: editing,
	                  options: _influencerFormOptions.ageOptions,
	                  placeholder: 'Select age group',
	                  onChange: this.handleInputChange
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Gender'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(InputSelect, {
	                  name: 'gender',
	                  value: gender,
	                  editing: editing,
	                  options: _influencerFormOptions.genderOptions,
	                  placeholder: 'Select gender',
	                  onChange: this.handleInputChange
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Ethnicity'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(InputSelect, {
	                  name: 'ethnicity',
	                  value: ethnicity,
	                  editing: editing,
	                  options: _influencerFormOptions.ethnicityOptions,
	                  placeholder: 'Select ethnicity',
	                  onChange: this.handleInputChange
	                })
	              )
	            )
	          )
	        ),
	        editing ? _react2.default.createElement(
	          'div',
	          { className: 'flex' },
	          _react2.default.createElement(
	            'div',
	            { className: 'space' },
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              { size: 'medium', basic: true, fluid: true, onClick: this.reset },
	              'Cancel'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'space' },
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              { size: 'medium', color: 'pink', fluid: true, onClick: this.handleSubmit },
	              'Save Changes'
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex' },
	          _react2.default.createElement(
	            'div',
	            { className: 'space' },
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              {
	                size: 'medium',
	                basic: true, fluid: true, onClick: function onClick() {
	                  return _this2.setState({ editing: true });
	                }
	              },
	              'Edit Demographics Data'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfileDemographics;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleSubmit = function () {
	    var _state2 = _this3.state,
	        gender = _state2.gender,
	        ageBracket = _state2.ageBracket,
	        ethnicity = _state2.ethnicity;
	    var influencer = _this3.props.influencer;
	
	
	    (0, _utils.updateDemographics)(influencer.id, { gender: gender, ageBracket: ageBracket, ethnicity: ethnicity });
	    _this3.setState({ editing: false });
	  };
	
	  this.reset = function () {
	    var _props$influencer2 = _this3.props.influencer,
	        gender = _props$influencer2.gender,
	        ageBracket = _props$influencer2.ageBracket,
	        ethnicity = _props$influencer2.ethnicity;
	
	    _this3.setState({
	      gender: gender,
	      ageBracket: ageBracket,
	      ethnicity: ethnicity,
	      editing: false
	    });
	  };
	
	  this.handleInputChange = function (e, v) {
	    _this3.setState(_defineProperty({}, v.name, v.value));
	  };
	};
	
	var fullWidth = { width: '100%' };
	var InputSelect = function InputSelect(_ref) {
	  var editing = _ref.editing,
	      value = _ref.value,
	      name = _ref.name,
	      options = _ref.options,
	      placeholder = _ref.placeholder,
	      onChange = _ref.onChange;
	
	  var selectedOption = _lodash2.default.find(options, { value: value });
	  var displayValue = _lodash2.default.get(selectedOption, 'text', '-');
	  return editing ? _react2.default.createElement(_semanticUiReact.Select, {
	    style: fullWidth,
	    placeholder: placeholder,
	    name: name,
	    value: value,
	    options: options,
	    onChange: onChange,
	    clearable: true
	  }) : _react2.default.createElement(_semanticUiReact.Input, { name: name, value: displayValue, fluid: true, readOnly: true });
	};
	
	ProfileDemographics.propTypes = {
	  influencer: _propTypes2.default.object.isRequired
	};
	
	InputSelect.propTypes = {
	  editing: _propTypes2.default.bool.isRequired,
	  value: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  options: _propTypes2.default.array.isRequired,
	  placeholder: _propTypes2.default.string.isRequired,
	  onChange: _propTypes2.default.func.isRequired
	};
	exports.default = ProfileDemographics;

/***/ },
/* 2151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _utils = __webpack_require__(281);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var bioTextAreaStyle = {
	  padding: 0,
	  marginTop: 10
	};
	
	var mgTop10 = {
	  marginTop: 10
	};
	
	var hintStyle = {
	  color: 'gray'
	};
	
	var spacerStyle = {
	  width: '100%',
	  height: 5
	};
	
	var ProfileDescription = function (_Component) {
	  _inherits(ProfileDescription, _Component);
	
	  function ProfileDescription(props) {
	    _classCallCheck(this, ProfileDescription);
	
	    var _this = _possibleConstructorReturn(this, (ProfileDescription.__proto__ || Object.getPrototypeOf(ProfileDescription)).call(this, props));
	
	    _this.handleChange = function (e, v) {
	      return _this.setState(_defineProperty({}, v.name, v.value));
	    };
	
	    _this.reset = function () {
	      return _this.setState({
	        editing: false,
	        description: _this.props.influencerDetails.description
	      });
	    };
	
	    _this.handleUpdateDescription = function () {
	      var influencerDetailsID = _this.props.influencerDetails.id;
	      var description = _this.state.description;
	
	      (0, _utils.updateDescription)(influencerDetailsID, description);
	      _this.setState({ editing: false });
	    };
	
	    _this.state = {
	      editing: false,
	      description: props.influencerDetails.description
	    };
	    return _this;
	  }
	
	  _createClass(ProfileDescription, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.influencerDetails !== this.props.influencerDetails) {
	        this.setState({ description: nextProps.influencerDetails.description || '' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          editing = _state.editing,
	          description = _state.description;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { padded: true },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Influencer Bio'
	        ),
	        _react2.default.createElement('div', { style: spacerStyle }),
	        _react2.default.createElement(
	          'p',
	          { style: hintStyle },
	          'This Bio will be seen, when you add this influencer to a Shortlist.'
	        ),
	        _react2.default.createElement(_semanticUiReact.TextArea, { style: !editing ? bioTextAreaStyle : mgTop10, name: 'description', readOnly: !editing, value: description, onChange: this.handleChange }),
	        editing ? _react2.default.createElement(
	          'div',
	          { className: 'flex' },
	          _react2.default.createElement(
	            'div',
	            { className: 'space' },
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              { size: 'medium', basic: true, fluid: true, onClick: this.reset },
	              'Cancel'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'space' },
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              { size: 'medium', color: 'pink', fluid: true, onClick: this.handleUpdateDescription },
	              'Save Changes'
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex' },
	          _react2.default.createElement(
	            'div',
	            { className: 'space' },
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              { size: 'medium', basic: true, fluid: true, onClick: function onClick() {
	                  return _this2.setState({ editing: true });
	                } },
	              'Edit Description'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfileDescription;
	}(_react.Component);
	
	ProfileDescription.propTypes = {
	  influencerDetails: _propTypes2.default.object.isRequired
	};
	exports.default = ProfileDescription;

/***/ },
/* 2152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _utils = __webpack_require__(281);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfilePayments = function (_Component) {
	  _inherits(ProfilePayments, _Component);
	
	  function ProfilePayments(props) {
	    _classCallCheck(this, ProfilePayments);
	
	    var _this = _possibleConstructorReturn(this, (ProfilePayments.__proto__ || Object.getPrototypeOf(ProfilePayments)).call(this, props));
	
	    _this.handleChange = function (e, v) {
	      return _this.setState(_defineProperty({}, v.name, v.value));
	    };
	
	    _this.reset = function () {
	      return _this.setState({
	        editing: false,
	        paypalEmail: _this.props.influencer.paypalEmail,
	        discountCode: _this.props.influencer.discountCode
	      });
	    };
	
	    _this.handleUpdatePayments = function () {
	      var influencerID = _this.props.influencer.id;
	      var _this$state = _this.state,
	          paypalEmail = _this$state.paypalEmail,
	          discountCode = _this$state.discountCode;
	
	      (0, _utils.updatePayments)(influencerID, paypalEmail, discountCode);
	      _this.setState({ editing: false });
	    };
	
	    _this.state = {
	      editing: false,
	      paypalEmail: props.influencer.paypalEmail,
	      discountCode: props.influencer.discountCode
	    };
	    return _this;
	  }
	
	  _createClass(ProfilePayments, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          editing = _state.editing,
	          paypalEmail = _state.paypalEmail,
	          discountCode = _state.discountCode;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { padded: true },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Payments & Discount Codes'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very' },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Paypal Email'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Input, { name: 'paypalEmail', value: paypalEmail, onChange: this.handleChange, fluid: true, readOnly: !editing })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Shopify Discount Code'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Input, { name: 'discountCode', value: discountCode, onChange: this.handleChange, fluid: true, readOnly: !editing })
	              )
	            )
	          )
	        ),
	        editing ? _react2.default.createElement(
	          'div',
	          { className: 'flex' },
	          _react2.default.createElement(
	            'div',
	            { className: 'space' },
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              { size: 'medium', basic: true, fluid: true, onClick: this.reset },
	              'Cancel'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'space' },
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              { size: 'medium', color: 'pink', fluid: true, onClick: this.handleUpdatePayments },
	              'Save Changes'
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex' },
	          _react2.default.createElement(
	            'div',
	            { className: 'space' },
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              _semanticUiReact.Button,
	              { size: 'medium', basic: true, fluid: true, onClick: function onClick() {
	                  return _this2.setState({ editing: true });
	                } },
	              'Edit Payments & Discount Codes'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfilePayments;
	}(_react.Component);
	
	ProfilePayments.propTypes = {
	  influencer: _propTypes2.default.object.isRequired
	};
	exports.default = ProfilePayments;

/***/ },
/* 2153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfilePlatformData = function ProfilePlatformData(_ref) {
	  var influencer = _ref.influencer;
	
	  var name = influencer.name;
	  var statisticsUpdatedDate = influencer.statisticsUpdatedDate;
	  var dataRefreshMessage = 'Data collected ' + (0, _moment2.default)(statisticsUpdatedDate).fromNow();
	  var totalSocialReachDayChange = influencer.totalSocialReachDayChange;
	  var totalSocialReach = influencer.totalSocialReach;
	  var calculateDayOnDayGrowth = function calculateDayOnDayGrowth(totalReach, dayChange) {
	    var percentageGrowth = dayChange / totalReach;
	    return percentageGrowth;
	  };
	
	  var dayOnDayGrowth = calculateDayOnDayGrowth(totalSocialReach, totalSocialReachDayChange);
	  var trending = dayOnDayGrowth > 0.01;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { padded: true },
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Data'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table,
	      { basic: 'very' },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Body,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              (0, _numeral2.default)(totalSocialReachDayChange).format('0,0'),
	              '\xA0\xA0'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Follower day change'
	            ),
	            _react2.default.createElement('br', null),
	            dataRefreshMessage
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              (0, _numeral2.default)(dayOnDayGrowth).format('+0.0%'),
	              '\xA0\xA0'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Day on day change'
	            ),
	            _react2.default.createElement('br', null),
	            dataRefreshMessage
	          )
	        )
	      )
	    ),
	    trending && _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'b',
	        null,
	        name,
	        ' is currently trending'
	      )
	    )
	  );
	};
	
	ProfilePlatformData.propTypes = {
	  influencer: _propTypes2.default.object.isRequired
	};
	
	exports.default = ProfilePlatformData;

/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(37);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _dyzioIcons = __webpack_require__(92);
	
	var _utils = __webpack_require__(281);
	
	var _editButton = __webpack_require__(913);
	
	var _editButton2 = _interopRequireDefault(_editButton);
	
	var _tooltip = __webpack_require__(554);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _networkHandleInput = __webpack_require__(277);
	
	var _networkHandleInput2 = _interopRequireDefault(_networkHandleInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var externalIconStyle = {
	  color: '#20c49e'
	};
	
	var ProfileSocialDetails = function (_Component) {
	  _inherits(ProfileSocialDetails, _Component);
	
	  function ProfileSocialDetails(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ProfileSocialDetails);
	
	    var _this = _possibleConstructorReturn(this, (ProfileSocialDetails.__proto__ || Object.getPrototypeOf(ProfileSocialDetails)).call(this, props));
	
	    _this.getChannelData = function (channel, handle) {
	      var fetchableChannels = ['youtube', 'instagram', 'twitter', 'facebook', 'tiktok'];
	      if (!_lodash2.default.includes(fetchableChannels, channel)) {
	        return;
	      }
	      var count = channel + 'Count';
	      var loading = channel + 'Loading';
	      var error = channel + 'Error';
	      var options = {
	        data: {
	          platform: channel,
	          name: _lodash2.default.trimStart(handle, '@')
	        }
	      };
	
	      _this.setState(_defineProperty({}, loading, true));
	
	      if (handle.length === 0) {
	        var _this$setState2;
	
	        return _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, loading, false), _defineProperty(_this$setState2, count, 0), _defineProperty(_this$setState2, error, false), _this$setState2));
	      }
	
	      return setTimeout(function () {
	        return _axios2.default.post(("https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer"), options).then(function () {
	          var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(r) {
	            var _updatedData;
	
	            var channelData, updatedData;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	              while (1) {
	                switch (_context.prev = _context.next) {
	                  case 0:
	                    channelData = _lodash2.default.get(r, 'data.body.data', {});
	                    updatedData = (_updatedData = {}, _defineProperty(_updatedData, loading, false), _defineProperty(_updatedData, count, channelData.followerCount), _defineProperty(_updatedData, error, false), _updatedData);
	
	                    if (channel === 'instagram' && channelData.id) {
	                      updatedData.instagramId = channelData.id;
	                    }
	                    _this.setState(updatedData);
	
	                  case 4:
	                  case 'end':
	                    return _context.stop();
	                }
	              }
	            }, _callee, _this2);
	          }));
	
	          return function (_x) {
	            return _ref.apply(this, arguments);
	          };
	        }()).catch(function () {
	          var _this$setState3;
	
	          _this.setState((_this$setState3 = {}, _defineProperty(_this$setState3, loading, false), _defineProperty(_this$setState3, error, true), _this$setState3));
	        });
	      }, 1000);
	    };
	
	    _this.reset = function () {
	      return _this.setState({
	        editing: false,
	        facebook: _this.props.influencer.facebook,
	        instagram: _this.props.influencer.instagram,
	        twitter: _this.props.influencer.twitter,
	        youtube: _this.props.influencer.youtube,
	        pinterest: _this.props.influencer.pinterest,
	        otherChannels: _this.props.influencer.otherChannels,
	        twitch: _this.props.influencer.twitch,
	        tiktok: _this.props.influencer.tiktok,
	        web: _this.props.influencer.web,
	        snapchat: _this.props.influencer.snapchat,
	        linkedin: _this.props.influencer.linkedin
	      });
	    };
	
	    _this.handleChange = function (e, v) {
	      var value = _lodash2.default.replace(_lodash2.default.get(v, 'value'), /\s/g, '');
	      _this.setState(_defineProperty({}, v.name, value));
	      _this.getChannelData(v.name, value);
	    };
	
	    _this.findIcon = function (count, error) {
	      if (_this.state.editing) {
	        if (error) {
	          return 'close';
	        }
	        return count > 0 ? 'check' : 'search';
	      }
	      return _react2.default.createElement(_semanticUiReact.Icon, { name: 'external', basic: true, circular: true, style: externalIconStyle });
	    };
	
	    _this.sanitizeLink = function (platform, link) {
	      if (_lodash2.default.startsWith(link, 'http')) {
	        return link;
	      }
	      switch (platform) {
	        case 'facebook':
	          return 'https://facebook.com/' + link;
	        case 'twitter':
	          return 'https://twitter.com/' + link;
	        case 'youtube':
	          return 'https://youtube.com/channel/' + link;
	        case 'pinterest':
	          return 'https://pinterest.com/' + link;
	        case 'instagram':
	          return 'https://instagram.com/' + link;
	        case 'linkedin':
	          return 'https://www.linkedin.com/in/' + link;
	        case 'tiktok':
	          return 'https://www.tiktok.com/@' + link;
	        default:
	          return null;
	      }
	    };
	
	    _this.state = {
	      editing: false,
	      facebook: props.influencer.facebook,
	      facebookCount: props.influencer.facebookCount,
	      facebookLoading: false,
	      facebookError: false,
	      instagramId: props.influencer.instagramId,
	      instagram: props.influencer.instagram,
	      instagramCount: props.influencer.instagramCount,
	      instagramLoading: false,
	      instagramError: false,
	      twitter: props.influencer.twitter,
	      twitterCount: props.influencer.twitterCount,
	      twitterLoading: false,
	      twitterError: false,
	      tiktokCount: props.influencer.tiktokCount,
	      tiktokError: props.influencer.tiktokError,
	      youtube: props.influencer.youtube,
	      youtubeCount: props.influencer.youtubeCount,
	      youtubeChannelTitle: props.influencer.youtubeChannelTitle,
	      youtubeLoading: false,
	      youtubeError: false,
	      otherChannels: props.influencer.otherChannels,
	      twitch: props.influencer.twitch,
	      tiktok: props.influencer.tiktok,
	      web: props.influencer.web,
	      snapchat: props.influencer.snapchat,
	      linkedin: props.influencer.linkedin,
	      pinterest: props.influencer.pinterest
	    };
	    return _this;
	  }
	
	  _createClass(ProfileSocialDetails, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.influencer !== this.props.influencer) {
	        this.setState({
	          facebook: nextProps.influencer.facebook || '',
	          facebookCount: nextProps.influencer.facebookCount || 0,
	          instagram: nextProps.influencer.instagram || '',
	          instagramCount: nextProps.influencer.instagramCount || 0,
	          instagramId: nextProps.influencer.instagramId || '',
	          twitter: nextProps.influencer.twitter || '',
	          twitterCount: nextProps.influencer.twitterCount || 0,
	          youtube: nextProps.influencer.youtube || '',
	          youtubeCount: nextProps.influencer.youtubeCount || 0,
	          youtubeChannelTitle: nextProps.influencer.youtubeChannelTitle || '',
	          otherChannels: nextProps.influencer.otherChannels,
	          twitch: nextProps.influencer.twitch || '',
	          tiktok: nextProps.influencer.tiktok || '',
	          web: nextProps.influencer.web || '',
	          snapchat: nextProps.influencer.snapchat || '',
	          linkedin: nextProps.influencer.linkedin || '',
	          pinterest: nextProps.influencer.pinterest || ''
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          editing = _state.editing,
	          facebook = _state.facebook,
	          facebookCount = _state.facebookCount,
	          facebookLoading = _state.facebookLoading,
	          facebookError = _state.facebookError,
	          instagram = _state.instagram,
	          instagramCount = _state.instagramCount,
	          instagramLoading = _state.instagramLoading,
	          instagramError = _state.instagramError,
	          instagramId = _state.instagramId,
	          twitter = _state.twitter,
	          twitterCount = _state.twitterCount,
	          twitterLoading = _state.twitterLoading,
	          twitterError = _state.twitterError,
	          tiktok = _state.tiktok,
	          tiktokCount = _state.tiktokCount,
	          tiktokError = _state.tiktokError,
	          tiktokLoading = _state.tiktokLoading,
	          youtube = _state.youtube,
	          youtubeCount = _state.youtubeCount,
	          youtubeLoading = _state.youtubeLoading,
	          youtubeError = _state.youtubeError,
	          youtubeChannelTitle = _state.youtubeChannelTitle,
	          otherChannels = _state.otherChannels,
	          twitch = _state.twitch,
	          web = _state.web,
	          snapchat = _state.snapchat,
	          linkedin = _state.linkedin,
	          pinterest = _state.pinterest;
	
	      var influencerID = this.props.influencer.id;
	      var facebookInitial = this.props.influencer.facebook;
	      var instagramInitial = this.props.influencer.instagram;
	      var twitterInitial = this.props.influencer.twitter;
	      var youtubeInitial = this.props.influencer.youtube;
	      var status = this.props.influencer.status;
	      var isClaimed = status === 'CLAIMED';
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { padded: true },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Social'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very' },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement('img', { src: '/icons/facebook.svg', alt: 'Facebook', readOnly: !editing })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  _tooltip2.default,
	                  { content: _react2.default.createElement('img', { src: '/images/find-facebook-handle.png', alt: 'info' }), style: 'frame small' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'nowrap' },
	                    'Facebook ',
	                    _react2.default.createElement('img', { src: '/icons/info.svg', alt: 'info' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 3 },
	                _react2.default.createElement(_networkHandleInput2.default, {
	                  network: 'facebook',
	                  name: 'facebook',
	                  value: facebook,
	                  onChange: this.handleChange,
	                  as: !editing && _reactRouter.Link,
	                  placeholder: 'Facebook',
	                  to: this.sanitizeLink('facebook', facebook),
	                  target: '_blank',
	                  fluid: true,
	                  loading: facebookLoading,
	                  error: facebookError,
	                  count: facebookCount,
	                  readOnly: !editing
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement('img', { src: '/icons/instagram.svg', alt: 'Instagram' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  _tooltip2.default,
	                  { content: _react2.default.createElement('img', { src: '/images/find-instagram-handle.png', alt: 'info' }), style: 'frame small' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'nowrap' },
	                    'Instagram ',
	                    _react2.default.createElement('img', { src: '/icons/info.svg', alt: 'info' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 3 },
	                _react2.default.createElement(_networkHandleInput2.default, {
	                  network: 'instagram',
	                  name: 'instagram',
	                  value: instagram,
	                  onChange: this.handleChange,
	                  as: !editing && _reactRouter.Link,
	                  placeholder: 'Instagram',
	                  to: this.sanitizeLink('instagram', instagram),
	                  target: '_blank',
	                  fluid: true,
	                  loading: instagramLoading,
	                  error: instagramError,
	                  count: instagramCount,
	                  readOnly: !editing
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement('img', { src: '/icons/twitter.svg', alt: 'Twitter' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  _tooltip2.default,
	                  { content: _react2.default.createElement('img', { src: '/images/find-twitter-handle.png', alt: 'info' }), style: 'frame small' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'nowrap' },
	                    'Twitter ',
	                    _react2.default.createElement('img', { src: '/icons/info.svg', alt: 'info' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 3 },
	                _react2.default.createElement(_networkHandleInput2.default, {
	                  network: 'twitter',
	                  name: 'twitter',
	                  value: twitter,
	                  onChange: this.handleChange,
	                  as: !editing && _reactRouter.Link,
	                  placeholder: 'Twitter',
	                  to: this.sanitizeLink('twitter', twitter),
	                  target: '_blank',
	                  fluid: true,
	                  loading: twitterLoading,
	                  error: twitterError,
	                  count: twitterCount,
	                  readOnly: !editing
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement('img', { src: '/icons/youtube.svg', alt: 'YouTube' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  _tooltip2.default,
	                  { content: _react2.default.createElement('img', { src: '/images/find-youtube-handle.png', alt: 'info' }), style: 'frame small' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'nowrap' },
	                    'Youtube ',
	                    _react2.default.createElement('img', { src: '/icons/info.svg', alt: 'info' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 3 },
	                _react2.default.createElement(_networkHandleInput2.default, {
	                  network: 'youtube',
	                  name: 'youtube',
	                  value: youtube,
	                  onChange: this.handleChange,
	                  as: !editing && _reactRouter.Link,
	                  placeholder: 'Youtube',
	                  to: this.sanitizeLink('youtube', youtube),
	                  target: '_blank',
	                  fluid: true,
	                  loading: youtubeLoading,
	                  error: youtubeError,
	                  count: youtubeCount,
	                  readOnly: !editing
	                }),
	                _react2.default.createElement('br', null),
	                youtubeChannelTitle && _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { size: 'large', color: 'green', basic: true },
	                  youtubeChannelTitle
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'pinterest', color: 'red' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'nowrap' },
	                  'Pinterest'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 3 },
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  name: 'pinterest',
	                  value: pinterest,
	                  onChange: this.handleChange,
	                  as: !editing && _reactRouter.Link,
	                  placeholder: 'Pinterest',
	                  to: this.sanitizeLink('pinterest', pinterest),
	                  icon: this.findIcon(facebookCount, facebookError),
	                  target: '_blank',
	                  fluid: true,
	                  readOnly: !editing
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitch', color: 'purple' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'nowrap' },
	                  'Twitch'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 3 },
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  name: 'twitch',
	                  value: twitch,
	                  onChange: this.handleChange,
	                  placeholder: 'Twitch',
	                  fluid: true,
	                  readOnly: !editing
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(_dyzioIcons.TiktokIcon, null)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'nowrap' },
	                  'TikTok'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 3 },
	                _react2.default.createElement(_networkHandleInput2.default, {
	                  network: 'tiktok',
	                  name: 'tiktok',
	                  value: tiktok,
	                  onChange: this.handleChange,
	                  as: !editing && _reactRouter.Link,
	                  placeholder: 'Tiktok',
	                  to: this.sanitizeLink('tiktok', tiktok),
	                  target: '_blank',
	                  fluid: true,
	                  loading: tiktokLoading,
	                  error: tiktokError,
	                  count: tiktokCount,
	                  readOnly: !editing
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'snapchat ghost', color: 'yellow' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'nowrap' },
	                  'Snapchat'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 3 },
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  name: 'snapchat',
	                  value: snapchat,
	                  onChange: this.handleChange,
	                  placeholder: 'Snapchat',
	                  fluid: true,
	                  readOnly: !editing
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkedin', color: 'blue' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'nowrap' },
	                  'LinkedIn'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 3 },
	                _react2.default.createElement(_networkHandleInput2.default, {
	                  network: 'linkedin',
	                  name: 'linkedin',
	                  error: false,
	                  value: linkedin,
	                  loading: false,
	                  as: !editing && _reactRouter.Link,
	                  to: this.sanitizeLink('linkedin', linkedin),
	                  target: '_blank',
	                  readOnly: !editing,
	                  onChange: this.handleChange,
	                  fluid: true
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'world', color: 'blue' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'nowrap' },
	                  'Website/blog'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 3 },
	                _react2.default.createElement(_semanticUiReact.Input, {
	                  name: 'web',
	                  value: web,
	                  onChange: this.handleChange,
	                  placeholder: 'Website or blog',
	                  fluid: true,
	                  readOnly: !editing
	                })
	              )
	            ),
	            otherChannels && otherChannels.map(function (c) {
	              var channelName = c.name;
	              var channelHandle = c.handle;
	
	              return _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                { key: channelName + '_' + channelHandle },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  { collapsing: true },
	                  _react2.default.createElement('img', { src: '/icons/transparent.svg', alt: 'no channel' })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  channelName
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  { colSpan: 3 },
	                  _lodash2.default.startsWith(channelHandle, 'http') ? _react2.default.createElement(
	                    'a',
	                    { href: channelHandle, target: '_blank', rel: 'noopener noreferrer' },
	                    channelHandle
	                  ) : channelHandle
	                )
	              );
	            }),
	            editing ? _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 2 },
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { size: 'medium', basic: true, fluid: true, onClick: this.reset },
	                  'Cancel'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 3 },
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    size: 'medium',
	                    fluid: true,
	                    color: 'pink',
	                    onClick: function onClick() {
	                      (0, _utils.updateProfileSocialDetails)(influencerID, facebook, facebookCount, instagram, instagramCount, instagramId, twitter, twitterCount, youtube, youtubeCount, twitch, web, snapchat, pinterest, linkedin, tiktok, tiktokCount);
	                      _this3.setState({ editing: false });
	                    },
	                    disabled: (facebook !== facebookInitial || instagram !== instagramInitial || twitter !== twitterInitial || youtube !== youtubeInitial) && (facebookLoading || facebookError || instagramLoading || instagramError || twitterLoading || twitterError || youtubeLoading || youtubeError)
	                  },
	                  'Save Changes'
	                )
	              )
	            ) : _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 3 },
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(_editButton2.default, {
	                  isClaimed: isClaimed,
	                  content: 'Edit Social Details',
	                  onClick: function onClick() {
	                    return _this3.setState({ editing: true });
	                  }
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfileSocialDetails;
	}(_react.Component);
	
	ProfileSocialDetails.propTypes = {
	  influencer: _propTypes2.default.object.isRequired
	};
	exports.default = ProfileSocialDetails;

/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _tagsSelector = __webpack_require__(894);
	
	var _tagsSelector2 = _interopRequireDefault(_tagsSelector);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _utils = __webpack_require__(281);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileTags = function (_Component) {
	  _inherits(ProfileTags, _Component);
	
	  function ProfileTags(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ProfileTags);
	
	    var _this = _possibleConstructorReturn(this, (ProfileTags.__proto__ || Object.getPrototypeOf(ProfileTags)).call(this, props));
	
	    _this.setReadableTags = function () {
	      var contentTagsSplit = _lodash2.default.split(_this.state.contentTagsReadable, ',');
	      var contentCleanValues = _lodash2.default.filter(contentTagsSplit, function (item) {
	        return item && _lodash2.default.trim(item) !== '';
	      });
	      var contentTagArray = _lodash2.default.map(contentCleanValues, function (tag) {
	        return _lodash2.default.trim(tag);
	      });
	
	      var brandTagsSplit = _lodash2.default.split(_this.state.brandTagsReadable, ',');
	      var brandCleanValues = _lodash2.default.filter(brandTagsSplit, function (item) {
	        return item && _lodash2.default.trim(item) !== '';
	      });
	      var brandTagArray = _lodash2.default.map(brandCleanValues, function (tag) {
	        return _lodash2.default.trim(tag);
	      });
	
	      _this.setState({
	        contentTags: contentTagArray,
	        brandTags: brandTagArray
	      });
	    };
	
	    _this.handleChange = function (e, v) {
	      _this.setState(_defineProperty({}, v.name, v.value));
	    };
	
	    _this.updateTags = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var tags, _this$props, restClient, id, payload;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              tags = _this.state.tags;
	              _this$props = _this.props, restClient = _this$props.restClient, id = _this$props.details.id;
	              payload = _lodash2.default.map(tags, function (tag) {
	                return {
	                  id: tag.id,
	                  type: 'tags'
	                };
	              });
	              _context.next = 5;
	              return restClient.patch('influencerDetails/' + id, {
	                data: {
	                  attributes: {
	                    tags: payload
	                  }
	                }
	              });
	
	            case 5:
	              _context.next = 7;
	              return _this.props.onReloadDetails();
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.onTagSelected = function (tagId, tags) {
	      var selected = _lodash2.default.find(tags, ['id', tagId]);
	      var stateTags = _this.state.tags;
	
	      var newTags = _lodash2.default.concat(stateTags, [{
	        id: selected.id,
	        value: _lodash2.default.get(selected, 'attributes.value')
	      }]);
	      _this.setState({
	        tags: newTags
	      });
	    };
	
	    _this.onTagUnselected = function (tagId) {
	      var tags = _this.state.tags;
	
	      var newTags = _lodash2.default.reject(tags, ['id', tagId]);
	      _this.setState({
	        tags: newTags
	      });
	    };
	
	    var contentTags = _lodash2.default.get(props.details, 'contentTags', []);
	    var brandTags = _lodash2.default.get(props.details, 'brandTags', []);
	
	    _this.state = {
	      editing: false,
	      contentTags: contentTags,
	      brandTags: brandTags,
	      contentTagsReadable: contentTags.join(', '),
	      brandTagsReadable: brandTags.join(', '),
	      tags: _lodash2.default.get(props, 'details.tags', [])
	    };
	    return _this;
	  }
	
	  _createClass(ProfileTags, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          editing = _state.editing,
	          contentTags = _state.contentTags,
	          brandTags = _state.brandTags,
	          contentTagsReadable = _state.contentTagsReadable,
	          brandTagsReadable = _state.brandTagsReadable,
	          tags = _state.tags;
	
	      var influencerDetailsID = this.props.details.id;
	
	      var selectedTagsIds = _lodash2.default.map(tags, 'id');
	
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { padded: true },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Tags'
	        ),
	        editing && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('div', { className: 'spacer small' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Enter tags, separated by commas'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          { basic: 'very' },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Tags'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                editing ? _react2.default.createElement(_tagsSelector2.default, {
	                  onSelected: this.onTagSelected,
	                  onUnselected: this.onTagUnselected,
	                  selectedTags: selectedTagsIds
	                }) : _react2.default.createElement(
	                  _semanticUiReact.Label.Group,
	                  null,
	                  _lodash2.default.map(tags, function (tag) {
	                    return _react2.default.createElement(
	                      _semanticUiReact.Label,
	                      null,
	                      tag.value
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Content'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                editing ? _react2.default.createElement(_semanticUiReact.Input, { name: 'contentTagsReadable', value: contentTagsReadable, onChange: this.handleChange, placeholder: 'e.g. football, comedy...', fluid: true }) : _react2.default.createElement(
	                  'div',
	                  null,
	                  contentTags && _lodash2.default.map(contentTags, function (t) {
	                    return t && _react2.default.createElement(
	                      _semanticUiReact.Label,
	                      { basic: true, color: 'green', key: t },
	                      t
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { collapsing: true },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Brands'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                editing ? _react2.default.createElement(_semanticUiReact.Input, { name: 'brandTagsReadable', value: brandTagsReadable, onChange: this.handleChange, placeholder: 'e.g. Nike, L\'oreal...', fluid: true }) : _react2.default.createElement(
	                  'div',
	                  null,
	                  brandTags && _lodash2.default.map(brandTags, function (t) {
	                    return t && _react2.default.createElement(
	                      _semanticUiReact.Label,
	                      { basic: true, color: 'blue', key: t },
	                      t
	                    );
	                  })
	                )
	              )
	            ),
	            editing ? _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { size: 'medium', basic: true, fluid: true, onClick: function onClick() {
	                      return _this3.setState({ editing: false });
	                    } },
	                  'Cancel'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    fluid: true,
	                    color: 'pink',
	                    size: 'medium',
	                    onClick: function onClick() {
	                      _this3.setState({ editing: false });
	                      _this3.updateTags();
	                      (0, _utils.updateProfileTags)(influencerDetailsID, contentTagsReadable, brandTagsReadable);
	                      _this3.setReadableTags();
	                    }
	                  },
	                  'Save Changes'
	                )
	              )
	            ) : _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                { colSpan: 2 },
	                _react2.default.createElement('div', { className: 'spacer small' }),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { size: 'medium', basic: true, fluid: true, onClick: function onClick() {
	                      return _this3.setState({ editing: true });
	                    } },
	                  'Edit Tags'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfileTags;
	}(_react.Component);
	
	ProfileTags.propTypes = {
	  details: _propTypes2.default.object.isRequired
	};
	exports.default = (0, _hasRestClient2.default)(ProfileTags);

/***/ },
/* 2156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _recompose = __webpack_require__(15);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfluencerQuestionnaire = function (_Component) {
	  _inherits(InfluencerQuestionnaire, _Component);
	
	  function InfluencerQuestionnaire() {
	    _classCallCheck(this, InfluencerQuestionnaire);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerQuestionnaire.__proto__ || Object.getPrototypeOf(InfluencerQuestionnaire)).call(this));
	
	    _this.componentWillMount = function () {
	      var influencer = _this.props.influencer;
	
	
	      console.log(_this.props);
	
	      _this.setState({
	        loading: true
	      });
	      _axios2.default.get('https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/typeform/' + influencer.createdDate + '/' + influencer.id).then(function (response) {
	        var data = response.data;
	        console.log(data);
	        return _this.setState({ data: data, loading: false });
	      }).catch(function (err) {
	        _this.setState({
	          loading: false,
	          error: err
	        });
	      });
	    };
	
	    _this.state = { loading: true };
	    return _this;
	  }
	
	  _createClass(InfluencerQuestionnaire, [{
	    key: 'render',
	    value: function render() {
	      var data = this.state.data;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: { padding: '20px' } },
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card.Header,
	              null,
	              'Questionnaire Results'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table,
	              { textAlign: 'center' },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                _lodash2.default.map(data, function (_ref) {
	                  var question = _ref.question,
	                      answer = _ref.answer;
	                  return _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      { textAlign: 'left' },
	                      question
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      answer
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencerQuestionnaire;
	}(_react.Component);
	
	InfluencerQuestionnaire.propTypes = {};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(InfluencerQuestionnaire);

/***/ },
/* 2157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _campaignDashboardHeader = __webpack_require__(344);
	
	var _campaignDashboardHeader2 = _interopRequireDefault(_campaignDashboardHeader);
	
	var _tabActionBar = __webpack_require__(194);
	
	var _tabActionBar2 = _interopRequireDefault(_tabActionBar);
	
	var _dataRequestsListing = __webpack_require__(867);
	
	var _dataRequestsListing2 = _interopRequireDefault(_dataRequestsListing);
	
	var _audienceDataRequestHandlingModal = __webpack_require__(1890);
	
	var _audienceDataRequestHandlingModal2 = _interopRequireDefault(_audienceDataRequestHandlingModal);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _resources = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS_APPROVED = 'APPROVED';
	var STATE_DECLINED = 'DECLINED';
	
	var INITIAL_STATE = {
	  isLoading: true,
	  isError: false,
	  isReviewModalOpen: false,
	  selectedRequest: null
	};
	
	var InfluencerRequests = function (_Component) {
	  _inherits(InfluencerRequests, _Component);
	
	  function InfluencerRequests() {
	    _classCallCheck(this, InfluencerRequests);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerRequests.__proto__ || Object.getPrototypeOf(InfluencerRequests)).call(this));
	
	    _this.onToggleReviewModalState = function () {
	      _this.setState(function (prevState) {
	        return {
	          isReviewModalOpen: !prevState.isReviewModalOpen
	        };
	      });
	    };
	
	    _this.onRequestReviewButtonClick = function (event, _ref) {
	      var id = _ref.id;
	      var requests = _this.state.requests;
	
	      var request = _lodash2.default.find(requests, ['id', id]);
	      _this.setState({
	        isReviewModalOpen: true,
	        selectedRequest: request
	      });
	    };
	
	    _this.onRequestAccepted = function () {
	      _this.updateRequestState(STATUS_APPROVED);
	    };
	
	    _this.onRequestDeclined = function () {
	      _this.updateRequestState(STATE_DECLINED);
	    };
	
	    _this.fetchRequests = function () {
	      var _this$props = _this.props,
	          jsonAPIClient = _this$props.jsonAPIClient,
	          userInfo = _this$props.userInfo;
	
	      jsonAPIClient.get(_resources.ORGANISATION_RESOURCE, userInfo.organisationId).then(function (response) {
	        var organisation = response.toJSON();
	        var influencerId = _lodash2.default.get(organisation, 'influencer.id');
	        jsonAPIClient.find(_resources.DATA_REQUESTS_RESOURCE, { // eslint-disable-line lodash/prefer-lodash-method
	          filter: {
	            influencer: influencerId
	          },
	          include: ['agency']
	        }).then(function (resources) {
	          var requests = _lodash2.default.map(resources, function (resource) {
	            return resource.toJSONTree();
	          });
	          _this.setState({
	            requests: requests,
	            isLoading: false,
	            isError: false
	          });
	        });
	      });
	    };
	
	    _this.updateRequestState = function (state) {
	      var jsonAPIClient = _this.props.jsonAPIClient;
	      var id = _this.state.selectedRequest.id;
	
	      jsonAPIClient.get(_resources.DATA_REQUESTS_RESOURCE, id).then(function (resource) {
	        resource.set('requestStatus', state);
	        resource.sync().then(function () {
	          _this.setState(INITIAL_STATE, _this.fetchRequests);
	        });
	      });
	    };
	
	    _this.state = _extends({
	      requests: []
	    }, INITIAL_STATE);
	    return _this;
	  }
	
	  _createClass(InfluencerRequests, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchRequests();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          isError = _state.isError,
	          requests = _state.requests,
	          selectedRequest = _state.selectedRequest,
	          isReviewModalOpen = _state.isReviewModalOpen;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_campaignDashboardHeader2.default, {
	          name: 'My Requests'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(_tabActionBar2.default, {
	            onViewModeChanged: this.onViewModeChanged
	          }),
	          _react2.default.createElement(_dataRequestsListing2.default, {
	            isInfluencerMode: true,
	            isLoading: isLoading,
	            isError: isError,
	            requests: requests,
	            onRequestReviewButtonClick: this.onRequestReviewButtonClick
	          }),
	          isReviewModalOpen && _react2.default.createElement(_audienceDataRequestHandlingModal2.default, Object.assign({}, selectedRequest, {
	            onClose: this.onToggleReviewModalState,
	            onRequestAccepted: this.onRequestAccepted,
	            onRequestDeclined: this.onRequestDeclined
	          }))
	        )
	      );
	    }
	  }]);
	
	  return InfluencerRequests;
	}(_react.Component);
	
	InfluencerRequests.propTypes = {
	  jsonAPIClient: _propTypes2.default.func.isRequired,
	  userInfo: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasJsonapiClient2.default, _hasUserInfo2.default)(InfluencerRequests);

/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axiosRetry = __webpack_require__(168);
	
	var _axiosRetry2 = _interopRequireDefault(_axiosRetry);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(37);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ramda = __webpack_require__(252);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _recompose = __webpack_require__(15);
	
	var _pagination = __webpack_require__(147);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _influencerTableSettings = __webpack_require__(549);
	
	var _influencerTableSettings2 = _interopRequireDefault(_influencerTableSettings);
	
	var _hasLocalstorageClient = __webpack_require__(127);
	
	var _hasLocalstorageClient2 = _interopRequireDefault(_hasLocalstorageClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _dyzioEmptyState = __webpack_require__(192);
	
	var _dyzioEmptyState2 = _interopRequireDefault(_dyzioEmptyState);
	
	var _influencersTable = __webpack_require__(883);
	
	var _influencersTable2 = _interopRequireDefault(_influencersTable);
	
	var _influencerFilter = __webpack_require__(878);
	
	var _influencerFilter2 = _interopRequireDefault(_influencerFilter);
	
	var _organisationTags = __webpack_require__(2011);
	
	var _organisationTags2 = _interopRequireDefault(_organisationTags);
	
	var _oldOrganisationTags = __webpack_require__(2006);
	
	var _oldOrganisationTags2 = _interopRequireDefault(_oldOrganisationTags);
	
	var _organisationBrandTags = __webpack_require__(2009);
	
	var _organisationBrandTags2 = _interopRequireDefault(_organisationBrandTags);
	
	var _countries = __webpack_require__(93);
	
	var countryList = _interopRequireWildcard(_countries);
	
	var _platforms = __webpack_require__(933);
	
	var _platforms2 = _interopRequireDefault(_platforms);
	
	var _authService = __webpack_require__(21);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _staticConfiguration = __webpack_require__(27);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HELP_URL = 'https://help.dyzio.co/my-influencers-database/adding-an-influencer-to-your-my-influencers-database';
	
	var businessUnitLabelStyle = {
	  marginLeft: '5px'
	};
	
	var InfluencerTable = function (_Component) {
	  _inherits(InfluencerTable, _Component);
	
	  function InfluencerTable(props) {
	    _classCallCheck(this, InfluencerTable);
	
	    var _this = _possibleConstructorReturn(this, (InfluencerTable.__proto__ || Object.getPrototypeOf(InfluencerTable)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var storedPerPage = localStorage.getItem('' + _staticConfiguration.LS_PER_PAGE_KEY + _authService.authService.uid());
	    var dyzioStorage = props.dyzioStorage,
	        userId = props.userInfo.userId,
	        searchParams = props.searchParams;
	
	    var injectedSearchParams = _lodash2.default.pick(searchParams, ['filter', 'sort', 'currentPage']);
	    var columnsSettings = dyzioStorage.getTableColumnsSettings({ userId: userId });
	    _this.state = _extends({
	      term: '',
	      toBeDeleted: null,
	      confirmOpen: false,
	      selected: [],
	      loading: false,
	      loadingCountries: true,
	      links: null,
	      totalInfluencers: '-',
	      perPage: _lodash2.default.toSafeInteger(storedPerPage) || 25,
	      timeout: null,
	      shortlists: [],
	      countries: [],
	      currentPage: 1,
	      sliderValue: { min: 100000, max: 300000 },
	      clearTags: false,
	      filter: {
	        platform: '',
	        min: '',
	        max: '',
	        country: '',
	        maxInstagramEngagementRate: '',
	        minInstagramEngagementRate: '',
	        selectedTags: [],
	        mustMatchAllTags: true
	      },
	      sort: {
	        field: 'growth.relative7',
	        order: 'DESC'
	      },
	      errors: {
	        platform: false,
	        slider: false,
	        search: false
	      },
	      filtered: false,
	      name: 'My new shortlist',
	      notes: 'add some notes',
	      createdDate: null,
	      reportUrls: {
	        loading: true,
	        csv: null,
	        xlsx: null
	      },
	      columnsChooseModalVisible: false,
	      columnsSettings: columnsSettings,
	      businessUnits: [],
	      selectedBusinessUnits: JSON.parse(localStorage.getItem('selectedBusinessUnits')) || {},
	      triggerBusinessUnitsFilter: false,
	      settingTab: 0
	    }, injectedSearchParams);
	    _this.restClient = _axios2.default.create({
	      timeout: 30000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    _this.jsonClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	      header: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    (0, _axiosRetry2.default)(_this.restClient, {
	      retries: 3,
	      delay: 100
	    });
	    return _this;
	  }
	
	  _createClass(InfluencerTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var organisationId = this.props.organisationId;
	
	
	      var onPrivateLinkClickons = {
	        filter: {
	          organisation: organisationId
	        },
	        sort: '-createdDate'
	      };
	
	      var options = {
	        filter: {
	          organisation: organisationId
	        },
	        sort: '-createdDate'
	      };
	
	      this.jsonClient.find('shortlists', options) // eslint-disable-line lodash/prefer-lodash-method
	      .then(function (lists) {
	        var listsJson = _lodash2.default.map(lists, function (list) {
	          return list.toJSONTree();
	        });
	        _this2.setState({
	          shortlists: listsJson
	        });
	      });
	
	      var countriesBaseUrl = ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production");
	      var countriesEndpoint = '/countries/' + organisationId;
	      var countriesFullUrl = countriesBaseUrl.concat(countriesEndpoint);
	
	      this.restClient.get(countriesFullUrl).then(function (response) {
	        var rows = response.data.data;
	        var countries = _lodash2.default.flatMap(rows, _this2.formatCountries);
	
	        _this2.setState({
	          countries: countries,
	          loadingCountries: false
	        });
	      }).catch(function (e) {
	        (0, _errorHandlingService.reportError)('could not fetch countries', e);
	      });
	
	      this.restClient.get(("https://api2.dyzio.co/v1") + '/businessUnits?filter[organisation]=' + organisationId).then(function (response) {
	        var data = _lodash2.default.get(response, 'data.data', []);
	        var businessUnits = _lodash2.default.map(data, function (businessUnit) {
	          return {
	            key: _lodash2.default.get(businessUnit, 'id'),
	            value: _lodash2.default.get(businessUnit, 'id'),
	            text: _lodash2.default.get(businessUnit, 'attributes.value')
	          };
	        });
	        console.log(businessUnits);
	        _this2.setState({
	          businessUnits: businessUnits
	        });
	      }).catch(function (e) {
	        (0, _errorHandlingService.reportError)('could not fetch business units', e);
	      });
	
	      this.fetch();
	      this.fetchReportUrls();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          sort = _state.sort,
	          loading = _state.loading,
	          isLoadingCountries = _state.isLoadingCountries,
	          countries = _state.countries,
	          links = _state.links,
	          perPage = _state.perPage,
	          totalInfluencers = _state.totalInfluencers,
	          currentPage = _state.currentPage,
	          filtered = _state.filtered,
	          shortlists = _state.shortlists,
	          errors = _state.errors,
	          selected = _state.selected,
	          confirmOpen = _state.confirmOpen,
	          createdDate = _state.createdDate,
	          reportUrls = _state.reportUrls,
	          columnsChooseModalVisible = _state.columnsChooseModalVisible,
	          columnsSettings = _state.columnsSettings,
	          businessUnits = _state.businessUnits,
	          selectedBusinessUnits = _state.selectedBusinessUnits,
	          settingTab = _state.settingTab;
	      var _props = this.props,
	          organisationId = _props.organisationId,
	          searchParams = _props.searchParams,
	          usesGlobalTags = _props.usesGlobalTags,
	          displayAuthorisedData = _props.displayAuthorisedData;
	
	
	      var injectedSearchParams = _lodash2.default.pick(searchParams, ['filter', 'sort', 'currentPage']);
	
	      var from = (currentPage - 1) * perPage + 1;
	      var to = links ? from - 1 + links.length : perPage;
	
	      var totalPages = Math.ceil(totalInfluencers / perPage);
	      var noInfluencers = totalInfluencers === 0;
	      var withActions = selected.length > 0;
	
	      var isSearchContext = !_lodash2.default.isEmpty(_lodash2.default.pickBy(_lodash2.default.get(injectedSearchParams, 'filter', {}), _lodash2.default.identity));
	      var selectedTags = _lodash2.default.get(injectedSearchParams, 'filter.selectedTags', []);
	      var mustMatchAllTags = _lodash2.default.get(injectedSearchParams, 'filter.mustMatchAllTags', true);
	      var organisation = {
	        id: this.props.organisationId,
	        slug: this.props.organisationSlug
	      };
	
	      var emptyStateWrapper = {
	        marginTop: 120
	      };
	
	      var businessUnitsFiltered = !_lodash2.default.isEmpty(_lodash2.default.filter(_lodash2.default.get(selectedBusinessUnits, 'businessUnits'), function (bu) {
	        return bu.selected;
	      }));
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 12, verticalAlign: 'middle', textAlign: 'right' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    filtered ? 'showing matching influencers' : from + ' - ' + to + ' of ' + totalInfluencers + ' influencers'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 3, textAlign: 'right' },
	                  _react2.default.createElement(_pagination2.default, {
	                    onPageIncrement: this.incrementPage,
	                    onPageDecrement: this.decrementPage,
	                    currentPage: currentPage,
	                    totalPages: totalPages
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 1, textAlign: 'center', verticalAlign: 'middle' },
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                      circular: true, inverted: true, color: 'green', icon: 'settings', onClick: this.toggleColumnChooserModal
	                    }),
	                    content: 'Click here to show/hide table columns...'
	                  })
	                )
	              ),
	              businessUnitsFiltered && _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                { className: 'padding5' },
	                _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 4 }),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 12, verticalAlign: 'middle', textAlign: 'left' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Segment,
	                    { className: 'padding5' },
	                    _react2.default.createElement(
	                      'table',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          { style: { backgroundColor: '#eee', border: '1px solid #ddd', padding: '10px' } },
	                          'Business Unit / Brand'
	                        ),
	                        _lodash2.default.map(_lodash2.default.get(selectedBusinessUnits, 'businessUnits'), function (businessUnit) {
	                          if (businessUnit.selected) {
	                            return _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement(_semanticUiReact.Popup, {
	                                trigger: _react2.default.createElement(_semanticUiReact.Label, {
	                                  style: businessUnitLabelStyle,
	                                  color: 'pink',
	                                  basic: true,
	                                  content: businessUnit.text
	                                }),
	                                content: 'use the settings screen too remove the filter'
	                              })
	                            );
	                          }
	                          return '';
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 4 },
	                  _react2.default.createElement(_influencerFilter2.default, Object.assign({
	                    reportUrls: reportUrls,
	                    currentPerPage: perPage,
	                    onSearchFormSubmit: this.handleSearchButtonClick,
	                    onPerPageChange: this.handlePerPageChange,
	                    isLoadingCountries: isLoadingCountries,
	                    isLoading: loading,
	                    countries: countries,
	                    platforms: _platforms2.default,
	                    withDemographicsFilter: true
	                  }, injectedSearchParams)),
	                  _react2.default.createElement(
	                    _semanticUiReact.Segment,
	                    { textAlign: 'center' },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkify' }),
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: '/my-requests' },
	                      'My requests'
	                    )
	                  ),
	                  usesGlobalTags ? _react2.default.createElement(_organisationTags2.default, {
	                    organisationId: organisationId,
	                    onTagSelected: this.onNewTagSelected,
	                    selectedTags: selectedTags,
	                    onSwitchToggle: this.onTagsSwitchToggle,
	                    mustMatchAllTags: mustMatchAllTags
	                  }) : _react2.default.createElement(_oldOrganisationTags2.default, {
	                    organisationId: organisationId,
	                    handleClick: this.fetch,
	                    clearTags: true
	                  }),
	                  _react2.default.createElement(_organisationBrandTags2.default, {
	                    organisationId: organisationId,
	                    handleClick: this.fetch,
	                    clearTags: true
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 12 },
	                  !loading && noInfluencers && _react2.default.createElement(
	                    'div',
	                    { style: emptyStateWrapper },
	                    _react2.default.createElement(_dyzioEmptyState2.default, {
	                      context: 'INFLUENCER',
	                      buttonLabel: 'Add an influencer',
	                      onClick: this.redirectToAddInfluencer,
	                      helpUrl: HELP_URL,
	                      content: _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          !isSearchContext && !businessUnitsFiltered ? 'You have not saved any influencers!' : 'No search results!'
	                        ),
	                        !isSearchContext && _react2.default.createElement(
	                          'p',
	                          null,
	                          'Use the button below to add your first.'
	                        )
	                      )
	                    })
	                  ),
	                  !noInfluencers && _react2.default.createElement(_influencersTable2.default, {
	                    displayAuthorisedData: displayAuthorisedData,
	                    columnsSettings: columnsSettings,
	                    createdDate: createdDate,
	                    withActions: withActions,
	                    organisation: organisation,
	                    selected: selected,
	                    links: links,
	                    errors: errors,
	                    loading: loading,
	                    sort: sort,
	                    shortlists: shortlists,
	                    handleCheckAllInfluencers: this.handleCheckAllInfluencers,
	                    handleDeleteInfluencer: this.handleDeleteInfluencer,
	                    handleSaveShortlist: this.handleSaveShortlist,
	                    patchShortlist: this.patchShortlist,
	                    incrementPage: this.incrementPage,
	                    decrementPage: this.decrementPage,
	                    handleDeleteQueue: this.handleDeleteQueue,
	                    handleSorting: this.handleSorting,
	                    handlePageRedirect: this.handlePageRedirect,
	                    handleCheckChange: this.handleCheckChange,
	                    influencerPageRedirect: this.handeRedirectToInfluencerProfile,
	                    tryAgainCallback: this.fetchIf,
	                    reportUrls: reportUrls
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Modal,
	            {
	              size: 'tiny',
	              open: confirmOpen,
	              onClose: this.popupToggleHandler,
	              closeOnEscape: true
	            },
	            _react2.default.createElement(
	              _semanticUiReact.Modal.Content,
	              null,
	              _react2.default.createElement(
	                'h5',
	                { className: 'align-center' },
	                'Are you sure you want to delete ',
	                selected.length === 1 ? 'this influencer' : 'these influencers',
	                '?'
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              _react2.default.createElement(
	                _semanticUiReact.List,
	                { divided: true, relaxed: true },
	                _lodash2.default.map(selected, function (influencer) {
	                  return _react2.default.createElement(
	                    _semanticUiReact.List.Item,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Image, { src: influencer.thumbnail, avatar: true }),
	                    _react2.default.createElement(
	                      _semanticUiReact.List.Content,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.List.Header,
	                        null,
	                        influencer.name
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.List.Description,
	                        { as: 'span' },
	                        '@' + influencer.primarySocialHandle
	                      )
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              _react2.default.createElement(
	                'div',
	                { className: 'align-right' },
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { onClick: this.popupToggleHandler, color: 'grey' },
	                  'Nope'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { color: 'pink', onClick: this.deleteSelectedInfluencers },
	                  'Do it!'
	                )
	              )
	            )
	          ),
	          columnsChooseModalVisible && _react2.default.createElement(_influencerTableSettings2.default, {
	            onClose: this.toggleColumnChooserModal,
	            onColumnCheckboxChange: this.onColumnCheckboxChange,
	            onBusinessUnitsChange: this.onBusinessUnitsChange,
	            columnsSettings: columnsSettings,
	            selectedBusinessUnits: selectedBusinessUnits,
	            businessUnits: businessUnits,
	            tab: settingTab
	          })
	        )
	      );
	    }
	  }]);
	
	  return InfluencerTable;
	}(_react.Component);
	
	InfluencerTable.contextTypes = {
	  router: _propTypes2.default.object
	};
	InfluencerTable.propTypes = {
	  organisationId: _propTypes2.default.string.isRequired,
	  organisationSlug: _propTypes2.default.string.isRequired,
	  usesGlobalTags: _propTypes2.default.bool.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onColumnCheckboxChange = function (e, data) {
	    var platform = data.label,
	        displayed = data.checked;
	    var columnsSettings = _this3.state.columnsSettings;
	
	    _lodash2.default.set(columnsSettings, 'columns.' + _lodash2.default.snakeCase(_lodash2.default.lowerCase(platform)) + '.displayed', displayed);
	    _this3.setState({
	      columnsSettings: columnsSettings,
	      settingTab: 0
	    });
	  };
	
	  this.onBusinessUnitsChange = function (e, data) {
	    var businessUnit = data.label,
	        selected = data.checked,
	        id = data.id;
	    var selectedBusinessUnits = _this3.state.selectedBusinessUnits;
	
	    _lodash2.default.set(selectedBusinessUnits, 'businessUnits.' + _lodash2.default.snakeCase(_lodash2.default.lowerCase(businessUnit)) + '.selected', selected);
	    _lodash2.default.set(selectedBusinessUnits, 'businessUnits.' + _lodash2.default.snakeCase(_lodash2.default.lowerCase(businessUnit)) + '.text', businessUnit);
	    _lodash2.default.set(selectedBusinessUnits, 'businessUnits.' + _lodash2.default.snakeCase(_lodash2.default.lowerCase(businessUnit)) + '.id', id);
	    localStorage.setItem('selectedBusinessUnits', JSON.stringify(selectedBusinessUnits));
	    console.log(JSON.parse(localStorage.getItem('selectedBusinessUnits')));
	    _this3.setState({
	      selectedBusinessUnits: selectedBusinessUnits,
	      settingTab: 1,
	      triggerBusinessUnitsFilter: true
	    });
	  };
	
	  this.getFilterText = function (filter, term) {
	    var text = '';
	    text += term ? '<p>search term: ' + term + '</p>' : '';
	    text += filter.country ? '<p>country: ' + filter.country + '</p>' : '';
	    text += filter.platform ? '<p>channel: ' + filter.platform + '</p>' : '';
	    text += filter.min ? '<p>more than: ' + filter.min + ' followers</p>' : '';
	    text += filter.max ? '<p>less than: ' + filter.max + ' followers</p>' : '';
	    return text;
	  };
	
	  this.setPage = function (step) {
	    var currentPage = _this3.state.currentPage;
	    var onSearchParamsChange = _this3.props.onSearchParamsChange;
	
	    currentPage += step;
	    _this3.setState({ currentPage: currentPage }, _this3.fetch);
	    onSearchParamsChange({ currentPage: currentPage });
	  };
	
	  this.patchShortlist = function (event, data) {
	    var shortlistId = data.value;
	    var _state2 = _this3.state,
	        shortlists = _state2.shortlists,
	        selected = _state2.selected;
	
	    var shortlist = _lodash2.default.find(shortlists, { id: shortlistId });
	    var oldInfluencers = shortlist.influencers;
	    var oldLinks = shortlist.influencerLinks;
	
	    var newInfluencers = _lodash2.default.map(selected, function (influencer) {
	      return { type: 'influencer', id: influencer.id };
	    });
	    var newLinks = _lodash2.default.map(selected, function (row) {
	      return { type: 'influencerLink', id: row.linkId };
	    });
	
	    var union = _lodash2.default.union(oldInfluencers, newInfluencers);
	    var linksUnion = _lodash2.default.union(oldLinks, newLinks);
	
	    var patch = {
	      data: {
	        type: 'shortlists',
	        attributes: {
	          influencers: _lodash2.default.uniqBy(union, 'id'),
	          influencerLinks: _lodash2.default.uniqBy(linksUnion, 'id')
	        }
	      }
	    };
	
	    _this3.restClient.patch(("https://api2.dyzio.co/v1") + '/shortlists/' + shortlistId, patch).then(_this3.context.router.push('/shortlists/' + shortlistId)).catch(function (e) {
	      (0, _errorHandlingService.reportError)('could not patch shortlist', e);
	    });
	  };
	
	  this.handleDeleteQueue = function (e, _ref) {
	    var value = _ref.value;
	
	    _this3.setState({
	      toBeDeleted: value.id,
	      confirmOpen: true,
	      influencerName: value.name
	    });
	  };
	
	  this.checkReportFilePresence = function (fileName, fileType) {
	    var reportUrls = _this3.state.reportUrls;
	
	    _this3.restClient.get(("https://1hweifjj4e.execute-api.eu-west-1.amazonaws.com/production/report") + '/' + fileName).then(function (response) {
	      var signedUrl = response.data.body.signedUrl;
	
	      reportUrls[fileType] = signedUrl;
	      reportUrls.loading = false;
	      _this3.setState({
	        reportUrls: reportUrls
	      });
	    }).catch(function () {
	      reportUrls[fileType] = null;
	      reportUrls.loading = false;
	      _this3.setState({
	        reportUrls: reportUrls
	      });
	    });
	  };
	
	  this.fetch = function (searchParams) {
	    _this3.setState({
	      loading: true
	    });
	
	    var MIN_SEARCH_LENGTH = 2;
	    var _state3 = _this3.state,
	        perPage = _state3.perPage,
	        currentPage = _state3.currentPage,
	        filter = _state3.filter,
	        sort = _state3.sort,
	        selectedBusinessUnits = _state3.selectedBusinessUnits;
	    var term = filter.term,
	        searchType = filter.searchType;
	    var _props2 = _this3.props,
	        organisationId = _props2.organisationId,
	        cacheBuster = _props2.cacheBuster;
	    var clearTags = _this3.state.clearTags;
	
	
	    var search = {};
	    if (searchParams) {
	      if (searchParams.brandTag) {
	        search.brandTag = searchParams.brandTag;
	      } else {
	        var tag = searchParams.tag;
	
	        search.searchTerm = tag;
	        search.tagSearch = true;
	      }
	    } else {
	      if (term && term.length >= MIN_SEARCH_LENGTH) {
	        search[searchType || 'handles'] = term;
	      }
	
	      if (!_lodash2.default.isEmpty(filter.selectedTags)) {
	        search.tagIds = filter.selectedTags;
	        search.matchAllTags = filter.mustMatchAllTags;
	      } else {
	        if (filter.platform) {
	          if (_lodash2.default.isEqual(filter.platform, 'instagram')) {
	            if (filter.minInstagramEngagementRate > 0) {
	              search.minInstagramEngagementRate = _lodash2.default.toNumber(filter.minInstagramEngagementRate);
	            }
	            if (filter.maxInstagramEngagementRate > 0) {
	              search.maxInstagramEngagementRate = _lodash2.default.toNumber(filter.maxInstagramEngagementRate);
	            }
	          }
	
	          if (filter.min > 0) {
	            search.moreThan = _lodash2.default.parseInt(filter.min);
	            search.platform = filter.platform;
	          }
	          if (filter.max > 0) {
	            search.lessThan = _lodash2.default.parseInt(filter.max);
	            search.platform = filter.platform;
	          }
	        }
	
	        if (!_lodash2.default.isEmpty(filter.ageGroup)) {
	          search.ageGroup = filter.ageGroup;
	        }
	        if (!_lodash2.default.isEmpty(filter.gender)) {
	          search.gender = filter.gender;
	        }
	        if (!_lodash2.default.isEmpty(filter.ethnicity)) {
	          search.ethnicity = filter.ethnicity;
	        }
	
	        if (filter.country) {
	          search.country = '' + filter.country;
	        }
	
	        clearTags = true;
	      }
	    }
	
	    console.log('selectedBusinessUnits', selectedBusinessUnits);
	
	    var businessUnitsFilter = _lodash2.default.filter(_lodash2.default.get(selectedBusinessUnits, 'businessUnits'), function (bu) {
	      return bu.selected;
	    });
	
	    if (!_lodash2.default.isEmpty(businessUnitsFilter)) {
	      search.businessUnitIds = _lodash2.default.map(businessUnitsFilter, function (bu) {
	        return bu.id;
	      });
	    }
	
	    console.log('businessUnitsFilter', search.businessUnitIds);
	
	    // ADD business Units Param to search
	
	    if (_lodash2.default.isEmpty(search)) {
	      _this3.setState({ filtered: false });
	    } else {
	      _this3.setState({ filtered: true });
	    }
	
	    if (cacheBuster.cb) {
	      // remove the CB
	      var loc = window.location;
	      var barePath = '' + loc.origin + loc.pathname;
	      _reactRouter.browserHistory.push(barePath);
	      sort.field = 'createdDate';
	      sort.order = 'DESC';
	    }
	
	    var request = {
	      data: {
	        organisationId: organisationId,
	        perPage: perPage,
	        currentPage: currentPage,
	        search: search,
	        sort: sort,
	        cacheBuster: cacheBuster
	      }
	    };
	
	    var searchURI = encodeURIComponent(JSON.stringify(request));
	
	    var errors = _this3.state.errors;
	
	    var url = ("https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production") + '/filter/' + searchURI;
	
	    _this3.restClient.get(url).then(function (r) {
	      var totalInfluencers = _lodash2.default.get(r, 'data.body.data.metadata.total', 0);
	      var results = _lodash2.default.filter(r.data.body.data.data || [], _this3.filterInfluencers);
	      errors.search = false;
	      _this3.setState({
	        links: results,
	        loading: false,
	        loadingInfluencerFailed: false,
	        totalInfluencers: totalInfluencers,
	        errors: errors,
	        createdDate: _moment2.default.now(),
	        clearTags: clearTags
	      });
	    }).catch(function (ex) {
	      errors.search = true;
	      _this3.setState({
	        errors: errors,
	        loading: false,
	        clearTags: clearTags
	      });
	    });
	  };
	
	  this.filterInfluencers = function (influencer) {
	    var term = _this3.state.term;
	    var _influencer$lookupDet = influencer.lookupDetails,
	        contentTags = _influencer$lookupDet.contentTags,
	        brandTags = _influencer$lookupDet.brandTags;
	
	    var tags = _lodash2.default.concat(contentTags || [], brandTags || []).join(',');
	    var conditions = [_lodash2.default.includes(influencer.name, term), _lodash2.default.includes(influencer.primarySocialHandle, term), _lodash2.default.includes(tags, term)];
	    return _ramda2.default.anyPass(conditions);
	  };
	
	  this.handleSaveShortlist = function () {
	    var _state4 = _this3.state,
	        name = _state4.name,
	        selected = _state4.selected,
	        filter = _state4.filter,
	        term = _state4.term;
	    var organisationId = _this3.props.organisationId;
	
	
	    var filterText = _this3.getFilterText(filter, term);
	
	    var shortlist = _this3.jsonClient.create('shortlists');
	    shortlist.set('name', name);
	    shortlist.set('notes', filterText || 'notes for the shortlist...');
	    shortlist.set('organisation', {
	      type: 'organisations',
	      id: organisationId
	    });
	    shortlist.set('dataMap', {});
	    shortlist.set('selectedPlatforms', { instagram: true });
	    var influencers = _lodash2.default.map(selected, function (row) {
	      return { type: 'influencer', id: row.id };
	    });
	    var links = _lodash2.default.map(selected, function (row) {
	      return { type: 'influencerLink', id: row.linkId };
	    });
	
	    shortlist.set('influencers', _lodash2.default.uniqBy(influencers, 'id'));
	    shortlist.set('influencerLinks', _lodash2.default.uniqBy(links, 'id'));
	
	    shortlist.sync().then(function (list) {
	      var listJson = list.toJSON();
	      _this3.context.router.push('/shortlists/' + listJson.id);
	    });
	  };
	
	  this.handleCheckChange = function (e, _ref2) {
	    var checked = _ref2.checked,
	        value = _ref2.value;
	    var selected = _this3.state.selected;
	
	    var newSelected = _lodash2.default.clone(selected);
	    if (checked) {
	      newSelected.push(value);
	    } else {
	      _lodash2.default.remove(newSelected, { id: value.id });
	    }
	
	    _this3.setState({
	      selected: newSelected
	    });
	  };
	
	  this.incrementPage = function () {
	    _this3.setPage(1);
	  };
	
	  this.decrementPage = function () {
	    _this3.setPage(-1);
	  };
	
	  this.handeRedirectToInfluencerProfile = function (id) {
	    _this3.context.router.push('/influencer/' + id + '/statistics');
	  };
	
	  this.handleSearchKeywordChange = function (e, _ref3) {
	    var value = _ref3.value;
	    var _state5 = _this3.state,
	        filter = _state5.filter,
	        errors = _state5.errors;
	
	
	    var sliderHasValues = filter.min || filter.max;
	    var hasPlatform = filter.platform;
	
	    errors.platform = _ramda2.default.and(!hasPlatform, sliderHasValues);
	    errors.slider = _ramda2.default.and(hasPlatform, !sliderHasValues);
	
	    if (_ramda2.default.or(errors.platform, errors.slider)) {
	      _this3.setState({ errors: errors });
	    } else {
	      _this3.setState({ term: value, errors: errors });
	    }
	  };
	
	  this.handleSearchButtonClick = function (filter) {
	    var term = filter.term,
	        searchType = filter.searchType,
	        min = filter.min,
	        max = filter.max,
	        platform = filter.platform,
	        country = filter.country,
	        minInstagramEngagementRate = filter.minInstagramEngagementRate,
	        maxInstagramEngagementRate = filter.maxInstagramEngagementRate,
	        ageGroup = filter.ageGroup,
	        gender = filter.gender,
	        ethnicity = filter.ethnicity;
	    var onSearchParamsChange = _this3.props.onSearchParamsChange;
	
	    var currentPage = 1;
	    onSearchParamsChange({ filter: filter, currentPage: currentPage });
	    _this3.setState({
	      currentPage: currentPage,
	      filter: {
	        term: term,
	        searchType: searchType,
	        min: min,
	        max: max,
	        platform: platform,
	        country: country,
	        minInstagramEngagementRate: minInstagramEngagementRate,
	        maxInstagramEngagementRate: maxInstagramEngagementRate,
	        ageGroup: ageGroup,
	        gender: gender,
	        ethnicity: ethnicity
	      }
	    }, _this3.fetch);
	  };
	
	  this.handlePageRedirect = function (e, _ref4) {
	    var value = _ref4.value;
	
	    _this3.context.router.push('/influencers/' + value + '/latest');
	  };
	
	  this.handlePerPageChange = function (e, option) {
	    _this3.setState({ perPage: option.value }, function () {
	      _this3.fetch();
	      localStorage.setItem('' + _staticConfiguration.LS_PER_PAGE_KEY + _authService.authService.uid(), option.value);
	    });
	  };
	
	  this.handleSorting = function (field, current) {
	    var _state6 = _this3.state,
	        sort = _state6.sort,
	        links = _state6.links,
	        perPage = _state6.perPage,
	        totalInfluencers = _state6.totalInfluencers;
	    var onSearchParamsChange = _this3.props.onSearchParamsChange;
	
	    if (!links) return;
	
	    sort.field = field;
	    sort.order = !current || current === 'ascending' ? 'DESC' : 'ASC';
	
	    onSearchParamsChange({ sort: sort });
	
	    _this3.setState({
	      sort: sort
	    }, _this3.fetch);
	  };
	
	  this.deleteLink = function () {
	    var value = _this3.state.toBeDeleted;
	    var url = ("https://api2.dyzio.co/v1") + '/influencerLink/' + value;
	    _this3.restClient.delete(url).then(function () {
	      var links = _this3.state.links;
	
	      _lodash2.default.remove(links, {
	        id: value
	      });
	
	      _this3.setState({
	        confirmOpen: false,
	        links: links
	      });
	    });
	  };
	
	  this.handleCancel = function () {
	    _this3.setState({
	      toBeDeleted: null,
	      confirmOpen: false
	    });
	  };
	
	  this.fetchIf = _lodash2.default.debounce(function () {
	    var term = _this3.state.term;
	
	    var alwaysSearch = true; // take this out with a delay
	    if (term && term.length >= 3 || alwaysSearch) {
	      _this3.fetch();
	    }
	  }, 500);
	
	  this.handleCheckAllInfluencers = function (e, checkbox) {
	    var links = _this3.state.links;
	
	    if (checkbox.checked) {
	      var selected = _lodash2.default.map(links, function (link) {
	        var details = link.lookupInfluencer;
	        var id = details.id,
	            name = details.name,
	            thumbnail = details.thumbnail,
	            primarySocialHandle = details.primarySocialHandle;
	
	        return {
	          id: id,
	          name: name,
	          thumbnail: thumbnail,
	          primarySocialHandle: primarySocialHandle,
	          linkId: link.id
	        };
	      });
	      _this3.setState({
	        selected: selected
	      });
	    } else {
	      _this3.setState({
	        selected: []
	      });
	    }
	  };
	
	  this.handleDeleteInfluencer = function () {
	    _this3.setState({
	      confirmOpen: true
	    });
	  };
	
	  this.formatCountries = function (row) {
	    var mapping = _lodash2.default.find(countryList.default, ['key', row.isoCode]);
	    return mapping ? {
	      key: row.isoCode,
	      value: row.isoCode,
	      count: row.influencerCount,
	      text: mapping.text + ' (' + row.influencerCount + ')'
	    } : [];
	  };
	
	  this.deleteSelectedInfluencers = function () {
	    var _state7 = _this3.state,
	        selected = _state7.selected,
	        links = _state7.links;
	
	    var ids = _lodash2.default.map(selected, 'linkId');
	    var requests = _lodash2.default.map(ids, function (value) {
	      return _this3.restClient.delete(("https://api2.dyzio.co/v1") + '/influencerLink/' + value);
	    });
	
	    _axios2.default.all(requests).then(function () {
	      var newLinks = _lodash2.default.filter(links, function (link) {
	        return !_lodash2.default.includes(ids, link.id);
	      });
	      _this3.setState({
	        selected: [],
	        links: newLinks,
	        confirmOpen: false
	      });
	    });
	  };
	
	  this.popupToggleHandler = function () {
	    _this3.setState({
	      confirmOpen: false
	    });
	  };
	
	  this.fetchReportUrls = function () {
	    var _props3 = _this3.props,
	        organisationId = _props3.organisationId,
	        organisationSlug = _props3.organisationSlug;
	
	    var fileExtensions = ['csv', 'xlsx'];
	    _lodash2.default.forEach(fileExtensions, function (extension) {
	      var fileName = organisationSlug + '-' + organisationId + '/' + organisationSlug + '-influencers.' + extension;
	      _this3.checkReportFilePresence(fileName, extension);
	    });
	  };
	
	  this.toggleColumnChooserModal = function () {
	    var _props4 = _this3.props,
	        userId = _props4.userInfo.userId,
	        dyzioStorage = _props4.dyzioStorage;
	    var _state8 = _this3.state,
	        columnsSettings = _state8.columnsSettings,
	        triggerBusinessUnitsFilter = _state8.triggerBusinessUnitsFilter;
	
	    dyzioStorage.updateTableColumnSettings({
	      userId: userId,
	      settings: columnsSettings
	    });
	    // trigger BU api filtering
	    if (triggerBusinessUnitsFilter) {
	      _this3.fetch();
	      _this3.setState({
	        triggerBusinessUnitsFilter: false
	      });
	    }
	    _this3.setState(function (prevState) {
	      return {
	        columnsChooseModalVisible: !prevState.columnsChooseModalVisible
	      };
	    });
	  };
	
	  this.redirectToAddInfluencer = function () {
	    _this3.context.router.push('/influencer/add');
	  };
	
	  this.onNewTagSelected = function (tagId, mustMatchAllTags) {
	    var updateSelectedTags = function updateSelectedTags(currentTags, id) {
	      if (tagId) {
	        var included = _lodash2.default.some(currentTags, function (tg) {
	          return _lodash2.default.eq(tg, id);
	        });
	        return included ? [].concat(_toConsumableArray(_lodash2.default.reject(currentTags, function (tg) {
	          return _lodash2.default.eq(id, tg);
	        }))) : [].concat(_toConsumableArray(currentTags), [id]);
	      }
	      return [];
	    };
	    var onSearchParamsChange = _this3.props.onSearchParamsChange;
	
	    var currentTags = _lodash2.default.get(_this3.state, 'filter.selectedTags', []);
	    var tagsFilter = { selectedTags: updateSelectedTags(currentTags, tagId), mustMatchAllTags: mustMatchAllTags };
	    onSearchParamsChange({ filter: tagsFilter, currentPage: 1 });
	    _this3.setState({
	      filter: tagsFilter
	    }, _this3.fetch);
	  };
	
	  this.onTagsSwitchToggle = function (isChecked) {
	    var onSearchParamsChange = _this3.props.onSearchParamsChange;
	
	    var tagsFilter = _extends({}, _this3.state.filter, { mustMatchAllTags: isChecked });
	    onSearchParamsChange({ filter: tagsFilter, currentPage: 1 });
	    _this3.setState({
	      filter: tagsFilter
	    }, _this3.fetch);
	  };
	};
	
	InfluencerTable.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	InfluencerTable.propTypes = {
	  userInfo: _propTypes2.default.object.isRequired,
	  dyzioStorage: _propTypes2.default.object.isRequired,
	  searchParams: _propTypes2.default.object.isRequired,
	  onSearchParamsChange: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasLocalstorageClient2.default, _hasUserInfo2.default)(InfluencerTable);

/***/ },
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _capitalize = __webpack_require__(575);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _actions = __webpack_require__(359);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _campaigns = __webpack_require__(129);
	
	var _avatar = __webpack_require__(191);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _influencerCampaignCard = __webpack_require__(1958);
	
	var _influencerCampaignCard2 = _interopRequireDefault(_influencerCampaignCard);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _authService = __webpack_require__(21);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _influencerSetupForm = __webpack_require__(879);
	
	var _influencerSetupForm2 = _interopRequireDefault(_influencerSetupForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfluencerSetupModal = function InfluencerSetupModal(props) {
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    Object.assign({
	      hasActionButton: true,
	      actionButtonContent: 'Close',
	      headerText: 'Complete your profile',
	      onActionButtonClick: props.onClose
	    }, props),
	    _react2.default.createElement(_influencerSetupForm2.default, { influencer: props.influencer })
	  );
	};
	
	var ENROLLED_BY = {
	  self: 'SELF'
	};
	
	var InfluencersCampaignList = function (_React$Component) {
	  _inherits(InfluencersCampaignList, _React$Component);
	
	  function InfluencersCampaignList(props, context) {
	    _classCallCheck(this, InfluencersCampaignList);
	
	    var _this = _possibleConstructorReturn(this, (InfluencersCampaignList.__proto__ || Object.getPrototypeOf(InfluencersCampaignList)).call(this, props, context));
	
	    _this.closeinfluencerSetupModal = function () {
	      _this.setState({
	        influencerSetupModalVisible: false
	      });
	    };
	
	    _this.loadInfluencer = function () {
	      var profile = _authService.authService.getProfile();
	      var organisationId = profile.app_metadata.dyzio.o_id;
	
	      var jsonAPIClient = _this.props.jsonAPIClient;
	
	      jsonAPIClient.get('organisations', organisationId, { include: ['influencer'] }).then(function (organisation) {
	        return organisation.toJSONTree();
	      }).then(function (org) {
	        var influencer = org.influencer;
	
	        console.log(influencer);
	        var selfEnrolled = influencer.enrolledBy === ENROLLED_BY.self;
	        var influencerSetupModalVisible = selfEnrolled && !influencer.setupComplete;
	        _this.setState({
	          influencer: influencer,
	          influencerSetupModalVisible: influencerSetupModalVisible,
	          selfEnrolled: selfEnrolled
	        });
	      }).catch(function (e) {
	        console.log(e);
	      });
	    };
	
	    _this.toggleViewPeople = function () {
	      _this.setState({ viewPeople: !_this.state.viewPeople });
	    };
	
	    _this.redirectToCampaignPage = function (id) {
	      // INFLUENCERS MUST NOT USE THE NEW CAMPAIGN ROUTE!!!
	      _this.context.router.push('/acr-campaign/' + id + '?collaborations');
	    };
	
	    _this.setPermissionStatus = function (campaignPermissionId, campaignId, status) {
	      return function () {
	        _this.props.onSetPermissionStatus(campaignPermissionId, campaignId, status);
	        _this.setState({ archiving: { modal: false } });
	      };
	    };
	
	    _this.state = {
	      viewPeople: false,
	      campaignPeople: [],
	      archiving: {
	        modal: false,
	        permissionId: null,
	        campaignId: null
	      },
	      influencer: null,
	      influencerSetupModalVisible: false,
	      selfEnrolled: false
	    };
	    return _this;
	  }
	
	  _createClass(InfluencersCampaignList, [{
	    key: 'getCampaignMembers',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(id) {
	        var returnedData, dataToTree, members;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (id) {
	                  _context.next = 2;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 2:
	                _context.prev = 2;
	                _context.next = 5;
	                return (0, _campaigns.getCampaignMembers)(id);
	
	              case 5:
	                returnedData = _context.sent;
	                dataToTree = returnedData.toJSONTree();
	                members = dataToTree.members;
	
	                this.setState({ viewPeople: true, campaignPeople: members });
	                _context.next = 14;
	                break;
	
	              case 11:
	                _context.prev = 11;
	                _context.t0 = _context['catch'](2);
	
	                (0, _errorHandlingService.reportError)('GET_CAMPAIGN_MEMBERS_LIST_ERROR', _context.t0.message);
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[2, 11]]);
	      }));
	
	      function getCampaignMembers(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getCampaignMembers;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Load the users campaign list
	      this.props.onLoadingCampaignsList();
	      this.loadInfluencer();
	    }
	  }, {
	    key: 'findClick',
	    value: function findClick(id, path, e) {
	      // let isClickInsidePeople = this.refs['people-' + id].contains(e.target);
	      // if (isClickInsidePeople) {
	      //   this.getCampaignMembers(id);
	      // }
	
	      var isClickInsidePermissionStatus = this.refs['permission-status-' + id].contains(e.target);
	      if (!isClickInsidePermissionStatus) {
	        this.context.router.push(path);
	      }
	    }
	  }, {
	    key: 'onOutsideClick',
	    value: function onOutsideClick(event) {
	      var isClickInside = this.refs.modal_content.contains(event.target);
	      if (this.state.viewPeople && !isClickInside) {
	        this.setState({ viewPeople: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          campaignsList = _props.campaignsList,
	          campaignsLoadError = _props.campaignsLoadError,
	          campaignsLoading = _props.campaignsLoading,
	          showCampaignsList = _props.showCampaignsList,
	          userData = _props.userData;
	      var _state = this.state,
	          influencerSetupModalVisible = _state.influencerSetupModalVisible,
	          influencer = _state.influencer,
	          selfEnrolled = _state.selfEnrolled;
	
	
	      var profile = _authService.authService.getProfile();
	      var userRole = profile.app_metadata.dyzio.role;
	      var userIsInfluencer = userRole === _staticConfiguration.INFLUENCER;
	
	      var getFriendlyRole = function getFriendlyRole(role) {
	        return _capitalize2.default.words(role.replace('_', ' ').toLowerCase());
	      };
	      var filteredCampaignList = campaignsList.filter(function (campaignPermission) {
	        return campaignPermission.get('status') === showCampaignsList;
	      });
	
	      console.log(filteredCampaignList.toJSON());
	
	      var isVoxogram = window.location.hostname === 'app.voxogram.com';
	      var displayName = isVoxogram ? 'voxogram' : 'dyzio';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'grid', onClick: campaignsLoading ? '' : this.onOutsideClick.bind(this) },
	        showCampaignsList === _staticConfiguration.ARCHIVED && _react2.default.createElement(
	          'p',
	          { className: 'small light info' },
	          'Archived campaigns are hidden for you but are still available to others.'
	        ),
	        campaignsLoadError && _react2.default.createElement(
	          'div',
	          { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hero left' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'There was a problem loading your campaigns. ',
	              campaignsLoadError
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Please check you are connected to the internet and try again.'
	            )
	          )
	        ),
	        influencerSetupModalVisible && _react2.default.createElement(InfluencerSetupModal, { influencer: influencer, onClose: this.closeinfluencerSetupModal }),
	        userIsInfluencer && _react2.default.createElement(
	          'div',
	          { style: { padding: '0px 15px' } },
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            { columns: 2, divided: true },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 10 },
	                _react2.default.createElement(
	                  _semanticUiReact.Card,
	                  { color: 'pink', fluid: true },
	                  _react2.default.createElement(_semanticUiReact.Card.Content, { header: 'Welcome to ' + displayName + ' - so what does it do?' }),
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      displayName,
	                      ' allows agencies and brands to easily create influencer marketing campaign reports. By authorising ',
	                      displayName,
	                      ' to read data from your social channels, your client can then see live data for your campaign posts, without constantly bothering you for screenshots or data requests.'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Once your channels are authenticated (read-only access),  allows your client to see the data related to your posts and no one else.'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      displayName,
	                      ' is ',
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        'FREE'
	                      ),
	                      ' for influencers to authenticate, plus there are some great free features arriving soon, to help you manage your business and brand activities.'
	                    ),
	                    _react2.default.createElement('br', null)
	                  ),
	                  !isVoxogram && _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    { extra: true },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'help circle outline' }),
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        href: 'https://help.dyzio.co/dyzio-contextual-help/welcome-to-dyzio',
	                        target: '_blank',
	                        rel: 'noopener noreferrer'
	                      },
	                      'find out more about ',
	                      displayName,
	                      '...'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: 6 },
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  {
	                    inverted: true,
	                    color: 'pink',
	                    fluid: true,
	                    size: 'massive',
	                    icon: true,
	                    labelPosition: 'left',
	                    onClick: function onClick() {
	                      return _this2.context.router.push('/influencer/authorisation');
	                    }
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlock alternate' }),
	                  'Click here to Authorise'
	                ),
	                selfEnrolled && _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    _semanticUiReact.Button,
	                    {
	                      inverted: true,
	                      color: 'blue',
	                      fluid: true,
	                      icon: true,
	                      labelPosition: 'left',
	                      onClick: function onClick() {
	                        return _this2.setState({ influencerSetupModalVisible: true });
	                      }
	                    },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'wpforms' }),
	                    'show profile setup form'
	                  )
	                ),
	                !isVoxogram && _react2.default.createElement(
	                  _semanticUiReact.Message,
	                  { info: true },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'help circle outline' }),
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: 'https://help.dyzio.co/influencer-experience/authorising-dyzio',
	                      target: '_blank',
	                      rel: 'noopener noreferrer'
	                    },
	                    'Need help authorising ',
	                    displayName,
	                    '?'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Campaigns'
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Group,
	          { itemsPerRow: 3, style: { margin: '0px 15px' } },
	          _lodash2.default.map(filteredCampaignList.toArray(), function (campaignPermission) {
	            return _react2.default.createElement(_influencerCampaignCard2.default, Object.assign({}, campaignPermission.toJSON(), {
	              onClick: _this2.redirectToCampaignPage
	            }));
	          })
	        ),
	        campaignsLoading && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-2-6 grid-xl-2-6' },
	            _react2.default.createElement('div', { className: 'box loading' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-2-6 grid-xl-2-6' },
	            _react2.default.createElement('div', { className: 'box loading' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-2-6 grid-xl-2-6' },
	            _react2.default.createElement('div', { className: 'box loading' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.viewPeople ? 'custom-modal visible' : 'custom-modal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content', ref: 'modal_content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'top' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'People on this campaign'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-close' },
	              _react2.default.createElement('img', { src: '/icons/close.svg', alt: 'close', onClick: this.toggleViewPeople })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement(
	                'div',
	                { className: 'members-list' },
	                _react2.default.createElement(
	                  'table',
	                  null,
	                  this.state.campaignPeople.length !== 0 && _react2.default.createElement(
	                    'tbody',
	                    null,
	                    this.state.campaignPeople.map(function (person) {
	                      var personName = person.name;
	                      var personId = person.id;
	                      var role = person.role;
	                      var email = person.email;
	                      return _react2.default.createElement(
	                        'tr',
	                        { key: personId },
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'avatar' },
	                          _react2.default.createElement(_avatar2.default, { name: personName, role: role, email: email, pending: false, size: 44, noTooltip: true })
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            personName
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'spacer small' }),
	            _react2.default.createElement(
	              'button',
	              { className: 'medium rose stretch', onClick: this.toggleViewPeople },
	              'Done'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.archiving.modal ? 'custom-modal visible' : 'custom-modal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'top' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Archive this campaign'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-close' },
	              _react2.default.createElement('img', { src: '/icons/close.svg', alt: 'close', onClick: function onClick() {
	                  return _this2.setState({ archiving: { modal: false } });
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'By archiving this campaign it will no longer be one of your active campaigns. However, other people on this campaign can still choose to see it.'
	              ),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              _react2.default.createElement(
	                'button',
	                { className: 'large rose stretch', onClick: this.setPermissionStatus(this.state.archiving.permissionId, this.state.archiving.campaignId, _staticConfiguration.ARCHIVED) },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Archive campaign'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InfluencersCampaignList;
	}(_react2.default.Component);
	
	InfluencersCampaignList.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    userData: state.userData.get('userData'),
	    campaignsList: state.campaignList.get('campaigns'),
	    showCampaignsList: state.campaignList.get('showCampaignsList'),
	    archivedCampaignsList: state.campaignList.get('archivedCampaigns'),
	    campaignsLoadError: state.campaignList.get('campaignsLoadError'),
	    campaignsLoading: state.campaignList.get('campaignsLoading')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onLoadingCampaignsList: function onLoadingCampaignsList(statusFilter) {
	      return dispatch((0, _actions.loadingCampaignsList)(statusFilter));
	    },
	    onSetPermissionStatus: function onSetPermissionStatus(campaignPermissionId, campaignId, status) {
	      return dispatch((0, _actions.setPermissionStatus)(campaignPermissionId, campaignId, status));
	    }
	  };
	}
	
	exports.default = (0, _recompose.compose)(_hasJsonapiClient2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InfluencersCampaignList));

/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _constants = __webpack_require__(282);
	
	var initialState = (0, _immutable.fromJS)({
	  campaigns: {},
	  showCampaignsList: _staticConfiguration.ACTIVE,
	  loading: false,
	  campaignsLoadError: null,
	  campaignsLoading: false
	});
	
	function campaignsListReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.LOAD_CAMPAIGNS:
	      return state.set('loading', true).set('campaignsLoadError', null).set('campaignsLoading', true);
	    case _constants.LOAD_CAMPAIGNS_SUCCESS:
	      return state.set('campaigns', action.campaigns).set('loading', false).set('campaignsLoadError', null).set('campaignsLoading', false);
	    case _constants.LOAD_CAMPAIGNS_ERROR:
	      return state.set('campaignsLoadError', action.error).set('loading', false).set('campaignsLoading', false);
	    case _constants.UPDATE_SHOW_CAMPAIGNS_LIST:
	      return state.set('showCampaignsList', action.campaignPermissionStatus);
	    case _constants.UPDATE_PERMISSION:
	      return state.setIn(['campaigns', action.campaignId, 'status'], action.status);
	    case _constants.SET_CAMPAIGN_PERMISSION:
	      {
	        var permission = (0, _immutable.fromJS)(action.campaignPermission);
	        return state.set('campaigns', state.get('campaigns').set(permission.getIn(['campaign', 'id']), permission));
	      }
	    default:
	      return state;
	  }
	}
	
	exports.default = campaignsListReducer;

/***/ },
/* 2161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.loadCampaigns = loadCampaigns;
	exports.updateCampaignPermissionStatus = updateCampaignPermissionStatus;
	exports.watchUpdatePermissionStatus = watchUpdatePermissionStatus;
	exports.watchCampaigns = watchCampaigns;
	exports.default = campaignSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _campaignPermissions = __webpack_require__(363);
	
	var _userSelectors = __webpack_require__(118);
	
	var _campaignPermissionSelectors = __webpack_require__(285);
	
	var _influencerCampaigns = __webpack_require__(2384);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _constants = __webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadCampaigns, updateCampaignPermissionStatus, watchUpdatePermissionStatus, watchCampaigns, campaignSagas].map(_regenerator2.default.mark);
	
	function loadCampaigns(actions) {
	  var userId, campaignPermissionsJSON, campaignPermissions, immutableCampaignPermissions, sortedImmutableCampaignPermissions;
	  return _regenerator2.default.wrap(function loadCampaigns$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 3:
	          userId = _context.sent;
	          _context.next = 6;
	          return (0, _effects.call)(_influencerCampaigns.getInfluencerCampaignPermissions, userId);
	
	        case 6:
	          campaignPermissionsJSON = _context.sent;
	          campaignPermissions = formatCampaignPermissions(campaignPermissionsJSON);
	          immutableCampaignPermissions = (0, _immutable.fromJS)(campaignPermissions);
	          sortedImmutableCampaignPermissions = immutableCampaignPermissions.sort(function (campaign1, campaign2) {
	            var d1 = campaign1.getIn(['campaign', 'createdDate']);
	            var d2 = campaign2.getIn(['campaign', 'createdDate']);
	            if ((0, _moment2.default)(d1).isBefore(d2)) return 1;
	            if ((0, _moment2.default)(d1).isAfter(d2)) return -1;
	            return 0;
	          });
	          _context.next = 12;
	          return (0, _effects.put)({ type: _constants.LOAD_CAMPAIGNS_SUCCESS, campaigns: sortedImmutableCampaignPermissions });
	
	        case 12:
	          _context.next = 19;
	          break;
	
	        case 14:
	          _context.prev = 14;
	          _context.t0 = _context['catch'](0);
	
	          (0, _errorHandlingService.reportError)('LOAD_CAMPAIGNS_LIST_ERROR', _context.t0.message);
	          _context.next = 19;
	          return (0, _effects.put)({ type: _constants.LOAD_CAMPAIGNS_ERROR, error: _context.t0.message });
	
	        case 19:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 14]]);
	}
	
	function formatCampaignPermissions(campaignPermissions) {
	  var campaignPermissionsFormatted = {};
	  campaignPermissions.forEach(function (campaignPermission) {
	    campaignPermissionsFormatted[campaignPermission.campaign.id] = campaignPermission;
	  });
	  return campaignPermissionsFormatted;
	}
	
	function updateCampaignPermissionStatus(actions) {
	  var status, permissionId, campaignId, archivedCampaignPermissions;
	  return _regenerator2.default.wrap(function updateCampaignPermissionStatus$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          status = actions.status;
	          permissionId = actions.campaignPermissionId;
	          campaignId = actions.campaignId;
	          _context2.prev = 3;
	          _context2.next = 6;
	          return (0, _effects.call)(_campaignPermissions.updatePermissionStatus, permissionId, status);
	
	        case 6:
	          _context2.next = 8;
	          return (0, _effects.put)({ type: _constants.UPDATE_PERMISSION, campaignPermissionId: permissionId, campaignId: campaignId, status: status });
	
	        case 8:
	          _context2.next = 10;
	          return (0, _effects.select)(_campaignPermissionSelectors.getCampaignPermissionsByStatus, _staticConfiguration.ARCHIVED);
	
	        case 10:
	          archivedCampaignPermissions = _context2.sent;
	
	          if (!(archivedCampaignPermissions.size === 0)) {
	            _context2.next = 14;
	            break;
	          }
	
	          _context2.next = 14;
	          return (0, _effects.put)({ type: _constants.UPDATE_SHOW_CAMPAIGNS_LIST, campaignPermissionStatus: _staticConfiguration.ACTIVE });
	
	        case 14:
	          _context2.next = 19;
	          break;
	
	        case 16:
	          _context2.prev = 16;
	          _context2.t0 = _context2['catch'](3);
	
	          (0, _errorHandlingService.reportError)('UPDATE_CAMPAIGN_PERMISSION_STATUS_ERROR', _context2.t0.message);
	
	        case 19:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[3, 16]]);
	}
	
	function watchUpdatePermissionStatus() {
	  return _regenerator2.default.wrap(function watchUpdatePermissionStatus$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.SET_PERMISSION_STATUS, updateCampaignPermissionStatus);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function watchCampaigns() {
	  return _regenerator2.default.wrap(function watchCampaigns$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.LOAD_CAMPAIGNS, loadCampaigns);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function campaignSagas() {
	  return _regenerator2.default.wrap(function campaignSagas$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(watchUpdatePermissionStatus), (0, _effects.fork)(watchCampaigns)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 2162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadInfluencers = loadInfluencers;
	exports.loadSingleInfluencer = loadSingleInfluencer;
	exports.search = search;
	exports.addInfluencer = addInfluencer;
	exports.loadOrganisationName = loadOrganisationName;
	exports.changeTab = changeTab;
	
	var _constants = __webpack_require__(560);
	
	function loadInfluencers(page) {
	  return {
	    type: _constants.LOAD_INFLUENCERS,
	    page: page
	  };
	}
	
	function loadSingleInfluencer(id) {
	  return {
	    type: _constants.LOAD_SINGLE_INFLUENCER,
	    id: id
	  };
	}
	
	function search(term) {
	  return {
	    type: _constants.SEARCH,
	    term: term
	  };
	}
	
	function addInfluencer(data, details) {
	  return {
	    type: _constants.ADD_INFLUENCER,
	    data: data,
	    details: details
	  };
	}
	
	function loadOrganisationName() {
	  return {
	    type: _constants.LOAD_ORGANISATION_NAME
	  };
	}
	
	function changeTab(tab) {
	  return {
	    type: _constants.CHANGE_TAB,
	    tab: tab
	  };
	}

/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _shortid = __webpack_require__(525);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _constants = __webpack_require__(560);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = (0, _immutable.fromJS)({
	  data: null,
	  singleData: null,
	  error: null,
	  success: null,
	  loading: false,
	  add: false,
	  count: 0,
	  searchData: null,
	  searchError: null,
	  searchLoading: false,
	  organisationName: null
	});
	
	function influencersReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.LOAD_INFLUENCERS:
	      return state.set('data', null).set('loading', true).set('count', 0);
	    case _constants.LOAD_INFLUENCERS_SUCCESS:
	      return state.set('data', action.data).set('error', null).set('loading', false).set('count', action.count);
	    case _constants.LOAD_INFLUENCERS_ERROR:
	      return state.set('loading', false).set('error', action.data).set('count', 0);
	    case _constants.LOAD_SINGLE_INFLUENCER:
	      return state.set('data', null).set('loading', true);
	    case _constants.LOAD_SINGLE_INFLUENCER_SUCCESS:
	      return state.set('singleData', action.data).set('error', null).set('loading', false);
	    case _constants.LOAD_SINGLE_INFLUENCER_ERROR:
	      return state.set('loading', false).set('error', action.data);
	    case _constants.SEARCH:
	      return state.set('searchData', null).set('searchLoading', true);
	    case _constants.SEARCH_SUCCESS:
	      return state.set('searchData', action.data).set('searchError', null).set('searchLoading', false);
	    case _constants.SEARCH_ERROR:
	      return state.set('searchError', action.data).set('searchLoading', false);
	    case _constants.ADD_INFLUENCER:
	      return state.set('loading', true);
	    case _constants.ADD_INFLUENCER_SUCCESS:
	      {
	        var cachebuster = _shortid2.default.generate();
	        window.location.assign('/influencers?cb=' + cachebuster);
	        return state.set('loading', false).set('success', 'Your new influencer has been successfully added!').set('error', null);
	      }
	    case _constants.ADD_INFLUENCER_EROR:
	      return state.set('loading', false).set('error', action.data);
	    case _constants.LOAD_ORGANISATION_NAME_SUCCESS:
	      return state.set('organisationName', action.data);
	    case _constants.LOAD_ORGANISATION_NAME_ERROR:
	      return state.set('organisationName', 'Organisation Name Load Error');
	    default:
	      return state;
	  }
	}
	
	exports.default = influencersReducer;

/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.loadInfluencersData = loadInfluencersData;
	exports.loadSingleInfluencerData = loadSingleInfluencerData;
	exports.loadSearchData = loadSearchData;
	exports.setInfluencerData = setInfluencerData;
	exports.loadOrganisationData = loadOrganisationData;
	exports.watchLoadInfluencers = watchLoadInfluencers;
	exports.watchLoadSingleInfluencer = watchLoadSingleInfluencer;
	exports.watchSearch = watchSearch;
	exports.watchAddInfluencer = watchAddInfluencer;
	exports.watchLoadOrganisationName = watchLoadOrganisationName;
	exports.default = InfluencersSaga;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _influencers = __webpack_require__(2385);
	
	var _userSelectors = __webpack_require__(118);
	
	var _constants = __webpack_require__(560);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadInfluencersData, loadSingleInfluencerData, loadSearchData, setInfluencerData, loadOrganisationData, watchLoadInfluencers, watchLoadSingleInfluencer, watchSearch, watchAddInfluencer, watchLoadOrganisationName, InfluencersSaga].map(_regenerator2.default.mark);
	
	function loadInfluencersData(action) {
	  var page, organisationId, influencerData, influencerCount;
	  return _regenerator2.default.wrap(function loadInfluencersData$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          page = action.page;
	          _context.next = 4;
	          return (0, _effects.select)(_userSelectors.getOrganisationId);
	
	        case 4:
	          organisationId = _context.sent;
	          _context.next = 7;
	          return (0, _effects.call)(_influencers.findInfluencers, organisationId, page);
	
	        case 7:
	          influencerData = _context.sent;
	          _context.next = 10;
	          return (0, _effects.call)(_influencers.countInfluencers, organisationId);
	
	        case 10:
	          influencerCount = _context.sent;
	          _context.next = 13;
	          return (0, _effects.put)({
	            type: _constants.LOAD_INFLUENCERS_SUCCESS,
	            data: (0, _immutable.fromJS)(influencerData),
	            count: influencerCount
	          });
	
	        case 13:
	          _context.next = 19;
	          break;
	
	        case 15:
	          _context.prev = 15;
	          _context.t0 = _context['catch'](0);
	          _context.next = 19;
	          return (0, _effects.put)({ type: _constants.LOAD_INFLUENCERS_ERROR, data: _context.t0.title });
	
	        case 19:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 15]]);
	}
	
	function loadSingleInfluencerData(action) {
	  var organisationId, influencerData;
	  return _regenerator2.default.wrap(function loadSingleInfluencerData$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.select)(_userSelectors.getOrganisationId);
	
	        case 3:
	          organisationId = _context2.sent;
	          _context2.next = 6;
	          return (0, _effects.call)(_influencers.getInfluencer, organisationId, action.id);
	
	        case 6:
	          influencerData = _context2.sent;
	          _context2.next = 9;
	          return (0, _effects.put)({ type: _constants.LOAD_SINGLE_INFLUENCER_SUCCESS, data: (0, _immutable.fromJS)(influencerData) });
	
	        case 9:
	          _context2.next = 15;
	          break;
	
	        case 11:
	          _context2.prev = 11;
	          _context2.t0 = _context2['catch'](0);
	          _context2.next = 15;
	          return (0, _effects.put)({ type: _constants.LOAD_SINGLE_INFLUENCER_ERROR, data: _context2.t0.title });
	
	        case 15:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 11]]);
	}
	
	function loadSearchData(action) {
	  var term, organisationId, searchData, searchArray;
	  return _regenerator2.default.wrap(function loadSearchData$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.prev = 0;
	          term = action.term;
	          _context3.next = 4;
	          return (0, _effects.select)(_userSelectors.getOrganisationId);
	
	        case 4:
	          organisationId = _context3.sent;
	          _context3.next = 7;
	          return (0, _effects.call)(_influencers.runSearch, organisationId, term);
	
	        case 7:
	          searchData = _context3.sent;
	          searchArray = [];
	
	          searchData.forEach(function (item) {
	            var flattened = item.toJSON();
	            var influencer = {
	              title: flattened.name,
	              description: flattened.primarySocialHandle,
	              image: flattened.thumbnail
	            };
	
	            searchArray.push(influencer);
	          });
	          _context3.next = 12;
	          return (0, _effects.put)({ type: _constants.SEARCH_SUCCESS, data: searchArray });
	
	        case 12:
	          _context3.next = 18;
	          break;
	
	        case 14:
	          _context3.prev = 14;
	          _context3.t0 = _context3['catch'](0);
	          _context3.next = 18;
	          return (0, _effects.put)({ type: _constants.SEARCH_ERROR, data: _context3.t0.title });
	
	        case 18:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this, [[0, 14]]);
	}
	
	function setInfluencerData(action) {
	  var data, details, influencerId, influencerDetailsId, organisationId;
	  return _regenerator2.default.wrap(function setInfluencerData$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.prev = 0;
	          data = action.data, details = action.details;
	          _context4.next = 4;
	          return (0, _effects.call)(_influencers.addInfluencer, data);
	
	        case 4:
	          influencerId = _context4.sent;
	          _context4.next = 7;
	          return (0, _effects.call)(_influencers.addInfluencerDetails, details);
	
	        case 7:
	          influencerDetailsId = _context4.sent;
	          _context4.next = 10;
	          return (0, _effects.select)(_userSelectors.getOrganisationId);
	
	        case 10:
	          organisationId = _context4.sent;
	          _context4.next = 13;
	          return (0, _effects.call)(_influencers.addInfluencerLink, organisationId, influencerId, influencerDetailsId);
	
	        case 13:
	          _context4.next = 15;
	          return (0, _effects.put)({ type: _constants.ADD_INFLUENCER_SUCCESS, data: 'Influencer successfully created!' });
	
	        case 15:
	          _context4.next = 21;
	          break;
	
	        case 17:
	          _context4.prev = 17;
	          _context4.t0 = _context4['catch'](0);
	          _context4.next = 21;
	          return (0, _effects.put)({ type: _constants.ADD_INFLUENCER_EROR, data: _context4.t0.title });
	
	        case 21:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this, [[0, 17]]);
	}
	
	function loadOrganisationData() {
	  var organisationId, name;
	  return _regenerator2.default.wrap(function loadOrganisationData$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.prev = 0;
	          _context5.next = 3;
	          return (0, _effects.select)(_userSelectors.getOrganisationId);
	
	        case 3:
	          organisationId = _context5.sent;
	          _context5.next = 6;
	          return (0, _effects.call)(_influencers.getOrganisationName, organisationId);
	
	        case 6:
	          name = _context5.sent;
	          _context5.next = 9;
	          return (0, _effects.put)({ type: _constants.LOAD_ORGANISATION_NAME_SUCCESS, data: name.name });
	
	        case 9:
	          _context5.next = 15;
	          break;
	
	        case 11:
	          _context5.prev = 11;
	          _context5.t0 = _context5['catch'](0);
	          _context5.next = 15;
	          return (0, _effects.put)({ type: _constants.LOAD_ORGANISATION_NAME_ERROR, data: _context5.t0.title });
	
	        case 15:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this, [[0, 11]]);
	}
	
	function watchLoadInfluencers() {
	  return _regenerator2.default.wrap(function watchLoadInfluencers$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.LOAD_INFLUENCERS, loadInfluencersData);
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}
	
	function watchLoadSingleInfluencer() {
	  return _regenerator2.default.wrap(function watchLoadSingleInfluencer$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.LOAD_SINGLE_INFLUENCER, loadSingleInfluencerData);
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}
	
	function watchSearch() {
	  return _regenerator2.default.wrap(function watchSearch$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.SEARCH, loadSearchData);
	
	        case 2:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[7], this);
	}
	
	function watchAddInfluencer() {
	  return _regenerator2.default.wrap(function watchAddInfluencer$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.ADD_INFLUENCER, setInfluencerData);
	
	        case 2:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked[8], this);
	}
	
	function watchLoadOrganisationName() {
	  return _regenerator2.default.wrap(function watchLoadOrganisationName$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          _context10.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.LOAD_ORGANISATION_NAME, loadOrganisationData);
	
	        case 2:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked[9], this);
	}
	
	function InfluencersSaga() {
	  return _regenerator2.default.wrap(function InfluencersSaga$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          _context11.next = 2;
	          return [(0, _effects.fork)(watchLoadInfluencers)];
	
	        case 2:
	          _context11.next = 4;
	          return [(0, _effects.fork)(watchLoadSingleInfluencer)];
	
	        case 4:
	          _context11.next = 6;
	          return [(0, _effects.fork)(watchSearch)];
	
	        case 6:
	          _context11.next = 8;
	          return [(0, _effects.fork)(watchAddInfluencer)];
	
	        case 8:
	          _context11.next = 10;
	          return [(0, _effects.fork)(watchLoadOrganisationName)];
	
	        case 10:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked[10], this);
	}

/***/ },
/* 2165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _instagramStory = __webpack_require__(599);
	
	var _instagramStory2 = _interopRequireDefault(_instagramStory);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InstagramStoryModal = function (_Component) {
	  _inherits(InstagramStoryModal, _Component);
	
	  function InstagramStoryModal(props) {
	    _classCallCheck(this, InstagramStoryModal);
	
	    var _this = _possibleConstructorReturn(this, (InstagramStoryModal.__proto__ || Object.getPrototypeOf(InstagramStoryModal)).call(this, props));
	
	    _this.state = {
	      isLoading: true,
	      story: null
	    };
	    return _this;
	  }
	
	  _createClass(InstagramStoryModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          restClient = _props.restClient,
	          selectedStory = _props.selectedStory;
	
	      restClient.get('stories/' + selectedStory).then(function (response) {
	        var data = response.data.data;
	
	        _this2.setState({
	          story: data.attributes,
	          isLoading: false
	        });
	      }).catch(function () {
	        return _this2.setState({
	          isLoading: false
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          story = _state.story;
	      var _props2 = this.props,
	          campaignHashtags = _props2.campaignHashtags,
	          selectedStory = _props2.selectedStory,
	          campaignName = _props2.campaignName,
	          onClose = _props2.onClose,
	          inDeleteMode = _props2.inDeleteMode,
	          onDeleteAssetCallback = _props2.onDeleteAssetCallback;
	
	      var campaign = { name: campaignName };
	      return _react2.default.createElement(
	        _dyzioModal2.default,
	        {
	          onClose: onClose,
	          headerText: 'Story'
	        },
	        isLoading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, inverted: true }),
	        !isLoading && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_instagramStory2.default, Object.assign({
	            campaign: campaign,
	            shouldHighlight: true,
	            campaignHashtags: _lodash2.default.map(_lodash2.default.split(campaignHashtags || '', ','), _lodash2.default.trim),
	            fluid: true
	          }, story)),
	          inDeleteMode && _react2.default.createElement(_semanticUiReact.Popup, {
	            position: 'bottom center',
	            content: _react2.default.createElement(
	              'div',
	              { style: { width: 200, textAlign: 'center' } },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Are you sure?'
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              _react2.default.createElement(
	                _semanticUiReact.Button.Group,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { size: 'big', onClick: function onClick() {
	                      return onDeleteAssetCallback(selectedStory);
	                    }, color: 'green' },
	                  'Yes'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Button,
	                  { size: 'big', onClick: onClose },
	                  'No'
	                )
	              )
	            ),
	            on: 'click',
	            trigger: _react2.default.createElement(_semanticUiReact.Button, {
	              inverted: true,
	              fluid: true,
	              color: 'red',
	              icon: 'warning',
	              content: 'Remove story'
	            })
	          })
	        )
	      );
	    }
	  }]);
	
	  return InstagramStoryModal;
	}(_react.Component);
	
	InstagramStoryModal.propTypes = {
	  selectedStory: _propTypes2.default.string.isRequired,
	  campaignName: _propTypes2.default.string.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  restClient: _propTypes2.default.func.isRequired,
	  inDeleteMode: _propTypes2.default.bool,
	  onDeleteAssetCallback: _propTypes2.default.func
	};
	
	InstagramStoryModal.defaultProps = {
	  inDeleteMode: false,
	  onDeleteAssetCallback: _lodash2.default.noop
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default)(InstagramStoryModal);

/***/ },
/* 2166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _campaignsTable = __webpack_require__(540);
	
	var _campaignsTable2 = _interopRequireDefault(_campaignsTable);
	
	var _dyzioEmptyState = __webpack_require__(192);
	
	var _dyzioEmptyState2 = _interopRequireDefault(_dyzioEmptyState);
	
	var _dyzioMessages = __webpack_require__(870);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasLocalstorageClient = __webpack_require__(127);
	
	var _hasLocalstorageClient2 = _interopRequireDefault(_hasLocalstorageClient);
	
	var _hasViewmodeManagement = __webpack_require__(568);
	
	var _hasViewmodeManagement2 = _interopRequireDefault(_hasViewmodeManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getLastSixMonths = function getLastSixMonths() {
	  return _lodash2.default.map(_lodash2.default.range(6), function (i) {
	    var m = (0, _moment2.default)().subtract(i, 'months');
	    return {
	      key: m.format('YYYY-MM'),
	      value: m.format('YYYY-MM'),
	      text: m.format('YYYY - MMMM')
	    };
	  });
	};
	var monthOptions = getLastSixMonths();
	
	var buildTSV = function buildTSV(records) {
	  var headers = ['Campaign Name', 'Status', 'Influencers', 'Assets', 'Start Date', 'End Date'];
	
	  var rows = _lodash2.default.map(records, function (record) {
	    return [_lodash2.default.get(record, 'name', ''), _lodash2.default.get(record, 'status', ''), _lodash2.default.get(record, 'campaignDiscussions.length', _lodash2.default.get(record, 'influencersCount', 0)), _lodash2.default.get(record, 'assets.length', _lodash2.default.get(record, 'assetsCount', 0)), _lodash2.default.get(record, 'startDate', ''), _lodash2.default.get(record, 'endDate', '')];
	  });
	
	  return [headers].concat(_toConsumableArray(rows)).map(function (row) {
	    return row.join('\t');
	  }).join('\n');
	};
	
	var LaunchMetricsCampaignsList = function (_React$Component) {
	  _inherits(LaunchMetricsCampaignsList, _React$Component);
	
	  function LaunchMetricsCampaignsList(props) {
	    _classCallCheck(this, LaunchMetricsCampaignsList);
	
	    var _this = _possibleConstructorReturn(this, (LaunchMetricsCampaignsList.__proto__ || Object.getPrototypeOf(LaunchMetricsCampaignsList)).call(this, props));
	
	    _this.handleExportToSheets = function () {
	      var records = _this.props.records;
	
	      var tsv = buildTSV(records);
	
	      navigator.clipboard.writeText(tsv).then(function () {
	        _this.setState({ copied: true });
	        window.open('https://sheets.new', '_blank');
	        setTimeout(function () {
	          return _this.setState({ copied: false });
	        }, 3000);
	      }).catch(function () {
	        // Fallback for older browsers
	        var textArea = document.createElement('textarea');
	        textArea.value = tsv;
	        document.body.appendChild(textArea);
	        textArea.select();
	        document.execCommand('copy');
	        document.body.removeChild(textArea);
	        _this.setState({ copied: true });
	        window.open('https://sheets.new', '_blank');
	        setTimeout(function () {
	          return _this.setState({ copied: false });
	        }, 3000);
	      });
	    };
	
	    _this.state = {
	      copied: false
	    };
	    return _this;
	  }
	
	  _createClass(LaunchMetricsCampaignsList, [{
	    key: 'render',
	    value: function render() {
	      var _props$userInfo = this.props.userInfo,
	          email = _props$userInfo.email,
	          userName = _props$userInfo.name,
	          userId = _props$userInfo.userId;
	
	      var messageProps = {
	        email: email, userName: userName, userId: userId
	      };
	      var _props = this.props,
	          isLoading = _props.isLoading,
	          isLoaded = _props.isLoaded,
	          isFailed = _props.isFailed,
	          records = _props.records,
	          isLoadingCampaigns = _props.isLoadingCampaigns,
	          isTimeoutError = _props.isTimeoutError,
	          selectedMonth = _props.selectedMonth,
	          sortBy = _props.sortBy,
	          sortDirection = _props.sortDirection,
	          onSortChange = _props.onSortChange;
	      var copied = this.state.copied;
	
	      var noCampaignPermissions = _lodash2.default.isEmpty(records);
	      var isLoadSuccess = isLoaded && !isFailed && !noCampaignPermissions;
	      var isLoadEmptyData = isLoaded && !isFailed && noCampaignPermissions;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Menu,
	          { icon: true },
	          _react2.default.createElement(
	            _semanticUiReact.Menu.Menu,
	            { position: 'left' },
	            _react2.default.createElement(_semanticUiReact.Dropdown, {
	              onChange: this.props.onMonthSelect,
	              value: selectedMonth,
	              options: monthOptions,
	              simple: true,
	              item: true
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Menu.Menu,
	            { position: 'right' },
	            _react2.default.createElement(
	              _semanticUiReact.Menu.Item,
	              null,
	              _react2.default.createElement(_semanticUiReact.Popup, {
	                content: 'Data copied! Paste into the new sheet with Ctrl+V / Cmd+V',
	                open: copied,
	                trigger: _react2.default.createElement(_semanticUiReact.Button, {
	                  icon: 'google',
	                  content: 'Open in Sheets',
	                  onClick: this.handleExportToSheets,
	                  disabled: isLoading || noCampaignPermissions,
	                  primary: true
	                })
	              })
	            )
	          )
	        ),
	        isLoading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading campaigns...' }),
	        isTimeoutError && _react2.default.createElement(_dyzioMessages.DyzioWarningMessage, {
	          header: 'Sorry... Your request timed out!',
	          content: 'Our tech team has been informed and will look into the issue for you.',
	          reportMessage: 'Loading campaigns timeout',
	          reportMessageArgs: messageProps
	        }),
	        isLoadEmptyData && _react2.default.createElement(_dyzioEmptyState2.default, {
	          isSearchContext: false,
	          buttonLabel: 'Add a campaign',
	          helpUrl: 'https://help.dyzio.co/en/articles/5089448-how-to-create-a-campaign',
	          context: 'CAMPAIGNS',
	          onClick: this.toggleAddNewCampaignModalState,
	          content: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'No results!'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Can not find campaigns for given month '
	            )
	          )
	        }),
	        isLoadSuccess && _react2.default.createElement(_campaignsTable2.default, {
	          records: records,
	          isLoadingCampaigns: isLoadingCampaigns,
	          sortBy: sortBy,
	          sortDirection: sortDirection,
	          onSortChange: onSortChange
	        })
	      );
	    }
	  }]);
	
	  return LaunchMetricsCampaignsList;
	}(_react2.default.Component);
	
	LaunchMetricsCampaignsList.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	LaunchMetricsCampaignsList.propTypes = {
	  onMonthSelect: _propTypes2.default.func.isRequired,
	  isLoading: _propTypes2.default.bool,
	  isLoaded: _propTypes2.default.bool,
	  isFailed: _propTypes2.default.bool,
	  records: _propTypes2.default.array,
	  isLoadingCampaigns: _propTypes2.default.bool,
	  isTimeoutError: _propTypes2.default.bool,
	  selectedMonth: _propTypes2.default.string,
	  sortBy: _propTypes2.default.string,
	  sortDirection: _propTypes2.default.string,
	  onSortChange: _propTypes2.default.func
	};
	LaunchMetricsCampaignsList.defaultProps = {
	  isLoading: false,
	  isLoaded: false,
	  isFailed: false,
	  records: [],
	  isLoadingCampaigns: false,
	  isTimeoutError: false,
	  selectedMonth: '',
	  sortBy: 'influencers',
	  sortDirection: 'desc',
	  onSortChange: function onSortChange() {}
	};
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasJsonapiClient2.default, _hasUserInfo2.default, _hasLocalstorageClient2.default, _hasViewmodeManagement2.default)(LaunchMetricsCampaignsList);

/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _statusBar = __webpack_require__(170);
	
	var _statusBar2 = _interopRequireDefault(_statusBar);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _launchMetricsCampaignList = __webpack_require__(2166);
	
	var _launchMetricsCampaignList2 = _interopRequireDefault(_launchMetricsCampaignList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCampaignInfluencers = function getCampaignInfluencers(campaign) {
	  return _lodash2.default.map(campaign.campaignDiscussions, 'name');
	};
	
	var getUniqueInfluencers = function getUniqueInfluencers(campaigns) {
	  var influencers = _lodash2.default.flatMap(campaigns, getCampaignInfluencers);
	  return _lodash2.default.uniq(influencers);
	};
	var formatNumber = function formatNumber(num, numFormat) {
	  return (0, _numeral2.default)(num).format(numFormat);
	};
	
	var LaunchMetricsDashboard = function (_React$Component) {
	  _inherits(LaunchMetricsDashboard, _React$Component);
	
	  function LaunchMetricsDashboard(props) {
	    _classCallCheck(this, LaunchMetricsDashboard);
	
	    var _this = _possibleConstructorReturn(this, (LaunchMetricsDashboard.__proto__ || Object.getPrototypeOf(LaunchMetricsDashboard)).call(this, props));
	
	    _this.componentDidMount = function () {
	      _this.requestData();
	    };
	
	    _this.requestData = function () {
	      var _this$props = _this.props,
	          restClient = _this$props.restClient,
	          userInfo = _this$props.userInfo;
	      var userId = userInfo.userId,
	          organisationId = userInfo.organisationId;
	      var selectedMonth = _this.state.selectedMonth;
	
	
	      _this.setState({
	        isLoaded: false,
	        isFailed: false,
	        isLoading: true
	      });
	
	      var options = {
	        organisationId: organisationId,
	        userId: userId,
	        filter: {
	          monthName: selectedMonth
	        }
	      };
	      var queryParams = encodeURIComponent(JSON.stringify(options));
	      restClient({
	        method: 'get',
	        url: '/campaigns/active/query?q=' + queryParams,
	        baseURL: ("https://dl6gzrmms2.execute-api.eu-west-1.amazonaws.com/production")
	      }).then(function (response) {
	        var _response$data$data = response.data.data,
	            data = _response$data$data.data,
	            results = _response$data$data.results;
	
	        _this.setState({
	          records: data,
	          isLoadingCampaigns: false,
	          totalRecords: results,
	          isLoaded: true,
	          isFailed: false,
	          isLoading: false
	        });
	      }).catch(function (error) {
	        _this.setState({
	          isLoadingCampaigns: false,
	          isLoaded: true,
	          isTimeoutError: error && _lodash2.default.includes(error.toString(), 'timeout'),
	          isFailed: true,
	          isLoading: false
	        });
	      });
	
	      restClient({
	        method: 'get',
	        url: '/influencers/active/query?q=' + queryParams,
	        baseURL: ("https://dl6gzrmms2.execute-api.eu-west-1.amazonaws.com/production")
	      }).then(function (response) {
	        var _response$data$data2 = response.data.data,
	            data = _response$data$data2.data,
	            results = _response$data$data2.results;
	
	        console.log(results);
	        var uniqueInfluencers = data.uniqInfluencers;
	        var totalInfluencers = data.totalInfluencers;
	        _this.setState({
	          uniqueInfluencers: uniqueInfluencers,
	          totalInfluencers: totalInfluencers
	        });
	      }).catch(function (error) {
	        _this.setState({});
	      });
	    };
	
	    _this.onMonthSelect = function (event, _ref) {
	      var value = _ref.value;
	      var isLoading = _this.state.isLoading;
	
	      if (isLoading) return;
	      _this.setState({
	        selectedMonth: value
	      }, _this.requestData);
	    };
	
	    _this.state = {
	      isLoadingCampaigns: true,
	      isLoading: true,
	      isFailed: false,
	      isLoaded: false,
	      isTimeoutError: false,
	      records: [],
	      selectedMonth: (0, _moment2.default)().format('YYYY-MM')
	    };
	    return _this;
	  }
	
	  _createClass(LaunchMetricsDashboard, [{
	    key: 'render',
	    value: function render() {
	      var role = this.props.userInfo.role;
	      var _state = this.state,
	          selectedMonth = _state.selectedMonth,
	          uniqueInfluencers = _state.uniqueInfluencers,
	          totalInfluencers = _state.totalInfluencers,
	          isLoading = _state.isLoading,
	          isLoaded = _state.isLoaded,
	          isFailed = _state.isFailed,
	          records = _state.records,
	          isLoadingCampaigns = _state.isLoadingCampaigns,
	          isTimeoutError = _state.isTimeoutError;
	
	
	      var dateHeader = new Date(selectedMonth).toLocaleString('en-US', { month: 'long', year: 'numeric' });
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_statusBar2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-hero' },
	          _react2.default.createElement(
	            'div',
	            { style: { height: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
	            _react2.default.createElement(
	              'h1',
	              null,
	              dateHeader,
	              ' Active Campaigns'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  null,
	                  isLoading ? '...' : formatNumber(totalInfluencers, '0,0')
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'Total influencers'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  null,
	                  isLoading ? '...' : formatNumber(uniqueInfluencers, '0,0')
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'Unique influencers'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(_launchMetricsCampaignList2.default, {
	            isLoading: isLoading,
	            isLoaded: isLoaded,
	            isFailed: isFailed,
	            records: records,
	            isLoadingCampaigns: isLoadingCampaigns,
	            isTimeoutError: isTimeoutError,
	            selectedMonth: selectedMonth,
	            onMonthSelect: this.onMonthSelect
	          })
	        )
	      );
	    }
	  }]);
	
	  return LaunchMetricsDashboard;
	}(_react2.default.Component);
	
	LaunchMetricsDashboard.propTypes = {
	  userInfo: _propTypes2.default.object.isRequired,
	  restClient: _propTypes2.default.func.isRequired
	
	};
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _hasRestClient2.default)(LaunchMetricsDashboard);

/***/ },
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _immutable = __webpack_require__(71);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactBrowserDetection = __webpack_require__(255);
	
	var _reactBrowserDetection2 = _interopRequireDefault(_reactBrowserDetection);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _authService = __webpack_require__(21);
	
	var _formInputText = __webpack_require__(104);
	
	var _formInputText2 = _interopRequireDefault(_formInputText);
	
	var _loginProblemNotification = __webpack_require__(1996);
	
	var _loginProblemNotification2 = _interopRequireDefault(_loginProblemNotification);
	
	var _poweredByDyzio = __webpack_require__(278);
	
	var _poweredByDyzio2 = _interopRequireDefault(_poweredByDyzio);
	
	var _withGuestIntercom = __webpack_require__(360);
	
	var _withGuestIntercom2 = _interopRequireDefault(_withGuestIntercom);
	
	var _formInputValidation = __webpack_require__(286);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _metricAnalyticsService = __webpack_require__(119);
	
	var _browserHandler = __webpack_require__(231);
	
	var _browserHandler2 = _interopRequireDefault(_browserHandler);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var theme = _themeSelector2.default.theme();
	var IS_WHITE_LABEL = _themeSelector2.default.isWhiteLabel();
	
	var DYZIO_ERROR_MESSAGE_STEM = 'Please contact the dyzio team using the intercom button at the bottom right';
	var GENERAL_ERROR_MESSAGE_STEM = 'Please contact the support team';
	
	var getBlockedErrorMessage = function getBlockedErrorMessage(isWhiteLabel) {
	  var stem = isWhiteLabel ? GENERAL_ERROR_MESSAGE_STEM : DYZIO_ERROR_MESSAGE_STEM;
	  return isWhiteLabel ? '' : stem + ' to get unblocked.'; // just return empty string for now
	};
	
	var getGeneralErrorMessage = function getGeneralErrorMessage(isWhiteLabel) {
	  var stem = isWhiteLabel ? GENERAL_ERROR_MESSAGE_STEM : DYZIO_ERROR_MESSAGE_STEM;
	  return isWhiteLabel ? '' : stem + ' if you are having problems logging in.'; // just return empty string for now
	};
	
	var ERROR_MESSAGES = {
	  blocked: getBlockedErrorMessage(IS_WHITE_LABEL),
	  general: getGeneralErrorMessage(IS_WHITE_LABEL)
	};
	
	var LoginErrorComponent = function LoginErrorComponent(_ref) {
	  var message = _ref.message;
	
	  if (message.match(/blocked/i)) {
	    return _react2.default.createElement(_semanticUiReact.Message, {
	      icon: 'ban',
	      error: true,
	      header: 'Sorry... Your account is blocked temporarily',
	      content: ERROR_MESSAGES.blocked
	    });
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Message, {
	    icon: 'ban',
	    error: true,
	    header: message,
	    content: ERROR_MESSAGES.general
	  });
	};
	
	var Login = function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login(props, context) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props, context));
	
	    _this.getAuthParams = function (data) {
	      return {
	        email: data.get('email'),
	        password: data.get('password')
	      };
	    };
	
	    _this.login = function (data) {
	      _this.setState({
	        loginError: null,
	        isLoggingIn: true
	      });
	      var loginData = {
	        email: data.get('email'),
	        loginType: 'emailPassword'
	      };
	      (0, _metricAnalyticsService.trackEvent)('Login', loginData);
	      _authService.authService.login(_this.getAuthParams(data), function (error) {
	        if (error) {
	          if (_lodash2.default.includes(error.message, 'Wrong email or password')) {
	            (0, _errorHandlingService.reportWarning)('LOGIN_WARNING', error.description);
	          } else {
	            (0, _errorHandlingService.reportError)('LOGIN_ERROR', error.description);
	          }
	          _this.setState({ loginError: error.description, isLoggingIn: false });
	        } else {
	          _this.setState({ loginError: false });
	        }
	      });
	    };
	
	    _this.googleLogin = function () {
	      (0, _metricAnalyticsService.trackEvent)('Login', { loginType: 'google' });
	      _authService.authService.socialLogin({
	        connection: 'google-oauth2',
	        scope: 'openid app_metadata'
	      });
	    };
	
	    _this.state = {
	      loginError: null,
	      isLoggingIn: false
	    };
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var handleSubmit = this.props.handleSubmit;
	      var _state = this.state,
	          loginError = _state.loginError,
	          isLoggingIn = _state.isLoggingIn;
	
	      var loginProblem = false;
	
	      var isVoxogram = window.location.hostname.match(/voxogram/);
	
	      var logoStyle = {
	        marginBottom: 35
	      };
	
	      var whiteLabelStyle = {
	        height: '60px',
	        marginBottom: 35
	      };
	
	      var viewportStyles = {
	        backgroundColor: '#f7fafa',
	        height: 'auto',
	        minHeight: '100vh',
	        padding: '64px 24px'
	      };
	
	      var signinBoxStyle = {
	        background: 'white',
	        border: '1px solid #e8e8e8',
	        borderRadius: '4px',
	        padding: '24px',
	        maxWidth: '960px',
	        margin: '0 auto'
	      };
	
	      var noBorderOrShadow = {
	        border: 'none',
	        'box-shadow': 'none'
	      };
	
	      var shortlistsPreviewStyle = {
	        maxWidth: '100%',
	        marginBottom: '10px'
	      };
	
	      var WhatsNew = function WhatsNew() {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'What\'s new?'
	          ),
	          _react2.default.createElement('div', { className: 'spacer small' }),
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'http://help.dyzio.co/my-influencers-database/instagram-business-accounts',
	              target: '_blank',
	              rel: 'noreferrer noopener'
	            },
	            _react2.default.createElement('img', {
	              alt: 'Instagram Business Accounts',
	              src: '/images/instagram-business-accounts.png',
	              style: shortlistsPreviewStyle
	            })
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'http://help.dyzio.co/my-influencers-database/instagram-business-accounts',
	                target: '_blank',
	                rel: 'noreferrer noopener'
	              },
	              'Instagram Business Accounts!'
	            )
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Dyzio can now show you which of your influencers have an Instagram Business Account, which is essential for anyone posting branded or paid for content.'
	          )
	        );
	      };
	
	      var derivedLogoStyle = IS_WHITE_LABEL ? whiteLabelStyle : logoStyle;
	
	      return _react2.default.createElement(
	        'div',
	        { style: viewportStyles },
	        _react2.default.createElement(
	          'div',
	          { className: 'align-center' },
	          _react2.default.createElement('img', { src: theme.darkLogo.src, alt: theme.darkLogo.alt, style: derivedLogoStyle })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: signinBoxStyle },
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            { columns: 2, divided: true },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              { stretched: true, stackable: true },
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Segment,
	                  { style: noBorderOrShadow },
	                  loginProblem && _react2.default.createElement(_loginProblemNotification2.default, null),
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'large stretch', onClick: this.googleLogin },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Log in with\xA0',
	                      _react2.default.createElement('img', { className: 'google', src: '/logos/google-logo.svg', alt: 'Google', tabIndex: '-1' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.login) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'option-separator' },
	                      _react2.default.createElement('div', { className: 'left' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'center' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          'or'
	                        )
	                      ),
	                      _react2.default.createElement('div', { className: 'right' })
	                    ),
	                    _react2.default.createElement(_immutable.Field, {
	                      name: 'email',
	                      type: 'text',
	                      component: _formInputText2.default,
	                      placeholder: 'Email address',
	                      img: '/icons/email.svg'
	                    }),
	                    _react2.default.createElement(_immutable.Field, {
	                      name: 'password',
	                      type: 'password',
	                      component: _formInputText2.default,
	                      placeholder: 'Password',
	                      img: '/icons/password.svg'
	                    }),
	                    loginError && _react2.default.createElement(LoginErrorComponent, { message: loginError }),
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', className: 'large rose stretch', disabled: isLoggingIn },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Log In'
	                      )
	                    ),
	                    !isVoxogram && _react2.default.createElement(
	                      'p',
	                      { className: 'info' },
	                      'Forgotten your ',
	                      _react2.default.createElement(
	                        'a',
	                        { onClick: function onClick() {
	                            return _this2.context.router.push('/resetpassword');
	                          } },
	                        'password'
	                      ),
	                      '?'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Segment,
	                  { style: noBorderOrShadow, textAlign: 'center' },
	                  theme.loginMessage || _react2.default.createElement(WhatsNew, null)
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'align-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'browser-detect' },
	            _react2.default.createElement(_poweredByDyzio2.default, null),
	            _react2.default.createElement(
	              _reactBrowserDetection2.default,
	              null,
	              _browserHandler2.default.handle
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react2.default.Component);
	
	Login.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	function validate(values) {
	  var errors = {};
	
	  var email = values.get('email');
	  var password = values.get('password');
	
	  if (!email) errors.email = 'Enter an email address.';
	  if (email && !_formInputValidation.EMAIL_REGULAR_EXPRESSION.test(email)) errors.email = 'Enter a valid email address.';
	
	  if (!password) errors.password = 'Enter a password.';
	
	  return errors;
	}
	
	Login.propTypes = {
	  handleSubmit: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    email: state.invite.get('email'),
	    initialValues: {
	      email: state.invite.get('email')
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)(_withGuestIntercom2.default, (0, _reactRedux.connect)(mapStateToProps, null), (0, _immutable.reduxForm)({
	  form: 'LoginForm',
	  validate: validate
	}))(Login);

/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _papaparse = __webpack_require__(425);
	
	var _papaparse2 = _interopRequireDefault(_papaparse);
	
	var _reactRouter = __webpack_require__(37);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _tryAgainView = __webpack_require__(897);
	
	var _tryAgainView2 = _interopRequireDefault(_tryAgainView);
	
	var _mailoutInfluencerTableRow = __webpack_require__(1997);
	
	var _mailoutInfluencerTableRow2 = _interopRequireDefault(_mailoutInfluencerTableRow);
	
	var _influencerTableLoadingRow = __webpack_require__(880);
	
	var _influencerTableLoadingRow2 = _interopRequireDefault(_influencerTableLoadingRow);
	
	var _mailoutsCreateModal = __webpack_require__(887);
	
	var _mailoutsCreateModal2 = _interopRequireDefault(_mailoutsCreateModal);
	
	var _mailoutTestModal = __webpack_require__(1999);
	
	var _mailoutTestModal2 = _interopRequireDefault(_mailoutTestModal);
	
	var _mailoutSendModal = __webpack_require__(1998);
	
	var _mailoutSendModal2 = _interopRequireDefault(_mailoutSendModal);
	
	var _countries = __webpack_require__(93);
	
	var countryList = _interopRequireWildcard(_countries);
	
	var _confirmationModal = __webpack_require__(345);
	
	var _confirmationModal2 = _interopRequireDefault(_confirmationModal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var buttonHeight = { height: '40px' };
	var btnStyles = { height: '40px', border: 'none', width: '80%' };
	var menuOptions = [{ key: 'test', text: 'Test Mailout', value: 'test', icon: 'send' }, { key: 'send', text: 'Send Mailout', value: 'send', icon: 'mail' }, { key: 'delete', text: 'Delete Mailout', value: 'delete', icon: 'trash' }];
	
	var menuGroupStyles = {
	  color: '#1d1937',
	  border: '2px solid #1d1937',
	  fontWeight: 600,
	  width: '100%'
	};
	var dropdownStyles = { display: 'flex', alignItems: 'center' };
	var accordionTitleStyle = { color: 'rgba(0,0,0,.4)' };
	var accordionContentStyle = { position: 'absolute', zIndex: 999 };
	var historyItemStyle = { padding: '10px' };
	
	var Mailouts = function (_Component) {
	  _inherits(Mailouts, _Component);
	
	  function Mailouts(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Mailouts);
	
	    var _this = _possibleConstructorReturn(this, (Mailouts.__proto__ || Object.getPrototypeOf(Mailouts)).call(this, props));
	
	    _this.submitMailout = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(payload) {
	        var _this$props, restClient, campaign, userInfo, routeParams, id, urlId, name, outreachEmailTemplate, outreachEmailSubject, utmSource, mailout, patchResponse;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props = _this.props, restClient = _this$props.restClient, campaign = _this$props.campaign, userInfo = _this$props.userInfo, routeParams = _this$props.routeParams, id = _this$props.id;
	                urlId = _lodash2.default.get(routeParams, 'id', id);
	
	
	                _this.setState({ isSubmitting: true });
	                name = payload.mailoutName, outreachEmailTemplate = payload.outreachEmailTemplate, outreachEmailSubject = payload.outreachEmailSubject, utmSource = payload.utmSource;
	                mailout = {
	                  data: {
	                    attributes: {
	                      name: name,
	                      outreachEmailTemplate: outreachEmailTemplate,
	                      outreachEmailSubject: outreachEmailSubject,
	                      utmSource: utmSource
	                    }
	                  }
	                };
	                _context.next = 7;
	                return restClient.patch('/mailouts/' + urlId, mailout).catch(function (err) {
	                  console.log('Error updating mailout: ', err);
	                  _this.setState({ isSubmitting: false, submitError: true });
	                });
	
	              case 7:
	                patchResponse = _context.sent;
	
	                _this.setState(function (prev) {
	                  return {
	                    isSubmitting: false,
	                    submitError: !patchResponse,
	                    modalOpened: patchResponse ? false : prev.modalOpened
	                  };
	                });
	                _this.fetchInfluencers();
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.submitTestMailout = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(payload) {
	        var routeParams, campaignId, urlId, email, name, domain, request, testResponse, isSentSuccessfully;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                routeParams = _this.props.routeParams;
	                campaignId = _this.state.campaignId;
	                urlId = _lodash2.default.get(routeParams, 'id');
	                email = payload.email, name = payload.name;
	                domain = window.location.origin;
	                request = {
	                  email: email, name: name, campaignId: campaignId, mailoutId: urlId, domain: domain
	                };
	
	                _this.setState({ isSubmittingTestMailout: true });
	                _context2.next = 9;
	                return _this.emailProcessor.post('/mailouts/test', request).then(function (_ref3) {
	                  var data = _ref3.data;
	                  return data;
	                }).catch(function (e) {
	                  _this.setState({ submitTestMailoutError: 'Something went wrong. Pleas try again later', isSubmittingTestMailout: false });
	                });
	
	              case 9:
	                testResponse = _context2.sent;
	                isSentSuccessfully = _lodash2.default.get(testResponse, '[0].status') === 'sent';
	
	                if (isSentSuccessfully) {
	                  _this.setState({
	                    isSubmittingTestMailout: false,
	                    mailoutTestSuccess: true,
	                    submitTestMailoutError: null
	                  });
	                } else {
	                  _this.setState({
	                    isSubmittingTestMailout: false,
	                    mailoutTestSuccess: false,
	                    submitTestMailoutError: _lodash2.default.get(testResponse, 'data.message', 'Something went wrong. Pleas try again later')
	                  });
	                }
	                _this.fetchInfluencers();
	
	              case 13:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.submitSendMailout = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var routeParams, campaignId, urlId, _$get, testEmail, testName, domain, request, response, isSentSuccessfully, _$get2, sentEmails, failedEmails, errorMessage;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              routeParams = _this.props.routeParams;
	              campaignId = _this.state.campaignId;
	              urlId = _lodash2.default.get(routeParams, 'id');
	              _$get = _lodash2.default.get(_this.props, 'userInfo', {}), testEmail = _$get.email, testName = _$get.name;
	              domain = window.location.origin;
	              request = {
	                campaignId: campaignId,
	                mailoutId: urlId,
	                testEmail: testEmail,
	                testName: testName,
	                domain: domain
	              };
	
	
	              _this.setState({ isSendingMailout: true });
	              _context3.next = 9;
	              return _this.emailProcessor.post('/mailouts/send', request).then(function (_ref5) {
	                var data = _ref5.data;
	                return data;
	              }).catch(function (e) {
	                _this.setState({
	                  isSendingMailout: false,
	                  mailoutSendModalOpened: false
	                });
	              });
	
	            case 9:
	              response = _context3.sent;
	              isSentSuccessfully = _lodash2.default.get(response, 'statusCode') === 200;
	
	              if (isSentSuccessfully) {
	                _$get2 = _lodash2.default.get(response, 'data', {}), sentEmails = _$get2.sentEmails, failedEmails = _$get2.failedEmails;
	
	                _this.setState({
	                  isSendingMailout: false,
	                  sendMailoutError: null,
	                  mailoutSuccessMessage: 'Mailout sent successfully. Sent emails: ' + _lodash2.default.size(sentEmails) + '. Failed emails: ' + _lodash2.default.size(failedEmails)
	                });
	              } else {
	                errorMessage = _lodash2.default.get(response, 'data.message', null);
	
	                _this.setState(function (prev) {
	                  return {
	                    isSendingMailout: false,
	                    sendMailoutError: errorMessage,
	                    mailoutSuccessMessage: null,
	                    mailoutSendModalOpened: errorMessage ? prev.mailoutSendModalOpened : false
	                  };
	                });
	              }
	              _this.fetchInfluencers();
	
	            case 13:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.toggleDeleteConfirmModal = function (influencerId) {
	      _this.setState({
	        influencerToDelete: influencerId
	      }, _this.removeInfluencer);
	    };
	
	    _this.deleteMailout = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var _this$props2, restClient, routeParams, id, router, urlId, campaignId;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this.toggleMailoutDeleteConfirmation();
	              _this.setState({ isDeletingMailout: true });
	              _this$props2 = _this.props, restClient = _this$props2.restClient, routeParams = _this$props2.routeParams, id = _this$props2.id, router = _this$props2.router;
	              urlId = _lodash2.default.get(routeParams, 'id', id);
	              campaignId = _this.state.campaignId;
	
	              if (!campaignId) {
	                _context4.next = 9;
	                break;
	              }
	
	              console.log('Campaign Id: ', campaignId);
	              _context4.next = 9;
	              return restClient.delete('/mailouts/' + urlId).then(function (res) {
	                _this.setState({ isDeletingMailout: false });
	                // eslint-disable-next-line lodash/prefer-lodash-method
	                router.replace('/campaign/' + campaignId + '/notifications');
	              }).catch(function (e) {
	                _this.setState({ isDeletingMailout: false });
	              });
	
	            case 9:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	    _this.removeInfluencer = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var _this$state, deletingId, influencerToDelete, _this$props3, restClient, routeParams, id, influencers, urlId, filteredInfluencers, data;
	
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _this$state = _this.state, deletingId = _this$state.deletingId, influencerToDelete = _this$state.influencerToDelete;
	
	              if (!deletingId) {
	                _context5.next = 3;
	                break;
	              }
	
	              return _context5.abrupt('return');
	
	            case 3:
	
	              // Set loading state at the start
	              _this.setState({
	                deletingId: influencerToDelete,
	                isRemovingInfluencer: true // Add this
	              });
	              _this.toggleDeleteConfirmModal();
	
	              _this$props3 = _this.props, restClient = _this$props3.restClient, routeParams = _this$props3.routeParams, id = _this$props3.id;
	              influencers = _this.state.influencers;
	              urlId = _lodash2.default.get(routeParams, 'id', id);
	              filteredInfluencers = _lodash2.default.reject(influencers, ['instagramId', influencerToDelete]);
	              data = {
	                attributes: { influencers: filteredInfluencers }
	              };
	              _context5.next = 12;
	              return restClient.patch('/mailouts/' + urlId, {
	                data: data
	              }).then(function () {
	                _this.setState({ influencers: filteredInfluencers });
	              }).catch(function (e) {
	                console.log('Patch Error: ', e);
	              }).finally(function () {
	                _this.setState({
	                  deletingId: null,
	                  isRemovingInfluencer: false // Remove loading state
	                });
	              });
	
	            case 12:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	
	    _this.toggleMailoutTestModal = function () {
	      _this.setState(function (prev) {
	        return {
	          mailoutTestModalOpened: !prev.mailoutTestModalOpened,
	          mailoutTestSuccess: !prev.mailoutTestModalOpened ? false : prev.mailoutTestSuccess,
	          submitTestMailoutError: !prev.mailoutTestModalOpened ? null : prev.submitTestMailoutError
	        };
	      });
	    };
	
	    _this.toggleMailoutSendModal = function () {
	      _this.setState(function (prev) {
	        return {
	          mailoutSendModalOpened: !prev.mailoutSendModalOpened,
	          mailoutSuccessMessage: !prev.mailoutSendModalOpened ? false : prev.mailoutSuccessMessage,
	          sendMailoutError: !prev.mailoutSendModalOpened ? null : prev.sendMailoutError
	        };
	      });
	    };
	
	    _this.toggleMailoutDeleteConfirmation = function () {
	      _this.setState(function (prev) {
	        return { confirmDeleteMailoutOpened: !prev.confirmDeleteMailoutOpened };
	      });
	    };
	
	    _this.onMenuItemSelect = function (item) {
	      if (item === 'test') {
	        _this.toggleMailoutTestModal();
	      }
	      if (item === 'send') {
	        _this.toggleMailoutSendModal();
	      }
	      if (item === 'delete') {
	        _this.toggleMailoutDeleteConfirmation();
	      }
	    };
	
	    _this.downloadCSV = function () {
	      var _this$state2 = _this.state,
	          influencers = _this$state2.influencers,
	          title = _this$state2.title;
	
	      if (_lodash2.default.isEmpty(influencers)) {
	        return;
	      }
	      var csv = _papaparse2.default.unparse(influencers);
	      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
	      var url = URL.createObjectURL(blob);
	      var link = document.createElement('a');
	      link.setAttribute('href', url);
	      link.setAttribute('download', title + '.csv');
	      link.style.visibility = 'hidden';
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    };
	
	    _this.toggleMailoutsModal = function () {
	      _this.setState(function (prev) {
	        return {
	          modalOpened: !prev.modalOpened,
	          isSubmitting: !prev.modalOpened ? false : prev.isSubmitting,
	          submitError: false
	        };
	      });
	    };
	
	    _this.toggleHistory = function () {
	      _this.setState(function (prev) {
	        return {
	          historyOpened: !prev.historyOpened
	        };
	      });
	    };
	
	    _this.state = {
	      influencers: [],
	      title: '',
	      isLoading: false,
	      error: null,
	      isRemovingInfluencer: false // Add this state
	    };
	    var buildRESTClient = _this.props.buildRESTClient;
	
	    _this.emailProcessor = buildRESTClient({
	      baseURL: ("https://hjkv4vhd73.execute-api.eu-west-1.amazonaws.com/production") || '',
	      hasToken: false,
	      timeout: 100000
	    });
	    return _this;
	  }
	
	  _createClass(Mailouts, [{
	    key: 'fetchInfluencers',
	    value: function fetchInfluencers() {
	      var _this3 = this;
	
	      this.setState({ isLoading: true });
	
	      var _props = this.props,
	          restClient = _props.restClient,
	          routeParams = _props.routeParams,
	          id = _props.id;
	
	      var urlId = _lodash2.default.get(routeParams, 'id', id);
	
	      restClient.get('/mailouts/' + urlId).then(function (response) {
	        var _response$data$data = response.data.data,
	            _response$data$data$a = _response$data$data.attributes,
	            influencers = _response$data$data$a.influencers,
	            name = _response$data$data$a.name,
	            createdDate = _response$data$data$a.createdDate,
	            outreachEmailSubject = _response$data$data$a.outreachEmailSubject,
	            outreachEmailTemplate = _response$data$data$a.outreachEmailTemplate,
	            lastSentDate = _response$data$data$a.lastSentDate,
	            outreachHistory = _response$data$data$a.outreachHistory,
	            utmSource = _response$data$data$a.utmSource,
	            relationships = _response$data$data.relationships;
	
	        var campaignId = _lodash2.default.get(relationships, 'campaign.data.id');
	        _this3.setState({
	          isLoading: false,
	          influencers: influencers,
	          createdDate: createdDate,
	          title: name,
	          campaignId: campaignId,
	          lastSentDate: lastSentDate,
	          outreachHistory: outreachHistory,
	          mailout: {
	            id: urlId,
	            mailoutName: name,
	            outreachEmailTemplate: outreachEmailTemplate,
	            outreachEmailSubject: outreachEmailSubject,
	            lastSentDate: lastSentDate,
	            outreachHistory: outreachHistory,
	            utmSource: utmSource,
	            totalInfluencers: _lodash2.default.size(influencers)
	          },
	          error: null
	        });
	      }).catch(function (err) {
	        _this3.setState({ isLoading: false, error: err });
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchInfluencers();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          influencers = _state.influencers,
	          isLoading = _state.isLoading,
	          error = _state.error,
	          title = _state.title,
	          createdDate = _state.createdDate,
	          modalOpened = _state.modalOpened,
	          isSubmitting = _state.isSubmitting,
	          submitError = _state.submitError,
	          mailout = _state.mailout,
	          mailoutTestModalOpened = _state.mailoutTestModalOpened,
	          isSubmittingTestMailout = _state.isSubmittingTestMailout,
	          submitTestMailoutError = _state.submitTestMailoutError,
	          mailoutTestSuccess = _state.mailoutTestSuccess,
	          mailoutSendModalOpened = _state.mailoutSendModalOpened,
	          isSendingMailout = _state.isSendingMailout,
	          mailoutSuccessMessage = _state.mailoutSuccessMessage,
	          sendMailoutError = _state.sendMailoutError,
	          confirmModalOpened = _state.confirmModalOpened,
	          lastSentDate = _state.lastSentDate,
	          outreachHistory = _state.outreachHistory,
	          historyOpened = _state.historyOpened,
	          confirmDeleteMailoutOpened = _state.confirmDeleteMailoutOpened,
	          isRemovingInfluencer = _state.isRemovingInfluencer;
	
	
	      var hasOutreachHistory = !_lodash2.default.isEmpty(outreachHistory);
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        modalOpened && _react2.default.createElement(_mailoutsCreateModal2.default, {
	          onClose: this.toggleMailoutsModal,
	          onSubmit: this.submitMailout,
	          isSubmitting: isSubmitting,
	          mailout: mailout,
	          error: submitError
	        }),
	        mailoutTestModalOpened && _react2.default.createElement(_mailoutTestModal2.default, {
	          onClose: this.toggleMailoutTestModal,
	          onSubmit: this.submitTestMailout,
	          isSubmitting: isSubmittingTestMailout,
	          mailout: mailout,
	          error: submitTestMailoutError,
	          mailoutTestSuccess: mailoutTestSuccess
	        }),
	        mailoutSendModalOpened && _react2.default.createElement(_mailoutSendModal2.default, {
	          onClose: this.toggleMailoutSendModal,
	          onSubmit: this.submitSendMailout,
	          isSubmitting: isSendingMailout,
	          mailout: mailout,
	          error: sendMailoutError,
	          successMessage: mailoutSuccessMessage
	        }),
	        confirmModalOpened && _react2.default.createElement(_confirmationModal2.default, {
	          headerText: 'Deleting Influencer',
	          bodyText: 'Are you sure you want to delete influencer?',
	          onCancel: function onCancel() {
	            return _this4.toggleDeleteConfirmModal();
	          },
	          onConfirm: this.removeInfluencer
	        }),
	        confirmDeleteMailoutOpened && _react2.default.createElement(_confirmationModal2.default, {
	          headerText: 'Deleting Mailout',
	          bodyText: 'Are you sure you want to delete mailout?',
	          onCancel: function onCancel() {
	            return _this4.toggleMailoutDeleteConfirmation();
	          },
	          onConfirm: this.deleteMailout
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: { paddingTop: 40, backgroundColor: '#FFF', borderBottom: '1px solid #EEE' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'page-hero', style: { height: 'auto' } },
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 11 },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h1',
	                      null,
	                      'Mailouts'
	                    ),
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      title,
	                      ' '
	                    ),
	                    !isLoading && _react2.default.createElement(
	                      'div',
	                      { style: { paddingTop: '10px', paddingBottom: '20px' } },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Total Influencers: ',
	                        _lodash2.default.size(influencers)
	                      ),
	                      _react2.default.createElement(
	                        'h5',
	                        { style: { color: 'rgba(0,0,0,.4)' } },
	                        'Created: ',
	                        (0, _moment2.default)(createdDate).format('YYYY-MM-DD, h:mm')
	                      ),
	                      hasOutreachHistory && _react2.default.createElement(
	                        _semanticUiReact.Accordion,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Accordion.Title,
	                          {
	                            active: historyOpened,
	                            index: 0,
	                            onClick: this.toggleHistory,
	                            style: accordionTitleStyle
	                          },
	                          hasOutreachHistory,
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            'Last Sent: ',
	                            (0, _moment2.default)(lastSentDate).format('YYYY-MM-DD, h:mm')
	                          ),
	                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'dropdown' })
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Accordion.Content,
	                          { active: historyOpened },
	                          _react2.default.createElement(
	                            _semanticUiReact.Card,
	                            { style: accordionContentStyle },
	                            _react2.default.createElement(
	                              _semanticUiReact.Card.Content,
	                              null,
	                              _react2.default.createElement(
	                                _semanticUiReact.List,
	                                { divided: true, verticalAlign: 'middle' },
	                                _lodash2.default.map(outreachHistory, function (item) {
	                                  var dateString = _lodash2.default.replace(item, 'Mailout sent on ', '');
	                                  var date = (0, _moment2.default)(dateString).format('YYYY-MM-DD, h:mm');
	                                  return _react2.default.createElement(
	                                    _semanticUiReact.List.Item,
	                                    { style: historyItemStyle },
	                                    ' Mailout sent on ',
	                                    date
	                                  );
	                                })
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      !hasOutreachHistory && _react2.default.createElement(
	                        'h5',
	                        { style: { color: 'rgba(0,0,0,.4)' } },
	                        'Not sent yet'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 2, textAlign: 'center' },
	                  _react2.default.createElement(_semanticUiReact.Button, {
	                    style: buttonHeight,
	                    disabled: _lodash2.default.isEmpty(influencers),
	                    onClick: this.downloadCSV,
	                    color: 'pink',
	                    icon: 'download',
	                    content: 'Export as CSV'
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: 3, textAlign: 'center' },
	                  _react2.default.createElement(
	                    _semanticUiReact.ButtonGroup,
	                    {
	                      basic: true, compact: true, style: menuGroupStyles
	                    },
	                    _react2.default.createElement(_semanticUiReact.Button, { style: btnStyles, disabled: isLoading, onClick: this.toggleMailoutsModal, basic: true, icon: 'edit', content: 'Edit Mailout' }),
	                    _react2.default.createElement(_semanticUiReact.Dropdown, {
	                      className: 'button icon',
	                      style: dropdownStyles,
	                      options: menuOptions,
	                      floating: true,
	                      selectOnBlur: false,
	                      onChange: function onChange(e, data) {
	                        _this4.onMenuItemSelect(data.value);
	                      },
	                      trigger: _react2.default.createElement('div', null)
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content', style: { position: 'relative' } },
	          _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: isRemovingInfluencer, inverted: true },
	            _react2.default.createElement(
	              _semanticUiReact.Loader,
	              { inverted: true },
	              'Removing influencer...'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Header,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  {
	                    width: 10
	                  },
	                  'Influencer'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  {
	                    width: 3
	                  },
	                  'Email'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  {
	                    width: 1,
	                    textAlign: 'center'
	                  },
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'flag outline' }),
	                    content: 'Influencer country'
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  {
	                    textAlign: 'center',
	                    width: 1
	                  },
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'percent', color: 'pink' }),
	                    content: 'Instagram Engagement Rate'
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.HeaderCell,
	                  {
	                    width: 1,
	                    textAlign: 'center'
	                  },
	                  _react2.default.createElement('img', { src: '/icons/instagram.svg', alt: 'Instagram' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Body,
	              null,
	              isLoading && _react2.default.createElement(_influencerTableLoadingRow2.default, { colSpan: 11 }),
	              !isLoading && error && _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  { colSpan: 16, height: '500', textAlign: 'center' },
	                  _react2.default.createElement(_tryAgainView2.default, {
	                    onClick: this.fetchInfluencers
	                  })
	                )
	              ),
	              !isLoading && !error && influencers && _lodash2.default.map(influencers, function (influencer, index) {
	                return _react2.default.createElement(_mailoutInfluencerTableRow2.default, {
	                  key: influencer.instagramId + '(' + index + ')',
	                  colSpan: 12,
	                  influencer: influencer,
	                  countries: countryList.default,
	                  onDelete: function onDelete(influencerId) {
	                    return _this4.toggleDeleteConfirmModal(influencerId);
	                  },
	                  isDeleting: influencer.instagramId && influencer.instagramId === _this4.state.deletingId
	                });
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Mailouts;
	}(_react.Component);
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default, _reactRouter.withRouter)(Mailouts);
	
	
	Mailouts.propTypes = {
	  restClient: _propTypes2.default.func.isRequired,
	  buildRESTClient: _propTypes2.default.func.isRequired,
	  routeParams: _propTypes2.default.object,
	  id: _propTypes2.default.string
	};
	Mailouts.defaultProps = {
	  routeParams: null,
	  id: null
	};

/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _mediaKitHeader = __webpack_require__(2566);
	
	var _mediaKitHeader2 = _interopRequireDefault(_mediaKitHeader);
	
	var _mediaKitBody = __webpack_require__(2565);
	
	var _mediaKitBody2 = _interopRequireDefault(_mediaKitBody);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _resources = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pageStyle = {
	  border: '1px solid #ddd',
	  margin: '50px auto',
	  background: '#FFF',
	  padding: 20
	};
	
	var textAlignCenter = {
	  textAlign: 'center',
	  height: 200
	};
	
	var MediaKit = function (_Component) {
	  _inherits(MediaKit, _Component);
	
	  function MediaKit() {
	    _classCallCheck(this, MediaKit);
	
	    var _this = _possibleConstructorReturn(this, (MediaKit.__proto__ || Object.getPrototypeOf(MediaKit)).call(this));
	
	    _this.componentDidMount = function () {
	      var _this$props = _this.props,
	          jsonAPIClient = _this$props.jsonAPIClient,
	          influnecerId = _this$props.params.influnecerId;
	      // eslint-disable-next-line lodash/prefer-lodash-method
	
	      jsonAPIClient.get(_resources.INFLUENCER_RESOURCE, influnecerId).then(function (influencerResource) {
	        var influencer = influencerResource.toJSON();
	        var influencerApiLink = influencer.influencerApiLink;
	
	        if (!influencerApiLink) {
	          _this.setState({
	            isLoading: false,
	            influencer: influencer
	          });
	        } else {
	          _axios2.default.get(influencerApiLink.url).then(function (response) {
	            var data = response.data;
	
	            _this.setState({
	              isLoading: false,
	              youtubeAPIDetails: data.influencer,
	              influencer: influencer
	            });
	          });
	        }
	      });
	    };
	
	    _this.toggleYoutubeModalState = function () {
	      var youtubeModalOpen = _this.state.youtubeModalOpen;
	
	      _this.setState({
	        youtubeModalOpen: !youtubeModalOpen
	      });
	    };
	
	    _this.state = {
	      isLoading: true,
	      youtubeModalOpen: false,
	      influencer: null,
	      youtubeAPIDetails: null
	    };
	    return _this;
	  }
	
	  _createClass(MediaKit, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          influencer = _state.influencer,
	          youtubeAPIDetails = _state.youtubeAPIDetails,
	          youtubeModalOpen = _state.youtubeModalOpen;
	
	
	      var theme = _themeSelector2.default.theme();
	      var logo = (0, _lodash.get)(theme, 'headerLogo.src', null);
	      var logoFixed = logo ? (0, _lodash.replace)(logo, /^\//, '') : null;
	
	      var avatarProps = (0, _lodash.get)(theme, 'mediaKit.avatarProps');
	      var logoProps = (0, _lodash.get)(theme, 'mediaKit.logoProps');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page', id: 'media-kit' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            'div',
	            { style: pageStyle, className: 'media-kit-wrapper' },
	            isLoading && _react2.default.createElement(
	              'div',
	              { style: textAlignCenter },
	              'Loading...'
	            ),
	            !isLoading && influencer && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_mediaKitHeader2.default, { influencer: influencer, logo: logoFixed, avatarProps: avatarProps, logoProps: logoProps }),
	              _react2.default.createElement(_mediaKitBody2.default, {
	                influencer: influencer,
	                youtubeAPIDetails: youtubeAPIDetails,
	                youtubeModalOpen: youtubeModalOpen,
	                toggleYoutubeModalState: this.toggleYoutubeModalState
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MediaKit;
	}(_react.Component);
	
	MediaKit.propTypes = {
	  jsonAPIClient: _propTypes2.default.object.isRequired,
	  params: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _hasJsonapiClient2.default)(MediaKit);

/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _influencerContextBar = __webpack_require__(193);
	
	var _influencerContextBar2 = _interopRequireDefault(_influencerContextBar);
	
	var _creatorTable = __webpack_require__(2100);
	
	var _creatorTable2 = _interopRequireDefault(_creatorTable);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MyCreators = function (_Component) {
	  _inherits(MyCreators, _Component);
	
	  function MyCreators(props) {
	    _classCallCheck(this, MyCreators);
	
	    var _this = _possibleConstructorReturn(this, (MyCreators.__proto__ || Object.getPrototypeOf(MyCreators)).call(this, props));
	
	    _this.toggleShowTooltip = function (showTooltip) {
	      return _this.setState({ showTooltip: showTooltip });
	    };
	
	    _this.leftButtonCallback = function () {
	      return _this.context.router.push('/dashboard');
	    };
	
	    _this.rightButtonCallback = function () {
	      return _this.context.router.push('/influencer/add');
	    };
	
	    _this.extractSearchParams = function (_ref) {
	      var hash = _ref.hash;
	
	      try {
	        var data = JSON.parse(decodeURIComponent(hash.slice(1)));
	        _this.setState(data);
	        return data;
	      } catch (e) {
	        console.error(e);
	        (0, _errorHandlingService.reportError)('SEARCH_PARSE_ERROR', e);
	
	        return {};
	      }
	    };
	
	    _this.onSearchParamsChange = function (newParams) {
	      var filter = newParams.filter || _this.state.filter;
	      var currentPage = newParams.currentPage || _this.state.currentPage;
	      var sort = newParams.sort || _this.state.sort;
	      var hash = JSON.stringify({ filter: filter, currentPage: currentPage, sort: sort });
	      var pathname = _this.props.location.pathname;
	
	      _this.context.router.replace({ pathname: pathname, hash: '#' + hash });
	      _this.setState(newParams);
	    };
	
	    var defaultApprovalModeEnabled = _lodash2.default.last(_lodash2.default.split(props.location.pathname, '/')) === 'approvals';
	    _this.state = _extends({
	      showTooltip: false,
	      filter: {
	        platform: 'instagram',
	        min: '1000',
	        max: '5000',
	        country: '',
	        maxInstagramEngagementRate: '',
	        minInstagramEngagementRate: '1',
	        hasEmail: true
	      },
	      currentPage: 1,
	      sort: {
	        field: 'createdDate',
	        order: 'DESC'
	      },
	      defaultApprovalModeEnabled: defaultApprovalModeEnabled
	    }, _this.extractSearchParams(props.location));
	    return _this;
	  }
	
	  _createClass(MyCreators, [{
	    key: 'render',
	    value: function render() {
	      var user = this.props.user;
	      var _state = this.state,
	          filter = _state.filter,
	          currentPage = _state.currentPage,
	          sort = _state.sort,
	          defaultApprovalModeEnabled = _state.defaultApprovalModeEnabled;
	
	      var searchParams = { filter: filter, currentPage: currentPage, sort: sort };
	
	      var cacheBuster = this.props.location.query;
	
	      var organisationName = user ? user.organisation.name : '';
	      var organisationId = user ? user.organisation.id : '';
	      var organisationSlug = user ? user.organisation.slug : '';
	      var displayAuthorisedData = user ? user.organisation.displayAuthorisedData : false;
	      var usesGlobalTags = user ? user.organisation.usesGlobalTags : false;
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_influencerContextBar2.default, {
	          organisationName: organisationName,
	          showTooltip: this.state.showTooltip,
	          rightButtonLabel: 'Add A Creator',
	          leftButtonLabel: 'Create A Campaign',
	          rightButtonCallback: _lodash2.default.noop
	          // rightButtonCallback={this.rightButtonCallback}
	          , leftButtonCallback: _lodash2.default.noop
	          // leftButtonCallback={this.leftButtonCallback}
	          , title: 'My Creators',
	          hasPrivateLink: true
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          user && _react2.default.createElement(_creatorTable2.default, {
	            usesGlobalTags: usesGlobalTags,
	            organisationSlug: organisationSlug,
	            organisationId: organisationId,
	            displayAuthorisedData: displayAuthorisedData,
	            toggleShowTooltip: this.toggleShowTooltip,
	            cacheBuster: cacheBuster,
	            searchParams: searchParams,
	            onSearchParamsChange: this.onSearchParamsChange,
	            defaultApprovalModeEnabled: defaultApprovalModeEnabled
	          })
	        )
	      );
	    }
	  }]);
	
	  return MyCreators;
	}(_react.Component);
	
	MyCreators.contextTypes = {
	  router: _propTypes2.default.object
	};
	MyCreators.propTypes = {
	  user: _propTypes2.default.object,
	  location: _propTypes2.default.object
	};
	MyCreators.defaultProps = {
	  user: null,
	  location: {}
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(MyCreators);

/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _influencerContextBar = __webpack_require__(193);
	
	var _influencerContextBar2 = _interopRequireDefault(_influencerContextBar);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CREATOR_API = 'https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production/creators/find/xxx';
	
	var MyCreators = function (_Component) {
	  _inherits(MyCreators, _Component);
	
	  function MyCreators(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, MyCreators);
	
	    var _this = _possibleConstructorReturn(this, (MyCreators.__proto__ || Object.getPrototypeOf(MyCreators)).call(this, props));
	
	    _this.fetchCreators = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var creatorResponse, creators;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              _this.setState({ isLoading: true });
	              _context.next = 4;
	              return _axios2.default.get(CREATOR_API);
	
	            case 4:
	              creatorResponse = _context.sent;
	              creators = creatorResponse.data.body.data.data;
	
	
	              _this.setState({
	                creators: creators,
	                lastUpdated: new Date(),
	                isLoading: false
	              });
	              console.log('Data refreshed at:', new Date().toLocaleTimeString());
	              _context.next = 15;
	              break;
	
	            case 10:
	              _context.prev = 10;
	              _context.t0 = _context['catch'](0);
	
	              console.error('Error fetching creators:', _context.t0);
	              (0, _errorHandlingService.reportError)('CREATOR_FETCH_ERROR', _context.t0);
	              _this.setState({ isLoading: false });
	
	            case 15:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[0, 10]]);
	    }));
	
	    _this.toggleShowTooltip = function (showTooltip) {
	      return _this.setState({ showTooltip: showTooltip });
	    };
	
	    _this.leftButtonCallback = function () {
	      return _this.context.router.push('/dashboard');
	    };
	
	    _this.rightButtonCallback = function () {
	      return _this.context.router.push('/influencer/add');
	    };
	
	    _this.extractSearchParams = function (_ref2) {
	      var hash = _ref2.hash;
	
	      try {
	        var data = JSON.parse(decodeURIComponent(hash.slice(1)));
	        _this.setState(data);
	        return data;
	      } catch (e) {
	        console.error(e);
	        (0, _errorHandlingService.reportError)('SEARCH_PARSE_ERROR', e);
	
	        return {};
	      }
	    };
	
	    _this.onSearchParamsChange = function (newParams) {
	      var filter = newParams.filter || _this.state.filter;
	      var currentPage = newParams.currentPage || _this.state.currentPage;
	      var sort = newParams.sort || _this.state.sort;
	      var hash = JSON.stringify({ filter: filter, currentPage: currentPage, sort: sort });
	      var pathname = _this.props.location.pathname;
	
	      _this.context.router.replace({ pathname: pathname, hash: '#' + hash });
	      _this.setState(newParams);
	    };
	
	    var defaultApprovalModeEnabled = _lodash2.default.last(_lodash2.default.split(props.location.pathname, '/')) === 'approvals';
	    _this.state = _extends({
	      showTooltip: false,
	      filter: {
	        platform: 'instagram',
	        min: '1000',
	        max: '5000',
	        country: '',
	        maxInstagramEngagementRate: '',
	        minInstagramEngagementRate: '1',
	        hasEmail: true
	      },
	      currentPage: 1,
	      sort: {
	        field: 'createdDate',
	        order: 'DESC'
	      },
	      defaultApprovalModeEnabled: defaultApprovalModeEnabled
	    }, _this.extractSearchParams(props.location), {
	      creators: null,
	      lastUpdated: null,
	      secondsUntilReload: 60,
	      isLoading: false
	    });
	
	    // Interval reference for cleanup
	    _this.refreshInterval = null;
	    _this.countdownInterval = null;
	    return _this;
	  }
	
	  _createClass(MyCreators, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this3 = this;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return this.fetchCreators();
	
	              case 2:
	
	                // Set up auto-refresh every 60 seconds (60000 milliseconds)
	                this.refreshInterval = setInterval(function () {
	                  _this3.fetchCreators();
	                  // Reset countdown when data is refreshed
	                  _this3.setState({ secondsUntilReload: 60 });
	                }, 60000);
	
	                // Set up countdown timer that updates every second
	                this.countdownInterval = setInterval(function () {
	                  _this3.setState(function (prevState) {
	                    return {
	                      secondsUntilReload: prevState.secondsUntilReload > 0 ? prevState.secondsUntilReload - 1 : 0
	                    };
	                  });
	                }, 1000);
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Clear the intervals when component unmounts to prevent memory leaks
	      if (this.refreshInterval) {
	        clearInterval(this.refreshInterval);
	      }
	      if (this.countdownInterval) {
	        clearInterval(this.countdownInterval);
	      }
	    }
	
	    // Separated fetch logic into its own method for reuse
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var user = this.props.user;
	      var _state = this.state,
	          filter = _state.filter,
	          currentPage = _state.currentPage,
	          sort = _state.sort,
	          creators = _state.creators,
	          lastUpdated = _state.lastUpdated,
	          secondsUntilReload = _state.secondsUntilReload,
	          isLoading = _state.isLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_influencerContextBar2.default, {
	          organisationName: 'ALL',
	          showTooltip: this.state.showTooltip,
	          rightButtonLabel: 'Add A Creator',
	          leftButtonLabel: 'Create A Campaign',
	          rightButtonCallback: _lodash2.default.noop
	          // rightButtonCallback={this.rightButtonCallback}
	          , leftButtonCallback: _lodash2.default.noop
	          // leftButtonCallback={this.leftButtonCallback}
	          , title: 'My Creators V2 - AI driven creators',
	          hasPrivateLink: true
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          user && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Recently Added Creators'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This query is returning creators who are in the UK, who are in a ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Creator Category'
	              ),
	              ' with more than 1,000 followers.'
	            )
	          ),
	          lastUpdated && _react2.default.createElement(
	            'div',
	            { style: { marginTop: '10px', marginBottom: '10px', fontSize: '12px', color: '#888' } },
	            'Last updated: ',
	            lastUpdated.toLocaleTimeString(),
	            isLoading ? _react2.default.createElement(
	              'span',
	              { style: { marginLeft: '10px' } },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'spinner', loading: true }),
	              'Loading...'
	            ) : _react2.default.createElement(
	              'span',
	              { style: { marginLeft: '10px' } },
	              'Next refresh in: ',
	              secondsUntilReload,
	              ' seconds',
	              _react2.default.createElement(_semanticUiReact.Icon, {
	                name: 'refresh',
	                style: { marginLeft: '8px', cursor: 'pointer' },
	                title: 'Refresh now',
	                onClick: function onClick() {
	                  return _this4.fetchCreators();
	                }
	              })
	            )
	          ),
	          creators && _react2.default.createElement(
	            _semanticUiReact.Table,
	            { basic: 'very', celled: true },
	            _react2.default.createElement(
	              _semanticUiReact.TableHeader,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.TableRow,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.TableHeaderCell,
	                  { width: 1 },
	                  'Pic'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableHeaderCell,
	                  { width: 2 },
	                  'Creator'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableHeaderCell,
	                  { width: 1 },
	                  'Followers'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableHeaderCell,
	                  { width: 1 },
	                  'Email'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableHeaderCell,
	                  { width: 2 },
	                  'Categories'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableHeaderCell,
	                  { width: 3 },
	                  'Keywords'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableHeaderCell,
	                  { width: 4 },
	                  'Summary'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableHeaderCell,
	                  { width: 2 },
	                  'Discovered'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.TableBody,
	              null,
	              _lodash2.default.map(creators, function (creator) {
	                return _react2.default.createElement(
	                  _semanticUiReact.TableRow,
	                  { key: creator.instagram || creator.id },
	                  _react2.default.createElement(
	                    _semanticUiReact.TableCell,
	                    { width: 1 },
	                    _react2.default.createElement(_semanticUiReact.Image, { src: creator.thumbnail, rounded: true, size: 'tiny' })
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.TableCell,
	                    { width: 2 },
	                    _react2.default.createElement(
	                      _semanticUiReact.Header,
	                      { as: 'h4', image: true },
	                      _react2.default.createElement(
	                        _semanticUiReact.HeaderContent,
	                        null,
	                        creator.name,
	                        _react2.default.createElement(
	                          _semanticUiReact.HeaderSubheader,
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { href: 'https://instagram.com/' + creator.instagram, target: '_blank', rel: 'noopener noreferrer' },
	                            creator.instagram
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.TableCell,
	                    { width: 1 },
	                    (0, _numeral2.default)(creator.instagramCount).format('0,0')
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.TableCell,
	                    { width: 1 },
	                    creator.email
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.TableCell,
	                    { width: 2 },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      creator.instagramCategory
	                    ),
	                    _lodash2.default.map(creator.contentCategories, function (cc) {
	                      return _react2.default.createElement(
	                        _semanticUiReact.Label,
	                        null,
	                        cc
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.TableCell,
	                    { width: 3 },
	                    _lodash2.default.join(creator.keywords, ', ')
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.TableCell,
	                    { width: 4 },
	                    creator.summary
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.TableCell,
	                    { width: 2 },
	                    creator.createdDate
	                  )
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MyCreators;
	}(_react.Component);
	
	MyCreators.contextTypes = {
	  router: _propTypes2.default.object
	};
	MyCreators.propTypes = {
	  user: _propTypes2.default.object,
	  location: _propTypes2.default.object
	};
	MyCreators.defaultProps = {
	  user: null,
	  location: {}
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(MyCreators);

/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _influencerContextBar = __webpack_require__(193);
	
	var _influencerContextBar2 = _interopRequireDefault(_influencerContextBar);
	
	var _influencerTable = __webpack_require__(2158);
	
	var _influencerTable2 = _interopRequireDefault(_influencerTable);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MyInfluencers = function (_Component) {
	  _inherits(MyInfluencers, _Component);
	
	  function MyInfluencers(props) {
	    _classCallCheck(this, MyInfluencers);
	
	    var _this = _possibleConstructorReturn(this, (MyInfluencers.__proto__ || Object.getPrototypeOf(MyInfluencers)).call(this, props));
	
	    _this.toggleShowTooltip = function (showTooltip) {
	      return _this.setState({ showTooltip: showTooltip });
	    };
	
	    _this.leftButtonCallback = function () {
	      return _this.context.router.push('/dashboard');
	    };
	
	    _this.rightButtonCallback = function () {
	      return _this.context.router.push('/influencer/add');
	    };
	
	    _this.extractSearchParams = function (_ref) {
	      var hash = _ref.hash;
	
	      try {
	        var data = JSON.parse(decodeURIComponent(hash.slice(1)));
	        _this.setState(data);
	        return data;
	      } catch (e) {
	        console.error(e);
	        (0, _errorHandlingService.reportError)('SEARCH_PARSE_ERROR', e);
	
	        return {};
	      }
	    };
	
	    _this.onSearchParamsChange = function (newParams) {
	      var filter = newParams.filter || _this.state.filter;
	      var currentPage = newParams.currentPage || _this.state.currentPage;
	      var sort = newParams.sort || _this.state.sort;
	      var hash = JSON.stringify({ filter: filter, currentPage: currentPage, sort: sort });
	      var pathname = _this.props.location.pathname;
	
	      _this.context.router.replace({ pathname: pathname, hash: '#' + hash });
	      _this.setState(newParams);
	    };
	
	    _this.state = _extends({
	      showTooltip: false,
	      filter: {},
	      currentPage: 1,
	      sort: {}
	    }, _this.extractSearchParams(props.location));
	    return _this;
	  }
	
	  _createClass(MyInfluencers, [{
	    key: 'render',
	    value: function render() {
	      var user = this.props.user;
	      var _state = this.state,
	          filter = _state.filter,
	          currentPage = _state.currentPage,
	          sort = _state.sort;
	
	      var searchParams = { filter: filter, currentPage: currentPage, sort: sort };
	
	      var cacheBuster = this.props.location.query;
	
	      var organisationName = user ? user.organisation.name : '';
	      var organisationId = user ? user.organisation.id : '';
	      var organisationSlug = user ? user.organisation.slug : '';
	      var displayAuthorisedData = user ? user.organisation.displayAuthorisedData : false;
	      var usesGlobalTags = user ? user.organisation.usesGlobalTags : false;
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_influencerContextBar2.default, {
	          organisationName: organisationName,
	          showTooltip: this.state.showTooltip,
	          rightButtonLabel: 'Add An Influencer',
	          leftButtonLabel: 'Create A Campaign',
	          rightButtonCallback: this.rightButtonCallback,
	          leftButtonCallback: this.leftButtonCallback,
	          title: 'My Influencers',
	          hasPrivateLink: true
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          user && _react2.default.createElement(_influencerTable2.default, {
	            usesGlobalTags: usesGlobalTags,
	            organisationSlug: organisationSlug,
	            organisationId: organisationId,
	            displayAuthorisedData: displayAuthorisedData,
	            toggleShowTooltip: this.toggleShowTooltip,
	            cacheBuster: cacheBuster,
	            searchParams: searchParams,
	            onSearchParamsChange: this.onSearchParamsChange
	          })
	        )
	      );
	    }
	  }]);
	
	  return MyInfluencers;
	}(_react.Component);
	
	MyInfluencers.contextTypes = {
	  router: _propTypes2.default.object
	};
	MyInfluencers.propTypes = {
	  user: _propTypes2.default.object
	};
	MyInfluencers.defaultProps = {
	  user: null
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(MyInfluencers);

/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(37);
	
	var _recompose = __webpack_require__(15);
	
	var _authService = __webpack_require__(21);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewInfluencerWelcome = function (_React$Component) {
	  _inherits(NewInfluencerWelcome, _React$Component);
	
	  function NewInfluencerWelcome() {
	    _classCallCheck(this, NewInfluencerWelcome);
	
	    var _this = _possibleConstructorReturn(this, (NewInfluencerWelcome.__proto__ || Object.getPrototypeOf(NewInfluencerWelcome)).call(this));
	
	    _this.loadInfluencer = function () {
	      var profile = _authService.authService.getProfile();
	      var organisationId = profile.app_metadata.dyzio.o_id;
	
	      var jsonAPIClient = _this.props.jsonAPIClient;
	
	      jsonAPIClient.get('organisations', organisationId, { include: ['influencer'] }).then(function (organisation) {
	        return organisation.toJSONTree();
	      }).then(function (org) {
	        var influencer = org.influencer;
	
	        _this.setState({
	          influencer: influencer
	        });
	      }).catch(function (e) {
	        console.log(e);
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(NewInfluencerWelcome, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadInfluencer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var influencer = this.state.influencer;
	
	      if (!influencer) return null;
	
	      var setupComplete = influencer.setupComplete;
	
	      if (!setupComplete) {
	        this.props.history.push('/new-influencer/registration');
	        return null;
	      }
	      return _react2.default.createElement(
	        'pre',
	        null,
	        JSON.stringify(influencer, null, ' ')
	      );
	    }
	  }]);
	
	  return NewInfluencerWelcome;
	}(_react2.default.Component);
	
	exports.default = (0, _recompose.compose)(_reactRouter.withRouter, _hasJsonapiClient2.default, _hasUserInfo2.default)(NewInfluencerWelcome);

/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(37);
	
	var _recompose = __webpack_require__(15);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _validator = __webpack_require__(84);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _authService = __webpack_require__(21);
	
	var _influencerCardPreview = __webpack_require__(349);
	
	var _influencerCardPreview2 = _interopRequireDefault(_influencerCardPreview);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _addInfluencerToOrganisation = __webpack_require__(2370);
	
	var _addInfluencerToOrganisation2 = _interopRequireDefault(_addInfluencerToOrganisation);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _influencerSetupForm = __webpack_require__(879);
	
	var _influencerSetupForm2 = _interopRequireDefault(_influencerSetupForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ENROLLED_BY = {
	  self: 'SELF'
	};
	
	var toObject = function toObject(string) {
	  return { value: string };
	};
	
	var NewInfluencerRegistration = function (_React$Component) {
	  _inherits(NewInfluencerRegistration, _React$Component);
	
	  function NewInfluencerRegistration() {
	    _classCallCheck(this, NewInfluencerRegistration);
	
	    // TODO: Find out if pages are still supposed to just create their own restClient?
	    var _this = _possibleConstructorReturn(this, (NewInfluencerRegistration.__proto__ || Object.getPrototypeOf(NewInfluencerRegistration)).call(this));
	
	    _this.onInfluencerChange = function (influencer) {
	      _this.setState({ influencer: influencer });
	    };
	
	    _this.onSubmit = function () {
	      var influencer = _this.state.influencer;
	      var id = influencer.id,
	          name = influencer.name,
	          country = influencer.country,
	          email = influencer.email,
	          facebook = influencer.facebook,
	          twitter = influencer.twitter,
	          youtube = influencer.youtube,
	          website = influencer.website,
	          contentTags = influencer.contentTags,
	          previousClients = influencer.previousClients,
	          willNotWorkWith = influencer.willNotWorkWith,
	          setupComplete = influencer.setupComplete,
	          contactNumber = influencer.contactNumber,
	          addressLine1 = influencer.addressLine1,
	          region = influencer.region,
	          postalCode = influencer.postalCode,
	          city = influencer.city;
	
	      var influencerPatch = {
	        name: name,
	        country: country,
	        email: email,
	        facebook: facebook,
	        twitter: twitter,
	        youtube: youtube,
	        website: website,
	        contactNumber: contactNumber,
	        addressLine1: addressLine1,
	        region: region,
	        postalCode: postalCode,
	        city: city,
	        contentTags: (0, _lodash.map)(contentTags, toObject),
	        previousClients: (0, _lodash.map)(previousClients, toObject),
	        willNotWorkWith: (0, _lodash.map)(willNotWorkWith, toObject),
	        setupComplete: true
	      };
	
	      var safePatch = (0, _lodash.pickBy)(influencerPatch);
	
	      var requestData = { data: { attributes: safePatch } };
	      _this.restClient.patch('/influencer/' + id, requestData).then(function () {
	        if (!setupComplete) {
	          var _ThemeSelector$theme = _themeSelector2.default.theme(),
	              organisationId = _ThemeSelector$theme.organisationId;
	
	          return (0, _addInfluencerToOrganisation2.default)(_extends({}, influencer, { brandTags: previousClients }), organisationId);
	        }
	        return true;
	      }).then(function () {
	        return _this.props.history.push('/new-influencer/welcome');
	      }).catch(function (e) {
	        console.error('Can not patch influencer', e);
	        (0, _errorHandlingService.reportError)('CANNOT_PATCH_NEW_INFLUENCER', e);
	      });
	    };
	
	    _this.loadInfluencer = function () {
	      var profile = _authService.authService.getProfile();
	      var organisationId = profile.app_metadata.dyzio.o_id;
	
	      var jsonAPIClient = _this.props.jsonAPIClient;
	
	      jsonAPIClient.get('organisations', organisationId, { include: ['influencer'] }).then(function (organisation) {
	        return organisation.toJSONTree();
	      }).then(function (org) {
	        var influencer = org.influencer;
	
	        var selfEnrolled = influencer.enrolledBy === ENROLLED_BY.self;
	        return _this.setState({
	          influencer: _extends({}, influencer, {
	            contentTags: (0, _lodash.map)(influencer.contentTags, 'value'),
	            previousClients: (0, _lodash.map)(influencer.previousClients, 'value'),
	            willNotWorkWith: (0, _lodash.map)(influencer.willNotWorkWith, 'value')
	          }),
	          selfEnrolled: selfEnrolled
	        });
	      }).catch(function (e) {
	        console.log(e);
	        (0, _errorHandlingService.reportError)('CANNOT_LOAD_NEW_INFLUENCER', e);
	      });
	    };
	
	    _this.canSubmit = function (_ref) {
	      var name = _ref.name,
	          country = _ref.country,
	          email = _ref.email,
	          agreedToShareWithDyzio = _ref.agreedToShareWithDyzio,
	          agreedToTermsOfUse = _ref.agreedToTermsOfUse,
	          setupComplete = _ref.setupComplete,
	          facebook = _ref.facebook,
	          facebookError = _ref.facebookError,
	          facebookLoading = _ref.facebookLoading,
	          twitter = _ref.twitter,
	          twitterError = _ref.twitterError,
	          twitterLoading = _ref.twitterLoading,
	          youtube = _ref.youtube,
	          youtubeError = _ref.youtubeError,
	          youtubeLoading = _ref.youtubeLoading;
	      return !(0, _lodash.isEmpty)(name) && !(0, _lodash.isEmpty)(country) && (0, _lodash.isString)(email) && (0, _validator.isEmail)(email) && (setupComplete || agreedToShareWithDyzio && agreedToTermsOfUse) && (!facebook || !facebookError && !facebookLoading) && (!twitter || !twitterError && !twitterLoading) && (!youtube || !youtubeError && !youtubeLoading);
	    };
	
	    _this.render = function () {
	      var influencer = _this.state.influencer;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { divided: true, stackable: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 10 },
	            influencer && _react2.default.createElement(_influencerSetupForm2.default, {
	              influencer: influencer,
	              onChange: (0, _lodash.debounce)(_this.onInfluencerChange, 200)
	            }),
	            influencer && _react2.default.createElement(_dyzioButtons.DyzioPrimaryButton, {
	              fluid: true,
	              label: 'Submit your application',
	              hasIcon: true,
	              disabled: !_this.canSubmit(influencer),
	              onClick: _this.onSubmit,
	              icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'save' })
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Responsive,
	            { width: 6, as: _semanticUiReact.Grid.Column, minWidth: 768 },
	            influencer && _react2.default.createElement(_influencerCardPreview2.default, influencer)
	          )
	        )
	      );
	    };
	
	    _this.restClient = _axios2.default.create({
	      baseURL: ("https://api2.dyzio.co/v1"),
	      timeout: 5000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    _this.state = { influencer: null };
	    return _this;
	  }
	
	  _createClass(NewInfluencerRegistration, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadInfluencer();
	      // const theme = ThemeSelector.theme();
	    }
	  }]);
	
	  return NewInfluencerRegistration;
	}(_react2.default.Component);
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _reactRouter.withRouter, _hasJsonapiClient2.default)(NewInfluencerRegistration);

/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactBrowserDetection = __webpack_require__(255);
	
	var _reactBrowserDetection2 = _interopRequireDefault(_reactBrowserDetection);
	
	var _poweredByDyzio = __webpack_require__(278);
	
	var _poweredByDyzio2 = _interopRequireDefault(_poweredByDyzio);
	
	var _browserHandler = __webpack_require__(231);
	
	var _browserHandler2 = _interopRequireDefault(_browserHandler);
	
	var _authService = __webpack_require__(21);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var viewportStyles = {
	  backgroundColor: '#f7fafa',
	  height: 'auto',
	  minHeight: '100vh',
	  display: 'flex',
	  alignItems: 'center',
	  justifyContent: 'center',
	  padding: '64px 24px'
	};
	
	var signupBoxStyle = {
	  background: 'white',
	  border: '1px solid #e8e8e8',
	  borderRadius: '4px',
	  padding: '24px',
	  maxWidth: '960px',
	  margin: '0 auto'
	};
	
	var gridStyle = {
	  minHeight: 300
	};
	
	var NewInfluencerSignup = function NewInfluencerSignup() {
	  var theme = _themeSelector2.default.theme();
	  var _theme$copy = theme.copy,
	      featureList = _theme$copy.featureList,
	      joinTitle = _theme$copy.joinTitle,
	      joinDescription = _theme$copy.joinDescription;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: viewportStyles },
	    _react2.default.createElement(
	      'div',
	      { className: 'align-center' },
	      _react2.default.createElement(
	        _semanticUiReact.Responsive,
	        { minWidth: 300, maxWidth: 599 },
	        _react2.default.createElement(_semanticUiReact.Image, { size: 'large', src: theme.darkLogo.src, centered: true })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Responsive,
	        { minWidth: 600 },
	        _react2.default.createElement(_semanticUiReact.Image, { size: 'big', src: theme.darkLogo.src, centered: true })
	      ),
	      _react2.default.createElement('div', { className: 'spacer' }),
	      _react2.default.createElement(
	        'h2',
	        null,
	        joinTitle
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        joinDescription
	      ),
	      _react2.default.createElement('div', { className: 'spacer large' }),
	      _react2.default.createElement(
	        'div',
	        { style: signupBoxStyle },
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { columns: 2, stackable: true, divided: true, style: gridStyle },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { verticalAlign: 'middle' },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              null,
	              _react2.default.createElement(_semanticUiReact.Button, {
	                content: 'Sign up with Instagram',
	                inverted: true, color: 'pink',
	                icon: 'instagram',
	                size: 'large',
	                onClick: function onClick() {
	                  var origin = window.location.origin;
	
	                  var options = {
	                    prompt: 'login',
	                    redirectUri: window.location.origin + '/influencer-auth',
	                    logo: '' + origin + theme.darkLogo.src
	                  };
	                  _authService.authService.socialLogin(options);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { className: 'align-left' },
	              featureList
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: 'spacer' }),
	      _react2.default.createElement(_poweredByDyzio2.default, null),
	      _react2.default.createElement(
	        _reactBrowserDetection2.default,
	        null,
	        _browserHandler2.default.handle
	      )
	    )
	  );
	};
	
	exports.default = NewInfluencerSignup;

/***/ },
/* 2177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(37);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _authService = __webpack_require__(21);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _influencerCardPreview = __webpack_require__(349);
	
	var _influencerCardPreview2 = _interopRequireDefault(_influencerCardPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewInfluencerWelcome = function (_React$Component) {
	  _inherits(NewInfluencerWelcome, _React$Component);
	
	  function NewInfluencerWelcome() {
	    _classCallCheck(this, NewInfluencerWelcome);
	
	    var _this = _possibleConstructorReturn(this, (NewInfluencerWelcome.__proto__ || Object.getPrototypeOf(NewInfluencerWelcome)).call(this));
	
	    _this.loadInfluencer = function () {
	      var profile = _authService.authService.getProfile();
	      var organisationId = profile.app_metadata.dyzio.o_id;
	
	      var jsonAPIClient = _this.props.jsonAPIClient;
	
	      jsonAPIClient.get('organisations', organisationId, { include: ['influencer'] }).then(function (organisation) {
	        return organisation.toJSONTree();
	      }).then(function (org) {
	        var influencer = org.influencer;
	
	        _this.setState({
	          influencer: influencer
	        });
	      }).catch(function (e) {
	        console.log(e);
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(NewInfluencerWelcome, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadInfluencer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var influencer = this.state.influencer;
	
	      var _ref = influencer || {},
	          name = _ref.name,
	          country = _ref.country,
	          email = _ref.email,
	          instagram = _ref.instagram,
	          facebook = _ref.facebook,
	          twitter = _ref.twitter,
	          youtube = _ref.youtube,
	          web = _ref.web,
	          contentTags = _ref.contentTags,
	          previousClients = _ref.previousClients,
	          willNotWorkWith = _ref.willNotWorkWith;
	
	      if (!influencer) return null;
	      var setupComplete = influencer.setupComplete;
	
	      if (!setupComplete) {
	        this.props.history.push('/new-influencer/registration');
	        return null;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Thankyou for registering'
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Please see below the information that you submitted. If you would like to update this information please',
	          _react2.default.createElement(
	            'a',
	            { href: '/new-influencer/registration' },
	            ' click here'
	          ),
	          '.'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We\'ll be in contact when we find a brief that we think will be good for you.'
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Your profile ',
	          _react2.default.createElement(
	            'a',
	            { href: '/new-influencer/registration' },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' })
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 10 },
	              _react2.default.createElement(
	                _semanticUiReact.Grid,
	                { stackable: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 8 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Name'
	                    ),
	                    name
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 8 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Country'
	                    ),
	                    country
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 8 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Email Address'
	                    ),
	                    email
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Row,
	                  null,
	                  instagram && _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 8 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Instagram'
	                    ),
	                    instagram
	                  ),
	                  facebook && _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 8 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Facebook'
	                    ),
	                    facebook
	                  ),
	                  youtube && _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 8 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Youtube'
	                    ),
	                    youtube
	                  ),
	                  twitter && _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 8 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Twitter'
	                    ),
	                    twitter
	                  )
	                ),
	                web && _react2.default.createElement(
	                  _semanticUiReact.Grid.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 5 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Name'
	                    ),
	                    name
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Row,
	                  null,
	                  contentTags && _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 8 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Content Tags'
	                    ),
	                    (0, _lodash.map)(contentTags, function (_ref2) {
	                      var value = _ref2.value;
	                      return _react2.default.createElement(
	                        _semanticUiReact.Label,
	                        null,
	                        value
	                      );
	                    })
	                  ),
	                  previousClients && _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 8 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Previous Clients'
	                    ),
	                    (0, _lodash.map)(previousClients, function (_ref3) {
	                      var value = _ref3.value;
	                      return _react2.default.createElement(
	                        _semanticUiReact.Label,
	                        null,
	                        value
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Row,
	                  null,
	                  willNotWorkWith && _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { width: 8 },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Sectors & Brands you will not work for'
	                    ),
	                    (0, _lodash.map)(willNotWorkWith, function (_ref4) {
	                      var value = _ref4.value;
	                      return _react2.default.createElement(
	                        _semanticUiReact.Label,
	                        { key: value },
	                        value
	                      );
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Responsive,
	              { width: 6, as: _semanticUiReact.Grid.Column, minWidth: 768 },
	              influencer && _react2.default.createElement(_influencerCardPreview2.default, influencer)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewInfluencerWelcome;
	}(_react2.default.Component);
	
	exports.default = (0, _recompose.compose)(_reactRouter.withRouter, _hasJsonapiClient2.default, _hasUserInfo2.default)(NewInfluencerWelcome);

/***/ },
/* 2178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBrowserDetection = __webpack_require__(255);
	
	var _reactBrowserDetection2 = _interopRequireDefault(_reactBrowserDetection);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _browserHandler = __webpack_require__(231);
	
	var _browserHandler2 = _interopRequireDefault(_browserHandler);
	
	var _header = __webpack_require__(348);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _poweredByDyzio = __webpack_require__(278);
	
	var _poweredByDyzio2 = _interopRequireDefault(_poweredByDyzio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewInfluencer = function NewInfluencer(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_header2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'page' },
	      _react2.default.createElement(
	        'div',
	        { className: 'page-content' },
	        _react2.default.createElement(
	          _semanticUiReact.Segment,
	          null,
	          children,
	          _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	        )
	      ),
	      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	      _react2.default.createElement(
	        'div',
	        { className: 'align-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'browser-detect' },
	          _react2.default.createElement(_poweredByDyzio2.default, null),
	          _react2.default.createElement(
	            _reactBrowserDetection2.default,
	            null,
	            _browserHandler2.default.handle
	          )
	        )
	      ),
	      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	    )
	  );
	};
	
	NewInfluencer.propTypes = {
	  children: _propTypes2.default.object.isRequired
	};
	
	exports.default = NewInfluencer;

/***/ },
/* 2179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NONACRCampaignSetup = function (_Component) {
	  _inherits(NONACRCampaignSetup, _Component);
	
	  function NONACRCampaignSetup() {
	    _classCallCheck(this, NONACRCampaignSetup);
	
	    var _this = _possibleConstructorReturn(this, (NONACRCampaignSetup.__proto__ || Object.getPrototypeOf(NONACRCampaignSetup)).call(this));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(NONACRCampaignSetup, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        'Hello, I am that tab'
	      );
	    }
	  }]);
	
	  return NONACRCampaignSetup;
	}(_react.Component);
	
	exports.default = NONACRCampaignSetup;

/***/ },
/* 2180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OnlineChecker = function (_React$Component) {
	  _inherits(OnlineChecker, _React$Component);
	
	  function OnlineChecker(props, context) {
	    _classCallCheck(this, OnlineChecker);
	
	    var _this = _possibleConstructorReturn(this, (OnlineChecker.__proto__ || Object.getPrototypeOf(OnlineChecker)).call(this, props, context));
	
	    _this.state = {
	      online: window.navigator.onLine
	    };
	
	    window.addEventListener('offline', function () {
	      return _this.setState({ online: false });
	    });
	    window.addEventListener('online', function () {
	      return _this.setState({ online: true });
	    });
	    return _this;
	  }
	
	  _createClass(OnlineChecker, [{
	    key: 'render',
	    value: function render() {
	      var online = this.state.online;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        !online && _react2.default.createElement(
	          'div',
	          { className: 'app-offline-message' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Oops! You don\u2019t appear to be connected to the internet. Please connect and try again.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return OnlineChecker;
	}(_react2.default.Component);
	
	exports.default = OnlineChecker;

/***/ },
/* 2181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _ordersTable = __webpack_require__(2182);
	
	var _ordersTable2 = _interopRequireDefault(_ordersTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var boxStyle = {
	  paddingTop: 19,
	  paddingBottom: 19
	};
	
	var OrdersDashboard = function (_React$Component) {
	  _inherits(OrdersDashboard, _React$Component);
	
	  function OrdersDashboard(props) {
	    _classCallCheck(this, OrdersDashboard);
	
	    var _this = _possibleConstructorReturn(this, (OrdersDashboard.__proto__ || Object.getPrototypeOf(OrdersDashboard)).call(this, props));
	
	    _this.componentDidMount = function () {
	      _this.requestData();
	    };
	
	    _this.requestData = function () {
	      var reloading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var selectedCountry = _this.state.selectedCountry;
	
	
	      var loadingKey = reloading ? 'isReloading' : 'isLoading';
	      _this.setState(_defineProperty({}, loadingKey, true));
	      _this.shareApiClient.get('/affiliates/orders/' + selectedCountry).then(function (response) {
	        var orders = _lodash2.default.get(response, 'data.data.orders', []);
	        _this.setState(_defineProperty({
	          orders: orders
	        }, loadingKey, false));
	      }).catch(function (err) {
	        console.log('Error: ', err);
	        _this.setState(_defineProperty({
	          orders: []
	        }, loadingKey, false));
	      });
	    };
	
	    _this.onCountrySelect = function (event, _ref) {
	      var value = _ref.value;
	      var isLoading = _this.state.isLoading;
	
	      if (isLoading) return;
	      _this.setState({
	        selectedCountry: value
	      }, _this.requestData);
	    };
	
	    _this.state = {
	      isLoading: false,
	      orders: [],
	      selectedCountry: 'UK'
	    };
	    var buildRESTClient = _this.props.buildRESTClient;
	
	    _this.shareApiClient = buildRESTClient({
	      baseURL: ("https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production") || '',
	      timeout: 100000
	    });
	    return _this;
	  }
	
	  _createClass(OrdersDashboard, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          isReloading = _state.isReloading,
	          orders = _state.orders,
	          selectedCountry = _state.selectedCountry;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'influencer-context-bar', style: boxStyle },
	          _react2.default.createElement('div', { className: 'spacer small' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Orders Dashboard'
	              )
	            ),
	            _react2.default.createElement('div', { className: 'space' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'light' },
	                'Abbott Lyon'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement('div', { className: 'horizontal-spacer' })
	            ),
	            _react2.default.createElement('div', { className: 'space' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(_ordersTable2.default, {
	            onCountrySelect: this.onCountrySelect,
	            isLoading: isLoading,
	            orders: orders,
	            onReload: this.requestData,
	            isReloading: isReloading,
	            selectedCountry: selectedCountry
	          })
	        )
	      );
	    }
	  }]);
	
	  return OrdersDashboard;
	}(_react2.default.Component);
	
	OrdersDashboard.propTypes = {
	  userInfo: _propTypes2.default.object.isRequired,
	  buildRESTClient: _propTypes2.default.func.isRequired
	};
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _hasRestClient2.default)(OrdersDashboard);

/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _numeral = __webpack_require__(32);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var countriesOptions = [{ key: 'UK', value: 'UK', text: 'United Kingdom' }, { key: 'US', value: 'US', text: 'United States' }];
	
	var currencies = {
	  GBP: '£',
	  USD: '$'
	};
	
	var getCurrencySymbol = function getCurrencySymbol(currency) {
	  return _lodash2.default.get(currencies, currency, '');
	};
	
	var getFixed = function getFixed(num) {
	  return (0, _numeral2.default)(num).format('0.00');
	};
	
	var totalsRowStyles = {
	  fontWeight: 900,
	  backgroundColor: '#D2D1D7'
	};
	
	var OrdersTable = function OrdersTable(_ref) {
	  var isLoading = _ref.isLoading,
	      orders = _ref.orders,
	      selectedCountry = _ref.selectedCountry,
	      onReload = _ref.onReload,
	      isReloading = _ref.isReloading,
	      onCountrySelect = _ref.onCountrySelect;
	
	  var ordersTotals = _lodash2.default.sumBy(orders, 'orderTotal');
	  var ordersCommissionsTotals = _lodash2.default.sumBy(orders, 'orderCommission');
	  var orderCurrency = _lodash2.default.get(orders, '[0].orderCurrency');
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Menu,
	      { icon: true },
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Menu,
	        { position: 'left' },
	        _react2.default.createElement(_semanticUiReact.Dropdown, {
	          onChange: onCountrySelect,
	          value: selectedCountry,
	          options: countriesOptions,
	          simple: true,
	          item: true
	        })
	      )
	    ),
	    isLoading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading orders...' }),
	    _react2.default.createElement(
	      _semanticUiReact.Card,
	      { color: 'green', fluid: true },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        !isLoading && _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', justifyContent: 'flex-between', alignItems: 'center' } },
	          _react2.default.createElement(
	            'h3',
	            { style: { flexGrow: 1 } },
	            'Total Orders: ',
	            _lodash2.default.size(orders)
	          ),
	          _react2.default.createElement(_semanticUiReact.Popup, {
	            trigger: _react2.default.createElement(_semanticUiReact.Button, {
	              circular: true, inverted: true, color: 'green', icon: 'refresh',
	              onClick: function onClick() {
	                return isReloading ? null : onReload(true);
	              },
	              loading: isReloading
	            }),
	            content: 'Click here reload orders'
	          })
	        ),
	        !isLoading && _react2.default.createElement(
	          _semanticUiReact.Table,
	          { celled: true },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Header,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'Order Date'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'Order ID'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'Campaign'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'Term'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'Name'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'Discount Code'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'Order Total'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'Order Commission'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _lodash2.default.map(orders, function (order) {
	              return _react2.default.createElement(OrderTableRow, {
	                key: order.orderId,
	                order: order
	              });
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Footer,
	            { fullWidth: true },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              { style: totalsRowStyles },
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { style: totalsRowStyles },
	                'TOTALS'
	              ),
	              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { style: totalsRowStyles }),
	              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { style: totalsRowStyles }),
	              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { style: totalsRowStyles }),
	              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { style: totalsRowStyles }),
	              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { style: totalsRowStyles }),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { style: totalsRowStyles, textAlign: 'right' },
	                getCurrencySymbol(orderCurrency),
	                getFixed(ordersTotals)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                { style: totalsRowStyles, textAlign: 'right' },
	                getCurrencySymbol(orderCurrency),
	                getFixed(ordersCommissionsTotals)
	              )
	            )
	          )
	        ),
	        isLoading && _react2.default.createElement(
	          'p',
	          null,
	          'Loading...'
	        )
	      )
	    )
	  );
	};
	
	var OrderTableRow = function OrderTableRow(_ref2) {
	  var order = _ref2.order;
	  var orderDate = order.orderDate,
	      orderId = order.orderId,
	      campaign = order.campaign,
	      term = order.term,
	      name = order.name,
	      discountCode = order.discountCode,
	      orderTotal = order.orderTotal,
	      orderCommission = order.orderCommission,
	      orderCurrency = order.orderCurrency;
	
	  var date = orderDate ? (0, _moment2.default)(orderDate).format('YYYY-MM-DD, HH:mm') : null;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      date
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      orderId
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      campaign
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      term
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      name
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      discountCode
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'right' },
	      getCurrencySymbol(orderCurrency),
	      getFixed(orderTotal)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'right' },
	      getCurrencySymbol(orderCurrency),
	      getFixed(orderCommission)
	    )
	  );
	};
	
	OrderTableRow.propTypes = {
	  order: _propTypes2.default.object.isRequired
	};
	
	OrdersTable.propTypes = {
	  onCountrySelect: _propTypes2.default.func.isRequired,
	  isLoading: _propTypes2.default.bool,
	  isReloading: _propTypes2.default.bool,
	  orders: _propTypes2.default.array,
	  selectedCountry: _propTypes2.default.string,
	  onReload: _propTypes2.default.func
	};
	
	OrdersTable.defaultProps = {
	  isLoading: false,
	  isReloading: false,
	  orders: [],
	  isLoadingCampaigns: false,
	  isTimeoutError: false,
	  selectedCountry: '',
	  onReload: null
	};
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default)(OrdersTable);

/***/ },
/* 2183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _influencerContextBar = __webpack_require__(193);
	
	var _influencerContextBar2 = _interopRequireDefault(_influencerContextBar);
	
	var _auditLogTable = __webpack_require__(1892);
	
	var _auditLogTable2 = _interopRequireDefault(_auditLogTable);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _withOrganisationData = __webpack_require__(2249);
	
	var _withOrganisationData2 = _interopRequireDefault(_withOrganisationData);
	
	var _withDyzioEventsData = __webpack_require__(284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PER_PAGE = 12;
	
	var OrganisationAuditLog = function (_Component) {
	  _inherits(OrganisationAuditLog, _Component);
	
	  function OrganisationAuditLog(props) {
	    _classCallCheck(this, OrganisationAuditLog);
	
	    var _this = _possibleConstructorReturn(this, (OrganisationAuditLog.__proto__ || Object.getPrototypeOf(OrganisationAuditLog)).call(this, props));
	
	    _this.onPageIncrement = function () {
	      return _this.setState({
	        currentOffset: _lodash2.default.add(_this.state.currentOffset, PER_PAGE),
	        shouldRenderLoader: true
	      }, _this.fetchEvents);
	    };
	
	    _this.onPageDecrement = function () {
	      return _this.setState({
	        currentOffset: _lodash2.default.subtract(_this.state.currentOffset, PER_PAGE),
	        shouldRenderLoader: true
	      }, _this.fetchEvents);
	    };
	
	    _this.fetchEvents = function () {
	      var _this$props = _this.props,
	          getDyzioEvents = _this$props.getDyzioEvents,
	          organisationId = _this$props.userInfo.organisationId;
	      var currentOffset = _this.state.currentOffset;
	
	
	      getDyzioEvents({
	        filter: {
	          organisation: organisationId,
	          eventName: [_withDyzioEventsData.EVENT_TYPES.INFLUENCER_CREATED, _withDyzioEventsData.EVENT_TYPES.USER_CREATED, _withDyzioEventsData.EVENT_TYPES.CAMPAIGN_CREATED, _withDyzioEventsData.EVENT_TYPES.SHORTLIST_CREATED, _withDyzioEventsData.EVENT_TYPES.TRACKED_ASSED_CREATED, _withDyzioEventsData.EVENT_TYPES.CAMPAIGN_PERMISSION_CREATED, _withDyzioEventsData.EVENT_TYPES.CAMPAIGN_INVITATION_CREATED, _withDyzioEventsData.EVENT_TYPES.CAMPAIGN_INVITATION_UPDATED]
	        },
	        page: {
	          limit: PER_PAGE,
	          offset: currentOffset
	        },
	        sort: '-createdDate'
	      }).then(function (eventRecords) {
	        var eventsSize = _lodash2.default.size(eventRecords);
	        var shouldDisableNextButton = currentOffset > 0 && eventsSize < PER_PAGE;
	        var events = _lodash2.default.isEmpty(eventRecords) && shouldDisableNextButton ? _this.state.events : eventRecords;
	        _this.setState({
	          events: events,
	          isLoaded: true,
	          shouldRenderLoader: false,
	          shouldDisableNextButton: shouldDisableNextButton
	        });
	        return events;
	      }).catch(function () {
	        _this.setState({
	          shouldRenderLoader: false,
	          events: [],
	          isLoaded: false,
	          hasNextPage: false
	        });
	      });
	    };
	
	    _this.state = {
	      shouldRenderLoader: true,
	      isLoaded: false,
	      hasNextPage: true,
	      organisation: null,
	      events: [],
	      currentOffset: 0
	    };
	    return _this;
	  }
	
	  _createClass(OrganisationAuditLog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          getOrganisationById = _props.getOrganisationById,
	          organisationId = _props.userInfo.organisationId;
	      var _console = console,
	          error = _console.error;
	
	      getOrganisationById(organisationId).then(function (organisation) {
	        _this2.setState({
	          organisation: organisation
	        }, _this2.fetchEvents);
	        return organisation;
	      }).catch(error);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          organisation = _state.organisation,
	          isLoaded = _state.isLoaded,
	          shouldRenderLoader = _state.shouldRenderLoader,
	          events = _state.events,
	          currentOffset = _state.currentOffset,
	          shouldDisableNextButton = _state.shouldDisableNextButton;
	
	
	      var tableProps = {
	        isLoaded: isLoaded,
	        shouldRenderLoader: shouldRenderLoader,
	        events: events,
	        onPageIncrement: this.onPageIncrement,
	        onPageDecrement: this.onPageDecrement,
	        currentOffset: currentOffset,
	        shouldDisableNextButton: shouldDisableNextButton
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        organisation && _react2.default.createElement(_influencerContextBar2.default, {
	          organisationName: organisation.name,
	          showTooltip: false,
	          rightButtonCallback: null,
	          leftButtonLabel: '',
	          rightButtonLabel: '',
	          title: 'Audit Log'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(_auditLogTable2.default, tableProps)
	        )
	      );
	    }
	  }]);
	
	  return OrganisationAuditLog;
	}(_react.Component);
	
	OrganisationAuditLog.propTypes = {
	  userInfo: _propTypes2.default.object.isRequired,
	  getOrganisationById: _propTypes2.default.func.isRequired,
	  getDyzioEvents: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_withDyzioEventsData.withDyzioEventsData, _withOrganisationData2.default, _hasUserInfo2.default)(OrganisationAuditLog);

/***/ },
/* 2184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadPayments = loadPayments;
	
	var _constants = __webpack_require__(561);
	
	function loadPayments(id) {
	  return {
	    type: _constants.LOAD_PAYMENTS,
	    id: id
	  };
	}

/***/ },
/* 2185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(561);
	
	var initialState = (0, _immutable.fromJS)({
	  payments: {},
	  paymentsLoading: true,
	  paymentsError: null
	});
	
	function paymentsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.LOAD_PAYMENTS_ERROR:
	      return state.set('payments', null).set('paymentsLoading', false).set('paymentsError', action.error);
	    case _constants.LOAD_PAYMENTS_SUCCESS:
	      return state.set('payments', action.data).set('paymentsLoading', false).set('paymentsError', null);
	    default:
	      return state;
	  }
	}
	
	exports.default = paymentsReducer;

/***/ },
/* 2186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.loadPayments = loadPayments;
	exports.watchPayments = watchPayments;
	exports.default = paymentsSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _constants = __webpack_require__(561);
	
	var _payments = __webpack_require__(2387);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadPayments, watchPayments, paymentsSagas].map(_regenerator2.default.mark);
	
	function loadPayments(action) {
	  var id, paymentsData;
	  return _regenerator2.default.wrap(function loadPayments$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          id = action.id;
	          _context.prev = 1;
	          _context.next = 4;
	          return (0, _effects.call)(_payments.getPaymentsData, id);
	
	        case 4:
	          paymentsData = _context.sent;
	          _context.next = 7;
	          return (0, _effects.put)({ type: _constants.LOAD_PAYMENTS_SUCCESS, data: paymentsData });
	
	        case 7:
	          _context.next = 13;
	          break;
	
	        case 9:
	          _context.prev = 9;
	          _context.t0 = _context['catch'](1);
	          _context.next = 13;
	          return (0, _effects.put)({ type: _constants.LOAD_PAYMENTS_ERROR, error: _context.t0.message });
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[1, 9]]);
	}
	
	function watchPayments() {
	  return _regenerator2.default.wrap(function watchPayments$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.LOAD_PAYMENTS, loadPayments);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function paymentsSagas() {
	  return _regenerator2.default.wrap(function paymentsSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(watchPayments)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 2187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _plainHeader = __webpack_require__(350);
	
	var _plainHeader2 = _interopRequireDefault(_plainHeader);
	
	var _pendingInvitationsList = __webpack_require__(2013);
	
	var _pendingInvitationsList2 = _interopRequireDefault(_pendingInvitationsList);
	
	var _withPendingInvitations = __webpack_require__(923);
	
	var _withPendingInvitations2 = _interopRequireDefault(_withPendingInvitations);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS_DECLINED = 'DECLINED';
	
	var PendingInvitations = function (_Component) {
	  _inherits(PendingInvitations, _Component);
	
	  function PendingInvitations(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, PendingInvitations);
	
	    var _this = _possibleConstructorReturn(this, (PendingInvitations.__proto__ || Object.getPrototypeOf(PendingInvitations)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.fetchInvitations();
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.onInvitationAccepted = function (invitationId) {
	      var invitation = _lodash2.default.find(_this.state.invitations, ['id', invitationId]);
	      var link = invitation.link;
	
	      window.open(link, '_blank');
	      var updatedInvitations = _lodash2.default.reject(_this.state.invitations, ['id', invitation.id]);
	      _this.setState({
	        invitations: updatedInvitations
	      });
	    };
	
	    _this.onInvitationDeclined = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(invitationId) {
	        var updateInvitationStatusById;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                updateInvitationStatusById = _this.props.updateInvitationStatusById;
	                _context2.next = 3;
	                return updateInvitationStatusById(invitationId, STATUS_DECLINED);
	
	              case 3:
	                _context2.next = 5;
	                return _this.fetchInvitations();
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.onShowDeclinedInvitationsToggleChanged = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(event, data) {
	        var checked;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                checked = data.checked;
	
	                _this.setState({
	                  shouldFetchDeclinedInvitations: checked
	                }, _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	                  return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          _context3.next = 2;
	                          return _this.fetchInvitations();
	
	                        case 2:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this2);
	                })));
	
	              case 2:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x2, _x3) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.fetchInvitations = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var _this$props, userEmail, getPendingInvitationsByUserEmail, shouldFetchDeclinedInvitations, invitations;
	
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _this$props = _this.props, userEmail = _this$props.userInfo.email, getPendingInvitationsByUserEmail = _this$props.getPendingInvitationsByUserEmail;
	              shouldFetchDeclinedInvitations = _this.state.shouldFetchDeclinedInvitations;
	
	
	              _this.setState({
	                isLoading: true,
	                isError: false
	              });
	
	              _context5.next = 5;
	              return getPendingInvitationsByUserEmail(userEmail, shouldFetchDeclinedInvitations).catch(_this.handleError);
	
	            case 5:
	              invitations = _context5.sent;
	
	
	              if (invitations) {
	                _this.setState({
	                  isLoading: false,
	                  isError: false,
	                  invitations: invitations
	                });
	              }
	
	            case 7:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	
	    _this.handleError = function () {
	      return _this.setState({
	        invitations: null,
	        isLoading: false,
	        isError: true
	      });
	    };
	
	    _this.render = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'padded-content white border-bottom' },
	          _react2.default.createElement(_plainHeader2.default, { title: 'My pending invitations' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(_pendingInvitationsList2.default, Object.assign({}, _this.state, {
	            onInvitationAccepted: _this.onInvitationAccepted,
	            onInvitationDeclined: _this.onInvitationDeclined,
	            onShowDeclinedInvitationsToggleChanged: _this.onShowDeclinedInvitationsToggleChanged
	          }))
	        )
	      );
	    };
	
	    _this.state = {
	      isLoading: true,
	      isError: false,
	      shouldFetchDeclinedInvitations: true,
	      invitations: []
	    };
	    return _this;
	  }
	
	  return PendingInvitations;
	}(_react.Component);
	
	exports.default = (0, _recompose.compose)(_withPendingInvitations2.default, _hasUserInfo2.default)(PendingInvitations);

/***/ },
/* 2188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _plainHeader = __webpack_require__(350);
	
	var _plainHeader2 = _interopRequireDefault(_plainHeader);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasOrganisation = __webpack_require__(106);
	
	var _hasOrganisation2 = _interopRequireDefault(_hasOrganisation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Profiles = function (_React$Component) {
	  _inherits(Profiles, _React$Component);
	
	  function Profiles(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Profiles);
	
	    var _this = _possibleConstructorReturn(this, (Profiles.__proto__ || Object.getPrototypeOf(Profiles)).call(this, props));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var AX, response, data, meta, profiles;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              AX = _axios2.default.create({
	                baseURL: 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production',
	                timeout: 10000
	              });
	              _context.next = 3;
	              return AX.get('/profiles/corq').then(function (r) {
	                return r.data;
	              });
	
	            case 3:
	              response = _context.sent;
	              data = response.data, meta = response.meta;
	
	
	              console.log(meta);
	
	              profiles = data;
	
	              _this.setState({
	                profiles: profiles,
	                meta: meta,
	                isLoading: false
	              });
	
	            case 8:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      profiles: null,
	      isLoading: true
	    };
	    console.log('Profiles constructor');
	    return _this;
	  }
	
	  _createClass(Profiles, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          profiles = _state.profiles,
	          meta = _state.meta;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'page' },
	          _react2.default.createElement(
	            'div',
	            { className: 'padded-content white border-bottom' },
	            _react2.default.createElement(_plainHeader2.default, { title: 'PROFILE QA SYSTEM' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'page-content' },
	            isLoading && _react2.default.createElement(
	              'h1',
	              null,
	              'LOADING....'
	            ),
	            !isLoading && _react2.default.createElement(
	              _semanticUiReact.Table,
	              { celled: true, padded: true },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Header,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { singleLine: true },
	                    'Profile Pic'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    { singleLine: true },
	                    'Name'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'Instagram'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'Instagram OK?'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'Tiktok'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'Tiktok OK?'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'Twitter'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'CreatedDate'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                _lodash2.default.map(profiles, function (profile) {
	                  return _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      { singleLine: true },
	                      _react2.default.createElement(_semanticUiReact.Image, { src: profile.instagramThumbnail })
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      { singleLine: true },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        profile.name
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        profile.instagram
	                      ),
	                      profile.instagramFollowers
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      profile.instagramOk ? 'yes' : 'no'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        profile.tiktok
	                      ),
	                      profile.tiktokCount
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      profile.tiktokOk ? 'yes' : 'no'
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      profile.twitter
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      profile.createdDate
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Profiles;
	}(_react2.default.Component);
	
	Profiles.propTypes = {
	  // campaignId: PropTypes.string.isRequired,
	  // organisation: PropTypes.object.isRequired,
	};
	
	exports.default = (0, _recompose.compose)(_hasOrganisation2.default, _hasJsonapiClient2.default)(Profiles);

/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reportTypes = __webpack_require__(2391);
	
	var _reportTypes2 = _interopRequireDefault(_reportTypes);
	
	var _reportTypesLegacy = __webpack_require__(2390);
	
	var _reportTypesLegacy2 = _interopRequireDefault(_reportTypesLegacy);
	
	var _reportCard = __webpack_require__(2191);
	
	var _reportCard2 = _interopRequireDefault(_reportCard);
	
	var _reportCardLegacy = __webpack_require__(2190);
	
	var _reportCardLegacy2 = _interopRequireDefault(_reportCardLegacy);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _hasOrganisation = __webpack_require__(106);
	
	var _hasOrganisation2 = _interopRequireDefault(_hasOrganisation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var bookingLinkStyle = {
	  color: 'rgb(32, 196, 158)'
	};
	
	var BOOK_A_DEMO = 'https://dyzio.co/book-a-demo';
	
	var isFreeReport = function isFreeReport(type) {
	  return _lodash2.default.isEqual(type, 'free');
	};
	var isPremiumReport = function isPremiumReport(type) {
	  return _lodash2.default.isEqual(type, 'premium');
	};
	var ZIP_API = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/stories/zip';
	
	var ReportsList = function (_React$Component) {
	  _inherits(ReportsList, _React$Component);
	
	  function ReportsList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ReportsList);
	
	    var _this = _possibleConstructorReturn(this, (ReportsList.__proto__ || Object.getPrototypeOf(ReportsList)).call(this, props));
	
	    _this.getZipRequestStatus = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, campaignId, restClient, campaign, storyZipUrl;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, campaignId = _this$props.params.id, restClient = _this$props.restClient;
	              _context.next = 3;
	              return restClient.get('campaigns/' + campaignId).then(function (r) {
	                return r.data.data;
	              });
	
	            case 3:
	              campaign = _context.sent;
	              storyZipUrl = campaign.attributes.storyZipUrl;
	              return _context.abrupt('return', storyZipUrl);
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var _this$props2, campaignId, jsonAPIClient, storyZipUrl, response, campaign;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this$props2 = _this.props, campaignId = _this$props2.params.id, jsonAPIClient = _this$props2.jsonAPIClient;
	              _context2.next = 3;
	              return _this.getZipRequestStatus();
	
	            case 3:
	              storyZipUrl = _context2.sent;
	
	              console.log('ReportsList componentDidMount');
	              _context2.next = 7;
	              return jsonAPIClient.get('campaigns', campaignId);
	
	            case 7:
	              response = _context2.sent;
	              campaign = response.toJSONTree();
	
	              _this.setState({
	                campaign: campaign,
	                isLoadingCampaign: false,
	                storyZipUrl: storyZipUrl
	              });
	
	            case 10:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }));
	    _this.requestZipFile = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var _this$props3, campaignId, restClient, storyZipUrl, requestPayload, response;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _this$props3 = _this.props, campaignId = _this$props3.params.id, restClient = _this$props3.restClient;
	              storyZipUrl = null;
	
	              storyZipUrl = {
	                url: 'requesting...',
	                createdDate: 'requesting...'
	              };
	              _this.setState({
	                storyZipUrl: storyZipUrl,
	                requestZipLoading: true,
	                requestZipDisabled: true
	              });
	              requestPayload = {
	                data: {
	                  campaignId: campaignId
	                }
	              };
	              _context3.next = 7;
	              return restClient.post(ZIP_API, requestPayload).catch(function (err) {
	                console.log(err.message);
	              });
	
	            case 7:
	              response = _context3.sent;
	
	
	              if (response) {
	                storyZipUrl = {
	                  url: response.data.zipUrl,
	                  createdDate: new Date().toISOString()
	                };
	              }
	              _this.setState({
	                requestZipLoading: false,
	                requestZipDisabled: false,
	                storyZipUrl: storyZipUrl
	              });
	
	            case 10:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2);
	    }));
	
	    _this.state = {
	      campaign: null,
	      isLoadingCampaign: true,
	      storyZipUrl: null,
	      requestZipLoading: false,
	      requestZipDisabled: false
	    };
	    console.log('ReportsList constructor');
	    return _this;
	  }
	
	  _createClass(ReportsList, [{
	    key: 'render',
	    value: function render() {
	      var organisation = this.props.organisation;
	
	      var _ref4 = organisation || {},
	          licenseSubscriptionType = _ref4.licenseSubscriptionType;
	
	      var isFreeAccount = _lodash2.default.isEqual(licenseSubscriptionType, 'FREE');
	      var _state = this.state,
	          isLoadingCampaign = _state.isLoadingCampaign,
	          campaign = _state.campaign,
	          storyZipUrl = _state.storyZipUrl,
	          requestZipLoading = _state.requestZipLoading,
	          requestZipDisabled = _state.requestZipDisabled;
	
	
	      var ELEMIS = 'df27f0a0-7ad2-4161-b14e-f928b464a85b';
	      var DYZIO = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';
	      var LAUNCH = '4a6b0ee0-6c1a-423b-984f-49a7cb849d1e';
	      var orgs = [ELEMIS, LAUNCH, DYZIO];
	      var shouldShowZip = _lodash2.default.includes(orgs, organisation.id);
	      var isShopifyCampaign = _lodash2.default.get(campaign, 'isShopifyCampaign');
	
	      console.log('campaign', campaign);
	      console.log('isShopifyCampaign', isShopifyCampaign);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        !isLoadingCampaign && !isFreeAccount && _react2.default.createElement(
	          'div',
	          null,
	          shouldShowZip && _react2.default.createElement(
	            _semanticUiReact.Card,
	            { fluid: true },
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Card.Header,
	                null,
	                'Download Story Media'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Card.Meta,
	                null,
	                'Click on the button to request a zip file of all the story media your campaign has collected. Large campaigns may take a couple of minutes to prepare.'
	              )
	            ),
	            storyZipUrl && _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'download link:\xA0',
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', href: storyZipUrl.url },
	                  requestZipLoading ? 'requesting...' : 'STORY ZIP FILE'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'created date: ',
	                storyZipUrl.createdDate
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  disabled: requestZipDisabled,
	                  loading: requestZipLoading,
	                  onClick: this.requestZipFile
	                },
	                'Request ZIP FILE'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card,
	            { fluid: true },
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Card.Header,
	                null,
	                'Standard Campaign Reports'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Card.Meta,
	                null,
	                'Click on the cards below to access your campaign reports. Each report is easily shareable, just copy the link in the report and share via email to your colleagues or clients. No login is required to view the shareable reports. Reports will show data once your influencers start posting.'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Card.Group,
	                { itemsPerRow: 4 },
	                _lodash2.default.map(_lodash2.default.filter(_reportTypes2.default, function (report) {
	                  return isPremiumReport(report.type);
	                }), function (r) {
	                  return _reportCard2.default.ReportCard(r, campaign, organisation);
	                })
	              )
	            )
	          )
	        ),
	        !isLoadingCampaign && !isFreeAccount && _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card.Header,
	              null,
	              'Integration Reports'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card.Meta,
	              null,
	              'The Integration Reports are only available on Enterprise plans - you will need to upgrade your account to access these reports. Each of these reports requires a 3rd party integration to activate all the data and features in the reports (e.g. Facebook Ads Manager, Google Analytics or Shopify).',
	              _react2.default.createElement(
	                _targetLink2.default,
	                {
	                  style: bookingLinkStyle,
	                  renderIf: true, href: BOOK_A_DEMO
	                },
	                ' Click here'
	              ),
	              ' to book a call to discuss the Enterprise plans with the Dyzio team.'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card.Group,
	              { itemsPerRow: 4 },
	              _lodash2.default.map(_lodash2.default.filter(_reportTypes2.default, function (report) {
	                return !isPremiumReport(report.type);
	              }), function (r) {
	                return _reportCard2.default.ReportCard(r, campaign, organisation);
	              })
	            )
	          )
	        ),
	        !isLoadingCampaign && isFreeAccount && _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card.Header,
	              null,
	              'Basic Reports'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card.Meta,
	              null,
	              'Click on the cards below to access your campaign reports. Each report is easily shareable, just copy the link in the report and share via email to your colleagues or clients. No login is required to view the shareable reports. Reports will show data once your influencers start posting.'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card.Group,
	              { itemsPerRow: 4 },
	              _lodash2.default.map(_lodash2.default.filter(_reportTypesLegacy2.default, function (report) {
	                return isFreeReport(report.type);
	              }), function (r) {
	                return _reportCardLegacy2.default.ReportCard(r, campaign, organisation);
	              })
	            )
	          )
	        ),
	        !isLoadingCampaign && isFreeAccount && _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card.Header,
	              null,
	              'Premium Reports'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card.Meta,
	              null,
	              'The Premium Reports are only available on a Dyzio paid plan - you will need to upgrade your account to access these reports. A number of these Premium Reports also require a 3rd party integration to activate all the data and features in the reports (e.g. Facebook Ads Manager or Google Analytics). ',
	              _react2.default.createElement(
	                _targetLink2.default,
	                {
	                  style: bookingLinkStyle,
	                  renderIf: true, href: BOOK_A_DEMO
	                },
	                'click here'
	              ),
	              ' to book a call to discuss the paid plans with the Dyzio team.'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Card.Group,
	              { itemsPerRow: 4 },
	              _lodash2.default.map(_lodash2.default.filter(_reportTypesLegacy2.default, function (report) {
	                return !isFreeReport(report.type);
	              }), function (r) {
	                return _reportCardLegacy2.default.ReportCard(r, campaign, organisation);
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReportsList;
	}(_react2.default.Component);
	
	ReportsList.propTypes = {
	  campaignId: _propTypes2.default.string.isRequired,
	  organisation: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasOrganisation2.default, _hasJsonapiClient2.default, _hasRestClient2.default)(ReportsList);

/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentTheme = _themeSelector2.default.theme();
	
	var greyOut = {
	  background: '#f1f1f1'
	};
	
	var helpLinkStyle = {
	  color: 'rgb(32, 196, 158)',
	  float: 'right'
	};
	
	var reportLinkStyle = {
	  color: 'rgb(32, 196, 158)'
	};
	
	var reportCardStyle = {
	  cursor: 'initial'
	};
	
	var reportTypeLabelStyle = {
	  marginTop: '5px',
	  textAlign: 'center'
	};
	
	var halfPadding = {
	  padding: '5px 0.7em'
	};
	
	var linkSectionStyle = {
	  padding: '5px 0.7em'
	};
	
	var descriptSectionStyle = {
	  'min-height': '6rem'
	};
	
	var MANAGE_ORG_LINK = '/team/manage';
	var BOOK_A_DEMO = 'https://dyzio.co/book-a-demo';
	
	var openReport = function openReport(report, campaignId) {
	  console.log('open', currentTheme.shareSite);
	  window.open(currentTheme.shareSite + '/report/' + campaignId + '/' + report.link, '_blank');
	};
	
	var upgradeURLs = {
	  free: '',
	  premium: MANAGE_ORG_LINK,
	  integration: BOOK_A_DEMO
	};
	var isFreeReport = function isFreeReport(type) {
	  return _lodash2.default.isEqual(type, 'free');
	};
	
	var isReportAvailable = function isReportAvailable(report, organisation, isShopifyCampaign) {
	  var _ref = organisation || {},
	      isFacebookAdsEnabled = _ref.isFacebookAdsEnabled,
	      isGoogleAnalyticsEnabled = _ref.isGoogleAnalyticsEnabled,
	      licenseSubscriptionType = _ref.licenseSubscriptionType;
	
	  var isPremiumAccount = !_lodash2.default.isEqual(licenseSubscriptionType, 'FREE');
	
	  if (isFreeReport(report.type)) return true;
	
	  if (_lodash2.default.isEqual(report.type, 'premium') && isPremiumAccount) return true;
	
	  if (_lodash2.default.isEqual(report.type, 'integration') && _lodash2.default.isEqual(report.subType, 'facebook') && isFacebookAdsEnabled) return true;
	
	  if (_lodash2.default.isEqual(report.type, 'integration') && _lodash2.default.isEqual(report.subType, 'google') && isGoogleAnalyticsEnabled) return true;
	
	  if (_lodash2.default.isEqual(report.type, 'integration') && _lodash2.default.isEqual(report.subType, 'shopify') && isShopifyCampaign) return true;
	
	  return false;
	};
	
	var ReportCard = function ReportCard(report, _ref2, organisation) {
	  var campaignId = _ref2.id,
	      isShopifyCampaign = _ref2.isShopifyCampaign;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    {
	      style: isReportAvailable(report, organisation, isShopifyCampaign) ? reportCardStyle : greyOut,
	      'class': 'ui',
	      color: report.color,
	      onClick: isReportAvailable(report, organisation, isShopifyCampaign) ? function () {
	        return _lodash2.default.noop();
	      } : null
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: halfPadding },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 2 },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: report.icon, size: 'large' })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 14 },
	              report.name
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Label,
	          { color: report.color, style: reportTypeLabelStyle },
	          _lodash2.default.upperFirst(report.type)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: halfPadding },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Description,
	        { style: descriptSectionStyle },
	        _react2.default.createElement(
	          'div',
	          null,
	          report.description
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: linkSectionStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          isReportAvailable(report, organisation, isShopifyCampaign) && _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            {
	              width: 13,
	              onClick: isReportAvailable(report, organisation, isShopifyCampaign) ? function () {
	                return openReport(report, campaignId);
	              } : null
	            },
	            _react2.default.createElement(
	              _targetLink2.default,
	              { style: reportLinkStyle, renderIf: true },
	              'Open in a new tab'
	            )
	          ),
	          !isReportAvailable(report, organisation, isShopifyCampaign) && _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 13 },
	            _react2.default.createElement(
	              _targetLink2.default,
	              { style: reportLinkStyle, renderIf: true, href: upgradeURLs[report.type] },
	              _lodash2.default.isEqual(report.type, 'premium') && 'Click here to upgrade',
	              _lodash2.default.isEqual(report.type, 'integration') && 'Click here to book a call'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 3 },
	            _react2.default.createElement(
	              _targetLink2.default,
	              { style: helpLinkStyle, renderIf: true, href: report.helpLink },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'help', circular: true })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = {
	  ReportCard: ReportCard
	};

/***/ },
/* 2191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _targetLink = __webpack_require__(38);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentTheme = _themeSelector2.default.theme();
	
	var greyOut = {
	  background: '#f1f1f1'
	};
	
	var helpLinkStyle = {
	  color: 'rgb(32, 196, 158)',
	  float: 'right'
	};
	
	var reportLinkStyle = {
	  color: 'rgb(32, 196, 158)'
	};
	
	var reportCardStyle = {
	  cursor: 'initial'
	};
	
	var reportTypeLabelStyle = {
	  marginTop: '5px',
	  textAlign: 'center'
	};
	
	var halfPadding = {
	  padding: '5px 0.7em'
	};
	
	var linkSectionStyle = {
	  padding: '5px 0.7em'
	};
	
	var descriptSectionStyle = {
	  'min-height': '6rem'
	};
	
	var MANAGE_ORG_LINK = '/team/manage';
	var BOOK_A_DEMO = 'https://dyzio.co/book-a-demo';
	
	var openReport = function openReport(report, campaignId) {
	  console.log('open', currentTheme.shareSite);
	  window.open(currentTheme.shareSite + '/report/' + campaignId + '/' + report.link, '_blank');
	};
	
	var upgradeURLs = {
	  free: '',
	  premium: MANAGE_ORG_LINK,
	  integration: BOOK_A_DEMO
	};
	
	var isPremiumReport = function isPremiumReport(type) {
	  return _lodash2.default.isEqual(type, 'premium');
	};
	
	var isReportAvailable = function isReportAvailable(report, organisation, isShopifyCampaign, isPrestaShopCampaign) {
	  var _ref = organisation || {},
	      isFacebookAdsEnabled = _ref.isFacebookAdsEnabled,
	      isGoogleAnalyticsEnabled = _ref.isGoogleAnalyticsEnabled;
	
	  if (isPremiumReport(report.type)) return true;
	
	  if (_lodash2.default.isEqual(report.type, 'integration') && _lodash2.default.isEqual(report.subType, 'facebook') && isFacebookAdsEnabled) return true;
	
	  if (_lodash2.default.isEqual(report.type, 'integration') && _lodash2.default.isEqual(report.subType, 'google') && isGoogleAnalyticsEnabled) return true;
	
	  if (_lodash2.default.isEqual(report.type, 'integration') && _lodash2.default.isEqual(report.subType, 'shopify') && isShopifyCampaign) return true;
	
	  if (_lodash2.default.isEqual(report.type, 'integration') && _lodash2.default.isEqual(report.subType, 'prestashop') && isPrestaShopCampaign) return true;
	
	  return false;
	};
	
	var isReportAvailableByOrg = function isReportAvailableByOrg(report, organisation) {
	  var id = organisation.id;
	
	  if (!report.organisations) return true;
	  if (_lodash2.default.includes(report.organisations, id)) return true;
	  return false;
	};
	
	var ReportCard = function ReportCard(report, _ref2, organisation) {
	  var campaignId = _ref2.id,
	      isShopifyCampaign = _ref2.isShopifyCampaign,
	      isPrestaShopCampaign = _ref2.isPrestaShopCampaign;
	  return isReportAvailableByOrg(report, organisation) && _react2.default.createElement(
	    _semanticUiReact.Card,
	    {
	      style: isReportAvailable(report, organisation, isShopifyCampaign, isPrestaShopCampaign) ? reportCardStyle : greyOut,
	      'class': 'ui',
	      color: report.color,
	      onClick: isReportAvailable(report, organisation, isShopifyCampaign, isPrestaShopCampaign) ? function () {
	        return _lodash2.default.noop();
	      } : null
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: halfPadding },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Header,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 2 },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: report.icon, size: 'large' })
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 14 },
	              report.name
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Label,
	          { color: report.color, style: reportTypeLabelStyle },
	          _lodash2.default.upperFirst(report.type)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: halfPadding },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Description,
	        { style: descriptSectionStyle },
	        _react2.default.createElement(
	          'div',
	          null,
	          report.description
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: linkSectionStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          isReportAvailable(report, organisation, isShopifyCampaign, isPrestaShopCampaign) && _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            {
	              width: 13,
	              onClick: isReportAvailable(report, organisation, isShopifyCampaign, isPrestaShopCampaign) ? function () {
	                return openReport(report, campaignId);
	              } : null
	            },
	            _react2.default.createElement(
	              _targetLink2.default,
	              { style: reportLinkStyle, renderIf: true },
	              'Open in a new tab'
	            )
	          ),
	          !isReportAvailable(report, organisation, isShopifyCampaign, isPrestaShopCampaign) && _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 13 },
	            _react2.default.createElement(
	              _targetLink2.default,
	              { style: reportLinkStyle, renderIf: true, href: upgradeURLs[report.type] },
	              _lodash2.default.isEqual(report.type, 'premium') && 'Click here to upgrade',
	              _lodash2.default.isEqual(report.type, 'integration') && 'Click here to book a call'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 3 },
	            _react2.default.createElement(
	              _targetLink2.default,
	              { style: helpLinkStyle, renderIf: true, href: report.helpLink },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'help', circular: true })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = {
	  ReportCard: ReportCard
	};

/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(71);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	var _formInputText = __webpack_require__(104);
	
	var _formInputText2 = _interopRequireDefault(_formInputText);
	
	var _formInputValidation = __webpack_require__(286);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var theme = _themeSelector2.default.theme();
	
	var ResetPassword = function (_React$Component) {
	  _inherits(ResetPassword, _React$Component);
	
	  function ResetPassword(props, context) {
	    _classCallCheck(this, ResetPassword);
	
	    var _this = _possibleConstructorReturn(this, (ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).call(this, props, context));
	
	    _this.state = {
	      resetSentSuccess: false,
	      requestError: false,
	      email: null
	    };
	    return _this;
	  }
	
	  _createClass(ResetPassword, [{
	    key: 'resetPassword',
	    value: function resetPassword(data) {
	      var context = this;
	
	      var email = data.get('email');
	
	      context.setState({ email: email });
	
	      var axiosService = new _axiosService2.default('https://dyzio.eu.auth0.com/', ("4000"), {});
	
	      var insertParams = {
	        client_id: ("MxuEZkaXquZnlJeL9oE8QhyQzhMtjfTp"),
	        email: email,
	        connection: 'Username-Password-Authentication',
	        json: true
	      };
	
	      axiosService.post('dbconnections/change_password', insertParams).then(function () {
	        context.setState({ resetSentSuccess: true, requestError: false });
	      }, function (error) {
	        (0, _errorHandlingService.reportError)('RESET_PASSWORD_ERROR', error.message);
	        context.setState({ resetSentSuccess: false, requestError: error.message });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var handleSubmit = this.props.handleSubmit;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-centered' },
	        _react2.default.createElement(
	          'div',
	          { className: 'center-outer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'center-inner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'center-logo' },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this2.context.router.push('/');
	                  } },
	                _react2.default.createElement('img', { src: theme.darkLogo.src, alt: theme.darkLogo.alt })
	              )
	            ),
	            !this.state.resetSentSuccess && _react2.default.createElement(
	              'div',
	              { className: 'center-content' },
	              _react2.default.createElement(
	                'p',
	                { className: 'info' },
	                'Forgotten your password? Enter your email address and we\u2019ll send you a link to set a new one.'
	              ),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit(this.resetPassword.bind(this)) },
	                _react2.default.createElement(_immutable.Field, {
	                  name: 'email',
	                  type: 'text',
	                  component: _formInputText2.default,
	                  img: '/icons/email.svg',
	                  placeholder: 'Email address'
	                }),
	                this.state.requestError && _react2.default.createElement(
	                  'p',
	                  { className: 'error' },
	                  'Request has failed: ',
	                  this.state.requestError
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', className: 'large rose stretch' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Reset password'
	                  )
	                )
	              )
	            ),
	            this.state.resetSentSuccess && !this.state.requestError && _react2.default.createElement(
	              'div',
	              { className: 'center-content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'info-image' },
	                _react2.default.createElement('img', { src: '/icons/large-success-seagreen.svg', alt: 'Success' })
	              ),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              _react2.default.createElement(
	                'h2',
	                { className: 'info' },
	                'Message sent'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'info' },
	                'Please check your inbox and click the link in the email we sent you to reset your password.'
	              ),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              _react2.default.createElement(
	                'p',
	                { className: 'info' },
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return _this2.context.router.push('/login');
	                    } },
	                  'Back to log in'
	                )
	              ),
	              _react2.default.createElement('div', { className: 'spacer' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResetPassword;
	}(_react2.default.Component);
	
	ResetPassword.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	function validate(values) {
	  var errors = {};
	
	  var email = values.get('email');
	
	  if (!email) errors.email = 'Enter a valid email address.';
	  if (email && !_formInputValidation.EMAIL_REGULAR_EXPRESSION.test(email)) errors.email = 'Enter a valid email address.';
	
	  return errors;
	}
	
	exports.default = (0, _immutable.reduxForm)({
	  form: 'ResetPasswordForm',
	  validate: validate
	})(ResetPassword);

/***/ },
/* 2193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tooltip = __webpack_require__(554);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceDelete = function (_Component) {
	  _inherits(ResourceDelete, _Component);
	
	  function ResourceDelete(props) {
	    _classCallCheck(this, ResourceDelete);
	
	    var _this = _possibleConstructorReturn(this, (ResourceDelete.__proto__ || Object.getPrototypeOf(ResourceDelete)).call(this, props));
	
	    var className = '';
	    if (!_this.props.visible) {
	      className += 'no-vis';
	    }
	
	    _this.state = {
	      resourceId: _this.props.resourceId,
	      resourceType: _this.props.resourceType,
	      wrapperClassName: className
	    };
	    return _this;
	  }
	
	  _createClass(ResourceDelete, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      e.preventDefault();
	      e.resourceDeleteEvent = true;
	      var authToken = localStorage.getItem('id_token');
	      this.deleteResource(authToken, this.state.resourceId, this.state.resourceType);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var removeButton = _react2.default.createElement(
	        'div',
	        { className: this.state.wrapperClassName },
	        _react2.default.createElement(
	          'button',
	          { className: 'small rose top-right', onClick: this.onClick.bind(this) },
	          _react2.default.createElement('img', { className: 'image budget-patch', src: '/icons/cross.svg' })
	        )
	      );
	
	      if (this.props.visible) {
	        return _react2.default.createElement(
	          _tooltip2.default,
	          { content: 'Remove Item?', style: 'frame' },
	          removeButton
	        );
	      }
	
	      return removeButton;
	    }
	
	    /* SUPPORT FUNCTIONS */
	
	  }, {
	    key: 'deleteResource',
	    value: function deleteResource(authToken, resourceId, resourceType) {
	      var options = this.getResourceDeleteOptions(authToken, resourceId, resourceType);
	    }
	  }, {
	    key: 'getResourceDeleteOptions',
	    value: function getResourceDeleteOptions(authToken, resourceId, resourceType) {
	      return {
	        method: 'DELETE',
	        url: ("https://api2.dyzio.co/v1") + '/' + resourceType + '/' + resourceId,
	        headers: {
	          authorization: 'Bearer ' + authToken,
	          'content-type': 'application/json'
	        },
	        json: true
	      };
	    }
	  }]);
	
	  return ResourceDelete;
	}(_react.Component);
	
	exports.default = ResourceDelete;

/***/ },
/* 2194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Sandbox;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _eventFeed = __webpack_require__(230);
	
	var _eventFeed2 = _interopRequireDefault(_eventFeed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var containerStyle = {
	  paddingTop: 50
	};
	
	function Sandbox() {
	  return _react2.default.createElement(
	    _semanticUiReact.Container,
	    { style: containerStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 16 },
	          _react2.default.createElement(_eventFeed2.default, {
	            campaignId: 'ebf9702f-626b-439b-9676-160cbdfd2ee5',
	            feedType: 'CAMPAIGN',
	            viewMode: 'TABLE'
	          })
	        )
	      )
	    )
	  );
	}

/***/ },
/* 2195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RETURN_KEY_CODE = 13;
	
	var SearchInput = function (_Component) {
	  _inherits(SearchInput, _Component);
	
	  function SearchInput(props) {
	    _classCallCheck(this, SearchInput);
	
	    var _this = _possibleConstructorReturn(this, (SearchInput.__proto__ || Object.getPrototypeOf(SearchInput)).call(this, props));
	
	    _this.onValueChanged = function (event, _ref) {
	      var value = _ref.value;
	
	      _this.setState({
	        value: value
	      });
	    };
	
	    _this.onKeyDown = function (event) {
	      var value = _this.state.value;
	      var onSubmit = _this.props.onSubmit;
	
	      var canInvokeCallback = _lodash2.default.isFunction(onSubmit);
	      if (RETURN_KEY_CODE === event.which && value.length > 0 && canInvokeCallback) {
	        _this.props.onSubmit(value);
	      }
	      if (value.length === 0) {
	        _this.props.onSearchCleared();
	      }
	    };
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(SearchInput, [{
	    key: 'render',
	    value: function render() {
	      var value = this.state.value;
	
	      return _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Input, {
	          value: value,
	          onKeyUp: this.onKeyDown,
	          onChange: this.onValueChanged,
	          placeholder: 'Search...',
	          icon: 'search'
	        }),
	        content: 'enter your search term and hit return to search'
	      });
	    }
	  }]);
	
	  return SearchInput;
	}(_react.Component);
	
	exports.default = SearchInput;
	
	
	SearchInput.propTypes = {
	  onSubmit: _propTypes2.default.func,
	  onSearchCleared: _propTypes2.default.func
	};
	
	SearchInput.defaultProps = {
	  onSubmit: _lodash2.default.noop,
	  onSearchCleared: _lodash2.default.noop
	};

/***/ },
/* 2196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendBriefAll = sendBriefAll;
	
	var _constants = __webpack_require__(917);
	
	function sendBriefAll(data) {
	  return {
	    type: _constants.SEND_BRIEF_ALL,
	    data: data
	  };
	}

/***/ },
/* 2197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _immutable = __webpack_require__(71);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _uploader = __webpack_require__(353);
	
	var _uploader2 = _interopRequireDefault(_uploader);
	
	var _modal = __webpack_require__(103);
	
	var _actions = __webpack_require__(2196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SendBriefAllModal = function (_React$Component) {
	  _inherits(SendBriefAllModal, _React$Component);
	
	  function SendBriefAllModal(props, context) {
	    _classCallCheck(this, SendBriefAllModal);
	
	    var _this = _possibleConstructorReturn(this, (SendBriefAllModal.__proto__ || Object.getPrototypeOf(SendBriefAllModal)).call(this, props, context));
	
	    _this.onOutsideClick = function (event) {
	      var isClickInside = _this.refs.modal_content.contains(event.target);
	      if (!isClickInside) {
	        _this.onClearModal();
	      }
	    };
	
	    _this.onClearModal = function () {
	      _this.props.onClearModal();
	      _this.setState({ uploaderState: 1, documentData: {} });
	      _this.props.reset();
	    };
	
	    _this.uploadDataCallback = function (documentData) {
	      _this.setState({ documentData: documentData });
	    };
	
	    _this.submitSendBriefAll = function (formData) {
	      var documentData = _this.state.documentData;
	      documentData.approved = false;
	
	      var message = formData.get('submitDocumentMessage');
	      if (message) documentData.message = message;
	
	      _this.props.onSendBriefAll({ documentData: documentData });
	    };
	
	    _this.updateUploaderState = function (newUploaderState) {
	      _this.setState({ uploaderState: newUploaderState });
	    };
	
	    _this.state = {
	      uploaderState: 1,
	      documentData: {}
	    };
	    return _this;
	  }
	
	  _createClass(SendBriefAllModal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.onClearModal();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          uploaderState = _state.uploaderState,
	          documentData = _state.documentData;
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          showModal = _props.showModal,
	          modalLoading = _props.modalLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: showModal === _staticConfiguration.SEND_BRIEF_ALL ? 'custom-modal visible' : 'custom-modal', onClick: this.onOutsideClick },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.submitSendBriefAll) },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content', ref: 'modal_content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'top-text' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Add a brief for everyone'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'This will be sent to all influencers on this campaign.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-close large' },
	              _react2.default.createElement('img', { src: '/icons/close.svg', alt: 'close', onClick: this.onClearModal })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              uploaderState === 1 && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Wondering what to write? Find out ',
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'http://blog.dyzio.co/how-to-write-a-winning-influencer-marketing-creative-brief', target: '_blank' },
	                    ' how to write a winning creative brief'
	                  ),
	                  '.'
	                ),
	                _react2.default.createElement('div', { className: 'spacer small' })
	              ),
	              _react2.default.createElement(
	                'table',
	                null,
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '2' },
	                      _react2.default.createElement(_uploader2.default, {
	                        uploaderState: uploaderState,
	                        updateUploaderState: this.updateUploaderState,
	                        docType: showModal,
	                        uploadDataCallback: this.uploadDataCallback
	                      })
	                    )
	                  ),
	                  uploaderState === 6 && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '2' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Message'
	                      )
	                    )
	                  ),
	                  uploaderState === 6 && _react2.default.createElement(
	                    'tr',
	                    { colSpan: '2' },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(_immutable.Field, {
	                        name: 'submitDocumentMessage',
	                        label: 'Message',
	                        component: 'textarea',
	                        placeholder: 'Message about the file'
	                      })
	                    )
	                  ),
	                  documentData.filePath && uploaderState === 6 && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '2' },
	                      _react2.default.createElement('div', { className: 'spacer' }),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'medium rose stretch', type: 'submit' },
	                        modalLoading ? _react2.default.createElement(
	                          'ul',
	                          { className: 'dots' },
	                          _react2.default.createElement('li', { id: 'dot1' }),
	                          _react2.default.createElement('li', null),
	                          _react2.default.createElement('li', { id: 'dot2' }),
	                          _react2.default.createElement('li', null),
	                          _react2.default.createElement('li', { id: 'dot3' })
	                        ) : _react2.default.createElement(
	                          'span',
	                          null,
	                          'Send'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SendBriefAllModal;
	}(_react2.default.Component);
	
	SendBriefAllModal.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	SendBriefAllModal.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    showModal: state.modal.get('showModal'),
	    modalLoading: state.modal.get('loading'),
	    modalError: state.modal.get('error')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onClearModal: function onClearModal() {
	      return dispatch((0, _modal.clearModal)());
	    },
	    onSendBriefAll: function onSendBriefAll(data) {
	      return dispatch((0, _actions.sendBriefAll)(data));
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutable.reduxForm)({
	  form: 'DocumentUploadForm'
	})(SendBriefAllModal));

/***/ },
/* 2198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.sendBriefAll = sendBriefAll;
	exports.watchSendBriefAll = watchSendBriefAll;
	exports.default = sendBriefAllSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _constants = __webpack_require__(917);
	
	var _userSelectors = __webpack_require__(118);
	
	var _campaignSelectors = __webpack_require__(117);
	
	var _sendbirdSendAllService = __webpack_require__(936);
	
	var _modal = __webpack_require__(169);
	
	var _constants2 = __webpack_require__(195);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [sendBriefAll, watchSendBriefAll, sendBriefAllSagas].map(_regenerator2.default.mark);
	
	function sendBriefAll(action) {
	  var documentData, userId, campaignId, permissionId, data, response;
	  return _regenerator2.default.wrap(function sendBriefAll$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.put)({ type: _modal.MODAL_LOADING, loading: true });
	
	        case 3:
	          documentData = action.data.documentData;
	
	          documentData.docType = _staticConfiguration.BRIEF;
	
	          _context.next = 7;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 7:
	          userId = _context.sent;
	          _context.next = 10;
	          return (0, _effects.select)(_campaignSelectors.getCampaignId);
	
	        case 10:
	          campaignId = _context.sent;
	          _context.next = 13;
	          return (0, _effects.select)(_campaignSelectors.getPermissionId);
	
	        case 13:
	          permissionId = _context.sent;
	          data = {
	            userId: userId,
	            campaignId: campaignId,
	            permissionId: permissionId,
	            message: documentData.message,
	            documentData: documentData
	          };
	          _context.next = 17;
	          return (0, _effects.call)(_sendbirdSendAllService.sendbirdSendBriefAll, data);
	
	        case 17:
	          response = _context.sent;
	          _context.next = 20;
	          return (0, _effects.put)({ type: _constants2.RELOAD_DISCUSSIONS, data: { campaignId: campaignId } });
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.put)({ type: _modal.MODAL_CLEAR });
	
	        case 22:
	          _context.next = 29;
	          break;
	
	        case 24:
	          _context.prev = 24;
	          _context.t0 = _context['catch'](0);
	
	          (0, _errorHandlingService.reportError)('SEND_BRIEF_ALL_ERROR', _context.t0.message);
	          _context.next = 29;
	          return (0, _effects.put)({ type: _modal.MODAL_ERROR, error: _context.t0.message });
	
	        case 29:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 24]]);
	}
	
	function watchSendBriefAll() {
	  return _regenerator2.default.wrap(function watchSendBriefAll$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.SEND_BRIEF_ALL, sendBriefAll);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function sendBriefAllSagas() {
	  return _regenerator2.default.wrap(function sendBriefAllSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(watchSendBriefAll)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 2199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendDeliverableAll = sendDeliverableAll;
	
	var _constants = __webpack_require__(918);
	
	function sendDeliverableAll(data, callback) {
	  return {
	    type: _constants.SEND_DELIVERABLE_ALL,
	    data: data,
	    callback: callback
	  };
	}

/***/ },
/* 2200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _immutable = __webpack_require__(71);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDates = __webpack_require__(1487);
	
	var _formInputRadio = __webpack_require__(544);
	
	var _formInputRadio2 = _interopRequireDefault(_formInputRadio);
	
	var _formInputSelect = __webpack_require__(545);
	
	var _formInputSelect2 = _interopRequireDefault(_formInputSelect);
	
	var _formInputText = __webpack_require__(104);
	
	var _formInputText2 = _interopRequireDefault(_formInputText);
	
	var _formInputTextarea = __webpack_require__(875);
	
	var _formInputTextarea2 = _interopRequireDefault(_formInputTextarea);
	
	var _actions = __webpack_require__(2199);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _modal = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SendDeliverableAll = function (_React$Component) {
	  _inherits(SendDeliverableAll, _React$Component);
	
	  function SendDeliverableAll(props, context) {
	    _classCallCheck(this, SendDeliverableAll);
	
	    var _this = _possibleConstructorReturn(this, (SendDeliverableAll.__proto__ || Object.getPrototypeOf(SendDeliverableAll)).call(this, props, context));
	
	    _this.resetForm = function () {
	      _this.props.reset();
	      _this.props.onClearModal();
	    };
	
	    _this.formatDeliverableFormData = function (formData) {
	      var title = formData.get('title');
	      var channelType = formData.get('channelType');
	      if (channelType === _staticConfiguration.OTHER) channelType = formData.get('otherChannelType');
	
	      var assetType = [formData.get('assetType')];
	      var description = formData.get('description');
	      var dueDate = formData.get('dueDate').toISOString();
	      var liveDateEnd = formData.get('liveDate').toISOString();
	
	      var deliverableData = {
	        title: title,
	        channelType: channelType,
	        assetType: assetType,
	        dueDate: dueDate,
	        liveDateEnd: liveDateEnd,
	        description: description
	      };
	
	      return deliverableData;
	    };
	
	    _this.submitSendDeliverableAll = function (formData) {
	      var deliverableData = _this.formatDeliverableFormData(formData);
	      _this.props.onSendDeliverableAll(deliverableData, _this.resetForm);
	    };
	
	    _this.state = {
	      focused: false,
	      liveFocused: false
	    };
	    return _this;
	  }
	
	  _createClass(SendDeliverableAll, [{
	    key: 'onOutsideClick',
	    value: function onOutsideClick(event) {
	      var isClickInside = this.refs.modal_content.contains(event.target);
	      if (!isClickInside) {
	        this.props.onClearModal();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.resetForm();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          showModal = _props.showModal,
	          onClearModal = _props.onClearModal,
	          modalLoading = _props.modalLoading,
	          formValues = _props.formValues;
	
	
	      var channelTypeSelected = formValues ? formValues.get('channelType') : null;
	      var channelTypeOptions = [{ value: _staticConfiguration.YOUTUBE, label: 'Youtube' }, { value: _staticConfiguration.FACEBOOK, label: 'Facebook' }, { value: _staticConfiguration.INSTAGRAM, label: 'Instagram' }, { value: _staticConfiguration.TWITTER, label: 'Twitter' }, { value: _staticConfiguration.SNAPCHAT, label: 'Snapchat' }, { value: _staticConfiguration.OTHER, label: 'Other' }];
	
	      return _react2.default.createElement(
	        'div',
	        { className: showModal === _staticConfiguration.SEND_DELIVERABLE_ALL ? 'custom-modal visible' : 'custom-modal', onClick: this.onOutsideClick.bind(this) },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.submitSendDeliverableAll) },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content', ref: 'modal_content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'top-text' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Assign a deliverable for everyone'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'This will be sent to all influencers on this campaign.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-close large' },
	              _react2.default.createElement('img', { src: '/icons/close.svg', alt: 'close', onClick: function onClick() {
	                  return onClearModal();
	                } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement(
	                'table',
	                null,
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { width: '150px' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Title'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '2' },
	                      _react2.default.createElement(_immutable.Field, {
	                        name: 'title',
	                        type: 'text',
	                        label: '',
	                        component: _formInputText2.default,
	                        placeholder: 'Deliverable title'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { width: '150px' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Channel type'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '2' },
	                      _react2.default.createElement(_immutable.Field, {
	                        name: 'channelType',
	                        component: function component(props) {
	                          return _react2.default.createElement(_formInputSelect2.default, Object.assign({
	                            name: 'channelType',
	                            label: '',
	                            className: 'stacked'
	                          }, props, {
	                            options: channelTypeOptions
	                          }));
	                        }
	                      })
	                    )
	                  ),
	                  channelTypeSelected === _staticConfiguration.OTHER && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement('td', { width: '150px' }),
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '2' },
	                      _react2.default.createElement(_immutable.Field, {
	                        name: 'otherChannelType',
	                        type: 'text',
	                        label: '',
	                        component: _formInputText2.default,
	                        placeholder: 'channel name'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { width: '150px' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Asset type'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '2' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'checkbox-wrapper' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'checkbox-row' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(_immutable.Field, {
	                              id: 'Video',
	                              type: 'radio',
	                              component: _formInputRadio2.default,
	                              name: 'assetType',
	                              value: _staticConfiguration.VIDEO,
	                              label: 'Video'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(_immutable.Field, {
	                              id: 'Image',
	                              type: 'radio',
	                              component: _formInputRadio2.default,
	                              name: 'assetType',
	                              value: _staticConfiguration.IMAGE,
	                              label: 'Image'
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'checkbox-row' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(_immutable.Field, {
	                              id: 'Blog',
	                              type: 'radio',
	                              component: _formInputRadio2.default,
	                              name: 'assetType',
	                              value: _staticConfiguration.BLOG,
	                              label: 'Blog'
	                            })
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(_immutable.Field, {
	                              id: 'Text',
	                              type: 'radio',
	                              component: _formInputRadio2.default,
	                              name: 'assetType',
	                              value: _staticConfiguration.TEXT,
	                              label: 'Text'
	                            })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { width: '150px' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Due date'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '2' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker-wrapper' },
	                        _react2.default.createElement(_immutable.Field, {
	                          name: 'dueDate',
	                          component: function component(props) {
	                            var _props$input = props.input,
	                                value = _props$input.value,
	                                onChange = _props$input.onChange;
	
	                            return _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(_reactDates.SingleDatePicker, Object.assign({
	                                id: 'dueDate'
	                              }, props, {
	                                date: value,
	                                focused: _this2.state.focused,
	                                numberOfMonths: 1,
	                                displayFormat: 'DD/MM/YYYY',
	                                placeholder: 'Select date',
	                                onDateChange: function onDateChange(date) {
	                                  return onChange(date);
	                                },
	                                onFocusChange: function onFocusChange(_ref) {
	                                  var focused = _ref.focused;
	                                  return _this2.setState({ focused: focused });
	                                }
	                              })),
	                              props.meta.touched && props.meta.error && _react2.default.createElement(
	                                'p',
	                                { className: 'small error' },
	                                props.meta.error
	                              )
	                            );
	                          }
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { width: '150px' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Live date'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '2' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'datepicker-wrapper' },
	                        _react2.default.createElement(_immutable.Field, {
	                          name: 'liveDate',
	                          component: function component(props) {
	                            var _props$input2 = props.input,
	                                value = _props$input2.value,
	                                onChange = _props$input2.onChange;
	
	                            return _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement(_reactDates.SingleDatePicker, Object.assign({
	                                id: 'liveDate'
	                              }, props, {
	                                date: value,
	                                focused: _this2.state.liveFocused,
	                                numberOfMonths: 1,
	                                displayFormat: 'DD/MM/YYYY',
	                                placeholder: 'Select date',
	                                onDateChange: function onDateChange(date) {
	                                  return onChange(date);
	                                },
	                                onFocusChange: function onFocusChange(_ref2) {
	                                  var focused = _ref2.focused;
	                                  return _this2.setState({ liveFocused: focused });
	                                }
	                              })),
	                              props.meta.touched && props.meta.error && _react2.default.createElement(
	                                'p',
	                                { className: 'small error' },
	                                props.meta.error
	                              )
	                            );
	                          }
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { width: '150px' },
	                      _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Requirements ',
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'light' },
	                          '(optional)'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '2' },
	                      _react2.default.createElement(_immutable.Field, {
	                        name: 'description',
	                        component: _formInputTextarea2.default,
	                        placeholder: 'e.g. video length, image size, copy or required hashtags'
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '3' },
	                      _react2.default.createElement('div', { className: 'spacer' }),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'medium rose stretch', type: 'submit' },
	                        modalLoading ? _react2.default.createElement(
	                          'ul',
	                          { className: 'dots' },
	                          _react2.default.createElement('li', { id: 'dot1' }),
	                          _react2.default.createElement('li', null),
	                          _react2.default.createElement('li', { id: 'dot2' }),
	                          _react2.default.createElement('li', null),
	                          _react2.default.createElement('li', { id: 'dot3' })
	                        ) : _react2.default.createElement(
	                          'span',
	                          null,
	                          'Assign deliverable'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SendDeliverableAll;
	}(_react2.default.Component);
	
	SendDeliverableAll.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	
	function validate(values) {
	  var errors = {};
	
	  var title = values.get('title');
	  var channelType = values.get('channelType');
	  var otherChannelType = values.get('otherChannelType');
	  var assetType = values.get('assetType');
	  var dueDate = values.get('dueDate');
	  var liveDate = values.get('liveDate');
	
	  if (!title) errors.title = 'Please enter a title';
	  if (!channelType) errors.channelType = 'Please select a channel type';
	  if (channelType === _staticConfiguration.OTHER && !otherChannelType) errors.channelType = 'Please enter a channel type';
	  if (!assetType) errors.assetType = 'Please select an asset type';
	  if (!dueDate) errors.dueDate = 'Please select a due date';
	  if (!liveDate) errors.liveDate = 'Please select a live date';
	  if (dueDate && liveDate && dueDate.isAfter(liveDate)) errors.liveDate = 'Live date must be after due date';
	
	  return errors;
	}
	
	var getDeliverableChannelType = function getDeliverableChannelType(channelType) {
	  if (!channelType) return '';
	  if (channelType === _staticConfiguration.FACEBOOK || channelType === _staticConfiguration.TWITTER || channelType === _staticConfiguration.INSTAGRAM || channelType === _staticConfiguration.YOUTUBE || channelType === _staticConfiguration.SNAPCHAT) {
	    return channelType;
	  }
	  return _staticConfiguration.OTHER;
	};
	
	var getOtherChannelTypeInput = function getOtherChannelTypeInput(channelType) {
	  if (!channelType) return '';
	  if (channelType === _staticConfiguration.FACEBOOK || channelType === _staticConfiguration.TWITTER || channelType === _staticConfiguration.INSTAGRAM || channelType === _staticConfiguration.YOUTUBE || channelType === _staticConfiguration.SNAPCHAT) {
	    return '';
	  }
	  return channelType;
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    formValues: (0, _immutable.getFormValues)('SendDeliverableAll')(state),
	    showModal: state.modal.get('showModal'),
	    modalLoading: state.modal.get('loading'),
	    modalError: state.modal.get('error'),
	    initialValues: {
	      dueDate: (0, _moment2.default)().add(7, 'days'),
	      liveDate: (0, _moment2.default)().add(2, 'weeks')
	    }
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onSendDeliverableAll: function onSendDeliverableAll(deliverableData, createDeliverableCallback) {
	      return dispatch((0, _actions.sendDeliverableAll)(deliverableData, createDeliverableCallback));
	    },
	    onClearModal: function onClearModal() {
	      return dispatch((0, _modal.clearModal)());
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutable.reduxForm)({
	  form: 'SendDeliverableAll',
	  validate: validate
	})(SendDeliverableAll));

/***/ },
/* 2201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.sendDeliverableAll = sendDeliverableAll;
	exports.watchSendDeliverableAll = watchSendDeliverableAll;
	exports.default = sendDeliverableAllSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _constants = __webpack_require__(918);
	
	var _userSelectors = __webpack_require__(118);
	
	var _campaignSelectors = __webpack_require__(117);
	
	var _sendbirdSendAllService = __webpack_require__(936);
	
	var _modal = __webpack_require__(169);
	
	var _constants2 = __webpack_require__(195);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [sendDeliverableAll, watchSendDeliverableAll, sendDeliverableAllSagas].map(_regenerator2.default.mark);
	
	function sendDeliverableAll(action) {
	  var deliverableData, callback, userId, campaignId, permissionId, data, response;
	  return _regenerator2.default.wrap(function sendDeliverableAll$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.put)({ type: _modal.MODAL_LOADING, loading: true });
	
	        case 3:
	          deliverableData = action.data;
	          callback = action.callback;
	          _context.next = 7;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 7:
	          userId = _context.sent;
	          _context.next = 10;
	          return (0, _effects.select)(_campaignSelectors.getCampaignId);
	
	        case 10:
	          campaignId = _context.sent;
	          _context.next = 13;
	          return (0, _effects.select)(_campaignSelectors.getPermissionId);
	
	        case 13:
	          permissionId = _context.sent;
	          data = {
	            userId: userId,
	            campaignId: campaignId,
	            permissionId: permissionId,
	            message: 'deliverable',
	            deliverableData: deliverableData
	          };
	          _context.next = 17;
	          return (0, _effects.call)(_sendbirdSendAllService.sendbirdSendDeliverableAll, data);
	
	        case 17:
	          response = _context.sent;
	          _context.next = 20;
	          return (0, _effects.put)({ type: _constants2.RELOAD_DISCUSSIONS, data: { campaignId: campaignId } });
	
	        case 20:
	          if (callback) callback();
	
	          _context.next = 28;
	          break;
	
	        case 23:
	          _context.prev = 23;
	          _context.t0 = _context['catch'](0);
	
	          (0, _errorHandlingService.reportError)('SEND_DELIVERABLE_ALL_ERROR', _context.t0.message);
	          _context.next = 28;
	          return (0, _effects.put)({ type: _modal.MODAL_ERROR, error: _context.t0.message });
	
	        case 28:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 23]]);
	}
	
	function watchSendDeliverableAll() {
	  return _regenerator2.default.wrap(function watchSendDeliverableAll$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.SEND_DELIVERABLE_ALL, sendDeliverableAll);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function sendDeliverableAllSagas() {
	  return _regenerator2.default.wrap(function sendDeliverableAllSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(watchSendDeliverableAll)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 2202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _pagination = __webpack_require__(147);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _reportUploadModal = __webpack_require__(891);
	
	var _reportUploadModal2 = _interopRequireDefault(_reportUploadModal);
	
	var _campaignReportCard = __webpack_require__(539);
	
	var _campaignReportCard2 = _interopRequireDefault(_campaignReportCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var delay = function delay(ms) {
	  return new Promise(function (resolve, reject) {
	    return setTimeout(resolve, ms);
	  });
	};
	
	var reportsMonths = ['DEC_GENERAL', 'NOV_GENERAL', 'OCT_GENERAL', 'SEPT_GENERAL', 'AUG_GENERAL', 'JULY_GENERAL', 'JUNE_GENERAL', 'MAY_GENERAL', 'APRIL_GENERAL', 'MARCH_GENERAL', 'FEBRUARY_GENERAL', 'JANUARY_GENERAL', 'DECEMBER_GENERAL', 'NOVEMBER_GENERAL', 'OCTOBER_GENERAL', 'SEPTEMBER_GENERAL'];
	
	var PAGE_SIZE = 4;
	var reportsPages = _lodash2.default.chunk(reportsMonths, PAGE_SIZE);
	
	var boxStyle = {
	  paddingTop: 19,
	  paddingBottom: 19
	};
	
	var REPORT_FILE_PATTERN = /^processed-(\d+)-(.+)$$/;
	
	var parseFilename = function parseFilename(filename) {
	  var match = filename.match(REPORT_FILE_PATTERN);
	  var parsedName = _lodash2.default.get(match, '[2]');
	  return parsedName;
	};
	
	var messageStyles = {
	  width: 'max-content'
	};
	
	var getMessageColor = function getMessageColor(dateUploaded) {
	  var date = (0, _moment2.default)(dateUploaded);
	  var now = (0, _moment2.default)(new Date());
	  var duration = _moment2.default.duration(now.diff(date));
	  var hours = duration.asHours();
	  if (hours >= 72) {
	    return 'red';
	  }
	  var isToday = date.isSame(new Date(), 'day');
	  return isToday ? 'green' : 'orange';
	};
	
	var getKeyPrefix = function getKeyPrefix(key) {
	  return _lodash2.default.camelCase(_lodash2.default.toLower(key));
	};
	
	var ShopfluenceDashboard = function (_Component) {
	  _inherits(ShopfluenceDashboard, _Component);
	
	  function ShopfluenceDashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ShopfluenceDashboard);
	
	    var _this = _possibleConstructorReturn(this, (ShopfluenceDashboard.__proto__ || Object.getPrototypeOf(ShopfluenceDashboard)).call(this, props));
	
	    _this.toggleUploadModal = function () {
	      _this.setState(function (prev) {
	        return { showUploadModal: !prev.showUploadModal };
	      });
	    };
	
	    _this.importReport = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(fileUrl) {
	        var payload;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.setState({ isImporting: true });
	                payload = {
	                  fileUrl: fileUrl
	                };
	                _context.next = 4;
	                return _this.reportImportClient.post('/elemis/import', payload).catch(function (err) {
	                  console.log('Import Error: ', err);
	                });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onReportSubmit = function (file) {
	      if (file.filePath) {
	        _this.importReport('https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/' + file.filePath);
	      }
	    };
	
	    _this.fetchReportForMonth = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(key) {
	        var reloading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var keyPrefix, loadingStateKey, organisationId, params;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                keyPrefix = getKeyPrefix(key);
	                loadingStateKey = reloading ? keyPrefix + 'IsReloading' : keyPrefix + 'IsLoading';
	
	                _this.setState(_defineProperty({}, loadingStateKey, true));
	                organisationId = _this.props.userInfo.organisationId;
	                params = reloading ? { clearCache: true } : {};
	                _context2.next = 7;
	                return _this.reportImportClient.get('/organisation/' + organisationId + '/report/' + key, { params: params }).then(function (response) {
	                  var _this$setState2;
	
	                  var reports = _lodash2.default.get(response, 'data.data.data.reports', []);
	                  _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, keyPrefix + 'Reports', reports), _defineProperty(_this$setState2, loadingStateKey, false), _this$setState2));
	                }).catch(function (err) {
	                  var _this$setState3;
	
	                  _this.setState((_this$setState3 = {}, _defineProperty(_this$setState3, keyPrefix + 'Reports', []), _defineProperty(_this$setState3, loadingStateKey, false), _this$setState3));
	                });
	
	              case 7:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.fetchReports = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var loadingKeys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, month;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              loadingKeys = _lodash2.default.reduce(reportsMonths, function (acc, key) {
	                var keyPrefix = getKeyPrefix(key);
	                acc[keyPrefix + 'IsLoading'] = true;
	                return acc;
	              }, {});
	
	              _this.setState(_extends({}, loadingKeys));
	              // eslint-disable-next-line no-restricted-syntax
	              _iteratorNormalCompletion = true;
	              _didIteratorError = false;
	              _iteratorError = undefined;
	              _context3.prev = 5;
	              _iterator = reportsMonths[Symbol.iterator]();
	
	            case 7:
	              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                _context3.next = 15;
	                break;
	              }
	
	              month = _step.value;
	              _context3.next = 11;
	              return _this.fetchReportForMonth(month);
	
	            case 11:
	              delay(500);
	
	            case 12:
	              _iteratorNormalCompletion = true;
	              _context3.next = 7;
	              break;
	
	            case 15:
	              _context3.next = 21;
	              break;
	
	            case 17:
	              _context3.prev = 17;
	              _context3.t0 = _context3['catch'](5);
	              _didIteratorError = true;
	              _iteratorError = _context3.t0;
	
	            case 21:
	              _context3.prev = 21;
	              _context3.prev = 22;
	
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	
	            case 24:
	              _context3.prev = 24;
	
	              if (!_didIteratorError) {
	                _context3.next = 27;
	                break;
	              }
	
	              throw _iteratorError;
	
	            case 27:
	              return _context3.finish(24);
	
	            case 28:
	              return _context3.finish(21);
	
	            case 29:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2, [[5, 17, 21, 29], [22,, 24, 28]]);
	    }));
	    _this.fetchLatestUploadedFile = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var latestFile;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this.setState({
	                isFetchingLatestFile: true
	              });
	
	              _context4.next = 3;
	              return _this.reportImportClient.get('/elemis/uploads/latest').then(function (_ref5) {
	                var data = _ref5.data;
	                return data;
	              }).catch(function (err) {
	                console.log('Fetching latest file upload error', err);
	              }).finally(function () {
	                _this.setState({
	                  isFetchingLatestFile: false
	                });
	              });
	
	            case 3:
	              latestFile = _context4.sent;
	
	
	              if (latestFile) {
	                _this.setState({
	                  latestFile: _lodash2.default.get(latestFile, 'data')
	                });
	              }
	
	            case 5:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.getReportsPage = function (currentPage) {
	      var pageIndex = currentPage > 0 ? currentPage - 1 : 0;
	      return reportsPages[pageIndex];
	    };
	
	    _this.incrementPage = function () {
	      _this.setState(function (prev) {
	        return { currentPage: prev.currentPage + 1 };
	      });
	    };
	
	    _this.decrementPage = function () {
	      _this.setState(function (prev) {
	        return { currentPage: prev.currentPage - 1 };
	      });
	    };
	
	    _this.getStateValue = function (key) {
	      return _this.state[key];
	    };
	
	    _this.state = {
	      showUploadModal: false,
	      isImporting: false,
	      currentPage: 1
	    };
	    var buildRESTClient = _this.props.buildRESTClient;
	
	    _this.reportImportClient = buildRESTClient({
	      baseURL: ("https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production") || '',
	      hasToken: false,
	      timeout: 100000
	    });
	    return _this;
	  }
	
	  _createClass(ShopfluenceDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchReports();
	      this.fetchLatestUploadedFile();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          showUploadModal = _state.showUploadModal,
	          isImporting = _state.isImporting,
	          currentPage = _state.currentPage,
	          latestFile = _state.latestFile;
	
	
	      var currentPageReports = this.getReportsPage(currentPage);
	      var latestFiles = !_lodash2.default.isArray(latestFile) ? [latestFile] : latestFile;
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'influencer-context-bar', style: boxStyle },
	          _react2.default.createElement('div', { className: 'spacer small' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'GENERAL CAMPAIGNS'
	              )
	            ),
	            _react2.default.createElement('div', { className: 'space' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'light' },
	                'Shopfluence'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement('div', { className: 'horizontal-spacer' })
	            ),
	            _react2.default.createElement('div', { className: 'space' }),
	            latestFile && !_lodash2.default.isEmpty(latestFiles) && _react2.default.createElement(LatestUploadedFileMessage, { files: latestFiles }),
	            _react2.default.createElement('div', { className: 'space' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement('div', { className: 'horizontal-spacer' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  color: 'pink',
	                  size: 'medium',
	                  onClick: this.toggleUploadModal
	                },
	                'Upload Redemption Report'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          showUploadModal && _react2.default.createElement(_reportUploadModal2.default, {
	            onSubmit: this.onReportSubmit,
	            onClose: this.toggleUploadModal,
	            isSubmitting: isImporting
	          }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_pagination2.default, {
	              onPageIncrement: this.incrementPage,
	              onPageDecrement: this.decrementPage,
	              currentPage: currentPage,
	              totalPages: _lodash2.default.size(reportsPages)
	            }),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\xA0'
	            ),
	            _lodash2.default.map(currentPageReports, function (key) {
	              var keyPrefix = getKeyPrefix(key);
	              var title = _lodash2.default.startCase(_lodash2.default.replace(key, '_', ' '));
	              var showContactedInfluencersValue = !_lodash2.default.isEqual(key, 'AUGUST_SEGMENTATION');
	              var showReviewedInfluencersValue = !_lodash2.default.isEqual(key, 'AUGUST_SEGMENTATION');
	              return _react2.default.createElement(_campaignReportCard2.default, {
	                key: key,
	                campaigns: _this3.getStateValue(keyPrefix + 'Reports'),
	                title: title,
	                month: key,
	                isLoading: _this3.getStateValue(keyPrefix + 'IsLoading'),
	                onReload: _this3.fetchReportForMonth,
	                isReloading: _this3.getStateValue(keyPrefix + 'IsReloading'),
	                showReviewedInfluencers: true,
	                showContactedInfluencers: true,
	                showContactedInfluencersValue: showContactedInfluencersValue,
	                showReviewedInfluencersValue: showReviewedInfluencersValue,
	                showCampaignTitle: false
	              });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShopfluenceDashboard;
	}(_react.Component);
	
	var LatestUploadedFileMessage = function LatestUploadedFileMessage(_ref6) {
	  var files = _ref6.files;
	
	  if (_lodash2.default.isEmpty(files)) {
	    return null;
	  }
	  var getMessageText = function getMessageText(file) {
	    var lastModified = _lodash2.default.get(file, 'lastModified');
	    var uploadedDate = (0, _moment2.default)(lastModified).format('YYYY-MM-DD');
	    var latestUploadedFilename = parseFilename(_lodash2.default.get(file, 'filename', ''));
	    var latestFileText = latestUploadedFilename ? 'Last report loaded: ' + latestUploadedFilename + ' on ' + uploadedDate : null;
	    return latestFileText;
	  };
	
	  return _react2.default.createElement(_semanticUiReact.Message, {
	    style: messageStyles,
	    icon: 'clock outline',
	    header: 'Last reports',
	    color: getMessageColor(_lodash2.default.head(files).lastModified),
	    list: _lodash2.default.map(files, getMessageText)
	  });
	};
	
	ShopfluenceDashboard.propTypes = {
	  buildRESTClient: _propTypes2.default.func.isRequired
	};
	LatestUploadedFileMessage.propTypes = {
	  files: _propTypes2.default.array
	};
	LatestUploadedFileMessage.defaultProps = {
	  files: null
	};
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(ShopfluenceDashboard);

/***/ },
/* 2203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _reactRedux = __webpack_require__(28);
	
	var _recompose = __webpack_require__(15);
	
	var _reactToastify = __webpack_require__(1570);
	
	var _reactCsv = __webpack_require__(316);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactQuill = __webpack_require__(731);
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	var _quillSnow = __webpack_require__(2907);
	
	var _quillSnow2 = _interopRequireDefault(_quillSnow);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _validator = __webpack_require__(84);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _authService = __webpack_require__(21);
	
	var _influencerShortlistEditableCard = __webpack_require__(1982);
	
	var _influencerShortlistEditableCard2 = _interopRequireDefault(_influencerShortlistEditableCard);
	
	var _shortlistSummary = __webpack_require__(2025);
	
	var _shortlistSummary2 = _interopRequireDefault(_shortlistSummary);
	
	var _cloneShortlist = __webpack_require__(1914);
	
	var _cloneShortlist2 = _interopRequireDefault(_cloneShortlist);
	
	var _newAddCampaignModal = __webpack_require__(550);
	
	var _newAddCampaignModal2 = _interopRequireDefault(_newAddCampaignModal);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasJsonapiClient = __webpack_require__(40);
	
	var _hasJsonapiClient2 = _interopRequireDefault(_hasJsonapiClient);
	
	var _createNewCampaign = __webpack_require__(569);
	
	var _createNewCampaign2 = _interopRequireDefault(_createNewCampaign);
	
	var _dyzioIcons = __webpack_require__(92);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var currentTheme = _themeSelector2.default.theme();
	
	var iconStyle = {
	  height: '1rem',
	  margin: '0 5px'
	};
	
	var MT5 = {
	  marginTop: 5
	};
	
	var MR15 = {
	  marginRight: 15
	};
	
	var cloneShortlistStyle = {
	  cursor: 'pointer'
	};
	
	var TEAM_DYZIO_ID = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';
	
	var Shortlist = function (_Component) {
	  _inherits(Shortlist, _Component);
	
	  function Shortlist() {
	    var _this2 = this;
	
	    _classCallCheck(this, Shortlist);
	
	    var _this = _possibleConstructorReturn(this, (Shortlist.__proto__ || Object.getPrototypeOf(Shortlist)).call(this));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.loadShortlist();
	
	            case 2:
	              window.scrollTo(0, 0);
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.toggleAddCampaignModalState = function () {
	      _this.setState(function (prevState) {
	        return {
	          addCampaignModalOpen: !prevState.addCampaignModalOpen
	        };
	      });
	    };
	
	    _this.loadShortlist = function () {
	      var id = _this.props.params.id;
	
	      return _this.jsonClient.get('shortlists', id, { include: ['influencers', 'organisation', 'influencerLinks.influencerDetails'] }).then(function (response) {
	        var linksMap = _lodash2.default.map(response.influencerLinks, function (l) {
	          return { influencerId: l.influencer && l.influencer._base.id, linkId: l._base.id };
	        });
	        var listJson = response.toJSONTree();
	        _this.setState({
	          saved: true,
	          shortlist: listJson,
	          list: listJson.influencers,
	          links: listJson.influencerLinks,
	          linksMap: linksMap,
	          initialName: listJson.name,
	          loading: false,
	          dataMap: listJson.dataMap || {},
	          history: listJson.history || [],
	          isShortlistApprovalDisabled: listJson.isShortlistApprovalDisabled || false,
	          selectedPlatforms: listJson.selectedPlatforms || {
	            instagram: true,
	            facebook: true,
	            youtube: true,
	            tiktok: true,
	            twitch: true,
	            twitter: true
	          }
	        });
	      }).catch(function (e) {
	        console.log(e);
	      });
	    };
	
	    _this.handleNameChange = function (e, _ref2) {
	      var value = _ref2.value;
	      var shortlist = _this.state.shortlist;
	
	      shortlist.name = value;
	      _this.setState({
	        shortlist: shortlist
	      });
	    };
	
	    _this.handleQuillChange = function (value) {
	      var shortlist = _this.state.shortlist;
	
	      shortlist.notes = value;
	      _this.setState({
	        shortlist: shortlist
	      });
	    };
	
	    _this.toastMessage = function (message) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'save', color: 'pink' }),
	          message
	        )
	      );
	    };
	
	    _this.handleApprovalSave = function () {
	      var isShortlistApprovalDisabled = _this.state.isShortlistApprovalDisabled;
	
	      var id = _this.props.params.id;
	
	      var patch = {
	        data: {
	          type: 'shortlists',
	          attributes: {
	            isShortlistApprovalDisabled: !isShortlistApprovalDisabled
	          }
	        }
	      };
	
	      _this.restClient.patch('/shortlists/' + id, patch).then(function () {
	        (0, _reactToastify.toast)(_this.toastMessage('Shortlist saved OK!'));
	        _this.setState({
	          isShortlistApprovalDisabled: !isShortlistApprovalDisabled
	        });
	      }).catch(function (e) {
	        console.log(e);
	      });
	    };
	
	    _this.handlePlatformsSave = function (platform) {
	      var selectedPlatforms = _this.state.selectedPlatforms;
	
	      var id = _this.props.params.id;
	
	      console.log(selectedPlatforms);
	
	      var newSelectedPlatforms = selectedPlatforms;
	      newSelectedPlatforms[platform] = !newSelectedPlatforms[platform];
	
	      console.log(newSelectedPlatforms);
	
	      _this.setState({
	        selectedPlatforms: newSelectedPlatforms
	      });
	
	      var patch = {
	        data: {
	          type: 'shortlists',
	          attributes: {
	            selectedPlatforms: selectedPlatforms
	          }
	        }
	      };
	
	      console.log(patch);
	
	      _this.restClient.patch('/shortlists/' + id, patch).then(function () {
	        (0, _reactToastify.toast)(_this.toastMessage('Shortlist saved OK!'));
	      }).catch(function (e) {
	        console.log(e);
	      });
	    };
	
	    _this.handleSave = function () {
	      var _this$state = _this.state,
	          dataMap = _this$state.dataMap,
	          history = _this$state.history,
	          status = _this$state.status;
	      var _this$state$shortlist = _this.state.shortlist,
	          name = _this$state$shortlist.name,
	          notes = _this$state$shortlist.notes;
	
	      var id = _this.props.params.id;
	
	      var patch = {
	        data: {
	          type: 'shortlists',
	          attributes: {
	            notes: notes,
	            name: name,
	            dataMap: dataMap,
	            history: history,
	            status: status
	          }
	        }
	      };
	
	      _this.restClient.patch('/shortlists/' + id, patch).then(function () {
	        (0, _reactToastify.toast)(_this.toastMessage('Shortlist saved OK!'));
	      }).catch(function (e) {
	        console.log(e);
	      });
	    };
	
	    _this.handleRemove = function (influencerId) {
	      var id = _this.props.params.id;
	      var influencers = _this.state.shortlist.influencers;
	
	
	      var removedInfluencer = _lodash2.default.remove(influencers, { id: influencerId })[0];
	      console.log(removedInfluencer);
	      var influencersPatch = _lodash2.default.map(influencers, function (i) {
	        return { type: 'influencer', id: i.id };
	      });
	
	      var patch = {
	        data: {
	          type: 'shortlists',
	          attributes: {
	            influencers: influencersPatch
	          }
	        }
	      };
	
	      _this.restClient.patch('/shortlists/' + id, patch).then(function () {
	        (0, _reactToastify.toast)(_this.toastMessage('Removed ' + removedInfluencer.name + '!'));
	        var sl = _this.state.shortlist;
	        sl.influencers = influencers;
	        _this.setState({
	          shortlist: sl
	        });
	      }).catch(function (e) {
	        console.log(e);
	      });
	    };
	
	    _this.handleNoteChange = function (id, e) {
	      var dataMap = _this.state.dataMap;
	
	      var dataNode = dataMap[id] || {};
	      dataNode.description = e;
	      dataMap[id] = dataNode;
	    };
	
	    _this.handleShare = function () {
	      var _this$state2 = _this.state,
	          history = _this$state2.history,
	          emailList = _this$state2.emailList;
	      var user = _this.props.user;
	
	      var shortlistId = _this.props.params.id;
	
	      var emails = _lodash2.default.split(emailList, ',');
	      var trimmedEmails = _lodash2.default.map(emails, function (e) {
	        return _lodash2.default.trim(e);
	      });
	      var wrongShareValues = _lodash2.default.filter(trimmedEmails, function (x) {
	        return !_validator2.default.isEmail(x);
	      });
	
	      if (wrongShareValues.length > 0) {
	        _this.setState({
	          wrongShareValues: wrongShareValues
	        });
	        return;
	      }
	
	      history.push({ message: user.name + ' shared the shortlist with ' + emailList + ' on ' + (0, _moment2.default)(new Date()).format('DD MMM YYYY') });
	
	      var share = _this.jsonClient.create('shares');
	
	      share.set('sharedWith', trimmedEmails);
	      share.set('resourceType', 'SHORTLIST');
	      share.set('resource', {
	        type: 'shortlists',
	        id: shortlistId
	      });
	
	      share.set('sharedDate', new Date());
	      share.set('sharedBy', user.name);
	
	      share.sync().then(function (r) {
	        console.log(r);
	        _this.setState({
	          history: history,
	          emailList: '',
	          status: 'SHARED',
	          wrongShareValues: []
	        }, _this.handleSave);
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    _this.handleChange = function (e, _ref3) {
	      var name = _ref3.name,
	          value = _ref3.value;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.toggleCardView = function () {
	      var compactCards = _this.state.compactCards;
	
	      _this.setState({
	        compactCards: !compactCards
	      });
	    };
	
	    _this.openCloneShortListModal = function () {
	      var cloneModal = _this.state.cloneModal;
	
	      var updated = _lodash2.default.assign(cloneModal, { visible: true });
	      _this.setState({
	        cloneModal: updated
	      });
	    };
	
	    _this.closeCloneShortListModal = function () {
	      var cloneModal = _this.state.cloneModal;
	
	      var updated = _lodash2.default.assign(cloneModal, {
	        visible: false,
	        selected: null
	      });
	      _this.setState({
	        cloneModal: updated
	      });
	    };
	
	    _this.handleCloneShortListModalSearch = _lodash2.default.debounce(function (event, data) {
	      var value = data.value;
	      var cloneModal = _this.state.cloneModal;
	
	
	      if (!value) {
	        var _cloneModalUpdated = _lodash2.default.assign(cloneModal, { isSearching: false, searched: false });
	        _this.setState({ cloneModal: _cloneModalUpdated });
	        return;
	      }
	
	      var cloneModalUpdated = _lodash2.default.assign(cloneModal, { isSearching: true });
	
	      _this.setState({
	        cloneModal: cloneModalUpdated
	      }, function () {
	        return _this.searchOrganisation(value);
	      });
	    }, 1000);
	
	    _this.searchOrganisation = function (value) {
	      var encodedValue = encodeURI(value);
	      _this.restClient.get('/organisations?filter[name]=:' + encodedValue + '&filter[orgType]=REAL_AGENCY').then(function (response) {
	        var data = response.data.data;
	
	        var options = _lodash2.default.map(data, function (organisation) {
	          return {
	            title: organisation.attributes.name,
	            id: organisation.id
	          };
	        });
	        var cloneModal = _this.state.cloneModal;
	
	        var updated = _lodash2.default.assign(cloneModal, {
	          options: options,
	          isSearching: false,
	          searched: true
	        });
	        _this.setState({
	          cloneModal: updated
	        });
	      }).catch(function (error) {
	        console.log(error);
	      });
	    };
	
	    _this.handleOptionsSelected = function (event, data) {
	      var result = data.result;
	      var cloneModal = _this.state.cloneModal;
	
	      var updated = _lodash2.default.assign(cloneModal, { selected: result });
	      _this.setState({
	        cloneModal: updated
	      });
	    };
	
	    _this.handleCloneButton = function () {
	      var cloneModal = _this.state.cloneModal;
	
	      var recipientOrganisationId = cloneModal.selected.id;
	
	      var shortlistId = _this.props.params.id;
	
	      var dto = {
	        data: {
	          shortlistId: shortlistId,
	          recipientOrganisationId: recipientOrganisationId
	        }
	      };
	
	      _this.cloneClient.post('/', dto).then(function (response) {
	        console.log(response);
	        _this.closeCloneShortListModal();
	      });
	    };
	
	    _this.onAddCampaignSubmit = function (values) {
	      var _this$props = _this.props,
	          jsonAPIClient = _this$props.jsonAPIClient,
	          userInfo = _this$props.userInfo;
	
	
	      var shortlistId = _this.props.params.id;
	      _lodash2.default.assignIn(values, { shortlistId: shortlistId });
	
	      return (0, _createNewCampaign2.default)(_extends({}, values, {
	        jsonAPIClient: jsonAPIClient,
	        userInfo: userInfo
	      }));
	    };
	
	    _this.state = {
	      loading: true,
	      compactCards: false,
	      shortlist: {
	        name: 'loading...',
	        notes: 'loading...'
	      },
	      addCampaignModalOpen: false,
	      cloneModal: {
	        visible: false,
	        selected: null,
	        options: [],
	        isSearching: false,
	        searched: false
	      },
	      history: [],
	      dataMap: {},
	      status: 'CREATED',
	      wrongShareValues: [],
	      isShortlistApprovalDisabled: false,
	      selectedPlatforms: {}
	    };
	
	    _this.jsonClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	      header: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    _this.restClient = _axios2.default.create({
	      baseURL: ("https://api2.dyzio.co/v1"),
	      timeout: 2000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    _this.cloneClient = _axios2.default.create({
	      baseURL: 'https://ag7nil8td4.execute-api.eu-west-1.amazonaws.com/production/importer/shortlist/clone',
	      timeout: 2000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Shortlist, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          list = _state.list,
	          shortlist = _state.shortlist,
	          initialName = _state.initialName,
	          loading = _state.loading,
	          history = _state.history,
	          dataMap = _state.dataMap,
	          emailList = _state.emailList,
	          compactCards = _state.compactCards,
	          wrongShareValues = _state.wrongShareValues,
	          cloneModal = _state.cloneModal,
	          links = _state.links,
	          linksMap = _state.linksMap,
	          isShortlistApprovalDisabled = _state.isShortlistApprovalDisabled,
	          selectedPlatforms = _state.selectedPlatforms,
	          addCampaignModalOpen = _state.addCampaignModalOpen;
	      var influencers = shortlist.influencers;
	
	
	      var id = this.props.params.id;
	      var buttonStyles = {
	        width: '150px'
	      };
	      var verticalAlignSuperStyle = {
	        'vertical-align': 'super'
	      };
	
	      var basicData = list ? _lodash2.default.map(list, function (li) {
	        return {
	          name: li.name,
	          email: li.email,
	          primarySocialHandle: li.primarySocialHandle,
	          thumbnail: li.thumbnail,
	          country: li.country,
	          youtube: li.youtube,
	          instagram: li.instagram,
	          facebook: li.facebook,
	          twitter: li.twitter,
	          tiktok: li.tiktok,
	          youtubeChannelTitle: li.youtubeChannelTitle,
	          youtubeCount: li.youtubeCount,
	          instagramCount: li.instagramCount,
	          instagramEngagementRate: _lodash2.default.get(li, 'instagramEngagementRate'),
	          facebookCount: li.facebookCount,
	          twitterCount: li.twitterCount,
	          tiktokCount: li.tiktokCount,
	          tiktokEngagementRate: _lodash2.default.get(li, 'tiktokProfileData.engagementData.engagementRate')
	        };
	      }) : [];
	
	      var filename = _lodash2.default.kebabCase(initialName) + '.csv';
	
	      var hostname = window.location.hostname;
	
	      var isVoxogram = hostname === 'app.voxogram.com';
	
	      var shareableLink = currentTheme.shareSite + '/shortlists/' + id;
	      var shareableLinkTable = currentTheme.shareSite + '/shortlists2/' + id;
	      var shareableLinkInstagramTiktok = currentTheme.shareSite + '/shortlists3/' + id;
	
	      var user = this.props.user;
	
	      var isDyzioTeam = user && user.organisation.id === TEAM_DYZIO_ID;
	
	      var influencerCount = _lodash2.default.size(influencers);
	      var totalInstagram = _lodash2.default.sumBy(influencers, 'instagramCount');
	      var totalYoutube = _lodash2.default.sumBy(influencers, 'youtubeCount');
	      var totalFacebook = _lodash2.default.sumBy(influencers, 'facebookCount');
	      var totalTwitter = _lodash2.default.sumBy(influencers, 'twitterCount');
	      var totalTwitch = _lodash2.default.sumBy(influencers, 'twitchCount');
	      var totalTiktok = _lodash2.default.sumBy(influencers, 'tiktokCount');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { style: { height: 140, backgroundColor: '#FFF', borderBottom: '1px solid #EEE' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'page-hero' },
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h2', style: { paddingTop: 40 } },
	              _react2.default.createElement(
	                'div',
	                { style: { width: 500, float: 'right', textAlign: 'right', padding: 10 } },
	                isDyzioTeam && _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  {
	                    basic: true,
	                    size: 'large',
	                    color: 'pink',
	                    onClick: this.openCloneShortListModal,
	                    style: cloneShortlistStyle
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'clone outline' }),
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    'Clone Shortlist'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  {
	                    basic: true,
	                    size: 'large',
	                    color: 'pink',
	                    onClick: this.toggleAddCampaignModalState,
	                    style: cloneShortlistStyle
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'lightning' }),
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    'Create Campaign'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Label,
	                  { basic: true, size: 'large', color: 'pink' },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
	                  _react2.default.createElement(
	                    _reactCsv.CSVLink,
	                    { data: basicData, filename: filename },
	                    'Download Shortlist'
	                  )
	                )
	              ),
	              initialName,
	              _react2.default.createElement(
	                _semanticUiReact.Header.Subheader,
	                null,
	                'Created by ',
	                shortlist.createdBy,
	                ' on ',
	                (0, _moment2.default)(shortlist.createdDate).format('DD MMM YYYY')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h2' },
	              'Shortlist name'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'small light' },
	              _react2.default.createElement(
	                'em',
	                null,
	                '(visible to client)'
	              )
	            ),
	            _react2.default.createElement(_semanticUiReact.Input, { value: shortlist.name, fluid: true, onChange: this.handleNameChange }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h2' },
	              'Shortlist notes'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'small light' },
	              _react2.default.createElement(
	                'em',
	                null,
	                '(visible to client)'
	              )
	            ),
	            _react2.default.createElement(_reactQuill2.default, {
	              value: shortlist.notes,
	              onChange: this.handleQuillChange
	            }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { style: { width: '100%' } },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_semanticUiReact.Radio, {
	                  toggle: true, checked: !isShortlistApprovalDisabled,
	                  onChange: function onChange() {
	                    _this3.handleApprovalSave();
	                  }
	                }),
	                ' ',
	                _react2.default.createElement(
	                  'span',
	                  { style: verticalAlignSuperStyle },
	                  ' Enable Shortlist Approval'
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  style: { float: 'right' }
	                },
	                _react2.default.createElement(_semanticUiReact.Button, { content: 'cancel', icon: 'cancel', style: buttonStyles }),
	                _react2.default.createElement(_semanticUiReact.Button, { content: 'save', icon: 'save', onClick: this.handleSave, style: buttonStyles })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { width: '100%', 'margin-top': '15px' } },
	              _react2.default.createElement(
	                _semanticUiReact.Header,
	                { as: 'h2' },
	                'Channels'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'small light' },
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'choose which social networks to display in the shortlist'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid,
	                { style: MT5 },
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { style: MR15 },
	                    _react2.default.createElement(_dyzioIcons.InstagramIcon, { size: 'large', style: iconStyle }),
	                    _react2.default.createElement(_semanticUiReact.Radio, {
	                      toggle: true, checked: selectedPlatforms.instagram,
	                      onChange: function onChange() {
	                        _this3.handlePlatformsSave('instagram');
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { style: MR15 },
	                    _react2.default.createElement(_dyzioIcons.FacebookIcon, { size: 'large', style: iconStyle }),
	                    _react2.default.createElement(_semanticUiReact.Radio, {
	                      toggle: true, checked: selectedPlatforms.facebook,
	                      onChange: function onChange() {
	                        _this3.handlePlatformsSave('facebook');
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { style: MR15 },
	                    _react2.default.createElement(_dyzioIcons.YoutubeIcon, { size: 'large', style: iconStyle }),
	                    _react2.default.createElement(_semanticUiReact.Radio, {
	                      toggle: true, checked: selectedPlatforms.youtube,
	                      onChange: function onChange() {
	                        _this3.handlePlatformsSave('youtube');
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { style: MR15 },
	                    _react2.default.createElement('img', { style: iconStyle, src: '/icons/tik-tok.svg', alt: 'Tiktok' }),
	                    _react2.default.createElement(_semanticUiReact.Radio, {
	                      toggle: true, checked: selectedPlatforms.tiktok,
	                      onChange: function onChange() {
	                        _this3.handlePlatformsSave('tiktok');
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { style: MR15 },
	                    _react2.default.createElement(_dyzioIcons.TwitchIcon, { size: 'large', style: iconStyle }),
	                    _react2.default.createElement(_semanticUiReact.Radio, {
	                      toggle: true, checked: selectedPlatforms.twitch,
	                      onChange: function onChange() {
	                        _this3.handlePlatformsSave('twitch');
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid.Column,
	                    { style: MR15 },
	                    _react2.default.createElement(_dyzioIcons.TwitterIcon, { size: 'large', style: iconStyle }),
	                    _react2.default.createElement(_semanticUiReact.Radio, {
	                      toggle: true, checked: selectedPlatforms.twitter,
	                      onChange: function onChange() {
	                        _this3.handlePlatformsSave('twitter');
	                      }
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h2' },
	              'Sharing'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Message,
	              { icon: true, info: true },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'share alternate' }),
	              _react2.default.createElement(
	                _semanticUiReact.Message.Content,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Message.Header,
	                  null,
	                  'Shareable link (Original)'
	                ),
	                shareableLink,
	                '\xA0-\xA0 ',
	                _react2.default.createElement(
	                  'a',
	                  { href: shareableLink, target: '_blank', rel: 'noopener noreferrer' },
	                  'open in new window ',
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'external share' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Message,
	              { icon: true, info: true },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'share alternate', color: 'pink' }),
	              _react2.default.createElement(
	                _semanticUiReact.Message.Content,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Message.Header,
	                  null,
	                  'Shareable link (Table)'
	                ),
	                shareableLinkTable,
	                '\xA0-\xA0 ',
	                _react2.default.createElement(
	                  'a',
	                  { href: shareableLinkTable, target: '_blank', rel: 'noopener noreferrer' },
	                  'open in new window ',
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'external share' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Message,
	              { icon: true, info: true },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'share alternate', color: 'black' }),
	              _react2.default.createElement(
	                _semanticUiReact.Message.Content,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Message.Header,
	                  null,
	                  'Shareable link (Instagram & Tiktok)'
	                ),
	                shareableLinkInstagramTiktok,
	                '\xA0-\xA0 ',
	                _react2.default.createElement(
	                  'a',
	                  { href: shareableLinkInstagramTiktok, target: '_blank', rel: 'noopener noreferrer' },
	                  'open in new window ',
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'external share' })
	                )
	              )
	            ),
	            wrongShareValues && wrongShareValues.length > 0 && _react2.default.createElement(_semanticUiReact.Message, {
	              error: true,
	              header: 'There was some errors with your submission. Please check the values below:',
	              list: wrongShareValues
	            }),
	            !isVoxogram && _react2.default.createElement(
	              _semanticUiReact.Form,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Form.Group,
	                { widths: 'equal' },
	                _react2.default.createElement(_semanticUiReact.Form.Input, {
	                  label: 'share with',
	                  placeholder: 'enter comma separated email list...',
	                  name: 'emailList',
	                  value: emailList,
	                  onChange: this.handleChange
	                }),
	                _react2.default.createElement(_semanticUiReact.Form.Button, {
	                  disabled: !emailList || _validator2.default.isEmpty(emailList),
	                  label: '.',
	                  color: 'pink',
	                  icon: 'mail outline',
	                  content: 'share shortlist',
	                  onClick: this.handleShare
	                })
	              )
	            ),
	            _lodash2.default.map(history, function (h) {
	              return _react2.default.createElement(
	                'p',
	                null,
	                h.message
	              );
	            })
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	          _react2.default.createElement(_shortlistSummary2.default, {
	            influencerCount: influencerCount,
	            totalTwitter: totalTwitter,
	            totalInstagram: totalInstagram,
	            totalYoutube: totalYoutube,
	            totalFacebook: totalFacebook,
	            totalTwitch: totalTwitch,
	            totalTiktok: totalTiktok
	          }),
	          _react2.default.createElement(_semanticUiReact.Divider, null),
	          _react2.default.createElement(
	            _semanticUiReact.Header,
	            { as: 'h2' },
	            'Influencers',
	            compactCards ? _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'toggle down', basic: true, content: 'expand all', onClick: this.toggleCardView, style: buttonStyles }) : _react2.default.createElement(_semanticUiReact.Button, { floated: 'right', icon: 'toggle up', basic: true, content: 'collapse all', onClick: this.toggleCardView, style: buttonStyles })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { loading: loading, basic: true, style: { margin: 0, padding: 0 } },
	            _lodash2.default.map(list, function (influencer) {
	              var linkRecord = _lodash2.default.find(linksMap, { influencerId: influencer.id });
	              var description = void 0;
	              if (linkRecord) {
	                var link = _lodash2.default.find(links, { id: linkRecord.linkId });
	                description = link.influencerDetails.description;
	              }
	              return _react2.default.createElement(_influencerShortlistEditableCard2.default, {
	                influencer: influencer,
	                organisation: user.organisation,
	                dataNode: dataMap[influencer.id],
	                description: description,
	                onChange: _this3.handleNoteChange,
	                onSave: _this3.handleSave,
	                onRemove: _this3.handleRemove,
	                compact: compactCards
	              });
	            })
	          ),
	          isDyzioTeam && _react2.default.createElement(_cloneShortlist2.default, {
	            loading: cloneModal.isSearching,
	            visible: cloneModal.visible,
	            selected: cloneModal.selected,
	            closeHandler: this.closeCloneShortListModal,
	            searchHandler: this.handleCloneShortListModalSearch,
	            selectedHandler: this.handleOptionsSelected,
	            searched: cloneModal.searched,
	            yepButtonHandler: this.handleCloneButton,
	            options: cloneModal.options
	          }),
	          addCampaignModalOpen && _react2.default.createElement(_newAddCampaignModal2.default, {
	            onClose: this.toggleAddCampaignModalState,
	            onAddCampaignSubmit: this.onAddCampaignSubmit
	          })
	        )
	      );
	    }
	  }]);
	
	  return Shortlist;
	}(_react.Component);
	
	Shortlist.propTypes = {
	  userInfo: _propTypes2.default.object.isRequired,
	  jsonAPIClient: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user.user
	  };
	};
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _hasJsonapiClient2.default, (0, _reactRedux.connect)(mapStateToProps))(Shortlist);

/***/ },
/* 2204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _confirmationModal = __webpack_require__(345);
	
	var _confirmationModal2 = _interopRequireDefault(_confirmationModal);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _authService = __webpack_require__(21);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Shortlists = function (_Component) {
	  _inherits(Shortlists, _Component);
	
	  function Shortlists() {
	    _classCallCheck(this, Shortlists);
	
	    var _this = _possibleConstructorReturn(this, (Shortlists.__proto__ || Object.getPrototypeOf(Shortlists)).call(this));
	
	    _this.componentDidMount = function () {
	      var userInfo = _this.props.userInfo;
	
	      _this.restClient = _axios2.default.create({
	        baseURL: ("https://api2.dyzio.co/v1"),
	        timeout: 2000,
	        headers: {
	          Authorization: 'Bearer ' + _authService.authService.getToken()
	        }
	      });
	      if (userInfo) _this.getShortlists(userInfo);
	    };
	
	    _this.getShortlists = function (userInfo) {
	      var organisationId = userInfo.organisationId;
	
	      if (!organisationId) return;
	      var options = {
	        filter: {
	          organisation: organisationId
	        },
	        sort: '-createdDate'
	      };
	
	      _this.jsonClient.find('shortlists', options).then(function (lists) {
	        var listsJson = _lodash2.default.map(lists, function (list) {
	          return list.toJSONTree();
	        });
	        _this.setState({
	          lists: listsJson,
	          loading: false
	        });
	      });
	    };
	
	    _this.queueDelete = function (e, _ref) {
	      var value = _ref.value;
	
	      _this.setState({
	        toBeDeleted: value.id,
	        confirmOpen: true,
	        shortlistName: value.name
	      });
	    };
	
	    _this.deleteLink = function () {
	      var value = _this.state.toBeDeleted;
	      var url = '/shortlists/' + value;
	
	      _this.restClient.delete(url).then(function () {
	        var lists = _this.state.lists;
	
	        _lodash2.default.remove(lists, {
	          id: value
	        });
	
	        _this.setState({
	          confirmOpen: false,
	          lists: lists
	        });
	      });
	    };
	
	    _this.handleCancel = function () {
	      _this.setState({
	        toBeDeleted: null,
	        confirmOpen: false
	      });
	    };
	
	    _this.state = {
	      loading: true,
	      lists: [],
	      confirmOpen: false
	    };
	
	    _this.jsonClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	      header: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Shortlists, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loading = _state.loading,
	          lists = _state.lists,
	          confirmOpen = _state.confirmOpen,
	          shortlistName = _state.shortlistName;
	      var userInfo = this.props.userInfo;
	
	      var organisationName = _lodash2.default.get(userInfo, 'organization.name');
	      var shortlistFAQ = 'http://help.dyzio.co/getting-started/influencer-shortlists';
	      var segmentStyles = { margin: 0, padding: 0 };
	      var blackText = { color: '#000' };
	
	      var isFullWhiteLabel = _themeSelector2.default.isFullWhiteLabel();
	
	      var getDeleteButton = function getDeleteButton(list, handleDelete) {
	        return _react2.default.createElement(_semanticUiReact.Button, {
	          floated: 'right',
	          icon: 'delete',
	          circular: true,
	          inverted: true,
	          color: 'pink',
	          value: list,
	          content: 'delete',
	          onClick: handleDelete
	        });
	      };
	
	      var getStatusLabel = function getStatusLabel(list) {
	        return _react2.default.createElement(
	          _semanticUiReact.Label,
	          null,
	          list.status
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { style: { height: 140, backgroundColor: '#FFF', borderBottom: '1px solid #EEE' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'page-hero' },
	            _react2.default.createElement(
	              'h1',
	              { style: { paddingTop: 40 } },
	              'Shortlists'
	            ),
	            _react2.default.createElement(
	              'h4',
	              { className: 'light' },
	              organisationName
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            _semanticUiReact.Message,
	            { icon: true },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'info', color: 'teal' }),
	            _react2.default.createElement(
	              _semanticUiReact.Message.Content,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Message.Header,
	                null,
	                'Go to \'My Influencers\' to create a Shortlist'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Select influencers from your private database and then click add to shortlist.'
	              ),
	              !isFullWhiteLabel && _react2.default.createElement(
	                'p',
	                null,
	                'Check out our ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'FAQ'
	                ),
	                ' if you get stuck ',
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: shortlistFAQ, rel: 'noopener noreferrer',
	                    target: '_blank'
	                  },
	                  shortlistFAQ
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { loading: loading, basic: true, style: segmentStyles },
	            !loading && lists.length === 0 && _react2.default.createElement(
	              _semanticUiReact.Card,
	              { fluid: true },
	              _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Header,
	                  null,
	                  'No shortlists yet!'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card.Content,
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'check out our ',
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'FAQ'
	                  ),
	                  ' to get you started \xA0',
	                  _react2.default.createElement(
	                    'a',
	                    { href: shortlistFAQ, rel: 'noopener noreferrer', target: '_blank' },
	                    shortlistFAQ
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'hint: '
	                  ),
	                  'You need to head over to My Influencers and select some influencers first!'
	                )
	              )
	            ),
	            _lodash2.default.map(lists, function (list) {
	              var deleteButton = getDeleteButton(list, _this2.queueDelete);
	              var statusLabel = getStatusLabel(list);
	              var shortlistedInfuencers = _lodash2.default.uniqBy(list.influencers, 'id');
	              return _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true, key: list.id },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Header,
	                    null,
	                    deleteButton,
	                    _react2.default.createElement(
	                      'a',
	                      { href: '/shortlists/' + list.id, style: blackText },
	                      list.name
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Meta,
	                    null,
	                    'Created by ',
	                    list.createdBy,
	                    ' on ',
	                    (0, _moment2.default)(list.createdDate).format('DD MMM YYYY')
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: list.notes } })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { extra: true },
	                  statusLabel,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'user', color: 'pink' }),
	                  shortlistedInfuencers.length,
	                  ' Influencers'
	                )
	              );
	            })
	          ),
	          confirmOpen && _react2.default.createElement(_confirmationModal2.default, {
	            bodyText: 'Are you sure you want to delete shortlist \'' + shortlistName + '\'?',
	            onCancel: this.handleCancel,
	            onConfirm: this.deleteLink
	          })
	        )
	      );
	    }
	  }]);
	
	  return Shortlists;
	}(_react.Component);
	
	Shortlists.propTypes = {
	  userInfo: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _hasUserInfo2.default)(Shortlists);

/***/ },
/* 2205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _qs = __webpack_require__(251);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _immutable = __webpack_require__(71);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _authService = __webpack_require__(21);
	
	var _formInputText = __webpack_require__(104);
	
	var _formInputText2 = _interopRequireDefault(_formInputText);
	
	var _formInputValidation = __webpack_require__(286);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _metricAnalyticsService = __webpack_require__(119);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var theme = _themeSelector2.default.theme();
	var TERMS_LINK = _themeSelector2.default.getTermsAndConditionsLink();
	
	var trimAndSplit = function trimAndSplit(name) {
	  var trimmedName = _lodash2.default.trim(name);
	  var splitFullname = _lodash2.default.split(trimmedName, /\s+/);
	  return splitFullname;
	};
	
	var Signup = function (_React$Component) {
	  _inherits(Signup, _React$Component);
	
	  function Signup(props, context) {
	    _classCallCheck(this, Signup);
	
	    var _this = _possibleConstructorReturn(this, (Signup.__proto__ || Object.getPrototypeOf(Signup)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var location = _this.props.location;
	
	
	    var qs = location.search;
	    var parsed = _qs2.default.parse(_lodash2.default.replace(qs, '?', ''));
	    var qsEmail = parsed.email;
	    var qsName = parsed.name;
	
	    if (qsEmail) {
	      _this.props.change('email', qsEmail);
	    }
	
	    if (qsName) {
	      _this.props.change('fullname', qsName);
	    }
	
	    _this.state = {
	      signupError: null,
	      modal: false,
	      checked: false,
	      submittedData: null
	    };
	    return _this;
	  }
	
	  _createClass(Signup, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          email = _props.email;
	      var _state = this.state,
	          signupError = _state.signupError,
	          modal = _state.modal,
	          submittedData = _state.submittedData;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: modal ? 'page-centered blurred' : 'page-centered' },
	          _react2.default.createElement(
	            'div',
	            { className: 'center-outer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'center-inner' },
	              _react2.default.createElement(
	                'div',
	                { className: 'center-logo' },
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return _this2.context.router.push('/');
	                    } },
	                  _react2.default.createElement('img', { src: theme.darkLogo.src, alt: theme.darkLogo.alt })
	                )
	              ),
	              signupError && _lodash2.default.includes(signupError, 'already exist') ? _react2.default.createElement(
	                'div',
	                { className: 'center-content' },
	                _react2.default.createElement(_semanticUiReact.Message, {
	                  icon: 'user outline',
	                  info: true,
	                  header: 'It looks like you already have an account with us',
	                  content: _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      submittedData.email,
	                      ' is already registered'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Click the button below to log in instead...'
	                    )
	                  )
	                }),
	                _react2.default.createElement('div', { className: 'spacer' }),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'large rose stretch', onClick: function onClick() {
	                      return _this2.context.router.push('/login');
	                    } },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Log In'
	                  )
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'center-content' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'large stretch', onClick: this.googleSignupValidate },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Sign up with ',
	                    _react2.default.createElement('img', { className: 'google', alt: 'Google logo', src: '/logos/google-logo.svg' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { onSubmit: handleSubmit(this.signUp) },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'option-separator' },
	                    _react2.default.createElement('div', { className: 'left' }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'center' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'or'
	                      )
	                    ),
	                    _react2.default.createElement('div', { className: 'right' })
	                  ),
	                  _react2.default.createElement(_immutable.Field, {
	                    name: 'fullname',
	                    type: 'text',
	                    component: _formInputText2.default,
	                    img: '/icons/user.svg',
	                    placeholder: 'Full name'
	                  }),
	                  _react2.default.createElement(_immutable.Field, {
	                    name: 'email',
	                    type: 'text',
	                    component: _formInputText2.default,
	                    img: '/icons/email.svg',
	                    disabled: !!email,
	                    placeholder: 'Email address'
	                  }),
	                  _react2.default.createElement(_immutable.Field, {
	                    name: 'password',
	                    type: 'password',
	                    component: _formInputText2.default,
	                    img: '/icons/password.svg',
	                    placeholder: 'Choose a password'
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'item' },
	                      _react2.default.createElement(_semanticUiReact.Radio, {
	                        toggle: true, checked: this.state.checked,
	                        onChange: function onChange() {
	                          return _this2.setState({ checked: !_this2.state.checked });
	                        }
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'space' },
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'radio-label' },
	                        'I agree to the ',
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            href: TERMS_LINK,
	                            target: '_blank',
	                            rel: 'noopener noreferrer'
	                          },
	                          'Terms and Conditions'
	                        ),
	                        '.'
	                      )
	                    )
	                  ),
	                  signupError && _react2.default.createElement(_semanticUiReact.Message, {
	                    icon: 'ban',
	                    error: true,
	                    header: 'There was a problem signing up',
	                    content: signupError
	                  }),
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'submit', className: 'large rose stretch', disabled: !this.state.checked },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Sign up'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'info' },
	                  'Already with us? ',
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                        return _this2.context.router.push('/login');
	                      } },
	                    'Log in'
	                  ),
	                  '.'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: modal ? 'custom-modal visible' : 'custom-modal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'top' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Signing in with Google?'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-close' },
	              _react2.default.createElement('img', { src: '/icons/close.svg', alt: 'close', onClick: this.hideModal })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Please use the google account associated with the email address we sent your invite to:\xA0',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  email
	                ),
	                '.'
	              ),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              _react2.default.createElement('div', { className: 'spacer' }),
	              _react2.default.createElement(
	                'button',
	                { className: 'large rose stretch', onClick: this.acceptModal },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Sign In'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Signup;
	}(_react2.default.Component);
	
	Signup.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.getAuthParams = function (data) {
	    var fullname = data.get('fullname');
	    var splitFullname = trimAndSplit(fullname);
	    var firstname = _lodash2.default.head(_lodash2.default.take(splitFullname));
	    var lastname = _lodash2.default.join(_lodash2.default.slice(splitFullname, 1), ' ');
	    return {
	      connection: 'Username-Password-Authentication',
	      email: data.get('email'),
	      password: data.get('password'),
	      scope: 'openid app_metadata',
	      user_metadata: {
	        firstname: firstname,
	        lastname: lastname
	      }
	    };
	  };
	
	  this.showModal = function () {
	    _this3.setState({ modal: true });
	  };
	
	  this.acceptModal = function () {
	    _this3.setState({ modal: false });
	    _this3.googleSignup();
	  };
	
	  this.hideModal = function () {
	    _this3.setState({ modal: false });
	  };
	
	  this.signUp = function (data) {
	    var context = _this3;
	
	    var signUpData = {
	      name: data.get('fullname'),
	      email: data.get('email'),
	      signupType: 'emailPassword'
	    };
	    (0, _metricAnalyticsService.trackEvent)('Sign Up', signUpData);
	
	    _this3.setState({
	      submittedData: signUpData
	    }, function () {
	      _authService.authService.signup(_this3.getAuthParams(data), function (error) {
	        if (error) {
	          (0, _errorHandlingService.reportError)('SIGNUP_ERROR', error.description);
	          context.setState({ signupError: error.description });
	        }
	      });
	    });
	  };
	
	  this.googleSignupValidate = function () {
	    if (_this3.props.email) {
	      _this3.showModal();
	    } else {
	      _this3.googleSignup();
	    }
	  };
	
	  this.googleSignup = function () {
	    (0, _metricAnalyticsService.trackEvent)('Sign Up', { signupType: 'google' });
	    _authService.authService.socialLogin({
	      connection: 'google-oauth2',
	      scope: 'openid app_metadata'
	    }, function (error) {
	      if (error) {
	        (0, _errorHandlingService.reportError)('GOOGLE_SIGNUP_ERROR', error.description);
	        _this3.setState({ signupError: error.description });
	      }
	    });
	  };
	};
	
	Signup.propTypes = {
	  email: _propTypes2.default.string,
	  location: _propTypes2.default.object.isRequired,
	  change: _propTypes2.default.func.isRequired,
	  handleSubmit: _propTypes2.default.func.isRequired
	};
	
	Signup.defaultProps = {
	  routeParams: null,
	  email: null
	};
	
	var validate = function validate(values) {
	  var errors = {};
	
	  var fullname = values.get('fullname');
	  var email = values.get('email');
	  var password = values.get('password');
	
	  if (!fullname) errors.fullname = 'Enter your full name.';
	  if (fullname) {
	    var splitFullname = trimAndSplit(fullname);
	    if (splitFullname.length < 2) errors.fullname = 'Enter both your first and last name.';
	  }
	
	  if (!email) errors.email = 'Enter your email address.';
	  if (email && !_formInputValidation.EMAIL_REGULAR_EXPRESSION.test(email)) errors.email = 'Enter a valid email address.';
	
	  if (!password) errors.password = 'Enter a new password.';
	  if (password && (password.length < 8 || !password.match(/\d+/g))) {
	    errors.password = 'Password must have at least 8 characters and contain 1 number.';
	  }
	
	  return errors;
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    shortId: state.invite.get('shortId'),
	    email: state.invite.get('email'),
	    initialValues: {
	      fullname: state.invite.get('name'),
	      email: state.invite.get('email')
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)((0, _immutable.reduxForm)({
	  form: 'SignupForm',
	  validate: validate
	})(Signup));

/***/ },
/* 2206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _pagination = __webpack_require__(147);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _reportUploadModal = __webpack_require__(891);
	
	var _reportUploadModal2 = _interopRequireDefault(_reportUploadModal);
	
	var _campaignReportCard = __webpack_require__(539);
	
	var _campaignReportCard2 = _interopRequireDefault(_campaignReportCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var delay = function delay(ms) {
	  return new Promise(function (resolve) {
	    return setTimeout(resolve, ms);
	  });
	};
	
	var reportsMonths = ['SKINSIDERS_CAMP_FIVE', 'SKINSIDERS_CAMP_FOUR', 'SKINSIDERS_CAMP_THREE', 'SKINSIDERS_CAMP_TWO', 'SKINSIDERS_CAMP_ONE'];
	
	var PAGE_SIZE = 6;
	var reportsPages = _lodash2.default.chunk(reportsMonths, PAGE_SIZE);
	
	var boxStyle = {
	  paddingTop: 19,
	  paddingBottom: 19
	};
	
	var REPORT_FILE_PATTERN = /^processed-(\d+)-(.+)$$/;
	
	var parseFilename = function parseFilename(filename) {
	  var match = filename.match(REPORT_FILE_PATTERN);
	  var parsedName = _lodash2.default.get(match, '[2]');
	  return parsedName;
	};
	
	var messageStyles = {
	  width: 'max-content'
	};
	
	var getMessageColor = function getMessageColor(dateUploaded) {
	  var date = (0, _moment2.default)(dateUploaded);
	  var now = (0, _moment2.default)(new Date());
	  var duration = _moment2.default.duration(now.diff(date));
	  var hours = duration.asHours();
	  if (hours >= 72) {
	    return 'red';
	  }
	  var isToday = date.isSame(new Date(), 'day');
	  return isToday ? 'green' : 'orange';
	};
	
	var getKeyPrefix = function getKeyPrefix(key) {
	  return _lodash2.default.camelCase(_lodash2.default.toLower(key));
	};
	
	var ShopfluenceDashboard = function (_Component) {
	  _inherits(ShopfluenceDashboard, _Component);
	
	  function ShopfluenceDashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ShopfluenceDashboard);
	
	    var _this = _possibleConstructorReturn(this, (ShopfluenceDashboard.__proto__ || Object.getPrototypeOf(ShopfluenceDashboard)).call(this, props));
	
	    _this.toggleUploadModal = function () {
	      _this.setState(function (prev) {
	        return { showUploadModal: !prev.showUploadModal };
	      });
	    };
	
	    _this.importReport = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(fileUrl) {
	        var payload;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.setState({ isImporting: true });
	                payload = {
	                  fileUrl: fileUrl
	                };
	                _context.next = 4;
	                return _this.reportImportClient.post('/elemis/import', payload).catch(function (err) {
	                  console.log('Import Error: ', err);
	                });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onReportSubmit = function (file) {
	      if (file.filePath) {
	        _this.importReport('https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/' + file.filePath);
	      }
	    };
	
	    _this.fetchReportForMonth = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(key) {
	        var reloading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var keyPrefix, loadingStateKey, organisationId, params;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                keyPrefix = getKeyPrefix(key);
	                loadingStateKey = reloading ? keyPrefix + 'IsReloading' : keyPrefix + 'IsLoading';
	
	                _this.setState(_defineProperty({}, loadingStateKey, true));
	                organisationId = _this.props.userInfo.organisationId;
	                params = reloading ? { clearCache: true } : {};
	                _context2.next = 7;
	                return _this.reportImportClient.get('/organisation/' + 'SKINSIDERS' + '/report/' + key, { params: params }).then(function (response) {
	                  var _this$setState2;
	
	                  var reports = _lodash2.default.get(response, 'data.data.data.reports', []);
	                  _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, keyPrefix + 'Reports', reports), _defineProperty(_this$setState2, loadingStateKey, false), _this$setState2));
	                }).catch(function (err) {
	                  var _this$setState3;
	
	                  _this.setState((_this$setState3 = {}, _defineProperty(_this$setState3, keyPrefix + 'Reports', []), _defineProperty(_this$setState3, loadingStateKey, false), _this$setState3));
	                });
	
	              case 7:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.fetchReports = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var loadingKeys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, month;
	
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              loadingKeys = _lodash2.default.reduce(reportsMonths, function (acc, key) {
	                var keyPrefix = getKeyPrefix(key);
	                acc[keyPrefix + 'IsLoading'] = true;
	                return acc;
	              }, {});
	
	              _this.setState(_extends({}, loadingKeys));
	              // eslint-disable-next-line no-restricted-syntax
	              _iteratorNormalCompletion = true;
	              _didIteratorError = false;
	              _iteratorError = undefined;
	              _context3.prev = 5;
	              _iterator = reportsMonths[Symbol.iterator]();
	
	            case 7:
	              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                _context3.next = 15;
	                break;
	              }
	
	              month = _step.value;
	              _context3.next = 11;
	              return _this.fetchReportForMonth(month);
	
	            case 11:
	              delay(500);
	
	            case 12:
	              _iteratorNormalCompletion = true;
	              _context3.next = 7;
	              break;
	
	            case 15:
	              _context3.next = 21;
	              break;
	
	            case 17:
	              _context3.prev = 17;
	              _context3.t0 = _context3['catch'](5);
	              _didIteratorError = true;
	              _iteratorError = _context3.t0;
	
	            case 21:
	              _context3.prev = 21;
	              _context3.prev = 22;
	
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	
	            case 24:
	              _context3.prev = 24;
	
	              if (!_didIteratorError) {
	                _context3.next = 27;
	                break;
	              }
	
	              throw _iteratorError;
	
	            case 27:
	              return _context3.finish(24);
	
	            case 28:
	              return _context3.finish(21);
	
	            case 29:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2, [[5, 17, 21, 29], [22,, 24, 28]]);
	    }));
	    _this.fetchLatestUploadedFile = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var latestFile;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _this.setState({
	                isFetchingLatestFile: true
	              });
	
	              _context4.next = 3;
	              return _this.reportImportClient.get('/elemis/uploads/latest').then(function (_ref5) {
	                var data = _ref5.data;
	                return data;
	              }).catch(function (err) {
	                console.log('Fetching latest file upload error', err);
	              }).finally(function () {
	                _this.setState({
	                  isFetchingLatestFile: false
	                });
	              });
	
	            case 3:
	              latestFile = _context4.sent;
	
	
	              if (latestFile) {
	                _this.setState({
	                  latestFile: _lodash2.default.get(latestFile, 'data')
	                });
	              }
	
	            case 5:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this2);
	    }));
	
	    _this.getReportsPage = function (currentPage) {
	      var pageIndex = currentPage > 0 ? currentPage - 1 : 0;
	      return reportsPages[pageIndex];
	    };
	
	    _this.incrementPage = function () {
	      _this.setState(function (prev) {
	        return { currentPage: prev.currentPage + 1 };
	      });
	    };
	
	    _this.decrementPage = function () {
	      _this.setState(function (prev) {
	        return { currentPage: prev.currentPage - 1 };
	      });
	    };
	
	    _this.getStateValue = function (key) {
	      return _this.state[key];
	    };
	
	    _this.state = {
	      showUploadModal: false,
	      isImporting: false,
	      currentPage: 1
	    };
	    var buildRESTClient = _this.props.buildRESTClient;
	
	    _this.reportImportClient = buildRESTClient({
	      baseURL: ("https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production") || '',
	      hasToken: false,
	      timeout: 100000
	    });
	    return _this;
	  }
	
	  _createClass(ShopfluenceDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchReports();
	      this.fetchLatestUploadedFile();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          showUploadModal = _state.showUploadModal,
	          isImporting = _state.isImporting,
	          currentPage = _state.currentPage,
	          latestFile = _state.latestFile;
	
	
	      var currentPageReports = this.getReportsPage(currentPage);
	      var latestFiles = !_lodash2.default.isArray(latestFile) ? [latestFile] : latestFile;
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'influencer-context-bar', style: boxStyle },
	          _react2.default.createElement('div', { className: 'spacer small' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'SKINSIDERS'
	              )
	            ),
	            _react2.default.createElement('div', { className: 'space' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'light' },
	                'ELEMIS'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement('div', { className: 'horizontal-spacer' })
	            ),
	            _react2.default.createElement('div', { className: 'space' }),
	            latestFile && !_lodash2.default.isEmpty(latestFiles) && _react2.default.createElement(LatestUploadedFileMessage, { files: latestFiles }),
	            _react2.default.createElement('div', { className: 'space' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement('div', { className: 'horizontal-spacer' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item' },
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                {
	                  color: 'pink',
	                  size: 'medium',
	                  onClick: this.toggleUploadModal
	                },
	                'Upload Redemption Report'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          showUploadModal && _react2.default.createElement(_reportUploadModal2.default, {
	            onSubmit: this.onReportSubmit,
	            onClose: this.toggleUploadModal,
	            isSubmitting: isImporting
	          }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_pagination2.default, {
	              onPageIncrement: this.incrementPage,
	              onPageDecrement: this.decrementPage,
	              currentPage: currentPage,
	              totalPages: _lodash2.default.size(reportsPages)
	            }),
	            _lodash2.default.map(currentPageReports, function (key) {
	              var keyPrefix = getKeyPrefix(key);
	              var title = _lodash2.default.startCase(_lodash2.default.replace(key, '_', ' '));
	              var showContactedInfluencersValue = !_lodash2.default.isEqual(key, 'AUGUST_SEGMENTATION');
	              var showReviewedInfluencersValue = !_lodash2.default.isEqual(key, 'AUGUST_SEGMENTATION');
	              return _react2.default.createElement(_campaignReportCard2.default, {
	                key: key,
	                campaigns: _this3.getStateValue(keyPrefix + 'Reports'),
	                title: title,
	                month: key,
	                isLoading: _this3.getStateValue(keyPrefix + 'IsLoading'),
	                onReload: _this3.fetchReportForMonth,
	                isReloading: _this3.getStateValue(keyPrefix + 'IsReloading'),
	                showReviewedInfluencers: true,
	                showContactedInfluencers: true,
	                showContactedInfluencersValue: showContactedInfluencersValue,
	                showReviewedInfluencersValue: showReviewedInfluencersValue,
	                showCampaignTitle: false
	              });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShopfluenceDashboard;
	}(_react.Component);
	
	var LatestUploadedFileMessage = function LatestUploadedFileMessage(_ref6) {
	  var files = _ref6.files;
	
	  if (_lodash2.default.isEmpty(files)) {
	    return null;
	  }
	  var getMessageText = function getMessageText(file) {
	    var lastModified = _lodash2.default.get(file, 'lastModified');
	    var uploadedDate = (0, _moment2.default)(lastModified).format('YYYY-MM-DD');
	    var latestUploadedFilename = parseFilename(_lodash2.default.get(file, 'filename', ''));
	    var latestFileText = latestUploadedFilename ? 'Last report loaded: ' + latestUploadedFilename + ' on ' + uploadedDate : null;
	    return latestFileText;
	  };
	
	  return _react2.default.createElement(_semanticUiReact.Message, {
	    style: messageStyles,
	    icon: 'clock outline',
	    header: 'Last reports',
	    color: getMessageColor(_lodash2.default.head(files).lastModified),
	    list: _lodash2.default.map(files, getMessageText)
	  });
	};
	
	ShopfluenceDashboard.propTypes = {
	  buildRESTClient: _propTypes2.default.func.isRequired
	};
	LatestUploadedFileMessage.propTypes = {
	  files: _propTypes2.default.array
	};
	LatestUploadedFileMessage.defaultProps = {
	  files: null
	};
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(ShopfluenceDashboard);

/***/ },
/* 2207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(562);
	
	var initialState = (0, _immutable.fromJS)({
	  message: null,
	  colour: null
	});
	
	function statusBarReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_STATUS_BAR:
	      return state.set('message', action.message).set('colour', action.colour);
	    case _constants.CLEAR_STATUS_BAR:
	      return state.set('message', null).set('colour', null);
	    default:
	      return state;
	  }
	}
	
	exports.default = statusBarReducer;

/***/ },
/* 2208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactPlayer = __webpack_require__(453);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var modalImageStyle = {
	  maxHeight: 500,
	  minHeight: 500,
	  display: 'block',
	  margin: '0 auto',
	  maxWidth: '100%'
	};
	
	var loaderStyle = {
	  maxHeight: 500,
	  minHeight: 500,
	  textAlign: 'center',
	  paddingTop: 190,
	  color: '#555'
	};
	
	var StoryPickerModal = function (_React$Component) {
	  _inherits(StoryPickerModal, _React$Component);
	
	  //
	  function StoryPickerModal() {
	    _classCallCheck(this, StoryPickerModal);
	
	    var _this = _possibleConstructorReturn(this, (StoryPickerModal.__proto__ || Object.getPrototypeOf(StoryPickerModal)).call(this));
	
	    _this.changeActiveStoryIndex = function (direction) {
	      var currentStoryIndex = _this.state.currentStoryIndex;
	
	      if (direction === 'down') {
	        _this.setState({
	          currentStoryIndex: _lodash2.default.subtract(currentStoryIndex, 1)
	        });
	      } else {
	        _this.setState({
	          currentStoryIndex: _lodash2.default.add(currentStoryIndex, 1)
	        });
	      }
	    };
	
	    _this.state = {
	      isLoading: true,
	      isError: false,
	      stories: [],
	      currentStoryIndex: 0
	    };
	    return _this;
	  }
	
	  _createClass(StoryPickerModal, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _props, influencerId, buildRESTClient, restClient, response, stories;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props, influencerId = _props.influencerId, buildRESTClient = _props.buildRESTClient;
	                restClient = buildRESTClient({
	                  baseURL: ("https://se8yaarvy6.execute-api.eu-west-3.amazonaws.com/production")
	                });
	                _context.next = 4;
	                return restClient.get('stories/by-influencer/' + influencerId);
	
	              case 4:
	                response = _context.sent;
	
	                if (response) {
	                  stories = _lodash2.default.get(response, 'data.data', []);
	
	                  this.setState({
	                    isLoading: false,
	                    isError: false,
	                    stories: stories
	                  });
	                }
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          isError = _state.isError,
	          stories = _state.stories,
	          currentStoryIndex = _state.currentStoryIndex;
	      var _props2 = this.props,
	          onClose = _props2.onClose,
	          existingStoriesIDs = _props2.existingStoriesIDs,
	          onAddStoryToCollaboration = _props2.onAddStoryToCollaboration,
	          isAddingStoryToCollab = _props2.isAddingStoryToCollab;
	
	      var renderedStory = _lodash2.default.nth(stories, currentStoryIndex);
	      var isVideo = _lodash2.default.get(renderedStory, 'media_type') === 'VIDEO';
	      var hasMediaURL = _lodash2.default.has(renderedStory, 'media_url');
	
	      var isAlreadyAdded = _lodash2.default.includes(existingStoriesIDs, _lodash2.default.get(renderedStory, 'shortcode'));
	
	      return _react2.default.createElement(
	        _semanticUiReact.Modal,
	        {
	          open: true,
	          size: 'tiny',
	          onClose: onClose,
	          closeOnEscape: true,
	          closeOnDimmerClick: true
	        },
	        _react2.default.createElement(_dyzioModal.DyzioModalHeader, { headerText: 'Stories', onClose: onClose }),
	        _react2.default.createElement(
	          _semanticUiReact.Modal.Content,
	          null,
	          isLoading && _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { style: loaderStyle },
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { icon: true },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', loading: true }),
	              'Loading stories'
	            )
	          ),
	          !isLoading && !isError && _lodash2.default.isEmpty(stories) && _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { style: loaderStyle },
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { icon: true },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle' }),
	              'No live stories found'
	            )
	          ),
	          !isLoading && !isError && renderedStory && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: '8' },
	                  !isVideo && _react2.default.createElement(_semanticUiReact.Image, {
	                    style: modalImageStyle,
	                    src: _lodash2.default.get(renderedStory, 'media_url')
	                  }),
	                  isVideo && hasMediaURL && _react2.default.createElement(_reactPlayer2.default, {
	                    controls: true,
	                    style: modalImageStyle,
	                    url: _lodash2.default.get(renderedStory, 'media_url')
	                  }),
	                  isVideo && !hasMediaURL && _react2.default.createElement(_semanticUiReact.Image, {
	                    style: modalImageStyle,
	                    src: _lodash2.default.get(renderedStory, 'thumbnail_url')
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: '8' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Button,
	                    {
	                      onClick: function onClick() {
	                        return onAddStoryToCollaboration(renderedStory);
	                      },
	                      icon: true,
	                      labelPosition: 'right',
	                      fluid: true,
	                      color: isAlreadyAdded ? 'gray' : 'pink',
	                      disabled: isAlreadyAdded || isAddingStoryToCollab
	                    },
	                    isAlreadyAdded ? 'Already added' : 'Add to collaboration',
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: isAlreadyAdded ? 'checkmark' : 'add' })
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    { basic: 'very' },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'type'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        _lodash2.default.get(renderedStory, 'media_type', '-')
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'posted'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _moment2.default)(_lodash2.default.get(renderedStory, 'timestamp')).format('lll')
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'expires'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _moment2.default)(_lodash2.default.get(renderedStory, 'timestamp')).add('hours', 24).format('lll')
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Divider, null),
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Caption:'
	                  ),
	                  _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	                  _lodash2.default.get(renderedStory, 'caption', 'No caption')
	                )
	              )
	            ),
	            _react2.default.createElement(_semanticUiReact.Divider, null),
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              { verticalAlign: 'middle' },
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: '4' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Button,
	                    {
	                      icon: true,
	                      labelPosition: 'left',
	                      inverted: true,
	                      color: 'green', disabled: currentStoryIndex === 0,
	                      onClick: function onClick() {
	                        return _this2.changeActiveStoryIndex('down');
	                      }
	                    },
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'left arrow' }),
	                    'Previous'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: '8', textAlign: 'center' },
	                  'Story ',
	                  currentStoryIndex + 1,
	                  ' of ',
	                  _lodash2.default.size(stories)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Grid.Column,
	                  { width: '4', textAlign: 'right' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Button,
	                    {
	                      icon: true,
	                      labelPosition: 'right',
	                      inverted: true,
	                      color: 'green',
	                      disabled: _lodash2.default.add(1, currentStoryIndex) === _lodash2.default.size(stories),
	                      onClick: function onClick() {
	                        return _this2.changeActiveStoryIndex('up');
	                      }
	                    },
	                    'Next',
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'right arrow' })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StoryPickerModal;
	}(_react2.default.Component);
	
	StoryPickerModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  influencerId: _propTypes2.default.string.isRequired,
	  onAddStoryToCollaboration: _propTypes2.default.func.isRequired,
	  existingStoriesIDs: _propTypes2.default.array,
	  isAddingStoryToCollab: _propTypes2.default.bool.isRequired
	};
	
	StoryPickerModal.defaultProps = {
	  existingStoriesIDs: []
	};
	
	exports.default = (0, _hasRestClient2.default)(StoryPickerModal);

/***/ },
/* 2209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _recompose = __webpack_require__(15);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var wrapperStyle = {
	  display: 'block',
	  minHeight: 50
	};
	
	var TagCloud = function (_React$Component) {
	  _inherits(TagCloud, _React$Component);
	
	  function TagCloud() {
	    var _this2 = this;
	
	    _classCallCheck(this, TagCloud);
	
	    var _this = _possibleConstructorReturn(this, (TagCloud.__proto__ || Object.getPrototypeOf(TagCloud)).call(this));
	
	    _this.loadTags = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props, organisationId, restClient;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props = _this.props, organisationId = _this$props.userInfo.organisationId, restClient = _this$props.restClient;
	              return _context.abrupt('return', restClient.get('tags?filter[organisation]=' + organisationId));
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      isLoading: true,
	      tags: []
	    };
	    return _this;
	  }
	
	  _createClass(TagCloud, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var response, tags;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return this.loadTags();
	
	              case 2:
	                response = _context2.sent;
	                tags = _lodash2.default.get(response, 'data.data');
	
	                this.setState({
	                  tags: tags,
	                  isLoading: false
	                });
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          tags = _state.tags;
	      var onTagSelected = this.props.onTagSelected;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: true },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Influencer tags'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          { style: wrapperStyle },
	          isLoading && _react2.default.createElement(_semanticUiReact.Loader, { inline: 'centered', active: true }),
	          _react2.default.createElement(
	            _semanticUiReact.Label.Group,
	            { size: 'huge' },
	            _lodash2.default.map(tags, function (tag) {
	              return _react2.default.createElement(
	                _semanticUiReact.Label,
	                {
	                  onClick: function onClick() {
	                    return onTagSelected(_lodash2.default.get(tag, 'id'));
	                  },
	                  key: _lodash2.default.get(tag, 'id')
	                },
	                _lodash2.default.get(tag, 'attributes.value')
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TagCloud;
	}(_react2.default.Component);
	
	TagCloud.propTypes = {
	  onTagSelected: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _hasRestClient2.default)(TagCloud);

/***/ },
/* 2210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _businessUnitsManager = __webpack_require__(2056);
	
	var _businessUnitsManager2 = _interopRequireDefault(_businessUnitsManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BusinessUnitsTab = function BusinessUnitsTab(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_businessUnitsManager2.default, props)
	  );
	};
	
	exports.default = BusinessUnitsTab;

/***/ },
/* 2211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouter = __webpack_require__(37);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _validator = __webpack_require__(84);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _recompose = __webpack_require__(15);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _confirmationModal = __webpack_require__(345);
	
	var _confirmationModal2 = _interopRequireDefault(_confirmationModal);
	
	var _addTeamMemberForm = __webpack_require__(1876);
	
	var _addTeamMemberForm2 = _interopRequireDefault(_addTeamMemberForm);
	
	var _authService = __webpack_require__(21);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _resources = __webpack_require__(171);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var REEPAY_PLANS = {
	  premium: 'https://dyzio.reepay.com/e2107b19c39a4263a632f5e93010fc34',
	  proteam: 'https://dyzio.reepay.com/2cddaf93f6e2b4c06d824b2eb7414217'
	};
	
	var panes = [{ menuItem: 'Settings' }, { menuItem: 'Team' }, { menuItem: 'Tags' }, { menuItem: 'Gifting Inventory' }, { menuItem: 'Business Units' }];
	
	var boxStyle = {
	  padding: '24px calc(50vw - 670px)',
	  paddingBottom: 0,
	  background: '#FFF'
	};
	
	var paneStyle = {
	  marginTop: 10
	};
	
	var routes = ['/team/manage', '/team/members', '/team/tags', '/team/inventory', '/team/business-units'];
	
	var TeamManager = function (_Component) {
	  _inherits(TeamManager, _Component);
	
	  function TeamManager() {
	    var _this2 = this;
	
	    _classCallCheck(this, TeamManager);
	
	    var _this = _possibleConstructorReturn(this, (TeamManager.__proto__ || Object.getPrototypeOf(TeamManager)).call(this));
	
	    _this.fetchOrganisation = function () {
	      var userInfo = _this.props.userInfo;
	
	      if (userInfo) {
	        var organisationId = userInfo.organisationId;
	
	        _this.client.get(_resources.ORGANISATION_RESOURCE, organisationId).then(function (organisationResource) {
	          var organisation = organisationResource.toJSON();
	          return _this.setState({ organisation: organisation }, _this.fetchTeamMembers);
	        }).catch(function (err) {
	          (0, _errorHandlingService.reportError)('Unknown error', err);
	        });
	      }
	    };
	
	    _this.componentDidMount = function () {
	      _this.fetchOrganisation();
	    };
	
	    _this.fetchTeamMembers = function () {
	      var _this$state = _this.state,
	          organisation = _this$state.organisation,
	          errors = _this$state.errors;
	
	      errors.loading = false;
	      _this.setState({
	        loading: true,
	        errors: errors
	      });
	      _this.client.find('users', { filter: { organisation: organisation.id }, sort: ['name'], 'page[limit]': 500 }).then(function (users) {
	        var userJsons = _lodash2.default.map(users, function (u) {
	          return u.toJSON();
	        });
	        return _this.setState({
	          members: userJsons,
	          loading: false
	        });
	      }).catch(function (err) {
	        (0, _errorHandlingService.reportError)('FETCH_TEAM_MEMBER_ERROR', err);
	        errors.loading = true;
	        _this.setState({
	          errors: errors,
	          loading: false
	        });
	      }); // TODO: handle errors
	    };
	
	    _this.handleDeleteConfirmation = function (e, data) {
	      var toBeDeleted = {
	        id: data.id,
	        name: data.name
	      };
	      _this.setState({
	        toBeDeleted: toBeDeleted
	      });
	    };
	
	    _this.handleDeleteCancel = function () {
	      return _this.setState({
	        toBeDeleted: null
	      });
	    };
	
	    _this.handleAddUser = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state2, user, organisation, members, updatedMembers, users, userJsons, creatingUser, errors, origin, resource;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state2 = _this.state, user = _this$state2.user, organisation = _this$state2.organisation, members = _this$state2.members;
	              updatedMembers = members;
	              _context.prev = 2;
	              _context.next = 5;
	              return _this.client.find('users', { filter: { organisation: organisation.id }, sort: ['name'], 'page[limit]': 500 });
	
	            case 5:
	              users = _context.sent;
	              userJsons = _lodash2.default.map(users, function (u) {
	                return u.toJSON();
	              });
	
	              updatedMembers = userJsons;
	              _this.setState({
	                members: updatedMembers
	              });
	              _context.next = 14;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context['catch'](2);
	
	              (0, _errorHandlingService.reportError)('FETCH_TEAM_MEMBER_ERROR', _context.t0);
	
	            case 14:
	              creatingUser = _this.props.userInfo;
	              errors = {
	                name: _validator2.default.isEmpty(user.name) ? 'Name is required.' : false,
	                email: _validator2.default.isEmpty(user.email) || !_validator2.default.isEmail(user.email) ? 'Email should be an valid email address.' : false
	              };
	
	
	              if (user.name && _lodash2.default.split(_lodash2.default.trim(user.name), /\s+/).length < 2) {
	                errors.name = 'Enter both your first and last name.';
	              }
	
	              if (user.email && _lodash2.default.find(updatedMembers, function (member) {
	                return _lodash2.default.toLower(member.email) === _lodash2.default.toLower(user.email);
	              })) {
	                errors.email = '\'' + user.email + '\' is already on your team.';
	              }
	
	              if (!(errors.name || errors.email)) {
	                _context.next = 21;
	                break;
	              }
	
	              _this.setState({
	                errors: errors
	              });
	              return _context.abrupt('return');
	
	            case 21:
	
	              _this.setState({
	                addingUser: true
	              });
	
	              origin = window.location.origin;
	              resource = _this.client.create('users');
	
	              resource.set('name', user.name);
	              resource.set('email', user.email);
	              resource.set('origin', origin);
	              resource.set('organisation', {
	                type: 'organisations',
	                id: organisation.id
	              });
	              resource.set('createdBy', creatingUser.name);
	              resource.set('createdDate', new Date());
	              resource.set('createdByProcess', 'TEAM_MANAGER');
	              resource.sync().then(function (res) {
	                var newUser = res.toJSON();
	                updatedMembers.push(newUser);
	                var patch = {
	                  data: {
	                    type: 'organisations',
	                    attributes: {
	                      users: _lodash2.default.map(updatedMembers, function (f) {
	                        return { type: 'users', id: f.id };
	                      })
	                    }
	                  }
	                };
	                var cb = function cb() {
	                  return _this.setState({
	                    members: updatedMembers,
	                    modalVisible: false,
	                    user: {
	                      name: '',
	                      email: ''
	                    },
	                    addingUser: false
	                  });
	                };
	                return _this.patchOrganisation(organisation.id, patch, cb);
	              }).catch(function (err) {
	                (0, _errorHandlingService.reportError)('ADD_USER_ERROR', err);
	              });
	
	            case 32:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[2, 11]]);
	    }));
	
	    _this.patchOrganisation = function (id, patch, cb) {
	      return _this.restClient.patch(("https://api2.dyzio.co/v1").concat('/organisations/' + id), patch).then(cb);
	    };
	
	    _this.handleTeamMemberDelete = function () {
	      var _this$state3 = _this.state,
	          toBeDeleted = _this$state3.toBeDeleted,
	          members = _this$state3.members,
	          organisation = _this$state3.organisation;
	
	      var url = ("https://api2.dyzio.co/v1").concat('/users/' + toBeDeleted.id);
	      _this.restClient.delete(url).then(function () {
	        var patched = _lodash2.default.reject(members, ['id', toBeDeleted.id]);
	        var patch = {
	          data: {
	            type: 'organisations',
	            attributes: {
	              users: _lodash2.default.map(patched, function (f) {
	                return { type: 'users', id: f.id };
	              })
	            }
	          }
	        };
	        return _this.patchOrganisation(organisation.id, patch, function () {
	          _this.setState({
	            toBeDeleted: null,
	            members: patched,
	            loading: false
	          });
	        });
	      }).catch(function (err) {
	        (0, _errorHandlingService.reportError)('DELETE_USER_ERROR', err);
	      });
	    };
	
	    _this.toggleAddMemberPopup = function () {
	      _this.setState({
	        modalVisible: !_this.state.modalVisible,
	        errors: {
	          name: false,
	          email: false
	        },
	        addingUser: false
	      });
	    };
	
	    _this.togglePaymentModal = function () {
	      _this.setState({
	        paymentModalVisible: !_this.state.paymentModalVisible
	      });
	    };
	
	    _this.toggleCancelModal = function () {
	      _this.setState({
	        cancelModalVisible: !_this.state.cancelModalVisible
	      });
	    };
	
	    _this.handleFormChange = function (e, field) {
	      if (field && field.name) {
	        var user = _this.state.user;
	
	        user[field.name] = field.name === 'email' ? _lodash2.default.toLower(field.value) : field.value;
	        _this.setState({ user: user });
	      }
	    };
	
	    _this.handleOrganisationChange = function (e, _ref2) {
	      var name = _ref2.name,
	          value = _ref2.value;
	      var organisation = _this.state.organisation;
	
	      _this.setState({
	        organisation: _extends({}, organisation, _defineProperty({}, name, value))
	      }, function () {
	        _this.patchOrganisationSettings();
	      });
	    };
	
	    _this.patchOrganisationSettings = function () {
	      var _this$state$organisat = _this.state.organisation,
	          defaultCurrency = _this$state$organisat.defaultCurrency,
	          _this$state$organisat2 = _this$state$organisat.usesGlobalTags,
	          usesGlobalTags = _this$state$organisat2 === undefined ? false : _this$state$organisat2;
	      var organisationId = _this.props.userInfo.organisationId;
	
	      var patch = {
	        data: {
	          attributes: {
	            defaultCurrency: defaultCurrency,
	            usesGlobalTags: usesGlobalTags
	          }
	        }
	      };
	      _this.patchOrganisation(organisationId, patch);
	    };
	
	    _this.handlePaymentSuccess = function (licenseInfo) {
	      _this.togglePaymentModal();
	      var organisation = _this.state.organisation;
	
	      organisation.licenseInfo = licenseInfo;
	
	      _this.setState({
	        organisation: organisation
	      });
	    };
	
	    _this.openReepayWindow = function (plan) {
	      var planUrl = REEPAY_PLANS[plan];
	      window.open(planUrl, '_blank');
	    };
	
	    _this.state = {
	      organisation: null,
	      user: {
	        name: '',
	        email: ''
	      },
	      errors: {
	        name: false,
	        email: false,
	        loading: false
	      },
	      members: [],
	      addingUser: false,
	      loading: true,
	      toBeDeleted: null,
	      modalVisible: false,
	      paymentModalVisible: false,
	      cancelModalVisible: false
	    };
	
	    // TODO: Move this to HOC
	    _this.client = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	      header: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	
	    // TODO: Move this to HOC
	    _this.restClient = _axios2.default.create({
	      timeout: 5000,
	      headers: {
	        Authorization: 'Bearer ' + _authService.authService.getToken()
	      }
	    });
	    return _this;
	  }
	
	  _createClass(TeamManager, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          loading = _state.loading,
	          addingUser = _state.addingUser,
	          organisation = _state.organisation,
	          toBeDeleted = _state.toBeDeleted,
	          modalVisible = _state.modalVisible,
	          user = _state.user,
	          errors = _state.errors;
	      var children = this.props.children;
	
	
	      if (loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'page' },
	          _react2.default.createElement(
	            'div',
	            { className: 'page-content' },
	            _react2.default.createElement(
	              'h1',
	              { style: { padding: 100 } },
	              'loading...'
	            )
	          )
	        );
	      }
	
	      var onTabChanged = function onTabChanged(event, data) {
	        var activeIndex = data.activeIndex;
	        var history = _this3.props.history;
	
	        history.push(routes[activeIndex]);
	      };
	
	      var pathname = _lodash2.default.get(this.props, 'location.pathname');
	      var activeIndex = _lodash2.default.findIndex(routes, function (route) {
	        return _lodash2.default.eq(route, pathname);
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        organisation && _react2.default.createElement(
	          'div',
	          { style: boxStyle },
	          _react2.default.createElement(
	            'h1',
	            null,
	            _lodash2.default.get(organisation, 'name')
	          ),
	          _react2.default.createElement(_semanticUiReact.Tab, { activeIndex: activeIndex, panes: panes, style: paneStyle, onTabChange: onTabChanged })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.cloneElement(children, this.state, _extends({
	            handleDeleteConfirmation: this.handleDeleteConfirmation,
	            openAddTeamMemberModal: this.toggleAddMemberPopup,
	            handleOrganisationChange: this.handleOrganisationChange,
	            fetchOrganisation: this.fetchOrganisation
	          }, this.props)),
	          !loading && toBeDeleted && _react2.default.createElement(_confirmationModal2.default, {
	            bodyText: 'Are you sure you want to delete ' + toBeDeleted.name + ' from your team?',
	            onCancel: this.handleDeleteCancel,
	            onConfirm: this.handleTeamMemberDelete
	          }),
	          modalVisible && _react2.default.createElement(_addTeamMemberForm2.default, {
	            errors: errors,
	            user: user,
	            addingUser: addingUser,
	            formChangeHandler: this.handleFormChange,
	            addUserHandler: this.handleAddUser,
	            popupToggleHandler: this.toggleAddMemberPopup
	          })
	        )
	      );
	    }
	  }]);
	
	  return TeamManager;
	}(_react.Component);
	
	TeamManager.contextTypes = {
	  router: _propTypes2.default.object
	};
	TeamManager.propTypes = {
	  userInfo: _propTypes2.default.object
	};
	TeamManager.defaultProps = {
	  userInfo: null
	};
	
	
	TeamManager.propTypes = {
	  userInfo: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, _reactRouter.withRouter)(TeamManager);

/***/ },
/* 2212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _organisationInventory = __webpack_require__(915);
	
	var _organisationInventory2 = _interopRequireDefault(_organisationInventory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InventoryTab = function InventoryTab(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_organisationInventory2.default, props)
	  );
	};
	
	exports.default = InventoryTab;

/***/ },
/* 2213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _teamMember = __webpack_require__(895);
	
	var _teamMember2 = _interopRequireDefault(_teamMember);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var leftFloatedStyle = {
	  float: 'left',
	  display: 'block',
	  paddingTop: 8
	};
	
	var KASPERSKY = 'ec3b6d8e-f9f0-42f4-9c09-294368cbe683';
	var ROLE_BASED_ORGS = [KASPERSKY];
	
	var MembersTab = function MembersTab(props) {
	  var openAddTeamMemberModal = _lodash2.default.get(props, 'children.openAddTeamMemberModal', _lodash2.default.noop);
	  var handleDeleteConfirmation = _lodash2.default.get(props, 'children.handleDeleteConfirmation', _lodash2.default.noop);
	  var members = _lodash2.default.get(props, 'members', []);
	  var filteredMembers = _lodash2.default.reject(members, function (m) {
	    return m.email.match(/@dyzio.co/);
	  });
	  var userInfo = _lodash2.default.get(props, 'children.userInfo');
	  var organisation = _lodash2.default.get(props, 'children.organisation');
	  var isUserSuperAdmin = userInfo.isUserSuperAdmin;
	
	
	  var isRoleBasedOrganisation = organisation && _lodash2.default.includes(ROLE_BASED_ORGS, organisation.id);
	  var showAddTeamMemberButton = isRoleBasedOrganisation ? isUserSuperAdmin : true;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        'h3',
	        { style: leftFloatedStyle },
	        'Team Members (',
	        filteredMembers.length,
	        ')'
	      ),
	      showAddTeamMemberButton && _react2.default.createElement(_semanticUiReact.Button, {
	        icon: 'plus',
	        color: 'pink',
	        content: 'Add a team member',
	        floated: 'right',
	        onClick: openAddTeamMemberModal
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card.Group,
	        { itemsPerRow: 4 },
	        _lodash2.default.map(filteredMembers, function (member) {
	          return _react2.default.createElement(_teamMember2.default, {
	            key: member.id,
	            member: member,
	            buttonClickHandler: handleDeleteConfirmation
	          });
	        })
	      )
	    )
	  );
	};
	
	exports.default = MembersTab;

/***/ },
/* 2214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _reepayCard = __webpack_require__(2017);
	
	var _reepayCard2 = _interopRequireDefault(_reepayCard);
	
	var _organisationSettings = __webpack_require__(2010);
	
	var _organisationSettings2 = _interopRequireDefault(_organisationSettings);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var REEPAY_PLANS = {
	  premium: 'https://dyzio.reepay.com/3521307b5322ffc7b379683d6944a698',
	  proteam: 'https://dyzio.reepay.com/2cddaf93f6e2b4c06d824b2eb7414217'
	};
	
	var spacedOut = {
	  marginBottom: 50
	};
	
	var SettingsTab = function (_React$Component) {
	  _inherits(SettingsTab, _React$Component);
	
	  function SettingsTab() {
	    _classCallCheck(this, SettingsTab);
	
	    var _this = _possibleConstructorReturn(this, (SettingsTab.__proto__ || Object.getPrototypeOf(SettingsTab)).call(this));
	
	    _this.toggleCancelModal = function () {
	      _this.setState({
	        modalOpen: !_this.state.modalOpen
	      });
	    };
	
	    _this.openReepayWindow = function (plan) {
	      var planUrl = REEPAY_PLANS[plan];
	      window.open(planUrl, '_blank');
	    };
	
	    _this.state = {
	      modalOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(SettingsTab, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var modalOpen = this.state.modalOpen;
	
	      var _ThemeSelector$theme = _themeSelector2.default.theme(),
	          isFullWhiteLabel = _ThemeSelector$theme.isFullWhiteLabel;
	
	      var organisation = this.props.organisation;
	
	      var handleOrganisationChange = _lodash2.default.get(this.props, 'children.handleOrganisationChange', _lodash2.default.noop);
	      var licenseSubscriptionType = _lodash2.default.get(organisation, 'licenseSubscriptionType', null);
	      var fetchOrganisation = _lodash2.default.get(this.props, 'children.fetchOrganisation', _lodash2.default.noop);
	      return _react2.default.createElement(
	        'div',
	        null,
	        !isFullWhiteLabel && _react2.default.createElement(
	          'div',
	          { style: spacedOut },
	          _react2.default.createElement(_reepayCard2.default, {
	            onButtonClick: this.openReepayWindow,
	            licenseSubscriptionType: licenseSubscriptionType,
	            toggleCancelModal: this.toggleCancelModal
	          })
	        ),
	        modalOpen && _react2.default.createElement(
	          _dyzioModal2.default,
	          {
	            headerText: 'Cancel Subscription',
	            size: 'small',
	            onClose: this.toggleCancelModal
	          },
	          'Send an email to ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:payments@dyzio.co' },
	            'payments@dyzio.co'
	          ),
	          ' to cancel your subscription. Alternatively, use the',
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this2.toggleCancelModal() || window.Intercom('show');
	              } },
	            ' Intercom '
	          ),
	          'button at the bottom right of your screen to contact us, and we will arrange cancellation.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: spacedOut },
	          _react2.default.createElement(_organisationSettings2.default, {
	            organisation: organisation,
	            onChange: handleOrganisationChange,
	            fetchOrganisation: fetchOrganisation
	          })
	        )
	      );
	    }
	  }]);
	
	  return SettingsTab;
	}(_react2.default.Component);
	
	SettingsTab.propTypes = {
	  organisation: _propTypes2.default.object.isRequired
	};
	
	exports.default = SettingsTab;

/***/ },
/* 2215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tagsManager = __webpack_require__(919);
	
	var _tagsManager2 = _interopRequireDefault(_tagsManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TagsTab = function TagsTab() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_tagsManager2.default, null)
	  );
	};
	
	exports.default = TagsTab;

/***/ },
/* 2216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inviteModal = __webpack_require__(884);
	
	var _inviteModal2 = _interopRequireDefault(_inviteModal);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TestContainer = function TestContainer() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'this is not a test!'
	    ),
	    _react2.default.createElement(_inviteModal2.default, {
	      thumbnail: 'https://scontent-lht6-1.cdninstagram.com/vp/f8da84290e055d6da7ad8dfa48088c82/5E6F89EE/t51.2885-19/s320x320/67120347_431260040811500_4819299055274295296_n.jpg?_nc_ht=scontent-lht6-1.cdninstagram.com',
	      closeHandler: _lodash2.default.noop,
	      sendHandler: _lodash2.default.noop,
	      email: 'info+cass@dyzio.co',
	      name: 'Cass DiMicco',
	      inviteSentOK: false
	    })
	  );
	};
	
	exports.default = TestContainer;

/***/ },
/* 2217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(15);
	
	var _reactRouter = __webpack_require__(37);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _basicHeader = __webpack_require__(860);
	
	var _basicHeader2 = _interopRequireDefault(_basicHeader);
	
	var _tokenGenerationCard = __webpack_require__(2031);
	
	var _tokenGenerationCard2 = _interopRequireDefault(_tokenGenerationCard);
	
	var _tokenMediaModal = __webpack_require__(2032);
	
	var _tokenMediaModal2 = _interopRequireDefault(_tokenMediaModal);
	
	var _missingPermissions = __webpack_require__(2218);
	
	var _missingPermissions2 = _interopRequireDefault(_missingPermissions);
	
	var _noLinkedAccounts = __webpack_require__(2219);
	
	var _noLinkedAccounts2 = _interopRequireDefault(_noLinkedAccounts);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var THEME = _themeSelector2.default.theme();
	
	var FACEBOOK_OPTIONS = {
	  clientId: '307083449705342'
	};
	
	var REQUIRED_PERMISSIONS = ['manage_pages', 'instagram_basic', 'instagram_manage_insights'];
	
	// the response has changed, but could be a glitch!?
	var NEW_REQUIRED_PERMISSIONS = ['pages_show_list', 'instagram_basic', 'instagram_manage_insights'];
	
	var facebookCallbackUrl = 'https://uiqcrs8dhb.execute-api.eu-west-1.amazonaws.com/production/callback/facebook';
	
	var getFacebookOptions = function getFacebookOptions() {
	  var clientId = THEME.facebookClientId;
	  return clientId ? { clientId: clientId } : FACEBOOK_OPTIONS;
	};
	
	var ACCOUNT_AUTO_PROCESSING_TIMEOUT = 500;
	
	var TokenGenerationPage = function (_Component) {
	  _inherits(TokenGenerationPage, _Component);
	
	  function TokenGenerationPage() {
	    var _this2 = this;
	
	    _classCallCheck(this, TokenGenerationPage);
	
	    var _this = _possibleConstructorReturn(this, (TokenGenerationPage.__proto__ || Object.getPrototypeOf(TokenGenerationPage)).call(this));
	
	    _this.onAccountSelected = function (id) {
	      _this.setState({
	        tokenMediaModalOpen: true,
	        selectedTokenMediaId: id
	      });
	    };
	
	    _this.onMediaModalClose = function () {
	      _this.setState({
	        tokenMediaModalOpen: false,
	        selectedTokenMediaId: null
	      });
	    };
	
	    _this.authoriseInstagram = function () {
	      var instagramScopes = ['manage_pages', 'instagram_manage_insights', 'instagram_basic'];
	      _this.authorise('instagram', instagramScopes);
	    };
	
	    _this.authorise = function (platform, scopeList) {
	      var influencerId = _this.state.influencerId;
	      var _window$location = window.location,
	          hostname = _window$location.hostname,
	          origin = _window$location.origin;
	
	      var callbackURL = origin + '/token/generate';
	      var scopes = _lodash2.default.join(scopeList, ',');
	      var version = 2;
	
	      var state = encodeURIComponent(JSON.stringify({
	        influencerId: influencerId,
	        callbackURL: callbackURL,
	        platform: platform,
	        hostname: hostname,
	        version: version
	      }));
	
	      var facebookOptions = getFacebookOptions();
	      var opts = ['https://www.facebook.com/v2.11/dialog/oauth', '?client_id=' + facebookOptions.clientId, '&response_type=code', '&redirect_uri=' + facebookCallbackUrl, '&scope=' + scopes, '&auth_type=rerequest', '&state=' + state];
	      window.location.href = _lodash2.default.join(opts, '');
	    };
	
	    _this.onAccountConfirmed = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(_ref2) {
	        var accountId = _ref2.accountId;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this.setState({
	                  tokenConfirmationInProgress: true
	                }, _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                  var _this$props, userInfo, oauthResourceId, oauthTokenAPIClient, router, name, tokenData, remainingAccounts;
	
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          _this$props = _this.props, userInfo = _this$props.userInfo, oauthResourceId = _this$props.routeParams.tokenId, oauthTokenAPIClient = _this$props.oauthTokenAPIClient, router = _this$props.router;
	                          name = userInfo.name;
	                          tokenData = {
	                            accountId: accountId,
	                            oauthResourceId: oauthResourceId,
	                            createdBy: name
	                          };
	                          _context.next = 5;
	                          return oauthTokenAPIClient.post('oauthresponse/create-token', _extends({}, tokenData)).catch(function () {
	                            _this.setState({
	                              tokenConfirmationInProgress: false
	                            });
	                          });
	
	                        case 5:
	                          remainingAccounts = _lodash2.default.reject(_this.state.accounts, ['id', accountId]);
	
	
	                          if (_lodash2.default.isEmpty(remainingAccounts)) {
	                            router.push('/influencer/authorisation');
	                          }
	
	                          _this.setState({
	                            tokenMediaModalOpen: false,
	                            selectedTokenMediaId: null,
	                            accounts: remainingAccounts,
	                            tokenConfirmationInProgress: false
	                          });
	
	                        case 8:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                })));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.arePermissionsOK = function (_ref4) {
	      var grantedPermissions = _ref4.grantedPermissions;
	
	      console.log(grantedPermissions);
	      var granted = _lodash2.default.toArray(_lodash2.default.mapValues(grantedPermissions, 'permission'));
	      var ok = _lodash2.default.intersection(granted, REQUIRED_PERMISSIONS).length === REQUIRED_PERMISSIONS.length || _lodash2.default.intersection(granted, NEW_REQUIRED_PERMISSIONS).length === NEW_REQUIRED_PERMISSIONS.length;
	      return ok;
	    };
	
	    _this.state = {
	      accounts: [],
	      declinedPermissions: [],
	      grantedPermissions: [],
	      isLoading: true,
	      tokenMediaModalOpen: false,
	      selectedTokenMediaId: null,
	      tokenConfirmationInProgress: false
	    };
	    return _this;
	  }
	
	  _createClass(TokenGenerationPage, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this3 = this;
	
	        var _props, oauthTokenAPIClient, restClient, tokenId, oauthResourceResponse, oauthFetchFailed, oauthResource, response, data, isExactMatch;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _props = this.props, oauthTokenAPIClient = _props.oauthTokenAPIClient, restClient = _props.restClient, tokenId = _props.routeParams.tokenId;
	                _context4.next = 3;
	                return restClient.get('oauthresponses/' + tokenId);
	
	              case 3:
	                oauthResourceResponse = _context4.sent;
	                oauthFetchFailed = _lodash2.default.isUndefined(oauthResourceResponse);
	                oauthResource = oauthFetchFailed ? null : _lodash2.default.get(oauthResourceResponse, 'data.data');
	                _context4.next = 8;
	                return oauthTokenAPIClient.get('oauthresponse/' + tokenId);
	
	              case 8:
	                response = _context4.sent;
	
	                if (response) {
	                  data = response.data.data;
	                  isExactMatch = _lodash2.default.get(data, 'isExactMatch', false);
	
	                  this.setState(_extends({
	                    isLoading: false,
	                    oauthResource: oauthResource
	                  }, data), function () {
	                    if (isExactMatch) {
	                      setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	                        var account, id;
	                        return _regenerator2.default.wrap(function _callee3$(_context3) {
	                          while (1) {
	                            switch (_context3.prev = _context3.next) {
	                              case 0:
	                                account = _lodash2.default.head(_lodash2.default.get(data, 'accounts'));
	                                id = _lodash2.default.get(account, 'id');
	
	                                if (id) {
	                                  _context3.next = 4;
	                                  break;
	                                }
	
	                                return _context3.abrupt('return');
	
	                              case 4:
	                                _context3.next = 6;
	                                return _this3.onAccountConfirmed({
	                                  accountId: id
	                                });
	
	                              case 6:
	                              case 'end':
	                                return _context3.stop();
	                            }
	                          }
	                        }, _callee3, _this3);
	                      })), ACCOUNT_AUTO_PROCESSING_TIMEOUT);
	                    }
	                  });
	                }
	
	              case 10:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var tokenId = this.props.routeParams.tokenId;
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          accounts = _state.accounts,
	          declinedPermissions = _state.declinedPermissions,
	          grantedPermissions = _state.grantedPermissions,
	          tokenMediaModalOpen = _state.tokenMediaModalOpen,
	          selectedTokenMediaId = _state.selectedTokenMediaId,
	          tokenConfirmationInProgress = _state.tokenConfirmationInProgress;
	
	
	      var arePermissionsOK = this.arePermissionsOK({ declinedPermissions: declinedPermissions, grantedPermissions: grantedPermissions });
	      var noAccounts = _lodash2.default.isEmpty(accounts);
	
	      var margin30 = {
	        margin: 30
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_basicHeader2.default, {
	          title: 'Instagram Authorisation'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          isLoading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading' }),
	          !isLoading && !arePermissionsOK && _react2.default.createElement(_missingPermissions2.default, {
	            declinedPermissions: declinedPermissions,
	            onContinueClick: this.authoriseInstagram
	          }),
	          !isLoading && arePermissionsOK && !noAccounts && _react2.default.createElement(
	            'div',
	            { style: margin30 },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Please select your Instagram account from the list below'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Then check your content and hit confirm to continue'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Card.Group,
	              { itemsPerRow: 4, style: margin30 },
	              _lodash2.default.map(accounts, function (account) {
	                return _react2.default.createElement(_tokenGenerationCard2.default, Object.assign({}, account, {
	                  onClick: _this4.onAccountSelected
	                }));
	              })
	            )
	          ),
	          !isLoading && arePermissionsOK && noAccounts && _react2.default.createElement(_noLinkedAccounts2.default, {
	            declinedPermissions: declinedPermissions,
	            onContinueClick: this.authoriseInstagram
	          })
	        ),
	        tokenMediaModalOpen && _react2.default.createElement(_tokenMediaModal2.default, {
	          tokenConfirmationInProgress: tokenConfirmationInProgress,
	          onConfirm: this.onAccountConfirmed,
	          onClose: this.onMediaModalClose,
	          oauthResponseId: tokenId,
	          accountId: selectedTokenMediaId
	        })
	      );
	    }
	  }]);
	
	  return TokenGenerationPage;
	}(_react.Component);
	
	TokenGenerationPage.propTypes = {
	  routeParams: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default, _reactRouter.withRouter)(TokenGenerationPage);

/***/ },
/* 2218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _authorisationButton = __webpack_require__(538);
	
	var _authorisationButton2 = _interopRequireDefault(_authorisationButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var containerStyle = {
	  width: 600,
	  margin: '0 auto'
	};
	
	var YouTubeLink = function YouTubeLink() {
	  return _react2.default.createElement(
	    'a',
	    { href: 'https://www.youtube.com/watch?v=cpBMyaEkDPI', target: '_blank' },
	    _react2.default.createElement(
	      'span',
	      null,
	      'here ',
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', color: 'red', size: 'large' })
	    )
	  );
	};
	var MissingPermissions = function MissingPermissions(_ref) {
	  var declinedPermissions = _ref.declinedPermissions,
	      onContinueClick = _ref.onContinueClick;
	  return _react2.default.createElement(
	    'div',
	    { style: containerStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Card,
	      { color: 'red', fluid: true },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { textAlign: 'center' },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'x', color: 'orange', size: 'massive' })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { textAlign: 'center' },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Header,
	          null,
	          'PERMISSIONS REMOVED'
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'It looks like you have removed the following permission(s).'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _lodash2.default.map(declinedPermissions, function (dp) {
	            return _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'code',
	                null,
	                dp.permission
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We need this to generate a secure access token to fetch your Instagram Insights data.'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We only ever have read access to your data, we cannot edit or delete anything.'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Click ',
	          _react2.default.createElement(YouTubeLink, null),
	          ' to view an explainer video of the process.'
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Please click the button below to restart the Authorisation process.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(_authorisationButton2.default, {
	        platform: 'instagram',
	        disabled: false,
	        handleAuthClick: onContinueClick
	      })
	    )
	  );
	};
	
	MissingPermissions.propTypes = {
	  declinedPermissions: _propTypes2.default.array.isRequired,
	  onClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = MissingPermissions;

/***/ },
/* 2219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _authorisationButton = __webpack_require__(538);
	
	var _authorisationButton2 = _interopRequireDefault(_authorisationButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var containerStyle = {
	  width: 600,
	  margin: '0 auto'
	};
	
	var NoLinkedAccounts = function NoLinkedAccounts(_ref) {
	  var onContinueClick = _ref.onContinueClick;
	  return _react2.default.createElement(
	    'div',
	    { style: containerStyle },
	    _react2.default.createElement(
	      _semanticUiReact.Card,
	      { color: 'red', fluid: true },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { textAlign: 'center' },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'x', color: 'orange', size: 'massive' })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        { textAlign: 'center' },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Header,
	          null,
	          'NO LINKED ACCOUNTS'
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { margin: 30 } },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'You have no Instagram account',
	            _react2.default.createElement('br', null),
	            'linked to your Facebook page!'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Please check that you have ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://help.dyzio.co/en/articles/4044324-how-to-link-your-instagram-account-to-your-facebook-fan-page', target: '_blank' },
	              'linked your Instagram account'
	            ),
	            '.'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Please check that your Facebook page is a ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://help.dyzio.co/en/articles/4063438-how-to-create-a-facebook-community-page-and-connect-it-to-instagram', target: '_blank' },
	              'community page'
	            ),
	            '... not a personal page!'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If it is linked then please try ',
	            _react2.default.createElement(
	              'b',
	              null,
	              'unlinking'
	            ),
	            ' and ',
	            _react2.default.createElement(
	              'b',
	              null,
	              'relinking'
	            ),
	            '.'
	          ),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you need assistance please use the chat tool in the bottom right corner.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Please click the button below to restart the Authorisation process.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(_authorisationButton2.default, {
	        platform: 'instagram',
	        disabled: false,
	        handleAuthClick: onContinueClick
	      })
	    )
	  );
	};
	
	NoLinkedAccounts.propTypes = {
	  onClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = NoLinkedAccounts;

/***/ },
/* 2220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(15);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iconStyle = {
	  cursor: 'pointer'
	};
	
	var divStyle = {
	  padding: '5px 30px'
	};
	
	var TokenStatusModal = function (_Component) {
	  _inherits(TokenStatusModal, _Component);
	
	  //
	  function TokenStatusModal(props) {
	    _classCallCheck(this, TokenStatusModal);
	
	    var _this = _possibleConstructorReturn(this, (TokenStatusModal.__proto__ || Object.getPrototypeOf(TokenStatusModal)).call(this, props));
	
	    _this.state = {
	      isLoading: true,
	      isError: false,
	      tokenState: null
	    };
	    return _this;
	  }
	
	  _createClass(TokenStatusModal, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var _props, buildRESTClient, channel, influencer, apiClient, response;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props, buildRESTClient = _props.buildRESTClient, channel = _props.channel, influencer = _props.influencer;
	                apiClient = buildRESTClient({
	                  baseURL: ("https://se8yaarvy6.execute-api.eu-west-3.amazonaws.com/production")
	                });
	                _context.next = 4;
	                return apiClient('influencer/' + influencer.id + '/tokens/' + channel + '/info').catch(function () {
	                  _this2.setState({
	                    isLoading: false,
	                    isError: false
	                  });
	                });
	
	              case 4:
	                response = _context.sent;
	
	                if (response) {
	                  this.setState({
	                    isLoading: false,
	                    isError: false,
	                    tokenState: _lodash2.default.get(response, 'data.data')
	                  });
	                }
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          userInfo = _props2.userInfo,
	          channel = _props2.channel,
	          handle = _props2.handle;
	      var tokenState = this.state.tokenState;
	
	      if (userInfo.isDyzioUser) {
	        return _react2.default.createElement(_semanticUiReact.Modal, {
	          trigger: _react2.default.createElement(_semanticUiReact.Icon, {
	            style: iconStyle,
	            name: 'warning circle',
	            color: 'orange',
	            size: 'large'
	          }),
	          content: _react2.default.createElement(
	            'div',
	            { style: divStyle },
	            _react2.default.createElement(
	              'pre',
	              null,
	              JSON.stringify(tokenState, null, 2)
	            )
	          )
	        });
	      }
	      return _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning circle', color: 'orange', size: 'large' }),
	        content: 'Something went wrong accessing data from ' + _lodash2.default.upperFirst(channel) + ' channel ' + handle
	      });
	    }
	  }]);
	
	  return TokenStatusModal;
	}(_react.Component);
	
	TokenStatusModal.propTypes = {
	  channel: _propTypes2.default.string.isRequired,
	  influencer: _propTypes2.default.object.isRequired,
	  userInfo: _propTypes2.default.object.isRequired,
	  handle: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default)(TokenStatusModal);

/***/ },
/* 2221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addTrackedVideo = addTrackedVideo;
	exports.setTrackedAssetData = setTrackedAssetData;
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(283);
	
	function addTrackedVideo(data, callback) {
	  return {
	    type: _constants.ADD_TRACKED_ASSET,
	    data: data,
	    callback: callback
	  };
	}
	
	function setTrackedAssetData(data) {
	  return {
	    type: _constants.SET_TRACKED_ASSET_DATA,
	    data: (0, _immutable.fromJS)(data)
	  };
	}

/***/ },
/* 2222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _immutable = __webpack_require__(71);
	
	var _modal = __webpack_require__(103);
	
	var _actions = __webpack_require__(2221);
	
	var _formInputText = __webpack_require__(104);
	
	var _formInputText2 = _interopRequireDefault(_formInputText);
	
	var _staticConfiguration = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TrackAssetModal = function (_React$Component) {
	  _inherits(TrackAssetModal, _React$Component);
	
	  function TrackAssetModal() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TrackAssetModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TrackAssetModal.__proto__ || Object.getPrototypeOf(TrackAssetModal)).call.apply(_ref, [this].concat(args))), _this), _this.onOutsideClick = function (event) {
	      var isClickInside = _this.refs.modal_content.contains(event.target);
	      if (!isClickInside) {
	        _this.onClearModal();
	      }
	    }, _this.onClearModal = function () {
	      _this.props.onClearModal();
	      _this.props.reset();
	    }, _this.submitCreateTrackedVideo = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(formData) {
	        var data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                data = { assetURL: formData.get('assetURL') };
	
	                if (_this.props.campaignId) data.campaignId = _this.props.campaignId;
	                if (_this.props.discussionId) data.discussionId = _this.props.discussionId;
	                if (_this.props.discussionName) data.discussionName = _this.props.discussionName;
	                _this.props.onAddTrackedVideo(data, _this.onClearModal);
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }(), _this.updateUploaderState = function (newUploaderState) {
	      _this.setState({ uploaderState: newUploaderState });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TrackAssetModal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.onClearModal();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          showModal = _props.showModal,
	          modalLoading = _props.modalLoading,
	          modalError = _props.modalError;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: showModal === _staticConfiguration.TRACKED_ASSET ? 'custom-modal visible' : 'custom-modal', onClick: this.onOutsideClick },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.submitCreateTrackedVideo) },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-content', ref: 'modal_content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'top no-border' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Track a new deliverable'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'You can currently track Youtube, Facebook and Instagram deliverables'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-close no-border' },
	              _react2.default.createElement('img', { src: '/icons/close.svg', alt: 'close', onClick: this.onClearModal })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement('div', { className: 'spacer large' }),
	              _react2.default.createElement(
	                'table',
	                null,
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '3' },
	                      _react2.default.createElement(_immutable.Field, {
	                        name: 'assetURL',
	                        className: 'small-margin',
	                        type: 'text',
	                        label: 'Add a URL',
	                        component: _formInputText2.default,
	                        placeholder: 'The deliverable URL'
	                      }),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: 'http://help.dyzio.co/getting-started/how-to-find-trackable-asset-urls', target: '_blank' },
	                          'where do I find the live URL for my deliverable?'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { colSpan: '3' },
	                      modalError && _react2.default.createElement(
	                        'div',
	                        { className: 'center-all' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          modalError
	                        )
	                      ),
	                      _react2.default.createElement('div', { className: 'spacer' }),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'medium rose stretch', type: 'submit' },
	                        modalLoading ? _react2.default.createElement(
	                          'ul',
	                          { className: 'dots' },
	                          _react2.default.createElement('li', { id: 'dot1' }),
	                          _react2.default.createElement('li', null),
	                          _react2.default.createElement('li', { id: 'dot2' }),
	                          _react2.default.createElement('li', null),
	                          _react2.default.createElement('li', { id: 'dot3' })
	                        ) : _react2.default.createElement(
	                          'span',
	                          null,
	                          'track this deliverable'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TrackAssetModal;
	}(_react2.default.Component);
	
	TrackAssetModal.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	TrackAssetModal.propTypes = {
	  routeParams: _react2.default.PropTypes.object
	};
	
	function validate(values) {
	  var errors = {};
	
	  var assetURL = values.get('assetURL');
	
	  if (!assetURL) {
	    errors.assetURL = 'Please enter an asset URL';
	  } else {
	    /* TODO Use the helper function to determine whether valid
	    const checkValid = extractYoutubeVideoID(assetURL);
	    if (!checkValid) {
	      errors.assetURL = 'Please enter a valid asset URL';
	    }
	    */
	  }
	
	  return errors;
	}
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    userData: state.userData.get('userData'),
	    showModal: state.modal.get('showModal'),
	    modalLoading: state.modal.get('loading'),
	    modalError: state.modal.get('error')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onClearModal: function onClearModal() {
	      return dispatch((0, _modal.clearModal)());
	    },
	    onAddTrackedVideo: function onAddTrackedVideo(data, callback) {
	      return dispatch((0, _actions.addTrackedVideo)(data, callback));
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutable.reduxForm)({
	  form: 'TrackAssetForm',
	  validate: validate
	})(TrackAssetModal));

/***/ },
/* 2223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(283);
	
	var initialState = (0, _immutable.fromJS)({
	  data: {}
	});
	
	function trackAssetModalReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_TRACKED_ASSET_DATA:
	      return state.set('data', action.data);
	    default:
	      return state;
	  }
	}
	
	exports.default = trackAssetModalReducer;

/***/ },
/* 2224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.addTrackedVideo = addTrackedVideo;
	exports.watchAddTrackedVideo = watchAddTrackedVideo;
	exports.default = trackedVideoSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _userSelectors = __webpack_require__(118);
	
	var _campaignSelectors = __webpack_require__(117);
	
	var _trackedAssets = __webpack_require__(570);
	
	var _assetUrlHelperService = __webpack_require__(362);
	
	var _discussions = __webpack_require__(172);
	
	var _campaigns = __webpack_require__(129);
	
	var _deliverables = __webpack_require__(288);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _helperFunctions = __webpack_require__(107);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _constants = __webpack_require__(283);
	
	var _constants2 = __webpack_require__(279);
	
	var _constants3 = __webpack_require__(355);
	
	var _modal = __webpack_require__(169);
	
	var _trackAssetModalSelectors = __webpack_require__(2263);
	
	var _constants4 = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [addTrackedVideo, watchAddTrackedVideo, trackedVideoSagas].map(_regenerator2.default.mark);
	
	// Adds a tracked video if the URL is valid
	function addTrackedVideo(action) {
	  var data, callback, assetURL, userId, campaignId, discussionId, discussionName, assetTypeData, trackedAssetData, newTrackedAsset, modalData, deliverableId, permissionId, message, metaData, messageData;
	  return _regenerator2.default.wrap(function addTrackedVideo$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.put)({ type: _modal.MODAL_LOADING, loading: true });
	
	        case 3:
	          data = action.data;
	          callback = action.callback || null;
	          assetURL = data.assetURL;
	          _context.next = 8;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 8:
	          userId = _context.sent;
	          campaignId = data.campaignId || null;
	          discussionId = data.discussionId || null;
	          discussionName = data.discussionName || null;
	          assetTypeData = data.assetTypeData || (0, _assetUrlHelperService.extractAssetURLData)(assetURL);
	
	          if (!assetTypeData) {
	            _context.next = 53;
	            break;
	          }
	
	          trackedAssetData = _extends({}, assetTypeData, {
	            userId: userId,
	            createdSource: campaignId ? _staticConfiguration.CAMPAIGN : _staticConfiguration.USER
	          });
	
	          if (campaignId) trackedAssetData.campaignId = campaignId;
	          if (discussionId) trackedAssetData.discussionId = discussionId;
	          if (discussionName) trackedAssetData.discussionName = discussionName;
	
	          _context.next = 20;
	          return (0, _effects.call)(_trackedAssets.createTrackedAsset, trackedAssetData);
	
	        case 20:
	          newTrackedAsset = _context.sent;
	
	          if (!(discussionId && campaignId)) {
	            _context.next = 40;
	            break;
	          }
	
	          _context.next = 24;
	          return (0, _effects.call)(_discussions.updateDiscussionTrackedAssets, discussionId, newTrackedAsset);
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.select)(_trackAssetModalSelectors.getData);
	
	        case 26:
	          modalData = _context.sent;
	          deliverableId = modalData.get('deliverableId');
	          _context.next = 30;
	          return (0, _effects.call)(_deliverables.updateDeliverableIsLive, deliverableId, { live: true });
	
	        case 30:
	          _context.next = 32;
	          return (0, _effects.put)({ type: _constants4.UPDATE_DELIVERABLE_IS_LIVE, deliverableId: deliverableId, live: true });
	
	        case 32:
	          _context.next = 34;
	          return (0, _effects.select)(_campaignSelectors.getPermissionId);
	
	        case 34:
	          permissionId = _context.sent;
	          message = assetTypeData.assetURL;
	          metaData = {
	            messageType: 'tracked-asset',
	            permissionId: permissionId,
	            discussionId: discussionId,
	            deliverableId: deliverableId
	          };
	          messageData = {
	            message: message,
	            metaData: metaData,
	            page: _staticConfiguration.DISCUSSION_PAGE
	          };
	          _context.next = 40;
	          return (0, _effects.put)({ type: _constants4.SEND_MESSAGE, data: messageData });
	
	        case 40:
	          if (!(campaignId && !discussionId)) {
	            _context.next = 47;
	            break;
	          }
	
	          _context.next = 43;
	          return (0, _effects.call)(_campaigns.updateCampaignTrackedAssets, campaignId, newTrackedAsset);
	
	        case 43:
	          _context.next = 45;
	          return (0, _effects.call)(_helperFunctions.timeout, 3000);
	
	        case 45:
	          _context.next = 47;
	          return (0, _effects.put)({ type: _constants3.GET_NEW_CAMPAIGN_ANALYTICS, data: { trackedAsset: newTrackedAsset.toJSONTree() } });
	
	        case 47:
	          if (!(!discussionId && !campaignId)) {
	            _context.next = 52;
	            break;
	          }
	
	          _context.next = 50;
	          return (0, _effects.call)(_helperFunctions.timeout, 3000);
	
	        case 50:
	          _context.next = 52;
	          return (0, _effects.put)({ type: _constants2.GET_NEW_ASSET, data: { trackedAsset: newTrackedAsset.toJSONTree() } });
	
	        case 52:
	          if (callback) callback();
	
	        case 53:
	          if (!(!assetTypeData && !discussionId && !campaignId)) {
	            _context.next = 56;
	            break;
	          }
	
	          _context.next = 56;
	          return (0, _effects.put)({ type: _modal.MODAL_ERROR, error: 'Invalid asset URL' });
	
	        case 56:
	          _context.next = 63;
	          break;
	
	        case 58:
	          _context.prev = 58;
	          _context.t0 = _context['catch'](0);
	
	          (0, _errorHandlingService.reportError)('ADD_TRACKED_ASSET_ERROR', _context.t0.message);
	          _context.next = 63;
	          return (0, _effects.put)({ type: _modal.MODAL_ERROR, error: _context.t0 });
	
	        case 63:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 58]]);
	}
	
	function watchAddTrackedVideo() {
	  return _regenerator2.default.wrap(function watchAddTrackedVideo$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.ADD_TRACKED_ASSET, addTrackedVideo);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function trackedVideoSagas() {
	  return _regenerator2.default.wrap(function trackedVideoSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(watchAddTrackedVideo)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 2225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = _themeSelector2.default.theme();
	
	var logoStyle = {
	  display: 'block',
	  margin: '50px auto 30px auto',
	  maxWidth: '70%'
	};
	
	var UnsubscribeConfirmation = function UnsubscribeConfirmation() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page' },
	    _react2.default.createElement(
	      'div',
	      { className: 'page-content' },
	      _react2.default.createElement(
	        'a',
	        { href: '/' },
	        _react2.default.createElement('img', { style: logoStyle, src: '/themes/theme/elemis/logo.png', alt: theme.darkLogo.alt })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { container: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer', computer: '3' }),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { computer: '10', mobile: '16' },
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { textAlign: 'center', size: 'small' },
	              _react2.default.createElement(
	                'h1',
	                { style: { textAlign: 'center' } },
	                'Unsubscribed successfully'
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null),
	              _react2.default.createElement(
	                'p',
	                { className: 'info' },
	                'You have been unsubscribed from our Elemis Influencer outreach program'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer', computer: '3' })
	      )
	    )
	  );
	};
	
	exports.default = UnsubscribeConfirmation;

/***/ },
/* 2226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUser;
	
	var _constants = __webpack_require__(563);
	
	function getUser() {
	  return {
	    type: _constants.GET_USER
	  };
	}

/***/ },
/* 2227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(28);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _actions = __webpack_require__(2226);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _dropdown = __webpack_require__(542);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _authService = __webpack_require__(21);
	
	var _trialExpired = __webpack_require__(2034);
	
	var _trialExpired2 = _interopRequireDefault(_trialExpired);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var organisationBlacklist = ['ad9f2dda-ff2a-4eb7-8e4a-ddbf00e046db', '692f214c-6a63-466e-b83d-a6c945050c9d', '45f827f2-96cd-4dad-bba3-5f97fb6321c5',
	// 'd2b05bec-dfc3-4b55-8a82-ec47bafacb7e', // Hansmann PR
	// '42516f65-6ce6-4606-a8aa-1174763590da', // ELEVATE
	'1c4e0611-e4fc-4522-833e-7a4905227908'];
	
	var ENTRY_SURVEY_STATUS = {
	  mustComplete: 'MUST_COMPLETE'
	};
	
	var SuperAdminIcon = function SuperAdminIcon(_ref) {
	  var name = _ref.name;
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'user circle outline', color: 'green' }),
	    content: name + ' is a super admin'
	  });
	};
	var DYZIO_ORIGINS = ['https://app.dyzio.co', 'http://localhost:3000'];
	
	var isOriginDyzio = function isOriginDyzio(origin) {
	  return _lodash2.default.includes(DYZIO_ORIGINS, origin);
	};
	var userMustCompleteSurvey = function userMustCompleteSurvey(organisation) {
	  return organisation.entrySurveyStatus === ENTRY_SURVEY_STATUS.mustComplete;
	};
	
	var UserHandler = function (_Component) {
	  _inherits(UserHandler, _Component);
	
	  function UserHandler() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserHandler);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = UserHandler.__proto__ || Object.getPrototypeOf(UserHandler)).call.apply(_ref2, [this].concat(args))), _this), _this.profileFeedback = function (action) {
	      window.Intercom('shutdown');
	      _authService.authService.logout();
	      _this.context.router.push(action);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserHandler, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      return this.props.onLoadUser();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          user = _props.user,
	          isLightOnDark = _props.isLightOnDark;
	
	      var showTrialExpiredModal = false;
	
	      var theme = _themeSelector2.default.theme();
	      var hideOptions = theme.hideHomepage || false;
	
	      var linkStyle = {
	        fontWeight: 800,
	        fontSize: '120%'
	      };
	
	      linkStyle.color = isLightOnDark ? '#FFF' : '#000';
	
	      var chevronSrc = isLightOnDark ? '/icons/chevron-down-white.svg' : '/icons/chevron-down.svg';
	
	      if (user && user.organisation) {
	        if (_lodash2.default.includes(organisationBlacklist, user.organisation.id)) {
	          console.log(user.organisation.id + ' is on our blacklist.');
	          (0, _errorHandlingService.reportError)('TRIAL_EXPIRED_ERROR', user.name + ' was shown the trial expired screen.');
	          showTrialExpiredModal = true;
	        } else {
	          var origin = window.location.origin;
	
	          console.log(origin);
	          console.log(user.organisation.id + ' is cleared for take-off.');
	          if (isOriginDyzio(origin) && userMustCompleteSurvey(user.organisation)) {
	            this.context.router.push('/survey');
	          }
	        }
	      }
	
	      var errorStyle = {
	        color: '#fdb02b'
	      };
	      if (user) {
	        var role = user.role;
	
	        var profile = _authService.authService.getProfile();
	        var _profile$app_metadata = profile.app_metadata.dyzio,
	            enrolledBy = _profile$app_metadata.enrolledBy,
	            isUserSuperAdmin = _profile$app_metadata.isUserSuperAdmin;
	
	        var isInfluencer = role === 'INFLUENCER';
	        var selfEnrolled = isInfluencer && enrolledBy === 'SELF';
	        var menuOptions = [];
	
	        if (!selfEnrolled && !hideOptions) {
	          menuOptions.push({
	            name: 'Profile',
	            action: function action() {
	              return _this2.context.router.push('/profile');
	            }
	          });
	        }
	
	        if (!isInfluencer && !hideOptions) {
	          menuOptions.push({
	            name: 'Manage Organisation',
	            action: function action() {
	              return _this2.context.router.push('/team/manage');
	            }
	          });
	        }
	
	        if (!selfEnrolled && !hideOptions) {
	          menuOptions.push({
	            name: 'Notification preferences',
	            action: function action() {
	              return _this2.context.router.push('/profile/settings');
	            }
	          });
	        }
	
	        if (isUserSuperAdmin && !hideOptions) {
	          menuOptions.push({
	            name: 'Audit log',
	            action: function action() {
	              return _this2.context.router.push('/organisation/audit-log');
	            }
	          });
	        }
	
	        menuOptions.push({
	          name: 'Log out',
	          action: function action() {
	            _authService.authService.logout();
	            _this2.context.router.push('/');
	          }
	        });
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _dropdown2.default,
	            {
	              align: 'left',
	              onClick: this.profileFeedback,
	              content: menuOptions
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { style: linkStyle },
	                  user && user.name,
	                  ' ',
	                  isUserSuperAdmin && _react2.default.createElement(SuperAdminIcon, { name: user.name }),
	                  _react2.default.createElement('img', { src: chevronSrc, alt: 'logout' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_trialExpired2.default, { open: showTrialExpiredModal, username: user.name })
	        );
	      }
	
	      return _react2.default.createElement(
	        'p',
	        { style: errorStyle },
	        'loading...'
	      );
	    }
	  }]);
	
	  return UserHandler;
	}(_react.Component);
	
	UserHandler.contextTypes = {
	  router: _propTypes2.default.object
	};
	UserHandler.propTypes = {
	  user: _propTypes2.default.object,
	  onLoadUser: _propTypes2.default.func.isRequired
	};
	UserHandler.defaultProps = {
	  user: {}
	};
	function mapDispatchToProps(dispatch) {
	  return {
	    onLoadUser: function onLoadUser() {
	      return dispatch((0, _actions2.default)());
	    },
	    dispatch: dispatch
	  };
	}
	
	UserHandler.propTypes = {
	  isLightOnDark: _propTypes2.default.bool.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user.user
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserHandler);

/***/ },
/* 2228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(3007);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _constants = __webpack_require__(563);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  user: null
	};
	
	function userHandlerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.GET_USER_SUCCESS:
	      return (0, _assign3.default)({}, state, {
	        user: action.user
	      });
	    case _constants.GET_USER_ERROR:
	      return initialState;
	    default:
	      return state;
	  }
	}
	
	exports.default = userHandlerReducer;

/***/ },
/* 2229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.getUser = getUser;
	exports.watchGetUser = watchGetUser;
	exports.default = userHandlerSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _utils = __webpack_require__(2230);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _constants = __webpack_require__(563);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [getUser, watchGetUser, userHandlerSagas].map(_regenerator2.default.mark);
	
	function getUser() {
	  var user;
	  return _regenerator2.default.wrap(function getUser$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.call)(_utils2.default);
	
	        case 3:
	          user = _context.sent;
	          _context.next = 6;
	          return (0, _effects.put)({ type: _constants.GET_USER_SUCCESS, user: user });
	
	        case 6:
	          _context.next = 12;
	          break;
	
	        case 8:
	          _context.prev = 8;
	          _context.t0 = _context['catch'](0);
	          _context.next = 12;
	          return (0, _effects.put)({ type: _constants.GET_USER_ERROR, error: _context.t0.message });
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 8]]);
	}
	
	function watchGetUser() {
	  return _regenerator2.default.wrap(function watchGetUser$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.GET_USER, getUser);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function userHandlerSagas() {
	  return _regenerator2.default.wrap(function userHandlerSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(watchGetUser)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 2230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUserData;
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _authService = __webpack_require__(21);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getUserData() {
	  var token = _authService.authService.getToken();
	  var uid = _authService.authService.uid();
	
	  var client = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	    header: {
	      Authorization: 'Bearer ' + token
	    }
	  });
	
	  return client.get('users', uid, { include: ['organisation'] }).then(function (user) {
	    return user.toJSONTree();
	  }).catch(function (error) {
	    (0, _errorHandlingService.reportError)('LOAD_USER_ERROR', error.message);
	  });
	}

/***/ },
/* 2231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadOnboardingState = loadOnboardingState;
	exports.updateOnboardingState = updateOnboardingState;
	
	var _constants = __webpack_require__(564);
	
	function loadOnboardingState() {
	  return {
	    type: _constants.LOAD_ONBOARDING_STATE
	  };
	}
	
	function updateOnboardingState(data) {
	  return {
	    type: _constants.UPDATE_ONBOARDING_STATE,
	    data: data
	  };
	}

/***/ },
/* 2232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(564);
	
	var initialState = (0, _immutable.fromJS)({
	  viewedOnboarding: {},
	  loading: false,
	  error: null
	});
	
	function userOnboardingReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.LOAD_ONBOARDING_STATE:
	      return state.set('loading', true).set('error', null).set('viewedOnboarding', (0, _immutable.fromJS)({}));
	    case _constants.LOAD_ONBOARDING_STATE_SUCCESS:
	      return state.set('viewedOnboarding', action.viewedOnboarding).set('loading', false);
	    case _constants.LOAD_ONBOARDING_STATE_ERROR:
	      return state.set('error', action.error).set('loading', false);
	    default:
	      return state;
	  }
	}
	
	exports.default = userOnboardingReducer;

/***/ },
/* 2233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.loadUserOnboardingState = loadUserOnboardingState;
	exports.updateUserOnboardingState = updateUserOnboardingState;
	exports.watchLoadOnboardingStateSagas = watchLoadOnboardingStateSagas;
	exports.watchUpdateOnboardingStateSagas = watchUpdateOnboardingStateSagas;
	exports.default = userOboardingStateSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _authService = __webpack_require__(21);
	
	var _users = __webpack_require__(571);
	
	var _userOnboardingStateSelectors = __webpack_require__(2264);
	
	var _constants = __webpack_require__(564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadUserOnboardingState, updateUserOnboardingState, watchLoadOnboardingStateSagas, watchUpdateOnboardingStateSagas, userOboardingStateSagas].map(_regenerator2.default.mark);
	
	function loadUserOnboardingState(action) {
	  var userId, userData, userDataJSON, viewedOnboarding;
	  return _regenerator2.default.wrap(function loadUserOnboardingState$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          userId = _authService.authService.uid();
	          _context.next = 4;
	          return (0, _effects.call)(_users.fetchUser, userId);
	
	        case 4:
	          userData = _context.sent;
	          userDataJSON = userData.toJSONTree();
	          viewedOnboarding = (0, _immutable.fromJS)(userDataJSON.viewedOnboardingState);
	          _context.next = 9;
	          return (0, _effects.put)({ type: _constants.LOAD_ONBOARDING_STATE_SUCCESS, viewedOnboarding: viewedOnboarding });
	
	        case 9:
	          _context.next = 16;
	          break;
	
	        case 11:
	          _context.prev = 11;
	          _context.t0 = _context['catch'](0);
	
	          (0, _errorHandlingService.reportError)('LOAD_ONBOARDING_STATE_ERROR', _context.t0.message);
	          _context.next = 16;
	          return (0, _effects.put)({ type: _constants.LOAD_ONBOARDING_STATE_ERROR, error: _context.t0.message });
	
	        case 16:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 11]]);
	}
	
	function updateUserOnboardingState(action) {
	  var _action$data, page, onboardingState, callback, currentOnboardingState, onboardingStateJSON, userId, updatedUser, viewedOnboarding;
	
	  return _regenerator2.default.wrap(function updateUserOnboardingState$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _action$data = action.data, page = _action$data.page, onboardingState = _action$data.onboardingState, callback = _action$data.callback;
	          _context2.next = 4;
	          return (0, _effects.select)(_userOnboardingStateSelectors.getOnboardingState);
	
	        case 4:
	          currentOnboardingState = _context2.sent;
	          onboardingStateJSON = currentOnboardingState.toJS();
	
	          if (!(onboardingStateJSON[page][onboardingState] === false)) {
	            _context2.next = 16;
	            break;
	          }
	
	          onboardingStateJSON[page][onboardingState] = true;
	
	          userId = _authService.authService.uid();
	          _context2.next = 11;
	          return (0, _effects.call)(_users.updateUser, userId, { viewedOnboardingState: onboardingStateJSON });
	
	        case 11:
	          updatedUser = _context2.sent;
	          viewedOnboarding = (0, _immutable.fromJS)(updatedUser.toJSONTree());
	          _context2.next = 15;
	          return (0, _effects.put)({ type: _constants.LOAD_ONBOARDING_STATE_SUCCESS, viewedOnboarding: viewedOnboarding });
	
	        case 15:
	
	          if (callback) callback();
	
	        case 16:
	          _context2.next = 23;
	          break;
	
	        case 18:
	          _context2.prev = 18;
	          _context2.t0 = _context2['catch'](0);
	
	          (0, _errorHandlingService.reportError)('UPDATE_ONBOARDING_STATE_ERROR', _context2.t0.message);
	          _context2.next = 23;
	          return (0, _effects.put)({ type: _constants.UPDATE_ONBOARDING_STATE_ERROR, error: _context2.t0.message });
	
	        case 23:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 18]]);
	}
	
	function watchLoadOnboardingStateSagas() {
	  return _regenerator2.default.wrap(function watchLoadOnboardingStateSagas$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.LOAD_ONBOARDING_STATE, loadUserOnboardingState);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function watchUpdateOnboardingStateSagas() {
	  return _regenerator2.default.wrap(function watchUpdateOnboardingStateSagas$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants.UPDATE_ONBOARDING_STATE, updateUserOnboardingState);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function userOboardingStateSagas() {
	  return _regenerator2.default.wrap(function userOboardingStateSagas$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(watchLoadOnboardingStateSagas), (0, _effects.fork)(watchUpdateOnboardingStateSagas)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 2234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadProfile = loadProfile;
	
	var _constants = __webpack_require__(921);
	
	function loadProfile(fields) {
	  return {
	    type: _constants.LOAD_PROFILE,
	    fields: fields
	  };
	}

/***/ },
/* 2235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _reactRouter = __webpack_require__(37);
	
	var _immutable = __webpack_require__(71);
	
	var _validator = __webpack_require__(84);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _header = __webpack_require__(348);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _tabs = __webpack_require__(352);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _formInputText = __webpack_require__(104);
	
	var _formInputText2 = _interopRequireDefault(_formInputText);
	
	var _statusBar = __webpack_require__(170);
	
	var _statusBar2 = _interopRequireDefault(_statusBar);
	
	var _actions = __webpack_require__(105);
	
	var _actions2 = __webpack_require__(2234);
	
	var _users = __webpack_require__(571);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scroll = __webpack_require__(327);
	
	var scroll = Scroll.animateScroll;
	
	var UserProfile = function (_React$Component) {
	  _inherits(UserProfile, _React$Component);
	
	  function UserProfile(props, context) {
	    _classCallCheck(this, UserProfile);
	
	    var _this = _possibleConstructorReturn(this, (UserProfile.__proto__ || Object.getPrototypeOf(UserProfile)).call(this, props, context));
	
	    _this.handleTabChange = function (tab) {
	      return function (event) {
	        if (event) event.preventDefault();
	        if (tab === 'NOTIFICATIONS_SETTINGS') {
	          _this.context.router.push('/profile/settings');
	        }
	      };
	    };
	
	    _this.handleUpdate = function (formData) {
	      _this.setState({ updateProfileLoading: true });
	      var email = formData.get('email');
	      (0, _users.updateUser)(_authService.authService.uid(), {
	        name: formData.get('name'),
	        email: email
	      }).then(function () {
	        _this.props.onSetStatusBar('Profile has been updated.', 'green');
	        scroll.scrollToTop();
	        _this.setState({ updateProfileLoading: false });
	        // TODO Get authService working with getting the profile again after updating the user
	        // this.setState({ updateProfileLoading: true });
	        // authService.renewProfile(email, this.updateUserResponse);
	      });
	    };
	
	    _this.updateUserResponse = function (error, result) {
	      _this.setState({ updateProfileLoading: false });
	      if (error) {
	        _this.props.onSetStatusBar(error.message, 'red');
	      } else {
	        _this.props.onSetStatusBar('Profile has been updated.', 'green');
	      }
	    };
	
	    _this.state = {
	      updateProfileLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(UserProfile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var uid = _authService.authService.uid();
	      (0, _users.fetchUser)(uid).then(function (user) {
	        var userData = user.toJSONTree();
	        _this2.props.onLoadProfile({
	          name: userData.name,
	          email: userData.email
	        });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onClearStatusBar();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var updateProfileLoading = this.state.updateProfileLoading;
	      var _props = this.props,
	          loading = _props.loading,
	          handleSubmit = _props.handleSubmit;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page profile' },
	        _react2.default.createElement(_tabs2.default, {
	          headerStyle: 'padded-content white border-bottom',
	          tabsStyle: 'tabs',
	          data: ['PROFILE', 'NOTIFICATIONS_SETTINGS'],
	          panesTitles: { PROFILE: 'Profile', NOTIFICATIONS_SETTINGS: 'Notification preferences' },
	          active: 'PROFILE',
	          onClick: this.handleTabChange
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            _react2.default.createElement(_statusBar2.default, null),
	            !loading && _react2.default.createElement(
	              'form',
	              { onSubmit: handleSubmit(this.handleUpdate.bind(this)) },
	              _react2.default.createElement(
	                'div',
	                { className: 'profile-header' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'label' },
	                  'Profile'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'profile-form' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-title' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Full name'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-input' },
	                    _react2.default.createElement(_immutable.Field, {
	                      id: 'name',
	                      type: 'text',
	                      component: _formInputText2.default,
	                      name: 'name'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-comment' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'small light' },
	                      'Only new campaigns will use an updated name.'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-title' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'E-mail'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-input' },
	                    _react2.default.createElement(_immutable.Field, {
	                      id: 'email',
	                      type: 'text',
	                      disabled: true,
	                      component: _formInputText2.default,
	                      name: 'email'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-comment' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'small light' },
	                      'You must use the email you were assigned when signing up to the platform.'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-submit' },
	                    updateProfileLoading && _react2.default.createElement(
	                      'button',
	                      { className: 'medium rose', disabled: true },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'dots' },
	                        _react2.default.createElement('li', { id: 'dot1' }),
	                        _react2.default.createElement('li', null),
	                        _react2.default.createElement('li', { id: 'dot2' }),
	                        _react2.default.createElement('li', null),
	                        _react2.default.createElement('li', { id: 'dot3' })
	                      )
	                    ),
	                    !updateProfileLoading && _react2.default.createElement(
	                      'button',
	                      { className: 'medium rose', type: 'submit' },
	                      'Save'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserProfile;
	}(_react2.default.Component);
	
	UserProfile.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	function validate(values) {
	  var errors = {};
	
	  var name = values.get('name');
	  var email = values.get('email');
	
	  if (!name || name && _validator2.default.isEmpty(name)) errors.name = 'Invalid name';
	  if (!email || email && !_validator2.default.isEmail(email)) errors.email = 'Invalid e-mail';
	
	  return errors;
	}
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loading: state.userProfile.get('loading'),
	    initialValues: {
	      name: state.userProfile.get('name'),
	      email: state.userProfile.get('email')
	    }
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onLoadProfile: function onLoadProfile(data) {
	      return dispatch((0, _actions2.loadProfile)(data));
	    },
	    onSetStatusBar: function onSetStatusBar(message, colour) {
	      return dispatch((0, _actions.setStatusBar)(message, colour));
	    },
	    onClearStatusBar: function onClearStatusBar() {
	      return dispatch((0, _actions.clearStatusBar)());
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutable.reduxForm)({
	  form: 'EditProfileForm',
	  enableReinitialize: true,
	  validate: validate
	})(UserProfile));

/***/ },
/* 2236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(921);
	
	var initialState = (0, _immutable.fromJS)({
	  loading: true,
	  name: null,
	  email: null,
	  avatar: null,
	  company: null
	});
	
	function userProfileReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var payload = arguments[1];
	
	  switch (payload.type) {
	    case _constants.LOAD_PROFILE:
	      return state.set('loading', false).set('email', payload.fields.email).set('avatar', payload.fields.avatar).set('name', payload.fields.name);
	    default:
	      return state;
	  }
	}
	
	exports.default = userProfileReducer;

/***/ },
/* 2237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadSettings = loadSettings;
	exports.updateSettings = updateSettings;
	exports.updateAlertState = updateAlertState;
	
	var _constants = __webpack_require__(565);
	
	function loadSettings() {
	  return {
	    type: _constants.LOAD_SETTINGS
	  };
	}
	
	function updateSettings(data) {
	  return {
	    type: _constants.UPDATE_SETTINGS,
	    data: data
	  };
	}
	
	function updateAlertState(fields) {
	  return {
	    type: _constants.NOTIFY_ACTION,
	    fields: fields
	  };
	}

/***/ },
/* 2238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(28);
	
	var _immutable = __webpack_require__(71);
	
	var _tabs = __webpack_require__(352);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _formInputRadio = __webpack_require__(544);
	
	var _formInputRadio2 = _interopRequireDefault(_formInputRadio);
	
	var _actions = __webpack_require__(2237);
	
	var _actions2 = __webpack_require__(105);
	
	var _statusBar = __webpack_require__(170);
	
	var _statusBar2 = _interopRequireDefault(_statusBar);
	
	var _comingSoonText = __webpack_require__(1918);
	
	var _comingSoonText2 = _interopRequireDefault(_comingSoonText);
	
	var _staticConfiguration = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSettings = function (_React$Component) {
	  _inherits(UserSettings, _React$Component);
	
	  function UserSettings() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserSettings);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserSettings.__proto__ || Object.getPrototypeOf(UserSettings)).call.apply(_ref, [this].concat(args))), _this), _this.handleUpdate = function (formData) {
	      var data = {
	        emailType: formData.get('type'),
	        emailFrequency: formData.get('frequency')
	      };
	      _this.props.onUpdateSettings(data);
	    }, _this.handleTabChange = function (tab) {
	      return function (event) {
	        if (event) event.preventDefault();
	        if (tab === 'PROFILE') {
	          _this.context.router.push('/profile');
	        }
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserSettings, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onLoadSettings();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onClearStatusBar();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          settings = _props.settings,
	          handleSubmit = _props.handleSubmit,
	          loadingSettings = _props.loadingSettings,
	          loadSettingsError = _props.loadSettingsError,
	          updateSettingsLoading = _props.updateSettingsLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page profile' },
	        _react2.default.createElement(_tabs2.default, {
	          headerStyle: 'padded-content white border-bottom',
	          tabsStyle: 'tabs',
	          data: ['PROFILE', 'NOTIFICATIONS_SETTINGS'],
	          panesTitles: { PROFILE: 'Profile', NOTIFICATIONS_SETTINGS: 'Notification preferences' },
	          active: 'NOTIFICATIONS_SETTINGS',
	          onClick: this.handleTabChange
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid' },
	            _react2.default.createElement(_statusBar2.default, null),
	            loadingSettings && _react2.default.createElement(
	              'div',
	              { className: 'discussion-preloader' },
	              _react2.default.createElement('img', { src: '/icons/dyzio-icon.svg', alt: 'Loading...' })
	            ),
	            !loadingSettings && loadSettingsError && _react2.default.createElement(
	              'p',
	              null,
	              'Error: ',
	              loadSettingsError
	            ),
	            !loadingSettings && !loadSettingsError && _react2.default.createElement(
	              'form',
	              { onSubmit: handleSubmit(this.handleUpdate.bind(this)) },
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'label' },
	                  'Notification Preferences'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'E-mail'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'hint' },
	                  'Select the type of notifications you would like to receive'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'profile-form-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'profile-form-row' },
	                    _react2.default.createElement(_immutable.Field, {
	                      id: 'all',
	                      type: 'radio',
	                      component: _formInputRadio2.default,
	                      name: 'type',
	                      value: _staticConfiguration.ALL,
	                      label: 'All Messages'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'profile-form-row' },
	                    _react2.default.createElement(_immutable.Field, {
	                      id: 'milestones',
	                      type: 'radio',
	                      component: _formInputRadio2.default,
	                      disabled: true,
	                      name: 'type',
	                      value: _staticConfiguration.MILESTONES,
	                      label: 'Milestones only  (brief, contract and deliverables)'
	                    }),
	                    _react2.default.createElement(_comingSoonText2.default, null)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'profile-form-row' },
	                    _react2.default.createElement(_immutable.Field, {
	                      id: 'none',
	                      type: 'radio',
	                      component: _formInputRadio2.default,
	                      name: 'type',
	                      value: _staticConfiguration.NONE,
	                      label: 'None'
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Email Frequency'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'hint' },
	                  'How often would you like to receive emails?'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'profile-form-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'profile-form-row' },
	                    _react2.default.createElement(_immutable.Field, {
	                      id: 'instantly',
	                      type: 'radio',
	                      component: _formInputRadio2.default,
	                      name: 'frequency',
	                      value: _staticConfiguration.INSTANTLY,
	                      label: 'Instantly'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'profile-form-row' },
	                    _react2.default.createElement(_immutable.Field, {
	                      id: 'hourly',
	                      type: 'radio',
	                      component: _formInputRadio2.default,
	                      disabled: true,
	                      name: 'frequency',
	                      value: _staticConfiguration.HOURLY,
	                      label: 'Hourly'
	                    }),
	                    _react2.default.createElement(_comingSoonText2.default, null)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'profile-form-row' },
	                    _react2.default.createElement(_immutable.Field, {
	                      id: 'daily',
	                      type: 'radio',
	                      component: _formInputRadio2.default,
	                      disabled: true,
	                      name: 'frequency',
	                      value: _staticConfiguration.DAILY,
	                      label: 'Daily'
	                    }),
	                    _react2.default.createElement(_comingSoonText2.default, null)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-3-6 grid-sm-3-6 grid-md-3-6 grid-lg-3-6 grid-xl-3-6' },
	                !updateSettingsLoading && _react2.default.createElement(
	                  'button',
	                  { className: 'medium rose' },
	                  'Save'
	                ),
	                updateSettingsLoading && _react2.default.createElement(
	                  'button',
	                  { className: 'medium rose', disabled: true },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'dots' },
	                    _react2.default.createElement('li', { id: 'dot1' }),
	                    _react2.default.createElement('li', null),
	                    _react2.default.createElement('li', { id: 'dot2' }),
	                    _react2.default.createElement('li', null),
	                    _react2.default.createElement('li', { id: 'dot3' })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserSettings;
	}(_react2.default.Component);
	
	UserSettings.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	
	function validate(values) {
	  var errors = {};
	}
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    settings: state.userSettings.get('settings'),
	    loadingSettings: state.userSettings.get('loadingSettings'),
	    loadSettingsError: state.userSettings.get('loadSettingsError'),
	    updateSettingsLoading: state.userSettings.get('updateSettingsLoading'),
	    updateSettingsError: state.userSettings.get('updateSettingsError'),
	    initialValues: {
	      type: state.userSettings.getIn(['settings', 'emailType']),
	      frequency: state.userSettings.getIn(['settings', 'emailFrequency'])
	    }
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch,
	    onLoadSettings: function onLoadSettings() {
	      return dispatch((0, _actions.loadSettings)());
	    },
	    onUpdateSettings: function onUpdateSettings(data) {
	      return dispatch((0, _actions.updateSettings)(data));
	    },
	    onClearStatusBar: function onClearStatusBar() {
	      return dispatch((0, _actions2.clearStatusBar)());
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutable.reduxForm)({
	  form: 'EditProfileSettingsForm',
	  enableReinitialize: true,
	  validate: validate
	})(UserSettings));

/***/ },
/* 2239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(565);
	
	var initialState = (0, _immutable.fromJS)({
	  settings: {},
	  loadingSettings: false,
	  loadSettingsError: null,
	  hasUserSettings: false,
	  updateSettingsLoading: false,
	  updateSettingsError: false
	});
	
	function userSettingsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.LOAD_SETTINGS:
	      return state.set('settings', (0, _immutable.fromJS)({})).set('loadingSettings', true).set('loadSettingsError', null).set('hasUserSettings', false);
	    case _constants.LOAD_SETTINGS_SUCCESS:
	      return state.set('settings', action.data.settings).set('hasUserSettings', action.data.hasUserSettings).set('loadingSettings', false);
	    case _constants.LOAD_SETTINGS_ERROR:
	      return state.set('loadSettingsError', action.error).set('loadingSettings', false);
	    case _constants.UPDATE_SETTINGS:
	      return state.set('updateSettingsLoading', true).set('updateSettingsError', null);
	    case _constants.UPDATE_SETTINGS_SUCCESS:
	      return state.set('updateSettingsLoading', false).setIn(['settings', 'emailType'], action.data.emailType).setIn(['settings', 'emailFrequency'], action.data.emailFrequency);
	    case _constants.UPDATE_SETTINGS_ERROR:
	      return state.set('updateSettingsLoading', false).set('updateSettingsError', action.error);
	    default:
	      return state;
	  }
	}
	
	exports.default = userSettingsReducer;

/***/ },
/* 2240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.loadSettings = loadSettings;
	exports.updateSettings = updateSettings;
	exports.watchLoadSettings = watchLoadSettings;
	exports.watchUpdateSettings = watchUpdateSettings;
	exports.default = userSettingsSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _users = __webpack_require__(571);
	
	var _userSelectors = __webpack_require__(118);
	
	var _userSettingsSelectors = __webpack_require__(2265);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _constants = __webpack_require__(562);
	
	var _staticConfiguration = __webpack_require__(27);
	
	var _constants2 = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadSettings, updateSettings, watchLoadSettings, watchUpdateSettings, userSettingsSagas].map(_regenerator2.default.mark);
	
	var Scroll = __webpack_require__(327);
	var scroll = Scroll.animateScroll;
	
	function loadSettings(action) {
	  var userId, userDetails, userDetailsJSON, hasUserSettings, userSettings;
	  return _regenerator2.default.wrap(function loadSettings$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 3:
	          userId = _context.sent;
	          _context.next = 6;
	          return (0, _effects.call)(_users.fetchUser, userId);
	
	        case 6:
	          userDetails = _context.sent;
	          userDetailsJSON = userDetails.toJSONTree();
	          hasUserSettings = userDetailsJSON.settings ? true : false;
	          userSettings = hasUserSettings ? userDetailsJSON.settings : { emailType: _staticConfiguration.ALL, emailFrequency: _staticConfiguration.INSTANTLY };
	          _context.next = 12;
	          return (0, _effects.put)({ type: _constants2.LOAD_SETTINGS_SUCCESS, data: { settings: (0, _immutable.fromJS)(userSettings), hasUserSettings: hasUserSettings } });
	
	        case 12:
	          _context.next = 19;
	          break;
	
	        case 14:
	          _context.prev = 14;
	          _context.t0 = _context['catch'](0);
	
	          (0, _errorHandlingService.reportError)('LOAD_SETTINGS_ERROR', _context.t0.message);
	          _context.next = 19;
	          return (0, _effects.put)({ type: _constants2.LOAD_SETTINGS_ERROR, error: _context.t0.message });
	
	        case 19:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 14]]);
	}
	
	function updateSettings(action) {
	  var data, userId, hasUserSettings, settingsId, userSettings, updatedUser;
	  return _regenerator2.default.wrap(function updateSettings$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          data = action.data;
	          _context2.next = 4;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 4:
	          userId = _context2.sent;
	          _context2.next = 7;
	          return (0, _effects.select)(_userSettingsSelectors.getHasUserSettings);
	
	        case 7:
	          hasUserSettings = _context2.sent;
	
	          if (!hasUserSettings) {
	            _context2.next = 16;
	            break;
	          }
	
	          _context2.next = 11;
	          return (0, _effects.select)(_userSettingsSelectors.getSettingsId);
	
	        case 11:
	          settingsId = _context2.sent;
	          _context2.next = 14;
	          return (0, _effects.call)(_users.updateUserSettings, settingsId, data);
	
	        case 14:
	          _context2.next = 22;
	          break;
	
	        case 16:
	          _context2.next = 18;
	          return (0, _effects.call)(_users.createUserSettings, data);
	
	        case 18:
	          userSettings = _context2.sent;
	          _context2.next = 21;
	          return (0, _effects.call)(_users.saveUserSettings, userId, userSettings);
	
	        case 21:
	          updatedUser = _context2.sent;
	
	        case 22:
	          _context2.next = 24;
	          return (0, _effects.put)({ type: _constants2.UPDATE_SETTINGS_SUCCESS, data: data });
	
	        case 24:
	          _context2.next = 26;
	          return (0, _effects.put)({ type: _constants.SET_STATUS_BAR, message: 'Settings updated successfully.', colour: 'green' });
	
	        case 26:
	          scroll.scrollToTop();
	
	          _context2.next = 37;
	          break;
	
	        case 29:
	          _context2.prev = 29;
	          _context2.t0 = _context2['catch'](0);
	
	          (0, _errorHandlingService.reportError)('UPDATE_SETTINGS_ERROR', _context2.t0.message);
	          _context2.next = 34;
	          return (0, _effects.put)({ type: _constants.SET_STATUS_BAR, message: 'Failed to update settings, please try again.', colour: 'red' });
	
	        case 34:
	          scroll.scrollToTop();
	          _context2.next = 37;
	          return (0, _effects.put)({ type: _constants2.UPDATE_SETTINGS_ERROR, error: _context2.t0.message });
	
	        case 37:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 29]]);
	}
	
	function watchLoadSettings() {
	  return _regenerator2.default.wrap(function watchLoadSettings$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants2.LOAD_SETTINGS, loadSettings);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function watchUpdateSettings() {
	  return _regenerator2.default.wrap(function watchUpdateSettings$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _reduxSaga.takeLatest)(_constants2.UPDATE_SETTINGS, updateSettings);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function userSettingsSagas() {
	  return _regenerator2.default.wrap(function userSettingsSagas$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(watchLoadSettings), (0, _effects.fork)(watchUpdateSettings)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 2241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateUser = updateUser;
	exports.clearUser = clearUser;
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _metricAnalyticsService = __webpack_require__(119);
	
	var _constants = __webpack_require__(566);
	
	var _authService = __webpack_require__(21);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _resources = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateUser(userData) {
	  var _ThemeSelector$theme = _themeSelector2.default.theme(),
	      disableIntercom = _ThemeSelector$theme.disableIntercom;
	
	  var extractedUserData = {
	    id: userData.app_metadata ? userData.app_metadata.dyzio.u_id : '',
	    organisationId: userData.app_metadata ? userData.app_metadata.dyzio.o_id : '',
	    auth0_id: userData.user_id,
	    email: userData.email || _lodash2.default.get(userData, 'app_metadata.dyzio.email', null),
	    name: userData.name || _lodash2.default.get(userData, 'app_metadata.dyzio.name', null),
	    version: userData.app_metadata.dyzio.version,
	    nickname: userData.nickname,
	    picture: userData.picture,
	    role: userData.app_metadata ? userData.app_metadata.dyzio.role : 'blah'
	  };
	
	  var jsonAPIClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	    header: {
	      Authorization: 'Bearer ' + _authService.authService.getToken()
	    }
	  });
	
	  var intercomName = extractedUserData.name;
	  var emailIdentifier = '@';
	
	  var isNameEmailAddress = _lodash2.default.includes(intercomName, emailIdentifier);
	  var hostname = window.location.hostname;
	  // check the created date here?
	  // version the users?
	
	  jsonAPIClient.get(_resources.ORGANISATION_RESOURCE, extractedUserData.organisationId).then(function (organisationResource) {
	    var organisation = organisationResource.toJSON();
	    var userDto = {
	      app_id: 'xef2tjr2',
	      name: isNameEmailAddress ? '' : intercomName,
	      email: extractedUserData.email,
	      user_id: extractedUserData.id,
	      apples: 10,
	      hostname: hostname,
	      role: extractedUserData.role,
	      company: {
	        id: extractedUserData.organisationId,
	        name: organisation.name,
	        plan: organisation.licenseSubscriptionType,
	        monthly_spend: organisation.licenseSubscriptionAmount,
	        org_type: organisation.orgType,
	        remote_created_at: (0, _moment2.default)(organisation.createdDate).unix()
	      }
	    };
	
	    var pickedUserDto = _lodash2.default.pickBy(userDto);
	
	    var _window = window,
	        mixpanel = _window.mixpanel;
	
	    if (mixpanel) {
	      mixpanel.identify(extractedUserData.id);
	      mixpanel.people.set({
	        $email: extractedUserData.email,
	        name: extractedUserData.name,
	        role: extractedUserData.role,
	        organisationId: extractedUserData.organisationId
	      });
	    }
	
	    window.dataLayer = window.dataLayer || [];
	    var dataLayerInfo = {
	      visitorStatus: 'logged-in',
	      registeredDays: (0, _moment2.default)().diff(organisation.createdDate, 'days'),
	      activityScore: organisation.activityScore,
	      userId: userDto.user_id,
	      companyName: userDto.company.name
	    };
	
	    window.dataLayer.push(dataLayerInfo);
	
	    if (extractedUserData.version > 1) {
	      pickedUserDto.user_id = extractedUserData.id;
	    }
	    if (!disableIntercom) {
	      window.Intercom('boot', pickedUserDto);
	    }
	    return true;
	  }).catch(function (err) {
	    (0, _errorHandlingService.reportError)('ERROR_FETCHING_ORG_FOR_ROLLBAR', err);
	  });
	
	  var trackUserData = {
	    id: userData.app_metadata ? userData.app_metadata.dyzio.u_id : '',
	    email: userData.email,
	    username: userData.name
	  };
	
	  (0, _errorHandlingService.configureRollbarUser)(trackUserData);
	  // configureAppcuesUser(trackUserData);
	  (0, _metricAnalyticsService.identifyUser)(trackUserData);
	
	  return {
	    type: _constants.UPDATE_USER,
	    user: extractedUserData
	  };
	}
	
	function clearUser() {
	  return {
	    type: _constants.CLEAR_USER
	  };
	}

/***/ },
/* 2242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _constants = __webpack_require__(566);
	
	var initialState = (0, _immutable.fromJS)({
	  currentUser: null,
	  userData: (0, _immutable.fromJS)({
	    id: null,
	    organisationId: null,
	    auth0_id: null,
	    email: null,
	    name: null,
	    nickname: null,
	    picture: null,
	    roles: []
	  }),
	  userLoaded: false
	});
	
	function userReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.UPDATE_USER:
	      return state.set('currentUser', action.user.name).setIn(['userData', 'id'], action.user.id).setIn(['userData', 'organisationId'], action.user.organisationId).setIn(['userData', 'auth0_id'], action.user.auth0_id).setIn(['userData', 'email'], action.user.email).setIn(['userData', 'name'], action.user.name).setIn(['userData', 'nickname'], action.user.nickname).setIn(['userData', 'picture'], action.user.picture).setIn(['userData', 'roles'], action.user.roles).set('userLoaded', true);
	    case _constants.CLEAR_USER:
	      return initialState;
	    default:
	      return state;
	  }
	}
	
	exports.default = userReducer;

/***/ },
/* 2243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.mapDispatchToProps = mapDispatchToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(28);
	
	var _recompose = __webpack_require__(15);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _header = __webpack_require__(348);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _originBasedLock = __webpack_require__(890);
	
	var _originBasedLock2 = _interopRequireDefault(_originBasedLock);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var User = function (_React$Component) {
	  _inherits(User, _React$Component);
	
	  function User() {
	    _classCallCheck(this, User);
	
	    return _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).apply(this, arguments));
	  }
	
	  _createClass(User, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // this.props.onSetupSendbirdUser();
	      // this.props.onLoadOnboardingState();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(_header2.default, null),
	        this.props.children
	      );
	    }
	  }]);
	
	  return User;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    requiredOrigin: _lodash2.default.get(state, 'user.user.organisation.origin'),
	    organisationName: _lodash2.default.get(state, 'user.user.organisation.name')
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    // onSetupSendbirdUser: () => dispatch(setupSendbirdUser()),
	    // onLoadOnboardingState: () => dispatch(loadOnboardingState()),
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _recompose.compose)(_hasUserInfo2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(User);

/***/ },
/* 2244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var descriptionStyle = {
	  maxWidth: 290,
	  marginTop: 10
	};
	
	var commentsWrapper = {
	  height: 200,
	  overflowY: 'scroll'
	};
	
	var loaderStyle = {
	  height: 200
	};
	
	var marginTop20 = {
	  marginTop: 20,
	  display: 'block'
	};
	
	var iconStyle = {
	  marginTop: 10,
	  marginRight: 20,
	  border: 'none'
	};
	
	var Comments = function (_React$Component) {
	  _inherits(Comments, _React$Component);
	
	  //
	  function Comments() {
	    var _this2 = this;
	
	    _classCallCheck(this, Comments);
	
	    var _this = _possibleConstructorReturn(this, (Comments.__proto__ || Object.getPrototypeOf(Comments)).call(this));
	
	    _this.loadAsset = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var restClient, assetId, asset;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              restClient = _this.props.restClient;
	              assetId = _lodash2.default.get(_this.props, 'trackedAssetId');
	              _context.next = 4;
	              return restClient.get('trackedAssets/' + assetId);
	
	            case 4:
	              asset = _context.sent;
	
	              _this.setState({
	                asset: _lodash2.default.get(asset, 'data.data')
	              });
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.toggleCommentFavouriteState = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(comment) {
	        var restClient, assetId, comments, isFavourited, updatedComments;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                restClient = _this.props.restClient;
	                assetId = _lodash2.default.get(_this.props, 'trackedAssetId');
	                comments = _lodash2.default.get(_this.state, 'asset.attributes.featuredComments', []);
	                isFavourited = _lodash2.default.find(comments, ['id', comment.id]);
	                updatedComments = _lodash2.default.clone(comments);
	
	                if (isFavourited) {
	                  updatedComments = _lodash2.default.reject(updatedComments, ['id', comment.id]);
	                } else {
	                  updatedComments.push(comment);
	                }
	                _context2.next = 8;
	                return restClient.patch('trackedAssets/' + assetId, {
	                  data: {
	                    attributes: {
	                      featuredComments: updatedComments
	                    }
	                  }
	                });
	
	              case 8:
	                _context2.next = 10;
	                return _this.loadAsset();
	
	              case 10:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      asset: null,
	      comments: [],
	      isLoading: true,
	      canFetchComments: true
	    };
	    return _this;
	  }
	
	  _createClass(Comments, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var buildRESTClient, facebookMediaId, influencerId, apiClient, response;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                buildRESTClient = this.props.buildRESTClient;
	                facebookMediaId = _lodash2.default.get(this.props, 'facebookMediaId');
	                influencerId = _lodash2.default.get(this.props, 'influencer.id');
	                _context3.next = 5;
	                return this.loadAsset();
	
	              case 5:
	                if (!(facebookMediaId && influencerId)) {
	                  _context3.next = 13;
	                  break;
	                }
	
	                apiClient = buildRESTClient({
	                  baseURL: ("https://qa4ui1tue5.execute-api.eu-west-1.amazonaws.com/production"),
	                  hasToken: false
	                });
	                _context3.next = 9;
	                return apiClient.get('/influencer/' + influencerId + '/media/' + facebookMediaId + '/comments');
	
	              case 9:
	                response = _context3.sent;
	
	                this.setState({
	                  comments: _lodash2.default.get(response, 'data.data.data', []),
	                  isLoading: false
	                });
	                _context3.next = 14;
	                break;
	
	              case 13:
	                this.setState({
	                  isLoading: false,
	                  canFetchComments: false
	                });
	
	              case 14:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function componentDidMount() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          comments = _state.comments,
	          isLoading = _state.isLoading,
	          asset = _state.asset;
	
	      var featuredComments = _lodash2.default.get(asset, 'attributes.featuredComments', []);
	      return _react2.default.createElement(
	        'div',
	        null,
	        isLoading && _react2.default.createElement(
	          'div',
	          { style: loaderStyle },
	          _react2.default.createElement(_semanticUiReact.Loader, { style: marginTop20, active: true, content: 'Loading comments...' })
	        ),
	        !isLoading && _react2.default.createElement(
	          _semanticUiReact.List,
	          { relaxed: 'very', style: commentsWrapper },
	          _lodash2.default.map(comments, function (comment) {
	            return _react2.default.createElement(
	              _semanticUiReact.List.Item,
	              { key: _lodash2.default.get(comment, 'id') },
	              _react2.default.createElement(
	                _semanticUiReact.List.Content,
	                { floated: 'right' },
	                _react2.default.createElement(_semanticUiReact.Button, {
	                  circular: true,
	                  basic: 'very',
	                  icon: 'favorite',
	                  style: iconStyle,
	                  color: _lodash2.default.find(featuredComments, ['id', comment.id]) ? 'orange' : 'grey',
	                  onClick: function onClick() {
	                    return _this3.toggleCommentFavouriteState(comment);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.List.Content,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.List.Header,
	                  { as: 'span' },
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    _lodash2.default.get(comment, 'username')
	                  ),
	                  ' ',
	                  _react2.default.createElement(
	                    'small',
	                    null,
	                    (0, _moment2.default)(_lodash2.default.get(comment, 'timestamp')).format('ddd D MMM hh:mm')
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.List.Description,
	                  { style: descriptionStyle },
	                  _lodash2.default.get(comment, 'text')
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return Comments;
	}(_react2.default.Component);
	
	exports.default = (0, _hasRestClient2.default)(Comments);

/***/ },
/* 2245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(37);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _hasRestClient = __webpack_require__(22);
	
	var _hasRestClient2 = _interopRequireDefault(_hasRestClient);
	
	var _hasUserInfo = __webpack_require__(23);
	
	var _hasUserInfo2 = _interopRequireDefault(_hasUserInfo);
	
	var _verticalInfluencerBar = __webpack_require__(900);
	
	var _verticalInfluencerBar2 = _interopRequireDefault(_verticalInfluencerBar);
	
	var _instagramPost = __webpack_require__(2246);
	
	var _instagramPost2 = _interopRequireDefault(_instagramPost);
	
	var _instagramStory = __webpack_require__(2247);
	
	var _instagramStory2 = _interopRequireDefault(_instagramStory);
	
	var _adsModal = __webpack_require__(922);
	
	var _adsModal2 = _interopRequireDefault(_adsModal);
	
	var _existingAds = __webpack_require__(567);
	
	var _existingAds2 = _interopRequireDefault(_existingAds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var backButtonStyle = {
	  border: '0px solid #1d1937'
	};
	
	var adsLinkStyle = {
	  post: {
	    width: '200px'
	  },
	  story: {
	    width: '400px'
	  }
	};
	
	var ViewAssetPage = function (_PureComponent) {
	  _inherits(ViewAssetPage, _PureComponent);
	
	  //
	  function ViewAssetPage(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ViewAssetPage);
	
	    var _this = _possibleConstructorReturn(this, (ViewAssetPage.__proto__ || Object.getPrototypeOf(ViewAssetPage)).call(this, props));
	
	    _this.returnToCollaboration = function () {
	      var history = _this.props.history;
	
	      history.goBack();
	    };
	
	    _this.toggleAdsModalState = function () {
	      _this.setState({
	        adsModalOpen: !_this.state.adsModalOpen
	      });
	    };
	
	    _this.updateAssetLinkedAds = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref2) {
	        var assetType = _ref2.assetType,
	            assetId = _ref2.assetId,
	            linkedAds = _ref2.linkedAds;
	        var restClient, updatedAssetResponse;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                restClient = _this.props.restClient;
	                _context.next = 3;
	                return restClient.patch(assetType + '/' + assetId, {
	                  data: {
	                    attributes: {
	                      linkedAds: linkedAds
	                    }
	                  }
	                });
	
	              case 3:
	                updatedAssetResponse = _context.sent;
	
	                _this.setState({
	                  asset: _lodash2.default.get(updatedAssetResponse, 'data.data'),
	                  processedAdId: null
	                });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.unlinkAd = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(adId) {
	        var asset, linkedAds, updatedAds, assetType, assetId;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                asset = _this.state.asset;
	
	                _this.setState({
	                  processedAdId: adId
	                });
	                linkedAds = _lodash2.default.get(asset, 'attributes.linkedAds', []);
	                updatedAds = _lodash2.default.reject(linkedAds, ['id', adId]);
	                assetType = _lodash2.default.get(asset, 'type');
	                assetId = _lodash2.default.get(asset, 'id');
	                _context2.next = 8;
	                return _this.updateAssetLinkedAds({
	                  assetType: assetType,
	                  assetId: assetId,
	                  linkedAds: updatedAds
	                });
	
	              case 8:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.linkAd = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(adId) {
	        var _this$state, ads, asset, adToLink, fields, existingAds, assetType, assetId;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this.setState({
	                  processedAdId: adId
	                });
	                _this$state = _this.state, ads = _this$state.ads, asset = _this$state.asset;
	                adToLink = _lodash2.default.find(_lodash2.default.get(ads, 'ads', []), ['ad.id', adId]);
	                fields = {
	                  id: adId,
	                  objectType: _lodash2.default.get(adToLink, 'ad.creative.object_type'),
	                  name: _lodash2.default.get(adToLink, 'ad.campaign.name'),
	                  campaignName: _lodash2.default.get(adToLink, 'ad.campaign.name'),
	                  adName: _lodash2.default.get(adToLink, 'ad.name'),
	                  thumbnail: _lodash2.default.get(adToLink, 'ad.creative.thumbnail_url')
	                };
	                existingAds = _lodash2.default.get(asset, 'attributes.linkedAds', []);
	
	                existingAds.push(fields);
	                assetType = _lodash2.default.get(asset, 'type');
	                assetId = _lodash2.default.get(asset, 'id');
	                _context3.next = 10;
	                return _this.updateAssetLinkedAds({
	                  assetType: assetType,
	                  assetId: assetId,
	                  linkedAds: existingAds
	                });
	
	              case 10:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x3) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      isLoading: true,
	      isLoadingAds: true,
	      processedAdId: null,
	      adsModalOpen: false,
	      failedToLoad: false,
	      failedToLoadAds: false,
	      asset: null,
	      ads: [],
	      campaign: null
	    };
	    return _this;
	  }
	
	  _createClass(ViewAssetPage, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this3 = this;
	
	        var _props, routeParams, restClient, buildRESTClient, assetId, assetType, resourceURL, response, data, included, campaign, influencer, shareAPIClient, adsResponse, ads;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _props = this.props, routeParams = _props.routeParams, restClient = _props.restClient, buildRESTClient = _props.buildRESTClient;
	                assetId = _lodash2.default.get(routeParams, 'assetId');
	                assetType = _lodash2.default.get(routeParams, 'assetType');
	                resourceURL = _lodash2.default.eq(assetType, 'story') ? 'stories' : 'trackedAssets';
	                _context4.next = 6;
	                return restClient.get(resourceURL + '/' + assetId + '?include=campaign,discussion,discussion.organisations.influencer').catch(function () {
	                  _this3.setState({
	                    isLoading: false,
	                    failedToLoad: true
	                  });
	                });
	
	              case 6:
	                response = _context4.sent;
	
	                if (!response) {
	                  _context4.next = 19;
	                  break;
	                }
	
	                data = _lodash2.default.get(response, 'data.data');
	                included = _lodash2.default.get(response, 'data.included');
	                campaign = _lodash2.default.find(included, { type: 'campaigns' });
	                influencer = _lodash2.default.find(included, { type: 'influencer' });
	
	                this.setState({
	                  asset: data,
	                  isLoading: false,
	                  failedToLoad: false,
	                  campaign: campaign,
	                  influencer: influencer
	                });
	                shareAPIClient = buildRESTClient({
	                  baseURL: ("https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production"),
	                  hasToken: true
	                });
	                _context4.next = 16;
	                return shareAPIClient.get('/marketing/campaign/by-id/' + campaign.id).catch(function () {
	                  _this3.setState({
	                    failedToLoadAds: true
	                  });
	                });
	
	              case 16:
	                adsResponse = _context4.sent;
	                ads = _lodash2.default.get(adsResponse, 'data.data', []);
	
	                this.setState({
	                  ads: ads,
	                  isLoadingAds: false,
	                  failedToLoadAds: _lodash2.default.has(adsResponse, 'data.errorType')
	                });
	
	              case 19:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          asset = _state.asset,
	          campaign = _state.campaign,
	          influencer = _state.influencer,
	          isLoading = _state.isLoading,
	          adsModalOpen = _state.adsModalOpen,
	          ads = _state.ads,
	          processedAdId = _state.processedAdId,
	          failedToLoadAds = _state.failedToLoadAds;
	
	      var existingAds = _lodash2.default.get(asset, 'attributes.linkedAds', []);
	      var isInstagramPost = _lodash2.default.get(asset, 'attributes.platform') === 'INSTAGRAM' && _lodash2.default.get(asset, 'type') !== _instagramStory.STORY_TYPE;
	      var isInstagramStory = _lodash2.default.get(asset, 'type') === _instagramStory.STORY_TYPE;
	      var verticalBarProps = _lodash2.default.get(influencer, 'attributes', {});
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page-content' },
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: '4' },
	                _react2.default.createElement(
	                  _semanticUiReact.Card,
	                  { fluid: true },
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    null,
	                    _react2.default.createElement(_dyzioButtons.DyzioSecondaryButton, {
	                      label: 'back to list',
	                      icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'arrow left' }),
	                      style: backButtonStyle,
	                      hasIcon: true,
	                      onClick: this.returnToCollaboration,
	                      fluid: true
	                    })
	                  )
	                ),
	                _react2.default.createElement(_verticalInfluencerBar2.default, Object.assign({}, verticalBarProps, { isLoading: isLoading })),
	                _react2.default.createElement(
	                  _semanticUiReact.Card,
	                  { fluid: true },
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Content,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Button, { fluid: true, inverted: true, color: 'blue', content: 'Link Facebook Ads', onClick: this.toggleAdsModalState })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                { width: '12' },
	                isInstagramPost && _react2.default.createElement(_instagramPost2.default, {
	                  asset: asset,
	                  influencer: influencer,
	                  campaign: campaign,
	                  ads: existingAds,
	                  unlinkAd: this.unlinkAd
	                }),
	                isInstagramStory && _react2.default.createElement(_instagramStory2.default, {
	                  story: asset,
	                  ads: existingAds,
	                  unlinkAd: this.unlinkAd
	                })
	              )
	            )
	          )
	        ),
	        adsModalOpen && _react2.default.createElement(_adsModal2.default, {
	          linkAd: this.linkAd,
	          onClose: this.toggleAdsModalState,
	          ads: ads,
	          existingAds: existingAds,
	          processedAdId: processedAdId,
	          failedToLoadAds: failedToLoadAds
	        })
	      );
	    }
	  }]);
	
	  return ViewAssetPage;
	}(_react.PureComponent);
	
	ViewAssetPage.propTypes = {
	  history: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_hasRestClient2.default, _hasUserInfo2.default, _reactRouter.withRouter)(ViewAssetPage);

/***/ },
/* 2246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _textHighlighter = __webpack_require__(378);
	
	var _textHighlighter2 = _interopRequireDefault(_textHighlighter);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(3);
	
	var _dyzioInstagramEmbed = __webpack_require__(346);
	
	var _dyzioInstagramEmbed2 = _interopRequireDefault(_dyzioInstagramEmbed);
	
	var _dyzioButtons = __webpack_require__(73);
	
	var _hashtagsUtils = __webpack_require__(232);
	
	var _formatting = __webpack_require__(62);
	
	var _trackedAssetsAnalyticsService = __webpack_require__(173);
	
	var _comments = __webpack_require__(2244);
	
	var _comments2 = _interopRequireDefault(_comments);
	
	var _existingAds = __webpack_require__(567);
	
	var _existingAds2 = _interopRequireDefault(_existingAds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCaption = function getCaption(asset) {
	  if (_lodash2.default.has(asset, 'attributes.initialData.standardFormat.text')) {
	    var caption = _lodash2.default.get(asset, 'attributes.initialData.standardFormat.text');
	    return caption;
	  }
	  return 'No caption';
	};
	
	var avatarStyle = {
	  width: 50,
	  height: 50,
	  float: 'left',
	  margin: '10px',
	  backgroundColor: 'gray',
	  display: 'inline-block'
	};
	
	var handleStyle = {
	  padding: '15px 5px 5px 5px',
	  marginLeft: 5,
	  float: 'left',
	  display: 'inline-block',
	  fontSize: 16
	};
	
	var captionBoxStyle = {
	  whiteSpace: 'pre-wrap'
	};
	
	var textCentered = {
	  textAlign: 'center'
	};
	
	var shareButtonStyle = {
	  border: '0px solid #1d1937'
	};
	
	var noPadding = {
	  padding: '0'
	};
	
	var InstagramPost = function (_React$Component) {
	  _inherits(InstagramPost, _React$Component);
	
	  function InstagramPost() {
	    _classCallCheck(this, InstagramPost);
	
	    var _this = _possibleConstructorReturn(this, (InstagramPost.__proto__ || Object.getPrototypeOf(InstagramPost)).call(this));
	
	    _this.state = {
	      privateData: null,
	      isLoadingPrivateData: true
	    };
	    return _this;
	  }
	
	  _createClass(InstagramPost, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var asset, trackedAssetId, attributes, analyticsPayload, response, record, privateData;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                asset = this.props.asset;
	                trackedAssetId = asset.id;
	
	                console.log('ta => ' + trackedAssetId);
	                attributes = _lodash2.default.get(asset, 'attributes');
	                analyticsPayload = _extends({
	                  id: _lodash2.default.get(asset, 'id'),
	                  type: _lodash2.default.get(asset, 'type')
	                }, attributes);
	                _context.next = 7;
	                return (0, _trackedAssetsAnalyticsService.getTrackedAssetAnalytics)([analyticsPayload]);
	
	              case 7:
	                response = _context.sent;
	                record = _lodash2.default.head(response);
	                privateData = _lodash2.default.get(record, 'response.data', {});
	
	                this.setState({
	                  isLoadingPrivateData: false,
	                  privateData: privateData,
	                  trackedAssetId: trackedAssetId
	                });
	
	              case 11:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          asset = _props.asset,
	          campaign = _props.campaign,
	          influencer = _props.influencer,
	          ads = _props.ads,
	          unlinkAd = _props.unlinkAd;
	      var _state = this.state,
	          privateData = _state.privateData,
	          trackedAssetId = _state.trackedAssetId;
	
	      var assetURL = _lodash2.default.get(asset, 'attributes.assetURL');
	      var assetId = _lodash2.default.get(asset, 'attributes.assetId');
	      var caption = getCaption(asset);
	      var hashtags = (0, _hashtagsUtils.transformHashtagstIntoArray)(_lodash2.default.get(campaign, 'attributes.hashtags'), '');
	
	      var _$get = _lodash2.default.get(influencer, 'attributes'),
	          instagramThumbnail = _$get.instagramThumbnail,
	          instagram = _$get.instagram,
	          instagramCount = _$get.instagramCount;
	
	      var reach = 1.1 * (_lodash2.default.get(privateData, 'latestInsights.reach') || _lodash2.default.get(privateData, 'latestStatistic.playCount') || _lodash2.default.get(privateData, 'latestStatistic.viewCount'));
	
	      var impressions = 1.3 * (_lodash2.default.get(privateData, 'latestInsights.impressions') || _lodash2.default.get(privateData, 'latestStatistic.playCount') || _lodash2.default.get(privateData, 'latestStatistic.viewCount'));
	
	      var engagements = _lodash2.default.get(privateData, 'latestInsights.engagement') || _lodash2.default.get(privateData, 'latestStatistic.likeCount', 0) + _lodash2.default.get(privateData, 'latestStatistic.commentCount', 0);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: '9' },
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(_dyzioButtons.DyzioSecondaryButton, {
	                    label: 'open asset in new tab',
	                    icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'share' }),
	                    style: shareButtonStyle,
	                    hasIcon: true,
	                    onClick: function onClick() {
	                      return window.open(assetURL, '_blank');
	                    },
	                    fluid: true
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Grid,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Grid.Row,
	                      null,
	                      _react2.default.createElement(_semanticUiReact.Image, {
	                        src: instagramThumbnail,
	                        className: 'circular',
	                        size: 'tiny',
	                        style: avatarStyle
	                      }),
	                      _react2.default.createElement(
	                        'div',
	                        { style: handleStyle },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          _lodash2.default.truncate(instagram, {
	                            length: 15
	                          })
	                        ),
	                        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	                        (0, _formatting.commaFormatted)(instagramCount),
	                        ' followers'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  { style: noPadding },
	                  _react2.default.createElement(_dyzioInstagramEmbed2.default, { maxWidth: true, assetId: assetId })
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(_existingAds2.default, { ads: ads, unlinkAd: unlinkAd })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: '7' },
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Header,
	                    null,
	                    'Instagram Metrics'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    { basic: 'very' },
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Body,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          'reach'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          (0, _formatting.commaFormatted)(reach)
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          'impressions'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          (0, _formatting.commaFormatted)(impressions)
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          'engagement'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          (0, _formatting.commaFormatted)(engagements)
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Row,
	                        null,
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          'saved'
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.Table.Cell,
	                          null,
	                          (0, _formatting.commaFormatted)(_lodash2.default.get(privateData, 'latestInsights.saved', _lodash2.default.get(privateData, 'latestStatistic.saved', 0)))
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Header,
	                    null,
	                    'Caption'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Meta,
	                    null,
	                    'highlighted text shows hashtag matches'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(_textHighlighter2.default, { style: captionBoxStyle, text: caption !== 'No caption' ? caption : _lodash2.default.get(privateData, 'text', caption), words: hashtags })
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Card,
	                { fluid: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Header,
	                    null,
	                    'Comments'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Card.Meta,
	                    null,
	                    'click star to favourite the comment'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Card.Content,
	                  null,
	                  privateData && _react2.default.createElement(_comments2.default, Object.assign({}, privateData, { influencer: influencer, trackedAssetId: trackedAssetId }))
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InstagramPost;
	}(_react2.default.Component);
	
	InstagramPost.propTypes = {
	  asset: _propTypes2.default.object.isRequired,
	  campaign: _propTypes2.default.object.isRequired,
	  influencer: _propTypes2.default.object.isRequired
	};
	
	exports.default = InstagramPost;

/***/ },
/* 2247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STORY_TYPE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _instagramStory = __webpack_require__(599);
	
	var _instagramStory2 = _interopRequireDefault(_instagramStory);
	
	var _existingAds = __webpack_require__(567);
	
	var _existingAds2 = _interopRequireDefault(_existingAds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STORY_TYPE = exports.STORY_TYPE = 'stories';
	
	var fluidStyle = {
	  width: '100%'
	};
	
	var InstagramStory = function (_React$Component) {
	  _inherits(InstagramStory, _React$Component);
	
	  function InstagramStory() {
	    _classCallCheck(this, InstagramStory);
	
	    var _this = _possibleConstructorReturn(this, (InstagramStory.__proto__ || Object.getPrototypeOf(InstagramStory)).call(this));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(InstagramStory, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          story = _props.story,
	          ads = _props.ads,
	          unlinkAd = _props.unlinkAd;
	
	      var storyAttributes = _lodash2.default.get(story, 'attributes');
	      var sharedComponentProps = _extends({
	        id: _lodash2.default.get(story, 'id'),
	        type: _lodash2.default.get(story, 'type')
	      }, storyAttributes);
	      return _react2.default.createElement(
	        'div',
	        { style: fluidStyle },
	        _react2.default.createElement(_instagramStory2.default, Object.assign({ expanded: true, fluid: true }, sharedComponentProps, { handlesCampaignAdd: false })),
	        _react2.default.createElement(_existingAds2.default, { ads: ads, unlinkAd: unlinkAd })
	      );
	    }
	  }]);
	
	  return InstagramStory;
	}(_react2.default.Component);
	
	InstagramStory.propTypes = {
	  story: _propTypes2.default.object.isRequired,
	  ads: _propTypes2.default.array,
	  unlinkAd: _propTypes2.default.func
	};
	
	InstagramStory.defaultProps = {
	  ads: [],
	  unlinkAd: _lodash2.default.noop
	};
	
	exports.default = InstagramStory;

/***/ },
/* 2248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withInfluencerData = function withInfluencerData(WrapperComponent) {
	  return function (_Component) {
	    _inherits(HasJSONAPIClient, _Component);
	
	    function HasJSONAPIClient(props) {
	      _classCallCheck(this, HasJSONAPIClient);
	
	      var _this = _possibleConstructorReturn(this, (HasJSONAPIClient.__proto__ || Object.getPrototypeOf(HasJSONAPIClient)).call(this, props));
	
	      _this.getInfluencerById = function (id) {
	        return _this.restClient.get('influencer/' + id).then(function (response) {
	          var _response$data$data = response.data.data,
	              influencerId = _response$data$data.id,
	              attributes = _response$data$data.attributes;
	
	          return _extends({ id: influencerId }, attributes);
	        });
	      };
	
	      _this.restClient = _axios2.default.create({
	        baseURL: ("https://api2.dyzio.co/v1"),
	        timeout: 6000,
	        headers: {
	          'Content-Type': 'application/json',
	          Authorization: 'Bearer ' + _authService.authService.getToken()
	        }
	      });
	      return _this;
	    }
	
	    _createClass(HasJSONAPIClient, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, {
	          getInfluencerById: this.getInfluencerById
	        }));
	      }
	    }]);
	
	    return HasJSONAPIClient;
	  }(_react.Component);
	};
	
	exports.default = withInfluencerData;

/***/ },
/* 2249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withOrganisationData = function withOrganisationData(WrapperComponent) {
	  return function (_Component) {
	    _inherits(HasJSONAPIClient, _Component);
	
	    function HasJSONAPIClient(props) {
	      _classCallCheck(this, HasJSONAPIClient);
	
	      var _this = _possibleConstructorReturn(this, (HasJSONAPIClient.__proto__ || Object.getPrototypeOf(HasJSONAPIClient)).call(this, props));
	
	      _this.getOrganisationById = function (id) {
	        return _this.restClient.get('organisations/' + id).then(function (response) {
	          var attributes = response.data.data.attributes;
	
	          return _extends({ id: id }, attributes);
	        });
	      };
	
	      _this.restClient = _axios2.default.create({
	        baseURL: ("https://api2.dyzio.co/v1"),
	        timeout: 6000,
	        headers: {
	          'Content-Type': 'application/json',
	          Authorization: 'Bearer ' + _authService.authService.getToken()
	        }
	      });
	      return _this;
	    }
	
	    _createClass(HasJSONAPIClient, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, {
	          getOrganisationById: this.getOrganisationById
	        }));
	      }
	    }]);
	
	    return HasJSONAPIClient;
	  }(_react.Component);
	};
	
	exports.default = withOrganisationData;

/***/ },
/* 2250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsonapiClient = __webpack_require__(61);
	
	var _jsonapiClient2 = _interopRequireDefault(_jsonapiClient);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withTrackedAssetsData = function withTrackedAssetsData(WrapperComponent) {
	  return function (_Component) {
	    _inherits(HasTrackedAssetsData, _Component);
	
	    function HasTrackedAssetsData(props) {
	      var _this2 = this;
	
	      _classCallCheck(this, HasTrackedAssetsData);
	
	      var _this = _possibleConstructorReturn(this, (HasTrackedAssetsData.__proto__ || Object.getPrototypeOf(HasTrackedAssetsData)).call(this, props));
	
	      _this.createTrackedAsset = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref2) {
	          var assetId = _ref2.assetId,
	              assetURL = _ref2.assetURL,
	              discussionId = _ref2.discussionId,
	              campaignId = _ref2.campaignId,
	              discussionName = _ref2.discussionName,
	              instagramAccountId = _ref2.instagramAccountId,
	              platform = _ref2.platform,
	              assetType = _ref2.assetType;
	          var trackedAsset;
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  trackedAsset = _this.jsonAPIClient.create('trackedAssets');
	
	                  trackedAsset.set('assetId', assetId);
	                  trackedAsset.set('assetURL', assetURL);
	                  trackedAsset.set('user', {
	                    type: 'users',
	                    id: _authService.authService.uid()
	                  });
	                  trackedAsset.set('campaign', {
	                    type: 'campaigns',
	                    id: campaignId
	                  });
	                  trackedAsset.set('discussion', {
	                    type: 'discussions',
	                    id: discussionId
	                  });
	                  trackedAsset.set('discussionName', discussionName);
	                  if (platform === 'INSTAGRAM') trackedAsset.set('instagramAccountId', instagramAccountId);
	                  trackedAsset.set('platform', platform);
	                  trackedAsset.set('assetType', assetType);
	                  trackedAsset.set('createdSource', 'CAMPAIGN');
	                  return _context.abrupt('return', trackedAsset.sync().then(function (response) {
	                    return response.toJSON();
	                  }));
	
	                case 12:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }();
	
	      _this.syncTrackedAssetAndDiscussion = function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(_ref4) {
	          var discussionId = _ref4.discussionId,
	              trackedAssetId = _ref4.trackedAssetId;
	          var discussion, trackedAsset;
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  _context2.next = 2;
	                  return _this.jsonAPIClient.get('discussions', discussionId);
	
	                case 2:
	                  discussion = _context2.sent;
	                  _context2.next = 5;
	                  return _this.jsonAPIClient.get('trackedAssets', trackedAssetId);
	
	                case 5:
	                  trackedAsset = _context2.sent;
	
	                  discussion.set('hasPosted', true);
	                  return _context2.abrupt('return', discussion.relationships('trackedAssets').add(trackedAsset).sync());
	
	                case 8:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this2);
	        }));
	
	        return function (_x2) {
	          return _ref3.apply(this, arguments);
	        };
	      }();
	
	      _this.removeTrackedAssetById = function () {
	        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(trackedAssetId) {
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  return _context3.abrupt('return', _this.jsonAPIClient.get('trackedAssets', trackedAssetId).then(function (resource) {
	                    return resource.delete();
	                  }));
	
	                case 1:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this2);
	        }));
	
	        return function (_x3) {
	          return _ref5.apply(this, arguments);
	        };
	      }();
	
	      _this.removeTrackedAssetFromDiscussionById = function () {
	        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(_ref7) {
	          var discussionId = _ref7.discussionId,
	              trackedAssetId = _ref7.trackedAssetId;
	          var discussion, trackedAsset;
	          return _regenerator2.default.wrap(function _callee4$(_context4) {
	            while (1) {
	              switch (_context4.prev = _context4.next) {
	                case 0:
	                  _context4.next = 2;
	                  return _this.jsonAPIClient.get('discussions', discussionId);
	
	                case 2:
	                  discussion = _context4.sent;
	                  _context4.next = 5;
	                  return _this.jsonAPIClient.get('trackedAssets', trackedAssetId);
	
	                case 5:
	                  trackedAsset = _context4.sent;
	                  return _context4.abrupt('return', discussion.relationships('trackedAssets').remove(trackedAsset).sync());
	
	                case 7:
	                case 'end':
	                  return _context4.stop();
	              }
	            }
	          }, _callee4, _this2);
	        }));
	
	        return function (_x4) {
	          return _ref6.apply(this, arguments);
	        };
	      }();
	
	      _this.jsonAPIClient = new _jsonapiClient2.default(("https://api2.dyzio.co/v1"), {
	        header: {
	          Authorization: 'Bearer ' + _authService.authService.getToken()
	        }
	      });
	      return _this;
	    }
	
	    _createClass(HasTrackedAssetsData, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrapperComponent, Object.assign({}, this.props, {
	          removeTrackedAssetFromDiscussionById: this.removeTrackedAssetFromDiscussionById,
	          createTrackedAsset: this.createTrackedAsset,
	          syncTrackedAssetAndDiscussion: this.syncTrackedAssetAndDiscussion,
	          removeTrackedAssetById: this.removeTrackedAssetById
	        }));
	      }
	    }]);
	
	    return HasTrackedAssetsData;
	  }(_react.Component);
	};
	
	exports.default = withTrackedAssetsData;

/***/ },
/* 2251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _errorHandlingService = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prestaShopUrlBase = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production';
	
	var isTugPrestaShopPath = function isTugPrestaShopPath(organisationId) {
	  if (organisationId === 'b847c281-d377-4528-a416-303234e382d8') {
	    return '/tugenuff';
	  }
	  return '';
	};
	
	var getPrestaShopPath = function getPrestaShopPath(discussionId, discountCode, organisationId) {
	  var discountCodePath = discountCode ? '/' + discountCode : '';
	  return '/discussion/' + discussionId + '/prestashop' + isTugPrestaShopPath(organisationId) + '/sales' + discountCodePath;
	};
	
	var getPrestaShopOrdersByDiscussionIdUrl = function getPrestaShopOrdersByDiscussionIdUrl(discussionId, discountCode, organisationId) {
	  return '' + prestaShopUrlBase + getPrestaShopPath(discussionId, discountCode, organisationId);
	};
	
	var getPrestaShopOrdersByDiscussionId = function getPrestaShopOrdersByDiscussionId(_ref) {
	  var discussionId = _ref.discussionId,
	      discountCode = _ref.discountCode,
	      organisationId = _ref.organisationId;
	  return _axios2.default.get(getPrestaShopOrdersByDiscussionIdUrl(discussionId, discountCode, organisationId)).then(function (response) {
	    var data = response.data;
	
	    return data;
	  }).catch(function (err) {
	    (0, _errorHandlingService.reportError)('Unknown error', err);
	    return { data: { orders: [], error: err } };
	  });
	};
	
	module.exports = {
	  getPrestaShopOrdersByDiscussionId: getPrestaShopOrdersByDiscussionId
	};

/***/ },
/* 2252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(76);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(28);
	
	var _reactHelmet = __webpack_require__(3354);
	
	var _redux = __webpack_require__(332);
	
	var _reduxSaga = __webpack_require__(55);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _reactRouter = __webpack_require__(37);
	
	var _reactRouterRedux = __webpack_require__(1555);
	
	var _queryString = __webpack_require__(1427);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactToastify = __webpack_require__(1570);
	
	var _reactRouterScroll = __webpack_require__(3490);
	
	__webpack_require__(2910);
	
	__webpack_require__(2909);
	
	var _authService = __webpack_require__(21);
	
	var _app = __webpack_require__(1873);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _sandbox = __webpack_require__(2194);
	
	var _sandbox2 = _interopRequireDefault(_sandbox);
	
	var _testContainer = __webpack_require__(2216);
	
	var _testContainer2 = _interopRequireDefault(_testContainer);
	
	var _homepage = __webpack_require__(2140);
	
	var _homepage2 = _interopRequireDefault(_homepage);
	
	var _dashboard = __webpack_require__(2102);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _reportList = __webpack_require__(2189);
	
	var _reportList2 = _interopRequireDefault(_reportList);
	
	var _campaign = __webpack_require__(2089);
	
	var _campaign2 = _interopRequireDefault(_campaign);
	
	var _tagsManager = __webpack_require__(919);
	
	var _tagsManager2 = _interopRequireDefault(_tagsManager);
	
	var _tagCloud = __webpack_require__(2209);
	
	var _tagCloud2 = _interopRequireDefault(_tagCloud);
	
	var _acrCampaign = __webpack_require__(2045);
	
	var _acrCampaign2 = _interopRequireDefault(_acrCampaign);
	
	var _pendingInvitations = __webpack_require__(2187);
	
	var _pendingInvitations2 = _interopRequireDefault(_pendingInvitations);
	
	var _campaignNew = __webpack_require__(2084);
	
	var _campaignNew2 = _interopRequireDefault(_campaignNew);
	
	var _viewAssetPage = __webpack_require__(2245);
	
	var _viewAssetPage2 = _interopRequireDefault(_viewAssetPage);
	
	var _campaignUpdate = __webpack_require__(2088);
	
	var _campaignUpdate2 = _interopRequireDefault(_campaignUpdate);
	
	var _campaignMembers = __webpack_require__(2082);
	
	var _campaignMembers2 = _interopRequireDefault(_campaignMembers);
	
	var _campaignMembersManage = __webpack_require__(2079);
	
	var _campaignMembersManage2 = _interopRequireDefault(_campaignMembersManage);
	
	var _discussionCreate = __webpack_require__(2115);
	
	var _discussionCreate2 = _interopRequireDefault(_discussionCreate);
	
	var _collaboration = __webpack_require__(2096);
	
	var _collaboration2 = _interopRequireDefault(_collaboration);
	
	var _userProfile = __webpack_require__(2235);
	
	var _userProfile2 = _interopRequireDefault(_userProfile);
	
	var _userSettings = __webpack_require__(2238);
	
	var _userSettings2 = _interopRequireDefault(_userSettings);
	
	var _mediaKit = __webpack_require__(2170);
	
	var _mediaKit2 = _interopRequireDefault(_mediaKit);
	
	var _login = __webpack_require__(2168);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _signup = __webpack_require__(2205);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _nonAcrCampaignSetup = __webpack_require__(2179);
	
	var _nonAcrCampaignSetup2 = _interopRequireDefault(_nonAcrCampaignSetup);
	
	var _campaignInvite = __webpack_require__(2074);
	
	var _campaignInvite2 = _interopRequireDefault(_campaignInvite);
	
	var _campaignManage = __webpack_require__(2078);
	
	var _campaignManage2 = _interopRequireDefault(_campaignManage);
	
	var _organisationAuditLog = __webpack_require__(2183);
	
	var _organisationAuditLog2 = _interopRequireDefault(_organisationAuditLog);
	
	var _campaignInviteMore = __webpack_require__(2072);
	
	var _campaignInviteMore2 = _interopRequireDefault(_campaignInviteMore);
	
	var _resetPassword = __webpack_require__(2192);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _notFoundPage = __webpack_require__(2005);
	
	var _notFoundPage2 = _interopRequireDefault(_notFoundPage);
	
	var _user = __webpack_require__(2243);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _analytics = __webpack_require__(2055);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _analyticsAsset = __webpack_require__(2053);
	
	var _analyticsAsset2 = _interopRequireDefault(_analyticsAsset);
	
	var _discussionList = __webpack_require__(2121);
	
	var _discussionList2 = _interopRequireDefault(_discussionList);
	
	var _campaignAuditTrail = __webpack_require__(905);
	
	var _campaignAuditTrail2 = _interopRequireDefault(_campaignAuditTrail);
	
	var _campaignDashboard = __webpack_require__(2070);
	
	var _campaignDashboard2 = _interopRequireDefault(_campaignDashboard);
	
	var _deliverable = __webpack_require__(2110);
	
	var _deliverable2 = _interopRequireDefault(_deliverable);
	
	var _onboarding = __webpack_require__(2007);
	
	var _onboarding2 = _interopRequireDefault(_onboarding);
	
	var _payments = __webpack_require__(916);
	
	var _payments2 = _interopRequireDefault(_payments);
	
	var _accessDenied = __webpack_require__(1874);
	
	var _accessDenied2 = _interopRequireDefault(_accessDenied);
	
	var _companySignup = __webpack_require__(2097);
	
	var _companySignup2 = _interopRequireDefault(_companySignup);
	
	var _myInfluencers = __webpack_require__(2173);
	
	var _myInfluencers2 = _interopRequireDefault(_myInfluencers);
	
	var _myCreators = __webpack_require__(2171);
	
	var _myCreators2 = _interopRequireDefault(_myCreators);
	
	var _myCreators3 = __webpack_require__(2172);
	
	var _myCreators4 = _interopRequireDefault(_myCreators3);
	
	var _teamManager = __webpack_require__(2211);
	
	var _teamManager2 = _interopRequireDefault(_teamManager);
	
	var _homePage = __webpack_require__(2139);
	
	var _homePage2 = _interopRequireDefault(_homePage);
	
	var _creator = __webpack_require__(2101);
	
	var _creator2 = _interopRequireDefault(_creator);
	
	var _creatorNew = __webpack_require__(2099);
	
	var _creatorNew2 = _interopRequireDefault(_creatorNew);
	
	var _creatorFull = __webpack_require__(2098);
	
	var _creatorFull2 = _interopRequireDefault(_creatorFull);
	
	var _campaignNotificationsTab = __webpack_require__(1908);
	
	var _campaignNotificationsTab2 = _interopRequireDefault(_campaignNotificationsTab);
	
	var _campaignSettings = __webpack_require__(2087);
	
	var _campaignSettings2 = _interopRequireDefault(_campaignSettings);
	
	var _shortlists = __webpack_require__(2204);
	
	var _shortlists2 = _interopRequireDefault(_shortlists);
	
	var _shortlist = __webpack_require__(2203);
	
	var _shortlist2 = _interopRequireDefault(_shortlist);
	
	var _campaignsV = __webpack_require__(2092);
	
	var _campaignsV2 = _interopRequireDefault(_campaignsV);
	
	var _campaignDashboardV = __webpack_require__(2069);
	
	var _campaignDashboardV2 = _interopRequireDefault(_campaignDashboardV);
	
	var _campaignDashboardReport = __webpack_require__(2066);
	
	var _campaignDashboardReport2 = _interopRequireDefault(_campaignDashboardReport);
	
	var _campaignDashboardAssets = __webpack_require__(2059);
	
	var _campaignDashboardAssets2 = _interopRequireDefault(_campaignDashboardAssets);
	
	var _campaignDashboardTeam = __webpack_require__(2068);
	
	var _campaignDashboardTeam2 = _interopRequireDefault(_campaignDashboardTeam);
	
	var _campaignDashboardOverview = __webpack_require__(2065);
	
	var _campaignDashboardOverview2 = _interopRequireDefault(_campaignDashboardOverview);
	
	var _campaignDashboardSettings = __webpack_require__(2067);
	
	var _campaignDashboardSettings2 = _interopRequireDefault(_campaignDashboardSettings);
	
	var _campaignDashboardInfluencers = __webpack_require__(2061);
	
	var _campaignDashboardInfluencers2 = _interopRequireDefault(_campaignDashboardInfluencers);
	
	var _influencerAuthorisation = __webpack_require__(2141);
	
	var _influencerAuthorisation2 = _interopRequireDefault(_influencerAuthorisation);
	
	var _influencerPage = __webpack_require__(2143);
	
	var _influencerPage2 = _interopRequireDefault(_influencerPage);
	
	var _influencerLatest = __webpack_require__(1968);
	
	var _influencerLatest2 = _interopRequireDefault(_influencerLatest);
	
	var _influencerInstagramStories = __webpack_require__(2142);
	
	var _influencerInstagramStories2 = _interopRequireDefault(_influencerInstagramStories);
	
	var _influencerAdPosts = __webpack_require__(1954);
	
	var _influencerAdPosts2 = _interopRequireDefault(_influencerAdPosts);
	
	var _influencerProfileStats = __webpack_require__(1975);
	
	var _influencerProfileStats2 = _interopRequireDefault(_influencerProfileStats);
	
	var _influencerReviews = __webpack_require__(1980);
	
	var _influencerReviews2 = _interopRequireDefault(_influencerReviews);
	
	var _influencerCampaigns = __webpack_require__(1960);
	
	var _influencerCampaigns2 = _interopRequireDefault(_influencerCampaigns);
	
	var _influencerBlogosphere = __webpack_require__(1957);
	
	var _influencerBlogosphere2 = _interopRequireDefault(_influencerBlogosphere);
	
	var _influencerPostRates = __webpack_require__(2144);
	
	var _influencerPostRates2 = _interopRequireDefault(_influencerPostRates);
	
	var _influencerQuestionnaire = __webpack_require__(2156);
	
	var _influencerQuestionnaire2 = _interopRequireDefault(_influencerQuestionnaire);
	
	var _influencerProfile = __webpack_require__(2145);
	
	var _influencerProfile2 = _interopRequireDefault(_influencerProfile);
	
	var _agencyInfluencerRequests = __webpack_require__(2048);
	
	var _agencyInfluencerRequests2 = _interopRequireDefault(_agencyInfluencerRequests);
	
	var _influencerForm = __webpack_require__(1964);
	
	var _influencerForm2 = _interopRequireDefault(_influencerForm);
	
	var _influencerRequests = __webpack_require__(2157);
	
	var _influencerRequests2 = _interopRequireDefault(_influencerRequests);
	
	var _creatorPage = __webpack_require__(909);
	
	var _creatorPage2 = _interopRequireDefault(_creatorPage);
	
	var _shopfluenceDashboard = __webpack_require__(2202);
	
	var _shopfluenceDashboard2 = _interopRequireDefault(_shopfluenceDashboard);
	
	var _skinsidersDashboard = __webpack_require__(2206);
	
	var _skinsidersDashboard2 = _interopRequireDefault(_skinsidersDashboard);
	
	var _abbottLyonDashboard = __webpack_require__(2042);
	
	var _abbottLyonDashboard2 = _interopRequireDefault(_abbottLyonDashboard);
	
	var _ordersDashboard = __webpack_require__(2181);
	
	var _ordersDashboard2 = _interopRequireDefault(_ordersDashboard);
	
	var _elevenMeadowDashboard = __webpack_require__(2127);
	
	var _elevenMeadowDashboard2 = _interopRequireDefault(_elevenMeadowDashboard);
	
	var _newInfluencer = __webpack_require__(2178);
	
	var _newInfluencer2 = _interopRequireDefault(_newInfluencer);
	
	var _newInfluencerSignup = __webpack_require__(2176);
	
	var _newInfluencerSignup2 = _interopRequireDefault(_newInfluencerSignup);
	
	var _newInfluencerRegistration = __webpack_require__(2175);
	
	var _newInfluencerRegistration2 = _interopRequireDefault(_newInfluencerRegistration);
	
	var _newInfluencerWelcome = __webpack_require__(2177);
	
	var _newInfluencerWelcome2 = _interopRequireDefault(_newInfluencerWelcome);
	
	var _newInfluencerProfile = __webpack_require__(2174);
	
	var _newInfluencerProfile2 = _interopRequireDefault(_newInfluencerProfile);
	
	var _tokenGenerationPage = __webpack_require__(2217);
	
	var _tokenGenerationPage2 = _interopRequireDefault(_tokenGenerationPage);
	
	var _tokenThanks = __webpack_require__(2033);
	
	var _tokenThanks2 = _interopRequireDefault(_tokenThanks);
	
	var _applyThanks = __webpack_require__(1882);
	
	var _applyThanks2 = _interopRequireDefault(_applyThanks);
	
	var _registerThanks = __webpack_require__(2018);
	
	var _registerThanks2 = _interopRequireDefault(_registerThanks);
	
	var _profiles = __webpack_require__(2188);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _membersTab = __webpack_require__(2213);
	
	var _membersTab2 = _interopRequireDefault(_membersTab);
	
	var _settingsTab = __webpack_require__(2214);
	
	var _settingsTab2 = _interopRequireDefault(_settingsTab);
	
	var _tagsTab = __webpack_require__(2215);
	
	var _tagsTab2 = _interopRequireDefault(_tagsTab);
	
	var _inventoryTab = __webpack_require__(2212);
	
	var _inventoryTab2 = _interopRequireDefault(_inventoryTab);
	
	var _businessUnitsTab = __webpack_require__(2210);
	
	var _businessUnitsTab2 = _interopRequireDefault(_businessUnitsTab);
	
	var _entrySurvey = __webpack_require__(2128);
	
	var _entrySurvey2 = _interopRequireDefault(_entrySurvey);
	
	var _themeSelector = __webpack_require__(26);
	
	var _themeSelector2 = _interopRequireDefault(_themeSelector);
	
	var _chat = __webpack_require__(2093);
	
	var _chat2 = _interopRequireDefault(_chat);
	
	var _mailouts = __webpack_require__(2169);
	
	var _mailouts2 = _interopRequireDefault(_mailouts);
	
	var _unsubscribeConfirmation = __webpack_require__(2225);
	
	var _unsubscribeConfirmation2 = _interopRequireDefault(_unsubscribeConfirmation);
	
	var _launchMetricsDashboard = __webpack_require__(2167);
	
	var _launchMetricsDashboard2 = _interopRequireDefault(_launchMetricsDashboard);
	
	var _sagas = __webpack_require__(2256);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	var _reducer = __webpack_require__(2253);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	__webpack_require__(4088);
	
	__webpack_require__(2911);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var theme = _themeSelector2.default.theme();
	var pageTitle = theme.title || 'dyzio';
	
	var HIDE_HOMEPAGE = theme.hideHomepage || false;
	
	// Configure segment analytics
	analytics.load(("x4ncWxJLy1KTYYNOBGk6Z1JNafljYSxE"));
	analytics.page();
	
	// onEnter callback to validate authentication in private routes
	var requireAuth = function requireAuth(nextState, replace) {
	  if (!_authService.authService.loggedIn()) {
	    localStorage.setItem('path', nextState.location.pathname);
	    replace({ pathname: '/' });
	  }
	};
	
	// onEnter callback to validate authentication in non-private routes
	var notRequireAuth = function notRequireAuth(nextState, replace) {
	  var hash = window.location.hash;
	
	  var parsedHash = _queryString2.default.parse(hash);
	
	  var FORCE_RELOAD = true;
	  // LAB - the reload is being forced because the auth token is not available
	  // in the constructor of the data HOCs unless we write to storage and
	  // then reload the app. I'm sure this could be fixed using React Context
	  // or some kind of provider pattern.
	  var pathname = void 0;
	
	  if (_authService.authService.loggedIn()) {
	    var profile = _authService.authService.getProfile();
	    var _profile$app_metadata = profile.app_metadata.dyzio,
	        role = _profile$app_metadata.role,
	        enrolledBy = _profile$app_metadata.enrolledBy;
	
	    if (role && role === 'INFLUENCER') {
	      if (enrolledBy === 'SELF') {
	        pathname = '/new-influencer/welcome';
	      } else {
	        pathname = '/dashboard';
	      }
	    } else if (parsedHash.campaign) {
	      pathname = '/campaign/' + parsedHash.campaign;
	    } else {
	      var destination = HIDE_HOMEPAGE ? '/dashboard' : '/home';
	      pathname = destination;
	    }
	    if (FORCE_RELOAD) window.location = pathname;
	    replace({ pathname: pathname });
	  }
	};
	
	var logoutUser = function logoutUser(nextState, replace) {
	  var redirectUri = _lodash2.default.get(nextState, 'location.query.redirect_uri');
	  _authService.authService.logout();
	  if (redirectUri) {
	    // eslint-disable-next-line lodash/prefer-lodash-method
	    window.location.replace(redirectUri);
	  } else {
	    replace({ pathname: '/' });
	  }
	};
	
	var parseAuthHash = function parseAuthHash(nextState, replace, callback) {
	  var hash = window.location.hash;
	
	  var parsedHash = _queryString2.default.parse(hash);
	
	  return _authService.authService.parseHash().then(function () {
	    if (parsedHash.campaign) {
	      replace({ pathname: '/campaign/' + parsedHash.campaign });
	    } else {
	      replace({ pathname: '/invite' });
	    }
	    return callback();
	  }).catch(function () {
	    replace({ pathname: '/access-denied/' + hash });
	    return callback();
	  });
	};
	
	var parseInfluencerAuthHash = function parseInfluencerAuthHash(nextState, replace, callback) {
	  return _authService.authService.parseHash().then(function () {
	    replace({ pathname: '/new-influencer/registration' });
	    callback();
	  }).catch(function () {
	    replace({ pathname: '/access-denied' });
	    return callback();
	  });
	};
	
	var processSurveyComplete = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(nextState, replace, callback) {
	    var profile, organisationId, token, ax, payload;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            console.log('processSurveyComplete');
	
	            profile = _authService.authService.getProfile();
	            organisationId = profile.app_metadata.dyzio.o_id;
	            token = _authService.authService.getToken();
	            ax = _axios2.default.create({
	              baseURL: ("https://api2.dyzio.co/v1"),
	              timeout: 500,
	              headers: {
	                'Content-Type': 'application/json',
	                Authorization: 'Bearer ' + token
	              }
	            });
	            payload = {
	              data: {
	                attributes: {
	                  entrySurveyStatus: 'COMPLETED'
	                }
	              }
	            };
	            _context.next = 8;
	            return ax.patch('/organisations/' + organisationId, payload);
	
	          case 8:
	
	            replace({ pathname: '/home' });
	            return _context.abrupt('return', callback());
	
	          case 10:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function processSurveyComplete(_x, _x2, _x3) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	// create the saga middleware
	var sagaMiddleware = (0, _reduxSaga2.default)();
	// mount it on the Store
	var store = (0, _redux.createStore)(_reducer2.default, (0, _redux.applyMiddleware)(sagaMiddleware));
	
	// Create an enhanced history that syncs navigation events with the store
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	sagaMiddleware.run(_sagas2.default);
	
	_reactDom2.default.render(_react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(
	    _reactHelmet.Helmet,
	    null,
	    _react2.default.createElement('meta', { charSet: 'utf-8' }),
	    _react2.default.createElement(
	      'title',
	      null,
	      pageTitle
	    )
	  ),
	  _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(
	      _reactRouter.Router,
	      {
	        history: history
	        // Scroll to top when going to a new page, imitating default browser behaviour
	        , render: (0, _reactRouter.applyRouterMiddleware)((0, _reactRouterScroll.useScroll)())
	      },
	      _react2.default.createElement(_reactRouter.Route, { component: _tokenThanks2.default, exact: true, path: 'token-thanks' }),
	      _react2.default.createElement(_reactRouter.Route, { component: _registerThanks2.default, exact: true, path: 'register' }),
	      _react2.default.createElement(_reactRouter.Route, { component: _creatorNew2.default, path: 'creator/new' }),
	      _react2.default.createElement(_reactRouter.Route, { component: _creatorFull2.default, path: 'creator/signup' }),
	      _react2.default.createElement(_reactRouter.Route, { component: _creatorFull2.default, path: 'brand/:brand/signup' }),
	      _react2.default.createElement(_reactRouter.Route, { component: _unsubscribeConfirmation2.default, exact: true, path: 'creator/unsubscribe' }),
	      _react2.default.createElement(_reactRouter.Route, { component: _applyThanks2.default, exact: true, path: 'creator/thanks' }),
	      _react2.default.createElement(_reactRouter.Route, { component: _creator2.default, path: 'creator/:id' }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { component: _app2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: '/', component: _homepage2.default, onEnter: notRequireAuth }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'media-kit/:influnecerId', component: _mediaKit2.default, onEnter: requireAuth }),
	        _react2.default.createElement(_reactRouter.Route, { mobileAllowed: true, path: 'new-influencer/signup', component: _newInfluencerSignup2.default }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { mobileAllowed: true, path: 'new-influencer', component: _newInfluencer2.default, onEnter: requireAuth },
	          _react2.default.createElement(_reactRouter.Route, { path: 'registration', component: _newInfluencerRegistration2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'welcome', component: _newInfluencerWelcome2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'profile', component: _newInfluencerProfile2.default })
	        ),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { component: _user2.default, onEnter: requireAuth },
	          _react2.default.createElement(_reactRouter.Route, { path: 'dashboard', component: _dashboard2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'launch-metrics/dashboard', component: _launchMetricsDashboard2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'mailouts/:id', component: _mailouts2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'survey', component: _entrySurvey2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'survey-complete', onEnter: processSurveyComplete }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'shopfluence/dashboard', component: _shopfluenceDashboard2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'skinsiders/dashboard', component: _skinsidersDashboard2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'abbott-lyon/dashboard', component: _abbottLyonDashboard2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'abbott-lyon/orders', component: _ordersDashboard2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'eleven-meadow/dashboard', component: _elevenMeadowDashboard2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'home', component: _homePage2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'profile', component: _userProfile2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'profile/settings', component: _userSettings2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'profiles', component: _profiles2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'campaigns/v2', component: _campaignsV2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'organisations/events', component: _sandbox2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'pending-invitations', component: _pendingInvitations2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'campaign/v2/:id', component: _campaignDashboardV2.default },
	            _react2.default.createElement(_reactRouter.Route, { path: 'assets', component: _campaignDashboardAssets2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'overview', component: _campaignDashboardOverview2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'report', component: _campaignDashboardReport2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'team', component: _campaignDashboardTeam2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'settings', component: _campaignDashboardSettings2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'influencers', component: _campaignDashboardInfluencers2.default })
	          ),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'acr-campaign' },
	            _react2.default.createElement(_reactRouter.Route, { path: 'members', component: _campaignMembers2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'members/manage', component: _campaignMembersManage2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'update/:id', component: _campaignUpdate2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'discussioncreate', component: _discussionCreate2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'deliverable/:id', component: _deliverable2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id', component: _acrCampaign2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id/manage', component: _campaignManage2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id/invite', component: _campaignInviteMore2.default })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'asset/:assetType/:assetId', component: _viewAssetPage2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            {
	              path: 'campaign', component: _campaign2.default
	            },
	            _react2.default.createElement(_reactRouter.Route, {
	              path: ':id',
	              component: function component(props) {
	                return props.history.push('/campaign/' + props.params.id + '/collaborations');
	              }
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: ':id/setup',
	              componend: _nonAcrCampaignSetup2.default
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: ':id/collaboration/:collabId',
	              component: _collaboration2.default
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: ':id/collaborations',
	              component: _discussionList2.default
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: ':id/audit-trail',
	              component: _campaignAuditTrail2.default
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: ':id/analytics',
	              component: _campaignDashboard2.default
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: ':id/reports',
	              component: _reportList2.default
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: ':id/payments',
	              component: _payments2.default
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: ':id/notifications',
	              component: _campaignNotificationsTab2.default
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: ':id/settings',
	              component: _campaignSettings2.default
	            })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'campaign/new', component: _campaignNew2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'campaign/members', component: _campaignMembers2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'campaign/members/manage', component: _campaignMembersManage2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'campaign/update/:id', component: _campaignUpdate2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'campaign/discussioncreate', component: _discussionCreate2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'campaign/deliverable/:id', component: _deliverable2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'campaign/:id/manage', component: _campaignManage2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'campaign/:id/invite', component: _campaignInviteMore2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'team', component: _teamManager2.default },
	            _react2.default.createElement(_reactRouter.Route, { path: 'members', component: _membersTab2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'manage', component: _settingsTab2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'tags', component: _tagsTab2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'inventory', component: _inventoryTab2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'business-units', component: _businessUnitsTab2.default })
	          ),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'organisation' },
	            _react2.default.createElement(_reactRouter.Route, { path: 'audit-log', component: _organisationAuditLog2.default })
	          ),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'influencer' },
	            _react2.default.createElement(_reactRouter.Route, { path: 'authorisation', component: _influencerAuthorisation2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'my-requests', component: _influencerRequests2.default })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'chat', component: _chat2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'sandbox', component: function component() {
	              return _react2.default.createElement(
	                'div',
	                { style: { width: 800, margin: '20px auto' } },
	                _react2.default.createElement(_tagCloud2.default, { onTagSelected: function onTagSelected(id) {
	                    return console.log(id);
	                  } })
	              );
	            } }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'shortlists', component: _shortlists2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'shortlists/:id', component: _shortlist2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'analytics', component: _analytics2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'analytics/:id', component: _analyticsAsset2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'influencers', component: _myInfluencers2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'creators', component: _myCreators2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'creators2', component: _myCreators4.default }),
	          _react2.default.createElement(_reactRouter.Route, { exact: true, path: 'creators/approvals', component: _myCreators2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'creators/:id', component: _creatorPage2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'my-requests', component: _agencyInfluencerRequests2.default }),
	          _react2.default.createElement(_reactRouter.Route, { exact: true, path: 'influencer/add', component: _influencerForm2.default }),
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'influencer', component: _influencerPage2.default },
	            _react2.default.createElement(_reactRouter.Route, { path: ':id/latest', component: _influencerLatest2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id/ads', component: _influencerAdPosts2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id/statistics', component: _influencerProfileStats2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id/reviews', component: _influencerReviews2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id/campaigns', component: _influencerCampaigns2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id/profile', component: _influencerProfile2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id/stories', component: _influencerInstagramStories2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id/blogosphere', component: _influencerBlogosphere2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id/rates', component: _influencerPostRates2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: ':id/questionnaire', component: _influencerQuestionnaire2.default })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'onboarding', component: _onboarding2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: '/token/generate/:tokenId', component: _tokenGenerationPage2.default })
	        ),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { onEnter: notRequireAuth },
	          _react2.default.createElement(_reactRouter.Route, { path: 'login', component: _login2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'signup', component: _signup2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'company/signup', component: _companySignup2.default }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: 'auth',
	            onEnter: function onEnter(nextState, replace, callback) {
	              parseAuthHash(nextState, replace, callback);
	            }
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: 'influencer-auth',
	            onEnter: function onEnter(nextState, replace, callback) {
	              parseInfluencerAuthHash(nextState, replace, callback);
	            }
	          })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: 'invite/:inviteid', component: _campaignInvite2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'invite', component: _campaignInvite2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'resetpassword', component: _resetPassword2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'logout', onEnter: logoutUser }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'access-denied/*', component: _accessDenied2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'not-found', component: _notFoundPage2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: '*', component: _notFoundPage2.default })
	      )
	    )
	  ),
	  _react2.default.createElement(_reactToastify.ToastContainer, null)
	), document.getElementById('root'));

/***/ },
/* 2253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(332);
	
	var _immutable = __webpack_require__(71);
	
	var _reactRouterRedux = __webpack_require__(1555);
	
	var _immutable2 = __webpack_require__(34);
	
	var _reducer = __webpack_require__(2228);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__(2242);
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__(2160);
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__(2090);
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__(2207);
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	var _reducer11 = __webpack_require__(2075);
	
	var _reducer12 = _interopRequireDefault(_reducer11);
	
	var _reducer13 = __webpack_require__(2123);
	
	var _reducer14 = _interopRequireDefault(_reducer13);
	
	var _reducer15 = __webpack_require__(2117);
	
	var _reducer16 = _interopRequireDefault(_reducer15);
	
	var _reducer17 = __webpack_require__(2080);
	
	var _reducer18 = _interopRequireDefault(_reducer17);
	
	var _reducer19 = __webpack_require__(2111);
	
	var _reducer20 = _interopRequireDefault(_reducer19);
	
	var _reducer21 = __webpack_require__(2051);
	
	var _reducer22 = _interopRequireDefault(_reducer21);
	
	var _reducer23 = __webpack_require__(2236);
	
	var _reducer24 = _interopRequireDefault(_reducer23);
	
	var _reducer25 = __webpack_require__(2239);
	
	var _reducer26 = _interopRequireDefault(_reducer25);
	
	var _reducer27 = __webpack_require__(2163);
	
	var _reducer28 = _interopRequireDefault(_reducer27);
	
	var _reducer29 = __webpack_require__(2107);
	
	var _reducer30 = _interopRequireDefault(_reducer29);
	
	var _reducer31 = __webpack_require__(2103);
	
	var _reducer32 = _interopRequireDefault(_reducer31);
	
	var _reducer33 = __webpack_require__(2057);
	
	var _reducer34 = _interopRequireDefault(_reducer33);
	
	var _reducer35 = __webpack_require__(2054);
	
	var _reducer36 = _interopRequireDefault(_reducer35);
	
	var _reducer37 = __webpack_require__(2185);
	
	var _reducer38 = _interopRequireDefault(_reducer37);
	
	var _reducer39 = __webpack_require__(2223);
	
	var _reducer40 = _interopRequireDefault(_reducer39);
	
	var _reducer41 = __webpack_require__(2232);
	
	var _reducer42 = _interopRequireDefault(_reducer41);
	
	var _sendbird = __webpack_require__(2255);
	
	var _sendbird2 = _interopRequireDefault(_sendbird);
	
	var _modal = __webpack_require__(2254);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _constants = __webpack_require__(902);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialWindowSizeState = (0, _immutable2.fromJS)({
	  windowWidth: 0,
	  windowHeight: 0
	});
	
	function windowSizeReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialWindowSizeState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.WINDOW_RESIZE:
	      return state.set('windowWidth', action.windowWidth).set('windowHeight', action.windowHeight);
	    default:
	      return state;
	  }
	}
	
	var reducers = {
	  windowSize: windowSizeReducer,
	  user: _reducer2.default,
	  userData: _reducer4.default,
	  campaignList: _reducer6.default,
	  campaign: _reducer8.default,
	  members: _reducer18.default,
	  discussionList: _reducer16.default,
	  discussion: _reducer14.default,
	  statusBar: _reducer10.default,
	  form: _immutable.reducer,
	  invite: _reducer12.default,
	  modal: _modal2.default,
	  routing: _reactRouterRedux.routerReducer,
	  deliverable: _reducer20.default,
	  analyticsAssetList: _reducer22.default,
	  userProfile: _reducer24.default,
	  userSettings: _reducer26.default,
	  influencers: _reducer28.default,
	  deliverableSubmit: _reducer30.default,
	  deliverableAssign: _reducer32.default,
	  campaignAnalytics: _reducer34.default,
	  analyticsAsset: _reducer36.default,
	  payments: _reducer38.default,
	  trackAssetModal: _reducer40.default,
	  userOnboarding: _reducer42.default
	};
	
	var reducer = (0, _redux.combineReducers)(reducers);
	
	exports.default = reducer;

/***/ },
/* 2254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _modal = __webpack_require__(169);
	
	var initialState = (0, _immutable.fromJS)({
	  showModal: null,
	  loading: false,
	  error: null
	});
	
	function modalReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _modal.MODAL_SET:
	      return state.set('loading', false).set('showModal', action.modalName);
	    case _modal.MODAL_LOADING:
	      return state.set('loading', action.loading).set('error', null);
	    case _modal.MODAL_CLEAR:
	      return state.set('showModal', null).set('loading', false).set('error', null);
	    case _modal.MODAL_ERROR:
	      return state.set('error', action.error).set('loading', false);
	    default:
	      return state;
	  }
	}
	
	exports.default = modalReducer;

/***/ },
/* 2255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var _sendbird = __webpack_require__(354);
	
	var initialState = (0, _immutable.fromJS)({
	  sendbirdUser: null,
	  loading: false,
	  error: null,
	  sendbirdChannelURL: null,
	  sendbirdChannel: null,
	  channelLoading: false,
	  channelError: null,
	  messageListQuery: null
	});
	
	function sendbirdReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _sendbird.LOAD_SENDBIRD_USER:
	      return state.set('sendbirdUser', null).set('loading', true);
	    case _sendbird.LOAD_SENDBIRD_USER_SUCCESS:
	      return state.set('sendbirdUser', action.sendbirdUser).set('loading', false);
	    case _sendbird.LOAD_SENDBIRD_USER_ERROR:
	      return state.set('sendbirdUser', null).set('loading', false).set('error', action.error);
	    case _sendbird.LOAD_SENDBIRD_CHANNEL:
	      return state.set('sendbirdChannel', null).set('channelLoading', true).set('channelError', null);
	    case _sendbird.LOAD_SENDBIRD_CHANNEL_SUCCESS:
	      return state.set('sendbirdChannel', action.sendbirdChannel).set('channelLoading', false);
	    case _sendbird.LOAD_SENDBIRD_CHANNEL_ERROR:
	      return state.set('sendbirdChannel', null).set('channelLoading', false).set('channelError', action.error);
	    case _sendbird.SET_SENDBIRD_CHANNEL_URL:
	      return state.set('sendbirdChannelURL', action.sendbirdChannelURL);
	    case _sendbird.SET_MESSAGE_LIST_QUERY:
	      return state.set('messageListQuery', action.messageListQuery);
	    case _sendbird.CLEAR_SENDBIRD_DATA:
	      return state.set('sendbirdChannelURL', null).set('sendbirdChannel', null).set('channelLoading', false).set('channelError', null).set('messageListQuery', null);
	    default:
	      return state;
	  }
	}
	
	exports.default = sendbirdReducer;

/***/ },
/* 2256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = rootSaga;
	
	var _effects = __webpack_require__(54);
	
	var _sagas = __webpack_require__(2229);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	var _sagas3 = __webpack_require__(2161);
	
	var _sagas4 = _interopRequireDefault(_sagas3);
	
	var _sagas5 = __webpack_require__(2091);
	
	var _sagas6 = _interopRequireDefault(_sagas5);
	
	var _sagas7 = __webpack_require__(2124);
	
	var _sagas8 = _interopRequireDefault(_sagas7);
	
	var _sagas9 = __webpack_require__(2118);
	
	var _sagas10 = _interopRequireDefault(_sagas9);
	
	var _sagas11 = __webpack_require__(2081);
	
	var _sagas12 = _interopRequireDefault(_sagas11);
	
	var _sagas13 = __webpack_require__(2104);
	
	var _sagas14 = _interopRequireDefault(_sagas13);
	
	var _sagas15 = __webpack_require__(2108);
	
	var _sagas16 = _interopRequireDefault(_sagas15);
	
	var _sagas17 = __webpack_require__(2126);
	
	var _sagas18 = _interopRequireDefault(_sagas17);
	
	var _sagas19 = __webpack_require__(2224);
	
	var _sagas20 = _interopRequireDefault(_sagas19);
	
	var _sagas21 = __webpack_require__(903);
	
	var _sagas22 = _interopRequireDefault(_sagas21);
	
	var _sagas23 = __webpack_require__(2112);
	
	var _sagas24 = _interopRequireDefault(_sagas23);
	
	var _sagas25 = __webpack_require__(2164);
	
	var _sagas26 = _interopRequireDefault(_sagas25);
	
	var _sagas27 = __webpack_require__(2240);
	
	var _sagas28 = _interopRequireDefault(_sagas27);
	
	var _sagas29 = __webpack_require__(2058);
	
	var _sagas30 = _interopRequireDefault(_sagas29);
	
	var _sagas31 = __webpack_require__(2186);
	
	var _sagas32 = _interopRequireDefault(_sagas31);
	
	var _sagas33 = __webpack_require__(2076);
	
	var _sagas34 = _interopRequireDefault(_sagas33);
	
	var _sagas35 = __webpack_require__(2233);
	
	var _sagas36 = _interopRequireDefault(_sagas35);
	
	var _sagas37 = __webpack_require__(2198);
	
	var _sagas38 = _interopRequireDefault(_sagas37);
	
	var _sagas39 = __webpack_require__(2201);
	
	var _sagas40 = _interopRequireDefault(_sagas39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [rootSaga].map(_regenerator2.default.mark);
	
	// single entry point to start all Sagas at once
	function rootSaga() {
	  return _regenerator2.default.wrap(function rootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return [(0, _effects.fork)(_sagas2.default), (0, _effects.fork)(_sagas4.default), (0, _effects.fork)(_sagas6.default), (0, _effects.fork)(_sagas10.default), (0, _effects.fork)(_sagas8.default), (0, _effects.fork)(_sagas12.default), (0, _effects.fork)(_sagas14.default), (0, _effects.fork)(_sagas16.default), (0, _effects.fork)(_sagas18.default),
	          // fork(SendbirdSaga),
	          (0, _effects.fork)(_sagas20.default), (0, _effects.fork)(_sagas22.default), (0, _effects.fork)(_sagas24.default), (0, _effects.fork)(_sagas26.default), (0, _effects.fork)(_sagas28.default), (0, _effects.fork)(_sagas30.default), (0, _effects.fork)(_sagas32.default), (0, _effects.fork)(_sagas34.default), (0, _effects.fork)(_sagas36.default), (0, _effects.fork)(_sagas38.default), (0, _effects.fork)(_sagas40.default)];
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}

/***/ },
/* 2257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(16);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.receiveMessageHandler = receiveMessageHandler;
	exports.setupSendbirdUser = setupSendbirdUser;
	exports.checkSendbirdUserIsSetup = checkSendbirdUserIsSetup;
	exports.loadSendbirdChannel = loadSendbirdChannel;
	exports.watchLoadSendbirdChannel = watchLoadSendbirdChannel;
	exports.watchSetupSendbirdUser = watchSetupSendbirdUser;
	exports.default = sendbirdSagas;
	
	var _reduxSaga = __webpack_require__(55);
	
	var _effects = __webpack_require__(54);
	
	var _immutable = __webpack_require__(34);
	
	var _sendbirdService = __webpack_require__(366);
	
	var _userSelectors = __webpack_require__(118);
	
	var _sendbirdSelectors = __webpack_require__(927);
	
	var _errorHandlingService = __webpack_require__(30);
	
	var _constants = __webpack_require__(142);
	
	var _constants2 = __webpack_require__(566);
	
	var _sendbird = __webpack_require__(354);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [receiveMessageHandler, setupSendbirdUser, checkSendbirdUserIsSetup, loadSendbirdChannel, watchLoadSendbirdChannel, watchSetupSendbirdUser, sendbirdSagas].map(_regenerator2.default.mark);
	
	var Scroll = __webpack_require__(327);
	var scroll = Scroll.animateScroll;
	
	/* eslint no-constant-condition: "off" */
	function receiveMessageHandler(uniqueId) {
	  var messageChannel, message;
	  return _regenerator2.default.wrap(function receiveMessageHandler$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(sendbirdChannelHandler, uniqueId);
	
	        case 2:
	          messageChannel = _context.sent;
	
	        case 3:
	          if (false) {
	            _context.next = 11;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.take)(messageChannel);
	
	        case 6:
	          message = _context.sent;
	          _context.next = 9;
	          return (0, _effects.put)({ type: _constants.RECEIVE_MESSAGE, message: message });
	
	        case 9:
	          _context.next = 3;
	          break;
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function sendbirdChannelHandler(uniqueId) {
	  return (0, _reduxSaga.eventChannel)(function (emitter) {
	    var sendBird = _sendbirdService.sendBirdService.getSendbirdService();
	    var ChannelHandler = new sendBird.ChannelHandler();
	
	    ChannelHandler.onMessageReceived = function (channel, message) {
	      emitter(message);
	    };
	    sendBird.addChannelHandler(uniqueId, ChannelHandler);
	
	    // The subscriber must return an unsubscribe function
	    return function () {
	      sendBird.removeChannelHandler(uniqueId);
	    };
	  });
	}
	
	function setupSendbirdUser(actions) {
	  var userId, sendbirdUser;
	  return _regenerator2.default.wrap(function setupSendbirdUser$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 3:
	          userId = _context2.sent;
	
	          if (userId) {
	            _context2.next = 10;
	            break;
	          }
	
	          _context2.next = 7;
	          return (0, _effects.take)(_constants2.UPDATE_USER);
	
	        case 7:
	          _context2.next = 9;
	          return (0, _effects.select)(_userSelectors.getUserId);
	
	        case 9:
	          userId = _context2.sent;
	
	        case 10:
	          _context2.next = 12;
	          return (0, _effects.call)(_sendbirdService.sendBirdService.connectSendbirdUser, userId);
	
	        case 12:
	          sendbirdUser = _context2.sent;
	          _context2.next = 15;
	          return (0, _effects.put)({ type: _sendbird.LOAD_SENDBIRD_USER_SUCCESS, sendbirdUser: (0, _immutable.fromJS)(sendbirdUser) });
	
	        case 15:
	          _context2.next = 17;
	          return (0, _effects.fork)(receiveMessageHandler, Math.random());
	
	        case 17:
	          _context2.next = 24;
	          break;
	
	        case 19:
	          _context2.prev = 19;
	          _context2.t0 = _context2['catch'](0);
	
	          (0, _errorHandlingService.reportError)('LOAD_SENDBIRD_USER_ERROR', _context2.t0.message);
	          _context2.next = 24;
	          return (0, _effects.put)({ type: _sendbird.LOAD_SENDBIRD_USER_ERROR, error: _context2.t0 });
	
	        case 24:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 19]]);
	}
	
	function checkSendbirdUserIsSetup() {
	  var isSendbirdUserLoading, sendbirdUser;
	  return _regenerator2.default.wrap(function checkSendbirdUserIsSetup$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_sendbirdSelectors.getIsSendbirdUserLoading);
	
	        case 2:
	          isSendbirdUserLoading = _context3.sent;
	          _context3.next = 5;
	          return (0, _effects.select)(_sendbirdSelectors.getSendbirdUser);
	
	        case 5:
	          sendbirdUser = _context3.sent;
	
	          if (!isSendbirdUserLoading) {
	            _context3.next = 11;
	            break;
	          }
	
	          _context3.next = 9;
	          return (0, _effects.take)(_sendbird.LOAD_SENDBIRD_USER_SUCCESS);
	
	        case 9:
	          _context3.next = 16;
	          break;
	
	        case 11:
	          if (!(!sendbirdUser && !isSendbirdUserLoading)) {
	            _context3.next = 16;
	            break;
	          }
	
	          _context3.next = 14;
	          return (0, _effects.put)({ type: _sendbird.LOAD_SENDBIRD_USER });
	
	        case 14:
	          _context3.next = 16;
	          return (0, _effects.take)(_sendbird.LOAD_SENDBIRD_USER_SUCCESS);
	
	        case 16:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function loadSendbirdChannel(action) {
	  var sendbirdChannelURL, sendbirdChannel;
	  return _regenerator2.default.wrap(function loadSendbirdChannel$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.prev = 0;
	          _context4.next = 3;
	          return (0, _effects.select)(_sendbirdSelectors.getSendbirdChannelURL);
	
	        case 3:
	          sendbirdChannelURL = _context4.sent;
	          _context4.next = 6;
	          return (0, _effects.call)(checkSendbirdUserIsSetup);
	
	        case 6:
	          _context4.next = 8;
	          return (0, _effects.call)(_sendbirdService.sendBirdService.fetchSendbirdChannel, sendbirdChannelURL);
	
	        case 8:
	          sendbirdChannel = _context4.sent;
	          _context4.next = 11;
	          return (0, _effects.put)({ type: _sendbird.LOAD_SENDBIRD_CHANNEL_SUCCESS, sendbirdChannel: sendbirdChannel });
	
	        case 11:
	          _context4.next = 18;
	          break;
	
	        case 13:
	          _context4.prev = 13;
	          _context4.t0 = _context4['catch'](0);
	
	          (0, _errorHandlingService.reportError)('LOAD_SENDBIRD_CHANNEL_ERROR', _context4.t0.message);
	          _context4.next = 18;
	          return (0, _effects.put)({ type: _sendbird.LOAD_SENDBIRD_CHANNEL_ERROR, error: _context4.t0 });
	
	        case 18:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this, [[0, 13]]);
	}
	
	function watchLoadSendbirdChannel() {
	  return _regenerator2.default.wrap(function watchLoadSendbirdChannel$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _reduxSaga.takeLatest)(_sendbird.LOAD_SENDBIRD_CHANNEL, loadSendbirdChannel);
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function watchSetupSendbirdUser() {
	  return _regenerator2.default.wrap(function watchSetupSendbirdUser$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _reduxSaga.takeLatest)(_sendbird.LOAD_SENDBIRD_USER, setupSendbirdUser);
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this);
	}
	
	function sendbirdSagas() {
	  return _regenerator2.default.wrap(function sendbirdSagas$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return [(0, _effects.fork)(watchSetupSendbirdUser)];
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}

/***/ },
/* 2258 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getAllYoutubeVideos = exports.getAllYoutubeVideos = function getAllYoutubeVideos(state) {
	  return state.analyticsAssetList.get('youtubeVideos');
	};
	var getFilteredYoutubeVideos = exports.getFilteredYoutubeVideos = function getFilteredYoutubeVideos(state) {
	  return state.analyticsAssetList.get('filteredYoutubeVideos');
	};
	var getAllInstagramPosts = exports.getAllInstagramPosts = function getAllInstagramPosts(state) {
	  return state.analyticsAssetList.get('instagramPosts');
	};
	var getFilteredInstagramPosts = exports.getFilteredInstagramPosts = function getFilteredInstagramPosts(state) {
	  return state.analyticsAssetList.get('filteredInstagramPosts');
	};
	var getAllFacebookPosts = exports.getAllFacebookPosts = function getAllFacebookPosts(state) {
	  return state.analyticsAssetList.get('facebookPosts');
	};
	var getFilteredFacebookPosts = exports.getFilteredFacebookPosts = function getFilteredFacebookPosts(state) {
	  return state.analyticsAssetList.get('filteredFacebookPosts');
	};
	var getAllTwitterPosts = exports.getAllTwitterPosts = function getAllTwitterPosts(state) {
	  return state.analyticsAssetList.get('twitterPosts');
	};
	var getFilteredTwitterPosts = exports.getFilteredTwitterPosts = function getFilteredTwitterPosts(state) {
	  return state.analyticsAssetList.get('filteredTwitterPosts');
	};
	var getUserVideos = exports.getUserVideos = function getUserVideos(state) {
	  return state.analyticsAssetList.get('userVideos');
	};
	var getCampaignVideos = exports.getCampaignVideos = function getCampaignVideos(state) {
	  return state.analyticsAssetList.get('campaignVideos');
	};
	var getSortBy = exports.getSortBy = function getSortBy(state) {
	  return state.analyticsAssetList.get('sortBy');
	};
	var getFilterBy = exports.getFilterBy = function getFilterBy(state) {
	  return state.analyticsAssetList.get('filterBy');
	};

/***/ },
/* 2259 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getYoutubeVideos = exports.getYoutubeVideos = function getYoutubeVideos(state) {
	  return state.campaignAnalytics.get('youtubeVideos');
	};
	var getInstagramPosts = exports.getInstagramPosts = function getInstagramPosts(state) {
	  return state.campaignAnalytics.get('instagramPosts');
	};
	var getFacebookPosts = exports.getFacebookPosts = function getFacebookPosts(state) {
	  return state.campaignAnalytics.get('facebookPosts');
	};
	var getTwitterPosts = exports.getTwitterPosts = function getTwitterPosts(state) {
	  return state.campaignAnalytics.get('twitterPosts');
	};
	var isLoading = exports.isLoading = function isLoading(state) {
	  return state.campaignAnalytics.get('loading');
	};

/***/ },
/* 2260 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getAssignDeliverable = exports.getAssignDeliverable = function getAssignDeliverable(state) {
	  return state.deliverableAssign.get('deliverable');
	};
	var getDeliverableId = exports.getDeliverableId = function getDeliverableId(state) {
	  return state.deliverableAssign.getIn(['deliverable', 'id']);
	};

/***/ },
/* 2261 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDeliverableId = exports.getDeliverableId = function getDeliverableId(state) {
	  return state.deliverable.getIn(['data', 'id']);
	};
	var getDeliverableName = exports.getDeliverableName = function getDeliverableName(state) {
	  return state.deliverable.getIn(['data', 'title']);
	};
	var getDocumentId = exports.getDocumentId = function getDocumentId(state) {
	  return state.deliverable.getIn(['mostRecentDocument', 'id']);
	};
	var getDocumentApproved = exports.getDocumentApproved = function getDocumentApproved(state) {
	  return state.deliverable.getIn(['data', 'document', 'approved']);
	};
	var getDeliverableComments = exports.getDeliverableComments = function getDeliverableComments(state) {
	  return state.deliverable.getIn(['data', 'comments']);
	};
	var getDiscussionId = exports.getDiscussionId = function getDiscussionId(state) {
	  return state.deliverable.getIn(['data', 'discussion', 'id']);
	};
	var getCampaignId = exports.getCampaignId = function getCampaignId(state) {
	  return state.deliverable.getIn(['data', 'discussion', 'campaign', 'id']);
	};
	var getCampaignName = exports.getCampaignName = function getCampaignName(state) {
	  return state.deliverable.getIn(['data', 'discussion', 'campaign', 'name']);
	};
	var getDiscussionName = exports.getDiscussionName = function getDiscussionName(state) {
	  return state.deliverable.getIn(['data', 'discussion', 'name']);
	};
	var getCommentsPerPage = exports.getCommentsPerPage = function getCommentsPerPage(state) {
	  return state.deliverable.get('commentsPerPage');
	};
	var getActiveCommentsPage = exports.getActiveCommentsPage = function getActiveCommentsPage(state) {
	  return state.deliverable.get('activeCommentsPage');
	};
	var getDocumentByVersion = exports.getDocumentByVersion = function getDocumentByVersion(state, version) {
	  return state.deliverable.getIn(['data', 'documents', '' + version]);
	};

/***/ },
/* 2262 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDiscussionsList = exports.getDiscussionsList = function getDiscussionsList(state) {
	  return state.discussionList.get('discussions');
	};
	var getDiscussionIsLoaded = exports.getDiscussionIsLoaded = function getDiscussionIsLoaded(state, discussionId) {
	  return state.discussionList.getIn(['discussions', discussionId]);
	};
	var getDiscussionUnreadMessageCount = exports.getDiscussionUnreadMessageCount = function getDiscussionUnreadMessageCount(state, discussionId) {
	  return state.discussionList.getIn(['discussions', discussionId, 'unreadMessageCount']);
	};

/***/ },
/* 2263 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getData = exports.getData = function getData(state) {
	  return state.trackAssetModal.get('data');
	};

/***/ },
/* 2264 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getOnboardingState = exports.getOnboardingState = function getOnboardingState(state) {
	  return state.userOnboarding.get('viewedOnboarding');
	};

/***/ },
/* 2265 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getHasUserSettings = exports.getHasUserSettings = function getHasUserSettings(state) {
	  return state.userSettings.get('hasUserSettings');
	};
	var getSettingsId = exports.getSettingsId = function getSettingsId(state) {
	  return state.userSettings.getIn(['settings', 'id']);
	};

/***/ },
/* 2266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  joinTitle: 'Join the Dyzio Influencer Network today',
	
	  joinDescription: _react2.default.createElement(
	    'span',
	    null,
	    'We offer you the opportunity to collaborate with global brands, on new and exciting briefs.',
	    _react2.default.createElement('br', null),
	    'We just ask that you sign-in with instagram, so we can verify who you are!'
	  ),
	
	  featureList: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Get paid to produce content for the brands you love:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Sign-up to our exclusive influencer network and receive briefs direct from the Dyzio team'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Get a free media kit and personal page (coming soon)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Create your own campaigns and reports (coming soon)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'You choose the campaigns that you want to work on'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'We believe influencers should create and be creative'
	      )
	    )
	  ),
	
	  applicationFormInstructions: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'Please fill in this short form to complete your application.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The Dyzio Influencer Network is free to join, no contracts and your data is not shared without your permission'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'All influencer accounts are manually checked by our team before gaining access to the platform, we\u2019ll be in touch soon.'
	    )
	  )
	};

/***/ },
/* 2267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTypeformEmbed = __webpack_require__(1574);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-undef */
	var _require = __webpack_require__(2351),
	    tagsJson = _require.tagsJson;
	
	var getTypeFormUrl = function getTypeFormUrl(newInfluencer) {
	  var id = newInfluencer.id,
	      _newInfluencer$attrib = newInfluencer.attributes,
	      name = _newInfluencer$attrib.name,
	      email = _newInfluencer$attrib.email,
	      instagram = _newInfluencer$attrib.instagram,
	      tiktok = _newInfluencer$attrib.tiktok,
	      country = _newInfluencer$attrib.country;
	
	  var baseUrl = 'https://dyzio.typeform.com/to/Tz1F9ciO';
	  var typeFormUrl = baseUrl + '?user_id=' + id + '&name=' + encodeURIComponent(name) + '&email=' + encodeURIComponent(email);
	  typeFormUrl += '&instagram=' + instagram + '&tiktok=' + tiktok + '&country=' + country;
	  console.log(typeFormUrl);
	  return typeFormUrl;
	};
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var landingImg = {
	  margin: 'auto',
	  width: '50%',
	  height: 'auto',
	  display: 'flex'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var ABBOTTLYONTheme = {
	  headerLogo: {
	    src: '/themes/theme/abbottlyon/logo.png',
	    alt: 'Abbott Lyon'
	  },
	  darkLogo: {
	    src: '/themes/theme/abbottlyon/logo.png',
	    alt: 'Abbott Lyon'
	  },
	  headerStyle: {
	    backgroundColor: '#EEDDD5',
	    borderBottom: '2px solid #FDF5ED'
	  },
	  linkStyle: {
	    color: '#fff',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Abbott Lyon',
	  tagsTitle: function tagsTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Tell us more about yourself ...'
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'How would you describe your content style? (please select at least one)'
	    );
	  },
	  socialHandle1HtmlTitle: function socialHandle1HtmlTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Your Socials'
	    );
	  },
	  socialHandle2HtmlTitle: function socialHandle2HtmlTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Your Socials'
	    );
	  },
	  socialHandle3HtmlTitle: function socialHandle3HtmlTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Your Socials'
	    );
	  },
	  confirmationTitle: function confirmationTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'One last step (nearly there!)'
	    );
	  },
	  signUpTitle: function signUpTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'What happens now?'
	    );
	  },
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 18+ to sign up)',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '50', src: '/themes/theme/abbottlyon/logo.png', alt: 'Abbott Lyon' })
	  ),
	  shareSite: 'https://reporting.abbottlyon.com',
	  organisationId: '6b7ed405-e8ef-4b8d-9515-f09108e9e367',
	  dobRequired: true,
	  primaryButtonColorStyle: {
	    background: '#EEDDD5',
	    color: 'black',
	    margin: 5
	  },
	  tagButtonColor: 'pink',
	  skipAdditionalHandles: true,
	  skipMainHandles: true,
	  tAndCUrl: '/themes/theme/abbottlyon/AL_terms.pdf',
	  ppUrl: 'https://www.abbottlyon.com/pages/privacy-policy',
	  useLogoOnPreview: true,
	  hideLastCheckbox: false,
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Join the Abbott Lyon Affiliate Programme!'
	    );
	  },
	  personalDetailHtmlBottom: function personalDetailHtmlBottom() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Personal Email Address (Don\'t worry, this will not be shared with any third parties for marketing purposes!)'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Create your profile'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Simply fill in our submission form (This should not take more than five minutes!). Our team members will then review your profile and get back to you soon.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('img', {
	        style: landingImg,
	        src: '/themes/theme/abbottlyon/abbottlyon_signup.png', alt: 'Abbott Lyon'
	      })
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '- Please note that this Affiliate Programme is only available for UK, Ireland, and USA residents only.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '- A member of the Abbott Lyon team will review your profile. If successful you will be welcomed onboard to our Affiliate Programme (We can\'t wait to work together). If not, don\'t worry we will provide you with top tips on how to improve your profile to be considered again in the future.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '- If successful, you will receive free Abbott Lyon jewellery and if you love it (which we are sure you will), we encourage you to share this on your social media platform (Don\'t worry, we will keep you up to date with the beautiful pieces that you will receive and any instructions that you need to follow!)'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'You\'re all set!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thank you for your submission! Please remember to fill in the form below and you can expect to receive an email from us soon.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  typeForm: function typeForm(newInfluencer) {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      newInfluencer && newInfluencer.id && _react2.default.createElement(_reactTypeformEmbed.ReactTypeformEmbed, { url: getTypeFormUrl(newInfluencer) })
	    );
	  },
	  extraCheckboxHtml: function extraCheckboxHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: { marginLeft: 10 } },
	      _react2.default.createElement(
	        'p',
	        null,
	        'I accept the usage rights'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { fontSize: '80%', color: 'grey' } },
	        '(Want more followers?',
	        _react2.default.createElement('br', null),
	        'Discover the benefits of allowing usage rights ',
	        _react2.default.createElement(
	          'a',
	          {
	            target: '_blank',
	            rel: 'noopener noreferrer',
	            href: '/themes/theme/abbottlyon/benefits.pdf'
	          },
	          'here'
	        ),
	        ')'
	      )
	    );
	  },
	  tagsJson: tagsJson,
	  tiktokOnFrontPage: true
	
	};
	
	exports.default = ABBOTTLYONTheme;

/***/ },
/* 2268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddfluenceTheme = {
	  headerLogo: {
	    src: '/themes/theme/addfluence/logo.png',
	    alt: 'Addfluence'
	  },
	  darkLogo: {
	    src: '/themes/theme/addfluence/logo.png',
	    alt: 'Addfluence'
	  },
	  headerStyle: {
	    backgroundImage: 'linear-gradient(to right, #f373a1, #ff9f1e)',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { height: '400px', padding: '10px', backgroundColor: '#ffdaa7' } },
	    _react2.default.createElement('img', { width: '300', src: '/themes/theme/addfluence/logo.png', alt: 'Addfluence', style: { marginTop: 150 } })
	  ),
	  shareSite: 'https://addfluencer.dyzio.co'
	};
	
	exports.default = AddfluenceTheme;

/***/ },
/* 2269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AfterpartyTheme = {
	  headerLogo: {
	    src: '/themes/theme/afterparty/logo.png',
	    alt: 'Afterparty Studios Logo',
	    size: 60
	  },
	  darkLogo: {
	    src: '/themes/theme/afterparty/logo.png',
	    alt: 'Afterparty Studios Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '100', src: '/themes/theme/afterparty/logo.png', alt: 'Afterparty Studios Logo' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'AfterParty Studios Influencer Platform'
	    )
	  ),
	  shareSite: 'https://afterpartyr.dyzio.co'
	};
	
	exports.default = AfterpartyTheme;

/***/ },
/* 2270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var AGENT99_LOGO = '/themes/theme/agent99/logo.png';
	
	var AGENT99Theme = {
	  headerLogo: {
	    src: AGENT99_LOGO,
	    alt: 'AGENT99 Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: AGENT99_LOGO,
	    alt: 'AGENT99 Logo',
	    size: 70
	  },
	  linkStyle: {
	    color: '#c9378d',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #000',
	    height: 80
	  },
	  title: 'Agent99',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '150',
	      src: AGENT99_LOGO, alt: 'AGENT99 Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://agent99r.dyzio.co',
	  isFullWhiteLabel: true
	};
	
	exports.default = AGENT99Theme;

/***/ },
/* 2271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/akara/akara.png';
	var IMG_ALT_TEXT = 'AKARA';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = '32e4196d-6c97-4703-bdc4-3db252e4257b';
	var INSTAGRAM_URL = 'https://www.instagram.com/akarashapesyou';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 70
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  hideLastCheckbox: false,
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true,
	  extraCheckboxHtml: function extraCheckboxHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      '\xA0I am happy for ',
	      IMG_ALT_TEXT,
	      ' to use my collaboration content',
	      _react2.default.createElement('br', null),
	      ' in their promotional material.'
	    );
	  }
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllwynTheme = {
	  headerLogo: {
	    src: '/themes/theme/allwyn/logo.png',
	    alt: 'ALLWYN influencers'
	  },
	  darkLogo: {
	    src: '/themes/theme/allwyn/logo.png',
	    alt: 'ALLWYN influencers',
	    size: 100
	  },
	  headerStyle: {
	    backgroundColor: '#FFF',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'ALLWYN | CAMPAIGNS',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '70', src: '/themes/theme/allwyn/logo.png', alt: 'ALLWYN Influencers' }),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://allwynr.dyzio.co'
	};
	
	exports.default = AllwynTheme;

/***/ },
/* 2273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BdsTheme = {
	  headerLogo: {
	    src: '/themes/theme/bds/logo.png',
	    alt: 'Brandfluencer',
	    size: 40
	  },
	  darkLogo: {
	    src: '/themes/theme/bds/logo.png',
	    alt: 'Brandfluencer Logo',
	    size: 70
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #A0CC3A',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Brandfluencers',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '80', src: '/themes/theme/bds/logo.png', alt: 'Brandfluencers' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Brandfluencers'
	    )
	  ),
	  platformName: 'Brandfluencers',
	  shareSite: 'https://brandfluencersanalytics.bdsmktg.com'
	};
	
	exports.default = BdsTheme;

/***/ },
/* 2274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/bevas/bevas.png';
	var IMG_ALT_TEXT = 'BEVAS';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = '485b0c2a-8764-4c04-ad57-c4cfd69ca8a7';
	var INSTAGRAM_URL = 'https://www.instagram.com/bevascoffee';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 70
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  skipMainHandles: true,
	  skipAdditionalHandles: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  hideLastCheckbox: false,
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true,
	  extraCheckboxHtml: function extraCheckboxHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      '\xA0I am happy for ',
	      IMG_ALT_TEXT,
	      ' to use my collaboration content',
	      _react2.default.createElement('br', null),
	      ' in their promotional material.'
	    );
	  }
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BmbTheme = {
	  headerLogo: {
	    src: '/themes/theme/bmb/logo.png',
	    alt: 'British Master Barbers'
	  },
	  darkLogo: {
	    src: '/themes/theme/bmb/logo-black.png',
	    alt: 'British Master Barbers'
	  },
	  headerStyle: {
	    backgroundColor: '#000',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#FFF',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '250', src: '/themes/theme/bmb/logo.jpg', alt: 'British Master Barbers' })
	  ),
	  shareSite: 'https://bmbr.dyzio.co',
	  organisationId: 'c1616c2e-8904-4456-b2b4-1b7ecaecbf29',
	  captureInfluencerAddressDetails: true,
	  copy: {
	    joinTitle: 'Join our influencer network today',
	
	    joinDescription: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'We offer you the opportunity to collaborate with global brands, on new and exciting briefs.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We just ask that you update your member details so we can verify who you are!'
	      )
	    ),
	
	    featureList: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Please verify your details so we can add you to the network'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Check your Business name'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Add address details so we can add you to our App directory'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Add social handles to benefit from influencer incentives'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Start sharing your content with our community'
	        )
	      )
	    ),
	
	    applicationFormInstructions: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Please fill in this short form to complete your application.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Our Influencer Network is free to join, no contracts and your data is not shared without your permission'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        'All influencer accounts are manually checked by our team before gaining access to the platform, we\u2019ll be in touch soon.'
	      )
	    )
	  }
	};
	
	exports.default = BmbTheme;

/***/ },
/* 2276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/bold-and-grit/bold-and-grit-logo.png';
	var IMG_ALT_TEXT = 'Bold & Grit';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'edb3c551-aa6c-4787-9520-b37c0c40d505';
	var INSTAGRAM_URL = 'https://www.instagram.com/boldandgritcosmetics/';
	
	var ClientTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 100
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = ClientTheme;

/***/ },
/* 2277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = 'https://bornnouli.com/cdn/shop/t/44/assets/logo_440x.png';
	var IMG_ALT_TEXT = 'BORN | NOULI';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = '337b85bc-b9f2-4f84-b16a-76cd3aac5ba3';
	var INSTAGRAM_URL = 'https://www.instagram.com/born_nouli_activewear';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 70
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  hideLastCheckbox: false,
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true,
	  extraCheckboxHtml: function extraCheckboxHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      '\xA0I am happy for ',
	      IMG_ALT_TEXT,
	      ' to use my collaboration content',
	      _react2.default.createElement('br', null),
	      ' in their promotional material.'
	    );
	  }
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var BROADWAY_LOGO = '/themes/theme/broadway/logo.png';
	var BROADWAY_FULL_LOGO = '/themes/theme/broadway/logo-full.png';
	
	var BroadwayTheme = {
	  headerLogo: {
	    src: BROADWAY_LOGO,
	    alt: 'Broadway Logo',
	    size: 75
	  },
	  darkLogo: {
	    src: BROADWAY_LOGO,
	    alt: 'Broadway Logo',
	    size: 75
	  },
	  linkStyle: {
	    color: '#305fab',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #d472c3',
	    height: 80
	  },
	  title: 'Broadway',
	  organisationId: 'd1121be5-13d3-4f5a-82ff-6e49557d40c2',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '100',
	      src: BROADWAY_FULL_LOGO, alt: 'Broadway Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://reports.broadwaysocial.media'
	};
	
	exports.default = BroadwayTheme;

/***/ },
/* 2279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/caffeine-bullet/caffeine-bullet-logo.png';
	var IMG_ALT_TEXT = 'Caffeine Bullet';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'c773bac0-5c9f-420f-89c7-7e300baf7cea';
	var INSTAGRAM_URL = 'https://www.instagram.com/caffeinebullet';
	
	var CaffeineBulletTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 100
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#ea5b3a',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = CaffeineBulletTheme;

/***/ },
/* 2280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var CAMPFIRE = '/themes/theme/campfire/logo.png';
	var CAMPFIRE_DARK_LOGO = '/themes/theme/campfire/logo.png';
	
	var CampfireTheme = {
	  headerLogo: {
	    src: CAMPFIRE,
	    alt: 'Campfire Logo',
	    size: 40
	  },
	  darkLogo: {
	    src: CAMPFIRE_DARK_LOGO,
	    alt: 'Campfire Logo',
	    size: 40
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #FBBD4B',
	    height: 80
	  },
	  title: 'Campfire',
	  isLightOnDark: false,
	  organisationId: '69f06ccc-17de-495a-87fb-fd13afeaa52e',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '60',
	      src: CAMPFIRE, alt: 'Campfire Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.campfire.co.uk'
	};
	
	exports.default = CampfireTheme;

/***/ },
/* 2281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = 'https://www.chubbymealworms.co.uk/cdn/shop/files/NEW-CHUBBY-LOGO_eec9dc13-3080-4ef0-bdb5-b2486df837b5.png';
	var IMG_ALT_TEXT = 'Chubby Mealworms';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'd8dce007-f35f-43ab-926d-6a97167a85dc';
	var INSTAGRAM_URL = 'https://www.instagram.com/chubbymealwormsuk/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 70
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  hideLastCheckbox: false,
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true,
	  extraCheckboxHtml: function extraCheckboxHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      '\xA0I am happy for ',
	      IMG_ALT_TEXT,
	      ' to use my collaboration content',
	      _react2.default.createElement('br', null),
	      ' in their promotional material.'
	    );
	  }
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClimateCitizenTheme = {
	  headerLogo: {
	    src: '/themes/theme/climate-citizen/logo.png',
	    alt: 'Climate Citizen'
	  },
	  darkLogo: {
	    src: '/themes/theme/climate-citizen/logo-black-text.png',
	    alt: 'Climate Citizen',
	    size: 80
	  },
	  headerStyle: {
	    backgroundColor: '#1d1937',
	    borderBottom: '2px solid #37B2AB'
	  },
	  linkStyle: {
	    color: '#DDD',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'CLIMATE CITIZEN',
	  isLightOnDark: true,
	  organisationId: '6990ac5d-f654-47cb-98d4-c43ca7ac1225',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '50', src: '/themes/theme/climate-citizen/logo-black-text.png', alt: 'Climate Citizen' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      { style: { fontSize: 'large' } },
	      'Automated Influencer Tracking'
	    ),
	    _react2.default.createElement('hr', null)
	  ),
	  shareSite: 'https://climate-citizenr.dyzio.co'
	};
	
	exports.default = ClimateCitizenTheme;

/***/ },
/* 2283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CorqTheme = {
	  headerLogo: {
	    src: '/themes/theme/corq/corq-logo.svg',
	    alt: 'Corq Agency Logo',
	    size: 35
	  },
	  darkLogo: {
	    src: '/themes/theme/corq/corq-logo.svg',
	    alt: 'Corq Agency Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 90
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'CORQ CREATORS',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '90', src: '/themes/theme/corq/logo.png', alt: 'Corq Agency Logo' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'CORQ CREATORS'
	    )
	  ),
	  shareSite: 'https://share.corq.studio'
	};
	
	exports.default = CorqTheme;

/***/ },
/* 2284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CorqTheme = {
	  headerLogo: {
	    src: '/themes/theme/corq/corq-logo.svg',
	    alt: 'Corq Agency Logo',
	    size: 35
	  },
	  darkLogo: {
	    src: '/themes/theme/corq/corq-logo.svg',
	    alt: 'Corq Agency Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 90
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Corq Data',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '90', src: '/themes/theme/corq/logo.png', alt: 'Corq Agency Logo' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Corq Agency Influencers'
	    )
	  ),
	  shareSite: 'https://share.corq.studio',
	  hideMyInfluencers: true,
	  hideShortlists: true,
	  hideHomepage: true,
	  disableHelpLinks: true
	};
	
	exports.default = CorqTheme;

/***/ },
/* 2285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CPATheme = {
	  headerLogo: {
	    src: '/themes/theme/crowdpointanalytics/cpa-horizontal.png',
	    alt: 'CrowdPoint Analytics'
	  },
	  darkLogo: {
	    src: '/themes/theme/crowdpointanalytics/cpa-vertical.png',
	    alt: 'CrowdPoint Analytics',
	    size: 100
	  },
	  headerStyle: {
	    backgroundColor: '#FFF',
	    borderBottom: '2px solid #001F5B'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'CROWDPOINT ANALYTICS | CAMPAIGNS',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '200', src: '/themes/theme/crowdpointanalytics/cpa-vertical.png', alt: 'CrowdPoint Analytics' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      { style: { fontSize: 'large' } },
	      'Automated Influencer Campaign Tracking'
	    ),
	    _react2.default.createElement('hr', null)
	  ),
	  shareSite: 'https://share.crowdpointanalytics.com'
	};
	
	exports.default = CPATheme;

/***/ },
/* 2286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/diem/diem.png';
	var IMG_ALT_TEXT = 'DIEM';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'f3d73b90-539e-419c-8f12-25bb812b874c';
	var INSTAGRAM_URL = 'https://www.instagram.com/diemscents';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 70
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  skipMainHandles: true,
	  skipAdditionalHandles: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  hideLastCheckbox: false,
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true,
	  extraCheckboxHtml: function extraCheckboxHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      '\xA0I am happy for ',
	      IMG_ALT_TEXT,
	      ' to use my collaboration content',
	      _react2.default.createElement('br', null),
	      ' in their promotional material.'
	    );
	  }
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/diso/Diso_Logo.webp';
	var IMG_ALT_TEXT = 'Diso';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = '43448027-1676-4091-8879-abd5a390122c';
	var INSTAGRAM_URL = 'https://www.instagram.com/mydisouk/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 70
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  hideLastCheckbox: false,
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true,
	  extraCheckboxHtml: function extraCheckboxHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      '\xA0I am happy for Diso to use my collaboration content',
	      _react2.default.createElement('br', null),
	      ' in their promotional material.'
	    );
	  }
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DisruptTheme = {
	  headerLogo: {
	    src: '/themes/theme/disrupt/logo.png',
	    alt: 'Disrupt - Youth Marketing Agency London'
	  },
	  darkLogo: {
	    src: '/themes/theme/disrupt/logo.png',
	    alt: 'Disrupt - Youth Marketing Agency London'
	  },
	  headerStyle: {
	    backgroundColor: '#ffd200',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { border: '1px solid #333', padding: '10px' } },
	    _react2.default.createElement('img', { height: '200', src: '/themes/theme/disrupt/logo.png', alt: 'Disrupt - Youth Marketing Agency London' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Disrupt - Influencer Agency'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We\'re an agile youth marketing agency in London specialising in brand strategy, content and influencer marketing and media buying in one place, in real-time'
	    )
	  ),
	  shareSite: 'https://disruptr.dyzio.co'
	};
	
	exports.default = DisruptTheme;

/***/ },
/* 2289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = 'https://dogdynamicsstore.com/cdn/shop/files/DogDynamics_140x_1_200x.png';
	var IMG_ALT_TEXT = 'Dog Dynamics';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = '4c28951c-ddaa-409b-8e9d-1f2b60cd7e86';
	var INSTAGRAM_URL = 'https://www.instagram.com/dogdynamicsstore/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 100
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DorchesterTheme = {
	  headerLogo: {
	    src: '/themes/theme/dc/dc-logo.png',
	    alt: 'Dorchester Collection Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: '/themes/theme/dc/logo-dark.png',
	    alt: 'Dorchester Collection Logo',
	    size: 60
	  },
	  headerStyle: {
	    backgroundColor: '#000',
	    borderBottom: '2px solid #CCC',
	    height: 80
	  },
	  linkStyle: {
	    color: '#FFF',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Dorchester Collection',
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '40', src: '/themes/theme/dc/logo-dark.png', alt: 'Dorchester Collection Logo' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Dochester Collection Creators'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Nine iconic addresses, nine extraordinary hotels, one unique collection. One global compass guiding you to the only destinations you\u2019ll ever need.'
	    )
	  ),
	  shareSite: 'https://share.dorchestercollection.com',
	  copy: {
	    joinTitle: 'Join the Dorchester Collection Creators Network today',
	
	    joinDescription: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'We offer you the opportunity to join our Creator network and collaborate with our hotel collection.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We just ask that you update your member details so we can verify who you are!'
	      )
	    ),
	
	    featureList: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Please verify your details so we can add you to the network'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Check your Creator name'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Add address details so we can add you to our creator directory'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Add social handles to benefit from creator incentives'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Start sharing your content with our community'
	        )
	      )
	    ),
	
	    applicationFormInstructions: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Please fill in this short form to complete your application.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Our Creator Network is free to join, no contracts and your data is not shared without your permission'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        'All creator accounts are manually checked by our team before gaining access to the platform, we\u2019ll be in touch soon.'
	      )
	    )
	  }
	};
	
	exports.default = DorchesterTheme;

/***/ },
/* 2291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var DREAMLAB_LOGO = '/themes/theme/dreamlab/logo.png';
	var DREAMLAB_DARK_LOGO = '/themes/theme/dreamlab/logo_dark.png';
	
	var DreamlabTheme = {
	  headerLogo: {
	    src: DREAMLAB_LOGO,
	    alt: 'Dream Lab Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: DREAMLAB_LOGO,
	    alt: 'Dream Lab Logo',
	    size: 70
	  },
	  linkStyle: {
	    color: '#fff',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#000',
	    borderBottom: '4px solid #ffff',
	    height: 80
	  },
	  title: 'Dream Lab',
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '150',
	      src: DREAMLAB_DARK_LOGO, alt: 'Dream Lab Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://reports.dreamlabstudio.co.uk'
	};
	
	exports.default = DreamlabTheme;

/***/ },
/* 2292 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DyzioTheme = {
	  platformName: 'Dyzio',
	  headerLogo: {
	    src: '/logo-white.png',
	    alt: 'Dyzio Beta'
	  },
	  darkLogo: {
	    src: '/dyzio-logo.png',
	    alt: 'Dyzio Beta'
	  },
	  organisationId: 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96',
	  isLightOnDark: true,
	  shareSite: 'https://share.dyzio.co',
	  title: 'dyzio',
	  termsAndConditionsLink: 'https://dyzio.co/terms-of-use',
	  influencerTermsAndConditionsLink: 'https://dyzio.co/terms-of-use',
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left'
	    },
	    logoProps: {
	      src: 'https://app.dyzio.co/dyzio-logo.png',
	      floated: 'right',
	      size: 'medium'
	    }
	  }
	};
	
	exports.default = DyzioTheme;

/***/ },
/* 2293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var ELEMIS = '/themes/theme/elemis/logo.png';
	var ELEMIS_DARK_LOGO = '/themes/theme/elemis/logo.png';
	
	var ElemisTheme = {
	  headerLogo: {
	    src: ELEMIS,
	    alt: 'Elemis Logo',
	    size: 40
	  },
	  darkLogo: {
	    src: ELEMIS_DARK_LOGO,
	    alt: 'Elemis Logo',
	    size: 40
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #000',
	    height: 80
	  },
	  title: 'Elemis',
	  isLightOnDark: false,
	  organisationId: 'df27f0a0-7ad2-4161-b14e-f928b464a85b',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '60',
	      src: ELEMIS, alt: 'Elemis Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.elemis.com'
	};
	
	exports.default = ElemisTheme;

/***/ },
/* 2294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShopfluenceTheme;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/elemis/logo.png';
	var IMG_ALT_TEXT = 'ELEMIS';
	var SHARE_SITE_URL = 'https://share.elemis.com';
	var ORGANISATION_ID = 'df27f0a0-7ad2-4161-b14e-f928b464a85b';
	var INSTAGRAM_URL = 'https://www.instagram.com/elemis/';
	
	var ShopfluenceTheme = (_ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 50
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram handle or profile link',
	  instagramPlaceholder: '@kimkardashian or instagram.com/kimkardashian',
	  tiktokLabel: 'Tiktok handle or profile link',
	  tiktokPlaceholder: '@kimkardashian or tiktok.com/@kimkardashian',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  skipMainHandles: true,
	  skipAdditionalHandles: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#004f71',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'h3',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        _react2.default.createElement('img', { src: 'https://s3.eu-west-1.amazonaws.com/static.dyzio.co/superfood-midnight-facial.png', width: '200px' })
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\xA0'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up to receive exclusive ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'ELEMIS'
	        ),
	        ' products and ',
	        _react2.default.createElement('br', null),
	        'work with ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'ELEMIS'
	        ),
	        ' on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\xA0'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'The ',
	        IMG_ALT_TEXT,
	        ' campaign is delivered via ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://shopfluence.app/', target: '_blank' },
	          'Shopfluence'
	        ),
	        '.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'If you sign up to an Elemis campaign,',
	        _react2.default.createElement('br', null),
	        ' we hope that you will produce at least one piece of content according to our content brief.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Collaborators who produce good content',
	        _react2.default.createElement('br', null),
	        'are more likely to be included in future campaigns.'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  tiktokOnFrontPage: true
	}, _defineProperty(_ShopfluenceTheme, 'skipMainHandles', true), _defineProperty(_ShopfluenceTheme, 'skipAdditionalHandles', true), _defineProperty(_ShopfluenceTheme, 'hideLastCheckbox', false), _defineProperty(_ShopfluenceTheme, 'signUpTitle', function signUpTitle() {
	  return _react2.default.createElement(
	    'h3',
	    { style: textAlignCentre },
	    'Collaboration Expectations'
	  );
	}), _defineProperty(_ShopfluenceTheme, 'socialHandle1HtmlTitle', function socialHandle1HtmlTitle(preLoaded) {
	  if (preLoaded) {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Your Instagram profile'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We\'ve found and loaded your Instagram profile. Click next to continue.'
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    { style: textAlignCentre },
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add your handles'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'enter your handle(s) and click look up'
	    )
	  );
	}), _defineProperty(_ShopfluenceTheme, 'confirmationTitle', function confirmationTitle() {
	  return _react2.default.createElement(
	    'div',
	    { style: textAlignCentre },
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Confirm your Elemis profile'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ELEMIS campaign is delivered via Shopfluence'
	    )
	  );
	}), _defineProperty(_ShopfluenceTheme, 'shopfluenceTitle', 'Shopfluence'), _defineProperty(_ShopfluenceTheme, 'extraCheckboxHtml', function extraCheckboxHtml() {
	  return _react2.default.createElement(
	    'div',
	    { style: textAlignCentre },
	    '\xA0I am happy for ELEMIS to use my collaboration content',
	    _react2.default.createElement('br', null),
	    ' in their promotional material.'
	  );
	}), _ShopfluenceTheme);
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/elsasorganics/elsas.webp';
	var IMG_ALT_TEXT = 'Elsa\'s Organics';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = '64d05554-a6db-4e0a-ac9e-1ffa4e2d02b2';
	var INSTAGRAM_URL = 'https://www.instagram.com/elsasorganics/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 100
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var EMBELLISHEDLONDON = '/themes/theme/embellishedlondon/logo.png';
	var EMBELLISHEDLONDON_DARK_LOGO = '/themes/theme/embellishedlondon/logo.png';
	
	var EmbellishedlondonTheme = {
	  headerLogo: {
	    src: EMBELLISHEDLONDON,
	    alt: 'Embellished London Logo',
	    size: 80
	  },
	  darkLogo: {
	    src: EMBELLISHEDLONDON_DARK_LOGO,
	    alt: 'Embellished London Logo',
	    size: 80
	  },
	  linkStyle: {
	    color: '#ee1090',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #ee1090',
	    height: 100
	  },
	  title: 'Embellished London',
	  isLightOnDark: false,
	  organisationId: '730c6c28-07a4-47e9-b4ca-e50403ddb5ac',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '80',
	      src: EMBELLISHEDLONDON_DARK_LOGO, alt: 'Embellished London Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.embellishedlondon.com'
	};
	
	exports.default = EmbellishedlondonTheme;

/***/ },
/* 2297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/equi/logo.webp';
	var IMG_ALT_TEXT = 'EQUI London';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'e4de39f1-bb49-491e-a1a7-f05886afb710';
	var INSTAGRAM_URL = 'https://www.instagram.com/equilondon/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 70
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/fiercelondon/fierce.svg';
	var IMG_ALT_TEXT = 'Fierce London';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = '21a267ad-91af-4f43-931e-b36ba05750ac';
	var INSTAGRAM_URL = 'https://www.instagram.com/fierce.london/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 100
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var FLYT_LOGO = '/themes/theme/flyt/flyt-logo.png';
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var FLYTTheme = {
	  headerLogo: {
	    src: FLYT_LOGO,
	    alt: 'FLYT Logo',
	    size: 60
	  },
	  darkLogo: {
	    src: FLYT_LOGO,
	    alt: 'FLYT Logo',
	    size: 150
	  },
	  headerStyle: {
	    backgroundColor: '#272727',
	    borderBottom: '4px solid #272727',
	    height: 90
	  },
	  linkStyle: {
	    color: '#45F4DC',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'FLYT',
	  isLightOnDark: true,
	  organisationId: 'f065f647-ea84-47a2-a4c5-b385108aac4c',
	  tokenThanksRedirectUrl: 'https://flyt-321af.web.app/#/invitacion/ok',
	  tokenThanksMessage: '¡Muchas gracias!',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '180',
	      src: FLYT_LOGO, alt: 'FLYT Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.flytexperience.com',
	  primaryButtonColorStyle: {
	    background: '#45f4dc',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'teal',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Crea tu perfil'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Bienvenid@ a Flyt, tu asistente personal para colaboraciones'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        '\xDAnete a nuestra red y accede a las experiencias y productos que mejor se adapten a tu estilo y audiencia.\xA0'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Disfruta de una amplia selecci\xF3n de colaboraciones a un clic.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '--This block is customisable--'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Si no quieres a\xF1adirlas, pulsa "next"'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Si no quieres a\xF1adirlas, pulsa "next"'
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      '\xBFC\xF3mo describir\xEDas el estilo de tu contenido? (Por favor, selecciona por lo menos una etiqueta)'
	    );
	  }
	};
	
	exports.default = FLYTTheme;

/***/ },
/* 2300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var FREEFOLK = '/themes/theme/freefolk/logo.png';
	var FREEFOLK_DARK_LOGO = '/themes/theme/freefolk/logo.png';
	
	var FreefolkTheme = {
	  headerLogo: {
	    src: FREEFOLK,
	    alt: 'Free Folk Logo',
	    size: 80
	  },
	  darkLogo: {
	    src: FREEFOLK_DARK_LOGO,
	    alt: 'Free Folk Logo',
	    size: 80
	  },
	  linkStyle: {
	    color: '#37AAFA',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #37AAFA',
	    height: 100
	  },
	  title: 'Free Folk',
	  isLightOnDark: false,
	  organisationId: '6b36442f-d960-45c0-97a9-b12b4be626ea',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '80',
	      src: FREEFOLK_DARK_LOGO, alt: 'Free Folk Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.freefolkagency.com'
	};
	
	exports.default = FreefolkTheme;

/***/ },
/* 2301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var GENFLUENCER_LOGO = '/themes/theme/genfluencer/genfluencer-logo.png';
	var GENFLUENCER_DARK_LOGO = '/themes/theme/genfluencer/genfluencer-dark-logo.png';
	
	var GenfluencerTheme = {
	  headerLogo: {
	    src: GENFLUENCER_LOGO,
	    alt: 'Genfluencer Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: GENFLUENCER_DARK_LOGO,
	    alt: 'Genfluencer Logo',
	    size: 70
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #CCFF33',
	    height: 80
	  },
	  title: 'Genfluencer',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '80',
	      src: GENFLUENCER_DARK_LOGO, alt: 'Genfluencer Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Genfluencer'
	    )
	  ),
	  shareSite: 'https://share.genfluencer.io'
	};
	
	exports.default = GenfluencerTheme;

/***/ },
/* 2302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _require = __webpack_require__(2352),
	    tagsJson = _require.tagsJson;
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var GiftaTheme = {
	  headerLogo: {
	    src: '/themes/theme/gifta/logo.png',
	    alt: 'Gifta Logo',
	    size: 70
	  },
	  darkLogo: {
	    // use new logo
	    // src: '/themes/theme/gifta/logo_dark.png',
	    src: '/themes/theme/gifta/logo.png',
	    alt: 'Gifta Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Gifta',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '80',
	      src: '/themes/theme/gifta/logo.png', alt: 'Gifta Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer campaign tracking'
	    )
	  ),
	  shareSite: 'https://share.gifta.co.uk',
	  organisationId: '2beaa438-af69-46f1-b639-f7ae1f374241',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: '/themes/theme/gifta/logo.png',
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to gifta.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up to Gifta and start receiving campaign offers best suited to your feed and audience. We only send you gifted products for campaigns you want to work on.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the Gifta family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brands will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the Gifta platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://to.mysocial.io/s/wbmXLkFD7' },
	          _react2.default.createElement('img', {
	            href: 'https://to.mysocial.io/s/wbmXLkFD7',
	            className: 'logo',
	            style: logoStyle,
	            src: '/themes/theme/gifta/instagram.png',
	            alt: 'Gifta Instagram'
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://to.mysocial.io/s/wbmXLkFD7' },
	          'Our Instagram page'
	        )
	      ),
	      '      ',
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle1HtmlTitle: function socialHandle1HtmlTitle(preLoaded) {
	    if (preLoaded) {
	      return _react2.default.createElement(
	        'div',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Your Instagram profile'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We\'ve found and loaded your Instagram profile. Click next to continue.'
	        )
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Add your handles'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'enter your handle(s) and click look up'
	      )
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  ppUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tAndCUrl: 'https://docs.google.com/document/d/1JDPTrKmRXQHei1pqYGxbmBtPd3ikO402cxbK2AE5IGA/edit?tab=t.0'
	};
	
	exports.default = GiftaTheme;

/***/ },
/* 2303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/glaze/glaze.png';
	var IMG_ALT_TEXT = 'Glaze';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = '6314ef74-3740-4c8e-801d-39c31c41a869';
	var INSTAGRAM_URL = 'https://www.instagram.com/glazecup/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 70
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  hideLastCheckbox: false,
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true,
	  extraCheckboxHtml: function extraCheckboxHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      '\xA0I am happy for Glaze to use my collaboration content',
	      _react2.default.createElement('br', null),
	      ' in their promotional material.'
	    );
	  }
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GLOBALMEDIATheme = {
	  headerLogo: {
	    src: '/themes/theme/global-media/GLOBAL-MEDIA-FINAL-LOGO_TRANSPARENT.png',
	    alt: 'Global Media'
	  },
	  darkLogo: {
	    src: '/themes/theme/global-media/GLOBAL-MEDIA-FINAL-LOGO_TRANSPARENT.png',
	    alt: 'Global Media'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #474648'
	  },
	  linkStyle: {
	    color: '#474648',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Global Media',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '50', src: '/themes/theme/global-media/GLOBAL-MEDIA-FINAL-LOGO_TRANSPARENT.png', alt: 'Global Media' })
	  ),
	  shareSite: 'https://reports.global-media.gr',
	  organisationId: '424c25b6-f3fa-479a-b159-6fc7d6edde31'
	};
	
	exports.default = GLOBALMEDIATheme;

/***/ },
/* 2305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GB42Theme = {
	  headerLogo: {
	    src: '/themes/theme/gb42/logo.png',
	    alt: 'BLUE 42 Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: '/themes/theme/gb42/logo.png',
	    alt: 'BLUE 42 Logo',
	    size: 100
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'BLUE 42 Agency',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '300', src: '/themes/theme/gb42/logo-vertical.png', alt: 'BLUE 42 Logo' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'BLUE 42 Influencers'
	    )
	  ),
	  shareSite: 'https://reports.goblue42.com'
	};
	
	exports.default = GB42Theme;

/***/ },
/* 2306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/herbalessentials/logo.png';
	var IMG_ALT_TEXT = 'Herbal Essentials';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'dfd9c918-0b5e-4ec2-a51f-6fc09f7f3fe6';
	var INSTAGRAM_URL = 'https://www.instagram.com/herbal_essentials';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 100
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HitchTheme = {
	  headerLogo: {
	    src: '/themes/theme/hitch/logo.png',
	    alt: 'Hitch eSports'
	  },
	  darkLogo: {
	    src: '/themes/theme/hitch/logo.png',
	    alt: 'Hitch eSports'
	  },
	  headerStyle: {
	    backgroundColor: '#FFF',
	    borderBottom: '2px solid #BF0000'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'WHAT IS HITCH eSPORTS?'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Hitch eSports is an online marketplace for professional players, teams and organisations enabling them to present commercial branding opportunities to advertising brands and media groups.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The platform is an invite only, automated, transactional marketplace, allowing parties to review, negotiate and transact within a managed environment, making the process more efficient and accountable.'
	    )
	  ),
	  shareSite: 'https://hitchr.dyzio.co'
	};
	
	exports.default = HitchTheme;

/***/ },
/* 2308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IncastTheme = {
	  headerLogo: {
	    src: '/themes/theme/incast/incast-header-logo.png',
	    alt: 'Incast Logo',
	    size: 50
	  },
	  darkLogo: {
	    src: '/themes/theme/incast/incast-logo.png',
	    alt: 'Incast Logo',
	    size: 150
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 50
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Incast Data',
	  isLightOnDark: false,
	  organisationId: 'a9c52633-eb7d-4730-ac3b-90bc3857cb2c',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '120',
	      src: '/themes/theme/incast/incast-logo.png', alt: 'Incast Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Incast Influencer Marketing'
	    )
	  ),
	  shareSite: 'https://shareable.incast.us'
	};
	
	exports.default = IncastTheme;

/***/ },
/* 2309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var INFLUXCROWD_LOGO = '/themes/theme/influxcrowd/logo.svg';
	var INFLUXCROWD_DARK_LOGO = '/themes/theme/influxcrowd/logo.svg';
	
	var InfluxcrowdTheme = {
	  headerLogo: {
	    src: INFLUXCROWD_LOGO,
	    alt: 'Influxcrowd Logo',
	    size: 25
	  },
	  darkLogo: {
	    src: INFLUXCROWD_DARK_LOGO,
	    alt: 'Influxcrowd Logo',
	    size: 25
	  },
	  linkStyle: {
	    color: '#ED0444',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #ED0444',
	    height: 80
	  },
	  title: 'Influxcrowd',
	  isLightOnDark: false,
	  organisationId: '7fb89fec-c49d-43db-ae7e-02b149037d47',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '25',
	      src: INFLUXCROWD_DARK_LOGO, alt: 'Influxcrowd Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.influxcrowd.com'
	};
	
	exports.default = InfluxcrowdTheme;

/***/ },
/* 2310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfluxerTheme = {
	  headerLogo: {
	    src: '/themes/theme/influxer/influxer-logo.png',
	    alt: 'Influxer Agency Logo',
	    size: 35
	  },
	  darkLogo: {
	    src: '/themes/theme/influxer/influxer-logo-dark.png',
	    alt: 'Influxer Agency Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#000',
	    borderBottom: '2px solid #fff',
	    height: 50
	  },
	  linkStyle: {
	    color: '#fff',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Influxer Data',
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: '/themes/theme/influxer/influxer-logo-dark.png', alt: 'Influxer Agency Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Influxer Agency Influencers'
	    )
	  ),
	  shareSite: 'https://brands.influxer.co.uk',
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: 'https://creators.influxer.co.uk/themes/theme/influxer/influxer-logo-dark.png',
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  }
	};
	
	exports.default = InfluxerTheme;

/***/ },
/* 2311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InSpaceTheme = {
	  headerLogo: {
	    src: '/themes/theme/inspace/inspace-logo.png',
	    alt: 'Incast Logo',
	    size: 60
	  },
	  darkLogo: {
	    src: '/themes/theme/inspace/inspace-logo.png',
	    alt: 'InSpace Logo',
	    size: 150
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #FEC909',
	    height: 60
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'InSpace',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '120',
	      src: '/themes/theme/inspace/inspace-logo.png', alt: 'Inspace Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'InSpace'
	    )
	  ),
	  shareSite: 'https://share-influencer.inspace.asia'
	};
	
	exports.default = InSpaceTheme;

/***/ },
/* 2312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var KEMOSABE_LOGO = '/themes/theme/kemosabe/logo.png';
	
	var KemosabeTheme = {
	  headerLogo: {
	    src: KEMOSABE_LOGO,
	    alt: 'Kemosabe Logo',
	    size: 30
	  },
	  darkLogo: {
	    src: KEMOSABE_LOGO,
	    alt: 'Kemosabe Logo',
	    size: 30
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #000',
	    height: 80
	  },
	  title: 'Kemosabe',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '30',
	      src: KEMOSABE_LOGO, alt: 'Kemosabe Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Kemosabe'
	    )
	  ),
	  shareSite: 'https://kemosaber.dyzio.co'
	};
	
	exports.default = KemosabeTheme;

/***/ },
/* 2313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KinTheme = {
	  headerLogo: {
	    src: '/themes/theme/kin/logo.png',
	    alt: 'Kin Community'
	  },
	  darkLogo: {
	    src: '/themes/theme/kin/logo-dark.png',
	    alt: 'Kin Community'
	  },
	  headerStyle: {
	    backgroundColor: '#0d1b2d',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#FFF',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Kin Community',
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '120', src: '/themes/theme/kin/logo-dark.png', alt: 'Kin' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Kin Community Influencers'
	    )
	  ),
	  shareSite: 'https://kin.dyzio.co'
	};
	
	exports.default = KinTheme;

/***/ },
/* 2314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LacajaTheme = {
	  headerLogo: {
	    src: '/themes/theme/lacaja/la_caja_pink_small.png',
	    alt: 'La caja influencers'
	  },
	  darkLogo: {
	    src: '/themes/theme/lacaja/la_caja_pink_small.png',
	    alt: 'La caja influencers',
	    size: 100
	  },
	  headerStyle: {
	    backgroundColor: '#FFF',
	    borderBottom: '2px solid #ff0093'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'LA CAJA PINK | CAMPAIGNS',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '70', src: '/themes/theme/lacaja/la_caja_pink_small.png', alt: 'Lacaja Influencers' }),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://lacajar.dyzio.co'
	};
	
	exports.default = LacajaTheme;

/***/ },
/* 2315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var LANGTON_LOGO = '/themes/theme/langton/logo.png';
	
	var LangtonTheme = {
	  headerLogo: {
	    src: LANGTON_LOGO,
	    alt: 'Langton Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: LANGTON_LOGO,
	    alt: 'Langton Logo',
	    size: 70
	  },
	  linkStyle: {
	    color: '#FF0000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #FF0000',
	    height: 80
	  },
	  title: 'Langton',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LANGTON_LOGO, alt: 'Langton Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://reports.langtonpr.com'
	};
	
	exports.default = LangtonTheme;

/***/ },
/* 2316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var LINEUP_LOGO = '/themes/theme/lineup/lineup_logo.png';
	var LINEUP_DARK_LOGO = '/themes/theme/lineup/lineup_dark_logo.png';
	
	var LINEUPTheme = {
	  headerLogo: {
	    src: LINEUP_LOGO,
	    alt: 'LINEUP Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: LINEUP_DARK_LOGO,
	    alt: 'LINEUP Logo',
	    size: 70
	  },
	  linkStyle: {
	    color: '#fff',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#000',
	    borderBottom: '4px solid #000',
	    height: 80
	  },
	  title: 'LineupSports',
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '150',
	      src: LINEUP_DARK_LOGO, alt: 'LINEUP Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://lineupr.dyzio.co',
	  isFullWhiteLabel: true
	};
	
	exports.default = LINEUPTheme;

/***/ },
/* 2317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = 'https://luna-daily.com/cdn/shop/files/luna-logo.png';
	var IMG_ALT_TEXT = 'Luna Daily';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'df6286a8-7593-4b01-993b-0c7a89e7db2c';
	var INSTAGRAM_URL = 'https://www.instagram.com/luna_daily_official';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 70
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  hideLastCheckbox: false,
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true,
	  extraCheckboxHtml: function extraCheckboxHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      '\xA0I am happy for ',
	      IMG_ALT_TEXT,
	      ' to use my collaboration content',
	      _react2.default.createElement('br', null),
	      ' in their promotional material.'
	    );
	  }
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarmaladeTheme = {
	  headerLogo: {
	    src: '/themes/theme/marmalade/marmalade-logo.png',
	    alt: 'Marmalade Agency Logo',
	    size: 35
	  },
	  darkLogo: {
	    src: '/themes/theme/marmalade/marmalade-logo.png',
	    alt: 'Marmalade Agency Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 70
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Marmalade Data',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '50', src: '/themes/theme/marmalade/marmalade-logo.png', alt: 'Marmalade Agency Logo' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Marmalade Agency Influencers'
	    )
	  ),
	  shareSite: 'https://marmalader.dyzio.co'
	};
	
	exports.default = MarmaladeTheme;

/***/ },
/* 2319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarshallTheme = {
	  headerLogo: {
	    src: '/themes/theme/marshall/logo.png',
	    alt: 'Marshall Logo'
	  },
	  darkLogo: {
	    src: '/themes/theme/marshall/logo.png',
	    alt: 'Marshall Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '120', src: '/themes/theme/marshall/marshall_logo_120px.png', alt: 'Marshall Logo' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Marshall Influencers'
	    )
	  ),
	  shareSite: 'https://marshallr.dyzio.co'
	};
	
	exports.default = MarshallTheme;

/***/ },
/* 2320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var MECINC_LOGO = '/themes/theme/mecinc/mecInc-logo.jpg';
	
	var MecIncTheme = {
	  organisationId: '9aae0ea7-27e1-447e-a17d-b180a3742a4e',
	  headerLogo: {
	    src: MECINC_LOGO,
	    alt: 'Mec Inc Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: MECINC_LOGO,
	    alt: 'Mec Inc Logo',
	    size: 70
	  },
	  linkStyle: {
	    color: '#fff',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#000',
	    borderBottom: '4px solid #000',
	    height: 80
	  },
	  title: 'Mec Inc.',
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '150',
	      src: MECINC_LOGO, alt: 'Mec Inc Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Mec Inc.'
	    )
	  ),
	  shareSite: 'https://share.mecinc.gg'
	};
	
	exports.default = MecIncTheme;

/***/ },
/* 2321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _require = __webpack_require__(2353),
	    tagsJson = _require.tagsJson;
	
	// eslint-disable-next-line max-len
	
	
	var MINGOAPP_LOGO = '/themes/theme/mingoApp/mingoApp-logo.png';
	var MINGOAPP_DARK_LOGO = '/themes/theme/mingoApp/mingoApp-dark-logo.png';
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var MingoAppTheme = {
	  organisationId: '9aae0ea7-27e1-447e-a17d-b180a3742a4e',
	  headerLogo: {
	    src: MINGOAPP_LOGO,
	    alt: 'Mingo App Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: MINGOAPP_DARK_LOGO,
	    alt: 'Mingo App Logo',
	    size: 70
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #03A8C2',
	    height: 80
	  },
	  title: 'Mingo App',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '80',
	      src: MINGOAPP_DARK_LOGO, alt: 'Mingo App Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Mingo App'
	    )
	  ),
	  shareSite: 'https://share.mingoapp.dk ',
	  primaryButtonColorStyle: {
	    background: '#03A8C2',
	    color: 'white',
	    margin: 5
	  },
	  // secondaryButtonColorStyle: {
	  //   background: '#a5a5a5',
	  //   color: 'white',
	  //   margin: 5,
	  // },
	  tagButtonColor: 'blue',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Opret profil'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Velkommen til Mingo App'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Opret din profil, s\xE5 du kan deltage i l\xE6kre kampagner i Mingo App.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Vi ser frem til samarbejdet med dig, '
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. V\xE6r \xE6rlig i dit content, n\xE5r du fort\xE6ller om kampagnens produkter.',
	        _react2.default.createElement('br', null),
	        '2. V\xE6r kreativ i dit content, det giver virksomheder motivation til at bruge dig igen.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Tak for din tilmelding!'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  // socialHandle1HtmlTop: () => (
	  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
	  // ),
	  // socialHandle1HtmlBottom: () => (
	  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
	  // ),
	  // socialHandle2HtmlTop: () => (
	  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
	  // ),
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Det er ikke et krav at udfylde alle felter.'
	    );
	  },
	  // socialHandle3HtmlTop: () => (
	  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
	  // ),
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Det er ikke et krav at udfylde alle felter.'
	    );
	  },
	  // personalDetailHtmlTop: () => (
	  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
	  // ),
	  // personalDetailHtmlBottom: () => (
	  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
	  // ),
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'V\xE6lg dine interesser her (v\xE6lg mindst to)'
	    );
	  },
	  // tagsHtmlBottom: () => (
	  //   <h3 style={textAlignCentre}>--This block is customisable--</h3>
	  // ),
	  tagsJson: tagsJson,
	  tAndCUrl: 'https://dyzio.co/terms-of-use'
	};
	
	exports.default = MingoAppTheme;

/***/ },
/* 2322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var MOI_LOGO = '/themes/theme/moi/moi-logo.png';
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var MOITheme = {
	  headerLogo: {
	    src: MOI_LOGO,
	    alt: 'MOI Logo',
	    size: 80
	  },
	  darkLogo: {
	    src: MOI_LOGO,
	    alt: 'MOI Logo',
	    size: 150
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid rgb(111 111 111)',
	    height: 90
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'MOI-Digital',
	  isLightOnDark: false,
	  organisationId: 'efcb872a-50d9-417c-b6a5-ba427dba4c84',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '120',
	      src: MOI_LOGO, alt: 'MOI Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://moir.dyzio.co',
	  primaryButtonColorStyle: {
	    background: '#000',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'teal',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      '--Form Title--'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '--Customisable tab title--'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '--This block is customisable--'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '--Customisable sign up info title--'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '--This block is customisable--'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '--This block is customisable--'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  socialHandle1HtmlTop: function socialHandle1HtmlTop() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      '--This block is customisable--'
	    );
	  },
	  socialHandle1HtmlBottom: function socialHandle1HtmlBottom() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      '--This block is customisable--'
	    );
	  },
	  socialHandle2HtmlTop: function socialHandle2HtmlTop() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      '--This block is customisable--'
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      '--This block is customisable--'
	    );
	  },
	  socialHandle3HtmlTop: function socialHandle3HtmlTop() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      '--This block is customisable--'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      '--This block is customisable--'
	    );
	  },
	  personalDetailHtmlTop: function personalDetailHtmlTop() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      '--This block is customisable--'
	    );
	  },
	  personalDetailHtmlBottom: function personalDetailHtmlBottom() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      '--This block is customisable--'
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      '--This block is customisable--'
	    );
	  },
	  tagsHtmlBottom: function tagsHtmlBottom() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      '--This block is customisable--'
	    );
	  }
	};
	
	exports.default = MOITheme;

/***/ },
/* 2323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var MONUMENTAL_LOGO = '/themes/theme/monumental/logo.png';
	
	var MonumentalTheme = {
	  headerLogo: {
	    src: MONUMENTAL_LOGO,
	    alt: 'Monumental Logo',
	    size: 30
	  },
	  darkLogo: {
	    src: MONUMENTAL_LOGO,
	    alt: 'Monumental Logo',
	    size: 30
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#F2E3AB',
	    borderBottom: '4px solid #000',
	    height: 80
	  },
	  title: 'Monumental',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '30',
	      src: MONUMENTAL_LOGO, alt: 'Monumental Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Monumental'
	    )
	  ),
	  shareSite: 'https://reports.monumentalmarketing.co.uk'
	};
	
	exports.default = MonumentalTheme;

/***/ },
/* 2324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var MOONBOOTS_LOGO = '/themes/theme/moonboots/logo.png';
	var MOONBOOTS_DARK_LOGO = '/themes/theme/moonboots/logo-dark.png';
	
	var MOONBOOTSTheme = {
	  headerLogo: {
	    src: MOONBOOTS_DARK_LOGO,
	    alt: 'MOONBOOTS Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: MOONBOOTS_DARK_LOGO,
	    alt: 'MOONBOOTS Logo',
	    size: 70
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #000000',
	    height: 80
	  },
	  title: 'MOONBOOTS',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: MOONBOOTS_DARK_LOGO, alt: 'MOONBOOTS Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.mymoonboots.io'
	};
	
	exports.default = MOONBOOTSTheme;

/***/ },
/* 2325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/mothercuppa/logo.png';
	var IMG_ALT_TEXT = 'Mother Cuppa';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'd8c22b99-869b-4419-83c3-479139f3498d';
	var INSTAGRAM_URL = 'https://www.instagram.com/mother_cuppatea/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 100
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MsqsourceTheme = {
	  headerLogo: {
	    src: '/themes/theme/msqsource/M3_Labs_Logo_Blue.png',
	    alt: 'Msqsource Logo'
	  },
	  darkLogo: {
	    src: '/themes/theme/msqsource/M3_Labs_Logo_Blue.png',
	    alt: 'Msqsource Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #0000eb'
	  },
	  linkStyle: {
	    color: '#0000eb',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  organisationId: 'b46dd5bc-86bf-4fc8-9de7-990816a26e0c',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '50', src: '/themes/theme/msqsource/M3_Labs_Logo_Blue.png', alt: 'Msqsource Logo' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.msqpartners.com',
	  copy: {
	    joinTitle: 'Join the Travlrr Influencer Network today',
	
	    joinDescription: _react2.default.createElement(
	      'span',
	      null,
	      'We offer you the opportunity to collaborate with global travel brands, on new and exciting briefs.',
	      _react2.default.createElement('br', null),
	      'We just ask that you sign-in with instagram, so we can verify who you are!'
	    ),
	
	    featureList: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Get paid to produce content for the brands you love:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Join our exclusive travel and lifestyle influencer network'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Get recommended to our clients and receive new briefs direct from the Travlrr team'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'You choose the campaigns that you want to work on'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'We believe influencers should create and be creative'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'No joining fees! We will only deduct our commission when you get paid'
	        )
	      )
	    ),
	
	    applicationFormInstructions: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Please fill in this short form to complete your application.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The Travlrr Influencer Network is free to join, no contracts and your data is not shared without your permission'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        'All influencer accounts are manually checked by our team before gaining access to the platform, we\u2019ll be in touch soon.'
	      )
	    )
	  },
	  influencerTermsAndConditionsLink: 'https://www.travlrr.co/influencer-network-terms-conditions'
	};
	
	exports.default = MsqsourceTheme;

/***/ },
/* 2327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/myota/myota-small.png';
	var IMG_ALT_TEXT = 'Myota Health';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'a72ddf5a-eace-42fb-b1f4-6e000cc36622';
	var INSTAGRAM_URL = 'https://www.instagram.com/myotahealth';
	
	var CaffeineBulletTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 60
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#FFF',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = CaffeineBulletTheme;

/***/ },
/* 2328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/nl-beauty/logo.png';
	var IMG_ALT_TEXT = 'NL BEAUTY';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'ee2dd50e-7f98-42ce-8021-6163829b7aed';
	var INSTAGRAM_URL = 'https://www.instagram.com/nlbeauty/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 50
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram handle or profile link',
	  instagramPlaceholder: '@kimkardashian or instagram.com/kimkardashian',
	  tiktokLabel: 'Tiktok handle or profile link',
	  tiktokPlaceholder: '@kimkardashian or tiktok.com/@kimkardashian',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#004f71',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'The ',
	        IMG_ALT_TEXT,
	        ' campaign is delivered via ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://shopfluence.app/', target: '_blank' },
	          'Shopfluence'
	        ),
	        '.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'If you sign up to an NL BEAUTY campaign,',
	        _react2.default.createElement('br', null),
	        ' we hope that you will produce at least one piece of content according to our content brief.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Collaborators who produce good content',
	        _react2.default.createElement('br', null),
	        'are more likely to be included in future campaigns.'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  tiktokOnFrontPage: true,
	  skipMainHandles: true,
	  skipAdditionalHandles: true,
	  hideLastCheckbox: false,
	  signUpTitle: function signUpTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Collaboration Expectations'
	    );
	  },
	  socialHandle1HtmlTitle: function socialHandle1HtmlTitle() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Add your handles'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'enter your handle(s) and click look up'
	      )
	    );
	  },
	  confirmationTitle: function confirmationTitle() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Confirm your NL BEAUTY profile'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The NL BEAUTY campaign is delivered via Shopfluence'
	      )
	    );
	  },
	  shopfluenceTitle: 'Shopfluence',
	  extraCheckboxHtml: function extraCheckboxHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      '\xA0I am happy for NL BEAUTY to use my collaboration content',
	      _react2.default.createElement('br', null),
	      ' in their promotional material.'
	    );
	  }
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NovaiTheme = {
	  headerLogo: {
	    src: '/themes/theme/novai/logo.svg',
	    alt: 'NOVAI influencers'
	  },
	  darkLogo: {
	    src: '/themes/theme/novai/logo.svg',
	    alt: 'NOVAI influencers',
	    size: 100
	  },
	  headerStyle: {
	    backgroundColor: '#FFF',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'NOVAI | CAMPAIGNS',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '70', src: '/themes/theme/novai/logo.svg', alt: 'NOVAI Influencers' }),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://reports.novaiinfluencer.ai'
	};
	
	exports.default = NovaiTheme;

/***/ },
/* 2330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var NTW_LOGO = '/themes/theme/ntw/logo.svg';
	var NTW_DARK_LOGO = '/themes/theme/ntw/logo.svg';
	
	var NTWTheme = {
	  headerLogo: {
	    src: NTW_LOGO,
	    alt: 'NTW Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: NTW_DARK_LOGO,
	    alt: 'NTW Logo',
	    size: 70
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #E94E1A',
	    height: 80
	  },
	  title: 'NTW',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: NTW_DARK_LOGO, alt: 'NTW Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://ntwr.dyzio.co'
	};
	
	exports.default = NTWTheme;

/***/ },
/* 2331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = 'https://store.paddington.com/cdn/shop/files/PN_franchise_logo_cd849b5f-df2d-415c-948f-9fb75c90b041_1000x.png';
	var IMG_ALT_TEXT = 'Paddington';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = '248fad8f-4d81-4bc0-a728-48faaf642614';
	var INSTAGRAM_URL = 'https://www.instagram.com/paddingtonbear/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 70
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  hideLastCheckbox: false,
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true,
	  extraCheckboxHtml: function extraCheckboxHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      '\xA0I am happy for ',
	      IMG_ALT_TEXT,
	      ' to use my collaboration content',
	      _react2.default.createElement('br', null),
	      ' in their promotional material.'
	    );
	  }
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/palome/palome_cover2.jpg';
	var IMG_ALT_TEXT = 'PALOME';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = '16893ef0-c96a-436f-b70c-a4c438cf7e0c';
	var INSTAGRAM_URL = 'https://www.instagram.com/palomeofficial/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 50
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#efefef',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#004f71',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'h3',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\xA0'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up to receive exclusive ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'PALOME'
	        ),
	        ' products and work with ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'PALOME'
	        ),
	        ' on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\xA0'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'The ',
	        IMG_ALT_TEXT,
	        ' campaign is delivered via ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://shopfluence.app/', target: '_blank' },
	          'Shopfluence'
	        ),
	        '.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'If you sign up to a PALOME campaign,',
	        _react2.default.createElement('br', null),
	        ' we hope that you will produce at least one piece of content according to our content brief.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Collaborators who produce good content',
	        _react2.default.createElement('br', null),
	        'are more likely to be included in future campaigns.'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  tiktokOnFrontPage: true,
	  skipMainHandles: true,
	  skipAdditionalHandles: true,
	  hideLastCheckbox: false,
	  signUpTitle: function signUpTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Collaboration Expectations'
	    );
	  },
	  socialHandle1HtmlTitle: function socialHandle1HtmlTitle() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Add your handles'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'enter your handle(s) and click look up'
	      )
	    );
	  },
	  confirmationTitle: function confirmationTitle() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Confirm your PALOME profile'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The PALOME campaign is delivered via Shopfluence'
	      )
	    );
	  },
	  shopfluenceTitle: 'Shopfluence',
	  extraCheckboxHtml: function extraCheckboxHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: textAlignCentre },
	      '\xA0I am happy for PALOME to use my collaboration content',
	      _react2.default.createElement('br', null),
	      ' in their promotional material.'
	    );
	  }
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var PARENTSTARS_LOGO = '/themes/theme/parentstars/logo.jpeg';
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var minHeight100 = {
	  'min-height': '100px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center',
	  'font-size': '15px'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  'font-size': '12px',
	  padding: '0 20px'
	};
	
	var PARENTSTARSTheme = {
	  headerLogo: {
	    src: PARENTSTARS_LOGO,
	    alt: 'PARENTSTARS Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: PARENTSTARS_LOGO,
	    alt: 'PARENTSTARS Logo',
	    size: 70
	  },
	  linkStyle: {
	    color: '#c9378d',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #302c6b',
	    height: 80
	  },
	  title: 'ParentStars',
	  organisationId: '715455ac-7059-4d1c-9ed6-9d420c00fde3',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '150',
	      src: PARENTSTARS_LOGO, alt: 'PARENTSTARS Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight100 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Welcome to ParentStars'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Join our network of talented parent creators for the opportunity to collaborate with more of the UK\u2019s leading children\u2019s brands.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight100 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Ready to Create Your Account\u2026'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight100 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Sign-up completed'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  shareSite: 'https://share.parentstars.co.uk',
	  isFullWhiteLabel: true
	};
	
	exports.default = PARENTSTARSTheme;

/***/ },
/* 2334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PgoneTheme = {
	  headerLogo: {
	    src: '/themes/theme/pgone/logo.png',
	    alt: 'PG One Logo',
	    size: 50
	  },
	  darkLogo: {
	    src: '/themes/theme/pgone/logo.png',
	    alt: 'PG One Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '120', src: '/themes/theme/pgone/logo.png', alt: 'PG One Logo' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'PG One Influencers'
	    )
	  ),
	  shareSite: 'https://pgoner.dyzio.co'
	};
	
	exports.default = PgoneTheme;

/***/ },
/* 2335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var PULSE_LOGO = '/themes/theme/pulse/logo.png';
	var PULSE_DARK_LOGO = '/themes/theme/pulse/logo.png';
	
	var PulseTheme = {
	  headerLogo: {
	    src: PULSE_LOGO,
	    alt: 'Pulse Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: PULSE_DARK_LOGO,
	    alt: 'Pulse Logo',
	    size: 70
	  },
	  linkStyle: {
	    color: '#AB2923',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #AB2923',
	    height: 80
	  },
	  title: 'Pulse',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: PULSE_DARK_LOGO, alt: 'Pulse Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.pulse.africa'
	};
	
	exports.default = PulseTheme;

/***/ },
/* 2336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var RIGHTLANDER_LOGO = '/themes/theme/rightlander/rightlander-logo.png';
	var RIGHTLANDER_DARK_LOGO = '/themes/theme/rightlander/rightlander-dark-logo.png';
	
	var RightlanderTheme = {
	  headerLogo: {
	    src: RIGHTLANDER_LOGO,
	    alt: 'Rightlander Logo',
	    size: 40
	  },
	  darkLogo: {
	    src: RIGHTLANDER_DARK_LOGO,
	    alt: 'Rightlander Logo',
	    size: 40
	  },
	  linkStyle: {
	    color: '#fff',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#0057bc',
	    borderBottom: '4px solid #0057bc',
	    height: 80
	  },
	  title: 'Rightlander',
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: RIGHTLANDER_DARK_LOGO, alt: 'Rightlander Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://rightlanderr.dyzio.co'
	};
	
	exports.default = RightlanderTheme;

/***/ },
/* 2337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = 'https://www.therippleco.com/cdn/shop/files/logo_6d9f5757-43eb-452e-8fd4-aaaaab50f17c_180x.png';
	var IMG_ALT_TEXT = 'Ripple';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = '4d2f4261-06a1-408e-b31f-58f22ee31ba0';
	var INSTAGRAM_URL = 'https://www.instagram.com/therippleco/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 70
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROOMUNLOCKEDTheme = {
	  headerLogo: {
	    src: '/themes/theme/theroom/Room_Unlocked_logo.png',
	    alt: 'TheRoom influencers'
	  },
	  darkLogo: {
	    src: '/themes/theme/theroom/Room_Unlocked_logo.png',
	    alt: 'TheRoom influencers'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #002a5a'
	  },
	  linkStyle: {
	    color: '#002a5a',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'THE ROOM | CAMPAIGNS',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '50', src: '/themes/theme/theroom/Room_Unlocked_logo.png', alt: 'TheRoom Influencers' })
	  ),
	  shareSite: 'https://reports.roomunlocked.com',
	  organisationId: '5bf5b36b-48cb-4d2a-a304-580db89965f9'
	};
	
	exports.default = ROOMUNLOCKEDTheme;

/***/ },
/* 2339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/sandi/logo.png';
	var IMG_ALT_TEXT = 'Stories & Ink';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'd0b2626a-de90-4dfb-8069-43f0650e3900';
	var INSTAGRAM_URL = 'https://www.instagram.com/storiesandinkskincare';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 70
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var SEHO = '/themes/theme/seho/logo.png';
	var SEHO_DARK_LOGO = '/themes/theme/seho/logo.png';
	
	var SehoTheme = {
	  headerLogo: {
	    src: SEHO,
	    alt: 'Seho Logo',
	    size: 60
	  },
	  darkLogo: {
	    src: SEHO_DARK_LOGO,
	    alt: 'Seho Logo',
	    size: 60
	  },
	  linkStyle: {
	    color: '#2683EF',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #2683EF',
	    height: 100
	  },
	  title: 'Seho',
	  isLightOnDark: false,
	  organisationId: '7a8786cb-31ef-4bdf-8318-eb6ee0e23d2b',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '60',
	      src: SEHO, alt: 'Seho Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.seho.app'
	};
	
	exports.default = SehoTheme;

/***/ },
/* 2341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var SELECTBRITY_LOGO = '/themes/theme/selectbrity/logo.png';
	var SELECTBRITY_FULL_LOGO = '/themes/theme/selectbrity/logo-full.png';
	
	var SelectbrityTheme = {
	  headerLogo: {
	    src: SELECTBRITY_LOGO,
	    alt: 'Selectbrity Logo',
	    size: 75
	  },
	  darkLogo: {
	    src: SELECTBRITY_LOGO,
	    alt: 'Selectbrity Logo',
	    size: 75
	  },
	  linkStyle: {
	    color: '#ffc800',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #003a5b',
	    height: 80
	  },
	  title: 'Selectbrity',
	  organisationId: '99bcbe81-9f60-42bc-83a5-58994c1a351c',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '100',
	      src: SELECTBRITY_FULL_LOGO, alt: 'Selectbrity Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://selectbrityr.dyzio.co'
	};
	
	exports.default = SelectbrityTheme;

/***/ },
/* 2342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _require = __webpack_require__(2354),
	    tagsJson = _require.tagsJson;
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var SENDYTheme = {
	  headerLogo: {
	    src: '/themes/theme/sendy/logo.webp',
	    alt: 'Sendy'
	  },
	  darkLogo: {
	    src: '/themes/theme/sendy/logo.webp',
	    alt: 'Sendy'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #9bd4de'
	  },
	  linkStyle: {
	    color: '#474648',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Sendy',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '50', src: '/themes/theme/sendy/logo.webp', alt: 'Sendy' })
	  ),
	  shareSite: 'https://reports.sendy.io',
	  organisationId: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: '/themes/theme/gifta/logo.png',
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#9bd4de',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'blue',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Apply now'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'An Ambassador program like no other'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'SENDY Ambassadors will share in our success alongside our Stockholders!. We stand by, for and of the people. We ride together, we win together. Welcome to the the next generation of collaboration.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to SENDY.'
	      )
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'h5',
	        { style: textAlignCentre },
	        'The Sendy Shares Program:'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How does it work? You will receive 1 Sendy Share for each $1 you make on the SENDY platform after sharing your listings on instagram. You keep the cash from the gear you sold too.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'We have set aside a minimum Sendy Shares Pool of $500,000 to share with Ambassadors if we exit for $20 million or more. This program is limited. $5k per person and $500k total. First chair gets the pow.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  socialHandle1HtmlTitle: function socialHandle1HtmlTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Link your Gram'
	    );
	  },
	  socialHandle1HtmlTop: function socialHandle1HtmlTop() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'So we can track your insta shares and give you SENDY shares.'
	    );
	  },
	  socialHandle1HtmlBottom: function socialHandle1HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'Every piece of gear posted on SENDY and shared to stories qualifies for the SENDY shares program.'
	    );
	  },
	  socialHandle2HtmlTitle: function socialHandle2HtmlTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'You\'re almost there'
	    );
	  },
	  socialHandle3HtmlTitle: function socialHandle3HtmlTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Last thing'
	    );
	  },
	  personalDetailHtmlTitle: function personalDetailHtmlTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'This is how we get in touch'
	    );
	  },
	  personalDetailHtmlTop: function personalDetailHtmlTop() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'We will email unique links and details about the program'
	    );
	  },
	  personalDetailHtmlBottom: function personalDetailHtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'A dollar of gear sold on SENDY qualifies for a dollar in SENDY shares.'
	    );
	  },
	  tagsTitle: function tagsTitle() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'What\'s your vibe'
	    );
	  },
	  tagsJson: tagsJson,
	  tAndCUrl: 'https://app.termly.io/document/terms-of-use-for-website/90d513e8-5d9e-4661-98d4-2c7c782342e0',
	  ppUrl: 'https://app.termly.io/document/cookie-policy/b8d59005-fbea-48e8-909f-4a78f58e474b'
	};
	
	exports.default = SENDYTheme;

/***/ },
/* 2343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShellRimulaTheme = {
	  headerLogo: {
	    src: '/themes/theme/shellrimula/logo.svg',
	    alt: 'ShellRimula Logo'
	  },
	  darkLogo: {
	    src: '/themes/theme/shellrimula/logo.svg',
	    alt: 'ShellRimula Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #e5001d'
	  },
	  linkStyle: {
	    color: '#e5001d',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  organisationId: '700c1e32-5994-45fc-865f-1d49b8b338b3',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '50', src: '/themes/theme/shellrimula/logo.svg', alt: 'Shell Rimula Logo' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://shellreports.msqpartners.com',
	  copy: {
	    joinTitle: 'Join the Travlrr Influencer Network today',
	
	    joinDescription: _react2.default.createElement(
	      'span',
	      null,
	      'We offer you the opportunity to collaborate with global travel brands, on new and exciting briefs.',
	      _react2.default.createElement('br', null),
	      'We just ask that you sign-in with instagram, so we can verify who you are!'
	    ),
	
	    featureList: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Get paid to produce content for the brands you love:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Join our exclusive travel and lifestyle influencer network'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Get recommended to our clients and receive new briefs direct from the Travlrr team'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'You choose the campaigns that you want to work on'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'We believe influencers should create and be creative'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'No joining fees! We will only deduct our commission when you get paid'
	        )
	      )
	    ),
	
	    applicationFormInstructions: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Please fill in this short form to complete your application.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The Travlrr Influencer Network is free to join, no contracts and your data is not shared without your permission'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        'All influencer accounts are manually checked by our team before gaining access to the platform, we\u2019ll be in touch soon.'
	      )
	    )
	  },
	  influencerTermsAndConditionsLink: 'https://www.travlrr.co/influencer-network-terms-conditions'
	};
	
	exports.default = ShellRimulaTheme;

/***/ },
/* 2344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = 'https://share.dyzio.co/images/shopfluence-small.png';
	var IMG_ALT_TEXT = 'Shopfluence';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'de3b479b-7533-49f6-9c90-24d739d8fc8b';
	var INSTAGRAM_URL = 'https://www.instagram.com/shopfluence.app';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 100
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var SNACKDRAWER_LOGO = '/themes/theme/snackDrawer/logo.png';
	
	var SNACKDRAWERTheme = {
	  headerLogo: {
	    src: SNACKDRAWER_LOGO,
	    alt: 'SNACKDRAWER Logo',
	    size: 70
	  },
	  darkLogo: {
	    src: SNACKDRAWER_LOGO,
	    alt: 'SNACKDRAWER Logo',
	    size: 70
	  },
	  linkStyle: {
	    color: '#6c5543',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #6c5543',
	    height: 80
	  },
	  title: 'Snack Drawer',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '150',
	      src: SNACKDRAWER_LOGO, alt: 'SNACKDRAWER Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.snackdrawer.com'
	};
	
	exports.default = SNACKDRAWERTheme;

/***/ },
/* 2346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var STARBOX = '/themes/theme/starbox/logo.png';
	var STARBOX_DARK_LOGO = '/themes/theme/starbox/logo_dark.png';
	
	var StarboxTheme = {
	  headerLogo: {
	    src: STARBOX,
	    alt: 'Starbox Logo',
	    size: 60
	  },
	  darkLogo: {
	    src: STARBOX_DARK_LOGO,
	    alt: 'Starbox Logo',
	    size: 60
	  },
	  linkStyle: {
	    color: '#fff',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#000',
	    borderBottom: '4px solid #000',
	    height: 100
	  },
	  title: 'Starbox',
	  isLightOnDark: true,
	  organisationId: '928fa5eb-6d12-4382-95f3-d3a80362a73a',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '60',
	      src: STARBOX_DARK_LOGO, alt: 'Starbox Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.starbox.co.uk'
	};
	
	exports.default = StarboxTheme;

/***/ },
/* 2347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StardustTheme = {
	  headerLogo: {
	    src: '/themes/theme/stardust/logo-stardust-light.svg',
	    alt: 'Stardust influencers',
	    size: 100
	  },
	  darkLogo: {
	    src: '/themes/theme/stardust/logo-stardust.svg',
	    alt: 'Stardust influencers',
	    size: 150
	  },
	  headerStyle: {
	    backgroundColor: '#110',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#FFF',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'STARDUST | CAMPAIGNS',
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '150', src: '/themes/theme/stardust/logo-stardust.svg', alt: 'Stardust Influencers' })
	  ),
	  shareSite: 'https://stardustr.dyzio.co',
	  organisationId: 'f11da016-ca79-4f3a-9fe4-1f03bb8ee6c3'
	};
	
	exports.default = StardustTheme;

/***/ },
/* 2348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StylistTheme = {
	  headerLogo: {
	    src: '/themes/theme/stylist/stylist-dark.png',
	    alt: 'Stylist influencers'
	  },
	  darkLogo: {
	    src: '/themes/theme/stylist/stylist-dark-large.png',
	    alt: 'Stylist influencers',
	    size: 100
	  },
	  headerStyle: {
	    backgroundColor: '#FFF',
	    borderBottom: '2px solid #3dd2be'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'STYLIST | CAMPAIGNS',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '70', src: '/themes/theme/stylist/stylist-dark-large.png', alt: 'Stylist Influencers' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      { style: { fontSize: 'large' } },
	      'Automated Influencer Campaign Tracking'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Stylist is the online home of Stylist Magazine, featuring all of the latest lifestyle, fashion, beauty, travel, wellness & entertainment news, all through a feminist lens.'
	    )
	  ),
	  shareSite: 'https://reports.stylist.co.uk',
	  organisationId: '5bf5b36b-48cb-4d2a-a304-580db89965f9'
	};
	
	exports.default = StylistTheme;

/***/ },
/* 2349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuforiaTheme = {
	  headerLogo: {
	    src: '/themes/theme/suforia/suforia-white-text.png',
	    alt: 'Suforia influencers'
	  },
	  darkLogo: {
	    src: '/themes/theme/suforia/suforia-dark-text.png',
	    alt: 'Suforia influencers'
	  },
	  headerStyle: {
	    backgroundColor: '#211e1e',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#FFF',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  isLightOnDark: true,
	  title: 'SUFORIA',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '100', src: '/themes/theme/suforia/suforia-dark-text.png', alt: 'Suforia Influencers' })
	  ),
	  shareSite: 'https://share.suforia.com',
	  organisationId: '5bf5b36b-48cb-4d2a-a304-580db89965f9'
	};
	
	exports.default = SuforiaTheme;

/***/ },
/* 2350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var SweatCoinTheme = {
	  headerLogo: {
	    src: '/themes/theme/sweatcoin/logo.png',
	    alt: 'Sweatcoin Logo',
	    size: 45
	  },
	  darkLogo: {
	    // use new logo
	    // src: '/themes/theme/sweatcoin/logo_dark.png',
	    src: '/themes/theme/sweatcoin/logo.png',
	    alt: 'Sweatcoin Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #001430',
	    height: 60
	  },
	  linkStyle: {
	    color: '#001430',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Sweatcoin',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: '/themes/theme/sweatcoin/logo.png', alt: 'Sweatcoin Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Sweatcoin'
	    )
	  ),
	  shareSite: 'https://sweatcoinr.dyzio.co',
	  organisationId: '8cfa2645-50bc-4700-a548-b9bd6e826ec5',
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: '/themes/theme/sweatcoin/logo.png',
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#001430',
	    color: 'white',
	    margin: 5
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Welcome to Sweatcoin'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Join our creator community to help us run competitions and other exciting creator activities.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for submitting your application to join our Sweatcoin creator community. We will be in touch shortly. Now why don\u2019t you head over to our Instagram page and follow us to stay up to date with all our Creator activity!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://to.mysocial.io/s/sywMulium' },
	          _react2.default.createElement('img', {
	            href: 'https://to.mysocial.io/s/sywMulium',
	            className: 'logo',
	            style: logoStyle,
	            src: '/themes/theme/sweatcoin/instagram.png',
	            alt: 'Sweatcoin Instagram'
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://to.mysocial.io/s/sywMulium' },
	          'Our Sweatcoin page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  socialHandle1HtmlBottom: function socialHandle1HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'Add your social handles so we can keep track of your posts and stories.'
	    );
	  }
	};
	
	exports.default = SweatCoinTheme;

/***/ },
/* 2351 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports.tagsJson = [{
	  type: 'tags',
	  id: '81b684fb-526a-4463-a7ea-e3480b03ec30',
	  attributes: {
	    value: 'Jewellery'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '0da63934-3606-458f-8502-bc82eeedaa16',
	  attributes: {
	    value: 'Fashion'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '84c5c823-86dd-481a-9870-6867a6c22d6a',
	  attributes: {
	    value: 'Beauty'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '31e48572-3d67-4309-8bb9-ccf7ad12e9c9',
	  attributes: {
	    value: 'Skincare'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: 'e62621fc-2e0f-47bb-9b86-f604caf65b25',
	  attributes: {
	    value: 'Lifestyle'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '752c2810-afa0-4707-8a9e-20955e9d9feb',
	  attributes: {
	    value: 'Fitness'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '67200f98-f913-41e1-88a3-bf215ffdc290',
	  attributes: {
	    value: 'Family'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '01317ff0-be15-46bc-b0de-ce5ff9d90582',
	  attributes: {
	    value: 'Travel'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '3f16f291-0599-4463-94bc-461c44d965ff',
	  attributes: {
	    value: 'Interior'
	  },
	  selected: false
	}];

/***/ },
/* 2352 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports.tagsJson = [{
	  type: 'tags',
	  id: '0aa58771-6e41-4dc8-b3ed-47a5209277b2',
	  attributes: {
	    value: 'Fashion'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '039d2191-4685-42b4-90dc-cfd0c4688a6e',
	  attributes: {
	    value: 'Beauty'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '8c9800d2-6d33-483d-8264-6e01bd00dcea',
	  attributes: {
	    value: 'Lifestyle'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '034495db-3c1d-41c4-87b3-a4139a202929',
	  attributes: {
	    value: 'Travel'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '9b939e20-5c12-4403-9220-b8f728fe79cb',
	  attributes: {
	    value: 'Mummy'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: 'f5a1e17b-edd1-444f-8cea-565adc775549',
	  attributes: {
	    value: 'Food'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: 'ee1180ff-2613-4b62-ab50-71815c7a945b',
	  attributes: {
	    value: 'Health and Fitness'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '61b665db-15f8-4f3c-a7f1-93b6fd72531b',
	  attributes: {
	    value: 'Mental health'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '74f3428c-54b6-41f1-aca3-691a2496a964',
	  attributes: {
	    value: 'Business'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: 'e7eadd17-1b32-4716-a00a-b9d86d964fe8',
	  attributes: {
	    value: 'Vegan/Vegetarian'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '11b99c3d-629e-40c8-9db5-b81b6856c9a6',
	  attributes: {
	    value: 'Pets'
	  },
	  selected: false
	}];

/***/ },
/* 2353 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports.tagsJson = [{
	  type: 'tags',
	  id: '40e64437-48fe-4acb-a614-0b146adad6f1',
	  attributes: {
	    value: 'Fashion'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: 'b151e9a1-beae-498b-ae4a-6bb27e875288',
	  attributes: {
	    value: 'Beauty'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '9a5ddfc5-71d7-4857-b643-339e640939b2',
	  attributes: {
	    value: 'Home'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '6c793493-7161-47c7-99ec-f40c511f7ac2',
	  attributes: {
	    value: 'Mommy'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '791e6c3c-e781-451e-bd1d-bee00f96b1e5',
	  attributes: {
	    value: 'Food'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '983a7bb6-ce1e-4486-b310-f5c32929e2db',
	  attributes: {
	    value: 'Health'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '7c0f5cf7-5ed8-438d-8bc7-02b6ee49c9a9',
	  attributes: {
	    value: 'Vegan/vegeterian'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: '1c42628e-44df-453b-9369-1897435c6489',
	  attributes: {
	    value: 'Pets'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: 'a1c5f80b-b890-4ea1-8fe5-f2ad167c1ce5',
	  attributes: {
	    value: 'Lifestyle'
	  },
	  selected: false
	}, {
	  type: 'tags',
	  id: 'f07a4b4c-b0c4-4460-972d-8f0a2aabe444',
	  attributes: {
	    value: 'Sport'
	  },
	  selected: false
	}];

/***/ },
/* 2354 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports.tagsJson = [{
	  type: 'tags',
	  id: 'de8e05f5-9db2-4917-88f9-098d2549c787',
	  attributes: {
	    value: 'climb',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/de8e05f5-9db2-4917-88f9-098d2549c787'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/de8e05f5-9db2-4917-88f9-098d2549c787/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/de8e05f5-9db2-4917-88f9-098d2549c787/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: '1e19f4ec-878c-448e-8841-9914d34d9aef',
	  attributes: {
	    value: 'ride',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/1e19f4ec-878c-448e-8841-9914d34d9aef'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/1e19f4ec-878c-448e-8841-9914d34d9aef/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/1e19f4ec-878c-448e-8841-9914d34d9aef/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: 'aa8a94c5-aaa3-48ab-a280-f107ecab802b',
	  attributes: {
	    value: 'fish',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/aa8a94c5-aaa3-48ab-a280-f107ecab802b'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/aa8a94c5-aaa3-48ab-a280-f107ecab802b/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/aa8a94c5-aaa3-48ab-a280-f107ecab802b/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: 'f8558fb1-ab44-4755-93fe-bc9f26f083e7',
	  attributes: {
	    value: 'hike',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/f8558fb1-ab44-4755-93fe-bc9f26f083e7'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/f8558fb1-ab44-4755-93fe-bc9f26f083e7/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/f8558fb1-ab44-4755-93fe-bc9f26f083e7/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: 'b9b16222-ddf5-4b1a-800b-d9b6fe3afbda',
	  attributes: {
	    value: 'camp',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/b9b16222-ddf5-4b1a-800b-d9b6fe3afbda'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/b9b16222-ddf5-4b1a-800b-d9b6fe3afbda/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/b9b16222-ddf5-4b1a-800b-d9b6fe3afbda/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: '241387db-252d-4b2b-8d24-593c038ec08a',
	  attributes: {
	    value: 'surf',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/241387db-252d-4b2b-8d24-593c038ec08a'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/241387db-252d-4b2b-8d24-593c038ec08a/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/241387db-252d-4b2b-8d24-593c038ec08a/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: 'da5615df-26f2-4601-bb38-ee2a3718bc49',
	  attributes: {
	    value: 'snow',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/da5615df-26f2-4601-bb38-ee2a3718bc49'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/da5615df-26f2-4601-bb38-ee2a3718bc49/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/da5615df-26f2-4601-bb38-ee2a3718bc49/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: '33dd9552-868d-4147-b314-5fc75a94e9db',
	  attributes: {
	    value: 'photos',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/33dd9552-868d-4147-b314-5fc75a94e9db'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/33dd9552-868d-4147-b314-5fc75a94e9db/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/33dd9552-868d-4147-b314-5fc75a94e9db/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: '98ffa49d-0bcc-43fa-97b9-64522757813c',
	  attributes: {
	    value: 'motorsport',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/98ffa49d-0bcc-43fa-97b9-64522757813c'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/98ffa49d-0bcc-43fa-97b9-64522757813c/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/98ffa49d-0bcc-43fa-97b9-64522757813c/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: '70bc01dc-2840-4b5c-90a2-4ecd363c1c13',
	  attributes: {
	    value: 'paddle',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/70bc01dc-2840-4b5c-90a2-4ecd363c1c13'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/70bc01dc-2840-4b5c-90a2-4ecd363c1c13/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/70bc01dc-2840-4b5c-90a2-4ecd363c1c13/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: '8cdd6da7-d0fd-4de8-baba-fd2887573e97',
	  attributes: {
	    value: 'skate',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/8cdd6da7-d0fd-4de8-baba-fd2887573e97'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/8cdd6da7-d0fd-4de8-baba-fd2887573e97/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/8cdd6da7-d0fd-4de8-baba-fd2887573e97/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: '8e6974ed-dfc1-4f76-a3f9-06fbf6e7a65e',
	  attributes: {
	    value: 'wake',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/8e6974ed-dfc1-4f76-a3f9-06fbf6e7a65e'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/8e6974ed-dfc1-4f76-a3f9-06fbf6e7a65e/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/8e6974ed-dfc1-4f76-a3f9-06fbf6e7a65e/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: '0b1f520f-04d1-4cf3-9452-7d4705e60ea0',
	  attributes: {
	    value: 'yoga',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/0b1f520f-04d1-4cf3-9452-7d4705e60ea0'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/0b1f520f-04d1-4cf3-9452-7d4705e60ea0/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/0b1f520f-04d1-4cf3-9452-7d4705e60ea0/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: 'd690580a-9507-4697-81d5-61ce2682b119',
	  attributes: {
	    value: 'travel',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/d690580a-9507-4697-81d5-61ce2682b119'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/d690580a-9507-4697-81d5-61ce2682b119/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/d690580a-9507-4697-81d5-61ce2682b119/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: '638363f0-a624-40dc-b9ec-024518e587ee',
	  attributes: {
	    value: 'you didn\'t list my sport',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/638363f0-a624-40dc-b9ec-024518e587ee'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/638363f0-a624-40dc-b9ec-024518e587ee/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/638363f0-a624-40dc-b9ec-024518e587ee/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}, {
	  type: 'tags',
	  id: '25827d83-e4eb-4427-a995-67e32948acdf',
	  attributes: {
	    value: 'general sending',
	    createdBy: 'Matt Hebden',
	    createdDate: '2022-10-26T16:31:52.039Z'
	  },
	  links: {
	    self: 'https://api2021.dyzio.co/v1/tags/25827d83-e4eb-4427-a995-67e32948acdf'
	  },
	  relationships: {
	    organisation: {
	      meta: {
	        relation: 'primary',
	        readOnly: false
	      },
	      links: {
	        self: 'https://api2021.dyzio.co/v1/tags/25827d83-e4eb-4427-a995-67e32948acdf/relationships/organisation',
	        related: 'https://api2021.dyzio.co/v1/tags/25827d83-e4eb-4427-a995-67e32948acdf/organisation'
	      },
	      data: {
	        type: 'organisations',
	        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c'
	      }
	    }
	  }
	}];

/***/ },
/* 2355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TheInfluencerTheme = {
	  headerLogo: {
	    src: '/themes/theme/the-influencer/logo.png',
	    alt: 'The Content Club Logo',
	    size: 40
	  },
	  darkLogo: {
	    src: '/themes/theme/the-influencer/logo.png',
	    alt: 'The Content Club Logo',
	    size: 70
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 80
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Content Club',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Content Club'
	    )
	  ),
	  platformName: 'Content Club',
	  shareSite: 'https://share.contentclub.es',
	  organisationId: '04ae9be3-5130-4f6a-9344-34ca81e1f994',
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: '/themes/theme/the-influencer/logo.png',
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  }
	};
	
	exports.default = TheInfluencerTheme;

/***/ },
/* 2356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var THEINFLUENCROOMTheme = {
	  headerLogo: {
	    src: '/themes/theme/the-influence-room/the-room-small.png',
	    alt: 'The Influence Room influencers'
	  },
	  darkLogo: {
	    src: '/themes/theme/the-influence-room/the-room-small.png',
	    alt: 'The Influence Room influencers'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #0b1919'
	  },
	  linkStyle: {
	    color: '#0b1919',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'THE INFLUENCE ROOM | CAMPAIGNS',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '50', src: '/themes/theme/the-influence-room/the-room-small.png', alt: 'The Room Influencers' })
	  ),
	  shareSite: 'https://reports.theinfluenceroom.com',
	  organisationId: '5bf5b36b-48cb-4d2a-a304-580db89965f9'
	};
	
	exports.default = THEINFLUENCROOMTheme;

/***/ },
/* 2357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var NottingHillCompanyTheme = {
	  headerLogo: {
	    src: '/themes/theme/thenottinghillcompany/logo.png',
	    alt: 'The Notting Hill Company Logo',
	    size: 100
	  },
	  darkLogo: {
	    // use new logo
	    // src: '/themes/theme/gifta/logo_dark.png',
	    src: '/themes/theme/thenottinghillcompany/logo.png',
	    alt: 'The Notting Hill Company Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'The Notting Hill Company',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: '/themes/theme/thenottinghillcompany/logo.png', alt: 'The Notting Hill Company Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: 'https://share.shopfluence.app',
	  organisationId: '5e5b1e80-9a21-4888-a576-4cc24afe9412',
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: '/themes/theme/thenottinghillcompany/logo.png',
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to The Notting Hill Company.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles to work with The Notting Hill Company on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the The Notting Hill Company family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the The Notting Hill Company Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://to.mysocial.io/s/NLuEM7pfB' },
	          _react2.default.createElement('img', {
	            href: 'https://to.mysocial.io/s/NLuEM7pfB',
	            className: 'logo',
	            style: logoStyle,
	            src: '/themes/theme/thenottinghillcompany/logo.png',
	            alt: 'The Notting Hill Company Instagram'
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://to.mysocial.io/s/NLuEM7pfB' },
	          'Our Instagram page'
	        )
	      ),
	      '      ',
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = NottingHillCompanyTheme;

/***/ },
/* 2358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TheRoomTheme = {
	  headerLogo: {
	    src: '/themes/theme/theroom/theroom-dark.png',
	    alt: 'TheRoom influencers'
	  },
	  darkLogo: {
	    src: '/themes/theme/theroom/theroom-light.png',
	    alt: 'TheRoom influencers'
	  },
	  headerStyle: {
	    backgroundColor: '#002a5a',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#FFF',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'THE ROOM | CAMPAIGNS',
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '50', src: '/themes/theme/theroom/theroom-light.png', alt: 'TheRoom Influencers' })
	  ),
	  shareSite: 'https://reports.theroom.io',
	  organisationId: '5bf5b36b-48cb-4d2a-a304-580db89965f9'
	};
	
	exports.default = TheRoomTheme;

/***/ },
/* 2359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	// eslint-disable-next-line max-len
	var TOPTRUMPS = '/themes/theme/toptrumps/logo.svg';
	
	var LOGO_URL = TOPTRUMPS;
	var IMG_ALT_TEXT = 'Top Trumps';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'db11d3e8-0237-471b-8e44-78390f37a1dc';
	var INSTAGRAM_URL = 'https://www.instagram.com/officialtoptrumps/';
	
	var ShopfluenceTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 100
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = ShopfluenceTheme;

/***/ },
/* 2360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TravlrrTheme = {
	  headerLogo: {
	    src: '/themes/theme/travlrr/travlrr-minimal.png',
	    alt: 'Travlrr Agency Logo'
	  },
	  darkLogo: {
	    src: '/themes/theme/travlrr/travlrr-minimal.png',
	    alt: 'Travlrr Agency Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  organisationId: 'b46dd5bc-86bf-4fc8-9de7-990816a26e0c',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '200', src: '/themes/theme/travlrr/travlrr-new-vertical.png', alt: 'Travlrr Agency Logo' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://travlrrr.dyzio.co',
	  copy: {
	    joinTitle: 'Join the Travlrr Influencer Network today',
	
	    joinDescription: _react2.default.createElement(
	      'span',
	      null,
	      'We offer you the opportunity to collaborate with global travel brands, on new and exciting briefs.',
	      _react2.default.createElement('br', null),
	      'We just ask that you sign-in with instagram, so we can verify who you are!'
	    ),
	
	    featureList: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Get paid to produce content for the brands you love:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Join our exclusive travel and lifestyle influencer network'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Get recommended to our clients and receive new briefs direct from the Travlrr team'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'You choose the campaigns that you want to work on'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'We believe influencers should create and be creative'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'No joining fees! We will only deduct our commission when you get paid'
	        )
	      )
	    ),
	
	    applicationFormInstructions: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Please fill in this short form to complete your application.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The Travlrr Influencer Network is free to join, no contracts and your data is not shared without your permission'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        'All influencer accounts are manually checked by our team before gaining access to the platform, we\u2019ll be in touch soon.'
	      )
	    )
	  },
	  influencerTermsAndConditionsLink: 'https://www.travlrr.co/influencer-network-terms-conditions'
	};
	
	exports.default = TravlrrTheme;

/***/ },
/* 2361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/truestart/true-start-logo.avif';
	var IMG_ALT_TEXT = 'TrueStart Coffee';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = 'cf9cc681-d1a0-4d68-808b-6eaf131842eb';
	var INSTAGRAM_URL = 'https://www.instagram.com/truestartcoffee';
	
	var TrueStartTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 100
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = TrueStartTheme;

/***/ },
/* 2362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoStyle = {
	  height: 60,
	  display: 'block',
	  margin: '0 auto'
	};
	
	var minHeight200 = {
	  'min-height': '200px'
	};
	
	var textAlignCentre = {
	  'text-align': 'center'
	};
	
	var textAlignCentre50p = {
	  'text-align': 'center',
	  padding: '0 50px'
	};
	
	var LOGO_URL = '/themes/theme/umberto-giannini/ug_logo.webp';
	var IMG_ALT_TEXT = 'Umberto Giannini';
	var SHARE_SITE_URL = 'https://share.shopfluence.app';
	var ORGANISATION_ID = '6bb1c5bd-8f30-442f-b343-bca12d3829c2';
	var INSTAGRAM_URL = 'https://www.instagram.com/umbertogiannini/';
	
	var UmbertoGianniniTheme = {
	  headerLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT,
	    size: 100
	  },
	  darkLogo: {
	    src: LOGO_URL,
	    alt: IMG_ALT_TEXT
	  },
	  headerStyle: {
	    backgroundColor: '#eee',
	    borderBottom: '2px solid #000',
	    height: 110
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: IMG_ALT_TEXT,
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: LOGO_URL,
	      alt: IMG_ALT_TEXT
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'influencer gifting'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'powered by shopfluence'
	    )
	  ),
	  shareSite: SHARE_SITE_URL,
	  organisationId: ORGANISATION_ID,
	  instagramLabel: 'Instagram Handle (1,000+ Followers)',
	  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
	  dobLabel: 'Date of birth (You must be 16+ to sign up)',
	  dobRequired: true,
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: LOGO_URL,
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  },
	  primaryButtonColorStyle: {
	    background: '#8068ab',
	    color: 'white',
	    margin: 5
	  },
	  tagButtonColor: 'violet',
	  formTitle: function formTitle() {
	    return _react2.default.createElement(
	      'h3',
	      { style: textAlignCentre },
	      'Create your profile'
	    );
	  },
	  welcomeHtml: function welcomeHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'welcome to ',
	        IMG_ALT_TEXT,
	        '.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Sign up here with your social handles',
	        _react2.default.createElement('br', null),
	        'to work with ',
	        IMG_ALT_TEXT,
	        _react2.default.createElement('br', null),
	        'on their upcoming promotional campaigns.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre50p },
	        'Once you have been selected you will be',
	        _react2.default.createElement('br', null),
	        'sent discount codes to use in the store.'
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  signUpHtml: function signUpHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'To become part of the ',
	        IMG_ALT_TEXT,
	        ' family, we have some simple guidelines to follow;'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '1. If you love it, share it and tag all relevant parties'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '2. Be authentic but get creative in your own unique style'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '3. If you\u2019re not feeling the love, please provide honest and constructive feedback to be eligible for future campaigns'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        '4. The more content you share, the more our brand will choose you for future campaigns'
	      )
	    );
	  },
	  finishedHtml: function finishedHtml() {
	    return _react2.default.createElement(
	      'div',
	      { style: minHeight200 },
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Thanks for signing up to the ',
	        IMG_ALT_TEXT,
	        ' Shopfluence platform. We will review your application and get in touch with any suitable gifting campaigns for you.'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'Please head over to our instagram account (LINK BELOW) and hit the follow button. This is the best way to keep up to date with upcoming campaigns!!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          _react2.default.createElement('img', {
	            href: INSTAGRAM_URL,
	            className: 'logo',
	            style: logoStyle,
	            src: LOGO_URL,
	            alt: IMG_ALT_TEXT
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: INSTAGRAM_URL },
	          'Our Instagram page'
	        )
	      ),
	      _react2.default.createElement('br', null)
	    );
	  },
	  tagsHtmlTop: function tagsHtmlTop() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'Tags'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' }),
	      _react2.default.createElement(
	        'p',
	        { style: textAlignCentre },
	        'How would you describe your content style? (please select at least one)'
	      ),
	      _react2.default.createElement('div', { className: 'spacer small' })
	    );
	  },
	  socialHandle2HtmlBottom: function socialHandle2HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  socialHandle3HtmlBottom: function socialHandle3HtmlBottom() {
	    return _react2.default.createElement(
	      'p',
	      { style: textAlignCentre },
	      'if none to add, please click next'
	    );
	  },
	  // tagsJson, //GIfta requested to hide the tags screen
	  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
	  tiktokOnFrontPage: true
	};
	
	exports.default = UmbertoGianniniTheme;

/***/ },
/* 2363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnderArmourTheme = {
	  headerLogo: {
	    src: '/themes/theme/underarmour/logo.png',
	    alt: 'Under Armour influencers'
	  },
	  darkLogo: {
	    src: '/themes/theme/underarmour/logo.png',
	    alt: 'Under Armour influencers',
	    size: 100
	  },
	  headerStyle: {
	    backgroundColor: '#FFF',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'UNDER ARMOUR | CAMPAIGNS',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '70', src: '/themes/theme/underarmour/logo.png', alt: 'Under Armour Influencers' }),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://underarmourr.dyzio.co'
	};
	
	exports.default = UnderArmourTheme;

/***/ },
/* 2364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UploadTheme = {
	  headerLogo: {
	    src: '/themes/theme/upload/upload-agency.png',
	    alt: 'Upload Agency Logo',
	    size: 45
	  },
	  darkLogo: {
	    src: '/themes/theme/upload/upload-agency-wide.png',
	    alt: 'Upload Agency Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #ef2a30',
	    height: 60
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Upload Data',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '50',
	      src: '/themes/theme/upload/upload-agency-wide.png', alt: 'Upload Agency Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Upload Agency Influencers'
	    )
	  ),
	  shareSite: 'https://share.uploadagency.com',
	  mediaKit: {
	    avatarProps: {
	      size: 'small',
	      avatar: true,
	      floated: 'left',
	      style: {
	        width: 150
	      }
	    },
	    logoProps: {
	      floated: 'right',
	      src: 'https://upload.dyzio.co/themes/theme/upload/upload-logo-wide.png',
	      style: {
	        width: 400,
	        marginTop: 35
	      }
	    }
	  }
	};
	
	exports.default = UploadTheme;

/***/ },
/* 2365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VizzTheme = {
	  headerLogo: {
	    src: '/themes/theme/vizz/logo.png',
	    alt: 'Vizz Agency Logo'
	  },
	  darkLogo: {
	    src: '/themes/theme/vizz/logo.png',
	    alt: 'Vizz Agency Logo'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '2px solid #000'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  title: 'Vizz Agency',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { height: '120', src: '/themes/theme/vizz/logo.png', alt: 'Vizz Agency Logo' }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Vizz Agency Influencers'
	    )
	  ),
	  shareSite: 'https://vizzr.dyzio.co'
	};
	
	exports.default = VizzTheme;

/***/ },
/* 2366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VoxogramTheme = {
	  headerLogo: {
	    src: '/themes/theme/voxogram/logo.png',
	    alt: 'Voxogram'
	  },
	  darkLogo: {
	    src: '/themes/theme/voxogram/logo.png',
	    alt: 'Voxogram'
	  },
	  headerStyle: {
	    backgroundColor: '#FFF',
	    borderBottom: '2px solid #df0098'
	  },
	  linkStyle: {
	    color: '#000',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  isLightOnDark: false,
	  title: 'voxogram',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('img', { height: '80', src: '/themes/theme/voxogram/logo.png', alt: 'Voxogram' })
	  ),
	  shareSite: 'https://app.voxogram.com',
	  mobileRedirectLink: 'www.voxogram.com',
	  facebookClientId: '1517444368400108',
	  disableIntercom: true,
	  isFullWhiteLabel: true,
	  disableHelpLinks: true,
	  hideCopyrightNotices: true,
	  hideSignup: true,
	  hideInfluencerImportExport: true,
	  platformName: 'voxogram',
	  termsAndConditionsLink: 'https://www.voxogram.com/terms-and-conditions'
	};
	
	exports.default = VoxogramTheme;

/***/ },
/* 2367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var WEFLUENS = '/themes/theme/wefluens/wefluens.png';
	var WEFLUENS_DARK_LOGO = '/themes/theme/wefluens/wefluens.png';
	
	var WefluensTheme = {
	  headerLogo: {
	    src: WEFLUENS,
	    alt: 'Wefluens Logo',
	    size: 60
	  },
	  darkLogo: {
	    src: WEFLUENS_DARK_LOGO,
	    alt: 'Wefluens Logo',
	    size: 60
	  },
	  linkStyle: {
	    color: '#DA1F59',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #DA1F59',
	    height: 100
	  },
	  title: 'Wefluens',
	  isLightOnDark: false,
	  organisationId: '542d8875-c943-4b40-a972-150c39ac511b',
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      height: '60',
	      src: WEFLUENS, alt: 'Wefluens Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.wefluens.com'
	};
	
	exports.default = WefluensTheme;

/***/ },
/* 2368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var WILDFUSION_LOGO = '/themes/theme/wildfusion/logo.png';
	
	var WILDFUSIONTheme = {
	  headerLogo: {
	    src: WILDFUSION_LOGO,
	    alt: 'WILDFUSION Logo',
	    size: 30
	  },
	  darkLogo: {
	    src: WILDFUSION_LOGO,
	    alt: 'WILDFUSION Logo',
	    size: 30
	  },
	  linkStyle: {
	    color: '#326598',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#fff',
	    borderBottom: '4px solid #326598',
	    height: 80
	  },
	  title: 'Wild Fusion',
	  isLightOnDark: false,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      width: '80%',
	      src: WILDFUSION_LOGO, alt: 'WILDFUSION Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://share.wildfusions.com',
	  isFullWhiteLabel: true
	};
	
	exports.default = WILDFUSIONTheme;

/***/ },
/* 2369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line max-len
	var WREN_LOGO = '/themes/theme/wren/logo.png';
	var WREN_GREEN_LOGO = '/themes/theme/wren/logo_on_green.png';
	
	var WRENTheme = {
	  headerLogo: {
	    src: WREN_LOGO,
	    alt: 'WREN Logo',
	    size: 80
	  },
	  darkLogo: {
	    src: WREN_GREEN_LOGO,
	    alt: 'WREN Logo',
	    size: 80
	  },
	  linkStyle: {
	    color: '#fff',
	    fontWeight: 800,
	    fontSize: '120%'
	  },
	  headerStyle: {
	    backgroundColor: '#26a85d',
	    borderBottom: '4px solid #26a85d',
	    height: 80
	  },
	  title: 'Wren Kitchens',
	  isLightOnDark: true,
	  loginMessage: _react2.default.createElement(
	    'div',
	    { style: { padding: '10px' } },
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', {
	      width: '40%',
	      src: WREN_GREEN_LOGO, alt: 'WREN Logo'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  ),
	  shareSite: 'https://wrenr.dyzio.co',
	  isFullWhiteLabel: true
	};
	
	exports.default = WRENTheme;

/***/ },
/* 2370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(6);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _authService = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getInfluencerDetails = function getInfluencerDetails(_ref, _ref2) {
	  var email = _ref.email;
	  var contentTags = _ref2.contentTags,
	      brandTags = _ref2.brandTags,
	      description = _ref2.description;
	
	  var cTags = contentTags ? (0, _lodash.replace)(contentTags, /\s+/g, '') : '';
	  var bTags = brandTags ? (0, _lodash.replace)(brandTags, /\s+/g, '') : '';
	
	  var contentTagsArray = cTags.length ? (0, _lodash.split)(cTags, ',') : [];
	  var brandTagsArray = bTags.length ? (0, _lodash.split)(bTags, ',') : [];
	
	  var details = {
	    type: 'influencerDetails',
	    attributes: {
	      email: email,
	      associated: false,
	      contentTags: (0, _lodash.compact)(contentTagsArray),
	      brandTags: (0, _lodash.compact)(brandTagsArray),
	      description: description || ''
	    }
	  };
	
	  return details;
	};
	
	var createInfluencerDetails = function createInfluencerDetails(influencer, user, restClient) {
	  var details = getInfluencerDetails(influencer, user);
	
	  console.log(details);
	
	  return restClient.post('influencerDetails', {
	    data: details
	  });
	};
	
	exports.default = function (_ref3, organisationId) {
	  var id = _ref3.id,
	      email = _ref3.email,
	      contentTags = _ref3.contentTags,
	      brandTags = _ref3.brandTags,
	      description = _ref3.description;
	
	  var aggregate = {};
	  var restClient = _axios2.default.create({
	    baseURL: ("https://api2.dyzio.co/v1"),
	    timeout: 5000,
	    headers: {
	      Authorization: 'Bearer ' + _authService.authService.getToken()
	    }
	  });
	  aggregate.influencerId = id;
	  createInfluencerDetails({ email: email }, { contentTags: contentTags, brandTags: brandTags, description: description }, restClient).then(function (r) {
	    if (aggregate.influencerId && r.data.data.id) {
	      restClient.post('influencerLink', {
	        data: {
	          type: 'influencerLink',
	          attributes: {
	            organisation: {
	              type: 'organisations',
	              id: organisationId
	            },
	            influencer: {
	              type: 'influencer',
	              id: aggregate.influencerId
	            },
	            influencerDetails: {
	              type: 'influencerDetails',
	              id: r.data.data.id
	            }
	          }
	        }
	      }).then(function (r2) {
	        console.log('influencer ' + id + ' and link ' + r2.data.data.id + ' created!');
	      });
	    } else {
	      console.log('error creating influencer >>> ' + id);
	    }
	  }).catch(function (e) {
	    console.log(e);
	    throw e;
	  });
	};

/***/ },
/* 2371 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDeliverablesStatus = getDeliverablesStatus;
	function getDeliverablesStatus(deliverables) {
	
	  var deliverablesStatus = {};
	
	  var setDeliverables = 0;
	  var addedDeliverables = 0;
	  var approvedDeliverables = 0;
	  var liveDeliverables = 0;
	
	  if (deliverables) {
	    deliverables.forEach(function (deliverable) {
	      setDeliverables++;
	      var deliverableDocuments = deliverable.get('documents');
	      if (deliverableDocuments && deliverableDocuments.first()) {
	        addedDeliverables++;
	        if (deliverableDocuments.find(function (document) {
	          return document.get('approved') === true;
	        })) {
	          approvedDeliverables++;
	        }
	      } else {
	        if (deliverable.get('document')) addedDeliverables++;
	        if (deliverable.getIn(['document', 'approved'])) approvedDeliverables++;
	      }
	
	      if (deliverable.get('live')) liveDeliverables++;
	    });
	  }
	
	  deliverablesStatus.set = setDeliverables;
	  deliverablesStatus.added = addedDeliverables;
	  deliverablesStatus.approved = approvedDeliverables;
	  deliverablesStatus.live = liveDeliverables;
	  // TODO Changed approvedDeliverables back to liveDeliverables when we use live
	  deliverablesStatus.setStatus = deliverableStatus(approvedDeliverables, setDeliverables);
	  deliverablesStatus.addedStatus = deliverableStatus(addedDeliverables, setDeliverables);
	  deliverablesStatus.approvedStatus = deliverableStatus(approvedDeliverables, addedDeliverables, setDeliverables);
	  deliverablesStatus.liveStatus = deliverableStatus(liveDeliverables, approvedDeliverables);
	  return deliverablesStatus;
	}
	
	function deliverableStatus(first, second, third) {
	  var status = 'incomplete';
	  if (first < second && (first || second)) status = 'pending';
	  if (first === second && (first || second)) status = 'complete';
	  if (third) {
	    if (first === second && first !== third && (first || second)) status = 'pending';
	  }
	  return status;
	}

/***/ },
/* 2372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function tabulateDemographics(demographics) {
	  var demographicsTable = {};
	  var AGE_BUCKET_REGEX = /([a-zA-Z])+/gi;
	  var total = {
	    M: 0,
	    F: 0
	  };
	  _lodash2.default.map(demographics, function (value, key) {
	    var _$tail = _lodash2.default.tail(_lodash2.default.split(key, AGE_BUCKET_REGEX)),
	        _$tail2 = _slicedToArray(_$tail, 2),
	        gender = _$tail2[0],
	        ageGroup = _$tail2[1];
	
	    total[gender] += value.percentage;
	    if (!demographicsTable[ageGroup]) {
	      demographicsTable[ageGroup] = {};
	    }
	    demographicsTable[ageGroup][gender] = value;
	  });
	  var demographicsArray = Object.entries(demographicsTable);
	  console.log(demographicsArray);
	  demographicsArray.sort(function (a, b) {
	    var _$tail3 = _lodash2.default.tail(a),
	        _$tail4 = _slicedToArray(_$tail3, 1),
	        aValue = _$tail4[0];
	
	    var _$tail5 = _lodash2.default.tail(b),
	        _$tail6 = _slicedToArray(_$tail5, 1),
	        bValue = _$tail6[0];
	
	    return bValue.M.percentage + bValue.F.percentage - (aValue.M.percentage + aValue.F.percentage);
	  });
	  console.log(total);
	  return {
	    demographicsTable: demographicsArray,
	    total: total
	  };
	}
	
	module.exports = {
	  tabulateDemographics: tabulateDemographics
	};

/***/ },
/* 2373 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBriefStatus = getBriefStatus;
	exports.getContractStatus = getContractStatus;
	function getBriefStatus(currentBrief) {
	
	  var isBriefActive = currentBrief && !currentBrief.get('removed') ? true : false;
	  var isBriefApproved = currentBrief && currentBrief.get('approved') ? true : false;
	
	  return briefStatus(isBriefActive, isBriefApproved);
	}
	
	function briefStatus(isBriefActive, isBriefApproved) {
	  if (!isBriefActive && !isBriefApproved) return 'incomplete';
	  if (isBriefActive && !isBriefApproved) return 'pending';
	  if (isBriefActive && isBriefApproved) return 'complete';
	}
	
	function getContractStatus(currentContract, signedContract) {
	
	  var isContractActive = currentContract && !currentContract.get('removed') ? true : false;
	  var isSignedContractActive = signedContract && !signedContract.get('removed') ? true : false;
	
	  return contractStatus(isContractActive, isSignedContractActive);
	}
	
	function contractStatus(isContractActive, isSignedContractActive) {
	  if (!isContractActive) return 'incomplete';
	  if (isContractActive && !isSignedContractActive) return 'pending';
	  if (isContractActive && isSignedContractActive) return 'complete';
	}

/***/ },
/* 2374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	var assert = __webpack_require__(1824);
	
	var createDyzioEvent = function createDyzioEvent(_ref) {
	  var message = _ref.message,
	      organisationId = _ref.organisationId,
	      campaignId = _ref.campaignId,
	      messageData = _ref.messageData,
	      jsonAPIClient = _ref.jsonAPIClient;
	
	  var dyzioevent = jsonAPIClient.create('dyzioevents');
	  assert.ok(organisationId);
	  assert.ok(campaignId);
	  assert.ok(message);
	  var attributes = {
	    message: message,
	    messageData: messageData || {},
	    campaign: {
	      type: 'campaigns',
	      id: campaignId
	    },
	    organisation: {
	      type: 'organisations',
	      id: organisationId
	    },
	    source: 'dyzio-web',
	    createdBy: 'dyzio',
	    createdDate: new Date()
	  };
	
	  _.forEach(attributes, function (value, key) {
	    if (value) {
	      dyzioevent.set(key, value);
	    }
	  });
	
	  return dyzioevent.sync();
	};
	
	module.exports = {
	  createDyzioEvent: createDyzioEvent
	};

/***/ },
/* 2375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(6);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (channel, handle) {
	  var options = {
	    data: {
	      platform: channel,
	      name: (0, _lodash.trimStart)(handle, '@')
	    }
	  };
	
	  if (handle.length === 0) {
	    var details = {
	      count: 0,
	      error: false,
	      thumbnail: ''
	    };
	    switch (channel) {
	      case 'facebook':
	        details.facebookpageName = null;
	        details.facebookUserName = null;
	        details.facebookVerified = false;
	        break;
	      case 'instagram':
	        details.instagrampageName = null;
	        details.instagramUserName = null;
	        details.instagramVerified = false;
	        break;
	      case 'twitter':
	        details.twitterpageName = null;
	        details.twitterUserName = null;
	        details.twitterVerified = false;
	        break;
	      case 'youtube':
	        details.youtubeChannelTitle = null;
	        details.youtubeChannelUserName = null;
	        details.youtubeVerified = false;
	        break;
	      default:
	        break;
	    }
	  }
	
	  return _axios2.default.post(("https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer"), options).then(function (response) {
	    var result = {
	      count: response.data.body.data.followerCount,
	      error: false,
	      thumbnail: response.data.body.data.thumbnail
	    };
	
	    var country = response.data.body.data.location;
	    switch (channel) {
	      case 'facebook':
	        result.pageName = response.data.body.data.pagename;
	        result.username = response.data.body.data.username;
	        result.verified = response.data.body.data.verified;
	        break;
	      case 'instagram':
	        result.pageName = response.data.body.data.full_name;
	        result.username = response.data.body.data.username;
	        result.verified = response.data.body.data.isVerified;
	        break;
	      case 'twitter':
	        result.pageName = response.data.body.data.name;
	        result.username = response.data.body.data.screen_name;
	        result.verified = response.data.body.data.verified;
	        break;
	      case 'youtube':
	        result.pageName = response.data.body.data.channelTitle;
	        result.username = response.data.body.data.username;
	        result.verified = response.data.body.data.verified;
	        break;
	      default:
	        break;
	    }
	    result.thumbnail = response.data.body.data.thumbnail;
	    result.country = country;
	    result.shouldRenderSocialHandlesBlock = true;
	    return result;
	  });
	};

/***/ },
/* 2376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _qs = __webpack_require__(251);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTrackingBioLink = function getTrackingBioLink(_ref) {
	  var campaignId = _ref.campaignId,
	      hashtags = _ref.hashtags,
	      instagram = _ref.instagram;
	  return _qs2.default.stringify({
	    utm_source: 'instagram',
	    utm_medium: 'post',
	    utm_campaign: campaignId,
	    utm_term: hashtags,
	    utm_content: instagram
	  });
	};
	
	var getTrackingStoryLink = function getTrackingStoryLink(_ref2) {
	  var campaignId = _ref2.campaignId,
	      hashtags = _ref2.hashtags,
	      instagram = _ref2.instagram;
	  return _qs2.default.stringify({
	    utm_source: 'instagram',
	    utm_medium: 'post',
	    utm_campaign: campaignId,
	    utm_term: hashtags,
	    utm_content: instagram
	  });
	};
	
	module.exports = {
	  getTrackingBioLink: getTrackingBioLink,
	  getTrackingStoryLink: getTrackingStoryLink
	};

/***/ },
/* 2377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateEmail = exports.fetchOrganizationEmails = exports.doesInfluencerExistInOrganisation = undefined;
	
	var _validator = __webpack_require__(84);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NOT_VALID_EMAIL_MESSAGE = 'This email address is invalid.';
	var SAME_EMAIL_AS_USER = 'You cannot use your own email to create an influencer.';
	var EMAIL_USED_BY_ORG_USER_MESSAGE = 'Someone in your organisation is already using this email address.';
	var INFLUENCER_EXISTS_IN_DB = 'An influencer from your database is already using this email address.';
	
	var getFilter = function getFilter(ids) {
	  if (_lodash2.default.size(ids)) {
	    return {
	      filter: {
	        influencer: _lodash2.default.join(ids, ',')
	      },
	      include: ['influencer']
	    };
	  }
	  return {
	    include: ['influencer']
	  };
	};
	
	var doesInfluencerExistInOrganisation = exports.doesInfluencerExistInOrganisation = function doesInfluencerExistInOrganisation(value, organisationId, jsonAPIClient, influencerId) {
	  return jsonAPIClient.find('influencer', {
	    filter: {
	      email: value
	    }
	  }).then(function (res) {
	    var influencerIds = _lodash2.default.size(res) > 0 ? _lodash2.default.map(res, function (item) {
	      return item.toJSON().id;
	    }) : [];
	    return jsonAPIClient.find('influencerLink', getFilter(influencerIds));
	  }).then(function (links) {
	    var records = _lodash2.default.reject(_lodash2.default.map(links, function (link) {
	      return link.toJSONTree();
	    }), function (_ref) {
	      var influencer = _ref.influencer;
	      return influencer.id === influencerId;
	    });
	
	    var influencerAlreadyExists = !_lodash2.default.isUndefined(_lodash2.default.find(records, function (record) {
	      var influencerEmail = record.influencer.email,
	          organisation = record.organisation;
	
	      return influencerEmail === value && organisation.id === organisationId;
	    }));
	
	    return influencerAlreadyExists;
	  });
	};
	
	var fetchOrganizationEmails = exports.fetchOrganizationEmails = function fetchOrganizationEmails(_ref2) {
	  var organisationId = _ref2.userInfo.organisationId,
	      jsonAPIClient = _ref2.jsonAPIClient;
	  return jsonAPIClient.find('users', {
	    filter: {
	      organisation: organisationId
	    }
	  }).then(function (res) {
	    return _lodash2.default.map(res, function (item) {
	      return item.get('email');
	    });
	  });
	};
	
	var validateEmail = exports.validateEmail = function validateEmail(_ref3) {
	  var value = _ref3.value,
	      organisationEmails = _ref3.organisationEmails,
	      _ref3$userInfo = _ref3.userInfo,
	      organisationId = _ref3$userInfo.organisationId,
	      email = _ref3$userInfo.email,
	      jsonAPIClient = _ref3.jsonAPIClient,
	      influencerId = _ref3.influencerId;
	
	  if (_lodash2.default.isEmpty(value)) {
	    return Promise.resolve({ isValid: true });
	  }
	  if (!_validator2.default.isEmail(value)) {
	    return Promise.resolve({ isValid: false, message: NOT_VALID_EMAIL_MESSAGE });
	  }
	  if (value === email) {
	    return Promise.resolve({ isValid: false, message: SAME_EMAIL_AS_USER });
	  }
	  if (_lodash2.default.includes(organisationEmails, value)) {
	    return Promise.resolve({ isValid: false, message: EMAIL_USED_BY_ORG_USER_MESSAGE });
	  }
	  return doesInfluencerExistInOrganisation(value, organisationId, jsonAPIClient, influencerId).then(function (exists) {
	    if (exists) {
	      return { isValid: false, message: INFLUENCER_EXISTS_IN_DB };
	    }
	    return { isValid: true };
	  });
	};

/***/ },
/* 2378 */
/***/ function(module, exports) {

	"use strict";
	
	var mapPostData = function mapPostData(post) {
	  if (post.date) return post;
	  return {
	    date: post.taken_at_timestamp,
	    caption: post.edge_media_to_caption.edges[0].node.text,
	    likes: {
	      count: post.edge_liked_by.count
	    },
	    comments: {
	      count: post.edge_media_to_comment.count
	    },
	    display_src: post.thumbnail_resources[4].src
	  };
	};
	
	module.exports = {
	  mapPostData: mapPostData
	};

/***/ },
/* 2379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*  weak */
	var Client = module.exports = function (path, auth) {
	  if (!path) {
	    throw new Error('API path is needed to construct an instanceof jsonapi-client');
	  }
	  auth = auth || {};
	  this._construct(path, auth);
	};
	
	if (typeof window !== 'undefined') {
	  window.JsonapiClient = Client; // eslint-disable-line
	}
	
	var Promise = __webpack_require__(1423);
	// Promise.denodeify = function(a) { return a; };
	var Resource = __webpack_require__(2380);
	Client.Resource = Resource;
	var Transport = __webpack_require__(2381);
	var createResourceCache = __webpack_require__(2382);
	
	Client.prototype._construct = function (path, auth) {
	  this._resourceCache = createResourceCache();
	  this._transport = new Transport(path, auth);
	};
	
	Client.prototype.find = Promise.denodeify(function (type, options, callback) {
	  var self = this;
	
	  if (typeof options === 'function') {
	    callback = options;
	    options = {};
	  }
	
	  this._transport.search(type, options, function (err, rawResponse, rawResources, rawIncludes) {
	    if (err) return callback(err);
	
	    var resources = rawResources.map(function (someRawResource) {
	      return new Resource(someRawResource, self);
	    });
	    if (rawIncludes) {
	      rawIncludes.forEach(function (someRawResource) {
	        return new Resource(someRawResource, self);
	      });
	    }
	
	    return callback(null, resources);
	  });
	});
	
	Client.prototype.get = Promise.denodeify(function (type, id, options, callback) {
	  var self = this;
	
	  if (typeof options === 'function') {
	    callback = options;
	    options = {};
	  }
	
	  this._transport.find(type, id, options, function (err, rawResponse, rawResource, rawIncludes) {
	    if (err) return callback(err);
	
	    var resource = new Resource(rawResource, self);
	    if (rawIncludes) {
	      rawIncludes.forEach(function (someRawResource) {
	        return new Resource(someRawResource, self);
	      });
	    }
	
	    return callback(null, resource);
	  });
	});
	
	Client.prototype._getRelated = function (resource, relation, options, callback) {
	  var self = this;
	  this._transport.fetch(resource, relation, options, function (err, rawResponse, rawResources, rawIncludes) {
	    if (err) return callback(err);
	
	    if (rawIncludes) {
	      rawIncludes.forEach(function (someRawResource) {
	        return new Resource(someRawResource, self);
	      });
	    }
	
	    if (!(rawResources instanceof Array)) {
	      var rawResource = new Resource(rawResources, self);
	      return callback(null, rawResource);
	    }
	
	    var resources = rawResources.map(function (someRawResource) {
	      return new Resource(someRawResource, self);
	    });
	
	    return callback(null, resources);
	  });
	};
	
	Client.prototype.create = function (type, properties) {
	  var newResource = new Resource({
	    id: null,
	    type: type,
	    attributes: properties || {},
	    relationships: {}
	  }, this);
	  return newResource;
	};
	
	Client.prototype._remoteCreate = function (resource, callback) {
	  this._transport.create(resource, callback);
	};
	
	Client.prototype._update = function (resource, callback) {
	  this._transport.update(resource, callback);
	};
	
	Client.prototype._delete = function (resource, callback) {
	  this._transport.delete(resource, callback);
	};

/***/ },
/* 2380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*  weak */
	var Resource = module.exports = function (rawResource, client) {
	  rawResource = rawResource || {};
	  return this._construct(rawResource, client);
	};
	
	var Promise = __webpack_require__(1423);
	// Promise.denodeify = function(a) { return a; };
	var assign = __webpack_require__(45);
	
	function getMeta(obj) {
	  var metaDefaults = { relation: 'primary' };
	  return obj.meta || metaDefaults;
	}
	
	Resource.prototype._construct = function (rawResource, client) {
	  this._raw = rawResource;
	  this._base = {
	    id: rawResource.id,
	    type: rawResource.type
	  };
	  this._client = client;
	  this._changed = [];
	
	  if (!this._base.id) return this;
	
	  var fromCache = client._resourceCache.get(this);
	  if (fromCache) return fromCache;
	
	  client._resourceCache.set(this);
	  return this;
	};
	
	Resource.prototype._checkIsResource = function (resource) {
	  if (resource instanceof Resource) {
	    if (!resource._base.id) throw new Error('Resource has not been created remotely, it can&#39;t be assigned to a relationship!');
	    return;
	  }
	
	  var type = typeof resource === 'undefined' ? 'undefined' : _typeof(resource);
	  if (resource.constructor) type = resource.constructor.name;
	
	  throw new Error('Expected Resource, got ' + type);
	};
	
	Resource.prototype._getBase = function () {
	  return this._base;
	};
	
	Resource.prototype._getRaw = function () {
	  return this._raw;
	};
	
	Resource.prototype._getDelta = function () {
	  var primaryRelations = {};
	  var relationships = this._getRaw().relationships;
	  Object.keys(relationships).forEach(function (i) {
	    if (getMeta(relationships[i]).relation === 'foreign') return;
	    primaryRelations[i] = relationships[i];
	  });
	
	  return {
	    id: this._base.id,
	    type: this._base.type,
	    attributes: this._getRaw().attributes,
	    relationships: primaryRelations
	  };
	};
	
	Resource.prototype._getUid = function () {
	  return this._base.id;
	};
	
	Resource.prototype._getUidString = function () {
	  return this._base.id + '/' + this._base.type;
	};
	
	Resource.prototype._getPathFor = function (relation) {
	  return this._getRaw().relationships[relation].links.related;
	};
	
	Resource.prototype._matches = function (other) {
	  return this._base.id === other.id && this._base.type === other.type;
	};
	
	Resource.prototype._associateWithAll = function (resources) {
	  var self = this;
	  resources.forEach(function (resource) {
	    self._associateWith(resource);
	    resource._associateWith(self);
	  });
	};
	
	Resource.prototype._relationHasResource = function (relationName, resource) {
	  var relation = this[relationName];
	
	  if (relation instanceof Array) {
	    relation = relation.filter(function (i) {
	      return i._base === resource._base;
	    }).pop();
	  }
	
	  return !!relation;
	};
	
	Resource._rawRelationHasMany = function (rawRelation) {
	  var meta = getMeta(rawRelation);
	  if (meta.relation === 'primary') return rawRelation.data instanceof Array;
	  return meta.many;
	};
	
	Resource.prototype._associateWith = function (resource) {
	  var self = this;
	  var relationships = self._getRaw().relationships;
	  if (!relationships) return;
	  Object.keys(relationships).forEach(function (relationName) {
	    var rawRelation = relationships[relationName];
	    var otherRelation = resource;
	    var rawRelationData = rawRelation.data;
	    var rawRelationMeta = getMeta(rawRelation);
	    if (rawRelationMeta.relation === 'foreign') {
	      if (rawRelationMeta.belongsTo !== resource._getBase().type) {
	        return;
	      }
	      otherRelation = self;
	      rawRelationData = resource._getRaw().relationships[rawRelationMeta.as].data;
	    }
	
	    var match = !![].concat(rawRelationData).filter(function (dataItem) {
	      // should null ever get here?
	      return dataItem && otherRelation._matches(dataItem);
	    }).pop();
	    if (!match) return;
	
	    if (Resource._rawRelationHasMany(rawRelation)) {
	      if (self._relationHasResource(relationName, resource)) return;
	      self[relationName] = self[relationName] || [];
	      self[relationName].push(resource);
	    } else {
	      self[relationName] = resource;
	    }
	  });
	};
	
	Resource.prototype.relationships = function (relationName) {
	  var self = this;
	  var rawRelation = this._raw.relationships[relationName];
	
	  if (!self._base.id) {
	    rawRelation = this._raw.relationships[relationName] = {
	      meta: { _trust: true },
	      links: {},
	      data: null
	    };
	  }
	
	  if (!rawRelation) {
	    throw new Error('Relationship ' + relationName + ' on ' + this._raw.type + ' does not exist!');
	  }
	
	  if (getMeta(rawRelation).relation === 'foreign') {
	    throw new Error('Relationship ' + relationName + ' on ' + this._raw.type + ' is a foreign relation and cannot be updated from here!');
	  }
	
	  return {
	    add: function add(resource) {
	      return self._addRelation(relationName, rawRelation, resource);
	    },
	    set: function set(resource) {
	      return self._setRelation(relationName, rawRelation, resource);
	    },
	    remove: function remove(resource) {
	      return self._removeRelation(relationName, rawRelation, resource);
	    }
	  };
	};
	Resource.prototype._addRelation = function (relationName, rawRelation, resource) {
	  this._checkIsResource(resource);
	  if (rawRelation.meta && rawRelation.meta._trust) {
	    delete rawRelation.meta;
	    rawRelation.data = [];
	  }
	  if (!Resource._rawRelationHasMany(rawRelation)) {
	    throw new Error('Relationship ' + relationName + ' on ' + this._raw.type + ' is a not a MANY relationship and cannot be added to!');
	  }
	  if (this._relationHasResource(relationName, resource)) return this;
	  rawRelation.data.push(resource._getBase());
	  this[relationName] = this[relationName] || [];
	  this[relationName].push(resource);
	  resource._tweakLinksTo('add', this);
	  return this;
	};
	Resource.prototype._removeRelation = function (relationName, rawRelation, resource) {
	  this._checkIsResource(resource);
	  if (rawRelation.meta && rawRelation.meta._trust) {
	    delete rawRelation.meta;
	    rawRelation.data = [];
	  }
	  if (Resource._rawRelationHasMany(rawRelation)) {
	    rawRelation.data = rawRelation.data.filter(function (id) {
	      return !resource._matches(id);
	    });
	    this[relationName] = this[relationName].filter(function (id) {
	      return !resource._matches(id);
	    });
	    resource._tweakLinksTo('remove', this);
	  } else {
	    rawRelation.data = undefined;
	    this[relationName] = undefined;
	  }
	  resource._tweakLinksTo('remove', this);
	  return this;
	};
	Resource.prototype._setRelation = function (relationName, rawRelation, resource) {
	  this._checkIsResource(resource);
	  rawRelation.data = resource._getBase();
	  this[relationName] = resource;
	  resource._tweakLinksTo('add', this);
	  return this;
	};
	
	Resource.prototype.toJSON = function () {
	  var theirs = this._raw;
	  var theirResource = assign({
	    id: theirs.id,
	    type: theirs.type
	  }, theirs.attributes);
	  for (var i in theirs.relationships) {
	    // eslint-disable-line guard-for-in
	    theirResource[i] = theirs.relationships[i].data;
	  }
	  return theirResource;
	};
	
	Resource.prototype.toJSONTree = function (seen) {
	  seen = seen || [];
	  if (seen.indexOf(this) !== -1) return '[Circular]';
	  seen.push(this);
	  var theirs = this._raw;
	  var theirResource = assign({
	    id: theirs.id,
	    type: theirs.type
	  }, theirs.attributes);
	  for (var i in theirs.relationships) {
	    if (this[i] instanceof Array) {
	      theirResource[i] = this[i].map(function (j) {
	        // eslint-disable-line guard-for-in
	        return j.toJSONTree(seen);
	      });
	    } else if (this[i] instanceof Resource) {
	      theirResource[i] = this[i].toJSONTree(seen);
	    } else {
	      theirResource[i] = theirs.relationships[i].data || null;
	    }
	  }
	  return theirResource;
	};
	
	Resource.prototype.get = function (attibuteName) {
	  return this._raw.attributes[attibuteName];
	};
	
	Resource.prototype.set = function (attributeName, value) {
	  this._raw.attributes[attributeName] = value;
	  this._changed.push(attributeName);
	  return this;
	};
	
	Resource.prototype.fetch = Promise.denodeify(function (relationName, options, callback) {
	  var self = this;
	
	  if (typeof options === 'function') {
	    callback = options;
	    options = {};
	  }
	
	  self._client._getRelated(this, relationName, options, function (err, newResources) {
	    if (!newResources) return callback('No related resources found');
	
	    if (!(newResources instanceof Array)) {
	      self._raw.relationships[relationName].data = newResources._getBase();
	      return callback(err, newResources);
	    }
	
	    self._raw.relationships[relationName].data = newResources.map(function (someResource) {
	      return someResource._getBase();
	    });
	
	    return callback(err, newResources);
	  });
	});
	
	Resource.prototype.sync = Promise.denodeify(function (callback) {
	  var self = this;
	  var target = self._client._update;
	  if (!self._getBase().id) {
	    target = self._client._remoteCreate;
	  }
	
	  target.call(self._client, self, function (err, rawResponse, rawResource) {
	    if (err) return callback(err);
	    self._construct(rawResource, self._client);
	    return callback(null, self);
	  });
	});
	
	Resource.prototype.delete = Promise.denodeify(function (callback) {
	  var self = this;
	  self._client._delete(self, function (err) {
	    if (err) return callback(err);
	
	    self._client._resourceCache.removeFromCache(self);
	    self._getBase().id = null;
	    self._getRaw().id = null;
	
	    return callback();
	  });
	});
	
	Resource.prototype._tweakLinksTo = function (method, resource) {
	  var self = this;
	  if (!self._raw.relationships) return;
	  Object.keys(self._raw.relationships).forEach(function (i) {
	    var someRawRelationship = self._raw.relationships[i];
	    var someRawRelationshipMeta = getMeta(someRawRelationship);
	    if (someRawRelationshipMeta.relation !== 'foreign') return;
	    if (someRawRelationshipMeta.belongsTo !== resource._raw.type) return;
	
	    self['_' + method + 'LinksTo'](i, resource, someRawRelationshipMeta.many);
	  });
	};
	
	Resource.prototype._removeLinksTo = function (i, resource) {
	  if (this[i] instanceof Array) {
	    this[i] = this[i].filter(function (j) {
	      return j !== resource;
	    });
	  } else {
	    if (this[i] === resource) {
	      this[i] = undefined;
	    }
	  }
	};
	
	Resource.prototype._addLinksTo = function (i, resource, many) {
	  if (this[i] instanceof Array) {
	    this[i].push(resource);
	  } else {
	    if (many) {
	      this[i] = [resource];
	    } else {
	      this[i] = resource;
	    }
	  }
	};

/***/ },
/* 2381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint no-console: "off" */
	/*  weak */
	var Transport = module.exports = function (path, auth) {
	  auth = auth || {};
	  this._construct(path, auth);
	};
	
	var request = __webpack_require__(4089);
	var qs = __webpack_require__(251);
	
	Transport.prototype._construct = function (path, auth) {
	  this._path = path;
	  this._auth = {
	    cookie: auth.cookie,
	    header: auth.header
	  };
	};
	
	Transport.prototype._attachAuthToRequest = function (someRequest) {
	  if (this._auth.cookie) {
	    var cookieName = Object.keys(this._auth.cookie)[0];
	    someRequest.set('Cookie', cookieName + '=' + this._auth.cookie[cookieName]);
	  }
	
	  if (this._auth.header) {
	    var headerName = Object.keys(this._auth.header)[0];
	    someRequest.set(headerName, this._auth.header[headerName]);
	  }
	};
	
	Transport._defaultError = function (response) {
	  return {
	    status: '500',
	    code: 'EUNKNOWN',
	    title: 'An unknown error has occured',
	    detail: response
	  };
	};
	
	Transport.prototype._action = function (method, url, data, callback) {
	  var someRequest = request[method](url);
	  someRequest.set('Content-Type', 'application/vnd.api+json');
	  this._attachAuthToRequest(someRequest);
	  if (method === 'get') {
	    someRequest = someRequest.query(qs.stringify(data));
	  } else {
	    someRequest = someRequest.send(data || {});
	  }
	  someRequest.end(function (err, payload) {
	    if (err) {
	      if (err.status === 401) {
	        return callback(new Error('401 Unauthorized'));
	      }
	
	      var response;
	      try {
	        response = JSON.parse(err.response.text);
	      } catch (e) {
	        console.error('Transport Error: ' + JSON.stringify(err));
	        return callback(Transport._defaultError(response));
	      }
	
	      if (!Array.isArray(response.errors)) {
	        console.error('Invalid Error payload!', response);
	        return callback(Transport._defaultError(response));
	      }
	
	      var realErrors = response.errors.map(function (apiError) {
	        var someError = new Error(JSON.stringify(apiError.detail));
	        someError.name = apiError.title;
	        // $FlowFixMe: Technically "status" isn't a field on Error
	        someError.status = apiError.status;
	        // $FlowFixMe: Technically "code" isn't a field on Error
	        someError.code = apiError.code;
	
	        return someError;
	      });
	
	      return callback(realErrors[0]);
	    }
	
	    if (!payload.body) {
	      try {
	        payload.body = JSON.parse(payload.text);
	      } catch (e) {
	        return callback(Transport._defaultError(payload));
	      }
	    }
	
	    if (!payload.body) {
	      return callback(Transport._defaultError(payload));
	    }
	
	    return callback(null, payload.body, payload.body.data, payload.body.included);
	  });
	};
	
	Transport.prototype.search = function (type, options, callback) {
	  var url = this._path + '/' + type;
	  this._action('get', url, options, callback);
	};
	
	Transport.prototype.find = function (type, id, options, callback) {
	  var url = this._path + '/' + type + '/' + id;
	  this._action('get', url, options, callback);
	};
	
	Transport.prototype.fetch = function (resource, relation, options, callback) {
	  var url = resource._getPathFor(relation);
	  this._action('get', url, options, callback);
	};
	
	Transport.prototype.create = function (resource, callback) {
	  var url = this._path + '/' + resource._getBase().type;
	  var postData = resource._getRaw();
	  delete postData.id;
	  this._action('post', url, {
	    data: resource._getRaw()
	  }, callback);
	};
	
	Transport.prototype.update = function (resource, callback) {
	  var url = this._path + '/' + resource._getBase().type + '/' + resource._getBase().id;
	  this._action('patch', url, {
	    data: resource._getDelta()
	  }, callback);
	};
	
	Transport.prototype.delete = function (resource, callback) {
	  var url = this._path + '/' + resource._getBase().type + '/' + resource._getBase().id;
	  this._action('del', url, null, callback);
	};

/***/ },
/* 2382 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*  weak */
	module.exports = function createResourceCache() {
	  var resourceCache = {};
	
	  resourceCache._cacheDuration = 5000;
	  if (( false ? "undefined" : _typeof(module)) === undefined) {
	    resourceCache._cacheDuration = null;
	  }
	  resourceCache._cache = {};
	  resourceCache._cacheList = [];
	
	  resourceCache.get = function (someResource) {
	    var key = someResource._getUidString();
	    return resourceCache._cache[key];
	  };
	
	  resourceCache.set = function (someResource) {
	    someResource._associateWithAll(resourceCache._cacheList);
	
	    var key = someResource._getUidString();
	    resourceCache._cache[key] = someResource;
	    resourceCache._cacheList.push(someResource);
	
	    if (!resourceCache._cacheDuration) return;
	
	    setTimeout(function () {
	      resourceCache.removeFromCache(someResource);
	    }, resourceCache._cacheDuration);
	  };
	
	  resourceCache.removeFromCache = function (someResource) {
	    var key = someResource._getUidString();
	    resourceCache._cache[key] = undefined;
	    var i = resourceCache._cacheList.indexOf(someResource);
	    resourceCache._cacheList.splice(i, 1);
	  };
	
	  return resourceCache;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)(module)))

/***/ },
/* 2383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createCampaign = createCampaign;
	exports.getCampaignOld = getCampaignOld;
	exports.getCampaign = getCampaign;
	exports.getFastLoadCampaign = getFastLoadCampaign;
	exports.getCampaignMembers = getCampaignMembers;
	exports.getCampaignDiscussions = getCampaignDiscussions;
	exports.getScheduleDeliverables = getScheduleDeliverables;
	exports.updateCampaign = updateCampaign;
	exports.getCampaignDiscussionsOld = getCampaignDiscussionsOld;
	exports.getCampaignPermissions = getCampaignPermissions;
	exports.removeCampaignPermissionFromCampaign = removeCampaignPermissionFromCampaign;
	exports.removePendingInviationFromCampaign = removePendingInviationFromCampaign;
	exports.addDiscussionToCampaign = addDiscussionToCampaign;
	exports.addCampaignPermission = addCampaignPermission;
	exports.addChatDiscussionToCamapign = addChatDiscussionToCamapign;
	exports.getCampaignTrackedAssets = getCampaignTrackedAssets;
	exports.updateCampaignTrackedAssets = updateCampaignTrackedAssets;
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	var _authService = __webpack_require__(21);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO Client brief needs adding
	function createCampaign(campaignData, clientOrganisationData) {
	  var client = (0, _jsonapiService2.default)();
	
	  var campaign = client.create('campaigns');
	  campaign.set('name', campaignData.name);
	  campaign.set('campaignType', campaignData.campaignType);
	  campaign.set('memberCount', 1);
	  campaign.set('description', 'Description generated at ' + new Date().toTimeString());
	  campaign.set('budget', campaignData.budget);
	  campaign.set('clientBrief', 'https://s3-eu-west-1.amazonaws.com/cf-templates-o6s432he4qgr-eu-west-1/2016202Jd5-dyzio-aws-stack.json');
	  if (campaignData.liveDate) campaign.set('liveDate', campaignData.liveDate);
	  if (clientOrganisationData.hasClient === 'yes') {
	    campaign.set('client', { type: 'organisations', id: clientOrganisationData.id });
	  }
	
	  return campaign.sync().then(function (response) {
	    return response;
	  });
	}
	
	function getCampaignOld(campaignId) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('campaigns', campaignId, { include: ['owner', 'pendingInvitations', 'members'] }).then(function (response) {
	    return response;
	  });
	}
	
	// ADD ATTRIBUTES TO CAMPAIGN OBJECT FOR QUERYING
	function makeCampaignQuery(campaignId) {
	  var query = '\n  query Campaign {\n    campaigns(id: "' + campaignId + '") {\n      id\n      name\n      description\n      budget\n      campaignType\n      liveDate\n      endDate\n      currency\n      country\n      approvalStatus\n      impressionsCPM\n      engagementsCPM\n      ieRatio\n      scanUnauthorisedStories\n      useEstimatedReachAndImpressions\n      captureAllStories\n      captureAllStoriesWhenMatched\n      premiumFeaturesBlocked\n      isShopifyCampaign\n      isPrestaShopCampaign\n      workflow\n      baseTrackingUrl\n      campaignCode\n      sendChaseEmails\n      hashtags\n      brand\n      creationStatus\n      rollfwdCampaign {\n        id\n        name\n      }\n      mailouts{\n        name\n        id\n      }\n      discussions {\n        id\n        name\n        budget\n        lastScannedDate\n        createdDate\n        lastSuccessfulStoryScan\n        instagramScanFailures\n        isScanningCompleted\n        internalDiscountCode\n        discountCode\n        productOrderedDate\n        workflowStatus\n        hasPosted\n        bioLinkUrl\n        trackedAssets {\n          id\n          assetId\n          assetURL\n          platform\n          assetType\n          createdBy\n          createdDate\n          createdSource\n          publishedDate\n        }\n        stories {\n          id\n          platform\n          caption\n          assetId\n          assetURL\n          assetType\n          createdDate\n          createdBy\n          createdSource\n          latestReach\n          latestImpressions\n        }\n        organisations {\n          id\n          name\n          orgType\n          influencer {\n            id\n            name\n            thumbnail\n            email\n            facebook\n            facebookCount\n            facebookAuthorised\n            facebookStatus\n            instagram\n            instagramCount\n            instagramVerified\n            instagramStatus\n            instagramAuthorised\n            instagramBusinessAccount\n            youtube\n            youtubeStatus\n            youtubeCount\n            twitter\n            twitterStatus\n            twitterCount\n            twitterAuthorised\n            youtubeAuthorised\n            youtubeCount\n            youtubeStatus\n            youtubeChannelTitle\n            primarySocialHandle\n            instagramPrivate\n            discountCode\n            usageRightsGranted\n            tiktok\n            instagramId\n            tiktokId\n            tiktokCount\n            telegramChannels {\n              username\n            }\n            twitch\n          }\n        }\n        invitations {\n          id\n          status\n          link\n          metadata\n        }\n      }\n      owner {\n        id\n        name\n      }\n      shortlist {\n        id\n        name\n      }\n      partnerAgency {\n        id\n        name\n      }\n      memberCount\n      members {\n        id\n        name\n        email\n        campaign {\n          id\n        }\n        organisation {\n          id\n          name\n        }\n        role\n        metadata\n        sendDailyNotifications\n        sendWeeklyNotifications\n      }\n      pendingInvitations {\n        id\n        email\n        name\n        campaign {\n          id\n        }\n        role\n        organisation {\n          id\n          name\n        }\n        status\n        metadata\n      }\n      createdDate\n      createdBy\n    }\n  }\n  ';
	  return query;
	}
	
	// ADD ATTRIBUTES TO CAMPAIGN OBJECT FOR QUERYING
	function makeFastLoadCampaignQuery(campaignId) {
	  var query = '\n  query FastLoadCampaign {\n    campaigns(id: "' + campaignId + '") {\n      id\n      name\n      description\n      budget\n      campaignType\n      liveDate\n      endDate\n      currency\n      country\n      approvalStatus\n      impressionsCPM\n      engagementsCPM\n      ieRatio\n      scanUnauthorisedStories\n      useEstimatedReachAndImpressions\n      premiumFeaturesBlocked\n      isShopifyCampaign\n      isPrestaShopCampaign\n      workflow\n      baseTrackingUrl\n      campaignCode\n      sendChaseEmails\n      hashtags\n      brand\n      creationStatus\n      captureAllStories\n      rollfwdCampaign {\n        id\n        name\n      }\n      discussions {\n        id\n        name\n        budget\n        lastScannedDate\n        lastSuccessfulStoryScan\n        instagramScanFailures\n        isScanningCompleted\n        internalDiscountCode\n        discountCode\n        productOrderedDate\n        workflowStatus\n        hasPosted\n        createdDate\n        bioLinkUrl\n        influencer {\n          id\n          name\n          thumbnail\n          email\n          facebook\n          facebookCount\n          facebookAuthorised\n          facebookStatus\n          instagram\n          instagramCount\n          instagramVerified\n          instagramStatus\n          instagramAuthorised\n          instagramBusinessAccount\n          youtube\n          youtubeStatus\n          youtubeCount\n          twitter\n          twitterStatus\n          twitterCount\n          twitterAuthorised\n          youtubeAuthorised\n          youtubeCount\n          youtubeStatus\n          youtubeChannelTitle\n          primarySocialHandle\n          instagramPrivate\n          usageRightsGranted\n          discountCode\n          tiktok\n          tiktokCount\n          instagramId\n          tiktokId\n          telegramChannels {\n            username\n          }\n          twitch\n        }\n        trackedAssets{\n          id\n        }\n        stories {\n          id\n        }\n      }\n      owner {\n        id\n        name\n      }\n      shortlist {\n        id\n        name\n      }\n      partnerAgency {\n        id\n        name\n      }\n      memberCount\n      createdDate\n      createdBy\n    }\n  }\n  ';
	  return query;
	}
	
	function getCampaign(campaignId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 20000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = makeCampaignQuery(campaignId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    return response.data.data.campaigns[0];
	  });
	}
	
	function getFastLoadCampaign(campaignId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 20000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = makeFastLoadCampaignQuery(campaignId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    return response.data.data.campaigns[0];
	  });
	}
	function getCampaignMembers(campaignId) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('campaigns', campaignId, { include: ['members'] }).then(function (response, error) {
	    return (
	      // Returns resource object
	      response
	    );
	  });
	}
	
	function makeCampaignDiscussionQuery(campaignId) {
	  var query = '\n  query CampaignDiscussions {\n    campaigns(id: "' + campaignId + '") {\n      id\n      currency\n      hashtags\n      discussions {\n        id\n        name\n        budget\n        budgetStatus\n        discussionType\n        trackedAssets {\n          id\n          assetId\n          assetURL\n          platform\n          assetType\n          createdBy\n          createdDate\n          createdSource\n          publishedDate\n        }\n        stories {\n          id\n          platform\n          caption\n          assetId\n          assetURL\n          assetType\n          createdDate\n          createdBy\n          createdSource\n          latestReach\n          latestImpressions\n        }\n        organisations {\n          id\n          name\n          influencer {\n            id\n            name\n            email\n            totalSocialReach\n            youtubeCount\n            facebookCount\n            twitterCount\n            instagramCount\n            primarySocialHandle\n            youtubeChannelTitle\n            thumbnail\n            facebook\n            twitter\n            instagram\n            youtube\n            instagramVerified\n            twitterVerified\n            facebookVerified\n            instagramAuthorised\n            twitterAuthorised\n            facebookAuthorised\n            youtubeAuthorised\n            instagramStatus\n            twitterStatus\n            facebookStatus\n            youtubeStatus\n            instagramBusinessAccount\n          }\n        }\n        invitations {\n          id\n          status\n          link\n          metadata\n        }\n        channelURL\n        currentBrief\n        members {\n          id\n          name\n          role\n        }\n        documents {\n          id\n          name\n          filePath\n          docType\n          fileType\n          size\n          discussion {\n            id\n          }\n          message\n          approved\n          createdBy\n          createdDate\n          approvedBy\n          approvalDate\n          version\n        }\n        deliverables {\n          id\n          title\n          channelType\n          assetType\n          dueDate\n          liveDateEnd\n          live\n          description\n          createdBy\n          createdDate\n          document {\n            id\n            name\n            approved\n            version\n          }\n          documents {\n            id\n            name\n            approved\n            version\n          }\n        }\n        trackedAssets {\n          id\n          assetId\n          assetURL\n          platform\n          assetType\n          createdBy\n          createdDate\n          createdSource\n          publishedDate\n          supportingData {\n            id\n            filePath\n            engagements\n            impressions\n            saves\n            reach\n            createdBy\n            createdDate\n          }\n        }\n        currentContract\n        signedContract\n      }\n    }\n  }\n  ';
	  return query;
	}
	
	function getCampaignDiscussions(campaignId) {
	  console.log('looking for ' + campaignId);
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = makeCampaignDiscussionQuery(campaignId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    console.log(response);
	    return response.data.data.campaigns[0].discussions;
	  });
	}
	
	function makeScheduleDeliverablesQuery(campaignId) {
	  var query = '\n  query ScheduleDeliverables {\n    campaigns(id: "' + campaignId + '") {\n      id\n      name\n      discussions {\n        id\n        name\n        members {\n          id\n          name\n          role\n        }\n        deliverables {\n          id\n          title\n          channelType\n          assetType\n          dueDate\n          liveDateEnd\n          live\n          description\n          createdBy\n          createdDate\n          document {\n            id\n            name\n            approved\n            docType\n            filePath\n            message\n            createdDate\n            createdBy\n            removed\n            approvedBy\n            approvalDate\n            version\n          }\n          documents {\n            id\n            name\n            approved\n            docType\n            filePath\n            message\n            createdDate\n            createdBy\n            removed\n            approvedBy\n            approvalDate\n            version\n          }\n          version\n        }\n      }\n    }\n  }\n  ';
	  return query;
	}
	
	function getScheduleDeliverables(campaignId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = makeScheduleDeliverablesQuery(campaignId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    return response.data.data.campaigns[0];
	  });
	}
	
	function updateCampaign(id, budget) {
	  var client = (0, _jsonapiService2.default)();
	  return client.get('campaigns', id).then(function (campaign) {
	    if (budget) campaign.set('budget', budget);
	    return campaign.sync();
	  });
	}
	
	function getCampaignDiscussionsOld(campaignId) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('campaigns', campaignId, { include: ['discussions'] }).then(function (response) {
	    // Returns JSON object
	    var campaign = response.toJSONTree();
	    return campaign.discussions;
	  });
	}
	
	function getCampaignPermissions(userId) {
	  console.log('getCampaignPermissions');
	  var client = (0, _jsonapiService2.default)();
	  var options = {
	    filter: {
	      user: userId
	    },
	    include: ['campaign'],
	    sort: ['-createdDate']
	  };
	
	  return client.find('campaignPermission', options).then(function (permissions) {
	    var campaignPermissions = [];
	    permissions.forEach(function (permission) {
	      campaignPermissions.push(permission.toJSONTree());
	    });
	    // Returns JSON object
	    return campaignPermissions;
	  });
	}
	
	function removeCampaignPermissionFromCampaign(campaignId, campaignPermission) {
	  var client = (0, _jsonapiService2.default)();
	
	  client.get('campaigns', campaignId, {}).then(function (campaign) {
	    campaign.relationships('members').remove(campaignPermission);
	    return campaign.sync().then(function (campaign) {
	      return campaign;
	    });
	  });
	}
	
	function removePendingInviationFromCampaign(campaignId, campaignInvitation) {
	  // TODO Requires it's own client to not have circular issues which needs addressing
	  var client = (0, _jsonapiService2.default)();
	
	  client.get('campaigns', campaignId, {}).then(function (campaign) {
	    campaign.relationships('pendingInvitations').remove(campaignInvitation);
	    return campaign.sync().then(function (campaign) {
	      return campaign;
	    });
	  });
	}
	
	function addDiscussionToCampaign(campaignId, discussion) {
	  var client = (0, _jsonapiService2.default)();
	
	  client.get('campaigns', campaignId, {}).then(function (campaign) {
	    campaign.relationships('discussions').add(discussion);
	    return campaign.sync().then(function (campaign) {
	      return campaign;
	    });
	  });
	}
	
	function addCampaignPermission(campaignResource, campaignPermission) {
	  campaignResource.relationships('members').add(campaignPermission);
	  return campaignResource.sync().then(function (response) {
	    return response;
	  });
	}
	
	// This doesn't sync the data but instead only preps the resource for syncing.
	function addChatDiscussionToCamapign(campaignResource, discussionName, discussionResource) {
	  campaignResource.relationships('discussions').add(discussionResource);
	  campaignResource.set(discussionName, discussionResource.toJSON().id);
	}
	
	function makeCampaignTrackedAssetsQuery(campaignId) {
	  var query = '\n  query CampaignTrackedAssets {\n    campaigns(id: "' + campaignId + '") {\n      id\n      name\n      trackedAssets {\n        id\n        assetId\n        assetURL\n        platform\n        assetType\n        createdSource\n        createdBy\n        createdDate\n        user {\n          id\n        }\n        campaign {\n          id\n          name\n        }\n        discussion {\n          id\n          name\n        }\n      }\n      discussions {\n        id\n        name\n        trackedAssets {\n          id\n          assetId\n          assetURL\n          platform\n          assetType\n          createdSource\n          createdBy\n          createdDate\n          user {\n            id\n          }\n          campaign {\n            id\n            name\n          }\n          discussion {\n            id\n            name\n          }\n        }\n      }\n    }\n  }';
	  return query;
	}
	
	function getCampaignTrackedAssets(campaignId) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = makeCampaignTrackedAssetsQuery(campaignId);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (response) {
	    var campaign = response.data.data.campaigns[0];
	    var trackedAssetsList = [];
	    if (campaign.trackedAssets && campaign.trackedAssets[0]) {
	      campaign.trackedAssets.forEach(function (trackedAsset) {
	        return trackedAssetsList.push(trackedAsset);
	      });
	    }
	    campaign.discussions.forEach(function (discussion) {
	      if (discussion.trackedAssets && discussion.trackedAssets[0]) {
	        discussion.trackedAssets.forEach(function (trackedAsset) {
	          return trackedAssetsList.push(trackedAsset);
	        });
	      }
	    });
	    return trackedAssetsList;
	  });
	}
	
	function updateCampaignTrackedAssets(campaignId, trackedAsset) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('campaigns', campaignId, {}).then(function (campaign) {
	    campaign.relationships('trackedAssets').add(trackedAsset);
	    return campaign.sync();
	  });
	}

/***/ },
/* 2384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getInfluencerCampaignPermissions = function getInfluencerCampaignPermissions(userId) {
	  console.log('getInfluencerCampaignPermissions');
	  var client = (0, _jsonapiService2.default)();
	  var options = {
	    filter: {
	      user: userId
	    },
	    include: ['campaign'],
	    sort: ['-createdDate']
	  };
	
	  return client.find('campaignPermission', options).then(function (permissions) {
	    var campaignPermissions = [];
	    _lodash2.default.forEach(permissions, function (permission) {
	      campaignPermissions.push(permission.toJSONTree());
	    });
	    // Returns JSON object
	    return campaignPermissions;
	  });
	};
	
	module.exports = {
	  getInfluencerCampaignPermissions: getInfluencerCampaignPermissions
	};

/***/ },
/* 2385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findInfluencers = findInfluencers;
	exports.countInfluencers = countInfluencers;
	exports.getInfluencer = getInfluencer;
	exports.runSearch = runSearch;
	exports.addInfluencer = addInfluencer;
	exports.addInfluencerDetails = addInfluencerDetails;
	exports.addInfluencerLink = addInfluencerLink;
	exports.getOrganisationName = getOrganisationName;
	exports.getReviews = getReviews;
	exports.setRating = setRating;
	exports.setReviews = setReviews;
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function findInfluencers(organisationId, page, term) {
	  var client = (0, _jsonapiService2.default)();
	
	  var options = {
	    filter: {
	      organisation: organisationId
	    },
	    include: ['influencer', 'influencerDetails', 'statistics'],
	    'page[limit]': 100,
	    'page[offset]': page * 10,
	    sort: ['createdDate']
	  };
	
	  return client.find('influencerLink', options).then(function (r) {
	    var influencerArray = [];
	    r.forEach(function (i) {
	      var s = i.toJSONTree();
	      influencerArray.push(s);
	    });
	    return influencerArray.reverse();
	  });
	}
	
	function countInfluencers(organisationId) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.find('influencerLink', { filter: { organisation: organisationId } }).then(function (r) {
	    var count = r.length;
	    return count;
	  });
	}
	
	function getInfluencer(organisationId, id) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('influencerLink', id, { include: ['influencer', 'influencerDetails', 'influencer.statistics', 'influencerDetails.tags'] }).then(function (r) {
	    console.log('ascd', r.toJSONTree());
	    return r.toJSONTree();
	  });
	}
	
	function runSearch(organisationId, term) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.find('influencer', { filter: { name: ':' + term } });
	}
	
	function addInfluencer(data) {
	  var client = (0, _jsonapiService2.default)();
	  var influencer = client.create('influencer');
	
	  influencer.set('name', data.name);
	  influencer.set('primarySocialHandle', data.primarySocialHandle);
	  influencer.set('facebookCount', data.facebookCount || 0);
	  influencer.set('instagramCount', data.instagramCount || 0);
	  influencer.set('twitterCount', data.twitterCount || 0);
	  influencer.set('youtubeCount', data.youtubeCount || 0);
	  influencer.set('otherChannels', data.otherChannels);
	  influencer.set('totalSocialReach', data.totalSocialReach);
	
	  var fields = ['email', 'contactNumber', 'thumbnail', 'facebook', 'instagram', 'twitter', 'youtube', 'agentName', 'agentContactNumber', 'addressLine1', 'city', 'region', 'postalCode', 'country', 'youtubeChannelTitle', 'twitch', 'snapchat', 'linkedin', 'web'];
	
	  _lodash2.default.forEach(fields, function (field) {
	    var value = data[field];
	    if (value) {
	      influencer.set(field, value);
	    }
	  });
	
	  return influencer.sync().then(function (r) {
	    var flat = r.toJSON();
	    return flat.id;
	  });
	}
	
	function addInfluencerDetails(details) {
	  var client = (0, _jsonapiService2.default)();
	  var influencerDetails = client.create('influencerDetails');
	
	  influencerDetails.set('associated', details.associated);
	  influencerDetails.set('contentTags', details.contentTags);
	  influencerDetails.set('brandTags', details.brandTags);
	  influencerDetails.set('description', details.description);
	
	  if (details.email) {
	    influencerDetails.set('email', details.email);
	  }
	
	  return influencerDetails.sync().then(function (r) {
	    var flat = r.toJSON();
	    return flat.id;
	  });
	}
	
	function addInfluencerLink(organisationId, influencerId, influencerDetailsId) {
	  var client = (0, _jsonapiService2.default)();
	  var influencerLink = client.create('influencerLink');
	
	  influencerLink.set('organisation', { type: 'organisations', id: organisationId });
	  influencerLink.set('influencer', { type: 'influencer', id: influencerId });
	  influencerLink.set('influencerDetails', { type: 'influencerDetails', id: influencerDetailsId });
	
	  return influencerLink.sync().then(function (r) {
	    return console.log(r.toJSON().id);
	  });
	}
	
	function getOrganisationName(organisationId) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('organisations', organisationId).then(function (r) {
	    return r.toJSONTree();
	  });
	}
	
	function getReviews(influencer) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('influencer', influencer).then(function (r) {
	    return r.toJSONTree().reviews;
	  });
	}
	
	function setRating(influencerDetailsId, avg) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('influencerDetails', influencerDetailsId).then(function (i) {
	    i.set('assessment', avg);
	    return i.sync();
	  });
	}
	
	function setReviews(influencer, final) {
	  var client = (0, _jsonapiService2.default)();
	
	  return client.get('influencer', influencer).then(function (i) {
	    i.set('reviews', final);
	    return i.sync();
	  });
	}

/***/ },
/* 2386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOrganisationByName = getOrganisationByName;
	
	var _jsonapiService = __webpack_require__(94);
	
	var _jsonapiService2 = _interopRequireDefault(_jsonapiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getOrganisationByName(organisationName, currntUserName) {
	
	  var client = (0, _jsonapiService2.default)();
	
	  return client.find('organisations', { filter: { name: '~' + organisationName } }).then(function (response) {
	
	    if (response.length > 0) {
	      return response[0];
	    } else {
	      var organisation = client.create('organisations');
	      organisation.set('name', organisationName);
	      organisation.set('description', 'Created by ' + currntUserName);
	      return organisation.sync().then(function (response) {
	        return response;
	      });
	    }
	  });
	}

/***/ },
/* 2387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPaymentsData = getPaymentsData;
	
	var _authService = __webpack_require__(21);
	
	var _axiosService = __webpack_require__(86);
	
	var _axiosService2 = _interopRequireDefault(_axiosService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function paymentsQuery(id) {
	  var query = '\n  query Payments {\n    campaigns(id: "' + id + '") {\n      id\n      name\n      budget\n      teamDiscussion\n      clientDiscussion\n      discussions {\n        id\n        name\n        budget\n        budgetStatus\n        members(role: "INFLUENCER") {\n          id\n          user {\n            id\n          }\n          email\n          role\n          name\n        }\n      }\n    }\n  }';
	  return query;
	}
	
	function getPaymentsData(id) {
	  var axiosService = new _axiosService2.default(("https://api2.dyzio.co/v1"), 10000, { Authorization: 'Bearer ' + _authService.authService.getToken() });
	
	  var query = paymentsQuery(id);
	
	  return axiosService.post('', {
	    query: query,
	    variables: null,
	    operationName: null
	  }).then(function (res) {
	    return res.data.data.campaigns[0];
	  });
	}

/***/ },
/* 2388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTokenExpirationDate = getTokenExpirationDate;
	exports.isTokenExpired = isTokenExpired;
	
	var _jwtDecode = __webpack_require__(1298);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTokenExpirationDate(token) {
	  var decoded = (0, _jwtDecode2.default)(token);
	  if (!decoded.exp) {
	    return null;
	  }
	
	  var date = new Date(0); // The 0 here is the key, which sets the date to the epoch
	  date.setUTCSeconds(decoded.exp);
	  return date;
	}
	
	function isTokenExpired(token) {
	  var date = getTokenExpirationDate(token);
	  var offsetSeconds = 0;
	  if (date === null) {
	    return false;
	  }
	  return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
	}

/***/ },
/* 2389 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendDesktopNotification = sendDesktopNotification;
	exports.checkDesktopNotificationPermissions = checkDesktopNotificationPermissions;
	exports.checkNotificationStatusCanBeSet = checkNotificationStatusCanBeSet;
	exports.requestDesktopNotificationPermissions = requestDesktopNotificationPermissions;
	function sendDesktopNotification(title, options, onClickFunction) {
	  var notification = new Notification(title, options);
	  notification.onclick = onClickFunction;
	}
	
	function checkDesktopNotificationPermissions() {
	  if (!('Notification' in window)) return false;
	  if (Notification.permission === 'granted') {
	    return true;
	  } else if (Notification.permission !== 'denied') {
	    Notification.requestPermission(function (permission) {
	      return permission === 'granted' ? true : false;
	    });
	  }
	}
	
	function checkNotificationStatusCanBeSet() {
	  if (!('Notification' in window)) return false;
	  if (Notification.permission === 'granted') {
	    return false;
	  } else if (Notification.permission !== 'denied') {
	    return true;
	  }
	}
	
	function requestDesktopNotificationPermissions(callback) {
	  Notification.requestPermission(function (permission) {
	    callback();
	  });
	}

/***/ },
/* 2390 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  name: 'Campaign Report',
	  description: 'Standard campaign report, that includes every post, story or video that is being tracked, across all platforms.',
	  icon: 'file text outline',
	  link: 'campaign',
	  type: 'free',
	  color: 'blue',
	  helpLink: 'http://help.dyzio.co/en/articles/5391082-campaign-report'
	}, {
	  name: 'Instagram Report',
	  description: 'Basic Instagram report for Instagram-only campaigns. Includes Influencer summary cards, visualisation and engagement rates.',
	  icon: 'instagram',
	  link: 'instagram',
	  type: 'free',
	  color: 'blue',
	  helpLink: 'http://help.dyzio.co/en/articles/5391088-instagram-report'
	}, {
	  name: 'ROI Report',
	  description: 'Analyse the ROI of each influencer on your campaign. Add a budget or gift value to each influencer to activate all the report data.',
	  icon: 'dollar',
	  link: 'roi',
	  type: 'free',
	  color: 'blue',
	  helpLink: 'https://help.dyzio.co/en/articles/2816572-roi-report'
	}, {
	  name: 'Earned Media Value',
	  description: 'View the Impression EMV or Engagement EMV, at both the influencer and campaign level. Add CPMs in the campaign settings tab to activate all report data.',
	  icon: 'calculator',
	  link: 'emv',
	  type: 'free',
	  color: 'blue',
	  helpLink: 'https://help.dyzio.co/en/articles/4156487-how-to-calculate-earned-media-value-emv'
	}, {
	  name: 'Custom Instagram',
	  description: 'Customisable report for Instagram-only campaigns. Includes images for all posts and stories, plus add your campaign overview, favorite posts and comments.',
	  icon: 'instagram',
	  link: 'instagram-custom',
	  type: 'premium',
	  color: 'pink',
	  helpLink: 'https://help.dyzio.co/en/articles/5099207-custom-instagram-report'
	}, {
	  name: 'Authorisation Report',
	  description: 'See which influencers have successfully authenticated on your campaign. Access the campaign invite URLs, to share with your influencers if needed.',
	  icon: 'lock',
	  link: 'auth',
	  type: 'premium',
	  color: 'pink',
	  helpLink: 'http://help.dyzio.co/en/articles/5391110-influencer-authorisation-report'
	}, {
	  name: 'Tiktok Report',
	  description: 'Customisable report for TikTok campaigns. Includes images and data for all TikTok posts, plus add your campaign overview.',
	  icon: 'file text outline',
	  link: 'tiktok',
	  type: 'premium',
	  color: 'pink',
	  helpLink: 'http://help.dyzio.co/en/articles/6778681-tiktok-custom-report'
	}, {
	  name: 'Paid Report',
	  description: 'Add Facebook paid campaign date to the Campaign Report, requires a Facebook Ads Manager integration.',
	  icon: 'money bill alternate outline',
	  link: 'paid',
	  type: 'integration',
	  subType: 'facebook',
	  color: 'green',
	  helpLink: 'http://help.dyzio.co/en/articles/5391120-facebook-paid-report'
	}, {
	  name: 'Guaranteed Impressions',
	  description: 'Merge Facebook paid data with organic post data to show the combined data for your campaign, requires a Facebook Ads Manager integration.',
	  icon: 'line graph',
	  link: 'gi',
	  type: 'integration',
	  subType: 'facebook',
	  color: 'green',
	  helpLink: 'http://help.dyzio.co/en/articles/5391122-guaranteed-impression-report'
	}, {
	  name: 'Google Analytics',
	  description: 'Track influencer post click activate through to your custom goals set-up in Google Analytics. Requires a Google Analytics integration and a bespoke report.',
	  icon: 'google',
	  link: 'ga',
	  type: 'integration',
	  subType: 'google',
	  color: 'green',
	  helpLink: 'http://help.dyzio.co/en/articles/5391126-google-analytics-report'
	}, {
	  name: 'Shopify',
	  description: 'Track Shopify sales and revenue, linked directly to your influencers’ social activity. Requires a Shopify integration and a bespoke report.',
	  icon: 'shop',
	  link: 'shopify',
	  type: 'integration',
	  subType: 'shopify',
	  color: 'green',
	  helpLink: 'http://help.dyzio.co/en/articles/5391126-google-analytics-report'
	}];

/***/ },
/* 2391 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  name: 'Campaign Report',
	  description: 'Standard campaign report, that includes every post, story or video that is being tracked, across all platforms.',
	  icon: 'file text outline',
	  link: 'campaign',
	  type: 'premium',
	  color: 'pink',
	  helpLink: 'http://help.dyzio.co/en/articles/5391082-campaign-report'
	}, {
	  name: 'Instagram Report',
	  description: 'Basic Instagram report for Instagram-only campaigns. Includes Influencer summary cards, visualisation and engagement rates.',
	  icon: 'instagram',
	  link: 'instagram',
	  type: 'premium',
	  color: 'pink',
	  helpLink: 'http://help.dyzio.co/en/articles/5391088-instagram-report'
	}, {
	  name: 'ROI Report',
	  description: 'Analyse the ROI of each influencer on your campaign. Add a budget or gift value to each influencer to activate all the report data.',
	  icon: 'dollar',
	  link: 'roi',
	  type: 'premium',
	  color: 'pink',
	  helpLink: 'https://help.dyzio.co/en/articles/2816572-roi-report'
	}, {
	  name: 'Earned Media Value',
	  description: 'View the Impression EMV or Engagement EMV, at both the influencer and campaign level. Add CPMs in the campaign settings tab to activate all report data.',
	  icon: 'calculator',
	  link: 'emv',
	  type: 'premium',
	  color: 'pink',
	  helpLink: 'https://help.dyzio.co/en/articles/4156487-how-to-calculate-earned-media-value-emv'
	}, {
	  name: 'Custom Instagram',
	  description: 'Customisable report for Instagram-only campaigns. Includes images for all posts and stories, plus add your campaign overview, favorite posts and comments.',
	  icon: 'instagram',
	  link: 'instagram-custom',
	  type: 'premium',
	  color: 'pink',
	  helpLink: 'https://help.dyzio.co/en/articles/5099207-custom-instagram-report'
	},
	// {
	//   name: 'Authorisation Report',
	//   description: 'See which influencers have successfully authenticated on your campaign. Access the campaign invite URLs, to share with your influencers if needed.',
	//   icon: 'lock',
	//   link: 'auth',
	//   type: 'premium',
	//   color: 'pink',
	//   helpLink: 'http://help.dyzio.co/en/articles/5391110-influencer-authorisation-report',
	// },
	{
	  name: 'Insights Report',
	  description: 'View the top performing influencers, posts and stories on your Instagram campaign. Filter and rank the results by different KPIs.',
	  icon: 'file text outline',
	  link: 'campaign-insights',
	  type: 'premium',
	  color: 'pink',
	  helpLink: 'http://help.dyzio.co/en/articles/5631782-campaign-insights-report'
	}, {
	  name: 'Tiktok Report',
	  description: 'Customisable report for TikTok campaigns. Includes images and data for all TikTok posts, plus add your campaign overview.',
	  icon: 'file text outline',
	  link: 'tiktok',
	  type: 'premium',
	  color: 'pink',
	  helpLink: 'http://help.dyzio.co/en/articles/6778681-tiktok-custom-report'
	}, {
	  name: 'Follower Growth',
	  description: 'View the follower growth of each influencers’ socials networks used in the campaign. Data updates every 4 days.',
	  icon: 'line graph',
	  link: 'followers',
	  type: 'premium',
	  color: 'pink',
	  helpLink: 'http://help.dyzio.co/en/articles/5736419-follower-growth-report',
	  organisations: ['f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96', 'ab432213-e637-492d-9377-05c2b52a7748']
	}, {
	  name: 'Google Analytics',
	  description: 'Track influencer post click activate through to your custom goals set-up in Google Analytics. Requires a Google Analytics integration and a bespoke report.',
	  icon: 'google',
	  link: 'ga',
	  type: 'integration',
	  subType: 'google',
	  color: 'green',
	  helpLink: 'http://help.dyzio.co/en/articles/5391126-google-analytics-report'
	}, {
	  name: 'Shopify',
	  description: 'Track Shopify sales and revenue, linked directly to your influencers’ social activity. Requires a Shopify integration and a bespoke report.',
	  icon: 'shop',
	  link: 'shopify',
	  type: 'integration',
	  subType: 'shopify',
	  color: 'green',
	  helpLink: 'http://help.dyzio.co/en/articles/5391126-google-analytics-report'
	}, {
	  name: 'PrestaShop',
	  description: 'Track PrestaShop sales and revenue, linked directly to your influencers’ social activity. Requires a PrestaShop integration and a bespoke report.',
	  icon: 'shop',
	  link: 'prestashop',
	  type: 'integration',
	  subType: 'prestashop',
	  color: 'green',
	  helpLink: 'http://help.dyzio.co/en/articles/5391126-google-analytics-report'
	}, {
	  name: 'Paid Report',
	  description: 'Add Facebook paid campaign date to the Campaign Report, requires a Facebook Ads Manager integration.',
	  icon: 'money bill alternate outline',
	  link: 'paid',
	  type: 'integration',
	  subType: 'facebook',
	  color: 'green',
	  helpLink: 'http://help.dyzio.co/en/articles/5391120-facebook-paid-report'
	}, {
	  name: 'Guaranteed Impressions',
	  description: 'Merge Facebook paid data with organic post data to show the combined data for your campaign, requires a Facebook Ads Manager integration.',
	  icon: 'line graph',
	  link: 'gi',
	  type: 'integration',
	  subType: 'facebook',
	  color: 'green',
	  helpLink: 'http://help.dyzio.co/en/articles/5391122-guaranteed-impression-report'
	}];

/***/ },
/* 2392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _errorHandlingService = __webpack_require__(30);
	
	var SafeLocalStorage = module.exports;
	
	SafeLocalStorage.check = function () {
	
	  var isLocalStorageOk = false;
	
	  try {
	    localStorage.setItem('testLocalStorage', 'pending');
	    localStorage.removeItem('testLocalStorage');
	    isLocalStorageOk = true;
	  } catch (error) {
	    (0, _errorHandlingService.reportWarning)('UNAVAILABLE_LOCAL_STORAGE_WARNING', error);
	  }
	
	  return isLocalStorageOk;
	};

/***/ },
/* 2393 */
/***/ function(module, exports) {

	'use strict';
	
	var WHATS_NEW = {
	  text: 'See what\'s new in Dyzio',
	  link: 'https://help.dyzio.co/en/articles/6987785-product-update-feb-23'
	};
	
	module.exports = {
	  WHATS_NEW: WHATS_NEW
	};

/***/ },
/* 2394 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(2395);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2395 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(66)))

/***/ },
/* 2396 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2462), __esModule: true };

/***/ },
/* 2397 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2464), __esModule: true };

/***/ },
/* 2398 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2465), __esModule: true };

/***/ },
/* 2399 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2466), __esModule: true };

/***/ },
/* 2400 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2468), __esModule: true };

/***/ },
/* 2401 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2471), __esModule: true };

/***/ },
/* 2402 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2472), __esModule: true };

/***/ },
/* 2403 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2473), __esModule: true };

/***/ },
/* 2404 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2474), __esModule: true };

/***/ },
/* 2405 */
/***/ function(module, exports, __webpack_require__) {

	var Filter = (function() {
	  function Filter(options) {
	    options = options || {};
	    this.list = options.emptyList && [] || Array.prototype.concat.apply(__webpack_require__(2945).words, [__webpack_require__(2407).array, options.list || []]);
	    this.placeHolder = options.placeHolder || '*';
	    this.regex = options.regex || /[^a-zA-z0-9|\$|\@]|\^/g;
	    this.replaceRegex = options.replaceRegex || /\w/g;
	  }
	
	  Filter.prototype.isProfane = function isProfane(string) {
	    var words = string.split(' ');
	    for (var j = 0; j < words.length; j++) {
	      var word = words[j].toLowerCase().replace(this.regex, '');
	      if (~this.list.indexOf(word)) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  Filter.prototype.replaceWord = function replaceWord(string) {
	    return string.replace(this.regex, '').replace(this.replaceRegex, this.placeHolder);
	  };
	
	  Filter.prototype.clean = function clean(string) {
	    return string.split(' ').map(function(word) {
	      return this.isProfane(word) ? this.replaceWord(word) : word;
	    }.bind(this)).join(' ');
	  };
	
	  Filter.prototype.addWords = function addWords(words) {
	    words = (words instanceof Array) ? words : [words];
	    this.list = this.list.concat(words);
	  };
	
	  Filter.prototype.removeWords = function removeWords() {
	    var words = Array.prototype.slice.call(arguments);
	    words.map(function(word) {
	      return this.list.indexOf(word);
	    }, this).filter(function(index) {
	      return !!~index;
	    }).forEach(function(index){
	      this.list.splice(index, 1);
	    }, this);
	  };
	
	  return Filter;
	})();
	
	module.exports = Filter;

/***/ },
/* 2406 */
/***/ function(module, exports) {

	module.exports = ["4r5e", "5h1t", "5hit", "a55", "anal", "anus", "ar5e", "arrse", "arse", "ass", "ass-fucker", "asses", "assfucker", "assfukka", "asshole", "assholes", "asswhole", "a_s_s", "b!tch", "b00bs", "b17ch", "b1tch", "ballbag", "balls", "ballsack", "bastard", "beastial", "beastiality", "bellend", "bestial", "bestiality", "bi+ch", "biatch", "bitch", "bitcher", "bitchers", "bitches", "bitchin", "bitching", "bloody", "blow job", "blowjob", "blowjobs", "boiolas", "bollock", "bollok", "boner", "boob", "boobs", "booobs", "boooobs", "booooobs", "booooooobs", "breasts", "buceta", "bugger", "bum", "bunny fucker", "butt", "butthole", "buttmuch", "buttplug", "c0ck", "c0cksucker", "carpet muncher", "cawk", "chink", "cipa", "cl1t", "clit", "clitoris", "clits", "cnut", "cock", "cock-sucker", "cockface", "cockhead", "cockmunch", "cockmuncher", "cocks", "cocksuck", "cocksucked", "cocksucker", "cocksucking", "cocksucks", "cocksuka", "cocksukka", "cok", "cokmuncher", "coksucka", "coon", "cox", "crap", "cum", "cummer", "cumming", "cums", "cumshot", "cunilingus", "cunillingus", "cunnilingus", "cunt", "cuntlick", "cuntlicker", "cuntlicking", "cunts", "cyalis", "cyberfuc", "cyberfuck", "cyberfucked", "cyberfucker", "cyberfuckers", "cyberfucking", "d1ck", "damn", "dick", "dickhead", "dildo", "dildos", "dink", "dinks", "dirsa", "dlck", "dog-fucker", "doggin", "dogging", "donkeyribber", "doosh", "duche", "dyke", "ejaculate", "ejaculated", "ejaculates", "ejaculating", "ejaculatings", "ejaculation", "ejakulate", "f u c k", "f u c k e r", "f4nny", "fag", "fagging", "faggitt", "faggot", "faggs", "fagot", "fagots", "fags", "fanny", "fannyflaps", "fannyfucker", "fanyy", "fatass", "fcuk", "fcuker", "fcuking", "feck", "fecker", "felching", "fellate", "fellatio", "fingerfuck", "fingerfucked", "fingerfucker", "fingerfuckers", "fingerfucking", "fingerfucks", "fistfuck", "fistfucked", "fistfucker", "fistfuckers", "fistfucking", "fistfuckings", "fistfucks", "flange", "fook", "fooker", "fuck", "fucka", "fucked", "fucker", "fuckers", "fuckhead", "fuckheads", "fuckin", "fucking", "fuckings", "fuckingshitmotherfucker", "fuckme", "fucks", "fuckwhit", "fuckwit", "fudge packer", "fudgepacker", "fuk", "fuker", "fukker", "fukkin", "fuks", "fukwhit", "fukwit", "fux", "fux0r", "f_u_c_k", "gangbang", "gangbanged", "gangbangs", "gaylord", "gaysex", "goatse", "God", "god-dam", "god-damned", "goddamn", "goddamned", "hardcoresex", "hell", "heshe", "hoar", "hoare", "hoer", "homo", "hore", "horniest", "horny", "hotsex", "jack-off", "jackoff", "jap", "jerk-off", "jism", "jiz", "jizm", "jizz", "kawk", "knob", "knobead", "knobed", "knobend", "knobhead", "knobjocky", "knobjokey", "kock", "kondum", "kondums", "kum", "kummer", "kumming", "kums", "kunilingus", "l3i+ch", "l3itch", "labia", "lust", "lusting", "m0f0", "m0fo", "m45terbate", "ma5terb8", "ma5terbate", "masochist", "master-bate", "masterb8", "masterbat*", "masterbat3", "masterbate", "masterbation", "masterbations", "masturbate", "mo-fo", "mof0", "mofo", "mothafuck", "mothafucka", "mothafuckas", "mothafuckaz", "mothafucked", "mothafucker", "mothafuckers", "mothafuckin", "mothafucking", "mothafuckings", "mothafucks", "mother fucker", "motherfuck", "motherfucked", "motherfucker", "motherfuckers", "motherfuckin", "motherfucking", "motherfuckings", "motherfuckka", "motherfucks", "muff", "mutha", "muthafecker", "muthafuckker", "muther", "mutherfucker", "n1gga", "n1gger", "nazi", "nigg3r", "nigg4h", "nigga", "niggah", "niggas", "niggaz", "nigger", "niggers", "nob", "nob jokey", "nobhead", "nobjocky", "nobjokey", "numbnuts", "nutsack", "orgasim", "orgasims", "orgasm", "orgasms", "p0rn", "pawn", "pecker", "penis", "penisfucker", "phonesex", "phuck", "phuk", "phuked", "phuking", "phukked", "phukking", "phuks", "phuq", "pigfucker", "pimpis", "piss", "pissed", "pisser", "pissers", "pisses", "pissflaps", "pissin", "pissing", "pissoff", "poop", "porn", "porno", "pornography", "pornos", "prick", "pricks", "pron", "pube", "pusse", "pussi", "pussies", "pussy", "pussys", "rectum", "retard", "rimjaw", "rimming", "s hit", "s.o.b.", "sadist", "schlong", "screwing", "scroat", "scrote", "scrotum", "semen", "sex", "sh!+", "sh!t", "sh1t", "shag", "shagger", "shaggin", "shagging", "shemale", "shi+", "shit", "shitdick", "shite", "shited", "shitey", "shitfuck", "shitfull", "shithead", "shiting", "shitings", "shits", "shitted", "shitter", "shitters", "shitting", "shittings", "shitty", "skank", "slut", "sluts", "smegma", "smut", "snatch", "son-of-a-bitch", "spac", "spunk", "s_h_i_t", "t1tt1e5", "t1tties", "teets", "teez", "testical", "testicle", "tit", "titfuck", "tits", "titt", "tittie5", "tittiefucker", "titties", "tittyfuck", "tittywank", "titwank", "tosser", "turd", "tw4t", "twat", "twathead", "twatty", "twunt", "twunter", "v14gra", "v1gra", "vagina", "viagra", "vulva", "w00se", "wang", "wank", "wanker", "wanky", "whoar", "whore", "willies", "willy", "xrated", "xxx"];

/***/ },
/* 2407 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  object: __webpack_require__(2408),
	  array: __webpack_require__(2406),
	  regex: __webpack_require__(2409)
	};

/***/ },
/* 2408 */
/***/ function(module, exports) {

	module.exports = {"4r5e": 1, "5h1t": 1, "5hit": 1, "a55": 1, "anal": 1, "anus": 1, "ar5e": 1, "arrse": 1, "arse": 1, "ass": 1, "ass-fucker": 1, "asses": 1, "assfucker": 1, "assfukka": 1, "asshole": 1, "assholes": 1, "asswhole": 1, "a_s_s": 1, "b!tch": 1, "b00bs": 1, "b17ch": 1, "b1tch": 1, "ballbag": 1, "balls": 1, "ballsack": 1, "bastard": 1, "beastial": 1, "beastiality": 1, "bellend": 1, "bestial": 1, "bestiality": 1, "bi+ch": 1, "biatch": 1, "bitch": 1, "bitcher": 1, "bitchers": 1, "bitches": 1, "bitchin": 1, "bitching": 1, "bloody": 1, "blow job": 1, "blowjob": 1, "blowjobs": 1, "boiolas": 1, "bollock": 1, "bollok": 1, "boner": 1, "boob": 1, "boobs": 1, "booobs": 1, "boooobs": 1, "booooobs": 1, "booooooobs": 1, "breasts": 1, "buceta": 1, "bugger": 1, "bum": 1, "bunny fucker": 1, "butt": 1, "butthole": 1, "buttmuch": 1, "buttplug": 1, "c0ck": 1, "c0cksucker": 1, "carpet muncher": 1, "cawk": 1, "chink": 1, "cipa": 1, "cl1t": 1, "clit": 1, "clitoris": 1, "clits": 1, "cnut": 1, "cock": 1, "cock-sucker": 1, "cockface": 1, "cockhead": 1, "cockmunch": 1, "cockmuncher": 1, "cocks": 1, "cocksuck": 1, "cocksucked": 1, "cocksucker": 1, "cocksucking": 1, "cocksucks": 1, "cocksuka": 1, "cocksukka": 1, "cok": 1, "cokmuncher": 1, "coksucka": 1, "coon": 1, "cox": 1, "crap": 1, "cum": 1, "cummer": 1, "cumming": 1, "cums": 1, "cumshot": 1, "cunilingus": 1, "cunillingus": 1, "cunnilingus": 1, "cunt": 1, "cuntlick": 1, "cuntlicker": 1, "cuntlicking": 1, "cunts": 1, "cyalis": 1, "cyberfuc": 1, "cyberfuck": 1, "cyberfucked": 1, "cyberfucker": 1, "cyberfuckers": 1, "cyberfucking": 1, "d1ck": 1, "damn": 1, "dick": 1, "dickhead": 1, "dildo": 1, "dildos": 1, "dink": 1, "dinks": 1, "dirsa": 1, "dlck": 1, "dog-fucker": 1, "doggin": 1, "dogging": 1, "donkeyribber": 1, "doosh": 1, "duche": 1, "dyke": 1, "ejaculate": 1, "ejaculated": 1, "ejaculates": 1, "ejaculating": 1, "ejaculatings": 1, "ejaculation": 1, "ejakulate": 1, "f u c k": 1, "f u c k e r": 1, "f4nny": 1, "fag": 1, "fagging": 1, "faggitt": 1, "faggot": 1, "faggs": 1, "fagot": 1, "fagots": 1, "fags": 1, "fanny": 1, "fannyflaps": 1, "fannyfucker": 1, "fanyy": 1, "fatass": 1, "fcuk": 1, "fcuker": 1, "fcuking": 1, "feck": 1, "fecker": 1, "felching": 1, "fellate": 1, "fellatio": 1, "fingerfuck": 1, "fingerfucked": 1, "fingerfucker": 1, "fingerfuckers": 1, "fingerfucking": 1, "fingerfucks": 1, "fistfuck": 1, "fistfucked": 1, "fistfucker": 1, "fistfuckers": 1, "fistfucking": 1, "fistfuckings": 1, "fistfucks": 1, "flange": 1, "fook": 1, "fooker": 1, "fuck": 1, "fucka": 1, "fucked": 1, "fucker": 1, "fuckers": 1, "fuckhead": 1, "fuckheads": 1, "fuckin": 1, "fucking": 1, "fuckings": 1, "fuckingshitmotherfucker": 1, "fuckme": 1, "fucks": 1, "fuckwhit": 1, "fuckwit": 1, "fudge packer": 1, "fudgepacker": 1, "fuk": 1, "fuker": 1, "fukker": 1, "fukkin": 1, "fuks": 1, "fukwhit": 1, "fukwit": 1, "fux": 1, "fux0r": 1, "f_u_c_k": 1, "gangbang": 1, "gangbanged": 1, "gangbangs": 1, "gaylord": 1, "gaysex": 1, "goatse": 1, "God": 1, "god-dam": 1, "god-damned": 1, "goddamn": 1, "goddamned": 1, "hardcoresex": 1, "hell": 1, "heshe": 1, "hoar": 1, "hoare": 1, "hoer": 1, "homo": 1, "hore": 1, "horniest": 1, "horny": 1, "hotsex": 1, "jack-off": 1, "jackoff": 1, "jap": 1, "jerk-off": 1, "jism": 1, "jiz": 1, "jizm": 1, "jizz": 1, "kawk": 1, "knob": 1, "knobead": 1, "knobed": 1, "knobend": 1, "knobhead": 1, "knobjocky": 1, "knobjokey": 1, "kock": 1, "kondum": 1, "kondums": 1, "kum": 1, "kummer": 1, "kumming": 1, "kums": 1, "kunilingus": 1, "l3i+ch": 1, "l3itch": 1, "labia": 1, "lust": 1, "lusting": 1, "m0f0": 1, "m0fo": 1, "m45terbate": 1, "ma5terb8": 1, "ma5terbate": 1, "masochist": 1, "master-bate": 1, "masterb8": 1, "masterbat*": 1, "masterbat3": 1, "masterbate": 1, "masterbation": 1, "masterbations": 1, "masturbate": 1, "mo-fo": 1, "mof0": 1, "mofo": 1, "mothafuck": 1, "mothafucka": 1, "mothafuckas": 1, "mothafuckaz": 1, "mothafucked": 1, "mothafucker": 1, "mothafuckers": 1, "mothafuckin": 1, "mothafucking": 1, "mothafuckings": 1, "mothafucks": 1, "mother fucker": 1, "motherfuck": 1, "motherfucked": 1, "motherfucker": 1, "motherfuckers": 1, "motherfuckin": 1, "motherfucking": 1, "motherfuckings": 1, "motherfuckka": 1, "motherfucks": 1, "muff": 1, "mutha": 1, "muthafecker": 1, "muthafuckker": 1, "muther": 1, "mutherfucker": 1, "n1gga": 1, "n1gger": 1, "nazi": 1, "nigg3r": 1, "nigg4h": 1, "nigga": 1, "niggah": 1, "niggas": 1, "niggaz": 1, "nigger": 1, "niggers": 1, "nob": 1, "nob jokey": 1, "nobhead": 1, "nobjocky": 1, "nobjokey": 1, "numbnuts": 1, "nutsack": 1, "orgasim": 1, "orgasims": 1, "orgasm": 1, "orgasms": 1, "p0rn": 1, "pawn": 1, "pecker": 1, "penis": 1, "penisfucker": 1, "phonesex": 1, "phuck": 1, "phuk": 1, "phuked": 1, "phuking": 1, "phukked": 1, "phukking": 1, "phuks": 1, "phuq": 1, "pigfucker": 1, "pimpis": 1, "piss": 1, "pissed": 1, "pisser": 1, "pissers": 1, "pisses": 1, "pissflaps": 1, "pissin": 1, "pissing": 1, "pissoff": 1, "poop": 1, "porn": 1, "porno": 1, "pornography": 1, "pornos": 1, "prick": 1, "pricks": 1, "pron": 1, "pube": 1, "pusse": 1, "pussi": 1, "pussies": 1, "pussy": 1, "pussys": 1, "rectum": 1, "retard": 1, "rimjaw": 1, "rimming": 1, "s hit": 1, "s.o.b.": 1, "sadist": 1, "schlong": 1, "screwing": 1, "scroat": 1, "scrote": 1, "scrotum": 1, "semen": 1, "sex": 1, "sh!+": 1, "sh!t": 1, "sh1t": 1, "shag": 1, "shagger": 1, "shaggin": 1, "shagging": 1, "shemale": 1, "shi+": 1, "shit": 1, "shitdick": 1, "shite": 1, "shited": 1, "shitey": 1, "shitfuck": 1, "shitfull": 1, "shithead": 1, "shiting": 1, "shitings": 1, "shits": 1, "shitted": 1, "shitter": 1, "shitters": 1, "shitting": 1, "shittings": 1, "shitty": 1, "skank": 1, "slut": 1, "sluts": 1, "smegma": 1, "smut": 1, "snatch": 1, "son-of-a-bitch": 1, "spac": 1, "spunk": 1, "s_h_i_t": 1, "t1tt1e5": 1, "t1tties": 1, "teets": 1, "teez": 1, "testical": 1, "testicle": 1, "tit": 1, "titfuck": 1, "tits": 1, "titt": 1, "tittie5": 1, "tittiefucker": 1, "titties": 1, "tittyfuck": 1, "tittywank": 1, "titwank": 1, "tosser": 1, "turd": 1, "tw4t": 1, "twat": 1, "twathead": 1, "twatty": 1, "twunt": 1, "twunter": 1, "v14gra": 1, "v1gra": 1, "vagina": 1, "viagra": 1, "vulva": 1, "w00se": 1, "wang": 1, "wank": 1, "wanker": 1, "wanky": 1, "whoar": 1, "whore": 1, "willies": 1, "willy": 1, "xrated": 1, "xxx": 1};

/***/ },
/* 2409 */
/***/ function(module, exports) {

	module.exports = /\b(4r5e|5h1t|5hit|a55|anal|anus|ar5e|arrse|arse|ass|ass-fucker|asses|assfucker|assfukka|asshole|assholes|asswhole|a_s_s|b!tch|b00bs|b17ch|b1tch|ballbag|balls|ballsack|bastard|beastial|beastiality|bellend|bestial|bestiality|bi\+ch|biatch|bitch|bitcher|bitchers|bitches|bitchin|bitching|bloody|blow job|blowjob|blowjobs|boiolas|bollock|bollok|boner|boob|boobs|booobs|boooobs|booooobs|booooooobs|breasts|buceta|bugger|bum|bunny fucker|butt|butthole|buttmuch|buttplug|c0ck|c0cksucker|carpet muncher|cawk|chink|cipa|cl1t|clit|clitoris|clits|cnut|cock|cock-sucker|cockface|cockhead|cockmunch|cockmuncher|cocks|cocksuck|cocksucked|cocksucker|cocksucking|cocksucks|cocksuka|cocksukka|cok|cokmuncher|coksucka|coon|cox|crap|cum|cummer|cumming|cums|cumshot|cunilingus|cunillingus|cunnilingus|cunt|cuntlick|cuntlicker|cuntlicking|cunts|cyalis|cyberfuc|cyberfuck|cyberfucked|cyberfucker|cyberfuckers|cyberfucking|d1ck|damn|dick|dickhead|dildo|dildos|dink|dinks|dirsa|dlck|dog-fucker|doggin|dogging|donkeyribber|doosh|duche|dyke|ejaculate|ejaculated|ejaculates|ejaculating|ejaculatings|ejaculation|ejakulate|f u c k|f u c k e r|f4nny|fag|fagging|faggitt|faggot|faggs|fagot|fagots|fags|fanny|fannyflaps|fannyfucker|fanyy|fatass|fcuk|fcuker|fcuking|feck|fecker|felching|fellate|fellatio|fingerfuck|fingerfucked|fingerfucker|fingerfuckers|fingerfucking|fingerfucks|fistfuck|fistfucked|fistfucker|fistfuckers|fistfucking|fistfuckings|fistfucks|flange|fook|fooker|fuck|fucka|fucked|fucker|fuckers|fuckhead|fuckheads|fuckin|fucking|fuckings|fuckingshitmotherfucker|fuckme|fucks|fuckwhit|fuckwit|fudge packer|fudgepacker|fuk|fuker|fukker|fukkin|fuks|fukwhit|fukwit|fux|fux0r|f_u_c_k|gangbang|gangbanged|gangbangs|gaylord|gaysex|goatse|God|god-dam|god-damned|goddamn|goddamned|hardcoresex|hell|heshe|hoar|hoare|hoer|homo|hore|horniest|horny|hotsex|jack-off|jackoff|jap|jerk-off|jism|jiz|jizm|jizz|kawk|knob|knobead|knobed|knobend|knobhead|knobjocky|knobjokey|kock|kondum|kondums|kum|kummer|kumming|kums|kunilingus|l3i\+ch|l3itch|labia|lust|lusting|m0f0|m0fo|m45terbate|ma5terb8|ma5terbate|masochist|master-bate|masterb8|masterbat*|masterbat3|masterbate|masterbation|masterbations|masturbate|mo-fo|mof0|mofo|mothafuck|mothafucka|mothafuckas|mothafuckaz|mothafucked|mothafucker|mothafuckers|mothafuckin|mothafucking|mothafuckings|mothafucks|mother fucker|motherfuck|motherfucked|motherfucker|motherfuckers|motherfuckin|motherfucking|motherfuckings|motherfuckka|motherfucks|muff|mutha|muthafecker|muthafuckker|muther|mutherfucker|n1gga|n1gger|nazi|nigg3r|nigg4h|nigga|niggah|niggas|niggaz|nigger|niggers|nob|nob jokey|nobhead|nobjocky|nobjokey|numbnuts|nutsack|orgasim|orgasims|orgasm|orgasms|p0rn|pawn|pecker|penis|penisfucker|phonesex|phuck|phuk|phuked|phuking|phukked|phukking|phuks|phuq|pigfucker|pimpis|piss|pissed|pisser|pissers|pisses|pissflaps|pissin|pissing|pissoff|poop|porn|porno|pornography|pornos|prick|pricks|pron|pube|pusse|pussi|pussies|pussy|pussys|rectum|retard|rimjaw|rimming|s hit|s.o.b.|sadist|schlong|screwing|scroat|scrote|scrotum|semen|sex|sh!\+|sh!t|sh1t|shag|shagger|shaggin|shagging|shemale|shi\+|shit|shitdick|shite|shited|shitey|shitfuck|shitfull|shithead|shiting|shitings|shits|shitted|shitter|shitters|shitting|shittings|shitty|skank|slut|sluts|smegma|smut|snatch|son-of-a-bitch|spac|spunk|s_h_i_t|t1tt1e5|t1tties|teets|teez|testical|testicle|tit|titfuck|tits|titt|tittie5|tittiefucker|titties|tittyfuck|tittywank|titwank|tosser|turd|tw4t|twat|twathead|twatty|twunt|twunter|v14gra|v1gra|vagina|viagra|vulva|w00se|wang|wank|wanker|wanky|whoar|whore|willies|willy|xrated|xxx)\b/gi;

/***/ },
/* 2410 */
/***/ function(module, exports, __webpack_require__) {

	/*jshint node:true */
	'use strict';
	var Buffer = __webpack_require__(58).Buffer; // browserify
	var SlowBuffer = __webpack_require__(58).SlowBuffer;
	
	module.exports = bufferEq;
	
	function bufferEq(a, b) {
	
	  // shortcutting on type is necessary for correctness
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    return false;
	  }
	
	  // buffer sizes should be well-known information, so despite this
	  // shortcutting, it doesn't leak any information about the *contents* of the
	  // buffers.
	  if (a.length !== b.length) {
	    return false;
	  }
	
	  var c = 0;
	  for (var i = 0; i < a.length; i++) {
	    /*jshint bitwise:false */
	    c |= a[i] ^ b[i]; // XOR
	  }
	  return c === 0;
	}
	
	bufferEq.install = function() {
	  Buffer.prototype.equal = SlowBuffer.prototype.equal = function equal(that) {
	    return bufferEq(this, that);
	  };
	};
	
	var origBufEqual = Buffer.prototype.equal;
	var origSlowBufEqual = SlowBuffer.prototype.equal;
	bufferEq.restore = function() {
	  Buffer.prototype.equal = origBufEqual;
	  SlowBuffer.prototype.equal = origSlowBufEqual;
	};


/***/ },
/* 2411 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 2412 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  function listen(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function () {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  function emit() {
	    currentListeners = nextListeners;
	    var listeners = currentListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i].apply(listeners, arguments);
	    }
	  }
	
	  return {
	    listen: listen,
	    emit: emit
	  };
	};

/***/ },
/* 2413 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @namespace Chart
	 */
	var Chart = __webpack_require__(2434)();
	
	__webpack_require__(2432)(Chart);
	__webpack_require__(2448)(Chart);
	__webpack_require__(2428)(Chart);
	__webpack_require__(2437)(Chart);
	__webpack_require__(2431)(Chart);
	__webpack_require__(2427)(Chart);
	__webpack_require__(2429)(Chart);
	__webpack_require__(2430)(Chart);
	__webpack_require__(2435)(Chart);
	__webpack_require__(2439)(Chart);
	__webpack_require__(2440)(Chart);
	__webpack_require__(2438)(Chart);
	__webpack_require__(2441)(Chart);
	__webpack_require__(2436)(Chart);
	__webpack_require__(2433)(Chart);
	__webpack_require__(2442)(Chart);
	
	__webpack_require__(2443)(Chart);
	__webpack_require__(2444)(Chart);
	__webpack_require__(2445)(Chart);
	__webpack_require__(2446)(Chart);
	
	__webpack_require__(2451)(Chart);
	__webpack_require__(2449)(Chart);
	__webpack_require__(2450)(Chart);
	__webpack_require__(2452)(Chart);
	__webpack_require__(2453)(Chart);
	__webpack_require__(2454)(Chart);
	
	// Controllers must be loaded after elements
	// See Chart.core.datasetController.dataElementType
	__webpack_require__(2421)(Chart);
	__webpack_require__(2422)(Chart);
	__webpack_require__(2423)(Chart);
	__webpack_require__(2424)(Chart);
	__webpack_require__(2425)(Chart);
	__webpack_require__(2426)(Chart);
	
	__webpack_require__(2414)(Chart);
	__webpack_require__(2415)(Chart);
	__webpack_require__(2416)(Chart);
	__webpack_require__(2417)(Chart);
	__webpack_require__(2418)(Chart);
	__webpack_require__(2419)(Chart);
	__webpack_require__(2420)(Chart);
	
	window.Chart = module.exports = Chart;


/***/ },
/* 2414 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bar = function(context, config) {
			config.type = 'bar';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 2415 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bubble = function(context, config) {
			config.type = 'bubble';
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 2416 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Doughnut = function(context, config) {
			config.type = 'doughnut';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 2417 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Line = function(context, config) {
			config.type = 'line';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 2418 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.PolarArea = function(context, config) {
			config.type = 'polarArea';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 2419 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Radar = function(context, config) {
			config.type = 'radar';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 2420 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // scatter should not use a category axis
					position: 'bottom',
					id: 'x-axis-1' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-1'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem) {
						return '(' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ')';
					}
				}
			}
		};
	
		// Register the default config for this type
		Chart.defaults.scatter = defaultConfig;
	
		// Scatter charts use line controllers
		Chart.controllers.scatter = Chart.controllers.line;
	
		Chart.Scatter = function(context, config) {
			config.type = 'scatter';
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 2421 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
	
					// Specific to Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}],
				yAxes: [{
					type: 'linear'
				}]
			}
		};
	
		Chart.controllers.bar = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Rectangle,
	
			initialize: function(chart, datasetIndex) {
				Chart.DatasetController.prototype.initialize.call(this, chart, datasetIndex);
	
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				meta.stack = dataset.stack;
				// Use this to indicate that this is a bar dataset.
				meta.bar = true;
			},
	
			// Correctly calculate the bar width accounting for stacks and the fact that not all bars are visible
			getStackCount: function() {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
	
				var stacks = [];
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var dsMeta = me.chart.getDatasetMeta(datasetIndex);
					if (dsMeta.bar && me.chart.isDatasetVisible(datasetIndex) &&
						(yScale.options.stacked === false ||
						(yScale.options.stacked === true && stacks.indexOf(dsMeta.stack) === -1) ||
						(yScale.options.stacked === undefined && (dsMeta.stack === undefined || stacks.indexOf(dsMeta.stack) === -1)))) {
						stacks.push(dsMeta.stack);
					}
				}, me);
	
				return stacks.length;
			},
	
			update: function(reset) {
				var me = this;
				helpers.each(me.getMeta().data, function(rectangle, index) {
					me.updateElement(rectangle, index, reset);
				}, me);
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var scaleBase = yScale.getBasePixel();
				var rectangleElementOptions = me.chart.options.elements.rectangle;
				var custom = rectangle.custom || {};
				var dataset = me.getDataset();
	
				rectangle._xScale = xScale;
				rectangle._yScale = yScale;
				rectangle._datasetIndex = me.index;
				rectangle._index = index;
	
				var ruler = me.getRuler(index); // The index argument for compatible
				rectangle._model = {
					x: me.calculateBarX(index, me.index, ruler),
					y: reset ? scaleBase : me.calculateBarY(index, me.index),
	
					// Tooltip
					label: me.chart.data.labels[index],
					datasetLabel: dataset.label,
	
					// Appearance
					horizontal: false,
					base: reset ? scaleBase : me.calculateBarBase(me.index, index),
					width: me.calculateBarWidth(ruler),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor),
					borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleElementOptions.borderSkipped,
					borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth)
				};
	
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var base = yScale.getBaseValue();
				var original = base;
	
				if ((yScale.options.stacked === true) ||
					(yScale.options.stacked === undefined && meta.stack !== undefined)) {
					var chart = me.chart;
					var datasets = chart.data.datasets;
					var value = Number(datasets[datasetIndex].data[index]);
	
					for (var i = 0; i < datasetIndex; i++) {
						var currentDs = datasets[i];
						var currentDsMeta = chart.getDatasetMeta(i);
						if (currentDsMeta.bar && currentDsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i) &&
							meta.stack === currentDsMeta.stack) {
							var currentVal = Number(currentDs.data[index]);
							base += value < 0 ? Math.min(currentVal, original) : Math.max(currentVal, original);
						}
					}
	
					return yScale.getPixelForValue(base);
				}
	
				return yScale.getBasePixel();
			},
	
			getRuler: function() {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var stackCount = me.getStackCount();
	
				var tickWidth = xScale.width / xScale.ticks.length;
				var categoryWidth = tickWidth * xScale.options.categoryPercentage;
				var categorySpacing = (tickWidth - (tickWidth * xScale.options.categoryPercentage)) / 2;
				var fullBarWidth = categoryWidth / stackCount;
	
				var barWidth = fullBarWidth * xScale.options.barPercentage;
				var barSpacing = fullBarWidth - (fullBarWidth * xScale.options.barPercentage);
	
				return {
					stackCount: stackCount,
					tickWidth: tickWidth,
					categoryWidth: categoryWidth,
					categorySpacing: categorySpacing,
					fullBarWidth: fullBarWidth,
					barWidth: barWidth,
					barSpacing: barSpacing
				};
			},
	
			calculateBarWidth: function(ruler) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				if (xScale.options.barThickness) {
					return xScale.options.barThickness;
				}
				return ruler.barWidth;
			},
	
			// Get stack index from the given dataset index accounting for stacks and the fact that not all bars are visible
			getStackIndex: function(datasetIndex) {
				var me = this;
				var meta = me.chart.getDatasetMeta(datasetIndex);
				var yScale = me.getScaleForId(meta.yAxisID);
				var dsMeta, j;
				var stacks = [meta.stack];
	
				for (j = 0; j < datasetIndex; ++j) {
					dsMeta = this.chart.getDatasetMeta(j);
					if (dsMeta.bar && this.chart.isDatasetVisible(j) &&
						(yScale.options.stacked === false ||
						(yScale.options.stacked === true && stacks.indexOf(dsMeta.stack) === -1) ||
						(yScale.options.stacked === undefined && (dsMeta.stack === undefined || stacks.indexOf(dsMeta.stack) === -1)))) {
						stacks.push(dsMeta.stack);
					}
				}
	
				return stacks.length - 1;
			},
	
			calculateBarX: function(index, datasetIndex, ruler) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var stackIndex = me.getStackIndex(datasetIndex);
				var leftTick = xScale.getPixelForValue(null, index, datasetIndex, me.chart.isCombo);
				leftTick -= me.chart.isCombo ? (ruler.tickWidth / 2) : 0;
	
				return leftTick +
					(ruler.barWidth / 2) +
					ruler.categorySpacing +
					(ruler.barWidth * stackIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * stackIndex);
			},
	
			calculateBarY: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var value = Number(me.getDataset().data[index]);
	
				if (yScale.options.stacked ||
					(yScale.options.stacked === undefined && meta.stack !== undefined)) {
					var base = yScale.getBaseValue();
					var sumPos = base,
						sumNeg = base;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = me.chart.data.datasets[i];
						var dsMeta = me.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.yAxisID === yScale.id && me.chart.isDatasetVisible(i) &&
							meta.stack === dsMeta.stack) {
							var stackedVal = Number(ds.data[index]);
							if (stackedVal < 0) {
								sumNeg += stackedVal || 0;
							} else {
								sumPos += stackedVal || 0;
							}
						}
					}
	
					if (value < 0) {
						return yScale.getPixelForValue(sumNeg + value);
					}
					return yScale.getPixelForValue(sumPos + value);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			draw: function(ease) {
				var me = this;
				var easingDecimal = ease || 1;
				var metaData = me.getMeta().data;
				var dataset = me.getDataset();
				var i, len;
	
				Chart.canvasHelpers.clipArea(me.chart.chart.ctx, me.chart.chartArea);
				for (i = 0, len = metaData.length; i < len; ++i) {
					var d = dataset.data[i];
					if (d !== null && d !== undefined && !isNaN(d)) {
						metaData[i].transition(easingDecimal).draw();
					}
				}
				Chart.canvasHelpers.unclipArea(me.chart.chart.ctx);
			},
	
			setHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
	
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				var rectangleElementOptions = this.chart.options.elements.rectangle;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
			}
	
		});
	
	
		// including horizontalBar in the bar file, instead of a file of its own
		// it extends bar (like pie extends doughnut)
		Chart.defaults.horizontalBar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'linear',
					position: 'bottom'
				}],
				yAxes: [{
					position: 'left',
					type: 'category',
	
					// Specific to Horizontal Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}]
			},
			elements: {
				rectangle: {
					borderSkipped: 'left'
				}
			},
			tooltips: {
				callbacks: {
					title: function(tooltipItems, data) {
						// Pick first xLabel for now
						var title = '';
	
						if (tooltipItems.length > 0) {
							if (tooltipItems[0].yLabel) {
								title = tooltipItems[0].yLabel;
							} else if (data.labels.length > 0 && tooltipItems[0].index < data.labels.length) {
								title = data.labels[tooltipItems[0].index];
							}
						}
	
						return title;
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						return datasetLabel + ': ' + tooltipItem.xLabel;
					}
				}
			}
		};
	
		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
	
			// Correctly calculate the bar width accounting for stacks and the fact that not all bars are visible
			getStackCount: function() {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
	
				var stacks = [];
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var dsMeta = me.chart.getDatasetMeta(datasetIndex);
					if (dsMeta.bar && me.chart.isDatasetVisible(datasetIndex) &&
						(xScale.options.stacked === false ||
						(xScale.options.stacked === true && stacks.indexOf(dsMeta.stack) === -1) ||
						(xScale.options.stacked === undefined && (dsMeta.stack === undefined || stacks.indexOf(dsMeta.stack) === -1)))) {
						stacks.push(dsMeta.stack);
					}
				}, me);
	
				return stacks.length;
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var scaleBase = xScale.getBasePixel();
				var custom = rectangle.custom || {};
				var dataset = me.getDataset();
				var rectangleElementOptions = me.chart.options.elements.rectangle;
	
				rectangle._xScale = xScale;
				rectangle._yScale = yScale;
				rectangle._datasetIndex = me.index;
				rectangle._index = index;
	
				var ruler = me.getRuler(index); // The index argument for compatible
				rectangle._model = {
					x: reset ? scaleBase : me.calculateBarX(index, me.index),
					y: me.calculateBarY(index, me.index, ruler),
	
					// Tooltip
					label: me.chart.data.labels[index],
					datasetLabel: dataset.label,
	
					// Appearance
					horizontal: true,
					base: reset ? scaleBase : me.calculateBarBase(me.index, index),
					height: me.calculateBarHeight(ruler),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor),
					borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleElementOptions.borderSkipped,
					borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth)
				};
	
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var base = xScale.getBaseValue();
				var originalBase = base;
	
				if (xScale.options.stacked ||
					(xScale.options.stacked === undefined && meta.stack !== undefined)) {
					var chart = me.chart;
					var datasets = chart.data.datasets;
					var value = Number(datasets[datasetIndex].data[index]);
	
					for (var i = 0; i < datasetIndex; i++) {
						var currentDs = datasets[i];
						var currentDsMeta = chart.getDatasetMeta(i);
						if (currentDsMeta.bar && currentDsMeta.xAxisID === xScale.id && chart.isDatasetVisible(i) &&
							meta.stack === currentDsMeta.stack) {
							var currentVal = Number(currentDs.data[index]);
							base += value < 0 ? Math.min(currentVal, originalBase) : Math.max(currentVal, originalBase);
						}
					}
	
					return xScale.getPixelForValue(base);
				}
	
				return xScale.getBasePixel();
			},
	
			getRuler: function() {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var stackCount = me.getStackCount();
	
				var tickHeight = yScale.height / yScale.ticks.length;
				var categoryHeight = tickHeight * yScale.options.categoryPercentage;
				var categorySpacing = (tickHeight - (tickHeight * yScale.options.categoryPercentage)) / 2;
				var fullBarHeight = categoryHeight / stackCount;
	
				var barHeight = fullBarHeight * yScale.options.barPercentage;
				var barSpacing = fullBarHeight - (fullBarHeight * yScale.options.barPercentage);
	
				return {
					stackCount: stackCount,
					tickHeight: tickHeight,
					categoryHeight: categoryHeight,
					categorySpacing: categorySpacing,
					fullBarHeight: fullBarHeight,
					barHeight: barHeight,
					barSpacing: barSpacing
				};
			},
	
			calculateBarHeight: function(ruler) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				if (yScale.options.barThickness) {
					return yScale.options.barThickness;
				}
				return ruler.barHeight;
			},
	
			// Get stack index from the given dataset index accounting for stacks and the fact that not all bars are visible
			getStackIndex: function(datasetIndex) {
				var me = this;
				var meta = me.chart.getDatasetMeta(datasetIndex);
				var xScale = me.getScaleForId(meta.xAxisID);
				var dsMeta, j;
				var stacks = [meta.stack];
	
				for (j = 0; j < datasetIndex; ++j) {
					dsMeta = this.chart.getDatasetMeta(j);
					if (dsMeta.bar && this.chart.isDatasetVisible(j) &&
						(xScale.options.stacked === false ||
						(xScale.options.stacked === true && stacks.indexOf(dsMeta.stack) === -1) ||
						(xScale.options.stacked === undefined && (dsMeta.stack === undefined || stacks.indexOf(dsMeta.stack) === -1)))) {
						stacks.push(dsMeta.stack);
					}
				}
	
				return stacks.length - 1;
			},
	
			calculateBarX: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var value = Number(me.getDataset().data[index]);
	
				if (xScale.options.stacked ||
					(xScale.options.stacked === undefined && meta.stack !== undefined)) {
					var base = xScale.getBaseValue();
					var sumPos = base,
						sumNeg = base;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = me.chart.data.datasets[i];
						var dsMeta = me.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.xAxisID === xScale.id && me.chart.isDatasetVisible(i) &&
							meta.stack === dsMeta.stack) {
							var stackedVal = Number(ds.data[index]);
							if (stackedVal < 0) {
								sumNeg += stackedVal || 0;
							} else {
								sumPos += stackedVal || 0;
							}
						}
					}
	
					if (value < 0) {
						return xScale.getPixelForValue(sumNeg + value);
					}
					return xScale.getPixelForValue(sumPos + value);
				}
	
				return xScale.getPixelForValue(value);
			},
	
			calculateBarY: function(index, datasetIndex, ruler) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var stackIndex = me.getStackIndex(datasetIndex);
				var topTick = yScale.getPixelForValue(null, index, datasetIndex, me.chart.isCombo);
				topTick -= me.chart.isCombo ? (ruler.tickHeight / 2) : 0;
	
				return topTick +
					(ruler.barHeight / 2) +
					ruler.categorySpacing +
					(ruler.barHeight * stackIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * stackIndex);
			}
		});
	};


/***/ },
/* 2422 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bubble = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // bubble should probably use a linear scale by default
					position: 'bottom',
					id: 'x-axis-0' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-0'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						var dataPoint = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return datasetLabel + ': (' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ', ' + dataPoint.r + ')';
					}
				}
			}
		};
	
		Chart.controllers.bubble = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data;
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				});
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
	
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var data = dataset.data[index];
				var pointElementOptions = me.chart.options.elements.point;
				var dsIndex = me.index;
	
				helpers.extend(point, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: dsIndex,
					_index: index,
	
					// Desired view properties
					_model: {
						x: reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex, me.chart.isCombo),
						y: reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex),
						// Appearance
						radius: reset ? 0 : custom.radius ? custom.radius : me.getRadius(data),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				// Trick to reset the styles of the point
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, pointElementOptions);
	
				var model = point._model;
				model.skip = custom.skip ? custom.skip : (isNaN(model.x) || isNaN(model.y));
	
				point.pivot();
			},
	
			getRadius: function(value) {
				return value.r || this.chart.options.elements.point.radius;
			},
	
			setHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.setHoverStyle.call(me, point);
	
				// Radius
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
				model.radius = custom.hoverRadius ? custom.hoverRadius : (helpers.getValueAtIndexOrDefault(dataset.hoverRadius, index, me.chart.options.elements.point.hoverRadius)) + me.getRadius(dataset.data[index]);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, me.chart.options.elements.point);
	
				var dataVal = me.chart.data.datasets[point._datasetIndex].data[point._index];
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.radius ? custom.radius : me.getRadius(dataVal);
			}
		});
	};


/***/ },
/* 2423 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			defaults = Chart.defaults;
	
		defaults.doughnut = {
			animation: {
				// Boolean - Whether we animate the rotation of the Doughnut
				animateRotate: true,
				// Boolean - Whether we animate scaling the Doughnut from the centre
				animateScale: false
			},
			aspectRatio: 1,
			hover: {
				mode: 'single'
			},
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc && arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						// toggle visibility of index if exists
						if (meta.data[index]) {
							meta.data[index].hidden = !meta.data[index].hidden;
						}
					}
	
					chart.update();
				}
			},
	
			// The percentage of the chart that we cut out of the middle.
			cutoutPercentage: 50,
	
			// The rotation of the chart, where the first data arc begins.
			rotation: Math.PI * -0.5,
	
			// The total circumference of the chart.
			circumference: Math.PI * 2.0,
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						var dataLabel = data.labels[tooltipItem.index];
						var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
						if (helpers.isArray(dataLabel)) {
							// show value on first line of multiline label
							// need to clone because we are changing the value
							dataLabel = dataLabel.slice();
							dataLabel[0] += value;
						} else {
							dataLabel += value;
						}
	
						return dataLabel;
					}
				}
			}
		};
	
		defaults.pie = helpers.clone(defaults.doughnut);
		helpers.extend(defaults.pie, {
			cutoutPercentage: 0
		});
	
	
		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function(datasetIndex) {
				var ringIndex = 0;
	
				for (var j = 0; j < datasetIndex; ++j) {
					if (this.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}
	
				return ringIndex;
			},
	
			update: function(reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					arcOpts = opts.elements.arc,
					availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth,
					availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth,
					minSize = Math.min(availableWidth, availableHeight),
					offset = {
						x: 0,
						y: 0
					},
					meta = me.getMeta(),
					cutoutPercentage = opts.cutoutPercentage,
					circumference = opts.circumference;
	
				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (circumference < Math.PI * 2.0) {
					var startAngle = opts.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && 0 <= endAngle) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}
	
				chart.borderWidth = me.getMaxBorderWidth(meta.data);
				chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
				chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
				chart.offsetX = offset.x * chart.outerRadius;
				chart.offsetY = offset.y * chart.outerRadius;
	
				meta.total = me.calculateTotal();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
				me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					animationOpts = opts.animation,
					centerX = (chartArea.left + chartArea.right) / 2,
					centerY = (chartArea.top + chartArea.bottom) / 2,
					startAngle = opts.rotation, // non reset case handled later
					endAngle = opts.rotation, // non reset case handled later
					dataset = me.getDataset(),
					circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI)),
					innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius,
					outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius,
					valueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: centerX + chart.offsetX,
						y: centerY + chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
						label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					}
				});
	
				var model = arc._model;
				// Resets the visual styles
				this.removeHoverStyle(arc);
	
				// Set correct angles if not resetting
				if (!reset || !animationOpts.animateRotate) {
					if (index === 0) {
						model.startAngle = opts.rotation;
					} else {
						model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
					}
	
					model.endAngle = model.startAngle + model.circumference;
				}
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;
	
				helpers.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});
	
				/* if (total === 0) {
					total = NaN;
				}*/
	
				return total;
			},
	
			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (value / total);
				}
				return 0;
			},
	
			// gets the max border or hover width to properly scale pie charts
			getMaxBorderWidth: function(elements) {
				var max = 0,
					index = this.index,
					length = elements.length,
					borderWidth,
					hoverWidth;
	
				for (var i = 0; i < length; i++) {
					borderWidth = elements[i]._model ? elements[i]._model.borderWidth : 0;
					hoverWidth = elements[i]._chart ? elements[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
				return max;
			}
		});
	};


/***/ },
/* 2424 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.line = {
			showLines: true,
			spanGaps: false,
	
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
					id: 'x-axis-0'
				}],
				yAxes: [{
					type: 'linear',
					id: 'y-axis-0'
				}]
			}
		};
	
		function lineEnabled(dataset, options) {
			return helpers.getValueOrDefault(dataset.showLine, options.showLines);
		}
	
		Chart.controllers.line = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data || [];
				var options = me.chart.options;
				var lineElementOptions = options.elements.line;
				var scale = me.getScaleForId(meta.yAxisID);
				var i, ilen, custom;
				var dataset = me.getDataset();
				var showLine = lineEnabled(dataset, options);
	
				// Update Line
				if (showLine) {
					custom = line.custom || {};
	
					// Compatibility: If the properties are defined with only the old name, use those values
					if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
						dataset.lineTension = dataset.tension;
					}
	
					// Utility
					line._scale = scale;
					line._datasetIndex = me.index;
					// Data
					line._children = points;
					// Model
					line._model = {
						// Appearance
						// The default behavior of lines is to break at null values, according
						// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
						// This option gives lines the ability to span gaps
						spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						steppedLine: custom.steppedLine ? custom.steppedLine : helpers.getValueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
						cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.getValueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scale.getBasePixel()
					};
	
					line.pivot();
				}
	
				// Update Points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					me.updateElement(points[i], i, reset);
				}
	
				if (showLine && line._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
	
				// Now pivot the point for animation
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].pivot();
				}
			},
	
			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.backgroundColor) {
					backgroundColor = custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}
	
				return backgroundColor;
			},
	
			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderColor) {
					borderColor = custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}
	
				return borderColor;
			},
	
			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (!isNaN(custom.borderWidth)) {
					borderWidth = custom.borderWidth;
				} else if (!isNaN(dataset.pointBorderWidth)) {
					borderWidth = helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (!isNaN(dataset.borderWidth)) {
					borderWidth = dataset.borderWidth;
				}
	
				return borderWidth;
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var datasetIndex = me.index;
				var value = dataset.data[index];
				var yScale = me.getScaleForId(meta.yAxisID);
				var xScale = me.getScaleForId(meta.xAxisID);
				var pointOptions = me.chart.options.elements.point;
				var x, y;
				var labels = me.chart.data.labels || [];
				var includeOffset = (labels.length === 1 || dataset.data.length === 1) || me.chart.isCombo;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex, includeOffset);
				y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
				// Utility
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = datasetIndex;
				point._index = index;
	
				// Desired view properties
				point._model = {
					x: x,
					y: y,
					skip: custom.skip || isNaN(x) || isNaN(y),
					// Appearance
					radius: custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
					pointStyle: custom.pointStyle || helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
					backgroundColor: me.getPointBackgroundColor(point, index),
					borderColor: me.getPointBorderColor(point, index),
					borderWidth: me.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
					// Tooltip
					hitRadius: custom.hitRadius || helpers.getValueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
				};
			},
	
			calculatePointY: function(value, index, datasetIndex) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var sumPos = 0;
				var sumNeg = 0;
				var i, ds, dsMeta;
	
				if (yScale.options.stacked) {
					for (i = 0; i < datasetIndex; i++) {
						ds = chart.data.datasets[i];
						dsMeta = chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
							if (stackedRightValue < 0) {
								sumNeg += stackedRightValue || 0;
							} else {
								sumPos += stackedRightValue || 0;
							}
						}
					}
	
					var rightValue = Number(yScale.getRightValue(value));
					if (rightValue < 0) {
						return yScale.getPixelForValue(sumNeg + rightValue);
					}
					return yScale.getPixelForValue(sumPos + rightValue);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			updateBezierControlPoints: function() {
				var me = this;
				var meta = me.getMeta();
				var area = me.chart.chartArea;
				var points = (meta.data || []);
				var i, ilen, point, model, controlPoints;
	
				// Only consider points that are drawn in case the spanGaps option is used
				if (meta.dataset._model.spanGaps) {
					points = points.filter(function(pt) {
						return !pt._model.skip;
					});
				}
	
				function capControlPoint(pt, min, max) {
					return Math.max(Math.min(pt, max), min);
				}
	
				if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
					helpers.splineCurveMonotone(points);
				} else {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						point = points[i];
						model = point._model;
						controlPoints = helpers.splineCurve(
							helpers.previousItem(points, i)._model,
							model,
							helpers.nextItem(points, i)._model,
							meta.dataset._model.tension
						);
						model.controlPointPreviousX = controlPoints.previous.x;
						model.controlPointPreviousY = controlPoints.previous.y;
						model.controlPointNextX = controlPoints.next.x;
						model.controlPointNextY = controlPoints.next.y;
					}
				}
	
				if (me.chart.options.elements.line.capBezierPoints) {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						model = points[i]._model;
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			},
	
			draw: function(ease) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data || [];
				var easingDecimal = ease || 1;
				var i, ilen;
	
				// Transition Point Locations
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].transition(easingDecimal);
				}
	
				Chart.canvasHelpers.clipArea(me.chart.chart.ctx, me.chart.chartArea);
				// Transition and Draw the line
				if (lineEnabled(me.getDataset(), me.chart.options)) {
					meta.dataset.transition(easingDecimal).draw();
				}
				Chart.canvasHelpers.unclipArea(me.chart.chart.ctx);
	
				// Draw the points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].draw(me.chart.chartArea);
				}
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.hoverRadius || helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
	
				model.radius = custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
				model.backgroundColor = me.getPointBackgroundColor(point, index);
				model.borderColor = me.getPointBorderColor(point, index);
				model.borderWidth = me.getPointBorderWidth(point, index);
			}
		});
	};


/***/ },
/* 2425 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.polarArea = {
	
			scale: {
				type: 'radialLinear',
				lineArc: true, // so that lines are circular
				ticks: {
					beginAtZero: true
				}
			},
	
			// Boolean - Whether to animate the rotation of the chart
			animation: {
				animateRotate: true,
				animateScale: true
			},
	
			startAngle: -0.5 * Math.PI,
			aspectRatio: 1,
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						meta.data[index].hidden = !meta.data[index].hidden;
					}
	
					chart.update();
				}
			},
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
					}
				}
			}
		};
	
		Chart.controllers.polarArea = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var meta = me.getMeta();
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
				chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
				chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				meta.count = me.countVisibleElements();
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var dataset = me.getDataset();
				var opts = chart.options;
				var animationOpts = opts.animation;
				var scale = chart.scale;
				var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
				var labels = chart.data.labels;
	
				var circumference = me.calculateCircumference(dataset.data[index]);
				var centerX = scale.xCenter;
				var centerY = scale.yCenter;
	
				// If there is NaN data before us, we need to calculate the starting angle correctly.
				// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
				var visibleCount = 0;
				var meta = me.getMeta();
				for (var i = 0; i < index; ++i) {
					if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
						++visibleCount;
					}
				}
	
				// var negHalfPI = -0.5 * Math.PI;
				var datasetStartAngle = opts.startAngle;
				var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
				var startAngle = datasetStartAngle + (circumference * visibleCount);
				var endAngle = startAngle + (arc.hidden ? 0 : circumference);
	
				var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: reset ? resetRadius : distance,
						startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
						endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
						label: getValueAtIndexOrDefault(labels, index, labels[index])
					}
				});
	
				// Apply border and fill style
				me.removeHoverStyle(arc);
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;
	
				helpers.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});
	
				return count;
			},
	
			calculateCircumference: function(value) {
				var count = this.getMeta().count;
				if (count > 0 && !isNaN(value)) {
					return (2 * Math.PI) / count;
				}
				return 0;
			}
		});
	};


/***/ },
/* 2426 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.radar = {
			aspectRatio: 1,
			scale: {
				type: 'radialLinear'
			},
			elements: {
				line: {
					tension: 0 // no bezier in radar
				}
			}
		};
	
		Chart.controllers.radar = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data;
				var custom = line.custom || {};
				var dataset = me.getDataset();
				var lineElementOptions = me.chart.options.elements.line;
				var scale = me.chart.scale;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}
	
				helpers.extend(meta.dataset, {
					// Utility
					_datasetIndex: me.index,
					// Data
					_children: points,
					_loop: true,
					// Model
					_model: {
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
	
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scale.getBasePosition()
					}
				});
	
				meta.dataset.pivot();
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				}, me);
	
				// Update bezier control points
				me.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var me = this;
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var scale = me.chart.scale;
				var pointElementOptions = me.chart.options.elements.point;
				var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
	
				helpers.extend(point, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? scale.yCenter : pointPosition.y,
	
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
						radius: custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
						pointStyle: custom.pointStyle ? custom.pointStyle : helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var chartArea = this.chart.chartArea;
				var meta = this.getMeta();
	
				helpers.each(meta.data, function(point, index) {
					var model = point._model;
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index, true)._model,
						model,
						helpers.nextItem(meta.data, index, true)._model,
						model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
					model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);
	
					model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
					model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				});
			},
	
			draw: function(ease) {
				var meta = this.getMeta();
				var easingDecimal = ease || 1;
	
				// Transition Point Locations
				helpers.each(meta.data, function(point) {
					point.transition(easingDecimal);
				});
	
				// Transition and Draw the line
				meta.dataset.transition(easingDecimal).draw();
	
				// Draw the points
				helpers.each(meta.data, function(point) {
					point.draw();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
	
				model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
				var pointElementOptions = this.chart.options.elements.point;
	
				model.radius = custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.radius, index, pointElementOptions.radius);
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
			}
		});
	};


/***/ },
/* 2427 */
/***/ function(module, exports) {

	/* global window: false */
	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.animation = {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers.noop,
			onComplete: helpers.noop
		};
	
		Chart.Animation = Chart.Element.extend({
			currentStep: null, // the current animation step
			numSteps: 60, // default number of steps
			easing: '', // the easing to use for this animation
			render: null, // render function used by the animation service
	
			onAnimationProgress: null, // user specified callback to fire on each step of the animation
			onAnimationComplete: null // user specified callback to fire when the animation finishes
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			request: null,
	
			/**
			 * @function Chart.animationService.addAnimation
			 * @param chartInstance {ChartController} the chart to animate
			 * @param animationObject {IAnimation} the animation that we will animate
			 * @param duration {Number} length of animation in ms
			 * @param lazy {Boolean} if true, the chart is not marked as animating to enable more responsive interactions
			 */
			addAnimation: function(chartInstance, animationObject, duration, lazy) {
				var me = this;
	
				if (!lazy) {
					chartInstance.animating = true;
				}
	
				for (var index = 0; index < me.animations.length; ++index) {
					if (me.animations[index].chartInstance === chartInstance) {
						// replacing an in progress animation
						me.animations[index].animationObject = animationObject;
						return;
					}
				}
	
				me.animations.push({
					chartInstance: chartInstance,
					animationObject: animationObject
				});
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (me.animations.length === 1) {
					me.requestAnimationFrame();
				}
			},
			// Cancel the animation for a given chart instance
			cancelAnimation: function(chartInstance) {
				var index = helpers.findIndex(this.animations, function(animationWrapper) {
					return animationWrapper.chartInstance === chartInstance;
				});
	
				if (index !== -1) {
					this.animations.splice(index, 1);
					chartInstance.animating = false;
				}
			},
			requestAnimationFrame: function() {
				var me = this;
				if (me.request === null) {
					// Skip animation frame requests until the active one is executed.
					// This can happen when processing mouse events, e.g. 'mousemove'
					// and 'mouseout' events will trigger multiple renders.
					me.request = helpers.requestAnimFrame.call(window, function() {
						me.request = null;
						me.startDigest();
					});
				}
			},
			startDigest: function() {
				var me = this;
	
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if (me.dropFrames > 1) {
					framesToDrop = Math.floor(me.dropFrames);
					me.dropFrames = me.dropFrames % 1;
				}
	
				var i = 0;
				while (i < me.animations.length) {
					if (me.animations[i].animationObject.currentStep === null) {
						me.animations[i].animationObject.currentStep = 0;
					}
	
					me.animations[i].animationObject.currentStep += 1 + framesToDrop;
	
					if (me.animations[i].animationObject.currentStep > me.animations[i].animationObject.numSteps) {
						me.animations[i].animationObject.currentStep = me.animations[i].animationObject.numSteps;
					}
	
					me.animations[i].animationObject.render(me.animations[i].chartInstance, me.animations[i].animationObject);
					if (me.animations[i].animationObject.onAnimationProgress && me.animations[i].animationObject.onAnimationProgress.call) {
						me.animations[i].animationObject.onAnimationProgress.call(me.animations[i].chartInstance, me.animations[i]);
					}
	
					if (me.animations[i].animationObject.currentStep === me.animations[i].animationObject.numSteps) {
						if (me.animations[i].animationObject.onAnimationComplete && me.animations[i].animationObject.onAnimationComplete.call) {
							me.animations[i].animationObject.onAnimationComplete.call(me.animations[i].chartInstance, me.animations[i]);
						}
	
						// executed the last frame. Remove the animation.
						me.animations[i].chartInstance.animating = false;
	
						me.animations.splice(i, 1);
					} else {
						++i;
					}
				}
	
				var endTime = Date.now();
				var dropFrames = (endTime - startTime) / me.frameDuration;
	
				me.dropFrames += dropFrames;
	
				// Do we have more stuff to animate?
				if (me.animations.length > 0) {
					me.requestAnimationFrame();
				}
			}
		};
	};


/***/ },
/* 2428 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		// Global Chart canvas helpers object for drawing items to canvas
		var helpers = Chart.canvasHelpers = {};
	
		helpers.drawPoint = function(ctx, pointStyle, radius, x, y) {
			var type, edgeLength, xOffset, yOffset, height, size;
	
			if (typeof pointStyle === 'object') {
				type = pointStyle.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(pointStyle, x - pointStyle.width / 2, y - pointStyle.height / 2);
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			switch (pointStyle) {
			// Default includes circle
			default:
				ctx.beginPath();
				ctx.arc(x, y, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'triangle':
				ctx.beginPath();
				edgeLength = 3 * radius / Math.sqrt(3);
				height = edgeLength * Math.sqrt(3) / 2;
				ctx.moveTo(x - edgeLength / 2, y + height / 3);
				ctx.lineTo(x + edgeLength / 2, y + height / 3);
				ctx.lineTo(x, y - 2 * height / 3);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rect':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
				ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
				break;
			case 'rectRounded':
				var offset = radius / Math.SQRT2;
				var leftX = x - offset;
				var topY = y - offset;
				var sideSize = Math.SQRT2 * radius;
				Chart.helpers.drawRoundedRectangle(ctx, leftX, topY, sideSize, sideSize, radius / 2);
				ctx.fill();
				break;
			case 'rectRot':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.moveTo(x - size, y);
				ctx.lineTo(x, y + size);
				ctx.lineTo(x + size, y);
				ctx.lineTo(x, y - size);
				ctx.closePath();
				ctx.fill();
				break;
			case 'cross':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'crossRot':
				ctx.beginPath();
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'star':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'line':
				ctx.beginPath();
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'dash':
				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			}
	
			ctx.stroke();
		};
	
		helpers.clipArea = function(ctx, clipArea) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(clipArea.left, clipArea.top, clipArea.right - clipArea.left, clipArea.bottom - clipArea.top);
			ctx.clip();
		};
	
		helpers.unclipArea = function(ctx) {
			ctx.restore();
		};
	
	};


/***/ },
/* 2429 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var plugins = Chart.plugins;
		var platform = Chart.platform;
	
		// Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		// Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};
	
		/**
		 * Initializes the given config with global and chart default values.
		 */
		function initConfig(config) {
			config = config || {};
	
			// Do NOT use configMerge() for the data object because this method merges arrays
			// and so would change references to labels and datasets, preventing data updates.
			var data = config.data = config.data || {};
			data.datasets = data.datasets || [];
			data.labels = data.labels || [];
	
			config.options = helpers.configMerge(
				Chart.defaults.global,
				Chart.defaults[config.type],
				config.options || {});
	
			return config;
		}
	
		/**
		 * Updates the config of the chart
		 * @param chart {Chart.Controller} chart to update the options for
		 */
		function updateConfig(chart) {
			var newOptions = chart.options;
	
			// Update Scale(s) with options
			if (newOptions.scale) {
				chart.scale.options = newOptions.scale;
			} else if (newOptions.scales) {
				newOptions.scales.xAxes.concat(newOptions.scales.yAxes).forEach(function(scaleOptions) {
					chart.scales[scaleOptions.id].options = scaleOptions;
				});
			}
	
			// Tooltip
			chart.tooltip._options = newOptions.tooltips;
		}
	
		/**
		 * @class Chart.Controller
		 * The main controller of a chart.
		 */
		Chart.Controller = function(item, config, instance) {
			var me = this;
	
			config = initConfig(config);
	
			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;
	
			instance.ctx = context;
			instance.canvas = canvas;
			instance.config = config;
			instance.width = width;
			instance.height = height;
			instance.aspectRatio = height? width / height : null;
	
			me.id = helpers.uid();
			me.chart = instance;
			me.config = config;
			me.options = config.options;
			me._bufferedRender = false;
	
			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;
	
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				}
			});
	
			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return me;
			}
	
			me.initialize();
			me.update();
	
			return me;
		};
	
		helpers.extend(Chart.Controller.prototype, /** @lends Chart.Controller.prototype */ {
			initialize: function() {
				var me = this;
	
				// Before init plugin notification
				plugins.notify(me, 'beforeInit');
	
				helpers.retinaScale(me.chart);
	
				me.bindEvents();
	
				if (me.options.responsive) {
					// Initial resize before chart draws (must be silent to preserve initial animations).
					me.resize(true);
				}
	
				// Make sure scales have IDs and are built before we build any controllers.
				me.ensureScalesHaveIDs();
				me.buildScales();
				me.initToolTip();
	
				// After init plugin notification
				plugins.notify(me, 'afterInit');
	
				return me;
			},
	
			clear: function() {
				helpers.clear(this.chart);
				return this;
			},
	
			stop: function() {
				// Stops any current animation loop occurring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
	
			resize: function(silent) {
				var me = this;
				var chart = me.chart;
				var options = me.options;
				var canvas = chart.canvas;
				var aspectRatio = (options.maintainAspectRatio && chart.aspectRatio) || null;
	
				// the canvas render width and height will be casted to integers so make sure that
				// the canvas display style uses the same integer values to avoid blurring effect.
				var newWidth = Math.floor(helpers.getMaximumWidth(canvas));
				var newHeight = Math.floor(aspectRatio? newWidth / aspectRatio : helpers.getMaximumHeight(canvas));
	
				if (chart.width === newWidth && chart.height === newHeight) {
					return;
				}
	
				canvas.width = chart.width = newWidth;
				canvas.height = chart.height = newHeight;
				canvas.style.width = newWidth + 'px';
				canvas.style.height = newHeight + 'px';
	
				helpers.retinaScale(chart);
	
				if (!silent) {
					// Notify any plugins about the resize
					var newSize = {width: newWidth, height: newHeight};
					plugins.notify(me, 'resize', [newSize]);
	
					// Notify of resize
					if (me.options.onResize) {
						me.options.onResize(me, newSize);
					}
	
					me.stop();
					me.update(me.options.responsiveAnimationDuration);
				}
			},
	
			ensureScalesHaveIDs: function() {
				var options = this.options;
				var scalesOptions = options.scales || {};
				var scaleOptions = options.scale;
	
				helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
					xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
				});
	
				helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
					yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
				});
	
				if (scaleOptions) {
					scaleOptions.id = scaleOptions.id || 'scale';
				}
			},
	
			/**
			 * Builds a map of scale ID to scale object for future lookup.
			 */
			buildScales: function() {
				var me = this;
				var options = me.options;
				var scales = me.scales = {};
				var items = [];
	
				if (options.scales) {
					items = items.concat(
						(options.scales.xAxes || []).map(function(xAxisOptions) {
							return {options: xAxisOptions, dtype: 'category'};
						}),
						(options.scales.yAxes || []).map(function(yAxisOptions) {
							return {options: yAxisOptions, dtype: 'linear'};
						})
					);
				}
	
				if (options.scale) {
					items.push({options: options.scale, dtype: 'radialLinear', isDefault: true});
				}
	
				helpers.each(items, function(item) {
					var scaleOptions = item.options;
					var scaleType = helpers.getValueOrDefault(scaleOptions.type, item.dtype);
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
	
					var scale = new scaleClass({
						id: scaleOptions.id,
						options: scaleOptions,
						ctx: me.chart.ctx,
						chart: me
					});
	
					scales[scale.id] = scale;
	
					// TODO(SB): I think we should be able to remove this custom case (options.scale)
					// and consider it as a regular scale part of the "scales"" map only! This would
					// make the logic easier and remove some useless? custom code.
					if (item.isDefault) {
						me.scale = scale;
					}
				});
	
				Chart.scaleService.addScalesToLayout(this);
			},
	
			buildOrUpdateControllers: function() {
				var me = this;
				var types = [];
				var newControllers = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					var meta = me.getDatasetMeta(datasetIndex);
					if (!meta.type) {
						meta.type = dataset.type || me.config.type;
					}
	
					types.push(meta.type);
	
					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
					} else {
						meta.controller = new Chart.controllers[meta.type](me, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, me);
	
				if (types.length > 1) {
					for (var i = 1; i < types.length; i++) {
						if (types[i] !== types[i - 1]) {
							me.isCombo = true;
							break;
						}
					}
				}
	
				return newControllers;
			},
	
			/**
			 * Reset the elements of all datasets
			 * @private
			 */
			resetElements: function() {
				var me = this;
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.reset();
				}, me);
			},
	
			/**
			* Resets the chart back to it's state before the initial animation
			*/
			reset: function() {
				this.resetElements();
				this.tooltip.initialize();
			},
	
			update: function(animationDuration, lazy) {
				var me = this;
	
				updateConfig(me);
	
				if (plugins.notify(me, 'beforeUpdate') === false) {
					return;
				}
	
				// In case the entire data object changed
				me.tooltip._data = me.data;
	
				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = me.buildOrUpdateControllers();
	
				// Make sure all dataset controllers have correct meta data counts
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, me);
	
				me.updateLayout();
	
				// Can only reset the new controllers after the scales have been updated
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
	
				me.updateDatasets();
	
				// Do this before render so that any plugins that need final scale updates can use it
				plugins.notify(me, 'afterUpdate');
	
				if (me._bufferedRender) {
					me._bufferedRequest = {
						lazy: lazy,
						duration: animationDuration
					};
				} else {
					me.render(animationDuration, lazy);
				}
			},
	
			/**
			 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
			 * hook, in which case, plugins will not be called on `afterLayout`.
			 * @private
			 */
			updateLayout: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeLayout') === false) {
					return;
				}
	
				Chart.layoutService.update(this, this.chart.width, this.chart.height);
	
				/**
				 * Provided for backward compatibility, use `afterLayout` instead.
				 * @method IPlugin#afterScaleUpdate
				 * @deprecated since version 2.5.0
				 * @todo remove at version 3
				 */
				plugins.notify(me, 'afterScaleUpdate');
				plugins.notify(me, 'afterLayout');
			},
	
			/**
			 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
			 * @private
			 */
			updateDatasets: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
					return;
				}
	
				for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.getDatasetMeta(i).controller.update();
				}
	
				plugins.notify(me, 'afterDatasetsUpdate');
			},
	
			render: function(duration, lazy) {
				var me = this;
	
				if (plugins.notify(me, 'beforeRender') === false) {
					return;
				}
	
				var animationOptions = me.options.animation;
				var onComplete = function() {
					plugins.notify(me, 'afterRender');
					var callback = animationOptions && animationOptions.onComplete;
					if (callback && callback.call) {
						callback.call(me);
					}
				};
	
				if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
					var animation = new Chart.Animation();
					animation.numSteps = (duration || animationOptions.duration) / 16.66; // 60 fps
					animation.easing = animationOptions.easing;
	
					// render function
					animation.render = function(chartInstance, animationObject) {
						var easingFunction = helpers.easingEffects[animationObject.easing];
						var stepDecimal = animationObject.currentStep / animationObject.numSteps;
						var easeDecimal = easingFunction(stepDecimal);
	
						chartInstance.draw(easeDecimal, stepDecimal, animationObject.currentStep);
					};
	
					// user events
					animation.onAnimationProgress = animationOptions.onProgress;
					animation.onAnimationComplete = onComplete;
	
					Chart.animationService.addAnimation(me, animation, duration, lazy);
				} else {
					me.draw();
					onComplete();
				}
	
				return me;
			},
	
			draw: function(easingValue) {
				var me = this;
	
				me.clear();
	
				if (easingValue === undefined || easingValue === null) {
					easingValue = 1;
				}
	
				if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw all the scales
				helpers.each(me.boxes, function(box) {
					box.draw(me.chartArea);
				}, me);
	
				if (me.scale) {
					me.scale.draw();
				}
	
				me.drawDatasets(easingValue);
	
				// Finally draw the tooltip
				me.tooltip.transition(easingValue).draw();
	
				plugins.notify(me, 'afterDraw', [easingValue]);
			},
	
			/**
			 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
			 * @private
			 */
			drawDatasets: function(easingValue) {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw each dataset via its respective controller (reversed to support proper line stacking)
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						me.getDatasetMeta(datasetIndex).controller.draw(easingValue);
					}
				}, me, true);
	
				plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
			},
	
			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				return Chart.Interaction.modes.single(this, e);
			},
	
			getElementsAtEvent: function(e) {
				return Chart.Interaction.modes.label(this, e, {intersect: true});
			},
	
			getElementsAtXAxis: function(e) {
				return Chart.Interaction.modes['x-axis'](this, e, {intersect: true});
			},
	
			getElementsAtEventForMode: function(e, mode, options) {
				var method = Chart.Interaction.modes[mode];
				if (typeof method === 'function') {
					return method(this, e, options);
				}
	
				return [];
			},
	
			getDatasetAtEvent: function(e) {
				return Chart.Interaction.modes.dataset(this, e, {intersect: true});
			},
	
			getDatasetMeta: function(datasetIndex) {
				var me = this;
				var dataset = me.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}
	
				var meta = dataset._meta[me.id];
				if (!meta) {
					meta = dataset._meta[me.id] = {
						type: null,
						data: [],
						dataset: null,
						controller: null,
						hidden: null,			// See isDatasetVisible() comment
						xAxisID: null,
						yAxisID: null
					};
				}
	
				return meta;
			},
	
			getVisibleDatasetCount: function() {
				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i<ilen; ++i) {
					if (this.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},
	
			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);
	
				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean'? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},
	
			generateLegend: function() {
				return this.options.legendCallback(this);
			},
	
			destroy: function() {
				var me = this;
				var canvas = me.chart.canvas;
				var meta, i, ilen;
	
				me.stop();
	
				// dataset controllers need to cleanup associated data
				for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					meta = me.getDatasetMeta(i);
					if (meta.controller) {
						meta.controller.destroy();
						meta.controller = null;
					}
				}
	
				if (canvas) {
					me.unbindEvents();
					helpers.clear(me.chart);
					platform.releaseContext(me.chart.ctx);
					me.chart.canvas = null;
					me.chart.ctx = null;
				}
	
				plugins.notify(me, 'destroy');
	
				delete Chart.instances[me.id];
			},
	
			toBase64Image: function() {
				return this.chart.canvas.toDataURL.apply(this.chart.canvas, arguments);
			},
	
			initToolTip: function() {
				var me = this;
				me.tooltip = new Chart.Tooltip({
					_chart: me.chart,
					_chartInstance: me,
					_data: me.data,
					_options: me.options.tooltips
				}, me);
				me.tooltip.initialize();
			},
	
			/**
			 * @private
			 */
			bindEvents: function() {
				var me = this;
				var listeners = me._listeners = {};
				var listener = function() {
					me.eventHandler.apply(me, arguments);
				};
	
				helpers.each(me.options.events, function(type) {
					platform.addEventListener(me, type, listener);
					listeners[type] = listener;
				});
	
				// Responsiveness is currently based on the use of an iframe, however this method causes
				// performance issues and could be troublesome when used with ad blockers. So make sure
				// that the user is still able to create a chart without iframe when responsive is false.
				// See https://github.com/chartjs/Chart.js/issues/2210
				if (me.options.responsive) {
					listener = function() {
						me.resize();
					};
	
					platform.addEventListener(me, 'resize', listener);
					listeners.resize = listener;
				}
			},
	
			/**
			 * @private
			 */
			unbindEvents: function() {
				var me = this;
				var listeners = me._listeners;
				if (!listeners) {
					return;
				}
	
				delete me._listeners;
				helpers.each(listeners, function(listener, type) {
					platform.removeEventListener(me, type, listener);
				});
			},
	
			updateHoverStyle: function(elements, mode, enabled) {
				var method = enabled? 'setHoverStyle' : 'removeHoverStyle';
				var element, i, ilen;
	
				for (i=0, ilen=elements.length; i<ilen; ++i) {
					element = elements[i];
					if (element) {
						this.getDatasetMeta(element._datasetIndex).controller[method](element);
					}
				}
			},
	
			/**
			 * @private
			 */
			eventHandler: function(e) {
				var me = this;
				var tooltip = me.tooltip;
	
				if (plugins.notify(me, 'beforeEvent', [e]) === false) {
					return;
				}
	
				// Buffer any update calls so that renders do not occur
				me._bufferedRender = true;
				me._bufferedRequest = null;
	
				var changed = me.handleEvent(e);
				changed |= tooltip && tooltip.handleEvent(e);
	
				plugins.notify(me, 'afterEvent', [e]);
	
				var bufferedRequest = me._bufferedRequest;
				if (bufferedRequest) {
					// If we have an update that was triggered, we need to do a normal render
					me.render(bufferedRequest.duration, bufferedRequest.lazy);
				} else if (changed && !me.animating) {
					// If entering, leaving, or changing elements, animate the change via pivot
					me.stop();
	
					// We only need to render at this point. Updating will cause scales to be
					// recomputed generating flicker & using more memory than necessary.
					me.render(me.options.hover.animationDuration, true);
				}
	
				me._bufferedRender = false;
				me._bufferedRequest = null;
	
				return me;
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event the event to handle
			 * @return {Boolean} true if the chart needs to re-render
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me.options || {};
				var hoverOptions = options.hover;
				var changed = false;
	
				me.lastActive = me.lastActive || [];
	
				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					me.active = [];
				} else {
					me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
				}
	
				// On Hover hook
				if (hoverOptions.onHover) {
					// Need to call with native event here to not break backwards compatibility
					hoverOptions.onHover.call(me, e.native, me.active);
				}
	
				if (e.type === 'mouseup' || e.type === 'click') {
					if (options.onClick) {
						// Use e.native here for backwards compatibility
						options.onClick.call(me, e.native, me.active);
					}
				}
	
				// Remove styling for last active (even if it may still be active)
				if (me.lastActive.length) {
					me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
				}
	
				// Built in hover styling
				if (me.active.length && hoverOptions.mode) {
					me.updateHoverStyle(me.active, hoverOptions.mode, true);
				}
	
				changed = !helpers.arrayEquals(me.active, me.lastActive);
	
				// Remember Last Actives
				me.lastActive = me.active;
	
				return changed;
			}
		});
	};


/***/ },
/* 2430 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
		/**
		 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
		 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
		 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
		 */
		function listenArrayEvents(array, listener) {
			if (array._chartjs) {
				array._chartjs.listeners.push(listener);
				return;
			}
	
			Object.defineProperty(array, '_chartjs', {
				configurable: true,
				enumerable: false,
				value: {
					listeners: [listener]
				}
			});
	
			arrayEvents.forEach(function(key) {
				var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
				var base = array[key];
	
				Object.defineProperty(array, key, {
					configurable: true,
					enumerable: false,
					value: function() {
						var args = Array.prototype.slice.call(arguments);
						var res = base.apply(this, args);
	
						helpers.each(array._chartjs.listeners, function(object) {
							if (typeof object[method] === 'function') {
								object[method].apply(object, args);
							}
						});
	
						return res;
					}
				});
			});
		}
	
		/**
		 * Removes the given array event listener and cleanup extra attached properties (such as
		 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
		 */
		function unlistenArrayEvents(array, listener) {
			var stub = array._chartjs;
			if (!stub) {
				return;
			}
	
			var listeners = stub.listeners;
			var index = listeners.indexOf(listener);
			if (index !== -1) {
				listeners.splice(index, 1);
			}
	
			if (listeners.length > 0) {
				return;
			}
	
			arrayEvents.forEach(function(key) {
				delete array[key];
			});
	
			delete array._chartjs;
		}
	
		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize(chart, datasetIndex);
		};
	
		helpers.extend(Chart.DatasetController.prototype, {
	
			/**
			 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
			 * @type {Chart.core.element}
			 */
			datasetElementType: null,
	
			/**
			 * Element type used to generate a meta data (e.g. Chart.element.Point).
			 * @type {Chart.core.element}
			 */
			dataElementType: null,
	
			initialize: function(chart, datasetIndex) {
				var me = this;
				me.chart = chart;
				me.index = datasetIndex;
				me.linkScales();
				me.addElements();
			},
	
			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},
	
			linkScales: function() {
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				if (meta.xAxisID === null) {
					meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null) {
					meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
				}
			},
	
			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},
	
			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},
	
			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},
	
			reset: function() {
				this.update(true);
			},
	
			/**
			 * @private
			 */
			destroy: function() {
				if (this._data) {
					unlistenArrayEvents(this._data, this);
				}
			},
	
			createMetaDataset: function() {
				var me = this;
				var type = me.datasetElementType;
				return type && new type({
					_chart: me.chart.chart,
					_datasetIndex: me.index
				});
			},
	
			createMetaData: function(index) {
				var me = this;
				var type = me.dataElementType;
				return type && new type({
					_chart: me.chart.chart,
					_datasetIndex: me.index,
					_index: index
				});
			},
	
			addElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data || [];
				var metaData = meta.data;
				var i, ilen;
	
				for (i=0, ilen=data.length; i<ilen; ++i) {
					metaData[i] = metaData[i] || me.createMetaData(i);
				}
	
				meta.dataset = meta.dataset || me.createMetaDataset();
			},
	
			addElementAndReset: function(index) {
				var element = this.createMetaData(index);
				this.getMeta().data.splice(index, 0, element);
				this.updateElement(element, index, true);
			},
	
			buildOrUpdateElements: function() {
				var me = this;
				var dataset = me.getDataset();
				var data = dataset.data || (dataset.data = []);
	
				// In order to correctly handle data addition/deletion animation (an thus simulate
				// real-time charts), we need to monitor these data modifications and synchronize
				// the internal meta data accordingly.
				if (me._data !== data) {
					if (me._data) {
						// This case happens when the user replaced the data array instance.
						unlistenArrayEvents(me._data, me);
					}
	
					listenArrayEvents(data, me);
					me._data = data;
				}
	
				// Re-sync meta data in case the user replaced the data array or if we missed
				// any updates and so make sure that we handle number of datapoints changing.
				me.resyncElements();
			},
	
			update: helpers.noop,
	
			draw: function(ease) {
				var easingDecimal = ease || 1;
				var i, len;
				var metaData = this.getMeta().data;
				for (i = 0, len = metaData.length; i < len; ++i) {
					metaData[i].transition(easingDecimal).draw();
				}
			},
	
			removeHoverStyle: function(element, elementOpts) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					model = element._model;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
			},
	
			setHoverStyle: function(element) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					getHoverColor = helpers.getHoverColor,
					model = element._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			/**
			 * @private
			 */
			resyncElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data;
				var numMeta = meta.data.length;
				var numData = data.length;
	
				if (numData < numMeta) {
					meta.data.splice(numData, numMeta - numData);
				} else if (numData > numMeta) {
					me.insertElements(numMeta, numData - numMeta);
				}
			},
	
			/**
			 * @private
			 */
			insertElements: function(start, count) {
				for (var i=0; i<count; ++i) {
					this.addElementAndReset(start + i);
				}
			},
	
			/**
			 * @private
			 */
			onDataPush: function() {
				this.insertElements(this.getDataset().data.length-1, arguments.length);
			},
	
			/**
			 * @private
			 */
			onDataPop: function() {
				this.getMeta().data.pop();
			},
	
			/**
			 * @private
			 */
			onDataShift: function() {
				this.getMeta().data.shift();
			},
	
			/**
			 * @private
			 */
			onDataSplice: function(start, count) {
				this.getMeta().data.splice(start, count);
				this.insertElements(start, arguments.length - 2);
			},
	
			/**
			 * @private
			 */
			onDataUnshift: function() {
				this.insertElements(0, arguments.length);
			}
		});
	
		Chart.DatasetController.extend = helpers.inherits;
	};


/***/ },
/* 2431 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.elements = {};
	
		Chart.Element = function(configuration) {
			helpers.extend(this, configuration);
			this.initialize.apply(this, arguments);
		};
	
		helpers.extend(Chart.Element.prototype, {
	
			initialize: function() {
				this.hidden = false;
			},
	
			pivot: function() {
				var me = this;
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
				me._start = helpers.clone(me._view);
				return me;
			},
	
			transition: function(ease) {
				var me = this;
	
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
	
				// No animation -> No Transition
				if (ease === 1) {
					me._view = me._model;
					me._start = null;
					return me;
				}
	
				if (!me._start) {
					me.pivot();
				}
	
				helpers.each(me._model, function(value, key) {
	
					if (key[0] === '_') {
						// Only non-underscored properties
					// Init if doesn't exist
					} else if (!me._view.hasOwnProperty(key)) {
						if (typeof value === 'number' && !isNaN(me._view[key])) {
							me._view[key] = value * ease;
						} else {
							me._view[key] = value;
						}
					// No unnecessary computations
					} else if (value === me._view[key]) {
						// It's the same! Woohoo!
					// Color transitions if possible
					} else if (typeof value === 'string') {
						try {
							var color = helpers.color(me._model[key]).mix(helpers.color(me._start[key]), ease);
							me._view[key] = color.rgbString();
						} catch (err) {
							me._view[key] = value;
						}
					// Number transitions
					} else if (typeof value === 'number') {
						var startVal = me._start[key] !== undefined && isNaN(me._start[key]) === false ? me._start[key] : 0;
						me._view[key] = ((me._model[key] - startVal) * ease) + startVal;
					// Everything else
					} else {
						me._view[key] = value;
					}
				}, me);
	
				return me;
			},
	
			tooltipPosition: function() {
				return {
					x: this._model.x,
					y: this._model.y
				};
			},
	
			hasValue: function() {
				return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
			}
		});
	
		Chart.Element.extend = helpers.inherits;
	
	};


/***/ },
/* 2432 */
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	/* global document: false */
	'use strict';
	
	var color = __webpack_require__(2456);
	
	module.exports = function(Chart) {
		// Global Chart helpers object for utility methods and classes
		var helpers = Chart.helpers = {};
	
		// -- Basic js utility methods
		helpers.each = function(loopable, callback, self, reverse) {
			// Check to see if null or undefined firstly.
			var i, len;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						callback.call(self, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						callback.call(self, loopable[i], i);
					}
				}
			} else if (typeof loopable === 'object') {
				var keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					callback.call(self, loopable[keys[i]], keys[i]);
				}
			}
		};
		helpers.clone = function(obj) {
			var objClone = {};
			helpers.each(obj, function(value, key) {
				if (helpers.isArray(value)) {
					objClone[key] = value.slice(0);
				} else if (typeof value === 'object' && value !== null) {
					objClone[key] = helpers.clone(value);
				} else {
					objClone[key] = value;
				}
			});
			return objClone;
		};
		helpers.extend = function(base) {
			var setFn = function(value, key) {
				base[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; i++) {
				helpers.each(arguments[i], setFn);
			}
			return base;
		};
		// Need a special merge function to chart configs since they are now grouped
		helpers.configMerge = function(_base) {
			var base = helpers.clone(_base);
			helpers.each(Array.prototype.slice.call(arguments, 1), function(extension) {
				helpers.each(extension, function(value, key) {
					var baseHasProperty = base.hasOwnProperty(key);
					var baseVal = baseHasProperty ? base[key] : {};
	
					if (key === 'scales') {
						// Scale config merging is complex. Add our own function here for that
						base[key] = helpers.scaleMerge(baseVal, value);
					} else if (key === 'scale') {
						// Used in polar area & radar charts since there is only one scale
						base[key] = helpers.configMerge(baseVal, Chart.scaleService.getScaleDefaults(value.type), value);
					} else if (baseHasProperty
							&& typeof baseVal === 'object'
							&& !helpers.isArray(baseVal)
							&& baseVal !== null
							&& typeof value === 'object'
							&& !helpers.isArray(value)) {
						// If we are overwriting an object with an object, do a merge of the properties.
						base[key] = helpers.configMerge(baseVal, value);
					} else {
						// can just overwrite the value in this case
						base[key] = value;
					}
				});
			});
	
			return base;
		};
		helpers.scaleMerge = function(_base, extension) {
			var base = helpers.clone(_base);
	
			helpers.each(extension, function(value, key) {
				if (key === 'xAxes' || key === 'yAxes') {
					// These properties are arrays of items
					if (base.hasOwnProperty(key)) {
						helpers.each(value, function(valueObj, index) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							var axisDefaults = Chart.scaleService.getScaleDefaults(axisType);
							if (index >= base[key].length || !base[key][index].type) {
								base[key].push(helpers.configMerge(axisDefaults, valueObj));
							} else if (valueObj.type && valueObj.type !== base[key][index].type) {
								// Type changed. Bring in the new defaults before we bring in valueObj so that valueObj can override the correct scale defaults
								base[key][index] = helpers.configMerge(base[key][index], axisDefaults, valueObj);
							} else {
								// Type is the same
								base[key][index] = helpers.configMerge(base[key][index], valueObj);
							}
						});
					} else {
						base[key] = [];
						helpers.each(value, function(valueObj) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							base[key].push(helpers.configMerge(Chart.scaleService.getScaleDefaults(axisType), valueObj));
						});
					}
				} else if (base.hasOwnProperty(key) && typeof base[key] === 'object' && base[key] !== null && typeof value === 'object') {
					// If we are overwriting an object with an object, do a merge of the properties.
					base[key] = helpers.configMerge(base[key], value);
	
				} else {
					// can just overwrite the value in this case
					base[key] = value;
				}
			});
	
			return base;
		};
		helpers.getValueAtIndexOrDefault = function(value, index, defaultValue) {
			if (value === undefined || value === null) {
				return defaultValue;
			}
	
			if (helpers.isArray(value)) {
				return index < value.length ? value[index] : defaultValue;
			}
	
			return value;
		};
		helpers.getValueOrDefault = function(value, defaultValue) {
			return value === undefined ? defaultValue : value;
		};
		helpers.indexOf = Array.prototype.indexOf?
			function(array, item) {
				return array.indexOf(item);
			}:
			function(array, item) {
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (array[i] === item) {
						return i;
					}
				}
				return -1;
			};
		helpers.where = function(collection, filterCallback) {
			if (helpers.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers.findIndex = Array.prototype.findIndex?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.inherits = function(extensions) {
			// Basic javascript inheritance based on the model created in Backbone.js
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
	
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
	
			return ChartElement;
		};
		helpers.noop = function() {};
		helpers.uid = (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}());
		// -- Math methods
		helpers.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
		};
		helpers.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers.sign = Math.sign?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers.log10 = Math.log10?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				return Math.log(x) / Math.LN10;
			};
		helpers.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x,
				distanceFromYCenter = anglePoint.y - centrePoint.y,
				radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
		helpers.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint,
				current = middlePoint,
				next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers.EPSILON = Number.EPSILON || 1e-14;
		helpers.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers.niceNum = function(range, round) {
			var exponent = Math.floor(helpers.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Easing functions adapted from Robert Penner's easing equations
		// http://www.robertpenner.com/easing/
		var easingEffects = helpers.easingEffects = {
			linear: function(t) {
				return t;
			},
			easeInQuad: function(t) {
				return t * t;
			},
			easeOutQuad: function(t) {
				return -1 * t * (t - 2);
			},
			easeInOutQuad: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t;
				}
				return -1 / 2 * ((--t) * (t - 2) - 1);
			},
			easeInCubic: function(t) {
				return t * t * t;
			},
			easeOutCubic: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t + 1);
			},
			easeInOutCubic: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t + 2);
			},
			easeInQuart: function(t) {
				return t * t * t * t;
			},
			easeOutQuart: function(t) {
				return -1 * ((t = t / 1 - 1) * t * t * t - 1);
			},
			easeInOutQuart: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t;
				}
				return -1 / 2 * ((t -= 2) * t * t * t - 2);
			},
			easeInQuint: function(t) {
				return 1 * (t /= 1) * t * t * t * t;
			},
			easeOutQuint: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t * t * t + 1);
			},
			easeInOutQuint: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t * t * t + 2);
			},
			easeInSine: function(t) {
				return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1;
			},
			easeOutSine: function(t) {
				return 1 * Math.sin(t / 1 * (Math.PI / 2));
			},
			easeInOutSine: function(t) {
				return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1);
			},
			easeInExpo: function(t) {
				return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1));
			},
			easeOutExpo: function(t) {
				return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1);
			},
			easeInOutExpo: function(t) {
				if (t === 0) {
					return 0;
				}
				if (t === 1) {
					return 1;
				}
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * Math.pow(2, 10 * (t - 1));
				}
				return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
			},
			easeInCirc: function(t) {
				if (t >= 1) {
					return t;
				}
				return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1);
			},
			easeOutCirc: function(t) {
				return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t);
			},
			easeInOutCirc: function(t) {
				if ((t /= 1 / 2) < 1) {
					return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
				}
				return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
			},
			easeInElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
			},
			easeOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1;
			},
			easeInOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1 / 2) === 2) {
					return 1;
				}
				if (!p) {
					p = 1 * (0.3 * 1.5);
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				if (t < 1) {
					return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
				}
				return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
			},
			easeInBack: function(t) {
				var s = 1.70158;
				return 1 * (t /= 1) * t * ((s + 1) * t - s);
			},
			easeOutBack: function(t) {
				var s = 1.70158;
				return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1);
			},
			easeInOutBack: function(t) {
				var s = 1.70158;
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s));
				}
				return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
			},
			easeInBounce: function(t) {
				return 1 - easingEffects.easeOutBounce(1 - t);
			},
			easeOutBounce: function(t) {
				if ((t /= 1) < (1 / 2.75)) {
					return 1 * (7.5625 * t * t);
				} else if (t < (2 / 2.75)) {
					return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75);
				} else if (t < (2.5 / 2.75)) {
					return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375);
				}
				return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375);
			},
			easeInOutBounce: function(t) {
				if (t < 1 / 2) {
					return easingEffects.easeInBounce(t * 2) * 0.5;
				}
				return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5;
			}
		};
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers.requestAnimFrame = (function() {
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt,
				canvas = evt.currentTarget || evt.srcElement,
				boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
		helpers.addEvent = function(node, eventType, method) {
			if (node.addEventListener) {
				node.addEventListener(eventType, method);
			} else if (node.attachEvent) {
				node.attachEvent('on' + eventType, method);
			} else {
				node['on' + eventType] = method;
			}
		};
		helpers.removeEvent = function(node, eventType, handler) {
			if (node.removeEventListener) {
				node.removeEventListener(eventType, handler, false);
			} else if (node.detachEvent) {
				node.detachEvent('on' + eventType, handler);
			} else {
				node['on' + eventType] = helpers.noop;
			}
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof(styleValue) === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = domNode.parentNode;
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		helpers.getMaximumWidth = function(domNode) {
			var container = domNode.parentNode;
			var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
			var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
			var w = container.clientWidth - paddingLeft - paddingRight;
			var cw = helpers.getConstraintWidth(domNode);
			return isNaN(cw)? w : Math.min(w, cw);
		};
		helpers.getMaximumHeight = function(domNode) {
			var container = domNode.parentNode;
			var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
			var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
			var h = container.clientHeight - paddingTop - paddingBottom;
			var ch = helpers.getConstraintHeight(domNode);
			return isNaN(ch)? h : Math.min(h, ch);
		};
		helpers.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers.retinaScale = function(chart) {
			var pixelRatio = chart.currentDevicePixelRatio = window.devicePixelRatio || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		};
		// -- Canvas methods
		helpers.clear = function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		};
		helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
					longest = helpers.measureText(ctx, data, gc, longest, thing);
				} else if (helpers.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
							longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers.each(arrayOfThings, function(thing) {
				if (helpers.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
		helpers.drawRoundedRectangle = function(ctx, x, y, width, height, radius) {
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
		};
		helpers.color = function(c) {
			if (!color) {
				console.error('Color.js not found!');
				return c;
			}
	
			/* global CanvasGradient */
			if (c instanceof CanvasGradient) {
				return color(Chart.defaults.global.defaultColor);
			}
	
			return color(c);
		};
		helpers.isArray = Array.isArray?
			function(obj) {
				return Array.isArray(obj);
			} :
			function(obj) {
				return Object.prototype.toString.call(obj) === '[object Array]';
			};
		// ! @see http://stackoverflow.com/a/14853974
		helpers.arrayEquals = function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen=a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		};
		helpers.callCallback = function(fn, args, _tArg) {
			if (fn && typeof fn.call === 'function') {
				fn.apply(_tArg, args);
			}
		};
		helpers.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern) ?
				colorValue :
				helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};


/***/ },
/* 2433 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		var helpers = Chart.helpers;
	
		/**
		 * Helper function to get relative position for an event
		 * @param {Event|IEvent} event - The event to get the position for
		 * @param {Chart} chart - The chart
		 * @returns {Point} the event position
		 */
		function getRelativePosition(e, chart) {
			if (e.native) {
				return {
					x: e.x,
					y: e.y
				};
			}
	
			return helpers.getRelativePosition(e, chart);
		}
	
		/**
		 * Helper function to traverse all of the visible elements in the chart
		 * @param chart {chart} the chart
		 * @param handler {Function} the callback to execute for each visible item
		 */
		function parseVisibleItems(chart, handler) {
			var datasets = chart.data.datasets;
			var meta, i, j, ilen, jlen;
	
			for (i = 0, ilen = datasets.length; i < ilen; ++i) {
				if (!chart.isDatasetVisible(i)) {
					continue;
				}
	
				meta = chart.getDatasetMeta(i);
				for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
					var element = meta.data[j];
					if (!element._view.skip) {
						handler(element);
					}
				}
			}
		}
	
		/**
		 * Helper function to get the items that intersect the event position
		 * @param items {ChartElement[]} elements to filter
		 * @param position {Point} the point to be nearest to
		 * @return {ChartElement[]} the nearest items
		 */
		function getIntersectItems(chart, position) {
			var elements = [];
	
			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
				}
			});
	
			return elements;
		}
	
		/**
		 * Helper function to get the items nearest to the event position considering all visible items in teh chart
		 * @param chart {Chart} the chart to look at elements from
		 * @param position {Point} the point to be nearest to
		 * @param intersect {Boolean} if true, only consider items that intersect the position
		 * @param distanceMetric {Function} Optional function to provide the distance between
		 * @return {ChartElement[]} the nearest items
		 */
		function getNearestItems(chart, position, intersect, distanceMetric) {
			var minDistance = Number.POSITIVE_INFINITY;
			var nearestItems = [];
	
			if (!distanceMetric) {
				distanceMetric = helpers.distanceBetweenPoints;
			}
	
			parseVisibleItems(chart, function(element) {
				if (intersect && !element.inRange(position.x, position.y)) {
					return;
				}
	
				var center = element.getCenterPoint();
				var distance = distanceMetric(position, center);
	
				if (distance < minDistance) {
					nearestItems = [element];
					minDistance = distance;
				} else if (distance === minDistance) {
					// Can have multiple items at the same distance in which case we sort by size
					nearestItems.push(element);
				}
			});
	
			return nearestItems;
		}
	
		function indexMode(chart, e, options) {
			var position = getRelativePosition(e, chart.chart);
			var distanceMetric = function(pt1, pt2) {
				return Math.abs(pt1.x - pt2.x);
			};
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
			var elements = [];
	
			if (!items.length) {
				return [];
			}
	
			chart.data.datasets.forEach(function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex),
						element = meta.data[items[0]._index];
	
					// don't count items that are skipped (null data)
					if (element && !element._view.skip) {
						elements.push(element);
					}
				}
			});
	
			return elements;
		}
	
		/**
		 * @interface IInteractionOptions
		 */
		/**
		 * If true, only consider items that intersect the point
		 * @name IInterfaceOptions#boolean
		 * @type Boolean
		 */
	
		/**
		 * Contains interaction related functions
		 * @namespace Chart.Interaction
		 */
		Chart.Interaction = {
			// Helper function for different modes
			modes: {
				single: function(chart, e) {
					var position = getRelativePosition(e, chart.chart);
					var elements = [];
	
					parseVisibleItems(chart, function(element) {
						if (element.inRange(position.x, position.y)) {
							elements.push(element);
							return elements;
						}
					});
	
					return elements.slice(0, 1);
				},
	
				/**
				 * @function Chart.Interaction.modes.label
				 * @deprecated since version 2.4.0
				 */
				label: indexMode,
	
				/**
				 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
				 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
				 * @function Chart.Interaction.modes.index
				 * @since v2.4.0
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use during interaction
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				index: indexMode,
	
				/**
				 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
				 * If the options.intersect is false, we find the nearest item and return the items in that dataset
				 * @function Chart.Interaction.modes.dataset
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use during interaction
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				dataset: function(chart, e, options) {
					var position = getRelativePosition(e, chart.chart);
					var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false);
	
					if (items.length > 0) {
						items = chart.getDatasetMeta(items[0]._datasetIndex).data;
					}
	
					return items;
				},
	
				/**
				 * @function Chart.Interaction.modes.x-axis
				 * @deprecated since version 2.4.0. Use index mode and intersect == true
				 */
				'x-axis': function(chart, e) {
					return indexMode(chart, e, true);
				},
	
				/**
				 * Point mode returns all elements that hit test based on the event position
				 * of the event
				 * @function Chart.Interaction.modes.intersect
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				point: function(chart, e) {
					var position = getRelativePosition(e, chart.chart);
					return getIntersectItems(chart, position);
				},
	
				/**
				 * nearest mode returns the element closest to the point
				 * @function Chart.Interaction.modes.intersect
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				nearest: function(chart, e, options) {
					var position = getRelativePosition(e, chart.chart);
					var nearestItems = getNearestItems(chart, position, options.intersect);
	
					// We have multiple items at the same distance from the event. Now sort by smallest
					if (nearestItems.length > 1) {
						nearestItems.sort(function(a, b) {
							var sizeA = a.getArea();
							var sizeB = b.getArea();
							var ret = sizeA - sizeB;
	
							if (ret === 0) {
								// if equal sort by dataset index
								ret = a._datasetIndex - b._datasetIndex;
							}
	
							return ret;
						});
					}
	
					// Return only 1 item
					return nearestItems.slice(0, 1);
				},
	
				/**
				 * x mode returns the elements that hit-test at the current x coordinate
				 * @function Chart.Interaction.modes.x
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				x: function(chart, e, options) {
					var position = getRelativePosition(e, chart.chart);
					var items = [];
					var intersectsItem = false;
	
					parseVisibleItems(chart, function(element) {
						if (element.inXRange(position.x)) {
							items.push(element);
						}
	
						if (element.inRange(position.x, position.y)) {
							intersectsItem = true;
						}
					});
	
					// If we want to trigger on an intersect and we don't have any items
					// that intersect the position, return nothing
					if (options.intersect && !intersectsItem) {
						items = [];
					}
					return items;
				},
	
				/**
				 * y mode returns the elements that hit-test at the current y coordinate
				 * @function Chart.Interaction.modes.y
				 * @param chart {chart} the chart we are returning items from
				 * @param e {Event} the event we are find things at
				 * @param options {IInteractionOptions} options to use
				 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
				 */
				y: function(chart, e, options) {
					var position = getRelativePosition(e, chart.chart);
					var items = [];
					var intersectsItem = false;
	
					parseVisibleItems(chart, function(element) {
						if (element.inYRange(position.y)) {
							items.push(element);
						}
	
						if (element.inRange(position.x, position.y)) {
							intersectsItem = true;
						}
					});
	
					// If we want to trigger on an intersect and we don't have any items
					// that intersect the position, return nothing
					if (options.intersect && !intersectsItem) {
						items = [];
					}
					return items;
				}
			}
		};
	};


/***/ },
/* 2434 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function() {
	
		// Occupy the global variable of Chart, and create a simple base class
		var Chart = function(item, config) {
			this.controller = new Chart.Controller(item, config, this);
			return this.controller;
		};
	
		// Globally expose the defaults to allow for user updating/changing
		Chart.defaults = {
			global: {
				responsive: true,
				responsiveAnimationDuration: 0,
				maintainAspectRatio: true,
				events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
				hover: {
					onHover: null,
					mode: 'nearest',
					intersect: true,
					animationDuration: 400
				},
				onClick: null,
				defaultColor: 'rgba(0,0,0,0.1)',
				defaultFontColor: '#666',
				defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
				defaultFontSize: 12,
				defaultFontStyle: 'normal',
				showLines: true,
	
				// Element defaults defined in element extensions
				elements: {},
	
				// Legend callback string
				legendCallback: function(chart) {
					var text = [];
					text.push('<ul class="' + chart.id + '-legend">');
					for (var i = 0; i < chart.data.datasets.length; i++) {
						text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
						if (chart.data.datasets[i].label) {
							text.push(chart.data.datasets[i].label);
						}
						text.push('</li>');
					}
					text.push('</ul>');
	
					return text.join('');
				}
			}
		};
	
		Chart.Chart = Chart;
	
		return Chart;
	};


/***/ },
/* 2435 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		// The layout service is very self explanatory.  It's responsible for the layout within a chart.
		// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
		// It is this service's responsibility of carrying out that layout.
		Chart.layoutService = {
			defaults: {},
	
			// Register a box to a chartInstance. A box is simply a reference to an object that requires layout. eg. Scales, Legend, Plugins.
			addBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					chartInstance.boxes = [];
				}
				chartInstance.boxes.push(box);
			},
	
			removeBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					return;
				}
				chartInstance.boxes.splice(chartInstance.boxes.indexOf(box), 1);
			},
	
			// The most important function
			update: function(chartInstance, width, height) {
	
				if (!chartInstance) {
					return;
				}
	
				var layoutOptions = chartInstance.options.layout;
				var padding = layoutOptions ? layoutOptions.padding : null;
	
				var leftPadding = 0;
				var rightPadding = 0;
				var topPadding = 0;
				var bottomPadding = 0;
	
				if (!isNaN(padding)) {
					// options.layout.padding is a number. assign to all
					leftPadding = padding;
					rightPadding = padding;
					topPadding = padding;
					bottomPadding = padding;
				} else {
					leftPadding = padding.left || 0;
					rightPadding = padding.right || 0;
					topPadding = padding.top || 0;
					bottomPadding = padding.bottom || 0;
				}
	
				var leftBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'left';
				});
				var rightBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'right';
				});
				var topBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'top';
				});
				var bottomBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'bottom';
				});
	
				// Boxes that overlay the chartarea such as the radialLinear scale
				var chartAreaBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'chartArea';
				});
	
				// Ensure that full width boxes are at the very top / bottom
				topBoxes.sort(function(a, b) {
					return (b.options.fullWidth ? 1 : 0) - (a.options.fullWidth ? 1 : 0);
				});
				bottomBoxes.sort(function(a, b) {
					return (a.options.fullWidth ? 1 : 0) - (b.options.fullWidth ? 1 : 0);
				});
	
				// Essentially we now have any number of boxes on each of the 4 sides.
				// Our canvas looks like the following.
				// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
				// B1 is the bottom axis
				// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
				// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
				// an error will be thrown.
				//
				// |----------------------------------------------------|
				// |                  T1 (Full Width)                   |
				// |----------------------------------------------------|
				// |    |    |                 T2                  |    |
				// |    |----|-------------------------------------|----|
				// |    |    | C1 |                           | C2 |    |
				// |    |    |----|                           |----|    |
				// |    |    |                                     |    |
				// | L1 | L2 |           ChartArea (C0)            | R1 |
				// |    |    |                                     |    |
				// |    |    |----|                           |----|    |
				// |    |    | C3 |                           | C4 |    |
				// |    |----|-------------------------------------|----|
				// |    |    |                 B1                  |    |
				// |----------------------------------------------------|
				// |                  B2 (Full Width)                   |
				// |----------------------------------------------------|
				//
				// What we do to find the best sizing, we do the following
				// 1. Determine the minimum size of the chart area.
				// 2. Split the remaining width equally between each vertical axis
				// 3. Split the remaining height equally between each horizontal axis
				// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
				// 5. Adjust the sizes of each axis based on it's minimum reported size.
				// 6. Refit each axis
				// 7. Position each axis in the final location
				// 8. Tell the chart the final location of the chart area
				// 9. Tell any axes that overlay the chart area the positions of the chart area
	
				// Step 1
				var chartWidth = width - leftPadding - rightPadding;
				var chartHeight = height - topPadding - bottomPadding;
				var chartAreaWidth = chartWidth / 2; // min 50%
				var chartAreaHeight = chartHeight / 2; // min 50%
	
				// Step 2
				var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);
	
				// Step 3
				var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);
	
				// Step 4
				var maxChartAreaWidth = chartWidth;
				var maxChartAreaHeight = chartHeight;
				var minBoxSizes = [];
	
				function getMinimumBoxSize(box) {
					var minSize;
					var isHorizontal = box.isHorizontal();
	
					if (isHorizontal) {
						minSize = box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
						maxChartAreaHeight -= minSize.height;
					} else {
						minSize = box.update(verticalBoxWidth, chartAreaHeight);
						maxChartAreaWidth -= minSize.width;
					}
	
					minBoxSizes.push({
						horizontal: isHorizontal,
						minSize: minSize,
						box: box,
					});
				}
	
				helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);
	
				// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
				var maxHorizontalLeftPadding = 0;
				var maxHorizontalRightPadding = 0;
				var maxVerticalTopPadding = 0;
				var maxVerticalBottomPadding = 0;
	
				helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
					if (horizontalBox.getPadding) {
						var boxPadding = horizontalBox.getPadding();
						maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
						maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
					}
				});
	
				helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
					if (verticalBox.getPadding) {
						var boxPadding = verticalBox.getPadding();
						maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
						maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
					}
				});
	
				// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
				// be if the axes are drawn at their minimum sizes.
				// Steps 5 & 6
				var totalLeftBoxesWidth = leftPadding;
				var totalRightBoxesWidth = rightPadding;
				var totalTopBoxesHeight = topPadding;
				var totalBottomBoxesHeight = bottomPadding;
	
				// Function to fit a box
				function fitBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
						return minBox.box === box;
					});
	
					if (minBoxSize) {
						if (box.isHorizontal()) {
							var scaleMargin = {
								left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
								right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
								top: 0,
								bottom: 0
							};
	
							// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
							// on the margin. Sometimes they need to increase in size slightly
							box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
						} else {
							box.update(minBoxSize.minSize.width, maxChartAreaHeight);
						}
					}
				}
	
				// Update, and calculate the left and right margins for the horizontal boxes
				helpers.each(leftBoxes.concat(rightBoxes), fitBox);
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				// Set the Left and Right margins for the horizontal boxes
				helpers.each(topBoxes.concat(bottomBoxes), fitBox);
	
				// Figure out how much margin is on the top and bottom of the vertical boxes
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
	
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				function finalFitVerticalBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
						return minSize.box === box;
					});
	
					var scaleMargin = {
						left: 0,
						right: 0,
						top: totalTopBoxesHeight,
						bottom: totalBottomBoxesHeight
					};
	
					if (minBoxSize) {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
					}
				}
	
				// Let the left layout know the final margin
				helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);
	
				// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
				totalLeftBoxesWidth = leftPadding;
				totalRightBoxesWidth = rightPadding;
				totalTopBoxesHeight = topPadding;
				totalBottomBoxesHeight = bottomPadding;
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				// We may be adding some padding to account for rotated x axis labels
				var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
				totalLeftBoxesWidth += leftPaddingAddition;
				totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);
	
				var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
				totalTopBoxesHeight += topPaddingAddition;
				totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);
	
				// Figure out if our chart area changed. This would occur if the dataset layout label rotation
				// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
				// without calling `fit` again
				var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
				var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;
	
				if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
					helpers.each(leftBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(rightBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(topBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					helpers.each(bottomBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					maxChartAreaHeight = newMaxChartAreaHeight;
					maxChartAreaWidth = newMaxChartAreaWidth;
				}
	
				// Step 7 - Position the boxes
				var left = leftPadding + leftPaddingAddition;
				var top = topPadding + topPaddingAddition;
	
				function placeBox(box) {
					if (box.isHorizontal()) {
						box.left = box.options.fullWidth ? leftPadding : totalLeftBoxesWidth;
						box.right = box.options.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
						box.top = top;
						box.bottom = top + box.height;
	
						// Move to next point
						top = box.bottom;
	
					} else {
	
						box.left = left;
						box.right = left + box.width;
						box.top = totalTopBoxesHeight;
						box.bottom = totalTopBoxesHeight + maxChartAreaHeight;
	
						// Move to next point
						left = box.right;
					}
				}
	
				helpers.each(leftBoxes.concat(topBoxes), placeBox);
	
				// Account for chart width and height
				left += maxChartAreaWidth;
				top += maxChartAreaHeight;
	
				helpers.each(rightBoxes, placeBox);
				helpers.each(bottomBoxes, placeBox);
	
				// Step 8
				chartInstance.chartArea = {
					left: totalLeftBoxesWidth,
					top: totalTopBoxesHeight,
					right: totalLeftBoxesWidth + maxChartAreaWidth,
					bottom: totalTopBoxesHeight + maxChartAreaHeight
				};
	
				// Step 9
				helpers.each(chartAreaBoxes, function(box) {
					box.left = chartInstance.chartArea.left;
					box.top = chartInstance.chartArea.top;
					box.right = chartInstance.chartArea.right;
					box.bottom = chartInstance.chartArea.bottom;
	
					box.update(maxChartAreaWidth, maxChartAreaHeight);
				});
			}
		};
	};


/***/ },
/* 2436 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var noop = helpers.noop;
	
		Chart.defaults.global.legend = {
	
			display: true,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
			reverse: false,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		};
	
		/**
		 * Helper function to get the box width based on the usePointStyle option
		 * @param labelopts {Object} the label options on the legend
		 * @param fontSize {Number} the label font size
		 * @return {Number} width of the color box area
		 */
		function getBoxWidth(labelOpts, fontSize) {
			return labelOpts.usePointStyle ?
				fontSize * Math.SQRT2 :
				labelOpts.boxWidth;
		}
	
		Chart.Legend = Chart.Element.extend({
	
			initialize: function(config) {
				helpers.extend(this, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				this.legendHitBoxes = [];
	
				// Are we in doughnut mode which has a different data type
				this.doughnutMode = false;
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
			// Any function defined here is inherited by all legend types.
			// Any function can be extended by the legend type
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: function() {
				var me = this;
				var labelOpts = me.options.labels;
				var legendItems = labelOpts.generateLabels.call(me, me.chart);
	
				if (labelOpts.filter) {
					legendItems = legendItems.filter(function(item) {
						return labelOpts.filter(item, me.chart.data);
					});
				}
	
				if (me.options.reverse) {
					legendItems.reverse();
				}
	
				me.legendItems = legendItems;
			},
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var display = opts.display;
	
				var ctx = me.ctx;
	
				var globalDefault = Chart.defaults.global,
					itemOrDefault = helpers.getValueOrDefault,
					fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
					fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
					fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
					labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
				// Reset hit boxes
				var hitboxes = me.legendHitBoxes = [];
	
				var minSize = me.minSize;
				var isHorizontal = me.isHorizontal();
	
				if (isHorizontal) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? 10 : 0;
				} else {
					minSize.width = display ? 10 : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Increase sizes here
				if (display) {
					ctx.font = labelFont;
	
					if (isHorizontal) {
						// Labels
	
						// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
						var lineWidths = me.lineWidths = [0];
						var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;
	
						ctx.textAlign = 'left';
						ctx.textBaseline = 'top';
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
								totalHeight += fontSize + (labelOpts.padding);
								lineWidths[lineWidths.length] = me.left;
							}
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: width,
								height: fontSize
							};
	
							lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
						});
	
						minSize.height += totalHeight;
	
					} else {
						var vPadding = labelOpts.padding;
						var columnWidths = me.columnWidths = [];
						var totalWidth = labelOpts.padding;
						var currentColWidth = 0;
						var currentColHeight = 0;
						var itemHeight = fontSize + vPadding;
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							// If too tall, go to new column
							if (currentColHeight + itemHeight > minSize.height) {
								totalWidth += currentColWidth + labelOpts.padding;
								columnWidths.push(currentColWidth); // previous column width
	
								currentColWidth = 0;
								currentColHeight = 0;
							}
	
							// Get max width
							currentColWidth = Math.max(currentColWidth, itemWidth);
							currentColHeight += itemHeight;
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: itemWidth,
								height: fontSize
							};
						});
	
						totalWidth += currentColWidth;
						columnWidths.push(currentColWidth);
						minSize.width += totalWidth;
					}
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
	
			// Actually draw the legend on the canvas
			draw: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var globalDefault = Chart.defaults.global,
					lineDefault = globalDefault.elements.line,
					legendWidth = me.width,
					lineWidths = me.lineWidths;
	
				if (opts.display) {
					var ctx = me.ctx,
						cursor,
						itemOrDefault = helpers.getValueOrDefault,
						fontColor = itemOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor),
						fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
						fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
						fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
						labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
					// Canvas setup
					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';
					ctx.lineWidth = 0.5;
					ctx.strokeStyle = fontColor; // for strikethrough effect
					ctx.fillStyle = fontColor; // render in correct colour
					ctx.font = labelFont;
	
					var boxWidth = getBoxWidth(labelOpts, fontSize),
						hitboxes = me.legendHitBoxes;
	
					// current position
					var drawLegendBox = function(x, y, legendItem) {
						if (isNaN(boxWidth) || boxWidth <= 0) {
							return;
						}
	
						// Set the ctx for the box
						ctx.save();
	
						ctx.fillStyle = itemOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
						ctx.lineCap = itemOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
						ctx.lineDashOffset = itemOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
						ctx.lineJoin = itemOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
						ctx.lineWidth = itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
						ctx.strokeStyle = itemOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
						var isLineWidthZero = (itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);
	
						if (ctx.setLineDash) {
							// IE 9 and 10 do not support line dash
							ctx.setLineDash(itemOrDefault(legendItem.lineDash, lineDefault.borderDash));
						}
	
						if (opts.labels && opts.labels.usePointStyle) {
							// Recalculate x and y for drawPoint() because its expecting
							// x and y to be center of figure (instead of top left)
							var radius = fontSize * Math.SQRT2 / 2;
							var offSet = radius / Math.SQRT2;
							var centerX = x + offSet;
							var centerY = y + offSet;
	
							// Draw pointStyle as legend symbol
							Chart.canvasHelpers.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
						} else {
							// Draw box as legend symbol
							if (!isLineWidthZero) {
								ctx.strokeRect(x, y, boxWidth, fontSize);
							}
							ctx.fillRect(x, y, boxWidth, fontSize);
						}
	
						ctx.restore();
					};
					var fillText = function(x, y, legendItem, textWidth) {
						ctx.fillText(legendItem.text, boxWidth + (fontSize / 2) + x, y);
	
						if (legendItem.hidden) {
							// Strikethrough the text if hidden
							ctx.beginPath();
							ctx.lineWidth = 2;
							ctx.moveTo(boxWidth + (fontSize / 2) + x, y + (fontSize / 2));
							ctx.lineTo(boxWidth + (fontSize / 2) + x + textWidth, y + (fontSize / 2));
							ctx.stroke();
						}
					};
	
					// Horizontal
					var isHorizontal = me.isHorizontal();
					if (isHorizontal) {
						cursor = {
							x: me.left + ((legendWidth - lineWidths[0]) / 2),
							y: me.top + labelOpts.padding,
							line: 0
						};
					} else {
						cursor = {
							x: me.left + labelOpts.padding,
							y: me.top + labelOpts.padding,
							line: 0
						};
					}
	
					var itemHeight = fontSize + labelOpts.padding;
					helpers.each(me.legendItems, function(legendItem, i) {
						var textWidth = ctx.measureText(legendItem.text).width,
							width = boxWidth + (fontSize / 2) + textWidth,
							x = cursor.x,
							y = cursor.y;
	
						if (isHorizontal) {
							if (x + width >= legendWidth) {
								y = cursor.y += itemHeight;
								cursor.line++;
								x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
							}
						} else if (y + itemHeight > me.bottom) {
							x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
							y = cursor.y = me.top + labelOpts.padding;
							cursor.line++;
						}
	
						drawLegendBox(x, y, legendItem);
	
						hitboxes[i].left = x;
						hitboxes[i].top = y;
	
						// Fill the actual label
						fillText(x, y, legendItem, textWidth);
	
						if (isHorizontal) {
							cursor.x += width + (labelOpts.padding);
						} else {
							cursor.y += itemHeight;
						}
	
					});
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @return {Boolean} true if a change occured
			 */
			handleEvent: function(e) {
				var me = this;
				var opts = me.options;
				var type = e.type === 'mouseup' ? 'click' : e.type;
				var changed = false;
	
				if (type === 'mousemove') {
					if (!opts.onHover) {
						return;
					}
				} else if (type === 'click') {
					if (!opts.onClick) {
						return;
					}
				} else {
					return;
				}
	
				// Chart event already has relative position in it
				var x = e.x,
					y = e.y;
	
				if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
					// See if we are touching one of the dataset boxes
					var lh = me.legendHitBoxes;
					for (var i = 0; i < lh.length; ++i) {
						var hitBox = lh[i];
	
						if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
							// Touching an element
							if (type === 'click') {
								// use e.native for backwards compatibility
								opts.onClick.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							} else if (type === 'mousemove') {
								// use e.native for backwards compatibility
								opts.onHover.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							}
						}
					}
				}
	
				return changed;
			}
		});
	
		function createNewLegendAndAttach(chartInstance, legendOpts) {
			var legend = new Chart.Legend({
				ctx: chartInstance.chart.ctx,
				options: legendOpts,
				chart: chartInstance
			});
			chartInstance.legend = legend;
			Chart.layoutService.addBox(chartInstance, legend);
		}
	
		// Register the legend plugin
		Chart.plugins.register({
			beforeInit: function(chartInstance) {
				var legendOpts = chartInstance.options.legend;
	
				if (legendOpts) {
					createNewLegendAndAttach(chartInstance, legendOpts);
				}
			},
			beforeUpdate: function(chartInstance) {
				var legendOpts = chartInstance.options.legend;
	
				if (legendOpts) {
					legendOpts = helpers.configMerge(Chart.defaults.global.legend, legendOpts);
	
					if (chartInstance.legend) {
						chartInstance.legend.options = legendOpts;
					} else {
						createNewLegendAndAttach(chartInstance, legendOpts);
					}
				} else {
					Chart.layoutService.removeBox(chartInstance, chartInstance.legend);
					delete chartInstance.legend;
				}
			},
			afterEvent: function(chartInstance, e) {
				var legend = chartInstance.legend;
				if (legend) {
					legend.handleEvent(e);
				}
			}
		});
	};


/***/ },
/* 2437 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.plugins = {};
	
		/**
		 * The plugin service singleton
		 * @namespace Chart.plugins
		 * @since 2.1.0
		 */
		Chart.plugins = {
			/**
			 * Globally registered plugins.
			 * @private
			 */
			_plugins: [],
	
			/**
			 * This identifier is used to invalidate the descriptors cache attached to each chart
			 * when a global plugin is registered or unregistered. In this case, the cache ID is
			 * incremented and descriptors are regenerated during following API calls.
			 * @private
			 */
			_cacheId: 0,
	
			/**
			 * Registers the given plugin(s) if not already registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			register: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					if (p.indexOf(plugin) === -1) {
						p.push(plugin);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Unregisters the given plugin(s) only if registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			unregister: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					var idx = p.indexOf(plugin);
					if (idx !== -1) {
						p.splice(idx, 1);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Remove all registered plugins.
			 * @since 2.1.5
			 */
			clear: function() {
				this._plugins = [];
				this._cacheId++;
			},
	
			/**
			 * Returns the number of registered plugins?
			 * @returns {Number}
			 * @since 2.1.5
			 */
			count: function() {
				return this._plugins.length;
			},
	
			/**
			 * Returns all registered plugin instances.
			 * @returns {Array} array of plugin objects.
			 * @since 2.1.5
			 */
			getAll: function() {
				return this._plugins;
			},
	
			/**
			 * Calls enabled plugins for `chart` on the specified hook and with the given args.
			 * This method immediately returns as soon as a plugin explicitly returns false. The
			 * returned value can be used, for instance, to interrupt the current action.
			 * @param {Object} chart - The chart instance for which plugins should be called.
			 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
			 * @param {Array} [args] - Extra arguments to apply to the hook call.
			 * @returns {Boolean} false if any of the plugins return false, else returns true.
			 */
			notify: function(chart, hook, args) {
				var descriptors = this.descriptors(chart);
				var ilen = descriptors.length;
				var i, descriptor, plugin, params, method;
	
				for (i=0; i<ilen; ++i) {
					descriptor = descriptors[i];
					plugin = descriptor.plugin;
					method = plugin[hook];
					if (typeof method === 'function') {
						params = [chart].concat(args || []);
						params.push(descriptor.options);
						if (method.apply(plugin, params) === false) {
							return false;
						}
					}
				}
	
				return true;
			},
	
			/**
			 * Returns descriptors of enabled plugins for the given chart.
			 * @returns {Array} [{ plugin, options }]
			 * @private
			 */
			descriptors: function(chart) {
				var cache = chart._plugins || (chart._plugins = {});
				if (cache.id === this._cacheId) {
					return cache.descriptors;
				}
	
				var plugins = [];
				var descriptors = [];
				var config = (chart && chart.config) || {};
				var defaults = Chart.defaults.global.plugins;
				var options = (config.options && config.options.plugins) || {};
	
				this._plugins.concat(config.plugins || []).forEach(function(plugin) {
					var idx = plugins.indexOf(plugin);
					if (idx !== -1) {
						return;
					}
	
					var id = plugin.id;
					var opts = options[id];
					if (opts === false) {
						return;
					}
	
					if (opts === true) {
						opts = helpers.clone(defaults[id]);
					}
	
					plugins.push(plugin);
					descriptors.push({
						plugin: plugin,
						options: opts || {}
					});
				});
	
				cache.descriptors = descriptors;
				cache.id = this._cacheId;
				return descriptors;
			}
		};
	
		/**
		 * Plugin extension hooks.
		 * @interface IPlugin
		 * @since 2.1.0
		 */
		/**
		 * @method IPlugin#beforeInit
		 * @desc Called before initializing `chart`.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterInit
		 * @desc Called after `chart` has been initialized and before the first update.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeUpdate
		 * @desc Called before updating `chart`. If any plugin returns `false`, the update
		 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart update.
		 */
		/**
		 * @method IPlugin#afterUpdate
		 * @desc Called after `chart` has been updated and before rendering. Note that this
		 * hook will not be called if the chart update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsUpdate
	 	 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
		 * the datasets update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} false to cancel the datasets update.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#afterDatasetsUpdate
		 * @desc Called after the `chart` datasets have been updated. Note that this hook
		 * will not be called if the datasets update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#beforeLayout
		 * @desc Called before laying out `chart`. If any plugin returns `false`,
		 * the layout update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart layout.
		 */
		/**
		 * @method IPlugin#afterLayout
		 * @desc Called after the `chart` has been layed out. Note that this hook will not
		 * be called if the layout update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeRender
		 * @desc Called before rendering `chart`. If any plugin returns `false`,
		 * the rendering is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart rendering.
		 */
		/**
		 * @method IPlugin#afterRender
		 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
		 * that this hook will not be called if the rendering has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDraw
		 * @desc Called before drawing `chart` at every animation frame specified by the given
		 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
		 * another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart drawing.
		 */
		/**
		 * @method IPlugin#afterDraw
		 * @desc Called after the `chart` has been drawn for the specific easing value. Note
		 * that this hook will not be called if the drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsDraw
	 	 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
		 * the datasets drawing is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetsDraw
		 * @desc Called after the `chart` datasets have been drawn. Note that this hook
		 * will not be called if the datasets drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeEvent
	 	 * @desc Called before processing the specified `event`. If any plugin returns `false`,
		 * the event will be discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterEvent
		 * @desc Called after the `event` has been consumed. Note that this hook
		 * will not be called if the `event` has been previously discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#resize
		 * @desc Called after the chart as been resized.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#destroy
		 * @desc Called after the chart as been destroyed.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
	
		/**
		 * Provided for backward compatibility, use Chart.plugins instead
		 * @namespace Chart.pluginService
		 * @deprecated since version 2.1.5
		 * @todo remove at version 3
		 * @private
		 */
		Chart.pluginService = Chart.plugins;
	
		/**
		 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
		 * effect, instead simply create/register plugins via plain JavaScript objects.
		 * @interface Chart.PluginBase
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.PluginBase = helpers.inherits({});
	};


/***/ },
/* 2438 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.scale = {
			display: true,
			position: 'left',
	
			// grid line settings
			gridLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1,
				drawBorder: true,
				drawOnChartArea: true,
				drawTicks: true,
				tickMarkLength: 10,
				zeroLineWidth: 1,
				zeroLineColor: 'rgba(0,0,0,0.25)',
				offsetGridLines: false,
				borderDash: [],
				borderDashOffset: 0.0
			},
	
			// scale label
			scaleLabel: {
				// actual label
				labelString: '',
	
				// display property
				display: false
			},
	
			// label settings
			ticks: {
				beginAtZero: false,
				minRotation: 0,
				maxRotation: 50,
				mirror: false,
				padding: 0,
				reverse: false,
				display: true,
				autoSkip: true,
				autoSkipPadding: 0,
				labelOffset: 0,
				// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
				callback: Chart.Ticks.formatters.values
			}
		};
	
		function computeTextSize(context, tick, font) {
			return helpers.isArray(tick) ?
				helpers.longestText(context, font, tick) :
				context.measureText(tick).width;
		}
	
		function parseFontOptions(options) {
			var getValueOrDefault = helpers.getValueOrDefault;
			var globalDefaults = Chart.defaults.global;
			var size = getValueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var style = getValueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
			var family = getValueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);
	
			return {
				size: size,
				style: style,
				family: family,
				font: helpers.fontString(size, style, family)
			};
		}
	
		Chart.Scale = Chart.Element.extend({
			/**
			 * Get the padding needed for the scale
			 * @method getPadding
			 * @private
			 * @returns {Padding} the necessary padding
			 */
			getPadding: function() {
				var me = this;
				return {
					left: me.paddingLeft || 0,
					top: me.paddingTop || 0,
					right: me.paddingRight || 0,
					bottom: me.paddingBottom || 0
				};
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all scale types.
			// Any function can be extended by the scale type
	
			beforeUpdate: function() {
				helpers.callCallback(this.options.beforeUpdate, [this]);
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = helpers.extend({
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}, margins);
				me.longestTextCache = me.longestTextCache || {};
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
	
				// Data min/max
				me.beforeDataLimits();
				me.determineDataLimits();
				me.afterDataLimits();
	
				// Ticks
				me.beforeBuildTicks();
				me.buildTicks();
				me.afterBuildTicks();
	
				me.beforeTickToLabelConversion();
				me.convertTicksToLabels();
				me.afterTickToLabelConversion();
	
				// Tick Rotation
				me.beforeCalculateTickRotation();
				me.calculateTickRotation();
				me.afterCalculateTickRotation();
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: function() {
				helpers.callCallback(this.options.afterUpdate, [this]);
			},
	
			//
	
			beforeSetDimensions: function() {
				helpers.callCallback(this.options.beforeSetDimensions, [this]);
			},
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
			},
			afterSetDimensions: function() {
				helpers.callCallback(this.options.afterSetDimensions, [this]);
			},
	
			// Data limits
			beforeDataLimits: function() {
				helpers.callCallback(this.options.beforeDataLimits, [this]);
			},
			determineDataLimits: helpers.noop,
			afterDataLimits: function() {
				helpers.callCallback(this.options.afterDataLimits, [this]);
			},
	
			//
			beforeBuildTicks: function() {
				helpers.callCallback(this.options.beforeBuildTicks, [this]);
			},
			buildTicks: helpers.noop,
			afterBuildTicks: function() {
				helpers.callCallback(this.options.afterBuildTicks, [this]);
			},
	
			beforeTickToLabelConversion: function() {
				helpers.callCallback(this.options.beforeTickToLabelConversion, [this]);
			},
			convertTicksToLabels: function() {
				var me = this;
				// Convert ticks to strings
				var tickOpts = me.options.ticks;
				me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback);
			},
			afterTickToLabelConversion: function() {
				helpers.callCallback(this.options.afterTickToLabelConversion, [this]);
			},
	
			//
	
			beforeCalculateTickRotation: function() {
				helpers.callCallback(this.options.beforeCalculateTickRotation, [this]);
			},
			calculateTickRotation: function() {
				var me = this;
				var context = me.ctx;
				var tickOpts = me.options.ticks;
	
				// Get the width of each grid by calculating the difference
				// between x offsets between 0 and 1.
				var tickFont = parseFontOptions(tickOpts);
				context.font = tickFont.font;
	
				var labelRotation = tickOpts.minRotation || 0;
	
				if (me.options.display && me.isHorizontal()) {
					var originalLabelWidth = helpers.longestText(context, tickFont.font, me.ticks, me.longestTextCache);
					var labelWidth = originalLabelWidth;
					var cosRotation;
					var sinRotation;
	
					// Allow 3 pixels x2 padding either side for label readability
					var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;
	
					// Max label rotation can be set or default to 90 - also act as a loop counter
					while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
						var angleRadians = helpers.toRadians(labelRotation);
						cosRotation = Math.cos(angleRadians);
						sinRotation = Math.sin(angleRadians);
	
						if (sinRotation * originalLabelWidth > me.maxHeight) {
							// go back one step
							labelRotation--;
							break;
						}
	
						labelRotation++;
						labelWidth = cosRotation * originalLabelWidth;
					}
				}
	
				me.labelRotation = labelRotation;
			},
			afterCalculateTickRotation: function() {
				helpers.callCallback(this.options.afterCalculateTickRotation, [this]);
			},
	
			//
	
			beforeFit: function() {
				helpers.callCallback(this.options.beforeFit, [this]);
			},
			fit: function() {
				var me = this;
				// Reset
				var minSize = me.minSize = {
					width: 0,
					height: 0
				};
	
				var opts = me.options;
				var tickOpts = opts.ticks;
				var scaleLabelOpts = opts.scaleLabel;
				var gridLineOpts = opts.gridLines;
				var display = opts.display;
				var isHorizontal = me.isHorizontal();
	
				var tickFont = parseFontOptions(tickOpts);
				var scaleLabelFontSize = parseFontOptions(scaleLabelOpts).size * 1.5;
				var tickMarkLength = opts.gridLines.tickMarkLength;
	
				// Width
				if (isHorizontal) {
					// subtract the margins to line up with the chartArea if we are a full width scale
					minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
				} else {
					minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				}
	
				// height
				if (isHorizontal) {
					minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				} else {
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Are we showing a title for the scale?
				if (scaleLabelOpts.display && display) {
					if (isHorizontal) {
						minSize.height += scaleLabelFontSize;
					} else {
						minSize.width += scaleLabelFontSize;
					}
				}
	
				// Don't bother fitting the ticks if we are not showing them
				if (tickOpts.display && display) {
					var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, me.ticks, me.longestTextCache);
					var tallestLabelHeightInLines = helpers.numberOfLabelLines(me.ticks);
					var lineSpace = tickFont.size * 0.5;
	
					if (isHorizontal) {
						// A horizontal axis is more constrained by the height.
						me.longestLabelWidth = largestTextWidth;
	
						var angleRadians = helpers.toRadians(me.labelRotation);
						var cosRotation = Math.cos(angleRadians);
						var sinRotation = Math.sin(angleRadians);
	
						// TODO - improve this calculation
						var labelHeight = (sinRotation * largestTextWidth)
							+ (tickFont.size * tallestLabelHeightInLines)
							+ (lineSpace * tallestLabelHeightInLines);
	
						minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight);
						me.ctx.font = tickFont.font;
	
						var firstTick = me.ticks[0];
						var firstLabelWidth = computeTextSize(me.ctx, firstTick, tickFont.font);
	
						var lastTick = me.ticks[me.ticks.length - 1];
						var lastLabelWidth = computeTextSize(me.ctx, lastTick, tickFont.font);
	
						// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned which means that the right padding is dominated
						// by the font height
						if (me.labelRotation !== 0) {
							me.paddingLeft = opts.position === 'bottom'? (cosRotation * firstLabelWidth) + 3: (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
							me.paddingRight = opts.position === 'bottom'? (cosRotation * lineSpace) + 3: (cosRotation * lastLabelWidth) + 3;
						} else {
							me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
							me.paddingRight = lastLabelWidth / 2 + 3;
						}
					} else {
						// A vertical axis is more constrained by the width. Labels are the dominant factor here, so get that length first
						// Account for padding
	
						if (tickOpts.mirror) {
							largestTextWidth = 0;
						} else {
							largestTextWidth += me.options.ticks.padding;
						}
						minSize.width += largestTextWidth;
						me.paddingTop = tickFont.size / 2;
						me.paddingBottom = tickFont.size / 2;
					}
				}
	
				me.handleMargins();
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
	
			/**
			 * Handle margins and padding interactions
			 * @private
			 */
			handleMargins: function() {
				var me = this;
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
					me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
				}
			},
	
			afterFit: function() {
				helpers.callCallback(this.options.afterFit, [this]);
			},
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
			isFullWidth: function() {
				return (this.options.fullWidth);
			},
	
			// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
			getRightValue: function(rawValue) {
				// Null and undefined values first
				if (rawValue === null || typeof(rawValue) === 'undefined') {
					return NaN;
				}
				// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
				if (typeof(rawValue) === 'number' && !isFinite(rawValue)) {
					return NaN;
				}
				// If it is in fact an object, dive in one more level
				if (typeof(rawValue) === 'object') {
					if ((rawValue instanceof Date) || (rawValue.isValid)) {
						return rawValue;
					}
					return this.getRightValue(this.isHorizontal() ? rawValue.x : rawValue.y);
				}
	
				// Value is good, return it
				return rawValue;
			},
	
			// Used to get the value to display in the tooltip for the data at the given index
			// function getLabelForIndex(index, datasetIndex)
			getLabelForIndex: helpers.noop,
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: helpers.noop,
	
			// Used to get the data value from a given pixel. This is the inverse of getPixelForValue
			getValueForPixel: helpers.noop,
	
			// Used for tick location, should
			getPixelForTick: function(index, includeOffset) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var tickWidth = innerWidth / Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
					var pixel = (tickWidth * index) + me.paddingLeft;
	
					if (includeOffset) {
						pixel += tickWidth / 2;
					}
	
					var finalVal = me.left + Math.round(pixel);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				return me.top + (index * (innerHeight / (me.ticks.length - 1)));
			},
	
			// Utility for getting the pixel location of a percentage of scale
			getPixelForDecimal: function(decimal /* , includeOffset*/) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
					var finalVal = me.left + Math.round(valueOffset);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				return me.top + (decimal * me.height);
			},
	
			getBasePixel: function() {
				return this.getPixelForValue(this.getBaseValue());
			},
	
			getBaseValue: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.beginAtZero ? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0;
			},
	
			// Actually draw the scale on the canvas
			// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
			draw: function(chartArea) {
				var me = this;
				var options = me.options;
				if (!options.display) {
					return;
				}
	
				var context = me.ctx;
				var globalDefaults = Chart.defaults.global;
				var optionTicks = options.ticks;
				var gridLines = options.gridLines;
				var scaleLabel = options.scaleLabel;
	
				var isRotated = me.labelRotation !== 0;
				var skipRatio;
				var useAutoskipper = optionTicks.autoSkip;
				var isHorizontal = me.isHorizontal();
	
				// figure out the maximum number of gridlines to show
				var maxTicks;
				if (optionTicks.maxTicksLimit) {
					maxTicks = optionTicks.maxTicksLimit;
				}
	
				var tickFontColor = helpers.getValueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
				var tickFont = parseFontOptions(optionTicks);
	
				var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;
				var borderDash = helpers.getValueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
				var borderDashOffset = helpers.getValueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
	
				var scaleLabelFontColor = helpers.getValueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
				var scaleLabelFont = parseFontOptions(scaleLabel);
	
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
				var cosRotation = Math.cos(labelRotationRadians);
				var longestRotatedLabel = me.longestLabelWidth * cosRotation;
	
				// Make sure we draw text in the correct color and font
				context.fillStyle = tickFontColor;
	
				var itemsToDraw = [];
	
				if (isHorizontal) {
					skipRatio = false;
	
					// Only calculate the skip ratio with the half width of longestRotateLabel if we got an actual rotation
					// See #2584
					if (isRotated) {
						longestRotatedLabel /= 2;
					}
	
					if ((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length > (me.width - (me.paddingLeft + me.paddingRight))) {
						skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length) / (me.width - (me.paddingLeft + me.paddingRight)));
					}
	
					// if they defined a max number of optionTicks,
					// increase skipRatio until that number is met
					if (maxTicks && me.ticks.length > maxTicks) {
						while (!skipRatio || me.ticks.length / (skipRatio || 1) > maxTicks) {
							if (!skipRatio) {
								skipRatio = 1;
							}
							skipRatio += 1;
						}
					}
	
					if (!useAutoskipper) {
						skipRatio = false;
					}
				}
	
	
				var xTickStart = options.position === 'right' ? me.left : me.right - tl;
				var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
				var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
				var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;
	
				helpers.each(me.ticks, function(label, index) {
					// If the callback returned a null or undefined value, do not draw this line
					if (label === undefined || label === null) {
						return;
					}
	
					var isLastTick = me.ticks.length === index + 1;
	
					// Since we always show the last tick,we need may need to hide the last shown one before
					var shouldSkip = (skipRatio > 1 && index % skipRatio > 0) || (index % skipRatio === 0 && index + skipRatio >= me.ticks.length);
					if (shouldSkip && !isLastTick || (label === undefined || label === null)) {
						return;
					}
	
					var lineWidth, lineColor;
					if (index === (typeof me.zeroLineIndex !== 'undefined' ? me.zeroLineIndex : 0)) {
						// Draw the first index specially
						lineWidth = gridLines.zeroLineWidth;
						lineColor = gridLines.zeroLineColor;
					} else {
						lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, index);
						lineColor = helpers.getValueAtIndexOrDefault(gridLines.color, index);
					}
	
					// Common properties
					var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
					var textAlign = 'middle';
					var textBaseline = 'middle';
	
					if (isHorizontal) {
	
						if (options.position === 'bottom') {
							// bottom
							textBaseline = !isRotated? 'top':'middle';
							textAlign = !isRotated? 'center': 'right';
							labelY = me.top + tl;
						} else {
							// top
							textBaseline = !isRotated? 'bottom':'middle';
							textAlign = !isRotated? 'center': 'left';
							labelY = me.bottom - tl;
						}
	
						var xLineValue = me.getPixelForTick(index) + helpers.aliasPixel(lineWidth); // xvalues for grid lines
						labelX = me.getPixelForTick(index, gridLines.offsetGridLines) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)
	
						tx1 = tx2 = x1 = x2 = xLineValue;
						ty1 = yTickStart;
						ty2 = yTickEnd;
						y1 = chartArea.top;
						y2 = chartArea.bottom;
					} else {
						var isLeft = options.position === 'left';
						var tickPadding = optionTicks.padding;
						var labelXOffset;
	
						if (optionTicks.mirror) {
							textAlign = isLeft ? 'left' : 'right';
							labelXOffset = tickPadding;
						} else {
							textAlign = isLeft ? 'right' : 'left';
							labelXOffset = tl + tickPadding;
						}
	
						labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;
	
						var yLineValue = me.getPixelForTick(index); // xvalues for grid lines
						yLineValue += helpers.aliasPixel(lineWidth);
						labelY = me.getPixelForTick(index, gridLines.offsetGridLines);
	
						tx1 = xTickStart;
						tx2 = xTickEnd;
						x1 = chartArea.left;
						x2 = chartArea.right;
						ty1 = ty2 = y1 = y2 = yLineValue;
					}
	
					itemsToDraw.push({
						tx1: tx1,
						ty1: ty1,
						tx2: tx2,
						ty2: ty2,
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						labelX: labelX,
						labelY: labelY,
						glWidth: lineWidth,
						glColor: lineColor,
						glBorderDash: borderDash,
						glBorderDashOffset: borderDashOffset,
						rotation: -1 * labelRotationRadians,
						label: label,
						textBaseline: textBaseline,
						textAlign: textAlign
					});
				});
	
				// Draw all of the tick labels, tick marks, and grid lines at the correct places
				helpers.each(itemsToDraw, function(itemToDraw) {
					if (gridLines.display) {
						context.save();
						context.lineWidth = itemToDraw.glWidth;
						context.strokeStyle = itemToDraw.glColor;
						if (context.setLineDash) {
							context.setLineDash(itemToDraw.glBorderDash);
							context.lineDashOffset = itemToDraw.glBorderDashOffset;
						}
	
						context.beginPath();
	
						if (gridLines.drawTicks) {
							context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
							context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
						}
	
						if (gridLines.drawOnChartArea) {
							context.moveTo(itemToDraw.x1, itemToDraw.y1);
							context.lineTo(itemToDraw.x2, itemToDraw.y2);
						}
	
						context.stroke();
						context.restore();
					}
	
					if (optionTicks.display) {
						context.save();
						context.translate(itemToDraw.labelX, itemToDraw.labelY);
						context.rotate(itemToDraw.rotation);
						context.font = tickFont.font;
						context.textBaseline = itemToDraw.textBaseline;
						context.textAlign = itemToDraw.textAlign;
	
						var label = itemToDraw.label;
						if (helpers.isArray(label)) {
							for (var i = 0, y = 0; i < label.length; ++i) {
								// We just make sure the multiline element is a string here..
								context.fillText('' + label[i], 0, y);
								// apply same lineSpacing as calculated @ L#320
								y += (tickFont.size * 1.5);
							}
						} else {
							context.fillText(label, 0, 0);
						}
						context.restore();
					}
				});
	
				if (scaleLabel.display) {
					// Draw the scale label
					var scaleLabelX;
					var scaleLabelY;
					var rotation = 0;
	
					if (isHorizontal) {
						scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
						scaleLabelY = options.position === 'bottom' ? me.bottom - (scaleLabelFont.size / 2) : me.top + (scaleLabelFont.size / 2);
					} else {
						var isLeft = options.position === 'left';
						scaleLabelX = isLeft ? me.left + (scaleLabelFont.size / 2) : me.right - (scaleLabelFont.size / 2);
						scaleLabelY = me.top + ((me.bottom - me.top) / 2);
						rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
					}
	
					context.save();
					context.translate(scaleLabelX, scaleLabelY);
					context.rotate(rotation);
					context.textAlign = 'center';
					context.textBaseline = 'middle';
					context.fillStyle = scaleLabelFontColor; // render in correct colour
					context.font = scaleLabelFont.font;
					context.fillText(scaleLabel.labelString, 0, 0);
					context.restore();
				}
	
				if (gridLines.drawBorder) {
					// Draw the line at the edge of the axis
					context.lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, 0);
					context.strokeStyle = helpers.getValueAtIndexOrDefault(gridLines.color, 0);
					var x1 = me.left,
						x2 = me.right,
						y1 = me.top,
						y2 = me.bottom;
	
					var aliasPixel = helpers.aliasPixel(context.lineWidth);
					if (isHorizontal) {
						y1 = y2 = options.position === 'top' ? me.bottom : me.top;
						y1 += aliasPixel;
						y2 += aliasPixel;
					} else {
						x1 = x2 = options.position === 'left' ? me.right : me.left;
						x1 += aliasPixel;
						x2 += aliasPixel;
					}
	
					context.beginPath();
					context.moveTo(x1, y1);
					context.lineTo(x2, y2);
					context.stroke();
				}
			}
		});
	};


/***/ },
/* 2439 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.scaleService = {
			// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
			// use the new chart options to grab the correct scale
			constructors: {},
			// Use a registration function so that we can move to an ES6 map when we no longer need to support
			// old browsers
	
			// Scale config defaults
			defaults: {},
			registerScaleType: function(type, scaleConstructor, defaults) {
				this.constructors[type] = scaleConstructor;
				this.defaults[type] = helpers.clone(defaults);
			},
			getScaleConstructor: function(type) {
				return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
			},
			getScaleDefaults: function(type) {
				// Return the scale defaults merged with the global settings so that we always use the latest ones
				return this.defaults.hasOwnProperty(type) ? helpers.scaleMerge(Chart.defaults.scale, this.defaults[type]) : {};
			},
			updateScaleDefaults: function(type, additions) {
				var defaults = this.defaults;
				if (defaults.hasOwnProperty(type)) {
					defaults[type] = helpers.extend(defaults[type], additions);
				}
			},
			addScalesToLayout: function(chartInstance) {
				// Adds each scale to the chart.boxes array to be sized accordingly
				helpers.each(chartInstance.scales, function(scale) {
					Chart.layoutService.addBox(chartInstance, scale);
				});
			}
		};
	};


/***/ },
/* 2440 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		/**
		 * Namespace to hold static tick generation functions
		 * @namespace Chart.Ticks
		 */
		Chart.Ticks = {
			/**
			 * Namespace to hold generators for different types of ticks
			 * @namespace Chart.Ticks.generators
			 */
			generators: {
				/**
				 * Interface for the options provided to the numeric tick generator
				 * @interface INumericTickGenerationOptions
				 */
				/**
				 * The maximum number of ticks to display
				 * @name INumericTickGenerationOptions#maxTicks
				 * @type Number
				 */
				/**
				 * The distance between each tick.
				 * @name INumericTickGenerationOptions#stepSize
				 * @type Number
				 * @optional
				 */
				/**
				 * Forced minimum for the ticks. If not specified, the minimum of the data range is used to calculate the tick minimum
				 * @name INumericTickGenerationOptions#min
				 * @type Number
				 * @optional
				 */
				/**
				 * The maximum value of the ticks. If not specified, the maximum of the data range is used to calculate the tick maximum
				 * @name INumericTickGenerationOptions#max
				 * @type Number
				 * @optional
				 */
	
				/**
				 * Generate a set of linear ticks
				 * @method Chart.Ticks.generators.linear
				 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
				 * @param dataRange {IRange} the range of the data
				 * @returns {Array<Number>} array of tick values
				 */
				linear: function(generationOptions, dataRange) {
					var ticks = [];
					// To get a "nice" value for the tick spacing, we will use the appropriately named
					// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
					// for details.
	
					var spacing;
					if (generationOptions.stepSize && generationOptions.stepSize > 0) {
						spacing = generationOptions.stepSize;
					} else {
						var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
						spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
					}
					var niceMin = Math.floor(dataRange.min / spacing) * spacing;
					var niceMax = Math.ceil(dataRange.max / spacing) * spacing;
	
					// If min, max and stepSize is set and they make an evenly spaced scale use it.
					if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
						// If very close to our whole number, use it.
						if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
							niceMin = generationOptions.min;
							niceMax = generationOptions.max;
						}
					}
	
					var numSpaces = (niceMax - niceMin) / spacing;
					// If very close to our rounded value, use it.
					if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
						numSpaces = Math.round(numSpaces);
					} else {
						numSpaces = Math.ceil(numSpaces);
					}
	
					// Put the values into the ticks array
					ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
					for (var j = 1; j < numSpaces; ++j) {
						ticks.push(niceMin + (j * spacing));
					}
					ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);
	
					return ticks;
				},
	
				/**
				 * Generate a set of logarithmic ticks
				 * @method Chart.Ticks.generators.logarithmic
				 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
				 * @param dataRange {IRange} the range of the data
				 * @returns {Array<Number>} array of tick values
				 */
				logarithmic: function(generationOptions, dataRange) {
					var ticks = [];
					var getValueOrDefault = helpers.getValueOrDefault;
	
					// Figure out what the max number of ticks we can support it is based on the size of
					// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
					// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
					// the graph
					var tickVal = getValueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));
	
					var endExp = Math.floor(helpers.log10(dataRange.max));
					var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
					var exp;
					var significand;
	
					if (tickVal === 0) {
						exp = Math.floor(helpers.log10(dataRange.minNotZero));
						significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
						ticks.push(tickVal);
						tickVal = significand * Math.pow(10, exp);
					} else {
						exp = Math.floor(helpers.log10(tickVal));
						significand = Math.floor(tickVal / Math.pow(10, exp));
					}
	
					do {
						ticks.push(tickVal);
	
						++significand;
						if (significand === 10) {
							significand = 1;
							++exp;
						}
	
						tickVal = significand * Math.pow(10, exp);
					} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
					var lastTick = getValueOrDefault(generationOptions.max, tickVal);
					ticks.push(lastTick);
	
					return ticks;
				}
			},
	
			/**
			 * Namespace to hold formatters for different types of ticks
			 * @namespace Chart.Ticks.formatters
			 */
			formatters: {
				/**
				 * Formatter for value labels
				 * @method Chart.Ticks.formatters.values
				 * @param value the value to display
				 * @return {String|Array} the label to display
				 */
				values: function(value) {
					return helpers.isArray(value) ? value : '' + value;
				},
	
				/**
				 * Formatter for linear numeric ticks
				 * @method Chart.Ticks.formatters.linear
				 * @param tickValue {Number} the value to be formatted
				 * @param index {Number} the position of the tickValue parameter in the ticks array
				 * @param ticks {Array<Number>} the list of ticks being converted
				 * @return {String} string representation of the tickValue parameter
				 */
				linear: function(tickValue, index, ticks) {
					// If we have lots of ticks, don't use the ones
					var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
					// If we have a number like 2.5 as the delta, figure out how many decimal places we need
					if (Math.abs(delta) > 1) {
						if (tickValue !== Math.floor(tickValue)) {
							// not an integer
							delta = tickValue - Math.floor(tickValue);
						}
					}
	
					var logDelta = helpers.log10(Math.abs(delta));
					var tickString = '';
	
					if (tickValue !== 0) {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					} else {
						tickString = '0'; // never show decimal places for 0
					}
	
					return tickString;
				},
	
				logarithmic: function(tickValue, index, ticks) {
					var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));
	
					if (tickValue === 0) {
						return '0';
					} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
						return tickValue.toExponential();
					}
					return '';
				}
			}
		};
	};


/***/ },
/* 2441 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.title = {
			display: false,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
	
			fontStyle: 'bold',
			padding: 10,
	
			// actual title
			text: ''
		};
	
		var noop = helpers.noop;
		Chart.Title = Chart.Element.extend({
	
			initialize: function(config) {
				var me = this;
				helpers.extend(me, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				me.legendHitBoxes = [];
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: noop,
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global,
					display = opts.display,
					fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
					minSize = me.minSize;
	
				if (me.isHorizontal()) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? fontSize + (opts.padding * 2) : 0;
				} else {
					minSize.width = display ? fontSize + (opts.padding * 2) : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				var pos = this.options.position;
				return pos === 'top' || pos === 'bottom';
			},
	
			// Actually draw the title block on the canvas
			draw: function() {
				var me = this,
					ctx = me.ctx,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global;
	
				if (opts.display) {
					var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
						fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle),
						fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily),
						titleFont = helpers.fontString(fontSize, fontStyle, fontFamily),
						rotation = 0,
						titleX,
						titleY,
						top = me.top,
						left = me.left,
						bottom = me.bottom,
						right = me.right,
						maxWidth;
	
					ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
					ctx.font = titleFont;
	
					// Horizontal
					if (me.isHorizontal()) {
						titleX = left + ((right - left) / 2); // midpoint of the width
						titleY = top + ((bottom - top) / 2); // midpoint of the height
						maxWidth = right - left;
					} else {
						titleX = opts.position === 'left' ? left + (fontSize / 2) : right - (fontSize / 2);
						titleY = top + ((bottom - top) / 2);
						maxWidth = bottom - top;
						rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
					}
	
					ctx.save();
					ctx.translate(titleX, titleY);
					ctx.rotate(rotation);
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					ctx.fillText(opts.text, 0, 0, maxWidth);
					ctx.restore();
				}
			}
		});
	
		function createNewTitleBlockAndAttach(chartInstance, titleOpts) {
			var title = new Chart.Title({
				ctx: chartInstance.chart.ctx,
				options: titleOpts,
				chart: chartInstance
			});
			chartInstance.titleBlock = title;
			Chart.layoutService.addBox(chartInstance, title);
		}
	
		// Register the title plugin
		Chart.plugins.register({
			beforeInit: function(chartInstance) {
				var titleOpts = chartInstance.options.title;
	
				if (titleOpts) {
					createNewTitleBlockAndAttach(chartInstance, titleOpts);
				}
			},
			beforeUpdate: function(chartInstance) {
				var titleOpts = chartInstance.options.title;
	
				if (titleOpts) {
					titleOpts = helpers.configMerge(Chart.defaults.global.title, titleOpts);
	
					if (chartInstance.titleBlock) {
						chartInstance.titleBlock.options = titleOpts;
					} else {
						createNewTitleBlockAndAttach(chartInstance, titleOpts);
					}
				} else {
					Chart.layoutService.removeBox(chartInstance, chartInstance.titleBlock);
					delete chartInstance.titleBlock;
				}
			}
		});
	};


/***/ },
/* 2442 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		/**
	 	 * Helper method to merge the opacity into a color
	 	 */
		function mergeOpacity(colorString, opacity) {
			var color = helpers.color(colorString);
			return color.alpha(opacity * color.alpha()).rgbaString();
		}
	
		Chart.defaults.global.tooltips = {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
	
						if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers.noop,
				label: function(tooltipItem, data) {
					var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
					return datasetLabel + ': ' + tooltipItem.yLabel;
				},
				labelColor: function(tooltipItem, chartInstance) {
					var meta = chartInstance.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				afterLabel: helpers.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers.noop,
				footer: helpers.noop,
				afterFooter: helpers.noop
			}
		};
	
		// Helper to push or concat based on if the 2nd parameter is an array or not
		function pushOrConcat(base, toPush) {
			if (toPush) {
				if (helpers.isArray(toPush)) {
					// base = base.concat(toPush);
					Array.prototype.push.apply(base, toPush);
				} else {
					base.push(toPush);
				}
			}
	
			return base;
		}
	
		// Private helper to create a tooltip item model
		// @param element : the chart element (point, arc, bar) to create the tooltip item for
		// @return : new tooltip item
		function createTooltipItem(element) {
			var xScale = element._xScale;
			var yScale = element._yScale || element._scale; // handle radar || polarArea charts
			var index = element._index,
				datasetIndex = element._datasetIndex;
	
			return {
				xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
				yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
				index: index,
				datasetIndex: datasetIndex,
				x: element._model.x,
				y: element._model.y
			};
		}
	
		/**
		 * Helper to get the reset model for the tooltip
		 * @param tooltipOpts {Object} the tooltip options
		 */
		function getBaseModel(tooltipOpts) {
			var globalDefaults = Chart.defaults.global;
			var getValueOrDefault = helpers.getValueOrDefault;
	
			return {
				// Positioning
				xPadding: tooltipOpts.xPadding,
				yPadding: tooltipOpts.yPadding,
				xAlign: tooltipOpts.xAlign,
				yAlign: tooltipOpts.yAlign,
	
				// Body
				bodyFontColor: tooltipOpts.bodyFontColor,
				_bodyFontFamily: getValueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
				_bodyFontStyle: getValueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
				_bodyAlign: tooltipOpts.bodyAlign,
				bodyFontSize: getValueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
				bodySpacing: tooltipOpts.bodySpacing,
	
				// Title
				titleFontColor: tooltipOpts.titleFontColor,
				_titleFontFamily: getValueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
				_titleFontStyle: getValueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
				titleFontSize: getValueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
				_titleAlign: tooltipOpts.titleAlign,
				titleSpacing: tooltipOpts.titleSpacing,
				titleMarginBottom: tooltipOpts.titleMarginBottom,
	
				// Footer
				footerFontColor: tooltipOpts.footerFontColor,
				_footerFontFamily: getValueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
				_footerFontStyle: getValueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
				footerFontSize: getValueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
				_footerAlign: tooltipOpts.footerAlign,
				footerSpacing: tooltipOpts.footerSpacing,
				footerMarginTop: tooltipOpts.footerMarginTop,
	
				// Appearance
				caretSize: tooltipOpts.caretSize,
				cornerRadius: tooltipOpts.cornerRadius,
				backgroundColor: tooltipOpts.backgroundColor,
				opacity: 0,
				legendColorBackground: tooltipOpts.multiKeyBackground,
				displayColors: tooltipOpts.displayColors
			};
		}
	
		/**
		 * Get the size of the tooltip
		 */
		function getTooltipSize(tooltip, model) {
			var ctx = tooltip._chart.ctx;
	
			var height = model.yPadding * 2; // Tooltip Padding
			var width = 0;
	
			// Count of all lines in the body
			var body = model.body;
			var combinedBodyLength = body.reduce(function(count, bodyItem) {
				return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
			}, 0);
			combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
			var titleLineCount = model.title.length;
			var footerLineCount = model.footer.length;
			var titleFontSize = model.titleFontSize,
				bodyFontSize = model.bodyFontSize,
				footerFontSize = model.footerFontSize;
	
			height += titleLineCount * titleFontSize; // Title Lines
			height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
			height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
			height += combinedBodyLength * bodyFontSize; // Body Lines
			height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
			height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
			height += footerLineCount * (footerFontSize); // Footer Lines
			height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
			// Title width
			var widthPadding = 0;
			var maxLineWidth = function(line) {
				width = Math.max(width, ctx.measureText(line).width + widthPadding);
			};
	
			ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
			helpers.each(model.title, maxLineWidth);
	
			// Body width
			ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
			helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
			// Body lines may include some extra width due to the color box
			widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
			helpers.each(body, function(bodyItem) {
				helpers.each(bodyItem.before, maxLineWidth);
				helpers.each(bodyItem.lines, maxLineWidth);
				helpers.each(bodyItem.after, maxLineWidth);
			});
	
			// Reset back to 0
			widthPadding = 0;
	
			// Footer width
			ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
			helpers.each(model.footer, maxLineWidth);
	
			// Add padding
			width += 2 * model.xPadding;
	
			return {
				width: width,
				height: height
			};
		}
	
		/**
		 * Helper to get the alignment of a tooltip given the size
		 */
		function determineAlignment(tooltip, size) {
			var model = tooltip._model;
			var chart = tooltip._chart;
			var chartArea = tooltip._chartInstance.chartArea;
			var xAlign = 'center';
			var yAlign = 'center';
	
			if (model.y < size.height) {
				yAlign = 'top';
			} else if (model.y > (chart.height - size.height)) {
				yAlign = 'bottom';
			}
	
			var lf, rf; // functions to determine left, right alignment
			var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
			var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
			var midX = (chartArea.left + chartArea.right) / 2;
			var midY = (chartArea.top + chartArea.bottom) / 2;
	
			if (yAlign === 'center') {
				lf = function(x) {
					return x <= midX;
				};
				rf = function(x) {
					return x > midX;
				};
			} else {
				lf = function(x) {
					return x <= (size.width / 2);
				};
				rf = function(x) {
					return x >= (chart.width - (size.width / 2));
				};
			}
	
			olf = function(x) {
				return x + size.width > chart.width;
			};
			orf = function(x) {
				return x - size.width < 0;
			};
			yf = function(y) {
				return y <= midY ? 'top' : 'bottom';
			};
	
			if (lf(model.x)) {
				xAlign = 'left';
	
				// Is tooltip too wide and goes over the right side of the chart.?
				if (olf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			} else if (rf(model.x)) {
				xAlign = 'right';
	
				// Is tooltip too wide and goes outside left edge of canvas?
				if (orf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			}
	
			var opts = tooltip._options;
			return {
				xAlign: opts.xAlign ? opts.xAlign : xAlign,
				yAlign: opts.yAlign ? opts.yAlign : yAlign
			};
		}
	
		/**
		 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
		 */
		function getBackgroundPoint(vm, size, alignment) {
			// Background Position
			var x = vm.x;
			var y = vm.y;
	
			var caretSize = vm.caretSize,
				caretPadding = vm.caretPadding,
				cornerRadius = vm.cornerRadius,
				xAlign = alignment.xAlign,
				yAlign = alignment.yAlign,
				paddingAndSize = caretSize + caretPadding,
				radiusAndPadding = cornerRadius + caretPadding;
	
			if (xAlign === 'right') {
				x -= size.width;
			} else if (xAlign === 'center') {
				x -= (size.width / 2);
			}
	
			if (yAlign === 'top') {
				y += paddingAndSize;
			} else if (yAlign === 'bottom') {
				y -= size.height + paddingAndSize;
			} else {
				y -= (size.height / 2);
			}
	
			if (yAlign === 'center') {
				if (xAlign === 'left') {
					x += paddingAndSize;
				} else if (xAlign === 'right') {
					x -= paddingAndSize;
				}
			} else if (xAlign === 'left') {
				x -= radiusAndPadding;
			} else if (xAlign === 'right') {
				x += radiusAndPadding;
			}
	
			return {
				x: x,
				y: y
			};
		}
	
		Chart.Tooltip = Chart.Element.extend({
			initialize: function() {
				this._model = getBaseModel(this._options);
			},
	
			// Get the title
			// Args are: (tooltipItem, data)
			getTitle: function() {
				var me = this;
				var opts = me._options;
				var callbacks = opts.callbacks;
	
				var beforeTitle = callbacks.beforeTitle.apply(me, arguments),
					title = callbacks.title.apply(me, arguments),
					afterTitle = callbacks.afterTitle.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeTitle);
				lines = pushOrConcat(lines, title);
				lines = pushOrConcat(lines, afterTitle);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getBeforeBody: function() {
				var lines = this._options.callbacks.beforeBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Args are: (tooltipItem, data)
			getBody: function(tooltipItems, data) {
				var me = this;
				var callbacks = me._options.callbacks;
				var bodyItems = [];
	
				helpers.each(tooltipItems, function(tooltipItem) {
					var bodyItem = {
						before: [],
						lines: [],
						after: []
					};
					pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));
	
					bodyItems.push(bodyItem);
				});
	
				return bodyItems;
			},
	
			// Args are: (tooltipItem, data)
			getAfterBody: function() {
				var lines = this._options.callbacks.afterBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Get the footer and beforeFooter and afterFooter lines
			// Args are: (tooltipItem, data)
			getFooter: function() {
				var me = this;
				var callbacks = me._options.callbacks;
	
				var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
				var footer = callbacks.footer.apply(me, arguments);
				var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeFooter);
				lines = pushOrConcat(lines, footer);
				lines = pushOrConcat(lines, afterFooter);
	
				return lines;
			},
	
			update: function(changed) {
				var me = this;
				var opts = me._options;
	
				// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
				// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
				// which breaks any animations.
				var existingModel = me._model;
				var model = me._model = getBaseModel(opts);
				var active = me._active;
	
				var data = me._data;
				var chartInstance = me._chartInstance;
	
				// In the case where active.length === 0 we need to keep these at existing values for good animations
				var alignment = {
					xAlign: existingModel.xAlign,
					yAlign: existingModel.yAlign
				};
				var backgroundPoint = {
					x: existingModel.x,
					y: existingModel.y
				};
				var tooltipSize = {
					width: existingModel.width,
					height: existingModel.height
				};
				var tooltipPosition = {
					x: existingModel.caretX,
					y: existingModel.caretY
				};
	
				var i, len;
	
				if (active.length) {
					model.opacity = 1;
	
					var labelColors = [];
					tooltipPosition = Chart.Tooltip.positioners[opts.position](active, me._eventPosition);
	
					var tooltipItems = [];
					for (i = 0, len = active.length; i < len; ++i) {
						tooltipItems.push(createTooltipItem(active[i]));
					}
	
					// If the user provided a filter function, use it to modify the tooltip items
					if (opts.filter) {
						tooltipItems = tooltipItems.filter(function(a) {
							return opts.filter(a, data);
						});
					}
	
					// If the user provided a sorting function, use it to modify the tooltip items
					if (opts.itemSort) {
						tooltipItems = tooltipItems.sort(function(a, b) {
							return opts.itemSort(a, b, data);
						});
					}
	
					// Determine colors for boxes
					helpers.each(tooltipItems, function(tooltipItem) {
						labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, chartInstance));
					});
	
					// Build the Text Lines
					model.title = me.getTitle(tooltipItems, data);
					model.beforeBody = me.getBeforeBody(tooltipItems, data);
					model.body = me.getBody(tooltipItems, data);
					model.afterBody = me.getAfterBody(tooltipItems, data);
					model.footer = me.getFooter(tooltipItems, data);
	
					// Initial positioning and colors
					model.x = Math.round(tooltipPosition.x);
					model.y = Math.round(tooltipPosition.y);
					model.caretPadding = helpers.getValueOrDefault(tooltipPosition.padding, 2);
					model.labelColors = labelColors;
	
					// data points
					model.dataPoints = tooltipItems;
	
					// We need to determine alignment of the tooltip
					tooltipSize = getTooltipSize(this, model);
					alignment = determineAlignment(this, tooltipSize);
					// Final Size and Position
					backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment);
				} else {
					model.opacity = 0;
				}
	
				model.xAlign = alignment.xAlign;
				model.yAlign = alignment.yAlign;
				model.x = backgroundPoint.x;
				model.y = backgroundPoint.y;
				model.width = tooltipSize.width;
				model.height = tooltipSize.height;
	
				// Point where the caret on the tooltip points to
				model.caretX = tooltipPosition.x;
				model.caretY = tooltipPosition.y;
	
				me._model = model;
	
				if (changed && opts.custom) {
					opts.custom.call(me, model);
				}
	
				return me;
			},
			drawCaret: function(tooltipPoint, size, opacity) {
				var vm = this._view;
				var ctx = this._chart.ctx;
				var x1, x2, x3;
				var y1, y2, y3;
				var caretSize = vm.caretSize;
				var cornerRadius = vm.cornerRadius;
				var xAlign = vm.xAlign,
					yAlign = vm.yAlign;
				var ptX = tooltipPoint.x,
					ptY = tooltipPoint.y;
				var width = size.width,
					height = size.height;
	
				if (yAlign === 'center') {
					// Left or right side
					if (xAlign === 'left') {
						x1 = ptX;
						x2 = x1 - caretSize;
						x3 = x1;
					} else {
						x1 = ptX + width;
						x2 = x1 + caretSize;
						x3 = x1;
					}
	
					y2 = ptY + (height / 2);
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				} else {
					if (xAlign === 'left') {
						x1 = ptX + cornerRadius;
						x2 = x1 + caretSize;
						x3 = x2 + caretSize;
					} else if (xAlign === 'right') {
						x1 = ptX + width - cornerRadius;
						x2 = x1 - caretSize;
						x3 = x2 - caretSize;
					} else {
						x2 = ptX + (width / 2);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					}
	
					if (yAlign === 'top') {
						y1 = ptY;
						y2 = y1 - caretSize;
						y3 = y1;
					} else {
						y1 = ptY + height;
						y2 = y1 + caretSize;
						y3 = y1;
					}
				}
	
				ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.lineTo(x3, y3);
				ctx.closePath();
				ctx.fill();
			},
			drawTitle: function(pt, vm, ctx, opacity) {
				var title = vm.title;
	
				if (title.length) {
					ctx.textAlign = vm._titleAlign;
					ctx.textBaseline = 'top';
	
					var titleFontSize = vm.titleFontSize,
						titleSpacing = vm.titleSpacing;
	
					ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
					ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
					var i, len;
					for (i = 0, len = title.length; i < len; ++i) {
						ctx.fillText(title[i], pt.x, pt.y);
						pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
						if (i + 1 === title.length) {
							pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
						}
					}
				}
			},
			drawBody: function(pt, vm, ctx, opacity) {
				var bodyFontSize = vm.bodyFontSize;
				var bodySpacing = vm.bodySpacing;
				var body = vm.body;
	
				ctx.textAlign = vm._bodyAlign;
				ctx.textBaseline = 'top';
	
				var textColor = mergeOpacity(vm.bodyFontColor, opacity);
				ctx.fillStyle = textColor;
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
				// Before Body
				var xLinePadding = 0;
				var fillLineOfText = function(line) {
					ctx.fillText(line, pt.x + xLinePadding, pt.y);
					pt.y += bodyFontSize + bodySpacing;
				};
	
				// Before body lines
				helpers.each(vm.beforeBody, fillLineOfText);
	
				var drawColorBoxes = vm.displayColors;
				xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;
	
				// Draw body lines now
				helpers.each(body, function(bodyItem, i) {
					helpers.each(bodyItem.before, fillLineOfText);
	
					helpers.each(bodyItem.lines, function(line) {
						// Draw Legend-like boxes if needed
						if (drawColorBoxes) {
							// Fill a white rect so that colours merge nicely if the opacity is < 1
							ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
							ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Border
							ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
							ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Inner square
							ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
							ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
	
							ctx.fillStyle = textColor;
						}
	
						fillLineOfText(line);
					});
	
					helpers.each(bodyItem.after, fillLineOfText);
				});
	
				// Reset back to 0 for after body
				xLinePadding = 0;
	
				// After body lines
				helpers.each(vm.afterBody, fillLineOfText);
				pt.y -= bodySpacing; // Remove last body spacing
			},
			drawFooter: function(pt, vm, ctx, opacity) {
				var footer = vm.footer;
	
				if (footer.length) {
					pt.y += vm.footerMarginTop;
	
					ctx.textAlign = vm._footerAlign;
					ctx.textBaseline = 'top';
	
					ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
					ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
					helpers.each(footer, function(line) {
						ctx.fillText(line, pt.x, pt.y);
						pt.y += vm.footerFontSize + vm.footerSpacing;
					});
				}
			},
			drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
				ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
				helpers.drawRoundedRectangle(ctx, pt.x, pt.y, tooltipSize.width, tooltipSize.height, vm.cornerRadius);
				ctx.fill();
			},
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				if (vm.opacity === 0) {
					return;
				}
	
				var tooltipSize = {
					width: vm.width,
					height: vm.height
				};
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				// IE11/Edge does not like very small opacities, so snap to 0
				var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
				if (this._options.enabled) {
					// Draw Background
					this.drawBackground(pt, vm, ctx, tooltipSize, opacity);
	
					// Draw Caret
					this.drawCaret(pt, tooltipSize, opacity);
	
					// Draw Title, Body, and Footer
					pt.x += vm.xPadding;
					pt.y += vm.yPadding;
	
					// Titles
					this.drawTitle(pt, vm, ctx, opacity);
	
					// Body
					this.drawBody(pt, vm, ctx, opacity);
	
					// Footer
					this.drawFooter(pt, vm, ctx, opacity);
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @returns {Boolean} true if the tooltip changed
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me._options;
				var changed = false;
	
				me._lastActive = me._lastActive || [];
	
				// Find Active Elements for tooltips
				if (e.type === 'mouseout') {
					me._active = [];
				} else {
					me._active = me._chartInstance.getElementsAtEventForMode(e, options.mode, options);
				}
	
				// Remember Last Actives
				changed = !helpers.arrayEquals(me._active, me._lastActive);
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					var model = me._model;
					me.update(true);
					me.pivot();
	
					// See if our tooltip position changed
					changed |= (model.x !== me._model.x) || (model.y !== me._model.y);
				}
	
				return changed;
			}
		});
	
		/**
		 * @namespace Chart.Tooltip.positioners
		 */
		Chart.Tooltip.positioners = {
			/**
			 * Average mode places the tooltip at the average position of the elements shown
			 * @function Chart.Tooltip.positioners.average
			 * @param elements {ChartElement[]} the elements being displayed in the tooltip
			 * @returns {Point} tooltip position
			 */
			average: function(elements) {
				if (!elements.length) {
					return false;
				}
	
				var i, len;
				var x = 0;
				var y = 0;
				var count = 0;
	
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var pos = el.tooltipPosition();
						x += pos.x;
						y += pos.y;
						++count;
					}
				}
	
				return {
					x: Math.round(x / count),
					y: Math.round(y / count)
				};
			},
	
			/**
			 * Gets the tooltip position nearest of the item nearest to the event position
			 * @function Chart.Tooltip.positioners.nearest
			 * @param elements {Chart.Element[]} the tooltip elements
			 * @param eventPosition {Point} the position of the event in canvas coordinates
			 * @returns {Point} the tooltip position
			 */
			nearest: function(elements, eventPosition) {
				var x = eventPosition.x;
				var y = eventPosition.y;
	
				var nearestElement;
				var minDistance = Number.POSITIVE_INFINITY;
				var i, len;
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var center = el.getCenterPoint();
						var d = helpers.distanceBetweenPoints(eventPosition, center);
	
						if (d < minDistance) {
							minDistance = d;
							nearestElement = el;
						}
					}
				}
	
				if (nearestElement) {
					var tp = nearestElement.tooltipPosition();
					x = tp.x;
					y = tp.y;
				}
	
				return {
					x: x,
					y: y
				};
			}
		};
	};


/***/ },
/* 2443 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global;
	
		globalOpts.elements.arc = {
			backgroundColor: globalOpts.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		};
	
		Chart.elements.Arc = Chart.Element.extend({
			inLabelRange: function(mouseX) {
				var vm = this._view;
	
				if (vm) {
					return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
				}
				return false;
			},
			inRange: function(chartX, chartY) {
				var vm = this._view;
	
				if (vm) {
					var pointRelativePosition = helpers.getAngleFromPoint(vm, {
							x: chartX,
							y: chartY
						}),
						angle = pointRelativePosition.angle,
						distance = pointRelativePosition.distance;
	
					// Sanitise angle range
					var startAngle = vm.startAngle;
					var endAngle = vm.endAngle;
					while (endAngle < startAngle) {
						endAngle += 2.0 * Math.PI;
					}
					while (angle > endAngle) {
						angle -= 2.0 * Math.PI;
					}
					while (angle < startAngle) {
						angle += 2.0 * Math.PI;
					}
	
					// Check if within the range of the open/close angle
					var betweenAngles = (angle >= startAngle && angle <= endAngle),
						withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
					return (betweenAngles && withinRadius);
				}
				return false;
			},
			getCenterPoint: function() {
				var vm = this._view;
				var halfAngle = (vm.startAngle + vm.endAngle) / 2;
				var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
				return {
					x: vm.x + Math.cos(halfAngle) * halfRadius,
					y: vm.y + Math.sin(halfAngle) * halfRadius
				};
			},
			getArea: function() {
				var vm = this._view;
				return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
			},
			tooltipPosition: function() {
				var vm = this._view;
	
				var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2),
					rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
				return {
					x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
					y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
				};
			},
			draw: function() {
	
				var ctx = this._chart.ctx,
					vm = this._view,
					sA = vm.startAngle,
					eA = vm.endAngle;
	
				ctx.beginPath();
	
				ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
				ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
	
				ctx.closePath();
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = vm.borderWidth;
	
				ctx.fillStyle = vm.backgroundColor;
	
				ctx.fill();
				ctx.lineJoin = 'bevel';
	
				if (vm.borderWidth) {
					ctx.stroke();
				}
			}
		});
	};


/***/ },
/* 2444 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		Chart.defaults.global.elements.line = {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		};
	
		Chart.elements.Line = Chart.Element.extend({
			draw: function() {
				var me = this;
				var vm = me._view;
				var spanGaps = vm.spanGaps;
				var fillPoint = vm.scaleZero;
				var loop = me._loop;
	
				// Handle different fill modes for cartesian lines
				if (!loop) {
					if (vm.fill === 'top') {
						fillPoint = vm.scaleTop;
					} else if (vm.fill === 'bottom') {
						fillPoint = vm.scaleBottom;
					}
				}
	
				var ctx = me._chart.ctx;
				ctx.save();
	
				// Helper function to draw a line to a point
				function lineToPoint(previousPoint, point) {
					var pointVM = point._view;
					if (point._view.steppedLine === true) {
						ctx.lineTo(pointVM.x, previousPoint._view.y);
						ctx.lineTo(pointVM.x, pointVM.y);
					} else if (point._view.tension === 0) {
						ctx.lineTo(pointVM.x, pointVM.y);
					} else {
						ctx.bezierCurveTo(
							previousPoint._view.controlPointNextX,
							previousPoint._view.controlPointNextY,
							pointVM.controlPointPreviousX,
							pointVM.controlPointPreviousY,
							pointVM.x,
							pointVM.y
						);
					}
				}
	
				var points = me._children.slice(); // clone array
				var lastDrawnIndex = -1;
	
				// If we are looping, adding the first point again
				if (loop && points.length) {
					points.push(points[0]);
				}
	
				var index, current, previous, currentVM;
	
				// Fill Line
				if (points.length && vm.fill) {
					ctx.beginPath();
	
					for (index = 0; index < points.length; ++index) {
						current = points[index];
						previous = helpers.previousItem(points, index);
						currentVM = current._view;
	
						// First point moves to it's starting position no matter what
						if (index === 0) {
							if (loop) {
								ctx.moveTo(fillPoint.x, fillPoint.y);
							} else {
								ctx.moveTo(currentVM.x, fillPoint);
							}
	
							if (!currentVM.skip) {
								lastDrawnIndex = index;
								ctx.lineTo(currentVM.x, currentVM.y);
							}
						} else {
							previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
							if (currentVM.skip) {
								// Only do this if this is the first point that is skipped
								if (!spanGaps && lastDrawnIndex === (index - 1)) {
									if (loop) {
										ctx.lineTo(fillPoint.x, fillPoint.y);
									} else {
										ctx.lineTo(previous._view.x, fillPoint);
									}
								}
							} else {
								if (lastDrawnIndex !== (index - 1)) {
									// There was a gap and this is the first point after the gap. If we've never drawn a point, this is a special case.
									// If the first data point is NaN, then there is no real gap to skip
									if (spanGaps && lastDrawnIndex !== -1) {
										// We are spanning the gap, so simple draw a line to this point
										lineToPoint(previous, current);
									} else if (loop) {
										ctx.lineTo(currentVM.x, currentVM.y);
									} else {
										ctx.lineTo(currentVM.x, fillPoint);
										ctx.lineTo(currentVM.x, currentVM.y);
									}
								} else {
									// Line to next point
									lineToPoint(previous, current);
								}
								lastDrawnIndex = index;
							}
						}
					}
	
					if (!loop && lastDrawnIndex !== -1) {
						ctx.lineTo(points[lastDrawnIndex]._view.x, fillPoint);
					}
	
					ctx.fillStyle = vm.backgroundColor || globalDefaults.defaultColor;
					ctx.closePath();
					ctx.fill();
				}
	
				// Stroke Line Options
				var globalOptionLineElements = globalDefaults.elements.line;
				ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
				// IE 9 and 10 do not support line dash
				if (ctx.setLineDash) {
					ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
				}
	
				ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
				ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
				ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
				ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
				// Stroke Line
				ctx.beginPath();
				lastDrawnIndex = -1;
	
				for (index = 0; index < points.length; ++index) {
					current = points[index];
					previous = helpers.previousItem(points, index);
					currentVM = current._view;
	
					// First point moves to it's starting position no matter what
					if (index === 0) {
						if (!currentVM.skip) {
							ctx.moveTo(currentVM.x, currentVM.y);
							lastDrawnIndex = index;
						}
					} else {
						previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
						if (!currentVM.skip) {
							if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
								// There was a gap and this is the first point after the gap
								ctx.moveTo(currentVM.x, currentVM.y);
							} else {
								// Line to next point
								lineToPoint(previous, current);
							}
							lastDrawnIndex = index;
						}
					}
				}
	
				ctx.stroke();
				ctx.restore();
			}
		});
	};


/***/ },
/* 2445 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global,
			defaultColor = globalOpts.defaultColor;
	
		globalOpts.elements.point = {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderWidth: 1,
			borderColor: defaultColor,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		};
	
		function xRange(mouseX) {
			var vm = this._view;
			return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
		}
	
		function yRange(mouseY) {
			var vm = this._view;
			return vm ? (Math.pow(mouseY - vm.y, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
		}
	
		Chart.elements.Point = Chart.Element.extend({
			inRange: function(mouseX, mouseY) {
				var vm = this._view;
				return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
			},
	
			inLabelRange: xRange,
			inXRange: xRange,
			inYRange: yRange,
	
			getCenterPoint: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y
				};
			},
			getArea: function() {
				return Math.PI * Math.pow(this._view.radius, 2);
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y,
					padding: vm.radius + vm.borderWidth
				};
			},
			draw: function(chartArea) {
				var vm = this._view;
				var model = this._model;
				var ctx = this._chart.ctx;
				var pointStyle = vm.pointStyle;
				var radius = vm.radius;
				var x = vm.x;
				var y = vm.y;
				var color = Chart.helpers.color;
				var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
				var ratio = 0;
	
				if (vm.skip) {
					return;
				}
	
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = helpers.getValueOrDefault(vm.borderWidth, globalOpts.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
	
				// Cliping for Points.
				// going out from inner charArea?
				if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right*errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom*errMargin < model.y))) {
					// Point fade out
					if (model.x < chartArea.left) {
						ratio = (x - model.x) / (chartArea.left - model.x);
					} else if (chartArea.right*errMargin < model.x) {
						ratio = (model.x - x) / (model.x - chartArea.right);
					} else if (model.y < chartArea.top) {
						ratio = (y - model.y) / (chartArea.top - model.y);
					} else if (chartArea.bottom*errMargin < model.y) {
						ratio = (model.y - y) / (model.y - chartArea.bottom);
					}
					ratio = Math.round(ratio*100) / 100;
					ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
					ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
				}
	
				Chart.canvasHelpers.drawPoint(ctx, pointStyle, radius, x, y);
			}
		});
	};


/***/ },
/* 2446 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var globalOpts = Chart.defaults.global;
	
		globalOpts.elements.rectangle = {
			backgroundColor: globalOpts.defaultColor,
			borderWidth: 0,
			borderColor: globalOpts.defaultColor,
			borderSkipped: 'bottom'
		};
	
		function isVertical(bar) {
			return bar._view.width !== undefined;
		}
	
		/**
		 * Helper function to get the bounds of the bar regardless of the orientation
		 * @private
		 * @param bar {Chart.Element.Rectangle} the bar
		 * @return {Bounds} bounds of the bar
		 */
		function getBarBounds(bar) {
			var vm = bar._view;
			var x1, x2, y1, y2;
	
			if (isVertical(bar)) {
				// vertical
				var halfWidth = vm.width / 2;
				x1 = vm.x - halfWidth;
				x2 = vm.x + halfWidth;
				y1 = Math.min(vm.y, vm.base);
				y2 = Math.max(vm.y, vm.base);
			} else {
				// horizontal bar
				var halfHeight = vm.height / 2;
				x1 = Math.min(vm.x, vm.base);
				x2 = Math.max(vm.x, vm.base);
				y1 = vm.y - halfHeight;
				y2 = vm.y + halfHeight;
			}
	
			return {
				left: x1,
				top: y1,
				right: x2,
				bottom: y2
			};
		}
	
		Chart.elements.Rectangle = Chart.Element.extend({
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
				var left, right, top, bottom, signX, signY, borderSkipped;
				var borderWidth = vm.borderWidth;
	
				if (!vm.horizontal) {
					// bar
					left = vm.x - vm.width / 2;
					right = vm.x + vm.width / 2;
					top = vm.y;
					bottom = vm.base;
					signX = 1;
					signY = bottom > top? 1: -1;
					borderSkipped = vm.borderSkipped || 'bottom';
				} else {
					// horizontal bar
					left = vm.base;
					right = vm.x;
					top = vm.y - vm.height / 2;
					bottom = vm.y + vm.height / 2;
					signX = right > left? 1: -1;
					signY = 1;
					borderSkipped = vm.borderSkipped || 'left';
				}
	
				// Canvas doesn't allow us to stroke inside the width so we can
				// adjust the sizes to fit if we're setting a stroke on the line
				if (borderWidth) {
					// borderWidth shold be less than bar width and bar height.
					var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
					borderWidth = borderWidth > barSize? barSize: borderWidth;
					var halfStroke = borderWidth / 2;
					// Adjust borderWidth when bar top position is near vm.base(zero).
					var borderLeft = left + (borderSkipped !== 'left'? halfStroke * signX: 0);
					var borderRight = right + (borderSkipped !== 'right'? -halfStroke * signX: 0);
					var borderTop = top + (borderSkipped !== 'top'? halfStroke * signY: 0);
					var borderBottom = bottom + (borderSkipped !== 'bottom'? -halfStroke * signY: 0);
					// not become a vertical line?
					if (borderLeft !== borderRight) {
						top = borderTop;
						bottom = borderBottom;
					}
					// not become a horizontal line?
					if (borderTop !== borderBottom) {
						left = borderLeft;
						right = borderRight;
					}
				}
	
				ctx.beginPath();
				ctx.fillStyle = vm.backgroundColor;
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = borderWidth;
	
				// Corner points, from bottom-left to bottom-right clockwise
				// | 1 2 |
				// | 0 3 |
				var corners = [
					[left, bottom],
					[left, top],
					[right, top],
					[right, bottom]
				];
	
				// Find first (starting) corner with fallback to 'bottom'
				var borders = ['bottom', 'left', 'top', 'right'];
				var startCorner = borders.indexOf(borderSkipped, 0);
				if (startCorner === -1) {
					startCorner = 0;
				}
	
				function cornerAt(index) {
					return corners[(startCorner + index) % 4];
				}
	
				// Draw rectangle from 'startCorner'
				var corner = cornerAt(0);
				ctx.moveTo(corner[0], corner[1]);
	
				for (var i = 1; i < 4; i++) {
					corner = cornerAt(i);
					ctx.lineTo(corner[0], corner[1]);
				}
	
				ctx.fill();
				if (borderWidth) {
					ctx.stroke();
				}
			},
			height: function() {
				var vm = this._view;
				return vm.base - vm.y;
			},
			inRange: function(mouseX, mouseY) {
				var inRange = false;
	
				if (this._view) {
					var bounds = getBarBounds(this);
					inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
				}
	
				return inRange;
			},
			inLabelRange: function(mouseX, mouseY) {
				var me = this;
				if (!me._view) {
					return false;
				}
	
				var inRange = false;
				var bounds = getBarBounds(me);
	
				if (isVertical(me)) {
					inRange = mouseX >= bounds.left && mouseX <= bounds.right;
				} else {
					inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
				}
	
				return inRange;
			},
			inXRange: function(mouseX) {
				var bounds = getBarBounds(this);
				return mouseX >= bounds.left && mouseX <= bounds.right;
			},
			inYRange: function(mouseY) {
				var bounds = getBarBounds(this);
				return mouseY >= bounds.top && mouseY <= bounds.bottom;
			},
			getCenterPoint: function() {
				var vm = this._view;
				var x, y;
				if (isVertical(this)) {
					x = vm.x;
					y = (vm.y + vm.base) / 2;
				} else {
					x = (vm.x + vm.base) / 2;
					y = vm.y;
				}
	
				return {x: x, y: y};
			},
			getArea: function() {
				var vm = this._view;
				return vm.width * Math.abs(vm.y - vm.base);
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y
				};
			}
		});
	
	};


/***/ },
/* 2447 */
/***/ function(module, exports) {

	'use strict';
	
	// Chart.Platform implementation for targeting a web browser
	module.exports = function(Chart) {
		var helpers = Chart.helpers;
	
		// DOM event types -> Chart.js event types.
		// Note: only events with different types are mapped.
		// https://developer.mozilla.org/en-US/docs/Web/Events
		var eventTypeMap = {
			// Touch events
			touchstart: 'mousedown',
			touchmove: 'mousemove',
			touchend: 'mouseup',
	
			// Pointer events
			pointerenter: 'mouseenter',
			pointerdown: 'mousedown',
			pointermove: 'mousemove',
			pointerup: 'mouseup',
			pointerleave: 'mouseout',
			pointerout: 'mouseout'
		};
	
		/**
		 * The "used" size is the final value of a dimension property after all calculations have
		 * been performed. This method uses the computed style of `element` but returns undefined
		 * if the computed style is not expressed in pixels. That can happen in some cases where
		 * `element` has a size relative to its parent and this last one is not yet displayed,
		 * for example because of `display: none` on a parent node.
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
		 * @returns {Number} Size in pixels or undefined if unknown.
		 */
		function readUsedSize(element, property) {
			var value = helpers.getStyle(element, property);
			var matches = value && value.match(/(\d+)px/);
			return matches? Number(matches[1]) : undefined;
		}
	
		/**
		 * Initializes the canvas style and render size without modifying the canvas display size,
		 * since responsiveness is handled by the controller.resize() method. The config is used
		 * to determine the aspect ratio to apply in case no explicit height has been specified.
		 */
		function initCanvas(canvas, config) {
			var style = canvas.style;
	
			// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
			// returns null or '' if no explicit value has been set to the canvas attribute.
			var renderHeight = canvas.getAttribute('height');
			var renderWidth = canvas.getAttribute('width');
	
			// Chart.js modifies some canvas values that we want to restore on destroy
			canvas._chartjs = {
				initial: {
					height: renderHeight,
					width: renderWidth,
					style: {
						display: style.display,
						height: style.height,
						width: style.width
					}
				}
			};
	
			// Force canvas to display as block to avoid extra space caused by inline
			// elements, which would interfere with the responsive resize process.
			// https://github.com/chartjs/Chart.js/issues/2538
			style.display = style.display || 'block';
	
			if (renderWidth === null || renderWidth === '') {
				var displayWidth = readUsedSize(canvas, 'width');
				if (displayWidth !== undefined) {
					canvas.width = displayWidth;
				}
			}
	
			if (renderHeight === null || renderHeight === '') {
				if (canvas.style.height === '') {
					// If no explicit render height and style height, let's apply the aspect ratio,
					// which one can be specified by the user but also by charts as default option
					// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
					canvas.height = canvas.width / (config.options.aspectRatio || 2);
				} else {
					var displayHeight = readUsedSize(canvas, 'height');
					if (displayWidth !== undefined) {
						canvas.height = displayHeight;
					}
				}
			}
	
			return canvas;
		}
	
		function createEvent(type, chart, x, y, native) {
			return {
				type: type,
				chart: chart,
				native: native || null,
				x: x !== undefined? x : null,
				y: y !== undefined? y : null,
			};
		}
	
		function fromNativeEvent(event, chart) {
			var type = eventTypeMap[event.type] || event.type;
			var pos = helpers.getRelativePosition(event, chart);
			return createEvent(type, chart, pos.x, pos.y, event);
		}
	
		function createResizer(handler) {
			var iframe = document.createElement('iframe');
			iframe.className = 'chartjs-hidden-iframe';
			iframe.style.cssText =
				'display:block;'+
				'overflow:hidden;'+
				'border:0;'+
				'margin:0;'+
				'top:0;'+
				'left:0;'+
				'bottom:0;'+
				'right:0;'+
				'height:100%;'+
				'width:100%;'+
				'position:absolute;'+
				'pointer-events:none;'+
				'z-index:-1;';
	
			// Prevent the iframe to gain focus on tab.
			// https://github.com/chartjs/Chart.js/issues/3090
			iframe.tabIndex = -1;
	
			// If the iframe is re-attached to the DOM, the resize listener is removed because the
			// content is reloaded, so make sure to install the handler after the iframe is loaded.
			// https://github.com/chartjs/Chart.js/issues/3521
			helpers.addEvent(iframe, 'load', function() {
				helpers.addEvent(iframe.contentWindow || iframe, 'resize', handler);
	
				// The iframe size might have changed while loading, which can also
				// happen if the size has been changed while detached from the DOM.
				handler();
			});
	
			return iframe;
		}
	
		function addResizeListener(node, listener, chart) {
			var stub = node._chartjs = {
				ticking: false
			};
	
			// Throttle the callback notification until the next animation frame.
			var notify = function() {
				if (!stub.ticking) {
					stub.ticking = true;
					helpers.requestAnimFrame.call(window, function() {
						if (stub.resizer) {
							stub.ticking = false;
							return listener(createEvent('resize', chart));
						}
					});
				}
			};
	
			// Let's keep track of this added iframe and thus avoid DOM query when removing it.
			stub.resizer = createResizer(notify);
	
			node.insertBefore(stub.resizer, node.firstChild);
		}
	
		function removeResizeListener(node) {
			if (!node || !node._chartjs) {
				return;
			}
	
			var resizer = node._chartjs.resizer;
			if (resizer) {
				resizer.parentNode.removeChild(resizer);
				node._chartjs.resizer = null;
			}
	
			delete node._chartjs;
		}
	
		return {
			acquireContext: function(item, config) {
				if (typeof item === 'string') {
					item = document.getElementById(item);
				} else if (item.length) {
					// Support for array based queries (such as jQuery)
					item = item[0];
				}
	
				if (item && item.canvas) {
					// Support for any object associated to a canvas (including a context2d)
					item = item.canvas;
				}
	
				if (item instanceof HTMLCanvasElement) {
					// To prevent canvas fingerprinting, some add-ons undefine the getContext
					// method, for example: https://github.com/kkapsner/CanvasBlocker
					// https://github.com/chartjs/Chart.js/issues/2807
					var context = item.getContext && item.getContext('2d');
					if (context instanceof CanvasRenderingContext2D) {
						initCanvas(item, config);
						return context;
					}
				}
	
				return null;
			},
	
			releaseContext: function(context) {
				var canvas = context.canvas;
				if (!canvas._chartjs) {
					return;
				}
	
				var initial = canvas._chartjs.initial;
				['height', 'width'].forEach(function(prop) {
					var value = initial[prop];
					if (value === undefined || value === null) {
						canvas.removeAttribute(prop);
					} else {
						canvas.setAttribute(prop, value);
					}
				});
	
				helpers.each(initial.style || {}, function(value, key) {
					canvas.style[key] = value;
				});
	
				// The canvas render size might have been changed (and thus the state stack discarded),
				// we can't use save() and restore() to restore the initial state. So make sure that at
				// least the canvas context is reset to the default state by setting the canvas width.
				// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
				canvas.width = canvas.width;
	
				delete canvas._chartjs;
			},
	
			addEventListener: function(chart, type, listener) {
				var canvas = chart.chart.canvas;
				if (type === 'resize') {
					// Note: the resize event is not supported on all browsers.
					addResizeListener(canvas.parentNode, listener, chart.chart);
					return;
				}
	
				var stub = listener._chartjs || (listener._chartjs = {});
				var proxies = stub.proxies || (stub.proxies = {});
				var proxy = proxies[chart.id + '_' + type] = function(event) {
					listener(fromNativeEvent(event, chart.chart));
				};
	
				helpers.addEvent(canvas, type, proxy);
			},
	
			removeEventListener: function(chart, type, listener) {
				var canvas = chart.chart.canvas;
				if (type === 'resize') {
					// Note: the resize event is not supported on all browsers.
					removeResizeListener(canvas.parentNode, listener);
					return;
				}
	
				var stub = listener._chartjs || {};
				var proxies = stub.proxies || {};
				var proxy = proxies[chart.id + '_' + type];
				if (!proxy) {
					return;
				}
	
				helpers.removeEvent(canvas, type, proxy);
			}
		};
	};


/***/ },
/* 2448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// By default, select the browser (DOM) platform.
	// @TODO Make possible to select another platform at build time.
	var implementation = __webpack_require__(2447);
	
	module.exports = function(Chart) {
		/**
		 * @namespace Chart.platform
		 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
		 * @since 2.4.0
		 */
		Chart.platform = {
			/**
			 * Called at chart construction time, returns a context2d instance implementing
			 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
			 * @param {*} item - The native item from which to acquire context (platform specific)
			 * @param {Object} options - The chart options
			 * @returns {CanvasRenderingContext2D} context2d instance
			 */
			acquireContext: function() {},
	
			/**
			 * Called at chart destruction time, releases any resources associated to the context
			 * previously returned by the acquireContext() method.
			 * @param {CanvasRenderingContext2D} context - The context2d instance
			 * @returns {Boolean} true if the method succeeded, else false
			 */
			releaseContext: function() {},
	
			/**
			 * Registers the specified listener on the given chart.
			 * @param {Chart} chart - Chart from which to listen for event
			 * @param {String} type - The ({@link IEvent}) type to listen for
			 * @param {Function} listener - Receives a notification (an object that implements
			 * the {@link IEvent} interface) when an event of the specified type occurs.
			 */
			addEventListener: function() {},
	
			/**
			 * Removes the specified listener previously registered with addEventListener.
			 * @param {Chart} chart -Chart from which to remove the listener
			 * @param {String} type - The ({@link IEvent}) type to remove
			 * @param {Function} listener - The listener function to remove from the event target.
			 */
			removeEventListener: function() {}
		};
	
		/**
		 * @interface IPlatform
		 * Allows abstracting platform dependencies away from the chart
		 * @borrows Chart.platform.acquireContext as acquireContext
		 * @borrows Chart.platform.releaseContext as releaseContext
		 * @borrows Chart.platform.addEventListener as addEventListener
		 * @borrows Chart.platform.removeEventListener as removeEventListener
		 */
	
		/**
		 * @interface IEvent
		 * @prop {String} type - The event type name, possible values are:
		 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
		 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
		 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
		 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
		 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
		 */
	
		Chart.helpers.extend(Chart.platform, implementation(Chart));
	};


/***/ },
/* 2449 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		// Default config for a category scale
		var defaultConfig = {
			position: 'bottom'
		};
	
		var DatasetScale = Chart.Scale.extend({
			/**
			* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
			* else fall back to data.labels
			* @private
			*/
			getLabels: function() {
				var data = this.chart.data;
				return (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
			},
			// Implement this so that
			determineDataLimits: function() {
				var me = this;
				var labels = me.getLabels();
				me.minIndex = 0;
				me.maxIndex = labels.length - 1;
				var findIndex;
	
				if (me.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = helpers.indexOf(labels, me.options.ticks.min);
					me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
				}
	
				if (me.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = helpers.indexOf(labels, me.options.ticks.max);
					me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
				}
	
				me.min = labels[me.minIndex];
				me.max = labels[me.maxIndex];
			},
	
			buildTicks: function() {
				var me = this;
				var labels = me.getLabels();
				// If we are viewing some subset of labels, slice the original array
				me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var isHorizontal = me.isHorizontal();
	
				if (data.yLabels && !isHorizontal) {
					return me.getRightValue(data.datasets[datasetIndex].data[index]);
				}
				return me.ticks[index - me.minIndex];
			},
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index, datasetIndex, includeOffset) {
				var me = this;
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
	
				if (value !== undefined && isNaN(index)) {
					var labels = me.getLabels();
					var idx = labels.indexOf(value);
					index = idx !== -1 ? idx : index;
				}
	
				if (me.isHorizontal()) {
					var valueWidth = me.width / offsetAmt;
					var widthOffset = (valueWidth * (index - me.minIndex));
	
					if (me.options.gridLines.offsetGridLines && includeOffset || me.maxIndex === me.minIndex && includeOffset) {
						widthOffset += (valueWidth / 2);
					}
	
					return me.left + Math.round(widthOffset);
				}
				var valueHeight = me.height / offsetAmt;
				var heightOffset = (valueHeight * (index - me.minIndex));
	
				if (me.options.gridLines.offsetGridLines && includeOffset) {
					heightOffset += (valueHeight / 2);
				}
	
				return me.top + Math.round(heightOffset);
			},
			getPixelForTick: function(index, includeOffset) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null, includeOffset);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var value;
				var offsetAmt = Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
				var horz = me.isHorizontal();
				var valueDimension = (horz ? me.width : me.height) / offsetAmt;
	
				pixel -= horz ? me.left : me.top;
	
				if (me.options.gridLines.offsetGridLines) {
					pixel -= (valueDimension / 2);
				}
	
				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}
	
				return value;
			},
			getBasePixel: function() {
				return this.bottom;
			}
		});
	
		Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);
	
	};


/***/ },
/* 2450 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
			ticks: {
				callback: Chart.Ticks.formatters.linear
			}
		};
	
		var LinearScale = Chart.LinearScaleBase.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
	
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// First Calculate the range
				me.min = null;
				me.max = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = {
								positiveValues: [],
								negativeValues: []
							};
						}
	
						// Store these per type
						var positiveValues = valuesPerStack[key].positiveValues;
						var negativeValues = valuesPerStack[key].negativeValues;
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;
	
								if (opts.relativePoints) {
									positiveValues[index] = 100;
								} else if (value < 0) {
									negativeValues[index] += value;
								} else {
									positiveValues[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers.min(values);
						var maxVal = helpers.max(values);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
							});
						}
					});
				}
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				this.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var maxTicks;
				var me = this;
				var tickOpts = me.options.ticks;
	
				if (me.isHorizontal()) {
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, Chart.defaults.global.defaultFontSize);
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
				}
	
				return maxTicks;
			},
			// Called after the ticks are built. We need
			handleDirectionalChanges: function() {
				if (!this.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			// Utils
			getPixelForValue: function(value) {
				// This must be called after fit has been run so that
				// this.left, this.top, this.right, and this.bottom have been defined
				var me = this;
				var start = me.start;
	
				var rightValue = +me.getRightValue(value);
				var pixel;
				var range = me.end - start;
	
				if (me.isHorizontal()) {
					pixel = me.left + (me.width / range * (rightValue - start));
					return Math.round(pixel);
				}
	
				pixel = me.bottom - (me.height / range * (rightValue - start));
				return Math.round(pixel);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var isHorizontal = me.isHorizontal();
				var innerDimension = isHorizontal ? me.width : me.height;
				var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
				return me.start + ((me.end - me.start) * offset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticksAsNumbers[index]);
			}
		});
		Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);
	
	};


/***/ },
/* 2451 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			noop = helpers.noop;
	
		Chart.LinearScaleBase = Chart.Scale.extend({
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (tickOpts.beginAtZero) {
					var minSign = helpers.sign(me.min);
					var maxSign = helpers.sign(me.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						me.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the bottom down to 0
						me.min = 0;
					}
				}
	
				if (tickOpts.min !== undefined) {
					me.min = tickOpts.min;
				} else if (tickOpts.suggestedMin !== undefined) {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
	
				if (tickOpts.max !== undefined) {
					me.max = tickOpts.max;
				} else if (tickOpts.suggestedMax !== undefined) {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
	
				if (me.min === me.max) {
					me.max++;
	
					if (!tickOpts.beginAtZero) {
						me.min--;
					}
				}
			},
			getTickLimit: noop,
			handleDirectionalChanges: noop,
	
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph. Make sure we always have at least 2 ticks
				var maxTicks = me.getTickLimit();
				maxTicks = Math.max(2, maxTicks);
	
				var numericGeneratorOptions = {
					maxTicks: maxTicks,
					min: tickOpts.min,
					max: tickOpts.max,
					stepSize: helpers.getValueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
				};
				var ticks = me.ticks = Chart.Ticks.generators.linear(numericGeneratorOptions, me);
	
				me.handleDirectionalChanges();
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsNumbers = me.ticks.slice();
				me.zeroLineIndex = me.ticks.indexOf(0);
	
				Chart.Scale.prototype.convertTicksToLabels.call(me);
			}
		});
	};


/***/ },
/* 2452 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
	
			// label settings
			ticks: {
				callback: Chart.Ticks.formatters.logarithmic
			}
		};
	
		var LogarithmicScale = Chart.Scale.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var getValueOrDefault = helpers.getValueOrDefault;
				var isHorizontal = me.isHorizontal();
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// Calculate Range
				me.min = null;
				me.max = null;
				me.minNotZero = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							if (valuesPerStack[key] === undefined) {
								valuesPerStack[key] = [];
							}
	
							helpers.each(dataset.data, function(rawValue, index) {
								var values = valuesPerStack[key];
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								values[index] = values[index] || 0;
	
								if (opts.relativePoints) {
									values[index] = 100;
								} else {
									// Don't need to split positive and negative since the log scale can't handle a 0 crossing
									values[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
	
								if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
									me.minNotZero = value;
								}
							});
						}
					});
				}
	
				me.min = getValueOrDefault(tickOpts.min, me.min);
				me.max = getValueOrDefault(tickOpts.max, me.max);
	
				if (me.min === me.max) {
					if (me.min !== 0 && me.min !== null) {
						me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
						me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
					} else {
						me.min = 1;
						me.max = 10;
					}
				}
			},
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				var generationOptions = {
					min: tickOpts.min,
					max: tickOpts.max
				};
				var ticks = me.ticks = Chart.Ticks.generators.logarithmic(generationOptions, me);
	
				if (!me.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					ticks.reverse();
				}
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickValues[index]);
			},
			getPixelForValue: function(value) {
				var me = this;
				var innerDimension;
				var pixel;
	
				var start = me.start;
				var newVal = +me.getRightValue(value);
				var range;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				if (me.isHorizontal()) {
					range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
					if (newVal === 0) {
						pixel = me.left;
					} else {
						innerDimension = me.width;
						pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				} else {
					// Bottom - top since pixels increase downward on a screen
					innerDimension = me.height;
					if (start === 0 && !tickOpts.reverse) {
						range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
						if (newVal === start) {
							pixel = me.bottom;
						} else if (newVal === me.minNotZero) {
							pixel = me.bottom - innerDimension * 0.02;
						} else {
							pixel = me.bottom - innerDimension * 0.02 - (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else if (me.end === 0 && tickOpts.reverse) {
						range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
						if (newVal === me.end) {
							pixel = me.top;
						} else if (newVal === me.minNotZero) {
							pixel = me.top + innerDimension * 0.02;
						} else {
							pixel = me.top + innerDimension * 0.02 + (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else {
						range = helpers.log10(me.end) - helpers.log10(start);
						innerDimension = me.height;
						pixel = me.bottom - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var range = helpers.log10(me.end) - helpers.log10(me.start);
				var value, innerDimension;
	
				if (me.isHorizontal()) {
					innerDimension = me.width;
					value = me.start * Math.pow(10, (pixel - me.left) * range / innerDimension);
				} else {  // todo: if start === 0
					innerDimension = me.height;
					value = Math.pow(10, (me.bottom - pixel) * range / innerDimension) / me.start;
				}
				return value;
			}
		});
		Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
	
	};


/***/ },
/* 2453 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		var defaultConfig = {
			display: true,
	
			// Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			lineArc: false,
			position: 'chartArea',
	
			angleLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1
			},
	
			// label settings
			ticks: {
				// Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,
	
				// String - The colour of the label backdrop
				backdropColor: 'rgba(255,255,255,0.75)',
	
				// Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,
	
				// Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2,
	
				callback: Chart.Ticks.formatters.linear
			},
	
			pointLabels: {
				// Number - Point label font size in pixels
				fontSize: 10,
	
				// Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};
	
		function getValueCount(scale) {
			return !scale.options.lineArc ? scale.chart.data.labels.length : 0;
		}
	
		function getPointLabelFontOptions(scale) {
			var pointLabelOptions = scale.options.pointLabels;
			var fontSize = helpers.getValueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = helpers.getValueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = helpers.getValueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
			var font = helpers.fontString(fontSize, fontStyle, fontFamily);
	
			return {
				size: fontSize,
				style: fontStyle,
				family: fontFamily,
				font: font
			};
		}
	
		function measureLabelSize(ctx, fontSize, label) {
			if (helpers.isArray(label)) {
				return {
					w: helpers.longestText(ctx, ctx.font, label),
					h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
				};
			}
	
			return {
				w: ctx.measureText(label).width,
				h: fontSize
			};
		}
	
		function determineLimits(angle, pos, size, min, max) {
			if (angle === min || angle === max) {
				return {
					start: pos - (size / 2),
					end: pos + (size / 2)
				};
			} else if (angle < min || angle > max) {
				return {
					start: pos - size - 5,
					end: pos
				};
			}
	
			return {
				start: pos,
				end: pos + size + 5
			};
		}
	
		/**
		 * Helper function to fit a radial linear scale with point labels
		 */
		function fitWithPointLabels(scale) {
			/*
			 * Right, this is really confusing and there is a lot of maths going on here
			 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
			 *
			 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
			 *
			 * Solution:
			 *
			 * We assume the radius of the polygon is half the size of the canvas at first
			 * at each index we check if the text overlaps.
			 *
			 * Where it does, we store that angle and that index.
			 *
			 * After finding the largest index and angle we calculate how much we need to remove
			 * from the shape radius to move the point inwards by that x.
			 *
			 * We average the left and right distances to get the maximum shape radius that can fit in the box
			 * along with labels.
			 *
			 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
			 * on each side, removing that from the size, halving it and adding the left x protrusion width.
			 *
			 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
			 * and position it in the most space efficient manner
			 *
			 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
			 */
	
			var plFont = getPointLabelFontOptions(scale);
	
			// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
			// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			var furthestLimits = {
				l: scale.width,
				r: 0,
				t: scale.height,
				b: 0
			};
			var furthestAngles = {};
			var i;
			var textSize;
			var pointPosition;
	
			scale.ctx.font = plFont.font;
			scale._pointLabelSizes = [];
	
			var valueCount = getValueCount(scale);
			for (i = 0; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, largestPossibleRadius);
				textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
				scale._pointLabelSizes[i] = textSize;
	
				// Add quarter circle to make degree 0 mean top of circle
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians) % 360;
				var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
				var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
				if (hLimits.start < furthestLimits.l) {
					furthestLimits.l = hLimits.start;
					furthestAngles.l = angleRadians;
				}
	
				if (hLimits.end > furthestLimits.r) {
					furthestLimits.r = hLimits.end;
					furthestAngles.r = angleRadians;
				}
	
				if (vLimits.start < furthestLimits.t) {
					furthestLimits.t = vLimits.start;
					furthestAngles.t = angleRadians;
				}
	
				if (vLimits.end > furthestLimits.b) {
					furthestLimits.b = vLimits.end;
					furthestAngles.b = angleRadians;
				}
			}
	
			scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
		}
	
		/**
		 * Helper function to fit a radial linear scale with no point labels
		 */
		function fit(scale) {
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			scale.drawingArea = Math.round(largestPossibleRadius);
			scale.setCenterPoint(0, 0, 0, 0);
		}
	
		function getTextAlignForAngle(angle) {
			if (angle === 0 || angle === 180) {
				return 'center';
			} else if (angle < 180) {
				return 'left';
			}
	
			return 'right';
		}
	
		function fillText(ctx, text, position, fontSize) {
			if (helpers.isArray(text)) {
				var y = position.y;
				var spacing = 1.5 * fontSize;
	
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], position.x, y);
					y+= spacing;
				}
			} else {
				ctx.fillText(text, position.x, position.y);
			}
		}
	
		function adjustPointPositionForLabelHeight(angle, textSize, position) {
			if (angle === 90 || angle === 270) {
				position.y -= (textSize.h / 2);
			} else if (angle > 270 || angle < 90) {
				position.y -= textSize.h;
			}
		}
	
		function drawPointLabels(scale) {
			var ctx = scale.ctx;
			var getValueOrDefault = helpers.getValueOrDefault;
			var opts = scale.options;
			var angleLineOpts = opts.angleLines;
			var pointLabelOpts = opts.pointLabels;
	
			ctx.lineWidth = angleLineOpts.lineWidth;
			ctx.strokeStyle = angleLineOpts.color;
	
			var outerDistance = scale.getDistanceFromCenterForValue(opts.reverse ? scale.min : scale.max);
	
			// Point Label Font
			var plFont = getPointLabelFontOptions(scale);
	
			ctx.textBaseline = 'top';
	
			for (var i = getValueCount(scale) - 1; i >= 0; i--) {
				if (angleLineOpts.display) {
					var outerPosition = scale.getPointPosition(i, outerDistance);
					ctx.beginPath();
					ctx.moveTo(scale.xCenter, scale.yCenter);
					ctx.lineTo(outerPosition.x, outerPosition.y);
					ctx.stroke();
					ctx.closePath();
				}
				// Extra 3px out for some label spacing
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);
	
				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = getValueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
				ctx.font = plFont.font;
				ctx.fillStyle = pointLabelFontColor;
	
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
			}
		}
	
		function drawRadiusLine(scale, gridLineOpts, radius, index) {
			var ctx = scale.ctx;
			ctx.strokeStyle = helpers.getValueAtIndexOrDefault(gridLineOpts.color, index - 1);
			ctx.lineWidth = helpers.getValueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);
	
			if (scale.options.lineArc) {
				// Draw circular arcs between the points
				ctx.beginPath();
				ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.stroke();
			} else {
				// Draw straight lines connecting each index
				var valueCount = getValueCount(scale);
	
				if (valueCount === 0) {
					return;
				}
	
				ctx.beginPath();
				var pointPosition = scale.getPointPosition(0, radius);
				ctx.moveTo(pointPosition.x, pointPosition.y);
	
				for (var i = 1; i < valueCount; i++) {
					pointPosition = scale.getPointPosition(i, radius);
					ctx.lineTo(pointPosition.x, pointPosition.y);
				}
	
				ctx.closePath();
				ctx.stroke();
			}
		}
	
		function numberOrZero(param) {
			return helpers.isNumber(param) ? param : 0;
		}
	
		var LinearRadialScale = Chart.LinearScaleBase.extend({
			setDimensions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				// Set the unconstrained dimension before label rotation
				me.width = me.maxWidth;
				me.height = me.maxHeight;
				me.xCenter = Math.round(me.width / 2);
				me.yCenter = Math.round(me.height / 2);
	
				var minSize = helpers.min([me.height, me.width]);
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var min = Number.POSITIVE_INFINITY;
				var max = Number.NEGATIVE_INFINITY;
	
				helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);
	
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							min = Math.min(value, min);
							max = Math.max(value, max);
						});
					}
				});
	
				me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
				me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				me.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var tickOpts = this.options.ticks;
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
			},
			convertTicksToLabels: function() {
				var me = this;
				Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);
	
				// Point labels
				me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				if (this.options.lineArc) {
					fit(this);
				} else {
					fitWithPointLabels(this);
				}
			},
			/**
			 * Set radius reductions and determine new radius and center point
			 * @private
			 */
			setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
				var me = this;
				var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
				var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
				var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
				var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);
	
				radiusReductionLeft = numberOrZero(radiusReductionLeft);
				radiusReductionRight = numberOrZero(radiusReductionRight);
				radiusReductionTop = numberOrZero(radiusReductionTop);
				radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
				me.drawingArea = Math.min(
					Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
					Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
				me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
			},
			setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
				var me = this;
				var maxRight = me.width - rightMovement - me.drawingArea,
					maxLeft = leftMovement + me.drawingArea,
					maxTop = topMovement + me.drawingArea,
					maxBottom = me.height - bottomMovement - me.drawingArea;
	
				me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
				me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
			},
	
			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / getValueCount(this);
				var startAngle = this.chart.options && this.chart.options.startAngle ?
					this.chart.options.startAngle :
					0;
	
				var startAngleRadians = startAngle * Math.PI * 2 / 360;
	
				// Start from the top instead of right, so remove a quarter of the circle
				return index * angleMultiplier + startAngleRadians;
			},
			getDistanceFromCenterForValue: function(value) {
				var me = this;
	
				if (value === null) {
					return 0; // null always in center
				}
	
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = me.drawingArea / (me.max - me.min);
				if (me.options.reverse) {
					return (me.max - value) * scalingFactor;
				}
				return (value - me.min) * scalingFactor;
			},
			getPointPosition: function(index, distanceFromCenter) {
				var me = this;
				var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},
	
			getBasePosition: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPointPositionForValue(0,
					me.beginAtZero? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0);
			},
	
			draw: function() {
				var me = this;
				var opts = me.options;
				var gridLineOpts = opts.gridLines;
				var tickOpts = opts.ticks;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				if (opts.display) {
					var ctx = me.ctx;
	
					// Tick Font
					var tickFontSize = getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
					var tickFontStyle = getValueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
					var tickFontFamily = getValueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
					var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
					helpers.each(me.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || opts.reverse) {
							var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
							var yHeight = me.yCenter - yCenterOffset;
	
							// Draw circular lines around the scale
							if (gridLineOpts.display && index !== 0) {
								drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
							}
	
							if (tickOpts.display) {
								var tickFontColor = getValueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
								ctx.font = tickLabelFont;
	
								if (tickOpts.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = tickOpts.backdropColor;
									ctx.fillRect(
										me.xCenter - labelWidth / 2 - tickOpts.backdropPaddingX,
										yHeight - tickFontSize / 2 - tickOpts.backdropPaddingY,
										labelWidth + tickOpts.backdropPaddingX * 2,
										tickFontSize + tickOpts.backdropPaddingY * 2
									);
								}
	
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, me.xCenter, yHeight);
							}
						}
					});
	
					if (!opts.lineArc) {
						drawPointLabels(me);
					}
				}
			}
		});
		Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
	
	};


/***/ },
/* 2454 */
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var moment = __webpack_require__(7);
	moment = typeof(moment) === 'function' ? moment : window.moment;
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var time = {
			units: [{
				name: 'millisecond',
				steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
			}, {
				name: 'second',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'minute',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'hour',
				steps: [1, 2, 3, 6, 12]
			}, {
				name: 'day',
				steps: [1, 2, 5]
			}, {
				name: 'week',
				maxStep: 4
			}, {
				name: 'month',
				maxStep: 3
			}, {
				name: 'quarter',
				maxStep: 4
			}, {
				name: 'year',
				maxStep: false
			}]
		};
	
		var defaultConfig = {
			position: 'bottom',
	
			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
				minUnit: 'millisecond',
	
				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					second: 'h:mm:ss a', // 11:20:01 AM
					minute: 'h:mm:ss a', // 11:20:01 AM
					hour: 'MMM D, hA', // Sept 4, 5PM
					day: 'll', // Sep 4 2015
					week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					month: 'MMM YYYY', // Sept 2015
					quarter: '[Q]Q - YYYY', // Q3
					year: 'YYYY' // 2015
				}
			},
			ticks: {
				autoSkip: false
			}
		};
	
		var TimeScale = Chart.Scale.extend({
			initialize: function() {
				if (!moment) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}
	
				Chart.Scale.prototype.initialize.call(this);
			},
			getLabelMoment: function(datasetIndex, index) {
				if (datasetIndex === null || index === null) {
					return null;
				}
	
				if (typeof this.labelMoments[datasetIndex] !== 'undefined') {
					return this.labelMoments[datasetIndex][index];
				}
	
				return null;
			},
			getLabelDiff: function(datasetIndex, index) {
				var me = this;
				if (datasetIndex === null || index === null) {
					return null;
				}
	
				if (me.labelDiffs === undefined) {
					me.buildLabelDiffs();
				}
	
				if (typeof me.labelDiffs[datasetIndex] !== 'undefined') {
					return me.labelDiffs[datasetIndex][index];
				}
	
				return null;
			},
			getMomentStartOf: function(tick) {
				var me = this;
				if (me.options.time.unit === 'week' && me.options.time.isoWeekday !== false) {
					return tick.clone().startOf('isoWeek').isoWeekday(me.options.time.isoWeekday);
				}
				return tick.clone().startOf(me.tickUnit);
			},
			determineDataLimits: function() {
				var me = this;
				me.labelMoments = [];
	
				// Only parse these once. If the dataset does not have data as x,y pairs, we will use
				// these
				var scaleLabelMoments = [];
				if (me.chart.data.labels && me.chart.data.labels.length > 0) {
					helpers.each(me.chart.data.labels, function(label) {
						var labelMoment = me.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (me.options.time.round) {
								labelMoment.startOf(me.options.time.round);
							}
							scaleLabelMoments.push(labelMoment);
						}
					}, me);
	
					me.firstTick = moment.min.call(me, scaleLabelMoments);
					me.lastTick = moment.max.call(me, scaleLabelMoments);
				} else {
					me.firstTick = null;
					me.lastTick = null;
				}
	
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var momentsForDataset = [];
					var datasetVisible = me.chart.isDatasetVisible(datasetIndex);
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null) {
						helpers.each(dataset.data, function(value) {
							var labelMoment = me.parseTime(me.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (me.options.time.round) {
									labelMoment.startOf(me.options.time.round);
								}
								momentsForDataset.push(labelMoment);
	
								if (datasetVisible) {
									// May have gone outside the scale ranges, make sure we keep the first and last ticks updated
									me.firstTick = me.firstTick !== null ? moment.min(me.firstTick, labelMoment) : labelMoment;
									me.lastTick = me.lastTick !== null ? moment.max(me.lastTick, labelMoment) : labelMoment;
								}
							}
						}, me);
					} else {
						// We have no labels. Use the ones from the scale
						momentsForDataset = scaleLabelMoments;
					}
	
					me.labelMoments.push(momentsForDataset);
				}, me);
	
				// Set these after we've done all the data
				if (me.options.time.min) {
					me.firstTick = me.parseTime(me.options.time.min);
				}
	
				if (me.options.time.max) {
					me.lastTick = me.parseTime(me.options.time.max);
				}
	
				// We will modify these, so clone for later
				me.firstTick = (me.firstTick || moment()).clone();
				me.lastTick = (me.lastTick || moment()).clone();
			},
			buildLabelDiffs: function() {
				var me = this;
				me.labelDiffs = [];
				var scaleLabelDiffs = [];
				// Parse common labels once
				if (me.chart.data.labels && me.chart.data.labels.length > 0) {
					helpers.each(me.chart.data.labels, function(label) {
						var labelMoment = me.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (me.options.time.round) {
								labelMoment.startOf(me.options.time.round);
							}
							scaleLabelDiffs.push(labelMoment.diff(me.firstTick, me.tickUnit, true));
						}
					}, me);
				}
	
				helpers.each(me.chart.data.datasets, function(dataset) {
					var diffsForDataset = [];
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null) {
						helpers.each(dataset.data, function(value) {
							var labelMoment = me.parseTime(me.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (me.options.time.round) {
									labelMoment.startOf(me.options.time.round);
								}
								diffsForDataset.push(labelMoment.diff(me.firstTick, me.tickUnit, true));
							}
						}, me);
					} else {
						// We have no labels. Use common ones
						diffsForDataset = scaleLabelDiffs;
					}
	
					me.labelDiffs.push(diffsForDataset);
				}, me);
			},
			buildTicks: function() {
				var me = this;
	
				me.ctx.save();
				var tickFontSize = helpers.getValueOrDefault(me.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(me.options.ticks.fontStyle, Chart.defaults.global.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(me.options.ticks.fontFamily, Chart.defaults.global.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				me.ctx.font = tickLabelFont;
	
				me.ticks = [];
				me.unitScale = 1; // How much we scale the unit by, ie 2 means 2x unit per step
				me.scaleSizeInUnits = 0; // How large the scale is in the base unit (seconds, minutes, etc)
	
				// Set unit override if applicable
				if (me.options.time.unit) {
					me.tickUnit = me.options.time.unit || 'day';
					me.displayFormat = me.options.time.displayFormats[me.tickUnit];
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, 1);
				} else {
					// Determine the smallest needed unit of the time
					var innerWidth = me.isHorizontal() ? me.width : me.height;
	
					// Crude approximation of what the label length might be
					var tempFirstLabel = me.tickFormatFunction(me.firstTick, 0, []);
					var tickLabelWidth = me.ctx.measureText(tempFirstLabel).width;
					var cosRotation = Math.cos(helpers.toRadians(me.options.ticks.maxRotation));
					var sinRotation = Math.sin(helpers.toRadians(me.options.ticks.maxRotation));
					tickLabelWidth = (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
					var labelCapacity = innerWidth / (tickLabelWidth);
	
					// Start as small as possible
					me.tickUnit = me.options.time.minUnit;
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					me.displayFormat = me.options.time.displayFormats[me.tickUnit];
	
					var unitDefinitionIndex = 0;
					var unitDefinition = time.units[unitDefinitionIndex];
	
					// While we aren't ideal and we don't have units left
					while (unitDefinitionIndex < time.units.length) {
						// Can we scale this unit. If `false` we can scale infinitely
						me.unitScale = 1;
	
						if (helpers.isArray(unitDefinition.steps) && Math.ceil(me.scaleSizeInUnits / labelCapacity) < helpers.max(unitDefinition.steps)) {
							// Use one of the predefined steps
							for (var idx = 0; idx < unitDefinition.steps.length; ++idx) {
								if (unitDefinition.steps[idx] >= Math.ceil(me.scaleSizeInUnits / labelCapacity)) {
									me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, unitDefinition.steps[idx]);
									break;
								}
							}
	
							break;
						} else if ((unitDefinition.maxStep === false) || (Math.ceil(me.scaleSizeInUnits / labelCapacity) < unitDefinition.maxStep)) {
							// We have a max step. Scale this unit
							me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, Math.ceil(me.scaleSizeInUnits / labelCapacity));
							break;
						} else {
							// Move to the next unit up
							++unitDefinitionIndex;
							unitDefinition = time.units[unitDefinitionIndex];
	
							me.tickUnit = unitDefinition.name;
							var leadingUnitBuffer = me.firstTick.diff(me.getMomentStartOf(me.firstTick), me.tickUnit, true);
							var trailingUnitBuffer = me.getMomentStartOf(me.lastTick.clone().add(1, me.tickUnit)).diff(me.lastTick, me.tickUnit, true);
							me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true) + leadingUnitBuffer + trailingUnitBuffer;
							me.displayFormat = me.options.time.displayFormats[unitDefinition.name];
						}
					}
				}
	
				var roundedStart;
	
				// Only round the first tick if we have no hard minimum
				if (!me.options.time.min) {
					me.firstTick = me.getMomentStartOf(me.firstTick);
					roundedStart = me.firstTick;
				} else {
					roundedStart = me.getMomentStartOf(me.firstTick);
				}
	
				// Only round the last tick if we have no hard maximum
				if (!me.options.time.max) {
					var roundedEnd = me.getMomentStartOf(me.lastTick);
					var delta = roundedEnd.diff(me.lastTick, me.tickUnit, true);
					if (delta < 0) {
						// Do not use end of because we need me to be in the next time unit
						me.lastTick = me.getMomentStartOf(me.lastTick.add(1, me.tickUnit));
					} else if (delta >= 0) {
						me.lastTick = roundedEnd;
					}
	
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
				}
	
				// Tick displayFormat override
				if (me.options.time.displayFormat) {
					me.displayFormat = me.options.time.displayFormat;
				}
	
				// first tick. will have been rounded correctly if options.time.min is not specified
				me.ticks.push(me.firstTick.clone());
	
				// For every unit in between the first and last moment, create a moment and add it to the ticks tick
				for (var i = me.unitScale; i <= me.scaleSizeInUnits; i += me.unitScale) {
					var newTick = roundedStart.clone().add(i, me.tickUnit);
	
					// Are we greater than the max time
					if (me.options.time.max && newTick.diff(me.lastTick, me.tickUnit, true) >= 0) {
						break;
					}
	
					me.ticks.push(newTick);
				}
	
				// Always show the right tick
				var diff = me.ticks[me.ticks.length - 1].diff(me.lastTick, me.tickUnit);
				if (diff !== 0 || me.scaleSizeInUnits === 0) {
					// this is a weird case. If the <max> option is the same as the end option, we can't just diff the times because the tick was created from the roundedStart
					// but the last tick was not rounded.
					if (me.options.time.max) {
						me.ticks.push(me.lastTick.clone());
						me.scaleSizeInUnits = me.lastTick.diff(me.ticks[0], me.tickUnit, true);
					} else {
						me.ticks.push(me.lastTick.clone());
						me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					}
				}
	
				me.ctx.restore();
	
				// Invalidate label diffs cache
				me.labelDiffs = undefined;
			},
			// Get tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var label = me.chart.data.labels && index < me.chart.data.labels.length ? me.chart.data.labels[index] : '';
				var value = me.chart.data.datasets[datasetIndex].data[index];
	
				if (value !== null && typeof value === 'object') {
					label = me.getRightValue(value);
				}
	
				// Format nicely
				if (me.options.time.tooltipFormat) {
					label = me.parseTime(label).format(me.options.time.tooltipFormat);
				}
	
				return label;
			},
			// Function to format an individual tick mark
			tickFormatFunction: function(tick, index, ticks) {
				var formattedTick = tick.format(this.displayFormat);
				var tickOpts = this.options.ticks;
				var callback = helpers.getValueOrDefault(tickOpts.callback, tickOpts.userCallback);
	
				if (callback) {
					return callback(formattedTick, index, ticks);
				}
				return formattedTick;
			},
			convertTicksToLabels: function() {
				var me = this;
				me.tickMoments = me.ticks;
				me.ticks = me.ticks.map(me.tickFormatFunction, me);
			},
			getPixelForValue: function(value, index, datasetIndex) {
				var me = this;
				var offset = null;
				if (index !== undefined && datasetIndex !== undefined) {
					offset = me.getLabelDiff(datasetIndex, index);
				}
	
				if (offset === null) {
					if (!value || !value.isValid) {
						// not already a moment object
						value = me.parseTime(me.getRightValue(value));
					}
					if (value && value.isValid && value.isValid()) {
						offset = value.diff(me.firstTick, me.tickUnit, true);
					}
				}
	
				if (offset !== null) {
					var decimal = offset !== 0 ? offset / me.scaleSizeInUnits : offset;
	
					if (me.isHorizontal()) {
						var valueOffset = (me.width * decimal);
						return me.left + Math.round(valueOffset);
					}
	
					var heightOffset = (me.height * decimal);
					return me.top + Math.round(heightOffset);
				}
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickMoments[index], null, null);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var innerDimension = me.isHorizontal() ? me.width : me.height;
				var offset = (pixel - (me.isHorizontal() ? me.left : me.top)) / innerDimension;
				offset *= me.scaleSizeInUnits;
				return me.firstTick.clone().add(moment.duration(offset, me.tickUnit).asSeconds(), 'seconds');
			},
			parseTime: function(label) {
				var me = this;
				if (typeof me.options.time.parser === 'string') {
					return moment(label, me.options.time.parser);
				}
				if (typeof me.options.time.parser === 'function') {
					return me.options.time.parser(label);
				}
				// Date objects
				if (typeof label.getMonth === 'function' || typeof label === 'number') {
					return moment(label);
				}
				// Moment support
				if (label.isValid && label.isValid()) {
					return label;
				}
				// Custom parsing (return an instance of moment)
				if (typeof me.options.time.format !== 'string' && me.options.time.format.call) {
					console.warn('options.time.format is deprecated and replaced by options.time.parser. See http://nnnick.github.io/Chart.js/docs-v2/#scales-time-scale');
					return me.options.time.format(label);
				}
				// Moment format parsing
				return moment(label, me.options.time.format);
			}
		});
		Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
	
	};


/***/ },
/* 2455 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(2460);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ },
/* 2456 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(2457);
	var string = __webpack_require__(2455);
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = string.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = string.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = string.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return string.hexString(this.values.rgb);
		},
		rgbString: function () {
			return string.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return string.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return string.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return string.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return string.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return string.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return string.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = convert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	module.exports = Color;


/***/ },
/* 2457 */
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(943);
	var route = __webpack_require__(2459);
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	module.exports = convert;


/***/ },
/* 2458 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ },
/* 2459 */
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(943);
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	module.exports = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	


/***/ },
/* 2460 */
2458,
/* 2461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var deselectCurrent = __webpack_require__(4095);
	
	var clipboardToIE11Formatting = {
	  "text/plain": "Text",
	  "text/html": "Url",
	  "default": "Text"
	}
	
	var defaultMessage = "Copy to clipboard: #{key}, Enter";
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug,
	    message,
	    reselectPrevious,
	    range,
	    selection,
	    mark,
	    success = false;
	  if (!options) {
	    options = {};
	  }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement("span");
	    mark.textContent = text;
	    // reset user styles for span element
	    mark.style.all = "unset";
	    // prevents scrolling to the end of the page
	    mark.style.position = "fixed";
	    mark.style.top = 0;
	    mark.style.clip = "rect(0, 0, 0, 0)";
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = "pre";
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = "text";
	    mark.style.MozUserSelect = "text";
	    mark.style.msUserSelect = "text";
	    mark.style.userSelect = "text";
	    mark.addEventListener("copy", function(e) {
	      e.stopPropagation();
	      if (options.format) {
	        e.preventDefault();
	        if (typeof e.clipboardData === "undefined") { // IE 11
	          debug && console.warn("unable to use e.clipboardData");
	          debug && console.warn("trying IE specific stuff");
	          window.clipboardData.clearData();
	          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
	          window.clipboardData.setData(format, text);
	        } else { // all other browsers
	          e.clipboardData.clearData();
	          e.clipboardData.setData(options.format, text);
	        }
	      }
	      if (options.onCopy) {
	        e.preventDefault();
	        options.onCopy(e.clipboardData);
	      }
	    });
	
	    document.body.appendChild(mark);
	
	    range.selectNodeContents(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand("copy");
	    if (!successful) {
	      throw new Error("copy command was unsuccessful");
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error("unable to copy using execCommand: ", err);
	    debug && console.warn("trying IE specific stuff");
	    try {
	      window.clipboardData.setData(options.format || "text", text);
	      options.onCopy && options.onCopy(window.clipboardData);
	      success = true;
	    } catch (err) {
	      debug && console.error("unable to copy using clipboardData: ", err);
	      debug && console.error("falling back to prompt");
	      message = format("message" in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == "function") {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ },
/* 2462 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(294);
	__webpack_require__(2498);
	module.exports = __webpack_require__(64).Array.from;


/***/ },
/* 2463 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(374);
	__webpack_require__(294);
	module.exports = __webpack_require__(2496);


/***/ },
/* 2464 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(374);
	__webpack_require__(294);
	module.exports = __webpack_require__(2497);


/***/ },
/* 2465 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2500);
	module.exports = __webpack_require__(64).Object.assign;


/***/ },
/* 2466 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2501);
	var $Object = __webpack_require__(64).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 2467 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2502);
	var $Object = __webpack_require__(64).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 2468 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2503);
	var $Object = __webpack_require__(64).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ },
/* 2469 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2504);
	module.exports = __webpack_require__(64).Object.getPrototypeOf;


/***/ },
/* 2470 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2505);
	module.exports = __webpack_require__(64).Object.keys;


/***/ },
/* 2471 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2506);
	module.exports = __webpack_require__(64).Object.setPrototypeOf;


/***/ },
/* 2472 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(959);
	__webpack_require__(294);
	__webpack_require__(374);
	__webpack_require__(2507);
	__webpack_require__(2509);
	__webpack_require__(2510);
	module.exports = __webpack_require__(64).Promise;


/***/ },
/* 2473 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2508);
	__webpack_require__(959);
	__webpack_require__(2511);
	__webpack_require__(2512);
	module.exports = __webpack_require__(64).Symbol;


/***/ },
/* 2474 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(294);
	__webpack_require__(374);
	module.exports = __webpack_require__(592).f('iterator');


/***/ },
/* 2475 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 2476 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 2477 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(198);
	var toLength = __webpack_require__(589);
	var toAbsoluteIndex = __webpack_require__(2494);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 2478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(145);
	var createDesc = __webpack_require__(293);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 2479 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(292);
	var gOPS = __webpack_require__(584);
	var pIE = __webpack_require__(371);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 2480 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(235);
	var call = __webpack_require__(948);
	var isArrayIter = __webpack_require__(947);
	var anObject = __webpack_require__(132);
	var toLength = __webpack_require__(589);
	var getIterFn = __webpack_require__(593);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 2481 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 2482 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(290);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 2483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(582);
	var descriptor = __webpack_require__(293);
	var setToStringTag = __webpack_require__(372);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(197)(IteratorPrototype, __webpack_require__(88)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 2484 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 2485 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(373)('meta');
	var isObject = __webpack_require__(174);
	var has = __webpack_require__(196);
	var setDesc = __webpack_require__(145).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(236)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 2486 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(87);
	var macrotask = __webpack_require__(958).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(290)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 2487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(144);
	var getKeys = __webpack_require__(292);
	var gOPS = __webpack_require__(584);
	var pIE = __webpack_require__(371);
	var toObject = __webpack_require__(238);
	var IObject = __webpack_require__(946);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(236)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 2488 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(145);
	var anObject = __webpack_require__(132);
	var getKeys = __webpack_require__(292);
	
	module.exports = __webpack_require__(144) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 2489 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(198);
	var gOPN = __webpack_require__(951).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 2490 */
/***/ function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(197);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ },
/* 2491 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(174);
	var anObject = __webpack_require__(132);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(235)(Function.call, __webpack_require__(583).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 2492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(87);
	var core = __webpack_require__(64);
	var dP = __webpack_require__(145);
	var DESCRIPTORS = __webpack_require__(144);
	var SPECIES = __webpack_require__(88)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 2493 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(588);
	var defined = __webpack_require__(578);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 2494 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(588);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 2495 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(87);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 2496 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(132);
	var get = __webpack_require__(593);
	module.exports = __webpack_require__(64).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 2497 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(577);
	var ITERATOR = __webpack_require__(88)('iterator');
	var Iterators = __webpack_require__(237);
	module.exports = __webpack_require__(64).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 2498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(235);
	var $export = __webpack_require__(121);
	var toObject = __webpack_require__(238);
	var call = __webpack_require__(948);
	var isArrayIter = __webpack_require__(947);
	var toLength = __webpack_require__(589);
	var createProperty = __webpack_require__(2478);
	var getIterFn = __webpack_require__(593);
	
	$export($export.S + $export.F * !__webpack_require__(950)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 2499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(2475);
	var step = __webpack_require__(2484);
	var Iterators = __webpack_require__(237);
	var toIObject = __webpack_require__(198);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(949)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 2500 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(121);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(2487) });


/***/ },
/* 2501 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(121);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(582) });


/***/ },
/* 2502 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(121);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(144), 'Object', { defineProperty: __webpack_require__(145).f });


/***/ },
/* 2503 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(198);
	var $getOwnPropertyDescriptor = __webpack_require__(583).f;
	
	__webpack_require__(585)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 2504 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(238);
	var $getPrototypeOf = __webpack_require__(952);
	
	__webpack_require__(585)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 2505 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(238);
	var $keys = __webpack_require__(292);
	
	__webpack_require__(585)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 2506 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(121);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(2491).set });


/***/ },
/* 2507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(291);
	var global = __webpack_require__(87);
	var ctx = __webpack_require__(235);
	var classof = __webpack_require__(577);
	var $export = __webpack_require__(121);
	var isObject = __webpack_require__(174);
	var aFunction = __webpack_require__(370);
	var anInstance = __webpack_require__(2476);
	var forOf = __webpack_require__(2480);
	var speciesConstructor = __webpack_require__(957);
	var task = __webpack_require__(958).set;
	var microtask = __webpack_require__(2486)();
	var newPromiseCapabilityModule = __webpack_require__(581);
	var perform = __webpack_require__(954);
	var userAgent = __webpack_require__(2495);
	var promiseResolve = __webpack_require__(955);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(88)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(2490)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(372)($Promise, PROMISE);
	__webpack_require__(2492)(PROMISE);
	Wrapper = __webpack_require__(64)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(950)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 2508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(87);
	var has = __webpack_require__(196);
	var DESCRIPTORS = __webpack_require__(144);
	var $export = __webpack_require__(121);
	var redefine = __webpack_require__(956);
	var META = __webpack_require__(2485).KEY;
	var $fails = __webpack_require__(236);
	var shared = __webpack_require__(587);
	var setToStringTag = __webpack_require__(372);
	var uid = __webpack_require__(373);
	var wks = __webpack_require__(88);
	var wksExt = __webpack_require__(592);
	var wksDefine = __webpack_require__(591);
	var enumKeys = __webpack_require__(2479);
	var isArray = __webpack_require__(2482);
	var anObject = __webpack_require__(132);
	var isObject = __webpack_require__(174);
	var toObject = __webpack_require__(238);
	var toIObject = __webpack_require__(198);
	var toPrimitive = __webpack_require__(590);
	var createDesc = __webpack_require__(293);
	var _create = __webpack_require__(582);
	var gOPNExt = __webpack_require__(2489);
	var $GOPD = __webpack_require__(583);
	var $GOPS = __webpack_require__(584);
	var $DP = __webpack_require__(145);
	var $keys = __webpack_require__(292);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(951).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(371).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(291)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(197)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 2509 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(121);
	var core = __webpack_require__(64);
	var global = __webpack_require__(87);
	var speciesConstructor = __webpack_require__(957);
	var promiseResolve = __webpack_require__(955);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 2510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(121);
	var newPromiseCapability = __webpack_require__(581);
	var perform = __webpack_require__(954);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 2511 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(591)('asyncIterator');


/***/ },
/* 2512 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(591)('observable');


/***/ },
/* 2513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(831);
	var regions = __webpack_require__(960);
	var continents = {};
	
	continents.asia = {
	  name: 'Asia',
	  regions: ['centralAsia', 'southernAsia', 'southeastAsia', 'eastAsia', 'westernAsia'],
	  countries: _.flatten([
	    regions.centralAsia.countries,
	    regions.southernAsia.countries,
	    regions.southeastAsia.countries,
	    regions.eastAsia.countries,
	    regions.westernAsia.countries
	  ])
	  .sort()
	};
	
	continents.africa = {
	  name: 'Africa',
	  regions: ['centralAfrica', 'northAfrica', 'southernAfrica', 'eastAfrica', 'westAfrica'],
	  countries: _.flatten([
	      regions.centralAfrica.countries,
	      regions.northAfrica.countries,
	      regions.southernAfrica.countries,
	      regions.eastAfrica.countries,
	      regions.westAfrica.countries
	  ])
	  .sort()
	};
	
	continents.northAmerica = {
	  name: 'North America',
	  regions: ['centralAmerica', 'northernAmerica', 'caribbean'],
	  countries: _.flatten([
	    regions.centralAmerica.countries,
	    regions.northernAmerica.countries,
	    regions.caribbean.countries
	  ])
	  .sort()
	};
	
	continents.southAmerica = {
	  name: 'South America',
	  regions: ['southAmerica'],
	  countries: _.flatten([
	    regions.southAmerica.countries
	  ])
	  .sort()
	}
	
	continents.antartica = {
	  name: 'Antartica',
	  regions: ['antartica'],
	  countries: _.flatten([
	    regions.antartica.countries
	  ])
	  .sort()
	}
	
	continents.europe = {
	  name: 'Europe',
	  regions: ['northernEurope', 'southernEurope', 'easternEurope', 'westernEurope'],
	  countries: _.flatten([
	    regions.northernEurope.countries,
	    regions.southernEurope.countries,
	    regions.easternEurope.countries,
	    regions.westernEurope.countries
	  ])
	  .sort()
	}
	
	continents.oceania = {
	  name: 'Oceania',
	  regions: ['australia', 'melanesia', 'micronesia', 'polynesia'],
	  countries: _.flatten([
	    regions.australia.countries,
	    regions.melanesia.countries,
	    regions.micronesia.countries,
	    regions.polynesia.countries
	  ])
	  .sort()
	};
	
	module.exports = continents;


/***/ },
/* 2514 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(831);
	
	module.exports = init;
	
	function init(o) {
	  return {
	    countries: search.bind(null, o.countries),
	    currencies: search.bind(null, o.currencies),
	    languages: search.bind(null, o.languages)
	  };
	}
	
	function search(data, query) {
	  var q = _.pairs(query);
	
	  return data.filter(function(d) {
	    return q.filter(function(v) {
	      var prop = d[v[0]];
	
	      if(_.isArray(prop)) return prop.indexOf(v[1]) >= 0;
	
	      return prop == v[1];
	    }).length == q.length;
	  });
	}

/***/ },
/* 2515 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(2516);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 2516 */
1808,
/* 2517 */
/***/ function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ },
/* 2518 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(239), __webpack_require__(240), __webpack_require__(199), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var BlockCipher = C_lib.BlockCipher;
		    var C_algo = C.algo;
	
		    // Lookup tables
		    var SBOX = [];
		    var INV_SBOX = [];
		    var SUB_MIX_0 = [];
		    var SUB_MIX_1 = [];
		    var SUB_MIX_2 = [];
		    var SUB_MIX_3 = [];
		    var INV_SUB_MIX_0 = [];
		    var INV_SUB_MIX_1 = [];
		    var INV_SUB_MIX_2 = [];
		    var INV_SUB_MIX_3 = [];
	
		    // Compute lookup tables
		    (function () {
		        // Compute double table
		        var d = [];
		        for (var i = 0; i < 256; i++) {
		            if (i < 128) {
		                d[i] = i << 1;
		            } else {
		                d[i] = (i << 1) ^ 0x11b;
		            }
		        }
	
		        // Walk GF(2^8)
		        var x = 0;
		        var xi = 0;
		        for (var i = 0; i < 256; i++) {
		            // Compute sbox
		            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
		            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
		            SBOX[x] = sx;
		            INV_SBOX[sx] = x;
	
		            // Compute multiplication
		            var x2 = d[x];
		            var x4 = d[x2];
		            var x8 = d[x4];
	
		            // Compute sub bytes, mix columns tables
		            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
		            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
		            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
		            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
		            SUB_MIX_3[x] = t;
	
		            // Compute inv sub bytes, inv mix columns tables
		            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
		            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
		            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
		            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
		            INV_SUB_MIX_3[sx] = t;
	
		            // Compute next counter
		            if (!x) {
		                x = xi = 1;
		            } else {
		                x = x2 ^ d[d[d[x8 ^ x2]]];
		                xi ^= d[d[xi]];
		            }
		        }
		    }());
	
		    // Precomputed Rcon lookup
		    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	
		    /**
		     * AES block cipher algorithm.
		     */
		    var AES = C_algo.AES = BlockCipher.extend({
		        _doReset: function () {
		            // Skip reset of nRounds has been set before and key did not change
		            if (this._nRounds && this._keyPriorReset === this._key) {
		                return;
		            }
	
		            // Shortcuts
		            var key = this._keyPriorReset = this._key;
		            var keyWords = key.words;
		            var keySize = key.sigBytes / 4;
	
		            // Compute number of rounds
		            var nRounds = this._nRounds = keySize + 6;
	
		            // Compute number of key schedule rows
		            var ksRows = (nRounds + 1) * 4;
	
		            // Compute key schedule
		            var keySchedule = this._keySchedule = [];
		            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
		                if (ksRow < keySize) {
		                    keySchedule[ksRow] = keyWords[ksRow];
		                } else {
		                    var t = keySchedule[ksRow - 1];
	
		                    if (!(ksRow % keySize)) {
		                        // Rot word
		                        t = (t << 8) | (t >>> 24);
	
		                        // Sub word
		                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	
		                        // Mix Rcon
		                        t ^= RCON[(ksRow / keySize) | 0] << 24;
		                    } else if (keySize > 6 && ksRow % keySize == 4) {
		                        // Sub word
		                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
		                    }
	
		                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
		                }
		            }
	
		            // Compute inv key schedule
		            var invKeySchedule = this._invKeySchedule = [];
		            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
		                var ksRow = ksRows - invKsRow;
	
		                if (invKsRow % 4) {
		                    var t = keySchedule[ksRow];
		                } else {
		                    var t = keySchedule[ksRow - 4];
		                }
	
		                if (invKsRow < 4 || ksRow <= 4) {
		                    invKeySchedule[invKsRow] = t;
		                } else {
		                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
		                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
		                }
		            }
		        },
	
		        encryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
		        },
	
		        decryptBlock: function (M, offset) {
		            // Swap 2nd and 4th rows
		            var t = M[offset + 1];
		            M[offset + 1] = M[offset + 3];
		            M[offset + 3] = t;
	
		            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
	
		            // Inv swap 2nd and 4th rows
		            var t = M[offset + 1];
		            M[offset + 1] = M[offset + 3];
		            M[offset + 3] = t;
		        },
	
		        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
		            // Shortcut
		            var nRounds = this._nRounds;
	
		            // Get input, add round key
		            var s0 = M[offset]     ^ keySchedule[0];
		            var s1 = M[offset + 1] ^ keySchedule[1];
		            var s2 = M[offset + 2] ^ keySchedule[2];
		            var s3 = M[offset + 3] ^ keySchedule[3];
	
		            // Key schedule row counter
		            var ksRow = 4;
	
		            // Rounds
		            for (var round = 1; round < nRounds; round++) {
		                // Shift rows, sub bytes, mix columns, add round key
		                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
		                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
		                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
		                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
	
		                // Update state
		                s0 = t0;
		                s1 = t1;
		                s2 = t2;
		                s3 = t3;
		            }
	
		            // Shift rows, sub bytes, add round key
		            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
		            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
		            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
		            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	
		            // Set output
		            M[offset]     = t0;
		            M[offset + 1] = t1;
		            M[offset + 2] = t2;
		            M[offset + 3] = t3;
		        },
	
		        keySize: 256/32
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
		     */
		    C.AES = BlockCipher._createHelper(AES);
		}());
	
	
		return CryptoJS.AES;
	
	}));

/***/ },
/* 2519 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * UTF-16 BE encoding strategy.
		     */
		    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
		        /**
		         * Converts a word array to a UTF-16 BE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 BE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var utf16Chars = [];
		            for (var i = 0; i < sigBytes; i += 2) {
		                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
		                utf16Chars.push(String.fromCharCode(codePoint));
		            }
	
		            return utf16Chars.join('');
		        },
	
		        /**
		         * Converts a UTF-16 BE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 BE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
		         */
		        parse: function (utf16Str) {
		            // Shortcut
		            var utf16StrLength = utf16Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < utf16StrLength; i++) {
		                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
		            }
	
		            return WordArray.create(words, utf16StrLength * 2);
		        }
		    };
	
		    /**
		     * UTF-16 LE encoding strategy.
		     */
		    C_enc.Utf16LE = {
		        /**
		         * Converts a word array to a UTF-16 LE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 LE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var utf16Chars = [];
		            for (var i = 0; i < sigBytes; i += 2) {
		                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
		                utf16Chars.push(String.fromCharCode(codePoint));
		            }
	
		            return utf16Chars.join('');
		        },
	
		        /**
		         * Converts a UTF-16 LE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 LE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
		         */
		        parse: function (utf16Str) {
		            // Shortcut
		            var utf16StrLength = utf16Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < utf16StrLength; i++) {
		                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
		            }
	
		            return WordArray.create(words, utf16StrLength * 2);
		        }
		    };
	
		    function swapEndian(word) {
		        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
		    }
		}());
	
	
		return CryptoJS.enc.Utf16;
	
	}));

/***/ },
/* 2520 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var CipherParams = C_lib.CipherParams;
		    var C_enc = C.enc;
		    var Hex = C_enc.Hex;
		    var C_format = C.format;
	
		    var HexFormatter = C_format.Hex = {
		        /**
		         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The hexadecimally encoded string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
		         */
		        stringify: function (cipherParams) {
		            return cipherParams.ciphertext.toString(Hex);
		        },
	
		        /**
		         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
		         *
		         * @param {string} input The hexadecimally encoded string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
		         */
		        parse: function (input) {
		            var ciphertext = Hex.parse(input);
		            return CipherParams.create({ ciphertext: ciphertext });
		        }
		    };
		}());
	
	
		return CryptoJS.format.Hex;
	
	}));

/***/ },
/* 2521 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(375), __webpack_require__(2522), __webpack_require__(2519), __webpack_require__(239), __webpack_require__(240), __webpack_require__(596), __webpack_require__(961), __webpack_require__(2538), __webpack_require__(962), __webpack_require__(2540), __webpack_require__(2539), __webpack_require__(2537), __webpack_require__(595), __webpack_require__(2533), __webpack_require__(199), __webpack_require__(68), __webpack_require__(2523), __webpack_require__(2525), __webpack_require__(2524), __webpack_require__(2527), __webpack_require__(2526), __webpack_require__(2528), __webpack_require__(2529), __webpack_require__(2530), __webpack_require__(2532), __webpack_require__(2531), __webpack_require__(2520), __webpack_require__(2518), __webpack_require__(2541), __webpack_require__(2536), __webpack_require__(2535), __webpack_require__(2534));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		return CryptoJS;
	
	}));

/***/ },
/* 2522 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Check if typed arrays are supported
		    if (typeof ArrayBuffer != 'function') {
		        return;
		    }
	
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
	
		    // Reference original init
		    var superInit = WordArray.init;
	
		    // Augment WordArray.init to handle typed arrays
		    var subInit = WordArray.init = function (typedArray) {
		        // Convert buffers to uint8
		        if (typedArray instanceof ArrayBuffer) {
		            typedArray = new Uint8Array(typedArray);
		        }
	
		        // Convert other array views to uint8
		        if (
		            typedArray instanceof Int8Array ||
		            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
		            typedArray instanceof Int16Array ||
		            typedArray instanceof Uint16Array ||
		            typedArray instanceof Int32Array ||
		            typedArray instanceof Uint32Array ||
		            typedArray instanceof Float32Array ||
		            typedArray instanceof Float64Array
		        ) {
		            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
		        }
	
		        // Handle Uint8Array
		        if (typedArray instanceof Uint8Array) {
		            // Shortcut
		            var typedArrayByteLength = typedArray.byteLength;
	
		            // Extract bytes
		            var words = [];
		            for (var i = 0; i < typedArrayByteLength; i++) {
		                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
		            }
	
		            // Initialize this word array
		            superInit.call(this, words, typedArrayByteLength);
		        } else {
		            // Else call normal init
		            superInit.apply(this, arguments);
		        }
		    };
	
		    subInit.prototype = WordArray;
		}());
	
	
		return CryptoJS.lib.WordArray;
	
	}));

/***/ },
/* 2523 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Cipher Feedback block mode.
		 */
		CryptoJS.mode.CFB = (function () {
		    var CFB = CryptoJS.lib.BlockCipherMode.extend();
	
		    CFB.Encryptor = CFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher;
		            var blockSize = cipher.blockSize;
	
		            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
		            // Remember this block to use with next block
		            this._prevBlock = words.slice(offset, offset + blockSize);
		        }
		    });
	
		    CFB.Decryptor = CFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher;
		            var blockSize = cipher.blockSize;
	
		            // Remember this block to use with next block
		            var thisBlock = words.slice(offset, offset + blockSize);
	
		            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
		            // This block becomes the previous block
		            this._prevBlock = thisBlock;
		        }
		    });
	
		    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
		        // Shortcut
		        var iv = this._iv;
	
		        // Generate keystream
		        if (iv) {
		            var keystream = iv.slice(0);
	
		            // Remove IV for subsequent blocks
		            this._iv = undefined;
		        } else {
		            var keystream = this._prevBlock;
		        }
		        cipher.encryptBlock(keystream, 0);
	
		        // Encrypt
		        for (var i = 0; i < blockSize; i++) {
		            words[offset + i] ^= keystream[i];
		        }
		    }
	
		    return CFB;
		}());
	
	
		return CryptoJS.mode.CFB;
	
	}));

/***/ },
/* 2524 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/** @preserve
		 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
		 * derived from CryptoJS.mode.CTR
		 * Jan Hruby jhruby.web@gmail.com
		 */
		CryptoJS.mode.CTRGladman = (function () {
		    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
	
			function incWord(word)
			{
				if (((word >> 24) & 0xff) === 0xff) { //overflow
				var b1 = (word >> 16)&0xff;
				var b2 = (word >> 8)&0xff;
				var b3 = word & 0xff;
	
				if (b1 === 0xff) // overflow b1
				{
				b1 = 0;
				if (b2 === 0xff)
				{
					b2 = 0;
					if (b3 === 0xff)
					{
						b3 = 0;
					}
					else
					{
						++b3;
					}
				}
				else
				{
					++b2;
				}
				}
				else
				{
				++b1;
				}
	
				word = 0;
				word += (b1 << 16);
				word += (b2 << 8);
				word += b3;
				}
				else
				{
				word += (0x01 << 24);
				}
				return word;
			}
	
			function incCounter(counter)
			{
				if ((counter[0] = incWord(counter[0])) === 0)
				{
					// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
					counter[1] = incWord(counter[1]);
				}
				return counter;
			}
	
		    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var counter = this._counter;
	
		            // Generate keystream
		            if (iv) {
		                counter = this._counter = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
	
					incCounter(counter);
	
					var keystream = counter.slice(0);
		            cipher.encryptBlock(keystream, 0);
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    CTRGladman.Decryptor = Encryptor;
	
		    return CTRGladman;
		}());
	
	
	
	
		return CryptoJS.mode.CTRGladman;
	
	}));

/***/ },
/* 2525 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Counter block mode.
		 */
		CryptoJS.mode.CTR = (function () {
		    var CTR = CryptoJS.lib.BlockCipherMode.extend();
	
		    var Encryptor = CTR.Encryptor = CTR.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var counter = this._counter;
	
		            // Generate keystream
		            if (iv) {
		                counter = this._counter = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
		            var keystream = counter.slice(0);
		            cipher.encryptBlock(keystream, 0);
	
		            // Increment counter
		            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    CTR.Decryptor = Encryptor;
	
		    return CTR;
		}());
	
	
		return CryptoJS.mode.CTR;
	
	}));

/***/ },
/* 2526 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Electronic Codebook block mode.
		 */
		CryptoJS.mode.ECB = (function () {
		    var ECB = CryptoJS.lib.BlockCipherMode.extend();
	
		    ECB.Encryptor = ECB.extend({
		        processBlock: function (words, offset) {
		            this._cipher.encryptBlock(words, offset);
		        }
		    });
	
		    ECB.Decryptor = ECB.extend({
		        processBlock: function (words, offset) {
		            this._cipher.decryptBlock(words, offset);
		        }
		    });
	
		    return ECB;
		}());
	
	
		return CryptoJS.mode.ECB;
	
	}));

/***/ },
/* 2527 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Output Feedback block mode.
		 */
		CryptoJS.mode.OFB = (function () {
		    var OFB = CryptoJS.lib.BlockCipherMode.extend();
	
		    var Encryptor = OFB.Encryptor = OFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var keystream = this._keystream;
	
		            // Generate keystream
		            if (iv) {
		                keystream = this._keystream = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
		            cipher.encryptBlock(keystream, 0);
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    OFB.Decryptor = Encryptor;
	
		    return OFB;
		}());
	
	
		return CryptoJS.mode.OFB;
	
	}));

/***/ },
/* 2528 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ANSI X.923 padding strategy.
		 */
		CryptoJS.pad.AnsiX923 = {
		    pad: function (data, blockSize) {
		        // Shortcuts
		        var dataSigBytes = data.sigBytes;
		        var blockSizeBytes = blockSize * 4;
	
		        // Count padding bytes
		        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
	
		        // Compute last byte position
		        var lastBytePos = dataSigBytes + nPaddingBytes - 1;
	
		        // Pad
		        data.clamp();
		        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
		        data.sigBytes += nPaddingBytes;
		    },
	
		    unpad: function (data) {
		        // Get number of padding bytes from last byte
		        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		        // Remove padding
		        data.sigBytes -= nPaddingBytes;
		    }
		};
	
	
		return CryptoJS.pad.Ansix923;
	
	}));

/***/ },
/* 2529 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ISO 10126 padding strategy.
		 */
		CryptoJS.pad.Iso10126 = {
		    pad: function (data, blockSize) {
		        // Shortcut
		        var blockSizeBytes = blockSize * 4;
	
		        // Count padding bytes
		        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
		        // Pad
		        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
		             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
		    },
	
		    unpad: function (data) {
		        // Get number of padding bytes from last byte
		        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		        // Remove padding
		        data.sigBytes -= nPaddingBytes;
		    }
		};
	
	
		return CryptoJS.pad.Iso10126;
	
	}));

/***/ },
/* 2530 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ISO/IEC 9797-1 Padding Method 2.
		 */
		CryptoJS.pad.Iso97971 = {
		    pad: function (data, blockSize) {
		        // Add 0x80 byte
		        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));
	
		        // Zero pad the rest
		        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
		    },
	
		    unpad: function (data) {
		        // Remove zero padding
		        CryptoJS.pad.ZeroPadding.unpad(data);
	
		        // Remove one more byte -- the 0x80 byte
		        data.sigBytes--;
		    }
		};
	
	
		return CryptoJS.pad.Iso97971;
	
	}));

/***/ },
/* 2531 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * A noop padding strategy.
		 */
		CryptoJS.pad.NoPadding = {
		    pad: function () {
		    },
	
		    unpad: function () {
		    }
		};
	
	
		return CryptoJS.pad.NoPadding;
	
	}));

/***/ },
/* 2532 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Zero padding strategy.
		 */
		CryptoJS.pad.ZeroPadding = {
		    pad: function (data, blockSize) {
		        // Shortcut
		        var blockSizeBytes = blockSize * 4;
	
		        // Pad
		        data.clamp();
		        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
		    },
	
		    unpad: function (data) {
		        // Shortcut
		        var dataWords = data.words;
	
		        // Unpad
		        var i = data.sigBytes - 1;
		        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
		            i--;
		        }
		        data.sigBytes = i + 1;
		    }
		};
	
	
		return CryptoJS.pad.ZeroPadding;
	
	}));

/***/ },
/* 2533 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(596), __webpack_require__(595));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha1", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var SHA1 = C_algo.SHA1;
		    var HMAC = C_algo.HMAC;
	
		    /**
		     * Password-Based Key Derivation Function 2 algorithm.
		     */
		    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hasher to use. Default: SHA1
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */
		        cfg: Base.extend({
		            keySize: 128/32,
		            hasher: SHA1,
		            iterations: 1
		        }),
	
		        /**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.PBKDF2.create();
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
		         */
		        init: function (cfg) {
		            this.cfg = this.cfg.extend(cfg);
		        },
	
		        /**
		         * Computes the Password-Based Key Derivation Function 2.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */
		        compute: function (password, salt) {
		            // Shortcut
		            var cfg = this.cfg;
	
		            // Init HMAC
		            var hmac = HMAC.create(cfg.hasher, password);
	
		            // Initial values
		            var derivedKey = WordArray.create();
		            var blockIndex = WordArray.create([0x00000001]);
	
		            // Shortcuts
		            var derivedKeyWords = derivedKey.words;
		            var blockIndexWords = blockIndex.words;
		            var keySize = cfg.keySize;
		            var iterations = cfg.iterations;
	
		            // Generate key
		            while (derivedKeyWords.length < keySize) {
		                var block = hmac.update(salt).finalize(blockIndex);
		                hmac.reset();
	
		                // Shortcuts
		                var blockWords = block.words;
		                var blockWordsLength = blockWords.length;
	
		                // Iterations
		                var intermediate = block;
		                for (var i = 1; i < iterations; i++) {
		                    intermediate = hmac.finalize(intermediate);
		                    hmac.reset();
	
		                    // Shortcut
		                    var intermediateWords = intermediate.words;
	
		                    // XOR intermediate with block
		                    for (var j = 0; j < blockWordsLength; j++) {
		                        blockWords[j] ^= intermediateWords[j];
		                    }
		                }
	
		                derivedKey.concat(block);
		                blockIndexWords[0]++;
		            }
		            derivedKey.sigBytes = keySize * 4;
	
		            return derivedKey;
		        }
		    });
	
		    /**
		     * Computes the Password-Based Key Derivation Function 2.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.PBKDF2(password, salt);
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
		     */
		    C.PBKDF2 = function (password, salt, cfg) {
		        return PBKDF2.create(cfg).compute(password, salt);
		    };
		}());
	
	
		return CryptoJS.PBKDF2;
	
	}));

/***/ },
/* 2534 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(239), __webpack_require__(240), __webpack_require__(199), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    // Reusable objects
		    var S  = [];
		    var C_ = [];
		    var G  = [];
	
		    /**
		     * Rabbit stream cipher algorithm.
		     *
		     * This is a legacy version that neglected to convert the key to little-endian.
		     * This error doesn't affect the cipher's security,
		     * but it does affect its compatibility with other implementations.
		     */
		    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var K = this._key.words;
		            var iv = this.cfg.iv;
	
		            // Generate initial state values
		            var X = this._X = [
		                K[0], (K[3] << 16) | (K[2] >>> 16),
		                K[1], (K[0] << 16) | (K[3] >>> 16),
		                K[2], (K[1] << 16) | (K[0] >>> 16),
		                K[3], (K[2] << 16) | (K[1] >>> 16)
		            ];
	
		            // Generate initial counter values
		            var C = this._C = [
		                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
		                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
		                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
		                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
		            ];
	
		            // Carry bit
		            this._b = 0;
	
		            // Iterate the system four times
		            for (var i = 0; i < 4; i++) {
		                nextState.call(this);
		            }
	
		            // Modify the counters
		            for (var i = 0; i < 8; i++) {
		                C[i] ^= X[(i + 4) & 7];
		            }
	
		            // IV setup
		            if (iv) {
		                // Shortcuts
		                var IV = iv.words;
		                var IV_0 = IV[0];
		                var IV_1 = IV[1];
	
		                // Generate four subvectors
		                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
		                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
		                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
		                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);
	
		                // Modify counter values
		                C[0] ^= i0;
		                C[1] ^= i1;
		                C[2] ^= i2;
		                C[3] ^= i3;
		                C[4] ^= i0;
		                C[5] ^= i1;
		                C[6] ^= i2;
		                C[7] ^= i3;
	
		                // Iterate the system four times
		                for (var i = 0; i < 4; i++) {
		                    nextState.call(this);
		                }
		            }
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var X = this._X;
	
		            // Iterate the system
		            nextState.call(this);
	
		            // Generate four keystream words
		            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
		            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
		            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
		            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
	
		            for (var i = 0; i < 4; i++) {
		                // Swap endian
		                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
		                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);
	
		                // Encrypt
		                M[offset + i] ^= S[i];
		            }
		        },
	
		        blockSize: 128/32,
	
		        ivSize: 64/32
		    });
	
		    function nextState() {
		        // Shortcuts
		        var X = this._X;
		        var C = this._C;
	
		        // Save old counter values
		        for (var i = 0; i < 8; i++) {
		            C_[i] = C[i];
		        }
	
		        // Calculate new counter values
		        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
		        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
		        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
		        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
		        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
		        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
		        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
		        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
		        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;
	
		        // Calculate the g-values
		        for (var i = 0; i < 8; i++) {
		            var gx = X[i] + C[i];
	
		            // Construct high and low argument for squaring
		            var ga = gx & 0xffff;
		            var gb = gx >>> 16;
	
		            // Calculate high and low result of squaring
		            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
		            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);
	
		            // High XOR low
		            G[i] = gh ^ gl;
		        }
	
		        // Calculate new state values
		        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
		        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
		        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
		        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
		        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
		        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
		        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
		        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
		     */
		    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
		}());
	
	
		return CryptoJS.RabbitLegacy;
	
	}));

/***/ },
/* 2535 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(239), __webpack_require__(240), __webpack_require__(199), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    // Reusable objects
		    var S  = [];
		    var C_ = [];
		    var G  = [];
	
		    /**
		     * Rabbit stream cipher algorithm
		     */
		    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var K = this._key.words;
		            var iv = this.cfg.iv;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
		                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
		            }
	
		            // Generate initial state values
		            var X = this._X = [
		                K[0], (K[3] << 16) | (K[2] >>> 16),
		                K[1], (K[0] << 16) | (K[3] >>> 16),
		                K[2], (K[1] << 16) | (K[0] >>> 16),
		                K[3], (K[2] << 16) | (K[1] >>> 16)
		            ];
	
		            // Generate initial counter values
		            var C = this._C = [
		                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
		                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
		                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
		                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
		            ];
	
		            // Carry bit
		            this._b = 0;
	
		            // Iterate the system four times
		            for (var i = 0; i < 4; i++) {
		                nextState.call(this);
		            }
	
		            // Modify the counters
		            for (var i = 0; i < 8; i++) {
		                C[i] ^= X[(i + 4) & 7];
		            }
	
		            // IV setup
		            if (iv) {
		                // Shortcuts
		                var IV = iv.words;
		                var IV_0 = IV[0];
		                var IV_1 = IV[1];
	
		                // Generate four subvectors
		                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
		                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
		                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
		                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);
	
		                // Modify counter values
		                C[0] ^= i0;
		                C[1] ^= i1;
		                C[2] ^= i2;
		                C[3] ^= i3;
		                C[4] ^= i0;
		                C[5] ^= i1;
		                C[6] ^= i2;
		                C[7] ^= i3;
	
		                // Iterate the system four times
		                for (var i = 0; i < 4; i++) {
		                    nextState.call(this);
		                }
		            }
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var X = this._X;
	
		            // Iterate the system
		            nextState.call(this);
	
		            // Generate four keystream words
		            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
		            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
		            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
		            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
	
		            for (var i = 0; i < 4; i++) {
		                // Swap endian
		                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
		                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);
	
		                // Encrypt
		                M[offset + i] ^= S[i];
		            }
		        },
	
		        blockSize: 128/32,
	
		        ivSize: 64/32
		    });
	
		    function nextState() {
		        // Shortcuts
		        var X = this._X;
		        var C = this._C;
	
		        // Save old counter values
		        for (var i = 0; i < 8; i++) {
		            C_[i] = C[i];
		        }
	
		        // Calculate new counter values
		        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
		        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
		        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
		        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
		        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
		        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
		        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
		        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
		        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;
	
		        // Calculate the g-values
		        for (var i = 0; i < 8; i++) {
		            var gx = X[i] + C[i];
	
		            // Construct high and low argument for squaring
		            var ga = gx & 0xffff;
		            var gb = gx >>> 16;
	
		            // Calculate high and low result of squaring
		            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
		            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);
	
		            // High XOR low
		            G[i] = gh ^ gl;
		        }
	
		        // Calculate new state values
		        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
		        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
		        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
		        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
		        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
		        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
		        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
		        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
		     */
		    C.Rabbit = StreamCipher._createHelper(Rabbit);
		}());
	
	
		return CryptoJS.Rabbit;
	
	}));

/***/ },
/* 2536 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(239), __webpack_require__(240), __webpack_require__(199), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    /**
		     * RC4 stream cipher algorithm.
		     */
		    var RC4 = C_algo.RC4 = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
		            var keySigBytes = key.sigBytes;
	
		            // Init sbox
		            var S = this._S = [];
		            for (var i = 0; i < 256; i++) {
		                S[i] = i;
		            }
	
		            // Key setup
		            for (var i = 0, j = 0; i < 256; i++) {
		                var keyByteIndex = i % keySigBytes;
		                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;
	
		                j = (j + S[i] + keyByte) % 256;
	
		                // Swap
		                var t = S[i];
		                S[i] = S[j];
		                S[j] = t;
		            }
	
		            // Counters
		            this._i = this._j = 0;
		        },
	
		        _doProcessBlock: function (M, offset) {
		            M[offset] ^= generateKeystreamWord.call(this);
		        },
	
		        keySize: 256/32,
	
		        ivSize: 0
		    });
	
		    function generateKeystreamWord() {
		        // Shortcuts
		        var S = this._S;
		        var i = this._i;
		        var j = this._j;
	
		        // Generate keystream word
		        var keystreamWord = 0;
		        for (var n = 0; n < 4; n++) {
		            i = (i + 1) % 256;
		            j = (j + S[i]) % 256;
	
		            // Swap
		            var t = S[i];
		            S[i] = S[j];
		            S[j] = t;
	
		            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
		        }
	
		        // Update counters
		        this._i = i;
		        this._j = j;
	
		        return keystreamWord;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
		     */
		    C.RC4 = StreamCipher._createHelper(RC4);
	
		    /**
		     * Modified RC4 stream cipher algorithm.
		     */
		    var RC4Drop = C_algo.RC4Drop = RC4.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} drop The number of keystream words to drop. Default 192
		         */
		        cfg: RC4.cfg.extend({
		            drop: 192
		        }),
	
		        _doReset: function () {
		            RC4._doReset.call(this);
	
		            // Drop
		            for (var i = this.cfg.drop; i > 0; i--) {
		                generateKeystreamWord.call(this);
		            }
		        }
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
		     */
		    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
		}());
	
	
		return CryptoJS.RC4;
	
	}));

/***/ },
/* 2537 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/** @preserve
		(c) 2012 by Cédric Mesnil. All rights reserved.
	
		Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
		    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
		    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
		THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		*/
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var _zl = WordArray.create([
		        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
		        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
		        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
		        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
		        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
		    var _zr = WordArray.create([
		        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
		        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
		        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
		        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
		        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
		    var _sl = WordArray.create([
		         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
		        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
		        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
		          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
		        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
		    var _sr = WordArray.create([
		        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
		        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
		        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
		        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
		        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);
	
		    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
		    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);
	
		    /**
		     * RIPEMD160 hash algorithm.
		     */
		    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
		        _doReset: function () {
		            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
		        },
	
		        _doProcessBlock: function (M, offset) {
	
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                // Swap
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
		            // Shortcut
		            var H  = this._hash.words;
		            var hl = _hl.words;
		            var hr = _hr.words;
		            var zl = _zl.words;
		            var zr = _zr.words;
		            var sl = _sl.words;
		            var sr = _sr.words;
	
		            // Working variables
		            var al, bl, cl, dl, el;
		            var ar, br, cr, dr, er;
	
		            ar = al = H[0];
		            br = bl = H[1];
		            cr = cl = H[2];
		            dr = dl = H[3];
		            er = el = H[4];
		            // Computation
		            var t;
		            for (var i = 0; i < 80; i += 1) {
		                t = (al +  M[offset+zl[i]])|0;
		                if (i<16){
			            t +=  f1(bl,cl,dl) + hl[0];
		                } else if (i<32) {
			            t +=  f2(bl,cl,dl) + hl[1];
		                } else if (i<48) {
			            t +=  f3(bl,cl,dl) + hl[2];
		                } else if (i<64) {
			            t +=  f4(bl,cl,dl) + hl[3];
		                } else {// if (i<80) {
			            t +=  f5(bl,cl,dl) + hl[4];
		                }
		                t = t|0;
		                t =  rotl(t,sl[i]);
		                t = (t+el)|0;
		                al = el;
		                el = dl;
		                dl = rotl(cl, 10);
		                cl = bl;
		                bl = t;
	
		                t = (ar + M[offset+zr[i]])|0;
		                if (i<16){
			            t +=  f5(br,cr,dr) + hr[0];
		                } else if (i<32) {
			            t +=  f4(br,cr,dr) + hr[1];
		                } else if (i<48) {
			            t +=  f3(br,cr,dr) + hr[2];
		                } else if (i<64) {
			            t +=  f2(br,cr,dr) + hr[3];
		                } else {// if (i<80) {
			            t +=  f1(br,cr,dr) + hr[4];
		                }
		                t = t|0;
		                t =  rotl(t,sr[i]) ;
		                t = (t+er)|0;
		                ar = er;
		                er = dr;
		                dr = rotl(cr, 10);
		                cr = br;
		                br = t;
		            }
		            // Intermediate hash value
		            t    = (H[1] + cl + dr)|0;
		            H[1] = (H[2] + dl + er)|0;
		            H[2] = (H[3] + el + ar)|0;
		            H[3] = (H[4] + al + br)|0;
		            H[4] = (H[0] + bl + cr)|0;
		            H[0] =  t;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
		            );
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 5; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                // Swap
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
	
		    function f1(x, y, z) {
		        return ((x) ^ (y) ^ (z));
	
		    }
	
		    function f2(x, y, z) {
		        return (((x)&(y)) | ((~x)&(z)));
		    }
	
		    function f3(x, y, z) {
		        return (((x) | (~(y))) ^ (z));
		    }
	
		    function f4(x, y, z) {
		        return (((x) & (z)) | ((y)&(~(z))));
		    }
	
		    function f5(x, y, z) {
		        return ((x) ^ ((y) |(~(z))));
	
		    }
	
		    function rotl(x,n) {
		        return (x<<n) | (x>>>(32-n));
		    }
	
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.RIPEMD160('message');
		     *     var hash = CryptoJS.RIPEMD160(wordArray);
		     */
		    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
		     */
		    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
		}(Math));
	
	
		return CryptoJS.RIPEMD160;
	
	}));

/***/ },
/* 2538 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(961));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha256"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var SHA256 = C_algo.SHA256;
	
		    /**
		     * SHA-224 hash algorithm.
		     */
		    var SHA224 = C_algo.SHA224 = SHA256.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
		                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
		            ]);
		        },
	
		        _doFinalize: function () {
		            var hash = SHA256._doFinalize.call(this);
	
		            hash.sigBytes -= 4;
	
		            return hash;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA224('message');
		     *     var hash = CryptoJS.SHA224(wordArray);
		     */
		    C.SHA224 = SHA256._createHelper(SHA224);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA224(message, key);
		     */
		    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
		}());
	
	
		return CryptoJS.SHA224;
	
	}));

/***/ },
/* 2539 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(375));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var C_algo = C.algo;
	
		    // Constants tables
		    var RHO_OFFSETS = [];
		    var PI_INDEXES  = [];
		    var ROUND_CONSTANTS = [];
	
		    // Compute Constants
		    (function () {
		        // Compute rho offset constants
		        var x = 1, y = 0;
		        for (var t = 0; t < 24; t++) {
		            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;
	
		            var newX = y % 5;
		            var newY = (2 * x + 3 * y) % 5;
		            x = newX;
		            y = newY;
		        }
	
		        // Compute pi index constants
		        for (var x = 0; x < 5; x++) {
		            for (var y = 0; y < 5; y++) {
		                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
		            }
		        }
	
		        // Compute round constants
		        var LFSR = 0x01;
		        for (var i = 0; i < 24; i++) {
		            var roundConstantMsw = 0;
		            var roundConstantLsw = 0;
	
		            for (var j = 0; j < 7; j++) {
		                if (LFSR & 0x01) {
		                    var bitPosition = (1 << j) - 1;
		                    if (bitPosition < 32) {
		                        roundConstantLsw ^= 1 << bitPosition;
		                    } else /* if (bitPosition >= 32) */ {
		                        roundConstantMsw ^= 1 << (bitPosition - 32);
		                    }
		                }
	
		                // Compute next LFSR
		                if (LFSR & 0x80) {
		                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
		                    LFSR = (LFSR << 1) ^ 0x71;
		                } else {
		                    LFSR <<= 1;
		                }
		            }
	
		            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
		        }
		    }());
	
		    // Reusable objects for temporary values
		    var T = [];
		    (function () {
		        for (var i = 0; i < 25; i++) {
		            T[i] = X64Word.create();
		        }
		    }());
	
		    /**
		     * SHA-3 hash algorithm.
		     */
		    var SHA3 = C_algo.SHA3 = Hasher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} outputLength
		         *   The desired number of bits in the output hash.
		         *   Only values permitted are: 224, 256, 384, 512.
		         *   Default: 512
		         */
		        cfg: Hasher.cfg.extend({
		            outputLength: 512
		        }),
	
		        _doReset: function () {
		            var state = this._state = []
		            for (var i = 0; i < 25; i++) {
		                state[i] = new X64Word.init();
		            }
	
		            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcuts
		            var state = this._state;
		            var nBlockSizeLanes = this.blockSize / 2;
	
		            // Absorb
		            for (var i = 0; i < nBlockSizeLanes; i++) {
		                // Shortcuts
		                var M2i  = M[offset + 2 * i];
		                var M2i1 = M[offset + 2 * i + 1];
	
		                // Swap endian
		                M2i = (
		                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
		                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
		                );
		                M2i1 = (
		                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
		                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
		                );
	
		                // Absorb message into state
		                var lane = state[i];
		                lane.high ^= M2i1;
		                lane.low  ^= M2i;
		            }
	
		            // Rounds
		            for (var round = 0; round < 24; round++) {
		                // Theta
		                for (var x = 0; x < 5; x++) {
		                    // Mix column lanes
		                    var tMsw = 0, tLsw = 0;
		                    for (var y = 0; y < 5; y++) {
		                        var lane = state[x + 5 * y];
		                        tMsw ^= lane.high;
		                        tLsw ^= lane.low;
		                    }
	
		                    // Temporary values
		                    var Tx = T[x];
		                    Tx.high = tMsw;
		                    Tx.low  = tLsw;
		                }
		                for (var x = 0; x < 5; x++) {
		                    // Shortcuts
		                    var Tx4 = T[(x + 4) % 5];
		                    var Tx1 = T[(x + 1) % 5];
		                    var Tx1Msw = Tx1.high;
		                    var Tx1Lsw = Tx1.low;
	
		                    // Mix surrounding columns
		                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
		                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
		                    for (var y = 0; y < 5; y++) {
		                        var lane = state[x + 5 * y];
		                        lane.high ^= tMsw;
		                        lane.low  ^= tLsw;
		                    }
		                }
	
		                // Rho Pi
		                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
		                    // Shortcuts
		                    var lane = state[laneIndex];
		                    var laneMsw = lane.high;
		                    var laneLsw = lane.low;
		                    var rhoOffset = RHO_OFFSETS[laneIndex];
	
		                    // Rotate lanes
		                    if (rhoOffset < 32) {
		                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
		                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
		                    } else /* if (rhoOffset >= 32) */ {
		                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
		                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
		                    }
	
		                    // Transpose lanes
		                    var TPiLane = T[PI_INDEXES[laneIndex]];
		                    TPiLane.high = tMsw;
		                    TPiLane.low  = tLsw;
		                }
	
		                // Rho pi at x = y = 0
		                var T0 = T[0];
		                var state0 = state[0];
		                T0.high = state0.high;
		                T0.low  = state0.low;
	
		                // Chi
		                for (var x = 0; x < 5; x++) {
		                    for (var y = 0; y < 5; y++) {
		                        // Shortcuts
		                        var laneIndex = x + 5 * y;
		                        var lane = state[laneIndex];
		                        var TLane = T[laneIndex];
		                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
		                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];
	
		                        // Mix rows
		                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
		                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
		                    }
		                }
	
		                // Iota
		                var lane = state[0];
		                var roundConstant = ROUND_CONSTANTS[round];
		                lane.high ^= roundConstant.high;
		                lane.low  ^= roundConstant.low;;
		            }
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
		            var blockSizeBits = this.blockSize * 32;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
		            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var state = this._state;
		            var outputLengthBytes = this.cfg.outputLength / 8;
		            var outputLengthLanes = outputLengthBytes / 8;
	
		            // Squeeze
		            var hashWords = [];
		            for (var i = 0; i < outputLengthLanes; i++) {
		                // Shortcuts
		                var lane = state[i];
		                var laneMsw = lane.high;
		                var laneLsw = lane.low;
	
		                // Swap endian
		                laneMsw = (
		                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
		                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
		                );
		                laneLsw = (
		                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
		                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
		                );
	
		                // Squeeze state to retrieve hash
		                hashWords.push(laneLsw);
		                hashWords.push(laneMsw);
		            }
	
		            // Return final computed hash
		            return new WordArray.init(hashWords, outputLengthBytes);
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
	
		            var state = clone._state = this._state.slice(0);
		            for (var i = 0; i < 25; i++) {
		                state[i] = state[i].clone();
		            }
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA3('message');
		     *     var hash = CryptoJS.SHA3(wordArray);
		     */
		    C.SHA3 = Hasher._createHelper(SHA3);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA3(message, key);
		     */
		    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
		}(Math));
	
	
		return CryptoJS.SHA3;
	
	}));

/***/ },
/* 2540 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(375), __webpack_require__(962));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core", "./sha512"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var X64WordArray = C_x64.WordArray;
		    var C_algo = C.algo;
		    var SHA512 = C_algo.SHA512;
	
		    /**
		     * SHA-384 hash algorithm.
		     */
		    var SHA384 = C_algo.SHA384 = SHA512.extend({
		        _doReset: function () {
		            this._hash = new X64WordArray.init([
		                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
		                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
		                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
		                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
		            ]);
		        },
	
		        _doFinalize: function () {
		            var hash = SHA512._doFinalize.call(this);
	
		            hash.sigBytes -= 16;
	
		            return hash;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA384('message');
		     *     var hash = CryptoJS.SHA384(wordArray);
		     */
		    C.SHA384 = SHA512._createHelper(SHA384);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA384(message, key);
		     */
		    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
		}());
	
	
		return CryptoJS.SHA384;
	
	}));

/***/ },
/* 2541 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(39), __webpack_require__(239), __webpack_require__(240), __webpack_require__(199), __webpack_require__(68));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var BlockCipher = C_lib.BlockCipher;
		    var C_algo = C.algo;
	
		    // Permuted Choice 1 constants
		    var PC1 = [
		        57, 49, 41, 33, 25, 17, 9,  1,
		        58, 50, 42, 34, 26, 18, 10, 2,
		        59, 51, 43, 35, 27, 19, 11, 3,
		        60, 52, 44, 36, 63, 55, 47, 39,
		        31, 23, 15, 7,  62, 54, 46, 38,
		        30, 22, 14, 6,  61, 53, 45, 37,
		        29, 21, 13, 5,  28, 20, 12, 4
		    ];
	
		    // Permuted Choice 2 constants
		    var PC2 = [
		        14, 17, 11, 24, 1,  5,
		        3,  28, 15, 6,  21, 10,
		        23, 19, 12, 4,  26, 8,
		        16, 7,  27, 20, 13, 2,
		        41, 52, 31, 37, 47, 55,
		        30, 40, 51, 45, 33, 48,
		        44, 49, 39, 56, 34, 53,
		        46, 42, 50, 36, 29, 32
		    ];
	
		    // Cumulative bit shift constants
		    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];
	
		    // SBOXes and round permutation constants
		    var SBOX_P = [
		        {
		            0x0: 0x808200,
		            0x10000000: 0x8000,
		            0x20000000: 0x808002,
		            0x30000000: 0x2,
		            0x40000000: 0x200,
		            0x50000000: 0x808202,
		            0x60000000: 0x800202,
		            0x70000000: 0x800000,
		            0x80000000: 0x202,
		            0x90000000: 0x800200,
		            0xa0000000: 0x8200,
		            0xb0000000: 0x808000,
		            0xc0000000: 0x8002,
		            0xd0000000: 0x800002,
		            0xe0000000: 0x0,
		            0xf0000000: 0x8202,
		            0x8000000: 0x0,
		            0x18000000: 0x808202,
		            0x28000000: 0x8202,
		            0x38000000: 0x8000,
		            0x48000000: 0x808200,
		            0x58000000: 0x200,
		            0x68000000: 0x808002,
		            0x78000000: 0x2,
		            0x88000000: 0x800200,
		            0x98000000: 0x8200,
		            0xa8000000: 0x808000,
		            0xb8000000: 0x800202,
		            0xc8000000: 0x800002,
		            0xd8000000: 0x8002,
		            0xe8000000: 0x202,
		            0xf8000000: 0x800000,
		            0x1: 0x8000,
		            0x10000001: 0x2,
		            0x20000001: 0x808200,
		            0x30000001: 0x800000,
		            0x40000001: 0x808002,
		            0x50000001: 0x8200,
		            0x60000001: 0x200,
		            0x70000001: 0x800202,
		            0x80000001: 0x808202,
		            0x90000001: 0x808000,
		            0xa0000001: 0x800002,
		            0xb0000001: 0x8202,
		            0xc0000001: 0x202,
		            0xd0000001: 0x800200,
		            0xe0000001: 0x8002,
		            0xf0000001: 0x0,
		            0x8000001: 0x808202,
		            0x18000001: 0x808000,
		            0x28000001: 0x800000,
		            0x38000001: 0x200,
		            0x48000001: 0x8000,
		            0x58000001: 0x800002,
		            0x68000001: 0x2,
		            0x78000001: 0x8202,
		            0x88000001: 0x8002,
		            0x98000001: 0x800202,
		            0xa8000001: 0x202,
		            0xb8000001: 0x808200,
		            0xc8000001: 0x800200,
		            0xd8000001: 0x0,
		            0xe8000001: 0x8200,
		            0xf8000001: 0x808002
		        },
		        {
		            0x0: 0x40084010,
		            0x1000000: 0x4000,
		            0x2000000: 0x80000,
		            0x3000000: 0x40080010,
		            0x4000000: 0x40000010,
		            0x5000000: 0x40084000,
		            0x6000000: 0x40004000,
		            0x7000000: 0x10,
		            0x8000000: 0x84000,
		            0x9000000: 0x40004010,
		            0xa000000: 0x40000000,
		            0xb000000: 0x84010,
		            0xc000000: 0x80010,
		            0xd000000: 0x0,
		            0xe000000: 0x4010,
		            0xf000000: 0x40080000,
		            0x800000: 0x40004000,
		            0x1800000: 0x84010,
		            0x2800000: 0x10,
		            0x3800000: 0x40004010,
		            0x4800000: 0x40084010,
		            0x5800000: 0x40000000,
		            0x6800000: 0x80000,
		            0x7800000: 0x40080010,
		            0x8800000: 0x80010,
		            0x9800000: 0x0,
		            0xa800000: 0x4000,
		            0xb800000: 0x40080000,
		            0xc800000: 0x40000010,
		            0xd800000: 0x84000,
		            0xe800000: 0x40084000,
		            0xf800000: 0x4010,
		            0x10000000: 0x0,
		            0x11000000: 0x40080010,
		            0x12000000: 0x40004010,
		            0x13000000: 0x40084000,
		            0x14000000: 0x40080000,
		            0x15000000: 0x10,
		            0x16000000: 0x84010,
		            0x17000000: 0x4000,
		            0x18000000: 0x4010,
		            0x19000000: 0x80000,
		            0x1a000000: 0x80010,
		            0x1b000000: 0x40000010,
		            0x1c000000: 0x84000,
		            0x1d000000: 0x40004000,
		            0x1e000000: 0x40000000,
		            0x1f000000: 0x40084010,
		            0x10800000: 0x84010,
		            0x11800000: 0x80000,
		            0x12800000: 0x40080000,
		            0x13800000: 0x4000,
		            0x14800000: 0x40004000,
		            0x15800000: 0x40084010,
		            0x16800000: 0x10,
		            0x17800000: 0x40000000,
		            0x18800000: 0x40084000,
		            0x19800000: 0x40000010,
		            0x1a800000: 0x40004010,
		            0x1b800000: 0x80010,
		            0x1c800000: 0x0,
		            0x1d800000: 0x4010,
		            0x1e800000: 0x40080010,
		            0x1f800000: 0x84000
		        },
		        {
		            0x0: 0x104,
		            0x100000: 0x0,
		            0x200000: 0x4000100,
		            0x300000: 0x10104,
		            0x400000: 0x10004,
		            0x500000: 0x4000004,
		            0x600000: 0x4010104,
		            0x700000: 0x4010000,
		            0x800000: 0x4000000,
		            0x900000: 0x4010100,
		            0xa00000: 0x10100,
		            0xb00000: 0x4010004,
		            0xc00000: 0x4000104,
		            0xd00000: 0x10000,
		            0xe00000: 0x4,
		            0xf00000: 0x100,
		            0x80000: 0x4010100,
		            0x180000: 0x4010004,
		            0x280000: 0x0,
		            0x380000: 0x4000100,
		            0x480000: 0x4000004,
		            0x580000: 0x10000,
		            0x680000: 0x10004,
		            0x780000: 0x104,
		            0x880000: 0x4,
		            0x980000: 0x100,
		            0xa80000: 0x4010000,
		            0xb80000: 0x10104,
		            0xc80000: 0x10100,
		            0xd80000: 0x4000104,
		            0xe80000: 0x4010104,
		            0xf80000: 0x4000000,
		            0x1000000: 0x4010100,
		            0x1100000: 0x10004,
		            0x1200000: 0x10000,
		            0x1300000: 0x4000100,
		            0x1400000: 0x100,
		            0x1500000: 0x4010104,
		            0x1600000: 0x4000004,
		            0x1700000: 0x0,
		            0x1800000: 0x4000104,
		            0x1900000: 0x4000000,
		            0x1a00000: 0x4,
		            0x1b00000: 0x10100,
		            0x1c00000: 0x4010000,
		            0x1d00000: 0x104,
		            0x1e00000: 0x10104,
		            0x1f00000: 0x4010004,
		            0x1080000: 0x4000000,
		            0x1180000: 0x104,
		            0x1280000: 0x4010100,
		            0x1380000: 0x0,
		            0x1480000: 0x10004,
		            0x1580000: 0x4000100,
		            0x1680000: 0x100,
		            0x1780000: 0x4010004,
		            0x1880000: 0x10000,
		            0x1980000: 0x4010104,
		            0x1a80000: 0x10104,
		            0x1b80000: 0x4000004,
		            0x1c80000: 0x4000104,
		            0x1d80000: 0x4010000,
		            0x1e80000: 0x4,
		            0x1f80000: 0x10100
		        },
		        {
		            0x0: 0x80401000,
		            0x10000: 0x80001040,
		            0x20000: 0x401040,
		            0x30000: 0x80400000,
		            0x40000: 0x0,
		            0x50000: 0x401000,
		            0x60000: 0x80000040,
		            0x70000: 0x400040,
		            0x80000: 0x80000000,
		            0x90000: 0x400000,
		            0xa0000: 0x40,
		            0xb0000: 0x80001000,
		            0xc0000: 0x80400040,
		            0xd0000: 0x1040,
		            0xe0000: 0x1000,
		            0xf0000: 0x80401040,
		            0x8000: 0x80001040,
		            0x18000: 0x40,
		            0x28000: 0x80400040,
		            0x38000: 0x80001000,
		            0x48000: 0x401000,
		            0x58000: 0x80401040,
		            0x68000: 0x0,
		            0x78000: 0x80400000,
		            0x88000: 0x1000,
		            0x98000: 0x80401000,
		            0xa8000: 0x400000,
		            0xb8000: 0x1040,
		            0xc8000: 0x80000000,
		            0xd8000: 0x400040,
		            0xe8000: 0x401040,
		            0xf8000: 0x80000040,
		            0x100000: 0x400040,
		            0x110000: 0x401000,
		            0x120000: 0x80000040,
		            0x130000: 0x0,
		            0x140000: 0x1040,
		            0x150000: 0x80400040,
		            0x160000: 0x80401000,
		            0x170000: 0x80001040,
		            0x180000: 0x80401040,
		            0x190000: 0x80000000,
		            0x1a0000: 0x80400000,
		            0x1b0000: 0x401040,
		            0x1c0000: 0x80001000,
		            0x1d0000: 0x400000,
		            0x1e0000: 0x40,
		            0x1f0000: 0x1000,
		            0x108000: 0x80400000,
		            0x118000: 0x80401040,
		            0x128000: 0x0,
		            0x138000: 0x401000,
		            0x148000: 0x400040,
		            0x158000: 0x80000000,
		            0x168000: 0x80001040,
		            0x178000: 0x40,
		            0x188000: 0x80000040,
		            0x198000: 0x1000,
		            0x1a8000: 0x80001000,
		            0x1b8000: 0x80400040,
		            0x1c8000: 0x1040,
		            0x1d8000: 0x80401000,
		            0x1e8000: 0x400000,
		            0x1f8000: 0x401040
		        },
		        {
		            0x0: 0x80,
		            0x1000: 0x1040000,
		            0x2000: 0x40000,
		            0x3000: 0x20000000,
		            0x4000: 0x20040080,
		            0x5000: 0x1000080,
		            0x6000: 0x21000080,
		            0x7000: 0x40080,
		            0x8000: 0x1000000,
		            0x9000: 0x20040000,
		            0xa000: 0x20000080,
		            0xb000: 0x21040080,
		            0xc000: 0x21040000,
		            0xd000: 0x0,
		            0xe000: 0x1040080,
		            0xf000: 0x21000000,
		            0x800: 0x1040080,
		            0x1800: 0x21000080,
		            0x2800: 0x80,
		            0x3800: 0x1040000,
		            0x4800: 0x40000,
		            0x5800: 0x20040080,
		            0x6800: 0x21040000,
		            0x7800: 0x20000000,
		            0x8800: 0x20040000,
		            0x9800: 0x0,
		            0xa800: 0x21040080,
		            0xb800: 0x1000080,
		            0xc800: 0x20000080,
		            0xd800: 0x21000000,
		            0xe800: 0x1000000,
		            0xf800: 0x40080,
		            0x10000: 0x40000,
		            0x11000: 0x80,
		            0x12000: 0x20000000,
		            0x13000: 0x21000080,
		            0x14000: 0x1000080,
		            0x15000: 0x21040000,
		            0x16000: 0x20040080,
		            0x17000: 0x1000000,
		            0x18000: 0x21040080,
		            0x19000: 0x21000000,
		            0x1a000: 0x1040000,
		            0x1b000: 0x20040000,
		            0x1c000: 0x40080,
		            0x1d000: 0x20000080,
		            0x1e000: 0x0,
		            0x1f000: 0x1040080,
		            0x10800: 0x21000080,
		            0x11800: 0x1000000,
		            0x12800: 0x1040000,
		            0x13800: 0x20040080,
		            0x14800: 0x20000000,
		            0x15800: 0x1040080,
		            0x16800: 0x80,
		            0x17800: 0x21040000,
		            0x18800: 0x40080,
		            0x19800: 0x21040080,
		            0x1a800: 0x0,
		            0x1b800: 0x21000000,
		            0x1c800: 0x1000080,
		            0x1d800: 0x40000,
		            0x1e800: 0x20040000,
		            0x1f800: 0x20000080
		        },
		        {
		            0x0: 0x10000008,
		            0x100: 0x2000,
		            0x200: 0x10200000,
		            0x300: 0x10202008,
		            0x400: 0x10002000,
		            0x500: 0x200000,
		            0x600: 0x200008,
		            0x700: 0x10000000,
		            0x800: 0x0,
		            0x900: 0x10002008,
		            0xa00: 0x202000,
		            0xb00: 0x8,
		            0xc00: 0x10200008,
		            0xd00: 0x202008,
		            0xe00: 0x2008,
		            0xf00: 0x10202000,
		            0x80: 0x10200000,
		            0x180: 0x10202008,
		            0x280: 0x8,
		            0x380: 0x200000,
		            0x480: 0x202008,
		            0x580: 0x10000008,
		            0x680: 0x10002000,
		            0x780: 0x2008,
		            0x880: 0x200008,
		            0x980: 0x2000,
		            0xa80: 0x10002008,
		            0xb80: 0x10200008,
		            0xc80: 0x0,
		            0xd80: 0x10202000,
		            0xe80: 0x202000,
		            0xf80: 0x10000000,
		            0x1000: 0x10002000,
		            0x1100: 0x10200008,
		            0x1200: 0x10202008,
		            0x1300: 0x2008,
		            0x1400: 0x200000,
		            0x1500: 0x10000000,
		            0x1600: 0x10000008,
		            0x1700: 0x202000,
		            0x1800: 0x202008,
		            0x1900: 0x0,
		            0x1a00: 0x8,
		            0x1b00: 0x10200000,
		            0x1c00: 0x2000,
		            0x1d00: 0x10002008,
		            0x1e00: 0x10202000,
		            0x1f00: 0x200008,
		            0x1080: 0x8,
		            0x1180: 0x202000,
		            0x1280: 0x200000,
		            0x1380: 0x10000008,
		            0x1480: 0x10002000,
		            0x1580: 0x2008,
		            0x1680: 0x10202008,
		            0x1780: 0x10200000,
		            0x1880: 0x10202000,
		            0x1980: 0x10200008,
		            0x1a80: 0x2000,
		            0x1b80: 0x202008,
		            0x1c80: 0x200008,
		            0x1d80: 0x0,
		            0x1e80: 0x10000000,
		            0x1f80: 0x10002008
		        },
		        {
		            0x0: 0x100000,
		            0x10: 0x2000401,
		            0x20: 0x400,
		            0x30: 0x100401,
		            0x40: 0x2100401,
		            0x50: 0x0,
		            0x60: 0x1,
		            0x70: 0x2100001,
		            0x80: 0x2000400,
		            0x90: 0x100001,
		            0xa0: 0x2000001,
		            0xb0: 0x2100400,
		            0xc0: 0x2100000,
		            0xd0: 0x401,
		            0xe0: 0x100400,
		            0xf0: 0x2000000,
		            0x8: 0x2100001,
		            0x18: 0x0,
		            0x28: 0x2000401,
		            0x38: 0x2100400,
		            0x48: 0x100000,
		            0x58: 0x2000001,
		            0x68: 0x2000000,
		            0x78: 0x401,
		            0x88: 0x100401,
		            0x98: 0x2000400,
		            0xa8: 0x2100000,
		            0xb8: 0x100001,
		            0xc8: 0x400,
		            0xd8: 0x2100401,
		            0xe8: 0x1,
		            0xf8: 0x100400,
		            0x100: 0x2000000,
		            0x110: 0x100000,
		            0x120: 0x2000401,
		            0x130: 0x2100001,
		            0x140: 0x100001,
		            0x150: 0x2000400,
		            0x160: 0x2100400,
		            0x170: 0x100401,
		            0x180: 0x401,
		            0x190: 0x2100401,
		            0x1a0: 0x100400,
		            0x1b0: 0x1,
		            0x1c0: 0x0,
		            0x1d0: 0x2100000,
		            0x1e0: 0x2000001,
		            0x1f0: 0x400,
		            0x108: 0x100400,
		            0x118: 0x2000401,
		            0x128: 0x2100001,
		            0x138: 0x1,
		            0x148: 0x2000000,
		            0x158: 0x100000,
		            0x168: 0x401,
		            0x178: 0x2100400,
		            0x188: 0x2000001,
		            0x198: 0x2100000,
		            0x1a8: 0x0,
		            0x1b8: 0x2100401,
		            0x1c8: 0x100401,
		            0x1d8: 0x400,
		            0x1e8: 0x2000400,
		            0x1f8: 0x100001
		        },
		        {
		            0x0: 0x8000820,
		            0x1: 0x20000,
		            0x2: 0x8000000,
		            0x3: 0x20,
		            0x4: 0x20020,
		            0x5: 0x8020820,
		            0x6: 0x8020800,
		            0x7: 0x800,
		            0x8: 0x8020000,
		            0x9: 0x8000800,
		            0xa: 0x20800,
		            0xb: 0x8020020,
		            0xc: 0x820,
		            0xd: 0x0,
		            0xe: 0x8000020,
		            0xf: 0x20820,
		            0x80000000: 0x800,
		            0x80000001: 0x8020820,
		            0x80000002: 0x8000820,
		            0x80000003: 0x8000000,
		            0x80000004: 0x8020000,
		            0x80000005: 0x20800,
		            0x80000006: 0x20820,
		            0x80000007: 0x20,
		            0x80000008: 0x8000020,
		            0x80000009: 0x820,
		            0x8000000a: 0x20020,
		            0x8000000b: 0x8020800,
		            0x8000000c: 0x0,
		            0x8000000d: 0x8020020,
		            0x8000000e: 0x8000800,
		            0x8000000f: 0x20000,
		            0x10: 0x20820,
		            0x11: 0x8020800,
		            0x12: 0x20,
		            0x13: 0x800,
		            0x14: 0x8000800,
		            0x15: 0x8000020,
		            0x16: 0x8020020,
		            0x17: 0x20000,
		            0x18: 0x0,
		            0x19: 0x20020,
		            0x1a: 0x8020000,
		            0x1b: 0x8000820,
		            0x1c: 0x8020820,
		            0x1d: 0x20800,
		            0x1e: 0x820,
		            0x1f: 0x8000000,
		            0x80000010: 0x20000,
		            0x80000011: 0x800,
		            0x80000012: 0x8020020,
		            0x80000013: 0x20820,
		            0x80000014: 0x20,
		            0x80000015: 0x8020000,
		            0x80000016: 0x8000000,
		            0x80000017: 0x8000820,
		            0x80000018: 0x8020820,
		            0x80000019: 0x8000020,
		            0x8000001a: 0x8000800,
		            0x8000001b: 0x0,
		            0x8000001c: 0x20800,
		            0x8000001d: 0x820,
		            0x8000001e: 0x20020,
		            0x8000001f: 0x8020800
		        }
		    ];
	
		    // Masks that select the SBOX input
		    var SBOX_MASK = [
		        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
		        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
		    ];
	
		    /**
		     * DES block cipher algorithm.
		     */
		    var DES = C_algo.DES = BlockCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
	
		            // Select 56 bits according to PC1
		            var keyBits = [];
		            for (var i = 0; i < 56; i++) {
		                var keyBitPos = PC1[i] - 1;
		                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
		            }
	
		            // Assemble 16 subkeys
		            var subKeys = this._subKeys = [];
		            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
		                // Create subkey
		                var subKey = subKeys[nSubKey] = [];
	
		                // Shortcut
		                var bitShift = BIT_SHIFTS[nSubKey];
	
		                // Select 48 bits according to PC2
		                for (var i = 0; i < 24; i++) {
		                    // Select from the left 28 key bits
		                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);
	
		                    // Select from the right 28 key bits
		                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
		                }
	
		                // Since each subkey is applied to an expanded 32-bit input,
		                // the subkey can be broken into 8 values scaled to 32-bits,
		                // which allows the key to be used without expansion
		                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
		                for (var i = 1; i < 7; i++) {
		                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
		                }
		                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
		            }
	
		            // Compute inverse subkeys
		            var invSubKeys = this._invSubKeys = [];
		            for (var i = 0; i < 16; i++) {
		                invSubKeys[i] = subKeys[15 - i];
		            }
		        },
	
		        encryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._subKeys);
		        },
	
		        decryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._invSubKeys);
		        },
	
		        _doCryptBlock: function (M, offset, subKeys) {
		            // Get input
		            this._lBlock = M[offset];
		            this._rBlock = M[offset + 1];
	
		            // Initial permutation
		            exchangeLR.call(this, 4,  0x0f0f0f0f);
		            exchangeLR.call(this, 16, 0x0000ffff);
		            exchangeRL.call(this, 2,  0x33333333);
		            exchangeRL.call(this, 8,  0x00ff00ff);
		            exchangeLR.call(this, 1,  0x55555555);
	
		            // Rounds
		            for (var round = 0; round < 16; round++) {
		                // Shortcuts
		                var subKey = subKeys[round];
		                var lBlock = this._lBlock;
		                var rBlock = this._rBlock;
	
		                // Feistel function
		                var f = 0;
		                for (var i = 0; i < 8; i++) {
		                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
		                }
		                this._lBlock = rBlock;
		                this._rBlock = lBlock ^ f;
		            }
	
		            // Undo swap from last round
		            var t = this._lBlock;
		            this._lBlock = this._rBlock;
		            this._rBlock = t;
	
		            // Final permutation
		            exchangeLR.call(this, 1,  0x55555555);
		            exchangeRL.call(this, 8,  0x00ff00ff);
		            exchangeRL.call(this, 2,  0x33333333);
		            exchangeLR.call(this, 16, 0x0000ffff);
		            exchangeLR.call(this, 4,  0x0f0f0f0f);
	
		            // Set output
		            M[offset] = this._lBlock;
		            M[offset + 1] = this._rBlock;
		        },
	
		        keySize: 64/32,
	
		        ivSize: 64/32,
	
		        blockSize: 64/32
		    });
	
		    // Swap bits across the left and right words
		    function exchangeLR(offset, mask) {
		        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
		        this._rBlock ^= t;
		        this._lBlock ^= t << offset;
		    }
	
		    function exchangeRL(offset, mask) {
		        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
		        this._lBlock ^= t;
		        this._rBlock ^= t << offset;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
		     */
		    C.DES = BlockCipher._createHelper(DES);
	
		    /**
		     * Triple-DES block cipher algorithm.
		     */
		    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
	
		            // Create DES instances
		            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
		            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
		            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
		        },
	
		        encryptBlock: function (M, offset) {
		            this._des1.encryptBlock(M, offset);
		            this._des2.decryptBlock(M, offset);
		            this._des3.encryptBlock(M, offset);
		        },
	
		        decryptBlock: function (M, offset) {
		            this._des3.decryptBlock(M, offset);
		            this._des2.encryptBlock(M, offset);
		            this._des1.decryptBlock(M, offset);
		        },
	
		        keySize: 192/32,
	
		        ivSize: 64/32,
	
		        blockSize: 64/32
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
		     */
		    C.TripleDES = BlockCipher._createHelper(TripleDES);
		}());
	
	
		return CryptoJS.TripleDES;
	
	}));

/***/ },
/* 2542 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2543)();
	// imports
	
	
	// module
	exports.push([module.id, "button.large{height:54px;width:auto;padding:0 15px;margin:10px 0;border:1px solid #1d1937;color:#1d1937;border-radius:4px;background-color:transparent;cursor:pointer;-webkit-user-drag:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;text-align:center}button.large,button.large p{display:inline-block;transition:all .2s ease-in-out}button.large p{font-size:18px;font-weight:600;line-height:50px;padding:0;white-space:nowrap}button.large img.google{width:auto;height:20px;margin:15px 6px;display:inline-block;vertical-align:top}button.large.wide{padding:0 100px}button.large:hover{border:1px solid #8e8c9b}button.large:hover p{color:#8e8c9b}button.large:hover img.google{opacity:.7}button.large.rose{border:1px solid #fc4085;background-color:#fc4085;color:#fff}button.large.rose:hover{border:1px solid #e33a78;background-color:#e33a78}button.large.rose:hover p{color:#fff}button.large.seagreen{border:1px solid #20c49e;background-color:#20c49e;color:#fff}button.large.seagreen:hover{border:1px solid #1db08e;background-color:#1db08e}button.large.seagreen:hover p{color:#fff}button.small{height:34px;padding:0 10px;margin:10px}button.small img{width:18px!important;height:18px!important;vertical-align:top;margin:4px 0!important;display:inline-block;float:right}button.small.small-image img{width:20px!important;height:20px!important}button.small.seagreen{border:1px solid #20c49e;background-color:#20c49e;color:#fff}button.small.seagreen:hover{opacity:1;border:2px solid #1db08e;background-color:#1db08e}button.small.seagreen:hover p{color:#fff}button.medium{height:46px;width:auto;padding:0 10px;margin:10px 0;border:2px solid #1d1937;color:#1d1937;border-radius:4px;background-color:transparent;cursor:pointer;-webkit-user-drag:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;text-align:center}button.medium,button.medium p{display:inline-block;transition:all .2s ease-in-out}button.medium p{font-size:16px;font-weight:600;line-height:26px;padding:0;float:left;white-space:nowrap}button.medium img{width:24px!important;height:24px!important;opacity:1;display:inline-block;float:right;transition:all .2s ease-in-out}button.medium.small-image img{width:20px!important;height:20px!important}button.medium.grey-icon{border:2px solid #e8e8eb;border-radius:0;background:#e8e8eb}button.medium.grey-icon:first-child{margin-right:0!important}button.medium.grey-icon:last-child{border-radius:0 4px 4px 0;margin-right:10px!important}button.medium:hover{opacity:.5}button.medium.wide{padding:0 100px}button.medium.small-wide{padding:0 50px}button.medium.rose{border:2px solid #fc4085;background-color:#fc4085;color:#fff}button.medium.rose:hover{opacity:1;border:2px solid #e33a78;background-color:#e33a78}button.medium.rose:hover p{color:#fff}button.medium.seagreen{border:2px solid #20c49e;background-color:#20c49e;color:#fff}button.medium.seagreen:hover{opacity:1;border:2px solid #1db08e;background-color:#1db08e}button.medium.seagreen:hover p{color:#fff}button.outline-seagreen{border:2px solid #20c49e;background-color:#fff;color:#20c49e}button.outline-seagreen:hover{opacity:1;border:2px solid #20c49e;cursor:default}button.outline-seagreen:hover p{color:#20c49e}button.small{height:30px;width:auto;padding:0 12px;margin:10px 0;border:2px solid #1d1937;color:#1d1937;border-radius:4px;background-color:transparent;cursor:pointer;-webkit-user-drag:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;text-align:center}button.small,button.small p{display:inline-block;transition:all .2s ease-in-out}button.small p{font-size:14px;font-weight:600;line-height:26px;white-space:nowrap;padding:0;vertical-align:top;margin:0}button.small img{max-width:24px;max-height:24px;padding:1px 0;opacity:1;transition:all .2s ease-in-out}button.small img.open{transform:rotate(180deg);-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg)}button.small.icon{padding-right:6px}button.small.icon img{margin-left:0}button.small:hover{opacity:.5}button.stretch{width:100%}button.icon img{margin-left:10px}button.add-person{height:44px;width:44px;border:2px solid #1d1937;border-radius:100%;background-color:transparent;cursor:pointer;-webkit-user-drag:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;text-align:center;transition:all .2s ease-in-out;padding:8px 0;opacity:1}button.add-person img{width:24px;height:24px}button.add-person:hover{opacity:.5}button.message{height:60px;width:60px;border:2px solid #1d1937;background-color:transparent;cursor:pointer;-webkit-user-drag:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;text-align:center;transition:all .2s ease-in-out;padding:12px;margin:0;border-radius:4px;opacity:1}button.message img{width:24px;height:24px}button.message:hover{opacity:.5}button.message.inactive,button.message.inactive:hover{opacity:0}button.message.rose{border:2px solid #fc4085;background-color:#fc4085;color:#fff;cursor:pointer}button.message.rose:hover{opacity:1;border:2px solid #e33a78;background-color:#e33a78}button.message.rose:hover p{color:#fff}button.message.seagreen{border:2px solid #20c49e;background-color:#20c49e;color:#fff;margin-bottom:20px;cursor:pointer}button.message.seagreen:hover{opacity:1;border:2px solid #1db08e;background-color:#1db08e}button.message.seagreen:hover p{color:#fff}button.dropdown{margin:0!important}button.dropdown:hover{opacity:1!important}button.large .dots{height:50px;padding:18px 0}button.large .dots,button.medium .dots{list-style-type:none;width:100%;margin:0}button.medium .dots{height:36px;padding:11px 0}.dots>li{width:14px;height:14px;display:inline-block;vertical-align:top;margin:0;padding:0;background-color:hsla(0,0%,100%,0);border-radius:100%}button.more{width:36px;height:36px;border:2px solid #1d1937;border-radius:4px;background:transparent;background-image:url(\"/icons/more.svg\");background-size:24px 24px;background-position:50%;background-repeat:no-repeat;cursor:pointer;opacity:1;transition:opacity .2s}button.more:hover{opacity:.5}#dot1{animation:dot-fader 1s linear 0s infinite}#dot2{animation:dot-fader 1s linear .125s infinite}#dot3{animation:dot-fader 1s linear .25s infinite}@keyframes dot-fader{0%{background-color:hsla(0,0%,100%,0)}12.5%{background-color:hsla(0,0%,100%,.4)}25%{background-color:hsla(0,0%,100%,.8)}37.5%{background-color:hsla(0,0%,100%,.8)}50%{background-color:hsla(0,0%,100%,.4)}62.5%{background-color:hsla(0,0%,100%,0)}75%{background-color:hsla(0,0%,100%,0)}}@media only screen and (max-width:768px){button.large.wide{width:100%;padding:0 15px}button.medium.wide{width:100%;padding:0 10px}button.small.wide{width:100%;padding:0 12px}}button.disabled,button:disabled{background-color:#e8e8eb;color:#8b8998;pointer-events:none;border:1px solid #e8e8eb;opacity:.7}button.mixed{border:2px solid #d2d1d7;cursor:default}button.mixed,button.mixed:hover{background:transparent;color:#20c49e}button.mixed:hover{border:2px solid #1d1937}.text-button-container{width:250px;display:flex;align-items:center;justify-content:flex-end}.text-button-container p{flex:0 0 210px;text-align:right;font-weight:600;padding-right:8px}.text-button-container p a{color:#1d1937}.text-button-container p a:hover{color:#fc4085}.text-button-container .add-button{width:40px;height:40px;margin:0!important;text-align:center;display:flex;align-items:center;justify-content:center}.text-button-container .add-button img{flex:0 0 24px}.ui.red.button{background:#ef3a50;color:#fff;border:none}.ui.red.button:hover{background:#f15265;opacity:1}button.ui.green.button:hover{background-color:#1cae8c}html{font-family:sans-serif;line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,figcaption,figure,footer,header,main,nav,section{display:block}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button:active,button:focus{outline:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}p.small.error{color:#ef3a50}.option-separator{width:100%;height:48px;overflow:hidden;display:flex;flex-wrap:nowrap;justify-content:flex-start}.option-separator .left{height:23px;border-bottom:1px solid #d2d1d7;margin-bottom:24px;order:1;flex-grow:10;flex-basis:auto}.option-separator .center{order:2;flex-basis:content;padding:0 20px}.option-separator .center p{line-height:48px}.option-separator .right{height:23px;border-bottom:1px solid #d2d1d7;margin-bottom:24px;order:3;flex-grow:10;flex-basis:auto}.form-field{width:auto;height:auto;position:relative}.form-field img{width:auto;height:24px;position:absolute;top:20px;left:12px}.form-field .field-symbol{position:absolute;top:20px;left:10px}.form-field .field-status{width:24px;height:24px;position:absolute;top:11px;right:11px;overflow:hidden}.form-field .field-status img{position:static}.form-field.status input{margin:0}.form-field.status p.field-symbol{top:13px}.form-field.status img{top:10px;left:auto;right:10px}.radio-row{width:300%;height:64px}.form-field input,input[type=color],input[type=date],input[type=datetime-local],input[type=datetime],input[type=email],input[type=month],input[type=number],input[type=password],input[type=search],input[type=tel],input[type=text],input[type=time],input[type=url],input[type=week],select{width:100%;padding:12px 14px;display:inline-block;border:1px solid #d2d1d7;border-radius:4px;vertical-align:middle;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;font-family:Varela Round;font-size:16px;line-height:16px;color:#1d1937;font-weight:400;background-color:#fff;margin:10px 0 20px;resize:none;transition:all .2s ease-in-out}.form-field input:focus,input[type=color]:focus,input[type=date]:focus,input[type=datetime-local]:focus,input[type=datetime]:focus,input[type=email]:focus,input[type=month]:focus,input[type=number]:focus,input[type=password]:focus,input[type=search]:focus,input[type=tel]:focus,input[type=text]:focus,input[type=time]:focus,input[type=url]:focus,input[type=week]:focus,select:focus{outline:none;border:1px solid #1d1937}.form-field input.error,input[type=color].error,input[type=date].error,input[type=datetime-local].error,input[type=datetime].error,input[type=email].error,input[type=month].error,input[type=number].error,input[type=password].error,input[type=search].error,input[type=tel].error,input[type=text].error,input[type=time].error,input[type=url].error,input[type=week].error,select.error{border:1px solid #fc4085}.form-field input.stacked,input[type=color].stacked,input[type=date].stacked,input[type=datetime-local].stacked,input[type=datetime].stacked,input[type=email].stacked,input[type=month].stacked,input[type=number].stacked,input[type=password].stacked,input[type=search].stacked,input[type=tel].stacked,input[type=text].stacked,input[type=time].stacked,input[type=url].stacked,input[type=week].stacked,select.stacked{margin:10px 0 0}.form-field input.disabled,input[type=color].disabled,input[type=date].disabled,input[type=datetime-local].disabled,input[type=datetime].disabled,input[type=email].disabled,input[type=month].disabled,input[type=number].disabled,input[type=password].disabled,input[type=search].disabled,input[type=tel].disabled,input[type=text].disabled,input[type=time].disabled,input[type=url].disabled,input[type=week].disabled,select.disabled{border:1px solid #d8d8d8;background-color:#e8e8eb;color:#4b475f;cursor:not-allowed}.form-field input.small-margin,input[type=color].small-margin,input[type=date].small-margin,input[type=datetime-local].small-margin,input[type=datetime].small-margin,input[type=email].small-margin,input[type=month].small-margin,input[type=number].small-margin,input[type=password].small-margin,input[type=search].small-margin,input[type=tel].small-margin,input[type=text].small-margin,input[type=time].small-margin,input[type=url].small-margin,input[type=week].small-margin,select.small-margin{margin:10px 0 5px}.form-field.number input{padding-left:22px}.form-field.number.disabled input{color:rgba(29,25,55,.5)}.form-field.number.disabled p.field-symbol{opacity:.5}.form-field.number.editable input{border-radius:4px 0 0 4px;border-right:none}.disabled-text{color:#e4e4e4}textarea{width:100%;height:160px;padding:8px 14px;display:inline-block;border:1px solid #d2d1d7;border-radius:4px;vertical-align:middle;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;font-family:Varela Round;font-size:16px;line-height:26px;color:#1d1937;font-weight:400;background-color:#fff;margin:0;resize:none;transition:all .2s ease-in-out}textarea:focus{outline:none;border:1px solid #1d1937}textarea.error{border:1px solid #fc4085}textarea.stacked{margin:10px 0 0}textarea.disabled{border:1px solid #d8d8d8;background-color:#e8e8eb;color:#4b475f;cursor:not-allowed}.form-field.image input[type=color],.form-field.image input[type=date],.form-field.image input[type=datetime-local],.form-field.image input[type=datetime],.form-field.image input[type=email],.form-field.image input[type=month],.form-field.image input[type=number],.form-field.image input[type=password],.form-field.image input[type=search],.form-field.image input[type=tel],.form-field.image input[type=text],.form-field.image input[type=time],.form-field.image input[type=url],.form-field.image input[type=week],.form-field.image select,.form-field.image textarea{padding:12px 14px 12px 46px}label{font-family:Varela Round,Arial Rounded MT,Arial,sans-serif;font-size:18px;font-weight:600;font-style:normal;text-transform:none;text-decoration:none;line-height:26px;margin:0;padding:0;color:#1d1937}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=radio]{display:none}input[type=checkbox]{display:inline-block;width:24px;height:24px;margin:8px 0;vertical-align:top}input[type=radio]+label p{display:inline-block;float:left;line-height:40px;padding-right:20px}input[type=checkbox]+label p{display:inline-block;padding-left:10px;line-height:40px;vertical-align:top}input[type=radio]:not(old)+label span{display:inline-block;float:left;width:18px;height:18px;border:1px solid #d2d1d7;background-color:#fff;box-sizing:border-box;border-radius:100%;margin:10px 10px 10px 0}input[type=radio].disabled+label span{border:1px solid #d8d8d8;background-color:#e8e8eb;cursor:not-allowed}input[type=radio]:not(old):checked+label span{border:4px solid #fc4085;background-color:#fff}input[type=submit],input[type=text],textarea{-webkit-appearance:none}.form-break{width:100%;height:19px;border-bottom:1px solid #d2d1d7;margin-bottom:20px}p.form-label{font-family:Varela Round,Arial Rounded MT,Arial,sans-serif;font-size:18px;font-weight:600;font-style:normal;text-transform:none;text-decoration:none;line-height:26px;margin:0;padding:0;color:#1d1937}p.form-label img{width:22px;height:22px;display:inline-block;vertical-align:middle;padding:0 10px;margin-top:-2px;cursor:pointer;opacity:.7;transition:all .2s ease-in-out}p.form-label img:hover{opacity:1}p.small.error{margin-top:-10px}p.small.error.stacked{margin-top:10px}.Select{position:relative}.Select,.Select div,.Select input,.Select span{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.Select-control{background-color:#fff;border-radius:4px;border:1px solid #d2d1d7;color:#1d1937;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:46px;outline:none;overflow:hidden;position:relative;width:100%;margin:10px 0;float:left}.Select.stacked .Select-control{margin:10px 0 0}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none}.is-searchable.is-open>.Select-control{cursor:text}.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#1d1937}.is-open>.Select-control>.Select-arrow{border-color:transparent transparent #999;border-width:0 5px 5px}.is-searchable.is-focused:not(.is-open)>.Select-control{cursor:text}.is-focused:not(.is-open)>.Select-control{border-color:#1d1937}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:46px;padding-left:14px;padding-right:14px;font-family:Varela Round;font-size:16px;font-weight:400;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:none;text-decoration:underline}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:transparent;line-height:32px;font-family:Varela Round,sans-serif;font-size:16px;font-weight:400;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;-o-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;-o-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0}.is-open .Select-arrow,.Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden}@-webkit-keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{background-color:#fff;border:1px solid #d2d1d7;border-radius:4px;-webkit-box-shadow:0 2px 10px 0 rgba(0,0,0,.2);-moz-box-shadow:0 2px 10px 0 rgba(0,0,0,.2);box-shadow:0 2px 10px 0 rgba(0,0,0,.2);box-sizing:border-box;max-height:210px;padding:5px;position:absolute;top:10px;width:100%;-webkit-overflow-scrolling:touch;z-index:31}.Select-menu{max-height:190px;overflow-y:auto}.Select-option{width:100%;height:40px;border-radius:4px;box-sizing:border-box;color:#1d1937;font-family:Varela Round,Arial Rounded MT,Arial,sans-serif;font-size:16px;font-weight:400;font-style:normal;text-transform:none;text-decoration:none;line-height:40px;margin:0;padding:0;cursor:pointer;display:block;padding:0 10px;overflow:hidden;white-space:nowrap;text-align:left;text-overflow:ellipsis;transition:all .1s ease-in-out}.Select-menu:first-child{color:gray}.Select-option.is-selected{background-color:#ffecf3}.Select-option.is-focused{background-color:#fc4085;color:#fff}.Select-option.is-disabled{border:1px solid #d8d8d8;background-color:#e8e8eb;color:#4b475f;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{border:1px solid #d8d8d8;background-color:#e8e8eb;color:#4b475f}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon,.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{border:1px solid #d8d8d8;background-color:#e8e8eb;color:#4b475f}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}.uploader{position:relative;z-index:10}.uploader,.uploader .file-drop{width:100%;height:240px;border-radius:4px}.uploader .file-drop{position:absolute;top:0;left:0;box-sizing:border-box}.uploader .file-drop .file-drop-target{width:100vw;height:100vh;position:fixed;top:0;left:0;box-sizing:border-box;background-color:transparent;border:10px solid #20c49e;z-index:-1;visibility:hidden;opacity:0;border-radius:0}.uploader .file-drop .file-drop-target.file-drop-dragging-over-frame{z-index:41;visibility:visible;opacity:1}.uploader .uploader-content{width:100%;height:240px;position:absolute;top:0;left:0;display:table;border-collapse:separate;padding:0;margin:0;background-color:#f7fafa;border:none;border-radius:4px}.uploader .uploader-content .uploader-center{display:table-cell;width:100%;height:200px;box-sizing:border-box;vertical-align:middle;text-align:center;border:1px dashed #d2d1d7;border-radius:4px}.uploader .uploader-content .uploader-center img{width:60px;height:60px}.uploader .uploader-content .uploader-center .uploading-spinner{width:60px;height:60px;box-sizing:border-box;border:2px solid #92f2dc;border-top:2px solid #20c49e;border-radius:100%;margin:0 auto;animation:spin 2s linear infinite}.uploader .uploader-content .uploader-center .processing-spinner{width:60px;height:60px;box-sizing:border-box;border:2px dashed #20c49e;border-radius:100%;margin:0 auto;animation:spin 2s linear infinite}.uploader .uploader-content .uploader-center p{width:100%;height:26px;color:#20c49e;position:relative}.uploader .uploader-content .uploader-center p.black{color:#1d1937;font-weight:700}.uploader .uploader-content .uploader-center p .absolute{width:100%;height:26px;text-align:center;position:absolute;top:26px;left:0}.uploader input.uploader{width:.01px;height:.01px;visibility:hidden;opacity:0;position:absolute;top:0;left:0}.uploader input.uploader+label{width:100%;height:240px;position:absolute;top:0;left:0;cursor:pointer}.uploader.display{height:84px}.uploader.display .file-drop{height:60px}.uploader.display .uploader-content{height:60px;background-color:#fff}.uploader.display .uploader-content .uploader-center{border:none;background-color:#fff;padding:0;height:60px}.uploader.display .uploader-content .uploader-center .uploaded-document{width:100%;height:60px;box-sizing:border-box;border:1px solid #d2d1d7;border-radius:4px;margin-bottom:20px}.uploader.display .uploader-content .uploader-center .uploaded-document .center,.uploader.display .uploader-content .uploader-center .uploaded-document .left,.uploader.display .uploader-content .uploader-center .uploaded-document .right{display:inline-block;vertical-align:top;margin:0}.uploader.display .uploader-content .uploader-center .uploaded-document .left,.uploader.display .uploader-content .uploader-center .uploaded-document .right{width:58px;height:58px;box-sizing:border-box;padding:17px}.uploader.display .uploader-content .uploader-center .uploaded-document .left img,.uploader.display .uploader-content .uploader-center .uploaded-document .right img{width:24px;height:24px}.uploader.display .uploader-content .uploader-center .uploaded-document .center{width:calc(100% - 116px);height:58px;box-sizing:border-box;padding:17px 0;text-align:left}.uploader.display .uploader-content .uploader-center .uploaded-document .center p{width:100%;height:24px;line-height:24px;overflow:hidden;text-overflow:ellipsis;color:#d2d1d7;word-break:break-all}.uploader.display .uploader-content .uploader-center .uploaded-document .right img{cursor:pointer}.uploader.display .uploader-content .uploader-center .uploaded-message{width:100%;height:100px;box-sizing:border-box;border:none;border-radius:4px}.uploader.display .uploader-content .uploader-center .uploaded-message textarea{max-height:98px;border:none}.uploader.display .uploader-content .uploader-center .uploaded-submit{width:100%;height:40px;box-sizing:border-box;margin-top:20px;text-align:right}.uploader.display .uploader-content .uploader-center .uploaded-submit button.medium{margin:0}.uploader.display .uploader-content .uploader-center .uploaded-submit button.medium p{color:#fff}.ui label{line-height:normal}.datepicker-wrapper{width:100%;height:auto;padding:10px 0 20px}.SingleDatePicker,.SingleDatePickerInput{width:100%}table.form tr td.1-3{background-color:green!important}.checkbox-wrapper{display:flex;margin:10px 0 0;flex-direction:column}.checkbox-wrapper .checkbox-row{display:flex;flex:1 1 auto}.checkbox-wrapper .checkbox-row span{flex:1 1 auto}.flex{display:flex;justify-content:flex-start;align-items:center;vertical-align:middle}.flex .item{flex:0 0 content;white-space:nowrap}.flex .space{flex:1 1 auto;padding:10px}.flex .equal{flex:1 1 0}.flex .space:first-child{padding-left:0}.flex .space:last-child{padding-right:0}.flex.top{align-items:flex-start;vertical-align:top}.grid p.info{padding:0 15px}.grid-0,.grid-0-6,.grid-1,.grid-1-1,.grid-1-2,.grid-1-3,.grid-1-6,.grid-2-3,.grid-2-6,.grid-3-6,.grid-4-6,.grid-5-6,.grid-6-6{display:inline-block;*display:inline;zoom:1;letter-spacing:normal;word-spacing:normal;vertical-align:top;text-rendering:auto;box-sizing:border-box;padding:15px}.grid-0-6{display:none}.grid-1-6{width:16.6667%;*width:16.6357%}.grid-1-3,.grid-2-6{width:33.3333%;*width:33.3023%}.grid-1-2,.grid-3-6{width:50%;*width:49.969%}.grid-2-3,.grid-4-6{width:66.6667%;*width:66.6357%}.grid-5-6{width:83.3333%;*width:83.3023%}.grid-1,.grid-1-1,.grid-6-6{width:100%}@media screen and (min-width:375px){.grid-sm-1,.grid-sm-1-1,.grid-sm-1-2,.grid-sm-1-3,.grid-sm-1-6,.grid-sm-2-3,.grid-sm-2-6,.grid-sm-3-6,.grid-sm-4-6,.grid-sm-5-6,.grid-sm-6-6{display:inline-block;*display:inline;zoom:1;letter-spacing:normal;word-spacing:normal;vertical-align:top;text-rendering:auto}.grid-sm-0-6{display:none}.grid-sm-1-6{width:16.6667%;*width:16.6357%}.grid-sm-1-3,.grid-sm-2-6{width:33.3333%;*width:33.3023%}.grid-sm-1-2,.grid-sm-3-6{width:50%;*width:49.969%}.grid-sm-2-3,.grid-sm-4-6{width:66.6667%;*width:66.6357%}.grid-sm-5-6{width:83.3333%;*width:83.3023%}.grid-sm-1,.grid-sm-1-1,.grid-sm-6-6{width:100%}}@media screen and (min-width:768px){.grid-md-1,.grid-md-1-1,.grid-md-1-2,.grid-md-1-3,.grid-md-1-6,.grid-md-2-3,.grid-md-2-6,.grid-md-3-6,.grid-md-4-6,.grid-md-5-6,.grid-md-6-6{display:inline-block;*display:inline;zoom:1;letter-spacing:normal;word-spacing:normal;vertical-align:top;text-rendering:auto}.grid-md-0-6{display:none}.grid-md-1-6{width:16.6667%;*width:16.6357%}.grid-md-1-3,.grid-md-2-6{width:33.3333%;*width:33.3023%}.grid-md-1-2,.grid-md-3-6{width:50%;*width:49.969%}.grid-md-2-3,.grid-md-4-6{width:66.6667%;*width:66.6357%}.grid-md-5-6{width:83.3333%;*width:83.3023%}.grid-md-1,.grid-md-1-1,.grid-md-6-6{width:100%}}@media screen and (min-width:1024px){.grid-lg-1,.grid-lg-1-1,.grid-lg-1-2,.grid-lg-1-3,.grid-lg-1-6,.grid-lg-2-3,.grid-lg-2-6,.grid-lg-3-6,.grid-lg-4-6,.grid-lg-5-6,.grid-lg-6-6{display:inline-block;*display:inline;zoom:1;letter-spacing:normal;word-spacing:normal;vertical-align:top;text-rendering:auto}.grid-lg-0-6{display:none}.grid-lg-1-6{width:16.6667%;*width:16.6357%}.grid-lg-1-3,.grid-lg-2-6{width:33.3333%;*width:33.3023%}.grid-lg-1-2,.grid-lg-3-6{width:50%;*width:49.969%}.grid-lg-2-3,.grid-lg-4-6{width:66.6667%;*width:66.6357%}.grid-lg-5-6{width:83.3333%;*width:83.3023%}.grid-lg-1,.grid-lg-1-1,.grid-lg-6-6{width:100%}}@media screen and (min-width:1440px){.grid-xl-1,.grid-xl-1-1,.grid-xl-1-2,.grid-xl-1-3,.grid-xl-1-6,.grid-xl-2-3,.grid-xl-2-6,.grid-xl-3-6,.grid-xl-4-6,.grid-xl-5-6,.grid-xl-6-6{display:inline-block;*display:inline;zoom:1;letter-spacing:normal;word-spacing:normal;vertical-align:top;text-rendering:auto}.grid-xl-0-6{display:none}.grid-xl-1-6{width:16.6667%;*width:16.6357%}.grid-xl-1-3,.grid-xl-2-6{width:33.3333%;*width:33.3023%}.grid-xl-1-2,.grid-xl-3-6{width:50%;*width:49.969%}.grid-xl-2-3,.grid-xl-4-6{width:66.6667%;*width:66.6357%}.grid-xl-5-6{width:83.3333%;*width:83.3023%}.grid-xl-1,.grid-xl-1-1,.grid-xl-6-6{width:100%}}.grid.list{background-color:#fff}.grid.list p{line-height:68px}.grid.list button.profile p{line-height:36px}.break{width:100%;height:1px;background-color:#d2d1d7;border:none}.break.light{background-color:#e8e8eb}.page-modal-title{width:100%;height:auto;padding:30px 0}.page-modal-title h1{line-height:60px;display:inline-block;vertical-align:top;margin:0}.page-modal-title img{width:40px;height:40px;float:right;vertical-align:top;margin:10px 0;opacity:1;cursor:pointer;transition:all .2s ease-in-out}.page-modal-title img:hover{opacity:.5}.mobile-menu{width:100%;height:auto;top:60px;left:0;position:absolute;background-color:#1d1937;padding:0 calc(50vw - 570px);box-sizing:border-box;z-index:11}.mobile-menu ul{width:100%;height:auto;list-style-type:none}.mobile-menu ul li{width:100%;height:60px;box-sizing:border-box;padding-left:10px}.mobile-menu ul li p{line-height:60px;color:#fff;transition:all .2s ease-in-out}.mobile-menu ul li:hover{cursor:pointer}.mobile-menu ul li:hover p{opacity:.5}.page-navigation-header{width:100vw;height:60px;background-color:#1d1937;padding:0 calc(50vw - 670px);display:flex;flex-wrap:nowrap;justify-content:flex-start;align-items:center;z-index:11}.page-navigation-header .flex-item{flex:0 1 auto;min-width:0;white-space:nowrap;text-overflow:ellipsis}.page-navigation-header .flex-item img.logo{width:auto;height:40px}.page-navigation-header .flex-item p{width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;color:#fff;padding:0 10px;display:inline}.page-navigation-header .flex-item p img{display:inline;vertical-align:top;margin:0}.page-navigation-header .flex-item p a.feedback{padding:8px 10px;border:1px solid #fff;border-radius:4px}.page-navigation-header .flex-item a,.page-navigation-header .flex-item img.logo,.page-navigation-header .flex-item img.menu{color:#fff;cursor:pointer;text-decoration:none;font-weight:400;transition:opacity .1s ease-in-out}.page-navigation-header .flex-item a:hover,.page-navigation-header .flex-item img.logo:hover,.page-navigation-header .flex-item img.menu:hover{opacity:.5}.page-navigation-header .flex-item.mobile{flex:0 0 content;display:none}.page-navigation-header .flex-item.dropdown{flex:0 0 content}.page-navigation-header .flex-spacer{flex:1 1 auto}@media only screen and (max-width:1440px){.page-navigation-header{padding:0 15px}}@media only screen and (max-width:1024px){.page-navigation-header{padding:0 15px}}@media only screen and (max-width:940px){.page-navigation-header .flex-item p,.page-navigation-header a,.page-navigation-header span{display:none}.page-navigation-header .flex-item.mobile{display:inherit}}@media only screen and (max-width:768px){.page-navigation-header{padding:0 15px}}@media only screen and (max-width:375px){.page-navigation-header{padding:0 15px}}.hero{width:100%;height:auto;padding:40px 0;box-sizing:border-box;text-align:center}.hero h1{width:100%;height:48px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.hero p.light{padding-top:10px;opacity:.5}.hero.left{text-align:left}.hero.right{text-align:right}.hero.action{width:100%;padding:44px 0;box-sizing:border-box}.hero.action button{margin:0 0 0 20px}.hero.small{padding:0}.hero-flex{width:100%;height:auto;padding:40px 0;display:flex;flex-wrap:nowrap;justify-content:flex-start}.hero-flex.small{padding:0}.hero-flex>*{flex-basis:auto;flex-grow:10;overflow:hidden}.hero-flex>* h1,.hero-flex>* h2,.hero-flex>* h3{line-height:60px}.hero-flex>*>*{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.hero-flex>.fixed{flex-basis:content;flex-grow:1;flex-shrink:0;overflow:visible}.hero-flex>.fixed>*{overflow:visible}.hero-flex>.fixed.right{text-align:right;padding-left:20px}.hero-flex>.fixed.right button:last-child{margin-left:20px}.breadcrumb-bar{width:100%;height:64px;border-bottom:1px solid #d2d1d7}.breadcrumb-bar img{width:24px;height:24px;margin:20px 10px 20px 0;display:inline-block;vertical-align:top;cursor:pointer;opacity:1;transition:all .2s ease-in-out}.breadcrumb-bar img:hover{opacity:.7}.breadcrumb-bar h3{line-height:64px;white-space:nowrap;text-overflow:ellipsis;width:calc(100% - 34px);display:inline-block;overflow:hidden;vertical-align:top;margin:0;cursor:pointer}.info-bar{width:100%;height:64px;border-bottom:1px solid #d2d1d7}.info-bar h3{line-height:64px;white-space:nowrap;text-overflow:ellipsis;width:100%;display:inline-block;overflow:hidden;vertical-align:top;margin:0;cursor:pointer}.page-hero{background-color:#fff;height:140px;padding:0 calc(50vw - 670px);border-bottom:1px solid #e8e8eb;white-space:nowrap}.page-hero.small{height:80px}.page-hero.extra-small{height:40px}.page-hero.no-border{border:none}.influencer-context-bar{width:100%;height:auto;padding:0 calc(50vw - 670px);background:#fff;border-bottom:1px solid #d2d1d7}@media only screen and (max-width:1440px){.influencer-context-bar,.page-hero{padding:0 50px}}@media only screen and (max-width:1024px){.influencer-context-bar,.page-hero{padding:0 50px}}@media only screen and (max-width:768px){.hero.action{padding:0;text-align:left}.hero button{margin:0 20px 0 0!important}}.page{width:100vw;height:auto;min-height:100vh;overflow-x:hidden;margin:0;box-sizing:border-box;background-color:#f7fafa;z-index:1}.page .padded-content{padding:0 calc(50vw - 700px)}.page .padded-content.white{background-color:#fff}.page .padded-content.border-bottom{border-bottom:1px solid #e8e8eb}.page.blurred{-webkit-filter:blur(5px);-moz-filter:blur(5px);-ms-filter:blur(5px);filter:blur(5px)}.page-centered{width:100vw;height:auto;min-height:100vh;overflow-x:hidden;display:table;margin:0;padding:0;border-collapse:collapse;background-color:#f7fafa}.page-centered .center-outer{display:table-cell;width:100vw;height:auto;min-height:100vh;vertical-align:top;padding:60px 0}.page-centered .center-outer .center-inner{width:555px;height:auto;margin:auto}.page-centered .center-outer .center-inner .browser-detect{margin-top:80px;text-align:center}.page-centered .center-outer .center-inner .browser-detect .browser-warning{border:1px solid #ffc6db;border-radius:4px;padding:20px 30px;background-color:#fff}.page-centered .center-outer .center-inner .center-logo{width:100%;height:auto;padding:0 0 60px;text-align:center}.page-centered .center-outer .center-inner .center-logo img{width:auto;height:60px;cursor:pointer}.page-centered .center-outer .center-inner .center-content{width:100%;height:auto;border:1px solid #d2d1d7;border-radius:4px;padding:20px 30px;background-color:#fff}.page-centered .center-outer .center-inner .center-content .info-image{width:100%;height:auto;text-align:center;padding:30px 0 0}.page-centered .center-outer .center-inner .center-content .info-image img{width:auto;height:60px}.page-centered .center-outer .center-inner .center-content h2.info{margin:10px 0 20px;text-align:center}.page-centered .center-outer .center-inner .center-content p.info{margin-top:10px;text-align:center}.page-centered.blurred{-webkit-filter:blur(5px);-moz-filter:blur(5px);-ms-filter:blur(5px);filter:blur(5px)}.spacer{width:100%;height:20px}.spacer.small{width:100%;height:10px}.spacer.large{width:100%;height:40px}.preloader{width:100vw;height:100vh;position:relative;background-color:#f7fafa}.preloader img{width:60px;height:60px;position:absolute;top:calc(50% - 30px);left:calc(50% - 30px);transition-property:transform;transition-duration:1s;animation-name:spin;animation-duration:1.25s;animation-iteration-count:infinite;animation-timing-function:linear}.discussion-preloader{width:100%;height:calc(100vh - 241px);position:relative;background:transparent;display:flex;justify-content:center;align-items:center}.discussion-preloader img{width:60px;height:60px;transition-property:transform;transition-duration:1s;animation-name:spin;animation-duration:1.25s;animation-iteration-count:infinite;animation-timing-function:linear}img.image-component{opacity:0;transition:opacity .2s}img.image-component.loaded{opacity:1}.align-left{width:100%;height:auto;text-align:left}.align-right{width:100%;height:auto;text-align:right}.align-center{width:100%;text-align:center;height:auto}.logo-container{width:100%;height:120px;padding:40px 0;text-align:center}.logo-container img{width:auto;height:40px}.mobile-lock{width:100vw;height:calc(100vh - 60px);display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;padding:40px;padding-bottom:60px}.mobile-lock>*{flex:0 0 content}.mobile-lock .mobile-highlight{width:100px;height:100px;border-radius:50%;background:#fff;padding:30px 0}.mobile-lock .mobile-highlight img{width:auto;height:40px}.mobile-lock.no-header{height:calc(100vh - 120px);padding-bottom:120px}.page-content{width:100%;height:auto;min-height:calc(100vh - 200px);background-color:#f7fafa;padding:24px calc(50vw - 670px)}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@media only screen and (max-width:1440px){.page-content{padding:20px}}@media only screen and (max-width:1024px){.page-content{padding:20px}}img.cta{opacity:.7}img.cta:hover{opacity:1}.dropdown{position:relative;display:inline-block;vertical-align:top;margin:0}.dropdown .dropdown-area{width:300px;height:auto;position:absolute;top:calc(100% + 20px);left:calc(50% - 150px);filter:drop-shadow(rgba(0,0,0,.3) 0 2px 10px);opacity:0;visibility:hidden;pointer-events:none;transition:all .2s ease-in-out;z-index:31;-webkit-transform:translateZ(0);-webkit-backface-visibility:hidden}.dropdown .dropdown-area .arrow{width:0;height:0;border-style:solid;border-width:0 10px 10px;border-color:transparent transparent #fff;margin:0 auto}.dropdown .dropdown-area .wrapper{width:100%;height:auto;background-color:#fff;border-radius:4px;box-sizing:border-box;padding:10px}.dropdown .dropdown-area .wrapper .dropdown-content{width:100%;height:auto;max-height:200px;overflow-x:hidden;overflow-y:hidden}.dropdown .dropdown-area .wrapper .dropdown-content ul{width:100%;height:auto;list-style-type:none;margin:0;padding:0;text-align:left}.dropdown .dropdown-area .wrapper .dropdown-content ul li.seagreen:hover{background-color:#20c49e}.dropdown .dropdown-area .wrapper .dropdown-content ul li.seagreen:hover p{color:#fff}.dropdown .dropdown-area .wrapper .dropdown-content ul li{width:100%;height:40px;box-sizing:border-box;border:none;border-radius:4px;background-color:#fff;transition:all .15s ease-in-out;padding:0 10px;cursor:pointer}.dropdown .dropdown-area .wrapper .dropdown-content ul li p{width:100%;height:40px;line-height:40px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;transition:all .15s ease-in-out;color:#1d1937}.dropdown .dropdown-area .wrapper .dropdown-content ul li:hover{background-color:#fc4085}.dropdown .dropdown-area .wrapper .dropdown-content ul li:hover p{color:#fff}.dropdown .dropdown-area .wrapper .dropdown-content ul li.no-effect{cursor:default;text-align:center}.dropdown .dropdown-area .wrapper .dropdown-content ul li.no-effect:hover{background-color:#fff}.dropdown .dropdown-area .wrapper .dropdown-content ul li.no-effect:hover p{color:#1d1937}.dropdown .dropdown-area .wrapper .dropdown-content:hover{overflow-y:hidden}.dropdown .dropdown-area .wrapper .dropdown-button{width:100%;height:auto;box-sizing:border-box;padding-top:10px}.dropdown .dropdown-area .wrapper .dropdown-button .button-inner{width:100%;height:40px;box-sizing:border-box;border:2px solid #1d1937;border-radius:4px;opacity:1;cursor:pointer;transition:all .2s ease-in-out}.dropdown .dropdown-area .wrapper .dropdown-button .button-inner p{width:100%;height:36px;text-align:center;line-height:36px;color:#1d1937}.dropdown .dropdown-area .wrapper .dropdown-button .button-inner:hover{opacity:.5}.dropdown .dropdown-area.visible{top:calc(100% + 10px);opacity:1;visibility:visible;pointer-events:all}.dropdown.open-center .dropdown-area{left:calc(100% - 180px)}.dropdown.open-center .dropdown-area .arrow{margin:0 0 0 calc(100% - 155px)}.dropdown.open-left .dropdown-area{left:calc(100% - 300px)}.dropdown.open-left .dropdown-area .arrow{margin:0 40px 0 calc(100% - 60px)}.dropdown.open-right .dropdown-area{left:0}.dropdown.open-right .dropdown-area .arrow{margin:0 calc(100% - 60px) 0 40px}.dropdown.analytics{border:1px solid #fed995;background-color:#fff1d5}.more-button{position:relative;display:inline-block;vertical-align:top;margin:0}.more-button .trigger{opacity:1;transition:opacity .2s}.more-button .more-button-area{width:300px;height:auto;position:absolute;top:calc(100% + 20px);left:calc(100% - 300px);filter:drop-shadow(rgba(0,0,0,.3) 0 2px 10px);opacity:0;visibility:hidden;pointer-events:none;transition:all .2s ease-in-out;z-index:31;-webkit-transform:translateZ(0);-webkit-backface-visibility:hidden}.more-button .more-button-area .wrapper{width:100%;height:auto;background-color:#fff;border-radius:4px;box-sizing:border-box;padding:10px}.more-button .more-button-area .wrapper .more-button-content{width:100%;height:auto;max-height:200px;overflow-x:hidden;overflow-y:hidden}.more-button .more-button-area .wrapper .more-button-content ul{width:100%;height:auto;list-style-type:none;margin:0;padding:0;text-align:left}.more-button .more-button-area .wrapper .more-button-content ul li{width:100%;height:40px;box-sizing:border-box;border:none;border-radius:4px;background-color:#fff;transition:all .15s ease-in-out;padding:0 10px;cursor:pointer}.more-button .more-button-area .wrapper .more-button-content ul li p{width:100%;height:40px;line-height:40px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;transition:all .15s ease-in-out;color:#1d1937}.more-button .more-button-area .wrapper .more-button-content ul li:hover{background-color:#fc4085}.more-button .more-button-area .wrapper .more-button-content ul li:hover p{color:#fff}.more-button .more-button-area .wrapper .more-button-content:hover{overflow-y:hidden}.more-button.visible .more-button-area{top:calc(100% + 10px);opacity:1;visibility:visible;pointer-events:all}.dropup{position:relative;display:inline-block;vertical-align:top;margin:0}.dropup .dropup-area{width:300px;height:auto;position:absolute;bottom:calc(100% + 20px);left:calc(50% - 150px);filter:drop-shadow(rgba(0,0,0,.3) 0 2px 10px);opacity:0;visibility:hidden;pointer-events:none;transition:all .2s ease-in-out;z-index:21}.dropup .dropup-area .arrow{width:0;height:0;border-style:solid;border-width:10px 10px 0;border-color:#fff transparent transparent;margin:0 auto}.dropup .dropup-area .wrapper{width:100%;height:auto;background-color:#fff;border-radius:4px;box-sizing:border-box;padding:10px}.dropup .dropup-area .wrapper .dropup-content{width:100%;height:auto;max-height:200px;overflow:hidden}.dropup .dropup-area .wrapper .dropup-content ul{width:100%;height:auto;list-style-type:none;margin:0;padding:0;text-align:left}.dropup .dropup-area .wrapper .dropup-content ul li{width:100%;height:40px;box-sizing:border-box;border:none;border-radius:4px;background-color:#fff;transition:all .15s ease-in-out;padding:0 10px;cursor:pointer}.dropup .dropup-area .wrapper .dropup-content ul li p{width:100%;height:40px;line-height:40px;overflow:hidden;text-overflow:ellipsis;transition:all .15s ease-in-out;color:#1d1937}.dropup .dropup-area .wrapper .dropup-content ul li:hover{background-color:#fc4085}.dropup .dropup-area .wrapper .dropup-content ul li:hover p{color:#fff}.dropup .dropup-area .wrapper .dropup-button{width:100%;height:auto;box-sizing:border-box;padding-top:10px}.dropup .dropup-area .wrapper .dropup-button .button-inner{width:100%;height:40px;box-sizing:border-box;border:2px solid #1d1937;border-radius:4px;opacity:1;cursor:pointer;transition:all .2s ease-in-out}.dropup .dropup-area .wrapper .dropup-button .button-inner p{width:100%;height:36px;text-align:center;line-height:36px;color:#1d1937}.dropup .dropup-area .wrapper .dropup-button .button-inner:hover{opacity:.5}.dropup .dropup-area.visible{bottom:calc(100% + 10px);opacity:1;visibility:visible;pointer-events:all}@media only screen and (max-width:768px){.dropdown .dropdown-area{left:0}.dropdown .dropdown-area .arrow{margin:0 calc(100% - 60px) 0 40px}}.campaign-card{width:100%;height:290px;background-color:#fff;border:1px solid #d2d1d7;border-radius:4px;padding:20px;display:flex;justify-content:flex-start;flex-wrap:nowrap;flex-direction:column;cursor:pointer}.campaign-card .flex-item{width:100%;height:auto;flex:0 0 content}.campaign-card .flex-item .bottom{border-top:1px solid #d2d1d7;padding-top:15px;margin-top:5px}.campaign-card .flex-item .bottom span{width:50%;height:auto;display:inline-block;margin:0;vertical-align:top}.campaign-card .flex-item .bottom span p{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:top}.campaign-card .flex-item .bottom span p img{width:24px;height:24px;opacity:.5;vertical-align:top;padding-right:4px}.campaign-card .flex-item .bottom span.left{text-align:left}.campaign-card .flex-item .bottom span.right{text-align:right}.campaign-card .flex-item.spacer{flex:1 1 auto}.workflow{width:100%;height:auto;background-color:#fff1d5;border:1px solid #fed995;border-radius:4px;box-sizing:border-box;padding-bottom:15px}.workflow .grid-6-6{padding-bottom:0}.workflow .workflow-item{width:100%;height:auto;opacity:1}.workflow .workflow-item .workflow-icon{width:48px;padding:12px 3px 12px 12px;box-sizing:border-box;display:inline-block;vertical-align:top;margin:0}.workflow .workflow-item .workflow-icon .item-inner{width:24px;height:24px;border:2px solid #1d1937;border-radius:100%;box-sizing:border-box;text-align:center}.workflow .workflow-item .workflow-icon .item-inner p{line-height:20px}.workflow .workflow-item .workflow-text{width:calc(100% - 48px);padding:12px 12px 12px 3px;box-sizing:border-box;display:inline-block;vertical-align:top;margin:0}.workflow .workflow-item .workflow-text p{line-height:24px}.workflow .workflow-item.disabled{opacity:.5}.workflow .workflow-item.disabled .workflow-text>p{text-decoration:line-through}.profile-row{width:100%;height:auto;padding:10px 0}.profile-row ul{width:100%;height:auto;list-style-type:none;padding:0;margin:0}.profile-row ul li{height:60px;width:54px;padding:10px 0;box-sizing:border-box;display:inline-block;vertical-align:top;margin:0;text-align:left}.timeline{width:100%;height:auto;box-sizing:border-box;padding:20px 40px}.timeline .timeline-item{width:25%;height:auto;display:inline-block;vertical-align:top;margin:0;padding:0 20px 0 0;box-sizing:border-box}.timeline .timeline-item img{width:24px;height:24px;display:inline-block;vertical-align:top;margin:0 20px 0 0}.timeline .timeline-item .timeline-line{width:calc(100% - 44px);height:13px;box-sizing:border-box;border-bottom:2px solid #d2d1d7;margin-bottom:11px;display:inline-block;vertical-align:top}.timeline .timeline-item .timeline-content{width:100%;height:auto;min-height:40px;box-sizing:border-box;display:block;padding:10px 0 0}.timeline.vertical{width:100%;height:auto;display:table;border-collapse:collapse;padding:0;margin:0}.timeline.vertical .timeline-icon{display:table-row;width:100%;height:24px}.timeline.vertical .timeline-icon .left{display:table-cell;width:24px;height:24px}.timeline.vertical .timeline-icon .right{display:table-cell;width:100%;height:24px;padding-left:20px}.timeline.vertical .timeline-icon .right p{line-height:24px;font-weight:700}.timeline.vertical .timeline-content{display:table-row;width:100%;height:80px}.timeline.vertical .timeline-content .left{display:table-cell;width:24px;height:80px}.timeline.vertical .timeline-content .left .timeline-line{width:12px;height:60px;box-sizing:border-box;margin:10px 12px 10px 0;border-right:1px solid #d2d1d7}.timeline.vertical .timeline-content .right{display:table-cell;width:100%;height:80px;box-sizing:border-box;padding:0;vertical-align:top}.timeline.vertical .timeline-content .right p{padding:10px 0 21px 20px}.timeline.vertical .timeline-content.small,.timeline.vertical .timeline-content.small .left{height:50px}.timeline.vertical .timeline-content.small .left .timeline-line{height:30px}.timeline.vertical .timeline-content.small .right{height:50px}.timeline.vertical .timeline-content.extra-small,.timeline.vertical .timeline-content.extra-small .left{height:30px}.timeline.vertical .timeline-content.extra-small .left .timeline-line{height:10px}.timeline.vertical .timeline-content.extra-small .right{height:30px}.custom-tooltip{width:260px;max-width:260px;color:#1d1937!important;background-color:#fff!important;-webkit-box-shadow:0 2px 10px 0 rgba(0,0,0,.2);-moz-box-shadow:0 2px 10px 0 rgba(0,0,0,.2);box-shadow:0 2px 10px 0 rgba(0,0,0,.2);border-radius:4px;font-family:Varela Round,Arial Rounded MT,Arial,sans-serif;font-size:16px!important;font-weight:400!important;font-style:normal!important;text-transform:none!important;text-decoration:none!important;line-height:24px!important;margin:0!important;padding:20px!important}.custom-tooltip.place-top:after{border-top-color:#fff!important;border-top-style:solid!important;border-top-width:6px!important}.overview-header{line-height:80px}.clickable{cursor:pointer}li.discussion-break{max-width:10px;height:100%;box-sizing:border-box;padding-right:9px}li.discussion-break .vertical-break{width:1px;height:100%;background-color:#d2d1d7}.sb-avatar div{font-family:Varela Round,Arial Rounded MT,Arial,sans-serif!important;color:#1d1937!important;font-weight:700!important}.large-tabs{flex-direction:row}.large-tabs,.large-tabs .flex-item{width:100%;display:flex;justify-content:center}.large-tabs .flex-item{flex:1 1 auto;height:40px;text-align:center;align-items:center;border-bottom:3px solid #d2d1d7;padding:0 100px}.large-tabs .flex-item h4{flex:1 1 auto}.large-tabs .flex-item.active{border-bottom:3px solid #1d1937}.large-tabs .flex-item:hover{cursor:pointer}.box{width:100%;background-color:#fff;border:1px solid #d2d1d7;border-radius:4px}.box,.box .box-content-one{height:auto;box-sizing:border-box}.box .box-content-one{display:inline-block;width:calc(100% - 60px);padding:20px;vertical-align:top;margin:0;text-align:left;color:#1d1937}.box .box-content-one .title-row{display:flex;justify-content:flex-start;align-items:center}.box .box-content-one .title-row .flex-item{flex:0 0 content;padding-right:10px}.box .box-content-one .title-row .flex-item input{margin:0}.box .box-content-one .title-row .flex-item p.field-symbol{top:13px}.box .box-content-one .title-row .flex-spacer{flex:1 1 auto}.box .box-content-one .title-row div:last-child{padding-right:0}.box .box-content-one h2{width:calc(100% - 120px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.box .box-content-one h2,.box .box-content-two{display:inline-block;vertical-align:top;margin:0}.box .box-content-two{width:60px;text-align:right}.box .box-content-three,.box .box-content-two{height:auto;box-sizing:border-box;padding:20px}.box .box-content-three{display:block;width:100%;min-height:88px;text-align:left}.box.centered{background-color:transparent;border:1px dashed #d2d1d7}.box.centered .box-content-one{display:table;border-collapse:collapse;margin:0;padding:0;width:100%;height:auto;min-height:288px}.box.centered .box-content-one .box-content-two{display:table-row;width:100%;height:auto;min-height:288px}.box.centered .box-content-one .box-content-two .box-content-three{display:table-cell;width:100%;height:auto;min-height:200px;box-sizing:border-box;padding:20px;vertical-align:middle;text-align:center}.box.centered.small .box-content-one,.box.centered.small .box-content-one .box-content-two{min-height:174px}.box.centered.small .box-content-one .box-content-two .box-content-three{min-height:114px}.box.loading{width:100%;height:260px;border:1px dashed #d2d1d7;border-radius:4px;box-sizing:border-box;animation:pulse 1s infinite}.box.member .box-content-one{width:100px;height:auto;min-height:100px;padding:20px}.box.member .box-content-two{width:calc(100% - 100px);height:auto;min-height:100px;padding:20px 20px 20px 0;text-align:left}.box.member .box-content-two h2{line-height:60px;width:100%;height:60px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.box.member .box-content-two h2 img{width:24px;height:24px;display:inline-block;vertical-align:top;padding:0;margin:18px 0;float:right;cursor:pointer;opacity:1;transition:all .2s ease-in-out}.box.member .box-content-two h2 img:hover{opacity:.5}.box.member .box-content-three{width:100%;height:auto}.box.member .box-content-three p{width:100%;height:24px;line-height:24px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.box.split .box-content-three{border-top:1px solid #d2d1d7}.box.fixed .box-content-one,.box.fixed .box-content-two{height:200px}.box.wide .box-content-one{width:100%}.box.clickable{cursor:pointer}@keyframes pulse{0%{background-color:transparent}50%{background-color:#fff}to{background-color:transparent}}.status-bar{width:100%;height:auto;border-radius:4px;box-sizing:border-box}.status-bar .status-text{width:calc(100% - 48px);height:auto;padding:12px;box-sizing:border-box;display:inline-block;vertical-align:top;margin:0}.status-bar .status-text p{line-height:24px}.status-bar .status-close{width:48px;height:auto;min-height:48px;padding:12px;box-sizing:border-box;display:inline-block;vertical-align:top;margin:0}.status-bar .status-close img{width:24px;height:24px;opacity:1;transition:all .2s ease-in-out;cursor:pointer}.status-bar .status-close img:hover{opacity:.5}.status-bar.green{background-color:#d4faf1;border:1px solid #92f2dc}.status-bar.orange{background-color:#fff1d5;border:1px solid #fed995}.status-bar.red{background-color:#ffecf3;border:1px solid #ffc6db}.custom-modal{width:100vw;height:auto;min-height:100vh;position:fixed;top:0;right:0;bottom:0;left:0;box-sizing:border-box;padding:25vh calc(50vw - 270px);overflow-x:hidden;overflow-y:scroll;background-color:rgba(29,25,55,.8);display:none;visibility:hidden;z-index:-1}.custom-modal .modal-content{width:540px;height:auto;box-sizing:border-box;border:none;padding:0 20px 20px;border-radius:4px;background-color:#fff;-webkit-box-shadow:0 0 50px 0 rgba(0,0,0,.5);-moz-box-shadow:0 0 50px 0 rgba(0,0,0,.5);box-shadow:0 0 50px 0 rgba(0,0,0,.55)}.custom-modal .modal-content .top{width:calc(100% - 24px);height:60px;text-align:center;box-sizing:border-box;border-bottom:1px solid #d2d1d7;display:inline-block;vertical-align:top;margin:0;padding-left:24px}.custom-modal .modal-content .top h3{line-height:60px}.custom-modal .modal-content .top-text{width:calc(100% - 24px);height:80px;text-align:center;box-sizing:border-box;border-bottom:1px solid #d2d1d7;display:inline-block;vertical-align:top;margin:0;padding-top:15px;padding-left:24px}.custom-modal .modal-content .top-text h3{line-height:30px}.custom-modal .modal-content .top.no-border{border-bottom:0}.custom-modal .modal-content .modal-close{width:24px;height:60px;box-sizing:border-box;padding:18px 0;border-bottom:1px solid #d2d1d7;display:inline-block;vertical-align:top;margin:0}.custom-modal .modal-content .modal-close.large{height:80px}.custom-modal .modal-content .modal-close img{width:24px;height:24px;cursor:pointer;opacity:1;transition:all .2s ease-in-out}.custom-modal .modal-content .modal-close.no-border{border-bottom:0}.custom-modal .modal-content .action{width:100%;height:40px;box-sizing:border-box;padding-top:20px}.custom-modal .modal-content .center{width:100%;height:auto;padding-top:20px}.custom-modal .modal-content .center table,.custom-modal .modal-content .center tbody,.custom-modal .modal-content .center tr{width:100%}.custom-modal .modal-content .center td{vertical-align:top}.custom-modal .modal-content .center td h4{line-height:48px}.custom-modal .modal-content .center td h4,.custom-modal .modal-content .center td textarea{padding-top:10px}.custom-modal .modal-content .center .members-list{width:100%;height:auto;max-height:342px;overflow-x:hidden;overflow-y:auto;border:1px solid #e8e8eb;border-radius:4px;padding:5px}.custom-modal .modal-content .center .members-list table{margin:0;padding:0}.custom-modal .modal-content .center .members-list table td{margin:0;padding:5px;text-align:left}.custom-modal .modal-content .center .members-list table td p{line-height:44px}.custom-modal .modal-content .center .members-list table td.avatar{width:64px}.custom-modal .modal-content .bottom{width:100%;height:auto;text-align:center}.custom-modal.visible{display:inherit;visibility:visible;z-index:31}.custom-modal.large{display:flex;justify-content:center;align-items:center;padding:0}.custom-modal.large .modal-content{flex:0 0 content;width:70vw}.analytics-modal,.modal-wrapper{width:100vw;height:auto;min-height:100vh}.analytics-modal{position:fixed;top:0;right:0;bottom:0;left:0;box-sizing:border-box;padding:25vh calc(50vw - 270px);overflow-x:hidden;overflow-y:scroll;background-color:rgba(29,25,55,.8);display:none;visibility:hidden;z-index:-1}.analytics-modal .modal-content{width:540px;height:auto;box-sizing:border-box;border:none;padding:20px;border-radius:4px;background-color:#fff;-webkit-box-shadow:0 0 50px 0 rgba(0,0,0,.5);-moz-box-shadow:0 0 50px 0 rgba(0,0,0,.5);box-shadow:0 0 50px 0 rgba(0,0,0,.55)}.analytics-modal .modal-content .top{width:100%;display:flex;justify-content:flex-start;flex-wrap:nowrap;margin-bottom:20px}.analytics-modal .modal-content .top .title{flex:1 1 auto;padding-left:24px;text-align:center}.analytics-modal .modal-content .top .title img{padding-bottom:20px}.analytics-modal .modal-content .top .close{flex:0 0 content}.analytics-modal .modal-content .top .close img{width:24px;height:24px;cursor:pointer}.analytics-modal .modal-content .center{width:100%;height:auto;padding:20px 40px 0;text-align:center}.analytics-modal .modal-content .center .engagement-labels{width:100%;display:flex;justify-content:flex-end;align-items:center}.analytics-modal .modal-content .center .engagement-labels .flex-item{flex:1 1 auto}.analytics-modal .modal-content .center img.engagement-line{width:100%}.analytics-modal.visible{display:inherit;visibility:visible;z-index:31}.image-modal{width:100vw;height:100vh;position:fixed;top:0;left:0;overflow-y:scroll;background:rgba(29,25,55,.8);text-align:center;z-index:41;padding:5vh 5vw}.image-modal img{width:auto;max-width:90vw;height:auto;max-height:90vh}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#fc4085;border-color:#fc4085}.pagination>ul,.pagination>ul>a{list-style-type:none}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#fc4085;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li>a:hover,.pagination>li>span:hover{color:#fc4085}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#fc4085;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination>.disabled>a:focus:hover,.pagination>.disabled>a:hover,.pagination>.disabled>a:hover:hover,.pagination>.disabled>span:focus:hover,.pagination>.disabled>span:hover,.pagination>.disabled>span:hover:hover{color:#fc4085}.campaign-pagination{width:100%;height:62px;box-sizing:border-box;border:1px solid #d2d1d7;border-radius:4px;background-color:#e8e8eb;margin:0}.campaign-pagination .left,.campaign-pagination .right{width:calc(50% - 5px);height:60px;display:inline-block;vertical-align:top;background-color:#fff;margin:0;text-align:left}.campaign-pagination .left .pagination-icon,.campaign-pagination .right .pagination-icon{width:24px;height:24px;padding:18px;box-sizing:border-box;display:inline-block;vertical-align:top;margin:0}.campaign-pagination .left .pagination-icon .icon-inner,.campaign-pagination .right .pagination-icon .icon-inner{width:24px;height:24px;border:2px solid #1d1937;border-radius:100%;box-sizing:border-box;text-align:center}.campaign-pagination .left .pagination-icon .icon-inner p,.campaign-pagination .right .pagination-icon .icon-inner p{line-height:20px}.campaign-pagination .left .pagination-icon.disabled,.campaign-pagination .right .pagination-icon.disabled{opacity:.5}.campaign-pagination .left h5,.campaign-pagination .right h5{display:inline-block;vertical-align:top;margin:0;line-height:60px;padding:0 6px 0 18px;text-transform:uppercase;font-weight:500;letter-spacing:1px;width:calc(100% - 56px);height:60px;box-sizing:border-box;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.campaign-pagination .left h5.disabled,.campaign-pagination .right h5.disabled{opacity:.5}.campaign-pagination .center{width:10px;height:60px;display:inline-block;vertical-align:top;margin:0}.campaign-pagination .center .triangle{width:0;height:0;position:relative;border-style:solid;border-width:30px 0 30px 10px;border-color:#fff #fff #fff #d2d1d7}.campaign-pagination .center .triangle .triangle-inner{width:0;height:0;position:absolute;top:-29px;left:-10px;border-style:solid;border-width:29px 0 29px 9px;border-color:transparent transparent transparent #fff}.campaign-pagination .center .triangle.triangle.disabled{border-color:transparent transparent transparent #d2d1d7}.campaign-pagination .left{border-radius:3px 0 0 3px}.campaign-pagination .right.disabled{background-color:transparent}.campaign-pagination.complete,.discussion-header{background-color:#fff}.discussion-header{width:100vw;height:81px;border-bottom:1px solid #d2d1d7;padding:0 calc(50vw - 660px);z-index:21;display:flex;justify-content:flex-start;flex-wrap:nowrap;position:absolute;top:0;left:0}.discussion-header .one{flex:0 0 content}.discussion-header .one img{width:24px;height:24px;margin:28px 10px 28px 0;cursor:pointer;opacity:1;transition:all .2s ease-in-out}.discussion-header .one img:hover{opacity:.7}.discussion-header .two{flex:0 0 content}.discussion-header .two,.discussion-header .two>*{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.discussion-header .two h3{line-height:80px;cursor:pointer}.discussion-header .three{flex:1 1 auto;padding:0 20px}.discussion-header .three p{line-height:82px}.discussion-header .four{flex:0 0 content;text-align:right;padding:20px 0}.discussion-header .four button{margin:0 0 0 20px}.discussion-header .four button p{padding-right:10px}.discussion-header .four button img{margin:0}.discussion-header .five{flex:0 0 content;text-align:right;padding:20px 0}.discussion-header .five .dropdown-area{top:80px}.discussion-header .five .dropdown-area.visible{top:70px}.discussion-header .five button{margin:0 0 0 20px}.discussion-header .five button p{padding-right:10px}.discussion-header .five button img{margin:0}.discussion-header.true{position:fixed;top:0;left:0}.collaboration-header{width:100%;height:auto;padding-bottom:20px}.discussion-members{width:100%;height:auto;text-align:center;list-style-type:none;padding:10px 0;margin:0}.discussion-members li{display:inline-block;vertical-align:top;margin:0 5px;padding:0}.discussion-members li .frame{width:30px;height:30px}.unread-message{width:34px;height:34px;position:relative;float:right;display:inline-block;vertical-align:top;margin:0 10px 0 0}.unread-message img{width:34px;height:34px;position:absolute;top:0;left:0}.unread-message p{width:24px;height:34px;line-height:34px;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;position:absolute;top:1px;left:5px}.discussion{display:flex;justify-content:flex-start;flex-wrap:nowrap;flex-direction:row-reverse;position:relative}.discussion .right{flex:0 1 calc(50vw - 264px);min-height:calc(100vh - 60px);height:auto;padding:120px calc(50vw - 660px) 40px 40px;border-left:1px solid #e8e8eb}.discussion .right.fixed .right-content{position:fixed;width:calc(50vw - 346px);max-width:240px;top:120px;left:calc(50vw + 306px)}.discussion .left{flex:0 1 calc(50vw + 264px);min-height:calc(100vh - 60px);height:auto;padding:120px 40px 40px calc(50vw - 660px);background:#fff}.message-wrapper{margin:20px 0}.simple-message{width:100%;height:auto;box-sizing:border-box}.simple-message .top{display:flex;align-items:center}.simple-message .top .avatar{flex:0 0 46px}.simple-message .top .user-info{flex:1 1 auto}.simple-message .content-container{margin:10px 0}.simple-message .content-container p{white-space:pre-wrap;word-break:break-all}.messageBLOCK{display:flex;justify-content:flex-start;flex-wrap:nowrap}.messageBLOCK .message-left{flex:0 0 content;padding-right:20px}.messageBLOCK .message-right{flex:1 1 auto;width:100%;height:auto;background:#fff;padding:5px 0}.messageBLOCK .message-right .message-timestamp{padding-bottom:10px}.messageBLOCK .message-right .message-right-content{border:1px solid #d2d1d7;border-radius:4px;padding:8px 15px}.messageBLOCK .message-right .message-right-content p{white-space:pre-wrap;word-break:break-all}.messageBLOCK .message-right .message-right-content .row{display:flex;flex-wrap:nowrap;justify-content:flex-start;align-items:center;padding:5px}.messageBLOCK .message-right .message-right-content .row .flex-item{flex:0 0 content;padding-left:10px}.messageBLOCK .message-right .message-right-content .row .flex-item img{width:36px;height:36px;vertical-align:top;margin:0}.messageBLOCK .message-right .message-right-content .row .flex-item:first-child{padding-left:0}.messageBLOCK .message-right .message-right-content .row .flex-spacer{flex:1 1 auto}.message-timestamp{width:100%;height:auto;padding:4px 10px 0 0;text-align:left}.message-file{flex:1 1 auto;width:100%;height:auto;background:#fff}.message-file,.message-file .message-text{border:1px solid #d2d1d7;border-radius:4px}.message-file .message-text{padding:12px}.message-file .message-text p{font-size:18px}.message-file .file-row{display:flex;flex-wrap:nowrap;justify-content:flex-start;align-items:center;border-radius:4px;padding:13px;background:#fff;transition:background .2s;cursor:pointer}.message-file .file-row .flex-item{flex:0 0 content;padding-left:10px}.message-file .file-row .flex-item img{width:48px;height:48px;vertical-align:top;margin:0}.message-file .file-row .flex-item:first-child{padding-left:0}.message-file .file-row .flex-spacer{flex:1 1 auto;padding-left:10px}.message-file .file-row:hover{background-color:#f7fafa}.message-file .image-row{border-radius:4px 4px 0 0;border-bottom:1px solid #d2d1d7;cursor:pointer;overflow:hidden}.message-file .image-row img{width:100%;height:auto;border-radius:4px 4px 0 0}.message-file .message-row{border-top:1px solid #d2d1d7;padding:8px 13px}.message-file.inline{border-top:none;border-bottom:none;border-radius:0}.message-file.padded{padding:12px}.message-callout{flex:1 1 auto;width:100%;height:auto;border:none;border-radius:4px;text-align:center;padding:5px 0 10px}.message-callout .message-file{flex:none;text-align:left}.message-callout .deliverable-content{width:100%;height:auto;border:1px solid #d2d1d7;border-radius:4px 4px 0 0;padding:8px 15px;background:#fff}.message-callout .deliverable-content .row{display:flex;flex-wrap:nowrap;justify-content:flex-start;align-items:center;padding:5px}.message-callout .deliverable-content .row .flex-item{flex:0 0 content;padding-left:10px}.message-callout .deliverable-content .row .flex-item img{width:24px;height:24px;vertical-align:top;margin:0}.message-callout .deliverable-content .row .flex-item:first-child{padding-left:0}.message-callout .deliverable-content .row .flex-spacer{flex:1 1 auto}.message-callout .deliverable-asset{width:100%;height:auto;border-bottom:1px solid #d2d1d7}.message-callout .deliverable-asset img{width:100%;height:auto}.message-callout .deliverable-comment{width:100%;height:auto;padding:8px 13px;border:1px solid #d2d1d7;border-top:none;border-bottom:none;text-align:left;background:#fff;transition:background .2s;cursor:pointer}.message-callout .deliverable-comment:hover{background:#f7fafa}.message-callout .deliverable-action{width:100%;height:auto;border:1px solid #d2d1d7;border-top:none;border-radius:0 0 4px 4px;padding:8px 15px;background:#fff;transition:background .2s;cursor:pointer}.message-callout .deliverable-action:hover{background:#f7fafa}.message-callout .deliverable-action p{line-height:24px}.message-callout .deliverable-action img{width:24px;height:24px;margin-left:10px}.live-url-wrapper{border:1px solid #d2d1d7;padding:5px;border-radius:7px;max-width:500px;display:flex;justify-content:center;margin:0 auto}.live-url-wrapper p{flex:1 1 auto;max-width:490px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.live-url-wrapper:hover{background-color:#f7fafa;cursor:pointer}.discuss{display:flex;justify-content:flex-start;flex-wrap:nowrap;padding-top:20px}.discuss .flex-item{flex:0 0 content}.discuss .flex-item button{width:44px;height:44px;padding:8px}.discuss .flex-item button img{width:24px;height:24px}.discuss .flex-item button.send{display:none;opacity:0}.discuss .flex-spacer{flex:1 1 auto;padding:0 20px}.discuss .flex-spacer textarea{height:44px;transition:none}.discuss.composing .flex-item button.send{display:inherit;opacity:1}.discuss.composing .flex-spacer textarea{height:108px}.discussion-cta{width:100%;height:auto;min-height:400px;display:flex;justify-content:center}.discussion-cta h2{padding-left:20px}.discussion-cta.team{text-align:center;align-items:center}.version-container{width:100%;height:auto;margin:10px 0;border:1px solid #d2d1d7;border-radius:5px;display:flex;align-items:center;padding:5px}.version-container img{flex:0 0 30px;width:30px!important;height:30px!important;margin:5px;margin-right:10px}.version-container p{flex:0 0 auto;margin:5px;font-weight:600;white-space:pre-wrap;word-break:break-all}.version-text{display:flex}.version-text p{flex:0 1 auto;padding-right:5px}.discussion-multi-buttons{display:flex;flex-direction:row;align-items:center;justify-content:center}.discussion-multi-buttons div{flex:0 1 auto;padding:10px!important}.discussion-multi-buttons div button{padding:10px}.discussion-multi-buttons p{flex:0 0 auto;padding:0 10px;font-weight:600}@media only screen and (max-width:1440px){.discussion-header{padding:0 60px}.discussion .left{flex:0 0 70%;padding:120px 40px 40px 60px}.discussion .right{flex:0 0 30%;padding:120px 60px 40px 40px}}@media only screen and (max-width:1024px){.discussion-header{padding:0 60px}.discussion{display:block}.discussion .left{display:block;padding:40px 50px;min-height:0}.discussion .right{display:block;border-left:none;border-bottom:1px solid #d2d1d7;padding:120px 60px 40px;min-height:0}.discussion .right.fixed .right-content{position:static}}@media only screen and (max-width:768px){.discussion-header{padding:0 50px}.discussion .left{padding:40px}}@media only screen and (max-width:375px){.discussion-header{padding:0 20px}.discussion .left{padding:40px 20px}}.member{width:100%;height:auto;border:1px solid #d2d1d7;border-radius:4px;background-color:#fff}.member .member-data{width:100%;height:84px}.member .member-data .center,.member .member-data .left,.member .member-data .right{display:inline-block;vertical-align:top;margin:0}.member .member-data .left{width:84px;height:84px;padding:20px}.member .member-data .center{width:calc(100% - 148px);height:84px}.member .member-data .center h2{width:100%;height:84px;line-height:84px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.member .member-data .right{width:64px;height:84px;padding:30px 20px}.member .member-data .right img{width:24px;height:24px;opacity:1;cursor:pointer;transition:all .2s ease-in-out}.member .member-data .right img:hover{opacity:.5}.member .member-meta{border-top:1px solid #d2d1d7}.member .member-meta,.member .member-meta .meta-toggle{width:100%;height:auto;border-radius:0 0 4px 4px;background-color:#fff}.member .member-meta .meta-toggle{padding:0 20px;cursor:pointer;transition:all .2s ease-in-out}.member .member-meta .meta-toggle .container,.member .member-meta .meta-toggle p{display:inline-block;vertical-align:top;margin:0}.member .member-meta .meta-toggle p{width:calc(100% - 44px);height:40px;line-height:40px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;transition:all .2s ease-in-out}.member .member-meta .meta-toggle .container{width:44px;height:40px;padding:8px 0 8px 20px}.member .member-meta .meta-toggle .container img{width:24px;height:24px;opacity:.5;transition:all .2s ease-in-out}.member .member-meta .meta-toggle:hover{background-color:#f7fafa}.member .member-meta .meta-toggle:hover img{opacity:1}.member .member-meta .meta-toggle.open .container img{transform:rotate(180deg)}.member .member-meta .meta-details{width:100%;height:auto;padding:20px;border-top:1px solid #d2d1d7}.member .member-meta .meta-details p{width:100%;height:24px;line-height:24px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.role-text{display:inline-block;border:1px solid #d2d1d7;border-radius:4px;margin:10px 10px 0 0!important;padding:6px 8px!important}table.timeline{width:100%;height:auto;display:flex;align-items:center}table.timeline img{width:24px;height:auto}table.timeline td{text-align:left;vertical-align:top;min-width:24px;min-height:24px}table.timeline td p{line-height:24px}table.timeline td.fixed{width:34px}table.timeline td.line{text-align:center}table.timeline.vertical .line>.timeline-line{width:2px;height:80px;background-color:#d2d1d7;margin:0 11px}table.timeline.vertical .line>.timeline-line.short{height:35px}table.timeline.vertical .line>.timeline-line.long{height:70px}div.timeline{width:80%;height:40px;padding:0;display:flex;justify-content:flex-start;flex-wrap:nowrap}div.timeline .item{flex:0 0 30%;text-align:left;vertical-align:top}div.timeline .item .line,div.timeline .item img{display:inline-block;vertical-align:top}div.timeline .item img{width:24px;height:24px;margin:0}div.timeline .item .line{width:calc(100% - 44px);height:12px;border-bottom:2px solid #d2d1d7;margin:0 0 12px}div.timeline .item p,div.timeline .item span{width:100%;height:36px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-top:10px}.timeline-item-wrapper{display:flex;align-items:center;justify-content:flex-start;flex-direction:row}.timeline-item-wrapper p{flex:0 0 auto;padding-right:10px}.timeline-item-wrapper button{flex:0 0 auto;width:57px;font-size:14px;margin:0}.analytics-frame{width:auto;height:auto;position:relative}.analytics-frame .tooltip{position:absolute;top:10px;left:-6px;width:auto;height:auto;opacity:0;pointer-events:none;transition:all .2s ease-in-out;z-index:21}.analytics-frame .tooltip .tooltip-inner{width:100%;height:auto;position:relative}.analytics-frame .tooltip .tooltip-inner .arrow-outer{width:0;height:0;border-style:solid;border-width:0 10px 10px;border-color:transparent transparent #fed995;position:absolute;top:25px;left:52px}.analytics-frame .tooltip .tooltip-inner .arrow-inner{width:0;height:0;border-style:solid;border-width:0 8px 8px;border-color:transparent transparent #fff1d5;position:absolute;top:27px;left:54px}.analytics-frame .tooltip .tooltip-inner .tooltip-content{width:300px;height:auto;position:absolute;top:34px;left:-80px;background-color:#fff1d5;border-radius:4px;border:1px solid #fed995;padding:16px 20px}.analytics-frame:hover .tooltip{top:60px;opacity:1;pointer-events:all}.custom-react-tooltip{background:#fff!important;opacity:1!important;box-shadow:0 2px 5px 0 rgba(0,0,0,.3)}.analytics-small-frame{width:auto;height:auto;position:relative}.analytics-small-frame .tooltip{position:absolute;top:10px;left:-6px;width:auto;height:auto;opacity:0;pointer-events:none;transition:all .2s ease-in-out;z-index:21}.analytics-small-frame .tooltip .tooltip-inner{width:100%;height:auto;position:relative}.analytics-small-frame .tooltip .tooltip-inner .arrow-outer{width:0;height:0;border-style:solid;border-width:0 10px 10px;border-color:transparent transparent #fed995;position:absolute;top:2px;left:30px}.analytics-small-frame .tooltip .tooltip-inner .arrow-inner{width:0;height:0;border-style:solid;border-width:0 8px 8px;border-color:transparent transparent #fff1d5;position:absolute;top:4px;left:32px}.analytics-small-frame .tooltip .tooltip-inner .tooltip-content{width:300px;height:auto;position:absolute;top:12px;left:-110px;background-color:#fff1d5;border-radius:4px;border:1px solid #fed995;padding:16px 20px}.analytics-small-frame:hover .tooltip{top:60px;opacity:1;pointer-events:all}.frame{width:auto;height:auto;position:relative}.frame .tooltip{position:absolute;bottom:60px;left:0;width:auto;height:auto;opacity:0;pointer-events:none;transition:all .2s ease-in-out;z-index:21}.frame .tooltip .tooltip-inner{width:100%;height:auto;position:relative}.frame .tooltip .tooltip-inner .arrow-outer{width:0;height:0;border-style:solid;border-width:0 10px 10px;border-color:transparent transparent #fed995;position:absolute;top:0;left:10px}.frame .tooltip .tooltip-inner .arrow-inner{width:0;height:0;border-style:solid;border-width:0 8px 8px;border-color:transparent transparent #fff1d5;position:absolute;top:2px;left:12px}.frame .tooltip .tooltip-inner .tooltip-content{width:auto;height:60px;position:absolute;top:9px;left:0;background-color:#fff1d5;border-radius:4px;border:1px solid #fed995;padding:16px 20px;white-space:nowrap}.frame .tooltip .tooltip-profile-inner{width:100%;height:auto;position:relative;filter:drop-shadow(rgba(0,0,0,.3) 0 2px 10px)}.frame .tooltip .tooltip-profile-inner .arrow-outer{width:0;height:0;border-style:solid;border-width:10px 10px 0;border-color:#fff transparent transparent;position:absolute;bottom:0;left:10px}.frame .tooltip .tooltip-profile-inner .arrow-inner{width:0;height:0;border-style:solid;border-width:8px 8px 0;border-color:#fff transparent transparent;position:absolute;bottom:2px;left:12px}.frame .tooltip .tooltip-profile-inner .tooltip-content{width:auto;height:auto;position:absolute;bottom:9px;left:0;background-color:#fff;border-radius:4px;border:1px solid #fff;padding:16px 20px;white-space:nowrap;text-align:left}.frame .tooltip .tooltip-profile-inner .tooltip-content .role{padding:0 8px;border:1px solid #e8e8eb;border-radius:4px;margin-top:6px;display:inline-block}.frame .tooltip .tooltip-profile-inner .tooltip-content .role p{display:inline-block;color:#d2d1d7}.frame:hover .tooltip{bottom:50px;opacity:1;pointer-events:all}.frame.small .tooltip{bottom:40px}.frame.small:hover .tooltip{bottom:30px}.schedule{width:100vw;height:100vh;position:fixed;top:0;left:0;overflow:auto;background-color:#f7fafa;opacity:0;pointer-events:none;z-index:-1}.schedule .schedule-meta{width:100%;height:60px;background-color:#fff;border-bottom:1px solid #e8e8eb;padding:0 60px}.schedule .schedule-meta h3{line-height:60px;display:inline-block;vertical-align:top;margin:0}.schedule .schedule-meta img{width:24px;height:24px;float:right;vertical-align:top;margin:18px 0;opacity:1;cursor:pointer;transition:all .2s ease-in-out}.schedule .schedule-meta img:hover{opacity:.5}.schedule .schedule-content{width:100%;height:auto;padding:0 60px 100px}.schedule .schedule-content .rbc-calendar{width:100%;height:auto;display:flex;flex-direction:column;justify-content:flex-start}.schedule .schedule-content .rbc-calendar .rbc-toolbar{display:flex;flex-direction:row-reverse;align-items:center;padding:20px 0}.schedule .schedule-content .rbc-calendar .rbc-toolbar .rbc-toolbar-label{width:100%;padding:0 10px;text-align:center;font-family:Varela Round,sans-serif;font-size:22px;font-weight:600;font-style:normal;text-transform:none;text-decoration:none;line-height:30px;margin:0;color:#1d1937}.schedule .schedule-content .rbc-calendar .rbc-toolbar .rbc-btn-group{display:inline-block;white-space:nowrap}.schedule .schedule-content .rbc-calendar .rbc-toolbar .rbc-btn-group button{color:#1d1937;display:inline-block;margin:0;text-align:center;vertical-align:middle;background:none;background-image:none;border:2px solid #d2d1d7;padding:.375rem 1rem;line-height:normal;white-space:nowrap;overflow:visible;text-transform:none;-webkit-appearance:button;cursor:pointer}.schedule .schedule-content .rbc-calendar .rbc-toolbar .rbc-btn-group button.rbc-active,.schedule .schedule-content .rbc-calendar .rbc-toolbar .rbc-btn-group button:active{color:#fff;background-color:#d2d1d7}.schedule .schedule-content .rbc-calendar .rbc-toolbar .rbc-btn-group button:focus,.schedule .schedule-content .rbc-calendar .rbc-toolbar .rbc-btn-group button:hover{color:#fff;background-color:#d2d1d7;cursor:pointer}.schedule .schedule-content .rbc-calendar .rbc-toolbar .rbc-btn-group button::-moz-focus-inner{border:0;padding:0}.schedule .schedule-content .rbc-calendar .rbc-toolbar .rbc-btn-group button:first-child:not(:last-child){border-right:none;border-radius:4px 0 0 4px}.schedule .schedule-content .rbc-calendar .rbc-toolbar .rbc-btn-group button:last-child:not(:first-child){border-left:none;border-radius:0 4px 4px 0}.schedule .schedule-content .rbc-calendar .rbc-toolbar span:first-child button:first-child{display:none}.schedule .schedule-content .rbc-calendar .rbc-toolbar span:first-child button:nth-child(2){border-radius:4px 0 0 4px}.schedule.true{opacity:1;pointer-events:all;z-index:100}.rbc-abs-full,.rbc-row-bg{overflow:hidden;position:absolute;top:0;left:0;right:0;bottom:0}.rbc-ellipsis,.rbc-event-label,.rbc-row-segment .rbc-event-content,.rbc-show-more{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.rbc-rtl{direction:rtl}.rbc-off-range{color:#b3b3b3}.rbc-header{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:0 3px;text-align:center;vertical-align:middle;font-weight:700;font-size:90%;min-height:0}.rbc-header>a,.rbc-header>a:active,.rbc-header>a:visited{color:inherit;text-decoration:none}.rbc-row-content{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:4}.rbc-today{background-color:#e8e8eb}.rbc-event{height:auto;min-height:28px;padding:5px 10px;border-radius:4px;color:#fff;white-space:nowrap}.rbc-event,.rbc-event.rbc-selected{background-color:#fc4085}.rbc-event,.rbc-event-label{font-family:Varela Round,Arial Rounded MT,Arial,sans-serif;font-size:16px;font-weight:400;font-style:normal;text-transform:none;line-height:24px;margin:0;padding:5px 10px;text-decoration:none;color:#fff}.rbc-event-label{display:none}.rbc-event-continues-prior{border-top-left-radius:0;border-bottom-left-radius:0}.rbc-event-continues-after{border-top-right-radius:0;border-bottom-right-radius:0}.rbc-event-continues-earlier{border-top-left-radius:0;border-top-right-radius:0}.rbc-event-continues-later{border-bottom-left-radius:0;border-bottom-right-radius:0}.rbc-row{display:flex;flex-direction:row}.rbc-row-segment{padding:0 1px 1px}.rbc-selected-cell{background-color:#e8e8eb}.rbc-show-more{z-index:4;height:auto;white-space:nowrap;font-family:Varela Round,Arial Rounded MT,Arial,sans-serif;font-size:16px;font-weight:600;font-style:normal;text-transform:none;line-height:24px;margin:0;padding:0 10px;text-decoration:none;color:#1d1937}.rbc-month-view{position:relative;border:1px solid #d2d1d7;display:flex;flex-direction:column;flex:1 0 content;width:100%;user-select:none;height:100%}.rbc-month-view .rbc-header{border-bottom:1px solid #d2d1d7}.rbc-month-view .rbc-header+.rbc-header{border-left:1px solid #d2d1d7}.rbc-rtl .rbc-month-view .rbc-header+.rbc-header{border-left-width:0;border-right:1px solid #d2d1d7}.rbc-month-header{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.rbc-month-row{display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:column;flex-direction:column;-ms-flex:1 0 100px;flex:1 0 100px;overflow:hidden;height:100%}.rbc-month-row+.rbc-month-row{border-top:1px solid #d2d1d7}.rbc-date-cell{padding-right:5px;text-align:right}.rbc-date-cell.rbc-now{font-weight:700}.rbc-date-cell>a,.rbc-date-cell>a:active,.rbc-date-cell>a:visited{color:inherit;text-decoration:none}.rbc-row-bg{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex:1 0 0px;flex:1 0 0;overflow:hidden}.rbc-day-bg+.rbc-day-bg{border-left:1px solid #d2d1d7}.rbc-rtl .rbc-day-bg+.rbc-day-bg{border-left-width:0;border-right:1px solid #d2d1d7}.rbc-overlay{position:absolute;z-index:5;border:1px solid #e5e5e5;background-color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.25);padding:10px}.rbc-overlay>*+*{margin-top:1px}.rbc-overlay-header{border-bottom:1px solid #e5e5e5;margin:-10px -10px 5px;padding:2px 10px}.rbc-agenda-view{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex:1 0 0px;flex:1 0 0;overflow:auto}.rbc-agenda-view table{width:100%;border:1px solid #d2d1d7}.rbc-agenda-view table tbody>tr>td{padding:5px 10px;vertical-align:top}.rbc-agenda-view table .rbc-agenda-time-cell{padding-left:15px;padding-right:15px;text-transform:lowercase}.rbc-agenda-view table tbody>tr>td+td{border-left:1px solid #d2d1d7}.rbc-rtl .rbc-agenda-view table tbody>tr>td+td{border-left-width:0;border-right:1px solid #d2d1d7}.rbc-agenda-view table tbody>tr+tr{border-top:1px solid #d2d1d7}.rbc-agenda-view table thead>tr>th{padding:3px 5px;text-align:left;border-bottom:1px solid #d2d1d7}.rbc-rtl .rbc-agenda-view table thead>tr>th{text-align:right}.rbc-agenda-time-cell{text-transform:lowercase}.rbc-agenda-time-cell .rbc-continues-after:after{content:\" \\BB\"}.rbc-agenda-time-cell .rbc-continues-prior:before{content:\"\\AB   \"}.rbc-agenda-date-cell,.rbc-agenda-time-cell{white-space:nowrap}.rbc-agenda-event-cell{width:100%}.rbc-time-column{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-height:100%}.rbc-time-column .rbc-timeslot-group{-ms-flex:1;flex:1}.rbc-timeslot-group{border-bottom:1px solid #d2d1d7;min-height:40px;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap}.rbc-header-gutter,.rbc-time-gutter{-ms-flex:none;flex:none}.rbc-label{padding:0 5px}.rbc-day-slot{position:relative}.rbc-day-slot .rbc-event{display:-ms-flexbox;display:flex;max-height:100%;-ms-flex-flow:column wrap;flex-flow:column wrap;-ms-flex-align:start;align-items:flex-start;overflow:hidden}.rbc-day-slot .rbc-event-label{-ms-flex:none;flex:none;padding-right:5px;width:auto}.rbc-day-slot .rbc-event-content{width:100%;-ms-flex:1 1 0px;flex:1 1 0;word-wrap:break-word;line-height:1;height:100%;min-height:1em}.rbc-day-slot .rbc-time-slot{border-top:1px solid #f7f7f7}.rbc-time-slot{-ms-flex:1 0 0px;flex:1 0 0}.rbc-time-slot.rbc-now{font-weight:700}.rbc-day-header{text-align:center}.rbc-day-slot .rbc-event{position:absolute;z-index:2}.rbc-slot-selection{z-index:10;position:absolute;cursor:default;background-color:rgba(0,0,0,.5);color:#fff;font-size:75%;padding:3px}.rbc-time-view{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1;width:100%;border:1px solid #d2d1d7;min-height:0}.rbc-time-view .rbc-time-gutter{white-space:nowrap}.rbc-time-view .rbc-allday-cell{width:100%;position:relative}.rbc-time-view .rbc-allday-events{position:relative;z-index:4}.rbc-time-view .rbc-row{min-height:20px}.rbc-time-header{display:-ms-flexbox;display:flex;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-direction:column;flex-direction:column}.rbc-time-header.rbc-overflowing{border-right:1px solid #d2d1d7}.rbc-rtl .rbc-time-header.rbc-overflowing{border-right-width:0;border-left:1px solid #d2d1d7}.rbc-time-header>.rbc-row>*+*{border-left:1px solid #d2d1d7}.rbc-rtl .rbc-time-header>.rbc-row>*+*{border-left-width:0;border-right:1px solid #d2d1d7}.rbc-time-header>.rbc-row:first-child{border-bottom:1px solid #d2d1d7}.rbc-time-header .rbc-gutter-cell{-ms-flex:none;flex:none}.rbc-time-header>.rbc-gutter-cell+*{width:100%}.rbc-time-content{display:-ms-flexbox;display:flex;-ms-flex:1 0 0%;flex:1 0 0%;-ms-flex-align:start;align-items:flex-start;width:100%;border-top:2px solid #d2d1d7;overflow-y:auto;position:relative}.rbc-time-content>.rbc-time-gutter{-ms-flex:none;flex:none}.rbc-time-content>*+*>*{border-left:1px solid #d2d1d7}.rbc-rtl .rbc-time-content>*+*>*{border-left-width:0;border-right:1px solid #d2d1d7}.rbc-time-content>.rbc-day-slot{width:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rbc-current-time-indicator{position:absolute;z-index:1;left:0;height:1px;background-color:#20c49e;pointer-events:none}.rbc-current-time-indicator:before{display:block;position:absolute;left:-3px;top:-3px;content:\" \";background-color:#20c49e;border-radius:50%;width:8px;height:8px}.rbc-rtl .rbc-current-time-indicator:before{left:0;right:-3px}.tabs.white{background-color:#fff}.tabs{width:100vw;height:auto;padding:0 60px;z-index:20}.tabs .title{width:100%;height:auto;padding:40px 0}.tabs .title h1{width:100%;height:48px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.tabs ul.panes{width:100%;height:auto;display:flex;justify-content:flex-start;flex-wrap:nowrap;list-style-type:none;padding:0;margin:0}.tabs ul.panes li{flex:0 0 content;border-bottom:4px solid transparent;margin-right:20px}.tabs ul.panes li p{color:#d2d1d7;font-weight:700;padding-bottom:4px;cursor:pointer;white-space:nowrap}.tabs ul.panes li.active{border-bottom:4px solid #1d1937}.tabs ul.panes li.active p{color:#1d1937;cursor:default}.tabs ul.panes li.spacer{flex:1 1 auto}.tabs-small{height:auto;width:100%;background-color:#fff}.tabs-small .title{width:100%;height:auto;padding:0}.tabs-small .title h1{line-height:60px;display:inline-block;vertical-align:top;margin:0}.tabs-small ul.panes{width:100%;height:auto;display:flex;justify-content:flex-start;flex-wrap:nowrap;list-style-type:none;padding:0;margin:0}.tabs-small ul.panes li{flex:0 0 content;border-bottom:4px solid transparent;margin-right:20px}.tabs-small ul.panes li p{color:#d2d1d7;font-weight:700;padding-bottom:4px;cursor:pointer;white-space:nowrap}.tabs-small ul.panes li.active{border-bottom:4px solid #1d1937}.tabs-small ul.panes li.active p{color:#1d1937;cursor:default}.tabs-small ul.panes li.spacer{flex:1 1 auto}.white-header{width:100vw;height:auto;z-index:20;background:#fff;padding:0 calc(50vw - 700px);border-bottom:1px solid #e8e8eb}.white-header.collab{padding-bottom:10px}.white-header .row{width:100%;height:auto;min-height:46px;display:flex;justify-content:flex-start;align-items:center;padding:10px 60px}.white-header .row.no-bottom-padding{padding:10px 60px 0}.white-header .row .flex-spacer{flex:1 1 auto;min-width:0;margin-top:10px}.white-header .row .flex-spacer h1{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.white-header .row .flex-spacer.no-padding{padding:0}.white-header .row .flex-spacer .input-label{padding:10px}.white-header .row .flex-item{flex:0 0 content}.white-header .row .flex-item button,.white-header .row .flex-item input{vertical-align:top;margin:0}.white-header .row .flex-item p.field-symbol{top:13px}.white-header .row .flex-item button.margin{margin-left:10px}.white-header .row .flex-item .input-label{padding:10px}.white-header .row .flex-item.no-padding{padding:0}.white-header .row.large{padding:20px 32px 10px}.budget-col-header{width:100%;height:auto;z-index:20;padding:0}.budget-col-header .row{width:100%;height:auto;min-height:46px;display:flex;justify-content:flex-start;align-items:center;padding:0}.budget-col-header .row .add-button{padding-top:0;margin-top:0;margin-right:15px}.budget-col-header .row .flex-spacer{flex:1 1 auto;min-width:0}.budget-col-header .row .flex-spacer h1{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.budget-col-header .row .flex-spacer.no-padding{padding:0}.budget-col-header .row .flex-item{flex:0 0 content}.budget-col-header .row .flex-item button,.budget-col-header .row .flex-item input{vertical-align:top;margin:0}.budget-col-header .row .flex-item p.field-symbol{top:13px}.budget-col-header .row .flex-item button.margin{margin-left:10px}.budget-col-header .row .flex-item .input-label{padding:10px}.budget-col-header .row .flex-item.no-padding{padding:0}.flex-tabs{width:100%;height:auto;display:flex;flex-wrap:nowrap;background:#fff;padding:0 calc(50vw - 670px)}.flex-tabs .tab{flex:1 0 0;border-bottom:4px solid #fff;text-align:center;opacity:.5;padding:10px}.flex-tabs .tab.active{border-bottom:4px solid #1d1937;opacity:1}@media only screen and (max-width:1440px){.tabs{padding:0 60px}.flex-tabs{padding:0 50px}}@media only screen and (max-width:1024px){.tabs{padding:0 60px}.flex-tabs{padding:0 50px}}@media only screen and (max-width:768px){.tabs{padding:0 50px}.tabs .left,.tabs .notifications,.tabs .right{display:none;visibility:hidden}.tabs .menu{visibility:visible}}@media only screen and (max-width:375px){.tabs{padding:0 20px}}.analytics{width:100vw;height:100vh;position:fixed;top:0;left:0;overflow:auto;background-color:#fff;opacity:0;pointer-events:none;z-index:-1}.analytics .analytics-meta{width:100%;height:60px;background-color:#fff;border-bottom:1px solid #e8e8eb;padding:0 60px}.analytics .analytics-meta h3{line-height:60px;display:inline-block;vertical-align:top;margin:0}.analytics .analytics-meta img{width:24px;height:24px;float:right;vertical-align:top;margin:18px 0;opacity:1;cursor:pointer;transition:all .2s ease-in-out}.analytics .analytics-meta img:hover{opacity:.5}.analytics .analytics-content{padding:0}.analytics .analytics-content,.analytics .analytics-content iframe{width:100%;height:calc(100vh - 60px)}.analytics.visible{opacity:1;pointer-events:all;z-index:100}.analytics-chart{border:1px solid #e8e8eb;background-color:#fff;border-radius:4px;margin-top:10px;padding:10px}.analytics-asset-list{padding:0 15px}.chartsubtitle{padding:0 20px}.info-hover-wrapper{display:flex;flex-direction:row;justify-content:center;align-items:center}.info-hover-wrapper div,.info-hover-wrapper p{flex:0 0 auto;margin:0 5px}.info-hover-icon{width:24px;height:24px;clear:both;cursor:pointer;background-image:url(\"/icons/stats-info.svg\");background-size:cover;background-position:50%;background-repeat:no-repeat}.info-hover-icon:hover{background-image:url(\"/icons/stats-info-hover.svg\")}.progressX{width:160px;height:160px;background-color:#e8e8eb;border-radius:50%}.progressX .circle{position:relative}.progressX .circle .small-overlay-cirle{display:none;position:absolute;left:72.5px;top:-5px;width:15px;height:15px;border-radius:50%;background-color:#20c49e;z-index:1}.progressX .circle .small-overlay-cirle.display{display:inline-block}.progressX .circle .fill,.progressX .circle .mask{width:160px;height:160px;position:absolute;-webkit-backface-visibility:hidden;transition:transform 1s;border-radius:50%}.progressX .circle .mask{clip:rect(0,160px,160px,80px)}.progressX .circle .mask .fill{clip:rect(0,80px,160px,0)}.progressX .circle.rose .fill{background:#fc4085}.progressX .circle.amber .fill{background:#fdb02b}.progressX .circle.seagreen .fill{background:#20c49e}.progressX .overlay{width:150px;height:150px;position:absolute;margin-left:5px;margin-top:5px;border-radius:50%;background-color:#fff;display:flex;justify-content:center;flex-direction:column;align-items:center;flex-wrap:nowrap;text-align:center}.progressX .overlay h2.modal{padding-top:24px}.progressX .overlay>*{flex:0 0 content}.progressX .overlay .stats-info{width:24px;height:24px;clear:both;cursor:pointer;background-image:url(\"/icons/stats-info.svg\");background-size:cover;background-position:50%;background-repeat:no-repeat}.progressX .overlay .stats-info:hover{background-image:url(\"/icons/stats-info-hover.svg\")}.progressX[data-progress=\"0\"] .circle .fill,.progressX[data-progress=\"0\"] .circle .fill.fix,.progressX[data-progress=\"0\"] .circle .mask.full{transform:rotate(0deg)}.progressX[data-progress=\"1\"] .circle .fill,.progressX[data-progress=\"1\"] .circle .mask.full{transform:rotate(1.8deg)}.progressX[data-progress=\"1\"] .circle .fill.fix,.progressX[data-progress=\"2\"] .circle .fill,.progressX[data-progress=\"2\"] .circle .mask.full{transform:rotate(3.6deg)}.progressX[data-progress=\"2\"] .circle .fill.fix{transform:rotate(7.2deg)}.progressX[data-progress=\"3\"] .circle .fill,.progressX[data-progress=\"3\"] .circle .mask.full{transform:rotate(5.4deg)}.progressX[data-progress=\"3\"] .circle .fill.fix{transform:rotate(10.8deg)}.progressX[data-progress=\"4\"] .circle .fill,.progressX[data-progress=\"4\"] .circle .mask.full{transform:rotate(7.2deg)}.progressX[data-progress=\"4\"] .circle .fill.fix{transform:rotate(14.4deg)}.progressX[data-progress=\"5\"] .circle .fill,.progressX[data-progress=\"5\"] .circle .mask.full{transform:rotate(9deg)}.progressX[data-progress=\"5\"] .circle .fill.fix{transform:rotate(18deg)}.progressX[data-progress=\"6\"] .circle .fill,.progressX[data-progress=\"6\"] .circle .mask.full{transform:rotate(10.8deg)}.progressX[data-progress=\"6\"] .circle .fill.fix{transform:rotate(21.6deg)}.progressX[data-progress=\"7\"] .circle .fill,.progressX[data-progress=\"7\"] .circle .mask.full{transform:rotate(12.6deg)}.progressX[data-progress=\"7\"] .circle .fill.fix{transform:rotate(25.2deg)}.progressX[data-progress=\"8\"] .circle .fill,.progressX[data-progress=\"8\"] .circle .mask.full{transform:rotate(14.4deg)}.progressX[data-progress=\"8\"] .circle .fill.fix{transform:rotate(28.8deg)}.progressX[data-progress=\"9\"] .circle .fill,.progressX[data-progress=\"9\"] .circle .mask.full{transform:rotate(16.2deg)}.progressX[data-progress=\"9\"] .circle .fill.fix{transform:rotate(32.4deg)}.progressX[data-progress=\"10\"] .circle .fill,.progressX[data-progress=\"10\"] .circle .mask.full{transform:rotate(18deg)}.progressX[data-progress=\"10\"] .circle .fill.fix{transform:rotate(36deg)}.progressX[data-progress=\"11\"] .circle .fill,.progressX[data-progress=\"11\"] .circle .mask.full{transform:rotate(19.8deg)}.progressX[data-progress=\"11\"] .circle .fill.fix{transform:rotate(39.6deg)}.progressX[data-progress=\"12\"] .circle .fill,.progressX[data-progress=\"12\"] .circle .mask.full{transform:rotate(21.6deg)}.progressX[data-progress=\"12\"] .circle .fill.fix{transform:rotate(43.2deg)}.progressX[data-progress=\"13\"] .circle .fill,.progressX[data-progress=\"13\"] .circle .mask.full{transform:rotate(23.4deg)}.progressX[data-progress=\"13\"] .circle .fill.fix{transform:rotate(46.8deg)}.progressX[data-progress=\"14\"] .circle .fill,.progressX[data-progress=\"14\"] .circle .mask.full{transform:rotate(25.2deg)}.progressX[data-progress=\"14\"] .circle .fill.fix{transform:rotate(50.4deg)}.progressX[data-progress=\"15\"] .circle .fill,.progressX[data-progress=\"15\"] .circle .mask.full{transform:rotate(27deg)}.progressX[data-progress=\"15\"] .circle .fill.fix{transform:rotate(54deg)}.progressX[data-progress=\"16\"] .circle .fill,.progressX[data-progress=\"16\"] .circle .mask.full{transform:rotate(28.8deg)}.progressX[data-progress=\"16\"] .circle .fill.fix{transform:rotate(57.6deg)}.progressX[data-progress=\"17\"] .circle .fill,.progressX[data-progress=\"17\"] .circle .mask.full{transform:rotate(30.6deg)}.progressX[data-progress=\"17\"] .circle .fill.fix{transform:rotate(61.2deg)}.progressX[data-progress=\"18\"] .circle .fill,.progressX[data-progress=\"18\"] .circle .mask.full{transform:rotate(32.4deg)}.progressX[data-progress=\"18\"] .circle .fill.fix{transform:rotate(64.8deg)}.progressX[data-progress=\"19\"] .circle .fill,.progressX[data-progress=\"19\"] .circle .mask.full{transform:rotate(34.2deg)}.progressX[data-progress=\"19\"] .circle .fill.fix{transform:rotate(68.4deg)}.progressX[data-progress=\"20\"] .circle .fill,.progressX[data-progress=\"20\"] .circle .mask.full{transform:rotate(36deg)}.progressX[data-progress=\"20\"] .circle .fill.fix{transform:rotate(72deg)}.progressX[data-progress=\"21\"] .circle .fill,.progressX[data-progress=\"21\"] .circle .mask.full{transform:rotate(37.8deg)}.progressX[data-progress=\"21\"] .circle .fill.fix{transform:rotate(75.6deg)}.progressX[data-progress=\"22\"] .circle .fill,.progressX[data-progress=\"22\"] .circle .mask.full{transform:rotate(39.6deg)}.progressX[data-progress=\"22\"] .circle .fill.fix{transform:rotate(79.2deg)}.progressX[data-progress=\"23\"] .circle .fill,.progressX[data-progress=\"23\"] .circle .mask.full{transform:rotate(41.4deg)}.progressX[data-progress=\"23\"] .circle .fill.fix{transform:rotate(82.8deg)}.progressX[data-progress=\"24\"] .circle .fill,.progressX[data-progress=\"24\"] .circle .mask.full{transform:rotate(43.2deg)}.progressX[data-progress=\"24\"] .circle .fill.fix{transform:rotate(86.4deg)}.progressX[data-progress=\"25\"] .circle .fill,.progressX[data-progress=\"25\"] .circle .mask.full{transform:rotate(45deg)}.progressX[data-progress=\"25\"] .circle .fill.fix{transform:rotate(90deg)}.progressX[data-progress=\"26\"] .circle .fill,.progressX[data-progress=\"26\"] .circle .mask.full{transform:rotate(46.8deg)}.progressX[data-progress=\"26\"] .circle .fill.fix{transform:rotate(93.6deg)}.progressX[data-progress=\"27\"] .circle .fill,.progressX[data-progress=\"27\"] .circle .mask.full{transform:rotate(48.6deg)}.progressX[data-progress=\"27\"] .circle .fill.fix{transform:rotate(97.2deg)}.progressX[data-progress=\"28\"] .circle .fill,.progressX[data-progress=\"28\"] .circle .mask.full{transform:rotate(50.4deg)}.progressX[data-progress=\"28\"] .circle .fill.fix{transform:rotate(100.8deg)}.progressX[data-progress=\"29\"] .circle .fill,.progressX[data-progress=\"29\"] .circle .mask.full{transform:rotate(52.2deg)}.progressX[data-progress=\"29\"] .circle .fill.fix{transform:rotate(104.4deg)}.progressX[data-progress=\"30\"] .circle .fill,.progressX[data-progress=\"30\"] .circle .mask.full{transform:rotate(54deg)}.progressX[data-progress=\"30\"] .circle .fill.fix{transform:rotate(108deg)}.progressX[data-progress=\"31\"] .circle .fill,.progressX[data-progress=\"31\"] .circle .mask.full{transform:rotate(55.8deg)}.progressX[data-progress=\"31\"] .circle .fill.fix{transform:rotate(.31turn)}.progressX[data-progress=\"32\"] .circle .fill,.progressX[data-progress=\"32\"] .circle .mask.full{transform:rotate(57.6deg)}.progressX[data-progress=\"32\"] .circle .fill.fix{transform:rotate(.32turn)}.progressX[data-progress=\"33\"] .circle .fill,.progressX[data-progress=\"33\"] .circle .mask.full{transform:rotate(59.4deg)}.progressX[data-progress=\"33\"] .circle .fill.fix{transform:rotate(.33turn)}.progressX[data-progress=\"34\"] .circle .fill,.progressX[data-progress=\"34\"] .circle .mask.full{transform:rotate(61.2deg)}.progressX[data-progress=\"34\"] .circle .fill.fix{transform:rotate(.34turn)}.progressX[data-progress=\"35\"] .circle .fill,.progressX[data-progress=\"35\"] .circle .mask.full{transform:rotate(63deg)}.progressX[data-progress=\"35\"] .circle .fill.fix{transform:rotate(126deg)}.progressX[data-progress=\"36\"] .circle .fill,.progressX[data-progress=\"36\"] .circle .mask.full{transform:rotate(64.8deg)}.progressX[data-progress=\"36\"] .circle .fill.fix{transform:rotate(.36turn)}.progressX[data-progress=\"37\"] .circle .fill,.progressX[data-progress=\"37\"] .circle .mask.full{transform:rotate(66.6deg)}.progressX[data-progress=\"37\"] .circle .fill.fix{transform:rotate(.37turn)}.progressX[data-progress=\"38\"] .circle .fill,.progressX[data-progress=\"38\"] .circle .mask.full{transform:rotate(68.4deg)}.progressX[data-progress=\"38\"] .circle .fill.fix{transform:rotate(.38turn)}.progressX[data-progress=\"39\"] .circle .fill,.progressX[data-progress=\"39\"] .circle .mask.full{transform:rotate(70.2deg)}.progressX[data-progress=\"39\"] .circle .fill.fix{transform:rotate(.39turn)}.progressX[data-progress=\"40\"] .circle .fill,.progressX[data-progress=\"40\"] .circle .mask.full{transform:rotate(72deg)}.progressX[data-progress=\"40\"] .circle .fill.fix{transform:rotate(144deg)}.progressX[data-progress=\"41\"] .circle .fill,.progressX[data-progress=\"41\"] .circle .mask.full{transform:rotate(73.8deg)}.progressX[data-progress=\"41\"] .circle .fill.fix{transform:rotate(.41turn)}.progressX[data-progress=\"42\"] .circle .fill,.progressX[data-progress=\"42\"] .circle .mask.full{transform:rotate(75.6deg)}.progressX[data-progress=\"42\"] .circle .fill.fix{transform:rotate(.42turn)}.progressX[data-progress=\"43\"] .circle .fill,.progressX[data-progress=\"43\"] .circle .mask.full{transform:rotate(77.4deg)}.progressX[data-progress=\"43\"] .circle .fill.fix{transform:rotate(154.8deg)}.progressX[data-progress=\"44\"] .circle .fill,.progressX[data-progress=\"44\"] .circle .mask.full{transform:rotate(79.2deg)}.progressX[data-progress=\"44\"] .circle .fill.fix{transform:rotate(.44turn)}.progressX[data-progress=\"45\"] .circle .fill,.progressX[data-progress=\"45\"] .circle .mask.full{transform:rotate(81deg)}.progressX[data-progress=\"45\"] .circle .fill.fix{transform:rotate(162deg)}.progressX[data-progress=\"46\"] .circle .fill,.progressX[data-progress=\"46\"] .circle .mask.full{transform:rotate(82.8deg)}.progressX[data-progress=\"46\"] .circle .fill.fix{transform:rotate(165.6deg)}.progressX[data-progress=\"47\"] .circle .fill,.progressX[data-progress=\"47\"] .circle .mask.full{transform:rotate(84.6deg)}.progressX[data-progress=\"47\"] .circle .fill.fix{transform:rotate(.47turn)}.progressX[data-progress=\"48\"] .circle .fill,.progressX[data-progress=\"48\"] .circle .mask.full{transform:rotate(86.4deg)}.progressX[data-progress=\"48\"] .circle .fill.fix{transform:rotate(172.8deg)}.progressX[data-progress=\"49\"] .circle .fill,.progressX[data-progress=\"49\"] .circle .mask.full{transform:rotate(88.2deg)}.progressX[data-progress=\"49\"] .circle .fill.fix{transform:rotate(.49turn)}.progressX[data-progress=\"50\"] .circle .fill,.progressX[data-progress=\"50\"] .circle .mask.full{transform:rotate(90deg)}.progressX[data-progress=\"50\"] .circle .fill.fix{transform:rotate(180deg)}.progressX[data-progress=\"51\"] .circle .fill,.progressX[data-progress=\"51\"] .circle .mask.full{transform:rotate(91.8deg)}.progressX[data-progress=\"51\"] .circle .fill.fix{transform:rotate(.51turn)}.progressX[data-progress=\"52\"] .circle .fill,.progressX[data-progress=\"52\"] .circle .mask.full{transform:rotate(93.6deg)}.progressX[data-progress=\"52\"] .circle .fill.fix{transform:rotate(.52turn)}.progressX[data-progress=\"53\"] .circle .fill,.progressX[data-progress=\"53\"] .circle .mask.full{transform:rotate(95.4deg)}.progressX[data-progress=\"53\"] .circle .fill.fix{transform:rotate(.53turn)}.progressX[data-progress=\"54\"] .circle .fill,.progressX[data-progress=\"54\"] .circle .mask.full{transform:rotate(97.2deg)}.progressX[data-progress=\"54\"] .circle .fill.fix{transform:rotate(.54turn)}.progressX[data-progress=\"55\"] .circle .fill,.progressX[data-progress=\"55\"] .circle .mask.full{transform:rotate(99deg)}.progressX[data-progress=\"55\"] .circle .fill.fix{transform:rotate(198deg)}.progressX[data-progress=\"56\"] .circle .fill,.progressX[data-progress=\"56\"] .circle .mask.full{transform:rotate(100.8deg)}.progressX[data-progress=\"56\"] .circle .fill.fix{transform:rotate(201.6deg)}.progressX[data-progress=\"57\"] .circle .fill,.progressX[data-progress=\"57\"] .circle .mask.full{transform:rotate(102.6deg)}.progressX[data-progress=\"57\"] .circle .fill.fix{transform:rotate(.57turn)}.progressX[data-progress=\"58\"] .circle .fill,.progressX[data-progress=\"58\"] .circle .mask.full{transform:rotate(104.4deg)}.progressX[data-progress=\"58\"] .circle .fill.fix{transform:rotate(208.8deg)}.progressX[data-progress=\"59\"] .circle .fill,.progressX[data-progress=\"59\"] .circle .mask.full{transform:rotate(106.2deg)}.progressX[data-progress=\"59\"] .circle .fill.fix{transform:rotate(.59turn)}.progressX[data-progress=\"60\"] .circle .fill,.progressX[data-progress=\"60\"] .circle .mask.full{transform:rotate(108deg)}.progressX[data-progress=\"60\"] .circle .fill.fix{transform:rotate(216deg)}.progressX[data-progress=\"61\"] .circle .fill,.progressX[data-progress=\"61\"] .circle .mask.full{transform:rotate(109.8deg)}.progressX[data-progress=\"61\"] .circle .fill.fix{transform:rotate(.61turn)}.progressX[data-progress=\"62\"] .circle .fill,.progressX[data-progress=\"62\"] .circle .mask.full{transform:rotate(.31turn)}.progressX[data-progress=\"62\"] .circle .fill.fix{transform:rotate(.62turn)}.progressX[data-progress=\"63\"] .circle .fill,.progressX[data-progress=\"63\"] .circle .mask.full{transform:rotate(113.4deg)}.progressX[data-progress=\"63\"] .circle .fill.fix{transform:rotate(.63turn)}.progressX[data-progress=\"64\"] .circle .fill,.progressX[data-progress=\"64\"] .circle .mask.full{transform:rotate(.32turn)}.progressX[data-progress=\"64\"] .circle .fill.fix{transform:rotate(.64turn)}.progressX[data-progress=\"65\"] .circle .fill,.progressX[data-progress=\"65\"] .circle .mask.full{transform:rotate(117deg)}.progressX[data-progress=\"65\"] .circle .fill.fix{transform:rotate(234deg)}.progressX[data-progress=\"66\"] .circle .fill,.progressX[data-progress=\"66\"] .circle .mask.full{transform:rotate(.33turn)}.progressX[data-progress=\"66\"] .circle .fill.fix{transform:rotate(.66turn)}.progressX[data-progress=\"67\"] .circle .fill,.progressX[data-progress=\"67\"] .circle .mask.full{transform:rotate(120.6deg)}.progressX[data-progress=\"67\"] .circle .fill.fix{transform:rotate(241.2deg)}.progressX[data-progress=\"68\"] .circle .fill,.progressX[data-progress=\"68\"] .circle .mask.full{transform:rotate(.34turn)}.progressX[data-progress=\"68\"] .circle .fill.fix{transform:rotate(.68turn)}.progressX[data-progress=\"69\"] .circle .fill,.progressX[data-progress=\"69\"] .circle .mask.full{transform:rotate(124.2deg)}.progressX[data-progress=\"69\"] .circle .fill.fix{transform:rotate(248.4deg)}.progressX[data-progress=\"70\"] .circle .fill,.progressX[data-progress=\"70\"] .circle .mask.full{transform:rotate(126deg)}.progressX[data-progress=\"70\"] .circle .fill.fix{transform:rotate(252deg)}.progressX[data-progress=\"71\"] .circle .fill,.progressX[data-progress=\"71\"] .circle .mask.full{transform:rotate(127.8deg)}.progressX[data-progress=\"71\"] .circle .fill.fix{transform:rotate(.71turn)}.progressX[data-progress=\"72\"] .circle .fill,.progressX[data-progress=\"72\"] .circle .mask.full{transform:rotate(.36turn)}.progressX[data-progress=\"72\"] .circle .fill.fix{transform:rotate(.72turn)}.progressX[data-progress=\"73\"] .circle .fill,.progressX[data-progress=\"73\"] .circle .mask.full{transform:rotate(131.4deg)}.progressX[data-progress=\"73\"] .circle .fill.fix{transform:rotate(.73turn)}.progressX[data-progress=\"74\"] .circle .fill,.progressX[data-progress=\"74\"] .circle .mask.full{transform:rotate(.37turn)}.progressX[data-progress=\"74\"] .circle .fill.fix{transform:rotate(.74turn)}.progressX[data-progress=\"75\"] .circle .fill,.progressX[data-progress=\"75\"] .circle .mask.full{transform:rotate(135deg)}.progressX[data-progress=\"75\"] .circle .fill.fix{transform:rotate(270deg)}.progressX[data-progress=\"76\"] .circle .fill,.progressX[data-progress=\"76\"] .circle .mask.full{transform:rotate(.38turn)}.progressX[data-progress=\"76\"] .circle .fill.fix{transform:rotate(.76turn)}.progressX[data-progress=\"77\"] .circle .fill,.progressX[data-progress=\"77\"] .circle .mask.full{transform:rotate(138.6deg)}.progressX[data-progress=\"77\"] .circle .fill.fix{transform:rotate(.77turn)}.progressX[data-progress=\"78\"] .circle .fill,.progressX[data-progress=\"78\"] .circle .mask.full{transform:rotate(.39turn)}.progressX[data-progress=\"78\"] .circle .fill.fix{transform:rotate(.78turn)}.progressX[data-progress=\"79\"] .circle .fill,.progressX[data-progress=\"79\"] .circle .mask.full{transform:rotate(142.2deg)}.progressX[data-progress=\"79\"] .circle .fill.fix{transform:rotate(284.4deg)}.progressX[data-progress=\"80\"] .circle .fill,.progressX[data-progress=\"80\"] .circle .mask.full{transform:rotate(144deg)}.progressX[data-progress=\"80\"] .circle .fill.fix{transform:rotate(288deg)}.progressX[data-progress=\"81\"] .circle .fill,.progressX[data-progress=\"81\"] .circle .mask.full{transform:rotate(145.8deg)}.progressX[data-progress=\"81\"] .circle .fill.fix{transform:rotate(.81turn)}.progressX[data-progress=\"82\"] .circle .fill,.progressX[data-progress=\"82\"] .circle .mask.full{transform:rotate(.41turn)}.progressX[data-progress=\"82\"] .circle .fill.fix{transform:rotate(.82turn)}.progressX[data-progress=\"83\"] .circle .fill,.progressX[data-progress=\"83\"] .circle .mask.full{transform:rotate(149.4deg)}.progressX[data-progress=\"83\"] .circle .fill.fix{transform:rotate(298.8deg)}.progressX[data-progress=\"84\"] .circle .fill,.progressX[data-progress=\"84\"] .circle .mask.full{transform:rotate(.42turn)}.progressX[data-progress=\"84\"] .circle .fill.fix{transform:rotate(.84turn)}.progressX[data-progress=\"85\"] .circle .fill,.progressX[data-progress=\"85\"] .circle .mask.full{transform:rotate(153deg)}.progressX[data-progress=\"85\"] .circle .fill.fix{transform:rotate(306deg)}.progressX[data-progress=\"86\"] .circle .fill,.progressX[data-progress=\"86\"] .circle .mask.full{transform:rotate(154.8deg)}.progressX[data-progress=\"86\"] .circle .fill.fix{transform:rotate(309.6deg)}.progressX[data-progress=\"87\"] .circle .fill,.progressX[data-progress=\"87\"] .circle .mask.full{transform:rotate(156.6deg)}.progressX[data-progress=\"87\"] .circle .fill.fix{transform:rotate(.87turn)}.progressX[data-progress=\"88\"] .circle .fill,.progressX[data-progress=\"88\"] .circle .mask.full{transform:rotate(.44turn)}.progressX[data-progress=\"88\"] .circle .fill.fix{transform:rotate(.88turn)}.progressX[data-progress=\"89\"] .circle .fill,.progressX[data-progress=\"89\"] .circle .mask.full{transform:rotate(160.2deg)}.progressX[data-progress=\"89\"] .circle .fill.fix{transform:rotate(320.4deg)}.progressX[data-progress=\"90\"] .circle .fill,.progressX[data-progress=\"90\"] .circle .mask.full{transform:rotate(162deg)}.progressX[data-progress=\"90\"] .circle .fill.fix{transform:rotate(324deg)}.progressX[data-progress=\"91\"] .circle .fill,.progressX[data-progress=\"91\"] .circle .mask.full{transform:rotate(163.8deg)}.progressX[data-progress=\"91\"] .circle .fill.fix{transform:rotate(.91turn)}.progressX[data-progress=\"92\"] .circle .fill,.progressX[data-progress=\"92\"] .circle .mask.full{transform:rotate(165.6deg)}.progressX[data-progress=\"92\"] .circle .fill.fix{transform:rotate(331.2deg)}.progressX[data-progress=\"93\"] .circle .fill,.progressX[data-progress=\"93\"] .circle .mask.full{transform:rotate(167.4deg)}.progressX[data-progress=\"93\"] .circle .fill.fix{transform:rotate(.93turn)}.progressX[data-progress=\"94\"] .circle .fill,.progressX[data-progress=\"94\"] .circle .mask.full{transform:rotate(.47turn)}.progressX[data-progress=\"94\"] .circle .fill.fix{transform:rotate(.94turn)}.progressX[data-progress=\"95\"] .circle .fill,.progressX[data-progress=\"95\"] .circle .mask.full{transform:rotate(171deg)}.progressX[data-progress=\"95\"] .circle .fill.fix{transform:rotate(342deg)}.progressX[data-progress=\"96\"] .circle .fill,.progressX[data-progress=\"96\"] .circle .mask.full{transform:rotate(172.8deg)}.progressX[data-progress=\"96\"] .circle .fill.fix{transform:rotate(345.6deg)}.progressX[data-progress=\"97\"] .circle .fill,.progressX[data-progress=\"97\"] .circle .mask.full{transform:rotate(174.6deg)}.progressX[data-progress=\"97\"] .circle .fill.fix{transform:rotate(.97turn)}.progressX[data-progress=\"98\"] .circle .fill,.progressX[data-progress=\"98\"] .circle .mask.full{transform:rotate(.49turn)}.progressX[data-progress=\"98\"] .circle .fill.fix{transform:rotate(.98turn)}.progressX[data-progress=\"99\"] .circle .fill,.progressX[data-progress=\"99\"] .circle .mask.full{transform:rotate(178.2deg)}.progressX[data-progress=\"99\"] .circle .fill.fix{transform:rotate(.99turn)}.progressX[data-progress=\"100\"] .circle .fill,.progressX[data-progress=\"100\"] .circle .mask.full{transform:rotate(180deg)}.progressX[data-progress=\"100\"] .circle .fill.fix{transform:rotate(1turn)}.stats{flex:1 1 auto;width:auto;height:auto;display:flex;justify-content:flex-start;flex-direction:column;text-align:center}.asset-list{border-bottom:1px solid #d2d1d7}.asset-list .asset-card{width:100%;height:80px;display:flex;justify-content:center;align-items:center;flex-wrap:nowrap;padding:8px 0;background:#fff;border-top:1px solid #d2d1d7!important}.asset-list .asset-card .flex-item{flex:0 0 100px;min-width:80px;padding:0 16px}.asset-list .asset-card .flex-item img.thumbnail{width:86px;height:64px;object-fit:cover}.asset-list .asset-card .flex-spacer{flex:1 1 550px;padding:0 8px}.asset-list .asset-card .flex-item-small{height:100%;flex:0 0 auto;min-width:40px;padding:5px 0}.asset-list-header{width:100%;height:80px;display:flex;justify-content:center;align-items:center;flex-wrap:nowrap;padding:0}.asset-list-header .flex-item{flex:0 0 100px;padding:0;text-align:center}.asset-list-header .flex-item img.thumbnail{width:86px;height:64px;object-fit:cover}.asset-list-header .flex-item p{text-align:center;font-weight:600}.asset-list-header .flex-item.large{flex:0 0 120px}.asset-list-header .flex-spacer{flex:1 1 auto;display:flex;justify-content:flex-start;align-items:center;padding:0 8px}.asset-list-header .flex-spacer img{flex:0 0 auto}.asset-list-header .flex-spacer h2{flex:1 1 auto}.asset-list-header .flex-item-small{height:100%;flex:0 0 auto;min-width:40px;padding:0}.asset-list-totals{width:100%;height:50px;display:flex;background-color:#e8e8eb;justify-content:center;align-items:center;flex-wrap:nowrap;padding:0}.asset-list-totals .flex-item{flex:0 0 100px;padding:0;text-align:center}.asset-list-totals .flex-item p{text-align:center;font-weight:600}.asset-list-totals .flex-spacer{flex:1 1 auto;display:flex;justify-content:flex-start;align-items:center;padding:0 8px}.asset-list-totals .flex-item-small{height:100%;flex:0 0 auto;min-width:40px;padding:0}.video-list-filtering-container{display:flex;width:100%;flex-wrap:wrap;margin-bottom:10px;justify-content:flex-end;align-items:center}.video-list-filtering-container .filter-by{flex:0 0 300px;display:flex;align-items:center;justify-content:center}.video-list-filtering-container .filter-by p{flex:0 0 100px;font-weight:600}.video-list-filtering-container .sort-by{flex:1 0 270px;display:flex;align-items:center}.video-list-filtering-container .sort-by p{flex:1 0 70px;text-align:right;padding-right:10px;font-weight:600}.video-list-filtering-container .select{flex:0 0 200px}.influencer-card{width:100%;height:auto;background-color:#fff;border:1px solid #d2d1d7;border-radius:4px;display:flex;justify-content:flex-start;align-items:center;flex-wrap:nowrap;padding:20px}.influencer-card .flex-item{flex:0 0 content;padding:0 20px}.influencer-card .flex-item:first-child{padding-left:0}.influencer-card .flex-spacer{flex:1 1 auto}.info-card{width:100%;height:auto;background-color:#fff;padding:10px;border:1px solid #d2d1d7;border-radius:4px;flex-wrap:nowrap}.info-card,.info-card .info-left{display:flex;justify-content:center}.info-card .info-left{flex:1 0 300px;margin:10px;align-items:flex-start}.info-card .info-left .asset-wrapper{flex:1 1 calc(40vw - 30px);height:calc((40vw - 30px) * .5625)}.info-card .info-left .instagram-wrapper{flex:1 1 calc(40vw - 30px);height:auto}.info-card .info-left .instagram-wrapper img{height:auto;max-height:400px}.info-card .info-left .facebook-wrapper{flex:1 1 auto;text-align:center}.info-card .info-left .image-wrapper{flex:0 0 400px;text-align:center;margin:0 auto;max-height:380px;height:auto}.info-card .info-left .image-wrapper img{width:auto;height:auto;max-width:450px;max-height:380px}.info-card .info-right{flex:0 0 600px;margin:10px}.info-card .info-right .column-item{width:100%;height:auto;display:block}.info-card .info-right .column-item .calculator{width:100%;height:auto;padding:20px;border:2px dashed #d2d1d7;border-radius:4px}.info-card .info-right .column-item .calculator .calculator-input{height:46px;position:relative}.info-card .info-right .column-item .calculator .calculator-input input{width:200px;margin:0;position:absolute;top:0;left:0;padding-left:24px}.info-card .info-right .column-item .calculator .calculator-input input+label{position:absolute;top:10px;left:15px}.info-card .info-right .column-item .calculator .calculator-input .result{position:absolute;top:10px;left:220px}.tag-cloud{width:100%;height:auto;background-color:#fff;border:1px solid #d2d1d7;border-radius:4px;padding:20px;text-align:center}.tag-cloud .tag-cloud-tag{color:#000!important;padding:10px}.social-bar{width:100%;height:auto}.social-bar .line-item{height:4px;background:red;display:inline-block;vertical-align:top;margin:0}.social-bar .line-item.youtube{background:#cd1e21}.social-bar .line-item.facebook{background:#3a5799}.social-bar .line-item.instagram{background:linear-gradient(90deg,#fec053,#f2203e 33%,#b729a8 65%,#5342d6)}.social-bar .line-item.twitter{background:#169ff2}.social-bar .line-item:first-child{border-radius:2px 0 0 2px}.social-bar .line-item:last-child{border-radius:0 2px 2px 0}.social-bar-labels{display:flex;justify-content:flex-start;align-items:center;flex-wrap:nowrap}.social-bar-labels .label{flex:1 1 25%;text-align:center}.analytics-chart h4{padding:20px 0 0 20px}div.stat{width:80px;text-align:center}div.actionX{width:40px}.video-card{width:100%;height:auto;min-height:100px;display:flex;margin:15px 0;border-top:1px solid #d2d1d7;border-bottom:1px solid #d2d1d7;justify-content:space-around;align-items:flex-start;padding:15px 0;flex-wrap:nowrap}.video-card .flex-item{height:auto;flex:1 1 auto;min-width:100px}@media only screen and (min-width:1024px){.info-card{flex-wrap:wrap}.info-card .info-left .facebook-wrapper{text-align:left}}@media only screen and (max-width:1024px){.info-card{flex-wrap:wrap}.info-card .info-left .asset-wrapper{height:calc((80vw - 30px) * .5625)}}.cinema-wrapper{width:100%;height:auto;padding-top:80px;position:relative;border-bottom:1px solid #d2d1d7}.deliverable-copy-text{text-align:center;display:flex;justify-content:center;align-items:center;padding:12px;background-color:#fff}.deliverable-copy-text p{flex:1 1 auto;max-width:calc(90vw - 50px);font-size:18px;font-weight:500}.text-callout{width:100vw;height:auto;text-align:center;display:flex;align-items:center;justify-content:center}.text-callout .text-container{max-width:calc(80vw - 20px);background-color:#fff;margin:50px;border:1px solid #d2d1d7;border-radius:4px;padding:15px}.text-callout .text-container p{font-size:18px}.cinema-callout{height:500px}.cinema-callout,.image-callout{width:100vw;padding:0 calc(50vw - 660px);background:#000;text-align:center}.image-callout{height:auto;display:flex;align-items:center;justify-content:center}.image-callout img{width:auto;height:500px;max-height:500px;object-fit:cover;cursor:pointer}.file-callout{width:100vw;height:auto;padding:0 calc(50vw - 660px);background:#f7fafa;text-align:center}.file-callout .file{width:50px;height:50px;background-color:red;margin:30px auto}.document-callout{width:400px;height:auto;box-sizing:border-box;background-color:#fff;border:1px solid #d2d1d7;border-radius:4px;text-align:center;margin:50px auto;padding:20px;cursor:pointer;transition:all .2s ease-in-out;display:flex;flex-direction:column}.document-callout img{flex:0 0 80px;width:80px;height:80px;margin:0 auto}.document-callout p{width:100%;height:24px;line-height:24px;overflow:hidden;text-overflow:ellipsis}.document-callout:hover{opacity:.5}.cinema-add{width:100vw;height:500px;padding:60px;background:#f7fafa;border-bottom:1px solid #d2d1d7;display:flex;justify-content:center;align-items:center;cursor:pointer}.deliverable{display:flex;justify-content:flex-start;flex-wrap:nowrap;flex-direction:row-reverse}.deliverable .right{flex:0 1 calc(50vw - 264px);padding:40px calc(50vw - 660px) 40px 40px;border-left:1px solid #e8e8eb}.deliverable .left,.deliverable .right{min-height:calc(100vh - 60px);height:auto}.deliverable .left{flex:0 1 calc(50vw + 264px);padding:40px 40px 40px calc(50vw - 660px);background:#fff}.deliverable .left textarea{height:96px}.deliverable .row{display:flex;flex-wrap:nowrap;justify-content:flex-start;align-items:center;padding:5px}.deliverable .row .flex-item{flex:0 0 content;padding-left:10px}.deliverable .row .flex-item img{width:36px;height:36px;vertical-align:top;margin:0}.deliverable .row .flex-item:first-child{padding-left:0}.deliverable .row .flex-spacer{flex:1 1 auto}.channel-type-text{font-weight:600;text-align:left;padding-right:15px;max-width:200px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}@media only screen and (max-width:1440px){.deliverable .left{flex:0 1 70vw;padding:40px 40px 40px 60px}.deliverable .right{flex:0 1 30vw;padding:40px 60px 40px 40px}.cinema-callout,.image-callout{padding:0 60px}}@media only screen and (max-width:1024px){.deliverable{display:block}.deliverable .left{display:block;padding:40px 50px;min-height:0}.deliverable .right{display:block;border-left:none;border-bottom:1px solid #d2d1d7;padding:40px 60px;min-height:0}.cinema-callout,.image-callout{padding:0 60px}}@media only screen and (max-width:768px){.deliverable .left{padding:40px}.cinema-callout,.image-callout{padding:0 50px}}@media only screen and (max-width:375px){.deliverable .left{padding:40px 20px}.cinema-callout,.image-callout{padding:0 20px}}.full-page-modal{width:100vw;height:100vh;position:fixed;top:0;left:0;overflow:auto;background-color:#f7fafa;opacity:0;pointer-events:none;z-index:-1;visibility:hidden}.full-page-modal.open{visibility:visible;opacity:1;pointer-events:all;z-index:100}.full-page-modal .meta{background-color:#fff;border-bottom:1px solid #e8e8eb;padding:0 60px}.full-page-modal .meta.fixed{position:fixed;width:100%}.full-page-modal .meta.fixed.modal-meta-top{top:0}.full-page-modal .meta.fixed.modal-meta-bottom{bottom:0}.full-page-modal .meta h3{line-height:60px;display:inline-block;vertical-align:top;margin:0}.full-page-modal .meta img{width:24px!important;height:24px!important;float:right;vertical-align:top;margin:18px 0;opacity:1;cursor:pointer;transition:all .2s ease-in-out}.full-page-modal .meta img:hover{opacity:.5}.full-page-modal .full-page-modal-content{width:100%;height:auto;padding:0 60px 100px}.full-page-modal .full-page-modal-content.with-fixed-top{margin-top:60px}.full-page-modal .full-page-modal-content.with-fixed-bottom{margin-bottom:60px}.full-page-modal .full-page-modal-content .centered canvas{display:block;margin:0 auto}.member-list{width:100%;height:auto;background:#fff;border:1px solid #d2d1d7;border-radius:4px}.member-list .row{display:flex;width:100%;height:auto;padding:20px;border-bottom:1px solid #d2d1d7;align-items:center}.member-list .row .flex-item{flex:0 0 content;padding-right:20px}.member-list .row .flex-item:last-child{padding-right:0}.member-list .row .flex-spacer{flex:1 1 auto}.member-list .row:last-child{border-bottom:none}.profile .tabs .panes{flex-wrap:wrap-reverse}.profile .tabs .panes li{margin-top:12px}.profile .tabs .panes li.active p{font-weight:600}.profile .tabs .panes li p{text-transform:capitalize;font-weight:400;font-size:18px}.profile .page-content .profile-form-label{padding:5px 5px 5px 0;margin-top:15px;display:block}.profile .page-content h4{font-size:26px;font-weight:600}.profile .page-content span.hint{padding:22px 0;display:block;font-weight:400;font-size:14px}.profile .page-content button{float:right;min-width:185px}.profile .page-content .picture{width:94px;height:94px;background-color:#e8e8eb;border-radius:94px}.profile-form-wrapper{display:flex;flex-direction:column}.profile-form-wrapper .profile-form-row{display:inline-flex}.ui.sortable.table thead th.sorted:after{color:#fc4085}.onboarding-modal{width:100vw;height:auto;position:fixed;top:0;right:0;bottom:0;left:0;overflow-x:hidden;overflow-y:scroll;background:rgba(29,25,55,.95)}.onboarding-modal .onboarding-content{width:100vw;height:auto;min-height:calc(100vh - 60px);display:flex;justify-content:center;align-items:center;flex-direction:column;padding:60px}.onboarding-modal .onboarding-content .flex{width:100%;height:auto;padding:20px 0;display:flex;justify-content:center;align-items:center;flex-wrap:wrap;color:#fff}.onboarding-modal .onboarding-content .flex button{border:2px solid #fff;color:#fff}.onboarding-modal .onboarding-content .box{width:calc((100vw - 160px) / 3);min-width:360px;height:300px;display:inline-block;margin:20px 20px 0 0;padding:20px;text-align:center;position:relative}.onboarding-modal .onboarding-content .box h3,.onboarding-modal .onboarding-content .box p{color:#1d1937}.onboarding-modal .onboarding-content .box .link{width:calc(100% - 40px);height:24px;position:absolute;bottom:20px;right:20px}.onboarding-modal .onboarding-content .box:last-child{margin:20px 0 0}.budget-wrapper{width:100%;height:auto;display:flex;justify-content:flex-start;align-items:center}.budget-wrapper>*{flex:0 0 content}.budget-wrapper>* button,.budget-wrapper>* input{vertical-align:top;margin:10px 0}.budget-wrapper>* input{width:202px}.editable .react-numeric-input #budget{width:160px!important;transition:none!important}.false .react-numeric-input #budget{width:100px!important}.profile-header{padding:15px}.profile-form{display:flex;flex-direction:column;padding:15px}.profile-form .form-row{flex:1 1 auto;display:flex;align-items:center;margin:5px 0;padding:5px}.profile-form .form-row .form-title{margin:5px 0;flex:1 1 100px;min-width:100px;max-width:125px;align-items:center;justify-content:center}.profile-form .form-row .form-input{margin:5px;flex:1 1 200px;min-width:200px;max-width:300px;align-items:center;justify-content:center}.profile-form .form-row .form-input input{margin:0}.profile-form .form-row .form-comment{margin:5px;flex:1 0 100px;align-items:center;justify-content:center}.profile-form .form-row .form-submit{margin:5px;flex:1 1 300px;min-width:300px;max-width:425px;justify-content:flex-end}.removable-initial{visibility:visible;opacity:1}.removable-removing{visibility:hidden;opacity:0;transition:visibility 0s 2s,opacity 2s linear}.removable-removed{display:none}.top-right{margin:0!important;padding:0 4px!important}.no-vis{visibility:hidden!important}.edit-deliverable-button-container{display:flex;justify-content:center;align-items:center}.edit-deliverable-button-container .discard{flex:1 1 auto;width:50%;margin-right:5px}.edit-deliverable-button-container .update{flex:1 1 auto;width:50%;margin-left:5px}.coming-soon-wrapper{display:flex;align-items:center;justify-content:center}.coming-soon-wrapper p{flex:1 1 auto;line-height:16px;font-size:16px;font-weight:500;color:#20c49e}.asset-list-heading{display:flex;height:auto;justify-content:center;align-items:stretch}.asset-list-heading .asset-list-content{display:flex;flex:1 1 auto;justify-content:center;align-items:center;flex-wrap:wrap}.asset-list-heading .asset-list-content .asset-list-heading{width:50%;min-width:300px;flex:1 1 auto;display:flex;justify-content:center;align-items:center}.asset-list-heading .asset-list-content .asset-list-heading h3{flex:1 1 auto;display:flex;justify-content:flex-start;align-items:center}.asset-list-heading .asset-list-content .asset-list-heading h3 img{flex:0 0 auto}.asset-list-heading .asset-list-content .asset-list-stats{width:50%;min-width:300px;display:flex;flex:1 1 auto;flex-direction:row;justify-content:space-between;align-items:center}.asset-list-heading .asset-list-content .asset-list-stats .asset-list-stats-column{display:flex;background-color:red;flex:1 1 auto;min-width:50px;flex-direction:column;justify-content:center}.asset-list-heading .asset-list-content .asset-list-stats .asset-list-stats-column h4,.asset-list-heading .asset-list-content .asset-list-stats .asset-list-stats-column h5,.asset-list-heading .asset-list-content .asset-list-stats .asset-list-stats-column h6,.asset-list-heading .asset-list-content .asset-list-stats .asset-list-stats-column p{text-align:center;flex:1 1 auto}.asset-list-heading .asset-list-content .asset-list-stats .asset-list-stats-column.large{min-width:70px}.asset-list-heading .asset-list-options{flex:0 0 50px;display:flex;justify-content:center;align-items:center}.asset-list-heading .asset-list-options div{flex:0 0 auto}.plain-header{width:100vw;height:auto;padding:40px 60px 20px}.plain-header h1{width:100%;height:48px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.asset-page-header{display:flex;flex-direction:row;justify-content:flex-start;align-items:center}.asset-page-header img{flex:0 0 auto;width:30px;height:30px;margin-right:10px}.asset-page-header h1{flex:1 1 auto}.campaign-analytics-header{display:flex;flex-direction:row}.campaign-analytics-header h2{flex:1 1 auto}.campaign-analytics-header div{flex:0 0 auto}.app-offline-message{width:100%;height:50px;background-color:#fed995;display:flex;justify-content:center;align-items:center}.app-offline-message p{flex:1 1 auto;font-weight:600;text-align:center}.card .sb-avatar{float:right}.card .buttons .button{border:none!important;font-family:inherit!important;font-weight:400}.ui.pink.progress .bar{background-color:#fc4085!important}.ui.flyt.button{background:#3d49c7}.ui.flyt.button,.ui.flyt.button:hover{box-shadow:inset 0 0 0 2px #3d49c7!important;color:#fff}.ui.flyt.button:hover{background:#7780d8}.ui.inverted.green.button{box-shadow:inset 0 0 0 2px #20c49e!important;color:#20c49e}.ui.green.button:active,.ui.inverted.green.button:active,.ui.inverted.green.button:visited{background-color:#20c49e!important}.ui.inverted.pink.button,.ui.inverted.pink.buttons .button{box-shadow:inset 0 0 0 2px #fc4085!important;color:#fc4085}.ui.button.toggle.active,.ui.button.toggle.active:hover{background-color:#ccc!important}.ui.inverted.pink.button:focus,.ui.inverted.pink.button:hover{background-color:#fc4085}.ui.inverted.green.button:focus,.ui.inverted.green.button:hover{background-color:#20c49e}.ui.inverted.pink.button:active,.ui.inverted.pink.button:visited,.ui.pink.button:active,.ui.pink.label{background-color:#fc4085!important}.ui.pink.label{border-color:#fc4085!important}.ui.green.label{background-color:#20c49e!important;border-color:#20c49e!important}.ui.basic.label.blue{color:#6c93b3!important}.dyzio-tab.active{border-bottom:2px solid #20c49e!important;margin-bottom:-2px!important}.dyzio-tab.active .icon{color:#20c49e}i.icon.pink{color:#fc4085!important}i.icon.green{color:#20c49e!important}i.icon.red{color:#ef3a50!important}.ui.icon.menu .item.disabled{color:rgba(40,40,40,.3)!important}.ui.basic.pink.label{color:#fc4085!important;border-color:#fc4085!important}.ui .ui.basic.green.label{color:#20c49e!important;border-color:#20c49e!important}.ui.cards>.ui.green.card{box-shadow:0 0 0 1px #d4d4d5,0 2px 0 0 #20c49e,0 1px 3px 0 #d4d4d5}.ui.cards>.ui.pink.card{box-shadow:0 0 0 1px #d4d4d5,0 2px 0 0 #fc4085,0 1px 3px 0 #d4d4d5}.ui.cards>.ui.orange.card{box-shadow:0 0 0 1px #d4d4d5,0 2px 0 0 #fdb02b,0 1px 3px 0 #d4d4d5}.menu span{font-size:12px!important;line-height:normal!important}@media print{.media-kit-wrapper{margin-top:0!important}.media-kit-wrapper .table tr td{font-size:10px!important;padding:4px!important}.media-kit-wrapper .supporting-data-row,.media-kit-wrapper a{display:none}.media-kit-wrapper h2{font-size:14px!important}.media-kit-wrapper .row .column{padding:2px!important}.media-kit-wrapper .ui.table tr td{padding:1px}.media-kit-wrapper .label{font-size:11px!important}.media-kit-wrapper .ui.table thead th{padding:1px;font-size:11px!important;font-weight:400!important}.media-kit-wrapper .segment{border-radius:none!important;box-shadow:none!important;border:none!important}.media-kit-wrapper .chart-wrapper-print.padding-top-on-print{padding-top:15px}.media-kit-wrapper .chart-wrapper-print canvas{height:auto!important;margin-top:25px!important}}h1,h2,h3,h4,h5,h6,p{margin:0!important}h1,h2{font-family:Varela Round,sans-serif;font-style:normal;text-transform:none;margin:0;padding:0}h1,h2,h2 a{text-decoration:none}h2 a{color:#1d1937;cursor:pointer;transition:all .2s ease-in-out}h2 a:hover{text-decoration:none;color:#8e8c9b}h2 a.normal{color:#20c49e}h2 a.normal:hover{color:#1db08e}h3{font-family:Varela Round,sans-serif;font-style:normal;text-transform:none;margin:0;padding:0}h3,h3 a{text-decoration:none}h3 a,h3 a:hover{color:inherit}h3 img{vertical-align:top;margin:0;height:30px;padding:3px 0;width:auto}h4{font-family:Varela Round,Arial Rounded MT,Arial,sans-serif;font-style:normal;text-transform:none;text-decoration:none;margin:0;padding:0}h4 a,h4 a:hover{color:#1d1937}.image-heading{display:flex;align-items:center}.image-heading img{flex:0 0 34px;width:24px;height:24px}.image-heading h4{flex:1 1 auto;margin:0;padding:0;line-height:24px}h5{text-transform:none}h5,h6{font-family:Varela Round,Arial Rounded MT,Arial,sans-serif;font-style:normal;text-decoration:none;margin:0;padding:0}h6{text-transform:uppercase}p,span,td{font-family:Varela Round,Arial Rounded MT,Arial,sans-serif;text-transform:none;text-decoration:none;margin:0;padding:0}p a,span a,td a{text-decoration:none;color:#20c49e;font-weight:700;cursor:pointer;transition:all .2s ease-in-out}p a:hover,span a:hover,td a:hover{text-decoration:none;color:#1db08e}p.bold,span.bold,td.bold{font-weight:600}p.large,p.small,span.large,span.small{font-family:Varela Round,Arial Rounded MT,Arial,sans-serif;font-style:normal;text-transform:none;text-decoration:none;margin:0;padding:0}p.centered{text-align:center}p.tiny{line-height:normal;opacity:.5}p.caption,p.tiny{font-family:Varela Round,Arial Rounded MT,Arial,sans-serif;text-transform:none;text-decoration:none;margin:0;padding:0}p.caption{font-style:normal}h1.light,h2.light,h3.light,h4.light,h5.light,h6.light,p.light,span.light{opacity:.5}p.transparent{opacity:0}.capitalized,p.capitalized{text-transform:capitalize!important}.lowercase{text-transform:lowercase;font-size:inherit;font-weight:inherit;font-style:inherit}.align-left{text-align:left!important}.align-center{text-align:center!important}.align-right{text-align:right!important}.clickable{cursor:pointer!important}.nowrap{white-space:nowrap!important}.center-all{text-align:center;margin:0 auto}.horizontal-spacer{width:10px;height:100%;min-height:1px}img.inline{vertical-align:top;margin:0;display:inline-block}.ui.toggle.checkbox .box:before,.ui.toggle.checkbox label:before{background:#7d7d7d}.ui.checkbox input:indeterminate~.box:after,.ui.checkbox input:indeterminate~label:after{border:1px solid #888}.ui.toggle.checkbox input:checked~.box:after,.ui.toggle.checkbox input:checked~label:after{border:1px solid #888}.react-datepicker-popper{z-index:10!important}.instagram-media .Embed .Footer{display:none}.CalendarDay{position:relative;display:table;height:100%;width:100%}.CalendarDay__day{display:table-cell;vertical-align:middle;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}.CalendarMonth{text-align:center;padding:0 13px;vertical-align:top}.CalendarMonth:first-of-type{position:absolute;z-index:-1;opacity:0;pointer-events:none}.CalendarMonth table{border-collapse:collapse;border-spacing:0}.CalendarMonth--horizontal{display:inline-block;min-height:100%}.CalendarMonth--vertical{display:block}.CalendarMonth__caption{color:#3c3f40;margin-top:7px;font-size:18px;padding:15px 0 35px;text-align:center;margin-bottom:2px}.CalendarMonth__day{border:1px solid #e4e7e7;padding:0;box-sizing:border-box;color:#565a5c;cursor:pointer;width:39px;height:38px}.CalendarMonth__day:active{background:#f2f2f2}.CalendarMonth__day--highlighted-calendar{background:#ffe8bc;color:#565a5c;cursor:default}.CalendarMonth__day--highlighted-calendar:active{background:#007a87}.CalendarMonth__day--outside{border:0;cursor:default}.CalendarMonth__day--outside:active{background:#fff}.CalendarMonth__day--hovered{background:#e4e7e7;border:1px double #d4d9d9;color:inherit}.CalendarMonth__day--blocked-minimum-nights{color:#cacccd;background:#fff;border:1px solid #e4e7e7;cursor:default}.CalendarMonth__day--blocked-minimum-nights:active{background:#fff}.CalendarMonth__day--selected-span{background:#66e2da;border:1px double #33dacd;color:#fff}.CalendarMonth__day--selected-span.CalendarMonth__day--hovered,.CalendarMonth__day--selected-span:active{background:#33dacd;border:1px double #00a699}.CalendarMonth__day--selected-span.CalendarMonth__day--last-in-range{border-right:#00a699}.CalendarMonth__day--after-hovered-start,.CalendarMonth__day--hovered-span{background:#b2f1ec;border:1px double #80e8e0;color:#007a87}.CalendarMonth__day--selected,.CalendarMonth__day--selected-end,.CalendarMonth__day--selected-start{background:#00a699;border:1px double #00a699;color:#fff}.CalendarMonth__day--selected-end:active,.CalendarMonth__day--selected-start:active,.CalendarMonth__day--selected:active{background:#00a699}.CalendarMonth__day--blocked-calendar{background:#cacccd;color:#82888a;cursor:default}.CalendarMonth__day--blocked-calendar:active{background:#cacccd}.CalendarMonth__day--blocked-out-of-range{color:#cacccd;background:#fff;border:1px solid #e4e7e7;cursor:default}.CalendarMonth__day--blocked-out-of-range:active{background:#fff}.CalendarMonthGrid{background:#fff;z-index:0;text-align:left}.CalendarMonthGrid--animating{-webkit-transition:-webkit-transform .2s ease-in-out;-moz-transition:-moz-transform .2s ease-in-out;transition:transform .2s ease-in-out;z-index:1}.CalendarMonthGrid--horizontal{position:absolute;left:9px;width:1200px}.CalendarMonthGrid--vertical{width:300px;margin:0 auto}.DayPicker{background:#fff;position:relative;text-align:left}.DayPicker--horizontal{background:#fff;box-shadow:0 2px 6px rgba(0,0,0,.05),0 0 0 1px rgba(0,0,0,.07);border-radius:3px}.DayPicker--horizontal.DayPicker--portal{box-shadow:none;position:absolute;left:50%;top:50%}.DayPicker--vertical.DayPicker--portal{position:static}.DayPicker__week-headers{position:relative}.DayPicker--horizontal .DayPicker__week-headers{margin-left:9px}.DayPicker__week-header{color:#757575;position:absolute;width:300px;top:62px;z-index:2;padding:0 13px;text-align:left}.DayPicker__week-header ul{list-style:none;margin:1px 0;padding-left:0}.DayPicker__week-header li{display:inline-block;width:39px;text-align:center}.DayPicker--vertical .DayPicker__week-header{margin-left:-150px;left:50%}.transition-container{position:relative;overflow:hidden;border-radius:3px}.transition-container--horizontal{transition:height .2s ease-in-out}.transition-container--vertical{width:100%}.DayPickerNavigation__next,.DayPickerNavigation__prev{cursor:pointer;line-height:.78;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}.DayPickerNavigation__next--default,.DayPickerNavigation__prev--default{border:1px solid #dce0e0;background-color:#fff;color:#757575}.DayPickerNavigation__next--default:focus,.DayPickerNavigation__next--default:hover,.DayPickerNavigation__prev--default:focus,.DayPickerNavigation__prev--default:hover{border:1px solid #c4c4c4}.DayPickerNavigation__next--default:active,.DayPickerNavigation__prev--default:active{background:#f2f2f2}.DayPickerNavigation--horizontal{position:relative}.DayPickerNavigation--horizontal .DayPickerNavigation__next,.DayPickerNavigation--horizontal .DayPickerNavigation__prev{border-radius:3px;padding:6px 9px;top:18px;z-index:2;position:absolute}.DayPickerNavigation--horizontal .DayPickerNavigation__prev{left:22px}.DayPickerNavigation--horizontal .DayPickerNavigation__next{right:22px}.DayPickerNavigation--horizontal .DayPickerNavigation__next--default svg,.DayPickerNavigation--horizontal .DayPickerNavigation__prev--default svg{height:19px;width:19px;fill:#82888a}.DayPickerNavigation--vertical{background:#fff;box-shadow:0 0 5px 2px rgba(0,0,0,.1);position:absolute;bottom:0;left:0;height:52px;width:100%;z-index:2}.DayPickerNavigation--vertical .DayPickerNavigation__next,.DayPickerNavigation--vertical .DayPickerNavigation__prev{display:inline-block;position:relative;height:100%;width:50%}.DayPickerNavigation--vertical .DayPickerNavigation__next--default{border-left:0}.DayPickerNavigation--vertical .DayPickerNavigation__next--default,.DayPickerNavigation--vertical .DayPickerNavigation__prev--default{text-align:center;font-size:2.5em;padding:5px}.DayPickerNavigation--vertical .DayPickerNavigation__next--default svg,.DayPickerNavigation--vertical .DayPickerNavigation__prev--default svg{height:42px;width:42px;fill:#484848}.DateInput{font-weight:200;font-size:18px;line-height:24px;color:#757575;margin:0;padding:8px;background:#fff;position:relative;display:inline-block;width:130px;vertical-align:middle}.DateInput--with-caret:after,.DateInput--with-caret:before{content:\"\";display:inline-block;position:absolute;bottom:auto;border:10px solid transparent;border-top:0;left:22px;z-index:2}.DateInput--with-caret:before{top:62px;border-bottom-color:rgba(0,0,0,.1)}.DateInput--with-caret:after{top:63px;border-bottom-color:#fff}.DateInput--disabled{background:#cacccd}.DateInput__label{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.DateInput__input{opacity:0;position:absolute;top:0;left:0;border:0;height:100%;width:100%}.DateInput__display-text{padding:4px 8px;white-space:nowrap;overflow:hidden}.DateInput__display-text--has-input{color:#484848}.DateInput__display-text--focused{background:#99ede6;border-color:#99ede6;border-radius:3px;color:#007a87}.DateInput__display-text--disabled{font-style:italic}.screen-reader-only{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.DateRangePicker{position:relative;display:inline-block}.DateRangePicker__picker{z-index:1;background-color:#fff;position:absolute;top:72px}.DateRangePicker__picker--show{visibility:visible}.DateRangePicker__picker--invisible{visibility:hidden}.DateRangePicker__picker--direction-left{left:0}.DateRangePicker__picker--direction-right{right:0}.DateRangePicker__picker--portal{background-color:rgba(0,0,0,.3);position:fixed;top:0;left:0;height:100%;width:100%}.DateRangePicker__picker--full-screen-portal{background-color:#fff}.DateRangePicker__close{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;cursor:pointer;position:absolute;top:0;right:0;padding:15px;z-index:2}.DateRangePicker__close svg{height:15px;width:15px;fill:#cacccd}.DateRangePicker__close:focus,.DateRangePicker__close:hover{color:#b0b3b4;text-decoration:none}.DateRangePickerInput{background-color:#fff;border:1px solid #cacccd;display:inline-block}.DateRangePickerInput--disabled{background:#cacccd}.DateRangePickerInput__arrow{display:inline-block;vertical-align:middle}.DateRangePickerInput__arrow svg{vertical-align:middle;fill:#484848;height:24px;width:24px}.DateRangePickerInput__clear-dates{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;display:inline-block;vertical-align:middle;padding:10px;margin:0 10px 0 5px}.DateRangePickerInput__clear-dates svg{fill:#82888a;height:12px;width:15px;vertical-align:middle}.DateRangePickerInput__clear-dates--hide{visibility:hidden}.DateRangePickerInput__clear-dates--hover,.DateRangePickerInput__clear-dates:focus{background:#dbdbdb;border-radius:50%}.SingleDatePicker{position:relative;display:inline-block}.SingleDatePicker__picker{z-index:1;background-color:#fff;position:absolute;top:72px}.SingleDatePicker__picker--show{visibility:visible}.SingleDatePicker__picker--invisible{visibility:hidden}.SingleDatePicker__picker--direction-left{left:0}.SingleDatePicker__picker--direction-right{right:0}.SingleDatePicker__picker--portal{background-color:rgba(0,0,0,.3);position:fixed;top:0;left:0;height:100%;width:100%}.SingleDatePicker__picker--full-screen-portal{background-color:#fff}.SingleDatePicker__close{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;cursor:pointer;position:absolute;top:0;right:0;padding:15px;z-index:2}.SingleDatePicker__close svg{height:15px;width:15px;fill:#cacccd}.SingleDatePicker__close:focus,.SingleDatePicker__close:hover{color:#b0b3b4;text-decoration:none}.SingleDatePickerInput{background-color:#fff;border:1px solid #dbdbdb}.SingleDatePickerInput__clear-date{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;display:inline-block;vertical-align:middle;padding:10px;margin:0 10px 0 5px}.SingleDatePickerInput__clear-date svg{fill:#82888a;height:12px;width:15px;vertical-align:middle}.SingleDatePickerInput__clear-date--hide{visibility:hidden}.SingleDatePickerInput__clear-date--hover,.SingleDatePickerInput__clear-date:focus{background:#dbdbdb;border-radius:50%}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{margin-left:-8px;position:absolute}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{content:\"\";z-index:-1;border-width:8px;left:-8px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-top:none;border-bottom-color:#f0f0f0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{bottom:-1px;border-top-color:#aeaeae}.react-datepicker,.react-datepicker-wrapper{display:inline-block}.react-datepicker{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;position:relative}.react-datepicker--time-only .react-datepicker__triangle{left:35px}.react-datepicker--time-only .react-datepicker__time-container{border-left:0}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-radius:.3rem}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{margin-top:10px}.react-datepicker-popper[data-placement^=top]{margin-bottom:10px}.react-datepicker-popper[data-placement^=right]{margin-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{margin-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:.3rem;border-top-right-radius:.3rem;padding-top:8px;position:relative}.react-datepicker__header--time{padding-bottom:8px;padding-left:5px;padding-right:5px}.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__year-dropdown-container--select{display:inline-block;margin:0 2px}.react-datepicker-time__header,.react-datepicker__current-month{margin-top:0;color:#000;font-weight:700;font-size:.944rem}.react-datepicker-time__header{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-datepicker__navigation{background:none;line-height:1.7rem;text-align:center;cursor:pointer;position:absolute;top:10px;width:0;padding:0;border:.45rem solid transparent;z-index:1}.react-datepicker__navigation--previous{left:10px;border-right-color:#ccc}.react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__navigation--previous--disabled,.react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__navigation--next{right:10px;border-left-color:#ccc}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:80px}.react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__navigation--next--disabled,.react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px;border-top-color:#ccc}.react-datepicker__navigation--years-previous:hover{border-top-color:#b3b3b3}.react-datepicker__navigation--years-upcoming{top:-4px;border-bottom-color:#ccc}.react-datepicker__navigation--years-upcoming:hover{border-bottom-color:#b3b3b3}.react-datepicker__month-container{float:left}.react-datepicker__month{margin:.4rem;text-align:center}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae;width:70px}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-72px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:70px;overflow-x:hidden;margin:0 auto;text-align:center}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + 0.85rem);overflow-y:scroll;padding-right:30px;width:100%;box-sizing:content-box}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{padding:5px 10px}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day-names,.react-datepicker__week{white-space:nowrap}.react-datepicker__day,.react-datepicker__day-name,.react-datepicker__time-name{color:#000;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__day{cursor:pointer}.react-datepicker__day:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today{font-weight:700}.react-datepicker__day--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2{color:green}.react-datepicker__day--in-range,.react-datepicker__day--in-selecting-range,.react-datepicker__day--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--in-range:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--selected:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected{border-radius:.3rem;background-color:#2a87d0;color:#fff}.react-datepicker__day--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range){background-color:rgba(33,107,165,.5)}.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range){background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover{background-color:transparent}.react-datepicker__input-container{position:relative;display:inline-block}.react-datepicker__month-read-view,.react-datepicker__month-year-read-view,.react-datepicker__year-read-view{border:1px solid transparent;border-radius:.3rem}.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover,.react-datepicker__year-read-view:hover{cursor:pointer}.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{border-top-color:#ccc;float:right;margin-left:20px;top:8px;position:relative;border-width:.45rem}.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown,.react-datepicker__year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover,.react-datepicker__year-dropdown:hover{cursor:pointer}.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable,.react-datepicker__year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__month-option,.react-datepicker__month-year-option,.react-datepicker__year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type,.react-datepicker__year-option:first-of-type{border-top-left-radius:.3rem;border-top-right-radius:.3rem}.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type,.react-datepicker__year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover,.react-datepicker__year-option:hover{background-color:#ccc}.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected,.react-datepicker__year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{background-color:transparent;border:0;cursor:pointer;display:inline-block;height:0;outline:0;padding:0;vertical-align:middle}.react-datepicker__close-icon:after{background-color:#216ba5;border-radius:50%;bottom:0;box-sizing:border-box;color:#fff;content:\"\\D7\";cursor:pointer;font-size:12px;height:16px;width:16px;line-height:1;margin:-8px auto 0;padding:2px;position:absolute;right:7px;text-align:center;top:50%}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:rgba(0,0,0,.8);left:0;top:0;justify-content:center;align-items:center;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-height:550px),(max-width:400px){.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker-time__header,.react-datepicker__portal .react-datepicker__current-month{font-size:1.44rem}.react-datepicker__portal .react-datepicker__navigation{border:.81rem solid transparent}.react-datepicker__portal .react-datepicker__navigation--previous{border-right-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--previous--disabled,.react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__portal .react-datepicker__navigation--next{border-left-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--next--disabled,.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}*{font-family:Varela Round;box-sizing:border-box!important;backface-visibility:hidden}img{vertical-align:top;margin:0}.DateInput,.DateInput.DateInput--with-caret,.SingleDatePicker,.SingleDatePickerInput,.transition-container.transition-container--horizontal{border-radius:4px}.react-datepicker-wrapper,.react-datepicker__input-container{width:100%}.chart-wrapper-print canvas{width:100%!important}.social-stripe{width:100%;height:6px;overflow:hidden;border-radius:3px;background-color:#e0e1e2}.social-stripe .facebook{background-color:#3b5998}.social-stripe .instagram{background:linear-gradient(45deg,#f09433,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888)}.social-stripe .twitter{background-color:#1da1f2}.social-stripe .youtube{background-color:#e62117}.social-stripe .tiktok{background-color:#000}.social-stripe .telegram{background-color:blue}.social-stripe .facebook,.social-stripe .instagram,.social-stripe .telegram,.social-stripe .tiktok,.social-stripe .twitter,.social-stripe .youtube{flex:0 0 0;height:6px;transition:all .2s}.social-stripe .facebook.active,.social-stripe .instagram.active,.social-stripe .telegram.active,.social-stripe .tiktok.active,.social-stripe .twitter.active,.social-stripe .youtube.active{flex:1 1 auto}.faded{opacity:.5!important;transition:opacity .2s!important}button.ui.green.button{background-color:#20c49e}button.ui.green.button:focus,button.ui.green.button:hover{background-color:#1cae8c}.ui.green.button:active{background-color:#1cae8c!important}.ui.pink.button{background-color:#fc4085}.ui.pink.button:hover{background-color:#fc2775}button.ui.basic.button{color:#1d1937!important;border:2px solid #1d1937;font-weight:600}button.ui.basic.red.button{border:2px solid #ef3a50}.ui.search input{border-radius:4px!important}.ui.checked.fitted.toggle.checkbox input+label:before,.ui.checked.toggle.checkbox input+label:before{background-color:#20c49e!important}p.radio-label{padding:0 10px;line-height:30px!important}.icon{outline:none!important}input:read-only,textarea:read-only{pointer-events:none!important;border-color:transparent!important}.ui.basic.label.green{border-color:#d1e297!important;color:#1d1937!important}.ui.basic.label.blue{border-color:#8dcece!important}i.icons{font-style:normal}.full-width .ui.icon.input{width:100%}.add-influencer-card:hover{opacity:1!important}.influencer-cards-table td{padding:5px!important}.ui.success.message{color:#20c49e;box-shadow:inset 0 0 0 1px #20c49e,0 0 0 0 transparent}i.inverted.circular.red.icon{background-color:#ef3a50!important}.ui.success.message .header{color:#20c49e!important}.ui.orange.message{box-shadow:inset 0 0 0 1px #fdb02b,0 0 0 0 transparent!important;background-color:#fff1d5!important;border-color:#fed995!important}.ui.orange.message .content,.ui.orange.message .header,.ui.orange.message .icon{color:#fdb02b!important}.ui.label>.settings.icon{cursor:pointer;margin-right:0;margin-left:.5em;font-size:.92857143em;opacity:.5;transition:background-color .1s ease}.ui.label>.settings.icon:hover{opacity:1}.padding5{padding:5px!important}.ql-editor{min-height:140px}.dyzio-green-link,.dyzio-green-link:hover{color:#20c49e;font-weight:700}", ""]);
	
	// exports


/***/ },
/* 2543 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 2544 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = mapSymbol
	
	var map = __webpack_require__(2545)
	
	function mapSymbol(currencyCode) {
	  if (map.hasOwnProperty(currencyCode)) {
	    return map[currencyCode]
	  } else {
	    return '?'
	  }
	}

/***/ },
/* 2545 */
/***/ function(module, exports) {

	module.exports =
	{ "ALL": "L"
	, "AFN": "؋"
	, "ARS": "$"
	, "AWG": "ƒ"
	, "AUD": "$"
	, "AZN": "₼"
	, "BSD": "$"
	, "BBD": "$"
	, "BYR": "p."
	, "BZD": "BZ$"
	, "BMD": "$"
	, "BOB": "Bs."
	, "BAM": "KM"
	, "BWP": "P"
	, "BGN": "лв"
	, "BRL": "R$"
	, "BND": "$"
	, "KHR": "៛"
	, "CAD": "$"
	, "KYD": "$"
	, "CLP": "$"
	, "CNY": "¥"
	, "COP": "$"
	, "CRC": "₡"
	, "HRK": "kn"
	, "CUP": "₱"
	, "CZK": "Kč"
	, "DKK": "kr"
	, "DOP": "RD$"
	, "XCD": "$"
	, "EGP": "£"
	, "SVC": "$"
	, "EEK": "kr"
	, "EUR": "€"
	, "FKP": "£"
	, "FJD": "$"
	, "GHC": "¢"
	, "GIP": "£"
	, "GTQ": "Q"
	, "GGP": "£"
	, "GYD": "$"
	, "HNL": "L"
	, "HKD": "$"
	, "HUF": "Ft"
	, "ISK": "kr"
	, "INR": "₹"
	, "IDR": "Rp"
	, "IRR": "﷼"
	, "IMP": "£"
	, "ILS": "₪"
	, "JMD": "J$"
	, "JPY": "¥"
	, "JEP": "£"
	, "KES": "KSh"
	, "KZT": "лв"
	, "KPW": "₩"
	, "KRW": "₩"
	, "KGS": "лв"
	, "LAK": "₭"
	, "LVL": "Ls"
	, "LBP": "£"
	, "LRD": "$"
	, "LTL": "Lt"
	, "MKD": "ден"
	, "MYR": "RM"
	, "MUR": "₨"
	, "MXN": "$"
	, "MNT": "₮"
	, "MZN": "MT"
	, "NAD": "$"
	, "NPR": "₨"
	, "ANG": "ƒ"
	, "NZD": "$"
	, "NIO": "C$"
	, "NGN": "₦"
	, "NOK": "kr"
	, "OMR": "﷼"
	, "PKR": "₨"
	, "PAB": "B/."
	, "PYG": "Gs"
	, "PEN": "S/."
	, "PHP": "₱"
	, "PLN": "zł"
	, "QAR": "﷼"
	, "RON": "lei"
	, "RUB": "₽"
	, "SHP": "£"
	, "SAR": "﷼"
	, "RSD": "Дин."
	, "SCR": "₨"
	, "SGD": "$"
	, "SBD": "$"
	, "SOS": "S"
	, "ZAR": "R"
	, "LKR": "₨"
	, "SEK": "kr"
	, "CHF": "CHF"
	, "SRD": "$"
	, "SYP": "£"
	, "TZS": "TSh"
	, "TWD": "NT$"
	, "THB": "฿"
	, "TTD": "TT$"
	, "TRY": ""
	, "TRL": "₤"
	, "TVD": "$"
	, "UGX": "USh"
	, "UAH": "₴"
	, "GBP": "£"
	, "USD": "$"
	, "UYU": "$U"
	, "UZS": "лв"
	, "VEF": "Bs"
	, "VND": "₫"
	, "YER": "﷼"
	, "ZWD": "Z$"
	}


/***/ },
/* 2546 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(2547);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = process.env.DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 2547 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(3017);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 2548 */
/***/ function(module, exports) {

	'use strict';
	var token = '%[a-f0-9]{2}';
	var singleMatcher = new RegExp(token, 'gi');
	var multiMatcher = new RegExp('(' + token + ')+', 'gi');
	
	function decodeComponents(components, split) {
		try {
			// Try to decode the entire string first
			return decodeURIComponent(components.join(''));
		} catch (err) {
			// Do nothing
		}
	
		if (components.length === 1) {
			return components;
		}
	
		split = split || 1;
	
		// Split the array in 2 parts
		var left = components.slice(0, split);
		var right = components.slice(split);
	
		return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
	}
	
	function decode(input) {
		try {
			return decodeURIComponent(input);
		} catch (err) {
			var tokens = input.match(singleMatcher);
	
			for (var i = 1; i < tokens.length; i++) {
				input = decodeComponents(tokens, i).join('');
	
				tokens = input.match(singleMatcher);
			}
	
			return input;
		}
	}
	
	function customDecodeURIComponent(input) {
		// Keep track of all the replacements and prefill the map with the `BOM`
		var replaceMap = {
			'%FE%FF': '\uFFFD\uFFFD',
			'%FF%FE': '\uFFFD\uFFFD'
		};
	
		var match = multiMatcher.exec(input);
		while (match) {
			try {
				// Decode as big chunks as possible
				replaceMap[match[0]] = decodeURIComponent(match[0]);
			} catch (err) {
				var result = decode(match[0]);
	
				if (result !== match[0]) {
					replaceMap[match[0]] = result;
				}
			}
	
			match = multiMatcher.exec(input);
		}
	
		// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
		replaceMap['%C2'] = '\uFFFD';
	
		var entries = Object.keys(replaceMap);
	
		for (var i = 0; i < entries.length; i++) {
			// Replace all decoded components
			var key = entries[i];
			input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
		}
	
		return input;
	}
	
	module.exports = function (encodedURI) {
		if (typeof encodedURI !== 'string') {
			throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
		}
	
		try {
			encodedURI = encodedURI.replace(/\+/g, ' ');
	
			// Try the built in decoder first
			return decodeURIComponent(encodedURI);
		} catch (err) {
			// Fallback to a more advanced decoder
			return customDecodeURIComponent(encodedURI);
		}
	};


/***/ },
/* 2549 */
/***/ function(module, exports) {

	'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}
	
	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}
	
	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}
	
	function getMergeFunction(key, options) {
		if (!options.customMerge) {
			return deepmerge
		}
		var customMerge = options.customMerge(key);
		return typeof customMerge === 'function' ? customMerge : deepmerge
	}
	
	function getEnumerableOwnPropertySymbols(target) {
		return Object.getOwnPropertySymbols
			? Object.getOwnPropertySymbols(target).filter(function(symbol) {
				return target.propertyIsEnumerable(symbol)
			})
			: []
	}
	
	function getKeys(target) {
		return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	}
	
	function propertyIsOnObject(object, property) {
		try {
			return property in object
		} catch(_) {
			return false
		}
	}
	
	// Protects from prototype poisoning and unexpected merging up the prototype chain.
	function propertyIsUnsafe(target, key) {
		return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
			&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
				&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
	}
	
	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			getKeys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		getKeys(source).forEach(function(key) {
			if (propertyIsUnsafe(target, key)) {
				return
			}
	
			if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
				destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
			} else {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			}
		});
		return destination
	}
	
	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;
		// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
		// implementations can use it. The caller may not replace it.
		options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
	
		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}
	
	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}
	
		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};
	
	var deepmerge_1 = deepmerge;
	
	module.exports = deepmerge_1;


/***/ },
/* 2550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TypeCol = function TypeCol(_ref) {
	  var paidPartnership = _ref.paidPartnership,
	      brand = _ref.brand;
	
	  if (paidPartnership) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(_semanticUiReact.Label, { icon: 'checkmark', basic: true, color: 'green', content: 'PP' }),
	      content: 'Paid partnership with ' + brand
	    });
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    'Ad'
	  );
	};
	
	var latestPostDate = function latestPostDate(posts) {
	  if (posts.length > 0) {
	    var sortedPosts = _lodash2.default.orderBy(posts, ['publishedDate'], ['desc']);
	    return sortedPosts[0].publishedDate;
	  }
	  return '-';
	};
	
	var BrandMentionsTable = function BrandMentionsTable(_ref2) {
	  var data = _ref2.data,
	      clickHandler = _ref2.clickHandler;
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    {
	      textAlign: 'center',
	      celled: true
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Header,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Brand'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          '# posts'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Published Date'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Type'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Avg. Engs.'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.HeaderCell,
	          null,
	          'Engs. Rate'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _lodash2.default.map(data.data, function (item) {
	        var brand = item.brand,
	            url = item.url,
	            engagementFigures = item.engagementFigures;
	
	        return _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            brand,
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', rel: 'noopener noreferrer', href: url },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'external', color: 'grey' })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            engagementFigures.numberOfPosts,
	            _react2.default.createElement(
	              'a',
	              {
	                style: { cursor: 'pointer', color: '#20c49e' },
	                onClick: function onClick() {
	                  return clickHandler(item);
	                }
	              },
	              ' (click to view)'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            (0, _moment2.default)(latestPostDate(engagementFigures.brandPosts)).format('MMMM Do YYYY')
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(TypeCol, {
	              brand: brand,
	              paidPartnership: engagementFigures.paidPartnership
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            (0, _formatting.commaFormatted)(engagementFigures.engagementAverage.toFixed(0))
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            !engagementFigures.engagementRate && _react2.default.createElement(_semanticUiReact.Popup, {
	              trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock outline', color: 'orange' }),
	              content: 'Calculating Engs. Rate'
	            }),
	            engagementFigures.engagementRate && engagementFigures.engagementRate.toFixed(2) + '%'
	          )
	        );
	      })
	    )
	  );
	};
	
	BrandMentionsTable.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  clickHandler: _propTypes2.default.func.isRequired
	};
	
	exports.default = BrandMentionsTable;

/***/ },
/* 2551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(120);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = CollaborationCard;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var avatarStyle = {
	  width: 50,
	  height: 50,
	  marginTop: 0,
	  marginRight: 10,
	  marginBottom: 0,
	  marginLeft: 0
	};
	
	var nameH3Style = {
	  marginTop: 5,
	  float: 'left',
	  marginBottom: -2
	};
	
	var socialHandleStyle = {
	  color: 'gray'
	};
	
	var socialNetworkWrapperStyle = {
	  fontSize: 12,
	  textAlign: 'center'
	};
	
	var socialNetworkImageStyle = {
	  width: 24,
	  height: 24,
	  display: 'block',
	  margin: '0 auto',
	  marginTop: 5
	};
	
	var zeroFollowersSpanStyle = {
	  color: 'gray'
	};
	
	var socialNetworkLinkStyle = {
	  color: 'rgb(32, 196, 158)',
	  fontWeight: 'bold'
	};
	
	var SocialNetworkLink = function SocialNetworkLink(_ref) {
	  var link = _ref.link,
	      count = _ref.count,
	      platform = _ref.platform;
	
	  var hasFollowers = count > 0;
	  return _react2.default.createElement(
	    'div',
	    { style: socialNetworkWrapperStyle },
	    _react2.default.createElement(_semanticUiReact.Image, {
	      src: 'https://app.dyzio.co/icons/' + platform + '.svg',
	      style: socialNetworkImageStyle
	    }),
	    hasFollowers && _react2.default.createElement(
	      'a',
	      {
	        href: link,
	        target: '_blank',
	        rel: 'noopener noreferrer',
	        style: socialNetworkLinkStyle
	      },
	      (0, _formatting.scientificFormatted)(count)
	    ),
	    !hasFollowers && _react2.default.createElement(
	      'span',
	      { style: zeroFollowersSpanStyle },
	      '0'
	    )
	  );
	};
	
	function CollaborationCard(_ref2) {
	  var onClick = _ref2.onClick,
	      name = _ref2.name,
	      thumbnail = _ref2.thumbnail,
	      primarySocialHandle = _ref2.primarySocialHandle,
	      facebook = _ref2.facebook,
	      twitter = _ref2.twitter,
	      instagram = _ref2.instagram,
	      youtube = _ref2.youtube,
	      facebookCount = _ref2.facebookCount,
	      twitterCount = _ref2.twitterCount,
	      instagramCount = _ref2.instagramCount,
	      youtubeCount = _ref2.youtubeCount,
	      cardProps = (0, _objectWithoutProperties3.default)(_ref2, ['onClick', 'name', 'thumbnail', 'primarySocialHandle', 'facebook', 'twitter', 'instagram', 'youtube', 'facebookCount', 'twitterCount', 'instagramCount', 'youtubeCount']);
	
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    (0, _extends3.default)({}, cardProps, { fluid: true }),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 'eight' },
	            _react2.default.createElement(_semanticUiReact.Image, {
	              className: 'circular',
	              src: thumbnail,
	              style: avatarStyle,
	              floated: 'left',
	              size: 'tiny'
	            }),
	            _react2.default.createElement(
	              'h3',
	              { style: nameH3Style },
	              name
	            ),
	            _react2.default.createElement(
	              'h5',
	              { style: socialHandleStyle },
	              primarySocialHandle
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 'two' },
	            _react2.default.createElement(SocialNetworkLink, {
	              platform: 'facebook',
	              count: facebookCount,
	              link: 'https://facebook.com/' + facebook
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 'two' },
	            _react2.default.createElement(SocialNetworkLink, {
	              platform: 'instagram',
	              count: instagramCount,
	              link: 'https://instagram.com/' + instagram
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 'two' },
	            _react2.default.createElement(SocialNetworkLink, {
	              platform: 'twitter',
	              count: twitterCount,
	              link: 'https://twitter.com/' + twitter
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 'two' },
	            _react2.default.createElement(SocialNetworkLink, {
	              platform: 'youtube',
	              count: youtubeCount,
	              link: 'https://youtube.com/channel/' + youtube
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	CollaborationCard.propTypes = {
	  onClick: _propTypes2.default.func,
	  name: _propTypes2.default.string.isRequired,
	  thumbnail: _propTypes2.default.string.isRequired,
	  primarySocialHandle: _propTypes2.default.string.isRequired
	};
	
	CollaborationCard.defaultProps = {
	  onClick: _lodash2.default.noop
	};

/***/ },
/* 2552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _countryData = __webpack_require__(175);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _reactEllipsisText = __webpack_require__(3342);
	
	var _reactEllipsisText2 = _interopRequireDefault(_reactEllipsisText);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCountry = function getCountry(code) {
	  return _lodash2.default.find(_countryData.countries.all, ['alpha2', _lodash2.default.upperCase(code)]);
	};
	var DemographicsRow = function DemographicsRow(_ref) {
	  var row = _ref.row,
	      uniqueKey = _ref.uniqueKey,
	      metric = _ref.metric,
	      totalMetric = _ref.totalMetric;
	
	  var countryKey = uniqueKey === 'location' && _lodash2.default.has(row, 'location') ? 'location' : 'countryCode';
	  var country = getCountry(row[countryKey]);
	  var percentage = row.percentage || 100 * row[metric] / totalMetric;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    country ? _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'left' },
	      country.emoji,
	      ' ',
	      _react2.default.createElement(_reactEllipsisText2.default, { text: country.name, length: 16 })
	    ) : _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'left' },
	      _react2.default.createElement(_reactEllipsisText2.default, { text: row[uniqueKey] || '', length: 16 })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.commaFormatted)(row[metric])
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.commaFormatted)(percentage),
	      ' %'
	    )
	  );
	};
	
	DemographicsRow.propTypes = {
	  row: _propTypes2.default.object.isRequired,
	  uniqueKey: _propTypes2.default.string.isRequired,
	  metric: _propTypes2.default.string.isRequired,
	  totalMetric: _propTypes2.default.number.isRequired
	};
	
	exports.default = DemographicsRow;

/***/ },
/* 2553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(120);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _regenerator = __webpack_require__(234);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(233);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(108);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BASE_URL = 'https://75b9bx130e.execute-api.eu-west-1.amazonaws.com/production/scraper/facebook/thumbnail';
	
	var iconStyle = {
	  margin: '0 auto'
	};
	
	var failedIconWrapperStyle = {
	  height: 50,
	  display: 'flex',
	  'align-items': 'center'
	};
	
	var DyzioFacebookThumbnail = function (_Component) {
	  (0, _inherits3.default)(DyzioFacebookThumbnail, _Component);
	
	  function DyzioFacebookThumbnail(props) {
	    (0, _classCallCheck3.default)(this, DyzioFacebookThumbnail);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DyzioFacebookThumbnail.__proto__ || (0, _getPrototypeOf2.default)(DyzioFacebookThumbnail)).call(this, props));
	
	    _this.state = {
	      loading: true,
	      failed: false,
	      url: null
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(DyzioFacebookThumbnail, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var assetId, response, url, failed;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                assetId = this.props.assetId;
	                _context.next = 3;
	                return _axios2.default.get(BASE_URL + '/' + assetId);
	
	              case 3:
	                response = _context.sent;
	                url = _lodash2.default.get(response, 'data.data.url', null);
	                failed = _lodash2.default.has(response, 'data.errorType');
	
	                this.setState({
	                  loading: false,
	                  url: url,
	                  failed: failed
	                });
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          failed = _state.failed,
	          url = _state.url,
	          loading = _state.loading;
	      var _props = this.props,
	          assetId = _props.assetId,
	          failedText = _props.failedText,
	          rest = (0, _objectWithoutProperties3.default)(_props, ['assetId', 'failedText']);
	
	
	      if (loading) {
	        return null;
	      }
	
	      if (failed) {
	        return _react2.default.createElement(
	          'div',
	          { style: failedIconWrapperStyle },
	          _react2.default.createElement(_semanticUiReact.Popup, {
	            content: failedText,
	            trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'picture', size: 'big', style: iconStyle })
	          })
	        );
	      }
	
	      return _react2.default.createElement(_semanticUiReact.Image, (0, _extends3.default)({ 'data-fetched': 'dyzio-thumb-l', src: url }, rest));
	    }
	  }]);
	  return DyzioFacebookThumbnail;
	}(_react.Component);
	
	DyzioFacebookThumbnail.propTypes = {
	  assetId: _propTypes2.default.string.isRequired,
	  style: _propTypes2.default.object,
	  failedText: _propTypes2.default.string
	};
	
	DyzioFacebookThumbnail.defaultProps = {
	  failedText: 'Failed to load thumbnail. Try again later',
	  style: {
	    width: '100%',
	    height: 50,
	    'object-fit': 'cover'
	  }
	};
	
	exports.default = DyzioFacebookThumbnail;

/***/ },
/* 2554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(234);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(233);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(108);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import InstagramEmbed from 'dyzio-shared-components/lib/components/dyzio-instagram-embed';
	
	var imgStyle = {
	  margin: '0px auto',
	  height: 380,
	  cursor: 'pointer',
	  'object-fit': 'cover',
	  'object-position': 'top'
	};
	
	var width100 = {
	  width: '100%',
	  height: 380,
	  cursor: 'pointer',
	  'object-fit': 'cover',
	  'object-position': 'top'
	};
	
	var DyzioInstagramEmbed = function (_Component) {
	  (0, _inherits3.default)(DyzioInstagramEmbed, _Component);
	
	  function DyzioInstagramEmbed() {
	    (0, _classCallCheck3.default)(this, DyzioInstagramEmbed);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DyzioInstagramEmbed.__proto__ || (0, _getPrototypeOf2.default)(DyzioInstagramEmbed)).call(this));
	
	    _this.state = {
	      savedThumbnailUrl: '',
	      error: false,
	      loading: true
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(DyzioInstagramEmbed, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var assetId, _ref2, status, data, _$get, savedThumbnailUrl;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                assetId = this.props.assetId;
	                _context.prev = 1;
	                _context.next = 4;
	                return (0, _axios2.default)('https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer/instagram/embed/' + assetId + '/data');
	
	              case 4:
	                _ref2 = _context.sent;
	                status = _ref2.status;
	                data = _ref2.data;
	
	
	                if (_lodash2.default.isEqual(status, 200)) {
	                  console.log('SUCCESS');
	                  _$get = _lodash2.default.get(data, 'data'), savedThumbnailUrl = _$get.savedThumbnailUrl;
	
	                  this.setState({
	                    savedThumbnailUrl: savedThumbnailUrl,
	                    loading: false
	                  });
	                } else {
	                  this.setState({
	                    error: true,
	                    loading: false
	                  });
	                }
	                _context.next = 14;
	                break;
	
	              case 10:
	                _context.prev = 10;
	                _context.t0 = _context['catch'](1);
	
	                console.log(_context.t0);
	                this.setState({
	                  error: true,
	                  loading: false
	                });
	
	              case 14:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[1, 10]]);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          savedThumbnailUrl = _state.savedThumbnailUrl,
	          error = _state.error,
	          loading = _state.loading;
	      var _props = this.props,
	          assetId = _props.assetId,
	          maxWidth = _props.maxWidth;
	
	
	      console.log('savedThumbnailUrl', savedThumbnailUrl);
	      if (error) {
	        return _react2.default.createElement(_semanticUiReact.Message, {
	          header: 'Error Fetching Asset',
	          content: 'Please check the url and retry.'
	        });
	      }
	
	      if (loading) {
	        return _react2.default.createElement(_semanticUiReact.Message, {
	          header: 'Loading Asset'
	        });
	      }
	
	      if (savedThumbnailUrl) {
	        return _react2.default.createElement(_semanticUiReact.Image, {
	          size: 'large',
	          style: maxWidth ? width100 : imgStyle,
	          src: savedThumbnailUrl,
	          onClick: function onClick() {
	            return window.open('https://instagram.com/p/' + assetId, '_blank');
	          }
	        });
	      }
	
	      return _react2.default.createElement(_semanticUiReact.Message, {
	        header: 'Error Fetching Asset',
	        content: 'Please check the url and retry.'
	      });
	    }
	  }]);
	  return DyzioInstagramEmbed;
	}(_react.Component);
	
	DyzioInstagramEmbed.propTypes = {
	  assetId: _propTypes2.default.string.isRequired
	};
	
	DyzioInstagramEmbed.defaultProps = {
	  maxWidth: false
	};
	
	exports.default = DyzioInstagramEmbed;

/***/ },
/* 2555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(234);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(233);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(108);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _axiosRetry = __webpack_require__(973);
	
	var _axiosRetry2 = _interopRequireDefault(_axiosRetry);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_IMAGE = 'https://ri.dyzio.co/no_image_available.png';
	
	var restClient = _axios2.default.create({
	  timeout: 5000
	});
	
	(0, _axiosRetry2.default)(restClient, {
	  delay: 100,
	  retries: 3
	});
	
	var thumbnailStyle = {
	  width: '100%',
	  objectFit: 'cover',
	  display: 'table-cell',
	  verticalAlign: 'middle',
	  backgroundColor: '#EEEEEE'
	};
	
	var noImageStyle = {
	  width: '60%',
	  objectFit: 'cover',
	  display: 'table-cell',
	  verticalAlign: 'middle',
	  backgroundColor: '#EEEEEE'
	};
	
	var DyzioInstagramThumbnail = function (_React$Component) {
	  (0, _inherits3.default)(DyzioInstagramThumbnail, _React$Component);
	
	  function DyzioInstagramThumbnail() {
	    var _this2 = this;
	
	    (0, _classCallCheck3.default)(this, DyzioInstagramThumbnail);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DyzioInstagramThumbnail.__proto__ || (0, _getPrototypeOf2.default)(DyzioInstagramThumbnail)).call(this));
	
	    _this.loadEmbed = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              console.log('skip embed');
	              // const shortCode = this.props.assetId;
	              // const baseUrl = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/';
	              // const path = `influencer/instagram/embed/${shortCode}`;
	              // restClient.get(`${baseUrl}${path}`).then(response => {
	              //   const embed = response.data;
	              //   this.setState({
	              //     imageUrl: embed.body.data.thumbnail_url,
	              //     requestFinished: true,
	              //   });
	              // }).catch(err => {
	              //   console.log('err', err);
	              //   this.setState({
	              //     imageUrl: '',
	              //     requestFinished: true,
	              //   });
	              // });
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      imageUrl: '',
	      requestFinished: false,
	      initialised: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(DyzioInstagramThumbnail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.trackedAssetId) {
	        var initialised = this.state.initialised;
	
	        if (!initialised) {
	          this.loadEmbed();
	        }
	        this.setState({
	          initialised: true
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.trackedAssetId) {
	        if (this.props.assetId !== prevProps.assetId) {
	          this.loadEmbed();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // const { imageUrl, requestFinished } = this.state;
	      var _props = this.props,
	          customStyle = _props.customStyle,
	          fallbackURL = _props.fallbackURL,
	          assetId = _props.assetId,
	          savedMediumImageUrl = _props.savedMediumImageUrl;
	
	
	      var style = (0, _extends3.default)({}, thumbnailStyle, customStyle);
	
	      if (assetId) {
	        return _react2.default.createElement(_semanticUiReact.Image, {
	          style: style,
	          src: 'https://pics.dyzio.co/' + assetId + '.jpg',
	          onError: function onError(i) {
	            i.target.src = DEFAULT_IMAGE;
	          }
	        });
	      }
	
	      if (savedMediumImageUrl) {
	        return _react2.default.createElement(_semanticUiReact.Image, {
	          style: style,
	          src: savedMediumImageUrl,
	          onError: function onError(i) {
	            i.target.src = DEFAULT_IMAGE;
	          }
	        });
	      }
	
	      return _react2.default.createElement(_semanticUiReact.Image, {
	        style: style,
	        src: fallbackURL,
	        onError: function onError(i) {
	          i.target.src = DEFAULT_IMAGE;
	        }
	      });
	    }
	  }]);
	  return DyzioInstagramThumbnail;
	}(_react2.default.Component);
	
	DyzioInstagramThumbnail.propTypes = {
	  assetId: _propTypes2.default.string.isRequired,
	  customStyle: _propTypes2.default.object,
	  fallbackURL: _propTypes2.default.string,
	  trackedAssetId: _propTypes2.default.string,
	  savedMediumImageUrl: _propTypes2.default.string
	};
	
	DyzioInstagramThumbnail.defaultProps = {
	  customStyle: {},
	  fallbackURL: '',
	  trackedAssetId: null,
	  savedMediumImageUrl: null
	};
	
	exports.default = DyzioInstagramThumbnail;

/***/ },
/* 2556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(108);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DyzioSearchBox = function (_React$Component) {
	  (0, _inherits3.default)(DyzioSearchBox, _React$Component);
	
	  function DyzioSearchBox(props) {
	    (0, _classCallCheck3.default)(this, DyzioSearchBox);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DyzioSearchBox.__proto__ || (0, _getPrototypeOf2.default)(DyzioSearchBox)).call(this, props));
	
	    _this.onSearchActivate = function () {
	      var onSearch = _this.props.onSearch;
	      var _this$state = _this.state,
	          searchTerm = _this$state.searchTerm,
	          lastSubmittedSearch = _this$state.lastSubmittedSearch;
	
	      if (lastSubmittedSearch !== searchTerm) {
	        onSearch(_this.state.searchTerm);
	        _this.setState({
	          lastSubmittedSearch: searchTerm
	        });
	      }
	    };
	
	    _this.onSearchKeyPress = function (e) {
	      if (e.key === 'Enter') {
	        _this.onSearchActivate();
	      }
	    };
	
	    _this.onSearchChange = function (e) {
	      _this.setState({
	        searchTerm: e.target.value
	      });
	    };
	
	    _this.clear = function () {
	      _this.setState({
	        searchTerm: ''
	      }, _this.onSearchActivate);
	    };
	
	    _this.searchTerm = '';
	    _this.state = {
	      searchTerm: '',
	      lastSubmittedSearch: null
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(DyzioSearchBox, [{
	    key: 'render',
	    value: function render() {
	      var searchTerm = this.state.searchTerm;
	      var _props = this.props,
	          placeholderText = _props.placeholderText,
	          isLoading = _props.isLoading;
	
	
	      return _react2.default.createElement(
	        _semanticUiReact.Input,
	        {
	          labelPosition: 'left',
	          iconPosition: 'right',
	          placeholder: placeholderText,
	          onChange: this.onSearchChange,
	          onKeyPress: this.onSearchKeyPress,
	          onBlur: this.onSearchActivate,
	          loading: isLoading,
	          disabled: isLoading,
	          value: searchTerm
	        },
	        _react2.default.createElement(
	          _semanticUiReact.Label,
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'search' })
	        ),
	        _react2.default.createElement('input', { style: { flex: 'auto' } }),
	        searchTerm ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'delete', link: true, onClick: this.clear }) : _react2.default.createElement(_semanticUiReact.Icon, null)
	      );
	    }
	  }]);
	  return DyzioSearchBox;
	}(_react2.default.Component);
	
	DyzioSearchBox.propTypes = {
	  onSearch: _propTypes2.default.func.isRequired,
	  placeholderText: _propTypes2.default.string.isRequired,
	  isLoading: _propTypes2.default.boolean
	};
	DyzioSearchBox.defaultProps = {
	  isLoading: false
	};
	
	exports.default = DyzioSearchBox;

/***/ },
/* 2557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _demographicsAgeGraph = __webpack_require__(241);
	
	var _demographicsAgeGraph2 = _interopRequireDefault(_demographicsAgeGraph);
	
	var _demographicsGenderGraph = __webpack_require__(376);
	
	var _demographicsGenderGraph2 = _interopRequireDefault(_demographicsGenderGraph);
	
	var _followersBarChart = __webpack_require__(176);
	
	var _followersBarChart2 = _interopRequireDefault(_followersBarChart);
	
	var _locationTabs = __webpack_require__(2558);
	
	var _locationTabs2 = _interopRequireDefault(_locationTabs);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noBottomPadding = {
	  paddingBottom: 0
	};
	
	var dividerStyle = {
	  marginTop: 5,
	  marginBottom: 5
	};
	
	var textCenter = {
	  textAlign: 'center'
	};
	
	var MODAL_LINK_STYLE = (0, _extends3.default)({
	  cursor: 'pointer'
	}, textCenter);
	
	var DYZIO_APP_ID = '116451675157336';
	
	var FacebookProfileDataLarge = function FacebookProfileDataLarge(props) {
	  var influencer = props.influencer,
	      handle = props.handle,
	      facebookVerified = props.facebookVerified,
	      countHistory = props.countHistory,
	      pageMetrics = props.pageMetrics,
	      displayAuthorisedData = props.displayAuthorisedData;
	
	
	  if (!handle) return null;
	
	  var cleanHandle = _lodash2.default.replace(handle, 'https://www.facebook.com/', '');
	  var facebookHistory = _lodash2.default.filter(countHistory, function (item) {
	    return _lodash2.default.has(item, 'facebookCount');
	  });
	  var lastFBHistoryItem = _lodash2.default.last(facebookHistory);
	
	  var _ref = pageMetrics || { data: {} },
	      _ref$data = _ref.data,
	      engagements = _ref$data.engagements,
	      views = _ref$data.views,
	      impressions = _ref$data.impressions,
	      consumptions = _ref$data.consumptions,
	      videos = _ref$data.videos;
	
	  var usingOldFormat = !!_lodash2.default.last(_lodash2.default.get(engagements, 'values')); /* TODO(Kai): Depricate then remove this line */
	
	  var graphProps = {
	    label: 'followers',
	    labels: _lodash2.default.map(facebookHistory, function (item) {
	      return (0, _moment2.default)(item.createdDate).format('MMM D');
	    }),
	    values: _lodash2.default.map(facebookHistory, 'facebookCount'),
	    rgbColorCode: '#3B5998'
	  };
	
	  var canRenderModals = false;
	
	  var lastFacebookCount = _lodash2.default.get(lastFBHistoryItem, 'facebookCount', null);
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { color: 'blue' },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 16 },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', color: 'blue' }),
	            'Facebook'
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, null)
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 3 },
	          _react2.default.createElement(_semanticUiReact.Image, {
	            src: 'https://graph.facebook.com/v2.11/' + cleanHandle + '/picture?redirect=1&app_id=' + DYZIO_APP_ID,
	            className: 'circular',
	            centered: true,
	            size: 'small'
	          }),
	          _react2.default.createElement(
	            _semanticUiReact.Table,
	            { basic: 'very', fluid: true, textAlign: 'center' },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Body,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  cleanHandle,
	                  facebookVerified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' })
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  (0, _formatting.commaFormatted)(lastFacebookCount),
	                  ' followers'
	                )
	              ),
	              !facebookVerified && _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'grey', content: 'not verified' }),
	                    content: cleanHandle + ' is not verified by Facebook (blue tick)'
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 8 },
	          _react2.default.createElement(_followersBarChart2.default, (0, _extends3.default)({}, graphProps, { percentageRange: 0.5 }))
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 5 },
	          _react2.default.createElement(
	            'h4',
	            { style: textCenter },
	            'Last 28 days page insights'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table,
	            { basic: 'very', fluid: true },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Body,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  'total page followers'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  (0, _formatting.commaFormatted)(lastFacebookCount)
	                )
	              ),
	              !usingOldFormat && displayAuthorisedData && engagements && _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(
	                      'span',
	                      null,
	                      'posts engagements',
	                      ' ',
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
	                    ),
	                    content: 'The number of times people have engaged with page posts through like, comments and shares and more.'
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  (0, _formatting.commaFormatted)(engagements.value)
	                )
	              ),
	              !usingOldFormat && displayAuthorisedData && views && _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(
	                      'span',
	                      null,
	                      'views ',
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
	                    ),
	                    content: 'Total views count per Page'
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  (0, _formatting.commaFormatted)(views.value)
	                )
	              ),
	              !usingOldFormat && displayAuthorisedData && impressions && _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(
	                      'span',
	                      null,
	                      'impressions',
	                      ' ',
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
	                    ),
	                    content: 'The number of times your Page\'s posts entered a person\'s screen. Posts include statuses, photos, links, videos and more. (Total Count)'
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  (0, _formatting.commaFormatted)(impressions.value)
	                )
	              ),
	              !usingOldFormat && displayAuthorisedData && consumptions && _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(
	                      'span',
	                      null,
	                      'consumptions',
	                      ' ',
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
	                    ),
	                    content: 'The number of clicks on any of page content. Stories generated without clicks on page content (e.g., liking the page in Timeline) are not included. (Total Count)'
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  (0, _formatting.commaFormatted)(consumptions.value)
	                )
	              ),
	              !usingOldFormat && displayAuthorisedData && videos && _react2.default.createElement(
	                _semanticUiReact.Table.Row,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    trigger: _react2.default.createElement(
	                      'span',
	                      null,
	                      'videos engagements',
	                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
	                    ),
	                    content: 'Total number of times videos have been viewed for more than 3 seconds. (Total Count)'
	                  })
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Cell,
	                  null,
	                  (0, _formatting.commaFormatted)(videos.value)
	                )
	              )
	            )
	          ),
	          !usingOldFormat && canRenderModals && displayAuthorisedData && _react2.default.createElement(
	            'div',
	            { style: textCenter },
	            _react2.default.createElement(
	              'a',
	              {
	                style: MODAL_LINK_STYLE,
	                onClick: undefined.onFullPageMetrics
	              },
	              'View full page metric data'
	            )
	          )
	        )
	      ),
	      displayAuthorisedData && props.audienceDemographics && props.audienceLocations && _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        { textAlign: 'center', style: noBottomPadding, divided: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 16 },
	          _react2.default.createElement(_semanticUiReact.Divider, { fitted: true, style: dividerStyle }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Audience Demographics and Regions',
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'orange' }),
	              content: 'Private data collected from Facebook API'
	            })
	          ),
	          _react2.default.createElement(_semanticUiReact.Divider, { fitted: true, style: dividerStyle })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 4, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Viewing by Gender'
	          ),
	          _react2.default.createElement(_demographicsGenderGraph2.default, props)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 7, verticalAlign: 'middle' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Channel demographic by gender / age'
	          ),
	          _react2.default.createElement(_demographicsAgeGraph2.default, props)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 5 },
	          _react2.default.createElement(_locationTabs2.default, props)
	        )
	      )
	    )
	  );
	};
	
	FacebookProfileDataLarge.defaultProps = {
	  enforceWhiteListCheck: false,
	  facebookVerified: false,
	  audienceLocations: null,
	  audienceDemographics: null,
	  pageMetrics: null,
	  facebookCountryDemographicsModalOpen: false,
	  facebookCityDemographicsModalOpen: false,
	  pageMetricModalOpen: false
	};
	
	exports.default = FacebookProfileDataLarge;

/***/ },
/* 2558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _instagramDemographicsCountriesTable = __webpack_require__(598);
	
	var _instagramDemographicsCountriesTable2 = _interopRequireDefault(_instagramDemographicsCountriesTable);
	
	var _demographicsLocationTable = __webpack_require__(146);
	
	var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB_STYLES = {
	  marginBottom: 4
	};
	var MODAL_LINK_STYLE = {
	  cursor: 'pointer'
	};
	
	var canRenderModals = false;
	
	var getPanes = function getPanes(props) {
	  var audienceCities = props.audienceCities,
	      onFullCountryClick = props.onFullCountryClick,
	      onFullCityClick = props.onFullCityClick;
	
	  var panes = [{
	    menuItem: { content: 'Fans by Country', key: 'country', icon: 'globe' },
	    render: function render() {
	      return _react2.default.createElement(
	        _semanticUiReact.Tab.Pane,
	        null,
	        _react2.default.createElement(_instagramDemographicsCountriesTable2.default, props),
	        canRenderModals && _react2.default.createElement(
	          'a',
	          { style: MODAL_LINK_STYLE, onClick: onFullCountryClick },
	          'View full engagement data'
	        )
	      );
	    }
	  }, {
	    menuItem: { content: 'Fans by City', key: 'last12posts', icon: 'building outline' },
	    render: function render() {
	      return _react2.default.createElement(
	        _semanticUiReact.Tab.Pane,
	        null,
	        _react2.default.createElement(_demographicsLocationTable2.default, {
	          data: audienceCities.data,
	          metric: 'absolute',
	          metricLabel: 'Followers',
	          itemLabel: 'City'
	        }),
	        canRenderModals && _react2.default.createElement(
	          'a',
	          { style: MODAL_LINK_STYLE, onClick: onFullCityClick },
	          'View full engagement data'
	        )
	      );
	    }
	  }];
	  return panes;
	};
	
	var InstagramTabs = function InstagramTabs(props) {
	  var audienceCities = props.audienceCities;
	
	  if (audienceCities) {
	    return _react2.default.createElement(_semanticUiReact.Tab, { style: TAB_STYLES, panes: getPanes(props) });
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h5',
	      null,
	      'Fans by Country'
	    ),
	    _react2.default.createElement(_instagramDemographicsCountriesTable2.default, props)
	  );
	};
	
	InstagramTabs.propTypes = {
	  audienceCities: _propTypes2.default.Object
	};
	InstagramTabs.defaultProps = {
	  audienceCities: undefined
	};
	
	exports.default = InstagramTabs;

/***/ },
/* 2559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _demographicsLocationTable = __webpack_require__(146);
	
	var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullCityModal = function FullCityModal(_ref) {
	  var onToggle = _ref.onToggle,
	      audienceCities = _ref.audienceCities;
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      headerText: 'Followers by City',
	      size: 'small',
	      onClose: onToggle,
	      hasCloseButton: true
	    },
	    _react2.default.createElement(_demographicsLocationTable2.default, {
	      data: audienceCities.data,
	      metric: 'absolute',
	      metricLabel: 'Followers',
	      itemLabel: 'City',
	      uniqueKey: 'location',
	      rowsToShow: -1
	    })
	  );
	};
	
	FullCityModal.propTypes = {
	  onToggle: _propTypes2.default.func.isRequired,
	  audienceCities: _propTypes2.default.object.isRequired
	};
	
	exports.default = FullCityModal;

/***/ },
/* 2560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _demographicsLocationTable = __webpack_require__(146);
	
	var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullCountryModal = function FullCountryModal(_ref) {
	  var onToggle = _ref.onToggle,
	      audienceLocations = _ref.audienceLocations;
	  return _react2.default.createElement(
	    _dyzioModal2.default,
	    {
	      headerText: 'Followers by Country',
	      size: 'small',
	      onClose: onToggle,
	      hasCloseButton: true
	    },
	    _react2.default.createElement(_demographicsLocationTable2.default, {
	      data: audienceLocations.data,
	      metric: 'absolute',
	      metricLabel: 'Followers',
	      itemLabel: 'Country',
	      uniqueKey: 'location',
	      rowsToShow: -1
	    })
	  );
	};
	
	FullCountryModal.propTypes = {
	  onToggle: _propTypes2.default.func.isRequired,
	  audienceLocations: _propTypes2.default.object.isRequired
	};
	
	exports.default = FullCountryModal;

/***/ },
/* 2561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _instagramDemographicsCountriesTable = __webpack_require__(598);
	
	var _instagramDemographicsCountriesTable2 = _interopRequireDefault(_instagramDemographicsCountriesTable);
	
	var _demographicsLocationTable = __webpack_require__(146);
	
	var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB_STYLES = {
	  marginBottom: 4
	};
	var MODAL_LINK_STYLE = {
	  cursor: 'pointer'
	};
	
	var getPanes = function getPanes(props) {
	  var audienceCities = props.audienceCities,
	      audienceLocations = props.audienceLocations,
	      onFullCountryClick = props.onFullCountryClick,
	      onFullCityClick = props.onFullCityClick;
	
	  var panes = [{
	    menuItem: { content: 'Fans by Country', key: 'country', icon: 'globe' },
	    render: function render() {
	      return _react2.default.createElement(
	        _semanticUiReact.Tab.Pane,
	        null,
	        _react2.default.createElement(_demographicsLocationTable2.default, {
	          data: audienceLocations.data,
	          metric: 'absolute',
	          metricLabel: 'Followers',
	          itemLabel: 'Country',
	          uniqueKey: 'location'
	        }),
	        _react2.default.createElement(
	          'a',
	          { style: MODAL_LINK_STYLE, onClick: onFullCountryClick },
	          'View full engagement data'
	        )
	      );
	    }
	  }, {
	    menuItem: { content: 'Fans by City', key: 'last12posts', icon: 'building outline' },
	    render: function render() {
	      return _react2.default.createElement(
	        _semanticUiReact.Tab.Pane,
	        null,
	        _react2.default.createElement(_demographicsLocationTable2.default, {
	          data: audienceCities.data,
	          metric: 'absolute',
	          metricLabel: 'Followers',
	          itemLabel: 'City',
	          uniqueKey: 'location'
	        }),
	        _react2.default.createElement(
	          'a',
	          { style: MODAL_LINK_STYLE, onClick: onFullCityClick },
	          'View full engagement data'
	        )
	      );
	    }
	  }];
	  return panes;
	};
	
	var InstagramTabs = function InstagramTabs(props) {
	  var audienceCities = props.audienceCities;
	
	  if (audienceCities) {
	    return _react2.default.createElement(_semanticUiReact.Tab, { style: TAB_STYLES, panes: getPanes(props) });
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h5',
	      null,
	      'Fans by Country'
	    ),
	    _react2.default.createElement(_instagramDemographicsCountriesTable2.default, props)
	  );
	};
	
	InstagramTabs.propTypes = {
	  audienceCities: _propTypes2.default.Object
	};
	InstagramTabs.defaultProps = {
	  audienceCities: undefined
	};
	
	exports.default = InstagramTabs;

/***/ },
/* 2562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _storiesIcon = __webpack_require__(2602);
	
	var _storiesIcon2 = _interopRequireDefault(_storiesIcon);
	
	var _instagramStory = __webpack_require__(599);
	
	var _instagramStory2 = _interopRequireDefault(_instagramStory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InstagramStories = function InstagramStories(props) {
	  var isLoading = props.isLoading,
	      hasFailed = props.hasFailed,
	      stories = props.stories,
	      emptyMessageText = props.emptyMessageText,
	      campaignList = props.campaignList,
	      onCampaignSelected = props.onCampaignSelected;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { basic: true },
	    isLoading && !hasFailed && _react2.default.createElement(_semanticUiReact.Loader, {
	      active: true,
	      style: { marginTop: '32px' },
	      content: 'Loading...'
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Group,
	      { itemsPerRow: 1 },
	      !isLoading && !hasFailed && _lodash2.default.map(stories, function (story) {
	        return _react2.default.createElement(_instagramStory2.default, (0, _extends3.default)({}, story, {
	          campaignList: campaignList,
	          onCampaignSelected: onCampaignSelected
	        }));
	      }),
	      !isLoading && hasFailed && _react2.default.createElement(_semanticUiReact.Message, {
	        icon: 'ban',
	        error: true,
	        fluid: true,
	        content: 'Could not load stories. Please try again later.'
	      }),
	      !isLoading && !hasFailed && _lodash2.default.size(stories) === 0 && _react2.default.createElement(
	        _semanticUiReact.Message,
	        { style: { marginTop: '64px' }, icon: true, info: true },
	        _react2.default.createElement(_semanticUiReact.Image, { style: { marginRight: '10px' }, src: _storiesIcon2.default, size: 'tiny' }),
	        _react2.default.createElement(
	          _semanticUiReact.Message.Content,
	          null,
	          emptyMessageText
	        )
	      )
	    )
	  );
	};
	
	exports.default = InstagramStories;

/***/ },
/* 2563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _pagination = __webpack_require__(147);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _dyzioSearchBox = __webpack_require__(2556);
	
	var _dyzioSearchBox2 = _interopRequireDefault(_dyzioSearchBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InstagramStoryMenu = function InstagramStoryMenu(props) {
	  var onPageIncrement = props.onPageIncrement,
	      onPageDecrement = props.onPageDecrement,
	      currentPage = props.currentPage,
	      totalPages = props.totalPages,
	      onSearch = props.onSearch,
	      isLoading = props.isLoading;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { width: '12' },
	        _react2.default.createElement(_dyzioSearchBox2.default, {
	          onSearch: onSearch,
	          placeholderText: 'Search captions...',
	          isLoading: isLoading
	        })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { width: '4' },
	        _react2.default.createElement(_pagination2.default, {
	          onPageIncrement: onPageIncrement,
	          onPageDecrement: onPageDecrement,
	          currentPage: currentPage,
	          totalPages: totalPages
	        })
	      )
	    )
	  );
	};
	
	InstagramStoryMenu.propTypes = {
	  onPageIncrement: _propTypes2.default.func.isRequired,
	  onPageDecrement: _propTypes2.default.func.isRequired,
	  onSearch: _propTypes2.default.func.isRequired,
	  currentPage: _propTypes2.default.number.isRequired,
	  totalPages: _propTypes2.default.number.isRequired,
	  isLoading: _propTypes2.default.bool
	};
	InstagramStoryMenu.defaultProps = {
	  isLoading: false
	};
	
	exports.default = InstagramStoryMenu;

/***/ },
/* 2564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _reactPlayer = __webpack_require__(410);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(152);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _formatting = __webpack_require__(52);
	
	var _assets = __webpack_require__(243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sf = function sf(num) {
	  var format = num > 1000 ? '0a' : '0';
	  return (0, _numeral2.default)(num).format(format);
	};
	var pf = function pf(num) {
	  return (0, _numeral2.default)(num).format('0.0%');
	};
	var DATE_FORMAT = 'LLLL';
	
	var textTransform = {
	  textTransform: 'none'
	};
	
	var InstagramStoryReport = function InstagramStoryReport(_ref) {
	  var story = _ref.story,
	      _ref$inManualStoryMod = _ref.inManualStoryMode,
	      inManualStoryMode = _ref$inManualStoryMod === undefined ? false : _ref$inManualStoryMod,
	      _ref$inGIMode = _ref.inGIMode,
	      inGIMode = _ref$inGIMode === undefined ? false : _ref$inGIMode;
	
	  var status = _lodash2.default.get(story, 'attributes.status', 'Unknown');
	  var assetType = _lodash2.default.get(story, 'attributes.assetType', _lodash2.default.get(story, 'trackedAsset.assetType'));
	  var publishedDate = _lodash2.default.get(story, 'attributes.publishedDate', _lodash2.default.get(story, 'trackedAsset.publishedDate'));
	  var caption = _lodash2.default.get(story, 'attributes.caption', _lodash2.default.get(story, 'trackedAsset.extraData.text'));
	
	  var storyMentions = _lodash2.default.get(story, 'attributes.mentions');
	  var mentions = _lodash2.default.isArray(storyMentions) ? storyMentions : _lodash2.default.split(storyMentions, ',');
	
	  var storyHashtags = _lodash2.default.get(story, 'attributes.hashtags');
	  var hashtags = _lodash2.default.isArray(storyHashtags) ? storyHashtags : _lodash2.default.split(storyHashtags, ',');
	
	  var username = _lodash2.default.get(story, 'attributes.username', _lodash2.default.get(story, 'influencerName'));
	  var isVideo = assetType === 'VIDEO';
	  var latest = _lodash2.default.last(_lodash2.default.get(story, 'attributes.storyData', []));
	  var supportingData = _lodash2.default.get(story, 'relationships.supportingData') || _lodash2.default.get(story, 'trackedAsset.supportingData');
	
	  var manualImps = (0, _assets.getSupportingDataField)(supportingData, 'impressions');
	  var manualReach = (0, _assets.getSupportingDataField)(supportingData, 'reach');
	
	  var isBoosted = !_lodash2.default.isNull(_lodash2.default.get(story, 'attributes.finalImps', null));
	
	  var completionRate = inManualStoryMode || inGIMode || isBoosted || !latest || !latest.impressions || !latest.exits ? null : (latest.impressions - latest.exits) / latest.impressions;
	
	  var pubDate = (0, _moment2.default)(publishedDate).format(DATE_FORMAT);
	  var expDate = (0, _moment2.default)(publishedDate).add(1, 'day').format(DATE_FORMAT);
	
	  var imps = _lodash2.default.get(story, 'attributes.finalImps') || latest ? _lodash2.default.get(latest, 'impressions') : _lodash2.default.get(story, 'insights.impressions');
	  var reach = _lodash2.default.get(story, 'attributes.finalReach') || latest ? _lodash2.default.get(latest, 'reach') : _lodash2.default.get(story, 'insights.reach');
	
	  var s3Url = (0, _assets.getS3Url)((0, _assets.getSupportingDataField)(supportingData, 'filePath'));
	  var savedThumbnailUrl = _lodash2.default.get(story, 'attributes.savedThumbnailUrl', s3Url);
	  var savedMediaUrl = _lodash2.default.get(story, 'attributes.savedMediaUrl', s3Url);
	
	  console.log(s3Url);
	
	  var imageUrl = savedThumbnailUrl || savedMediaUrl;
	
	  var storyImage = imageUrl ? _react2.default.createElement(_semanticUiReact.Image, { src: imageUrl, size: 'large' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: isVideo ? 'film' : 'image', size: 'massive', color: 'pink' });
	
	  var StoryVideo = function StoryVideo() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _lodash2.default.isNil(savedMediaUrl) && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_semanticUiReact.Image, { src: imageUrl, size: 'large' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Video not available'
	        )
	      ),
	      _lodash2.default.isNil(savedMediaUrl) && (0, _assets.isVideoUrl)(savedThumbnailUrl) && _react2.default.createElement(_reactPlayer2.default, { url: savedThumbnailUrl, width: '100%', height: '100%', controls: true }),
	      savedMediaUrl && _react2.default.createElement(_reactPlayer2.default, { url: savedMediaUrl, width: '100%', height: '100%', controls: true })
	    );
	  };
	
	  var storyContent = isVideo || (0, _assets.isVideoUrl)(s3Url) || (0, _assets.isVideoUrl)(savedThumbnailUrl) ? _react2.default.createElement(StoryVideo, null) : storyImage;
	
	  return _react2.default.createElement(
	    _semanticUiReact.Grid,
	    { columns: 2 },
	    _react2.default.createElement(
	      _semanticUiReact.Grid.Row,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { width: 5, verticalAlign: 'top' },
	        storyContent
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { width: 11 },
	        !inGIMode && _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Statistic.Group,
	              { widths: inManualStoryMode ? 'two' : 'three' },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  { style: textTransform },
	                  (0, _formatting.sciFormatted)(inManualStoryMode ? manualImps : imps)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'Impressions'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  { style: textTransform },
	                  (0, _formatting.sciFormatted)(inManualStoryMode ? manualReach : reach)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'Reach'
	                )
	              ),
	              completionRate && _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                { color: 'teal' },
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  { style: textTransform },
	                  pf(completionRate)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'Completion Rate \xA0',
	                  _react2.default.createElement(_semanticUiReact.Popup, {
	                    content: 'Completion rate is calculated as the percentage of users who viewed the story and did NOT exit the story.', trigger: _react2.default.createElement(_semanticUiReact.Icon, {
	                      className: 'circular',
	                      name: 'help',
	                      color: 'teal'
	                    })
	                  })
	                )
	              )
	            )
	          )
	        ),
	        !inManualStoryMode && !inGIMode && _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table,
	              { basic: 'very', textAlign: 'center', columns: 'four' },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Header,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'TAPS FORWARD'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'TAPS BACK'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'REPLIES'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'EXITS'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    (0, _formatting.commaFormatted)(_lodash2.default.get(latest, 'taps_forward'))
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    (0, _formatting.commaFormatted)(_lodash2.default.get(latest, 'taps_back'))
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    (0, _formatting.commaFormatted)(_lodash2.default.get(latest, 'replies'))
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    (0, _formatting.commaFormatted)(_lodash2.default.get(latest, 'exits'))
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table,
	              { basic: 'very', celled: true, fluid: true },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Header,
	                      { as: 'h4' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Header.Content,
	                        null,
	                        'INFLUENCER'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    username
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Header,
	                      { as: 'h4' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Header.Content,
	                        null,
	                        'POSTED'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    pubDate
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Header,
	                      { as: 'h4' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Header.Content,
	                        null,
	                        'CAPTION'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    caption || 'no caption created'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Header,
	                      { as: 'h4' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Header.Content,
	                        null,
	                        '@MENTIONS'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _lodash2.default.map(mentions, function (mention) {
	                      if (!_lodash2.default.isEmpty(mention)) {
	                        return _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'pink', content: _lodash2.default.toLower(mention) });
	                      }
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Header,
	                      { as: 'h4' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Header.Content,
	                        null,
	                        '#HASHTAGS'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _lodash2.default.map(hashtags, function (hashtag) {
	                      if (!_lodash2.default.isEmpty(hashtag)) {
	                        return _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'green', content: _lodash2.default.toLower(hashtag) });
	                      }
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	InstagramStoryReport.propTypes = {
	  story: _propTypes2.default.object.isRequired
	};
	
	exports.default = InstagramStoryReport;

/***/ },
/* 2565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _instagramProfileData = __webpack_require__(377);
	
	var _instagramProfileData2 = _interopRequireDefault(_instagramProfileData);
	
	var _facebookProfileDataLarge = __webpack_require__(2557);
	
	var _facebookProfileDataLarge2 = _interopRequireDefault(_facebookProfileDataLarge);
	
	var _youtubeProfileDataLarge = __webpack_require__(2572);
	
	var _youtubeProfileDataLarge2 = _interopRequireDefault(_youtubeProfileDataLarge);
	
	var _twitchData = __webpack_require__(600);
	
	var _twitchData2 = _interopRequireDefault(_twitchData);
	
	var _tiktokProfileDataLarge = __webpack_require__(2570);
	
	var _tiktokProfileDataLarge2 = _interopRequireDefault(_tiktokProfileDataLarge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaKitBody = function MediaKitBody(_ref) {
	  var influencer = _ref.influencer,
	      youtubeAPIDetails = _ref.youtubeAPIDetails,
	      youtubeModalOpen = _ref.youtubeModalOpen,
	      toggleYoutubeModalState = _ref.toggleYoutubeModalState,
	      hasFullEngagementDataLink = _ref.hasFullEngagementDataLink,
	      organisationId = _ref.organisationId,
	      displayAuthorisedData = _ref.displayAuthorisedData;
	
	  //
	  if (!influencer) {
	    return _react2.default.createElement(_semanticUiReact.Message, { content: 'No data to display', warning: true });
	  }
	
	  var countHistory = influencer.countHistory,
	      facebookVerified = influencer.facebookVerified,
	      facebook = influencer.facebook,
	      instagram = influencer.instagram,
	      youtube = influencer.youtube,
	      facebookData = influencer.facebookData,
	      statistics = influencer.statistics,
	      influencerApiLink = influencer.influencerApiLink,
	      twitch = influencer.twitch,
	      twitchCount = influencer.twitchCount,
	      tiktok = influencer.tiktok;
	
	
	  var twitchProps = {
	    twitchCount: twitchCount,
	    twitch: twitch,
	    countHistory: countHistory
	  };
	
	  var isMissingYoutubeAPILink = !_lodash2.default.isObject(influencerApiLink);
	  return _react2.default.createElement(
	    'div',
	    null,
	    youtube && _react2.default.createElement(_youtubeProfileDataLarge2.default, {
	      displayAuthorisedData: displayAuthorisedData,
	      hasFullEngagementDataLink: hasFullEngagementDataLink,
	      influencer: influencer,
	      apiInfluencer: youtubeAPIDetails,
	      missingAPILink: isMissingYoutubeAPILink,
	      youtubeDemographicsModalOpen: youtubeModalOpen,
	      toggleYoutubeDemographicsModalState: toggleYoutubeModalState
	    }),
	    instagram && _react2.default.createElement(_instagramProfileData2.default, {
	      influencer: influencer,
	      stats: statistics,
	      data: instagram,
	      organisationId: organisationId,
	      displayAuthorisedData: displayAuthorisedData
	    }),
	    facebook && _react2.default.createElement(_facebookProfileDataLarge2.default, (0, _extends3.default)({
	      displayAuthorisedData: displayAuthorisedData
	    }, facebookData, {
	      influencer: influencer,
	      handle: facebook,
	      countHistory: countHistory,
	      facebookVerified: facebookVerified
	    })),
	    twitch && _react2.default.createElement(_twitchData2.default, { influencer: twitchProps }),
	    tiktok && _react2.default.createElement(_tiktokProfileDataLarge2.default, {
	      influencer: influencer,
	      countHistory: countHistory
	    })
	  );
	};
	
	MediaKitBody.defaultProps = {
	  displayAuthorisedData: false
	};
	
	exports.default = MediaKitBody;

/***/ },
/* 2566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _dyzioIcons = __webpack_require__(597);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = typeof window !== 'undefined' && window.location,
	    hostname = _ref.hostname;
	
	var headerStyle = {
	  marginLeft: 170,
	  marginRight: 170,
	  paddingTop: 30
	};
	
	var VizzMediaKit = function VizzMediaKit(_ref2) {
	  var influencer = _ref2.influencer,
	      logoProps = _ref2.logoProps,
	      avatarProps = _ref2.avatarProps;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_semanticUiReact.Image, (0, _extends3.default)({ src: influencer.thumbnail }, avatarProps)),
	    _react2.default.createElement(_semanticUiReact.Image, logoProps),
	    _react2.default.createElement(
	      'div',
	      { style: headerStyle },
	      _react2.default.createElement(
	        _semanticUiReact.Header,
	        { size: 'huge' },
	        influencer.primarySocialHandle
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Header,
	        { size: 'large', color: 'grey' },
	        influencer.name
	      )
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, { clearing: true }),
	    _react2.default.createElement(
	      _semanticUiReact.Table,
	      { basic: 'very', fixed: true, singleLine: true, textAlign: 'center' },
	      _react2.default.createElement(
	        _semanticUiReact.Table.Body,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(_dyzioIcons.YoutubeIcon, null),
	            (0, _formatting.commaFormatted)(influencer.youtubeCount)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(_dyzioIcons.InstagramIcon, null),
	            (0, _formatting.commaFormatted)(influencer.instagramCount)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(_dyzioIcons.TwitterIcon, null),
	            (0, _formatting.commaFormatted)(influencer.twitterCount)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(_dyzioIcons.FacebookIcon, null),
	            (0, _formatting.commaFormatted)(influencer.facebookCount)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Cell,
	            null,
	            _react2.default.createElement(_dyzioIcons.TwitchIcon, null),
	            (0, _formatting.commaFormatted)(influencer.twitchCount)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, null)
	  );
	};
	
	exports.default = VizzMediaKit;

/***/ },
/* 2567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _numeral = __webpack_require__(152);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _targetLink = __webpack_require__(2569);
	
	var _targetLink2 = _interopRequireDefault(_targetLink);
	
	var _assets = __webpack_require__(243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_IMAGE = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/no_image_available.png';
	
	var textTransform = {
	  textTransform: 'none'
	};
	
	var sf = function sf(num) {
	  var format = num > 1000 ? '0a' : '0';
	  return (0, _numeral2.default)(num).format(format);
	};
	
	var SupportingDataModalBody = function SupportingDataModalBody(_ref) {
	  var supportingData = _ref.supportingData,
	      platform = _ref.platform,
	      discussionName = _ref.discussionName,
	      assetType = _ref.assetType,
	      publishedDate = _ref.publishedDate,
	      assetURL = _ref.assetURL,
	      extraData = _ref.extraData;
	
	  var filePath = (0, _assets.getSupportingDataField)(supportingData, 'filePath');
	  var views = (0, _assets.getSupportingDataField)(supportingData, 'views');
	  var likes = (0, _assets.getSupportingDataField)(supportingData, 'likes');
	  var shares = (0, _assets.getSupportingDataField)(supportingData, 'shares');
	  var comments = (0, _assets.getSupportingDataField)(supportingData, 'comments');
	  var clicks = (0, _assets.getSupportingDataField)(supportingData, 'clicks');
	  var isVK = platform === 'VK';
	  var isBlog = platform === 'BLOG';
	  var isSnapchat = platform === 'SNAPCHAT';
	  return _react2.default.createElement(
	    _semanticUiReact.Grid,
	    { columns: 2 },
	    _react2.default.createElement(
	      _semanticUiReact.Grid.Row,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { width: 5, verticalAlign: 'top' },
	        _react2.default.createElement(_semanticUiReact.Image, { src: (0, _assets.getS3Url)(filePath, DEFAULT_IMAGE), size: 'large' })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Column,
	        { width: 11 },
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            isVK && _react2.default.createElement(
	              _semanticUiReact.Statistic.Group,
	              { widths: 'three' },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  { style: textTransform },
	                  sf(views)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'views'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  { style: textTransform },
	                  sf(likes)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'likes'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  { style: textTransform },
	                  sf(comments)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'comments'
	                )
	              )
	            ),
	            isBlog && _react2.default.createElement(
	              _semanticUiReact.Statistic.Group,
	              { widths: 'three' },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  { style: textTransform },
	                  sf(views)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'views'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  { style: textTransform },
	                  sf(clicks)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'clicks'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  { style: textTransform },
	                  sf(comments)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'comments'
	                )
	              )
	            ),
	            isSnapchat && _react2.default.createElement(
	              _semanticUiReact.Statistic.Group,
	              { widths: 'two' },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  { style: textTransform },
	                  sf(views)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'views'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  { style: textTransform },
	                  sf(shares)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  'shares'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card,
	          { fluid: true },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table,
	              { basic: 'very', celled: true, fluid: true },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    { width: 4 },
	                    _react2.default.createElement(
	                      _semanticUiReact.Header,
	                      { as: 'h4' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Header.Content,
	                        null,
	                        'PLATFORM / TYPE'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    { width: 12 },
	                    platform,
	                    ' / ',
	                    assetType
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Header,
	                      { as: 'h4' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Header.Content,
	                        null,
	                        'INFLUENCER'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    discussionName || '-'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Header,
	                      { as: 'h4' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Header.Content,
	                        null,
	                        'POSTED'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    publishedDate ? (0, _moment2.default)(publishedDate).format('YYYY-MM-DD') : '-'
	                  )
	                ),
	                !isSnapchat && _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Header,
	                      { as: 'h4' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Header.Content,
	                        null,
	                        'LINK'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(
	                      _targetLink2.default,
	                      {
	                        renderIf: true,
	                        href: assetURL
	                      },
	                      _lodash2.default.truncate(assetURL, { length: 80 })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Header,
	                      { as: 'h4' },
	                      _react2.default.createElement(
	                        _semanticUiReact.Header.Content,
	                        null,
	                        'CAPTION'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _lodash2.default.get(extraData, 'text', 'no caption created')
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	SupportingDataModalBody.propTypes = {
	  supportingData: _propTypes2.default.array,
	  platform: _propTypes2.default.string,
	  discussionName: _propTypes2.default.string,
	  assetType: _propTypes2.default.string,
	  assetURL: _propTypes2.default.string,
	  publishedDate: _propTypes2.default.string,
	  extraData: _propTypes2.default.object
	};
	
	SupportingDataModalBody.defaultProps = {
	  supportingData: [],
	  platform: '-',
	  discussionName: '-',
	  assetType: '-',
	  publishedDate: '-',
	  assetURL: '-',
	  extraData: { text: '-' }
	};
	
	exports.default = SupportingDataModalBody;

/***/ },
/* 2568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _body = __webpack_require__(2567);
	
	var _body2 = _interopRequireDefault(_body);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cursorPointer = {
	  cursor: 'pointer',
	  color: '#20c49e'
	};
	
	var smallFont = {
	  fontSize: '60%',
	  color: 'grey'
	};
	
	var SupportingDataModal = function SupportingDataModal(_ref) {
	  var asset = _ref.asset;
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      trigger: _react2.default.createElement(
	        'div',
	        { style: cursorPointer },
	        _react2.default.createElement(_semanticUiReact.Icon, {
	          title: 'view full story performance data (including media)',
	          name: 'expand'
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: smallFont },
	          'view...'
	        )
	      )
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Header,
	      null,
	      _lodash2.default.get(asset, 'platform') === 'VK' ? 'VK' : _lodash2.default.capitalize(_lodash2.default.get(asset, 'platform')),
	      ' Performance'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      _react2.default.createElement(_body2.default, asset)
	    )
	  );
	};
	
	SupportingDataModal.propTypes = {
	  asset: _propTypes2.default.object.isRequired
	};
	
	exports.default = SupportingDataModal;

/***/ },
/* 2569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TargetLink = function TargetLink(props) {
	
	  if (!props.renderIf) return _react2.default.createElement(
	    "div",
	    null,
	    props.children
	  );
	
	  return _react2.default.createElement(
	    "a",
	    {
	      href: props.href,
	      target: "_blank",
	      rel: "noopener noreferrer"
	    },
	    props.children
	  );
	};
	
	exports.default = TargetLink;

/***/ },
/* 2570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(234);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(233);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(108);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(20);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _axiosRetry = __webpack_require__(973);
	
	var _axiosRetry2 = _interopRequireDefault(_axiosRetry);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _followersBarChart = __webpack_require__(176);
	
	var _followersBarChart2 = _interopRequireDefault(_followersBarChart);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var iconStyle = {
	  'vertical-align': 'middle',
	  display: 'inline',
	  height: 35
	};
	
	var loadingStyle = {
	  minHeight: 90,
	  marginTop: 30
	};
	
	var textCenterStyle = {
	  textAlign: 'center',
	  width: '100%'
	};
	
	var TiktokProfileDataLarge = function (_React$Component) {
	  (0, _inherits3.default)(TiktokProfileDataLarge, _React$Component);
	
	  function TiktokProfileDataLarge() {
	    (0, _classCallCheck3.default)(this, TiktokProfileDataLarge);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TiktokProfileDataLarge.__proto__ || (0, _getPrototypeOf2.default)(TiktokProfileDataLarge)).call(this));
	
	    _this.state = {
	      loading: false,
	      profile: {}
	    };
	    _this.restClient = _axios2.default.create({
	      baseURL: ("https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/twitter"),
	      timeout: 5000
	    });
	
	    (0, _axiosRetry2.default)(_this.restClient, {
	      delay: 100,
	      retries: 3
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(TiktokProfileDataLarge, [{
	    key: 'componentWillMount',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('data mount');
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentWillMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentWillMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          influencer = _props.influencer,
	          countHistory = _props.countHistory;
	      var _state = this.state,
	          profile = _state.profile,
	          loading = _state.loading;
	      var tiktokProfileData = influencer.tiktokProfileData,
	          tiktokThumbnail = influencer.tiktokThumbnail;
	
	      var _ref2 = tiktokProfileData || {},
	          engagementData = _ref2.engagementData,
	          verified = _ref2.verified,
	          handle = _ref2.username;
	
	      var _ref3 = engagementData || {},
	          postsPerWeek = _ref3.postsPerWeek,
	          likes = _ref3.likes,
	          comments = _ref3.comments,
	          shares = _ref3.shares,
	          engagementRate = _ref3.engagementRate;
	
	      console.log('tiktok profile', profile);
	
	      var tiktokData = _lodash2.default.filter(countHistory, function (item) {
	        return _lodash2.default.has(item, 'tiktokCount');
	      });
	      if (_lodash2.default.isEmpty(tiktokData)) {
	        tiktokData = [{
	          tiktokCount: _lodash2.default.get(influencer, 'tiktokCount'),
	          createdDate: (0, _moment2.default)().format('MMM D')
	        }];
	      }
	      console.log('tiktokData', tiktokData);
	      var graphProps = {
	        label: 'followers',
	        labels: _lodash2.default.map(tiktokData, function (item) {
	          return (0, _moment2.default)(item.createdDate).format('MMM D');
	        }),
	        values: _lodash2.default.map(tiktokData, 'tiktokCount'),
	        rgbColorCode: '#000'
	      };
	      var lastTiktokScan = _lodash2.default.last(tiktokData);
	      return _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { color: 'black' },
	        loading && _react2.default.createElement(_semanticUiReact.Loader, {
	          active: true,
	          inline: 'centered',
	          content: 'Loading Tiktok data',
	          style: loadingStyle
	        }),
	        !loading && _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 16 },
	              _react2.default.createElement(
	                'h3',
	                null,
	                _react2.default.createElement(_semanticUiReact.Image, { src: 'https://app.dyzio.co/icons/tiktok.svg', alt: 'Tiktok', style: iconStyle }),
	                'Tiktok'
	              ),
	              _react2.default.createElement(_semanticUiReact.Divider, null)
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            { divided: true },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 4 },
	              _react2.default.createElement(_semanticUiReact.Image, {
	                src: tiktokThumbnail,
	                shape: 'circular',
	                centered: true,
	                size: 'small'
	              }),
	              _react2.default.createElement(
	                _semanticUiReact.Table,
	                { basic: 'very', fluid: true, textAlign: 'center' },
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Body,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      handle,
	                      verified && _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      (0, _formatting.commaFormatted)(lastTiktokScan.tiktokCount),
	                      ' followers'
	                    )
	                  ),
	                  !verified && _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      _react2.default.createElement(_semanticUiReact.Popup, {
	                        trigger: _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'grey', content: 'not verified' }),
	                        content: handle + ' is not verified by Tiktok (blue tick)'
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 7 },
	              _react2.default.createElement(_followersBarChart2.default, (0, _extends3.default)({}, graphProps, {
	                percentageRange: 0.5
	              }))
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { width: 5 },
	              loading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading...' }),
	              engagementRate && !loading && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  { style: textCenterStyle },
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    null,
	                    (0, _formatting.ierFormat2DP)(engagementRate),
	                    '%'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'engagement rate'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table,
	                  { basic: 'very', fluid: true, compact: true },
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Body,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'posts per week'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(postsPerWeek)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'avg. likes per post'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(likes)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'avg. comments per post'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(comments)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Row,
	                      null,
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        'avg. shares per post'
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.Table.Cell,
	                        null,
	                        (0, _formatting.countFormat)(shares)
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return TiktokProfileDataLarge;
	}(_react2.default.Component);
	
	TiktokProfileDataLarge.propTypes = {
	  influencer: _propTypes2.default.object.isRequired,
	  countHistory: _propTypes2.default.array
	};
	
	TiktokProfileDataLarge.defaultProps = {
	  countHistory: []
	};
	
	exports.default = TiktokProfileDataLarge;

/***/ },
/* 2571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _youtubeWatchingStats = __webpack_require__(2575);
	
	var _youtubeWatchingStats2 = _interopRequireDefault(_youtubeWatchingStats);
	
	var _transformer = __webpack_require__(2589);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cursorPointer = {
	  cursor: 'pointer'
	};
	
	var smallFont = {
	  fontSize: '60%',
	  color: 'grey'
	};
	
	var YoutubeModalComponent = function YoutubeModalComponent(_ref) {
	  var post = _ref.post;
	
	  var mainData = _transformer2.default.getHeroData({
	    posts: [post]
	  });
	  var heroPost = _transformer2.default.getHeroPost({
	    posts: [post]
	  });
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      trigger: _react2.default.createElement(
	        'div',
	        { style: cursorPointer },
	        _react2.default.createElement(_semanticUiReact.Icon, {
	          title: 'view full data',
	          name: 'expand'
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: smallFont },
	          'view...'
	        )
	      )
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Header,
	      null,
	      'YouTube Video Performance'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      _react2.default.createElement(_youtubeWatchingStats2.default, { mainData: mainData, heroPost: heroPost })
	    )
	  );
	};
	
	YoutubeModalComponent.propTypes = {
	  post: _propTypes2.default.object.isRequired
	};
	
	exports.default = YoutubeModalComponent;

/***/ },
/* 2572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _dyzioModal = __webpack_require__(33);
	
	var _dyzioModal2 = _interopRequireDefault(_dyzioModal);
	
	var _demographicsAgeGraph = __webpack_require__(241);
	
	var _demographicsAgeGraph2 = _interopRequireDefault(_demographicsAgeGraph);
	
	var _demographicsGenderGraph = __webpack_require__(376);
	
	var _demographicsGenderGraph2 = _interopRequireDefault(_demographicsGenderGraph);
	
	var _youtubeDemographicsCountriesTable = __webpack_require__(966);
	
	var _youtubeDemographicsCountriesTable2 = _interopRequireDefault(_youtubeDemographicsCountriesTable);
	
	var _demographicsYoutubeDataTable = __webpack_require__(965);
	
	var _demographicsYoutubeDataTable2 = _interopRequireDefault(_demographicsYoutubeDataTable);
	
	var _followersBarChart = __webpack_require__(176);
	
	var _followersBarChart2 = _interopRequireDefault(_followersBarChart);
	
	var _youtubeDataTabs = __webpack_require__(2573);
	
	var _youtubeDataTabs2 = _interopRequireDefault(_youtubeDataTabs);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noBottomPadding = {
	  paddingBottom: 0
	};
	
	var chartWrapperStyles = {
	  width: '100%'
	};
	
	var dividerStyle = {
	  marginTop: 5,
	  marginBottom: 5
	};
	
	var notificationStyle = {
	  paddingTop: 100,
	  paddingBottom: 100
	};
	
	var messageStyle = { color: 'grey', fontSize: 16 };
	
	var modalLinkStyle = {
	  cursor: 'pointer'
	};
	
	var YoutubeProfileDataLarge = function YoutubeProfileDataLarge(props) {
	  var hasFullEngagementDataLink = props.hasFullEngagementDataLink,
	      toggleYoutubeDemographicsModalState = props.toggleYoutubeDemographicsModalState,
	      isYouTubeCompliance = props.isYouTubeCompliance,
	      _props$influencer = props.influencer,
	      countHistory = _props$influencer.countHistory,
	      youtube = _props$influencer.youtube,
	      youtubeData = _props$influencer.youtubeData,
	      name = _props$influencer.name,
	      thumbnail = _props$influencer.thumbnail,
	      youtubeDemographicsModalOpen = props.youtubeDemographicsModalOpen,
	      missingAPILink = props.missingAPILink,
	      apiInfluencer = props.apiInfluencer;
	
	
	  var youtubeDataExists = youtubeData && _lodash2.default.size(youtubeData) > 0;
	
	  var hasYoutubeHandle = _lodash2.default.isString(youtube);
	  var lastMonthHistory = _lodash2.default.slice(countHistory, -30);
	
	  var chartProps = {
	    rgbColorCode: '#ff0000',
	    label: 'subscribers',
	    labels: _lodash2.default.map(lastMonthHistory, function (item) {
	      return (0, _moment2.default)(item.createdDate).format('MMM D');
	    }),
	    values: _lodash2.default.map(lastMonthHistory, 'youtubeCount')
	  };
	
	  var percentageChange = void 0;
	  if (lastMonthHistory && lastMonthHistory.length > 10) {
	    var first = _lodash2.default.head(lastMonthHistory).youtubeCount;
	    var last = _lodash2.default.last(lastMonthHistory).youtubeCount;
	    percentageChange = (last - first) / first;
	  }
	
	  var avgComments = void 0;
	  var thirtyDayData = void 0;
	
	  if (apiInfluencer) {
	    var latestVideos = apiInfluencer.latestYoutubeVideos;
	    var sumComments = _lodash2.default.sumBy(latestVideos, function (lv) {
	      return parseInt(_lodash2.default.get(lv, 'statistics.commentCount', 0), 10);
	    });
	    avgComments = sumComments / latestVideos.length;
	
	    var channelStatistics = apiInfluencer.channelStatistics;
	
	    var orderedStats = _lodash2.default.orderBy(channelStatistics, 'collectedDate', 'desc');
	    var latestStat = _lodash2.default.head(orderedStats);
	    var earliestStat = orderedStats[30] || _lodash2.default.last(orderedStats);
	    thirtyDayData = {
	      subscriberChange: latestStat.subscriberCount - earliestStat.subscriberCount,
	      viewChange: latestStat.viewCount - earliestStat.viewCount,
	      videoChange: latestStat.videoCount - earliestStat.videoCount,
	      dayChange: (0, _moment2.default)(latestStat.collectedDate).diff((0, _moment2.default)(earliestStat.collectedDate), 'days')
	    };
	  }
	
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { loading: props.loading, color: 'red' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      !isYouTubeCompliance && _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube', color: 'red' }),
	      'YouTube'
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, null),
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        { columns: 3, style: noBottomPadding },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 3 },
	          hasYoutubeHandle && apiInfluencer && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_semanticUiReact.Image, {
	              src: thumbnail,
	              circular: true,
	              centered: true,
	              size: 'small'
	            }),
	            _react2.default.createElement(
	              _semanticUiReact.Table,
	              { basic: 'very', fluid: true, textAlign: 'center' },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    apiInfluencer.name,
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'grey' })
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    _react2.default.createElement(_semanticUiReact.Label, { color: 'blue', basic: true, content: apiInfluencer.category })
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.videoCount),
	                    ' videos'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.Cell,
	                    null,
	                    (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.subscriberCount),
	                    ' subscribers'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 8 },
	          hasYoutubeHandle && _react2.default.createElement(
	            'div',
	            { className: 'chart-wrapper-print' },
	            _react2.default.createElement(_followersBarChart2.default, (0, _extends3.default)({}, chartProps, {
	              percentageRange: 0.5
	            }))
	          ),
	          !hasYoutubeHandle && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h2', icon: true, textAlign: 'center', style: notificationStyle },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus', color: 'orange', circular: true }),
	              _react2.default.createElement(
	                _semanticUiReact.Header.Content,
	                { style: messageStyle },
	                'no Youtube channel',
	                _react2.default.createElement('br', null),
	                'for this influencer'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 5 },
	          hasYoutubeHandle && !props.data && !props.loading && props.error && _react2.default.createElement(
	            _semanticUiReact.Message,
	            { error: true },
	            'could not load Youtube data'
	          ),
	          hasYoutubeHandle && !props.data && !props.loading && missingAPILink && _react2.default.createElement(
	            _semanticUiReact.Message,
	            { warning: true },
	            'missing api link'
	          ),
	          hasYoutubeHandle && apiInfluencer && _react2.default.createElement(_youtubeDataTabs2.default, {
	            percentageChange: percentageChange,
	            apiInfluencer: apiInfluencer,
	            avgComments: avgComments,
	            isYouTubeCompliance: isYouTubeCompliance,
	            thirtyDayData: thirtyDayData
	          })
	        )
	      ),
	      youtubeDataExists && _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        { textAlign: 'center', style: noBottomPadding },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 16 },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Audience Demographics and Regions (last 30 days)',
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'orange' }),
	              content: 'Private data collected from Youtube Insights API'
	            })
	          )
	        )
	      ),
	      youtubeDataExists && _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        { textAlign: 'center' },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 3 },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Viewing by Gender'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'chart-wrapper-print' },
	            _react2.default.createElement(_demographicsGenderGraph2.default, youtubeData)
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Video View Duration'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table,
	            { singleLine: true, basic: 'very', compact: true },
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'Avg. Watch Time:'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                youtubeData && youtubeData.watchTimeMetrics && _react2.default.createElement(
	                  'span',
	                  null,
	                  _moment2.default.utc(youtubeData.watchTimeMetrics.data.averageViewDuration * 1000).format('mm[m] ss[s]')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                'Avg. View Percentage:'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                youtubeData && youtubeData.watchTimeMetrics && _react2.default.createElement(
	                  'span',
	                  null,
	                  _lodash2.default.round(youtubeData.watchTimeMetrics.data.averageViewPercentage),
	                  ' %'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 8 },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Channel demographic by gender / age'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'chart-wrapper-print' },
	            _react2.default.createElement(
	              'div',
	              { className: 'chart-wrapper-print' },
	              _react2.default.createElement(_demographicsAgeGraph2.default, youtubeData)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 5 },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Where are they watching?'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'chart-wrapper-print padding-top-on-print' },
	            _react2.default.createElement(_youtubeDemographicsCountriesTable2.default, youtubeData)
	          ),
	          hasFullEngagementDataLink && _react2.default.createElement(
	            'a',
	            { style: modalLinkStyle, onClick: toggleYoutubeDemographicsModalState },
	            'View full engagement data'
	          )
	        )
	      )
	    ),
	    youtubeDemographicsModalOpen && _react2.default.createElement(
	      _dyzioModal2.default,
	      {
	        headerText: 'Full Channel Engagement Data (last 30 days)',
	        size: 'fullscreen',
	        onClose: toggleYoutubeDemographicsModalState
	      },
	      _react2.default.createElement(_demographicsYoutubeDataTable2.default, youtubeData)
	    )
	  );
	};
	
	YoutubeProfileDataLarge.defaultProps = {
	  hasFullEngagementDataLink: true
	};
	
	exports.default = YoutubeProfileDataLarge;

/***/ },
/* 2573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _numeral = __webpack_require__(152);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllTimeDataTable = function AllTimeDataTable(_ref) {
	  var apiInfluencer = _ref.apiInfluencer,
	      avgComments = _ref.avgComments,
	      isYouTubeCompliance = _ref.isYouTubeCompliance;
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { basic: 'very', fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'videos'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.videoCount)
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'subscribers'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.subscriberCount)
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'views'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.viewCount)
	        )
	      ),
	      !isYouTubeCompliance && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'views per video'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.viewCount / apiInfluencer.aggregateYoutubeChannelStatistics.videoCount)
	        )
	      ),
	      !isYouTubeCompliance && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'comments per video'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(avgComments)
	        )
	      ),
	      !isYouTubeCompliance && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'avg. daily viewing'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.averageDailyViews)
	        )
	      ),
	      !isYouTubeCompliance && _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'avg. monthly viewing'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.averageMonthlyViews)
	        )
	      )
	    )
	  );
	};
	
	var LastThirtyDaysTable = function LastThirtyDaysTable(_ref2) {
	  var thirtyDayData = _ref2.thirtyDayData,
	      percentageChange = _ref2.percentageChange;
	  return _react2.default.createElement(
	    _semanticUiReact.Table,
	    { basic: 'very', fluid: true },
	    _react2.default.createElement(
	      _semanticUiReact.Table.Body,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          '30 day trend'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Label, {
	            basic: true,
	            color: percentageChange > 0 ? 'green' : 'red',
	            content: (0, _numeral2.default)(percentageChange).format('+0.0%')
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'videos'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(thirtyDayData.videoChange)
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'subscribers'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Label, {
	            color: percentageChange > 0 ? 'green' : 'red',
	            basic: true,
	            content: '' + (percentageChange > 0 ? '+' : '') + (0, _formatting.commaFormatted)(thirtyDayData.subscriberChange)
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'views'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(thirtyDayData.viewChange)
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          'avg. daily viewing'
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.commaFormatted)(thirtyDayData.viewChange / thirtyDayData.dayChange)
	        )
	      )
	    )
	  );
	};
	
	var YoutubeDataTabs = function YoutubeDataTabs(_ref3) {
	  var percentageChange = _ref3.percentageChange,
	      apiInfluencer = _ref3.apiInfluencer,
	      avgComments = _ref3.avgComments,
	      isYouTubeCompliance = _ref3.isYouTubeCompliance,
	      thirtyDayData = _ref3.thirtyDayData;
	
	  var panes = [{ menuItem: { content: 'Last 30 days', key: 'last30', icon: 'calendar alternate outline' },
	    render: function render() {
	      return _react2.default.createElement(LastThirtyDaysTable, {
	        thirtyDayData: thirtyDayData,
	        percentageChange: percentageChange
	      });
	    }
	  }, { menuItem: { key: 'alltime', icon: 'history', content: 'All time' },
	    render: function render() {
	      return _react2.default.createElement(AllTimeDataTable, {
	        apiInfluencer: apiInfluencer,
	        avgComments: avgComments,
	        isYouTubeCompliance: isYouTubeCompliance
	      });
	    }
	  }];
	
	  return _react2.default.createElement(_semanticUiReact.Tab, { panes: panes });
	};
	
	YoutubeDataTabs.propTypes = {
	  percentageChange: _propTypes2.default.number.isRequired,
	  apiInfluencer: _propTypes2.default.object.isRequired,
	  avgComments: _propTypes2.default.number.isRequired,
	  isYouTubeCompliance: _propTypes2.default.bool.isRequired,
	  thirtyDayData: _propTypes2.default.object.isRequired
	};
	
	exports.default = YoutubeDataTabs;

/***/ },
/* 2574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(207);
	
	var _numeral = __webpack_require__(152);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactChartjs.defaults.global.defaultFontStyle = 'bold';
	_reactChartjs.defaults.global.defaultFontFamily = '"proxima-nova-soft", "Arial Rounded MT", "Arial", "sans-serif"';
	_reactChartjs.defaults.global.defaultFontSize = 14;
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format('0,0');
	};
	
	var MIN_XAXIS_DAYS = 20;
	
	function getChartdataFromAnalytics(trackedAsset) {
	  var latest = trackedAsset.statistics.slice(-100);
	  var latestViews = latest.map(function (s) {
	    return {
	      x: Date.parse(s.createdDate),
	      y: s.viewCount
	    };
	  });
	  return latestViews;
	}
	
	var dyzioPalette = {
	  pink: '#fc4085',
	  bgPink: '#ffecf3',
	  green: '#20c49e',
	  bgGreen: '#d4faf1',
	  amber: '#fdb02b',
	  bgAmber: '#fff1d5',
	  blue: '#9ad2ff',
	  bgBlue: '#323299'
	};
	
	function getDailyViewingFromAnalytics(trackedAsset) {
	  var latest = trackedAsset.statistics.slice(-100);
	  var dailyViews = [];
	
	  _lodash2.default.forEach(latest, function (dp, idx) {
	    var lastPoint = latest[idx - 1];
	    // only include the data point if it's a days difference.
	    if (lastPoint) {
	      var d1 = (0, _moment2.default)(dp.createdDate);
	      var d0 = (0, _moment2.default)(lastPoint.createdDate);
	      var hoursDelta = _moment2.default.duration(d1.diff(d0)).asHours();
	      if (hoursDelta > 20 && hoursDelta < 30) {
	        var delta = lastPoint ? dp.viewCount - lastPoint.viewCount : 0;
	        dailyViews.push({
	          x: Date.parse(dp.createdDate),
	          y: delta
	        });
	      }
	    }
	  });
	
	  return dailyViews;
	}
	
	var getXAxisMin = function getXAxisMin(trackedAsset) {
	  var firstStat = trackedAsset.statistics[0];
	  console.log(firstStat.createdDate);
	  var d1 = _moment2.default.utc(firstStat.createdDate);
	  console.log('d1: ' + d1);
	  console.log(d1.format('YYYY-MM-DD'));
	  var d2 = _moment2.default.utc();
	  console.log('d2: ' + d2);
	  console.log(d2);
	  console.log(d2.format('YYYY-MM-DD'));
	
	  var min = d2.subtract(MIN_XAXIS_DAYS, 'days');
	
	  var daysDelta = _moment2.default.duration(d2.diff(d1)).asHours();
	  console.log('DD: ' + daysDelta);
	  if (daysDelta > MIN_XAXIS_DAYS) {
	    console.log('blah');
	    min = d1;
	  }
	
	  return min;
	};
	
	var AnalyticsChart = function AnalyticsChart(_ref) {
	  var trackedAsset = _ref.trackedAsset;
	
	  if (!trackedAsset || !trackedAsset.statistics) return null;
	  var analyticsData = getChartdataFromAnalytics(trackedAsset);
	  var data = {
	    datasets: [{
	      fill: false,
	      type: 'line',
	      fillColor: 'rgba(38,228,184,0.05)',
	      backgroundColor: 'rgba(38,228,184,0.05)',
	      borderColor: 'rgba(38,228,184,1)',
	      pointBorderColor: 'rgba(38,228,184,1)',
	      pointBackgroundColor: '#fff',
	      pointHoverBackgroundColor: 'rgba(38,228,184,1)',
	      pointHoverBorderColor: 'rgba(38,228,184,1)',
	      label: 'Total Views (left axis)',
	      data: analyticsData,
	      yAxisID: 'y-axis-1'
	    }, {
	      type: 'bar',
	      label: 'Daily Views (right axis)',
	      fillColor: dyzioPalette.bgPink,
	      backgroundColor: dyzioPalette.bgPink,
	      borderColor: dyzioPalette.pink,
	      data: getDailyViewingFromAnalytics(trackedAsset),
	      borderWidth: 1,
	      yAxisID: 'y-axis-2'
	    }]
	  };
	
	  var chartOptions = {
	    responsive: true,
	    maintainAspectRatio: true,
	    tooltips: {
	      mode: 'index',
	      intersect: false,
	      callbacks: {
	        title: function title(tooltipItems) {
	          return '' + (0, _moment2.default)(tooltipItems[0].xLabel).format('ddd DD MMM hh:mm');
	        },
	        label: function label(tooltipItem) {
	          var desc = tooltipItem.datasetIndex === 0 ? 'Total Views' : 'Daily Views';
	          return cf(tooltipItem.yLabel) + ' ' + desc;
	        }
	      }
	    },
	    title: {
	      display: false,
	      text: 'Total Viewing',
	      padding: 10,
	      fontSize: 18
	    },
	    legend: {
	      display: true
	    },
	    elements: {
	      line: {
	        tension: 0
	      }
	    },
	    layout: {
	      padding: 20,
	      fullWidth: false
	    },
	    hover: {
	      mode: 'nearest',
	      intersect: true
	    },
	    scales: {
	      xAxes: [{
	        type: 'time',
	        ticks: {
	          maxRotation: 0,
	          autoSkip: true,
	          maxTicksLimit: 5
	          // callback: function(value) {
	          //     return (new Date(value).getDate() % 5 == 0) ? value : null;
	          // },
	        },
	        time: {
	          displayFormats: {
	            day: 'ddd DD MMM'
	          },
	          min: getXAxisMin(trackedAsset),
	          max: (0, _moment2.default)().add(1, 'days')
	        }
	      }],
	      yAxes: [{
	        type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
	        display: true,
	        position: 'left',
	        title: {
	          text: 'Total Viewing'
	        },
	        id: 'y-axis-1'
	      }, {
	        type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
	        display: true,
	        position: 'right',
	
	        id: 'y-axis-2',
	        // grid line settings
	        gridLines: {
	          drawOnChartArea: false // only want the grid lines for one axis to show up
	        }
	      }]
	    }
	  };
	
	  // scales: {
	  //   yAxes: [{
	  //     type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
	  //     display: true,
	  //     position: 'left',
	  //     id: 'y-axis-1',
	  //   }, {
	  //     type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
	  //     display: true,
	  //     position: 'right',
	  //     id: 'y-axis-2',
	  //     // grid line settings
	  //     gridLines: {
	  //       drawOnChartArea: false, // only want the grid lines for one axis to show up
	  //     },
	  //   }],
	  // }
	
	  return _react2.default.createElement(_reactChartjs.Bar, { data: data, options: chartOptions });
	};
	
	exports.default = AnalyticsChart;

/***/ },
/* 2575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _numeral = __webpack_require__(152);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _reactChartjs = __webpack_require__(207);
	
	var _reactPlayer = __webpack_require__(410);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _chart = __webpack_require__(2574);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cf = function cf(num) {
	  return (0, _numeral2.default)(num).format(0, 0);
	};
	
	var displayBlock = {
	  display: 'block'
	};
	
	var barOptions = {
	  tooltips: {
	    mode: 'index',
	    intersect: false
	  },
	  responsive: true,
	  showScale: false,
	  scales: {
	    xAxes: [{
	      stacked: true
	    }],
	    yAxes: [{
	      stacked: true
	    }]
	  }
	};
	
	var youtubeVideoStyle = {
	  maxWidth: '640px'
	};
	
	var getTimeStamp = function getTimeStamp(post) {
	  return (0, _moment2.default)(post.latestStatistic.createdDate).format('MMMM Do YYYY, h:mm:ss a');
	};
	
	var YoutubeWatchingStats = function YoutubeWatchingStats(_ref) {
	  var mainData = _ref.mainData,
	      heroPost = _ref.heroPost;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true, color: 'red' },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Message,
	        { icon: true },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', color: 'red' }),
	        _react2.default.createElement(
	          _semanticUiReact.Message.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Message.Header,
	            null,
	            mainData.title
	          ),
	          mainData.subTitle
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { computer: 10, mobile: 16 },
	            _react2.default.createElement(_reactPlayer2.default, { width: '100%', url: mainData.videoUrl, controls: true, style: youtubeVideoStyle })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { computer: 6, mobile: 16, textAlign: 'center' },
	            _react2.default.createElement(
	              'div',
	              null,
	              '\xA0',
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                { color: 'pink', size: 'small', style: displayBlock },
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  null,
	                  cf(mainData.views)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play' }),
	                  'views'
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                { color: 'pink', size: 'small', style: displayBlock },
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  null,
	                  cf(mainData.engagements)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'like' }),
	                  'engagements'
	                )
	              ),
	              '\xA0',
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                { color: 'pink', size: 'small', style: displayBlock },
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  null,
	                  cf(mainData.watchTimeUKIre)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock' }),
	                  'watch time UK/Ire (mins)'
	                )
	              ),
	              '\xA0',
	              _react2.default.createElement(
	                _semanticUiReact.Statistic,
	                { color: 'pink', size: 'small', style: displayBlock },
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Value,
	                  null,
	                  cf(mainData.watchTimeTotal)
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic.Label,
	                  null,
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock' }),
	                  'watch time total (mins)'
	                )
	              ),
	              '\xA0'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { computer: 4, mobile: 16 },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Who\'s watching? (views by gender)'
	            ),
	            _react2.default.createElement(_reactChartjs.Doughnut, { data: mainData.donutData })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { computer: 6, mobile: 16 },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Who\u2019s watching? (avg. watch time by age/gender)'
	            ),
	            _react2.default.createElement(_reactChartjs.HorizontalBar, { data: mainData.barData, options: barOptions })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { computer: 6, mobile: 16, verticalAlign: 'middle' },
	            _react2.default.createElement(
	              'h4',
	              { style: { marginTop: '20px', marginBottom: '5px' } },
	              'Where are they watching?'
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table,
	              { celled: true, stackable: true, fluid: true, size: 'small', basic: 'very', textAlign: 'center' },
	              _react2.default.createElement(
	                _semanticUiReact.Table.Header,
	                null,
	                _react2.default.createElement(
	                  _semanticUiReact.Table.Row,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'country'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'watch time'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'views'
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Table.HeaderCell,
	                    null,
	                    'likes'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Body,
	                null,
	                _lodash2.default.map(mainData.viewingData, function (d) {
	                  return _react2.default.createElement(
	                    _semanticUiReact.Table.Row,
	                    null,
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      d.name
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      cf(d.watchTime * (mainData.scaleFactor || 1))
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      cf(d.views * (mainData.scaleFactor || 1))
	                    ),
	                    _react2.default.createElement(
	                      _semanticUiReact.Table.Cell,
	                      null,
	                      cf(d.likes * (mainData.scaleFactor || 1))
	                    )
	                  );
	                })
	              )
	            ),
	            '\xA0'
	          )
	        )
	      )
	    ),
	    heroPost && _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { textAlign: 'center' },
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Total and Daily Viewing over time'
	      ),
	      _react2.default.createElement(_chart2.default, { trackedAsset: heroPost }),
	      _react2.default.createElement(_semanticUiReact.Label, {
	        centered: true,
	        icon: 'clock',
	        color: 'grey',
	        basic: true,
	        content: 'data collected ' + getTimeStamp(heroPost)
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { extra: true },
	      'youtube engagements are calculated as likes + comments + shares'
	    )
	  );
	};
	
	exports.default = YoutubeWatchingStats;

/***/ },
/* 2576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ASCENDING = 'ascending';
	var DESCENDING = 'descending';
	
	var BasicReportHeader = function BasicReportHeader(props) {
	  var onOrderChanged = props.onOrderChanged,
	      order = props.order,
	      withDeleteButton = props.withDeleteButton;
	
	
	  var isPlatformSort = order.field === 'platform';
	  var isInfluencerSort = order.field === 'influencer';
	  var isViewsSort = order.field === 'views';
	  var isThumbsUpSort = order.field === 'thumbsUp';
	  var isCommentsSort = order.field === 'comments';
	  var isShareSort = order.field === 'shares';
	
	  var isASC = order.value === ASCENDING;
	  var sortedValue = isASC ? ASCENDING : DESCENDING;
	  var clickValue = isASC ? DESCENDING : ASCENDING;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      {
	        width: 1,
	        sorted: isPlatformSort && sortedValue,
	        onClick: function onClick() {
	          return onOrderChanged('platform', clickValue);
	        }
	      },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          'channel'
	        ),
	        content: 'sort by platform'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { width: 1 },
	      _react2.default.createElement(
	        'span',
	        null,
	        'image'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      {
	        width: 4,
	        sorted: isInfluencerSort && sortedValue,
	        onClick: function onClick() {
	          return onOrderChanged('influencer', clickValue);
	        }
	      },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          'influencer - asset'
	        ),
	        content: 'sort by influencer'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { width: 1 },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'external', color: 'grey' }),
	        content: 'view detailed post performance data (or the live post)'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { width: 1 },
	      _react2.default.createElement(
	        'span',
	        null,
	        'source'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      {
	        width: 1,
	        sorted: isViewsSort && sortedValue,
	        onClick: function onClick() {
	          return onOrderChanged('views', clickValue);
	        }
	      },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          'views'
	        ),
	        content: 'sort by views'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { width: 1 },
	      _react2.default.createElement(
	        'span',
	        null,
	        'reach'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { width: 1 },
	      _react2.default.createElement(
	        'span',
	        null,
	        'impressions'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      {
	        width: 1,
	        sorted: isThumbsUpSort && sortedValue,
	        onClick: function onClick() {
	          return onOrderChanged('thumbsUp', clickValue);
	        }
	      },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          'likes'
	        ),
	        content: 'sort by number of likes'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      {
	        width: 1,
	        sorted: isCommentsSort && sortedValue,
	        onClick: function onClick() {
	          return onOrderChanged('comments', clickValue);
	        }
	      },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          'comments'
	        ),
	        content: 'sort by number of comments'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      {
	        sorted: isShareSort && sortedValue,
	        onClick: function onClick() {
	          return onOrderChanged('shares', clickValue);
	        },
	        width: 1
	      },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          'shares'
	        ),
	        content: 'sort by number of retweets or shares'
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { width: 1 },
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'grey' }),
	          '#ad?'
	        ),
	        content: 'This confirms that the post includes #ad, #spon, #partner'
	      })
	    ),
	    withDeleteButton && _react2.default.createElement(
	      _semanticUiReact.Table.HeaderCell,
	      { width: 1 },
	      _react2.default.createElement(
	        'span',
	        null,
	        'remove'
	      )
	    )
	  );
	};
	
	BasicReportHeader.propTypes = {
	  onOrderChanged: _propTypes2.default.func.isRequired,
	  order: _propTypes2.default.object.isRequired,
	  withDeleteButton: _propTypes2.default.bool.isRequired
	};
	
	BasicReportHeader.defaultProps = {
	  withDeleteButton: false
	};
	
	exports.default = BasicReportHeader;

/***/ },
/* 2577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _imageComponent = __webpack_require__(967);
	
	var _imageComponent2 = _interopRequireDefault(_imageComponent);
	
	var _formatting = __webpack_require__(52);
	
	var _assets = __webpack_require__(243);
	
	var _style = __webpack_require__(2580);
	
	var _supporingDataModal = __webpack_require__(2568);
	
	var _supporingDataModal2 = _interopRequireDefault(_supporingDataModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ManualDataComponent = function ManualDataComponent(_ref) {
	  var asset = _ref.asset,
	      deleteCallback = _ref.deleteCallback;
	
	  var supportingData = _lodash2.default.get(asset, 'supportingData', []);
	  var isTelegram = asset.assetURL && asset.assetURL.match(/\/\/t.me\//i);
	  var impressions = (0, _assets.getSupportingDataField)(supportingData, 'impressions', null);
	  var reach = (0, _assets.getSupportingDataField)(supportingData, 'reach', null);
	  var views = (0, _assets.getSupportingDataField)(supportingData, 'views', null);
	  var likes = (0, _assets.getSupportingDataField)(supportingData, 'likes', null);
	  var shares = (0, _assets.getSupportingDataField)(supportingData, 'shares', null);
	  var comments = (0, _assets.getSupportingDataField)(supportingData, 'comments', null);
	  var icon = (0, _assets.resolvePlatformIcon)(asset.platform);
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'div',
	          null,
	          isTelegram ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram plane', color: 'blue', size: 'large' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: icon.name, color: icon.color }),
	          _lodash2.default.get(asset, 'assetType') === 'VIDEO' && _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', color: icon.color }),
	          _lodash2.default.get(asset, 'assetType') === 'IMAGE' && _react2.default.createElement(_semanticUiReact.Icon, { name: 'image', color: icon.color }),
	          _react2.default.createElement(
	            'p',
	            { style: _style.smallFont },
	            (0, _formatting.formatAssetPublishedData)(asset)
	          )
	        ),
	        content: (0, _formatting.getAssetPublishedDateMessage)(asset)
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_imageComponent2.default, { post: asset })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'left' },
	      _react2.default.createElement(
	        _semanticUiReact.Header,
	        { as: 'h5' },
	        _react2.default.createElement(
	          _semanticUiReact.Header.Content,
	          { style: _style.ellipsisWrapper },
	          _lodash2.default.get(asset, 'discussionName'),
	          _react2.default.createElement(
	            _semanticUiReact.Header.Subheader,
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: _style.ellipsisWrapper },
	              _lodash2.default.get(asset, 'extraData.text') || '(uncaptioned)'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_supporingDataModal2.default, { asset: asset })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(
	        'b',
	        { style: _style.dyzioGreen },
	        'Manual'
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      views ? (0, _formatting.sciFormatted)(views) : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      reach ? (0, _formatting.sciFormatted)(reach) : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      impressions ? (0, _formatting.sciFormatted)(impressions) : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      likes ? (0, _formatting.sciFormatted)(likes) : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      comments ? (0, _formatting.sciFormatted)(comments) : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      shares ? (0, _formatting.sciFormatted)(shares) : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      '-'
	    ),
	    deleteCallback && _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      '-'
	    )
	  );
	};
	
	ManualDataComponent.propTypes = {
	  asset: _propTypes2.default.object.isRequired
	};
	
	exports.default = ManualDataComponent;

/***/ },
/* 2578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _notAvailableComponent = __webpack_require__(242);
	
	var _notAvailableComponent2 = _interopRequireDefault(_notAvailableComponent);
	
	var _asaCompliance = __webpack_require__(601);
	
	var _asaCompliance2 = _interopRequireDefault(_asaCompliance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ellipsisStyle = {
	  maxWidth: '95%',
	  textOverflow: 'ellipsis',
	  display: 'block',
	  overflow: 'hidden'
	};
	
	var ellipsisWrapper = {
	  width: '100%'
	};
	
	var AssetComponent = function AssetComponent(_ref) {
	  var post = _ref.post,
	      viewMode = _ref.viewMode;
	
	  var discussionName = _lodash2.default.get(post, 'trackedAsset.discussionName');
	  return _react2.default.createElement(
	    _semanticUiReact.Header,
	    { as: 'h5' },
	    _react2.default.createElement(
	      _semanticUiReact.Header.Content,
	      { style: ellipsisWrapper },
	      discussionName || post.channelTitle || post.influencerName || post.twitterHandle || post.instagramHandle,
	      _react2.default.createElement(
	        _semanticUiReact.Header.Subheader,
	        null,
	        _react2.default.createElement(
	          'span',
	          { style: ellipsisStyle },
	          post.title || post.text
	        )
	      )
	    )
	  );
	};
	
	var PaidPartnershipComponent = function PaidPartnershipComponent(_ref2) {
	  var sponsor = _ref2.sponsor;
	
	  var sponsorName = sponsor.name || sponsor.username;
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Label, { icon: 'checkmark', basic: true, color: 'green', content: 'PP' }),
	    content: 'Paid partnership with ' + sponsorName
	  });
	};
	
	var AdWrapper = function AdWrapper(_ref3) {
	  var post = _ref3.post;
	
	  if (post.trackedAsset.assetType === 'STORY') {
	    return _react2.default.createElement(_notAvailableComponent2.default, { metricName: '#ad', platform: post.trackedAsset.platform, assetType: 'post' });
	  }
	  if (post.sponsor) {
	    return _react2.default.createElement(PaidPartnershipComponent, { sponsor: post.sponsor });
	  }
	  return _react2.default.createElement(_asaCompliance2.default, { text: post.text });
	};
	
	var DeleteButton = function DeleteButton(props) {
	  return _react2.default.createElement(_semanticUiReact.Button, { value: props.value, onClick: props.handler, circular: true, compact: true, icon: 'delete' });
	};
	
	module.exports = {
	  AdWrapper: AdWrapper,
	  AssetComponent: AssetComponent,
	  DeleteButton: DeleteButton
	};

/***/ },
/* 2579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _instagramStoryReport = __webpack_require__(2564);
	
	var _instagramStoryReport2 = _interopRequireDefault(_instagramStoryReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storyImageStyle = {
	  width: 60,
	  height: 40,
	  objectFit: 'cover',
	  cursor: 'pointer'
	};
	
	var cursorPointer = {
	  cursor: 'pointer',
	  color: '#20c49e'
	};
	
	var smallFont = {
	  fontSize: '60%',
	  color: 'grey'
	};
	
	var StoryImageModalComponent = function StoryImageModalComponent(_ref) {
	  var story = _ref.story;
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      trigger: _react2.default.createElement(_semanticUiReact.Image, {
	        centered: true,
	        style: storyImageStyle,
	        src: story.attributes.savedThumbnailUrl
	      })
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Header,
	      null,
	      'Story Performance'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      _react2.default.createElement(_instagramStoryReport2.default, { story: story })
	    )
	  );
	};
	
	var StoryIconModalComponent = function StoryIconModalComponent(_ref2) {
	  var story = _ref2.story,
	      _ref2$inManualStoryMo = _ref2.inManualStoryMode,
	      inManualStoryMode = _ref2$inManualStoryMo === undefined ? false : _ref2$inManualStoryMo;
	  return _react2.default.createElement(
	    _semanticUiReact.Modal,
	    {
	      trigger: _react2.default.createElement(
	        'div',
	        { style: cursorPointer },
	        _react2.default.createElement(_semanticUiReact.Icon, {
	          title: 'view full story performance data (including media)',
	          name: 'expand'
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: smallFont },
	          'view...'
	        )
	      )
	    },
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Header,
	      null,
	      'Story Performance'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Modal.Content,
	      null,
	      _react2.default.createElement(_instagramStoryReport2.default, { story: story, inManualStoryMode: inManualStoryMode })
	    )
	  );
	};
	
	module.exports = {
	  StoryIconModalComponent: StoryIconModalComponent,
	  StoryImageModalComponent: StoryImageModalComponent
	};

/***/ },
/* 2580 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var dyzioGreen = exports.dyzioGreen = {
	  color: '#20c49e'
	};
	
	var smallFont = exports.smallFont = {
	  fontSize: '60%',
	  color: 'grey'
	};
	
	var ellipsisWrapper = exports.ellipsisWrapper = {
	  width: '100%'
	};

/***/ },
/* 2581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TiktokRow = exports.TelegramRow = exports.getPublishedMessage = exports.getAssetType = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _asaCompliance = __webpack_require__(601);
	
	var _asaCompliance2 = _interopRequireDefault(_asaCompliance);
	
	var _instagramIcon = __webpack_require__(968);
	
	var _instagramIcon2 = _interopRequireDefault(_instagramIcon);
	
	var _formatting = __webpack_require__(52);
	
	var _facebookPostType = __webpack_require__(2588);
	
	var _facebookPostType2 = _interopRequireDefault(_facebookPostType);
	
	var _twitterPostType = __webpack_require__(2597);
	
	var _twitterPostType2 = _interopRequireDefault(_twitterPostType);
	
	var _reachComponent = __webpack_require__(2594);
	
	var _reachComponent2 = _interopRequireDefault(_reachComponent);
	
	var _youtubeModalComponent = __webpack_require__(2571);
	
	var _youtubeModalComponent2 = _interopRequireDefault(_youtubeModalComponent);
	
	var _sourceComponent = __webpack_require__(2596);
	
	var _sourceComponent2 = _interopRequireDefault(_sourceComponent);
	
	var _sharesComponent = __webpack_require__(2595);
	
	var _sharesComponent2 = _interopRequireDefault(_sharesComponent);
	
	var _impressionsComponent = __webpack_require__(2590);
	
	var _impressionsComponent2 = _interopRequireDefault(_impressionsComponent);
	
	var _notAvailableComponent = __webpack_require__(242);
	
	var _notAvailableComponent2 = _interopRequireDefault(_notAvailableComponent);
	
	var _privateDataComponent = __webpack_require__(379);
	
	var _privateDataComponent2 = _interopRequireDefault(_privateDataComponent);
	
	var _imageComponent = __webpack_require__(967);
	
	var _imageComponent2 = _interopRequireDefault(_imageComponent);
	
	var _manualDataComponent = __webpack_require__(2577);
	
	var _manualDataComponent2 = _interopRequireDefault(_manualDataComponent);
	
	var _storyComponents = __webpack_require__(2579);
	
	var _rowComponents = __webpack_require__(2578);
	
	var _dyzioIcons = __webpack_require__(597);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CAPTION_LENGTH = 50;
	
	var dyzioGreen = {
	  color: '#20c49e'
	};
	
	var fromNow = function fromNow(date) {
	  return (0, _moment2.default)(date).fromNow();
	};
	var smallFont = {
	  fontSize: '60%',
	  color: 'grey'
	};
	
	var ellipsisWrapper = {
	  width: '100%'
	};
	
	var df = function df(post) {
	  return (0, _moment2.default)(post.trackedAsset && post.trackedAsset.publishedDate ? post.trackedAsset.publishedDate : post.publishedDate).format('YYYY-MM-DD');
	};
	
	var getAssetType = exports.getAssetType = function getAssetType(post) {
	  if (post.isIGTV) return 'IGTV';
	  if (post.isReel) return 'REEL';
	  if (post.isVideo) return 'video';
	  if (post.isCarousel || _lodash2.default.get(post, 'trackedAsset.assetType', '') === 'CAROUSEL') return 'carousel';
	  if (post.type === 'stories' || post.isStory || _lodash2.default.get(post, 'trackedAsset.assetType', '') === 'STORY') return 'story';
	
	  return 'image';
	};
	
	var getPublishedMessage = exports.getPublishedMessage = function getPublishedMessage(post) {
	  var platform = post.trackedAsset ? post.trackedAsset.platform : 'Instagram';
	  var assetType = getAssetType(post);
	  var date = post.trackedAsset ? post.trackedAsset.publishedDate : post.publishedDate;
	
	  if (post.tweetId) {
	    console.log(post);
	    var tweetMedia = _lodash2.default.get(post, 'entities.media') || [];
	    var mainTweetMedia = _lodash2.default.head(tweetMedia);
	    var mediaUrl = _lodash2.default.get(mainTweetMedia, 'expanded_url');
	
	    console.log(mediaUrl);
	
	    assetType = 'post';
	
	    if (_lodash2.default.includes(mediaUrl, 'video')) {
	      assetType = 'video';
	    }
	    if (_lodash2.default.includes(mediaUrl, 'photo')) {
	      assetType = 'photo';
	    }
	  }
	
	  return '\n   ' + _lodash2.default.capitalize(platform) + ' ' + assetType + ' posted at ' + (0, _moment2.default)(date).format('LT') + ' on ' + df(post);
	};
	
	var TelegramRow = exports.TelegramRow = function TelegramRow(_ref) {
	  var post = _ref.post,
	      deleteCallback = _ref.deleteCallback;
	  var initialData = post.initialData,
	      telegramData = post.telegramData;
	
	  var latestTelegramData = _lodash2.default.last(_lodash2.default.sortBy(telegramData, 'createdDate')) || initialData;
	  var publishedDate = (0, _moment2.default)(post.publishedDate).format('YYYY-MM-DD');
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram', color: 'blue' }),
	          _react2.default.createElement(
	            'p',
	            { style: smallFont },
	            publishedDate
	          )
	        ),
	        content: 'TELEGRAM posted at ' + (0, _moment2.default)(post.publishedDate).format('LT') + ' on ' + publishedDate
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_imageComponent2.default, { post: post })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'left' },
	      _react2.default.createElement(
	        _semanticUiReact.Header,
	        { as: 'h5' },
	        _react2.default.createElement(
	          _semanticUiReact.Header.Content,
	          { style: ellipsisWrapper },
	          post.discussionName,
	          _react2.default.createElement(
	            _semanticUiReact.Header.Subheader,
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: ellipsisWrapper },
	              initialData.text || '(uncaptioned)'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: dyzioGreen },
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          content: 'view post on Telegram',
	          trigger: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                target: '_blank',
	                rel: 'noopener noreferrer',
	                href: post.assetURL,
	                style: dyzioGreen
	              },
	              _react2.default.createElement(_semanticUiReact.Icon, {
	                name: 'external'
	              }),
	              _react2.default.createElement(
	                'div',
	                { style: smallFont },
	                'view...'
	              )
	            )
	          )
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        hoverable: true,
	        trigger: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: dyzioGreen },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlock alternate' }),
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'feed' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: smallFont },
	            fromNow(latestTelegramData.createdDate)
	          )
	        ),
	        content: 'Public data collected from the TELEGRAM API ' + fromNow(latestTelegramData.createdDate)
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'video views', platform: 'Telegram', assetType: 'post' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.sciFormatted)(latestTelegramData.views)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'impression', platform: 'Telegram', assetType: 'post' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'likes', platform: 'Telegram', assetType: 'post' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      latestTelegramData.replies ? (0, _formatting.sciFormatted)(latestTelegramData.replies.replies) : '-'
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.sciFormatted)(latestTelegramData.forwards)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_notAvailableComponent2.default, { metricName: '#ad', platform: 'Telegram', assetType: 'post' })
	    ),
	    deleteCallback && _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'grey' }),
	        content: 'Cannot delete a telegram'
	      })
	    )
	  );
	};
	
	var TiktokRow = exports.TiktokRow = function TiktokRow(_ref2) {
	  var post = _ref2.post,
	      deleteCallback = _ref2.deleteCallback,
	      inGIMode = _ref2.inGIMode;
	  var initialData = post.initialData,
	      tiktokData = post.tiktokData;
	
	  var user = _lodash2.default.get(initialData, 'authorMeta.name.uniqueId') ? _lodash2.default.get(initialData, 'authorMeta.name') : _lodash2.default.get(initialData, 'authorMeta') || _lodash2.default.get(initialData, 'author');
	  var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
	  var publishedDate = (0, _moment2.default)(post.publishedDate).format('YYYY-MM-DD');
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_dyzioIcons.TiktokIcon, null),
	          _react2.default.createElement(
	            'p',
	            { style: smallFont },
	            publishedDate
	          )
	        ),
	        content: 'TIKTOK posted at ' + (0, _moment2.default)(post.publishedDate).format('LT') + ' on ' + publishedDate
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_imageComponent2.default, { post: post })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'left' },
	      _react2.default.createElement(
	        _semanticUiReact.Header,
	        { as: 'h5' },
	        _react2.default.createElement(
	          _semanticUiReact.Header.Content,
	          { style: ellipsisWrapper },
	          user.nickName || user.uniqueId,
	          ' (',
	          user.name || user.nickname,
	          ')',
	          _react2.default.createElement(
	            _semanticUiReact.Header.Subheader,
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: ellipsisWrapper },
	              initialData.text || initialData.desc || '(uncaptioned)'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: dyzioGreen },
	        _react2.default.createElement(_semanticUiReact.Popup, {
	          content: 'view post on Tiktok',
	          trigger: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                target: '_blank',
	                rel: 'noopener noreferrer',
	                href: post.assetURL,
	                style: dyzioGreen
	              },
	              _react2.default.createElement(_semanticUiReact.Icon, {
	                name: 'external'
	              }),
	              _react2.default.createElement(
	                'div',
	                { style: smallFont },
	                'view...'
	              )
	            )
	          )
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        hoverable: true,
	        trigger: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: dyzioGreen },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlock alternate' }),
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'feed' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: smallFont },
	            fromNow(latestTiktokData.createdDate)
	          )
	        ),
	        content: 'Public data collected from the Tiktok API ' + fromNow(latestTiktokData.createdDate)
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      inGIMode && _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'impression', platform: 'Tiktok', assetType: 'post' }),
	      !inGIMode && (0, _formatting.sciFormatted)(latestTiktokData.playCount)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'reach', platform: 'Tiktok', assetType: 'post' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      !inGIMode && _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'impression', platform: 'Tiktok', assetType: 'post' }),
	      inGIMode && (0, _formatting.sciFormatted)(latestTiktokData.playCount)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.sciFormatted)(latestTiktokData.diggCount)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.sciFormatted)(latestTiktokData.commentCount)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.sciFormatted)(latestTiktokData.shareCount)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_notAvailableComponent2.default, { metricName: '#ad', platform: 'Tiktok', assetType: 'post' })
	    ),
	    deleteCallback && _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'grey' }),
	        content: 'Cannot delete a tiktok'
	      })
	    )
	  );
	};
	
	var StoryRow = function StoryRow(_ref3) {
	  var story = _ref3.story,
	      deleteCallback = _ref3.deleteCallback;
	  var storyData = story.attributes.storyData;
	  var data = story.relationships.supportingData.data;
	
	  var latestSupportingData = _lodash2.default.last(data) || {};
	  var isVideo = _lodash2.default.get(story, 'attributes.assetType') === 'VIDEO';
	  var latestData = _lodash2.default.last(storyData);
	  var views = _lodash2.default.get(latestSupportingData, 'attributes.views') || _lodash2.default.get(latestData, 'views') || _lodash2.default.get(latestData, 'impressions', 0);
	  var atts = story.attributes;
	  var truncatedCaption = _lodash2.default.truncate(atts.caption, { length: CAPTION_LENGTH });
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Icon.Group,
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
	              _react2.default.createElement(_semanticUiReact.Icon, { corner: true, name: 'circle outline', color: 'pink' })
	            ),
	            _react2.default.createElement(_semanticUiReact.Icon, { name: isVideo ? 'video play' : 'image', color: 'pink' })
	          ),
	          atts.status === 'LIVE' ? _react2.default.createElement(
	            'p',
	            { style: { fontSize: '80%', color: '#20c49e' } },
	            atts.status
	          ) : _react2.default.createElement(
	            'p',
	            { style: smallFont },
	            df(story)
	          )
	        ),
	        content: getPublishedMessage(story)
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_storyComponents.StoryImageModalComponent, { story: story })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'left' },
	      _react2.default.createElement(
	        _semanticUiReact.Header,
	        { as: 'h5' },
	        _react2.default.createElement(
	          _semanticUiReact.Header.Content,
	          { style: ellipsisWrapper },
	          atts.username,
	          _react2.default.createElement(
	            _semanticUiReact.Header.Subheader,
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: ellipsisWrapper },
	              truncatedCaption || '(uncaptioned)'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: dyzioGreen },
	        _react2.default.createElement(_storyComponents.StoryIconModalComponent, { story: story })
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        hoverable: true,
	        trigger: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: dyzioGreen },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlock alternate' }),
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'feed' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: smallFont },
	            fromNow(latestData.createdDate)
	          )
	        ),
	        content: 'Authorised data collected from the Instagram API ' + fromNow(latestData.createdDate)
	      })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      isVideo ? (0, _formatting.sciFormatted)(views) : _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'views', platform: 'Instagram', assetType: 'Story' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.sciFormatted)(_lodash2.default.get(latestSupportingData, 'attributes.reach') || latestData.reach)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.sciFormatted)(_lodash2.default.get(latestSupportingData, 'attributes.impressions') || latestData.impressions)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'likes', platform: 'Instagram', assetType: 'Story' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'comments', platform: 'Instagram', assetType: 'Story' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'shares', platform: 'Instagram', assetType: 'Story' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_asaCompliance2.default, { text: atts.caption })
	    ),
	    deleteCallback && _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'ban', color: 'grey' }),
	        content: 'Cannot delete a story'
	      })
	    )
	  );
	};
	
	var BasicReportRow = function BasicReportRow(props) {
	  var post = props.post,
	      viewMode = props.viewMode,
	      deleteCallback = props.deleteCallback;
	
	  if (post && (post.platform === 'VK' || post.platform === 'BLOG' || post.platform === 'SNAPCHAT')) {
	    return _react2.default.createElement(_manualDataComponent2.default, { asset: post, deleteCallback: deleteCallback });
	  }
	  if (post && post.platform === 'TIKTOK') {
	    return _react2.default.createElement(TiktokRow, { post: post, deleteCallback: deleteCallback });
	  }
	  if (post && post.platform === 'TELEGRAM' && post.initialData) {
	    return _react2.default.createElement(TelegramRow, { post: post, deleteCallback: deleteCallback });
	  }
	  if (post && post.type === 'stories') {
	    return _react2.default.createElement(StoryRow, { story: post, deleteCallback: deleteCallback });
	  }
	  switch (post.trackedAsset.platform) {
	    case 'TWITTER':
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Popup, {
	            trigger: _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter', color: 'blue' }),
	              _react2.default.createElement(_twitterPostType2.default, { asset: post }),
	              _react2.default.createElement(
	                'p',
	                { style: smallFont },
	                df(post)
	              )
	            ),
	            content: getPublishedMessage(post)
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_imageComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { textAlign: 'left' },
	          _react2.default.createElement(_rowComponents.AssetComponent, { post: post, viewMode: viewMode })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: dyzioGreen },
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              content: 'view tweet on twitter',
	              trigger: _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: post.trackedAsset.assetURL,
	                    style: dyzioGreen
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, {
	                    name: 'external'
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { style: smallFont },
	                    'view...'
	                  )
	                )
	              )
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_sourceComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'views', platform: post.trackedAsset.platform, assetType: 'tweet' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_reachComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_impressionsComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.sciFormatted)(post.latestStatistic.favoriteCount)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.sciFormatted)(post.latestStatistic.commentCount)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.sciFormatted)(post.latestStatistic.retweetCount)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_asaCompliance2.default, { text: post.text })
	        ),
	        deleteCallback && _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_rowComponents.DeleteButton, { value: post.trackedAsset.id, handler: deleteCallback })
	        )
	      );
	    case 'FACEBOOK':
	      var latestInsights = post.latestInsights;
	
	      var views = latestInsights ? latestInsights.totalVideoViews : post.latestStatistic.viewCount;
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Popup, {
	            trigger: _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', color: 'blue' }),
	              _react2.default.createElement(_facebookPostType2.default, { asset: post }),
	              _react2.default.createElement(
	                'p',
	                { style: smallFont },
	                df(post)
	              )
	            ),
	            content: getPublishedMessage(post)
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_imageComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { textAlign: 'left' },
	          _react2.default.createElement(_rowComponents.AssetComponent, { post: post, viewMode: viewMode })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: dyzioGreen },
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              content: 'view post on facebook',
	              trigger: _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: post.trackedAsset.assetURL,
	                    style: dyzioGreen
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, {
	                    name: 'external'
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { style: smallFont },
	                    'view...'
	                  )
	                )
	              )
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_sourceComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          post.postType === 'post' || post.postType === 'photo' ? _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'views', platform: post.trackedAsset.platform, assetType: post.postType }) : _react2.default.createElement(
	            'span',
	            null,
	            (0, _formatting.sciFormatted)(views)
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_reachComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_impressionsComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.sciFormatted)(post.latestStatistic.likeCount)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.sciFormatted)(post.latestStatistic.commentCount)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_sharesComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_asaCompliance2.default, { text: post.text })
	        ),
	        deleteCallback && _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_rowComponents.DeleteButton, { value: post.trackedAsset.id, handler: deleteCallback })
	        )
	      );
	    case 'YOUTUBE':
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Popup, {
	            trigger: _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                { style: smallFont },
	                _react2.default.createElement(
	                  'strong',
	                  { style: { color: 'red' } },
	                  'YOUTUBE'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: smallFont },
	                df(post)
	              )
	            ),
	            content: getPublishedMessage(post)
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_imageComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { textAlign: 'left' },
	          _react2.default.createElement(_rowComponents.AssetComponent, { post: post, viewMode: viewMode })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: dyzioGreen },
	            true ? _react2.default.createElement(
	              'p',
	              null,
	              '-'
	            ) : _react2.default.createElement(_youtubeModalComponent2.default, { post: post })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_sourceComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.sciFormatted)(_lodash2.default.last(post.statistics).viewCount)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_reachComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_impressionsComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.sciFormatted)(_lodash2.default.last(post.statistics).likeCount)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.sciFormatted)(_lodash2.default.last(post.statistics).commentCount)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'shares', platform: post.trackedAsset.platform, assetType: post.postType })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_asaCompliance2.default, { text: post.description })
	        ),
	        deleteCallback && _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_rowComponents.DeleteButton, { value: post.trackedAsset.id, handler: deleteCallback })
	        )
	      );
	    case 'INSTAGRAM':
	      var isIGTV = post.isIGTV;
	      var isReel = post.isReel;
	      var isStory = _lodash2.default.get(post, 'trackedAsset.assetType') === 'STORY';
	
	      var supportingData = post.trackedAsset.supportingData;
	
	      var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
	      var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
	        return o.createdDate;
	      }));
	      var latestSupportingData = ordered[0];
	
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Popup, {
	            trigger: post.trackedAsset.assetType === 'STORY' ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                { style: { margin: 0 } },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline', color: 'pink' })
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: smallFont },
	                df(post)
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_instagramIcon2.default, { post: post }),
	              _react2.default.createElement(
	                'p',
	                { style: smallFont },
	                df(post)
	              )
	            ),
	            content: getPublishedMessage(post)
	          })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_imageComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { textAlign: 'left' },
	          _react2.default.createElement(_rowComponents.AssetComponent, { post: post, viewMode: viewMode })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          isStory && _react2.default.createElement(_storyComponents.StoryIconModalComponent, { story: post, inManualStoryMode: true }),
	          !isStory && _react2.default.createElement(
	            'div',
	            { style: dyzioGreen },
	            _react2.default.createElement(_semanticUiReact.Popup, {
	              content: 'view post on instagram',
	              trigger: _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    rel: 'noopener noreferrer',
	                    href: post.trackedAsset.assetURL,
	                    style: dyzioGreen
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, {
	                    name: 'external'
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { style: smallFont },
	                    'view...'
	                  )
	                )
	              )
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_sourceComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _lodash2.default.has(latestSupportingData, 'views') ? (0, _formatting.sciFormatted)(_lodash2.default.get(latestSupportingData, 'views')) : isReel ? (0, _formatting.sciFormatted)(post.latestStatistic.playCount) : post.isVideo ? (0, _formatting.sciFormatted)(post.latestStatistic.viewCount) : _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'views', platform: post.trackedAsset.platform, assetType: 'image' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_reachComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_impressionsComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          post.latestStatistic ? (0, _formatting.sciFormatted)(post.latestStatistic.likeCount) : _react2.default.createElement(_privateDataComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          post.latestStatistic ? (0, _formatting.sciFormatted)(post.latestStatistic.commentCount) : _react2.default.createElement(_privateDataComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_sharesComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_rowComponents.AdWrapper, { post: post })
	        ),
	        deleteCallback && _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_rowComponents.DeleteButton, { value: post.trackedAsset.id, handler: deleteCallback })
	        )
	      );
	    case 'SNAPCHAT':
	      return _react2.default.createElement(
	        _semanticUiReact.Table.Row,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'snapchat', color: 'yellow' }),
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'photo', color: 'yellow' })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_imageComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          { textAlign: 'left' },
	          _react2.default.createElement(_rowComponents.AssetComponent, { post: post, viewMode: viewMode })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'external', color: 'green' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_sourceComponent2.default, { post: post })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          (0, _formatting.sciFormatted)(post.latestStatistic.openCount)
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'reach', platform: post.trackedAsset.platform, assetType: 'post' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'impressions', platform: post.trackedAsset.platform, assetType: 'post' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'likes', platform: post.trackedAsset.platform, assetType: 'post' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'comments', platform: post.trackedAsset.platform, assetType: 'post' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_notAvailableComponent2.default, { metricName: 'shares', platform: post.trackedAsset.platform, assetType: 'post' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_notAvailableComponent2.default, { metricName: '#ad', platform: post.trackedAsset.platform, assetType: 'post' })
	        ),
	        deleteCallback && _react2.default.createElement(
	          _semanticUiReact.Table.Cell,
	          null,
	          _react2.default.createElement(_rowComponents.DeleteButton, { value: post.trackedAsset.id, handler: deleteCallback })
	        )
	      );
	    default:
	      return _react2.default.createElement(_semanticUiReact.Table.Row, null);
	  }
	};
	
	BasicReportRow.propTypes = {
	  post: _propTypes2.default.object.isRequired,
	  viewMode: _propTypes2.default.string.isRequired,
	  deleteCallback: _propTypes2.default.func
	};
	
	BasicReportRow.defaultProps = {
	  viewMode: 'external',
	  deleteCallback: _lodash2.default.noop
	};
	
	exports.default = BasicReportRow;

/***/ },
/* 2582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _numeral = __webpack_require__(152);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _pluralize = __webpack_require__(3026);
	
	var _pluralize2 = _interopRequireDefault(_pluralize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sf = function sf(num) {
	  var format = num > 1000 ? '0a' : '0';
	  format = num > 1000000 ? '0.0a' : format;
	  return (0, _numeral2.default)(num).format(format);
	};
	var textTransform = {
	  textTransform: 'none'
	};
	
	var dividerStyle = { borderRight: '1px solid #ccc' };
	
	var BasicReportSummary = function BasicReportSummary(_ref) {
	  var influencerCount = _ref.influencerCount,
	      assetCount = _ref.assetCount,
	      totalReach = _ref.totalReach,
	      totalImpressions = _ref.totalImpressions,
	      totalEngagements = _ref.totalEngagements,
	      totalViews = _ref.totalViews,
	      adsCount = _ref.adsCount;
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true, color: 'pink' },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Table,
	        { basic: 'very' },
	        _react2.default.createElement(
	          _semanticUiReact.Table.Body,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Table.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 4 },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Group,
	                { widths: adsCount ? 'three' : 'two', size: 'small' },
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  { color: 'grey' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    { style: textTransform },
	                    influencerCount
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    (0, _pluralize2.default)('Influencer', influencerCount)
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  { color: 'grey' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    { style: textTransform },
	                    assetCount
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    (0, _pluralize2.default)('Asset', assetCount)
	                  )
	                ),
	                adsCount ? _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  { color: 'grey' },
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    { style: textTransform },
	                    adsCount
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    (0, _pluralize2.default)('Ad', adsCount)
	                  )
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Cell,
	              { width: 12 },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Group,
	                { widths: 'four' },
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    { style: textTransform },
	                    sf(totalViews)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'Views'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    { style: textTransform },
	                    sf(totalReach)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'Reach'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    { style: textTransform },
	                    sf(totalImpressions)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'Impressions'
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.Statistic,
	                  null,
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Value,
	                    { style: textTransform },
	                    sf(totalEngagements)
	                  ),
	                  _react2.default.createElement(
	                    _semanticUiReact.Statistic.Label,
	                    null,
	                    'Engagements'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	BasicReportSummary.propTypes = {
	  influencerCount: _propTypes2.default.number.isRequired,
	  assetCount: _propTypes2.default.number.isRequired,
	  totalReach: _propTypes2.default.number.isRequired,
	  totalImpressions: _propTypes2.default.number.isRequired,
	  totalEngagements: _propTypes2.default.number.isRequired,
	  totalViews: _propTypes2.default.number.isRequired,
	  adsCount: _propTypes2.default.number.isRequired
	};
	
	exports.default = BasicReportSummary;

/***/ },
/* 2583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _number = __webpack_require__(2593);
	
	var _number2 = _interopRequireDefault(_number);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var totalStyles = {
	  backgroundColor: 'rgba(0,0,0,.05)',
	  fontWeight: 'bold'
	};
	
	var BasicReportTotalsRow = function BasicReportTotalsRow(_ref) {
	  var assetCount = _ref.assetCount,
	      totalReach = _ref.totalReach,
	      totalImpressions = _ref.totalImpressions,
	      totalLikes = _ref.totalLikes,
	      totalComments = _ref.totalComments,
	      totalShares = _ref.totalShares,
	      totalViews = _ref.totalViews,
	      withDeleteButton = _ref.withDeleteButton;
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    { style: totalStyles },
	    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        'Totals (',
	        assetCount,
	        ' assets)'
	      )
	    ),
	    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_number2.default, { number: totalViews, label: 'views' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      totalReach && _react2.default.createElement(_number2.default, { number: totalReach, label: 'reach' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      totalImpressions && _react2.default.createElement(_number2.default, { number: totalImpressions, label: 'impressions' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_number2.default, { number: totalLikes, label: 'likes' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_number2.default, { number: totalComments, label: 'comments' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_number2.default, { number: totalShares, label: 'shares' })
	    ),
	    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	    withDeleteButton && _react2.default.createElement(_semanticUiReact.Table.Cell, null)
	  );
	};
	
	BasicReportTotalsRow.propTypes = {
	  withDeleteButton: _propTypes2.default.bool,
	  assetCount: _propTypes2.default.number.isRequired,
	  totalReach: _propTypes2.default.number.isRequired,
	  totalImpressions: _propTypes2.default.number.isRequired,
	  totalLikes: _propTypes2.default.number.isRequired,
	  totalComments: _propTypes2.default.number.isRequired,
	  totalShares: _propTypes2.default.number.isRequired,
	  totalViews: _propTypes2.default.number.isRequired
	};
	
	BasicReportTotalsRow.defaultProps = {
	  withDeleteButton: false
	};
	
	exports.default = BasicReportTotalsRow;

/***/ },
/* 2584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _assets = __webpack_require__(243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var safeSum = function safeSum(object, fields) {
	  var sum = void 0;
	
	  _lodash2.default.forEach(fields, function (f) {
	    var v = _lodash2.default.get(object, f, 0);
	    sum += v;
	  });
	
	  return sum || '';
	};
	
	var replaceHash = function replaceHash(text) {
	  return _lodash2.default.replace(text, /\n/g, '%23');
	};
	var replaceNumberSign = function replaceNumberSign(text) {
	  return _lodash2.default.replace(text, /#/g, '');
	};
	
	var safeDescription = function safeDescription(text) {
	  var safe = _lodash2.default.replace(text, /\n/g, ' ');
	  safe = replaceHash(safe);
	  safe = replaceNumberSign(safe);
	  return _lodash2.default.truncate(safe, { length: 500 }) || '';
	};
	
	var getHandle = function getHandle(post) {
	  if (post.type === 'stories') {
	    return post.attributes.username;
	  }
	  switch (post.trackedAsset.platform) {
	    case 'YOUTUBE':
	      return post.channelTitle;
	    case 'TWITTER':
	      return post.twitterHandle;
	    case 'FACEBOOK':
	      return post.facebookHandle || post.influencerName;
	    case 'INSTAGRAM':
	      return post.instagramHandle || post.influencerName;
	    default:
	      return null;
	  }
	};
	
	var getCsvData = function getCsvData(posts) {
	  var csvOutput = _lodash2.default.map(posts, function (p) {
	    //
	    if (_lodash2.default.get(p, 'platform') === 'VK' || _lodash2.default.get(p, 'platform') === 'BLOG' || _lodash2.default.get(p, 'platform') === 'SNAPCHAT') {
	      return {
	        channel: _lodash2.default.get(p, 'platform'),
	        influencer: _lodash2.default.get(p, 'discussionName'),
	        date: _lodash2.default.get(p, 'createdDate'),
	        post_type: _lodash2.default.get(p, 'assetType'),
	        asset_link: _lodash2.default.get(p, 'assetURL'),
	        views: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'views'),
	        likes: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'likes'),
	        clicks: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'clicks'),
	        comments: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'comments'),
	        shares: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'shares'),
	        caption: safeDescription(_lodash2.default.get(p, 'extraData.text')),
	        impressions: '',
	        reach: '',
	        username: _lodash2.default.get(p, 'discussionName'),
	        followerCount: _lodash2.default.get(p, 'followerCount')
	      };
	    }
	    //
	    if (p && p.platform && p.platform === 'TIKTOK') {
	      var initialData = p.initialData,
	          tiktokData = p.tiktokData;
	
	      var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
	      return {
	        channel: 'TIKTOK',
	        influencer: _lodash2.default.get(p, 'discussionName'),
	        influencer_link: "https://www.tiktok.com/@" + _lodash2.default.get(p, 'discussionName'),
	        date: _lodash2.default.get(p, 'createdDate'),
	        post_type: _lodash2.default.get(p, 'assetType'),
	        asset_link: _lodash2.default.get(p, 'assetURL'),
	        caption: safeDescription(_lodash2.default.get(p, 'initialData.text')),
	        views: _lodash2.default.get(latestTiktokData, 'playCount', ''),
	        likes: _lodash2.default.get(latestTiktokData, 'diggCount', ''),
	        comments: _lodash2.default.get(latestTiktokData, 'commentCount', ''),
	        shares: _lodash2.default.get(latestTiktokData, 'shareCount', ''),
	        impressions: '',
	        reach: '',
	        username: _lodash2.default.get(p, 'discussionName'),
	        followerCount: _lodash2.default.get(p, 'initialData.authorMeta.fans')
	      };
	    }
	
	    if (p.type === 'stories') {
	      var _p$attributes = p.attributes,
	          storyData = _p$attributes.storyData,
	          assetType = _p$attributes.assetType;
	
	      var latestData = _lodash2.default.last(storyData);
	      var _supportingData = _lodash2.default.get(p, 'relationships.supportingData.data');
	
	      var _latestSupportingData = void 0;
	
	      if (_supportingData && _supportingData.length) {
	        var filtered = _lodash2.default.filter(_supportingData, 'attributes.createdDate'); // remove the GraphQL null at [0]
	        var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
	          return _lodash2.default.get(o, 'attributes.createdDate');
	        }));
	        _latestSupportingData = ordered[0];
	      }
	
	      var _data = {
	        channel: 'INSTAGRAM',
	        influencer: p.attributes.username,
	        influencer_link: "https://www.instagram.com/" + p.attributes.username,
	        date: latestData.createdDate,
	        post_type: 'STORY',
	        asset_link: p.attributes.assetURL,
	        caption: safeDescription(p.attributes.caption),
	        followerCount: _lodash2.default.get(p, 'followerCount'),
	        mentions: p.attributes.mentions,
	        hashtags: safeDescription(p.attributes.hashtags)
	      };
	
	      _lodash2.default.assign(_data, {
	        impressions: _lodash2.default.get(_latestSupportingData, 'attributes.impressions', latestData.impressions),
	        views: assetType === 'VIDEO' ? _lodash2.default.get(_latestSupportingData, 'attributes.views', latestData.impressions) : '',
	        reach: _lodash2.default.get(_latestSupportingData, 'attributes.reach', latestData.reach)
	      });
	
	      return _data;
	    }
	
	    var stats = p.latestStatistic;
	    var insights = _lodash2.default.get(stats, 'insights');
	    var supportingData = _lodash2.default.get(p, 'trackedAsset.supportingData');
	
	    var latestSupportingData = void 0;
	
	    if (supportingData && supportingData.length) {
	      var _filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
	      var _ordered = _lodash2.default.reverse(_lodash2.default.sortBy(_filtered, function (o) {
	        return o.createdDate;
	      }));
	      latestSupportingData = _ordered[0];
	    }
	
	    var postType = p.isVideo ? 'VIDEO' : 'IMAGE';
	
	    if (_lodash2.default.get(p, 'trackedAsset.assetType') === 'STORY') {
	      postType = 'STORY';
	    }
	
	    var data = {
	      channel: p.trackedAsset.platform,
	      influencer: safeDescription(getHandle(p)),
	      influencer_link: "https://www.instagram.com/" + safeDescription(getHandle(p)),
	      followerCount: _lodash2.default.get(p, 'followerCount'),
	      date: p.publishedDate || _lodash2.default.get(p, 'trackedAsset.publishedDate', ''),
	      post_type: postType,
	      asset_link: p.trackedAsset.assetURL,
	      caption: safeDescription(p.text),
	      isReel: p.isReel || '',
	      isIGTV: p.isIGTV || ''
	    };
	
	    if (_lodash2.default.get(p, 'trackedAsset.createdSource', '') === 'CAMPAIGN') {
	      _lodash2.default.set(data, 'caption', safeDescription(p.text));
	    }
	
	    if (stats) {
	      _lodash2.default.assign(data, {
	        views: stats.playCount || stats.viewCount || stats.openCount || '',
	        likes: stats.likeCount || '',
	        comments: stats.commentCount || '',
	        reactions: stats.reactionCount || '',
	        engagements: safeSum(stats, ['viewCount', 'likeCount', 'commentCount', 'reactionCount'])
	      });
	    }
	
	    if (insights) {
	      _lodash2.default.assign(data, {
	        impressions: insights.totalVideoImpressions || insights.impressions || '',
	        reach: insights.totalVideoImpressionsUnique || insights.reach || '',
	        saved: insights.saved || ''
	      });
	    }
	
	    if (latestSupportingData) {
	      _lodash2.default.assign(data, {
	        impressions: latestSupportingData.impressions || '',
	        reach: latestSupportingData.reach || '',
	        saved: latestSupportingData.saves || '',
	        engagements: latestSupportingData.engagements || '',
	        shares: latestSupportingData.shares || '',
	        stickerTaps: latestSupportingData.stickerTaps || ''
	      });
	    }
	
	    if (!data.reach) {
	      _lodash2.default.assign(data, { reach: _lodash2.default.get(p, 'latestInsights.reach', 0) });
	    }
	
	    if (!data.impressions) {
	      _lodash2.default.assign(data, { impressions: _lodash2.default.get(p, 'latestInsights.impressions', 0) });
	    }
	
	    return data;
	  });
	
	  return csvOutput;
	};
	
	module.exports = {
	  getCsvData: getCsvData
	};

/***/ },
/* 2585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOrderField = exports.getDiscussionLabel = exports.getDiscussionId = exports.getReactionsField = exports.getSharesField = exports.getCommentsField = exports.getThumbsDownField = exports.getThumbsUpField = exports.getViews = exports.getText = undefined;
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getIterator2 = __webpack_require__(938);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _reactCsv = __webpack_require__(2789);
	
	var _map = __webpack_require__(1029);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _uniq = __webpack_require__(2756);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _flow = __webpack_require__(401);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _DayPickerInput = __webpack_require__(3262);
	
	var _DayPickerInput2 = _interopRequireDefault(_DayPickerInput);
	
	__webpack_require__(2906);
	
	var _moment3 = __webpack_require__(3272);
	
	var _basicReportSummary = __webpack_require__(2582);
	
	var _basicReportSummary2 = _interopRequireDefault(_basicReportSummary);
	
	var _basicReportHeader = __webpack_require__(2576);
	
	var _basicReportHeader2 = _interopRequireDefault(_basicReportHeader);
	
	var _basicReportRow = __webpack_require__(2581);
	
	var _basicReportRow2 = _interopRequireDefault(_basicReportRow);
	
	var _basicReportTotalsRow = __webpack_require__(2583);
	
	var _basicReportTotalsRow2 = _interopRequireDefault(_basicReportTotalsRow);
	
	var _reportHeader = __webpack_require__(969);
	
	var _reportHeader2 = _interopRequireDefault(_reportHeader);
	
	var _collaborationCard = __webpack_require__(2551);
	
	var _collaborationCard2 = _interopRequireDefault(_collaborationCard);
	
	var _dyzioIcons = __webpack_require__(597);
	
	var _utils = __webpack_require__(2586);
	
	var _csvGenerator = __webpack_require__(2584);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DATE_PICKER_DATE_FORMAT = 'DD/MM/YYYY';
	
	var pinkBoldTextStyle = {
	  fontWeight: 'bold',
	  color: '#fc4085',
	  fontSize: 14
	};
	
	var pinkIconStyle = {
	  color: '#fc4085',
	  marginLeft: 10
	};
	
	var shortOrder = function shortOrder() {
	  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'descending';
	
	  if (text === 'descending' || text === 'desc') {
	    return 'desc';
	  }
	  return 'asc';
	};
	
	var getHandle = function getHandle(post) {
	  if (post.type === 'stories') {
	    return post.attributes.username;
	  }
	  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
	    case 'YOUTUBE':
	      return post.channelTitle;
	    case 'TWITTER':
	      return post.twitterHandle;
	    case 'FACEBOOK':
	      return post.facebookHandle || post.influencerName;
	    case 'INSTAGRAM':
	      return post.instagramHandle || post.influencerName;
	    default:
	      return null;
	  }
	};
	
	var getText = exports.getText = function getText(post) {
	  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
	    case 'YOUTUBE':
	      return post.description;
	    default:
	      return post.text;
	  }
	};
	
	var getViews = exports.getViews = function getViews(post) {
	  if (post.type === 'stories') {
	    return post.attributes.latestImpressions || 0;
	  }
	  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
	    case 'INSTAGRAM':
	    case 'FACEBOOK':
	      return post.latestStatistic.viewCount || 0;
	    case 'YOUTUBE':
	      var latest = _lodash2.default.last(post.statistics);
	      return latest.viewCount || 0;
	    case 'TIKTOK':
	      var lastData = _lodash2.default.last(post.tiktokData || []);
	      return lastData.playCount;
	    default:
	      return 0;
	  }
	};
	
	var getThumbsUpField = exports.getThumbsUpField = function getThumbsUpField(post) {
	  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
	    case 'TWITTER':
	    case 'FACEBOOK':
	    case 'INSTAGRAM':
	      return post.latestStatistic.likeCount || 0;
	    case 'YOUTUBE':
	      var latest = _lodash2.default.last(post.statistics);
	      return latest.likeCount || 0;
	    default:
	      return 0;
	  }
	};
	
	var getThumbsDownField = exports.getThumbsDownField = function getThumbsDownField(post) {
	  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
	    case 'YOUTUBE':
	      var latest = _lodash2.default.last(post.statistics);
	      return latest.dislikeCount || 0;
	    default:
	      return 0;
	  }
	};
	
	var getCommentsField = exports.getCommentsField = function getCommentsField(post) {
	  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
	    case 'FACEBOOK':
	    case 'TWITTER':
	    case 'INSTAGRAM':
	      return post.latestStatistic.commentCount || 0;
	    case 'YOUTUBE':
	      var latest = _lodash2.default.last(post.statistics);
	      return latest.commentCount || 0;
	    default:
	      return 0;
	  }
	};
	
	var getSharesField = exports.getSharesField = function getSharesField(post) {
	  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
	    case 'FACEBOOK':
	      return post.latestStatistic.shareCount || 0;
	    case 'TWITTER':
	      return post.latestStatistic.retweetCount || 0;
	    default:
	      return 0;
	  }
	};
	
	var getReactionsField = exports.getReactionsField = function getReactionsField(post) {
	  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
	    case 'FACEBOOK':
	      return post.latestStatistic.reactionCount || 0;
	    default:
	      return 0;
	  }
	};
	
	var getDiscussionId = exports.getDiscussionId = function getDiscussionId(post) {
	  //
	  if (_lodash2.default.has(post, 'relationships.discussion.data.id')) {
	    return _lodash2.default.get(post, 'relationships.discussion.data.id');
	  }
	
	  if (_lodash2.default.has(post, 'trackedAsset.discussionId')) {
	    return _lodash2.default.get(post, 'trackedAsset.discussionId');
	  }
	
	  if (_lodash2.default.has(post, 'trackedAsset.discussion.id')) {
	    return _lodash2.default.get(post, 'trackedAsset.discussion.id');
	  }
	
	  if (_lodash2.default.has(post, 'discussion.id')) {
	    return _lodash2.default.get(post, 'discussion.id');
	  }
	
	  // Try to resolve discusssionId by matching handle and campaign discussions
	  var handle = _lodash2.default.get(post, 'discussionName');
	  if (handle) {
	    var discussion = _lodash2.default.find(_lodash2.default.get(post, 'campaign.discussions', []), 'name', handle);
	    return _lodash2.default.get(discussion, 'id');
	  }
	  return _lodash2.default.get(post, 'discussionName');
	};
	
	var getDiscussionLabel = exports.getDiscussionLabel = function getDiscussionLabel(post) {
	  if (post.type === 'stories') {
	    return _lodash2.default.get(post, 'attributes.username');
	  }
	  return _lodash2.default.get(post, 'trackedAsset.discussionName') || _lodash2.default.get(post, 'discussionName');
	};
	
	var getOrderField = exports.getOrderField = function getOrderField(post, field) {
	  switch (field) {
	    case 'platform':
	      return _lodash2.default.get(post, 'trackedAsset.platform');
	    case 'influencer':
	      return getHandle(post);
	    case 'title':
	      return _lodash2.default.lowerCase(getText(post));
	    case 'views':
	      return getViews(post);
	    case 'thumbsUp':
	      return getThumbsUpField(post);
	    case 'thumbsDown':
	      return getThumbsDownField(post);
	    case 'comments':
	      return getCommentsField(post);
	    case 'shares':
	      return getSharesField(post);
	    case 'reactions':
	      return getReactionsField(post);
	    default:
	      return _lodash2.default.get(post, 'publishedDate');
	  }
	};
	
	var tableStyle = {
	  marginBottom: 0
	};
	
	var greenBoldTextStyle = {
	  fontWeight: 'bold',
	  color: '#20c49e',
	  fontSize: 14
	};
	
	var greenIconStyle = {
	  color: '#20c49e',
	  marginLeft: 10
	};
	
	var inputStyle = {
	  margin: 5
	};
	
	var BasicReport = function BasicReport(props) {
	  var onFilterChange = props.onFilterChange,
	      onOrderChanged = props.onOrderChanged,
	      filter = props.filter,
	      order = props.order,
	      rightFilterOptions = props.rightFilterOptions,
	      withHeader = props.withHeader,
	      hasMarketingCampaigns = props.hasMarketingCampaigns,
	      ads = props.ads,
	      emptyCampaignText = props.emptyCampaignText,
	      reportMode = props.reportMode,
	      deleteCallback = props.deleteCallback,
	      onDownloadClick = props.onDownloadClick,
	      withDaysFilter = props.withDaysFilter,
	      withDatePeriodFilter = props.withDatePeriodFilter,
	      datePeriodFilterValues = props.datePeriodFilterValues,
	      daysOptions = props.daysOptions,
	      onPerDaysChanged = props.onPerDaysChanged,
	      onDateFilterChange = props.onDateFilterChange,
	      perDaysOption = props.perDaysOption,
	      emptyCampaignMessageType = props.emptyCampaignMessageType,
	      onForceRefresh = props.onForceRefresh,
	      isLoadingMarketingCampaigns = props.isLoadingMarketingCampaigns,
	      loadingMarketingCampaignsFailed = props.loadingMarketingCampaignsFailed,
	      hasRightFilterOptions = props.hasRightFilterOptions,
	      assetOptions = props.assetOptions,
	      shouldRenderShareableLinks = props.shouldRenderShareableLinks,
	      instagramHandleFilter = props.instagramHandleFilter;
	  //
	
	  var _ref = props.data || { data: { errored: true } },
	      data = _ref.data,
	      meta = _ref.meta;
	
	  var name = data.name,
	      country = data.country,
	      liveDate = data.liveDate,
	      endDate = data.endDate,
	      createdBy = data.createdBy,
	      posts = data.posts,
	      stories = data.stories,
	      tiktoks = data.tiktoks,
	      telegrams = data.telegrams,
	      newTypeAssets = data.newTypeAssets,
	      hashtags = data.hashtags,
	      campaignType = data.campaignType,
	      influencer = data.influencer,
	      influencers = data.influencers,
	      errored = data.errored;
	
	
	  var handleDownloadClick = onDownloadClick || _lodash2.default.noop();
	
	  var vkSnapChatAndBlogs = _lodash2.default.flatten(_lodash2.default.values(newTypeAssets));
	
	  var processed = _lodash2.default.compact(posts);
	  var isACR = campaignType === 'ACR';
	
	  var adsCount = ads ? _lodash2.default.size(ads) : null;
	  var isEmptyCampaign = _lodash2.default.size(processed) + _lodash2.default.size(telegrams) + _lodash2.default.size(stories) + _lodash2.default.size(tiktoks) + _lodash2.default.size(vkSnapChatAndBlogs) === 0;
	
	  var hostname = window.location.hostname;
	
	
	  var compliantHostnames = ['share.dyzio.co', 'app.dyzio.co', 'reporting.abbottlyon.com'];
	  var isDyzio = _lodash2.default.includes(compliantHostnames, hostname);
	
	  var hasYoutube = _lodash2.default.some(processed, { trackedAsset: { platform: 'YOUTUBE' } });
	
	  var postsAndStories = processed;
	
	  if (stories && stories.length > 0) {
	    _lodash2.default.forEach(stories, function (s) {
	      s.publishedDate = s.attributes.publishedDate;
	      var trackedAsset = _lodash2.default.clone(_lodash2.default.get(s, 'attributes'));
	      s.trackedAsset = trackedAsset;
	    });
	    postsAndStories = _lodash2.default.concat(stories, processed);
	  }
	
	  var headerInfo = {
	    hasLogo: false,
	    campaignName: name,
	    reportDate: liveDate,
	    reportType: 'Campaign report',
	    reportCountry: country,
	    hashtags: hashtags,
	    liveDate: liveDate,
	    endDate: endDate
	  };
	
	  var basicData = null;
	  var filename = void 0;
	  var timestamp = (0, _moment2.default)().format('YYYY-MM-DD');
	
	  if (!_lodash2.default.isEmpty(vkSnapChatAndBlogs)) {
	    var _postsAndStories;
	
	    (_postsAndStories = postsAndStories).push.apply(_postsAndStories, (0, _toConsumableArray3.default)(vkSnapChatAndBlogs));
	  }
	
	  if (!_lodash2.default.isEmpty(tiktoks)) {
	    var _postsAndStories2;
	
	    var newTiktoks = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(tiktoks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var t = _step.value;
	
	        var trackedAsset = _lodash2.default.clone(t);
	        t.trackedAsset = trackedAsset;
	        newTiktoks.push(t);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    console.log('newTiktoks', newTiktoks);
	    console.log('tiktoks', tiktoks);
	
	    (_postsAndStories2 = postsAndStories).push.apply(_postsAndStories2, (0, _toConsumableArray3.default)(_lodash2.default.flatten(newTiktoks)));
	  }
	
	  var channels = (0, _flow2.default)((0, _map2.default)('trackedAsset.platform'), _uniq2.default)(postsAndStories);
	
	  if (!_lodash2.default.isEmpty(telegrams)) {
	    var _postsAndStories3;
	
	    var newTelegrams = [];
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = (0, _getIterator3.default)(telegrams), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var _t = _step2.value;
	
	        var _trackedAsset = _lodash2.default.clone(_t);
	        _t.trackedAsset = _trackedAsset;
	        newTelegrams.push(_t);
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	
	    console.log('newTellys', newTelegrams);
	
	    (_postsAndStories3 = postsAndStories).push.apply(_postsAndStories3, (0, _toConsumableArray3.default)(_lodash2.default.flatten(newTelegrams)));
	  }
	
	  var discussionsNotUnique = _lodash2.default.map(postsAndStories, function (post) {
	    if (post.attributes && post.attributes.username && post.attributes.username.match(/1000/)) {
	      console.log(post);
	    }
	
	    return {
	      label: getDiscussionLabel(post),
	      value: getDiscussionId(post)
	    };
	  });
	
	  var discussions = _lodash2.default.map(discussionsNotUnique, function (item) {
	    if (!_lodash2.default.isNil(item.label) && !_lodash2.default.isNil(item.value)) {
	      return item;
	    }
	    // Resolve discussionId
	    var goodRecord = _lodash2.default.find(discussionsNotUnique, function (record) {
	      return _lodash2.default.get(record, 'label') === _lodash2.default.get(item, 'label') && !_lodash2.default.isNil(record.value);
	    });
	
	    if (goodRecord) {
	      return goodRecord;
	    }
	    return {
	      label: _lodash2.default.get(item, 'label'),
	      value: _lodash2.default.get(item, 'label')
	    };
	  });
	
	  var uniqDiscussions = _lodash2.default.uniqBy(_lodash2.default.compact(discussions), 'value');
	  var alphaSortedDiscussions = _lodash2.default.orderBy(uniqDiscussions, function (item) {
	    return _lodash2.default.lowerCase(_lodash2.default.deburr(item.label));
	  }, ['asc']);
	
	  if (filter && filter.platform) {
	    postsAndStories = _lodash2.default.filter(postsAndStories, ['trackedAsset.platform', filter.platform]);
	  }
	
	  if (filter && filter.discussion) {
	    var lowerDiscussion = _lodash2.default.toLower(filter.discussion);
	    postsAndStories = _lodash2.default.filter(postsAndStories, function (postOrStory) {
	      var objectDiscussionName = _lodash2.default.toLower(_lodash2.default.get(postOrStory, 'discussionName', null));
	      var matchesByDiscussionId = getDiscussionId(postOrStory) === _lodash2.default.get(filter, 'discussion');
	      var matchesByStoryHandle = _lodash2.default.get(postOrStory, 'attributes.username', null) === instagramHandleFilter;
	      var matchesByAssetDiscussionName = _lodash2.default.get(postOrStory, 'trackedAsset.discussionName', null) === instagramHandleFilter;
	      var matchesByAssetDiscussionName2 = _lodash2.default.toLower(_lodash2.default.get(postOrStory, 'trackedAsset.discussionName', null)) === lowerDiscussion;
	      var matchByAssetDiscName = matchesByAssetDiscussionName || matchesByAssetDiscussionName2;
	      var matchesByObjectDiscussionName = objectDiscussionName === lowerDiscussion;
	      return matchesByDiscussionId || matchByAssetDiscName || matchesByStoryHandle || matchesByObjectDiscussionName;
	    });
	  }
	
	  // sorting haoppens here....
	  if (order && order.field) {
	    _lodash2.default.forEach(postsAndStories, function (p) {
	      if (!p.orderBy) p.orderBy = {};
	      p.orderBy[order.field] = getOrderField(p, order.field);
	    });
	
	    postsAndStories = _lodash2.default.orderBy(postsAndStories, ['orderBy.' + order.field], [shortOrder(order.value)]);
	  }
	
	  var dname = _lodash2.default.get(_lodash2.default.find(uniqDiscussions, ['value', filter.discussion]), 'label', instagramHandleFilter);
	  var currentDiscussionName = filter.discussion && dname;
	
	  var allPosts = postsAndStories;
	
	  _lodash2.default.forEach(postsAndStories, function (asset) {
	    if (_lodash2.default.get(asset, 'instagramAccountId') || _lodash2.default.get(asset, 'type') === 'stories') {
	      var instagramId = _lodash2.default.get(asset, 'instagramAccountId', _lodash2.default.get(asset, 'attributes.instagramAccountId'));
	      var matchedInfluencer = _lodash2.default.find(influencers, function (inf) {
	        return inf.instagramId === instagramId;
	      });
	      _lodash2.default.assign(asset, {
	        followerCount: _lodash2.default.get(matchedInfluencer, 'instagramCount')
	      });
	    } else {
	      var discussionId = _lodash2.default.get(asset, 'trackedAsset.discussionId');
	
	      var platform = _lodash2.default.toLower(_lodash2.default.get(asset, 'trackedAsset.platform'));
	      var _matchedInfluencer = _lodash2.default.find(influencers, function (inf) {
	        return inf.discussionId === discussionId;
	      });
	      _lodash2.default.assign(asset, {
	        followerCount: _lodash2.default.get(_matchedInfluencer, platform + 'Count')
	      });
	    }
	  });
	
	  var YOUTUBE_AUDIT_LIVE = false;
	  var showAggregates = !YOUTUBE_AUDIT_LIVE || !(isDyzio && hasYoutube);
	
	  if (data) {
	    filename = _lodash2.default.kebabCase(data.name) + '-' + timestamp + '.csv';
	    basicData = (0, _csvGenerator.getCsvData)(postsAndStories);
	  }
	
	  var totalReach = (0, _utils.getTotalReach)(postsAndStories);
	  var totalImpressions = (0, _utils.getTotalImpressions)(postsAndStories);
	
	  var summaryTotals = {
	    totalReach: totalReach,
	    totalImpressions: totalImpressions
	  };
	
	  var orderedPostsAndStories = !order ? _lodash2.default.orderBy(allPosts, ['publishedDate'], ['desc']) : allPosts;
	
	  var influencerCount = (0, _utils.getInfluencerCount)(orderedPostsAndStories);
	  var assetCount = (0, _utils.getAssetCount)(orderedPostsAndStories);
	  var totalViews = (0, _utils.getTotalViews)(orderedPostsAndStories);
	  var totalLikes = (0, _utils.getTotalLikes)(orderedPostsAndStories);
	  var totalShares = (0, _utils.getTotalShares)(orderedPostsAndStories);
	  var totalComments = (0, _utils.getTotalComments)(orderedPostsAndStories);
	
	  var totalEngagements = _lodash2.default.sum([totalLikes, totalShares, totalComments]);
	
	  var campaignHasPosts = meta && meta.postCount + meta.storyCount > 0;
	  var appearsToBeEmpty = orderedPostsAndStories.length === 0 && campaignHasPosts;
	  return _react2.default.createElement(
	    'div',
	    null,
	    withHeader && _react2.default.createElement(
	      _semanticUiReact.Card,
	      { fluid: true, color: 'pink' },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Message,
	          { icon: true },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file text outline', color: 'pink' }),
	          _react2.default.createElement(
	            _semanticUiReact.Message.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Message.Header,
	              null,
	              name
	            ),
	            'created by ',
	            createdBy
	          )
	        ),
	        _react2.default.createElement(_reportHeader2.default, { info: headerInfo })
	      )
	    ),
	    showAggregates && _react2.default.createElement(_basicReportSummary2.default, {
	      totalReach: summaryTotals.totalReach,
	      totalImpressions: summaryTotals.totalImpressions,
	      influencerCount: influencerCount,
	      assetCount: assetCount,
	      totalEngagements: totalEngagements,
	      totalViews: totalViews
	      // adsCount={adsCount}
	    }),
	    isACR && _react2.default.createElement(_collaborationCard2.default, influencer),
	    showAggregates && _react2.default.createElement(
	      _semanticUiReact.Menu,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Menu,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Menu.Item,
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'FILTER BY:'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Dropdown,
	          { scrolling: true, item: true, text: _lodash2.default.lowerCase(filter.platform) || 'platform' },
	          _react2.default.createElement(
	            _semanticUiReact.Dropdown.Menu,
	            null,
	            filter.platform && _react2.default.createElement(
	              _semanticUiReact.Dropdown.Item,
	              {
	                onClick: onFilterChange,
	                value: 'platform.reset'
	              },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', size: 'tiny' }),
	              'reset'
	            ),
	            _lodash2.default.map(channels, function (channel) {
	              return _react2.default.createElement(
	                _semanticUiReact.Dropdown.Item,
	                {
	                  value: 'platform.' + channel,
	                  onClick: onFilterChange
	                },
	                _lodash2.default.toLower(channel) === 'tiktok' ? _react2.default.createElement(_dyzioIcons.TiktokIcon, { additionalStyles: { margin: "0 .75em 0 0" } }) : _react2.default.createElement(_semanticUiReact.Icon, { name: _lodash2.default.toLower(channel), size: 'tiny' }),
	                ' ',
	                _lodash2.default.toLower(channel)
	              );
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Menu,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Dropdown,
	          { scrolling: true, item: true, text: currentDiscussionName || 'influencer' },
	          _react2.default.createElement(
	            _semanticUiReact.Dropdown.Menu,
	            null,
	            filter.discussion && _react2.default.createElement(
	              _semanticUiReact.Dropdown.Item,
	              {
	                onClick: onFilterChange,
	                value: 'discussion.reset'
	              },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', size: 'tiny' }),
	              'reset'
	            ),
	            _lodash2.default.map(alphaSortedDiscussions, function (option) {
	              return option.value && _react2.default.createElement(
	                _semanticUiReact.Dropdown.Item,
	                {
	                  onClick: onFilterChange,
	                  value: 'discussion.' + option.value
	                },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'user', size: 'tiny' }),
	                '\xA0',
	                _lodash2.default.toLower(option.label)
	              );
	            })
	          )
	        )
	      ),
	      withDatePeriodFilter && _react2.default.createElement(
	        _semanticUiReact.Menu.Menu,
	        null,
	        _react2.default.createElement(_DayPickerInput2.default, {
	          component: function component(p) {
	            return _react2.default.createElement(
	              'div',
	              { style: inputStyle, className: 'ui input' },
	              _react2.default.createElement('input', p)
	            );
	          },
	          onDayChange: function onDayChange(day) {
	            return onDateFilterChange(day, 'start');
	          },
	          format: DATE_PICKER_DATE_FORMAT,
	          dateFormat: DATE_PICKER_DATE_FORMAT,
	          placeholder: 'Start date',
	          formatDate: _moment3.formatDate,
	          parseDate: _moment3.parseDate,
	          value: datePeriodFilterValues.start
	        }),
	        _react2.default.createElement(_DayPickerInput2.default, {
	          component: function component(p) {
	            return _react2.default.createElement(
	              'div',
	              { style: inputStyle, className: 'ui input' },
	              _react2.default.createElement('input', p)
	            );
	          },
	          onDayChange: function onDayChange(day) {
	            return onDateFilterChange(day, 'end');
	          },
	          format: DATE_PICKER_DATE_FORMAT,
	          dateFormat: DATE_PICKER_DATE_FORMAT,
	          placeholder: 'End date',
	          formatDate: _moment3.formatDate,
	          parseDate: _moment3.parseDate,
	          value: datePeriodFilterValues.end
	        })
	      ),
	      withDaysFilter && _react2.default.createElement(
	        _semanticUiReact.Menu.Menu,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Dropdown,
	          { scrolling: true, item: true, text: perDaysOption ? perDaysOption.label : '30 days' },
	          _react2.default.createElement(
	            _semanticUiReact.Dropdown.Menu,
	            null,
	            _lodash2.default.map(daysOptions, function (option) {
	              return _react2.default.createElement(
	                _semanticUiReact.Dropdown.Item,
	                {
	                  key: option.id,
	                  onClick: function onClick(e) {
	                    return onPerDaysChanged(e, (0, _extends3.default)({}, option));
	                  }
	                },
	                _lodash2.default.get(option, 'label', '-')
	              );
	            })
	          )
	        )
	      ),
	      withDaysFilter && _react2.default.createElement(
	        _semanticUiReact.Menu.Item,
	        null,
	        _react2.default.createElement(_semanticUiReact.Label, {
	          content: (perDaysOption ? perDaysOption.label : '30 days') + ' data',
	          color: 'orange', basic: true
	        })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Menu.Menu,
	        { position: 'right' },
	        hasRightFilterOptions && _react2.default.createElement(
	          _semanticUiReact.Dropdown,
	          {
	            scrolling: true,
	            icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus', style: pinkIconStyle }),
	            item: true,
	            basic: true,
	            trigger: _react2.default.createElement(
	              'span',
	              { style: pinkBoldTextStyle },
	              'Add a new asset'
	            )
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Dropdown.Menu,
	            null,
	            _lodash2.default.map(assetOptions, function (option) {
	              return _react2.default.createElement(
	                _semanticUiReact.Dropdown.Item,
	                {
	                  onClick: option.onClick,
	                  value: option.value
	                },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: option.icon }),
	                option.label
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Menu.Item,
	          { position: 'right', onClick: handleDownloadClick },
	          _react2.default.createElement(
	            _semanticUiReact.Label,
	            { basic: true, size: 'large', color: 'pink' },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
	            _react2.default.createElement(
	              _reactCsv.CSVLink,
	              { data: basicData, filename: filename },
	              'Download Report'
	            )
	          )
	        ),
	        shouldRenderShareableLinks && _react2.default.createElement(_semanticUiReact.Popup, {
	          trigger: _react2.default.createElement(
	            _semanticUiReact.Dropdown,
	            {
	              scrolling: true,
	              icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'share', style: greenIconStyle }),
	              item: true,
	              trigger: _react2.default.createElement(
	                'span',
	                { style: greenBoldTextStyle },
	                'shareable reports'
	              )
	            },
	            _react2.default.createElement(
	              _semanticUiReact.Dropdown.Menu,
	              null,
	              _lodash2.default.map(rightFilterOptions, function (option) {
	                return _react2.default.createElement(
	                  _semanticUiReact.Dropdown.Item,
	                  {
	                    value: option.value,
	                    onClick: option.onClick
	                  },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: option.icon }),
	                  option.text
	                );
	              })
	            )
	          ),
	          content: 'Get links to your shareable reports'
	        })
	      )
	    ),
	    appearsToBeEmpty && _react2.default.createElement(
	      _semanticUiReact.Message,
	      {
	        icon: true,
	        color: 'orange'
	      },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'calendar check outline' }),
	      _react2.default.createElement(
	        _semanticUiReact.Message.Content,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Message.Header,
	          null,
	          'This campaign has posts - you just cannot see them'
	        ),
	        'Choose ',
	        _react2.default.createElement(
	          'b',
	          null,
	          'All Days'
	        ),
	        ' in the selector above to see the posts/stories (your date range has filtered them out)'
	      )
	    ),
	    isEmptyCampaign && !appearsToBeEmpty && !errored && _react2.default.createElement(
	      _semanticUiReact.Message,
	      {
	        icon: true,
	        info: _lodash2.default.eq(emptyCampaignMessageType, 'info'),
	        warning: _lodash2.default.eq(emptyCampaignMessageType, 'warning')
	      },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning' }),
	      _react2.default.createElement(
	        _semanticUiReact.Message.Content,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Message.Header,
	          null,
	          'Info'
	        ),
	        emptyCampaignText
	      )
	    ),
	    isEmptyCampaign && !appearsToBeEmpty && errored && _react2.default.createElement(
	      _semanticUiReact.Message,
	      {
	        icon: true,
	        info: _lodash2.default.eq(emptyCampaignMessageType, 'info'),
	        warning: _lodash2.default.eq(emptyCampaignMessageType, 'warning')
	      },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning' }),
	      _react2.default.createElement(
	        _semanticUiReact.Message.Content,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Message.Header,
	          null,
	          'Info'
	        ),
	        'Could not load report. Please try setting a date range using the date filter'
	      )
	    ),
	    !isEmptyCampaign && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: true, color: 'green' },
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          {
	            style: tableStyle,
	            sortable: true,
	            singleLine: true,
	            celled: true,
	            fixed: true,
	            basic: 'very',
	            size: 'small',
	            textAlign: 'center'
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Header,
	            null,
	            _react2.default.createElement(_basicReportHeader2.default, {
	              onOrderChanged: onOrderChanged,
	              order: order,
	              withDeleteButton: deleteCallback
	            })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _lodash2.default.map(orderedPostsAndStories, function (post) {
	              return _react2.default.createElement(_basicReportRow2.default, {
	                deleteCallback: deleteCallback,
	                viewMode: reportMode,
	                post: post
	              });
	            }),
	            showAggregates && _react2.default.createElement(_basicReportTotalsRow2.default, {
	              totalReach: totalReach,
	              totalImpressions: totalImpressions,
	              influencerCount: influencerCount,
	              assetCount: assetCount,
	              totalEngagements: totalEngagements,
	              totalViews: totalViews,
	              totalShares: totalShares,
	              totalComments: totalComments,
	              totalLikes: totalLikes,
	              withDeleteButton: deleteCallback
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          { extra: true },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui right aligned' },
	            'Report generated at ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              (0, _moment2.default)().format('MMMM Do YYYY, h:mm a')
	            ),
	            '.'
	          )
	        )
	      )
	    )
	  );
	};
	
	BasicReport.defaultProps = {
	  withHeader: false,
	  hasRightFilterOptions: true,
	  emptyCampaignText: 'No posts included in this campaign',
	  emptyCampaignMessageType: 'info',
	  reportMode: 'external',
	  withDaysFilter: false,
	  withDatePeriodFilter: false,
	  onDateFilterChange: _lodash2.default.noop,
	  datePeriodFilterValues: {
	    start: new Date(),
	    end: new Date()
	  },
	  daysOptions: [],
	  perDaysOption: null,
	  deleteCallback: null,
	  onPerDaysChanged: function onPerDaysChanged() {
	    return _lodash2.default.noop;
	  },
	  hasMarketingCampaigns: false,
	  ads: [],
	  shouldRenderShareableLinks: true
	};
	
	exports.default = BasicReport;

/***/ },
/* 2586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _assets = __webpack_require__(243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FACEBOOK = 'FACEBOOK';
	var INSTAGRAM = 'INSTAGRAM';
	var YOUTUBE = 'YOUTUBE';
	var TWITTER = 'TWITTER';
	var TELEGRAM = 'TELEGRAM';
	var STORIES = 'stories';
	var STORY = 'STORY';
	
	var getAssetCount = function getAssetCount(posts) {
	  return posts.length;
	};
	
	var isManualDataOnlyAsset = function isManualDataOnlyAsset(post) {
	  return _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'SNAPCHAT') || _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'VK') || _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'BLOG');
	};
	
	var getLatestSupportingData = function getLatestSupportingData(supportingData) {
	  var latestSupportingData = void 0;
	
	  if (supportingData && supportingData.length) {
	    var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
	    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
	      return o.createdDate;
	    }));
	    latestSupportingData = ordered[0];
	  }
	
	  return latestSupportingData;
	};
	
	var getInfluencerCount = function getInfluencerCount(posts) {
	  var prefiltered = _lodash2.default.map(posts, function (p) {
	    if (p.discussionId) return { discussionId: p.discussionId };
	
	    if (_lodash2.default.get(p, 'platform') === 'TIKTOK') {
	      return { discussionId: _lodash2.default.get(_lodash2.default.get(p, 'discussion'), 'id') };
	    }
	    if (_lodash2.default.get(p, 'type') === 'stories') {
	      return { discussionId: _lodash2.default.get(p, 'relationships.discussion.data.id') };
	    }
	    // if (_.get(p, 'trackedAsset.platform') === 'INSTAGRAM' && _.has(p, 'instagramHandle')) {
	    //   return { discussionName: _.get(p, 'instagramHandle') };
	    // }
	    return { discussionId: _lodash2.default.get(p, 'trackedAsset.discussionId', null) };
	  });
	  var filtered = _lodash2.default.filter(prefiltered, 'discussionId'); // get rid of posts without discussion
	  var discussions = _lodash2.default.uniqBy(filtered, 'discussionId');
	
	  return discussions.length || 1; // there must be 1 influencer?
	};
	
	var getTotalImpressions = function getTotalImpressions(posts, usesBoostedData) {
	  return _lodash2.default.sumBy(posts, function (post) {
	    var totalImpressions = void 0;
	
	    if (_lodash2.default.get(post, 'platform') === 'TIKTOK') {
	
	      // REMOVED 15 JUNE 2024 - requested impressions should not include TIKTOK Views
	      // const { initialData, tiktokData } = post;
	      // const latestTiktokData = _.last(_.sortBy(tiktokData, 'createdDate')) || initialData;
	      // return _.get(latestTiktokData, 'playCount');
	
	      return 0;
	    }
	
	    if (post.type === STORIES) {
	      var storyData = post.attributes.storyData;
	      var data = post.relationships.supportingData.data;
	
	
	      var latestSupportingData = _lodash2.default.last(data) || {};
	
	      var latestData = _lodash2.default.get(latestSupportingData, 'attributes.impressions') ? _lodash2.default.get(latestSupportingData, 'attributes') : _lodash2.default.last(storyData);
	
	      var nonboostedReach = _lodash2.default.get(latestData, 'impressions', 0);
	
	      var boostedReach = _lodash2.default.get(post, 'attributes.finalImps');
	      totalImpressions = usesBoostedData && boostedReach > 0 ? boostedReach : nonboostedReach;
	    } else {
	      if (usesBoostedData && _lodash2.default.has(post, 'finalImps')) {
	        return _lodash2.default.get(post, 'finalImps');
	      }
	      var hasSupportingData = false;
	
	      var insights = _lodash2.default.get(post, 'latestStatistic.insights');
	      var hasInsightsError = insights && insights.error;
	
	      if (_lodash2.default.get(post, 'trackedAsset.platform') === FACEBOOK && insights) {
	        totalImpressions = insights.totalVideoImpressions || insights.postImpressions || 0;
	      }
	
	      var fullSupportingData = _lodash2.default.get(post, 'supportingData', _lodash2.default.get(post, 'trackedAsset.supportingData', []));
	      var _latestSupportingData = getLatestSupportingData(fullSupportingData);
	
	      if (_latestSupportingData && _latestSupportingData.impressions) {
	        hasSupportingData = true;
	        totalImpressions = _latestSupportingData.impressions;
	      }
	
	      if (!hasSupportingData && _lodash2.default.get(post, 'trackedAsset.platform') === INSTAGRAM && insights && !hasInsightsError) {
	        totalImpressions = insights.impressions || 0;
	      }
	    }
	    return totalImpressions;
	  });
	};
	
	var getTotalReach = function getTotalReach(posts, usesBoostedData) {
	  return _lodash2.default.sumBy(posts, function (post) {
	    var totalReach = void 0;
	
	    if (_lodash2.default.get(post, 'platform') === 'TIKTOK') {
	      return null;
	    }
	
	    if (_lodash2.default.get(post, 'platform', '') === TELEGRAM) {
	      var telegramData = _lodash2.default.last(_lodash2.default.get(post, 'telegramData'));
	      return _lodash2.default.get(telegramData, 'views', 0);
	    }
	
	    if (post.type === STORIES) {
	      var storyData = post.attributes.storyData;
	      var data = post.relationships.supportingData.data;
	
	
	      var latestSupportingData = _lodash2.default.last(data) || {};
	
	      var latestData = _lodash2.default.get(latestSupportingData, 'attributes.reach') ? _lodash2.default.get(latestSupportingData, 'attributes') : _lodash2.default.last(storyData);
	
	      var nonboostedReach = _lodash2.default.get(latestData, 'reach', 0);
	
	      var boostedReach = _lodash2.default.get(post, 'attributes.finalReach');
	      totalReach = usesBoostedData && boostedReach > 0 ? boostedReach : nonboostedReach;
	    } else {
	      if (usesBoostedData && _lodash2.default.has(post, 'finalReach')) {
	        return _lodash2.default.get(post, 'finalReach');
	      }
	      var hasSupportingData = false;
	
	      var insights = _lodash2.default.get(post, 'latestStatistic.insights');
	      var hasInsightsError = insights && insights.error;
	
	      if (_lodash2.default.get(post, 'trackedAsset.platform') === FACEBOOK && insights) {
	        totalReach = insights.totalVideoImpressionsUnique || insights.postImpressionsUnique || 0;
	      }
	
	      var fullSupportingData = _lodash2.default.get(post, 'supportingData', _lodash2.default.get(post, 'trackedAsset.supportingData', []));
	      var _latestSupportingData2 = getLatestSupportingData(fullSupportingData);
	
	      if (_latestSupportingData2 && _latestSupportingData2.reach) {
	        hasSupportingData = true;
	        totalReach = _latestSupportingData2.reach;
	      }
	
	      if (!hasSupportingData && _lodash2.default.get(post, 'trackedAsset.platform') === INSTAGRAM && insights && !hasInsightsError) {
	        totalReach = insights.reach || 0;
	      }
	    }
	    return totalReach;
	  });
	};
	
	var getTotalViews = function getTotalViews(posts) {
	  return _lodash2.default.sumBy(posts, function (post) {
	    var isStory = _lodash2.default.eq(_lodash2.default.get(post, 'type'), STORIES);
	    var isVideo = _lodash2.default.eq(_lodash2.default.get(post, 'attributes.assetType'), 'VIDEO');
	    var isTiktok = _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'TIKTOK');
	    var linkedAds = _lodash2.default.get(post, 'attributes.linkedAds', []);
	    var hasLinkedAds = !_lodash2.default.isEmpty(linkedAds);
	    var isManual = isManualDataOnlyAsset(post);
	
	    if (isManual) {
	      return (0, _assets.getSupportingDataField)(_lodash2.default.get(post, 'supportingData', []), 'views', 0);
	    }
	
	    if (isTiktok) {
	      var tiktokData = post.tiktokData,
	          initialData = post.initialData;
	
	      var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
	      var num = _lodash2.default.toNumber(_lodash2.default.get(latestTiktokData, 'playCount', 0));
	      return num;
	    }
	
	    var data = _lodash2.default.get(post, 'relationships.supportingData.data');
	
	    var latestSupportingData = _lodash2.default.last(data) || {};
	
	    if (!hasLinkedAds) {
	      if (latestSupportingData && _lodash2.default.get(latestSupportingData, 'attributes.views')) {
	        return _lodash2.default.get(latestSupportingData, 'attributes.views');
	      }
	      if (latestSupportingData && _lodash2.default.get(latestSupportingData, 'attributes.impressions')) {
	        return _lodash2.default.get(latestSupportingData, 'attributes.impressions');
	      }
	    }
	
	    if (isStory && isVideo) {
	      var storyData = _lodash2.default.get(post, 'attributes.storyData', []);
	      var latestData = _lodash2.default.last(storyData);
	
	      var finalViews = _lodash2.default.get(post, 'attributes.finalViews');
	      if (finalViews) return finalViews;
	
	      var _num = _lodash2.default.toNumber(_lodash2.default.get(latestData, 'impressions', 0));
	      return _num;
	    }
	
	    if (_lodash2.default.get(post, 'trackedAsset.platform') === YOUTUBE) {
	      var latestStatistic = _lodash2.default.last(post.statistics);
	      return latestStatistic.viewCount || 0;
	    }
	
	    if (_lodash2.default.get(post, 'trackedAsset.platform') === INSTAGRAM && post.trackedAsset.assetType === STORY) {
	      var supportingData = post.trackedAsset.supportingData;
	
	      var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
	      var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
	        return o.createdDate;
	      }));
	      var _latestSupportingData3 = ordered[0];
	
	      return post.latestStatistic.openCount || _latestSupportingData3 && _latestSupportingData3.views || _latestSupportingData3 && _latestSupportingData3.impressions || 0;
	    }
	
	    if (_lodash2.default.get(post, 'trackedAsset.platform') === INSTAGRAM || _lodash2.default.get(post, 'trackedAsset.platform') === FACEBOOK) {
	      return post.latestStatistic ? post.latestStatistic.playCount || post.latestStatistic.viewCount || 0 : 0;
	    }
	    return 0;
	  });
	};
	
	var getTotalClicks = function getTotalClicks(ads) {
	  return _lodash2.default.sumBy(ads, function (ad) {
	    return ad.insights ? Number(ad.insights.clicks) : 0;
	  });
	};
	
	var getTotalLikes = function getTotalLikes(posts) {
	  return _lodash2.default.sumBy(posts, function (post) {
	    var isManual = isManualDataOnlyAsset(post);
	    if (isManual) {
	      return (0, _assets.getSupportingDataField)(_lodash2.default.get(post, 'supportingData', []), 'likes', 0);
	    }
	    var isTiktok = _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'TIKTOK');
	    if (isTiktok) {
	      var tiktokData = post.tiktokData,
	          initialData = post.initialData;
	
	      var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
	      var num = _lodash2.default.toNumber(_lodash2.default.get(latestTiktokData, 'diggCount', 0));
	      return num;
	    }
	    if (post.type === STORIES) return 0;
	    if (_lodash2.default.get(post, 'trackedAsset.platform') === YOUTUBE) {
	      var latestStatistic = _lodash2.default.last(post.statistics);
	      return latestStatistic.likeCount || 0;
	    }
	    if (_lodash2.default.get(post, 'trackedAsset.platform') === TWITTER) {
	      return post.latestStatistic.likeCount || 0;
	    }
	    if (_lodash2.default.get(post, 'trackedAsset.platform') === INSTAGRAM || _lodash2.default.get(post, 'trackedAsset.platform ') === FACEBOOK) {
	      return post.latestStatistic ? post.latestStatistic.likeCount || 0 : 0;
	    }
	    return 0;
	  });
	};
	
	var getTotalComments = function getTotalComments(posts) {
	  return _lodash2.default.sumBy(posts, function (post) {
	    var isManual = isManualDataOnlyAsset(post);
	    if (isManual) {
	      return (0, _assets.getSupportingDataField)(_lodash2.default.get(post, 'supportingData', []), 'comments', 0);
	    }
	    var isTiktok = _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'TIKTOK');
	    if (isTiktok) {
	      var tiktokData = post.tiktokData,
	          initialData = post.initialData;
	
	      var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
	      var num = _lodash2.default.toNumber(_lodash2.default.get(latestTiktokData, 'commentCount', 0));
	      return num;
	    }
	    if (post.type === STORIES) return 0;
	    if (_lodash2.default.get(post, 'trackedAsset.platform') === YOUTUBE) {
	      var latestStatistic = _lodash2.default.last(post.statistics);
	      return latestStatistic.commentCount || 0;
	    }
	    if (_lodash2.default.get(post, 'trackedAsset.platform') === FACEBOOK) {
	      return post.latestStatistic.commentCount || 0;
	    }
	    if (_lodash2.default.get(post, 'trackedAsset.platform') === INSTAGRAM) {
	      return post.latestStatistic.commentCount || 0;
	    }
	    return 0;
	  });
	};
	
	var getTotalShares = function getTotalShares(posts) {
	  return _lodash2.default.sumBy(posts, function (post) {
	    var isManual = isManualDataOnlyAsset(post);
	    if (isManual) {
	      return (0, _assets.getSupportingDataField)(_lodash2.default.get(post, 'supportingData', []), 'shares', 0);
	    }
	    var isTiktok = _lodash2.default.eq(_lodash2.default.get(post, 'platform'), 'TIKTOK');
	    if (isTiktok) {
	      var tiktokData = post.tiktokData,
	          initialData = post.initialData;
	
	      var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
	      var num = _lodash2.default.toNumber(_lodash2.default.get(latestTiktokData, 'shareCount', 0));
	      return num;
	    }
	    if (post.type === STORIES) return 0;
	    var YT_SHARE_INDEX = 7;
	    var platform = _lodash2.default.get(post, 'trackedAsset.platform');
	
	    if (platform === FACEBOOK) {
	      return post.latestStatistic.shareCount || 0;
	    }
	    if (platform === TWITTER) {
	      return post.latestStatistic.retweetCount || 0;
	    }
	    var insights = _lodash2.default.get(post, 'latestStatistic.insights');
	    if (platform === YOUTUBE && insights) {
	      var shareCount = _lodash2.default.sumBy(insights.viewingByCountry, function (o) {
	        return o[YT_SHARE_INDEX];
	      });
	      return shareCount;
	    }
	    return 0;
	  });
	};
	
	module.exports = {
	  getTotalReach: getTotalReach,
	  getTotalImpressions: getTotalImpressions,
	  getInfluencerCount: getInfluencerCount,
	  getAssetCount: getAssetCount,
	  getTotalViews: getTotalViews,
	  getTotalComments: getTotalComments,
	  getTotalLikes: getTotalLikes,
	  getTotalShares: getTotalShares,
	  getTotalClicks: getTotalClicks
	};

/***/ },
/* 2587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExternalLink = function ExternalLink(_ref) {
	  var post = _ref.post;
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(
	      'a',
	      { target: '_blank', rel: 'noopener noreferrer', href: post.trackedAsset.assetURL },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'external' })
	    ),
	    content: 'view the asset on ' + _lodash2.default.toLower(post.trackedAsset.platform)
	  });
	};
	
	ExternalLink.propTypes = {
	  post: _propTypes2.default.object.isRequired
	};
	
	exports.default = ExternalLink;

/***/ },
/* 2588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FacebookPostType = function FacebookPostType(_ref) {
	  var asset = _ref.asset;
	
	  var pt = void 0;
	  pt = asset.postType;
	
	  if (!pt) {
	    pt = asset.isVideo ? 'video' : 'photo';
	  }
	
	  var types = {
	    video: _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', color: 'blue' }),
	    photo: _react2.default.createElement(_semanticUiReact.Icon, { name: 'image', color: 'blue' }),
	    post: _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment outline', color: 'blue' }),
	    pagepost: _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment outline', color: 'blue' })
	  };
	  return types[pt];
	};
	
	exports.default = FacebookPostType;

/***/ },
/* 2589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dyzioPalette = {
	  pink: '#fc4085',
	  bgPink: '#ffecf3',
	  green: '#20c49e',
	  bgGreen: '#d4faf1',
	  amber: '#fdb02b',
	  bgAmber: '#fff1d5',
	  blue: '#9ad2ff',
	  bgBlue: '#323299'
	};
	
	var VIEWS = 1;
	var MINS = 2;
	var LIKES = 3;
	var COMMENTS = 4;
	var SHARES = 6;
	var ISO = 0;
	
	var UK_AND_IRE = ['GB', 'IE'];
	
	var getEngagements = function getEngagements(vd) {
	  return vd[LIKES] + vd[COMMENTS] + vd[SHARES];
	};
	var getWatchTimeUKIre = function getWatchTimeUKIre(viewingByCountry) {
	  var ukAndIre = _lodash2.default.filter(viewingByCountry, function (vd) {
	    return _lodash2.default.includes(UK_AND_IRE, vd[ISO]);
	  });
	  return _lodash2.default.reduce(ukAndIre, function (result, vd) {
	    return result + vd[MINS];
	  }, 0);
	};
	
	var getDemographics = function getDemographics(data, gender) {
	  var labels = ['age13-17', 'age18-24', 'age25-34', 'age35-44', 'age45-54', 'age55-64', 'age65-'];
	  var demos = _lodash2.default.map(labels, function (label) {
	    var dp = _lodash2.default.find(data, function (d) {
	      if (d[0] === gender && d[1] === label) {
	        return d[2];
	      }
	    });
	    return dp;
	  });
	
	  var xxx = _lodash2.default.map(demos, function (d) {
	    return d && d[2];
	  });
	  return xxx;
	};
	
	var getGenderPercentages = function getGenderPercentages(data) {
	  var maleValues = _lodash2.default.filter(data, function (d) {
	    return d[0] === 'male';
	  });
	  var malePercentage = _lodash2.default.reduce(maleValues, function (sum, d) {
	    return sum + d[2];
	  }, 0);
	  return {
	    male: malePercentage,
	    female: 100 - malePercentage
	  };
	};
	
	var Transformer = {
	  getInfoSection: function getInfoSection(data) {
	    var heroContent = _lodash2.default.find(data.posts, function (p) {
	      return p.trackedAsset.platform === 'YOUTUBE';
	    });
	    return {
	      campaignName: data.name,
	      influencerName: heroContent && heroContent.influencerName,
	      reportDate: new Date()
	    };
	  },
	
	  getHeroPost: function getHeroPost(data) {
	    var heroContent = _lodash2.default.find(data.posts, function (p) {
	      return p.trackedAsset.platform === 'YOUTUBE';
	    });
	    return heroContent;
	  },
	
	  getSupportingActivity: function getSupportingActivity(data) {
	    var filteredPosts = _lodash2.default.filter(data.posts, function (post) {
	      return post.trackedAsset.platform !== 'YOUTUBE';
	    });
	    var supportingActivity = _lodash2.default.map(filteredPosts, function (post) {
	      return {
	        platform: _lodash2.default.toLower(post.trackedAsset.platform),
	        url: post.trackedAsset.assetURL,
	        title: post.text,
	        isVideo: post.isVideo,
	        views: post.latestStatistic.insights && post.latestStatistic.insights.impressions,
	        reach: post.latestStatistic.insights && post.latestStatistic.insights.reach,
	        engagements: post.latestStatistic.insights && post.latestStatistic.insights.engagement,
	        screenshot: post.thumbnail
	      };
	    });
	
	    return supportingActivity;
	  },
	
	  getSummaryData: function getSummaryData(data) {
	    var heroContent = _lodash2.default.find(data.posts, function (p) {
	      return p.trackedAsset.platform === 'YOUTUBE';
	    });
	    var insights = heroContent.latestStatistic.insights;
	    var vbc = insights.viewingByCountry;
	    var heroEngagements = _lodash2.default.reduce(vbc, function (result, vd) {
	      return result + getEngagements(vd);
	    }, 0);
	    var heroViews = heroContent.latestStatistic.viewCount;
	
	    var filteredPosts = _lodash2.default.filter(data.posts, function (post) {
	      return post.trackedAsset.platform !== 'YOUTUBE';
	    });
	
	    return {
	      totalViews: heroViews,
	      totalImpressions: _lodash2.default.reduce(filteredPosts, function (result, post) {
	        var ins = post.latestStatistic.insights;
	        if (!ins) return result;
	        return post.isVideo ? result + (ins.totalVideoImpressions || 0) : result + ins.impressions;
	      }, 0),
	      totalEngagements: heroEngagements + _lodash2.default.reduce(filteredPosts, function (result, post) {
	        var ins = post.latestStatistic.insights;
	        if (!ins) return result;
	        return post.isVideo ? result : result + ins.engagement;
	      }, 0)
	    };
	  },
	
	  getHeroData: function getHeroData(data) {
	    var heroContent = _lodash2.default.find(data.posts, function (p) {
	      return p.trackedAsset.platform === 'YOUTUBE';
	    });
	    var insights = heroContent.latestStatistic.insights;
	    var vbc = _lodash2.default.get(insights, 'viewingByCountry', []);
	    var demoPercentages = _lodash2.default.get(insights, 'audienceDemographics', []);
	    var barData = {
	      labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'],
	      datasets: [{
	        label: 'male %',
	        backgroundColor: dyzioPalette.blue,
	        borderColor: dyzioPalette.bgBlue,
	        borderWidth: 1,
	        data: getDemographics(demoPercentages, 'male')
	      }, {
	        label: 'female %',
	        backgroundColor: dyzioPalette.bgPink,
	        borderColor: dyzioPalette.pink,
	        borderWidth: 1,
	        data: getDemographics(demoPercentages, 'female')
	      }]
	    };
	
	    var genderPercentages = getGenderPercentages(demoPercentages);
	
	    return {
	      title: heroContent.title,
	      subTitle: _lodash2.default.truncate(heroContent.description, {
	        length: 300,
	        separator: ' '
	      }),
	      videoUrl: 'https://www.youtube.com/watch?v=' + heroContent.youtubeVideoId,
	      views: heroContent.latestStatistic.viewCount,
	      engagements: _lodash2.default.reduce(vbc, function (result, vd) {
	        return result + getEngagements(vd);
	      }, 0),
	      watchTimeUKIre: getWatchTimeUKIre(vbc),
	      watchTimeTotal: _lodash2.default.reduce(vbc, function (result, vd) {
	        return result + vd[MINS];
	      }, 0),
	      donutData: {
	        labels: ['male %', 'female %'],
	        datasets: [{
	          data: [genderPercentages.male, genderPercentages.female],
	          backgroundColor: [dyzioPalette.blue, dyzioPalette.bgPink],
	          borderColor: [dyzioPalette.bgBlue, dyzioPalette.pink],
	          borderWidth: 1
	        }]
	      },
	      barData: barData,
	      viewingData: _lodash2.default.map(_lodash2.default.take(vbc, 5), function (vd) {
	        return {
	          name: vd[ISO],
	          watchTime: vd[MINS],
	          views: vd[VIEWS],
	          engagements: getEngagements(vd),
	          likes: vd[LIKES]
	        };
	      })
	    };
	  }
	};
	
	exports.default = Transformer;

/***/ },
/* 2590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _formatting = __webpack_require__(52);
	
	var _notAvailableComponent = __webpack_require__(242);
	
	var _notAvailableComponent2 = _interopRequireDefault(_notAvailableComponent);
	
	var _privateDataComponent = __webpack_require__(379);
	
	var _privateDataComponent2 = _interopRequireDefault(_privateDataComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METRIC_NAME = 'impressions';
	
	var ImpressionsComponent = function ImpressionsComponent(_ref) {
	  var post = _ref.post,
	      inGIMode = _ref.inGIMode;
	  var insights = post.latestStatistic.insights;
	  var estimated = post.estimated;
	
	  var finalImps = _lodash2.default.get(post, 'finalImps');
	  var latestInsights = post.latestInsights;
	  var _post$trackedAsset = post.trackedAsset,
	      platform = _post$trackedAsset.platform,
	      supportingData = _post$trackedAsset.supportingData;
	
	
	  var isReel = post.isReel;
	  if (platform === 'YOUTUBE') {
	    return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: 'video' });
	  }
	
	  if (platform === 'FACEBOOK') {
	    if (insights) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        (0, _formatting.sciFormatted)(insights.impressions || insights.postImpressions)
	      );
	    }
	
	    if (latestInsights) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        (0, _formatting.sciFormatted)(latestInsights.impressions || latestInsights.totalVideoImpressions)
	      );
	    }
	
	    // TODO work out if this is true (no reach and imressions on posts/photos)
	    if (post.postType === 'post' || post.postType === 'photo') {
	      return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: post.postType });
	    }
	
	    return _react2.default.createElement(_privateDataComponent2.default, { post: post });
	  }
	
	  if (platform === 'INSTAGRAM') {
	    if (finalImps && inGIMode) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'B' },
	        (0, _formatting.sciFormatted)(finalImps)
	      );
	    }
	  }
	
	  var hasSupportingData = supportingData && supportingData.length;
	  var hasInsightsError = insights && insights.error;
	  if (platform === 'INSTAGRAM' && hasInsightsError && !hasSupportingData) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(_semanticUiReact.Icon, { color: 'orange', name: 'warning circle' }),
	      content: insights.error.error_user_msg
	    });
	  }
	
	  // this is where ESTIMATED REELS get rendered
	  if (platform === 'INSTAGRAM' && insights && !hasInsightsError) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(post.latestStatistic.insights.impressions)
	    );
	  }
	
	  var latestSupportingData = void 0;
	
	  if (hasSupportingData) {
	    var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
	    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
	      return o.createdDate;
	    }));
	    latestSupportingData = ordered[0];
	  }
	
	  if (latestSupportingData && latestSupportingData.impressions) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(latestSupportingData.impressions)
	    );
	  }
	
	  if (platform === 'INSTAGRAM' && isReel && !estimated) {
	    return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: 'REELS' });
	  }
	
	  if (latestInsights && platform === 'INSTAGRAM') {
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(latestInsights.impressions)
	    );
	  }
	
	  if (platform === 'INSTAGRAM' && !latestSupportingData) {
	    return _react2.default.createElement(_privateDataComponent2.default, { post: post });
	  }
	
	  if (latestInsights && platform === 'TWITTER') {
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(latestInsights.impressions)
	    );
	  }
	
	  return _react2.default.createElement(_notAvailableComponent2.default, {
	    metricName: METRIC_NAME,
	    platform: post.trackedAsset.platform,
	    assetType: post.trackedAsset.assetType
	  });
	};
	
	exports.default = ImpressionsComponent;

/***/ },
/* 2591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGiftaEngagementsRate = exports.getJLEngagementsRate = exports.getEngagementsRate = exports.getPostTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _asaCompliance = __webpack_require__(970);
	
	var _asaCompliance2 = _interopRequireDefault(_asaCompliance);
	
	var _colors = __webpack_require__(380);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paddingTopTen = {
	  margin: 0
	};
	
	var igValueStyle = {
	  fontSize: 20,
	  color: _colors.dyzioPalette.pink,
	  fontWeight: 'bold',
	  padding: 5
	};
	
	var gridStyle = {
	  fontSize: 16,
	  color: 'gray'
	};
	
	var IGValue = function IGValue(_ref) {
	  var value = _ref.value;
	  return _react2.default.createElement(
	    'div',
	    { style: igValueStyle },
	    value
	  );
	};
	
	IGValue.propTypes = {
	  value: _propTypes2.default.string.isRequired
	};
	
	var InfluencerPost = function InfluencerPost(props) {
	  var post = props.post;
	
	  if (!post || !post.trackedAsset || !post.trackedAsset.assetURL) return null;
	
	  var isASA = (0, _asaCompliance2.default)(post.text);
	
	  return _react2.default.createElement(
	    _semanticUiReact.Grid.Column,
	    { textAlign: 'center' },
	    _react2.default.createElement(
	      'a',
	      { href: post.trackedAsset.assetURL, rel: 'noopener noreferrer', target: '_blank' },
	      _react2.default.createElement(_semanticUiReact.Image, { src: post.thumbnail, size: 'tiny', fluid: true }),
	      isASA && _react2.default.createElement(_semanticUiReact.Popup, {
	        trigger: _react2.default.createElement(_semanticUiReact.Label, { size: 'mini', icon: 'check', color: 'green' }),
	        content: 'This confirms that the post includes #ad, #spon, #partner'
	      }),
	      !isASA && _react2.default.createElement(_semanticUiReact.Label, { size: 'mini', icon: 'minus', color: 'grey' })
	    )
	  );
	};
	
	InfluencerPost.propTypes = {
	  post: _propTypes2.default.object.isRequired
	};
	
	var getPostTypes = exports.getPostTypes = function getPostTypes(items) {
	  var isStoryValidation = function isStoryValidation(post) {
	    return _lodash2.default.eq('stories', _lodash2.default.get(post, 'type')) || _lodash2.default.eq('STORY', _lodash2.default.get(post, 'trackedAsset.assetType'));
	  };
	  var stories = _lodash2.default.filter(items, function (post) {
	    return isStoryValidation(post);
	  });
	  var posts = _lodash2.default.reject(items, function (post) {
	    return isStoryValidation(post);
	  });
	  return {
	    stories: _lodash2.default.size(stories),
	    posts: _lodash2.default.size(posts)
	  };
	};
	
	var getImpressions = function getImpressions(posts) {
	  return _lodash2.default.sumBy(posts, function (post) {
	    if (post.type === 'stories') {
	      return _lodash2.default.get(post, 'attributes.latestImpressions', 0);
	    }
	    return _lodash2.default.get(post, 'insights.impressions', 0);
	  });
	};
	
	var getEngagementsRate = exports.getEngagementsRate = function getEngagementsRate(_ref2) {
	  var likes = _ref2.likes,
	      comments = _ref2.comments,
	      postsCount = _ref2.postsCount,
	      followerCount = _ref2.followerCount;
	  return (likes + comments) / postsCount / followerCount * 100;
	};
	
	var getJLEngagementsRate = exports.getJLEngagementsRate = function getJLEngagementsRate(_ref3) {
	  var likes = _ref3.likes,
	      comments = _ref3.comments,
	      impressions = _ref3.impressions;
	  return (likes + comments) / impressions * 100;
	};
	
	var getGiftaEngagementsRate = exports.getGiftaEngagementsRate = function getGiftaEngagementsRate(_ref4) {
	  var likes = _ref4.likes,
	      comments = _ref4.comments,
	      followerCount = _ref4.followerCount;
	  return (likes + comments) / followerCount * 100;
	};
	
	var getReach = function getReach(posts) {
	  return _lodash2.default.sumBy(posts, function (post) {
	    if (post.type === 'stories') {
	      return _lodash2.default.get(post, 'attributes.latestReach', 0);
	    }
	    return _lodash2.default.get(post, 'insights.reach', 0);
	  });
	};
	
	var InfluencerReportCard = function InfluencerReportCard(props) {
	  var _props$value = props.value,
	      values = _props$value.values,
	      handle = _props$value.handle;
	  var posts = values.posts,
	      totals = values.totals,
	      profilePic = values.profilePic;
	
	  var totalImpressions = totals.impressions || getImpressions(posts);
	  var totalReach = totals.reach || getReach(posts);
	  var postTypes = getPostTypes(posts);
	
	  var engagementsRate = getEngagementsRate({
	    likes: totals.likes,
	    comments: totals.comments,
	    postsCount: postTypes.posts,
	    followerCount: totals.followersCount
	  });
	
	  return _react2.default.createElement(
	    _semanticUiReact.Card,
	    { fluid: true, color: 'green' },
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      { style: { backgroundColor: '#eee' } },
	      _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center' } },
	        profilePic && _react2.default.createElement(_semanticUiReact.Image, {
	          circular: true,
	          size: 'tiny',
	          src: profilePic
	        }),
	        _react2.default.createElement(
	          'h3',
	          { style: paddingTopTen },
	          handle
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
	          (0, _formatting.commaFormatted)(totals.followersCount),
	          ' followers'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Card.Content,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { fluid: true, textAlign: 'center', columns: 2, style: gridStyle, divided: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	            'posts',
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(postTypes.posts) })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	            'stories',
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(postTypes.stories) })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'like' }),
	            'likes',
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(totals.likes) })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment' }),
	            'comments',
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(totals.comments) })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'video play outline' }),
	            'views',
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(totals.views) })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'percent' }),
	            'eng. rate',
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	            _react2.default.createElement(IGValue, { value: '' + (engagementsRate ? (0, _formatting.percentFormatted)(engagementsRate) + ' %' : '-') })
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'line graph' }),
	            'reach',
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(totalReach) })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye' }),
	            'imps',
	            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
	            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(totalImpressions) })
	          )
	        )
	      )
	    )
	  );
	};
	
	InfluencerReportCard.propTypes = {
	  value: _propTypes2.default.object.isRequired
	};
	
	exports.default = InfluencerReportCard;

/***/ },
/* 2592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _flatten = __webpack_require__(2739);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _orderBy = __webpack_require__(2749);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _flow = __webpack_require__(401);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _reactChartjs = __webpack_require__(207);
	
	var _influencerReportCard = __webpack_require__(2591);
	
	var _influencerReportCard2 = _interopRequireDefault(_influencerReportCard);
	
	var _reportHeader = __webpack_require__(969);
	
	var _reportHeader2 = _interopRequireDefault(_reportHeader);
	
	var _asaCompliance = __webpack_require__(601);
	
	var _asaCompliance2 = _interopRequireDefault(_asaCompliance);
	
	var _instagramIcon = __webpack_require__(968);
	
	var _instagramIcon2 = _interopRequireDefault(_instagramIcon);
	
	var _externalLink = __webpack_require__(2587);
	
	var _externalLink2 = _interopRequireDefault(_externalLink);
	
	var _unavailableData = __webpack_require__(2598);
	
	var _unavailableData2 = _interopRequireDefault(_unavailableData);
	
	var _formatting = __webpack_require__(52);
	
	var _colors = __webpack_require__(380);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var chartOptions = {
	  legend: {
	    position: 'left'
	  }
	};
	
	var theRestChartColours = {
	  main: 'rgba(140, 140, 140, .7)',
	  background: 'rgba(140, 140, 140, 1)'
	};
	
	var EmptyDataComponent = function EmptyDataComponent() {
	  return _react2.default.createElement(_unavailableData2.default, { iconName: 'circle thin', iconColor: 'grey', content: 'This channel does not support this data.' });
	};
	
	var hostname = _lodash2.default.toLower(window.location.hostname);
	var isVoxo = hostname.match(/voxogram/);
	var isGifta = hostname.match(/gifta/);
	var platformName = isVoxo ? 'voxogram' : 'dyzio';
	var platformUrl = isVoxo ? 'www.voxogram.com' : 'dyzio.co';
	
	var PrivateDataComponent = function PrivateDataComponent() {
	  return _react2.default.createElement(_unavailableData2.default, {
	    iconName: 'lock', iconColor: 'orange', content: 'This is private data.\n            You need to ask the influencer to log in and authorise\n            ' + platformName + ' to fetch it for you.'
	  });
	};
	
	var getTopFivePieChartData = function getTopFivePieChartData(all, valueKey) {
	  var firstFive = _lodash2.default.take(all, 5);
	  var lastFive = _lodash2.default.slice(all, 5);
	
	  var labels = _lodash2.default.map(firstFive, 'handle');
	
	  var data = _lodash2.default.map(firstFive, function (item) {
	    return _lodash2.default.get(item, 'values.totals.' + valueKey, 0);
	  });
	
	  labels.push('the rest');
	  data.push(_lodash2.default.sumBy(lastFive, 'values.totals.' + valueKey));
	
	  var bgColors = _lodash2.default.map(firstFive, 'colors.mainColor');
	  var borderColors = _lodash2.default.map(firstFive, 'colors.borderColor');
	
	  return {
	    labels: labels,
	    datasets: [{
	      data: data,
	      backgroundColor: [].concat((0, _toConsumableArray3.default)(bgColors), [theRestChartColours.main]),
	      borderColor: [].concat((0, _toConsumableArray3.default)(borderColors), [theRestChartColours.background]),
	      borderWidth: 1
	    }]
	  };
	};
	
	var totalStyles = {
	  backgroundColor: 'rgba(0,0,0,.05)',
	  fontWeight: 'bold'
	};
	
	var getSortField = function getSortField(key) {
	  var values = {
	    'values.totals.followersCount': 'followerCount',
	    'values.totals.likes': 'likeCount',
	    'values.totals.comments': 'commentCount',
	    'values.totals.views': 'viewCount'
	  };
	  return values[key];
	};
	var summaryStyle = {
	  marginBottom: 50
	};
	var rightBordered = {
	  borderRight: '1px solid #e0e0e0',
	  marginLeft: -1
	};
	var textTransformNormal = {
	  textTransform: 'none'
	};
	var mostEffectiveStyle = {
	  textAlign: 'center',
	  padding: 10,
	  backgroundColor: _colors.dyzioPalette.white
	};
	
	var ReportRowIG = function ReportRowIG(_ref) {
	  var post = _ref.post;
	
	  var isStory = post.type === 'stories';
	  return _react2.default.createElement(
	    _semanticUiReact.Table.Row,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_instagramIcon2.default, { post: post })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      post.influencerName || post.handle
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      { textAlign: 'left' },
	      post.text
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.commaFormatted)(post.viewCount)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.commaFormatted)(_lodash2.default.get(post, isStory ? 'attributes.latestImpressions' : 'insights.impressions', 0))
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.commaFormatted)(_lodash2.default.get(post, isStory ? 'attributes.latestReach' : 'insights.reach', 0))
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.commaFormatted)(post.likeCount)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(EmptyDataComponent, null)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      (0, _formatting.commaFormatted)(post.commentCount)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(EmptyDataComponent, null)
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_asaCompliance2.default, { text: post.text })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Table.Cell,
	      null,
	      _react2.default.createElement(_externalLink2.default, { post: post })
	    )
	  );
	};
	
	var InstagramReport = function InstagramReport(props) {
	  var _props$data$data = props.data.data,
	      name = _props$data$data.name,
	      createdBy = _props$data$data.createdBy,
	      influencers = _props$data$data.influencers,
	      postsCount = _props$data$data.postsCount,
	      liveDate = _props$data$data.liveDate,
	      endDate = _props$data$data.endDate,
	      totalViews = _props$data$data.totalViews,
	      totalLikes = _props$data$data.totalLikes,
	      totalComments = _props$data$data.totalComments,
	      posts = _props$data$data.posts;
	  var sort = props.sort,
	      groupBy = props.groupBy,
	      onSortChanged = props.onSortChanged,
	      onGroupByChanged = props.onGroupByChanged,
	      withHeader = props.withHeader;
	
	
	  var allPosts = _lodash2.default.compact(_lodash2.default.reduce(posts, function (result, item) {
	    result.push(item.posts);
	    return result;
	  }, []));
	
	  var ungroupedPosts = (0, _flow2.default)(_flatten2.default, (0, _orderBy2.default)(function (it) {
	    var key = getSortField(sort);
	    return it[key] || 0;
	  }, ['desc']))(_lodash2.default.compact(allPosts));
	
	  var items = _lodash2.default.map(posts, function (values, handle) {
	    var position = _lodash2.default.keys(posts).indexOf(handle);
	    return { handle: handle, values: values, colors: (0, _colors.getRowColors)(position) };
	  });
	
	  var totalImpressions = _lodash2.default.sumBy(ungroupedPosts, function (item) {
	    var isStory = _lodash2.default.get(item, 'type', null) === 'stories';
	    if (isStory) {
	      if (_lodash2.default.has(item, 'attributes.storyData') && _lodash2.default.last(_lodash2.default.get(item, 'attributes.storyData'))) {
	        var storyData = _lodash2.default.last(_lodash2.default.get(item, 'attributes.storyData'));
	        return _lodash2.default.get(storyData, 'impressions', 0);
	      }
	      if (_lodash2.default.has(item, 'trackedAsset.insights.impressions')) {
	        return _lodash2.default.get(item, 'trackedAsset.insights.impressions', 0);
	      }
	      if (_lodash2.default.has(item, 'attributes.latestImpressions')) {
	        return _lodash2.default.get(item, 'attributes.latestImpressions', 0);
	      }
	    }
	    return _lodash2.default.get(item, 'insights.impressions', 0);
	  });
	
	  var totalReach = _lodash2.default.sumBy(ungroupedPosts, function (item) {
	    var isStory = _lodash2.default.get(item, 'type', null) === 'stories';
	    if (isStory) {
	      if (_lodash2.default.has(item, 'attributes.storyData') && _lodash2.default.last(_lodash2.default.get(item, 'attributes.storyData'))) {
	        var storyData = _lodash2.default.last(_lodash2.default.get(item, 'attributes.storyData'));
	        return _lodash2.default.get(storyData, 'reach', 0);
	      }
	      if (_lodash2.default.has(item, 'trackedAsset.insights.reach')) {
	        return _lodash2.default.get(item, 'trackedAsset.insights.reach', 0);
	      }
	      if (_lodash2.default.has(item, 'attributes.latestReach')) {
	        return _lodash2.default.get(item, 'attributes.latestReach', 0);
	      }
	    }
	    return _lodash2.default.get(item, 'insights.reach', 0);
	  });
	
	  // console.log(`totalReach=${totalReach}`);
	
	  var menuOptions = [{
	    onClick: onSortChanged,
	    key: 'folowers',
	    active: sort === 'values.totals.followersCount',
	    value: 'values.totals.followersCount',
	    name: 'followers',
	    icon: 'user'
	  }, {
	    onClick: onSortChanged,
	    key: 'likes',
	    active: sort === 'values.totals.likes',
	    value: 'values.totals.likes',
	    name: 'likes',
	    icon: 'empty heart'
	  }, {
	    onClick: onSortChanged,
	    key: 'comments',
	    active: sort === 'values.totals.comments',
	    value: 'values.totals.comments',
	    name: 'comments',
	    icon: 'comments outline'
	  }, {
	    onClick: onSortChanged,
	    key: 'views',
	    active: sort === 'values.totals.views',
	    value: 'values.totals.views',
	    name: 'views',
	    icon: 'video play'
	  }, {
	    onClick: onGroupByChanged,
	    key: 'influencer',
	    active: groupBy === 'influencer',
	    position: 'right',
	    value: 'influencer',
	    name: 'influencer',
	    icon: 'user circle outline'
	  }, {
	    onClick: onGroupByChanged,
	    key: 'none',
	    active: groupBy === 'none',
	    value: 'none',
	    name: 'none',
	    icon: 'circle outline'
	  }];
	
	  var orderedByLikes = _lodash2.default.orderBy(items, 'values.totals.likes', 'desc');
	  var orderedByComments = _lodash2.default.orderBy(items, 'values.totals.comments', 'desc');
	  var orderedByViews = _lodash2.default.orderBy(items, 'values.totals.views', 'desc');
	
	  var likesChartData = getTopFivePieChartData(orderedByLikes, 'likes');
	  var commentsChartData = getTopFivePieChartData(orderedByComments, 'comments');
	  var viewsChartData = getTopFivePieChartData(orderedByViews, 'views');
	
	  var views = _lodash2.default.head(viewsChartData.datasets).data;
	  var shouldDisplayViewsChart = _lodash2.default.find(views, function (x) {
	    return x > 0;
	  });
	
	  var isEmptyCampaign = _lodash2.default.size(posts) === 0;
	
	  var noBorderTop = {
	    borderTop: 'none'
	  };
	
	  var headerInfo = {
	    hasLogo: false,
	    campaignName: name,
	    reportDate: liveDate,
	    reportType: 'Instagram',
	    liveDate: liveDate,
	    endDate: endDate
	  };
	  return _react2.default.createElement(
	    'div',
	    null,
	    isEmptyCampaign && _react2.default.createElement(
	      _semanticUiReact.Message,
	      { icon: 'icon', warning: 'warning' },
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning' }),
	      _react2.default.createElement(
	        _semanticUiReact.Message.Content,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Message.Header,
	          null,
	          'Warning'
	        ),
	        'No Instagram posts included in this campaign'
	      )
	    ),
	    withHeader && _react2.default.createElement(
	      _semanticUiReact.Card,
	      { fluid: 'fluid', color: 'pink' },
	      _react2.default.createElement(
	        _semanticUiReact.Card.Content,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Message,
	          { icon: 'icon' },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file text outline', color: 'pink' }),
	          _react2.default.createElement(
	            _semanticUiReact.Message.Content,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Message.Header,
	              null,
	              name
	            ),
	            'created by ',
	            createdBy
	          )
	        ),
	        _react2.default.createElement(_reportHeader2.default, { info: headerInfo })
	      )
	    ),
	    !isEmptyCampaign && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: 'fluid', style: summaryStyle, color: 'pink' },
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          { style: noBorderTop },
	          _react2.default.createElement(
	            _semanticUiReact.Card.Header,
	            null,
	            'Campaign Summary'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Meta,
	            null,
	            'engagements and viewing across Instagram'
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Statistic.Group,
	            { color: 'pink', widths: 6 },
	            _react2.default.createElement(
	              _semanticUiReact.Statistic,
	              { style: rightBordered },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Value,
	                { style: textTransformNormal },
	                (0, _formatting.sciFormatted)(influencers)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Label,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'user circle outline' }),
	                'influencers'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Statistic,
	              { style: rightBordered },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Value,
	                { style: textTransformNormal },
	                (0, _formatting.sciFormatted)(totalViews)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Label,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'video play outline' }),
	                'views'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Statistic,
	              { style: rightBordered },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Value,
	                { style: textTransformNormal },
	                (0, _formatting.sciFormatted)(totalComments)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Label,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment' }),
	                'comments'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Statistic,
	              { style: rightBordered },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Value,
	                { style: textTransformNormal },
	                (0, _formatting.sciFormatted)(totalLikes)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Label,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'like' }),
	                'likes'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Statistic,
	              { style: rightBordered },
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Value,
	                { style: textTransformNormal },
	                (0, _formatting.sciFormatted)(postsCount)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Label,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
	                'assets'
	              )
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Statistic,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Value,
	                { style: textTransformNormal },
	                (0, _formatting.sciFormatted)(totalImpressions)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Statistic.Label,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye' }),
	                'impressions'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            'h3',
	            { style: mostEffectiveStyle },
	            'Who was the most effective influencer?'
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid,
	            {
	              columns: shouldDisplayViewsChart ? 3 : 2, divided: 'divided', textAlign: 'center'
	            },
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                null,
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'likes by influencer'
	                ),
	                _react2.default.createElement(_reactChartjs.Doughnut, { data: likesChartData, options: chartOptions })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                null,
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'comments by influencer'
	                ),
	                _react2.default.createElement(_reactChartjs.Doughnut, { data: commentsChartData, options: chartOptions })
	              ),
	              shouldDisplayViewsChart && _react2.default.createElement(
	                _semanticUiReact.Grid.Column,
	                null,
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'views by influencer (videos only)'
	                ),
	                _react2.default.createElement(_reactChartjs.Doughnut, { data: viewsChartData, options: chartOptions })
	              )
	            )
	          )
	        ),
	        !isGifta && _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          { textAlign: 'center' },
	          _react2.default.createElement(
	            'a',
	            { rel: 'noopener noreferrer', href: 'https://' + platformUrl, target: '_blank' },
	            'influencer analytics - powered by ',
	            platformName
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 8 },
	            _react2.default.createElement(
	              'b',
	              null,
	              'SORT BY'
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 8, textAlign: 'right' },
	            _react2.default.createElement(
	              'b',
	              null,
	              'GROUP BY'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_semanticUiReact.Menu, { items: menuOptions }),
	      (!groupBy || groupBy === 'influencer') && _react2.default.createElement(
	        _semanticUiReact.Card.Group,
	        { itemsPerRow: 4 },
	        _lodash2.default.map(_lodash2.default.orderBy(items, sort, 'desc'), function (value, idx) {
	          return _react2.default.createElement(_influencerReportCard2.default, { value: value, key: idx });
	        })
	      ),
	      groupBy && groupBy === 'none' && _react2.default.createElement(
	        _semanticUiReact.Card,
	        { fluid: 'fluid' },
	        _react2.default.createElement(
	          _semanticUiReact.Table,
	          {
	            singleLine: 'singleLine', celled: 'celled', fixed: 'fixed', basic: 'very', size: 'small', textAlign: 'center', style: {
	              marginTop: 20
	            }
	          },
	          _react2.default.createElement(
	            _semanticUiReact.Table.Header,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'platform'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'influencer'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'title'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'views'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'impressions'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'reach'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'thumbs up', color: 'grey' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'thumbs down', color: 'grey' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'comments', color: 'grey' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'share', color: 'grey' })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                _react2.default.createElement(_semanticUiReact.Popup, {
	                  trigger: _react2.default.createElement(
	                    'span',
	                    null,
	                    ' ',
	                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'grey' }),
	                    ' #ad ? '
	                  ), content: 'This confirms that the post includes #ad, #spon, #partner'
	                })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.HeaderCell,
	                null,
	                'view'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Table.Body,
	            null,
	            _lodash2.default.map(ungroupedPosts, function (post) {
	              return _react2.default.createElement(ReportRowIG, { post: post });
	            }),
	            _react2.default.createElement(
	              _semanticUiReact.Table.Row,
	              { style: totalStyles },
	              _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	              _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	              _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                (0, _formatting.sciFormatted)(_lodash2.default.sumBy(ungroupedPosts, 'viewCount'))
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                (0, _formatting.sciFormatted)(totalImpressions)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                (0, _formatting.sciFormatted)(totalReach)
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                (0, _formatting.sciFormatted)(_lodash2.default.sumBy(ungroupedPosts, 'likeCount'))
	              ),
	              _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	              _react2.default.createElement(
	                _semanticUiReact.Table.Cell,
	                null,
	                (0, _formatting.sciFormatted)(_lodash2.default.sumBy(ungroupedPosts, 'commentCount'))
	              ),
	              _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	              _react2.default.createElement(_semanticUiReact.Table.Cell, null),
	              _react2.default.createElement(_semanticUiReact.Table.Cell, null)
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	InstagramReport.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  sort: _propTypes2.default.string.isRequired,
	  groupBy: _propTypes2.default.string.isRequired,
	  onSortChanged: _propTypes2.default.func.isRequired,
	  onGroupByChanged: _propTypes2.default.func.isRequired,
	  withHeader: _propTypes2.default.bool.isRequired
	};
	
	InstagramReport.defaultProps = {
	  withHeader: false
	};
	
	exports.default = InstagramReport;

/***/ },
/* 2593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _formatting = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NumberComponent = function NumberComponent(_ref) {
	  var number = _ref.number,
	      label = _ref.label;
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(number)
	    ),
	    content: (0, _formatting.commaFormatted)(number) + ' ' + label
	  });
	};
	
	NumberComponent.propTypes = {
	  number: _propTypes2.default.number.isRequired,
	  label: _propTypes2.default.string.isRequired
	};
	
	exports.default = NumberComponent;

/***/ },
/* 2594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _formatting = __webpack_require__(52);
	
	var _notAvailableComponent = __webpack_require__(242);
	
	var _notAvailableComponent2 = _interopRequireDefault(_notAvailableComponent);
	
	var _privateDataComponent = __webpack_require__(379);
	
	var _privateDataComponent2 = _interopRequireDefault(_privateDataComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METRIC_NAME = 'reach';
	var ReachComponent = function ReachComponent(_ref) {
	  var post = _ref.post,
	      inGIMode = _ref.inGIMode;
	  var insights = post.latestStatistic.insights;
	  var latestInsights = post.latestInsights,
	      estimated = post.estimated;
	
	
	  var isReel = post.isReel;
	
	  var _post$trackedAsset = post.trackedAsset,
	      platform = _post$trackedAsset.platform,
	      supportingData = _post$trackedAsset.supportingData;
	
	
	  if (platform === 'YOUTUBE') {
	    return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: 'video' });
	  }
	
	  var hasSupportingData = supportingData && supportingData.length;
	  var hasInsightsError = insights && insights.error;
	  if (platform === 'INSTAGRAM' && hasInsightsError && !hasSupportingData) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      trigger: _react2.default.createElement(_semanticUiReact.Icon, { color: 'orange', name: 'warning circle' }),
	      content: insights.error.error_user_msg
	    });
	  }
	
	  if ((platform === 'INSTAGRAM' || platform === 'FACEBOOK') && inGIMode && _lodash2.default.has(post, 'finalReach')) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(_lodash2.default.get(post, 'finalReach'))
	    );
	  }
	
	  // this is where ESTIMATED REELS get rendered
	  if (platform === 'INSTAGRAM' && insights && !hasInsightsError) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(post.latestStatistic.insights.reach)
	    );
	  }
	
	  var latestSupportingData = void 0;
	
	  if (hasSupportingData) {
	    var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
	    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
	      return o.createdDate;
	    }));
	    latestSupportingData = ordered[0];
	  }
	
	  if (insights && platform === 'FACEBOOK') {
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(insights.reach || insights.postImpressionsUnique)
	    );
	  }
	
	  if (latestInsights && platform === 'FACEBOOK') {
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(latestInsights.reach || latestInsights.totalVideoImpressionsUnique)
	    );
	  }
	
	  if (latestInsights && platform === 'TWITTER') {
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(latestInsights.reach)
	    );
	  }
	
	  if (latestInsights && platform === 'INSTAGRAM') {
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(latestInsights.reach)
	    );
	  }
	
	  if (latestSupportingData) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(latestSupportingData.reach)
	    );
	  }
	
	  if (platform === 'INSTAGRAM' && isReel && !estimated) {
	    return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: 'REELS' });
	  }
	
	  if (platform === 'INSTAGRAM' && !latestSupportingData) {
	    return _react2.default.createElement(_privateDataComponent2.default, { post: post });
	  }
	
	  return _react2.default.createElement(_notAvailableComponent2.default, {
	    metricName: METRIC_NAME,
	    platform: post.trackedAsset.platform,
	    assetType: post.trackedAsset.assetType
	  });
	};
	
	exports.default = ReachComponent;

/***/ },
/* 2595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _formatting = __webpack_require__(52);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _notAvailableComponent = __webpack_require__(242);
	
	var _notAvailableComponent2 = _interopRequireDefault(_notAvailableComponent);
	
	var _privateDataComponent = __webpack_require__(379);
	
	var _privateDataComponent2 = _interopRequireDefault(_privateDataComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METRIC_NAME = 'shares';
	var SHARE_INDEX = 7; // shares is indexed 7 in the YT data
	
	var SharesComponent = function SharesComponent(_ref) {
	  var post = _ref.post,
	      inGIMode = _ref.inGIMode;
	
	  var _ref2 = post.latestStatistic || {},
	      insights = _ref2.insights;
	
	  var _ref3 = post.trackedAsset || {},
	      platform = _ref3.platform,
	      supportingData = _ref3.supportingData,
	      assetType = _ref3.assetType;
	
	  if (platform === 'YOUTUBE' && insights) {
	    var shareCount = _lodash2.default.sumBy(insights.viewingByCountry, function (o) {
	      return o[SHARE_INDEX];
	    });
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(shareCount)
	    );
	  }
	
	  if (platform === 'YOUTUBE') {
	    return _react2.default.createElement(_privateDataComponent2.default, { post: post });
	  }
	
	  // TODO - figure this out as well.
	  if (platform === 'FACEBOOK') {
	    if (post.postType === 'post') {
	      return _react2.default.createElement(
	        'span',
	        null,
	        (0, _formatting.sciFormatted)(post.latestStatistic.shareCount)
	      );
	    }
	
	    return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: 'video' });
	  }
	
	  if ((_lodash2.default.isEqual(_lodash2.default.get(post, 'type'), 'stories') || platform === 'INSTAGRAM') && inGIMode) {
	    if (post.finalClicks) {
	      return post.finalClicks;
	    }
	    if (post.type === 'stories') {
	      var _$get = _lodash2.default.get(post, 'relationships'),
	          data = _$get.supportingData.data;
	
	      var finalClicks = _lodash2.default.get(post, 'attributes.finalClicks');
	      var _latestSupportingData = _lodash2.default.last(data) || {};
	      return _react2.default.createElement(
	        'span',
	        null,
	        inGIMode && finalClicks ? finalClicks : _lodash2.default.get(_latestSupportingData, 'attributes.clicks') || post.attributes.finalClicks || '-'
	      );
	    }
	    if (post.trackedAsset) {
	      var iGSupportingData = post.trackedAsset.iGSupportingData;
	
	      if (iGSupportingData) {
	        var filtered = _lodash2.default.filter(iGSupportingData, 'createdDate'); // remove the GraphQL null at [0]
	        var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
	          return o.createdDate;
	        }));
	        var _latestSupportingData2 = ordered[0];
	        return _react2.default.createElement(
	          'span',
	          null,
	          _latestSupportingData2 ? _latestSupportingData2.clicks : '-'
	        );
	      }
	    }
	    return _react2.default.createElement(
	      'span',
	      null,
	      '-'
	    );
	  }
	
	  if (platform === 'INSTAGRAM' && assetType === 'STORY') {
	    return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: 'story' });
	  }
	
	  if (platform === 'INSTAGRAM') {
	    return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: 'post' });
	  }
	
	  var latestSupportingData = void 0;
	
	  if (supportingData && supportingData.length) {
	    console.log(supportingData);
	    var _filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
	    var _ordered = _lodash2.default.reverse(_lodash2.default.sortBy(_filtered, function (o) {
	      return o.createdDate;
	    }));
	    latestSupportingData = _ordered[0];
	  }
	
	  if (latestSupportingData) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      (0, _formatting.sciFormatted)(latestSupportingData.impressions)
	    );
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline', color: 'grey' });
	};
	
	exports.default = SharesComponent;

/***/ },
/* 2596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _formatting = __webpack_require__(52);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bucket = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/';
	
	var leftAlign = {
	  textAlign: 'left'
	};
	
	var fromNow = function fromNow(date) {
	  return (0, _moment2.default)(date).fromNow();
	};
	var smallFont = {
	  fontSize: '60%'
	};
	
	var dyzioGreen = {
	  color: '#20c49e'
	};
	
	var PopupContent = function PopupContent(_ref) {
	  var supportingData = _ref.supportingData;
	  var reach = supportingData.reach,
	      impressions = supportingData.impressions,
	      createdBy = supportingData.createdBy,
	      createdDate = supportingData.createdDate,
	      actions = supportingData.actions,
	      engagements = supportingData.engagements,
	      clicks = supportingData.clicks;
	
	  var imageSrc = '' + bucket + supportingData.filePath;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_semanticUiReact.Image, { src: imageSrc, bordered: true, width: 600 }),
	    _react2.default.createElement(
	      'table',
	      { style: { width: '100%', marginTop: '5px', border: '1px solid #ccc', padding: '3px', backgroundColor: '#eee' } },
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            { style: leftAlign },
	            'reach'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            (0, _formatting.sciFormatted)(reach)
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            { style: leftAlign },
	            'impressions'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            (0, _formatting.sciFormatted)(impressions)
	          )
	        ),
	        clicks && _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            { style: leftAlign },
	            'clicks'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            (0, _formatting.sciFormatted)(clicks)
	          )
	        ),
	        engagements && _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            { style: leftAlign },
	            'engagements'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            (0, _formatting.sciFormatted)(engagements)
	          )
	        ),
	        actions && _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            { style: leftAlign },
	            'actions'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            (0, _formatting.sciFormatted)(actions)
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            { colSpan: 2, style: { fontSize: '80%', borderTop: '1px solid #ccc', textAlign: 'center' } },
	            'data added manually by ',
	            createdBy,
	            _react2.default.createElement('br', null),
	            fromNow(createdDate)
	          )
	        )
	      )
	    )
	  );
	};
	
	var SourceComponent = function SourceComponent(_ref2) {
	  var post = _ref2.post,
	      voxi = _ref2.voxi;
	  var insights = post.latestStatistic.insights;
	  var _post$trackedAsset = post.trackedAsset,
	      platform = _post$trackedAsset.platform,
	      supportingData = _post$trackedAsset.supportingData;
	
	
	  var latestSupportingData = void 0;
	
	  if (supportingData && supportingData.length) {
	    console.log(supportingData);
	    var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
	    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
	      return o.createdDate;
	    }));
	    latestSupportingData = ordered[0];
	  }
	
	  if (insights) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      hoverable: true,
	      trigger: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: dyzioGreen },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlock alternate' }),
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'feed' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: smallFont },
	          fromNow(post.latestStatistic.createdDate)
	        )
	      ),
	      content: 'Authorised data collected from the ' + _lodash2.default.capitalize(platform) + ' API ' + fromNow(post.latestStatistic.createdDate)
	    });
	  }
	
	  if (voxi) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      hoverable: true,
	      trigger: _react2.default.createElement(
	        'div',
	        { style: dyzioGreen },
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'file image outline', color: 'pink', size: 'large' })
	      ),
	      content: _react2.default.createElement(PopupContent, {
	        supportingData: latestSupportingData
	      })
	    });
	  }
	
	  if (latestSupportingData) {
	    return _react2.default.createElement(_semanticUiReact.Popup, {
	      hoverable: true,
	      size: 'huge',
	      trigger: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: dyzioGreen },
	          _react2.default.createElement(_semanticUiReact.Icon, { name: 'cloud upload' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: smallFont },
	          fromNow(latestSupportingData.createdDate)
	        )
	      ),
	      content: _react2.default.createElement(PopupContent, {
	        supportingData: latestSupportingData
	      })
	    });
	  }
	
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'world', color: 'grey' }),
	        _react2.default.createElement(_semanticUiReact.Icon, { name: 'feed', color: 'grey' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: smallFont },
	        fromNow(post.latestStatistic.createdDate)
	      )
	    ),
	    content: 'Public data collected from the ' + _lodash2.default.capitalize(platform) + ' API ' + fromNow(post.latestStatistic.createdDate)
	  });
	};
	
	exports.default = SourceComponent;

/***/ },
/* 2597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _lodash = __webpack_require__(31);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwitterPostType = function TwitterPostType(_ref) {
	  var post = _ref.asset;
	
	  var tweetMedia = _lodash2.default.get(post, 'entities.media') || [];
	  var mainTweetMedia = _lodash2.default.head(tweetMedia);
	  var mediaUrl = _lodash2.default.get(mainTweetMedia, 'expanded_url');
	
	  var postType = 'post';
	
	  if (_lodash2.default.includes(mediaUrl, 'video')) {
	    postType = 'video';
	  }
	  if (_lodash2.default.includes(mediaUrl, 'photo')) {
	    postType = 'photo';
	  }
	
	  var types = {
	    video: _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', color: 'blue' }),
	    photo: _react2.default.createElement(_semanticUiReact.Icon, { name: 'image', color: 'blue' }),
	    post: _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment outline', color: 'blue' }),
	    pagepost: _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment outline', color: 'blue' })
	  };
	
	  return types[postType] || null;
	};
	
	exports.default = TwitterPostType;

/***/ },
/* 2598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnavailableData = function UnavailableData(props) {
	  var iconName = props.iconName,
	      iconColor = props.iconColor,
	      content = props.content;
	
	  return _react2.default.createElement(_semanticUiReact.Popup, {
	    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: iconName, color: iconColor }),
	    content: content
	  });
	};
	
	UnavailableData.propTypes = {
	  iconName: _propTypes2.default.string.isRequired,
	  iconColor: _propTypes2.default.string.isRequired,
	  content: _propTypes2.default.string.isRequired
	};
	
	exports.default = UnavailableData;

/***/ },
/* 2599 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsonwebtoken = __webpack_require__(2951);
	
	var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAuthToken = function getAuthToken() {
	  var user = {
	    app_metadata: {
	      roles: ['admin'],
	      dyzio: {
	        u_id: 'c9b88fbf-e8c7-49e5-9641-fab85fd0b863',
	        name: 'Laurie Bantin',
	        email: 'laurie@dyzio.co',
	        o_id: '6c1b653e-d704-4055-acc7-79f280f523f6'
	      }
	    }
	  };
	
	  var options = {
	    audience: 'MxuEZkaXquZnlJeL9oE8QhyQzhMtjfTp',
	    issuer: 'dyzio.eu.auth0.com',
	    expiresIn: 10000
	  };
	
	  return _jsonwebtoken2.default.sign(user, Buffer.from('WXRhOW5rQ3ExVFJXejBmSFVmNFB2Q0xFeUJFcTJHdkJQMGdGUnFwdHJXMVYwUktDWU1mYlRkMnNCcmFrVXZ4Vw==', 'base64'), options);
	};
	
	exports.default = getAuthToken;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58).Buffer))

/***/ },
/* 2600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isNetworkError = isNetworkError;
	exports.isRetryableError = isRetryableError;
	exports.isSafeRequestError = isSafeRequestError;
	exports.isIdempotentRequestError = isIdempotentRequestError;
	exports.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
	exports.exponentialDelay = exponentialDelay;
	exports.default = axiosRetry;
	
	var _isRetryAllowed = __webpack_require__(1289);
	
	var _isRetryAllowed2 = _interopRequireDefault(_isRetryAllowed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var namespace = 'axios-retry';
	
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	function isNetworkError(error) {
	  return !error.response && Boolean(error.code) && // Prevents retrying cancelled requests
	  error.code !== 'ECONNABORTED' && // Prevents retrying timed out requests
	  (0, _isRetryAllowed2.default)(error); // Prevents retrying unsafe errors
	}
	
	var SAFE_HTTP_METHODS = ['get', 'head', 'options'];
	var IDEMPOTENT_HTTP_METHODS = SAFE_HTTP_METHODS.concat(['put', 'delete']);
	
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	function isRetryableError(error) {
	  return error.code !== 'ECONNABORTED' && (!error.response || error.response.status >= 500 && error.response.status <= 599);
	}
	
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	function isSafeRequestError(error) {
	  if (!error.config) {
	    // Cannot determine if the request can be retried
	    return false;
	  }
	
	  return isRetryableError(error) && SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
	}
	
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	function isIdempotentRequestError(error) {
	  if (!error.config) {
	    // Cannot determine if the request can be retried
	    return false;
	  }
	
	  return isRetryableError(error) && IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
	}
	
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	function isNetworkOrIdempotentRequestError(error) {
	  return isNetworkError(error) || isIdempotentRequestError(error);
	}
	
	/**
	 * @return {number} - delay in milliseconds, always 0
	 */
	function noDelay() {
	  return 0;
	}
	
	/**
	 * @param  {number} [retryNumber=0]
	 * @return {number} - delay in milliseconds
	 */
	function exponentialDelay() {
	  var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  var delay = Math.pow(2, retryNumber) * 100;
	  var randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
	  return delay + randomSum;
	}
	
	/**
	 * Initializes and returns the retry state for the given request/config
	 * @param  {AxiosRequestConfig} config
	 * @return {Object}
	 */
	function getCurrentState(config) {
	  var currentState = config[namespace] || {};
	  currentState.retryCount = currentState.retryCount || 0;
	  config[namespace] = currentState;
	  return currentState;
	}
	
	/**
	 * Returns the axios-retry options for the current request
	 * @param  {AxiosRequestConfig} config
	 * @param  {AxiosRetryConfig} defaultOptions
	 * @return {AxiosRetryConfig}
	 */
	function getRequestOptions(config, defaultOptions) {
	  return Object.assign({}, defaultOptions, config[namespace]);
	}
	
	/**
	 * @param  {Axios} axios
	 * @param  {AxiosRequestConfig} config
	 */
	function fixConfig(axios, config) {
	  if (axios.defaults.agent === config.agent) {
	    delete config.agent;
	  }
	  if (axios.defaults.httpAgent === config.httpAgent) {
	    delete config.httpAgent;
	  }
	  if (axios.defaults.httpsAgent === config.httpsAgent) {
	    delete config.httpsAgent;
	  }
	}
	
	/**
	 * Adds response interceptors to an axios instance to retry requests failed due to network issues
	 *
	 * @example
	 *
	 * import axios from 'axios';
	 *
	 * axiosRetry(axios, { retries: 3 });
	 *
	 * axios.get('http://example.com/test') // The first request fails and the second returns 'ok'
	 *   .then(result => {
	 *     result.data; // 'ok'
	 *   });
	 *
	 * // Exponential back-off retry delay between requests
	 * axiosRetry(axios, { retryDelay : axiosRetry.exponentialDelay});
	 *
	 * // Custom retry delay
	 * axiosRetry(axios, { retryDelay : (retryCount) => {
	 *   return retryCount * 1000;
	 * }});
	 *
	 * // Also works with custom axios instances
	 * const client = axios.create({ baseURL: 'http://example.com' });
	 * axiosRetry(client, { retries: 3 });
	 *
	 * client.get('/test') // The first request fails and the second returns 'ok'
	 *   .then(result => {
	 *     result.data; // 'ok'
	 *   });
	 *
	 * // Allows request-specific configuration
	 * client
	 *   .get('/test', {
	 *     'axios-retry': {
	 *       retries: 0
	 *     }
	 *   })
	 *   .catch(error => { // The first request fails
	 *     error !== undefined
	 *   });
	 *
	 * @param {Axios} axios An axios instance (the axios object or one created from axios.create)
	 * @param {Object} [defaultOptions]
	 * @param {number} [defaultOptions.retries=3] Number of retries
	 * @param {boolean} [defaultOptions.shouldResetTimeout=false]
	 *        Defines if the timeout should be reset between retries
	 * @param {Function} [defaultOptions.retryCondition=isNetworkOrIdempotentRequestError]
	 *        A function to determine if the error can be retried
	 * @param {Function} [defaultOptions.retryDelay=noDelay]
	 *        A function to determine the delay between retry requests
	 */
	function axiosRetry(axios, defaultOptions) {
	  axios.interceptors.request.use(function (config) {
	    var currentState = getCurrentState(config);
	    currentState.lastRequestTime = Date.now();
	    return config;
	  });
	
	  axios.interceptors.response.use(null, function (error) {
	    var config = error.config;
	
	    // If we have no information to retry the request
	    if (!config) {
	      return Promise.reject(error);
	    }
	
	    var _getRequestOptions = getRequestOptions(config, defaultOptions),
	        _getRequestOptions$re = _getRequestOptions.retries,
	        retries = _getRequestOptions$re === undefined ? 3 : _getRequestOptions$re,
	        _getRequestOptions$re2 = _getRequestOptions.retryCondition,
	        retryCondition = _getRequestOptions$re2 === undefined ? isNetworkOrIdempotentRequestError : _getRequestOptions$re2,
	        _getRequestOptions$re3 = _getRequestOptions.retryDelay,
	        retryDelay = _getRequestOptions$re3 === undefined ? noDelay : _getRequestOptions$re3,
	        _getRequestOptions$sh = _getRequestOptions.shouldResetTimeout,
	        shouldResetTimeout = _getRequestOptions$sh === undefined ? false : _getRequestOptions$sh;
	
	    var currentState = getCurrentState(config);
	
	    var shouldRetry = retryCondition(error) && currentState.retryCount < retries;
	
	    if (shouldRetry) {
	      currentState.retryCount += 1;
	      var delay = retryDelay(currentState.retryCount, error);
	
	      // Axios fails merging this configuration to the default configuration because it has an issue
	      // with circular structures: https://github.com/mzabriskie/axios/issues/370
	      fixConfig(axios, config);
	
	      if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
	        var lastRequestDuration = Date.now() - currentState.lastRequestTime;
	        // Minimum 1ms timeout (passing 0 or less to XHR means no timeout)
	        config.timeout = Math.max(config.timeout - lastRequestDuration - delay, 1);
	      }
	
	      config.transformRequest = [function (data) {
	        return data;
	      }];
	
	      return new Promise(function (resolve) {
	        return setTimeout(function () {
	          return resolve(axios(config));
	        }, delay);
	      });
	    }
	
	    return Promise.reject(error);
	  });
	}
	
	// Compatibility with CommonJS
	axiosRetry.isNetworkError = isNetworkError;
	axiosRetry.isSafeRequestError = isSafeRequestError;
	axiosRetry.isIdempotentRequestError = isIdempotentRequestError;
	axiosRetry.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
	axiosRetry.exponentialDelay = exponentialDelay;
	axiosRetry.isRetryableError = isRetryableError;
	//# sourceMappingURL=index.js.map

/***/ },
/* 2601 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Chart.js v2.9.4
	 * https://www.chartjs.org
	 * (c) 2020 Chart.js Contributors
	 * Released under the MIT License
	 */
	(function (global, factory) {
	 true ? module.exports = factory(function() { try { return __webpack_require__(9); } catch(e) { } }()) :
	typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
	(global = global || self, global.Chart = factory(global.moment));
	}(this, (function (moment) { 'use strict';
	
	moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	function getCjsExportFromNamespace (n) {
		return n && n['default'] || n;
	}
	
	var colorName = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	var conversions = createCommonjsModule(function (module) {
	/* MIT license */
	
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in colorName) {
		if (colorName.hasOwnProperty(key)) {
			reverseKeywords[colorName[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;
	
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};
	
		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);
	
			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}
	
		return [
			h * 360,
			s * 100,
			v * 100
		];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in colorName) {
			if (colorName.hasOwnProperty(keyword)) {
				var value = colorName[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return colorName[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};
	});
	var conversions_1 = conversions.rgb;
	var conversions_2 = conversions.hsl;
	var conversions_3 = conversions.hsv;
	var conversions_4 = conversions.hwb;
	var conversions_5 = conversions.cmyk;
	var conversions_6 = conversions.xyz;
	var conversions_7 = conversions.lab;
	var conversions_8 = conversions.lch;
	var conversions_9 = conversions.hex;
	var conversions_10 = conversions.keyword;
	var conversions_11 = conversions.ansi16;
	var conversions_12 = conversions.ansi256;
	var conversions_13 = conversions.hcg;
	var conversions_14 = conversions.apple;
	var conversions_15 = conversions.gray;
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	var route = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	var colorConvert = convert;
	
	var colorName$1 = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	/* MIT license */
	
	
	var colorString = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	};
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorName$1[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorName$1) {
	   reverseNames[colorName$1[name]] = name;
	}
	
	/* MIT license */
	
	
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = colorString.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = colorString.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = colorString.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return colorString.hexString(this.values.rgb);
		},
		rgbString: function () {
			return colorString.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return colorString.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return colorString.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return colorString.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return colorString.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return colorString.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return colorString.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = colorConvert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	var chartjsColor = Color;
	
	function isValidKey(key) {
		return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
	}
	
	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},
	
		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),
	
		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},
	
		/**
		 * Returns true if `value` is an array (including typed arrays), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @function
		 */
		isArray: function(value) {
			if (Array.isArray && Array.isArray(value)) {
				return true;
			}
			var type = Object.prototype.toString.call(value);
			if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
				return true;
			}
			return false;
		},
	
		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},
	
		/**
		 * Returns true if `value` is a finite number, else returns false
		 * @param {*} value  - The value to test.
		 * @returns {boolean}
		 */
		isFinite: function(value) {
			return (typeof value === 'number' || value instanceof Number) && isFinite(value);
		},
	
		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},
	
		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},
	
		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},
	
		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {object|Array} loopable - The object or array to be iterated.
		 * @param {function} fn - The function to call for each item.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},
	
		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see https://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		},
	
		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}
	
			if (helpers.isObject(source)) {
				var target = Object.create(source);
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;
	
				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}
	
				return target;
			}
	
			return source;
		},
	
		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			if (!isValidKey(key)) {
				// We want to ensure we do not copy prototypes over
				// as this can pollute global namespaces
				return;
			}
	
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			if (!isValidKey(key)) {
				// We want to ensure we do not copy prototypes over
				// as this can pollute global namespaces
				return;
			}
	
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @param {object} [options] - Merging options:
		 * @param {function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;
	
			if (!helpers.isObject(target)) {
				return target;
			}
	
			options = options || {};
			merge = options.merger || helpers._merger;
	
			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}
	
				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}
	
			return target;
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @returns {object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},
	
		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {object} target - The target object in which all objects are merged into.
		 * @param {object} arg1 - Object containing additional properties to merge in target.
		 * @param {object} argN - Additional objects containing properties to merge in target.
		 * @returns {object} The `target` object.
		 */
		extend: Object.assign || function(target) {
			return helpers.merge(target, [].slice.call(arguments, 1), {
				merger: function(key, dst, src) {
					dst[key] = src[key];
				}
			});
		},
	
		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
	
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
			return ChartElement;
		},
	
		_deprecated: function(scope, value, previous, current) {
			if (value !== undefined) {
				console.warn(scope + ': "' + previous +
					'" is deprecated. Please use "' + current + '" instead');
			}
		}
	};
	
	var helpers_core = helpers;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;
	
	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
	
	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},
	
		easeInQuad: function(t) {
			return t * t;
		},
	
		easeOutQuad: function(t) {
			return -t * (t - 2);
		},
	
		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},
	
		easeInCubic: function(t) {
			return t * t * t;
		},
	
		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},
	
		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},
	
		easeInQuart: function(t) {
			return t * t * t * t;
		},
	
		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},
	
		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},
	
		easeInQuint: function(t) {
			return t * t * t * t * t;
		},
	
		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},
	
		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},
	
		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},
	
		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},
	
		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},
	
		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},
	
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},
	
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},
	
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},
	
		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},
	
		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
	
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},
	
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},
	
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},
	
		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},
	
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
	
		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},
	
		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},
	
		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};
	
	var helpers_easing = {
		effects: effects
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.easingEffects = effects;
	
	var PI = Math.PI;
	var RAD_PER_DEG = PI / 180;
	var DOUBLE_PI = PI * 2;
	var HALF_PI = PI / 2;
	var QUARTER_PI = PI / 4;
	var TWO_THIRDS_PI = PI * 2 / 3;
	
	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports$1 = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},
	
		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {number} width - The rectangle's width.
		 * @param {number} height - The rectangle's height.
		 * @param {number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var r = Math.min(radius, height / 2, width / 2);
				var left = x + r;
				var top = y + r;
				var right = x + width - r;
				var bottom = y + height - r;
	
				ctx.moveTo(x, top);
				if (left < right && top < bottom) {
					ctx.arc(left, top, r, -PI, -HALF_PI);
					ctx.arc(right, top, r, -HALF_PI, 0);
					ctx.arc(right, bottom, r, 0, HALF_PI);
					ctx.arc(left, bottom, r, HALF_PI, PI);
				} else if (left < right) {
					ctx.moveTo(left, y);
					ctx.arc(right, top, r, -HALF_PI, HALF_PI);
					ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
				} else if (top < bottom) {
					ctx.arc(left, top, r, -PI, 0);
					ctx.arc(left, bottom, r, 0, PI);
				} else {
					ctx.arc(left, top, r, -PI, PI);
				}
				ctx.closePath();
				ctx.moveTo(x, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},
	
		drawPoint: function(ctx, style, radius, x, y, rotation) {
			var type, xOffset, yOffset, size, cornerRadius;
			var rad = (rotation || 0) * RAD_PER_DEG;
	
			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.save();
					ctx.translate(x, y);
					ctx.rotate(rad);
					ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
					ctx.restore();
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			ctx.beginPath();
	
			switch (style) {
			// Default includes circle
			default:
				ctx.arc(x, y, radius, 0, DOUBLE_PI);
				ctx.closePath();
				break;
			case 'triangle':
				ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				ctx.closePath();
				break;
			case 'rectRounded':
				// NOTE: the rounded rect implementation changed to use `arc` instead of
				// `quadraticCurveTo` since it generates better results when rect is
				// almost a circle. 0.516 (instead of 0.5) produces results with visually
				// closer proportion to the previous impl and it is inscribed in the
				// circle with `radius`. For more details, see the following PRs:
				// https://github.com/chartjs/Chart.js/issues/5597
				// https://github.com/chartjs/Chart.js/issues/5858
				cornerRadius = radius * 0.516;
				size = radius - cornerRadius;
				xOffset = Math.cos(rad + QUARTER_PI) * size;
				yOffset = Math.sin(rad + QUARTER_PI) * size;
				ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
				ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
				ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
				ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
				ctx.closePath();
				break;
			case 'rect':
				if (!rotation) {
					size = Math.SQRT1_2 * radius;
					ctx.rect(x - size, y - size, 2 * size, 2 * size);
					break;
				}
				rad += QUARTER_PI;
				/* falls through */
			case 'rectRot':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + yOffset, y - xOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				ctx.closePath();
				break;
			case 'crossRot':
				rad += QUARTER_PI;
				/* falls through */
			case 'cross':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'star':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				rad += QUARTER_PI;
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'line':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				break;
			case 'dash':
				ctx.moveTo(x, y);
				ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
				break;
			}
	
			ctx.fill();
			ctx.stroke();
		},
	
		/**
		 * Returns true if the point is inside the rectangle
		 * @param {object} point - The point to test
		 * @param {object} area - The rectangle
		 * @returns {boolean}
		 * @private
		 */
		_isPointInArea: function(point, area) {
			var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	
			return point.x > area.left - epsilon && point.x < area.right + epsilon &&
				point.y > area.top - epsilon && point.y < area.bottom + epsilon;
		},
	
		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},
	
		unclipArea: function(ctx) {
			ctx.restore();
		},
	
		lineTo: function(ctx, previous, target, flip) {
			var stepped = target.steppedLine;
			if (stepped) {
				if (stepped === 'middle') {
					var midpoint = (previous.x + target.x) / 2.0;
					ctx.lineTo(midpoint, flip ? target.y : previous.y);
					ctx.lineTo(midpoint, flip ? previous.y : target.y);
				} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};
	
	var helpers_canvas = exports$1;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.clear = exports$1.clear;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports$1.roundedRect.apply(exports$1, arguments);
	};
	
	var defaults = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers_core.merge(this[scope] || (this[scope] = {}), values);
		}
	};
	
	// TODO(v3): remove 'global' from namespace.  all default are global and
	// there's inconsistency around which options are under 'global'
	defaults._set('global', {
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		defaultLineHeight: 1.2,
		showLines: true
	});
	
	var core_defaults = defaults;
	
	var valueOrDefault = helpers_core.valueOrDefault;
	
	/**
	 * Converts the given font object into a CSS font string.
	 * @param {object} font - A font object.
	 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
	 * @private
	 */
	function toFontString(font) {
		if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
			return null;
		}
	
		return (font.style ? font.style + ' ' : '')
			+ (font.weight ? font.weight + ' ' : '')
			+ font.size + 'px '
			+ font.family;
	}
	
	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	var helpers_options = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}
	
			value = +matches[2];
	
			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			}
	
			return size * value;
		},
	
		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {number|object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;
	
			if (helpers_core.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}
	
			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},
	
		/**
		 * Parses font options and returns the font object.
		 * @param {object} options - A object that contains font options to be parsed.
		 * @return {object} The font object.
		 * @todo Support font.* options and renamed to toFont().
		 * @private
		 */
		_parseFont: function(options) {
			var globalDefaults = core_defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var font = {
				family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
				lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
				size: size,
				style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
				weight: null,
				string: ''
			};
	
			font.string = toFontString(font);
			return font;
		},
	
		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array} inputs - An array of values, falling back to the last value.
		 * @param {object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @param {object} [info] - object to return information about resolution in
		 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index, info) {
			var cacheable = true;
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
					cacheable = false;
				}
				if (index !== undefined && helpers_core.isArray(value)) {
					value = value[index];
					cacheable = false;
				}
				if (value !== undefined) {
					if (info && !cacheable) {
						info.cacheable = false;
					}
					return value;
				}
			}
		}
	};
	
	/**
	 * @alias Chart.helpers.math
	 * @namespace
	 */
	var exports$2 = {
		/**
		 * Returns an array of factors sorted from 1 to sqrt(value)
		 * @private
		 */
		_factorize: function(value) {
			var result = [];
			var sqrt = Math.sqrt(value);
			var i;
	
			for (i = 1; i < sqrt; i++) {
				if (value % i === 0) {
					result.push(i);
					result.push(value / i);
				}
			}
			if (sqrt === (sqrt | 0)) { // if value is a square number
				result.push(sqrt);
			}
	
			result.sort(function(a, b) {
				return a - b;
			}).pop();
			return result;
		},
	
		log10: Math.log10 || function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);
	
			return isPowerOf10 ? powerOf10 : exponent;
		}
	};
	
	var helpers_math = exports$2;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
	 * @namespace Chart.helpers.log10
	 * @deprecated since version 2.9.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.log10 = exports$2.log10;
	
	var getRtlAdapter = function(rectX, width) {
		return {
			x: function(x) {
				return rectX + rectX + width - x;
			},
			setWidth: function(w) {
				width = w;
			},
			textAlign: function(align) {
				if (align === 'center') {
					return align;
				}
				return align === 'right' ? 'left' : 'right';
			},
			xPlus: function(x, value) {
				return x - value;
			},
			leftForLtr: function(x, itemWidth) {
				return x - itemWidth;
			},
		};
	};
	
	var getLtrAdapter = function() {
		return {
			x: function(x) {
				return x;
			},
			setWidth: function(w) { // eslint-disable-line no-unused-vars
			},
			textAlign: function(align) {
				return align;
			},
			xPlus: function(x, value) {
				return x + value;
			},
			leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
				return x;
			},
		};
	};
	
	var getAdapter = function(rtl, rectX, width) {
		return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
	};
	
	var overrideTextDirection = function(ctx, direction) {
		var style, original;
		if (direction === 'ltr' || direction === 'rtl') {
			style = ctx.canvas.style;
			original = [
				style.getPropertyValue('direction'),
				style.getPropertyPriority('direction'),
			];
	
			style.setProperty('direction', direction, 'important');
			ctx.prevTextDirection = original;
		}
	};
	
	var restoreTextDirection = function(ctx) {
		var original = ctx.prevTextDirection;
		if (original !== undefined) {
			delete ctx.prevTextDirection;
			ctx.canvas.style.setProperty('direction', original[0], original[1]);
		}
	};
	
	var helpers_rtl = {
		getRtlAdapter: getAdapter,
		overrideTextDirection: overrideTextDirection,
		restoreTextDirection: restoreTextDirection,
	};
	
	var helpers$1 = helpers_core;
	var easing = helpers_easing;
	var canvas = helpers_canvas;
	var options = helpers_options;
	var math = helpers_math;
	var rtl = helpers_rtl;
	helpers$1.easing = easing;
	helpers$1.canvas = canvas;
	helpers$1.options = options;
	helpers$1.math = math;
	helpers$1.rtl = rtl;
	
	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;
	
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
	
			target = model[key];
	
			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}
	
			actual = view[key];
	
			if (actual === target || key[0] === '_') {
				continue;
			}
	
			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}
	
			origin = start[key];
	
			type = typeof target;
	
			if (type === typeof origin) {
				if (type === 'string') {
					c0 = chartjsColor(origin);
					if (c0.valid) {
						c1 = chartjsColor(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}
	
			view[key] = target;
		}
	}
	
	var Element = function(configuration) {
		helpers$1.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};
	
	helpers$1.extend(Element.prototype, {
		_type: undefined,
	
		initialize: function() {
			this.hidden = false;
		},
	
		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers$1.extend({}, me._model);
			}
			me._start = {};
			return me;
		},
	
		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;
	
			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = helpers$1.extend({}, model);
				me._start = null;
				return me;
			}
	
			if (!view) {
				view = me._view = {};
			}
	
			if (!start) {
				start = me._start = {};
			}
	
			interpolate(start, view, model, ease);
	
			return me;
		},
	
		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},
	
		hasValue: function() {
			return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
		}
	});
	
	Element.extend = helpers$1.inherits;
	
	var core_element = Element;
	
	var exports$3 = core_element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service
	
		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});
	
	var core_animation = exports$3;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});
	
	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});
	
	core_defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers$1.noop,
			onComplete: helpers$1.noop
		}
	});
	
	var core_animations = {
		animations: [],
		request: null,
	
		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {number} duration - The animation duration in ms.
		 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;
	
			animation.chart = chart;
			animation.startTime = Date.now();
			animation.duration = duration;
	
			if (!lazy) {
				chart.animating = true;
			}
	
			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}
	
			animations.push(animation);
	
			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},
	
		cancelAnimation: function(chart) {
			var index = helpers$1.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});
	
			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},
	
		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers$1.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},
	
		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
	
			me.advance();
	
			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},
	
		/**
		 * @private
		 */
		advance: function() {
			var animations = this.animations;
			var animation, chart, numSteps, nextStep;
			var i = 0;
	
			// 1 animation per chart, so we are looping charts here
			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;
				numSteps = animation.numSteps;
	
				// Make sure that currentStep starts at 1
				// https://github.com/chartjs/Chart.js/issues/6104
				nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
				animation.currentStep = Math.min(nextStep, numSteps);
	
				helpers$1.callback(animation.render, [chart, animation], chart);
				helpers$1.callback(animation.onAnimationProgress, [animation], chart);
	
				if (animation.currentStep >= numSteps) {
					helpers$1.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};
	
	var resolve = helpers$1.options.resolve;
	
	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}
	
		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});
	
		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];
	
			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);
	
					helpers$1.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});
	
					return res;
				}
			});
		});
	}
	
	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}
	
		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}
	
		if (listeners.length > 0) {
			return;
		}
	
		arrayEvents.forEach(function(key) {
			delete array[key];
		});
	
		delete array._chartjs;
	}
	
	// Base class for all dataset controllers (line, bar, etc)
	var DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};
	
	helpers$1.extend(DatasetController.prototype, {
	
		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,
	
		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,
	
		/**
		 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth'
		],
	
		/**
		 * Data element option keys to be resolved in _resolveDataElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'pointStyle'
		],
	
		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
			me._type = me.getMeta().type;
		},
	
		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},
	
		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var chart = me.chart;
			var scales = chart.scales;
			var dataset = me.getDataset();
			var scalesOpts = chart.options.scales;
	
			if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
				meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
				meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
			}
		},
	
		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},
	
		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},
	
		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getValueScale: function() {
			return this.getScaleForId(this._getValueScaleId());
		},
	
		/**
		 * @private
		 */
		_getIndexScale: function() {
			return this.getScaleForId(this._getIndexScaleId());
		},
	
		reset: function() {
			this._update(true);
		},
	
		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},
	
		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},
	
		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},
	
		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;
	
			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}
	
			meta.dataset = meta.dataset || me.createMetaDataset();
		},
	
		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},
	
		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);
	
			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}
	
				if (data && Object.isExtensible(data)) {
					listenArrayEvents(data, me);
				}
				me._data = data;
			}
	
			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},
	
		/**
		 * Returns the merged user-supplied and default dataset-level options
		 * @private
		 */
		_configure: function() {
			var me = this;
			me._config = helpers$1.merge(Object.create(null), [
				me.chart.options.datasets[me._type],
				me.getDataset(),
			], {
				merger: function(key, target, source) {
					if (key !== '_meta' && key !== 'data') {
						helpers$1._merger(key, target, source);
					}
				}
			});
		},
	
		_update: function(reset) {
			var me = this;
			me._configure();
			me._cachedDataOpts = null;
			me.update(reset);
		},
	
		update: helpers$1.noop,
	
		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}
	
			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},
	
		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			if (meta.dataset) {
				meta.dataset.draw();
			}
	
			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},
	
		/**
		 * Returns a set of predefined style properties that should be used to represent the dataset
		 * or the data if the index is specified
		 * @param {number} index - data index
		 * @return {IStyleInterface} style object
		 */
		getStyle: function(index) {
			var me = this;
			var meta = me.getMeta();
			var dataset = meta.dataset;
			var style;
	
			me._configure();
			if (dataset && index === undefined) {
				style = me._resolveDatasetElementOptions(dataset || {});
			} else {
				index = index || 0;
				style = me._resolveDataElementOptions(meta.data[index] || {}, index);
			}
	
			if (style.fill === false || style.fill === null) {
				style.backgroundColor = style.borderColor;
			}
	
			return style;
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element, hover) {
			var me = this;
			var chart = me.chart;
			var datasetOpts = me._config;
			var custom = element.custom || {};
			var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
			var elementOptions = me._datasetElementOptions;
			var values = {};
			var i, ilen, key, readKey;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataset: me.getDataset(),
				datasetIndex: me.index,
				hover: hover
			};
	
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
				values[key] = resolve([
					custom[readKey],
					datasetOpts[readKey],
					options[readKey]
				], context);
			}
	
			return values;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(element, index) {
			var me = this;
			var custom = element && element.custom;
			var cached = me._cachedDataOpts;
			if (cached && !custom) {
				return cached;
			}
			var chart = me.chart;
			var datasetOpts = me._config;
			var options = chart.options.elements[me.dataElementType.prototype._type] || {};
			var elementOptions = me._dataElementOptions;
			var values = {};
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: me.getDataset(),
				datasetIndex: me.index
			};
	
			// `resolve` sets cacheable to `false` if any option is indexed or scripted
			var info = {cacheable: !custom};
	
			var keys, i, ilen, key;
	
			custom = custom || {};
	
			if (helpers$1.isArray(elementOptions)) {
				for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
					key = elementOptions[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			} else {
				keys = Object.keys(elementOptions);
				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[elementOptions[key]],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			}
	
			if (info.cacheable) {
				me._cachedDataOpts = Object.freeze(values);
			}
	
			return values;
		},
	
		removeHoverStyle: function(element) {
			helpers$1.merge(element._model, element.$previousStyle || {});
			delete element.$previousStyle;
		},
	
		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var model = element._model;
			var getHoverColor = helpers$1.getHoverColor;
	
			element.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};
	
			model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
			model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
			model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
		},
	
		/**
		 * @private
		 */
		_removeDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
	
			if (element) {
				this.removeHoverStyle(element);
			}
		},
	
		/**
		 * @private
		 */
		_setDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
			var prev = {};
			var i, ilen, key, keys, hoverOptions, model;
	
			if (!element) {
				return;
			}
	
			model = element._model;
			hoverOptions = this._resolveDatasetElementOptions(element, true);
	
			keys = Object.keys(hoverOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				prev[key] = model[key];
				model[key] = hoverOptions[key];
			}
	
			element.$previousStyle = prev;
		},
	
		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;
	
			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},
	
		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},
	
		/**
		 * @private
		 */
		onDataPush: function() {
			var count = arguments.length;
			this.insertElements(this.getDataset().data.length - count, count);
		},
	
		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},
	
		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},
	
		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},
	
		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});
	
	DatasetController.extend = helpers$1.inherits;
	
	var core_datasetController = DatasetController;
	
	var TAU = Math.PI * 2;
	
	core_defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: core_defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2,
				borderAlign: 'center'
			}
		}
	});
	
	function clipArc(ctx, arc) {
		var startAngle = arc.startAngle;
		var endAngle = arc.endAngle;
		var pixelMargin = arc.pixelMargin;
		var angleMargin = pixelMargin / arc.outerRadius;
		var x = arc.x;
		var y = arc.y;
	
		// Draw an inner border by cliping the arc and drawing a double-width border
		// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
		ctx.beginPath();
		ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
		if (arc.innerRadius > pixelMargin) {
			angleMargin = pixelMargin / arc.innerRadius;
			ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
		} else {
			ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
		}
		ctx.closePath();
		ctx.clip();
	}
	
	function drawFullCircleBorders(ctx, vm, arc, inner) {
		var endAngle = arc.endAngle;
		var i;
	
		if (inner) {
			arc.endAngle = arc.startAngle + TAU;
			clipArc(ctx, arc);
			arc.endAngle = endAngle;
			if (arc.endAngle === arc.startAngle && arc.fullCircles) {
				arc.endAngle += TAU;
				arc.fullCircles--;
			}
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	}
	
	function drawBorder(ctx, vm, arc) {
		var inner = vm.borderAlign === 'inner';
	
		if (inner) {
			ctx.lineWidth = vm.borderWidth * 2;
			ctx.lineJoin = 'round';
		} else {
			ctx.lineWidth = vm.borderWidth;
			ctx.lineJoin = 'bevel';
		}
	
		if (arc.fullCircles) {
			drawFullCircleBorders(ctx, vm, arc, inner);
		}
	
		if (inner) {
			clipArc(ctx, arc);
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.stroke();
	}
	
	var element_arc = core_element.extend({
		_type: 'arc',
	
		inLabelRange: function(mouseX) {
			var vm = this._view;
	
			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
	
		inRange: function(chartX, chartY) {
			var vm = this._view;
	
			if (vm) {
				var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;
	
				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += TAU;
				}
				while (angle > endAngle) {
					angle -= TAU;
				}
				while (angle < startAngle) {
					angle += TAU;
				}
	
				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
				return (betweenAngles && withinRadius);
			}
			return false;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
	
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
			var arc = {
				x: vm.x,
				y: vm.y,
				innerRadius: vm.innerRadius,
				outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
				pixelMargin: pixelMargin,
				startAngle: vm.startAngle,
				endAngle: vm.endAngle,
				fullCircles: Math.floor(vm.circumference / TAU)
			};
			var i;
	
			ctx.save();
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
	
			if (arc.fullCircles) {
				arc.endAngle = arc.startAngle + TAU;
				ctx.beginPath();
				ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
				ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
				ctx.closePath();
				for (i = 0; i < arc.fullCircles; ++i) {
					ctx.fill();
				}
				arc.endAngle = arc.startAngle + vm.circumference % TAU;
			}
	
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			ctx.fill();
	
			if (vm.borderWidth) {
				drawBorder(ctx, vm, arc);
			}
	
			ctx.restore();
		}
	});
	
	var valueOrDefault$1 = helpers$1.valueOrDefault;
	
	var defaultColor = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: defaultColor,
				borderWidth: 3,
				borderColor: defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});
	
	var element_line = core_element.extend({
		_type: 'line',
	
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalDefaults = core_defaults.global;
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var closePath = me._loop;
			var index, previous, currentVM;
	
			if (!points.length) {
				return;
			}
	
			if (me._loop) {
				for (index = 0; index < points.length; ++index) {
					previous = helpers$1.previousItem(points, index);
					// If the line has an open path, shift the point array
					if (!points[index]._view.skip && previous._view.skip) {
						points = points.slice(index).concat(points.slice(0, index));
						closePath = spanGaps;
						break;
					}
				}
				// If the line has a close path, add the first point again
				if (closePath) {
					points.push(points[0]);
				}
			}
	
			ctx.save();
	
			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}
	
			ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
			// Stroke Line
			ctx.beginPath();
	
			// First point moves to it's starting position no matter what
			currentVM = points[0]._view;
			if (!currentVM.skip) {
				ctx.moveTo(currentVM.x, currentVM.y);
				lastDrawnIndex = 0;
			}
	
			for (index = 1; index < points.length; ++index) {
				currentVM = points[index]._view;
				previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
	
				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
					}
					lastDrawnIndex = index;
				}
			}
	
			if (closePath) {
				ctx.closePath();
			}
	
			ctx.stroke();
			ctx.restore();
		}
	});
	
	var valueOrDefault$2 = helpers$1.valueOrDefault;
	
	var defaultColor$1 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor$1,
				borderColor: defaultColor$1,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});
	
	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
	}
	
	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
	}
	
	var element_point = core_element.extend({
		_type: 'point',
	
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},
	
		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,
	
		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
	
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
	
		draw: function(chartArea) {
			var vm = this._view;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var rotation = vm.rotation;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
	
			if (vm.skip) {
				return;
			}
	
			// Clipping for Points.
			if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
				helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
			}
		}
	});
	
	var defaultColor$2 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaultColor$2,
				borderColor: defaultColor$2,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});
	
	function isVertical(vm) {
		return vm && vm.width !== undefined;
	}
	
	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(vm) {
		var x1, x2, y1, y2, half;
	
		if (isVertical(vm)) {
			half = vm.width / 2;
			x1 = vm.x - half;
			x2 = vm.x + half;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			half = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - half;
			y2 = vm.y + half;
		}
	
		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}
	
	function swap(orig, v1, v2) {
		return orig === v1 ? v2 : orig === v2 ? v1 : orig;
	}
	
	function parseBorderSkipped(vm) {
		var edge = vm.borderSkipped;
		var res = {};
	
		if (!edge) {
			return res;
		}
	
		if (vm.horizontal) {
			if (vm.base > vm.x) {
				edge = swap(edge, 'left', 'right');
			}
		} else if (vm.base < vm.y) {
			edge = swap(edge, 'bottom', 'top');
		}
	
		res[edge] = true;
		return res;
	}
	
	function parseBorderWidth(vm, maxW, maxH) {
		var value = vm.borderWidth;
		var skip = parseBorderSkipped(vm);
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}
	
		return {
			t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
			r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
			b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
			l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
		};
	}
	
	function boundingRects(vm) {
		var bounds = getBarBounds(vm);
		var width = bounds.right - bounds.left;
		var height = bounds.bottom - bounds.top;
		var border = parseBorderWidth(vm, width / 2, height / 2);
	
		return {
			outer: {
				x: bounds.left,
				y: bounds.top,
				w: width,
				h: height
			},
			inner: {
				x: bounds.left + border.l,
				y: bounds.top + border.t,
				w: width - border.l - border.r,
				h: height - border.t - border.b
			}
		};
	}
	
	function inRange(vm, x, y) {
		var skipX = x === null;
		var skipY = y === null;
		var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);
	
		return bounds
			&& (skipX || x >= bounds.left && x <= bounds.right)
			&& (skipY || y >= bounds.top && y <= bounds.bottom);
	}
	
	var element_rectangle = core_element.extend({
		_type: 'rectangle',
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var rects = boundingRects(vm);
			var outer = rects.outer;
			var inner = rects.inner;
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
	
			if (outer.w === inner.w && outer.h === inner.h) {
				return;
			}
	
			ctx.save();
			ctx.beginPath();
			ctx.rect(outer.x, outer.y, outer.w, outer.h);
			ctx.clip();
			ctx.fillStyle = vm.borderColor;
			ctx.rect(inner.x, inner.y, inner.w, inner.h);
			ctx.fill('evenodd');
			ctx.restore();
		},
	
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
	
		inRange: function(mouseX, mouseY) {
			return inRange(this._view, mouseX, mouseY);
		},
	
		inLabelRange: function(mouseX, mouseY) {
			var vm = this._view;
			return isVertical(vm)
				? inRange(vm, mouseX, null)
				: inRange(vm, null, mouseY);
		},
	
		inXRange: function(mouseX) {
			return inRange(this._view, mouseX, null);
		},
	
		inYRange: function(mouseY) {
			return inRange(this._view, null, mouseY);
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(vm)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}
	
			return {x: x, y: y};
		},
	
		getArea: function() {
			var vm = this._view;
	
			return isVertical(vm)
				? vm.width * Math.abs(vm.y - vm.base)
				: vm.height * Math.abs(vm.x - vm.base);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});
	
	var elements = {};
	var Arc = element_arc;
	var Line = element_line;
	var Point = element_point;
	var Rectangle = element_rectangle;
	elements.Arc = Arc;
	elements.Line = Line;
	elements.Point = Point;
	elements.Rectangle = Rectangle;
	
	var deprecated = helpers$1._deprecated;
	var valueOrDefault$3 = helpers$1.valueOrDefault;
	
	core_defaults._set('bar', {
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}],
	
			yAxes: [{
				type: 'linear'
			}]
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			bar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	/**
	 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
	 * @private
	 */
	function computeMinSampleSize(scale, pixels) {
		var min = scale._length;
		var prev, curr, i, ilen;
	
		for (i = 1, ilen = pixels.length; i < ilen; ++i) {
			min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
		}
	
		for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
			curr = scale.getPixelForTick(i);
			min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
			prev = curr;
		}
	
		return min;
	}
	
	/**
	 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
	 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
	 * mode currently always generates bars equally sized (until we introduce scriptable options?).
	 * @private
	 */
	function computeFitCategoryTraits(index, ruler, options) {
		var thickness = options.barThickness;
		var count = ruler.stackCount;
		var curr = ruler.pixels[index];
		var min = helpers$1.isNullOrUndef(thickness)
			? computeMinSampleSize(ruler.scale, ruler.pixels)
			: -1;
		var size, ratio;
	
		if (helpers$1.isNullOrUndef(thickness)) {
			size = min * options.categoryPercentage;
			ratio = options.barPercentage;
		} else {
			// When bar thickness is enforced, category and bar percentages are ignored.
			// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
			// and deprecate barPercentage since this value is ignored when thickness is absolute.
			size = thickness * count;
			ratio = 1;
		}
	
		return {
			chunk: size / count,
			ratio: ratio,
			start: curr - (size / 2)
		};
	}
	
	/**
	 * Computes an "optimal" category that globally arranges bars side by side (no gap when
	 * percentage options are 1), based on the previous and following categories. This mode
	 * generates bars with different widths when data are not evenly spaced.
	 * @private
	 */
	function computeFlexCategoryTraits(index, ruler, options) {
		var pixels = ruler.pixels;
		var curr = pixels[index];
		var prev = index > 0 ? pixels[index - 1] : null;
		var next = index < pixels.length - 1 ? pixels[index + 1] : null;
		var percent = options.categoryPercentage;
		var start, size;
	
		if (prev === null) {
			// first data: its size is double based on the next point or,
			// if it's also the last data, we use the scale size.
			prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
		}
	
		if (next === null) {
			// last data: its size is also double based on the previous point.
			next = curr + curr - prev;
		}
	
		start = curr - (curr - Math.min(prev, next)) / 2 * percent;
		size = Math.abs(next - prev) / 2 * percent;
	
		return {
			chunk: size / ruler.stackCount,
			ratio: options.barPercentage,
			start: start
		};
	}
	
	var controller_bar = core_datasetController.extend({
	
		dataElementType: elements.Rectangle,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderSkipped',
			'borderWidth',
			'barPercentage',
			'barThickness',
			'categoryPercentage',
			'maxBarThickness',
			'minBarLength'
		],
	
		initialize: function() {
			var me = this;
			var meta, scaleOpts;
	
			core_datasetController.prototype.initialize.apply(me, arguments);
	
			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
	
			scaleOpts = me._getIndexScale().options;
			deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
			deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
			deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
			deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
			deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
		},
	
		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;
	
			me._ruler = me.getRuler();
	
			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},
	
		updateElement: function(rectangle, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var options = me._resolveDataElementOptions(rectangle, index);
	
			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;
			rectangle._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderSkipped: options.borderSkipped,
				borderWidth: options.borderWidth,
				datasetLabel: dataset.label,
				label: me.chart.data.labels[index]
			};
	
			if (helpers$1.isArray(dataset.data[index])) {
				rectangle._model.borderSkipped = null;
			}
	
			me._updateElementGeometry(rectangle, index, reset, options);
	
			rectangle.pivot();
		},
	
		/**
		 * @private
		 */
		_updateElementGeometry: function(rectangle, index, reset, options) {
			var me = this;
			var model = rectangle._model;
			var vscale = me._getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index, options);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
	
			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},
	
		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {number} [last] - The dataset index
		 * @returns {string[]} The list of stack IDs
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var scale = me._getIndexScale();
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var stacked = scale.options.stacked;
			var ilen = metasets.length;
			var stacks = [];
			var i, meta;
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				// stacked   | meta.stack
				//           | found | not found | undefined
				// false     |   x   |     x     |     x
				// true      |       |     x     |
				// undefined |       |     x     |     x
				if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
					(stacked === undefined && meta.stack === undefined)) {
					stacks.push(meta.stack);
				}
				if (meta.index === last) {
					break;
				}
			}
	
			return stacks;
		},
	
		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},
	
		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {number} [datasetIndex] - The dataset index
		 * @param {string} [name] - The stack name to find
		 * @returns {number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present
	
			return (index === -1)
				? stacks.length - 1
				: index;
		},
	
		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me._getIndexScale();
			var pixels = [];
			var i, ilen;
	
			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, me.index));
			}
	
			return {
				pixels: pixels,
				start: scale._startPixel,
				end: scale._endPixel,
				stackCount: me.getStackCount(),
				scale: scale
			};
		},
	
		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index, options) {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var isHorizontal = scale.isHorizontal();
			var datasets = chart.data.datasets;
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var value = scale._parseValue(datasets[datasetIndex].data[index]);
			var minBarLength = options.minBarLength;
			var stacked = scale.options.stacked;
			var stack = me.getMeta().stack;
			var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
			var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
			var ilen = metasets.length;
			var i, imeta, ivalue, base, head, size, stackLength;
	
			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < ilen; ++i) {
					imeta = metasets[i];
	
					if (imeta.index === datasetIndex) {
						break;
					}
	
					if (imeta.stack === stack) {
						stackLength = scale._parseValue(datasets[imeta.index].data[index]);
						ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
	
						if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}
	
			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + length);
			size = head - base;
	
			if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
				size = minBarLength;
				if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
					head = base - minBarLength;
				} else {
					head = base + minBarLength;
				}
			}
	
			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},
	
		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
			var me = this;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);
	
			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				valueOrDefault$3(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);
	
			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;
	
			helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
	
			for (; i < ilen; ++i) {
				var val = scale._parseValue(dataset.data[i]);
				if (!isNaN(val.min) && !isNaN(val.max)) {
					rects[i].draw();
				}
			}
	
			helpers$1.canvas.unclipArea(chart.ctx);
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function() {
			var me = this;
			var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
			var indexOpts = me._getIndexScale().options;
			var valueOpts = me._getValueScale().options;
	
			values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
			values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
			values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
			values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
			values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
	
			return values;
		}
	
	});
	
	var valueOrDefault$4 = helpers$1.valueOrDefault;
	var resolve$1 = helpers$1.options.resolve;
	
	core_defaults._set('bubble', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});
	
	var controller_bubble = core_datasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
			'hoverRadius',
			'hitRadius',
			'pointStyle',
			'rotation'
		],
	
		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;
	
			// Update Points
			helpers$1.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},
	
		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveDataElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;
	
			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
	
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};
	
			point.pivot();
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var custom = point.custom || {};
			var data = dataset.data[index] || {};
			var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			// In case values were cached (and thus frozen), we need to clone the values
			if (me._cachedDataOpts === values) {
				values = helpers$1.extend({}, values);
			}
	
			// Custom radius resolution
			values.radius = resolve$1([
				custom.radius,
				data.r,
				me._config.radius,
				chart.options.elements.point.radius
			], context, index);
	
			return values;
		}
	});
	
	var valueOrDefault$5 = helpers$1.valueOrDefault;
	
	var PI$1 = Math.PI;
	var DOUBLE_PI$1 = PI$1 * 2;
	var HALF_PI$1 = PI$1 / 2;
	
	core_defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}
	
				chart.update();
			}
		},
	
		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,
	
		// The rotation of the chart, where the first data arc begins.
		rotation: -HALF_PI$1,
	
		// The total circumference of the chart.
		circumference: DOUBLE_PI$1,
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
					if (helpers$1.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}
	
					return dataLabel;
				}
			}
		}
	});
	
	var controller_doughnut = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;
	
			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}
	
			return ringIndex;
		},
	
		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var ratioX = 1;
			var ratioY = 1;
			var offsetX = 0;
			var offsetY = 0;
			var meta = me.getMeta();
			var arcs = meta.data;
			var cutout = opts.cutoutPercentage / 100 || 0;
			var circumference = opts.circumference;
			var chartWeight = me._getRingWeight(me.index);
			var maxWidth, maxHeight, i, ilen;
	
			// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
			if (circumference < DOUBLE_PI$1) {
				var startAngle = opts.rotation % DOUBLE_PI$1;
				startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
				var endAngle = startAngle + circumference;
				var startX = Math.cos(startAngle);
				var startY = Math.sin(startAngle);
				var endX = Math.cos(endAngle);
				var endY = Math.sin(endAngle);
				var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
				var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
				var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
				var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
				var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
				var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
				var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
				var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
				ratioX = (maxX - minX) / 2;
				ratioY = (maxY - minY) / 2;
				offsetX = -(maxX + minX) / 2;
				offsetY = -(maxY + minY) / 2;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			}
	
			chart.borderWidth = me.getMaxBorderWidth();
			maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
			maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
			chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
			chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
			chart.offsetX = offsetX * chart.outerRadius;
			chart.offsetY = offsetY * chart.outerRadius;
	
			meta.total = me.calculateTotal();
	
			me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});
	
			var model = arc._model;
	
			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}
	
				model.endAngle = model.startAngle + model.circumference;
			}
	
			arc.pivot();
		},
	
		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;
	
			helpers$1.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});
	
			/* if (total === 0) {
				total = NaN;
			}*/
	
			return total;
		},
	
		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return DOUBLE_PI$1 * (Math.abs(value) / total);
			}
			return 0;
		},
	
		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var me = this;
			var max = 0;
			var chart = me.chart;
			var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
	
			if (!arcs) {
				// Find the outmost visible dataset
				for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						meta = chart.getDatasetMeta(i);
						arcs = meta.data;
						if (i !== me.index) {
							controller = meta.controller;
						}
						break;
					}
				}
			}
	
			if (!arcs) {
				return 0;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arc = arcs[i];
				if (controller) {
					controller._configure();
					options = controller._resolveDataElementOptions(arc, i);
				} else {
					options = arc._options;
				}
				if (options.borderAlign !== 'inner') {
					borderWidth = options.borderWidth;
					hoverWidth = options.hoverBorderWidth;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
			}
			return max;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
		 * @private
		 */
		_getRingWeightOffset: function(datasetIndex) {
			var ringWeightOffset = 0;
	
			for (var i = 0; i < datasetIndex; ++i) {
				if (this.chart.isDatasetVisible(i)) {
					ringWeightOffset += this._getRingWeight(i);
				}
			}
	
			return ringWeightOffset;
		},
	
		/**
		 * @private
		 */
		_getRingWeight: function(dataSetIndex) {
			return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
		},
	
		/**
		 * Returns the sum of all visibile data set weights.  This value can be 0.
		 * @private
		 */
		_getVisibleDatasetWeightTotal: function() {
			return this._getRingWeightOffset(this.chart.data.datasets.length);
		}
	});
	
	core_defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},
	
		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
	
			yAxes: [{
				type: 'category',
				position: 'left',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
	
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
	
		tooltips: {
			mode: 'index',
			axis: 'y'
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			horizontalBar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	var controller_horizontalBar = controller_bar.extend({
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
	
	var valueOrDefault$6 = helpers$1.valueOrDefault;
	var resolve$2 = helpers$1.options.resolve;
	var isPointInArea = helpers$1.canvas._isPointInArea;
	
	core_defaults._set('line', {
		showLines: true,
		spanGaps: false,
	
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});
	
	function scaleClip(scale, halfBorderWidth) {
		var tickOpts = scale && scale.options.ticks || {};
		var reverse = tickOpts.reverse;
		var min = tickOpts.min === undefined ? halfBorderWidth : 0;
		var max = tickOpts.max === undefined ? halfBorderWidth : 0;
		return {
			start: reverse ? max : min,
			end: reverse ? min : max
		};
	}
	
	function defaultClip(xScale, yScale, borderWidth) {
		var halfBorderWidth = borderWidth / 2;
		var x = scaleClip(xScale, halfBorderWidth);
		var y = scaleClip(yScale, halfBorderWidth);
	
		return {
			top: y.end,
			right: x.end,
			bottom: y.start,
			left: x.start
		};
	}
	
	function toClip(value) {
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = value.top;
			r = value.right;
			b = value.bottom;
			l = value.left;
		} else {
			t = r = b = l = value;
		}
	
		return {
			top: t,
			right: r,
			bottom: b,
			left: l
		};
	}
	
	
	var controller_line = core_datasetController.extend({
	
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth',
			'cubicInterpolationMode',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var config = me._config;
			var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
			var i, ilen;
	
			me._xScale = me.getScaleForId(meta.xAxisID);
			me._yScale = me.getScaleForId(meta.yAxisID);
	
			// Update Line
			if (showLine) {
				// Compatibility: If the properties are defined with only the old name, use those values
				if (config.tension !== undefined && config.lineTension === undefined) {
					config.lineTension = config.tension;
				}
	
				// Utility
				line._scale = me._yScale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = me._resolveDatasetElementOptions(line);
	
				line.pivot();
			}
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var xScale = me._xScale;
			var yScale = me._yScale;
			var lineModel = meta.dataset._model;
			var x, y;
	
			var options = me._resolveDataElementOptions(point, index);
	
			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = datasetIndex;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
				steppedLine: lineModel ? lineModel.steppedLine : false,
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element) {
			var me = this;
			var config = me._config;
			var custom = element.custom || {};
			var options = me.chart.options;
			var lineOptions = options.elements.line;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			// The default behavior of lines is to break at null values, according
			// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
			// This option gives lines the ability to span gaps
			values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
			values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
			values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
	
			return values;
		},
	
		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var yScale = me._yScale;
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
	
			if (yScale.options.stacked) {
				rightValue = +yScale.getRightValue(value);
				metasets = chart._getSortedVisibleDatasetMetas();
				ilen = metasets.length;
	
				for (i = 0; i < ilen; ++i) {
					dsMeta = metasets[i];
					if (dsMeta.index === datasetIndex) {
						break;
					}
	
					ds = chart.data.datasets[dsMeta.index];
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
						stackedRightValue = +yScale.getRightValue(ds.data[index]);
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}
	
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}
			return yScale.getPixelForValue(value);
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var lineModel = meta.dataset._model;
			var area = chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (lineModel.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			if (lineModel.cubicInterpolationMode === 'monotone') {
				helpers$1.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					controlPoints = helpers$1.splineCurve(
						helpers$1.previousItem(points, i)._model,
						model,
						helpers$1.nextItem(points, i)._model,
						lineModel.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}
	
			if (chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					if (isPointInArea(model, area)) {
						if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
							model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
							model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						}
						if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
							model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
							model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
						}
					}
				}
			}
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var canvas = chart.canvas;
			var i = 0;
			var ilen = points.length;
			var clip;
	
			if (me._showLine) {
				clip = meta.dataset._model.clip;
	
				helpers$1.canvas.clipArea(chart.ctx, {
					left: clip.left === false ? 0 : area.left - clip.left,
					right: clip.right === false ? canvas.width : area.right + clip.right,
					top: clip.top === false ? 0 : area.top - clip.top,
					bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
				});
	
				meta.dataset.draw();
	
				helpers$1.canvas.unclipArea(chart.ctx);
			}
	
			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
		},
	});
	
	var resolve$3 = helpers$1.options.resolve;
	
	core_defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},
	
		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},
	
		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}
	
				chart.update();
			}
		},
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});
	
	var controller_polarArea = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var dataset = me.getDataset();
			var meta = me.getMeta();
			var start = me.chart.options.startAngle || 0;
			var starts = me._starts = [];
			var angles = me._angles = [];
			var arcs = meta.data;
			var i, ilen, angle;
	
			me._updateRadius();
	
			meta.count = me.countVisibleElements();
	
			for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
				starts[i] = start;
				angle = me._computeAngle(i);
				angles[i] = angle;
				start += angle;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		/**
		 * @private
		 */
		_updateRadius: function() {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
	
			chart.outerRadius = Math.max(minSize / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;
	
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;
	
			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = me._starts[index];
			var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
	
			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});
	
			arc.pivot();
		},
	
		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;
	
			helpers$1.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});
	
			return count;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
			var valueOrDefault = helpers$1.valueOrDefault;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * @private
		 */
		_computeAngle: function(index) {
			var me = this;
			var count = this.getMeta().count;
			var dataset = me.getDataset();
			var meta = me.getMeta();
	
			if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
				return 0;
			}
	
			// Scriptable options
			var context = {
				chart: me.chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			return resolve$3([
				me.chart.options.elements.arc.angle,
				(2 * Math.PI) / count
			], context, index);
		}
	});
	
	core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
	core_defaults._set('pie', {
		cutoutPercentage: 0
	});
	
	// Pie charts are Doughnut chart with different defaults
	var controller_pie = controller_doughnut;
	
	var valueOrDefault$7 = helpers$1.valueOrDefault;
	
	core_defaults._set('radar', {
		spanGaps: false,
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				fill: 'start',
				tension: 0 // no bezier in radar
			}
		}
	});
	
	var controller_radar = core_datasetController.extend({
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderWidth',
			'borderColor',
			'borderCapStyle',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var scale = me.chart.scale;
			var config = me._config;
			var i, ilen;
	
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}
	
			// Utility
			line._scale = scale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			line._loop = true;
			// Model
			line._model = me._resolveDatasetElementOptions(line);
	
			line.pivot();
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			// Update bezier control points
			me.updateBezierControlPoints();
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
			var options = me._resolveDataElementOptions(point, index);
			var lineModel = me.getMeta().dataset._model;
			var x = reset ? scale.xCenter : pointPosition.x;
			var y = reset ? scale.yCenter : pointPosition.y;
	
			// Utility
			point._scale = scale;
			point._options = options;
			point._datasetIndex = me.index;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x, // value not used in dataset scale, but we want a consistent API between scales
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
	
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function() {
			var me = this;
			var config = me._config;
			var options = me.chart.options;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
	
			return values;
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i, true)._model,
					model,
					helpers$1.nextItem(points, i, true)._model,
					model.tension
				);
	
				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
				model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
				model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
				model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
			}
		},
	
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
		}
	});
	
	core_defaults._set('scatter', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			scatter: {
				showLine: false
			}
		}
	});
	
	// Scatter charts use line controllers
	var controller_scatter = controller_line;
	
	// NOTE export a map in which the key represents the controller type, not
	// the class, and so must be CamelCase in order to be correctly retrieved
	// by the controller in core.controller.js (`controllers[meta.type]`).
	
	var controllers = {
		bar: controller_bar,
		bubble: controller_bubble,
		doughnut: controller_doughnut,
		horizontalBar: controller_horizontalBar,
		line: controller_line,
		polarArea: controller_polarArea,
		pie: controller_pie,
		radar: controller_radar,
		scatter: controller_scatter
	};
	
	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {object} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}
	
		return helpers$1.getRelativePosition(e, chart);
	}
	
	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param {Chart} chart - the chart
	 * @param {function} handler - the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var metadata, i, j, ilen, jlen, element;
	
		for (i = 0, ilen = metasets.length; i < ilen; ++i) {
			metadata = metasets[i].data;
			for (j = 0, jlen = metadata.length; j < jlen; ++j) {
				element = metadata[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}
	
	/**
	 * Helper function to get the items that intersect the event position
	 * @param {ChartElement[]} items - elements to filter
	 * @param {object} position - the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];
	
		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param {Chart} chart - the chart to look at elements from
	 * @param {object} position - the point to be nearest to
	 * @param {boolean} intersect - if true, only consider items that intersect the position
	 * @param {function} distanceMetric - function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];
	
		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}
	
			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});
	
		return nearestItems;
	}
	
	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {string} axis - the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;
	
		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}
	
	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];
	
		if (!items.length) {
			return [];
		}
	
		chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
			var element = meta.data[items[0]._index];
	
			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */
	
	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	var core_interaction = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];
	
				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});
	
				return elements.slice(0, 1);
			},
	
			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,
	
			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,
	
			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	
				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}
	
				return items;
			},
	
			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},
	
			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},
	
			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				return getNearestItems(chart, position, options.intersect, distanceMetric);
			},
	
			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},
	
			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};
	
	var extend = helpers$1.extend;
	
	function filterByPosition(array, position) {
		return helpers$1.where(array, function(v) {
			return v.pos === position;
		});
	}
	
	function sortByWeight(array, reverse) {
		return array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0.index - v1.index :
				v0.weight - v1.weight;
		});
	}
	
	function wrapBoxes(boxes) {
		var layoutBoxes = [];
		var i, ilen, box;
	
		for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
			box = boxes[i];
			layoutBoxes.push({
				index: i,
				box: box,
				pos: box.position,
				horizontal: box.isHorizontal(),
				weight: box.weight
			});
		}
		return layoutBoxes;
	}
	
	function setLayoutDims(layouts, params) {
		var i, ilen, layout;
		for (i = 0, ilen = layouts.length; i < ilen; ++i) {
			layout = layouts[i];
			// store width used instead of chartArea.w in fitBoxes
			layout.width = layout.horizontal
				? layout.box.fullWidth && params.availableWidth
				: params.vBoxMaxWidth;
			// store height used instead of chartArea.h in fitBoxes
			layout.height = layout.horizontal && params.hBoxMaxHeight;
		}
	}
	
	function buildLayoutBoxes(boxes) {
		var layoutBoxes = wrapBoxes(boxes);
		var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
		var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
		var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
		var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
	
		return {
			leftAndTop: left.concat(top),
			rightAndBottom: right.concat(bottom),
			chartArea: filterByPosition(layoutBoxes, 'chartArea'),
			vertical: left.concat(right),
			horizontal: top.concat(bottom)
		};
	}
	
	function getCombinedMax(maxPadding, chartArea, a, b) {
		return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
	}
	
	function updateDims(chartArea, params, layout) {
		var box = layout.box;
		var maxPadding = chartArea.maxPadding;
		var newWidth, newHeight;
	
		if (layout.size) {
			// this layout was already counted for, lets first reduce old size
			chartArea[layout.pos] -= layout.size;
		}
		layout.size = layout.horizontal ? box.height : box.width;
		chartArea[layout.pos] += layout.size;
	
		if (box.getPadding) {
			var boxPadding = box.getPadding();
			maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
			maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
			maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
			maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
		}
	
		newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
		newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
	
		if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
			chartArea.w = newWidth;
			chartArea.h = newHeight;
	
			// return true if chart area changed in layout's direction
			var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
			return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
		}
	}
	
	function handleMaxPadding(chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function updatePos(pos) {
			var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
			chartArea[pos] += change;
			return change;
		}
		chartArea.y += updatePos('top');
		chartArea.x += updatePos('left');
		updatePos('right');
		updatePos('bottom');
	}
	
	function getMargins(horizontal, chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function marginForPositions(positions) {
			var margin = {left: 0, top: 0, right: 0, bottom: 0};
			positions.forEach(function(pos) {
				margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
			});
			return margin;
		}
	
		return horizontal
			? marginForPositions(['left', 'right'])
			: marginForPositions(['top', 'bottom']);
	}
	
	function fitBoxes(boxes, chartArea, params) {
		var refitBoxes = [];
		var i, ilen, layout, box, refit, changed;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
	
			box.update(
				layout.width || chartArea.w,
				layout.height || chartArea.h,
				getMargins(layout.horizontal, chartArea)
			);
			if (updateDims(chartArea, params, layout)) {
				changed = true;
				if (refitBoxes.length) {
					// Dimensions changed and there were non full width boxes before this
					// -> we have to refit those
					refit = true;
				}
			}
			if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
				refitBoxes.push(layout);
			}
		}
	
		return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
	}
	
	function placeBoxes(boxes, chartArea, params) {
		var userPadding = params.padding;
		var x = chartArea.x;
		var y = chartArea.y;
		var i, ilen, layout, box;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
			if (layout.horizontal) {
				box.left = box.fullWidth ? userPadding.left : chartArea.left;
				box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
				box.top = y;
				box.bottom = y + box.height;
				box.width = box.right - box.left;
				y = box.bottom;
			} else {
				box.left = x;
				box.right = x + box.width;
				box.top = chartArea.top;
				box.bottom = chartArea.top + chartArea.h;
				box.height = box.bottom - box.top;
				x = box.right;
			}
		}
	
		chartArea.x = x;
		chartArea.y = y;
	}
	
	core_defaults._set('global', {
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});
	
	/**
	 * @interface ILayoutItem
	 * @prop {string} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {function} getPadding -  Returns an object with padding on the edges
	 * @prop {number} width - Width of item. Must be valid after update()
	 * @prop {number} height - Height of item. Must be valid after update()
	 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */
	
	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	var core_layouts = {
		defaults: {},
	
		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}
	
			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;
			item._layers = item._layers || function() {
				return [{
					z: 0,
					draw: function() {
						item.draw.apply(item, arguments);
					}
				}];
			};
	
			chart.boxes.push(item);
		},
	
		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {ILayoutItem} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},
	
		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {ILayoutItem} item - the item to configure with the given options
		 * @param {object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;
	
			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},
	
		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {number} width - the width to fit into
		 * @param {number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}
	
			var layoutOptions = chart.options.layout || {};
			var padding = helpers$1.options.toPadding(layoutOptions.padding);
	
			var availableWidth = width - padding.width;
			var availableHeight = height - padding.height;
			var boxes = buildLayoutBoxes(chart.boxes);
			var verticalBoxes = boxes.vertical;
			var horizontalBoxes = boxes.horizontal;
	
			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
	
			var params = Object.freeze({
				outerWidth: width,
				outerHeight: height,
				padding: padding,
				availableWidth: availableWidth,
				vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
				hBoxMaxHeight: availableHeight / 2
			});
			var chartArea = extend({
				maxPadding: extend({}, padding),
				w: availableWidth,
				h: availableHeight,
				x: padding.left,
				y: padding.top
			}, padding);
	
			setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
	
			// First fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
	
			// Then fit horizontal boxes
			if (fitBoxes(horizontalBoxes, chartArea, params)) {
				// if the area changed, re-fit vertical boxes
				fitBoxes(verticalBoxes, chartArea, params);
			}
	
			handleMaxPadding(chartArea);
	
			// Finally place the boxes to correct coordinates
			placeBoxes(boxes.leftAndTop, chartArea, params);
	
			// Move to opposite side of chart
			chartArea.x += chartArea.w;
			chartArea.y += chartArea.h;
	
			placeBoxes(boxes.rightAndBottom, chartArea, params);
	
			chart.chartArea = {
				left: chartArea.left,
				top: chartArea.top,
				right: chartArea.left + chartArea.w,
				bottom: chartArea.top + chartArea.h
			};
	
			// Finally update boxes in chartArea (radial scale for example)
			helpers$1.each(boxes.chartArea, function(layout) {
				var box = layout.box;
				extend(box, chart.chartArea);
				box.update(chartArea.w, chartArea.h);
			});
		}
	};
	
	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */
	
	var platform_basic = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			return item && item.getContext('2d') || null;
		}
	};
	
	var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
	
	var platform_dom$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': platform_dom
	});
	
	var stylesheet = getCjsExportFromNamespace(platform_dom$1);
	
	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
	
	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};
	
	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers$1.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}
	
	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;
	
		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');
	
		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};
	
		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';
	
		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}
	
		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}
	
		return canvas;
	}
	
	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line getter-return
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());
	
	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
	
	function addListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}
	
	function removeListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}
	
	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}
	
	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers$1.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}
	
	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];
	
		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;
	
			if (!ticking) {
				ticking = true;
				helpers$1.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}
	
	function createDiv(cls) {
		var el = document.createElement('div');
		el.className = cls || '';
		return el;
	}
	
	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var maxSize = 1000000;
	
		// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
		// https://github.com/chartjs/Chart.js/issues/5902
		var resizer = createDiv(CSS_SIZE_MONITOR);
		var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
		var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
	
		expand.appendChild(createDiv());
		shrink.appendChild(createDiv());
	
		resizer.appendChild(expand);
		resizer.appendChild(shrink);
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
	
		var onScroll = function() {
			resizer._reset();
			handler();
		};
	
		addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
	
		return resizer;
	}
	
	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};
	
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			addListener(node, type, proxy);
		});
	
		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;
	
		node.classList.add(CSS_RENDER_MONITOR);
	}
	
	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;
	
		if (proxy) {
			helpers$1.each(ANIMATION_START_EVENTS, function(type) {
				removeListener(node, type, proxy);
			});
	
			delete expando.renderProxy;
		}
	
		node.classList.remove(CSS_RENDER_MONITOR);
	}
	
	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	
		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				var container = chart.options.maintainAspectRatio && node.parentNode;
				var w = container ? container.clientWidth : 0;
				listener(createEvent('resize', chart));
				if (container && container.clientWidth < w && chart.canvas) {
					// If the container size shrank during chart resize, let's assume
					// scrollbar appeared. So we resize again with the scrollbar visible -
					// effectively making chart smaller and the scrollbar hidden again.
					// Because we are inside `throttled`, and currently `ticking`, scroll
					// events are ignored during this whole 2 resize process.
					// If we assumed wrong and something else happened, we are resizing
					// twice in a frame (potential performance issue)
					listener(createEvent('resize', chart));
				}
			}
		}));
	
		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}
	
				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}
	
	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;
	
		delete expando.resizer;
		unwatchForRender(node);
	
		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}
	
	/**
	 * Injects CSS styles inline if the styles are not already present.
	 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
	 * @param {string} css - the CSS to be injected.
	 */
	function injectCSS(rootNode, css) {
		// https://stackoverflow.com/q/3922139
		var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
		if (!expando.containsStyles) {
			expando.containsStyles = true;
			css = '/* Chart.js */\n' + css;
			var style = document.createElement('style');
			style.setAttribute('type', 'text/css');
			style.appendChild(document.createTextNode(css));
			rootNode.appendChild(style);
		}
	}
	
	var platform_dom$2 = {
		/**
		 * When `true`, prevents the automatic injection of the stylesheet required to
		 * correctly detect when the chart is added to the DOM and then resized. This
		 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
		 * to be manually imported to make this library compatible with any CSP.
		 * See https://github.com/chartjs/Chart.js/issues/5208
		 */
		disableCSSInjection: false,
	
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
	
		/**
		 * Initializes resources that depend on platform options.
		 * @param {HTMLCanvasElement} canvas - The Canvas element.
		 * @private
		 */
		_ensureLoaded: function(canvas) {
			if (!this.disableCSSInjection) {
				// If the canvas is in a shadow DOM, then the styles must also be inserted
				// into the same shadow DOM.
				// https://github.com/chartjs/Chart.js/issues/5763
				var root = canvas.getRootNode ? canvas.getRootNode() : document;
				var targetNode = root.host ? root : document.head;
				injectCSS(targetNode, stylesheet);
			}
		},
	
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}
	
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');
	
			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				// Load platform resources on first chart creation, to make it possible to
				// import the library before setting platform options.
				this._ensureLoaded(item);
				initCanvas(item, config);
				return context;
			}
	
			return null;
		},
	
		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}
	
			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers$1.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});
	
			helpers$1.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});
	
			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			// eslint-disable-next-line no-self-assign
			canvas.width = canvas.width;
	
			delete canvas[EXPANDO_KEY];
		},
	
		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};
	
			addListener(canvas, type, proxy);
		},
	
		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}
	
			removeListener(canvas, type, proxy);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.addEvent = addListener;
	
	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.removeEvent = removeListener;
	
	// @TODO Make possible to select another platform at build time.
	var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
	
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	var platform = helpers$1.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},
	
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},
	
		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},
	
		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {string} type - The ({@link IEvent}) type to listen for
		 * @param {function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},
	
		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart - Chart from which to remove the listener
		 * @param {string} type - The ({@link IEvent}) type to remove
		 * @param {function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	
	}, implementation);
	
	core_defaults._set('global', {
		plugins: {}
	});
	
	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	var core_plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],
	
		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,
	
		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},
	
		/**
		 * Returns the number of registered plugins?
		 * @returns {number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},
	
		/**
		 * Returns all registered plugin instances.
		 * @returns {IPlugin[]} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},
	
		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Chart} chart - The chart instance for which plugins should be called.
		 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;
	
			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}
	
			return true;
		},
	
		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {object[]} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart.$plugins || (chart.$plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}
	
			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};
	
			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}
	
				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}
	
				if (opts === true) {
					opts = helpers$1.clone(core_defaults.global.plugins[id]);
				}
	
				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});
	
			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		},
	
		/**
		 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
		 * but in some cases, this reference can be changed by the user when updating options.
		 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		 * @private
		 */
		_invalidate: function(chart) {
			delete chart.$plugins;
		}
	};
	
	var core_scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers
	
		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers$1.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers$1.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				core_layouts.addBox(chart, scale);
			});
		}
	};
	
	var valueOrDefault$8 = helpers$1.valueOrDefault;
	var getRtlHelper = helpers$1.rtl.getRtlAdapter;
	
	core_defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers$1.noop,
				title: function(tooltipItems, data) {
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
						if (item.label) {
							title = item.label;
						} else if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers$1.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers$1.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
						label += tooltipItem.value;
					} else {
						label += tooltipItem.yLabel;
					}
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers$1.noop,
				footer: helpers$1.noop,
				afterFooter: helpers$1.noop
			}
		}
	});
	
	var positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {object} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}
	
			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}
	
			return {
				x: x / count,
				y: y / count
			};
		},
	
		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {object} the position of the event in canvas coordinates
		 * @returns {object} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers$1.distanceBetweenPoints(eventPosition, center);
	
					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}
	
			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}
	
			return {
				x: x,
				y: y
			};
		}
	};
	
	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers$1.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}
	
		return base;
	}
	
	/**
	 * Returns array of strings split by newline
	 * @param {string} value - The value to split by newline.
	 * @returns {string[]} value if newline present - Returned from String split() method
	 * @function
	 */
	function splitNewlines(str) {
		if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
			return str.split('\n');
		}
		return str;
	}
	
	
	/**
	 * Private helper to create a tooltip item model
	 * @param element - the chart element (point, arc, bar) to create the tooltip item for
	 * @return new tooltip item
	 */
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;
		var controller = element._chart.getDatasetMeta(datasetIndex).controller;
		var indexScale = controller._getIndexScale();
		var valueScale = controller._getValueScale();
	
		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
			value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}
	
	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = core_defaults.global;
	
		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,
	
			// Drawing direction and text direction
			rtl: tooltipOpts.rtl,
			textDirection: tooltipOpts.textDirection,
	
			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,
	
			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,
	
			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,
	
			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}
	
	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;
	
		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;
	
		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;
	
		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};
	
		ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers$1.each(model.title, maxLineWidth);
	
		// Body width
		ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers$1.each(body, function(bodyItem) {
			helpers$1.each(bodyItem.before, maxLineWidth);
			helpers$1.each(bodyItem.lines, maxLineWidth);
			helpers$1.each(bodyItem.after, maxLineWidth);
		});
	
		// Reset back to 0
		widthPadding = 0;
	
		// Footer width
		ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers$1.each(model.footer, maxLineWidth);
	
		// Add padding
		width += 2 * model.xPadding;
	
		return {
			width: width,
			height: height
		};
	}
	
	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';
	
		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}
	
		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;
	
		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}
	
		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};
	
		if (lf(model.x)) {
			xAlign = 'left';
	
			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';
	
			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}
	
		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}
	
	/**
	 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;
	
		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;
	
		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}
	
		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}
	
		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}
	
		return {
			x: x,
			y: y
		};
	}
	
	function getAlignedX(vm, align) {
		return align === 'center'
			? vm.x + vm.width / 2
			: align === 'right'
				? vm.x + vm.width - vm.xPadding
				: vm.x + vm.xPadding;
	}
	
	/**
	 * Helper to build before and after body lines
	 */
	function getBeforeAfterBodyLines(callback) {
		return pushOrConcat([], splitNewlines(callback));
	}
	
	var exports$4 = core_element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},
	
		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;
	
			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeTitle));
			lines = pushOrConcat(lines, splitNewlines(title));
			lines = pushOrConcat(lines, splitNewlines(afterTitle));
	
			return lines;
		},
	
		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
		},
	
		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];
	
			helpers$1.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
	
				bodyItems.push(bodyItem);
			});
	
			return bodyItems;
		},
	
		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
		},
	
		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;
	
			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeFooter));
			lines = pushOrConcat(lines, splitNewlines(footer));
			lines = pushOrConcat(lines, splitNewlines(afterFooter));
	
			return lines;
		},
	
		update: function(changed) {
			var me = this;
			var opts = me._options;
	
			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;
	
			var data = me._data;
	
			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};
	
			var i, len;
	
			if (active.length) {
				model.opacity = 1;
	
				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
	
				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}
	
				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}
	
				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}
	
				// Determine colors for boxes
				helpers$1.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});
	
	
				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);
	
				// Initial positioning and colors
				model.x = tooltipPosition.x;
				model.y = tooltipPosition.y;
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;
	
				// data points
				model.dataPoints = tooltipItems;
	
				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}
	
			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;
	
			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;
	
			me._model = model;
	
			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}
	
			return me;
		},
	
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;
	
			if (yAlign === 'center') {
				y2 = ptY + (height / 2);
	
				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;
	
					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;
	
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
	
		drawTitle: function(pt, vm, ctx) {
			var title = vm.title;
			var length = title.length;
			var titleFontSize, titleSpacing, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._titleAlign);
	
				ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
				ctx.textBaseline = 'middle';
	
				titleFontSize = vm.titleFontSize;
				titleSpacing = vm.titleSpacing;
	
				ctx.fillStyle = vm.titleFontColor;
				ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
					if (i + 1 === length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
	
		drawBody: function(pt, vm, ctx) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var bodyAlign = vm._bodyAlign;
			var body = vm.body;
			var drawColorBoxes = vm.displayColors;
			var xLinePadding = 0;
			var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
	
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
			var fillLineOfText = function(line) {
				ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
				pt.y += bodyFontSize + bodySpacing;
			};
	
			var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
			var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
	
			ctx.textAlign = bodyAlign;
			ctx.textBaseline = 'middle';
			ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
			pt.x = getAlignedX(vm, bodyAlignForCalculation);
	
			// Before body lines
			ctx.fillStyle = vm.bodyFontColor;
			helpers$1.each(vm.beforeBody, fillLineOfText);
	
			xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
				? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
				: 0;
	
			// Draw body lines now
			for (i = 0, ilen = body.length; i < ilen; ++i) {
				bodyItem = body[i];
				textColor = vm.labelTextColors[i];
				labelColors = vm.labelColors[i];
	
				ctx.fillStyle = textColor;
				helpers$1.each(bodyItem.before, fillLineOfText);
	
				lines = bodyItem.lines;
				for (j = 0, jlen = lines.length; j < jlen; ++j) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						var rtlColorX = rtlHelper.x(colorX);
	
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = vm.legendColorBackground;
						ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = labelColors.borderColor;
						ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Inner square
						ctx.fillStyle = labelColors.backgroundColor;
						ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}
	
					fillLineOfText(lines[j]);
				}
	
				helpers$1.each(bodyItem.after, fillLineOfText);
			}
	
			// Reset back to 0 for after body
			xLinePadding = 0;
	
			// After body lines
			helpers$1.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
	
		drawFooter: function(pt, vm, ctx) {
			var footer = vm.footer;
			var length = footer.length;
			var footerFontSize, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._footerAlign);
				pt.y += vm.footerMarginTop;
	
				ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
				ctx.textBaseline = 'middle';
	
				footerFontSize = vm.footerFontSize;
	
				ctx.fillStyle = vm.footerFontColor;
				ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
					pt.y += footerFontSize + vm.footerSpacing;
				}
			}
		},
	
		drawBackground: function(pt, vm, ctx, tooltipSize) {
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;
	
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
	
			ctx.fill();
	
			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
	
			if (vm.opacity === 0) {
				return;
			}
	
			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};
	
			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
			if (this._options.enabled && hasTooltipContent) {
				ctx.save();
				ctx.globalAlpha = opacity;
	
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize);
	
				// Draw Title, Body, and Footer
				pt.y += vm.yPadding;
	
				helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
	
				// Titles
				this.drawTitle(pt, vm, ctx);
	
				// Body
				this.drawBody(pt, vm, ctx);
	
				// Footer
				this.drawFooter(pt, vm, ctx);
	
				helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
	
				ctx.restore();
			}
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;
	
			me._lastActive = me._lastActive || [];
	
			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				if (options.reverse) {
					me._active.reverse();
				}
			}
	
			// Remember Last Actives
			changed = !helpers$1.arrayEquals(me._active, me._lastActive);
	
			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					me.update(true);
					me.pivot();
				}
			}
	
			return changed;
		}
	});
	
	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	var positioners_1 = positioners;
	
	var core_tooltip = exports$4;
	core_tooltip.positioners = positioners_1;
	
	var valueOrDefault$9 = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		elements: {},
		events: [
			'mousemove',
			'mouseout',
			'click',
			'touchstart',
			'touchmove'
		],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		maintainAspectRatio: true,
		responsive: true,
		responsiveAnimationDuration: 0
	});
	
	/**
	 * Recursively merge the given config objects representing the `scales` option
	 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
	 * returns a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeScaleConfig(/* config objects ... */) {
		return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;
	
					if (!target[key]) {
						target[key] = [];
					}
	
					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
	
						if (i >= target[key].length) {
							target[key].push({});
						}
	
						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers$1.merge(target[key][i], scale);
						}
					}
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	/**
	 * Recursively merge the given config objects as the root options by handling
	 * default scale options for the `scales` and `scale` properties, then returns
	 * a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeConfig(/* config objects ... */) {
		return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				var tval = target[key] || Object.create(null);
				var sval = source[key];
	
				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = mergeScaleConfig(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	function initConfig(config) {
		config = config || Object.create(null);
	
		// Do NOT use mergeConfig for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];
	
		config.options = mergeConfig(
			core_defaults.global,
			core_defaults[config.type],
			config.options || {});
	
		return config;
	}
	
	function updateConfig(chart) {
		var newOptions = chart.options;
	
		helpers$1.each(chart.scales, function(scale) {
			core_layouts.removeBox(chart, scale);
		});
	
		newOptions = mergeConfig(
			core_defaults.global,
			core_defaults[chart.config.type],
			newOptions);
	
		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();
	
		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}
	
	function nextAvailableScaleId(axesOpts, prefix, index) {
		var id;
		var hasId = function(obj) {
			return obj.id === id;
		};
	
		do {
			id = prefix + index++;
		} while (helpers$1.findIndex(axesOpts, hasId) >= 0);
	
		return id;
	}
	
	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}
	
	function compare2Level(l1, l2) {
		return function(a, b) {
			return a[l1] === b[l1]
				? a[l2] - b[l2]
				: a[l1] - b[l1];
		};
	}
	
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};
	
	helpers$1.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;
	
			config = initConfig(config);
	
			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;
	
			me.id = helpers$1.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;
			me._layers = [];
	
			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception
	
			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;
	
			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});
	
			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}
	
			me.initialize();
			me.update();
		},
	
		/**
		 * @private
		 */
		initialize: function() {
			var me = this;
	
			// Before init plugin notification
			core_plugins.notify(me, 'beforeInit');
	
			helpers$1.retinaScale(me, me.options.devicePixelRatio);
	
			me.bindEvents();
	
			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}
	
			me.initToolTip();
	
			// After init plugin notification
			core_plugins.notify(me, 'afterInit');
	
			return me;
		},
	
		clear: function() {
			helpers$1.canvas.clear(this);
			return this;
		},
	
		stop: function() {
			// Stops any current animation loop occurring
			core_animations.cancelAnimation(this);
			return this;
		},
	
		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.
	
			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
			var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
	
			if (me.width === newWidth && me.height === newHeight) {
				return;
			}
	
			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';
	
			helpers$1.retinaScale(me, options.devicePixelRatio);
	
			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				core_plugins.notify(me, 'resize', [newSize]);
	
				// Notify of resize
				if (options.onResize) {
					options.onResize(me, newSize);
				}
	
				me.stop();
				me.update({
					duration: options.responsiveAnimationDuration
				});
			}
		},
	
		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;
	
			helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				if (!xAxisOptions.id) {
					xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
				}
			});
	
			helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				if (!yAxisOptions.id) {
					yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
				}
			});
	
			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},
	
		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});
	
			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}
	
			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}
	
			helpers$1.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
	
				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}
	
				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = core_scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}
	
				scale.mergeTicksOptions();
	
				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers$1.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});
	
			me.scales = scales;
	
			core_scaleService.addScalesToLayout(this);
		},
	
		buildOrUpdateControllers: function() {
			var me = this;
			var newControllers = [];
			var datasets = me.data.datasets;
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				var dataset = datasets[i];
				var meta = me.getDatasetMeta(i);
				var type = dataset.type || me.config.type;
	
				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(i);
					meta = me.getDatasetMeta(i);
				}
				meta.type = type;
				meta.order = dataset.order || 0;
				meta.index = i;
	
				if (meta.controller) {
					meta.controller.updateIndex(i);
					meta.controller.linkScales();
				} else {
					var ControllerClass = controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}
	
					meta.controller = new ControllerClass(me, i);
					newControllers.push(meta.controller);
				}
			}
	
			return newControllers;
		},
	
		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},
	
		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},
	
		update: function(config) {
			var me = this;
			var i, ilen;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			updateConfig(me);
	
			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			core_plugins._invalidate(me);
	
			if (core_plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}
	
			// In case the entire data object changed
			me.tooltip._data = me.data;
	
			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();
	
			// Make sure all dataset controllers have correct meta data counts
			for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
				me.getDatasetMeta(i).controller.buildOrUpdateElements();
			}
	
			me.updateLayout();
	
			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers$1.each(newControllers, function(controller) {
					controller.reset();
				});
			}
	
			me.updateDatasets();
	
			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();
	
			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];
	
			// Do this before render so that any plugins that need final scale updates can use it
			core_plugins.notify(me, 'afterUpdate');
	
			me._layers.sort(compare2Level('z', '_idx'));
	
			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},
	
		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeLayout') === false) {
				return;
			}
	
			core_layouts.update(this, this.width, this.height);
	
			me._layers = [];
			helpers$1.each(me.boxes, function(box) {
				// _configure is called twice, once in core.scale.update and once here.
				// Here the boxes are fully updated and at their final positions.
				if (box._configure) {
					box._configure();
				}
				me._layers.push.apply(me._layers, box._layers());
			}, me);
	
			me._layers.forEach(function(item, index) {
				item._idx = index;
			});
	
			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			core_plugins.notify(me, 'afterScaleUpdate');
			core_plugins.notify(me, 'afterLayout');
		},
	
		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}
	
			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}
	
			core_plugins.notify(me, 'afterDatasetsUpdate');
		},
	
		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};
	
			if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}
	
			meta.controller._update();
	
			core_plugins.notify(me, 'afterDatasetUpdate', [args]);
		},
	
		render: function(config) {
			var me = this;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			var animationOptions = me.options.animation;
			var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
			var lazy = config.lazy;
	
			if (core_plugins.notify(me, 'beforeRender') === false) {
				return;
			}
	
			var onComplete = function(animation) {
				core_plugins.notify(me, 'afterRender');
				helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};
	
			if (animationOptions && duration) {
				var animation = new core_animation({
					numSteps: duration / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,
	
					render: function(chart, animationObject) {
						var easingFunction = helpers$1.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;
	
						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},
	
					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});
	
				core_animations.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();
	
				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new core_animation({numSteps: 0, chart: me}));
			}
	
			return me;
		},
	
		draw: function(easingValue) {
			var me = this;
			var i, layers;
	
			me.clear();
	
			if (helpers$1.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}
	
			me.transition(easingValue);
	
			if (me.width <= 0 || me.height <= 0) {
				return;
			}
	
			if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}
	
			// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
			// currently be part of layers. Instead, we draw
			// layers <= 0 before(default, backward compat), and the rest after
			layers = me._layers;
			for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me.drawDatasets(easingValue);
	
			// Rest of layers
			for (; i < layers.length; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me._drawTooltip(easingValue);
	
			core_plugins.notify(me, 'afterDraw', [easingValue]);
		},
	
		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;
	
			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}
	
			me.tooltip.transition(easingValue);
		},
	
		/**
		 * @private
		 */
		_getSortedDatasetMetas: function(filterVisible) {
			var me = this;
			var datasets = me.data.datasets || [];
			var result = [];
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; ++i) {
				if (!filterVisible || me.isDatasetVisible(i)) {
					result.push(me.getDatasetMeta(i));
				}
			}
	
			result.sort(compare2Level('order', 'index'));
	
			return result;
		},
	
		/**
		 * @private
		 */
		_getSortedVisibleDatasetMetas: function() {
			return this._getSortedDatasetMetas(true);
		},
	
		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;
			var metasets, i;
	
			if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}
	
			metasets = me._getSortedVisibleDatasetMetas();
			for (i = metasets.length - 1; i >= 0; --i) {
				me.drawDataset(metasets[i], easingValue);
			}
	
			core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},
	
		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(meta, easingValue) {
			var me = this;
			var args = {
				meta: meta,
				index: meta.index,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}
	
			meta.controller.draw(easingValue);
	
			core_plugins.notify(me, 'afterDatasetDraw', [args]);
		},
	
		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}
	
			tooltip.draw();
	
			core_plugins.notify(me, 'afterTooltipDraw', [args]);
		},
	
		/**
		 * Get the single element that was clicked on
		 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		 */
		getElementAtEvent: function(e) {
			return core_interaction.modes.single(this, e);
		},
	
		getElementsAtEvent: function(e) {
			return core_interaction.modes.label(this, e, {intersect: true});
		},
	
		getElementsAtXAxis: function(e) {
			return core_interaction.modes['x-axis'](this, e, {intersect: true});
		},
	
		getElementsAtEventForMode: function(e, mode, options) {
			var method = core_interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}
	
			return [];
		},
	
		getDatasetAtEvent: function(e) {
			return core_interaction.modes.dataset(this, e, {intersect: true});
		},
	
		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}
	
			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null,
					order: dataset.order || 0,
					index: datasetIndex
				};
			}
	
			return meta;
		},
	
		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},
	
		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);
	
			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},
	
		generateLegend: function() {
			return this.options.legendCallback(this);
		},
	
		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];
	
			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},
	
		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;
	
			me.stop();
	
			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}
	
			if (canvas) {
				me.unbindEvents();
				helpers$1.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}
	
			core_plugins.notify(me, 'destroy');
	
			delete Chart.instances[me.id];
		},
	
		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},
	
		initToolTip: function() {
			var me = this;
			me.tooltip = new core_tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},
	
		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};
	
			helpers$1.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});
	
			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};
	
				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},
	
		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}
	
			delete me._listeners;
			helpers$1.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},
	
		updateHoverStyle: function(elements, mode, enabled) {
			var prefix = enabled ? 'set' : 'remove';
			var element, i, ilen;
	
			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
				}
			}
	
			if (mode === 'dataset') {
				this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
			}
		},
	
		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;
	
			if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}
	
			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;
	
			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}
	
			core_plugins.notify(me, 'afterEvent', [e]);
	
			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();
	
				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render({
					duration: me.options.hover.animationDuration,
					lazy: true
				});
			}
	
			me._bufferedRender = false;
			me._bufferedRequest = null;
	
			return me;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;
	
			me.lastActive = me.lastActive || [];
	
			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}
	
			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);
	
			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}
	
			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}
	
			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}
	
			changed = !helpers$1.arrayEquals(me.active, me.lastActive);
	
			// Remember Last Actives
			me.lastActive = me.active;
	
			return changed;
		}
	});
	
	/**
	 * NOTE(SB) We actually don't use this container anymore but we need to keep it
	 * for backward compatibility. Though, it can still be useful for plugins that
	 * would need to work on multiple charts?!
	 */
	Chart.instances = {};
	
	var core_controller = Chart;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	Chart.types = {};
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.configMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.configMerge = mergeConfig;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.scaleMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.scaleMerge = mergeScaleConfig;
	
	var core_helpers = function() {
	
		// -- Basic js utility methods
	
		helpers$1.where = function(collection, filterCallback) {
			if (helpers$1.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers$1.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers$1.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
	
		// -- Math methods
		helpers$1.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers$1.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers$1.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
		};
		helpers$1.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers$1.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers$1.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers$1.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers$1.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
	
		/**
		 * Returns the number of decimal places
		 * i.e. the number of digits after the decimal point, of the value of this Number.
		 * @param {number} x - A number.
		 * @returns {number} The number of decimal places.
		 * @private
		 */
		helpers$1._decimalPlaces = function(x) {
			if (!helpers$1.isFinite(x)) {
				return;
			}
			var e = 1;
			var p = 0;
			while (Math.round(x * e) / e !== x) {
				e *= 10;
				p++;
			}
			return p;
		};
	
		// Gets the angle from vertical upright to the point about a centre.
		helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers$1.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.helpers.aliasPixel
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		helpers$1.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
	
		/**
		 * Returns the aligned pixel value to avoid anti-aliasing blur
		 * @param {Chart} chart - The chart instance.
		 * @param {number} pixel - A pixel value.
		 * @param {number} width - The width of the element.
		 * @returns {number} The aligned pixel value.
		 * @private
		 */
		helpers$1._alignPixel = function(chart, pixel, width) {
			var devicePixelRatio = chart.currentDevicePixelRatio;
			var halfWidth = width / 2;
			return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
		};
	
		helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers$1.EPSILON = Number.EPSILON || 1e-14;
		helpers$1.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers$1.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers$1.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers$1.niceNum = function(range, round) {
			var exponent = Math.floor(helpers$1.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers$1.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers$1.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.target || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		/**
		 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
		 * @param {HTMLElement} domNode - the node to check the constraint on
		 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
		 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
		 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
		 */
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = helpers$1._getParentNode(domNode);
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers$1.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers$1.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		/**
		 * @private
	 	 */
		helpers$1._calculatePadding = function(container, padding, parentDimension) {
			padding = helpers$1.getStyle(container, padding);
	
			return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
		};
		/**
		 * @private
		 */
		helpers$1._getParentNode = function(domNode) {
			var parent = domNode.parentNode;
			if (parent && parent.toString() === '[object ShadowRoot]') {
				parent = parent.host;
			}
			return parent;
		};
		helpers$1.getMaximumWidth = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientWidth;
			}
	
			var clientWidth = container.clientWidth;
			var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
			var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
	
			var w = clientWidth - paddingLeft - paddingRight;
			var cw = helpers$1.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers$1.getMaximumHeight = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientHeight;
			}
	
			var clientHeight = container.clientHeight;
			var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
			var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
	
			var h = clientHeight - paddingTop - paddingBottom;
			var ch = helpers$1.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers$1.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers$1.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			if (!canvas.style.height && !canvas.style.width) {
				canvas.style.height = height + 'px';
				canvas.style.width = width + 'px';
			}
		};
		// -- Canvas methods
		helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			var ilen = arrayOfThings.length;
			var i, j, jlen, thing, nestedThing;
			for (i = 0; i < ilen; i++) {
				thing = arrayOfThings[i];
	
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
					longest = helpers$1.measureText(ctx, data, gc, longest, thing);
				} else if (helpers$1.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					for (j = 0, jlen = thing.length; j < jlen; j++) {
						nestedThing = thing[j];
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
							longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
						}
					}
				}
			}
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers$1.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
	
		/**
		 * @deprecated
		 */
		helpers$1.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers$1.each(arrayOfThings, function(thing) {
				if (helpers$1.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
	
		helpers$1.color = !chartjsColor ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = core_defaults.global.defaultColor;
				}
	
				return chartjsColor(value);
			};
	
		helpers$1.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
				colorValue :
				helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};
	
	function abstract() {
		throw new Error(
			'This method is not implemented: either no adapter can ' +
			'be found or an incomplete integration was provided.'
		);
	}
	
	/**
	 * Date adapter (current used by the time scale)
	 * @namespace Chart._adapters._date
	 * @memberof Chart._adapters
	 * @private
	 */
	
	/**
	 * Currently supported unit string values.
	 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
	 * @memberof Chart._adapters._date
	 * @name Unit
	 */
	
	/**
	 * @class
	 */
	function DateAdapter(options) {
		this.options = options || {};
	}
	
	helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
		/**
		 * Returns a map of time formats for the supported formatting units defined
		 * in Unit as well as 'datetime' representing a detailed date/time string.
		 * @returns {{string: string}}
		 */
		formats: abstract,
	
		/**
		 * Parses the given `value` and return the associated timestamp.
		 * @param {any} value - the value to parse (usually comes from the data)
		 * @param {string} [format] - the expected data format
		 * @returns {(number|null)}
		 * @function
		 */
		parse: abstract,
	
		/**
		 * Returns the formatted date in the specified `format` for a given `timestamp`.
		 * @param {number} timestamp - the timestamp to format
		 * @param {string} format - the date/time token
		 * @return {string}
		 * @function
		 */
		format: abstract,
	
		/**
		 * Adds the specified `amount` of `unit` to the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {number} amount - the amount to add
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		add: abstract,
	
		/**
		 * Returns the number of `unit` between the given timestamps.
		 * @param {number} max - the input timestamp (reference)
		 * @param {number} min - the timestamp to substract
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		diff: abstract,
	
		/**
		 * Returns start of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
		 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
		 * @function
		 */
		startOf: abstract,
	
		/**
		 * Returns end of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @function
		 */
		endOf: abstract,
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility for scale.getValueForPixel(),
		 * this method should be overridden only by the moment adapter.
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(value) {
			return value;
		}
	});
	
	DateAdapter.override = function(members) {
		helpers$1.extend(DateAdapter.prototype, members);
	};
	
	var _date = DateAdapter;
	
	var core_adapters = {
		_date: _date
	};
	
	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	var core_ticks = {
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {string|string[]} the label to display
			 */
			values: function(value) {
				return helpers$1.isArray(value) ? value : '' + value;
			},
	
			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {number} the value to be formatted
			 * @param index {number} the position of the tickValue parameter in the ticks array
			 * @param ticks {number[]} the list of ticks being converted
			 * @return {string} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}
	
				var logDelta = helpers$1.log10(Math.abs(delta));
				var tickString = '';
	
				if (tickValue !== 0) {
					var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
					if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
						var logTick = helpers$1.log10(Math.abs(tickValue));
						var numExponential = Math.floor(logTick) - Math.floor(logDelta);
						numExponential = Math.max(Math.min(numExponential, 20), 0);
						tickString = tickValue.toExponential(numExponential);
					} else {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					}
				} else {
					tickString = '0'; // never show decimal places for 0
				}
	
				return tickString;
			},
	
			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));
	
				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};
	
	var isArray = helpers$1.isArray;
	var isNullOrUndef = helpers$1.isNullOrUndef;
	var valueOrDefault$a = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
	
	core_defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,
	
		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		// scale label
		scaleLabel: {
			// display property
			display: false,
	
			// actual label
			labelString: '',
	
			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},
	
		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: core_ticks.formatters.values,
			minor: {},
			major: {}
		}
	});
	
	/** Returns a new array containing numItems from arr */
	function sample(arr, numItems) {
		var result = [];
		var increment = arr.length / numItems;
		var i = 0;
		var len = arr.length;
	
		for (; i < len; i += increment) {
			result.push(arr[Math.floor(i)]);
		}
		return result;
	}
	
	function getPixelForGridLine(scale, index, offsetGridLines) {
		var length = scale.getTicks().length;
		var validIndex = Math.min(index, length - 1);
		var lineValue = scale.getPixelForTick(validIndex);
		var start = scale._startPixel;
		var end = scale._endPixel;
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
		var offset;
	
		if (offsetGridLines) {
			if (length === 1) {
				offset = Math.max(lineValue - start, end - lineValue);
			} else if (index === 0) {
				offset = (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
			}
			lineValue += validIndex < index ? offset : -offset;
	
			// Return undefined if the pixel is out of the range
			if (lineValue < start - epsilon || lineValue > end + epsilon) {
				return;
			}
		}
		return lineValue;
	}
	
	function garbageCollect(caches, length) {
		helpers$1.each(caches, function(cache) {
			var gc = cache.gc;
			var gcLen = gc.length / 2;
			var i;
			if (gcLen > length) {
				for (i = 0; i < gcLen; ++i) {
					delete cache.data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
		});
	}
	
	/**
	 * Returns {width, height, offset} objects for the first, last, widest, highest tick
	 * labels where offset indicates the anchor point offset from the top in pixels.
	 */
	function computeLabelSizes(ctx, tickFonts, ticks, caches) {
		var length = ticks.length;
		var widths = [];
		var heights = [];
		var offsets = [];
		var widestLabelSize = 0;
		var highestLabelSize = 0;
		var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
	
		for (i = 0; i < length; ++i) {
			label = ticks[i].label;
			tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
			ctx.font = fontString = tickFont.string;
			cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
			lineHeight = tickFont.lineHeight;
			width = height = 0;
			// Undefined labels and arrays should not be measured
			if (!isNullOrUndef(label) && !isArray(label)) {
				width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
				height = lineHeight;
			} else if (isArray(label)) {
				// if it is an array let's measure each element
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					nestedLabel = label[j];
					// Undefined labels and arrays should not be measured
					if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
						width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
						height += lineHeight;
					}
				}
			}
			widths.push(width);
			heights.push(height);
			offsets.push(lineHeight / 2);
			widestLabelSize = Math.max(width, widestLabelSize);
			highestLabelSize = Math.max(height, highestLabelSize);
		}
		garbageCollect(caches, length);
	
		widest = widths.indexOf(widestLabelSize);
		highest = heights.indexOf(highestLabelSize);
	
		function valueAt(idx) {
			return {
				width: widths[idx] || 0,
				height: heights[idx] || 0,
				offset: offsets[idx] || 0
			};
		}
	
		return {
			first: valueAt(0),
			last: valueAt(length - 1),
			widest: valueAt(widest),
			highest: valueAt(highest)
		};
	}
	
	function getTickMarkLength(options) {
		return options.drawTicks ? options.tickMarkLength : 0;
	}
	
	function getScaleLabelHeight(options) {
		var font, padding;
	
		if (!options.display) {
			return 0;
		}
	
		font = helpers$1.options._parseFont(options);
		padding = helpers$1.options.toPadding(options.padding);
	
		return font.lineHeight + padding.height;
	}
	
	function parseFontOptions(options, nestedOpts) {
		return helpers$1.extend(helpers$1.options._parseFont({
			fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
			fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
			fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
			lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
		}), {
			color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
		});
	}
	
	function parseTickFontOptions(options) {
		var minor = parseFontOptions(options, options.minor);
		var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
	
		return {minor: minor, major: major};
	}
	
	function nonSkipped(ticksToFilter) {
		var filtered = [];
		var item, index, len;
		for (index = 0, len = ticksToFilter.length; index < len; ++index) {
			item = ticksToFilter[index];
			if (typeof item._index !== 'undefined') {
				filtered.push(item);
			}
		}
		return filtered;
	}
	
	function getEvenSpacing(arr) {
		var len = arr.length;
		var i, diff;
	
		if (len < 2) {
			return false;
		}
	
		for (diff = arr[0], i = 1; i < len; ++i) {
			if (arr[i] - arr[i - 1] !== diff) {
				return false;
			}
		}
		return diff;
	}
	
	function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
		var evenMajorSpacing = getEvenSpacing(majorIndices);
		var spacing = (ticks.length - 1) / ticksLimit;
		var factors, factor, i, ilen;
	
		// If the major ticks are evenly spaced apart, place the minor ticks
		// so that they divide the major ticks into even chunks
		if (!evenMajorSpacing) {
			return Math.max(spacing, 1);
		}
	
		factors = helpers$1.math._factorize(evenMajorSpacing);
		for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
			factor = factors[i];
			if (factor > spacing) {
				return factor;
			}
		}
		return Math.max(spacing, 1);
	}
	
	function getMajorIndices(ticks) {
		var result = [];
		var i, ilen;
		for (i = 0, ilen = ticks.length; i < ilen; i++) {
			if (ticks[i].major) {
				result.push(i);
			}
		}
		return result;
	}
	
	function skipMajors(ticks, majorIndices, spacing) {
		var count = 0;
		var next = majorIndices[0];
		var i, tick;
	
		spacing = Math.ceil(spacing);
		for (i = 0; i < ticks.length; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = majorIndices[count * spacing];
			} else {
				delete tick.label;
			}
		}
	}
	
	function skip(ticks, spacing, majorStart, majorEnd) {
		var start = valueOrDefault$a(majorStart, 0);
		var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
		var count = 0;
		var length, i, tick, next;
	
		spacing = Math.ceil(spacing);
		if (majorEnd) {
			length = majorEnd - majorStart;
			spacing = length / Math.floor(length / spacing);
		}
	
		next = start;
	
		while (next < 0) {
			count++;
			next = Math.round(start + count * spacing);
		}
	
		for (i = Math.max(start, 0); i < end; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = Math.round(start + count * spacing);
			} else {
				delete tick.label;
			}
		}
	}
	
	var Scale = core_element.extend({
	
		zeroLineIndex: 0,
	
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},
	
		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},
	
		/**
		* @private
		*/
		_getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
		},
	
		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.Scale.mergeTicksOptions
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		mergeTicksOptions: function() {
			// noop
		},
	
		beforeUpdate: function() {
			helpers$1.callback(this.options.beforeUpdate, [this]);
		},
	
		/**
		 * @param {number} maxWidth - the max width in pixels
		 * @param {number} maxHeight - the max height in pixels
		 * @param {object} margins - the space between the edge of the other scales and edge of the chart
		 *   This space comes from two sources:
		 *     - padding - space that's required to show the labels at the edges of the scale
		 *     - thickness of scales or legends in another orientation
		 */
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var tickOpts = me.options.ticks;
			var sampleSize = tickOpts.sampleSize;
			var i, ilen, labels, ticks, samplingEnabled;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers$1.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
	
			me._ticks = null;
			me.ticks = null;
			me._labelSizes = null;
			me._maxLabelLines = 0;
			me.longestLabelWidth = 0;
			me.longestTextCache = me.longestTextCache || {};
			me._gridLineItems = null;
			me._labelItems = null;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
	
			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();
	
			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.
	
			me.beforeBuildTicks();
	
			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];
	
			// Allow modification of ticks in callback.
			ticks = me.afterBuildTicks(ticks) || ticks;
	
			// Ensure ticks contains ticks in new tick format
			if ((!ticks || !ticks.length) && me.ticks) {
				ticks = [];
				for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
					ticks.push({
						value: me.ticks[i],
						major: false
					});
				}
			}
	
			me._ticks = ticks;
	
			// Compute tick rotation and fit using a sampled subset of labels
			// We generally don't need to compute the size of every single label for determining scale size
			samplingEnabled = sampleSize < ticks.length;
			labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
	
			// _configure is called twice, once here, once from core.controller.updateLayout.
			// Here we haven't been positioned yet, but dimensions are correct.
			// Variables set in _configure are needed for calculateTickRotation, and
			// it's ok that coordinates are not correct there, only dimensions matter.
			me._configure();
	
			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
	
			me.beforeFit();
			me.fit();
			me.afterFit();
	
			// Auto-skip
			me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
	
			if (samplingEnabled) {
				// Generate labels using all non-skipped ticks
				labels = me._convertTicksToLabels(me._ticksToDraw);
			}
	
			me.ticks = labels;   // BACKWARD COMPATIBILITY
	
			// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
	
			me.afterUpdate();
	
			// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
			// make maxWidth and maxHeight private
			return me.minSize;
		},
	
		/**
		 * @private
		 */
		_configure: function() {
			var me = this;
			var reversePixels = me.options.ticks.reverse;
			var startPixel, endPixel;
	
			if (me.isHorizontal()) {
				startPixel = me.left;
				endPixel = me.right;
			} else {
				startPixel = me.top;
				endPixel = me.bottom;
				// by default vertical scales are from bottom to top, so pixels are reversed
				reversePixels = !reversePixels;
			}
			me._startPixel = startPixel;
			me._endPixel = endPixel;
			me._reversePixels = reversePixels;
			me._length = endPixel - startPixel;
		},
	
		afterUpdate: function() {
			helpers$1.callback(this.options.afterUpdate, [this]);
		},
	
		//
	
		beforeSetDimensions: function() {
			helpers$1.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers$1.callback(this.options.afterSetDimensions, [this]);
		},
	
		// Data limits
		beforeDataLimits: function() {
			helpers$1.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers$1.noop,
		afterDataLimits: function() {
			helpers$1.callback(this.options.afterDataLimits, [this]);
		},
	
		//
		beforeBuildTicks: function() {
			helpers$1.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers$1.noop,
		afterBuildTicks: function(ticks) {
			var me = this;
			// ticks is empty for old axis implementations here
			if (isArray(ticks) && ticks.length) {
				return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
			}
			// Support old implementations (that modified `this.ticks` directly in buildTicks)
			me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
			return ticks;
		},
	
		beforeTickToLabelConversion: function() {
			helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
		},
	
		//
	
		beforeCalculateTickRotation: function() {
			helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var options = me.options;
			var tickOpts = options.ticks;
			var numTicks = me.getTicks().length;
			var minRotation = tickOpts.minRotation || 0;
			var maxRotation = tickOpts.maxRotation;
			var labelRotation = minRotation;
			var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
	
			if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
				me.labelRotation = minRotation;
				return;
			}
	
			labelSizes = me._getLabelSizes();
			maxLabelWidth = labelSizes.widest.width;
			maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
	
			// Estimate the width of each grid based on the canvas width, the maximum
			// label width and the number of tick intervals
			maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
			tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
	
			// Allow 3 pixels x2 padding either side for label readability
			if (maxLabelWidth + 6 > tickWidth) {
				tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
				maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
					- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
				maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
				labelRotation = helpers$1.toDegrees(Math.min(
					Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
					Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
				));
				labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
			}
	
			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
		},
	
		//
	
		beforeFit: function() {
			helpers$1.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};
	
			var chart = me.chart;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = me._isVisible();
			var isBottom = opts.position === 'bottom';
			var isHorizontal = me.isHorizontal();
	
			// Width
			if (isHorizontal) {
				minSize.width = me.maxWidth;
			} else if (display) {
				minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// height
			if (!isHorizontal) {
				minSize.height = me.maxHeight; // fill all the height
			} else if (display) {
				minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// Don't bother fitting the ticks if we are not showing the labels
			if (tickOpts.display && display) {
				var tickFonts = parseTickFontOptions(tickOpts);
				var labelSizes = me._getLabelSizes();
				var firstLabelSize = labelSizes.first;
				var lastLabelSize = labelSizes.last;
				var widestLabelSize = labelSizes.widest;
				var highestLabelSize = labelSizes.highest;
				var lineSpace = tickFonts.minor.lineHeight * 0.4;
				var tickPadding = tickOpts.padding;
	
				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					var isRotated = me.labelRotation !== 0;
					var angleRadians = helpers$1.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);
	
					var labelHeight = sinRotation * widestLabelSize.width
						+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
						+ (isRotated ? 0 : lineSpace); // padding
	
					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
	
					var offsetLeft = me.getPixelForTick(0) - me.left;
					var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
					var paddingLeft, paddingRight;
	
					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (isRotated) {
						paddingLeft = isBottom ?
							cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
							sinRotation * (firstLabelSize.height - firstLabelSize.offset);
						paddingRight = isBottom ?
							sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
							cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
					} else {
						paddingLeft = firstLabelSize.width / 2;
						paddingRight = lastLabelSize.width / 2;
					}
	
					// Adjust padding taking into account changes in offsets
					// and add 3 px to move away from canvas edges
					me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
					me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					var labelWidth = tickOpts.mirror ? 0 :
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						widestLabelSize.width + tickPadding + lineSpace;
	
					minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
	
					me.paddingTop = firstLabelSize.height / 2;
					me.paddingBottom = lastLabelSize.height / 2;
				}
			}
	
			me.handleMargins();
	
			if (isHorizontal) {
				me.width = me._length = chart.width - me.margins.left - me.margins.right;
				me.height = minSize.height;
			} else {
				me.width = minSize.width;
				me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
			}
		},
	
		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.margins.left = Math.max(me.paddingLeft, me.margins.left);
				me.margins.top = Math.max(me.paddingTop, me.margins.top);
				me.margins.right = Math.max(me.paddingRight, me.margins.right);
				me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
			}
		},
	
		afterFit: function() {
			helpers$1.callback(this.options.afterFit, [this]);
		},
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
		isFullWidth: function() {
			return this.options.fullWidth;
		},
	
		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
				return NaN;
			}
	
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}
	
			// Value is good, return it
			return rawValue;
		},
	
		_convertTicksToLabels: function(ticks) {
			var me = this;
			var labels, i, ilen;
	
			me.ticks = ticks.map(function(tick) {
				return tick.value;
			});
	
			me.beforeTickToLabelConversion();
	
			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;
	
			me.afterTickToLabelConversion();
	
			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				ticks[i].label = labels[i];
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		_getLabelSizes: function() {
			var me = this;
			var labelSizes = me._labelSizes;
	
			if (!labelSizes) {
				me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
				me.longestLabelWidth = labelSizes.widest.width;
			}
	
			return labelSizes;
		},
	
		/**
		 * @private
		 */
		_parseValue: function(value) {
			var start, end, min, max;
	
			if (isArray(value)) {
				start = +this.getRightValue(value[0]);
				end = +this.getRightValue(value[1]);
				min = Math.min(start, end);
				max = Math.max(start, end);
			} else {
				value = +this.getRightValue(value);
				start = undefined;
				end = value;
				min = value;
				max = value;
			}
	
			return {
				min: min,
				max: max,
				start: start,
				end: end
			};
		},
	
		/**
		* @private
		*/
		_getScaleLabel: function(rawValue) {
			var v = this._parseValue(rawValue);
			if (v.start !== undefined) {
				return '[' + v.start + ', ' + v.end + ']';
			}
	
			return +this.getRightValue(rawValue);
		},
	
		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers$1.noop,
	
		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers$1.noop,
	
		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers$1.noop,
	
		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			var numTicks = me._ticks.length;
			var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
	
			return index < 0 || index > numTicks - 1
				? null
				: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
		},
	
		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
	
			if (me._reversePixels) {
				decimal = 1 - decimal;
			}
	
			return me._startPixel + decimal * me._length;
		},
	
		getDecimalForPixel: function(pixel) {
			var decimal = (pixel - this._startPixel) / this._length;
			return this._reversePixels ? 1 - decimal : decimal;
		},
	
		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},
	
		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},
	
		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var me = this;
			var tickOpts = me.options.ticks;
			var axisLength = me._length;
			var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
			var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
			var numMajorIndices = majorIndices.length;
			var first = majorIndices[0];
			var last = majorIndices[numMajorIndices - 1];
			var i, ilen, spacing, avgMajorSpacing;
	
			// If there are too many major ticks to display them all
			if (numMajorIndices > ticksLimit) {
				skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
				return nonSkipped(ticks);
			}
	
			spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
	
			if (numMajorIndices > 0) {
				for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
					skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
				}
				avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
				skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
				skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
				return nonSkipped(ticks);
			}
			skip(ticks, spacing);
			return nonSkipped(ticks);
		},
	
		/**
		 * @private
		 */
		_tickSize: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			// Calculate space needed by label in axis direction.
			var rot = helpers$1.toRadians(me.labelRotation);
			var cos = Math.abs(Math.cos(rot));
			var sin = Math.abs(Math.sin(rot));
	
			var labelSizes = me._getLabelSizes();
			var padding = optionTicks.autoSkipPadding || 0;
			var w = labelSizes ? labelSizes.widest.width + padding : 0;
			var h = labelSizes ? labelSizes.highest.height + padding : 0;
	
			// Calculate space needed for 1 tick in axis direction.
			return me.isHorizontal()
				? h * cos > w * sin ? w / cos : h / sin
				: h * sin < w * cos ? h / cos : w / sin;
		},
	
		/**
		 * @private
		 */
		_isVisible: function() {
			var me = this;
			var chart = me.chart;
			var display = me.options.display;
			var i, ilen, meta;
	
			if (display !== 'auto') {
				return !!display;
			}
	
			// When 'auto', the scale is visible if at least one associated dataset is visible.
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
						return true;
					}
				}
			}
	
			return false;
		},
	
		/**
		 * @private
		 */
		_computeGridLineItems: function(chartArea) {
			var me = this;
			var chart = me.chart;
			var options = me.options;
			var gridLines = options.gridLines;
			var position = options.position;
			var offsetGridLines = gridLines.offsetGridLines;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
	
			var tl = getTickMarkLength(gridLines);
			var items = [];
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var axisHalfWidth = axisWidth / 2;
			var alignPixel = helpers$1._alignPixel;
			var alignBorderValue = function(pixel) {
				return alignPixel(chart, pixel, axisWidth);
			};
			var borderValue, i, tick, lineValue, alignedLineValue;
			var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
	
			if (position === 'top') {
				borderValue = alignBorderValue(me.bottom);
				ty1 = me.bottom - tl;
				ty2 = borderValue - axisHalfWidth;
				y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
				y2 = chartArea.bottom;
			} else if (position === 'bottom') {
				borderValue = alignBorderValue(me.top);
				y1 = chartArea.top;
				y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
				ty1 = borderValue + axisHalfWidth;
				ty2 = me.top + tl;
			} else if (position === 'left') {
				borderValue = alignBorderValue(me.right);
				tx1 = me.right - tl;
				tx2 = borderValue - axisHalfWidth;
				x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
				x2 = chartArea.right;
			} else {
				borderValue = alignBorderValue(me.left);
				x1 = chartArea.left;
				x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
				tx1 = borderValue + axisHalfWidth;
				tx2 = me.left + tl;
			}
	
			for (i = 0; i < ticksLength; ++i) {
				tick = ticks[i] || {};
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(tick.label) && i < ticks.length) {
					continue;
				}
	
				if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash || [];
					borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
				} else {
					lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
					lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
					borderDash = gridLines.borderDash || [];
					borderDashOffset = gridLines.borderDashOffset || 0.0;
				}
	
				lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
	
				// Skip if the pixel is out of the range
				if (lineValue === undefined) {
					continue;
				}
	
				alignedLineValue = alignPixel(chart, lineValue, lineWidth);
	
				if (isHorizontal) {
					tx1 = tx2 = x1 = x2 = alignedLineValue;
				} else {
					ty1 = ty2 = y1 = y2 = alignedLineValue;
				}
	
				items.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					width: lineWidth,
					color: lineColor,
					borderDash: borderDash,
					borderDashOffset: borderDashOffset,
				});
			}
	
			items.ticksLength = ticksLength;
			items.borderValue = borderValue;
	
			return items;
		},
	
		/**
		 * @private
		 */
		_computeLabelItems: function() {
			var me = this;
			var options = me.options;
			var optionTicks = options.ticks;
			var position = options.position;
			var isMirrored = optionTicks.mirror;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var fonts = parseTickFontOptions(optionTicks);
			var tickPadding = optionTicks.padding;
			var tl = getTickMarkLength(options.gridLines);
			var rotation = -helpers$1.toRadians(me.labelRotation);
			var items = [];
			var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
	
			if (position === 'top') {
				y = me.bottom - tl - tickPadding;
				textAlign = !rotation ? 'center' : 'left';
			} else if (position === 'bottom') {
				y = me.top + tl + tickPadding;
				textAlign = !rotation ? 'center' : 'right';
			} else if (position === 'left') {
				x = me.right - (isMirrored ? 0 : tl) - tickPadding;
				textAlign = isMirrored ? 'left' : 'right';
			} else {
				x = me.left + (isMirrored ? 0 : tl) + tickPadding;
				textAlign = isMirrored ? 'right' : 'left';
			}
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				tick = ticks[i];
				label = tick.label;
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(label)) {
					continue;
				}
	
				pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
				font = tick.major ? fonts.major : fonts.minor;
				lineHeight = font.lineHeight;
				lineCount = isArray(label) ? label.length : 1;
	
				if (isHorizontal) {
					x = pixel;
					textOffset = position === 'top'
						? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
						: (!rotation ? 0.5 : 0) * lineHeight;
				} else {
					y = pixel;
					textOffset = (1 - lineCount) * lineHeight / 2;
				}
	
				items.push({
					x: x,
					y: y,
					rotation: rotation,
					label: label,
					font: font,
					textOffset: textOffset,
					textAlign: textAlign
				});
			}
	
			return items;
		},
	
		/**
		 * @private
		 */
		_drawGrid: function(chartArea) {
			var me = this;
			var gridLines = me.options.gridLines;
	
			if (!gridLines.display) {
				return;
			}
	
			var ctx = me.ctx;
			var chart = me.chart;
			var alignPixel = helpers$1._alignPixel;
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
			var width, color, i, ilen, item;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				width = item.width;
				color = item.color;
	
				if (width && color) {
					ctx.save();
					ctx.lineWidth = width;
					ctx.strokeStyle = color;
					if (ctx.setLineDash) {
						ctx.setLineDash(item.borderDash);
						ctx.lineDashOffset = item.borderDashOffset;
					}
	
					ctx.beginPath();
	
					if (gridLines.drawTicks) {
						ctx.moveTo(item.tx1, item.ty1);
						ctx.lineTo(item.tx2, item.ty2);
					}
	
					if (gridLines.drawOnChartArea) {
						ctx.moveTo(item.x1, item.y1);
						ctx.lineTo(item.x2, item.y2);
					}
	
					ctx.stroke();
					ctx.restore();
				}
			}
	
			if (axisWidth) {
				// Draw the line at the edge of the axis
				var firstLineWidth = axisWidth;
				var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
				var borderValue = items.borderValue;
				var x1, x2, y1, y2;
	
				if (me.isHorizontal()) {
					x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
					x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
					y1 = y2 = borderValue;
				} else {
					y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
					y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
					x1 = x2 = borderValue;
				}
	
				ctx.lineWidth = axisWidth;
				ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.stroke();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			if (!optionTicks.display) {
				return;
			}
	
			var ctx = me.ctx;
			var items = me._labelItems || (me._labelItems = me._computeLabelItems());
			var i, j, ilen, jlen, item, tickFont, label, y;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				tickFont = item.font;
	
				// Make sure we draw text in the correct color and font
				ctx.save();
				ctx.translate(item.x, item.y);
				ctx.rotate(item.rotation);
				ctx.font = tickFont.string;
				ctx.fillStyle = tickFont.color;
				ctx.textBaseline = 'middle';
				ctx.textAlign = item.textAlign;
	
				label = item.label;
				y = item.textOffset;
				if (isArray(label)) {
					for (j = 0, jlen = label.length; j < jlen; ++j) {
						// We just make sure the multiline element is a string here..
						ctx.fillText('' + label[j], 0, y);
						y += tickFont.lineHeight;
					}
				} else {
					ctx.fillText(label, 0, y);
				}
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawTitle: function() {
			var me = this;
			var ctx = me.ctx;
			var options = me.options;
			var scaleLabel = options.scaleLabel;
	
			if (!scaleLabel.display) {
				return;
			}
	
			var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
			var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
			var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
			var halfLineHeight = scaleLabelFont.lineHeight / 2;
			var position = options.position;
			var rotation = 0;
			var scaleLabelX, scaleLabelY;
	
			if (me.isHorizontal()) {
				scaleLabelX = me.left + me.width / 2; // midpoint of the width
				scaleLabelY = position === 'bottom'
					? me.bottom - halfLineHeight - scaleLabelPadding.bottom
					: me.top + halfLineHeight + scaleLabelPadding.top;
			} else {
				var isLeft = position === 'left';
				scaleLabelX = isLeft
					? me.left + halfLineHeight + scaleLabelPadding.top
					: me.right - halfLineHeight - scaleLabelPadding.top;
				scaleLabelY = me.top + me.height / 2;
				rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
			}
	
			ctx.save();
			ctx.translate(scaleLabelX, scaleLabelY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
			ctx.fillStyle = scaleLabelFontColor; // render in correct colour
			ctx.font = scaleLabelFont.string;
			ctx.fillText(scaleLabel.labelString, 0, 0);
			ctx.restore();
		},
	
		draw: function(chartArea) {
			var me = this;
	
			if (!me._isVisible()) {
				return;
			}
	
			me._drawGrid(chartArea);
			me._drawTitle();
			me._drawLabels();
		},
	
		/**
		 * @private
		 */
		_layers: function() {
			var me = this;
			var opts = me.options;
			var tz = opts.ticks && opts.ticks.z || 0;
			var gz = opts.gridLines && opts.gridLines.z || 0;
	
			if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
				// backward compatibility: draw has been overridden by custom scale
				return [{
					z: tz,
					draw: function() {
						me.draw.apply(me, arguments);
					}
				}];
			}
	
			return [{
				z: gz,
				draw: function() {
					me._drawGrid.apply(me, arguments);
					me._drawTitle.apply(me, arguments);
				}
			}, {
				z: tz,
				draw: function() {
					me._drawLabels.apply(me, arguments);
				}
			}];
		},
	
		/**
		 * @private
		 */
		_getMatchingVisibleMetas: function(type) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			return me.chart._getSortedVisibleDatasetMetas()
				.filter(function(meta) {
					return (!type || meta.type === type)
						&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
				});
		}
	});
	
	Scale.prototype._draw = Scale.prototype.draw;
	
	var core_scale = Scale;
	
	var isNullOrUndef$1 = helpers$1.isNullOrUndef;
	
	var defaultConfig = {
		position: 'bottom'
	};
	
	var scale_category = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var labels = me._getLabels();
			var ticksOpts = me.options.ticks;
			var min = ticksOpts.min;
			var max = ticksOpts.max;
			var minIndex = 0;
			var maxIndex = labels.length - 1;
			var findIndex;
	
			if (min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(min);
				if (findIndex >= 0) {
					minIndex = findIndex;
				}
			}
	
			if (max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(max);
				if (findIndex >= 0) {
					maxIndex = findIndex;
				}
			}
	
			me.minIndex = minIndex;
			me.maxIndex = maxIndex;
			me.min = labels[minIndex];
			me.max = labels[maxIndex];
		},
	
		buildTicks: function() {
			var me = this;
			var labels = me._getLabels();
			var minIndex = me.minIndex;
			var maxIndex = me.maxIndex;
	
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var chart = me.chart;
	
			if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
				return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
			}
	
			return me._getLabels()[index];
		},
	
		_configure: function() {
			var me = this;
			var offset = me.options.offset;
			var ticks = me.ticks;
	
			core_scale.prototype._configure.call(me);
	
			if (!me.isHorizontal()) {
				// For backward compatibility, vertical category scale reverse is inverted.
				me._reversePixels = !me._reversePixels;
			}
	
			if (!ticks) {
				return;
			}
	
			me._startValue = me.minIndex - (offset ? 0.5 : 0);
			me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
		},
	
		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var valueCategory, labels, idx;
	
			if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
				value = me.chart.data.datasets[datasetIndex].data[index];
			}
	
			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			if (!isNullOrUndef$1(value)) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				labels = me._getLabels();
				value = helpers$1.valueOrDefault(valueCategory, value);
				idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
				if (isNaN(index)) {
					index = value;
				}
			}
			return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticks;
			return index < 0 || index > ticks.length - 1
				? null
				: this.getPixelForValue(ticks[index], index + this.minIndex);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
			return Math.min(Math.max(value, 0), me.ticks.length - 1);
		},
	
		getBasePixel: function() {
			return this.bottom;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults = defaultConfig;
	scale_category._defaults = _defaults;
	
	var noop = helpers$1.noop;
	var isNullOrUndef$2 = helpers$1.isNullOrUndef;
	
	/**
	 * Generate a set of linear ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		// To get a "nice" value for the tick spacing, we will use the appropriately named
		// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
		// for details.
	
		var MIN_SPACING = 1e-14;
		var stepSize = generationOptions.stepSize;
		var unit = stepSize || 1;
		var maxNumSpaces = generationOptions.maxTicks - 1;
		var min = generationOptions.min;
		var max = generationOptions.max;
		var precision = generationOptions.precision;
		var rmin = dataRange.min;
		var rmax = dataRange.max;
		var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
		var factor, niceMin, niceMax, numSpaces;
	
		// Beyond MIN_SPACING floating point numbers being to lose precision
		// such that we can't do the math necessary to generate ticks
		if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
			return [rmin, rmax];
		}
	
		numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
		if (numSpaces > maxNumSpaces) {
			// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
			spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
		}
	
		if (stepSize || isNullOrUndef$2(precision)) {
			// If a precision is not specified, calculate factor based on spacing
			factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
		} else {
			// If the user specified a precision, round to that number of decimal places
			factor = Math.pow(10, precision);
			spacing = Math.ceil(spacing * factor) / factor;
		}
	
		niceMin = Math.floor(rmin / spacing) * spacing;
		niceMax = Math.ceil(rmax / spacing) * spacing;
	
		// If min, max and stepSize is set and they make an evenly spaced scale use it.
		if (stepSize) {
			// If very close to our whole number, use it.
			if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
				niceMin = min;
			}
			if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
				niceMax = max;
			}
		}
	
		numSpaces = (niceMax - niceMin) / spacing;
		// If very close to our rounded value, use it.
		if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
			numSpaces = Math.round(numSpaces);
		} else {
			numSpaces = Math.ceil(numSpaces);
		}
	
		niceMin = Math.round(niceMin * factor) / factor;
		niceMax = Math.round(niceMax * factor) / factor;
		ticks.push(isNullOrUndef$2(min) ? niceMin : min);
		for (var j = 1; j < numSpaces; ++j) {
			ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
		}
		ticks.push(isNullOrUndef$2(max) ? niceMax : max);
	
		return ticks;
	}
	
	var scale_linearbase = core_scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return core_scale.prototype.getRightValue.call(this, value);
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers$1.sign(me.min);
				var maxSign = helpers$1.sign(me.max);
	
				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}
	
			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
	
			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}
	
			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}
	
			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}
	
			if (me.min === me.max) {
				me.max++;
	
				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
	
		getTickLimit: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var stepSize = tickOpts.stepSize;
			var maxTicksLimit = tickOpts.maxTicksLimit;
			var maxTicks;
	
			if (stepSize) {
				maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
			} else {
				maxTicks = me._computeTickLimit();
				maxTicksLimit = maxTicksLimit || 11;
			}
	
			if (maxTicksLimit) {
				maxTicks = Math.min(maxTicksLimit, maxTicks);
			}
	
			return maxTicks;
		},
	
		_computeTickLimit: function() {
			return Number.POSITIVE_INFINITY;
		},
	
		handleDirectionalChanges: noop,
	
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);
	
			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				precision: tickOpts.precision,
				stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
	
			me.handleDirectionalChanges();
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				ticks.reverse();
	
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
	
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);
	
			core_scale.prototype.convertTicksToLabels.call(me);
		},
	
		_configure: function() {
			var me = this;
			var ticks = me.getTicks();
			var start = me.min;
			var end = me.max;
			var offset;
	
			core_scale.prototype._configure.call(me);
	
			if (me.options.offset && ticks.length) {
				offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
				start -= offset;
				end += offset;
			}
			me._startValue = start;
			me._endValue = end;
			me._valueRange = end - start;
		}
	});
	
	var defaultConfig$1 = {
		position: 'left',
		ticks: {
			callback: core_ticks.formatters.linear
		}
	};
	
	var DEFAULT_MIN = 0;
	var DEFAULT_MAX = 1;
	
	function getOrCreateStack(stacks, stacked, meta) {
		var key = [
			meta.type,
			// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
			stacked === undefined && meta.stack === undefined ? meta.index : '',
			meta.stack
		].join('.');
	
		if (stacks[key] === undefined) {
			stacks[key] = {
				pos: [],
				neg: []
			};
		}
	
		return stacks[key];
	}
	
	function stackData(scale, stacks, meta, data) {
		var opts = scale.options;
		var stacked = opts.stacked;
		var stack = getOrCreateStack(stacks, stacked, meta);
		var pos = stack.pos;
		var neg = stack.neg;
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			pos[i] = pos[i] || 0;
			neg[i] = neg[i] || 0;
	
			if (opts.relativePoints) {
				pos[i] = 100;
			} else if (value.min < 0 || value.max < 0) {
				neg[i] += value.min;
			} else {
				pos[i] += value.max;
			}
		}
	}
	
	function updateMinMax(scale, meta, data) {
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			scale.min = Math.min(scale.min, value.min);
			scale.max = Math.max(scale.max, value.max);
		}
	}
	
	var scale_linear = scale_linearbase.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var metasets = me._getMatchingVisibleMetas();
			var hasStacks = opts.stacked;
			var stacks = {};
			var ilen = metasets.length;
			var i, meta, data, values;
	
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
	
			if (hasStacks === undefined) {
				for (i = 0; !hasStacks && i < ilen; ++i) {
					meta = metasets[i];
					hasStacks = meta.stack !== undefined;
				}
			}
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				data = datasets[meta.index].data;
				if (hasStacks) {
					stackData(me, stacks, meta, data);
				} else {
					updateMinMax(me, meta, data);
				}
			}
	
			helpers$1.each(stacks, function(stackValues) {
				values = stackValues.pos.concat(stackValues.neg);
				me.min = Math.min(me.min, helpers$1.min(values));
				me.max = Math.max(me.max, helpers$1.max(values));
			});
	
			me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			var me = this;
			var tickFont;
	
			if (me.isHorizontal()) {
				return Math.ceil(me.width / 40);
			}
			tickFont = helpers$1.options._parseFont(me.options.ticks);
			return Math.ceil(me.height / tickFont.lineHeight);
		},
	
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		// Utils
		getPixelForValue: function(value) {
			var me = this;
			return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
		},
	
		getValueForPixel: function(pixel) {
			return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticksAsNumbers;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$1 = defaultConfig$1;
	scale_linear._defaults = _defaults$1;
	
	var valueOrDefault$b = helpers$1.valueOrDefault;
	var log10 = helpers$1.math.log10;
	
	/**
	 * Generate a set of logarithmic ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks$1(generationOptions, dataRange) {
		var ticks = [];
	
		var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
	
		var endExp = Math.floor(log10(dataRange.max));
		var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
		var exp, significand;
	
		if (tickVal === 0) {
			exp = Math.floor(log10(dataRange.minNotZero));
			significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
			ticks.push(tickVal);
			tickVal = significand * Math.pow(10, exp);
		} else {
			exp = Math.floor(log10(tickVal));
			significand = Math.floor(tickVal / Math.pow(10, exp));
		}
		var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
	
		do {
			ticks.push(tickVal);
	
			++significand;
			if (significand === 10) {
				significand = 1;
				++exp;
				precision = exp >= 0 ? 1 : precision;
			}
	
			tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
		} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
		var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
		ticks.push(lastTick);
	
		return ticks;
	}
	
	var defaultConfig$2 = {
		position: 'left',
	
		// label settings
		ticks: {
			callback: core_ticks.formatters.logarithmic
		}
	};
	
	// TODO(v3): change this to positiveOrDefault
	function nonNegativeOrDefault(value, defaultValue) {
		return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
	}
	
	var scale_logarithmic = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}
			var datasetIndex, meta, value, data, i, ilen;
	
			// Calculate Range
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
			me.minNotZero = Number.POSITIVE_INFINITY;
	
			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
						break;
					}
				}
			}
	
			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};
	
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');
	
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}
	
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							var values = valuesPerStack[key];
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
							values[i] = values[i] || 0;
							values[i] += value.max;
						}
					}
				}
	
				helpers$1.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers$1.min(valuesForType);
						var maxVal = helpers$1.max(valuesForType);
						me.min = Math.min(me.min, minVal);
						me.max = Math.max(me.max, maxVal);
					}
				});
	
			} else {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
	
							me.min = Math.min(value.min, me.min);
							me.max = Math.max(value.max, me.max);
	
							if (value.min !== 0) {
								me.minNotZero = Math.min(value.min, me.minNotZero);
							}
						}
					}
				}
			}
	
			me.min = helpers$1.isFinite(me.min) ? me.min : null;
			me.max = helpers$1.isFinite(me.max) ? me.max : null;
			me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
	
			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;
	
			me.min = nonNegativeOrDefault(tickOpts.min, me.min);
			me.max = nonNegativeOrDefault(tickOpts.max, me.max);
	
			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},
	
		buildTicks: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = !me.isHorizontal();
	
			var generationOptions = {
				min: nonNegativeOrDefault(tickOpts.min),
				max: nonNegativeOrDefault(tickOpts.max)
			};
			var ticks = me.ticks = generateTicks$1(generationOptions, me);
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},
	
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();
	
			core_scale.prototype.convertTicksToLabels.call(this);
		},
	
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.tickValues;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		},
	
		/**
		 * Returns the value of the first tick.
		 * @param {number} value - The minimum not zero value.
		 * @return {number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));
	
			return significand * Math.pow(10, exp);
		},
	
		_configure: function() {
			var me = this;
			var start = me.min;
			var offset = 0;
	
			core_scale.prototype._configure.call(me);
	
			if (start === 0) {
				start = me._getFirstTickValue(me.minNotZero);
				offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
			}
	
			me._startValue = log10(start);
			me._valueOffset = offset;
			me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
		},
	
		getPixelForValue: function(value) {
			var me = this;
			var decimal = 0;
	
			value = +me.getRightValue(value);
	
			if (value > me.min && value > 0) {
				decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
			}
			return me.getPixelForDecimal(decimal);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var decimal = me.getDecimalForPixel(pixel);
			return decimal === 0 && me.min === 0
				? 0
				: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$2 = defaultConfig$2;
	scale_logarithmic._defaults = _defaults$2;
	
	var valueOrDefault$c = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
	var resolve$4 = helpers$1.options.resolve;
	
	var defaultConfig$3 = {
		display: true,
	
		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',
	
		angleLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		gridLines: {
			circular: false
		},
	
		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,
	
			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',
	
			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,
	
			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,
	
			callback: core_ticks.formatters.linear
		},
	
		pointLabels: {
			// Boolean - if true, show point labels
			display: true,
	
			// Number - Point label font size in pixels
			fontSize: 10,
	
			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};
	
	function getTickBackdropHeight(opts) {
		var tickOpts = opts.ticks;
	
		if (tickOpts.display && opts.display) {
			return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
		}
		return 0;
	}
	
	function measureLabelSize(ctx, lineHeight, label) {
		if (helpers$1.isArray(label)) {
			return {
				w: helpers$1.longestText(ctx, ctx.font, label),
				h: label.length * lineHeight
			};
		}
	
		return {
			w: ctx.measureText(label).width,
			h: lineHeight
		};
	}
	
	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size,
				end: pos
			};
		}
	
		return {
			start: pos,
			end: pos + size
		};
	}
	
	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
	
		// Right, this is really confusing and there is a lot of maths going on here
		// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		//
		// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		//
		// Solution:
		//
		// We assume the radius of the polygon is half the size of the canvas at first
		// at each index we check if the text overlaps.
		//
		// Where it does, we store that angle and that index.
		//
		// After finding the largest index and angle we calculate how much we need to remove
		// from the shape radius to move the point inwards by that x.
		//
		// We average the left and right distances to get the maximum shape radius that can fit in the box
		// along with labels.
		//
		// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		// on each side, removing that from the size, halving it and adding the left x protrusion width.
		//
		// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		// and position it in the most space efficient manner
		//
		// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
	
		var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
	
		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var furthestLimits = {
			l: 0,
			r: scale.width,
			t: 0,
			b: scale.height - scale.paddingTop
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;
	
		scale.ctx.font = plFont.string;
		scale._pointLabelSizes = [];
	
		var valueCount = scale.chart.data.labels.length;
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
			textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
			scale._pointLabelSizes[i] = textSize;
	
			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}
	
			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}
	
			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}
	
			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}
	
		scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
	}
	
	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}
	
		return 'right';
	}
	
	function fillText(ctx, text, position, lineHeight) {
		var y = position.y + lineHeight / 2;
		var i, ilen;
	
		if (helpers$1.isArray(text)) {
			for (i = 0, ilen = text.length; i < ilen; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, position.x, y);
		}
	}
	
	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}
	
	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var pointLabelOpts = opts.pointLabels;
		var tickBackdropHeight = getTickBackdropHeight(opts);
		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
		var plFont = helpers$1.options._parseFont(pointLabelOpts);
	
		ctx.save();
	
		ctx.font = plFont.string;
		ctx.textBaseline = 'middle';
	
		for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
			// Extra pixels out for some label spacing
			var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
			var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
	
			// Keep this in loop since we may support array properties here
			var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
			ctx.fillStyle = pointLabelFontColor;
	
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians);
			ctx.textAlign = getTextAlignForAngle(angle);
			adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
			fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
		}
		ctx.restore();
	}
	
	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		var circular = gridLineOpts.circular;
		var valueCount = scale.chart.data.labels.length;
		var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
		var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
		var pointPosition;
	
		if ((!circular && !valueCount) || !lineColor || !lineWidth) {
			return;
		}
	
		ctx.save();
		ctx.strokeStyle = lineColor;
		ctx.lineWidth = lineWidth;
		if (ctx.setLineDash) {
			ctx.setLineDash(gridLineOpts.borderDash || []);
			ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
		}
	
		ctx.beginPath();
		if (circular) {
			// Draw circular arcs between the points
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
		} else {
			// Draw straight lines connecting each index
			pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);
	
			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}
		}
		ctx.closePath();
		ctx.stroke();
		ctx.restore();
	}
	
	function numberOrZero(param) {
		return helpers$1.isNumber(param) ? param : 0;
	}
	
	var scale_radialLinear = scale_linearbase.extend({
		setDimensions: function() {
			var me = this;
	
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.paddingTop = getTickBackdropHeight(me.options) / 2;
			me.xCenter = Math.floor(me.width / 2);
			me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
			me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;
	
			helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);
	
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}
	
						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});
	
			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
		},
	
		convertTicksToLabels: function() {
			var me = this;
	
			scale_linearbase.prototype.convertTicksToLabels.call(me);
	
			// Point labels
			me.pointLabels = me.chart.data.labels.map(function() {
				var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
				return label || label === 0 ? label : '';
			});
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		fit: function() {
			var me = this;
			var opts = me.options;
	
			if (opts.display && opts.pointLabels.display) {
				fitWithPointLabels(me);
			} else {
				me.setCenterPoint(0, 0, 0, 0);
			}
		},
	
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
	
			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
			me.drawingArea = Math.min(
				Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
	
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;
	
			me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
		},
	
		getIndexAngle: function(index) {
			var chart = this.chart;
			var angleMultiplier = 360 / chart.data.labels.length;
			var options = chart.options || {};
			var startAngle = options.startAngle || 0;
	
			// Start from the top instead of right, so remove a quarter of the circle
			var angle = (index * angleMultiplier + startAngle) % 360;
	
			return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
		},
	
		getDistanceFromCenterForValue: function(value) {
			var me = this;
	
			if (helpers$1.isNullOrUndef(value)) {
				return NaN;
			}
	
			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
	
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
				y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
			};
		},
	
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},
	
		getBasePosition: function(index) {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.getPointPositionForValue(index || 0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},
	
		/**
		 * @private
		 */
		_drawGrid: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var angleLineOpts = opts.angleLines;
			var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
			var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
			var i, offset, position;
	
			if (opts.pointLabels.display) {
				drawPointLabels(me);
			}
	
			if (gridLineOpts.display) {
				helpers$1.each(me.ticks, function(label, index) {
					if (index !== 0) {
						offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
						drawRadiusLine(me, gridLineOpts, offset, index);
					}
				});
			}
	
			if (angleLineOpts.display && lineWidth && lineColor) {
				ctx.save();
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = lineColor;
				if (ctx.setLineDash) {
					ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
					ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
				}
	
				for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
					offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
					position = me.getPointPosition(i, offset);
					ctx.beginPath();
					ctx.moveTo(me.xCenter, me.yCenter);
					ctx.lineTo(position.x, position.y);
					ctx.stroke();
				}
	
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			if (!tickOpts.display) {
				return;
			}
	
			var startAngle = me.getIndexAngle(0);
			var tickFont = helpers$1.options._parseFont(tickOpts);
			var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
			var offset, width;
	
			ctx.save();
			ctx.font = tickFont.string;
			ctx.translate(me.xCenter, me.yCenter);
			ctx.rotate(startAngle);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			helpers$1.each(me.ticks, function(label, index) {
				if (index === 0 && !tickOpts.reverse) {
					return;
				}
	
				offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
	
				if (tickOpts.showLabelBackdrop) {
					width = ctx.measureText(label).width;
					ctx.fillStyle = tickOpts.backdropColor;
	
					ctx.fillRect(
						-width / 2 - tickOpts.backdropPaddingX,
						-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
						width + tickOpts.backdropPaddingX * 2,
						tickFont.size + tickOpts.backdropPaddingY * 2
					);
				}
	
				ctx.fillStyle = tickFontColor;
				ctx.fillText(label, 0, -offset);
			});
	
			ctx.restore();
		},
	
		/**
		 * @private
		 */
		_drawTitle: helpers$1.noop
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$3 = defaultConfig$3;
	scale_radialLinear._defaults = _defaults$3;
	
	var deprecated$1 = helpers$1._deprecated;
	var resolve$5 = helpers$1.options.resolve;
	var valueOrDefault$d = helpers$1.valueOrDefault;
	
	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: 1000
		},
		second: {
			common: true,
			size: 1000,
			steps: 60
		},
		minute: {
			common: true,
			size: 60000,
			steps: 60
		},
		hour: {
			common: true,
			size: 3600000,
			steps: 24
		},
		day: {
			common: true,
			size: 86400000,
			steps: 30
		},
		week: {
			common: false,
			size: 604800000,
			steps: 4
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: 12
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: 4
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};
	
	var UNITS = Object.keys(INTERVALS);
	
	function sorter(a, b) {
		return a - b;
	}
	
	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}
	
		return out;
	}
	
	function getMin(options) {
		return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
	}
	
	function getMax(options) {
		return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
	}
	
	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}
	
		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;
	
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}
	
		items.push(max);
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];
	
			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}
	
		return table;
	}
	
	// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;
	
		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];
	
			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}
	
		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}
	
	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate$1(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);
	
		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
	
		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;
	
		return prev[tkey] + offset;
	}
	
	function toTimestamp(scale, input) {
		var adapter = scale._adapter;
		var options = scale.options.time;
		var parser = options.parser;
		var format = parser || options.format;
		var value = input;
	
		if (typeof parser === 'function') {
			value = parser(value);
		}
	
		// Only parse if its not a timestamp already
		if (!helpers$1.isFinite(value)) {
			value = typeof format === 'string'
				? adapter.parse(value, format)
				: adapter.parse(value);
		}
	
		if (value !== null) {
			return +value;
		}
	
		// Labels are in an incompatible format and no `parser` has been provided.
		// The user might still use the deprecated `format` option for parsing.
		if (!parser && typeof format === 'function') {
			value = format(input);
	
			// `format` could return something else than a timestamp, if so, parse it
			if (!helpers$1.isFinite(value)) {
				value = adapter.parse(value);
			}
		}
	
		return value;
	}
	
	function parse(scale, input) {
		if (helpers$1.isNullOrUndef(input)) {
			return null;
		}
	
		var options = scale.options.time;
		var value = toTimestamp(scale, scale.getRightValue(input));
		if (value === null) {
			return value;
		}
	
		if (options.round) {
			value = +scale._adapter.startOf(value, options.round);
		}
	
		return value;
	}
	
	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;
	
		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps : MAX_INTEGER;
	
			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}
	
		return UNITS[ilen - 1];
	}
	
	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
		var i, unit;
	
		for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
				return unit;
			}
		}
	
		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}
	
	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}
	
	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(scale, min, max, capacity) {
		var adapter = scale._adapter;
		var options = scale.options;
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var first = min;
		var ticks = [];
		var time;
	
		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = +adapter.startOf(first, 'isoWeek', weekday);
		}
	
		// Align first ticks on unit
		first = +adapter.startOf(first, weekday ? 'day' : minor);
	
		// Prevent browser from freezing in case user options request millions of milliseconds
		if (adapter.diff(max, min, minor) > 100000 * stepSize) {
			throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
		}
	
		for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
			ticks.push(time);
		}
	
		if (time === max || options.bounds === 'ticks') {
			ticks.push(time);
		}
	
		return ticks;
	}
	
	/**
	 * Returns the start and end offsets from edges in the form of {start, end}
	 * where each value is a relative width to the scale and ranges between 0 and 1.
	 * They add extra margins on the both sides by scaling down the original scale.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var start = 0;
		var end = 0;
		var first, last;
	
		if (options.offset && ticks.length) {
			first = interpolate$1(table, 'time', ticks[0], 'pos');
			if (ticks.length === 1) {
				start = 1 - first;
			} else {
				start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
			}
			last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
			if (ticks.length === 1) {
				end = last;
			} else {
				end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
			}
		}
	
		return {start: start, end: end, factor: 1 / (start + 1 + end)};
	}
	
	function setMajorTicks(scale, ticks, map, majorUnit) {
		var adapter = scale._adapter;
		var first = +adapter.startOf(ticks[0].value, majorUnit);
		var last = ticks[ticks.length - 1].value;
		var major, index;
	
		for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
			index = map[major];
			if (index >= 0) {
				ticks[index].major = true;
			}
		}
		return ticks;
	}
	
	function ticksFromTimestamps(scale, values, majorUnit) {
		var ticks = [];
		var map = {};
		var ilen = values.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = values[i];
			map[value] = i;
	
			ticks.push({
				value: value,
				major: false
			});
		}
	
		// We set the major ticks separately from the above loop because calling startOf for every tick
		// is expensive when there is a large number of ticks
		return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
	}
	
	var defaultConfig$4 = {
		position: 'bottom',
	
		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',
	
		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',
	
		adapters: {},
		time: {
			parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',
			displayFormats: {}
		},
		ticks: {
			autoSkip: false,
	
			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',
	
			major: {
				enabled: false
			}
		}
	};
	
	var scale_time = core_scale.extend({
		initialize: function() {
			this.mergeTicksOptions();
			core_scale.prototype.initialize.call(this);
		},
	
		update: function() {
			var me = this;
			var options = me.options;
			var time = options.time || (options.time = {});
			var adapter = me._adapter = new core_adapters._date(options.adapters.date);
	
			// DEPRECATIONS: output a message only one time per update
			deprecated$1('time scale', time.format, 'time.format', 'time.parser');
			deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
			deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
	
			// Backward compatibility: before introducing adapter, `displayFormats` was
			// supposed to contain *all* unit/string pairs but this can't be resolved
			// when loading the scale (adapters are loaded afterward), so let's populate
			// missing formats on update
			helpers$1.mergeIf(time.displayFormats, adapter.formats());
	
			return core_scale.prototype.update.apply(me, arguments);
		},
	
		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return core_scale.prototype.getRightValue.call(this, rawValue);
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var adapter = me._adapter;
			var options = me.options;
			var unit = options.time.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp, labelsAdded;
			var dataLabels = me._getLabels();
	
			for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
				labels.push(parse(me, dataLabels[i]));
			}
	
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;
	
					// Let's consider that all data have the same format.
					if (helpers$1.isObject(data[0])) {
						datasets[i] = [];
	
						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(me, data[j]);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						datasets[i] = labels.slice(0);
						if (!labelsAdded) {
							timestamps = timestamps.concat(labels);
							labelsAdded = true;
						}
					}
				} else {
					datasets[i] = [];
				}
			}
	
			if (labels.length) {
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}
	
			if (timestamps.length) {
				timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}
	
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
			max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
	
			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);
	
			// PRIVATE
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},
	
		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var tickOpts = options.ticks;
			var timeOpts = options.time;
			var timestamps = me._timestamps;
			var ticks = [];
			var capacity = me.getLabelCapacity(min);
			var source = tickOpts.source;
			var distribution = options.distribution;
			var i, ilen, timestamp;
	
			if (source === 'data' || (source === 'auto' && distribution === 'series')) {
				timestamps = timestamps.data;
			} else if (source === 'labels') {
				timestamps = timestamps.labels;
			} else {
				timestamps = generate(me, min, max, capacity);
			}
	
			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}
	
			// Enforce limits with user min/max options
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}
	
			me.min = min;
			me.max = max;
	
			// PRIVATE
			// determineUnitForFormatting relies on the number of ticks so we don't use it when
			// autoSkip is enabled because we don't yet know what the final number of ticks will be
			me._unit = timeOpts.unit || (tickOpts.autoSkip
				? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
				: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
			me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
				: determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);
	
			if (tickOpts.reverse) {
				ticks.reverse();
			}
	
			return ticksFromTimestamps(me, ticks, me._majorUnit);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var adapter = me._adapter;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];
	
			if (helpers$1.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}
			return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
		},
	
		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(time, index, ticks, format) {
			var me = this;
			var adapter = me._adapter;
			var options = me.options;
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var tick = ticks[index];
			var tickOpts = options.ticks;
			var major = majorUnit && majorFormat && tick && tick.major;
			var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
			var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
			var formatter = resolve$5([
				nestedTickOpts.callback,
				nestedTickOpts.userCallback,
				tickOpts.callback,
				tickOpts.userCallback
			]);
	
			return formatter ? formatter(label, index, ticks) : label;
		},
	
		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var offsets = me._offsets;
			var pos = interpolate$1(me._table, 'time', time, 'pos');
			return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
		},
	
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;
	
			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}
	
			if (time === null) {
				time = parse(me, value);
			}
	
			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},
	
		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var offsets = me._offsets;
			var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
			var time = interpolate$1(me._table, 'pos', pos, 'time');
	
			// DEPRECATION, we should return time directly
			return me._adapter._create(time);
		},
	
		/**
		 * @private
		 */
		_getLabelSize: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
	
			return {
				w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
				h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
			};
		},
	
		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			return this._getLabelSize(label).w;
		},
	
		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;
			var timeOpts = me.options.time;
			var displayFormats = timeOpts.displayFormats;
	
			// pick the longest format (milliseconds) for guestimation
			var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
			var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
			var size = me._getLabelSize(exampleLabel);
			var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
	
			if (me.options.offset) {
				capacity--;
			}
	
			return capacity > 0 ? capacity : 1;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$4 = defaultConfig$4;
	scale_time._defaults = _defaults$4;
	
	var scales = {
		category: scale_category,
		linear: scale_linear,
		logarithmic: scale_logarithmic,
		radialLinear: scale_radialLinear,
		time: scale_time
	};
	
	var FORMATS = {
		datetime: 'MMM D, YYYY, h:mm:ss a',
		millisecond: 'h:mm:ss.SSS a',
		second: 'h:mm:ss a',
		minute: 'h:mm a',
		hour: 'hA',
		day: 'MMM D',
		week: 'll',
		month: 'MMM YYYY',
		quarter: '[Q]Q - YYYY',
		year: 'YYYY'
	};
	
	core_adapters._date.override(typeof moment === 'function' ? {
		_id: 'moment', // DEBUG ONLY
	
		formats: function() {
			return FORMATS;
		},
	
		parse: function(value, format) {
			if (typeof value === 'string' && typeof format === 'string') {
				value = moment(value, format);
			} else if (!(value instanceof moment)) {
				value = moment(value);
			}
			return value.isValid() ? value.valueOf() : null;
		},
	
		format: function(time, format) {
			return moment(time).format(format);
		},
	
		add: function(time, amount, unit) {
			return moment(time).add(amount, unit).valueOf();
		},
	
		diff: function(max, min, unit) {
			return moment(max).diff(moment(min), unit);
		},
	
		startOf: function(time, unit, weekday) {
			time = moment(time);
			if (unit === 'isoWeek') {
				return time.isoWeekday(weekday).valueOf();
			}
			return time.startOf(unit).valueOf();
		},
	
		endOf: function(time, unit) {
			return moment(time).endOf(unit).valueOf();
		},
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility with scale.getValueForPixel().
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(time) {
			return moment(time);
		},
	} : {});
	
	core_defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});
	
	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;
	
			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},
	
		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;
	
			if (helpers$1.isArray(boundary)) {
				return function(point, i) {
					return boundary[i];
				};
			}
	
			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};
	
	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;
	
		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}
	
		if (fill === false || fill === null) {
			return false;
		}
	
		if (fill === true) {
			return 'origin';
		}
	
		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}
	
			if (target === index || target < 0 || target >= count) {
				return false;
			}
	
			return target;
		}
	
		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}
	
	function computeLinearBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;
	
		if (isFinite(fill)) {
			return null;
		}
	
		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).
	
		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}
	
		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}
	
			if (helpers$1.isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}
	
		return null;
	}
	
	function computeCircularBoundary(source) {
		var scale = source.el._scale;
		var options = scale.options;
		var length = scale.chart.data.labels.length;
		var fill = source.fill;
		var target = [];
		var start, end, center, i, point;
	
		if (!length) {
			return null;
		}
	
		start = options.ticks.reverse ? scale.max : scale.min;
		end = options.ticks.reverse ? scale.min : scale.max;
		center = scale.getPointPositionForValue(0, start);
		for (i = 0; i < length; ++i) {
			point = fill === 'start' || fill === 'end'
				? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
				: scale.getBasePosition(i);
			if (options.gridLines.circular) {
				point.cx = center.x;
				point.cy = center.y;
				point.angle = scale.getIndexAngle(i) - Math.PI / 2;
			}
			target.push(point);
		}
		return target;
	}
	
	function computeBoundary(source) {
		var scale = source.el._scale || {};
	
		if (scale.getPointPositionForValue) {
			return computeCircularBoundary(source);
		}
		return computeLinearBoundary(source);
	}
	
	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;
	
		if (!propagate) {
			return fill;
		}
	
		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}
	
			target = sources[fill];
			if (!target) {
				return false;
			}
	
			if (target.visible) {
				return fill;
			}
	
			visited.push(fill);
			fill = target.fill;
		}
	
		return false;
	}
	
	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';
	
		if (fill === false) {
			return null;
		}
	
		if (!isFinite(fill)) {
			type = 'boundary';
		}
	
		return mappers[type](source);
	}
	
	function isDrawable(point) {
		return point && !point.skip;
	}
	
	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i, cx, cy, r;
	
		if (!len0 || !len1) {
			return;
		}
	
		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}
	
		if (curve1[0].angle !== undefined) {
			cx = curve1[0].cx;
			cy = curve1[0].cy;
			r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
			for (i = len1 - 1; i > 0; --i) {
				ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
			}
			return;
		}
	
		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
	
		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}
	
	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1, loopOffset;
	
		ctx.beginPath();
	
		for (i = 0, ilen = count; i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);
	
			if (loop && loopOffset === undefined && d0) {
				loopOffset = i + 1;
				ilen = count + loopOffset;
			}
	
			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}
	
		drawArea(ctx, curve0, curve1, len0, len1);
	
		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}
	
	var plugin_filler = {
		id: 'filler',
	
		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;
	
			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;
	
				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}
	
				meta.$filler = source;
				sources.push(source);
			}
	
			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}
	
				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},
	
		beforeDatasetsDraw: function(chart) {
			var metasets = chart._getSortedVisibleDatasetMetas();
			var ctx = chart.ctx;
			var meta, i, el, view, points, mapper, color;
	
			for (i = metasets.length - 1; i >= 0; --i) {
				meta = metasets[i].$filler;
	
				if (!meta || !meta.visible) {
					continue;
				}
	
				el = meta.el;
				view = el._view;
				points = el._children || [];
				mapper = meta.mapper;
				color = view.backgroundColor || core_defaults.global.defaultColor;
	
				if (mapper && color && points.length) {
					helpers$1.canvas.clipArea(ctx, chart.chartArea);
					doFill(ctx, points, mapper, view, color, el._loop);
					helpers$1.canvas.unclipArea(ctx);
				}
			}
		}
	};
	
	var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
	var noop$1 = helpers$1.noop;
	var valueOrDefault$e = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			align: 'center',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
			onLeave: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var datasets = chart.data.datasets;
					var options = chart.options.legend || {};
					var usePointStyle = options.labels && options.labels.usePointStyle;
	
					return chart._getSortedDatasetMetas().map(function(meta) {
						var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
	
						return {
							text: datasets[meta.index].label,
							fillStyle: style.backgroundColor,
							hidden: !chart.isDatasetVisible(meta.index),
							lineCap: style.borderCapStyle,
							lineDash: style.borderDash,
							lineDashOffset: style.borderDashOffset,
							lineJoin: style.borderJoinStyle,
							lineWidth: style.borderWidth,
							strokeStyle: style.borderColor,
							pointStyle: style.pointStyle,
							rotation: style.rotation,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: meta.index
						};
					}, this);
				}
			}
		},
	
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var datasets = chart.data.datasets;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
				if (datasets[i].label) {
					listItem.appendChild(document.createTextNode(datasets[i].label));
				}
			}
	
			return list.outerHTML;
		}
	});
	
	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param {object} labelopts - the label options on the legend
	 * @param {number} fontSize - the label font size
	 * @return {number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
			fontSize :
			labelOpts.boxWidth;
	}
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Legend = core_element.extend({
	
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
	
			/**
	 		 * @private
	 		 */
			me._hoveredItem = null;
	
			// Are we in doughnut mode which has a different data type
			me.doughnutMode = false;
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type
	
		beforeUpdate: noop$1,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
		},
		afterUpdate: noop$1,
	
		//
	
		beforeSetDimensions: noop$1,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$1,
	
		//
	
		beforeBuildLabels: noop$1,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
	
			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}
	
			if (me.options.reverse) {
				legendItems.reverse();
			}
	
			me.legendItems = legendItems;
		},
		afterBuildLabels: noop$1,
	
		//
	
		beforeFit: noop$1,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;
	
			var ctx = me.ctx;
	
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
	
			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];
	
			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();
	
			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}
	
			// Increase sizes here
			if (!display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
			ctx.font = labelFont.string;
	
			if (isHorizontal) {
				// Labels
	
				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = 0;
	
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
						totalHeight += fontSize + labelOpts.padding;
						lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
					}
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};
	
					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});
	
				minSize.height += totalHeight;
	
			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var columnHeights = me.columnHeights = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					// If too tall, go to new column
					if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width
						columnHeights.push(currentColHeight);
						currentColWidth = 0;
						currentColHeight = 0;
					}
	
					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += fontSize + vPadding;
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});
	
				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				columnHeights.push(currentColHeight);
				minSize.width += totalWidth;
			}
	
			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop$1,
	
		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
	
		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor;
			var lineDefault = globalDefaults.elements.line;
			var legendHeight = me.height;
			var columnHeights = me.columnHeights;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;
	
			if (!opts.display) {
				return;
			}
	
			var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
			var ctx = me.ctx;
			var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
			var cursor;
	
			// Canvas setup
			ctx.textAlign = rtlHelper.textAlign('left');
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont.string;
	
			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;
	
			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}
	
				// Set the ctx for the box
				ctx.save();
	
				var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
				ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
	
				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
				}
	
				if (labelOpts && labelOpts.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = boxWidth * Math.SQRT2 / 2;
					var centerX = rtlHelper.xPlus(x, boxWidth / 2);
					var centerY = y + fontSize / 2;
	
					// Draw pointStyle as legend symbol
					helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
				} else {
					// Draw box as legend symbol
					ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					if (lineWidth !== 0) {
						ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					}
				}
	
				ctx.restore();
			};
	
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
				var yMiddle = y + halfFontSize;
	
				ctx.fillText(legendItem.text, xLeft, yMiddle);
	
				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
					ctx.stroke();
				}
			};
	
			var alignmentOffset = function(dimension, blockSize) {
				switch (opts.align) {
				case 'start':
					return labelOpts.padding;
				case 'end':
					return dimension - blockSize;
				default: // center
					return (dimension - blockSize + labelOpts.padding) / 2;
				}
			};
	
			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
					line: 0
				};
			}
	
			helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
	
			var itemHeight = fontSize + labelOpts.padding;
			helpers$1.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;
	
				rtlHelper.setWidth(me.minSize.width);
	
				// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
				// instead of me.right and me.bottom because me.width and me.height
				// may have been changed since me.minSize was calculated
				if (isHorizontal) {
					if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
					}
				} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					cursor.line++;
					y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
				}
	
				var realX = rtlHelper.x(x);
	
				drawLegendBox(realX, y, legendItem);
	
				hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
				hitboxes[i].top = y;
	
				// Fill the actual label
				fillText(realX, y, legendItem, textWidth);
	
				if (isHorizontal) {
					cursor.x += width + labelOpts.padding;
				} else {
					cursor.y += itemHeight;
				}
			});
	
			helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
		},
	
		/**
		 * @private
		 */
		_getLegendItemAt: function(x, y) {
			var me = this;
			var i, hitBox, lh;
	
			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				lh = me.legendHitBoxes;
				for (i = 0; i < lh.length; ++i) {
					hitBox = lh[i];
	
					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						return me.legendItems[i];
					}
				}
			}
	
			return null;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var hoveredItem;
	
			if (type === 'mousemove') {
				if (!opts.onHover && !opts.onLeave) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}
	
			// Chart event already has relative position in it
			hoveredItem = me._getLegendItemAt(e.x, e.y);
	
			if (type === 'click') {
				if (hoveredItem && opts.onClick) {
					// use e.native for backwards compatibility
					opts.onClick.call(me, e.native, hoveredItem);
				}
			} else {
				if (opts.onLeave && hoveredItem !== me._hoveredItem) {
					if (me._hoveredItem) {
						opts.onLeave.call(me, e.native, me._hoveredItem);
					}
					me._hoveredItem = hoveredItem;
				}
	
				if (opts.onHover && hoveredItem) {
					// use e.native for backwards compatibility
					opts.onHover.call(me, e.native, hoveredItem);
				}
			}
		}
	});
	
	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, legend, legendOpts);
		core_layouts.addBox(chart, legend);
		chart.legend = legend;
	}
	
	var plugin_legend = {
		id: 'legend',
	
		/**
		 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
		 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Legend,
	
		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;
	
			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;
	
			if (legendOpts) {
				helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
	
				if (legend) {
					core_layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				core_layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},
	
		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
	
	var noop$2 = helpers$1.noop;
	
	core_defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Title = core_element.extend({
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
	
		beforeUpdate: noop$2,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
	
		},
		afterUpdate: noop$2,
	
		//
	
		beforeSetDimensions: noop$2,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$2,
	
		//
	
		beforeBuildLabels: noop$2,
		buildLabels: noop$2,
		afterBuildLabels: noop$2,
	
		//
	
		beforeFit: noop$2,
		fit: function() {
			var me = this;
			var opts = me.options;
			var minSize = me.minSize = {};
			var isHorizontal = me.isHorizontal();
			var lineCount, textSize;
	
			if (!opts.display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
	
			lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
			textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
	
			me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
			me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
		},
		afterFit: noop$2,
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
	
		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
	
			if (!opts.display) {
				return;
			}
	
			var fontOpts = helpers$1.options._parseFont(opts);
			var lineHeight = fontOpts.lineHeight;
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;
	
			ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
			ctx.font = fontOpts.string;
	
			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}
	
			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			var text = opts.text;
			if (helpers$1.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}
	
			ctx.restore();
		}
	});
	
	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, title, titleOpts);
		core_layouts.addBox(chart, title);
		chart.titleBlock = title;
	}
	
	var plugin_title = {
		id: 'title',
	
		/**
		 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
		 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Title,
	
		beforeInit: function(chart) {
			var titleOpts = chart.options.title;
	
			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;
	
			if (titleOpts) {
				helpers$1.mergeIf(titleOpts, core_defaults.global.title);
	
				if (titleBlock) {
					core_layouts.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				core_layouts.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
	
	var plugins = {};
	var filler = plugin_filler;
	var legend = plugin_legend;
	var title = plugin_title;
	plugins.filler = filler;
	plugins.legend = legend;
	plugins.title = title;
	
	/**
	 * @namespace Chart
	 */
	
	
	core_controller.helpers = helpers$1;
	
	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	core_helpers();
	
	core_controller._adapters = core_adapters;
	core_controller.Animation = core_animation;
	core_controller.animationService = core_animations;
	core_controller.controllers = controllers;
	core_controller.DatasetController = core_datasetController;
	core_controller.defaults = core_defaults;
	core_controller.Element = core_element;
	core_controller.elements = elements;
	core_controller.Interaction = core_interaction;
	core_controller.layouts = core_layouts;
	core_controller.platform = platform;
	core_controller.plugins = core_plugins;
	core_controller.Scale = core_scale;
	core_controller.scaleService = core_scaleService;
	core_controller.Ticks = core_ticks;
	core_controller.Tooltip = core_tooltip;
	
	// Register built-in scales
	
	core_controller.helpers.each(scales, function(scale, type) {
		core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
	});
	
	// Load to register built-in adapters (as side effects)
	
	
	// Loading built-in plugins
	
	for (var k in plugins) {
		if (plugins.hasOwnProperty(k)) {
			core_controller.plugins.register(plugins[k]);
		}
	}
	
	core_controller.platform.initialize();
	
	var src = core_controller;
	if (typeof window !== 'undefined') {
		window.Chart = core_controller;
	}
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Chart
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Chart = core_controller;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Legend
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Legend = plugins.legend._element;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Title
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Title = plugins.title._element;
	
	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.pluginService = core_controller.plugins;
	
	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.PluginBase = core_controller.Element.extend({});
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.canvasHelpers = core_controller.helpers.canvas;
	
	/**
	 * Provided for backward compatibility, use Chart.layouts instead.
	 * @namespace Chart.layoutService
	 * @deprecated since version 2.7.3
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.layoutService = core_controller.layouts;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.LinearScaleBase
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.LinearScaleBase = scale_linearbase;
	
	/**
	 * Provided for backward compatibility, instead we should create a new Chart
	 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	core_controller.helpers.each(
		[
			'Bar',
			'Bubble',
			'Doughnut',
			'Line',
			'PolarArea',
			'Radar',
			'Scatter'
		],
		function(klass) {
			core_controller[klass] = function(ctx, cfg) {
				return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
					type: klass.charAt(0).toLowerCase() + klass.slice(1)
				}));
			};
		}
	);
	
	return src;
	
	})));


/***/ },
/* 2602 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/stories-icon.8e3298d5.png";

/***/ },
/* 2603 */
[4186, 202, 78],
/* 2604 */
[4187, 2678, 2679, 2680, 2681, 2682],
/* 2605 */
[4193, 202, 78],
/* 2606 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },
/* 2607 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 2608 */
[4202, 990],
/* 2609 */
/***/ function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ },
/* 2610 */
/***/ function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ },
/* 2611 */
[4205, 201],
/* 2612 */
[4207, 300, 628],
/* 2613 */
[4213, 201],
/* 2614 */
[4214, 206],
/* 2615 */
[4215, 201],
/* 2616 */
[4217, 2660],
/* 2617 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ },
/* 2618 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 2619 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * The base implementation of `_.inRange` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to check.
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	 */
	function baseInRange(number, start, end) {
	  return number >= nativeMin(start, end) && number < nativeMax(start, end);
	}
	
	module.exports = baseInRange;


/***/ },
/* 2620 */
[4223, 382, 384, 607, 148, 245, 392],
/* 2621 */
[4224, 383, 299, 1033, 2706, 204],
/* 2622 */
[4225, 133, 79],
/* 2623 */
[4227, 606, 1002, 2671, 2672, 203, 47, 304, 406],
/* 2624 */
[4228, 203, 79],
/* 2625 */
[4229, 606, 610],
/* 2626 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 2627 */
[4230, 205, 2689, 96, 1020],
/* 2628 */
[4231, 203, 79],
/* 2629 */
[4232, 133, 626, 79],
/* 2630 */
[4235, 96, 302, 2704],
/* 2631 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ },
/* 2632 */
[4237, 2625, 2673, 1011],
/* 2633 */
[4238, 610, 109, 1030, 619, 1010, 1011, 204],
/* 2634 */
[4240, 989, 1030],
/* 2635 */
[4242, 298],
/* 2636 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ },
/* 2637 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 2638 */
[4246, 2727, 1001, 179],
/* 2639 */
[4247, 201],
/* 2640 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 2641 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 2642 */
[4250, 148],
/* 2643 */
[4251, 403],
/* 2644 */
[4255, 389],
/* 2645 */
[4256, 389],
/* 2646 */
[4258, 78],
/* 2647 */
[4259, 613],
/* 2648 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 2649 */
[4260, 244],
/* 2650 */
[4261, 613],
/* 2651 */
[4262, 206],
/* 2652 */
[4263, 2651],
/* 2653 */
[4265, 300, 617],
/* 2654 */
[4266, 300, 1007],
/* 2655 */
[4267, 78],
/* 2656 */
/***/ function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ },
/* 2657 */
[4268, 2606, 2611, 95, 47],
/* 2658 */
[4269, 177, 398],
/* 2659 */
[4270, 123],
/* 2660 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 2661 */
[4271, 394, 78],
/* 2662 */
[4272, 996, 618, 1018, 151],
/* 2663 */
[4273, 979, 1023, 2784],
/* 2664 */
[4275, 383, 394, 999, 1000, 616, 400, 78],
/* 2665 */
[4276, 95, 123, 97],
/* 2666 */
[4277, 603, 614, 615, 1006, 47, 1009],
/* 2667 */
[4279, 383, 394, 78],
/* 2668 */
[4281, 78, 150, 409, 151],
/* 2669 */
[4282, 974, 1036, 621],
/* 2670 */
[4284, 2636],
/* 2671 */
[4287, 244, 975, 303, 1002, 2700, 621],
/* 2672 */
[4288, 1004],
/* 2673 */
[4295, 1010, 97],
/* 2674 */
[4298, 244],
/* 2675 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 2676 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ },
/* 2677 */
/***/ function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ },
/* 2678 */
[4303, 399],
/* 2679 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 2680 */
[4304, 399],
/* 2681 */
[4305, 399],
/* 2682 */
[4306, 399],
/* 2683 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 2684 */
[4307, 613, 2647, 2648, 2649, 2650],
/* 2685 */
[4308, 297, 397, 302],
/* 2686 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ },
/* 2687 */
[4309, 244, 402, 47],
/* 2688 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 2689 */
[4313, 2655],
/* 2690 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 2691 */
[4315, 386],
/* 2692 */
[4316, 386],
/* 2693 */
[4317, 386],
/* 2694 */
[4318, 386],
/* 2695 */
[4319, 2604, 381, 604],
/* 2696 */
[4320, 396],
/* 2697 */
[4321, 396],
/* 2698 */
[4322, 396],
/* 2699 */
[4323, 396],
/* 2700 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 2701 */
[4324, 1035],
/* 2702 */
[4325, 997, 998, 400],
/* 2703 */
[4328, 1013],
/* 2704 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 2705 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 2706 */
[4331, 298, 391],
/* 2707 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 2708 */
[4332, 393, 301],
/* 2709 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 2710 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 2711 */
[4337, 381],
/* 2712 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 2713 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 2714 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 2715 */
[4338, 381, 604, 605],
/* 2716 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 2717 */
[4339, 2608, 618, 2718],
/* 2718 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Gets the size of a Unicode `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	function unicodeSize(string) {
	  var result = reUnicode.lastIndex = 0;
	  while (reUnicode.test(string)) {
	    ++result;
	  }
	  return result;
	}
	
	module.exports = unicodeSize;


/***/ },
/* 2719 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ },
/* 2720 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ },
/* 2721 */
[4343, 296, 384],
/* 2722 */
[4344, 602, 603, 393],
/* 2723 */
[4345, 395],
/* 2724 */
[4346, 385, 300, 2658, 123, 302, 97],
/* 2725 */
[4347, 982, 409],
/* 2726 */
[4348, 983],
/* 2727 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 2728 */
[4352, 391, 150],
/* 2729 */
[4354, 151],
/* 2730 */
[4355, 2607, 2613, 95, 47, 398],
/* 2731 */
[4360, 2666],
/* 2732 */
[4362, 2733, 50],
/* 2733 */
/***/ function(module, exports) {

	/** Used to map aliases to their real names. */
	exports.aliasToReal = {
	
	  // Lodash aliases.
	  'each': 'forEach',
	  'eachRight': 'forEachRight',
	  'entries': 'toPairs',
	  'entriesIn': 'toPairsIn',
	  'extend': 'assignIn',
	  'extendAll': 'assignInAll',
	  'extendAllWith': 'assignInAllWith',
	  'extendWith': 'assignInWith',
	  'first': 'head',
	
	  // Methods that are curried variants of others.
	  'conforms': 'conformsTo',
	  'matches': 'isMatch',
	  'property': 'get',
	
	  // Ramda aliases.
	  '__': 'placeholder',
	  'F': 'stubFalse',
	  'T': 'stubTrue',
	  'all': 'every',
	  'allPass': 'overEvery',
	  'always': 'constant',
	  'any': 'some',
	  'anyPass': 'overSome',
	  'apply': 'spread',
	  'assoc': 'set',
	  'assocPath': 'set',
	  'complement': 'negate',
	  'compose': 'flowRight',
	  'contains': 'includes',
	  'dissoc': 'unset',
	  'dissocPath': 'unset',
	  'dropLast': 'dropRight',
	  'dropLastWhile': 'dropRightWhile',
	  'equals': 'isEqual',
	  'identical': 'eq',
	  'indexBy': 'keyBy',
	  'init': 'initial',
	  'invertObj': 'invert',
	  'juxt': 'over',
	  'omitAll': 'omit',
	  'nAry': 'ary',
	  'path': 'get',
	  'pathEq': 'matchesProperty',
	  'pathOr': 'getOr',
	  'paths': 'at',
	  'pickAll': 'pick',
	  'pipe': 'flow',
	  'pluck': 'map',
	  'prop': 'get',
	  'propEq': 'matchesProperty',
	  'propOr': 'getOr',
	  'props': 'at',
	  'symmetricDifference': 'xor',
	  'symmetricDifferenceBy': 'xorBy',
	  'symmetricDifferenceWith': 'xorWith',
	  'takeLast': 'takeRight',
	  'takeLastWhile': 'takeRightWhile',
	  'unapply': 'rest',
	  'unnest': 'flatten',
	  'useWith': 'overArgs',
	  'where': 'conformsTo',
	  'whereEq': 'isMatch',
	  'zipObj': 'zipObject'
	};
	
	/** Used to map ary to method names. */
	exports.aryMethod = {
	  '1': [
	    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
	    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
	    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
	    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
	    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
	    'uniqueId', 'words', 'zipAll'
	  ],
	  '2': [
	    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
	    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
	    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
	    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
	    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
	    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
	    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
	    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
	    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
	    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
	    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
	    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
	    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
	    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
	    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
	    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
	    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
	    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
	    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
	    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
	    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
	    'zipObjectDeep'
	  ],
	  '3': [
	    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
	    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
	    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
	    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
	    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
	    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
	    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
	    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
	    'xorWith', 'zipWith'
	  ],
	  '4': [
	    'fill', 'setWith', 'updateWith'
	  ]
	};
	
	/** Used to map ary to rearg configs. */
	exports.aryRearg = {
	  '2': [1, 0],
	  '3': [2, 0, 1],
	  '4': [3, 2, 0, 1]
	};
	
	/** Used to map method names to their iteratee ary. */
	exports.iterateeAry = {
	  'dropRightWhile': 1,
	  'dropWhile': 1,
	  'every': 1,
	  'filter': 1,
	  'find': 1,
	  'findFrom': 1,
	  'findIndex': 1,
	  'findIndexFrom': 1,
	  'findKey': 1,
	  'findLast': 1,
	  'findLastFrom': 1,
	  'findLastIndex': 1,
	  'findLastIndexFrom': 1,
	  'findLastKey': 1,
	  'flatMap': 1,
	  'flatMapDeep': 1,
	  'flatMapDepth': 1,
	  'forEach': 1,
	  'forEachRight': 1,
	  'forIn': 1,
	  'forInRight': 1,
	  'forOwn': 1,
	  'forOwnRight': 1,
	  'map': 1,
	  'mapKeys': 1,
	  'mapValues': 1,
	  'partition': 1,
	  'reduce': 2,
	  'reduceRight': 2,
	  'reject': 1,
	  'remove': 1,
	  'some': 1,
	  'takeRightWhile': 1,
	  'takeWhile': 1,
	  'times': 1,
	  'transform': 2
	};
	
	/** Used to map method names to iteratee rearg configs. */
	exports.iterateeRearg = {
	  'mapKeys': [1],
	  'reduceRight': [1, 0]
	};
	
	/** Used to map method names to rearg configs. */
	exports.methodRearg = {
	  'assignInAllWith': [1, 0],
	  'assignInWith': [1, 2, 0],
	  'assignAllWith': [1, 0],
	  'assignWith': [1, 2, 0],
	  'differenceBy': [1, 2, 0],
	  'differenceWith': [1, 2, 0],
	  'getOr': [2, 1, 0],
	  'intersectionBy': [1, 2, 0],
	  'intersectionWith': [1, 2, 0],
	  'isEqualWith': [1, 2, 0],
	  'isMatchWith': [2, 1, 0],
	  'mergeAllWith': [1, 0],
	  'mergeWith': [1, 2, 0],
	  'padChars': [2, 1, 0],
	  'padCharsEnd': [2, 1, 0],
	  'padCharsStart': [2, 1, 0],
	  'pullAllBy': [2, 1, 0],
	  'pullAllWith': [2, 1, 0],
	  'rangeStep': [1, 2, 0],
	  'rangeStepRight': [1, 2, 0],
	  'setWith': [3, 1, 2, 0],
	  'sortedIndexBy': [2, 1, 0],
	  'sortedLastIndexBy': [2, 1, 0],
	  'unionBy': [1, 2, 0],
	  'unionWith': [1, 2, 0],
	  'updateWith': [3, 1, 2, 0],
	  'xorBy': [1, 2, 0],
	  'xorWith': [1, 2, 0],
	  'zipWith': [1, 2, 0]
	};
	
	/** Used to map method names to spread configs. */
	exports.methodSpread = {
	  'assignAll': { 'start': 0 },
	  'assignAllWith': { 'start': 0 },
	  'assignInAll': { 'start': 0 },
	  'assignInAllWith': { 'start': 0 },
	  'defaultsAll': { 'start': 0 },
	  'defaultsDeepAll': { 'start': 0 },
	  'invokeArgs': { 'start': 2 },
	  'invokeArgsMap': { 'start': 2 },
	  'mergeAll': { 'start': 0 },
	  'mergeAllWith': { 'start': 0 },
	  'partial': { 'start': 1 },
	  'partialRight': { 'start': 1 },
	  'without': { 'start': 1 },
	  'zipAll': { 'start': 0 }
	};
	
	/** Used to identify methods which mutate arrays or objects. */
	exports.mutate = {
	  'array': {
	    'fill': true,
	    'pull': true,
	    'pullAll': true,
	    'pullAllBy': true,
	    'pullAllWith': true,
	    'pullAt': true,
	    'remove': true,
	    'reverse': true
	  },
	  'object': {
	    'assign': true,
	    'assignAll': true,
	    'assignAllWith': true,
	    'assignIn': true,
	    'assignInAll': true,
	    'assignInAllWith': true,
	    'assignInWith': true,
	    'assignWith': true,
	    'defaults': true,
	    'defaultsAll': true,
	    'defaultsDeep': true,
	    'defaultsDeepAll': true,
	    'merge': true,
	    'mergeAll': true,
	    'mergeAllWith': true,
	    'mergeWith': true,
	  },
	  'set': {
	    'set': true,
	    'setWith': true,
	    'unset': true,
	    'update': true,
	    'updateWith': true
	  }
	};
	
	/** Used to map real names to their aliases. */
	exports.realToAlias = (function() {
	  var hasOwnProperty = Object.prototype.hasOwnProperty,
	      object = exports.aliasToReal,
	      result = {};
	
	  for (var key in object) {
	    var value = object[key];
	    if (hasOwnProperty.call(result, value)) {
	      result[value].push(key);
	    } else {
	      result[value] = [key];
	    }
	  }
	  return result;
	}());
	
	/** Used to map method names to other names. */
	exports.remap = {
	  'assignAll': 'assign',
	  'assignAllWith': 'assignWith',
	  'assignInAll': 'assignIn',
	  'assignInAllWith': 'assignInWith',
	  'curryN': 'curry',
	  'curryRightN': 'curryRight',
	  'defaultsAll': 'defaults',
	  'defaultsDeepAll': 'defaultsDeep',
	  'findFrom': 'find',
	  'findIndexFrom': 'findIndex',
	  'findLastFrom': 'findLast',
	  'findLastIndexFrom': 'findLastIndex',
	  'getOr': 'get',
	  'includesFrom': 'includes',
	  'indexOfFrom': 'indexOf',
	  'invokeArgs': 'invoke',
	  'invokeArgsMap': 'invokeMap',
	  'lastIndexOfFrom': 'lastIndexOf',
	  'mergeAll': 'merge',
	  'mergeAllWith': 'mergeWith',
	  'padChars': 'pad',
	  'padCharsEnd': 'padEnd',
	  'padCharsStart': 'padStart',
	  'propertyOf': 'get',
	  'rangeStep': 'range',
	  'rangeStepRight': 'rangeRight',
	  'restFrom': 'rest',
	  'spreadFrom': 'spread',
	  'trimChars': 'trim',
	  'trimCharsEnd': 'trimEnd',
	  'trimCharsStart': 'trimStart',
	  'zipAll': 'zip'
	};
	
	/** Used to track methods that skip fixing their arity. */
	exports.skipFixed = {
	  'castArray': true,
	  'flow': true,
	  'flowRight': true,
	  'iteratee': true,
	  'mixin': true,
	  'rearg': true,
	  'runInContext': true
	};
	
	/** Used to track methods that skip rearranging arguments. */
	exports.skipRearg = {
	  'add': true,
	  'assign': true,
	  'assignIn': true,
	  'bind': true,
	  'bindKey': true,
	  'concat': true,
	  'difference': true,
	  'divide': true,
	  'eq': true,
	  'gt': true,
	  'gte': true,
	  'isEqual': true,
	  'lt': true,
	  'lte': true,
	  'matchesProperty': true,
	  'merge': true,
	  'multiply': true,
	  'overArgs': true,
	  'partial': true,
	  'partialRight': true,
	  'propertyOf': true,
	  'random': true,
	  'range': true,
	  'rangeRight': true,
	  'subtract': true,
	  'zip': true,
	  'zipObject': true,
	  'zipObjectDeep': true
	};


/***/ },
/* 2734 */
[4363, 2723, 981, 2726, 1022, 296, 47, 2761, 205, 2764, 2765, 390, 2771, 150, 2779],
/* 2735 */
[4364, 51, 1021, 122, 50],
/* 2736 */
[4366, 51, 1022, 50],
/* 2737 */
[4367, 51, 1024, 50],
/* 2738 */
[4368, 51, 303, 50],
/* 2739 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(51),
	    func = convert('flatten', __webpack_require__(1027), __webpack_require__(122));
	
	func.placeholder = __webpack_require__(50);
	module.exports = func;


/***/ },
/* 2740 */
[4370, 51, 109, 50],
/* 2741 */
[4371, 51, 178, 50],
/* 2742 */
[4373, 51, 205, 122, 50],
/* 2743 */
[4374, 51, 74, 122, 50],
/* 2744 */
[4375, 51, 96, 122, 50],
/* 2745 */
[4376, 51, 405, 122, 50],
/* 2746 */
[4377, 51, 97, 122, 50],
/* 2747 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(51),
	    func = convert('memoize', __webpack_require__(1035));
	
	func.placeholder = __webpack_require__(50);
	module.exports = func;


/***/ },
/* 2748 */
[4379, 51, 2766, 122, 50],
/* 2749 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(51),
	    func = convert('orderBy', __webpack_require__(2767));
	
	func.placeholder = __webpack_require__(50);
	module.exports = func;


/***/ },
/* 2750 */
[4380, 51, 629, 50],
/* 2751 */
[4381, 51, 2775, 50],
/* 2752 */
[4382, 51, 1037, 50],
/* 2753 */
[4383, 51, 1039, 122, 50],
/* 2754 */
[4384, 51, 2778, 50],
/* 2755 */
[4385, 51, 2781, 50],
/* 2756 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(51),
	    func = convert('uniq', __webpack_require__(631), __webpack_require__(122));
	
	func.placeholder = __webpack_require__(50);
	module.exports = func;


/***/ },
/* 2757 */
[4386, 51, 305, 122, 50],
/* 2758 */
[4390, 2619, 1041, 409],
/* 2759 */
[4392, 148, 2620, 177, 2643],
/* 2760 */
[4397, 133, 79],
/* 2761 */
[4401, 133, 79, 405],
/* 2762 */
[4403, 2624, 245, 620],
/* 2763 */
[4406, 2628, 245, 620],
/* 2764 */
[4410, 203, 79],
/* 2765 */
[4411, 983, 95],
/* 2766 */
[4418, 2614, 2631, 179],
/* 2767 */
/***/ function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(988),
	    isArray = __webpack_require__(47);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ },
/* 2768 */
[4419, 177, 395, 616, 400],
/* 2769 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(148),
	    baseIteratee = __webpack_require__(95),
	    basePickBy = __webpack_require__(989),
	    getAllKeysIn = __webpack_require__(1005);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  if (object == null) {
	    return {};
	  }
	  var props = arrayMap(getAllKeysIn(object), function(prop) {
	    return [prop];
	  });
	  predicate = baseIteratee(predicate);
	  return basePickBy(object, props, function(value, path) {
	    return predicate(value, path[0]);
	  });
	}
	
	module.exports = pickBy;


/***/ },
/* 2770 */
[4421, 990, 2635, 619, 204],
/* 2771 */
[4422, 395, 614],
/* 2772 */
[4424, 2668],
/* 2773 */
[4425, 991],
/* 2774 */
[4426, 390, 203, 123, 627, 2717],
/* 2775 */
[4428, 388, 988, 177, 398],
/* 2776 */
[4429, 2663, 2783],
/* 2777 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 2778 */
[4432, 391, 150],
/* 2779 */
[4437, 148, 393, 47, 206, 1019, 204, 151],
/* 2780 */
[4439, 296, 297, 609, 95, 397, 47, 304, 205, 96, 406],
/* 2781 */
[4440, 612, 996, 2644, 2645, 1018, 151],
/* 2782 */
[4441, 388, 177, 994, 403],
/* 2783 */
[4443, 2662],
/* 2784 */
[4446, 2610, 2677, 151, 2720],
/* 2785 */
[4447, 602, 603, 611, 47, 79, 2722],
/* 2786 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 1042,
		"./af.js": 1042,
		"./ar": 1049,
		"./ar-dz": 1043,
		"./ar-dz.js": 1043,
		"./ar-kw": 1044,
		"./ar-kw.js": 1044,
		"./ar-ly": 1045,
		"./ar-ly.js": 1045,
		"./ar-ma": 1046,
		"./ar-ma.js": 1046,
		"./ar-sa": 1047,
		"./ar-sa.js": 1047,
		"./ar-tn": 1048,
		"./ar-tn.js": 1048,
		"./ar.js": 1049,
		"./az": 1050,
		"./az.js": 1050,
		"./be": 1051,
		"./be.js": 1051,
		"./bg": 1052,
		"./bg.js": 1052,
		"./bm": 1053,
		"./bm.js": 1053,
		"./bn": 1055,
		"./bn-bd": 1054,
		"./bn-bd.js": 1054,
		"./bn.js": 1055,
		"./bo": 1056,
		"./bo.js": 1056,
		"./br": 1057,
		"./br.js": 1057,
		"./bs": 1058,
		"./bs.js": 1058,
		"./ca": 1059,
		"./ca.js": 1059,
		"./cs": 1060,
		"./cs.js": 1060,
		"./cv": 1061,
		"./cv.js": 1061,
		"./cy": 1062,
		"./cy.js": 1062,
		"./da": 1063,
		"./da.js": 1063,
		"./de": 1066,
		"./de-at": 1064,
		"./de-at.js": 1064,
		"./de-ch": 1065,
		"./de-ch.js": 1065,
		"./de.js": 1066,
		"./dv": 1067,
		"./dv.js": 1067,
		"./el": 1068,
		"./el.js": 1068,
		"./en-au": 1069,
		"./en-au.js": 1069,
		"./en-ca": 1070,
		"./en-ca.js": 1070,
		"./en-gb": 1071,
		"./en-gb.js": 1071,
		"./en-ie": 1072,
		"./en-ie.js": 1072,
		"./en-il": 1073,
		"./en-il.js": 1073,
		"./en-in": 1074,
		"./en-in.js": 1074,
		"./en-nz": 1075,
		"./en-nz.js": 1075,
		"./en-sg": 1076,
		"./en-sg.js": 1076,
		"./eo": 1077,
		"./eo.js": 1077,
		"./es": 1081,
		"./es-do": 1078,
		"./es-do.js": 1078,
		"./es-mx": 1079,
		"./es-mx.js": 1079,
		"./es-us": 1080,
		"./es-us.js": 1080,
		"./es.js": 1081,
		"./et": 1082,
		"./et.js": 1082,
		"./eu": 1083,
		"./eu.js": 1083,
		"./fa": 1084,
		"./fa.js": 1084,
		"./fi": 1085,
		"./fi.js": 1085,
		"./fil": 1086,
		"./fil.js": 1086,
		"./fo": 1087,
		"./fo.js": 1087,
		"./fr": 1090,
		"./fr-ca": 1088,
		"./fr-ca.js": 1088,
		"./fr-ch": 1089,
		"./fr-ch.js": 1089,
		"./fr.js": 1090,
		"./fy": 1091,
		"./fy.js": 1091,
		"./ga": 1092,
		"./ga.js": 1092,
		"./gd": 1093,
		"./gd.js": 1093,
		"./gl": 1094,
		"./gl.js": 1094,
		"./gom-deva": 1095,
		"./gom-deva.js": 1095,
		"./gom-latn": 1096,
		"./gom-latn.js": 1096,
		"./gu": 1097,
		"./gu.js": 1097,
		"./he": 1098,
		"./he.js": 1098,
		"./hi": 1099,
		"./hi.js": 1099,
		"./hr": 1100,
		"./hr.js": 1100,
		"./hu": 1101,
		"./hu.js": 1101,
		"./hy-am": 1102,
		"./hy-am.js": 1102,
		"./id": 1103,
		"./id.js": 1103,
		"./is": 1104,
		"./is.js": 1104,
		"./it": 1106,
		"./it-ch": 1105,
		"./it-ch.js": 1105,
		"./it.js": 1106,
		"./ja": 1107,
		"./ja.js": 1107,
		"./jv": 1108,
		"./jv.js": 1108,
		"./ka": 1109,
		"./ka.js": 1109,
		"./kk": 1110,
		"./kk.js": 1110,
		"./km": 1111,
		"./km.js": 1111,
		"./kn": 1112,
		"./kn.js": 1112,
		"./ko": 1113,
		"./ko.js": 1113,
		"./ku": 1114,
		"./ku.js": 1114,
		"./ky": 1115,
		"./ky.js": 1115,
		"./lb": 1116,
		"./lb.js": 1116,
		"./lo": 1117,
		"./lo.js": 1117,
		"./lt": 1118,
		"./lt.js": 1118,
		"./lv": 1119,
		"./lv.js": 1119,
		"./me": 1120,
		"./me.js": 1120,
		"./mi": 1121,
		"./mi.js": 1121,
		"./mk": 1122,
		"./mk.js": 1122,
		"./ml": 1123,
		"./ml.js": 1123,
		"./mn": 1124,
		"./mn.js": 1124,
		"./mr": 1125,
		"./mr.js": 1125,
		"./ms": 1127,
		"./ms-my": 1126,
		"./ms-my.js": 1126,
		"./ms.js": 1127,
		"./mt": 1128,
		"./mt.js": 1128,
		"./my": 1129,
		"./my.js": 1129,
		"./nb": 1130,
		"./nb.js": 1130,
		"./ne": 1131,
		"./ne.js": 1131,
		"./nl": 1133,
		"./nl-be": 1132,
		"./nl-be.js": 1132,
		"./nl.js": 1133,
		"./nn": 1134,
		"./nn.js": 1134,
		"./oc-lnc": 1135,
		"./oc-lnc.js": 1135,
		"./pa-in": 1136,
		"./pa-in.js": 1136,
		"./pl": 1137,
		"./pl.js": 1137,
		"./pt": 1139,
		"./pt-br": 1138,
		"./pt-br.js": 1138,
		"./pt.js": 1139,
		"./ro": 1140,
		"./ro.js": 1140,
		"./ru": 1141,
		"./ru.js": 1141,
		"./sd": 1142,
		"./sd.js": 1142,
		"./se": 1143,
		"./se.js": 1143,
		"./si": 1144,
		"./si.js": 1144,
		"./sk": 1145,
		"./sk.js": 1145,
		"./sl": 1146,
		"./sl.js": 1146,
		"./sq": 1147,
		"./sq.js": 1147,
		"./sr": 1149,
		"./sr-cyrl": 1148,
		"./sr-cyrl.js": 1148,
		"./sr.js": 1149,
		"./ss": 1150,
		"./ss.js": 1150,
		"./sv": 1151,
		"./sv.js": 1151,
		"./sw": 1152,
		"./sw.js": 1152,
		"./ta": 1153,
		"./ta.js": 1153,
		"./te": 1154,
		"./te.js": 1154,
		"./tet": 1155,
		"./tet.js": 1155,
		"./tg": 1156,
		"./tg.js": 1156,
		"./th": 1157,
		"./th.js": 1157,
		"./tk": 1158,
		"./tk.js": 1158,
		"./tl-ph": 1159,
		"./tl-ph.js": 1159,
		"./tlh": 1160,
		"./tlh.js": 1160,
		"./tr": 1161,
		"./tr.js": 1161,
		"./tzl": 1162,
		"./tzl.js": 1162,
		"./tzm": 1164,
		"./tzm-latn": 1163,
		"./tzm-latn.js": 1163,
		"./tzm.js": 1164,
		"./ug-cn": 1165,
		"./ug-cn.js": 1165,
		"./uk": 1166,
		"./uk.js": 1166,
		"./ur": 1167,
		"./ur.js": 1167,
		"./uz": 1169,
		"./uz-latn": 1168,
		"./uz-latn.js": 1168,
		"./uz.js": 1169,
		"./vi": 1170,
		"./vi.js": 1170,
		"./x-pseudo": 1171,
		"./x-pseudo.js": 1171,
		"./yo": 1172,
		"./yo.js": 1172,
		"./zh-cn": 1173,
		"./zh-cn.js": 1173,
		"./zh-hk": 1174,
		"./zh-hk.js": 1174,
		"./zh-mo": 1175,
		"./zh-mo.js": 1175,
		"./zh-tw": 1176,
		"./zh-tw.js": 1176
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2786;


/***/ },
/* 2787 */
[4448, 2788],
/* 2788 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 2789 */
[4450, 2792],
/* 2790 */
[4451, 1177, 1178],
/* 2791 */
[4452, 1177, 1178],
/* 2792 */
[4453, 2790, 2791],
/* 2793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ICON_SIZE = '64px';
	
	var Preview = /*#__PURE__*/function (_Component) {
	  _inherits(Preview, _Component);
	
	  var _super = _createSuper(Preview);
	
	  function Preview() {
	    var _this;
	
	    _classCallCheck(this, Preview);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "mounted", false);
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      image: null
	    });
	
	    return _this;
	  }
	
	  _createClass(Preview, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	      this.fetchImage(this.props);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props = this.props,
	          url = _this$props.url,
	          light = _this$props.light;
	
	      if (prevProps.url !== url || prevProps.light !== light) {
	        this.fetchImage(this.props);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: "fetchImage",
	    value: function fetchImage(_ref) {
	      var _this2 = this;
	
	      var url = _ref.url,
	          light = _ref.light;
	
	      if (typeof light === 'string') {
	        this.setState({
	          image: light
	        });
	        return;
	      }
	
	      this.setState({
	        image: null
	      });
	      return window.fetch("https://noembed.com/embed?url=".concat(url)).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        if (data.thumbnail_url && _this2.mounted) {
	          var image = data.thumbnail_url.replace('height=100', 'height=480');
	
	          _this2.setState({
	            image: image
	          });
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          onClick = _this$props2.onClick,
	          playIcon = _this$props2.playIcon;
	      var image = this.state.image;
	      var flexCenter = {
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	      };
	      var styles = {
	        preview: _objectSpread({
	          width: '100%',
	          height: '100%',
	          backgroundImage: image ? "url(".concat(image, ")") : undefined,
	          backgroundSize: 'cover',
	          backgroundPosition: 'center',
	          cursor: 'pointer'
	        }, flexCenter),
	        shadow: _objectSpread({
	          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
	          borderRadius: ICON_SIZE,
	          width: ICON_SIZE,
	          height: ICON_SIZE
	        }, flexCenter),
	        playIcon: {
	          borderStyle: 'solid',
	          borderWidth: '16px 0 16px 26px',
	          borderColor: 'transparent transparent transparent white',
	          marginLeft: '7px'
	        }
	      };
	
	      var defaultPlayIcon = /*#__PURE__*/_react["default"].createElement("div", {
	        style: styles.shadow,
	        className: "react-player__shadow"
	      }, /*#__PURE__*/_react["default"].createElement("div", {
	        style: styles.playIcon,
	        className: "react-player__play-icon"
	      }));
	
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        style: styles.preview,
	        className: "react-player__preview",
	        onClick: onClick
	      }, playIcon || defaultPlayIcon);
	    }
	  }]);
	
	  return Preview;
	}(_react.Component);
	
	exports["default"] = Preview;

/***/ },
/* 2794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _YouTube = __webpack_require__(636);
	
	var _SoundCloud = __webpack_require__(634);
	
	var _Vimeo = __webpack_require__(635);
	
	var _Facebook = __webpack_require__(1179);
	
	var _Streamable = __webpack_require__(1182);
	
	var _Wistia = __webpack_require__(1184);
	
	var _Twitch = __webpack_require__(1183);
	
	var _DailyMotion = __webpack_require__(633);
	
	var _Mixcloud = __webpack_require__(1181);
	
	var _FilePlayer = __webpack_require__(1180);
	
	var _default = [_YouTube.YouTube, _SoundCloud.SoundCloud, _Vimeo.Vimeo, _Facebook.Facebook, _Streamable.Streamable, _Wistia.Wistia, _Twitch.Twitch, _DailyMotion.DailyMotion, _Mixcloud.Mixcloud, _FilePlayer.FilePlayer];
	exports["default"] = _default;

/***/ },
/* 2795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = renderPreloadPlayers;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Player = _interopRequireDefault(__webpack_require__(632));
	
	var _YouTube = __webpack_require__(636);
	
	var _SoundCloud = __webpack_require__(634);
	
	var _Vimeo = __webpack_require__(635);
	
	var _DailyMotion = __webpack_require__(633);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var PRELOAD_PLAYERS = [{
	  Player: _YouTube.YouTube,
	  configKey: 'youtube',
	  url: 'https://www.youtube.com/watch?v=GlCmAC4MHek'
	}, {
	  Player: _SoundCloud.SoundCloud,
	  configKey: 'soundcloud',
	  url: 'https://soundcloud.com/seucheu/john-cage-433-8-bit-version'
	}, {
	  Player: _Vimeo.Vimeo,
	  configKey: 'vimeo',
	  url: 'https://vimeo.com/300970506'
	}, {
	  Player: _DailyMotion.DailyMotion,
	  configKey: 'dailymotion',
	  url: 'http://www.dailymotion.com/video/xqdpyk'
	}];
	
	function renderPreloadPlayers(url, controls, config) {
	  var players = [];
	
	  var _iterator = _createForOfIteratorHelper(PRELOAD_PLAYERS),
	      _step;
	
	  try {
	    for (_iterator.s(); !(_step = _iterator.n()).done;) {
	      var player = _step.value;
	
	      if (!player.Player.canPlay(url) && config[player.configKey].preload) {
	        players.push( /*#__PURE__*/_react["default"].createElement(_Player["default"], {
	          key: player.Player.displayName,
	          activePlayer: player.Player,
	          url: player.url,
	          controls: controls,
	          playing: true,
	          muted: true,
	          display: "none"
	        }));
	      }
	    }
	  } catch (err) {
	    _iterator.e(err);
	  } finally {
	    _iterator.f();
	  }
	
	  return players;
	}

/***/ },
/* 2796 */
[4455, 178, 44, 8, 10, 413, 1245],
/* 2797 */
[4456, 2796],
/* 2798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(76);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lib = __webpack_require__(10);
	
	var _Ref = __webpack_require__(1185);
	
	var _Ref2 = _interopRequireDefault(_Ref);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A component that allows you to render children outside their parent.
	 * @see Modal
	 * @see Popup
	 * @see Dimmer
	 * @see Confirm
	 */
	var Portal = function (_Component) {
	  (0, _inherits3.default)(Portal, _Component);
	
	  function Portal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.handleDocumentClick = function (e) {
	      var _this$props = _this.props,
	          closeOnDocumentClick = _this$props.closeOnDocumentClick,
	          closeOnRootNodeClick = _this$props.closeOnRootNodeClick;
	
	
	      if (!_this.rootNode // not mounted
	      || !_this.portalNode // no portal
	      || (0, _invoke3.default)(_this, 'triggerNode.contains', e.target) // event happened in trigger (delegate to trigger handlers)
	      || (0, _invoke3.default)(_this, 'portalNode.contains', e.target) // event happened in the portal
	      ) return; // ignore the click
	
	      var didClickInRootNode = _this.rootNode.contains(e.target);
	
	      if (closeOnDocumentClick && !didClickInRootNode || closeOnRootNodeClick && didClickInRootNode) {
	
	        _this.close(e);
	      }
	    }, _this.handleEscape = function (e) {
	      if (!_this.props.closeOnEscape) return;
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Escape) return;
	
	      _this.close(e);
	    }, _this.handlePortalMouseLeave = function (e) {
	      var _this$props2 = _this.props,
	          closeOnPortalMouseLeave = _this$props2.closeOnPortalMouseLeave,
	          mouseLeaveDelay = _this$props2.mouseLeaveDelay;
	
	
	      if (!closeOnPortalMouseLeave) return;
	
	      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
	    }, _this.handlePortalMouseEnter = function () {
	      // In order to enable mousing from the trigger to the portal, we need to
	      // clear the mouseleave timer that was set when leaving the trigger.
	      var closeOnPortalMouseLeave = _this.props.closeOnPortalMouseLeave;
	
	
	      if (!closeOnPortalMouseLeave) return;
	
	      clearTimeout(_this.mouseLeaveTimer);
	    }, _this.handleTriggerBlur = function (e) {
	      for (var _len2 = arguments.length, rest = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        rest[_key2 - 1] = arguments[_key2];
	      }
	
	      var _this$props3 = _this.props,
	          trigger = _this$props3.trigger,
	          closeOnTriggerBlur = _this$props3.closeOnTriggerBlur;
	
	      // Call original event handler
	
	      _invoke3.default.apply(undefined, [trigger, 'props.onBlur', e].concat(rest));
	
	      // do not close if focus is given to the portal
	      var didFocusPortal = (0, _invoke3.default)(_this, 'rootNode.contains', e.relatedTarget);
	
	      if (!closeOnTriggerBlur || didFocusPortal) return;
	
	      _this.close(e);
	    }, _this.handleTriggerClick = function (e) {
	      for (var _len3 = arguments.length, rest = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        rest[_key3 - 1] = arguments[_key3];
	      }
	
	      var _this$props4 = _this.props,
	          trigger = _this$props4.trigger,
	          closeOnTriggerClick = _this$props4.closeOnTriggerClick,
	          openOnTriggerClick = _this$props4.openOnTriggerClick;
	      var open = _this.state.open;
	
	      // Call original event handler
	
	      _invoke3.default.apply(undefined, [trigger, 'props.onClick', e].concat(rest));
	
	      if (open && closeOnTriggerClick) {
	
	        _this.close(e);
	      } else if (!open && openOnTriggerClick) {
	
	        _this.open(e);
	      }
	    }, _this.handleTriggerFocus = function (e) {
	      for (var _len4 = arguments.length, rest = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	        rest[_key4 - 1] = arguments[_key4];
	      }
	
	      var _this$props5 = _this.props,
	          trigger = _this$props5.trigger,
	          openOnTriggerFocus = _this$props5.openOnTriggerFocus;
	
	      // Call original event handler
	
	      _invoke3.default.apply(undefined, [trigger, 'props.onFocus', e].concat(rest));
	
	      if (!openOnTriggerFocus) return;
	
	      _this.open(e);
	    }, _this.handleTriggerMouseLeave = function (e) {
	      for (var _len5 = arguments.length, rest = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	        rest[_key5 - 1] = arguments[_key5];
	      }
	
	      clearTimeout(_this.mouseEnterTimer);
	
	      var _this$props6 = _this.props,
	          trigger = _this$props6.trigger,
	          closeOnTriggerMouseLeave = _this$props6.closeOnTriggerMouseLeave,
	          mouseLeaveDelay = _this$props6.mouseLeaveDelay;
	
	      // Call original event handler
	
	      _invoke3.default.apply(undefined, [trigger, 'props.onMouseLeave', e].concat(rest));
	
	      if (!closeOnTriggerMouseLeave) return;
	
	      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
	    }, _this.handleTriggerMouseEnter = function (e) {
	      for (var _len6 = arguments.length, rest = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	        rest[_key6 - 1] = arguments[_key6];
	      }
	
	      clearTimeout(_this.mouseLeaveTimer);
	
	      var _this$props7 = _this.props,
	          trigger = _this$props7.trigger,
	          mouseEnterDelay = _this$props7.mouseEnterDelay,
	          openOnTriggerMouseEnter = _this$props7.openOnTriggerMouseEnter;
	
	      // Call original event handler
	
	      _invoke3.default.apply(undefined, [trigger, 'props.onMouseEnter', e].concat(rest));
	
	      if (!openOnTriggerMouseEnter) return;
	
	      _this.mouseEnterTimer = _this.openWithTimeout(e, mouseEnterDelay);
	    }, _this.open = function (e) {
	      var onOpen = _this.props.onOpen;
	
	      if (onOpen) onOpen(e, _this.props);
	
	      _this.trySetState({ open: true });
	    }, _this.openWithTimeout = function (e, delay) {
	      // React wipes the entire event object and suggests using e.persist() if
	      // you need the event for async access. However, even with e.persist
	      // certain required props (e.g. currentTarget) are null so we're forced to clone.
	      var eventClone = (0, _extends3.default)({}, e);
	      return setTimeout(function () {
	        return _this.open(eventClone);
	      }, delay || 0);
	    }, _this.close = function (e) {
	      var onClose = _this.props.onClose;
	
	      if (onClose) onClose(e, _this.props);
	
	      _this.trySetState({ open: false });
	    }, _this.closeWithTimeout = function (e, delay) {
	      // React wipes the entire event object and suggests using e.persist() if
	      // you need the event for async access. However, even with e.persist
	      // certain required props (e.g. currentTarget) are null so we're forced to clone.
	      var eventClone = (0, _extends3.default)({}, e);
	      return setTimeout(function () {
	        return _this.close(eventClone);
	      }, delay || 0);
	    }, _this.mountPortal = function () {
	      if (!(0, _lib.isBrowser)() || _this.rootNode) return;
	
	      var _this$props8 = _this.props,
	          eventPool = _this$props8.eventPool,
	          _this$props8$mountNod = _this$props8.mountNode,
	          mountNode = _this$props8$mountNod === undefined ? (0, _lib.isBrowser)() ? document.body : null : _this$props8$mountNod,
	          prepend = _this$props8.prepend;
	
	
	      _this.rootNode = document.createElement('div');
	
	      if (prepend) {
	        mountNode.insertBefore(_this.rootNode, mountNode.firstElementChild);
	      } else {
	        mountNode.appendChild(_this.rootNode);
	      }
	
	      _lib.eventStack.sub('click', _this.handleDocumentClick, eventPool);
	      _lib.eventStack.sub('keydown', _this.handleEscape, eventPool);
	      (0, _invoke3.default)(_this.props, 'onMount', null, _this.props);
	    }, _this.unmountPortal = function () {
	      if (!(0, _lib.isBrowser)() || !_this.rootNode) return;
	
	      var eventPool = _this.props.eventPool;
	
	
	      _reactDom2.default.unmountComponentAtNode(_this.rootNode);
	      _this.rootNode.parentNode.removeChild(_this.rootNode);
	
	      _lib.eventStack.unsub('mouseleave', _this.handlePortalMouseLeave, { target: _this.portalNode });
	      _lib.eventStack.unsub('mouseenter', _this.handlePortalMouseEnter, { target: _this.portalNode });
	
	      _this.rootNode = null;
	      _this.portalNode = null;
	
	      _lib.eventStack.unsub('click', _this.handleDocumentClick, eventPool);
	      _lib.eventStack.unsub('keydown', _this.handleEscape, eventPool);
	      (0, _invoke3.default)(_this.props, 'onUnmount', null, _this.props);
	    }, _this.handleRef = function (c) {
	      return _this.triggerNode = c;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // NOTE: Ideally the portal rendering would happen in the render() function
	      // but React gives a warning about not being pure and suggests doing it
	      // within this method.
	
	      // If the portal is open, render (or re-render) the portal and child.
	      this.renderPortal();
	
	      if (prevState.open && !this.state.open) {
	        this.unmountPortal();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unmountPortal();
	
	      // Clean up timers
	      clearTimeout(this.mouseEnterTimer);
	      clearTimeout(this.mouseLeaveTimer);
	    }
	
	    // ----------------------------------------
	    // Document Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Component Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Behavior
	    // ----------------------------------------
	
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal() {
	      var _this2 = this;
	
	      if (!this.state.open) return;
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	
	      this.mountPortal();
	
	      // Server side rendering
	      if (!(0, _lib.isBrowser)()) return null;
	
	      this.rootNode.className = className || '';
	
	      // when re-rendering, first remove listeners before re-adding them to the new node
	      if (this.portalNode) {
	        _lib.eventStack.unsub('mouseleave', this.handlePortalMouseLeave, { target: this.portalNode });
	        _lib.eventStack.unsub('mouseenter', this.handlePortalMouseEnter, { target: this.portalNode });
	      }
	
	      _reactDom2.default.unstable_renderSubtreeIntoContainer(this, _react.Children.only(children), this.rootNode, function () {
	        _this2.portalNode = _this2.rootNode.firstElementChild;
	
	        _lib.eventStack.sub('mouseleave', _this2.handlePortalMouseLeave, { target: _this2.portalNode });
	        _lib.eventStack.sub('mouseenter', _this2.handlePortalMouseEnter, { target: _this2.portalNode });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var trigger = this.props.trigger;
	
	
	      if (!trigger) return null;
	      return _react2.default.createElement(
	        _Ref2.default,
	        { innerRef: this.handleRef },
	        (0, _react.cloneElement)(trigger, {
	          onBlur: this.handleTriggerBlur,
	          onClick: this.handleTriggerClick,
	          onFocus: this.handleTriggerFocus,
	          onMouseLeave: this.handleTriggerMouseLeave,
	          onMouseEnter: this.handleTriggerMouseEnter
	        })
	      );
	    }
	  }]);
	  return Portal;
	}(_lib.AutoControlledComponent);
	
	Portal.defaultProps = {
	  closeOnDocumentClick: true,
	  closeOnEscape: true,
	  eventPool: 'default',
	  openOnTriggerClick: true
	};
	Portal.autoControlledProps = ['open'];
	Portal._meta = {
	  name: 'Portal',
	  type: _lib.META.TYPES.ADDON
	};
	Portal.handledProps = ['children', 'className', 'closeOnDocumentClick', 'closeOnEscape', 'closeOnPortalMouseLeave', 'closeOnRootNodeClick', 'closeOnTriggerBlur', 'closeOnTriggerClick', 'closeOnTriggerMouseLeave', 'defaultOpen', 'eventPool', 'mountNode', 'mouseEnterDelay', 'mouseLeaveDelay', 'onClose', 'onMount', 'onOpen', 'onUnmount', 'open', 'openOnTriggerClick', 'openOnTriggerFocus', 'openOnTriggerMouseEnter', 'prepend', 'trigger'];
	Portal.propTypes =  false ? {
	  /** Primary content. */
	  children: _propTypes2.default.node.isRequired,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Controls whether or not the portal should close when the document is clicked. */
	  closeOnDocumentClick: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should close when escape is pressed is displayed. */
	  closeOnEscape: _propTypes2.default.bool,
	
	  /**
	   * Controls whether or not the portal should close when mousing out of the portal.
	   * NOTE: This will prevent `closeOnTriggerMouseLeave` when mousing over the
	   * gap from the trigger to the portal.
	   */
	  closeOnPortalMouseLeave: _propTypes2.default.bool,
	
	  /**
	   * Controls whether or not the portal should close on a click on the portal background.
	   * NOTE: This differs from closeOnDocumentClick:
	   * - DocumentClick - any click not within the portal
	   * - RootNodeClick - a click not within the portal but within the portal's wrapper
	   */
	  closeOnRootNodeClick: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should close on blur of the trigger. */
	  closeOnTriggerBlur: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should close on click of the trigger. */
	  closeOnTriggerClick: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should close when mousing out of the trigger. */
	  closeOnTriggerMouseLeave: _propTypes2.default.bool,
	
	  /** Initial value of open. */
	  defaultOpen: _propTypes2.default.bool,
	
	  /** Event pool namespace that is used to handle component events */
	  eventPool: _propTypes2.default.string,
	
	  /** The node where the portal should mount. */
	  mountNode: _propTypes2.default.any,
	
	  /** Milliseconds to wait before opening on mouse over */
	  mouseEnterDelay: _propTypes2.default.number,
	
	  /** Milliseconds to wait before closing on mouse leave */
	  mouseLeaveDelay: _propTypes2.default.number,
	
	  /**
	   * Called when a close event happens
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * Called when the portal is mounted on the DOM
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _propTypes2.default.func,
	
	  /**
	   * Called when an open event happens
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * Called when the portal is unmounted from the DOM
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _propTypes2.default.func,
	
	  /** Controls whether or not the portal is displayed. */
	  open: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should open when the trigger is clicked. */
	  openOnTriggerClick: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should open on focus of the trigger. */
	  openOnTriggerFocus: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should open when mousing over the trigger. */
	  openOnTriggerMouseEnter: _propTypes2.default.bool,
	
	  /** Controls whether the portal should be prepended to the mountNode instead of appended. */
	  prepend: _propTypes2.default.bool,
	
	  /** Element to be rendered in-place where the portal is defined. */
	  trigger: _propTypes2.default.node
	} : {};
	exports.default = Portal;

/***/ },
/* 2799 */
[4458, 10, 418],
/* 2800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(76);
	
	var _META = __webpack_require__(1231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This component exposes a callback prop that always returns the DOM node of both functional and class component
	 * children.
	 */
	var Ref = function (_Component) {
	  (0, _inherits3.default)(Ref, _Component);
	
	  function Ref() {
	    (0, _classCallCheck3.default)(this, Ref);
	    return (0, _possibleConstructorReturn3.default)(this, (Ref.__proto__ || Object.getPrototypeOf(Ref)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Ref, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var innerRef = this.props.innerRef;
	
	      // Heads up! Don't move this condition, it's a short circuit that avoids run of `findDOMNode`
	      // if `innerRef` isn't passed
	      // eslint-disable-next-line react/no-find-dom-node
	
	      if (innerRef) innerRef((0, _reactDom.findDOMNode)(this));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return _react.Children.only(children);
	    }
	  }]);
	  return Ref;
	}(_react.Component);
	
	Ref._meta = {
	  name: 'Ref',
	  type: _META.TYPES.ADDON
	};
	Ref.handledProps = ['children', 'innerRef'];
	exports.default = Ref;
	Ref.propTypes =  false ? {
	  /** Primary content. */
	  children: _propTypes2.default.element,
	
	  /**
	   * Called when componentDidMount.
	   *
	   * @param {HTMLElement} node - Referred node.
	   */
	  innerRef: _propTypes2.default.func
	} : {};

/***/ },
/* 2801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _isNil2 = __webpack_require__(74);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Responsive can control visibility of content.
	 */
	var Responsive = function (_Component) {
	  (0, _inherits3.default)(Responsive, _Component);
	
	  function Responsive() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, Responsive);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Responsive.__proto__ || Object.getPrototypeOf(Responsive)).call.apply(_ref, [this].concat(args)));
	
	    _this.fitsMaxWidth = function () {
	      var maxWidth = _this.props.maxWidth;
	      var width = _this.state.width;
	
	
	      return (0, _isNil3.default)(maxWidth) ? true : width <= maxWidth;
	    };
	
	    _this.fitsMinWidth = function () {
	      var minWidth = _this.props.minWidth;
	      var width = _this.state.width;
	
	
	      return (0, _isNil3.default)(minWidth) ? true : width >= minWidth;
	    };
	
	    _this.isVisible = function () {
	      return _this.fitsMinWidth() && _this.fitsMaxWidth();
	    };
	
	    _this.handleResize = function (e) {
	      if (_this.ticking) return;
	
	      _this.ticking = true;
	      requestAnimationFrame(function () {
	        return _this.handleUpdate(e);
	      });
	    };
	
	    _this.handleUpdate = function (e) {
	      _this.ticking = false;
	      var width = window.innerWidth;
	
	      _this.setState({ width: width });
	      (0, _invoke3.default)(_this.props, 'onUpdate', e, (0, _extends3.default)({}, _this.props, { width: width }));
	    };
	
	    _this.state = { width: (0, _lib.isBrowser)() ? window.innerWidth : 0 };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Responsive, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var fireOnMount = this.props.fireOnMount;
	
	
	      _lib.eventStack.sub('resize', this.handleResize, { target: 'window' });
	      if (fireOnMount) this.handleUpdate();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _lib.eventStack.unsub('resize', this.handleResize, { target: 'window' });
	    }
	
	    // ----------------------------------------
	    // Helpers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Event handlers
	    // ----------------------------------------
	
	  }, {
	    key: 'render',
	
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	    value: function render() {
	      var children = this.props.children;
	
	
	      var ElementType = (0, _lib.getElementType)(Responsive, this.props);
	      var rest = (0, _lib.getUnhandledProps)(Responsive, this.props);
	
	      if (this.isVisible()) return _react2.default.createElement(
	        ElementType,
	        rest,
	        children
	      );
	      return null;
	    }
	  }]);
	  return Responsive;
	}(_react.Component);
	
	Responsive._meta = {
	  name: 'Responsive',
	  type: _lib.META.TYPES.ADDON
	};
	Responsive.onlyMobile = { minWidth: 320, maxWidth: 767 };
	Responsive.onlyTablet = { minWidth: 768, maxWidth: 991 };
	Responsive.onlyComputer = { minWidth: 992 };
	Responsive.onlyLargeScreen = { minWidth: 1200, maxWidth: 1919 };
	Responsive.onlyWidescreen = { minWidth: 1920 };
	Responsive.handledProps = ['as', 'children', 'fireOnMount', 'maxWidth', 'minWidth', 'onUpdate'];
	exports.default = Responsive;
	Responsive.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Fires callbacks immediately after mount. */
	  fireOnMount: _propTypes2.default.bool,
	
	  /** The maximum width at which content will be displayed. */
	  maxWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** The minimum width at which content will be displayed. */
	  minWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Called on update.
	   *
	   * @param {SyntheticEvent} event - The React SyntheticEvent object
	   * @param {object} data - All props and the event value.
	   */
	  onUpdate: _propTypes2.default.func
	} : {};

/***/ },
/* 2802 */
[4460, 2801],
/* 2803 */
[4461, 10, 651],
/* 2804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _sum2 = __webpack_require__(1039);
	
	var _sum3 = _interopRequireDefault(_sum2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _get2 = __webpack_require__(109);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A TextArea can be used to allow for extended user input.
	 * @see Form
	 */
	var TextArea = function (_Component) {
	  (0, _inherits3.default)(TextArea, _Component);
	
	  function TextArea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextArea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this), _this.focus = function () {
	      return _this.ref.focus();
	    }, _this.handleChange = function (e) {
	      var value = (0, _get3.default)(e, 'target.value');
	
	      (0, _invoke3.default)(_this.props, 'onChange', e, (0, _extends3.default)({}, _this.props, { value: value }));
	    }, _this.handleInput = function (e) {
	      var value = (0, _get3.default)(e, 'target.value');
	
	      (0, _invoke3.default)(_this.props, 'onInput', e, (0, _extends3.default)({}, _this.props, { value: value }));
	      _this.updateHeight();
	    }, _this.handleRef = function (c) {
	      return _this.ref = c;
	    }, _this.removeAutoHeightStyles = function () {
	      _this.ref.style.height = null;
	      _this.ref.style.resize = null;
	    }, _this.updateHeight = function () {
	      var autoHeight = _this.props.autoHeight;
	
	      if (!_this.ref || !autoHeight) return;
	
	      var _window$getComputedSt = window.getComputedStyle(_this.ref),
	          minHeight = _window$getComputedSt.minHeight,
	          borderBottomWidth = _window$getComputedSt.borderBottomWidth,
	          borderTopWidth = _window$getComputedSt.borderTopWidth;
	
	      var borderHeight = (0, _sum3.default)([borderBottomWidth, borderTopWidth].map(function (x) {
	        return parseFloat(x);
	      }));
	
	      // Measure the scrollHeight and update the height to match.
	      _this.ref.style.height = 'auto';
	      _this.ref.style.overflowY = 'hidden';
	      _this.ref.style.height = Math.max(parseFloat(minHeight), Math.ceil(_this.ref.scrollHeight + borderHeight)) + 'px';
	      _this.ref.style.overflowY = '';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextArea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateHeight();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // removed autoHeight
	      if (!this.props.autoHeight && prevProps.autoHeight) {
	        this.removeAutoHeightStyles();
	      }
	      // added autoHeight or value changed
	      if (this.props.autoHeight && !prevProps.autoHeight || prevProps.value !== this.props.value) {
	        this.updateHeight();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoHeight = _props.autoHeight,
	          rows = _props.rows,
	          style = _props.style,
	          value = _props.value;
	
	      var rest = (0, _lib.getUnhandledProps)(TextArea, this.props);
	      var ElementType = (0, _lib.getElementType)(TextArea, this.props);
	
	      var resize = autoHeight ? 'none' : '';
	
	      return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, {
	        onChange: this.handleChange,
	        onInput: this.handleInput,
	        ref: this.handleRef,
	        rows: rows,
	        style: (0, _extends3.default)({ resize: resize }, style),
	        value: value
	      }));
	    }
	  }]);
	  return TextArea;
	}(_react.Component);
	
	TextArea._meta = {
	  name: 'TextArea',
	  type: _lib.META.TYPES.ADDON
	};
	TextArea.defaultProps = {
	  as: 'textarea',
	  rows: 3
	};
	TextArea.handledProps = ['as', 'autoHeight', 'onChange', 'onInput', 'rows', 'style', 'value'];
	TextArea.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Indicates whether height of the textarea fits the content or not. */
	  autoHeight: _propTypes2.default.bool,
	
	  /**
	   * Called on change.
	   * @param {SyntheticEvent} event - The React SyntheticEvent object
	   * @param {object} data - All props and the event value.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * Called on input.
	   * @param {SyntheticEvent} event - The React SyntheticEvent object
	   * @param {object} data - All props and the event value.
	   */
	  onInput: _propTypes2.default.func,
	
	  /** Indicates row count for a TextArea. */
	  rows: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** Custom TextArea style. */
	  style: _propTypes2.default.object,
	
	  /** The value of the textarea. */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	} : {};
	exports.default = TextArea;

/***/ },
/* 2805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _isNil2 = __webpack_require__(74);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(306);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Transition = __webpack_require__(1257);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A sugar for `Portal` and `Transition`.
	 * @see Portal
	 * @see Transition
	 */
	var TransitionablePortal = function (_Component) {
	  (0, _inherits3.default)(TransitionablePortal, _Component);
	
	  function TransitionablePortal(props) {
	    (0, _classCallCheck3.default)(this, TransitionablePortal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TransitionablePortal.__proto__ || Object.getPrototypeOf(TransitionablePortal)).call(this, props));
	
	    _this.handlePortalClose = function () {
	      var open = _this.props.open;
	      var portalOpen = _this.state.portalOpen;
	
	      // Heads up! We simply call `onClose` when component is controlled with `open` prop.
	      // But, when it's autocontrolled we should change the state to opposite to keep the transition
	      // queue
	
	      if ((0, _isNil3.default)(open)) _this.setState({ portalOpen: !portalOpen });
	    };
	
	    _this.handlePortalOpen = function () {
	
	      _this.setState({ portalOpen: true });
	    };
	
	    _this.handleTransitionHide = function (nothing, data) {
	      var portalOpen = _this.state.portalOpen;
	
	
	      _this.setState({ transitionVisible: false });
	      (0, _invoke3.default)(_this.props, 'onClose', null, (0, _extends3.default)({}, data, { portalOpen: false, transitionVisible: false }));
	      (0, _invoke3.default)(_this.props, 'onHide', null, (0, _extends3.default)({}, data, { portalOpen: portalOpen, transitionVisible: false }));
	    };
	
	    _this.handleTransitionStart = function (nothing, data) {
	      var portalOpen = _this.state.portalOpen;
	      var status = data.status;
	
	      var transitionVisible = status === _Transition2.default.ENTERING;
	
	      (0, _invoke3.default)(_this.props, 'onStart', null, (0, _extends3.default)({}, data, { portalOpen: portalOpen, transitionVisible: transitionVisible }));
	
	      // Heads up! TransitionablePortal fires onOpen callback on the start of transition animation
	      if (!transitionVisible) return;
	
	      _this.setState({ transitionVisible: transitionVisible });
	      (0, _invoke3.default)(_this.props, 'onOpen', null, (0, _extends3.default)({}, data, { transitionVisible: transitionVisible, portalOpen: true }));
	    };
	
	    _this.state = {
	      portalOpen: props.open
	    };
	    return _this;
	  }
	
	  // ----------------------------------------
	  // Lifecycle
	  // ----------------------------------------
	
	  (0, _createClass3.default)(TransitionablePortal, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var open = _ref.open;
	
	
	      // Heads up! We apply `open` prop only when it's defined, otherwise it will break
	      // autocontrolled Portal
	      if (!(0, _isNil3.default)(open)) this.setState({ portalOpen: open });
	    }
	
	    // ----------------------------------------
	    // Callback handling
	    // ----------------------------------------
	
	  }, {
	    key: 'render',
	
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          transition = _props.transition;
	      var _state = this.state,
	          portalOpen = _state.portalOpen,
	          transitionVisible = _state.transitionVisible;
	
	
	      var open = portalOpen || transitionVisible;
	      var rest = (0, _lib.getUnhandledProps)(TransitionablePortal, this.props);
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        (0, _extends3.default)({}, rest, {
	          open: open,
	          onOpen: this.handlePortalOpen,
	          onClose: this.handlePortalClose
	        }),
	        _react2.default.createElement(
	          _Transition2.default,
	          (0, _extends3.default)({}, transition, {
	            transitionOnMount: true,
	            onStart: this.handleTransitionStart,
	            onHide: this.handleTransitionHide,
	            visible: portalOpen
	          }),
	          children
	        )
	      );
	    }
	  }]);
	  return TransitionablePortal;
	}(_react.Component);
	
	TransitionablePortal._meta = {
	  name: 'TransitionablePortal',
	  type: _lib.META.TYPES.ADDON
	};
	TransitionablePortal.defaultProps = {
	  transition: {
	    animation: 'scale',
	    duration: 400
	  }
	};
	TransitionablePortal.handledProps = ['children', 'onClose', 'onHide', 'onOpen', 'onStart', 'open', 'transition'];
	exports.default = TransitionablePortal;
	TransitionablePortal.propTypes =  false ? {
	  /** Primary content. */
	  children: _propTypes2.default.node.isRequired,
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and internal state.
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * Callback on each transition that changes visibility to hidden.
	   *
	   * @param {null}
	   * @param {object} data - All props with transition status and internal state.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and internal state.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * Callback on animation start.
	   *
	   * @param {null}
	   * @param {object} data - All props with transition status and internal state.
	   */
	  onStart: _propTypes2.default.func,
	
	  /** Controls whether or not the portal is displayed. */
	  open: _propTypes2.default.bool,
	
	  /** Transition props. */
	  transition: _propTypes2.default.object
	} : {};

/***/ },
/* 2806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TransitionablePortal = __webpack_require__(2805);
	
	var _TransitionablePortal2 = _interopRequireDefault(_TransitionablePortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TransitionablePortal2.default;

/***/ },
/* 2807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(130);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _forEach2 = __webpack_require__(246);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _includes2 = __webpack_require__(149);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Visibility provides a set of callbacks for when a content appears in the viewport.
	 */
	var Visibility = function (_Component) {
	  (0, _inherits3.default)(Visibility, _Component);
	
	  function Visibility() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Visibility);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Visibility.__proto__ || Object.getPrototypeOf(Visibility)).call.apply(_ref, [this].concat(args))), _this), _this.calculations = {
	      bottomPassed: false,
	      bottomVisible: false,
	      fits: false,
	      passing: false,
	      offScreen: false,
	      onScreen: false,
	      topPassed: false,
	      topVisible: false
	    }, _this.firedCallbacks = [], _this.fire = function (_ref2, value) {
	      var callback = _ref2.callback,
	          name = _ref2.name;
	      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var _this$props = _this.props,
	          continuous = _this$props.continuous,
	          once = _this$props.once;
	
	      // Heads up! For the execution is required:
	      // - current value correspond to the fired direction
	      // - `continuous` is true or calculation values are different
	
	      var matchesDirection = _this.calculations[value] !== reverse;
	      var executionPossible = continuous || _this.calculations[value] !== _this.oldCalculations[value];
	
	      if (matchesDirection && executionPossible) _this.execute(callback, name);
	
	      // Heads up! We should remove callback from the happened when it's not `once`
	      if (!once) _this.firedCallbacks = (0, _without3.default)(_this.firedCallbacks, name);
	    }, _this.handleUpdate = function () {
	      if (_this.ticking) return;
	
	      _this.ticking = true;
	      requestAnimationFrame(_this.update);
	    }, _this.update = function () {
	      _this.ticking = false;
	
	      _this.oldCalculations = _this.calculations;
	      _this.calculations = _this.computeCalculations();
	      _this.pageYOffset = window.pageYOffset;
	
	      var _this$props2 = _this.props,
	          onBottomPassed = _this$props2.onBottomPassed,
	          onBottomPassedReverse = _this$props2.onBottomPassedReverse,
	          onBottomVisible = _this$props2.onBottomVisible,
	          onBottomVisibleReverse = _this$props2.onBottomVisibleReverse,
	          onPassing = _this$props2.onPassing,
	          onPassingReverse = _this$props2.onPassingReverse,
	          onTopPassed = _this$props2.onTopPassed,
	          onTopPassedReverse = _this$props2.onTopPassedReverse,
	          onTopVisible = _this$props2.onTopVisible,
	          onTopVisibleReverse = _this$props2.onTopVisibleReverse,
	          onOffScreen = _this$props2.onOffScreen,
	          onOnScreen = _this$props2.onOnScreen;
	
	      var forward = {
	        bottomPassed: { callback: onBottomPassed, name: 'onBottomPassed' },
	        bottomVisible: { callback: onBottomVisible, name: 'onBottomVisible' },
	        passing: { callback: onPassing, name: 'onPassing' },
	        offScreen: { callback: onOffScreen, name: 'onOffScreen' },
	        onScreen: { callback: onOnScreen, name: 'onOnScreen' },
	        topPassed: { callback: onTopPassed, name: 'onTopPassed' },
	        topVisible: { callback: onTopVisible, name: 'onTopVisible' }
	      };
	
	      var reverse = {
	        bottomPassed: { callback: onBottomPassedReverse, name: 'onBottomPassedReverse' },
	        bottomVisible: { callback: onBottomVisibleReverse, name: 'onBottomVisibleReverse' },
	        passing: { callback: onPassingReverse, name: 'onPassingReverse' },
	        topPassed: { callback: onTopPassedReverse, name: 'onTopPassedReverse' },
	        topVisible: { callback: onTopVisibleReverse, name: 'onTopVisibleReverse' }
	      };
	
	      (0, _invoke3.default)(_this.props, 'onUpdate', null, (0, _extends3.default)({}, _this.props, { calculations: _this.calculations }));
	      _this.fireOnPassed();
	
	      // Heads up! Reverse callbacks should be fired first
	      (0, _forEach3.default)(reverse, function (data, value) {
	        return _this.fire(data, value, true);
	      });
	      (0, _forEach3.default)(forward, function (data, value) {
	        return _this.fire(data, value);
	      });
	    }, _this.handleRef = function (c) {
	      return _this.ref = c;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Visibility, [{
	    key: 'componentWillReceiveProps',
	
	
	    // ----------------------------------------
	    // Lifecycle
	    // ----------------------------------------
	
	    value: function componentWillReceiveProps(_ref3) {
	      var continuous = _ref3.continuous,
	          once = _ref3.once;
	
	      var cleanHappened = continuous !== this.props.continuous || once !== this.props.once;
	
	      // Heads up! We should clean up array of happened callbacks, if values of these props are changed
	      if (cleanHappened) this.firedCallbacks = [];
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!(0, _lib.isBrowser)()) return;
	      var _props = this.props,
	          context = _props.context,
	          fireOnMount = _props.fireOnMount;
	
	
	      this.pageYOffset = window.pageYOffset;
	      _lib.eventStack.sub('resize', this.handleUpdate, { target: context });
	      _lib.eventStack.sub('scroll', this.handleUpdate, { target: context });
	
	      if (fireOnMount) this.update();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var context = this.props.context;
	
	
	      _lib.eventStack.unsub('resize', this.handleUpdate, { target: context });
	      _lib.eventStack.unsub('scroll', this.handleUpdate, { target: context });
	    }
	
	    // ----------------------------------------
	    // Callback handling
	    // ----------------------------------------
	
	  }, {
	    key: 'execute',
	    value: function execute(callback, name) {
	      var continuous = this.props.continuous;
	
	      if (!callback) return;
	
	      // Heads up! When `continuous` is true, callback will be fired always
	      if (!continuous && (0, _includes3.default)(this.firedCallbacks, name)) return;
	
	      callback(null, (0, _extends3.default)({}, this.props, { calculations: this.calculations }));
	      this.firedCallbacks.push(name);
	    }
	  }, {
	    key: 'fireOnPassed',
	    value: function fireOnPassed() {
	      var _this2 = this;
	
	      var _calculations = this.calculations,
	          percentagePassed = _calculations.percentagePassed,
	          pixelsPassed = _calculations.pixelsPassed;
	      var onPassed = this.props.onPassed;
	
	
	      (0, _forEach3.default)(onPassed, function (callback, passed) {
	        var pixelsValue = Number(passed);
	
	        if (pixelsValue && pixelsPassed >= pixelsValue) {
	          _this2.execute(callback, passed);
	          return;
	        }
	
	        var matchPercentage = ('' + passed).match(/^(\d+)%$/);
	        if (!matchPercentage) return;
	
	        var percentageValue = Number(matchPercentage[1]) / 100;
	        if (percentagePassed >= percentageValue) _this2.execute(callback, passed);
	      });
	    }
	  }, {
	    key: 'computeCalculations',
	
	
	    // ----------------------------------------
	    // Helpers
	    // ----------------------------------------
	
	    value: function computeCalculations() {
	      var offset = this.props.offset;
	
	      var _ref$getBoundingClien = this.ref.getBoundingClientRect(),
	          bottom = _ref$getBoundingClien.bottom,
	          height = _ref$getBoundingClien.height,
	          top = _ref$getBoundingClien.top,
	          width = _ref$getBoundingClien.width;
	
	      var _normalizeOffset = (0, _lib.normalizeOffset)(offset),
	          _normalizeOffset2 = (0, _slicedToArray3.default)(_normalizeOffset, 2),
	          topOffset = _normalizeOffset2[0],
	          bottomOffset = _normalizeOffset2[1];
	
	      var direction = window.pageYOffset > this.pageYOffset ? 'down' : 'up';
	      var topPassed = top < topOffset;
	      var bottomPassed = bottom < bottomOffset;
	
	      var pixelsPassed = bottomPassed ? 0 : Math.max(top * -1, 0);
	      var percentagePassed = pixelsPassed / height;
	
	      var bottomVisible = bottom >= bottomOffset && bottom <= window.innerHeight;
	      var topVisible = top >= topOffset && top <= window.innerHeight;
	
	      var fits = topVisible && bottomVisible;
	      var passing = topPassed && !bottomPassed;
	
	      var onScreen = (topVisible || topPassed) && !bottomPassed;
	      var offScreen = !onScreen;
	
	      return {
	        bottomPassed: bottomPassed,
	        bottomVisible: bottomVisible,
	        direction: direction,
	        fits: fits,
	        height: height,
	        passing: passing,
	        percentagePassed: percentagePassed,
	        pixelsPassed: pixelsPassed,
	        offScreen: offScreen,
	        onScreen: onScreen,
	        topPassed: topPassed,
	        topVisible: topVisible,
	        width: width
	      };
	    }
	
	    // ----------------------------------------
	    // Refs
	    // ----------------------------------------
	
	  }, {
	    key: 'render',
	
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	    value: function render() {
	      var children = this.props.children;
	
	      var ElementType = (0, _lib.getElementType)(Visibility, this.props);
	      var rest = (0, _lib.getUnhandledProps)(Visibility, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { ref: this.handleRef }),
	        children
	      );
	    }
	  }]);
	  return Visibility;
	}(_react.Component);
	
	Visibility.defaultProps = {
	  context: (0, _lib.isBrowser)() ? window : null,
	  continuous: false,
	  offset: [0, 0],
	  once: true
	};
	Visibility._meta = {
	  name: 'Visibility',
	  type: _lib.META.TYPES.BEHAVIOR
	};
	Visibility.handledProps = ['as', 'children', 'context', 'continuous', 'fireOnMount', 'offset', 'onBottomPassed', 'onBottomPassedReverse', 'onBottomVisible', 'onBottomVisibleReverse', 'onOffScreen', 'onOnScreen', 'onPassed', 'onPassing', 'onPassingReverse', 'onTopPassed', 'onTopPassedReverse', 'onTopVisible', 'onTopVisibleReverse', 'onUpdate', 'once'];
	exports.default = Visibility;
	Visibility.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Context which visibility should attach onscroll events. */
	  context: _propTypes2.default.object,
	
	  /**
	   * When set to true a callback will occur anytime an element passes a condition not just immediately after the
	   * threshold is met.
	   */
	  continuous: _propTypes2.default.bool,
	
	  /** Fires callbacks immediately after mount. */
	  fireOnMount: _propTypes2.default.bool,
	
	  /**
	   * Element's bottom edge has passed top of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onBottomPassed: _propTypes2.default.func,
	
	  /**
	   * Element's bottom edge has not passed top of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onBottomPassedReverse: _propTypes2.default.func,
	
	  /**
	   * Element's bottom edge has passed bottom of screen
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onBottomVisible: _propTypes2.default.func,
	
	  /**
	   * Element's bottom edge has not passed bottom of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onBottomVisibleReverse: _propTypes2.default.func,
	
	  /**
	   * Value that context should be adjusted in pixels. Useful for making content appear below content fixed to the
	   * page.
	   */
	  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
	
	  /** When set to false a callback will occur each time an element passes the threshold for a condition. */
	  once: _propTypes2.default.bool,
	
	  /** Element is not visible on the screen. */
	  onPassed: _propTypes2.default.object,
	
	  /**
	   * Any part of an element is visible on screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onPassing: _propTypes2.default.func,
	
	  /**
	   * Element's top has not passed top of screen but bottom has.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onPassingReverse: _propTypes2.default.func,
	
	  /**
	   * Element is not visible on the screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onOffScreen: _propTypes2.default.func,
	
	  /**
	   * Element is visible on the screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onOnScreen: _propTypes2.default.func,
	
	  /**
	   * Element's top edge has passed top of the screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onTopPassed: _propTypes2.default.func,
	
	  /**
	   * Element's top edge has not passed top of the screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onTopPassedReverse: _propTypes2.default.func,
	
	  /**
	   * Element's top edge has passed bottom of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onTopVisible: _propTypes2.default.func,
	
	  /**
	   * Element's top edge has not passed bottom of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onTopVisibleReverse: _propTypes2.default.func,
	
	  /**
	   * Element's top edge has passed bottom of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUpdate: _propTypes2.default.func
	} : {};

/***/ },
/* 2808 */
[4464, 2807],
/* 2809 */
[4465, 43, 623, 8, 10, 1188, 1189],
/* 2810 */
[4467, 2809],
/* 2811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _FormButton = __webpack_require__(1190);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _FormCheckbox = __webpack_require__(1191);
	
	var _FormCheckbox2 = _interopRequireDefault(_FormCheckbox);
	
	var _FormDropdown = __webpack_require__(1192);
	
	var _FormDropdown2 = _interopRequireDefault(_FormDropdown);
	
	var _FormField = __webpack_require__(153);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormGroup = __webpack_require__(1193);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormInput = __webpack_require__(1194);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormRadio = __webpack_require__(1195);
	
	var _FormRadio2 = _interopRequireDefault(_FormRadio);
	
	var _FormSelect = __webpack_require__(1196);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _FormTextArea = __webpack_require__(1197);
	
	var _FormTextArea2 = _interopRequireDefault(_FormTextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A Form displays a set of related user input fields in a structured way.
	 * @see Button
	 * @see Checkbox
	 * @see Dropdown
	 * @see Input
	 * @see Message
	 * @see Radio
	 * @see Select
	 * @see Visibility
	 */
	var Form = function (_Component) {
	  (0, _inherits3.default)(Form, _Component);
	
	  function Form() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Form);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Form, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          action = _props.action,
	          children = _props.children,
	          className = _props.className,
	          error = _props.error,
	          inverted = _props.inverted,
	          loading = _props.loading,
	          reply = _props.reply,
	          size = _props.size,
	          success = _props.success,
	          unstackable = _props.unstackable,
	          warning = _props.warning,
	          widths = _props.widths;
	
	
	      var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(reply, 'reply'), (0, _lib.useKeyOnly)(success, 'success'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useWidthProp)(widths, null, true), 'form', className);
	      var rest = (0, _lib.getUnhandledProps)(Form, this.props);
	      var ElementType = (0, _lib.getElementType)(Form, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, {
	          action: action,
	          className: classes,
	          onSubmit: this.handleSubmit
	        }),
	        children
	      );
	    }
	  }]);
	  return Form;
	}(_react.Component);
	
	Form.defaultProps = {
	  as: 'form'
	};
	Form._meta = {
	  name: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	Form.Field = _FormField2.default;
	Form.Button = _FormButton2.default;
	Form.Checkbox = _FormCheckbox2.default;
	Form.Dropdown = _FormDropdown2.default;
	Form.Group = _FormGroup2.default;
	Form.Input = _FormInput2.default;
	Form.Radio = _FormRadio2.default;
	Form.Select = _FormSelect2.default;
	Form.TextArea = _FormTextArea2.default;
	Form.handledProps = ['action', 'as', 'children', 'className', 'error', 'inverted', 'loading', 'onSubmit', 'reply', 'size', 'success', 'unstackable', 'warning', 'widths'];
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.handleSubmit = function (e) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    var action = _this2.props.action;
	
	    // Heads up! Third party libs can pass own data as first argument, we need to check that it has preventDefault()
	    // method.
	
	    if (typeof action !== 'string') (0, _invoke3.default)(e, 'preventDefault');
	    _invoke3.default.apply(undefined, [_this2.props, 'onSubmit', e, _this2.props].concat(args));
	  };
	};
	
	Form.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** The HTML form action */
	  action: _propTypes2.default.string,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Automatically show any error Message children. */
	  error: _propTypes2.default.bool,
	
	  /** A form can have its color inverted for contrast. */
	  inverted: _propTypes2.default.bool,
	
	  /** Automatically show a loading indicator. */
	  loading: _propTypes2.default.bool,
	
	  /** The HTML form submit handler. */
	  onSubmit: _propTypes2.default.func,
	
	  /** A comment can contain a form to reply to a comment. This may have arbitrary content. */
	  reply: _propTypes2.default.bool,
	
	  /** A form can vary in size. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** Automatically show any success Message children. */
	  success: _propTypes2.default.bool,
	
	  /** A form can prevent itself from stacking on mobile. */
	  unstackable: _propTypes2.default.bool,
	
	  /** Automatically show any warning Message children. */
	  warning: _propTypes2.default.bool,
	
	  /** Forms can automatically divide fields to be equal width. */
	  widths: _propTypes2.default.oneOf(['equal'])
	} : {};
	exports.default = Form;

/***/ },
/* 2812 */
[4476, 2811],
/* 2813 */
[4477, 1198],
/* 2814 */
[4480, 1200],
/* 2815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(74);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Icon = __webpack_require__(75);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MessageContent = __webpack_require__(1204);
	
	var _MessageContent2 = _interopRequireDefault(_MessageContent);
	
	var _MessageHeader = __webpack_require__(1205);
	
	var _MessageHeader2 = _interopRequireDefault(_MessageHeader);
	
	var _MessageList = __webpack_require__(1206);
	
	var _MessageList2 = _interopRequireDefault(_MessageList);
	
	var _MessageItem = __webpack_require__(639);
	
	var _MessageItem2 = _interopRequireDefault(_MessageItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A message displays information that explains nearby content.
	 * @see Form
	 */
	var Message = function (_Component) {
	  (0, _inherits3.default)(Message, _Component);
	
	  function Message() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Message);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Message.__proto__ || Object.getPrototypeOf(Message)).call.apply(_ref, [this].concat(args))), _this), _this.handleDismiss = function (e) {
	      var onDismiss = _this.props.onDismiss;
	
	
	      if (onDismiss) onDismiss(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Message, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          attached = _props.attached,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          compact = _props.compact,
	          content = _props.content,
	          error = _props.error,
	          floating = _props.floating,
	          header = _props.header,
	          hidden = _props.hidden,
	          icon = _props.icon,
	          info = _props.info,
	          list = _props.list,
	          negative = _props.negative,
	          onDismiss = _props.onDismiss,
	          positive = _props.positive,
	          size = _props.size,
	          success = _props.success,
	          visible = _props.visible,
	          warning = _props.warning;
	
	
	      var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(floating, 'floating'), (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(icon, 'icon'), (0, _lib.useKeyOnly)(info, 'info'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(success, 'success'), (0, _lib.useKeyOnly)(visible, 'visible'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), 'message', className);
	
	      var dismissIcon = onDismiss && _react2.default.createElement(_Icon2.default, { name: 'close', onClick: this.handleDismiss });
	      var rest = (0, _lib.getUnhandledProps)(Message, this.props);
	      var ElementType = (0, _lib.getElementType)(Message, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes }),
	          dismissIcon,
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        dismissIcon,
	        _Icon2.default.create(icon),
	        (!(0, _isNil3.default)(header) || !(0, _isNil3.default)(content) || !(0, _isNil3.default)(list)) && _react2.default.createElement(
	          _MessageContent2.default,
	          null,
	          _MessageHeader2.default.create(header),
	          _MessageList2.default.create(list),
	          (0, _lib.createHTMLParagraph)(content)
	        )
	      );
	    }
	  }]);
	  return Message;
	}(_react.Component);
	
	Message._meta = {
	  name: 'Message',
	  type: _lib.META.TYPES.COLLECTION
	};
	Message.Content = _MessageContent2.default;
	Message.Header = _MessageHeader2.default;
	Message.List = _MessageList2.default;
	Message.Item = _MessageItem2.default;
	Message.handledProps = ['as', 'attached', 'children', 'className', 'color', 'compact', 'content', 'error', 'floating', 'header', 'hidden', 'icon', 'info', 'list', 'negative', 'onDismiss', 'positive', 'size', 'success', 'visible', 'warning'];
	exports.default = Message;
	Message.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A message can be formatted to attach itself to other content. */
	  attached: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['bottom', 'top'])]),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A message can be formatted to be different colors. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** A message can only take up the width of its content. */
	  compact: _propTypes2.default.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A message may be formatted to display a negative message. Same as `negative`. */
	  error: _propTypes2.default.bool,
	
	  /** A message can float above content that it is related to. */
	  floating: _propTypes2.default.bool,
	
	  /** Shorthand for MessageHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** A message can be hidden. */
	  hidden: _propTypes2.default.bool,
	
	  /** A message can contain an icon. */
	  icon: _propTypes2.default.oneOfType([_lib.customPropTypes.itemShorthand, _propTypes2.default.bool]),
	
	  /** A message may be formatted to display information. */
	  info: _propTypes2.default.bool,
	
	  /** Array shorthand items for the MessageList. Mutually exclusive with children. */
	  list: _lib.customPropTypes.collectionShorthand,
	
	  /** A message may be formatted to display a negative message. Same as `error`. */
	  negative: _propTypes2.default.bool,
	
	  /**
	   * A message that the user can choose to hide.
	   * Called when the user clicks the "x" icon. This also adds the "x" icon.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onDismiss: _propTypes2.default.func,
	
	  /** A message may be formatted to display a positive message.  Same as `success`. */
	  positive: _propTypes2.default.bool,
	
	  /** A message can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** A message may be formatted to display a positive message.  Same as `positive`. */
	  success: _propTypes2.default.bool,
	
	  /** A message can be set to visible to force itself to be shown. */
	  visible: _propTypes2.default.bool,
	
	  /** A message may be formatted to display warning messages. */
	  warning: _propTypes2.default.bool
	} : {};

/***/ },
/* 2816 */
[4484, 2815],
/* 2817 */
[4485, 43, 69, 8, 10, 1207, 412, 1208, 640, 1209, 1210],
/* 2818 */
[4491, 2817],
/* 2819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A container limits content to a maximum width.
	 */
	function Container(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      fluid = props.fluid,
	      text = props.text,
	      textAlign = props.textAlign;
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(text, 'text'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useTextAlignProp)(textAlign), 'container', className);
	  var rest = (0, _lib.getUnhandledProps)(Container, props);
	  var ElementType = (0, _lib.getElementType)(Container, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	Container.handledProps = ['as', 'children', 'className', 'content', 'fluid', 'text', 'textAlign'];
	Container._meta = {
	  name: 'Container',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Container.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Container has no maximum width. */
	  fluid: _propTypes2.default.bool,
	
	  /** Reduce maximum width to more naturally accommodate text. */
	  text: _propTypes2.default.bool,
	
	  /** Align container text. */
	  textAlign: _propTypes2.default.oneOf(_lib.SUI.TEXT_ALIGNMENTS)
	} : {};
	
	exports.default = Container;

/***/ },
/* 2820 */
[4495, 2819],
/* 2821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A divider visually segments content into groups.
	 */
	function Divider(props) {
	  var children = props.children,
	      className = props.className,
	      clearing = props.clearing,
	      content = props.content,
	      fitted = props.fitted,
	      hidden = props.hidden,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      section = props.section,
	      vertical = props.vertical;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(clearing, 'clearing'), (0, _lib.useKeyOnly)(fitted, 'fitted'), (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(section, 'section'), (0, _lib.useKeyOnly)(vertical, 'vertical'), 'divider', className);
	  var rest = (0, _lib.getUnhandledProps)(Divider, props);
	  var ElementType = (0, _lib.getElementType)(Divider, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	Divider.handledProps = ['as', 'children', 'className', 'clearing', 'content', 'fitted', 'hidden', 'horizontal', 'inverted', 'section', 'vertical'];
	Divider._meta = {
	  name: 'Divider',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Divider.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Divider can clear the content above it. */
	  clearing: _propTypes2.default.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Divider can be fitted without any space above or below it. */
	  fitted: _propTypes2.default.bool,
	
	  /** Divider can divide content without creating a dividing line. */
	  hidden: _propTypes2.default.bool,
	
	  /** Divider can segment content horizontally. */
	  horizontal: _propTypes2.default.bool,
	
	  /** Divider can have its colours inverted. */
	  inverted: _propTypes2.default.bool,
	
	  /** Divider can provide greater margins to divide sections of content. */
	  section: _propTypes2.default.bool,
	
	  /** Divider can segment content vertically. */
	  vertical: _propTypes2.default.bool
	} : {};
	
	exports.default = Divider;

/***/ },
/* 2822 */
[4496, 2821],
/* 2823 */
[4497, 8, 10],
/* 2824 */
[4499, 43, 8, 10, 75, 247, 1217, 1216],
/* 2825 */
[4501, 2824],
/* 2826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(130);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _includes2 = __webpack_require__(149);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _map2 = __webpack_require__(69);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _get2 = __webpack_require__(109);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isNil2 = __webpack_require__(74);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Button = __webpack_require__(413);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(75);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Label = __webpack_require__(415);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An Input is a field used to elicit a response from a user.
	 * @see Button
	 * @see Form
	 * @see Icon
	 * @see Label
	 */
	var Input = function (_Component) {
	  (0, _inherits3.default)(Input, _Component);
	
	  function Input() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Input);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.computeIcon = function () {
	      var _this$props = _this.props,
	          loading = _this$props.loading,
	          icon = _this$props.icon;
	
	
	      if (!(0, _isNil3.default)(icon)) return icon;
	      if (loading) return 'spinner';
	    }, _this.computeTabIndex = function () {
	      var _this$props2 = _this.props,
	          disabled = _this$props2.disabled,
	          tabIndex = _this$props2.tabIndex;
	
	
	      if (!(0, _isNil3.default)(tabIndex)) return tabIndex;
	      if (disabled) return -1;
	    }, _this.focus = function () {
	      return _this.inputRef.focus();
	    }, _this.handleChange = function (e) {
	      var value = (0, _get3.default)(e, 'target.value');
	
	      (0, _invoke3.default)(_this.props, 'onChange', e, (0, _extends3.default)({}, _this.props, { value: value }));
	    }, _this.handleChildOverrides = function (child, defaultProps) {
	      return (0, _extends3.default)({}, defaultProps, child.props, {
	        ref: function ref(c) {
	          (0, _invoke3.default)(child, 'ref', c);
	          _this.handleInputRef(c);
	        }
	      });
	    }, _this.handleInputRef = function (c) {
	      return _this.inputRef = c;
	    }, _this.partitionProps = function () {
	      var _this$props3 = _this.props,
	          disabled = _this$props3.disabled,
	          type = _this$props3.type;
	
	
	      var tabIndex = _this.computeTabIndex();
	      var unhandled = (0, _lib.getUnhandledProps)(Input, _this.props);
	
	      var _partitionHTMLInputPr = (0, _lib.partitionHTMLInputProps)(unhandled),
	          _partitionHTMLInputPr2 = (0, _slicedToArray3.default)(_partitionHTMLInputPr, 2),
	          htmlInputProps = _partitionHTMLInputPr2[0],
	          rest = _partitionHTMLInputPr2[1];
	
	      return [(0, _extends3.default)({}, htmlInputProps, {
	        disabled: disabled,
	        type: type,
	        tabIndex: tabIndex,
	        onChange: _this.handleChange,
	        ref: _this.handleInputRef
	      }), rest];
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Input, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          action = _props.action,
	          actionPosition = _props.actionPosition,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          error = _props.error,
	          fluid = _props.fluid,
	          focus = _props.focus,
	          icon = _props.icon,
	          iconPosition = _props.iconPosition,
	          input = _props.input,
	          inverted = _props.inverted,
	          label = _props.label,
	          labelPosition = _props.labelPosition,
	          loading = _props.loading,
	          size = _props.size,
	          transparent = _props.transparent,
	          type = _props.type;
	
	
	      var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(focus, 'focus'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(transparent, 'transparent'), (0, _lib.useValueAndKey)(actionPosition, 'action') || (0, _lib.useKeyOnly)(action, 'action'), (0, _lib.useValueAndKey)(iconPosition, 'icon') || (0, _lib.useKeyOnly)(icon || loading, 'icon'), (0, _lib.useValueAndKey)(labelPosition, 'labeled') || (0, _lib.useKeyOnly)(label, 'labeled'), 'input', className);
	      var ElementType = (0, _lib.getElementType)(Input, this.props);
	
	      var _partitionProps = this.partitionProps(),
	          _partitionProps2 = (0, _slicedToArray3.default)(_partitionProps, 2),
	          htmlInputProps = _partitionProps2[0],
	          rest = _partitionProps2[1];
	
	      // Render with children
	      // ----------------------------------------
	
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        // add htmlInputProps to the `<input />` child
	        var childElements = (0, _map3.default)(_react.Children.toArray(children), function (child) {
	          if (child.type !== 'input') return child;
	          return (0, _react.cloneElement)(child, _this2.handleChildOverrides(child, htmlInputProps));
	        });
	
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes }),
	          childElements
	        );
	      }
	
	      // Render Shorthand
	      // ----------------------------------------
	      var actionElement = _Button2.default.create(action);
	      var iconElement = _Icon2.default.create(this.computeIcon());
	      var labelElement = _Label2.default.create(label, {
	        defaultProps: {
	          className: (0, _classnames2.default)('label',
	          // add 'left|right corner'
	          (0, _includes3.default)(labelPosition, 'corner') && labelPosition)
	        }
	      });
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        actionPosition === 'left' && actionElement,
	        iconPosition === 'left' && iconElement,
	        labelPosition !== 'right' && labelElement,
	        (0, _lib.createHTMLInput)(input || type, { defaultProps: htmlInputProps }),
	        actionPosition !== 'left' && actionElement,
	        iconPosition !== 'left' && iconElement,
	        labelPosition === 'right' && labelElement
	      );
	    }
	  }]);
	  return Input;
	}(_react.Component);
	
	Input.defaultProps = {
	  type: 'text'
	};
	Input._meta = {
	  name: 'Input',
	  type: _lib.META.TYPES.ELEMENT
	};
	Input.handledProps = ['action', 'actionPosition', 'as', 'children', 'className', 'disabled', 'error', 'fluid', 'focus', 'icon', 'iconPosition', 'input', 'inverted', 'label', 'labelPosition', 'loading', 'onChange', 'size', 'tabIndex', 'transparent', 'type'];
	Input.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** An Input can be formatted to alert the user to an action they may perform. */
	  action: _propTypes2.default.oneOfType([_propTypes2.default.bool, _lib.customPropTypes.itemShorthand]),
	
	  /** An action can appear along side an Input on the left or right. */
	  actionPosition: _propTypes2.default.oneOf(['left']),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** An Input field can show that it is disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** An Input field can show the data contains errors. */
	  error: _propTypes2.default.bool,
	
	  /** Take on the size of its container. */
	  fluid: _propTypes2.default.bool,
	
	  /** An Input field can show a user is currently interacting with it. */
	  focus: _propTypes2.default.bool,
	
	  /** Optional Icon to display inside the Input. */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _lib.customPropTypes.itemShorthand]),
	
	  /** An Icon can appear inside an Input on the left or right. */
	  iconPosition: _propTypes2.default.oneOf(['left']),
	
	  /** Shorthand for creating the HTML Input. */
	  input: _lib.customPropTypes.itemShorthand,
	
	  /** Format to appear on dark backgrounds. */
	  inverted: _propTypes2.default.bool,
	
	  /** Optional Label to display along side the Input. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** A Label can appear outside an Input on the left or right. */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right', 'left corner', 'right corner']),
	
	  /** An Icon Input field can show that it is currently loading data. */
	  loading: _propTypes2.default.bool,
	
	  /**
	   * Called on change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed value.
	   */
	  onChange: _propTypes2.default.func,
	
	  /** An Input can vary in size. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES),
	
	  /** An Input can receive focus. */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** Transparent Input has no background. */
	  transparent: _propTypes2.default.bool,
	
	  /** The HTML input type. */
	  type: _propTypes2.default.string
	} : {};
	
	
	Input.create = (0, _lib.createShorthandFactory)(Input, function (type) {
	  return { type: type };
	});
	
	exports.default = Input;

/***/ },
/* 2827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _map2 = __webpack_require__(69);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _ListContent = __webpack_require__(643);
	
	var _ListContent2 = _interopRequireDefault(_ListContent);
	
	var _ListDescription = __webpack_require__(416);
	
	var _ListDescription2 = _interopRequireDefault(_ListDescription);
	
	var _ListHeader = __webpack_require__(417);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _ListIcon = __webpack_require__(644);
	
	var _ListIcon2 = _interopRequireDefault(_ListIcon);
	
	var _ListItem = __webpack_require__(1223);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListList = __webpack_require__(1224);
	
	var _ListList2 = _interopRequireDefault(_ListList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list groups related content.
	 */
	var List = function (_Component) {
	  (0, _inherits3.default)(List, _Component);
	
	  function List() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, List);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e, itemProps) {
	          (0, _invoke3.default)(predefinedProps, 'onClick', e, itemProps);
	          (0, _invoke3.default)(_this.props, 'onItemClick', e, itemProps);
	        }
	      };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animated = _props.animated,
	          bulleted = _props.bulleted,
	          celled = _props.celled,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content,
	          divided = _props.divided,
	          floated = _props.floated,
	          horizontal = _props.horizontal,
	          inverted = _props.inverted,
	          items = _props.items,
	          link = _props.link,
	          ordered = _props.ordered,
	          relaxed = _props.relaxed,
	          selection = _props.selection,
	          size = _props.size,
	          verticalAlign = _props.verticalAlign;
	
	
	      var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(animated, 'animated'), (0, _lib.useKeyOnly)(bulleted, 'bulleted'), (0, _lib.useKeyOnly)(celled, 'celled'), (0, _lib.useKeyOnly)(divided, 'divided'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(ordered, 'ordered'), (0, _lib.useKeyOnly)(selection, 'selection'), (0, _lib.useKeyOrValueAndKey)(relaxed, 'relaxed'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign), 'list', className);
	      var rest = (0, _lib.getUnhandledProps)(List, this.props);
	      var ElementType = (0, _lib.getElementType)(List, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { role: 'list', className: classes }),
	          children
	        );
	      }
	
	      if (!_lib.childrenUtils.isNil(content)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { role: 'list', className: classes }),
	          content
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { role: 'list', className: classes }),
	        (0, _map3.default)(items, function (item) {
	          return _ListItem2.default.create(item, { overrideProps: _this2.handleItemOverrides });
	        })
	      );
	    }
	  }]);
	  return List;
	}(_react.Component);
	
	List._meta = {
	  name: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	List.Content = _ListContent2.default;
	List.Description = _ListDescription2.default;
	List.Header = _ListHeader2.default;
	List.Icon = _ListIcon2.default;
	List.Item = _ListItem2.default;
	List.List = _ListList2.default;
	List.handledProps = ['animated', 'as', 'bulleted', 'celled', 'children', 'className', 'content', 'divided', 'floated', 'horizontal', 'inverted', 'items', 'link', 'onItemClick', 'ordered', 'relaxed', 'selection', 'size', 'verticalAlign'];
	List.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A list can animate to set the current item apart from the list. */
	  animated: _propTypes2.default.bool,
	
	  /** A list can mark items with a bullet. */
	  bulleted: _propTypes2.default.bool,
	
	  /** A list can divide its items into cells. */
	  celled: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A list can show divisions between content. */
	  divided: _propTypes2.default.bool,
	
	  /** An list can be floated left or right. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** A list can be formatted to have items appear horizontally. */
	  horizontal: _propTypes2.default.bool,
	
	  /** A list can be inverted to appear on a dark background. */
	  inverted: _propTypes2.default.bool,
	
	  /** Shorthand array of props for ListItem. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A list can be specially formatted for navigation links. */
	  link: _propTypes2.default.bool,
	
	  /**
	   * onClick handler for ListItem. Mutually exclusive with children.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All item props.
	   */
	  onItemClick: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes2.default.func]),
	
	  /** A list can be ordered numerically. */
	  ordered: _propTypes2.default.bool,
	
	  /** A list can relax its padding to provide more negative space. */
	  relaxed: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])]),
	
	  /** A selection list formats list items as possible choices. */
	  selection: _propTypes2.default.bool,
	
	  /** A list can vary in size. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES),
	
	  /** An element inside a list can be vertically aligned. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	exports.default = List;

/***/ },
/* 2828 */
[4514, 2827],
/* 2829 */
[4515, 8, 10],
/* 2830 */
[4516, 2829],
/* 2831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A rail is used to show accompanying content outside the boundaries of the main view of a site.
	 */
	function Rail(props) {
	  var attached = props.attached,
	      children = props.children,
	      className = props.className,
	      close = props.close,
	      content = props.content,
	      dividing = props.dividing,
	      internal = props.internal,
	      position = props.position,
	      size = props.size;
	
	
	  var classes = (0, _classnames2.default)('ui', position, size, (0, _lib.useKeyOnly)(attached, 'attached'), (0, _lib.useKeyOnly)(dividing, 'dividing'), (0, _lib.useKeyOnly)(internal, 'internal'), (0, _lib.useKeyOrValueAndKey)(close, 'close'), 'rail', className);
	  var rest = (0, _lib.getUnhandledProps)(Rail, props);
	  var ElementType = (0, _lib.getElementType)(Rail, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	Rail.handledProps = ['as', 'attached', 'children', 'className', 'close', 'content', 'dividing', 'internal', 'position', 'size'];
	Rail._meta = {
	  name: 'Rail',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Rail.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A rail can appear attached to the main viewport. */
	  attached: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A rail can appear closer to the main viewport. */
	  close: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])]),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A rail can create a division between itself and a container. */
	  dividing: _propTypes2.default.bool,
	
	  /** A rail can attach itself to the inside of a container. */
	  internal: _propTypes2.default.bool,
	
	  /** A rail can be presented on the left or right side of a container. */
	  position: _propTypes2.default.oneOf(_lib.SUI.FLOATS).isRequired,
	
	  /** A rail can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : {};
	
	exports.default = Rail;

/***/ },
/* 2832 */
[4517, 2831],
/* 2833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _RevealContent = __webpack_require__(1225);
	
	var _RevealContent2 = _interopRequireDefault(_RevealContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A reveal displays additional content in place of previous content when activated.
	 */
	function Reveal(props) {
	  var active = props.active,
	      animated = props.animated,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      disabled = props.disabled,
	      instant = props.instant;
	
	
	  var classes = (0, _classnames2.default)('ui', animated, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(instant, 'instant'), 'reveal', className);
	  var rest = (0, _lib.getUnhandledProps)(Reveal, props);
	  var ElementType = (0, _lib.getElementType)(Reveal, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	Reveal.handledProps = ['active', 'animated', 'as', 'children', 'className', 'content', 'disabled', 'instant'];
	Reveal._meta = {
	  name: 'Reveal',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Reveal.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** An active reveal displays its hidden content. */
	  active: _propTypes2.default.bool,
	
	  /** An animation name that will be applied to Reveal. */
	  animated: _propTypes2.default.oneOf(['fade', 'small fade', 'move', 'move right', 'move up', 'move down', 'rotate', 'rotate left']),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A disabled reveal will not animate when hovered. */
	  disabled: _propTypes2.default.bool,
	
	  /** An element can show its content without delay. */
	  instant: _propTypes2.default.bool
	} : {};
	
	Reveal.Content = _RevealContent2.default;
	
	exports.default = Reveal;

/***/ },
/* 2834 */
[4518, 2833],
/* 2835 */
[4519, 1226],
/* 2836 */
[4520, 1228],
/* 2837 */
[4521, 1024, 407, 1037, 624, 404, 97, 2759, 178, 623, 44],
/* 2838 */
[4523, 305, 97, 648],
/* 2839 */
[4524, 178, 97, 246, 624, 1032],
/* 2840 */
[4525, 1025, 630],
/* 2841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useWidthProp = exports.useVerticalAlignProp = exports.useTextAlignProp = exports.useMultipleProp = exports.useKeyOrValueAndKey = exports.useValueAndKey = exports.useKeyOnly = undefined;
	
	var _typeof2 = __webpack_require__(131);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _numberToWord = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * There are 3 prop patterns used to build up the className for a component.
	 * Each utility here is meant for use in a classnames() argument.
	 *
	 * There is no util for valueOnly() because it would simply return val.
	 * Use the prop value inline instead.
	 *   <Label size='big' />
	 *   <div class="ui big label"></div>
	 */
	
	/**
	 * Props where only the prop key is used in the className.
	 * @param {*} val A props value
	 * @param {string} key A props key
	 *
	 * @example
	 * <Label tag />
	 * <div class="ui tag label"></div>
	 */
	var useKeyOnly = exports.useKeyOnly = function useKeyOnly(val, key) {
	  return val && key;
	};
	
	/**
	 * Props that require both a key and value to create a className.
	 * @param {*} val A props value
	 * @param {string} key A props key
	 *
	 * @example
	 * <Label corner='left' />
	 * <div class="ui left corner label"></div>
	 */
	var useValueAndKey = exports.useValueAndKey = function useValueAndKey(val, key) {
	  return val && val !== true && val + ' ' + key;
	};
	
	/**
	 * Props whose key will be used in className, or value and key.
	 * @param {*} val A props value
	 * @param {string} key A props key
	 *
	 * @example Key Only
	 * <Label pointing />
	 * <div class="ui pointing label"></div>
	 *
	 * @example Key and Value
	 * <Label pointing='left' />
	 * <div class="ui left pointing label"></div>
	 */
	var useKeyOrValueAndKey = exports.useKeyOrValueAndKey = function useKeyOrValueAndKey(val, key) {
	  return val && (val === true ? key : val + ' ' + key);
	};
	
	//
	// Prop to className exceptions
	//
	
	/**
	 * The "multiple" prop implements control of visibility and reserved classes for Grid subcomponents.
	 *
	 * @param {*} val The value of the "multiple" prop
	 * @param {*} key A props key
	 *
	 * @example
	 * <Grid.Row only='mobile' />
	 * <Grid.Row only='mobile tablet' />
	 * <div class="mobile only row"></div>
	 * <div class="mobile only tablet only row"></div>
	 */
	var useMultipleProp = exports.useMultipleProp = function useMultipleProp(val, key) {
	  if (!val || val === true) return null;
	
	  return val.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function (prop) {
	    return prop.replace('-', ' ') + ' ' + key;
	  }).join(' ');
	};
	
	/**
	 * The "textAlign" prop follows the useValueAndKey except when the value is "justified'.
	 * In this case, only the class "justified" is used, ignoring the "aligned" class.
	 * @param {*} val The value of the "textAlign" prop
	 *
	 * @example
	 * <Container textAlign='justified' />
	 * <div class="ui justified container"></div>
	 *
	 * @example
	 * <Container textAlign='left' />
	 * <div class="ui left aligned container"></div>
	 */
	var useTextAlignProp = exports.useTextAlignProp = function useTextAlignProp(val) {
	  return val === 'justified' ? 'justified' : useValueAndKey(val, 'aligned');
	};
	
	/**
	 * The "verticalAlign" prop follows the useValueAndKey.
	 *
	 * @param {*} val The value of the "verticalAlign" prop
	 *
	 * @example
	 * <Grid verticalAlign='middle' />
	 * <div class="ui middle aligned grid"></div>
	 */
	var useVerticalAlignProp = exports.useVerticalAlignProp = function useVerticalAlignProp(val) {
	  return useValueAndKey(val, 'aligned');
	};
	
	/**
	 * Create "X", "X wide" and "equal width" classNames.
	 * "X" is a numberToWord value and "wide" is configurable.
	 * @param {*} val The prop value
	 * @param {string} [widthClass=''] The class
	 * @param {boolean} [canEqual=false] Flag that indicates possibility of "equal" value
	 *
	 * @example
	 * <Grid columns='equal' />
	 * <div class="ui equal width grid"></div>
	 *
	 * <Form widths='equal' />
	 * <div class="ui equal width form"></div>
	 *
	 * <FieldGroup widths='equal' />
	 * <div class="equal width fields"></div>
	 *
	 * @example
	 * <Grid columns={4} />
	 * <div class="ui four column grid"></div>
	 */
	var useWidthProp = exports.useWidthProp = function useWidthProp(val) {
	  var widthClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var canEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (canEqual && val === 'equal') {
	    return 'equal width';
	  }
	  var valType = typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val);
	  if ((valType === 'string' || valType === 'number') && widthClass) {
	    return (0, _numberToWord.numberToWord)(val) + ' ' + widthClass;
	  }
	  return (0, _numberToWord.numberToWord)(val);
	};

/***/ },
/* 2842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deprecate = exports.collectionShorthand = exports.itemShorthand = exports.contentShorthand = exports.multipleProp = exports.demand = exports.givenProps = exports.some = exports.every = exports.disallow = exports.suggest = exports.as = undefined;
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _difference2 = __webpack_require__(2737);
	
	var _difference3 = _interopRequireDefault(_difference2);
	
	var _trim2 = __webpack_require__(2755);
	
	var _trim3 = _interopRequireDefault(_trim2);
	
	var _isObject2 = __webpack_require__(2744);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _pick2 = __webpack_require__(2750);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _keys2 = __webpack_require__(2746);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _isPlainObject2 = __webpack_require__(2745);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isFunction2 = __webpack_require__(2742);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _compact2 = __webpack_require__(2735);
	
	var _compact3 = _interopRequireDefault(_compact2);
	
	var _includes2 = __webpack_require__(1028);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _isNil2 = __webpack_require__(2743);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _take2 = __webpack_require__(2754);
	
	var _take3 = _interopRequireDefault(_take2);
	
	var _sortBy2 = __webpack_require__(2751);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _sum2 = __webpack_require__(2753);
	
	var _sum3 = _interopRequireDefault(_sum2);
	
	var _min2 = __webpack_require__(2748);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _map2 = __webpack_require__(1029);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _flow2 = __webpack_require__(401);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _memoize2 = __webpack_require__(2747);
	
	var _memoize3 = _interopRequireDefault(_memoize2);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _leven = __webpack_require__(1232);
	
	var _leven2 = _interopRequireDefault(_leven);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var typeOf = function typeOf() {
	  var _Object$prototype$toS;
	
	  return (_Object$prototype$toS = Object.prototype.toString).call.apply(_Object$prototype$toS, arguments);
	};
	
	/**
	 * Ensure a component can render as a give prop value.
	 */
	var as = exports.as = function as() {
	  return _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).apply(undefined, arguments);
	};
	
	/* eslint-disable max-nested-callbacks */
	var findBestSuggestions = (0, _memoize3.default)(function (propValueWords, suggestions) {
	  return (0, _flow3.default)((0, _map3.default)(function (suggestion) {
	    var suggestionWords = suggestion.split(' ');
	
	    var propValueScore = (0, _flow3.default)((0, _map3.default)(function (x) {
	      return (0, _map3.default)(function (y) {
	        return (0, _leven2.default)(x, y);
	      }, suggestionWords);
	    }), (0, _map3.default)(_min3.default), _sum3.default)(propValueWords);
	
	    var suggestionScore = (0, _flow3.default)((0, _map3.default)(function (x) {
	      return (0, _map3.default)(function (y) {
	        return (0, _leven2.default)(x, y);
	      }, propValueWords);
	    }), (0, _map3.default)(_min3.default), _sum3.default)(suggestionWords);
	
	    return { suggestion: suggestion, score: propValueScore + suggestionScore };
	  }), (0, _sortBy3.default)(['score', 'suggestion']), (0, _take3.default)(3))(suggestions);
	});
	/* eslint-enable max-nested-callbacks */
	
	/**
	 * Similar to PropTypes.oneOf but shows closest matches.
	 * Word order is ignored allowing `left chevron` to match `chevron left`.
	 * Useful for very large lists of options (e.g. Icon name, Flag name, etc.)
	 * @param {string[]} suggestions An array of allowed values.
	 */
	var suggest = exports.suggest = function suggest(suggestions) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(suggestions)) {
	      throw new Error(['Invalid argument supplied to suggest, expected an instance of array.', ' See `' + propName + '` prop in `' + componentName + '`.'].join(''));
	    }
	    var propValue = props[propName];
	
	    // skip if prop is undefined or is included in the suggestions
	    if ((0, _isNil3.default)(propValue) || propValue === false || (0, _includes3.default)(propValue, suggestions)) return;
	
	    // find best suggestions
	    var propValueWords = propValue.split(' ');
	    var bestMatches = findBestSuggestions(propValueWords, suggestions);
	
	    // skip if a match scored 0
	    // since we're matching on words (classNames) this allows any word order to pass validation
	    // e.g. `left chevron` vs `chevron left`
	    if (bestMatches.some(function (x) {
	      return x.score === 0;
	    })) return;
	
	    return new Error(['Invalid prop `' + propName + '` of value `' + propValue + '` supplied to `' + componentName + '`.', '\n\nInstead of `' + propValue + '`, did you mean:', bestMatches.map(function (x) {
	      return '\n  - ' + x.suggestion;
	    }).join(''), '\n'].join(''));
	  };
	};
	
	/**
	 * Disallow other props from being defined with this prop.
	 * @param {string[]} disallowedProps An array of props that cannot be used with this prop.
	 */
	var disallow = exports.disallow = function disallow(disallowedProps) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(disallowedProps)) {
	      throw new Error(['Invalid argument supplied to disallow, expected an instance of array.', ' See `' + propName + '` prop in `' + componentName + '`.'].join(''));
	    }
	
	    // skip if prop is undefined
	    if ((0, _isNil3.default)(props[propName]) || props[propName] === false) return;
	
	    // find disallowed props with values
	    var disallowed = disallowedProps.reduce(function (acc, disallowedProp) {
	      if (!(0, _isNil3.default)(props[disallowedProp]) && props[disallowedProp] !== false) {
	        return [].concat((0, _toConsumableArray3.default)(acc), [disallowedProp]);
	      }
	      return acc;
	    }, []);
	
	    if (disallowed.length > 0) {
	      return new Error(['Prop `' + propName + '` in `' + componentName + '` conflicts with props: `' + disallowed.join('`, `') + '`.', 'They cannot be defined together, choose one or the other.'].join(' '));
	    }
	  };
	};
	
	/**
	 * Ensure a prop adherers to multiple prop type validators.
	 * @param {function[]} validators An array of propType functions.
	 */
	var every = exports.every = function every(validators) {
	  return function (props, propName, componentName) {
	    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      rest[_key - 3] = arguments[_key];
	    }
	
	    if (!Array.isArray(validators)) {
	      throw new Error(['Invalid argument supplied to every, expected an instance of array.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    var errors = (0, _flow3.default)((0, _map3.default)(function (validator) {
	      if (typeof validator !== 'function') {
	        throw new Error('every() argument "validators" should contain functions, found: ' + typeOf(validator) + '.');
	      }
	      return validator.apply(undefined, [props, propName, componentName].concat(rest));
	    }), _compact3.default)(validators);
	
	    // we can only return one error at a time
	    return errors[0];
	  };
	};
	
	/**
	 * Ensure a prop adherers to at least one of the given prop type validators.
	 * @param {function[]} validators An array of propType functions.
	 */
	var some = exports.some = function some(validators) {
	  return function (props, propName, componentName) {
	    for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      rest[_key2 - 3] = arguments[_key2];
	    }
	
	    if (!Array.isArray(validators)) {
	      throw new Error(['Invalid argument supplied to some, expected an instance of array.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    var errors = (0, _compact3.default)((0, _map3.default)(validators, function (validator) {
	      if (!(0, _isFunction3.default)(validator)) {
	        throw new Error('some() argument "validators" should contain functions, found: ' + typeOf(validator) + '.');
	      }
	      return validator.apply(undefined, [props, propName, componentName].concat(rest));
	    }));
	
	    // fail only if all validators failed
	    if (errors.length === validators.length) {
	      var error = new Error('One of these validators must pass:');
	      error.message += '\n' + (0, _map3.default)(errors, function (err, i) {
	        return '[' + (i + 1) + ']: ' + err.message;
	      }).join('\n');
	      return error;
	    }
	  };
	};
	
	/**
	 * Ensure a validator passes only when a component has a given propsShape.
	 * @param {object} propsShape An object describing the prop shape.
	 * @param {function} validator A propType function.
	 */
	var givenProps = exports.givenProps = function givenProps(propsShape, validator) {
	  return function (props, propName, componentName) {
	    for (var _len3 = arguments.length, rest = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	      rest[_key3 - 3] = arguments[_key3];
	    }
	
	    if (!(0, _isPlainObject3.default)(propsShape)) {
	      throw new Error(['Invalid argument supplied to givenProps, expected an object.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    if (typeof validator !== 'function') {
	      throw new Error(['Invalid argument supplied to givenProps, expected a function.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    var shouldValidate = (0, _keys3.default)(propsShape).every(function (key) {
	      var val = propsShape[key];
	      // require propShape validators to pass or prop values to match
	      return typeof val === 'function' ? !val.apply(undefined, [props, key, componentName].concat(rest)) : val === props[propName];
	    });
	
	    if (!shouldValidate) return;
	
	    var error = validator.apply(undefined, [props, propName, componentName].concat(rest));
	
	    if (error) {
	      // poor mans shallow pretty print, prevents JSON circular reference errors
	      var prettyProps = '{ ' + (0, _keys3.default)((0, _pick3.default)((0, _keys3.default)(propsShape), props)).map(function (key) {
	        var val = props[key];
	        var renderedValue = val;
	        if (typeof val === 'string') renderedValue = '"' + val + '"';else if (Array.isArray(val)) renderedValue = '[' + val.join(', ') + ']';else if ((0, _isObject3.default)(val)) renderedValue = '{...}';
	
	        return key + ': ' + renderedValue;
	      }).join(', ') + ' }';
	
	      error.message = 'Given props ' + prettyProps + ': ' + error.message;
	      return error;
	    }
	  };
	};
	
	/**
	 * Define prop dependencies by requiring other props.
	 * @param {string[]} requiredProps An array of required prop names.
	 */
	var demand = exports.demand = function demand(requiredProps) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(requiredProps)) {
	      throw new Error(['Invalid `requiredProps` argument supplied to require, expected an instance of array.', ' See `' + propName + '` prop in `' + componentName + '`.'].join(''));
	    }
	
	    // skip if prop is undefined
	    if (props[propName] === undefined) return;
	
	    var missingRequired = requiredProps.filter(function (requiredProp) {
	      return props[requiredProp] === undefined;
	    });
	    if (missingRequired.length > 0) {
	      return new Error('`' + propName + '` prop in `' + componentName + '` requires props: `' + missingRequired.join('`, `') + '`.');
	    }
	  };
	};
	
	/**
	 * Ensure an multiple prop contains a string with only possible values.
	 * @param {string[]} possible An array of possible values to prop.
	 */
	var multipleProp = exports.multipleProp = function multipleProp(possible) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(possible)) {
	      throw new Error(['Invalid argument supplied to some, expected an instance of array.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    var propValue = props[propName];
	
	    // skip if prop is undefined
	    if ((0, _isNil3.default)(propValue) || propValue === false) return;
	
	    var values = propValue.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function (val) {
	      return (0, _trim3.default)(val).replace('-', ' ');
	    });
	    var invalid = (0, _difference3.default)(values, possible);
	
	    // fail only if there are invalid values
	    if (invalid.length > 0) {
	      return new Error('`' + propName + '` prop in `' + componentName + '` has invalid values: `' + invalid.join('`, `') + '`.');
	    }
	  };
	};
	
	/**
	 * Ensure a component can render as a node passed as a prop value in place of children.
	 */
	var contentShorthand = exports.contentShorthand = function contentShorthand() {
	  return every([disallow(['children']), _propTypes2.default.node]).apply(undefined, arguments);
	};
	
	/**
	 * Item shorthand is a description of a component that can be a literal,
	 * a props object, or an element.
	 */
	var itemShorthand = exports.itemShorthand = function itemShorthand() {
	  return every([disallow(['children']), _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object]))])]).apply(undefined, arguments);
	};
	
	/**
	 * Collection shorthand ensures a prop is an array of item shorthand.
	 */
	var collectionShorthand = exports.collectionShorthand = function collectionShorthand() {
	  return every([disallow(['children']), _propTypes2.default.arrayOf(itemShorthand)]).apply(undefined, arguments);
	};
	
	/**
	 * Show a deprecated warning for component props with a help message and optional validator.
	 * @param {string} help A help message to display with the deprecation warning.
	 * @param {function} [validator] A propType function.
	 */
	var deprecate = exports.deprecate = function deprecate(help, validator) {
	  return function (props, propName, componentName) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
	      args[_key4 - 3] = arguments[_key4];
	    }
	
	    if (typeof help !== 'string') {
	      throw new Error(['Invalid `help` argument supplied to deprecate, expected a string.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    // skip if prop is undefined
	    if (props[propName] === undefined) return;
	
	    // deprecation error and help
	    var error = new Error('The `' + propName + '` prop in `' + componentName + '` is deprecated.');
	    if (help) error.message += ' ' + help;
	
	    // add optional validation error message
	    if (validator) {
	      if (typeof validator === 'function') {
	        var validationError = validator.apply(undefined, [props, propName, componentName].concat(args));
	        if (validationError) {
	          error.message = error.message + ' ' + validationError.message;
	        }
	      } else {
	        throw new Error(['Invalid argument supplied to deprecate, expected a function.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	      }
	    }
	
	    return error;
	  };
	};

/***/ },
/* 2843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.debug = exports.makeDebugger = undefined;
	
	var _isBrowser = __webpack_require__(647);
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if ((0, _isBrowser2.default)() && ("production") !== 'production' && ("production") !== 'test') {
	  // Heads Up!
	  // https://github.com/visionmedia/debug/pull/331
	  //
	  // debug now clears storage on load, grab the debug settings before require('debug').
	  // We try/catch here as Safari throws on localStorage access in private mode or with cookies disabled.
	  var DEBUG = void 0;
	  try {
	    DEBUG = window.localStorage.debug;
	  } catch (e) {
	    /* eslint-disable no-console */
	    console.error('Semantic-UI-React could not enable debug.');
	    console.error(e);
	    /* eslint-enable no-console */
	  }
	
	  // enable what ever settings we got from storage
	}
	
	/**
	 * Create a namespaced debug function.
	 * @param {String} namespace Usually a component name.
	 * @example
	 * import { makeDebugger } from 'src/lib'
	 * const debug = makeDebugger('namespace')
	 *
	 * debug('Some message')
	 * @returns {Function}
	 */
	var makeDebugger = exports.makeDebugger = function makeDebugger(namespace) {};
	
	/**
	 * Default debugger, simple log.
	 * @example
	 * import { debug } from 'src/lib'
	 * debug('Some message')
	 */
	var debug = exports.debug = makeDebugger('log');

/***/ },
/* 2844 */
[4526, 43, 2773, 109, 631, 404, 630, 178, 47, 1033, 246],
/* 2845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _isBrowser = __webpack_require__(647);
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	var _EventTarget = __webpack_require__(2844);
	
	var _EventTarget2 = _interopRequireDefault(_EventTarget);
	
	var _normalizeTarget = __webpack_require__(2847);
	
	var _normalizeTarget2 = _interopRequireDefault(_normalizeTarget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventStack = function EventStack() {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, EventStack);
	
	  this._find = function (target) {
	    var autoCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var normalized = (0, _normalizeTarget2.default)(target);
	
	    if (_this._targets.has(normalized)) return _this._targets.get(normalized);
	    if (!autoCreate) return;
	
	    var eventTarget = new _EventTarget2.default(normalized);
	    _this._targets.set(normalized, eventTarget);
	
	    return eventTarget;
	  };
	
	  this._remove = function (target) {
	    var normalized = (0, _normalizeTarget2.default)(target);
	
	    _this._targets.delete(normalized);
	  };
	
	  this.sub = function (name, handlers) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (!(0, _isBrowser2.default)()) return;
	
	    var _options$target = options.target,
	        target = _options$target === undefined ? document : _options$target,
	        _options$pool = options.pool,
	        pool = _options$pool === undefined ? 'default' : _options$pool;
	
	    var eventTarget = _this._find(target);
	
	    eventTarget.sub(name, handlers, pool);
	  };
	
	  this.unsub = function (name, handlers) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (!(0, _isBrowser2.default)()) return;
	
	    var _options$target2 = options.target,
	        target = _options$target2 === undefined ? document : _options$target2,
	        _options$pool2 = options.pool,
	        pool = _options$pool2 === undefined ? 'default' : _options$pool2;
	
	    var eventTarget = _this._find(target, false);
	
	    if (eventTarget) {
	      eventTarget.unsub(name, handlers, pool);
	      if (eventTarget.empty()) _this._remove(target);
	    }
	  };
	
	  this._targets = new Map();
	}
	
	// ------------------------------------
	// Target utils
	// ------------------------------------
	
	// ------------------------------------
	// Pub/sub
	// ------------------------------------
	
	;
	
	var instance = new EventStack();
	
	exports.default = instance;

/***/ },
/* 2846 */
[4527, 2845],
/* 2847 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Normalizes `target` for EventStack, because `target` can be passed as `boolean` or `string`.
	 *
	 * @param {boolean|string|HTMLElement|Window} target Value for normalization.
	 * @return {HTMLElement|Window} A DOM node.
	 */
	var normalizeTarget = function normalizeTarget(target) {
	  if (target === 'document') return document;
	  if (target === 'window') return window;
	  return target || document;
	};
	
	exports.default = normalizeTarget;

/***/ },
/* 2848 */
[4528, 631, 205, 47, 405, 1031, 627, 2760, 74],
/* 2849 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Returns a createElement() type based on the props of the Component.
	 * Useful for calculating what type a component should render as.
	 *
	 * @param {function} Component A function or ReactClass.
	 * @param {object} props A ReactElement props object
	 * @param {function} [getDefault] A function that returns a default element type.
	 * @returns {string|function} A ReactElement type
	 */
	function getElementType(Component, props, getDefault) {
	  var _Component$defaultPro = Component.defaultProps,
	      defaultProps = _Component$defaultPro === undefined ? {} : _Component$defaultPro;
	
	  // ----------------------------------------
	  // user defined "as" element type
	
	  if (props.as && props.as !== defaultProps.as) return props.as;
	
	  // ----------------------------------------
	  // computed default element type
	
	  if (getDefault) {
	    var computedDefault = getDefault();
	    if (computedDefault) return computedDefault;
	  }
	
	  // ----------------------------------------
	  // infer anchor links
	
	  if (props.href) return 'a';
	
	  // ----------------------------------------
	  // use defaultProp or 'div'
	
	  return defaultProps.as || 'div';
	}
	
	exports.default = getElementType;

/***/ },
/* 2850 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Returns an object consisting of props beyond the scope of the Component.
	 * Useful for getting and spreading unknown props from the user.
	 * @param {function} Component A function or ReactClass.
	 * @param {object} props A ReactElement props object
	 * @returns {{}} A shallow copy of the prop object
	 */
	var getUnhandledProps = function getUnhandledProps(Component, props) {
	  // Note that `handledProps` are generated automatically during build with `babel-plugin-transform-react-handled-props`
	  var _Component$handledPro = Component.handledProps,
	      handledProps = _Component$handledPro === undefined ? [] : _Component$handledPro;
	
	
	  return Object.keys(props).reduce(function (acc, prop) {
	    if (prop === 'childKey') return acc;
	    if (handledProps.indexOf(prop) === -1) acc[prop] = props[prop];
	    return acc;
	  }, {});
	};
	
	exports.default = getUnhandledProps;

/***/ },
/* 2851 */
[4529, 149, 246],
/* 2852 */
[4530, 96, 1040],
/* 2853 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * Normalizes the offset value.
	 * @param {number|array} value The value to normalize.
	 * @returns {number}
	 */
	exports.default = function (value) {
	  return typeof value === 'number' || typeof value === 'string' ? [value, value] : value;
	};

/***/ },
/* 2854 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * Normalizes the duration of a transition.
	 * @param {number|object} duration The value to normalize.
	 * @param {'hide'|'show'} type The type of transition.
	 * @returns {number}
	 */
	exports.default = function (duration, type) {
	  return typeof duration === 'number' || typeof duration === 'string' ? duration : duration[type];
	};

/***/ },
/* 2855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(625);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _has2 = __webpack_require__(178);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _transform2 = __webpack_require__(2780);
	
	var _transform3 = _interopRequireDefault(_transform2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Naive and inefficient object difference, intended for development / debugging use only.
	 * Deleted keys are shown as [DELETED].
	 * @param {{}} source The source object
	 * @param {{}} target The target object.
	 * @returns {{}} A new object containing new/modified/deleted keys.
	 * @example
	 * import { objectDiff } from 'src/lib'
	 *
	 * const a = { key: 'val', foo: 'bar' }
	 * const b = { key: 'val', foo: 'baz' }
	 *
	 * objectDiff(a, b)
	 * //=> { foo: 'baz' }
	 */
	exports.default = function (source, target) {
	  return (0, _transform3.default)(source, function (res, val, key) {
	    // deleted keys
	    if (!(0, _has3.default)(target, key)) res[key] = '[DELETED]';
	    // new keys / changed values
	    // Note, we tolerate isEqual here as this is a dev only utility and not included in production code
	    else if (!(0, _isEqual3.default)(val, target[key])) res[key] = target[key];
	  }, {});
	};

/***/ },
/* 2856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _shallowEqual = __webpack_require__(208);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ },
/* 2857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _AccordionAccordion = __webpack_require__(1233);
	
	var _AccordionAccordion2 = _interopRequireDefault(_AccordionAccordion);
	
	var _AccordionContent = __webpack_require__(649);
	
	var _AccordionContent2 = _interopRequireDefault(_AccordionContent);
	
	var _AccordionTitle = __webpack_require__(650);
	
	var _AccordionTitle2 = _interopRequireDefault(_AccordionTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An accordion allows users to toggle the display of sections of content.
	 */
	function Accordion(props) {
	  var className = props.className,
	      fluid = props.fluid,
	      inverted = props.inverted,
	      styled = props.styled;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(styled, 'styled'), className);
	  var rest = (0, _lib.getUnhandledProps)(Accordion, props);
	
	  return _react2.default.createElement(_AccordionAccordion2.default, (0, _extends3.default)({}, rest, { className: classes }));
	}
	
	Accordion.handledProps = ['className', 'fluid', 'inverted', 'styled'];
	Accordion._meta = {
	  name: 'Accordion',
	  type: _lib.META.TYPES.MODULE
	};
	
	Accordion.propTypes =  false ? {
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Format to take up the width of its container. */
	  fluid: _propTypes2.default.bool,
	
	  /** Format for dark backgrounds. */
	  inverted: _propTypes2.default.bool,
	
	  /** Adds some basic styling to accordion panels. */
	  styled: _propTypes2.default.bool
	} : {};
	
	Accordion.Accordion = _AccordionAccordion2.default;
	Accordion.Content = _AccordionContent2.default;
	Accordion.Title = _AccordionTitle2.default;
	
	exports.default = Accordion;

/***/ },
/* 2858 */
[4534, 44, 74, 8, 10],
/* 2859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Portal = __webpack_require__(306);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _DimmerDimmable = __webpack_require__(1234);
	
	var _DimmerDimmable2 = _interopRequireDefault(_DimmerDimmable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A dimmer hides distractions to focus attention on particular content.
	 */
	var Dimmer = function (_Component) {
	  (0, _inherits3.default)(Dimmer, _Component);
	
	  function Dimmer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Dimmer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Dimmer.__proto__ || Object.getPrototypeOf(Dimmer)).call.apply(_ref, [this].concat(args))), _this), _this.handlePortalMount = function () {
	      if (!(0, _lib.isBrowser)()) return;
	
	      // Heads up, IE doesn't support second argument in add()
	      document.body.classList.add('dimmed');
	      document.body.classList.add('dimmable');
	    }, _this.handlePortalUnmount = function () {
	      if (!(0, _lib.isBrowser)()) return;
	
	      // Heads up, IE doesn't support second argument in add()
	      document.body.classList.remove('dimmed');
	      document.body.classList.remove('dimmable');
	    }, _this.handleClick = function (e) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          onClickOutside = _this$props.onClickOutside;
	
	
	      if (onClick) onClick(e, _this.props);
	      if (_this.centerRef && _this.centerRef !== e.target && _this.centerRef.contains(e.target)) return;
	      if (onClickOutside) onClickOutside(e, _this.props);
	    }, _this.handleCenterRef = function (c) {
	      return _this.centerRef = c;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Dimmer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content,
	          disabled = _props.disabled,
	          inverted = _props.inverted,
	          page = _props.page,
	          simple = _props.simple;
	
	
	      var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(active, 'active transition visible'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(page, 'page'), (0, _lib.useKeyOnly)(simple, 'simple'), 'dimmer', className);
	      var rest = (0, _lib.getUnhandledProps)(Dimmer, this.props);
	      var ElementType = (0, _lib.getElementType)(Dimmer, this.props);
	
	      var childrenContent = _lib.childrenUtils.isNil(children) ? content : children;
	
	      var dimmerElement = _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        childrenContent && _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'center', ref: this.handleCenterRef },
	            childrenContent
	          )
	        )
	      );
	
	      if (page) {
	        return _react2.default.createElement(
	          _Portal2.default,
	          {
	            closeOnEscape: false,
	            closeOnDocumentClick: false,
	            onMount: this.handlePortalMount,
	            onUnmount: this.handlePortalUnmount,
	            open: active,
	            openOnTriggerClick: false
	          },
	          dimmerElement
	        );
	      }
	
	      return dimmerElement;
	    }
	  }]);
	  return Dimmer;
	}(_react.Component);
	
	Dimmer._meta = {
	  name: 'Dimmer',
	  type: _lib.META.TYPES.MODULE
	};
	Dimmer.Dimmable = _DimmerDimmable2.default;
	Dimmer.handledProps = ['active', 'as', 'children', 'className', 'content', 'disabled', 'inverted', 'onClick', 'onClickOutside', 'page', 'simple'];
	exports.default = Dimmer;
	Dimmer.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** An active dimmer will dim its parent container. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A disabled dimmer cannot be activated */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Handles click outside Dimmer's content, but inside Dimmer area.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClickOutside: _propTypes2.default.func,
	
	  /** A dimmer can be formatted to have its colors inverted. */
	  inverted: _propTypes2.default.bool,
	
	  /** A dimmer can be formatted to be fixed to the page. */
	  page: _propTypes2.default.bool,
	
	  /** A dimmer can be controlled with simple prop. */
	  simple: _propTypes2.default.bool
	} : {};
	
	
	Dimmer.create = (0, _lib.createShorthandFactory)(Dimmer, function (value) {
	  return { content: value };
	});

/***/ },
/* 2860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(574);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get3 = __webpack_require__(367);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _compact2 = __webpack_require__(1021);
	
	var _compact3 = _interopRequireDefault(_compact2);
	
	var _map2 = __webpack_require__(69);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _every2 = __webpack_require__(2730);
	
	var _every3 = _interopRequireDefault(_every2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _findIndex2 = __webpack_require__(1026);
	
	var _findIndex3 = _interopRequireDefault(_findIndex2);
	
	var _find2 = __webpack_require__(1025);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _reduce2 = __webpack_require__(408);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _some2 = __webpack_require__(630);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _escapeRegExp2 = __webpack_require__(2729);
	
	var _escapeRegExp3 = _interopRequireDefault(_escapeRegExp2);
	
	var _deburr2 = __webpack_require__(1023);
	
	var _deburr3 = _interopRequireDefault(_deburr2);
	
	var _filter2 = __webpack_require__(624);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _isFunction2 = __webpack_require__(205);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _dropRight2 = __webpack_require__(2728);
	
	var _dropRight3 = _interopRequireDefault(_dropRight2);
	
	var _isEmpty2 = __webpack_require__(404);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _size2 = __webpack_require__(2774);
	
	var _size3 = _interopRequireDefault(_size2);
	
	var _union2 = __webpack_require__(2782);
	
	var _union3 = _interopRequireDefault(_union2);
	
	var _get5 = __webpack_require__(109);
	
	var _get6 = _interopRequireDefault(_get5);
	
	var _includes2 = __webpack_require__(149);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _isUndefined2 = __webpack_require__(407);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _isEqual2 = __webpack_require__(625);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _has2 = __webpack_require__(178);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _isNil2 = __webpack_require__(74);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Icon = __webpack_require__(75);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Label = __webpack_require__(415);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _DropdownDivider = __webpack_require__(1236);
	
	var _DropdownDivider2 = _interopRequireDefault(_DropdownDivider);
	
	var _DropdownItem = __webpack_require__(1238);
	
	var _DropdownItem2 = _interopRequireDefault(_DropdownItem);
	
	var _DropdownHeader = __webpack_require__(1237);
	
	var _DropdownHeader2 = _interopRequireDefault(_DropdownHeader);
	
	var _DropdownMenu = __webpack_require__(1239);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownSearchInput = __webpack_require__(1240);
	
	var _DropdownSearchInput2 = _interopRequireDefault(_DropdownSearchInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getKeyOrValue = function getKeyOrValue(key, value) {
	  return (0, _isNil3.default)(key) ? value : key;
	};
	
	/**
	 * A dropdown allows a user to select a value from a series of options.
	 * @see Form
	 * @see Select
	 * @see Menu
	 */
	
	var Dropdown = function (_Component) {
	  (0, _inherits3.default)(Dropdown, _Component);
	
	  function Dropdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Dropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e, value) {
	      (0, _invoke3.default)(_this.props, 'onChange', e, (0, _extends3.default)({}, _this.props, { value: value }));
	    }, _this.closeOnChange = function (e) {
	      var _this$props = _this.props,
	          closeOnChange = _this$props.closeOnChange,
	          multiple = _this$props.multiple;
	
	      var shouldClose = (0, _isUndefined3.default)(closeOnChange) ? !multiple : closeOnChange;
	
	      if (shouldClose) _this.close(e);
	    }, _this.closeOnEscape = function (e) {
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Escape) return;
	      e.preventDefault();
	      _this.close();
	    }, _this.moveSelectionOnKeyDown = function (e) {
	      var _moves;
	
	      var _this$props2 = _this.props,
	          multiple = _this$props2.multiple,
	          selectOnNavigation = _this$props2.selectOnNavigation;
	
	      var moves = (_moves = {}, (0, _defineProperty3.default)(_moves, _lib.keyboardKey.ArrowDown, 1), (0, _defineProperty3.default)(_moves, _lib.keyboardKey.ArrowUp, -1), _moves);
	      var move = moves[_lib.keyboardKey.getCode(e)];
	
	      if (move === undefined) return;
	      e.preventDefault();
	      _this.moveSelectionBy(move);
	      if (!multiple && selectOnNavigation) _this.makeSelectedItemActive(e);
	    }, _this.openOnSpace = function (e) {
	
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Spacebar) return;
	      if (_this.state.open) return;
	
	      e.preventDefault();
	
	      _this.open(e);
	    }, _this.openOnArrow = function (e) {
	
	      var code = _lib.keyboardKey.getCode(e);
	      if (!(0, _includes3.default)([_lib.keyboardKey.ArrowDown, _lib.keyboardKey.ArrowUp], code)) return;
	      if (_this.state.open) return;
	
	      e.preventDefault();
	
	      _this.open(e);
	    }, _this.makeSelectedItemActive = function (e) {
	      var open = _this.state.open;
	      var multiple = _this.props.multiple;
	
	
	      var item = _this.getSelectedItem();
	      var value = (0, _get6.default)(item, 'value');
	
	      // prevent selecting null if there was no selected item value
	      // prevent selecting duplicate items when the dropdown is closed
	      if ((0, _isNil3.default)(value) || !open) return;
	
	      // state value may be undefined
	      var newValue = multiple ? (0, _union3.default)(_this.state.value, [value]) : value;
	
	      // notify the onChange prop that the user is trying to change value
	      _this.setValue(newValue);
	      _this.setSelectedIndex(newValue);
	      _this.handleChange(e, newValue);
	
	      // Heads up! This event handler should be called after `onChange`
	      // Notify the onAddItem prop if this is a new value
	      if (item['data-additional']) (0, _invoke3.default)(_this.props, 'onAddItem', e, (0, _extends3.default)({}, _this.props, { value: value }));
	    }, _this.selectItemOnEnter = function (e) {
	      var search = _this.props.search;
	
	
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Enter) return;
	      e.preventDefault();
	
	      var optionSize = (0, _size3.default)(_this.getMenuOptions());
	      if (search && optionSize === 0) return;
	
	      _this.makeSelectedItemActive(e);
	      _this.closeOnChange(e);
	      _this.clearSearchQuery();
	      if (search && _this.searchRef) _this.searchRef.focus();
	    }, _this.removeItemOnBackspace = function (e) {
	      var _this$props3 = _this.props,
	          multiple = _this$props3.multiple,
	          search = _this$props3.search;
	      var _this$state = _this.state,
	          searchQuery = _this$state.searchQuery,
	          value = _this$state.value;
	
	
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Backspace) return;
	      if (searchQuery || !search || !multiple || (0, _isEmpty3.default)(value)) return;
	      e.preventDefault();
	
	      // remove most recent value
	      var newValue = (0, _dropRight3.default)(value);
	
	      _this.setValue(newValue);
	      _this.setSelectedIndex(newValue);
	      _this.handleChange(e, newValue);
	    }, _this.closeOnDocumentClick = function (e) {
	
	      if (!_this.props.closeOnBlur) return;
	
	      // If event happened in the dropdown, ignore it
	      if (_this.ref && (0, _isFunction3.default)(_this.ref.contains) && _this.ref.contains(e.target)) return;
	
	      _this.close();
	    }, _this.handleMouseDown = function (e) {
	
	      _this.isMouseDown = true;
	      _lib.eventStack.sub('mouseup', _this.handleDocumentMouseUp);
	      (0, _invoke3.default)(_this.props, 'onMouseDown', e, _this.props);
	    }, _this.handleDocumentMouseUp = function () {
	
	      _this.isMouseDown = false;
	      _lib.eventStack.unsub('mouseup', _this.handleDocumentMouseUp);
	    }, _this.handleClick = function (e) {
	      var _this$props4 = _this.props,
	          minCharacters = _this$props4.minCharacters,
	          search = _this$props4.search;
	      var _this$state2 = _this.state,
	          open = _this$state2.open,
	          searchQuery = _this$state2.searchQuery;
	
	
	      (0, _invoke3.default)(_this.props, 'onClick', e, _this.props);
	      // prevent closeOnDocumentClick()
	      e.stopPropagation();
	
	      if (!search) return _this.toggle(e);
	      if (open) return;
	      if (searchQuery.length >= minCharacters || minCharacters === 1) {
	        _this.open(e);
	        return;
	      }
	      if (_this.searchRef) _this.searchRef.focus();
	    }, _this.handleIconClick = function (e) {
	
	      (0, _invoke3.default)(_this.props, 'onClick', e, _this.props);
	      // prevent handleClick()
	      e.stopPropagation();
	      _this.toggle(e);
	    }, _this.handleItemClick = function (e, item) {
	      var _this$props5 = _this.props,
	          multiple = _this$props5.multiple,
	          search = _this$props5.search;
	      var value = item.value;
	
	      // prevent toggle() in handleClick()
	
	      e.stopPropagation();
	      // prevent closeOnDocumentClick() if multiple or item is disabled
	      if (multiple || item.disabled) e.nativeEvent.stopImmediatePropagation();
	      if (item.disabled) return;
	
	      var isAdditionItem = item['data-additional'];
	      var newValue = multiple ? (0, _union3.default)(_this.state.value, [value]) : value;
	
	      // notify the onChange prop that the user is trying to change value
	      _this.setValue(newValue);
	      _this.setSelectedIndex(value);
	
	      var optionSize = (0, _size3.default)(_this.getMenuOptions());
	      if (!multiple || isAdditionItem || optionSize === 1) _this.clearSearchQuery();
	
	      _this.handleChange(e, newValue);
	      _this.closeOnChange(e);
	
	      // Heads up! This event handler should be called after `onChange`
	      // Notify the onAddItem prop if this is a new value
	      if (isAdditionItem) (0, _invoke3.default)(_this.props, 'onAddItem', e, (0, _extends3.default)({}, _this.props, { value: value }));
	
	      if (multiple && search && _this.searchRef) _this.searchRef.focus();
	    }, _this.handleFocus = function (e) {
	      var focus = _this.state.focus;
	
	
	      if (focus) return;
	
	      (0, _invoke3.default)(_this.props, 'onFocus', e, _this.props);
	      _this.setState({ focus: true });
	    }, _this.handleBlur = function (e) {
	
	      // Heads up! Don't remove this.
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/1315
	      var currentTarget = (0, _get6.default)(e, 'currentTarget');
	      if (currentTarget && currentTarget.contains(document.activeElement)) return;
	
	      var _this$props6 = _this.props,
	          closeOnBlur = _this$props6.closeOnBlur,
	          multiple = _this$props6.multiple,
	          onBlur = _this$props6.onBlur,
	          selectOnBlur = _this$props6.selectOnBlur;
	      // do not "blur" when the mouse is down inside of the Dropdown
	
	      if (_this.isMouseDown) return;
	      if (onBlur) onBlur(e, _this.props);
	      if (selectOnBlur && !multiple) {
	        _this.makeSelectedItemActive(e);
	        if (closeOnBlur) _this.close();
	      }
	      _this.setState({ focus: false });
	      _this.clearSearchQuery();
	    }, _this.handleSearchChange = function (e, _ref2) {
	      var value = _ref2.value;
	
	
	      // prevent propagating to this.props.onChange()
	      e.stopPropagation();
	
	      var minCharacters = _this.props.minCharacters;
	      var open = _this.state.open;
	
	      var newQuery = value;
	
	      (0, _invoke3.default)(_this.props, 'onSearchChange', e, (0, _extends3.default)({}, _this.props, { searchQuery: newQuery }));
	      _this.trySetState({ searchQuery: newQuery }, { selectedIndex: 0 });
	
	      // open search dropdown on search query
	      if (!open && newQuery.length >= minCharacters) {
	        _this.open();
	        return;
	      }
	      // close search dropdown if search query is too small
	      if (open && minCharacters !== 1 && newQuery.length < minCharacters) _this.close();
	    }, _this.getMenuOptions = function () {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
	      var _this$props7 = _this.props,
	          additionLabel = _this$props7.additionLabel,
	          additionPosition = _this$props7.additionPosition,
	          allowAdditions = _this$props7.allowAdditions,
	          deburr = _this$props7.deburr,
	          multiple = _this$props7.multiple,
	          search = _this$props7.search;
	      var searchQuery = _this.state.searchQuery;
	
	
	      var filteredOptions = options;
	
	      // filter out active options
	      if (multiple) {
	        filteredOptions = (0, _filter3.default)(filteredOptions, function (opt) {
	          return !(0, _includes3.default)(value, opt.value);
	        });
	      }
	
	      // filter by search query
	      if (search && searchQuery) {
	        if ((0, _isFunction3.default)(search)) {
	          filteredOptions = search(filteredOptions, searchQuery);
	        } else {
	          // remove diacritics on search input and options, if deburr prop is set
	          var strippedQuery = deburr ? (0, _deburr3.default)(searchQuery) : searchQuery;
	
	          var re = new RegExp((0, _escapeRegExp3.default)(strippedQuery), 'i');
	
	          filteredOptions = (0, _filter3.default)(filteredOptions, function (opt) {
	            return re.test(deburr ? (0, _deburr3.default)(opt.text) : opt.text);
	          });
	        }
	      }
	
	      // insert the "add" item
	      if (allowAdditions && search && searchQuery && !(0, _some3.default)(filteredOptions, { text: searchQuery })) {
	        var additionLabelElement = _react2.default.isValidElement(additionLabel) ? _react2.default.cloneElement(additionLabel, { key: 'addition-label' }) : additionLabel || '';
	
	        var addItem = {
	          key: 'addition',
	          // by using an array, we can pass multiple elements, but when doing so
	          // we must specify a `key` for React to know which one is which
	          text: [additionLabelElement, _react2.default.createElement(
	            'b',
	            { key: 'addition-query' },
	            searchQuery
	          )],
	          value: searchQuery,
	          className: 'addition',
	          'data-additional': true
	        };
	        if (additionPosition === 'top') filteredOptions.unshift(addItem);else filteredOptions.push(addItem);
	      }
	
	      return filteredOptions;
	    }, _this.getSelectedItem = function () {
	      var selectedIndex = _this.state.selectedIndex;
	
	      var options = _this.getMenuOptions();
	
	      return (0, _get6.default)(options, '[' + selectedIndex + ']');
	    }, _this.getEnabledIndices = function (givenOptions) {
	      var options = givenOptions || _this.getMenuOptions();
	
	      return (0, _reduce3.default)(options, function (memo, item, index) {
	        if (!item.disabled) memo.push(index);
	        return memo;
	      }, []);
	    }, _this.getItemByValue = function (value) {
	      var options = _this.props.options;
	
	
	      return (0, _find3.default)(options, { value: value });
	    }, _this.getMenuItemIndexByValue = function (value, givenOptions) {
	      var options = givenOptions || _this.getMenuOptions();
	
	      return (0, _findIndex3.default)(options, ['value', value]);
	    }, _this.getDropdownAriaOptions = function () {
	      var _this$props8 = _this.props,
	          loading = _this$props8.loading,
	          disabled = _this$props8.disabled,
	          search = _this$props8.search,
	          multiple = _this$props8.multiple;
	      var open = _this.state.open;
	
	      var ariaOptions = {
	        role: search ? 'combobox' : 'listbox',
	        'aria-busy': loading,
	        'aria-disabled': disabled,
	        'aria-expanded': !!open
	      };
	      if (ariaOptions.role === 'listbox') {
	        ariaOptions['aria-multiselectable'] = multiple;
	      }
	      return ariaOptions;
	    }, _this.clearSearchQuery = function () {
	      _this.trySetState({ searchQuery: '' });
	    }, _this.setValue = function (value) {
	      _this.trySetState({ value: value });
	    }, _this.setSelectedIndex = function () {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
	      var optionsProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
	      var multiple = _this.props.multiple;
	      var selectedIndex = _this.state.selectedIndex;
	
	      var options = _this.getMenuOptions(value, optionsProps);
	      var enabledIndicies = _this.getEnabledIndices(options);
	
	      var newSelectedIndex = void 0;
	
	      // update the selected index
	      if (!selectedIndex || selectedIndex < 0) {
	        var firstIndex = enabledIndicies[0];
	
	        // Select the currently active item, if none, use the first item.
	        // Multiple selects remove active items from the list,
	        // their initial selected index should be 0.
	        newSelectedIndex = multiple ? firstIndex : _this.getMenuItemIndexByValue(value, options) || enabledIndicies[0];
	      } else if (multiple) {
	        // multiple selects remove options from the menu as they are made active
	        // keep the selected index within range of the remaining items
	        if (selectedIndex >= options.length - 1) {
	          newSelectedIndex = enabledIndicies[enabledIndicies.length - 1];
	        }
	      } else {
	        var activeIndex = _this.getMenuItemIndexByValue(value, options);
	
	        // regular selects can only have one active item
	        // set the selected index to the currently active item
	        newSelectedIndex = (0, _includes3.default)(enabledIndicies, activeIndex) ? activeIndex : undefined;
	      }
	
	      if (!newSelectedIndex || newSelectedIndex < 0) {
	        newSelectedIndex = enabledIndicies[0];
	      }
	
	      _this.setState({ selectedIndex: newSelectedIndex });
	    }, _this.handleLabelClick = function (e, labelProps) {
	      // prevent focusing search input on click
	      e.stopPropagation();
	
	      _this.setState({ selectedLabel: labelProps.value });
	
	      var onLabelClick = _this.props.onLabelClick;
	
	      if (onLabelClick) onLabelClick(e, labelProps);
	    }, _this.handleLabelRemove = function (e, labelProps) {
	      // prevent focusing search input on click
	      e.stopPropagation();
	      var value = _this.state.value;
	
	      var newValue = (0, _without3.default)(value, labelProps.value);
	
	
	      _this.setValue(newValue);
	      _this.setSelectedIndex(newValue);
	      _this.handleChange(e, newValue);
	    }, _this.moveSelectionBy = function (offset) {
	      var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.selectedIndex;
	
	
	      var options = _this.getMenuOptions();
	
	      // Prevent infinite loop
	      // TODO: remove left part of condition after children API will be removed
	      if (options === undefined || (0, _every3.default)(options, 'disabled')) return;
	
	      var lastIndex = options.length - 1;
	      // next is after last, wrap to beginning
	      // next is before first, wrap to end
	      var nextIndex = startIndex + offset;
	      if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;
	
	      if (options[nextIndex].disabled) {
	        _this.moveSelectionBy(offset, nextIndex);
	        return;
	      }
	
	      _this.setState({ selectedIndex: nextIndex });
	      _this.scrollSelectedItemIntoView();
	    }, _this.handleIconOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e) {
	          (0, _invoke3.default)(predefinedProps, 'onClick', e, predefinedProps);
	          _this.handleIconClick(e);
	        }
	      };
	    }, _this.handleSearchRef = function (c) {
	      return _this.searchRef = c;
	    }, _this.handleSizerRef = function (c) {
	      return _this.sizerRef = c;
	    }, _this.handleRef = function (c) {
	      return _this.ref = c;
	    }, _this.computeSearchInputTabIndex = function () {
	      var _this$props9 = _this.props,
	          disabled = _this$props9.disabled,
	          tabIndex = _this$props9.tabIndex;
	
	
	      if (!(0, _isNil3.default)(tabIndex)) return tabIndex;
	      return disabled ? -1 : 0;
	    }, _this.computeSearchInputWidth = function () {
	      var searchQuery = _this.state.searchQuery;
	
	
	      if (_this.sizerRef && searchQuery) {
	        // resize the search input, temporarily show the sizer so we can measure it
	
	        _this.sizerRef.style.display = 'inline';
	        _this.sizerRef.textContent = searchQuery;
	        var searchWidth = Math.ceil(_this.sizerRef.getBoundingClientRect().width);
	        _this.sizerRef.style.removeProperty('display');
	
	        return searchWidth;
	      }
	    }, _this.computeTabIndex = function () {
	      var _this$props10 = _this.props,
	          disabled = _this$props10.disabled,
	          search = _this$props10.search,
	          tabIndex = _this$props10.tabIndex;
	
	      // don't set a root node tabIndex as the search input has its own tabIndex
	
	      if (search) return undefined;
	      if (disabled) return -1;
	      return (0, _isNil3.default)(tabIndex) ? 0 : tabIndex;
	    }, _this.scrollSelectedItemIntoView = function () {
	      if (!_this.ref) return;
	      var menu = _this.ref.querySelector('.menu.visible');
	      if (!menu) return;
	      var item = menu.querySelector('.item.selected');
	      if (!item) return;
	
	      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
	      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;
	
	      if (isOutOfUpperView) {
	        menu.scrollTop = item.offsetTop;
	      } else if (isOutOfLowerView) {
	        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
	      }
	    }, _this.open = function (e) {
	      var _this$props11 = _this.props,
	          disabled = _this$props11.disabled,
	          onOpen = _this$props11.onOpen,
	          search = _this$props11.search;
	
	      if (disabled) return;
	      if (search && _this.searchRef) _this.searchRef.focus();
	      if (onOpen) onOpen(e, _this.props);
	
	      _this.trySetState({ open: true });
	      _this.scrollSelectedItemIntoView();
	    }, _this.close = function (e) {
	      var onClose = _this.props.onClose;
	
	      if (onClose) onClose(e, _this.props);
	
	      _this.trySetState({ open: false });
	    }, _this.handleClose = function () {
	      var hasSearchFocus = document.activeElement === _this.searchRef;
	      var hasDropdownFocus = document.activeElement === _this.ref;
	      var hasFocus = hasSearchFocus || hasDropdownFocus;
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/627
	      // Blur the Dropdown on close so it is blurred after selecting an item.
	      // This is to prevent it from re-opening when switching tabs after selecting an item.
	      if (!hasSearchFocus) {
	        _this.ref.blur();
	      }
	
	      // We need to keep the virtual model in sync with the browser focus change
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/692
	      _this.setState({ focus: hasFocus });
	    }, _this.toggle = function (e) {
	      return _this.state.open ? _this.close(e) : _this.open(e);
	    }, _this.renderText = function () {
	      var _this$props12 = _this.props,
	          multiple = _this$props12.multiple,
	          placeholder = _this$props12.placeholder,
	          search = _this$props12.search,
	          text = _this$props12.text;
	      var _this$state3 = _this.state,
	          searchQuery = _this$state3.searchQuery,
	          value = _this$state3.value,
	          open = _this$state3.open;
	
	      var hasValue = multiple ? !(0, _isEmpty3.default)(value) : !(0, _isNil3.default)(value) && value !== '';
	
	      var classes = (0, _classnames2.default)(placeholder && !hasValue && 'default', 'text', search && searchQuery && 'filtered');
	      var _text = placeholder;
	      if (searchQuery) {
	        _text = null;
	      } else if (text) {
	        _text = text;
	      } else if (open && !multiple) {
	        _text = (0, _get6.default)(_this.getSelectedItem(), 'text');
	      } else if (hasValue) {
	        _text = (0, _get6.default)(_this.getItemByValue(value), 'text');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes, role: 'alert', 'aria-live': 'polite' },
	        _text
	      );
	    }, _this.renderSearchInput = function () {
	      var _this$props13 = _this.props,
	          search = _this$props13.search,
	          searchInput = _this$props13.searchInput;
	      var searchQuery = _this.state.searchQuery;
	
	
	      if (!search) return null;
	      return _DropdownSearchInput2.default.create(searchInput, { defaultProps: {
	          inputRef: _this.handleSearchRef,
	          onChange: _this.handleSearchChange,
	          style: { width: _this.computeSearchInputWidth() },
	          tabIndex: _this.computeSearchInputTabIndex(),
	          value: searchQuery
	        } });
	    }, _this.renderSearchSizer = function () {
	      var _this$props14 = _this.props,
	          search = _this$props14.search,
	          multiple = _this$props14.multiple;
	
	
	      if (!(search && multiple)) return null;
	      return _react2.default.createElement('span', { className: 'sizer', ref: _this.handleSizerRef });
	    }, _this.renderLabels = function () {
	      var _this$props15 = _this.props,
	          multiple = _this$props15.multiple,
	          renderLabel = _this$props15.renderLabel;
	      var _this$state4 = _this.state,
	          selectedLabel = _this$state4.selectedLabel,
	          value = _this$state4.value;
	
	      if (!multiple || (0, _isEmpty3.default)(value)) {
	        return;
	      }
	      var selectedItems = (0, _map3.default)(value, _this.getItemByValue);
	
	
	      // if no item could be found for a given state value the selected item will be undefined
	      // compact the selectedItems so we only have actual objects left
	      return (0, _map3.default)((0, _compact3.default)(selectedItems), function (item, index) {
	        var defaultProps = {
	          active: item.value === selectedLabel,
	          as: 'a',
	          key: getKeyOrValue(item.key, item.value),
	          onClick: _this.handleLabelClick,
	          onRemove: _this.handleLabelRemove,
	          value: item.value
	        };
	
	        return _Label2.default.create(renderLabel(item, index, defaultProps), { defaultProps: defaultProps });
	      });
	    }, _this.renderOptions = function () {
	      var _this$props16 = _this.props,
	          multiple = _this$props16.multiple,
	          search = _this$props16.search,
	          noResultsMessage = _this$props16.noResultsMessage;
	      var _this$state5 = _this.state,
	          selectedIndex = _this$state5.selectedIndex,
	          value = _this$state5.value;
	
	      var options = _this.getMenuOptions();
	
	      if (noResultsMessage !== null && search && (0, _isEmpty3.default)(options)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'message' },
	          noResultsMessage
	        );
	      }
	
	      var isActive = multiple ? function (optValue) {
	        return (0, _includes3.default)(value, optValue);
	      } : function (optValue) {
	        return optValue === value;
	      };
	
	      return (0, _map3.default)(options, function (opt, i) {
	        return _DropdownItem2.default.create((0, _extends3.default)({
	          active: isActive(opt.value),
	          onClick: _this.handleItemClick,
	          selected: selectedIndex === i
	        }, opt, {
	          key: getKeyOrValue(opt.key, opt.value),
	          // Needed for handling click events on disabled items
	          style: (0, _extends3.default)({}, opt.style, { pointerEvents: 'all' })
	        }));
	      });
	    }, _this.renderMenu = function () {
	      var _this$props17 = _this.props,
	          children = _this$props17.children,
	          header = _this$props17.header;
	      var open = _this.state.open;
	
	      var menuClasses = open ? 'visible' : '';
	      var ariaOptions = _this.getDropdownMenuAriaOptions();
	
	      // single menu child
	      if (!_lib.childrenUtils.isNil(children)) {
	        var menuChild = _react.Children.only(children);
	        var className = (0, _classnames2.default)(menuClasses, menuChild.props.className);
	
	        return (0, _react.cloneElement)(menuChild, (0, _extends3.default)({ className: className }, ariaOptions));
	      }
	
	      return _react2.default.createElement(
	        _DropdownMenu2.default,
	        (0, _extends3.default)({}, ariaOptions, { className: menuClasses }),
	        _DropdownHeader2.default.create(header),
	        _this.renderOptions()
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Dropdown, [{
	    key: 'getInitialAutoControlledState',
	    value: function getInitialAutoControlledState() {
	      return { searchQuery: '' };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _state = this.state,
	          open = _state.open,
	          value = _state.value;
	
	
	      this.setValue(value);
	      this.setSelectedIndex(value);
	
	      if (open) this.open();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get4.default)(Dropdown.prototype.__proto__ || Object.getPrototypeOf(Dropdown.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
	
	
	      /* eslint-disable no-console */
	      if (false) {
	        // in development, validate value type matches dropdown type
	        var isNextValueArray = Array.isArray(nextProps.value);
	        var hasValue = (0, _has3.default)(nextProps, 'value');
	
	        if (hasValue && nextProps.multiple && !isNextValueArray) {
	          console.error('Dropdown `value` must be an array when `multiple` is set.' + (' Received type: `' + Object.prototype.toString.call(nextProps.value) + '`.'));
	        } else if (hasValue && !nextProps.multiple && isNextValueArray) {
	          console.error('Dropdown `value` must not be an array when `multiple` is not set.' + ' Either set `multiple={true}` or use a string or number value.');
	        }
	      }
	      /* eslint-enable no-console */
	
	      if (!(0, _lib.shallowEqual)(nextProps.value, this.props.value)) {
	        this.setValue(nextProps.value);
	        this.setSelectedIndex(nextProps.value);
	      }
	
	      if (!(0, _isEqual3.default)(nextProps.options, this.props.options)) {
	        this.setSelectedIndex(undefined, nextProps.options);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _lib.shallowEqual)(nextProps, this.props) || !(0, _lib.shallowEqual)(nextState, this.state);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	
	      // focused / blurred
	      // eslint-disable-line complexity
	      if (!prevState.focus && this.state.focus) {
	        if (!this.isMouseDown) {
	          var _props = this.props,
	              minCharacters = _props.minCharacters,
	              openOnFocus = _props.openOnFocus,
	              search = _props.search;
	
	          var openable = !search || search && minCharacters === 1;
	
	          if (openOnFocus && openable) this.open();
	        }
	        if (!this.state.open) {
	          _lib.eventStack.sub('keydown', [this.openOnArrow, this.openOnSpace]);
	        } else {
	          _lib.eventStack.sub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	        }
	        _lib.eventStack.sub('keydown', this.removeItemOnBackspace);
	      } else if (prevState.focus && !this.state.focus) {
	        var closeOnBlur = this.props.closeOnBlur;
	
	        if (!this.isMouseDown && closeOnBlur) {
	          this.close();
	        }
	        _lib.eventStack.unsub('keydown', [this.openOnArrow, this.openOnSpace, this.moveSelectionOnKeyDown, this.selectItemOnEnter, this.removeItemOnBackspace]);
	      }
	
	      // opened / closed
	      if (!prevState.open && this.state.open) {
	        _lib.eventStack.sub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter, this.removeItemOnBackspace]);
	        _lib.eventStack.sub('click', this.closeOnDocumentClick);
	        _lib.eventStack.unsub('keydown', [this.openOnArrow, this.openOnSpace]);
	        this.scrollSelectedItemIntoView();
	      } else if (prevState.open && !this.state.open) {
	        this.handleClose();
	        _lib.eventStack.unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	        _lib.eventStack.unsub('click', this.closeOnDocumentClick);
	        if (!this.state.focus) {
	          _lib.eventStack.unsub('keydown', this.removeItemOnBackspace);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	
	      _lib.eventStack.unsub('keydown', [this.openOnArrow, this.openOnSpace, this.moveSelectionOnKeyDown, this.selectItemOnEnter, this.removeItemOnBackspace, this.closeOnEscape]);
	      _lib.eventStack.unsub('click', this.closeOnDocumentClick);
	    }
	
	    // ----------------------------------------
	    // Document Event Handlers
	    // ----------------------------------------
	
	    // onChange needs to receive a value
	    // can't rely on props.value if we are controlled
	
	
	    // ----------------------------------------
	    // Component Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Getters
	    // ----------------------------------------
	
	    // There are times when we need to calculate the options based on a value
	    // that hasn't yet been persisted to state.
	
	  }, {
	    key: 'getDropdownMenuAriaOptions',
	    value: function getDropdownMenuAriaOptions() {
	      var _props2 = this.props,
	          search = _props2.search,
	          multiple = _props2.multiple;
	
	      var ariaOptions = {};
	
	      if (search) {
	        ariaOptions['aria-multiselectable'] = multiple;
	        ariaOptions.role = 'listbox';
	      }
	      return ariaOptions;
	    }
	
	    // ----------------------------------------
	    // Setters
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Overrides
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Refs
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Helpers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Behavior
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          basic = _props3.basic,
	          button = _props3.button,
	          className = _props3.className,
	          compact = _props3.compact,
	          disabled = _props3.disabled,
	          error = _props3.error,
	          fluid = _props3.fluid,
	          floating = _props3.floating,
	          icon = _props3.icon,
	          inline = _props3.inline,
	          item = _props3.item,
	          labeled = _props3.labeled,
	          loading = _props3.loading,
	          multiple = _props3.multiple,
	          pointing = _props3.pointing,
	          search = _props3.search,
	          selection = _props3.selection,
	          scrolling = _props3.scrolling,
	          simple = _props3.simple,
	          trigger = _props3.trigger,
	          upward = _props3.upward;
	      var open = this.state.open;
	
	      // Classes
	
	      var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(open, 'active visible'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(button, 'button'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(floating, 'floating'), (0, _lib.useKeyOnly)(inline, 'inline'),
	      // TODO: consider augmentation to render Dropdowns as Button/Menu, solves icon/link item issues
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/401#issuecomment-240487229
	      // TODO: the icon class is only required when a dropdown is a button
	      // useKeyOnly(icon, 'icon'),
	      (0, _lib.useKeyOnly)(labeled, 'labeled'), (0, _lib.useKeyOnly)(item, 'item'), (0, _lib.useKeyOnly)(multiple, 'multiple'), (0, _lib.useKeyOnly)(search, 'search'), (0, _lib.useKeyOnly)(selection, 'selection'), (0, _lib.useKeyOnly)(simple, 'simple'), (0, _lib.useKeyOnly)(scrolling, 'scrolling'), (0, _lib.useKeyOnly)(upward, 'upward'), (0, _lib.useKeyOrValueAndKey)(pointing, 'pointing'), 'dropdown', className);
	      var rest = (0, _lib.getUnhandledProps)(Dropdown, this.props);
	      var ElementType = (0, _lib.getElementType)(Dropdown, this.props);
	      var ariaOptions = this.getDropdownAriaOptions(ElementType, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, ariaOptions, {
	          className: classes,
	          onBlur: this.handleBlur,
	          onClick: this.handleClick,
	          onMouseDown: this.handleMouseDown,
	          onFocus: this.handleFocus,
	          onChange: this.handleChange,
	          tabIndex: this.computeTabIndex(),
	          ref: this.handleRef
	        }),
	        this.renderLabels(),
	        this.renderSearchInput(),
	        this.renderSearchSizer(),
	        trigger || this.renderText(),
	        _Icon2.default.create(icon, {
	          overrideProps: this.handleIconOverrides
	        }),
	        this.renderMenu()
	      );
	    }
	  }]);
	  return Dropdown;
	}(_lib.AutoControlledComponent);
	
	Dropdown.defaultProps = {
	  additionLabel: 'Add ',
	  additionPosition: 'top',
	  closeOnBlur: true,
	  deburr: false,
	  icon: 'dropdown',
	  minCharacters: 1,
	  noResultsMessage: 'No results found.',
	  openOnFocus: true,
	  renderLabel: function renderLabel(_ref3) {
	    var text = _ref3.text;
	    return text;
	  },
	  searchInput: 'text',
	  selectOnBlur: true,
	  selectOnNavigation: true
	};
	Dropdown.autoControlledProps = ['open', 'searchQuery', 'selectedLabel', 'value'];
	Dropdown._meta = {
	  name: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	Dropdown.Divider = _DropdownDivider2.default;
	Dropdown.Header = _DropdownHeader2.default;
	Dropdown.Item = _DropdownItem2.default;
	Dropdown.Menu = _DropdownMenu2.default;
	Dropdown.SearchInput = _DropdownSearchInput2.default;
	Dropdown.handledProps = ['additionLabel', 'additionPosition', 'allowAdditions', 'as', 'basic', 'button', 'children', 'className', 'closeOnBlur', 'closeOnChange', 'compact', 'deburr', 'defaultOpen', 'defaultSearchQuery', 'defaultSelectedLabel', 'defaultValue', 'disabled', 'error', 'floating', 'fluid', 'header', 'icon', 'inline', 'item', 'labeled', 'loading', 'minCharacters', 'multiple', 'noResultsMessage', 'onAddItem', 'onBlur', 'onChange', 'onClick', 'onClose', 'onFocus', 'onLabelClick', 'onMouseDown', 'onOpen', 'onSearchChange', 'open', 'openOnFocus', 'options', 'placeholder', 'pointing', 'renderLabel', 'scrolling', 'search', 'searchInput', 'searchQuery', 'selectOnBlur', 'selectOnNavigation', 'selectedLabel', 'selection', 'simple', 'tabIndex', 'text', 'trigger', 'upward', 'value'];
	exports.default = Dropdown;
	Dropdown.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Label prefixed to an option added by a user. */
	  additionLabel: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
	
	  /** Position of the `Add: ...` option in the dropdown list ('top' or 'bottom'). */
	  additionPosition: _propTypes2.default.oneOf(['top', 'bottom']),
	
	  /**
	   * Allow user additions to the list of options (boolean).
	   * Requires the use of `selection`, `options` and `search`.
	   */
	  allowAdditions: _lib.customPropTypes.every([_lib.customPropTypes.demand(['options', 'selection', 'search']), _propTypes2.default.bool]),
	
	  /** A Dropdown can reduce its complexity. */
	  basic: _propTypes2.default.bool,
	
	  /** Format the Dropdown to appear as a button. */
	  button: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['options', 'selection']), _lib.customPropTypes.givenProps({ children: _propTypes2.default.any.isRequired }, _propTypes2.default.element.isRequired)]),
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Whether or not the menu should close when the dropdown is blurred. */
	  closeOnBlur: _propTypes2.default.bool,
	
	  /**
	   * Whether or not the menu should close when a value is selected from the dropdown.
	   * By default, multiple selection dropdowns will remain open on change, while single
	   * selection dropdowns will close on change.
	   */
	  closeOnChange: _propTypes2.default.bool,
	
	  /** A compact dropdown has no minimum width. */
	  compact: _propTypes2.default.bool,
	
	  /** Whether or not the dropdown should strip diacritics in options and input search */
	  deburr: _propTypes2.default.bool,
	
	  /** Initial value of open. */
	  defaultOpen: _propTypes2.default.bool,
	
	  /** Initial value of searchQuery. */
	  defaultSearchQuery: _propTypes2.default.string,
	
	  /** Currently selected label in multi-select. */
	  defaultSelectedLabel: _lib.customPropTypes.every([_lib.customPropTypes.demand(['multiple']), _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])]),
	
	  /** Initial value or value array if multiple. */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))]),
	
	  /** A disabled dropdown menu or item does not allow user interaction. */
	  disabled: _propTypes2.default.bool,
	
	  /** An errored dropdown can alert a user to a problem. */
	  error: _propTypes2.default.bool,
	
	  /** A dropdown menu can contain floated content. */
	  floating: _propTypes2.default.bool,
	
	  /** A dropdown can take the full width of its parent */
	  fluid: _propTypes2.default.bool,
	
	  /** A dropdown menu can contain a header. */
	  header: _propTypes2.default.node,
	
	  /** Shorthand for Icon. */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object]),
	
	  /** A dropdown can be formatted to appear inline in other content. */
	  inline: _propTypes2.default.bool,
	
	  /** A dropdown can be formatted as a Menu item. */
	  item: _propTypes2.default.bool,
	
	  /** A dropdown can be labeled. */
	  labeled: _propTypes2.default.bool,
	
	  /** A dropdown can show that it is currently loading data. */
	  loading: _propTypes2.default.bool,
	
	  /** The minimum characters for a search to begin showing results. */
	  minCharacters: _propTypes2.default.number,
	
	  /** A selection dropdown can allow multiple selections. */
	  multiple: _propTypes2.default.bool,
	
	  /** Message to display when there are no results. */
	  noResultsMessage: _propTypes2.default.string,
	
	  /**
	   * Called when a user adds a new item. Use this to update the options list.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and the new item's value.
	   */
	  onAddItem: _propTypes2.default.func,
	
	  /**
	   * Called on blur.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * Called when the user attempts to change the value.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed value.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * Called on focus.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * Called when a multi-select label is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All label props.
	   */
	  onLabelClick: _propTypes2.default.func,
	
	  /**
	   * Called on mousedown.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * Called on search input change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props, includes current value of searchQuery.
	   */
	  onSearchChange: _propTypes2.default.func,
	
	  /** Controls whether or not the dropdown menu is displayed. */
	  open: _propTypes2.default.bool,
	
	  /** Whether or not the menu should open when the dropdown is focused. */
	  openOnFocus: _propTypes2.default.bool,
	
	  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
	  options: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes2.default.arrayOf(_propTypes2.default.shape(_DropdownItem2.default.propTypes))]),
	
	  /** Placeholder text. */
	  placeholder: _propTypes2.default.string,
	
	  /** A dropdown can be formatted so that its menu is pointing. */
	  pointing: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['left', 'right', 'top', 'top left', 'top right', 'bottom', 'bottom left', 'bottom right'])]),
	
	  /**
	   * Mapped over the active items and returns shorthand for the active item Labels.
	   * Only applies to `multiple` Dropdowns.
	   *
	   * @param {object} item - A currently active dropdown item.
	   * @param {number} index - The current index.
	   * @param {object} defaultLabelProps - The default props for an active item Label.
	   * @returns {*} Shorthand for a Label.
	   */
	  renderLabel: _propTypes2.default.func,
	
	  /** A dropdown can have its menu scroll. */
	  scrolling: _propTypes2.default.bool,
	
	  /**
	   * A selection dropdown can allow a user to search through a large list of choices.
	   * Pass a function here to replace the default search.
	   */
	  search: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
	
	  /** A shorthand for a search input. */
	  searchInput: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.node, _propTypes2.default.object]),
	
	  /** Current value of searchQuery. Creates a controlled component. */
	  searchQuery: _propTypes2.default.string,
	
	  // TODO 'searchInMenu' or 'search='in menu' or ???  How to handle this markup and functionality?
	
	  /** Define whether the highlighted item should be selected on blur. */
	  selectOnBlur: _propTypes2.default.bool,
	
	  /**
	   * Whether or not to change the value when navigating the menu using arrow keys.
	   * Setting to false will require enter or left click to confirm a choice.
	   */
	  selectOnNavigation: _propTypes2.default.bool,
	
	  /** Currently selected label in multi-select. */
	  selectedLabel: _lib.customPropTypes.every([_lib.customPropTypes.demand(['multiple']), _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])]),
	
	  /** A dropdown can be used to select between choices in a form. */
	  selection: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _lib.customPropTypes.demand(['options']), _propTypes2.default.bool]),
	
	  /** A simple dropdown can open without Javascript. */
	  simple: _propTypes2.default.bool,
	
	  /** A dropdown can receive focus. */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** The text displayed in the dropdown, usually for the active item. */
	  text: _propTypes2.default.string,
	
	  /** Custom element to trigger the menu to become visible. Takes place of 'text'. */
	  trigger: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['selection', 'text']), _propTypes2.default.node]),
	
	  /** Current value or value array if multiple. Creates a controlled component. */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))]),
	
	  /** A dropdown can open upward. */
	  upward: _propTypes2.default.bool
	} : {};

/***/ },
/* 2861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Icon = __webpack_require__(75);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An embed displays content from other websites like YouTube videos or Google Maps.
	 */
	var Embed = function (_Component) {
	  (0, _inherits3.default)(Embed, _Component);
	
	  function Embed() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Embed);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Embed.__proto__ || Object.getPrototypeOf(Embed)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	      var active = _this.state.active;
	
	
	      if (onClick) onClick(e, (0, _extends3.default)({}, _this.props, { active: true }));
	      if (!active) _this.trySetState({ active: true });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Embed, [{
	    key: 'getSrc',
	    value: function getSrc() {
	      var _props = this.props,
	          _props$autoplay = _props.autoplay,
	          autoplay = _props$autoplay === undefined ? true : _props$autoplay,
	          _props$brandedUI = _props.brandedUI,
	          brandedUI = _props$brandedUI === undefined ? false : _props$brandedUI,
	          _props$color = _props.color,
	          color = _props$color === undefined ? '#444444' : _props$color,
	          _props$hd = _props.hd,
	          hd = _props$hd === undefined ? true : _props$hd,
	          id = _props.id,
	          source = _props.source,
	          url = _props.url;
	
	
	      if (source === 'youtube') {
	        return ['//www.youtube.com/embed/' + id, '?autohide=true', '&amp;autoplay=' + autoplay, '&amp;color=' + encodeURIComponent(color), '&amp;hq=' + hd, '&amp;jsapi=false', '&amp;modestbranding=' + brandedUI].join('');
	      }
	
	      if (source === 'vimeo') {
	        return ['//player.vimeo.com/video/' + id, '?api=false', '&amp;autoplay=' + autoplay, '&amp;byline=false', '&amp;color=' + encodeURIComponent(color), '&amp;portrait=false', '&amp;title=false'].join('');
	      }
	
	      return url;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          aspectRatio = _props2.aspectRatio,
	          className = _props2.className,
	          icon = _props2.icon,
	          placeholder = _props2.placeholder;
	      var active = this.state.active;
	
	
	      var classes = (0, _classnames2.default)('ui', aspectRatio, (0, _lib.useKeyOnly)(active, 'active'), 'embed', className);
	      var rest = (0, _lib.getUnhandledProps)(Embed, this.props);
	      var ElementType = (0, _lib.getElementType)(Embed, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        _Icon2.default.create(icon),
	        placeholder && _react2.default.createElement('img', { className: 'placeholder', src: placeholder }),
	        this.renderEmbed()
	      );
	    }
	  }, {
	    key: 'renderEmbed',
	    value: function renderEmbed() {
	      var _props3 = this.props,
	          children = _props3.children,
	          content = _props3.content,
	          iframe = _props3.iframe,
	          source = _props3.source;
	      var active = this.state.active;
	
	
	      if (!active) return null;
	      if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	        'div',
	        { className: 'embed' },
	        children
	      );
	      if (!_lib.childrenUtils.isNil(content)) return _react2.default.createElement(
	        'div',
	        { className: 'embed' },
	        content
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'embed' },
	        (0, _lib.createHTMLIframe)(_lib.childrenUtils.isNil(iframe) ? this.getSrc() : iframe, {
	          defaultProps: {
	            allowFullScreen: false,
	            frameBorder: 0,
	            height: '100%',
	            scrolling: 'no',
	            src: this.getSrc(),
	            title: 'Embedded content from ' + source + '.',
	            width: '100%'
	          }
	        })
	      );
	    }
	  }]);
	  return Embed;
	}(_lib.AutoControlledComponent);
	
	Embed.autoControlledProps = ['active'];
	Embed.defaultProps = {
	  icon: 'video play'
	};
	Embed._meta = {
	  name: 'Embed',
	  type: _lib.META.TYPES.MODULE
	};
	Embed.handledProps = ['active', 'as', 'aspectRatio', 'autoplay', 'brandedUI', 'children', 'className', 'color', 'content', 'defaultActive', 'hd', 'icon', 'id', 'iframe', 'onClick', 'placeholder', 'source', 'url'];
	exports.default = Embed;
	Embed.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** An embed can be active. */
	  active: _propTypes2.default.bool,
	
	  /** An embed can specify an alternative aspect ratio. */
	  aspectRatio: _propTypes2.default.oneOf(['4:3', '16:9', '21:9']),
	
	  /** Setting to true or false will force autoplay. */
	  autoplay: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes2.default.bool]),
	
	  /** Whether to show networks branded UI like title cards, or after video calls to action. */
	  brandedUI: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes2.default.bool]),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Specifies a default chrome color with Vimeo or YouTube. */
	  color: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes2.default.string]),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Initial value of active. */
	  defaultActive: _propTypes2.default.bool,
	
	  /** Whether to show networks branded UI like title cards, or after video calls to action. */
	  hd: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes2.default.bool]),
	
	  /** Specifies an icon to use with placeholder content. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** Specifies an id for source. */
	  id: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes2.default.string]),
	
	  /** Shorthand for HTML iframe. */
	  iframe: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _lib.customPropTypes.itemShorthand]),
	
	  /**
	   * Сalled on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed value.
	   */
	  onClick: _propTypes2.default.func,
	
	  /** A placeholder image for embed. */
	  placeholder: _propTypes2.default.string,
	
	  /** Specifies a source to use. */
	  source: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['sourceUrl']), _propTypes2.default.oneOf(['youtube', 'vimeo'])]),
	
	  /** Specifies a url to use for embed. */
	  url: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['source']), _propTypes2.default.string])
	} : {};

/***/ },
/* 2862 */
[4541, 2861],
/* 2863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _pick2 = __webpack_require__(629);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _includes2 = __webpack_require__(149);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _reduce2 = __webpack_require__(408);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Icon = __webpack_require__(75);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Portal = __webpack_require__(306);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalHeader = __webpack_require__(1244);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalContent = __webpack_require__(1242);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _ModalActions = __webpack_require__(1241);
	
	var _ModalActions2 = _interopRequireDefault(_ModalActions);
	
	var _ModalDescription = __webpack_require__(1243);
	
	var _ModalDescription2 = _interopRequireDefault(_ModalDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A modal displays content that temporarily blocks interactions with the main view of a site.
	 * @see Confirm
	 * @see Portal
	 */
	var Modal = function (_Component) {
	  (0, _inherits3.default)(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.getMountNode = function () {
	      return (0, _lib.isBrowser)() ? _this.props.mountNode || document.body : null;
	    }, _this.handleActionsOverrides = function (predefinedProps) {
	      return {
	        onActionClick: function onActionClick(e, actionProps) {
	          (0, _invoke3.default)(predefinedProps, 'onActionClick', e, actionProps);
	          (0, _invoke3.default)(_this.props, 'onActionClick', e, _this.props);
	
	          _this.handleClose(e);
	        }
	      };
	    }, _this.handleClose = function (e) {
	
	      (0, _invoke3.default)(_this.props, 'onClose', e, _this.props);
	      _this.trySetState({ open: false });
	    }, _this.handleIconOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e) {
	          (0, _invoke3.default)(predefinedProps, 'onClick', e);
	          _this.handleClose(e);
	        }
	      };
	    }, _this.handleOpen = function (e) {
	
	      (0, _invoke3.default)(_this.props, 'onOpen', e, _this.props);
	      _this.trySetState({ open: true });
	    }, _this.handlePortalMount = function (e) {
	
	      _this.setState({ scrolling: false });
	      _this.setPositionAndClassNames();
	
	      (0, _invoke3.default)(_this.props, 'onMount', e, _this.props);
	    }, _this.handlePortalUnmount = function (e) {
	
	      // Always remove all dimmer classes.
	      // If the dimmer value changes while the modal is open, then removing its
	      // current value could leave cruft classes previously added.
	      var mountNode = _this.getMountNode();
	
	      // Heads up, IE doesn't support second argument in remove()
	      mountNode.classList.remove('blurring');
	      mountNode.classList.remove('dimmable');
	      mountNode.classList.remove('dimmed');
	      mountNode.classList.remove('scrolling');
	
	      cancelAnimationFrame(_this.animationRequestId);
	      (0, _invoke3.default)(_this.props, 'onUnmount', e, _this.props);
	    }, _this.handleRef = function (c) {
	      return _this.ref = c;
	    }, _this.setPositionAndClassNames = function () {
	      var dimmer = _this.props.dimmer;
	
	      var mountNode = _this.getMountNode();
	
	      if (dimmer) {
	        mountNode.classList.add('dimmable');
	        mountNode.classList.add('dimmed');
	
	        if (dimmer === 'blurring') {
	          mountNode.classList.add('blurring');
	        }
	      }
	
	      if (_this.ref) {
	        var _this$ref$getBounding = _this.ref.getBoundingClientRect(),
	            height = _this$ref$getBounding.height;
	
	        var marginTop = -Math.round(height / 2);
	        var scrolling = height >= window.innerHeight;
	
	        var newState = {};
	
	        if (_this.state.marginTop !== marginTop) {
	          newState.marginTop = marginTop;
	        }
	
	        if (_this.state.scrolling !== scrolling) {
	          newState.scrolling = scrolling;
	
	          if (scrolling) {
	            mountNode.classList.add('scrolling');
	          } else {
	            mountNode.classList.remove('scrolling');
	          }
	        }
	
	        if (Object.keys(newState).length > 0) _this.setState(newState);
	      }
	
	      _this.animationRequestId = requestAnimationFrame(_this.setPositionAndClassNames);
	    }, _this.renderContent = function (rest) {
	      var _this$props = _this.props,
	          actions = _this$props.actions,
	          basic = _this$props.basic,
	          children = _this$props.children,
	          className = _this$props.className,
	          closeIcon = _this$props.closeIcon,
	          content = _this$props.content,
	          header = _this$props.header,
	          size = _this$props.size,
	          style = _this$props.style;
	      var _this$state = _this.state,
	          marginTop = _this$state.marginTop,
	          scrolling = _this$state.scrolling;
	
	
	      var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(scrolling, 'scrolling'), 'modal transition visible active', className);
	      var ElementType = (0, _lib.getElementType)(Modal, _this.props);
	
	      var closeIconName = closeIcon === true ? 'close' : closeIcon;
	      var closeIconJSX = _Icon2.default.create(closeIconName, { overrideProps: _this.handleIconOverrides });
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, style: (0, _extends3.default)({ marginTop: marginTop }, style), ref: _this.handleRef }),
	          closeIconJSX,
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, style: (0, _extends3.default)({ marginTop: marginTop }, style), ref: _this.handleRef }),
	        closeIconJSX,
	        _ModalHeader2.default.create(header),
	        _ModalContent2.default.create(content),
	        _ModalActions2.default.create(actions, { overrideProps: _this.handleActionsOverrides })
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Modal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handlePortalUnmount();
	    }
	
	    // Do not access document when server side rendering
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var open = this.state.open;
	      var _props = this.props,
	          closeOnDimmerClick = _props.closeOnDimmerClick,
	          closeOnDocumentClick = _props.closeOnDocumentClick,
	          dimmer = _props.dimmer,
	          eventPool = _props.eventPool,
	          trigger = _props.trigger;
	
	      var mountNode = this.getMountNode();
	
	      // Short circuit when server side rendering
	      if (!(0, _lib.isBrowser)()) {
	        return (0, _react.isValidElement)(trigger) ? trigger : null;
	      }
	
	      var unhandled = (0, _lib.getUnhandledProps)(Modal, this.props);
	      var portalPropNames = _Portal2.default.handledProps;
	
	      var rest = (0, _reduce3.default)(unhandled, function (acc, val, key) {
	        if (!(0, _includes3.default)(portalPropNames, key)) acc[key] = val;
	
	        return acc;
	      }, {});
	      var portalProps = (0, _pick3.default)(unhandled, portalPropNames);
	
	      // wrap dimmer modals
	      var dimmerClasses = !dimmer ? null : (0, _classnames2.default)('ui', dimmer === 'inverted' && 'inverted', 'page modals dimmer transition visible active');
	
	      // Heads up!
	      //
	      // The SUI CSS selector to prevent the modal itself from blurring requires an immediate .dimmer child:
	      // .blurring.dimmed.dimmable>:not(.dimmer) { ... }
	      //
	      // The .blurring.dimmed.dimmable is the body, so that all body content inside is blurred.
	      // We need the immediate child to be the dimmer to :not() blur the modal itself!
	      // Otherwise, the portal div is also blurred, blurring the modal.
	      //
	      // We cannot them wrap the modalJSX in an actual <Dimmer /> instead, we apply the dimmer classes to the <Portal />.
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        (0, _extends3.default)({
	          closeOnDocumentClick: closeOnDocumentClick,
	          closeOnRootNodeClick: closeOnDimmerClick
	        }, portalProps, {
	          trigger: trigger,
	          className: dimmerClasses,
	          eventPool: eventPool,
	          mountNode: mountNode,
	          open: open,
	          onClose: this.handleClose,
	          onMount: this.handlePortalMount,
	          onOpen: this.handleOpen,
	          onUnmount: this.handlePortalUnmount
	        }),
	        this.renderContent(rest)
	      );
	    }
	  }]);
	  return Modal;
	}(_lib.AutoControlledComponent);
	
	Modal.defaultProps = {
	  dimmer: true,
	  closeOnDimmerClick: true,
	  closeOnDocumentClick: false,
	  eventPool: 'Modal'
	};
	Modal.autoControlledProps = ['open'];
	Modal._meta = {
	  name: 'Modal',
	  type: _lib.META.TYPES.MODULE
	};
	Modal.Header = _ModalHeader2.default;
	Modal.Content = _ModalContent2.default;
	Modal.Description = _ModalDescription2.default;
	Modal.Actions = _ModalActions2.default;
	Modal.handledProps = ['actions', 'as', 'basic', 'children', 'className', 'closeIcon', 'closeOnDimmerClick', 'closeOnDocumentClick', 'content', 'defaultOpen', 'dimmer', 'eventPool', 'header', 'mountNode', 'onActionClick', 'onClose', 'onMount', 'onOpen', 'onUnmount', 'open', 'size', 'style', 'trigger'];
	Modal.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Shorthand for Modal.Actions. Typically an array of button shorthand. */
	  actions: _lib.customPropTypes.itemShorthand,
	
	  /** A modal can reduce its complexity */
	  basic: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for the close icon. Closes the modal on click. */
	  closeIcon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object, _propTypes2.default.bool]),
	
	  /** Whether or not the Modal should close when the dimmer is clicked. */
	  closeOnDimmerClick: _propTypes2.default.bool,
	
	  /** Whether or not the Modal should close when the document is clicked. */
	  closeOnDocumentClick: _propTypes2.default.bool,
	
	  /** Simple text content for the Modal. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** Initial value of open. */
	  defaultOpen: _propTypes2.default.bool,
	
	  /** A Modal can appear in a dimmer. */
	  dimmer: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['inverted', 'blurring'])]),
	
	  /** Event pool namespace that is used to handle component events */
	  eventPool: _propTypes2.default.string,
	
	  /** Modal displayed above the content in bold. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** The node where the modal should mount. Defaults to document.body. */
	  mountNode: _propTypes2.default.any,
	
	  /**
	   * Action onClick handler when using shorthand `actions`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onActionClick: _propTypes2.default.func,
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * Called when the portal is mounted on the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _propTypes2.default.func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * Called when the portal is unmounted from the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _propTypes2.default.func,
	
	  /** Controls whether or not the Modal is displayed. */
	  open: _propTypes2.default.bool,
	
	  /** A modal can vary in size */
	  size: _propTypes2.default.oneOf(['fullscreen', 'large', 'mini', 'small', 'tiny']),
	
	  /** Custom styles. */
	  style: _propTypes2.default.object,
	
	  /** Element to be rendered in-place where the portal is defined. */
	  trigger: _propTypes2.default.node
	
	  /**
	   * NOTE: Any unhandled props that are defined in Portal are passed-through
	   * to the wrapping Portal.
	   */
	} : {};
	exports.default = Modal;

/***/ },
/* 2864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.POSITIONS = undefined;
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _pick2 = __webpack_require__(629);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _reduce2 = __webpack_require__(408);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _assign2 = __webpack_require__(2724);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _isArray2 = __webpack_require__(47);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _mapValues2 = __webpack_require__(1034);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _isNumber2 = __webpack_require__(1031);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _includes2 = __webpack_require__(149);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Portal = __webpack_require__(306);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _PopupContent = __webpack_require__(1246);
	
	var _PopupContent2 = _interopRequireDefault(_PopupContent);
	
	var _PopupHeader = __webpack_require__(1247);
	
	var _PopupHeader2 = _interopRequireDefault(_PopupHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var POSITIONS = exports.POSITIONS = ['top left', 'top right', 'bottom right', 'bottom left', 'right center', 'left center', 'top center', 'bottom center'];
	
	/**
	 * A Popup displays additional information on top of a page.
	 */
	
	var Popup = function (_Component) {
	  (0, _inherits3.default)(Popup, _Component);
	
	  function Popup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Popup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Popup.__proto__ || Object.getPrototypeOf(Popup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.hideOnScroll = function (e) {
	      _this.setState({ closed: true });
	
	      _lib.eventStack.unsub('scroll', _this.hideOnScroll, { target: window });
	      setTimeout(function () {
	        return _this.setState({ closed: false });
	      }, 50);
	
	      _this.handleClose(e);
	    }, _this.handleClose = function (e) {
	
	      (0, _invoke3.default)(_this.props, 'onClose', e, _this.props);
	    }, _this.handleOpen = function (e) {
	      _this.coords = e.currentTarget.getBoundingClientRect();
	
	      var onOpen = _this.props.onOpen;
	
	      if (onOpen) onOpen(e, _this.props);
	    }, _this.handlePortalMount = function (e) {
	      var hideOnScroll = _this.props.hideOnScroll;
	
	
	      if (hideOnScroll) _lib.eventStack.sub('scroll', _this.hideOnScroll, { target: window });
	      (0, _invoke3.default)(_this.props, 'onMount', e, _this.props);
	    }, _this.handlePortalUnmount = function (e) {
	      var hideOnScroll = _this.props.hideOnScroll;
	
	
	      if (hideOnScroll) _lib.eventStack.unsub('scroll', _this.hideOnScroll, { target: window });
	      (0, _invoke3.default)(_this.props, 'onUnmount', e, _this.props);
	    }, _this.handlePopupRef = function (popupRef) {
	      _this.popupCoords = popupRef ? popupRef.getBoundingClientRect() : null;
	      _this.setPopupStyle();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Popup, [{
	    key: 'computePopupStyle',
	    value: function computePopupStyle(positions) {
	      var style = { position: 'absolute'
	
	        // Do not access window/document when server side rendering
	      };if (!(0, _lib.isBrowser)()) return style;
	
	      var offset = this.props.offset;
	      var _window = window,
	          pageYOffset = _window.pageYOffset,
	          pageXOffset = _window.pageXOffset;
	      var _document$documentEle = document.documentElement,
	          clientWidth = _document$documentEle.clientWidth,
	          clientHeight = _document$documentEle.clientHeight;
	
	
	      if ((0, _includes3.default)(positions, 'right')) {
	        style.right = Math.round(clientWidth - (this.coords.right + pageXOffset));
	        style.left = 'auto';
	      } else if ((0, _includes3.default)(positions, 'left')) {
	        style.left = Math.round(this.coords.left + pageXOffset);
	        style.right = 'auto';
	      } else {
	        // if not left nor right, we are horizontally centering the element
	        var xOffset = (this.coords.width - this.popupCoords.width) / 2;
	        style.left = Math.round(this.coords.left + xOffset + pageXOffset);
	        style.right = 'auto';
	      }
	
	      if ((0, _includes3.default)(positions, 'top')) {
	        style.bottom = Math.round(clientHeight - (this.coords.top + pageYOffset));
	        style.top = 'auto';
	      } else if ((0, _includes3.default)(positions, 'bottom')) {
	        style.top = Math.round(this.coords.bottom + pageYOffset);
	        style.bottom = 'auto';
	      } else {
	        // if not top nor bottom, we are vertically centering the element
	        var yOffset = (this.coords.height + this.popupCoords.height) / 2;
	        style.top = Math.round(this.coords.bottom + pageYOffset - yOffset);
	        style.bottom = 'auto';
	
	        var _xOffset = this.popupCoords.width + 8;
	        if ((0, _includes3.default)(positions, 'right')) {
	          style.right -= _xOffset;
	        } else {
	          style.left -= _xOffset;
	        }
	      }
	
	      if (offset) {
	        if ((0, _isNumber3.default)(style.right)) {
	          style.right -= offset;
	        } else {
	          style.left -= offset;
	        }
	      }
	
	      return style;
	    }
	
	    // check if the style would display
	    // the popup outside of the view port
	
	  }, {
	    key: 'isStyleInViewport',
	    value: function isStyleInViewport(style) {
	      var _window2 = window,
	          pageYOffset = _window2.pageYOffset,
	          pageXOffset = _window2.pageXOffset;
	      var _document$documentEle2 = document.documentElement,
	          clientWidth = _document$documentEle2.clientWidth,
	          clientHeight = _document$documentEle2.clientHeight;
	
	
	      var element = {
	        top: style.top,
	        left: style.left,
	        width: this.popupCoords.width,
	        height: this.popupCoords.height
	      };
	      if ((0, _isNumber3.default)(style.right)) {
	        element.left = clientWidth - style.right - element.width;
	      }
	      if ((0, _isNumber3.default)(style.bottom)) {
	        element.top = clientHeight - style.bottom - element.height;
	      }
	
	      // hidden on top
	      if (element.top < pageYOffset) return false;
	      // hidden on the bottom
	      if (element.top + element.height > pageYOffset + clientHeight) return false;
	      // hidden the left
	      if (element.left < pageXOffset) return false;
	      // hidden on the right
	      if (element.left + element.width > pageXOffset + clientWidth) return false;
	
	      return true;
	    }
	  }, {
	    key: 'setPopupStyle',
	    value: function setPopupStyle() {
	      if (!this.coords || !this.popupCoords) return;
	      var position = this.props.position;
	      var style = this.computePopupStyle(position);
	
	      // Lets detect if the popup is out of the viewport and adjust
	      // the position accordingly
	      var positions = (0, _without3.default)(POSITIONS, position).concat([position]);
	      for (var i = 0; !this.isStyleInViewport(style) && i < positions.length; i += 1) {
	        style = this.computePopupStyle(positions[i]);
	        position = positions[i];
	      }
	
	      // Append 'px' to every numerical values in the style
	      style = (0, _mapValues3.default)(style, function (value) {
	        return (0, _isNumber3.default)(value) ? value + 'px' : value;
	      });
	      this.setState({ style: style, position: position });
	    }
	  }, {
	    key: 'getPortalProps',
	    value: function getPortalProps() {
	      var portalProps = {};
	
	      var _props = this.props,
	          on = _props.on,
	          hoverable = _props.hoverable;
	
	      var normalizedOn = (0, _isArray3.default)(on) ? on : [on];
	
	      if (hoverable) {
	        portalProps.closeOnPortalMouseLeave = true;
	        portalProps.mouseLeaveDelay = 300;
	      }
	      if ((0, _includes3.default)(normalizedOn, 'click')) {
	        portalProps.openOnTriggerClick = true;
	        portalProps.closeOnTriggerClick = true;
	        portalProps.closeOnDocumentClick = true;
	      }
	      if ((0, _includes3.default)(normalizedOn, 'focus')) {
	        portalProps.openOnTriggerFocus = true;
	        portalProps.closeOnTriggerBlur = true;
	      }
	      if ((0, _includes3.default)(normalizedOn, 'hover')) {
	        portalProps.openOnTriggerMouseEnter = true;
	        portalProps.closeOnTriggerMouseLeave = true;
	        // Taken from SUI: https://git.io/vPmCm
	        portalProps.mouseLeaveDelay = 70;
	        portalProps.mouseEnterDelay = 50;
	      }
	
	      return portalProps;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          basic = _props2.basic,
	          children = _props2.children,
	          className = _props2.className,
	          content = _props2.content,
	          flowing = _props2.flowing,
	          header = _props2.header,
	          inverted = _props2.inverted,
	          size = _props2.size,
	          trigger = _props2.trigger,
	          wide = _props2.wide;
	      var _state = this.state,
	          position = _state.position,
	          closed = _state.closed;
	
	      var style = (0, _assign3.default)({}, this.state.style, this.props.style);
	      var classes = (0, _classnames2.default)('ui', position, size, (0, _lib.useKeyOrValueAndKey)(wide, 'wide'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(flowing, 'flowing'), (0, _lib.useKeyOnly)(inverted, 'inverted'), 'popup transition visible', className);
	
	      if (closed) return trigger;
	
	      var unhandled = (0, _lib.getUnhandledProps)(Popup, this.props);
	      var portalPropNames = _Portal2.default.handledProps;
	
	      var rest = (0, _reduce3.default)(unhandled, function (acc, val, key) {
	        if (!(0, _includes3.default)(portalPropNames, key)) acc[key] = val;
	
	        return acc;
	      }, {});
	      var portalProps = (0, _pick3.default)(unhandled, portalPropNames);
	      var ElementType = (0, _lib.getElementType)(Popup, this.props);
	
	      var popupJSX = _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, style: style, ref: this.handlePopupRef }),
	        children,
	        _lib.childrenUtils.isNil(children) && _PopupHeader2.default.create(header),
	        _lib.childrenUtils.isNil(children) && _PopupContent2.default.create(content)
	      );
	
	      var mergedPortalProps = (0, _extends3.default)({}, this.getPortalProps(), portalProps);
	
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        (0, _extends3.default)({}, mergedPortalProps, {
	          trigger: trigger,
	          onClose: this.handleClose,
	          onMount: this.handlePortalMount,
	          onOpen: this.handleOpen,
	          onUnmount: this.handlePortalUnmount
	        }),
	        popupJSX
	      );
	    }
	  }]);
	  return Popup;
	}(_react.Component);
	
	Popup.defaultProps = {
	  position: 'top left',
	  on: 'hover'
	};
	Popup._meta = {
	  name: 'Popup',
	  type: _lib.META.TYPES.MODULE
	};
	Popup.Content = _PopupContent2.default;
	Popup.Header = _PopupHeader2.default;
	Popup.handledProps = ['as', 'basic', 'children', 'className', 'content', 'flowing', 'header', 'hideOnScroll', 'hoverable', 'inverted', 'offset', 'on', 'onClose', 'onMount', 'onOpen', 'onUnmount', 'position', 'size', 'style', 'trigger', 'wide'];
	exports.default = Popup;
	Popup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Display the popup without the pointing arrow. */
	  basic: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Simple text content for the popover. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** A flowing Popup has no maximum width and continues to flow to fit its content. */
	  flowing: _propTypes2.default.bool,
	
	  /** Takes up the entire width of its offset container. */
	  // TODO: implement the Popup fluid layout
	  // fluid: PropTypes.bool,
	
	  /** Header displayed above the content in bold. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Hide the Popup when scrolling the window. */
	  hideOnScroll: _propTypes2.default.bool,
	
	  /** Whether the popup should not close on hover. */
	  hoverable: _propTypes2.default.bool,
	
	  /** Invert the colors of the Popup. */
	  inverted: _propTypes2.default.bool,
	
	  /** Horizontal offset in pixels to be applied to the Popup. */
	  offset: _propTypes2.default.number,
	
	  /** Events triggering the popup. */
	  on: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['hover', 'click', 'focus']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['hover', 'click', 'focus']))]),
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * Called when the portal is mounted on the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _propTypes2.default.func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * Called when the portal is unmounted from the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _propTypes2.default.func,
	
	  /** Position for the popover. */
	  position: _propTypes2.default.oneOf(POSITIONS),
	
	  /** Popup size. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium', 'big', 'massive')),
	
	  /** Custom Popup style. */
	  style: _propTypes2.default.object,
	
	  /** Element to be rendered in-place where the popup is defined. */
	  trigger: _propTypes2.default.node,
	
	  /** Popup width. */
	  wide: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])])
	} : {};

/***/ },
/* 2865 */
[4545, 2864],
/* 2866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _round2 = __webpack_require__(2772);
	
	var _round3 = _interopRequireDefault(_round2);
	
	var _clamp2 = __webpack_require__(2725);
	
	var _clamp3 = _interopRequireDefault(_clamp2);
	
	var _isUndefined2 = __webpack_require__(407);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A progress bar shows the progression of a task.
	 */
	var Progress = function (_Component) {
	  (0, _inherits3.default)(Progress, _Component);
	
	  function Progress() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Progress);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Progress.__proto__ || Object.getPrototypeOf(Progress)).call.apply(_ref, [this].concat(args))), _this), _this.calculatePercent = function () {
	      var _this$props = _this.props,
	          percent = _this$props.percent,
	          total = _this$props.total,
	          value = _this$props.value;
	
	
	      if (!(0, _isUndefined3.default)(percent)) return percent;
	      if (!(0, _isUndefined3.default)(total) && !(0, _isUndefined3.default)(value)) return value / total * 100;
	    }, _this.getPercent = function () {
	      var precision = _this.props.precision;
	
	      var percent = (0, _clamp3.default)(_this.calculatePercent(), 0, 100);
	
	      if ((0, _isUndefined3.default)(precision)) return percent;
	      return (0, _round3.default)(percent, precision);
	    }, _this.isAutoSuccess = function () {
	      var _this$props2 = _this.props,
	          autoSuccess = _this$props2.autoSuccess,
	          percent = _this$props2.percent,
	          total = _this$props2.total,
	          value = _this$props2.value;
	
	
	      return autoSuccess && (percent >= 100 || value >= total);
	    }, _this.renderLabel = function () {
	      var _this$props3 = _this.props,
	          children = _this$props3.children,
	          content = _this$props3.content,
	          label = _this$props3.label;
	
	
	      if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	        'div',
	        { className: 'label' },
	        children
	      );
	      if (!_lib.childrenUtils.isNil(content)) return _react2.default.createElement(
	        'div',
	        { className: 'label' },
	        content
	      );
	      return (0, _lib.createHTMLDivision)(label, { defaultProps: { className: 'label' } });
	    }, _this.renderProgress = function (percent) {
	      var _this$props4 = _this.props,
	          precision = _this$props4.precision,
	          progress = _this$props4.progress,
	          total = _this$props4.total,
	          value = _this$props4.value;
	
	
	      if (!progress && (0, _isUndefined3.default)(precision)) return;
	      return _react2.default.createElement(
	        'div',
	        { className: 'progress' },
	        progress !== 'ratio' ? percent + '%' : value + '/' + total
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Progress, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          attached = _props.attached,
	          className = _props.className,
	          color = _props.color,
	          disabled = _props.disabled,
	          error = _props.error,
	          indicating = _props.indicating,
	          inverted = _props.inverted,
	          size = _props.size,
	          success = _props.success,
	          warning = _props.warning;
	
	
	      var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(active || indicating, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(indicating, 'indicating'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(success || this.isAutoSuccess(), 'success'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useValueAndKey)(attached, 'attached'), 'progress', className);
	      var rest = (0, _lib.getUnhandledProps)(Progress, this.props);
	      var ElementType = (0, _lib.getElementType)(Progress, this.props);
	      var percent = this.getPercent();
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, 'data-percent': Math.floor(percent) }),
	        _react2.default.createElement(
	          'div',
	          { className: 'bar', style: { width: percent + '%' } },
	          this.renderProgress(percent)
	        ),
	        this.renderLabel()
	      );
	    }
	  }]);
	  return Progress;
	}(_react.Component);
	
	Progress._meta = {
	  name: 'Progress',
	  type: _lib.META.TYPES.MODULE
	};
	Progress.handledProps = ['active', 'as', 'attached', 'autoSuccess', 'children', 'className', 'color', 'content', 'disabled', 'error', 'indicating', 'inverted', 'label', 'percent', 'precision', 'progress', 'size', 'success', 'total', 'value', 'warning'];
	Progress.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A progress bar can show activity. */
	  active: _propTypes2.default.bool,
	
	  /** A progress bar can attach to and show the progress of an element (i.e. Card or Segment). */
	  attached: _propTypes2.default.oneOf(['top', 'bottom']),
	
	  /** Whether success state should automatically trigger when progress completes. */
	  autoSuccess: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A progress bar can have different colors. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A progress bar be disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** A progress bar can show a error state. */
	  error: _propTypes2.default.bool,
	
	  /** An indicating progress bar visually indicates the current level of progress of a task. */
	  indicating: _propTypes2.default.bool,
	
	  /** A progress bar can have its colors inverted. */
	  inverted: _propTypes2.default.bool,
	
	  /** Can be set to either to display progress as percent or ratio. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** Current percent complete. */
	  percent: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['total', 'value']), _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])]),
	
	  /** Decimal point precision for calculated progress. */
	  precision: _propTypes2.default.number,
	
	  /** A progress bar can contain a text value indicating current progress. */
	  progress: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['percent', 'ratio'])]),
	
	  /** A progress bar can vary in size. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'mini', 'huge', 'massive')),
	
	  /** A progress bar can show a success state. */
	  success: _propTypes2.default.bool,
	
	  /** For use with value. Together, these will calculate the percent. Mutually excludes percent. */
	  total: _lib.customPropTypes.every([_lib.customPropTypes.demand(['value']), _lib.customPropTypes.disallow(['percent']), _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])]),
	
	  /** For use with total. Together, these will calculate the percent. Mutually excludes percent. */
	  value: _lib.customPropTypes.every([_lib.customPropTypes.demand(['total']), _lib.customPropTypes.disallow(['percent']), _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])]),
	
	  /** A progress bar can show a warning state. */
	  warning: _propTypes2.default.bool
	} : {};
	exports.default = Progress;

/***/ },
/* 2867 */
[4546, 2866],
/* 2868 */
[4547, 1040, 44, 43, 8, 10, 1248],
/* 2869 */
[4549, 2868],
/* 2870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(130);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(120);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get3 = __webpack_require__(367);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isEmpty2 = __webpack_require__(404);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _partialRight2 = __webpack_require__(2768);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _inRange2 = __webpack_require__(2758);
	
	var _inRange3 = _interopRequireDefault(_inRange2);
	
	var _map2 = __webpack_require__(69);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _get5 = __webpack_require__(109);
	
	var _get6 = _interopRequireDefault(_get5);
	
	var _reduce2 = __webpack_require__(408);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _without2 = __webpack_require__(43);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _Input = __webpack_require__(641);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _SearchCategory = __webpack_require__(1249);
	
	var _SearchCategory2 = _interopRequireDefault(_SearchCategory);
	
	var _SearchResult = __webpack_require__(1250);
	
	var _SearchResult2 = _interopRequireDefault(_SearchResult);
	
	var _SearchResults = __webpack_require__(1251);
	
	var _SearchResults2 = _interopRequireDefault(_SearchResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A search module allows a user to query for results from a selection of data
	 */
	var Search = function (_Component) {
	  (0, _inherits3.default)(Search, _Component);
	
	  function Search() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Search);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Search.__proto__ || Object.getPrototypeOf(Search)).call.apply(_ref, [this].concat(args))), _this), _this.handleResultSelect = function (e, result) {
	
	      (0, _invoke3.default)(_this.props, 'onResultSelect', e, (0, _extends3.default)({}, _this.props, { result: result }));
	    }, _this.handleSelectionChange = function (e) {
	
	      var result = _this.getSelectedResult();
	      (0, _invoke3.default)(_this.props, 'onSelectionChange', e, (0, _extends3.default)({}, _this.props, { result: result }));
	    }, _this.closeOnEscape = function (e) {
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Escape) return;
	      e.preventDefault();
	      _this.close();
	    }, _this.moveSelectionOnKeyDown = function (e) {
	      switch (_lib.keyboardKey.getCode(e)) {
	        case _lib.keyboardKey.ArrowDown:
	          e.preventDefault();
	          _this.moveSelectionBy(e, 1);
	          break;
	        case _lib.keyboardKey.ArrowUp:
	          e.preventDefault();
	          _this.moveSelectionBy(e, -1);
	          break;
	        default:
	          break;
	      }
	    }, _this.selectItemOnEnter = function (e) {
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Enter) return;
	
	      var result = _this.getSelectedResult();
	
	      // prevent selecting null if there was no selected item value
	      if (!result) return;
	
	      e.preventDefault();
	
	      // notify the onResultSelect prop that the user is trying to change value
	      _this.setValue(result.title);
	      _this.handleResultSelect(e, result);
	      _this.close();
	    }, _this.closeOnDocumentClick = function (e) {
	      _this.close();
	    }, _this.handleMouseDown = function (e) {
	
	      _this.isMouseDown = true;
	      (0, _invoke3.default)(_this.props, 'onMouseDown', e, _this.props);
	      _lib.eventStack.sub('mouseup', _this.handleDocumentMouseUp);
	    }, _this.handleDocumentMouseUp = function () {
	
	      _this.isMouseDown = false;
	      _lib.eventStack.unsub('mouseup', _this.handleDocumentMouseUp);
	    }, _this.handleInputClick = function (e) {
	
	      // prevent closeOnDocumentClick()
	      e.nativeEvent.stopImmediatePropagation();
	
	      _this.tryOpen();
	    }, _this.handleItemClick = function (e, _ref2) {
	      var id = _ref2.id;
	
	      var result = _this.getSelectedResult(id);
	
	      // prevent closeOnDocumentClick()
	      e.nativeEvent.stopImmediatePropagation();
	
	      // notify the onResultSelect prop that the user is trying to change value
	      _this.setValue(result.title);
	      _this.handleResultSelect(e, result);
	      _this.close();
	    }, _this.handleFocus = function (e) {
	      var onFocus = _this.props.onFocus;
	
	      if (onFocus) onFocus(e, _this.props);
	      _this.setState({ focus: true });
	    }, _this.handleBlur = function (e) {
	      var onBlur = _this.props.onBlur;
	
	      if (onBlur) onBlur(e, _this.props);
	      _this.setState({ focus: false });
	    }, _this.handleSearchChange = function (e) {
	      // prevent propagating to this.props.onChange()
	      e.stopPropagation();
	      var minCharacters = _this.props.minCharacters;
	      var open = _this.state.open;
	
	      var newQuery = e.target.value;
	
	      (0, _invoke3.default)(_this.props, 'onSearchChange', e, (0, _extends3.default)({}, _this.props, { value: newQuery }));
	
	      // open search dropdown on search query
	      if (newQuery.length < minCharacters) {
	        _this.close();
	      } else if (!open) {
	        _this.tryOpen(newQuery);
	      }
	
	      _this.setValue(newQuery);
	    }, _this.getFlattenedResults = function () {
	      var _this$props = _this.props,
	          category = _this$props.category,
	          results = _this$props.results;
	
	
	      return !category ? results : (0, _reduce3.default)(results, function (memo, categoryData) {
	        return memo.concat(categoryData.results);
	      }, []);
	    }, _this.getSelectedResult = function () {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.selectedIndex;
	
	      var results = _this.getFlattenedResults();
	      return (0, _get6.default)(results, index);
	    }, _this.setValue = function (value) {
	      var selectFirstResult = _this.props.selectFirstResult;
	
	
	      _this.trySetState({ value: value }, { selectedIndex: selectFirstResult ? 0 : -1 });
	    }, _this.moveSelectionBy = function (e, offset) {
	      var selectedIndex = _this.state.selectedIndex;
	
	
	      var results = _this.getFlattenedResults();
	      var lastIndex = results.length - 1;
	
	      // next is after last, wrap to beginning
	      // next is before first, wrap to end
	      var nextIndex = selectedIndex + offset;
	      if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;
	
	      _this.setState({ selectedIndex: nextIndex });
	      _this.scrollSelectedItemIntoView();
	      _this.handleSelectionChange(e);
	    }, _this.scrollSelectedItemIntoView = function () {
	      // Do not access document when server side rendering
	      if (!(0, _lib.isBrowser)()) return;
	      var menu = document.querySelector('.ui.search.active.visible .results.visible');
	      var item = menu.querySelector('.result.active');
	      if (!item) return;
	
	      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
	      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;
	
	      if (isOutOfUpperView) {
	        menu.scrollTop = item.offsetTop;
	      } else if (isOutOfLowerView) {
	        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
	      }
	    }, _this.tryOpen = function () {
	      var currentValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
	      var minCharacters = _this.props.minCharacters;
	
	      if (currentValue.length < minCharacters) return;
	
	      _this.open();
	    }, _this.open = function () {
	      _this.trySetState({ open: true });
	    }, _this.close = function () {
	      _this.trySetState({ open: false });
	    }, _this.renderSearchInput = function (rest) {
	      var _this$props2 = _this.props,
	          icon = _this$props2.icon,
	          input = _this$props2.input;
	      var value = _this.state.value;
	
	
	      return _Input2.default.create(input, { defaultProps: (0, _extends3.default)({}, rest, {
	          icon: icon,
	          input: { className: 'prompt', tabIndex: '0', autoComplete: 'off' },
	          onChange: _this.handleSearchChange,
	          onClick: _this.handleInputClick,
	          value: value
	        }) });
	    }, _this.renderNoResults = function () {
	      var _this$props3 = _this.props,
	          noResultsDescription = _this$props3.noResultsDescription,
	          noResultsMessage = _this$props3.noResultsMessage;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'message empty' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          noResultsMessage
	        ),
	        noResultsDescription && _react2.default.createElement(
	          'div',
	          { className: 'description' },
	          noResultsDescription
	        )
	      );
	    }, _this.renderResult = function (_ref3, index, _array) {
	      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	      var childKey = _ref3.childKey,
	          result = (0, _objectWithoutProperties3.default)(_ref3, ['childKey']);
	      var resultRenderer = _this.props.resultRenderer;
	      var selectedIndex = _this.state.selectedIndex;
	
	      var offsetIndex = index + offset;
	
	      return _react2.default.createElement(_SearchResult2.default, (0, _extends3.default)({
	        key: childKey || result.title,
	        active: selectedIndex === offsetIndex,
	        onClick: _this.handleItemClick,
	        renderer: resultRenderer
	      }, result, {
	        id: offsetIndex // Used to lookup the result on item click
	      }));
	    }, _this.renderResults = function () {
	      var results = _this.props.results;
	
	
	      return (0, _map3.default)(results, _this.renderResult);
	    }, _this.renderCategories = function () {
	      var _this$props4 = _this.props,
	          categoryRenderer = _this$props4.categoryRenderer,
	          categories = _this$props4.results;
	      var selectedIndex = _this.state.selectedIndex;
	
	
	      var count = 0;
	
	      return (0, _map3.default)(categories, function (_ref4) {
	        var childKey = _ref4.childKey,
	            category = (0, _objectWithoutProperties3.default)(_ref4, ['childKey']);
	
	        var categoryProps = (0, _extends3.default)({
	          key: childKey || category.name,
	          active: (0, _inRange3.default)(selectedIndex, count, count + category.results.length),
	          renderer: categoryRenderer
	        }, category);
	        var renderFn = (0, _partialRight3.default)(_this.renderResult, count);
	
	        count += category.results.length;
	
	        return _react2.default.createElement(
	          _SearchCategory2.default,
	          categoryProps,
	          category.results.map(renderFn)
	        );
	      });
	    }, _this.renderMenuContent = function () {
	      var _this$props5 = _this.props,
	          category = _this$props5.category,
	          showNoResults = _this$props5.showNoResults,
	          results = _this$props5.results;
	
	
	      if ((0, _isEmpty3.default)(results)) {
	        return showNoResults ? _this.renderNoResults() : null;
	      }
	
	      return category ? _this.renderCategories() : _this.renderResults();
	    }, _this.renderResultsMenu = function () {
	      var open = _this.state.open;
	
	      var resultsClasses = open ? 'visible' : '';
	      var menuContent = _this.renderMenuContent();
	
	      if (!menuContent) return;
	
	      return _react2.default.createElement(
	        _SearchResults2.default,
	        { className: resultsClasses },
	        menuContent
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Search, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _state = this.state,
	          open = _state.open,
	          value = _state.value;
	
	
	      this.setValue(value);
	      if (open) this.open();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get4.default)(Search.prototype.__proto__ || Object.getPrototypeOf(Search.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
	
	
	      if (!(0, _lib.shallowEqual)(nextProps.value, this.props.value)) {
	        this.setValue(nextProps.value);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _lib.shallowEqual)(nextProps, this.props) || !(0, _lib.shallowEqual)(nextState, this.state);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	
	      // focused / blurred
	      // eslint-disable-line complexity
	      if (!prevState.focus && this.state.focus) {
	        if (!this.isMouseDown) {
	          this.tryOpen();
	        }
	        if (this.state.open) {
	          _lib.eventStack.sub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	        }
	      } else if (prevState.focus && !this.state.focus) {
	        if (!this.isMouseDown) {
	          this.close();
	        }
	        _lib.eventStack.unsub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	      }
	
	      // opened / closed
	      if (!prevState.open && this.state.open) {
	        this.open();
	        _lib.eventStack.sub('click', this.closeOnDocumentClick);
	        _lib.eventStack.sub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	      } else if (prevState.open && !this.state.open) {
	        this.close();
	        _lib.eventStack.unsub('click', this.closeOnDocumentClick);
	        _lib.eventStack.unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	
	      _lib.eventStack.unsub('click', this.closeOnDocumentClick);
	      _lib.eventStack.unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	    }
	
	    // ----------------------------------------
	    // Document Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Component Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Getters
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Setters
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Behavior
	    // ----------------------------------------
	
	    // Open if the current value is greater than the minCharacters prop
	
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	    /**
	     * Offset is needed for determining the active item for results within a
	     * category. Since the index is reset to 0 for each new category, an offset
	     * must be passed in.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          searchClasses = _state2.searchClasses,
	          focus = _state2.focus,
	          open = _state2.open;
	      var _props = this.props,
	          aligned = _props.aligned,
	          category = _props.category,
	          className = _props.className,
	          fluid = _props.fluid,
	          loading = _props.loading,
	          size = _props.size;
	
	      // Classes
	
	      var classes = (0, _classnames2.default)('ui', open && 'active visible', size, searchClasses, (0, _lib.useKeyOnly)(category, 'category'), (0, _lib.useKeyOnly)(focus, 'focus'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useValueAndKey)(aligned, 'aligned'), 'search', className);
	      var unhandled = (0, _lib.getUnhandledProps)(Search, this.props);
	      var ElementType = (0, _lib.getElementType)(Search, this.props);
	
	      var _partitionHTMLInputPr = (0, _lib.partitionHTMLInputProps)(unhandled, {
	        htmlProps: _lib.htmlInputAttrs
	      }),
	          _partitionHTMLInputPr2 = (0, _slicedToArray3.default)(_partitionHTMLInputPr, 2),
	          htmlInputProps = _partitionHTMLInputPr2[0],
	          rest = _partitionHTMLInputPr2[1];
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, {
	          className: classes,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseDown: this.handleMouseDown
	        }),
	        this.renderSearchInput(htmlInputProps),
	        this.renderResultsMenu()
	      );
	    }
	  }]);
	  return Search;
	}(_lib.AutoControlledComponent);
	
	Search.defaultProps = {
	  icon: 'search',
	  input: 'text',
	  minCharacters: 1,
	  noResultsMessage: 'No results found.',
	  showNoResults: true
	};
	Search.autoControlledProps = ['open', 'value'];
	Search._meta = {
	  name: 'Search',
	  type: _lib.META.TYPES.MODULE
	};
	Search.Category = _SearchCategory2.default;
	Search.Result = _SearchResult2.default;
	Search.Results = _SearchResults2.default;
	Search.handledProps = ['aligned', 'as', 'category', 'categoryRenderer', 'className', 'defaultOpen', 'defaultValue', 'fluid', 'icon', 'input', 'loading', 'minCharacters', 'noResultsDescription', 'noResultsMessage', 'onBlur', 'onFocus', 'onMouseDown', 'onResultSelect', 'onSearchChange', 'onSelectionChange', 'open', 'resultRenderer', 'results', 'selectFirstResult', 'showNoResults', 'size', 'value'];
	exports.default = Search;
	Search.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  // ------------------------------------
	  // Behavior
	  // ------------------------------------
	
	  /** Initial value of open. */
	  defaultOpen: _propTypes2.default.bool,
	
	  /** Initial value. */
	  defaultValue: _propTypes2.default.string,
	
	  /** Shorthand for Icon. */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object]),
	
	  /** Minimum characters to query for results */
	  minCharacters: _propTypes2.default.number,
	
	  /** Additional text for "No Results" message with less emphasis. */
	  noResultsDescription: _propTypes2.default.node,
	
	  /** Message to display when there are no results. */
	  noResultsMessage: _propTypes2.default.node,
	
	  /** Controls whether or not the results menu is displayed. */
	  open: _propTypes2.default.bool,
	
	  /**
	   * One of:
	   * - array of Search.Result props e.g. `{ title: '', description: '' }` or
	   * - object of categories e.g. `{ name: '', results: [{ title: '', description: '' }]`
	   */
	  results: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.shape(_SearchResult2.default.propTypes)), _propTypes2.default.object]),
	
	  /** Whether the search should automatically select the first result after searching. */
	  selectFirstResult: _propTypes2.default.bool,
	
	  /** Whether a "no results" message should be shown if no results are found. */
	  showNoResults: _propTypes2.default.bool,
	
	  /** Current value of the search input. Creates a controlled component. */
	  value: _propTypes2.default.string,
	
	  // ------------------------------------
	  // Rendering
	  // ------------------------------------
	
	  /**
	   * Renders the SearchCategory contents.
	   *
	   * @param {object} props - The SearchCategory props object.
	   * @returns {*} - Renderable SearchCategory contents.
	   */
	  categoryRenderer: _propTypes2.default.func,
	
	  /**
	   * Renders the SearchResult contents.
	   *
	   * @param {object} props - The SearchResult props object.
	   * @returns {*} - Renderable SearchResult contents.
	   */
	  resultRenderer: _propTypes2.default.func,
	
	  // ------------------------------------
	  // Callbacks
	  // ------------------------------------
	
	  /**
	   * Called on blur.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * Called on focus.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * Called on mousedown.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * Called when a result is selected.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onResultSelect: _propTypes2.default.func,
	
	  /**
	   * Called on search input change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props, includes current value of search input.
	   */
	  onSearchChange: _propTypes2.default.func,
	
	  /**
	   * Called when the active selection index is changed.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onSelectionChange: _propTypes2.default.func,
	
	  // ------------------------------------
	  // Style
	  // ------------------------------------
	
	  /** A search can have its results aligned to its left or right container edge. */
	  aligned: _propTypes2.default.string,
	
	  /** A search can display results from remote content ordered by categories. */
	  category: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A search can have its results take up the width of its container. */
	  fluid: _propTypes2.default.bool,
	
	  /** A search input can take up the width of its container. */
	  input: _lib.customPropTypes.itemShorthand,
	
	  /** A search can show a loading indicator. */
	  loading: _propTypes2.default.bool,
	
	  /** A search can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : {};

/***/ },
/* 2871 */
[4550, 2870],
/* 2872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _SidebarPushable = __webpack_require__(1252);
	
	var _SidebarPushable2 = _interopRequireDefault(_SidebarPushable);
	
	var _SidebarPusher = __webpack_require__(1253);
	
	var _SidebarPusher2 = _interopRequireDefault(_SidebarPusher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A sidebar hides additional content beside a page.
	 */
	var Sidebar = function (_Component) {
	  (0, _inherits3.default)(Sidebar, _Component);
	
	  function Sidebar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Sidebar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call.apply(_ref, [this].concat(args))), _this), _this.startAnimating = function () {
	      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
	
	      clearTimeout(_this.stopAnimatingTimer);
	
	      _this.setState({ animating: true });
	
	      _this.stopAnimatingTimer = setTimeout(function () {
	        return _this.setState({ animating: false });
	      }, duration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Sidebar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.visible !== this.props.visible) {
	        this.startAnimating();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          children = _props.children,
	          content = _props.content,
	          direction = _props.direction,
	          visible = _props.visible,
	          width = _props.width;
	      var animating = this.state.animating;
	
	
	      var classes = (0, _classnames2.default)('ui', animation, direction, width, (0, _lib.useKeyOnly)(animating, 'animating'), (0, _lib.useKeyOnly)(visible, 'visible'), 'sidebar', className);
	
	      var rest = (0, _lib.getUnhandledProps)(Sidebar, this.props);
	      var ElementType = (0, _lib.getElementType)(Sidebar, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        _lib.childrenUtils.isNil(children) ? content : children
	      );
	    }
	  }]);
	  return Sidebar;
	}(_lib.AutoControlledComponent);
	
	Sidebar.defaultProps = {
	  direction: 'left'
	};
	Sidebar.autoControlledProps = ['visible'];
	Sidebar._meta = {
	  name: 'Sidebar',
	  type: _lib.META.TYPES.MODULE
	};
	Sidebar.Pushable = _SidebarPushable2.default;
	Sidebar.Pusher = _SidebarPusher2.default;
	Sidebar.handledProps = ['animation', 'as', 'children', 'className', 'content', 'defaultVisible', 'direction', 'visible', 'width'];
	Sidebar.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Animation style. */
	  animation: _propTypes2.default.oneOf(['overlay', 'push', 'scale down', 'uncover', 'slide out', 'slide along']),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Initial value of visible. */
	  defaultVisible: _propTypes2.default.bool,
	
	  /** Direction the sidebar should appear on. */
	  direction: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /** Controls whether or not the sidebar is visible on the page. */
	  visible: _propTypes2.default.bool,
	
	  /** Sidebar width. */
	  width: _propTypes2.default.oneOf(['very thin', 'thin', 'wide', 'very wide'])
	} : {};
	exports.default = Sidebar;

/***/ },
/* 2873 */
[4551, 2872],
/* 2874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(44);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sticky content stays fixed to the browser viewport while another column of content is visible on the page.
	 */
	var Sticky = function (_Component) {
	  (0, _inherits3.default)(Sticky, _Component);
	
	  function Sticky() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Sticky);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      sticky: false
	    }, _this.addListeners = function (props) {
	      var scrollContext = props.scrollContext;
	
	
	      _lib.eventStack.sub('resize', _this.handleUpdate, { target: scrollContext });
	      _lib.eventStack.sub('scroll', _this.handleUpdate, { target: scrollContext });
	    }, _this.removeListeners = function () {
	      var scrollContext = _this.props.scrollContext;
	
	
	      _lib.eventStack.unsub('resize', _this.handleUpdate, { target: scrollContext });
	      _lib.eventStack.unsub('scroll', _this.handleUpdate, { target: scrollContext });
	    }, _this.update = function (e) {
	      var pushing = _this.state.pushing;
	
	
	      _this.ticking = false;
	      _this.assignRects();
	
	      if (pushing) {
	        if (_this.didReachStartingPoint()) return _this.stickToContextTop(e);
	        if (_this.didTouchScreenBottom()) return _this.stickToScreenBottom(e);
	        return _this.stickToContextBottom(e);
	      }
	
	      if (_this.isOversized()) {
	        if (_this.contextRect.top > 0) return _this.stickToContextTop(e);
	        if (_this.contextRect.bottom < window.innerHeight) return _this.stickToContextBottom(e);
	      }
	
	      if (_this.didTouchScreenTop()) {
	        if (_this.didReachContextBottom()) return _this.stickToContextBottom(e);
	        return _this.stickToScreenTop(e);
	      }
	
	      return _this.stickToContextTop(e);
	    }, _this.handleUpdate = function (e) {
	      if (!_this.ticking) {
	        _this.ticking = true;
	        requestAnimationFrame(function () {
	          return _this.update(e);
	        });
	      }
	    }, _this.assignRects = function () {
	      var context = _this.props.context;
	
	
	      _this.triggerRect = _this.triggerRef.getBoundingClientRect();
	      _this.contextRect = (context || document.body).getBoundingClientRect();
	      _this.stickyRect = _this.stickyRef.getBoundingClientRect();
	    }, _this.didReachContextBottom = function () {
	      var offset = _this.props.offset;
	
	
	      return _this.stickyRect.height + offset >= _this.contextRect.bottom;
	    }, _this.didReachStartingPoint = function () {
	      return _this.stickyRect.top <= _this.triggerRect.top;
	    }, _this.didTouchScreenTop = function () {
	      return _this.triggerRect.top < _this.props.offset;
	    }, _this.didTouchScreenBottom = function () {
	      var bottomOffset = _this.props.bottomOffset;
	
	
	      return _this.contextRect.bottom + bottomOffset > window.innerHeight;
	    }, _this.isOversized = function () {
	      return _this.stickyRect.height > window.innerHeight;
	    }, _this.pushing = function (pushing) {
	      var possible = _this.props.pushing;
	
	
	      if (possible) _this.setState({ pushing: pushing });
	    }, _this.stick = function (e) {
	      _this.setState({ sticky: true });
	      (0, _invoke3.default)(_this.props, 'onStick', e, _this.props);
	    }, _this.unstick = function (e) {
	      _this.setState({ sticky: false });
	      (0, _invoke3.default)(_this.props, 'onUnstick', e, _this.props);
	    }, _this.stickToContextBottom = function (e) {
	      var top = _this.contextRect.bottom - _this.stickyRect.height;
	
	      (0, _invoke3.default)(_this.props, 'onBottom', e, _this.props);
	
	      _this.stick(e);
	      _this.setState({ top: top, bottom: null });
	      _this.pushing(true);
	    }, _this.stickToContextTop = function (e) {
	      (0, _invoke3.default)(_this.props, 'onTop', e, _this.props);
	
	      _this.unstick(e);
	      _this.pushing(false);
	    }, _this.stickToScreenBottom = function (e) {
	      var bottom = _this.props.bottomOffset;
	
	
	      _this.stick(e);
	      _this.setState({ bottom: bottom, top: null });
	    }, _this.stickToScreenTop = function (e) {
	      var top = _this.props.offset;
	
	
	      _this.stick(e);
	      _this.setState({ top: top, bottom: null });
	    }, _this.handleStickyRef = function (c) {
	      return _this.stickyRef = c;
	    }, _this.handleTriggerRef = function (c) {
	      return _this.triggerRef = c;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Sticky, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!(0, _lib.isBrowser)()) return;
	      var active = this.props.active;
	
	
	      if (active) {
	        this.handleUpdate();
	        this.addListeners(this.props);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var current = this.props.active;
	      var next = nextProps.active;
	
	
	      if (current === next) return;
	      if (next) {
	        this.handleUpdate();
	        this.addListeners(nextProps);
	        return;
	      }
	      this.removeListeners();
	      this.setState({ sticky: false });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!(0, _lib.isBrowser)()) return;
	      var active = this.props.active;
	
	
	      if (active) this.removeListeners();
	    }
	
	    // ----------------------------------------
	    // Events
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Helpers
	    // ----------------------------------------
	
	  }, {
	    key: 'computeStyle',
	    value: function computeStyle() {
	      var _state = this.state,
	          bottom = _state.bottom,
	          sticky = _state.sticky,
	          top = _state.top;
	
	
	      if (!sticky) return {};
	      return {
	        bottom: bottom,
	        top: top,
	        position: 'fixed',
	        width: this.triggerRect.width
	      };
	    }
	
	    // Return true when the component reached the bottom of the context
	
	
	    // Return true when the component reached the starting point
	
	
	    // Return true when the top of the screen overpasses the Sticky component
	
	
	    // Return true when the bottom of the screen overpasses the Sticky component
	
	
	    // Return true if the height of the component is higher than the window
	
	
	    // ----------------------------------------
	    // Stick helpers
	    // ----------------------------------------
	
	    // If true, the component will stick to the bottom of the screen instead of the top
	
	
	    // ----------------------------------------
	    // Refs
	    // ----------------------------------------
	
	  }, {
	    key: 'render',
	
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	      var rest = (0, _lib.getUnhandledProps)(Sticky, this.props);
	      var ElementType = (0, _lib.getElementType)(Sticky, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: className }),
	        _react2.default.createElement('div', { ref: this.handleTriggerRef }),
	        _react2.default.createElement(
	          'div',
	          { ref: this.handleStickyRef, style: this.computeStyle() },
	          children
	        )
	      );
	    }
	  }]);
	  return Sticky;
	}(_react.Component);
	
	Sticky.defaultProps = {
	  active: true,
	  bottomOffset: 0,
	  offset: 0,
	  scrollContext: (0, _lib.isBrowser)() ? window : null
	};
	Sticky._meta = {
	  name: 'Sticky',
	  type: _lib.META.TYPES.MODULE
	};
	Sticky.handledProps = ['active', 'as', 'bottomOffset', 'children', 'className', 'context', 'offset', 'onBottom', 'onStick', 'onTop', 'onUnstick', 'pushing', 'scrollContext'];
	exports.default = Sticky;
	Sticky.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A Sticky can be active. */
	  active: _propTypes2.default.bool,
	
	  /** Offset in pixels from the bottom of the screen when fixing element to viewport. */
	  bottomOffset: _propTypes2.default.number,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Context which sticky element should stick to. */
	  context: _propTypes2.default.object,
	
	  /** Offset in pixels from the top of the screen when fixing element to viewport. */
	  offset: _propTypes2.default.number,
	
	  /**
	   * Callback when element is bound to bottom of parent container.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onBottom: _propTypes2.default.func,
	
	  /**
	   * Callback when element is fixed to page.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onStick: _propTypes2.default.func,
	
	  /**
	   * Callback when element is bound to top of parent container.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onTop: _propTypes2.default.func,
	
	  /**
	   * Callback when element is unfixed from page.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onUnstick: _propTypes2.default.func,
	
	  /** Whether element should be "pushed" by the viewport, attaching to the bottom of the screen when scrolling up. */
	  pushing: _propTypes2.default.bool,
	
	  /** Context which sticky should attach onscroll events. */
	  scrollContext: _propTypes2.default.object
	} : {};

/***/ },
/* 2875 */
[4552, 2874],
/* 2876 */
[4553, 69, 109, 44, 8, 10, 1198, 638, 1200, 1254],
/* 2877 */
[4555, 2876],
/* 2878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An ad displays third-party promotional content.
	 */
	function Advertisement(props) {
	  var centered = props.centered,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      test = props.test,
	      unit = props.unit;
	
	
	  var classes = (0, _classnames2.default)('ui', unit, (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(test, 'test'), 'ad', className);
	  var rest = (0, _lib.getUnhandledProps)(Advertisement, props);
	  var ElementType = (0, _lib.getElementType)(Advertisement, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes, 'data-text': test }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	Advertisement.handledProps = ['as', 'centered', 'children', 'className', 'content', 'test', 'unit'];
	Advertisement._meta = {
	  name: 'Advertisement',
	  type: _lib.META.TYPES.VIEW
	};
	
	Advertisement.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Center the advertisement. */
	  centered: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Text to be displayed on the advertisement. */
	  test: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /** Varies the size of the advertisement. */
	  unit: _propTypes2.default.oneOf(['medium rectangle', 'large rectangle', 'vertical rectangle', 'small rectangle', 'mobile banner', 'banner', 'vertical banner', 'top banner', 'half banner', 'button', 'square button', 'small button', 'skyscraper', 'wide skyscraper', 'leaderboard', 'large leaderboard', 'mobile leaderboard', 'billboard', 'panorama', 'netboard', 'half page', 'square', 'small square']).isRequired
	
	} : {};
	
	exports.default = Advertisement;

/***/ },
/* 2879 */
[4557, 2878],
/* 2880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(10);
	
	var _CommentAction = __webpack_require__(1261);
	
	var _CommentAction2 = _interopRequireDefault(_CommentAction);
	
	var _CommentActions = __webpack_require__(1262);
	
	var _CommentActions2 = _interopRequireDefault(_CommentActions);
	
	var _CommentAuthor = __webpack_require__(1263);
	
	var _CommentAuthor2 = _interopRequireDefault(_CommentAuthor);
	
	var _CommentAvatar = __webpack_require__(1264);
	
	var _CommentAvatar2 = _interopRequireDefault(_CommentAvatar);
	
	var _CommentContent = __webpack_require__(1265);
	
	var _CommentContent2 = _interopRequireDefault(_CommentContent);
	
	var _CommentGroup = __webpack_require__(1266);
	
	var _CommentGroup2 = _interopRequireDefault(_CommentGroup);
	
	var _CommentMetadata = __webpack_require__(1267);
	
	var _CommentMetadata2 = _interopRequireDefault(_CommentMetadata);
	
	var _CommentText = __webpack_require__(1268);
	
	var _CommentText2 = _interopRequireDefault(_CommentText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment displays user feedback to site content.
	 */
	function Comment(props) {
	  var className = props.className,
	      children = props.children,
	      collapsed = props.collapsed,
	      content = props.content;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(collapsed, 'collapsed'), 'comment', className);
	  var rest = (0, _lib.getUnhandledProps)(Comment, props);
	  var ElementType = (0, _lib.getElementType)(Comment, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	Comment.handledProps = ['as', 'children', 'className', 'collapsed', 'content'];
	Comment._meta = {
	  name: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	Comment.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Comment can be collapsed, or hidden from view. */
	  collapsed: _propTypes2.default.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	Comment.Author = _CommentAuthor2.default;
	Comment.Action = _CommentAction2.default;
	Comment.Actions = _CommentActions2.default;
	Comment.Avatar = _CommentAvatar2.default;
	Comment.Content = _CommentContent2.default;
	Comment.Group = _CommentGroup2.default;
	Comment.Metadata = _CommentMetadata2.default;
	Comment.Text = _CommentText2.default;
	
	exports.default = Comment;

/***/ },
/* 2881 */
[4562, 2880],
/* 2882 */
[4563, 43, 69, 8, 10, 655, 419, 1269, 656, 657, 658, 659, 660, 661],
/* 2883 */
[4573, 2882],
/* 2884 */
[4581, 1270],
/* 2885 */
[4582, 1274],
/* 2886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(333).Buffer;
	
	var getParamBytesForAlg = __webpack_require__(2887);
	
	var MAX_OCTET = 0x80,
		CLASS_UNIVERSAL = 0,
		PRIMITIVE_BIT = 0x20,
		TAG_SEQ = 0x10,
		TAG_INT = 0x02,
		ENCODED_TAG_SEQ = (TAG_SEQ | PRIMITIVE_BIT) | (CLASS_UNIVERSAL << 6),
		ENCODED_TAG_INT = TAG_INT | (CLASS_UNIVERSAL << 6);
	
	function base64Url(base64) {
		return base64
			.replace(/=/g, '')
			.replace(/\+/g, '-')
			.replace(/\//g, '_');
	}
	
	function signatureAsBuffer(signature) {
		if (Buffer.isBuffer(signature)) {
			return signature;
		} else if ('string' === typeof signature) {
			return Buffer.from(signature, 'base64');
		}
	
		throw new TypeError('ECDSA signature must be a Base64 string or a Buffer');
	}
	
	function derToJose(signature, alg) {
		signature = signatureAsBuffer(signature);
		var paramBytes = getParamBytesForAlg(alg);
	
		// the DER encoded param should at most be the param size, plus a padding
		// zero, since due to being a signed integer
		var maxEncodedParamLength = paramBytes + 1;
	
		var inputLength = signature.length;
	
		var offset = 0;
		if (signature[offset++] !== ENCODED_TAG_SEQ) {
			throw new Error('Could not find expected "seq"');
		}
	
		var seqLength = signature[offset++];
		if (seqLength === (MAX_OCTET | 1)) {
			seqLength = signature[offset++];
		}
	
		if (inputLength - offset < seqLength) {
			throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
		}
	
		if (signature[offset++] !== ENCODED_TAG_INT) {
			throw new Error('Could not find expected "int" for "r"');
		}
	
		var rLength = signature[offset++];
	
		if (inputLength - offset - 2 < rLength) {
			throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
		}
	
		if (maxEncodedParamLength < rLength) {
			throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
		}
	
		var rOffset = offset;
		offset += rLength;
	
		if (signature[offset++] !== ENCODED_TAG_INT) {
			throw new Error('Could not find expected "int" for "s"');
		}
	
		var sLength = signature[offset++];
	
		if (inputLength - offset !== sLength) {
			throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
		}
	
		if (maxEncodedParamLength < sLength) {
			throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
		}
	
		var sOffset = offset;
		offset += sLength;
	
		if (offset !== inputLength) {
			throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
		}
	
		var rPadding = paramBytes - rLength,
			sPadding = paramBytes - sLength;
	
		var dst = Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);
	
		for (offset = 0; offset < rPadding; ++offset) {
			dst[offset] = 0;
		}
		signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);
	
		offset = paramBytes;
	
		for (var o = offset; offset < o + sPadding; ++offset) {
			dst[offset] = 0;
		}
		signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);
	
		dst = dst.toString('base64');
		dst = base64Url(dst);
	
		return dst;
	}
	
	function countPadding(buf, start, stop) {
		var padding = 0;
		while (start + padding < stop && buf[start + padding] === 0) {
			++padding;
		}
	
		var needsSign = buf[start + padding] >= MAX_OCTET;
		if (needsSign) {
			--padding;
		}
	
		return padding;
	}
	
	function joseToDer(signature, alg) {
		signature = signatureAsBuffer(signature);
		var paramBytes = getParamBytesForAlg(alg);
	
		var signatureBytes = signature.length;
		if (signatureBytes !== paramBytes * 2) {
			throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
		}
	
		var rPadding = countPadding(signature, 0, paramBytes);
		var sPadding = countPadding(signature, paramBytes, signature.length);
		var rLength = paramBytes - rPadding;
		var sLength = paramBytes - sPadding;
	
		var rsBytes = 1 + 1 + rLength + 1 + 1 + sLength;
	
		var shortLength = rsBytes < MAX_OCTET;
	
		var dst = Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);
	
		var offset = 0;
		dst[offset++] = ENCODED_TAG_SEQ;
		if (shortLength) {
			// Bit 8 has value "0"
			// bits 7-1 give the length.
			dst[offset++] = rsBytes;
		} else {
			// Bit 8 of first octet has value "1"
			// bits 7-1 give the number of additional length octets.
			dst[offset++] = MAX_OCTET	| 1;
			// length, base 256
			dst[offset++] = rsBytes & 0xff;
		}
		dst[offset++] = ENCODED_TAG_INT;
		dst[offset++] = rLength;
		if (rPadding < 0) {
			dst[offset++] = 0;
			offset += signature.copy(dst, offset, 0, paramBytes);
		} else {
			offset += signature.copy(dst, offset, rPadding, paramBytes);
		}
		dst[offset++] = ENCODED_TAG_INT;
		dst[offset++] = sLength;
		if (sPadding < 0) {
			dst[offset++] = 0;
			signature.copy(dst, offset, paramBytes);
		} else {
			signature.copy(dst, offset, paramBytes + sPadding);
		}
	
		return dst;
	}
	
	module.exports = {
		derToJose: derToJose,
		joseToDer: joseToDer
	};


/***/ },
/* 2887 */
/***/ function(module, exports) {

	'use strict';
	
	function getParamSize(keySize) {
		var result = ((keySize / 8) | 0) + (keySize % 8 === 0 ? 0 : 1);
		return result;
	}
	
	var paramBytesForAlg = {
		ES256: getParamSize(256),
		ES384: getParamSize(384),
		ES512: getParamSize(521)
	};
	
	function getParamBytesForAlg(alg) {
		var paramBytes = paramBytesForAlg[alg];
		if (paramBytes) {
			return paramBytes;
		}
	
		throw new Error('Unknown algorithm "' + alg + '"');
	}
	
	module.exports = getParamBytesForAlg;


/***/ },
/* 2888 */
/***/ function(module, exports) {

	var requestFrame = (function () {
	  var window = this
	  var raf = window.requestAnimationFrame ||
	    window.mozRequestAnimationFrame ||
	    window.webkitRequestAnimationFrame ||
	    function fallbackRAF(func) {
	      return window.setTimeout(func, 20)
	    }
	  return function requestFrameFunction(func) {
	    return raf(func)
	  }
	})()
	
	var cancelFrame = (function () {
	  var window = this
	  var cancel = window.cancelAnimationFrame ||
	    window.mozCancelAnimationFrame ||
	    window.webkitCancelAnimationFrame ||
	    window.clearTimeout
	  return function cancelFrameFunction(id) {
	    return cancel(id)
	  }
	})()
	
	function resizeListener(e) {
	  var win = e.target || e.srcElement
	  if (win.__resizeRAF__) {
	    cancelFrame(win.__resizeRAF__)
	  }
	  win.__resizeRAF__ = requestFrame(function () {
	    var trigger = win.__resizeTrigger__
	    trigger.__resizeListeners__.forEach(function (fn) {
	      fn.call(trigger, e)
	    })
	  })
	}
	
	var exports = function exports(element, fn) {
	  var window = this
	  var document = window.document
	  var isIE
	
	  var attachEvent = document.attachEvent
	  if (typeof navigator !== 'undefined') {
	    isIE = navigator.userAgent.match(/Trident/) ||
	      navigator.userAgent.match(/Edge/)
	  }
	
	  function objectLoad() {
	    this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__
	    this.contentDocument.defaultView.addEventListener('resize', resizeListener)
	  }
	
	  if (!element.__resizeListeners__) {
	    element.__resizeListeners__ = []
	    if (attachEvent) {
	      element.__resizeTrigger__ = element
	      element.attachEvent('onresize', resizeListener)
	    } else {
	      if (getComputedStyle(element).position === 'static') {
	        element.style.position = 'relative'
	      }
	      var obj = (element.__resizeTrigger__ = document.createElement('object'))
	      obj.setAttribute(
	        'style',
	        'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1; opacity: 0;'
	      )
	      obj.setAttribute('class', 'resize-sensor')
	      obj.__resizeElement__ = element
	      obj.onload = objectLoad
	      obj.type = 'text/html'
	      if (isIE) {
	        element.appendChild(obj)
	      }
	      obj.data = 'about:blank'
	      if (!isIE) {
	        element.appendChild(obj)
	      }
	    }
	  }
	  element.__resizeListeners__.push(fn)
	}
	
	module.exports = typeof window === 'undefined' ? exports : exports.bind(window)
	
	module.exports.unbind = function (element, fn) {
	  var attachEvent = document.attachEvent
	  if (fn) {
	    element.__resizeListeners__.splice(
	      element.__resizeListeners__.indexOf(fn),
	      1
	    )
	  } else {
	    element.__resizeListeners__ = []
	  }
	  if (!element.__resizeListeners__.length) {
	    if (attachEvent) {
	      element.detachEvent('onresize', resizeListener)
	    } else {
	      element.__resizeTrigger__.contentDocument.defaultView.removeEventListener(
	        'resize',
	        resizeListener
	      )
	      delete element.__resizeTrigger__.contentDocument.defaultView.__resizeTrigger__
	      element.__resizeTrigger__ = !element.removeChild(
	        element.__resizeTrigger__
	      )
	    }
	    delete element.__resizeListeners__
	  }
	}


/***/ },
/* 2889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(666);
	
	// https://ecma-international.org/ecma-262/6.0/#sec-samevaluezero
	
	module.exports = function SameValueZero(x, y) {
		return (x === y) || ($isNaN(x) && $isNaN(y));
	};


/***/ },
/* 2890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var MAX_SAFE_INTEGER = __webpack_require__(2900);
	
	var ToInteger = __webpack_require__(1279);
	
	module.exports = function ToLength(argument) {
		var len = ToInteger(argument);
		if (len <= 0) { return 0; } // includes converting -0 to +0
		if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
		return len;
	};


/***/ },
/* 2891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(154);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	var $Number = GetIntrinsic('%Number%');
	var $RegExp = GetIntrinsic('%RegExp%');
	var $parseInteger = GetIntrinsic('%parseInt%');
	
	var callBound = __webpack_require__(369);
	var regexTester = __webpack_require__(2901);
	var isPrimitive = __webpack_require__(2899);
	
	var $strSlice = callBound('String.prototype.slice');
	var isBinary = regexTester(/^0b[01]+$/i);
	var isOctal = regexTester(/^0o[0-7]+$/i);
	var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
	var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
	var hasNonWS = regexTester(nonWSregex);
	
	// whitespace from: https://es5.github.io/#x15.5.4.20
	// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	var ws = [
		'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
		'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
		'\u2029\uFEFF'
	].join('');
	var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	var $replace = callBound('String.prototype.replace');
	var $trim = function (value) {
		return $replace(value, trimRegex, '');
	};
	
	var ToPrimitive = __webpack_require__(2893);
	
	// https://ecma-international.org/ecma-262/6.0/#sec-tonumber
	
	module.exports = function ToNumber(argument) {
		var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number);
		if (typeof value === 'symbol') {
			throw new $TypeError('Cannot convert a Symbol value to a number');
		}
		if (typeof value === 'string') {
			if (isBinary(value)) {
				return ToNumber($parseInteger($strSlice(value, 2), 2));
			} else if (isOctal(value)) {
				return ToNumber($parseInteger($strSlice(value, 2), 8));
			} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
				return NaN;
			} else {
				var trimmed = $trim(value);
				if (trimmed !== value) {
					return ToNumber(trimmed);
				}
			}
		}
		return $Number(value);
	};


/***/ },
/* 2892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(154);
	
	var $Object = GetIntrinsic('%Object%');
	
	var RequireObjectCoercible = __webpack_require__(1278);
	
	// https://ecma-international.org/ecma-262/6.0/#sec-toobject
	
	module.exports = function ToObject(value) {
		RequireObjectCoercible(value);
		return $Object(value);
	};


/***/ },
/* 2893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toPrimitive = __webpack_require__(2903);
	
	// https://ecma-international.org/ecma-262/6.0/#sec-toprimitive
	
	module.exports = function ToPrimitive(input) {
		if (arguments.length > 1) {
			return toPrimitive(input, arguments[1]);
		}
		return toPrimitive(input);
	};


/***/ },
/* 2894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(154);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	
	// http://ecma-international.org/ecma-262/5.1/#sec-9.10
	
	module.exports = function CheckObjectCoercible(value, optMessage) {
		if (value == null) {
			throw new $TypeError(optMessage || ('Cannot call method on ' + value));
		}
		return value;
	};


/***/ },
/* 2895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var abs = __webpack_require__(2897);
	var floor = __webpack_require__(2898);
	var ToNumber = __webpack_require__(2896);
	
	var $isNaN = __webpack_require__(666);
	var $isFinite = __webpack_require__(1280);
	var $sign = __webpack_require__(2902);
	
	// http://ecma-international.org/ecma-262/5.1/#sec-9.4
	
	module.exports = function ToInteger(value) {
		var number = ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return $sign(number) * floor(abs(number));
	};


/***/ },
/* 2896 */
/***/ function(module, exports) {

	'use strict';
	
	// http://ecma-international.org/ecma-262/5.1/#sec-9.3
	
	module.exports = function ToNumber(value) {
		return +value; // eslint-disable-line no-implicit-coercion
	};


/***/ },
/* 2897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(154);
	
	var $abs = GetIntrinsic('%Math.abs%');
	
	// http://ecma-international.org/ecma-262/5.1/#sec-5.2
	
	module.exports = function abs(x) {
		return $abs(x);
	};


/***/ },
/* 2898 */
/***/ function(module, exports) {

	'use strict';
	
	// var modulo = require('./modulo');
	var $floor = Math.floor;
	
	// http://ecma-international.org/ecma-262/5.1/#sec-5.2
	
	module.exports = function floor(x) {
		// return x - modulo(x, 1);
		return $floor(x);
	};


/***/ },
/* 2899 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ },
/* 2900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(154);
	
	var $Math = GetIntrinsic('%Math%');
	var $Number = GetIntrinsic('%Number%');
	
	module.exports = $Number.MAX_SAFE_INTEGER || $Math.pow(2, 53) - 1;


/***/ },
/* 2901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(154);
	
	var $test = GetIntrinsic('RegExp.prototype.test');
	
	var callBind = __webpack_require__(289);
	
	module.exports = function regexTester(regex) {
		return callBind($test, regex);
	};


/***/ },
/* 2902 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function sign(number) {
		return number >= 0 ? 1 : -1;
	};


/***/ },
/* 2903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var isPrimitive = __webpack_require__(2904);
	var isCallable = __webpack_require__(2938);
	var isDate = __webpack_require__(1288);
	var isSymbol = __webpack_require__(2942);
	
	var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
		if (typeof O === 'undefined' || O === null) {
			throw new TypeError('Cannot call method on ' + O);
		}
		if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
			throw new TypeError('hint must be "string" or "number"');
		}
		var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
		var method, result, i;
		for (i = 0; i < methodNames.length; ++i) {
			method = O[methodNames[i]];
			if (isCallable(method)) {
				result = method.call(O);
				if (isPrimitive(result)) {
					return result;
				}
			}
		}
		throw new TypeError('No default value');
	};
	
	var GetMethod = function GetMethod(O, P) {
		var func = O[P];
		if (func !== null && typeof func !== 'undefined') {
			if (!isCallable(func)) {
				throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
			}
			return func;
		}
		return void 0;
	};
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
	module.exports = function ToPrimitive(input) {
		if (isPrimitive(input)) {
			return input;
		}
		var hint = 'default';
		if (arguments.length > 1) {
			if (arguments[1] === String) {
				hint = 'string';
			} else if (arguments[1] === Number) {
				hint = 'number';
			}
		}
	
		var exoticToPrim;
		if (hasSymbols) {
			if (Symbol.toPrimitive) {
				exoticToPrim = GetMethod(input, Symbol.toPrimitive);
			} else if (isSymbol(input)) {
				exoticToPrim = Symbol.prototype.valueOf;
			}
		}
		if (typeof exoticToPrim !== 'undefined') {
			var result = exoticToPrim.call(input, hint);
			if (isPrimitive(result)) {
				return result;
			}
			throw new TypeError('unable to convert exotic object to primitive');
		}
		if (hint === 'default' && (isDate(input) || isSymbol(input))) {
			hint = 'string';
		}
		return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
	};


/***/ },
/* 2904 */
2899,
/* 2905 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    cls.apply(this, arguments);
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var ExtendableError = function (_extendableBuiltin2) {
	  _inherits(ExtendableError, _extendableBuiltin2);
	
	  function ExtendableError() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    _classCallCheck(this, ExtendableError);
	
	    // extending Error is weird and does not propagate `message`
	    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));
	
	    Object.defineProperty(_this, 'message', {
	      configurable: true,
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(_this, 'name', {
	      configurable: true,
	      enumerable: false,
	      value: _this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(_this, _this.constructor);
	      return _possibleConstructorReturn(_this);
	    }
	
	    Object.defineProperty(_this, 'stack', {
	      configurable: true,
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	    return _this;
	  }
	
	  return ExtendableError;
	}(_extendableBuiltin(Error));
	
	exports.default = ExtendableError;
	module.exports = exports['default'];


/***/ },
/* 2906 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 2907 */
2906,
/* 2908 */
2906,
/* 2909 */
2906,
/* 2910 */
2906,
/* 2911 */
2906,
/* 2912 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 2913 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(2912);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 2914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(2922);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 2915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(36);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 2916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(89);
	
	var createArrayFromMixed = __webpack_require__(2915);
	var getMarkupWrap = __webpack_require__(2917);
	var invariant = __webpack_require__(36);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 2917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(89);
	
	var invariant = __webpack_require__(36);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 2918 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 2919 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 2920 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(2919);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 2921 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 2922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(2921);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 2923 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 2924 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
	    factory(exports, module);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, mod);
	    global.fetchJsonp = mod.exports;
	  }
	})(this, function (exports, module) {
	  'use strict';
	
	  var defaultOptions = {
	    timeout: 5000,
	    jsonpCallback: 'callback',
	    jsonpCallbackFunction: null
	  };
	
	  function generateCallbackFunction() {
	    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
	  }
	
	  function clearFunction(functionName) {
	    // IE8 throws an exception when you try to delete a property on window
	    // http://stackoverflow.com/a/1824228/751089
	    try {
	      delete window[functionName];
	    } catch (e) {
	      window[functionName] = undefined;
	    }
	  }
	
	  function removeScript(scriptId) {
	    var script = document.getElementById(scriptId);
	    if (script) {
	      document.getElementsByTagName('head')[0].removeChild(script);
	    }
	  }
	
	  function fetchJsonp(_url) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    // to avoid param reassign
	    var url = _url;
	    var timeout = options.timeout || defaultOptions.timeout;
	    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;
	
	    var timeoutId = undefined;
	
	    return new Promise(function (resolve, reject) {
	      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
	      var scriptId = jsonpCallback + '_' + callbackFunction;
	
	      window[callbackFunction] = function (response) {
	        resolve({
	          ok: true,
	          // keep consistent with fetch API
	          json: function json() {
	            return Promise.resolve(response);
	          }
	        });
	
	        if (timeoutId) clearTimeout(timeoutId);
	
	        removeScript(scriptId);
	
	        clearFunction(callbackFunction);
	      };
	
	      // Check if the user set their own params, and if not add a ? to start a list of params
	      url += url.indexOf('?') === -1 ? '?' : '&';
	
	      var jsonpScript = document.createElement('script');
	      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
	      if (options.charset) {
	        jsonpScript.setAttribute('charset', options.charset);
	      }
	      jsonpScript.id = scriptId;
	      document.getElementsByTagName('head')[0].appendChild(jsonpScript);
	
	      timeoutId = setTimeout(function () {
	        reject(new Error('JSONP request to ' + _url + ' timed out'));
	
	        clearFunction(callbackFunction);
	        removeScript(scriptId);
	        window[callbackFunction] = function () {
	          clearFunction(callbackFunction);
	        };
	      }, timeout);
	
	      // Caught if got 404/500
	      jsonpScript.onerror = function () {
	        reject(new Error('JSONP request to ' + _url + ' failed'));
	
	        clearFunction(callbackFunction);
	        removeScript(scriptId);
	        if (timeoutId) clearTimeout(timeoutId);
	      };
	    });
	  }
	
	  // export as global function
	  /*
	  let local;
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	  local.fetchJsonp = fetchJsonp;
	  */
	
	  module.exports = fetchJsonp;
	});

/***/ },
/* 2925 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 2926 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 2927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(668);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ },
/* 2928 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 2929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(249);
	
	var _PathUtils = __webpack_require__(209);
	
	var _ExecutionEnvironment = __webpack_require__(420);
	
	var _DOMUtils = __webpack_require__(671);
	
	var _DOMStateStorage = __webpack_require__(670);
	
	var _createDOMHistory = __webpack_require__(1284);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 2930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(249);
	
	var _PathUtils = __webpack_require__(209);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 2931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(141);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(209);
	
	var _Actions = __webpack_require__(249);
	
	var _createHistory = __webpack_require__(1286);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 2932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(829);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 2933 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {var t="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function r(t,r){return t(r={exports:{}},r.exports),r.exports}var e=r(function(t,r){var e;t.exports=e=e||function(t,r){var e=Object.create||function(){function t(){}return function(r){var e;return t.prototype=r,e=new t,t.prototype=null,e}}(),i={},n=i.lib={},o=n.Base={extend:function(t){var r=e(this);return t&&r.mixIn(t),r.hasOwnProperty("init")&&this.init!==r.init||(r.init=function(){r.$super.init.apply(this,arguments)}),r.init.prototype=r,r.$super=this,r},create:function(){var t=this.extend();return t.init.apply(t,arguments),t},init:function(){},mixIn:function(t){for(var r in t)t.hasOwnProperty(r)&&(this[r]=t[r]);t.hasOwnProperty("toString")&&(this.toString=t.toString)},clone:function(){return this.init.prototype.extend(this)}},s=n.WordArray=o.extend({init:function(t,r){t=this.words=t||[],this.sigBytes=null!=r?r:4*t.length},toString:function(t){return(t||u).stringify(this)},concat:function(t){var r=this.words,e=t.words,i=this.sigBytes,n=t.sigBytes;if(this.clamp(),i%4)for(var o=0;o<n;o++)r[i+o>>>2]|=(e[o>>>2]>>>24-o%4*8&255)<<24-(i+o)%4*8;else for(o=0;o<n;o+=4)r[i+o>>>2]=e[o>>>2];return this.sigBytes+=n,this},clamp:function(){var r=this.words,e=this.sigBytes;r[e>>>2]&=4294967295<<32-e%4*8,r.length=t.ceil(e/4)},clone:function(){var t=o.clone.call(this);return t.words=this.words.slice(0),t},random:function(r){for(var e,i=[],n=function(r){r=r;var e=987654321,i=4294967295;return function(){var n=((e=36969*(65535&e)+(e>>16)&i)<<16)+(r=18e3*(65535&r)+(r>>16)&i)&i;return n/=4294967296,(n+=.5)*(t.random()>.5?1:-1)}},o=0;o<r;o+=4){var h=n(4294967296*(e||t.random()));e=987654071*h(),i.push(4294967296*h()|0)}return new s.init(i,r)}}),h=i.enc={},u=h.Hex={stringify:function(t){for(var r=t.words,e=t.sigBytes,i=[],n=0;n<e;n++){var o=r[n>>>2]>>>24-n%4*8&255;i.push((o>>>4).toString(16)),i.push((15&o).toString(16))}return i.join("")},parse:function(t){for(var r=t.length,e=[],i=0;i<r;i+=2)e[i>>>3]|=parseInt(t.substr(i,2),16)<<24-i%8*4;return new s.init(e,r/2)}},a=h.Latin1={stringify:function(t){for(var r=t.words,e=t.sigBytes,i=[],n=0;n<e;n++)i.push(String.fromCharCode(r[n>>>2]>>>24-n%4*8&255));return i.join("")},parse:function(t){for(var r=t.length,e=[],i=0;i<r;i++)e[i>>>2]|=(255&t.charCodeAt(i))<<24-i%4*8;return new s.init(e,r)}},f=h.Utf8={stringify:function(t){try{return decodeURIComponent(escape(a.stringify(t)))}catch(t){throw new Error("Malformed UTF-8 data")}},parse:function(t){return a.parse(unescape(encodeURIComponent(t)))}},c=n.BufferedBlockAlgorithm=o.extend({reset:function(){this._data=new s.init,this._nDataBytes=0},_append:function(t){"string"==typeof t&&(t=f.parse(t)),this._data.concat(t),this._nDataBytes+=t.sigBytes},_process:function(r){var e=this._data,i=e.words,n=e.sigBytes,o=this.blockSize,h=n/(4*o),u=(h=r?t.ceil(h):t.max((0|h)-this._minBufferSize,0))*o,a=t.min(4*u,n);if(u){for(var f=0;f<u;f+=o)this._doProcessBlock(i,f);var c=i.splice(0,u);e.sigBytes-=a}return new s.init(c,a)},clone:function(){var t=o.clone.call(this);return t._data=this._data.clone(),t},_minBufferSize:0}),p=(n.Hasher=c.extend({cfg:o.extend(),init:function(t){this.cfg=this.cfg.extend(t),this.reset()},reset:function(){c.reset.call(this),this._doReset()},update:function(t){return this._append(t),this._process(),this},finalize:function(t){return t&&this._append(t),this._doFinalize()},blockSize:16,_createHelper:function(t){return function(r,e){return new t.init(e).finalize(r)}},_createHmacHelper:function(t){return function(r,e){return new p.HMAC.init(t,e).finalize(r)}}}),i.algo={});return i}(Math)}),i=r(function(t,r){var i;t.exports=(i=e,function(t){var r=i,e=r.lib,n=e.WordArray,o=e.Hasher,s=r.algo,h=[],u=[];!function(){function r(r){for(var e=t.sqrt(r),i=2;i<=e;i++)if(!(r%i))return!1;return!0}function e(t){return 4294967296*(t-(0|t))|0}for(var i=2,n=0;n<64;)r(i)&&(n<8&&(h[n]=e(t.pow(i,.5))),u[n]=e(t.pow(i,1/3)),n++),i++}();var a=[],f=s.SHA256=o.extend({_doReset:function(){this._hash=new n.init(h.slice(0))},_doProcessBlock:function(t,r){for(var e=this._hash.words,i=e[0],n=e[1],o=e[2],s=e[3],h=e[4],f=e[5],c=e[6],p=e[7],l=0;l<64;l++){if(l<16)a[l]=0|t[r+l];else{var d=a[l-15],v=a[l-2];a[l]=((d<<25|d>>>7)^(d<<14|d>>>18)^d>>>3)+a[l-7]+((v<<15|v>>>17)^(v<<13|v>>>19)^v>>>10)+a[l-16]}var y=i&n^i&o^n&o,m=p+((h<<26|h>>>6)^(h<<21|h>>>11)^(h<<7|h>>>25))+(h&f^~h&c)+u[l]+a[l];p=c,c=f,f=h,h=s+m|0,s=o,o=n,n=i,i=m+(((i<<30|i>>>2)^(i<<19|i>>>13)^(i<<10|i>>>22))+y)|0}e[0]=e[0]+i|0,e[1]=e[1]+n|0,e[2]=e[2]+o|0,e[3]=e[3]+s|0,e[4]=e[4]+h|0,e[5]=e[5]+f|0,e[6]=e[6]+c|0,e[7]=e[7]+p|0},_doFinalize:function(){var r=this._data,e=r.words,i=8*this._nDataBytes,n=8*r.sigBytes;return e[n>>>5]|=128<<24-n%32,e[14+(n+64>>>9<<4)]=t.floor(i/4294967296),e[15+(n+64>>>9<<4)]=i,r.sigBytes=4*e.length,this._process(),this._hash},clone:function(){var t=o.clone.call(this);return t._hash=this._hash.clone(),t}});r.SHA256=o._createHelper(f),r.HmacSHA256=o._createHmacHelper(f)}(Math),i.SHA256)}),n=r(function(t,r){var i,n;t.exports=(n=(i=e).lib.WordArray,i.enc.Base64={stringify:function(t){var r=t.words,e=t.sigBytes,i=this._map;t.clamp();for(var n=[],o=0;o<e;o+=3)for(var s=(r[o>>>2]>>>24-o%4*8&255)<<16|(r[o+1>>>2]>>>24-(o+1)%4*8&255)<<8|r[o+2>>>2]>>>24-(o+2)%4*8&255,h=0;h<4&&o+.75*h<e;h++)n.push(i.charAt(s>>>6*(3-h)&63));var u=i.charAt(64);if(u)for(;n.length%4;)n.push(u);return n.join("")},parse:function(t){var r=t.length,e=this._map,i=this._reverseMap;if(!i){i=this._reverseMap=[];for(var o=0;o<e.length;o++)i[e.charCodeAt(o)]=o}var s=e.charAt(64);if(s){var h=t.indexOf(s);-1!==h&&(r=h)}return function(t,r,e){for(var i=[],o=0,s=0;s<r;s++)if(s%4){var h=e[t.charCodeAt(s-1)]<<s%4*2,u=e[t.charCodeAt(s)]>>>6-s%4*2;i[o>>>2]|=(h|u)<<24-o%4*8,o++}return n.create(i,o)}(t,r,i)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="},i.enc.Base64)}),o=r(function(t,r){t.exports=e.enc.Hex}),s=r(function(r,e){(function(){var t;function e(t,r,e){null!=t&&("number"==typeof t?this.fromNumber(t,r,e):this.fromString(t,null==r&&"string"!=typeof t?256:r))}function i(){return new e(null)}var n="undefined"!=typeof navigator;n&&"Microsoft Internet Explorer"==navigator.appName?(e.prototype.am=function(t,r,e,i,n,o){for(var s=32767&r,h=r>>15;--o>=0;){var u=32767&this[t],a=this[t++]>>15,f=h*u+a*s;n=((u=s*u+((32767&f)<<15)+e[i]+(1073741823&n))>>>30)+(f>>>15)+h*a+(n>>>30),e[i++]=1073741823&u}return n},t=30):n&&"Netscape"!=navigator.appName?(e.prototype.am=function(t,r,e,i,n,o){for(;--o>=0;){var s=r*this[t++]+e[i]+n;n=Math.floor(s/67108864),e[i++]=67108863&s}return n},t=26):(e.prototype.am=function(t,r,e,i,n,o){for(var s=16383&r,h=r>>14;--o>=0;){var u=16383&this[t],a=this[t++]>>14,f=h*u+a*s;n=((u=s*u+((16383&f)<<14)+e[i]+n)>>28)+(f>>14)+h*a,e[i++]=268435455&u}return n},t=28),e.prototype.DB=t,e.prototype.DM=(1<<t)-1,e.prototype.DV=1<<t,e.prototype.FV=Math.pow(2,52),e.prototype.F1=52-t,e.prototype.F2=2*t-52;var o,s,h="0123456789abcdefghijklmnopqrstuvwxyz",u=new Array;for(o="0".charCodeAt(0),s=0;s<=9;++s)u[o++]=s;for(o="a".charCodeAt(0),s=10;s<36;++s)u[o++]=s;for(o="A".charCodeAt(0),s=10;s<36;++s)u[o++]=s;function a(t){return h.charAt(t)}function f(t,r){var e=u[t.charCodeAt(r)];return null==e?-1:e}function c(t){var r=i();return r.fromInt(t),r}function p(t){var r,e=1;return 0!=(r=t>>>16)&&(t=r,e+=16),0!=(r=t>>8)&&(t=r,e+=8),0!=(r=t>>4)&&(t=r,e+=4),0!=(r=t>>2)&&(t=r,e+=2),0!=(r=t>>1)&&(t=r,e+=1),e}function l(t){this.m=t}function d(t){this.m=t,this.mp=t.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<t.DB-15)-1,this.mt2=2*t.t}function v(t,r){return t&r}function y(t,r){return t|r}function m(t,r){return t^r}function g(t,r){return t&~r}function w(t){if(0==t)return-1;var r=0;return 0==(65535&t)&&(t>>=16,r+=16),0==(255&t)&&(t>>=8,r+=8),0==(15&t)&&(t>>=4,r+=4),0==(3&t)&&(t>>=2,r+=2),0==(1&t)&&++r,r}function T(t){for(var r=0;0!=t;)t&=t-1,++r;return r}function b(){}function _(t){return t}function S(t){this.r2=i(),this.q3=i(),e.ONE.dlShiftTo(2*t.t,this.r2),this.mu=this.r2.divide(t),this.m=t}l.prototype.convert=function(t){return t.s<0||t.compareTo(this.m)>=0?t.mod(this.m):t},l.prototype.revert=function(t){return t},l.prototype.reduce=function(t){t.divRemTo(this.m,null,t)},l.prototype.mulTo=function(t,r,e){t.multiplyTo(r,e),this.reduce(e)},l.prototype.sqrTo=function(t,r){t.squareTo(r),this.reduce(r)},d.prototype.convert=function(t){var r=i();return t.abs().dlShiftTo(this.m.t,r),r.divRemTo(this.m,null,r),t.s<0&&r.compareTo(e.ZERO)>0&&this.m.subTo(r,r),r},d.prototype.revert=function(t){var r=i();return t.copyTo(r),this.reduce(r),r},d.prototype.reduce=function(t){for(;t.t<=this.mt2;)t[t.t++]=0;for(var r=0;r<this.m.t;++r){var e=32767&t[r],i=e*this.mpl+((e*this.mph+(t[r]>>15)*this.mpl&this.um)<<15)&t.DM;for(t[e=r+this.m.t]+=this.m.am(0,i,t,r,0,this.m.t);t[e]>=t.DV;)t[e]-=t.DV,t[++e]++}t.clamp(),t.drShiftTo(this.m.t,t),t.compareTo(this.m)>=0&&t.subTo(this.m,t)},d.prototype.mulTo=function(t,r,e){t.multiplyTo(r,e),this.reduce(e)},d.prototype.sqrTo=function(t,r){t.squareTo(r),this.reduce(r)},e.prototype.copyTo=function(t){for(var r=this.t-1;r>=0;--r)t[r]=this[r];t.t=this.t,t.s=this.s},e.prototype.fromInt=function(t){this.t=1,this.s=t<0?-1:0,t>0?this[0]=t:t<-1?this[0]=t+this.DV:this.t=0},e.prototype.fromString=function(t,r){var i;if(16==r)i=4;else if(8==r)i=3;else if(256==r)i=8;else if(2==r)i=1;else if(32==r)i=5;else{if(4!=r)return void this.fromRadix(t,r);i=2}this.t=0,this.s=0;for(var n=t.length,o=!1,s=0;--n>=0;){var h=8==i?255&t[n]:f(t,n);h<0?"-"==t.charAt(n)&&(o=!0):(o=!1,0==s?this[this.t++]=h:s+i>this.DB?(this[this.t-1]|=(h&(1<<this.DB-s)-1)<<s,this[this.t++]=h>>this.DB-s):this[this.t-1]|=h<<s,(s+=i)>=this.DB&&(s-=this.DB))}8==i&&0!=(128&t[0])&&(this.s=-1,s>0&&(this[this.t-1]|=(1<<this.DB-s)-1<<s)),this.clamp(),o&&e.ZERO.subTo(this,this)},e.prototype.clamp=function(){for(var t=this.s&this.DM;this.t>0&&this[this.t-1]==t;)--this.t},e.prototype.dlShiftTo=function(t,r){var e;for(e=this.t-1;e>=0;--e)r[e+t]=this[e];for(e=t-1;e>=0;--e)r[e]=0;r.t=this.t+t,r.s=this.s},e.prototype.drShiftTo=function(t,r){for(var e=t;e<this.t;++e)r[e-t]=this[e];r.t=Math.max(this.t-t,0),r.s=this.s},e.prototype.lShiftTo=function(t,r){var e,i=t%this.DB,n=this.DB-i,o=(1<<n)-1,s=Math.floor(t/this.DB),h=this.s<<i&this.DM;for(e=this.t-1;e>=0;--e)r[e+s+1]=this[e]>>n|h,h=(this[e]&o)<<i;for(e=s-1;e>=0;--e)r[e]=0;r[s]=h,r.t=this.t+s+1,r.s=this.s,r.clamp()},e.prototype.rShiftTo=function(t,r){r.s=this.s;var e=Math.floor(t/this.DB);if(e>=this.t)r.t=0;else{var i=t%this.DB,n=this.DB-i,o=(1<<i)-1;r[0]=this[e]>>i;for(var s=e+1;s<this.t;++s)r[s-e-1]|=(this[s]&o)<<n,r[s-e]=this[s]>>i;i>0&&(r[this.t-e-1]|=(this.s&o)<<n),r.t=this.t-e,r.clamp()}},e.prototype.subTo=function(t,r){for(var e=0,i=0,n=Math.min(t.t,this.t);e<n;)i+=this[e]-t[e],r[e++]=i&this.DM,i>>=this.DB;if(t.t<this.t){for(i-=t.s;e<this.t;)i+=this[e],r[e++]=i&this.DM,i>>=this.DB;i+=this.s}else{for(i+=this.s;e<t.t;)i-=t[e],r[e++]=i&this.DM,i>>=this.DB;i-=t.s}r.s=i<0?-1:0,i<-1?r[e++]=this.DV+i:i>0&&(r[e++]=i),r.t=e,r.clamp()},e.prototype.multiplyTo=function(t,r){var i=this.abs(),n=t.abs(),o=i.t;for(r.t=o+n.t;--o>=0;)r[o]=0;for(o=0;o<n.t;++o)r[o+i.t]=i.am(0,n[o],r,o,0,i.t);r.s=0,r.clamp(),this.s!=t.s&&e.ZERO.subTo(r,r)},e.prototype.squareTo=function(t){for(var r=this.abs(),e=t.t=2*r.t;--e>=0;)t[e]=0;for(e=0;e<r.t-1;++e){var i=r.am(e,r[e],t,2*e,0,1);(t[e+r.t]+=r.am(e+1,2*r[e],t,2*e+1,i,r.t-e-1))>=r.DV&&(t[e+r.t]-=r.DV,t[e+r.t+1]=1)}t.t>0&&(t[t.t-1]+=r.am(e,r[e],t,2*e,0,1)),t.s=0,t.clamp()},e.prototype.divRemTo=function(t,r,n){var o=t.abs();if(!(o.t<=0)){var s=this.abs();if(s.t<o.t)return null!=r&&r.fromInt(0),void(null!=n&&this.copyTo(n));null==n&&(n=i());var h=i(),u=this.s,a=t.s,f=this.DB-p(o[o.t-1]);f>0?(o.lShiftTo(f,h),s.lShiftTo(f,n)):(o.copyTo(h),s.copyTo(n));var c=h.t,l=h[c-1];if(0!=l){var d=l*(1<<this.F1)+(c>1?h[c-2]>>this.F2:0),v=this.FV/d,y=(1<<this.F1)/d,m=1<<this.F2,g=n.t,w=g-c,T=null==r?i():r;for(h.dlShiftTo(w,T),n.compareTo(T)>=0&&(n[n.t++]=1,n.subTo(T,n)),e.ONE.dlShiftTo(c,T),T.subTo(h,h);h.t<c;)h[h.t++]=0;for(;--w>=0;){var b=n[--g]==l?this.DM:Math.floor(n[g]*v+(n[g-1]+m)*y);if((n[g]+=h.am(0,b,n,w,0,c))<b)for(h.dlShiftTo(w,T),n.subTo(T,n);n[g]<--b;)n.subTo(T,n)}null!=r&&(n.drShiftTo(c,r),u!=a&&e.ZERO.subTo(r,r)),n.t=c,n.clamp(),f>0&&n.rShiftTo(f,n),u<0&&e.ZERO.subTo(n,n)}}},e.prototype.invDigit=function(){if(this.t<1)return 0;var t=this[0];if(0==(1&t))return 0;var r=3&t;return(r=(r=(r=(r=r*(2-(15&t)*r)&15)*(2-(255&t)*r)&255)*(2-((65535&t)*r&65535))&65535)*(2-t*r%this.DV)%this.DV)>0?this.DV-r:-r},e.prototype.isEven=function(){return 0==(this.t>0?1&this[0]:this.s)},e.prototype.exp=function(t,r){if(t>4294967295||t<1)return e.ONE;var n=i(),o=i(),s=r.convert(this),h=p(t)-1;for(s.copyTo(n);--h>=0;)if(r.sqrTo(n,o),(t&1<<h)>0)r.mulTo(o,s,n);else{var u=n;n=o,o=u}return r.revert(n)},e.prototype.toString=function(t){if(this.s<0)return"-"+this.negate().toString(t);var r;if(16==t)r=4;else if(8==t)r=3;else if(2==t)r=1;else if(32==t)r=5;else{if(4!=t)return this.toRadix(t);r=2}var e,i=(1<<r)-1,n=!1,o="",s=this.t,h=this.DB-s*this.DB%r;if(s-- >0)for(h<this.DB&&(e=this[s]>>h)>0&&(n=!0,o=a(e));s>=0;)h<r?(e=(this[s]&(1<<h)-1)<<r-h,e|=this[--s]>>(h+=this.DB-r)):(e=this[s]>>(h-=r)&i,h<=0&&(h+=this.DB,--s)),e>0&&(n=!0),n&&(o+=a(e));return n?o:"0"},e.prototype.negate=function(){var t=i();return e.ZERO.subTo(this,t),t},e.prototype.abs=function(){return this.s<0?this.negate():this},e.prototype.compareTo=function(t){var r=this.s-t.s;if(0!=r)return r;var e=this.t;if(0!=(r=e-t.t))return this.s<0?-r:r;for(;--e>=0;)if(0!=(r=this[e]-t[e]))return r;return 0},e.prototype.bitLength=function(){return this.t<=0?0:this.DB*(this.t-1)+p(this[this.t-1]^this.s&this.DM)},e.prototype.mod=function(t){var r=i();return this.abs().divRemTo(t,null,r),this.s<0&&r.compareTo(e.ZERO)>0&&t.subTo(r,r),r},e.prototype.modPowInt=function(t,r){var e;return e=t<256||r.isEven()?new l(r):new d(r),this.exp(t,e)},e.ZERO=c(0),e.ONE=c(1),b.prototype.convert=_,b.prototype.revert=_,b.prototype.mulTo=function(t,r,e){t.multiplyTo(r,e)},b.prototype.sqrTo=function(t,r){t.squareTo(r)},S.prototype.convert=function(t){if(t.s<0||t.t>2*this.m.t)return t.mod(this.m);if(t.compareTo(this.m)<0)return t;var r=i();return t.copyTo(r),this.reduce(r),r},S.prototype.revert=function(t){return t},S.prototype.reduce=function(t){for(t.drShiftTo(this.m.t-1,this.r2),t.t>this.m.t+1&&(t.t=this.m.t+1,t.clamp()),this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3),this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);t.compareTo(this.r2)<0;)t.dAddOffset(1,this.m.t+1);for(t.subTo(this.r2,t);t.compareTo(this.m)>=0;)t.subTo(this.m,t)},S.prototype.mulTo=function(t,r,e){t.multiplyTo(r,e),this.reduce(e)},S.prototype.sqrTo=function(t,r){t.squareTo(r),this.reduce(r)};var A,B,D,x=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997],E=(1<<26)/x[x.length-1];function M(){var t;t=(new Date).getTime(),B[D++]^=255&t,B[D++]^=t>>8&255,B[D++]^=t>>16&255,B[D++]^=t>>24&255,D>=N&&(D-=N)}if(e.prototype.chunkSize=function(t){return Math.floor(Math.LN2*this.DB/Math.log(t))},e.prototype.toRadix=function(t){if(null==t&&(t=10),0==this.signum()||t<2||t>36)return"0";var r=this.chunkSize(t),e=Math.pow(t,r),n=c(e),o=i(),s=i(),h="";for(this.divRemTo(n,o,s);o.signum()>0;)h=(e+s.intValue()).toString(t).substr(1)+h,o.divRemTo(n,o,s);return s.intValue().toString(t)+h},e.prototype.fromRadix=function(t,r){this.fromInt(0),null==r&&(r=10);for(var i=this.chunkSize(r),n=Math.pow(r,i),o=!1,s=0,h=0,u=0;u<t.length;++u){var a=f(t,u);a<0?"-"==t.charAt(u)&&0==this.signum()&&(o=!0):(h=r*h+a,++s>=i&&(this.dMultiply(n),this.dAddOffset(h,0),s=0,h=0))}s>0&&(this.dMultiply(Math.pow(r,s)),this.dAddOffset(h,0)),o&&e.ZERO.subTo(this,this)},e.prototype.fromNumber=function(t,r,i){if("number"==typeof r)if(t<2)this.fromInt(1);else for(this.fromNumber(t,i),this.testBit(t-1)||this.bitwiseTo(e.ONE.shiftLeft(t-1),y,this),this.isEven()&&this.dAddOffset(1,0);!this.isProbablePrime(r);)this.dAddOffset(2,0),this.bitLength()>t&&this.subTo(e.ONE.shiftLeft(t-1),this);else{var n=new Array,o=7&t;n.length=1+(t>>3),r.nextBytes(n),o>0?n[0]&=(1<<o)-1:n[0]=0,this.fromString(n,256)}},e.prototype.bitwiseTo=function(t,r,e){var i,n,o=Math.min(t.t,this.t);for(i=0;i<o;++i)e[i]=r(this[i],t[i]);if(t.t<this.t){for(n=t.s&this.DM,i=o;i<this.t;++i)e[i]=r(this[i],n);e.t=this.t}else{for(n=this.s&this.DM,i=o;i<t.t;++i)e[i]=r(n,t[i]);e.t=t.t}e.s=r(this.s,t.s),e.clamp()},e.prototype.changeBit=function(t,r){var i=e.ONE.shiftLeft(t);return this.bitwiseTo(i,r,i),i},e.prototype.addTo=function(t,r){for(var e=0,i=0,n=Math.min(t.t,this.t);e<n;)i+=this[e]+t[e],r[e++]=i&this.DM,i>>=this.DB;if(t.t<this.t){for(i+=t.s;e<this.t;)i+=this[e],r[e++]=i&this.DM,i>>=this.DB;i+=this.s}else{for(i+=this.s;e<t.t;)i+=t[e],r[e++]=i&this.DM,i>>=this.DB;i+=t.s}r.s=i<0?-1:0,i>0?r[e++]=i:i<-1&&(r[e++]=this.DV+i),r.t=e,r.clamp()},e.prototype.dMultiply=function(t){this[this.t]=this.am(0,t-1,this,0,0,this.t),++this.t,this.clamp()},e.prototype.dAddOffset=function(t,r){if(0!=t){for(;this.t<=r;)this[this.t++]=0;for(this[r]+=t;this[r]>=this.DV;)this[r]-=this.DV,++r>=this.t&&(this[this.t++]=0),++this[r]}},e.prototype.multiplyLowerTo=function(t,r,e){var i,n=Math.min(this.t+t.t,r);for(e.s=0,e.t=n;n>0;)e[--n]=0;for(i=e.t-this.t;n<i;++n)e[n+this.t]=this.am(0,t[n],e,n,0,this.t);for(i=Math.min(t.t,r);n<i;++n)this.am(0,t[n],e,n,0,r-n);e.clamp()},e.prototype.multiplyUpperTo=function(t,r,e){var i=e.t=this.t+t.t- --r;for(e.s=0;--i>=0;)e[i]=0;for(i=Math.max(r-this.t,0);i<t.t;++i)e[this.t+i-r]=this.am(r-i,t[i],e,0,0,this.t+i-r);e.clamp(),e.drShiftTo(1,e)},e.prototype.modInt=function(t){if(t<=0)return 0;var r=this.DV%t,e=this.s<0?t-1:0;if(this.t>0)if(0==r)e=this[0]%t;else for(var i=this.t-1;i>=0;--i)e=(r*e+this[i])%t;return e},e.prototype.millerRabin=function(t){var r=this.subtract(e.ONE),n=r.getLowestSetBit();if(n<=0)return!1;var o=r.shiftRight(n);(t=t+1>>1)>x.length&&(t=x.length);for(var s=i(),h=0;h<t;++h){s.fromInt(x[Math.floor(Math.random()*x.length)]);var u=s.modPow(o,this);if(0!=u.compareTo(e.ONE)&&0!=u.compareTo(r)){for(var a=1;a++<n&&0!=u.compareTo(r);)if(0==(u=u.modPowInt(2,this)).compareTo(e.ONE))return!1;if(0!=u.compareTo(r))return!1}}return!0},e.prototype.clone=function(){var t=i();return this.copyTo(t),t},e.prototype.intValue=function(){if(this.s<0){if(1==this.t)return this[0]-this.DV;if(0==this.t)return-1}else{if(1==this.t)return this[0];if(0==this.t)return 0}return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0]},e.prototype.byteValue=function(){return 0==this.t?this.s:this[0]<<24>>24},e.prototype.shortValue=function(){return 0==this.t?this.s:this[0]<<16>>16},e.prototype.signum=function(){return this.s<0?-1:this.t<=0||1==this.t&&this[0]<=0?0:1},e.prototype.toByteArray=function(){var t=this.t,r=new Array;r[0]=this.s;var e,i=this.DB-t*this.DB%8,n=0;if(t-- >0)for(i<this.DB&&(e=this[t]>>i)!=(this.s&this.DM)>>i&&(r[n++]=e|this.s<<this.DB-i);t>=0;)i<8?(e=(this[t]&(1<<i)-1)<<8-i,e|=this[--t]>>(i+=this.DB-8)):(e=this[t]>>(i-=8)&255,i<=0&&(i+=this.DB,--t)),0!=(128&e)&&(e|=-256),0==n&&(128&this.s)!=(128&e)&&++n,(n>0||e!=this.s)&&(r[n++]=e);return r},e.prototype.equals=function(t){return 0==this.compareTo(t)},e.prototype.min=function(t){return this.compareTo(t)<0?this:t},e.prototype.max=function(t){return this.compareTo(t)>0?this:t},e.prototype.and=function(t){var r=i();return this.bitwiseTo(t,v,r),r},e.prototype.or=function(t){var r=i();return this.bitwiseTo(t,y,r),r},e.prototype.xor=function(t){var r=i();return this.bitwiseTo(t,m,r),r},e.prototype.andNot=function(t){var r=i();return this.bitwiseTo(t,g,r),r},e.prototype.not=function(){for(var t=i(),r=0;r<this.t;++r)t[r]=this.DM&~this[r];return t.t=this.t,t.s=~this.s,t},e.prototype.shiftLeft=function(t){var r=i();return t<0?this.rShiftTo(-t,r):this.lShiftTo(t,r),r},e.prototype.shiftRight=function(t){var r=i();return t<0?this.lShiftTo(-t,r):this.rShiftTo(t,r),r},e.prototype.getLowestSetBit=function(){for(var t=0;t<this.t;++t)if(0!=this[t])return t*this.DB+w(this[t]);return this.s<0?this.t*this.DB:-1},e.prototype.bitCount=function(){for(var t=0,r=this.s&this.DM,e=0;e<this.t;++e)t+=T(this[e]^r);return t},e.prototype.testBit=function(t){var r=Math.floor(t/this.DB);return r>=this.t?0!=this.s:0!=(this[r]&1<<t%this.DB)},e.prototype.setBit=function(t){return this.changeBit(t,y)},e.prototype.clearBit=function(t){return this.changeBit(t,g)},e.prototype.flipBit=function(t){return this.changeBit(t,m)},e.prototype.add=function(t){var r=i();return this.addTo(t,r),r},e.prototype.subtract=function(t){var r=i();return this.subTo(t,r),r},e.prototype.multiply=function(t){var r=i();return this.multiplyTo(t,r),r},e.prototype.divide=function(t){var r=i();return this.divRemTo(t,r,null),r},e.prototype.remainder=function(t){var r=i();return this.divRemTo(t,null,r),r},e.prototype.divideAndRemainder=function(t){var r=i(),e=i();return this.divRemTo(t,r,e),new Array(r,e)},e.prototype.modPow=function(t,r){var e,n,o=t.bitLength(),s=c(1);if(o<=0)return s;e=o<18?1:o<48?3:o<144?4:o<768?5:6,n=o<8?new l(r):r.isEven()?new S(r):new d(r);var h=new Array,u=3,a=e-1,f=(1<<e)-1;if(h[1]=n.convert(this),e>1){var v=i();for(n.sqrTo(h[1],v);u<=f;)h[u]=i(),n.mulTo(v,h[u-2],h[u]),u+=2}var y,m,g=t.t-1,w=!0,T=i();for(o=p(t[g])-1;g>=0;){for(o>=a?y=t[g]>>o-a&f:(y=(t[g]&(1<<o+1)-1)<<a-o,g>0&&(y|=t[g-1]>>this.DB+o-a)),u=e;0==(1&y);)y>>=1,--u;if((o-=u)<0&&(o+=this.DB,--g),w)h[y].copyTo(s),w=!1;else{for(;u>1;)n.sqrTo(s,T),n.sqrTo(T,s),u-=2;u>0?n.sqrTo(s,T):(m=s,s=T,T=m),n.mulTo(T,h[y],s)}for(;g>=0&&0==(t[g]&1<<o);)n.sqrTo(s,T),m=s,s=T,T=m,--o<0&&(o=this.DB-1,--g)}return n.revert(s)},e.prototype.modInverse=function(t){var r=t.isEven();if(this.isEven()&&r||0==t.signum())return e.ZERO;for(var i=t.clone(),n=this.clone(),o=c(1),s=c(0),h=c(0),u=c(1);0!=i.signum();){for(;i.isEven();)i.rShiftTo(1,i),r?(o.isEven()&&s.isEven()||(o.addTo(this,o),s.subTo(t,s)),o.rShiftTo(1,o)):s.isEven()||s.subTo(t,s),s.rShiftTo(1,s);for(;n.isEven();)n.rShiftTo(1,n),r?(h.isEven()&&u.isEven()||(h.addTo(this,h),u.subTo(t,u)),h.rShiftTo(1,h)):u.isEven()||u.subTo(t,u),u.rShiftTo(1,u);i.compareTo(n)>=0?(i.subTo(n,i),r&&o.subTo(h,o),s.subTo(u,s)):(n.subTo(i,n),r&&h.subTo(o,h),u.subTo(s,u))}return 0!=n.compareTo(e.ONE)?e.ZERO:u.compareTo(t)>=0?u.subtract(t):u.signum()<0?(u.addTo(t,u),u.signum()<0?u.add(t):u):u},e.prototype.pow=function(t){return this.exp(t,new b)},e.prototype.gcd=function(t){var r=this.s<0?this.negate():this.clone(),e=t.s<0?t.negate():t.clone();if(r.compareTo(e)<0){var i=r;r=e,e=i}var n=r.getLowestSetBit(),o=e.getLowestSetBit();if(o<0)return r;for(n<o&&(o=n),o>0&&(r.rShiftTo(o,r),e.rShiftTo(o,e));r.signum()>0;)(n=r.getLowestSetBit())>0&&r.rShiftTo(n,r),(n=e.getLowestSetBit())>0&&e.rShiftTo(n,e),r.compareTo(e)>=0?(r.subTo(e,r),r.rShiftTo(1,r)):(e.subTo(r,e),e.rShiftTo(1,e));return o>0&&e.lShiftTo(o,e),e},e.prototype.isProbablePrime=function(t){var r,e=this.abs();if(1==e.t&&e[0]<=x[x.length-1]){for(r=0;r<x.length;++r)if(e[0]==x[r])return!0;return!1}if(e.isEven())return!1;for(r=1;r<x.length;){for(var i=x[r],n=r+1;n<x.length&&i<E;)i*=x[n++];for(i=e.modInt(i);r<n;)if(i%x[r++]==0)return!1}return e.millerRabin(t)},e.prototype.square=function(){var t=i();return this.squareTo(t),t},e.prototype.Barrett=S,null==B){var C;if(B=new Array,D=0,"undefined"!=typeof window&&window.crypto)if(window.crypto.getRandomValues){var R=new Uint8Array(32);for(window.crypto.getRandomValues(R),C=0;C<32;++C)B[D++]=R[C]}else if("Netscape"==navigator.appName&&navigator.appVersion<"5"){var k=window.crypto.random(32);for(C=0;C<k.length;++C)B[D++]=255&k.charCodeAt(C)}for(;D<N;)C=Math.floor(65536*Math.random()),B[D++]=C>>>8,B[D++]=255&C;D=0,M()}function j(){if(null==A){for(M(),(A=new I).init(B),D=0;D<B.length;++D)B[D]=0;D=0}return A.next()}function O(){}function I(){this.i=0,this.j=0,this.S=new Array}O.prototype.nextBytes=function(t){var r;for(r=0;r<t.length;++r)t[r]=j()},I.prototype.init=function(t){var r,e,i;for(r=0;r<256;++r)this.S[r]=r;for(e=0,r=0;r<256;++r)i=this.S[r],this.S[r]=this.S[e=e+this.S[r]+t[r%t.length]&255],this.S[e]=i;this.i=0,this.j=0},I.prototype.next=function(){var t;return this.i=this.i+1&255,this.j=this.j+this.S[this.i]&255,t=this.S[this.i],this.S[this.i]=this.S[this.j],this.S[this.j]=t,this.S[t+this.S[this.i]&255]};var N=256;r.exports={default:e,BigInteger:e,SecureRandom:O}}).call(t)}).BigInteger,h={sha1:"3021300906052b0e03021a05000414",sha224:"302d300d06096086480165030402040500041c",sha256:"3031300d060960864801650304020105000420",sha384:"3041300d060960864801650304020205000430",sha512:"3051300d060960864801650304020305000440",md2:"3020300c06082a864886f70d020205000410",md5:"3020300c06082a864886f70d020505000410",ripemd160:"3021300906052b2403020105000414"},u={sha256:i};function a(t,r){if(this.n=null,this.e=0,!(null!=t&&null!=r&&t.length>0&&r.length>0))throw new Error("Invalid key data");this.n=new s(t,16),this.e=parseInt(r,16)}a.prototype.verify=function(t,r){r=r.replace(/[^0-9a-f]|[\s\n]]/gi,"");var e=new s(r,16);if(e.bitLength()>this.n.bitLength())throw new Error("Signature does not match with the key modulus.");var i=function(t){for(var r in h){var e=h[r],i=e.length;if(t.substring(0,i)===e)return{alg:r,hash:t.substring(i)}}return[]}(e.modPowInt(this.e,this.n).toString(16).replace(/^1f+00/,""));if(0===i.length)return!1;if(!u.hasOwnProperty(i.alg))throw new Error("Hashing algorithm is not supported.");var n=u[i.alg](t).toString();return i.hash===n};for(var f=[],c=[],p="undefined"!=typeof Uint8Array?Uint8Array:Array,l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",d=0,v=l.length;d<v;++d)f[d]=l[d],c[l.charCodeAt(d)]=d;function y(t){var r=t.length;if(r%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var e=t.indexOf("=");return-1===e&&(e=r),[e,e===r?0:4-e%4]}function m(t,r,e){for(var i,n=[],o=r;o<e;o+=3)n.push(f[(i=(t[o]<<16&16711680)+(t[o+1]<<8&65280)+(255&t[o+2]))>>18&63]+f[i>>12&63]+f[i>>6&63]+f[63&i]);return n.join("")}c["-".charCodeAt(0)]=62,c["_".charCodeAt(0)]=63;var g={byteLength:function(t){var r=y(t),e=r[1];return 3*(r[0]+e)/4-e},toByteArray:function(t){var r,e,i=y(t),n=i[0],o=i[1],s=new p(function(t,r,e){return 3*(r+e)/4-e}(0,n,o)),h=0,u=o>0?n-4:n;for(e=0;e<u;e+=4)r=c[t.charCodeAt(e)]<<18|c[t.charCodeAt(e+1)]<<12|c[t.charCodeAt(e+2)]<<6|c[t.charCodeAt(e+3)],s[h++]=r>>16&255,s[h++]=r>>8&255,s[h++]=255&r;return 2===o&&(r=c[t.charCodeAt(e)]<<2|c[t.charCodeAt(e+1)]>>4,s[h++]=255&r),1===o&&(r=c[t.charCodeAt(e)]<<10|c[t.charCodeAt(e+1)]<<4|c[t.charCodeAt(e+2)]>>2,s[h++]=r>>8&255,s[h++]=255&r),s},fromByteArray:function(t){for(var r,e=t.length,i=e%3,n=[],o=0,s=e-i;o<s;o+=16383)n.push(m(t,o,o+16383>s?s:o+16383));return 1===i?n.push(f[(r=t[e-1])>>2]+f[r<<4&63]+"=="):2===i&&n.push(f[(r=(t[e-2]<<8)+t[e-1])>>10]+f[r>>4&63]+f[r<<2&63]+"="),n.join("")}};function w(t){var r=t.length%4;return 0===r?t:t+new Array(4-r+1).join("=")}function T(t){return t=w(t).replace(/\-/g,"+").replace(/_/g,"/"),decodeURIComponent(function(t){for(var r="",e=0;e<t.length;e++)r+=String.fromCharCode(t[e]);return r}(g.toByteArray(t)).split("").map(function(t){return"%"+("00"+t.charCodeAt(0).toString(16)).slice(-2)}).join(""))}function b(t){return function(t){for(var r="",e=0;e<t.length;e++){var i=t[e].toString(16);r+=2===i.length?i:"0"+i}return r}(g.toByteArray(w(t)))}var _=r(function(r,e){r.exports=function(){function r(t){return"function"==typeof t}var e=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)},i=0,n=void 0,o=void 0,s=function(t,r){l[i]=t,l[i+1]=r,2===(i+=2)&&(o?o(d):w())},h="undefined"!=typeof window?window:void 0,u=h||{},a=u.MutationObserver||u.WebKitMutationObserver,f="undefined"==typeof self&&"undefined"!=typeof process&&"[object process]"==={}.toString.call(process),c="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel;function p(){var t=setTimeout;return function(){return t(d,1)}}var l=new Array(1e3);function d(){for(var t=0;t<i;t+=2)(0,l[t])(l[t+1]),l[t]=void 0,l[t+1]=void 0;i=0}var v,y,m,g,w=void 0;function T(t,r){var e=this,i=new this.constructor(S);void 0===i[_]&&N(i);var n=e._state;if(n){var o=arguments[n-1];s(function(){return O(n,i,o,e._result)})}else k(e,i,t,r);return i}function b(t){if(t&&"object"==typeof t&&t.constructor===this)return t;var r=new this(S);return E(r,t),r}f?w=function(){return process.nextTick(d)}:a?(y=0,m=new a(d),g=document.createTextNode(""),m.observe(g,{characterData:!0}),w=function(){g.data=y=++y%2}):c?((v=new MessageChannel).port1.onmessage=d,w=function(){return v.port2.postMessage(0)}):w=void 0===h?function(){try{var t=Function("return this")().require("vertx");return void 0!==(n=t.runOnLoop||t.runOnContext)?function(){n(d)}:p()}catch(t){return p()}}():p();var _=Math.random().toString(36).substring(2);function S(){}var A=void 0,B=1,D=2;function x(t,e,i){e.constructor===t.constructor&&i===T&&e.constructor.resolve===b?function(t,r){r._state===B?C(t,r._result):r._state===D?R(t,r._result):k(r,void 0,function(r){return E(t,r)},function(r){return R(t,r)})}(t,e):void 0===i?C(t,e):r(i)?function(t,r,e){s(function(t){var i=!1,n=function(e,n,o,s){try{e.call(n,function(e){i||(i=!0,r!==e?E(t,e):C(t,e))},function(r){i||(i=!0,R(t,r))})}catch(t){return t}}(e,r);!i&&n&&(i=!0,R(t,n))},t)}(t,e,i):C(t,e)}function E(t,r){if(t===r)R(t,new TypeError("You cannot resolve a promise with itself"));else if(n=typeof(i=r),null===i||"object"!==n&&"function"!==n)C(t,r);else{var e=void 0;try{e=r.then}catch(r){return void R(t,r)}x(t,r,e)}var i,n}function M(t){t._onerror&&t._onerror(t._result),j(t)}function C(t,r){t._state===A&&(t._result=r,t._state=B,0!==t._subscribers.length&&s(j,t))}function R(t,r){t._state===A&&(t._state=D,t._result=r,s(M,t))}function k(t,r,e,i){var n=t._subscribers,o=n.length;t._onerror=null,n[o]=r,n[o+B]=e,n[o+D]=i,0===o&&t._state&&s(j,t)}function j(t){var r=t._subscribers,e=t._state;if(0!==r.length){for(var i=void 0,n=void 0,o=t._result,s=0;s<r.length;s+=3)n=r[s+e],(i=r[s])?O(e,i,n,o):n(o);t._subscribers.length=0}}function O(t,e,i,n){var o=r(i),s=void 0,h=void 0,u=!0;if(o){try{s=i(n)}catch(t){u=!1,h=t}if(e===s)return void R(e,new TypeError("A promises callback cannot return that same promise."))}else s=n;e._state!==A||(o&&u?E(e,s):!1===u?R(e,h):t===B?C(e,s):t===D&&R(e,s))}var I=0;function N(t){t[_]=I++,t._state=void 0,t._result=void 0,t._subscribers=[]}var P=function(){function t(t,r){this._instanceConstructor=t,this.promise=new t(S),this.promise[_]||N(this.promise),e(r)?(this.length=r.length,this._remaining=r.length,this._result=new Array(this.length),0===this.length?C(this.promise,this._result):(this.length=this.length||0,this._enumerate(r),0===this._remaining&&C(this.promise,this._result))):R(this.promise,new Error("Array Methods must be provided an Array"))}return t.prototype._enumerate=function(t){for(var r=0;this._state===A&&r<t.length;r++)this._eachEntry(t[r],r)},t.prototype._eachEntry=function(t,r){var e=this._instanceConstructor,i=e.resolve;if(i===b){var n=void 0,o=void 0,s=!1;try{n=t.then}catch(t){s=!0,o=t}if(n===T&&t._state!==A)this._settledAt(t._state,r,t._result);else if("function"!=typeof n)this._remaining--,this._result[r]=t;else if(e===V){var h=new e(S);s?R(h,o):x(h,t,n),this._willSettleAt(h,r)}else this._willSettleAt(new e(function(r){return r(t)}),r)}else this._willSettleAt(i(t),r)},t.prototype._settledAt=function(t,r,e){var i=this.promise;i._state===A&&(this._remaining--,t===D?R(i,e):this._result[r]=e),0===this._remaining&&C(i,this._result)},t.prototype._willSettleAt=function(t,r){var e=this;k(t,void 0,function(t){return e._settledAt(B,r,t)},function(t){return e._settledAt(D,r,t)})},t}(),V=function(){function t(r){this[_]=I++,this._result=this._state=void 0,this._subscribers=[],S!==r&&("function"!=typeof r&&function(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}(),this instanceof t?function(t,r){try{r(function(r){E(t,r)},function(r){R(t,r)})}catch(r){R(t,r)}}(this,r):function(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}())}return t.prototype.catch=function(t){return this.then(null,t)},t.prototype.finally=function(t){var e=this.constructor;return r(t)?this.then(function(r){return e.resolve(t()).then(function(){return r})},function(r){return e.resolve(t()).then(function(){throw r})}):this.then(t,t)},t}();return V.prototype.then=T,V.all=function(t){return new P(this,t).promise},V.race=function(t){var r=this;return e(t)?new r(function(e,i){for(var n=t.length,o=0;o<n;o++)r.resolve(t[o]).then(e,i)}):new r(function(t,r){return r(new TypeError("You must pass an array to race."))})},V.resolve=b,V.reject=function(t){var r=new this(S);return R(r,t),r},V._setScheduler=function(t){o=t},V._setAsap=function(t){s=t},V._asap=s,V.polyfill=function(){var r=void 0;if(void 0!==t)r=t;else if("undefined"!=typeof self)r=self;else try{r=Function("return this")()}catch(t){throw new Error("polyfill failed because global object is unavailable in this environment")}var e=r.Promise;if(e){var i=null;try{i=Object.prototype.toString.call(e.resolve())}catch(t){}if("[object Promise]"===i&&!e.cast)return}r.Promise=V},V.Promise=V,V}()}),S=r(function(r){var e,i;e=t,i=function(){return function(){return function(t){var r=[];if(0===t.length)return"";if("string"!=typeof t[0])throw new TypeError("Url must be a string. Received "+t[0]);if(t[0].match(/^[^/:]+:\/*$/)&&t.length>1){var e=t.shift();t[0]=e+t[0]}t[0]=t[0].match(/^file:\/\/\//)?t[0].replace(/^([^/:]+):\/*/,"$1:///"):t[0].replace(/^([^/:]+):\/*/,"$1://");for(var i=0;i<t.length;i++){var n=t[i];if("string"!=typeof n)throw new TypeError("Url must be a string. Received "+n);""!==n&&(i>0&&(n=n.replace(/^[\/]+/,"")),n=n.replace(/[\/]+$/,i<t.length-1?"":"/"),r.push(n))}var o=r.join("/"),s=(o=o.replace(/\/(\?|&|#[^!])/g,"$1")).split("?");return s.shift()+(s.length>0?"?":"")+s.join("&")}("object"==typeof arguments[0]?arguments[0]:[].slice.call(arguments))}},r.exports?r.exports=i():e.urljoin=i()});function A(t){if(t.ok)return t.json();var r=new Error(t.statusText);return r.response=t,Promise.reject(r)}function B(t){this.name="ConfigurationError",this.message=t||""}function D(t){this.name="TokenValidationError",this.message=t||""}_.polyfill(),B.prototype=Error.prototype,D.prototype=Error.prototype;var x=function(){};x.prototype.get=function(){return null},x.prototype.has=function(){return null},x.prototype.set=function(){return null};var E=["RS256"];function M(t){var r=t||{};if(this.jwksCache=r.jwksCache||new x,this.expectedAlg=r.expectedAlg||"RS256",this.issuer=r.issuer,this.audience=r.audience,this.leeway=r.leeway||0,this.__disableExpirationCheck=r.__disableExpirationCheck||!1,this.jwksURI=r.jwksURI,this.leeway<0||this.leeway>300)throw new B("The leeway should be positive and lower than five minutes.");if(-1===E.indexOf(this.expectedAlg))throw new B("Algorithm "+this.expectedAlg+" is not supported. (Expected algs: ["+E.join(",")+"])")}M.prototype.verify=function(t,r,e){var i=this.decode(t);if(i instanceof Error)return e(i,!1);var n=i.encoded.header+"."+i.encoded.payload,o=b(i.encoded.signature),s=i.header.alg,h=i.header.kid,u=i.payload.aud,a=i.payload.iss,f=i.payload.exp,c=i.payload.nbf,p=i.payload.nonce||null,l=this;if(l.expectedAlg!==s)return e(new D("Algorithm "+s+" is not supported. (Expected algs: ["+E.join(",")+"])"),!1);this.getRsaVerifier(a,h,function(t,s){if(t)return e(t);if(s.verify(n,o)){if(l.issuer!==a)return e(new D("Issuer "+a+" is not valid."),!1);if(l.audience!==u)return e(new D("Audience "+u+" is not valid."),!1);if(p!==r)return e(new D("Nonce does not match."),!1);var h=l.verifyExpAndNbf(f,c);return h?e(h,!1):e(null,i.payload)}return e(new D("Invalid signature."))})},M.prototype.verifyExpAndNbf=function(t,r){console.warn("This method is deprecated and will be removed in the next major version");var e=new Date,i=new Date(0),n=new Date(0);return this.__disableExpirationCheck?null:(i.setUTCSeconds(t+this.leeway),e>i?new D("Expired token."):void 0===r?null:(n.setUTCSeconds(r-this.leeway),e<n?new D("The token is not valid until later in the future. Please check your computed clock."):null))},M.prototype.verifyExpAndIat=function(t,r){console.warn("This method is deprecated and will be removed in the next major version");var e=new Date,i=new Date(0),n=new Date(0);return this.__disableExpirationCheck?null:(i.setUTCSeconds(t+this.leeway),e>i?new D("Expired token."):(n.setUTCSeconds(r-this.leeway),e<n?new D("The token was issued in the future. Please check your computed clock."):null))},M.prototype.getRsaVerifier=function(t,r,e){var i=this,n=t+r;if(this.jwksCache.has(n)){var o=this.jwksCache.get(n);e(null,new a(o.modulus,o.exp))}else!function(t,r){("undefined"==typeof fetch?function(t,r){return r=r||{},new Promise(function(e,i){var n=new XMLHttpRequest,o=[],s=[],h={},u=function(){return{ok:2==(n.status/100|0),statusText:n.statusText,status:n.status,url:n.responseURL,text:function(){return Promise.resolve(n.responseText)},json:function(){return Promise.resolve(JSON.parse(n.responseText))},blob:function(){return Promise.resolve(new Blob([n.response]))},clone:u,headers:{keys:function(){return o},entries:function(){return s},get:function(t){return h[t.toLowerCase()]},has:function(t){return t.toLowerCase()in h}}}};for(var a in n.open(r.method||"get",t,!0),n.onload=function(){n.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(t,r,e){o.push(r=r.toLowerCase()),s.push([r,e]),h[r]=h[r]?h[r]+","+e:e}),e(u())},n.onerror=i,n.withCredentials="include"==r.credentials,r.headers)n.setRequestHeader(a,r.headers[a]);n.send(r.body||null)})}:fetch)(t.jwksURI||S(t.iss,".well-known","jwks.json")).then(A).then(function(e){var i,n,o,s=null;for(i=0;i<e.keys.length&&null===s;i++)(n=e.keys[i]).kid===t.kid&&(s=n);return r(null,{modulus:b((o=s).n),exp:b(o.e)})}).catch(function(t){r(t)})}({jwksURI:this.jwksURI,iss:t,kid:r},function(t,r){return t?e(t):(i.jwksCache.set(n,r),e(null,new a(r.modulus,r.exp)))})},M.prototype.decode=function(t){var r,e,i=t.split(".");if(3!==i.length)return new D("Cannot decode a malformed JWT");try{r=JSON.parse(T(i[0])),e=JSON.parse(T(i[1]))}catch(t){return new D("Token header or payload is not valid JSON")}return{header:r,payload:e,encoded:{header:i[0],payload:i[1],signature:i[2]}}},M.prototype.validateAccessToken=function(t,r,e,s){if(this.expectedAlg!==r)return s(new D("Algorithm "+r+" is not supported. (Expected alg: "+this.expectedAlg+")"));var h,u=i(t),a=o.stringify(u),f=a.substring(0,a.length/2),c=o.parse(f),p=n.stringify(c);return s((h={"+":"-","/":"_","=":""},p.replace(/[+/=]/g,function(t){return h[t]})!==e?new D("Invalid access_token"):null))},module.exports=M;
	//# sourceMappingURL=idtoken-verifier.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(66)))

/***/ },
/* 2934 */
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 2935 */
/***/ function(module, exports) {

	'use strict'
	
	function extend(dest, src) {
	  if (src) {
	    var props = Object.keys(src)
	    for (var i = 0, l = props.length; i < l ; i++) {
	      dest[props[i]] = src[props[i]]
	    }
	  }
	  return dest
	}
	
	function copy(obj) {
	  return extend({}, obj)
	}
	
	/**
	 * Merge an object defining format characters into the defaults.
	 * Passing null/undefined for en existing format character removes it.
	 * Passing a definition for an existing format character overrides it.
	 * @param {?Object} formatCharacters.
	 */
	function mergeFormatCharacters(formatCharacters) {
	  var merged = copy(DEFAULT_FORMAT_CHARACTERS)
	  if (formatCharacters) {
	    var chars = Object.keys(formatCharacters)
	    for (var i = 0, l = chars.length; i < l ; i++) {
	      var char = chars[i]
	      if (formatCharacters[char] == null) {
	        delete merged[char]
	      }
	      else {
	        merged[char] = formatCharacters[char]
	      }
	    }
	  }
	  return merged
	}
	
	var ESCAPE_CHAR = '\\'
	
	var DIGIT_RE = /^\d$/
	var LETTER_RE = /^[A-Za-z]$/
	var ALPHANNUMERIC_RE = /^[\dA-Za-z]$/
	
	var DEFAULT_PLACEHOLDER_CHAR = '_'
	var DEFAULT_FORMAT_CHARACTERS = {
	  '*': {
	    validate: function(char) { return ALPHANNUMERIC_RE.test(char) }
	  },
	  '1': {
	    validate: function(char) { return DIGIT_RE.test(char) }
	  },
	  'a': {
	    validate: function(char) { return LETTER_RE.test(char) }
	  },
	  'A': {
	    validate: function(char) { return LETTER_RE.test(char) },
	    transform: function(char) { return char.toUpperCase() }
	  },
	  '#': {
	    validate: function(char) { return ALPHANNUMERIC_RE.test(char) },
	    transform: function(char) { return char.toUpperCase() }
	  }
	}
	
	/**
	 * @param {string} source
	 * @patam {?Object} formatCharacters
	 */
	function Pattern(source, formatCharacters, placeholderChar, isRevealingMask) {
	  if (!(this instanceof Pattern)) {
	    return new Pattern(source, formatCharacters, placeholderChar)
	  }
	
	  /** Placeholder character */
	  this.placeholderChar = placeholderChar || DEFAULT_PLACEHOLDER_CHAR
	  /** Format character definitions. */
	  this.formatCharacters = formatCharacters || DEFAULT_FORMAT_CHARACTERS
	  /** Pattern definition string with escape characters. */
	  this.source = source
	  /** Pattern characters after escape characters have been processed. */
	  this.pattern = []
	  /** Length of the pattern after escape characters have been processed. */
	  this.length = 0
	  /** Index of the first editable character. */
	  this.firstEditableIndex = null
	  /** Index of the last editable character. */
	  this.lastEditableIndex = null
	  /** Lookup for indices of editable characters in the pattern. */
	  this._editableIndices = {}
	  /** If true, only the pattern before the last valid value character shows. */
	  this.isRevealingMask = isRevealingMask || false
	
	  this._parse()
	}
	
	Pattern.prototype._parse = function parse() {
	  var sourceChars = this.source.split('')
	  var patternIndex = 0
	  var pattern = []
	
	  for (var i = 0, l = sourceChars.length; i < l; i++) {
	    var char = sourceChars[i]
	    if (char === ESCAPE_CHAR) {
	      if (i === l - 1) {
	        throw new Error('InputMask: pattern ends with a raw ' + ESCAPE_CHAR)
	      }
	      char = sourceChars[++i]
	    }
	    else if (char in this.formatCharacters) {
	      if (this.firstEditableIndex === null) {
	        this.firstEditableIndex = patternIndex
	      }
	      this.lastEditableIndex = patternIndex
	      this._editableIndices[patternIndex] = true
	    }
	
	    pattern.push(char)
	    patternIndex++
	  }
	
	  if (this.firstEditableIndex === null) {
	    throw new Error(
	      'InputMask: pattern "' + this.source + '" does not contain any editable characters.'
	    )
	  }
	
	  this.pattern = pattern
	  this.length = pattern.length
	}
	
	/**
	 * @param {Array<string>} value
	 * @return {Array<string>}
	 */
	Pattern.prototype.formatValue = function format(value) {
	  var valueBuffer = new Array(this.length)
	  var valueIndex = 0
	
	  for (var i = 0, l = this.length; i < l ; i++) {
	    if (this.isEditableIndex(i)) {
	      if (this.isRevealingMask &&
	          value.length <= valueIndex &&
	          !this.isValidAtIndex(value[valueIndex], i)) {
	        break
	      }
	      valueBuffer[i] = (value.length > valueIndex && this.isValidAtIndex(value[valueIndex], i)
	                        ? this.transform(value[valueIndex], i)
	                        : this.placeholderChar)
	      valueIndex++
	    }
	    else {
	      valueBuffer[i] = this.pattern[i]
	      // Also allow the value to contain static values from the pattern by
	      // advancing its index.
	      if (value.length > valueIndex && value[valueIndex] === this.pattern[i]) {
	        valueIndex++
	      }
	    }
	  }
	
	  return valueBuffer
	}
	
	/**
	 * @param {number} index
	 * @return {boolean}
	 */
	Pattern.prototype.isEditableIndex = function isEditableIndex(index) {
	  return !!this._editableIndices[index]
	}
	
	/**
	 * @param {string} char
	 * @param {number} index
	 * @return {boolean}
	 */
	Pattern.prototype.isValidAtIndex = function isValidAtIndex(char, index) {
	  return this.formatCharacters[this.pattern[index]].validate(char)
	}
	
	Pattern.prototype.transform = function transform(char, index) {
	  var format = this.formatCharacters[this.pattern[index]]
	  return typeof format.transform == 'function' ? format.transform(char) : char
	}
	
	function InputMask(options) {
	  if (!(this instanceof InputMask)) { return new InputMask(options) }
	  options = extend({
	    formatCharacters: null,
	    pattern: null,
	    isRevealingMask: false,
	    placeholderChar: DEFAULT_PLACEHOLDER_CHAR,
	    selection: {start: 0, end: 0},
	    value: ''
	  }, options)
	
	  if (options.pattern == null) {
	    throw new Error('InputMask: you must provide a pattern.')
	  }
	
	  if (typeof options.placeholderChar !== 'string' || options.placeholderChar.length > 1) {
	    throw new Error('InputMask: placeholderChar should be a single character or an empty string.')
	  }
	
	  this.placeholderChar = options.placeholderChar
	  this.formatCharacters = mergeFormatCharacters(options.formatCharacters)
	  this.setPattern(options.pattern, {
	    value: options.value,
	    selection: options.selection,
	    isRevealingMask: options.isRevealingMask
	  })
	}
	
	// Editing
	
	/**
	 * Applies a single character of input based on the current selection.
	 * @param {string} char
	 * @return {boolean} true if a change has been made to value or selection as a
	 *   result of the input, false otherwise.
	 */
	InputMask.prototype.input = function input(char) {
	  // Ignore additional input if the cursor's at the end of the pattern
	  if (this.selection.start === this.selection.end &&
	      this.selection.start === this.pattern.length) {
	    return false
	  }
	
	  var selectionBefore = copy(this.selection)
	  var valueBefore = this.getValue()
	
	  var inputIndex = this.selection.start
	
	  // If the cursor or selection is prior to the first editable character, make
	  // sure any input given is applied to it.
	  if (inputIndex < this.pattern.firstEditableIndex) {
	    inputIndex = this.pattern.firstEditableIndex
	  }
	
	  // Bail out or add the character to input
	  if (this.pattern.isEditableIndex(inputIndex)) {
	    if (!this.pattern.isValidAtIndex(char, inputIndex)) {
	      return false
	    }
	    this.value[inputIndex] = this.pattern.transform(char, inputIndex)
	  }
	
	  // If multiple characters were selected, blank the remainder out based on the
	  // pattern.
	  var end = this.selection.end - 1
	  while (end > inputIndex) {
	    if (this.pattern.isEditableIndex(end)) {
	      this.value[end] = this.placeholderChar
	    }
	    end--
	  }
	
	  // Advance the cursor to the next character
	  this.selection.start = this.selection.end = inputIndex + 1
	
	  // Skip over any subsequent static characters
	  while (this.pattern.length > this.selection.start &&
	         !this.pattern.isEditableIndex(this.selection.start)) {
	    this.selection.start++
	    this.selection.end++
	  }
	
	  // History
	  if (this._historyIndex != null) {
	    // Took more input after undoing, so blow any subsequent history away
	    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
	    this._historyIndex = null
	  }
	  if (this._lastOp !== 'input' ||
	      selectionBefore.start !== selectionBefore.end ||
	      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
	    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
	  }
	  this._lastOp = 'input'
	  this._lastSelection = copy(this.selection)
	
	  return true
	}
	
	/**
	 * Attempts to delete from the value based on the current cursor position or
	 * selection.
	 * @return {boolean} true if the value or selection changed as the result of
	 *   backspacing, false otherwise.
	 */
	InputMask.prototype.backspace = function backspace() {
	  // If the cursor is at the start there's nothing to do
	  if (this.selection.start === 0 && this.selection.end === 0) {
	    return false
	  }
	
	  var selectionBefore = copy(this.selection)
	  var valueBefore = this.getValue()
	
	  // No range selected - work on the character preceding the cursor
	  if (this.selection.start === this.selection.end) {
	    if (this.pattern.isEditableIndex(this.selection.start - 1)) {
	      this.value[this.selection.start - 1] = this.placeholderChar
	    }
	    this.selection.start--
	    this.selection.end--
	  }
	  // Range selected - delete characters and leave the cursor at the start of the selection
	  else {
	    var end = this.selection.end - 1
	    while (end >= this.selection.start) {
	      if (this.pattern.isEditableIndex(end)) {
	        this.value[end] = this.placeholderChar
	      }
	      end--
	    }
	    this.selection.end = this.selection.start
	  }
	
	  // History
	  if (this._historyIndex != null) {
	    // Took more input after undoing, so blow any subsequent history away
	    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
	  }
	  if (this._lastOp !== 'backspace' ||
	      selectionBefore.start !== selectionBefore.end ||
	      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
	    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
	  }
	  this._lastOp = 'backspace'
	  this._lastSelection = copy(this.selection)
	
	  return true
	}
	
	/**
	 * Attempts to paste a string of input at the current cursor position or over
	 * the top of the current selection.
	 * Invalid content at any position will cause the paste to be rejected, and it
	 * may contain static parts of the mask's pattern.
	 * @param {string} input
	 * @return {boolean} true if the paste was successful, false otherwise.
	 */
	InputMask.prototype.paste = function paste(input) {
	  // This is necessary because we're just calling input() with each character
	  // and rolling back if any were invalid, rather than checking up-front.
	  var initialState = {
	    value: this.value.slice(),
	    selection: copy(this.selection),
	    _lastOp: this._lastOp,
	    _history: this._history.slice(),
	    _historyIndex: this._historyIndex,
	    _lastSelection: copy(this._lastSelection)
	  }
	
	  // If there are static characters at the start of the pattern and the cursor
	  // or selection is within them, the static characters must match for a valid
	  // paste.
	  if (this.selection.start < this.pattern.firstEditableIndex) {
	    for (var i = 0, l = this.pattern.firstEditableIndex - this.selection.start; i < l; i++) {
	      if (input.charAt(i) !== this.pattern.pattern[i]) {
	        return false
	      }
	    }
	
	    // Continue as if the selection and input started from the editable part of
	    // the pattern.
	    input = input.substring(this.pattern.firstEditableIndex - this.selection.start)
	    this.selection.start = this.pattern.firstEditableIndex
	  }
	
	  for (i = 0, l = input.length;
	       i < l && this.selection.start <= this.pattern.lastEditableIndex;
	       i++) {
	    var valid = this.input(input.charAt(i))
	    // Allow static parts of the pattern to appear in pasted input - they will
	    // already have been stepped over by input(), so verify that the value
	    // deemed invalid by input() was the expected static character.
	    if (!valid) {
	      if (this.selection.start > 0) {
	        // XXX This only allows for one static character to be skipped
	        var patternIndex = this.selection.start - 1
	        if (!this.pattern.isEditableIndex(patternIndex) &&
	            input.charAt(i) === this.pattern.pattern[patternIndex]) {
	          continue
	        }
	      }
	      extend(this, initialState)
	      return false
	    }
	  }
	
	  return true
	}
	
	// History
	
	InputMask.prototype.undo = function undo() {
	  // If there is no history, or nothing more on the history stack, we can't undo
	  if (this._history.length === 0 || this._historyIndex === 0) {
	    return false
	  }
	
	  var historyItem
	  if (this._historyIndex == null) {
	    // Not currently undoing, set up the initial history index
	    this._historyIndex = this._history.length - 1
	    historyItem = this._history[this._historyIndex]
	    // Add a new history entry if anything has changed since the last one, so we
	    // can redo back to the initial state we started undoing from.
	    var value = this.getValue()
	    if (historyItem.value !== value ||
	        historyItem.selection.start !== this.selection.start ||
	        historyItem.selection.end !== this.selection.end) {
	      this._history.push({value: value, selection: copy(this.selection), lastOp: this._lastOp, startUndo: true})
	    }
	  }
	  else {
	    historyItem = this._history[--this._historyIndex]
	  }
	
	  this.value = historyItem.value.split('')
	  this.selection = historyItem.selection
	  this._lastOp = historyItem.lastOp
	  return true
	}
	
	InputMask.prototype.redo = function redo() {
	  if (this._history.length === 0 || this._historyIndex == null) {
	    return false
	  }
	  var historyItem = this._history[++this._historyIndex]
	  // If this is the last history item, we're done redoing
	  if (this._historyIndex === this._history.length - 1) {
	    this._historyIndex = null
	    // If the last history item was only added to start undoing, remove it
	    if (historyItem.startUndo) {
	      this._history.pop()
	    }
	  }
	  this.value = historyItem.value.split('')
	  this.selection = historyItem.selection
	  this._lastOp = historyItem.lastOp
	  return true
	}
	
	// Getters & setters
	
	InputMask.prototype.setPattern = function setPattern(pattern, options) {
	  options = extend({
	    selection: {start: 0, end: 0},
	    value: ''
	  }, options)
	  this.pattern = new Pattern(pattern, this.formatCharacters, this.placeholderChar, options.isRevealingMask)
	  this.setValue(options.value)
	  this.emptyValue = this.pattern.formatValue([]).join('')
	  this.selection = options.selection
	  this._resetHistory()
	}
	
	InputMask.prototype.setSelection = function setSelection(selection) {
	  this.selection = copy(selection)
	  if (this.selection.start === this.selection.end) {
	    if (this.selection.start < this.pattern.firstEditableIndex) {
	      this.selection.start = this.selection.end = this.pattern.firstEditableIndex
	      return true
	    }
	    // Set selection to the first editable, non-placeholder character before the selection
	    // OR to the beginning of the pattern
	    var index = this.selection.start
	    while (index >= this.pattern.firstEditableIndex) {
	      if (this.pattern.isEditableIndex(index - 1) &&
	          this.value[index - 1] !== this.placeholderChar ||
	          index === this.pattern.firstEditableIndex) {
	        this.selection.start = this.selection.end = index
	        break
	      }
	      index--
	    }
	    return true
	  }
	  return false
	}
	
	InputMask.prototype.setValue = function setValue(value) {
	  if (value == null) {
	    value = ''
	  }
	  this.value = this.pattern.formatValue(value.split(''))
	}
	
	InputMask.prototype.getValue = function getValue() {
	  return this.value.join('')
	}
	
	InputMask.prototype.getRawValue = function getRawValue() {
	  var rawValue = []
	  for (var i = 0; i < this.value.length; i++) {
	    if (this.pattern._editableIndices[i] === true) {
	      rawValue.push(this.value[i])
	    }
	  }
	  return rawValue.join('')
	}
	
	InputMask.prototype._resetHistory = function _resetHistory() {
	  this._history = []
	  this._historyIndex = null
	  this._lastOp = null
	  this._lastSelection = copy(this.selection)
	}
	
	InputMask.Pattern = Pattern
	
	module.exports = InputMask


/***/ },
/* 2936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	var callBound = __webpack_require__(369);
	
	var $toString = callBound('Object.prototype.toString');
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			$toString(value) !== '[object Array]' &&
			$toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 2937 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 2938 */
/***/ function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
	var badArrayLike;
	var isCallableMarker;
	if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
		try {
			badArrayLike = Object.defineProperty({}, 'length', {
				get: function () {
					throw isCallableMarker;
				}
			});
			isCallableMarker = {};
			// eslint-disable-next-line no-throw-literal
			reflectApply(function () { throw 42; }, null, badArrayLike);
		} catch (_) {
			if (_ !== isCallableMarker) {
				reflectApply = null;
			}
		}
	} else {
		reflectApply = null;
	}
	
	var constructorRegex = /^\s*class\b/;
	var isES6ClassFn = function isES6ClassFunction(value) {
		try {
			var fnStr = fnToStr.call(value);
			return constructorRegex.test(fnStr);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionToStr(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = reflectApply
		? function isCallable(value) {
			if (!value) { return false; }
			if (typeof value !== 'function' && typeof value !== 'object') { return false; }
			if (typeof value === 'function' && !value.prototype) { return true; }
			try {
				reflectApply(value, null, badArrayLike);
			} catch (e) {
				if (e !== isCallableMarker) { return false; }
			}
			return !isES6ClassFn(value);
		}
		: function isCallable(value) {
			if (!value) { return false; }
			if (typeof value !== 'function' && typeof value !== 'object') { return false; }
			if (typeof value === 'function' && !value.prototype) { return true; }
			if (hasToStringTag) { return tryFunctionObject(value); }
			if (isES6ClassFn(value)) { return false; }
			var strClass = toStr.call(value);
			return strClass === fnClass || strClass === genClass;
		};


/***/ },
/* 2939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(669)();
	var hasToStringTag = hasSymbols && typeof Symbol.toStringTag === 'symbol';
	var hasOwnProperty;
	var regexExec;
	var isRegexMarker;
	var badStringifier;
	
	if (hasToStringTag) {
		hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
		regexExec = Function.call.bind(RegExp.prototype.exec);
		isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	}
	
	var toStr = Object.prototype.toString;
	var gOPD = Object.getOwnPropertyDescriptor;
	var regexClass = '[object RegExp]';
	
	module.exports = hasToStringTag
		// eslint-disable-next-line consistent-return
		? function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			var descriptor = gOPD(value, 'lastIndex');
			var hasLastIndexDataProperty = descriptor && hasOwnProperty(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				regexExec(value, badStringifier);
			} catch (e) {
				return e === isRegexMarker;
			}
		}
		: function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return toStr.call(value) === regexClass;
		};


/***/ },
/* 2940 */
/***/ function(module, exports) {

	module.exports = function() {
	  var mediaQuery;
	  if (typeof window !== "undefined" && window !== null) {
	    mediaQuery = "(-webkit-min-device-pixel-ratio: 1.25), (min--moz-device-pixel-ratio: 1.25), (-o-min-device-pixel-ratio: 5/4), (min-resolution: 1.25dppx)";
	    if (window.devicePixelRatio > 1.25) {
	      return true;
	    }
	    if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
	      return true;
	    }
	  }
	  return false;
	};


/***/ },
/* 2941 */
/***/ function(module, exports) {

	'use strict';
	
	var strValue = String.prototype.valueOf;
	var tryStringObject = function tryStringObject(value) {
		try {
			strValue.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var strClass = '[object String]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isString(value) {
		if (typeof value === 'string') {
			return true;
		}
		if (typeof value !== 'object') {
			return false;
		}
		return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
	};


/***/ },
/* 2942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	var hasSymbols = __webpack_require__(669)();
	
	if (hasSymbols) {
		var symToStr = Symbol.prototype.toString;
		var symStringRegex = /^Symbol\(.*\)$/;
		var isSymbolObject = function isRealSymbolObject(value) {
			if (typeof value.valueOf() !== 'symbol') {
				return false;
			}
			return symStringRegex.test(symToStr.call(value));
		};
	
		module.exports = function isSymbol(value) {
			if (typeof value === 'symbol') {
				return true;
			}
			if (toStr.call(value) !== '[object Symbol]') {
				return false;
			}
			try {
				return isSymbolObject(value);
			} catch (e) {
				return false;
			}
		};
	} else {
	
		module.exports = function isSymbol(value) {
			// this environment does not support Symbols.
			return false && value;
		};
	}


/***/ },
/* 2943 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 2944 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ },
/* 2945 */
/***/ function(module, exports) {

	module.exports = {
		"words": [
			"ahole",
			"anus",
			"ash0le",
			"ash0les",
			"asholes",
			"ass",
			"Ass Monkey",
			"Assface",
			"assh0le",
			"assh0lez",
			"asshole",
			"assholes",
			"assholz",
			"asswipe",
			"azzhole",
			"bassterds",
			"bastard",
			"bastards",
			"bastardz",
			"basterds",
			"basterdz",
			"Biatch",
			"bitch",
			"bitches",
			"Blow Job",
			"boffing",
			"butthole",
			"buttwipe",
			"c0ck",
			"c0cks",
			"c0k",
			"Carpet Muncher",
			"cawk",
			"cawks",
			"Clit",
			"cnts",
			"cntz",
			"cock",
			"cockhead",
			"cock-head",
			"cocks",
			"CockSucker",
			"cock-sucker",
			"crap",
			"cum",
			"cunt",
			"cunts",
			"cuntz",
			"dick",
			"dild0",
			"dild0s",
			"dildo",
			"dildos",
			"dilld0",
			"dilld0s",
			"dominatricks",
			"dominatrics",
			"dominatrix",
			"dyke",
			"enema",
			"f u c k",
			"f u c k e r",
			"fag",
			"fag1t",
			"faget",
			"fagg1t",
			"faggit",
			"faggot",
			"fagit",
			"fags",
			"fagz",
			"faig",
			"faigs",
			"fart",
			"flipping the bird",
			"fuck",
			"fucker",
			"fuckin",
			"fucking",
			"fucks",
			"Fudge Packer",
			"fuk",
			"Fukah",
			"Fuken",
			"fuker",
			"Fukin",
			"Fukk",
			"Fukkah",
			"Fukken",
			"Fukker",
			"Fukkin",
			"g00k",
			"gay",
			"gayboy",
			"gaygirl",
			"gays",
			"gayz",
			"God-damned",
			"h00r",
			"h0ar",
			"h0re",
			"hells",
			"hoar",
			"hoor",
			"hoore",
			"jackoff",
			"jap",
			"japs",
			"jerk-off",
			"jisim",
			"jiss",
			"jizm",
			"jizz",
			"knob",
			"knobs",
			"knobz",
			"kunt",
			"kunts",
			"kuntz",
			"Lesbian",
			"Lezzian",
			"Lipshits",
			"Lipshitz",
			"masochist",
			"masokist",
			"massterbait",
			"masstrbait",
			"masstrbate",
			"masterbaiter",
			"masterbate",
			"masterbates",
			"Motha Fucker",
			"Motha Fuker",
			"Motha Fukkah",
			"Motha Fukker",
			"Mother Fucker",
			"Mother Fukah",
			"Mother Fuker",
			"Mother Fukkah",
			"Mother Fukker",
			"mother-fucker",
			"Mutha Fucker",
			"Mutha Fukah",
			"Mutha Fuker",
			"Mutha Fukkah",
			"Mutha Fukker",
			"n1gr",
			"nastt",
			"nigger;",
			"nigur;",
			"niiger;",
			"niigr;",
			"orafis",
			"orgasim;",
			"orgasm",
			"orgasum",
			"oriface",
			"orifice",
			"orifiss",
			"packi",
			"packie",
			"packy",
			"paki",
			"pakie",
			"paky",
			"pecker",
			"peeenus",
			"peeenusss",
			"peenus",
			"peinus",
			"pen1s",
			"penas",
			"penis",
			"penis-breath",
			"penus",
			"penuus",
			"Phuc",
			"Phuck",
			"Phuk",
			"Phuker",
			"Phukker",
			"polac",
			"polack",
			"polak",
			"Poonani",
			"pr1c",
			"pr1ck",
			"pr1k",
			"pusse",
			"pussee",
			"pussy",
			"puuke",
			"puuker",
			"queer",
			"queers",
			"queerz",
			"qweers",
			"qweerz",
			"qweir",
			"recktum",
			"rectum",
			"retard",
			"sadist",
			"scank",
			"schlong",
			"screwing",
			"semen",
			"sex",
			"sexy",
			"Sh!t",
			"sh1t",
			"sh1ter",
			"sh1ts",
			"sh1tter",
			"sh1tz",
			"shit",
			"shits",
			"shitter",
			"Shitty",
			"Shity",
			"shitz",
			"Shyt",
			"Shyte",
			"Shytty",
			"Shyty",
			"skanck",
			"skank",
			"skankee",
			"skankey",
			"skanks",
			"Skanky",
			"slag",
			"slut",
			"sluts",
			"Slutty",
			"slutz",
			"son-of-a-bitch",
			"tit",
			"turd",
			"va1jina",
			"vag1na",
			"vagiina",
			"vagina",
			"vaj1na",
			"vajina",
			"vullva",
			"vulva",
			"w0p",
			"wh00r",
			"wh0re",
			"whore",
			"xrated",
			"xxx",
			"b!+ch",
			"bitch",
			"blowjob",
			"clit",
			"arschloch",
			"fuck",
			"shit",
			"ass",
			"asshole",
			"b!tch",
			"b17ch",
			"b1tch",
			"bastard",
			"bi+ch",
			"boiolas",
			"buceta",
			"c0ck",
			"cawk",
			"chink",
			"cipa",
			"clits",
			"cock",
			"cum",
			"cunt",
			"dildo",
			"dirsa",
			"ejakulate",
			"fatass",
			"fcuk",
			"fuk",
			"fux0r",
			"hoer",
			"hore",
			"jism",
			"kawk",
			"l3itch",
			"l3i+ch",
			"lesbian",
			"masturbate",
			"masterbat*",
			"masterbat3",
			"motherfucker",
			"s.o.b.",
			"mofo",
			"nazi",
			"nigga",
			"nigger",
			"nutsack",
			"phuck",
			"pimpis",
			"pusse",
			"pussy",
			"scrotum",
			"sh!t",
			"shemale",
			"shi+",
			"sh!+",
			"slut",
			"smut",
			"teets",
			"tits",
			"boobs",
			"b00bs",
			"teez",
			"testical",
			"testicle",
			"titt",
			"w00se",
			"jackoff",
			"wank",
			"whoar",
			"whore",
			"*damn",
			"*dyke",
			"*fuck*",
			"*shit*",
			"@$$",
			"amcik",
			"andskota",
			"arse*",
			"assrammer",
			"ayir",
			"bi7ch",
			"bitch*",
			"bollock*",
			"breasts",
			"butt-pirate",
			"cabron",
			"cazzo",
			"chraa",
			"chuj",
			"Cock*",
			"cunt*",
			"d4mn",
			"daygo",
			"dego",
			"dick*",
			"dike*",
			"dupa",
			"dziwka",
			"ejackulate",
			"Ekrem*",
			"Ekto",
			"enculer",
			"faen",
			"fag*",
			"fanculo",
			"fanny",
			"feces",
			"feg",
			"Felcher",
			"ficken",
			"fitt*",
			"Flikker",
			"foreskin",
			"Fotze",
			"Fu(*",
			"fuk*",
			"futkretzn",
			"gay",
			"gook",
			"guiena",
			"h0r",
			"h4x0r",
			"hell",
			"helvete",
			"hoer*",
			"honkey",
			"Huevon",
			"hui",
			"injun",
			"jizz",
			"kanker*",
			"kike",
			"klootzak",
			"kraut",
			"knulle",
			"kuk",
			"kuksuger",
			"Kurac",
			"kurwa",
			"kusi*",
			"kyrpa*",
			"lesbo",
			"mamhoon",
			"masturbat*",
			"merd*",
			"mibun",
			"monkleigh",
			"mouliewop",
			"muie",
			"mulkku",
			"muschi",
			"nazis",
			"nepesaurio",
			"nigger*",
			"orospu",
			"paska*",
			"perse",
			"picka",
			"pierdol*",
			"pillu*",
			"pimmel",
			"piss*",
			"pizda",
			"poontsee",
			"poop",
			"porn",
			"p0rn",
			"pr0n",
			"preteen",
			"pula",
			"pule",
			"puta",
			"puto",
			"qahbeh",
			"queef*",
			"rautenberg",
			"schaffer",
			"scheiss*",
			"schlampe",
			"schmuck",
			"screw",
			"sh!t*",
			"sharmuta",
			"sharmute",
			"shipal",
			"shiz",
			"skribz",
			"skurwysyn",
			"sphencter",
			"spic",
			"spierdalaj",
			"splooge",
			"suka",
			"b00b*",
			"testicle*",
			"titt*",
			"twat",
			"vittu",
			"wank*",
			"wetback*",
			"wichser",
			"wop*",
			"yed",
			"zabourah"
		]
	};

/***/ },
/* 2946 */
/***/ function(module, exports) {

	module.exports = [
		{
			"alpha2": "AC",
			"alpha3": "",
			"countryCallingCodes": [
				"+247"
			],
			"currencies": [
				"USD"
			],
			"emoji": "",
			"ioc": "SHP",
			"languages": [
				"eng"
			],
			"name": "Ascension Island",
			"status": "reserved"
		},
		{
			"alpha2": "AD",
			"alpha3": "AND",
			"countryCallingCodes": [
				"+376"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇦🇩",
			"ioc": "AND",
			"languages": [
				"cat"
			],
			"name": "Andorra",
			"status": "assigned"
		},
		{
			"alpha2": "AE",
			"alpha3": "ARE",
			"countryCallingCodes": [
				"+971"
			],
			"currencies": [
				"AED"
			],
			"emoji": "🇦🇪",
			"ioc": "UAE",
			"languages": [
				"ara"
			],
			"name": "United Arab Emirates",
			"status": "assigned"
		},
		{
			"alpha2": "AF",
			"alpha3": "AFG",
			"countryCallingCodes": [
				"+93"
			],
			"currencies": [
				"AFN"
			],
			"emoji": "🇦🇫",
			"ioc": "AFG",
			"languages": [
				"pus"
			],
			"name": "Afghanistan",
			"status": "assigned"
		},
		{
			"alpha2": "AG",
			"alpha3": "ATG",
			"countryCallingCodes": [
				"+1 268"
			],
			"currencies": [
				"XCD"
			],
			"emoji": "🇦🇬",
			"ioc": "ANT",
			"languages": [
				"eng"
			],
			"name": "Antigua And Barbuda",
			"status": "assigned"
		},
		{
			"alpha2": "AI",
			"alpha3": "AIA",
			"countryCallingCodes": [
				"+1 264"
			],
			"currencies": [
				"XCD"
			],
			"emoji": "🇦🇮",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Anguilla",
			"status": "assigned"
		},
		{
			"alpha2": "AI",
			"alpha3": "AFI",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "French Afar and Issas",
			"status": "deleted"
		},
		{
			"alpha2": "AL",
			"alpha3": "ALB",
			"countryCallingCodes": [
				"+355"
			],
			"currencies": [
				"ALL"
			],
			"emoji": "🇦🇱",
			"ioc": "ALB",
			"languages": [
				"sqi"
			],
			"name": "Albania",
			"status": "assigned"
		},
		{
			"alpha2": "AM",
			"alpha3": "ARM",
			"countryCallingCodes": [
				"+374"
			],
			"currencies": [
				"AMD"
			],
			"emoji": "🇦🇲",
			"ioc": "ARM",
			"languages": [
				"hye",
				"rus"
			],
			"name": "Armenia",
			"status": "assigned"
		},
		{
			"alpha2": "AN",
			"alpha3": "ANT",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Netherlands Antilles",
			"status": "deleted"
		},
		{
			"alpha2": "AO",
			"alpha3": "AGO",
			"countryCallingCodes": [
				"+244"
			],
			"currencies": [
				"AOA"
			],
			"emoji": "🇦🇴",
			"ioc": "ANG",
			"languages": [
				"por"
			],
			"name": "Angola",
			"status": "assigned"
		},
		{
			"alpha2": "AQ",
			"alpha3": "ATA",
			"countryCallingCodes": [
				"+672"
			],
			"currencies": [],
			"emoji": "🇦🇶",
			"ioc": "",
			"languages": [],
			"name": "Antarctica",
			"status": "assigned"
		},
		{
			"alpha2": "AR",
			"alpha3": "ARG",
			"countryCallingCodes": [
				"+54"
			],
			"currencies": [
				"ARS"
			],
			"emoji": "🇦🇷",
			"ioc": "ARG",
			"languages": [
				"spa"
			],
			"name": "Argentina",
			"status": "assigned"
		},
		{
			"alpha2": "AS",
			"alpha3": "ASM",
			"countryCallingCodes": [
				"+1 684"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇦🇸",
			"ioc": "ASA",
			"languages": [
				"eng",
				"smo"
			],
			"name": "American Samoa",
			"status": "assigned"
		},
		{
			"alpha2": "AT",
			"alpha3": "AUT",
			"countryCallingCodes": [
				"+43"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇦🇹",
			"ioc": "AUT",
			"languages": [
				"deu"
			],
			"name": "Austria",
			"status": "assigned"
		},
		{
			"alpha2": "AU",
			"alpha3": "AUS",
			"countryCallingCodes": [
				"+61"
			],
			"currencies": [
				"AUD"
			],
			"emoji": "🇦🇺",
			"ioc": "AUS",
			"languages": [
				"eng"
			],
			"name": "Australia",
			"status": "assigned"
		},
		{
			"alpha2": "AW",
			"alpha3": "ABW",
			"countryCallingCodes": [
				"+297"
			],
			"currencies": [
				"AWG"
			],
			"emoji": "🇦🇼",
			"ioc": "ARU",
			"languages": [
				"nld"
			],
			"name": "Aruba",
			"status": "assigned"
		},
		{
			"alpha2": "AX",
			"alpha3": "ALA",
			"countryCallingCodes": [
				"+358"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇦🇽",
			"ioc": "",
			"languages": [
				"swe"
			],
			"name": "Åland Islands",
			"status": "assigned"
		},
		{
			"alpha2": "AZ",
			"alpha3": "AZE",
			"countryCallingCodes": [
				"+994"
			],
			"currencies": [
				"AZN"
			],
			"emoji": "🇦🇿",
			"ioc": "AZE",
			"languages": [
				"aze"
			],
			"name": "Azerbaijan",
			"status": "assigned"
		},
		{
			"alpha2": "BA",
			"alpha3": "BIH",
			"countryCallingCodes": [
				"+387"
			],
			"currencies": [
				"BAM"
			],
			"emoji": "🇧🇦",
			"ioc": "BIH",
			"languages": [
				"bos",
				"cre",
				"srp"
			],
			"name": "Bosnia & Herzegovina",
			"status": "assigned"
		},
		{
			"alpha2": "BB",
			"alpha3": "BRB",
			"countryCallingCodes": [
				"+1 246"
			],
			"currencies": [
				"BBD"
			],
			"emoji": "🇧🇧",
			"ioc": "BAR",
			"languages": [
				"eng"
			],
			"name": "Barbados",
			"status": "assigned"
		},
		{
			"alpha2": "BD",
			"alpha3": "BGD",
			"countryCallingCodes": [
				"+880"
			],
			"currencies": [
				"BDT"
			],
			"emoji": "🇧🇩",
			"ioc": "BAN",
			"languages": [
				"ben"
			],
			"name": "Bangladesh",
			"status": "assigned"
		},
		{
			"alpha2": "BE",
			"alpha3": "BEL",
			"countryCallingCodes": [
				"+32"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇧🇪",
			"ioc": "BEL",
			"languages": [
				"nld",
				"fra",
				"deu"
			],
			"name": "Belgium",
			"status": "assigned"
		},
		{
			"alpha2": "BF",
			"alpha3": "BFA",
			"countryCallingCodes": [
				"+226"
			],
			"currencies": [
				"XOF"
			],
			"emoji": "🇧🇫",
			"ioc": "BUR",
			"languages": [
				"fra"
			],
			"name": "Burkina Faso",
			"status": "assigned"
		},
		{
			"alpha2": "BG",
			"alpha3": "BGR",
			"countryCallingCodes": [
				"+359"
			],
			"currencies": [
				"BGN"
			],
			"emoji": "🇧🇬",
			"ioc": "BUL",
			"languages": [
				"bul"
			],
			"name": "Bulgaria",
			"status": "assigned"
		},
		{
			"alpha2": "BH",
			"alpha3": "BHR",
			"countryCallingCodes": [
				"+973"
			],
			"currencies": [
				"BHD"
			],
			"emoji": "🇧🇭",
			"ioc": "BRN",
			"languages": [
				"ara"
			],
			"name": "Bahrain",
			"status": "assigned"
		},
		{
			"alpha2": "BI",
			"alpha3": "BDI",
			"countryCallingCodes": [
				"+257"
			],
			"currencies": [
				"BIF"
			],
			"emoji": "🇧🇮",
			"ioc": "BDI",
			"languages": [
				"fra"
			],
			"name": "Burundi",
			"status": "assigned"
		},
		{
			"alpha2": "BJ",
			"alpha3": "BEN",
			"countryCallingCodes": [
				"+229"
			],
			"currencies": [
				"XOF"
			],
			"emoji": "🇧🇯",
			"ioc": "BEN",
			"languages": [
				"fra"
			],
			"name": "Benin",
			"status": "assigned"
		},
		{
			"alpha2": "BL",
			"alpha3": "BLM",
			"countryCallingCodes": [
				"+590"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇧🇱",
			"ioc": "",
			"languages": [
				"fra"
			],
			"name": "Saint Barthélemy",
			"status": "assigned"
		},
		{
			"alpha2": "BM",
			"alpha3": "BMU",
			"countryCallingCodes": [
				"+1 441"
			],
			"currencies": [
				"BMD"
			],
			"emoji": "🇧🇲",
			"ioc": "BER",
			"languages": [
				"eng"
			],
			"name": "Bermuda",
			"status": "assigned"
		},
		{
			"alpha2": "BN",
			"alpha3": "BRN",
			"countryCallingCodes": [
				"+673"
			],
			"currencies": [
				"BND"
			],
			"emoji": "🇧🇳",
			"ioc": "BRU",
			"languages": [
				"msa",
				"eng"
			],
			"name": "Brunei Darussalam",
			"status": "assigned"
		},
		{
			"alpha2": "BO",
			"alpha3": "BOL",
			"countryCallingCodes": [
				"+591"
			],
			"currencies": [
				"BOB",
				"BOV"
			],
			"emoji": "🇧🇴",
			"ioc": "BOL",
			"languages": [
				"spa",
				"aym",
				"que"
			],
			"name": "Bolivia, Plurinational State Of",
			"status": "assigned"
		},
		{
			"alpha2": "BQ",
			"alpha3": "BES",
			"countryCallingCodes": [
				"+599"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇧🇶",
			"ioc": "",
			"languages": [
				"nld"
			],
			"name": "Bonaire, Saint Eustatius And Saba",
			"status": "assigned"
		},
		{
			"alpha2": "BQ",
			"alpha3": "ATB",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "British Antarctic Territory",
			"status": "deleted"
		},
		{
			"alpha2": "BR",
			"alpha3": "BRA",
			"countryCallingCodes": [
				"+55"
			],
			"currencies": [
				"BRL"
			],
			"emoji": "🇧🇷",
			"ioc": "BRA",
			"languages": [
				"por"
			],
			"name": "Brazil",
			"status": "assigned"
		},
		{
			"alpha2": "BS",
			"alpha3": "BHS",
			"countryCallingCodes": [
				"+1 242"
			],
			"currencies": [
				"BSD"
			],
			"emoji": "🇧🇸",
			"ioc": "BAH",
			"languages": [
				"eng"
			],
			"name": "Bahamas",
			"status": "assigned"
		},
		{
			"alpha2": "BT",
			"alpha3": "BTN",
			"countryCallingCodes": [
				"+975"
			],
			"currencies": [
				"INR",
				"BTN"
			],
			"emoji": "🇧🇹",
			"ioc": "BHU",
			"languages": [
				"dzo"
			],
			"name": "Bhutan",
			"status": "assigned"
		},
		{
			"alpha2": "BU",
			"alpha3": "BUR",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Burma",
			"status": "deleted"
		},
		{
			"alpha2": "BV",
			"alpha3": "BVT",
			"countryCallingCodes": [],
			"currencies": [
				"NOK"
			],
			"emoji": "🇧🇻",
			"ioc": "",
			"languages": [],
			"name": "Bouvet Island",
			"status": "assigned"
		},
		{
			"alpha2": "BW",
			"alpha3": "BWA",
			"countryCallingCodes": [
				"+267"
			],
			"currencies": [
				"BWP"
			],
			"emoji": "🇧🇼",
			"ioc": "BOT",
			"languages": [
				"eng",
				"tsn"
			],
			"name": "Botswana",
			"status": "assigned"
		},
		{
			"alpha2": "BY",
			"alpha3": "BLR",
			"countryCallingCodes": [
				"+375"
			],
			"currencies": [
				"BYR"
			],
			"emoji": "🇧🇾",
			"ioc": "BLR",
			"languages": [
				"bel",
				"rus"
			],
			"name": "Belarus",
			"status": "assigned"
		},
		{
			"alpha2": "BY",
			"alpha3": "BYS",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Byelorussian SSR",
			"status": "deleted"
		},
		{
			"alpha2": "BZ",
			"alpha3": "BLZ",
			"countryCallingCodes": [
				"+501"
			],
			"currencies": [
				"BZD"
			],
			"emoji": "🇧🇿",
			"ioc": "BIZ",
			"languages": [
				"eng"
			],
			"name": "Belize",
			"status": "assigned"
		},
		{
			"alpha2": "CA",
			"alpha3": "CAN",
			"countryCallingCodes": [
				"+1"
			],
			"currencies": [
				"CAD"
			],
			"emoji": "🇨🇦",
			"ioc": "CAN",
			"languages": [
				"eng",
				"fra"
			],
			"name": "Canada",
			"status": "assigned"
		},
		{
			"alpha2": "CC",
			"alpha3": "CCK",
			"countryCallingCodes": [
				"+61"
			],
			"currencies": [
				"AUD"
			],
			"emoji": "🇨🇨",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Cocos (Keeling) Islands",
			"status": "assigned"
		},
		{
			"alpha2": "CD",
			"alpha3": "COD",
			"countryCallingCodes": [
				"+243"
			],
			"currencies": [
				"CDF"
			],
			"emoji": "🇨🇩",
			"ioc": "COD",
			"languages": [
				"fra",
				"lin",
				"kon",
				"swa"
			],
			"name": "Democratic Republic Of Congo",
			"status": "assigned"
		},
		{
			"alpha2": "CF",
			"alpha3": "CAF",
			"countryCallingCodes": [
				"+236"
			],
			"currencies": [
				"XAF"
			],
			"emoji": "🇨🇫",
			"ioc": "CAF",
			"languages": [
				"fra",
				"sag"
			],
			"name": "Central African Republic",
			"status": "assigned"
		},
		{
			"alpha2": "CG",
			"alpha3": "COG",
			"countryCallingCodes": [
				"+242"
			],
			"currencies": [
				"XAF"
			],
			"emoji": "🇨🇬",
			"ioc": "CGO",
			"languages": [
				"fra",
				"lin"
			],
			"name": "Republic Of Congo",
			"status": "assigned"
		},
		{
			"alpha2": "CH",
			"alpha3": "CHE",
			"countryCallingCodes": [
				"+41"
			],
			"currencies": [
				"CHF",
				"CHE",
				"CHW"
			],
			"emoji": "🇨🇭",
			"ioc": "SUI",
			"languages": [
				"deu",
				"fra",
				"ita",
				"roh"
			],
			"name": "Switzerland",
			"status": "assigned"
		},
		{
			"alpha2": "CI",
			"alpha3": "CIV",
			"countryCallingCodes": [
				"+225"
			],
			"currencies": [
				"XOF"
			],
			"emoji": "🇨🇮",
			"ioc": "CIV",
			"languages": [
				"fra"
			],
			"name": "Côte d'Ivoire",
			"status": "assigned"
		},
		{
			"alpha2": "CK",
			"alpha3": "COK",
			"countryCallingCodes": [
				"+682"
			],
			"currencies": [
				"NZD"
			],
			"emoji": "🇨🇰",
			"ioc": "COK",
			"languages": [
				"eng",
				"mri"
			],
			"name": "Cook Islands",
			"status": "assigned"
		},
		{
			"alpha2": "CL",
			"alpha3": "CHL",
			"countryCallingCodes": [
				"+56"
			],
			"currencies": [
				"CLP",
				"CLF"
			],
			"emoji": "🇨🇱",
			"ioc": "CHI",
			"languages": [
				"spa"
			],
			"name": "Chile",
			"status": "assigned"
		},
		{
			"alpha2": "CM",
			"alpha3": "CMR",
			"countryCallingCodes": [
				"+237"
			],
			"currencies": [
				"XAF"
			],
			"emoji": "🇨🇲",
			"ioc": "CMR",
			"languages": [
				"eng",
				"fra"
			],
			"name": "Cameroon",
			"status": "assigned"
		},
		{
			"alpha2": "CN",
			"alpha3": "CHN",
			"countryCallingCodes": [
				"+86"
			],
			"currencies": [
				"CNY"
			],
			"emoji": "🇨🇳",
			"ioc": "CHN",
			"languages": [
				"zho"
			],
			"name": "China",
			"status": "assigned"
		},
		{
			"alpha2": "CO",
			"alpha3": "COL",
			"countryCallingCodes": [
				"+57"
			],
			"currencies": [
				"COP",
				"COU"
			],
			"emoji": "🇨🇴",
			"ioc": "COL",
			"languages": [
				"spa"
			],
			"name": "Colombia",
			"status": "assigned"
		},
		{
			"alpha2": "CP",
			"alpha3": "",
			"countryCallingCodes": [],
			"currencies": [
				"EUR"
			],
			"emoji": "",
			"ioc": "",
			"languages": [],
			"name": "Clipperton Island",
			"status": "reserved"
		},
		{
			"alpha2": "CR",
			"alpha3": "CRI",
			"countryCallingCodes": [
				"+506"
			],
			"currencies": [
				"CRC"
			],
			"emoji": "🇨🇷",
			"ioc": "CRC",
			"languages": [
				"spa"
			],
			"name": "Costa Rica",
			"status": "assigned"
		},
		{
			"alpha2": "CS",
			"alpha3": "CSK",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Czechoslovakia",
			"status": "deleted"
		},
		{
			"alpha2": "CS",
			"alpha3": "SCG",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Serbia and Montenegro",
			"status": "deleted"
		},
		{
			"alpha2": "CT",
			"alpha3": "CTE",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Canton and Enderbury Islands",
			"status": "deleted"
		},
		{
			"alpha2": "CU",
			"alpha3": "CUB",
			"countryCallingCodes": [
				"+53"
			],
			"currencies": [
				"CUP",
				"CUC"
			],
			"emoji": "🇨🇺",
			"ioc": "CUB",
			"languages": [
				"spa"
			],
			"name": "Cuba",
			"status": "assigned"
		},
		{
			"alpha2": "CV",
			"alpha3": "CPV",
			"countryCallingCodes": [
				"+238"
			],
			"currencies": [
				"CVE"
			],
			"emoji": "🇨🇻",
			"ioc": "CPV",
			"languages": [
				"por"
			],
			"name": "Cabo Verde",
			"status": "assigned"
		},
		{
			"alpha2": "CW",
			"alpha3": "CUW",
			"countryCallingCodes": [
				"+599"
			],
			"currencies": [
				"ANG"
			],
			"emoji": "🇨🇼",
			"ioc": "",
			"languages": [
				"nld"
			],
			"name": "Curacao",
			"status": "assigned"
		},
		{
			"alpha2": "CX",
			"alpha3": "CXR",
			"countryCallingCodes": [
				"+61"
			],
			"currencies": [
				"AUD"
			],
			"emoji": "🇨🇽",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Christmas Island",
			"status": "assigned"
		},
		{
			"alpha2": "CY",
			"alpha3": "CYP",
			"countryCallingCodes": [
				"+357"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇨🇾",
			"ioc": "CYP",
			"languages": [
				"ell",
				"tur"
			],
			"name": "Cyprus",
			"status": "assigned"
		},
		{
			"alpha2": "CZ",
			"alpha3": "CZE",
			"countryCallingCodes": [
				"+420"
			],
			"currencies": [
				"CZK"
			],
			"emoji": "🇨🇿",
			"ioc": "CZE",
			"languages": [
				"ces"
			],
			"name": "Czech Republic",
			"status": "assigned"
		},
		{
			"alpha2": "DD",
			"alpha3": "DDR",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "German Democratic Republic",
			"status": "deleted"
		},
		{
			"alpha2": "DE",
			"alpha3": "DEU",
			"countryCallingCodes": [
				"+49"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇩🇪",
			"ioc": "GER",
			"languages": [
				"deu"
			],
			"name": "Germany",
			"status": "assigned"
		},
		{
			"alpha2": "DG",
			"alpha3": "",
			"countryCallingCodes": [],
			"currencies": [
				"USD"
			],
			"emoji": "",
			"ioc": "",
			"languages": [],
			"name": "Diego Garcia",
			"status": "reserved"
		},
		{
			"alpha2": "DJ",
			"alpha3": "DJI",
			"countryCallingCodes": [
				"+253"
			],
			"currencies": [
				"DJF"
			],
			"emoji": "🇩🇯",
			"ioc": "DJI",
			"languages": [
				"ara",
				"fra"
			],
			"name": "Djibouti",
			"status": "assigned"
		},
		{
			"alpha2": "DK",
			"alpha3": "DNK",
			"countryCallingCodes": [
				"+45"
			],
			"currencies": [
				"DKK"
			],
			"emoji": "🇩🇰",
			"ioc": "DEN",
			"languages": [
				"dan"
			],
			"name": "Denmark",
			"status": "assigned"
		},
		{
			"alpha2": "DM",
			"alpha3": "DMA",
			"countryCallingCodes": [
				"+1 767"
			],
			"currencies": [
				"XCD"
			],
			"emoji": "🇩🇲",
			"ioc": "DMA",
			"languages": [
				"eng"
			],
			"name": "Dominica",
			"status": "assigned"
		},
		{
			"alpha2": "DO",
			"alpha3": "DOM",
			"countryCallingCodes": [
				"+1 809",
				"+1 829",
				"+1 849"
			],
			"currencies": [
				"DOP"
			],
			"emoji": "🇩🇴",
			"ioc": "DOM",
			"languages": [
				"spa"
			],
			"name": "Dominican Republic",
			"status": "assigned"
		},
		{
			"alpha2": "DY",
			"alpha3": "DHY",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Dahomey",
			"status": "deleted"
		},
		{
			"alpha2": "DZ",
			"alpha3": "DZA",
			"countryCallingCodes": [
				"+213"
			],
			"currencies": [
				"DZD"
			],
			"emoji": "🇩🇿",
			"ioc": "ALG",
			"languages": [
				"ara"
			],
			"name": "Algeria",
			"status": "assigned"
		},
		{
			"alpha2": "EA",
			"alpha3": "",
			"countryCallingCodes": [],
			"currencies": [
				"EUR"
			],
			"emoji": "",
			"ioc": "",
			"languages": [],
			"name": "Ceuta, Mulilla",
			"status": "reserved"
		},
		{
			"alpha2": "EC",
			"alpha3": "ECU",
			"countryCallingCodes": [
				"+593"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇪🇨",
			"ioc": "ECU",
			"languages": [
				"spa",
				"que"
			],
			"name": "Ecuador",
			"status": "assigned"
		},
		{
			"alpha2": "EE",
			"alpha3": "EST",
			"countryCallingCodes": [
				"+372"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇪🇪",
			"ioc": "EST",
			"languages": [
				"est"
			],
			"name": "Estonia",
			"status": "assigned"
		},
		{
			"alpha2": "EG",
			"alpha3": "EGY",
			"countryCallingCodes": [
				"+20"
			],
			"currencies": [
				"EGP"
			],
			"emoji": "🇪🇬",
			"ioc": "EGY",
			"languages": [
				"ara"
			],
			"name": "Egypt",
			"status": "assigned"
		},
		{
			"alpha2": "EH",
			"alpha3": "ESH",
			"countryCallingCodes": [
				"+212"
			],
			"currencies": [
				"MAD"
			],
			"emoji": "🇪🇭",
			"ioc": "",
			"languages": [],
			"name": "Western Sahara",
			"status": "assigned"
		},
		{
			"alpha2": "ER",
			"alpha3": "ERI",
			"countryCallingCodes": [
				"+291"
			],
			"currencies": [
				"ERN"
			],
			"emoji": "🇪🇷",
			"ioc": "ERI",
			"languages": [
				"eng",
				"ara",
				"tir"
			],
			"name": "Eritrea",
			"status": "assigned"
		},
		{
			"alpha2": "ES",
			"alpha3": "ESP",
			"countryCallingCodes": [
				"+34"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇪🇸",
			"ioc": "ESP",
			"languages": [
				"spa"
			],
			"name": "Spain",
			"status": "assigned"
		},
		{
			"alpha2": "ET",
			"alpha3": "ETH",
			"countryCallingCodes": [
				"+251"
			],
			"currencies": [
				"ETB"
			],
			"emoji": "🇪🇹",
			"ioc": "ETH",
			"languages": [
				"amh"
			],
			"name": "Ethiopia",
			"status": "assigned"
		},
		{
			"alpha2": "EU",
			"alpha3": "",
			"countryCallingCodes": [
				"+388"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇪🇺",
			"ioc": "",
			"languages": [],
			"name": "European Union",
			"status": "reserved"
		},
		{
			"alpha2": "FI",
			"alpha3": "FIN",
			"countryCallingCodes": [
				"+358"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇫🇮",
			"ioc": "FIN",
			"languages": [
				"fin",
				"swe"
			],
			"name": "Finland",
			"status": "assigned"
		},
		{
			"alpha2": "FJ",
			"alpha3": "FJI",
			"countryCallingCodes": [
				"+679"
			],
			"currencies": [
				"FJD"
			],
			"emoji": "🇫🇯",
			"ioc": "FIJ",
			"languages": [
				"eng",
				"fij"
			],
			"name": "Fiji",
			"status": "assigned"
		},
		{
			"alpha2": "FK",
			"alpha3": "FLK",
			"countryCallingCodes": [
				"+500"
			],
			"currencies": [
				"FKP"
			],
			"emoji": "🇫🇰",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Falkland Islands",
			"status": "assigned"
		},
		{
			"alpha2": "FM",
			"alpha3": "FSM",
			"countryCallingCodes": [
				"+691"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇫🇲",
			"ioc": "FSM",
			"languages": [
				"eng"
			],
			"name": "Micronesia, Federated States Of",
			"status": "assigned"
		},
		{
			"alpha2": "FO",
			"alpha3": "FRO",
			"countryCallingCodes": [
				"+298"
			],
			"currencies": [
				"DKK"
			],
			"emoji": "🇫🇴",
			"ioc": "FAI",
			"languages": [
				"fao",
				"dan"
			],
			"name": "Faroe Islands",
			"status": "assigned"
		},
		{
			"alpha2": "FQ",
			"alpha3": "ATF",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "French Southern and Antarctic Territories",
			"status": "deleted"
		},
		{
			"alpha2": "FR",
			"alpha3": "FRA",
			"countryCallingCodes": [
				"+33"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇫🇷",
			"ioc": "FRA",
			"languages": [
				"fra"
			],
			"name": "France",
			"status": "assigned"
		},
		{
			"alpha2": "FX",
			"alpha3": "",
			"countryCallingCodes": [
				"+241"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "",
			"ioc": "",
			"languages": [
				"fra"
			],
			"name": "France, Metropolitan",
			"status": "reserved"
		},
		{
			"alpha2": "GA",
			"alpha3": "GAB",
			"countryCallingCodes": [
				"+241"
			],
			"currencies": [
				"XAF"
			],
			"emoji": "🇬🇦",
			"ioc": "GAB",
			"languages": [
				"fra"
			],
			"name": "Gabon",
			"status": "assigned"
		},
		{
			"alpha2": "GB",
			"alpha3": "GBR",
			"countryCallingCodes": [
				"+44"
			],
			"currencies": [
				"GBP"
			],
			"emoji": "🇬🇧",
			"ioc": "GBR",
			"languages": [
				"eng",
				"cor",
				"gle",
				"gla",
				"cym"
			],
			"name": "United Kingdom",
			"status": "assigned"
		},
		{
			"alpha2": "GD",
			"alpha3": "GRD",
			"countryCallingCodes": [
				"+473"
			],
			"currencies": [
				"XCD"
			],
			"emoji": "🇬🇩",
			"ioc": "GRN",
			"languages": [
				"eng"
			],
			"name": "Grenada",
			"status": "assigned"
		},
		{
			"alpha2": "GE",
			"alpha3": "GEO",
			"countryCallingCodes": [
				"+995"
			],
			"currencies": [
				"GEL"
			],
			"emoji": "🇬🇪",
			"ioc": "GEO",
			"languages": [
				"kat"
			],
			"name": "Georgia",
			"status": "assigned"
		},
		{
			"alpha2": "GE",
			"alpha3": "GEL",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Gilbert and Ellice Islands",
			"status": "deleted"
		},
		{
			"alpha2": "GF",
			"alpha3": "GUF",
			"countryCallingCodes": [
				"+594"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇬🇫",
			"ioc": "",
			"languages": [
				"fra"
			],
			"name": "French Guiana",
			"status": "assigned"
		},
		{
			"alpha2": "GG",
			"alpha3": "GGY",
			"countryCallingCodes": [
				"+44"
			],
			"currencies": [
				"GBP"
			],
			"emoji": "🇬🇬",
			"ioc": "GCI",
			"languages": [
				"fra"
			],
			"name": "Guernsey",
			"status": "assigned"
		},
		{
			"alpha2": "GH",
			"alpha3": "GHA",
			"countryCallingCodes": [
				"+233"
			],
			"currencies": [
				"GHS"
			],
			"emoji": "🇬🇭",
			"ioc": "GHA",
			"languages": [
				"eng"
			],
			"name": "Ghana",
			"status": "assigned"
		},
		{
			"alpha2": "GI",
			"alpha3": "GIB",
			"countryCallingCodes": [
				"+350"
			],
			"currencies": [
				"GIP"
			],
			"emoji": "🇬🇮",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Gibraltar",
			"status": "assigned"
		},
		{
			"alpha2": "GL",
			"alpha3": "GRL",
			"countryCallingCodes": [
				"+299"
			],
			"currencies": [
				"DKK"
			],
			"emoji": "🇬🇱",
			"ioc": "",
			"languages": [
				"kal"
			],
			"name": "Greenland",
			"status": "assigned"
		},
		{
			"alpha2": "GM",
			"alpha3": "GMB",
			"countryCallingCodes": [
				"+220"
			],
			"currencies": [
				"GMD"
			],
			"emoji": "🇬🇲",
			"ioc": "GAM",
			"languages": [
				"eng"
			],
			"name": "Gambia",
			"status": "assigned"
		},
		{
			"alpha2": "GN",
			"alpha3": "GIN",
			"countryCallingCodes": [
				"+224"
			],
			"currencies": [
				"GNF"
			],
			"emoji": "🇬🇳",
			"ioc": "GUI",
			"languages": [
				"fra"
			],
			"name": "Guinea",
			"status": "assigned"
		},
		{
			"alpha2": "GP",
			"alpha3": "GLP",
			"countryCallingCodes": [
				"+590"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇬🇵",
			"ioc": "",
			"languages": [
				"fra"
			],
			"name": "Guadeloupe",
			"status": "assigned"
		},
		{
			"alpha2": "GQ",
			"alpha3": "GNQ",
			"countryCallingCodes": [
				"+240"
			],
			"currencies": [
				"XAF"
			],
			"emoji": "🇬🇶",
			"ioc": "GEQ",
			"languages": [
				"spa",
				"fra",
				"por"
			],
			"name": "Equatorial Guinea",
			"status": "assigned"
		},
		{
			"alpha2": "GR",
			"alpha3": "GRC",
			"countryCallingCodes": [
				"+30"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇬🇷",
			"ioc": "GRE",
			"languages": [
				"ell"
			],
			"name": "Greece",
			"status": "assigned"
		},
		{
			"alpha2": "GS",
			"alpha3": "SGS",
			"countryCallingCodes": [],
			"currencies": [
				"GBP"
			],
			"emoji": "🇬🇸",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "South Georgia And The South Sandwich Islands",
			"status": "assigned"
		},
		{
			"alpha2": "GT",
			"alpha3": "GTM",
			"countryCallingCodes": [
				"+502"
			],
			"currencies": [
				"GTQ"
			],
			"emoji": "🇬🇹",
			"ioc": "GUA",
			"languages": [
				"spa"
			],
			"name": "Guatemala",
			"status": "assigned"
		},
		{
			"alpha2": "GU",
			"alpha3": "GUM",
			"countryCallingCodes": [
				"+1 671"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇬🇺",
			"ioc": "GUM",
			"languages": [
				"eng"
			],
			"name": "Guam",
			"status": "assigned"
		},
		{
			"alpha2": "GW",
			"alpha3": "GNB",
			"countryCallingCodes": [
				"+245"
			],
			"currencies": [
				"XOF"
			],
			"emoji": "🇬🇼",
			"ioc": "GBS",
			"languages": [
				"por"
			],
			"name": "Guinea-bissau",
			"status": "assigned"
		},
		{
			"alpha2": "GY",
			"alpha3": "GUY",
			"countryCallingCodes": [
				"+592"
			],
			"currencies": [
				"GYD"
			],
			"emoji": "🇬🇾",
			"ioc": "GUY",
			"languages": [
				"eng"
			],
			"name": "Guyana",
			"status": "assigned"
		},
		{
			"alpha2": "HK",
			"alpha3": "HKG",
			"countryCallingCodes": [
				"+852"
			],
			"currencies": [
				"HKD"
			],
			"emoji": "🇭🇰",
			"ioc": "HKG",
			"languages": [
				"zho",
				"eng"
			],
			"name": "Hong Kong",
			"status": "assigned"
		},
		{
			"alpha2": "HM",
			"alpha3": "HMD",
			"countryCallingCodes": [],
			"currencies": [
				"AUD"
			],
			"emoji": "🇭🇲",
			"ioc": "",
			"languages": [],
			"name": "Heard Island And McDonald Islands",
			"status": "assigned"
		},
		{
			"alpha2": "HN",
			"alpha3": "HND",
			"countryCallingCodes": [
				"+504"
			],
			"currencies": [
				"HNL"
			],
			"emoji": "🇭🇳",
			"ioc": "HON",
			"languages": [
				"spa"
			],
			"name": "Honduras",
			"status": "assigned"
		},
		{
			"alpha2": "HR",
			"alpha3": "HRV",
			"countryCallingCodes": [
				"+385"
			],
			"currencies": [
				"HRK"
			],
			"emoji": "🇭🇷",
			"ioc": "CRO",
			"languages": [
				"hrv"
			],
			"name": "Croatia",
			"status": "assigned"
		},
		{
			"alpha2": "HT",
			"alpha3": "HTI",
			"countryCallingCodes": [
				"+509"
			],
			"currencies": [
				"HTG",
				"USD"
			],
			"emoji": "🇭🇹",
			"ioc": "HAI",
			"languages": [
				"fra",
				"hat"
			],
			"name": "Haiti",
			"status": "assigned"
		},
		{
			"alpha2": "HU",
			"alpha3": "HUN",
			"countryCallingCodes": [
				"+36"
			],
			"currencies": [
				"HUF"
			],
			"emoji": "🇭🇺",
			"ioc": "HUN",
			"languages": [
				"hun"
			],
			"name": "Hungary",
			"status": "assigned"
		},
		{
			"alpha2": "HV",
			"alpha3": "HVO",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Upper Volta",
			"status": "deleted"
		},
		{
			"alpha2": "IC",
			"alpha3": "",
			"countryCallingCodes": [],
			"currencies": [
				"EUR"
			],
			"emoji": "",
			"ioc": "",
			"languages": [],
			"name": "Canary Islands",
			"status": "reserved"
		},
		{
			"alpha2": "ID",
			"alpha3": "IDN",
			"countryCallingCodes": [
				"+62"
			],
			"currencies": [
				"IDR"
			],
			"emoji": "🇮🇩",
			"ioc": "INA",
			"languages": [
				"ind"
			],
			"name": "Indonesia",
			"status": "assigned"
		},
		{
			"alpha2": "IE",
			"alpha3": "IRL",
			"countryCallingCodes": [
				"+353"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇮🇪",
			"ioc": "IRL",
			"languages": [
				"eng",
				"gle"
			],
			"name": "Ireland",
			"status": "assigned"
		},
		{
			"alpha2": "IL",
			"alpha3": "ISR",
			"countryCallingCodes": [
				"+972"
			],
			"currencies": [
				"ILS"
			],
			"emoji": "🇮🇱",
			"ioc": "ISR",
			"languages": [
				"heb",
				"ara",
				"eng"
			],
			"name": "Israel",
			"status": "assigned"
		},
		{
			"alpha2": "IM",
			"alpha3": "IMN",
			"countryCallingCodes": [
				"+44"
			],
			"currencies": [
				"GBP"
			],
			"emoji": "🇮🇲",
			"ioc": "",
			"languages": [
				"eng",
				"glv"
			],
			"name": "Isle Of Man",
			"status": "assigned"
		},
		{
			"alpha2": "IN",
			"alpha3": "IND",
			"countryCallingCodes": [
				"+91"
			],
			"currencies": [
				"INR"
			],
			"emoji": "🇮🇳",
			"ioc": "IND",
			"languages": [
				"eng",
				"hin"
			],
			"name": "India",
			"status": "assigned"
		},
		{
			"alpha2": "IO",
			"alpha3": "IOT",
			"countryCallingCodes": [
				"+246"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇮🇴",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "British Indian Ocean Territory",
			"status": "assigned"
		},
		{
			"alpha2": "IQ",
			"alpha3": "IRQ",
			"countryCallingCodes": [
				"+964"
			],
			"currencies": [
				"IQD"
			],
			"emoji": "🇮🇶",
			"ioc": "IRQ",
			"languages": [
				"ara",
				"kur"
			],
			"name": "Iraq",
			"status": "assigned"
		},
		{
			"alpha2": "IR",
			"alpha3": "IRN",
			"countryCallingCodes": [
				"+98"
			],
			"currencies": [
				"IRR"
			],
			"emoji": "🇮🇷",
			"ioc": "IRI",
			"languages": [
				"fas"
			],
			"name": "Iran, Islamic Republic Of",
			"status": "assigned"
		},
		{
			"alpha2": "IS",
			"alpha3": "ISL",
			"countryCallingCodes": [
				"+354"
			],
			"currencies": [
				"ISK"
			],
			"emoji": "🇮🇸",
			"ioc": "ISL",
			"languages": [
				"isl"
			],
			"name": "Iceland",
			"status": "assigned"
		},
		{
			"alpha2": "IT",
			"alpha3": "ITA",
			"countryCallingCodes": [
				"+39"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇮🇹",
			"ioc": "ITA",
			"languages": [
				"ita"
			],
			"name": "Italy",
			"status": "assigned"
		},
		{
			"alpha2": "JE",
			"alpha3": "JEY",
			"countryCallingCodes": [
				"+44"
			],
			"currencies": [
				"GBP"
			],
			"emoji": "🇯🇪",
			"ioc": "JCI",
			"languages": [
				"eng",
				"fra"
			],
			"name": "Jersey",
			"status": "assigned"
		},
		{
			"alpha2": "JM",
			"alpha3": "JAM",
			"countryCallingCodes": [
				"+1 876"
			],
			"currencies": [
				"JMD"
			],
			"emoji": "🇯🇲",
			"ioc": "JAM",
			"languages": [
				"eng"
			],
			"name": "Jamaica",
			"status": "assigned"
		},
		{
			"alpha2": "JO",
			"alpha3": "JOR",
			"countryCallingCodes": [
				"+962"
			],
			"currencies": [
				"JOD"
			],
			"emoji": "🇯🇴",
			"ioc": "JOR",
			"languages": [
				"ara"
			],
			"name": "Jordan",
			"status": "assigned"
		},
		{
			"alpha2": "JP",
			"alpha3": "JPN",
			"countryCallingCodes": [
				"+81"
			],
			"currencies": [
				"JPY"
			],
			"emoji": "🇯🇵",
			"ioc": "JPN",
			"languages": [
				"jpn"
			],
			"name": "Japan",
			"status": "assigned"
		},
		{
			"alpha2": "JT",
			"alpha3": "JTN",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Johnston Island",
			"status": "deleted"
		},
		{
			"alpha2": "KE",
			"alpha3": "KEN",
			"countryCallingCodes": [
				"+254"
			],
			"currencies": [
				"KES"
			],
			"emoji": "🇰🇪",
			"ioc": "KEN",
			"languages": [
				"eng",
				"swa"
			],
			"name": "Kenya",
			"status": "assigned"
		},
		{
			"alpha2": "KG",
			"alpha3": "KGZ",
			"countryCallingCodes": [
				"+996"
			],
			"currencies": [
				"KGS"
			],
			"emoji": "🇰🇬",
			"ioc": "KGZ",
			"languages": [
				"rus"
			],
			"name": "Kyrgyzstan",
			"status": "assigned"
		},
		{
			"alpha2": "KH",
			"alpha3": "KHM",
			"countryCallingCodes": [
				"+855"
			],
			"currencies": [
				"KHR"
			],
			"emoji": "🇰🇭",
			"ioc": "CAM",
			"languages": [
				"khm"
			],
			"name": "Cambodia",
			"status": "assigned"
		},
		{
			"alpha2": "KI",
			"alpha3": "KIR",
			"countryCallingCodes": [
				"+686"
			],
			"currencies": [
				"AUD"
			],
			"emoji": "🇰🇮",
			"ioc": "KIR",
			"languages": [
				"eng"
			],
			"name": "Kiribati",
			"status": "assigned"
		},
		{
			"alpha2": "KM",
			"alpha3": "COM",
			"countryCallingCodes": [
				"+269"
			],
			"currencies": [
				"KMF"
			],
			"emoji": "🇰🇲",
			"ioc": "COM",
			"languages": [
				"ara",
				"fra"
			],
			"name": "Comoros",
			"status": "assigned"
		},
		{
			"alpha2": "KN",
			"alpha3": "KNA",
			"countryCallingCodes": [
				"+1 869"
			],
			"currencies": [
				"XCD"
			],
			"emoji": "🇰🇳",
			"ioc": "SKN",
			"languages": [
				"eng"
			],
			"name": "Saint Kitts And Nevis",
			"status": "assigned"
		},
		{
			"alpha2": "KP",
			"alpha3": "PRK",
			"countryCallingCodes": [
				"+850"
			],
			"currencies": [
				"KPW"
			],
			"emoji": "🇰🇵",
			"ioc": "PRK",
			"languages": [
				"kor"
			],
			"name": "Korea, Democratic People's Republic Of",
			"status": "assigned"
		},
		{
			"alpha2": "KR",
			"alpha3": "KOR",
			"countryCallingCodes": [
				"+82"
			],
			"currencies": [
				"KRW"
			],
			"emoji": "🇰🇷",
			"ioc": "KOR",
			"languages": [
				"kor"
			],
			"name": "Korea, Republic Of",
			"status": "assigned"
		},
		{
			"alpha2": "KW",
			"alpha3": "KWT",
			"countryCallingCodes": [
				"+965"
			],
			"currencies": [
				"KWD"
			],
			"emoji": "🇰🇼",
			"ioc": "KUW",
			"languages": [
				"ara"
			],
			"name": "Kuwait",
			"status": "assigned"
		},
		{
			"alpha2": "KY",
			"alpha3": "CYM",
			"countryCallingCodes": [
				"+1 345"
			],
			"currencies": [
				"KYD"
			],
			"emoji": "🇰🇾",
			"ioc": "CAY",
			"languages": [
				"eng"
			],
			"name": "Cayman Islands",
			"status": "assigned"
		},
		{
			"alpha2": "KZ",
			"alpha3": "KAZ",
			"countryCallingCodes": [
				"+7",
				"+7 6",
				"+7 7"
			],
			"currencies": [
				"KZT"
			],
			"emoji": "🇰🇿",
			"ioc": "KAZ",
			"languages": [
				"kaz",
				"rus"
			],
			"name": "Kazakhstan",
			"status": "assigned"
		},
		{
			"alpha2": "LA",
			"alpha3": "LAO",
			"countryCallingCodes": [
				"+856"
			],
			"currencies": [
				"LAK"
			],
			"emoji": "🇱🇦",
			"ioc": "LAO",
			"languages": [
				"lao"
			],
			"name": "Lao People's Democratic Republic",
			"status": "assigned"
		},
		{
			"alpha2": "LB",
			"alpha3": "LBN",
			"countryCallingCodes": [
				"+961"
			],
			"currencies": [
				"LBP"
			],
			"emoji": "🇱🇧",
			"ioc": "LIB",
			"languages": [
				"ara",
				"hye"
			],
			"name": "Lebanon",
			"status": "assigned"
		},
		{
			"alpha2": "LC",
			"alpha3": "LCA",
			"countryCallingCodes": [
				"+1 758"
			],
			"currencies": [
				"XCD"
			],
			"emoji": "🇱🇨",
			"ioc": "LCA",
			"languages": [
				"eng"
			],
			"name": "Saint Lucia",
			"status": "assigned"
		},
		{
			"alpha2": "LI",
			"alpha3": "LIE",
			"countryCallingCodes": [
				"+423"
			],
			"currencies": [
				"CHF"
			],
			"emoji": "🇱🇮",
			"ioc": "LIE",
			"languages": [
				"deu"
			],
			"name": "Liechtenstein",
			"status": "assigned"
		},
		{
			"alpha2": "LK",
			"alpha3": "LKA",
			"countryCallingCodes": [
				"+94"
			],
			"currencies": [
				"LKR"
			],
			"emoji": "🇱🇰",
			"ioc": "SRI",
			"languages": [
				"sin",
				"tam"
			],
			"name": "Sri Lanka",
			"status": "assigned"
		},
		{
			"alpha2": "LR",
			"alpha3": "LBR",
			"countryCallingCodes": [
				"+231"
			],
			"currencies": [
				"LRD"
			],
			"emoji": "🇱🇷",
			"ioc": "LBR",
			"languages": [
				"eng"
			],
			"name": "Liberia",
			"status": "assigned"
		},
		{
			"alpha2": "LS",
			"alpha3": "LSO",
			"countryCallingCodes": [
				"+266"
			],
			"currencies": [
				"LSL",
				"ZAR"
			],
			"emoji": "🇱🇸",
			"ioc": "LES",
			"languages": [
				"eng",
				"sot"
			],
			"name": "Lesotho",
			"status": "assigned"
		},
		{
			"alpha2": "LT",
			"alpha3": "LTU",
			"countryCallingCodes": [
				"+370"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇱🇹",
			"ioc": "LTU",
			"languages": [
				"lit"
			],
			"name": "Lithuania",
			"status": "assigned"
		},
		{
			"alpha2": "LU",
			"alpha3": "LUX",
			"countryCallingCodes": [
				"+352"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇱🇺",
			"ioc": "LUX",
			"languages": [
				"fra",
				"deu",
				"ltz"
			],
			"name": "Luxembourg",
			"status": "assigned"
		},
		{
			"alpha2": "LV",
			"alpha3": "LVA",
			"countryCallingCodes": [
				"+371"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇱🇻",
			"ioc": "LAT",
			"languages": [
				"lav"
			],
			"name": "Latvia",
			"status": "assigned"
		},
		{
			"alpha2": "LY",
			"alpha3": "LBY",
			"countryCallingCodes": [
				"+218"
			],
			"currencies": [
				"LYD"
			],
			"emoji": "🇱🇾",
			"ioc": "LBA",
			"languages": [
				"ara"
			],
			"name": "Libya",
			"status": "assigned"
		},
		{
			"alpha2": "MA",
			"alpha3": "MAR",
			"countryCallingCodes": [
				"+212"
			],
			"currencies": [
				"MAD"
			],
			"emoji": "🇲🇦",
			"ioc": "MAR",
			"languages": [
				"ara"
			],
			"name": "Morocco",
			"status": "assigned"
		},
		{
			"alpha2": "MC",
			"alpha3": "MCO",
			"countryCallingCodes": [
				"+377"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇲🇨",
			"ioc": "MON",
			"languages": [
				"fra"
			],
			"name": "Monaco",
			"status": "assigned"
		},
		{
			"alpha2": "MD",
			"alpha3": "MDA",
			"countryCallingCodes": [
				"+373"
			],
			"currencies": [
				"MDL"
			],
			"emoji": "🇲🇩",
			"ioc": "MDA",
			"languages": [
				"ron"
			],
			"name": "Moldova",
			"status": "assigned"
		},
		{
			"alpha2": "ME",
			"alpha3": "MNE",
			"countryCallingCodes": [
				"+382"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇲🇪",
			"ioc": "MNE",
			"languages": [
				"mot"
			],
			"name": "Montenegro",
			"status": "assigned"
		},
		{
			"alpha2": "MF",
			"alpha3": "MAF",
			"countryCallingCodes": [
				"+590"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇲🇫",
			"ioc": "",
			"languages": [
				"fra"
			],
			"name": "Saint Martin",
			"status": "assigned"
		},
		{
			"alpha2": "MG",
			"alpha3": "MDG",
			"countryCallingCodes": [
				"+261"
			],
			"currencies": [
				"MGA"
			],
			"emoji": "🇲🇬",
			"ioc": "MAD",
			"languages": [
				"fra",
				"mlg"
			],
			"name": "Madagascar",
			"status": "assigned"
		},
		{
			"alpha2": "MH",
			"alpha3": "MHL",
			"countryCallingCodes": [
				"+692"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇲🇭",
			"ioc": "MHL",
			"languages": [
				"eng",
				"mah"
			],
			"name": "Marshall Islands",
			"status": "assigned"
		},
		{
			"alpha2": "MI",
			"alpha3": "MID",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Midway Islands",
			"status": "deleted"
		},
		{
			"alpha2": "MK",
			"alpha3": "MKD",
			"countryCallingCodes": [
				"+389"
			],
			"currencies": [
				"MKD"
			],
			"emoji": "🇲🇰",
			"ioc": "MKD",
			"languages": [
				"mkd"
			],
			"name": "Macedonia, The Former Yugoslav Republic Of",
			"status": "assigned"
		},
		{
			"alpha2": "ML",
			"alpha3": "MLI",
			"countryCallingCodes": [
				"+223"
			],
			"currencies": [
				"XOF"
			],
			"emoji": "🇲🇱",
			"ioc": "MLI",
			"languages": [
				"fra"
			],
			"name": "Mali",
			"status": "assigned"
		},
		{
			"alpha2": "MM",
			"alpha3": "MMR",
			"countryCallingCodes": [
				"+95"
			],
			"currencies": [
				"MMK"
			],
			"emoji": "🇲🇲",
			"ioc": "MYA",
			"languages": [
				"mya"
			],
			"name": "Myanmar",
			"status": "assigned"
		},
		{
			"alpha2": "MN",
			"alpha3": "MNG",
			"countryCallingCodes": [
				"+976"
			],
			"currencies": [
				"MNT"
			],
			"emoji": "🇲🇳",
			"ioc": "MGL",
			"languages": [
				"mon"
			],
			"name": "Mongolia",
			"status": "assigned"
		},
		{
			"alpha2": "MO",
			"alpha3": "MAC",
			"countryCallingCodes": [
				"+853"
			],
			"currencies": [
				"MOP"
			],
			"emoji": "🇲🇴",
			"ioc": "MAC",
			"languages": [
				"zho",
				"por"
			],
			"name": "Macao",
			"status": "assigned"
		},
		{
			"alpha2": "MP",
			"alpha3": "MNP",
			"countryCallingCodes": [
				"+1 670"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇲🇵",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Northern Mariana Islands",
			"status": "assigned"
		},
		{
			"alpha2": "MQ",
			"alpha3": "MTQ",
			"countryCallingCodes": [
				"+596"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇲🇶",
			"ioc": "",
			"languages": [],
			"name": "Martinique",
			"status": "assigned"
		},
		{
			"alpha2": "MR",
			"alpha3": "MRT",
			"countryCallingCodes": [
				"+222"
			],
			"currencies": [
				"MRO"
			],
			"emoji": "🇲🇷",
			"ioc": "MTN",
			"languages": [
				"ara",
				"fra"
			],
			"name": "Mauritania",
			"status": "assigned"
		},
		{
			"alpha2": "MS",
			"alpha3": "MSR",
			"countryCallingCodes": [
				"+1 664"
			],
			"currencies": [
				"XCD"
			],
			"emoji": "🇲🇸",
			"ioc": "",
			"languages": [],
			"name": "Montserrat",
			"status": "assigned"
		},
		{
			"alpha2": "MT",
			"alpha3": "MLT",
			"countryCallingCodes": [
				"+356"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇲🇹",
			"ioc": "MLT",
			"languages": [
				"mlt",
				"eng"
			],
			"name": "Malta",
			"status": "assigned"
		},
		{
			"alpha2": "MU",
			"alpha3": "MUS",
			"countryCallingCodes": [
				"+230"
			],
			"currencies": [
				"MUR"
			],
			"emoji": "🇲🇺",
			"ioc": "MRI",
			"languages": [
				"eng",
				"fra"
			],
			"name": "Mauritius",
			"status": "assigned"
		},
		{
			"alpha2": "MV",
			"alpha3": "MDV",
			"countryCallingCodes": [
				"+960"
			],
			"currencies": [
				"MVR"
			],
			"emoji": "🇲🇻",
			"ioc": "MDV",
			"languages": [
				"div"
			],
			"name": "Maldives",
			"status": "assigned"
		},
		{
			"alpha2": "MW",
			"alpha3": "MWI",
			"countryCallingCodes": [
				"+265"
			],
			"currencies": [
				"MWK"
			],
			"emoji": "🇲🇼",
			"ioc": "MAW",
			"languages": [
				"eng",
				"nya"
			],
			"name": "Malawi",
			"status": "assigned"
		},
		{
			"alpha2": "MX",
			"alpha3": "MEX",
			"countryCallingCodes": [
				"+52"
			],
			"currencies": [
				"MXN",
				"MXV"
			],
			"emoji": "🇲🇽",
			"ioc": "MEX",
			"languages": [
				"spa"
			],
			"name": "Mexico",
			"status": "assigned"
		},
		{
			"alpha2": "MY",
			"alpha3": "MYS",
			"countryCallingCodes": [
				"+60"
			],
			"currencies": [
				"MYR"
			],
			"emoji": "🇲🇾",
			"ioc": "MAS",
			"languages": [
				"msa",
				"eng"
			],
			"name": "Malaysia",
			"status": "assigned"
		},
		{
			"alpha2": "MZ",
			"alpha3": "MOZ",
			"countryCallingCodes": [
				"+258"
			],
			"currencies": [
				"MZN"
			],
			"emoji": "🇲🇿",
			"ioc": "MOZ",
			"languages": [
				"por"
			],
			"name": "Mozambique",
			"status": "assigned"
		},
		{
			"alpha2": "NA",
			"alpha3": "NAM",
			"countryCallingCodes": [
				"+264"
			],
			"currencies": [
				"NAD",
				"ZAR"
			],
			"emoji": "🇳🇦",
			"ioc": "NAM",
			"languages": [
				"eng"
			],
			"name": "Namibia",
			"status": "assigned"
		},
		{
			"alpha2": "NC",
			"alpha3": "NCL",
			"countryCallingCodes": [
				"+687"
			],
			"currencies": [
				"XPF"
			],
			"emoji": "🇳🇨",
			"ioc": "",
			"languages": [
				"fra"
			],
			"name": "New Caledonia",
			"status": "assigned"
		},
		{
			"alpha2": "NE",
			"alpha3": "NER",
			"countryCallingCodes": [
				"+227"
			],
			"currencies": [
				"XOF"
			],
			"emoji": "🇳🇪",
			"ioc": "NIG",
			"languages": [
				"fra"
			],
			"name": "Niger",
			"status": "assigned"
		},
		{
			"alpha2": "NF",
			"alpha3": "NFK",
			"countryCallingCodes": [
				"+672"
			],
			"currencies": [
				"AUD"
			],
			"emoji": "🇳🇫",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Norfolk Island",
			"status": "assigned"
		},
		{
			"alpha2": "NG",
			"alpha3": "NGA",
			"countryCallingCodes": [
				"+234"
			],
			"currencies": [
				"NGN"
			],
			"emoji": "🇳🇬",
			"ioc": "NGR",
			"languages": [
				"eng"
			],
			"name": "Nigeria",
			"status": "assigned"
		},
		{
			"alpha2": "NH",
			"alpha3": "NHB",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "New Hebrides",
			"status": "deleted"
		},
		{
			"alpha2": "NI",
			"alpha3": "NIC",
			"countryCallingCodes": [
				"+505"
			],
			"currencies": [
				"NIO"
			],
			"emoji": "🇳🇮",
			"ioc": "NCA",
			"languages": [
				"spa"
			],
			"name": "Nicaragua",
			"status": "assigned"
		},
		{
			"alpha2": "NL",
			"alpha3": "NLD",
			"countryCallingCodes": [
				"+31"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇳🇱",
			"ioc": "NED",
			"languages": [
				"nld"
			],
			"name": "Netherlands",
			"status": "assigned"
		},
		{
			"alpha2": "NO",
			"alpha3": "NOR",
			"countryCallingCodes": [
				"+47"
			],
			"currencies": [
				"NOK"
			],
			"emoji": "🇳🇴",
			"ioc": "NOR",
			"languages": [
				"nor"
			],
			"name": "Norway",
			"status": "assigned"
		},
		{
			"alpha2": "NP",
			"alpha3": "NPL",
			"countryCallingCodes": [
				"+977"
			],
			"currencies": [
				"NPR"
			],
			"emoji": "🇳🇵",
			"ioc": "NEP",
			"languages": [
				"nep"
			],
			"name": "Nepal",
			"status": "assigned"
		},
		{
			"alpha2": "NQ",
			"alpha3": "ATN",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Dronning Maud Land",
			"status": "deleted"
		},
		{
			"alpha2": "NR",
			"alpha3": "NRU",
			"countryCallingCodes": [
				"+674"
			],
			"currencies": [
				"AUD"
			],
			"emoji": "🇳🇷",
			"ioc": "NRU",
			"languages": [
				"eng",
				"nau"
			],
			"name": "Nauru",
			"status": "assigned"
		},
		{
			"alpha2": "NT",
			"alpha3": "NTZ",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Neutral Zone",
			"status": "deleted"
		},
		{
			"alpha2": "NU",
			"alpha3": "NIU",
			"countryCallingCodes": [
				"+683"
			],
			"currencies": [
				"NZD"
			],
			"emoji": "🇳🇺",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Niue",
			"status": "assigned"
		},
		{
			"alpha2": "NZ",
			"alpha3": "NZL",
			"countryCallingCodes": [
				"+64"
			],
			"currencies": [
				"NZD"
			],
			"emoji": "🇳🇿",
			"ioc": "NZL",
			"languages": [
				"eng"
			],
			"name": "New Zealand",
			"status": "assigned"
		},
		{
			"alpha2": "OM",
			"alpha3": "OMN",
			"countryCallingCodes": [
				"+968"
			],
			"currencies": [
				"OMR"
			],
			"emoji": "🇴🇲",
			"ioc": "OMA",
			"languages": [
				"ara"
			],
			"name": "Oman",
			"status": "assigned"
		},
		{
			"alpha2": "PA",
			"alpha3": "PAN",
			"countryCallingCodes": [
				"+507"
			],
			"currencies": [
				"PAB",
				"USD"
			],
			"emoji": "🇵🇦",
			"ioc": "PAN",
			"languages": [
				"spa"
			],
			"name": "Panama",
			"status": "assigned"
		},
		{
			"alpha2": "PC",
			"alpha3": "PCI",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Pacific Islands, Trust Territory of the",
			"status": "deleted"
		},
		{
			"alpha2": "PE",
			"alpha3": "PER",
			"countryCallingCodes": [
				"+51"
			],
			"currencies": [
				"PEN"
			],
			"emoji": "🇵🇪",
			"ioc": "PER",
			"languages": [
				"spa",
				"aym",
				"que"
			],
			"name": "Peru",
			"status": "assigned"
		},
		{
			"alpha2": "PF",
			"alpha3": "PYF",
			"countryCallingCodes": [
				"+689"
			],
			"currencies": [
				"XPF"
			],
			"emoji": "🇵🇫",
			"ioc": "",
			"languages": [
				"fra"
			],
			"name": "French Polynesia",
			"status": "assigned"
		},
		{
			"alpha2": "PG",
			"alpha3": "PNG",
			"countryCallingCodes": [
				"+675"
			],
			"currencies": [
				"PGK"
			],
			"emoji": "🇵🇬",
			"ioc": "PNG",
			"languages": [
				"eng"
			],
			"name": "Papua New Guinea",
			"status": "assigned"
		},
		{
			"alpha2": "PH",
			"alpha3": "PHL",
			"countryCallingCodes": [
				"+63"
			],
			"currencies": [
				"PHP"
			],
			"emoji": "🇵🇭",
			"ioc": "PHI",
			"languages": [
				"eng"
			],
			"name": "Philippines",
			"status": "assigned"
		},
		{
			"alpha2": "PK",
			"alpha3": "PAK",
			"countryCallingCodes": [
				"+92"
			],
			"currencies": [
				"PKR"
			],
			"emoji": "🇵🇰",
			"ioc": "PAK",
			"languages": [
				"urd",
				"eng"
			],
			"name": "Pakistan",
			"status": "assigned"
		},
		{
			"alpha2": "PL",
			"alpha3": "POL",
			"countryCallingCodes": [
				"+48"
			],
			"currencies": [
				"PLN"
			],
			"emoji": "🇵🇱",
			"ioc": "POL",
			"languages": [
				"pol"
			],
			"name": "Poland",
			"status": "assigned"
		},
		{
			"alpha2": "PM",
			"alpha3": "SPM",
			"countryCallingCodes": [
				"+508"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇵🇲",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Saint Pierre And Miquelon",
			"status": "assigned"
		},
		{
			"alpha2": "PN",
			"alpha3": "PCN",
			"countryCallingCodes": [
				"+872"
			],
			"currencies": [
				"NZD"
			],
			"emoji": "🇵🇳",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Pitcairn",
			"status": "assigned"
		},
		{
			"alpha2": "PR",
			"alpha3": "PRI",
			"countryCallingCodes": [
				"+1 787",
				"+1 939"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇵🇷",
			"ioc": "PUR",
			"languages": [
				"spa",
				"eng"
			],
			"name": "Puerto Rico",
			"status": "assigned"
		},
		{
			"alpha2": "PS",
			"alpha3": "PSE",
			"countryCallingCodes": [
				"+970"
			],
			"currencies": [
				"JOD",
				"EGP",
				"ILS"
			],
			"emoji": "🇵🇸",
			"ioc": "PLE",
			"languages": [
				"ara"
			],
			"name": "Palestinian Territory, Occupied",
			"status": "assigned"
		},
		{
			"alpha2": "PT",
			"alpha3": "PRT",
			"countryCallingCodes": [
				"+351"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇵🇹",
			"ioc": "POR",
			"languages": [
				"por"
			],
			"name": "Portugal",
			"status": "assigned"
		},
		{
			"alpha2": "PU",
			"alpha3": "PUS",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "U.S. Miscellaneous Pacific Islands",
			"status": "deleted"
		},
		{
			"alpha2": "PW",
			"alpha3": "PLW",
			"countryCallingCodes": [
				"+680"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇵🇼",
			"ioc": "PLW",
			"languages": [
				"eng"
			],
			"name": "Palau",
			"status": "assigned"
		},
		{
			"alpha2": "PY",
			"alpha3": "PRY",
			"countryCallingCodes": [
				"+595"
			],
			"currencies": [
				"PYG"
			],
			"emoji": "🇵🇾",
			"ioc": "PAR",
			"languages": [
				"spa"
			],
			"name": "Paraguay",
			"status": "assigned"
		},
		{
			"alpha2": "PZ",
			"alpha3": "PCZ",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Panama Canal Zone",
			"status": "deleted"
		},
		{
			"alpha2": "QA",
			"alpha3": "QAT",
			"countryCallingCodes": [
				"+974"
			],
			"currencies": [
				"QAR"
			],
			"emoji": "🇶🇦",
			"ioc": "QAT",
			"languages": [
				"ara"
			],
			"name": "Qatar",
			"status": "assigned"
		},
		{
			"alpha2": "RE",
			"alpha3": "REU",
			"countryCallingCodes": [
				"+262"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇷🇪",
			"ioc": "",
			"languages": [
				"fra"
			],
			"name": "Reunion",
			"status": "assigned"
		},
		{
			"alpha2": "RH",
			"alpha3": "RHO",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Southern Rhodesia",
			"status": "deleted"
		},
		{
			"alpha2": "RO",
			"alpha3": "ROU",
			"countryCallingCodes": [
				"+40"
			],
			"currencies": [
				"RON"
			],
			"emoji": "🇷🇴",
			"ioc": "ROU",
			"languages": [
				"ron"
			],
			"name": "Romania",
			"status": "assigned"
		},
		{
			"alpha2": "RS",
			"alpha3": "SRB",
			"countryCallingCodes": [
				"+381"
			],
			"currencies": [
				"RSD"
			],
			"emoji": "🇷🇸",
			"ioc": "SRB",
			"languages": [
				"srp"
			],
			"name": "Serbia",
			"status": "assigned"
		},
		{
			"alpha2": "RU",
			"alpha3": "RUS",
			"countryCallingCodes": [
				"+7",
				"+7 3",
				"+7 4",
				"+7 8"
			],
			"currencies": [
				"RUB"
			],
			"emoji": "🇷🇺",
			"ioc": "RUS",
			"languages": [
				"rus"
			],
			"name": "Russian Federation",
			"status": "assigned"
		},
		{
			"alpha2": "RW",
			"alpha3": "RWA",
			"countryCallingCodes": [
				"+250"
			],
			"currencies": [
				"RWF"
			],
			"emoji": "🇷🇼",
			"ioc": "RWA",
			"languages": [
				"eng",
				"fra",
				"kin"
			],
			"name": "Rwanda",
			"status": "assigned"
		},
		{
			"alpha2": "SA",
			"alpha3": "SAU",
			"countryCallingCodes": [
				"+966"
			],
			"currencies": [
				"SAR"
			],
			"emoji": "🇸🇦",
			"ioc": "KSA",
			"languages": [
				"ara"
			],
			"name": "Saudi Arabia",
			"status": "assigned"
		},
		{
			"alpha2": "SB",
			"alpha3": "SLB",
			"countryCallingCodes": [
				"+677"
			],
			"currencies": [
				"SBD"
			],
			"emoji": "🇸🇧",
			"ioc": "SOL",
			"languages": [
				"eng"
			],
			"name": "Solomon Islands",
			"status": "assigned"
		},
		{
			"alpha2": "SC",
			"alpha3": "SYC",
			"countryCallingCodes": [
				"+248"
			],
			"currencies": [
				"SCR"
			],
			"emoji": "🇸🇨",
			"ioc": "SEY",
			"languages": [
				"eng",
				"fra"
			],
			"name": "Seychelles",
			"status": "assigned"
		},
		{
			"alpha2": "SD",
			"alpha3": "SDN",
			"countryCallingCodes": [
				"+249"
			],
			"currencies": [
				"SDG"
			],
			"emoji": "🇸🇩",
			"ioc": "SUD",
			"languages": [
				"ara",
				"eng"
			],
			"name": "Sudan",
			"status": "assigned"
		},
		{
			"alpha2": "SE",
			"alpha3": "SWE",
			"countryCallingCodes": [
				"+46"
			],
			"currencies": [
				"SEK"
			],
			"emoji": "🇸🇪",
			"ioc": "SWE",
			"languages": [
				"swe"
			],
			"name": "Sweden",
			"status": "assigned"
		},
		{
			"alpha2": "SG",
			"alpha3": "SGP",
			"countryCallingCodes": [
				"+65"
			],
			"currencies": [
				"SGD"
			],
			"emoji": "🇸🇬",
			"ioc": "SIN",
			"languages": [
				"eng",
				"zho",
				"msa",
				"tam"
			],
			"name": "Singapore",
			"status": "assigned"
		},
		{
			"alpha2": "SH",
			"alpha3": "SHN",
			"countryCallingCodes": [
				"+290"
			],
			"currencies": [
				"SHP"
			],
			"emoji": "🇸🇭",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Saint Helena, Ascension And Tristan Da Cunha",
			"status": "assigned"
		},
		{
			"alpha2": "SI",
			"alpha3": "SVN",
			"countryCallingCodes": [
				"+386"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇸🇮",
			"ioc": "SLO",
			"languages": [
				"slv"
			],
			"name": "Slovenia",
			"status": "assigned"
		},
		{
			"alpha2": "SJ",
			"alpha3": "SJM",
			"countryCallingCodes": [
				"+47"
			],
			"currencies": [
				"NOK"
			],
			"emoji": "🇸🇯",
			"ioc": "",
			"languages": [],
			"name": "Svalbard And Jan Mayen",
			"status": "assigned"
		},
		{
			"alpha2": "SK",
			"alpha3": "SVK",
			"countryCallingCodes": [
				"+421"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇸🇰",
			"ioc": "SVK",
			"languages": [
				"slk"
			],
			"name": "Slovakia",
			"status": "assigned"
		},
		{
			"alpha2": "SK",
			"alpha3": "SKM",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Sikkim",
			"status": "deleted"
		},
		{
			"alpha2": "SL",
			"alpha3": "SLE",
			"countryCallingCodes": [
				"+232"
			],
			"currencies": [
				"SLL"
			],
			"emoji": "🇸🇱",
			"ioc": "SLE",
			"languages": [
				"eng"
			],
			"name": "Sierra Leone",
			"status": "assigned"
		},
		{
			"alpha2": "SM",
			"alpha3": "SMR",
			"countryCallingCodes": [
				"+378"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇸🇲",
			"ioc": "SMR",
			"languages": [
				"ita"
			],
			"name": "San Marino",
			"status": "assigned"
		},
		{
			"alpha2": "SN",
			"alpha3": "SEN",
			"countryCallingCodes": [
				"+221"
			],
			"currencies": [
				"XOF"
			],
			"emoji": "🇸🇳",
			"ioc": "SEN",
			"languages": [
				"fra"
			],
			"name": "Senegal",
			"status": "assigned"
		},
		{
			"alpha2": "SO",
			"alpha3": "SOM",
			"countryCallingCodes": [
				"+252"
			],
			"currencies": [
				"SOS"
			],
			"emoji": "🇸🇴",
			"ioc": "SOM",
			"languages": [
				"som"
			],
			"name": "Somalia",
			"status": "assigned"
		},
		{
			"alpha2": "SR",
			"alpha3": "SUR",
			"countryCallingCodes": [
				"+597"
			],
			"currencies": [
				"SRD"
			],
			"emoji": "🇸🇷",
			"ioc": "SUR",
			"languages": [
				"nld"
			],
			"name": "Suriname",
			"status": "assigned"
		},
		{
			"alpha2": "SS",
			"alpha3": "SSD",
			"countryCallingCodes": [
				"+211"
			],
			"currencies": [
				"SSP"
			],
			"emoji": "🇸🇸",
			"ioc": "SSD",
			"languages": [
				"eng"
			],
			"name": "South Sudan",
			"status": "assigned"
		},
		{
			"alpha2": "ST",
			"alpha3": "STP",
			"countryCallingCodes": [
				"+239"
			],
			"currencies": [
				"STD"
			],
			"emoji": "🇸🇹",
			"ioc": "STP",
			"languages": [
				"por"
			],
			"name": "Sao Tome and Principe",
			"status": "assigned"
		},
		{
			"alpha2": "SU",
			"alpha3": "",
			"countryCallingCodes": [],
			"currencies": [
				"RUB"
			],
			"emoji": "",
			"ioc": "",
			"languages": [
				"rus"
			],
			"name": "USSR",
			"status": "reserved"
		},
		{
			"alpha2": "SV",
			"alpha3": "SLV",
			"countryCallingCodes": [
				"+503"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇸🇻",
			"ioc": "ESA",
			"languages": [
				"spa"
			],
			"name": "El Salvador",
			"status": "assigned"
		},
		{
			"alpha2": "SX",
			"alpha3": "SXM",
			"countryCallingCodes": [
				"+1 721"
			],
			"currencies": [
				"ANG"
			],
			"emoji": "🇸🇽",
			"ioc": "",
			"languages": [
				"nld"
			],
			"name": "Sint Maarten",
			"status": "assigned"
		},
		{
			"alpha2": "SY",
			"alpha3": "SYR",
			"countryCallingCodes": [
				"+963"
			],
			"currencies": [
				"SYP"
			],
			"emoji": "🇸🇾",
			"ioc": "SYR",
			"languages": [
				"ara"
			],
			"name": "Syrian Arab Republic",
			"status": "assigned"
		},
		{
			"alpha2": "SZ",
			"alpha3": "SWZ",
			"countryCallingCodes": [
				"+268"
			],
			"currencies": [
				"SZL"
			],
			"emoji": "🇸🇿",
			"ioc": "SWZ",
			"languages": [
				"eng",
				"ssw"
			],
			"name": "Swaziland",
			"status": "assigned"
		},
		{
			"alpha2": "TA",
			"alpha3": "",
			"countryCallingCodes": [
				"+290"
			],
			"currencies": [
				"GBP"
			],
			"emoji": "",
			"ioc": "",
			"languages": [],
			"name": "Tristan de Cunha",
			"status": "reserved"
		},
		{
			"alpha2": "TC",
			"alpha3": "TCA",
			"countryCallingCodes": [
				"+1 649"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇹🇨",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Turks And Caicos Islands",
			"status": "assigned"
		},
		{
			"alpha2": "TD",
			"alpha3": "TCD",
			"countryCallingCodes": [
				"+235"
			],
			"currencies": [
				"XAF"
			],
			"emoji": "🇹🇩",
			"ioc": "CHA",
			"languages": [
				"ara",
				"fra"
			],
			"name": "Chad",
			"status": "assigned"
		},
		{
			"alpha2": "TF",
			"alpha3": "ATF",
			"countryCallingCodes": [],
			"currencies": [
				"EUR"
			],
			"emoji": "🇹🇫",
			"ioc": "",
			"languages": [
				"fra"
			],
			"name": "French Southern Territories",
			"status": "assigned"
		},
		{
			"alpha2": "TG",
			"alpha3": "TGO",
			"countryCallingCodes": [
				"+228"
			],
			"currencies": [
				"XOF"
			],
			"emoji": "🇹🇬",
			"ioc": "TOG",
			"languages": [
				"fra"
			],
			"name": "Togo",
			"status": "assigned"
		},
		{
			"alpha2": "TH",
			"alpha3": "THA",
			"countryCallingCodes": [
				"+66"
			],
			"currencies": [
				"THB"
			],
			"emoji": "🇹🇭",
			"ioc": "THA",
			"languages": [
				"tha"
			],
			"name": "Thailand",
			"status": "assigned"
		},
		{
			"alpha2": "TJ",
			"alpha3": "TJK",
			"countryCallingCodes": [
				"+992"
			],
			"currencies": [
				"TJS"
			],
			"emoji": "🇹🇯",
			"ioc": "TJK",
			"languages": [
				"tgk",
				"rus"
			],
			"name": "Tajikistan",
			"status": "assigned"
		},
		{
			"alpha2": "TK",
			"alpha3": "TKL",
			"countryCallingCodes": [
				"+690"
			],
			"currencies": [
				"NZD"
			],
			"emoji": "🇹🇰",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "Tokelau",
			"status": "assigned"
		},
		{
			"alpha2": "TL",
			"alpha3": "TLS",
			"countryCallingCodes": [
				"+670"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇹🇱",
			"ioc": "TLS",
			"languages": [
				"por"
			],
			"name": "Timor-Leste, Democratic Republic of",
			"status": "assigned"
		},
		{
			"alpha2": "TM",
			"alpha3": "TKM",
			"countryCallingCodes": [
				"+993"
			],
			"currencies": [
				"TMT"
			],
			"emoji": "🇹🇲",
			"ioc": "TKM",
			"languages": [
				"tuk",
				"rus"
			],
			"name": "Turkmenistan",
			"status": "assigned"
		},
		{
			"alpha2": "TN",
			"alpha3": "TUN",
			"countryCallingCodes": [
				"+216"
			],
			"currencies": [
				"TND"
			],
			"emoji": "🇹🇳",
			"ioc": "TUN",
			"languages": [
				"ara"
			],
			"name": "Tunisia",
			"status": "assigned"
		},
		{
			"alpha2": "TO",
			"alpha3": "TON",
			"countryCallingCodes": [
				"+676"
			],
			"currencies": [
				"TOP"
			],
			"emoji": "🇹🇴",
			"ioc": "TGA",
			"languages": [
				"eng"
			],
			"name": "Tonga",
			"status": "assigned"
		},
		{
			"alpha2": "TP",
			"alpha3": "TMP",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "East Timor",
			"status": "deleted"
		},
		{
			"alpha2": "TR",
			"alpha3": "TUR",
			"countryCallingCodes": [
				"+90"
			],
			"currencies": [
				"TRY"
			],
			"emoji": "🇹🇷",
			"ioc": "TUR",
			"languages": [
				"tur"
			],
			"name": "Turkey",
			"status": "assigned"
		},
		{
			"alpha2": "TT",
			"alpha3": "TTO",
			"countryCallingCodes": [
				"+1 868"
			],
			"currencies": [
				"TTD"
			],
			"emoji": "🇹🇹",
			"ioc": "TTO",
			"languages": [
				"eng"
			],
			"name": "Trinidad And Tobago",
			"status": "assigned"
		},
		{
			"alpha2": "TV",
			"alpha3": "TUV",
			"countryCallingCodes": [
				"+688"
			],
			"currencies": [
				"AUD"
			],
			"emoji": "🇹🇻",
			"ioc": "TUV",
			"languages": [
				"eng"
			],
			"name": "Tuvalu",
			"status": "assigned"
		},
		{
			"alpha2": "TW",
			"alpha3": "TWN",
			"countryCallingCodes": [
				"+886"
			],
			"currencies": [
				"TWD"
			],
			"emoji": "🇹🇼",
			"ioc": "TPE",
			"languages": [
				"zho"
			],
			"name": "Taiwan",
			"status": "assigned"
		},
		{
			"alpha2": "TZ",
			"alpha3": "TZA",
			"countryCallingCodes": [
				"+255"
			],
			"currencies": [
				"TZS"
			],
			"emoji": "🇹🇿",
			"ioc": "TAN",
			"languages": [
				"swa",
				"eng"
			],
			"name": "Tanzania, United Republic Of",
			"status": "assigned"
		},
		{
			"alpha2": "UA",
			"alpha3": "UKR",
			"countryCallingCodes": [
				"+380"
			],
			"currencies": [
				"UAH"
			],
			"emoji": "🇺🇦",
			"ioc": "UKR",
			"languages": [
				"ukr",
				"rus"
			],
			"name": "Ukraine",
			"status": "assigned"
		},
		{
			"alpha2": "UG",
			"alpha3": "UGA",
			"countryCallingCodes": [
				"+256"
			],
			"currencies": [
				"UGX"
			],
			"emoji": "🇺🇬",
			"ioc": "UGA",
			"languages": [
				"eng",
				"swa"
			],
			"name": "Uganda",
			"status": "assigned"
		},
		{
			"alpha2": "UK",
			"alpha3": "",
			"countryCallingCodes": [],
			"currencies": [
				"GBP"
			],
			"emoji": "",
			"ioc": "",
			"languages": [
				"eng",
				"cor",
				"gle",
				"gla",
				"cym"
			],
			"name": "United Kingdom",
			"status": "reserved"
		},
		{
			"alpha2": "UM",
			"alpha3": "UMI",
			"countryCallingCodes": [
				"+1"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇺🇲",
			"ioc": "",
			"languages": [
				"eng"
			],
			"name": "United States Minor Outlying Islands",
			"status": "assigned"
		},
		{
			"alpha2": "US",
			"alpha3": "USA",
			"countryCallingCodes": [
				"+1"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇺🇸",
			"ioc": "USA",
			"languages": [
				"eng"
			],
			"name": "United States",
			"status": "assigned"
		},
		{
			"alpha2": "UY",
			"alpha3": "URY",
			"countryCallingCodes": [
				"+598"
			],
			"currencies": [
				"UYU",
				"UYI"
			],
			"emoji": "🇺🇾",
			"ioc": "URU",
			"languages": [
				"spa"
			],
			"name": "Uruguay",
			"status": "assigned"
		},
		{
			"alpha2": "UZ",
			"alpha3": "UZB",
			"countryCallingCodes": [
				"+998"
			],
			"currencies": [
				"UZS"
			],
			"emoji": "🇺🇿",
			"ioc": "UZB",
			"languages": [
				"uzb",
				"rus"
			],
			"name": "Uzbekistan",
			"status": "assigned"
		},
		{
			"alpha2": "VA",
			"alpha3": "VAT",
			"countryCallingCodes": [
				"+379",
				"+39"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇻🇦",
			"ioc": "",
			"languages": [
				"ita"
			],
			"name": "Vatican City State",
			"status": "assigned"
		},
		{
			"alpha2": "VC",
			"alpha3": "VCT",
			"countryCallingCodes": [
				"+1 784"
			],
			"currencies": [
				"XCD"
			],
			"emoji": "🇻🇨",
			"ioc": "VIN",
			"languages": [
				"eng"
			],
			"name": "Saint Vincent And The Grenadines",
			"status": "assigned"
		},
		{
			"alpha2": "VD",
			"alpha3": "VDR",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Viet-Nam, Democratic Republic of",
			"status": "deleted"
		},
		{
			"alpha2": "VE",
			"alpha3": "VEN",
			"countryCallingCodes": [
				"+58"
			],
			"currencies": [
				"VEF"
			],
			"emoji": "🇻🇪",
			"ioc": "VEN",
			"languages": [
				"spa"
			],
			"name": "Venezuela, Bolivarian Republic Of",
			"status": "assigned"
		},
		{
			"alpha2": "VG",
			"alpha3": "VGB",
			"countryCallingCodes": [
				"+1 284"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇻🇬",
			"ioc": "IVB",
			"languages": [
				"eng"
			],
			"name": "Virgin Islands (British)",
			"status": "assigned"
		},
		{
			"alpha2": "VI",
			"alpha3": "VIR",
			"countryCallingCodes": [
				"+1 340"
			],
			"currencies": [
				"USD"
			],
			"emoji": "🇻🇮",
			"ioc": "ISV",
			"languages": [
				"eng"
			],
			"name": "Virgin Islands (US)",
			"status": "assigned"
		},
		{
			"alpha2": "VN",
			"alpha3": "VNM",
			"countryCallingCodes": [
				"+84"
			],
			"currencies": [
				"VND"
			],
			"emoji": "🇻🇳",
			"ioc": "VIE",
			"languages": [
				"vie"
			],
			"name": "Viet Nam",
			"status": "assigned"
		},
		{
			"alpha2": "VU",
			"alpha3": "VUT",
			"countryCallingCodes": [
				"+678"
			],
			"currencies": [
				"VUV"
			],
			"emoji": "🇻🇺",
			"ioc": "VAN",
			"languages": [
				"bis",
				"eng",
				"fra"
			],
			"name": "Vanuatu",
			"status": "assigned"
		},
		{
			"alpha2": "WF",
			"alpha3": "WLF",
			"countryCallingCodes": [
				"+681"
			],
			"currencies": [
				"XPF"
			],
			"emoji": "🇼🇫",
			"ioc": "",
			"languages": [
				"fra"
			],
			"name": "Wallis And Futuna",
			"status": "assigned"
		},
		{
			"alpha2": "WK",
			"alpha3": "WAK",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Wake Island",
			"status": "deleted"
		},
		{
			"alpha2": "WS",
			"alpha3": "WSM",
			"countryCallingCodes": [
				"+685"
			],
			"currencies": [
				"WST"
			],
			"emoji": "🇼🇸",
			"ioc": "SAM",
			"languages": [
				"eng",
				"smo"
			],
			"name": "Samoa",
			"status": "assigned"
		},
		{
			"alpha2": "XK",
			"alpha3": "",
			"countryCallingCodes": [
				"+383"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "",
			"ioc": "KOS",
			"languages": [
				"sqi",
				"srp",
				"bos",
				"tur",
				"rom"
			],
			"name": "Kosovo",
			"status": "user assigned"
		},
		{
			"alpha2": "YD",
			"alpha3": "YMD",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Yemen, Democratic",
			"status": "deleted"
		},
		{
			"alpha2": "YE",
			"alpha3": "YEM",
			"countryCallingCodes": [
				"+967"
			],
			"currencies": [
				"YER"
			],
			"emoji": "🇾🇪",
			"ioc": "YEM",
			"languages": [
				"ara"
			],
			"name": "Yemen",
			"status": "assigned"
		},
		{
			"alpha2": "YT",
			"alpha3": "MYT",
			"countryCallingCodes": [
				"+262"
			],
			"currencies": [
				"EUR"
			],
			"emoji": "🇾🇹",
			"ioc": "",
			"languages": [
				"fra"
			],
			"name": "Mayotte",
			"status": "assigned"
		},
		{
			"alpha2": "YU",
			"alpha3": "YUG",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Yugoslavia",
			"status": "deleted"
		},
		{
			"alpha2": "ZA",
			"alpha3": "ZAF",
			"countryCallingCodes": [
				"+27"
			],
			"currencies": [
				"ZAR"
			],
			"emoji": "🇿🇦",
			"ioc": "RSA",
			"languages": [
				"afr",
				"eng",
				"nbl",
				"som",
				"tso",
				"ven",
				"xho",
				"zul"
			],
			"name": "South Africa",
			"status": "assigned"
		},
		{
			"alpha2": "ZM",
			"alpha3": "ZMB",
			"countryCallingCodes": [
				"+260"
			],
			"currencies": [
				"ZMW"
			],
			"emoji": "🇿🇲",
			"ioc": "ZAM",
			"languages": [
				"eng"
			],
			"name": "Zambia",
			"status": "assigned"
		},
		{
			"alpha2": "ZR",
			"alpha3": "ZAR",
			"countryCallingCodes": [],
			"currencies": [],
			"ioc": "",
			"languages": [],
			"name": "Zaire",
			"status": "deleted"
		},
		{
			"alpha2": "ZW",
			"alpha3": "ZWE",
			"countryCallingCodes": [
				"+263"
			],
			"currencies": [
				"USD",
				"ZAR",
				"BWP",
				"GBP",
				"EUR"
			],
			"emoji": "🇿🇼",
			"ioc": "ZIM",
			"languages": [
				"eng",
				"sna",
				"nde"
			],
			"name": "Zimbabwe",
			"status": "assigned"
		}
	];

/***/ },
/* 2947 */
/***/ function(module, exports) {

	module.exports = [
		{
			"code": "AED",
			"decimals": 2,
			"name": "United Arab Emirates dirham",
			"number": "784"
		},
		{
			"code": "AFN",
			"decimals": 2,
			"name": "Afghan afghani",
			"number": "971"
		},
		{
			"code": "ALL",
			"decimals": 2,
			"name": "Albanian lek",
			"number": "8"
		},
		{
			"code": "AMD",
			"decimals": 2,
			"name": "Armenian dram",
			"number": "51"
		},
		{
			"code": "ANG",
			"decimals": 2,
			"name": "Netherlands Antillean guilder",
			"number": "532"
		},
		{
			"code": "AOA",
			"decimals": 2,
			"name": "Angolan kwanza",
			"number": "973"
		},
		{
			"code": "ARS",
			"decimals": 2,
			"name": "Argentine peso",
			"number": "32"
		},
		{
			"code": "AUD",
			"decimals": 2,
			"name": "Australian dollar",
			"number": "36"
		},
		{
			"code": "AWG",
			"decimals": 2,
			"name": "Aruban florin",
			"number": "533"
		},
		{
			"code": "AZN",
			"decimals": 2,
			"name": "Azerbaijani manat",
			"number": "944"
		},
		{
			"code": "BAM",
			"decimals": 2,
			"name": "Bosnia and Herzegovina convertible mark",
			"number": "977"
		},
		{
			"code": "BBD",
			"decimals": 2,
			"name": "Barbados dollar",
			"number": "52"
		},
		{
			"code": "BDT",
			"decimals": 2,
			"name": "Bangladeshi taka",
			"number": "50"
		},
		{
			"code": "BGN",
			"decimals": 2,
			"name": "Bulgarian lev",
			"number": "975"
		},
		{
			"code": "BHD",
			"decimals": 3,
			"name": "Bahraini dinar",
			"number": "48"
		},
		{
			"code": "BIF",
			"decimals": 0,
			"name": "Burundian franc",
			"number": "108"
		},
		{
			"code": "BMD",
			"decimals": 2,
			"name": "Bermudian dollar (customarily known as Bermuda dollar)",
			"number": "60"
		},
		{
			"code": "BND",
			"decimals": 2,
			"name": "Brunei dollar",
			"number": "96"
		},
		{
			"code": "BOB",
			"decimals": 2,
			"name": "Boliviano",
			"number": "68"
		},
		{
			"code": "BOV",
			"decimals": 2,
			"name": "Bolivian Mvdol (funds code)",
			"number": "984"
		},
		{
			"code": "BRL",
			"decimals": 2,
			"name": "Brazilian real",
			"number": "986"
		},
		{
			"code": "BSD",
			"decimals": 2,
			"name": "Bahamian dollar",
			"number": "44"
		},
		{
			"code": "BTN",
			"decimals": 2,
			"name": "Bhutanese ngultrum",
			"number": "64"
		},
		{
			"code": "BWP",
			"decimals": 2,
			"name": "Botswana pula",
			"number": "72"
		},
		{
			"code": "BYR",
			"decimals": 0,
			"name": "Belarusian ruble",
			"number": "974"
		},
		{
			"code": "BZD",
			"decimals": 2,
			"name": "Belize dollar",
			"number": "84"
		},
		{
			"code": "CAD",
			"decimals": 2,
			"name": "Canadian dollar",
			"number": "124"
		},
		{
			"code": "CDF",
			"decimals": 2,
			"name": "Congolese franc",
			"number": "976"
		},
		{
			"code": "CHE",
			"decimals": 2,
			"name": "WIR Euro (complementary currency)",
			"number": "947"
		},
		{
			"code": "CHF",
			"decimals": 2,
			"name": "Swiss franc",
			"number": "756"
		},
		{
			"code": "CHW",
			"decimals": 2,
			"name": "WIR Franc (complementary currency)",
			"number": "948"
		},
		{
			"code": "CLF",
			"decimals": 0,
			"name": "Unidad de Fomento (funds code)",
			"number": "990"
		},
		{
			"code": "CLP",
			"decimals": 0,
			"name": "Chilean peso",
			"number": "152"
		},
		{
			"code": "CNY",
			"decimals": 2,
			"name": "Chinese yuan",
			"number": "156"
		},
		{
			"code": "COP",
			"decimals": 2,
			"name": "Colombian peso",
			"number": "170"
		},
		{
			"code": "COU",
			"decimals": 2,
			"name": "Unidad de Valor Real",
			"number": "970"
		},
		{
			"code": "CRC",
			"decimals": 2,
			"name": "Costa Rican colon",
			"number": "188"
		},
		{
			"code": "CUC",
			"decimals": 2,
			"name": "Cuban convertible peso",
			"number": "931"
		},
		{
			"code": "CUP",
			"decimals": 2,
			"name": "Cuban peso",
			"number": "192"
		},
		{
			"code": "CVE",
			"decimals": 0,
			"name": "Cape Verde escudo",
			"number": "132"
		},
		{
			"code": "CZK",
			"decimals": 2,
			"name": "Czech koruna",
			"number": "203"
		},
		{
			"code": "DJF",
			"decimals": 0,
			"name": "Djiboutian franc",
			"number": "262"
		},
		{
			"code": "DKK",
			"decimals": 2,
			"name": "Danish krone",
			"number": "208"
		},
		{
			"code": "DOP",
			"decimals": 2,
			"name": "Dominican peso",
			"number": "214"
		},
		{
			"code": "DZD",
			"decimals": 2,
			"name": "Algerian dinar",
			"number": "12"
		},
		{
			"code": "EGP",
			"decimals": 2,
			"name": "Egyptian pound",
			"number": "818"
		},
		{
			"code": "ERN",
			"decimals": 2,
			"name": "Eritrean nakfa",
			"number": "232"
		},
		{
			"code": "ETB",
			"decimals": 2,
			"name": "Ethiopian birr",
			"number": "230"
		},
		{
			"code": "EUR",
			"decimals": 2,
			"name": "Euro",
			"number": "978"
		},
		{
			"code": "FJD",
			"decimals": 2,
			"name": "Fiji dollar",
			"number": "242"
		},
		{
			"code": "FKP",
			"decimals": 2,
			"name": "Falkland Islands pound",
			"number": "238"
		},
		{
			"code": "GBP",
			"decimals": 2,
			"name": "Pound sterling",
			"number": "826"
		},
		{
			"code": "GEL",
			"decimals": 2,
			"name": "Georgian lari",
			"number": "981"
		},
		{
			"code": "GHS",
			"decimals": 2,
			"name": "Ghanaian cedi",
			"number": "936"
		},
		{
			"code": "GIP",
			"decimals": 2,
			"name": "Gibraltar pound",
			"number": "292"
		},
		{
			"code": "GMD",
			"decimals": 2,
			"name": "Gambian dalasi",
			"number": "270"
		},
		{
			"code": "GNF",
			"decimals": 0,
			"name": "Guinean franc",
			"number": "324"
		},
		{
			"code": "GTQ",
			"decimals": 2,
			"name": "Guatemalan quetzal",
			"number": "320"
		},
		{
			"code": "GYD",
			"decimals": 2,
			"name": "Guyanese dollar",
			"number": "328"
		},
		{
			"code": "HKD",
			"decimals": 2,
			"name": "Hong Kong dollar",
			"number": "344"
		},
		{
			"code": "HNL",
			"decimals": 2,
			"name": "Honduran lempira",
			"number": "340"
		},
		{
			"code": "HRK",
			"decimals": 2,
			"name": "Croatian kuna",
			"number": "191"
		},
		{
			"code": "HTG",
			"decimals": 2,
			"name": "Haitian gourde",
			"number": "332"
		},
		{
			"code": "HUF",
			"decimals": 2,
			"name": "Hungarian forint",
			"number": "348"
		},
		{
			"code": "IDR",
			"decimals": 2,
			"name": "Indonesian rupiah",
			"number": "360"
		},
		{
			"code": "ILS",
			"decimals": 2,
			"name": "Israeli new shekel",
			"number": "376"
		},
		{
			"code": "INR",
			"decimals": 2,
			"name": "Indian rupee",
			"number": "356"
		},
		{
			"code": "IQD",
			"decimals": 3,
			"name": "Iraqi dinar",
			"number": "368"
		},
		{
			"code": "IRR",
			"decimals": 0,
			"name": "Iranian rial",
			"number": "364"
		},
		{
			"code": "ISK",
			"decimals": 0,
			"name": "Icelandic króna",
			"number": "352"
		},
		{
			"code": "JMD",
			"decimals": 2,
			"name": "Jamaican dollar",
			"number": "388"
		},
		{
			"code": "JOD",
			"decimals": 3,
			"name": "Jordanian dinar",
			"number": "400"
		},
		{
			"code": "JPY",
			"decimals": 0,
			"name": "Japanese yen",
			"number": "392"
		},
		{
			"code": "KES",
			"decimals": 2,
			"name": "Kenyan shilling",
			"number": "404"
		},
		{
			"code": "KGS",
			"decimals": 2,
			"name": "Kyrgyzstani som",
			"number": "417"
		},
		{
			"code": "KHR",
			"decimals": 2,
			"name": "Cambodian riel",
			"number": "116"
		},
		{
			"code": "KMF",
			"decimals": 0,
			"name": "Comoro franc",
			"number": "174"
		},
		{
			"code": "KPW",
			"decimals": 0,
			"name": "North Korean won",
			"number": "408"
		},
		{
			"code": "KRW",
			"decimals": 0,
			"name": "South Korean won",
			"number": "410"
		},
		{
			"code": "KWD",
			"decimals": 3,
			"name": "Kuwaiti dinar",
			"number": "414"
		},
		{
			"code": "KYD",
			"decimals": 2,
			"name": "Cayman Islands dollar",
			"number": "136"
		},
		{
			"code": "KZT",
			"decimals": 2,
			"name": "Kazakhstani tenge",
			"number": "398"
		},
		{
			"code": "LAK",
			"decimals": 0,
			"name": "Lao kip",
			"number": "418"
		},
		{
			"code": "LBP",
			"decimals": 0,
			"name": "Lebanese pound",
			"number": "422"
		},
		{
			"code": "LKR",
			"decimals": 2,
			"name": "Sri Lankan rupee",
			"number": "144"
		},
		{
			"code": "LRD",
			"decimals": 2,
			"name": "Liberian dollar",
			"number": "430"
		},
		{
			"code": "LSL",
			"decimals": 2,
			"name": "Lesotho loti",
			"number": "426"
		},
		{
			"code": "LTL",
			"decimals": 2,
			"name": "Lithuanian litas",
			"number": "440"
		},
		{
			"code": "LVL",
			"decimals": 2,
			"name": "Latvian lats",
			"number": "428"
		},
		{
			"code": "LYD",
			"decimals": 3,
			"name": "Libyan dinar",
			"number": "434"
		},
		{
			"code": "MAD",
			"decimals": 2,
			"name": "Moroccan dirham",
			"number": "504"
		},
		{
			"code": "MDL",
			"decimals": 2,
			"name": "Moldovan leu",
			"number": "498"
		},
		{
			"code": "MGA",
			"decimals": 0,
			"name": "Malagasy ariary",
			"number": "969"
		},
		{
			"code": "MKD",
			"decimals": 0,
			"name": "Macedonian denar",
			"number": "807"
		},
		{
			"code": "MMK",
			"decimals": 0,
			"name": "Myanma kyat",
			"number": "104"
		},
		{
			"code": "MNT",
			"decimals": 2,
			"name": "Mongolian tugrik",
			"number": "496"
		},
		{
			"code": "MOP",
			"decimals": 2,
			"name": "Macanese pataca",
			"number": "446"
		},
		{
			"code": "MRO",
			"decimals": 0,
			"name": "Mauritanian ouguiya",
			"number": "478"
		},
		{
			"code": "MUR",
			"decimals": 2,
			"name": "Mauritian rupee",
			"number": "480"
		},
		{
			"code": "MVR",
			"decimals": 2,
			"name": "Maldivian rufiyaa",
			"number": "462"
		},
		{
			"code": "MWK",
			"decimals": 2,
			"name": "Malawian kwacha",
			"number": "454"
		},
		{
			"code": "MXN",
			"decimals": 2,
			"name": "Mexican peso",
			"number": "484"
		},
		{
			"code": "MXV",
			"decimals": 2,
			"name": "Mexican Unidad de Inversion (UDI) (funds code)",
			"number": "979"
		},
		{
			"code": "MYR",
			"decimals": 2,
			"name": "Malaysian ringgit",
			"number": "458"
		},
		{
			"code": "MZN",
			"decimals": 2,
			"name": "Mozambican metical",
			"number": "943"
		},
		{
			"code": "NAD",
			"decimals": 2,
			"name": "Namibian dollar",
			"number": "516"
		},
		{
			"code": "NGN",
			"decimals": 2,
			"name": "Nigerian naira",
			"number": "566"
		},
		{
			"code": "NIO",
			"decimals": 2,
			"name": "Nicaraguan córdoba",
			"number": "558"
		},
		{
			"code": "NOK",
			"decimals": 2,
			"name": "Norwegian krone",
			"number": "578"
		},
		{
			"code": "NPR",
			"decimals": 2,
			"name": "Nepalese rupee",
			"number": "524"
		},
		{
			"code": "NZD",
			"decimals": 2,
			"name": "New Zealand dollar",
			"number": "554"
		},
		{
			"code": "OMR",
			"decimals": 3,
			"name": "Omani rial",
			"number": "512"
		},
		{
			"code": "PAB",
			"decimals": 2,
			"name": "Panamanian balboa",
			"number": "590"
		},
		{
			"code": "PEN",
			"decimals": 2,
			"name": "Peruvian nuevo sol",
			"number": "604"
		},
		{
			"code": "PGK",
			"decimals": 2,
			"name": "Papua New Guinean kina",
			"number": "598"
		},
		{
			"code": "PHP",
			"decimals": 2,
			"name": "Philippine peso",
			"number": "608"
		},
		{
			"code": "PKR",
			"decimals": 2,
			"name": "Pakistani rupee",
			"number": "586"
		},
		{
			"code": "PLN",
			"decimals": 2,
			"name": "Polish złoty",
			"number": "985"
		},
		{
			"code": "PYG",
			"decimals": 0,
			"name": "Paraguayan guaraní",
			"number": "600"
		},
		{
			"code": "QAR",
			"decimals": 2,
			"name": "Qatari riyal",
			"number": "634"
		},
		{
			"code": "RON",
			"decimals": 2,
			"name": "Romanian new leu",
			"number": "946"
		},
		{
			"code": "RSD",
			"decimals": 2,
			"name": "Serbian dinar",
			"number": "941"
		},
		{
			"code": "RUB",
			"decimals": 2,
			"name": "Russian rouble",
			"number": "643"
		},
		{
			"code": "RWF",
			"decimals": 0,
			"name": "Rwandan franc",
			"number": "646"
		},
		{
			"code": "SAR",
			"decimals": 2,
			"name": "Saudi riyal",
			"number": "682"
		},
		{
			"code": "SBD",
			"decimals": 2,
			"name": "Solomon Islands dollar",
			"number": "90"
		},
		{
			"code": "SCR",
			"decimals": 2,
			"name": "Seychelles rupee",
			"number": "690"
		},
		{
			"code": "SDG",
			"decimals": 2,
			"name": "Sudanese pound",
			"number": "938"
		},
		{
			"code": "SEK",
			"decimals": 2,
			"name": "Swedish krona/kronor",
			"number": "752"
		},
		{
			"code": "SGD",
			"decimals": 2,
			"name": "Singapore dollar",
			"number": "702"
		},
		{
			"code": "SHP",
			"decimals": 2,
			"name": "Saint Helena pound",
			"number": "654"
		},
		{
			"code": "SLL",
			"decimals": 0,
			"name": "Sierra Leonean leone",
			"number": "694"
		},
		{
			"code": "SOS",
			"decimals": 2,
			"name": "Somali shilling",
			"number": "706"
		},
		{
			"code": "SRD",
			"decimals": 2,
			"name": "Surinamese dollar",
			"number": "968"
		},
		{
			"code": "SSP",
			"decimals": 2,
			"name": "South Sudanese pound",
			"number": "728"
		},
		{
			"code": "STD",
			"decimals": 0,
			"name": "São Tomé and Príncipe dobra",
			"number": "678"
		},
		{
			"code": "SYP",
			"decimals": 2,
			"name": "Syrian pound",
			"number": "760"
		},
		{
			"code": "SZL",
			"decimals": 2,
			"name": "Swazi lilangeni",
			"number": "748"
		},
		{
			"code": "THB",
			"decimals": 2,
			"name": "Thai baht",
			"number": "764"
		},
		{
			"code": "TJS",
			"decimals": 2,
			"name": "Tajikistani somoni",
			"number": "972"
		},
		{
			"code": "TMT",
			"decimals": 2,
			"name": "Turkmenistani manat",
			"number": "934"
		},
		{
			"code": "TND",
			"decimals": 3,
			"name": "Tunisian dinar",
			"number": "788"
		},
		{
			"code": "TOP",
			"decimals": 2,
			"name": "Tongan paʻanga",
			"number": "776"
		},
		{
			"code": "TRY",
			"decimals": 2,
			"name": "Turkish lira",
			"number": "949"
		},
		{
			"code": "TTD",
			"decimals": 2,
			"name": "Trinidad and Tobago dollar",
			"number": "780"
		},
		{
			"code": "TWD",
			"decimals": 2,
			"name": "New Taiwan dollar",
			"number": "901"
		},
		{
			"code": "TZS",
			"decimals": 2,
			"name": "Tanzanian shilling",
			"number": "834"
		},
		{
			"code": "UAH",
			"decimals": 2,
			"name": "Ukrainian hryvnia",
			"number": "980"
		},
		{
			"code": "UGX",
			"decimals": 2,
			"name": "Ugandan shilling",
			"number": "800"
		},
		{
			"code": "USD",
			"decimals": 2,
			"name": "United States dollar",
			"number": "840"
		},
		{
			"code": "USN",
			"decimals": 2,
			"name": "United States dollar (next day) (funds code)",
			"number": "997"
		},
		{
			"code": "USS",
			"decimals": 2,
			"name": "United States dollar (same day) (funds code) (one source[who?] claims it is no longer used, but it is still on the ISO 4217-MA list)",
			"number": "998"
		},
		{
			"code": "UYI",
			"decimals": 0,
			"name": "Uruguay Peso en Unidades Indexadas (URUIURUI) (funds code)",
			"number": "940"
		},
		{
			"code": "UYU",
			"decimals": 2,
			"name": "Uruguayan peso",
			"number": "858"
		},
		{
			"code": "UZS",
			"decimals": 2,
			"name": "Uzbekistan som",
			"number": "860"
		},
		{
			"code": "VEF",
			"decimals": 2,
			"name": "Venezuelan bolívar fuerte",
			"number": "937"
		},
		{
			"code": "VND",
			"decimals": 0,
			"name": "Vietnamese dong",
			"number": "704"
		},
		{
			"code": "VUV",
			"decimals": 0,
			"name": "Vanuatu vatu",
			"number": "548"
		},
		{
			"code": "WST",
			"decimals": 2,
			"name": "Samoan tala",
			"number": "882"
		},
		{
			"code": "XAF",
			"decimals": 0,
			"name": "CFA franc BEAC",
			"number": "950"
		},
		{
			"code": "XAG",
			"decimals": null,
			"name": "Silver (one troy ounce)",
			"number": "961"
		},
		{
			"code": "XAU",
			"decimals": null,
			"name": "Gold (one troy ounce)",
			"number": "959"
		},
		{
			"code": "XBA",
			"decimals": null,
			"name": "European Composite Unit (EURCO) (bond market unit)",
			"number": "955"
		},
		{
			"code": "XBB",
			"decimals": null,
			"name": "European Monetary Unit (E.M.U.-6) (bond market unit)",
			"number": "956"
		},
		{
			"code": "XBC",
			"decimals": null,
			"name": "European Unit of Account 9 (E.U.A.-9) (bond market unit)",
			"number": "957"
		},
		{
			"code": "XBD",
			"decimals": null,
			"name": "European Unit of Account 17 (E.U.A.-17) (bond market unit)",
			"number": "958"
		},
		{
			"code": "XCD",
			"decimals": 2,
			"name": "East Caribbean dollar",
			"number": "951"
		},
		{
			"code": "XDR",
			"decimals": null,
			"name": "Special drawing rights",
			"number": "960"
		},
		{
			"code": "XFU",
			"decimals": null,
			"name": "UIC franc (special settlement currency)",
			"number": "Nil"
		},
		{
			"code": "XOF",
			"decimals": 0,
			"name": "CFA franc BCEAO",
			"number": "952"
		},
		{
			"code": "XPD",
			"decimals": null,
			"name": "Palladium (one troy ounce)",
			"number": "964"
		},
		{
			"code": "XPF",
			"decimals": 0,
			"name": "CFP franc",
			"number": "953"
		},
		{
			"code": "XPT",
			"decimals": null,
			"name": "Platinum (one troy ounce)",
			"number": "962"
		},
		{
			"code": "XTS",
			"decimals": null,
			"name": "Code reserved for testing purposes",
			"number": "963"
		},
		{
			"code": "XXX",
			"decimals": null,
			"name": "No currency",
			"number": "999"
		},
		{
			"code": "YER",
			"decimals": 2,
			"name": "Yemeni rial",
			"number": "886"
		},
		{
			"code": "ZAR",
			"decimals": 2,
			"name": "South African rand",
			"number": "710"
		},
		{
			"code": "ZMW",
			"decimals": 2,
			"name": "Zambian kwacha",
			"number": "967"
		}
	];

/***/ },
/* 2948 */
/***/ function(module, exports) {

	module.exports = [
		{
			"alpha2": "aa",
			"alpha3": "aar",
			"bibliographic": "",
			"name": "Afar"
		},
		{
			"alpha2": "ab",
			"alpha3": "abk",
			"bibliographic": "",
			"name": "Abkhazian"
		},
		{
			"alpha2": "",
			"alpha3": "ace",
			"bibliographic": "",
			"name": "Achinese"
		},
		{
			"alpha2": "",
			"alpha3": "ach",
			"bibliographic": "",
			"name": "Acoli"
		},
		{
			"alpha2": "",
			"alpha3": "ada",
			"bibliographic": "",
			"name": "Adangme"
		},
		{
			"alpha2": "",
			"alpha3": "ady",
			"bibliographic": "",
			"name": "Adygei"
		},
		{
			"alpha2": "",
			"alpha3": "ady",
			"bibliographic": "",
			"name": "Adyghe"
		},
		{
			"alpha2": "",
			"alpha3": "afa",
			"bibliographic": "",
			"name": "Afro-Asiatic languages"
		},
		{
			"alpha2": "",
			"alpha3": "afh",
			"bibliographic": "",
			"name": "Afrihili"
		},
		{
			"alpha2": "af",
			"alpha3": "afr",
			"bibliographic": "",
			"name": "Afrikaans"
		},
		{
			"alpha2": "",
			"alpha3": "ain",
			"bibliographic": "",
			"name": "Ainu"
		},
		{
			"alpha2": "ak",
			"alpha3": "aka",
			"bibliographic": "",
			"name": "Akan"
		},
		{
			"alpha2": "",
			"alpha3": "akk",
			"bibliographic": "",
			"name": "Akkadian"
		},
		{
			"alpha2": "",
			"alpha3": "ale",
			"bibliographic": "",
			"name": "Aleut"
		},
		{
			"alpha2": "",
			"alpha3": "alg",
			"bibliographic": "",
			"name": "Algonquian languages"
		},
		{
			"alpha2": "",
			"alpha3": "alt",
			"bibliographic": "",
			"name": "Southern Altai"
		},
		{
			"alpha2": "am",
			"alpha3": "amh",
			"bibliographic": "",
			"name": "Amharic"
		},
		{
			"alpha2": "",
			"alpha3": "ang",
			"bibliographic": "",
			"name": "English, Old (ca.450-1100)"
		},
		{
			"alpha2": "",
			"alpha3": "anp",
			"bibliographic": "",
			"name": "Angika"
		},
		{
			"alpha2": "",
			"alpha3": "apa",
			"bibliographic": "",
			"name": "Apache languages"
		},
		{
			"alpha2": "ar",
			"alpha3": "ara",
			"bibliographic": "",
			"name": "Arabic"
		},
		{
			"alpha2": "",
			"alpha3": "arc",
			"bibliographic": "",
			"name": "Imperial Aramaic (700-300 BCE)"
		},
		{
			"alpha2": "",
			"alpha3": "arc",
			"bibliographic": "",
			"name": "Official Aramaic (700-300 BCE)"
		},
		{
			"alpha2": "an",
			"alpha3": "arg",
			"bibliographic": "",
			"name": "Aragonese"
		},
		{
			"alpha2": "",
			"alpha3": "arn",
			"bibliographic": "",
			"name": "Mapuche"
		},
		{
			"alpha2": "",
			"alpha3": "arn",
			"bibliographic": "",
			"name": "Mapudungun"
		},
		{
			"alpha2": "",
			"alpha3": "arp",
			"bibliographic": "",
			"name": "Arapaho"
		},
		{
			"alpha2": "",
			"alpha3": "art",
			"bibliographic": "",
			"name": "Artificial languages"
		},
		{
			"alpha2": "",
			"alpha3": "arw",
			"bibliographic": "",
			"name": "Arawak"
		},
		{
			"alpha2": "as",
			"alpha3": "asm",
			"bibliographic": "",
			"name": "Assamese"
		},
		{
			"alpha2": "",
			"alpha3": "ast",
			"bibliographic": "",
			"name": "Asturian"
		},
		{
			"alpha2": "",
			"alpha3": "ast",
			"bibliographic": "",
			"name": "Asturleonese"
		},
		{
			"alpha2": "",
			"alpha3": "ast",
			"bibliographic": "",
			"name": "Bable"
		},
		{
			"alpha2": "",
			"alpha3": "ast",
			"bibliographic": "",
			"name": "Leonese"
		},
		{
			"alpha2": "",
			"alpha3": "ath",
			"bibliographic": "",
			"name": "Athapascan languages"
		},
		{
			"alpha2": "",
			"alpha3": "aus",
			"bibliographic": "",
			"name": "Australian languages"
		},
		{
			"alpha2": "av",
			"alpha3": "ava",
			"bibliographic": "",
			"name": "Avaric"
		},
		{
			"alpha2": "ae",
			"alpha3": "ave",
			"bibliographic": "",
			"name": "Avestan"
		},
		{
			"alpha2": "",
			"alpha3": "awa",
			"bibliographic": "",
			"name": "Awadhi"
		},
		{
			"alpha2": "ay",
			"alpha3": "aym",
			"bibliographic": "",
			"name": "Aymara"
		},
		{
			"alpha2": "az",
			"alpha3": "aze",
			"bibliographic": "",
			"name": "Azerbaijani"
		},
		{
			"alpha2": "",
			"alpha3": "bad",
			"bibliographic": "",
			"name": "Banda languages"
		},
		{
			"alpha2": "",
			"alpha3": "bai",
			"bibliographic": "",
			"name": "Bamileke languages"
		},
		{
			"alpha2": "ba",
			"alpha3": "bak",
			"bibliographic": "",
			"name": "Bashkir"
		},
		{
			"alpha2": "",
			"alpha3": "bal",
			"bibliographic": "",
			"name": "Baluchi"
		},
		{
			"alpha2": "bm",
			"alpha3": "bam",
			"bibliographic": "",
			"name": "Bambara"
		},
		{
			"alpha2": "",
			"alpha3": "ban",
			"bibliographic": "",
			"name": "Balinese"
		},
		{
			"alpha2": "",
			"alpha3": "bas",
			"bibliographic": "",
			"name": "Basa"
		},
		{
			"alpha2": "",
			"alpha3": "bat",
			"bibliographic": "",
			"name": "Baltic languages"
		},
		{
			"alpha2": "",
			"alpha3": "bej",
			"bibliographic": "",
			"name": "Bedawiyet"
		},
		{
			"alpha2": "",
			"alpha3": "bej",
			"bibliographic": "",
			"name": "Beja"
		},
		{
			"alpha2": "be",
			"alpha3": "bel",
			"bibliographic": "",
			"name": "Belarusian"
		},
		{
			"alpha2": "",
			"alpha3": "bem",
			"bibliographic": "",
			"name": "Bemba"
		},
		{
			"alpha2": "bn",
			"alpha3": "ben",
			"bibliographic": "",
			"name": "Bengali"
		},
		{
			"alpha2": "",
			"alpha3": "ber",
			"bibliographic": "",
			"name": "Berber languages"
		},
		{
			"alpha2": "",
			"alpha3": "bho",
			"bibliographic": "",
			"name": "Bhojpuri"
		},
		{
			"alpha2": "bh",
			"alpha3": "bih",
			"bibliographic": "",
			"name": "Bihari languages"
		},
		{
			"alpha2": "",
			"alpha3": "bik",
			"bibliographic": "",
			"name": "Bikol"
		},
		{
			"alpha2": "",
			"alpha3": "bin",
			"bibliographic": "",
			"name": "Bini"
		},
		{
			"alpha2": "",
			"alpha3": "bin",
			"bibliographic": "",
			"name": "Edo"
		},
		{
			"alpha2": "bi",
			"alpha3": "bis",
			"bibliographic": "",
			"name": "Bislama"
		},
		{
			"alpha2": "",
			"alpha3": "bla",
			"bibliographic": "",
			"name": "Siksika"
		},
		{
			"alpha2": "",
			"alpha3": "bnt",
			"bibliographic": "",
			"name": "Bantu languages"
		},
		{
			"alpha2": "bo",
			"alpha3": "bod",
			"bibliographic": "tib",
			"name": "Tibetan"
		},
		{
			"alpha2": "bs",
			"alpha3": "bos",
			"bibliographic": "",
			"name": "Bosnian"
		},
		{
			"alpha2": "",
			"alpha3": "bra",
			"bibliographic": "",
			"name": "Braj"
		},
		{
			"alpha2": "br",
			"alpha3": "bre",
			"bibliographic": "",
			"name": "Breton"
		},
		{
			"alpha2": "",
			"alpha3": "btk",
			"bibliographic": "",
			"name": "Batak languages"
		},
		{
			"alpha2": "",
			"alpha3": "bua",
			"bibliographic": "",
			"name": "Buriat"
		},
		{
			"alpha2": "",
			"alpha3": "bug",
			"bibliographic": "",
			"name": "Buginese"
		},
		{
			"alpha2": "bg",
			"alpha3": "bul",
			"bibliographic": "",
			"name": "Bulgarian"
		},
		{
			"alpha2": "",
			"alpha3": "byn",
			"bibliographic": "",
			"name": "Bilin"
		},
		{
			"alpha2": "",
			"alpha3": "byn",
			"bibliographic": "",
			"name": "Blin"
		},
		{
			"alpha2": "",
			"alpha3": "cad",
			"bibliographic": "",
			"name": "Caddo"
		},
		{
			"alpha2": "",
			"alpha3": "cai",
			"bibliographic": "",
			"name": "Central American Indian languages"
		},
		{
			"alpha2": "",
			"alpha3": "car",
			"bibliographic": "",
			"name": "Galibi Carib"
		},
		{
			"alpha2": "ca",
			"alpha3": "cat",
			"bibliographic": "",
			"name": "Catalan"
		},
		{
			"alpha2": "ca",
			"alpha3": "cat",
			"bibliographic": "",
			"name": "Valencian"
		},
		{
			"alpha2": "",
			"alpha3": "cau",
			"bibliographic": "",
			"name": "Caucasian languages"
		},
		{
			"alpha2": "",
			"alpha3": "ceb",
			"bibliographic": "",
			"name": "Cebuano"
		},
		{
			"alpha2": "",
			"alpha3": "cel",
			"bibliographic": "",
			"name": "Celtic languages"
		},
		{
			"alpha2": "cs",
			"alpha3": "ces",
			"bibliographic": "cze",
			"name": "Czech"
		},
		{
			"alpha2": "ch",
			"alpha3": "cha",
			"bibliographic": "",
			"name": "Chamorro"
		},
		{
			"alpha2": "",
			"alpha3": "chb",
			"bibliographic": "",
			"name": "Chibcha"
		},
		{
			"alpha2": "ce",
			"alpha3": "che",
			"bibliographic": "",
			"name": "Chechen"
		},
		{
			"alpha2": "",
			"alpha3": "chg",
			"bibliographic": "",
			"name": "Chagatai"
		},
		{
			"alpha2": "",
			"alpha3": "chk",
			"bibliographic": "",
			"name": "Chuukese"
		},
		{
			"alpha2": "",
			"alpha3": "chm",
			"bibliographic": "",
			"name": "Mari"
		},
		{
			"alpha2": "",
			"alpha3": "chn",
			"bibliographic": "",
			"name": "Chinook jargon"
		},
		{
			"alpha2": "",
			"alpha3": "cho",
			"bibliographic": "",
			"name": "Choctaw"
		},
		{
			"alpha2": "",
			"alpha3": "chp",
			"bibliographic": "",
			"name": "Chipewyan"
		},
		{
			"alpha2": "",
			"alpha3": "chp",
			"bibliographic": "",
			"name": "Dene Suline"
		},
		{
			"alpha2": "",
			"alpha3": "chr",
			"bibliographic": "",
			"name": "Cherokee"
		},
		{
			"alpha2": "cu",
			"alpha3": "chu",
			"bibliographic": "",
			"name": "Church Slavic"
		},
		{
			"alpha2": "cu",
			"alpha3": "chu",
			"bibliographic": "",
			"name": "Church Slavonic"
		},
		{
			"alpha2": "cu",
			"alpha3": "chu",
			"bibliographic": "",
			"name": "Old Bulgarian"
		},
		{
			"alpha2": "cu",
			"alpha3": "chu",
			"bibliographic": "",
			"name": "Old Church Slavonic"
		},
		{
			"alpha2": "cu",
			"alpha3": "chu",
			"bibliographic": "",
			"name": "Old Slavonic"
		},
		{
			"alpha2": "cv",
			"alpha3": "chv",
			"bibliographic": "",
			"name": "Chuvash"
		},
		{
			"alpha2": "",
			"alpha3": "chy",
			"bibliographic": "",
			"name": "Cheyenne"
		},
		{
			"alpha2": "",
			"alpha3": "cmc",
			"bibliographic": "",
			"name": "Chamic languages"
		},
		{
			"alpha2": "",
			"alpha3": "cop",
			"bibliographic": "",
			"name": "Coptic"
		},
		{
			"alpha2": "kw",
			"alpha3": "cor",
			"bibliographic": "",
			"name": "Cornish"
		},
		{
			"alpha2": "co",
			"alpha3": "cos",
			"bibliographic": "",
			"name": "Corsican"
		},
		{
			"alpha2": "",
			"alpha3": "cpe",
			"bibliographic": "",
			"name": "Creoles and pidgins, English based"
		},
		{
			"alpha2": "",
			"alpha3": "cpf",
			"bibliographic": "",
			"name": "Creoles and pidgins, French-based"
		},
		{
			"alpha2": "",
			"alpha3": "cpp",
			"bibliographic": "",
			"name": "Creoles and pidgins, Portuguese-based"
		},
		{
			"alpha2": "cr",
			"alpha3": "cre",
			"bibliographic": "",
			"name": "Cree"
		},
		{
			"alpha2": "",
			"alpha3": "crh",
			"bibliographic": "",
			"name": "Crimean Tatar"
		},
		{
			"alpha2": "",
			"alpha3": "crh",
			"bibliographic": "",
			"name": "Crimean Turkish"
		},
		{
			"alpha2": "",
			"alpha3": "crp",
			"bibliographic": "",
			"name": "Creoles and pidgins"
		},
		{
			"alpha2": "",
			"alpha3": "csb",
			"bibliographic": "",
			"name": "Kashubian"
		},
		{
			"alpha2": "",
			"alpha3": "cus",
			"bibliographic": "",
			"name": "Cushitic languages"
		},
		{
			"alpha2": "cy",
			"alpha3": "cym",
			"bibliographic": "wel",
			"name": "Welsh"
		},
		{
			"alpha2": "",
			"alpha3": "dak",
			"bibliographic": "",
			"name": "Dakota"
		},
		{
			"alpha2": "da",
			"alpha3": "dan",
			"bibliographic": "",
			"name": "Danish"
		},
		{
			"alpha2": "",
			"alpha3": "dar",
			"bibliographic": "",
			"name": "Dargwa"
		},
		{
			"alpha2": "",
			"alpha3": "day",
			"bibliographic": "",
			"name": "Land Dayak languages"
		},
		{
			"alpha2": "",
			"alpha3": "del",
			"bibliographic": "",
			"name": "Delaware"
		},
		{
			"alpha2": "",
			"alpha3": "den",
			"bibliographic": "",
			"name": "Slave (Athapascan)"
		},
		{
			"alpha2": "de",
			"alpha3": "deu",
			"bibliographic": "ger",
			"name": "German"
		},
		{
			"alpha2": "",
			"alpha3": "dgr",
			"bibliographic": "",
			"name": "Dogrib"
		},
		{
			"alpha2": "",
			"alpha3": "din",
			"bibliographic": "",
			"name": "Dinka"
		},
		{
			"alpha2": "dv",
			"alpha3": "div",
			"bibliographic": "",
			"name": "Dhivehi"
		},
		{
			"alpha2": "dv",
			"alpha3": "div",
			"bibliographic": "",
			"name": "Divehi"
		},
		{
			"alpha2": "dv",
			"alpha3": "div",
			"bibliographic": "",
			"name": "Maldivian"
		},
		{
			"alpha2": "",
			"alpha3": "doi",
			"bibliographic": "",
			"name": "Dogri"
		},
		{
			"alpha2": "",
			"alpha3": "dra",
			"bibliographic": "",
			"name": "Dravidian languages"
		},
		{
			"alpha2": "",
			"alpha3": "dsb",
			"bibliographic": "",
			"name": "Lower Sorbian"
		},
		{
			"alpha2": "",
			"alpha3": "dua",
			"bibliographic": "",
			"name": "Duala"
		},
		{
			"alpha2": "",
			"alpha3": "dum",
			"bibliographic": "",
			"name": "Dutch, Middle (ca.1050-1350)"
		},
		{
			"alpha2": "",
			"alpha3": "dyu",
			"bibliographic": "",
			"name": "Dyula"
		},
		{
			"alpha2": "dz",
			"alpha3": "dzo",
			"bibliographic": "",
			"name": "Dzongkha"
		},
		{
			"alpha2": "",
			"alpha3": "efi",
			"bibliographic": "",
			"name": "Efik"
		},
		{
			"alpha2": "",
			"alpha3": "egy",
			"bibliographic": "",
			"name": "Egyptian (Ancient)"
		},
		{
			"alpha2": "",
			"alpha3": "eka",
			"bibliographic": "",
			"name": "Ekajuk"
		},
		{
			"alpha2": "el",
			"alpha3": "ell",
			"bibliographic": "gre",
			"name": "Greek, Modern (1453-)"
		},
		{
			"alpha2": "",
			"alpha3": "elx",
			"bibliographic": "",
			"name": "Elamite"
		},
		{
			"alpha2": "en",
			"alpha3": "eng",
			"bibliographic": "",
			"name": "English"
		},
		{
			"alpha2": "",
			"alpha3": "enm",
			"bibliographic": "",
			"name": "English, Middle (1100-1500)"
		},
		{
			"alpha2": "eo",
			"alpha3": "epo",
			"bibliographic": "",
			"name": "Esperanto"
		},
		{
			"alpha2": "et",
			"alpha3": "est",
			"bibliographic": "",
			"name": "Estonian"
		},
		{
			"alpha2": "eu",
			"alpha3": "eus",
			"bibliographic": "baq",
			"name": "Basque"
		},
		{
			"alpha2": "ee",
			"alpha3": "ewe",
			"bibliographic": "",
			"name": "Ewe"
		},
		{
			"alpha2": "",
			"alpha3": "ewo",
			"bibliographic": "",
			"name": "Ewondo"
		},
		{
			"alpha2": "",
			"alpha3": "fan",
			"bibliographic": "",
			"name": "Fang"
		},
		{
			"alpha2": "fo",
			"alpha3": "fao",
			"bibliographic": "",
			"name": "Faroese"
		},
		{
			"alpha2": "fa",
			"alpha3": "fas",
			"bibliographic": "per",
			"name": "Persian"
		},
		{
			"alpha2": "",
			"alpha3": "fat",
			"bibliographic": "",
			"name": "Fanti"
		},
		{
			"alpha2": "fj",
			"alpha3": "fij",
			"bibliographic": "",
			"name": "Fijian"
		},
		{
			"alpha2": "",
			"alpha3": "fil",
			"bibliographic": "",
			"name": "Filipino"
		},
		{
			"alpha2": "",
			"alpha3": "fil",
			"bibliographic": "",
			"name": "Pilipino"
		},
		{
			"alpha2": "fi",
			"alpha3": "fin",
			"bibliographic": "",
			"name": "Finnish"
		},
		{
			"alpha2": "",
			"alpha3": "fiu",
			"bibliographic": "",
			"name": "Finno-Ugrian languages"
		},
		{
			"alpha2": "",
			"alpha3": "fon",
			"bibliographic": "",
			"name": "Fon"
		},
		{
			"alpha2": "fr",
			"alpha3": "fra",
			"bibliographic": "fre",
			"name": "French"
		},
		{
			"alpha2": "",
			"alpha3": "frm",
			"bibliographic": "",
			"name": "French, Middle (ca.1400-1600)"
		},
		{
			"alpha2": "",
			"alpha3": "fro",
			"bibliographic": "",
			"name": "French, Old (842-ca.1400)"
		},
		{
			"alpha2": "",
			"alpha3": "frr",
			"bibliographic": "",
			"name": "Northern Frisian"
		},
		{
			"alpha2": "",
			"alpha3": "frs",
			"bibliographic": "",
			"name": "Eastern Frisian"
		},
		{
			"alpha2": "fy",
			"alpha3": "fry",
			"bibliographic": "",
			"name": "Western Frisian"
		},
		{
			"alpha2": "ff",
			"alpha3": "ful",
			"bibliographic": "",
			"name": "Fulah"
		},
		{
			"alpha2": "",
			"alpha3": "fur",
			"bibliographic": "",
			"name": "Friulian"
		},
		{
			"alpha2": "",
			"alpha3": "gaa",
			"bibliographic": "",
			"name": "Ga"
		},
		{
			"alpha2": "",
			"alpha3": "gay",
			"bibliographic": "",
			"name": "Gayo"
		},
		{
			"alpha2": "",
			"alpha3": "gba",
			"bibliographic": "",
			"name": "Gbaya"
		},
		{
			"alpha2": "",
			"alpha3": "gem",
			"bibliographic": "",
			"name": "Germanic languages"
		},
		{
			"alpha2": "",
			"alpha3": "gez",
			"bibliographic": "",
			"name": "Geez"
		},
		{
			"alpha2": "",
			"alpha3": "gil",
			"bibliographic": "",
			"name": "Gilbertese"
		},
		{
			"alpha2": "gd",
			"alpha3": "gla",
			"bibliographic": "",
			"name": "Gaelic"
		},
		{
			"alpha2": "gd",
			"alpha3": "gla",
			"bibliographic": "",
			"name": "Scottish Gaelic"
		},
		{
			"alpha2": "ga",
			"alpha3": "gle",
			"bibliographic": "",
			"name": "Irish"
		},
		{
			"alpha2": "gl",
			"alpha3": "glg",
			"bibliographic": "",
			"name": "Galician"
		},
		{
			"alpha2": "gv",
			"alpha3": "glv",
			"bibliographic": "",
			"name": "Manx"
		},
		{
			"alpha2": "",
			"alpha3": "gmh",
			"bibliographic": "",
			"name": "German, Middle High (ca.1050-1500)"
		},
		{
			"alpha2": "",
			"alpha3": "goh",
			"bibliographic": "",
			"name": "German, Old High (ca.750-1050)"
		},
		{
			"alpha2": "",
			"alpha3": "gon",
			"bibliographic": "",
			"name": "Gondi"
		},
		{
			"alpha2": "",
			"alpha3": "gor",
			"bibliographic": "",
			"name": "Gorontalo"
		},
		{
			"alpha2": "",
			"alpha3": "got",
			"bibliographic": "",
			"name": "Gothic"
		},
		{
			"alpha2": "",
			"alpha3": "grb",
			"bibliographic": "",
			"name": "Grebo"
		},
		{
			"alpha2": "",
			"alpha3": "grc",
			"bibliographic": "",
			"name": "Greek, Ancient (to 1453)"
		},
		{
			"alpha2": "gn",
			"alpha3": "grn",
			"bibliographic": "",
			"name": "Guarani"
		},
		{
			"alpha2": "",
			"alpha3": "gsw",
			"bibliographic": "",
			"name": "Alemannic"
		},
		{
			"alpha2": "",
			"alpha3": "gsw",
			"bibliographic": "",
			"name": "Alsatian"
		},
		{
			"alpha2": "",
			"alpha3": "gsw",
			"bibliographic": "",
			"name": "Swiss German"
		},
		{
			"alpha2": "gu",
			"alpha3": "guj",
			"bibliographic": "",
			"name": "Gujarati"
		},
		{
			"alpha2": "",
			"alpha3": "gwi",
			"bibliographic": "",
			"name": "Gwich'in"
		},
		{
			"alpha2": "",
			"alpha3": "hai",
			"bibliographic": "",
			"name": "Haida"
		},
		{
			"alpha2": "ht",
			"alpha3": "hat",
			"bibliographic": "",
			"name": "Haitian"
		},
		{
			"alpha2": "ht",
			"alpha3": "hat",
			"bibliographic": "",
			"name": "Haitian Creole"
		},
		{
			"alpha2": "ha",
			"alpha3": "hau",
			"bibliographic": "",
			"name": "Hausa"
		},
		{
			"alpha2": "",
			"alpha3": "haw",
			"bibliographic": "",
			"name": "Hawaiian"
		},
		{
			"alpha2": "he",
			"alpha3": "heb",
			"bibliographic": "",
			"name": "Hebrew"
		},
		{
			"alpha2": "hz",
			"alpha3": "her",
			"bibliographic": "",
			"name": "Herero"
		},
		{
			"alpha2": "",
			"alpha3": "hil",
			"bibliographic": "",
			"name": "Hiligaynon"
		},
		{
			"alpha2": "",
			"alpha3": "him",
			"bibliographic": "",
			"name": "Himachali languages"
		},
		{
			"alpha2": "",
			"alpha3": "him",
			"bibliographic": "",
			"name": "Western Pahari languages"
		},
		{
			"alpha2": "hi",
			"alpha3": "hin",
			"bibliographic": "",
			"name": "Hindi"
		},
		{
			"alpha2": "",
			"alpha3": "hit",
			"bibliographic": "",
			"name": "Hittite"
		},
		{
			"alpha2": "",
			"alpha3": "hmn",
			"bibliographic": "",
			"name": "Hmong"
		},
		{
			"alpha2": "",
			"alpha3": "hmn",
			"bibliographic": "",
			"name": "Mong"
		},
		{
			"alpha2": "ho",
			"alpha3": "hmo",
			"bibliographic": "",
			"name": "Hiri Motu"
		},
		{
			"alpha2": "hr",
			"alpha3": "hrv",
			"bibliographic": "",
			"name": "Croatian"
		},
		{
			"alpha2": "",
			"alpha3": "hsb",
			"bibliographic": "",
			"name": "Upper Sorbian"
		},
		{
			"alpha2": "hu",
			"alpha3": "hun",
			"bibliographic": "",
			"name": "Hungarian"
		},
		{
			"alpha2": "",
			"alpha3": "hup",
			"bibliographic": "",
			"name": "Hupa"
		},
		{
			"alpha2": "hy",
			"alpha3": "hye",
			"bibliographic": "arm",
			"name": "Armenian"
		},
		{
			"alpha2": "",
			"alpha3": "iba",
			"bibliographic": "",
			"name": "Iban"
		},
		{
			"alpha2": "ig",
			"alpha3": "ibo",
			"bibliographic": "",
			"name": "Igbo"
		},
		{
			"alpha2": "io",
			"alpha3": "ido",
			"bibliographic": "",
			"name": "Ido"
		},
		{
			"alpha2": "ii",
			"alpha3": "iii",
			"bibliographic": "",
			"name": "Nuosu"
		},
		{
			"alpha2": "ii",
			"alpha3": "iii",
			"bibliographic": "",
			"name": "Sichuan Yi"
		},
		{
			"alpha2": "",
			"alpha3": "ijo",
			"bibliographic": "",
			"name": "Ijo languages"
		},
		{
			"alpha2": "iu",
			"alpha3": "iku",
			"bibliographic": "",
			"name": "Inuktitut"
		},
		{
			"alpha2": "ie",
			"alpha3": "ile",
			"bibliographic": "",
			"name": "Interlingue"
		},
		{
			"alpha2": "ie",
			"alpha3": "ile",
			"bibliographic": "",
			"name": "Occidental"
		},
		{
			"alpha2": "",
			"alpha3": "ilo",
			"bibliographic": "",
			"name": "Iloko"
		},
		{
			"alpha2": "ia",
			"alpha3": "ina",
			"bibliographic": "",
			"name": "Interlingua (International Auxiliary Language Association)"
		},
		{
			"alpha2": "",
			"alpha3": "inc",
			"bibliographic": "",
			"name": "Indic languages"
		},
		{
			"alpha2": "id",
			"alpha3": "ind",
			"bibliographic": "",
			"name": "Indonesian"
		},
		{
			"alpha2": "",
			"alpha3": "ine",
			"bibliographic": "",
			"name": "Indo-European languages"
		},
		{
			"alpha2": "",
			"alpha3": "inh",
			"bibliographic": "",
			"name": "Ingush"
		},
		{
			"alpha2": "ik",
			"alpha3": "ipk",
			"bibliographic": "",
			"name": "Inupiaq"
		},
		{
			"alpha2": "",
			"alpha3": "ira",
			"bibliographic": "",
			"name": "Iranian languages"
		},
		{
			"alpha2": "",
			"alpha3": "iro",
			"bibliographic": "",
			"name": "Iroquoian languages"
		},
		{
			"alpha2": "is",
			"alpha3": "isl",
			"bibliographic": "ice",
			"name": "Icelandic"
		},
		{
			"alpha2": "it",
			"alpha3": "ita",
			"bibliographic": "",
			"name": "Italian"
		},
		{
			"alpha2": "jv",
			"alpha3": "jav",
			"bibliographic": "",
			"name": "Javanese"
		},
		{
			"alpha2": "",
			"alpha3": "jbo",
			"bibliographic": "",
			"name": "Lojban"
		},
		{
			"alpha2": "ja",
			"alpha3": "jpn",
			"bibliographic": "",
			"name": "Japanese"
		},
		{
			"alpha2": "",
			"alpha3": "jpr",
			"bibliographic": "",
			"name": "Judeo-Persian"
		},
		{
			"alpha2": "",
			"alpha3": "jrb",
			"bibliographic": "",
			"name": "Judeo-Arabic"
		},
		{
			"alpha2": "",
			"alpha3": "kaa",
			"bibliographic": "",
			"name": "Kara-Kalpak"
		},
		{
			"alpha2": "",
			"alpha3": "kab",
			"bibliographic": "",
			"name": "Kabyle"
		},
		{
			"alpha2": "",
			"alpha3": "kac",
			"bibliographic": "",
			"name": "Jingpho"
		},
		{
			"alpha2": "",
			"alpha3": "kac",
			"bibliographic": "",
			"name": "Kachin"
		},
		{
			"alpha2": "kl",
			"alpha3": "kal",
			"bibliographic": "",
			"name": "Greenlandic"
		},
		{
			"alpha2": "kl",
			"alpha3": "kal",
			"bibliographic": "",
			"name": "Kalaallisut"
		},
		{
			"alpha2": "",
			"alpha3": "kam",
			"bibliographic": "",
			"name": "Kamba"
		},
		{
			"alpha2": "kn",
			"alpha3": "kan",
			"bibliographic": "",
			"name": "Kannada"
		},
		{
			"alpha2": "",
			"alpha3": "kar",
			"bibliographic": "",
			"name": "Karen languages"
		},
		{
			"alpha2": "ks",
			"alpha3": "kas",
			"bibliographic": "",
			"name": "Kashmiri"
		},
		{
			"alpha2": "ka",
			"alpha3": "kat",
			"bibliographic": "geo",
			"name": "Georgian"
		},
		{
			"alpha2": "kr",
			"alpha3": "kau",
			"bibliographic": "",
			"name": "Kanuri"
		},
		{
			"alpha2": "",
			"alpha3": "kaw",
			"bibliographic": "",
			"name": "Kawi"
		},
		{
			"alpha2": "kk",
			"alpha3": "kaz",
			"bibliographic": "",
			"name": "Kazakh"
		},
		{
			"alpha2": "",
			"alpha3": "kbd",
			"bibliographic": "",
			"name": "Kabardian"
		},
		{
			"alpha2": "",
			"alpha3": "kha",
			"bibliographic": "",
			"name": "Khasi"
		},
		{
			"alpha2": "",
			"alpha3": "khi",
			"bibliographic": "",
			"name": "Khoisan languages"
		},
		{
			"alpha2": "km",
			"alpha3": "khm",
			"bibliographic": "",
			"name": "Central Khmer"
		},
		{
			"alpha2": "",
			"alpha3": "kho",
			"bibliographic": "",
			"name": "Khotanese"
		},
		{
			"alpha2": "",
			"alpha3": "kho",
			"bibliographic": "",
			"name": "Sakan"
		},
		{
			"alpha2": "ki",
			"alpha3": "kik",
			"bibliographic": "",
			"name": "Gikuyu"
		},
		{
			"alpha2": "ki",
			"alpha3": "kik",
			"bibliographic": "",
			"name": "Kikuyu"
		},
		{
			"alpha2": "rw",
			"alpha3": "kin",
			"bibliographic": "",
			"name": "Kinyarwanda"
		},
		{
			"alpha2": "ky",
			"alpha3": "kir",
			"bibliographic": "",
			"name": "Kirghiz"
		},
		{
			"alpha2": "ky",
			"alpha3": "kir",
			"bibliographic": "",
			"name": "Kyrgyz"
		},
		{
			"alpha2": "",
			"alpha3": "kmb",
			"bibliographic": "",
			"name": "Kimbundu"
		},
		{
			"alpha2": "",
			"alpha3": "kok",
			"bibliographic": "",
			"name": "Konkani"
		},
		{
			"alpha2": "kv",
			"alpha3": "kom",
			"bibliographic": "",
			"name": "Komi"
		},
		{
			"alpha2": "kg",
			"alpha3": "kon",
			"bibliographic": "",
			"name": "Kongo"
		},
		{
			"alpha2": "ko",
			"alpha3": "kor",
			"bibliographic": "",
			"name": "Korean"
		},
		{
			"alpha2": "",
			"alpha3": "kos",
			"bibliographic": "",
			"name": "Kosraean"
		},
		{
			"alpha2": "",
			"alpha3": "kpe",
			"bibliographic": "",
			"name": "Kpelle"
		},
		{
			"alpha2": "",
			"alpha3": "krc",
			"bibliographic": "",
			"name": "Karachay-Balkar"
		},
		{
			"alpha2": "",
			"alpha3": "krl",
			"bibliographic": "",
			"name": "Karelian"
		},
		{
			"alpha2": "",
			"alpha3": "kro",
			"bibliographic": "",
			"name": "Kru languages"
		},
		{
			"alpha2": "",
			"alpha3": "kru",
			"bibliographic": "",
			"name": "Kurukh"
		},
		{
			"alpha2": "kj",
			"alpha3": "kua",
			"bibliographic": "",
			"name": "Kuanyama"
		},
		{
			"alpha2": "kj",
			"alpha3": "kua",
			"bibliographic": "",
			"name": "Kwanyama"
		},
		{
			"alpha2": "",
			"alpha3": "kum",
			"bibliographic": "",
			"name": "Kumyk"
		},
		{
			"alpha2": "ku",
			"alpha3": "kur",
			"bibliographic": "",
			"name": "Kurdish"
		},
		{
			"alpha2": "",
			"alpha3": "kut",
			"bibliographic": "",
			"name": "Kutenai"
		},
		{
			"alpha2": "",
			"alpha3": "lad",
			"bibliographic": "",
			"name": "Ladino"
		},
		{
			"alpha2": "",
			"alpha3": "lah",
			"bibliographic": "",
			"name": "Lahnda"
		},
		{
			"alpha2": "",
			"alpha3": "lam",
			"bibliographic": "",
			"name": "Lamba"
		},
		{
			"alpha2": "lo",
			"alpha3": "lao",
			"bibliographic": "",
			"name": "Lao"
		},
		{
			"alpha2": "la",
			"alpha3": "lat",
			"bibliographic": "",
			"name": "Latin"
		},
		{
			"alpha2": "lv",
			"alpha3": "lav",
			"bibliographic": "",
			"name": "Latvian"
		},
		{
			"alpha2": "",
			"alpha3": "lez",
			"bibliographic": "",
			"name": "Lezghian"
		},
		{
			"alpha2": "li",
			"alpha3": "lim",
			"bibliographic": "",
			"name": "Limburgan"
		},
		{
			"alpha2": "li",
			"alpha3": "lim",
			"bibliographic": "",
			"name": "Limburger"
		},
		{
			"alpha2": "li",
			"alpha3": "lim",
			"bibliographic": "",
			"name": "Limburgish"
		},
		{
			"alpha2": "ln",
			"alpha3": "lin",
			"bibliographic": "",
			"name": "Lingala"
		},
		{
			"alpha2": "lt",
			"alpha3": "lit",
			"bibliographic": "",
			"name": "Lithuanian"
		},
		{
			"alpha2": "",
			"alpha3": "lol",
			"bibliographic": "",
			"name": "Mongo"
		},
		{
			"alpha2": "",
			"alpha3": "loz",
			"bibliographic": "",
			"name": "Lozi"
		},
		{
			"alpha2": "lb",
			"alpha3": "ltz",
			"bibliographic": "",
			"name": "Letzeburgesch"
		},
		{
			"alpha2": "lb",
			"alpha3": "ltz",
			"bibliographic": "",
			"name": "Luxembourgish"
		},
		{
			"alpha2": "",
			"alpha3": "lua",
			"bibliographic": "",
			"name": "Luba-Lulua"
		},
		{
			"alpha2": "lu",
			"alpha3": "lub",
			"bibliographic": "",
			"name": "Luba-Katanga"
		},
		{
			"alpha2": "lg",
			"alpha3": "lug",
			"bibliographic": "",
			"name": "Ganda"
		},
		{
			"alpha2": "",
			"alpha3": "lui",
			"bibliographic": "",
			"name": "Luiseno"
		},
		{
			"alpha2": "",
			"alpha3": "lun",
			"bibliographic": "",
			"name": "Lunda"
		},
		{
			"alpha2": "",
			"alpha3": "luo",
			"bibliographic": "",
			"name": "Luo (Kenya and Tanzania)"
		},
		{
			"alpha2": "",
			"alpha3": "lus",
			"bibliographic": "",
			"name": "Lushai"
		},
		{
			"alpha2": "",
			"alpha3": "mad",
			"bibliographic": "",
			"name": "Madurese"
		},
		{
			"alpha2": "",
			"alpha3": "mag",
			"bibliographic": "",
			"name": "Magahi"
		},
		{
			"alpha2": "mh",
			"alpha3": "mah",
			"bibliographic": "",
			"name": "Marshallese"
		},
		{
			"alpha2": "",
			"alpha3": "mai",
			"bibliographic": "",
			"name": "Maithili"
		},
		{
			"alpha2": "",
			"alpha3": "mak",
			"bibliographic": "",
			"name": "Makasar"
		},
		{
			"alpha2": "ml",
			"alpha3": "mal",
			"bibliographic": "",
			"name": "Malayalam"
		},
		{
			"alpha2": "",
			"alpha3": "man",
			"bibliographic": "",
			"name": "Mandingo"
		},
		{
			"alpha2": "",
			"alpha3": "map",
			"bibliographic": "",
			"name": "Austronesian languages"
		},
		{
			"alpha2": "mr",
			"alpha3": "mar",
			"bibliographic": "",
			"name": "Marathi"
		},
		{
			"alpha2": "",
			"alpha3": "mas",
			"bibliographic": "",
			"name": "Masai"
		},
		{
			"alpha2": "",
			"alpha3": "mdf",
			"bibliographic": "",
			"name": "Moksha"
		},
		{
			"alpha2": "",
			"alpha3": "mdr",
			"bibliographic": "",
			"name": "Mandar"
		},
		{
			"alpha2": "",
			"alpha3": "men",
			"bibliographic": "",
			"name": "Mende"
		},
		{
			"alpha2": "",
			"alpha3": "mga",
			"bibliographic": "",
			"name": "Irish, Middle (900-1200)"
		},
		{
			"alpha2": "",
			"alpha3": "mic",
			"bibliographic": "",
			"name": "Mi'kmaq"
		},
		{
			"alpha2": "",
			"alpha3": "mic",
			"bibliographic": "",
			"name": "Micmac"
		},
		{
			"alpha2": "",
			"alpha3": "min",
			"bibliographic": "",
			"name": "Minangkabau"
		},
		{
			"alpha2": "",
			"alpha3": "mis",
			"bibliographic": "",
			"name": "Uncoded languages"
		},
		{
			"alpha2": "mk",
			"alpha3": "mkd",
			"bibliographic": "mac",
			"name": "Macedonian"
		},
		{
			"alpha2": "",
			"alpha3": "mkh",
			"bibliographic": "",
			"name": "Mon-Khmer languages"
		},
		{
			"alpha2": "mg",
			"alpha3": "mlg",
			"bibliographic": "",
			"name": "Malagasy"
		},
		{
			"alpha2": "mt",
			"alpha3": "mlt",
			"bibliographic": "",
			"name": "Maltese"
		},
		{
			"alpha2": "",
			"alpha3": "mnc",
			"bibliographic": "",
			"name": "Manchu"
		},
		{
			"alpha2": "",
			"alpha3": "mni",
			"bibliographic": "",
			"name": "Manipuri"
		},
		{
			"alpha2": "",
			"alpha3": "mno",
			"bibliographic": "",
			"name": "Manobo languages"
		},
		{
			"alpha2": "",
			"alpha3": "moh",
			"bibliographic": "",
			"name": "Mohawk"
		},
		{
			"alpha2": "mn",
			"alpha3": "mon",
			"bibliographic": "",
			"name": "Mongolian"
		},
		{
			"alpha2": "",
			"alpha3": "mos",
			"bibliographic": "",
			"name": "Mossi"
		},
		{
			"alpha2": "",
			"alpha3": "mot",
			"bibliographic": "",
			"name": "Montenegrin"
		},
		{
			"alpha2": "mi",
			"alpha3": "mri",
			"bibliographic": "mao",
			"name": "Maori"
		},
		{
			"alpha2": "ms",
			"alpha3": "msa",
			"bibliographic": "may",
			"name": "Malay"
		},
		{
			"alpha2": "",
			"alpha3": "mul",
			"bibliographic": "",
			"name": "Multiple languages"
		},
		{
			"alpha2": "",
			"alpha3": "mun",
			"bibliographic": "",
			"name": "Munda languages"
		},
		{
			"alpha2": "",
			"alpha3": "mus",
			"bibliographic": "",
			"name": "Creek"
		},
		{
			"alpha2": "",
			"alpha3": "mwl",
			"bibliographic": "",
			"name": "Mirandese"
		},
		{
			"alpha2": "",
			"alpha3": "mwr",
			"bibliographic": "",
			"name": "Marwari"
		},
		{
			"alpha2": "my",
			"alpha3": "mya",
			"bibliographic": "bur",
			"name": "Burmese"
		},
		{
			"alpha2": "",
			"alpha3": "myn",
			"bibliographic": "",
			"name": "Mayan languages"
		},
		{
			"alpha2": "",
			"alpha3": "myv",
			"bibliographic": "",
			"name": "Erzya"
		},
		{
			"alpha2": "",
			"alpha3": "nah",
			"bibliographic": "",
			"name": "Nahuatl languages"
		},
		{
			"alpha2": "",
			"alpha3": "nai",
			"bibliographic": "",
			"name": "North American Indian languages"
		},
		{
			"alpha2": "",
			"alpha3": "nap",
			"bibliographic": "",
			"name": "Neapolitan"
		},
		{
			"alpha2": "na",
			"alpha3": "nau",
			"bibliographic": "",
			"name": "Nauru"
		},
		{
			"alpha2": "nv",
			"alpha3": "nav",
			"bibliographic": "",
			"name": "Navaho"
		},
		{
			"alpha2": "nv",
			"alpha3": "nav",
			"bibliographic": "",
			"name": "Navajo"
		},
		{
			"alpha2": "nr",
			"alpha3": "nbl",
			"bibliographic": "",
			"name": "Ndebele, South"
		},
		{
			"alpha2": "nr",
			"alpha3": "nbl",
			"bibliographic": "",
			"name": "South Ndebele"
		},
		{
			"alpha2": "nd",
			"alpha3": "nde",
			"bibliographic": "",
			"name": "Ndebele, North"
		},
		{
			"alpha2": "nd",
			"alpha3": "nde",
			"bibliographic": "",
			"name": "North Ndebele"
		},
		{
			"alpha2": "ng",
			"alpha3": "ndo",
			"bibliographic": "",
			"name": "Ndonga"
		},
		{
			"alpha2": "",
			"alpha3": "nds",
			"bibliographic": "",
			"name": "German, Low"
		},
		{
			"alpha2": "",
			"alpha3": "nds",
			"bibliographic": "",
			"name": "Low German"
		},
		{
			"alpha2": "",
			"alpha3": "nds",
			"bibliographic": "",
			"name": "Low Saxon"
		},
		{
			"alpha2": "",
			"alpha3": "nds",
			"bibliographic": "",
			"name": "Saxon, Low"
		},
		{
			"alpha2": "ne",
			"alpha3": "nep",
			"bibliographic": "",
			"name": "Nepali"
		},
		{
			"alpha2": "",
			"alpha3": "new",
			"bibliographic": "",
			"name": "Nepal Bhasa"
		},
		{
			"alpha2": "",
			"alpha3": "new",
			"bibliographic": "",
			"name": "Newari"
		},
		{
			"alpha2": "",
			"alpha3": "nia",
			"bibliographic": "",
			"name": "Nias"
		},
		{
			"alpha2": "",
			"alpha3": "nic",
			"bibliographic": "",
			"name": "Niger-Kordofanian languages"
		},
		{
			"alpha2": "",
			"alpha3": "niu",
			"bibliographic": "",
			"name": "Niuean"
		},
		{
			"alpha2": "nl",
			"alpha3": "nld",
			"bibliographic": "dut",
			"name": "Dutch"
		},
		{
			"alpha2": "nl",
			"alpha3": "nld",
			"bibliographic": "dut",
			"name": "Flemish"
		},
		{
			"alpha2": "nn",
			"alpha3": "nno",
			"bibliographic": "",
			"name": "Norwegian Nynorsk"
		},
		{
			"alpha2": "nn",
			"alpha3": "nno",
			"bibliographic": "",
			"name": "Nynorsk, Norwegian"
		},
		{
			"alpha2": "nb",
			"alpha3": "nob",
			"bibliographic": "",
			"name": "Bokmål, Norwegian"
		},
		{
			"alpha2": "nb",
			"alpha3": "nob",
			"bibliographic": "",
			"name": "Norwegian Bokmål"
		},
		{
			"alpha2": "",
			"alpha3": "nog",
			"bibliographic": "",
			"name": "Nogai"
		},
		{
			"alpha2": "",
			"alpha3": "non",
			"bibliographic": "",
			"name": "Norse, Old"
		},
		{
			"alpha2": "no",
			"alpha3": "nor",
			"bibliographic": "",
			"name": "Norwegian"
		},
		{
			"alpha2": "",
			"alpha3": "nqo",
			"bibliographic": "",
			"name": "N'Ko"
		},
		{
			"alpha2": "",
			"alpha3": "nso",
			"bibliographic": "",
			"name": "Northern Sotho"
		},
		{
			"alpha2": "",
			"alpha3": "nso",
			"bibliographic": "",
			"name": "Pedi"
		},
		{
			"alpha2": "",
			"alpha3": "nso",
			"bibliographic": "",
			"name": "Sepedi"
		},
		{
			"alpha2": "",
			"alpha3": "nso",
			"bibliographic": "",
			"name": "Sotho, Northern"
		},
		{
			"alpha2": "",
			"alpha3": "nub",
			"bibliographic": "",
			"name": "Nubian languages"
		},
		{
			"alpha2": "",
			"alpha3": "nwc",
			"bibliographic": "",
			"name": "Classical Nepal Bhasa"
		},
		{
			"alpha2": "",
			"alpha3": "nwc",
			"bibliographic": "",
			"name": "Classical Newari"
		},
		{
			"alpha2": "",
			"alpha3": "nwc",
			"bibliographic": "",
			"name": "Old Newari"
		},
		{
			"alpha2": "ny",
			"alpha3": "nya",
			"bibliographic": "",
			"name": "Chewa"
		},
		{
			"alpha2": "ny",
			"alpha3": "nya",
			"bibliographic": "",
			"name": "Chichewa"
		},
		{
			"alpha2": "ny",
			"alpha3": "nya",
			"bibliographic": "",
			"name": "Nyanja"
		},
		{
			"alpha2": "",
			"alpha3": "nym",
			"bibliographic": "",
			"name": "Nyamwezi"
		},
		{
			"alpha2": "",
			"alpha3": "nyn",
			"bibliographic": "",
			"name": "Nyankole"
		},
		{
			"alpha2": "",
			"alpha3": "nyo",
			"bibliographic": "",
			"name": "Nyoro"
		},
		{
			"alpha2": "",
			"alpha3": "nzi",
			"bibliographic": "",
			"name": "Nzima"
		},
		{
			"alpha2": "oc",
			"alpha3": "oci",
			"bibliographic": "",
			"name": "Occitan (post 1500)"
		},
		{
			"alpha2": "oj",
			"alpha3": "oji",
			"bibliographic": "",
			"name": "Ojibwa"
		},
		{
			"alpha2": "or",
			"alpha3": "ori",
			"bibliographic": "",
			"name": "Oriya"
		},
		{
			"alpha2": "om",
			"alpha3": "orm",
			"bibliographic": "",
			"name": "Oromo"
		},
		{
			"alpha2": "",
			"alpha3": "osa",
			"bibliographic": "",
			"name": "Osage"
		},
		{
			"alpha2": "os",
			"alpha3": "oss",
			"bibliographic": "",
			"name": "Ossetian"
		},
		{
			"alpha2": "os",
			"alpha3": "oss",
			"bibliographic": "",
			"name": "Ossetic"
		},
		{
			"alpha2": "",
			"alpha3": "ota",
			"bibliographic": "",
			"name": "Turkish, Ottoman (1500-1928)"
		},
		{
			"alpha2": "",
			"alpha3": "oto",
			"bibliographic": "",
			"name": "Otomian languages"
		},
		{
			"alpha2": "",
			"alpha3": "paa",
			"bibliographic": "",
			"name": "Papuan languages"
		},
		{
			"alpha2": "",
			"alpha3": "pag",
			"bibliographic": "",
			"name": "Pangasinan"
		},
		{
			"alpha2": "",
			"alpha3": "pal",
			"bibliographic": "",
			"name": "Pahlavi"
		},
		{
			"alpha2": "",
			"alpha3": "pam",
			"bibliographic": "",
			"name": "Kapampangan"
		},
		{
			"alpha2": "",
			"alpha3": "pam",
			"bibliographic": "",
			"name": "Pampanga"
		},
		{
			"alpha2": "pa",
			"alpha3": "pan",
			"bibliographic": "",
			"name": "Panjabi"
		},
		{
			"alpha2": "pa",
			"alpha3": "pan",
			"bibliographic": "",
			"name": "Punjabi"
		},
		{
			"alpha2": "",
			"alpha3": "pap",
			"bibliographic": "",
			"name": "Papiamento"
		},
		{
			"alpha2": "",
			"alpha3": "pau",
			"bibliographic": "",
			"name": "Palauan"
		},
		{
			"alpha2": "",
			"alpha3": "peo",
			"bibliographic": "",
			"name": "Persian, Old (ca.600-400 B.C.)"
		},
		{
			"alpha2": "",
			"alpha3": "phi",
			"bibliographic": "",
			"name": "Philippine languages"
		},
		{
			"alpha2": "",
			"alpha3": "phn",
			"bibliographic": "",
			"name": "Phoenician"
		},
		{
			"alpha2": "pi",
			"alpha3": "pli",
			"bibliographic": "",
			"name": "Pali"
		},
		{
			"alpha2": "pl",
			"alpha3": "pol",
			"bibliographic": "",
			"name": "Polish"
		},
		{
			"alpha2": "",
			"alpha3": "pon",
			"bibliographic": "",
			"name": "Pohnpeian"
		},
		{
			"alpha2": "pt",
			"alpha3": "por",
			"bibliographic": "",
			"name": "Portuguese"
		},
		{
			"alpha2": "",
			"alpha3": "pra",
			"bibliographic": "",
			"name": "Prakrit languages"
		},
		{
			"alpha2": "",
			"alpha3": "pro",
			"bibliographic": "",
			"name": "Occitan, Old (to 1500)"
		},
		{
			"alpha2": "",
			"alpha3": "pro",
			"bibliographic": "",
			"name": "Provençal, Old (to 1500)"
		},
		{
			"alpha2": "ps",
			"alpha3": "pus",
			"bibliographic": "",
			"name": "Pashto"
		},
		{
			"alpha2": "ps",
			"alpha3": "pus",
			"bibliographic": "",
			"name": "Pushto"
		},
		{
			"alpha2": "qu",
			"alpha3": "que",
			"bibliographic": "",
			"name": "Quechua"
		},
		{
			"alpha2": "",
			"alpha3": "raj",
			"bibliographic": "",
			"name": "Rajasthani"
		},
		{
			"alpha2": "",
			"alpha3": "rap",
			"bibliographic": "",
			"name": "Rapanui"
		},
		{
			"alpha2": "",
			"alpha3": "rar",
			"bibliographic": "",
			"name": "Cook Islands Maori"
		},
		{
			"alpha2": "",
			"alpha3": "rar",
			"bibliographic": "",
			"name": "Rarotongan"
		},
		{
			"alpha2": "",
			"alpha3": "roa",
			"bibliographic": "",
			"name": "Romance languages"
		},
		{
			"alpha2": "rm",
			"alpha3": "roh",
			"bibliographic": "",
			"name": "Romansh"
		},
		{
			"alpha2": "",
			"alpha3": "rom",
			"bibliographic": "",
			"name": "Romany"
		},
		{
			"alpha2": "ro",
			"alpha3": "ron",
			"bibliographic": "rum",
			"name": "Moldavian"
		},
		{
			"alpha2": "ro",
			"alpha3": "ron",
			"bibliographic": "rum",
			"name": "Romanian"
		},
		{
			"alpha2": "rn",
			"alpha3": "run",
			"bibliographic": "",
			"name": "Rundi"
		},
		{
			"alpha2": "",
			"alpha3": "rup",
			"bibliographic": "",
			"name": "Aromanian"
		},
		{
			"alpha2": "",
			"alpha3": "rup",
			"bibliographic": "",
			"name": "Arumanian"
		},
		{
			"alpha2": "",
			"alpha3": "rup",
			"bibliographic": "",
			"name": "Macedo-Romanian"
		},
		{
			"alpha2": "ru",
			"alpha3": "rus",
			"bibliographic": "",
			"name": "Russian"
		},
		{
			"alpha2": "",
			"alpha3": "sad",
			"bibliographic": "",
			"name": "Sandawe"
		},
		{
			"alpha2": "sg",
			"alpha3": "sag",
			"bibliographic": "",
			"name": "Sango"
		},
		{
			"alpha2": "",
			"alpha3": "sah",
			"bibliographic": "",
			"name": "Yakut"
		},
		{
			"alpha2": "",
			"alpha3": "sai",
			"bibliographic": "",
			"name": "South American Indian languages"
		},
		{
			"alpha2": "",
			"alpha3": "sal",
			"bibliographic": "",
			"name": "Salishan languages"
		},
		{
			"alpha2": "",
			"alpha3": "sam",
			"bibliographic": "",
			"name": "Samaritan Aramaic"
		},
		{
			"alpha2": "sa",
			"alpha3": "san",
			"bibliographic": "",
			"name": "Sanskrit"
		},
		{
			"alpha2": "",
			"alpha3": "sas",
			"bibliographic": "",
			"name": "Sasak"
		},
		{
			"alpha2": "",
			"alpha3": "sat",
			"bibliographic": "",
			"name": "Santali"
		},
		{
			"alpha2": "",
			"alpha3": "scn",
			"bibliographic": "",
			"name": "Sicilian"
		},
		{
			"alpha2": "",
			"alpha3": "sco",
			"bibliographic": "",
			"name": "Scots"
		},
		{
			"alpha2": "",
			"alpha3": "sel",
			"bibliographic": "",
			"name": "Selkup"
		},
		{
			"alpha2": "",
			"alpha3": "sem",
			"bibliographic": "",
			"name": "Semitic languages"
		},
		{
			"alpha2": "",
			"alpha3": "sga",
			"bibliographic": "",
			"name": "Irish, Old (to 900)"
		},
		{
			"alpha2": "",
			"alpha3": "sgn",
			"bibliographic": "",
			"name": "Sign Languages"
		},
		{
			"alpha2": "",
			"alpha3": "shn",
			"bibliographic": "",
			"name": "Shan"
		},
		{
			"alpha2": "",
			"alpha3": "sid",
			"bibliographic": "",
			"name": "Sidamo"
		},
		{
			"alpha2": "si",
			"alpha3": "sin",
			"bibliographic": "",
			"name": "Sinhala"
		},
		{
			"alpha2": "si",
			"alpha3": "sin",
			"bibliographic": "",
			"name": "Sinhalese"
		},
		{
			"alpha2": "",
			"alpha3": "sio",
			"bibliographic": "",
			"name": "Siouan languages"
		},
		{
			"alpha2": "",
			"alpha3": "sit",
			"bibliographic": "",
			"name": "Sino-Tibetan languages"
		},
		{
			"alpha2": "",
			"alpha3": "sla",
			"bibliographic": "",
			"name": "Slavic languages"
		},
		{
			"alpha2": "sk",
			"alpha3": "slk",
			"bibliographic": "slo",
			"name": "Slovak"
		},
		{
			"alpha2": "sl",
			"alpha3": "slv",
			"bibliographic": "",
			"name": "Slovenian"
		},
		{
			"alpha2": "",
			"alpha3": "sma",
			"bibliographic": "",
			"name": "Southern Sami"
		},
		{
			"alpha2": "se",
			"alpha3": "sme",
			"bibliographic": "",
			"name": "Northern Sami"
		},
		{
			"alpha2": "",
			"alpha3": "smi",
			"bibliographic": "",
			"name": "Sami languages"
		},
		{
			"alpha2": "",
			"alpha3": "smj",
			"bibliographic": "",
			"name": "Lule Sami"
		},
		{
			"alpha2": "",
			"alpha3": "smn",
			"bibliographic": "",
			"name": "Inari Sami"
		},
		{
			"alpha2": "sm",
			"alpha3": "smo",
			"bibliographic": "",
			"name": "Samoan"
		},
		{
			"alpha2": "",
			"alpha3": "sms",
			"bibliographic": "",
			"name": "Skolt Sami"
		},
		{
			"alpha2": "sn",
			"alpha3": "sna",
			"bibliographic": "",
			"name": "Shona"
		},
		{
			"alpha2": "sd",
			"alpha3": "snd",
			"bibliographic": "",
			"name": "Sindhi"
		},
		{
			"alpha2": "",
			"alpha3": "snk",
			"bibliographic": "",
			"name": "Soninke"
		},
		{
			"alpha2": "",
			"alpha3": "sog",
			"bibliographic": "",
			"name": "Sogdian"
		},
		{
			"alpha2": "so",
			"alpha3": "som",
			"bibliographic": "",
			"name": "Somali"
		},
		{
			"alpha2": "",
			"alpha3": "son",
			"bibliographic": "",
			"name": "Songhai languages"
		},
		{
			"alpha2": "st",
			"alpha3": "sot",
			"bibliographic": "",
			"name": "Sotho, Southern"
		},
		{
			"alpha2": "es",
			"alpha3": "spa",
			"bibliographic": "",
			"name": "Castilian"
		},
		{
			"alpha2": "es",
			"alpha3": "spa",
			"bibliographic": "",
			"name": "Spanish"
		},
		{
			"alpha2": "sq",
			"alpha3": "sqi",
			"bibliographic": "alb",
			"name": "Albanian"
		},
		{
			"alpha2": "sc",
			"alpha3": "srd",
			"bibliographic": "",
			"name": "Sardinian"
		},
		{
			"alpha2": "",
			"alpha3": "srn",
			"bibliographic": "",
			"name": "Sranan Tongo"
		},
		{
			"alpha2": "sr",
			"alpha3": "srp",
			"bibliographic": "",
			"name": "Serbian"
		},
		{
			"alpha2": "",
			"alpha3": "srr",
			"bibliographic": "",
			"name": "Serer"
		},
		{
			"alpha2": "",
			"alpha3": "ssa",
			"bibliographic": "",
			"name": "Nilo-Saharan languages"
		},
		{
			"alpha2": "ss",
			"alpha3": "ssw",
			"bibliographic": "",
			"name": "Swati"
		},
		{
			"alpha2": "",
			"alpha3": "suk",
			"bibliographic": "",
			"name": "Sukuma"
		},
		{
			"alpha2": "su",
			"alpha3": "sun",
			"bibliographic": "",
			"name": "Sundanese"
		},
		{
			"alpha2": "",
			"alpha3": "sus",
			"bibliographic": "",
			"name": "Susu"
		},
		{
			"alpha2": "",
			"alpha3": "sux",
			"bibliographic": "",
			"name": "Sumerian"
		},
		{
			"alpha2": "sw",
			"alpha3": "swa",
			"bibliographic": "",
			"name": "Swahili"
		},
		{
			"alpha2": "sv",
			"alpha3": "swe",
			"bibliographic": "",
			"name": "Swedish"
		},
		{
			"alpha2": "",
			"alpha3": "syc",
			"bibliographic": "",
			"name": "Classical Syriac"
		},
		{
			"alpha2": "",
			"alpha3": "syr",
			"bibliographic": "",
			"name": "Syriac"
		},
		{
			"alpha2": "ty",
			"alpha3": "tah",
			"bibliographic": "",
			"name": "Tahitian"
		},
		{
			"alpha2": "",
			"alpha3": "tai",
			"bibliographic": "",
			"name": "Tai languages"
		},
		{
			"alpha2": "ta",
			"alpha3": "tam",
			"bibliographic": "",
			"name": "Tamil"
		},
		{
			"alpha2": "tt",
			"alpha3": "tat",
			"bibliographic": "",
			"name": "Tatar"
		},
		{
			"alpha2": "te",
			"alpha3": "tel",
			"bibliographic": "",
			"name": "Telugu"
		},
		{
			"alpha2": "",
			"alpha3": "tem",
			"bibliographic": "",
			"name": "Timne"
		},
		{
			"alpha2": "",
			"alpha3": "ter",
			"bibliographic": "",
			"name": "Tereno"
		},
		{
			"alpha2": "",
			"alpha3": "tet",
			"bibliographic": "",
			"name": "Tetum"
		},
		{
			"alpha2": "tg",
			"alpha3": "tgk",
			"bibliographic": "",
			"name": "Tajik"
		},
		{
			"alpha2": "tl",
			"alpha3": "tgl",
			"bibliographic": "",
			"name": "Tagalog"
		},
		{
			"alpha2": "th",
			"alpha3": "tha",
			"bibliographic": "",
			"name": "Thai"
		},
		{
			"alpha2": "",
			"alpha3": "tig",
			"bibliographic": "",
			"name": "Tigre"
		},
		{
			"alpha2": "ti",
			"alpha3": "tir",
			"bibliographic": "",
			"name": "Tigrinya"
		},
		{
			"alpha2": "",
			"alpha3": "tiv",
			"bibliographic": "",
			"name": "Tiv"
		},
		{
			"alpha2": "",
			"alpha3": "tkl",
			"bibliographic": "",
			"name": "Tokelau"
		},
		{
			"alpha2": "",
			"alpha3": "tlh",
			"bibliographic": "",
			"name": "Klingon"
		},
		{
			"alpha2": "",
			"alpha3": "tlh",
			"bibliographic": "",
			"name": "tlhIngan-Hol"
		},
		{
			"alpha2": "",
			"alpha3": "tli",
			"bibliographic": "",
			"name": "Tlingit"
		},
		{
			"alpha2": "",
			"alpha3": "tmh",
			"bibliographic": "",
			"name": "Tamashek"
		},
		{
			"alpha2": "",
			"alpha3": "tog",
			"bibliographic": "",
			"name": "Tonga (Nyasa)"
		},
		{
			"alpha2": "to",
			"alpha3": "ton",
			"bibliographic": "",
			"name": "Tonga (Tonga Islands)"
		},
		{
			"alpha2": "",
			"alpha3": "tpi",
			"bibliographic": "",
			"name": "Tok Pisin"
		},
		{
			"alpha2": "",
			"alpha3": "tsi",
			"bibliographic": "",
			"name": "Tsimshian"
		},
		{
			"alpha2": "tn",
			"alpha3": "tsn",
			"bibliographic": "",
			"name": "Tswana"
		},
		{
			"alpha2": "ts",
			"alpha3": "tso",
			"bibliographic": "",
			"name": "Tsonga"
		},
		{
			"alpha2": "tk",
			"alpha3": "tuk",
			"bibliographic": "",
			"name": "Turkmen"
		},
		{
			"alpha2": "",
			"alpha3": "tum",
			"bibliographic": "",
			"name": "Tumbuka"
		},
		{
			"alpha2": "",
			"alpha3": "tup",
			"bibliographic": "",
			"name": "Tupi languages"
		},
		{
			"alpha2": "tr",
			"alpha3": "tur",
			"bibliographic": "",
			"name": "Turkish"
		},
		{
			"alpha2": "",
			"alpha3": "tut",
			"bibliographic": "",
			"name": "Altaic languages"
		},
		{
			"alpha2": "",
			"alpha3": "tvl",
			"bibliographic": "",
			"name": "Tuvalu"
		},
		{
			"alpha2": "tw",
			"alpha3": "twi",
			"bibliographic": "",
			"name": "Twi"
		},
		{
			"alpha2": "",
			"alpha3": "tyv",
			"bibliographic": "",
			"name": "Tuvinian"
		},
		{
			"alpha2": "",
			"alpha3": "udm",
			"bibliographic": "",
			"name": "Udmurt"
		},
		{
			"alpha2": "",
			"alpha3": "uga",
			"bibliographic": "",
			"name": "Ugaritic"
		},
		{
			"alpha2": "ug",
			"alpha3": "uig",
			"bibliographic": "",
			"name": "Uighur"
		},
		{
			"alpha2": "ug",
			"alpha3": "uig",
			"bibliographic": "",
			"name": "Uyghur"
		},
		{
			"alpha2": "uk",
			"alpha3": "ukr",
			"bibliographic": "",
			"name": "Ukrainian"
		},
		{
			"alpha2": "",
			"alpha3": "umb",
			"bibliographic": "",
			"name": "Umbundu"
		},
		{
			"alpha2": "",
			"alpha3": "und",
			"bibliographic": "",
			"name": "Undetermined"
		},
		{
			"alpha2": "ur",
			"alpha3": "urd",
			"bibliographic": "",
			"name": "Urdu"
		},
		{
			"alpha2": "uz",
			"alpha3": "uzb",
			"bibliographic": "",
			"name": "Uzbek"
		},
		{
			"alpha2": "",
			"alpha3": "vai",
			"bibliographic": "",
			"name": "Vai"
		},
		{
			"alpha2": "ve",
			"alpha3": "ven",
			"bibliographic": "",
			"name": "Venda"
		},
		{
			"alpha2": "vi",
			"alpha3": "vie",
			"bibliographic": "",
			"name": "Vietnamese"
		},
		{
			"alpha2": "vo",
			"alpha3": "vol",
			"bibliographic": "",
			"name": "Volapük"
		},
		{
			"alpha2": "",
			"alpha3": "vot",
			"bibliographic": "",
			"name": "Votic"
		},
		{
			"alpha2": "",
			"alpha3": "wak",
			"bibliographic": "",
			"name": "Wakashan languages"
		},
		{
			"alpha2": "",
			"alpha3": "wal",
			"bibliographic": "",
			"name": "Wolaitta"
		},
		{
			"alpha2": "",
			"alpha3": "wal",
			"bibliographic": "",
			"name": "Wolaytta"
		},
		{
			"alpha2": "",
			"alpha3": "war",
			"bibliographic": "",
			"name": "Waray"
		},
		{
			"alpha2": "",
			"alpha3": "was",
			"bibliographic": "",
			"name": "Washo"
		},
		{
			"alpha2": "",
			"alpha3": "wen",
			"bibliographic": "",
			"name": "Sorbian languages"
		},
		{
			"alpha2": "wa",
			"alpha3": "wln",
			"bibliographic": "",
			"name": "Walloon"
		},
		{
			"alpha2": "wo",
			"alpha3": "wol",
			"bibliographic": "",
			"name": "Wolof"
		},
		{
			"alpha2": "",
			"alpha3": "xal",
			"bibliographic": "",
			"name": "Kalmyk"
		},
		{
			"alpha2": "",
			"alpha3": "xal",
			"bibliographic": "",
			"name": "Oirat"
		},
		{
			"alpha2": "xh",
			"alpha3": "xho",
			"bibliographic": "",
			"name": "Xhosa"
		},
		{
			"alpha2": "",
			"alpha3": "yao",
			"bibliographic": "",
			"name": "Yao"
		},
		{
			"alpha2": "",
			"alpha3": "yap",
			"bibliographic": "",
			"name": "Yapese"
		},
		{
			"alpha2": "yi",
			"alpha3": "yid",
			"bibliographic": "",
			"name": "Yiddish"
		},
		{
			"alpha2": "yo",
			"alpha3": "yor",
			"bibliographic": "",
			"name": "Yoruba"
		},
		{
			"alpha2": "",
			"alpha3": "ypk",
			"bibliographic": "",
			"name": "Yupik languages"
		},
		{
			"alpha2": "",
			"alpha3": "zap",
			"bibliographic": "",
			"name": "Zapotec"
		},
		{
			"alpha2": "",
			"alpha3": "zbl",
			"bibliographic": "",
			"name": "Bliss"
		},
		{
			"alpha2": "",
			"alpha3": "zbl",
			"bibliographic": "",
			"name": "Blissymbolics"
		},
		{
			"alpha2": "",
			"alpha3": "zbl",
			"bibliographic": "",
			"name": "Blissymbols"
		},
		{
			"alpha2": "",
			"alpha3": "zen",
			"bibliographic": "",
			"name": "Zenaga"
		},
		{
			"alpha2": "",
			"alpha3": "zgh",
			"bibliographic": "",
			"name": "Standard Moroccan Tamazight"
		},
		{
			"alpha2": "za",
			"alpha3": "zha",
			"bibliographic": "",
			"name": "Chuang"
		},
		{
			"alpha2": "za",
			"alpha3": "zha",
			"bibliographic": "",
			"name": "Zhuang"
		},
		{
			"alpha2": "zh",
			"alpha3": "zho",
			"bibliographic": "chi",
			"name": "Chinese"
		},
		{
			"alpha2": "",
			"alpha3": "znd",
			"bibliographic": "",
			"name": "Zande languages"
		},
		{
			"alpha2": "zu",
			"alpha3": "zul",
			"bibliographic": "",
			"name": "Zulu"
		},
		{
			"alpha2": "",
			"alpha3": "zun",
			"bibliographic": "",
			"name": "Zuni"
		},
		{
			"alpha2": "",
			"alpha3": "zxx",
			"bibliographic": "",
			"name": "No linguistic content"
		},
		{
			"alpha2": "",
			"alpha3": "zxx",
			"bibliographic": "",
			"name": "Not applicable"
		},
		{
			"alpha2": "",
			"alpha3": "zza",
			"bibliographic": "",
			"name": "Dimili"
		},
		{
			"alpha2": "",
			"alpha3": "zza",
			"bibliographic": "",
			"name": "Dimli"
		},
		{
			"alpha2": "",
			"alpha3": "zza",
			"bibliographic": "",
			"name": "Kirdki"
		},
		{
			"alpha2": "",
			"alpha3": "zza",
			"bibliographic": "",
			"name": "Kirmanjki"
		},
		{
			"alpha2": "",
			"alpha3": "zza",
			"bibliographic": "",
			"name": "Zaza"
		},
		{
			"alpha2": "",
			"alpha3": "zza",
			"bibliographic": "",
			"name": "Zazaki"
		}
	];

/***/ },
/* 2949 */
/***/ function(module, exports) {

	module.exports = [
		"1033edge.com",
		"10minutemail.com",
		"11mail.com",
		"123.com",
		"123box.net",
		"123india.com",
		"123mail.cl",
		"123qwe.co.uk",
		"126.com",
		"150ml.com",
		"15meg4free.com",
		"163.com",
		"1coolplace.com",
		"1freeemail.com",
		"1funplace.com",
		"1internetdrive.com",
		"1mail.net",
		"1me.net",
		"1mum.com",
		"1musicrow.com",
		"1netdrive.com",
		"1nsyncfan.com",
		"1under.com",
		"1webave.com",
		"1webhighway.com",
		"212.com",
		"21cn.com",
		"247emaildata.com",
		"24horas.com",
		"2911.net",
		"2bmail.co.uk",
		"2d2i.com",
		"2die4.com",
		"2trom.com",
		"3000.it",
		"321media.com",
		"37.com",
		"3ammagazine.com",
		"3dmail.com",
		"3email.com",
		"3xl.net",
		"444.net",
		"4email.com",
		"4email.net",
		"4mg.com",
		"4newyork.com",
		"4x4man.com",
		"5iron.com",
		"5star.com",
		"675hosting.com",
		"675hosting.net",
		"675hosting.org",
		"75hosting.com",
		"75hosting.net",
		"75hosting.org",
		"88.am",
		"8848.net",
		"888.nu",
		"97rock.com",
		"aaamail.zzn.com",
		"aamail.net",
		"aaronkwok.net",
		"abbeyroadlondon.co.uk",
		"abcflash.net",
		"abdulnour.com",
		"aberystwyth.com",
		"abolition-now.com",
		"about.com",
		"abv.bg",
		"academycougars.com",
		"acceso.or.cr",
		"access4less.net",
		"accessgcc.com",
		"accountant.com",
		"acdcfan.com",
		"ace-of-base.com",
		"acmecity.com",
		"acmemail.net",
		"acninc.net",
		"activist.com",
		"adelphia.net",
		"adexec.com",
		"adfarrow.com",
		"adios.net",
		"ados.fr",
		"advalvas.be",
		"aeiou.pt",
		"aemail4u.com",
		"aeneasmail.com",
		"afreeinternet.com",
		"africamail.com",
		"agoodmail.com",
		"ahaa.dk",
		"aichi.com",
		"aim.com",
		"aircraftmail.com",
		"airforce.net",
		"airforceemail.com",
		"airpost.net",
		"ajacied.com",
		"ajaxapp.net",
		"ak47.hu",
		"aknet.kg",
		"albawaba.com",
		"alex4all.com",
		"alexandria.cc",
		"algeria.com",
		"alhilal.net",
		"alibaba.com",
		"alice.it",
		"alive.cz",
		"allemails.co.uk",
		"allergist.com",
		"allmail.net",
		"alloymail.com",
		"allracing.com",
		"allsaintsfan.com",
		"alltel.net",
		"alskens.dk",
		"altavista.com",
		"altavista.net",
		"altavista.se",
		"alternativagratis.com",
		"alumni.com",
		"alumnidirector.com",
		"alvilag.hu",
		"amele.com",
		"america.hm",
		"ameritech.net",
		"amilegit.com",
		"amiri.net",
		"amiriindustries.com",
		"amnetsal.com",
		"amrer.net",
		"amuro.net",
		"amuromail.com",
		"ananzi.co.za",
		"ancestry.com",
		"andylau.net",
		"anfmail.com",
		"angelfan.com",
		"angelfire.com",
		"angelic.com",
		"animal.net",
		"animalhouse.com",
		"animalwoman.net",
		"anjungcafe.com",
		"anonymail.dk",
		"anonymbox.com",
		"anote.com",
		"another.com",
		"anotherwin95.com",
		"anti-social.com",
		"antisocial.com",
		"antongijsen.com",
		"antwerpen.com",
		"anymoment.com",
		"anytimenow.com",
		"aol.co.uk",
		"aol.com",
		"apexmail.com",
		"apmail.com",
		"apollo.lv",
		"appraiser.net",
		"approvers.net",
		"arabia.com",
		"arabtop.net",
		"arcademaster.com",
		"archaeologist.com",
		"arcor.de",
		"arcotronics.bg",
		"arcticmail.com",
		"argentina.com",
		"aristotle.org",
		"army.net",
		"arnet.com.ar",
		"artlover.com",
		"artlover.com.au",
		"as-if.com",
		"asean-mail.com",
		"asheville.com",
		"asia-links.com",
		"asia-mail.com",
		"asia.com",
		"asiafind.com",
		"asianavenue.com",
		"asiancityweb.com",
		"asiansonly.net",
		"asianwired.net",
		"asiapoint.net",
		"assala.com",
		"assamesemail.com",
		"astroboymail.com",
		"astrolover.com",
		"astrosfan.com",
		"astrosfan.net",
		"asurfer.com",
		"atheist.com",
		"athenachu.net",
		"atina.cl",
		"atl.lv",
		"atlaswebmail.com",
		"atlink.com",
		"ato.check.com",
		"atozasia.com",
		"atrickmail.com",
		"att.net",
		"attglobal.net",
		"attymail.com",
		"au.ru",
		"auctioneer.net",
		"ausi.com",
		"austin.rr.com",
		"australia.edu",
		"australiamail.com",
		"austrosearch.net",
		"autoescuelanerja.com",
		"automotiveauthority.com",
		"avh.hu",
		"awsom.net",
		"axoskate.com",
		"ayna.com",
		"azimiweb.com",
		"bachelorboy.com",
		"bachelorgal.com",
		"backpackers.com",
		"backstreet-boys.com",
		"backstreetboysclub.com",
		"bagherpour.com",
		"bangkok.com",
		"bangkok2000.com",
		"bannertown.net",
		"baptistmail.com",
		"baptized.com",
		"barcelona.com",
		"bartender.net",
		"baseballmail.com",
		"basketballmail.com",
		"batuta.net",
		"baudoinconsulting.com",
		"bboy.zzn.com",
		"bcvibes.com",
		"beeebank.com",
		"beenhad.com",
		"beep.ru",
		"beer.com",
		"beethoven.com",
		"belice.com",
		"belizehome.com",
		"bell.net",
		"bellair.com",
		"bellsouth.net",
		"berkscounty.com",
		"berlin.com",
		"berlin.de",
		"berlinexpo.de",
		"bestmail.us",
		"bettergolf.net",
		"bharatmail.com",
		"bickmail.com.au",
		"bigassweb.com",
		"bigblue.net.au",
		"bigboab.com",
		"bigfoot.com",
		"bigfoot.de",
		"bigger.com",
		"bigmailbox.com",
		"bigpond.com",
		"bigpond.com.au",
		"bigpond.net.au",
		"bigramp.com",
		"bikemechanics.com",
		"bikeracer.com",
		"bikeracers.net",
		"bikerider.com",
		"billsfan.com",
		"billsfan.net",
		"bimamail.com",
		"bimla.net",
		"birdlover.com",
		"birdowner.net",
		"bisons.com",
		"bitmail.com",
		"bitpage.net",
		"bizhosting.com",
		"bk.ru",
		"bla-bla.com",
		"blackburnmail.com",
		"blackplanet.com",
		"blader.com",
		"blazemail.com",
		"blu.it",
		"bluehyppo.com",
		"bluemail.ch",
		"bluemail.dk",
		"bluesfan.com",
		"blueyonder.co.uk",
		"blushmail.com",
		"bmlsports.net",
		"boardermail.com",
		"boatracers.com",
		"bol.com.br",
		"bolando.com",
		"bollywoodz.com",
		"bolt.com",
		"boltonfans.com",
		"bombdiggity.com",
		"bonbon.net",
		"boom.com",
		"bootmail.com",
		"bornnaked.com",
		"bossofthemoss.com",
		"bostonoffice.com",
		"bounce.net",
		"box.az",
		"boxbg.com",
		"boxemail.com",
		"boxfrog.com",
		"boyzoneclub.com",
		"bradfordfans.com",
		"brasilia.net",
		"brazilmail.com",
		"brazilmail.com.br",
		"breathe.com",
		"bresnan.net",
		"brew-master.com",
		"brew-meister.com",
		"brfree.com.br",
		"bright.net",
		"britneyclub.com",
		"brittonsign.com",
		"broadcast.net",
		"bsdmail.com",
		"bspamfree.org",
		"btconnect.com",
		"btinternet.com",
		"btopenworld.co.uk",
		"btopenworld.com",
		"buffymail.com",
		"bugmenot.com",
		"bullsfan.com",
		"bullsgame.com",
		"bumerang.ro",
		"bunko.com",
		"buryfans.com",
		"business-man.com",
		"businessman.net",
		"businessweekmail.com",
		"busta-rhymes.com",
		"busymail.com",
		"buyersusa.com",
		"buyusedlibrarybooks.org",
		"bvimailbox.com",
		"byteme.com",
		"c2i.net",
		"c3.hu",
		"c4.com",
		"ca.rr.com",
		"cabacabana.com",
		"cableone.net",
		"caere.it",
		"cairomail.com",
		"californiamail.com",
		"callnetuk.com",
		"callsign.net",
		"caltanet.it",
		"camidge.com",
		"canada-11.com",
		"canada.com",
		"canadianmail.com",
		"canoemail.com",
		"canwetalk.com",
		"caramail.com",
		"care2.com",
		"careerbuildermail.com",
		"carioca.net",
		"carolina.rr.com",
		"cart.4.0.0.1.com",
		"cartestraina.ro",
		"casablancaresort.com",
		"cash4u.com",
		"casino.com",
		"catcha.com",
		"catholic.org",
		"catlover.com",
		"catsrule.garfield.com",
		"ccnmail.com",
		"cd2.com",
		"cdr.fastmail.fm",
		"celineclub.com",
		"celtic.com",
		"centoper.it",
		"centralpets.com",
		"centrum.cz",
		"centrum.sk",
		"centurylink.net",
		"centurytel.net",
		"cfl.rr.com",
		"cgac.es",
		"chaiyomail.com",
		"chance2mail.com",
		"chandrasekar.net",
		"charmedmail.com",
		"charter.net",
		"chat.ru",
		"chattown.com",
		"chauhanweb.com",
		"check.com",
		"check1check.com",
		"cheerful.com",
		"chef.net",
		"chek.com",
		"chemist.com",
		"chequemail.com",
		"cheyenneweb.com",
		"chez.com",
		"chickmail.com",
		"china.net.vg",
		"chinalook.com",
		"chinamail.com",
		"chirk.com",
		"chocaholic.com.au",
		"christianmail.net",
		"churchusa.com",
		"cia-agent.com",
		"cia.hu",
		"ciaoweb.it",
		"cicciociccio.com",
		"cinci.rr.com",
		"cincinow.net",
		"citeweb.net",
		"citlink.net",
		"city-of-bath.org",
		"city-of-birmingham.com",
		"city-of-brighton.org",
		"city-of-cambridge.com",
		"city-of-coventry.com",
		"city-of-edinburgh.com",
		"city-of-lichfield.com",
		"city-of-lincoln.com",
		"city-of-liverpool.com",
		"city-of-manchester.com",
		"city-of-nottingham.com",
		"city-of-oxford.com",
		"city-of-swansea.com",
		"city-of-westminster.com",
		"city-of-westminster.net",
		"city-of-york.net",
		"city2city.com",
		"cityofcardiff.net",
		"cityoflondon.org",
		"claramail.com",
		"classicalfan.com",
		"classicmail.co.za",
		"clerk.com",
		"cliffhanger.com",
		"close2you.net",
		"club4x4.net",
		"clubalfa.com",
		"clubbers.net",
		"clubducati.com",
		"clubhonda.net",
		"clubmember.org",
		"clubvdo.net",
		"cluemail.com",
		"cmailg.com",
		"cmpmail.com",
		"cnnsimail.com",
		"codec.ro",
		"coder.hu",
		"cogeco.ca",
		"coid.biz",
		"coldmail.com",
		"collectiblesuperstore.com",
		"collector.org",
		"collegebeat.com",
		"collegeclub.com",
		"collegemail.com",
		"colleges.com",
		"columbus.rr.com",
		"columbusrr.com",
		"columnist.com",
		"comcast.net",
		"comic.com",
		"communityconnect.com",
		"comprendemail.com",
		"compuserve.com",
		"computer-freak.com",
		"computer4u.com",
		"computermail.net",
		"conexcol.com",
		"conk.com",
		"connect4free.net",
		"connectbox.com",
		"conok.com",
		"consultant.com",
		"contractor.net",
		"cookiemonster.com",
		"cool.br",
		"coolgoose.ca",
		"coolgoose.com",
		"coolkiwi.com",
		"coollist.com",
		"coolmail.com",
		"coolmail.net",
		"coolsend.com",
		"coolsite.net",
		"cooooool.com",
		"cooperation.net",
		"cooperationtogo.net",
		"copacabana.com",
		"cornells.com",
		"cornerpub.com",
		"corporatedirtbag.com",
		"correo.terra.com.gt",
		"cortinet.com",
		"cotas.net",
		"counsellor.com",
		"countrylover.com",
		"cox.net",
		"coxinet.net",
		"cpaonline.net",
		"cracker.hu",
		"crazedanddazed.com",
		"crazysexycool.com",
		"cristianemail.com",
		"critterpost.com",
		"croeso.com",
		"crosshairs.com",
		"crosswinds.net",
		"crwmail.com",
		"cry4helponline.com",
		"cs.com",
		"csinibaba.hu",
		"cuemail.com",
		"curio-city.com",
		"cute-girl.com",
		"cuteandcuddly.com",
		"cutey.com",
		"cww.de",
		"cyber-africa.net",
		"cyber-wizard.com",
		"cyber4all.com",
		"cyberbabies.com",
		"cybercafemaui.com",
		"cyberdude.com",
		"cyberforeplay.net",
		"cybergal.com",
		"cybergrrl.com",
		"cyberinbox.com",
		"cyberleports.com",
		"cybermail.net",
		"cybernet.it",
		"cyberservices.com",
		"cyberspace-asia.com",
		"cybertrains.org",
		"cyclefanz.com",
		"cynetcity.com",
		"dabsol.net",
		"dadacasa.com",
		"daha.com",
		"dailypioneer.com",
		"dallas.theboys.com",
		"dallasmail.com",
		"dangerous-minds.com",
		"dansegulvet.com",
		"data54.com",
		"davegracey.com",
		"dawnsonmail.com",
		"dawsonmail.com",
		"dazedandconfused.com",
		"dbzmail.com",
		"dcemail.com",
		"deadaddress.com",
		"deadlymob.org",
		"deal-maker.com",
		"dearriba.com",
		"death-star.com",
		"dejanews.com",
		"deliveryman.com",
		"deneg.net",
		"depechemode.com",
		"deseretmail.com",
		"desertmail.com",
		"desilota.com",
		"deskmail.com",
		"deskpilot.com",
		"destin.com",
		"detik.com",
		"deutschland-net.com",
		"devotedcouples.com",
		"dfwatson.com",
		"di-ve.com",
		"digibel.be",
		"diplomats.com",
		"dirtracer.com",
		"discardmail.com",
		"disciples.com",
		"discofan.com",
		"discovery.com",
		"discoverymail.com",
		"dishmail.net",
		"disinfo.net",
		"disposable.com",
		"disposeamail.com",
		"dispostable.com",
		"dmailman.com",
		"dnsmadeeasy.com",
		"docomo.ne.jp",
		"doctor.com",
		"dodgeit.com",
		"dodo.com.au",
		"dog.com",
		"doglover.com",
		"dogmail.co.uk",
		"dogsnob.net",
		"doityourself.com",
		"doneasy.com",
		"donjuan.com",
		"dontgotmail.com",
		"dontmesswithtexas.com",
		"dontsendmespam.de",
		"doramail.com",
		"dostmail.com",
		"dotcom.fr",
		"dott.it",
		"dplanet.ch",
		"dr.com",
		"dragoncon.net",
		"dragracer.com",
		"dropzone.com",
		"drotposta.hu",
		"dubaimail.com",
		"dublin.com",
		"dublin.ie",
		"dunesmail.com",
		"dunflimblag.mailexpire.com",
		"dunlopdriver.com",
		"dunloprider.com",
		"duno.com",
		"dutchmail.com",
		"dwp.net",
		"dygo.com",
		"dynamitemail.com",
		"e-apollo.lv",
		"e-mail.dk",
		"e-mail.jp",
		"e-mail.ru",
		"e-mailanywhere.com",
		"e-mails.ru",
		"e-tapaal.com",
		"earthalliance.com",
		"earthcam.net",
		"earthdome.com",
		"earthling.net",
		"earthlink.net",
		"earthonline.net",
		"eastcoast.co.za",
		"eastmail.com",
		"easy.to",
		"easypost.com",
		"eatmydirt.com",
		"ecardmail.com",
		"ecbsolutions.net",
		"echina.com",
		"ecompare.com",
		"edmail.com",
		"ednatx.com",
		"edtnmail.com",
		"educacao.te.pt",
		"educastmail.com",
		"ehmail.com",
		"eilersmail.com",
		"eircom.net",
		"elp.rr.com",
		"elsitio.com",
		"elvis.com",
		"elvisfan.com",
		"email-london.co.uk",
		"email.com",
		"email.cz",
		"email.de",
		"email.ee",
		"email.it",
		"email.nu",
		"email.plala.or.jp",
		"email.ro",
		"email.ru",
		"email.si",
		"email.women.com",
		"email2me.net",
		"emailacc.com",
		"emailaccount.com",
		"emailahi.com",
		"emailchoice.com",
		"emailcorner.net",
		"emaildienst.de",
		"emailem.com",
		"emailengine.net",
		"emailforyou.net",
		"emailgroups.net",
		"emailmiser.com",
		"emailpinoy.com",
		"emailplanet.com",
		"emails.ru",
		"emailthe.net",
		"emailuser.net",
		"emailx.net",
		"ematic.com",
		"embarqmail.com",
		"emumail.com",
		"end-war.com",
		"enel.net",
		"engineer.com",
		"england.com",
		"england.edu",
		"englandmail.com",
		"enjoy.email.ne.jp",
		"epatra.com",
		"epix.net",
		"epost.de",
		"eposta.hu",
		"eqqu.com",
		"eramail.co.za",
		"eresmas.com",
		"eriga.lv",
		"estranet.it",
		"etcmail.com",
		"ethos.st",
		"etoast.com",
		"etrademail.com",
		"etranquil.com",
		"etranquil.net",
		"etranquil.org",
		"eudoramail.com",
		"europe.com",
		"europemail.com",
		"euroseek.com",
		"every1.net",
		"everyday.com.kh",
		"everyone.net",
		"examnotes.net",
		"excite.co.jp",
		"excite.com",
		"excite.it",
		"exclusivemail.co.za",
		"execs.com",
		"executive.co.za",
		"exemail.com.au",
		"expressasia.com",
		"extenda.net",
		"extended.com",
		"eyou.com",
		"ezcybersearch.com",
		"ezmail.egine.com",
		"ezmail.ru",
		"ezrs.com",
		"ezweb.ne.jp",
		"f1fans.net",
		"fakeinbox.com",
		"fan.com",
		"fan.theboys.com",
		"fansonlymail.com",
		"fantasticmail.com",
		"farang.net",
		"faroweb.com",
		"fastacura.com",
		"fastchevy.com",
		"fastchrysler.com",
		"fastem.com",
		"fastemail.us",
		"fastemailer.com",
		"fastermail.com",
		"fastimap.com",
		"fastkawasaki.com",
		"fastmail.com.au",
		"fastmail.fm",
		"fastmailbox.net",
		"fastmazda.com",
		"fastmessaging.com",
		"fastmitsubishi.com",
		"fastnissan.com",
		"fastservice.com",
		"fastsubaru.com",
		"fastsuzuki.com",
		"fasttoyota.com",
		"fastyamaha.com",
		"fatcock.net",
		"fathersrightsne.org",
		"fbi-agent.com",
		"fbi.hu",
		"federalcontractors.com",
		"felicity.com",
		"felicitymail.com",
		"femenino.com",
		"fetchmail.co.uk",
		"fetchmail.com",
		"feyenoorder.com",
		"ffanet.com",
		"fiberia.com",
		"filipinolinks.com",
		"financemail.net",
		"financier.com",
		"findmail.com",
		"finebody.com",
		"finfin.com",
		"fire-brigade.com",
		"fireman.net",
		"fishburne.org",
		"flashemail.com",
		"flashmail.com",
		"flashmail.net",
		"flipcode.com",
		"fmail.co.uk",
		"fmailbox.com",
		"fmgirl.com",
		"fmguy.com",
		"fnbmail.co.za",
		"fnmail.com",
		"folkfan.com",
		"foodmail.com",
		"football.theboys.com",
		"footballmail.com",
		"for-president.com",
		"forfree.at",
		"forpresident.com",
		"fortuncity.com",
		"fortunecity.com",
		"forum.dk",
		"foxmail.com",
		"free-org.com",
		"free.com.pe",
		"free.fr",
		"freeaccess.nl",
		"freeaccount.com",
		"freeandsingle.com",
		"freedom.usa.com",
		"freedomlover.com",
		"freegates.be",
		"freeghana.com",
		"freeler.nl",
		"freemail.c3.hu",
		"freemail.com.au",
		"freemail.com.pk",
		"freemail.de",
		"freemail.et",
		"freemail.gr",
		"freemail.hu",
		"freemail.it",
		"freemail.lt",
		"freemail.nl",
		"freemail.org.mk",
		"freenet.de",
		"freenet.kg",
		"freeola.com",
		"freeola.net",
		"freeserve.co.uk",
		"freestamp.com",
		"freestart.hu",
		"freesurf.fr",
		"freesurf.nl",
		"freeuk.com",
		"freeuk.net",
		"freeukisp.co.uk",
		"freeweb.org",
		"freewebemail.com",
		"freeyellow.com",
		"freezone.co.uk",
		"fresnomail.com",
		"friends-cafe.com",
		"friendsfan.com",
		"from-africa.com",
		"from-america.com",
		"from-argentina.com",
		"from-asia.com",
		"from-australia.com",
		"from-belgium.com",
		"from-brazil.com",
		"from-canada.com",
		"from-china.net",
		"from-england.com",
		"from-europe.com",
		"from-france.net",
		"from-germany.net",
		"from-holland.com",
		"from-israel.com",
		"from-italy.net",
		"from-japan.net",
		"from-korea.com",
		"from-mexico.com",
		"from-outerspace.com",
		"from-russia.com",
		"from-spain.net",
		"fromalabama.com",
		"fromalaska.com",
		"fromarizona.com",
		"fromarkansas.com",
		"fromcalifornia.com",
		"fromcolorado.com",
		"fromconnecticut.com",
		"fromdelaware.com",
		"fromflorida.net",
		"fromgeorgia.com",
		"fromhawaii.net",
		"fromidaho.com",
		"fromillinois.com",
		"fromindiana.com",
		"fromiowa.com",
		"fromjupiter.com",
		"fromkansas.com",
		"fromkentucky.com",
		"fromlouisiana.com",
		"frommaine.net",
		"frommaryland.com",
		"frommassachusetts.com",
		"frommiami.com",
		"frommichigan.com",
		"fromminnesota.com",
		"frommississippi.com",
		"frommissouri.com",
		"frommontana.com",
		"fromnebraska.com",
		"fromnevada.com",
		"fromnewhampshire.com",
		"fromnewjersey.com",
		"fromnewmexico.com",
		"fromnewyork.net",
		"fromnorthcarolina.com",
		"fromnorthdakota.com",
		"fromohio.com",
		"fromoklahoma.com",
		"fromoregon.net",
		"frompennsylvania.com",
		"fromrhodeisland.com",
		"fromru.com",
		"fromsouthcarolina.com",
		"fromsouthdakota.com",
		"fromtennessee.com",
		"fromtexas.com",
		"fromthestates.com",
		"fromutah.com",
		"fromvermont.com",
		"fromvirginia.com",
		"fromwashington.com",
		"fromwashingtondc.com",
		"fromwestvirginia.com",
		"fromwisconsin.com",
		"fromwyoming.com",
		"front.ru",
		"frontier.com",
		"frontiernet.net",
		"frostbyte.uk.net",
		"fsmail.net",
		"ftml.net",
		"fullmail.com",
		"funkfan.com",
		"fuorissimo.com",
		"furnitureprovider.com",
		"fuse.net",
		"fut.es",
		"fwbfleamarket.gccoxmail.com",
		"fwnb.com",
		"fxsmails.com",
		"g4444mail.com",
		"galamb.net",
		"galaxy5.com",
		"galaxyhit.com",
		"gamebox.net",
		"gamegeek.com",
		"gamespotmail.com",
		"garbage.com",
		"gardener.com",
		"gawab.com",
		"gaybrighton.co.uk",
		"gaza.net",
		"gazeta.pl",
		"gazibooks.com",
		"gci.net",
		"gee-wiz.com",
		"geecities.com",
		"geek.com",
		"geek.hu",
		"geeklife.com",
		"general-hospital.com",
		"geocities.com",
		"geologist.com",
		"geopia.com",
		"germanymail.com",
		"getonemail.com",
		"gh2000.com",
		"ghanamail.com",
		"ghostmail.com",
		"giantsfan.com",
		"giga4u.de",
		"gigileung.org",
		"givepeaceachance.com",
		"glay.org",
		"glendale.net",
		"globalfree.it",
		"globalpagan.com",
		"globalsite.com.br",
		"gmai.com",
		"gmail.co",
		"gmail.co.uk",
		"gmail.com",
		"gmail.com.com",
		"gmail.it",
		"gmail.om",
		"gmx.at",
		"gmx.com",
		"gmx.de",
		"gmx.li",
		"gmx.net",
		"gnwmail.com",
		"go.com",
		"go.ro",
		"go.ru",
		"go2.com.py",
		"go2net.com",
		"gocollege.com",
		"gocubs.com",
		"gofree.co.uk",
		"goldenmail.ru",
		"goldmail.ru",
		"golfemail.com",
		"golfmail.be",
		"gonavy.net",
		"goodstick.com",
		"googlemail.com",
		"goplay.com",
		"gorontalo.net",
		"gospelfan.com",
		"gothere.uk.com",
		"gotmail.com",
		"gotomy.com",
		"govolsfan.com",
		"gowikibooks.com",
		"gowikicampus.com",
		"gowikicars.com",
		"gowikifilms.com",
		"gowikigames.com",
		"gowikimusic.com",
		"gowikinetwork.com",
		"gowikitravel.com",
		"gowikitv.com",
		"gportal.hu",
		"grabmail.com",
		"graduate.org",
		"graffiti.net",
		"gramszu.net",
		"graphic-designer.com",
		"grapplers.com",
		"gratisweb.com",
		"greenmail.net",
		"groupmail.com",
		"grungecafe.com",
		"gtemail.net",
		"gtmc.net",
		"gua.net",
		"guessmail.com",
		"guju.net",
		"gurlmail.com",
		"guy.com",
		"guy2.com",
		"guyanafriends.com",
		"gyorsposta.com",
		"gyorsposta.hu",
		"hackermail.com",
		"hackermail.net",
		"hailmail.net",
		"hairdresser.com",
		"hairdresser.net",
		"haltospam.com",
		"hamptonroads.com",
		"handbag.com",
		"handleit.com",
		"hang-ten.com",
		"hanmail.net",
		"happemail.com",
		"happycounsel.com",
		"happypuppy.com",
		"hardcorefreak.com",
		"hawaii.rr.com",
		"hawaiiantel.net",
		"headbone.com",
		"heartthrob.com",
		"heerschap.com",
		"heesun.net",
		"hehe.com",
		"hello.hu",
		"hello.net.au",
		"hello.to",
		"helter-skelter.com",
		"hempseed.com",
		"herediano.com",
		"heremail.com",
		"herono1.com",
		"hey.to",
		"hhdevel.com",
		"highmilton.com",
		"highquality.com",
		"highveldmail.co.za",
		"hilarious.com",
		"hiphopfan.com",
		"hispavista.com",
		"hitthe.net",
		"hkg.net",
		"hkstarphoto.com",
		"hockeymail.com",
		"hollywoodkids.com",
		"homail.com",
		"home-email.com",
		"home.no.net",
		"home.ro",
		"home.se",
		"homeart.com",
		"homelocator.com",
		"homemail.co.za",
		"homemail.com",
		"homestead.com",
		"homeworkcentral.com",
		"hongkong.com",
		"hookup.net",
		"hoopsmail.com",
		"horrormail.com",
		"host-it.com.sg",
		"hot-shot.com",
		"hot.ee",
		"hot.rr.com",
		"hotbot.com",
		"hotbrev.com",
		"hotepmail.com",
		"hotfire.net",
		"hotletter.com",
		"hotmail.ca",
		"hotmail.cm",
		"hotmail.co.il",
		"hotmail.co.jp",
		"hotmail.co.kr",
		"hotmail.co.nz",
		"hotmail.co.th",
		"hotmail.co.uk",
		"hotmail.com",
		"hotmail.com.au",
		"hotmail.con",
		"hotmail.de",
		"hotmail.dk",
		"hotmail.es",
		"hotmail.fr",
		"hotmail.gr",
		"hotmail.it",
		"hotmail.kg",
		"hotmail.kz",
		"hotmail.nl",
		"hotmail.ru",
		"hotmail.sg",
		"hotpop.com",
		"hotpop3.com",
		"hotvoice.com",
		"housefan.com",
		"housemail.com",
		"hsuchi.net",
		"html.tou.com",
		"hughes.net",
		"humanoid.net",
		"hunsa.com",
		"hushmail.com",
		"hvc.rr.com",
		"hypernautica.com",
		"i-connect.com",
		"i-france.com",
		"i-mail.com.au",
		"i-mail.jp",
		"i-p.com",
		"i.am",
		"i.softbank.jp",
		"i12.com",
		"iamawoman.com",
		"iamwaiting.com",
		"iamwasted.com",
		"iamyours.com",
		"icestorm.com",
		"ichimail.com",
		"icloud.com",
		"icmsconsultants.com",
		"icq.com",
		"icqmail.com",
		"icrazy.com",
		"id-base.com",
		"ididitmyway.com",
		"idirect.com",
		"iespana.es",
		"ifoward.com",
		"ig.com.br",
		"ignazio.it",
		"ignmail.com",
		"ihateclowns.com",
		"iinet.net.au",
		"ijustdontcare.com",
		"ilovechocolate.com",
		"ilovejesus.com",
		"ilovethemovies.com",
		"ilovetocollect.net",
		"ilse.nl",
		"imaginemail.com",
		"imail.org",
		"imail.ru",
		"imailbox.com",
		"imel.org",
		"imneverwrong.com",
		"imposter.co.uk",
		"imstressed.com",
		"imtoosexy.com",
		"in-box.net",
		"iname.com",
		"inbox.com",
		"inbox.lv",
		"inbox.net",
		"inbox.ru",
		"incamail.com",
		"incognitomail.org",
		"incredimail.com",
		"indexa.fr",
		"india.com",
		"indiatimes.com",
		"indo-mail.com",
		"indocities.com",
		"indomail.com",
		"indyracers.com",
		"info-media.de",
		"info66.com",
		"infohq.com",
		"infomail.es",
		"infomart.or.jp",
		"infoseek.jp",
		"infospacemail.com",
		"infovia.com.ar",
		"inicia.es",
		"inmail.sk",
		"innocent.com",
		"inorbit.com",
		"insidebaltimore.net",
		"insight.rr.com",
		"instruction.com",
		"insurer.com",
		"interburp.com",
		"interfree.it",
		"interia.pl",
		"interlap.com.ar",
		"intermail.co.il",
		"internet-club.com",
		"internet-police.com",
		"internetbiz.com",
		"internetdrive.com",
		"internetegypt.com",
		"internetemails.net",
		"internetmailing.net",
		"internode.on.net",
		"investormail.com",
		"inwind.it",
		"iobox.com",
		"iobox.fi",
		"iol.it",
		"iowaemail.com",
		"ip3.com",
		"ipoo.org",
		"iprimus.com.au",
		"iqemail.com",
		"irangate.net",
		"iraqmail.com",
		"ireland.com",
		"irelandmail.com",
		"irj.hu",
		"isellcars.com",
		"islamonline.net",
		"isleuthmail.com",
		"ismart.net",
		"isonfire.com",
		"isp9.net",
		"israelmail.com",
		"italymail.com",
		"itloox.com",
		"itmom.com",
		"ivebeenframed.com",
		"ivillage.com",
		"iwan-fals.com",
		"iwmail.com",
		"iwon.com",
		"ix.netcom.com",
		"izadpanah.com",
		"jahoopa.com",
		"jakuza.hu",
		"japan.com",
		"jaydemail.com",
		"jazzandjava.com",
		"jazzfan.com",
		"jazzgame.com",
		"jcom.home.ne.jp",
		"jerusalemmail.com",
		"jetemail.net",
		"jewishmail.com",
		"jippii.fi",
		"jmail.co.za",
		"job4u.com",
		"joinme.com",
		"jokes.com",
		"jordanmail.com",
		"journalist.com",
		"jovem.te.pt",
		"joymail.com",
		"jp.bigplanet.com",
		"jpopmail.com",
		"jubiimail.dk",
		"jump.com",
		"jumpy.it",
		"juniormail.com",
		"juno.com",
		"justemail.net",
		"justicemail.com",
		"kaazoo.com",
		"kabelmail.de",
		"kaixo.com",
		"kalpoint.com",
		"kansascity.com",
		"kapoorweb.com",
		"karachian.com",
		"karachioye.com",
		"karbasi.com",
		"katamail.com",
		"kayafmmail.co.za",
		"kbjrmail.com",
		"kc.rr.com",
		"kcks.com",
		"keg-party.com",
		"keko.com.ar",
		"kellychen.com",
		"keromail.com",
		"keyemail.com",
		"kgb.hu",
		"khosropour.com",
		"kickassmail.com",
		"killermail.com",
		"killmail.net",
		"kimo.com",
		"kinki-kids.com",
		"kissfans.com",
		"kittymail.com",
		"kitznet.at",
		"kiwibox.com",
		"kiwitown.com",
		"klassmaster.com",
		"kmail.com.au",
		"konx.com",
		"korea.com",
		"koreamail.com",
		"kozmail.com",
		"kpnmail.nl",
		"krongthip.com",
		"krunis.com",
		"ksanmail.com",
		"ksee24mail.com",
		"kube93mail.com",
		"kukamail.com",
		"kumarweb.com",
		"kurzepost.de",
		"kuwait-mail.com",
		"kyoto.email.ne.jp",
		"la.com",
		"ladymail.cz",
		"lagerlouts.com",
		"lahoreoye.com",
		"lakmail.com",
		"lamer.hu",
		"land.ru",
		"lankamail.com",
		"laposte.net",
		"latemodels.com",
		"latinmail.com",
		"latino.com",
		"lavabit.com",
		"law.com",
		"lawyer.com",
		"leehom.net",
		"legalactions.com",
		"legislator.com",
		"leonlai.net",
		"letsgomets.net",
		"letterbox.com",
		"levele.com",
		"levele.hu",
		"lex.bg",
		"lexis-nexis-mail.com",
		"libero.it",
		"liberomail.com",
		"liberto.it",
		"lick101.com",
		"link2mail.net",
		"linkmaster.com",
		"linktrader.com",
		"linuxfreemail.com",
		"linuxmail.com",
		"linuxmail.org",
		"lionsfan.com.au",
		"liontrucks.com",
		"liquidinformation.net",
		"list.ru",
		"littleblueroom.com",
		"live.be",
		"live.ca",
		"live.cn",
		"live.co.kr",
		"live.co.uk",
		"live.com",
		"live.com.au",
		"live.com.sg",
		"live.de",
		"live.dk",
		"live.fr",
		"live.hk",
		"live.ie",
		"live.it",
		"live.jp",
		"live.mdx.ac.uk",
		"live.nl",
		"live.vu.edu.au",
		"liverpoolfans.com",
		"llandudno.com",
		"llangollen.com",
		"lmxmail.sk",
		"lobbyist.com",
		"localbar.com",
		"london.com",
		"loobie.com",
		"looksmart.co.uk",
		"looksmart.com",
		"looksmart.com.au",
		"lopezclub.com",
		"lortemail.dk",
		"louiskoo.com",
		"love.cz",
		"loveable.com",
		"lovecat.com",
		"lovelygirl.net",
		"lovemail.com",
		"lover-boy.com",
		"lovergirl.com",
		"lovingjesus.com",
		"lowandslow.com",
		"luso.pt",
		"luukku.com",
		"lycos.at",
		"lycos.co.uk",
		"lycos.com",
		"lycos.de",
		"lycos.es",
		"lycos.it",
		"lycos.ne.jp",
		"lycos.nl",
		"lycosemail.com",
		"lycosmail.com",
		"m-a-i-l.com",
		"m-hmail.com",
		"m4.org",
		"ma.rr.com",
		"mac.com",
		"macbox.com",
		"macfreak.com",
		"machinecandy.com",
		"macmail.com",
		"madcreations.com",
		"madonnafan.com",
		"madrid.com",
		"maffia.hu",
		"magicmail.co.za",
		"mahmoodweb.com",
		"mail-awu.de",
		"mail-box.cz",
		"mail-center.com",
		"mail-central.com",
		"mail-me.com",
		"mail-page.com",
		"mail.austria.com",
		"mail.az",
		"mail.bbexcite.jp",
		"mail.bcu.ac.uk",
		"mail.be",
		"mail.bulgaria.com",
		"mail.byte.it",
		"mail.co.za",
		"mail.com",
		"mail.dcu.ie",
		"mail.ee",
		"mail.entrepeneurmag.com",
		"mail.freetown.com",
		"mail.goo.ne.jp",
		"mail.gr",
		"mail.hitthebeach.com",
		"mail.ie",
		"mail.kmsp.com",
		"mail.md",
		"mail.nu",
		"mail.org.uk",
		"mail.pf",
		"mail.pharmacy.com",
		"mail.pt",
		"mail.r-o-o-t.com",
		"mail.rossam.com",
		"mail.ru",
		"mail.salu.net",
		"mail.sisna.com",
		"mail.spaceports.com",
		"mail.theboys.com",
		"mail.usa.com",
		"mail.vasarhely.hu",
		"mail.vrfarm.com.tw",
		"mail15.com",
		"mail1st.com",
		"mail2007.com",
		"mail2aaron.com",
		"mail2abby.com",
		"mail2abc.com",
		"mail2actor.com",
		"mail2admiral.com",
		"mail2adorable.com",
		"mail2adoration.com",
		"mail2adore.com",
		"mail2adventure.com",
		"mail2aeolus.com",
		"mail2aether.com",
		"mail2affection.com",
		"mail2afghanistan.com",
		"mail2africa.com",
		"mail2agent.com",
		"mail2aha.com",
		"mail2ahoy.com",
		"mail2aim.com",
		"mail2air.com",
		"mail2airbag.com",
		"mail2airforce.com",
		"mail2airport.com",
		"mail2alabama.com",
		"mail2alan.com",
		"mail2alaska.com",
		"mail2albania.com",
		"mail2alcoholic.com",
		"mail2alec.com",
		"mail2alexa.com",
		"mail2algeria.com",
		"mail2alicia.com",
		"mail2alien.com",
		"mail2allan.com",
		"mail2allen.com",
		"mail2allison.com",
		"mail2alpha.com",
		"mail2alyssa.com",
		"mail2amanda.com",
		"mail2amazing.com",
		"mail2amber.com",
		"mail2america.com",
		"mail2american.com",
		"mail2andorra.com",
		"mail2andrea.com",
		"mail2andy.com",
		"mail2anesthesiologist.com",
		"mail2angela.com",
		"mail2angola.com",
		"mail2ann.com",
		"mail2anna.com",
		"mail2anne.com",
		"mail2anthony.com",
		"mail2anything.com",
		"mail2aphrodite.com",
		"mail2apollo.com",
		"mail2april.com",
		"mail2aquarius.com",
		"mail2arabia.com",
		"mail2arabic.com",
		"mail2architect.com",
		"mail2ares.com",
		"mail2argentina.com",
		"mail2aries.com",
		"mail2arizona.com",
		"mail2arkansas.com",
		"mail2armenia.com",
		"mail2army.com",
		"mail2arnold.com",
		"mail2art.com",
		"mail2artemus.com",
		"mail2arthur.com",
		"mail2artist.com",
		"mail2ashley.com",
		"mail2ask.com",
		"mail2astronomer.com",
		"mail2athena.com",
		"mail2athlete.com",
		"mail2atlas.com",
		"mail2atom.com",
		"mail2attitude.com",
		"mail2auction.com",
		"mail2aunt.com",
		"mail2australia.com",
		"mail2austria.com",
		"mail2azerbaijan.com",
		"mail2baby.com",
		"mail2bahamas.com",
		"mail2bahrain.com",
		"mail2ballerina.com",
		"mail2ballplayer.com",
		"mail2band.com",
		"mail2bangladesh.com",
		"mail2bank.com",
		"mail2banker.com",
		"mail2bankrupt.com",
		"mail2baptist.com",
		"mail2bar.com",
		"mail2barbados.com",
		"mail2barbara.com",
		"mail2barter.com",
		"mail2basketball.com",
		"mail2batter.com",
		"mail2beach.com",
		"mail2beast.com",
		"mail2beatles.com",
		"mail2beauty.com",
		"mail2becky.com",
		"mail2beijing.com",
		"mail2belgium.com",
		"mail2belize.com",
		"mail2ben.com",
		"mail2bernard.com",
		"mail2beth.com",
		"mail2betty.com",
		"mail2beverly.com",
		"mail2beyond.com",
		"mail2biker.com",
		"mail2bill.com",
		"mail2billionaire.com",
		"mail2billy.com",
		"mail2bio.com",
		"mail2biologist.com",
		"mail2black.com",
		"mail2blackbelt.com",
		"mail2blake.com",
		"mail2blind.com",
		"mail2blonde.com",
		"mail2blues.com",
		"mail2bob.com",
		"mail2bobby.com",
		"mail2bolivia.com",
		"mail2bombay.com",
		"mail2bonn.com",
		"mail2bookmark.com",
		"mail2boreas.com",
		"mail2bosnia.com",
		"mail2boston.com",
		"mail2botswana.com",
		"mail2bradley.com",
		"mail2brazil.com",
		"mail2breakfast.com",
		"mail2brian.com",
		"mail2bride.com",
		"mail2brittany.com",
		"mail2broker.com",
		"mail2brook.com",
		"mail2bruce.com",
		"mail2brunei.com",
		"mail2brunette.com",
		"mail2brussels.com",
		"mail2bryan.com",
		"mail2bug.com",
		"mail2bulgaria.com",
		"mail2business.com",
		"mail2buy.com",
		"mail2ca.com",
		"mail2california.com",
		"mail2calvin.com",
		"mail2cambodia.com",
		"mail2cameroon.com",
		"mail2canada.com",
		"mail2cancer.com",
		"mail2capeverde.com",
		"mail2capricorn.com",
		"mail2cardinal.com",
		"mail2cardiologist.com",
		"mail2care.com",
		"mail2caroline.com",
		"mail2carolyn.com",
		"mail2casey.com",
		"mail2cat.com",
		"mail2caterer.com",
		"mail2cathy.com",
		"mail2catlover.com",
		"mail2catwalk.com",
		"mail2cell.com",
		"mail2chad.com",
		"mail2champaign.com",
		"mail2charles.com",
		"mail2chef.com",
		"mail2chemist.com",
		"mail2cherry.com",
		"mail2chicago.com",
		"mail2chile.com",
		"mail2china.com",
		"mail2chinese.com",
		"mail2chocolate.com",
		"mail2christian.com",
		"mail2christie.com",
		"mail2christmas.com",
		"mail2christy.com",
		"mail2chuck.com",
		"mail2cindy.com",
		"mail2clark.com",
		"mail2classifieds.com",
		"mail2claude.com",
		"mail2cliff.com",
		"mail2clinic.com",
		"mail2clint.com",
		"mail2close.com",
		"mail2club.com",
		"mail2coach.com",
		"mail2coastguard.com",
		"mail2colin.com",
		"mail2college.com",
		"mail2colombia.com",
		"mail2color.com",
		"mail2colorado.com",
		"mail2columbia.com",
		"mail2comedian.com",
		"mail2composer.com",
		"mail2computer.com",
		"mail2computers.com",
		"mail2concert.com",
		"mail2congo.com",
		"mail2connect.com",
		"mail2connecticut.com",
		"mail2consultant.com",
		"mail2convict.com",
		"mail2cook.com",
		"mail2cool.com",
		"mail2cory.com",
		"mail2costarica.com",
		"mail2country.com",
		"mail2courtney.com",
		"mail2cowboy.com",
		"mail2cowgirl.com",
		"mail2craig.com",
		"mail2crave.com",
		"mail2crazy.com",
		"mail2create.com",
		"mail2croatia.com",
		"mail2cry.com",
		"mail2crystal.com",
		"mail2cuba.com",
		"mail2culture.com",
		"mail2curt.com",
		"mail2customs.com",
		"mail2cute.com",
		"mail2cutey.com",
		"mail2cynthia.com",
		"mail2cyprus.com",
		"mail2czechrepublic.com",
		"mail2dad.com",
		"mail2dale.com",
		"mail2dallas.com",
		"mail2dan.com",
		"mail2dana.com",
		"mail2dance.com",
		"mail2dancer.com",
		"mail2danielle.com",
		"mail2danny.com",
		"mail2darlene.com",
		"mail2darling.com",
		"mail2darren.com",
		"mail2daughter.com",
		"mail2dave.com",
		"mail2dawn.com",
		"mail2dc.com",
		"mail2dealer.com",
		"mail2deanna.com",
		"mail2dearest.com",
		"mail2debbie.com",
		"mail2debby.com",
		"mail2deer.com",
		"mail2delaware.com",
		"mail2delicious.com",
		"mail2demeter.com",
		"mail2democrat.com",
		"mail2denise.com",
		"mail2denmark.com",
		"mail2dennis.com",
		"mail2dentist.com",
		"mail2derek.com",
		"mail2desert.com",
		"mail2devoted.com",
		"mail2devotion.com",
		"mail2diamond.com",
		"mail2diana.com",
		"mail2diane.com",
		"mail2diehard.com",
		"mail2dilemma.com",
		"mail2dillon.com",
		"mail2dinner.com",
		"mail2dinosaur.com",
		"mail2dionysos.com",
		"mail2diplomat.com",
		"mail2director.com",
		"mail2dirk.com",
		"mail2disco.com",
		"mail2dive.com",
		"mail2diver.com",
		"mail2divorced.com",
		"mail2djibouti.com",
		"mail2doctor.com",
		"mail2doglover.com",
		"mail2dominic.com",
		"mail2dominica.com",
		"mail2dominicanrepublic.com",
		"mail2don.com",
		"mail2donald.com",
		"mail2donna.com",
		"mail2doris.com",
		"mail2dorothy.com",
		"mail2doug.com",
		"mail2dough.com",
		"mail2douglas.com",
		"mail2dow.com",
		"mail2downtown.com",
		"mail2dream.com",
		"mail2dreamer.com",
		"mail2dude.com",
		"mail2dustin.com",
		"mail2dyke.com",
		"mail2dylan.com",
		"mail2earl.com",
		"mail2earth.com",
		"mail2eastend.com",
		"mail2eat.com",
		"mail2economist.com",
		"mail2ecuador.com",
		"mail2eddie.com",
		"mail2edgar.com",
		"mail2edwin.com",
		"mail2egypt.com",
		"mail2electron.com",
		"mail2eli.com",
		"mail2elizabeth.com",
		"mail2ellen.com",
		"mail2elliot.com",
		"mail2elsalvador.com",
		"mail2elvis.com",
		"mail2emergency.com",
		"mail2emily.com",
		"mail2engineer.com",
		"mail2english.com",
		"mail2environmentalist.com",
		"mail2eos.com",
		"mail2eric.com",
		"mail2erica.com",
		"mail2erin.com",
		"mail2erinyes.com",
		"mail2eris.com",
		"mail2eritrea.com",
		"mail2ernie.com",
		"mail2eros.com",
		"mail2estonia.com",
		"mail2ethan.com",
		"mail2ethiopia.com",
		"mail2eu.com",
		"mail2europe.com",
		"mail2eurus.com",
		"mail2eva.com",
		"mail2evan.com",
		"mail2evelyn.com",
		"mail2everything.com",
		"mail2exciting.com",
		"mail2expert.com",
		"mail2fairy.com",
		"mail2faith.com",
		"mail2fanatic.com",
		"mail2fancy.com",
		"mail2fantasy.com",
		"mail2farm.com",
		"mail2farmer.com",
		"mail2fashion.com",
		"mail2fat.com",
		"mail2feeling.com",
		"mail2female.com",
		"mail2fever.com",
		"mail2fighter.com",
		"mail2fiji.com",
		"mail2filmfestival.com",
		"mail2films.com",
		"mail2finance.com",
		"mail2finland.com",
		"mail2fireman.com",
		"mail2firm.com",
		"mail2fisherman.com",
		"mail2flexible.com",
		"mail2florence.com",
		"mail2florida.com",
		"mail2floyd.com",
		"mail2fly.com",
		"mail2fond.com",
		"mail2fondness.com",
		"mail2football.com",
		"mail2footballfan.com",
		"mail2found.com",
		"mail2france.com",
		"mail2frank.com",
		"mail2frankfurt.com",
		"mail2franklin.com",
		"mail2fred.com",
		"mail2freddie.com",
		"mail2free.com",
		"mail2freedom.com",
		"mail2french.com",
		"mail2freudian.com",
		"mail2friendship.com",
		"mail2from.com",
		"mail2fun.com",
		"mail2gabon.com",
		"mail2gabriel.com",
		"mail2gail.com",
		"mail2galaxy.com",
		"mail2gambia.com",
		"mail2games.com",
		"mail2gary.com",
		"mail2gavin.com",
		"mail2gemini.com",
		"mail2gene.com",
		"mail2genes.com",
		"mail2geneva.com",
		"mail2george.com",
		"mail2georgia.com",
		"mail2gerald.com",
		"mail2german.com",
		"mail2germany.com",
		"mail2ghana.com",
		"mail2gilbert.com",
		"mail2gina.com",
		"mail2girl.com",
		"mail2glen.com",
		"mail2gloria.com",
		"mail2goddess.com",
		"mail2gold.com",
		"mail2golfclub.com",
		"mail2golfer.com",
		"mail2gordon.com",
		"mail2government.com",
		"mail2grab.com",
		"mail2grace.com",
		"mail2graham.com",
		"mail2grandma.com",
		"mail2grandpa.com",
		"mail2grant.com",
		"mail2greece.com",
		"mail2green.com",
		"mail2greg.com",
		"mail2grenada.com",
		"mail2gsm.com",
		"mail2guard.com",
		"mail2guatemala.com",
		"mail2guy.com",
		"mail2hades.com",
		"mail2haiti.com",
		"mail2hal.com",
		"mail2handhelds.com",
		"mail2hank.com",
		"mail2hannah.com",
		"mail2harold.com",
		"mail2harry.com",
		"mail2hawaii.com",
		"mail2headhunter.com",
		"mail2heal.com",
		"mail2heather.com",
		"mail2heaven.com",
		"mail2hebe.com",
		"mail2hecate.com",
		"mail2heidi.com",
		"mail2helen.com",
		"mail2hell.com",
		"mail2help.com",
		"mail2helpdesk.com",
		"mail2henry.com",
		"mail2hephaestus.com",
		"mail2hera.com",
		"mail2hercules.com",
		"mail2herman.com",
		"mail2hermes.com",
		"mail2hespera.com",
		"mail2hestia.com",
		"mail2highschool.com",
		"mail2hindu.com",
		"mail2hip.com",
		"mail2hiphop.com",
		"mail2holland.com",
		"mail2holly.com",
		"mail2hollywood.com",
		"mail2homer.com",
		"mail2honduras.com",
		"mail2honey.com",
		"mail2hongkong.com",
		"mail2hope.com",
		"mail2horse.com",
		"mail2hot.com",
		"mail2hotel.com",
		"mail2houston.com",
		"mail2howard.com",
		"mail2hugh.com",
		"mail2human.com",
		"mail2hungary.com",
		"mail2hungry.com",
		"mail2hygeia.com",
		"mail2hyperspace.com",
		"mail2hypnos.com",
		"mail2ian.com",
		"mail2ice-cream.com",
		"mail2iceland.com",
		"mail2idaho.com",
		"mail2idontknow.com",
		"mail2illinois.com",
		"mail2imam.com",
		"mail2in.com",
		"mail2india.com",
		"mail2indian.com",
		"mail2indiana.com",
		"mail2indonesia.com",
		"mail2infinity.com",
		"mail2intense.com",
		"mail2iowa.com",
		"mail2iran.com",
		"mail2iraq.com",
		"mail2ireland.com",
		"mail2irene.com",
		"mail2iris.com",
		"mail2irresistible.com",
		"mail2irving.com",
		"mail2irwin.com",
		"mail2isaac.com",
		"mail2israel.com",
		"mail2italian.com",
		"mail2italy.com",
		"mail2jackie.com",
		"mail2jacob.com",
		"mail2jail.com",
		"mail2jaime.com",
		"mail2jake.com",
		"mail2jamaica.com",
		"mail2james.com",
		"mail2jamie.com",
		"mail2jan.com",
		"mail2jane.com",
		"mail2janet.com",
		"mail2janice.com",
		"mail2japan.com",
		"mail2japanese.com",
		"mail2jasmine.com",
		"mail2jason.com",
		"mail2java.com",
		"mail2jay.com",
		"mail2jazz.com",
		"mail2jed.com",
		"mail2jeffrey.com",
		"mail2jennifer.com",
		"mail2jenny.com",
		"mail2jeremy.com",
		"mail2jerry.com",
		"mail2jessica.com",
		"mail2jessie.com",
		"mail2jesus.com",
		"mail2jew.com",
		"mail2jeweler.com",
		"mail2jim.com",
		"mail2jimmy.com",
		"mail2joan.com",
		"mail2joann.com",
		"mail2joanna.com",
		"mail2jody.com",
		"mail2joe.com",
		"mail2joel.com",
		"mail2joey.com",
		"mail2john.com",
		"mail2join.com",
		"mail2jon.com",
		"mail2jonathan.com",
		"mail2jones.com",
		"mail2jordan.com",
		"mail2joseph.com",
		"mail2josh.com",
		"mail2joy.com",
		"mail2juan.com",
		"mail2judge.com",
		"mail2judy.com",
		"mail2juggler.com",
		"mail2julian.com",
		"mail2julie.com",
		"mail2jumbo.com",
		"mail2junk.com",
		"mail2justin.com",
		"mail2justme.com",
		"mail2kansas.com",
		"mail2karate.com",
		"mail2karen.com",
		"mail2karl.com",
		"mail2karma.com",
		"mail2kathleen.com",
		"mail2kathy.com",
		"mail2katie.com",
		"mail2kay.com",
		"mail2kazakhstan.com",
		"mail2keen.com",
		"mail2keith.com",
		"mail2kelly.com",
		"mail2kelsey.com",
		"mail2ken.com",
		"mail2kendall.com",
		"mail2kennedy.com",
		"mail2kenneth.com",
		"mail2kenny.com",
		"mail2kentucky.com",
		"mail2kenya.com",
		"mail2kerry.com",
		"mail2kevin.com",
		"mail2kim.com",
		"mail2kimberly.com",
		"mail2king.com",
		"mail2kirk.com",
		"mail2kiss.com",
		"mail2kosher.com",
		"mail2kristin.com",
		"mail2kurt.com",
		"mail2kuwait.com",
		"mail2kyle.com",
		"mail2kyrgyzstan.com",
		"mail2la.com",
		"mail2lacrosse.com",
		"mail2lance.com",
		"mail2lao.com",
		"mail2larry.com",
		"mail2latvia.com",
		"mail2laugh.com",
		"mail2laura.com",
		"mail2lauren.com",
		"mail2laurie.com",
		"mail2lawrence.com",
		"mail2lawyer.com",
		"mail2lebanon.com",
		"mail2lee.com",
		"mail2leo.com",
		"mail2leon.com",
		"mail2leonard.com",
		"mail2leone.com",
		"mail2leslie.com",
		"mail2letter.com",
		"mail2liberia.com",
		"mail2libertarian.com",
		"mail2libra.com",
		"mail2libya.com",
		"mail2liechtenstein.com",
		"mail2life.com",
		"mail2linda.com",
		"mail2linux.com",
		"mail2lionel.com",
		"mail2lipstick.com",
		"mail2liquid.com",
		"mail2lisa.com",
		"mail2lithuania.com",
		"mail2litigator.com",
		"mail2liz.com",
		"mail2lloyd.com",
		"mail2lois.com",
		"mail2lola.com",
		"mail2london.com",
		"mail2looking.com",
		"mail2lori.com",
		"mail2lost.com",
		"mail2lou.com",
		"mail2louis.com",
		"mail2louisiana.com",
		"mail2lovable.com",
		"mail2love.com",
		"mail2lucky.com",
		"mail2lucy.com",
		"mail2lunch.com",
		"mail2lust.com",
		"mail2luxembourg.com",
		"mail2luxury.com",
		"mail2lyle.com",
		"mail2lynn.com",
		"mail2madagascar.com",
		"mail2madison.com",
		"mail2madrid.com",
		"mail2maggie.com",
		"mail2mail4.com",
		"mail2maine.com",
		"mail2malawi.com",
		"mail2malaysia.com",
		"mail2maldives.com",
		"mail2mali.com",
		"mail2malta.com",
		"mail2mambo.com",
		"mail2man.com",
		"mail2mandy.com",
		"mail2manhunter.com",
		"mail2mankind.com",
		"mail2many.com",
		"mail2marc.com",
		"mail2marcia.com",
		"mail2margaret.com",
		"mail2margie.com",
		"mail2marhaba.com",
		"mail2maria.com",
		"mail2marilyn.com",
		"mail2marines.com",
		"mail2mark.com",
		"mail2marriage.com",
		"mail2married.com",
		"mail2marries.com",
		"mail2mars.com",
		"mail2marsha.com",
		"mail2marshallislands.com",
		"mail2martha.com",
		"mail2martin.com",
		"mail2marty.com",
		"mail2marvin.com",
		"mail2mary.com",
		"mail2maryland.com",
		"mail2mason.com",
		"mail2massachusetts.com",
		"mail2matt.com",
		"mail2matthew.com",
		"mail2maurice.com",
		"mail2mauritania.com",
		"mail2mauritius.com",
		"mail2max.com",
		"mail2maxwell.com",
		"mail2maybe.com",
		"mail2mba.com",
		"mail2me4u.com",
		"mail2mechanic.com",
		"mail2medieval.com",
		"mail2megan.com",
		"mail2mel.com",
		"mail2melanie.com",
		"mail2melissa.com",
		"mail2melody.com",
		"mail2member.com",
		"mail2memphis.com",
		"mail2methodist.com",
		"mail2mexican.com",
		"mail2mexico.com",
		"mail2mgz.com",
		"mail2miami.com",
		"mail2michael.com",
		"mail2michelle.com",
		"mail2michigan.com",
		"mail2mike.com",
		"mail2milan.com",
		"mail2milano.com",
		"mail2mildred.com",
		"mail2milkyway.com",
		"mail2millennium.com",
		"mail2millionaire.com",
		"mail2milton.com",
		"mail2mime.com",
		"mail2mindreader.com",
		"mail2mini.com",
		"mail2minister.com",
		"mail2minneapolis.com",
		"mail2minnesota.com",
		"mail2miracle.com",
		"mail2missionary.com",
		"mail2mississippi.com",
		"mail2missouri.com",
		"mail2mitch.com",
		"mail2model.com",
		"mail2moldova.commail2molly.com",
		"mail2mom.com",
		"mail2monaco.com",
		"mail2money.com",
		"mail2mongolia.com",
		"mail2monica.com",
		"mail2montana.com",
		"mail2monty.com",
		"mail2moon.com",
		"mail2morocco.com",
		"mail2morpheus.com",
		"mail2mors.com",
		"mail2moscow.com",
		"mail2moslem.com",
		"mail2mouseketeer.com",
		"mail2movies.com",
		"mail2mozambique.com",
		"mail2mp3.com",
		"mail2mrright.com",
		"mail2msright.com",
		"mail2museum.com",
		"mail2music.com",
		"mail2musician.com",
		"mail2muslim.com",
		"mail2my.com",
		"mail2myboat.com",
		"mail2mycar.com",
		"mail2mycell.com",
		"mail2mygsm.com",
		"mail2mylaptop.com",
		"mail2mymac.com",
		"mail2mypager.com",
		"mail2mypalm.com",
		"mail2mypc.com",
		"mail2myphone.com",
		"mail2myplane.com",
		"mail2namibia.com",
		"mail2nancy.com",
		"mail2nasdaq.com",
		"mail2nathan.com",
		"mail2nauru.com",
		"mail2navy.com",
		"mail2neal.com",
		"mail2nebraska.com",
		"mail2ned.com",
		"mail2neil.com",
		"mail2nelson.com",
		"mail2nemesis.com",
		"mail2nepal.com",
		"mail2netherlands.com",
		"mail2network.com",
		"mail2nevada.com",
		"mail2newhampshire.com",
		"mail2newjersey.com",
		"mail2newmexico.com",
		"mail2newyork.com",
		"mail2newzealand.com",
		"mail2nicaragua.com",
		"mail2nick.com",
		"mail2nicole.com",
		"mail2niger.com",
		"mail2nigeria.com",
		"mail2nike.com",
		"mail2no.com",
		"mail2noah.com",
		"mail2noel.com",
		"mail2noelle.com",
		"mail2normal.com",
		"mail2norman.com",
		"mail2northamerica.com",
		"mail2northcarolina.com",
		"mail2northdakota.com",
		"mail2northpole.com",
		"mail2norway.com",
		"mail2notus.com",
		"mail2noway.com",
		"mail2nowhere.com",
		"mail2nuclear.com",
		"mail2nun.com",
		"mail2ny.com",
		"mail2oasis.com",
		"mail2oceanographer.com",
		"mail2ohio.com",
		"mail2ok.com",
		"mail2oklahoma.com",
		"mail2oliver.com",
		"mail2oman.com",
		"mail2one.com",
		"mail2onfire.com",
		"mail2online.com",
		"mail2oops.com",
		"mail2open.com",
		"mail2ophthalmologist.com",
		"mail2optometrist.com",
		"mail2oregon.com",
		"mail2oscars.com",
		"mail2oslo.com",
		"mail2painter.com",
		"mail2pakistan.com",
		"mail2palau.com",
		"mail2pan.com",
		"mail2panama.com",
		"mail2paraguay.com",
		"mail2paralegal.com",
		"mail2paris.com",
		"mail2park.com",
		"mail2parker.com",
		"mail2party.com",
		"mail2passion.com",
		"mail2pat.com",
		"mail2patricia.com",
		"mail2patrick.com",
		"mail2patty.com",
		"mail2paul.com",
		"mail2paula.com",
		"mail2pay.com",
		"mail2peace.com",
		"mail2pediatrician.com",
		"mail2peggy.com",
		"mail2pennsylvania.com",
		"mail2perry.com",
		"mail2persephone.com",
		"mail2persian.com",
		"mail2peru.com",
		"mail2pete.com",
		"mail2peter.com",
		"mail2pharmacist.com",
		"mail2phil.com",
		"mail2philippines.com",
		"mail2phoenix.com",
		"mail2phonecall.com",
		"mail2phyllis.com",
		"mail2pickup.com",
		"mail2pilot.com",
		"mail2pisces.com",
		"mail2planet.com",
		"mail2platinum.com",
		"mail2plato.com",
		"mail2pluto.com",
		"mail2pm.com",
		"mail2podiatrist.com",
		"mail2poet.com",
		"mail2poland.com",
		"mail2policeman.com",
		"mail2policewoman.com",
		"mail2politician.com",
		"mail2pop.com",
		"mail2pope.com",
		"mail2popular.com",
		"mail2portugal.com",
		"mail2poseidon.com",
		"mail2potatohead.com",
		"mail2power.com",
		"mail2presbyterian.com",
		"mail2president.com",
		"mail2priest.com",
		"mail2prince.com",
		"mail2princess.com",
		"mail2producer.com",
		"mail2professor.com",
		"mail2protect.com",
		"mail2psychiatrist.com",
		"mail2psycho.com",
		"mail2psychologist.com",
		"mail2qatar.com",
		"mail2queen.com",
		"mail2rabbi.com",
		"mail2race.com",
		"mail2racer.com",
		"mail2rachel.com",
		"mail2rage.com",
		"mail2rainmaker.com",
		"mail2ralph.com",
		"mail2randy.com",
		"mail2rap.com",
		"mail2rare.com",
		"mail2rave.com",
		"mail2ray.com",
		"mail2raymond.com",
		"mail2realtor.com",
		"mail2rebecca.com",
		"mail2recruiter.com",
		"mail2recycle.com",
		"mail2redhead.com",
		"mail2reed.com",
		"mail2reggie.com",
		"mail2register.com",
		"mail2rent.com",
		"mail2republican.com",
		"mail2resort.com",
		"mail2rex.com",
		"mail2rhodeisland.com",
		"mail2rich.com",
		"mail2richard.com",
		"mail2ricky.com",
		"mail2ride.com",
		"mail2riley.com",
		"mail2rita.com",
		"mail2rob.com",
		"mail2robert.com",
		"mail2roberta.com",
		"mail2robin.com",
		"mail2rock.com",
		"mail2rocker.com",
		"mail2rod.com",
		"mail2rodney.com",
		"mail2romania.com",
		"mail2rome.com",
		"mail2ron.com",
		"mail2ronald.com",
		"mail2ronnie.com",
		"mail2rose.com",
		"mail2rosie.com",
		"mail2roy.com",
		"mail2rudy.com",
		"mail2rugby.com",
		"mail2runner.com",
		"mail2russell.com",
		"mail2russia.com",
		"mail2russian.com",
		"mail2rusty.com",
		"mail2ruth.com",
		"mail2rwanda.com",
		"mail2ryan.com",
		"mail2sa.com",
		"mail2sabrina.com",
		"mail2safe.com",
		"mail2sagittarius.com",
		"mail2sail.com",
		"mail2sailor.com",
		"mail2sal.com",
		"mail2salaam.com",
		"mail2sam.com",
		"mail2samantha.com",
		"mail2samoa.com",
		"mail2samurai.com",
		"mail2sandra.com",
		"mail2sandy.com",
		"mail2sanfrancisco.com",
		"mail2sanmarino.com",
		"mail2santa.com",
		"mail2sara.com",
		"mail2sarah.com",
		"mail2sat.com",
		"mail2saturn.com",
		"mail2saudi.com",
		"mail2saudiarabia.com",
		"mail2save.com",
		"mail2savings.com",
		"mail2school.com",
		"mail2scientist.com",
		"mail2scorpio.com",
		"mail2scott.com",
		"mail2sean.com",
		"mail2search.com",
		"mail2seattle.com",
		"mail2secretagent.com",
		"mail2senate.com",
		"mail2senegal.com",
		"mail2sensual.com",
		"mail2seth.com",
		"mail2sevenseas.com",
		"mail2sexy.com",
		"mail2seychelles.com",
		"mail2shane.com",
		"mail2sharon.com",
		"mail2shawn.com",
		"mail2ship.com",
		"mail2shirley.com",
		"mail2shoot.com",
		"mail2shuttle.com",
		"mail2sierraleone.com",
		"mail2simon.com",
		"mail2singapore.com",
		"mail2single.com",
		"mail2site.com",
		"mail2skater.com",
		"mail2skier.com",
		"mail2sky.com",
		"mail2sleek.com",
		"mail2slim.com",
		"mail2slovakia.com",
		"mail2slovenia.com",
		"mail2smile.com",
		"mail2smith.com",
		"mail2smooth.com",
		"mail2soccer.com",
		"mail2soccerfan.com",
		"mail2socialist.com",
		"mail2soldier.com",
		"mail2somalia.com",
		"mail2son.com",
		"mail2song.com",
		"mail2sos.com",
		"mail2sound.com",
		"mail2southafrica.com",
		"mail2southamerica.com",
		"mail2southcarolina.com",
		"mail2southdakota.com",
		"mail2southkorea.com",
		"mail2southpole.com",
		"mail2spain.com",
		"mail2spanish.com",
		"mail2spare.com",
		"mail2spectrum.com",
		"mail2splash.com",
		"mail2sponsor.com",
		"mail2sports.com",
		"mail2srilanka.com",
		"mail2stacy.com",
		"mail2stan.com",
		"mail2stanley.com",
		"mail2star.com",
		"mail2state.com",
		"mail2stephanie.com",
		"mail2steve.com",
		"mail2steven.com",
		"mail2stewart.com",
		"mail2stlouis.com",
		"mail2stock.com",
		"mail2stockholm.com",
		"mail2stockmarket.com",
		"mail2storage.com",
		"mail2store.com",
		"mail2strong.com",
		"mail2student.com",
		"mail2studio.com",
		"mail2studio54.com",
		"mail2stuntman.com",
		"mail2subscribe.com",
		"mail2sudan.com",
		"mail2superstar.com",
		"mail2surfer.com",
		"mail2suriname.com",
		"mail2susan.com",
		"mail2suzie.com",
		"mail2swaziland.com",
		"mail2sweden.com",
		"mail2sweetheart.com",
		"mail2swim.com",
		"mail2swimmer.com",
		"mail2swiss.com",
		"mail2switzerland.com",
		"mail2sydney.com",
		"mail2sylvia.com",
		"mail2syria.com",
		"mail2taboo.com",
		"mail2taiwan.com",
		"mail2tajikistan.com",
		"mail2tammy.com",
		"mail2tango.com",
		"mail2tanya.com",
		"mail2tanzania.com",
		"mail2tara.com",
		"mail2taurus.com",
		"mail2taxi.com",
		"mail2taxidermist.com",
		"mail2taylor.com",
		"mail2taz.com",
		"mail2teacher.com",
		"mail2technician.com",
		"mail2ted.com",
		"mail2telephone.com",
		"mail2teletubbie.com",
		"mail2tenderness.com",
		"mail2tennessee.com",
		"mail2tennis.com",
		"mail2tennisfan.com",
		"mail2terri.com",
		"mail2terry.com",
		"mail2test.com",
		"mail2texas.com",
		"mail2thailand.com",
		"mail2therapy.com",
		"mail2think.com",
		"mail2tickets.com",
		"mail2tiffany.com",
		"mail2tim.com",
		"mail2time.com",
		"mail2timothy.com",
		"mail2tina.com",
		"mail2titanic.com",
		"mail2toby.com",
		"mail2todd.com",
		"mail2togo.com",
		"mail2tom.com",
		"mail2tommy.com",
		"mail2tonga.com",
		"mail2tony.com",
		"mail2touch.com",
		"mail2tourist.com",
		"mail2tracey.com",
		"mail2tracy.com",
		"mail2tramp.com",
		"mail2travel.com",
		"mail2traveler.com",
		"mail2travis.com",
		"mail2trekkie.com",
		"mail2trex.com",
		"mail2triallawyer.com",
		"mail2trick.com",
		"mail2trillionaire.com",
		"mail2troy.com",
		"mail2truck.com",
		"mail2trump.com",
		"mail2try.com",
		"mail2tunisia.com",
		"mail2turbo.com",
		"mail2turkey.com",
		"mail2turkmenistan.com",
		"mail2tv.com",
		"mail2tycoon.com",
		"mail2tyler.com",
		"mail2u4me.com",
		"mail2uae.com",
		"mail2uganda.com",
		"mail2uk.com",
		"mail2ukraine.com",
		"mail2uncle.com",
		"mail2unsubscribe.com",
		"mail2uptown.com",
		"mail2uruguay.com",
		"mail2usa.com",
		"mail2utah.com",
		"mail2uzbekistan.com",
		"mail2v.com",
		"mail2vacation.com",
		"mail2valentines.com",
		"mail2valerie.com",
		"mail2valley.com",
		"mail2vamoose.com",
		"mail2vanessa.com",
		"mail2vanuatu.com",
		"mail2venezuela.com",
		"mail2venous.com",
		"mail2venus.com",
		"mail2vermont.com",
		"mail2vickie.com",
		"mail2victor.com",
		"mail2victoria.com",
		"mail2vienna.com",
		"mail2vietnam.com",
		"mail2vince.com",
		"mail2virginia.com",
		"mail2virgo.com",
		"mail2visionary.com",
		"mail2vodka.com",
		"mail2volleyball.com",
		"mail2waiter.com",
		"mail2wallstreet.com",
		"mail2wally.com",
		"mail2walter.com",
		"mail2warren.com",
		"mail2washington.com",
		"mail2wave.com",
		"mail2way.com",
		"mail2waycool.com",
		"mail2wayne.com",
		"mail2web.com",
		"mail2webmaster.com",
		"mail2webtop.com",
		"mail2webtv.com",
		"mail2weird.com",
		"mail2wendell.com",
		"mail2wendy.com",
		"mail2westend.com",
		"mail2westvirginia.com",
		"mail2whether.com",
		"mail2whip.com",
		"mail2white.com",
		"mail2whitehouse.com",
		"mail2whitney.com",
		"mail2why.com",
		"mail2wilbur.com",
		"mail2wild.com",
		"mail2willard.com",
		"mail2willie.com",
		"mail2wine.com",
		"mail2winner.com",
		"mail2wired.com",
		"mail2wisconsin.com",
		"mail2woman.com",
		"mail2wonder.com",
		"mail2world.com",
		"mail2worship.com",
		"mail2wow.com",
		"mail2www.com",
		"mail2wyoming.com",
		"mail2xfiles.com",
		"mail2xox.com",
		"mail2yachtclub.com",
		"mail2yahalla.com",
		"mail2yemen.com",
		"mail2yes.com",
		"mail2yugoslavia.com",
		"mail2zack.com",
		"mail2zambia.com",
		"mail2zenith.com",
		"mail2zephir.com",
		"mail2zeus.com",
		"mail2zipper.com",
		"mail2zoo.com",
		"mail2zoologist.com",
		"mail2zurich.com",
		"mail3000.com",
		"mail333.com",
		"mailandftp.com",
		"mailandnews.com",
		"mailas.com",
		"mailasia.com",
		"mailbolt.com",
		"mailbomb.net",
		"mailboom.com",
		"mailbox.as",
		"mailbox.co.za",
		"mailbox.gr",
		"mailbox.hu",
		"mailbr.com.br",
		"mailc.net",
		"mailcan.com",
		"mailcatch.com",
		"mailcc.com",
		"mailchoose.co",
		"mailcity.com",
		"mailclub.fr",
		"mailclub.net",
		"maileater.com",
		"mailexcite.com",
		"mailforce.net",
		"mailftp.com",
		"mailgate.gr",
		"mailgenie.net",
		"mailhaven.com",
		"mailhood.com",
		"mailin8r.com",
		"mailinator.com",
		"mailinator.net",
		"mailinator2.com",
		"mailingweb.com",
		"mailisent.com",
		"mailite.com",
		"mailme.dk",
		"mailmetrash.com",
		"mailmight.com",
		"mailmij.nl",
		"mailnesia.com",
		"mailnew.com",
		"mailops.com",
		"mailoye.com",
		"mailpanda.com",
		"mailpost.zzn.com",
		"mailpride.com",
		"mailpuppy.com",
		"mailquack.com",
		"mailroom.com",
		"mailru.com",
		"mailsent.net",
		"mailshuttle.com",
		"mailslapping.com",
		"mailstart.com",
		"mailstartplus.com",
		"mailsucre.com",
		"mailsurf.com",
		"mailtag.com",
		"mailto.de",
		"mailup.net",
		"mailway.com",
		"mailwire.com",
		"maine.rr.com",
		"maktoob.com",
		"malayalamtelevision.net",
		"manager.de",
		"mantrafreenet.com",
		"mantramail.com",
		"mantraonline.com",
		"mar.email.ne.jp",
		"marchmail.com",
		"mariah-carey.ml.org",
		"mariahc.com",
		"marijuana.nl",
		"marketing.lu",
		"married-not.com",
		"marsattack.com",
		"martindalemail.com",
		"masrawy.com",
		"matmail.com",
		"mauimail.com",
		"mauritius.com",
		"maxleft.com",
		"maxmail.co.uk",
		"mbox.com.au",
		"mccreedymail.com",
		"mchsi.com",
		"me-mail.hu",
		"me.com",
		"medical.net.au",
		"medmail.com",
		"medscape.com",
		"meetingmall.com",
		"megago.com",
		"megamail.pt",
		"megapoint.com",
		"megotmail.com",
		"mehrani.com",
		"mehtaweb.com",
		"mekhong.com",
		"melodymail.com",
		"meloo.com",
		"meltmail.com",
		"members.student.com",
		"message.hu",
		"messages.to",
		"metacrawler.com",
		"metalfan.com",
		"metta.lk",
		"mexicomail.com",
		"miatadriver.com",
		"miesto.sk",
		"mighty.co.za",
		"miho-nakayama.com",
		"mikrotamanet.com",
		"millionaireintraining.com",
		"milmail.com",
		"mindless.com",
		"mindspring.com",
		"mini-mail.com",
		"minister.com",
		"misery.net",
		"mittalweb.com",
		"mixmail.com",
		"mjfrogmail.com",
		"ml1.net",
		"mmmmail.com",
		"mobilbatam.com",
		"mobileemail.vodafone.net",
		"mochamail.com",
		"mohammed.com",
		"moldova.cc",
		"moldova.com",
		"moldovacc.com",
		"money.net",
		"montevideo.com.uy",
		"moonman.com",
		"moose-mail.com",
		"mortaza.com",
		"mosaicfx.com",
		"moscowmail.com",
		"most-wanted.com",
		"mostlysunny.com",
		"motormania.com",
		"movemail.com",
		"movieluver.com",
		"mp4.it",
		"mr-potatohead.com",
		"mrpost.com",
		"mscold.com",
		"msgbox.com",
		"msn.co.uk",
		"msn.com",
		"mt2009.com",
		"mttestdriver.com",
		"mundomail.net",
		"munich.com",
		"music.com",
		"musician.org",
		"musicscene.org",
		"muslim.com",
		"mvdmail.com",
		"my.email.ne.jp",
		"mybox.it",
		"mycabin.com",
		"mycampus.com",
		"mycity.com",
		"mycool.com",
		"mydomain.com",
		"mydotcomaddress.com",
		"myemail.my",
		"myfamily.com",
		"mygo.com",
		"myiris.com",
		"mynamedot.com",
		"mynetaddress.com",
		"myownemail.com",
		"myownfriends.com",
		"mypad.com",
		"mypersonalemail.com",
		"myplace.com",
		"myrealbox.com",
		"myremarq.com",
		"myself.com",
		"mysentmail.com",
		"myspaceinc.com",
		"myspaceinc.net",
		"myspaceinc.org",
		"myspacepimpedup.com",
		"mystupidjob.com",
		"mythirdage.com",
		"mytrashmail.com",
		"myway.com",
		"myworldmail.com",
		"n2.com",
		"n2business.com",
		"n2mail.com",
		"n2software.com",
		"nabc.biz",
		"nafe.com",
		"nagpal.net",
		"nakedgreens.com",
		"name.com",
		"nameplanet.com",
		"nandomail.com",
		"naplesnews.net",
		"naseej.com",
		"nativestar.net",
		"nativeweb.net",
		"naui.net",
		"naver.com",
		"navigator.lv",
		"navy.org",
		"naz.com",
		"nc.rr.com",
		"nchoicemail.com",
		"neb.rr.com",
		"neeva.net",
		"nemra1.com",
		"nenter.com",
		"neo.rr.com",
		"nepwk.com",
		"nervhq.org",
		"net-pager.net",
		"net-shopping.com",
		"net.email.ne.jp",
		"net4b.pt",
		"net4you.at",
		"netbounce.com",
		"netbroadcaster.com",
		"netby.dk",
		"netcenter-vn.net",
		"netcourrier.com",
		"netexecutive.com",
		"netexpressway.com",
		"netgenie.com",
		"netian.com",
		"netins.net",
		"netizen.com.ar",
		"netlane.com",
		"netlimit.com",
		"netmanor.com",
		"netmongol.com",
		"netnet.com.sg",
		"netpiper.com",
		"netposta.net",
		"netradiomail.com",
		"netralink.com",
		"netscape.com",
		"netscape.net",
		"netscapeonline.co.uk",
		"netspace.net.au",
		"netspeedway.com",
		"netsquare.com",
		"netster.com",
		"nettaxi.com",
		"netvision.net.il",
		"netzero.com",
		"netzero.net",
		"new.rr.com",
		"newmail.com",
		"newmail.net",
		"newmail.ru",
		"newyork.com",
		"nexxmail.com",
		"nfmail.com",
		"nhmail.com",
		"nicebush.com",
		"nicegal.com",
		"nicholastse.net",
		"nicolastse.com",
		"nightmail.com",
		"nikopage.com",
		"nimail.com",
		"ninfan.com",
		"nirvanafan.com",
		"no-spam.hu",
		"noavar.com",
		"nobulk.com",
		"noclickemail.com",
		"nonpartisan.com",
		"norika-fujiwara.com",
		"norikomail.com",
		"northgates.net",
		"nospamfor.us",
		"nospammail.net",
		"nowmymail.com",
		"ntlworld.com",
		"ntscan.com",
		"null.net",
		"ny.com",
		"nyc.com",
		"nycap.rr.com",
		"nycmail.com",
		"nzoomail.com",
		"o-tay.com",
		"o2.co.uk",
		"o2.pl",
		"oaklandas-fan.com",
		"oath.com",
		"objectmail.com",
		"oceanfree.net",
		"oddpost.com",
		"odmail.com",
		"office-email.com",
		"officedomain.com",
		"offroadwarrior.com",
		"oh.rr.com",
		"oicexchange.com",
		"okbank.com",
		"okhuman.com",
		"okmad.com",
		"okmagic.com",
		"okname.net",
		"okuk.com",
		"oldies1041.com",
		"oldies104mail.com",
		"ole.com",
		"olemail.com",
		"olympist.net",
		"omaninfo.com",
		"onebox.com",
		"onenet.com.ar",
		"oneoffemail.com",
		"oneoffmail.com",
		"onet.pl",
		"oninet.pt",
		"online.de",
		"online.ie",
		"onlinehome.de",
		"onlinewiz.com",
		"onmilwaukee.com",
		"onobox.com",
		"onvillage.com",
		"oopi.org",
		"operafan.com",
		"operamail.com",
		"optician.com",
		"optician.net",
		"optimum.net",
		"optonline.net",
		"optusnet.com.au",
		"orange.fr",
		"orbitel.bg",
		"orgmail.net",
		"orthodontist.net",
		"osite.com.br",
		"oso.com",
		"otakumail.com",
		"our-computer.com",
		"our-office.com",
		"our.st",
		"ourbrisbane.com",
		"ourklips.com",
		"ournet.md",
		"outel.com",
		"outgun.com",
		"outlook.at",
		"outlook.be",
		"outlook.cl",
		"outlook.co.id",
		"outlook.co.il",
		"outlook.co.nz",
		"outlook.co.th",
		"outlook.com",
		"outlook.com.ar",
		"outlook.com.au",
		"outlook.com.br",
		"outlook.com.gr",
		"outlook.com.pe",
		"outlook.com.tr",
		"outlook.com.vn",
		"outlook.cz",
		"outlook.de",
		"outlook.dk",
		"outlook.es",
		"outlook.fr",
		"outlook.hu",
		"outlook.ie",
		"outlook.in",
		"outlook.it",
		"outlook.jp",
		"outlook.kr",
		"outlook.lv",
		"outlook.my",
		"outlook.ph",
		"outlook.pt",
		"outlook.sa",
		"outlook.sg",
		"outlook.sk",
		"over-the-rainbow.com",
		"ownmail.net",
		"ozbytes.net.au",
		"ozemail.com.au",
		"pacbell.net",
		"pacific-ocean.com",
		"pacific-re.com",
		"pacificwest.com",
		"packersfan.com",
		"pagina.de",
		"pagons.org",
		"pakistanoye.com",
		"palestinemail.com",
		"pancakemail.com",
		"papa.email.ne.jp",
		"parkjiyoon.com",
		"parrot.com",
		"parsmail.com",
		"partlycloudy.com",
		"partynight.at",
		"parvazi.com",
		"passwordmail.com",
		"pathfindermail.com",
		"pconnections.net",
		"pcpostal.com",
		"pcsrock.com",
		"peachworld.com",
		"pediatrician.com",
		"pemail.net",
		"penpen.com",
		"peoplepc.com",
		"peopleweb.com",
		"perfectmail.com",
		"personal.ro",
		"personales.com",
		"petlover.com",
		"petml.com",
		"pettypool.com",
		"pezeshkpour.com",
		"phayze.com",
		"photographer.net",
		"phreaker.net",
		"physicist.net",
		"pickupman.com",
		"picusnet.com",
		"pigpig.net",
		"pimpedupmyspace.com",
		"pinoymail.com",
		"piracha.net",
		"pisem.net",
		"planet-mail.com",
		"planetaccess.com",
		"planetall.com",
		"planetarymotion.net",
		"planetdirect.com",
		"planetearthinter.net",
		"planetmail.com",
		"planetmail.net",
		"planetout.com",
		"plasa.com",
		"playersodds.com",
		"playful.com",
		"plusmail.com.br",
		"pmail.net",
		"pobox.hu",
		"pobox.sk",
		"pochta.ru",
		"poczta.fm",
		"poetic.com",
		"polandmail.com",
		"polbox.com",
		"policeoffice.com",
		"politician.com",
		"pookmail.com",
		"pool-sharks.com",
		"poond.com",
		"popaccount.com",
		"popmail.com",
		"popsmail.com",
		"popstar.com",
		"populus.net",
		"portableoffice.com",
		"portugalmail.com",
		"portugalmail.pt",
		"portugalnet.com",
		"positive-thinking.com",
		"post.com",
		"post.cz",
		"post.sk",
		"posta.net",
		"posta.ro",
		"postaccesslite.com",
		"postafree.com",
		"postaweb.com",
		"postinbox.com",
		"postino.ch",
		"postmark.net",
		"postmaster.co.uk",
		"postpro.net",
		"pousa.com",
		"powerfan.com",
		"praize.com",
		"premiumservice.com",
		"presidency.com",
		"press.co.jp",
		"priest.com",
		"primposta.com",
		"primposta.hu",
		"pro.hu",
		"probemail.com",
		"prodigy.net",
		"progetplus.it",
		"programmer.net",
		"programozo.hu",
		"proinbox.com",
		"project2k.com",
		"prolaunch.com",
		"promessage.com",
		"prontomail.com",
		"protestant.com",
		"proxymail.eu",
		"psv-supporter.com",
		"ptd.net",
		"public.usa.com",
		"publicist.com",
		"pulp-fiction.com",
		"punkass.com",
		"q.com",
		"qatarmail.com",
		"qprfans.com",
		"qq.com",
		"qrio.com",
		"quackquack.com",
		"quakemail.com",
		"qualityservice.com",
		"qudsmail.com",
		"quepasa.com",
		"quickwebmail.com",
		"quiklinks.com",
		"quikmail.com",
		"qwest.net",
		"qwestoffice.net",
		"r-o-o-t.com",
		"raakim.com",
		"racedriver.com",
		"racefanz.com",
		"racingfan.com.au",
		"racingmail.com",
		"radicalz.com",
		"radiologist.net",
		"ragingbull.com",
		"ramail.co.uk",
		"rambler.ru",
		"ranmamail.com",
		"rastogi.net",
		"ratt-n-roll.com",
		"rattle-snake.com",
		"ravearena.com",
		"ravemail.co.za",
		"ravemail.com",
		"razormail.com",
		"rccgmail.org",
		"rcn.com",
		"rcpt.at",
		"reagan.com",
		"realemail.net",
		"reallyfast.biz",
		"realradiomail.com",
		"realtyagent.com",
		"reborn.com",
		"recyclemail.dk",
		"recycler.com",
		"rediffmail.com",
		"rediffmailpro.com",
		"rednecks.com",
		"redseven.de",
		"redsfans.com",
		"reggaefan.com",
		"reggafan.com",
		"registerednurses.com",
		"reincarnate.com",
		"rejectmail.com",
		"religious.com",
		"repairman.com",
		"reply.hu",
		"representative.com",
		"rescueteam.com",
		"resumemail.com",
		"revenue.com",
		"rezai.com",
		"richmondhill.com",
		"rickymail.com",
		"rin.ru",
		"riopreto.com.br",
		"rklips.com",
		"rn.com",
		"roadrunner.com",
		"roanokemail.com",
		"rochester.rr.com",
		"rock.com",
		"rocketmail.com",
		"rocketship.com",
		"rockfan.com",
		"rodrun.com",
		"rogers.com",
		"rome.com",
		"roosh.com",
		"rotfl.com",
		"roughnet.com",
		"rr.com",
		"rrohio.com",
		"rstarmail.com",
		"rsub.com",
		"rubyridge.com",
		"runbox.com",
		"rushpost.com",
		"ruttolibero.com",
		"rvshop.com",
		"s-mail.com",
		"sabreshockey.com",
		"sacbeemail.com",
		"safarimail.com",
		"safe-mail.net",
		"safrica.com",
		"sagra.lu",
		"sailormoon.com",
		"saintly.com",
		"saintmail.net",
		"saitama.email.ne.jp",
		"sale-sale-sale.com",
		"salehi.net",
		"salesperson.net",
		"samerica.com",
		"samilan.net",
		"sammimail.com",
		"san.rr.com",
		"sanfranmail.com",
		"sanook.com",
		"sapo.pt",
		"sativa.ro.org",
		"satx.rr.com",
		"saudia.com",
		"sayhi.net",
		"sbcglobal.net",
		"sc.rr.com",
		"scandalmail.com",
		"schizo.com",
		"schoolemail.com",
		"schoolmail.com",
		"schoolsucks.com",
		"schweiz.org",
		"sci.fi",
		"science.com.au",
		"scientist.com",
		"scifianime.com",
		"scotlandmail.com",
		"scottishmail.co.uk",
		"scubadiving.com",
		"seanet.com",
		"searchwales.com",
		"sebil.com",
		"secret-police.com",
		"secretary.net",
		"secretservices.net",
		"seductive.com",
		"seekstoyboy.com",
		"seguros.com.br",
		"send.hu",
		"sendme.cz",
		"sent.com",
		"sentrismail.com",
		"serga.com.ar",
		"servemymail.com",
		"sesmail.com",
		"sexmagnet.com",
		"seznam.cz",
		"sfr.fr",
		"shahweb.net",
		"shaniastuff.com",
		"sharewaredevelopers.com",
		"sharklasers.com",
		"sharmaweb.com",
		"shaw.ca",
		"she.com",
		"shootmail.com",
		"shortmail.me",
		"shortmail.net",
		"shotgun.hu",
		"shuf.com",
		"sialkotcity.com",
		"sialkotian.com",
		"sialkotoye.com",
		"sify.com",
		"silkroad.net",
		"sina.cn",
		"sina.com",
		"sinamail.com",
		"singapore.com",
		"singmail.com",
		"singnet.com.sg",
		"singpost.com",
		"skafan.com",
		"skim.com",
		"skizo.hu",
		"sky.com",
		"slamdunkfan.com",
		"slingshot.com",
		"slo.net",
		"slotter.com",
		"smapxsmap.net",
		"smileyface.comsmithemail.net",
		"smoothmail.com",
		"snail-mail.net",
		"snail-mail.ney",
		"snakebite.com",
		"snakemail.com",
		"sndt.net",
		"sneakemail.com",
		"snet.net",
		"sniper.hu",
		"snoopymail.com",
		"snowboarding.com",
		"snowdonia.net",
		"socal.rr.com",
		"socamail.com",
		"socceramerica.net",
		"soccermail.com",
		"soccermomz.com",
		"socialworker.net",
		"sociologist.com",
		"sofort-mail.de",
		"softbank.ne.jp",
		"softhome.net",
		"sogetthis.com",
		"sol.dk",
		"soldier.hu",
		"solution4u.com",
		"songwriter.net",
		"soon.com",
		"soulfoodcookbook.com",
		"sp.nl",
		"space-bank.com",
		"space-man.com",
		"space-ship.com",
		"space-travel.com",
		"space.com",
		"spaceart.com",
		"spacebank.com",
		"spacemart.com",
		"spacetowns.com",
		"spacewar.com",
		"spainmail.com",
		"spam.la",
		"spamavert.com",
		"spambob.com",
		"spambog.com",
		"spambox.us",
		"spamex.com",
		"spamfree24.com",
		"spamfree24.net",
		"spamfree24.org",
		"spaml.com",
		"spartapiet.com",
		"spazmail.com",
		"speedemail.net",
		"speedpost.net",
		"speedrules.com",
		"speedrulz.com",
		"spils.com",
		"spinfinder.com",
		"sportemail.com",
		"sportsmail.com",
		"sporttruckdriver.com",
		"spray.no",
		"spray.se",
		"spymac.com",
		"srilankan.net",
		"st-davids.net",
		"stade.fr",
		"stalag13.com",
		"stargateradio.com",
		"starmail.co.za",
		"starmail.com",
		"starmail.org",
		"starmedia.com",
		"starplace.com",
		"starspath.com",
		"start.com.au",
		"starting-point.com",
		"startrekmail.com",
		"stealthmail.com",
		"stevesmusclecars.arcoxmail.com",
		"stny.rr.com",
		"stockracer.com",
		"stones.com",
		"stopdropandroll.com",
		"storksite.com",
		"stribmail.com",
		"strompost.com",
		"strongguy.com",
		"studentcenter.org",
		"stx.rr.com",
		"subnetwork.com",
		"subram.com",
		"sudanmail.net",
		"suddenlinkmail.com",
		"suhabi.com",
		"suisse.org",
		"sukhumvit.net",
		"sullivanemail.net",
		"sunpoint.net",
		"sunrise-sunset.com",
		"sunsgame.com",
		"sunumail.sn",
		"superdada.com",
		"supereva.it",
		"supermail.ru",
		"surat.com",
		"surf3.net",
		"surfree.com",
		"surfy.net",
		"surgical.net",
		"surimail.com",
		"survivormail.com",
		"swbell.net",
		"sweb.cz",
		"swedenmail.com",
		"swiftdesk.com",
		"swingeasyhithard.com",
		"swingfan.com",
		"swipermail.zzn.com",
		"swirve.com",
		"swissinfo.org",
		"swissmail.com",
		"swissmail.net",
		"switchboardmail.com",
		"switzerland.org",
		"sx172.com",
		"sympatico.ca",
		"syom.com",
		"syriamail.com",
		"t-online.de",
		"t-online.hu",
		"t2mail.com",
		"takuyakimura.com",
		"talk21.com",
		"talkcity.com",
		"talktalk.net",
		"tamil.com",
		"tampabay.rr.com",
		"tatanova.com",
		"tbwt.com",
		"tds.net",
		"teachers.org",
		"teamdiscovery.com",
		"teamtulsa.net",
		"tech-center.com",
		"tech4peace.org",
		"techemail.com",
		"techie.com",
		"technisamail.co.za",
		"technologist.com",
		"techpointer.com",
		"techscout.com",
		"techseek.com",
		"techspot.com",
		"teenagedirtbag.com",
		"telebot.com",
		"telebot.net",
		"teleline.es",
		"telerymd.com",
		"teleserve.dynip.com",
		"telinco.net",
		"telkom.net",
		"telpage.net",
		"telstra.com",
		"telus.net",
		"tempemail.net",
		"tempinbox.com",
		"tempomail.fr",
		"temporaryinbox.com",
		"temtulsa.net",
		"tenchiclub.com",
		"tenderkiss.com",
		"tennismail.com",
		"terra.cl",
		"terra.com",
		"terra.com.ar",
		"terra.com.br",
		"terra.es",
		"tfanus.com.er",
		"tfz.net",
		"thai.com",
		"thaimail.com",
		"thaimail.net",
		"thankyou2010.com",
		"the-african.com",
		"the-airforce.com",
		"the-aliens.com",
		"the-american.com",
		"the-animal.com",
		"the-army.com",
		"the-astronaut.com",
		"the-beauty.com",
		"the-big-apple.com",
		"the-biker.com",
		"the-boss.com",
		"the-brazilian.com",
		"the-canadian.com",
		"the-canuck.com",
		"the-captain.com",
		"the-chinese.com",
		"the-country.com",
		"the-cowboy.com",
		"the-davis-home.com",
		"the-dutchman.com",
		"the-eagles.com",
		"the-englishman.com",
		"the-fastest.net",
		"the-fool.com",
		"the-frenchman.com",
		"the-galaxy.net",
		"the-genius.com",
		"the-gentleman.com",
		"the-german.com",
		"the-gremlin.com",
		"the-hooligan.com",
		"the-italian.com",
		"the-japanese.com",
		"the-lair.com",
		"the-madman.com",
		"the-mailinglist.com",
		"the-marine.com",
		"the-master.com",
		"the-mexican.com",
		"the-ministry.com",
		"the-monkey.com",
		"the-newsletter.net",
		"the-pentagon.com",
		"the-police.com",
		"the-prayer.com",
		"the-professional.com",
		"the-quickest.com",
		"the-russian.com",
		"the-snake.com",
		"the-spaceman.com",
		"the-stock-market.com",
		"the-student.net",
		"the-whitehouse.net",
		"the-wild-west.com",
		"the18th.com",
		"thecoolguy.com",
		"thecricket.co.za",
		"thecriminals.com",
		"thedoghousemail.com",
		"thedorm.com",
		"theend.hu",
		"theglobe.com",
		"thegolf.co.za",
		"thegolfcourse.com",
		"thegooner.com",
		"theheadoffice.com",
		"thelanddownunder.com",
		"themillionare.net",
		"theoffice.net",
		"theplate.com",
		"thepokerface.com",
		"thepostmaster.net",
		"thepub.co.za",
		"theraces.com",
		"theracetrack.com",
		"therapist.net",
		"therugby.co.za",
		"thestreetfighter.com",
		"theteebox.com",
		"thewatercooler.com",
		"thewebpros.co.uk",
		"thewizzard.com",
		"thewizzkid.com",
		"thezhangs.net",
		"thirdage.com",
		"thisgirl.com",
		"thisisnotmyrealemail.com",
		"thoic.com",
		"thundermail.com",
		"tidni.com",
		"timein.net",
		"tiscali.at",
		"tiscali.be",
		"tiscali.co.uk",
		"tiscali.it",
		"tiscali.lu",
		"tiscali.se",
		"tkcity.com",
		"toke.com",
		"tokyo.com",
		"tom.com",
		"toolsource.com",
		"toothfairy.com",
		"topchat.com",
		"topgamers.co.uk",
		"topletter.com",
		"topmail.com.ar",
		"topsurf.com",
		"topteam.bg",
		"torchmail.com",
		"torontomail.com",
		"totalmusic.net",
		"toughguy.net",
		"tpg.com.au",
		"trash-mail.at",
		"trash-mail.de",
		"trash2009.com",
		"trashdevil.com",
		"trashdevil.de",
		"trashmail.at",
		"trashmail.me",
		"trashmail.net",
		"trashymail.com",
		"travel.li",
		"triad.rr.com",
		"trialbytrivia.com",
		"tritium.net",
		"trmailbox.com",
		"tropicalstorm.com",
		"truckers.com",
		"truckerz.com",
		"truckracer.com",
		"trust-me.com",
		"tsamail.co.za",
		"ttml.co.in",
		"tunisiamail.com",
		"turkey.com",
		"turual.com",
		"tvstar.com",
		"twc.com",
		"twcny.rr.com",
		"twinmail.de",
		"twinstarsmail.com",
		"tx.rr.com",
		"tycoonmail.com",
		"typemail.com",
		"u2club.com",
		"uae.ac",
		"uaemail.com",
		"ubbi.com",
		"ubbi.com.br",
		"uboot.com",
		"uk2k.com",
		"uk2net.com",
		"uk7.net",
		"uk8.net",
		"ukbuilder.com",
		"ukcool.com",
		"ukdreamcast.com",
		"ukmail.com",
		"ukmail.org",
		"ukmax.com",
		"ukr.net",
		"uku.co.uk",
		"ultapulta.com",
		"ultrapostman.com",
		"ummah.org",
		"umpire.com",
		"unbounded.com",
		"unforgettable.com",
		"uni.de",
		"unican.es",
		"unihome.com",
		"universal.pt",
		"uno.ee",
		"uno.it",
		"unofree.it",
		"unomail.com",
		"uol.com.ar",
		"uol.com.br",
		"uol.com.co",
		"uol.com.mx",
		"uol.com.ve",
		"uole.com",
		"uole.com.ve",
		"uolmail.com",
		"uomail.com",
		"upcmail.ie",
		"upf.org",
		"upliftnow.com",
		"uplipht.com",
		"urbismail.com",
		"ureach.com",
		"urgentmail.biz",
		"usa.com",
		"usa.net",
		"usaaccess.net",
		"usanetmail.com",
		"usermail.com",
		"usma.net",
		"usmc.net",
		"uswestmail.net",
		"uymail.com",
		"uyuyuy.com",
		"v-sexi.com",
		"vahoo.com",
		"valuemailers.com",
		"varbizmail.com",
		"vcmail.com",
		"velnet.co.uk",
		"velocall.com",
		"verizon.net",
		"verizonmail.com",
		"veryfast.biz",
		"veryspeedy.net",
		"vfemail.net",
		"videotron.ca",
		"viditag.com",
		"viewcastmedia.com",
		"viewcastmedia.net",
		"viewcastmedia.org",
		"violinmakers.co.uk",
		"vip.gr",
		"vip.qq.com",
		"vip.sina.com",
		"vipmail.ru",
		"virgilio.it",
		"virgin.net",
		"virginmedia.co.uk",
		"virginmedia.com",
		"virtualactive.com",
		"virtualmail.com",
		"visitmail.com",
		"visitweb.com",
		"visto.com",
		"visualcities.com",
		"vivavelocity.com",
		"vivianhsu.net",
		"vjmail.com",
		"vjtimail.com",
		"vlmail.com",
		"vmail.co.il",
		"vnn.vn",
		"voila.fr",
		"volcanomail.com",
		"vote-democrats.com",
		"vote-hillary.com",
		"vote-republicans.com",
		"vote4gop.org",
		"votenet.com",
		"vr9.com",
		"vuemail.com",
		"w3.to",
		"wahoye.com",
		"wales2000.net",
		"walla.co.il",
		"walla.com",
		"wam.co.za",
		"wamail.net",
		"wanadoo.es",
		"wanadoo.fr",
		"warmmail.com",
		"warpmail.net",
		"warrior.hu",
		"wasimismail.com",
		"waumail.com",
		"wbdet.com",
		"wearab.net",
		"web-mail.com.ar",
		"web-mail.de",
		"web-police.com",
		"web.de",
		"webave.com",
		"webcammail.com",
		"webcity.ca",
		"webdream.com",
		"webinbox.com",
		"webindia123.com",
		"webjump.com",
		"webmail.bellsouth.net",
		"webmail.co.yu",
		"webmail.co.za",
		"webmail.hu",
		"webmails.com",
		"webname.com",
		"webprogramming.com",
		"websecuremail.com",
		"webstation.com",
		"websurfer.co.za",
		"webtopmail.com",
		"weedmail.com",
		"weekmail.com",
		"weekonline.com",
		"wegwerfmail.de",
		"wegwerfmail.net",
		"wegwerfmail.org",
		"wehshee.com",
		"welsh-lady.com",
		"westnet.com.au",
		"wetrainbayarea.com",
		"wetrainbayarea.org",
		"whale-mail.com",
		"whartontx.com",
		"wheelweb.com",
		"whipmail.com",
		"whoever.com",
		"whoopymail.com",
		"whopy.com",
		"whyspam.me",
		"wi.rr.com",
		"wickedmail.com",
		"wideopenwest.com",
		"wildblue.net",
		"wildmail.com",
		"wilemail.com",
		"willselfdestruct.com",
		"windowslive.com",
		"windrivers.net",
		"windstream.net",
		"wingnutz.com",
		"winmail.com.au",
		"winning.com",
		"witty.com",
		"wiz.cc",
		"wkbwmail.com",
		"woh.rr.com",
		"wolf-web.com",
		"wombles.com",
		"wonder-net.com",
		"wongfaye.com",
		"wooow.it",
		"worker.com",
		"workmail.co.za",
		"workmail.com",
		"worldemail.com",
		"worldmailer.com",
		"worldnet.att.net",
		"wosaddict.com",
		"wouldilie.com",
		"wowgirl.com",
		"wowmail.com",
		"wowway.com",
		"wp.pl",
		"wptamail.com",
		"wrestlingpages.com",
		"wrexham.net",
		"writeme.com",
		"writemeback.com",
		"wrongmail.com",
		"wtvhmail.com",
		"wwdg.com",
		"www.com",
		"www2000.net",
		"wx88.net",
		"wxs.net",
		"wyrm.supernews.com",
		"x-mail.net",
		"x-networks.net",
		"x5g.com",
		"xagloo.com",
		"xmastime.com",
		"xmsg.com",
		"xoom.com",
		"xoommail.com",
		"xpressmail.zzn.com",
		"xsmail.com",
		"xtra.co.nz",
		"xuno.com",
		"xzapmail.com",
		"y.email.ne.jp",
		"y7mail.com",
		"ya.ru",
		"yada-yada.com",
		"yaho.com",
		"yahoo.ca",
		"yahoo.cn",
		"yahoo.co.id",
		"yahoo.co.in",
		"yahoo.co.jp",
		"yahoo.co.kr",
		"yahoo.co.nz",
		"yahoo.co.th",
		"yahoo.co.uk",
		"yahoo.com",
		"yahoo.com.ar",
		"yahoo.com.asia",
		"yahoo.com.au",
		"yahoo.com.br",
		"yahoo.com.cn",
		"yahoo.com.es",
		"yahoo.com.hk",
		"yahoo.com.is",
		"yahoo.com.malaysia",
		"yahoo.com.mx",
		"yahoo.com.my",
		"yahoo.com.ph",
		"yahoo.com.ru",
		"yahoo.com.sg",
		"yahoo.com.tw",
		"yahoo.com.vn",
		"yahoo.de",
		"yahoo.dk",
		"yahoo.es",
		"yahoo.fr",
		"yahoo.gr",
		"yahoo.ie",
		"yahoo.in",
		"yahoo.it",
		"yahoo.jp",
		"yahoo.om",
		"yahoo.ro",
		"yahoo.ru",
		"yahoo.se",
		"yahoofs.com",
		"yalla.com",
		"yalla.com.lb",
		"yalook.com",
		"yam.com",
		"yandex.com",
		"yandex.ru",
		"yapost.com",
		"yawmail.com",
		"ybb.ne.jp",
		"yclub.com",
		"yeah.net",
		"yebox.com",
		"yehaa.com",
		"yehey.com",
		"yemenmail.com",
		"yepmail.net",
		"yesbox.net",
		"yifan.net",
		"ymail.com",
		"ynnmail.com",
		"yogotemail.com",
		"yopmail.com",
		"yopolis.com",
		"youareadork.com",
		"youpy.com",
		"your-house.com",
		"yourinbox.com",
		"yourlover.net",
		"yourname.ddns.org",
		"yourname.freeservers.com",
		"yournightmare.com",
		"yours.com",
		"yourssincerely.com",
		"yoursubdomain.findhere.com",
		"yoursubdomain.zzn.com",
		"yourteacher.net",
		"yourwap.com",
		"youvegotmail.net",
		"yuuhuu.net",
		"yyhmail.com",
		"zahadum.com",
		"zahav.net.il",
		"zcities.com",
		"zdnetmail.com",
		"zeeks.com",
		"zeepost.nl",
		"zensearch.net",
		"zhaowei.net",
		"zionweb.org",
		"zip.net",
		"zipido.com",
		"ziplip.com",
		"zipmail.com",
		"zipmail.com.br",
		"zipmax.com",
		"zmail.ru",
		"zoho.com",
		"zonnet.nl",
		"zoominternet.net",
		"zubee.com",
		"zuvio.com",
		"zuzzurello.com",
		"zwallet.com",
		"zybermail.com",
		"zydecofan.com",
		"zzn.com",
		"zzom.co.uk"
	];

/***/ },
/* 2950 */
/***/ function(module, exports) {

	module.exports = {
		"_args": [
			[
				"websocket@1.0.22",
				"/home/circleci/repo"
			]
		],
		"_from": "websocket@1.0.22",
		"_id": "websocket@1.0.22",
		"_inBundle": false,
		"_integrity": "sha1-jDPjRJ+Hmq9RgpfJdEzr+BK549g=",
		"_location": "/websocket",
		"_phantomChildren": {},
		"_requested": {
			"type": "version",
			"registry": true,
			"raw": "websocket@1.0.22",
			"name": "websocket",
			"escapedName": "websocket",
			"rawSpec": "1.0.22",
			"saveSpec": null,
			"fetchSpec": "1.0.22"
		},
		"_requiredBy": [
			"/sendbird"
		],
		"_resolved": "https://registry.npmjs.org/websocket/-/websocket-1.0.22.tgz",
		"_spec": "1.0.22",
		"_where": "/home/circleci/repo",
		"author": {
			"name": "Brian McKelvey",
			"email": "brian@worlize.com",
			"url": "https://www.worlize.com/"
		},
		"browser": "lib/browser.js",
		"bugs": {
			"url": "https://github.com/theturtle32/WebSocket-Node/issues"
		},
		"config": {
			"verbose": false
		},
		"contributors": [
			{
				"name": "Iñaki Baz Castillo",
				"email": "ibc@aliax.net",
				"url": "http://dev.sipdoc.net"
			}
		],
		"dependencies": {
			"debug": "~2.2.0",
			"nan": "~2.0.5",
			"typedarray-to-buffer": "~3.0.3",
			"yaeti": "~0.0.4"
		},
		"description": "Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.",
		"devDependencies": {
			"buffer-equal": "^0.0.1",
			"faucet": "^0.0.1",
			"gulp": "git+https://github.com/gulpjs/gulp.git#4.0",
			"gulp-jshint": "^1.11.2",
			"jshint-stylish": "^1.0.2",
			"tape": "^4.0.1"
		},
		"directories": {
			"lib": "./lib"
		},
		"engines": {
			"node": ">=0.8.0"
		},
		"homepage": "https://github.com/theturtle32/WebSocket-Node",
		"keywords": [
			"websocket",
			"websockets",
			"socket",
			"networking",
			"comet",
			"push",
			"RFC-6455",
			"realtime",
			"server",
			"client"
		],
		"license": "Apache-2.0",
		"main": "index",
		"name": "websocket",
		"repository": {
			"type": "git",
			"url": "git+https://github.com/theturtle32/WebSocket-Node.git"
		},
		"scripts": {
			"gulp": "gulp",
			"install": "(node-gyp rebuild 2> builderror.log) || (exit 0)",
			"test": "faucet test/unit"
		},
		"version": "1.0.22"
	};

/***/ },
/* 2951 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  decode: __webpack_require__(1290),
	  verify: __webpack_require__(2954),
	  sign: __webpack_require__(2953),
	  JsonWebTokenError: __webpack_require__(422),
	  NotBeforeError: __webpack_require__(1291),
	  TokenExpiredError: __webpack_require__(1292),
	};


/***/ },
/* 2952 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var w = d * 7;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isFinite(val)) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'weeks':
	    case 'week':
	    case 'w':
	      return n * w;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (msAbs >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (msAbs >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (msAbs >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return plural(ms, msAbs, d, 'day');
	  }
	  if (msAbs >= h) {
	    return plural(ms, msAbs, h, 'hour');
	  }
	  if (msAbs >= m) {
	    return plural(ms, msAbs, m, 'minute');
	  }
	  if (msAbs >= s) {
	    return plural(ms, msAbs, s, 'second');
	  }
	  return ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, msAbs, n, name) {
	  var isPlural = msAbs >= n * 1.5;
	  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
	}


/***/ },
/* 2953 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var timespan = __webpack_require__(1294);
	var PS_SUPPORTED = __webpack_require__(1293);
	var jws = __webpack_require__(676);
	var includes = __webpack_require__(2975);
	var isBoolean = __webpack_require__(2976);
	var isInteger = __webpack_require__(2978);
	var isNumber = __webpack_require__(2979);
	var isPlainObject = __webpack_require__(2980);
	var isString = __webpack_require__(2981);
	var once = __webpack_require__(2982);
	
	var SUPPORTED_ALGS = ['RS256', 'RS384', 'RS512', 'ES256', 'ES384', 'ES512', 'HS256', 'HS384', 'HS512', 'none']
	if (PS_SUPPORTED) {
	  SUPPORTED_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
	}
	
	var sign_options_schema = {
	  expiresIn: { isValid: function(value) { return isInteger(value) || (isString(value) && value); }, message: '"expiresIn" should be a number of seconds or string representing a timespan' },
	  notBefore: { isValid: function(value) { return isInteger(value) || (isString(value) && value); }, message: '"notBefore" should be a number of seconds or string representing a timespan' },
	  audience: { isValid: function(value) { return isString(value) || Array.isArray(value); }, message: '"audience" must be a string or array' },
	  algorithm: { isValid: includes.bind(null, SUPPORTED_ALGS), message: '"algorithm" must be a valid string enum value' },
	  header: { isValid: isPlainObject, message: '"header" must be an object' },
	  encoding: { isValid: isString, message: '"encoding" must be a string' },
	  issuer: { isValid: isString, message: '"issuer" must be a string' },
	  subject: { isValid: isString, message: '"subject" must be a string' },
	  jwtid: { isValid: isString, message: '"jwtid" must be a string' },
	  noTimestamp: { isValid: isBoolean, message: '"noTimestamp" must be a boolean' },
	  keyid: { isValid: isString, message: '"keyid" must be a string' },
	  mutatePayload: { isValid: isBoolean, message: '"mutatePayload" must be a boolean' }
	};
	
	var registered_claims_schema = {
	  iat: { isValid: isNumber, message: '"iat" should be a number of seconds' },
	  exp: { isValid: isNumber, message: '"exp" should be a number of seconds' },
	  nbf: { isValid: isNumber, message: '"nbf" should be a number of seconds' }
	};
	
	function validate(schema, allowUnknown, object, parameterName) {
	  if (!isPlainObject(object)) {
	    throw new Error('Expected "' + parameterName + '" to be a plain object.');
	  }
	  Object.keys(object)
	    .forEach(function(key) {
	      var validator = schema[key];
	      if (!validator) {
	        if (!allowUnknown) {
	          throw new Error('"' + key + '" is not allowed in "' + parameterName + '"');
	        }
	        return;
	      }
	      if (!validator.isValid(object[key])) {
	        throw new Error(validator.message);
	      }
	    });
	}
	
	function validateOptions(options) {
	  return validate(sign_options_schema, false, options, 'options');
	}
	
	function validatePayload(payload) {
	  return validate(registered_claims_schema, true, payload, 'payload');
	}
	
	var options_to_payload = {
	  'audience': 'aud',
	  'issuer': 'iss',
	  'subject': 'sub',
	  'jwtid': 'jti'
	};
	
	var options_for_objects = [
	  'expiresIn',
	  'notBefore',
	  'noTimestamp',
	  'audience',
	  'issuer',
	  'subject',
	  'jwtid',
	];
	
	module.exports = function (payload, secretOrPrivateKey, options, callback) {
	  if (typeof options === 'function') {
	    callback = options;
	    options = {};
	  } else {
	    options = options || {};
	  }
	
	  var isObjectPayload = typeof payload === 'object' &&
	                        !Buffer.isBuffer(payload);
	
	  var header = Object.assign({
	    alg: options.algorithm || 'HS256',
	    typ: isObjectPayload ? 'JWT' : undefined,
	    kid: options.keyid
	  }, options.header);
	
	  function failure(err) {
	    if (callback) {
	      return callback(err);
	    }
	    throw err;
	  }
	
	  if (!secretOrPrivateKey && options.algorithm !== 'none') {
	    return failure(new Error('secretOrPrivateKey must have a value'));
	  }
	
	  if (typeof payload === 'undefined') {
	    return failure(new Error('payload is required'));
	  } else if (isObjectPayload) {
	    try {
	      validatePayload(payload);
	    }
	    catch (error) {
	      return failure(error);
	    }
	    if (!options.mutatePayload) {
	      payload = Object.assign({},payload);
	    }
	  } else {
	    var invalid_options = options_for_objects.filter(function (opt) {
	      return typeof options[opt] !== 'undefined';
	    });
	
	    if (invalid_options.length > 0) {
	      return failure(new Error('invalid ' + invalid_options.join(',') + ' option for ' + (typeof payload ) + ' payload'));
	    }
	  }
	
	  if (typeof payload.exp !== 'undefined' && typeof options.expiresIn !== 'undefined') {
	    return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
	  }
	
	  if (typeof payload.nbf !== 'undefined' && typeof options.notBefore !== 'undefined') {
	    return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
	  }
	
	  try {
	    validateOptions(options);
	  }
	  catch (error) {
	    return failure(error);
	  }
	
	  var timestamp = payload.iat || Math.floor(Date.now() / 1000);
	
	  if (options.noTimestamp) {
	    delete payload.iat;
	  } else if (isObjectPayload) {
	    payload.iat = timestamp;
	  }
	
	  if (typeof options.notBefore !== 'undefined') {
	    try {
	      payload.nbf = timespan(options.notBefore, timestamp);
	    }
	    catch (err) {
	      return failure(err);
	    }
	    if (typeof payload.nbf === 'undefined') {
	      return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
	    }
	  }
	
	  if (typeof options.expiresIn !== 'undefined' && typeof payload === 'object') {
	    try {
	      payload.exp = timespan(options.expiresIn, timestamp);
	    }
	    catch (err) {
	      return failure(err);
	    }
	    if (typeof payload.exp === 'undefined') {
	      return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
	    }
	  }
	
	  Object.keys(options_to_payload).forEach(function (key) {
	    var claim = options_to_payload[key];
	    if (typeof options[key] !== 'undefined') {
	      if (typeof payload[claim] !== 'undefined') {
	        return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
	      }
	      payload[claim] = options[key];
	    }
	  });
	
	  var encoding = options.encoding || 'utf8';
	
	  if (typeof callback === 'function') {
	    callback = callback && once(callback);
	
	    jws.createSign({
	      header: header,
	      privateKey: secretOrPrivateKey,
	      payload: payload,
	      encoding: encoding
	    }).once('error', callback)
	      .once('done', function (signature) {
	        callback(null, signature);
	      });
	  } else {
	    return jws.sign({header: header, payload: payload, secret: secretOrPrivateKey, encoding: encoding});
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58).Buffer))

/***/ },
/* 2954 */
/***/ function(module, exports, __webpack_require__) {

	var JsonWebTokenError = __webpack_require__(422);
	var NotBeforeError    = __webpack_require__(1291);
	var TokenExpiredError = __webpack_require__(1292);
	var decode            = __webpack_require__(1290);
	var timespan          = __webpack_require__(1294);
	var PS_SUPPORTED      = __webpack_require__(1293);
	var jws               = __webpack_require__(676);
	
	var PUB_KEY_ALGS = ['RS256', 'RS384', 'RS512', 'ES256', 'ES384', 'ES512'];
	var RSA_KEY_ALGS = ['RS256', 'RS384', 'RS512'];
	var HS_ALGS = ['HS256', 'HS384', 'HS512'];
	
	if (PS_SUPPORTED) {
	  PUB_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
	  RSA_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
	}
	
	module.exports = function (jwtString, secretOrPublicKey, options, callback) {
	  if ((typeof options === 'function') && !callback) {
	    callback = options;
	    options = {};
	  }
	
	  if (!options) {
	    options = {};
	  }
	
	  //clone this object since we are going to mutate it.
	  options = Object.assign({}, options);
	
	  var done;
	
	  if (callback) {
	    done = callback;
	  } else {
	    done = function(err, data) {
	      if (err) throw err;
	      return data;
	    };
	  }
	
	  if (options.clockTimestamp && typeof options.clockTimestamp !== 'number') {
	    return done(new JsonWebTokenError('clockTimestamp must be a number'));
	  }
	
	  if (options.nonce !== undefined && (typeof options.nonce !== 'string' || options.nonce.trim() === '')) {
	    return done(new JsonWebTokenError('nonce must be a non-empty string'));
	  }
	
	  var clockTimestamp = options.clockTimestamp || Math.floor(Date.now() / 1000);
	
	  if (!jwtString){
	    return done(new JsonWebTokenError('jwt must be provided'));
	  }
	
	  if (typeof jwtString !== 'string') {
	    return done(new JsonWebTokenError('jwt must be a string'));
	  }
	
	  var parts = jwtString.split('.');
	
	  if (parts.length !== 3){
	    return done(new JsonWebTokenError('jwt malformed'));
	  }
	
	  var decodedToken;
	
	  try {
	    decodedToken = decode(jwtString, { complete: true });
	  } catch(err) {
	    return done(err);
	  }
	
	  if (!decodedToken) {
	    return done(new JsonWebTokenError('invalid token'));
	  }
	
	  var header = decodedToken.header;
	  var getSecret;
	
	  if(typeof secretOrPublicKey === 'function') {
	    if(!callback) {
	      return done(new JsonWebTokenError('verify must be called asynchronous if secret or public key is provided as a callback'));
	    }
	
	    getSecret = secretOrPublicKey;
	  }
	  else {
	    getSecret = function(header, secretCallback) {
	      return secretCallback(null, secretOrPublicKey);
	    };
	  }
	
	  return getSecret(header, function(err, secretOrPublicKey) {
	    if(err) {
	      return done(new JsonWebTokenError('error in secret or public key callback: ' + err.message));
	    }
	
	    var hasSignature = parts[2].trim() !== '';
	
	    if (!hasSignature && secretOrPublicKey){
	      return done(new JsonWebTokenError('jwt signature is required'));
	    }
	
	    if (hasSignature && !secretOrPublicKey) {
	      return done(new JsonWebTokenError('secret or public key must be provided'));
	    }
	
	    if (!hasSignature && !options.algorithms) {
	      options.algorithms = ['none'];
	    }
	
	    if (!options.algorithms) {
	      options.algorithms = ~secretOrPublicKey.toString().indexOf('BEGIN CERTIFICATE') ||
	        ~secretOrPublicKey.toString().indexOf('BEGIN PUBLIC KEY') ? PUB_KEY_ALGS :
	        ~secretOrPublicKey.toString().indexOf('BEGIN RSA PUBLIC KEY') ? RSA_KEY_ALGS : HS_ALGS;
	
	    }
	
	    if (!~options.algorithms.indexOf(decodedToken.header.alg)) {
	      return done(new JsonWebTokenError('invalid algorithm'));
	    }
	
	    var valid;
	
	    try {
	      valid = jws.verify(jwtString, decodedToken.header.alg, secretOrPublicKey);
	    } catch (e) {
	      return done(e);
	    }
	
	    if (!valid) {
	      return done(new JsonWebTokenError('invalid signature'));
	    }
	
	    var payload = decodedToken.payload;
	
	    if (typeof payload.nbf !== 'undefined' && !options.ignoreNotBefore) {
	      if (typeof payload.nbf !== 'number') {
	        return done(new JsonWebTokenError('invalid nbf value'));
	      }
	      if (payload.nbf > clockTimestamp + (options.clockTolerance || 0)) {
	        return done(new NotBeforeError('jwt not active', new Date(payload.nbf * 1000)));
	      }
	    }
	
	    if (typeof payload.exp !== 'undefined' && !options.ignoreExpiration) {
	      if (typeof payload.exp !== 'number') {
	        return done(new JsonWebTokenError('invalid exp value'));
	      }
	      if (clockTimestamp >= payload.exp + (options.clockTolerance || 0)) {
	        return done(new TokenExpiredError('jwt expired', new Date(payload.exp * 1000)));
	      }
	    }
	
	    if (options.audience) {
	      var audiences = Array.isArray(options.audience) ? options.audience : [options.audience];
	      var target = Array.isArray(payload.aud) ? payload.aud : [payload.aud];
	
	      var match = target.some(function (targetAudience) {
	        return audiences.some(function (audience) {
	          return audience instanceof RegExp ? audience.test(targetAudience) : audience === targetAudience;
	        });
	      });
	
	      if (!match) {
	        return done(new JsonWebTokenError('jwt audience invalid. expected: ' + audiences.join(' or ')));
	      }
	    }
	
	    if (options.issuer) {
	      var invalid_issuer =
	              (typeof options.issuer === 'string' && payload.iss !== options.issuer) ||
	              (Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1);
	
	      if (invalid_issuer) {
	        return done(new JsonWebTokenError('jwt issuer invalid. expected: ' + options.issuer));
	      }
	    }
	
	    if (options.subject) {
	      if (payload.sub !== options.subject) {
	        return done(new JsonWebTokenError('jwt subject invalid. expected: ' + options.subject));
	      }
	    }
	
	    if (options.jwtid) {
	      if (payload.jti !== options.jwtid) {
	        return done(new JsonWebTokenError('jwt jwtid invalid. expected: ' + options.jwtid));
	      }
	    }
	
	    if (options.nonce) {
	      if (payload.nonce !== options.nonce) {
	        return done(new JsonWebTokenError('jwt nonce invalid. expected: ' + options.nonce));
	      }
	    }
	
	    if (options.maxAge) {
	      if (typeof payload.iat !== 'number') {
	        return done(new JsonWebTokenError('iat required when maxAge is specified'));
	      }
	
	      var maxAgeTimestamp = timespan(options.maxAge, payload.iat);
	      if (typeof maxAgeTimestamp === 'undefined') {
	        return done(new JsonWebTokenError('"maxAge" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
	      }
	      if (clockTimestamp >= maxAgeTimestamp + (options.clockTolerance || 0)) {
	        return done(new TokenExpiredError('maxAge exceeded', new Date(maxAgeTimestamp * 1000)));
	      }
	    }
	
	    if (options.complete === true) {
	      var signature = decodedToken.signature;
	
	      return done(null, {
	        header: header,
	        payload: payload,
	        signature: signature
	      });
	    }
	
	    return done(null, payload);
	  });
	};


/***/ },
/* 2955 */
/***/ function(module, exports, __webpack_require__) {

	/*global module*/
	var Buffer = __webpack_require__(333).Buffer;
	var DataStream = __webpack_require__(1296);
	var jwa = __webpack_require__(1295);
	var Stream = __webpack_require__(226);
	var toString = __webpack_require__(1297);
	var util = __webpack_require__(527);
	
	function base64url(string, encoding) {
	  return Buffer
	    .from(string, encoding)
	    .toString('base64')
	    .replace(/=/g, '')
	    .replace(/\+/g, '-')
	    .replace(/\//g, '_');
	}
	
	function jwsSecuredInput(header, payload, encoding) {
	  encoding = encoding || 'utf8';
	  var encodedHeader = base64url(toString(header), 'binary');
	  var encodedPayload = base64url(toString(payload), encoding);
	  return util.format('%s.%s', encodedHeader, encodedPayload);
	}
	
	function jwsSign(opts) {
	  var header = opts.header;
	  var payload = opts.payload;
	  var secretOrKey = opts.secret || opts.privateKey;
	  var encoding = opts.encoding;
	  var algo = jwa(header.alg);
	  var securedInput = jwsSecuredInput(header, payload, encoding);
	  var signature = algo.sign(securedInput, secretOrKey);
	  return util.format('%s.%s', securedInput, signature);
	}
	
	function SignStream(opts) {
	  var secret = opts.secret||opts.privateKey||opts.key;
	  var secretStream = new DataStream(secret);
	  this.readable = true;
	  this.header = opts.header;
	  this.encoding = opts.encoding;
	  this.secret = this.privateKey = this.key = secretStream;
	  this.payload = new DataStream(opts.payload);
	  this.secret.once('close', function () {
	    if (!this.payload.writable && this.readable)
	      this.sign();
	  }.bind(this));
	
	  this.payload.once('close', function () {
	    if (!this.secret.writable && this.readable)
	      this.sign();
	  }.bind(this));
	}
	util.inherits(SignStream, Stream);
	
	SignStream.prototype.sign = function sign() {
	  try {
	    var signature = jwsSign({
	      header: this.header,
	      payload: this.payload.buffer,
	      secret: this.secret.buffer,
	      encoding: this.encoding
	    });
	    this.emit('done', signature);
	    this.emit('data', signature);
	    this.emit('end');
	    this.readable = false;
	    return signature;
	  } catch (e) {
	    this.readable = false;
	    this.emit('error', e);
	    this.emit('close');
	  }
	};
	
	SignStream.sign = jwsSign;
	
	module.exports = SignStream;


/***/ },
/* 2956 */
/***/ function(module, exports, __webpack_require__) {

	/*global module*/
	var Buffer = __webpack_require__(333).Buffer;
	var DataStream = __webpack_require__(1296);
	var jwa = __webpack_require__(1295);
	var Stream = __webpack_require__(226);
	var toString = __webpack_require__(1297);
	var util = __webpack_require__(527);
	var JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
	
	function isObject(thing) {
	  return Object.prototype.toString.call(thing) === '[object Object]';
	}
	
	function safeJsonParse(thing) {
	  if (isObject(thing))
	    return thing;
	  try { return JSON.parse(thing); }
	  catch (e) { return undefined; }
	}
	
	function headerFromJWS(jwsSig) {
	  var encodedHeader = jwsSig.split('.', 1)[0];
	  return safeJsonParse(Buffer.from(encodedHeader, 'base64').toString('binary'));
	}
	
	function securedInputFromJWS(jwsSig) {
	  return jwsSig.split('.', 2).join('.');
	}
	
	function signatureFromJWS(jwsSig) {
	  return jwsSig.split('.')[2];
	}
	
	function payloadFromJWS(jwsSig, encoding) {
	  encoding = encoding || 'utf8';
	  var payload = jwsSig.split('.')[1];
	  return Buffer.from(payload, 'base64').toString(encoding);
	}
	
	function isValidJws(string) {
	  return JWS_REGEX.test(string) && !!headerFromJWS(string);
	}
	
	function jwsVerify(jwsSig, algorithm, secretOrKey) {
	  if (!algorithm) {
	    var err = new Error("Missing algorithm parameter for jws.verify");
	    err.code = "MISSING_ALGORITHM";
	    throw err;
	  }
	  jwsSig = toString(jwsSig);
	  var signature = signatureFromJWS(jwsSig);
	  var securedInput = securedInputFromJWS(jwsSig);
	  var algo = jwa(algorithm);
	  return algo.verify(securedInput, signature, secretOrKey);
	}
	
	function jwsDecode(jwsSig, opts) {
	  opts = opts || {};
	  jwsSig = toString(jwsSig);
	
	  if (!isValidJws(jwsSig))
	    return null;
	
	  var header = headerFromJWS(jwsSig);
	
	  if (!header)
	    return null;
	
	  var payload = payloadFromJWS(jwsSig);
	  if (header.typ === 'JWT' || opts.json)
	    payload = JSON.parse(payload, opts.encoding);
	
	  return {
	    header: header,
	    payload: payload,
	    signature: signatureFromJWS(jwsSig)
	  };
	}
	
	function VerifyStream(opts) {
	  opts = opts || {};
	  var secretOrKey = opts.secret||opts.publicKey||opts.key;
	  var secretStream = new DataStream(secretOrKey);
	  this.readable = true;
	  this.algorithm = opts.algorithm;
	  this.encoding = opts.encoding;
	  this.secret = this.publicKey = this.key = secretStream;
	  this.signature = new DataStream(opts.signature);
	  this.secret.once('close', function () {
	    if (!this.signature.writable && this.readable)
	      this.verify();
	  }.bind(this));
	
	  this.signature.once('close', function () {
	    if (!this.secret.writable && this.readable)
	      this.verify();
	  }.bind(this));
	}
	util.inherits(VerifyStream, Stream);
	VerifyStream.prototype.verify = function verify() {
	  try {
	    var valid = jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
	    var obj = jwsDecode(this.signature.buffer, this.encoding);
	    this.emit('done', valid, obj);
	    this.emit('data', valid);
	    this.emit('end');
	    this.readable = false;
	    return valid;
	  } catch (e) {
	    this.readable = false;
	    this.emit('error', e);
	    this.emit('close');
	  }
	};
	
	VerifyStream.decode = jwsDecode;
	VerifyStream.isValid = isValidJws;
	VerifyStream.verify = jwsVerify;
	
	module.exports = VerifyStream;


/***/ },
/* 2957 */
/***/ function(module, exports) {

	/**
	 * The code was extracted from:
	 * https://github.com/davidchambers/Base64.js
	 */
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function InvalidCharacterError(message) {
	  this.message = message;
	}
	
	InvalidCharacterError.prototype = new Error();
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	function polyfill (input) {
	  var str = String(input).replace(/=+$/, '');
	  if (str.length % 4 == 1) {
	    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	  }
	  for (
	    // initialize result and counters
	    var bc = 0, bs, buffer, idx = 0, output = '';
	    // get next character
	    buffer = str.charAt(idx++);
	    // character found in table? initialize bit storage and add its ascii value;
	    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	      // and if not first of each 4 characters,
	      // convert the first 8 bits to one ascii character
	      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
	  ) {
	    // try to find character in table (0-63, not found => -1)
	    buffer = chars.indexOf(buffer);
	  }
	  return output;
	}
	
	
	module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ },
/* 2958 */
/***/ function(module, exports, __webpack_require__) {

	var atob = __webpack_require__(2957);
	
	function b64DecodeUnicode(str) {
	  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
	    var code = p.charCodeAt(0).toString(16).toUpperCase();
	    if (code.length < 2) {
	      code = '0' + code;
	    }
	    return '%' + code;
	  }));
	}
	
	module.exports = function(str) {
	  var output = str.replace(/-/g, "+").replace(/_/g, "/");
	  switch (output.length % 4) {
	    case 0:
	      break;
	    case 2:
	      output += "==";
	      break;
	    case 3:
	      output += "=";
	      break;
	    default:
	      throw "Illegal base64url string!";
	  }
	
	  try{
	    return b64DecodeUnicode(output);
	  } catch (err) {
	    return atob(output);
	  }
	};


/***/ },
/* 2959 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2960);

/***/ },
/* 2960 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(2974);
	_.str = __webpack_require__(4096);
	var supported_languages = ["danish","dutch","english","french","galician","german","italian","polish","portuguese","russian","spanish","swedish"];
	var stopwords = __webpack_require__(2973);
	
	function _extract(str, options){
	    if(_.isEmpty(str)){
	        return [];
	    }
	    if(_.isEmpty(options)){
	        options = {
	            remove_digits: true,
	            return_changed_case: true
	        };
	    }
	    var return_changed_case = options.return_changed_case;
	    var return_chained_words = options.return_chained_words;
	    var remove_digits = options.remove_digits;
	    var _language = options.language || "english";
	    var _remove_duplicates = options.remove_duplicates || false;
	
	    if(supported_languages.indexOf(_language) < 0){
	        throw new Error("Language must be one of ["+supported_languages.join(",")+"]");
	    }
	
	    //  strip any HTML and trim whitespace
	    var text = _.str.trim(_.str.stripTags(str));
	    if(_.isEmpty(text)){
	        return [];
	    }else{
	        var words = text.split(/\s/);
	        var unchanged_words = [];
	        var low_words = [];
	        //  change the case of all the words
	        for(var x = 0;x < words.length; x++){
	            var w = words[x].match(/https?:\/\/.*[\r\n]*/g) ? words[x] : words[x].replace(/\.|,|;|!|\?|\(|\)|:|"|^'|'$/g,'');
	            //  remove periods, question marks, exclamation points, commas, and semi-colons
	            //  if this is a short result, make sure it's not a single character or something 'odd'
	            if(w.length === 1){
	                w = w.replace(/-|_|@|&|#/g,'');
	            }
	            //  if it's a number, remove it
	            var digits_match = w.match(/\d/g);
	            if(remove_digits && digits_match && digits_match.length === w.length){
	                w = "";
	            }
	            if(w.length > 0){
	                low_words.push(w.toLowerCase());
	                unchanged_words.push(w);
	            }
	        }
	        var results = [];
	        var _stopwords = options.stopwords || _getStopwords({ language: _language });
	        var _last_result_word_index = 0;
	        for(var y = 0; y < low_words.length; y++){
	
	            if(_stopwords.indexOf(low_words[y]) < 0){
	                var result_word = return_changed_case && !unchanged_words[y].match(/https?:\/\/.*[\r\n]*/g) ? low_words[y] : unchanged_words[y];
	
	                if (return_chained_words && _last_result_word_index === y - 1) {
	                  var change_pos = results.length - 1 < 0 ? 0 : results.length - 1;
	                  results[change_pos] = results[change_pos] ? results[change_pos] + ' ' + result_word : result_word;
	                } else {
	                  results.push(result_word);
	                }
	
	                _last_result_word_index = y;
	            }
	        }
	
	        if(_remove_duplicates) {
	            results= _.uniq(results, function (item) {
	                return item;
	            });
	        }
	
	        return results;
	    }
	}
	
	function _getStopwords(options){
	    options = options || {};
	
	    var _language = options.language || "english";
	    if(supported_languages.indexOf(_language) < 0){
	        throw new Error("Language must be one of ["+supported_languages.join(",")+"]");
	    }
	
	    return stopwords[_language];
	}
	
	module.exports = {
	    extract:_extract,
	    getStopwords: _getStopwords
	};


/***/ },
/* 2961 */
/***/ function(module, exports) {

	// Danish stopwords
	// http://www.ranks.nl/stopwords/danish
	// https://github.com/dnohr
	
	module.exports = {
	    stopwords: [
			"ad",
			"af",
			"aldrig",
			"alle",
			"alt",
			"altid",
			"anden",
			"andet",
			"andre",
			"at",
			"bagved",
			"begge",
			"blev",
			"blive",
			"bliver",
			"da",
			"de",
			"dem",
			"den",
			"denne",
			"der",
			"deres",
			"det",
			"dette",
			"dig",
			"din",
			"disse",
			"dog",
			"du",
			"efter",
			"ej",
			"eller",
			"en",
			"end",
			"endnu",
			"ene",
			"eneste",
			"enhver",
			"er",
			"et",
			"fem",
			"fire",
			"fjernt",
			"flere",
			"fleste",
			"for",
			"foran",
			"fordi",
			"forrige",
			"fra",
			"få",
			"før",
			"gennem",
			"god",
			"ham",
			"han",
			"hans",
			"har",
			"havde",
			"have",
			"hende",
			"hendes",
			"her",
			"hos",
			"hovfor",
			"hun",
			"hurtig",
			"hvad",
			"hvem",
			"hver",
			"hvilken",
			"hvis",
			"hvonår",
			"hvor",
			"hvordan",
			"hvorfor",
			"hvorhen",
			"hvornår",
			"i",
			"ikke",
			"imod",
			"ind",
			"ingen",
			"intet",
			"ja",
			"jeg",
			"jer",
			"jeres",
			"jo",
			"kan",
			"kom",
			"kommer",
			"kunne",
			"langsom",
			"lav",
			"lidt",
			"lille",
			"man",
			"mand",
			"mange",
			"med",
			"meget",
			"mellem",
			"men",
			"mens",
			"mere",
			"mig",
			"min",
			"mindre",
			"mine",
			"mit",
			"mod",
			"måske",
			"ned",
			"nede",
			"nej",
			"ni",
			"nogen",
			"noget",
			"nogle",
			"nok",
			"nu",
			"ny",
			"nyt",
			"når",
			"nær",
			"næste",
			"næsten",
			"og",
			"også",
			"om",
			"op",
			"oppe",
			"os",
			"otte",
			"over",
			"på",
			"rask",
			"sammen",
			"se",
			"seks",
			"selv",
			"ses",
			"sig",
			"sin",
			"sine",
			"sit",
			"skal",
			"skulle",
			"som",
			"stor",
			"store",
			"syv",
			"sådan",
			"temmelig",
			"thi",
			"ti",
			"til",
			"to",
			"tre",
			"ud",
			"uden",
			"udenfor",
			"under",
			"var",
			"ved",
			"vi",
			"vil",
			"ville",
			"vor",
			"være",
			"været"
	    ]
	};

/***/ },
/* 2962 */
/***/ function(module, exports) {

	/**
	 * Created by jan on 9-3-15.
	 */
	// German stopwords
	// via https://code.google.com/p/stop-words/
	module.exports = {
	    stopwords: [
	        "a",
	        "ab",
	        "aber",
	        "ach",
	        "acht",
	        "achte",
	        "achten",
	        "achter",
	        "achtes",
	        "ag",
	        "alle",
	        "allein",
	        "allem",
	        "allen",
	        "aller",
	        "allerdings",
	        "alles",
	        "allgemeinen",
	        "als",
	        "also",
	        "am",
	        "an",
	        "andere",
	        "anderen",
	        "andern",
	        "anders",
	        "au",
	        "auch",
	        "auf",
	        "aus",
	        "ausser",
	        "außer",
	        "ausserdem",
	        "außerdem",
	        "b",
	        "bald",
	        "bei",
	        "beide",
	        "beiden",
	        "beim",
	        "beispiel",
	        "bekannt",
	        "bereits",
	        "besonders",
	        "besser",
	        "besten",
	        "bin",
	        "bis",
	        "bisher",
	        "bist",
	        "c",
	        "d",
	        "da",
	        "dabei",
	        "dadurch",
	        "dafür",
	        "dagegen",
	        "daher",
	        "dahin",
	        "dahinter",
	        "damals",
	        "damit",
	        "danach",
	        "daneben",
	        "dank",
	        "dann",
	        "daran",
	        "darauf",
	        "daraus",
	        "darf",
	        "darfst",
	        "darin",
	        "darüber",
	        "darum",
	        "darunter",
	        "das",
	        "dasein",
	        "daselbst",
	        "dass",
	        "daß",
	        "dasselbe",
	        "davon",
	        "davor",
	        "dazu",
	        "dazwischen",
	        "dein",
	        "deine",
	        "deinem",
	        "deiner",
	        "dem",
	        "dementsprechend",
	        "demgegenüber",
	        "demgemäss",
	        "demgemäß",
	        "demselben",
	        "demzufolge",
	        "den",
	        "denen",
	        "denn",
	        "denselben",
	        "der",
	        "deren",
	        "derjenige",
	        "derjenigen",
	        "dermassen",
	        "dermaßen",
	        "derselbe",
	        "derselben",
	        "des",
	        "deshalb",
	        "desselben",
	        "dessen",
	        "deswegen",
	        "d.h",
	        "dich",
	        "die",
	        "diejenige",
	        "diejenigen",
	        "dies",
	        "diese",
	        "dieselbe",
	        "dieselben",
	        "diesem",
	        "diesen",
	        "dieser",
	        "dieses",
	        "dir",
	        "doch",
	        "dort",
	        "drei",
	        "drin",
	        "dritte",
	        "dritten",
	        "dritter",
	        "drittes",
	        "du",
	        "durch",
	        "durchaus",
	        "dürfen",
	        "dürft",
	        "durfte",
	        "durften",
	        "e",
	        "eben",
	        "ebenso",
	        "ehrlich",
	        "ei",
	        "ei,",
	        "eigen",
	        "eigene",
	        "eigenen",
	        "eigener",
	        "eigenes",
	        "ein",
	        "einander",
	        "eine",
	        "einem",
	        "einen",
	        "einer",
	        "eines",
	        "einige",
	        "einigen",
	        "einiger",
	        "einiges",
	        "einmal",
	        "eins",
	        "elf",
	        "en",
	        "ende",
	        "endlich",
	        "entweder",
	        "er",
	        "Ernst",
	        "erst",
	        "erste",
	        "ersten",
	        "erster",
	        "erstes",
	        "es",
	        "etwa",
	        "etwas",
	        "euch",
	        "f",
	        "früher",
	        "fünf",
	        "fünfte",
	        "fünften",
	        "fünfter",
	        "fünftes",
	        "für",
	        "g",
	        "gab",
	        "ganz",
	        "ganze",
	        "ganzen",
	        "ganzer",
	        "ganzes",
	        "gar",
	        "gedurft",
	        "gegen",
	        "gegenüber",
	        "gehabt",
	        "gehen",
	        "geht",
	        "gekannt",
	        "gekonnt",
	        "gemacht",
	        "gemocht",
	        "gemusst",
	        "genug",
	        "gerade",
	        "gern",
	        "gesagt",
	        "geschweige",
	        "gewesen",
	        "gewollt",
	        "geworden",
	        "gibt",
	        "ging",
	        "gleich",
	        "gott",
	        "gross",
	        "groß",
	        "grosse",
	        "große",
	        "grossen",
	        "großen",
	        "grosser",
	        "großer",
	        "grosses",
	        "großes",
	        "gut",
	        "gute",
	        "guter",
	        "gutes",
	        "h",
	        "habe",
	        "haben",
	        "habt",
	        "hast",
	        "hat",
	        "hatte",
	        "hätte",
	        "hatten",
	        "hätten",
	        "heisst",
	        "her",
	        "heute",
	        "hier",
	        "hin",
	        "hinter",
	        "hoch",
	        "i",
	        "ich",
	        "ihm",
	        "ihn",
	        "ihnen",
	        "ihr",
	        "ihre",
	        "ihrem",
	        "ihren",
	        "ihrer",
	        "ihres",
	        "im",
	        "immer",
	        "in",
	        "indem",
	        "infolgedessen",
	        "ins",
	        "irgend",
	        "ist",
	        "j",
	        "ja",
	        "jahr",
	        "jahre",
	        "jahren",
	        "je",
	        "jede",
	        "jedem",
	        "jeden",
	        "jeder",
	        "jedermann",
	        "jedermanns",
	        "jedoch",
	        "jemand",
	        "jemandem",
	        "jemanden",
	        "jene",
	        "jenem",
	        "jenen",
	        "jener",
	        "jenes",
	        "jetzt",
	        "k",
	        "kam",
	        "kann",
	        "kannst",
	        "kaum",
	        "kein",
	        "keine",
	        "keinem",
	        "keinen",
	        "keiner",
	        "kleine",
	        "kleinen",
	        "kleiner",
	        "kleines",
	        "kommen",
	        "kommt",
	        "können",
	        "könnt",
	        "konnte",
	        "könnte",
	        "konnten",
	        "kurz",
	        "l",
	        "lang",
	        "lange",
	        "leicht",
	        "leide",
	        "lieber",
	        "los",
	        "m",
	        "machen",
	        "macht",
	        "machte",
	        "mag",
	        "magst",
	        "mahn",
	        "man",
	        "manche",
	        "manchem",
	        "manchen",
	        "mancher",
	        "manches",
	        "mann",
	        "mehr",
	        "mein",
	        "meine",
	        "meinem",
	        "meinen",
	        "meiner",
	        "meines",
	        "mensch",
	        "menschen",
	        "mich",
	        "mir",
	        "mit",
	        "mittel",
	        "mochte",
	        "möchte",
	        "mochten",
	        "mögen",
	        "möglich",
	        "mögt",
	        "morgen",
	        "muss",
	        "muß",
	        "müssen",
	        "musst",
	        "müsst",
	        "musste",
	        "mussten",
	        "n",
	        "na",
	        "nach",
	        "nachdem",
	        "nahm",
	        "natürlich",
	        "neben",
	        "nein",
	        "neue",
	        "neuen",
	        "neun",
	        "neunte",
	        "neunten",
	        "neunter",
	        "neuntes",
	        "nicht",
	        "nichts",
	        "nie",
	        "niemand",
	        "niemandem",
	        "niemanden",
	        "noch",
	        "nun",
	        "nur",
	        "o",
	        "ob",
	        "oben",
	        "oder",
	        "offen",
	        "oft",
	        "ohne",
	        "Ordnung",
	        "p",
	        "q",
	        "r",
	        "recht",
	        "rechte",
	        "rechten",
	        "rechter",
	        "rechtes",
	        "richtig",
	        "rund",
	        "s",
	        "sa",
	        "sache",
	        "sagt",
	        "sagte",
	        "sah",
	        "satt",
	        "schlecht",
	        "Schluss",
	        "schon",
	        "sechs",
	        "sechste",
	        "sechsten",
	        "sechster",
	        "sechstes",
	        "sehr",
	        "sei",
	        "seid",
	        "seien",
	        "sein",
	        "seine",
	        "seinem",
	        "seinen",
	        "seiner",
	        "seines",
	        "seit",
	        "seitdem",
	        "selbst",
	        "sich",
	        "sie",
	        "sieben",
	        "siebente",
	        "siebenten",
	        "siebenter",
	        "siebentes",
	        "sind",
	        "so",
	        "solang",
	        "solche",
	        "solchem",
	        "solchen",
	        "solcher",
	        "solches",
	        "soll",
	        "sollen",
	        "sollte",
	        "sollten",
	        "sondern",
	        "sonst",
	        "sowie",
	        "später",
	        "statt",
	        "t",
	        "tag",
	        "tage",
	        "tagen",
	        "tat",
	        "teil",
	        "tel",
	        "tritt",
	        "trotzdem",
	        "tun",
	        "u",
	        "über",
	        "überhaupt",
	        "übrigens",
	        "uhr",
	        "um",
	        "und",
	        "und?",
	        "uns",
	        "unser",
	        "unsere",
	        "unserer",
	        "unter",
	        "v",
	        "vergangenen",
	        "viel",
	        "viele",
	        "vielem",
	        "vielen",
	        "vielleicht",
	        "vier",
	        "vierte",
	        "vierten",
	        "vierter",
	        "viertes",
	        "vom",
	        "von",
	        "vor",
	        "w",
	        "wahr?",
	        "während",
	        "währenddem",
	        "währenddessen",
	        "wann",
	        "war",
	        "wäre",
	        "waren",
	        "wart",
	        "warum",
	        "was",
	        "wegen",
	        "weil",
	        "weit",
	        "weiter",
	        "weitere",
	        "weiteren",
	        "weiteres",
	        "welche",
	        "welchem",
	        "welchen",
	        "welcher",
	        "welches",
	        "wem",
	        "wen",
	        "wenig",
	        "wenige",
	        "weniger",
	        "weniges",
	        "wenigstens",
	        "wenn",
	        "wer",
	        "werde",
	        "werden",
	        "werdet",
	        "wessen",
	        "wie",
	        "wieder",
	        "will",
	        "willst",
	        "wir",
	        "wird",
	        "wirklich",
	        "wirst",
	        "wo",
	        "wohl",
	        "wollen",
	        "wollt",
	        "wollte",
	        "wollten",
	        "worden",
	        "wurde",
	        "würde",
	        "wurden",
	        "würden",
	        "x",
	        "y",
	        "z",
	        "z.b",
	        "zehn",
	        "zehnte",
	        "zehnten",
	        "zehnter",
	        "zehntes",
	        "zeit",
	        "zu",
	        "zuerst",
	        "zugleich",
	        "zum",
	        "zunächst",
	        "zur",
	        "zurück",
	        "zusammen",
	        "zwanzig",
	        "zwar",
	        "zwei",
	        "zweite",
	        "zweiten",
	        "zweiter",
	        "zweites",
	        "zwischen",
	        "zwölf",
	        "﻿aber",
	        "euer",
	        "eure",
	        "hattest",
	        "hattet",
	        "jedes",
	        "mußt",
	        "müßt",
	        "sollst",
	        "sollt",
	        "soweit",
	        "weshalb",
	        "wieso",
	        "woher",
	        "wohin"
	    ]
	
	};

/***/ },
/* 2963 */
/***/ function(module, exports) {

	// via http://jmlr.org/papers/volume5/lewis04a/a11-smart-stop-list/english.stop
	module.exports = {
	    stopwords:[
	        "a",
	        "a's",
	        "able",
	        "about",
	        "above",
	        "according",
	        "accordingly",
	        "across",
	        "actually",
	        "after",
	        "afterwards",
	        "again",
	        "against",
	        "ain't",
	        "all",
	        "allow",
	        "allows",
	        "almost",
	        "alone",
	        "along",
	        "already",
	        "also",
	        "although",
	        "always",
	        "am",
	        "among",
	        "amongst",
	        "an",
	        "and",
	        "another",
	        "any",
	        "anybody",
	        "anyhow",
	        "anyone",
	        "anything",
	        "anyway",
	        "anyways",
	        "anywhere",
	        "apart",
	        "appear",
	        "appreciate",
	        "appropriate",
	        "are",
	        "aren't",
	        "around",
	        "as",
	        "aside",
	        "ask",
	        "asking",
	        "associated",
	        "at",
	        "available",
	        "away",
	        "awfully",
	        "b",
	        "be",
	        "became",
	        "because",
	        "become",
	        "becomes",
	        "becoming",
	        "been",
	        "before",
	        "beforehand",
	        "behind",
	        "being",
	        "believe",
	        "below",
	        "beside",
	        "besides",
	        "best",
	        "better",
	        "between",
	        "beyond",
	        "both",
	        "brief",
	        "but",
	        "by",
	        "c",
	        "c'mon",
	        "c's",
	        "came",
	        "can",
	        "can't",
	        "cannot",
	        "cant",
	        "cause",
	        "causes",
	        "certain",
	        "certainly",
	        "changes",
	        "clearly",
	        "co",
	        "com",
	        "come",
	        "comes",
	        "concerning",
	        "consequently",
	        "consider",
	        "considering",
	        "contain",
	        "containing",
	        "contains",
	        "corresponding",
	        "could",
	        "couldn't",
	        "course",
	        "currently",
	        "d",
	        "definitely",
	        "described",
	        "despite",
	        "did",
	        "didn't",
	        "different",
	        "do",
	        "does",
	        "doesn't",
	        "doing",
	        "don't",
	        "done",
	        "down",
	        "downwards",
	        "during",
	        "e",
	        "each",
	        "edu",
	        "eg",
	        "eight",
	        "either",
	        "else",
	        "elsewhere",
	        "enough",
	        "entirely",
	        "especially",
	        "et",
	        "etc",
	        "even",
	        "ever",
	        "every",
	        "everybody",
	        "everyone",
	        "everything",
	        "everywhere",
	        "ex",
	        "exactly",
	        "example",
	        "except",
	        "f",
	        "far",
	        "few",
	        "fifth",
	        "first",
	        "five",
	        "followed",
	        "following",
	        "follows",
	        "for",
	        "former",
	        "formerly",
	        "forth",
	        "four",
	        "from",
	        "further",
	        "furthermore",
	        "g",
	        "get",
	        "gets",
	        "getting",
	        "given",
	        "gives",
	        "go",
	        "goes",
	        "going",
	        "gone",
	        "got",
	        "gotten",
	        "greetings",
	        "h",
	        "had",
	        "hadn't",
	        "happens",
	        "hardly",
	        "has",
	        "hasn't",
	        "have",
	        "haven't",
	        "having",
	        "he",
	        "he's",
	        "hello",
	        "help",
	        "hence",
	        "her",
	        "here",
	        "here's",
	        "hereafter",
	        "hereby",
	        "herein",
	        "hereupon",
	        "hers",
	        "herself",
	        "hi",
	        "him",
	        "himself",
	        "his",
	        "hither",
	        "hopefully",
	        "how",
	        "howbeit",
	        "however",
	        "i",
	        "i'd",
	        "i'll",
	        "i'm",
	        "i've",
	        "ie",
	        "if",
	        "ignored",
	        "immediate",
	        "in",
	        "inasmuch",
	        "inc",
	        "indeed",
	        "indicate",
	        "indicated",
	        "indicates",
	        "inner",
	        "insofar",
	        "instead",
	        "into",
	        "inward",
	        "is",
	        "isn't",
	        "it",
	        "it'd",
	        "it'll",
	        "it's",
	        "its",
	        "itself",
	        "j",
	        "just",
	        "k",
	        "keep",
	        "keeps",
	        "kept",
	        "know",
	        "knows",
	        "known",
	        "l",
	        "last",
	        "lately",
	        "later",
	        "latter",
	        "latterly",
	        "least",
	        "less",
	        "lest",
	        "let",
	        "let's",
	        "like",
	        "liked",
	        "likely",
	        "little",
	        "look",
	        "looking",
	        "looks",
	        "ltd",
	        "m",
	        "mainly",
	        "many",
	        "may",
	        "maybe",
	        "me",
	        "mean",
	        "meanwhile",
	        "merely",
	        "might",
	        "more",
	        "moreover",
	        "most",
	        "mostly",
	        "much",
	        "must",
	        "my",
	        "myself",
	        "n",
	        "name",
	        "namely",
	        "nd",
	        "near",
	        "nearly",
	        "necessary",
	        "need",
	        "needs",
	        "neither",
	        "never",
	        "nevertheless",
	        "new",
	        "next",
	        "nine",
	        "no",
	        "nobody",
	        "non",
	        "none",
	        "noone",
	        "nor",
	        "normally",
	        "not",
	        "nothing",
	        "novel",
	        "now",
	        "nowhere",
	        "o",
	        "obviously",
	        "of",
	        "off",
	        "often",
	        "oh",
	        "ok",
	        "okay",
	        "old",
	        "on",
	        "once",
	        "one",
	        "ones",
	        "only",
	        "onto",
	        "or",
	        "other",
	        "others",
	        "otherwise",
	        "ought",
	        "our",
	        "ours",
	        "ourselves",
	        "out",
	        "outside",
	        "over",
	        "overall",
	        "own",
	        "p",
	        "particular",
	        "particularly",
	        "per",
	        "perhaps",
	        "placed",
	        "please",
	        "plus",
	        "possible",
	        "presumably",
	        "probably",
	        "provides",
	        "q",
	        "que",
	        "quite",
	        "qv",
	        "r",
	        "rather",
	        "rd",
	        "re",
	        "really",
	        "reasonably",
	        "regarding",
	        "regardless",
	        "regards",
	        "relatively",
	        "respectively",
	        "right",
	        "s",
	        "said",
	        "same",
	        "saw",
	        "say",
	        "saying",
	        "says",
	        "second",
	        "secondly",
	        "see",
	        "seeing",
	        "seem",
	        "seemed",
	        "seeming",
	        "seems",
	        "seen",
	        "self",
	        "selves",
	        "sensible",
	        "sent",
	        "serious",
	        "seriously",
	        "seven",
	        "several",
	        "shall",
	        "she",
	        "should",
	        "shouldn't",
	        "since",
	        "six",
	        "so",
	        "some",
	        "somebody",
	        "somehow",
	        "someone",
	        "something",
	        "sometime",
	        "sometimes",
	        "somewhat",
	        "somewhere",
	        "soon",
	        "sorry",
	        "specified",
	        "specify",
	        "specifying",
	        "still",
	        "sub",
	        "such",
	        "sup",
	        "sure",
	        "t",
	        "t's",
	        "take",
	        "taken",
	        "tell",
	        "tends",
	        "th",
	        "than",
	        "thank",
	        "thanks",
	        "thanx",
	        "that",
	        "that's",
	        "thats",
	        "the",
	        "their",
	        "theirs",
	        "them",
	        "themselves",
	        "then",
	        "thence",
	        "there",
	        "there's",
	        "thereafter",
	        "thereby",
	        "therefore",
	        "therein",
	        "theres",
	        "thereupon",
	        "these",
	        "they",
	        "they'd",
	        "they'll",
	        "they're",
	        "they've",
	        "think",
	        "third",
	        "this",
	        "thorough",
	        "thoroughly",
	        "those",
	        "though",
	        "three",
	        "through",
	        "throughout",
	        "thru",
	        "thus",
	        "to",
	        "together",
	        "too",
	        "took",
	        "toward",
	        "towards",
	        "tried",
	        "tries",
	        "truly",
	        "try",
	        "trying",
	        "twice",
	        "two",
	        "u",
	        "un",
	        "under",
	        "unfortunately",
	        "unless",
	        "unlikely",
	        "until",
	        "unto",
	        "up",
	        "upon",
	        "us",
	        "use",
	        "used",
	        "useful",
	        "uses",
	        "using",
	        "usually",
	        "uucp",
	        "v",
	        "value",
	        "various",
	        "very",
	        "via",
	        "viz",
	        "vs",
	        "w",
	        "want",
	        "wants",
	        "was",
	        "wasn't",
	        "way",
	        "we",
	        "we'd",
	        "we'll",
	        "we're",
	        "we've",
	        "welcome",
	        "well",
	        "went",
	        "were",
	        "weren't",
	        "what",
	        "what's",
	        "whatever",
	        "when",
	        "whence",
	        "whenever",
	        "where",
	        "where's",
	        "whereafter",
	        "whereas",
	        "whereby",
	        "wherein",
	        "whereupon",
	        "wherever",
	        "whether",
	        "which",
	        "while",
	        "whither",
	        "who",
	        "who's",
	        "whoever",
	        "whole",
	        "whom",
	        "whose",
	        "why",
	        "will",
	        "willing",
	        "wish",
	        "with",
	        "within",
	        "without",
	        "won't",
	        "wonder",
	        "would",
	        "would",
	        "wouldn't",
	        "x",
	        "y",
	        "yes",
	        "yet",
	        "you",
	        "you'd",
	        "you'll",
	        "you're",
	        "you've",
	        "your",
	        "yours",
	        "yourself",
	        "yourselves",
	        "z",
	        "zero"
	    ]
	};

/***/ },
/* 2964 */
/***/ function(module, exports) {

	//  via https://stop-words.googlecode.com/svn/trunk/stop-words/stop-words/stop-words-spanish.txt
	module.exports = {
	    stopwords: [
	        'a',
	        'algún',
	        'alguna',
	        'algunas',
	        'alguno',
	        'algunos',
	        'ambos',
	        'ampleamos',
	        'ante',
	        'antes',
	        'aquel',
	        'aquellas',
	        'aquellos',
	        'aqui',
	        'arriba',
	        'atras',
	        'bajo',
	        'bastante',
	        'cada',
	        'cierta',
	        'ciertas',
	        'cierto',
	        'ciertos',
	        'como',
	        'con',
	        'conseguimos',
	        'conseguir',
	        'consigo',
	        'consigue',
	        'consiguen',
	        'consigues',
	        'cual',
	        'cuando',
	        'de',
	        'del',
	        'dentro',
	        'desde',
	        'donde',
	        'dos',
	        'el',
	        'ellas',
	        'ellos',
	        'empleais',
	        'emplean',
	        'emplear',
	        'empleas',
	        'empleo',
	        'en',
	        'encima',
	        'entonces',
	        'entre',
	        'era',
	        'eramos',
	        'eran',
	        'eras',
	        'eres',
	        'es',
	        'esta',
	        'estaba',
	        'estado',
	        'estais',
	        'estamos',
	        'estan',
	        'estoy',
	        'fin',
	        'fue',
	        'fueron',
	        'fui',
	        'fuimos',
	        'gueno',
	        'ha',
	        'hace',
	        'haceis',
	        'hacemos',
	        'hacen',
	        'hacer',
	        'haces',
	        'hago',
	        'incluso',
	        'intenta',
	        'intentais',
	        'intentamos',
	        'intentan',
	        'intentar',
	        'intentas',
	        'intento',
	        'ir',
	        'la',
	        'largo',
	        'las',
	        'lo',
	        'los',
	        'me',
	        'mientras',
	        'mi',
	        'mio',
	        'modo',
	        'mucho',
	        'muchos',
	        'más',
	        'mas',
	        'muy',
	        'nos',
	        'nosotros',
	        'otra',
	        'otras',
	        'otro',
	        'otros',
	        'para',
	        'pero',
	        'podeis',
	        'podemos',
	        'poder',
	        'podria',
	        'podriais',
	        'podriamos',
	        'podrian',
	        'podrias',
	        'por',
	        'por favor',
	        'por qué',
	        'porque',
	        'primero',
	        'puede',
	        'pueden',
	        'puedo',
	        'qué',
	        'que',
	        'quien',
	        'sabe',
	        'sabeis',
	        'sabemos',
	        'saben',
	        'saber',
	        'sabes',
	        'se',
	        'ser',
	        'si',
	        'siendo',
	        'sin',
	        'sobre',
	        'sois',
	        'solamente',
	        'solo',
	        'somos',
	        'soy',
	        'su',
	        'sus',
	        'también',
	        'te',
	        'teneis',
	        'tenemos',
	        'tener',
	        'tengo',
	        'tiempo',
	        'tiene',
	        'tienen',
	        'todo',
	        'trabaja',
	        'trabajais',
	        'trabajamos',
	        'trabajan',
	        'trabajar',
	        'trabajas',
	        'tras',
	        'tuyo',
	        'ultimo',
	        'un',
	        'una',
	        'unas',
	        'uno',
	        'unos',
	        'usa',
	        'usais',
	        'usamos',
	        'usan',
	        'usar',
	        'usas',
	        'uso',
	        'va',
	        'vais',
	        'valor',
	        'vamos',
	        'van',
	        'vaya',
	        'verdad',
	        'verdadera',
	        'verdadero',
	        'vosotras',
	        'vosotros',
	        'voy',
	        'yo'
	    ]
	};


/***/ },
/* 2965 */
/***/ function(module, exports) {

	/**
	 * Created by jan on 9-3-15.
	 */
	// French stopwords
	// via https://code.google.com/p/stop-words/
	
	module.exports = {
	    stopwords: [
	        "a",
	        "à",
	        "â",
	        "abord",
	        "afin",
	        "ah",
	        "ai",
	        "aie",
	        "ainsi",
	        "allaient",
	        "allo",
	        "allô",
	        "allons",
	        "après",
	        "assez",
	        "attendu",
	        "au",
	        "aucun",
	        "aucune",
	        "aujourd",
	        "aujourd'hui",
	        "auquel",
	        "aura",
	        "auront",
	        "aussi",
	        "autre",
	        "autres",
	        "aux",
	        "auxquelles",
	        "auxquels",
	        "avaient",
	        "avais",
	        "avait",
	        "avant",
	        "avec",
	        "avoir",
	        "ayant",
	        "b",
	        "bah",
	        "beaucoup",
	        "bien",
	        "bigre",
	        "boum",
	        "bravo",
	        "brrr",
	        "c",
	        "ça",
	        "car",
	        "ce",
	        "ceci",
	        "cela",
	        "celle",
	        "celle-ci",
	        "celle-là",
	        "celles",
	        "celles-ci",
	        "celles-là",
	        "celui",
	        "celui-ci",
	        "celui-là",
	        "cent",
	        "cependant",
	        "certain",
	        "certaine",
	        "certaines",
	        "certains",
	        "certes",
	        "ces",
	        "cet",
	        "cette",
	        "ceux",
	        "ceux-ci",
	        "ceux-là",
	        "chacun",
	        "chaque",
	        "cher",
	        "chère",
	        "chères",
	        "chers",
	        "chez",
	        "chiche",
	        "chut",
	        "ci",
	        "cinq",
	        "cinquantaine",
	        "cinquante",
	        "cinquantième",
	        "cinquième",
	        "clac",
	        "clic",
	        "combien",
	        "comme",
	        "comment",
	        "compris",
	        "concernant",
	        "contre",
	        "couic",
	        "crac",
	        "d",
	        "da",
	        "dans",
	        "de",
	        "debout",
	        "dedans",
	        "dehors",
	        "delà",
	        "depuis",
	        "derrière",
	        "des",
	        "dès",
	        "désormais",
	        "desquelles",
	        "desquels",
	        "dessous",
	        "dessus",
	        "deux",
	        "deuxième",
	        "deuxièmement",
	        "devant",
	        "devers",
	        "devra",
	        "différent",
	        "différente",
	        "différentes",
	        "différents",
	        "dire",
	        "divers",
	        "diverse",
	        "diverses",
	        "dix",
	        "dix-huit",
	        "dixième",
	        "dix-neuf",
	        "dix-sept",
	        "doit",
	        "doivent",
	        "donc",
	        "dont",
	        "douze",
	        "douzième",
	        "dring",
	        "du",
	        "duquel",
	        "durant",
	        "e",
	        "effet",
	        "eh",
	        "elle",
	        "elle-même",
	        "elles",
	        "elles-mêmes",
	        "en",
	        "encore",
	        "entre",
	        "envers",
	        "environ",
	        "es",
	        "ès",
	        "est",
	        "et",
	        "etant",
	        "étaient",
	        "étais",
	        "était",
	        "étant",
	        "etc",
	        "été",
	        "etre",
	        "être",
	        "eu",
	        "euh",
	        "eux",
	        "eux-mêmes",
	        "excepté",
	        "f",
	        "façon",
	        "fais",
	        "faisaient",
	        "faisant",
	        "fait",
	        "feront",
	        "fi",
	        "flac",
	        "floc",
	        "font",
	        "g",
	        "gens",
	        "h",
	        "ha",
	        "hé",
	        "hein",
	        "hélas",
	        "hem",
	        "hep",
	        "hi",
	        "ho",
	        "holà",
	        "hop",
	        "hormis",
	        "hors",
	        "hou",
	        "houp",
	        "hue",
	        "hui",
	        "huit",
	        "huitième",
	        "hum",
	        "hurrah",
	        "i",
	        "il",
	        "ils",
	        "importe",
	        "j",
	        "je",
	        "jusqu",
	        "jusque",
	        "k",
	        "l",
	        "la",
	        "là",
	        "laquelle",
	        "las",
	        "le",
	        "lequel",
	        "les",
	        "lès",
	        "lesquelles",
	        "lesquels",
	        "leur",
	        "leurs",
	        "longtemps",
	        "lorsque",
	        "lui",
	        "lui-même",
	        "m",
	        "ma",
	        "maint",
	        "mais",
	        "malgré",
	        "me",
	        "même",
	        "mêmes",
	        "merci",
	        "mes",
	        "mien",
	        "mienne",
	        "miennes",
	        "miens",
	        "mille",
	        "mince",
	        "moi",
	        "moi-même",
	        "moins",
	        "mon",
	        "moyennant",
	        "n",
	        "na",
	        "ne",
	        "néanmoins",
	        "neuf",
	        "neuvième",
	        "ni",
	        "nombreuses",
	        "nombreux",
	        "non",
	        "nos",
	        "notre",
	        "nôtre",
	        "nôtres",
	        "nous",
	        "nous-mêmes",
	        "nul",
	        "o",
	        "o|",
	        "ô",
	        "oh",
	        "ohé",
	        "olé",
	        "ollé",
	        "on",
	        "ont",
	        "onze",
	        "onzième",
	        "ore",
	        "ou",
	        "où",
	        "ouf",
	        "ouias",
	        "oust",
	        "ouste",
	        "outre",
	        "p",
	        "paf",
	        "pan",
	        "par",
	        "parmi",
	        "partant",
	        "particulier",
	        "particulière",
	        "particulièrement",
	        "pas",
	        "passé",
	        "pendant",
	        "personne",
	        "peu",
	        "peut",
	        "peuvent",
	        "peux",
	        "pff",
	        "pfft",
	        "pfut",
	        "pif",
	        "plein",
	        "plouf",
	        "plus",
	        "plusieurs",
	        "plutôt",
	        "pouah",
	        "pour",
	        "pourquoi",
	        "premier",
	        "première",
	        "premièrement",
	        "près",
	        "proche",
	        "psitt",
	        "puisque",
	        "q",
	        "qu",
	        "quand",
	        "quant",
	        "quanta",
	        "quant-à-soi",
	        "quarante",
	        "quatorze",
	        "quatre",
	        "quatre-vingt",
	        "quatrième",
	        "quatrièmement",
	        "que",
	        "quel",
	        "quelconque",
	        "quelle",
	        "quelles",
	        "quelque",
	        "quelques",
	        "quelqu'un",
	        "quels",
	        "qui",
	        "quiconque",
	        "quinze",
	        "quoi",
	        "quoique",
	        "r",
	        "revoici",
	        "revoilà",
	        "rien",
	        "s",
	        "sa",
	        "sacrebleu",
	        "sans",
	        "sapristi",
	        "sauf",
	        "se",
	        "seize",
	        "selon",
	        "sept",
	        "septième",
	        "sera",
	        "seront",
	        "ses",
	        "si",
	        "sien",
	        "sienne",
	        "siennes",
	        "siens",
	        "sinon",
	        "six",
	        "sixième",
	        "soi",
	        "soi-même",
	        "soit",
	        "soixante",
	        "son",
	        "sont",
	        "sous",
	        "stop",
	        "suis",
	        "suivant",
	        "sur",
	        "surtout",
	        "t",
	        "ta",
	        "tac",
	        "tant",
	        "te",
	        "té",
	        "tel",
	        "telle",
	        "tellement",
	        "telles",
	        "tels",
	        "tenant",
	        "tes",
	        "tic",
	        "tien",
	        "tienne",
	        "tiennes",
	        "tiens",
	        "toc",
	        "toi",
	        "toi-même",
	        "ton",
	        "touchant",
	        "toujours",
	        "tous",
	        "tout",
	        "toute",
	        "toutes",
	        "treize",
	        "trente",
	        "très",
	        "trois",
	        "troisième",
	        "troisièmement",
	        "trop",
	        "tsoin",
	        "tsouin",
	        "tu",
	        "u",
	        "un",
	        "une",
	        "unes",
	        "uns",
	        "v",
	        "va",
	        "vais",
	        "vas",
	        "vé",
	        "vers",
	        "via",
	        "vif",
	        "vifs",
	        "vingt",
	        "vivat",
	        "vive",
	        "vives",
	        "vlan",
	        "voici",
	        "voilà",
	        "vont",
	        "vos",
	        "votre",
	        "vôtre",
	        "vôtres",
	        "vous",
	        "vous-mêmes",
	        "vu",
	        "w",
	        "x",
	        "y",
	        "z",
	        "zut",
	        "﻿alors",
	        "aucuns",
	        "bon",
	        "devrait",
	        "dos",
	        "droite",
	        "début",
	        "essai",
	        "faites",
	        "fois",
	        "force",
	        "haut",
	        "ici",
	        "juste",
	        "maintenant",
	        "mine",
	        "mot",
	        "nommés",
	        "nouveaux",
	        "parce",
	        "parole",
	        "personnes",
	        "pièce",
	        "plupart",
	        "seulement",
	        "soyez",
	        "sujet",
	        "tandis",
	        "valeur",
	        "voie",
	        "voient",
	        "état",
	        "étions"
	
	    ]
	
	};


/***/ },
/* 2966 */
/***/ function(module, exports) {

	//  via http://www.ranks.nl/stopwords/galician
	module.exports = {
	    stopwords: [
	        'a',
	        'aínda',
	        'alí',
	        'aquel',
	        'aquela',
	        'aquelas',
	        'aqueles',
	        'aquilo',
	        'aquí',
	        'ao',
	        'aos',
	        'as',
	        'así',
	        'á',
	        'ben',
	        'cando',
	        'che',
	        'co',
	        'coa',
	        'comigo',
	        'con',
	        'connosco',
	        'contigo',
	        'convosco',
	        'coas',
	        'cos',
	        'cun',
	        'cuns',
	        'cunha',
	        'cunhas',
	        'da',
	        'dalgunha',
	        'dalgunhas',
	        'dalgún',
	        'dalgúns',
	        'das',
	        'de',
	        'del',
	        'dela',
	        'delas',
	        'deles',
	        'desde',
	        'deste',
	        'do',
	        'dos',
	        'dun',
	        'duns',
	        'dunha',
	        'dunhas',
	        'e',
	        'el',
	        'ela',
	        'elas',
	        'eles',
	        'en',
	        'era',
	        'eran',
	        'esa',
	        'esas',
	        'ese',
	        'eses',
	        'esta',
	        'estar',
	        'estaba',
	        'está',
	        'están',
	        'este',
	        'estes',
	        'estiven',
	        'estou',
	        'eu',
	        'é',
	        'facer',
	        'foi',
	        'foron',
	        'fun',
	        'había',
	        'hai',
	        'iso',
	        'isto',
	        'la',
	        'las',
	        'lle',
	        'lles',
	        'lo',
	        'los',
	        'mais',
	        'me',
	        'meu',
	        'meus',
	        'min',
	        'miña',
	        'miñas',
	        'moi',
	        'na',
	        'nas',
	        'neste',
	        'nin',
	        'no',
	        'non',
	        'nos',
	        'nosa',
	        'nosas',
	        'noso',
	        'nosos',
	        'nós',
	        'nun',
	        'nunha',
	        'nuns',
	        'nunhas',
	        'o',
	        'os',
	        'ou',
	        'ó',
	        'ós',
	        'para',
	        'pero',
	        'pode',
	        'pois',
	        'pola',
	        'polas',
	        'polo',
	        'polos',
	        'por',
	        'que',
	        'se',
	        'senón',
	        'ser',
	        'seu',
	        'seus',
	        'sexa',
	        'sido',
	        'sobre',
	        'súa',
	        'súas',
	        'tamén',
	        'tan',
	        'te',
	        'ten',
	        'teñen',
	        'teño',
	        'ter',
	        'teu',
	        'teus',
	        'ti',
	        'tido',
	        'tiña',
	        'tiven',
	        'túa',
	        'túas',
	        'un',
	        'unha',
	        'unhas',
	        'uns',
	        'vos',
	        'vosa',
	        'vosas',
	        'voso',
	        'vosos',
	        'vós'
	    ]
	};


/***/ },
/* 2967 */
/***/ function(module, exports) {

	/**
	 * Created by jan on 9-3-15.
	 */
	// Italian stopwords
	// via https://code.google.com/p/stop-words/
	
	module.exports = {
	    stopwords: [
	        "a",
	        "adesso",
	        "ai",
	        "al",
	        "alla",
	        "allo",
	        "allora",
	        "altre",
	        "altri",
	        "altro",
	        "anche",
	        "ancora",
	        "avere",
	        "aveva",
	        "avevano",
	        "ben",
	        "buono",
	        "che",
	        "chi",
	        "cinque",
	        "comprare",
	        "con",
	        "consecutivi",
	        "consecutivo",
	        "cosa",
	        "cui",
	        "da",
	        "del",
	        "della",
	        "dello",
	        "dentro",
	        "deve",
	        "devo",
	        "di",
	        "doppio",
	        "due",
	        "e",
	        "ecco",
	        "fare",
	        "fine",
	        "fino",
	        "fra",
	        "gente",
	        "giu",
	        "ha",
	        "hai",
	        "hanno",
	        "ho",
	        "il",
	        "indietro",
	        "invece",
	        "io",
	        "la",
	        "lavoro",
	        "le",
	        "lei",
	        "lo",
	        "loro",
	        "lui",
	        "lungo",
	        "ma",
	        "me",
	        "meglio",
	        "molta",
	        "molti",
	        "molto",
	        "nei",
	        "nella",
	        "no",
	        "noi",
	        "nome",
	        "nostro",
	        "nove",
	        "nuovi",
	        "nuovo",
	        "o",
	        "oltre",
	        "ora",
	        "otto",
	        "peggio",
	        "pero",
	        "persone",
	        "piu",
	        "poco",
	        "primo",
	        "promesso",
	        "qua",
	        "quarto",
	        "quasi",
	        "quattro",
	        "quello",
	        "questo",
	        "qui",
	        "quindi",
	        "quinto",
	        "rispetto",
	        "sara",
	        "secondo",
	        "sei",
	        "sembra",
	        "sembrava",
	        "senza",
	        "sette",
	        "sia",
	        "siamo",
	        "siete",
	        "solo",
	        "sono",
	        "sopra",
	        "soprattutto",
	        "sotto",
	        "stati",
	        "stato",
	        "stesso",
	        "su",
	        "subito",
	        "sul",
	        "sulla",
	        "tanto",
	        "te",
	        "tempo",
	        "terzo",
	        "tra",
	        "tre",
	        "triplo",
	        "ultimo",
	        "un",
	        "una",
	        "uno",
	        "va",
	        "vai",
	        "voi",
	        "volte",
	        "vostro",
	        "a",
	        "abbastanza",
	        "accidenti",
	        "ad",
	        "affinche",
	        "agli",
	        "ahime",
	        "ahimÃ",
	        "alcuna",
	        "alcuni",
	        "alcuno",
	        "all",
	        "alle",
	        "altrimenti",
	        "altrui",
	        "anni",
	        "anno",
	        "ansa",
	        "assai",
	        "attesa",
	        "avanti",
	        "avendo",
	        "avente",
	        "aver",
	        "avete",
	        "avuta",
	        "avute",
	        "avuti",
	        "avuto",
	        "basta",
	        "bene",
	        "benissimo",
	        "berlusconi",
	        "brava",
	        "bravo",
	        "c",
	        "casa",
	        "caso",
	        "cento",
	        "certa",
	        "certe",
	        "certi",
	        "certo",
	        "chicchessia",
	        "chiunque",
	        "ci",
	        "ciascuna",
	        "ciascuno",
	        "cima",
	        "cio",
	        "ciÃ",
	        "cioe",
	        "cioÃ",
	        "circa",
	        "citta",
	        "cittÃ",
	        "codesta",
	        "codesti",
	        "codesto",
	        "cogli",
	        "coi",
	        "col",
	        "colei",
	        "coll",
	        "coloro",
	        "colui",
	        "come",
	        "concernente",
	        "consiglio",
	        "contro",
	        "cortesia",
	        "cos",
	        "cosi",
	        "cosÃ",
	        "d",
	        "dagli",
	        "dai",
	        "dal",
	        "dall",
	        "dalla",
	        "dalle",
	        "dallo",
	        "davanti",
	        "degli",
	        "dei",
	        "dell",
	        "delle",
	        "detto",
	        "dice",
	        "dietro",
	        "dire",
	        "dirimpetto",
	        "dopo",
	        "dove",
	        "dovra",
	        "dovrÃ",
	        "dunque",
	        "durante",
	        "Ã",
	        "ed",
	        "egli",
	        "ella",
	        "eppure",
	        "era",
	        "erano",
	        "esse",
	        "essendo",
	        "esser",
	        "essere",
	        "essi",
	        "ex",
	        "fa",
	        "fatto",
	        "favore",
	        "fin",
	        "finalmente",
	        "finche",
	        "forse",
	        "fuori",
	        "gia",
	        "giÃ",
	        "giacche",
	        "giorni",
	        "giorno",
	        "gli",
	        "gliela",
	        "gliele",
	        "glieli",
	        "glielo",
	        "gliene",
	        "governo",
	        "grande",
	        "grazie",
	        "gruppo",
	        "i",
	        "ieri",
	        "improvviso",
	        "in",
	        "infatti",
	        "insieme",
	        "intanto",
	        "intorno",
	        "l",
	        "lÃ",
	        "li",
	        "lontano",
	        "macche",
	        "magari",
	        "mai",
	        "male",
	        "malgrado",
	        "malissimo",
	        "medesimo",
	        "mediante",
	        "meno",
	        "mentre",
	        "mesi",
	        "mezzo",
	        "mi",
	        "mia",
	        "mie",
	        "miei",
	        "mila",
	        "miliardi",
	        "milioni",
	        "ministro",
	        "mio",
	        "moltissimo",
	        "mondo",
	        "nazionale",
	        "ne",
	        "negli",
	        "nel",
	        "nell",
	        "nelle",
	        "nello",
	        "nemmeno",
	        "neppure",
	        "nessuna",
	        "nessuno",
	        "niente",
	        "non",
	        "nondimeno",
	        "nostra",
	        "nostre",
	        "nostri",
	        "nulla",
	        "od",
	        "oggi",
	        "ogni",
	        "ognuna",
	        "ognuno",
	        "oppure",
	        "ore",
	        "osi",
	        "ossia",
	        "paese",
	        "parecchi",
	        "parecchie",
	        "parecchio",
	        "parte",
	        "partendo",
	        "peccato",
	        "per",
	        "perche",
	        "perchÃ",
	        "percio",
	        "perciÃ",
	        "perfino",
	        "perÃ",
	        "piedi",
	        "pieno",
	        "piglia",
	        "piÃ",
	        "po",
	        "pochissimo",
	        "poi",
	        "poiche",
	        "press",
	        "prima",
	        "proprio",
	        "puo",
	        "puÃ",
	        "pure",
	        "purtroppo",
	        "qualche",
	        "qualcuna",
	        "qualcuno",
	        "quale",
	        "quali",
	        "qualunque",
	        "quando",
	        "quanta",
	        "quante",
	        "quanti",
	        "quanto",
	        "quantunque",
	        "quel",
	        "quella",
	        "quelli",
	        "quest",
	        "questa",
	        "queste",
	        "questi",
	        "riecco",
	        "salvo",
	        "sarÃ",
	        "sarebbe",
	        "scopo",
	        "scorso",
	        "se",
	        "seguente",
	        "sempre",
	        "si",
	        "solito",
	        "sta",
	        "staranno",
	        "stata",
	        "state",
	        "sua",
	        "successivo",
	        "sue",
	        "sugli",
	        "sui",
	        "sull",
	        "sulle",
	        "sullo",
	        "suo",
	        "suoi",
	        "tale",
	        "talvolta",
	        "ti",
	        "torino",
	        "tranne",
	        "troppo",
	        "tu",
	        "tua",
	        "tue",
	        "tuo",
	        "tuoi",
	        "tutta",
	        "tuttavia",
	        "tutte",
	        "tutti",
	        "tutto",
	        "uguali",
	        "uomo",
	        "vale",
	        "varia",
	        "varie",
	        "vario",
	        "verso",
	        "vi",
	        "via",
	        "vicino",
	        "visto",
	        "vita",
	        "volta",
	        "vostra",
	        "vostre",
	        "vostri"
	    ]
	};


/***/ },
/* 2968 */
/***/ function(module, exports) {

	/**
	 * Created by jan on 9-3-15.
	 */
	// Dutch stopwords
	// via https://code.google.com/p/stop-words/
	
	
	
	module.exports = {
	    stopwords:[
	        "aan",
	        "af",
	        "al",
	        "als",
	        "bij",
	        "dan",
	        "dat",
	        "die",
	        "dit",
	        "een",
	        "en",
	        "er",
	        "had",
	        "heb",
	        "hem",
	        "het",
	        "hij",
	        "hoe",
	        "hun",
	        "ik",
	        "in",
	        "is",
	        "je",
	        "kan",
	        "me",
	        "men",
	        "met",
	        "mij",
	        "nog",
	        "nu",
	        "of",
	        "ons",
	        "ook",
	        "te",
	        "tot",
	        "uit",
	        "van",
	        "was",
	        "wat",
	        "we",
	        "wel",
	        "wij",
	        "zal",
	        "ze",
	        "zei",
	        "zij",
	        "zo",
	        "zou",
	        "aan",
	        "aangaande",
	        "aangezien",
	        "achter",
	        "achterna",
	        "afgelopen",
	        "al",
	        "aldaar",
	        "aldus",
	        "alhoewel",
	        "alias",
	        "alle",
	        "allebei",
	        "alleen",
	        "alsnog",
	        "altijd",
	        "altoos",
	        "ander",
	        "andere",
	        "anders",
	        "anderszins",
	        "behalve",
	        "behoudens",
	        "beide",
	        "beiden",
	        "ben",
	        "beneden",
	        "bent",
	        "bepaald",
	        "betreffende",
	        "bij",
	        "binnen",
	        "binnenin",
	        "boven",
	        "bovenal",
	        "bovendien",
	        "bovengenoemd",
	        "bovenstaand",
	        "bovenvermeld",
	        "buiten",
	        "daar",
	        "daarheen",
	        "daarin",
	        "daarna",
	        "daarnet",
	        "daarom",
	        "daarop",
	        "daarvanlangs",
	        "dan",
	        "dat",
	        "de",
	        "die",
	        "dikwijls",
	        "dit",
	        "door",
	        "doorgaand",
	        "dus",
	        "echter",
	        "eer",
	        "eerdat",
	        "eerder",
	        "eerlang",
	        "eerst",
	        "elk",
	        "elke",
	        "en",
	        "enig",
	        "enigszins",
	        "enkel",
	        "er",
	        "erdoor",
	        "even",
	        "eveneens",
	        "evenwel",
	        "gauw",
	        "gedurende",
	        "geen",
	        "gehad",
	        "gekund",
	        "geleden",
	        "gelijk",
	        "gemoeten",
	        "gemogen",
	        "geweest",
	        "gewoon",
	        "gewoonweg",
	        "haar",
	        "had",
	        "hadden",
	        "hare",
	        "heb",
	        "hebben",
	        "hebt",
	        "heeft",
	        "hem",
	        "hen",
	        "het",
	        "hierbeneden",
	        "hierboven",
	        "hij",
	        "hoe",
	        "hoewel",
	        "hun",
	        "hunne",
	        "ik",
	        "ikzelf",
	        "in",
	        "inmiddels",
	        "inzake",
	        "is",
	        "jezelf",
	        "jij",
	        "jijzelf",
	        "jou",
	        "jouw",
	        "jouwe",
	        "juist",
	        "jullie",
	        "kan",
	        "klaar",
	        "kon",
	        "konden",
	        "krachtens",
	        "kunnen",
	        "kunt",
	        "later",
	        "liever",
	        "maar",
	        "mag",
	        "meer",
	        "met",
	        "mezelf",
	        "mij",
	        "mijn",
	        "mijnent",
	        "mijner",
	        "mijzelf",
	        "misschien",
	        "mocht",
	        "mochten",
	        "moest",
	        "moesten",
	        "moet",
	        "moeten",
	        "mogen",
	        "na",
	        "naar",
	        "nadat",
	        "net",
	        "niet",
	        "noch",
	        "nog",
	        "nogal",
	        "nu",
	        "of",
	        "ofschoon",
	        "om",
	        "omdat",
	        "omhoog",
	        "omlaag",
	        "omstreeks",
	        "omtrent",
	        "omver",
	        "onder",
	        "ondertussen",
	        "ongeveer",
	        "ons",
	        "onszelf",
	        "onze",
	        "ook",
	        "op",
	        "opnieuw",
	        "opzij",
	        "over",
	        "overeind",
	        "overigens",
	        "pas",
	        "precies",
	        "reeds",
	        "rond",
	        "rondom",
	        "sedert",
	        "sinds",
	        "sindsdien",
	        "slechts",
	        "sommige",
	        "spoedig",
	        "steeds",
	        "tamelijk",
	        "tenzij",
	        "terwijl",
	        "thans",
	        "tijdens",
	        "toch",
	        "toen",
	        "toenmaals",
	        "toenmalig",
	        "tot",
	        "totdat",
	        "tussen",
	        "uit",
	        "uitgezonderd",
	        "vaakwat",
	        "van",
	        "vandaan",
	        "vanuit",
	        "vanwege",
	        "veeleer",
	        "verder",
	        "vervolgens",
	        "vol",
	        "volgens",
	        "voor",
	        "vooraf",
	        "vooral",
	        "vooralsnog",
	        "voorbij",
	        "voordat",
	        "voordezen",
	        "voordien",
	        "voorheen",
	        "voorop",
	        "vooruit",
	        "vrij",
	        "vroeg",
	        "waar",
	        "waarom",
	        "wanneer",
	        "want",
	        "waren",
	        "was",
	        "weer",
	        "weg",
	        "wegens",
	        "wel",
	        "weldra",
	        "welk",
	        "welke",
	        "wie",
	        "wiens",
	        "wier",
	        "wij",
	        "wijzelf",
	        "zal",
	        "ze",
	        "zelfs",
	        "zichzelf",
	        "zij",
	        "zijn",
	        "zijne",
	        "zo",
	        "zodra",
	        "zonder",
	        "zou",
	        "zouden",
	        "zowat",
	        "zulke",
	        "zullen",
	        "zult"
	    ]
	};
	


/***/ },
/* 2969 */
/***/ function(module, exports) {

	// via http://hackage.haskell.org/package/glider-nlp-0.1/docs/src/Glider-NLP-Language-Polish-StopWords.html
	module.exports = {
	    stopwords:[
	        "a",
	"aby",
	"ach",
	"acz",
	"aczkolwiek",
	"aj",
	"albo",
	"ale",
	"alez",
	"ależ",
	"ani",
	"az",
	"aż",
	"bardziej",
	"bardzo",
	"bo",
	"bowiem",
	"by",
	"byli",
	"bynajmniej",
	"byc",
	"być",
	"byl",
	"był",
	"byla",
	"bylo",
	"byly",
	"była",
	"było",
	"były",
	"bedzie",
	"będzie",
	"beda",
	"będą",
	"cali",
	"cala",
	"cała",
	"caly",
	"cały",
	"ci",
	"cie",
	"cię",
	"ciebie",
	"co",
	"cokolwiek",
	"cos",
	"coś",
	"czasami",
	"czasem",
	"czemu",
	"czy",
	"czyli",
	"daleko",
	"dla",
	"dlaczego",
	"dlatego",
	"do",
	"dobrze",
	"dokad",
	"dokąd",
	"dosc",
	"dość",
	"duzo",
	"dużo",
	"dwa",
	"dwaj",
	"dwie",
	"dwoje",
	"dzis",
	"dziś",
	"dzisiaj",
	"gdy",
	"gdyby",
	"gdyz",
	"gdyż",
	"gdzie",
	"gdziekolwiek",
	"gdzies",
	"gdzieś",
	"go",
	"i",
	"ich",
	"ile",
	"im",
	"inna",
	"inne",
	"inny",
	"innych",
	"iz",
	"iż",
	"ja",
	"ją",
	"jak",
	"jakas",
	"jakaś",
	"jakby",
	"jaki",
	"jakichs",
	"jakichś",
	"jakie",
	"jakis",
	"jakiś",
	"jakiz",
	"jakiż",
	"jakkolwiek",
	"jako",
	"jakos",
	"jakoś",
	"je",
	"jeden",
	"jedna",
	"jedno",
	"jednak",
	"jednakze",
	"jednakże",
	"jego",
	"jej",
	"jemu",
	"jest",
	"jestem",
	"jeszcze",
	"jesli",
	"jeśli",
	"jezeli",
	"jeżeli",
	"juz",
	"już",
	"kazdy",
	"każdy",
	"kiedy",
	"kilka",
	"kims",
	"kimś",
	"kto",
	"ktokolwiek",
	"ktos",
	"ktoś",
	"ktora",
	"ktore",
	"które",
	"ktorego",
	"ktorej",
	"ktory",
	"ktorych",
	"ktorym",
	"ktorzy",
	"która",
	"którego",
	"której",
	"który",
	"których",
	"którym",
	"którzy",
	"ku",
	"lat",
	"lecz",
	"lub",
	"ma",
	"mają",
	"mało",
	"mam",
	"mi",
	"mimo",
	"miedzy",
	"między",
	"mna",
	"mną",
	"mnie",
	"moga",
	"mogą",
	"moi",
	"moim",
	"moja",
	"moje",
	"moze",
	"może",
	"mozliwe",
	"mozna",
	"możliwe",
	"można",
	"moj",
	"mój",
	"mu",
	"musi",
	"my",
	"na",
	"nad",
	"nam",
	"nami",
	"nas",
	"nasi",
	"nasz",
	"nasza",
	"nasze",
	"naszego",
	"naszych",
	"natomiast",
	"natychmiast",
	"nawet",
	"nia",
	"nią",
	"nic",
	"nich",
	"nie",
	"niech",
	"niego",
	"niej",
	"niemu",
	"nigdy",
	"nim",
	"nimi",
	"niz",
	"niż",
	"no",
	"o",
	"obok",
	"od",
	"około",
	"on",
	"ona",
	"one",
	"oni",
	"ono",
	"oraz",
	"oto",
	"owszem",
	"pan",
	"pana",
	"pani",
	"po",
	"pod",
	"podczas",
	"pomimo",
	"ponad",
	"poniewaz",
	"ponieważ",
	"powinien",
	"powinna",
	"powinni",
	"powinno",
	"poza",
	"prawie",
	"przeciez",
	"przecież",
	"przed",
	"przede",
	"przedtem",
	"przez",
	"przy",
	"roku",
	"rowniez",
	"również",
	"sam",
	"sama",
	"są",
	"sie",
	"się",
	"skad",
	"skąd",
	"sobie",
	"soba",
	"sobą",
	"sposob",
	"sposób",
	"swoje",
	"ta",
	"tak",
	"taka",
	"taki",
	"takie",
	"takze",
	"także",
	"tam",
	"te",
	"tego",
	"tej",
	"ten",
	"teraz",
	"też",
	"to",
	"toba",
	"tobą",
	"tobie",
	"totez",
	"toteż",
	"trzeba",
	"tu",
	"tutaj",
	"twoi",
	"twoim",
	"twoja",
	"twoje",
	"twym",
	"twoj",
	"twój",
	"ty",
	"tych",
	"tylko",
	"tym",
	"u",
	"w",
	"wam",
	"wami",
	"was",
	"wasz",
	"wasza",
	"wasze",
	"we",
	"według",
	"wiele",
	"wielu",
	"więc",
	"więcej",
	"wszyscy",
	"wszystkich",
	"wszystkie",
	"wszystkim",
	"wszystko",
	"wtedy",
	"wy",
	"wlasnie",
	"właśnie",
	"z",
	"za",
	"zapewne",
	"zawsze",
	"ze",
	"znowu",
	"znow",
	"znów",
	"zostal",
	"został",
	"zaden",
	"zadna",
	"zadne",
	"zadnych",
	"ze",
	"zeby",
	"żaden",
	"żadna",
	"żadne",
	"żadnych",
	"że",
	"żeby"
	    ]
	};


/***/ },
/* 2970 */
/***/ function(module, exports) {

	/**
	 * Created by rodrigo on 01/10/15.
	 */
	
	//Portuguese (BRAZIL) stopwords
	// via https://sites.google.com/site/kevinbouge/stopwords-lists
	module.exports = {
	    stopwords: [
	        "a",
	        "à",
	        "adeus",
	        "agora",
	        "aí",
	        "ainda",
	        "além",
	        "algo",
	        "algumas",
	        "alguns",
	        "ali",
	        "ano",
	        "anos",
	        "antes",
	        "ao",
	        "aos",
	        "apenas",
	        "apoio",
	        "após",
	        "aquela",
	        "aquelas",
	        "aquele",
	        "aqueles",
	        "aqui",
	        "aquilo",
	        "área",
	        "as",
	        "às",
	        "assim",
	        "até",
	        "atrás",
	        "através",
	        "baixo",
	        "bastante",
	        "bem",
	        "boa",
	        "boas",
	        "bom",
	        "bons",
	        "breve",
	        "cá",
	        "cada",
	        "catorze",
	        "cedo",
	        "cento",
	        "certamente",
	        "certeza",
	        "cima",
	        "cinco",
	        "coisa",
	        "com",
	        "como",
	        "conselho",
	        "contra",
	        "custa",
	        "da",
	        "dá",
	        "dão",
	        "daquela",
	        "daquelas",
	        "daquele",
	        "daqueles",
	        "dar",
	        "das",
	        "de",
	        "debaixo",
	        "demais",
	        "dentro",
	        "depois",
	        "desde",
	        "dessa",
	        "dessas",
	        "desse",
	        "desses",
	        "desta",
	        "destas",
	        "deste",
	        "destes",
	        "deve",
	        "deverá",
	        "dez",
	        "dezanove",
	        "dezasseis",
	        "dezassete",
	        "dezoito",
	        "dia",
	        "diante",
	        "diz",
	        "dizem",
	        "dizer",
	        "do",
	        "dois",
	        "dos",
	        "doze",
	        "duas",
	        "dúvida",
	        "e",
	        "é",
	        "ela",
	        "elas",
	        "ele",
	        "eles",
	        "em",
	        "embora",
	        "entre",
	        "era",
	        "és",
	        "essa",
	        "essas",
	        "esse",
	        "esses",
	        "esta",
	        "está",
	        "estão",
	        "estar",
	        "estas",
	        "estás",
	        "estava",
	        "este",
	        "estes",
	        "esteve",
	        "estive",
	        "estivemos",
	        "estiveram",
	        "estiveste",
	        "estivestes",
	        "estou",
	        "eu",
	        "exemplo",
	        "faço",
	        "falta",
	        "favor",
	        "faz",
	        "fazeis",
	        "fazem",
	        "fazemos",
	        "fazer",
	        "fazes",
	        "fez",
	        "fim",
	        "final",
	        "foi",
	        "fomos",
	        "for",
	        "foram",
	        "forma",
	        "foste",
	        "fostes",
	        "fui",
	        "geral",
	        "grande",
	        "grandes",
	        "grupo",
	        "há",
	        "hoje",
	        "hora",
	        "horas",
	        "isso",
	        "isto",
	        "já",
	        "lá",
	        "lado",
	        "local",
	        "logo",
	        "longe",
	        "lugar",
	        "maior",
	        "maioria",
	        "mais",
	        "mal",
	        "mas",
	        "máximo",
	        "me",
	        "meio",
	        "menor",
	        "menos",
	        "mês",
	        "meses",
	        "meu",
	        "meus",
	        "mil",
	        "minha",
	        "minhas",
	        "momento",
	        "muito",
	        "muitos",
	        "na",
	        "nada",
	        "não",
	        "naquela",
	        "naquelas",
	        "naquele",
	        "naqueles",
	        "nas",
	        "nem",
	        "nenhuma",
	        "nessa",
	        "nessas",
	        "nesse",
	        "nesses",
	        "nesta",
	        "nestas",
	        "neste",
	        "nestes",
	        "nível",
	        "no",
	        "noite",
	        "nome",
	        "nos",
	        "nós",
	        "nossa",
	        "nossas",
	        "nosso",
	        "nossos",
	        "nova",
	        "novas",
	        "nove",
	        "novo",
	        "novos",
	        "num",
	        "numa",
	        "número",
	        "nunca",
	        "o",
	        "obra",
	        "obrigada",
	        "obrigado",
	        "oitava",
	        "oitavo",
	        "oito",
	        "onde",
	        "ontem",
	        "onze",
	        "os",
	        "ou",
	        "outra",
	        "outras",
	        "outro",
	        "outros",
	        "para",
	        "parece",
	        "parte",
	        "partir",
	        "paucas",
	        "pela",
	        "pelas",
	        "pelo",
	        "pelos",
	        "perto",
	        "pode",
	        "pôde",
	        "podem",
	        "poder",
	        "põe",
	        "põem",
	        "ponto",
	        "pontos",
	        "por",
	        "porque",
	        "porquê",
	        "posição",
	        "possível",
	        "possivelmente",
	        "posso",
	        "pouca",
	        "pouco",
	        "poucos",
	        "primeira",
	        "primeiras",
	        "primeiro",
	        "primeiros",
	        "própria",
	        "próprias",
	        "próprio",
	        "próprios",
	        "próxima",
	        "próximas",
	        "próximo",
	        "próximos",
	        "puderam",
	        "quáis",
	        "qual",
	        "quando",
	        "quanto",
	        "quarta",
	        "quarto",
	        "quatro",
	        "que",
	        "quê",
	        "quem",
	        "quer",
	        "quereis",
	        "querem",
	        "queremas",
	        "queres",
	        "quero",
	        "questão",
	        "quinta",
	        "quinto",
	        "quinze",
	        "relação",
	        "sabe",
	        "sabem",
	        "são",
	        "se",
	        "segunda",
	        "segundo",
	        "sei",
	        "seis",
	        "sem",
	        "sempre",
	        "ser",
	        "seria",
	        "sete",
	        "sétima",
	        "sétimo",
	        "seu",
	        "seus",
	        "sexta",
	        "sexto",
	        "sim",
	        "sistema",
	        "sob",
	        "sobre",
	        "sois",
	        "somos",
	        "sou",
	        "sua",
	        "suas",
	        "tal",
	        "talvez",
	        "também",
	        "tanta",
	        "tantas",
	        "tanto",
	        "tão",
	        "tarde",
	        "te",
	        "tem",
	        "têm",
	        "temos",
	        "tendes",
	        "tenho",
	        "tens",
	        "ter",
	        "terceira",
	        "terceiro",
	        "teu",
	        "teus",
	        "teve",
	        "tive",
	        "tivemos",
	        "tiveram",
	        "tiveste",
	        "tivestes",
	        "toda",
	        "todas",
	        "todo",
	        "todos",
	        "trabalho",
	        "três",
	        "treze",
	        "tu",
	        "tua",
	        "tuas",
	        "tudo",
	        "um",
	        "uma",
	        "umas",
	        "uns",
	        "vai",
	        "vais",
	        "vão",
	        "vários",
	        "vem",
	        "vêm",
	        "vens",
	        "ver",
	        "vez",
	        "vezes",
	        "viagem",
	        "vindo",
	        "vinte",
	        "você",
	        "vocês",
	        "vos",
	        "vós",
	        "vossa",
	        "vossas",
	        "vosso",
	        "vossos",
	        "zero"
	    ]
	};

/***/ },
/* 2971 */
/***/ function(module, exports) {

	/**
	 * Created by jan on 9-3-15.
	 */
	// Russian stopwords
	// via https://code.google.com/p/stop-words/
	
	module.exports = {
	    stopwords: [
	        "а",
	        "е",
	        "и",
	        "ж",
	        "м",
	        "о",
	        "на",
	        "не",
	        "ни",
	        "об",
	        "но",
	        "он",
	        "мне",
	        "мои",
	        "мож",
	        "она",
	        "они",
	        "оно",
	        "мной",
	        "много",
	        "многочисленное",
	        "многочисленная",
	        "многочисленные",
	        "многочисленный",
	        "мною",
	        "мой",
	        "мог",
	        "могут",
	        "можно",
	        "может",
	        "можхо",
	        "мор",
	        "моя",
	        "моё",
	        "мочь",
	        "над",
	        "нее",
	        "оба",
	        "нам",
	        "нем",
	        "нами",
	        "ними",
	        "мимо",
	        "немного",
	        "одной",
	        "одного",
	        "менее",
	        "однажды",
	        "однако",
	        "меня",
	        "нему",
	        "меньше",
	        "ней",
	        "наверху",
	        "него",
	        "ниже",
	        "мало",
	        "надо",
	        "один",
	        "одиннадцать",
	        "одиннадцатый",
	        "назад",
	        "наиболее",
	        "недавно",
	        "миллионов",
	        "недалеко",
	        "между",
	        "низко",
	        "меля",
	        "нельзя",
	        "нибудь",
	        "непрерывно",
	        "наконец",
	        "никогда",
	        "никуда",
	        "нас",
	        "наш",
	        "нет",
	        "нею",
	        "неё",
	        "них",
	        "мира",
	        "наша",
	        "наше",
	        "наши",
	        "ничего",
	        "начала",
	        "нередко",
	        "несколько",
	        "обычно",
	        "опять",
	        "около",
	        "мы",
	        "ну",
	        "нх",
	        "от",
	        "отовсюду",
	        "особенно",
	        "нужно",
	        "очень",
	        "отсюда",
	        "в",
	        "во",
	        "вон",
	        "вниз",
	        "внизу",
	        "вокруг",
	        "вот",
	        "восемнадцать",
	        "восемнадцатый",
	        "восемь",
	        "восьмой",
	        "вверх",
	        "вам",
	        "вами",
	        "важное",
	        "важная",
	        "важные",
	        "важный",
	        "вдали",
	        "везде",
	        "ведь",
	        "вас",
	        "ваш",
	        "ваша",
	        "ваше",
	        "ваши",
	        "впрочем",
	        "весь",
	        "вдруг",
	        "вы",
	        "все",
	        "второй",
	        "всем",
	        "всеми",
	        "времени",
	        "время",
	        "всему",
	        "всего",
	        "всегда",
	        "всех",
	        "всею",
	        "всю",
	        "вся",
	        "всё",
	        "всюду",
	        "г",
	        "год",
	        "говорил",
	        "говорит",
	        "года",
	        "году",
	        "где",
	        "да",
	        "ее",
	        "за",
	        "из",
	        "ли",
	        "же",
	        "им",
	        "до",
	        "по",
	        "ими",
	        "под",
	        "иногда",
	        "довольно",
	        "именно",
	        "долго",
	        "позже",
	        "более",
	        "должно",
	        "пожалуйста",
	        "значит",
	        "иметь",
	        "больше",
	        "пока",
	        "ему",
	        "имя",
	        "пор",
	        "пора",
	        "потом",
	        "потому",
	        "после",
	        "почему",
	        "почти",
	        "посреди",
	        "ей",
	        "два",
	        "две",
	        "двенадцать",
	        "двенадцатый",
	        "двадцать",
	        "двадцатый",
	        "двух",
	        "его",
	        "дел",
	        "или",
	        "без",
	        "день",
	        "занят",
	        "занята",
	        "занято",
	        "заняты",
	        "действительно",
	        "давно",
	        "девятнадцать",
	        "девятнадцатый",
	        "девять",
	        "девятый",
	        "даже",
	        "алло",
	        "жизнь",
	        "далеко",
	        "близко",
	        "здесь",
	        "дальше",
	        "для",
	        "лет",
	        "зато",
	        "даром",
	        "первый",
	        "перед",
	        "затем",
	        "зачем",
	        "лишь",
	        "десять",
	        "десятый",
	        "ею",
	        "её",
	        "их",
	        "бы",
	        "еще",
	        "при",
	        "был",
	        "про",
	        "процентов",
	        "против",
	        "просто",
	        "бывает",
	        "бывь",
	        "если",
	        "люди",
	        "была",
	        "были",
	        "было",
	        "будем",
	        "будет",
	        "будете",
	        "будешь",
	        "прекрасно",
	        "буду",
	        "будь",
	        "будто",
	        "будут",
	        "ещё",
	        "пятнадцать",
	        "пятнадцатый",
	        "друго",
	        "другое",
	        "другой",
	        "другие",
	        "другая",
	        "других",
	        "есть",
	        "пять",
	        "быть",
	        "лучше",
	        "пятый",
	        "к",
	        "ком",
	        "конечно",
	        "кому",
	        "кого",
	        "когда",
	        "которой",
	        "которого",
	        "которая",
	        "которые",
	        "который",
	        "которых",
	        "кем",
	        "каждое",
	        "каждая",
	        "каждые",
	        "каждый",
	        "кажется",
	        "как",
	        "какой",
	        "какая",
	        "кто",
	        "кроме",
	        "куда",
	        "кругом",
	        "с",
	        "т",
	        "у",
	        "я",
	        "та",
	        "те",
	        "уж",
	        "со",
	        "то",
	        "том",
	        "снова",
	        "тому",
	        "совсем",
	        "того",
	        "тогда",
	        "тоже",
	        "собой",
	        "тобой",
	        "собою",
	        "тобою",
	        "сначала",
	        "только",
	        "уметь",
	        "тот",
	        "тою",
	        "хорошо",
	        "хотеть",
	        "хочешь",
	        "хоть",
	        "хотя",
	        "свое",
	        "свои",
	        "твой",
	        "своей",
	        "своего",
	        "своих",
	        "свою",
	        "твоя",
	        "твоё",
	        "раз",
	        "уже",
	        "сам",
	        "там",
	        "тем",
	        "чем",
	        "сама",
	        "сами",
	        "теми",
	        "само",
	        "рано",
	        "самом",
	        "самому",
	        "самой",
	        "самого",
	        "семнадцать",
	        "семнадцатый",
	        "самим",
	        "самими",
	        "самих",
	        "саму",
	        "семь",
	        "чему",
	        "раньше",
	        "сейчас",
	        "чего",
	        "сегодня",
	        "себе",
	        "тебе",
	        "сеаой",
	        "человек",
	        "разве",
	        "теперь",
	        "себя",
	        "тебя",
	        "седьмой",
	        "спасибо",
	        "слишком",
	        "так",
	        "такое",
	        "такой",
	        "такие",
	        "также",
	        "такая",
	        "сих",
	        "тех",
	        "чаще",
	        "четвертый",
	        "через",
	        "часто",
	        "шестой",
	        "шестнадцать",
	        "шестнадцатый",
	        "шесть",
	        "четыре",
	        "четырнадцать",
	        "четырнадцатый",
	        "сколько",
	        "сказал",
	        "сказала",
	        "сказать",
	        "ту",
	        "ты",
	        "три",
	        "эта",
	        "эти",
	        "что",
	        "это",
	        "чтоб",
	        "этом",
	        "этому",
	        "этой",
	        "этого",
	        "чтобы",
	        "этот",
	        "стал",
	        "туда",
	        "этим",
	        "этими",
	        "рядом",
	        "тринадцать",
	        "тринадцатый",
	        "этих",
	        "третий",
	        "тут",
	        "эту",
	        "суть",
	        "чуть",
	        "тысяч"
	    ]
	};


/***/ },
/* 2972 */
/***/ function(module, exports) {

	/**
	 * Created by jan on 9-3-15.
	 */
	// Swedish stopwords
	// http://www.ranks.nl/stopwords/swedish
	// https://github.com/AlexGustafsson
	
	module.exports = {
	    stopwords: [
	        "aderton",
	        "adertonde",
	        "adjö",
	        "aldrig",
	        "alla",
	        "allas",
	        "allt",
	        "alltid",
	        "alltså",
	        "än",
	        "andra",
	        "andras",
	        "annan",
	        "annat",
	        "ännu",
	        "artonde",
	        "artonn",
	        "åtminstone",
	        "att",
	        "åtta",
	        "åttio",
	        "åttionde",
	        "åttonde",
	        "av",
	        "även",
	        "båda",
	        "bådas",
	        "bakom",
	        "bara",
	        "bäst",
	        "bättre",
	        "behöva",
	        "behövas",
	        "behövde",
	        "behövt",
	        "beslut",
	        "beslutat",
	        "beslutit",
	        "bland",
	        "blev",
	        "bli",
	        "blir",
	        "blivit",
	        "bort",
	        "borta",
	        "bra",
	        "då",
	        "dag",
	        "dagar",
	        "dagarna",
	        "dagen",
	        "där",
	        "därför",
	        "de",
	        "del",
	        "delen",
	        "dem",
	        "den",
	        "deras",
	        "dess",
	        "det",
	        "detta",
	        "dig",
	        "din",
	        "dina",
	        "dit",
	        "ditt",
	        "dock",
	        "du",
	        "efter",
	        "eftersom",
	        "elfte",
	        "eller",
	        "elva",
	        "en",
	        "enkel",
	        "enkelt",
	        "enkla",
	        "enligt",
	        "er",
	        "era",
	        "ert",
	        "ett",
	        "ettusen",
	        "få",
	        "fanns",
	        "får",
	        "fått",
	        "fem",
	        "femte",
	        "femtio",
	        "femtionde",
	        "femton",
	        "femtonde",
	        "fick",
	        "fin",
	        "finnas",
	        "finns",
	        "fjärde",
	        "fjorton",
	        "fjortonde",
	        "fler",
	        "flera",
	        "flesta",
	        "följande",
	        "för",
	        "före",
	        "förlåt",
	        "förra",
	        "första",
	        "fram",
	        "framför",
	        "från",
	        "fyra",
	        "fyrtio",
	        "fyrtionde",
	        "gå",
	        "gälla",
	        "gäller",
	        "gällt",
	        "går",
	        "gärna",
	        "gått",
	        "genast",
	        "genom",
	        "gick",
	        "gjorde",
	        "gjort",
	        "god",
	        "goda",
	        "godare",
	        "godast",
	        "gör",
	        "göra",
	        "gott",
	        "ha",
	        "hade",
	        "haft",
	        "han",
	        "hans",
	        "har",
	        "här",
	        "heller",
	        "hellre",
	        "helst",
	        "helt",
	        "henne",
	        "hennes",
	        "hit",
	        "hög",
	        "höger",
	        "högre",
	        "högst",
	        "hon",
	        "honom",
	        "hundra",
	        "hundraen",
	        "hundraett",
	        "hur",
	        "i",
	        "ibland",
	        "idag",
	        "igår",
	        "igen",
	        "imorgon",
	        "in",
	        "inför",
	        "inga",
	        "ingen",
	        "ingenting",
	        "inget",
	        "innan",
	        "inne",
	        "inom",
	        "inte",
	        "inuti",
	        "ja",
	        "jag",
	        "jämfört",
	        "kan",
	        "kanske",
	        "knappast",
	        "kom",
	        "komma",
	        "kommer",
	        "kommit",
	        "kr",
	        "kunde",
	        "kunna",
	        "kunnat",
	        "kvar",
	        "länge",
	        "längre",
	        "långsam",
	        "långsammare",
	        "långsammast",
	        "långsamt",
	        "längst",
	        "långt",
	        "lätt",
	        "lättare",
	        "lättast",
	        "legat",
	        "ligga",
	        "ligger",
	        "lika",
	        "likställd",
	        "likställda",
	        "lilla",
	        "lite",
	        "liten",
	        "litet",
	        "man",
	        "många",
	        "måste",
	        "med",
	        "mellan",
	        "men",
	        "mer",
	        "mera",
	        "mest",
	        "mig",
	        "min",
	        "mina",
	        "mindre",
	        "minst",
	        "mitt",
	        "mittemot",
	        "möjlig",
	        "möjligen",
	        "möjligt",
	        "möjligtvis",
	        "mot",
	        "mycket",
	        "någon",
	        "någonting",
	        "något",
	        "några",
	        "när",
	        "nästa",
	        "ned",
	        "nederst",
	        "nedersta",
	        "nedre",
	        "nej",
	        "ner",
	        "ni",
	        "nio",
	        "nionde",
	        "nittio",
	        "nittionde",
	        "nitton",
	        "nittonde",
	        "nödvändig",
	        "nödvändiga",
	        "nödvändigt",
	        "nödvändigtvis",
	        "nog",
	        "noll",
	        "nr",
	        "nu",
	        "nummer",
	        "och",
	        "också",
	        "ofta",
	        "oftast",
	        "olika",
	        "olikt",
	        "om",
	        "oss",
	        "över",
	        "övermorgon",
	        "överst",
	        "övre",
	        "på",
	        "rakt",
	        "rätt",
	        "redan",
	        "redigera",
	        "så",
	        "sade",
	        "säga",
	        "säger",
	        "sagt",
	        "samma",
	        "sämre",
	        "sämst",
	        "se",
	        "sedan",
	        "senare",
	        "senast",
	        "sent",
	        "sex",
	        "sextio",
	        "sextionde",
	        "sexton",
	        "sextonde",
	        "sig",
	        "sin",
	        "sina",
	        "sist",
	        "sista",
	        "siste",
	        "sitt",
	        "sjätte",
	        "sju",
	        "sjunde",
	        "sjuttio",
	        "sjuttionde",
	        "sjutton",
	        "sjuttonde",
	        "ska",
	        "skall",
	        "skulle",
	        "slutligen",
	        "små",
	        "smått",
	        "snart",
	        "som",
	        "stor",
	        "stora",
	        "större",
	        "störst",
	        "stort",
	        "tack",
	        "tidig",
	        "tidigare",
	        "tidigast",
	        "tidigt",
	        "till",
	        "tills",
	        "tillsammans",
	        "tio",
	        "tionde",
	        "tjugo",
	        "tjugoen",
	        "tjugoett",
	        "tjugonde",
	        "tjugotre",
	        "tjugotvå",
	        "tjungo",
	        "tolfte",
	        "tolv",
	        "tre",
	        "tredje",
	        "trettio",
	        "trettionde",
	        "tretton",
	        "trettonde",
	        "två",
	        "tvåhundra",
	        "under",
	        "upp",
	        "ur",
	        "ursäkt",
	        "ut",
	        "utan",
	        "utanför",
	        "ute",
	        "vad",
	        "vänster",
	        "vänstra",
	        "vår",
	        "vara",
	        "våra",
	        "varför",
	        "varifrån",
	        "varit",
	        "varken",
	        "värre",
	        "varsågod",
	        "vart",
	        "vårt",
	        "vem",
	        "vems",
	        "verkligen",
	        "vi",
	        "vid",
	        "vidare",
	        "viktig",
	        "viktigare",
	        "viktigast",
	        "viktigt",
	        "vilka",
	        "vilken",
	        "vilket",
	        "vill",
	        "är",
	        "år",
	
	        "även",
	        "dessa",
	        "wikitext",
	        "wikipedia",
	        "tyngre",
	        "tung",
	        "tyngst",
	        "kall",
	        "var",
	        "minimum",
	        "min",
	        "max",
	        "maximum",
	        "ökning",
	        "öka",
	        "kallar",
	        "hjälp",
	        "använder",
	        "betydligt",
	        "sätt",
	        "denna",
	        "detta",
	        "det",
	        "hjälpa",
	        "används",
	        "består",
	        "tränger",
	        "igenom",
	        "denna",
	        "utöka",
	        "utarmat",
	        "ungefär",
	        "sprids",
	        "betydligt",
	        "omgivande",
	        "via",
	        "huvudartikel",
	        "exempel",
	        "exempelvis",
	        "vanligt",
	        "per",
	        "största",
	        "stor",
	        "ord",
	        "ordet",
	        "kallas",
	        "påbörjad",
	        "höra",
	        "främst",
	        "ihop",
	        "antalet",
	        "the",
	        "uttryck",
	        "uttrycket",
	        "ändra",
	        "presenteras",
	        "presenterades",
	        "tänka",
	        "delar",
	        "söka",
	        "hämta",
	        "innehåll",
	        "definera",
	        "använda",
	        "pekar",
	        "istället",
	        "stället",
	        "pekar",
	        "standard",
	        "vanligaste",
	        "heter",
	        "precist",
	        "felaktigt",
	        "källor",
	        "höga",
	        "mottagare",
	        "eng",
	        "bildade",
	        "bytte",
	        "bildades",
	        "grundades",
	        "svar",
	        "betyder",
	        "betydelse",
	        "möjligheter",
	        "möjlig",
	        "möjlighet",
	        "syfte",
	        "gamla",
	        "tioårig",
	        "år",
	        "övergångsperiod",
	        "ersättas",
	        "användes",
	        "används",
	        "utgörs",
	        "drygt",
	        "alla",
	        "allt",
	        "alltså",
	        "andra",
	        "att",
	        "bara",
	        "bli",
	        "blir",
	        "borde",
	        "bra",
	        "mitt",
	        "ser",
	        "dem",
	        "den",
	        "denna",
	        "det",
	        "detta",
	        "dig",
	        "din",
	        "dock",
	        "dom",
	        "där",
	        "edit",
	        "efter",
	        "eftersom",
	        "eller",
	        "ett",
	        "fast",
	        "fel",
	        "fick",
	        "finns",
	        "fram",
	        "från",
	        "får",
	        "fått",
	        "för",
	        "första",
	        "genom",
	        "ger",
	        "går",
	        "gör",
	        "göra",
	        "hade",
	        "han",
	        "har",
	        "hela",
	        "helt",
	        "honom",
	        "hur",
	        "här",
	        "iaf",
	        "igen",
	        "ingen",
	        "inget",
	        "inte",
	        "jag",
	        "kan",
	        "kanske",
	        "kommer",
	        "lika",
	        "lite",
	        "man",
	        "med",
	        "men",
	        "mer",
	        "mig",
	        "min",
	        "mot",
	        "mycket",
	        "många",
	        "måste",
	        "nog",
	        "när",
	        "någon",
	        "något",
	        "några",
	        "nån",
	        "nåt",
	        "och",
	        "också",
	        "rätt",
	        "samma",
	        "sedan",
	        "sen",
	        "sig",
	        "sin",
	        "själv",
	        "ska",
	        "skulle",
	        "som",
	        "sätt",
	        "tar",
	        "till",
	        "tror",
	        "tycker",
	        "typ",
	        "upp",
	        "utan",
	        "vad",
	        "var",
	        "vara",
	        "vet",
	        "vid",
	        "vilket",
	        "vill",
	        "väl",
	        "även",
	        "över",
	        "förekommer",
	        "varierar",
	        "representera",
	        "representerar",
	        "itu",
	        "påbörjades",
	        "le",
	        "åtgärder",
	        "åtgärd",
	        "sådant",
	        "särskilt",
	        "eftersom",
	        "som",
	        "efter",
	        "syftet",
	        "syfte",
	        "ersatts",
	        "ersätts",
	        "ersatt",
	        "ersätt",
	        "tagits",
	        "byter",
	        "benämningar",
	        "ler",
	        "ärvs",
	        "ärv",
	        "ärvd",
	        "januari",
	        "februari",
	        "mars",
	        "april",
	        "maj",
	        "juni",
	        "juli",
	        "augusti",
	        "september",
	        "oktober",
	        "november",
	        "december",
	        "on",
	        "övriga",
	        "använts",
	        "använd",
	        "används",
	        "använt",
	        "syftar",
	        "ex",
	        "svårt",
	        "svår",
	        "lätt",
	        "lätta",
	        "lättast",
	        "lättare",
	        "svårare",
	        "svårast",
	        "list",
	        "användningsområde",
	        "användningsområden",
	        "vissa",
	        "ii",
	        "hembyggda",
	        "krav",
	        "lugnt",
	        "ändå",
	        "stycken",
	        "styck",
	        "långa",
	        "korta",
	        "små",
	        "stora",
	        "smala",
	        "tjocka",
	        "början",
	        "tungt",
	        "lätt",
	        "tim",
	        "st",
	        "kg",
	        "km",
	        "tid",
	        "ny",
	        "gammal",
	        "nyare",
	        "antal",
	        "snabbare",
	        "började",
	        "ansvar",
	        "ansvarar",
	        "både",
	        "ca",
	        "låg",
	        "hög",
	        "ro",
	        "ton",
	        "kap",
	        "of",
	        "and",
	        "vars",
	        "kr/km",
	        "rör",
	        "gällande",
	        "placeras",
	        "placerades",
	        "täckt",
	        "samt",
	        "hos",
	        "sådana",
	        "endast",
	        "tillstånd",
	        "beror",
	        "på",
	        "marken",
	        "minska",
	        "orsaker",
	        "lösningar",
	        "problem",
	        "namn",
	        "förväntas",
	        "förväntan",
	        "förväntats",
	        "varning",
	        "utfärdas",
	        "utfärda",
	        "km/h",
	        "nådde",
	        "stod",
	        "området",
	        "områden",
	        "källa",
	        "behövs",
	        "drabbade",
	        "drabbat",
	        "which",
	        "top",
	        "that",
	        "lägre",
	        "allmänt",
	        "drog",
	        "drar",
	        "enorma",
	        "ända",
	        "enda",
	        "officiella",
	        "bekräftats",
	        "bekräftas",
	        "fall",
	        "sjunker",
	        "nedåt",
	        "värms",
	        "samtidigt",
	        "efterföljd",
	        "problematik",
	        "uppåt",
	        "utom",
	        "förutom",
	        "hörnet",
	        "söt",
	        "salt",
	        "svag",
	        "stark",
	        "ren",
	        "smutsig",
	        "förr",
	        "tiden",
	        "mångdag",
	        "tisdag",
	        "onsdag",
	        "torsdag",
	        "fredag",
	        "lördag",
	        "söndag",
	        "måndagar",
	        "tisdagar",
	        "onsdagar",
	        "torsdagar",
	        "fredagar",
	        "lördagar",
	        "söndagar",
	        "efterlikna",
	        "som",
	        "lik",
	        "bergis",
	        "bekymmer",
	        "så",
	        "lista",
	        "dig",
	        "dej",
	        "mig",
	        "mej",
	        "fri",
	        "vanlig",
	        "ovanlig",
	        "sällan",
	        "ofta",
	        "avskiljs",
	        "use",
	        "släkte",
	        "släktet",
	        "släkt",
	        "kategori",
	        "kategoriseras",
	        "rensas",
	        "renas",
	        "timmar",
	        "minuter",
	        "sekunder"
	    ]
	};


/***/ },
/* 2973 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
		danish: __webpack_require__(2961).stopwords,
		dutch: __webpack_require__(2968).stopwords,
		english: __webpack_require__(2963).stopwords,
		french: __webpack_require__(2965).stopwords,
		galician: __webpack_require__(2966).stopwords,
		german: __webpack_require__(2962).stopwords,
		italian: __webpack_require__(2967).stopwords,
		polish: __webpack_require__(2969).stopwords,
		portuguese: __webpack_require__(2970).stopwords,
		russian: __webpack_require__(2971).stopwords,
		spanish: __webpack_require__(2964).stopwords,
		swedish: __webpack_require__(2972).stopwords
	};


/***/ },
/* 2974 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.7.0
	//     http://underscorejs.org
	//     (c) 2009-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    concat           = ArrayProto.concat,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind;
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.7.0';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var createCallback = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  _.iteratee = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return createCallback(value, context, argCount);
	    if (_.isObject(value)) return _.matches(value);
	    return _.property(value);
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    if (obj == null) return obj;
	    iteratee = createCallback(iteratee, context);
	    var i, length = obj.length;
	    if (length === +length) {
	      for (i = 0; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    if (obj == null) return [];
	    iteratee = _.iteratee(iteratee, context);
	    var keys = obj.length !== +obj.length && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length),
	        currentKey;
	    for (var index = 0; index < length; index++) {
	      currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  var reduceError = 'Reduce of empty array with no initial value';
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = function(obj, iteratee, memo, context) {
	    if (obj == null) obj = [];
	    iteratee = createCallback(iteratee, context, 4);
	    var keys = obj.length !== +obj.length && _.keys(obj),
	        length = (keys || obj).length,
	        index = 0, currentKey;
	    if (arguments.length < 3) {
	      if (!length) throw new TypeError(reduceError);
	      memo = obj[keys ? keys[index++] : index++];
	    }
	    for (; index < length; index++) {
	      currentKey = keys ? keys[index] : index;
	      memo = iteratee(memo, obj[currentKey], currentKey, obj);
	    }
	    return memo;
	  };
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = function(obj, iteratee, memo, context) {
	    if (obj == null) obj = [];
	    iteratee = createCallback(iteratee, context, 4);
	    var keys = obj.length !== + obj.length && _.keys(obj),
	        index = (keys || obj).length,
	        currentKey;
	    if (arguments.length < 3) {
	      if (!index) throw new TypeError(reduceError);
	      memo = obj[keys ? keys[--index] : --index];
	    }
	    while (index--) {
	      currentKey = keys ? keys[index] : index;
	      memo = iteratee(memo, obj[currentKey], currentKey, obj);
	    }
	    return memo;
	  };
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var result;
	    predicate = _.iteratee(predicate, context);
	    _.some(obj, function(value, index, list) {
	      if (predicate(value, index, list)) {
	        result = value;
	        return true;
	      }
	    });
	    return result;
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    if (obj == null) return results;
	    predicate = _.iteratee(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(_.iteratee(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    if (obj == null) return true;
	    predicate = _.iteratee(predicate, context);
	    var keys = obj.length !== +obj.length && _.keys(obj),
	        length = (keys || obj).length,
	        index, currentKey;
	    for (index = 0; index < length; index++) {
	      currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    if (obj == null) return false;
	    predicate = _.iteratee(predicate, context);
	    var keys = obj.length !== +obj.length && _.keys(obj),
	        length = (keys || obj).length,
	        index, currentKey;
	    for (index = 0; index < length; index++) {
	      currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given value (using `===`).
	  // Aliased as `include`.
	  _.contains = _.include = function(obj, target) {
	    if (obj == null) return false;
	    if (obj.length !== +obj.length) obj = _.values(obj);
	    return _.indexOf(obj, target) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      return (isFunc ? method : value[method]).apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matches(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matches(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = obj.length === +obj.length ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = _.iteratee(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = obj.length === +obj.length ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = _.iteratee(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = obj && obj.length === +obj.length ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (obj.length !== +obj.length) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = _.iteratee(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = _.iteratee(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = _.iteratee(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = array.length;
	    while (low < high) {
	      var mid = low + high >>> 1;
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (obj.length === +obj.length) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return obj.length === +obj.length ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = _.iteratee(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    if (n < 0) return [];
	    return slice.call(array, 0, n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N. The **guard** check allows it to work with
	  // `_.map`.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return slice.call(array, Math.max(array.length - n, 0));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array. The **guard**
	  // check allows it to work with `_.map`.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, output) {
	    if (shallow && _.every(input, _.isArray)) {
	      return concat.apply(output, input);
	    }
	    for (var i = 0, length = input.length; i < length; i++) {
	      var value = input[i];
	      if (!_.isArray(value) && !_.isArguments(value)) {
	        if (!strict) output.push(value);
	      } else if (shallow) {
	        push.apply(output, value);
	      } else {
	        flatten(value, shallow, strict, output);
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false, []);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (array == null) return [];
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = _.iteratee(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = array.length; i < length; i++) {
	      var value = array[i];
	      if (isSorted) {
	        if (!i || seen !== value) result.push(value);
	        seen = value;
	      } else if (iteratee) {
	        var computed = iteratee(value, i, array);
	        if (_.indexOf(seen, computed) < 0) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (_.indexOf(result, value) < 0) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true, []));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    if (array == null) return [];
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = array.length; i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(slice.call(arguments, 1), true, true, []);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function(array) {
	    if (array == null) return [];
	    var length = _.max(arguments, 'length').length;
	    var results = Array(length);
	    for (var i = 0; i < length; i++) {
	      results[i] = _.pluck(arguments, i);
	    }
	    return results;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    if (list == null) return {};
	    var result = {};
	    for (var i = 0, length = list.length; i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = function(array, item, isSorted) {
	    if (array == null) return -1;
	    var i = 0, length = array.length;
	    if (isSorted) {
	      if (typeof isSorted == 'number') {
	        i = isSorted < 0 ? Math.max(0, length + isSorted) : isSorted;
	      } else {
	        i = _.sortedIndex(array, item);
	        return array[i] === item ? i : -1;
	      }
	    }
	    for (; i < length; i++) if (array[i] === item) return i;
	    return -1;
	  };
	
	  _.lastIndexOf = function(array, item, from) {
	    if (array == null) return -1;
	    var idx = array.length;
	    if (typeof from == 'number') {
	      idx = from < 0 ? idx + from + 1 : Math.min(idx, from + 1);
	    }
	    while (--idx >= 0) if (array[idx] === item) return idx;
	    return -1;
	  };
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (arguments.length <= 1) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Reusable constructor function for prototype setting.
	  var Ctor = function(){};
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    var args, bound;
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    args = slice.call(arguments, 2);
	    bound = function() {
	      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
	      Ctor.prototype = func.prototype;
	      var self = new Ctor;
	      Ctor.prototype = null;
	      var result = func.apply(self, args.concat(slice.call(arguments)));
	      if (_.isObject(result)) return result;
	      return self;
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    return function() {
	      var position = 0;
	      var args = boundArgs.slice();
	      for (var i = 0, length = args.length; i < length; i++) {
	        if (args[i] === _) args[i] = arguments[position++];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return func.apply(this, args);
	    };
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = hasher ? hasher.apply(this, arguments) : key;
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = function(func) {
	    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
	  };
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        clearTimeout(timeout);
	        timeout = null;
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last > 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed after being called N times.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed before being called N times.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      } else {
	        func = null;
	      }
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Retrieve the names of an object's properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    var source, prop;
	    for (var i = 1, length = arguments.length; i < length; i++) {
	      source = arguments[i];
	      for (prop in source) {
	        if (hasOwnProperty.call(source, prop)) {
	            obj[prop] = source[prop];
	        }
	      }
	    }
	    return obj;
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(obj, iteratee, context) {
	    var result = {}, key;
	    if (obj == null) return result;
	    if (_.isFunction(iteratee)) {
	      iteratee = createCallback(iteratee, context);
	      for (key in obj) {
	        var value = obj[key];
	        if (iteratee(value, key, obj)) result[key] = value;
	      }
	    } else {
	      var keys = concat.apply([], slice.call(arguments, 1));
	      obj = new Object(obj);
	      for (var i = 0, length = keys.length; i < length; i++) {
	        key = keys[i];
	        if (key in obj) result[key] = obj[key];
	      }
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(concat.apply([], slice.call(arguments, 1)), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    for (var i = 1, length = arguments.length; i < length; i++) {
	      var source = arguments[i];
	      for (var prop in source) {
	        if (obj[prop] === void 0) obj[prop] = source[prop];
	      }
	    }
	    return obj;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	    if (typeof a != 'object' || typeof b != 'object') return false;
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	    // Objects with different constructors are not equivalent, but `Object`s
	    // from different frames are.
	    var aCtor = a.constructor, bCtor = b.constructor;
	    if (
	      aCtor !== bCtor &&
	      // Handle Object.create(x) cases
	      'constructor' in a && 'constructor' in b &&
	      !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	        _.isFunction(bCtor) && bCtor instanceof bCtor)
	    ) {
	      return false;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    var size, result;
	    // Recursively compare objects and arrays.
	    if (className === '[object Array]') {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      size = a.length;
	      result = size === b.length;
	      if (result) {
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (size--) {
	          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
	        }
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      size = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      result = _.keys(b).length === size;
	      if (result) {
	        while (size--) {
	          // Deep compare each member
	          key = keys[size];
	          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
	        }
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return result;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b, [], []);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (_.isArray(obj) || _.isString(obj) || _.isArguments(obj)) return obj.length === 0;
	    for (var key in obj) if (_.has(obj, key)) return false;
	    return true;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around an IE 11 bug.
	  if (true) {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = function(key) {
	    return function(obj) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of `key:value` pairs.
	  _.matches = function(attrs) {
	    var pairs = _.pairs(attrs), length = pairs.length;
	    return function(obj) {
	      if (obj == null) return !length;
	      obj = new Object(obj);
	      for (var i = 0; i < length; i++) {
	        var pair = pairs[i], key = pair[0];
	        if (pair[1] !== obj[key] || !(key in obj)) return false;
	      }
	      return true;
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = createCallback(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property) {
	    if (object == null) return void 0;
	    var value = object[property];
	    return _.isFunction(value) ? object[property]() : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(obj) {
	    return this._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result.call(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result.call(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result.call(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ },
/* 2975 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object ? baseValues(object, keys(object)) : [];
	}
	
	module.exports = includes;


/***/ },
/* 2976 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a boolean primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isBoolean(false);
	 * // => true
	 *
	 * _.isBoolean(null);
	 * // => false
	 */
	function isBoolean(value) {
	  return value === true || value === false ||
	    (isObjectLike(value) && objectToString.call(value) == boolTag);
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isBoolean;


/***/ },
/* 2977 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEqual;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(53)(module)))

/***/ },
/* 2978 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is an integer.
	 *
	 * **Note:** This method is based on
	 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	 * @example
	 *
	 * _.isInteger(3);
	 * // => true
	 *
	 * _.isInteger(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isInteger(Infinity);
	 * // => false
	 *
	 * _.isInteger('3');
	 * // => false
	 */
	function isInteger(value) {
	  return typeof value == 'number' && value == toInteger(value);
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = isInteger;


/***/ },
/* 2979 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	 * as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && objectToString.call(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 2980 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 2981 */
/***/ function(module, exports) {

	/**
	 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @type Function
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 2982 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Creates a function that invokes `func`, with the `this` binding and arguments
	 * of the created function, while it's called less than `n` times. Subsequent
	 * calls to the created function return the result of the last `func` invocation.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {number} n The number of calls at which `func` is no longer invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * jQuery(element).on('click', _.before(5, addContactToList));
	 * // => Allows adding up to 4 contacts to the list.
	 */
	function before(n, func) {
	  var result;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n > 0) {
	      result = func.apply(this, arguments);
	    }
	    if (n <= 1) {
	      func = undefined;
	    }
	    return result;
	  };
	}
	
	/**
	 * Creates a function that is restricted to invoking `func` once. Repeat calls
	 * to the function return the value of the first invocation. The `func` is
	 * invoked with the `this` binding and arguments of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var initialize = _.once(createApplication);
	 * initialize();
	 * initialize();
	 * // => `createApplication` is invoked once
	 */
	function once(func) {
	  return before(2, func);
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = once;


/***/ },
/* 2983 */
383,
/* 2984 */
[4201, 2991, 3009, 3010, 3011, 1303, 3012],
/* 2985 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(424);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && objectToString.call(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 2986 */
[4230, 1309, 3000, 678, 3006],
/* 2987 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(1310),
	    isObjectLike = __webpack_require__(424);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 2988 */
[4234, 1304, 3001],
/* 2989 */
[4243, 1308, 3003, 3004],
/* 2990 */
[4246, 3008, 1301, 1308],
/* 2991 */
993,
/* 2992 */
245,
/* 2993 */
[4264, 1299, 1300],
/* 2994 */
[4267, 1306],
/* 2995 */
[4269, 2989, 2999],
/* 2996 */
[4296, 2986, 2998],
/* 2997 */
[4297, 1305],
/* 2998 */
2675,
/* 2999 */
[4310, 1307, 677, 1303, 678],
/* 3000 */
[4313, 2994],
/* 3001 */
[4328, 1305],
/* 3002 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(1302);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)(module)))

/***/ },
/* 3003 */
[4330, 2983],
/* 3004 */
[4335, 2990, 3005],
/* 3005 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 500,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 3006 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 3007 */
[4346, 1299, 2993, 2995, 677, 1304, 3013],
/* 3008 */
2727,
/* 3009 */
[4394, 2985, 424],
/* 3010 */
47,
/* 3011 */
[4398, 1306, 3014],
/* 3012 */
[4409, 2987, 2992, 3002],
/* 3013 */
[4413, 2984, 2988, 677],
/* 3014 */
2777,
/* 3015 */
/***/ function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__(2517),
	      utf8 = __webpack_require__(942).utf8,
	      isBuffer = __webpack_require__(2937),
	      bin = __webpack_require__(942).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ },
/* 3016 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 1311,
		"./af.js": 1311,
		"./ar": 1317,
		"./ar-dz": 1312,
		"./ar-dz.js": 1312,
		"./ar-ly": 1313,
		"./ar-ly.js": 1313,
		"./ar-ma": 1314,
		"./ar-ma.js": 1314,
		"./ar-sa": 1315,
		"./ar-sa.js": 1315,
		"./ar-tn": 1316,
		"./ar-tn.js": 1316,
		"./ar.js": 1317,
		"./az": 1318,
		"./az.js": 1318,
		"./be": 1319,
		"./be.js": 1319,
		"./bg": 1320,
		"./bg.js": 1320,
		"./bn": 1321,
		"./bn.js": 1321,
		"./bo": 1322,
		"./bo.js": 1322,
		"./br": 1323,
		"./br.js": 1323,
		"./bs": 1324,
		"./bs.js": 1324,
		"./ca": 1325,
		"./ca.js": 1325,
		"./cs": 1326,
		"./cs.js": 1326,
		"./cv": 1327,
		"./cv.js": 1327,
		"./cy": 1328,
		"./cy.js": 1328,
		"./da": 1329,
		"./da.js": 1329,
		"./de": 1331,
		"./de-at": 1330,
		"./de-at.js": 1330,
		"./de.js": 1331,
		"./dv": 1332,
		"./dv.js": 1332,
		"./el": 1333,
		"./el.js": 1333,
		"./en-au": 1334,
		"./en-au.js": 1334,
		"./en-ca": 1335,
		"./en-ca.js": 1335,
		"./en-gb": 1336,
		"./en-gb.js": 1336,
		"./en-ie": 1337,
		"./en-ie.js": 1337,
		"./en-nz": 1338,
		"./en-nz.js": 1338,
		"./eo": 1339,
		"./eo.js": 1339,
		"./es": 1341,
		"./es-do": 1340,
		"./es-do.js": 1340,
		"./es.js": 1341,
		"./et": 1342,
		"./et.js": 1342,
		"./eu": 1343,
		"./eu.js": 1343,
		"./fa": 1344,
		"./fa.js": 1344,
		"./fi": 1345,
		"./fi.js": 1345,
		"./fo": 1346,
		"./fo.js": 1346,
		"./fr": 1349,
		"./fr-ca": 1347,
		"./fr-ca.js": 1347,
		"./fr-ch": 1348,
		"./fr-ch.js": 1348,
		"./fr.js": 1349,
		"./fy": 1350,
		"./fy.js": 1350,
		"./gd": 1351,
		"./gd.js": 1351,
		"./gl": 1352,
		"./gl.js": 1352,
		"./he": 1353,
		"./he.js": 1353,
		"./hi": 1354,
		"./hi.js": 1354,
		"./hr": 1355,
		"./hr.js": 1355,
		"./hu": 1356,
		"./hu.js": 1356,
		"./hy-am": 1357,
		"./hy-am.js": 1357,
		"./id": 1358,
		"./id.js": 1358,
		"./is": 1359,
		"./is.js": 1359,
		"./it": 1360,
		"./it.js": 1360,
		"./ja": 1361,
		"./ja.js": 1361,
		"./jv": 1362,
		"./jv.js": 1362,
		"./ka": 1363,
		"./ka.js": 1363,
		"./kk": 1364,
		"./kk.js": 1364,
		"./km": 1365,
		"./km.js": 1365,
		"./ko": 1366,
		"./ko.js": 1366,
		"./ky": 1367,
		"./ky.js": 1367,
		"./lb": 1368,
		"./lb.js": 1368,
		"./lo": 1369,
		"./lo.js": 1369,
		"./lt": 1370,
		"./lt.js": 1370,
		"./lv": 1371,
		"./lv.js": 1371,
		"./me": 1372,
		"./me.js": 1372,
		"./mi": 1373,
		"./mi.js": 1373,
		"./mk": 1374,
		"./mk.js": 1374,
		"./ml": 1375,
		"./ml.js": 1375,
		"./mr": 1376,
		"./mr.js": 1376,
		"./ms": 1378,
		"./ms-my": 1377,
		"./ms-my.js": 1377,
		"./ms.js": 1378,
		"./my": 1379,
		"./my.js": 1379,
		"./nb": 1380,
		"./nb.js": 1380,
		"./ne": 1381,
		"./ne.js": 1381,
		"./nl": 1383,
		"./nl-be": 1382,
		"./nl-be.js": 1382,
		"./nl.js": 1383,
		"./nn": 1384,
		"./nn.js": 1384,
		"./pa-in": 1385,
		"./pa-in.js": 1385,
		"./pl": 1386,
		"./pl.js": 1386,
		"./pt": 1388,
		"./pt-br": 1387,
		"./pt-br.js": 1387,
		"./pt.js": 1388,
		"./ro": 1389,
		"./ro.js": 1389,
		"./ru": 1390,
		"./ru.js": 1390,
		"./se": 1391,
		"./se.js": 1391,
		"./si": 1392,
		"./si.js": 1392,
		"./sk": 1393,
		"./sk.js": 1393,
		"./sl": 1394,
		"./sl.js": 1394,
		"./sq": 1395,
		"./sq.js": 1395,
		"./sr": 1397,
		"./sr-cyrl": 1396,
		"./sr-cyrl.js": 1396,
		"./sr.js": 1397,
		"./ss": 1398,
		"./ss.js": 1398,
		"./sv": 1399,
		"./sv.js": 1399,
		"./sw": 1400,
		"./sw.js": 1400,
		"./ta": 1401,
		"./ta.js": 1401,
		"./te": 1402,
		"./te.js": 1402,
		"./tet": 1403,
		"./tet.js": 1403,
		"./th": 1404,
		"./th.js": 1404,
		"./tl-ph": 1405,
		"./tl-ph.js": 1405,
		"./tlh": 1406,
		"./tlh.js": 1406,
		"./tr": 1407,
		"./tr.js": 1407,
		"./tzl": 1408,
		"./tzl.js": 1408,
		"./tzm": 1410,
		"./tzm-latn": 1409,
		"./tzm-latn.js": 1409,
		"./tzm.js": 1410,
		"./uk": 1411,
		"./uk.js": 1411,
		"./uz": 1412,
		"./uz.js": 1412,
		"./vi": 1413,
		"./vi.js": 1413,
		"./x-pseudo": 1414,
		"./x-pseudo.js": 1414,
		"./yo": 1415,
		"./yo.js": 1415,
		"./zh-cn": 1416,
		"./zh-cn.js": 1416,
		"./zh-hk": 1417,
		"./zh-hk.js": 1417,
		"./zh-tw": 1418,
		"./zh-tw.js": 1418
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 3016;


/***/ },
/* 3017 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 3018 */
/***/ function(module, exports) {

	module.exports = function(size) {
	  return new LruCache(size)
	}
	
	function LruCache(size) {
	  this.capacity = size | 0
	  this.map = Object.create(null)
	  this.list = new DoublyLinkedList()
	}
	
	LruCache.prototype.get = function(key) {
	  var node = this.map[key]
	  if (node == null) return undefined
	  this.used(node)
	  return node.val
	}
	
	LruCache.prototype.set = function(key, val) {
	  var node = this.map[key]
	  if (node != null) {
	    node.val = val
	  } else {
	    if (!this.capacity) this.prune()
	    if (!this.capacity) return false
	    node = new DoublyLinkedNode(key, val)
	    this.map[key] = node
	    this.capacity--
	  }
	  this.used(node)
	  return true
	}
	
	LruCache.prototype.used = function(node) {
	  this.list.moveToFront(node)
	}
	
	LruCache.prototype.prune = function() {
	  var node = this.list.pop()
	  if (node != null) {
	    delete this.map[node.key]
	    this.capacity++
	  }
	}
	
	
	function DoublyLinkedList() {
	  this.firstNode = null
	  this.lastNode = null
	}
	
	DoublyLinkedList.prototype.moveToFront = function(node) {
	  if (this.firstNode == node) return
	
	  this.remove(node)
	
	  if (this.firstNode == null) {
	    this.firstNode = node
	    this.lastNode = node
	    node.prev = null
	    node.next = null
	  } else {
	    node.prev = null
	    node.next = this.firstNode
	    node.next.prev = node
	    this.firstNode = node
	  }
	}
	
	DoublyLinkedList.prototype.pop = function() {
	  var lastNode = this.lastNode
	  if (lastNode != null) {
	    this.remove(lastNode)
	  }
	  return lastNode
	}
	
	DoublyLinkedList.prototype.remove = function(node) {
	  if (this.firstNode == node) {
	    this.firstNode = node.next
	  } else if (node.prev != null) {
	    node.prev.next = node.next
	  }
	  if (this.lastNode == node) {
	    this.lastNode = node.prev
	  } else if (node.next != null) {
	    node.next.prev = node.prev
	  }
	}
	
	
	function DoublyLinkedNode(key, val) {
	  this.key = key
	  this.val = val
	  this.prev = null
	  this.next = null
	}


/***/ },
/* 3019 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aws4 = exports,
	  url = __webpack_require__(4097),
	  querystring = __webpack_require__(1428),
	  crypto = __webpack_require__(2521),
	  lru = __webpack_require__(3018),
	  credentialsCache = lru(1000)
	
	// http://docs.amazonwebservices.com/general/latest/gr/signature-version-4.html
	
	function hmac(key, string, encoding) {
	  // return crypto.createHmac('sha256', key).update(string, 'utf8').digest(encoding)
	  // return crypto.HmacSHA256(string, key);
	  return crypto.algo.HMAC.create(crypto.algo.SHA256, key).update(string).finalize();
	}
	
	function hash(string, encoding) {
	  // return crypto.createHash('sha256').update(string, 'utf8').digest(encoding)
	  // return crypto.SHA256(string)
	  return crypto.algo.SHA256.create().update(string).finalize().toString(crypto.enc.Hex);
	}
	
	// This function assumes the string has already been percent encoded
	function encodeRfc3986(urlEncodedString) {
	  return urlEncodedString.replace(/[!'()*]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	// request: { path | body, [host], [method], [headers], [service], [region] }
	// credentials: { accessKeyId, secretAccessKey, [sessionToken] }
	function RequestSigner(request, credentials) {
	
	  if (typeof request === 'string') request = url.parse(request)
	
	  var headers = request.headers = (request.headers || {}),
	    hostParts = this.matchHost(request.hostname || request.host || headers.Host || headers.host)
	
	  this.request = request
	  this.credentials = credentials || this.defaultCredentials()
	
	  this.service = request.service || hostParts[0] || ''
	  this.region = request.region || hostParts[1] || 'us-east-1'
	
	  // SES uses a different domain from the service name
	  if (this.service === 'email') this.service = 'ses'
	
	  if (!request.method && request.body)
	    request.method = 'POST'
	
	  if (!headers.Host && !headers.host) {
	    headers.Host = request.hostname || request.host || this.createHost()
	
	    // If a port is specified explicitly, use it as is
	    if (request.port)
	      headers.Host += ':' + request.port
	  }
	  if (!request.hostname && !request.host)
	    request.hostname = headers.Host || headers.host
	
	  this.isCodeCommitGit = this.service === 'codecommit' && request.method === 'GIT'
	}
	
	RequestSigner.prototype.matchHost = function (host) {
	  var match = (host || '').match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com(\.cn)?$/)
	  var hostParts = (match || []).slice(1, 3)
	
	  // ES's hostParts are sometimes the other way round, if the value that is expected
	  // to be region equals ‘es’ switch them back
	  // e.g. search-cluster-name-aaaa00aaaa0aaa0aaaaaaa0aaa.us-east-1.es.amazonaws.com
	  if (hostParts[1] === 'es')
	    hostParts = hostParts.reverse()
	
	  return hostParts
	}
	
	// http://docs.aws.amazon.com/general/latest/gr/rande.html
	RequestSigner.prototype.isSingleRegion = function () {
	  // Special case for S3 and SimpleDB in us-east-1
	  if (['s3', 'sdb'].indexOf(this.service) >= 0 && this.region === 'us-east-1') return true
	
	  return ['cloudfront', 'ls', 'route53', 'iam', 'importexport', 'sts']
	    .indexOf(this.service) >= 0
	}
	
	RequestSigner.prototype.createHost = function () {
	  var region = this.isSingleRegion() ? '' :
	    (this.service === 's3' && this.region !== 'us-east-1' ? '-' : '.') + this.region,
	    service = this.service === 'ses' ? 'email' : this.service
	  return service + region + '.amazonaws.com'
	}
	
	RequestSigner.prototype.prepareRequest = function () {
	  this.parsePath()
	
	  var request = this.request, headers = request.headers, query
	
	  if (request.signQuery) {
	
	    this.parsedPath.query = query = this.parsedPath.query || {}
	
	    if (this.credentials.sessionToken)
	      query['X-Amz-Security-Token'] = this.credentials.sessionToken
	
	    if (this.service === 's3' && !query['X-Amz-Expires'])
	      query['X-Amz-Expires'] = 86400
	
	    if (query['X-Amz-Date'])
	      this.datetime = query['X-Amz-Date']
	    else
	      query['X-Amz-Date'] = this.getDateTime()
	
	    query['X-Amz-Algorithm'] = 'AWS4-HMAC-SHA256'
	    query['X-Amz-Credential'] = this.credentials.accessKeyId + '/' + this.credentialString()
	    query['X-Amz-SignedHeaders'] = this.signedHeaders()
	
	  } else {
	
	    if (!request.doNotModifyHeaders && !this.isCodeCommitGit) {
	      if (request.body && !headers['Content-Type'] && !headers['content-type'])
	        headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'
	
	      if (request.body && !headers['Content-Length'] && !headers['content-length'])
	        headers['Content-Length'] = Buffer.byteLength(request.body)
	
	      if (this.credentials.sessionToken && !headers['X-Amz-Security-Token'] && !headers['x-amz-security-token'])
	        headers['X-Amz-Security-Token'] = this.credentials.sessionToken
	
	      if (this.service === 's3' && !headers['X-Amz-Content-Sha256'] && !headers['x-amz-content-sha256'])
	        headers['X-Amz-Content-Sha256'] = hash(this.request.body || '', 'hex')
	
	      if (headers['X-Amz-Date'] || headers['x-amz-date'])
	        this.datetime = headers['X-Amz-Date'] || headers['x-amz-date']
	      else
	        headers['X-Amz-Date'] = this.getDateTime()
	    }
	
	    delete headers.Authorization
	    delete headers.authorization
	  }
	}
	
	RequestSigner.prototype.sign = function () {
	  if (!this.parsedPath) this.prepareRequest()
	
	  if (this.request.signQuery) {
	    this.parsedPath.query['X-Amz-Signature'] = this.signature()
	  } else {
	    this.request.headers.Authorization = this.authHeader()
	  }
	
	  this.request.path = this.formatPath()
	
	  return this.request
	}
	
	RequestSigner.prototype.getDateTime = function () {
	  if (!this.datetime) {
	    var headers = this.request.headers,
	      date = new Date(headers.Date || headers.date || new Date)
	
	    this.datetime = date.toISOString().replace(/[:\-]|\.\d{3}/g, '')
	
	    // Remove the trailing 'Z' on the timestamp string for CodeCommit git access
	    if (this.isCodeCommitGit) this.datetime = this.datetime.slice(0, -1)
	  }
	  return this.datetime
	}
	
	RequestSigner.prototype.getDate = function () {
	  return this.getDateTime().substr(0, 8)
	}
	
	RequestSigner.prototype.authHeader = function () {
	  return [
	    'AWS4-HMAC-SHA256 Credential=' + this.credentials.accessKeyId + '/' + this.credentialString(),
	    'SignedHeaders=' + this.signedHeaders(),
	    'Signature=' + this.signature(),
	  ].join(', ')
	}
	
	RequestSigner.prototype.signature = function () {
	  var date = this.getDate(),
	    cacheKey = [this.credentials.secretAccessKey, date, this.region, this.service].join(),
	    kDate, kRegion, kService, kCredentials = credentialsCache.get(cacheKey)
	  if (!kCredentials) {
	    kDate = hmac('AWS4' + this.credentials.secretAccessKey, date)
	    kRegion = hmac(kDate, this.region)
	    kService = hmac(kRegion, this.service)
	    kCredentials = hmac(kService, 'aws4_request')
	    credentialsCache.set(cacheKey, kCredentials)
	  }
	  return hmac(kCredentials, this.stringToSign(), 'hex')
	}
	
	RequestSigner.prototype.stringToSign = function () {
	  return [
	    'AWS4-HMAC-SHA256',
	    this.getDateTime(),
	    this.credentialString(),
	    hash(this.canonicalString(), 'hex'),
	  ].join('\n')
	}
	
	RequestSigner.prototype.canonicalString = function () {
	  if (!this.parsedPath) this.prepareRequest()
	
	  var pathStr = this.parsedPath.path,
	    query = this.parsedPath.query,
	    headers = this.request.headers,
	    queryStr = '',
	    normalizePath = this.service !== 's3',
	    decodePath = this.service === 's3' || this.request.doNotEncodePath,
	    decodeSlashesInPath = this.service === 's3',
	    firstValOnly = this.service === 's3',
	    bodyHash
	
	  if (this.service === 's3' && this.request.signQuery) {
	    bodyHash = 'UNSIGNED-PAYLOAD'
	  } else if (this.isCodeCommitGit) {
	    bodyHash = ''
	  } else {
	    bodyHash = headers['X-Amz-Content-Sha256'] || headers['x-amz-content-sha256'] ||
	      hash(this.request.body || '', 'hex')
	  }
	
	  if (query) {
	    queryStr = encodeRfc3986(querystring.stringify(Object.keys(query).sort().reduce(function (obj, key) {
	      if (!key) return obj
	      obj[key] = !Array.isArray(query[key]) ? query[key] :
	        (firstValOnly ? query[key][0] : query[key].slice().sort())
	      return obj
	    }, {})))
	  }
	  if (pathStr !== '/') {
	    if (normalizePath) pathStr = pathStr.replace(/\/{2,}/g, '/')
	    pathStr = pathStr.split('/').reduce(function (path, piece) {
	      if (normalizePath && piece === '..') {
	        path.pop()
	      } else if (!normalizePath || piece !== '.') {
	        if (decodePath) piece = decodeURIComponent(piece)
	        path.push(encodeRfc3986(encodeURIComponent(piece)))
	      }
	      return path
	    }, []).join('/')
	    if (pathStr[0] !== '/') pathStr = '/' + pathStr
	    if (decodeSlashesInPath) pathStr = pathStr.replace(/%2F/g, '/')
	  }
	
	  return [
	    this.request.method || 'GET',
	    pathStr,
	    queryStr,
	    this.canonicalHeaders() + '\n',
	    this.signedHeaders(),
	    bodyHash,
	  ].join('\n')
	}
	
	RequestSigner.prototype.canonicalHeaders = function () {
	  var headers = this.request.headers
	  function trimAll(header) {
	    return header.toString().trim().replace(/\s+/g, ' ')
	  }
	  return Object.keys(headers)
	    .sort(function (a, b) { return a.toLowerCase() < b.toLowerCase() ? -1 : 1 })
	    .map(function (key) { return key.toLowerCase() + ':' + trimAll(headers[key]) })
	    .join('\n')
	}
	
	RequestSigner.prototype.signedHeaders = function () {
	  return Object.keys(this.request.headers)
	    .map(function (key) { return key.toLowerCase() })
	    .sort()
	    .join(';')
	}
	
	RequestSigner.prototype.credentialString = function () {
	  return [
	    this.getDate(),
	    this.region,
	    this.service,
	    'aws4_request',
	  ].join('/')
	}
	
	RequestSigner.prototype.defaultCredentials = function () {
	  var env = process.env
	  return {
	    accessKeyId: env.AWS_ACCESS_KEY_ID || env.AWS_ACCESS_KEY,
	    secretAccessKey: env.AWS_SECRET_ACCESS_KEY || env.AWS_SECRET_KEY,
	    sessionToken: env.AWS_SESSION_TOKEN,
	  }
	}
	
	RequestSigner.prototype.parsePath = function () {
	  var path = this.request.path || '/',
	    queryIx = path.indexOf('?'),
	    query = null
	
	  if (queryIx >= 0) {
	    query = querystring.parse(path.slice(queryIx + 1))
	    path = path.slice(0, queryIx)
	  }
	
	  // S3 doesn't always encode characters > 127 correctly and
	  // all services don't encode characters > 255 correctly
	  // So if there are non-reserved chars (and it's not already all % encoded), just encode them all
	  if (/[^0-9A-Za-z!'()*\-._~%/]/.test(path)) {
	    path = path.split('/').map(function (piece) {
	      return encodeURIComponent(decodeURIComponent(piece))
	    }).join('/')
	  }
	
	  this.parsedPath = {
	    path: path,
	    query: query,
	  }
	}
	
	RequestSigner.prototype.formatPath = function () {
	  var path = this.parsedPath.path,
	    query = this.parsedPath.query
	
	  if (!query) return path
	
	  // Services don't support empty query string keys
	  if (query[''] != null) delete query['']
	
	  return path + '?' + encodeRfc3986(querystring.stringify(query))
	}
	
	aws4.RequestSigner = RequestSigner
	
	aws4.sign = function (request, credentials) {
	  return new RequestSigner(request, credentials).sign()
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58).Buffer))

/***/ },
/* 3020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(200);
	var callBind = __webpack_require__(289);
	
	var implementation = __webpack_require__(1419);
	var getPolyfill = __webpack_require__(1420);
	var shim = __webpack_require__(3021);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 3021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(1420);
	var define = __webpack_require__(200);
	
	module.exports = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 3022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(1422); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 3023 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58).Buffer))

/***/ },
/* 3024 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 3025 */
/***/ function(module, exports) {

	'use strict';
	
	var processFn = function (fn, P, opts) {
		return function () {
			var that = this;
			var args = new Array(arguments.length);
	
			for (var i = 0; i < arguments.length; i++) {
				args[i] = arguments[i];
			}
	
			return new P(function (resolve, reject) {
				args.push(function (err, result) {
					if (err) {
						reject(err);
					} else if (opts.multiArgs) {
						var results = new Array(arguments.length - 1);
	
						for (var i = 1; i < arguments.length; i++) {
							results[i - 1] = arguments[i];
						}
	
						resolve(results);
					} else {
						resolve(result);
					}
				});
	
				fn.apply(that, args);
			});
		};
	};
	
	var pify = module.exports = function (obj, P, opts) {
		if (typeof P !== 'function') {
			opts = P;
			P = Promise;
		}
	
		opts = opts || {};
		opts.exclude = opts.exclude || [/.+Sync$/];
	
		var filter = function (key) {
			var match = function (pattern) {
				return typeof pattern === 'string' ? key === pattern : pattern.test(key);
			};
	
			return opts.include ? opts.include.some(match) : !opts.exclude.some(match);
		};
	
		var ret = typeof obj === 'function' ? function () {
			if (opts.excludeMain) {
				return obj.apply(this, arguments);
			}
	
			return processFn(obj, P, opts).apply(this, arguments);
		} : {};
	
		return Object.keys(obj).reduce(function (ret, key) {
			var x = obj[key];
	
			ret[key] = typeof x === 'function' && filter(key) ? processFn(x, P, opts) : x;
	
			return ret;
		}, ret);
	};
	
	pify.all = pify;


/***/ },
/* 3026 */
/***/ function(module, exports, __webpack_require__) {

	/* global define */
	
	(function (root, pluralize) {
	  /* istanbul ignore else */
	  if (true) {
	    // Node.
	    module.exports = pluralize();
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD, registers as an anonymous module.
	    define(function () {
	      return pluralize();
	    });
	  } else {
	    // Browser global.
	    root.pluralize = pluralize();
	  }
	})(this, function () {
	  // Rule storage - pluralize and singularize need to be run sequentially,
	  // while other rules can be optimized using an object for instant lookups.
	  var pluralRules = [];
	  var singularRules = [];
	  var uncountables = {};
	  var irregularPlurals = {};
	  var irregularSingles = {};
	
	  /**
	   * Sanitize a pluralization rule to a usable regular expression.
	   *
	   * @param  {(RegExp|string)} rule
	   * @return {RegExp}
	   */
	  function sanitizeRule (rule) {
	    if (typeof rule === 'string') {
	      return new RegExp('^' + rule + '$', 'i');
	    }
	
	    return rule;
	  }
	
	  /**
	   * Pass in a word token to produce a function that can replicate the case on
	   * another word.
	   *
	   * @param  {string}   word
	   * @param  {string}   token
	   * @return {Function}
	   */
	  function restoreCase (word, token) {
	    // Tokens are an exact match.
	    if (word === token) return token;
	
	    // Lower cased words. E.g. "hello".
	    if (word === word.toLowerCase()) return token.toLowerCase();
	
	    // Upper cased words. E.g. "WHISKY".
	    if (word === word.toUpperCase()) return token.toUpperCase();
	
	    // Title cased words. E.g. "Title".
	    if (word[0] === word[0].toUpperCase()) {
	      return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
	    }
	
	    // Lower cased words. E.g. "test".
	    return token.toLowerCase();
	  }
	
	  /**
	   * Interpolate a regexp string.
	   *
	   * @param  {string} str
	   * @param  {Array}  args
	   * @return {string}
	   */
	  function interpolate (str, args) {
	    return str.replace(/\$(\d{1,2})/g, function (match, index) {
	      return args[index] || '';
	    });
	  }
	
	  /**
	   * Replace a word using a rule.
	   *
	   * @param  {string} word
	   * @param  {Array}  rule
	   * @return {string}
	   */
	  function replace (word, rule) {
	    return word.replace(rule[0], function (match, index) {
	      var result = interpolate(rule[1], arguments);
	
	      if (match === '') {
	        return restoreCase(word[index - 1], result);
	      }
	
	      return restoreCase(match, result);
	    });
	  }
	
	  /**
	   * Sanitize a word by passing in the word and sanitization rules.
	   *
	   * @param  {string}   token
	   * @param  {string}   word
	   * @param  {Array}    rules
	   * @return {string}
	   */
	  function sanitizeWord (token, word, rules) {
	    // Empty string or doesn't need fixing.
	    if (!token.length || uncountables.hasOwnProperty(token)) {
	      return word;
	    }
	
	    var len = rules.length;
	
	    // Iterate over the sanitization rules and use the first one to match.
	    while (len--) {
	      var rule = rules[len];
	
	      if (rule[0].test(word)) return replace(word, rule);
	    }
	
	    return word;
	  }
	
	  /**
	   * Replace a word with the updated word.
	   *
	   * @param  {Object}   replaceMap
	   * @param  {Object}   keepMap
	   * @param  {Array}    rules
	   * @return {Function}
	   */
	  function replaceWord (replaceMap, keepMap, rules) {
	    return function (word) {
	      // Get the correct token and case restoration functions.
	      var token = word.toLowerCase();
	
	      // Check against the keep object map.
	      if (keepMap.hasOwnProperty(token)) {
	        return restoreCase(word, token);
	      }
	
	      // Check against the replacement map for a direct word replacement.
	      if (replaceMap.hasOwnProperty(token)) {
	        return restoreCase(word, replaceMap[token]);
	      }
	
	      // Run all the rules against the word.
	      return sanitizeWord(token, word, rules);
	    };
	  }
	
	  /**
	   * Check if a word is part of the map.
	   */
	  function checkWord (replaceMap, keepMap, rules, bool) {
	    return function (word) {
	      var token = word.toLowerCase();
	
	      if (keepMap.hasOwnProperty(token)) return true;
	      if (replaceMap.hasOwnProperty(token)) return false;
	
	      return sanitizeWord(token, token, rules) === token;
	    };
	  }
	
	  /**
	   * Pluralize or singularize a word based on the passed in count.
	   *
	   * @param  {string}  word      The word to pluralize
	   * @param  {number}  count     How many of the word exist
	   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
	   * @return {string}
	   */
	  function pluralize (word, count, inclusive) {
	    var pluralized = count === 1
	      ? pluralize.singular(word) : pluralize.plural(word);
	
	    return (inclusive ? count + ' ' : '') + pluralized;
	  }
	
	  /**
	   * Pluralize a word.
	   *
	   * @type {Function}
	   */
	  pluralize.plural = replaceWord(
	    irregularSingles, irregularPlurals, pluralRules
	  );
	
	  /**
	   * Check if a word is plural.
	   *
	   * @type {Function}
	   */
	  pluralize.isPlural = checkWord(
	    irregularSingles, irregularPlurals, pluralRules
	  );
	
	  /**
	   * Singularize a word.
	   *
	   * @type {Function}
	   */
	  pluralize.singular = replaceWord(
	    irregularPlurals, irregularSingles, singularRules
	  );
	
	  /**
	   * Check if a word is singular.
	   *
	   * @type {Function}
	   */
	  pluralize.isSingular = checkWord(
	    irregularPlurals, irregularSingles, singularRules
	  );
	
	  /**
	   * Add a pluralization rule to the collection.
	   *
	   * @param {(string|RegExp)} rule
	   * @param {string}          replacement
	   */
	  pluralize.addPluralRule = function (rule, replacement) {
	    pluralRules.push([sanitizeRule(rule), replacement]);
	  };
	
	  /**
	   * Add a singularization rule to the collection.
	   *
	   * @param {(string|RegExp)} rule
	   * @param {string}          replacement
	   */
	  pluralize.addSingularRule = function (rule, replacement) {
	    singularRules.push([sanitizeRule(rule), replacement]);
	  };
	
	  /**
	   * Add an uncountable word rule.
	   *
	   * @param {(string|RegExp)} word
	   */
	  pluralize.addUncountableRule = function (word) {
	    if (typeof word === 'string') {
	      uncountables[word.toLowerCase()] = true;
	      return;
	    }
	
	    // Set singular and plural references for the word.
	    pluralize.addPluralRule(word, '$0');
	    pluralize.addSingularRule(word, '$0');
	  };
	
	  /**
	   * Add an irregular word definition.
	   *
	   * @param {string} single
	   * @param {string} plural
	   */
	  pluralize.addIrregularRule = function (single, plural) {
	    plural = plural.toLowerCase();
	    single = single.toLowerCase();
	
	    irregularSingles[single] = plural;
	    irregularPlurals[plural] = single;
	  };
	
	  /**
	   * Irregular rules.
	   */
	  [
	    // Pronouns.
	    ['I', 'we'],
	    ['me', 'us'],
	    ['he', 'they'],
	    ['she', 'they'],
	    ['them', 'them'],
	    ['myself', 'ourselves'],
	    ['yourself', 'yourselves'],
	    ['itself', 'themselves'],
	    ['herself', 'themselves'],
	    ['himself', 'themselves'],
	    ['themself', 'themselves'],
	    ['is', 'are'],
	    ['was', 'were'],
	    ['has', 'have'],
	    ['this', 'these'],
	    ['that', 'those'],
	    // Words ending in with a consonant and `o`.
	    ['echo', 'echoes'],
	    ['dingo', 'dingoes'],
	    ['volcano', 'volcanoes'],
	    ['tornado', 'tornadoes'],
	    ['torpedo', 'torpedoes'],
	    // Ends with `us`.
	    ['genus', 'genera'],
	    ['viscus', 'viscera'],
	    // Ends with `ma`.
	    ['stigma', 'stigmata'],
	    ['stoma', 'stomata'],
	    ['dogma', 'dogmata'],
	    ['lemma', 'lemmata'],
	    ['schema', 'schemata'],
	    ['anathema', 'anathemata'],
	    // Other irregular rules.
	    ['ox', 'oxen'],
	    ['axe', 'axes'],
	    ['die', 'dice'],
	    ['yes', 'yeses'],
	    ['foot', 'feet'],
	    ['eave', 'eaves'],
	    ['goose', 'geese'],
	    ['tooth', 'teeth'],
	    ['quiz', 'quizzes'],
	    ['human', 'humans'],
	    ['proof', 'proofs'],
	    ['carve', 'carves'],
	    ['valve', 'valves'],
	    ['looey', 'looies'],
	    ['thief', 'thieves'],
	    ['groove', 'grooves'],
	    ['pickaxe', 'pickaxes'],
	    ['passerby', 'passersby']
	  ].forEach(function (rule) {
	    return pluralize.addIrregularRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Pluralization rules.
	   */
	  [
	    [/s?$/i, 's'],
	    [/[^\u0000-\u007F]$/i, '$0'],
	    [/([^aeiou]ese)$/i, '$1'],
	    [/(ax|test)is$/i, '$1es'],
	    [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, '$1es'],
	    [/(e[mn]u)s?$/i, '$1s'],
	    [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, '$1'],
	    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
	    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
	    [/(seraph|cherub)(?:im)?$/i, '$1im'],
	    [/(her|at|gr)o$/i, '$1oes'],
	    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
	    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
	    [/sis$/i, 'ses'],
	    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
	    [/([^aeiouy]|qu)y$/i, '$1ies'],
	    [/([^ch][ieo][ln])ey$/i, '$1ies'],
	    [/(x|ch|ss|sh|zz)$/i, '$1es'],
	    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
	    [/\b((?:tit)?m|l)(?:ice|ouse)$/i, '$1ice'],
	    [/(pe)(?:rson|ople)$/i, '$1ople'],
	    [/(child)(?:ren)?$/i, '$1ren'],
	    [/eaux$/i, '$0'],
	    [/m[ae]n$/i, 'men'],
	    ['thou', 'you']
	  ].forEach(function (rule) {
	    return pluralize.addPluralRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Singularization rules.
	   */
	  [
	    [/s$/i, ''],
	    [/(ss)$/i, '$1'],
	    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
	    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
	    [/ies$/i, 'y'],
	    [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'],
	    [/\b(mon|smil)ies$/i, '$1ey'],
	    [/\b((?:tit)?m|l)ice$/i, '$1ouse'],
	    [/(seraph|cherub)im$/i, '$1'],
	    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, '$1'],
	    [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, '$1sis'],
	    [/(movie|twelve|abuse|e[mn]u)s$/i, '$1'],
	    [/(test)(?:is|es)$/i, '$1is'],
	    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
	    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
	    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
	    [/(alumn|alg|vertebr)ae$/i, '$1a'],
	    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
	    [/(matr|append)ices$/i, '$1ix'],
	    [/(pe)(rson|ople)$/i, '$1rson'],
	    [/(child)ren$/i, '$1'],
	    [/(eau)x?$/i, '$1'],
	    [/men$/i, 'man']
	  ].forEach(function (rule) {
	    return pluralize.addSingularRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Uncountable rules.
	   */
	  [
	    // Singular words with no plurals.
	    'adulthood',
	    'advice',
	    'agenda',
	    'aid',
	    'aircraft',
	    'alcohol',
	    'ammo',
	    'analytics',
	    'anime',
	    'athletics',
	    'audio',
	    'bison',
	    'blood',
	    'bream',
	    'buffalo',
	    'butter',
	    'carp',
	    'cash',
	    'chassis',
	    'chess',
	    'clothing',
	    'cod',
	    'commerce',
	    'cooperation',
	    'corps',
	    'debris',
	    'diabetes',
	    'digestion',
	    'elk',
	    'energy',
	    'equipment',
	    'excretion',
	    'expertise',
	    'firmware',
	    'flounder',
	    'fun',
	    'gallows',
	    'garbage',
	    'graffiti',
	    'hardware',
	    'headquarters',
	    'health',
	    'herpes',
	    'highjinks',
	    'homework',
	    'housework',
	    'information',
	    'jeans',
	    'justice',
	    'kudos',
	    'labour',
	    'literature',
	    'machinery',
	    'mackerel',
	    'mail',
	    'media',
	    'mews',
	    'moose',
	    'music',
	    'mud',
	    'manga',
	    'news',
	    'only',
	    'personnel',
	    'pike',
	    'plankton',
	    'pliers',
	    'police',
	    'pollution',
	    'premises',
	    'rain',
	    'research',
	    'rice',
	    'salmon',
	    'scissors',
	    'series',
	    'sewage',
	    'shambles',
	    'shrimp',
	    'software',
	    'species',
	    'staff',
	    'swine',
	    'tennis',
	    'traffic',
	    'transportation',
	    'trout',
	    'tuna',
	    'wealth',
	    'welfare',
	    'whiting',
	    'wildebeest',
	    'wildlife',
	    'you',
	    /pok[eé]mon$/i,
	    // Regexes.
	    /[^aeiou]ese$/i, // "chinese", "japanese"
	    /deer$/i, // "deer", "reindeer"
	    /fish$/i, // "fish", "blowfish", "angelfish"
	    /measles$/i,
	    /o[iu]s$/i, // "carnivorous"
	    /pox$/i, // "chickpox", "smallpox"
	    /sheep$/i
	  ].forEach(pluralize.addUncountableRule);
	
	  return pluralize;
	});


/***/ },
/* 3027 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 3028 */
[4176, 210],
/* 3029 */
[4177, 210],
/* 3030 */
[4178, 210, 3028, 3029, 1424, 3031, 3033],
/* 3031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// This file contains then/promise specific extensions that are only useful
	// for node.js interop
	
	var Promise = __webpack_require__(210);
	var asap = __webpack_require__(844);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	Promise.denodeify = function (fn, argumentCount) {
	  if (
	    typeof argumentCount === 'number' && argumentCount !== Infinity
	  ) {
	    return denodeifyWithCount(fn, argumentCount);
	  } else {
	    return denodeifyWithoutCount(fn);
	  }
	}
	
	var callbackFn = (
	  'function (err, res) {' +
	  'if (err) { rj(err); } else { rs(res); }' +
	  '}'
	);
	function denodeifyWithCount(fn, argumentCount) {
	  var args = [];
	  for (var i = 0; i < argumentCount; i++) {
	    args.push('a' + i);
	  }
	  var body = [
	    'return function (' + args.join(',') + ') {',
	    'var self = this;',
	    'return new Promise(function (rs, rj) {',
	    'var res = fn.call(',
	    ['self'].concat(args).concat([callbackFn]).join(','),
	    ');',
	    'if (res &&',
	    '(typeof res === "object" || typeof res === "function") &&',
	    'typeof res.then === "function"',
	    ') {rs(res);}',
	    '});',
	    '};'
	  ].join('');
	  return Function(['Promise', 'fn'], body)(Promise, fn);
	}
	function denodeifyWithoutCount(fn) {
	  var fnLength = Math.max(fn.length - 1, 3);
	  var args = [];
	  for (var i = 0; i < fnLength; i++) {
	    args.push('a' + i);
	  }
	  var body = [
	    'return function (' + args.join(',') + ') {',
	    'var self = this;',
	    'var args;',
	    'var argLength = arguments.length;',
	    'if (arguments.length > ' + fnLength + ') {',
	    'args = new Array(arguments.length + 1);',
	    'for (var i = 0; i < arguments.length; i++) {',
	    'args[i] = arguments[i];',
	    '}',
	    '}',
	    'return new Promise(function (rs, rj) {',
	    'var cb = ' + callbackFn + ';',
	    'var res;',
	    'switch (argLength) {',
	    args.concat(['extra']).map(function (_, index) {
	      return (
	        'case ' + (index) + ':' +
	        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
	        'break;'
	      );
	    }).join(''),
	    'default:',
	    'args[argLength] = cb;',
	    'res = fn.apply(self, args);',
	    '}',
	    
	    'if (res &&',
	    '(typeof res === "object" || typeof res === "function") &&',
	    'typeof res.then === "function"',
	    ') {rs(res);}',
	    '});',
	    '};'
	  ].join('');
	
	  return Function(
	    ['Promise', 'fn'],
	    body
	  )(Promise, fn);
	}
	
	Promise.nodeify = function (fn) {
	  return function () {
	    var args = Array.prototype.slice.call(arguments);
	    var callback =
	      typeof args[args.length - 1] === 'function' ? args.pop() : null;
	    var ctx = this;
	    try {
	      return fn.apply(this, arguments).nodeify(callback, ctx);
	    } catch (ex) {
	      if (callback === null || typeof callback == 'undefined') {
	        return new Promise(function (resolve, reject) {
	          reject(ex);
	        });
	      } else {
	        asap(function () {
	          callback.call(ctx, ex);
	        })
	      }
	    }
	  }
	}
	
	Promise.prototype.nodeify = function (callback, ctx) {
	  if (typeof callback != 'function') return this;
	
	  this.then(function (value) {
	    asap(function () {
	      callback.call(ctx, null, value);
	    });
	  }, function (err) {
	    asap(function () {
	      callback.call(ctx, err);
	    });
	  });
	}


/***/ },
/* 3032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(210);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 3033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(210);
	
	module.exports = Promise;
	Promise.enableSynchronous = function () {
	  Promise.prototype.isPending = function() {
	    return this.getState() == 0;
	  };
	
	  Promise.prototype.isFulfilled = function() {
	    return this.getState() == 1;
	  };
	
	  Promise.prototype.isRejected = function() {
	    return this.getState() == 2;
	  };
	
	  Promise.prototype.getValue = function () {
	    if (this._81 === 3) {
	      return this._65.getValue();
	    }
	
	    if (!this.isFulfilled()) {
	      throw new Error('Cannot get a value of an unfulfilled promise.');
	    }
	
	    return this._65;
	  };
	
	  Promise.prototype.getReason = function () {
	    if (this._81 === 3) {
	      return this._65.getReason();
	    }
	
	    if (!this.isRejected()) {
	      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
	    }
	
	    return this._65;
	  };
	
	  Promise.prototype.getState = function () {
	    if (this._81 === 3) {
	      return this._65.getState();
	    }
	    if (this._81 === -1 || this._81 === -2) {
	      return 0;
	    }
	
	    return this._81;
	  };
	};
	
	Promise.disableSynchronous = function() {
	  Promise.prototype.isPending = undefined;
	  Promise.prototype.isFulfilled = undefined;
	  Promise.prototype.isRejected = undefined;
	  Promise.prototype.getValue = undefined;
	  Promise.prototype.getReason = undefined;
	  Promise.prototype.getState = undefined;
	};


/***/ },
/* 3034 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(110);
	var invariant = __webpack_require__(36);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 3035 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)(module), (function() { return this; }())))

/***/ },
/* 3036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1426);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseValues(str, options) {
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos));
	            val = options.decoder(part.slice(pos + 1));
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function parseObject(chain, val, options) {
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj;
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(parseObject(chain, val, options));
	    } else {
	        obj = options.plainObjects ? Object.create(null) : {};
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        if (
	            !isNaN(index) &&
	            root !== cleanRoot &&
	            String(index) === cleanRoot &&
	            index >= 0 &&
	            (options.parseArrays && index <= options.arrayLimit)
	        ) {
	            obj = [];
	            obj[index] = parseObject(chain, val, options);
	        } else {
	            obj[cleanRoot] = parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	var parseKeys = function parseKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^\.\[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, segment[1])) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].replace(/\[|\]/g, ''))) {
	            if (!options.allowPrototypes) {
	                continue;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts || {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ },
/* 3037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1426);
	var formats = __webpack_require__(1425);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder ? encoder(prefix) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            return [formatter(encoder(prefix)) + '=' + formatter(encoder(obj))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter
	            ));
	        } else {
	            values = values.concat(stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = encode ? (typeof options.encoder === 'function' ? options.encoder : defaults.encoder) : null;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    if (typeof options.format === 'undefined') {
	        options.format = formats.default;
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encoder,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter
	        ));
	    }
	
	    return keys.join(delimiter);
	};


/***/ },
/* 3038 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 3039 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 3040 */
/***/ function(module, exports, __webpack_require__) {

	var always = __webpack_require__(253);
	
	
	/**
	 * A function that always returns `false`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.T
	 * @example
	 *
	 *      R.F(); //=> false
	 */
	module.exports = always(false);


/***/ },
/* 3041 */
/***/ function(module, exports, __webpack_require__) {

	var always = __webpack_require__(253);
	
	
	/**
	 * A function that always returns `true`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.F
	 * @example
	 *
	 *      R.T(); //=> true
	 */
	module.exports = always(true);


/***/ },
/* 3042 */
/***/ function(module, exports) {

	/**
	 * A special placeholder value used to specify "gaps" within curried functions,
	 * allowing partial application of any combination of arguments, regardless of
	 * their positions.
	 *
	 * If `g` is a curried ternary function and `_` is `R.__`, the following are
	 * equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2, _)(1, 3)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @constant
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @example
	 *
	 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
	 *      greet('Alice'); //=> 'Hello, Alice!'
	 */
	module.exports = {'@@functional/placeholder': true};


/***/ },
/* 3043 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(124);
	var _curry1 = __webpack_require__(29);
	var curryN = __webpack_require__(80);
	
	
	/**
	 * Creates a new list iteration function from an existing one by adding two new
	 * parameters to its callback function: the current index, and the entire list.
	 *
	 * This would turn, for instance, [`R.map`](#map) function into one that
	 * more closely resembles `Array.prototype.map`. Note that this will only work
	 * for functions in which the iteration callback function is the first
	 * parameter, and where the list is the last parameter. (This latter might be
	 * unimportant if the list parameter is not used.)
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Function
	 * @category List
	 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
	 * @param {Function} fn A list iteration function that does not pass index or list to its callback
	 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
	 * @example
	 *
	 *      var mapIndexed = R.addIndex(R.map);
	 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
	 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
	 */
	module.exports = _curry1(function addIndex(fn) {
	  return curryN(fn.length, function() {
	    var idx = 0;
	    var origFn = arguments[0];
	    var list = arguments[arguments.length - 1];
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = function() {
	      var result = origFn.apply(this, _concat(arguments, [idx, list]));
	      idx += 1;
	      return result;
	    };
	    return fn.apply(this, args);
	  });
	});


/***/ },
/* 3044 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xall = __webpack_require__(3117);
	
	
	/**
	 * Returns `true` if all elements of the list match the predicate, `false` if
	 * there are any that don't.
	 *
	 * Dispatches to the `all` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
	 *         otherwise.
	 * @see R.any, R.none, R.transduce
	 * @example
	 *
	 *      var equals3 = R.equals(3);
	 *      R.all(equals3)([3, 3, 3, 3]); //=> true
	 *      R.all(equals3)([3, 3, 1, 3]); //=> false
	 */
	module.exports = _curry2(_dispatchable(['all'], _xall, function all(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (!fn(list[idx])) {
	      return false;
	    }
	    idx += 1;
	  }
	  return true;
	}));


/***/ },
/* 3045 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var curryN = __webpack_require__(80);
	var max = __webpack_require__(254);
	var pluck = __webpack_require__(312);
	var reduce = __webpack_require__(137);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if every one of the provided predicates is satisfied
	 * by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.anyPass
	 * @example
	 *
	 *      var isQueen = R.propEq('rank', 'Q');
	 *      var isSpade = R.propEq('suit', '♠︎');
	 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
	 *
	 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
	 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
	 */
	module.exports = _curry1(function allPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (!preds[idx].apply(this, arguments)) {
	        return false;
	      }
	      idx += 1;
	    }
	    return true;
	  });
	});


/***/ },
/* 3046 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var curryN = __webpack_require__(80);
	var max = __webpack_require__(254);
	var pluck = __webpack_require__(312);
	var reduce = __webpack_require__(137);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if at least one of the provided predicates is
	 * satisfied by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.allPass
	 * @example
	 *
	 *      var isClub = R.propEq('suit', '♣');
	 *      var isSpade = R.propEq('suit', '♠');
	 *      var isBlackCard = R.anyPass([isClub, isSpade]);
	 *
	 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
	 */
	module.exports = _curry1(function anyPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (preds[idx].apply(this, arguments)) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  });
	});


/***/ },
/* 3047 */
/***/ function(module, exports, __webpack_require__) {

	var _aperture = __webpack_require__(3100);
	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xaperture = __webpack_require__(3118);
	
	
	/**
	 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
	 * greater than the length of the list, an empty list is returned.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @param {Number} n The size of the tuples to create
	 * @param {Array} list The list to split into `n`-length tuples
	 * @return {Array} The resulting list of `n`-length tuples
	 * @see R.transduce
	 * @example
	 *
	 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
	 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
	 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
	 */
	module.exports = _curry2(_dispatchable([], _xaperture, _aperture));


/***/ },
/* 3048 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(124);
	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns a new list containing the contents of the given list, followed by
	 * the given element.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The element to add to the end of the new list.
	 * @param {Array} list The list of elements to add a new item to.
	 *        list.
	 * @return {Array} A new list containing the elements of the old list followed by `el`.
	 * @see R.prepend
	 * @example
	 *
	 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
	 *      R.append('tests', []); //=> ['tests']
	 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
	 */
	module.exports = _curry2(function append(el, list) {
	  return _concat(list, [el]);
	});


/***/ },
/* 3049 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var apply = __webpack_require__(1433);
	var curryN = __webpack_require__(80);
	var map = __webpack_require__(99);
	var max = __webpack_require__(254);
	var pluck = __webpack_require__(312);
	var reduce = __webpack_require__(137);
	var values = __webpack_require__(1483);
	
	
	/**
	 * Given a spec object recursively mapping properties to functions, creates a
	 * function producing an object of the same structure, by mapping each property
	 * to the result of calling its associated function with the supplied arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
	 * @param {Object} spec an object recursively mapping properties to functions for
	 *        producing the values for these properties.
	 * @return {Function} A function that returns an object of the same structure
	 * as `spec', with each property set to the value returned by calling its
	 * associated function with the supplied arguments.
	 * @see R.converge, R.juxt
	 * @example
	 *
	 *      var getMetrics = R.applySpec({
	 *                                      sum: R.add,
	 *                                      nested: { mul: R.multiply }
	 *                                   });
	 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
	 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
	 */
	module.exports = _curry1(function applySpec(spec) {
	  spec = map(function(v) { return typeof v == 'function' ? v : applySpec(v); },
	             spec);
	  return curryN(reduce(max, 0, pluck('length', values(spec))),
	                function() {
	                  var args = arguments;
	                  return map(function(f) { return apply(f, args); }, spec);
	                });
	});


/***/ },
/* 3050 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Makes an ascending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
	 * @see R.descend
	 * @example
	 *
	 *      var byAge = R.ascend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByYoungestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function ascend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa < bb ? -1 : aa > bb ? 1 : 0;
	});


/***/ },
/* 3051 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var nAry = __webpack_require__(439);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 2 parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> c) -> (a, b -> c)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 2.
	 * @see R.nAry, R.unary
	 * @example
	 *
	 *      var takesThreeArgs = function(a, b, c) {
	 *        return [a, b, c];
	 *      };
	 *      takesThreeArgs.length; //=> 3
	 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      var takesTwoArgs = R.binary(takesThreeArgs);
	 *      takesTwoArgs.length; //=> 2
	 *      // Only 2 arguments are passed to the wrapped function
	 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
	 * @symb R.binary(f)(a, b, c) = f(a, b)
	 */
	module.exports = _curry1(function binary(fn) {
	  return nAry(2, fn);
	});


/***/ },
/* 3052 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _isFunction = __webpack_require__(433);
	var and = __webpack_require__(1431);
	var lift = __webpack_require__(437);
	
	
	/**
	 * A function which calls the two provided functions and returns the `&&`
	 * of the results.
	 * It returns the result of the first function if it is false-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * false-y value.
	 *
	 * In addition to functions, `R.both` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f A predicate
	 * @param {Function} g Another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
	 * @see R.and
	 * @example
	 *
	 *      var gt10 = R.gt(R.__, 10)
	 *      var lt20 = R.lt(R.__, 20)
	 *      var f = R.both(gt10, lt20);
	 *      f(15); //=> true
	 *      f(30); //=> false
	 */
	module.exports = _curry2(function both(f, g) {
	  return _isFunction(f) ?
	    function _both() {
	      return f.apply(this, arguments) && g.apply(this, arguments);
	    } :
	    lift(and)(f, g);
	});


/***/ },
/* 3053 */
/***/ function(module, exports, __webpack_require__) {

	var curry = __webpack_require__(428);
	
	
	/**
	 * Returns the result of calling its first argument with the remaining
	 * arguments. This is occasionally useful as a converging function for
	 * [`R.converge`](#converge): the first branch can produce a function while the
	 * remaining branches produce values to be passed to that function as its
	 * arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig (*... -> a),*... -> a
	 * @param {Function} fn The function to apply to the remaining arguments.
	 * @param {...*} args Any number of positional arguments.
	 * @return {*}
	 * @see R.apply
	 * @example
	 *
	 *      R.call(R.add, 1, 2); //=> 3
	 *
	 *      var indentN = R.pipe(R.times(R.always(' ')),
	 *                           R.join(''),
	 *                           R.replace(/^(?!$)/gm));
	 *
	 *      var format = R.converge(R.call, [
	 *                                  R.pipe(R.prop('indent'), indentN),
	 *                                  R.prop('value')
	 *                              ]);
	 *
	 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
	 * @symb R.call(f, a, b) = f(a, b)
	 */
	module.exports = curry(function call(fn) {
	  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
	});


/***/ },
/* 3054 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	/**
	 * Restricts a number to be within a range.
	 *
	 * Also works for other ordered types such as Strings and Dates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a -> a
	 * @param {Number} minimum The lower limit of the clamp (inclusive)
	 * @param {Number} maximum The upper limit of the clamp (inclusive)
	 * @param {Number} value Value to be clamped
	 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
	 * @example
	 *
	 *      R.clamp(1, 10, -5) // => 1
	 *      R.clamp(1, 10, 15) // => 10
	 *      R.clamp(1, 10, 4)  // => 4
	 */
	module.exports = _curry3(function clamp(min, max, value) {
	  if (min > max) {
	    throw new Error('min must not be greater than max in clamp(min, max, value)');
	  }
	  return value < min ? min :
	         value > max ? max :
	         value;
	});


/***/ },
/* 3055 */
/***/ function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(1447);
	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Creates a deep copy of the value which may contain (nested) `Array`s and
	 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
	 * assigned by reference rather than copied
	 *
	 * Dispatches to a `clone` method if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {*} -> {*}
	 * @param {*} value The object or array to clone
	 * @return {*} A deeply cloned copy of `val`
	 * @example
	 *
	 *      var objects = [{}, {}, {}];
	 *      var objectsClone = R.clone(objects);
	 *      objects === objectsClone; //=> false
	 *      objects[0] === objectsClone[0]; //=> false
	 */
	module.exports = _curry1(function clone(value) {
	  return value != null && typeof value.clone === 'function' ?
	    value.clone() :
	    _clone(value, [], [], true);
	});


/***/ },
/* 3056 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Makes a comparator function out of a function that reports whether the first
	 * element is less than the second.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a, b -> Boolean) -> (a, b -> Number)
	 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
	 * is less than the second, `false` otherwise
	 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
	 * @example
	 *
	 *      var byAge = R.comparator((a, b) => a.age < b.age);
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByIncreasingAge = R.sort(byAge, people);
	 */
	module.exports = _curry1(function comparator(pred) {
	  return function(a, b) {
	    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
	  };
	});


/***/ },
/* 3057 */
/***/ function(module, exports, __webpack_require__) {

	var lift = __webpack_require__(437);
	var not = __webpack_require__(1467);
	
	
	/**
	 * Takes a function `f` and returns a function `g` such that if called with the same arguments
	 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
	 *
	 * `R.complement` may be applied to any functor
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> *) -> (*... -> Boolean)
	 * @param {Function} f
	 * @return {Function}
	 * @see R.not
	 * @example
	 *
	 *      var isNotNil = R.complement(R.isNil);
	 *      isNil(null); //=> true
	 *      isNotNil(null); //=> false
	 *      isNil(7); //=> false
	 *      isNotNil(7); //=> true
	 */
	module.exports = lift(not);


/***/ },
/* 3058 */
/***/ function(module, exports, __webpack_require__) {

	var pipeP = __webpack_require__(1473);
	var reverse = __webpack_require__(442);
	
	
	/**
	 * Performs right-to-left composition of one or more Promise-returning
	 * functions. The rightmost function may have any arity; the remaining
	 * functions must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
	 * @param {...Function} functions The functions to compose
	 * @return {Function}
	 * @see R.pipeP
	 * @example
	 *
	 *      var db = {
	 *        users: {
	 *          JOE: {
	 *            name: 'Joe',
	 *            followers: ['STEVE', 'SUZY']
	 *          }
	 *        }
	 *      }
	 *
	 *      // We'll pretend to do a db lookup which returns a promise
	 *      var lookupUser = (userId) => Promise.resolve(db.users[userId])
	 *      var lookupFollowers = (user) => Promise.resolve(user.followers)
	 *      lookupUser('JOE').then(lookupFollowers)
	 *
	 *      //  followersForUser :: String -> Promise [UserId]
	 *      var followersForUser = R.composeP(lookupFollowers, lookupUser);
	 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
	 *      // Followers: ["STEVE","SUZY"]
	 */
	module.exports = function composeP() {
	  if (arguments.length === 0) {
	    throw new Error('composeP requires at least one argument');
	  }
	  return pipeP.apply(this, reverse(arguments));
	};


/***/ },
/* 3059 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(135);
	var _curry1 = __webpack_require__(29);
	var map = __webpack_require__(99);
	var max = __webpack_require__(254);
	var reduce = __webpack_require__(137);
	
	
	/**
	 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
	 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
	 * to `fn` are applied to each of the predicates in turn until one returns a
	 * "truthy" value, at which point `fn` returns the result of applying its
	 * arguments to the corresponding transformer. If none of the predicates
	 * matches, `fn` returns undefined.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Logic
	 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
	 * @param {Array} pairs A list of [predicate, transformer]
	 * @return {Function}
	 * @example
	 *
	 *      var fn = R.cond([
	 *        [R.equals(0),   R.always('water freezes at 0°C')],
	 *        [R.equals(100), R.always('water boils at 100°C')],
	 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
	 *      ]);
	 *      fn(0); //=> 'water freezes at 0°C'
	 *      fn(50); //=> 'nothing special happens at 50°C'
	 *      fn(100); //=> 'water boils at 100°C'
	 */
	module.exports = _curry1(function cond(pairs) {
	  var arity = reduce(max,
	                     0,
	                     map(function(pair) { return pair[0].length; }, pairs));
	  return _arity(arity, function() {
	    var idx = 0;
	    while (idx < pairs.length) {
	      if (pairs[idx][0].apply(this, arguments)) {
	        return pairs[idx][1].apply(this, arguments);
	      }
	      idx += 1;
	    }
	  });
	});


/***/ },
/* 3060 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var constructN = __webpack_require__(1437);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> {*}) -> (* -> {*})
	 * @param {Function} fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @see R.invoker
	 * @example
	 *
	 *      // Constructor function
	 *      function Animal(kind) {
	 *        this.kind = kind;
	 *      };
	 *      Animal.prototype.sighting = function() {
	 *        return "It's a " + this.kind + "!";
	 *      }
	 *
	 *      var AnimalConstructor = R.construct(Animal)
	 *
	 *      // Notice we no longer need the 'new' keyword:
	 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
	 *
	 *      var animalTypes = ["Lion", "Tiger", "Bear"];
	 *      var animalSighting = R.invoker(0, 'sighting');
	 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
	 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
	 */
	module.exports = _curry1(function construct(Fn) {
	  return constructN(Fn.length, Fn);
	});


/***/ },
/* 3061 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(211);
	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
	 * terms, to at least one element of the given list; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Boolean
	 * @param {Object} a The item to compare against.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
	 * @see R.any
	 * @example
	 *
	 *      R.contains(3, [1, 2, 3]); //=> true
	 *      R.contains(4, [1, 2, 3]); //=> false
	 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
	 *      R.contains([42], [[42]]); //=> true
	 */
	module.exports = _curry2(_contains);


/***/ },
/* 3062 */
/***/ function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(440);
	
	
	/**
	 * Counts the elements of a list according to how many match each value of a
	 * key generated by the supplied function. Returns an object mapping the keys
	 * produced by `fn` to the number of occurrences in the list. Note that all
	 * keys are coerced to strings because of how JavaScript objects work.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> String) -> [a] -> {*}
	 * @param {Function} fn The function used to map values to keys.
	 * @param {Array} list The list to count elements from.
	 * @return {Object} An object mapping keys to number of occurrences in the list.
	 * @example
	 *
	 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
	 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
	 *
	 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
	 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
	 */
	module.exports = reduceBy(function(acc, elem) { return acc + 1; }, 0);


/***/ },
/* 3063 */
/***/ function(module, exports, __webpack_require__) {

	var add = __webpack_require__(426);
	
	
	/**
	 * Decrements its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n - 1
	 * @see R.inc
	 * @example
	 *
	 *      R.dec(42); //=> 41
	 */
	module.exports = add(-1);


/***/ },
/* 3064 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Makes a descending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
	 * @see R.ascend
	 * @example
	 *
	 *      var byAge = R.descend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByOldestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function descend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa > bb ? -1 : aa < bb ? 1 : 0;
	});


/***/ },
/* 3065 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _isInteger = __webpack_require__(690);
	var assoc = __webpack_require__(427);
	var dissoc = __webpack_require__(1442);
	var remove = __webpack_require__(1476);
	var update = __webpack_require__(700);
	
	
	/**
	 * Makes a shallow clone of an object, omitting the property at the given path.
	 * Note that this copies and flattens prototype properties onto the new object
	 * as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.11.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {k: v} -> {k: v}
	 * @param {Array} path The path to the value to omit
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object without the property at path
	 * @see R.assocPath
	 * @example
	 *
	 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
	 */
	module.exports = _curry2(function dissocPath(path, obj) {
	  switch (path.length) {
	    case 0:
	      return obj;
	    case 1:
	      return _isInteger(path[0]) ? remove(path[0], 1, obj) : dissoc(path[0], obj);
	    default:
	      var head = path[0];
	      var tail = Array.prototype.slice.call(path, 1);
	      if (obj[head] == null) {
	        return obj;
	      } else if (_isInteger(path[0])) {
	        return update(head, dissocPath(tail, obj[head]), obj);
	      } else {
	        return assoc(head, dissocPath(tail, obj[head]), obj);
	      }
	  }
	});


/***/ },
/* 3066 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Divides two numbers. Equivalent to `a / b`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a / b`.
	 * @see R.multiply
	 * @example
	 *
	 *      R.divide(71, 100); //=> 0.71
	 *
	 *      var half = R.divide(R.__, 2);
	 *      half(42); //=> 21
	 *
	 *      var reciprocal = R.divide(1);
	 *      reciprocal(4);   //=> 0.25
	 */
	module.exports = _curry2(function divide(a, b) { return a / b; });


/***/ },
/* 3067 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _dropLast = __webpack_require__(3102);
	var _xdropLast = __webpack_require__(3121);
	
	
	/**
	 * Returns a list containing all but the last `n` elements of the given `list`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements of `list` to skip.
	 * @param {Array} list The list of elements to consider.
	 * @return {Array} A copy of the list with only the first `list.length - n` elements
	 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
	 * @example
	 *
	 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(3, 'ramda');               //=> 'ra'
	 */
	module.exports = _curry2(_dispatchable([], _xdropLast, _dropLast));


/***/ },
/* 3068 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _dropLastWhile = __webpack_require__(3103);
	var _xdropLastWhile = __webpack_require__(3122);
	
	
	/**
	 * Returns a new list excluding all the tailing elements of a given list which
	 * satisfy the supplied predicate function. It passes each value from the right
	 * to the supplied predicate function, skipping elements until the predicate
	 * function returns a `falsy` value. The predicate function is applied to one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} predicate The function to be called on each element
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
	 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
	 * @example
	 *
	 *      var lteThree = x => x <= 3;
	 *
	 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(_dispatchable([], _xdropLastWhile, _dropLastWhile));


/***/ },
/* 3069 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _dispatchable = __webpack_require__(65);
	var _xdropRepeatsWith = __webpack_require__(1456);
	var dropRepeatsWith = __webpack_require__(1444);
	var equals = __webpack_require__(111);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements.
	 * [`R.equals`](#equals) is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
	 */
	module.exports = _curry1(_dispatchable([], _xdropRepeatsWith(equals), dropRepeatsWith(equals)));


/***/ },
/* 3070 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xdropWhile = __webpack_require__(3123);
	
	
	/**
	 * Returns a new list excluding the leading elements of a given list which
	 * satisfy the supplied predicate function. It passes each value to the supplied
	 * predicate function, skipping elements while the predicate function returns
	 * `true`. The predicate function is applied to one argument: *(value)*.
	 *
	 * Dispatches to the `dropWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.takeWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var lteTwo = x => x <= 2;
	 *
	 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
	 */
	module.exports = _curry2(_dispatchable(['dropWhile'], _xdropWhile, function dropWhile(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && pred(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, idx);
	}));


/***/ },
/* 3071 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _isFunction = __webpack_require__(433);
	var lift = __webpack_require__(437);
	var or = __webpack_require__(1469);
	
	
	/**
	 * A function wrapping calls to the two functions in an `||` operation,
	 * returning the result of the first function if it is truth-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * truth-y value.
	 *
	 * In addition to functions, `R.either` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f a predicate
	 * @param {Function} g another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
	 * @see R.or
	 * @example
	 *
	 *      var gt10 = x => x > 10;
	 *      var even = x => x % 2 === 0;
	 *      var f = R.either(gt10, even);
	 *      f(101); //=> true
	 *      f(8); //=> true
	 */
	module.exports = _curry2(function either(f, g) {
	  return _isFunction(f) ?
	    function _either() {
	      return f.apply(this, arguments) || g.apply(this, arguments);
	    } :
	    lift(or)(f, g);
	});


/***/ },
/* 3072 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var equals = __webpack_require__(111);
	var takeLast = __webpack_require__(1479);
	
	/**
	 * Checks if a list ends with the provided values
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category List
	 * @sig [a] -> Boolean
	 * @sig String -> Boolean
	 * @param {*} suffix
	 * @param {*} list
	 * @return {Boolean}
	 * @example
	 *
	 *      R.endsWith('c', 'abc')                //=> true
	 *      R.endsWith('b', 'abc')                //=> false
	 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
	 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
	 */
	module.exports = _curry2(function(suffix, list) {
	  return equals(takeLast(suffix.length, list), suffix);
	});


/***/ },
/* 3073 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var equals = __webpack_require__(111);
	
	
	/**
	 * Takes a function and two values in its domain and returns `true` if the
	 * values map to the same value in the codomain; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Relation
	 * @sig (a -> b) -> a -> a -> Boolean
	 * @param {Function} f
	 * @param {*} x
	 * @param {*} y
	 * @return {Boolean}
	 * @example
	 *
	 *      R.eqBy(Math.abs, 5, -5); //=> true
	 */
	module.exports = _curry3(function eqBy(f, x, y) {
	  return equals(f(x), f(y));
	});


/***/ },
/* 3074 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var equals = __webpack_require__(111);
	
	
	/**
	 * Reports whether two objects have the same value, in [`R.equals`](#equals)
	 * terms, for the specified property. Useful as a curried predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig k -> {k: v} -> {k: v} -> Boolean
	 * @param {String} prop The name of the property to compare
	 * @param {Object} obj1
	 * @param {Object} obj2
	 * @return {Boolean}
	 *
	 * @example
	 *
	 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
	 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
	 *      R.eqProps('a', o1, o2); //=> false
	 *      R.eqProps('c', o1, o2); //=> true
	 */
	module.exports = _curry3(function eqProps(prop, obj1, obj2) {
	  return equals(obj1[prop], obj2[prop]);
	});


/***/ },
/* 3075 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Creates a new object by recursively evolving a shallow copy of `object`,
	 * according to the `transformation` functions. All non-primitive properties
	 * are copied by reference.
	 *
	 * A `transformation` function will not be invoked if its corresponding key
	 * does not exist in the evolved object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
	 * @param {Object} transformations The object specifying transformation functions to apply
	 *        to the object.
	 * @param {Object} object The object to be transformed.
	 * @return {Object} The transformed object.
	 * @example
	 *
	 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
	 *      var transformations = {
	 *        firstName: R.trim,
	 *        lastName: R.trim, // Will not get invoked.
	 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
	 *      };
	 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
	 */
	module.exports = _curry2(function evolve(transformations, object) {
	  var result = {};
	  var transformation, key, type;
	  for (key in object) {
	    transformation = transformations[key];
	    type = typeof transformation;
	    result[key] = type === 'function'                 ? transformation(object[key])
	                : transformation && type === 'object' ? evolve(transformation, object[key])
	                                                      : object[key];
	  }
	  return result;
	});


/***/ },
/* 3076 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xfind = __webpack_require__(3125);
	
	
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable(['find'], _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx += 1;
	  }
	}));


/***/ },
/* 3077 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xfindIndex = __webpack_require__(3126);
	
	
	/**
	 * Returns the index of the first element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
	 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindIndex, function findIndex(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	}));


/***/ },
/* 3078 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xfindLast = __webpack_require__(3127);
	
	
	/**
	 * Returns the last element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
	 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable([], _xfindLast, function findLast(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx -= 1;
	  }
	}));


/***/ },
/* 3079 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xfindLastIndex = __webpack_require__(3128);
	
	
	/**
	 * Returns the index of the last element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
	 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindLastIndex, function findLastIndex(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx -= 1;
	  }
	  return -1;
	}));


/***/ },
/* 3080 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _makeFlat = __webpack_require__(1454);
	
	
	/**
	 * Returns a new list by pulling every item out of it (and all its sub-arrays)
	 * and putting them in a new array, depth-first.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b]
	 * @param {Array} list The array to consider.
	 * @return {Array} The flattened list.
	 * @see R.unnest
	 * @example
	 *
	 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
	 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
	 */
	module.exports = _curry1(_makeFlat(true));


/***/ },
/* 3081 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(307);
	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Iterate over an input `list`, calling a provided function `fn` for each
	 * element in the list.
	 *
	 * `fn` receives one argument: *(value)*.
	 *
	 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.forEach` method. For more
	 * details on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
	 *
	 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
	 * the original array. In some libraries this function is named `each`.
	 *
	 * Dispatches to the `forEach` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> *) -> [a] -> [a]
	 * @param {Function} fn The function to invoke. Receives one argument, `value`.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} The original list.
	 * @see R.addIndex
	 * @example
	 *
	 *      var printXPlusFive = x => console.log(x + 5);
	 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
	 *      // logs 6
	 *      // logs 7
	 *      // logs 8
	 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
	 */
	module.exports = _curry2(_checkForMethod('forEach', function forEach(fn, list) {
	  var len = list.length;
	  var idx = 0;
	  while (idx < len) {
	    fn(list[idx]);
	    idx += 1;
	  }
	  return list;
	}));


/***/ },
/* 3082 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var keys = __webpack_require__(136);
	
	
	/**
	 * Iterate over an input `object`, calling a provided function `fn` for each
	 * key and value in the object.
	 *
	 * `fn` receives three argument: *(value, key, obj)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Object
	 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
	 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
	 * @param {Object} obj The object to iterate over.
	 * @return {Object} The original object.
	 * @example
	 *
	 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
	 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
	 *      // logs x:1
	 *      // logs y:2
	 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
	 */
	module.exports = _curry2(function forEachObjIndexed(fn, obj) {
	  var keyList = keys(obj);
	  var idx = 0;
	  while (idx < keyList.length) {
	    var key = keyList[idx];
	    fn(obj[key], key, obj);
	    idx += 1;
	  }
	  return obj;
	});


/***/ },
/* 3083 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Creates a new object from a list key-value pairs. If a key appears in
	 * multiple pairs, the rightmost pair is included in the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [[k,v]] -> {k: v}
	 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
	 * @return {Object} The object made by pairing up `keys` and `values`.
	 * @see R.toPairs, R.pair
	 * @example
	 *
	 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry1(function fromPairs(pairs) {
	  var result = {};
	  var idx = 0;
	  while (idx < pairs.length) {
	    result[pairs[idx][0]] = pairs[idx][1];
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 3084 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(307);
	var _curry2 = __webpack_require__(13);
	var reduceBy = __webpack_require__(440);
	
	/**
	 * Splits a list into sub-lists stored in an object, based on the result of
	 * calling a String-returning function on each element, and grouping the
	 * results according to values returned.
	 *
	 * Dispatches to the `groupBy` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> String) -> [a] -> {String: [a]}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} list The array to group
	 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
	 *         that produced that key when passed to `fn`.
	 * @see R.transduce
	 * @example
	 *
	 *      var byGrade = R.groupBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Abby', score: 84},
	 *                      {name: 'Eddy', score: 58},
	 *                      // ...
	 *                      {name: 'Jack', score: 69}];
	 *      byGrade(students);
	 *      // {
	 *      //   'A': [{name: 'Dianne', score: 99}],
	 *      //   'B': [{name: 'Abby', score: 84}]
	 *      //   // ...,
	 *      //   'F': [{name: 'Eddy', score: 58}]
	 *      // }
	 */
	module.exports = _curry2(_checkForMethod('groupBy', reduceBy(function(acc, item) {
	  if (acc == null) {
	    acc = [];
	  }
	  acc.push(item);
	  return acc;
	}, null)));


/***/ },
/* 3085 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	/**
	 * Takes a list and returns a list of lists where each sublist's elements are
	 * all satisfied pairwise comparison according to the provided function.
	 * Only adjacent elements are passed to the comparison function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.21.0
	 * @category List
	 * @sig ((a, a) → Boolean) → [a] → [[a]]
	 * @param {Function} fn Function for determining whether two given (adjacent)
	 *        elements should be in the same group
	 * @param {Array} list The array to group. Also accepts a string, which will be
	 *        treated as a list of characters.
	 * @return {List} A list that contains sublists of elements,
	 *         whose concatenations are equal to the original list.
	 * @example
	 *
	 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
	 *
	 * R.groupWith(R.eqBy(isVowel), 'aestiou')
	 * //=> ['ae', 'st', 'iou']
	 */
	module.exports = _curry2(function(fn, list) {
	  var res = [];
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    var nextidx = idx + 1;
	    while (nextidx < len && fn(list[nextidx - 1], list[nextidx])) {
	      nextidx += 1;
	    }
	    res.push(list.slice(idx, nextidx));
	    idx = nextidx;
	  }
	  return res;
	});


/***/ },
/* 3086 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns `true` if the first argument is greater than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.lt
	 * @example
	 *
	 *      R.gt(2, 1); //=> true
	 *      R.gt(2, 2); //=> false
	 *      R.gt(2, 3); //=> false
	 *      R.gt('a', 'z'); //=> false
	 *      R.gt('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gt(a, b) { return a > b; });


/***/ },
/* 3087 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns `true` if the first argument is greater than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.lte
	 * @example
	 *
	 *      R.gte(2, 1); //=> true
	 *      R.gte(2, 2); //=> true
	 *      R.gte(2, 3); //=> false
	 *      R.gte('a', 'z'); //=> false
	 *      R.gte('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gte(a, b) { return a >= b; });


/***/ },
/* 3088 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _has = __webpack_require__(90);
	
	
	/**
	 * Returns whether or not an object has an own property with the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      var hasName = R.has('name');
	 *      hasName({name: 'alice'});   //=> true
	 *      hasName({name: 'bob'});     //=> true
	 *      hasName({});                //=> false
	 *
	 *      var point = {x: 0, y: 0};
	 *      var pointHas = R.has(R.__, point);
	 *      pointHas('x');  //=> true
	 *      pointHas('y');  //=> true
	 *      pointHas('z');  //=> false
	 */
	module.exports = _curry2(_has);


/***/ },
/* 3089 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns whether or not an object or its prototype chain has a property with
	 * the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      function Rectangle(width, height) {
	 *        this.width = width;
	 *        this.height = height;
	 *      }
	 *      Rectangle.prototype.area = function() {
	 *        return this.width * this.height;
	 *      };
	 *
	 *      var square = new Rectangle(2, 2);
	 *      R.hasIn('width', square);  //=> true
	 *      R.hasIn('area', square);  //=> true
	 */
	module.exports = _curry2(function hasIn(prop, obj) {
	  return prop in obj;
	});


/***/ },
/* 3090 */
/***/ function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(310);
	
	
	/**
	 * Returns the first element of the given list or string. In some libraries
	 * this function is named `first`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {*}
	 * @see R.tail, R.init, R.last
	 * @example
	 *
	 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
	 *      R.head([]); //=> undefined
	 *
	 *      R.head('abc'); //=> 'a'
	 *      R.head(''); //=> ''
	 */
	module.exports = nth(0);


/***/ },
/* 3091 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var curryN = __webpack_require__(80);
	
	
	/**
	 * Creates a function that will process either the `onTrue` or the `onFalse`
	 * function depending upon the result of the `condition` predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
	 * @param {Function} condition A predicate function
	 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
	 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
	 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
	 *                    function depending upon the result of the `condition` predicate.
	 * @see R.unless, R.when
	 * @example
	 *
	 *      var incCount = R.ifElse(
	 *        R.has('count'),
	 *        R.over(R.lensProp('count'), R.inc),
	 *        R.assoc('count', 1)
	 *      );
	 *      incCount({});           //=> { count: 1 }
	 *      incCount({ count: 1 }); //=> { count: 2 }
	 */
	module.exports = _curry3(function ifElse(condition, onTrue, onFalse) {
	  return curryN(Math.max(condition.length, onTrue.length, onFalse.length),
	    function _ifElse() {
	      return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
	    }
	  );
	});


/***/ },
/* 3092 */
/***/ function(module, exports, __webpack_require__) {

	var add = __webpack_require__(426);
	
	
	/**
	 * Increments its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n + 1
	 * @see R.dec
	 * @example
	 *
	 *      R.inc(42); //=> 43
	 */
	module.exports = add(1);


/***/ },
/* 3093 */
/***/ function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(440);
	
	
	/**
	 * Given a function that generates a key, turns a list of objects into an
	 * object indexing the objects by the given key. Note that if multiple
	 * objects generate the same value for the indexing key only the last value
	 * will be included in the generated object.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} array The array of objects to index
	 * @return {Object} An object indexing each array element by the given property.
	 * @example
	 *
	 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
	 *      R.indexBy(R.prop('id'), list);
	 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
	 */
	module.exports = reduceBy(function(acc, elem) { return elem; }, null);


/***/ },
/* 3094 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _indexOf = __webpack_require__(1451);
	var _isArray = __webpack_require__(180);
	
	
	/**
	 * Returns the position of the first occurrence of an item in an array, or -1
	 * if the item is not included in the array. [`R.equals`](#equals) is used to
	 * determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.lastIndexOf
	 * @example
	 *
	 *      R.indexOf(3, [1,2,3,4]); //=> 2
	 *      R.indexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function indexOf(target, xs) {
	  return typeof xs.indexOf === 'function' && !_isArray(xs) ?
	    xs.indexOf(target) :
	    _indexOf(xs, target, 0);
	});


/***/ },
/* 3095 */
/***/ function(module, exports, __webpack_require__) {

	var slice = __webpack_require__(212);
	
	
	/**
	 * Returns all but the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.last, R.head, R.tail
	 * @example
	 *
	 *      R.init([1, 2, 3]);  //=> [1, 2]
	 *      R.init([1, 2]);     //=> [1]
	 *      R.init([1]);        //=> []
	 *      R.init([]);         //=> []
	 *
	 *      R.init('abc');  //=> 'ab'
	 *      R.init('ab');   //=> 'a'
	 *      R.init('a');    //=> ''
	 *      R.init('');     //=> ''
	 */
	module.exports = slice(0, -1);


/***/ },
/* 3096 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(430);
	var _curry3 = __webpack_require__(35);
	var _filter = __webpack_require__(688);
	
	
	/**
	 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
	 * `xs'` comprising each of the elements of `xs` which is equal to one or more
	 * elements of `ys` according to `pred`.
	 *
	 * `pred` must be a binary function expecting an element from each list.
	 *
	 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
	 * not be significant, but since `xs'` is ordered the implementation guarantees
	 * that its values are in the same order as they appear in `xs`. Duplicates are
	 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Relation
	 * @sig (a -> b -> Boolean) -> [a] -> [b] -> [a]
	 * @param {Function} pred
	 * @param {Array} xs
	 * @param {Array} ys
	 * @return {Array}
	 * @see R.intersection
	 * @example
	 *
	 *      R.innerJoin(
	 *        (record, id) => record.id === id,
	 *        [{id: 824, name: 'Richie Furay'},
	 *         {id: 956, name: 'Dewey Martin'},
	 *         {id: 313, name: 'Bruce Palmer'},
	 *         {id: 456, name: 'Stephen Stills'},
	 *         {id: 177, name: 'Neil Young'}],
	 *        [177, 456, 999]
	 *      );
	 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
	 */
	module.exports = _curry3(function innerJoin(pred, xs, ys) {
	  return _filter(function(x) { return _containsWith(pred, x, ys); }, xs);
	});


/***/ },
/* 3097 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Inserts the supplied element into the list, at the specified `index`. _Note that
	
	 * this is not destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} index The position to insert the element
	 * @param {*} elt The element to insert into the Array
	 * @param {Array} list The list to insert into
	 * @return {Array} A new Array with `elt` inserted at `index`.
	 * @example
	 *
	 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
	 */
	module.exports = _curry3(function insert(idx, elt, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(idx, 0, elt);
	  return result;
	});


/***/ },
/* 3098 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
	 * destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig Number -> [a] -> [a] -> [a]
	 * @param {Number} index The position to insert the sub-list
	 * @param {Array} elts The sub-list to insert into the Array
	 * @param {Array} list The list to insert the sub-list into
	 * @return {Array} A new Array with `elts` inserted starting at `index`.
	 * @example
	 *
	 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
	 */
	module.exports = _curry3(function insertAll(idx, elts, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  return [].concat(Array.prototype.slice.call(list, 0, idx),
	                   elts,
	                   Array.prototype.slice.call(list, idx));
	});


/***/ },
/* 3099 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(211);
	
	
	// A simple Set type that honours R.equals semantics
	module.exports = (function() {
	  function _Set() {
	    /* globals Set */
	    this._nativeSet = typeof Set === 'function' ? new Set() : null;
	    this._items = {};
	  }
	
	  // until we figure out why jsdoc chokes on this
	  // @param item The item to add to the Set
	  // @returns {boolean} true if the item did not exist prior, otherwise false
	  //
	  _Set.prototype.add = function(item) {
	    return !hasOrAdd(item, true, this);
	  };
	
	  //
	  // @param item The item to check for existence in the Set
	  // @returns {boolean} true if the item exists in the Set, otherwise false
	  //
	  _Set.prototype.has = function(item) {
	    return hasOrAdd(item, false, this);
	  };
	
	  //
	  // Combines the logic for checking whether an item is a member of the set and
	  // for adding a new item to the set.
	  //
	  // @param item       The item to check or add to the Set instance.
	  // @param shouldAdd  If true, the item will be added to the set if it doesn't
	  //                   already exist.
	  // @param set        The set instance to check or add to.
	  // @return {boolean} true if the item already existed, otherwise false.
	  //
	  function hasOrAdd(item, shouldAdd, set) {
	    var type = typeof item;
	    var prevSize, newSize;
	    switch (type) {
	      case 'string':
	      case 'number':
	        // distinguish between +0 and -0
	        if (item === 0 && 1 / item === -Infinity) {
	          if (set._items['-0']) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items['-0'] = true;
	            }
	            return false;
	          }
	        }
	        // these types can all utilise the native Set
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = {};
	              set._items[type][item] = true;
	            }
	            return false;
	          } else if (item in set._items[type]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][item] = true;
	            }
	            return false;
	          }
	        }
	
	      case 'boolean':
	        // set._items['boolean'] holds a two element array
	        // representing [ falseExists, trueExists ]
	        if (type in set._items) {
	          var bIdx = item ? 1 : 0;
	          if (set._items[type][bIdx]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][bIdx] = true;
	            }
	            return false;
	          }
	        } else {
	          if (shouldAdd) {
	            set._items[type] = item ? [false, true] : [true, false];
	          }
	          return false;
	        }
	
	      case 'function':
	        // compare functions for reference equality
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = [item];
	            }
	            return false;
	          }
	          if (!_contains(item, set._items[type])) {
	            if (shouldAdd) {
	              set._items[type].push(item);
	            }
	            return false;
	          }
	          return true;
	        }
	
	      case 'undefined':
	        if (set._items[type]) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items[type] = true;
	          }
	          return false;
	        }
	
	      case 'object':
	        if (item === null) {
	          if (!set._items['null']) {
	            if (shouldAdd) {
	              set._items['null'] = true;
	            }
	            return false;
	          }
	          return true;
	        }
	      /* falls through */
	      default:
	        // reduce the search size of heterogeneous sets by creating buckets
	        // for each type.
	        type = Object.prototype.toString.call(item);
	        if (!(type in set._items)) {
	          if (shouldAdd) {
	            set._items[type] = [item];
	          }
	          return false;
	        }
	        // scan through all previously applied items
	        if (!_contains(item, set._items[type])) {
	          if (shouldAdd) {
	            set._items[type].push(item);
	          }
	          return false;
	        }
	        return true;
	    }
	  }
	  return _Set;
	}());


/***/ },
/* 3100 */
/***/ function(module, exports) {

	module.exports = function _aperture(n, list) {
	  var idx = 0;
	  var limit = list.length - (n - 1);
	  var acc = new Array(limit >= 0 ? limit : 0);
	  while (idx < limit) {
	    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
	    idx += 1;
	  }
	  return acc;
	};


/***/ },
/* 3101 */
/***/ function(module, exports) {

	module.exports = function _arrayFromIterator(iter) {
	  var list = [];
	  var next;
	  while (!(next = iter.next()).done) {
	    list.push(next.value);
	  }
	  return list;
	};


/***/ },
/* 3102 */
/***/ function(module, exports, __webpack_require__) {

	var take = __webpack_require__(696);
	
	module.exports = function dropLast(n, xs) {
	  return take(n < xs.length ? xs.length - n : 0, xs);
	};


/***/ },
/* 3103 */
/***/ function(module, exports) {

	module.exports = function dropLastWhile(pred, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && pred(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx + 1);
	};


/***/ },
/* 3104 */
/***/ function(module, exports, __webpack_require__) {

	var _arrayFromIterator = __webpack_require__(3101);
	var _functionName = __webpack_require__(3107);
	var _has = __webpack_require__(90);
	var identical = __webpack_require__(1446);
	var keys = __webpack_require__(136);
	var type = __webpack_require__(697);
	
	
	module.exports = function _equals(a, b, stackA, stackB) {
	  if (identical(a, b)) {
	    return true;
	  }
	
	  if (type(a) !== type(b)) {
	    return false;
	  }
	
	  if (a == null || b == null) {
	    return false;
	  }
	
	  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
	    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) &&
	           typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
	  }
	
	  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	    return typeof a.equals === 'function' && a.equals(b) &&
	           typeof b.equals === 'function' && b.equals(a);
	  }
	
	  switch (type(a)) {
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	      if (typeof a.constructor === 'function' &&
	          _functionName(a.constructor) === 'Promise') {
	        return a === b;
	      }
	      break;
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
	        return false;
	      }
	      break;
	    case 'Date':
	      if (!identical(a.valueOf(), b.valueOf())) {
	        return false;
	      }
	      break;
	    case 'Error':
	      return a.name === b.name && a.message === b.message;
	    case 'RegExp':
	      if (!(a.source === b.source &&
	            a.global === b.global &&
	            a.ignoreCase === b.ignoreCase &&
	            a.multiline === b.multiline &&
	            a.sticky === b.sticky &&
	            a.unicode === b.unicode)) {
	        return false;
	      }
	      break;
	    case 'Map':
	    case 'Set':
	      if (!_equals(_arrayFromIterator(a.entries()), _arrayFromIterator(b.entries()), stackA, stackB)) {
	        return false;
	      }
	      break;
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	      break;
	    case 'ArrayBuffer':
	      break;
	    default:
	      // Values of other types are only equal if identical.
	      return false;
	  }
	
	  var keysA = keys(a);
	  if (keysA.length !== keys(b).length) {
	    return false;
	  }
	
	  var idx = stackA.length - 1;
	  while (idx >= 0) {
	    if (stackA[idx] === a) {
	      return stackB[idx] === b;
	    }
	    idx -= 1;
	  }
	
	  stackA.push(a);
	  stackB.push(b);
	  idx = keysA.length - 1;
	  while (idx >= 0) {
	    var key = keysA[idx];
	    if (!(_has(key, b) && _equals(b[key], a[key], stackA, stackB))) {
	      return false;
	    }
	    idx -= 1;
	  }
	  stackA.pop();
	  stackB.pop();
	  return true;
	};


/***/ },
/* 3105 */
/***/ function(module, exports, __webpack_require__) {

	var _forceReduced = __webpack_require__(3106);
	var _isArrayLike = __webpack_require__(432);
	var _reduce = __webpack_require__(112);
	var _xfBase = __webpack_require__(67);
	
	module.exports = (function() {
	  var preservingReduced = function(xf) {
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return xf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        var ret = xf['@@transducer/step'](result, input);
	        return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
	      }
	    };
	  };
	
	  return function _xcat(xf) {
	    var rxf = preservingReduced(xf);
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return rxf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        return !_isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
	      }
	    };
	  };
	}());


/***/ },
/* 3106 */
/***/ function(module, exports) {

	module.exports = function _forceReduced(x) {
	  return {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	};


/***/ },
/* 3107 */
/***/ function(module, exports) {

	module.exports = function _functionName(f) {
	  // String(x => x) evaluates to "x => x", so the pattern may not match.
	  var match = String(f).match(/^function (\w*)/);
	  return match == null ? '' : match[1];
	};


/***/ },
/* 3108 */
/***/ function(module, exports) {

	module.exports = function _isRegExp(x) {
	  return Object.prototype.toString.call(x) === '[object RegExp]';
	};


/***/ },
/* 3109 */
/***/ function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(90);
	
	// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	module.exports = function _objectAssign(target) {
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	  var idx = 1;
	  var length = arguments.length;
	  while (idx < length) {
	    var source = arguments[idx];
	    if (source != null) {
	      for (var nextKey in source) {
	        if (_has(nextKey, source)) {
	          output[nextKey] = source[nextKey];
	        }
	      }
	    }
	    idx += 1;
	  }
	  return output;
	};


/***/ },
/* 3110 */
/***/ function(module, exports) {

	module.exports = function _of(x) { return [x]; };


/***/ },
/* 3111 */
/***/ function(module, exports) {

	module.exports = function _pipe(f, g) {
	  return function() {
	    return g.call(this, f.apply(this, arguments));
	  };
	};


/***/ },
/* 3112 */
/***/ function(module, exports) {

	module.exports = function _pipeP(f, g) {
	  return function() {
	    var ctx = this;
	    return f.apply(ctx, arguments).then(function(x) {
	      return g.call(ctx, x);
	    });
	  };
	};


/***/ },
/* 3113 */
/***/ function(module, exports) {

	module.exports = function _quote(s) {
	  var escaped = s
	    .replace(/\\/g, '\\\\')
	    .replace(/[\b]/g, '\\b')  // \b matches word boundary; [\b] matches backspace
	    .replace(/\f/g, '\\f')
	    .replace(/\n/g, '\\n')
	    .replace(/\r/g, '\\r')
	    .replace(/\t/g, '\\t')
	    .replace(/\v/g, '\\v')
	    .replace(/\0/g, '\\0');
	
	  return '"' + escaped.replace(/"/g, '\\"') + '"';
	};


/***/ },
/* 3114 */
/***/ function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(687);
	var _identity = __webpack_require__(689);
	var _isArrayLike = __webpack_require__(432);
	var _isTransformer = __webpack_require__(692);
	var objOf = __webpack_require__(1468);
	
	
	module.exports = (function() {
	  var _stepCatArray = {
	    '@@transducer/init': Array,
	    '@@transducer/step': function(xs, x) {
	      xs.push(x);
	      return xs;
	    },
	    '@@transducer/result': _identity
	  };
	  var _stepCatString = {
	    '@@transducer/init': String,
	    '@@transducer/step': function(a, b) { return a + b; },
	    '@@transducer/result': _identity
	  };
	  var _stepCatObject = {
	    '@@transducer/init': Object,
	    '@@transducer/step': function(result, input) {
	      return _assign(
	        result,
	        _isArrayLike(input) ? objOf(input[0], input[1]) : input
	      );
	    },
	    '@@transducer/result': _identity
	  };
	
	  return function _stepCat(obj) {
	    if (_isTransformer(obj)) {
	      return obj;
	    }
	    if (_isArrayLike(obj)) {
	      return _stepCatArray;
	    }
	    if (typeof obj === 'string') {
	      return _stepCatString;
	    }
	    if (typeof obj === 'object') {
	      return _stepCatObject;
	    }
	    throw new Error('Cannot create transformer for ' + obj);
	  };
	}());


/***/ },
/* 3115 */
/***/ function(module, exports) {

	/**
	 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
	 */
	module.exports = (function() {
	  var pad = function pad(n) { return (n < 10 ? '0' : '') + n; };
	
	  return typeof Date.prototype.toISOString === 'function' ?
	    function _toISOString(d) {
	      return d.toISOString();
	    } :
	    function _toISOString(d) {
	      return (
	        d.getUTCFullYear() + '-' +
	        pad(d.getUTCMonth() + 1) + '-' +
	        pad(d.getUTCDate()) + 'T' +
	        pad(d.getUTCHours()) + ':' +
	        pad(d.getUTCMinutes()) + ':' +
	        pad(d.getUTCSeconds()) + '.' +
	        (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z'
	      );
	    };
	}());


/***/ },
/* 3116 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(211);
	var _map = __webpack_require__(435);
	var _quote = __webpack_require__(3113);
	var _toISOString = __webpack_require__(3115);
	var keys = __webpack_require__(136);
	var reject = __webpack_require__(441);
	
	
	module.exports = function _toString(x, seen) {
	  var recur = function recur(y) {
	    var xs = seen.concat([x]);
	    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
	  };
	
	  //  mapPairs :: (Object, [String]) -> [String]
	  var mapPairs = function(obj, keys) {
	    return _map(function(k) { return _quote(k) + ': ' + recur(obj[k]); }, keys.slice().sort());
	  };
	
	  switch (Object.prototype.toString.call(x)) {
	    case '[object Arguments]':
	      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
	    case '[object Array]':
	      return '[' + _map(recur, x).concat(mapPairs(x, reject(function(k) { return /^\d+$/.test(k); }, keys(x)))).join(', ') + ']';
	    case '[object Boolean]':
	      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
	    case '[object Date]':
	      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
	    case '[object Null]':
	      return 'null';
	    case '[object Number]':
	      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
	    case '[object String]':
	      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
	    case '[object Undefined]':
	      return 'undefined';
	    default:
	      if (typeof x.toString === 'function') {
	        var repr = x.toString();
	        if (repr !== '[object Object]') {
	          return repr;
	        }
	      }
	      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
	  }
	};


/***/ },
/* 3117 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _reduced = __webpack_require__(181);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XAll(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.all = true;
	  }
	  XAll.prototype['@@transducer/init'] = _xfBase.init;
	  XAll.prototype['@@transducer/result'] = function(result) {
	    if (this.all) {
	      result = this.xf['@@transducer/step'](result, true);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAll.prototype['@@transducer/step'] = function(result, input) {
	    if (!this.f(input)) {
	      this.all = false;
	      result = _reduced(this.xf['@@transducer/step'](result, false));
	    }
	    return result;
	  };
	
	  return _curry2(function _xall(f, xf) { return new XAll(f, xf); });
	}());


/***/ },
/* 3118 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(124);
	var _curry2 = __webpack_require__(13);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XAperture(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XAperture.prototype['@@transducer/init'] = _xfBase.init;
	  XAperture.prototype['@@transducer/result'] = function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XAperture.prototype['@@transducer/step'] = function(result, input) {
	    this.store(input);
	    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
	  };
	  XAperture.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	  XAperture.prototype.getCopy = function() {
	    return _concat(Array.prototype.slice.call(this.acc, this.pos),
	                   Array.prototype.slice.call(this.acc, 0, this.pos));
	  };
	
	  return _curry2(function _xaperture(n, xf) { return new XAperture(n, xf); });
	}());


/***/ },
/* 3119 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _flatCat = __webpack_require__(3105);
	var map = __webpack_require__(99);
	
	
	module.exports = _curry2(function _xchain(f, xf) {
	  return map(f, _flatCat(xf));
	});


/***/ },
/* 3120 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XDrop(n, xf) {
	    this.xf = xf;
	    this.n = n;
	  }
	  XDrop.prototype['@@transducer/init'] = _xfBase.init;
	  XDrop.prototype['@@transducer/result'] = _xfBase.result;
	  XDrop.prototype['@@transducer/step'] = function(result, input) {
	    if (this.n > 0) {
	      this.n -= 1;
	      return result;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdrop(n, xf) { return new XDrop(n, xf); });
	}());


/***/ },
/* 3121 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XDropLast(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XDropLast.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLast.prototype['@@transducer/result'] =  function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.full) {
	      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
	    }
	    this.store(input);
	    return result;
	  };
	  XDropLast.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	
	  return _curry2(function _xdropLast(n, xf) { return new XDropLast(n, xf); });
	}());


/***/ },
/* 3122 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _reduce = __webpack_require__(112);
	var _xfBase = __webpack_require__(67);
	
	module.exports = (function() {
	  function XDropLastWhile(fn, xf) {
	    this.f = fn;
	    this.retained = [];
	    this.xf = xf;
	  }
	  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLastWhile.prototype['@@transducer/result'] = function(result) {
	    this.retained = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.retain(result, input)
	                         : this.flush(result, input);
	  };
	  XDropLastWhile.prototype.flush = function(result, input) {
	    result = _reduce(
	      this.xf['@@transducer/step'],
	      result,
	      this.retained
	    );
	    this.retained = [];
	    return this.xf['@@transducer/step'](result, input);
	  };
	  XDropLastWhile.prototype.retain = function(result, input) {
	    this.retained.push(input);
	    return result;
	  };
	
	  return _curry2(function _xdropLastWhile(fn, xf) { return new XDropLastWhile(fn, xf); });
	}());


/***/ },
/* 3123 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XDropWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XDropWhile.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f) {
	      if (this.f(input)) {
	        return result;
	      }
	      this.f = null;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropWhile(f, xf) { return new XDropWhile(f, xf); });
	}());


/***/ },
/* 3124 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	  XFilter.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return _curry2(function _xfilter(f, xf) { return new XFilter(f, xf); });
	}());


/***/ },
/* 3125 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _reduced = __webpack_require__(181);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	  XFind.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFind.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfind(f, xf) { return new XFind(f, xf); });
	}());


/***/ },
/* 3126 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _reduced = __webpack_require__(181);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XFindIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.found = false;
	  }
	  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindIndex.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, -1);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFindIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, this.idx));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindIndex(f, xf) { return new XFindIndex(f, xf); });
	}());


/***/ },
/* 3127 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XFindLast(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFindLast.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLast.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
	  };
	  XFindLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.last = input;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLast(f, xf) { return new XFindLast(f, xf); });
	}());


/***/ },
/* 3128 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XFindLastIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.lastIdx = -1;
	  }
	  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLastIndex.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
	  };
	  XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.lastIdx = this.idx;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLastIndex(f, xf) { return new XFindLastIndex(f, xf); });
	}());


/***/ },
/* 3129 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	  XMap.prototype['@@transducer/step'] = function(result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return _curry2(function _xmap(f, xf) { return new XMap(f, xf); });
	}());


/***/ },
/* 3130 */
/***/ function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(431);
	var _has = __webpack_require__(90);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
	    this.valueFn = valueFn;
	    this.valueAcc = valueAcc;
	    this.keyFn = keyFn;
	    this.xf = xf;
	    this.inputs = {};
	  }
	  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
	  XReduceBy.prototype['@@transducer/result'] = function(result) {
	    var key;
	    for (key in this.inputs) {
	      if (_has(key, this.inputs)) {
	        result = this.xf['@@transducer/step'](result, this.inputs[key]);
	        if (result['@@transducer/reduced']) {
	          result = result['@@transducer/value'];
	          break;
	        }
	      }
	    }
	    this.inputs = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XReduceBy.prototype['@@transducer/step'] = function(result, input) {
	    var key = this.keyFn(input);
	    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
	    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
	    return result;
	  };
	
	  return _curryN(4, [],
	                 function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
	                   return new XReduceBy(valueFn, valueAcc, keyFn, xf);
	                 });
	}());


/***/ },
/* 3131 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _reduced = __webpack_require__(181);
	var _xfBase = __webpack_require__(67);
	
	module.exports = (function() {
	  function XTake(n, xf) {
	    this.xf = xf;
	    this.n = n;
	    this.i = 0;
	  }
	  XTake.prototype['@@transducer/init'] = _xfBase.init;
	  XTake.prototype['@@transducer/result'] = _xfBase.result;
	  XTake.prototype['@@transducer/step'] = function(result, input) {
	    this.i += 1;
	    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
	    return this.n >= 0 && this.i >= this.n ? _reduced(ret) : ret;
	  };
	
	  return _curry2(function _xtake(n, xf) { return new XTake(n, xf); });
	}());


/***/ },
/* 3132 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _reduced = __webpack_require__(181);
	var _xfBase = __webpack_require__(67);
	
	
	module.exports = (function() {
	  function XTakeWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
	  };
	
	  return _curry2(function _xtakeWhile(f, xf) { return new XTakeWhile(f, xf); });
	}());


/***/ },
/* 3133 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(211);
	var _curry2 = __webpack_require__(13);
	var _filter = __webpack_require__(688);
	var flip = __webpack_require__(429);
	var uniq = __webpack_require__(698);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The list of elements found in both `list1` and `list2`.
	 * @see R.innerJoin
	 * @example
	 *
	 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
	 */
	module.exports = _curry2(function intersection(list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  return uniq(_filter(flip(_contains)(lookupList), filteredList));
	});


/***/ },
/* 3134 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(430);
	var _curry3 = __webpack_require__(35);
	var uniqWith = __webpack_require__(699);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate function that determines whether
	 *        the two supplied elements are equal.
	 * @param {Array} list1 One list of items to compare
	 * @param {Array} list2 A second list of items to compare
	 * @return {Array} A new list containing those elements common to both lists.
	 * @see R.innerJoin
	 * @deprecated since v0.24.0
	 * @example
	 *
	 *      var buffaloSpringfield = [
	 *        {id: 824, name: 'Richie Furay'},
	 *        {id: 956, name: 'Dewey Martin'},
	 *        {id: 313, name: 'Bruce Palmer'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *      var csny = [
	 *        {id: 204, name: 'David Crosby'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 539, name: 'Graham Nash'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *
	 *      R.intersectionWith(R.eqBy(R.prop('id')), buffaloSpringfield, csny);
	 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
	 */
	module.exports = _curry3(function intersectionWith(pred, list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  var results = [];
	  var idx = 0;
	  while (idx < filteredList.length) {
	    if (_containsWith(pred, filteredList[idx], lookupList)) {
	      results[results.length] = filteredList[idx];
	    }
	    idx += 1;
	  }
	  return uniqWith(pred, results);
	});


/***/ },
/* 3135 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(307);
	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Creates a new list with the separator interposed between elements.
	 *
	 * Dispatches to the `intersperse` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} separator The element to add to the list.
	 * @param {Array} list The list to be interposed.
	 * @return {Array} The new list.
	 * @example
	 *
	 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
	 */
	module.exports = _curry2(_checkForMethod('intersperse', function intersperse(separator, list) {
	  var out = [];
	  var idx = 0;
	  var length = list.length;
	  while (idx < length) {
	    if (idx === length - 1) {
	      out.push(list[idx]);
	    } else {
	      out.push(list[idx], separator);
	    }
	    idx += 1;
	  }
	  return out;
	}));


/***/ },
/* 3136 */
/***/ function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(1447);
	var _curry3 = __webpack_require__(35);
	var _isTransformer = __webpack_require__(692);
	var _reduce = __webpack_require__(112);
	var _stepCat = __webpack_require__(3114);
	
	
	/**
	 * Transforms the items of the list with the transducer and appends the
	 * transformed items to the accumulator using an appropriate iterator function
	 * based on the accumulator type.
	 *
	 * The accumulator can be an array, string, object or a transformer. Iterated
	 * items will be appended to arrays and concatenated to strings. Objects will
	 * be merged directly or 2-item arrays will be merged as key, value pairs.
	 *
	 * The accumulator can also be a transformer object that provides a 2-arity
	 * reducing iterator function, step, 0-arity initial value function, init, and
	 * 1-arity result extraction function result. The step function is used as the
	 * iterator function in reduce. The result function is used to convert the
	 * final accumulator into the return type and in most cases is R.identity. The
	 * init function is used to provide the initial accumulator.
	 *
	 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
	 * transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig a -> (b -> b) -> [c] -> a
	 * @param {*} acc The initial accumulator value.
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.into([], transducer, numbers); //=> [2, 3]
	 *
	 *      var intoArray = R.into([]);
	 *      intoArray(transducer, numbers); //=> [2, 3]
	 */
	module.exports = _curry3(function into(acc, xf, list) {
	  return _isTransformer(acc) ?
	    _reduce(xf(acc), acc['@@transducer/init'](), list) :
	    _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
	});


/***/ },
/* 3137 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _has = __webpack_require__(90);
	var keys = __webpack_require__(136);
	
	
	/**
	 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
	 * duplicate values by putting the values into an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: [ s, ... ]}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object with keys in an array.
	 * @see R.invertObj
	 * @example
	 *
	 *      var raceResultsByFirstName = {
	 *        first: 'alice',
	 *        second: 'jake',
	 *        third: 'alice',
	 *      };
	 *      R.invert(raceResultsByFirstName);
	 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
	 */
	module.exports = _curry1(function invert(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    var val = obj[key];
	    var list = _has(val, out) ? out[val] : (out[val] = []);
	    list[list.length] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 3138 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var keys = __webpack_require__(136);
	
	
	/**
	 * Returns a new object with the keys of the given object as values, and the
	 * values of the given object, which are coerced to strings, as keys. Note
	 * that the last key found is preferred when handling the same value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: s}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object
	 * @see R.invert
	 * @example
	 *
	 *      var raceResults = {
	 *        first: 'alice',
	 *        second: 'jake'
	 *      };
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': 'first', 'jake':'second' }
	 *
	 *      // Alternatively:
	 *      var raceResults = ['alice', 'jake'];
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': '0', 'jake':'1' }
	 */
	module.exports = _curry1(function invertObj(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    out[obj[key]] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 3139 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var empty = __webpack_require__(1445);
	var equals = __webpack_require__(111);
	
	
	/**
	 * Returns `true` if the given value is its type's empty value; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> Boolean
	 * @param {*} x
	 * @return {Boolean}
	 * @see R.empty
	 * @example
	 *
	 *      R.isEmpty([1, 2, 3]);   //=> false
	 *      R.isEmpty([]);          //=> true
	 *      R.isEmpty('');          //=> true
	 *      R.isEmpty(null);        //=> false
	 *      R.isEmpty({});          //=> true
	 *      R.isEmpty({length: 0}); //=> false
	 */
	module.exports = _curry1(function isEmpty(x) {
	  return x != null && equals(x, empty(x));
	});


/***/ },
/* 3140 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(309);
	
	
	/**
	 * Returns a string made by inserting the `separator` between each element and
	 * concatenating all the elements into a single string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig String -> [a] -> String
	 * @param {Number|String} separator The string used to separate the elements.
	 * @param {Array} xs The elements to join into a string.
	 * @return {String} str The string made by concatenating `xs` with `separator`.
	 * @see R.split
	 * @example
	 *
	 *      var spacer = R.join(' ');
	 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
	 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
	 */
	module.exports = invoker(1, 'join');


/***/ },
/* 3141 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Returns a list containing the names of all the properties of the supplied
	 * object, including prototype properties.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own and prototype properties.
	 * @see R.keys, R.valuesIn
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.keysIn(f); //=> ['x', 'y']
	 */
	module.exports = _curry1(function keysIn(obj) {
	  var prop;
	  var ks = [];
	  for (prop in obj) {
	    ks[ks.length] = prop;
	  }
	  return ks;
	});


/***/ },
/* 3142 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _isArray = __webpack_require__(180);
	var equals = __webpack_require__(111);
	
	
	/**
	 * Returns the position of the last occurrence of an item in an array, or -1 if
	 * the item is not included in the array. [`R.equals`](#equals) is used to
	 * determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.indexOf
	 * @example
	 *
	 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
	 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function lastIndexOf(target, xs) {
	  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
	    return xs.lastIndexOf(target);
	  } else {
	    var idx = xs.length - 1;
	    while (idx >= 0) {
	      if (equals(xs[idx], target)) {
	        return idx;
	      }
	      idx -= 1;
	    }
	    return -1;
	  }
	});


/***/ },
/* 3143 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var lens = __webpack_require__(436);
	var nth = __webpack_require__(310);
	var update = __webpack_require__(700);
	
	
	/**
	 * Returns a lens whose focus is the specified index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Number -> Lens s a
	 * @param {Number} n
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
	 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
	 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
	 */
	module.exports = _curry1(function lensIndex(n) {
	  return lens(nth(n), update(n));
	});


/***/ },
/* 3144 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var assocPath = __webpack_require__(1434);
	var lens = __webpack_require__(436);
	var path = __webpack_require__(311);
	
	
	/**
	 * Returns a lens whose focus is the specified path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig [Idx] -> Lens s a
	 * @param {Array} path The path to use.
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
	 *
	 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> 2
	 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
	 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
	 */
	module.exports = _curry1(function lensPath(p) {
	  return lens(path(p), assocPath(p));
	});


/***/ },
/* 3145 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var assoc = __webpack_require__(427);
	var lens = __webpack_require__(436);
	var prop = __webpack_require__(694);
	
	
	/**
	 * Returns a lens whose focus is the specified property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig String -> Lens s a
	 * @param {String} k
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry1(function lensProp(k) {
	  return lens(prop(k), assoc(k));
	});


/***/ },
/* 3146 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns `true` if the first argument is less than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.gt
	 * @example
	 *
	 *      R.lt(2, 1); //=> false
	 *      R.lt(2, 2); //=> false
	 *      R.lt(2, 3); //=> true
	 *      R.lt('a', 'z'); //=> true
	 *      R.lt('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lt(a, b) { return a < b; });


/***/ },
/* 3147 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns `true` if the first argument is less than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.gte
	 * @example
	 *
	 *      R.lte(2, 1); //=> false
	 *      R.lte(2, 2); //=> true
	 *      R.lte(2, 3); //=> true
	 *      R.lte('a', 'z'); //=> true
	 *      R.lte('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lte(a, b) { return a <= b; });


/***/ },
/* 3148 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * The `mapAccum` function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from left to right, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * The iterator function receives two arguments, *acc* and *value*, and should
	 * return a tuple *[acc, value]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (acc -> x -> (acc, y)) -> acc -> [x] -> (acc, [y])
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccumRight
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var appender = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
	 * @symb R.mapAccum(f, a, [b, c, d]) = [
	 *   f(f(f(a, b)[0], c)[0], d)[0],
	 *   [
	 *     f(a, b)[1],
	 *     f(f(a, b)[0], c)[1],
	 *     f(f(f(a, b)[0], c)[0], d)[1]
	 *   ]
	 * ]
	 */
	module.exports = _curry3(function mapAccum(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var tuple = [acc];
	  while (idx < len) {
	    tuple = fn(tuple[0], list[idx]);
	    result[idx] = tuple[1];
	    idx += 1;
	  }
	  return [tuple[0], result];
	});


/***/ },
/* 3149 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * The `mapAccumRight` function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from right to left, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
	 * the right to the left.
	 *
	 * The iterator function receives two arguments, *value* and *acc*, and should
	 * return a tuple *[value, acc]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (x-> acc -> (y, acc)) -> acc -> [x] -> ([y], acc)
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccum
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var append = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
	 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
	 *   [
	 *     f(b, f(c, f(d, a)[0])[0])[1],
	 *     f(c, f(d, a)[0])[1],
	 *     f(d, a)[1],
	 *   ]
	 *   f(b, f(c, f(d, a)[0])[0])[0],
	 * ]
	 */
	module.exports = _curry3(function mapAccumRight(fn, acc, list) {
	  var idx = list.length - 1;
	  var result = [];
	  var tuple = [acc];
	  while (idx >= 0) {
	    tuple = fn(list[idx], tuple[0]);
	    result[idx] = tuple[1];
	    idx -= 1;
	  }
	  return [result, tuple[0]];
	});


/***/ },
/* 3150 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _reduce = __webpack_require__(112);
	var keys = __webpack_require__(136);
	
	
	/**
	 * An Object-specific version of [`map`](#map). The function is applied to three
	 * arguments: *(value, key, obj)*. If only the value is significant, use
	 * [`map`](#map) instead.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig ((*, String, Object) -> *) -> Object -> Object
	 * @param {Function} fn
	 * @param {Object} obj
	 * @return {Object}
	 * @see R.map
	 * @example
	 *
	 *      var values = { x: 1, y: 2, z: 3 };
	 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
	 *
	 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
	 */
	module.exports = _curry2(function mapObjIndexed(fn, obj) {
	  return _reduce(function(acc, key) {
	    acc[key] = fn(obj[key], key, obj);
	    return acc;
	  }, {}, keys(obj));
	});


/***/ },
/* 3151 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Tests a regular expression against a String. Note that this function will
	 * return an empty array when there are no matches. This differs from
	 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
	 * which returns `null` when there are no matches.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig RegExp -> String -> [String | Undefined]
	 * @param {RegExp} rx A regular expression.
	 * @param {String} str The string to match against
	 * @return {Array} The list of matches or empty array.
	 * @see R.test
	 * @example
	 *
	 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
	 *      R.match(/a/, 'b'); //=> []
	 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
	 */
	module.exports = _curry2(function match(rx, str) {
	  return str.match(rx) || [];
	});


/***/ },
/* 3152 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _isInteger = __webpack_require__(690);
	
	
	/**
	 * `mathMod` behaves like the modulo operator should mathematically, unlike the
	 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
	 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
	 * arguments, and returns NaN when the modulus is zero or negative.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} m The dividend.
	 * @param {Number} p the modulus.
	 * @return {Number} The result of `b mod a`.
	 * @see R.modulo
	 * @example
	 *
	 *      R.mathMod(-17, 5);  //=> 3
	 *      R.mathMod(17, 5);   //=> 2
	 *      R.mathMod(17, -5);  //=> NaN
	 *      R.mathMod(17, 0);   //=> NaN
	 *      R.mathMod(17.2, 5); //=> NaN
	 *      R.mathMod(17, 5.3); //=> NaN
	 *
	 *      var clock = R.mathMod(R.__, 12);
	 *      clock(15); //=> 3
	 *      clock(24); //=> 0
	 *
	 *      var seventeenMod = R.mathMod(17);
	 *      seventeenMod(3);  //=> 2
	 *      seventeenMod(4);  //=> 1
	 *      seventeenMod(10); //=> 7
	 */
	module.exports = _curry2(function mathMod(m, p) {
	  if (!_isInteger(m)) { return NaN; }
	  if (!_isInteger(p) || p < 1) { return NaN; }
	  return ((m % p) + p) % p;
	});


/***/ },
/* 3153 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * larger result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.max, R.minBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.maxBy(square, -3, 2); //=> -3
	 *
	 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
	 *      R.reduce(R.maxBy(square), 0, []); //=> 0
	 */
	module.exports = _curry3(function maxBy(f, a, b) {
	  return f(b) > f(a) ? b : a;
	});


/***/ },
/* 3154 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var mean = __webpack_require__(1464);
	
	
	/**
	 * Returns the median of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @see R.mean
	 * @example
	 *
	 *      R.median([2, 9, 7]); //=> 7
	 *      R.median([7, 2, 10, 9]); //=> 8
	 *      R.median([]); //=> NaN
	 */
	module.exports = _curry1(function median(list) {
	  var len = list.length;
	  if (len === 0) {
	    return NaN;
	  }
	  var width = 2 - len % 2;
	  var idx = (len - width) / 2;
	  return mean(Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    return a < b ? -1 : a > b ? 1 : 0;
	  }).slice(idx, idx + width));
	});


/***/ },
/* 3155 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeWith = __webpack_require__(1465);
	var toString = __webpack_require__(313);
	
	
	/**
	 * Creates a new function that, when invoked, caches the result of calling `fn`
	 * for a given argument set and returns the result. Subsequent calls to the
	 * memoized `fn` with the same argument set will not result in an additional
	 * call to `fn`; instead, the cached result for that set of arguments will be
	 * returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (*... -> a) -> (*... -> a)
	 * @param {Function} fn The function to memoize.
	 * @return {Function} Memoized version of `fn`.
	 * @see R.memoizeWith
	 * @example
	 *
	 *      let count = 0;
	 *      const factorial = R.memoize(n => {
	 *        count += 1;
	 *        return R.product(R.range(1, n + 1));
	 *      });
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      count; //=> 1
	 */
	module.exports = memoizeWith(function() {
	  return toString(arguments);
	});


/***/ },
/* 3156 */
/***/ function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(687);
	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Create a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects,
	 * the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> {k: v} -> {k: v}
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeDeepRight, R.mergeWith, R.mergeWithKey
	 * @example
	 *
	 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
	 *      //=> { 'name': 'fred', 'age': 40 }
	 *
	 *      var resetToDefault = R.merge(R.__, {x: 0});
	 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
	 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
	 */
	module.exports = _curry2(function merge(l, r) {
	  return _assign({}, l, r);
	});


/***/ },
/* 3157 */
/***/ function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(687);
	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Merges a list of objects together into one object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig [{k: v}] -> {k: v}
	 * @param {Array} list An array of objects
	 * @return {Object} A merged object.
	 * @see R.reduce
	 * @example
	 *
	 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
	 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
	 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
	 */
	module.exports = _curry1(function mergeAll(list) {
	  return _assign.apply(null, [{}].concat(list));
	});


/***/ },
/* 3158 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var mergeDeepWithKey = __webpack_require__(438);
	
	
	/**
	 * Creates a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects:
	 * - and both values are objects, the two values will be recursively merged
	 * - otherwise the value from the first object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig {a} -> {a} -> {a}
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
	 * @example
	 *
	 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
	 *                      { age: 40, contact: { email: 'baa@example.com' }});
	 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
	 */
	module.exports = _curry2(function mergeDeepLeft(lObj, rObj) {
	  return mergeDeepWithKey(function(k, lVal, rVal) {
	    return lVal;
	  }, lObj, rObj);
	});


/***/ },
/* 3159 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var mergeDeepWithKey = __webpack_require__(438);
	
	
	/**
	 * Creates a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects:
	 * - and both values are objects, the two values will be recursively merged
	 * - otherwise the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig {a} -> {a} -> {a}
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
	 * @example
	 *
	 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
	 *                       { age: 40, contact: { email: 'baa@example.com' }});
	 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
	 */
	module.exports = _curry2(function mergeDeepRight(lObj, rObj) {
	  return mergeDeepWithKey(function(k, lVal, rVal) {
	    return rVal;
	  }, lObj, rObj);
	});


/***/ },
/* 3160 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var mergeDeepWithKey = __webpack_require__(438);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects.
	 * If a key exists in both objects:
	 * - and both associated values are also objects then the values will be
	 *   recursively merged.
	 * - otherwise the provided function is applied to associated values using the
	 *   resulting value as the new value associated with the key.
	 * If a key only exists in one object, the value will be associated with the key
	 * of the resulting object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.mergeWith, R.mergeDeep, R.mergeDeepWithKey
	 * @example
	 *
	 *      R.mergeDeepWith(R.concat,
	 *                      { a: true, c: { values: [10, 20] }},
	 *                      { b: true, c: { values: [15, 35] }});
	 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
	 */
	module.exports = _curry3(function mergeDeepWith(fn, lObj, rObj) {
	  return mergeDeepWithKey(function(k, lVal, rVal) {
	    return fn(lVal, rVal);
	  }, lObj, rObj);
	});


/***/ },
/* 3161 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var mergeWithKey = __webpack_require__(693);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the values
	 * associated with the key in each object, with the result being used as the
	 * value associated with the key in the returned object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
	 * @example
	 *
	 *      R.mergeWith(R.concat,
	 *                  { a: true, values: [10, 20] },
	 *                  { b: true, values: [15, 35] });
	 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
	 */
	module.exports = _curry3(function mergeWith(fn, l, r) {
	  return mergeWithKey(function(_, _l, _r) {
	    return fn(_l, _r);
	  }, l, r);
	});


/***/ },
/* 3162 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns the smaller of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.minBy, R.max
	 * @example
	 *
	 *      R.min(789, 123); //=> 123
	 *      R.min('a', 'b'); //=> 'a'
	 */
	module.exports = _curry2(function min(a, b) { return b < a ? b : a; });


/***/ },
/* 3163 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * smaller result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.min, R.maxBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.minBy(square, -3, 2); //=> 2
	 *
	 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
	 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
	 */
	module.exports = _curry3(function minBy(f, a, b) {
	  return f(b) < f(a) ? b : a;
	});


/***/ },
/* 3164 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Divides the first parameter by the second and returns the remainder. Note
	 * that this function preserves the JavaScript-style behavior for modulo. For
	 * mathematical modulo see [`mathMod`](#mathMod).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The value to the divide.
	 * @param {Number} b The pseudo-modulus
	 * @return {Number} The result of `b % a`.
	 * @see R.mathMod
	 * @example
	 *
	 *      R.modulo(17, 3); //=> 2
	 *      // JS behavior:
	 *      R.modulo(-17, 3); //=> -2
	 *      R.modulo(17, -3); //=> 2
	 *
	 *      var isOdd = R.modulo(R.__, 2);
	 *      isOdd(42); //=> 0
	 *      isOdd(21); //=> 1
	 */
	module.exports = _curry2(function modulo(a, b) { return a % b; });


/***/ },
/* 3165 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Negates its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number}
	 * @example
	 *
	 *      R.negate(42); //=> -42
	 */
	module.exports = _curry1(function negate(n) { return -n; });


/***/ },
/* 3166 */
/***/ function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(1449);
	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xany = __webpack_require__(1455);
	var any = __webpack_require__(1432);
	
	
	/**
	 * Returns `true` if no elements of the list match the predicate, `false`
	 * otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
	 * @see R.all, R.any
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
	 *      R.none(isEven, [1, 3, 5, 7, 8, 11]); //=> false
	 */
	module.exports = _curry2(_complement(_dispatchable(['any'], _xany, any)));


/***/ },
/* 3167 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var curryN = __webpack_require__(80);
	var nth = __webpack_require__(310);
	
	
	/**
	 * Returns a function which returns its nth argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig Number -> *... -> *
	 * @param {Number} n
	 * @return {Function}
	 * @example
	 *
	 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
	 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
	 * @symb R.nthArg(-1)(a, b, c) = c
	 * @symb R.nthArg(0)(a, b, c) = a
	 * @symb R.nthArg(1)(a, b, c) = b
	 */
	module.exports = _curry1(function nthArg(n) {
	  var arity = n < 0 ? 1 : n + 1;
	  return curryN(arity, function() {
	    return nth(n, arguments);
	  });
	});


/***/ },
/* 3168 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * `o` is a curried composition function that returns a unary function.
	 * Like [`compose`](#compose), `o` performs right-to-left function composition.
	 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
	 * invoked with only one argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Function
	 * @sig (b -> c) -> (a -> b) -> a -> c
	 * @param {Function} f
	 * @param {Function} g
	 * @return {Function}
	 * @see R.compose, R.pipe
	 * @example
	 *
	 *      var classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + lastName
	 *      var yellGreeting = R.o(R.toUpper, classyGreeting);
	 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
	 *
	 * @symb R.o(f, g, x) = f(g(x))
	 */
	module.exports = _curry3(function o(f, g, x) {
	  return f(g(x));
	});


/***/ },
/* 3169 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _of = __webpack_require__(3110);
	
	
	/**
	 * Returns a singleton array containing the value provided.
	 *
	 * Note this `of` is different from the ES6 `of`; See
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> [a]
	 * @param {*} x any value
	 * @return {Array} An array wrapping `x`.
	 * @example
	 *
	 *      R.of(null); //=> [null]
	 *      R.of([42]); //=> [[42]]
	 */
	module.exports = _curry1(_of);


/***/ },
/* 3170 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(211);
	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns a partial copy of an object omitting the keys specified.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [String] -> {String: *} -> {String: *}
	 * @param {Array} names an array of String property names to omit from the new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with properties from `names` not on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
	 */
	module.exports = _curry2(function omit(names, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (!_contains(prop, names)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ },
/* 3171 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(135);
	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Accepts a function `fn` and returns a function that guards invocation of
	 * `fn` such that `fn` can only ever be called once, no matter how many times
	 * the returned function is invoked. The first value calculated is returned in
	 * subsequent invocations.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a... -> b) -> (a... -> b)
	 * @param {Function} fn The function to wrap in a call-only-once wrapper.
	 * @return {Function} The wrapped function.
	 * @example
	 *
	 *      var addOneOnce = R.once(x => x + 1);
	 *      addOneOnce(10); //=> 11
	 *      addOneOnce(addOneOnce(50)); //=> 11
	 */
	module.exports = _curry1(function once(fn) {
	  var called = false;
	  var result;
	  return _arity(fn.length, function() {
	    if (called) {
	      return result;
	    }
	    called = true;
	    result = fn.apply(this, arguments);
	    return result;
	  });
	});


/***/ },
/* 3172 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category List
	 * @sig a -> b -> (a,b)
	 * @param {*} fst
	 * @param {*} snd
	 * @return {Array}
	 * @see R.objOf, R.of
	 * @example
	 *
	 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
	 */
	module.exports = _curry2(function pair(fst, snd) { return [fst, snd]; });


/***/ },
/* 3173 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(124);
	var _createPartialApplicator = __webpack_require__(1450);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided initially followed by the arguments provided to `g`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partialRight
	 * @example
	 *
	 *      var multiply2 = (a, b) => a * b;
	 *      var double = R.partial(multiply2, [2]);
	 *      double(2); //=> 4
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var sayHello = R.partial(greet, ['Hello']);
	 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
	 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
	 */
	module.exports = _createPartialApplicator(_concat);


/***/ },
/* 3174 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(124);
	var _createPartialApplicator = __webpack_require__(1450);
	var flip = __webpack_require__(429);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided to `g` followed by the arguments provided initially.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partial
	 * @example
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
	 *
	 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
	 */
	module.exports = _createPartialApplicator(flip(_concat));


/***/ },
/* 3175 */
/***/ function(module, exports, __webpack_require__) {

	var filter = __webpack_require__(685);
	var juxt = __webpack_require__(1460);
	var reject = __webpack_require__(441);
	
	
	/**
	 * Takes a predicate and a list or other `Filterable` object and returns the
	 * pair of filterable objects of the same type of elements which do and do not
	 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
	 * that has a filter method such as `Array`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
	 * @param {Function} pred A predicate to determine which side the element belongs to.
	 * @param {Array} filterable the list (or other filterable) to partition.
	 * @return {Array} An array, containing first the subset of elements that satisfy the
	 *         predicate, and second the subset of elements that do not satisfy.
	 * @see R.filter, R.reject
	 * @example
	 *
	 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
	 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
	 *
	 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
	 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
	 */
	module.exports = juxt([filter, reject]);


/***/ },
/* 3176 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var equals = __webpack_require__(111);
	var path = __webpack_require__(311);
	
	
	/**
	 * Determines whether a nested path on an object has a specific value, in
	 * [`R.equals`](#equals) terms. Most likely used to filter a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Relation
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> Boolean
	 * @param {Array} path The path of the nested property to use
	 * @param {*} val The value to compare the nested property with
	 * @param {Object} obj The object to check the nested property in
	 * @return {Boolean} `true` if the value equals the nested object property,
	 *         `false` otherwise.
	 * @example
	 *
	 *      var user1 = { address: { zipCode: 90210 } };
	 *      var user2 = { address: { zipCode: 55555 } };
	 *      var user3 = { name: 'Bob' };
	 *      var users = [ user1, user2, user3 ];
	 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
	 *      R.filter(isFamous, users); //=> [ user1 ]
	 */
	module.exports = _curry3(function pathEq(_path, val, obj) {
	  return equals(path(_path, obj), val);
	});


/***/ },
/* 3177 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var defaultTo = __webpack_require__(1439);
	var path = __webpack_require__(311);
	
	
	/**
	 * If the given, non-null object has a value at the given path, returns the
	 * value at that path. Otherwise returns the provided default value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig a -> [Idx] -> {a} -> a
	 * @param {*} d The default value.
	 * @param {Array} p The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path` of the supplied object or the default value.
	 * @example
	 *
	 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
	 */
	module.exports = _curry3(function pathOr(d, p, obj) {
	  return defaultTo(d, path(p, obj));
	});


/***/ },
/* 3178 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var path = __webpack_require__(311);
	
	
	/**
	 * Returns `true` if the specified object property at given path satisfies the
	 * given predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Logic
	 * @typedefn Idx = String | Int
	 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
	 * @param {Function} pred
	 * @param {Array} propPath
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propSatisfies, R.path
	 * @example
	 *
	 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
	 */
	module.exports = _curry3(function pathSatisfies(pred, propPath, obj) {
	  return propPath.length > 0 && pred(path(propPath, obj));
	});


/***/ },
/* 3179 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys specified. If
	 * the key does not exist, the property is ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.omit, R.props
	 * @example
	 *
	 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
	 */
	module.exports = _curry2(function pick(names, obj) {
	  var result = {};
	  var idx = 0;
	  while (idx < names.length) {
	    if (names[idx] in obj) {
	      result[names[idx]] = obj[names[idx]];
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 3180 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys that satisfy
	 * the supplied predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
	 * @param {Function} pred A predicate to determine whether or not a key
	 *        should be included on the output object.
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties that satisfy `pred`
	 *         on it.
	 * @see R.pick, R.filter
	 * @example
	 *
	 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
	 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
	 */
	module.exports = _curry2(function pickBy(test, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (test(obj[prop], prop, obj)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ },
/* 3181 */
/***/ function(module, exports, __webpack_require__) {

	var composeK = __webpack_require__(1436);
	var reverse = __webpack_require__(442);
	
	/**
	 * Returns the left-to-right Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(R.chain(f), R.chain(g), R.chain(h))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
	 * @param {...Function}
	 * @return {Function}
	 * @see R.composeK
	 * @example
	 *
	 *      //  parseJson :: String -> Maybe *
	 *      //  get :: String -> Object -> Maybe *
	 *
	 *      //  getStateCode :: Maybe String -> Maybe String
	 *      var getStateCode = R.pipeK(
	 *        parseJson,
	 *        get('user'),
	 *        get('address'),
	 *        get('state'),
	 *        R.compose(Maybe.of, R.toUpper)
	 *      );
	 *
	 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
	 *      //=> Just('NY')
	 *      getStateCode('[Invalid JSON]');
	 *      //=> Nothing()
	 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
	 */
	module.exports = function pipeK() {
	  if (arguments.length === 0) {
	    throw new Error('pipeK requires at least one argument');
	  }
	  return composeK.apply(this, reverse(arguments));
	};


/***/ },
/* 3182 */
/***/ function(module, exports, __webpack_require__) {

	var multiply = __webpack_require__(1466);
	var reduce = __webpack_require__(137);
	
	
	/**
	 * Multiplies together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The product of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.product([2,4,6,8,100,1]); //=> 38400
	 */
	module.exports = reduce(multiply, 1);


/***/ },
/* 3183 */
/***/ function(module, exports, __webpack_require__) {

	var _map = __webpack_require__(435);
	var identity = __webpack_require__(686);
	var pickAll = __webpack_require__(1471);
	var useWith = __webpack_require__(1482);
	
	
	/**
	 * Reasonable analog to SQL `select` statement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @category Relation
	 * @sig [k] -> [{k: v}] -> [{k: v}]
	 * @param {Array} props The property names to project
	 * @param {Array} objs The objects to query
	 * @return {Array} An array of objects with just the `props` properties.
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
	 *      var kids = [abby, fred];
	 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
	 */
	module.exports = useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity


/***/ },
/* 3184 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var equals = __webpack_require__(111);
	
	
	/**
	 * Returns `true` if the specified object property is equal, in
	 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig String -> a -> Object -> Boolean
	 * @param {String} name
	 * @param {*} val
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.equals, R.propSatisfies
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
	 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
	 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
	 *      var kids = [abby, fred, rusty, alois];
	 *      var hasBrownHair = R.propEq('hair', 'brown');
	 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
	 */
	module.exports = _curry3(function propEq(name, val, obj) {
	  return equals(val, obj[name]);
	});


/***/ },
/* 3185 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var is = __webpack_require__(1458);
	
	
	/**
	 * Returns `true` if the specified object property is of the given type;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Type
	 * @sig Type -> String -> Object -> Boolean
	 * @param {Function} type
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.is, R.propSatisfies
	 * @example
	 *
	 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
	 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
	 *      R.propIs(Number, 'x', {});            //=> false
	 */
	module.exports = _curry3(function propIs(type, name, obj) {
	  return is(type, obj[name]);
	});


/***/ },
/* 3186 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var _has = __webpack_require__(90);
	
	
	/**
	 * If the given, non-null object has an own property with the specified name,
	 * returns the value of that property. Otherwise returns the provided default
	 * value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Object
	 * @sig a -> String -> Object -> a
	 * @param {*} val The default value.
	 * @param {String} p The name of the property to return.
	 * @param {Object} obj The object to query.
	 * @return {*} The value of given property of the supplied object or the default value.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var favorite = R.prop('favoriteLibrary');
	 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
	 *
	 *      favorite(alice);  //=> undefined
	 *      favoriteWithDefault(alice);  //=> 'Ramda'
	 */
	module.exports = _curry3(function propOr(val, p, obj) {
	  return (obj != null && _has(p, obj)) ? obj[p] : val;
	});


/***/ },
/* 3187 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Returns `true` if the specified object property satisfies the given
	 * predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Logic
	 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
	 * @param {Function} pred
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propEq, R.propIs
	 * @example
	 *
	 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
	 */
	module.exports = _curry3(function propSatisfies(pred, name, obj) {
	  return pred(obj[name]);
	});


/***/ },
/* 3188 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> [v]
	 * @param {Array} ps The property names to fetch
	 * @param {Object} obj The object to query
	 * @return {Array} The corresponding values or partially applied function.
	 * @example
	 *
	 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
	 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
	 *
	 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
	 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
	 */
	module.exports = _curry2(function props(ps, obj) {
	  var len = ps.length;
	  var out = [];
	  var idx = 0;
	
	  while (idx < len) {
	    out[idx] = obj[ps[idx]];
	    idx += 1;
	  }
	
	  return out;
	});


/***/ },
/* 3189 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _isNumber = __webpack_require__(1453);
	
	
	/**
	 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> Number -> [Number]
	 * @param {Number} from The first number in the list.
	 * @param {Number} to One more than the last number in the list.
	 * @return {Array} The list of numbers in tthe set `[a, b)`.
	 * @example
	 *
	 *      R.range(1, 5);    //=> [1, 2, 3, 4]
	 *      R.range(50, 53);  //=> [50, 51, 52]
	 */
	module.exports = _curry2(function range(from, to) {
	  if (!(_isNumber(from) && _isNumber(to))) {
	    throw new TypeError('Both arguments to range must be numbers');
	  }
	  var result = [];
	  var n = from;
	  while (n < to) {
	    result.push(n);
	    n += 1;
	  }
	  return result;
	});


/***/ },
/* 3190 */
/***/ function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(431);
	var _reduce = __webpack_require__(112);
	var _reduced = __webpack_require__(181);
	
	
	/**
	 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
	 * through the list, successively calling the iterator function. `reduceWhile`
	 * also takes a predicate that is evaluated before each step. If the predicate
	 * returns `false`, it "short-circuits" the iteration and returns the current
	 * value of the accumulator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.22.0
	 * @category List
	 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} pred The predicate. It is passed the accumulator and the
	 *        current element.
	 * @param {Function} fn The iterator function. Receives two values, the
	 *        accumulator and the current element.
	 * @param {*} a The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced
	 * @example
	 *
	 *      var isOdd = (acc, x) => x % 2 === 1;
	 *      var xs = [1, 3, 5, 60, 777, 800];
	 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
	 *
	 *      var ys = [2, 4, 6]
	 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
	 */
	module.exports = _curryN(4, [], function _reduceWhile(pred, fn, a, list) {
	  return _reduce(function(acc, x) {
	    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
	  }, a, list);
	});


/***/ },
/* 3191 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _reduced = __webpack_require__(181);
	
	/**
	 * Returns a value wrapped to indicate that it is the final value of the reduce
	 * and transduce functions. The returned value should be considered a black
	 * box: the internal structure is not guaranteed to be stable.
	 *
	 * Note: this optimization is unavailable to functions not explicitly listed
	 * above. For instance, it is not currently supported by
	 * [`reduceRight`](#reduceRight).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category List
	 * @sig a -> *
	 * @param {*} x The final value of the reduce.
	 * @return {*} The wrapped value.
	 * @see R.reduce, R.transduce
	 * @example
	 *
	 *     R.reduce(
	 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
	 *       [],
	 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
	 */
	
	module.exports = _curry1(_reduced);


/***/ },
/* 3192 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var always = __webpack_require__(253);
	var times = __webpack_require__(1480);
	
	
	/**
	 * Returns a fixed list of size `n` containing a specified identical value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig a -> n -> [a]
	 * @param {*} value The value to repeat.
	 * @param {Number} n The desired size of the output list.
	 * @return {Array} A new array containing `n` `value`s.
	 * @see R.times
	 * @example
	 *
	 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
	 *
	 *      var obj = {};
	 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
	 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
	 * @symb R.repeat(a, 0) = []
	 * @symb R.repeat(a, 1) = [a]
	 * @symb R.repeat(a, 2) = [a, a]
	 */
	module.exports = _curry2(function repeat(value, n) {
	  return times(always(value), n);
	});


/***/ },
/* 3193 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Replace a substring or regex match in a string with a replacement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category String
	 * @sig RegExp|String -> String -> String -> String
	 * @param {RegExp|String} pattern A regular expression or a substring to match.
	 * @param {String} replacement The string to replace the matches with.
	 * @param {String} str The String to do the search and replacement in.
	 * @return {String} The result.
	 * @example
	 *
	 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *
	 *      // Use the "g" (global) flag to replace all occurrences:
	 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
	 */
	module.exports = _curry3(function replace(regex, replacement, str) {
	  return str.replace(regex, replacement);
	});


/***/ },
/* 3194 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
	 * reduced values from the left
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a,b -> a) -> a -> [b] -> [a]
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} A list of all intermediately reduced values.
	 * @see R.reduce
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
	 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
	 */
	module.exports = _curry3(function scan(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [acc];
	  while (idx < len) {
	    acc = fn(acc, list[idx]);
	    result[idx + 1] = acc;
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 3195 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var always = __webpack_require__(253);
	var over = __webpack_require__(1470);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> a -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
	 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
	 */
	module.exports = _curry3(function set(lens, v, x) {
	  return over(lens, always(v), x);
	});


/***/ },
/* 3196 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns a copy of the list, sorted according to the comparator function,
	 * which should accept two values at a time and return a negative number if the
	 * first value is smaller, a positive number if it's larger, and zero if they
	 * are equal. Please note that this is a **copy** of the list. It does not
	 * modify the original.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,a -> Number) -> [a] -> [a]
	 * @param {Function} comparator A sorting function :: a -> b -> Int
	 * @param {Array} list The list to sort
	 * @return {Array} a new array with its elements sorted by the comparator function.
	 * @example
	 *
	 *      var diff = function(a, b) { return a - b; };
	 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
	 */
	module.exports = _curry2(function sort(comparator, list) {
	  return Array.prototype.slice.call(list, 0).sort(comparator);
	});


/***/ },
/* 3197 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Sorts the list according to the supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> [a] -> [a]
	 * @param {Function} fn
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted by the keys generated by `fn`.
	 * @example
	 *
	 *      var sortByFirstItem = R.sortBy(R.prop(0));
	 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
	 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
	 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var bob = {
	 *        name: 'Bob',
	 *        age: -10
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 314.159
	 *      };
	 *      var people = [clara, bob, alice];
	 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
	 */
	module.exports = _curry2(function sortBy(fn, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var aa = fn(a);
	    var bb = fn(b);
	    return aa < bb ? -1 : aa > bb ? 1 : 0;
	  });
	});


/***/ },
/* 3198 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Sorts a list according to a list of comparators.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Relation
	 * @sig [a -> a -> Number] -> [a] -> [a]
	 * @param {Array} functions A list of comparator functions.
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted according to the comarator functions.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'alice',
	 *        age: 40
	 *      };
	 *      var bob = {
	 *        name: 'bob',
	 *        age: 30
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 40
	 *      };
	 *      var people = [clara, bob, alice];
	 *      var ageNameSort = R.sortWith([
	 *        R.descend(R.prop('age')),
	 *        R.ascend(R.prop('name'))
	 *      ]);
	 *      ageNameSort(people); //=> [alice, clara, bob]
	 */
	module.exports = _curry2(function sortWith(fns, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var result = 0;
	    var i = 0;
	    while (result === 0 && i < fns.length) {
	      result = fns[i](a, b);
	      i += 1;
	    }
	    return result;
	  });
	});


/***/ },
/* 3199 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(309);
	
	
	/**
	 * Splits a string into an array of strings based on the given
	 * separator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig (String | RegExp) -> String -> [String]
	 * @param {String|RegExp} sep The pattern.
	 * @param {String} str The string to separate into an array.
	 * @return {Array} The array of strings from `str` separated by `str`.
	 * @see R.join
	 * @example
	 *
	 *      var pathComponents = R.split('/');
	 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
	 *
	 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
	 */
	module.exports = invoker(1, 'split');


/***/ },
/* 3200 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var length = __webpack_require__(1462);
	var slice = __webpack_require__(212);
	
	
	/**
	 * Splits a given list or string at a given index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig Number -> [a] -> [[a], [a]]
	 * @sig Number -> String -> [String, String]
	 * @param {Number} index The index where the array/string is split.
	 * @param {Array|String} array The array/string to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
	 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
	 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
	 */
	module.exports = _curry2(function splitAt(index, array) {
	  return [slice(0, index, array), slice(index, length(array), array)];
	});


/***/ },
/* 3201 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var slice = __webpack_require__(212);
	
	
	/**
	 * Splits a collection into slices of the specified length.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @sig Number -> String -> [String]
	 * @param {Number} n
	 * @param {Array} list
	 * @return {Array}
	 * @example
	 *
	 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
	 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
	 */
	module.exports = _curry2(function splitEvery(n, list) {
	  if (n <= 0) {
	    throw new Error('First argument to splitEvery must be a positive integer');
	  }
	  var result = [];
	  var idx = 0;
	  while (idx < list.length) {
	    result.push(slice(idx, idx += n, list));
	  }
	  return result;
	});


/***/ },
/* 3202 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Takes a list and a predicate and returns a pair of lists with the following properties:
	 *
	 *  - the result of concatenating the two output lists is equivalent to the input list;
	 *  - none of the elements of the first output list satisfies the predicate; and
	 *  - if the second output list is non-empty, its first element satisfies the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
	 * @param {Function} pred The predicate that determines where the array is split.
	 * @param {Array} list The array to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
	 */
	module.exports = _curry2(function splitWhen(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var prefix = [];
	
	  while (idx < len && !pred(list[idx])) {
	    prefix.push(list[idx]);
	    idx += 1;
	  }
	
	  return [prefix, Array.prototype.slice.call(list, idx)];
	});


/***/ },
/* 3203 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var equals = __webpack_require__(111);
	var take = __webpack_require__(696);
	
	/**
	 * Checks if a list starts with the provided values
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category List
	 * @sig [a] -> Boolean
	 * @sig String -> Boolean
	 * @param {*} prefix
	 * @param {*} list
	 * @return {Boolean}
	 * @example
	 *
	 *      R.startsWith('a', 'abc')                //=> true
	 *      R.startsWith('b', 'abc')                //=> false
	 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
	 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
	 */
	module.exports = _curry2(function(prefix, list) {
	  return equals(take(prefix.length, list), prefix);
	});


/***/ },
/* 3204 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Subtracts its second argument from its first argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a - b`.
	 * @see R.add
	 * @example
	 *
	 *      R.subtract(10, 8); //=> 2
	 *
	 *      var minus5 = R.subtract(R.__, 5);
	 *      minus5(17); //=> 12
	 *
	 *      var complementaryAngle = R.subtract(90);
	 *      complementaryAngle(30); //=> 60
	 *      complementaryAngle(72); //=> 18
	 */
	module.exports = _curry2(function subtract(a, b) {
	  return Number(a) - Number(b);
	});


/***/ },
/* 3205 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var concat = __webpack_require__(684);
	var difference = __webpack_require__(1440);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
	 * @example
	 *
	 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
	 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
	 */
	module.exports = _curry2(function symmetricDifference(list1, list2) {
	  return concat(difference(list1, list2), difference(list2, list1));
	});


/***/ },
/* 3206 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var concat = __webpack_require__(684);
	var differenceWith = __webpack_require__(1441);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both. Duplication is determined according to the value
	 * returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifference, R.difference, R.differenceWith
	 * @example
	 *
	 *      var eqA = R.eqBy(R.prop('a'));
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
	 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
	 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
	 */
	module.exports = _curry3(function symmetricDifferenceWith(pred, list1, list2) {
	  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
	});


/***/ },
/* 3207 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns a new list containing the last `n` elements of a given list, passing
	 * each value to the supplied predicate function, and terminating when the
	 * predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropLastWhile, R.addIndex
	 * @example
	 *
	 *      var isNotOne = x => x !== 1;
	 *
	 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
	 */
	module.exports = _curry2(function takeLastWhile(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && fn(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, idx + 1);
	});


/***/ },
/* 3208 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var _dispatchable = __webpack_require__(65);
	var _xtakeWhile = __webpack_require__(3132);
	
	
	/**
	 * Returns a new list containing the first `n` elements of a given list,
	 * passing each value to the supplied predicate function, and terminating when
	 * the predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * Dispatches to the `takeWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isNotFour = x => x !== 4;
	 *
	 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
	 */
	module.exports = _curry2(_dispatchable(['takeWhile'], _xtakeWhile, function takeWhile(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && fn(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx);
	}));


/***/ },
/* 3209 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Runs the given function with the supplied object, then returns the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> *) -> a -> a
	 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
	 * @param {*} x
	 * @return {*} `x`.
	 * @example
	 *
	 *      var sayX = x => console.log('x is ' + x);
	 *      R.tap(sayX, 100); //=> 100
	 *      // logs 'x is 100'
	 * @symb R.tap(f, a) = a
	 */
	module.exports = _curry2(function tap(fn, x) {
	  fn(x);
	  return x;
	});


/***/ },
/* 3210 */
/***/ function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(1448);
	var _curry2 = __webpack_require__(13);
	var _isRegExp = __webpack_require__(3108);
	var toString = __webpack_require__(313);
	
	
	/**
	 * Determines whether a given string matches a given regular expression.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category String
	 * @sig RegExp -> String -> Boolean
	 * @param {RegExp} pattern
	 * @param {String} str
	 * @return {Boolean}
	 * @see R.match
	 * @example
	 *
	 *      R.test(/^x/, 'xyz'); //=> true
	 *      R.test(/^y/, 'xyz'); //=> false
	 */
	module.exports = _curry2(function test(pattern, str) {
	  if (!_isRegExp(pattern)) {
	    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
	  }
	  return _cloneRegExp(pattern).test(str);
	});


/***/ },
/* 3211 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(309);
	
	
	/**
	 * The lower case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to lower case.
	 * @return {String} The lower case version of `str`.
	 * @see R.toUpper
	 * @example
	 *
	 *      R.toLower('XYZ'); //=> 'xyz'
	 */
	module.exports = invoker(0, 'toLowerCase');


/***/ },
/* 3212 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var _has = __webpack_require__(90);
	
	
	/**
	 * Converts an object into an array of key, value arrays. Only the object's
	 * own properties are used.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own properties.
	 * @see R.fromPairs
	 * @example
	 *
	 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	 */
	module.exports = _curry1(function toPairs(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    if (_has(prop, obj)) {
	      pairs[pairs.length] = [prop, obj[prop]];
	    }
	  }
	  return pairs;
	});


/***/ },
/* 3213 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Converts an object into an array of key, value arrays. The object's own
	 * properties and prototype properties are used. Note that the order of the
	 * output array is not guaranteed to be consistent across different JS
	 * platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own
	 *         and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
	 */
	module.exports = _curry1(function toPairsIn(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    pairs[pairs.length] = [prop, obj[prop]];
	  }
	  return pairs;
	});


/***/ },
/* 3214 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(309);
	
	
	/**
	 * The upper case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to upper case.
	 * @return {String} The upper case version of `str`.
	 * @see R.toLower
	 * @example
	 *
	 *      R.toUpper('abc'); //=> 'ABC'
	 */
	module.exports = invoker(0, 'toUpperCase');


/***/ },
/* 3215 */
/***/ function(module, exports, __webpack_require__) {

	var _reduce = __webpack_require__(112);
	var _xwrap = __webpack_require__(1457);
	var curryN = __webpack_require__(80);
	
	
	/**
	 * Initializes a transducer using supplied iterator function. Returns a single
	 * item by iterating through the list, successively calling the transformed
	 * iterator function and passing it an accumulator value and the current value
	 * from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It will be
	 * wrapped as a transformer to initialize the transducer. A transformer can be
	 * passed directly in place of an iterator function. In both cases, iteration
	 * may be stopped early with the [`R.reduced`](#reduced) function.
	 *
	 * A transducer is a function that accepts a transformer and returns a
	 * transformer and can be composed directly.
	 *
	 * A transformer is an an object that provides a 2-arity reducing iterator
	 * function, step, 0-arity initial value function, init, and 1-arity result
	 * extraction function, result. The step function is used as the iterator
	 * function in reduce. The result function is used to convert the final
	 * accumulator into the return type and in most cases is
	 * [`R.identity`](#identity). The init function can be used to provide an
	 * initial accumulator, but is ignored by transduce.
	 *
	 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array. Wrapped as transformer, if necessary, and used to
	 *        initialize the transducer
	 * @param {*} acc The initial accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced, R.into
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
	 *
	 *      var isOdd = (x) => x % 2 === 1;
	 *      var firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
	 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
	 */
	module.exports = curryN(4, function transduce(xf, fn, acc, list) {
	  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
	});


/***/ },
/* 3216 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Transposes the rows and columns of a 2D list.
	 * When passed a list of `n` lists of length `x`,
	 * returns a list of `x` lists of length `n`.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [[a]] -> [[a]]
	 * @param {Array} list A 2D list
	 * @return {Array} A 2D list
	 * @example
	 *
	 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
	 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 *
	 *      // If some of the rows are shorter than the following rows, their elements are skipped:
	 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
	 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
	 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
	 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
	 */
	module.exports = _curry1(function transpose(outerlist) {
	  var i = 0;
	  var result = [];
	  while (i < outerlist.length) {
	    var innerlist = outerlist[i];
	    var j = 0;
	    while (j < innerlist.length) {
	      if (typeof result[j] === 'undefined') {
	        result[j] = [];
	      }
	      result[j].push(innerlist[j]);
	      j += 1;
	    }
	    i += 1;
	  }
	  return result;
	});


/***/ },
/* 3217 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	var map = __webpack_require__(99);
	var sequence = __webpack_require__(1477);
	
	
	/**
	 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
	 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
	 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
	 * into an Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
	 * @param {Function} of
	 * @param {Function} f
	 * @param {*} traversable
	 * @return {*}
	 * @see R.sequence
	 * @example
	 *
	 *      // Returns `Nothing` if the given divisor is `0`
	 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
	 *
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
	 */
	module.exports = _curry3(function traverse(of, f, traversable) {
	  return typeof traversable['fantasy-land/traverse'] === 'function' ?
	    traversable['fantasy-land/traverse'](f, of) :
	    sequence(of, map(f, traversable));
	});


/***/ },
/* 3218 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Removes (strips) whitespace from both ends of the string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to trim.
	 * @return {String} Trimmed version of `str`.
	 * @example
	 *
	 *      R.trim('   xyz  '); //=> 'xyz'
	 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
	 */
	module.exports = (function() {
	  var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	           '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' +
	           '\u2029\uFEFF';
	  var zeroWidth = '\u200b';
	  var hasProtoTrim = (typeof String.prototype.trim === 'function');
	  if (!hasProtoTrim || (ws.trim() || !zeroWidth.trim())) {
	    return _curry1(function trim(str) {
	      var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
	      var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
	      return str.replace(beginRx, '').replace(endRx, '');
	    });
	  } else {
	    return _curry1(function trim(str) {
	      return str.trim();
	    });
	  }
	}());


/***/ },
/* 3219 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(135);
	var _concat = __webpack_require__(124);
	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
	 * function evaluates the `tryer`; if it does not throw, it simply returns the
	 * result. If the `tryer` *does* throw, the returned function evaluates the
	 * `catcher` function and returns its result. Note that for effective
	 * composition with this function, both the `tryer` and `catcher` functions
	 * must return the same type of results.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
	 * @param {Function} tryer The function that may throw.
	 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
	 * @return {Function} A new function that will catch exceptions and send then to the catcher.
	 * @example
	 *
	 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
	 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
	 */
	module.exports = _curry2(function _tryCatch(tryer, catcher) {
	  return _arity(tryer.length, function() {
	    try {
	      return tryer.apply(this, arguments);
	    } catch (e) {
	      return catcher.apply(this, _concat([e], arguments));
	    }
	  });
	});


/***/ },
/* 3220 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Takes a function `fn`, which takes a single array argument, and returns a
	 * function which:
	 *
	 *   - takes any number of positional arguments;
	 *   - passes these arguments to `fn` as an array; and
	 *   - returns the result.
	 *
	 * In other words, `R.unapply` derives a variadic function from a function which
	 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Function
	 * @sig ([*...] -> a) -> (*... -> a)
	 * @param {Function} fn
	 * @return {Function}
	 * @see R.apply
	 * @example
	 *
	 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
	 * @symb R.unapply(f)(a, b) = f([a, b])
	 */
	module.exports = _curry1(function unapply(fn) {
	  return function() {
	    return fn(Array.prototype.slice.call(arguments, 0));
	  };
	});


/***/ },
/* 3221 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	var nAry = __webpack_require__(439);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 1 parameter. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> b) -> (a -> b)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 1.
	 * @see R.binary, R.nAry
	 * @example
	 *
	 *      var takesTwoArgs = function(a, b) {
	 *        return [a, b];
	 *      };
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.unary(takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only 1 argument is passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.unary(f)(a, b, c) = f(a)
	 */
	module.exports = _curry1(function unary(fn) {
	  return nAry(1, fn);
	});


/***/ },
/* 3222 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var curryN = __webpack_require__(80);
	
	
	/**
	 * Returns a function of arity `n` from a (manually) curried function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Function
	 * @sig Number -> (a -> b) -> (a -> c)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to uncurry.
	 * @return {Function} A new function.
	 * @see R.curry
	 * @example
	 *
	 *      var addFour = a => b => c => d => a + b + c + d;
	 *
	 *      var uncurriedAddFour = R.uncurryN(4, addFour);
	 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
	 */
	module.exports = _curry2(function uncurryN(depth, fn) {
	  return curryN(depth, function() {
	    var currentDepth = 1;
	    var value = fn;
	    var idx = 0;
	    var endIdx;
	    while (currentDepth <= depth && typeof value === 'function') {
	      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
	      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
	      currentDepth += 1;
	      idx = endIdx;
	    }
	    return value;
	  });
	});


/***/ },
/* 3223 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Builds a list from a seed value. Accepts an iterator function, which returns
	 * either false to stop iteration or an array of length 2 containing the value
	 * to add to the resulting list and the seed to be used in the next call to the
	 * iterator function.
	 *
	 * The iterator function receives one argument: *(seed)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a -> [b]) -> * -> [b]
	 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
	 *        either false to quit iteration or an array of length two to proceed. The element
	 *        at index 0 of this array will be added to the resulting array, and the element
	 *        at index 1 will be passed to the next call to `fn`.
	 * @param {*} seed The seed value.
	 * @return {Array} The final list.
	 * @example
	 *
	 *      var f = n => n > 50 ? false : [-n, n + 10];
	 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
	 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
	 */
	module.exports = _curry2(function unfold(fn, seed) {
	  var pair = fn(seed);
	  var result = [];
	  while (pair && pair.length) {
	    result[result.length] = pair[0];
	    pair = fn(pair[1]);
	  }
	  return result;
	});


/***/ },
/* 3224 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(124);
	var _curry2 = __webpack_require__(13);
	var compose = __webpack_require__(683);
	var uniq = __webpack_require__(698);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @example
	 *
	 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(compose(uniq, _concat));


/***/ },
/* 3225 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(124);
	var _curry3 = __webpack_require__(35);
	var uniqWith = __webpack_require__(699);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list. Duplication is determined according to the value returned by
	 * applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @see R.union
	 * @example
	 *
	 *      var l1 = [{a: 1}, {a: 2}];
	 *      var l2 = [{a: 1}, {a: 4}];
	 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
	 */
	module.exports = _curry3(function unionWith(pred, list1, list2) {
	  return uniqWith(pred, _concat(list1, list2));
	});


/***/ },
/* 3226 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is not satisfied, the function will return the result of
	 * calling the `whenFalseFn` function with the same argument. If the predicate
	 * is satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred        A predicate function
	 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
	 *                               to a falsy value.
	 * @param {*}        x           An object to test with the `pred` function and
	 *                               pass to `whenFalseFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
	 * @see R.ifElse, R.when
	 * @example
	 *
	 *      let safeInc = R.unless(R.isNil, R.inc);
	 *      safeInc(null); //=> null
	 *      safeInc(1); //=> 2
	 */
	module.exports = _curry3(function unless(pred, whenFalseFn, x) {
	  return pred(x) ? x : whenFalseFn(x);
	});


/***/ },
/* 3227 */
/***/ function(module, exports, __webpack_require__) {

	var _identity = __webpack_require__(689);
	var chain = __webpack_require__(682);
	
	
	/**
	 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
	 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain c => c (c a) -> c a
	 * @param {*} list
	 * @return {*}
	 * @see R.flatten, R.chain
	 * @example
	 *
	 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
	 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
	 */
	module.exports = chain(_identity);


/***/ },
/* 3228 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Takes a predicate, a transformation function, and an initial value,
	 * and returns a value of the same type as the initial value.
	 * It does so by applying the transformation until the predicate is satisfied,
	 * at which point it returns the satisfactory value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred A predicate function
	 * @param {Function} fn The iterator function
	 * @param {*} init Initial value
	 * @return {*} Final value that satisfies predicate
	 * @example
	 *
	 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
	 */
	module.exports = _curry3(function until(pred, fn, init) {
	  var val = init;
	  while (!pred(val)) {
	    val = fn(val);
	  }
	  return val;
	});


/***/ },
/* 3229 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(29);
	
	
	/**
	 * Returns a list of all the properties, including prototype properties, of the
	 * supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own and prototype properties.
	 * @see R.values, R.keysIn
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.valuesIn(f); //=> ['X', 'Y']
	 */
	module.exports = _curry1(function valuesIn(obj) {
	  var prop;
	  var vs = [];
	  for (prop in obj) {
	    vs[vs.length] = obj[prop];
	  }
	  return vs;
	});


/***/ },
/* 3230 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Returns a "view" of the given data structure, determined by the given lens.
	 * The lens's focus determines which portion of the data structure is visible.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> s -> a
	 * @param {Lens} lens
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});  //=> 1
	 *      R.view(xLens, {x: 4, y: 2});  //=> 4
	 */
	module.exports = (function() {
	  // `Const` is a functor that effectively ignores the function given to `map`.
	  var Const = function(x) {
	    return {value: x, 'fantasy-land/map': function() { return this; }};
	  };
	
	  return _curry2(function view(lens, x) {
	    // Using `Const` effectively ignores the setter function of the `lens`,
	    // leaving the value returned by the getter function unmodified.
	    return lens(Const)(x).value;
	  });
	}());


/***/ },
/* 3231 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is satisfied, the function will return the result of calling
	 * the `whenTrueFn` function with the same argument. If the predicate is not
	 * satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred       A predicate function
	 * @param {Function} whenTrueFn A function to invoke when the `condition`
	 *                              evaluates to a truthy value.
	 * @param {*}        x          An object to test with the `pred` function and
	 *                              pass to `whenTrueFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
	 * @see R.ifElse, R.unless
	 * @example
	 *
	 *      // truncate :: String -> String
	 *      var truncate = R.when(
	 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
	 *        R.pipe(R.take(10), R.append('…'), R.join(''))
	 *      );
	 *      truncate('12345');         //=> '12345'
	 *      truncate('0123456789ABC'); //=> '0123456789…'
	 */
	module.exports = _curry3(function when(pred, whenTrueFn, x) {
	  return pred(x) ? whenTrueFn(x) : x;
	});


/***/ },
/* 3232 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	var equals = __webpack_require__(111);
	var map = __webpack_require__(99);
	var where = __webpack_require__(1484);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec, false otherwise. An object satisfies the spec if, for each of the
	 * spec's own properties, accessing that property of the object gives the same
	 * value (in [`R.equals`](#equals) terms) as accessing that property of the
	 * spec.
	 *
	 * `whereEq` is a specialization of [`where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @sig {String: *} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @see R.where
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.whereEq({a: 1, b: 2});
	 *
	 *      pred({a: 1});              //=> false
	 *      pred({a: 1, b: 2});        //=> true
	 *      pred({a: 1, b: 2, c: 3});  //=> true
	 *      pred({a: 1, b: 1});        //=> false
	 */
	module.exports = _curry2(function whereEq(spec, testObj) {
	  return where(map(equals, spec), testObj);
	});


/***/ },
/* 3233 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(211);
	var _curry2 = __webpack_require__(13);
	var flip = __webpack_require__(429);
	var reject = __webpack_require__(441);
	
	
	/**
	 * Returns a new list without values in the first argument.
	 * [`R.equals`](#equals) is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @param {Array} list1 The values to be removed from `list2`.
	 * @param {Array} list2 The array to remove values from.
	 * @return {Array} The new array without values in `list1`.
	 * @see R.transduce, R.difference
	 * @example
	 *
	 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
	 */
	module.exports = _curry2(function(xs, list) {
	  return reject(flip(_contains)(xs), list);
	});


/***/ },
/* 3234 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Creates a new list out of the two supplied by creating each possible pair
	 * from the lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The list made by combining each possible pair from
	 *         `as` and `bs` into pairs (`[a, b]`).
	 * @example
	 *
	 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
	 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
	 */
	module.exports = _curry2(function xprod(a, b) { // = xprodWith(prepend); (takes about 3 times as long...)
	  var idx = 0;
	  var ilen = a.length;
	  var j;
	  var jlen = b.length;
	  var result = [];
	  while (idx < ilen) {
	    j = 0;
	    while (j < jlen) {
	      result[result.length] = [a[idx], b[j]];
	      j += 1;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 3235 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Creates a new list out of the two supplied by pairing up equally-positioned
	 * items from both lists. The returned list is truncated to the length of the
	 * shorter of the two input lists.
	 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
	 * @example
	 *
	 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
	 */
	module.exports = _curry2(function zip(a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = [a[idx], b[idx]];
	    idx += 1;
	  }
	  return rv;
	});


/***/ },
/* 3236 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(13);
	
	
	/**
	 * Creates a new object out of a list of keys and a list of values.
	 * Key/value pairing is truncated to the length of the shorter of the two lists.
	 * Note: `zipObj` is equivalent to `pipe(zipWith(pair), fromPairs)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [String] -> [*] -> {String: *}
	 * @param {Array} keys The array that will be properties on the output object.
	 * @param {Array} values The list of values on the output object.
	 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
	 * @example
	 *
	 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry2(function zipObj(keys, values) {
	  var idx = 0;
	  var len = Math.min(keys.length, values.length);
	  var out = {};
	  while (idx < len) {
	    out[keys[idx]] = values[idx];
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 3237 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(35);
	
	
	/**
	 * Creates a new list out of the two supplied by applying the function to each
	 * equally-positioned pair in the lists. The returned list is truncated to the
	 * length of the shorter of the two input lists.
	 *
	 * @function
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,b -> c) -> [a] -> [b] -> [c]
	 * @param {Function} fn The function used to combine the two elements into one value.
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
	 *         using `fn`.
	 * @example
	 *
	 *      var f = (x, y) => {
	 *        // ...
	 *      };
	 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
	 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
	 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
	 */
	module.exports = _curry3(function zipWith(fn, a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = fn(a[idx], b[idx]);
	    idx += 1;
	  }
	  return rv;
	});


/***/ },
/* 3238 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// randomColor by David Merfield under the CC0 license
	// https://github.com/davidmerfield/randomColor/
	
	;(function(root, factory) {
	
	  // Support CommonJS
	  if (true) {
	    var randomColor = factory();
	
	    // Support NodeJS & Component, which allow module.exports to be a function
	    if (typeof module === 'object' && module && module.exports) {
	      exports = module.exports = randomColor;
	    }
	
	    // Support CommonJS 1.1.1 spec
	    exports.randomColor = randomColor;
	
	  // Support AMD
	  } else if (typeof define === 'function' && define.amd) {
	    define([], factory);
	
	  // Support vanilla script loading
	  } else {
	    root.randomColor = factory();
	  }
	
	}(this, function() {
	
	  // Seed to get repeatable colors
	  var seed = null;
	
	  // Shared color dictionary
	  var colorDictionary = {};
	
	  // Populate the color dictionary
	  loadColorBounds();
	
	  // check if a range is taken
	  var colorRanges = [];
	
	  var randomColor = function (options) {
	
	    options = options || {};
	
	    // Check if there is a seed and ensure it's an
	    // integer. Otherwise, reset the seed value.
	    if (options.seed !== undefined && options.seed !== null && options.seed === parseInt(options.seed, 10)) {
	      seed = options.seed;
	
	    // A string was passed as a seed
	    } else if (typeof options.seed === 'string') {
	      seed = stringToInteger(options.seed);
	
	    // Something was passed as a seed but it wasn't an integer or string
	    } else if (options.seed !== undefined && options.seed !== null) {
	      throw new TypeError('The seed value must be an integer or string');
	
	    // No seed, reset the value outside.
	    } else {
	      seed = null;
	    }
	
	    var H,S,B;
	
	    // Check if we need to generate multiple colors
	    if (options.count !== null && options.count !== undefined) {
	
	      var totalColors = options.count,
	          colors = [];
	      // Value false at index i means the range i is not taken yet.
	      for (var i = 0; i < options.count; i++) {
	        colorRanges.push(false)
	        }
	      options.count = null;
	
	      while (totalColors > colors.length) {
	
	        // Since we're generating multiple colors,
	        // incremement the seed. Otherwise we'd just
	        // generate the same color each time...
	        if (seed && options.seed) options.seed += 1;
	
	        colors.push(randomColor(options));
	      }
	
	      options.count = totalColors;
	
	      return colors;
	    }
	
	    // First we pick a hue (H)
	    H = pickHue(options);
	
	    // Then use H to determine saturation (S)
	    S = pickSaturation(H, options);
	
	    // Then use S and H to determine brightness (B).
	    B = pickBrightness(H, S, options);
	
	    // Then we return the HSB color in the desired format
	    return setFormat([H,S,B], options);
	  };
	
	  function pickHue(options) {
	    if (colorRanges.length > 0) {
	      var hueRange = getRealHueRange(options.hue)
	
	      var hue = randomWithin(hueRange)
	
	      //Each of colorRanges.length ranges has a length equal approximatelly one step
	      var step = (hueRange[1] - hueRange[0]) / colorRanges.length
	
	      var j = parseInt((hue - hueRange[0]) / step)
	
	      //Check if the range j is taken
	      if (colorRanges[j] === true) {
	        j = (j + 2) % colorRanges.length
	      }
	      else {
	        colorRanges[j] = true
	           }
	
	      var min = (hueRange[0] + j * step) % 359,
	          max = (hueRange[0] + (j + 1) * step) % 359;
	
	      hueRange = [min, max]
	
	      hue = randomWithin(hueRange)
	
	      if (hue < 0) {hue = 360 + hue;}
	      return hue
	    }
	    else {
	      var hueRange = getHueRange(options.hue)
	
	      hue = randomWithin(hueRange);
	      // Instead of storing red as two seperate ranges,
	      // we group them, using negative numbers
	      if (hue < 0) {
	        hue = 360 + hue;
	      }
	
	      return hue;
	    }
	  }
	
	  function pickSaturation (hue, options) {
	
	    if (options.hue === 'monochrome') {
	      return 0;
	    }
	
	    if (options.luminosity === 'random') {
	      return randomWithin([0,100]);
	    }
	
	    var saturationRange = getSaturationRange(hue);
	
	    var sMin = saturationRange[0],
	        sMax = saturationRange[1];
	
	    switch (options.luminosity) {
	
	      case 'bright':
	        sMin = 55;
	        break;
	
	      case 'dark':
	        sMin = sMax - 10;
	        break;
	
	      case 'light':
	        sMax = 55;
	        break;
	   }
	
	    return randomWithin([sMin, sMax]);
	
	  }
	
	  function pickBrightness (H, S, options) {
	
	    var bMin = getMinimumBrightness(H, S),
	        bMax = 100;
	
	    switch (options.luminosity) {
	
	      case 'dark':
	        bMax = bMin + 20;
	        break;
	
	      case 'light':
	        bMin = (bMax + bMin)/2;
	        break;
	
	      case 'random':
	        bMin = 0;
	        bMax = 100;
	        break;
	    }
	
	    return randomWithin([bMin, bMax]);
	  }
	
	  function setFormat (hsv, options) {
	
	    switch (options.format) {
	
	      case 'hsvArray':
	        return hsv;
	
	      case 'hslArray':
	        return HSVtoHSL(hsv);
	
	      case 'hsl':
	        var hsl = HSVtoHSL(hsv);
	        return 'hsl('+hsl[0]+', '+hsl[1]+'%, '+hsl[2]+'%)';
	
	      case 'hsla':
	        var hslColor = HSVtoHSL(hsv);
	        var alpha = options.alpha || Math.random();
	        return 'hsla('+hslColor[0]+', '+hslColor[1]+'%, '+hslColor[2]+'%, ' + alpha + ')';
	
	      case 'rgbArray':
	        return HSVtoRGB(hsv);
	
	      case 'rgb':
	        var rgb = HSVtoRGB(hsv);
	        return 'rgb(' + rgb.join(', ') + ')';
	
	      case 'rgba':
	        var rgbColor = HSVtoRGB(hsv);
	        var alpha = options.alpha || Math.random();
	        return 'rgba(' + rgbColor.join(', ') + ', ' + alpha + ')';
	
	      default:
	        return HSVtoHex(hsv);
	    }
	
	  }
	
	  function getMinimumBrightness(H, S) {
	
	    var lowerBounds = getColorInfo(H).lowerBounds;
	
	    for (var i = 0; i < lowerBounds.length - 1; i++) {
	
	      var s1 = lowerBounds[i][0],
	          v1 = lowerBounds[i][1];
	
	      var s2 = lowerBounds[i+1][0],
	          v2 = lowerBounds[i+1][1];
	
	      if (S >= s1 && S <= s2) {
	
	         var m = (v2 - v1)/(s2 - s1),
	             b = v1 - m*s1;
	
	         return m*S + b;
	      }
	
	    }
	
	    return 0;
	  }
	
	  function getHueRange (colorInput) {
	
	    if (typeof parseInt(colorInput) === 'number') {
	
	      var number = parseInt(colorInput);
	
	      if (number < 360 && number > 0) {
	        return [number, number];
	      }
	
	    }
	
	    if (typeof colorInput === 'string') {
	
	      if (colorDictionary[colorInput]) {
	        var color = colorDictionary[colorInput];
	        if (color.hueRange) {return color.hueRange;}
	      } else if (colorInput.match(/^#?([0-9A-F]{3}|[0-9A-F]{6})$/i)) {
	        var hue = HexToHSB(colorInput)[0];
	        return [ hue, hue ];
	      }
	    }
	
	    return [0,360];
	
	  }
	
	  function getSaturationRange (hue) {
	    return getColorInfo(hue).saturationRange;
	  }
	
	  function getColorInfo (hue) {
	
	    // Maps red colors to make picking hue easier
	    if (hue >= 334 && hue <= 360) {
	      hue-= 360;
	    }
	
	    for (var colorName in colorDictionary) {
	       var color = colorDictionary[colorName];
	       if (color.hueRange &&
	           hue >= color.hueRange[0] &&
	           hue <= color.hueRange[1]) {
	          return colorDictionary[colorName];
	       }
	    } return 'Color not found';
	  }
	
	  function randomWithin (range) {
	    if (seed === null) {
	      //generate random evenly destinct number from : https://martin.ankerl.com/2009/12/09/how-to-create-random-colors-programmatically/
	      var golden_ratio = 0.618033988749895
	      var r=Math.random()
	      r += golden_ratio
	      r %= 1
	      return Math.floor(range[0] + r*(range[1] + 1 - range[0]));
	    } else {
	      //Seeded random algorithm from http://indiegamr.com/generate-repeatable-random-numbers-in-js/
	      var max = range[1] || 1;
	      var min = range[0] || 0;
	      seed = (seed * 9301 + 49297) % 233280;
	      var rnd = seed / 233280.0;
	      return Math.floor(min + rnd * (max - min));
	}
	  }
	
	  function HSVtoHex (hsv){
	
	    var rgb = HSVtoRGB(hsv);
	
	    function componentToHex(c) {
	        var hex = c.toString(16);
	        return hex.length == 1 ? '0' + hex : hex;
	    }
	
	    var hex = '#' + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);
	
	    return hex;
	
	  }
	
	  function defineColor (name, hueRange, lowerBounds) {
	
	    var sMin = lowerBounds[0][0],
	        sMax = lowerBounds[lowerBounds.length - 1][0],
	
	        bMin = lowerBounds[lowerBounds.length - 1][1],
	        bMax = lowerBounds[0][1];
	
	    colorDictionary[name] = {
	      hueRange: hueRange,
	      lowerBounds: lowerBounds,
	      saturationRange: [sMin, sMax],
	      brightnessRange: [bMin, bMax]
	    };
	
	  }
	
	  function loadColorBounds () {
	
	    defineColor(
	      'monochrome',
	      null,
	      [[0,0],[100,0]]
	    );
	
	    defineColor(
	      'red',
	      [-26,18],
	      [[20,100],[30,92],[40,89],[50,85],[60,78],[70,70],[80,60],[90,55],[100,50]]
	    );
	
	    defineColor(
	      'orange',
	      [19,46],
	      [[20,100],[30,93],[40,88],[50,86],[60,85],[70,70],[100,70]]
	    );
	
	    defineColor(
	      'yellow',
	      [47,62],
	      [[25,100],[40,94],[50,89],[60,86],[70,84],[80,82],[90,80],[100,75]]
	    );
	
	    defineColor(
	      'green',
	      [63,178],
	      [[30,100],[40,90],[50,85],[60,81],[70,74],[80,64],[90,50],[100,40]]
	    );
	
	    defineColor(
	      'blue',
	      [179, 257],
	      [[20,100],[30,86],[40,80],[50,74],[60,60],[70,52],[80,44],[90,39],[100,35]]
	    );
	
	    defineColor(
	      'purple',
	      [258, 282],
	      [[20,100],[30,87],[40,79],[50,70],[60,65],[70,59],[80,52],[90,45],[100,42]]
	    );
	
	    defineColor(
	      'pink',
	      [283, 334],
	      [[20,100],[30,90],[40,86],[60,84],[80,80],[90,75],[100,73]]
	    );
	
	  }
	
	  function HSVtoRGB (hsv) {
	
	    // this doesn't work for the values of 0 and 360
	    // here's the hacky fix
	    var h = hsv[0];
	    if (h === 0) {h = 1;}
	    if (h === 360) {h = 359;}
	
	    // Rebase the h,s,v values
	    h = h/360;
	    var s = hsv[1]/100,
	        v = hsv[2]/100;
	
	    var h_i = Math.floor(h*6),
	      f = h * 6 - h_i,
	      p = v * (1 - s),
	      q = v * (1 - f*s),
	      t = v * (1 - (1 - f)*s),
	      r = 256,
	      g = 256,
	      b = 256;
	
	    switch(h_i) {
	      case 0: r = v; g = t; b = p;  break;
	      case 1: r = q; g = v; b = p;  break;
	      case 2: r = p; g = v; b = t;  break;
	      case 3: r = p; g = q; b = v;  break;
	      case 4: r = t; g = p; b = v;  break;
	      case 5: r = v; g = p; b = q;  break;
	    }
	
	    var result = [Math.floor(r*255), Math.floor(g*255), Math.floor(b*255)];
	    return result;
	  }
	
	  function HexToHSB (hex) {
	    hex = hex.replace(/^#/, '');
	    hex = hex.length === 3 ? hex.replace(/(.)/g, '$1$1') : hex;
	
	    var red = parseInt(hex.substr(0, 2), 16) / 255,
	          green = parseInt(hex.substr(2, 2), 16) / 255,
	          blue = parseInt(hex.substr(4, 2), 16) / 255;
	
	    var cMax = Math.max(red, green, blue),
	          delta = cMax - Math.min(red, green, blue),
	          saturation = cMax ? (delta / cMax) : 0;
	
	    switch (cMax) {
	      case red: return [ 60 * (((green - blue) / delta) % 6) || 0, saturation, cMax ];
	      case green: return [ 60 * (((blue - red) / delta) + 2) || 0, saturation, cMax ];
	      case blue: return [ 60 * (((red - green) / delta) + 4) || 0, saturation, cMax ];
	    }
	  }
	
	  function HSVtoHSL (hsv) {
	    var h = hsv[0],
	      s = hsv[1]/100,
	      v = hsv[2]/100,
	      k = (2-s)*v;
	
	    return [
	      h,
	      Math.round(s*v / (k<1 ? k : 2-k) * 10000) / 100,
	      k/2 * 100
	    ];
	  }
	
	  function stringToInteger (string) {
	    var total = 0
	    for (var i = 0; i !== string.length; i++) {
	      if (total >= Number.MAX_SAFE_INTEGER) break;
	      total += string.charCodeAt(i)
	    }
	    return total
	  }
	
	  // get The range of given hue when options.count!=0
	  function getRealHueRange(colorHue)
	  { if (!isNaN(colorHue)) {
	    var number = parseInt(colorHue);
	
	    if (number < 360 && number > 0) {
	      return getColorInfo(colorHue).hueRange
	    }
	  }
	    else if (typeof colorHue === 'string') {
	
	      if (colorDictionary[colorHue]) {
	        var color = colorDictionary[colorHue];
	
	        if (color.hueRange) {
	          return color.hueRange
	       }
	    } else if (colorHue.match(/^#?([0-9A-F]{3}|[0-9A-F]{6})$/i)) {
	        var hue = HexToHSB(colorHue)[0]
	        return getColorInfo(hue).hueRange
	    }
	  }
	
	    return [0,360]
	}
	  return randomColor;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)(module)))

/***/ },
/* 3239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FacebookSource = function FacebookSource(props) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, FacebookSource);
	    this.props = null;
	
	    this.isCompatible = function () {
	        return !!_this.props.facebookId;
	    };
	
	    this.get = function (setState) {
	        var _props = _this.props;
	        var size = _props.size;
	        var facebookId = _props.facebookId;
	
	        var url = 'https://graph.facebook.com/' + (facebookId + '/picture?width=' + size + '&height=' + size);
	
	        setState({ src: url });
	    };
	
	    this.props = props;
	};
	
	exports.default = FacebookSource;
	module.exports = exports['default'];

/***/ },
/* 3240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _utils = __webpack_require__(314);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoogleSource = function GoogleSource(props) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, GoogleSource);
	    this.props = null;
	
	    this.isCompatible = function () {
	        return !!_this.props.googleId;
	    };
	
	    this.get = function (setState) {
	        var _props = _this.props;
	        var size = _props.size;
	        var googleId = _props.googleId;
	
	        var url = 'https://picasaweb.google.com/data/entry/api/user/' + googleId + '?alt=json';
	
	        if ((0, _utils.hasSourceFailedBefore)(url)) {
	            setState(null);
	            return;
	        }
	
	        (0, _utils.fetch)(url, function (data) {
	            var src = data.entry.gphoto$thumbnail.$t;
	            var srcWithCorrectSize = src.replace('s64', 's' + size);
	            setState({
	                src: srcWithCorrectSize
	            });
	        }, function () {
	            // on error
	            (0, _utils.cacheFailingSource)(url);
	            setState(null);
	        });
	    };
	
	    this.props = props;
	};
	
	exports.default = GoogleSource;
	module.exports = exports['default'];

/***/ },
/* 3241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _isRetina = __webpack_require__(2940);
	
	var _isRetina2 = _interopRequireDefault(_isRetina);
	
	var _md = __webpack_require__(3015);
	
	var _md2 = _interopRequireDefault(_md);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IS_RETINA = (0, _isRetina2.default)();
	
	var GravatarSource = function GravatarSource(props) {
	    (0, _classCallCheck3.default)(this, GravatarSource);
	
	    _initialiseProps.call(this);
	
	    this.props = props;
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this = this;
	
	    this.props = null;
	
	    this.isCompatible = function () {
	        return !!_this.props.email || !!_this.props.md5Email;
	    };
	
	    this.get = function (setState) {
	        var props = _this.props;
	
	        var email = props.md5Email || (0, _md2.default)(props.email);
	        var size = IS_RETINA ? props.size * 2 : props.size;
	        var url = 'https://secure.gravatar.com/avatar/' + email + '?s=' + size + '&d=404';
	
	        setState({ src: url });
	    };
	};
	
	exports.default = GravatarSource;
	module.exports = exports['default'];

/***/ },
/* 3242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _utils = __webpack_require__(314);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconSource = function IconSource(props) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, IconSource);
	    this.props = null;
	    this.icon = '✷';
	
	    this.isCompatible = function () {
	        return true;
	    };
	
	    this.get = function (setState) {
	        setState({
	            value: _this.icon,
	            color: (0, _utils.getRandomColor)(_this.icon, _this.props.colors)
	        });
	    };
	
	    this.props = props;
	};
	
	exports.default = IconSource;
	module.exports = exports['default'];

/***/ },
/* 3243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SkypeSource = function SkypeSource(props) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, SkypeSource);
	    this.props = null;
	
	    this.isCompatible = function () {
	        return !!_this.props.skypeId;
	    };
	
	    this.get = function (setState) {
	        var skypeId = _this.props.skypeId;
	
	        var url = 'https://api.skype.com/users/' + skypeId + '/profile/avatar';
	
	        setState({ src: url });
	    };
	
	    this.props = props;
	};
	
	exports.default = SkypeSource;
	module.exports = exports['default'];

/***/ },
/* 3244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SrcSource = function SrcSource(props) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, SrcSource);
	    this.props = null;
	
	    this.isCompatible = function () {
	        return !!_this.props.src;
	    };
	
	    this.get = function (setState) {
	        setState({
	            src: _this.props.src
	        });
	    };
	
	    this.props = props;
	};
	
	exports.default = SrcSource;
	module.exports = exports['default'];

/***/ },
/* 3245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwitterSource = function () {
	    function TwitterSource(props) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, TwitterSource);
	        this.props = null;
	
	        this.isCompatible = function () {
	            return !!_this.props.twitterHandle;
	        };
	
	        this.get = function (setState) {
	            var twitterHandle = _this.props.twitterHandle;
	
	            var size = _this.getImageSize();
	
	            var url = 'https://twitter.com/' + twitterHandle + '/profile_image?size=' + size;
	
	            setState({ src: url });
	        };
	
	        this.props = props;
	    }
	
	    (0, _createClass3.default)(TwitterSource, [{
	        key: 'getImageSize',
	        value: function getImageSize() {
	            var size = this.props.size;
	
	
	            if (size <= 24) return 'mini';
	
	            if (size <= 48) return 'normal';
	
	            if (size <= 73) return 'bigger';
	
	            return 'original';
	        }
	    }]);
	    return TwitterSource;
	}();
	
	exports.default = TwitterSource;
	module.exports = exports['default'];

/***/ },
/* 3246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _utils = __webpack_require__(314);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ValueSource = function () {
	    function ValueSource(props) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, ValueSource);
	        this.props = null;
	
	        this.isCompatible = function () {
	            return !!_this.props.name || !!_this.props.value;
	        };
	
	        this.get = function (setState) {
	            var value = _this.getValue();
	            var state = value ? {
	                value: value,
	                color: _this.getColor(value)
	            } : null;
	            setState(state);
	        };
	
	        this.props = props;
	    }
	
	    (0, _createClass3.default)(ValueSource, [{
	        key: 'getInitials',
	        value: function getInitials() {
	            var name = this.props.name;
	            var parts = name.split(' ');
	            var initials = '';
	            for (var i = 0; i < parts.length; i++) {
	                initials += parts[i].substr(0, 1).toUpperCase();
	            }
	            return initials;
	        }
	    }, {
	        key: 'getValue',
	        value: function getValue() {
	            if (this.props.name) return this.getInitials();
	
	            if (this.props.value) return this.props.value;
	
	            return null;
	        }
	    }, {
	        key: 'getColor',
	        value: function getColor(value) {
	            var _props = this.props;
	            var color = _props.color;
	            var colors = _props.colors;
	
	            return color || (0, _utils.getRandomColor)(value, colors);
	        }
	    }]);
	    return ValueSource;
	}();
	
	exports.default = ValueSource;
	module.exports = exports['default'];

/***/ },
/* 3247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _utils = __webpack_require__(314);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoogleSource = function () {
	    function GoogleSource(props) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, GoogleSource);
	        this.props = null;
	
	        this.isCompatible = function () {
	            return !!_this.props.vkontakteId;
	        };
	
	        this.get = function (setState) {
	            var vkontakteId = _this.props.vkontakteId;
	
	            var size = _this.getImageSize();
	            var url = 'https://api.vk.com/method/users.get?user_id=' + vkontakteId + '&v=5.8&fields=' + size;
	
	            (0, _utils.fetchJSONP)(url, function (data) {
	                var src = data.response[0][size];
	                setState({
	                    src: src
	                });
	            }, function () {
	                // on error
	                setState(null);
	            });
	        };
	
	        this.props = props;
	    }
	
	    (0, _createClass3.default)(GoogleSource, [{
	        key: 'getImageSize',
	        value: function getImageSize() {
	            var size = this.props.size;
	
	
	            if (size <= 50) return 'photo_50';
	
	            if (size <= 100) return 'photo_100';
	
	            if (size <= 200) return 'photo_200';
	
	            return 'photo_max';
	        }
	    }]);
	    return GoogleSource;
	}();
	
	exports.default = GoogleSource;
	module.exports = exports['default'];

/***/ },
/* 3248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CopyToClipboard = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _copyToClipboard = _interopRequireDefault(__webpack_require__(2461));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CopyToClipboard =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(CopyToClipboard, _React$PureComponent);
	
	  function CopyToClipboard() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, CopyToClipboard);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CopyToClipboard)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
	      var _this$props = _this.props,
	          text = _this$props.text,
	          onCopy = _this$props.onCopy,
	          children = _this$props.children,
	          options = _this$props.options;
	
	      var elem = _react["default"].Children.only(children);
	
	      var result = (0, _copyToClipboard["default"])(text, options);
	
	      if (onCopy) {
	        onCopy(text, result);
	      } // Bypass onClick if it was present
	
	
	      if (elem && elem.props && typeof elem.props.onClick === 'function') {
	        elem.props.onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(CopyToClipboard, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          _text = _this$props2.text,
	          _onCopy = _this$props2.onCopy,
	          _options = _this$props2.options,
	          children = _this$props2.children,
	          props = _objectWithoutProperties(_this$props2, ["text", "onCopy", "options", "children"]);
	
	      var elem = _react["default"].Children.only(children);
	
	      return _react["default"].cloneElement(elem, _objectSpread({}, props, {
	        onClick: this.onClick
	      }));
	    }
	  }]);
	
	  return CopyToClipboard;
	}(_react["default"].PureComponent);
	
	exports.CopyToClipboard = CopyToClipboard;
	
	_defineProperty(CopyToClipboard, "defaultProps", {
	  onCopy: undefined,
	  options: undefined
	});

/***/ },
/* 3249 */
[4451, 1485, 1486],
/* 3250 */
[4452, 1485, 1486],
/* 3251 */
[4453, 3249, 3250],
/* 3252 */
[4448, 3254],
/* 3253 */
[4449, 3252],
/* 3254 */
2788,
/* 3255 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(10);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _reactPortal = __webpack_require__(15);
	
		var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
		var _isTouchDevice = __webpack_require__(14);
	
		var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
		var _getResponsiveContainerStyles = __webpack_require__(16);
	
		var _getResponsiveContainerStyles2 = _interopRequireDefault(_getResponsiveContainerStyles);
	
		var _isInclusivelyAfterDay = __webpack_require__(17);
	
		var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
		var _DateRangePickerInputController = __webpack_require__(18);
	
		var _DateRangePickerInputController2 = _interopRequireDefault(_DateRangePickerInputController);
	
		var _DayPickerRangeController = __webpack_require__(19);
	
		var _DayPickerRangeController2 = _interopRequireDefault(_DayPickerRangeController);
	
		var _close = __webpack_require__(20);
	
		var _close2 = _interopRequireDefault(_close);
	
		var _DateRangePickerShape = __webpack_require__(21);
	
		var _DateRangePickerShape2 = _interopRequireDefault(_DateRangePickerShape);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = _DateRangePickerShape2['default'];
	
		var defaultProps = {
		  startDateId: _constants.START_DATE,
		  endDateId: _constants.END_DATE,
		  focusedInput: null,
		  minimumNights: 1,
		  isDayBlocked: function () {
		    function isDayBlocked() {
		      return false;
		    }
	
		    return isDayBlocked;
		  }(),
		  isDayHighlighted: function () {
		    function isDayHighlighted() {
		      return false;
		    }
	
		    return isDayHighlighted;
		  }(),
		  isOutsideRange: function () {
		    function isOutsideRange(day) {
		      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
		    }
	
		    return isOutsideRange;
		  }(),
		  enableOutsideDays: false,
		  numberOfMonths: 2,
		  showClearDates: false,
		  disabled: false,
		  required: false,
		  reopenPickerOnClearDates: false,
		  keepOpenOnDateSelect: false,
		  initialVisibleMonth: function () {
		    function initialVisibleMonth() {
		      return (0, _moment2['default'])();
		    }
	
		    return initialVisibleMonth;
		  }(),
		  navPrev: null,
		  navNext: null,
	
		  orientation: _constants.HORIZONTAL_ORIENTATION,
		  anchorDirection: _constants.ANCHOR_LEFT,
		  horizontalMargin: 0,
		  withPortal: false,
		  withFullScreenPortal: false,
	
		  onDatesChange: function () {
		    function onDatesChange() {}
	
		    return onDatesChange;
		  }(),
		  onFocusChange: function () {
		    function onFocusChange() {}
	
		    return onFocusChange;
		  }(),
		  onPrevMonthClick: function () {
		    function onPrevMonthClick() {}
	
		    return onPrevMonthClick;
		  }(),
		  onNextMonthClick: function () {
		    function onNextMonthClick() {}
	
		    return onNextMonthClick;
		  }(),
	
		  // i18n
		  displayFormat: function () {
		    function displayFormat() {
		      return _moment2['default'].localeData().longDateFormat('L');
		    }
	
		    return displayFormat;
		  }(),
		  monthFormat: 'MMMM YYYY',
		  phrases: {
		    closeDatePicker: 'Close',
		    clearDates: 'Clear Dates'
		  }
		};
	
		var DateRangePicker = function (_React$Component) {
		  _inherits(DateRangePicker, _React$Component);
	
		  function DateRangePicker(props) {
		    _classCallCheck(this, DateRangePicker);
	
		    var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));
	
		    _this.state = {
		      dayPickerContainerStyles: {}
		    };
	
		    _this.isTouchDevice = (0, _isTouchDevice2['default'])();
	
		    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
	
		    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_this);
		    return _this;
		  }
	
		  _createClass(DateRangePicker, [{
		    key: 'componentDidMount',
		    value: function () {
		      function componentDidMount() {
		        window.addEventListener('resize', this.responsivizePickerPosition);
		        this.responsivizePickerPosition();
		      }
	
		      return componentDidMount;
		    }()
		  }, {
		    key: 'componentWillUnmount',
		    value: function () {
		      function componentWillUnmount() {
		        window.removeEventListener('resize', this.responsivizePickerPosition);
		      }
	
		      return componentWillUnmount;
		    }()
		  }, {
		    key: 'onOutsideClick',
		    value: function () {
		      function onOutsideClick() {
		        var _props = this.props;
		        var focusedInput = _props.focusedInput;
		        var onFocusChange = _props.onFocusChange;
	
		        if (!focusedInput) return;
	
		        onFocusChange(null);
		      }
	
		      return onOutsideClick;
		    }()
		  }, {
		    key: 'getDayPickerContainerClasses',
		    value: function () {
		      function getDayPickerContainerClasses() {
		        var _props2 = this.props;
		        var focusedInput = _props2.focusedInput;
		        var orientation = _props2.orientation;
		        var withPortal = _props2.withPortal;
		        var withFullScreenPortal = _props2.withFullScreenPortal;
		        var anchorDirection = _props2.anchorDirection;
	
		        var showDatepicker = focusedInput === _constants.START_DATE || focusedInput === _constants.END_DATE;
	
		        var dayPickerClassName = (0, _classnames2['default'])('DateRangePicker__picker', {
		          'DateRangePicker__picker--show': showDatepicker,
		          'DateRangePicker__picker--invisible': !showDatepicker,
		          'DateRangePicker__picker--direction-left': anchorDirection === _constants.ANCHOR_LEFT,
		          'DateRangePicker__picker--direction-right': anchorDirection === _constants.ANCHOR_RIGHT,
		          'DateRangePicker__picker--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
		          'DateRangePicker__picker--vertical': orientation === _constants.VERTICAL_ORIENTATION,
		          'DateRangePicker__picker--portal': withPortal || withFullScreenPortal,
		          'DateRangePicker__picker--full-screen-portal': withFullScreenPortal
		        });
	
		        return dayPickerClassName;
		      }
	
		      return getDayPickerContainerClasses;
		    }()
		  }, {
		    key: 'getDayPickerDOMNode',
		    value: function () {
		      function getDayPickerDOMNode() {
		        return _reactDom2['default'].findDOMNode(this.dayPicker);
		      }
	
		      return getDayPickerDOMNode;
		    }()
		  }, {
		    key: 'responsivizePickerPosition',
		    value: function () {
		      function responsivizePickerPosition() {
		        var _props3 = this.props;
		        var anchorDirection = _props3.anchorDirection;
		        var horizontalMargin = _props3.horizontalMargin;
		        var withPortal = _props3.withPortal;
		        var withFullScreenPortal = _props3.withFullScreenPortal;
		        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
	
		        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;
		        if (!withPortal && !withFullScreenPortal) {
		          var containerRect = this.dayPickerContainer.getBoundingClientRect();
		          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
		          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];
	
		          this.setState({
		            dayPickerContainerStyles: (0, _getResponsiveContainerStyles2['default'])(anchorDirection, currentOffset, containerEdge, horizontalMargin)
		          });
		        }
		      }
	
		      return responsivizePickerPosition;
		    }()
		  }, {
		    key: 'maybeRenderDayPickerWithPortal',
		    value: function () {
		      function maybeRenderDayPickerWithPortal() {
		        var _props4 = this.props;
		        var focusedInput = _props4.focusedInput;
		        var withPortal = _props4.withPortal;
		        var withFullScreenPortal = _props4.withFullScreenPortal;
	
		        if (withPortal || withFullScreenPortal) {
		          return _react2['default'].createElement(_reactPortal2['default'], { isOpened: focusedInput !== null }, this.renderDayPicker());
		        }
	
		        return this.renderDayPicker();
		      }
	
		      return maybeRenderDayPickerWithPortal;
		    }()
		  }, {
		    key: 'renderDayPicker',
		    value: function () {
		      function renderDayPicker() {
		        var _this2 = this;
	
		        var _props5 = this.props;
		        var isDayBlocked = _props5.isDayBlocked;
		        var isDayHighlighted = _props5.isDayHighlighted;
		        var isOutsideRange = _props5.isOutsideRange;
		        var numberOfMonths = _props5.numberOfMonths;
		        var orientation = _props5.orientation;
		        var monthFormat = _props5.monthFormat;
		        var navPrev = _props5.navPrev;
		        var navNext = _props5.navNext;
		        var onPrevMonthClick = _props5.onPrevMonthClick;
		        var onNextMonthClick = _props5.onNextMonthClick;
		        var onDatesChange = _props5.onDatesChange;
		        var onFocusChange = _props5.onFocusChange;
		        var withPortal = _props5.withPortal;
		        var withFullScreenPortal = _props5.withFullScreenPortal;
		        var enableOutsideDays = _props5.enableOutsideDays;
		        var initialVisibleMonth = _props5.initialVisibleMonth;
		        var focusedInput = _props5.focusedInput;
		        var startDate = _props5.startDate;
		        var endDate = _props5.endDate;
		        var minimumNights = _props5.minimumNights;
		        var keepOpenOnDateSelect = _props5.keepOpenOnDateSelect;
		        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
	
		        var onOutsideClick = !withFullScreenPortal ? this.onOutsideClick : undefined;
	
		        return _react2['default'].createElement('div', {
		          ref: function () {
		            function ref(_ref2) {
		              _this2.dayPickerContainer = _ref2;
		            }
	
		            return ref;
		          }(),
		          className: this.getDayPickerContainerClasses(),
		          style: dayPickerContainerStyles
		        }, _react2['default'].createElement(_DayPickerRangeController2['default'], {
		          ref: function () {
		            function ref(_ref) {
		              _this2.dayPicker = _ref;
		            }
	
		            return ref;
		          }(),
		          orientation: orientation,
		          enableOutsideDays: enableOutsideDays,
		          numberOfMonths: numberOfMonths,
		          onDayMouseEnter: this.onDayMouseEnter,
		          onDayMouseLeave: this.onDayMouseLeave,
		          onDayMouseDown: this.onDayClick,
		          onDayTouchTap: this.onDayClick,
		          onPrevMonthClick: onPrevMonthClick,
		          onNextMonthClick: onNextMonthClick,
		          onDatesChange: onDatesChange,
		          onFocusChange: onFocusChange,
		          focusedInput: focusedInput,
		          startDate: startDate,
		          endDate: endDate,
		          monthFormat: monthFormat,
		          withPortal: withPortal || withFullScreenPortal,
		          hidden: !focusedInput,
		          initialVisibleMonth: initialVisibleMonth,
		          onOutsideClick: onOutsideClick,
		          navPrev: navPrev,
		          navNext: navNext,
		          minimumNights: minimumNights,
		          isOutsideRange: isOutsideRange,
		          isDayHighlighted: isDayHighlighted,
		          isDayBlocked: isDayBlocked,
		          keepOpenOnDateSelect: keepOpenOnDateSelect
		        }), withFullScreenPortal && _react2['default'].createElement('button', {
		          className: 'DateRangePicker__close',
		          type: 'button',
		          onClick: this.onOutsideClick
		        }, _react2['default'].createElement('span', { className: 'screen-reader-only' }, this.props.phrases.closeDatePicker), _react2['default'].createElement(_close2['default'], null)));
		      }
	
		      return renderDayPicker;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _props6 = this.props;
		        var startDate = _props6.startDate;
		        var startDateId = _props6.startDateId;
		        var startDatePlaceholderText = _props6.startDatePlaceholderText;
		        var endDate = _props6.endDate;
		        var endDateId = _props6.endDateId;
		        var endDatePlaceholderText = _props6.endDatePlaceholderText;
		        var focusedInput = _props6.focusedInput;
		        var showClearDates = _props6.showClearDates;
		        var disabled = _props6.disabled;
		        var required = _props6.required;
		        var phrases = _props6.phrases;
		        var isOutsideRange = _props6.isOutsideRange;
		        var withPortal = _props6.withPortal;
		        var withFullScreenPortal = _props6.withFullScreenPortal;
		        var displayFormat = _props6.displayFormat;
		        var reopenPickerOnClearDates = _props6.reopenPickerOnClearDates;
		        var keepOpenOnDateSelect = _props6.keepOpenOnDateSelect;
		        var onDatesChange = _props6.onDatesChange;
		        var onFocusChange = _props6.onFocusChange;
	
		        return _react2['default'].createElement('div', { className: 'DateRangePicker' }, _react2['default'].createElement(_DateRangePickerInputController2['default'], {
		          startDate: startDate,
		          startDateId: startDateId,
		          startDatePlaceholderText: startDatePlaceholderText,
		          isStartDateFocused: focusedInput === _constants.START_DATE,
		          endDate: endDate,
		          endDateId: endDateId,
		          endDatePlaceholderText: endDatePlaceholderText,
		          isEndDateFocused: focusedInput === _constants.END_DATE,
		          displayFormat: displayFormat,
		          showClearDates: showClearDates,
		          showCaret: !withPortal && !withFullScreenPortal,
		          disabled: disabled,
		          required: required,
		          reopenPickerOnClearDates: reopenPickerOnClearDates,
		          keepOpenOnDateSelect: keepOpenOnDateSelect,
		          isOutsideRange: isOutsideRange,
		          withFullScreenPortal: withFullScreenPortal,
		          onDatesChange: onDatesChange,
		          onFocusChange: onFocusChange,
		          phrases: phrases
		        }), this.maybeRenderDayPickerWithPortal());
		      }
	
		      return render;
		    }()
		  }]);
	
		  return DateRangePicker;
		}(_react2['default'].Component);
	
		exports['default'] = DateRangePicker;
	
		DateRangePicker.propTypes = propTypes;
		DateRangePicker.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */,
	/* 3 */,
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(7);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(5);
	
	/***/ },
	/* 6 */,
	/* 7 */,
	/* 8 */,
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(81);
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(76);
	
	/***/ },
	/* 11 */,
	/* 12 */,
	/* 13 */,
	/* 14 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(703);
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1534);
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1500);
	
	/***/ },
	/* 17 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(317);
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1493);
	
	/***/ },
	/* 19 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1494);
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 12 12" }, this.props),
		          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	/* 21 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1497);
	
	/***/ }
	/******/ ]);

/***/ },
/* 3256 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports['default'] = DayPickerNavigation;
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _arrowLeft = __webpack_require__(31);
	
		var _arrowLeft2 = _interopRequireDefault(_arrowLeft);
	
		var _arrowRight = __webpack_require__(23);
	
		var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
		var _chevronUp = __webpack_require__(32);
	
		var _chevronUp2 = _interopRequireDefault(_chevronUp);
	
		var _chevronDown = __webpack_require__(33);
	
		var _chevronDown2 = _interopRequireDefault(_chevronDown);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		var propTypes = {
		  navPrev: _react.PropTypes.node,
		  navNext: _react.PropTypes.node,
		  isVertical: _react.PropTypes.bool,
	
		  onPrevMonthClick: _react.PropTypes.func,
		  onNextMonthClick: _react.PropTypes.func
		};
		var defaultProps = {
		  navPrev: null,
		  navNext: null,
		  isVertical: false,
	
		  onPrevMonthClick: function () {
		    function onPrevMonthClick() {}
	
		    return onPrevMonthClick;
		  }(),
		  onNextMonthClick: function () {
		    function onNextMonthClick() {}
	
		    return onNextMonthClick;
		  }()
		};
	
		function DayPickerNavigation(props) {
		  var navPrev = props.navPrev;
		  var navNext = props.navNext;
		  var isVertical = props.isVertical;
		  var onPrevMonthClick = props.onPrevMonthClick;
		  var onNextMonthClick = props.onNextMonthClick;
	
		  var navPrevIcon = navPrev;
		  var navNextIcon = navNext;
		  var isDefaultNavPrev = false;
		  var isDefaultNavNext = false;
		  if (!navPrevIcon) {
		    isDefaultNavPrev = true;
		    navPrevIcon = isVertical ? _react2['default'].createElement(_chevronUp2['default'], null) : _react2['default'].createElement(_arrowLeft2['default'], null);
		  }
		  if (!navNextIcon) {
		    isDefaultNavNext = true;
		    navNextIcon = isVertical ? _react2['default'].createElement(_chevronDown2['default'], null) : _react2['default'].createElement(_arrowRight2['default'], null);
		  }
	
		  var navClassNames = (0, _classnames2['default'])('DayPickerNavigation', {
		    'DayPickerNavigation--horizontal': !isVertical,
		    'DayPickerNavigation--vertical': isVertical
		  });
		  var prevClassNames = (0, _classnames2['default'])('DayPickerNavigation__prev', {
		    'DayPickerNavigation__prev--default': isDefaultNavPrev
		  });
		  var nextClassNames = (0, _classnames2['default'])('DayPickerNavigation__next', {
		    'DayPickerNavigation__next--default': isDefaultNavNext
		  });
	
		  return _react2['default'].createElement('div', { className: navClassNames }, _react2['default'].createElement('span', {
		    className: prevClassNames,
		    onClick: onPrevMonthClick
		  }, navPrevIcon), _react2['default'].createElement('span', {
		    className: nextClassNames,
		    onClick: onNextMonthClick
		  }, navNextIcon));
		}
	
		DayPickerNavigation.propTypes = propTypes;
		DayPickerNavigation.defaultProps = defaultProps;
	
	/***/ },
	
	/***/ 1:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	
	/***/ 5:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(5);
	
	/***/ },
	
	/***/ 23:
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 1000 1000" }, this.props),
		          _react2["default"].createElement("path", { d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	
	/***/ 31:
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 1000 1000" }, this.props),
		          _react2["default"].createElement("path", { d: "M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	
	/***/ 32:
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 1000 1000" }, this.props),
		          _react2["default"].createElement("path", { d: "M32.1 712.6l453.2-452.2c11-11 21-11 32 0l453.2 452.2c4 5 6 10 6 16 0 13-10 23-22 23-7 0-12-2-16-7L501.3 308.5 64.1 744.7c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32.1z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	
	/***/ 33:
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 1000 1000" }, this.props),
		          _react2["default"].createElement("path", { d: "M967.5 288.5L514.3 740.7c-11 11-21 11-32 0L29.1 288.5c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437.2 436.2 437.2-436.2c4-5 9-7 16-7 6 0 11 2 16 7 9 10.9 9 21 0 32z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ }
	
	/******/ });

/***/ },
/* 3257 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(10);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = {
		  children: _react.PropTypes.node,
		  onOutsideClick: _react.PropTypes.func
		};
	
		var defaultProps = {
		  children: _react2['default'].createElement('span', null),
		  onOutsideClick: function () {
		    function onOutsideClick() {}
	
		    return onOutsideClick;
		  }()
		};
	
		var OutsideClickHandler = function (_React$Component) {
		  _inherits(OutsideClickHandler, _React$Component);
	
		  function OutsideClickHandler(props) {
		    _classCallCheck(this, OutsideClickHandler);
	
		    var _this = _possibleConstructorReturn(this, (OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call(this, props));
	
		    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
		    return _this;
		  }
	
		  _createClass(OutsideClickHandler, [{
		    key: 'componentDidMount',
		    value: function () {
		      function componentDidMount() {
		        if (document.addEventListener) {
		          // `useCapture` flag is set to true so that a `stopPropagation` in the children will
		          // not prevent all outside click handlers from firing - maja
		          document.addEventListener('click', this.onOutsideClick, true);
		        } else {
		          document.attachEvent('onclick', this.onOutsideClick);
		        }
		      }
	
		      return componentDidMount;
		    }()
		  }, {
		    key: 'componentWillUnmount',
		    value: function () {
		      function componentWillUnmount() {
		        if (document.removeEventListener) {
		          document.removeEventListener('click', this.onOutsideClick, true);
		        } else {
		          document.detachEvent('onclick', this.onOutsideClick);
		        }
		      }
	
		      return componentWillUnmount;
		    }()
		  }, {
		    key: 'onOutsideClick',
		    value: function () {
		      function onOutsideClick(e) {
		        var isDescendantOfRoot = _reactDom2['default'].findDOMNode(this.refs.childNode).contains(e.target);
		        if (!isDescendantOfRoot) {
		          this.props.onOutsideClick(e);
		        }
		      }
	
		      return onOutsideClick;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        return _react2['default'].createElement('div', { ref: 'childNode' }, this.props.children);
		      }
	
		      return render;
		    }()
		  }]);
	
		  return OutsideClickHandler;
		}(_react2['default'].Component);
	
		exports['default'] = OutsideClickHandler;
	
		OutsideClickHandler.propTypes = propTypes;
		OutsideClickHandler.defaultProps = defaultProps;
	
	/***/ },
	
	/***/ 1:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	
	/***/ 10:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(76);
	
	/***/ }
	
	/******/ });

/***/ },
/* 3258 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _reactPortal = __webpack_require__(15);
	
		var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
		var _arrayIncludes = __webpack_require__(34);
	
		var _arrayIncludes2 = _interopRequireDefault(_arrayIncludes);
	
		var _toMomentObject = __webpack_require__(25);
	
		var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
		var _toLocalizedDateString = __webpack_require__(26);
	
		var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);
	
		var _getResponsiveContainerStyles = __webpack_require__(16);
	
		var _getResponsiveContainerStyles2 = _interopRequireDefault(_getResponsiveContainerStyles);
	
		var _SingleDatePickerInput = __webpack_require__(39);
	
		var _SingleDatePickerInput2 = _interopRequireDefault(_SingleDatePickerInput);
	
		var _DayPicker = __webpack_require__(38);
	
		var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
		var _close = __webpack_require__(20);
	
		var _close2 = _interopRequireDefault(_close);
	
		var _isInclusivelyAfterDay = __webpack_require__(17);
	
		var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
		var _isSameDay = __webpack_require__(36);
	
		var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
		var _SingleDatePickerShape = __webpack_require__(40);
	
		var _SingleDatePickerShape2 = _interopRequireDefault(_SingleDatePickerShape);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = _SingleDatePickerShape2['default'];
	
		var defaultProps = {
		  date: null,
		  focused: false,
		  disabled: false,
		  required: false,
		  showClearDate: false,
		  reopenPickerOnClearDate: false,
		  keepOpenOnDateSelect: false,
	
		  navPrev: null,
		  navNext: null,
	
		  onDateChange: function () {
		    function onDateChange() {}
	
		    return onDateChange;
		  }(),
		  onFocusChange: function () {
		    function onFocusChange() {}
	
		    return onFocusChange;
		  }(),
	
		  isDayBlocked: function () {
		    function isDayBlocked() {
		      return false;
		    }
	
		    return isDayBlocked;
		  }(),
		  isDayHighlighted: function () {
		    function isDayHighlighted() {
		      return false;
		    }
	
		    return isDayHighlighted;
		  }(),
		  disabledDays: [],
		  isOutsideRange: function () {
		    function isOutsideRange(day) {
		      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
		    }
	
		    return isOutsideRange;
		  }(),
		  enableOutsideDays: false,
		  numberOfMonths: 2,
		  orientation: _constants.HORIZONTAL_ORIENTATION,
		  anchorDirection: _constants.ANCHOR_LEFT,
		  horizontalMargin: 0,
		  withPortal: false,
		  withFullScreenPortal: false,
		  initialVisibleMonth: function () {
		    function initialVisibleMonth() {
		      return (0, _moment2['default'])();
		    }
	
		    return initialVisibleMonth;
		  }(),
	
		  onPrevMonthClick: function () {
		    function onPrevMonthClick() {}
	
		    return onPrevMonthClick;
		  }(),
		  onNextMonthClick: function () {
		    function onNextMonthClick() {}
	
		    return onNextMonthClick;
		  }(),
	
		  // i18n
		  displayFormat: function () {
		    function displayFormat() {
		      return _moment2['default'].localeData().longDateFormat('L');
		    }
	
		    return displayFormat;
		  }(),
		  monthFormat: 'MMMM YYYY',
		  phrases: {
		    closeDatePicker: 'Close',
		    clearDate: 'Clear Date'
		  }
		};
	
		var SingleDatePicker = function (_React$Component) {
		  _inherits(SingleDatePicker, _React$Component);
	
		  function SingleDatePicker(props) {
		    _classCallCheck(this, SingleDatePicker);
	
		    var _this = _possibleConstructorReturn(this, (SingleDatePicker.__proto__ || Object.getPrototypeOf(SingleDatePicker)).call(this, props));
	
		    _this.state = {
		      dayPickerContainerStyles: {},
		      hoverDate: null
		    };
	
		    _this.today = (0, _moment2['default'])();
	
		    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
		    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
		    _this.onDayClick = _this.onDayClick.bind(_this);
	
		    _this.onChange = _this.onChange.bind(_this);
		    _this.onFocus = _this.onFocus.bind(_this);
		    _this.onClearFocus = _this.onClearFocus.bind(_this);
		    _this.clearDate = _this.clearDate.bind(_this);
	
		    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_this);
		    return _this;
		  }
	
		  /* istanbul ignore next */
	
		  _createClass(SingleDatePicker, [{
		    key: 'componentDidMount',
		    value: function () {
		      function componentDidMount() {
		        window.addEventListener('resize', this.responsivizePickerPosition);
		        this.responsivizePickerPosition();
		      }
	
		      return componentDidMount;
		    }()
		  }, {
		    key: 'componentWillUpdate',
		    value: function () {
		      function componentWillUpdate() {
		        this.today = (0, _moment2['default'])();
		      }
	
		      return componentWillUpdate;
		    }()
	
		    /* istanbul ignore next */
	
		  }, {
		    key: 'componentWillUnmount',
		    value: function () {
		      function componentWillUnmount() {
		        window.removeEventListener('resize', this.responsivizePickerPosition);
		      }
	
		      return componentWillUnmount;
		    }()
		  }, {
		    key: 'onChange',
		    value: function () {
		      function onChange(dateString) {
		        var _props = this.props;
		        var isOutsideRange = _props.isOutsideRange;
		        var keepOpenOnDateSelect = _props.keepOpenOnDateSelect;
		        var onDateChange = _props.onDateChange;
		        var onFocusChange = _props.onFocusChange;
	
		        var date = (0, _toMomentObject2['default'])(dateString, this.getDisplayFormat());
	
		        var isValid = date && !isOutsideRange(date);
		        if (isValid) {
		          onDateChange(date);
		          if (!keepOpenOnDateSelect) onFocusChange({ focused: false });
		        } else {
		          onDateChange(null);
		        }
		      }
	
		      return onChange;
		    }()
		  }, {
		    key: 'onDayClick',
		    value: function () {
		      function onDayClick(day, modifiers, e) {
		        if (e) e.preventDefault();
		        if ((0, _arrayIncludes2['default'])(modifiers, 'blocked')) return;
	
		        this.props.onDateChange(day);
		        if (!this.props.keepOpenOnDateSelect) this.props.onFocusChange({ focused: null });
		      }
	
		      return onDayClick;
		    }()
		  }, {
		    key: 'onDayMouseEnter',
		    value: function () {
		      function onDayMouseEnter(day) {
		        this.setState({
		          hoverDate: day
		        });
		      }
	
		      return onDayMouseEnter;
		    }()
		  }, {
		    key: 'onDayMouseLeave',
		    value: function () {
		      function onDayMouseLeave() {
		        this.setState({
		          hoverDate: null
		        });
		      }
	
		      return onDayMouseLeave;
		    }()
		  }, {
		    key: 'onFocus',
		    value: function () {
		      function onFocus() {
		        if (!this.props.disabled) {
		          this.props.onFocusChange({ focused: true });
		        }
		      }
	
		      return onFocus;
		    }()
		  }, {
		    key: 'onClearFocus',
		    value: function () {
		      function onClearFocus() {
		        var _props2 = this.props;
		        var focused = _props2.focused;
		        var onFocusChange = _props2.onFocusChange;
	
		        if (!focused) return;
	
		        onFocusChange({ focused: false });
		      }
	
		      return onClearFocus;
		    }()
		  }, {
		    key: 'getDateString',
		    value: function () {
		      function getDateString(date) {
		        var displayFormat = this.getDisplayFormat();
		        if (date && displayFormat) {
		          return date && date.format(displayFormat);
		        }
		        return (0, _toLocalizedDateString2['default'])(date);
		      }
	
		      return getDateString;
		    }()
		  }, {
		    key: 'getDayPickerContainerClasses',
		    value: function () {
		      function getDayPickerContainerClasses() {
		        var _props3 = this.props;
		        var orientation = _props3.orientation;
		        var withPortal = _props3.withPortal;
		        var withFullScreenPortal = _props3.withFullScreenPortal;
		        var anchorDirection = _props3.anchorDirection;
		        var focused = _props3.focused;
		        var hoverDate = this.state.hoverDate;
	
		        var dayPickerClassName = (0, _classnames2['default'])('SingleDatePicker__picker', {
		          'SingleDatePicker__picker--show': focused,
		          'SingleDatePicker__picker--invisible': !focused,
		          'SingleDatePicker__picker--direction-left': anchorDirection === _constants.ANCHOR_LEFT,
		          'SingleDatePicker__picker--direction-right': anchorDirection === _constants.ANCHOR_RIGHT,
		          'SingleDatePicker__picker--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
		          'SingleDatePicker__picker--vertical': orientation === _constants.VERTICAL_ORIENTATION,
		          'SingleDatePicker__picker--portal': withPortal || withFullScreenPortal,
		          'SingleDatePicker__picker--full-screen-portal': withFullScreenPortal,
		          'SingleDatePicker__picker--valid-date-hovered': hoverDate && !this.isBlocked(hoverDate)
		        });
	
		        return dayPickerClassName;
		      }
	
		      return getDayPickerContainerClasses;
		    }()
		  }, {
		    key: 'getDisplayFormat',
		    value: function () {
		      function getDisplayFormat() {
		        var displayFormat = this.props.displayFormat;
	
		        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
		      }
	
		      return getDisplayFormat;
		    }()
		  }, {
		    key: 'clearDate',
		    value: function () {
		      function clearDate() {
		        var _props4 = this.props;
		        var onDateChange = _props4.onDateChange;
		        var reopenPickerOnClearDate = _props4.reopenPickerOnClearDate;
		        var onFocusChange = _props4.onFocusChange;
	
		        onDateChange(null);
		        if (reopenPickerOnClearDate) {
		          onFocusChange({ focused: true });
		        }
		      }
	
		      return clearDate;
		    }()
	
		    /* istanbul ignore next */
	
		  }, {
		    key: 'responsivizePickerPosition',
		    value: function () {
		      function responsivizePickerPosition() {
		        var _props5 = this.props;
		        var anchorDirection = _props5.anchorDirection;
		        var horizontalMargin = _props5.horizontalMargin;
		        var withPortal = _props5.withPortal;
		        var withFullScreenPortal = _props5.withFullScreenPortal;
		        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
	
		        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;
	
		        if (!withPortal && !withFullScreenPortal) {
		          var containerRect = this.dayPickerContainer.getBoundingClientRect();
		          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
		          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];
	
		          this.setState({
		            dayPickerContainerStyles: (0, _getResponsiveContainerStyles2['default'])(anchorDirection, currentOffset, containerEdge, horizontalMargin)
		          });
		        }
		      }
	
		      return responsivizePickerPosition;
		    }()
		  }, {
		    key: 'isBlocked',
		    value: function () {
		      function isBlocked(day) {
		        var _props6 = this.props;
		        var isDayBlocked = _props6.isDayBlocked;
		        var isOutsideRange = _props6.isOutsideRange;
	
		        return isDayBlocked(day) || isOutsideRange(day);
		      }
	
		      return isBlocked;
		    }()
		  }, {
		    key: 'isHovered',
		    value: function () {
		      function isHovered(day) {
		        return (0, _isSameDay2['default'])(day, this.state.hoverDate);
		      }
	
		      return isHovered;
		    }()
		  }, {
		    key: 'isSelected',
		    value: function () {
		      function isSelected(day) {
		        return (0, _isSameDay2['default'])(day, this.props.date);
		      }
	
		      return isSelected;
		    }()
		  }, {
		    key: 'isToday',
		    value: function () {
		      function isToday(day) {
		        return (0, _isSameDay2['default'])(day, this.today);
		      }
	
		      return isToday;
		    }()
		  }, {
		    key: 'maybeRenderDayPickerWithPortal',
		    value: function () {
		      function maybeRenderDayPickerWithPortal() {
		        var _props7 = this.props;
		        var focused = _props7.focused;
		        var withPortal = _props7.withPortal;
		        var withFullScreenPortal = _props7.withFullScreenPortal;
	
		        if (withPortal || withFullScreenPortal) {
		          return _react2['default'].createElement(_reactPortal2['default'], { isOpened: focused }, this.renderDayPicker());
		        }
	
		        return this.renderDayPicker();
		      }
	
		      return maybeRenderDayPickerWithPortal;
		    }()
		  }, {
		    key: 'renderDayPicker',
		    value: function () {
		      function renderDayPicker() {
		        var _this2 = this;
	
		        var _props8 = this.props;
		        var isDayBlocked = _props8.isDayBlocked;
		        var isDayHighlighted = _props8.isDayHighlighted;
		        var isOutsideRange = _props8.isOutsideRange;
		        var enableOutsideDays = _props8.enableOutsideDays;
		        var numberOfMonths = _props8.numberOfMonths;
		        var orientation = _props8.orientation;
		        var monthFormat = _props8.monthFormat;
		        var navPrev = _props8.navPrev;
		        var navNext = _props8.navNext;
		        var onPrevMonthClick = _props8.onPrevMonthClick;
		        var onNextMonthClick = _props8.onNextMonthClick;
		        var withPortal = _props8.withPortal;
		        var withFullScreenPortal = _props8.withFullScreenPortal;
		        var focused = _props8.focused;
		        var initialVisibleMonth = _props8.initialVisibleMonth;
		        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
	
		        var modifiers = {
		          today: function () {
		            function today(day) {
		              return _this2.isToday(day);
		            }
	
		            return today;
		          }(),
		          blocked: function () {
		            function blocked(day) {
		              return _this2.isBlocked(day);
		            }
	
		            return blocked;
		          }(),
		          'blocked-calendar': function () {
		            function blockedCalendar(day) {
		              return isDayBlocked(day);
		            }
	
		            return blockedCalendar;
		          }(),
		          'blocked-out-of-range': function () {
		            function blockedOutOfRange(day) {
		              return isOutsideRange(day);
		            }
	
		            return blockedOutOfRange;
		          }(),
		          'highlighted-calendar': function () {
		            function highlightedCalendar(day) {
		              return isDayHighlighted(day);
		            }
	
		            return highlightedCalendar;
		          }(),
		          valid: function () {
		            function valid(day) {
		              return !_this2.isBlocked(day);
		            }
	
		            return valid;
		          }(),
		          hovered: function () {
		            function hovered(day) {
		              return _this2.isHovered(day);
		            }
	
		            return hovered;
		          }(),
		          selected: function () {
		            function selected(day) {
		              return _this2.isSelected(day);
		            }
	
		            return selected;
		          }()
		        };
	
		        var onOutsideClick = !withFullScreenPortal ? this.onClearFocus : undefined;
	
		        return _react2['default'].createElement('div', {
		          ref: function () {
		            function ref(_ref) {
		              _this2.dayPickerContainer = _ref;
		            }
	
		            return ref;
		          }(),
		          className: this.getDayPickerContainerClasses(),
		          style: dayPickerContainerStyles
		        }, _react2['default'].createElement(_DayPicker2['default'], {
		          orientation: orientation,
		          enableOutsideDays: enableOutsideDays,
		          modifiers: modifiers,
		          numberOfMonths: numberOfMonths,
		          onDayMouseEnter: this.onDayMouseEnter,
		          onDayMouseLeave: this.onDayMouseLeave,
		          onDayMouseDown: this.onDayClick,
		          onDayTouchTap: this.onDayClick,
		          onPrevMonthClick: onPrevMonthClick,
		          onNextMonthClick: onNextMonthClick,
		          monthFormat: monthFormat,
		          withPortal: withPortal || withFullScreenPortal,
		          hidden: !focused,
		          initialVisibleMonth: initialVisibleMonth,
		          onOutsideClick: onOutsideClick,
		          navPrev: navPrev,
		          navNext: navNext
		        }), withFullScreenPortal && _react2['default'].createElement('button', {
		          className: 'SingleDatePicker__close',
		          type: 'button',
		          onClick: this.onClearFocus
		        }, _react2['default'].createElement('span', { className: 'screen-reader-only' }, this.props.phrases.closeDatePicker), _react2['default'].createElement(_close2['default'], null)));
		      }
	
		      return renderDayPicker;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _props9 = this.props;
		        var id = _props9.id;
		        var placeholder = _props9.placeholder;
		        var focused = _props9.focused;
		        var disabled = _props9.disabled;
		        var required = _props9.required;
		        var showClearDate = _props9.showClearDate;
		        var date = _props9.date;
		        var phrases = _props9.phrases;
		        var withPortal = _props9.withPortal;
		        var withFullScreenPortal = _props9.withFullScreenPortal;
	
		        var dateString = this.getDateString(date);
	
		        return _react2['default'].createElement('div', { className: 'SingleDatePicker' }, _react2['default'].createElement(_SingleDatePickerInput2['default'], {
		          id: id,
		          placeholder: placeholder,
		          focused: focused,
		          disabled: disabled,
		          required: required,
		          showCaret: !withPortal && !withFullScreenPortal,
		          phrases: phrases,
		          onClearDate: this.clearDate,
		          showClearDate: showClearDate,
		          dateValue: dateString,
		          onChange: this.onChange,
		          onFocus: this.onFocus,
		          onKeyDownShiftTab: this.onClearFocus,
		          onKeyDownTab: this.onClearFocus,
		          border: true
		        }), this.maybeRenderDayPickerWithPortal());
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SingleDatePicker;
		}(_react2['default'].Component);
	
		exports['default'] = SingleDatePicker;
	
		SingleDatePicker.propTypes = propTypes;
		SingleDatePicker.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */,
	/* 3 */,
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(7);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(5);
	
	/***/ },
	/* 6 */,
	/* 7 */,
	/* 8 */,
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(81);
	
	/***/ },
	/* 10 */,
	/* 11 */,
	/* 12 */,
	/* 13 */,
	/* 14 */,
	/* 15 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1534);
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1500);
	
	/***/ },
	/* 17 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(317);
	
	/***/ },
	/* 18 */,
	/* 19 */,
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 12 12" }, this.props),
		          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	/* 21 */,
	/* 22 */,
	/* 23 */,
	/* 24 */,
	/* 25 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(318);
	
	/***/ },
	/* 26 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(704);
	
	/***/ },
	/* 27 */,
	/* 28 */,
	/* 29 */,
	/* 30 */,
	/* 31 */,
	/* 32 */,
	/* 33 */,
	/* 34 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(842);
	
	/***/ },
	/* 35 */,
	/* 36 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(257);
	
	/***/ },
	/* 37 */,
	/* 38 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(702);
	
	/***/ },
	/* 39 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1495);
	
	/***/ },
	/* 40 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1499);
	
	/***/ }
	/******/ ]);

/***/ },
/* 3259 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getCalendarMonthWeeks;
	function getCalendarMonthWeeks(month, enableOutsideDays) {
	  // set utc offset to get correct dates in future (when timezone changes)
	  var baseDate = month.clone();
	  var firstOfMonth = baseDate.clone().startOf('month').hour(12);
	  var lastOfMonth = baseDate.clone().endOf('month').hour(12);
	
	  var currentDay = firstOfMonth.clone();
	  var currentWeek = [];
	  var weeksInMonth = [];
	
	  // days belonging to the previous month
	  for (var i = 0; i < currentDay.weekday(); i++) {
	    var prevDay = enableOutsideDays && currentDay.clone().subtract(i + 1, 'day');
	    currentWeek.unshift(prevDay);
	  }
	
	  while (currentDay < lastOfMonth) {
	    currentWeek.push(currentDay.clone());
	    currentDay.add(1, 'd');
	
	    if (currentDay.weekday() === 0) {
	      weeksInMonth.push(currentWeek);
	      currentWeek = [];
	    }
	  }
	
	  // weekday() returns the index of the day of the week according to the locale
	  // this means if the week starts on Monday, weekday() will return 0 for a Monday date, not 1
	  if (currentDay.weekday() !== 0) {
	    // days belonging to the next month
	    for (var k = currentDay.weekday(), count = 0; k < 7; k++, count++) {
	      var nextDay = enableOutsideDays && currentDay.clone().add(count, 'day');
	      currentWeek.push(nextDay);
	    }
	
	    weeksInMonth.push(currentWeek);
	  }
	
	  return weeksInMonth;
	}

/***/ },
/* 3260 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isTransitionEndSupported;
	function isTransitionEndSupported() {
	  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
	}

/***/ },
/* 3261 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toLocalizedDateString;
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(318);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toLocalizedDateString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.ISO_FORMAT);
	}

/***/ },
/* 3262 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3266);


/***/ },
/* 3263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(182);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LocaleUtils = __webpack_require__(705);
	
	var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);
	
	var _keys = __webpack_require__(319);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Caption = function (_Component) {
	  _inherits(Caption, _Component);
	
	  function Caption(props) {
	    _classCallCheck(this, Caption);
	
	    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));
	
	    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
	    return _this;
	  }
	
	  _createClass(Caption, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
	    }
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(e) {
	      if (e.keyCode === _keys.ENTER) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          date = _props.date,
	          months = _props.months,
	          locale = _props.locale,
	          localeUtils = _props.localeUtils,
	          onClick = _props.onClick;
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.caption, role: 'heading' },
	        _react2.default.createElement(
	          'div',
	          { onClick: onClick, onKeyUp: this.handleKeyUp },
	          months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
	        )
	      );
	    }
	  }]);
	
	  return Caption;
	}(_react.Component);
	
	Caption.propTypes = {
	  date: _propTypes2.default.instanceOf(Date),
	  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  locale: _propTypes2.default.string,
	  localeUtils: _propTypes2.default.object,
	  onClick: _propTypes2.default.func,
	  classNames: _propTypes2.default.shape({
	    caption: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	Caption.defaultProps = {
	  localeUtils: _LocaleUtils2.default
	};
	exports.default = Caption;
	//# sourceMappingURL=Caption.js.map

/***/ },
/* 3264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(182);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DateUtils = __webpack_require__(258);
	
	var _Helpers = __webpack_require__(446);
	
	var _classNames = __webpack_require__(447);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */
	
	function handleEvent(handler, day, modifiers) {
	  if (!handler) {
	    return undefined;
	  }
	  return function (e) {
	    e.persist();
	    handler(day, modifiers, e);
	  };
	}
	
	var Day = function (_Component) {
	  _inherits(Day, _Component);
	
	  function Day() {
	    _classCallCheck(this, Day);
	
	    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
	  }
	
	  _createClass(Day, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var propNames = Object.keys(this.props);
	      var nextPropNames = Object.keys(nextProps);
	      if (propNames.length !== nextPropNames.length) {
	        return true;
	      }
	      return propNames.some(function (name) {
	        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
	          var prop = _this2.props[name];
	          var nextProp = nextProps[name];
	          var modifiers = Object.keys(prop);
	          var nextModifiers = Object.keys(nextProp);
	          if (modifiers.length !== nextModifiers.length) {
	            return true;
	          }
	          return modifiers.some(function (mod) {
	            return !(0, _Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
	          });
	        }
	        if (name === 'day') {
	          return !(0, _DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
	        }
	        return !(0, _Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          modifiersStyles = _props.modifiersStyles,
	          day = _props.day,
	          tabIndex = _props.tabIndex,
	          empty = _props.empty,
	          modifiers = _props.modifiers,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onClick = _props.onClick,
	          onKeyDown = _props.onKeyDown,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onFocus = _props.onFocus,
	          ariaLabel = _props.ariaLabel,
	          ariaDisabled = _props.ariaDisabled,
	          ariaSelected = _props.ariaSelected,
	          children = _props.children;
	
	
	      var className = classNames.day;
	      if (classNames !== _classNames2.default) {
	        // When using CSS modules prefix the modifier as required by the BEM syntax
	        className += ' ' + Object.keys(modifiers).join(' ');
	      } else {
	        className += Object.keys(modifiers).map(function (modifier) {
	          return ' ' + className + '--' + modifier;
	        }).join('');
	      }
	
	      var style = void 0;
	      if (modifiersStyles) {
	        Object.keys(modifiers).filter(function (modifier) {
	          return !!modifiersStyles[modifier];
	        }).forEach(function (modifier) {
	          style = _extends({}, style, modifiersStyles[modifier]);
	        });
	      }
	
	      if (empty) {
	        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
	      }
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          tabIndex: tabIndex,
	          style: style,
	          role: 'gridcell',
	          'aria-label': ariaLabel,
	          'aria-disabled': ariaDisabled,
	          'aria-selected': ariaSelected,
	          onClick: handleEvent(onClick, day, modifiers),
	          onKeyDown: handleEvent(onKeyDown, day, modifiers),
	          onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
	          onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
	          onMouseUp: handleEvent(onMouseUp, day, modifiers),
	          onMouseDown: handleEvent(onMouseDown, day, modifiers),
	          onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
	          onTouchStart: handleEvent(onTouchStart, day, modifiers),
	          onFocus: handleEvent(onFocus, day, modifiers)
	        },
	        children
	      );
	    }
	  }]);
	
	  return Day;
	}(_react.Component);
	
	Day.propTypes = {
	  classNames: _propTypes2.default.shape({
	    day: _propTypes2.default.string.isRequired
	  }).isRequired,
	
	  day: _propTypes2.default.instanceOf(Date).isRequired,
	  children: _propTypes2.default.node.isRequired,
	
	  ariaDisabled: _propTypes2.default.bool,
	  ariaLabel: _propTypes2.default.string,
	  ariaSelected: _propTypes2.default.bool,
	  empty: _propTypes2.default.bool,
	  modifiers: _propTypes2.default.object,
	  modifiersStyles: _propTypes2.default.object,
	  onClick: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onTouchStart: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  tabIndex: _propTypes2.default.number
	};
	Day.defaultProps = {
	  tabIndex: -1
	};
	Day.defaultProps = {
	  modifiers: {},
	  modifiersStyles: {},
	  empty: false
	};
	exports.default = Day;
	//# sourceMappingURL=Day.js.map

/***/ },
/* 3265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModifiersUtils = exports.LocaleUtils = exports.DateUtils = exports.DayPicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(182);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Caption = __webpack_require__(3263);
	
	var _Caption2 = _interopRequireDefault(_Caption);
	
	var _Navbar = __webpack_require__(3268);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Month = __webpack_require__(3267);
	
	var _Month2 = _interopRequireDefault(_Month);
	
	var _Weekday = __webpack_require__(3269);
	
	var _Weekday2 = _interopRequireDefault(_Weekday);
	
	var _Helpers = __webpack_require__(446);
	
	var Helpers = _interopRequireWildcard(_Helpers);
	
	var _DateUtils = __webpack_require__(258);
	
	var DateUtils = _interopRequireWildcard(_DateUtils);
	
	var _LocaleUtils = __webpack_require__(705);
	
	var LocaleUtils = _interopRequireWildcard(_LocaleUtils);
	
	var _ModifiersUtils = __webpack_require__(706);
	
	var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);
	
	var _classNames = __webpack_require__(447);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	var _keys = __webpack_require__(319);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DayPicker = exports.DayPicker = function (_Component) {
	  _inherits(DayPicker, _Component);
	
	  function DayPicker(props) {
	    _classCallCheck(this, DayPicker);
	
	    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));
	
	    _this.dayPicker = null;
	
	    _this.showNextMonth = function (callback) {
	      if (!_this.allowNextMonth()) {
	        return;
	      }
	      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
	      var nextMonth = DateUtils.addMonths(_this.state.currentMonth, deltaMonths);
	      _this.showMonth(nextMonth, callback);
	    };
	
	    _this.showPreviousMonth = function (callback) {
	      if (!_this.allowPreviousMonth()) {
	        return;
	      }
	      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
	      var previousMonth = DateUtils.addMonths(_this.state.currentMonth, -deltaMonths);
	      _this.showMonth(previousMonth, callback);
	    };
	
	    _this.handleKeyDown = function (e) {
	      e.persist();
	
	      switch (e.keyCode) {
	        case _keys.LEFT:
	          if (_this.props.dir === 'rtl') {
	            _this.showNextMonth();
	          } else {
	            _this.showPreviousMonth();
	          }
	          Helpers.cancelEvent(e);
	          break;
	        case _keys.RIGHT:
	          if (_this.props.dir === 'rtl') {
	            _this.showPreviousMonth();
	          } else {
	            _this.showNextMonth();
	          }
	          Helpers.cancelEvent(e);
	          break;
	        case _keys.UP:
	          _this.showPreviousYear();
	          Helpers.cancelEvent(e);
	          break;
	        case _keys.DOWN:
	          _this.showNextYear();
	          Helpers.cancelEvent(e);
	          break;
	        default:
	          break;
	      }
	
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	    };
	
	    _this.handleDayKeyDown = function (day, modifiers, e) {
	      e.persist();
	
	      switch (e.keyCode) {
	        case _keys.LEFT:
	          Helpers.cancelEvent(e);
	          if (_this.props.dir === 'rtl') {
	            _this.focusNextDay(e.target);
	          } else {
	            _this.focusPreviousDay(e.target);
	          }
	          break;
	        case _keys.RIGHT:
	          Helpers.cancelEvent(e);
	          if (_this.props.dir === 'rtl') {
	            _this.focusPreviousDay(e.target);
	          } else {
	            _this.focusNextDay(e.target);
	          }
	          break;
	        case _keys.UP:
	          Helpers.cancelEvent(e);
	          _this.focusPreviousWeek(e.target);
	          break;
	        case _keys.DOWN:
	          Helpers.cancelEvent(e);
	          _this.focusNextWeek(e.target);
	          break;
	        case _keys.ENTER:
	        case _keys.SPACE:
	          Helpers.cancelEvent(e);
	          if (_this.props.onDayClick) {
	            _this.handleDayClick(day, modifiers, e);
	          }
	          break;
	        default:
	          break;
	      }
	      if (_this.props.onDayKeyDown) {
	        _this.props.onDayKeyDown(day, modifiers, e);
	      }
	    };
	
	    _this.handleDayClick = function (day, modifiers, e) {
	      e.persist();
	
	      if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) {
	        _this.handleOutsideDayClick(day);
	      }
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, modifiers, e);
	      }
	    };
	
	    _this.handleTodayButtonClick = function (e) {
	      var today = new Date();
	      var month = new Date(today.getFullYear(), today.getMonth());
	      _this.showMonth(month);
	      e.target.blur();
	      if (_this.props.onTodayButtonClick) {
	        e.persist();
	        _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils.getModifiersForDay(today, _this.props.modifiers), e);
	      }
	    };
	
	    var currentMonth = _this.getCurrentMonthFromProps(props);
	    _this.state = { currentMonth: currentMonth };
	    return _this;
	  }
	
	  _createClass(DayPicker, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // Changing the `month` props means changing the current displayed month
	      if (prevProps.month !== this.props.month && !DateUtils.isSameMonth(prevProps.month, this.props.month)) {
	        var currentMonth = this.getCurrentMonthFromProps(this.props);
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState({ currentMonth: currentMonth });
	      }
	    }
	  }, {
	    key: 'getCurrentMonthFromProps',
	
	
	    /**
	     * Return the month to be shown in the calendar based on the component props.
	     *
	     * @param {Object} props
	     * @returns Date
	     * @memberof DayPicker
	     * @private
	     */
	    value: function getCurrentMonthFromProps(props) {
	      var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth || new Date());
	      var currentMonth = initialMonth;
	
	      if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
	        var fromMonth = Helpers.startOfMonth(props.fromMonth);
	        var diffInMonths = Helpers.getMonthsDiff(fromMonth, currentMonth);
	        currentMonth = DateUtils.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
	      } else if (props.toMonth && props.numberOfMonths > 1 && Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
	        currentMonth = DateUtils.addMonths(Helpers.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
	      }
	      return currentMonth;
	    }
	  }, {
	    key: 'getNextNavigableMonth',
	    value: function getNextNavigableMonth() {
	      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
	    }
	  }, {
	    key: 'getPreviousNavigableMonth',
	    value: function getPreviousNavigableMonth() {
	      return DateUtils.addMonths(this.state.currentMonth, -1);
	    }
	  }, {
	    key: 'allowPreviousMonth',
	    value: function allowPreviousMonth() {
	      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
	      return this.allowMonth(previousMonth);
	    }
	  }, {
	    key: 'allowNextMonth',
	    value: function allowNextMonth() {
	      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
	      return this.allowMonth(nextMonth);
	    }
	  }, {
	    key: 'allowMonth',
	    value: function allowMonth(d) {
	      var _props = this.props,
	          fromMonth = _props.fromMonth,
	          toMonth = _props.toMonth,
	          canChangeMonth = _props.canChangeMonth;
	
	      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'allowYearChange',
	    value: function allowYearChange() {
	      return this.props.canChangeMonth;
	    }
	  }, {
	    key: 'showMonth',
	    value: function showMonth(d, callback) {
	      var _this2 = this;
	
	      if (!this.allowMonth(d)) {
	        return;
	      }
	      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
	        if (callback) {
	          callback();
	        }
	        if (_this2.props.onMonthChange) {
	          _this2.props.onMonthChange(_this2.state.currentMonth);
	        }
	      });
	    }
	  }, {
	    key: 'showNextYear',
	    value: function showNextYear() {
	      if (!this.allowYearChange()) {
	        return;
	      }
	      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
	      this.showMonth(nextMonth);
	    }
	  }, {
	    key: 'showPreviousYear',
	    value: function showPreviousYear() {
	      if (!this.allowYearChange()) {
	        return;
	      }
	      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
	      this.showMonth(nextMonth);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.wrapper.focus();
	    }
	  }, {
	    key: 'focusFirstDayOfMonth',
	    value: function focusFirstDayOfMonth() {
	      Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
	    }
	  }, {
	    key: 'focusLastDayOfMonth',
	    value: function focusLastDayOfMonth() {
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      dayNodes[dayNodes.length - 1].focus();
	    }
	  }, {
	    key: 'focusPreviousDay',
	    value: function focusPreviousDay(dayNode) {
	      var _this3 = this;
	
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
	      if (dayNodeIndex === -1) return;
	      if (dayNodeIndex === 0) {
	        this.showPreviousMonth(function () {
	          return _this3.focusLastDayOfMonth();
	        });
	      } else {
	        dayNodes[dayNodeIndex - 1].focus();
	      }
	    }
	  }, {
	    key: 'focusNextDay',
	    value: function focusNextDay(dayNode) {
	      var _this4 = this;
	
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
	      if (dayNodeIndex === -1) return;
	      if (dayNodeIndex === dayNodes.length - 1) {
	        this.showNextMonth(function () {
	          return _this4.focusFirstDayOfMonth();
	        });
	      } else {
	        dayNodes[dayNodeIndex + 1].focus();
	      }
	    }
	  }, {
	    key: 'focusNextWeek',
	    value: function focusNextWeek(dayNode) {
	      var _this5 = this;
	
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
	      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;
	
	      if (isInLastWeekOfMonth) {
	        this.showNextMonth(function () {
	          var daysAfterIndex = dayNodes.length - dayNodeIndex;
	          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
	          Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
	        });
	      } else {
	        dayNodes[dayNodeIndex + 7].focus();
	      }
	    }
	  }, {
	    key: 'focusPreviousWeek',
	    value: function focusPreviousWeek(dayNode) {
	      var _this6 = this;
	
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
	      var isInFirstWeekOfMonth = dayNodeIndex <= 6;
	
	      if (isInFirstWeekOfMonth) {
	        this.showPreviousMonth(function () {
	          var previousMonthDayNodes = Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
	          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
	          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
	          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
	        });
	      } else {
	        dayNodes[dayNodeIndex - 7].focus();
	      }
	    }
	
	    // Event handlers
	
	  }, {
	    key: 'handleOutsideDayClick',
	    value: function handleOutsideDayClick(day) {
	      var currentMonth = this.state.currentMonth;
	      var numberOfMonths = this.props.numberOfMonths;
	
	      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
	      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
	        this.showNextMonth();
	      } else if (diffInMonths < 0) {
	        this.showPreviousMonth();
	      }
	    }
	  }, {
	    key: 'renderNavbar',
	    value: function renderNavbar() {
	      var _props2 = this.props,
	          labels = _props2.labels,
	          locale = _props2.locale,
	          localeUtils = _props2.localeUtils,
	          canChangeMonth = _props2.canChangeMonth,
	          navbarElement = _props2.navbarElement,
	          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);
	
	      if (!canChangeMonth) return null;
	
	      var props = {
	        month: this.state.currentMonth,
	        classNames: this.props.classNames,
	        className: this.props.classNames.navBar,
	        nextMonth: this.getNextNavigableMonth(),
	        previousMonth: this.getPreviousNavigableMonth(),
	        showPreviousButton: this.allowPreviousMonth(),
	        showNextButton: this.allowNextMonth(),
	        onNextClick: this.showNextMonth,
	        onPreviousClick: this.showPreviousMonth,
	        dir: attributes.dir,
	        labels: labels,
	        locale: locale,
	        localeUtils: localeUtils
	      };
	      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
	    }
	  }, {
	    key: 'renderMonths',
	    value: function renderMonths() {
	      var months = [];
	      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);
	      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
	        var month = DateUtils.addMonths(this.state.currentMonth, i);
	        months.push(_react2.default.createElement(_Month2.default, _extends({
	          key: i
	        }, this.props, {
	          month: month,
	          firstDayOfWeek: firstDayOfWeek,
	          onDayKeyDown: this.handleDayKeyDown,
	          onDayClick: this.handleDayClick
	        })));
	      }
	
	      if (this.props.reverseMonths) {
	        months.reverse();
	      }
	      return months;
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      if (this.props.todayButton) {
	        return _react2.default.createElement(
	          'div',
	          { className: this.props.classNames.footer },
	          this.renderTodayButton()
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderTodayButton',
	    value: function renderTodayButton() {
	      return _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          tabIndex: 0,
	          className: this.props.classNames.todayButton,
	          'aria-label': this.props.todayButton,
	          onClick: this.handleTodayButtonClick
	        },
	        this.props.todayButton
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var className = this.props.classNames.container;
	
	      if (!this.props.onDayClick) {
	        className = className + ' ' + this.props.classNames.interactionDisabled;
	      }
	      if (this.props.className) {
	        className = className + ' ' + this.props.className;
	      }
	      return _react2.default.createElement(
	        'div',
	        _extends({}, this.props.containerProps, {
	          className: className,
	          ref: function ref(el) {
	            return _this7.dayPicker = el;
	          },
	          lang: this.props.locale
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: this.props.classNames.wrapper,
	            ref: function ref(el) {
	              return _this7.wrapper = el;
	            },
	            tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== 'undefined' ? this.props.tabIndex : -1,
	            onKeyDown: this.handleKeyDown,
	            onFocus: this.props.onFocus,
	            onBlur: this.props.onBlur
	          },
	          this.renderNavbar(),
	          _react2.default.createElement(
	            'div',
	            { className: this.props.classNames.months },
	            this.renderMonths()
	          ),
	          this.renderFooter()
	        )
	      );
	    }
	  }]);
	
	  return DayPicker;
	}(_react.Component);
	
	DayPicker.propTypes = {
	  // Rendering months
	  initialMonth: _propTypes2.default.instanceOf(Date),
	  month: _propTypes2.default.instanceOf(Date),
	  numberOfMonths: _propTypes2.default.number,
	  fromMonth: _propTypes2.default.instanceOf(Date),
	  toMonth: _propTypes2.default.instanceOf(Date),
	  canChangeMonth: _propTypes2.default.bool,
	  reverseMonths: _propTypes2.default.bool,
	  pagedNavigation: _propTypes2.default.bool,
	  todayButton: _propTypes2.default.string,
	  showWeekNumbers: _propTypes2.default.bool,
	  showWeekDays: _propTypes2.default.bool,
	
	  // Modifiers
	  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
	  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
	
	  modifiers: _propTypes2.default.object,
	  modifiersStyles: _propTypes2.default.object,
	
	  // Localization
	  dir: _propTypes2.default.string,
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	  labels: _propTypes2.default.shape({
	    nextMonth: _propTypes2.default.string.isRequired,
	    previousMonth: _propTypes2.default.string.isRequired
	  }),
	  locale: _propTypes2.default.string,
	  localeUtils: _propTypes2.default.shape({
	    formatMonthTitle: _propTypes2.default.func,
	    formatWeekdayShort: _propTypes2.default.func,
	    formatWeekdayLong: _propTypes2.default.func,
	    getFirstDayOfWeek: _propTypes2.default.func
	  }),
	  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
	  // Customization
	  showOutsideDays: _propTypes2.default.bool,
	  enableOutsideDaysClick: _propTypes2.default.bool,
	  fixedWeeks: _propTypes2.default.bool,
	
	  // CSS and HTML
	  classNames: _propTypes2.default.shape({
	    body: _propTypes2.default.string,
	    container: _propTypes2.default.string,
	    day: _propTypes2.default.string.isRequired,
	    disabled: _propTypes2.default.string.isRequired,
	    footer: _propTypes2.default.string,
	    interactionDisabled: _propTypes2.default.string,
	    months: _propTypes2.default.string,
	    month: _propTypes2.default.string,
	    navBar: _propTypes2.default.string,
	    outside: _propTypes2.default.string.isRequired,
	    selected: _propTypes2.default.string.isRequired,
	    today: _propTypes2.default.string.isRequired,
	    todayButton: _propTypes2.default.string,
	    week: _propTypes2.default.string,
	    wrapper: _propTypes2.default.string
	  }),
	  className: _propTypes2.default.string,
	  containerProps: _propTypes2.default.object,
	  tabIndex: _propTypes2.default.number,
	
	  // Custom elements
	  renderDay: _propTypes2.default.func,
	  renderWeek: _propTypes2.default.func,
	  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
	  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
	  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
	
	  // Events
	  onBlur: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onDayClick: _propTypes2.default.func,
	  onDayKeyDown: _propTypes2.default.func,
	  onDayMouseEnter: _propTypes2.default.func,
	  onDayMouseLeave: _propTypes2.default.func,
	  onDayMouseDown: _propTypes2.default.func,
	  onDayMouseUp: _propTypes2.default.func,
	  onDayTouchStart: _propTypes2.default.func,
	  onDayTouchEnd: _propTypes2.default.func,
	  onDayFocus: _propTypes2.default.func,
	  onMonthChange: _propTypes2.default.func,
	  onCaptionClick: _propTypes2.default.func,
	  onWeekClick: _propTypes2.default.func,
	  onTodayButtonClick: _propTypes2.default.func
	};
	DayPicker.defaultProps = {
	  classNames: _classNames2.default,
	  tabIndex: 0,
	  numberOfMonths: 1,
	  labels: {
	    previousMonth: 'Previous Month',
	    nextMonth: 'Next Month'
	  },
	  locale: 'en',
	  localeUtils: LocaleUtils,
	  showOutsideDays: false,
	  enableOutsideDaysClick: true,
	  fixedWeeks: false,
	  canChangeMonth: true,
	  reverseMonths: false,
	  pagedNavigation: false,
	  showWeekNumbers: false,
	  showWeekDays: true,
	  renderDay: function renderDay(day) {
	    return day.getDate();
	  },
	  renderWeek: function renderWeek(weekNumber) {
	    return weekNumber;
	  },
	  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
	  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
	  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
	};
	DayPicker.VERSION = '7.4.8';
	
	
	DayPicker.DateUtils = DateUtils;
	DayPicker.LocaleUtils = LocaleUtils;
	DayPicker.ModifiersUtils = ModifiersUtils;
	
	exports.DateUtils = DateUtils;
	exports.LocaleUtils = LocaleUtils;
	exports.ModifiersUtils = ModifiersUtils;
	exports.default = DayPicker;
	//# sourceMappingURL=DayPicker.js.map

/***/ },
/* 3266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HIDE_TIMEOUT = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.OverlayComponent = OverlayComponent;
	exports.defaultFormat = defaultFormat;
	exports.defaultParse = defaultParse;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(182);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DayPicker = __webpack_require__(3265);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	var _DateUtils = __webpack_require__(258);
	
	var _ModifiersUtils = __webpack_require__(706);
	
	var _keys = __webpack_require__(319);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// When clicking on a day cell, overlay will be hidden after this timeout
	var HIDE_TIMEOUT = exports.HIDE_TIMEOUT = 100;
	
	/**
	 * The default component used as Overlay.
	 *
	 * @param {Object} props
	 */
	function OverlayComponent(_ref) {
	  var input = _ref.input,
	      selectedDay = _ref.selectedDay,
	      month = _ref.month,
	      children = _ref.children,
	      classNames = _ref.classNames,
	      props = _objectWithoutProperties(_ref, ['input', 'selectedDay', 'month', 'children', 'classNames']);
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: classNames.overlayWrapper }, props),
	    _react2.default.createElement(
	      'div',
	      { className: classNames.overlay },
	      children
	    )
	  );
	}
	
	OverlayComponent.propTypes = {
	  input: _propTypes2.default.any,
	  selectedDay: _propTypes2.default.any,
	  month: _propTypes2.default.instanceOf(Date),
	  children: _propTypes2.default.node,
	  classNames: _propTypes2.default.object
	};
	
	/**
	 * The default function used to format a Date to String, passed to the `format`
	 * prop.
	 * @param {Date} d
	 * @return {String}
	 */
	function defaultFormat(d) {
	  if ((0, _DateUtils.isDate)(d)) {
	    var year = d.getFullYear();
	    var month = '' + (d.getMonth() + 1);
	    var day = '' + d.getDate();
	    return year + '-' + month + '-' + day;
	  }
	  return '';
	}
	
	/**
	 * The default function used to parse a String as Date, passed to the `parse`
	 * prop.
	 * @param {String} str
	 * @return {Date}
	 */
	function defaultParse(str) {
	  if (typeof str !== 'string') {
	    return undefined;
	  }
	  var split = str.split('-');
	  if (split.length !== 3) {
	    return undefined;
	  }
	  var year = parseInt(split[0], 10);
	  var month = parseInt(split[1], 10) - 1;
	  var day = parseInt(split[2], 10);
	  if (isNaN(year) || String(year).length > 4 || isNaN(month) || isNaN(day) || day <= 0 || day > 31 || month < 0 || month >= 12) {
	    return undefined;
	  }
	
	  return new Date(year, month, day, 12, 0, 0, 0); // always set noon to avoid time zone issues
	}
	
	var DayPickerInput = function (_React$Component) {
	  _inherits(DayPickerInput, _React$Component);
	
	  function DayPickerInput(props) {
	    _classCallCheck(this, DayPickerInput);
	
	    var _this = _possibleConstructorReturn(this, (DayPickerInput.__proto__ || Object.getPrototypeOf(DayPickerInput)).call(this, props));
	
	    _this.input = null;
	    _this.daypicker = null;
	    _this.clickTimeout = null;
	    _this.hideTimeout = null;
	    _this.inputBlurTimeout = null;
	    _this.inputFocusTimeout = null;
	
	
	    _this.state = _this.getInitialStateFromProps(props);
	    _this.state.showOverlay = props.showOverlay;
	
	    _this.hideAfterDayClick = _this.hideAfterDayClick.bind(_this);
	    _this.handleInputClick = _this.handleInputClick.bind(_this);
	    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
	    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
	    _this.handleInputKeyUp = _this.handleInputKeyUp.bind(_this);
	    _this.handleDayClick = _this.handleDayClick.bind(_this);
	    _this.handleMonthChange = _this.handleMonthChange.bind(_this);
	    _this.handleOverlayFocus = _this.handleOverlayFocus.bind(_this);
	    _this.handleOverlayBlur = _this.handleOverlayBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPickerInput, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var newState = {};
	
	      // Current props
	      var _props = this.props,
	          value = _props.value,
	          formatDate = _props.formatDate,
	          format = _props.format,
	          dayPickerProps = _props.dayPickerProps;
	
	      // Update the input value if `value`, `dayPickerProps.locale` or `format`
	      // props have changed
	
	      if (value !== prevProps.value || dayPickerProps.locale !== prevProps.dayPickerProps.locale || format !== prevProps.format) {
	        if ((0, _DateUtils.isDate)(value)) {
	          newState.value = formatDate(value, format, dayPickerProps.locale);
	        } else {
	          newState.value = value;
	        }
	      }
	
	      // Update the month if the months from props changed
	      var prevMonth = prevProps.dayPickerProps.month;
	      if (dayPickerProps.month && dayPickerProps.month !== prevMonth && !(0, _DateUtils.isSameMonth)(dayPickerProps.month, prevMonth)) {
	        newState.month = dayPickerProps.month;
	      }
	
	      // Updated the selected days from props if they changed
	      if (prevProps.dayPickerProps.selectedDays !== dayPickerProps.selectedDays) {
	        newState.selectedDays = dayPickerProps.selectedDays;
	      }
	
	      if (Object.keys(newState).length > 0) {
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.clickTimeout);
	      clearTimeout(this.hideTimeout);
	      clearTimeout(this.inputFocusTimeout);
	      clearTimeout(this.inputBlurTimeout);
	      clearTimeout(this.overlayBlurTimeout);
	    }
	  }, {
	    key: 'getInitialMonthFromProps',
	    value: function getInitialMonthFromProps(props) {
	      var dayPickerProps = props.dayPickerProps,
	          format = props.format;
	
	      var day = void 0;
	      if (props.value) {
	        if ((0, _DateUtils.isDate)(props.value)) {
	          day = props.value;
	        } else {
	          day = props.parseDate(props.value, format, dayPickerProps.locale);
	        }
	      }
	      return dayPickerProps.initialMonth || dayPickerProps.month || day || new Date();
	    }
	  }, {
	    key: 'getInitialStateFromProps',
	    value: function getInitialStateFromProps(props) {
	      var dayPickerProps = props.dayPickerProps,
	          formatDate = props.formatDate,
	          format = props.format,
	          typedValue = props.typedValue;
	      var value = props.value;
	
	      if (props.value && (0, _DateUtils.isDate)(props.value)) {
	        value = formatDate(props.value, format, dayPickerProps.locale);
	      }
	
	      return {
	        value: value,
	        typedValue: typedValue,
	        month: this.getInitialMonthFromProps(props),
	        selectedDays: dayPickerProps.selectedDays
	      };
	    }
	  }, {
	    key: 'getInput',
	    value: function getInput() {
	      return this.input;
	    }
	  }, {
	    key: 'getDayPicker',
	    value: function getDayPicker() {
	      return this.daypicker;
	    }
	
	    /**
	     * Update the component's state and fire the `onDayChange` event passing the
	     * day's modifiers to it.
	     *
	     * @param {Date} day - Will be used for changing the month
	     * @param {String} value - Input field value
	     * @private
	     */
	
	  }, {
	    key: 'updateState',
	    value: function updateState(day, value, callback) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          dayPickerProps = _props2.dayPickerProps,
	          onDayChange = _props2.onDayChange;
	
	      this.setState({ month: day, value: value, typedValue: '' }, function () {
	        if (callback) {
	          callback();
	        }
	        if (!onDayChange) {
	          return;
	        }
	        var modifiersObj = _extends({
	          disabled: dayPickerProps.disabledDays,
	          selected: dayPickerProps.selectedDays
	        }, dayPickerProps.modifiers);
	        var modifiers = (0, _ModifiersUtils.getModifiersForDay)(day, modifiersObj).reduce(function (obj, modifier) {
	          return _extends({}, obj, _defineProperty({}, modifier, true));
	        }, {});
	        onDayChange(day, modifiers, _this2);
	      });
	    }
	
	    /**
	     * Show the Day Picker overlay.
	     *
	     * @memberof DayPickerInput
	     */
	
	  }, {
	    key: 'showDayPicker',
	    value: function showDayPicker() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          parseDate = _props3.parseDate,
	          format = _props3.format,
	          dayPickerProps = _props3.dayPickerProps;
	      var _state = this.state,
	          value = _state.value,
	          showOverlay = _state.showOverlay;
	
	      if (showOverlay) {
	        return;
	      }
	      // Reset the current displayed month when showing the overlay
	      var month = value ? parseDate(value, format, dayPickerProps.locale) // Use the month in the input field
	      : this.getInitialMonthFromProps(this.props); // Restore the month from the props
	      this.setState(function (state) {
	        return {
	          showOverlay: true,
	          month: month || state.month
	        };
	      }, function () {
	        if (_this3.props.onDayPickerShow) _this3.props.onDayPickerShow();
	      });
	    }
	
	    /**
	     * Hide the Day Picker overlay
	     *
	     * @memberof DayPickerInput
	     */
	
	  }, {
	    key: 'hideDayPicker',
	    value: function hideDayPicker() {
	      var _this4 = this;
	
	      if (this.state.showOverlay === false) {
	        return;
	      }
	      this.setState({ showOverlay: false }, function () {
	        if (_this4.props.onDayPickerHide) _this4.props.onDayPickerHide();
	      });
	    }
	  }, {
	    key: 'hideAfterDayClick',
	    value: function hideAfterDayClick() {
	      var _this5 = this;
	
	      if (!this.props.hideOnDayClick) {
	        return;
	      }
	      this.hideTimeout = setTimeout(function () {
	        _this5.overlayHasFocus = false;
	        _this5.hideDayPicker();
	      }, HIDE_TIMEOUT);
	    }
	  }, {
	    key: 'handleInputClick',
	    value: function handleInputClick(e) {
	      this.showDayPicker();
	      if (this.props.inputProps.onClick) {
	        e.persist();
	        this.props.inputProps.onClick(e);
	      }
	    }
	  }, {
	    key: 'handleInputFocus',
	    value: function handleInputFocus(e) {
	      var _this6 = this;
	
	      this.showDayPicker();
	      // Set `overlayHasFocus` after a timeout so the overlay can be hidden when
	      // the input is blurred
	      this.inputFocusTimeout = setTimeout(function () {
	        _this6.overlayHasFocus = false;
	      }, 2);
	      if (this.props.inputProps.onFocus) {
	        e.persist();
	        this.props.inputProps.onFocus(e);
	      }
	    }
	
	    // When the input is blurred, the overlay should disappear. However the input
	    // is blurred also when the user interacts with the overlay (e.g. the overlay
	    // get the focus by clicking it). In these cases, the overlay should not be
	    // hidden. There are different approaches to avoid hiding the overlay when
	    // this happens, but the only cross-browser hack we’ve found is to set all
	    // these timeouts in code before changing `overlayHasFocus`.
	
	  }, {
	    key: 'handleInputBlur',
	    value: function handleInputBlur(e) {
	      var _this7 = this;
	
	      this.inputBlurTimeout = setTimeout(function () {
	        if (!_this7.overlayHasFocus) {
	          _this7.hideDayPicker();
	        }
	      }, 1);
	      if (this.props.inputProps.onBlur) {
	        e.persist();
	        this.props.inputProps.onBlur(e);
	      }
	    }
	  }, {
	    key: 'handleOverlayFocus',
	    value: function handleOverlayFocus(e) {
	      e.preventDefault();
	      this.overlayHasFocus = true;
	      if (!this.props.keepFocus || !this.input || typeof this.input.focus !== 'function') {
	        return;
	      }
	      this.input.focus();
	    }
	  }, {
	    key: 'handleOverlayBlur',
	    value: function handleOverlayBlur() {
	      var _this8 = this;
	
	      // We need to set a timeout otherwise IE11 will hide the overlay when
	      // focusing it
	      this.overlayBlurTimeout = setTimeout(function () {
	        _this8.overlayHasFocus = false;
	      }, 3);
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(e) {
	      var _props4 = this.props,
	          dayPickerProps = _props4.dayPickerProps,
	          format = _props4.format,
	          inputProps = _props4.inputProps,
	          onDayChange = _props4.onDayChange,
	          parseDate = _props4.parseDate;
	
	      if (inputProps.onChange) {
	        e.persist();
	        inputProps.onChange(e);
	      }
	      var value = e.target.value;
	
	      if (value.trim() === '') {
	        this.setState({ value: value, typedValue: '' });
	        if (onDayChange) onDayChange(undefined, {}, this);
	        return;
	      }
	      var day = parseDate(value, format, dayPickerProps.locale);
	      if (!day) {
	        // Day is invalid: we save the value in the typedValue state
	        this.setState({ value: value, typedValue: value });
	        if (onDayChange) onDayChange(undefined, {}, this);
	        return;
	      }
	      this.updateState(day, value);
	    }
	  }, {
	    key: 'handleInputKeyDown',
	    value: function handleInputKeyDown(e) {
	      if (e.keyCode === _keys.TAB) {
	        this.hideDayPicker();
	      } else {
	        this.showDayPicker();
	      }
	      if (this.props.inputProps.onKeyDown) {
	        e.persist();
	        this.props.inputProps.onKeyDown(e);
	      }
	    }
	  }, {
	    key: 'handleInputKeyUp',
	    value: function handleInputKeyUp(e) {
	      if (e.keyCode === _keys.ESC) {
	        this.hideDayPicker();
	      } else {
	        this.showDayPicker();
	      }
	      if (this.props.inputProps.onKeyUp) {
	        e.persist();
	        this.props.inputProps.onKeyUp(e);
	      }
	    }
	  }, {
	    key: 'handleMonthChange',
	    value: function handleMonthChange(month) {
	      var _this9 = this;
	
	      this.setState({ month: month }, function () {
	        if (_this9.props.dayPickerProps && _this9.props.dayPickerProps.onMonthChange) {
	          _this9.props.dayPickerProps.onMonthChange(month);
	        }
	      });
	    }
	  }, {
	    key: 'handleDayClick',
	    value: function handleDayClick(day, modifiers, e) {
	      var _this10 = this;
	
	      var _props5 = this.props,
	          clickUnselectsDay = _props5.clickUnselectsDay,
	          dayPickerProps = _props5.dayPickerProps,
	          onDayChange = _props5.onDayChange,
	          formatDate = _props5.formatDate,
	          format = _props5.format;
	
	      if (dayPickerProps.onDayClick) {
	        dayPickerProps.onDayClick(day, modifiers, e);
	      }
	
	      // Do nothing if the day is disabled
	      if (modifiers.disabled || dayPickerProps && dayPickerProps.classNames && modifiers[dayPickerProps.classNames.disabled]) {
	        return;
	      }
	
	      // If the clicked day is already selected, remove the clicked day
	      // from the selected days and empty the field value
	      if (modifiers.selected && clickUnselectsDay) {
	        var selectedDays = this.state.selectedDays;
	
	        if (Array.isArray(selectedDays)) {
	          selectedDays = selectedDays.slice(0);
	          var selectedDayIdx = selectedDays.indexOf(day);
	          selectedDays.splice(selectedDayIdx, 1);
	        } else if (selectedDays) {
	          selectedDays = null;
	        }
	
	        this.setState({ value: '', typedValue: '', selectedDays: selectedDays }, this.hideAfterDayClick);
	
	        if (onDayChange) {
	          onDayChange(undefined, modifiers, this);
	        }
	        return;
	      }
	
	      var value = formatDate(day, format, dayPickerProps.locale);
	      this.setState({ value: value, typedValue: '', month: day }, function () {
	        if (onDayChange) {
	          onDayChange(day, modifiers, _this10);
	        }
	        _this10.hideAfterDayClick();
	      });
	    }
	  }, {
	    key: 'renderOverlay',
	    value: function renderOverlay() {
	      var _this11 = this;
	
	      var _props6 = this.props,
	          classNames = _props6.classNames,
	          dayPickerProps = _props6.dayPickerProps,
	          parseDate = _props6.parseDate,
	          formatDate = _props6.formatDate,
	          format = _props6.format;
	      var _state2 = this.state,
	          selectedDays = _state2.selectedDays,
	          value = _state2.value;
	
	      var selectedDay = void 0;
	      if (!selectedDays && value) {
	        var day = parseDate(value, format, dayPickerProps.locale);
	        if (day) {
	          selectedDay = day;
	        }
	      } else if (selectedDays) {
	        selectedDay = selectedDays;
	      }
	      var onTodayButtonClick = void 0;
	      if (dayPickerProps.todayButton) {
	        // Set the current day when clicking the today button
	        onTodayButtonClick = function onTodayButtonClick() {
	          return _this11.updateState(new Date(), formatDate(new Date(), format, dayPickerProps.locale), _this11.hideAfterDayClick);
	        };
	      }
	      var Overlay = this.props.overlayComponent;
	      return _react2.default.createElement(
	        Overlay,
	        {
	          classNames: classNames,
	          month: this.state.month,
	          selectedDay: selectedDay,
	          input: this.input,
	          tabIndex: 0 // tabIndex is necessary to catch focus/blur events on Safari
	          , onFocus: this.handleOverlayFocus,
	          onBlur: this.handleOverlayBlur
	        },
	        _react2.default.createElement(_DayPicker2.default, _extends({
	          ref: function ref(el) {
	            return _this11.daypicker = el;
	          },
	          onTodayButtonClick: onTodayButtonClick
	        }, dayPickerProps, {
	          month: this.state.month,
	          selectedDays: selectedDay,
	          onDayClick: this.handleDayClick,
	          onMonthChange: this.handleMonthChange
	        }))
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this12 = this;
	
	      var Input = this.props.component;
	      var inputProps = this.props.inputProps;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.classNames.container, style: this.props.style },
	        _react2.default.createElement(Input, _extends({
	          ref: function ref(el) {
	            return _this12.input = el;
	          },
	          placeholder: this.props.placeholder
	        }, inputProps, {
	          value: this.state.value || this.state.typedValue,
	          onChange: this.handleInputChange,
	          onFocus: this.handleInputFocus,
	          onBlur: this.handleInputBlur,
	          onKeyDown: this.handleInputKeyDown,
	          onKeyUp: this.handleInputKeyUp,
	          onClick: !inputProps.disabled ? this.handleInputClick : undefined
	        })),
	        this.state.showOverlay && this.renderOverlay()
	      );
	    }
	  }]);
	
	  return DayPickerInput;
	}(_react2.default.Component);
	
	DayPickerInput.propTypes = {
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	  inputProps: _propTypes2.default.object,
	  placeholder: _propTypes2.default.string,
	
	  format: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	
	  formatDate: _propTypes2.default.func,
	  parseDate: _propTypes2.default.func,
	  typedValue: _propTypes2.default.string,
	
	  showOverlay: _propTypes2.default.bool,
	  dayPickerProps: _propTypes2.default.object,
	  hideOnDayClick: _propTypes2.default.bool,
	  clickUnselectsDay: _propTypes2.default.bool,
	  keepFocus: _propTypes2.default.bool,
	  component: _propTypes2.default.any,
	  overlayComponent: _propTypes2.default.any,
	
	  style: _propTypes2.default.object,
	  classNames: _propTypes2.default.shape({
	    container: _propTypes2.default.string,
	    overlayWrapper: _propTypes2.default.string,
	    overlay: _propTypes2.default.string.isRequired
	  }),
	
	  onDayChange: _propTypes2.default.func,
	  onDayPickerHide: _propTypes2.default.func,
	  onDayPickerShow: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  onKeyUp: _propTypes2.default.func
	};
	DayPickerInput.defaultProps = {
	  dayPickerProps: {},
	  value: '',
	  typedValue: '',
	  placeholder: 'YYYY-M-D',
	  format: 'L',
	  formatDate: defaultFormat,
	  parseDate: defaultParse,
	  showOverlay: false,
	  hideOnDayClick: true,
	  clickUnselectsDay: false,
	  keepFocus: true,
	  component: 'input',
	  inputProps: {},
	  overlayComponent: OverlayComponent,
	  classNames: {
	    container: 'DayPickerInput',
	    overlayWrapper: 'DayPickerInput-OverlayWrapper',
	    overlay: 'DayPickerInput-Overlay'
	  }
	};
	exports.default = DayPickerInput;
	//# sourceMappingURL=DayPickerInput.js.map

/***/ },
/* 3267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(182);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Weekdays = __webpack_require__(3270);
	
	var _Weekdays2 = _interopRequireDefault(_Weekdays);
	
	var _Day = __webpack_require__(3264);
	
	var _Day2 = _interopRequireDefault(_Day);
	
	var _keys = __webpack_require__(319);
	
	var _ModifiersUtils = __webpack_require__(706);
	
	var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);
	
	var _Helpers = __webpack_require__(446);
	
	var Helpers = _interopRequireWildcard(_Helpers);
	
	var _DateUtils = __webpack_require__(258);
	
	var DateUtils = _interopRequireWildcard(_DateUtils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Month = function (_Component) {
	  _inherits(Month, _Component);
	
	  function Month() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
	      var monthNumber = _this.props.month.getMonth();
	      var propModifiers = Helpers.getModifiersFromProps(_this.props);
	      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
	      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
	        dayModifiers.push(_this.props.classNames.today);
	      }
	      if (day.getMonth() !== monthNumber) {
	        dayModifiers.push(_this.props.classNames.outside);
	      }
	
	      var isOutside = day.getMonth() !== monthNumber;
	      var tabIndex = -1;
	      // Focus on the first day of the month
	      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
	        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
	      }
	      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
	      var modifiers = {};
	      dayModifiers.forEach(function (modifier) {
	        modifiers[modifier] = true;
	      });
	
	      return _react2.default.createElement(
	        _Day2.default,
	        {
	          key: '' + (isOutside ? 'outside-' : '') + key,
	          classNames: _this.props.classNames,
	          day: day,
	          modifiers: modifiers,
	          modifiersStyles: _this.props.modifiersStyles,
	          empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
	          tabIndex: tabIndex,
	          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
	          ariaDisabled: isOutside || dayModifiers.indexOf(_this.props.classNames.disabled) > -1,
	          ariaSelected: dayModifiers.indexOf(_this.props.classNames.selected) > -1,
	          onClick: _this.props.onDayClick,
	          onFocus: _this.props.onDayFocus,
	          onKeyDown: _this.props.onDayKeyDown,
	          onMouseEnter: _this.props.onDayMouseEnter,
	          onMouseLeave: _this.props.onDayMouseLeave,
	          onMouseDown: _this.props.onDayMouseDown,
	          onMouseUp: _this.props.onDayMouseUp,
	          onTouchEnd: _this.props.onDayTouchEnd,
	          onTouchStart: _this.props.onDayTouchStart
	        },
	        _this.props.renderDay(day, modifiers)
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Month, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          classNames = _props.classNames,
	          month = _props.month,
	          months = _props.months,
	          fixedWeeks = _props.fixedWeeks,
	          captionElement = _props.captionElement,
	          weekdayElement = _props.weekdayElement,
	          locale = _props.locale,
	          localeUtils = _props.localeUtils,
	          weekdaysLong = _props.weekdaysLong,
	          weekdaysShort = _props.weekdaysShort,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          onCaptionClick = _props.onCaptionClick,
	          showWeekNumbers = _props.showWeekNumbers,
	          showWeekDays = _props.showWeekDays,
	          onWeekClick = _props.onWeekClick;
	
	
	      var captionProps = {
	        date: month,
	        classNames: classNames,
	        months: months,
	        localeUtils: localeUtils,
	        locale: locale,
	        onClick: onCaptionClick ? function (e) {
	          return onCaptionClick(month, e);
	        } : undefined
	      };
	      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);
	
	      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.month, role: 'grid' },
	        caption,
	        showWeekDays && _react2.default.createElement(_Weekdays2.default, {
	          classNames: classNames,
	          weekdaysShort: weekdaysShort,
	          weekdaysLong: weekdaysLong,
	          firstDayOfWeek: firstDayOfWeek,
	          showWeekNumbers: showWeekNumbers,
	          locale: locale,
	          localeUtils: localeUtils,
	          weekdayElement: weekdayElement
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: classNames.body, role: 'rowgroup' },
	          weeks.map(function (week) {
	            var weekNumber = void 0;
	            if (showWeekNumbers) {
	              weekNumber = DateUtils.getWeekNumber(week[6]);
	            }
	            return _react2.default.createElement(
	              'div',
	              {
	                key: week[0].getTime(),
	                className: classNames.week,
	                role: 'row'
	              },
	              showWeekNumbers && _react2.default.createElement(
	                'div',
	                {
	                  className: classNames.weekNumber,
	                  tabIndex: onWeekClick ? 0 : -1,
	                  role: 'gridcell',
	                  onClick: onWeekClick ? function (e) {
	                    return onWeekClick(weekNumber, week, e);
	                  } : undefined,
	                  onKeyUp: onWeekClick ? function (e) {
	                    return e.keyCode === _keys.ENTER && onWeekClick(weekNumber, week, e);
	                  } : undefined
	                },
	                _this2.props.renderWeek(weekNumber, week, month)
	              ),
	              week.map(_this2.renderDay)
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return Month;
	}(_react.Component);
	
	Month.propTypes = {
	  classNames: _propTypes2.default.shape({
	    body: _propTypes2.default.string.isRequired,
	    month: _propTypes2.default.string.isRequired,
	    outside: _propTypes2.default.string.isRequired,
	    today: _propTypes2.default.string.isRequired,
	    week: _propTypes2.default.string.isRequired,
	    weekNumber: _propTypes2.default.string.isRequired,
	    disabled: _propTypes2.default.string.isRequired,
	    selected: _propTypes2.default.string.isRequired
	  }).isRequired,
	  tabIndex: _propTypes2.default.number,
	
	  month: _propTypes2.default.instanceOf(Date).isRequired,
	  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
	  modifiersStyles: _propTypes2.default.object,
	
	  showWeekDays: _propTypes2.default.bool,
	  showOutsideDays: _propTypes2.default.bool,
	
	  renderDay: _propTypes2.default.func.isRequired,
	  renderWeek: _propTypes2.default.func.isRequired,
	
	  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
	  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),
	
	  fixedWeeks: _propTypes2.default.bool,
	  showWeekNumbers: _propTypes2.default.bool,
	
	  locale: _propTypes2.default.string.isRequired,
	  localeUtils: _propTypes2.default.object.isRequired,
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  firstDayOfWeek: _propTypes2.default.number.isRequired,
	
	  onCaptionClick: _propTypes2.default.func,
	  onDayClick: _propTypes2.default.func,
	  onDayFocus: _propTypes2.default.func,
	  onDayKeyDown: _propTypes2.default.func,
	  onDayMouseEnter: _propTypes2.default.func,
	  onDayMouseLeave: _propTypes2.default.func,
	  onDayMouseDown: _propTypes2.default.func,
	  onDayMouseUp: _propTypes2.default.func,
	  onDayTouchEnd: _propTypes2.default.func,
	  onDayTouchStart: _propTypes2.default.func,
	  onWeekClick: _propTypes2.default.func
	};
	exports.default = Month;
	//# sourceMappingURL=Month.js.map

/***/ },
/* 3268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(182);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classNames = __webpack_require__(447);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	var _keys = __webpack_require__(319);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navbar = function (_Component) {
	  _inherits(Navbar, _Component);
	
	  function Navbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Navbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
	      if (_this.props.onNextClick) {
	        _this.props.onNextClick();
	      }
	    }, _this.handlePreviousClick = function () {
	      if (_this.props.onPreviousClick) {
	        _this.props.onPreviousClick();
	      }
	    }, _this.handleNextKeyDown = function (e) {
	      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
	        return;
	      }
	      e.preventDefault();
	      _this.handleNextClick();
	    }, _this.handlePreviousKeyDown = function (e) {
	      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
	        return;
	      }
	      e.preventDefault();
	      _this.handlePreviousClick();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Navbar, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          className = _props.className,
	          showPreviousButton = _props.showPreviousButton,
	          showNextButton = _props.showNextButton,
	          labels = _props.labels,
	          dir = _props.dir;
	
	
	      var previousClickHandler = void 0;
	      var nextClickHandler = void 0;
	      var previousKeyDownHandler = void 0;
	      var nextKeyDownHandler = void 0;
	      var shouldShowPrevious = void 0;
	      var shouldShowNext = void 0;
	
	      if (dir === 'rtl') {
	        previousClickHandler = this.handleNextClick;
	        nextClickHandler = this.handlePreviousClick;
	        previousKeyDownHandler = this.handleNextKeyDown;
	        nextKeyDownHandler = this.handlePreviousKeyDown;
	        shouldShowNext = showPreviousButton;
	        shouldShowPrevious = showNextButton;
	      } else {
	        previousClickHandler = this.handlePreviousClick;
	        nextClickHandler = this.handleNextClick;
	        previousKeyDownHandler = this.handlePreviousKeyDown;
	        nextKeyDownHandler = this.handleNextKeyDown;
	        shouldShowNext = showNextButton;
	        shouldShowPrevious = showPreviousButton;
	      }
	
	      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;
	
	      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;
	
	      var previousButton = _react2.default.createElement('span', {
	        tabIndex: '0',
	        role: 'button',
	        'aria-label': labels.previousMonth,
	        key: 'previous',
	        className: previousClassName,
	        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
	        onClick: shouldShowPrevious ? previousClickHandler : undefined
	      });
	
	      var nextButton = _react2.default.createElement('span', {
	        tabIndex: '0',
	        role: 'button',
	        'aria-label': labels.nextMonth,
	        key: 'right',
	        className: nextClassName,
	        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
	        onClick: shouldShowNext ? nextClickHandler : undefined
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className || classNames.navBar },
	        dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
	      );
	    }
	  }]);
	
	  return Navbar;
	}(_react.Component);
	
	Navbar.propTypes = {
	  classNames: _propTypes2.default.shape({
	    navBar: _propTypes2.default.string.isRequired,
	    navButtonPrev: _propTypes2.default.string.isRequired,
	    navButtonNext: _propTypes2.default.string.isRequired,
	    navButtonInteractionDisabled: _propTypes2.default.string.isRequired
	  }),
	  className: _propTypes2.default.string,
	  showPreviousButton: _propTypes2.default.bool,
	  showNextButton: _propTypes2.default.bool,
	  onPreviousClick: _propTypes2.default.func,
	  onNextClick: _propTypes2.default.func,
	  dir: _propTypes2.default.string,
	  labels: _propTypes2.default.shape({
	    previousMonth: _propTypes2.default.string.isRequired,
	    nextMonth: _propTypes2.default.string.isRequired
	  })
	};
	Navbar.defaultProps = {
	  classNames: _classNames2.default,
	  dir: 'ltr',
	  labels: {
	    previousMonth: 'Previous Month',
	    nextMonth: 'Next Month'
	  },
	  showPreviousButton: true,
	  showNextButton: true
	};
	exports.default = Navbar;
	//# sourceMappingURL=Navbar.js.map

/***/ },
/* 3269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(182);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Weekday = function (_Component) {
	  _inherits(Weekday, _Component);
	
	  function Weekday() {
	    _classCallCheck(this, Weekday);
	
	    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
	  }
	
	  _createClass(Weekday, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props !== nextProps;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          weekday = _props.weekday,
	          className = _props.className,
	          weekdaysLong = _props.weekdaysLong,
	          weekdaysShort = _props.weekdaysShort,
	          localeUtils = _props.localeUtils,
	          locale = _props.locale;
	
	      var title = void 0;
	      if (weekdaysLong) {
	        title = weekdaysLong[weekday];
	      } else {
	        title = localeUtils.formatWeekdayLong(weekday, locale);
	      }
	      var content = void 0;
	      if (weekdaysShort) {
	        content = weekdaysShort[weekday];
	      } else {
	        content = localeUtils.formatWeekdayShort(weekday, locale);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, role: 'columnheader' },
	        _react2.default.createElement(
	          'abbr',
	          { title: title },
	          content
	        )
	      );
	    }
	  }]);
	
	  return Weekday;
	}(_react.Component);
	
	Weekday.propTypes = {
	  weekday: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  locale: _propTypes2.default.string,
	  localeUtils: _propTypes2.default.object,
	
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	exports.default = Weekday;
	//# sourceMappingURL=Weekday.js.map

/***/ },
/* 3270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(182);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Weekdays = function (_Component) {
	  _inherits(Weekdays, _Component);
	
	  function Weekdays() {
	    _classCallCheck(this, Weekdays);
	
	    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
	  }
	
	  _createClass(Weekdays, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props !== nextProps;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          showWeekNumbers = _props.showWeekNumbers,
	          weekdaysLong = _props.weekdaysLong,
	          weekdaysShort = _props.weekdaysShort,
	          locale = _props.locale,
	          localeUtils = _props.localeUtils,
	          weekdayElement = _props.weekdayElement;
	
	      var days = [];
	      for (var i = 0; i < 7; i += 1) {
	        var weekday = (i + firstDayOfWeek) % 7;
	        var elementProps = {
	          key: i,
	          className: classNames.weekday,
	          weekday: weekday,
	          weekdaysLong: weekdaysLong,
	          weekdaysShort: weekdaysShort,
	          localeUtils: localeUtils,
	          locale: locale
	        };
	        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
	        days.push(element);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.weekdays, role: 'rowgroup' },
	        _react2.default.createElement(
	          'div',
	          { className: classNames.weekdaysRow, role: 'row' },
	          showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
	          days
	        )
	      );
	    }
	  }]);
	
	  return Weekdays;
	}(_react.Component);
	
	Weekdays.propTypes = {
	  classNames: _propTypes2.default.shape({
	    weekday: _propTypes2.default.string.isRequired,
	    weekdays: _propTypes2.default.string.isRequired,
	    weekdaysRow: _propTypes2.default.string.isRequired
	  }).isRequired,
	
	  firstDayOfWeek: _propTypes2.default.number.isRequired,
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  showWeekNumbers: _propTypes2.default.bool,
	  locale: _propTypes2.default.string.isRequired,
	  localeUtils: _propTypes2.default.object.isRequired,
	  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
	};
	exports.default = Weekdays;
	//# sourceMappingURL=Weekdays.js.map

/***/ },
/* 3271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDay = formatDay;
	exports.formatMonthTitle = formatMonthTitle;
	exports.formatWeekdayShort = formatWeekdayShort;
	exports.formatWeekdayLong = formatWeekdayLong;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getMonths = getMonths;
	exports.formatDate = formatDate;
	exports.parseDate = parseDate;
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatDay(day) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	  return (0, _moment2.default)(day).locale(locale).format('ddd ll');
	} /* eslint-disable import/no-extraneous-dependencies, no-underscore-dangle */
	
	function formatMonthTitle(date) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	  return (0, _moment2.default)(date).locale(locale).format('MMMM YYYY');
	}
	
	function formatWeekdayShort(day) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	  return _moment2.default.localeData(locale).weekdaysMin()[day];
	}
	
	function formatWeekdayLong(day) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	  return _moment2.default.localeData(locale).weekdays()[day];
	}
	
	function getFirstDayOfWeek() {
	  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
	
	  return _moment2.default.localeData(locale).firstDayOfWeek();
	}
	
	function getMonths() {
	  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
	
	  return _moment2.default.localeData(locale).months();
	}
	
	function formatDate(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
	  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
	
	  return (0, _moment2.default)(date).locale(locale).format(Array.isArray(format) ? format[0] : format);
	}
	
	function parseDate(str) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
	  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
	
	  var m = (0, _moment2.default)(str, format, locale, true);
	  if (m.isValid()) {
	    return m.toDate();
	  }
	  return undefined;
	}
	
	exports.default = {
	  formatDay: formatDay,
	  formatMonthTitle: formatMonthTitle,
	  formatWeekdayShort: formatWeekdayShort,
	  formatWeekdayLong: formatWeekdayLong,
	  getFirstDayOfWeek: getFirstDayOfWeek,
	  getMonths: getMonths,
	  formatDate: formatDate,
	  parseDate: parseDate
	};
	//# sourceMappingURL=MomentLocaleUtils.js.map

/***/ },
/* 3272 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3271);


/***/ },
/* 3273 */
[4448, 3274],
/* 3274 */
2788,
/* 3275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var onElementResize = __webpack_require__(2888);
	
	var defaultContainerStyle = {
	  width: '100%',
	  height: '100%',
	  padding: 0,
	  border: 0
	};
	
	function defaultGetWidth(element) {
	  return element.clientWidth;
	}
	
	function defaultGetHeight(element) {
	  return element.clientHeight;
	}
	
	/**
	 * Wraps a react component and adds properties `containerHeight` and
	 * `containerWidth`. Useful for responsive design. Properties update on
	 * window resize. **Note** that the parent element must have either a
	 * height or a width, or nothing will be rendered
	 *
	 * Can be used as a
	 * [higher-order component](http://babeljs.io/blog/2015/06/07/react-on-es6-plus/#property-initializers)
	 * or as an [ES7 class decorator](https://github.com/wycats/javascript-decorators)
	 * (see examples)
	 *
	 * @param {object} [options]
	 * @param {function} [options.getHeight] A function that is passed an element and returns element
	 * height, where element is the wrapper div. Defaults to `(element) => element.clientHeight`
	 * @param {function} [options.getWidth]  A function that is passed an element and returns element
	 * width, where element is the wrapper div. Defaults to `(element) => element.clientWidth`
	 * @param {object} [options.containerStyle] A style object for the `<div>` that will wrap your component.
	 * The dimensions of this `div` are what are passed as props to your component. The default style is
	 * `{ width: '100%', height: '100%', padding: 0, border: 0 }` which will cause the `div` to fill its
	 * parent in most cases. If you are using a flexbox layout you will want to change this default style.
	 * @param {string} [options.className] Control the class name set on the wrapper `<div>`
	 * @param {boolean} [options.elementResize=false] Set true to watch the wrapper `div` for changes in
	 * size which are not a result of window resizing - e.g. changes to the flexbox and other layout.
	 * @return {function}                   A higher-order component that can be
	 * used to enhance a react component `Dimensions()(MyComponent)`
	 *
	 * @example
	 * // ES2015
	 * import React from 'react'
	 * import Dimensions from 'react-dimensions'
	 *
	 * class MyComponent extends React.Component {
	 *   render() (
	 *     <div
	 *       containerWidth={this.props.containerWidth}
	 *       containerHeight={this.props.containerHeight}
	 *     >
	 *     </div>
	 *   )
	 * }
	 *
	 * export default Dimensions()(MyComponent) // Enhanced component
	 *
	 * @example
	 * // ES5
	 * var React = require('react')
	 * var Dimensions = require('react-dimensions')
	 *
	 * var MyComponent = React.createClass({
	 *   render: function() {(
	 *     <div
	 *       containerWidth={this.props.containerWidth}
	 *       containerHeight={this.props.containerHeight}
	 *     >
	 *     </div>
	 *   )}
	 * }
	 *
	 * module.exports = Dimensions()(MyComponent) // Enhanced component
	 *
	 */
	module.exports = function Dimensions() {
	  var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var _ref$getHeight = _ref.getHeight;
	  var getHeight = _ref$getHeight === undefined ? defaultGetHeight : _ref$getHeight;
	  var _ref$getWidth = _ref.getWidth;
	  var getWidth = _ref$getWidth === undefined ? defaultGetWidth : _ref$getWidth;
	  var _ref$containerStyle = _ref.containerStyle;
	  var containerStyle = _ref$containerStyle === undefined ? defaultContainerStyle : _ref$containerStyle;
	  var _ref$className = _ref.className;
	  var className = _ref$className === undefined ? null : _ref$className;
	  var _ref$elementResize = _ref.elementResize;
	  var elementResize = _ref$elementResize === undefined ? false : _ref$elementResize;
	
	  return function (ComposedComponent) {
	    return function (_React$Component) {
	      _inherits(DimensionsHOC, _React$Component);
	
	      function DimensionsHOC() {
	        var _Object$getPrototypeO;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, DimensionsHOC);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(DimensionsHOC)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {}, _this.updateDimensions = function () {
	          var container = _this.refs.container;
	          var containerWidth = getWidth(container);
	          var containerHeight = getHeight(container);
	
	          if (containerWidth !== _this.state.containerWidth || containerHeight !== _this.state.containerHeight) {
	            _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
	          }
	        }, _this.onResize = function () {
	          if (_this.rqf) return;
	          _this.rqf = _this.getWindow().requestAnimationFrame(function () {
	            _this.rqf = null;
	            _this.updateDimensions();
	          });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	      // ES7 Class properties
	      // http://babeljs.io/blog/2015/06/07/react-on-es6-plus/#property-initializers
	
	
	      // Using arrow functions and ES7 Class properties to autobind
	      // http://babeljs.io/blog/2015/06/07/react-on-es6-plus/#arrow-functions
	
	
	      _createClass(DimensionsHOC, [{
	        key: 'getWindow',
	
	
	        // If the component is mounted in a different window to the javascript
	        // context, as with https://github.com/JakeGinnivan/react-popout
	        // then the `window` global will be different from the `window` that
	        // contains the component.
	        // Depends on `defaultView` which is not supported <IE9
	        value: function getWindow() {
	          return this.refs.container ? this.refs.container.ownerDocument.defaultView || window : window;
	        }
	      }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          if (!this.refs.container) {
	            throw new Error('Cannot find container div');
	          }
	          this.updateDimensions();
	          if (elementResize) {
	            // Experimental: `element-resize-event` fires when an element resizes.
	            // It attaches its own window resize listener and also uses
	            // requestAnimationFrame, so we can just call `this.updateDimensions`.
	            onElementResize(this.refs.container, this.updateDimensions);
	          } else {
	            this.getWindow().addEventListener('resize', this.onResize, false);
	          }
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.getWindow().removeEventListener('resize', this.onResize);
	        }
	
	        /**
	         * Returns the underlying wrapped component instance.
	         * Useful if you need to access a method or property of the component
	         * passed to react-dimensions.
	         *
	         * @return {object} The rendered React component
	         **/
	
	      }, {
	        key: 'getWrappedInstance',
	        value: function getWrappedInstance() {
	          this.refs.wrappedInstance;
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _state = this.state;
	          var containerWidth = _state.containerWidth;
	          var containerHeight = _state.containerHeight;
	
	          if (!containerWidth && !containerHeight) {
	            console.warn('Wrapper div has no height or width, try overriding style with `containerStyle` option');
	          }
	          return React.createElement(
	            'div',
	            { className: className, style: containerStyle, ref: 'container' },
	            (containerWidth || containerHeight) && React.createElement(ComposedComponent, _extends({}, this.state, this.props, {
	              updateDimensions: this.updateDimensions,
	              ref: 'wrappedInstance'
	            }))
	          );
	        }
	      }]);
	
	      return DimensionsHOC;
	    }(React.Component);
	  };
	};


/***/ },
/* 3276 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 3277 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(60);
	
	var focusNode = __webpack_require__(1282);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 3278 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(321);
	var ExecutionEnvironment = __webpack_require__(89);
	var FallbackCompositionState = __webpack_require__(3284);
	var SyntheticCompositionEvent = __webpack_require__(3318);
	var SyntheticInputEvent = __webpack_require__(3321);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 3279 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(1505);
	var ExecutionEnvironment = __webpack_require__(89);
	var ReactInstrumentation = __webpack_require__(113);
	
	var camelizeStyleName = __webpack_require__(2913);
	var dangerousStyleValue = __webpack_require__(3327);
	var hyphenateStyleName = __webpack_require__(2920);
	var memoizeStringOnly = __webpack_require__(2923);
	var warning = __webpack_require__(41);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 3280 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(320);
	var EventPropagators = __webpack_require__(321);
	var ExecutionEnvironment = __webpack_require__(89);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactUpdates = __webpack_require__(125);
	var SyntheticEvent = __webpack_require__(155);
	
	var inputValueTracking = __webpack_require__(1527);
	var getEventTarget = __webpack_require__(719);
	var isEventSupported = __webpack_require__(721);
	var isTextInputElement = __webpack_require__(1528);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 3281 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var DOMLazyTree = __webpack_require__(259);
	var ExecutionEnvironment = __webpack_require__(89);
	
	var createNodesFromMarkup = __webpack_require__(2916);
	var emptyFunction = __webpack_require__(110);
	var invariant = __webpack_require__(36);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 3282 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 3283 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(321);
	var ReactDOMComponentTree = __webpack_require__(60);
	var SyntheticMouseEvent = __webpack_require__(449);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 3284 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var PooledClass = __webpack_require__(213);
	
	var getTextContentAccessor = __webpack_require__(1526);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 3285 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(260);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 3286 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(214);
	
	var instantiateReactComponent = __webpack_require__(720);
	var KeyEscapeUtils = __webpack_require__(711);
	var shouldUpdateReactComponent = __webpack_require__(722);
	var traverseAllChildren = __webpack_require__(1530);
	var warning = __webpack_require__(41);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(1585);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 3287 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(707);
	var ReactDOMIDOperations = __webpack_require__(3293);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 3288 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(45);
	
	var React = __webpack_require__(217);
	var ReactComponentEnvironment = __webpack_require__(713);
	var ReactCurrentOwner = __webpack_require__(159);
	var ReactErrorUtils = __webpack_require__(714);
	var ReactInstanceMap = __webpack_require__(322);
	var ReactInstrumentation = __webpack_require__(113);
	var ReactNodeTypes = __webpack_require__(1519);
	var ReactReconciler = __webpack_require__(214);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(248);
	var invariant = __webpack_require__(36);
	var shallowEqual = __webpack_require__(208);
	var shouldUpdateReactComponent = __webpack_require__(722);
	var warning = __webpack_require__(41);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 3289 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactDefaultInjection = __webpack_require__(1512);
	var ReactMount = __webpack_require__(1518);
	var ReactReconciler = __webpack_require__(214);
	var ReactUpdates = __webpack_require__(125);
	var ReactVersion = __webpack_require__(1521);
	
	var findDOMNode = __webpack_require__(3328);
	var getHostComponentFromComposite = __webpack_require__(1525);
	var renderSubtreeIntoContainer = __webpack_require__(3335);
	var warning = __webpack_require__(41);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 3290 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(45);
	
	var AutoFocusUtils = __webpack_require__(3277);
	var CSSPropertyOperations = __webpack_require__(3279);
	var DOMLazyTree = __webpack_require__(259);
	var DOMNamespaces = __webpack_require__(708);
	var DOMProperty = __webpack_require__(260);
	var DOMPropertyOperations = __webpack_require__(1507);
	var EventPluginHub = __webpack_require__(320);
	var EventPluginRegistry = __webpack_require__(709);
	var ReactBrowserEventEmitter = __webpack_require__(448);
	var ReactDOMComponentFlags = __webpack_require__(1508);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactDOMInput = __webpack_require__(3294);
	var ReactDOMOption = __webpack_require__(3295);
	var ReactDOMSelect = __webpack_require__(1510);
	var ReactDOMTextarea = __webpack_require__(3299);
	var ReactInstrumentation = __webpack_require__(113);
	var ReactMultiChild = __webpack_require__(3305);
	var ReactServerRenderingTransaction = __webpack_require__(1520);
	
	var emptyFunction = __webpack_require__(110);
	var escapeTextContentForBrowser = __webpack_require__(451);
	var invariant = __webpack_require__(36);
	var isEventSupported = __webpack_require__(721);
	var shallowEqual = __webpack_require__(208);
	var inputValueTracking = __webpack_require__(1527);
	var validateDOMNesting = __webpack_require__(723);
	var warning = __webpack_require__(41);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 3291 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var DOMLazyTree = __webpack_require__(259);
	var ReactDOMComponentTree = __webpack_require__(60);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 3292 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 3293 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(707);
	var ReactDOMComponentTree = __webpack_require__(60);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 3294 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(45);
	
	var DOMPropertyOperations = __webpack_require__(1507);
	var LinkedValueUtils = __webpack_require__(712);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactUpdates = __webpack_require__(125);
	
	var invariant = __webpack_require__(36);
	var warning = __webpack_require__(41);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 3295 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var React = __webpack_require__(217);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactDOMSelect = __webpack_require__(1510);
	
	var warning = __webpack_require__(41);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 3296 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(89);
	
	var getNodeForCharacterOffset = __webpack_require__(3332);
	var getTextContentAccessor = __webpack_require__(1526);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 3297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(1512);
	var ReactServerRendering = __webpack_require__(3311);
	var ReactVersion = __webpack_require__(1521);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 3298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(45);
	
	var DOMChildrenOperations = __webpack_require__(707);
	var DOMLazyTree = __webpack_require__(259);
	var ReactDOMComponentTree = __webpack_require__(60);
	
	var escapeTextContentForBrowser = __webpack_require__(451);
	var invariant = __webpack_require__(36);
	var validateDOMNesting = __webpack_require__(723);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 3299 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(45);
	
	var LinkedValueUtils = __webpack_require__(712);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactUpdates = __webpack_require__(125);
	
	var invariant = __webpack_require__(36);
	var warning = __webpack_require__(41);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 3300 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(36);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 3301 */
1586,
/* 3302 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(320);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 3303 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var EventListener = __webpack_require__(1281);
	var ExecutionEnvironment = __webpack_require__(89);
	var PooledClass = __webpack_require__(213);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactUpdates = __webpack_require__(125);
	
	var getEventTarget = __webpack_require__(719);
	var getUnboundedScrollPosition = __webpack_require__(2918);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 3304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(260);
	var EventPluginHub = __webpack_require__(320);
	var EventPluginUtils = __webpack_require__(710);
	var ReactComponentEnvironment = __webpack_require__(713);
	var ReactEmptyComponent = __webpack_require__(1513);
	var ReactBrowserEventEmitter = __webpack_require__(448);
	var ReactHostComponent = __webpack_require__(1515);
	var ReactUpdates = __webpack_require__(125);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 3305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var ReactComponentEnvironment = __webpack_require__(713);
	var ReactInstanceMap = __webpack_require__(322);
	var ReactInstrumentation = __webpack_require__(113);
	
	var ReactCurrentOwner = __webpack_require__(159);
	var ReactReconciler = __webpack_require__(214);
	var ReactChildReconciler = __webpack_require__(3286);
	
	var emptyFunction = __webpack_require__(110);
	var flattenChildren = __webpack_require__(3329);
	var invariant = __webpack_require__(36);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 3306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(36);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 3307 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 3308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var CallbackQueue = __webpack_require__(1506);
	var PooledClass = __webpack_require__(213);
	var ReactBrowserEventEmitter = __webpack_require__(448);
	var ReactInputSelection = __webpack_require__(1516);
	var ReactInstrumentation = __webpack_require__(113);
	var Transaction = __webpack_require__(450);
	var ReactUpdateQueue = __webpack_require__(715);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 3309 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(3306);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 3310 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 3311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var React = __webpack_require__(217);
	var ReactDOMContainerInfo = __webpack_require__(1509);
	var ReactDefaultBatchingStrategy = __webpack_require__(1511);
	var ReactInstrumentation = __webpack_require__(113);
	var ReactMarkupChecksum = __webpack_require__(1517);
	var ReactReconciler = __webpack_require__(214);
	var ReactServerBatchingStrategy = __webpack_require__(3310);
	var ReactServerRenderingTransaction = __webpack_require__(1520);
	var ReactUpdates = __webpack_require__(125);
	
	var emptyObject = __webpack_require__(248);
	var instantiateReactComponent = __webpack_require__(720);
	var invariant = __webpack_require__(36);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 3312 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(715);
	
	var warning = __webpack_require__(41);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 3313 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 3314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(321);
	var ExecutionEnvironment = __webpack_require__(89);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactInputSelection = __webpack_require__(1516);
	var SyntheticEvent = __webpack_require__(155);
	
	var getActiveElement = __webpack_require__(1283);
	var isTextInputElement = __webpack_require__(1528);
	var shallowEqual = __webpack_require__(208);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 3315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var EventListener = __webpack_require__(1281);
	var EventPropagators = __webpack_require__(321);
	var ReactDOMComponentTree = __webpack_require__(60);
	var SyntheticAnimationEvent = __webpack_require__(3316);
	var SyntheticClipboardEvent = __webpack_require__(3317);
	var SyntheticEvent = __webpack_require__(155);
	var SyntheticFocusEvent = __webpack_require__(3320);
	var SyntheticKeyboardEvent = __webpack_require__(3322);
	var SyntheticMouseEvent = __webpack_require__(449);
	var SyntheticDragEvent = __webpack_require__(3319);
	var SyntheticTouchEvent = __webpack_require__(3323);
	var SyntheticTransitionEvent = __webpack_require__(3324);
	var SyntheticUIEvent = __webpack_require__(323);
	var SyntheticWheelEvent = __webpack_require__(3325);
	
	var emptyFunction = __webpack_require__(110);
	var getEventCharCode = __webpack_require__(717);
	var invariant = __webpack_require__(36);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 3316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(155);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 3317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(155);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 3318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(155);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 3319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(449);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 3320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(323);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 3321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(155);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 3322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(323);
	
	var getEventCharCode = __webpack_require__(717);
	var getEventKey = __webpack_require__(3330);
	var getEventModifierState = __webpack_require__(718);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 3323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(323);
	
	var getEventModifierState = __webpack_require__(718);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 3324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(155);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 3325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(449);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 3326 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 3327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(1505);
	var warning = __webpack_require__(41);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 3328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var ReactCurrentOwner = __webpack_require__(159);
	var ReactDOMComponentTree = __webpack_require__(60);
	var ReactInstanceMap = __webpack_require__(322);
	
	var getHostComponentFromComposite = __webpack_require__(1525);
	var invariant = __webpack_require__(36);
	var warning = __webpack_require__(41);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 3329 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(711);
	var traverseAllChildren = __webpack_require__(1530);
	var warning = __webpack_require__(41);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(1585);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 3330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(717);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 3331 */
1589,
/* 3332 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 3333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(89);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 3334 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(451);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 3335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(1518);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 3336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 3337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(3338);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 3338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(3360);
	var assign = __webpack_require__(3340);
	
	var ReactPropTypesSecret = __webpack_require__(3339);
	var checkPropTypes = __webpack_require__(3336);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 3339 */
2788,
/* 3340 */
1808,
/* 3341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(3297);


/***/ },
/* 3342 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3343);


/***/ },
/* 3343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(3349));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3346));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var styles = {
	  allText: {
	    MozUserSelect: 'text',
	    WebkitUserSelect: 'text',
	    msUserSelect: 'text',
	    userSelect: 'text'
	  }
	};
	
	var EllipsisText =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(EllipsisText, _React$Component);
	
	  function EllipsisText(props) {
	    var _this;
	
	    _classCallCheck(this, EllipsisText);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(EllipsisText).call(this, props));
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(EllipsisText, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          text = _this$props.text,
	          length = _this$props.length,
	          tail = _this$props.tail,
	          tailClassName = _this$props.tailClassName,
	          others = _objectWithoutProperties(_this$props, ["text", "length", "tail", "tailClassName"]);
	
	      if (text.length <= this.props.length || this.props.length < 0) {
	        return _react["default"].createElement("span", others, this.props.text);
	      } else {
	        var tailStyle = {
	          cursor: 'auto'
	        };
	        var displayText;
	
	        if (length - tail.length <= 0) {
	          displayText = '';
	        } else {
	          displayText = text.slice(0, length - tail.length);
	        }
	
	        return _react["default"].createElement("span", _extends({
	          title: this.props.text
	        }, others), displayText, _react["default"].createElement("span", {
	          style: tailStyle,
	          className: tailClassName
	        }, tail));
	      }
	    }
	  }]);
	
	  return EllipsisText;
	}(_react["default"].Component);
	
	EllipsisText.propTypes = {
	  text: _propTypes["default"].string.isRequired,
	  length: _propTypes["default"].number.isRequired,
	  tail: _propTypes["default"].string,
	  tailClassName: _propTypes["default"].string
	};
	EllipsisText.defaultProps = {
	  tail: '...',
	  tailClassName: 'more'
	};
	var _default = EllipsisText;
	exports["default"] = _default;

/***/ },
/* 3344 */
1808,
/* 3345 */
[4448, 3347],
/* 3346 */
[4449, 3345],
/* 3347 */
2788,
/* 3348 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(3344),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ },
/* 3349 */
[4584, 3348],
/* 3350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookPlayer = function (_Component) {
	  _inherits(FacebookPlayer, _Component);
	
	  function FacebookPlayer(props) {
	    _classCallCheck(this, FacebookPlayer);
	
	    /**
	     * Set events that will be added to listen list.
	     * REF: https://developers.facebook.com/docs/plugins/embedded-video-player/api#event-reference
	     */
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(FacebookPlayer).call(this, props));
	
	    _this.loadFB = function () {
	      if (window.FB) {
	        return new Promise(function (resolve) {
	          return resolve(window.FB);
	        });
	      }
	
	      return new Promise(function (resolve) {
	        window.fbAsyncInit = function () {
	          return resolve(window.FB);
	        };
	        (function (d, s, id) {
	          var js,
	              fjs = d.getElementsByTagName(s)[0];
	          if (d.getElementById(id)) {
	            return;
	          }
	          js = d.createElement(s);js.id = id;
	          js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.3";
	          js.onload = function () {
	            return resolve(window.FB);
	          };
	          fjs.parentNode.insertBefore(js, fjs);
	        })(document, 'script', 'facebook-jssdk');
	      });
	    };
	
	    _this.createPlayer = function (videoId) {
	      var _this$props = _this.props;
	      var id = _this$props.id;
	      var appId = _this$props.appId;
	      var allowfullscreen = _this$props.allowfullscreen;
	      var autoplay = _this$props.autoplay;
	      var width = _this$props.width;
	      var showText = _this$props.showText;
	      var showCaptions = _this$props.showCaptions;
	      var onReady = _this$props.onReady;
	
	      var FB = _this.FB;
	
	      var playerId = id + '--player';
	
	      // Clear
	      _this.container.innerHTML = '';
	      // this.unsubscribe();
	
	      var playerDiv = document.createElement('div');
	      playerDiv.classList.add('fb-video');
	      playerDiv.id = playerId;
	      playerDiv.setAttribute('data-href', 'https://www.facebook.com/facebook/videos/' + videoId);
	      playerDiv.setAttribute('data-allowfullscreen', allowfullscreen || 'false');
	      playerDiv.setAttribute('data-autoplay', autoplay || 'false');
	      playerDiv.setAttribute('data-width', width || 'auto');
	      playerDiv.setAttribute('data-show-text', showText || 'false');
	      playerDiv.setAttribute('data-show-captions', showCaptions || 'false');
	
	      _this.container.appendChild(playerDiv);
	
	      FB.init({
	        appId: appId,
	        xfbml: true,
	        version: 'v2.5'
	      });
	
	      FB.Event.subscribe('xfbml.ready', function (msg) {
	        window.msg = msg;
	        if (msg.type === 'video' && (id && msg.id === playerId || !id)) {
	          _this.videoPlayer = msg.instance;
	
	          // Dispatch ready event
	          if (onReady) onReady(id, _this.videoPlayer);
	
	          // Subscribe to events
	          _this.subscribe();
	        }
	      });
	    };
	
	    _this.subscribe = function () {
	      _this.eventHandlers = [];
	      _this.eventsToListen.map(function (ev) {
	        if (ev.listener) {
	          var handler = _this.videoPlayer.subscribe(ev.event, ev.listener);
	          _this.eventHandlers.push({
	            event: ev.event,
	            handler: handler
	          });
	        };
	      });
	    };
	
	    _this.unsubscribe = function () {
	      if (_this.eventHandlers && _this.eventHandlers.length) {
	        _this.eventHandlers.map(function (ev) {
	          if (ev.handler.removeListener) ev.handler.removeListener(ev.event);
	        });
	      }
	    };
	
	    _this.refContainer = function (container) {
	      _this.container = container;
	    };
	
	    _this.eventsToListen = [{
	      event: 'startedPlaying',
	      listener: function listener(player) {
	        return _this.props.onStartedPlaying(_this.props.id);
	      }
	    }, {
	      event: 'paused',
	      listener: function listener() {
	        return _this.props.onPaused(_this.props.id);
	      }
	    }, {
	      event: 'finishedPlaying',
	      listener: function listener() {
	        return _this.props.onFinishedPlaying(_this.props.id);
	      }
	    }, {
	      event: 'startedBuffering',
	      listener: function listener() {
	        return _this.props.onStartedBuffering(_this.props.id);
	      }
	    }, {
	      event: 'finishedBuffering',
	      listener: function listener() {
	        return _this.props.onFinishedBuffering(_this.props.id);
	      }
	    }, {
	      event: 'error',
	      listener: function listener() {
	        return _this.props.onError(_this.props.id);
	      }
	    }];
	
	    _this.FB = null;
	    _this.videoPlayer = null;
	    _this.eventHandlers = null;
	    return _this;
	  }
	
	  /**
	   * Load Facebook SDK and set FB to global vars
	   */
	
	
	  _createClass(FacebookPlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var videoId = this.props.videoId;
	
	
	      if (typeof window !== "undefined") {
	        this.loadFB().then(function (res) {
	          if (res) {
	            _this2.FB = res;
	            _this2.createPlayer(videoId);
	          }
	        });
	      }
	    }
	
	    /**
	     * Refresh component if a new video id is set,
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (this.FB && newProps.videoId !== this.props.videoId) {
	        this.createPlayer(newProps.videoId);
	      }
	    }
	
	    /**
	     * Kill all event listeners
	     */
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	    // this.unsubscribe();
	
	
	    /**
	     * Load Facebook SDK if it is not loaded already.
	     */
	
	
	    /**
	     * Create player.
	     *
	     * @param {string} Facebook video id
	     */
	
	
	    /**
	     * Listen to events based on eventsToListen var.
	     */
	
	
	    /**
	     * Stop listening to events.
	     */
	
	
	    /**
	     * Set container var to reuse as DOM object.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var id = _props.id;
	      var className = _props.className;
	
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('div', {
	          id: id,
	          className: className,
	          ref: this.refContainer
	        })
	      );
	    }
	  }]);
	
	  return FacebookPlayer;
	}(_react.Component);
	
	FacebookPlayer.propTypes = {
	  id: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  appId: _react.PropTypes.string.isRequired,
	  videoId: _react.PropTypes.string.isRequired,
	  width: _react.PropTypes.number,
	  allowfullscreen: _react.PropTypes.string,
	  autoplay: _react.PropTypes.string,
	  showText: _react.PropTypes.string,
	  showCaptions: _react.PropTypes.string,
	  onReady: _react.PropTypes.func,
	  onStartedPlaying: _react.PropTypes.func,
	  onPaused: _react.PropTypes.func,
	  onFinishedPlaying: _react.PropTypes.func,
	  onStartedBuffering: _react.PropTypes.func,
	  onFinishedBuffering: _react.PropTypes.func,
	  onError: _react.PropTypes.func
	};
	exports.default = FacebookPlayer;

/***/ },
/* 3351 */
[4448, 3353],
/* 3352 */
[4449, 3351],
/* 3353 */
2788,
/* 3354 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(3526);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(963);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(3355);
	
	var _HelmetConstants = __webpack_require__(1531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ },
/* 3355 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(3356);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(1531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 3356 */
1808,
/* 3357 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1);
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		var _Highlighter = __webpack_require__(2);
		
		var _Highlighter2 = _interopRequireDefault(_Highlighter);
	
		exports['default'] = _Highlighter2['default'];
		module.exports = exports['default'];
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		exports['default'] = Highlighter;
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
		
		var _highlightWordsCore = __webpack_require__(3);
		
		var _propTypes = __webpack_require__(4);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _react = __webpack_require__(14);
		
		var _memoizeOne = __webpack_require__(15);
		
		var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
		
		Highlighter.propTypes = {
		  activeClassName: _propTypes2['default'].string,
		  activeIndex: _propTypes2['default'].number,
		  activeStyle: _propTypes2['default'].object,
		  autoEscape: _propTypes2['default'].bool,
		  className: _propTypes2['default'].string,
		  findChunks: _propTypes2['default'].func,
		  highlightClassName: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
		  highlightStyle: _propTypes2['default'].object,
		  highlightTag: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func, _propTypes2['default'].string]),
		  sanitize: _propTypes2['default'].func,
		  searchWords: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].instanceOf(RegExp)])).isRequired,
		  textToHighlight: _propTypes2['default'].string.isRequired,
		  unhighlightClassName: _propTypes2['default'].string,
		  unhighlightStyle: _propTypes2['default'].object
		};
		
		/**
		 * Highlights all occurrences of search terms (searchText) within a string (textToHighlight).
		 * This function returns an array of strings and <span>s (wrapping highlighted words).
		 */
		
		function Highlighter(_ref) {
		  var _ref$activeClassName = _ref.activeClassName;
		  var activeClassName = _ref$activeClassName === undefined ? '' : _ref$activeClassName;
		  var _ref$activeIndex = _ref.activeIndex;
		  var activeIndex = _ref$activeIndex === undefined ? -1 : _ref$activeIndex;
		  var activeStyle = _ref.activeStyle;
		  var autoEscape = _ref.autoEscape;
		  var _ref$caseSensitive = _ref.caseSensitive;
		  var caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive;
		  var className = _ref.className;
		  var findChunks = _ref.findChunks;
		  var _ref$highlightClassName = _ref.highlightClassName;
		  var highlightClassName = _ref$highlightClassName === undefined ? '' : _ref$highlightClassName;
		  var _ref$highlightStyle = _ref.highlightStyle;
		  var highlightStyle = _ref$highlightStyle === undefined ? {} : _ref$highlightStyle;
		  var _ref$highlightTag = _ref.highlightTag;
		  var highlightTag = _ref$highlightTag === undefined ? 'mark' : _ref$highlightTag;
		  var sanitize = _ref.sanitize;
		  var searchWords = _ref.searchWords;
		  var textToHighlight = _ref.textToHighlight;
		  var _ref$unhighlightClassName = _ref.unhighlightClassName;
		  var unhighlightClassName = _ref$unhighlightClassName === undefined ? '' : _ref$unhighlightClassName;
		  var unhighlightStyle = _ref.unhighlightStyle;
		
		  var rest = _objectWithoutProperties(_ref, ['activeClassName', 'activeIndex', 'activeStyle', 'autoEscape', 'caseSensitive', 'className', 'findChunks', 'highlightClassName', 'highlightStyle', 'highlightTag', 'sanitize', 'searchWords', 'textToHighlight', 'unhighlightClassName', 'unhighlightStyle']);
		
		  var chunks = (0, _highlightWordsCore.findAll)({
		    autoEscape: autoEscape,
		    caseSensitive: caseSensitive,
		    findChunks: findChunks,
		    sanitize: sanitize,
		    searchWords: searchWords,
		    textToHighlight: textToHighlight
		  });
		  var HighlightTag = highlightTag;
		  var highlightIndex = -1;
		  var highlightClassNames = '';
		  var highlightStyles = undefined;
		
		  var lowercaseProps = function lowercaseProps(object) {
		    var mapped = {};
		    for (var key in object) {
		      mapped[key.toLowerCase()] = object[key];
		    }
		    return mapped;
		  };
		  var memoizedLowercaseProps = (0, _memoizeOne2['default'])(lowercaseProps);
		
		  return (0, _react.createElement)('span', _extends({
		    className: className
		  }, rest, {
		    children: chunks.map(function (chunk, index) {
		      var text = textToHighlight.substr(chunk.start, chunk.end - chunk.start);
		
		      if (chunk.highlight) {
		        highlightIndex++;
		
		        var highlightClass = undefined;
		        if (typeof highlightClassName === 'object') {
		          if (!caseSensitive) {
		            highlightClassName = memoizedLowercaseProps(highlightClassName);
		            highlightClass = highlightClassName[text.toLowerCase()];
		          } else {
		            highlightClass = highlightClassName[text];
		          }
		        } else {
		          highlightClass = highlightClassName;
		        }
		
		        var isActive = highlightIndex === +activeIndex;
		
		        highlightClassNames = highlightClass + ' ' + (isActive ? activeClassName : '');
		        highlightStyles = isActive === true && activeStyle != null ? Object.assign({}, highlightStyle, activeStyle) : highlightStyle;
		
		        var props = {
		          children: text,
		          className: highlightClassNames,
		          key: index,
		          style: highlightStyles
		        };
		
		        // Don't attach arbitrary props to DOM elements; this triggers React DEV warnings (https://fb.me/react-unknown-prop)
		        // Only pass through the highlightIndex attribute for custom components.
		        if (typeof HighlightTag !== 'string') {
		          props.highlightIndex = highlightIndex;
		        }
		
		        return (0, _react.createElement)(HighlightTag, props);
		      } else {
		        return (0, _react.createElement)('span', {
		          children: text,
		          className: unhighlightClassName,
		          key: index,
		          style: unhighlightStyle
		        });
		      }
		    })
		  }));
		}
		
		module.exports = exports['default'];
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		module.exports =
		/******/ (function(modules) { // webpackBootstrap
		/******/ 	// The module cache
		/******/ 	var installedModules = {};
		/******/
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
		/******/
		/******/ 		// Check if module is in cache
		/******/ 		if(installedModules[moduleId])
		/******/ 			return installedModules[moduleId].exports;
		/******/
		/******/ 		// Create a new module (and put it into the cache)
		/******/ 		var module = installedModules[moduleId] = {
		/******/ 			exports: {},
		/******/ 			id: moduleId,
		/******/ 			loaded: false
		/******/ 		};
		/******/
		/******/ 		// Execute the module function
		/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
		/******/
		/******/ 		// Flag the module as loaded
		/******/ 		module.loaded = true;
		/******/
		/******/ 		// Return the exports of the module
		/******/ 		return module.exports;
		/******/ 	}
		/******/
		/******/
		/******/ 	// expose the modules object (__webpack_modules__)
		/******/ 	__webpack_require__.m = modules;
		/******/
		/******/ 	// expose the module cache
		/******/ 	__webpack_require__.c = installedModules;
		/******/
		/******/ 	// __webpack_public_path__
		/******/ 	__webpack_require__.p = "";
		/******/
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(0);
		/******/ })
		/************************************************************************/
		/******/ ([
		/* 0 */
		/***/ (function(module, exports, __webpack_require__) {
		
			module.exports = __webpack_require__(1);
		
		
		/***/ }),
		/* 1 */
		/***/ (function(module, exports, __webpack_require__) {
		
			'use strict';
			
			Object.defineProperty(exports, "__esModule", {
			  value: true
			});
			
			var _utils = __webpack_require__(2);
			
			Object.defineProperty(exports, 'combineChunks', {
			  enumerable: true,
			  get: function get() {
			    return _utils.combineChunks;
			  }
			});
			Object.defineProperty(exports, 'fillInChunks', {
			  enumerable: true,
			  get: function get() {
			    return _utils.fillInChunks;
			  }
			});
			Object.defineProperty(exports, 'findAll', {
			  enumerable: true,
			  get: function get() {
			    return _utils.findAll;
			  }
			});
			Object.defineProperty(exports, 'findChunks', {
			  enumerable: true,
			  get: function get() {
			    return _utils.findChunks;
			  }
			});
		
		/***/ }),
		/* 2 */
		/***/ (function(module, exports) {
		
			'use strict';
			
			Object.defineProperty(exports, "__esModule", {
			  value: true
			});
			/**
			 * Creates an array of chunk objects representing both higlightable and non highlightable pieces of text that match each search word.
			 * @return Array of "chunks" (where a Chunk is { start:number, end:number, highlight:boolean })
			 */
			var findAll = exports.findAll = function findAll(_ref) {
			  var autoEscape = _ref.autoEscape,
			      _ref$caseSensitive = _ref.caseSensitive,
			      caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive,
			      _ref$findChunks = _ref.findChunks,
			      findChunks = _ref$findChunks === undefined ? defaultFindChunks : _ref$findChunks,
			      sanitize = _ref.sanitize,
			      searchWords = _ref.searchWords,
			      textToHighlight = _ref.textToHighlight;
			  return fillInChunks({
			    chunksToHighlight: combineChunks({
			      chunks: findChunks({
			        autoEscape: autoEscape,
			        caseSensitive: caseSensitive,
			        sanitize: sanitize,
			        searchWords: searchWords,
			        textToHighlight: textToHighlight
			      })
			    }),
			    totalLength: textToHighlight ? textToHighlight.length : 0
			  });
			};
			
			/**
			 * Takes an array of {start:number, end:number} objects and combines chunks that overlap into single chunks.
			 * @return {start:number, end:number}[]
			 */
			var combineChunks = exports.combineChunks = function combineChunks(_ref2) {
			  var chunks = _ref2.chunks;
			
			  chunks = chunks.sort(function (first, second) {
			    return first.start - second.start;
			  }).reduce(function (processedChunks, nextChunk) {
			    // First chunk just goes straight in the array...
			    if (processedChunks.length === 0) {
			      return [nextChunk];
			    } else {
			      // ... subsequent chunks get checked to see if they overlap...
			      var prevChunk = processedChunks.pop();
			      if (nextChunk.start <= prevChunk.end) {
			        // It may be the case that prevChunk completely surrounds nextChunk, so take the
			        // largest of the end indeces.
			        var endIndex = Math.max(prevChunk.end, nextChunk.end);
			        processedChunks.push({ start: prevChunk.start, end: endIndex });
			      } else {
			        processedChunks.push(prevChunk, nextChunk);
			      }
			      return processedChunks;
			    }
			  }, []);
			
			  return chunks;
			};
			
			/**
			 * Examine text for any matches.
			 * If we find matches, add them to the returned array as a "chunk" object ({start:number, end:number}).
			 * @return {start:number, end:number}[]
			 */
			var defaultFindChunks = function defaultFindChunks(_ref3) {
			  var autoEscape = _ref3.autoEscape,
			      caseSensitive = _ref3.caseSensitive,
			      _ref3$sanitize = _ref3.sanitize,
			      sanitize = _ref3$sanitize === undefined ? identity : _ref3$sanitize,
			      searchWords = _ref3.searchWords,
			      textToHighlight = _ref3.textToHighlight;
			
			  textToHighlight = sanitize(textToHighlight);
			
			  return searchWords.filter(function (searchWord) {
			    return searchWord;
			  }) // Remove empty words
			  .reduce(function (chunks, searchWord) {
			    searchWord = sanitize(searchWord);
			
			    if (autoEscape) {
			      searchWord = escapeRegExpFn(searchWord);
			    }
			
			    var regex = new RegExp(searchWord, caseSensitive ? 'g' : 'gi');
			
			    var match = void 0;
			    while (match = regex.exec(textToHighlight)) {
			      var start = match.index;
			      var end = regex.lastIndex;
			      // We do not return zero-length matches
			      if (end > start) {
			        chunks.push({ start: start, end: end });
			      }
			
			      // Prevent browsers like Firefox from getting stuck in an infinite loop
			      // See http://www.regexguru.com/2008/04/watch-out-for-zero-length-matches/
			      if (match.index == regex.lastIndex) {
			        regex.lastIndex++;
			      }
			    }
			
			    return chunks;
			  }, []);
			};
			// Allow the findChunks to be overridden in findAll,
			// but for backwards compatibility we export as the old name
			exports.findChunks = defaultFindChunks;
			
			/**
			 * Given a set of chunks to highlight, create an additional set of chunks
			 * to represent the bits of text between the highlighted text.
			 * @param chunksToHighlight {start:number, end:number}[]
			 * @param totalLength number
			 * @return {start:number, end:number, highlight:boolean}[]
			 */
			
			var fillInChunks = exports.fillInChunks = function fillInChunks(_ref4) {
			  var chunksToHighlight = _ref4.chunksToHighlight,
			      totalLength = _ref4.totalLength;
			
			  var allChunks = [];
			  var append = function append(start, end, highlight) {
			    if (end - start > 0) {
			      allChunks.push({
			        start: start,
			        end: end,
			        highlight: highlight
			      });
			    }
			  };
			
			  if (chunksToHighlight.length === 0) {
			    append(0, totalLength, false);
			  } else {
			    var lastIndex = 0;
			    chunksToHighlight.forEach(function (chunk) {
			      append(lastIndex, chunk.start, false);
			      append(chunk.start, chunk.end, true);
			      lastIndex = chunk.end;
			    });
			    append(lastIndex, totalLength, false);
			  }
			  return allChunks;
			};
			
			function identity(value) {
			  return value;
			}
			
			function escapeRegExpFn(str) {
			  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
			}
		
		/***/ })
		/******/ ]);
		//# sourceMappingURL=index.js.map
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
		
		if (process.env.NODE_ENV !== 'production') {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
		
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
		
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = __webpack_require__(6)(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(13)();
		}
		
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;
		
		process.listeners = function (name) { return [] }
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(7);
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(9);
		var assign = __webpack_require__(10);
		
		var ReactPropTypesSecret = __webpack_require__(11);
		var checkPropTypes = __webpack_require__(12);
		
		module.exports = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
		
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
		
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
		
		  var ANONYMOUS = '<<anonymous>>';
		
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
		
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker,
		    exact: createStrictShapeTypeChecker,
		  };
		
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
		
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
		
		  function createChainableTypeChecker(validate) {
		    if (process.env.NODE_ENV !== 'production') {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
		
		      if (secret !== ReactPropTypesSecret) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
		
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
		
		    return chainedCheckType;
		  }
		
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
		
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		  }
		
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
		
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
		
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
		
		    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		      var checker = arrayOfTypeCheckers[i];
		      if (typeof checker !== 'function') {
		        warning(
		          false,
		          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
		          'received %s at index %s.',
		          getPostfixForTypeWarning(checker),
		          i
		        );
		        return emptyFunction.thatReturnsNull;
		      }
		    }
		
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		          return null;
		        }
		      }
		
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createStrictShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      // We need to check all keys in case some are required but missing from
		      // props.
		      var allKeys = assign({}, props[propName], shapeTypes);
		      for (var key in allKeys) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          return new PropTypeError(
		            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
		            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
		            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
		          );
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		
		    return createChainableTypeChecker(validate);
		  }
		
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
		
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
		
		        return true;
		      default:
		        return false;
		    }
		  }
		
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
		
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
		
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
		
		    return false;
		  }
		
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
		
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    if (typeof propValue === 'undefined' || propValue === null) {
		      return '' + propValue;
		    }
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
		
		  // Returns a string that is postfixed to a warning about an invalid type.
		  // For example, "undefined" or "of type array"
		  function getPostfixForTypeWarning(value) {
		    var type = getPreciseType(value);
		    switch (type) {
		      case 'array':
		      case 'object':
		        return 'an ' + type;
		      case 'boolean':
		      case 'date':
		      case 'regexp':
		        return 'a ' + type;
		      default:
		        return type;
		    }
		  }
		
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
		
		  ReactPropTypes.checkPropTypes = checkPropTypes;
		  ReactPropTypes.PropTypes = ReactPropTypes;
		
		  return ReactPropTypes;
		};
		
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
		"use strict";
		
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 * 
		 */
		
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
		
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
		
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
		
		module.exports = emptyFunction;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
		
		'use strict';
		
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
		
		var validateFormat = function validateFormat(format) {};
		
		if (process.env.NODE_ENV !== 'production') {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
		
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
		
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
		
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
		
		module.exports = invariant;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2014-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 *
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(7);
		
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
		
		var warning = emptyFunction;
		
		if (process.env.NODE_ENV !== 'production') {
		  var printWarning = function printWarning(format) {
		    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		      args[_key - 1] = arguments[_key];
		    }
		
		    var argIndex = 0;
		    var message = 'Warning: ' + format.replace(/%s/g, function () {
		      return args[argIndex++];
		    });
		    if (typeof console !== 'undefined') {
		      console.error(message);
		    }
		    try {
		      // --- Welcome to debugging React ---
		      // This error was thrown as a convenience so that you can use this stack
		      // to find the callsite that caused this warning to fire.
		      throw new Error(message);
		    } catch (x) {}
		  };
		
		  warning = function warning(condition, format) {
		    if (format === undefined) {
		      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		    }
		
		    if (format.indexOf('Failed Composite propType: ') === 0) {
		      return; // Ignore CompositeComponent proptype check.
		    }
		
		    if (!condition) {
		      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		        args[_key2 - 2] = arguments[_key2];
		      }
		
		      printWarning.apply(undefined, [format].concat(args));
		    }
		  };
		}
		
		module.exports = warning;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
		/*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
		
		'use strict';
		/* eslint-disable no-unused-vars */
		var getOwnPropertySymbols = Object.getOwnPropertySymbols;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var propIsEnumerable = Object.prototype.propertyIsEnumerable;
		
		function toObject(val) {
			if (val === null || val === undefined) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
		
			return Object(val);
		}
		
		function shouldUseNative() {
			try {
				if (!Object.assign) {
					return false;
				}
		
				// Detect buggy property enumeration order in older V8 versions.
		
				// https://bugs.chromium.org/p/v8/issues/detail?id=4118
				var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
				test1[5] = 'de';
				if (Object.getOwnPropertyNames(test1)[0] === '5') {
					return false;
				}
		
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test2 = {};
				for (var i = 0; i < 10; i++) {
					test2['_' + String.fromCharCode(i)] = i;
				}
				var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
					return test2[n];
				});
				if (order2.join('') !== '0123456789') {
					return false;
				}
		
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test3 = {};
				'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
					test3[letter] = letter;
				});
				if (Object.keys(Object.assign({}, test3)).join('') !==
						'abcdefghijklmnopqrst') {
					return false;
				}
		
				return true;
			} catch (err) {
				// We don't expect any of the above to throw, but better to be safe.
				return false;
			}
		}
		
		module.exports = shouldUseNative() ? Object.assign : function (target, source) {
			var from;
			var to = toObject(target);
			var symbols;
		
			for (var s = 1; s < arguments.length; s++) {
				from = Object(arguments[s]);
		
				for (var key in from) {
					if (hasOwnProperty.call(from, key)) {
						to[key] = from[key];
					}
				}
		
				if (getOwnPropertySymbols) {
					symbols = getOwnPropertySymbols(from);
					for (var i = 0; i < symbols.length; i++) {
						if (propIsEnumerable.call(from, symbols[i])) {
							to[symbols[i]] = from[symbols[i]];
						}
					}
				}
			}
		
			return to;
		};
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
		
		'use strict';
		
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
		
		module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
		
		'use strict';
		
		if (process.env.NODE_ENV !== 'production') {
		  var invariant = __webpack_require__(8);
		  var warning = __webpack_require__(9);
		  var ReactPropTypesSecret = __webpack_require__(11);
		  var loggedTypeFailures = {};
		}
		
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  if (process.env.NODE_ENV !== 'production') {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		        } catch (ex) {
		          error = ex;
		        }
		        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
		
		          var stack = getStack ? getStack() : '';
		
		          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
		
		module.exports = checkPropTypes;
		
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(7);
		var invariant = __webpack_require__(8);
		var ReactPropTypesSecret = __webpack_require__(11);
		
		module.exports = function() {
		  function shim(props, propName, componentName, location, propFullName, secret) {
		    if (secret === ReactPropTypesSecret) {
		      // It is still safe when called from React.
		      return;
		    }
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
		
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim,
		    exact: getShim
		  };
		
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
		
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
		'use strict';
		
		var simpleIsEqual = function simpleIsEqual(a, b) {
		  return a === b;
		};
		
		function index (resultFn) {
		  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;
		
		  var lastThis = void 0;
		  var lastArgs = [];
		  var lastResult = void 0;
		  var calledOnce = false;
		
		  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
		    return isEqual(newArg, lastArgs[index]);
		  };
		
		  var result = function result() {
		    for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
		      newArgs[_key] = arguments[_key];
		    }
		
		    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
		      return lastResult;
		    }
		
		    calledOnce = true;
		    lastThis = this;
		    lastArgs = newArgs;
		    lastResult = resultFn.apply(this, newArgs);
		    return lastResult;
		  };
		
		  return result;
		}
		
		module.exports = index;
	
	
	/***/ })
	/******/ ]);
	//# sourceMappingURL=main.js.map

/***/ },
/* 3358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(4);
	var createClass = __webpack_require__(594);
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var AutosizeInput = createClass({
		propTypes: {
			className: PropTypes.string, // className for the outer element
			defaultValue: PropTypes.any, // default field value
			inputClassName: PropTypes.string, // className for the input element
			inputRef: PropTypes.func, // ref callback for the input element
			inputStyle: PropTypes.object, // css styles for the input element
			minWidth: PropTypes.oneOfType([// minimum width for input element
			PropTypes.number, PropTypes.string]),
			onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
			onChange: PropTypes.func, // onChange handler: function(newValue) {}
			placeholder: PropTypes.string, // placeholder text
			placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
			style: PropTypes.object, // css styles for the outer element
			value: PropTypes.any },
		// field value
		getDefaultProps: function getDefaultProps() {
			return {
				minWidth: 1
			};
		},
		getInitialState: function getInitialState() {
			return {
				inputWidth: this.props.minWidth,
				inputId: '_' + Math.random().toString(36).substr(2, 12)
			};
		},
		componentDidMount: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		},
		componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		},
		componentWillUnmount: function componentWillUnmount() {
			this.mounted = false;
		},
		inputRef: function inputRef(el) {
			this.input = el;
			if (typeof this.props.inputRef === 'function') {
				this.props.inputRef(el);
			}
		},
		placeHolderSizerRef: function placeHolderSizerRef(el) {
			this.placeHolderSizer = el;
		},
		sizerRef: function sizerRef(el) {
			this.sizer = el;
		},
		copyInputStyles: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyle = this.input && window.getComputedStyle(this.input);
			if (!inputStyle) {
				return;
			}
			var widthNode = this.sizer;
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.fontWeight = inputStyle.fontWeight;
			widthNode.style.fontStyle = inputStyle.fontStyle;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			widthNode.style.textTransform = inputStyle.textTransform;
			if (this.props.placeholder) {
				var placeholderNode = this.placeHolderSizer;
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.fontWeight = inputStyle.fontWeight;
				placeholderNode.style.fontStyle = inputStyle.fontStyle;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
				placeholderNode.style.textTransform = inputStyle.textTransform;
			}
		},
		updateInputWidth: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = undefined;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		},
		getInput: function getInput() {
			return this.input;
		},
		focus: function focus() {
			this.input.focus();
		},
		blur: function blur() {
			this.input.blur();
		},
		select: function select() {
			this.input.select();
		},
		render: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});
	
			var wrapperStyle = this.props.style || {};
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth + 'px';
			inputStyle.boxSizing = 'content-box';
			var inputProps = _extends({}, this.props);
			inputProps.className = this.props.inputClassName;
			inputProps.style = inputStyle;
			// ensure props meant for `AutosizeInput` don't end up on the `input`
			delete inputProps.inputClassName;
			delete inputProps.inputStyle;
			delete inputProps.minWidth;
			delete inputProps.onAutosize;
			delete inputProps.placeholderIsMinWidth;
			delete inputProps.inputRef;
			return React.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				React.createElement('style', { dangerouslySetInnerHTML: {
						__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
					} }),
				React.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
				React.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? React.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	});
	
	module.exports = AutosizeInput;

/***/ },
/* 3359 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 3360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(3359);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 3361 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 3362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _inputmaskCore = __webpack_require__(2935);
	
	var _inputmaskCore2 = _interopRequireDefault(_inputmaskCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODE_Z = 90;
	var KEYCODE_Y = 89;
	
	function isUndo(e) {
	  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Y : KEYCODE_Z);
	}
	
	function isRedo(e) {
	  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Z : KEYCODE_Y);
	}
	
	function getSelection(el) {
	  var start = void 0,
	      end = void 0;
	  if (el.selectionStart !== undefined) {
	    start = el.selectionStart;
	    end = el.selectionEnd;
	  } else {
	    try {
	      el.focus();
	      var rangeEl = el.createTextRange();
	      var clone = rangeEl.duplicate();
	
	      rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
	      clone.setEndPoint('EndToStart', rangeEl);
	
	      start = clone.text.length;
	      end = start + rangeEl.text.length;
	    } catch (e) {/* not focused or not visible */}
	  }
	
	  return { start: start, end: end };
	}
	
	function setSelection(el, selection) {
	  try {
	    if (el.selectionStart !== undefined) {
	      el.focus();
	      el.setSelectionRange(selection.start, selection.end);
	    } else {
	      el.focus();
	      var rangeEl = el.createTextRange();
	      rangeEl.collapse(true);
	      rangeEl.moveStart('character', selection.start);
	      rangeEl.moveEnd('character', selection.end - selection.start);
	      rangeEl.select();
	    }
	  } catch (e) {/* not focused or not visible */}
	}
	
	var MaskedInput = (_temp2 = _class = function (_React$Component) {
	  _inherits(MaskedInput, _React$Component);
	
	  function MaskedInput() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MaskedInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._onChange = function (e) {
	      // console.log('onChange', JSON.stringify(getSelection(this.input)), e.target.value)
	
	      var maskValue = _this.mask.getValue();
	      var incomingValue = e.target.value;
	      if (incomingValue !== maskValue) {
	        // only modify mask if form contents actually changed
	        _this._updateMaskSelection();
	        _this.mask.setValue(incomingValue); // write the whole updated value into the mask
	        e.target.value = _this._getDisplayValue(); // update the form with pattern applied to the value
	        _this._updateInputSelection();
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(e);
	      }
	    }, _this._onKeyDown = function (e) {
	      // console.log('onKeyDown', JSON.stringify(getSelection(this.input)), e.key, e.target.value)
	
	      if (isUndo(e)) {
	        e.preventDefault();
	        if (_this.mask.undo()) {
	          e.target.value = _this._getDisplayValue();
	          _this._updateInputSelection();
	          if (_this.props.onChange) {
	            _this.props.onChange(e);
	          }
	        }
	        return;
	      } else if (isRedo(e)) {
	        e.preventDefault();
	        if (_this.mask.redo()) {
	          e.target.value = _this._getDisplayValue();
	          _this._updateInputSelection();
	          if (_this.props.onChange) {
	            _this.props.onChange(e);
	          }
	        }
	        return;
	      }
	
	      if (e.key === 'Backspace') {
	        e.preventDefault();
	        _this._updateMaskSelection();
	        if (_this.mask.backspace()) {
	          var value = _this._getDisplayValue();
	          e.target.value = value;
	          if (value) {
	            _this._updateInputSelection();
	          }
	          if (_this.props.onChange) {
	            _this.props.onChange(e);
	          }
	        }
	      }
	    }, _this._onKeyPress = function (e) {
	      // console.log('onKeyPress', JSON.stringify(getSelection(this.input)), e.key, e.target.value)
	
	      // Ignore modified key presses
	      // Ignore enter key to allow form submission
	      if (e.metaKey || e.altKey || e.ctrlKey || e.key === 'Enter') {
	        return;
	      }
	
	      e.preventDefault();
	      _this._updateMaskSelection();
	      if (_this.mask.input(e.key || e.data)) {
	        e.target.value = _this.mask.getValue();
	        _this._updateInputSelection();
	        if (_this.props.onChange) {
	          _this.props.onChange(e);
	        }
	      }
	    }, _this._onPaste = function (e) {
	      // console.log('onPaste', JSON.stringify(getSelection(this.input)), e.clipboardData.getData('Text'), e.target.value)
	
	      e.preventDefault();
	      _this._updateMaskSelection();
	      // getData value needed for IE also works in FF & Chrome
	      if (_this.mask.paste(e.clipboardData.getData('Text'))) {
	        e.target.value = _this.mask.getValue();
	        // Timeout needed for IE
	        setTimeout(function () {
	          return _this._updateInputSelection();
	        }, 0);
	        if (_this.props.onChange) {
	          _this.props.onChange(e);
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MaskedInput.prototype.componentWillMount = function componentWillMount() {
	    var options = {
	      pattern: this.props.mask,
	      value: this.props.value,
	      formatCharacters: this.props.formatCharacters
	    };
	    if (this.props.placeholderChar) {
	      options.placeholderChar = this.props.placeholderChar;
	    }
	    this.mask = new _inputmaskCore2.default(options);
	  };
	
	  MaskedInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.mask !== nextProps.mask && this.props.value !== nextProps.mask) {
	      // if we get a new value and a new mask at the same time
	      // check if the mask.value is still the initial value
	      // - if so use the nextProps value
	      // - otherwise the `this.mask` has a value for us (most likely from paste action)
	      if (this.mask.getValue() === this.mask.emptyValue) {
	        this.mask.setPattern(nextProps.mask, { value: nextProps.value });
	      } else {
	        this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
	      }
	    } else if (this.props.mask !== nextProps.mask) {
	      this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
	    } else if (this.props.value !== nextProps.value) {
	      this.mask.setValue(nextProps.value);
	    }
	  };
	
	  MaskedInput.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
	    if (nextProps.mask !== this.props.mask) {
	      this._updatePattern(nextProps);
	    }
	  };
	
	  MaskedInput.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.mask !== this.props.mask && this.mask.selection.start) {
	      this._updateInputSelection();
	    }
	  };
	
	  MaskedInput.prototype._updatePattern = function _updatePattern(props) {
	    this.mask.setPattern(props.mask, {
	      value: this.mask.getRawValue(),
	      selection: getSelection(this.input)
	    });
	  };
	
	  MaskedInput.prototype._updateMaskSelection = function _updateMaskSelection() {
	    this.mask.selection = getSelection(this.input);
	  };
	
	  MaskedInput.prototype._updateInputSelection = function _updateInputSelection() {
	    setSelection(this.input, this.mask.selection);
	  };
	
	  MaskedInput.prototype._getDisplayValue = function _getDisplayValue() {
	    var value = this.mask.getValue();
	    return value === this.mask.emptyValue ? '' : value;
	  };
	
	  MaskedInput.prototype._keyPressPropName = function _keyPressPropName() {
	    if (typeof navigator !== 'undefined') {
	      return navigator.userAgent.match(/Android/i) ? 'onBeforeInput' : 'onKeyPress';
	    }
	    return 'onKeyPress';
	  };
	
	  MaskedInput.prototype._getEventHandlers = function _getEventHandlers() {
	    var _ref;
	
	    return _ref = {
	      onChange: this._onChange,
	      onKeyDown: this._onKeyDown,
	      onPaste: this._onPaste
	    }, _ref[this._keyPressPropName()] = this._onKeyPress, _ref;
	  };
	
	  MaskedInput.prototype.focus = function focus() {
	    this.input.focus();
	  };
	
	  MaskedInput.prototype.blur = function blur() {
	    this.input.blur();
	  };
	
	  MaskedInput.prototype.render = function render() {
	    var _this2 = this;
	
	    var ref = function ref(r) {
	      _this2.input = r;
	    };
	    var maxLength = this.mask.pattern.length;
	    var value = this._getDisplayValue();
	    var eventHandlers = this._getEventHandlers();
	    var _props = this.props,
	        _props$size = _props.size,
	        size = _props$size === undefined ? maxLength : _props$size,
	        _props$placeholder = _props.placeholder,
	        placeholder = _props$placeholder === undefined ? this.mask.emptyValue : _props$placeholder;
	
	    var _props2 = this.props,
	        placeholderChar = _props2.placeholderChar,
	        formatCharacters = _props2.formatCharacters,
	        cleanedProps = _objectWithoutProperties(_props2, ['placeholderChar', 'formatCharacters']); // eslint-disable-line no-unused-vars
	
	
	    var inputProps = _extends({}, cleanedProps, eventHandlers, { ref: ref, maxLength: maxLength, value: value, size: size, placeholder: placeholder });
	    return _react2.default.createElement('input', inputProps);
	  };
	
	  return MaskedInput;
	}(_react2.default.Component), _class.defaultProps = {
	  value: ''
	}, _temp2);
	MaskedInput.propTypes =  false ? {
	  mask: _propTypes2.default.string.isRequired,
	
	  formatCharacters: _propTypes2.default.object,
	  placeholderChar: _propTypes2.default.string
	} : {};
	exports.default = MaskedInput;
	module.exports = exports['default'];

/***/ },
/* 3363 */
/***/ function(module, exports) {

	var messages = {
	  invalidPredicate: '`predicate` must be a function',
	  invalidPropValidator: '`propValidator` must be a function',
	  requiredCore: 'is marked as required',
	  invalidTypeCore: 'Invalid input type',
	  predicateFailureCore: 'Failed to succeed with predicate',
	  anonymousMessage: '<<anonymous>>',
	  baseInvalidMessage: 'Invalid ',
	};
	
	function constructPropValidatorVariations(propValidator) {
	  if (typeof propValidator !== 'function') {
	    throw new Error(messages.invalidPropValidator);
	  }
	
	  var requiredPropValidator = propValidator.bind(null, false, null);
	  requiredPropValidator.isRequired = propValidator.bind(null, true, null);
	
	  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
	    if (typeof predicate !== 'function') {
	      throw new Error(messages.invalidPredicate);
	    }
	    var basePropValidator = propValidator.bind(null, false, predicate);
	    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
	    return basePropValidator;
	  };
	
	  return requiredPropValidator;
	}
	
	function createInvalidRequiredErrorMessage(propName, componentName, value) {
	  return new Error(
	    'The prop `' + propName + '` ' + messages.requiredCore +
	    ' in `' + componentName + '`, but its value is `' + value + '`.'
	  );
	}
	
	var independentGuardianValue = -1;
	
	function preValidationRequireCheck(isRequired, componentName, propFullName, propValue) {
	  var isPropValueUndefined = typeof propValue === 'undefined';
	  var isPropValueNull = propValue === null;
	
	  if (isRequired) {
	    if (isPropValueUndefined) {
	      return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
	    } else if (isPropValueNull) {
	      return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
	    }
	  }
	
	  if (isPropValueUndefined || isPropValueNull) {
	    return null;
	  }
	
	  return independentGuardianValue;
	}
	
	function createMomentChecker(type, typeValidator, validator, momentType) {
	
	  function propValidator(
	    isRequired, // Bound parameter to indicate with the propType is required
	    predicate, // Bound parameter to allow user to add dynamic validation
	    props,
	    propName,
	    componentName,
	    location,
	    propFullName
	  ) {
	    var propValue = props[ propName ];
	    var propType = typeof propValue;
	
	    componentName = componentName || messages.anonymousMessage;
	    propFullName = propFullName || propName;
	
	    var preValidationRequireCheckValue = preValidationRequireCheck(
	      isRequired, componentName, propFullName, propValue
	    );
	
	    if (preValidationRequireCheckValue !== independentGuardianValue) {
	      return preValidationRequireCheckValue;
	    }
	
	    if (typeValidator && !typeValidator(propValue)) {
	      return new Error(
	        messages.invalidTypeCore + ': `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + type + '`.'
	      );
	    }
	
	    if (!validator(propValue)) {
	      return new Error(
	        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
	      );
	    }
	
	    if (predicate && !predicate(propValue)) {
	      var predicateName = predicate.name || messages.anonymousMessage;
	      return new Error(
	        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`. ' + messages.predicateFailureCore + ' `' +
	        predicateName + '`.'
	      );
	    }
	
	    return null;
	
	  }
	
	  return constructPropValidatorVariations(propValidator);
	
	}
	
	module.exports = {
	  constructPropValidatorVariations: constructPropValidatorVariations,
	  createMomentChecker: createMomentChecker,
	  messages: messages,
	};


/***/ },
/* 3364 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(7);
	
	function isValidMoment(testMoment) {
	  if (typeof moment.isMoment === 'function' && !moment.isMoment(testMoment)) {
	    return false;
	  }
	
	  /* istanbul ignore else  */
	  if (typeof testMoment.isValid === 'function') {
	    // moment 1.7.0+
	    return testMoment.isValid();
	  }
	
	  /* istanbul ignore next */
	  return !isNaN(testMoment);
	}
	
	module.exports = {
	  isValidMoment : isValidMoment,
	};


/***/ },
/* 3365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(725);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(728);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(727);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(729);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(680);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(726);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = _react2['default'].createClass({
	  displayName: 'Motion',
	
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyle: _react.PropTypes.objectOf(_react.PropTypes.number),
	    style: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.object])).isRequired,
	    children: _react.PropTypes.func.isRequired,
	    onRest: _react.PropTypes.func
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  },
	
	  wasAnimating: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyle: null,
	  // after checking for unreadPropStyle != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
	    var dirty = false;
	    var _state = this.state;
	    var currentStyle = _state.currentStyle;
	    var currentVelocity = _state.currentVelocity;
	    var lastIdealStyle = _state.lastIdealStyle;
	    var lastIdealVelocity = _state.lastIdealVelocity;
	
	    for (var key in destStyle) {
	      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	        continue;
	      }
	
	      var styleValue = destStyle[key];
	      if (typeof styleValue === 'number') {
	        if (!dirty) {
	          dirty = true;
	          currentStyle = _extends({}, currentStyle);
	          currentVelocity = _extends({}, currentVelocity);
	          lastIdealStyle = _extends({}, lastIdealStyle);
	          lastIdealVelocity = _extends({}, lastIdealVelocity);
	        }
	
	        currentStyle[key] = styleValue;
	        currentVelocity[key] = 0;
	        lastIdealStyle[key] = styleValue;
	        lastIdealVelocity[key] = 0;
	      }
	    }
	
	    if (dirty) {
	      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // check if we need to animate in the first place
	      var propsStyle = _this.props.style;
	      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	        if (_this.wasAnimating && _this.props.onRest) {
	          _this.props.onRest();
	        }
	
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.wasAnimating = false;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      _this.wasAnimating = true;
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyle = {};
	      var newLastIdealVelocity = {};
	      var newCurrentStyle = {};
	      var newCurrentVelocity = {};
	
	      for (var key in propsStyle) {
	        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	          continue;
	        }
	
	        var styleValue = propsStyle[key];
	        if (typeof styleValue === 'number') {
	          newCurrentStyle[key] = styleValue;
	          newCurrentVelocity[key] = 0;
	          newLastIdealStyle[key] = styleValue;
	          newLastIdealVelocity[key] = 0;
	        } else {
	          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	          for (var i = 0; i < framesToCatchUp; i++) {
	            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            newLastIdealStyleValue = _stepper[0];
	            newLastIdealVelocityValue = _stepper[1];
	          }
	
	          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	          var nextIdealX = _stepper2[0];
	          var nextIdealV = _stepper2[1];
	
	          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	          newLastIdealStyle[key] = newLastIdealStyleValue;
	          newLastIdealVelocity[key] = newLastIdealVelocityValue;
	        }
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyle: newCurrentStyle,
	        currentVelocity: newCurrentVelocity,
	        lastIdealStyle: newLastIdealStyle,
	        lastIdealVelocity: newLastIdealVelocity
	      });
	
	      _this.unreadPropStyle = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = Motion;
	module.exports = exports['default'];

/***/ },
/* 3366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(725);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(728);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(727);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(729);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(680);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(726);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = _react2['default'].createClass({
	  displayName: 'StaggeredMotion',
	
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyles: _react.PropTypes.arrayOf(_react.PropTypes.objectOf(_react.PropTypes.number)),
	    styles: _react.PropTypes.func.isRequired,
	    children: _react.PropTypes.func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  },
	
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _state = this.state;
	    var currentStyles = _state.currentStyles;
	    var currentVelocities = _state.currentVelocities;
	    var lastIdealStyles = _state.lastIdealStyles;
	    var lastIdealVelocities = _state.lastIdealVelocities;
	
	    var someDirty = false;
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i];
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            someDirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	        }
	      }
	    }
	
	    if (someDirty) {
	      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyles = [];
	      var newLastIdealVelocities = [];
	      var newCurrentStyles = [];
	      var newCurrentVelocities = [];
	
	      for (var i = 0; i < destStyles.length; i++) {
	        var destStyle = destStyles[i];
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in destStyle) {
	          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	            continue;
	          }
	
	          var styleValue = destStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];

/***/ },
/* 3367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(725);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(728);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(727);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(3368);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(729);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(680);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(726);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = _react2['default'].createClass({
	  displayName: 'TransitionMotion',
	
	  propTypes: {
	    defaultStyles: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      key: _react.PropTypes.string.isRequired,
	      data: _react.PropTypes.any,
	      style: _react.PropTypes.objectOf(_react.PropTypes.number).isRequired
	    })),
	    styles: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      key: _react.PropTypes.string.isRequired,
	      data: _react.PropTypes.any,
	      style: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.object])).isRequired
	    }))]).isRequired,
	    children: _react.PropTypes.func.isRequired,
	    willEnter: _react.PropTypes.func,
	    willLeave: _react.PropTypes.func,
	    didLeave: _react.PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync = mergeAndSync(
	    // Because this is an old-style React.createClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync[0];
	    var currentStyles = _mergeAndSync[1];
	    var currentVelocities = _mergeAndSync[2];
	    var lastIdealStyles = _mergeAndSync[3];
	    var lastIdealVelocities = _mergeAndSync[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  },
	
	  unmounting: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.props.didLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);
	
	    var mergedPropsStyles = _mergeAndSync2[0];
	    var currentStyles = _mergeAndSync2[1];
	    var currentVelocities = _mergeAndSync2[2];
	    var lastIdealStyles = _mergeAndSync2[3];
	    var lastIdealVelocities = _mergeAndSync2[4];
	
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i].style;
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            mergedPropsStyles[i] = {
	              key: mergedPropsStyles[i].key,
	              data: mergedPropsStyles[i].data,
	              style: _extends({}, mergedPropsStyles[i].style)
	            };
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	          mergedPropsStyles[i].style[key] = styleValue;
	        }
	      }
	    }
	
	    // unlike the other 2 components, we can't detect staleness and optionally
	    // opt out of setState here. each style object's data might contain new
	    // stuff we're not/cannot compare
	    this.setState({
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      mergedPropsStyles: mergedPropsStyles,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities
	    });
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    if (this.unmounting) {
	      return;
	    }
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      var propStyles = _this.props.styles;
	      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var newMergedPropsStyles = _mergeAndSync3[0];
	      var newCurrentStyles = _mergeAndSync3[1];
	      var newCurrentVelocities = _mergeAndSync3[2];
	      var newLastIdealStyles = _mergeAndSync3[3];
	      var newLastIdealVelocities = _mergeAndSync3[4];
	
	      for (var i = 0; i < newMergedPropsStyles.length; i++) {
	        var newMergedPropsStyle = newMergedPropsStyles[i].style;
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in newMergedPropsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = newMergedPropsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = newLastIdealStyles[i][key];
	            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities,
	        mergedPropsStyles: newMergedPropsStyles
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives

/***/ },
/* 3368 */
/***/ function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ },
/* 3369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(3365);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(3366);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(3367);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(3371);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(1532);
	
	exports.presets = _interopRequire(_presets);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(3370);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ },
/* 3370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 3371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(1532);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ },
/* 3372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var reactDom = __webpack_require__(76);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ },
/* 3373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchJsonp = __webpack_require__(2924);
	
	var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);
	
	var _FilePlayer2 = __webpack_require__(455);
	
	var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);
	
	var _props3 = __webpack_require__(730);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESOLVE_URL = '//api.soundcloud.com/resolve.json';
	var MATCH_URL = /^https?:\/\/(soundcloud.com|snd.sc)\/([a-z0-9-_]+\/[a-z0-9-_]+)$/;
	
	var songData = {}; // Cache song data requests
	
	var SoundCloud = function (_FilePlayer) {
	  _inherits(SoundCloud, _FilePlayer);
	
	  function SoundCloud() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SoundCloud);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      image: null
	    }, _this.clientId = _this.props.soundcloudConfig.clientId || _props3.defaultProps.soundcloudConfig.clientId, _this.ref = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SoundCloud, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return _get(SoundCloud.prototype.__proto__ || Object.getPrototypeOf(SoundCloud.prototype), 'shouldComponentUpdate', this).call(this, nextProps, nextState) || this.state.image !== nextState.image;
	    }
	  }, {
	    key: 'getSongData',
	    value: function getSongData(url) {
	      var _this2 = this;
	
	      if (songData[url]) {
	        return Promise.resolve(songData[url]);
	      }
	      return (0, _fetchJsonp2['default'])(RESOLVE_URL + '?url=' + url + '&client_id=' + this.clientId).then(function (response) {
	        if (response.ok) {
	          songData[url] = response.json();
	          return songData[url];
	        } else {
	          _this2.props.onError(new Error('SoundCloud track could not be resolved'));
	        }
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this3 = this;
	
	      var _props = this.props,
	          soundcloudConfig = _props.soundcloudConfig,
	          onError = _props.onError;
	
	      this.stop();
	      this.getSongData(url).then(function (data) {
	        if (!_this3.mounted) return;
	        if (!data.streamable) {
	          onError(new Error('SoundCloud track is not streamable'));
	          return;
	        }
	        var image = data.artwork_url || data.user.avatar_url;
	        if (image && soundcloudConfig.showArtwork) {
	          _this3.setState({ image: image.replace('-large', '-t500x500') });
	        }
	        _this3.player.src = data.stream_url + '?client_id=' + _this3.clientId;
	      }, onError);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          url = _props2.url,
	          loop = _props2.loop,
	          controls = _props2.controls;
	
	      var style = {
	        display: url ? 'block' : 'none',
	        height: '100%',
	        backgroundImage: this.state.image ? 'url(' + this.state.image + ')' : null,
	        backgroundSize: 'cover',
	        backgroundPosition: 'center'
	      };
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('audio', {
	          ref: this.ref,
	          type: 'audio/mpeg',
	          preload: 'auto',
	          style: {
	            width: '100%',
	            height: '100%'
	          },
	          controls: controls,
	          loop: loop
	        })
	      );
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return SoundCloud;
	}(_FilePlayer3['default']);
	
	SoundCloud.displayName = 'SoundCloud';
	exports['default'] = SoundCloud;
	module.exports = exports['default'];

/***/ },
/* 3374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FilePlayer2 = __webpack_require__(455);
	
	var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESOLVE_URL = 'https://api.streamable.com/videos/';
	var MATCH_URL = /^https?:\/\/streamable.com\/([a-z0-9]+)$/;
	
	var cache = {}; // Cache song data requests
	
	var Streamable = function (_FilePlayer) {
	  _inherits(Streamable, _FilePlayer);
	
	  function Streamable() {
	    _classCallCheck(this, Streamable);
	
	    return _possibleConstructorReturn(this, (Streamable.__proto__ || Object.getPrototypeOf(Streamable)).apply(this, arguments));
	  }
	
	  _createClass(Streamable, [{
	    key: 'getData',
	    value: function getData(url) {
	      var onError = this.props.onError;
	
	      var id = url.match(MATCH_URL)[1];
	      if (cache[id]) {
	        return Promise.resolve(cache[id]);
	      }
	      return window.fetch(RESOLVE_URL + id).then(function (response) {
	        if (response.status === 200) {
	          cache[id] = response.json();
	          return cache[id];
	        } else {
	          onError(new Error('Streamable track could not be resolved'));
	        }
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var onError = this.props.onError;
	
	      this.stop();
	      this.getData(url).then(function (data) {
	        if (!_this2.mounted) return;
	        _this2.player.src = data.files.mp4.url;
	      }, onError);
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Streamable;
	}(_FilePlayer3['default']);
	
	Streamable.displayName = 'Streamable';
	exports['default'] = Streamable;
	module.exports = exports['default'];

/***/ },
/* 3375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FilePlayer2 = __webpack_require__(455);
	
	var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESOLVE_URL = 'https://api.vid.me/videoByUrl/';
	var MATCH_URL = /^https?:\/\/vid.me\/([a-z0-9]+)$/;
	
	var cache = {}; // Cache song data requests
	
	var Vidme = function (_FilePlayer) {
	  _inherits(Vidme, _FilePlayer);
	
	  function Vidme() {
	    _classCallCheck(this, Vidme);
	
	    return _possibleConstructorReturn(this, (Vidme.__proto__ || Object.getPrototypeOf(Vidme)).apply(this, arguments));
	  }
	
	  _createClass(Vidme, [{
	    key: 'getData',
	    value: function getData(url) {
	      var onError = this.props.onError;
	
	      var id = url.match(MATCH_URL)[1];
	      if (cache[id]) {
	        return Promise.resolve(cache[id]);
	      }
	      return window.fetch(RESOLVE_URL + id).then(function (response) {
	        if (response.status === 200) {
	          cache[id] = response.json();
	          return cache[id];
	        } else {
	          onError(new Error('Vidme track could not be resolved'));
	        }
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var onError = this.props.onError;
	
	      this.stop();
	      this.getData(url).then(function (data) {
	        if (!_this2.mounted) return;
	        _this2.player.src = data.video.complete_url;
	      }, onError);
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Vidme;
	}(_FilePlayer3['default']);
	
	Vidme.displayName = 'Vidme';
	exports['default'] = Vidme;
	module.exports = exports['default'];

/***/ },
/* 3376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _queryString = __webpack_require__(3380);
	
	var _Base2 = __webpack_require__(454);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IFRAME_SRC = 'https://player.vimeo.com/video/';
	var MATCH_URL = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
	var MATCH_MESSAGE_ORIGIN = /^https?:\/\/player.vimeo.com/;
	var BLANK_VIDEO_URL = 'https://vimeo.com/127250231';
	var DEFAULT_IFRAME_PARAMS = {
	  api: 1,
	  autoplay: 0,
	  badge: 0,
	  byline: 0,
	  fullscreen: 1,
	  portrait: 0,
	  title: 0
	};
	
	var Vimeo = function (_Base) {
	  _inherits(Vimeo, _Base);
	
	  function Vimeo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Vimeo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.onMessage = function (e) {
	      if (!MATCH_MESSAGE_ORIGIN.test(e.origin)) return;
	      _this.origin = _this.origin || e.origin;
	      var data = JSON.parse(e.data);
	      if (data.event === 'ready') {
	        _this.postMessage('getDuration');
	        _this.postMessage('addEventListener', 'playProgress');
	        _this.postMessage('addEventListener', 'loadProgress');
	        _this.postMessage('addEventListener', 'play');
	        _this.postMessage('addEventListener', 'pause');
	        _this.postMessage('addEventListener', 'finish');
	      }
	      if (data.event === 'playProgress') _this.fractionPlayed = data.data.percent;
	      if (data.event === 'loadProgress') _this.fractionLoaded = data.data.percent;
	      if (data.event === 'play') _this.onPlay();
	      if (data.event === 'pause') _this.props.onPause();
	      if (data.event === 'finish') _this.onEnded();
	      if (data.method === 'getDuration') {
	        _this.duration = data.value; // Store for use later
	        _this.onReady();
	      }
	    }, _this.onEnded = function () {
	      var _this$props = _this.props,
	          loop = _this$props.loop,
	          onEnded = _this$props.onEnded;
	
	      if (loop) {
	        _this.seekTo(0);
	      }
	      onEnded();
	    }, _this.postMessage = function (method, value) {
	      if (!_this.origin) return;
	      var data = JSON.stringify({ method: method, value: value });
	      return _this.iframe.contentWindow && _this.iframe.contentWindow.postMessage(data, _this.origin);
	    }, _this.ref = function (iframe) {
	      _this.iframe = iframe;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Vimeo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          url = _props.url,
	          vimeoConfig = _props.vimeoConfig;
	
	      window.addEventListener('message', this.onMessage, false);
	
	      if (!url && vimeoConfig.preload) {
	        this.preloading = true;
	        this.load(BLANK_VIDEO_URL);
	      }
	
	      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('message', this.onMessage, false);
	      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentWillUnmount', this).call(this);
	    }
	  }, {
	    key: 'getIframeParams',
	    value: function getIframeParams() {
	      return _extends({}, DEFAULT_IFRAME_PARAMS, this.props.vimeoConfig.iframeParams);
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var id = url.match(MATCH_URL)[3];
	      this.iframe.src = IFRAME_SRC + id + '?' + (0, _queryString.stringify)(this.getIframeParams());
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.postMessage('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.postMessage('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.iframe.src = '';
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'seekTo', this).call(this, fraction);
	      this.postMessage('seekTo', this.duration * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.postMessage('setVolume', fraction);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.postMessage('setPlaybackRate', rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      return this.fractionPlayed || null;
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      return this.fractionLoaded || null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _getIframeParams = this.getIframeParams(),
	          fullscreen = _getIframeParams.fullscreen;
	
	      var style = {
	        display: this.props.url ? 'block' : 'none',
	        width: '100%',
	        height: '100%'
	      };
	      return _react2['default'].createElement('iframe', {
	        ref: this.ref,
	        frameBorder: '0',
	        style: style,
	        allowFullScreen: fullscreen
	      });
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Vimeo;
	}(_Base3['default']);
	
	Vimeo.displayName = 'Vimeo';
	exports['default'] = Vimeo;
	module.exports = exports['default'];

/***/ },
/* 3377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(423);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _Base2 = __webpack_require__(454);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
	var SDK_GLOBAL = 'Wistia';
	var MATCH_URL = /^https?:\/\/(.+)?(wistia.com|wi.st)\/(medias|embed)\/(.*)$/;
	
	var Wistia = function (_Base) {
	  _inherits(Wistia, _Base);
	
	  function Wistia() {
	    _classCallCheck(this, Wistia);
	
	    return _possibleConstructorReturn(this, (Wistia.__proto__ || Object.getPrototypeOf(Wistia)).apply(this, arguments));
	  }
	
	  _createClass(Wistia, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onStart = _props.onStart,
	          onPause = _props.onPause,
	          onEnded = _props.onEnded;
	
	      this.loadingSDK = true;
	      this.getSDK().then(function () {
	        window._wq = window._wq || [];
	        window._wq.push({
	          id: _this2.getID(_this2.props.url),
	          onReady: function onReady(player) {
	            _this2.loadingSDK = false;
	            _this2.player = player;
	            _this2.player.bind('start', onStart);
	            _this2.player.bind('play', _this2.onPlay);
	            _this2.player.bind('pause', onPause);
	            _this2.player.bind('end', onEnded);
	            _this2.onReady();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'getSDK',
	    value: function getSDK() {
	      return new Promise(function (resolve, reject) {
	        if (window[SDK_GLOBAL]) {
	          resolve();
	        } else {
	          (0, _loadScript2['default'])(SDK_URL, function (err, script) {
	            if (err) reject(err);
	            resolve(script);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getID',
	    value: function getID(url) {
	      return url && url.match(MATCH_URL)[4];
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var id = this.getID(url);
	      if (this.isReady) {
	        this.player.replaceWith(id);
	        this.props.onReady();
	        this.onReady();
	      }
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      if (!this.isReady || !this.player) return;
	      this.player.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (!this.isReady || !this.player) return;
	      this.player && this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!this.isReady || !this.player) return;
	      this.player.pause();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(Wistia.prototype.__proto__ || Object.getPrototypeOf(Wistia.prototype), 'seekTo', this).call(this, fraction);
	      if (!this.isReady || !this.player) return;
	      this.player.time(this.getDuration() * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      if (!this.isReady || !this.player || !this.player.volume) return;
	      this.player.volume(fraction);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      if (!this.isReady || !this.player || !this.player.playbackRate) return;
	      this.player.playbackRate(rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady || !this.player || !this.player.duration) return;
	      return this.player.duration();
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady || !this.player || !this.player.percentWatched) return null;
	      return this.player.percentWatched();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var id = this.getID(this.props.url);
	      var className = 'wistia_embed wistia_async_' + id;
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: this.props.url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement('div', { className: className, style: style });
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Wistia;
	}(_Base3['default']);
	
	Wistia.displayName = 'Wistia';
	exports['default'] = Wistia;
	module.exports = exports['default'];

/***/ },
/* 3378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(423);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _Base2 = __webpack_require__(454);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _utils = __webpack_require__(3379);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://www.youtube.com/iframe_api';
	var SDK_GLOBAL = 'YT';
	var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
	var MATCH_URL = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
	var BLANK_VIDEO_URL = 'https://www.youtube.com/watch?v=GlCmAC4MHek';
	var DEFAULT_PLAYER_VARS = {
	  autoplay: 0,
	  playsinline: 1,
	  showinfo: 0,
	  rel: 0,
	  iv_load_policy: 3
	};
	
	var YouTube = function (_Base) {
	  _inherits(YouTube, _Base);
	
	  function YouTube() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, YouTube);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.onStateChange = function (_ref2) {
	      var data = _ref2.data;
	      var _this$props = _this.props,
	          onPause = _this$props.onPause,
	          onBuffer = _this$props.onBuffer;
	      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
	          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
	          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
	          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
	          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
	          CUED = _window$SDK_GLOBAL$Pl.CUED;
	
	      if (data === PLAYING) _this.onPlay();
	      if (data === PAUSED) onPause();
	      if (data === BUFFERING) onBuffer();
	      if (data === ENDED) _this.onEnded();
	      if (data === CUED) _this.onReady();
	    }, _this.onEnded = function () {
	      var _this$props2 = _this.props,
	          loop = _this$props2.loop,
	          onEnded = _this$props2.onEnded;
	
	      if (loop) {
	        _this.seekTo(0);
	      }
	      onEnded();
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(YouTube, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          url = _props.url,
	          youtubeConfig = _props.youtubeConfig;
	
	      if (!url && youtubeConfig.preload) {
	        this.preloading = true;
	        this.load(BLANK_VIDEO_URL);
	      }
	      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'getSDK',
	    value: function getSDK() {
	      if (window[SDK_GLOBAL] && window[SDK_GLOBAL].loaded) {
	        return Promise.resolve(window[SDK_GLOBAL]);
	      }
	      return new Promise(function (resolve, reject) {
	        var previousOnReady = window[SDK_GLOBAL_READY];
	        window[SDK_GLOBAL_READY] = function () {
	          if (previousOnReady) previousOnReady();
	          resolve(window[SDK_GLOBAL]);
	        };
	        (0, _loadScript2['default'])(SDK_URL, function (err) {
	          if (err) reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          controls = _props2.controls,
	          youtubeConfig = _props2.youtubeConfig,
	          _onError = _props2.onError;
	
	      var id = url && url.match(MATCH_URL)[1];
	      if (this.isReady) {
	        this.player.cueVideoById({
	          videoId: id,
	          startSeconds: (0, _utils.parseStartTime)(url)
	        });
	        return;
	      }
	      if (this.loadingSDK) {
	        this.loadOnReady = url;
	        return;
	      }
	      this.loadingSDK = true;
	      this.getSDK().then(function (YT) {
	        _this2.player = new YT.Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          videoId: id,
	          playerVars: _extends({}, DEFAULT_PLAYER_VARS, {
	            controls: controls ? 1 : 0
	          }, youtubeConfig.playerVars, {
	            start: (0, _utils.parseStartTime)(url),
	            origin: window.location.origin
	          }),
	          events: {
	            onReady: function onReady() {
	              _this2.loadingSDK = false;
	              _this2.onReady();
	            },
	            onStateChange: _this2.onStateChange,
	            onError: function onError(event) {
	              return _onError(event.data);
	            }
	          }
	        });
	      }, _onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      if (!this.isReady || !this.player.playVideo) return;
	      this.player.playVideo();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (!this.isReady || !this.player.pauseVideo) return;
	      this.player.pauseVideo();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!this.isReady || !this.player.stopVideo) return;
	      this.player.stopVideo();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'seekTo', this).call(this, fraction);
	      if (!this.isReady || !this.player.seekTo) return;
	      this.player.seekTo(this.getDuration() * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      if (!this.isReady || !this.player.setVolume) return;
	      this.player.setVolume(fraction * 100);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      if (!this.isReady || !this.player.setPlaybackRate) return;
	      this.player.setPlaybackRate(rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady || !this.player.getDuration) return null;
	      return this.player.getDuration();
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady || !this.getDuration()) return null;
	      return this.player.getCurrentTime() / this.getDuration();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      if (!this.isReady || !this.player.getVideoLoadedFraction) return null;
	      return this.player.getVideoLoadedFraction();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: this.props.url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('div', { ref: this.ref })
	      );
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return YouTube;
	}(_Base3['default']);
	
	YouTube.displayName = 'YouTube';
	exports['default'] = YouTube;
	module.exports = exports['default'];

/***/ },
/* 3379 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.parseStartTime = parseStartTime;
	var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
	var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
	var MATCH_NUMERIC = /^\d+$/;
	
	// Parse YouTube URL for a start time param, ie ?t=1h14m30s
	// and return the start time in seconds
	function parseStartTime(url) {
	  var match = url.match(MATCH_START_QUERY);
	  if (match) {
	    var stamp = match[1];
	    if (stamp.match(MATCH_START_STAMP)) {
	      return parseStartStamp(stamp);
	    }
	    if (MATCH_NUMERIC.test(stamp)) {
	      return parseInt(stamp, 10);
	    }
	  }
	  return 0;
	}
	
	function parseStartStamp(stamp) {
	  var seconds = 0;
	  var array = MATCH_START_STAMP.exec(stamp);
	  while (array !== null) {
	    var _array = array,
	        _array2 = _slicedToArray(_array, 3),
	        count = _array2[1],
	        period = _array2[2];
	
	    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
	    if (period === 'm') seconds += parseInt(count, 10) * 60;
	    if (period === 's') seconds += parseInt(count, 10);
	    array = MATCH_START_STAMP.exec(stamp);
	  }
	  return seconds;
	}

/***/ },
/* 3380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(829);
	var objectAssign = __webpack_require__(45);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 3381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var react = __webpack_require__(1);
	var PropTypes = _interopDefault(__webpack_require__(3383));
	var PopperJS = _interopDefault(__webpack_require__(3027));
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var Manager = function (_Component) {
	  inherits(Manager, _Component);
	
	  function Manager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Manager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
	      _this._targetNode = node;
	    }, _this._getTargetNode = function () {
	      return _this._targetNode;
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Manager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popperManager: {
	          setTargetNode: this._setTargetNode,
	          getTargetNode: this._getTargetNode
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          children = _props.children,
	          restProps = objectWithoutProperties(_props, ['tag', 'children']);
	
	      if (tag !== false) {
	        return react.createElement(tag, restProps, children);
	      } else {
	        return children;
	      }
	    }
	  }]);
	  return Manager;
	}(react.Component);
	
	Manager.childContextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	Manager.defaultProps = {
	  tag: 'div'
	};
	Manager.propTypes =  false ? {
	  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	} : {};
	
	var Target = function Target(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'div' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popperManager = context.popperManager;
	
	  var targetRef = function targetRef(node) {
	    popperManager.setTargetNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	
	  if (typeof children === 'function') {
	    var targetProps = { ref: targetRef };
	    return children({ targetProps: targetProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps);
	
	  if (typeof component === 'string') {
	    componentProps.ref = targetRef;
	  } else {
	    componentProps.innerRef = targetRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Target.contextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	
	Target.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	var placements = PopperJS.placements;
	
	var Popper = function (_Component) {
	  inherits(Popper, _Component);
	
	  function Popper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Popper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
	      _this._arrowNode = node;
	    }, _this._getTargetNode = function () {
	      if (_this.props.target) {
	        return _this.props.target;
	      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
	        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
	      }
	      return _this.context.popperManager.getTargetNode();
	    }, _this._getOffsets = function (data) {
	      return Object.keys(data.offsets).map(function (key) {
	        return data.offsets[key];
	      });
	    }, _this._isDataDirty = function (data) {
	      if (_this.state.data) {
	        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
	      } else {
	        return true;
	      }
	    }, _this._updateStateModifier = {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        if (_this._isDataDirty(data)) {
	          _this.setState({ data: data });
	        }
	        return data;
	      }
	    }, _this._getPopperStyle = function () {
	      var data = _this.state.data;
	
	
	      if (!_this._popper || !data) {
	        return {
	          position: 'absolute',
	          pointerEvents: 'none',
	          opacity: 0
	        };
	      }
	
	      return _extends({
	        position: data.offsets.popper.position
	      }, data.styles);
	    }, _this._getPopperPlacement = function () {
	      return _this.state.data ? _this.state.data.placement : undefined;
	    }, _this._getPopperHide = function () {
	      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
	    }, _this._getArrowStyle = function () {
	      if (!_this.state.data || !_this.state.data.offsets.arrow) {
	        return {};
	      } else {
	        var _this$state$data$offs = _this.state.data.offsets.arrow,
	            top = _this$state$data$offs.top,
	            left = _this$state$data$offs.left;
	
	        return { top: top, left: left };
	      }
	    }, _this._handlePopperRef = function (node) {
	      _this._popperNode = node;
	      if (node) {
	        _this._createPopper();
	      } else {
	        _this._destroyPopper();
	      }
	      if (_this.props.innerRef) {
	        _this.props.innerRef(node);
	      }
	    }, _this._scheduleUpdate = function () {
	      _this._popper && _this._popper.scheduleUpdate();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Popper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popper: {
	          setArrowNode: this._setArrowNode,
	          getArrowStyle: this._getArrowStyle
	        }
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(lastProps) {
	      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
	        this._destroyPopper();
	        this._createPopper();
	      }
	      if (lastProps.children !== this.props.children) {
	        this._scheduleUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyPopper();
	    }
	  }, {
	    key: '_createPopper',
	    value: function _createPopper() {
	      var _this2 = this;
	
	      var _props = this.props,
	          placement = _props.placement,
	          eventsEnabled = _props.eventsEnabled;
	
	      var modifiers = _extends({}, this.props.modifiers, {
	        applyStyle: { enabled: false },
	        updateState: this._updateStateModifier
	      });
	      if (this._arrowNode) {
	        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
	          element: this._arrowNode
	        });
	      }
	      this._popper = new PopperJS(this._getTargetNode(), this._popperNode, {
	        placement: placement,
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers
	      });
	
	      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
	      setTimeout(function () {
	        return _this2._scheduleUpdate();
	      });
	    }
	  }, {
	    key: '_destroyPopper',
	    value: function _destroyPopper() {
	      if (this._popper) {
	        this._popper.destroy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          component = _props2.component,
	          innerRef = _props2.innerRef,
	          placement = _props2.placement,
	          eventsEnabled = _props2.eventsEnabled,
	          modifiers = _props2.modifiers,
	          children = _props2.children,
	          restProps = objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);
	
	      var popperStyle = this._getPopperStyle();
	      var popperPlacement = this._getPopperPlacement();
	      var popperHide = this._getPopperHide();
	
	      if (typeof children === 'function') {
	        var popperProps = {
	          ref: this._handlePopperRef,
	          style: popperStyle,
	          'data-placement': popperPlacement,
	          'data-x-out-of-boundaries': popperHide
	        };
	        return children({
	          popperProps: popperProps,
	          restProps: restProps,
	          scheduleUpdate: this._scheduleUpdate
	        });
	      }
	
	      var componentProps = _extends({}, restProps, {
	        style: _extends({}, restProps.style, popperStyle),
	        'data-placement': popperPlacement,
	        'data-x-out-of-boundaries': popperHide
	      });
	
	      if (typeof component === 'string') {
	        componentProps.ref = this._handlePopperRef;
	      } else {
	        componentProps.innerRef = this._handlePopperRef;
	      }
	
	      return react.createElement(component, componentProps, children);
	    }
	  }]);
	  return Popper;
	}(react.Component);
	
	Popper.contextTypes = {
	  popperManager: PropTypes.object
	};
	Popper.childContextTypes = {
	  popper: PropTypes.object.isRequired
	};
	Popper.defaultProps = {
	  component: 'div',
	  placement: 'bottom',
	  eventsEnabled: true,
	  modifiers: {}
	};
	Popper.propTypes =  false ? {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  placement: PropTypes.oneOf(placements),
	  eventsEnabled: PropTypes.bool,
	  modifiers: PropTypes.object,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  target: PropTypes.oneOfType([
	  // the following check is needed for SSR
	  PropTypes.instanceOf(typeof Element !== 'undefined' ? Element : Object), PropTypes.shape({
	    getBoundingClientRect: PropTypes.func.isRequired,
	    clientWidth: PropTypes.number.isRequired,
	    clientHeight: PropTypes.number.isRequired
	  })])
	} : {};
	
	var Arrow = function Arrow(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'span' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popper = context.popper;
	
	  var arrowRef = function arrowRef(node) {
	    popper.setArrowNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	  var arrowStyle = popper.getArrowStyle();
	
	  if (typeof children === 'function') {
	    var arrowProps = {
	      ref: arrowRef,
	      style: arrowStyle
	    };
	    return children({ arrowProps: arrowProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps, {
	    style: _extends({}, arrowStyle, restProps.style)
	  });
	
	  if (typeof component === 'string') {
	    componentProps.ref = arrowRef;
	  } else {
	    componentProps.innerRef = arrowRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Arrow.contextTypes = {
	  popper: PropTypes.object.isRequired
	};
	
	Arrow.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	exports.Manager = Manager;
	exports.Target = Target;
	exports.Popper = Popper;
	exports.placements = placements;
	exports.Arrow = Arrow;
	//# sourceMappingURL=react-popper.js.map


/***/ },
/* 3382 */
[4448, 3384],
/* 3383 */
[4449, 3382],
/* 3384 */
2788,
/* 3385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(76);
	var createClass = __webpack_require__(594);
	var QuillMixin = __webpack_require__(1535);
	var find = __webpack_require__(1545);
	var some = __webpack_require__(3472);
	var isEqual = __webpack_require__(1548);
	var T = __webpack_require__(1551);
	var DOM = __webpack_require__(1504);
	
	var QuillComponent = createClass({
	
		displayName: 'Quill',
	
		mixins: [ QuillMixin ],
	
		propTypes: {
			id: T.string,
			className: T.string,
			theme: T.string,
			style: T.object,
			readOnly: T.bool,
			value: T.oneOfType([T.string, T.shape({ops: T.array})]),
			defaultValue: T.oneOfType([T.string, T.shape({ops: T.array})]),
			placeholder: T.string,
			tabIndex: T.number,
			bounds: T.oneOfType([T.string, T.element]),
			onChange: T.func,
			onChangeSelection: T.func,
			onFocus: T.func,
			onBlur: T.func,
			onKeyPress: T.func,
			onKeyDown: T.func,
			onKeyUp: T.func,
	
			modules: function(props) {
				var isNotObject = T.object.apply(this, arguments);
				if (isNotObject) return isNotObject;
	
				if (
					props.modules && 
					props.modules.toolbar &&
					props.modules.toolbar[0] &&
					props.modules.toolbar[0].type
				) return new Error(
					'Since v1.0.0, React Quill will not create a custom toolbar for you ' +
					'anymore. Create a toolbar explictly, or let Quill create one. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
				);
			},
	
			toolbar: function(props) {
				if ('toolbar' in props) return new Error(
					'The `toolbar` prop has been deprecated. Use `modules.toolbar` instead. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
				);
			},
	
			formats: function(props) {
				var isNotArrayOfString = T.arrayOf(T.string).apply(this, arguments);
	
				if (isNotArrayOfString) return new Error(
					'You cannot specify custom `formats` anymore. Use Parchment instead.  ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			styles: function(props) {
				if ('styles' in props) return new Error(
					'The `styles` prop has been deprecated. Use custom stylesheets instead. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			pollInterval: function(props) {
				if ('pollInterval' in props) return new Error(
					'The `pollInterval` property does not have any effect anymore. ' +
					'You can safely remove it from your props.' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			children: function(props) {
				// Validate that the editor has only one child element and it is not a <textarea>
				var isNotASingleElement = T.element.apply(this, arguments);
				if (isNotASingleElement) return new Error(
					'The Quill editing area can only be composed of a single React element.'
				);
	
				if (React.Children.count(props.children)) {
					var child = React.Children.only(props.children);
					if (child.type === 'textarea') return new Error(
						'Quill does not support editing on a <textarea>. Use a <div> instead.'
					);
				}
			}
		},
			
		/*
		Changing one of these props should cause a full re-render.
		*/
		dirtyProps: [
			'modules',
			'formats',
			'bounds',
			'theme',
			'children',
		],
	
		/*
		Changing one of these props should cause a regular update.
		*/
		cleanProps: [
			'id',
			'className',
			'style',
			'placeholder',
			'tabIndex',
			'onChange',
			'onChangeSelection',
			'onFocus',
			'onBlur',
			'onKeyPress',
			'onKeyDown',
			'onKeyUp',
		],
	
		getDefaultProps: function() {
			return {
				theme: 'snow',
				modules: {},
			};
		},
	
		/*
		We consider the component to be controlled if `value` is being sent in props.
		*/
		isControlled: function() {
			return 'value' in this.props;
		},
	
		getInitialState: function() {
			return {
				generation: 0,
				value: this.isControlled()
					? this.props.value
					: this.props.defaultValue
			};
		},
	
		componentWillReceiveProps: function(nextProps, nextState) {
			var editor = this.editor;
	
			// If the component is unmounted and mounted too quickly
			// an error is thrown in setEditorContents since editor is
			// still undefined. Must check if editor is undefined
			// before performing this call.
			if (!editor) return;
			
			// Update only if we've been passed a new `value`.
			// This leaves components using `defaultValue` alone.
			if ('value' in nextProps) {
				var currentContents = this.getEditorContents();
				var nextContents = nextProps.value;
	
				if (nextContents === this.lastDeltaChangeSet) throw new Error(
					'You are passing the `delta` object from the `onChange` event back ' +
					'as `value`. You most probably want `editor.getContents()` instead. ' +
					'See: https://github.com/zenoamaro/react-quill#using-deltas'
				);
	
				// NOTE: Seeing that Quill is missing a way to prevent
				//       edits, we have to settle for a hybrid between
				//       controlled and uncontrolled mode. We can't prevent
				//       the change, but we'll still override content
				//       whenever `value` differs from current state.
				// NOTE: Comparing an HTML string and a Quill Delta will always trigger 
				//       a change, regardless of whether they represent the same document.
				if (!this.isEqualValue(nextContents, currentContents)) {
					this.setEditorContents(editor, nextContents);
				}
			}
			
			// We can update readOnly state in-place.
			if ('readOnly' in nextProps) {
				if (nextProps.readOnly !== this.props.readOnly) {
					this.setEditorReadOnly(editor, nextProps.readOnly);
				}
			}
	
			// If we need to regenerate the component, we can avoid a detailed
			// in-place update step, and just let everything rerender.
			if (this.shouldComponentRegenerate(nextProps, nextState)) {
				return this.regenerate();
			}
		},
	
		componentDidMount: function() {
			this.editor = this.createEditor(
				this.getEditingArea(),
				this.getEditorConfig()
			);
			// Restore editor from Quill's native formats in regeneration scenario
			if (this.quillDelta) {
				this.editor.setContents(this.quillDelta);
				this.editor.setSelection(this.quillSelection);		
				this.editor.focus();
				this.quillDelta = this.quillSelection = null;
				return;
			}
			if (this.state.value) {
				this.setEditorContents(this.editor, this.state.value);
				return;
			}
		},
	
		componentWillUnmount: function() {
			var editor; if ((editor = this.getEditor())) {
				this.unhookEditor(editor);
				this.editor = null;
			}
		},
	
		shouldComponentUpdate: function(nextProps, nextState) {
			var self = this;
	
			// If the component has been regenerated, we already know we should update.
			if (this.state.generation !== nextState.generation) {
				return true;
			}
			
			// Compare props that require React updating the DOM.
			return some(this.cleanProps, function(prop) {
				// Note that `isEqual` compares deeply, making it safe to perform
				// non-immutable updates, at the cost of performance.
				return !isEqual(nextProps[prop], self.props[prop]);
			});
		},
	
		shouldComponentRegenerate: function(nextProps, nextState) {
			var self = this;
			// Whenever a `dirtyProp` changes, the editor needs reinstantiation.
			return some(this.dirtyProps, function(prop) {
				// Note that `isEqual` compares deeply, making it safe to perform
				// non-immutable updates, at the cost of performance.
				return !isEqual(nextProps[prop], self.props[prop]);
			});
		},
	
		/*
		If we could not update settings from the new props in-place, we have to tear
		down everything and re-render from scratch.
		*/
		componentWillUpdate: function(nextProps, nextState) {
			if (this.state.generation !== nextState.generation) {
				this.componentWillUnmount();
			}
		},
	
		componentDidUpdate: function(prevProps, prevState) {
			if (this.state.generation !== prevState.generation) {
				this.componentDidMount();
			}
		},
	
		getEditorConfig: function() {
			return {
				bounds:       this.props.bounds,
				formats:      this.props.formats,
				modules:      this.props.modules,
				placeholder:  this.props.placeholder,
				readOnly:     this.props.readOnly,
				theme:        this.props.theme,
			};
		},
	
		getEditor: function() {
			return this.editor;
		},
	
		getEditingArea: function () {
			return ReactDOM.findDOMNode(this.editingArea);
		},
	
		getEditorContents: function() {
			return this.state.value;
		},
	
		getEditorSelection: function() {
			return this.state.selection;
		},
	
		/*
		True if the value is a Delta instance or a Delta look-alike.
		*/
		isDelta: function(value) {
			return value && value.ops;
		},
	
		/*
		Special comparison function that knows how to compare Deltas.
		*/
		isEqualValue: function(value, nextValue) {
			if (this.isDelta(value) && this.isDelta(nextValue)) {
				return isEqual(value.ops, nextValue.ops);
			} else {
				return isEqual(value, nextValue);
			}
		},
	
		/*
		Regenerating the editor will cause the whole tree, including the container,
		to be cleaned up and re-rendered from scratch.
		*/
		regenerate: function() {
			// Cache selection and contents in Quill's native format to be restored later
			this.quillDelta = this.editor.getContents();
			this.quillSelection = this.editor.getSelection();
			this.setState({
				generation: this.state.generation + 1,
			});
		},
	
		/*
		Renders an editor area, unless it has been provided one to clone.
		*/
		renderEditingArea: function() {
			var self = this;
			var children = this.props.children;
	
			var properties = {
				key: this.state.generation,
				tabIndex: this.props.tabIndex,
				ref: function(element) { self.editingArea = element },
			};
	
			var customElement = React.Children.count(children)
				? React.Children.only(children)
				: null;
	
			var editingArea = customElement
				? React.cloneElement(customElement, properties)
				: DOM.div(properties);
	
			return editingArea;
		},
	
		render: function() {
			return DOM.div({
				id: this.props.id,
				style: this.props.style,
				key: this.state.generation,
				className: ['quill'].concat(this.props.className).join(' '),
				onKeyPress: this.props.onKeyPress,
				onKeyDown: this.props.onKeyDown,
				onKeyUp: this.props.onKeyUp },
				this.renderEditingArea()
			);
		},
	
		onEditorChangeText: function(value, delta, source, editor) {
			var currentContents = this.getEditorContents();
	
			// We keep storing the same type of value as what the user gives us,
			// so that value comparisons will be more stable and predictable.
			var nextContents = this.isDelta(currentContents)
				? editor.getContents()
				: editor.getHTML();
			
			if (!this.isEqualValue(nextContents, currentContents)) {
				// Taint this `delta` object, so we can recognize whether the user
				// is trying to send it back as `value`, preventing a likely loop.
				this.lastDeltaChangeSet = delta;
	
				this.setState({ value: nextContents });
	
				if (this.props.onChange) {
					this.props.onChange(value, delta, source, editor);
				}
			}
		},
	
		onEditorChangeSelection: function(nextSelection, source, editor) {
			var currentSelection = this.getEditorSelection();
			var hasGainedFocus = !currentSelection && nextSelection;
			var hasLostFocus = currentSelection && !nextSelection;
	
			if (isEqual(nextSelection, currentSelection)) {
				return;
			}
			
			this.setState({ selection: nextSelection });
			
			if (this.props.onChangeSelection) {
				this.props.onChangeSelection(nextSelection, source, editor);
			}
	
			if (hasGainedFocus && this.props.onFocus) {
				this.props.onFocus(nextSelection, source, editor);
			} else if (hasLostFocus && this.props.onBlur) {
				this.props.onBlur(currentSelection, source, editor);
			}
		},
	
		focus: function() {
			this.editor.focus();
		},
	
		blur: function() {
			this.setEditorSelection(this.editor, null);
		}
	
	});
	
	module.exports = QuillComponent;


/***/ },
/* 3386 */
/***/ function(module, exports, __webpack_require__) {

	/*
	QuillToolbar is deprecated. Consider switching to the official Quill
	toolbar format, or providing your own toolbar instead. 
	See https://quilljs.com/docs/modules/toolbar
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOMServer = __webpack_require__(3341);
	var createClass = __webpack_require__(594);
	var find = __webpack_require__(1545);
	var isEqual = __webpack_require__(1548);
	var T = __webpack_require__(1551);
	var DOM = __webpack_require__(1504);
	
	var defaultColors = [
		'rgb(  0,   0,   0)', 'rgb(230,   0,   0)', 'rgb(255, 153,   0)',
		'rgb(255, 255,   0)', 'rgb(  0, 138,   0)', 'rgb(  0, 102, 204)',
		'rgb(153,  51, 255)', 'rgb(255, 255, 255)', 'rgb(250, 204, 204)',
		'rgb(255, 235, 204)', 'rgb(255, 255, 204)', 'rgb(204, 232, 204)',
		'rgb(204, 224, 245)', 'rgb(235, 214, 255)', 'rgb(187, 187, 187)',
		'rgb(240, 102, 102)', 'rgb(255, 194, 102)', 'rgb(255, 255, 102)',
		'rgb(102, 185, 102)', 'rgb(102, 163, 224)', 'rgb(194, 133, 255)',
		'rgb(136, 136, 136)', 'rgb(161,   0,   0)', 'rgb(178, 107,   0)',
		'rgb(178, 178,   0)', 'rgb(  0,  97,   0)', 'rgb(  0,  71, 178)',
		'rgb(107,  36, 178)', 'rgb( 68,  68,  68)', 'rgb( 92,   0,   0)',
		'rgb(102,  61,   0)', 'rgb(102, 102,   0)', 'rgb(  0,  55,   0)',
		'rgb(  0,  41, 102)', 'rgb( 61,  20,  10)',
	].map(function(color){ return { value: color } });
	
	var defaultItems = [
	
		{ label:'Formats', type:'group', items: [
			{ label:'Font', type:'font', items: [
				{ label:'Sans Serif',  value:'sans-serif', selected:true },
				{ label:'Serif',       value:'serif' },
				{ label:'Monospace',   value:'monospace' }
			]},
			{ label:'Size', type:'size', items: [
				{ label:'Small',  value:'10px' },
				{ label:'Normal', value:'13px', selected:true },
				{ label:'Large',  value:'18px' },
				{ label:'Huge',   value:'32px' }
			]},
			{ label:'Alignment', type:'align', items: [
				{ label:'', value:'', selected:true },
				{ label:'', value:'center' },
				{ label:'', value:'right' },
				{ label:'', value:'justify' }
			]}
		]},
	
		{ label:'Text', type:'group', items: [
			{ type:'bold', label:'Bold' },
			{ type:'italic', label:'Italic' },
			{ type:'strike', label:'Strike' },
			{ type:'underline', label:'Underline' },
			{ type:'color', label:'Color', items:defaultColors },
			{ type:'background', label:'Background color', items:defaultColors },
			{ type:'link', label:'Link' }
		]},
	
		{ label:'Blocks', type:'group', items: [
			{ type:'list', value:'bullet' },
			{ type:'list', value:'ordered' }
		]},
	
		{ label:'Blocks', type:'group', items: [
			{ type:'image', label:'Image' }
		]}
	
	];
	
	var QuillToolbar = createClass({
	
		displayName: 'Quill Toolbar',
	
		propTypes: {
			id:        T.string,
			className: T.string,
			style:     T.object,
			items:     T.array
		},
	
		getDefaultProps: function() {
			return {
				items: defaultItems
			};
		},
	
		componentDidMount: function() {
			console.warn(
				'QuillToolbar is deprecated. Consider switching to the official Quill ' +
				'toolbar format, or providing your own toolbar instead. ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v1-0-0'
			);
		},
	
		shouldComponentUpdate: function(nextProps, nextState) {
			return !isEqual(nextProps, this.props);
		},
	
		renderGroup: function(item, key) {
			return React.DOM.span({
				key: item.label || key,
				className:'ql-formats' },
				item.items.map(this.renderItem)
			);
		},
	
		renderChoiceItem: function(item, key) {
			return React.DOM.option({
				key: item.label || item.value || key,
				value: item.value },
				item.label
			);
		},
	
		renderChoices: function(item, key) {
			var choiceItems = item.items.map(this.renderChoiceItem);
			var selectedItem = find(item.items, function(item){ return item.selected });
			var attrs = {
				key: item.label || key,
				title: item.label,
				className: 'ql-'+item.type,
				value: selectedItem.value,
			};
			return React.DOM.select(attrs, choiceItems);
		},
	
		renderButton: function(item, key) {
			return React.DOM.button({
				type: 'button',
				key: item.label || item.value || key,
				value: item.value,
				className: 'ql-'+item.type,
				title: item.label },
				item.children
			);
		},
	
		renderAction: function(item, key) {
			return React.DOM.button({
				key: item.label || item.value || key,
				className: 'ql-'+item.type,
				title: item.label },
				item.children
			);
		},
	
		/* jshint maxcomplexity: false */
		renderItem: function(item, key) {
			switch (item.type) {
				case 'group':
					return this.renderGroup(item, key);
				case 'font':
				case 'header':
				case 'align':
				case 'size':
				case 'color':
				case 'background':
					return this.renderChoices(item, key);
				case 'bold':
				case 'italic':
				case 'underline':
				case 'strike':
				case 'link':
				case 'list':
				case 'bullet':
				case 'ordered':
				case 'indent':
				case 'image':
				case 'video':
					return this.renderButton(item, key);
				default:
					return this.renderAction(item, key);
			}
		},
	
		getClassName: function() {
			return 'quill-toolbar ' + (this.props.className||'');
		},
	
		render: function() {
			var children = this.props.items.map(this.renderItem);
			var html = children.map(ReactDOMServer.renderToStaticMarkup).join('');
			return DOM.div({
				id: this.props.id,
				className: this.getClassName(),
				style: this.props.style,
				dangerouslySetInnerHTML: { __html:html }
			});
		},
	
	});
	
	module.exports = QuillToolbar;
	QuillToolbar.defaultItems = defaultItems;
	QuillToolbar.defaultColors = defaultColors;


/***/ },
/* 3387 */
[4186, 261, 156],
/* 3388 */
[4187, 3432, 3433, 3434, 3435, 3436],
/* 3389 */
[4193, 261, 156],
/* 3390 */
[4194, 261, 156],
/* 3391 */
[4195, 733, 3457, 3458],
/* 3392 */
[4198, 156],
/* 3393 */
[4199, 261, 156],
/* 3394 */
977,
/* 3395 */
[4201, 3415, 1546, 157, 1547, 736, 1550],
/* 3396 */
148,
/* 3397 */
608,
/* 3398 */
[4212, 3401, 3420],
/* 3399 */
985,
/* 3400 */
[4217, 3421],
/* 3401 */
[4218, 3400, 464],
/* 3402 */
[4220, 3397, 157],
/* 3403 */
2618,
/* 3404 */
[4225, 324, 326],
/* 3405 */
[4227, 1536, 1540, 3423, 3424, 3429, 157, 1547, 1550],
/* 3406 */
[4229, 1536, 734],
/* 3407 */
[4230, 1549, 3439, 325, 1544],
/* 3408 */
[4232, 324, 739, 326],
/* 3409 */
[4234, 3440, 3453],
/* 3410 */
[4237, 3406, 3426, 1543],
/* 3411 */
[4238, 734, 3467, 3468, 737, 1542, 1543, 461],
/* 3412 */
990,
/* 3413 */
[4242, 1538],
/* 3414 */
[4247, 3398],
/* 3415 */
993,
/* 3416 */
[4248, 457, 3396, 157, 463],
/* 3417 */
245,
/* 3418 */
392,
/* 3419 */
[4267, 156],
/* 3420 */
[4270, 462],
/* 3421 */
2660,
/* 3422 */
[4276, 735, 462, 464],
/* 3423 */
[4287, 457, 3392, 738, 1540, 3451, 3459],
/* 3424 */
[4288, 3425],
/* 3425 */
[4290, 3402, 3428, 464],
/* 3426 */
[4295, 1542, 464],
/* 3427 */
[4298, 457],
/* 3428 */
[4299, 3394, 3473],
/* 3429 */
[4301, 3387, 732, 3389, 3390, 3393, 324, 1544],
/* 3430 */
2675,
/* 3431 */
[4302, 1539, 1546, 157, 736, 739, 461],
/* 3432 */
[4303, 460],
/* 3433 */
2679,
/* 3434 */
[4304, 460],
/* 3435 */
[4305, 460],
/* 3436 */
[4306, 460],
/* 3437 */
[4310, 738, 462, 736, 325],
/* 3438 */
2688,
/* 3439 */
[4313, 3419],
/* 3440 */
302,
/* 3441 */
2690,
/* 3442 */
[4315, 458],
/* 3443 */
[4316, 458],
/* 3444 */
[4317, 458],
/* 3445 */
[4318, 458],
/* 3446 */
[4319, 3388, 456, 732],
/* 3447 */
[4320, 459],
/* 3448 */
[4321, 459],
/* 3449 */
[4322, 459],
/* 3450 */
[4323, 459],
/* 3451 */
2700,
/* 3452 */
[4324, 3470],
/* 3453 */
[4328, 3456],
/* 3454 */
[4329, 1541],
/* 3455 */
2705,
/* 3456 */
1013,
/* 3457 */
2709,
/* 3458 */
2710,
/* 3459 */
621,
/* 3460 */
[4337, 456],
/* 3461 */
2712,
/* 3462 */
2713,
/* 3463 */
2714,
/* 3464 */
[4338, 456, 732, 733],
/* 3465 */
[4341, 3452],
/* 3466 */
[4358, 3399, 735, 3476],
/* 3467 */
[4387, 1538],
/* 3468 */
[4389, 3403, 3431],
/* 3469 */
179,
/* 3470 */
[4417, 733],
/* 3471 */
[4421, 3412, 3413, 737, 461],
/* 3472 */
[4427, 1537, 735, 3414, 157, 3437],
/* 3473 */
1038,
/* 3474 */
2777,
/* 3475 */
[4434, 3477],
/* 3476 */
[4435, 3475],
/* 3477 */
[4436, 325, 463],
/* 3478 */
[4438, 3416],
/* 3479 */
[4448, 3480],
/* 3480 */
2788,
/* 3481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(1552);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(1553);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react.Children.only(children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 3482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(1552);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(3483);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(3484);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(1553);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(679);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(674);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = undefined;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure;
	  var pure = _options$pure === undefined ? true : _options$pure;
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged;
	        var hasStoreStateChanged = this.hasStoreStateChanged;
	        var haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated;
	        var statePropsPrecalculationError = this.statePropsPrecalculationError;
	        var renderedElement = this.renderedElement;
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 3483 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 3484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(332);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 3485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(1554);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload;
	        var method = _action$payload.method;
	        var args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ },
/* 3486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(1556);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  var _ref$selectLocationSt = _ref.selectLocationState;
	  var selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt;
	  var _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay;
	  var adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      listener(lastPublishedLocation);
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ },
/* 3487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollBehavior = __webpack_require__(3794);
	
	var _scrollBehavior2 = _interopRequireDefault(_scrollBehavior);
	
	var _StateStorage = __webpack_require__(3489);
	
	var _StateStorage2 = _interopRequireDefault(_StateStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  shouldUpdateScroll: _react2.default.PropTypes.func,
	  routerProps: _react2.default.PropTypes.object.isRequired,
	  children: _react2.default.PropTypes.element.isRequired
	};
	
	var childContextTypes = {
	  scrollBehavior: _react2.default.PropTypes.object.isRequired
	};
	
	var ScrollBehaviorContext = function (_React$Component) {
	  _inherits(ScrollBehaviorContext, _React$Component);
	
	  function ScrollBehaviorContext(props, context) {
	    _classCallCheck(this, ScrollBehaviorContext);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var routerProps = props.routerProps;
	    var router = routerProps.router;
	
	
	    _this.scrollBehavior = new _scrollBehavior2.default({
	      addTransitionHook: router.listenBefore,
	      stateStorage: new _StateStorage2.default(router),
	      getCurrentLocation: function getCurrentLocation() {
	        return _this.props.routerProps.location;
	      },
	      shouldUpdateScroll: _this.shouldUpdateScroll
	    });
	
	    _this.scrollBehavior.updateScroll(null, routerProps);
	    return _this;
	  }
	
	  ScrollBehaviorContext.prototype.getChildContext = function getChildContext() {
	    return {
	      scrollBehavior: this
	    };
	  };
	
	  ScrollBehaviorContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var routerProps = this.props.routerProps;
	
	    var prevRouterProps = prevProps.routerProps;
	
	    if (routerProps.location === prevRouterProps.location) {
	      return;
	    }
	
	    this.scrollBehavior.updateScroll(prevRouterProps, routerProps);
	  };
	
	  ScrollBehaviorContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollBehaviorContext.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollBehaviorContext;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	    var shouldUpdateScroll = _this2.props.shouldUpdateScroll;
	
	    if (!shouldUpdateScroll) {
	      return true;
	    }
	
	    // Hack to allow accessing scrollBehavior._stateStorage.
	    return shouldUpdateScroll.call(_this2.scrollBehavior, prevRouterProps, routerProps);
	  };
	
	  this.registerElement = function (key, element, shouldUpdateScroll) {
	    _this2.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this2.props.routerProps);
	  };
	
	  this.unregisterElement = function (key) {
	    _this2.scrollBehavior.unregisterElement(key);
	  };
	};
	
	ScrollBehaviorContext.propTypes = propTypes;
	ScrollBehaviorContext.childContextTypes = childContextTypes;
	
	exports.default = ScrollBehaviorContext;
	module.exports = exports['default'];

/***/ },
/* 3488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(76);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(3492);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  scrollKey: _react2.default.PropTypes.string.isRequired,
	  shouldUpdateScroll: _react2.default.PropTypes.func,
	  children: _react2.default.PropTypes.element.isRequired
	};
	
	var contextTypes = {
	  // This is necessary when rendering on the client. However, when rendering on
	  // the server, this container will do nothing, and thus does not require the
	  // scroll behavior context.
	  scrollBehavior: _react2.default.PropTypes.object
	};
	
	var ScrollContainer = function (_React$Component) {
	  _inherits(ScrollContainer, _React$Component);
	
	  function ScrollContainer(props, context) {
	    _classCallCheck(this, ScrollContainer);
	
	    // We don't re-register if the scroll key changes, so make sure we
	    // unregister with the initial scroll key just in case the user changes it.
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior._stateStorage.
	      return shouldUpdateScroll.call(_this.context.scrollBehavior.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.scrollKey = props.scrollKey;
	    return _this;
	  }
	
	  ScrollContainer.prototype.componentDidMount = function componentDidMount() {
	    this.context.scrollBehavior.registerElement(this.props.scrollKey, _reactDom2.default.findDOMNode(this), // eslint-disable-line react/no-find-dom-node
	    this.shouldUpdateScroll);
	
	    // Only keep around the current DOM node in development, as this is only
	    // for emitting the appropriate warning.
	    if (false) {
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	    }
	  };
	
	  ScrollContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	     false ? (0, _warning2.default)(nextProps.scrollKey === this.props.scrollKey, '<ScrollContainer> does not support changing scrollKey.') : void 0;
	  };
	
	  ScrollContainer.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (false) {
	      var prevDomNode = this.domNode;
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	
	      process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(this.domNode === prevDomNode, '<ScrollContainer> does not support changing DOM node.') : void 0;
	    }
	  };
	
	  ScrollContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.context.scrollBehavior.unregisterElement(this.scrollKey);
	  };
	
	  ScrollContainer.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollContainer;
	}(_react2.default.Component);
	
	ScrollContainer.propTypes = propTypes;
	ScrollContainer.contextTypes = contextTypes;
	
	exports.default = ScrollContainer;
	module.exports = exports['default'];

/***/ },
/* 3489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DOMStateStorage = __webpack_require__(670);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var STATE_KEY_PREFIX = '@@scroll|';
	
	var StateStorage = function () {
	  function StateStorage(router) {
	    _classCallCheck(this, StateStorage);
	
	    this.getFallbackLocationKey = router.createPath;
	  }
	
	  StateStorage.prototype.read = function read(location, key) {
	    return (0, _DOMStateStorage.readState)(this.getStateKey(location, key));
	  };
	
	  StateStorage.prototype.save = function save(location, key, value) {
	    (0, _DOMStateStorage.saveState)(this.getStateKey(location, key), value);
	  };
	
	  StateStorage.prototype.getStateKey = function getStateKey(location, key) {
	    var locationKey = location.key || this.getFallbackLocationKey(location);
	    var stateKeyBase = '' + STATE_KEY_PREFIX + locationKey;
	    return key == null ? stateKeyBase : stateKeyBase + '|' + key;
	  };
	
	  return StateStorage;
	}();
	
	exports.default = StateStorage;
	module.exports = exports['default'];

/***/ },
/* 3490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.useScroll = exports.ScrollContainer = undefined;
	
	var _ScrollContainer2 = __webpack_require__(3488);
	
	var _ScrollContainer3 = _interopRequireDefault(_ScrollContainer2);
	
	var _useScroll2 = __webpack_require__(3491);
	
	var _useScroll3 = _interopRequireDefault(_useScroll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ScrollContainer = _ScrollContainer3.default;
	exports.useScroll = _useScroll3.default;

/***/ },
/* 3491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useScroll;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollBehaviorContext = __webpack_require__(3487);
	
	var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useScroll(shouldUpdateScroll) {
	  return {
	    renderRouterContext: function renderRouterContext(child, props) {
	      return _react2.default.createElement(
	        _ScrollBehaviorContext2.default,
	        {
	          shouldUpdateScroll: shouldUpdateScroll,
	          routerProps: props
	        },
	        child
	      );
	    }
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 3492 */
141,
/* 3493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 3494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(1557);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 3495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(1558);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 3496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(183);
	
	var _InternalPropTypes = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 3497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 3498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(183);
	
	var _InternalPropTypes = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 3499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 3500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(1285);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(421);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(742);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(216);
	
	var _RouterContext = __webpack_require__(465);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(183);
	
	var _RouterUtils = __webpack_require__(1559);
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 3501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(465);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 3502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(740);
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 3503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(465);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 3504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(2929);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(1561);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 3505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(262);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 3506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(740);
	
	var _makeStateWithLocation = __webpack_require__(1562);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 3507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(262);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 3508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(1285);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(1561);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 3509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(262);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 3510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(249);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(1560);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(742);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(183);
	
	var _RouterUtils = __webpack_require__(1559);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 3511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(740);
	
	var _makeStateWithLocation = __webpack_require__(1562);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(262);
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 3512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(421);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(742);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(70);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 3513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(674);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(741);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 3514 */
141,
/* 3515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var Helpers = __webpack_require__(467);
	
	var Button = React.createClass({
	  render: function () {
	    return React.DOM.input(this.props, this.props.children);
	  }
	});
	
	module.exports = Helpers.Scroll(Button);


/***/ },
/* 3516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var Helpers = __webpack_require__(467);
	
	var Element = React.createClass({
	  render: function () {
	    return React.DOM.div(this.props, this.props.children);
	  }
	});
	
	module.exports = Helpers.Element(Element);


/***/ },
/* 3517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var Helpers = __webpack_require__(467);
	
	var Link = React.createClass({
	  render: function () {
	    return React.DOM.a(this.props, this.props.children);
	  }
	});
	
	module.exports = Helpers.Scroll(Link);


/***/ },
/* 3518 */
/***/ function(module, exports, __webpack_require__) {

	var addPassiveEventListener = __webpack_require__(1564);
	
	var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown']
	
	module.exports = {
		register : function(cancelEvent) {
			if (typeof document === 'undefined') {
				return;
			}
	
			for(var i = 0; i < events.length; i = i + 1) {
				addPassiveEventListener(document, events[i], cancelEvent);
			}
		}
	};


/***/ },
/* 3519 */
/***/ function(module, exports) {

	module.exports = {
	 /*
	  * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
	  */
	  defaultEasing : function (x) {
	    'use strict';
	
	    if(x < 0.5) {
	      return Math.pow(x*2, 2)/2;
	    }
	    return 1-Math.pow((1-x)*2, 2)/2;
	  }
	}

/***/ },
/* 3520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(328);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _utilsStripDiacritics = __webpack_require__(1569);
	
	var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);
	
	var propTypes = {
		autoload: _react2['default'].PropTypes.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _react2['default'].PropTypes.any, // object to use to cache results; set to null/false to disable caching
		children: _react2['default'].PropTypes.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _react2['default'].PropTypes.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _react2['default'].PropTypes.bool, // perform case-insensitive filtering; defaults to true
		loadingPlaceholder: _react.PropTypes.string.isRequired, // replaces the placeholder while options are loading
		loadOptions: _react2['default'].PropTypes.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		options: _react.PropTypes.array.isRequired, // array of options
		placeholder: _react2['default'].PropTypes.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		searchPromptText: _react2['default'].PropTypes.oneOfType([// label to prompt for search input
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node])
	};
	
	var defaultProps = {
		autoload: true,
		cache: {},
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = (function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);
	
			this.state = {
				isLoading: false,
				options: props.options
			};
	
			this._onInputChange = this._onInputChange.bind(this);
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {
				var _this = this;
	
				var propertiesToSync = ['options'];
				propertiesToSync.forEach(function (prop) {
					if (_this.props[prop] !== nextProps[prop]) {
						_this.setState(_defineProperty({}, prop, nextProps[prop]));
					}
				});
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var _props = this.props;
				var cache = _props.cache;
				var loadOptions = _props.loadOptions;
	
				if (cache && cache.hasOwnProperty(inputValue)) {
					this.setState({
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						var options = data && data.options || [];
	
						if (cache) {
							cache[inputValue] = options;
						}
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
	
				return inputValue;
			}
		}, {
			key: '_onInputChange',
			value: function _onInputChange(inputValue) {
				var _props2 = this.props;
				var ignoreAccents = _props2.ignoreAccents;
				var ignoreCase = _props2.ignoreCase;
	
				if (ignoreAccents) {
					inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
				}
	
				if (ignoreCase) {
					inputValue = inputValue.toLowerCase();
				}
	
				return this.loadOptions(inputValue);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props3 = this.props;
				var children = _props3.children;
				var loadingPlaceholder = _props3.loadingPlaceholder;
				var placeholder = _props3.placeholder;
				var searchPromptText = _props3.searchPromptText;
				var _state = this.state;
				var isLoading = _state.isLoading;
				var options = _state.options;
	
				var props = {
					noResultsText: isLoading ? loadingPlaceholder : searchPromptText,
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading ? [] : options
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this._onInputChange
				}));
			}
		}]);
	
		return Async;
	})(_react.Component);
	
	exports['default'] = Async;
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;
	
	function defaultChildren(props) {
		return _react2['default'].createElement(_Select2['default'], props);
	};
	module.exports = exports['default'];

/***/ },
/* 3521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(328);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var AsyncCreatable = _react2['default'].createClass({
		displayName: 'AsyncCreatableSelect',
	
		render: function render() {
			var _this = this;
	
			return _react2['default'].createElement(
				_Select2['default'].Async,
				this.props,
				function (asyncProps) {
					return _react2['default'].createElement(
						_Select2['default'].Creatable,
						_this.props,
						function (creatableProps) {
							return _react2['default'].createElement(_Select2['default'], _extends({}, asyncProps, creatableProps, {
								onInputChange: function (input) {
									creatableProps.onInputChange(input);
									return asyncProps.onInputChange(input);
								}
							}));
						}
					);
				}
			);
		}
	});
	
	module.exports = AsyncCreatable;

/***/ },
/* 3522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(328);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _utilsDefaultFilterOptions = __webpack_require__(1567);
	
	var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
	var _utilsDefaultMenuRenderer = __webpack_require__(1568);
	
	var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
	var Creatable = _react2['default'].createClass({
		displayName: 'CreatableSelect',
	
		propTypes: {
			// Child function responsible for creating the inner Select component
			// This component can be used to compose HOCs (eg Creatable and Async)
			// (props: Object): PropTypes.element
			children: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.filterOptions
			filterOptions: _react2['default'].PropTypes.any,
	
			// Searches for any matching option within the set of options.
			// This function prevents duplicate options from being created.
			// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
			isOptionUnique: _react2['default'].PropTypes.func,
	
			// Determines if the current input text represents a valid option.
			// ({ label: string }): boolean
			isValidNewOption: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.menuRenderer
			menuRenderer: _react2['default'].PropTypes.any,
	
			// Factory to create new option.
			// ({ label: string, labelKey: string, valueKey: string }): Object
			newOptionCreator: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.options
			options: _react2['default'].PropTypes.array,
	
			// Creates prompt/placeholder option text.
			// (filterText: string): string
			promptTextCreator: _react2['default'].PropTypes.func,
	
			// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
			shouldKeyDownEventCreateNewOption: _react2['default'].PropTypes.func
		},
	
		// Default prop methods
		statics: {
			isOptionUnique: isOptionUnique,
			isValidNewOption: isValidNewOption,
			newOptionCreator: newOptionCreator,
			promptTextCreator: promptTextCreator,
			shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
		},
	
		getDefaultProps: function getDefaultProps() {
			return {
				filterOptions: _utilsDefaultFilterOptions2['default'],
				isOptionUnique: isOptionUnique,
				isValidNewOption: isValidNewOption,
				menuRenderer: _utilsDefaultMenuRenderer2['default'],
				newOptionCreator: newOptionCreator,
				promptTextCreator: promptTextCreator,
				shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
			};
		},
	
		createNewOption: function createNewOption() {
			var _props = this.props;
			var isValidNewOption = _props.isValidNewOption;
			var newOptionCreator = _props.newOptionCreator;
			var _props$options = _props.options;
			var options = _props$options === undefined ? [] : _props$options;
			var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;
	
			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option });
	
				// Don't add the same option twice.
				if (_isOptionUnique) {
					options.unshift(option);
	
					this.select.selectValue(option);
				}
			}
		},
	
		filterOptions: function filterOptions() {
			var _props2 = this.props;
			var filterOptions = _props2.filterOptions;
			var isValidNewOption = _props2.isValidNewOption;
			var options = _props2.options;
			var promptTextCreator = _props2.promptTextCreator;
	
			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
			var excludeOptions = arguments[2] || [];
	
			var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;
	
				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});
	
				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});
	
				if (_isOptionUnique2) {
					var _prompt = promptTextCreator(this.inputValue);
	
					this._createPlaceholderOption = _newOptionCreator({
						label: _prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}
	
			return filteredOptions;
		},
	
		isOptionUnique: function isOptionUnique(_ref2) {
			var option = _ref2.option;
			var options = _ref2.options;
			var isOptionUnique = this.props.isOptionUnique;
	
			options = options || this.select.filterOptions();
	
			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		},
	
		menuRenderer: function menuRenderer(params) {
			var menuRenderer = this.props.menuRenderer;
	
			return menuRenderer(_extends({}, params, {
				onSelect: this.onOptionSelect
			}));
		},
	
		onInputChange: function onInputChange(input) {
			// This value may be needed in between Select mounts (when this.select is null)
			this.inputValue = input;
		},
	
		onInputKeyDown: function onInputKeyDown(event) {
			var shouldKeyDownEventCreateNewOption = this.props.shouldKeyDownEventCreateNewOption;
	
			var focusedOption = this.select.getFocusedOption();
	
			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();
	
				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			}
		},
	
		onOptionSelect: function onOptionSelect(option, event) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		},
	
		render: function render() {
			var _this = this;
	
			var _props3 = this.props;
			var _props3$children = _props3.children;
			var children = _props3$children === undefined ? defaultChildren : _props3$children;
			var newOptionCreator = _props3.newOptionCreator;
			var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
	
			var restProps = _objectWithoutProperties(_props3, ['children', 'newOptionCreator', 'shouldKeyDownEventCreateNewOption']);
	
			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref) {
					_this.select = _ref;
	
					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref) {
						_this.labelKey = _ref.props.labelKey;
						_this.valueKey = _ref.props.valueKey;
					}
				}
			});
	
			return children(props);
		}
	});
	
	function defaultChildren(props) {
		return _react2['default'].createElement(_Select2['default'], props);
	};
	
	function isOptionUnique(_ref3) {
		var option = _ref3.option;
		var options = _ref3.options;
		var labelKey = _ref3.labelKey;
		var valueKey = _ref3.valueKey;
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	function isValidNewOption(_ref4) {
		var label = _ref4.label;
	
		return !!label;
	};
	
	function newOptionCreator(_ref5) {
		var label = _ref5.label;
		var labelKey = _ref5.labelKey;
		var valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
		return option;
	};
	
	function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	}
	
	function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
		}
	
		return false;
	};
	
	module.exports = Creatable;

/***/ },
/* 3523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Option = _react2['default'].createClass({
		displayName: 'Option',
	
		propTypes: {
			children: _react2['default'].PropTypes.node,
			className: _react2['default'].PropTypes.string, // className (based on mouse position)
			instancePrefix: _react2['default'].PropTypes.string.isRequired, // unique prefix for the ids (used for aria)
			isDisabled: _react2['default'].PropTypes.bool, // the option is disabled
			isFocused: _react2['default'].PropTypes.bool, // the option is focused
			isSelected: _react2['default'].PropTypes.bool, // the option is selected
			onFocus: _react2['default'].PropTypes.func, // method to handle mouseEnter on option element
			onSelect: _react2['default'].PropTypes.func, // method to handle click on option element
			onUnfocus: _react2['default'].PropTypes.func, // method to handle mouseLeave on option element
			option: _react2['default'].PropTypes.object.isRequired, // object that is base for that option
			optionIndex: _react2['default'].PropTypes.number },
		// index of the option, used to generate unique ids for aria
		blockEvent: function blockEvent(event) {
			event.preventDefault();
			event.stopPropagation();
			if (event.target.tagName !== 'A' || !('href' in event.target)) {
				return;
			}
			if (event.target.target) {
				window.open(event.target.href, event.target.target);
			} else {
				window.location.href = event.target.href;
			}
		},
	
		handleMouseDown: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		},
	
		handleMouseEnter: function handleMouseEnter(event) {
			this.onFocus(event);
		},
	
		handleMouseMove: function handleMouseMove(event) {
			this.onFocus(event);
		},
	
		handleTouchEnd: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			this.handleMouseDown(event);
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		onFocus: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		},
		render: function render() {
			var _props = this.props;
			var option = _props.option;
			var instancePrefix = _props.instancePrefix;
			var optionIndex = _props.optionIndex;
	
			var className = (0, _classnames2['default'])(this.props.className, option.className);
	
			return option.disabled ? _react2['default'].createElement(
				'div',
				{ className: className,
					onMouseDown: this.blockEvent,
					onClick: this.blockEvent },
				this.props.children
			) : _react2['default'].createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	});
	
	module.exports = Option;

/***/ },
/* 3524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Value = _react2['default'].createClass({
	
		displayName: 'Value',
	
		propTypes: {
			children: _react2['default'].PropTypes.node,
			disabled: _react2['default'].PropTypes.bool, // disabled prop passed to ReactSelect
			id: _react2['default'].PropTypes.string, // Unique id for the value - used for aria
			onClick: _react2['default'].PropTypes.func, // method to handle click on value label
			onRemove: _react2['default'].PropTypes.func, // method to handle removal of the value
			value: _react2['default'].PropTypes.object.isRequired },
	
		// the option object for this value
		handleMouseDown: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		},
	
		onRemove: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		},
	
		handleTouchEndRemove: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Fire the mouse events
			this.onRemove(event);
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		renderRemoveIcon: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'×'
			);
		},
	
		renderLabel: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : _react2['default'].createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		},
	
		render: function render() {
			return _react2['default'].createElement(
				'div',
				{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	
	});
	
	module.exports = Value;

/***/ },
/* 3525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports["default"] = arrowRenderer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2["default"].createElement("span", {
			className: "Select-arrow",
			onMouseDown: onMouseDown
		});
	}
	
	;
	module.exports = exports["default"];

/***/ },
/* 3526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(4078));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ },
/* 3527 */
/***/ function(module, exports, __webpack_require__) {

	!function(t,n){ true?n(exports,__webpack_require__(1)):"function"==typeof define&&define.amd?define(["exports","react"],n):n((t=t||self).ReactStepWizard={},t.React)}(this,function(t,o){"use strict";var i="default"in o?o.default:o;function s(t){return(s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function c(t,n){for(var e=0;e<n.length;e++){var a=n[e];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(t,a.key,a)}}function p(t,n,e){return n in t?Object.defineProperty(t,n,{value:e,enumerable:!0,configurable:!0,writable:!0}):t[n]=e,t}function r(t){return(r=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function f(t,n){return(f=Object.setPrototypeOf||function(t,n){return t.__proto__=n,t})(t,n)}function u(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function l(e){var a=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,n=r(e);return t=a?(t=r(this).constructor,Reflect.construct(n,arguments,t)):n.apply(this,arguments),n=this,!(t=t)||"object"!=typeof t&&"function"!=typeof t?u(n):t}}function n(t,n){var e,a=(n=void 0===n?{}:n).insertAt;t&&"undefined"!=typeof document&&(e=document.head||document.getElementsByTagName("head")[0],(n=document.createElement("style")).type="text/css","top"===a&&e.firstChild?e.insertBefore(n,e.firstChild):e.appendChild(n),n.styleSheet?n.styleSheet.cssText=t:n.appendChild(document.createTextNode(t)))}var d={animated:"rsw_1z",fadeInRight:"rsw_1M",fadeInLeft:"rsw_19",fadeOutRight:"rsw_3C",fadeOutLeft:"rsw_1u"};n("/**\n * Snippets from animate.css\n * Credit goes to https://github.com/daneden\n * github.com/daneden/animate.css\n*/\n.rsw_1z {\n  -webkit-animation-duration: .8192s;\n  animation-duration: .8192s;\n  -webkit-animation-fill-mode: backwards;\n  animation-fill-mode: backwards;\n}\n\n/** fadeInRight */\n@-webkit-keyframes rsw_1M {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes rsw_1M {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.rsw_1M {\n  -webkit-animation-name: rsw_1M;\n  animation-name: rsw_1M;\n}\n\n/** fadeInLeft */\n@-webkit-keyframes rsw_19 {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes rsw_19 {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.rsw_19 {\n  -webkit-animation-name: rsw_19;\n  animation-name: rsw_19;\n}\n\n/** fadeOutRight */\n@-webkit-keyframes rsw_3C {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n@keyframes rsw_3C {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n.rsw_3C {\n  -webkit-animation-name: rsw_3C;\n  animation-name: rsw_3C;\n}\n\n/** fadeOutLeft */\n@-webkit-keyframes rsw_1u {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n@keyframes rsw_1u {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n.rsw_1u {\n  -webkit-animation-name: rsw_1u;\n  animation-name: rsw_1u;\n}\n");var m="rsw_2Y",a="rsw_2f",h="rsw_3G";n("/** Step Wizard */\n.rsw_2Y {\n    position: relative;\n}\n\n.rsw_2f {\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 0;\n}\n\n.rsw_3G {\n    opacity: 1;\n    pointer-events: inherit;\n    position: relative;\n    z-index: 1;\n}\n");var e=function(){!function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),n&&f(t,n)}(r,o.PureComponent);var t,n,e,a=l(r);function r(t){var o;return function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,r),p(u(o=a.call(this,t)),"initialState",function(){var e={activeStep:0,classes:{},hashKeys:{},namedSteps:{}},t="object"===("undefined"==typeof window?"undefined":s(window))?o.getHash():"",n=o.getSteps();n.forEach(function(t,n){e.hashKeys[n]=t.props&&t.props.hashKey||"step".concat(n+1),e.hashKeys[e.hashKeys[n]]=n,e.namedSteps[n]=t.props&&t.props.stepName||"step".concat(n+1),e.namedSteps[e.namedSteps[n]]=n});var a=o.props.initialStep-1;return a&&n[a]&&(e.activeStep=a),o.props.isHashEnabled&&t&&void 0!==e.hashKeys[t]&&(e.activeStep=e.hashKeys[t]),o.props.transitions&&(e.classes[e.activeStep]=o.props.transitions.intro||""),e}),p(u(o),"getHash",function(){return decodeURI(window.location.hash).replace(/^#/,"")}),p(u(o),"getTransitions",function(){return o.props.transitions||{enterRight:"".concat(d.animated," ").concat(d.fadeInRight),enterLeft:"".concat(d.animated," ").concat(d.fadeInLeft),exitRight:"".concat(d.animated," ").concat(d.fadeOutRight),exitLeft:"".concat(d.animated," ").concat(d.fadeOutLeft)}}),p(u(o),"onHashChange",function(){o.setActiveStep(o.state.hashKeys[o.getHash()]||0)}),p(u(o),"isInvalidStep",function(t){return t<0||t>=o.totalSteps}),p(u(o),"setActiveStep",function(t){var n,e,a=o.state.activeStep;a!==t&&(o.isInvalidStep(t)?"production"!==("production")&&console.error("".concat(t+1," is an invalid step")):(n=o.state.classes,e=o.getTransitions(),a<t?(n[a]=e.exitLeft,n[t]=e.enterRight):(n[a]=e.exitRight,n[t]=e.enterLeft),o.setState({activeStep:t,classes:n},function(){o.onStepChange({previousStep:a+1,activeStep:t+1})})))}),p(u(o),"onStepChange",function(t){o.props.onStepChange(t),o.props.isHashEnabled&&o.updateHash(o.state.activeStep)}),p(u(o),"getSteps",function(){return i.Children.toArray(o.props.children)}),p(u(o),"firstStep",function(){return o.goToStep(1)}),p(u(o),"lastStep",function(){return o.goToStep(o.totalSteps)}),p(u(o),"nextStep",function(){return o.setActiveStep(o.state.activeStep+1)}),p(u(o),"previousStep",function(){return o.setActiveStep(o.state.activeStep-1)}),p(u(o),"goToStep",function(t){o.props.isHashEnabled&&"string"==typeof t&&void 0!==o.state.hashKeys[t]?o.setActiveStep(o.state.hashKeys[t]):o.setActiveStep(t-1)}),p(u(o),"goToNamedStep",function(t){"string"==typeof t&&void 0!==o.state.namedSteps[t]?o.setActiveStep(o.state.namedSteps[t]):console.error('Cannot find step with name "'.concat(t,'"'))}),p(u(o),"updateHash",function(t){window.location.hash=o.state.hashKeys[t]}),p(u(o),"isReactComponent",function(t){t=t.type;return"function"==typeof t||"object"===s(t)}),o.state=o.initialState(),o}return t=r,(n=[{key:"componentDidMount",value:function(){this.props.isHashEnabled&&window.addEventListener("hashchange",this.onHashChange),this.props.instance(this)}},{key:"componentWillUnmount",value:function(){this.props.isHashEnabled&&window.removeEventListener("hashchange",this.onHashChange)}},{key:"currentStep",get:function(){return this.state.activeStep+1}},{key:"totalSteps",get:function(){return this.getSteps().length}},{key:"render",value:function(){var e=this,a={currentStep:this.currentStep,totalSteps:this.totalSteps,nextStep:this.nextStep,previousStep:this.previousStep,goToStep:this.goToStep,goToNamedStep:this.goToNamedStep,firstStep:this.firstStep,lastStep:this.lastStep},o=this.state.classes,t=i.Children.map(this.getSteps(),function(t,n){return t?(a.isActive=n===e.state.activeStep,a.transitions=o[n],!e.props.isLazyMount||e.props.isLazyMount&&a.isActive?i.createElement(y,a,e.isReactComponent(t)?i.cloneElement(t,a):t):null):null});return i.createElement("div",{className:this.props.className},this.props.nav&&i.cloneElement(this.props.nav,a),i.createElement("div",{className:m},t))}}])&&c(t.prototype,n),e&&c(t,e),r}();e.defaultProps={children:[],className:null,initialStep:1,instance:function(){},isHashEnabled:!1,isLazyMount:!1,nav:null,onStepChange:function(){},transitions:void 0};var y=function(t){var n=t.children,e=t.isActive,t=t.transitions;return i.createElement("div",{className:"".concat(a," ").concat(t," ").concat(e?h:"").trim()},n)};("production"),y.defaultProps={children:[],isActive:!1,transitions:""},t.Step=y,t.default=e,Object.defineProperty(t,"__esModule",{value:!0})});


/***/ },
/* 3528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TagCloud = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultRenderer = __webpack_require__(3529);
	
	var _arrayShuffle = __webpack_require__(1823);
	
	var _arrayShuffle2 = _interopRequireDefault(_arrayShuffle);
	
	var _randomcolor = __webpack_require__(3532);
	
	var _randomcolor2 = _interopRequireDefault(_randomcolor);
	
	var _helpers = __webpack_require__(3530);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var eventHandlers = ['onClick', 'onDoubleClick', 'onMouseMove'];
	var cloudProps = ['tags', 'shuffle', 'renderer', 'maxSize', 'minSize', 'colorOptions', 'disableRandomColor'];
	
	var generateColor = function generateColor(tag, _ref) {
	  var disableRandomColor = _ref.disableRandomColor,
	      colorOptions = _ref.colorOptions;
	
	  if (tag.color) {
	    return tag.color;
	  }
	  if (disableRandomColor) {
	    return undefined;
	  }
	  return (0, _randomcolor2.default)(colorOptions);
	};
	
	var TagCloud = exports.TagCloud = function (_React$Component) {
	  _inherits(TagCloud, _React$Component);
	
	  function TagCloud() {
	    _classCallCheck(this, TagCloud);
	
	    return _possibleConstructorReturn(this, (TagCloud.__proto__ || Object.getPrototypeOf(TagCloud)).apply(this, arguments));
	  }
	
	  _createClass(TagCloud, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var tags = newProps.tags,
	          shuffle = newProps.shuffle,
	          disableRandomColor = newProps.disableRandomColor;
	
	      var dataEquals = (0, _helpers.arraysEqual)(tags, this.props.tags) && shuffle == this.props.shuffle && disableRandomColor == this.props.disableRandomColor;
	      if (!dataEquals) {
	        this._populate(newProps);
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this._populate(this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = (0, _helpers.omitProps)(this.props, [].concat(cloudProps, eventHandlers));
	      var tagElements = this._attachEventHandlers();
	      return _react2.default.createElement(
	        'div',
	        props,
	        tagElements
	      );
	    }
	  }, {
	    key: '_attachEventHandlers',
	    value: function _attachEventHandlers() {
	      var _this2 = this;
	
	      var cloudHandlers = (0, _helpers.includeProps)(this.props, eventHandlers);
	      return this._data.map(function (_ref2) {
	        var tag = _ref2.tag,
	            fontSize = _ref2.fontSize,
	            color = _ref2.color;
	
	        var elem = _this2.props.renderer(tag, fontSize, color);
	        var tagHandlers = (0, _helpers.includeProps)(elem.props, eventHandlers);
	        var globalHandlers = Object.keys(cloudHandlers).reduce(function (r, k) {
	          r[k] = function (e) {
	            cloudHandlers[k](tag, e);
	            tagHandlers[k] && tagHandlers(e);
	          };
	          return r;
	        }, {});
	        return _react2.default.cloneElement(elem, globalHandlers);
	      });
	    }
	  }, {
	    key: '_populate',
	    value: function _populate(props) {
	      var tags = props.tags,
	          shuffle = props.shuffle,
	          minSize = props.minSize,
	          maxSize = props.maxSize;
	
	      var counts = tags.map(function (tag) {
	        return tag.count;
	      }),
	          min = Math.min.apply(Math, _toConsumableArray(counts)),
	          max = Math.max.apply(Math, _toConsumableArray(counts));
	      var data = tags.map(function (tag) {
	        return {
	          tag: tag,
	          color: generateColor(tag, props),
	          fontSize: (0, _helpers.fontSizeConverter)(tag.count, min, max, minSize, maxSize)
	        };
	      });
	      this._data = shuffle ? (0, _arrayShuffle2.default)(data) : data;
	    }
	  }]);
	
	  return TagCloud;
	}(_react2.default.Component);
	
	TagCloud.propTypes = {
	  tags: _react2.default.PropTypes.array.isRequired,
	  maxSize: _react2.default.PropTypes.number.isRequired,
	  minSize: _react2.default.PropTypes.number.isRequired,
	  shuffle: _react2.default.PropTypes.bool,
	  colorOptions: _react2.default.PropTypes.object,
	  disableRandomColor: _react2.default.PropTypes.bool,
	  renderer: _react2.default.PropTypes.func,
	  className: _react2.default.PropTypes.string
	};
	
	TagCloud.defaultProps = {
	  renderer: _defaultRenderer.defaultRenderer,
	  shuffle: true,
	  className: 'tag-cloud',
	  colorOptions: {}
	};

/***/ },
/* 3529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultRenderer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(45);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultRenderer = exports.defaultRenderer = function defaultRenderer(tag, size, color) {
	  var fontSize = size + 'px';
	  var key = tag.key || tag.value;
	  var style = (0, _objectAssign2.default)({}, styles, { color: color, fontSize: fontSize });
	  return _react2.default.createElement(
	    'span',
	    { className: 'tag-cloud-tag', style: style, key: key },
	    tag.value
	  );
	};
	
	var styles = {
	  margin: '0px 3px',
	  verticalAlign: 'middle',
	  display: 'inline-block'
	};

/***/ },
/* 3530 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Creates new object from target excluding given properties.
	 */
	var omitProps = exports.omitProps = function omitProps(target, props) {
	  return Object.keys(target).reduce(function (r, key) {
	    if (!~props.indexOf(key)) {
	      r[key] = target[key];
	    }
	    return r;
	  }, {});
	};
	
	/**
	 * Creates new object from target including all available properties.
	 */
	var includeProps = exports.includeProps = function includeProps(target, props) {
	  return Object.keys(target).reduce(function (r, key) {
	    if (~props.indexOf(key) && key in target) {
	      r[key] = target[key];
	    }
	    return r;
	  }, {});
	};
	
	/**
	 * Computes appropriate font size of tag.
	 */
	var fontSizeConverter = exports.fontSizeConverter = function fontSizeConverter(count, min, max, minSize, maxSize) {
	  return Math.round((count - min) * (maxSize - minSize) / (max - min) + minSize);
	};
	
	/**
	 * Returns true if arrays contains the same elements.
	 */
	var arraysEqual = exports.arraysEqual = function arraysEqual(arr1, arr2) {
	  if (arr1.length !== arr2.length) {
	    return false;
	  }
	  return arr1.every(function (o, i) {
	    return o === arr2[i];
	  });
	};

/***/ },
/* 3531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TagCloud = __webpack_require__(3528);
	
	Object.defineProperty(exports, 'TagCloud', {
	  enumerable: true,
	  get: function get() {
	    return _TagCloud.TagCloud;
	  }
	});

/***/ },
/* 3532 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// randomColor by David Merfield under the CC0 license
	// https://github.com/davidmerfield/randomColor/
	
	;(function(root, factory) {
	
	  // Support AMD
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Support CommonJS
	  } else if (typeof exports === 'object') {
	    var randomColor = factory();
	
	    // Support NodeJS & Component, which allow module.exports to be a function
	    if (typeof module === 'object' && module && module.exports) {
	      exports = module.exports = randomColor;
	    }
	
	    // Support CommonJS 1.1.1 spec
	    exports.randomColor = randomColor;
	
	  // Support vanilla script loading
	  } else {
	    root.randomColor = factory();
	  }
	
	}(this, function() {
	
	  // Seed to get repeatable colors
	  var seed = null;
	
	  // Shared color dictionary
	  var colorDictionary = {};
	
	  // Populate the color dictionary
	  loadColorBounds();
	
	  var randomColor = function (options) {
	
	    options = options || {};
	
	    // Check if there is a seed and ensure it's an
	    // integer. Otherwise, reset the seed value.
	    if (options.seed && options.seed === parseInt(options.seed, 10)) {
	      seed = options.seed;
	
	    // A string was passed as a seed
	    } else if (typeof options.seed === 'string') {
	      seed = stringToInteger(options.seed);
	
	    // Something was passed as a seed but it wasn't an integer or string
	    } else if (options.seed !== undefined && options.seed !== null) {
	      throw new TypeError('The seed value must be an integer or string');
	
	    // No seed, reset the value outside.
	    } else {
	      seed = null;
	    }
	
	    var H,S,B;
	
	    // Check if we need to generate multiple colors
	    if (options.count !== null && options.count !== undefined) {
	
	      var totalColors = options.count,
	          colors = [];
	
	      options.count = null;
	
	      while (totalColors > colors.length) {
	
	        // Since we're generating multiple colors,
	        // incremement the seed. Otherwise we'd just
	        // generate the same color each time...
	        if (seed && options.seed) options.seed += 1;
	
	        colors.push(randomColor(options));
	      }
	
	      options.count = totalColors;
	
	      return colors;
	    }
	
	    // First we pick a hue (H)
	    H = pickHue(options);
	
	    // Then use H to determine saturation (S)
	    S = pickSaturation(H, options);
	
	    // Then use S and H to determine brightness (B).
	    B = pickBrightness(H, S, options);
	
	    // Then we return the HSB color in the desired format
	    return setFormat([H,S,B], options);
	  };
	
	  function pickHue (options) {
	
	    var hueRange = getHueRange(options.hue),
	        hue = randomWithin(hueRange);
	
	    // Instead of storing red as two seperate ranges,
	    // we group them, using negative numbers
	    if (hue < 0) {hue = 360 + hue;}
	
	    return hue;
	
	  }
	
	  function pickSaturation (hue, options) {
	
	    if (options.luminosity === 'random') {
	      return randomWithin([0,100]);
	    }
	
	    if (options.hue === 'monochrome') {
	      return 0;
	    }
	
	    var saturationRange = getSaturationRange(hue);
	
	    var sMin = saturationRange[0],
	        sMax = saturationRange[1];
	
	    switch (options.luminosity) {
	
	      case 'bright':
	        sMin = 55;
	        break;
	
	      case 'dark':
	        sMin = sMax - 10;
	        break;
	
	      case 'light':
	        sMax = 55;
	        break;
	   }
	
	    return randomWithin([sMin, sMax]);
	
	  }
	
	  function pickBrightness (H, S, options) {
	
	    var bMin = getMinimumBrightness(H, S),
	        bMax = 100;
	
	    switch (options.luminosity) {
	
	      case 'dark':
	        bMax = bMin + 20;
	        break;
	
	      case 'light':
	        bMin = (bMax + bMin)/2;
	        break;
	
	      case 'random':
	        bMin = 0;
	        bMax = 100;
	        break;
	    }
	
	    return randomWithin([bMin, bMax]);
	  }
	
	  function setFormat (hsv, options) {
	
	    switch (options.format) {
	
	      case 'hsvArray':
	        return hsv;
	
	      case 'hslArray':
	        return HSVtoHSL(hsv);
	
	      case 'hsl':
	        var hsl = HSVtoHSL(hsv);
	        return 'hsl('+hsl[0]+', '+hsl[1]+'%, '+hsl[2]+'%)';
	
	      case 'hsla':
	        var hslColor = HSVtoHSL(hsv);
	        return 'hsla('+hslColor[0]+', '+hslColor[1]+'%, '+hslColor[2]+'%, ' + Math.random() + ')';
	
	      case 'rgbArray':
	        return HSVtoRGB(hsv);
	
	      case 'rgb':
	        var rgb = HSVtoRGB(hsv);
	        return 'rgb(' + rgb.join(', ') + ')';
	
	      case 'rgba':
	        var rgbColor = HSVtoRGB(hsv);
	        return 'rgba(' + rgbColor.join(', ') + ', ' + Math.random() + ')';
	
	      default:
	        return HSVtoHex(hsv);
	    }
	
	  }
	
	  function getMinimumBrightness(H, S) {
	
	    var lowerBounds = getColorInfo(H).lowerBounds;
	
	    for (var i = 0; i < lowerBounds.length - 1; i++) {
	
	      var s1 = lowerBounds[i][0],
	          v1 = lowerBounds[i][1];
	
	      var s2 = lowerBounds[i+1][0],
	          v2 = lowerBounds[i+1][1];
	
	      if (S >= s1 && S <= s2) {
	
	         var m = (v2 - v1)/(s2 - s1),
	             b = v1 - m*s1;
	
	         return m*S + b;
	      }
	
	    }
	
	    return 0;
	  }
	
	  function getHueRange (colorInput) {
	
	    if (typeof parseInt(colorInput) === 'number') {
	
	      var number = parseInt(colorInput);
	
	      if (number < 360 && number > 0) {
	        return [number, number];
	      }
	
	    }
	
	    if (typeof colorInput === 'string') {
	
	      if (colorDictionary[colorInput]) {
	        var color = colorDictionary[colorInput];
	        if (color.hueRange) {return color.hueRange;}
	      }
	    }
	
	    return [0,360];
	
	  }
	
	  function getSaturationRange (hue) {
	    return getColorInfo(hue).saturationRange;
	  }
	
	  function getColorInfo (hue) {
	
	    // Maps red colors to make picking hue easier
	    if (hue >= 334 && hue <= 360) {
	      hue-= 360;
	    }
	
	    for (var colorName in colorDictionary) {
	       var color = colorDictionary[colorName];
	       if (color.hueRange &&
	           hue >= color.hueRange[0] &&
	           hue <= color.hueRange[1]) {
	          return colorDictionary[colorName];
	       }
	    } return 'Color not found';
	  }
	
	  function randomWithin (range) {
	    if (seed === null) {
	      return Math.floor(range[0] + Math.random()*(range[1] + 1 - range[0]));
	    } else {
	      //Seeded random algorithm from http://indiegamr.com/generate-repeatable-random-numbers-in-js/
	      var max = range[1] || 1;
	      var min = range[0] || 0;
	      seed = (seed * 9301 + 49297) % 233280;
	      var rnd = seed / 233280.0;
	      return Math.floor(min + rnd * (max - min));
	    }
	  }
	
	  function HSVtoHex (hsv){
	
	    var rgb = HSVtoRGB(hsv);
	
	    function componentToHex(c) {
	        var hex = c.toString(16);
	        return hex.length == 1 ? '0' + hex : hex;
	    }
	
	    var hex = '#' + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);
	
	    return hex;
	
	  }
	
	  function defineColor (name, hueRange, lowerBounds) {
	
	    var sMin = lowerBounds[0][0],
	        sMax = lowerBounds[lowerBounds.length - 1][0],
	
	        bMin = lowerBounds[lowerBounds.length - 1][1],
	        bMax = lowerBounds[0][1];
	
	    colorDictionary[name] = {
	      hueRange: hueRange,
	      lowerBounds: lowerBounds,
	      saturationRange: [sMin, sMax],
	      brightnessRange: [bMin, bMax]
	    };
	
	  }
	
	  function loadColorBounds () {
	
	    defineColor(
	      'monochrome',
	      null,
	      [[0,0],[100,0]]
	    );
	
	    defineColor(
	      'red',
	      [-26,18],
	      [[20,100],[30,92],[40,89],[50,85],[60,78],[70,70],[80,60],[90,55],[100,50]]
	    );
	
	    defineColor(
	      'orange',
	      [19,46],
	      [[20,100],[30,93],[40,88],[50,86],[60,85],[70,70],[100,70]]
	    );
	
	    defineColor(
	      'yellow',
	      [47,62],
	      [[25,100],[40,94],[50,89],[60,86],[70,84],[80,82],[90,80],[100,75]]
	    );
	
	    defineColor(
	      'green',
	      [63,178],
	      [[30,100],[40,90],[50,85],[60,81],[70,74],[80,64],[90,50],[100,40]]
	    );
	
	    defineColor(
	      'blue',
	      [179, 257],
	      [[20,100],[30,86],[40,80],[50,74],[60,60],[70,52],[80,44],[90,39],[100,35]]
	    );
	
	    defineColor(
	      'purple',
	      [258, 282],
	      [[20,100],[30,87],[40,79],[50,70],[60,65],[70,59],[80,52],[90,45],[100,42]]
	    );
	
	    defineColor(
	      'pink',
	      [283, 334],
	      [[20,100],[30,90],[40,86],[60,84],[80,80],[90,75],[100,73]]
	    );
	
	  }
	
	  function HSVtoRGB (hsv) {
	
	    // this doesn't work for the values of 0 and 360
	    // here's the hacky fix
	    var h = hsv[0];
	    if (h === 0) {h = 1;}
	    if (h === 360) {h = 359;}
	
	    // Rebase the h,s,v values
	    h = h/360;
	    var s = hsv[1]/100,
	        v = hsv[2]/100;
	
	    var h_i = Math.floor(h*6),
	      f = h * 6 - h_i,
	      p = v * (1 - s),
	      q = v * (1 - f*s),
	      t = v * (1 - (1 - f)*s),
	      r = 256,
	      g = 256,
	      b = 256;
	
	    switch(h_i) {
	      case 0: r = v; g = t; b = p;  break;
	      case 1: r = q; g = v; b = p;  break;
	      case 2: r = p; g = v; b = t;  break;
	      case 3: r = p; g = q; b = v;  break;
	      case 4: r = t; g = p; b = v;  break;
	      case 5: r = v; g = p; b = q;  break;
	    }
	
	    var result = [Math.floor(r*255), Math.floor(g*255), Math.floor(b*255)];
	    return result;
	  }
	
	  function HSVtoHSL (hsv) {
	    var h = hsv[0],
	      s = hsv[1]/100,
	      v = hsv[2]/100,
	      k = (2-s)*v;
	
	    return [
	      h,
	      Math.round(s*v / (k<1 ? k : 2-k) * 10000) / 100,
	      k/2 * 100
	    ];
	  }
	
	  function stringToInteger (string) {
	    var total = 0
	    for (var i = 0; i !== string.length; i++) {
	      if (total >= Number.MAX_SAFE_INTEGER) break;
	      total += string.charCodeAt(i)
	    }
	    return total
	  }
	
	  return randomColor;
	}));


/***/ },
/* 3533 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 1);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(3536);
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(0);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  width: '100%',
	  frameBorder: '0',
	  scrolling: 'no',
	  border: 'none',
	  overflow: 'hidden'
	
	  /**
	   * Simple Component for Telegram embedding
	   * @extends Component
	   */
	
	};
	var TelegramEmbed = function (_Component) {
	  _inherits(TelegramEmbed, _Component);
	
	  function TelegramEmbed(props) {
	    _classCallCheck(this, TelegramEmbed);
	
	    var _this = _possibleConstructorReturn(this, (TelegramEmbed.__proto__ || Object.getPrototypeOf(TelegramEmbed)).call(this, props));
	
	    _this.state = {
	      src: _this.props.src,
	      id: '',
	      height: '80px'
	    };
	    _this.messageHandler = _this.messageHandler.bind(_this);
	    _this.urlObj = document.createElement('a');
	
	    return _this;
	  }
	
	  _createClass(TelegramEmbed, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.addEventListener('message', this.messageHandler);
	
	      this.iFrame.addEventListener('load', function () {
	
	        _this2.checkFrame(_this2.state.id);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('message', this.messageHandler);
	    }
	  }, {
	    key: 'messageHandler',
	    value: function messageHandler(_ref) {
	      var data = _ref.data,
	          source = _ref.source;
	
	      if (!data || typeof data !== 'string' || source !== this.iFrame.contentWindow) {
	        return;
	      }
	
	      var action = JSON.parse(data);
	
	      if (action.event === 'resize' && action.height) {
	        this.setState({
	          height: action.height + 'px'
	        });
	      }
	    }
	  }, {
	    key: 'checkFrame',
	    value: function checkFrame(id) {
	      this.iFrame.contentWindow.postMessage(JSON.stringify({ event: 'visible', frame: id }), '*');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref2) {
	      var _this3 = this;
	
	      var src = _ref2.src;
	
	      if (this.state.src !== src) {
	        this.urlObj.href = src;
	        var id = 'telegram-post' + this.urlObj.pathname.replace(/[^a-z0-9_]/ig, '-');
	
	        this.setState({ src: src, id: id }, function () {
	          return _this3.checkFrame(id);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          src = _state.src,
	          height = _state.height;
	      var container = this.props.container;
	
	
	      return _react2.default.createElement(
	        'div',
	        { 'data-sharing-id': container },
	        _react2.default.createElement('iframe', {
	          ref: function ref(node) {
	            return _this4.iFrame = node;
	          },
	          src: src + '?embed=1',
	          height: height,
	          id: 'telegram-post' + this.urlObj.pathname.replace(/[^a-z0-9_]/ig, '-'),
	          style: styles
	        })
	      );
	    }
	  }]);
	
	  return TelegramEmbed;
	}(_react.Component);
	
	exports.default = TelegramEmbed;
	
	/***/ })
	/******/ ]);

/***/ },
/* 3534 */
1808,
/* 3535 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v17.0.2
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var l=__webpack_require__(3534),n=60103,p=60106;exports.Fragment=60107;exports.StrictMode=60108;exports.Profiler=60114;var q=60109,r=60110,t=60112;exports.Suspense=60113;var u=60115,v=60116;
	if("function"===typeof Symbol&&Symbol.for){var w=Symbol.for;n=w("react.element");p=w("react.portal");exports.Fragment=w("react.fragment");exports.StrictMode=w("react.strict_mode");exports.Profiler=w("react.profiler");q=w("react.provider");r=w("react.context");t=w("react.forward_ref");exports.Suspense=w("react.suspense");u=w("react.memo");v=w("react.lazy")}var x="function"===typeof Symbol&&Symbol.iterator;
	function y(a){if(null===a||"object"!==typeof a)return null;a=x&&a[x]||a["@@iterator"];return"function"===typeof a?a:null}function z(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var A={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},B={};function C(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}C.prototype.isReactComponent={};C.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(z(85));this.updater.enqueueSetState(this,a,b,"setState")};C.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function D(){}D.prototype=C.prototype;function E(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}var F=E.prototype=new D;F.constructor=E;l(F,C.prototype);F.isPureReactComponent=!0;var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
	function J(a,b,c){var e,d={},k=null,h=null;if(null!=b)for(e in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)H.call(b,e)&&!I.hasOwnProperty(e)&&(d[e]=b[e]);var g=arguments.length-2;if(1===g)d.children=c;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];d.children=f}if(a&&a.defaultProps)for(e in g=a.defaultProps,g)void 0===d[e]&&(d[e]=g[e]);return{$$typeof:n,type:a,key:k,ref:h,props:d,_owner:G.current}}
	function K(a,b){return{$$typeof:n,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function L(a){return"object"===typeof a&&null!==a&&a.$$typeof===n}function escape(a){var b={"=":"=0",":":"=2"};return"$"+a.replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g;function N(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
	function O(a,b,c,e,d){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case n:case p:h=!0}}if(h)return h=a,d=d(h),a=""===e?"."+N(h,0):e,Array.isArray(d)?(c="",null!=a&&(c=a.replace(M,"$&/")+"/"),O(d,b,c,"",function(a){return a})):null!=d&&(L(d)&&(d=K(d,c+(!d.key||h&&h.key===d.key?"":(""+d.key).replace(M,"$&/")+"/")+a)),b.push(d)),1;h=0;e=""===e?".":e+":";if(Array.isArray(a))for(var g=
	0;g<a.length;g++){k=a[g];var f=e+N(k,g);h+=O(k,b,c,f,d)}else if(f=y(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=e+N(k,g++),h+=O(k,b,c,f,d);else if("object"===k)throw b=""+a,Error(z(31,"[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b));return h}function P(a,b,c){if(null==a)return a;var e=[],d=0;O(a,e,"","",function(a){return b.call(c,a,d++)});return e}
	function Q(a){if(-1===a._status){var b=a._result;b=b();a._status=0;a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}if(1===a._status)return a._result;throw a._result;}var R={current:null};function S(){var a=R.current;if(null===a)throw Error(z(321));return a}var T={ReactCurrentDispatcher:R,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:G,IsSomeRendererActing:{current:!1},assign:l};
	exports.Children={map:P,forEach:function(a,b,c){P(a,function(){b.apply(this,arguments)},c)},count:function(a){var b=0;P(a,function(){b++});return b},toArray:function(a){return P(a,function(a){return a})||[]},only:function(a){if(!L(a))throw Error(z(143));return a}};exports.Component=C;exports.PureComponent=E;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(z(267,a));var e=l({},a.props),d=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)H.call(b,f)&&!I.hasOwnProperty(f)&&(e[f]=void 0===b[f]&&void 0!==g?g[f]:b[f])}var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){g=Array(f);for(var m=0;m<f;m++)g[m]=arguments[m+2];e.children=g}return{$$typeof:n,type:a.type,
	key:d,ref:k,props:e,_owner:h}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:r,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:q,_context:a};return a.Consumer=a};exports.createElement=J;exports.createFactory=function(a){var b=J.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:t,render:a}};exports.isValidElement=L;
	exports.lazy=function(a){return{$$typeof:v,_payload:{_status:-1,_result:a},_init:Q}};exports.memo=function(a,b){return{$$typeof:u,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return S().useCallback(a,b)};exports.useContext=function(a,b){return S().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return S().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return S().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return S().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return S().useMemo(a,b)};exports.useReducer=function(a,b,c){return S().useReducer(a,b,c)};exports.useRef=function(a){return S().useRef(a)};exports.useState=function(a){return S().useState(a)};exports.version="17.0.2";


/***/ },
/* 3536 */
[4584, 3535],
/* 3537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint react/require-default-props: 0 */
	function DefaultCloseButton(_ref) {
	  var closeToast = _ref.closeToast;
	
	  return _react2.default.createElement(
	    'button',
	    {
	      className: 'toastify__close',
	      type: 'button',
	      onClick: closeToast
	    },
	    '\u2716'
	  );
	}
	
	DefaultCloseButton.propTypes = {
	  closeToast: _propTypes2.default.func
	};
	
	exports.default = DefaultCloseButton;

/***/ },
/* 3538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(468);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProgressBar(_ref) {
	  var delay = _ref.delay,
	      isRunning = _ref.isRunning,
	      closeToast = _ref.closeToast,
	      type = _ref.type,
	      hide = _ref.hide;
	
	  var style = {
	    animationDuration: delay + 'ms',
	    animationPlayState: isRunning ? 'running' : 'paused'
	  };
	  style.WebkitAnimationPlayState = style.animationPlayState;
	
	  if (hide) {
	    style.opacity = 0;
	  }
	
	  return _react2.default.createElement('div', {
	    className: 'toastify__progress toastify__progress--' + type,
	    style: style,
	    onAnimationEnd: closeToast
	  });
	}
	
	ProgressBar.propTypes = {
	  /**
	   * The animation delay which determine when to close the toast
	   */
	  delay: _propTypes2.default.number.isRequired,
	
	  /**
	   * Whether or not the animation is running or paused
	   */
	  isRunning: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Func to close the current toast
	   */
	  closeToast: _propTypes2.default.func.isRequired,
	
	  /**
	   * Optional type : info, success ...
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Hide or not the progress bar
	   */
	  hide: _propTypes2.default.bool
	};
	
	ProgressBar.defaultProps = {
	  type: _config2.default.TYPE.DEFAULT,
	  hide: false
	};
	
	exports.default = ProgressBar;

/***/ },
/* 3539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProgressBar = __webpack_require__(3538);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _config = __webpack_require__(468);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _objectValues = __webpack_require__(1572);
	
	var _objectValues2 = _interopRequireDefault(_objectValues);
	
	var _propValidator = __webpack_require__(1573);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toast = function (_Component) {
	  _inherits(Toast, _Component);
	
	  function Toast(props) {
	    _classCallCheck(this, Toast);
	
	    var _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this, props));
	
	    _this.setRef = function (ref) {
	      _this.ref = ref;
	    };
	
	    _this.pauseToast = function () {
	      _this.setState({ isRunning: false });
	    };
	
	    _this.playToast = function () {
	      _this.setState({ isRunning: true });
	    };
	
	    _this.ref = null;
	    _this.state = {
	      isRunning: true
	    };
	    return _this;
	  }
	
	  _createClass(Toast, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onOpen !== null && this.props.onOpen(this.getChildrenProps());
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onClose !== null && this.props.onClose(this.getChildrenProps());
	    }
	  }, {
	    key: 'getChildrenProps',
	    value: function getChildrenProps() {
	      return this.props.children.props;
	    }
	  }, {
	    key: 'getToastProps',
	    value: function getToastProps() {
	      var toastProps = {
	        className: 'toastify-content toastify-content--' + this.props.type,
	        ref: this.setRef
	      };
	
	      if (this.props.autoClose !== false) {
	        toastProps.onMouseEnter = this.pauseToast;
	        toastProps.onMouseLeave = this.playToast;
	      }
	
	      return toastProps;
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.ref.classList.add('toast-enter--' + this.props.position, 'toastify-animated');
	      callback();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.ref.classList.add('toast-enter--' + this.props.position, 'toastify-animated');
	      callback();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.ref.classList.remove('toast-enter--' + this.props.position, 'toastify-animated');
	      this.ref.classList.add('toast-exit--' + this.props.position, 'toastify-animated');
	      setTimeout(function () {
	        return callback();
	      }, 750);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          closeButton = _props.closeButton,
	          children = _props.children,
	          autoClose = _props.autoClose,
	          type = _props.type,
	          hideProgressBar = _props.hideProgressBar,
	          closeToast = _props.closeToast;
	
	
	      return _react2.default.createElement(
	        'div',
	        this.getToastProps(),
	        closeButton !== false && closeButton,
	        _react2.default.createElement(
	          'div',
	          { className: 'toastify__body' },
	          children
	        ),
	        autoClose !== false && _react2.default.createElement(_ProgressBar2.default, {
	          delay: autoClose,
	          isRunning: this.state.isRunning,
	          closeToast: closeToast,
	          hide: hideProgressBar,
	          type: type
	        })
	      );
	    }
	  }]);
	
	  return Toast;
	}(_react.Component);
	
	Toast.propTypes = {
	  closeButton: _propValidator.falseOrElement.isRequired,
	  autoClose: _propValidator.falseOrNumber.isRequired,
	  children: _propTypes2.default.node.isRequired,
	  closeToast: _propTypes2.default.func.isRequired,
	  position: _propTypes2.default.oneOf((0, _objectValues2.default)(_config2.default.POSITION)).isRequired,
	  hideProgressBar: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  type: _propTypes2.default.oneOf((0, _objectValues2.default)(_config2.default.TYPE))
	};
	Toast.defaultProps = {
	  type: _config2.default.TYPE.DEFAULT,
	  hideProgressBar: false,
	  onOpen: null,
	  onClose: null
	};
	exports.default = Toast;

/***/ },
/* 3540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(3542);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _Toast = __webpack_require__(3539);
	
	var _Toast2 = _interopRequireDefault(_Toast);
	
	var _DefaultCloseButton = __webpack_require__(3537);
	
	var _DefaultCloseButton2 = _interopRequireDefault(_DefaultCloseButton);
	
	var _config = __webpack_require__(468);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _EventManager = __webpack_require__(1571);
	
	var _EventManager2 = _interopRequireDefault(_EventManager);
	
	var _objectValues = __webpack_require__(1572);
	
	var _objectValues2 = _interopRequireDefault(_objectValues);
	
	var _propValidator = __webpack_require__(1573);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToastContainer = function (_Component) {
	  _inherits(ToastContainer, _Component);
	
	  function ToastContainer(props) {
	    _classCallCheck(this, ToastContainer);
	
	    var _this = _possibleConstructorReturn(this, (ToastContainer.__proto__ || Object.getPrototypeOf(ToastContainer)).call(this, props));
	
	    _this.state = {
	      toast: []
	    };
	    _this.collection = {};
	    return _this;
	  }
	
	  _createClass(ToastContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _EventManager2.default.on(_config2.default.ACTION.SHOW, function (content, options) {
	        return _this2.show(content, options);
	      }).on(_config2.default.ACTION.CLEAR, function (id) {
	        return id !== null ? _this2.removeToast(id) : _this2.clear();
	      }).emit(_config2.default.ACTION.MOUNTED);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _EventManager2.default.off(_config2.default.ACTION.SHOW);
	      _EventManager2.default.off(_config2.default.ACTION.CLEAR);
	    }
	  }, {
	    key: 'removeToast',
	    value: function removeToast(id) {
	      this.setState({
	        toast: this.state.toast.filter(function (v) {
	          return v !== parseInt(id, 10);
	        })
	      });
	    }
	  }, {
	    key: 'with',
	    value: function _with(component, props) {
	      return (0, _react.cloneElement)(component, _extends({}, props, component.props));
	    }
	  }, {
	    key: 'makeCloseButton',
	    value: function makeCloseButton(toastClose, toastId) {
	      var _this3 = this;
	
	      var closeButton = this.props.closeButton;
	
	      if ((0, _react.isValidElement)(toastClose) || toastClose === false) {
	        closeButton = toastClose;
	      }
	
	      return closeButton === false ? false : this.with(closeButton, {
	        closeToast: function closeToast() {
	          return _this3.removeToast(toastId);
	        }
	      });
	    }
	  }, {
	    key: 'getAutoCloseDelay',
	    value: function getAutoCloseDelay(toastAutoClose) {
	      return toastAutoClose === false || (0, _propValidator.isValidDelay)(toastAutoClose) ? toastAutoClose : this.props.autoClose;
	    }
	  }, {
	    key: 'isFunction',
	    value: function isFunction(object) {
	      return !!(object && object.constructor && object.call && object.apply);
	    }
	
	    /**
	     * TODO: check if throwing an error can be helpful
	     */
	
	  }, {
	    key: 'canBeRendered',
	    value: function canBeRendered(content) {
	      return (0, _react.isValidElement)(content) || (0, _propValidator.typeOf)(content) === 'String' || (0, _propValidator.typeOf)(content) === 'Number';
	    }
	  }, {
	    key: 'show',
	    value: function show(content, options) {
	      var _this4 = this;
	
	      if (this.canBeRendered(content)) {
	        var toastId = options.toastId;
	        var closeToast = function closeToast() {
	          return _this4.removeToast(toastId);
	        };
	        var toastOptions = {
	          id: toastId,
	          type: options.type,
	          closeButton: this.makeCloseButton(options.closeButton, toastId),
	          position: options.position || this.props.position
	        };
	
	        this.isFunction(options.onOpen) && (toastOptions.onOpen = options.onOpen);
	
	        this.isFunction(options.onClose) && (toastOptions.onClose = options.onClose);
	
	        toastOptions.autoClose = this.getAutoCloseDelay(options.autoClose !== false ? parseInt(options.autoClose, 10) : options.autoClose);
	
	        toastOptions.hideProgressBar = typeof options.hideProgressBar === 'boolean' ? options.hideProgressBar : this.props.hideProgressBar;
	
	        toastOptions.closeToast = closeToast;
	
	        if ((0, _react.isValidElement)(content) && (0, _propValidator.typeOf)(content.type) !== 'String') {
	          content = this.with(content, {
	            closeToast: closeToast
	          });
	        }
	
	        this.collection = Object.assign({}, this.collection, _defineProperty({}, toastId, {
	          content: this.makeToast(content, toastOptions),
	          position: toastOptions.position
	        }));
	
	        this.setState({
	          toast: [].concat(_toConsumableArray(this.state.toast), [toastId])
	        });
	      }
	    }
	  }, {
	    key: 'makeToast',
	    value: function makeToast(content, options) {
	      return _react2.default.createElement(
	        _Toast2.default,
	        _extends({}, options, {
	          key: 'toast-' + options.id + ' '
	        }),
	        content
	      );
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.setState({ toast: [] });
	    }
	  }, {
	    key: 'hasToast',
	    value: function hasToast() {
	      return this.state.toast.length > 0;
	    }
	  }, {
	    key: 'getContainerProps',
	    value: function getContainerProps(pos, disablePointer) {
	      var props = {
	        className: 'toastify toastify--' + pos,
	        style: disablePointer ? { pointerEvents: 'none' } : {}
	      };
	
	      if (this.props.className !== null) {
	        props.className = props.className + ' ' + this.props.className;
	      }
	
	      if (this.props.style !== null) {
	        props.style = Object.assign({}, this.props.style, props.style);
	      }
	
	      return props;
	    }
	  }, {
	    key: 'renderToast',
	    value: function renderToast() {
	      var _this5 = this;
	
	      var toastToRender = {};
	      var collection = Object.keys(this.collection);
	
	      collection.forEach(function (toastId) {
	        var item = _this5.collection[toastId];
	        toastToRender[item.position] || (toastToRender[item.position] = []);
	
	        if (_this5.state.toast.includes(parseInt(toastId, 10))) {
	          toastToRender[item.position].push(item.content);
	        } else {
	          // Temporal zone for animation
	          toastToRender[item.position].push(null);
	          // Delay garbage collecting. Useful when a lots of toast
	          setTimeout(function () {
	            return delete _this5.collection[toastId];
	          }, collection.length * 10);
	        }
	      });
	
	      return Object.keys(toastToRender).map(function (position) {
	        var disablePointer = toastToRender[position].length === 1 && toastToRender[position][0] === null;
	
	        return _react2.default.createElement(
	          _TransitionGroup2.default,
	          _extends({
	            component: 'div'
	          }, _this5.getContainerProps(position, disablePointer), {
	            key: 'container-' + position
	          }),
	          toastToRender[position].map(function (item) {
	            return item;
	          })
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderToast()
	      );
	    }
	  }]);
	
	  return ToastContainer;
	}(_react.Component);
	
	ToastContainer.propTypes = {
	  /**
	   * Set toast position
	   */
	  position: _propTypes2.default.oneOf((0, _objectValues2.default)(_config2.default.POSITION)),
	
	  /**
	   * Disable or set autoClose delay
	   */
	  autoClose: _propValidator.falseOrNumber,
	
	  /**
	   * Disable or set a custom react element for the close button
	   */
	  closeButton: _propValidator.falseOrElement,
	
	  /**
	   * Hide or not progress bar when autoClose is enabled
	   */
	  hideProgressBar: _propTypes2.default.bool,
	
	  /**
	   * An optional className
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style
	   */
	  style: _propTypes2.default.object
	};
	ToastContainer.defaultProps = {
	  position: _config2.default.POSITION.TOP_RIGHT,
	  autoClose: 5000,
	  hideProgressBar: false,
	  closeButton: _react2.default.createElement(_DefaultCloseButton2.default, null),
	  className: null,
	  style: null
	};
	exports.default = ToastContainer;

/***/ },
/* 3541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EventManager = __webpack_require__(1571);
	
	var _EventManager2 = _interopRequireDefault(_EventManager);
	
	var _config = __webpack_require__(468);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	* TODO: Add validation here :
	*   - Validate type
	*   - Maybe autoClose
	*   - Maybe closeButton as well
	* */
	var POSITION = _config2.default.POSITION,
	    TYPE = _config2.default.TYPE,
	    ACTION = _config2.default.ACTION;
	
	
	var defaultOptions = {
	  type: TYPE.DEFAULT,
	  autoClose: null,
	  closeButton: null,
	  hideProgressBar: null,
	  position: null
	};
	
	var isContainerMounted = false;
	var queue = [];
	var toastId = 0;
	
	function mergeOptions(options) {
	  return Object.assign({}, defaultOptions, options, { toastId: ++toastId });
	}
	
	_EventManager2.default.on(ACTION.MOUNTED, function () {
	  isContainerMounted = true;
	  queue.forEach(function (item) {
	    _EventManager2.default.emit(item.action, item.content, item.options);
	  });
	  queue = [];
	});
	
	var emitEvent = function emitEvent(content, options) {
	  if (isContainerMounted) {
	    _EventManager2.default.emit(ACTION.SHOW, content, options);
	  } else {
	    queue.push({ action: ACTION.SHOW, content: content, options: options });
	  }
	
	  return options.toastId;
	};
	
	exports.default = Object.assign(function (content, options) {
	  return emitEvent(content, mergeOptions(options));
	}, {
	  success: function success(content, options) {
	    return emitEvent(content, Object.assign(mergeOptions(options), { type: TYPE.SUCCESS }));
	  },
	  info: function info(content, options) {
	    return emitEvent(content, Object.assign(mergeOptions(options), { type: TYPE.INFO }));
	  },
	  warn: function warn(content, options) {
	    return emitEvent(content, Object.assign(mergeOptions(options), { type: TYPE.WARNING }));
	  },
	  error: function error(content, options) {
	    return emitEvent(content, Object.assign(mergeOptions(options), { type: TYPE.ERROR }));
	  },
	  dismiss: function dismiss() {
	    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    return _EventManager2.default.emit(ACTION.CLEAR, id);
	  }
	}, {
	  POSITION: POSITION,
	  TYPE: TYPE
	});

/***/ },
/* 3542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(2411);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(3543);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(3544);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 3543 */
141,
/* 3544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 3545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _embed = __webpack_require__(1821);
	
	var typeformEmbed = _interopRequireWildcard(_embed);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styleDefault = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  width: '100%',
	  height: '100%',
	  overflow: 'hidden'
	};
	
	var ReactTypeformEmbed = function (_Component) {
	  _inherits(ReactTypeformEmbed, _Component);
	
	  function ReactTypeformEmbed() {
	    _classCallCheck(this, ReactTypeformEmbed);
	
	    return _possibleConstructorReturn(this, (ReactTypeformEmbed.__proto__ || Object.getPrototypeOf(ReactTypeformEmbed)).apply(this, arguments));
	  }
	
	  _createClass(ReactTypeformEmbed, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          url = _props.url,
	          hideHeaders = _props.hideHeaders,
	          hideFooter = _props.hideFooter,
	          opacity = _props.opacity,
	          buttonText = _props.buttonText,
	          popup = _props.popup,
	          mode = _props.mode,
	          autoOpen = _props.autoOpen,
	          autoClose = _props.autoClose,
	          onSubmit = _props.onSubmit;
	
	
	      var options = {
	        hideHeaders: hideHeaders,
	        hideFooter: hideFooter,
	        opacity: opacity,
	        buttonText: buttonText,
	        mode: mode,
	        autoOpen: autoOpen,
	        autoClose: autoClose,
	        onSubmit: onSubmit
	      };
	
	      // Popup Mode
	      if (popup) {
	        // Load Typeform embed popup
	        this.typeform = typeformEmbed.makePopup(url, options);
	
	        // Widget Mode (default)
	      } else {
	        var elm = this.typeformElm;
	
	        // Load Typeform embed widget
	        typeformEmbed.makeWidget(elm, url, options);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var style = Object.assign({}, styleDefault, this.props.style);
	
	      return _react2.default.createElement('div', {
	        className: 'ReactTypeformEmbed',
	        ref: function ref(tf) {
	          _this2.typeformElm = tf;
	        },
	        style: style
	      });
	    }
	  }]);
	
	  return ReactTypeformEmbed;
	}(_react.Component);
	
	ReactTypeformEmbed.propTypes = {
	  style: _propTypes2.default.object,
	  url: _propTypes2.default.string.isRequired,
	  popup: _propTypes2.default.bool,
	  hideHeaders: _propTypes2.default.bool,
	  hideFooter: _propTypes2.default.bool,
	
	  // Widget options
	  opacity: _propTypes2.default.number,
	  buttonText: _propTypes2.default.string,
	
	  // Popup options
	  mode: _propTypes2.default.string,
	  autoOpen: _propTypes2.default.bool,
	  autoClose: _propTypes2.default.number,
	  onSubmit: _propTypes2.default.func
	};
	
	// Default values taken from official Typeform docs
	// https://developer.typeform.com/embed/modes/
	ReactTypeformEmbed.defaultProps = {
	  style: {},
	  popup: false,
	  hideHeaders: false,
	  hideFooter: false,
	  onSubmit: function onSubmit() {},
	
	  // Widget options
	  opacity: 100,
	  buttonText: 'Start',
	
	  // Popup options
	  mode: 'popup', // options: "popup", "drawer_left", "drawer_right"
	  autoOpen: false,
	  autoClose: 5
	};
	
	exports.default = ReactTypeformEmbed;

/***/ },
/* 3546 */
[4186, 263, 158],
/* 3547 */
[4187, 3576, 3577, 3578, 3579, 3580],
/* 3548 */
[4193, 263, 158],
/* 3549 */
[4194, 263, 158],
/* 3550 */
[4195, 1575, 3600, 3601],
/* 3551 */
[4196, 470, 3603, 3604, 3605, 3606, 3607],
/* 3552 */
[4198, 158],
/* 3553 */
[4199, 263, 158],
/* 3554 */
977,
/* 3555 */
[4201, 3565, 3608, 748, 1580, 3581, 1584],
/* 3556 */
608,
/* 3557 */
980,
/* 3558 */
[4220, 3556, 748],
/* 3559 */
[4225, 472, 475],
/* 3560 */
[4226, 3561, 475],
/* 3561 */
[4227, 3551, 1576, 3569, 3570, 3574, 748, 1580, 1584],
/* 3562 */
[4230, 1581, 3583, 1583, 1578],
/* 3563 */
[4232, 472, 1582, 475],
/* 3564 */
[4234, 3584, 3596],
/* 3565 */
993,
/* 3566 */
245,
/* 3567 */
392,
/* 3568 */
[4267, 158],
/* 3569 */
[4287, 747, 3552, 1579, 1576, 3595, 3602],
/* 3570 */
[4288, 3571],
/* 3571 */
[4290, 3558, 3573, 3611],
/* 3572 */
[4298, 747],
/* 3573 */
[4299, 3554, 3612],
/* 3574 */
[4301, 3546, 746, 3548, 3549, 3553, 472, 1578],
/* 3575 */
2675,
/* 3576 */
[4303, 474],
/* 3577 */
2679,
/* 3578 */
[4304, 474],
/* 3579 */
[4305, 474],
/* 3580 */
[4306, 474],
/* 3581 */
301,
/* 3582 */
2688,
/* 3583 */
[4313, 3568],
/* 3584 */
302,
/* 3585 */
2690,
/* 3586 */
[4315, 471],
/* 3587 */
[4316, 471],
/* 3588 */
[4317, 471],
/* 3589 */
[4318, 471],
/* 3590 */
[4319, 3547, 470, 746],
/* 3591 */
[4320, 473],
/* 3592 */
[4321, 473],
/* 3593 */
[4322, 473],
/* 3594 */
[4323, 473],
/* 3595 */
2700,
/* 3596 */
[4328, 3599],
/* 3597 */
[4329, 1577],
/* 3598 */
2705,
/* 3599 */
1013,
/* 3600 */
2709,
/* 3601 */
2710,
/* 3602 */
621,
/* 3603 */
[4337, 470],
/* 3604 */
2712,
/* 3605 */
2713,
/* 3606 */
2714,
/* 3607 */
[4338, 470, 746, 1575],
/* 3608 */
[4394, 3559, 475],
/* 3609 */
[4395, 1581, 1582],
/* 3610 */
[4400, 3560],
/* 3611 */
[4413, 3555, 3564, 3609],
/* 3612 */
1038,
/* 3613 */
2777,
/* 3614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PlayerStates = __webpack_require__(3616);
	
	var _PlayerStates2 = _interopRequireDefault(_PlayerStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  pauseVideo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
	    stateChangeRequired: false
	  },
	  playVideo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
	    stateChangeRequired: false
	  },
	  seekTo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
	    stateChangeRequired: true,
	
	    // TRICKY: `seekTo` may not cause a state change if no buffering is
	    // required.
	    timeout: 3000
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 3615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debug = __webpack_require__(2546);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _functionNames = __webpack_require__(3618);
	
	var _functionNames2 = _interopRequireDefault(_functionNames);
	
	var _eventNames = __webpack_require__(3617);
	
	var _eventNames2 = _interopRequireDefault(_eventNames);
	
	var _FunctionStateMap = __webpack_require__(3614);
	
	var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable promise/prefer-await-to-then */
	
	var debug = (0, _debug2.default)('youtube-player');
	
	var YouTubePlayer = {};
	
	/**
	 * Construct an object that defines an event handler for all of the YouTube
	 * player events. Proxy captured events through an event emitter.
	 *
	 * @todo Capture event parameters.
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 */
	YouTubePlayer.proxyEvents = function (emitter) {
	  var events = {};
	
	  var _loop = function _loop(eventName) {
	    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);
	
	    events[onEventName] = function (event) {
	      debug('event "%s"', onEventName, event);
	
	      emitter.trigger(eventName, event);
	    };
	  };
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var eventName = _step.value;
	
	      _loop(eventName);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return events;
	};
	
	/**
	 * Delays player API method execution until player state is ready.
	 *
	 * @todo Proxy all of the methods using Object.keys.
	 * @todo See TRICKY below.
	 * @param playerAPIReady Promise that resolves when player is ready.
	 * @param strictState A flag designating whether or not to wait for
	 * an acceptable state when calling supported functions.
	 * @returns {Object}
	 */
	YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
	  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var functions = {};
	
	  var _loop2 = function _loop2(functionName) {
	    if (strictState && _FunctionStateMap2.default[functionName]) {
	      functions[functionName] = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return playerAPIReady.then(function (player) {
	          var stateInfo = _FunctionStateMap2.default[functionName];
	          var playerState = player.getPlayerState();
	
	          // eslint-disable-next-line no-warning-comments
	          // TODO: Just spread the args into the function once Babel is fixed:
	          // https://github.com/babel/babel/issues/4270
	          //
	          // eslint-disable-next-line prefer-spread
	          var value = player[functionName].apply(player, args);
	
	          // TRICKY: For functions like `seekTo`, a change in state must be
	          // triggered given that the resulting state could match the initial
	          // state.
	          if (stateInfo.stateChangeRequired ||
	
	          // eslint-disable-next-line no-extra-parens
	          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
	            return new Promise(function (resolve) {
	              var onPlayerStateChange = function onPlayerStateChange() {
	                var playerStateAfterChange = player.getPlayerState();
	
	                var timeout = void 0;
	
	                if (typeof stateInfo.timeout === 'number') {
	                  timeout = setTimeout(function () {
	                    player.removeEventListener('onStateChange', onPlayerStateChange);
	
	                    resolve();
	                  }, stateInfo.timeout);
	                }
	
	                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
	                  player.removeEventListener('onStateChange', onPlayerStateChange);
	
	                  clearTimeout(timeout);
	
	                  resolve();
	                }
	              };
	
	              player.addEventListener('onStateChange', onPlayerStateChange);
	            }).then(function () {
	              return value;
	            });
	          }
	
	          return value;
	        });
	      };
	    } else {
	      functions[functionName] = function () {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        return playerAPIReady.then(function (player) {
	          // eslint-disable-next-line no-warning-comments
	          // TODO: Just spread the args into the function once Babel is fixed:
	          // https://github.com/babel/babel/issues/4270
	          //
	          // eslint-disable-next-line prefer-spread
	          return player[functionName].apply(player, args);
	        });
	      };
	    }
	  };
	
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var functionName = _step2.value;
	
	      _loop2(functionName);
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return functions;
	};
	
	exports.default = YouTubePlayer;
	module.exports = exports['default'];

/***/ },
/* 3616 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  BUFFERING: 3,
	  ENDED: 0,
	  PAUSED: 2,
	  PLAYING: 1,
	  UNSTARTED: -1,
	  VIDEO_CUED: 5
	};
	module.exports = exports["default"];

/***/ },
/* 3617 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 * `volumeChange` is not officially supported but seems to work
	 * it emits an object: `{volume: 82.6923076923077, muted: false}`
	 */
	exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
	module.exports = exports['default'];

/***/ },
/* 3618 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
	 */
	exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
	module.exports = exports['default'];

/***/ },
/* 3619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _sister = __webpack_require__(4086);
	
	var _sister2 = _interopRequireDefault(_sister);
	
	var _loadYouTubeIframeApi = __webpack_require__(3620);
	
	var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);
	
	var _YouTubePlayer = __webpack_require__(3615);
	
	var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @typedef YT.Player
	 * @see https://developers.google.com/youtube/iframe_api_reference
	 * */
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	 */
	var youtubeIframeAPI = void 0;
	
	/**
	 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
	 *
	 * @param maybeElementId Either An existing YT.Player instance,
	 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
	 * @param options See `options` (Ignored when using an existing YT.Player instance).
	 * @param strictState A flag designating whether or not to wait for
	 * an acceptable state when calling supported functions. Default: `false`.
	 * See `FunctionStateMap.js` for supported functions and acceptable states.
	 */
	
	exports.default = function (maybeElementId) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var emitter = (0, _sister2.default)();
	
	  if (!youtubeIframeAPI) {
	    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
	  }
	
	  if (options.events) {
	    throw new Error('Event handlers cannot be overwritten.');
	  }
	
	  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
	    throw new Error('Element "' + maybeElementId + '" does not exist.');
	  }
	
	  options.events = _YouTubePlayer2.default.proxyEvents(emitter);
	
	  var playerAPIReady = new Promise(function (resolve) {
	    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
	      var player = maybeElementId;
	
	      resolve(player);
	    } else {
	      // asume maybeElementId can be rendered inside
	      // eslint-disable-next-line promise/catch-or-return
	      youtubeIframeAPI.then(function (YT) {
	        // eslint-disable-line promise/prefer-await-to-then
	        var player = new YT.Player(maybeElementId, options);
	
	        emitter.on('ready', function () {
	          resolve(player);
	        });
	
	        return null;
	      });
	    }
	  });
	
	  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);
	
	  playerApi.on = emitter.on;
	  playerApi.off = emitter.off;
	
	  return playerApi;
	};
	
	module.exports = exports['default'];

/***/ },
/* 3620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loadScript = __webpack_require__(423);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (emitter) {
	  /**
	   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
	   * The promise is resolved with a reference to window.YT object.
	   */
	  var iframeAPIReady = new Promise(function (resolve) {
	    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
	      resolve(window.YT);
	
	      return;
	    } else {
	      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
	
	      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
	        if (error) {
	          emitter.trigger('error', error);
	        }
	      });
	    }
	
	    var previous = window.onYouTubeIframeAPIReady;
	
	    // The API will call this function when page has finished downloading
	    // the JavaScript for the player API.
	    window.onYouTubeIframeAPIReady = function () {
	      if (previous) {
	        previous();
	      }
	
	      resolve(window.YT);
	    };
	  });
	
	  return iframeAPIReady;
	};
	
	module.exports = exports['default'];

/***/ },
/* 3621 */
711,
/* 3622 */
[4583, 265],
/* 3623 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(3622);
	var ReactElement = __webpack_require__(264);
	
	var emptyFunction = __webpack_require__(110);
	var traverseAllChildren = __webpack_require__(3632);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 3624 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(265),
	    _assign = __webpack_require__(45);
	
	var ReactComponent = __webpack_require__(749);
	var ReactElement = __webpack_require__(264);
	var ReactPropTypeLocationNames = __webpack_require__(1587);
	var ReactNoopUpdateQueue = __webpack_require__(750);
	
	var emptyObject = __webpack_require__(248);
	var invariant = __webpack_require__(36);
	var warning = __webpack_require__(41);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 3625 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(264);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 3626 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(264);
	var ReactPropTypeLocationNames = __webpack_require__(1587);
	var ReactPropTypesSecret = __webpack_require__(3627);
	
	var emptyFunction = __webpack_require__(110);
	var getIteratorFn = __webpack_require__(1589);
	var warning = __webpack_require__(41);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 3627 */
3307,
/* 3628 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var ReactComponent = __webpack_require__(749);
	var ReactNoopUpdateQueue = __webpack_require__(750);
	
	var emptyObject = __webpack_require__(248);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 3629 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.2';

/***/ },
/* 3630 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 3631 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(265);
	
	var ReactElement = __webpack_require__(264);
	
	var invariant = __webpack_require__(36);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 3632 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(265);
	
	var ReactCurrentOwner = __webpack_require__(159);
	var REACT_ELEMENT_TYPE = __webpack_require__(1586);
	
	var getIteratorFn = __webpack_require__(1589);
	var invariant = __webpack_require__(36);
	var KeyEscapeUtils = __webpack_require__(3621);
	var warning = __webpack_require__(41);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 3633 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 3634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(28);
	
	var _createFieldProps2 = __webpack_require__(1592);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _onChangeValue = __webpack_require__(1594);
	
	var _onChangeValue2 = _interopRequireDefault(_onChangeValue);
	
	var _eventConsts = __webpack_require__(3681);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var createConnectedField = function createConnectedField(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      toJS = _ref.toJS;
	
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = getIn(syncErrors, name);
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name);
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedField = function (_Component) {
	    _inherits(ConnectedField, _Component);
	
	    function ConnectedField(props) {
	      _classCallCheck(this, ConnectedField);
	
	      var _this = _possibleConstructorReturn(this, (ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call(this, props));
	
	      _this.handleChange = _this.handleChange.bind(_this);
	      _this.handleFocus = _this.handleFocus.bind(_this);
	      _this.handleBlur = _this.handleBlur.bind(_this);
	      _this.handleDragStart = _this.handleDragStart.bind(_this);
	      _this.handleDrop = _this.handleDrop.bind(_this);
	      return _this;
	    }
	
	    _createClass(ConnectedField, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'isPristine',
	      value: function isPristine() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'getValue',
	      value: function getValue() {
	        return this.props.value;
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange(event) {
	        var _props = this.props,
	            name = _props.name,
	            dispatch = _props.dispatch,
	            parse = _props.parse,
	            normalize = _props.normalize,
	            onChange = _props.onChange,
	            _reduxForm = _props._reduxForm,
	            previousValue = _props.value;
	
	        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        var defaultPrevented = false;
	        if (onChange) {
	          onChange(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return event.preventDefault();
	            }
	          }), newValue, previousValue);
	        }
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	        }
	      }
	    }, {
	      key: 'handleFocus',
	      value: function handleFocus(event) {
	        var _props2 = this.props,
	            name = _props2.name,
	            dispatch = _props2.dispatch,
	            onFocus = _props2.onFocus,
	            _reduxForm = _props2._reduxForm;
	
	
	        var defaultPrevented = false;
	        if (onFocus) {
	          onFocus(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return event.preventDefault();
	            }
	          }));
	        }
	
	        if (!defaultPrevented) {
	          dispatch(_reduxForm.focus(name));
	        }
	      }
	    }, {
	      key: 'handleBlur',
	      value: function handleBlur(event) {
	        var _props3 = this.props,
	            name = _props3.name,
	            dispatch = _props3.dispatch,
	            parse = _props3.parse,
	            normalize = _props3.normalize,
	            onBlur = _props3.onBlur,
	            _reduxForm = _props3._reduxForm,
	            _value = _props3._value,
	            previousValue = _props3.value;
	
	        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        // for checkbox and radio, if the value property of checkbox or radio equals
	        // the value passed by blur event, then fire blur action with previousValue.
	        if (newValue === _value && _value !== undefined) {
	          newValue = previousValue;
	        }
	
	        var defaultPrevented = false;
	        if (onBlur) {
	          onBlur(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return event.preventDefault();
	            }
	          }), newValue, previousValue);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch blur action
	          dispatch(_reduxForm.blur(name, newValue));
	
	          // call post-blur callback
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue);
	          }
	        }
	      }
	    }, {
	      key: 'handleDragStart',
	      value: function handleDragStart(event) {
	        var _props4 = this.props,
	            onDragStart = _props4.onDragStart,
	            value = _props4.value;
	
	        event.dataTransfer.setData(_eventConsts.dataKey, value == null ? '' : value);
	
	        if (onDragStart) {
	          onDragStart(event);
	        }
	      }
	    }, {
	      key: 'handleDrop',
	      value: function handleDrop(event) {
	        var _props5 = this.props,
	            name = _props5.name,
	            dispatch = _props5.dispatch,
	            onDrop = _props5.onDrop,
	            _reduxForm = _props5._reduxForm,
	            previousValue = _props5.value;
	
	        var newValue = event.dataTransfer.getData(_eventConsts.dataKey);
	
	        var defaultPrevented = false;
	        if (onDrop) {
	          onDrop(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return event.preventDefault();
	            }
	          }), newValue, previousValue);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	          event.preventDefault();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props6 = this.props,
	            component = _props6.component,
	            withRef = _props6.withRef,
	            name = _props6.name,
	            _reduxForm = _props6._reduxForm,
	            normalize = _props6.normalize,
	            onBlur = _props6.onBlur,
	            onChange = _props6.onChange,
	            onFocus = _props6.onFocus,
	            onDragStart = _props6.onDragStart,
	            onDrop = _props6.onDrop,
	            rest = _objectWithoutProperties(_props6, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop']);
	
	        var _createFieldProps = (0, _createFieldProps3.default)({ getIn: getIn, toJS: toJS }, name, _extends({}, rest, {
	          form: _reduxForm.form,
	          onBlur: this.handleBlur,
	          onChange: this.handleChange,
	          onDrop: this.handleDrop,
	          onDragStart: this.handleDragStart,
	          onFocus: this.handleFocus
	        })),
	            custom = _createFieldProps.custom,
	            props = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	        if (withRef) {
	          custom.ref = 'renderedComponent';
	        }
	        if (typeof component === 'string') {
	          var input = props.input,
	              meta = props.meta; // eslint-disable-line no-unused-vars
	          // flatten input into other props
	
	          return (0, _react.createElement)(component, _extends({}, input, custom));
	        } else {
	          return (0, _react.createElement)(component, _extends({}, props, custom));
	        }
	      }
	    }]);
	
	    return ConnectedField;
	  }(_react.Component);
	
	  ConnectedField.propTypes = {
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    props: _react.PropTypes.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initialState = getIn(formState, 'initial.' + name);
	    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name),
	      asyncValidating: getIn(formState, 'asyncValidating') === name,
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      _value: ownProps.value // save value passed in (for checkboxes)
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedField);
	};
	
	exports.default = createConnectedField;

/***/ },
/* 3635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapValues2 = __webpack_require__(1617);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(28);
	
	var _redux = __webpack_require__(332);
	
	var _createFieldArrayProps = __webpack_require__(3644);
	
	var _createFieldArrayProps2 = _interopRequireDefault(_createFieldArrayProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm', 'value'];
	
	var createConnectedFieldArray = function createConnectedFieldArray(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      size = _ref.size;
	
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // For an array, the error can _ONLY_ be under _error.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return getIn(syncErrors, name + '._error');
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    // For an array, the warning can _ONLY_ be under _warning.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return getIn(syncWarnings, name + '._warning');
	  };
	
	  var ConnectedFieldArray = function (_Component) {
	    _inherits(ConnectedFieldArray, _Component);
	
	    function ConnectedFieldArray() {
	      _classCallCheck(this, ConnectedFieldArray);
	
	      var _this = _possibleConstructorReturn(this, (ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call(this));
	
	      _this.getValue = _this.getValue.bind(_this);
	      return _this;
	    }
	
	    _createClass(ConnectedFieldArray, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        // Update if the elements of the value array was updated.
	        var thisValue = this.props.value;
	        var nextValue = nextProps.value;
	
	        if (thisValue && nextValue) {
	          if (thisValue.length !== nextValue.length || thisValue.every(function (val) {
	            return nextValue.some(function (next) {
	              return deepEqual(val, next);
	            });
	          })) {
	            return true;
	          }
	        }
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          // useful to debug rerenders
	          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	          // }
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'getValue',
	      value: function getValue(index) {
	        return this.props.value && getIn(this.props.value, index);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            name = _props.name,
	            _reduxForm = _props._reduxForm,
	            validate = _props.validate,
	            warn = _props.warn,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn']);
	
	        var props = (0, _createFieldArrayProps2.default)(getIn, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	        return (0, _react.createElement)(component, props);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	
	    return ConnectedFieldArray;
	  }(_react.Component);
	
	  ConnectedFieldArray.propTypes = {
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    props: _react.PropTypes.object
	  };
	
	  ConnectedFieldArray.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      length: size(value)
	    };
	  }, function (dispatch, ownProps) {
	    var name = ownProps.name,
	        _reduxForm = ownProps._reduxForm;
	    var arrayInsert = _reduxForm.arrayInsert,
	        arrayMove = _reduxForm.arrayMove,
	        arrayPop = _reduxForm.arrayPop,
	        arrayPush = _reduxForm.arrayPush,
	        arrayRemove = _reduxForm.arrayRemove,
	        arrayRemoveAll = _reduxForm.arrayRemoveAll,
	        arrayShift = _reduxForm.arrayShift,
	        arraySplice = _reduxForm.arraySplice,
	        arraySwap = _reduxForm.arraySwap,
	        arrayUnshift = _reduxForm.arrayUnshift;
	
	    return (0, _mapValues3.default)({
	      arrayInsert: arrayInsert,
	      arrayMove: arrayMove,
	      arrayPop: arrayPop,
	      arrayPush: arrayPush,
	      arrayRemove: arrayRemove,
	      arrayRemoveAll: arrayRemoveAll,
	      arrayShift: arrayShift,
	      arraySplice: arraySplice,
	      arraySwap: arraySwap,
	      arrayUnshift: arrayUnshift
	    }, function (actionCreator) {
	      return (0, _redux.bindActionCreators)(actionCreator.bind(null, name), dispatch);
	    });
	  }, undefined, { withRef: true });
	  return connector(ConnectedFieldArray);
	};
	
	exports.default = createConnectedFieldArray;

/***/ },
/* 3636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(28);
	
	var _createFieldProps2 = __webpack_require__(1592);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _plain = __webpack_require__(329);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _onChangeValue = __webpack_require__(1594);
	
	var _onChangeValue2 = _interopRequireDefault(_onChangeValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var createConnectedFields = function createConnectedFields(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      toJS = _ref.toJS,
	      size = _ref.size;
	
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = getIn(syncErrors, name);
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name);
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedFields = function (_Component) {
	    _inherits(ConnectedFields, _Component);
	
	    function ConnectedFields(props) {
	      _classCallCheck(this, ConnectedFields);
	
	      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));
	
	      _this.handleChange = _this.handleChange.bind(_this);
	      _this.handleFocus = _this.handleFocus.bind(_this);
	      _this.handleBlur = _this.handleBlur.bind(_this);
	
	      _this.onChangeFns = props.names.reduce(function (acc, name) {
	        acc[name] = function (event) {
	          return _this.handleChange(name, event);
	        };
	        return acc;
	      }, {});
	
	      _this.onFocusFns = props.names.reduce(function (acc, name) {
	        acc[name] = function () {
	          return _this.handleFocus(name);
	        };
	        return acc;
	      }, {});
	
	      _this.onBlurFns = props.names.reduce(function (acc, name) {
	        acc[name] = function (event) {
	          return _this.handleBlur(name, event);
	        };
	        return acc;
	      }, {});
	      return _this;
	    }
	
	    _createClass(ConnectedFields, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
	          return !_this2.props._fields[nextName];
	        }))) {
	
	          // names is changed. The cached event handlers need to be updated
	          this.onChangeFns = nextProps.names.reduce(function (acc, name) {
	            acc[name] = function (event) {
	              return _this2.handleChange(name, event);
	            };
	            return acc;
	          }, {});
	
	          this.onFocusFns = nextProps.names.reduce(function (acc, name) {
	            acc[name] = function () {
	              return _this2.handleFocus(name);
	            };
	            return acc;
	          }, {});
	
	          this.onBlurFns = nextProps.names.reduce(function (acc, name) {
	            acc[name] = function (event) {
	              return _this2.handleBlur(name, event);
	            };
	            return acc;
	          }, {});
	        }
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this3 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'isDirty',
	      value: function isDirty() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).some(function (name) {
	          return _fields[name].dirty;
	        });
	      }
	    }, {
	      key: 'getValues',
	      value: function getValues() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).reduce(function (accumulator, name) {
	          return _plain2.default.setIn(accumulator, name, _fields[name].value);
	        }, {});
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange(name, event) {
	        var _props = this.props,
	            dispatch = _props.dispatch,
	            parse = _props.parse,
	            normalize = _props.normalize,
	            _reduxForm = _props._reduxForm;
	
	        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        dispatch(_reduxForm.change(name, value));
	      }
	    }, {
	      key: 'handleFocus',
	      value: function handleFocus(name) {
	        var _props2 = this.props,
	            dispatch = _props2.dispatch,
	            _reduxForm = _props2._reduxForm;
	
	        dispatch(_reduxForm.focus(name));
	      }
	    }, {
	      key: 'handleBlur',
	      value: function handleBlur(name, event) {
	        var _props3 = this.props,
	            dispatch = _props3.dispatch,
	            parse = _props3.parse,
	            normalize = _props3.normalize,
	            _reduxForm = _props3._reduxForm;
	
	        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        // dispatch blur action
	        dispatch(_reduxForm.blur(name, value));
	
	        // call post-blur callback
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this4 = this;
	
	        var _props4 = this.props,
	            component = _props4.component,
	            withRef = _props4.withRef,
	            _fields = _props4._fields,
	            _reduxForm = _props4._reduxForm,
	            rest = _objectWithoutProperties(_props4, ['component', 'withRef', '_fields', '_reduxForm']);
	
	        var sectionPrefix = _reduxForm.sectionPrefix;
	
	        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
	          var connectedProps = _fields[name];
	
	          var _createFieldProps = (0, _createFieldProps3.default)({ getIn: getIn, toJS: toJS }, name, _extends({}, connectedProps, rest, {
	            onBlur: _this4.onBlurFns[name],
	            onChange: _this4.onChangeFns[name],
	            onFocus: _this4.onFocusFns[name]
	          })),
	              custom = _createFieldProps.custom,
	              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	          accumulator.custom = custom;
	          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	          return _plain2.default.setIn(accumulator, fieldName, fieldProps);
	        }, {}),
	            custom = _Object$keys$reduce.custom,
	            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);
	
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	
	        return (0, _react.createElement)(component, _extends({}, props, custom));
	      }
	    }]);
	
	    return ConnectedFields;
	  }(_react.Component);
	
	  ConnectedFields.propTypes = {
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    _fields: _react.PropTypes.object.isRequired,
	    props: _react.PropTypes.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var names = ownProps.names,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    return {
	      _fields: names.reduce(function (accumulator, name) {
	        var initialState = getIn(formState, 'initial.' + name);
	        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	        var value = getIn(formState, 'values.' + name);
	        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	        var submitting = getIn(formState, 'submitting');
	        var pristine = value === initial;
	        accumulator[name] = {
	          asyncError: getIn(formState, 'asyncErrors.' + name),
	          asyncValidating: getIn(formState, 'asyncValidating') === name,
	          dirty: !pristine,
	          pristine: pristine,
	          state: getIn(formState, 'fields.' + name),
	          submitError: getIn(formState, 'submitErrors.' + name),
	          submitFailed: getIn(formState, 'submitFailed'),
	          submitting: submitting,
	          syncError: syncError,
	          syncWarning: syncWarning,
	          value: value,
	          _value: ownProps.value // save value passed in (for checkboxes)
	        };
	        return accumulator;
	      }, {})
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedFields);
	};
	
	exports.default = createConnectedFields;

/***/ },
/* 3637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedField = __webpack_require__(3634);
	
	var _ConnectedField2 = _interopRequireDefault(_ConnectedField);
	
	var _shallowCompare = __webpack_require__(753);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _prefixName = __webpack_require__(476);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createField = function createField(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      setIn = _ref.setIn,
	      toJS = _ref.toJS;
	
	
	  var ConnectedField = (0, _ConnectedField2.default)({
	    deepEqual: deepEqual,
	    getIn: getIn,
	    toJS: toJS
	  });
	
	  var Field = function (_Component) {
	    _inherits(Field, _Component);
	
	    function Field(props, context) {
	      _classCallCheck(this, Field);
	
	      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('Field must be inside a component decorated with reduxForm()');
	      }
	
	      _this.normalize = _this.normalize.bind(_this);
	      return _this;
	    }
	
	    _createClass(Field, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _shallowCompare2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        this.context._reduxForm.register(this.name, 'Field', function () {
	          return _this2.props.validate;
	        }, function () {
	          return _this2.props.warn;
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          // unregister old name
	          this.context._reduxForm.unregister(this.name);
	          // register new name
	          this.context._reduxForm.register((0, _prefixName2.default)(this.context, nextProps.name), 'Field');
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'normalize',
	      value: function normalize(name, value) {
	        var normalize = this.props.normalize;
	
	        if (!normalize) {
	          return value;
	        }
	        var previousValues = this.context._reduxForm.getValues();
	        var previousValue = this.value;
	        var nextValues = setIn(previousValues, name, value);
	        return normalize(value, previousValue, nextValues, previousValues);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedField, _extends({}, this.props, {
	          name: this.name,
	          normalize: this.normalize,
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return !this.pristine;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().isPristine();
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.refs.connected && this.refs.connected.getWrappedInstance().getValue();
	      }
	    }]);
	
	    return Field;
	  }(_react.Component);
	
	  Field.propTypes = {
	    name: _react.PropTypes.string.isRequired,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    format: _react.PropTypes.func,
	    normalize: _react.PropTypes.func,
	    onBlur: _react.PropTypes.func,
	    onChange: _react.PropTypes.func,
	    onFocus: _react.PropTypes.func,
	    onDragStart: _react.PropTypes.func,
	    onDrop: _react.PropTypes.func,
	    parse: _react.PropTypes.func,
	    props: _react.PropTypes.object,
	    validate: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.arrayOf(_react.PropTypes.func)]),
	    warn: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.arrayOf(_react.PropTypes.func)]),
	    withRef: _react.PropTypes.bool
	  };
	  Field.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  return Field;
	};
	
	exports.default = createField;

/***/ },
/* 3638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFieldArray = __webpack_require__(3635);
	
	var _ConnectedFieldArray2 = _interopRequireDefault(_ConnectedFieldArray);
	
	var _shallowCompare = __webpack_require__(753);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _prefixName = __webpack_require__(476);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var wrapError = function wrapError(fn, key) {
	  return fn && function () {
	    var validators = toArray(fn);
	    for (var i = 0; i < validators.length; i++) {
	      var result = validators[i].apply(validators, arguments);
	      if (result) {
	        return _defineProperty({}, key, result);
	      }
	    }
	  };
	};
	
	var createFieldArray = function createFieldArray(_ref2) {
	  var deepEqual = _ref2.deepEqual,
	      getIn = _ref2.getIn,
	      size = _ref2.size;
	
	
	  var ConnectedFieldArray = (0, _ConnectedFieldArray2.default)({ deepEqual: deepEqual, getIn: getIn, size: size });
	
	  var FieldArray = function (_Component) {
	    _inherits(FieldArray, _Component);
	
	    function FieldArray(props, context) {
	      _classCallCheck(this, FieldArray);
	
	      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(FieldArray, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _shallowCompare2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        this.context._reduxForm.register(this.name, 'FieldArray', function () {
	          return wrapError(_this2.props.validate, '_error');
	        }, function () {
	          return wrapError(_this2.props.warn, '_warning');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          // unregister old name
	          this.context._reduxForm.unregister(this.name);
	          // register new name
	          this.context._reduxForm.register((0, _prefixName2.default)(this.context, nextProps.name), 'FieldArray');
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedFieldArray, _extends({}, this.props, {
	          name: this.name,
	          syncError: this.syncError,
	          syncWarning: this.syncWarning,
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().value;
	      }
	    }]);
	
	    return FieldArray;
	  }(_react.Component);
	
	  FieldArray.propTypes = {
	    name: _react.PropTypes.string.isRequired,
	    component: _react.PropTypes.func.isRequired,
	    props: _react.PropTypes.object,
	    validate: _react.PropTypes.func,
	    warn: _react.PropTypes.func,
	    withRef: _react.PropTypes.bool
	  };
	  FieldArray.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  return FieldArray;
	};
	
	exports.default = createFieldArray;

/***/ },
/* 3639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFields = __webpack_require__(3636);
	
	var _ConnectedFields2 = _interopRequireDefault(_ConnectedFields);
	
	var _shallowCompare = __webpack_require__(753);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _plain = __webpack_require__(329);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _prefixName = __webpack_require__(476);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validateNameProp = function validateNameProp(prop) {
	  if (!prop) {
	    return new Error('No "names" prop was specified <Fields/>');
	  }
	  if (!Array.isArray(prop) && !prop._isFieldArray) {
	    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
	  }
	};
	
	var createFields = function createFields(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      toJS = _ref.toJS,
	      size = _ref.size;
	
	
	  var ConnectedFields = (0, _ConnectedFields2.default)({
	    deepEqual: deepEqual,
	    getIn: getIn,
	    toJS: toJS,
	    size: size
	  });
	
	  var Fields = function (_Component) {
	    _inherits(Fields, _Component);
	
	    function Fields(props, context) {
	      _classCallCheck(this, Fields);
	
	      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('Fields must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(Fields, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _shallowCompare2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var error = validateNameProp(this.props.names);
	        if (error) {
	          throw error;
	        }
	        var context = this.context;
	        var register = context._reduxForm.register;
	
	        this.names.forEach(function (name) {
	          return register(name, 'Field');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!_plain2.default.deepEqual(this.props.names, nextProps.names)) {
	          var context = this.context;
	          var _context$_reduxForm = context._reduxForm,
	              register = _context$_reduxForm.register,
	              unregister = _context$_reduxForm.unregister;
	          // unregister old name
	
	          this.props.names.forEach(function (name) {
	            return unregister((0, _prefixName2.default)(context, name));
	          });
	          // register new name
	          nextProps.names.forEach(function (name) {
	            return register((0, _prefixName2.default)(context, name), 'Field');
	          });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var context = this.context;
	        var unregister = context._reduxForm.unregister;
	
	        this.props.names.forEach(function (name) {
	          return unregister((0, _prefixName2.default)(context, name));
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var context = this.context;
	
	        return (0, _react.createElement)(ConnectedFields, _extends({}, this.props, {
	          names: this.props.names.map(function (name) {
	            return (0, _prefixName2.default)(context, name);
	          }),
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'names',
	      get: function get() {
	        var context = this.context;
	
	        return this.props.names.map(function (name) {
	          return (0, _prefixName2.default)(context, name);
	        });
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().isDirty();
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return !this.dirty;
	      }
	    }, {
	      key: 'values',
	      get: function get() {
	        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
	      }
	    }]);
	
	    return Fields;
	  }(_react.Component);
	
	  Fields.propTypes = {
	    names: function names(props, propName) {
	      return validateNameProp(props[propName]);
	    },
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	    format: _react.PropTypes.func,
	    parse: _react.PropTypes.func,
	    props: _react.PropTypes.object,
	    withRef: _react.PropTypes.bool
	  };
	  Fields.contextTypes = {
	    _reduxForm: _react.PropTypes.object
	  };
	
	  return Fields;
	};
	
	exports.default = createFields;

/***/ },
/* 3640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form(props, context) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('Form must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('form', this.props);
	    }
	  }]);
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = {
	  onSubmit: _react.PropTypes.func.isRequired
	};
	Form.contextTypes = {
	  _reduxForm: _react.PropTypes.object
	};
	
	exports.default = Form;

/***/ },
/* 3641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _prefixName = __webpack_require__(476);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormSection = function (_Component) {
	  _inherits(FormSection, _Component);
	
	  function FormSection(props, context) {
	    _classCallCheck(this, FormSection);
	
	    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('FormSection must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(FormSection, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var context = this.context,
	          name = this.props.name;
	
	      return {
	        _reduxForm: _extends({}, context._reduxForm, {
	          sectionPrefix: (0, _prefixName2.default)(context, name)
	        })
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          component = _props.component,
	          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);
	
	      if (_react2.default.isValidElement(children)) {
	        return children;
	      }
	
	      return (0, _react.createElement)(component, _extends({}, rest, {
	        children: children
	      }));
	    }
	  }]);
	
	  return FormSection;
	}(_react.Component);
	
	FormSection.propTypes = {
	  name: _react.PropTypes.string.isRequired,
	  component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string])
	};
	
	FormSection.defaultProps = {
	  component: 'div'
	};
	
	FormSection.childContextTypes = {
	  _reduxForm: _react.PropTypes.object.isRequired
	};
	
	FormSection.contextTypes = {
	  _reduxForm: _react.PropTypes.object
	};
	
	exports.default = FormSection;

/***/ },
/* 3642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPromise = __webpack_require__(675);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (errors && Object.keys(errors).length) {
	        stop(errors);
	        return errors;
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	exports.default = asyncValidation;

/***/ },
/* 3643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reducer = __webpack_require__(3657);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reduxForm = __webpack_require__(3658);
	
	var _reduxForm2 = _interopRequireDefault(_reduxForm);
	
	var _Field = __webpack_require__(3637);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Fields = __webpack_require__(3639);
	
	var _Fields2 = _interopRequireDefault(_Fields);
	
	var _FieldArray = __webpack_require__(3638);
	
	var _FieldArray2 = _interopRequireDefault(_FieldArray);
	
	var _formValueSelector = __webpack_require__(3650);
	
	var _formValueSelector2 = _interopRequireDefault(_formValueSelector);
	
	var _values = __webpack_require__(3683);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _getFormNames = __webpack_require__(3661);
	
	var _getFormNames2 = _interopRequireDefault(_getFormNames);
	
	var _getFormValues = __webpack_require__(3665);
	
	var _getFormValues2 = _interopRequireDefault(_getFormValues);
	
	var _getFormInitialValues = __webpack_require__(3660);
	
	var _getFormInitialValues2 = _interopRequireDefault(_getFormInitialValues);
	
	var _getFormSyncErrors = __webpack_require__(3663);
	
	var _getFormSyncErrors2 = _interopRequireDefault(_getFormSyncErrors);
	
	var _getFormAsyncErrors = __webpack_require__(3659);
	
	var _getFormAsyncErrors2 = _interopRequireDefault(_getFormAsyncErrors);
	
	var _getFormSyncWarnings = __webpack_require__(3664);
	
	var _getFormSyncWarnings2 = _interopRequireDefault(_getFormSyncWarnings);
	
	var _getFormSubmitErrors = __webpack_require__(3662);
	
	var _getFormSubmitErrors2 = _interopRequireDefault(_getFormSubmitErrors);
	
	var _isDirty = __webpack_require__(3668);
	
	var _isDirty2 = _interopRequireDefault(_isDirty);
	
	var _isInvalid = __webpack_require__(3669);
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _isPristine = __webpack_require__(1596);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _isValid = __webpack_require__(752);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _isSubmitting = __webpack_require__(3670);
	
	var _isSubmitting2 = _interopRequireDefault(_isSubmitting);
	
	var _hasSubmitSucceeded = __webpack_require__(3667);
	
	var _hasSubmitSucceeded2 = _interopRequireDefault(_hasSubmitSucceeded);
	
	var _hasSubmitFailed = __webpack_require__(3666);
	
	var _hasSubmitFailed2 = _interopRequireDefault(_hasSubmitFailed);
	
	var _Form = __webpack_require__(3640);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormSection = __webpack_require__(3641);
	
	var _FormSection2 = _interopRequireDefault(_FormSection);
	
	var _SubmissionError = __webpack_require__(1590);
	
	var _SubmissionError2 = _interopRequireDefault(_SubmissionError);
	
	var _propTypes = __webpack_require__(3656);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(1591);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actionTypes = __webpack_require__(751);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createAll = function createAll(structure) {
	  return _extends({
	    // separate out field actions
	    actionTypes: actionTypes
	  }, actions, {
	    Field: (0, _Field2.default)(structure),
	    Fields: (0, _Fields2.default)(structure),
	    FieldArray: (0, _FieldArray2.default)(structure),
	    Form: _Form2.default,
	    FormSection: _FormSection2.default,
	    formValueSelector: (0, _formValueSelector2.default)(structure),
	    getFormNames: (0, _getFormNames2.default)(structure),
	    getFormValues: (0, _getFormValues2.default)(structure),
	    getFormInitialValues: (0, _getFormInitialValues2.default)(structure),
	    getFormSyncErrors: (0, _getFormSyncErrors2.default)(structure),
	    getFormAsyncErrors: (0, _getFormAsyncErrors2.default)(structure),
	    getFormSyncWarnings: (0, _getFormSyncWarnings2.default)(structure),
	    getFormSubmitErrors: (0, _getFormSubmitErrors2.default)(structure),
	    isDirty: (0, _isDirty2.default)(structure),
	    isInvalid: (0, _isInvalid2.default)(structure),
	    isPristine: (0, _isPristine2.default)(structure),
	    isValid: (0, _isValid2.default)(structure),
	    isSubmitting: (0, _isSubmitting2.default)(structure),
	    hasSubmitSucceeded: (0, _hasSubmitSucceeded2.default)(structure),
	    hasSubmitFailed: (0, _hasSubmitFailed2.default)(structure),
	    propTypes: _propTypes2.default,
	    reduxForm: (0, _reduxForm2.default)(structure),
	    reducer: (0, _reducer2.default)(structure),
	    SubmissionError: _SubmissionError2.default,
	    values: (0, _values2.default)(structure)
	  });
	};
	
	exports.default = createAll;

/***/ },
/* 3644 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var createFieldArrayProps = function createFieldArrayProps(getIn, name, form, sectionPrefix, getValue, _ref) {
	  var arrayInsert = _ref.arrayInsert,
	      arrayMove = _ref.arrayMove,
	      arrayPop = _ref.arrayPop,
	      arrayPush = _ref.arrayPush,
	      arrayRemove = _ref.arrayRemove,
	      arrayRemoveAll = _ref.arrayRemoveAll,
	      arrayShift = _ref.arrayShift,
	      arraySplice = _ref.arraySplice,
	      arraySwap = _ref.arraySwap,
	      arrayUnshift = _ref.arrayUnshift,
	      asyncError = _ref.asyncError,
	      dirty = _ref.dirty,
	      length = _ref.length,
	      pristine = _ref.pristine,
	      submitError = _ref.submitError,
	      state = _ref.state,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      value = _ref.value,
	      props = _ref.props,
	      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	  var finalProps = _extends({
	    fields: {
	      _isFieldArray: true,
	      forEach: function forEach(callback) {
	        return (value || []).forEach(function (item, index) {
	          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      get: getValue,
	      getAll: function getAll() {
	        return value;
	      },
	      insert: arrayInsert,
	      length: length,
	      map: function map(callback) {
	        return (value || []).map(function (item, index) {
	          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      move: arrayMove,
	      name: name,
	      pop: function pop() {
	        arrayPop();
	        return getIn(value, length - 1);
	      },
	      push: arrayPush,
	      reduce: function reduce(callback, initial) {
	        return (value || []).reduce(function (accumulator, item, index) {
	          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
	        }, initial);
	      },
	      remove: arrayRemove,
	      removeAll: arrayRemoveAll,
	      shift: function shift() {
	        arrayShift();
	        return getIn(value, 0);
	      },
	      swap: arraySwap,
	      unshift: arrayUnshift
	    },
	    meta: {
	      dirty: dirty,
	      error: error,
	      form: form,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: submitting,
	      submitFailed: submitFailed,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error
	    }
	  }, props, rest);
	  return finalProps;
	};
	
	exports.default = createFieldArrayProps;

/***/ },
/* 3645 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
	  var initialized = _ref.initialized,
	      trigger = _ref.trigger,
	      pristine = _ref.pristine,
	      syncValidationPasses = _ref.syncValidationPasses;
	
	  if (!syncValidationPasses) {
	    return false;
	  }
	  switch (trigger) {
	    case 'blur':
	      // blurring
	      return true;
	    case 'submit':
	      // submitting, so only async validate if form is dirty or was never initialized
	      // conversely, DON'T async validate if the form is pristine just as it was initialized
	      return !pristine || !initialized;
	    default:
	      return false;
	  }
	};
	
	exports.default = defaultShouldAsyncValidate;

/***/ },
/* 3646 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultShouldValidate = function defaultShouldValidate(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	  return !structure.deepEqual(values, nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	exports.default = defaultShouldValidate;

/***/ },
/* 3647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(267);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createDeleteInWithCleanUp = function createDeleteInWithCleanUp(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn,
	      deleteIn = _ref.deleteIn,
	      setIn = _ref.setIn;
	
	
	  var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
	    if (path[path.length - 1] === ']') {
	      // array path
	      var pathTokens = (0, _toPath3.default)(path);
	      pathTokens.pop();
	      var parent = getIn(state, pathTokens.join('.'));
	      return parent ? setIn(state, path, undefined) : state;
	    }
	    var result = deleteIn(state, path);
	    var dotIndex = path.lastIndexOf('.');
	    if (dotIndex > 0) {
	      var parentPath = path.substring(0, dotIndex);
	      if (parentPath[parentPath.length - 1] !== ']') {
	        var _parent = getIn(result, parentPath);
	        if (deepEqual(_parent, empty)) {
	          return deleteInWithCleanUp(result, parentPath);
	        }
	      }
	    }
	    return result;
	  };
	
	  return deleteInWithCleanUp;
	};
	
	exports.default = createDeleteInWithCleanUp;

/***/ },
/* 3648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(1593);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target,
	        type = _event$target.type,
	        value = _event$target.value,
	        checked = _event$target.checked,
	        files = _event$target.files,
	        dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked;
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    return value;
	  }
	  return event;
	};
	
	exports.default = getValue;

/***/ },
/* 3649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _silenceEvent = __webpack_require__(1595);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	
	exports.default = silenceEvents;

/***/ },
/* 3650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invariant = __webpack_require__(59);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _plain = __webpack_require__(329);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFormValueSelector = function createFormValueSelector(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	
	    (0, _invariant2.default)(form, 'Form value must be specified');
	    return function (state) {
	      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      (0, _invariant2.default)(fields.length, 'No fields specified');
	      return fields.length === 1 ?
	      // only selecting one field, so return its value
	      getIn(getFormState(state), form + '.values.' + fields[0]) :
	      // selecting many fields, so return an object of field values
	      fields.reduce(function (accumulator, field) {
	        var value = getIn(getFormState(state), form + '.values.' + field);
	        return value === undefined ? accumulator : _plain2.default.setIn(accumulator, field, value);
	      }, {});
	    };
	  };
	};
	
	exports.default = createFormValueSelector;

/***/ },
/* 3651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _plain = __webpack_require__(329);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var getError = function getError(value, values, props, validators) {
	  var array = toArray(validators);
	  for (var i = 0; i < array.length; i++) {
	    var error = array[i](value, values, props);
	    if (error) {
	      return error;
	    }
	  }
	};
	
	var generateValidator = function generateValidator(validators, _ref) {
	  var getIn = _ref.getIn;
	  return function (values, props) {
	    var errors = {};
	    Object.keys(validators).forEach(function (name) {
	      var value = getIn(values, name);
	      var error = getError(value, values, props, validators[name]);
	      if (error) {
	        errors = _plain2.default.setIn(errors, name, error);
	      }
	    });
	    return errors;
	  };
	};
	
	exports.default = generateValidator;

/***/ },
/* 3652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPromise = __webpack_require__(675);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _SubmissionError = __webpack_require__(1590);
	
	var _SubmissionError2 = _interopRequireDefault(_SubmissionError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
	  var dispatch = props.dispatch,
	      onSubmitFail = props.onSubmitFail,
	      onSubmitSuccess = props.onSubmitSuccess,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      setSubmitFailed = props.setSubmitFailed,
	      setSubmitSucceeded = props.setSubmitSucceeded,
	      syncErrors = props.syncErrors,
	      touch = props.touch,
	      values = props.values,
	      persistentSubmitErrors = props.persistentSubmitErrors;
	
	
	  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched
	
	  if (valid || persistentSubmitErrors) {
	    var doSubmit = function doSubmit() {
	      var result = void 0;
	      try {
	        result = submit(values, dispatch, props);
	      } catch (submitError) {
	        var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	        stopSubmit(error);
	        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	        if (onSubmitFail) {
	          onSubmitFail(error, dispatch, submitError, props);
	        }
	        if (error || onSubmitFail) {
	          // if you've provided an onSubmitFail callback, don't re-throw the error
	          return error;
	        } else {
	          throw submitError;
	        }
	      }
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          setSubmitSucceeded();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(submitResult, dispatch, props);
	          }
	          return submitResult;
	        }, function (submitError) {
	          var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	          stopSubmit(error);
	          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	          if (onSubmitFail) {
	            onSubmitFail(error, dispatch, submitError, props);
	          }
	          if (error || onSubmitFail) {
	            // if you've provided an onSubmitFail callback, don't re-throw the error
	            return error;
	          } else {
	            throw submitError;
	          }
	        });
	      } else {
	        setSubmitSucceeded();
	        if (onSubmitSuccess) {
	          onSubmitSuccess(result, dispatch, props);
	        }
	      }
	      return result;
	    };
	
	    var asyncValidateResult = asyncValidate && asyncValidate();
	    if (asyncValidateResult) {
	      return asyncValidateResult.then(function (asyncErrors) {
	        if (asyncErrors) {
	          throw asyncErrors;
	        }
	        return doSubmit();
	      }).catch(function (asyncErrors) {
	        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	        if (onSubmitFail) {
	          onSubmitFail(asyncErrors, dispatch, null, props);
	        }
	        return Promise.reject(asyncErrors);
	      });
	    } else {
	      return doSubmit();
	    }
	  } else {
	    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	    if (onSubmitFail) {
	      onSubmitFail(syncErrors, dispatch, null, props);
	    }
	    return syncErrors;
	  }
	};
	
	exports.default = handleSubmit;

/***/ },
/* 3653 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getErrorKeys = function getErrorKeys(name, type) {
	  switch (type) {
	    case 'Field':
	      return [name, name + '._error'];
	    case 'FieldArray':
	      return [name + '._error'];
	    default:
	      throw new Error('Unknown field type');
	  }
	};
	
	var createHasError = function createHasError(_ref) {
	  var getIn = _ref.getIn;
	
	  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
	    if (!syncErrors && !asyncErrors && !submitErrors) {
	      return false;
	    }
	
	    var name = getIn(field, 'name');
	    var type = getIn(field, 'type');
	    return getErrorKeys(name, type).some(function (key) {
	      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
	    });
	  };
	  return hasError;
	};
	
	exports.default = createHasError;

/***/ },
/* 3654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.values = exports.untouch = exports.unregisterField = exports.touch = exports.SubmissionError = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.reset = exports.registerField = exports.reduxForm = exports.reducer = exports.propTypes = exports.hasSubmitFailed = exports.hasSubmitSucceeded = exports.isSubmitting = exports.isValid = exports.isPristine = exports.isInvalid = exports.isDirty = exports.initialize = exports.getFormSubmitErrors = exports.getFormSyncWarnings = exports.getFormAsyncErrors = exports.getFormSyncErrors = exports.getFormInitialValues = exports.getFormValues = exports.getFormNames = exports.formValueSelector = exports.focus = exports.FormSection = exports.Form = exports.FieldArray = exports.Fields = exports.Field = exports.destroy = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.actionTypes = undefined;
	
	var _createAll2 = __webpack_require__(3643);
	
	var _createAll3 = _interopRequireDefault(_createAll2);
	
	var _immutable = __webpack_require__(3672);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _createAll = (0, _createAll3.default)(_immutable2.default);
	
	var actionTypes = _createAll.actionTypes,
	    arrayInsert = _createAll.arrayInsert,
	    arrayMove = _createAll.arrayMove,
	    arrayPop = _createAll.arrayPop,
	    arrayPush = _createAll.arrayPush,
	    arrayRemove = _createAll.arrayRemove,
	    arrayRemoveAll = _createAll.arrayRemoveAll,
	    arrayShift = _createAll.arrayShift,
	    arraySplice = _createAll.arraySplice,
	    arraySwap = _createAll.arraySwap,
	    arrayUnshift = _createAll.arrayUnshift,
	    autofill = _createAll.autofill,
	    blur = _createAll.blur,
	    change = _createAll.change,
	    destroy = _createAll.destroy,
	    Field = _createAll.Field,
	    Fields = _createAll.Fields,
	    FieldArray = _createAll.FieldArray,
	    Form = _createAll.Form,
	    FormSection = _createAll.FormSection,
	    focus = _createAll.focus,
	    formValueSelector = _createAll.formValueSelector,
	    getFormNames = _createAll.getFormNames,
	    getFormValues = _createAll.getFormValues,
	    getFormInitialValues = _createAll.getFormInitialValues,
	    getFormSyncErrors = _createAll.getFormSyncErrors,
	    getFormAsyncErrors = _createAll.getFormAsyncErrors,
	    getFormSyncWarnings = _createAll.getFormSyncWarnings,
	    getFormSubmitErrors = _createAll.getFormSubmitErrors,
	    initialize = _createAll.initialize,
	    isDirty = _createAll.isDirty,
	    isInvalid = _createAll.isInvalid,
	    isPristine = _createAll.isPristine,
	    isValid = _createAll.isValid,
	    isSubmitting = _createAll.isSubmitting,
	    hasSubmitSucceeded = _createAll.hasSubmitSucceeded,
	    hasSubmitFailed = _createAll.hasSubmitFailed,
	    propTypes = _createAll.propTypes,
	    reducer = _createAll.reducer,
	    reduxForm = _createAll.reduxForm,
	    registerField = _createAll.registerField,
	    reset = _createAll.reset,
	    setSubmitFailed = _createAll.setSubmitFailed,
	    setSubmitSucceeded = _createAll.setSubmitSucceeded,
	    startAsyncValidation = _createAll.startAsyncValidation,
	    startSubmit = _createAll.startSubmit,
	    stopAsyncValidation = _createAll.stopAsyncValidation,
	    stopSubmit = _createAll.stopSubmit,
	    submit = _createAll.submit,
	    SubmissionError = _createAll.SubmissionError,
	    touch = _createAll.touch,
	    unregisterField = _createAll.unregisterField,
	    untouch = _createAll.untouch,
	    values = _createAll.values;
	exports.actionTypes = actionTypes;
	exports.arrayInsert = arrayInsert;
	exports.arrayMove = arrayMove;
	exports.arrayPop = arrayPop;
	exports.arrayPush = arrayPush;
	exports.arrayRemove = arrayRemove;
	exports.arrayRemoveAll = arrayRemoveAll;
	exports.arrayShift = arrayShift;
	exports.arraySplice = arraySplice;
	exports.arraySwap = arraySwap;
	exports.arrayUnshift = arrayUnshift;
	exports.autofill = autofill;
	exports.blur = blur;
	exports.change = change;
	exports.destroy = destroy;
	exports.Field = Field;
	exports.Fields = Fields;
	exports.FieldArray = FieldArray;
	exports.Form = Form;
	exports.FormSection = FormSection;
	exports.focus = focus;
	exports.formValueSelector = formValueSelector;
	exports.getFormNames = getFormNames;
	exports.getFormValues = getFormValues;
	exports.getFormInitialValues = getFormInitialValues;
	exports.getFormSyncErrors = getFormSyncErrors;
	exports.getFormAsyncErrors = getFormAsyncErrors;
	exports.getFormSyncWarnings = getFormSyncWarnings;
	exports.getFormSubmitErrors = getFormSubmitErrors;
	exports.initialize = initialize;
	exports.isDirty = isDirty;
	exports.isInvalid = isInvalid;
	exports.isPristine = isPristine;
	exports.isValid = isValid;
	exports.isSubmitting = isSubmitting;
	exports.hasSubmitSucceeded = hasSubmitSucceeded;
	exports.hasSubmitFailed = hasSubmitFailed;
	exports.propTypes = propTypes;
	exports.reducer = reducer;
	exports.reduxForm = reduxForm;
	exports.registerField = registerField;
	exports.reset = reset;
	exports.setSubmitFailed = setSubmitFailed;
	exports.setSubmitSucceeded = setSubmitSucceeded;
	exports.startAsyncValidation = startAsyncValidation;
	exports.startSubmit = startSubmit;
	exports.stopAsyncValidation = stopAsyncValidation;
	exports.stopSubmit = stopSubmit;
	exports.submit = submit;
	exports.SubmissionError = SubmissionError;
	exports.touch = touch;
	exports.unregisterField = unregisterField;
	exports.untouch = untouch;
	exports.values = values;

/***/ },
/* 3655 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	exports.default = isReactNative;

/***/ },
/* 3656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var any = _react.PropTypes.any,
	    bool = _react.PropTypes.bool,
	    func = _react.PropTypes.func,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string,
	    oneOfType = _react.PropTypes.oneOfType,
	    object = _react.PropTypes.object;
	
	
	var propTypes = {
	  // State:
	  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
	  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
	  dirty: bool.isRequired, // true if any values are different from initialValues
	  error: any, // form-wide error from '_error' key in validation result
	  form: string.isRequired, // the name of the form
	  invalid: bool.isRequired, // true if there are any validation errors
	  initialized: bool.isRequired, // true if the form has been initialized
	  initialValues: object, // the initialValues object passed to reduxForm
	  pristine: bool.isRequired, // true if the values are the same as initialValues
	  pure: bool.isRequired, // if true, implements shouldComponentUpdate
	  submitting: bool.isRequired, // true if the form is in the process of being submitted
	  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
	  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
	  valid: bool.isRequired, // true if there are no validation errors
	  warning: any, // form-wide warning from '_warning' key in validation result
	  // Actions:
	  array: shape({
	    insert: func.isRequired, // function to insert a value into an array field
	    move: func.isRequired, // function to move a value within an array field
	    pop: func.isRequired, // function to pop a value off of an array field
	    push: func.isRequired, // function to push a value onto an array field
	    remove: func.isRequired, // function to remove a value from an array field
	    removeAll: func.isRequired, // function to remove all the values from an array field
	    shift: func.isRequired, // function to shift a value out of an array field
	    splice: func.isRequired, // function to splice a value into an array field
	    swap: func.isRequired, // function to swap values in an array field
	    unshift: func.isRequired // function to unshift a value into an array field
	  }),
	  asyncValidate: func.isRequired, // function to trigger async validation
	  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
	  blur: func.isRequired, // action to mark a field as blurred
	  change: func.isRequired, // action to change the value of a field
	  clearAsyncError: func.isRequired, // action to clear the async error of a field
	  destroy: func.isRequired, // action to destroy the form's data in Redux
	  dispatch: func.isRequired, // the Redux dispatch action
	  handleSubmit: func.isRequired, // function to submit the form
	  initialize: func.isRequired, // action to initialize form data
	  reset: func.isRequired, // action to reset the form data to previously initialized values
	  touch: func.isRequired, // action to mark fields as touched
	  submit: func.isRequired, // action to trigger a submission of the specified form
	  untouch: func.isRequired, // action to mark fields as untouched
	
	  // triggerSubmit
	  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
	  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
	};
	
	exports.default = propTypes;

/***/ },
/* 3657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionTypes = __webpack_require__(751);
	
	var _deleteInWithCleanUp = __webpack_require__(3647);
	
	var _deleteInWithCleanUp2 = _interopRequireDefault(_deleteInWithCleanUp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var createReducer = function createReducer(structure) {
	  var _behaviors;
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      deleteIn = structure.deleteIn,
	      fromJS = structure.fromJS,
	      keys = structure.keys,
	      size = structure.size,
	      splice = structure.splice;
	
	  var deleteInWithCleanUp = (0, _deleteInWithCleanUp2.default)(structure);
	  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
	    var existing = getIn(state, key + '.' + field);
	    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
	  };
	  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
	  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
	    var result = state;
	    var nonValuesValue = value != null ? empty : undefined;
	    result = doSplice(result, 'values', field, index, removeNum, value, true);
	    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
	    result = doSplice(result, 'syncErrors', field, index, removeNum, undefined);
	    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
	    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
	    return result;
	  };
	
	  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, _actionTypes.ARRAY_INSERT, function (state, _ref) {
	    var _ref$meta = _ref.meta,
	        field = _ref$meta.field,
	        index = _ref$meta.index,
	        payload = _ref.payload;
	
	    return arraySplice(state, field, index, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_MOVE, function (state, _ref2) {
	    var _ref2$meta = _ref2.meta,
	        field = _ref2$meta.field,
	        from = _ref2$meta.from,
	        to = _ref2$meta.to;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    var result = state;
	    if (length) {
	      rootKeys.forEach(function (key) {
	        var path = key + '.' + field;
	        if (getIn(result, path)) {
	          var value = getIn(result, path + '[' + from + ']');
	          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
	          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
	        }
	      });
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_POP, function (state, _ref3) {
	    var field = _ref3.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, length - 1, 1) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_PUSH, function (state, _ref4) {
	    var field = _ref4.meta.field,
	        payload = _ref4.payload;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return arraySplice(state, field, length, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE, function (state, _ref5) {
	    var _ref5$meta = _ref5.meta,
	        field = _ref5$meta.field,
	        index = _ref5$meta.index;
	
	    return arraySplice(state, field, index, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE_ALL, function (state, _ref6) {
	    var field = _ref6.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, 0, length) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SHIFT, function (state, _ref7) {
	    var field = _ref7.meta.field;
	
	    return arraySplice(state, field, 0, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SPLICE, function (state, _ref8) {
	    var _ref8$meta = _ref8.meta,
	        field = _ref8$meta.field,
	        index = _ref8$meta.index,
	        removeNum = _ref8$meta.removeNum,
	        payload = _ref8.payload;
	
	    return arraySplice(state, field, index, removeNum, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SWAP, function (state, _ref9) {
	    var _ref9$meta = _ref9.meta,
	        field = _ref9$meta.field,
	        indexA = _ref9$meta.indexA,
	        indexB = _ref9$meta.indexB;
	
	    var result = state;
	    rootKeys.forEach(function (key) {
	      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
	      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
	      if (valueA !== undefined || valueB !== undefined) {
	        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
	        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
	      }
	    });
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_UNSHIFT, function (state, _ref10) {
	    var field = _ref10.meta.field,
	        payload = _ref10.payload;
	
	    return arraySplice(state, field, 0, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.AUTOFILL, function (state, _ref11) {
	    var field = _ref11.meta.field,
	        payload = _ref11.payload;
	
	    var result = state;
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    result = setIn(result, 'fields.' + field + '.autofilled', true);
	    result = setIn(result, 'values.' + field, payload);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.BLUR, function (state, _ref12) {
	    var _ref12$meta = _ref12.meta,
	        field = _ref12$meta.field,
	        touch = _ref12$meta.touch,
	        payload = _ref12.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    if (field === getIn(result, 'active')) {
	      result = deleteIn(result, 'active');
	    }
	    result = deleteIn(result, 'fields.' + field + '.active');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CHANGE, function (state, _ref13) {
	    var _ref13$meta = _ref13.meta,
	        field = _ref13$meta.field,
	        touch = _ref13$meta.touch,
	        persistentSubmitErrors = _ref13$meta.persistentSubmitErrors,
	        payload = _ref13.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    if (!persistentSubmitErrors) {
	      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    }
	    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT, function (state) {
	    return deleteIn(state, 'triggerSubmit');
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT_ERRORS, function (state) {
	    return deleteInWithCleanUp(state, 'submitErrors');
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_ASYNC_ERROR, function (state, _ref14) {
	    var field = _ref14.meta.field;
	
	    return deleteIn(state, 'asyncErrors.' + field);
	  }), _defineProperty(_behaviors, _actionTypes.FOCUS, function (state, _ref15) {
	    var field = _ref15.meta.field;
	
	    var result = state;
	    var previouslyActive = getIn(state, 'active');
	    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
	    result = setIn(result, 'fields.' + field + '.visited', true);
	    result = setIn(result, 'fields.' + field + '.active', true);
	    result = setIn(result, 'active', field);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.INITIALIZE, function (state, _ref16) {
	    var payload = _ref16.payload,
	        _ref16$meta = _ref16.meta,
	        keepDirty = _ref16$meta.keepDirty,
	        keepSubmitSucceeded = _ref16$meta.keepSubmitSucceeded;
	
	    var mapData = fromJS(payload);
	    var result = empty; // clean all field state
	
	    // persist old warnings, they will get recalculated if the new form values are different from the old values
	    var warning = getIn(state, 'warning');
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    }
	    var syncWarnings = getIn(state, 'syncWarnings');
	    if (syncWarnings) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    }
	
	    // persist old errors, they will get recalculated if the new form values are different from the old values
	    var error = getIn(state, 'error');
	    if (error) {
	      result = setIn(result, 'error', error);
	    }
	    var syncErrors = getIn(state, 'syncErrors');
	    if (syncErrors) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    }
	
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	    var newValues = mapData;
	    if (keepDirty && registeredFields) {
	      //
	      // Keep the value of dirty fields while updating the value of
	      // pristine fields. This way, apps can reinitialize forms while
	      // avoiding stomping on user edits.
	      //
	      // Note 1: The initialize action replaces all initial values
	      // regardless of keepDirty.
	      //
	      // Note 2: When a field is dirty, keepDirty is enabled, and the field
	      // value is the same as the new initial value for the field, the
	      // initialize action causes the field to become pristine. That effect
	      // is what we want.
	      //
	      var previousValues = getIn(state, 'values');
	      var previousInitialValues = getIn(state, 'initial');
	      keys(registeredFields).forEach(function (name) {
	        var previousInitialValue = getIn(previousInitialValues, name);
	        var previousValue = getIn(previousValues, name);
	        if (!deepEqual(previousValue, previousInitialValue)) {
	          // This field was dirty. Restore the dirty value.
	          newValues = setIn(newValues, name, previousValue);
	        }
	      });
	    }
	    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
	      result = setIn(result, 'submitSucceeded', true);
	    }
	    result = setIn(result, 'values', newValues);
	    result = setIn(result, 'initial', mapData);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.REGISTER_FIELD, function (state, _ref17) {
	    var _ref17$payload = _ref17.payload,
	        name = _ref17$payload.name,
	        type = _ref17$payload.type;
	
	    var key = 'registeredFields[\'' + name + '\']';
	    var field = getIn(state, key);
	    if (field) {
	      var count = getIn(field, 'count') + 1;
	      field = setIn(field, 'count', count);
	    } else {
	      field = fromJS({ name: name, type: type, count: 1 });
	    }
	    return setIn(state, key, field);
	  }), _defineProperty(_behaviors, _actionTypes.RESET, function (state) {
	    var result = empty;
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	    var values = getIn(state, 'initial');
	    if (values) {
	      result = setIn(result, 'values', values);
	      result = setIn(result, 'initial', values);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SUBMIT, function (state) {
	    return setIn(state, 'triggerSubmit', true);
	  }), _defineProperty(_behaviors, _actionTypes.START_ASYNC_VALIDATION, function (state, _ref18) {
	    var field = _ref18.meta.field;
	
	    return setIn(state, 'asyncValidating', field || true);
	  }), _defineProperty(_behaviors, _actionTypes.START_SUBMIT, function (state) {
	    return setIn(state, 'submitting', true);
	  }), _defineProperty(_behaviors, _actionTypes.STOP_ASYNC_VALIDATION, function (state, _ref19) {
	    var payload = _ref19.payload;
	
	    var result = state;
	    result = deleteIn(result, 'asyncValidating');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'asyncErrors');
	      }
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'asyncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.STOP_SUBMIT, function (state, _ref20) {
	    var payload = _ref20.payload;
	
	    var result = state;
	    result = deleteIn(result, 'submitting');
	    result = deleteIn(result, 'submitFailed');
	    result = deleteIn(result, 'submitSucceeded');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      } else {
	        result = deleteIn(result, 'error');
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'submitErrors');
	      }
	      result = setIn(result, 'submitFailed', true);
	    } else {
	      result = setIn(result, 'submitSucceeded', true);
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'submitErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_FAILED, function (state, _ref21) {
	    var fields = _ref21.meta.fields;
	
	    var result = state;
	    result = setIn(result, 'submitFailed', true);
	    result = deleteIn(result, 'submitSucceeded');
	    result = deleteIn(result, 'submitting');
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    if (fields.length) {
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_SUCCEEDED, function (state) {
	    var result = state;
	    result = deleteIn(result, 'submitFailed');
	    result = setIn(result, 'submitSucceeded', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.TOUCH, function (state, _ref22) {
	    var fields = _ref22.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    result = setIn(result, 'anyTouched', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNREGISTER_FIELD, function (state, _ref23) {
	    var _ref23$payload = _ref23.payload,
	        name = _ref23$payload.name,
	        destroyOnUnmount = _ref23$payload.destroyOnUnmount;
	
	    var result = state;
	    var key = 'registeredFields[\'' + name + '\']';
	    var field = getIn(result, key);
	    if (!field) {
	      return result;
	    }
	
	    var count = getIn(field, 'count') - 1;
	    if (count <= 0 && destroyOnUnmount) {
	      result = deleteIn(result, key);
	      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
	        result = deleteIn(result, 'registeredFields');
	      }
	    } else {
	      field = setIn(field, 'count', count);
	      result = setIn(result, key, field);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNTOUCH, function (state, _ref24) {
	    var fields = _ref24.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = deleteIn(result, 'fields.' + field + '.touched');
	    });
	    var anyTouched = keys(getIn(result, 'registeredFields')).some(function (key) {
	      return getIn(result, 'fields.' + key + '.touched');
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_ERRORS, function (state, _ref25) {
	    var _ref25$payload = _ref25.payload,
	        syncErrors = _ref25$payload.syncErrors,
	        error = _ref25$payload.error;
	
	    var result = state;
	    if (error) {
	      result = setIn(result, 'error', error);
	      result = setIn(result, 'syncError', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'syncError');
	    }
	    if (Object.keys(syncErrors).length) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    } else {
	      result = deleteIn(result, 'syncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_WARNINGS, function (state, _ref26) {
	    var _ref26$payload = _ref26.payload,
	        syncWarnings = _ref26$payload.syncWarnings,
	        warning = _ref26$payload.warning;
	
	    var result = state;
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    } else {
	      result = deleteIn(result, 'warning');
	    }
	    if (Object.keys(syncWarnings).length) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } else {
	      result = deleteIn(result, 'syncWarnings');
	    }
	    return result;
	  }), _behaviors);
	
	  var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	    var action = arguments[1];
	
	    var behavior = behaviors[action.type];
	    return behavior ? behavior(state, action) : state;
	  };
	
	  var byForm = function byForm(reducer) {
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var form = action && action.meta && action.meta.form;
	      if (!form) {
	        return state;
	      }
	      if (action.type === _actionTypes.DESTROY) {
	        return action.meta.form.reduce(function (result, form) {
	          return deleteInWithCleanUp(result, form);
	        }, state);
	      }
	      var formState = getIn(state, form);
	      var result = reducer(formState, action);
	      return result === formState ? state : setIn(state, form, result);
	    };
	  };
	
	  /**
	   * Adds additional functionality to the reducer
	   */
	  function decorate(target) {
	    target.plugin = function plugin(reducers) {
	      var _this = this;
	
	      // use 'function' keyword to enable 'this'
	      return decorate(function () {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return Object.keys(reducers).reduce(function (accumulator, key) {
	          var previousState = getIn(accumulator, key);
	          var nextState = reducers[key](previousState, action, getIn(state, key));
	          return nextState === previousState ? accumulator : setIn(accumulator, key, nextState);
	        }, _this(state, action));
	      });
	    };
	
	    return target;
	  }
	
	  return decorate(byForm(reducer));
	};
	
	exports.default = createReducer;

/***/ },
/* 3658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge4 = __webpack_require__(3777);
	
	var _merge5 = _interopRequireDefault(_merge4);
	
	var _mapValues2 = __webpack_require__(1617);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _hoistNonReactStatics = __webpack_require__(674);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _reactRedux = __webpack_require__(28);
	
	var _redux = __webpack_require__(332);
	
	var _isPromise = __webpack_require__(675);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _getDisplayName = __webpack_require__(3682);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _actions = __webpack_require__(1591);
	
	var importedActions = _interopRequireWildcard(_actions);
	
	var _handleSubmit = __webpack_require__(3652);
	
	var _handleSubmit2 = _interopRequireDefault(_handleSubmit);
	
	var _silenceEvent = __webpack_require__(1595);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _silenceEvents = __webpack_require__(3649);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _asyncValidation = __webpack_require__(3642);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _defaultShouldAsyncValidate = __webpack_require__(3645);
	
	var _defaultShouldAsyncValidate2 = _interopRequireDefault(_defaultShouldAsyncValidate);
	
	var _defaultShouldValidate = __webpack_require__(3646);
	
	var _defaultShouldValidate2 = _interopRequireDefault(_defaultShouldValidate);
	
	var _plain = __webpack_require__(329);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _generateValidator2 = __webpack_require__(3651);
	
	var _generateValidator3 = _interopRequireDefault(_generateValidator2);
	
	var _isValid = __webpack_require__(752);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
	};
	
	// extract field-specific actions
	
	var arrayInsert = importedActions.arrayInsert,
	    arrayMove = importedActions.arrayMove,
	    arrayPop = importedActions.arrayPop,
	    arrayPush = importedActions.arrayPush,
	    arrayRemove = importedActions.arrayRemove,
	    arrayRemoveAll = importedActions.arrayRemoveAll,
	    arrayShift = importedActions.arrayShift,
	    arraySplice = importedActions.arraySplice,
	    arraySwap = importedActions.arraySwap,
	    arrayUnshift = importedActions.arrayUnshift,
	    blur = importedActions.blur,
	    change = importedActions.change,
	    focus = importedActions.focus,
	    formActions = _objectWithoutProperties(importedActions, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);
	
	var arrayActions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift
	};
	
	var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(importedActions)), ['array', 'asyncErrors', 'initialized', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);
	
	var checkSubmit = function checkSubmit(submit) {
	  if (!submit || typeof submit !== 'function') {
	    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	  }
	  return submit;
	};
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(structure) {
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      keys = structure.keys,
	      fromJS = structure.fromJS;
	
	  var isValid = (0, _isValid2.default)(structure);
	  return function (initialConfig) {
	    var config = _extends({
	      touchOnBlur: true,
	      touchOnChange: false,
	      persistentSubmitErrors: false,
	      destroyOnUnmount: true,
	      shouldAsyncValidate: _defaultShouldAsyncValidate2.default,
	      shouldValidate: _defaultShouldValidate2.default,
	      enableReinitialize: false,
	      keepDirtyOnReinitialize: false,
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      },
	      pure: true,
	      forceUnregisterOnUnmount: false
	    }, initialConfig);
	
	    return function (WrappedComponent) {
	      var Form = function (_Component) {
	        _inherits(Form, _Component);
	
	        function Form(props) {
	          _classCallCheck(this, Form);
	
	          var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
	          _this.submit = _this.submit.bind(_this);
	          _this.reset = _this.reset.bind(_this);
	          _this.asyncValidate = _this.asyncValidate.bind(_this);
	          _this.getValues = _this.getValues.bind(_this);
	          _this.register = _this.register.bind(_this);
	          _this.unregister = _this.unregister.bind(_this);
	          _this.submitCompleted = _this.submitCompleted.bind(_this);
	          _this.submitFailed = _this.submitFailed.bind(_this);
	          _this.fieldValidators = {};
	          _this.lastFieldValidatorKeys = [];
	          _this.fieldWarners = {};
	          _this.lastFieldWarnerKeys = [];
	          return _this;
	        }
	
	        _createClass(Form, [{
	          key: 'getChildContext',
	          value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	              _reduxForm: _extends({}, this.props, {
	                getFormState: function getFormState(state) {
	                  return getIn(_this2.props.getFormState(state), _this2.props.form);
	                },
	                asyncValidate: this.asyncValidate,
	                getValues: this.getValues,
	                sectionPrefix: undefined,
	                register: this.register,
	                unregister: this.unregister,
	                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
	                  return _this2.innerOnSubmit = innerOnSubmit;
	                }
	              })
	            };
	          }
	        }, {
	          key: 'initIfNeeded',
	          value: function initIfNeeded(nextProps) {
	            var enableReinitialize = this.props.enableReinitialize;
	
	            if (nextProps) {
	              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
	                var keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
	                this.props.initialize(nextProps.initialValues, keepDirty);
	              }
	            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
	              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize);
	            }
	          }
	        }, {
	          key: 'updateSyncErrorsIfNeeded',
	          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError) {
	            var _props = this.props,
	                error = _props.error,
	                syncErrors = _props.syncErrors,
	                updateSyncErrors = _props.updateSyncErrors;
	
	            var noErrors = (!syncErrors || !Object.keys(syncErrors).length) && !error;
	            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
	            if (!(noErrors && nextNoErrors) && (!_plain2.default.deepEqual(syncErrors, nextSyncErrors) || !_plain2.default.deepEqual(error, nextError))) {
	              updateSyncErrors(nextSyncErrors, nextError);
	            }
	          }
	        }, {
	          key: 'clearSubmitPromiseIfNeeded',
	          value: function clearSubmitPromiseIfNeeded(nextProps) {
	            var submitting = this.props.submitting;
	
	            if (this.submitPromise && submitting && !nextProps.submitting) {
	              delete this.submitPromise;
	            }
	          }
	        }, {
	          key: 'submitIfNeeded',
	          value: function submitIfNeeded(nextProps) {
	            var _props2 = this.props,
	                clearSubmit = _props2.clearSubmit,
	                triggerSubmit = _props2.triggerSubmit;
	
	            if (!triggerSubmit && nextProps.triggerSubmit) {
	              clearSubmit();
	              this.submit();
	            }
	          }
	        }, {
	          key: 'validateIfNeeded',
	          value: function validateIfNeeded(nextProps) {
	            var _props3 = this.props,
	                shouldValidate = _props3.shouldValidate,
	                validate = _props3.validate,
	                values = _props3.values;
	
	            var fieldLevelValidate = this.generateValidator();
	            if (validate || fieldLevelValidate) {
	              var initialRender = nextProps === undefined;
	              var fieldValidatorKeys = Object.keys(this.getValidators());
	              var shouldValidateResult = shouldValidate({
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
	                fieldValidatorKeys: fieldValidatorKeys,
	                structure: structure
	              });
	
	              if (shouldValidateResult) {
	                var propsToValidate = initialRender ? this.props : nextProps;
	
	                var _merge2 = (0, _merge5.default)(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
	                    _error = _merge2._error,
	                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);
	
	                this.lastFieldValidatorKeys = fieldValidatorKeys;
	                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error);
	              }
	            }
	          }
	        }, {
	          key: 'updateSyncWarningsIfNeeded',
	          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning) {
	            var _props4 = this.props,
	                warning = _props4.warning,
	                syncWarnings = _props4.syncWarnings,
	                updateSyncWarnings = _props4.updateSyncWarnings;
	
	            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
	            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
	            if (!(noWarnings && nextNoWarnings) && (!_plain2.default.deepEqual(syncWarnings, nextSyncWarnings) || !_plain2.default.deepEqual(warning, nextWarning))) {
	              updateSyncWarnings(nextSyncWarnings, nextWarning);
	            }
	          }
	        }, {
	          key: 'warnIfNeeded',
	          value: function warnIfNeeded(nextProps) {
	            var _props5 = this.props,
	                shouldValidate = _props5.shouldValidate,
	                warn = _props5.warn,
	                values = _props5.values;
	
	            var fieldLevelWarn = this.generateWarner();
	            if (warn || fieldLevelWarn) {
	              var initialRender = nextProps === undefined;
	              var fieldWarnerKeys = Object.keys(this.getWarners());
	              var shouldWarnResult = shouldValidate({
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
	                fieldValidatorKeys: fieldWarnerKeys,
	                structure: structure
	              });
	
	              if (shouldWarnResult) {
	                var propsToWarn = initialRender ? this.props : nextProps;
	
	                var _merge3 = (0, _merge5.default)(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
	                    _warning = _merge3._warning,
	                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);
	
	                this.lastFieldWarnerKeys = fieldWarnerKeys;
	                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning);
	              }
	            }
	          }
	        }, {
	          key: 'componentWillMount',
	          value: function componentWillMount() {
	            this.initIfNeeded();
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	        }, {
	          key: 'componentWillReceiveProps',
	          value: function componentWillReceiveProps(nextProps) {
	            this.initIfNeeded(nextProps);
	            this.validateIfNeeded(nextProps);
	            this.warnIfNeeded(nextProps);
	            this.clearSubmitPromiseIfNeeded(nextProps);
	            this.submitIfNeeded(nextProps);
	            if (nextProps.onChange) {
	              if (!deepEqual(nextProps.values, this.props.values)) {
	                nextProps.onChange(nextProps.values, nextProps.dispatch, nextProps);
	              }
	            }
	          }
	        }, {
	          key: 'shouldComponentUpdate',
	          value: function shouldComponentUpdate(nextProps) {
	            var _this3 = this;
	
	            if (!this.props.pure) return true;
	            return Object.keys(nextProps).some(function (prop) {
	              // useful to debug rerenders
	              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	              // }
	              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	            });
	          }
	        }, {
	          key: 'componentWillUnmount',
	          value: function componentWillUnmount() {
	            var _props6 = this.props,
	                destroyOnUnmount = _props6.destroyOnUnmount,
	                destroy = _props6.destroy;
	
	            if (destroyOnUnmount) {
	              this.destroyed = true;
	              destroy();
	            }
	          }
	        }, {
	          key: 'getValues',
	          value: function getValues() {
	            return this.props.values;
	          }
	        }, {
	          key: 'isValid',
	          value: function isValid() {
	            return this.props.valid;
	          }
	        }, {
	          key: 'isPristine',
	          value: function isPristine() {
	            return this.props.pristine;
	          }
	        }, {
	          key: 'register',
	          value: function register(name, type, getValidator, getWarner) {
	            this.props.registerField(name, type);
	            if (getValidator) {
	              this.fieldValidators[name] = getValidator;
	            }
	            if (getWarner) {
	              this.fieldWarners[name] = getWarner;
	            }
	          }
	        }, {
	          key: 'unregister',
	          value: function unregister(name) {
	            if (!this.destroyed) {
	              if (this.props.destroyOnUnmount || this.props.forceUnregisterOnUnmount) {
	                this.props.unregisterField(name);
	                delete this.fieldValidators[name];
	                delete this.fieldWarners[name];
	              } else {
	                this.props.unregisterField(name, false);
	              }
	            }
	          }
	        }, {
	          key: 'getFieldList',
	          value: function getFieldList(options) {
	            var registeredFields = this.props.registeredFields;
	            var list = [];
	            if (!registeredFields) {
	              return list;
	            }
	            var keySeq = keys(registeredFields);
	            if (options && options.excludeFieldArray) {
	              keySeq = keySeq.filter(function (name) {
	                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
	              });
	            }
	            return fromJS(keySeq.reduce(function (acc, key) {
	              acc.push(key);
	              return acc;
	            }, list));
	          }
	        }, {
	          key: 'getValidators',
	          value: function getValidators() {
	            var _this4 = this;
	
	            var validators = {};
	            Object.keys(this.fieldValidators).forEach(function (name) {
	              var validator = _this4.fieldValidators[name]();
	              if (validator) {
	                validators[name] = validator;
	              }
	            });
	            return validators;
	          }
	        }, {
	          key: 'generateValidator',
	          value: function generateValidator() {
	            var validators = this.getValidators();
	            return Object.keys(validators).length ? (0, _generateValidator3.default)(validators, structure) : undefined;
	          }
	        }, {
	          key: 'getWarners',
	          value: function getWarners() {
	            var _this5 = this;
	
	            var warners = {};
	            Object.keys(this.fieldWarners).forEach(function (name) {
	              var warner = _this5.fieldWarners[name]();
	              if (warner) {
	                warners[name] = warner;
	              }
	            });
	            return warners;
	          }
	        }, {
	          key: 'generateWarner',
	          value: function generateWarner() {
	            var warners = this.getWarners();
	            return Object.keys(warners).length ? (0, _generateValidator3.default)(warners, structure) : undefined;
	          }
	        }, {
	          key: 'asyncValidate',
	          value: function asyncValidate(name, value) {
	            var _this6 = this;
	
	            var _props7 = this.props,
	                asyncBlurFields = _props7.asyncBlurFields,
	                asyncErrors = _props7.asyncErrors,
	                asyncValidate = _props7.asyncValidate,
	                dispatch = _props7.dispatch,
	                initialized = _props7.initialized,
	                pristine = _props7.pristine,
	                shouldAsyncValidate = _props7.shouldAsyncValidate,
	                startAsyncValidation = _props7.startAsyncValidation,
	                stopAsyncValidation = _props7.stopAsyncValidation,
	                syncErrors = _props7.syncErrors,
	                values = _props7.values;
	
	            var submitting = !name;
	            if (asyncValidate) {
	              var valuesToValidate = submitting ? values : setIn(values, name, value);
	              var syncValidationPasses = submitting || !getIn(syncErrors, name);
	              var isBlurredField = !submitting && (!asyncBlurFields || ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]')));
	              if ((isBlurredField || submitting) && shouldAsyncValidate({
	                asyncErrors: asyncErrors,
	                initialized: initialized,
	                trigger: submitting ? 'submit' : 'blur',
	                blurredField: name,
	                pristine: pristine,
	                syncValidationPasses: syncValidationPasses
	              })) {
	                return (0, _asyncValidation2.default)(function () {
	                  return asyncValidate(valuesToValidate, dispatch, _this6.props, name);
	                }, startAsyncValidation, stopAsyncValidation, name);
	              }
	            }
	          }
	        }, {
	          key: 'submitCompleted',
	          value: function submitCompleted(result) {
	            delete this.submitPromise;
	            return result;
	          }
	        }, {
	          key: 'submitFailed',
	          value: function submitFailed(error) {
	            delete this.submitPromise;
	            throw error;
	          }
	        }, {
	          key: 'listenToSubmit',
	          value: function listenToSubmit(promise) {
	            if (!(0, _isPromise2.default)(promise)) {
	              return promise;
	            }
	            this.submitPromise = promise;
	            return promise.then(this.submitCompleted, this.submitFailed);
	          }
	        }, {
	          key: 'submit',
	          value: function submit(submitOrEvent) {
	            var _this7 = this;
	
	            var _props8 = this.props,
	                onSubmit = _props8.onSubmit,
	                blur = _props8.blur,
	                change = _props8.change,
	                dispatch = _props8.dispatch,
	                validExceptSubmit = _props8.validExceptSubmit;
	
	
	            if (!submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent)) {
	              // submitOrEvent is an event: fire submit if not already submitting
	              if (!this.submitPromise) {
	                if (this.innerOnSubmit) {
	                  // will call "submitOrEvent is the submit function" block below
	                  return this.innerOnSubmit();
	                } else {
	                  return this.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(onSubmit), _extends({}, this.props, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch)), validExceptSubmit, this.asyncValidate, this.getFieldList({ excludeFieldArray: true })));
	                }
	              }
	            } else {
	              // submitOrEvent is the submit function: return deferred submit thunk
	              return (0, _silenceEvents2.default)(function () {
	                return !_this7.submitPromise && _this7.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(submitOrEvent), _extends({}, _this7.props, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch)), validExceptSubmit, _this7.asyncValidate, _this7.getFieldList({ excludeFieldArray: true })));
	              });
	            }
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            this.props.reset();
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            // remove some redux-form config-only props
	            /* eslint-disable no-unused-vars */
	            var _props9 = this.props,
	                anyTouched = _props9.anyTouched,
	                arrayInsert = _props9.arrayInsert,
	                arrayMove = _props9.arrayMove,
	                arrayPop = _props9.arrayPop,
	                arrayPush = _props9.arrayPush,
	                arrayRemove = _props9.arrayRemove,
	                arrayRemoveAll = _props9.arrayRemoveAll,
	                arrayShift = _props9.arrayShift,
	                arraySplice = _props9.arraySplice,
	                arraySwap = _props9.arraySwap,
	                arrayUnshift = _props9.arrayUnshift,
	                asyncErrors = _props9.asyncErrors,
	                asyncValidate = _props9.asyncValidate,
	                asyncValidating = _props9.asyncValidating,
	                blur = _props9.blur,
	                change = _props9.change,
	                destroy = _props9.destroy,
	                destroyOnUnmount = _props9.destroyOnUnmount,
	                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
	                dirty = _props9.dirty,
	                dispatch = _props9.dispatch,
	                enableReinitialize = _props9.enableReinitialize,
	                error = _props9.error,
	                focus = _props9.focus,
	                form = _props9.form,
	                getFormState = _props9.getFormState,
	                initialize = _props9.initialize,
	                initialized = _props9.initialized,
	                initialValues = _props9.initialValues,
	                invalid = _props9.invalid,
	                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
	                pristine = _props9.pristine,
	                propNamespace = _props9.propNamespace,
	                registeredFields = _props9.registeredFields,
	                registerField = _props9.registerField,
	                reset = _props9.reset,
	                setSubmitFailed = _props9.setSubmitFailed,
	                setSubmitSucceeded = _props9.setSubmitSucceeded,
	                shouldAsyncValidate = _props9.shouldAsyncValidate,
	                shouldValidate = _props9.shouldValidate,
	                startAsyncValidation = _props9.startAsyncValidation,
	                startSubmit = _props9.startSubmit,
	                stopAsyncValidation = _props9.stopAsyncValidation,
	                stopSubmit = _props9.stopSubmit,
	                submitting = _props9.submitting,
	                submitFailed = _props9.submitFailed,
	                submitSucceeded = _props9.submitSucceeded,
	                touch = _props9.touch,
	                touchOnBlur = _props9.touchOnBlur,
	                touchOnChange = _props9.touchOnChange,
	                persistentSubmitErrors = _props9.persistentSubmitErrors,
	                syncErrors = _props9.syncErrors,
	                syncWarnings = _props9.syncWarnings,
	                unregisterField = _props9.unregisterField,
	                untouch = _props9.untouch,
	                updateSyncErrors = _props9.updateSyncErrors,
	                updateSyncWarnings = _props9.updateSyncWarnings,
	                valid = _props9.valid,
	                validExceptSubmit = _props9.validExceptSubmit,
	                values = _props9.values,
	                warning = _props9.warning,
	                rest = _objectWithoutProperties(_props9, ['anyTouched', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
	            /* eslint-enable no-unused-vars */
	
	
	            var reduxFormProps = _extends({
	              anyTouched: anyTouched,
	              asyncValidate: this.asyncValidate,
	              asyncValidating: asyncValidating
	            }, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch), {
	              destroy: destroy,
	              dirty: dirty,
	              dispatch: dispatch,
	              error: error,
	              form: form,
	              handleSubmit: this.submit,
	              initialize: initialize,
	              initialized: initialized,
	              initialValues: initialValues,
	              invalid: invalid,
	              pristine: pristine,
	              reset: reset,
	              submitting: submitting,
	              submitFailed: submitFailed,
	              submitSucceeded: submitSucceeded,
	              touch: touch,
	              untouch: untouch,
	              valid: valid,
	              warning: warning
	            });
	            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
	            if (isClassComponent(WrappedComponent)) {
	              propsToPass.ref = 'wrapped';
	            }
	            return (0, _react.createElement)(WrappedComponent, propsToPass);
	          }
	        }]);
	
	        return Form;
	      }(_react.Component);
	
	      Form.displayName = 'Form(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	      Form.WrappedComponent = WrappedComponent;
	      Form.childContextTypes = {
	        _reduxForm: _react.PropTypes.object.isRequired
	      };
	      Form.propTypes = {
	        destroyOnUnmount: _react.PropTypes.bool,
	        forceUnregisterOnUnmount: _react.PropTypes.bool,
	        form: _react.PropTypes.string.isRequired,
	        initialValues: _react.PropTypes.object,
	        getFormState: _react.PropTypes.func,
	        onSubmitFail: _react.PropTypes.func,
	        onSubmitSuccess: _react.PropTypes.func,
	        propNameSpace: _react.PropTypes.string,
	        validate: _react.PropTypes.func,
	        warn: _react.PropTypes.func,
	        touchOnBlur: _react.PropTypes.bool,
	        touchOnChange: _react.PropTypes.bool,
	        triggerSubmit: _react.PropTypes.bool,
	        persistentSubmitErrors: _react.PropTypes.bool,
	        registeredFields: _react.PropTypes.any
	      };
	
	      var connector = (0, _reactRedux.connect)(function (state, props) {
	        var form = props.form,
	            getFormState = props.getFormState,
	            initialValues = props.initialValues,
	            enableReinitialize = props.enableReinitialize,
	            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
	
	        var formState = getIn(getFormState(state) || empty, form) || empty;
	        var stateInitial = getIn(formState, 'initial');
	        var initialized = !!stateInitial;
	
	        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
	        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
	
	        var initial = initialValues || stateInitial || empty;
	
	        if (shouldUpdateInitialValues) {
	          initial = stateInitial || empty;
	        }
	
	        var values = getIn(formState, 'values') || initial;
	
	        if (shouldResetValues) {
	          values = initial;
	        }
	
	        var pristine = shouldResetValues || deepEqual(initial, values);
	        var asyncErrors = getIn(formState, 'asyncErrors');
	        var syncErrors = getIn(formState, 'syncErrors') || {};
	        var syncWarnings = getIn(formState, 'syncWarnings') || {};
	        var registeredFields = getIn(formState, 'registeredFields');
	        var valid = isValid(form, getFormState, false)(state);
	        var validExceptSubmit = isValid(form, getFormState, true)(state);
	        var anyTouched = !!getIn(formState, 'anyTouched');
	        var submitting = !!getIn(formState, 'submitting');
	        var submitFailed = !!getIn(formState, 'submitFailed');
	        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
	        var error = getIn(formState, 'error');
	        var warning = getIn(formState, 'warning');
	        var triggerSubmit = getIn(formState, 'triggerSubmit');
	        return {
	          anyTouched: anyTouched,
	          asyncErrors: asyncErrors,
	          asyncValidating: getIn(formState, 'asyncValidating') || false,
	          dirty: !pristine,
	          error: error,
	          initialized: initialized,
	          invalid: !valid,
	          pristine: pristine,
	          registeredFields: registeredFields,
	          submitting: submitting,
	          submitFailed: submitFailed,
	          submitSucceeded: submitSucceeded,
	          syncErrors: syncErrors,
	          syncWarnings: syncWarnings,
	          triggerSubmit: triggerSubmit,
	          values: values,
	          valid: valid,
	          validExceptSubmit: validExceptSubmit,
	          warning: warning
	        };
	      }, function (dispatch, initialProps) {
	        var bindForm = function bindForm(actionCreator) {
	          return actionCreator.bind(null, initialProps.form);
	        };
	
	        // Bind the first parameter on `props.form`
	        var boundFormACs = (0, _mapValues3.default)(formActions, bindForm);
	        var boundArrayACs = (0, _mapValues3.default)(arrayActions, bindForm);
	        var boundBlur = function boundBlur(field, value) {
	          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
	        };
	        var boundChange = function boundChange(field, value) {
	          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
	        };
	        var boundFocus = bindForm(focus);
	
	        // Wrap action creators with `dispatch`
	        var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
	        var connectedArrayACs = {
	          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
	          move: (0, _redux.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
	          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
	          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
	          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
	          removeAll: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
	          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
	          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
	          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
	          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
	        };
	
	        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
	          blur: boundBlur,
	          change: boundChange,
	          array: connectedArrayACs,
	          focus: boundFocus,
	          dispatch: dispatch
	        });
	
	        return function () {
	          return computedActions;
	        };
	      }, undefined, { withRef: true });
	      var ConnectedForm = (0, _hoistNonReactStatics2.default)(connector(Form), WrappedComponent);
	      ConnectedForm.defaultProps = config;
	
	      // build outer component to expose instance api
	      return function (_Component2) {
	        _inherits(ReduxForm, _Component2);
	
	        function ReduxForm() {
	          _classCallCheck(this, ReduxForm);
	
	          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
	        }
	
	        _createClass(ReduxForm, [{
	          key: 'submit',
	          value: function submit() {
	            return this.refs.wrapped.getWrappedInstance().submit();
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            return this.refs.wrapped.getWrappedInstance().reset();
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            var _props10 = this.props,
	                initialValues = _props10.initialValues,
	                rest = _objectWithoutProperties(_props10, ['initialValues']);
	
	            return (0, _react.createElement)(ConnectedForm, _extends({}, rest, {
	              ref: 'wrapped',
	              // convert initialValues if need to
	              initialValues: fromJS(initialValues)
	            }));
	          }
	        }, {
	          key: 'valid',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().isValid();
	          }
	        }, {
	          key: 'invalid',
	          get: function get() {
	            return !this.valid;
	          }
	        }, {
	          key: 'pristine',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().isPristine();
	          }
	        }, {
	          key: 'dirty',
	          get: function get() {
	            return !this.pristine;
	          }
	        }, {
	          key: 'values',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().getValues();
	          }
	        }, {
	          key: 'fieldList',
	          get: function get() {
	            // mainly provided for testing
	            return this.refs.wrapped.getWrappedInstance().getFieldList();
	          }
	        }, {
	          key: 'wrappedInstance',
	          get: function get() {
	            // for testine
	            return this.refs.wrapped.getWrappedInstance().refs.wrapped;
	          }
	        }]);
	
	        return ReduxForm;
	      }(_react.Component);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ },
/* 3659 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.asyncErrors');
	    };
	  };
	};
	
	exports.default = createGetFormAsyncErrors;

/***/ },
/* 3660 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.initial');
	    };
	  };
	};
	
	exports.default = createGetFormInitialValues;

/***/ },
/* 3661 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormNames = function createGetFormNames(_ref) {
	  var getIn = _ref.getIn,
	      keys = _ref.keys;
	  return function () {
	    var getFormState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return keys(getFormState(state));
	    };
	  };
	};
	
	exports.default = createGetFormNames;

/***/ },
/* 3662 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.submitErrors');
	    };
	  };
	};
	
	exports.default = createGetFormSubmitErrors;

/***/ },
/* 3663 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.syncErrors');
	    };
	  };
	};
	
	exports.default = createGetFormSyncErrors;

/***/ },
/* 3664 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.syncWarnings');
	    };
	  };
	};
	
	exports.default = createGetFormSyncWarnings;

/***/ },
/* 3665 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormValues = function createGetFormValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.values');
	    };
	  };
	};
	
	exports.default = createGetFormValues;

/***/ },
/* 3666 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      return getIn(formState, form + '.submitFailed') || false;
	    };
	  };
	};
	
	exports.default = createHasSubmitFailed;

/***/ },
/* 3667 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      return getIn(formState, form + '.submitSucceeded') || false;
	    };
	  };
	};
	
	exports.default = createHasSubmitSucceeded;

/***/ },
/* 3668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPristine = __webpack_require__(1596);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsDirty = function createIsDirty(structure) {
	  return function (form, getFormState) {
	    var isPristine = (0, _isPristine2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isPristine(state);
	    };
	  };
	};
	
	exports.default = createIsDirty;

/***/ },
/* 3669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isValid = __webpack_require__(752);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsInvalid = function createIsInvalid(structure) {
	  return function (form, getFormState) {
	    var isValid = (0, _isValid2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isValid(state);
	    };
	  };
	};
	
	exports.default = createIsInvalid;

/***/ },
/* 3670 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsSubmitting = function createIsSubmitting(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      return getIn(formState, form + '.submitting') || false;
	    };
	  };
	};
	
	exports.default = createIsSubmitting;

/***/ },
/* 3671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(764);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	var _immutable = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(obj, other) {
	  if (obj == other) return true; // eslint-disable-line eqeqeq
	  if ((obj == null || obj === '' || obj === false) && (other == null || other === '' || other === false)) return true;
	
	  if (_immutable.Iterable.isIterable(obj) && _immutable.Iterable.isIterable(other)) {
	    return obj.count() === other.count() && obj.every(function (value, key) {
	      return (0, _isEqualWith3.default)(value, other.get(key), customizer);
	    });
	  }
	
	  return void 0;
	};
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith3.default)(a, b, customizer);
	};
	
	exports.default = deepEqual;

/***/ },
/* 3672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(267);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _immutable = __webpack_require__(34);
	
	var _deepEqual = __webpack_require__(3671);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _keys = __webpack_require__(3673);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _setIn = __webpack_require__(3674);
	
	var _setIn2 = _interopRequireDefault(_setIn);
	
	var _splice = __webpack_require__(3675);
	
	var _splice2 = _interopRequireDefault(_splice);
	
	var _getIn = __webpack_require__(1597);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyList = (0, _immutable.List)();
	
	var structure = {
	  empty: (0, _immutable.Map)(),
	  emptyList: emptyList,
	  getIn: function getIn(state, field) {
	    return _immutable.Iterable.isIterable(state) ? state.getIn((0, _toPath3.default)(field)) : (0, _getIn2.default)(state, field);
	  },
	  setIn: _setIn2.default,
	  deepEqual: _deepEqual2.default,
	  deleteIn: function deleteIn(state, field) {
	    return state.deleteIn((0, _toPath3.default)(field));
	  },
	  fromJS: function fromJS(jsValue) {
	    return (0, _immutable.fromJS)(jsValue, function (key, value) {
	      return _immutable.Iterable.isIndexed(value) ? value.toList() : value.toMap();
	    });
	  },
	  keys: _keys2.default,
	  size: function size(list) {
	    return list ? list.size : 0;
	  },
	  splice: _splice2.default,
	  toJS: function toJS(value) {
	    return _immutable.Iterable.isIterable(value) ? value.toJS() : value;
	  }
	};
	
	exports.default = structure;

/***/ },
/* 3673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	var empty = (0, _immutable.List)();
	
	var keys = function keys(value) {
	  return _immutable.Iterable.isIterable(value) ? value.keySeq() : empty;
	};
	
	exports.default = keys;

/***/ },
/* 3674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(267);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	exports.default = setIn;
	
	var _immutable = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrayPattern = /\[(\d+)\]/;
	
	var undefinedArrayMerge = function undefinedArrayMerge(previous, next) {
	  return next !== undefined ? next : previous;
	};
	
	var mergeLists = function mergeLists(original, value) {
	  return original && _immutable.List.isList(original) ? original.mergeDeepWith(undefinedArrayMerge, value) : value;
	};
	
	/*
	 * ImmutableJS' setIn function doesn't support array (List) creation
	 * so we must pre-insert all arrays in the path ahead of time.
	 * 
	 * Additionally we must also pre-set a dummy Map at the location
	 * of an array index if there's parts that come afterwards because 
	 * the setIn function uses `{}` to mark an unset value instead of 
	 * undefined (which is the case for list / arrays).
	 */
	function setIn(state, field, value) {
	  var path = (0, _toPath3.default)(field);
	  if (!field || typeof field !== 'string' || !arrayPattern.test(field)) {
	    return state.setIn(path, value);
	  }
	
	  return state.withMutations(function (mutable) {
	    var _loop = function _loop(pathIndex) {
	      var nextPart = path[pathIndex + 1];
	      if (isNaN(nextPart)) {
	        return 'continue';
	      }
	
	      var arr = [];
	      arr[nextPart] = new _immutable.Map();
	      mutable = mutable.updateIn(path.slice(0, pathIndex + 1), function (value) {
	        return mergeLists(value, new _immutable.List(arr));
	      });
	    };
	
	    for (var pathIndex = 0; pathIndex < path.length - 1; ++pathIndex) {
	      var _ret = _loop(pathIndex);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return mutable.setIn(path, value);
	  });
	}

/***/ },
/* 3675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(34);
	
	exports.default = function (list, index, removeNum, value) {
	  list = _immutable.List.isList(list) ? list : (0, _immutable.List)();
	
	  if (index < list.count()) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      // first insert null and then re-set it to undefined
	      return list.splice(index, 0, null).set(index, undefined);
	    }
	    if (value != null) {
	      return list.splice(index, removeNum, value); // removing and adding
	    } else {
	      return list.splice(index, removeNum); // removing
	    }
	  }
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return list;
	  }
	  // trying to add outside of range: just set value
	  return list.set(index, value);
	};

/***/ },
/* 3676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(764);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(obj, other) {
	  if (obj === other) return true;
	  if ((obj == null || obj === '' || obj === false) && (other == null || other === '' || other === false)) return true;
	
	  if (obj && other && obj._error !== other._error) return false;
	  if (obj && other && obj._warning !== other._warning) return false;
	};
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith3.default)(a, b, customizer);
	};
	
	exports.default = deepEqual;

/***/ },
/* 3677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(267);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var deleteInWithPath = function deleteInWithPath(state, first) {
	  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (state === undefined || first === undefined) {
	    return state;
	  }
	  if (rest.length) {
	    if (Array.isArray(state)) {
	      if (first < state.length) {
	        var result = deleteInWithPath.apply(undefined, [state && state[first]].concat(rest));
	        if (result !== state[first]) {
	          var copy = [].concat(_toConsumableArray(state));
	          copy[first] = result;
	          return copy;
	        }
	      }
	      return state;
	    }
	    if (first in state) {
	      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(rest));
	      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
	    }
	    return state;
	  }
	  if (Array.isArray(state)) {
	    if (isNaN(first)) {
	      throw new Error('Cannot delete non-numerical index from an array');
	    }
	    if (first < state.length) {
	      var _copy = [].concat(_toConsumableArray(state));
	      _copy.splice(first, 1);
	      return _copy;
	    }
	    return state;
	  }
	  if (first in state) {
	    var _copy2 = _extends({}, state);
	    delete _copy2[first];
	    return _copy2;
	  }
	  return state;
	};
	
	var deleteIn = function deleteIn(state, field) {
	  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray((0, _toPath3.default)(field))));
	};
	
	exports.default = deleteIn;

/***/ },
/* 3678 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var keys = function keys(value) {
	  return value ? Object.keys(value) : [];
	};
	
	exports.default = keys;

/***/ },
/* 3679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(267);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
	  if (pathIndex >= path.length) {
	    return value;
	  }
	
	  var first = path[pathIndex];
	  var next = setInWithPath(state && state[first], value, path, pathIndex + 1);
	
	  if (!state) {
	    var initialized = isNaN(first) ? {} : [];
	    initialized[first] = next;
	    return initialized;
	  }
	
	  if (Array.isArray(state)) {
	    var copy = [].concat(state);
	    copy[first] = next;
	    return copy;
	  }
	
	  return _extends({}, state, _defineProperty({}, first, next));
	};
	
	var setIn = function setIn(state, field, value) {
	  return setInWithPath(state, value, (0, _toPath3.default)(field), 0);
	};
	
	exports.default = setIn;

/***/ },
/* 3680 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var splice = function splice(array, index, removeNum, value) {
	  array = array || [];
	
	  if (index < array.length) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      var _copy2 = [].concat(_toConsumableArray(array));
	      _copy2.splice(index, 0, null);
	      _copy2[index] = undefined;
	      return _copy2;
	    }
	    if (value != null) {
	      var _copy3 = [].concat(_toConsumableArray(array));
	      _copy3.splice(index, removeNum, value); // removing and adding
	      return _copy3;
	    }
	    var _copy = [].concat(_toConsumableArray(array));
	    _copy.splice(index, removeNum); // removing
	    return _copy;
	  }
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return array;
	  }
	  // trying to add outside of range: just set value
	  var copy = [].concat(_toConsumableArray(array));
	  copy[index] = value;
	  return copy;
	};
	
	exports.default = splice;

/***/ },
/* 3681 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var dataKey = exports.dataKey = 'text';

/***/ },
/* 3682 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDisplayName = function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ },
/* 3683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(28);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var createValues = function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (config) {
	    var _prop$getFormState$co = _extends({
	      prop: 'values',
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, config),
	        form = _prop$getFormState$co.form,
	        prop = _prop$getFormState$co.prop,
	        getFormState = _prop$getFormState$co.getFormState;
	
	    return (0, _reactRedux.connect)(function (state) {
	      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
	    }, function () {
	      return {};
	    } // ignore dispatch
	    );
	  };
	};
	
	exports.default = createValues;

/***/ },
/* 3684 */
[4186, 218, 138],
/* 3685 */
[4187, 3735, 3736, 3737, 3738, 3739],
/* 3686 */
[4193, 218, 138],
/* 3687 */
[4194, 218, 138],
/* 3688 */
[4195, 755, 3761, 3762],
/* 3689 */
[4199, 218, 138],
/* 3690 */
383,
/* 3691 */
977,
/* 3692 */
608,
/* 3693 */
980,
/* 3694 */
[4203, 480, 331],
/* 3695 */
[4210, 184],
/* 3696 */
[4218, 1602, 768],
/* 3697 */
[4220, 3692, 139],
/* 3698 */
2618,
/* 3699 */
[4225, 266, 219],
/* 3700 */
[4227, 756, 1607, 3726, 3727, 3732, 139, 763, 767],
/* 3701 */
[4229, 756, 757],
/* 3702 */
[4230, 765, 3743, 184, 1615],
/* 3703 */
[4232, 266, 766, 219],
/* 3704 */
[4233, 3707, 3708, 761, 139, 3778],
/* 3705 */
[4234, 760, 3756],
/* 3706 */
[4235, 184, 760, 3757],
/* 3707 */
[4237, 3701, 3729, 1611],
/* 3708 */
[4238, 757, 3772, 3773, 759, 1610, 1611, 330],
/* 3709 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(756),
	    assignMergeValue = __webpack_require__(1601),
	    baseFor = __webpack_require__(1602),
	    baseMergeDeep = __webpack_require__(3710),
	    isObject = __webpack_require__(184),
	    keysIn = __webpack_require__(1616),
	    safeGet = __webpack_require__(1613);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 3710 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(1601),
	    cloneBuffer = __webpack_require__(3720),
	    cloneTypedArray = __webpack_require__(3721),
	    copyArray = __webpack_require__(1605),
	    initCloneObject = __webpack_require__(3740),
	    isArguments = __webpack_require__(762),
	    isArray = __webpack_require__(139),
	    isArrayLikeObject = __webpack_require__(3774),
	    isBuffer = __webpack_require__(763),
	    isFunction = __webpack_require__(765),
	    isObject = __webpack_require__(184),
	    isPlainObject = __webpack_require__(3775),
	    isTypedArray = __webpack_require__(767),
	    safeGet = __webpack_require__(1613),
	    toPlainObject = __webpack_require__(3781);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 3711 */
990,
/* 3712 */
[4242, 1603],
/* 3713 */
[4243, 761, 3760, 3764],
/* 3714 */
[4246, 3771, 1606, 761],
/* 3715 */
993,
/* 3716 */
[4248, 478, 1600, 139, 484],
/* 3717 */
245,
/* 3718 */
392,
/* 3719 */
[4257, 1598],
/* 3720 */
[4258, 138],
/* 3721 */
[4261, 3719],
/* 3722 */
[4264, 3694, 480],
/* 3723 */
[4267, 138],
/* 3724 */
[4269, 3713, 3741],
/* 3725 */
2660,
/* 3726 */
[4287, 478, 1598, 331, 1607, 3754, 3763],
/* 3727 */
[4288, 3728],
/* 3728 */
[4290, 3697, 3731, 768],
/* 3729 */
[4295, 1610, 768],
/* 3730 */
[4298, 478],
/* 3731 */
[4299, 3691, 3779],
/* 3732 */
[4301, 3684, 754, 3686, 3687, 3689, 266, 1615],
/* 3733 */
2675,
/* 3734 */
[4302, 1604, 762, 139, 758, 766, 330],
/* 3735 */
[4303, 482],
/* 3736 */
2679,
/* 3737 */
[4304, 482],
/* 3738 */
[4305, 482],
/* 3739 */
[4306, 482],
/* 3740 */
[4308, 3695, 1609, 760],
/* 3741 */
[4310, 331, 483, 758, 184],
/* 3742 */
2688,
/* 3743 */
[4313, 3723],
/* 3744 */
2690,
/* 3745 */
[4315, 479],
/* 3746 */
[4316, 479],
/* 3747 */
[4317, 479],
/* 3748 */
[4318, 479],
/* 3749 */
[4319, 3685, 477, 754],
/* 3750 */
[4320, 481],
/* 3751 */
[4321, 481],
/* 3752 */
[4322, 481],
/* 3753 */
[4323, 481],
/* 3754 */
2700,
/* 3755 */
[4324, 3776],
/* 3756 */
[4328, 1612],
/* 3757 */
2704,
/* 3758 */
[4329, 1608],
/* 3759 */
2705,
/* 3760 */
[4330, 3690],
/* 3761 */
2709,
/* 3762 */
2710,
/* 3763 */
621,
/* 3764 */
[4335, 3714, 3765],
/* 3765 */
1017,
/* 3766 */
[4337, 477],
/* 3767 */
2712,
/* 3768 */
2713,
/* 3769 */
2714,
/* 3770 */
[4338, 477, 754, 755],
/* 3771 */
2727,
/* 3772 */
[4387, 1603],
/* 3773 */
[4389, 3698, 3734],
/* 3774 */
[4396, 483, 219],
/* 3775 */
[4405, 266, 1609, 219],
/* 3776 */
[4417, 755],
/* 3777 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(3709),
	    createAssigner = __webpack_require__(3724);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 3778 */
[4421, 3711, 3712, 759, 330],
/* 3779 */
1038,
/* 3780 */
2777,
/* 3781 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(3722),
	    keysIn = __webpack_require__(1616);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 3782 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = asap;
	var queue = [];
	var isSuspended = false;
	
	function asap(task) {
	  if (!isSuspended) {
	    isSuspended = true;
	    queue.push(task);
	    asap.flush();
	  } else {
	    queue.push(task);
	  }
	}
	
	asap.suspend = function () {
	  return isSuspended = true;
	};
	asap.flush = function () {
	  var nextTask = void 0;
	  while (nextTask = queue.shift()) {
	    nextTask();
	  }
	  isSuspended = false;
	};

/***/ },
/* 3783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sagaMiddlewareFactory;
	
	var _utils = __webpack_require__(160);
	
	var _proc = __webpack_require__(1620);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	var _channel = __webpack_require__(486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sagaMiddlewareFactory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var runSagaDynamically = void 0;
	
	  if (_utils.is.func(options)) {
	    if (true) {
	      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
	    } else {
	      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
	    }
	  }
	
	  if (options.logger && !_utils.is.func(options.logger)) {
	    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
	  }
	
	  if (options.onerror && !_utils.is.func(options.onerror)) {
	    throw new Error('`options.onerror` passed to the Saga middleware is not a function!');
	  }
	
	  function sagaMiddleware(_ref) {
	    var getState = _ref.getState;
	    var dispatch = _ref.dispatch;
	
	    runSagaDynamically = runSaga;
	    var sagaEmitter = (0, _channel.emitter)();
	
	    function runSaga(saga) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return (0, _proc2.default)(saga.apply(undefined, args), sagaEmitter.subscribe, dispatch, getState, options, 0, saga.name);
	    }
	
	    return function (next) {
	      return function (action) {
	        var result = next(action); // hit reducers
	        sagaEmitter.emit(action);
	        return result;
	      };
	    };
	  }
	
	  sagaMiddleware.run = function (saga) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    (0, _utils.check)(runSagaDynamically, _utils.is.notUndef, 'Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
	    (0, _utils.check)(saga, _utils.is.func, 'sagaMiddleware.run(saga, ...args): saga argument must be a Generator function!');
	    return runSagaDynamically.apply(undefined, [saga].concat(args));
	  };
	
	  return sagaMiddleware;
	}

/***/ },
/* 3784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runSaga = runSaga;
	
	var _utils = __webpack_require__(160);
	
	var _proc = __webpack_require__(1620);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function runSaga(iterator, _ref) {
	  var subscribe = _ref.subscribe;
	  var dispatch = _ref.dispatch;
	  var getState = _ref.getState;
	  var sagaMonitor = _ref.sagaMonitor;
	  var logger = _ref.logger;
	
	
	  (0, _utils.check)(iterator, _utils.is.iterator, "runSaga must be called on an iterator");
	
	  return (0, _proc2.default)(iterator, subscribe, dispatch, getState, { sagaMonitor: sagaMonitor, logger: logger });
	}

/***/ },
/* 3785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	
	var _channel = __webpack_require__(486);
	
	var _utils = __webpack_require__(160);
	
	var _io = __webpack_require__(487);
	
	var _buffers = __webpack_require__(485);
	
	var done = { done: true, value: undefined };
	var qEnd = {};
	
	function fsmIterator(fsm, q0) {
	  var name = arguments.length <= 2 || arguments[2] === undefined ? 'iterator' : arguments[2];
	
	  var updateState = void 0,
	      qNext = q0;
	
	  function next(arg, error) {
	    if (qNext === qEnd) {
	      return done;
	    }
	
	    if (error) {
	      qNext = qEnd;
	      throw error;
	    } else {
	      updateState && updateState(arg);
	
	      var _fsm$qNext = fsm[qNext]();
	
	      var _fsm$qNext2 = _slicedToArray(_fsm$qNext, 3);
	
	      var q = _fsm$qNext2[0];
	      var output = _fsm$qNext2[1];
	      var _updateState = _fsm$qNext2[2];
	
	      qNext = q;
	      updateState = _updateState;
	      return qNext === qEnd ? done : output;
	    }
	  }
	
	  return (0, _utils.makeIterator)(next, function (error) {
	    return next(null, error);
	  }, name, true);
	}
	
	function safeName(pattern) {
	  if (Array.isArray(pattern)) {
	    return String(pattern.map(function (entry) {
	      return String(entry);
	    }));
	  } else {
	    return String(pattern);
	  }
	}
	
	function takeEvery(pattern, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(pattern) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	
	  var action = void 0,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [qEnd] : ['q1', yFork(action)];
	    }
	  }, 'q1', 'takeEvery(' + safeName(pattern) + ', ' + worker.name + ')');
	}
	
	function takeLatest(pattern, worker) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	    args[_key2 - 2] = arguments[_key2];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(pattern) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yCancel = function yCancel(task) {
	    return { done: false, value: (0, _io.cancel)(task) };
	  };
	
	  var task = void 0,
	      action = void 0;
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
	    },
	    q3: function q3() {
	      return ['q1', yFork(action), setTask];
	    }
	  }, 'q1', 'takeLatest(' + safeName(pattern) + ', ' + worker.name + ')');
	}
	
	function throttle(delayLength, pattern, worker) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	    args[_key3 - 3] = arguments[_key3];
	  }
	
	  var action = void 0,
	      channel = void 0;
	
	  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
	  var yTake = function yTake() {
	    return { done: false, value: (0, _io.take)(channel, pattern) };
	  };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	  var setChannel = function setChannel(ch) {
	    return channel = ch;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yActionChannel, setChannel];
	    },
	    q2: function q2() {
	      return ['q3', yTake(), setAction];
	    },
	    q3: function q3() {
	      return action === _channel.END ? [qEnd] : ['q4', yFork(action)];
	    },
	    q4: function q4() {
	      return ['q2', yDelay];
	    }
	  }, 'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
	}

/***/ },
/* 3786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(160);
	
	Object.defineProperty(exports, 'TASK', {
	  enumerable: true,
	  get: function get() {
	    return _utils.TASK;
	  }
	});
	Object.defineProperty(exports, 'noop', {
	  enumerable: true,
	  get: function get() {
	    return _utils.noop;
	  }
	});
	Object.defineProperty(exports, 'is', {
	  enumerable: true,
	  get: function get() {
	    return _utils.is;
	  }
	});
	Object.defineProperty(exports, 'deferred', {
	  enumerable: true,
	  get: function get() {
	    return _utils.deferred;
	  }
	});
	Object.defineProperty(exports, 'arrayOfDeffered', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayOfDeffered;
	  }
	});
	Object.defineProperty(exports, 'createMockTask', {
	  enumerable: true,
	  get: function get() {
	    return _utils.createMockTask;
	  }
	});
	
	var _io = __webpack_require__(487);
	
	Object.defineProperty(exports, 'asEffect', {
	  enumerable: true,
	  get: function get() {
	    return _io.asEffect;
	  }
	});

/***/ },
/* 3787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(1621);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 3788 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 3789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(1622);
	
	var _isPlainObject = __webpack_require__(679);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(1623);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 3790 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(3791);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ },
/* 3791 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ },
/* 3792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(200);
	var callBind = __webpack_require__(289);
	
	var implementation = __webpack_require__(1624);
	var getPolyfill = __webpack_require__(1625);
	var shim = __webpack_require__(3793);
	
	var flagsBound = callBind(implementation);
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 3793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(200).supportsDescriptors;
	var getPolyfill = __webpack_require__(1625);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 3794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _off = _interopRequireDefault(__webpack_require__(3796));
	
	var _on = _interopRequireDefault(__webpack_require__(3797));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(3798));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(3799));
	
	var _requestAnimationFrame = _interopRequireDefault(__webpack_require__(3800));
	
	var _invariant = _interopRequireDefault(__webpack_require__(59));
	
	var _utils = __webpack_require__(3795);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/* eslint-disable no-underscore-dangle */
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = /*#__PURE__*/function () {
	  function ScrollBehavior(_ref) {
	    var _this = this;
	
	    var addTransitionHook = _ref.addTransitionHook,
	        stateStorage = _ref.stateStorage,
	        getCurrentLocation = _ref.getCurrentLocation,
	        shouldUpdateScroll = _ref.shouldUpdateScroll;
	
	    this._restoreScrollRestoration = function () {
	      /* istanbul ignore if: not supported by any browsers on Travis */
	      if (_this._oldScrollRestoration) {
	        try {
	          window.history.scrollRestoration = _this._oldScrollRestoration;
	        } catch (e) {
	          /* silence */
	        }
	      }
	    };
	
	    this._onWindowScroll = function () {
	      if (_this._ignoreScrollEvents) {
	        // Don't save the scroll position until the transition is complete
	        return;
	      } // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	
	
	      if (!_this._saveWindowPositionHandle) {
	        _this._saveWindowPositionHandle = (0, _requestAnimationFrame["default"])(_this._saveWindowPosition);
	      }
	
	      if (_this._windowScrollTarget) {
	        var _this$_windowScrollTa = _this._windowScrollTarget,
	            xTarget = _this$_windowScrollTa[0],
	            yTarget = _this$_windowScrollTa[1];
	        var x = (0, _scrollLeft["default"])(window);
	        var y = (0, _scrollTop["default"])(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._windowScrollTarget = null;
	
	          _this._cancelCheckWindowScroll();
	        }
	      }
	    };
	
	    this._saveWindowPosition = function () {
	      _this._saveWindowPositionHandle = null;
	
	      _this._savePosition(null, window);
	    };
	
	    this._checkWindowScrollPosition = function () {
	      _this._checkWindowScrollHandle = null; // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	
	      /* istanbul ignore if: paranoid guard */
	
	      if (!_this._windowScrollTarget) {
	        return Promise.resolve();
	      }
	
	      _this.scrollToTarget(window, _this._windowScrollTarget);
	
	      ++_this._numWindowScrollAttempts;
	      /* istanbul ignore if: paranoid guard */
	
	      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        // This might happen if the scroll position was already set to the target
	        _this._windowScrollTarget = null;
	        return Promise.resolve();
	      }
	
	      return new Promise(function (resolve) {
	        _this._checkWindowScrollHandle = (0, _requestAnimationFrame["default"])(function () {
	          return resolve(_this._checkWindowScrollPosition());
	        });
	      });
	    };
	
	    this._stateStorage = stateStorage;
	    this._getCurrentLocation = getCurrentLocation;
	    this._shouldUpdateScroll = shouldUpdateScroll; // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	
	    /* istanbul ignore else: Travis browsers all support this */
	
	    if ('scrollRestoration' in window.history && // Unfortunately, Safari on iOS freezes for 2-6s after the user swipes to
	    // navigate through history with scrollRestoration being 'manual', so we
	    // need to detect this browser and exclude it from the following code
	    // until this bug is fixed by Apple.
	    !(0, _utils.isMobileSafari)()) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	
	      try {
	        window.history.scrollRestoration = 'manual'; // Scroll restoration persists across page reloads. We want to reset
	        // this to the original value, so that we can let the browser handle
	        // restoring the initial scroll position on server-rendered pages.
	
	        (0, _on["default"])(window, 'beforeunload', this._restoreScrollRestoration);
	      } catch (e) {
	        this._oldScrollRestoration = null;
	      }
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._saveWindowPositionHandle = null;
	    this._checkWindowScrollHandle = null;
	    this._windowScrollTarget = null;
	    this._numWindowScrollAttempts = 0;
	    this._ignoreScrollEvents = false;
	    this._scrollElements = {}; // We have to listen to each window scroll update rather than to just
	    // location updates, because some browsers will update scroll position
	    // before emitting the location change.
	
	    (0, _on["default"])(window, 'scroll', this._onWindowScroll);
	    this._removeTransitionHook = addTransitionHook(function () {
	      _requestAnimationFrame["default"].cancel(_this._saveWindowPositionHandle);
	
	      _this._saveWindowPositionHandle = null;
	      Object.keys(_this._scrollElements).forEach(function (key) {
	        var scrollElement = _this._scrollElements[key];
	
	        _requestAnimationFrame["default"].cancel(scrollElement.savePositionHandle);
	
	        scrollElement.savePositionHandle = null; // It's fine to save element scroll positions here, though; the browser
	        // won't modify them.
	
	        if (!_this._ignoreScrollEvents) {
	          _this._saveElementPosition(key);
	        }
	      });
	    });
	  }
	
	  var _proto = ScrollBehavior.prototype;
	
	  _proto.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
	    var _this2 = this;
	
	    !!this._scrollElements[key] ?  false ? (0, _invariant["default"])(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : invariant(false) : void 0;
	
	    var saveElementPosition = function saveElementPosition() {
	      _this2._saveElementPosition(key);
	    };
	
	    var scrollElement = {
	      element: element,
	      shouldUpdateScroll: shouldUpdateScroll,
	      savePositionHandle: null,
	      onScroll: function onScroll() {
	        if (!scrollElement.savePositionHandle && !_this2._ignoreScrollEvents) {
	          scrollElement.savePositionHandle = (0, _requestAnimationFrame["default"])(saveElementPosition);
	        }
	      }
	    }; // In case no scrolling occurs, save the initial position
	
	    if (!scrollElement.savePositionHandle && !this._ignoreScrollEvents) {
	      scrollElement.savePositionHandle = (0, _requestAnimationFrame["default"])(saveElementPosition);
	    }
	
	    this._scrollElements[key] = scrollElement;
	    (0, _on["default"])(element, 'scroll', scrollElement.onScroll);
	
	    this._updateElementScroll(key, null, context);
	  };
	
	  _proto.unregisterElement = function unregisterElement(key) {
	    !this._scrollElements[key] ?  false ? (0, _invariant["default"])(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : invariant(false) : void 0;
	    var _this$_scrollElements = this._scrollElements[key],
	        element = _this$_scrollElements.element,
	        onScroll = _this$_scrollElements.onScroll,
	        savePositionHandle = _this$_scrollElements.savePositionHandle;
	    (0, _off["default"])(element, 'scroll', onScroll);
	
	    _requestAnimationFrame["default"].cancel(savePositionHandle);
	
	    delete this._scrollElements[key];
	  };
	
	  _proto.updateScroll = function updateScroll(prevContext, context) {
	    var _this3 = this;
	
	    this._updateWindowScroll(prevContext, context).then(function () {
	      // Save the position immediately after a transition so that if no
	      // scrolling occurs, there is still a saved position
	      if (!_this3._saveWindowPositionHandle) {
	        _this3._saveWindowPositionHandle = (0, _requestAnimationFrame["default"])(_this3._saveWindowPosition);
	      }
	    });
	
	    Object.keys(this._scrollElements).forEach(function (key) {
	      _this3._updateElementScroll(key, prevContext, context);
	    });
	  };
	
	  _proto.stop = function stop() {
	    this._restoreScrollRestoration();
	
	    (0, _off["default"])(window, 'scroll', this._onWindowScroll);
	
	    this._cancelCheckWindowScroll();
	
	    this._removeTransitionHook();
	  };
	
	  _proto.startIgnoringScrollEvents = function startIgnoringScrollEvents() {
	    this._ignoreScrollEvents = true;
	  };
	
	  _proto.stopIgnoringScrollEvents = function stopIgnoringScrollEvents() {
	    this._ignoreScrollEvents = false;
	  };
	
	  _proto._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
	    _requestAnimationFrame["default"].cancel(this._checkWindowScrollHandle);
	
	    this._checkWindowScrollHandle = null;
	  };
	
	  _proto._saveElementPosition = function _saveElementPosition(key) {
	    var scrollElement = this._scrollElements[key];
	    scrollElement.savePositionHandle = null;
	
	    this._savePosition(key, scrollElement.element);
	  };
	
	  _proto._savePosition = function _savePosition(key, element) {
	    this._stateStorage.save(this._getCurrentLocation(), key, [(0, _scrollLeft["default"])(element), (0, _scrollTop["default"])(element)]);
	  };
	
	  _proto._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckWindowScroll();
	
	    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context); // Updating the window scroll position is really flaky. Just trying to
	    // scroll it isn't enough. Instead, try to scroll a few times until it
	    // works.
	
	    this._numWindowScrollAttempts = 0;
	    return this._checkWindowScrollPosition();
	  };
	
	  _proto._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
	    var _this$_scrollElements2 = this._scrollElements[key],
	        element = _this$_scrollElements2.element,
	        shouldUpdateScroll = _this$_scrollElements2.shouldUpdateScroll;
	
	    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
	
	    if (!scrollTarget) {
	      return;
	    } // Unlike with the window, there shouldn't be any flakiness to deal with
	    // here.
	
	
	    this.scrollToTarget(element, scrollTarget);
	  };
	
	  _proto._getDefaultScrollTarget = function _getDefaultScrollTarget(location) {
	    var hash = location.hash;
	
	    if (hash && hash !== '#') {
	      return hash.charAt(0) === '#' ? hash.slice(1) : hash;
	    }
	
	    return [0, 0];
	  };
	
	  _proto._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
	    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;
	
	    if (!scrollTarget || Array.isArray(scrollTarget) || typeof scrollTarget === 'string') {
	      return scrollTarget;
	    }
	
	    var location = this._getCurrentLocation();
	
	    return this._getSavedScrollTarget(key, location) || this._getDefaultScrollTarget(location);
	  };
	
	  _proto._getSavedScrollTarget = function _getSavedScrollTarget(key, location) {
	    if (location.action === 'PUSH') {
	      return null;
	    }
	
	    return this._stateStorage.read(location, key);
	  };
	
	  _proto.scrollToTarget = function scrollToTarget(element, target) {
	    if (typeof target === 'string') {
	      var targetElement = document.getElementById(target) || document.getElementsByName(target)[0];
	
	      if (targetElement) {
	        targetElement.scrollIntoView();
	        return;
	      } // Fallback to scrolling to top when target fragment doesn't exist.
	
	
	      target = [0, 0]; // eslint-disable-line no-param-reassign
	    }
	
	    var _target = target,
	        left = _target[0],
	        top = _target[1];
	    (0, _scrollLeft["default"])(element, left);
	    (0, _scrollTop["default"])(element, top);
	  };
	
	  return ScrollBehavior;
	}();
	
	exports["default"] = ScrollBehavior;
	module.exports = exports.default;

/***/ },
/* 3795 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isMobileSafari = isMobileSafari;
	
	function isMobileSafari() {
	  return /iPad|iPhone|iPod/.test(window.navigator.platform) && /^((?!CriOS).)*Safari/.test(window.navigator.userAgent);
	}

/***/ },
/* 3796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(273);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(769));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 3797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(273);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(769));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 3798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(273);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(1627));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 3799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(273);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(1627));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 3800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(273);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(769));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 3801 */
[4455, 187, 48, 12, 11, 490, 1686],
/* 3802 */
[4456, 3801],
/* 3803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(76);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A component that allows you to render children outside their parent.
	 * @see Modal
	 * @see Popup
	 * @see Dimmer
	 * @see Confirm
	 */
	var Portal = function (_Component) {
	  (0, _inherits3.default)(Portal, _Component);
	
	  function Portal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.handleDocumentClick = function (e) {
	      var _this$props = _this.props,
	          closeOnDocumentClick = _this$props.closeOnDocumentClick,
	          closeOnRootNodeClick = _this$props.closeOnRootNodeClick;
	
	
	      if (!_this.rootNode // not mounted
	      || !_this.portalNode // no portal
	      || (0, _invoke3.default)(_this, 'triggerNode.contains', e.target) // event happened in trigger (delegate to trigger handlers)
	      || (0, _invoke3.default)(_this, 'portalNode.contains', e.target) // event happened in the portal
	      ) return; // ignore the click
	
	      var didClickInRootNode = _this.rootNode.contains(e.target);
	
	      if (closeOnDocumentClick && !didClickInRootNode || closeOnRootNodeClick && didClickInRootNode) {
	
	        _this.close(e);
	      }
	    }, _this.handleEscape = function (e) {
	      if (!_this.props.closeOnEscape) return;
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Escape) return;
	
	      _this.close(e);
	    }, _this.handlePortalMouseLeave = function (e) {
	      var _this$props2 = _this.props,
	          closeOnPortalMouseLeave = _this$props2.closeOnPortalMouseLeave,
	          mouseLeaveDelay = _this$props2.mouseLeaveDelay;
	
	
	      if (!closeOnPortalMouseLeave) return;
	
	      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
	    }, _this.handlePortalMouseEnter = function () {
	      // In order to enable mousing from the trigger to the portal, we need to
	      // clear the mouseleave timer that was set when leaving the trigger.
	      var closeOnPortalMouseLeave = _this.props.closeOnPortalMouseLeave;
	
	
	      if (!closeOnPortalMouseLeave) return;
	
	      clearTimeout(_this.mouseLeaveTimer);
	    }, _this.handleTriggerBlur = function (e) {
	      var _this$props3 = _this.props,
	          trigger = _this$props3.trigger,
	          closeOnTriggerBlur = _this$props3.closeOnTriggerBlur;
	
	      // Call original event handler
	
	      (0, _invoke3.default)(trigger, 'props.onBlur', e);
	
	      // do not close if focus is given to the portal
	      var didFocusPortal = (0, _invoke3.default)(_this, 'rootNode.contains', e.relatedTarget);
	
	      if (!closeOnTriggerBlur || didFocusPortal) return;
	
	      _this.close(e);
	    }, _this.handleTriggerClick = function (e) {
	      var _this$props4 = _this.props,
	          trigger = _this$props4.trigger,
	          closeOnTriggerClick = _this$props4.closeOnTriggerClick,
	          openOnTriggerClick = _this$props4.openOnTriggerClick;
	      var open = _this.state.open;
	
	      // Call original event handler
	
	      (0, _invoke3.default)(trigger, 'props.onClick', e);
	
	      if (open && closeOnTriggerClick) {
	
	        _this.close(e);
	      } else if (!open && openOnTriggerClick) {
	
	        _this.open(e);
	      }
	    }, _this.handleTriggerFocus = function (e) {
	      var _this$props5 = _this.props,
	          trigger = _this$props5.trigger,
	          openOnTriggerFocus = _this$props5.openOnTriggerFocus;
	
	      // Call original event handler
	
	      (0, _invoke3.default)(trigger, 'props.onFocus', e);
	
	      if (!openOnTriggerFocus) return;
	
	      _this.open(e);
	    }, _this.handleTriggerMouseLeave = function (e) {
	      clearTimeout(_this.mouseEnterTimer);
	
	      var _this$props6 = _this.props,
	          trigger = _this$props6.trigger,
	          closeOnTriggerMouseLeave = _this$props6.closeOnTriggerMouseLeave,
	          mouseLeaveDelay = _this$props6.mouseLeaveDelay;
	
	      // Call original event handler
	
	      (0, _invoke3.default)(trigger, 'props.onMouseLeave', e);
	
	      if (!closeOnTriggerMouseLeave) return;
	
	      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
	    }, _this.handleTriggerMouseEnter = function (e) {
	      clearTimeout(_this.mouseLeaveTimer);
	
	      var _this$props7 = _this.props,
	          trigger = _this$props7.trigger,
	          mouseEnterDelay = _this$props7.mouseEnterDelay,
	          openOnTriggerMouseEnter = _this$props7.openOnTriggerMouseEnter;
	
	      // Call original event handler
	
	      (0, _invoke3.default)(trigger, 'props.onMouseEnter', _this.handleTriggerMouseEnter);
	
	      if (!openOnTriggerMouseEnter) return;
	
	      _this.mouseEnterTimer = _this.openWithTimeout(e, mouseEnterDelay);
	    }, _this.open = function (e) {
	      var onOpen = _this.props.onOpen;
	
	      if (onOpen) onOpen(e, _this.props);
	
	      _this.trySetState({ open: true });
	    }, _this.openWithTimeout = function (e, delay) {
	      // React wipes the entire event object and suggests using e.persist() if
	      // you need the event for async access. However, even with e.persist
	      // certain required props (e.g. currentTarget) are null so we're forced to clone.
	      var eventClone = (0, _extends3.default)({}, e);
	      return setTimeout(function () {
	        return _this.open(eventClone);
	      }, delay || 0);
	    }, _this.close = function (e) {
	      var onClose = _this.props.onClose;
	
	      if (onClose) onClose(e, _this.props);
	
	      _this.trySetState({ open: false });
	    }, _this.closeWithTimeout = function (e, delay) {
	      // React wipes the entire event object and suggests using e.persist() if
	      // you need the event for async access. However, even with e.persist
	      // certain required props (e.g. currentTarget) are null so we're forced to clone.
	      var eventClone = (0, _extends3.default)({}, e);
	      return setTimeout(function () {
	        return _this.close(eventClone);
	      }, delay || 0);
	    }, _this.mountPortal = function () {
	      if (!_lib.isBrowser || _this.rootNode) return;
	
	      var _this$props8 = _this.props,
	          eventPool = _this$props8.eventPool,
	          _this$props8$mountNod = _this$props8.mountNode,
	          mountNode = _this$props8$mountNod === undefined ? _lib.isBrowser ? document.body : null : _this$props8$mountNod,
	          prepend = _this$props8.prepend;
	
	
	      _this.rootNode = document.createElement('div');
	
	      if (prepend) {
	        mountNode.insertBefore(_this.rootNode, mountNode.firstElementChild);
	      } else {
	        mountNode.appendChild(_this.rootNode);
	      }
	
	      _lib.eventStack.sub('click', _this.handleDocumentClick, eventPool);
	      _lib.eventStack.sub('keydown', _this.handleEscape, eventPool);
	      (0, _invoke3.default)(_this.props, 'onMount', null, _this.props);
	    }, _this.unmountPortal = function () {
	      if (!_lib.isBrowser || !_this.rootNode) return;
	
	      var eventPool = _this.props.eventPool;
	
	
	      _reactDom2.default.unmountComponentAtNode(_this.rootNode);
	      _this.rootNode.parentNode.removeChild(_this.rootNode);
	
	      _lib.eventStack.unsub('mouseleave', _this.handlePortalMouseLeave, { target: _this.portalNode });
	      _lib.eventStack.unsub('mouseenter', _this.handlePortalMouseEnter, { target: _this.portalNode });
	
	      _this.rootNode = null;
	      _this.portalNode = null;
	
	      _lib.eventStack.unsub('click', _this.handleDocumentClick, eventPool);
	      _lib.eventStack.unsub('keydown', _this.handleEscape, eventPool);
	      (0, _invoke3.default)(_this.props, 'onUnmount', null, _this.props);
	    }, _this.handleRef = function (c) {
	      // TODO: Replace findDOMNode with Ref component when it will be merged
	      _this.triggerNode = _reactDom2.default.findDOMNode(c); // eslint-disable-line react/no-find-dom-node
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // NOTE: Ideally the portal rendering would happen in the render() function
	      // but React gives a warning about not being pure and suggests doing it
	      // within this method.
	
	      // If the portal is open, render (or re-render) the portal and child.
	      this.renderPortal();
	
	      if (prevState.open && !this.state.open) {
	        this.unmountPortal();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unmountPortal();
	
	      // Clean up timers
	      clearTimeout(this.mouseEnterTimer);
	      clearTimeout(this.mouseLeaveTimer);
	    }
	
	    // ----------------------------------------
	    // Document Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Component Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Behavior
	    // ----------------------------------------
	
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal() {
	      var _this2 = this;
	
	      if (!this.state.open) return;
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	
	      this.mountPortal();
	
	      // Server side rendering
	      if (!_lib.isBrowser) return null;
	
	      this.rootNode.className = className || '';
	
	      // when re-rendering, first remove listeners before re-adding them to the new node
	      if (this.portalNode) {
	        _lib.eventStack.unsub('mouseleave', this.handlePortalMouseLeave, { target: this.portalNode });
	        _lib.eventStack.unsub('mouseenter', this.handlePortalMouseEnter, { target: this.portalNode });
	      }
	
	      _reactDom2.default.unstable_renderSubtreeIntoContainer(this, _react.Children.only(children), this.rootNode, function () {
	        _this2.portalNode = _this2.rootNode.firstElementChild;
	
	        _lib.eventStack.sub('mouseleave', _this2.handlePortalMouseLeave, { target: _this2.portalNode });
	        _lib.eventStack.sub('mouseenter', _this2.handlePortalMouseEnter, { target: _this2.portalNode });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var trigger = this.props.trigger;
	
	
	      if (!trigger) return null;
	
	      return (0, _react.cloneElement)(trigger, {
	        ref: this.handleRef,
	        onBlur: this.handleTriggerBlur,
	        onClick: this.handleTriggerClick,
	        onFocus: this.handleTriggerFocus,
	        onMouseLeave: this.handleTriggerMouseLeave,
	        onMouseEnter: this.handleTriggerMouseEnter
	      });
	    }
	  }]);
	  return Portal;
	}(_lib.AutoControlledComponent);
	
	Portal.defaultProps = {
	  closeOnDocumentClick: true,
	  closeOnEscape: true,
	  eventPool: 'default',
	  openOnTriggerClick: true
	};
	Portal.autoControlledProps = ['open'];
	Portal._meta = {
	  name: 'Portal',
	  type: _lib.META.TYPES.ADDON
	};
	Portal.handledProps = ['children', 'className', 'closeOnDocumentClick', 'closeOnEscape', 'closeOnPortalMouseLeave', 'closeOnRootNodeClick', 'closeOnTriggerBlur', 'closeOnTriggerClick', 'closeOnTriggerMouseLeave', 'defaultOpen', 'eventPool', 'mountNode', 'mouseEnterDelay', 'mouseLeaveDelay', 'onClose', 'onMount', 'onOpen', 'onUnmount', 'open', 'openOnTriggerClick', 'openOnTriggerFocus', 'openOnTriggerMouseEnter', 'prepend', 'trigger'];
	Portal.propTypes =  false ? {
	  /** Primary content. */
	  children: _propTypes2.default.node.isRequired,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Controls whether or not the portal should close when the document is clicked. */
	  closeOnDocumentClick: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should close when escape is pressed is displayed. */
	  closeOnEscape: _propTypes2.default.bool,
	
	  /**
	   * Controls whether or not the portal should close when mousing out of the portal.
	   * NOTE: This will prevent `closeOnTriggerMouseLeave` when mousing over the
	   * gap from the trigger to the portal.
	   */
	  closeOnPortalMouseLeave: _propTypes2.default.bool,
	
	  /**
	   * Controls whether or not the portal should close on a click on the portal background.
	   * NOTE: This differs from closeOnDocumentClick:
	   * - DocumentClick - any click not within the portal
	   * - RootNodeClick - a click not within the portal but within the portal's wrapper
	   */
	  closeOnRootNodeClick: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should close on blur of the trigger. */
	  closeOnTriggerBlur: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should close on click of the trigger. */
	  closeOnTriggerClick: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should close when mousing out of the trigger. */
	  closeOnTriggerMouseLeave: _propTypes2.default.bool,
	
	  /** Initial value of open. */
	  defaultOpen: _propTypes2.default.bool,
	
	  /** Event pool namespace that is used to handle component events */
	  eventPool: _propTypes2.default.string,
	
	  /** The node where the portal should mount. */
	  mountNode: _propTypes2.default.any,
	
	  /** Milliseconds to wait before opening on mouse over */
	  mouseEnterDelay: _propTypes2.default.number,
	
	  /** Milliseconds to wait before closing on mouse leave */
	  mouseLeaveDelay: _propTypes2.default.number,
	
	  /**
	   * Called when a close event happens
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * Called when the portal is mounted on the DOM
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _propTypes2.default.func,
	
	  /**
	   * Called when an open event happens
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * Called when the portal is unmounted from the DOM
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _propTypes2.default.func,
	
	  /** Controls whether or not the portal is displayed. */
	  open: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should open when the trigger is clicked. */
	  openOnTriggerClick: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should open on focus of the trigger. */
	  openOnTriggerFocus: _propTypes2.default.bool,
	
	  /** Controls whether or not the portal should open when mousing over the trigger. */
	  openOnTriggerMouseEnter: _propTypes2.default.bool,
	
	  /** Controls whether the portal should be prepended to the mountNode instead of appended. */
	  prepend: _propTypes2.default.bool,
	
	  /** Element to be rendered in-place where the portal is defined. */
	  trigger: _propTypes2.default.node
	} : {};
	exports.default = Portal;

/***/ },
/* 3804 */
[4458, 11, 495],
/* 3805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _isNil2 = __webpack_require__(91);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Responsive can control visibility of content.
	 */
	var Responsive = function (_Component) {
	  (0, _inherits3.default)(Responsive, _Component);
	
	  function Responsive() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, Responsive);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Responsive.__proto__ || Object.getPrototypeOf(Responsive)).call.apply(_ref, [this].concat(args)));
	
	    _this.fitsMaxWidth = function () {
	      var maxWidth = _this.props.maxWidth;
	      var width = _this.state.width;
	
	
	      return (0, _isNil3.default)(maxWidth) ? true : width <= maxWidth;
	    };
	
	    _this.fitsMinWidth = function () {
	      var minWidth = _this.props.minWidth;
	      var width = _this.state.width;
	
	
	      return (0, _isNil3.default)(minWidth) ? true : width >= minWidth;
	    };
	
	    _this.isVisible = function () {
	      return _this.fitsMinWidth() && _this.fitsMaxWidth();
	    };
	
	    _this.handleResize = function (e) {
	      if (_this.ticking) return;
	
	      _this.ticking = true;
	      requestAnimationFrame(function () {
	        return _this.handleUpdate(e);
	      });
	    };
	
	    _this.handleUpdate = function (e) {
	      _this.ticking = false;
	      var width = window.innerWidth;
	
	      _this.setState({ width: width });
	      (0, _invoke3.default)(_this.props, 'onUpdate', e, (0, _extends3.default)({}, _this.props, { width: width }));
	    };
	
	    _this.state = { width: window.innerWidth };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Responsive, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _lib.eventStack.sub('resize', this.handleResize, { target: 'window' });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _lib.eventStack.unsub('resize', this.handleResize, { target: 'window' });
	    }
	
	    // ----------------------------------------
	    // Helpers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Event handlers
	    // ----------------------------------------
	
	  }, {
	    key: 'render',
	
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	    value: function render() {
	      var children = this.props.children;
	
	
	      var ElementType = (0, _lib.getElementType)(Responsive, this.props);
	      var rest = (0, _lib.getUnhandledProps)(Responsive, this.props);
	
	      if (this.isVisible()) return _react2.default.createElement(
	        ElementType,
	        rest,
	        children
	      );
	      return null;
	    }
	  }]);
	  return Responsive;
	}(_react.Component);
	
	Responsive._meta = {
	  name: 'Responsive',
	  type: _lib.META.TYPES.ADDON
	};
	Responsive.onlyMobile = { minWidth: 320, maxWidth: 767 };
	Responsive.onlyTablet = { minWidth: 768, maxWidth: 991 };
	Responsive.onlyComputer = { minWidth: 992 };
	Responsive.onlyLargeScreen = { minWidth: 1200, maxWidth: 1919 };
	Responsive.onlyWidescreen = { minWidth: 1920 };
	Responsive.handledProps = ['as', 'children', 'maxWidth', 'minWidth', 'onUpdate'];
	exports.default = Responsive;
	Responsive.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** The maximum width at which content will be displayed. */
	  maxWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** The minimum width at which content will be displayed. */
	  minWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Called on update.
	   *
	   * @param {SyntheticEvent} event - The React SyntheticEvent object
	   * @param {object} data - All props and the event value.
	   */
	  onUpdate: _propTypes2.default.func
	} : {};

/***/ },
/* 3806 */
[4460, 3805],
/* 3807 */
[4461, 11, 784],
/* 3808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _sum2 = __webpack_require__(1779);
	
	var _sum3 = _interopRequireDefault(_sum2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _get2 = __webpack_require__(115);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A TextArea can be used to allow for extended user input.
	 * @see Form
	 */
	var TextArea = function (_Component) {
	  (0, _inherits3.default)(TextArea, _Component);
	
	  function TextArea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextArea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this), _this.focus = function () {
	      return _this.ref.focus();
	    }, _this.handleChange = function (e) {
	      var value = (0, _get3.default)(e, 'target.value');
	
	      (0, _invoke3.default)(_this.props, 'onChange', e, (0, _extends3.default)({}, _this.props, { value: value }));
	    }, _this.handleInput = function (e) {
	      var value = (0, _get3.default)(e, 'target.value');
	
	      (0, _invoke3.default)(_this.props, 'onInput', e, (0, _extends3.default)({}, _this.props, { value: value }));
	      _this.updateHeight();
	    }, _this.handleRef = function (c) {
	      return _this.ref = c;
	    }, _this.removeAutoHeightStyles = function () {
	      _this.ref.style.height = null;
	      _this.ref.style.resize = null;
	    }, _this.updateHeight = function () {
	      var autoHeight = _this.props.autoHeight;
	
	      if (!_this.ref || !autoHeight) return;
	
	      var _window$getComputedSt = window.getComputedStyle(_this.ref),
	          minHeight = _window$getComputedSt.minHeight,
	          borderBottomWidth = _window$getComputedSt.borderBottomWidth,
	          borderTopWidth = _window$getComputedSt.borderTopWidth;
	
	      var borderHeight = (0, _sum3.default)([borderBottomWidth, borderTopWidth].map(function (x) {
	        return parseFloat(x);
	      }));
	
	      // Measure the scrollHeight and update the height to match.
	      _this.ref.style.height = 'auto';
	      _this.ref.style.height = Math.max(parseFloat(minHeight), Math.ceil(_this.ref.scrollHeight + borderHeight)) + 'px';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextArea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateHeight();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // removed autoHeight
	      if (!this.props.autoHeight && prevProps.autoHeight) {
	        this.removeAutoHeightStyles();
	      }
	      // added autoHeight or value changed
	      if (this.props.autoHeight && !prevProps.autoHeight || prevProps.value !== this.props.value) {
	        this.updateHeight();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoHeight = _props.autoHeight,
	          rows = _props.rows,
	          style = _props.style,
	          value = _props.value;
	
	      var rest = (0, _lib.getUnhandledProps)(TextArea, this.props);
	      var ElementType = (0, _lib.getElementType)(TextArea, this.props);
	
	      var resize = autoHeight ? 'none' : '';
	
	      return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, {
	        onChange: this.handleChange,
	        onInput: this.handleInput,
	        ref: this.handleRef,
	        rows: rows,
	        style: (0, _extends3.default)({ resize: resize }, style),
	        value: value
	      }));
	    }
	  }]);
	  return TextArea;
	}(_react.Component);
	
	TextArea._meta = {
	  name: 'TextArea',
	  type: _lib.META.TYPES.ADDON
	};
	TextArea.defaultProps = {
	  as: 'textarea',
	  rows: 3
	};
	TextArea.handledProps = ['as', 'autoHeight', 'onChange', 'onInput', 'rows', 'style', 'value'];
	TextArea.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Indicates whether height of the textarea fits the content or not. */
	  autoHeight: _propTypes2.default.bool,
	
	  /**
	   * Called on change.
	   * @param {SyntheticEvent} event - The React SyntheticEvent object
	   * @param {object} data - All props and the event value.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * Called on input.
	   * @param {SyntheticEvent} event - The React SyntheticEvent object
	   * @param {object} data - All props and the event value.
	   */
	  onInput: _propTypes2.default.func,
	
	  /** Indicates row count for a TextArea. */
	  rows: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** Custom TextArea style. */
	  style: _propTypes2.default.object,
	
	  /** The value of the textarea. */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	} : {};
	exports.default = TextArea;

/***/ },
/* 3809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(130);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _forEach2 = __webpack_require__(272);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _includes2 = __webpack_require__(189);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Visibility provides a set of callbacks for when a content appears in the viewport.
	 */
	var Visibility = function (_Component) {
	  (0, _inherits3.default)(Visibility, _Component);
	
	  function Visibility() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Visibility);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Visibility.__proto__ || Object.getPrototypeOf(Visibility)).call.apply(_ref, [this].concat(args))), _this), _this.calculations = {
	      bottomPassed: false,
	      bottomVisible: false,
	      fits: false,
	      passing: false,
	      offScreen: false,
	      onScreen: false,
	      topPassed: false,
	      topVisible: false
	    }, _this.firedCallbacks = [], _this.fire = function (_ref2, value) {
	      var callback = _ref2.callback,
	          name = _ref2.name;
	      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var _this$props = _this.props,
	          continuous = _this$props.continuous,
	          once = _this$props.once;
	
	      // Heads up! For the execution is required:
	      // - current value correspond to the fired direction
	      // - `continuous` is true or calculation values are different
	
	      var matchesDirection = _this.calculations[value] !== reverse;
	      var executionPossible = continuous || _this.calculations[value] !== _this.oldCalculations[value];
	
	      if (matchesDirection && executionPossible) _this.execute(callback, name);
	
	      // Heads up! We should remove callback from the happened when it's not `once`
	      if (!once) _this.firedCallbacks = (0, _without3.default)(_this.firedCallbacks, name);
	    }, _this.handleUpdate = function () {
	      if (_this.ticking) return;
	
	      _this.ticking = true;
	      requestAnimationFrame(_this.update);
	    }, _this.update = function () {
	      _this.ticking = false;
	
	      _this.oldCalculations = _this.calculations;
	      _this.calculations = _this.computeCalculations();
	      _this.pageYOffset = window.pageYOffset;
	
	      var _this$props2 = _this.props,
	          onBottomPassed = _this$props2.onBottomPassed,
	          onBottomPassedReverse = _this$props2.onBottomPassedReverse,
	          onBottomVisible = _this$props2.onBottomVisible,
	          onBottomVisibleReverse = _this$props2.onBottomVisibleReverse,
	          onPassing = _this$props2.onPassing,
	          onPassingReverse = _this$props2.onPassingReverse,
	          onTopPassed = _this$props2.onTopPassed,
	          onTopPassedReverse = _this$props2.onTopPassedReverse,
	          onTopVisible = _this$props2.onTopVisible,
	          onTopVisibleReverse = _this$props2.onTopVisibleReverse,
	          onOffScreen = _this$props2.onOffScreen,
	          onOnScreen = _this$props2.onOnScreen;
	
	      var forward = {
	        bottomPassed: { callback: onBottomPassed, name: 'onBottomPassed' },
	        bottomVisible: { callback: onBottomVisible, name: 'onBottomVisible' },
	        passing: { callback: onPassing, name: 'onPassing' },
	        offScreen: { callback: onOffScreen, name: 'onOffScreen' },
	        onScreen: { callback: onOnScreen, name: 'onOnScreen' },
	        topPassed: { callback: onTopPassed, name: 'onTopPassed' },
	        topVisible: { callback: onTopVisible, name: 'onTopVisible' }
	      };
	
	      var reverse = {
	        bottomPassed: { callback: onBottomPassedReverse, name: 'onBottomPassedReverse' },
	        bottomVisible: { callback: onBottomVisibleReverse, name: 'onBottomVisibleReverse' },
	        passing: { callback: onPassingReverse, name: 'onPassingReverse' },
	        topPassed: { callback: onTopPassedReverse, name: 'onTopPassedReverse' },
	        topVisible: { callback: onTopVisibleReverse, name: 'onTopVisibleReverse' }
	      };
	
	      (0, _invoke3.default)(_this.props, 'onUpdate', null, (0, _extends3.default)({}, _this.props, { calculations: _this.calculations }));
	      _this.fireOnPassed();
	
	      // Heads up! Reverse callbacks should be fired first
	      (0, _forEach3.default)(reverse, function (data, value) {
	        return _this.fire(data, value, true);
	      });
	      (0, _forEach3.default)(forward, function (data, value) {
	        return _this.fire(data, value);
	      });
	    }, _this.handleRef = function (c) {
	      return _this.ref = c;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Visibility, [{
	    key: 'componentWillReceiveProps',
	
	
	    // ----------------------------------------
	    // Lifecycle
	    // ----------------------------------------
	
	    value: function componentWillReceiveProps(_ref3) {
	      var continuous = _ref3.continuous,
	          once = _ref3.once;
	
	      var cleanHappened = continuous !== this.props.continuous || once !== this.props.once;
	
	      // Heads up! We should clean up array of happened callbacks, if values of these props are changed
	      if (cleanHappened) this.firedCallbacks = [];
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!_lib.isBrowser) return;
	      var _props = this.props,
	          context = _props.context,
	          fireOnMount = _props.fireOnMount;
	
	
	      this.pageYOffset = window.pageYOffset;
	      _lib.eventStack.sub('resize', this.handleUpdate, { target: context });
	      _lib.eventStack.sub('scroll', this.handleUpdate, { target: context });
	
	      if (fireOnMount) this.update();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var context = this.props.context;
	
	
	      _lib.eventStack.unsub('resize', this.handleUpdate, { target: context });
	      _lib.eventStack.unsub('scroll', this.handleUpdate, { target: context });
	    }
	
	    // ----------------------------------------
	    // Callback handling
	    // ----------------------------------------
	
	  }, {
	    key: 'execute',
	    value: function execute(callback, name) {
	      var continuous = this.props.continuous;
	
	      if (!callback) return;
	
	      // Heads up! When `continuous` is true, callback will be fired always
	      if (!continuous && (0, _includes3.default)(this.firedCallbacks, name)) return;
	
	      callback(null, (0, _extends3.default)({}, this.props, { calculations: this.calculations }));
	      this.firedCallbacks.push(name);
	    }
	  }, {
	    key: 'fireOnPassed',
	    value: function fireOnPassed() {
	      var _this2 = this;
	
	      var _calculations = this.calculations,
	          percentagePassed = _calculations.percentagePassed,
	          pixelsPassed = _calculations.pixelsPassed;
	      var onPassed = this.props.onPassed;
	
	
	      (0, _forEach3.default)(onPassed, function (callback, passed) {
	        var pixelsValue = Number(passed);
	
	        if (pixelsValue && pixelsPassed >= pixelsValue) {
	          _this2.execute(callback, passed);
	          return;
	        }
	
	        var matchPercentage = ('' + passed).match(/^(\d+)%$/);
	        if (!matchPercentage) return;
	
	        var percentageValue = Number(matchPercentage[1]) / 100;
	        if (percentagePassed >= percentageValue) _this2.execute(callback, passed);
	      });
	    }
	  }, {
	    key: 'computeCalculations',
	
	
	    // ----------------------------------------
	    // Helpers
	    // ----------------------------------------
	
	    value: function computeCalculations() {
	      var offset = this.props.offset;
	
	      var _ref$getBoundingClien = this.ref.getBoundingClientRect(),
	          bottom = _ref$getBoundingClien.bottom,
	          height = _ref$getBoundingClien.height,
	          top = _ref$getBoundingClien.top,
	          width = _ref$getBoundingClien.width;
	
	      var _normalizeOffset = (0, _lib.normalizeOffset)(offset),
	          _normalizeOffset2 = (0, _slicedToArray3.default)(_normalizeOffset, 2),
	          topOffset = _normalizeOffset2[0],
	          bottomOffset = _normalizeOffset2[1];
	
	      var direction = window.pageYOffset > this.pageYOffset ? 'down' : 'up';
	      var topPassed = top < topOffset;
	      var bottomPassed = bottom < bottomOffset;
	
	      var pixelsPassed = bottomPassed ? 0 : Math.max(top * -1, 0);
	      var percentagePassed = pixelsPassed / height;
	
	      var bottomVisible = bottom >= bottomOffset && bottom <= window.innerHeight;
	      var topVisible = top >= topOffset && top <= window.innerHeight;
	
	      var fits = topVisible && bottomVisible;
	      var passing = topPassed && !bottomPassed;
	
	      var onScreen = (topVisible || topPassed) && !bottomPassed;
	      var offScreen = !onScreen;
	
	      return {
	        bottomPassed: bottomPassed,
	        bottomVisible: bottomVisible,
	        direction: direction,
	        fits: fits,
	        height: height,
	        passing: passing,
	        percentagePassed: percentagePassed,
	        pixelsPassed: pixelsPassed,
	        offScreen: offScreen,
	        onScreen: onScreen,
	        topPassed: topPassed,
	        topVisible: topVisible,
	        width: width
	      };
	    }
	
	    // ----------------------------------------
	    // Refs
	    // ----------------------------------------
	
	  }, {
	    key: 'render',
	
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	    value: function render() {
	      var children = this.props.children;
	
	      var ElementType = (0, _lib.getElementType)(Visibility, this.props);
	      var rest = (0, _lib.getUnhandledProps)(Visibility, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { ref: this.handleRef }),
	        children
	      );
	    }
	  }]);
	  return Visibility;
	}(_react.Component);
	
	Visibility.defaultProps = {
	  context: _lib.isBrowser ? window : null,
	  continuous: false,
	  offset: [0, 0],
	  once: true
	};
	Visibility._meta = {
	  name: 'Visibility',
	  type: _lib.META.TYPES.BEHAVIOR
	};
	Visibility.handledProps = ['as', 'children', 'context', 'continuous', 'fireOnMount', 'offset', 'onBottomPassed', 'onBottomPassedReverse', 'onBottomVisible', 'onBottomVisibleReverse', 'onOffScreen', 'onOnScreen', 'onPassed', 'onPassing', 'onPassingReverse', 'onTopPassed', 'onTopPassedReverse', 'onTopVisible', 'onTopVisibleReverse', 'onUpdate', 'once'];
	exports.default = Visibility;
	Visibility.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Context which visibility should attach onscroll events. */
	  context: _propTypes2.default.object,
	
	  /**
	   * When set to true a callback will occur anytime an element passes a condition not just immediately after the
	   * threshold is met.
	   */
	  continuous: _propTypes2.default.bool,
	
	  /** Fires callbacks immediately after mount. */
	  fireOnMount: _propTypes2.default.bool,
	
	  /**
	   * Element's bottom edge has passed top of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onBottomPassed: _propTypes2.default.func,
	
	  /**
	   * Element's bottom edge has not passed top of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onBottomPassedReverse: _propTypes2.default.func,
	
	  /**
	   * Element's bottom edge has passed bottom of screen
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onBottomVisible: _propTypes2.default.func,
	
	  /**
	   * Element's bottom edge has not passed bottom of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onBottomVisibleReverse: _propTypes2.default.func,
	
	  /**
	   * Value that context should be adjusted in pixels. Useful for making content appear below content fixed to the
	   * page.
	   */
	  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
	
	  /** When set to false a callback will occur each time an element passes the threshold for a condition. */
	  once: _propTypes2.default.bool,
	
	  /** Element is not visible on the screen. */
	  onPassed: _propTypes2.default.object,
	
	  /**
	   * Any part of an element is visible on screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onPassing: _propTypes2.default.func,
	
	  /**
	   * Element's top has not passed top of screen but bottom has.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onPassingReverse: _propTypes2.default.func,
	
	  /**
	   * Element is not visible on the screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onOffScreen: _propTypes2.default.func,
	
	  /**
	   * Element is visible on the screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onOnScreen: _propTypes2.default.func,
	
	  /**
	   * Element's top edge has passed top of the screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onTopPassed: _propTypes2.default.func,
	
	  /**
	   * Element's top edge has not passed top of the screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onTopPassedReverse: _propTypes2.default.func,
	
	  /**
	   * Element's top edge has passed bottom of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onTopVisible: _propTypes2.default.func,
	
	  /**
	   * Element's top edge has not passed bottom of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onTopVisibleReverse: _propTypes2.default.func,
	
	  /**
	   * Element's top edge has passed bottom of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUpdate: _propTypes2.default.func
	} : {};

/***/ },
/* 3810 */
[4464, 3809],
/* 3811 */
[4465, 42, 820, 12, 11, 1630, 1631],
/* 3812 */
[4467, 3811],
/* 3813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _FormButton = __webpack_require__(1632);
	
	var _FormButton2 = _interopRequireDefault(_FormButton);
	
	var _FormCheckbox = __webpack_require__(1633);
	
	var _FormCheckbox2 = _interopRequireDefault(_FormCheckbox);
	
	var _FormDropdown = __webpack_require__(1634);
	
	var _FormDropdown2 = _interopRequireDefault(_FormDropdown);
	
	var _FormField = __webpack_require__(161);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormGroup = __webpack_require__(1635);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormInput = __webpack_require__(1636);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormRadio = __webpack_require__(1637);
	
	var _FormRadio2 = _interopRequireDefault(_FormRadio);
	
	var _FormSelect = __webpack_require__(1638);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _FormTextArea = __webpack_require__(1639);
	
	var _FormTextArea2 = _interopRequireDefault(_FormTextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A Form displays a set of related user input fields in a structured way.
	 * @see Button
	 * @see Checkbox
	 * @see Dropdown
	 * @see Input
	 * @see Message
	 * @see Radio
	 * @see Select
	 * @see Visibility
	 */
	var Form = function (_Component) {
	  (0, _inherits3.default)(Form, _Component);
	
	  function Form() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Form);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Form, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          action = _props.action,
	          children = _props.children,
	          className = _props.className,
	          error = _props.error,
	          inverted = _props.inverted,
	          loading = _props.loading,
	          reply = _props.reply,
	          size = _props.size,
	          success = _props.success,
	          unstackable = _props.unstackable,
	          warning = _props.warning,
	          widths = _props.widths;
	
	
	      var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(reply, 'reply'), (0, _lib.useKeyOnly)(success, 'success'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useWidthProp)(widths, null, true), 'form', className);
	      var rest = (0, _lib.getUnhandledProps)(Form, this.props);
	      var ElementType = (0, _lib.getElementType)(Form, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, {
	          action: action,
	          className: classes,
	          onSubmit: this.handleSubmit
	        }),
	        children
	      );
	    }
	  }]);
	  return Form;
	}(_react.Component);
	
	Form.defaultProps = {
	  as: 'form'
	};
	Form._meta = {
	  name: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	Form.Field = _FormField2.default;
	Form.Button = _FormButton2.default;
	Form.Checkbox = _FormCheckbox2.default;
	Form.Dropdown = _FormDropdown2.default;
	Form.Group = _FormGroup2.default;
	Form.Input = _FormInput2.default;
	Form.Radio = _FormRadio2.default;
	Form.Select = _FormSelect2.default;
	Form.TextArea = _FormTextArea2.default;
	Form.handledProps = ['action', 'as', 'children', 'className', 'error', 'inverted', 'loading', 'onSubmit', 'reply', 'size', 'success', 'unstackable', 'warning', 'widths'];
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.handleSubmit = function (e) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    var action = _this2.props.action;
	
	    // Heads up! Third party libs can pass own data as first argument, we need to check that it has preventDefault()
	    // method.
	
	    if (!action) (0, _invoke3.default)(e, 'preventDefault');
	    _invoke3.default.apply(undefined, [_this2.props, 'onSubmit', e, _this2.props].concat(args));
	  };
	};
	
	Form.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** The HTML form action */
	  action: _propTypes2.default.string,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Automatically show any error Message children. */
	  error: _propTypes2.default.bool,
	
	  /** A form can have its color inverted for contrast. */
	  inverted: _propTypes2.default.bool,
	
	  /** Automatically show a loading indicator. */
	  loading: _propTypes2.default.bool,
	
	  /** The HTML form submit handler. */
	  onSubmit: _propTypes2.default.func,
	
	  /** A comment can contain a form to reply to a comment. This may have arbitrary content. */
	  reply: _propTypes2.default.bool,
	
	  /** A form can vary in size. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** Automatically show any success Message children. */
	  success: _propTypes2.default.bool,
	
	  /** A form can prevent itself from stacking on mobile. */
	  unstackable: _propTypes2.default.bool,
	
	  /** Automatically show any warning Message children. */
	  warning: _propTypes2.default.bool,
	
	  /** Forms can automatically divide fields to be equal width. */
	  widths: _propTypes2.default.oneOf(['equal'])
	} : {};
	exports.default = Form;

/***/ },
/* 3814 */
[4476, 3813],
/* 3815 */
[4477, 1640],
/* 3816 */
[4480, 1642],
/* 3817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(91);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Icon = __webpack_require__(77);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MessageContent = __webpack_require__(1646);
	
	var _MessageContent2 = _interopRequireDefault(_MessageContent);
	
	var _MessageHeader = __webpack_require__(1647);
	
	var _MessageHeader2 = _interopRequireDefault(_MessageHeader);
	
	var _MessageList = __webpack_require__(1648);
	
	var _MessageList2 = _interopRequireDefault(_MessageList);
	
	var _MessageItem = __webpack_require__(772);
	
	var _MessageItem2 = _interopRequireDefault(_MessageItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A message displays information that explains nearby content.
	 * @see Form
	 */
	var Message = function (_Component) {
	  (0, _inherits3.default)(Message, _Component);
	
	  function Message() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Message);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Message.__proto__ || Object.getPrototypeOf(Message)).call.apply(_ref, [this].concat(args))), _this), _this.handleDismiss = function (e) {
	      var onDismiss = _this.props.onDismiss;
	
	
	      if (onDismiss) onDismiss(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Message, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          attached = _props.attached,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          compact = _props.compact,
	          content = _props.content,
	          error = _props.error,
	          floating = _props.floating,
	          header = _props.header,
	          hidden = _props.hidden,
	          icon = _props.icon,
	          info = _props.info,
	          list = _props.list,
	          negative = _props.negative,
	          onDismiss = _props.onDismiss,
	          positive = _props.positive,
	          size = _props.size,
	          success = _props.success,
	          visible = _props.visible,
	          warning = _props.warning;
	
	
	      var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(floating, 'floating'), (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(icon, 'icon'), (0, _lib.useKeyOnly)(info, 'info'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(success, 'success'), (0, _lib.useKeyOnly)(visible, 'visible'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), 'message', className);
	
	      var dismissIcon = onDismiss && _react2.default.createElement(_Icon2.default, { name: 'close', onClick: this.handleDismiss });
	      var rest = (0, _lib.getUnhandledProps)(Message, this.props);
	      var ElementType = (0, _lib.getElementType)(Message, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes }),
	          dismissIcon,
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        dismissIcon,
	        _Icon2.default.create(icon),
	        (!(0, _isNil3.default)(header) || !(0, _isNil3.default)(content) || !(0, _isNil3.default)(list)) && _react2.default.createElement(
	          _MessageContent2.default,
	          null,
	          _MessageHeader2.default.create(header),
	          _MessageList2.default.create(list),
	          (0, _lib.createHTMLParagraph)(content)
	        )
	      );
	    }
	  }]);
	  return Message;
	}(_react.Component);
	
	Message._meta = {
	  name: 'Message',
	  type: _lib.META.TYPES.COLLECTION
	};
	Message.Content = _MessageContent2.default;
	Message.Header = _MessageHeader2.default;
	Message.List = _MessageList2.default;
	Message.Item = _MessageItem2.default;
	Message.handledProps = ['as', 'attached', 'children', 'className', 'color', 'compact', 'content', 'error', 'floating', 'header', 'hidden', 'icon', 'info', 'list', 'negative', 'onDismiss', 'positive', 'size', 'success', 'visible', 'warning'];
	exports.default = Message;
	Message.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A message can be formatted to attach itself to other content. */
	  attached: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['bottom'])]),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A message can be formatted to be different colors. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** A message can only take up the width of its content. */
	  compact: _propTypes2.default.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A message may be formatted to display a negative message. Same as `negative`. */
	  error: _propTypes2.default.bool,
	
	  /** A message can float above content that it is related to. */
	  floating: _propTypes2.default.bool,
	
	  /** Shorthand for MessageHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** A message can be hidden. */
	  hidden: _propTypes2.default.bool,
	
	  /** A message can contain an icon. */
	  icon: _propTypes2.default.oneOfType([_lib.customPropTypes.itemShorthand, _propTypes2.default.bool]),
	
	  /** A message may be formatted to display information. */
	  info: _propTypes2.default.bool,
	
	  /** Array shorthand items for the MessageList. Mutually exclusive with children. */
	  list: _lib.customPropTypes.collectionShorthand,
	
	  /** A message may be formatted to display a negative message. Same as `error`. */
	  negative: _propTypes2.default.bool,
	
	  /**
	   * A message that the user can choose to hide.
	   * Called when the user clicks the "x" icon. This also adds the "x" icon.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onDismiss: _propTypes2.default.func,
	
	  /** A message may be formatted to display a positive message.  Same as `success`. */
	  positive: _propTypes2.default.bool,
	
	  /** A message can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium')),
	
	  /** A message may be formatted to display a positive message.  Same as `positive`. */
	  success: _propTypes2.default.bool,
	
	  /** A message can be set to visible to force itself to be shown. */
	  visible: _propTypes2.default.bool,
	
	  /** A message may be formatted to display warning messages. */
	  warning: _propTypes2.default.bool
	} : {};

/***/ },
/* 3818 */
[4484, 3817],
/* 3819 */
[4485, 42, 72, 12, 11, 1649, 489, 1650, 773, 1651, 1652],
/* 3820 */
[4491, 3819],
/* 3821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A container limits content to a maximum width.
	 */
	function Container(props) {
	  var children = props.children,
	      className = props.className,
	      fluid = props.fluid,
	      text = props.text,
	      textAlign = props.textAlign;
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(text, 'text'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useTextAlignProp)(textAlign), 'container', className);
	  var rest = (0, _lib.getUnhandledProps)(Container, props);
	  var ElementType = (0, _lib.getElementType)(Container, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Container.handledProps = ['as', 'children', 'className', 'fluid', 'text', 'textAlign'];
	Container._meta = {
	  name: 'Container',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Container.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Container has no maximum width. */
	  fluid: _propTypes2.default.bool,
	
	  /** Reduce maximum width to more naturally accommodate text. */
	  text: _propTypes2.default.bool,
	
	  /** Align container text. */
	  textAlign: _propTypes2.default.oneOf(_lib.SUI.TEXT_ALIGNMENTS)
	} : {};
	
	exports.default = Container;

/***/ },
/* 3822 */
[4495, 3821],
/* 3823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A divider visually segments content into groups.
	 */
	function Divider(props) {
	  var children = props.children,
	      className = props.className,
	      clearing = props.clearing,
	      fitted = props.fitted,
	      hidden = props.hidden,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      section = props.section,
	      vertical = props.vertical;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(clearing, 'clearing'), (0, _lib.useKeyOnly)(fitted, 'fitted'), (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(section, 'section'), (0, _lib.useKeyOnly)(vertical, 'vertical'), 'divider', className);
	  var rest = (0, _lib.getUnhandledProps)(Divider, props);
	  var ElementType = (0, _lib.getElementType)(Divider, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Divider.handledProps = ['as', 'children', 'className', 'clearing', 'fitted', 'hidden', 'horizontal', 'inverted', 'section', 'vertical'];
	Divider._meta = {
	  name: 'Divider',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Divider.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Divider can clear the content above it. */
	  clearing: _propTypes2.default.bool,
	
	  /** Divider can be fitted without any space above or below it. */
	  fitted: _propTypes2.default.bool,
	
	  /** Divider can divide content without creating a dividing line. */
	  hidden: _propTypes2.default.bool,
	
	  /** Divider can segment content horizontally. */
	  horizontal: _propTypes2.default.bool,
	
	  /** Divider can have it's colours inverted. */
	  inverted: _propTypes2.default.bool,
	
	  /** Divider can provide greater margins to divide sections of content. */
	  section: _propTypes2.default.bool,
	
	  /** Divider can segment content vertically. */
	  vertical: _propTypes2.default.bool
	} : {};
	
	exports.default = Divider;

/***/ },
/* 3824 */
[4496, 3823],
/* 3825 */
[4497, 12, 11],
/* 3826 */
[4499, 42, 12, 11, 77, 268, 1659, 1658],
/* 3827 */
[4501, 3826],
/* 3828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(130);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _includes2 = __webpack_require__(189);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _map2 = __webpack_require__(72);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _get2 = __webpack_require__(115);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isNil2 = __webpack_require__(91);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Button = __webpack_require__(490);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(77);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Label = __webpack_require__(492);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An Input is a field used to elicit a response from a user.
	 * @see Button
	 * @see Form
	 * @see Icon
	 * @see Label
	 */
	var Input = function (_Component) {
	  (0, _inherits3.default)(Input, _Component);
	
	  function Input() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Input);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.computeIcon = function () {
	      var _this$props = _this.props,
	          loading = _this$props.loading,
	          icon = _this$props.icon;
	
	
	      if (!(0, _isNil3.default)(icon)) return icon;
	      if (loading) return 'spinner';
	    }, _this.computeTabIndex = function () {
	      var _this$props2 = _this.props,
	          disabled = _this$props2.disabled,
	          tabIndex = _this$props2.tabIndex;
	
	
	      if (!(0, _isNil3.default)(tabIndex)) return tabIndex;
	      if (disabled) return -1;
	    }, _this.focus = function () {
	      return _this.inputRef.focus();
	    }, _this.handleChange = function (e) {
	      var value = (0, _get3.default)(e, 'target.value');
	
	      (0, _invoke3.default)(_this.props, 'onChange', e, (0, _extends3.default)({}, _this.props, { value: value }));
	    }, _this.handleChildOverrides = function (child, defaultProps) {
	      return (0, _extends3.default)({}, defaultProps, child.props, {
	        ref: function ref(c) {
	          (0, _invoke3.default)(child, 'ref', c);
	          _this.handleInputRef(c);
	        }
	      });
	    }, _this.handleInputRef = function (c) {
	      return _this.inputRef = c;
	    }, _this.partitionProps = function () {
	      var _this$props3 = _this.props,
	          disabled = _this$props3.disabled,
	          type = _this$props3.type;
	
	
	      var tabIndex = _this.computeTabIndex();
	      var unhandled = (0, _lib.getUnhandledProps)(Input, _this.props);
	
	      var _partitionHTMLInputPr = (0, _lib.partitionHTMLInputProps)(unhandled),
	          _partitionHTMLInputPr2 = (0, _slicedToArray3.default)(_partitionHTMLInputPr, 2),
	          htmlInputProps = _partitionHTMLInputPr2[0],
	          rest = _partitionHTMLInputPr2[1];
	
	      return [(0, _extends3.default)({}, htmlInputProps, {
	        disabled: disabled,
	        type: type,
	        tabIndex: tabIndex,
	        onChange: _this.handleChange,
	        ref: _this.handleInputRef
	      }), rest];
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Input, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          action = _props.action,
	          actionPosition = _props.actionPosition,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          error = _props.error,
	          fluid = _props.fluid,
	          focus = _props.focus,
	          icon = _props.icon,
	          iconPosition = _props.iconPosition,
	          input = _props.input,
	          inverted = _props.inverted,
	          label = _props.label,
	          labelPosition = _props.labelPosition,
	          loading = _props.loading,
	          size = _props.size,
	          transparent = _props.transparent,
	          type = _props.type;
	
	
	      var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(focus, 'focus'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(transparent, 'transparent'), (0, _lib.useValueAndKey)(actionPosition, 'action') || (0, _lib.useKeyOnly)(action, 'action'), (0, _lib.useValueAndKey)(iconPosition, 'icon') || (0, _lib.useKeyOnly)(icon || loading, 'icon'), (0, _lib.useValueAndKey)(labelPosition, 'labeled') || (0, _lib.useKeyOnly)(label, 'labeled'), 'input', className);
	      var ElementType = (0, _lib.getElementType)(Input, this.props);
	
	      var _partitionProps = this.partitionProps(),
	          _partitionProps2 = (0, _slicedToArray3.default)(_partitionProps, 2),
	          htmlInputProps = _partitionProps2[0],
	          rest = _partitionProps2[1];
	
	      // Render with children
	      // ----------------------------------------
	
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        // add htmlInputProps to the `<input />` child
	        var childElements = (0, _map3.default)(_react.Children.toArray(children), function (child) {
	          if (child.type !== 'input') return child;
	          return (0, _react.cloneElement)(child, _this2.handleChildOverrides(child, htmlInputProps));
	        });
	
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes }),
	          childElements
	        );
	      }
	
	      // Render Shorthand
	      // ----------------------------------------
	      var actionElement = _Button2.default.create(action);
	      var iconElement = _Icon2.default.create(this.computeIcon());
	      var labelElement = _Label2.default.create(label, {
	        defaultProps: {
	          className: (0, _classnames2.default)('label',
	          // add 'left|right corner'
	          (0, _includes3.default)(labelPosition, 'corner') && labelPosition)
	        }
	      });
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        actionPosition === 'left' && actionElement,
	        iconPosition === 'left' && iconElement,
	        labelPosition !== 'right' && labelElement,
	        (0, _lib.createHTMLInput)(input || type, { defaultProps: htmlInputProps }),
	        actionPosition !== 'left' && actionElement,
	        iconPosition !== 'left' && iconElement,
	        labelPosition === 'right' && labelElement
	      );
	    }
	  }]);
	  return Input;
	}(_react.Component);
	
	Input.defaultProps = {
	  type: 'text'
	};
	Input._meta = {
	  name: 'Input',
	  type: _lib.META.TYPES.ELEMENT
	};
	Input.handledProps = ['action', 'actionPosition', 'as', 'children', 'className', 'disabled', 'error', 'fluid', 'focus', 'icon', 'iconPosition', 'input', 'inverted', 'label', 'labelPosition', 'loading', 'onChange', 'size', 'tabIndex', 'transparent', 'type'];
	Input.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** An Input can be formatted to alert the user to an action they may perform. */
	  action: _propTypes2.default.oneOfType([_propTypes2.default.bool, _lib.customPropTypes.itemShorthand]),
	
	  /** An action can appear along side an Input on the left or right. */
	  actionPosition: _propTypes2.default.oneOf(['left']),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** An Input field can show that it is disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** An Input field can show the data contains errors. */
	  error: _propTypes2.default.bool,
	
	  /** Take on the size of it's container. */
	  fluid: _propTypes2.default.bool,
	
	  /** An Input field can show a user is currently interacting with it. */
	  focus: _propTypes2.default.bool,
	
	  /** Optional Icon to display inside the Input. */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _lib.customPropTypes.itemShorthand]),
	
	  /** An Icon can appear inside an Input on the left or right. */
	  iconPosition: _propTypes2.default.oneOf(['left']),
	
	  /** Shorthand for creating the HTML Input. */
	  input: _lib.customPropTypes.itemShorthand,
	
	  /** Format to appear on dark backgrounds. */
	  inverted: _propTypes2.default.bool,
	
	  /** Optional Label to display along side the Input. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** A Label can appear outside an Input on the left or right. */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right', 'left corner', 'right corner']),
	
	  /** An Icon Input field can show that it is currently loading data. */
	  loading: _propTypes2.default.bool,
	
	  /**
	   * Called on change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed value.
	   */
	  onChange: _propTypes2.default.func,
	
	  /** An Input can vary in size. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES),
	
	  /** An Input can receive focus. */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** Transparent Input has no background. */
	  transparent: _propTypes2.default.bool,
	
	  /** The HTML input type. */
	  type: _propTypes2.default.string
	} : {};
	
	
	Input.create = (0, _lib.createShorthandFactory)(Input, function (type) {
	  return { type: type };
	});
	
	exports.default = Input;

/***/ },
/* 3829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _map2 = __webpack_require__(72);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _ListContent = __webpack_require__(776);
	
	var _ListContent2 = _interopRequireDefault(_ListContent);
	
	var _ListDescription = __webpack_require__(493);
	
	var _ListDescription2 = _interopRequireDefault(_ListDescription);
	
	var _ListHeader = __webpack_require__(494);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _ListIcon = __webpack_require__(777);
	
	var _ListIcon2 = _interopRequireDefault(_ListIcon);
	
	var _ListItem = __webpack_require__(1665);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListList = __webpack_require__(1666);
	
	var _ListList2 = _interopRequireDefault(_ListList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list groups related content.
	 */
	var List = function (_Component) {
	  (0, _inherits3.default)(List, _Component);
	
	  function List() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, List);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e, itemProps) {
	          (0, _invoke3.default)(predefinedProps, 'onClick', e, itemProps);
	          (0, _invoke3.default)(_this.props, 'onItemClick', e, itemProps);
	        }
	      };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animated = _props.animated,
	          bulleted = _props.bulleted,
	          celled = _props.celled,
	          children = _props.children,
	          className = _props.className,
	          divided = _props.divided,
	          floated = _props.floated,
	          horizontal = _props.horizontal,
	          inverted = _props.inverted,
	          items = _props.items,
	          link = _props.link,
	          ordered = _props.ordered,
	          relaxed = _props.relaxed,
	          selection = _props.selection,
	          size = _props.size,
	          verticalAlign = _props.verticalAlign;
	
	
	      var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(animated, 'animated'), (0, _lib.useKeyOnly)(bulleted, 'bulleted'), (0, _lib.useKeyOnly)(celled, 'celled'), (0, _lib.useKeyOnly)(divided, 'divided'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(ordered, 'ordered'), (0, _lib.useKeyOnly)(selection, 'selection'), (0, _lib.useKeyOrValueAndKey)(relaxed, 'relaxed'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign), 'list', className);
	      var rest = (0, _lib.getUnhandledProps)(List, this.props);
	      var ElementType = (0, _lib.getElementType)(List, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { role: 'list', className: classes }),
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { role: 'list', className: classes }),
	        (0, _map3.default)(items, function (item) {
	          return _ListItem2.default.create(item, { overrideProps: _this2.handleItemOverrides });
	        })
	      );
	    }
	  }]);
	  return List;
	}(_react.Component);
	
	List._meta = {
	  name: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	List.Content = _ListContent2.default;
	List.Description = _ListDescription2.default;
	List.Header = _ListHeader2.default;
	List.Icon = _ListIcon2.default;
	List.Item = _ListItem2.default;
	List.List = _ListList2.default;
	List.handledProps = ['animated', 'as', 'bulleted', 'celled', 'children', 'className', 'divided', 'floated', 'horizontal', 'inverted', 'items', 'link', 'onItemClick', 'ordered', 'relaxed', 'selection', 'size', 'verticalAlign'];
	List.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A list can animate to set the current item apart from the list. */
	  animated: _propTypes2.default.bool,
	
	  /** A list can mark items with a bullet. */
	  bulleted: _propTypes2.default.bool,
	
	  /** A list can divide its items into cells. */
	  celled: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A list can show divisions between content. */
	  divided: _propTypes2.default.bool,
	
	  /** An list can be floated left or right. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** A list can be formatted to have items appear horizontally. */
	  horizontal: _propTypes2.default.bool,
	
	  /** A list can be inverted to appear on a dark background. */
	  inverted: _propTypes2.default.bool,
	
	  /** Shorthand array of props for ListItem. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A list can be specially formatted for navigation links. */
	  link: _propTypes2.default.bool,
	
	  /**
	   * onClick handler for ListItem. Mutually exclusive with children.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All item props.
	   */
	  onItemClick: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes2.default.func]),
	
	  /** A list can be ordered numerically. */
	  ordered: _propTypes2.default.bool,
	
	  /** A list can relax its padding to provide more negative space. */
	  relaxed: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])]),
	
	  /** A selection list formats list items as possible choices. */
	  selection: _propTypes2.default.bool,
	
	  /** A list can vary in size. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES),
	
	  /** An element inside a list can be vertically aligned. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	exports.default = List;

/***/ },
/* 3830 */
[4514, 3829],
/* 3831 */
[4515, 12, 11],
/* 3832 */
[4516, 3831],
/* 3833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A rail is used to show accompanying content outside the boundaries of the main view of a site.
	 */
	function Rail(props) {
	  var attached = props.attached,
	      children = props.children,
	      className = props.className,
	      close = props.close,
	      dividing = props.dividing,
	      internal = props.internal,
	      position = props.position,
	      size = props.size;
	
	
	  var classes = (0, _classnames2.default)('ui', position, size, (0, _lib.useKeyOnly)(attached, 'attached'), (0, _lib.useKeyOnly)(dividing, 'dividing'), (0, _lib.useKeyOnly)(internal, 'internal'), (0, _lib.useKeyOrValueAndKey)(close, 'close'), 'rail', className);
	  var rest = (0, _lib.getUnhandledProps)(Rail, props);
	  var ElementType = (0, _lib.getElementType)(Rail, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Rail.handledProps = ['as', 'attached', 'children', 'className', 'close', 'dividing', 'internal', 'position', 'size'];
	Rail._meta = {
	  name: 'Rail',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Rail.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A rail can appear attached to the main viewport. */
	  attached: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A rail can appear closer to the main viewport. */
	  close: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])]),
	
	  /** A rail can create a division between itself and a container. */
	  dividing: _propTypes2.default.bool,
	
	  /** A rail can attach itself to the inside of a container. */
	  internal: _propTypes2.default.bool,
	
	  /** A rail can be presented on the left or right side of a container. */
	  position: _propTypes2.default.oneOf(_lib.SUI.FLOATS).isRequired,
	
	  /** A rail can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : {};
	
	exports.default = Rail;

/***/ },
/* 3834 */
[4517, 3833],
/* 3835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _RevealContent = __webpack_require__(1667);
	
	var _RevealContent2 = _interopRequireDefault(_RevealContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A reveal displays additional content in place of previous content when activated.
	 */
	function Reveal(props) {
	  var active = props.active,
	      animated = props.animated,
	      children = props.children,
	      className = props.className,
	      disabled = props.disabled,
	      instant = props.instant;
	
	
	  var classes = (0, _classnames2.default)('ui', animated, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(instant, 'instant'), 'reveal', className);
	  var rest = (0, _lib.getUnhandledProps)(Reveal, props);
	  var ElementType = (0, _lib.getElementType)(Reveal, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Reveal.handledProps = ['active', 'animated', 'as', 'children', 'className', 'disabled', 'instant'];
	Reveal._meta = {
	  name: 'Reveal',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Reveal.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** An active reveal displays its hidden content. */
	  active: _propTypes2.default.bool,
	
	  /** An animation name that will be applied to Reveal. */
	  animated: _propTypes2.default.oneOf(['fade', 'small fade', 'move', 'move right', 'move up', 'move down', 'rotate', 'rotate left']),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A disabled reveal will not animate when hovered. */
	  disabled: _propTypes2.default.bool,
	
	  /** An element can show its content without delay. */
	  instant: _propTypes2.default.bool
	} : {};
	
	Reveal.Content = _RevealContent2.default;
	
	exports.default = Reveal;

/***/ },
/* 3836 */
[4518, 3835],
/* 3837 */
[4519, 1668],
/* 3838 */
[4520, 1670],
/* 3839 */
[4521, 1766, 522, 1777, 821, 520, 116, 4047, 187, 820, 48],
/* 3840 */
[4522, 4041, 4031, 4029, 1769, 4027, 4030, 1770, 4045],
/* 3841 */
[4523, 524, 116, 781],
/* 3842 */
[4524, 187, 116, 272, 821, 4054],
/* 3843 */
[4525, 1767, 828],
/* 3844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useWidthProp = exports.useVerticalAlignProp = exports.useTextAlignProp = exports.useOnlyProp = exports.useKeyOrValueAndKey = exports.useValueAndKey = exports.useKeyOnly = undefined;
	
	var _typeof2 = __webpack_require__(131);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _numberToWord = __webpack_require__(781);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * There are 3 prop patterns used to build up the className for a component.
	 * Each utility here is meant for use in a classnames() argument.
	 *
	 * There is no util for valueOnly() because it would simply return val.
	 * Use the prop value inline instead.
	 *   <Label size='big' />
	 *   <div class="ui big label"></div>
	 */
	
	/**
	 * Props where only the prop key is used in the className.
	 * @param {*} val A props value
	 * @param {string} key A props key
	 *
	 * @example
	 * <Label tag />
	 * <div class="ui tag label"></div>
	 */
	var useKeyOnly = exports.useKeyOnly = function useKeyOnly(val, key) {
	  return val && key;
	};
	
	/**
	 * Props that require both a key and value to create a className.
	 * @param {*} val A props value
	 * @param {string} key A props key
	 *
	 * @example
	 * <Label corner='left' />
	 * <div class="ui left corner label"></div>
	 */
	var useValueAndKey = exports.useValueAndKey = function useValueAndKey(val, key) {
	  return val && val !== true && val + ' ' + key;
	};
	
	/**
	 * Props whose key will be used in className, or value and key.
	 * @param {*} val A props value
	 * @param {string} key A props key
	 *
	 * @example Key Only
	 * <Label pointing />
	 * <div class="ui pointing label"></div>
	 *
	 * @example Key and Value
	 * <Label pointing='left' />
	 * <div class="ui left pointing label"></div>
	 */
	var useKeyOrValueAndKey = exports.useKeyOrValueAndKey = function useKeyOrValueAndKey(val, key) {
	  return val && (val === true ? key : val + ' ' + key);
	};
	
	//
	// Prop to className exceptions
	//
	
	/**
	 * The "only" prop implements control of visibility classes for Grid subcomponents.
	 *
	 * @param {*} val The value of the "only" prop
	 *
	 * @example
	 * <Grid.Row only='mobile' />
	 * <Grid.Row only='mobile tablet' />
	 * <div class="mobile only row"></div>
	 * <div class="mobile only tablet only row"></div>
	 */
	var useOnlyProp = exports.useOnlyProp = function useOnlyProp(val) {
	  if (!val || val === true) return null;
	
	  return val.replace('large screen', 'large-screen').split(' ').map(function (prop) {
	    return prop.replace('-', ' ') + ' only';
	  }).join(' ');
	};
	
	/**
	 * The "textAlign" prop follows the useValueAndKey except when the value is "justified'.
	 * In this case, only the class "justified" is used, ignoring the "aligned" class.
	 * @param {*} val The value of the "textAlign" prop
	 *
	 * @example
	 * <Container textAlign='justified' />
	 * <div class="ui justified container"></div>
	 *
	 * @example
	 * <Container textAlign='left' />
	 * <div class="ui left aligned container"></div>
	 */
	var useTextAlignProp = exports.useTextAlignProp = function useTextAlignProp(val) {
	  return val === 'justified' ? 'justified' : useValueAndKey(val, 'aligned');
	};
	
	/**
	 * The "verticalAlign" prop follows the useValueAndKey.
	 *
	 * @param {*} val The value of the "verticalAlign" prop
	 *
	 * @example
	 * <Grid verticalAlign='middle' />
	 * <div class="ui middle aligned grid"></div>
	 */
	var useVerticalAlignProp = exports.useVerticalAlignProp = function useVerticalAlignProp(val) {
	  return useValueAndKey(val, 'aligned');
	};
	
	/**
	 * Create "X", "X wide" and "equal width" classNames.
	 * "X" is a numberToWord value and "wide" is configurable.
	 * @param {*} val The prop value
	 * @param {string} [widthClass=''] The class
	 * @param {boolean} [canEqual=false] Flag that indicates possibility of "equal" value
	 *
	 * @example
	 * <Grid columns='equal' />
	 * <div class="ui equal width grid"></div>
	 *
	 * <Form widths='equal' />
	 * <div class="ui equal width form"></div>
	 *
	 * <FieldGroup widths='equal' />
	 * <div class="equal width fields"></div>
	 *
	 * @example
	 * <Grid columns={4} />
	 * <div class="ui four column grid"></div>
	 */
	var useWidthProp = exports.useWidthProp = function useWidthProp(val) {
	  var widthClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var canEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (canEqual && val === 'equal') {
	    return 'equal width';
	  }
	  var valType = typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val);
	  if ((valType === 'string' || valType === 'number') && widthClass) {
	    return (0, _numberToWord.numberToWord)(val) + ' ' + widthClass;
	  }
	  return (0, _numberToWord.numberToWord)(val);
	};

/***/ },
/* 3845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deprecate = exports.collectionShorthand = exports.itemShorthand = exports.contentShorthand = exports.onlyProp = exports.demand = exports.givenProps = exports.some = exports.every = exports.disallow = exports.suggest = exports.as = undefined;
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _difference2 = __webpack_require__(4028);
	
	var _difference3 = _interopRequireDefault(_difference2);
	
	var _trim2 = __webpack_require__(4044);
	
	var _trim3 = _interopRequireDefault(_trim2);
	
	var _isObject2 = __webpack_require__(4034);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _pick2 = __webpack_require__(4039);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _keys2 = __webpack_require__(4036);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _isPlainObject2 = __webpack_require__(4035);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isFunction2 = __webpack_require__(4032);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _compact2 = __webpack_require__(4026);
	
	var _compact3 = _interopRequireDefault(_compact2);
	
	var _take2 = __webpack_require__(4043);
	
	var _take3 = _interopRequireDefault(_take2);
	
	var _sortBy2 = __webpack_require__(4040);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _sum2 = __webpack_require__(4042);
	
	var _sum3 = _interopRequireDefault(_sum2);
	
	var _min2 = __webpack_require__(4038);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _map2 = __webpack_require__(4037);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _flow2 = __webpack_require__(1769);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _includes2 = __webpack_require__(1770);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _isNil2 = __webpack_require__(4033);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _leven = __webpack_require__(1673);
	
	var _leven2 = _interopRequireDefault(_leven);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var typeOf = function typeOf() {
	  var _Object$prototype$toS;
	
	  return (_Object$prototype$toS = Object.prototype.toString).call.apply(_Object$prototype$toS, arguments);
	};
	
	/**
	 * Ensure a component can render as a give prop value.
	 */
	var as = exports.as = function as() {
	  return _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).apply(undefined, arguments);
	};
	
	/**
	 * Similar to PropTypes.oneOf but shows closest matches.
	 * Word order is ignored allowing `left chevron` to match `chevron left`.
	 * Useful for very large lists of options (e.g. Icon name, Flag name, etc.)
	 * @param {string[]} suggestions An array of allowed values.
	 */
	var suggest = exports.suggest = function suggest(suggestions) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(suggestions)) {
	      throw new Error(['Invalid argument supplied to suggest, expected an instance of array.', ' See `' + propName + '` prop in `' + componentName + '`.'].join(''));
	    }
	    var propValue = props[propName];
	
	    // skip if prop is undefined or is included in the suggestions
	    if ((0, _isNil3.default)(propValue) || propValue === false || (0, _includes3.default)(propValue, suggestions)) return;
	
	    // find best suggestions
	    var propValueWords = propValue.split(' ');
	
	    /* eslint-disable max-nested-callbacks */
	    var bestMatches = (0, _flow3.default)((0, _map3.default)(function (suggestion) {
	      var suggestionWords = suggestion.split(' ');
	
	      var propValueScore = (0, _flow3.default)((0, _map3.default)(function (x) {
	        return (0, _map3.default)(function (y) {
	          return (0, _leven2.default)(x, y);
	        }, suggestionWords);
	      }), (0, _map3.default)(_min3.default), _sum3.default)(propValueWords);
	
	      var suggestionScore = (0, _flow3.default)((0, _map3.default)(function (x) {
	        return (0, _map3.default)(function (y) {
	          return (0, _leven2.default)(x, y);
	        }, propValueWords);
	      }), (0, _map3.default)(_min3.default), _sum3.default)(suggestionWords);
	
	      return { suggestion: suggestion, score: propValueScore + suggestionScore };
	    }), (0, _sortBy3.default)(['score', 'suggestion']), (0, _take3.default)(3))(suggestions);
	    /* eslint-enable max-nested-callbacks */
	
	    // skip if a match scored 0
	    // since we're matching on words (classNames) this allows any word order to pass validation
	    // e.g. `left chevron` vs `chevron left`
	    if (bestMatches.some(function (x) {
	      return x.score === 0;
	    })) return;
	
	    return new Error(['Invalid prop `' + propName + '` of value `' + propValue + '` supplied to `' + componentName + '`.', '\n\nInstead of `' + propValue + '`, did you mean:', bestMatches.map(function (x) {
	      return '\n  - ' + x.suggestion;
	    }).join(''), '\n'].join(''));
	  };
	};
	
	/**
	 * Disallow other props form being defined with this prop.
	 * @param {string[]} disallowedProps An array of props that cannot be used with this prop.
	 */
	var disallow = exports.disallow = function disallow(disallowedProps) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(disallowedProps)) {
	      throw new Error(['Invalid argument supplied to disallow, expected an instance of array.', ' See `' + propName + '` prop in `' + componentName + '`.'].join(''));
	    }
	
	    // skip if prop is undefined
	    if ((0, _isNil3.default)(props[propName]) || props[propName] === false) return;
	
	    // find disallowed props with values
	    var disallowed = disallowedProps.reduce(function (acc, disallowedProp) {
	      if (!(0, _isNil3.default)(props[disallowedProp]) && props[disallowedProp] !== false) {
	        return [].concat((0, _toConsumableArray3.default)(acc), [disallowedProp]);
	      }
	      return acc;
	    }, []);
	
	    if (disallowed.length > 0) {
	      return new Error(['Prop `' + propName + '` in `' + componentName + '` conflicts with props: `' + disallowed.join('`, `') + '`.', 'They cannot be defined together, choose one or the other.'].join(' '));
	    }
	  };
	};
	
	/**
	 * Ensure a prop adherers to multiple prop type validators.
	 * @param {function[]} validators An array of propType functions.
	 */
	var every = exports.every = function every(validators) {
	  return function (props, propName, componentName) {
	    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      rest[_key - 3] = arguments[_key];
	    }
	
	    if (!Array.isArray(validators)) {
	      throw new Error(['Invalid argument supplied to every, expected an instance of array.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    var errors = (0, _flow3.default)((0, _map3.default)(function (validator) {
	      if (typeof validator !== 'function') {
	        throw new Error('every() argument "validators" should contain functions, found: ' + typeOf(validator) + '.');
	      }
	      return validator.apply(undefined, [props, propName, componentName].concat(rest));
	    }), _compact3.default)(validators);
	
	    // we can only return one error at a time
	    return errors[0];
	  };
	};
	
	/**
	 * Ensure a prop adherers to at least one of the given prop type validators.
	 * @param {function[]} validators An array of propType functions.
	 */
	var some = exports.some = function some(validators) {
	  return function (props, propName, componentName) {
	    for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      rest[_key2 - 3] = arguments[_key2];
	    }
	
	    if (!Array.isArray(validators)) {
	      throw new Error(['Invalid argument supplied to some, expected an instance of array.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    var errors = (0, _compact3.default)((0, _map3.default)(validators, function (validator) {
	      if (!(0, _isFunction3.default)(validator)) {
	        throw new Error('some() argument "validators" should contain functions, found: ' + typeOf(validator) + '.');
	      }
	      return validator.apply(undefined, [props, propName, componentName].concat(rest));
	    }));
	
	    // fail only if all validators failed
	    if (errors.length === validators.length) {
	      var error = new Error('One of these validators must pass:');
	      error.message += '\n' + (0, _map3.default)(errors, function (err, i) {
	        return '[' + (i + 1) + ']: ' + err.message;
	      }).join('\n');
	      return error;
	    }
	  };
	};
	
	/**
	 * Ensure a validator passes only when a component has a given propsShape.
	 * @param {object} propsShape An object describing the prop shape.
	 * @param {function} validator A propType function.
	 */
	var givenProps = exports.givenProps = function givenProps(propsShape, validator) {
	  return function (props, propName, componentName) {
	    for (var _len3 = arguments.length, rest = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	      rest[_key3 - 3] = arguments[_key3];
	    }
	
	    if (!(0, _isPlainObject3.default)(propsShape)) {
	      throw new Error(['Invalid argument supplied to givenProps, expected an object.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    if (typeof validator !== 'function') {
	      throw new Error(['Invalid argument supplied to givenProps, expected a function.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    var shouldValidate = (0, _keys3.default)(propsShape).every(function (key) {
	      var val = propsShape[key];
	      // require propShape validators to pass or prop values to match
	      return typeof val === 'function' ? !val.apply(undefined, [props, key, componentName].concat(rest)) : val === props[propName];
	    });
	
	    if (!shouldValidate) return;
	
	    var error = validator.apply(undefined, [props, propName, componentName].concat(rest));
	
	    if (error) {
	      // poor mans shallow pretty print, prevents JSON circular reference errors
	      var prettyProps = '{ ' + (0, _keys3.default)((0, _pick3.default)((0, _keys3.default)(propsShape), props)).map(function (key) {
	        var val = props[key];
	        var renderedValue = val;
	        if (typeof val === 'string') renderedValue = '"' + val + '"';else if (Array.isArray(val)) renderedValue = '[' + val.join(', ') + ']';else if ((0, _isObject3.default)(val)) renderedValue = '{...}';
	
	        return key + ': ' + renderedValue;
	      }).join(', ') + ' }';
	
	      error.message = 'Given props ' + prettyProps + ': ' + error.message;
	      return error;
	    }
	  };
	};
	
	/**
	 * Define prop dependencies by requiring other props.
	 * @param {string[]} requiredProps An array of required prop names.
	 */
	var demand = exports.demand = function demand(requiredProps) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(requiredProps)) {
	      throw new Error(['Invalid `requiredProps` argument supplied to require, expected an instance of array.', ' See `' + propName + '` prop in `' + componentName + '`.'].join(''));
	    }
	
	    // skip if prop is undefined
	    if (props[propName] === undefined) return;
	
	    var missingRequired = requiredProps.filter(function (requiredProp) {
	      return props[requiredProp] === undefined;
	    });
	    if (missingRequired.length > 0) {
	      return new Error('`' + propName + '` prop in `' + componentName + '` requires props: `' + missingRequired.join('`, `') + '`.');
	    }
	  };
	};
	
	/**
	 * Ensure an only prop contains a string with only possible values.
	 * @param {string[]} possible An array of possible values to prop.
	 */
	var onlyProp = exports.onlyProp = function onlyProp(possible) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(possible)) {
	      throw new Error(['Invalid argument supplied to some, expected an instance of array.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    var propValue = props[propName];
	
	    // skip if prop is undefined
	    if ((0, _isNil3.default)(propValue) || propValue === false) return;
	
	    var values = propValue.replace('large screen', 'large-screen').split(' ').map(function (val) {
	      return (0, _trim3.default)(val).replace('-', ' ');
	    });
	    var invalid = (0, _difference3.default)(values, possible);
	
	    // fail only if there are invalid values
	    if (invalid.length > 0) {
	      return new Error('`' + propName + '` prop in `' + componentName + '` has invalid values: `' + invalid.join('`, `') + '`.');
	    }
	  };
	};
	
	/**
	 * Ensure a component can render as a node passed as a prop value in place of children.
	 */
	var contentShorthand = exports.contentShorthand = function contentShorthand() {
	  return every([disallow(['children']), _propTypes2.default.node]).apply(undefined, arguments);
	};
	
	/**
	 * Item shorthand is a description of a component that can be a literal,
	 * a props object, or an element.
	 */
	var itemShorthand = exports.itemShorthand = function itemShorthand() {
	  return every([disallow(['children']), _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object]))])]).apply(undefined, arguments);
	};
	
	/**
	 * Collection shorthand ensures a prop is an array of item shorthand.
	 */
	var collectionShorthand = exports.collectionShorthand = function collectionShorthand() {
	  return every([disallow(['children']), _propTypes2.default.arrayOf(itemShorthand)]).apply(undefined, arguments);
	};
	
	/**
	 * Show a deprecated warning for component props with a help message and optional validator.
	 * @param {string} help A help message to display with the deprecation warning.
	 * @param {function} [validator] A propType function.
	 */
	var deprecate = exports.deprecate = function deprecate(help, validator) {
	  return function (props, propName, componentName) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
	      args[_key4 - 3] = arguments[_key4];
	    }
	
	    if (typeof help !== 'string') {
	      throw new Error(['Invalid `help` argument supplied to deprecate, expected a string.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	    }
	
	    // skip if prop is undefined
	    if (props[propName] === undefined) return;
	
	    // deprecation error and help
	    var error = new Error('The `' + propName + '` prop in `' + componentName + '` is deprecated.');
	    if (help) error.message += ' ' + help;
	
	    // add optional validation error message
	    if (validator) {
	      if (typeof validator === 'function') {
	        var validationError = validator.apply(undefined, [props, propName, componentName].concat(args));
	        if (validationError) {
	          error.message = error.message + ' ' + validationError.message;
	        }
	      } else {
	        throw new Error(['Invalid argument supplied to deprecate, expected a function.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
	      }
	    }
	
	    return error;
	  };
	};

/***/ },
/* 3846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.debug = exports.makeDebugger = undefined;
	
	var _isBrowser = __webpack_require__(780);
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (_isBrowser2.default && ("production") !== 'production' && ("production") !== 'test') {
	  // Heads Up!
	  // https://github.com/visionmedia/debug/pull/331
	  //
	  // debug now clears storage on load, grab the debug settings before require('debug').
	  // We try/catch here as Safari throws on localStorage access in private mode or with cookies disabled.
	  var DEBUG = void 0;
	  try {
	    DEBUG = window.localStorage.debug;
	  } catch (e) {
	    /* eslint-disable no-console */
	    console.error('Semantic-UI-React could not enable debug.');
	    console.error(e);
	    /* eslint-enable no-console */
	  }
	
	  // enable what ever settings we got from storage
	}
	
	/**
	 * Create a namespaced debug function.
	 * @param {String} namespace Usually a component name.
	 * @example
	 * import { makeDebugger } from 'src/lib'
	 * const debug = makeDebugger('namespace')
	 *
	 * debug('Some message')
	 * @returns {Function}
	 */
	var makeDebugger = exports.makeDebugger = function makeDebugger(namespace) {};
	
	/**
	 * Default debugger, simple log.
	 * @example
	 * import { debug } from 'src/lib'
	 * debug('Some message')
	 */
	var debug = exports.debug = makeDebugger('log');

/***/ },
/* 3847 */
[4526, 42, 4061, 115, 1782, 520, 828, 187, 49, 826, 272],
/* 3848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _isBrowser = __webpack_require__(780);
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	var _EventTarget = __webpack_require__(3847);
	
	var _EventTarget2 = _interopRequireDefault(_EventTarget);
	
	var _normalizeTarget = __webpack_require__(3850);
	
	var _normalizeTarget2 = _interopRequireDefault(_normalizeTarget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventStack = function EventStack() {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, EventStack);
	  this._eventTargets = {};
	  this._targets = [];
	
	  this._find = function (target) {
	    var normalized = (0, _normalizeTarget2.default)(target);
	    var index = _this._targets.indexOf(normalized);
	
	    if (index !== -1) return _this._eventTargets[index];
	
	    index = _this._targets.push(normalized) - 1;
	    _this._eventTargets[index] = new _EventTarget2.default(normalized);
	
	    return _this._eventTargets[index];
	  };
	
	  this._remove = function (target) {
	    var normalized = (0, _normalizeTarget2.default)(target);
	    var index = _this._targets.indexOf(normalized);
	
	    _this._targets = (0, _without3.default)(_this._targets, normalized);
	    delete _this._eventTargets[index];
	  };
	
	  this.sub = function (name, handlers) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (!_isBrowser2.default) return;
	
	    var _options$target = options.target,
	        target = _options$target === undefined ? document : _options$target,
	        _options$pool = options.pool,
	        pool = _options$pool === undefined ? 'default' : _options$pool;
	
	    var eventTarget = _this._find(target);
	
	    eventTarget.sub(name, handlers, pool);
	  };
	
	  this.unsub = function (name, handlers) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (!_isBrowser2.default) return;
	
	    var _options$target2 = options.target,
	        target = _options$target2 === undefined ? document : _options$target2,
	        _options$pool2 = options.pool,
	        pool = _options$pool2 === undefined ? 'default' : _options$pool2;
	
	    var eventTarget = _this._find(target);
	
	    eventTarget.unsub(name, handlers, pool);
	    if (eventTarget.empty()) _this._remove(target);
	  };
	}
	
	// ------------------------------------
	// Target utils
	// ------------------------------------
	
	// ------------------------------------
	// Pub/sub
	// ------------------------------------
	
	;
	
	var instance = new EventStack();
	
	exports.default = instance;

/***/ },
/* 3849 */
[4527, 3848],
/* 3850 */
2847,
/* 3851 */
[4528, 1782, 224, 49, 341, 1772, 824, 4048, 91],
/* 3852 */
2849,
/* 3853 */
2850,
/* 3854 */
[4529, 189, 272],
/* 3855 */
[4530, 100, 1780],
/* 3856 */
2853,
/* 3857 */
2854,
/* 3858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(822);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _has2 = __webpack_require__(187);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _transform2 = __webpack_require__(4068);
	
	var _transform3 = _interopRequireDefault(_transform2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Naive and inefficient object difference, intended for development / debugging use only.
	 * Deleted keys are shown as [DELETED].
	 * @param {{}} source The source object
	 * @param {{}} target The target object.
	 * @returns {{}} A new object containing new/modified/deleted keys.
	 * @example
	 * import { objectDiff } from 'src/lib'
	 *
	 * const a = { key: 'val', foo: 'bar' }
	 * const b = { key: 'val', foo: 'baz' }
	 *
	 * objectDiff(a, b)
	 * //=> { foo: 'baz' }
	 */
	exports.default = function (source, target) {
	  return (0, _transform3.default)(source, function (res, val, key) {
	    // deleted keys
	    if (!(0, _has3.default)(target, key)) res[key] = '[DELETED]';
	    // new keys / changed values
	    else if (!(0, _isEqual3.default)(val, target[key])) res[key] = target[key];
	  }, {});
	};

/***/ },
/* 3859 */
2856,
/* 3860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _AccordionAccordion = __webpack_require__(1674);
	
	var _AccordionAccordion2 = _interopRequireDefault(_AccordionAccordion);
	
	var _AccordionContent = __webpack_require__(782);
	
	var _AccordionContent2 = _interopRequireDefault(_AccordionContent);
	
	var _AccordionTitle = __webpack_require__(783);
	
	var _AccordionTitle2 = _interopRequireDefault(_AccordionTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An accordion allows users to toggle the display of sections of content.
	 */
	function Accordion(props) {
	  var className = props.className,
	      fluid = props.fluid,
	      inverted = props.inverted,
	      styled = props.styled;
	
	
	  var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(styled, 'styled'), className);
	  var rest = (0, _lib.getUnhandledProps)(Accordion, props);
	
	  return _react2.default.createElement(_AccordionAccordion2.default, (0, _extends3.default)({}, rest, { className: classes }));
	}
	
	Accordion.handledProps = ['className', 'fluid', 'inverted', 'styled'];
	Accordion._meta = {
	  name: 'Accordion',
	  type: _lib.META.TYPES.MODULE
	};
	
	Accordion.propTypes =  false ? {
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Format to take up the width of it's container. */
	  fluid: _propTypes2.default.bool,
	
	  /** Format for dark backgrounds. */
	  inverted: _propTypes2.default.bool,
	
	  /** Adds some basic styling to accordion panels. */
	  styled: _propTypes2.default.bool
	} : {};
	
	Accordion.Accordion = _AccordionAccordion2.default;
	Accordion.Content = _AccordionContent2.default;
	Accordion.Title = _AccordionTitle2.default;
	
	exports.default = Accordion;

/***/ },
/* 3861 */
[4534, 48, 91, 12, 11],
/* 3862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Portal = __webpack_require__(488);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _DimmerDimmable = __webpack_require__(1675);
	
	var _DimmerDimmable2 = _interopRequireDefault(_DimmerDimmable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A dimmer hides distractions to focus attention on particular content.
	 */
	var Dimmer = function (_Component) {
	  (0, _inherits3.default)(Dimmer, _Component);
	
	  function Dimmer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Dimmer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Dimmer.__proto__ || Object.getPrototypeOf(Dimmer)).call.apply(_ref, [this].concat(args))), _this), _this.handlePortalMount = function () {
	      if (!_lib.isBrowser) return;
	
	      // Heads up, IE doesn't support second argument in add()
	      document.body.classList.add('dimmed');
	      document.body.classList.add('dimmable');
	    }, _this.handlePortalUnmount = function () {
	      if (!_lib.isBrowser) return;
	
	      // Heads up, IE doesn't support second argument in add()
	      document.body.classList.remove('dimmed');
	      document.body.classList.remove('dimmable');
	    }, _this.handleClick = function (e) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          onClickOutside = _this$props.onClickOutside;
	
	
	      if (onClick) onClick(e, _this.props);
	      if (_this.centerRef && _this.centerRef !== e.target && _this.centerRef.contains(e.target)) return;
	      if (onClickOutside) onClickOutside(e, _this.props);
	    }, _this.handleCenterRef = function (c) {
	      return _this.centerRef = c;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Dimmer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content,
	          disabled = _props.disabled,
	          inverted = _props.inverted,
	          page = _props.page,
	          simple = _props.simple;
	
	
	      var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(active, 'active transition visible'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(page, 'page'), (0, _lib.useKeyOnly)(simple, 'simple'), 'dimmer', className);
	      var rest = (0, _lib.getUnhandledProps)(Dimmer, this.props);
	      var ElementType = (0, _lib.getElementType)(Dimmer, this.props);
	
	      var childrenContent = _lib.childrenUtils.isNil(children) ? content : children;
	
	      var dimmerElement = _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        childrenContent && _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'center', ref: this.handleCenterRef },
	            childrenContent
	          )
	        )
	      );
	
	      if (page) {
	        return _react2.default.createElement(
	          _Portal2.default,
	          {
	            closeOnEscape: false,
	            closeOnDocumentClick: false,
	            onMount: this.handlePortalMount,
	            onUnmount: this.handlePortalUnmount,
	            open: active,
	            openOnTriggerClick: false
	          },
	          dimmerElement
	        );
	      }
	
	      return dimmerElement;
	    }
	  }]);
	  return Dimmer;
	}(_react.Component);
	
	Dimmer._meta = {
	  name: 'Dimmer',
	  type: _lib.META.TYPES.MODULE
	};
	Dimmer.Dimmable = _DimmerDimmable2.default;
	Dimmer.handledProps = ['active', 'as', 'children', 'className', 'content', 'disabled', 'inverted', 'onClick', 'onClickOutside', 'page', 'simple'];
	exports.default = Dimmer;
	Dimmer.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** An active dimmer will dim its parent container. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A disabled dimmer cannot be activated */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Handles click outside Dimmer's content, but inside Dimmer area.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClickOutside: _propTypes2.default.func,
	
	  /** A dimmer can be formatted to have its colors inverted. */
	  inverted: _propTypes2.default.bool,
	
	  /** A dimmer can be formatted to be fixed to the page. */
	  page: _propTypes2.default.bool,
	
	  /** A dimmer can be controlled with simple prop. */
	  simple: _propTypes2.default.bool
	} : {};
	
	
	Dimmer.create = (0, _lib.createShorthandFactory)(Dimmer, function (value) {
	  return { content: value };
	});

/***/ },
/* 3863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(574);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get3 = __webpack_require__(367);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _compact2 = __webpack_require__(1763);
	
	var _compact3 = _interopRequireDefault(_compact2);
	
	var _map2 = __webpack_require__(72);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _every2 = __webpack_require__(4020);
	
	var _every3 = _interopRequireDefault(_every2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _findIndex2 = __webpack_require__(1768);
	
	var _findIndex3 = _interopRequireDefault(_findIndex2);
	
	var _find2 = __webpack_require__(1767);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _reduce2 = __webpack_require__(1776);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _some2 = __webpack_require__(828);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _deburr2 = __webpack_require__(1765);
	
	var _deburr3 = _interopRequireDefault(_deburr2);
	
	var _escapeRegExp2 = __webpack_require__(4019);
	
	var _escapeRegExp3 = _interopRequireDefault(_escapeRegExp2);
	
	var _filter2 = __webpack_require__(821);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _isFunction2 = __webpack_require__(224);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _dropRight2 = __webpack_require__(4018);
	
	var _dropRight3 = _interopRequireDefault(_dropRight2);
	
	var _isEmpty2 = __webpack_require__(520);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _size2 = __webpack_require__(4062);
	
	var _size3 = _interopRequireDefault(_size2);
	
	var _union2 = __webpack_require__(4070);
	
	var _union3 = _interopRequireDefault(_union2);
	
	var _get5 = __webpack_require__(115);
	
	var _get6 = _interopRequireDefault(_get5);
	
	var _includes2 = __webpack_require__(189);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _isUndefined2 = __webpack_require__(522);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _has2 = __webpack_require__(187);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _isEqual2 = __webpack_require__(822);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isNil2 = __webpack_require__(91);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Icon = __webpack_require__(77);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Label = __webpack_require__(492);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _DropdownDivider = __webpack_require__(1677);
	
	var _DropdownDivider2 = _interopRequireDefault(_DropdownDivider);
	
	var _DropdownItem = __webpack_require__(1679);
	
	var _DropdownItem2 = _interopRequireDefault(_DropdownItem);
	
	var _DropdownHeader = __webpack_require__(1678);
	
	var _DropdownHeader2 = _interopRequireDefault(_DropdownHeader);
	
	var _DropdownMenu = __webpack_require__(1680);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownSearchInput = __webpack_require__(1681);
	
	var _DropdownSearchInput2 = _interopRequireDefault(_DropdownSearchInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getKeyOrValue = function getKeyOrValue(key, value) {
	  return (0, _isNil3.default)(key) ? value : key;
	};
	
	/**
	 * A dropdown allows a user to select a value from a series of options.
	 * @see Form
	 * @see Select
	 * @see Menu
	 */
	
	var Dropdown = function (_Component) {
	  (0, _inherits3.default)(Dropdown, _Component);
	
	  function Dropdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Dropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e, value) {
	      (0, _invoke3.default)(_this.props, 'onChange', e, (0, _extends3.default)({}, _this.props, { value: value }));
	    }, _this.closeOnChange = function (e) {
	      var _this$props = _this.props,
	          closeOnChange = _this$props.closeOnChange,
	          multiple = _this$props.multiple;
	
	      var shouldClose = (0, _isUndefined3.default)(closeOnChange) ? !multiple : closeOnChange;
	
	      if (shouldClose) _this.close(e);
	    }, _this.closeOnEscape = function (e) {
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Escape) return;
	      e.preventDefault();
	      _this.close();
	    }, _this.moveSelectionOnKeyDown = function (e) {
	      var _moves;
	
	      var _this$props2 = _this.props,
	          multiple = _this$props2.multiple,
	          selectOnNavigation = _this$props2.selectOnNavigation;
	
	      var moves = (_moves = {}, (0, _defineProperty3.default)(_moves, _lib.keyboardKey.ArrowDown, 1), (0, _defineProperty3.default)(_moves, _lib.keyboardKey.ArrowUp, -1), _moves);
	      var move = moves[_lib.keyboardKey.getCode(e)];
	
	      if (move === undefined) return;
	      e.preventDefault();
	      _this.moveSelectionBy(move);
	      if (!multiple && selectOnNavigation) _this.makeSelectedItemActive(e);
	    }, _this.openOnSpace = function (e) {
	
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Spacebar) return;
	      if (_this.state.open) return;
	
	      e.preventDefault();
	
	      _this.open(e);
	    }, _this.openOnArrow = function (e) {
	
	      var code = _lib.keyboardKey.getCode(e);
	      if (!(0, _includes3.default)([_lib.keyboardKey.ArrowDown, _lib.keyboardKey.ArrowUp], code)) return;
	      if (_this.state.open) return;
	
	      e.preventDefault();
	
	      _this.open(e);
	    }, _this.makeSelectedItemActive = function (e) {
	      var open = _this.state.open;
	      var multiple = _this.props.multiple;
	
	
	      var item = _this.getSelectedItem();
	      var value = (0, _get6.default)(item, 'value');
	
	      // prevent selecting null if there was no selected item value
	      // prevent selecting duplicate items when the dropdown is closed
	      if ((0, _isNil3.default)(value) || !open) return;
	
	      // state value may be undefined
	      var newValue = multiple ? (0, _union3.default)(_this.state.value, [value]) : value;
	
	      // notify the onChange prop that the user is trying to change value
	      _this.setValue(newValue);
	      _this.setSelectedIndex(newValue);
	      _this.handleChange(e, newValue);
	
	      // Heads up! This event handler should be called after `onChange`
	      // Notify the onAddItem prop if this is a new value
	      if (item['data-additional']) (0, _invoke3.default)(_this.props, 'onAddItem', e, (0, _extends3.default)({}, _this.props, { value: value }));
	    }, _this.selectItemOnEnter = function (e) {
	      var search = _this.props.search;
	
	
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Enter) return;
	      e.preventDefault();
	
	      var optionSize = (0, _size3.default)(_this.getMenuOptions());
	      if (search && optionSize === 0) return;
	
	      var item = _this.getSelectedItem();
	      var isAdditionItem = item['data-additional'];
	
	      _this.makeSelectedItemActive(e);
	      _this.closeOnChange(e);
	
	      if (isAdditionItem || optionSize === 1) _this.clearSearchQuery();
	      if (search && _this.searchRef) _this.searchRef.focus();
	    }, _this.removeItemOnBackspace = function (e) {
	      var _this$props3 = _this.props,
	          multiple = _this$props3.multiple,
	          search = _this$props3.search;
	      var _this$state = _this.state,
	          searchQuery = _this$state.searchQuery,
	          value = _this$state.value;
	
	
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Backspace) return;
	      if (searchQuery || !search || !multiple || (0, _isEmpty3.default)(value)) return;
	      e.preventDefault();
	
	      // remove most recent value
	      var newValue = (0, _dropRight3.default)(value);
	
	      _this.setValue(newValue);
	      _this.setSelectedIndex(newValue);
	      _this.handleChange(e, newValue);
	    }, _this.closeOnDocumentClick = function (e) {
	
	      if (!_this.props.closeOnBlur) return;
	
	      // If event happened in the dropdown, ignore it
	      if (_this.ref && (0, _isFunction3.default)(_this.ref.contains) && _this.ref.contains(e.target)) return;
	
	      _this.close();
	    }, _this.handleMouseDown = function (e) {
	
	      _this.isMouseDown = true;
	      _lib.eventStack.sub('mouseup', _this.handleDocumentMouseUp);
	      (0, _invoke3.default)(_this.props, 'onMouseDown', e, _this.props);
	    }, _this.handleDocumentMouseUp = function () {
	
	      _this.isMouseDown = false;
	      _lib.eventStack.unsub('mouseup', _this.handleDocumentMouseUp);
	    }, _this.handleClick = function (e) {
	      var _this$props4 = _this.props,
	          minCharacters = _this$props4.minCharacters,
	          search = _this$props4.search;
	      var _this$state2 = _this.state,
	          open = _this$state2.open,
	          searchQuery = _this$state2.searchQuery;
	
	
	      (0, _invoke3.default)(_this.props, 'onClick', e, _this.props);
	      // prevent closeOnDocumentClick()
	      e.stopPropagation();
	
	      if (!search) return _this.toggle(e);
	      if (open) return;
	      if (searchQuery.length >= minCharacters || minCharacters === 1) {
	        _this.open(e);
	        return;
	      }
	      if (_this.searchRef) _this.searchRef.focus();
	    }, _this.handleIconClick = function (e) {
	
	      (0, _invoke3.default)(_this.props, 'onClick', e, _this.props);
	      // prevent handleClick()
	      e.stopPropagation();
	      _this.toggle(e);
	    }, _this.handleItemClick = function (e, item) {
	      var _this$props5 = _this.props,
	          multiple = _this$props5.multiple,
	          search = _this$props5.search;
	      var value = item.value;
	
	      // prevent toggle() in handleClick()
	
	      e.stopPropagation();
	      // prevent closeOnDocumentClick() if multiple or item is disabled
	      if (multiple || item.disabled) e.nativeEvent.stopImmediatePropagation();
	      if (item.disabled) return;
	
	      var isAdditionItem = item['data-additional'];
	      var newValue = multiple ? (0, _union3.default)(_this.state.value, [value]) : value;
	
	      // notify the onChange prop that the user is trying to change value
	      _this.setValue(newValue);
	      _this.setSelectedIndex(value);
	
	      var optionSize = (0, _size3.default)(_this.getMenuOptions());
	      if (!multiple || isAdditionItem || optionSize === 1) _this.clearSearchQuery();
	
	      _this.handleChange(e, newValue);
	      _this.closeOnChange(e);
	
	      // Heads up! This event handler should be called after `onChange`
	      // Notify the onAddItem prop if this is a new value
	      if (isAdditionItem) (0, _invoke3.default)(_this.props, 'onAddItem', e, (0, _extends3.default)({}, _this.props, { value: value }));
	
	      if (multiple && search && _this.searchRef) _this.searchRef.focus();
	    }, _this.handleFocus = function (e) {
	      var focus = _this.state.focus;
	
	
	      if (focus) return;
	
	      (0, _invoke3.default)(_this.props, 'onFocus', e, _this.props);
	      _this.setState({ focus: true });
	    }, _this.handleBlur = function (e) {
	
	      // Heads up! Don't remove this.
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/1315
	      var currentTarget = (0, _get6.default)(e, 'currentTarget');
	      if (currentTarget && currentTarget.contains(document.activeElement)) return;
	
	      var _this$props6 = _this.props,
	          closeOnBlur = _this$props6.closeOnBlur,
	          multiple = _this$props6.multiple,
	          onBlur = _this$props6.onBlur,
	          selectOnBlur = _this$props6.selectOnBlur;
	      // do not "blur" when the mouse is down inside of the Dropdown
	
	      if (_this.isMouseDown) return;
	      if (onBlur) onBlur(e, _this.props);
	      if (selectOnBlur && !multiple) {
	        _this.makeSelectedItemActive(e);
	        if (closeOnBlur) _this.close();
	      }
	      _this.setState({ focus: false });
	      _this.clearSearchQuery();
	    }, _this.handleSearchChange = function (e, _ref2) {
	      var value = _ref2.value;
	
	
	      // prevent propagating to this.props.onChange()
	      e.stopPropagation();
	
	      var minCharacters = _this.props.minCharacters;
	      var open = _this.state.open;
	
	      var newQuery = value;
	
	      (0, _invoke3.default)(_this.props, 'onSearchChange', e, (0, _extends3.default)({}, _this.props, { searchQuery: newQuery }));
	      _this.trySetState({ searchQuery: newQuery }, { selectedIndex: 0 });
	
	      // open search dropdown on search query
	      if (!open && newQuery.length >= minCharacters) {
	        _this.open();
	        return;
	      }
	      // close search dropdown if search query is too small
	      if (open && minCharacters !== 1 && newQuery.length < minCharacters) _this.close();
	    }, _this.getMenuOptions = function () {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
	      var _this$props7 = _this.props,
	          multiple = _this$props7.multiple,
	          search = _this$props7.search,
	          allowAdditions = _this$props7.allowAdditions,
	          additionPosition = _this$props7.additionPosition,
	          additionLabel = _this$props7.additionLabel;
	      var searchQuery = _this.state.searchQuery;
	
	
	      var filteredOptions = options;
	
	      // filter out active options
	      if (multiple) {
	        filteredOptions = (0, _filter3.default)(filteredOptions, function (opt) {
	          return !(0, _includes3.default)(value, opt.value);
	        });
	      }
	
	      // filter by search query
	      if (search && searchQuery) {
	        if ((0, _isFunction3.default)(search)) {
	          filteredOptions = search(filteredOptions, searchQuery);
	        } else {
	          var re = new RegExp((0, _escapeRegExp3.default)(searchQuery), 'i');
	          // remove diacritics on search
	          filteredOptions = (0, _filter3.default)(filteredOptions, function (opt) {
	            return re.test((0, _deburr3.default)(opt.text));
	          });
	        }
	      }
	
	      // insert the "add" item
	      if (allowAdditions && search && searchQuery && !(0, _some3.default)(filteredOptions, { text: searchQuery })) {
	        var additionLabelElement = _react2.default.isValidElement(additionLabel) ? _react2.default.cloneElement(additionLabel, { key: 'addition-label' }) : additionLabel || '';
	
	        var addItem = {
	          key: 'addition',
	          // by using an array, we can pass multiple elements, but when doing so
	          // we must specify a `key` for React to know which one is which
	          text: [additionLabelElement, _react2.default.createElement(
	            'b',
	            { key: 'addition-query' },
	            searchQuery
	          )],
	          value: searchQuery,
	          className: 'addition',
	          'data-additional': true
	        };
	        if (additionPosition === 'top') filteredOptions.unshift(addItem);else filteredOptions.push(addItem);
	      }
	
	      return filteredOptions;
	    }, _this.getSelectedItem = function () {
	      var selectedIndex = _this.state.selectedIndex;
	
	      var options = _this.getMenuOptions();
	
	      return (0, _get6.default)(options, '[' + selectedIndex + ']');
	    }, _this.getEnabledIndices = function (givenOptions) {
	      var options = givenOptions || _this.getMenuOptions();
	
	      return (0, _reduce3.default)(options, function (memo, item, index) {
	        if (!item.disabled) memo.push(index);
	        return memo;
	      }, []);
	    }, _this.getItemByValue = function (value) {
	      var options = _this.props.options;
	
	
	      return (0, _find3.default)(options, { value: value });
	    }, _this.getMenuItemIndexByValue = function (value, givenOptions) {
	      var options = givenOptions || _this.getMenuOptions();
	
	      return (0, _findIndex3.default)(options, ['value', value]);
	    }, _this.getDropdownAriaOptions = function () {
	      var _this$props8 = _this.props,
	          loading = _this$props8.loading,
	          disabled = _this$props8.disabled,
	          search = _this$props8.search,
	          multiple = _this$props8.multiple;
	      var open = _this.state.open;
	
	      var ariaOptions = {
	        role: search ? 'combobox' : 'listbox',
	        'aria-busy': loading,
	        'aria-disabled': disabled,
	        'aria-expanded': !!open
	      };
	      if (ariaOptions.role === 'listbox') {
	        ariaOptions['aria-multiselectable'] = multiple;
	      }
	      return ariaOptions;
	    }, _this.clearSearchQuery = function () {
	      _this.trySetState({ searchQuery: '' });
	    }, _this.setValue = function (value) {
	      _this.trySetState({ value: value });
	    }, _this.setSelectedIndex = function () {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
	      var optionsProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
	      var multiple = _this.props.multiple;
	      var selectedIndex = _this.state.selectedIndex;
	
	      var options = _this.getMenuOptions(value, optionsProps);
	      var enabledIndicies = _this.getEnabledIndices(options);
	
	      var newSelectedIndex = void 0;
	
	      // update the selected index
	      if (!selectedIndex || selectedIndex < 0) {
	        var firstIndex = enabledIndicies[0];
	
	        // Select the currently active item, if none, use the first item.
	        // Multiple selects remove active items from the list,
	        // their initial selected index should be 0.
	        newSelectedIndex = multiple ? firstIndex : _this.getMenuItemIndexByValue(value, options) || enabledIndicies[0];
	      } else if (multiple) {
	        // multiple selects remove options from the menu as they are made active
	        // keep the selected index within range of the remaining items
	        if (selectedIndex >= options.length - 1) {
	          newSelectedIndex = enabledIndicies[enabledIndicies.length - 1];
	        }
	      } else {
	        var activeIndex = _this.getMenuItemIndexByValue(value, options);
	
	        // regular selects can only have one active item
	        // set the selected index to the currently active item
	        newSelectedIndex = (0, _includes3.default)(enabledIndicies, activeIndex) ? activeIndex : undefined;
	      }
	
	      if (!newSelectedIndex || newSelectedIndex < 0) {
	        newSelectedIndex = enabledIndicies[0];
	      }
	
	      _this.setState({ selectedIndex: newSelectedIndex });
	    }, _this.handleLabelClick = function (e, labelProps) {
	      // prevent focusing search input on click
	      e.stopPropagation();
	
	      _this.setState({ selectedLabel: labelProps.value });
	
	      var onLabelClick = _this.props.onLabelClick;
	
	      if (onLabelClick) onLabelClick(e, labelProps);
	    }, _this.handleLabelRemove = function (e, labelProps) {
	      // prevent focusing search input on click
	      e.stopPropagation();
	      var value = _this.state.value;
	
	      var newValue = (0, _without3.default)(value, labelProps.value);
	
	
	      _this.setValue(newValue);
	      _this.setSelectedIndex(newValue);
	      _this.handleChange(e, newValue);
	    }, _this.moveSelectionBy = function (offset) {
	      var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.selectedIndex;
	
	
	      var options = _this.getMenuOptions();
	      var lastIndex = options.length - 1;
	
	      // Prevent infinite loop
	      if ((0, _every3.default)(options, 'disabled')) return;
	
	      // next is after last, wrap to beginning
	      // next is before first, wrap to end
	      var nextIndex = startIndex + offset;
	      if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;
	
	      if (options[nextIndex].disabled) {
	        _this.moveSelectionBy(offset, nextIndex);
	        return;
	      }
	
	      _this.setState({ selectedIndex: nextIndex });
	      _this.scrollSelectedItemIntoView();
	    }, _this.handleIconOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e) {
	          (0, _invoke3.default)(predefinedProps, 'onClick', e, predefinedProps);
	          _this.handleIconClick(e);
	        }
	      };
	    }, _this.handleSearchRef = function (c) {
	      return _this.searchRef = c;
	    }, _this.handleSizerRef = function (c) {
	      return _this.sizerRef = c;
	    }, _this.handleRef = function (c) {
	      return _this.ref = c;
	    }, _this.computeSearchInputTabIndex = function () {
	      var _this$props9 = _this.props,
	          disabled = _this$props9.disabled,
	          tabIndex = _this$props9.tabIndex;
	
	
	      if (!(0, _isNil3.default)(tabIndex)) return tabIndex;
	      return disabled ? -1 : 0;
	    }, _this.computeSearchInputWidth = function () {
	      var searchQuery = _this.state.searchQuery;
	
	
	      if (_this.sizerRef && searchQuery) {
	        // resize the search input, temporarily show the sizer so we can measure it
	
	        _this.sizerRef.style.display = 'inline';
	        _this.sizerRef.textContent = searchQuery;
	        var searchWidth = Math.ceil(_this.sizerRef.getBoundingClientRect().width);
	        _this.sizerRef.style.removeProperty('display');
	
	        return searchWidth;
	      }
	    }, _this.computeTabIndex = function () {
	      var _this$props10 = _this.props,
	          disabled = _this$props10.disabled,
	          search = _this$props10.search,
	          tabIndex = _this$props10.tabIndex;
	
	      // don't set a root node tabIndex as the search input has its own tabIndex
	
	      if (search) return undefined;
	      if (disabled) return -1;
	      return (0, _isNil3.default)(tabIndex) ? 0 : tabIndex;
	    }, _this.scrollSelectedItemIntoView = function () {
	      if (!_this.ref) return;
	      var menu = _this.ref.querySelector('.menu.visible');
	      if (!menu) return;
	      var item = menu.querySelector('.item.selected');
	      if (!item) return;
	
	      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
	      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;
	
	      if (isOutOfUpperView) {
	        menu.scrollTop = item.offsetTop;
	      } else if (isOutOfLowerView) {
	        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
	      }
	    }, _this.open = function (e) {
	      var _this$props11 = _this.props,
	          disabled = _this$props11.disabled,
	          onOpen = _this$props11.onOpen,
	          search = _this$props11.search;
	
	      if (disabled) return;
	      if (search && _this.searchRef) _this.searchRef.focus();
	      if (onOpen) onOpen(e, _this.props);
	
	      _this.trySetState({ open: true });
	      _this.scrollSelectedItemIntoView();
	    }, _this.close = function (e) {
	      var onClose = _this.props.onClose;
	
	      if (onClose) onClose(e, _this.props);
	
	      _this.trySetState({ open: false });
	    }, _this.handleClose = function () {
	      var hasSearchFocus = document.activeElement === _this.searchRef;
	      var hasDropdownFocus = document.activeElement === _this.ref;
	      var hasFocus = hasSearchFocus || hasDropdownFocus;
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/627
	      // Blur the Dropdown on close so it is blurred after selecting an item.
	      // This is to prevent it from re-opening when switching tabs after selecting an item.
	      if (!hasSearchFocus) {
	        _this.ref.blur();
	      }
	
	      // We need to keep the virtual model in sync with the browser focus change
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/692
	      _this.setState({ focus: hasFocus });
	    }, _this.toggle = function (e) {
	      return _this.state.open ? _this.close(e) : _this.open(e);
	    }, _this.renderText = function () {
	      var _this$props12 = _this.props,
	          multiple = _this$props12.multiple,
	          placeholder = _this$props12.placeholder,
	          search = _this$props12.search,
	          text = _this$props12.text;
	      var _this$state3 = _this.state,
	          searchQuery = _this$state3.searchQuery,
	          value = _this$state3.value,
	          open = _this$state3.open;
	
	      var hasValue = multiple ? !(0, _isEmpty3.default)(value) : !(0, _isNil3.default)(value) && value !== '';
	
	      var classes = (0, _classnames2.default)(placeholder && !hasValue && 'default', 'text', search && searchQuery && 'filtered');
	      var _text = placeholder;
	      if (searchQuery) {
	        _text = null;
	      } else if (text) {
	        _text = text;
	      } else if (open && !multiple) {
	        _text = (0, _get6.default)(_this.getSelectedItem(), 'text');
	      } else if (hasValue) {
	        _text = (0, _get6.default)(_this.getItemByValue(value), 'text');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes, role: 'alert', 'aria-live': 'polite' },
	        _text
	      );
	    }, _this.renderSearchInput = function () {
	      var _this$props13 = _this.props,
	          search = _this$props13.search,
	          searchInput = _this$props13.searchInput;
	      var searchQuery = _this.state.searchQuery;
	
	
	      if (!search) return null;
	      return _DropdownSearchInput2.default.create(searchInput, { defaultProps: {
	          inputRef: _this.handleSearchRef,
	          onChange: _this.handleSearchChange,
	          style: { width: _this.computeSearchInputWidth() },
	          tabIndex: _this.computeSearchInputTabIndex(),
	          value: searchQuery
	        } });
	    }, _this.renderSearchSizer = function () {
	      var _this$props14 = _this.props,
	          search = _this$props14.search,
	          multiple = _this$props14.multiple;
	
	
	      if (!(search && multiple)) return null;
	      return _react2.default.createElement('span', { className: 'sizer', ref: _this.handleSizerRef });
	    }, _this.renderLabels = function () {
	      var _this$props15 = _this.props,
	          multiple = _this$props15.multiple,
	          renderLabel = _this$props15.renderLabel;
	      var _this$state4 = _this.state,
	          selectedLabel = _this$state4.selectedLabel,
	          value = _this$state4.value;
	
	      if (!multiple || (0, _isEmpty3.default)(value)) {
	        return;
	      }
	      var selectedItems = (0, _map3.default)(value, _this.getItemByValue);
	
	
	      // if no item could be found for a given state value the selected item will be undefined
	      // compact the selectedItems so we only have actual objects left
	      return (0, _map3.default)((0, _compact3.default)(selectedItems), function (item, index) {
	        var defaultProps = {
	          active: item.value === selectedLabel,
	          as: 'a',
	          key: getKeyOrValue(item.key, item.value),
	          onClick: _this.handleLabelClick,
	          onRemove: _this.handleLabelRemove,
	          value: item.value
	        };
	
	        return _Label2.default.create(renderLabel(item, index, defaultProps), { defaultProps: defaultProps });
	      });
	    }, _this.renderOptions = function () {
	      var _this$props16 = _this.props,
	          multiple = _this$props16.multiple,
	          search = _this$props16.search,
	          noResultsMessage = _this$props16.noResultsMessage;
	      var _this$state5 = _this.state,
	          selectedIndex = _this$state5.selectedIndex,
	          value = _this$state5.value;
	
	      var options = _this.getMenuOptions();
	
	      if (noResultsMessage !== null && search && (0, _isEmpty3.default)(options)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'message' },
	          noResultsMessage
	        );
	      }
	
	      var isActive = multiple ? function (optValue) {
	        return (0, _includes3.default)(value, optValue);
	      } : function (optValue) {
	        return optValue === value;
	      };
	
	      return (0, _map3.default)(options, function (opt, i) {
	        return _DropdownItem2.default.create((0, _extends3.default)({
	          active: isActive(opt.value),
	          onClick: _this.handleItemClick,
	          selected: selectedIndex === i
	        }, opt, {
	          key: getKeyOrValue(opt.key, opt.value),
	          // Needed for handling click events on disabled items
	          style: (0, _extends3.default)({}, opt.style, { pointerEvents: 'all' })
	        }));
	      });
	    }, _this.renderMenu = function () {
	      var _this$props17 = _this.props,
	          children = _this$props17.children,
	          header = _this$props17.header;
	      var open = _this.state.open;
	
	      var menuClasses = open ? 'visible' : '';
	      var ariaOptions = _this.getDropdownMenuAriaOptions();
	
	      // single menu child
	      if (!_lib.childrenUtils.isNil(children)) {
	        var menuChild = _react.Children.only(children);
	        var className = (0, _classnames2.default)(menuClasses, menuChild.props.className);
	
	        return (0, _react.cloneElement)(menuChild, (0, _extends3.default)({ className: className }, ariaOptions));
	      }
	
	      return _react2.default.createElement(
	        _DropdownMenu2.default,
	        (0, _extends3.default)({}, ariaOptions, { className: menuClasses }),
	        _DropdownHeader2.default.create(header),
	        _this.renderOptions()
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Dropdown, [{
	    key: 'getInitialAutoControlledState',
	    value: function getInitialAutoControlledState() {
	      return { searchQuery: '' };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _state = this.state,
	          open = _state.open,
	          value = _state.value;
	
	
	      this.setValue(value);
	      this.setSelectedIndex(value);
	
	      if (open) this.open();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _isEqual3.default)(nextProps, this.props) || !(0, _isEqual3.default)(nextState, this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get4.default)(Dropdown.prototype.__proto__ || Object.getPrototypeOf(Dropdown.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
	
	
	      /* eslint-disable no-console */
	      if (false) {
	        // in development, validate value type matches dropdown type
	        var isNextValueArray = Array.isArray(nextProps.value);
	        var hasValue = (0, _has3.default)(nextProps, 'value');
	
	        if (hasValue && nextProps.multiple && !isNextValueArray) {
	          console.error('Dropdown `value` must be an array when `multiple` is set.' + (' Received type: `' + Object.prototype.toString.call(nextProps.value) + '`.'));
	        } else if (hasValue && !nextProps.multiple && isNextValueArray) {
	          console.error('Dropdown `value` must not be an array when `multiple` is not set.' + ' Either set `multiple={true}` or use a string or number value.');
	        }
	      }
	      /* eslint-enable no-console */
	
	      if (!(0, _isEqual3.default)(nextProps.value, this.props.value)) {
	        this.setValue(nextProps.value);
	        this.setSelectedIndex(nextProps.value);
	      }
	
	      if (!(0, _isEqual3.default)(nextProps.options, this.props.options)) {
	        this.setSelectedIndex(undefined, nextProps.options);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	
	      // focused / blurred
	      // eslint-disable-line complexity
	      if (!prevState.focus && this.state.focus) {
	        if (!this.isMouseDown) {
	          var _props = this.props,
	              minCharacters = _props.minCharacters,
	              openOnFocus = _props.openOnFocus,
	              search = _props.search;
	
	          var openable = !search || search && minCharacters === 1;
	
	          if (openOnFocus && openable) this.open();
	        }
	        if (!this.state.open) {
	          _lib.eventStack.sub('keydown', [this.openOnArrow, this.openOnSpace]);
	        } else {
	          _lib.eventStack.sub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	        }
	        _lib.eventStack.sub('keydown', this.removeItemOnBackspace);
	      } else if (prevState.focus && !this.state.focus) {
	        var closeOnBlur = this.props.closeOnBlur;
	
	        if (!this.isMouseDown && closeOnBlur) {
	          this.close();
	        }
	        _lib.eventStack.unsub('keydown', [this.openOnArrow, this.openOnSpace, this.moveSelectionOnKeyDown, this.selectItemOnEnter, this.removeItemOnBackspace]);
	      }
	
	      // opened / closed
	      if (!prevState.open && this.state.open) {
	        _lib.eventStack.sub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter, this.removeItemOnBackspace]);
	        _lib.eventStack.sub('click', this.closeOnDocumentClick);
	        _lib.eventStack.unsub('keydown', [this.openOnArrow, this.openOnSpace]);
	        this.scrollSelectedItemIntoView();
	      } else if (prevState.open && !this.state.open) {
	        this.handleClose();
	        _lib.eventStack.unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	        _lib.eventStack.unsub('click', this.closeOnDocumentClick);
	        if (!this.state.focus) {
	          _lib.eventStack.unsub('keydown', this.removeItemOnBackspace);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	
	      _lib.eventStack.unsub('keydown', [this.openOnArrow, this.openOnSpace, this.moveSelectionOnKeyDown, this.selectItemOnEnter, this.removeItemOnBackspace, this.closeOnEscape]);
	      _lib.eventStack.unsub('click', this.closeOnDocumentClick);
	    }
	
	    // ----------------------------------------
	    // Document Event Handlers
	    // ----------------------------------------
	
	    // onChange needs to receive a value
	    // can't rely on props.value if we are controlled
	
	
	    // ----------------------------------------
	    // Component Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Getters
	    // ----------------------------------------
	
	    // There are times when we need to calculate the options based on a value
	    // that hasn't yet been persisted to state.
	
	  }, {
	    key: 'getDropdownMenuAriaOptions',
	    value: function getDropdownMenuAriaOptions() {
	      var _props2 = this.props,
	          search = _props2.search,
	          multiple = _props2.multiple;
	
	      var ariaOptions = {};
	
	      if (search) {
	        ariaOptions['aria-multiselectable'] = multiple;
	        ariaOptions.role = 'listbox';
	      }
	      return ariaOptions;
	    }
	
	    // ----------------------------------------
	    // Setters
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Overrides
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Refs
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Helpers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Behavior
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          basic = _props3.basic,
	          button = _props3.button,
	          className = _props3.className,
	          compact = _props3.compact,
	          disabled = _props3.disabled,
	          error = _props3.error,
	          fluid = _props3.fluid,
	          floating = _props3.floating,
	          icon = _props3.icon,
	          inline = _props3.inline,
	          item = _props3.item,
	          labeled = _props3.labeled,
	          loading = _props3.loading,
	          multiple = _props3.multiple,
	          pointing = _props3.pointing,
	          search = _props3.search,
	          selection = _props3.selection,
	          scrolling = _props3.scrolling,
	          simple = _props3.simple,
	          trigger = _props3.trigger,
	          upward = _props3.upward;
	      var open = this.state.open;
	
	      // Classes
	
	      var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(open, 'active visible'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(button, 'button'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(floating, 'floating'), (0, _lib.useKeyOnly)(inline, 'inline'),
	      // TODO: consider augmentation to render Dropdowns as Button/Menu, solves icon/link item issues
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/401#issuecomment-240487229
	      // TODO: the icon class is only required when a dropdown is a button
	      // useKeyOnly(icon, 'icon'),
	      (0, _lib.useKeyOnly)(labeled, 'labeled'), (0, _lib.useKeyOnly)(item, 'item'), (0, _lib.useKeyOnly)(multiple, 'multiple'), (0, _lib.useKeyOnly)(search, 'search'), (0, _lib.useKeyOnly)(selection, 'selection'), (0, _lib.useKeyOnly)(simple, 'simple'), (0, _lib.useKeyOnly)(scrolling, 'scrolling'), (0, _lib.useKeyOnly)(upward, 'upward'), (0, _lib.useKeyOrValueAndKey)(pointing, 'pointing'), 'dropdown', className);
	      var rest = (0, _lib.getUnhandledProps)(Dropdown, this.props);
	      var ElementType = (0, _lib.getElementType)(Dropdown, this.props);
	      var ariaOptions = this.getDropdownAriaOptions(ElementType, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, ariaOptions, {
	          className: classes,
	          onBlur: this.handleBlur,
	          onClick: this.handleClick,
	          onMouseDown: this.handleMouseDown,
	          onFocus: this.handleFocus,
	          onChange: this.handleChange,
	          tabIndex: this.computeTabIndex(),
	          ref: this.handleRef
	        }),
	        this.renderLabels(),
	        this.renderSearchInput(),
	        this.renderSearchSizer(),
	        trigger || this.renderText(),
	        _Icon2.default.create(icon, {
	          overrideProps: this.handleIconOverrides
	        }),
	        this.renderMenu()
	      );
	    }
	  }]);
	  return Dropdown;
	}(_lib.AutoControlledComponent);
	
	Dropdown.defaultProps = {
	  additionLabel: 'Add ',
	  additionPosition: 'top',
	  closeOnBlur: true,
	  icon: 'dropdown',
	  minCharacters: 1,
	  noResultsMessage: 'No results found.',
	  openOnFocus: true,
	  renderLabel: function renderLabel(_ref3) {
	    var text = _ref3.text;
	    return text;
	  },
	  searchInput: 'text',
	  selectOnBlur: true,
	  selectOnNavigation: true
	};
	Dropdown.autoControlledProps = ['open', 'searchQuery', 'selectedLabel', 'value'];
	Dropdown._meta = {
	  name: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	Dropdown.Divider = _DropdownDivider2.default;
	Dropdown.Header = _DropdownHeader2.default;
	Dropdown.Item = _DropdownItem2.default;
	Dropdown.Menu = _DropdownMenu2.default;
	Dropdown.SearchInput = _DropdownSearchInput2.default;
	Dropdown.handledProps = ['additionLabel', 'additionPosition', 'allowAdditions', 'as', 'basic', 'button', 'children', 'className', 'closeOnBlur', 'closeOnChange', 'compact', 'defaultOpen', 'defaultSearchQuery', 'defaultSelectedLabel', 'defaultValue', 'disabled', 'error', 'floating', 'fluid', 'header', 'icon', 'inline', 'item', 'labeled', 'loading', 'minCharacters', 'multiple', 'noResultsMessage', 'onAddItem', 'onBlur', 'onChange', 'onClick', 'onClose', 'onFocus', 'onLabelClick', 'onMouseDown', 'onOpen', 'onSearchChange', 'open', 'openOnFocus', 'options', 'placeholder', 'pointing', 'renderLabel', 'scrolling', 'search', 'searchInput', 'searchQuery', 'selectOnBlur', 'selectOnNavigation', 'selectedLabel', 'selection', 'simple', 'tabIndex', 'text', 'trigger', 'upward', 'value'];
	exports.default = Dropdown;
	Dropdown.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Label prefixed to an option added by a user. */
	  additionLabel: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
	
	  /** Position of the `Add: ...` option in the dropdown list ('top' or 'bottom'). */
	  additionPosition: _propTypes2.default.oneOf(['top', 'bottom']),
	
	  /**
	   * Allow user additions to the list of options (boolean).
	   * Requires the use of `selection`, `options` and `search`.
	   */
	  allowAdditions: _lib.customPropTypes.every([_lib.customPropTypes.demand(['options', 'selection', 'search']), _propTypes2.default.bool]),
	
	  /** A Dropdown can reduce its complexity. */
	  basic: _propTypes2.default.bool,
	
	  /** Format the Dropdown to appear as a button. */
	  button: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['options', 'selection']), _lib.customPropTypes.givenProps({ children: _propTypes2.default.any.isRequired }, _propTypes2.default.element.isRequired)]),
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Whether or not the menu should close when the dropdown is blurred. */
	  closeOnBlur: _propTypes2.default.bool,
	
	  /**
	   * Whether or not the menu should close when a value is selected from the dropdown.
	   * By default, multiple selection dropdowns will remain open on change, while single
	   * selection dropdowns will close on change.
	   */
	  closeOnChange: _propTypes2.default.bool,
	
	  /** A compact dropdown has no minimum width. */
	  compact: _propTypes2.default.bool,
	
	  /** Initial value of open. */
	  defaultOpen: _propTypes2.default.bool,
	
	  /** Initial value of searchQuery. */
	  defaultSearchQuery: _propTypes2.default.string,
	
	  /** Currently selected label in multi-select. */
	  defaultSelectedLabel: _lib.customPropTypes.every([_lib.customPropTypes.demand(['multiple']), _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])]),
	
	  /** Initial value or value array if multiple. */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))]),
	
	  /** A disabled dropdown menu or item does not allow user interaction. */
	  disabled: _propTypes2.default.bool,
	
	  /** An errored dropdown can alert a user to a problem. */
	  error: _propTypes2.default.bool,
	
	  /** A dropdown menu can contain floated content. */
	  floating: _propTypes2.default.bool,
	
	  /** A dropdown can take the full width of its parent */
	  fluid: _propTypes2.default.bool,
	
	  /** A dropdown menu can contain a header. */
	  header: _propTypes2.default.node,
	
	  /** Shorthand for Icon. */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object]),
	
	  /** A dropdown can be formatted to appear inline in other content. */
	  inline: _propTypes2.default.bool,
	
	  /** A dropdown can be formatted as a Menu item. */
	  item: _propTypes2.default.bool,
	
	  /** A dropdown can be labeled. */
	  labeled: _propTypes2.default.bool,
	
	  /** A dropdown can show that it is currently loading data. */
	  loading: _propTypes2.default.bool,
	
	  /** The minimum characters for a search to begin showing results. */
	  minCharacters: _propTypes2.default.number,
	
	  /** A selection dropdown can allow multiple selections. */
	  multiple: _propTypes2.default.bool,
	
	  /** Message to display when there are no results. */
	  noResultsMessage: _propTypes2.default.string,
	
	  /**
	   * Called when a user adds a new item. Use this to update the options list.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and the new item's value.
	   */
	  onAddItem: _propTypes2.default.func,
	
	  /**
	   * Called on blur.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * Called when the user attempts to change the value.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed value.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * Called on focus.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * Called when a multi-select label is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All label props.
	   */
	  onLabelClick: _propTypes2.default.func,
	
	  /**
	   * Called on mousedown.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * Called on search input change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props, includes current value of searchQuery.
	   */
	  onSearchChange: _propTypes2.default.func,
	
	  /** Controls whether or not the dropdown menu is displayed. */
	  open: _propTypes2.default.bool,
	
	  /** Whether or not the menu should open when the dropdown is focused. */
	  openOnFocus: _propTypes2.default.bool,
	
	  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
	  options: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes2.default.arrayOf(_propTypes2.default.shape(_DropdownItem2.default.propTypes))]),
	
	  /** Placeholder text. */
	  placeholder: _propTypes2.default.string,
	
	  /** A dropdown can be formatted so that its menu is pointing. */
	  pointing: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['left', 'right', 'top', 'top left', 'top right', 'bottom', 'bottom left', 'bottom right'])]),
	
	  /**
	   * Mapped over the active items and returns shorthand for the active item Labels.
	   * Only applies to `multiple` Dropdowns.
	   *
	   * @param {object} item - A currently active dropdown item.
	   * @param {number} index - The current index.
	   * @param {object} defaultLabelProps - The default props for an active item Label.
	   * @returns {*} Shorthand for a Label.
	   */
	  renderLabel: _propTypes2.default.func,
	
	  /** A dropdown can have its menu scroll. */
	  scrolling: _propTypes2.default.bool,
	
	  /**
	   * A selection dropdown can allow a user to search through a large list of choices.
	   * Pass a function here to replace the default search.
	   */
	  search: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
	
	  /** A shorthand for a search input. */
	  searchInput: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.node, _propTypes2.default.object]),
	
	  /** Current value of searchQuery. Creates a controlled component. */
	  searchQuery: _propTypes2.default.string,
	
	  // TODO 'searchInMenu' or 'search='in menu' or ???  How to handle this markup and functionality?
	
	  /** Define whether the highlighted item should be selected on blur. */
	  selectOnBlur: _propTypes2.default.bool,
	
	  /**
	   * Whether or not to change the value when navigating the menu using arrow keys.
	   * Setting to false will require enter or left click to confirm a choice.
	   */
	  selectOnNavigation: _propTypes2.default.bool,
	
	  /** Currently selected label in multi-select. */
	  selectedLabel: _lib.customPropTypes.every([_lib.customPropTypes.demand(['multiple']), _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])]),
	
	  /** A dropdown can be used to select between choices in a form. */
	  selection: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _lib.customPropTypes.demand(['options']), _propTypes2.default.bool]),
	
	  /** A simple dropdown can open without Javascript. */
	  simple: _propTypes2.default.bool,
	
	  /** A dropdown can receive focus. */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** The text displayed in the dropdown, usually for the active item. */
	  text: _propTypes2.default.string,
	
	  /** Custom element to trigger the menu to become visible. Takes place of 'text'. */
	  trigger: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['selection', 'text']), _propTypes2.default.node]),
	
	  /** Current value or value array if multiple. Creates a controlled component. */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))]),
	
	  /** A dropdown can open upward. */
	  upward: _propTypes2.default.bool
	} : {};

/***/ },
/* 3864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Icon = __webpack_require__(77);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An embed displays content from other websites like YouTube videos or Google Maps.
	 */
	var Embed = function (_Component) {
	  (0, _inherits3.default)(Embed, _Component);
	
	  function Embed() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Embed);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Embed.__proto__ || Object.getPrototypeOf(Embed)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	      var active = _this.state.active;
	
	
	      if (onClick) onClick(e, (0, _extends3.default)({}, _this.props, { active: true }));
	      if (!active) _this.trySetState({ active: true });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Embed, [{
	    key: 'getSrc',
	    value: function getSrc() {
	      var _props = this.props,
	          _props$autoplay = _props.autoplay,
	          autoplay = _props$autoplay === undefined ? true : _props$autoplay,
	          _props$brandedUI = _props.brandedUI,
	          brandedUI = _props$brandedUI === undefined ? false : _props$brandedUI,
	          _props$color = _props.color,
	          color = _props$color === undefined ? '#444444' : _props$color,
	          _props$hd = _props.hd,
	          hd = _props$hd === undefined ? true : _props$hd,
	          id = _props.id,
	          source = _props.source,
	          url = _props.url;
	
	
	      if (source === 'youtube') {
	        return ['//www.youtube.com/embed/' + id, '?autohide=true', '&amp;autoplay=' + autoplay, '&amp;color=' + encodeURIComponent(color), '&amp;hq=' + hd, '&amp;jsapi=false', '&amp;modestbranding=' + brandedUI].join('');
	      }
	
	      if (source === 'vimeo') {
	        return ['//player.vimeo.com/video/' + id, '?api=false', '&amp;autoplay=' + autoplay, '&amp;byline=false', '&amp;color=' + encodeURIComponent(color), '&amp;portrait=false', '&amp;title=false'].join('');
	      }
	
	      return url;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          aspectRatio = _props2.aspectRatio,
	          className = _props2.className,
	          icon = _props2.icon,
	          placeholder = _props2.placeholder;
	      var active = this.state.active;
	
	
	      var classes = (0, _classnames2.default)('ui', aspectRatio, (0, _lib.useKeyOnly)(active, 'active'), 'embed', className);
	      var rest = (0, _lib.getUnhandledProps)(Embed, this.props);
	      var ElementType = (0, _lib.getElementType)(Embed, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        _Icon2.default.create(icon),
	        placeholder && _react2.default.createElement('img', { className: 'placeholder', src: placeholder }),
	        this.renderEmbed()
	      );
	    }
	  }, {
	    key: 'renderEmbed',
	    value: function renderEmbed() {
	      var _props3 = this.props,
	          children = _props3.children,
	          iframe = _props3.iframe,
	          source = _props3.source;
	      var active = this.state.active;
	
	
	      if (!active) return null;
	      if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	        'div',
	        { className: 'embed' },
	        children
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'embed' },
	        (0, _lib.createHTMLIframe)(_lib.childrenUtils.isNil(iframe) ? this.getSrc() : iframe, {
	          defaultProps: {
	            allowFullScreen: false,
	            frameBorder: 0,
	            height: '100%',
	            scrolling: 'no',
	            src: this.getSrc(),
	            title: 'Embedded content from ' + source + '.',
	            width: '100%'
	          }
	        })
	      );
	    }
	  }]);
	  return Embed;
	}(_lib.AutoControlledComponent);
	
	Embed.autoControlledProps = ['active'];
	Embed.defaultProps = {
	  icon: 'video play'
	};
	Embed._meta = {
	  name: 'Embed',
	  type: _lib.META.TYPES.MODULE
	};
	Embed.handledProps = ['active', 'as', 'aspectRatio', 'autoplay', 'brandedUI', 'children', 'className', 'color', 'defaultActive', 'hd', 'icon', 'id', 'iframe', 'onClick', 'placeholder', 'source', 'url'];
	exports.default = Embed;
	Embed.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** An embed can be active. */
	  active: _propTypes2.default.bool,
	
	  /** An embed can specify an alternative aspect ratio. */
	  aspectRatio: _propTypes2.default.oneOf(['4:3', '16:9', '21:9']),
	
	  /** Setting to true or false will force autoplay. */
	  autoplay: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes2.default.bool]),
	
	  /** Whether to show networks branded UI like title cards, or after video calls to action. */
	  brandedUI: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes2.default.bool]),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Specifies a default chrome color with Vimeo or YouTube. */
	  color: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes2.default.string]),
	
	  /** Initial value of active. */
	  defaultActive: _propTypes2.default.bool,
	
	  /** Whether to show networks branded UI like title cards, or after video calls to action. */
	  hd: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes2.default.bool]),
	
	  /** Specifies an icon to use with placeholder content. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** Specifies an id for source. */
	  id: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes2.default.string]),
	
	  /** Shorthand for HTML iframe. */
	  iframe: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _lib.customPropTypes.itemShorthand]),
	
	  /**
	   * Сalled on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed value.
	   */
	  onClick: _propTypes2.default.func,
	
	  /** A placeholder image for embed. */
	  placeholder: _propTypes2.default.string,
	
	  /** Specifies a source to use. */
	  source: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['sourceUrl']), _propTypes2.default.oneOf(['youtube', 'vimeo'])]),
	
	  /** Specifies a url to use for embed. */
	  url: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['source']), _propTypes2.default.string])
	} : {};

/***/ },
/* 3865 */
[4541, 3864],
/* 3866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _pick2 = __webpack_require__(827);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _omit2 = __webpack_require__(1775);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Icon = __webpack_require__(77);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Portal = __webpack_require__(488);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalHeader = __webpack_require__(1685);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalContent = __webpack_require__(1683);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _ModalActions = __webpack_require__(1682);
	
	var _ModalActions2 = _interopRequireDefault(_ModalActions);
	
	var _ModalDescription = __webpack_require__(1684);
	
	var _ModalDescription2 = _interopRequireDefault(_ModalDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A modal displays content that temporarily blocks interactions with the main view of a site.
	 * @see Confirm
	 * @see Portal
	 */
	var Modal = function (_Component) {
	  (0, _inherits3.default)(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.getMountNode = function () {
	      return _lib.isBrowser ? _this.props.mountNode || document.body : null;
	    }, _this.handleActionsOverrides = function (predefinedProps) {
	      return {
	        onActionClick: function onActionClick(e, actionProps) {
	          (0, _invoke3.default)(predefinedProps, 'onActionClick', e, actionProps);
	          (0, _invoke3.default)(_this.props, 'onActionClick', e, _this.props);
	
	          _this.handleClose(e);
	        }
	      };
	    }, _this.handleClose = function (e) {
	      var onClose = _this.props.onClose;
	
	      if (onClose) onClose(e, _this.props);
	
	      _this.trySetState({ open: false });
	    }, _this.handleIconOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e) {
	          (0, _invoke3.default)(predefinedProps, 'onClick', e);
	          _this.handleClose(e);
	        }
	      };
	    }, _this.handleOpen = function (e) {
	      var onOpen = _this.props.onOpen;
	
	      if (onOpen) onOpen(e, _this.props);
	
	      _this.trySetState({ open: true });
	    }, _this.handlePortalMount = function (e) {
	      var dimmer = _this.props.dimmer;
	
	      var mountNode = _this.getMountNode();
	
	      if (dimmer) {
	        mountNode.classList.add('dimmable');
	        mountNode.classList.add('dimmed');
	
	        if (dimmer === 'blurring') {
	          mountNode.classList.add('blurring');
	        }
	      }
	
	      _this.setPosition();
	
	      var onMount = _this.props.onMount;
	
	      if (onMount) onMount(e, _this.props);
	    }, _this.handlePortalUnmount = function (e) {
	
	      // Always remove all dimmer classes.
	      // If the dimmer value changes while the modal is open, then removing its
	      // current value could leave cruft classes previously added.
	      var mountNode = _this.getMountNode();
	
	      // Heads up, IE doesn't support second argument in remove()
	      mountNode.classList.remove('blurring');
	      mountNode.classList.remove('dimmable');
	      mountNode.classList.remove('dimmed');
	      mountNode.classList.remove('scrolling');
	
	      cancelAnimationFrame(_this.animationRequestId);
	
	      var onUnmount = _this.props.onUnmount;
	
	      if (onUnmount) onUnmount(e, _this.props);
	    }, _this.handleRef = function (c) {
	      return _this.ref = c;
	    }, _this.setPosition = function () {
	      if (_this.ref) {
	        var mountNode = _this.getMountNode();
	
	        var _this$ref$getBounding = _this.ref.getBoundingClientRect(),
	            height = _this$ref$getBounding.height;
	
	        var marginTop = -Math.round(height / 2);
	        var scrolling = height >= window.innerHeight;
	
	        var newState = {};
	
	        if (_this.state.marginTop !== marginTop) {
	          newState.marginTop = marginTop;
	        }
	
	        if (_this.state.scrolling !== scrolling) {
	          newState.scrolling = scrolling;
	
	          if (scrolling) {
	            mountNode.classList.add('scrolling');
	          } else {
	            mountNode.classList.remove('scrolling');
	          }
	        }
	
	        if (Object.keys(newState).length > 0) _this.setState(newState);
	      }
	
	      _this.animationRequestId = requestAnimationFrame(_this.setPosition);
	    }, _this.renderContent = function (rest) {
	      var _this$props = _this.props,
	          actions = _this$props.actions,
	          basic = _this$props.basic,
	          children = _this$props.children,
	          className = _this$props.className,
	          closeIcon = _this$props.closeIcon,
	          content = _this$props.content,
	          header = _this$props.header,
	          size = _this$props.size,
	          style = _this$props.style;
	      var _this$state = _this.state,
	          marginTop = _this$state.marginTop,
	          scrolling = _this$state.scrolling;
	
	
	      var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(scrolling, 'scrolling'), 'modal transition visible active', className);
	      var ElementType = (0, _lib.getElementType)(Modal, _this.props);
	
	      var closeIconName = closeIcon === true ? 'close' : closeIcon;
	      var closeIconJSX = _Icon2.default.create(closeIconName, { overrideProps: _this.handleIconOverrides });
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, style: (0, _extends3.default)({ marginTop: marginTop }, style), ref: _this.handleRef }),
	          closeIconJSX,
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, style: (0, _extends3.default)({ marginTop: marginTop }, style), ref: _this.handleRef }),
	        closeIconJSX,
	        _ModalHeader2.default.create(header),
	        _ModalContent2.default.create(content),
	        _ModalActions2.default.create(actions, { overrideProps: _this.handleActionsOverrides })
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Modal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handlePortalUnmount();
	    }
	
	    // Do not access document when server side rendering
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var open = this.state.open;
	      var _props = this.props,
	          closeOnDimmerClick = _props.closeOnDimmerClick,
	          closeOnDocumentClick = _props.closeOnDocumentClick,
	          dimmer = _props.dimmer,
	          eventPool = _props.eventPool;
	
	      var mountNode = this.getMountNode();
	
	      // Short circuit when server side rendering
	      if (!_lib.isBrowser) return null;
	
	      var unhandled = (0, _lib.getUnhandledProps)(Modal, this.props);
	      var portalPropNames = _Portal2.default.handledProps;
	
	      var rest = (0, _omit3.default)(unhandled, portalPropNames);
	      var portalProps = (0, _pick3.default)(unhandled, portalPropNames);
	
	      // wrap dimmer modals
	      var dimmerClasses = !dimmer ? null : (0, _classnames2.default)('ui', dimmer === 'inverted' && 'inverted', 'page modals dimmer transition visible active');
	
	      // Heads up!
	      //
	      // The SUI CSS selector to prevent the modal itself from blurring requires an immediate .dimmer child:
	      // .blurring.dimmed.dimmable>:not(.dimmer) { ... }
	      //
	      // The .blurring.dimmed.dimmable is the body, so that all body content inside is blurred.
	      // We need the immediate child to be the dimmer to :not() blur the modal itself!
	      // Otherwise, the portal div is also blurred, blurring the modal.
	      //
	      // We cannot them wrap the modalJSX in an actual <Dimmer /> instead, we apply the dimmer classes to the <Portal />.
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        (0, _extends3.default)({
	          closeOnDocumentClick: closeOnDocumentClick,
	          closeOnRootNodeClick: closeOnDimmerClick
	        }, portalProps, {
	          className: dimmerClasses,
	          eventPool: eventPool,
	          mountNode: mountNode,
	          open: open,
	          onClose: this.handleClose,
	          onMount: this.handlePortalMount,
	          onOpen: this.handleOpen,
	          onUnmount: this.handlePortalUnmount
	        }),
	        this.renderContent(rest)
	      );
	    }
	  }]);
	  return Modal;
	}(_lib.AutoControlledComponent);
	
	Modal.defaultProps = {
	  dimmer: true,
	  closeOnDimmerClick: true,
	  closeOnDocumentClick: false,
	  eventPool: 'Modal'
	};
	Modal.autoControlledProps = ['open'];
	Modal._meta = {
	  name: 'Modal',
	  type: _lib.META.TYPES.MODULE
	};
	Modal.Header = _ModalHeader2.default;
	Modal.Content = _ModalContent2.default;
	Modal.Description = _ModalDescription2.default;
	Modal.Actions = _ModalActions2.default;
	Modal.handledProps = ['actions', 'as', 'basic', 'children', 'className', 'closeIcon', 'closeOnDimmerClick', 'closeOnDocumentClick', 'content', 'defaultOpen', 'dimmer', 'eventPool', 'header', 'mountNode', 'onActionClick', 'onClose', 'onMount', 'onOpen', 'onUnmount', 'open', 'size', 'style'];
	Modal.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Shorthand for Modal.Actions. Typically an array of button shorthand. */
	  actions: _lib.customPropTypes.itemShorthand,
	
	  /** A modal can reduce its complexity */
	  basic: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for the close icon. Closes the modal on click. */
	  closeIcon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object, _propTypes2.default.bool]),
	
	  /** Whether or not the Modal should close when the dimmer is clicked. */
	  closeOnDimmerClick: _propTypes2.default.bool,
	
	  /** Whether or not the Modal should close when the document is clicked. */
	  closeOnDocumentClick: _propTypes2.default.bool,
	
	  /** Simple text content for the Modal. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** Initial value of open. */
	  defaultOpen: _propTypes2.default.bool,
	
	  /** A Modal can appear in a dimmer. */
	  dimmer: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['inverted', 'blurring'])]),
	
	  /** Event pool namespace that is used to handle component events */
	  eventPool: _propTypes2.default.string,
	
	  /** Modal displayed above the content in bold. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** The node where the modal should mount. Defaults to document.body. */
	  mountNode: _propTypes2.default.any,
	
	  /**
	   * Action onClick handler when using shorthand `actions`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onActionClick: _propTypes2.default.func,
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * Called when the portal is mounted on the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _propTypes2.default.func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * Called when the portal is unmounted from the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _propTypes2.default.func,
	
	  /** Controls whether or not the Modal is displayed. */
	  open: _propTypes2.default.bool,
	
	  /** A modal can vary in size */
	  size: _propTypes2.default.oneOf(['fullscreen', 'large', 'mini', 'small', 'tiny']),
	
	  /** Custom styles. */
	  style: _propTypes2.default.object
	
	  /**
	   * NOTE: Any unhandled props that are defined in Portal are passed-through
	   * to the wrapping Portal.
	   */
	} : {};
	exports.default = Modal;

/***/ },
/* 3867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.POSITIONS = undefined;
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _pick2 = __webpack_require__(827);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _omit2 = __webpack_require__(1775);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _assign2 = __webpack_require__(4014);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _isArray2 = __webpack_require__(49);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _mapValues2 = __webpack_require__(1773);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _isNumber2 = __webpack_require__(1772);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _includes2 = __webpack_require__(189);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Portal = __webpack_require__(488);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _PopupContent = __webpack_require__(1687);
	
	var _PopupContent2 = _interopRequireDefault(_PopupContent);
	
	var _PopupHeader = __webpack_require__(1688);
	
	var _PopupHeader2 = _interopRequireDefault(_PopupHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var POSITIONS = exports.POSITIONS = ['top left', 'top right', 'bottom right', 'bottom left', 'right center', 'left center', 'top center', 'bottom center'];
	
	/**
	 * A Popup displays additional information on top of a page.
	 */
	
	var Popup = function (_Component) {
	  (0, _inherits3.default)(Popup, _Component);
	
	  function Popup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Popup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Popup.__proto__ || Object.getPrototypeOf(Popup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.hideOnScroll = function () {
	      _this.setState({ closed: true });
	
	      _lib.eventStack.unsub('scroll', _this.hideOnScroll, { target: window });
	      setTimeout(function () {
	        return _this.setState({ closed: false });
	      }, 50);
	    }, _this.handleClose = function (e) {
	      var onClose = _this.props.onClose;
	
	      if (onClose) onClose(e, _this.props);
	    }, _this.handleOpen = function (e) {
	      _this.coords = e.currentTarget.getBoundingClientRect();
	
	      var onOpen = _this.props.onOpen;
	
	      if (onOpen) onOpen(e, _this.props);
	    }, _this.handlePortalMount = function (e) {
	      var hideOnScroll = _this.props.hideOnScroll;
	
	
	      if (hideOnScroll) _lib.eventStack.sub('scroll', _this.hideOnScroll, { target: window });
	      (0, _invoke3.default)(_this.props, 'onMount', e, _this.props);
	    }, _this.handlePortalUnmount = function (e) {
	      var hideOnScroll = _this.props.hideOnScroll;
	
	
	      if (hideOnScroll) _lib.eventStack.unsub('scroll', _this.hideOnScroll, { target: window });
	      (0, _invoke3.default)(_this.props, 'onUnmount', e, _this.props);
	    }, _this.handlePopupRef = function (popupRef) {
	      _this.popupCoords = popupRef ? popupRef.getBoundingClientRect() : null;
	      _this.setPopupStyle();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Popup, [{
	    key: 'computePopupStyle',
	    value: function computePopupStyle(positions) {
	      var style = { position: 'absolute'
	
	        // Do not access window/document when server side rendering
	      };if (!_lib.isBrowser) return style;
	
	      var offset = this.props.offset;
	      var _window = window,
	          pageYOffset = _window.pageYOffset,
	          pageXOffset = _window.pageXOffset;
	      var _document$documentEle = document.documentElement,
	          clientWidth = _document$documentEle.clientWidth,
	          clientHeight = _document$documentEle.clientHeight;
	
	
	      if ((0, _includes3.default)(positions, 'right')) {
	        style.right = Math.round(clientWidth - (this.coords.right + pageXOffset));
	        style.left = 'auto';
	      } else if ((0, _includes3.default)(positions, 'left')) {
	        style.left = Math.round(this.coords.left + pageXOffset);
	        style.right = 'auto';
	      } else {
	        // if not left nor right, we are horizontally centering the element
	        var xOffset = (this.coords.width - this.popupCoords.width) / 2;
	        style.left = Math.round(this.coords.left + xOffset + pageXOffset);
	        style.right = 'auto';
	      }
	
	      if ((0, _includes3.default)(positions, 'top')) {
	        style.bottom = Math.round(clientHeight - (this.coords.top + pageYOffset));
	        style.top = 'auto';
	      } else if ((0, _includes3.default)(positions, 'bottom')) {
	        style.top = Math.round(this.coords.bottom + pageYOffset);
	        style.bottom = 'auto';
	      } else {
	        // if not top nor bottom, we are vertically centering the element
	        var yOffset = (this.coords.height + this.popupCoords.height) / 2;
	        style.top = Math.round(this.coords.bottom + pageYOffset - yOffset);
	        style.bottom = 'auto';
	
	        var _xOffset = this.popupCoords.width + 8;
	        if ((0, _includes3.default)(positions, 'right')) {
	          style.right -= _xOffset;
	        } else {
	          style.left -= _xOffset;
	        }
	      }
	
	      if (offset) {
	        if ((0, _isNumber3.default)(style.right)) {
	          style.right -= offset;
	        } else {
	          style.left -= offset;
	        }
	      }
	
	      return style;
	    }
	
	    // check if the style would display
	    // the popup outside of the view port
	
	  }, {
	    key: 'isStyleInViewport',
	    value: function isStyleInViewport(style) {
	      var _window2 = window,
	          pageYOffset = _window2.pageYOffset,
	          pageXOffset = _window2.pageXOffset;
	      var _document$documentEle2 = document.documentElement,
	          clientWidth = _document$documentEle2.clientWidth,
	          clientHeight = _document$documentEle2.clientHeight;
	
	
	      var element = {
	        top: style.top,
	        left: style.left,
	        width: this.popupCoords.width,
	        height: this.popupCoords.height
	      };
	      if ((0, _isNumber3.default)(style.right)) {
	        element.left = clientWidth - style.right - element.width;
	      }
	      if ((0, _isNumber3.default)(style.bottom)) {
	        element.top = clientHeight - style.bottom - element.height;
	      }
	
	      // hidden on top
	      if (element.top < pageYOffset) return false;
	      // hidden on the bottom
	      if (element.top + element.height > pageYOffset + clientHeight) return false;
	      // hidden the left
	      if (element.left < pageXOffset) return false;
	      // hidden on the right
	      if (element.left + element.width > pageXOffset + clientWidth) return false;
	
	      return true;
	    }
	  }, {
	    key: 'setPopupStyle',
	    value: function setPopupStyle() {
	      if (!this.coords || !this.popupCoords) return;
	      var position = this.props.position;
	      var style = this.computePopupStyle(position);
	
	      // Lets detect if the popup is out of the viewport and adjust
	      // the position accordingly
	      var positions = (0, _without3.default)(POSITIONS, position).concat([position]);
	      for (var i = 0; !this.isStyleInViewport(style) && i < positions.length; i += 1) {
	        style = this.computePopupStyle(positions[i]);
	        position = positions[i];
	      }
	
	      // Append 'px' to every numerical values in the style
	      style = (0, _mapValues3.default)(style, function (value) {
	        return (0, _isNumber3.default)(value) ? value + 'px' : value;
	      });
	      this.setState({ style: style, position: position });
	    }
	  }, {
	    key: 'getPortalProps',
	    value: function getPortalProps() {
	      var portalProps = {};
	
	      var _props = this.props,
	          on = _props.on,
	          hoverable = _props.hoverable;
	
	      var normalizedOn = (0, _isArray3.default)(on) ? on : [on];
	
	      if (hoverable) {
	        portalProps.closeOnPortalMouseLeave = true;
	        portalProps.mouseLeaveDelay = 300;
	      }
	      if ((0, _includes3.default)(normalizedOn, 'click')) {
	        portalProps.openOnTriggerClick = true;
	        portalProps.closeOnTriggerClick = true;
	        portalProps.closeOnDocumentClick = true;
	      }
	      if ((0, _includes3.default)(normalizedOn, 'focus')) {
	        portalProps.openOnTriggerFocus = true;
	        portalProps.closeOnTriggerBlur = true;
	      }
	      if ((0, _includes3.default)(normalizedOn, 'hover')) {
	        portalProps.openOnTriggerMouseEnter = true;
	        portalProps.closeOnTriggerMouseLeave = true;
	        // Taken from SUI: https://git.io/vPmCm
	        portalProps.mouseLeaveDelay = 70;
	        portalProps.mouseEnterDelay = 50;
	      }
	
	      return portalProps;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          basic = _props2.basic,
	          children = _props2.children,
	          className = _props2.className,
	          content = _props2.content,
	          flowing = _props2.flowing,
	          header = _props2.header,
	          inverted = _props2.inverted,
	          size = _props2.size,
	          trigger = _props2.trigger,
	          wide = _props2.wide;
	      var _state = this.state,
	          position = _state.position,
	          closed = _state.closed;
	
	      var style = (0, _assign3.default)({}, this.state.style, this.props.style);
	      var classes = (0, _classnames2.default)('ui', position, size, (0, _lib.useKeyOrValueAndKey)(wide, 'wide'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(flowing, 'flowing'), (0, _lib.useKeyOnly)(inverted, 'inverted'), 'popup transition visible', className);
	
	      if (closed) return trigger;
	
	      var unhandled = (0, _lib.getUnhandledProps)(Popup, this.props);
	      var portalPropNames = _Portal2.default.handledProps;
	
	      var rest = (0, _omit3.default)(unhandled, portalPropNames);
	      var portalProps = (0, _pick3.default)(unhandled, portalPropNames);
	      var ElementType = (0, _lib.getElementType)(Popup, this.props);
	
	      var popupJSX = _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, style: style, ref: this.handlePopupRef }),
	        children,
	        _lib.childrenUtils.isNil(children) && _PopupHeader2.default.create(header),
	        _lib.childrenUtils.isNil(children) && _PopupContent2.default.create(content)
	      );
	
	      var mergedPortalProps = (0, _extends3.default)({}, this.getPortalProps(), portalProps);
	
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        (0, _extends3.default)({}, mergedPortalProps, {
	          trigger: trigger,
	          onClose: this.handleClose,
	          onMount: this.handlePortalMount,
	          onOpen: this.handleOpen,
	          onUnmount: this.handlePortalUnmount
	        }),
	        popupJSX
	      );
	    }
	  }]);
	  return Popup;
	}(_react.Component);
	
	Popup.defaultProps = {
	  position: 'top left',
	  on: 'hover'
	};
	Popup._meta = {
	  name: 'Popup',
	  type: _lib.META.TYPES.MODULE
	};
	Popup.Content = _PopupContent2.default;
	Popup.Header = _PopupHeader2.default;
	Popup.handledProps = ['basic', 'children', 'className', 'content', 'flowing', 'header', 'hideOnScroll', 'hoverable', 'inverted', 'offset', 'on', 'onClose', 'onMount', 'onOpen', 'onUnmount', 'position', 'size', 'style', 'trigger', 'wide'];
	exports.default = Popup;
	Popup.propTypes =  false ? {
	  /** Display the popup without the pointing arrow. */
	  basic: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Simple text content for the popover. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** A flowing Popup has no maximum width and continues to flow to fit its content. */
	  flowing: _propTypes2.default.bool,
	
	  /** Takes up the entire width of its offset container. */
	  // TODO: implement the Popup fluid layout
	  // fluid: PropTypes.bool,
	
	  /** Header displayed above the content in bold. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Hide the Popup when scrolling the window. */
	  hideOnScroll: _propTypes2.default.bool,
	
	  /** Whether the popup should not close on hover. */
	  hoverable: _propTypes2.default.bool,
	
	  /** Invert the colors of the Popup. */
	  inverted: _propTypes2.default.bool,
	
	  /** Horizontal offset in pixels to be applied to the Popup. */
	  offset: _propTypes2.default.number,
	
	  /** Events triggering the popup. */
	  on: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['hover', 'click', 'focus']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['hover', 'click', 'focus']))]),
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * Called when the portal is mounted on the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _propTypes2.default.func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * Called when the portal is unmounted from the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _propTypes2.default.func,
	
	  /** Position for the popover. */
	  position: _propTypes2.default.oneOf(POSITIONS),
	
	  /** Popup size. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium', 'big', 'massive')),
	
	  /** Custom Popup style. */
	  style: _propTypes2.default.object,
	
	  /** Element to be rendered in-place where the popup is defined. */
	  trigger: _propTypes2.default.node,
	
	  /** Popup width. */
	  wide: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])])
	} : {};

/***/ },
/* 3868 */
[4545, 3867],
/* 3869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _round2 = __webpack_require__(4060);
	
	var _round3 = _interopRequireDefault(_round2);
	
	var _clamp2 = __webpack_require__(4015);
	
	var _clamp3 = _interopRequireDefault(_clamp2);
	
	var _isUndefined2 = __webpack_require__(522);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A progress bar shows the progression of a task.
	 */
	var Progress = function (_Component) {
	  (0, _inherits3.default)(Progress, _Component);
	
	  function Progress() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Progress);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Progress.__proto__ || Object.getPrototypeOf(Progress)).call.apply(_ref, [this].concat(args))), _this), _this.calculatePercent = function () {
	      var _this$props = _this.props,
	          percent = _this$props.percent,
	          total = _this$props.total,
	          value = _this$props.value;
	
	
	      if (!(0, _isUndefined3.default)(percent)) return percent;
	      if (!(0, _isUndefined3.default)(total) && !(0, _isUndefined3.default)(value)) return value / total * 100;
	    }, _this.getPercent = function () {
	      var precision = _this.props.precision;
	
	      var percent = (0, _clamp3.default)(_this.calculatePercent(), 0, 100);
	
	      if ((0, _isUndefined3.default)(precision)) return percent;
	      return (0, _round3.default)(percent, precision);
	    }, _this.isAutoSuccess = function () {
	      var _this$props2 = _this.props,
	          autoSuccess = _this$props2.autoSuccess,
	          percent = _this$props2.percent,
	          total = _this$props2.total,
	          value = _this$props2.value;
	
	
	      return autoSuccess && (percent >= 100 || value >= total);
	    }, _this.renderLabel = function () {
	      var _this$props3 = _this.props,
	          children = _this$props3.children,
	          label = _this$props3.label;
	
	
	      if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	        'div',
	        { className: 'label' },
	        children
	      );
	      return (0, _lib.createHTMLDivision)(label, { defaultProps: { className: 'label' } });
	    }, _this.renderProgress = function (percent) {
	      var _this$props4 = _this.props,
	          precision = _this$props4.precision,
	          progress = _this$props4.progress,
	          total = _this$props4.total,
	          value = _this$props4.value;
	
	
	      if (!progress && (0, _isUndefined3.default)(precision)) return;
	      return _react2.default.createElement(
	        'div',
	        { className: 'progress' },
	        progress !== 'ratio' ? percent + '%' : value + '/' + total
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Progress, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          attached = _props.attached,
	          className = _props.className,
	          color = _props.color,
	          disabled = _props.disabled,
	          error = _props.error,
	          indicating = _props.indicating,
	          inverted = _props.inverted,
	          size = _props.size,
	          success = _props.success,
	          warning = _props.warning;
	
	
	      var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(active || indicating, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(indicating, 'indicating'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(success || this.isAutoSuccess(), 'success'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useValueAndKey)(attached, 'attached'), 'progress', className);
	      var rest = (0, _lib.getUnhandledProps)(Progress, this.props);
	      var ElementType = (0, _lib.getElementType)(Progress, this.props);
	      var percent = this.getPercent();
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, 'data-percent': Math.floor(percent) }),
	        _react2.default.createElement(
	          'div',
	          { className: 'bar', style: { width: percent + '%' } },
	          this.renderProgress(percent)
	        ),
	        this.renderLabel()
	      );
	    }
	  }]);
	  return Progress;
	}(_react.Component);
	
	Progress._meta = {
	  name: 'Progress',
	  type: _lib.META.TYPES.MODULE
	};
	Progress.handledProps = ['active', 'as', 'attached', 'autoSuccess', 'children', 'className', 'color', 'disabled', 'error', 'indicating', 'inverted', 'label', 'percent', 'precision', 'progress', 'size', 'success', 'total', 'value', 'warning'];
	Progress.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A progress bar can show activity. */
	  active: _propTypes2.default.bool,
	
	  /** A progress bar can attach to and show the progress of an element (i.e. Card or Segment). */
	  attached: _propTypes2.default.oneOf(['top', 'bottom']),
	
	  /** Whether success state should automatically trigger when progress completes. */
	  autoSuccess: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A progress bar can have different colors. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** A progress bar be disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** A progress bar can show a error state. */
	  error: _propTypes2.default.bool,
	
	  /** An indicating progress bar visually indicates the current level of progress of a task. */
	  indicating: _propTypes2.default.bool,
	
	  /** A progress bar can have its colors inverted. */
	  inverted: _propTypes2.default.bool,
	
	  /** Can be set to either to display progress as percent or ratio. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** Current percent complete. */
	  percent: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['total', 'value']), _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])]),
	
	  /** Decimal point precision for calculated progress. */
	  precision: _propTypes2.default.number,
	
	  /** A progress bar can contain a text value indicating current progress. */
	  progress: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['percent', 'ratio'])]),
	
	  /** A progress bar can vary in size. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'mini', 'huge', 'massive')),
	
	  /** A progress bar can show a success state. */
	  success: _propTypes2.default.bool,
	
	  /** For use with value. Together, these will calculate the percent. Mutually excludes percent. */
	  total: _lib.customPropTypes.every([_lib.customPropTypes.demand(['value']), _lib.customPropTypes.disallow(['percent']), _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])]),
	
	  /** For use with total. Together, these will calculate the percent. Mutually excludes percent. */
	  value: _lib.customPropTypes.every([_lib.customPropTypes.demand(['total']), _lib.customPropTypes.disallow(['percent']), _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])]),
	
	  /** A progress bar can show a warning state. */
	  warning: _propTypes2.default.bool
	} : {};
	exports.default = Progress;

/***/ },
/* 3870 */
[4546, 3869],
/* 3871 */
[4547, 1780, 48, 42, 12, 11, 1689],
/* 3872 */
[4549, 3871],
/* 3873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(130);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(120);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get3 = __webpack_require__(367);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isEmpty2 = __webpack_require__(520);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _partialRight2 = __webpack_require__(4057);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _inRange2 = __webpack_require__(4046);
	
	var _inRange3 = _interopRequireDefault(_inRange2);
	
	var _map2 = __webpack_require__(72);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _get5 = __webpack_require__(115);
	
	var _get6 = _interopRequireDefault(_get5);
	
	var _reduce2 = __webpack_require__(1776);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _isEqual2 = __webpack_require__(822);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _without2 = __webpack_require__(42);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _Input = __webpack_require__(774);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _SearchCategory = __webpack_require__(1690);
	
	var _SearchCategory2 = _interopRequireDefault(_SearchCategory);
	
	var _SearchResult = __webpack_require__(1691);
	
	var _SearchResult2 = _interopRequireDefault(_SearchResult);
	
	var _SearchResults = __webpack_require__(1692);
	
	var _SearchResults2 = _interopRequireDefault(_SearchResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A search module allows a user to query for results from a selection of data
	 */
	var Search = function (_Component) {
	  (0, _inherits3.default)(Search, _Component);
	
	  function Search() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Search);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Search.__proto__ || Object.getPrototypeOf(Search)).call.apply(_ref, [this].concat(args))), _this), _this.handleResultSelect = function (e, result) {
	
	      (0, _invoke3.default)(_this.props, 'onResultSelect', e, (0, _extends3.default)({}, _this.props, { result: result }));
	    }, _this.handleSelectionChange = function (e) {
	
	      var result = _this.getSelectedResult();
	      (0, _invoke3.default)(_this.props, 'onSelectionChange', e, (0, _extends3.default)({}, _this.props, { result: result }));
	    }, _this.closeOnEscape = function (e) {
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Escape) return;
	      e.preventDefault();
	      _this.close();
	    }, _this.moveSelectionOnKeyDown = function (e) {
	      switch (_lib.keyboardKey.getCode(e)) {
	        case _lib.keyboardKey.ArrowDown:
	          e.preventDefault();
	          _this.moveSelectionBy(e, 1);
	          break;
	        case _lib.keyboardKey.ArrowUp:
	          e.preventDefault();
	          _this.moveSelectionBy(e, -1);
	          break;
	        default:
	          break;
	      }
	    }, _this.selectItemOnEnter = function (e) {
	      if (_lib.keyboardKey.getCode(e) !== _lib.keyboardKey.Enter) return;
	
	      var result = _this.getSelectedResult();
	
	      // prevent selecting null if there was no selected item value
	      if (!result) return;
	
	      e.preventDefault();
	
	      // notify the onResultSelect prop that the user is trying to change value
	      _this.setValue(result.title);
	      _this.handleResultSelect(e, result);
	      _this.close();
	    }, _this.closeOnDocumentClick = function (e) {
	      _this.close();
	    }, _this.handleMouseDown = function (e) {
	
	      _this.isMouseDown = true;
	      (0, _invoke3.default)(_this.props, 'onMouseDown', e, _this.props);
	      _lib.eventStack.sub('mouseup', _this.handleDocumentMouseUp);
	    }, _this.handleDocumentMouseUp = function () {
	
	      _this.isMouseDown = false;
	      _lib.eventStack.unsub('mouseup', _this.handleDocumentMouseUp);
	    }, _this.handleInputClick = function (e) {
	
	      // prevent closeOnDocumentClick()
	      e.nativeEvent.stopImmediatePropagation();
	
	      _this.tryOpen();
	    }, _this.handleItemClick = function (e, _ref2) {
	      var id = _ref2.id;
	
	      var result = _this.getSelectedResult(id);
	
	      // prevent closeOnDocumentClick()
	      e.nativeEvent.stopImmediatePropagation();
	
	      // notify the onResultSelect prop that the user is trying to change value
	      _this.setValue(result.title);
	      _this.handleResultSelect(e, result);
	      _this.close();
	    }, _this.handleFocus = function (e) {
	      var onFocus = _this.props.onFocus;
	
	      if (onFocus) onFocus(e, _this.props);
	      _this.setState({ focus: true });
	    }, _this.handleBlur = function (e) {
	      var onBlur = _this.props.onBlur;
	
	      if (onBlur) onBlur(e, _this.props);
	      _this.setState({ focus: false });
	    }, _this.handleSearchChange = function (e) {
	      // prevent propagating to this.props.onChange()
	      e.stopPropagation();
	      var minCharacters = _this.props.minCharacters;
	      var open = _this.state.open;
	
	      var newQuery = e.target.value;
	
	      (0, _invoke3.default)(_this.props, 'onSearchChange', e, (0, _extends3.default)({}, _this.props, { value: newQuery }));
	
	      // open search dropdown on search query
	      if (newQuery.length < minCharacters) {
	        _this.close();
	      } else if (!open) {
	        _this.tryOpen(newQuery);
	      }
	
	      _this.setValue(newQuery);
	    }, _this.getFlattenedResults = function () {
	      var _this$props = _this.props,
	          category = _this$props.category,
	          results = _this$props.results;
	
	
	      return !category ? results : (0, _reduce3.default)(results, function (memo, categoryData) {
	        return memo.concat(categoryData.results);
	      }, []);
	    }, _this.getSelectedResult = function () {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.selectedIndex;
	
	      var results = _this.getFlattenedResults();
	      return (0, _get6.default)(results, index);
	    }, _this.setValue = function (value) {
	      var selectFirstResult = _this.props.selectFirstResult;
	
	
	      _this.trySetState({ value: value }, { selectedIndex: selectFirstResult ? 0 : -1 });
	    }, _this.moveSelectionBy = function (e, offset) {
	      var selectedIndex = _this.state.selectedIndex;
	
	
	      var results = _this.getFlattenedResults();
	      var lastIndex = results.length - 1;
	
	      // next is after last, wrap to beginning
	      // next is before first, wrap to end
	      var nextIndex = selectedIndex + offset;
	      if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;
	
	      _this.setState({ selectedIndex: nextIndex });
	      _this.scrollSelectedItemIntoView();
	      _this.handleSelectionChange(e);
	    }, _this.scrollSelectedItemIntoView = function () {
	      // Do not access document when server side rendering
	      if (!_lib.isBrowser) return;
	      var menu = document.querySelector('.ui.search.active.visible .results.visible');
	      var item = menu.querySelector('.result.active');
	      if (!item) return;
	
	      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
	      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;
	
	      if (isOutOfUpperView) {
	        menu.scrollTop = item.offsetTop;
	      } else if (isOutOfLowerView) {
	        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
	      }
	    }, _this.tryOpen = function () {
	      var currentValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
	      var minCharacters = _this.props.minCharacters;
	
	      if (currentValue.length < minCharacters) return;
	
	      _this.open();
	    }, _this.open = function () {
	      _this.trySetState({ open: true });
	    }, _this.close = function () {
	      _this.trySetState({ open: false });
	    }, _this.renderSearchInput = function (rest) {
	      var _this$props2 = _this.props,
	          icon = _this$props2.icon,
	          input = _this$props2.input;
	      var value = _this.state.value;
	
	
	      return _Input2.default.create(input, { defaultProps: (0, _extends3.default)({}, rest, {
	          icon: icon,
	          input: { className: 'prompt', tabIndex: '0', autoComplete: 'off' },
	          onChange: _this.handleSearchChange,
	          onClick: _this.handleInputClick,
	          value: value
	        }) });
	    }, _this.renderNoResults = function () {
	      var _this$props3 = _this.props,
	          noResultsDescription = _this$props3.noResultsDescription,
	          noResultsMessage = _this$props3.noResultsMessage;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'message empty' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          noResultsMessage
	        ),
	        noResultsDescription && _react2.default.createElement(
	          'div',
	          { className: 'description' },
	          noResultsDescription
	        )
	      );
	    }, _this.renderResult = function (_ref3, index, _array) {
	      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	      var childKey = _ref3.childKey,
	          result = (0, _objectWithoutProperties3.default)(_ref3, ['childKey']);
	      var resultRenderer = _this.props.resultRenderer;
	      var selectedIndex = _this.state.selectedIndex;
	
	      var offsetIndex = index + offset;
	
	      return _react2.default.createElement(_SearchResult2.default, (0, _extends3.default)({
	        key: childKey || result.title,
	        active: selectedIndex === offsetIndex,
	        onClick: _this.handleItemClick,
	        renderer: resultRenderer
	      }, result, {
	        id: offsetIndex // Used to lookup the result on item click
	      }));
	    }, _this.renderResults = function () {
	      var results = _this.props.results;
	
	
	      return (0, _map3.default)(results, _this.renderResult);
	    }, _this.renderCategories = function () {
	      var _this$props4 = _this.props,
	          categoryRenderer = _this$props4.categoryRenderer,
	          categories = _this$props4.results;
	      var selectedIndex = _this.state.selectedIndex;
	
	
	      var count = 0;
	
	      return (0, _map3.default)(categories, function (_ref4) {
	        var childKey = _ref4.childKey,
	            category = (0, _objectWithoutProperties3.default)(_ref4, ['childKey']);
	
	        var categoryProps = (0, _extends3.default)({
	          key: childKey || category.name,
	          active: (0, _inRange3.default)(selectedIndex, count, count + category.results.length),
	          renderer: categoryRenderer
	        }, category);
	        var renderFn = (0, _partialRight3.default)(_this.renderResult, count);
	
	        count += category.results.length;
	
	        return _react2.default.createElement(
	          _SearchCategory2.default,
	          categoryProps,
	          category.results.map(renderFn)
	        );
	      });
	    }, _this.renderMenuContent = function () {
	      var _this$props5 = _this.props,
	          category = _this$props5.category,
	          showNoResults = _this$props5.showNoResults,
	          results = _this$props5.results;
	
	
	      if ((0, _isEmpty3.default)(results)) {
	        return showNoResults ? _this.renderNoResults() : null;
	      }
	
	      return category ? _this.renderCategories() : _this.renderResults();
	    }, _this.renderResultsMenu = function () {
	      var open = _this.state.open;
	
	      var resultsClasses = open ? 'visible' : '';
	      var menuContent = _this.renderMenuContent();
	
	      if (!menuContent) return;
	
	      return _react2.default.createElement(
	        _SearchResults2.default,
	        { className: resultsClasses },
	        menuContent
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Search, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _state = this.state,
	          open = _state.open,
	          value = _state.value;
	
	
	      this.setValue(value);
	      if (open) this.open();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _isEqual3.default)(nextProps, this.props) || !(0, _isEqual3.default)(nextState, this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get4.default)(Search.prototype.__proto__ || Object.getPrototypeOf(Search.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
	
	
	      if (!(0, _isEqual3.default)(nextProps.value, this.props.value)) {
	        this.setValue(nextProps.value);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	
	      // focused / blurred
	      // eslint-disable-line complexity
	      if (!prevState.focus && this.state.focus) {
	        if (!this.isMouseDown) {
	          this.tryOpen();
	        }
	        if (this.state.open) {
	          _lib.eventStack.sub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	        }
	      } else if (prevState.focus && !this.state.focus) {
	        if (!this.isMouseDown) {
	          this.close();
	        }
	        _lib.eventStack.unsub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	      }
	
	      // opened / closed
	      if (!prevState.open && this.state.open) {
	        this.open();
	        _lib.eventStack.sub('click', this.closeOnDocumentClick);
	        _lib.eventStack.sub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	      } else if (prevState.open && !this.state.open) {
	        this.close();
	        _lib.eventStack.unsub('click', this.closeOnDocumentClick);
	        _lib.eventStack.unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	
	      _lib.eventStack.unsub('click', this.closeOnDocumentClick);
	      _lib.eventStack.unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	    }
	
	    // ----------------------------------------
	    // Document Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Component Event Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Getters
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Setters
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Behavior
	    // ----------------------------------------
	
	    // Open if the current value is greater than the minCharacters prop
	
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	    /**
	     * Offset is needed for determining the active item for results within a
	     * category. Since the index is reset to 0 for each new category, an offset
	     * must be passed in.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          searchClasses = _state2.searchClasses,
	          focus = _state2.focus,
	          open = _state2.open;
	      var _props = this.props,
	          aligned = _props.aligned,
	          category = _props.category,
	          className = _props.className,
	          fluid = _props.fluid,
	          loading = _props.loading,
	          size = _props.size;
	
	      // Classes
	
	      var classes = (0, _classnames2.default)('ui', open && 'active visible', size, searchClasses, (0, _lib.useKeyOnly)(category, 'category'), (0, _lib.useKeyOnly)(focus, 'focus'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useValueAndKey)(aligned, 'aligned'), 'search', className);
	      var unhandled = (0, _lib.getUnhandledProps)(Search, this.props);
	      var ElementType = (0, _lib.getElementType)(Search, this.props);
	
	      var _partitionHTMLInputPr = (0, _lib.partitionHTMLInputProps)(unhandled, {
	        htmlProps: _lib.htmlInputAttrs
	      }),
	          _partitionHTMLInputPr2 = (0, _slicedToArray3.default)(_partitionHTMLInputPr, 2),
	          htmlInputProps = _partitionHTMLInputPr2[0],
	          rest = _partitionHTMLInputPr2[1];
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, {
	          className: classes,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseDown: this.handleMouseDown
	        }),
	        this.renderSearchInput(htmlInputProps),
	        this.renderResultsMenu()
	      );
	    }
	  }]);
	  return Search;
	}(_lib.AutoControlledComponent);
	
	Search.defaultProps = {
	  icon: 'search',
	  input: 'text',
	  minCharacters: 1,
	  noResultsMessage: 'No results found.',
	  showNoResults: true
	};
	Search.autoControlledProps = ['open', 'value'];
	Search._meta = {
	  name: 'Search',
	  type: _lib.META.TYPES.MODULE
	};
	Search.Category = _SearchCategory2.default;
	Search.Result = _SearchResult2.default;
	Search.Results = _SearchResults2.default;
	Search.handledProps = ['aligned', 'as', 'category', 'categoryRenderer', 'className', 'defaultOpen', 'defaultValue', 'fluid', 'icon', 'input', 'loading', 'minCharacters', 'noResultsDescription', 'noResultsMessage', 'onBlur', 'onFocus', 'onMouseDown', 'onResultSelect', 'onSearchChange', 'onSelectionChange', 'open', 'resultRenderer', 'results', 'selectFirstResult', 'showNoResults', 'size', 'value'];
	exports.default = Search;
	Search.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  // ------------------------------------
	  // Behavior
	  // ------------------------------------
	
	  /** Initial value of open. */
	  defaultOpen: _propTypes2.default.bool,
	
	  /** Initial value. */
	  defaultValue: _propTypes2.default.string,
	
	  /** Shorthand for Icon. */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.object]),
	
	  /** Minimum characters to query for results */
	  minCharacters: _propTypes2.default.number,
	
	  /** Additional text for "No Results" message with less emphasis. */
	  noResultsDescription: _propTypes2.default.node,
	
	  /** Message to display when there are no results. */
	  noResultsMessage: _propTypes2.default.node,
	
	  /** Controls whether or not the results menu is displayed. */
	  open: _propTypes2.default.bool,
	
	  /**
	   * One of:
	   * - array of Search.Result props e.g. `{ title: '', description: '' }` or
	   * - object of categories e.g. `{ name: '', results: [{ title: '', description: '' }]`
	   */
	  results: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.shape(_SearchResult2.default.propTypes)), _propTypes2.default.object]),
	
	  /** Whether the search should automatically select the first result after searching. */
	  selectFirstResult: _propTypes2.default.bool,
	
	  /** Whether a "no results" message should be shown if no results are found. */
	  showNoResults: _propTypes2.default.bool,
	
	  /** Current value of the search input. Creates a controlled component. */
	  value: _propTypes2.default.string,
	
	  // ------------------------------------
	  // Rendering
	  // ------------------------------------
	
	  /**
	   * Renders the SearchCategory contents.
	   *
	   * @param {object} props - The SearchCategory props object.
	   * @returns {*} - Renderable SearchCategory contents.
	   */
	  categoryRenderer: _propTypes2.default.func,
	
	  /**
	   * Renders the SearchResult contents.
	   *
	   * @param {object} props - The SearchResult props object.
	   * @returns {*} - Renderable SearchResult contents.
	   */
	  resultRenderer: _propTypes2.default.func,
	
	  // ------------------------------------
	  // Callbacks
	  // ------------------------------------
	
	  /**
	   * Called on blur.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * Called on focus.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * Called on mousedown.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * Called when a result is selected.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onResultSelect: _propTypes2.default.func,
	
	  /**
	   * Called on search input change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props, includes current value of search input.
	   */
	  onSearchChange: _propTypes2.default.func,
	
	  /**
	   * Called when the active selection index is changed.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onSelectionChange: _propTypes2.default.func,
	
	  // ------------------------------------
	  // Style
	  // ------------------------------------
	
	  /** A search can have its results aligned to its left or right container edge. */
	  aligned: _propTypes2.default.string,
	
	  /** A search can display results from remote content ordered by categories. */
	  category: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A search can have its results take up the width of its container. */
	  fluid: _propTypes2.default.bool,
	
	  /** A search input can take up the width of its container. */
	  input: _lib.customPropTypes.itemShorthand,
	
	  /** A search can show a loading indicator. */
	  loading: _propTypes2.default.bool,
	
	  /** A search can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : {};

/***/ },
/* 3874 */
[4550, 3873],
/* 3875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _SidebarPushable = __webpack_require__(1693);
	
	var _SidebarPushable2 = _interopRequireDefault(_SidebarPushable);
	
	var _SidebarPusher = __webpack_require__(1694);
	
	var _SidebarPusher2 = _interopRequireDefault(_SidebarPusher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A sidebar hides additional content beside a page.
	 */
	var Sidebar = function (_Component) {
	  (0, _inherits3.default)(Sidebar, _Component);
	
	  function Sidebar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Sidebar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call.apply(_ref, [this].concat(args))), _this), _this.startAnimating = function () {
	      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
	
	      clearTimeout(_this.stopAnimatingTimer);
	
	      _this.setState({ animating: true });
	
	      _this.stopAnimatingTimer = setTimeout(function () {
	        return _this.setState({ animating: false });
	      }, duration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Sidebar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.visible !== this.props.visible) {
	        this.startAnimating();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          children = _props.children,
	          direction = _props.direction,
	          visible = _props.visible,
	          width = _props.width;
	      var animating = this.state.animating;
	
	
	      var classes = (0, _classnames2.default)('ui', animation, direction, width, (0, _lib.useKeyOnly)(animating, 'animating'), (0, _lib.useKeyOnly)(visible, 'visible'), 'sidebar', className);
	
	      var rest = (0, _lib.getUnhandledProps)(Sidebar, this.props);
	      var ElementType = (0, _lib.getElementType)(Sidebar, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        children
	      );
	    }
	  }]);
	  return Sidebar;
	}(_lib.AutoControlledComponent);
	
	Sidebar.defaultProps = {
	  direction: 'left'
	};
	Sidebar.autoControlledProps = ['visible'];
	Sidebar._meta = {
	  name: 'Sidebar',
	  type: _lib.META.TYPES.MODULE
	};
	Sidebar.Pushable = _SidebarPushable2.default;
	Sidebar.Pusher = _SidebarPusher2.default;
	Sidebar.handledProps = ['animation', 'as', 'children', 'className', 'defaultVisible', 'direction', 'visible', 'width'];
	Sidebar.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Animation style. */
	  animation: _propTypes2.default.oneOf(['overlay', 'push', 'scale down', 'uncover', 'slide out', 'slide along']),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Initial value of visible. */
	  defaultVisible: _propTypes2.default.bool,
	
	  /** Direction the sidebar should appear on. */
	  direction: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /** Controls whether or not the sidebar is visible on the page. */
	  visible: _propTypes2.default.bool,
	
	  /** Sidebar width. */
	  width: _propTypes2.default.oneOf(['very thin', 'thin', 'wide', 'very wide'])
	} : {};
	exports.default = Sidebar;

/***/ },
/* 3876 */
[4551, 3875],
/* 3877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(48);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sticky content stays fixed to the browser viewport while another column of content is visible on the page.
	 */
	var Sticky = function (_Component) {
	  (0, _inherits3.default)(Sticky, _Component);
	
	  function Sticky() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Sticky);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      sticky: false
	    }, _this.addListener = function () {
	      var scrollContext = _this.props.scrollContext;
	
	
	      _lib.eventStack.sub('resize', _this.handleUpdate, { target: scrollContext });
	      _lib.eventStack.sub('scroll', _this.handleUpdate, { target: scrollContext });
	    }, _this.removeListener = function () {
	      var scrollContext = _this.props.scrollContext;
	
	
	      _lib.eventStack.unsub('resize', _this.handleUpdate, { target: scrollContext });
	      _lib.eventStack.unsub('scroll', _this.handleUpdate, { target: scrollContext });
	    }, _this.update = function (e) {
	      var pushing = _this.state.pushing;
	
	
	      _this.ticking = false;
	      _this.assignRects();
	
	      if (pushing) {
	        if (_this.didReachStartingPoint()) return _this.stickToContextTop(e);
	        if (_this.didTouchScreenBottom()) return _this.stickToScreenBottom(e);
	        return _this.stickToContextBottom(e);
	      }
	
	      if (_this.isOversized()) {
	        if (_this.contextRect.top > 0) return _this.stickToContextTop(e);
	        if (_this.contextRect.bottom < window.innerHeight) return _this.stickToContextBottom(e);
	      }
	
	      if (_this.didTouchScreenTop()) {
	        if (_this.didReachContextBottom()) return _this.stickToContextBottom(e);
	        return _this.stickToScreenTop(e);
	      }
	
	      return _this.stickToContextTop(e);
	    }, _this.handleUpdate = function (e) {
	      if (!_this.ticking) {
	        _this.ticking = true;
	        requestAnimationFrame(function () {
	          return _this.update(e);
	        });
	      }
	    }, _this.assignRects = function () {
	      var context = _this.props.context;
	
	
	      _this.triggerRect = _this.triggerRef.getBoundingClientRect();
	      _this.contextRect = (context || document.body).getBoundingClientRect();
	      _this.stickyRect = _this.stickyRef.getBoundingClientRect();
	    }, _this.didReachContextBottom = function () {
	      var offset = _this.props.offset;
	
	
	      return _this.stickyRect.height + offset >= _this.contextRect.bottom;
	    }, _this.didReachStartingPoint = function () {
	      return _this.stickyRect.top <= _this.triggerRect.top;
	    }, _this.didTouchScreenTop = function () {
	      return _this.triggerRect.top < _this.props.offset;
	    }, _this.didTouchScreenBottom = function () {
	      var bottomOffset = _this.props.bottomOffset;
	
	
	      return _this.contextRect.bottom + bottomOffset > window.innerHeight;
	    }, _this.isOversized = function () {
	      return _this.stickyRect.height > window.innerHeight;
	    }, _this.pushing = function (pushing) {
	      var possible = _this.props.pushing;
	
	
	      if (possible) _this.setState({ pushing: pushing });
	    }, _this.stick = function (e) {
	      _this.setState({ sticky: true });
	      (0, _invoke3.default)(_this.props, 'onStick', e, _this.props);
	    }, _this.unstick = function (e) {
	      _this.setState({ sticky: false });
	      (0, _invoke3.default)(_this.props, 'onUnstick', e, _this.props);
	    }, _this.stickToContextBottom = function (e) {
	      var top = _this.contextRect.bottom - _this.stickyRect.height;
	
	      (0, _invoke3.default)(_this.props, 'onBottom', e, _this.props);
	
	      _this.stick(e);
	      _this.setState({ top: top, bottom: null });
	      _this.pushing(true);
	    }, _this.stickToContextTop = function (e) {
	      (0, _invoke3.default)(_this.props, 'onTop', e, _this.props);
	
	      _this.unstick(e);
	      _this.pushing(false);
	    }, _this.stickToScreenBottom = function (e) {
	      var bottom = _this.props.bottomOffset;
	
	
	      _this.stick(e);
	      _this.setState({ bottom: bottom, top: null });
	    }, _this.stickToScreenTop = function (e) {
	      var top = _this.props.offset;
	
	
	      _this.stick(e);
	      _this.setState({ top: top, bottom: null });
	    }, _this.handleStickyRef = function (c) {
	      return _this.stickyRef = c;
	    }, _this.handleTriggerRef = function (c) {
	      return _this.triggerRef = c;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Sticky, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!_lib.isBrowser) return;
	      var active = this.props.active;
	
	
	      if (active) {
	        this.handleUpdate();
	        this.addListener();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref2) {
	      var next = _ref2.active;
	      var current = this.props.active;
	
	
	      if (current === next) return;
	      if (next) {
	        this.handleUpdate();
	        this.addListener();
	        return;
	      }
	      this.removeListener();
	      this.setState({ sticky: false });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!_lib.isBrowser) return;
	      var active = this.props.active;
	
	
	      if (active) this.removeListener();
	    }
	
	    // ----------------------------------------
	    // Events
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Handlers
	    // ----------------------------------------
	
	    // ----------------------------------------
	    // Helpers
	    // ----------------------------------------
	
	  }, {
	    key: 'computeStyle',
	    value: function computeStyle() {
	      var _state = this.state,
	          bottom = _state.bottom,
	          sticky = _state.sticky,
	          top = _state.top;
	
	
	      if (!sticky) return {};
	      return {
	        bottom: bottom,
	        top: top,
	        position: 'fixed',
	        width: this.triggerRect.width
	      };
	    }
	
	    // Return true when the component reached the bottom of the context
	
	
	    // Return true when the component reached the starting point
	
	
	    // Return true when the top of the screen overpasses the Sticky component
	
	
	    // Return true when the bottom of the screen overpasses the Sticky component
	
	
	    // Return true if the height of the component is higher than the window
	
	
	    // ----------------------------------------
	    // Stick helpers
	    // ----------------------------------------
	
	    // If true, the component will stick to the bottom of the screen instead of the top
	
	
	    // ----------------------------------------
	    // Refs
	    // ----------------------------------------
	
	  }, {
	    key: 'render',
	
	
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	      var rest = (0, _lib.getUnhandledProps)(Sticky, this.props);
	      var ElementType = (0, _lib.getElementType)(Sticky, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: className }),
	        _react2.default.createElement('div', { ref: this.handleTriggerRef }),
	        _react2.default.createElement(
	          'div',
	          { ref: this.handleStickyRef, style: this.computeStyle() },
	          children
	        )
	      );
	    }
	  }]);
	  return Sticky;
	}(_react.Component);
	
	Sticky.defaultProps = {
	  active: true,
	  bottomOffset: 0,
	  offset: 0,
	  scrollContext: _lib.isBrowser ? window : null
	};
	Sticky._meta = {
	  name: 'Sticky',
	  type: _lib.META.TYPES.MODULE
	};
	Sticky.handledProps = ['active', 'as', 'bottomOffset', 'children', 'className', 'context', 'offset', 'onBottom', 'onStick', 'onTop', 'onUnstick', 'pushing', 'scrollContext'];
	exports.default = Sticky;
	Sticky.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A Sticky can be active. */
	  active: _propTypes2.default.bool,
	
	  /** Offset in pixels from the bottom of the screen when fixing element to viewport. */
	  bottomOffset: _propTypes2.default.number,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Context which sticky element should stick to. */
	  context: _propTypes2.default.object,
	
	  /** Offset in pixels from the top of the screen when fixing element to viewport. */
	  offset: _propTypes2.default.number,
	
	  /**
	   * Callback when element is bound to bottom of parent container.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onBottom: _propTypes2.default.func,
	
	  /**
	   * Callback when element is fixed to page.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onStick: _propTypes2.default.func,
	
	  /**
	   * Callback when element is bound to top of parent container.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onTop: _propTypes2.default.func,
	
	  /**
	   * Callback when element is unfixed from page.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onUnstick: _propTypes2.default.func,
	
	  /** Whether element should be "pushed" by the viewport, attaching to the bottom of the screen when scrolling up. */
	  pushing: _propTypes2.default.bool,
	
	  /** Context which sticky should attach onscroll events. */
	  scrollContext: _propTypes2.default.object
	} : {};

/***/ },
/* 3878 */
[4552, 3877],
/* 3879 */
[4553, 72, 115, 48, 12, 11, 1640, 771, 1642, 1695],
/* 3880 */
[4555, 3879],
/* 3881 */
[4556, 1696],
/* 3882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An ad displays third-party promotional content.
	 */
	function Advertisement(props) {
	  var centered = props.centered,
	      children = props.children,
	      className = props.className,
	      test = props.test,
	      unit = props.unit;
	
	
	  var classes = (0, _classnames2.default)('ui', unit, (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(test, 'test'), 'ad', className);
	  var rest = (0, _lib.getUnhandledProps)(Advertisement, props);
	  var ElementType = (0, _lib.getElementType)(Advertisement, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes, 'data-text': test }),
	    children
	  );
	}
	
	Advertisement.handledProps = ['as', 'centered', 'children', 'className', 'test', 'unit'];
	Advertisement._meta = {
	  name: 'Advertisement',
	  type: _lib.META.TYPES.VIEW
	};
	
	Advertisement.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Center the advertisement. */
	  centered: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Text to be displayed on the advertisement. */
	  test: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /** Varies the size of the advertisement. */
	  unit: _propTypes2.default.oneOf(['medium rectangle', 'large rectangle', 'vertical rectangle', 'small rectangle', 'mobile banner', 'banner', 'vertical banner', 'top banner', 'half banner', 'button', 'square button', 'small button', 'skyscraper', 'wide skyscraper', 'leaderboard', 'large leaderboard', 'mobile leaderboard', 'billboard', 'panorama', 'netboard', 'half page', 'square', 'small square']).isRequired
	
	} : {};
	
	exports.default = Advertisement;

/***/ },
/* 3883 */
[4557, 3882],
/* 3884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(11);
	
	var _CommentAction = __webpack_require__(1701);
	
	var _CommentAction2 = _interopRequireDefault(_CommentAction);
	
	var _CommentActions = __webpack_require__(1702);
	
	var _CommentActions2 = _interopRequireDefault(_CommentActions);
	
	var _CommentAuthor = __webpack_require__(1703);
	
	var _CommentAuthor2 = _interopRequireDefault(_CommentAuthor);
	
	var _CommentAvatar = __webpack_require__(1704);
	
	var _CommentAvatar2 = _interopRequireDefault(_CommentAvatar);
	
	var _CommentContent = __webpack_require__(1705);
	
	var _CommentContent2 = _interopRequireDefault(_CommentContent);
	
	var _CommentGroup = __webpack_require__(1706);
	
	var _CommentGroup2 = _interopRequireDefault(_CommentGroup);
	
	var _CommentMetadata = __webpack_require__(1707);
	
	var _CommentMetadata2 = _interopRequireDefault(_CommentMetadata);
	
	var _CommentText = __webpack_require__(1708);
	
	var _CommentText2 = _interopRequireDefault(_CommentText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment displays user feedback to site content.
	 */
	function Comment(props) {
	  var className = props.className,
	      children = props.children,
	      collapsed = props.collapsed;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(collapsed, 'collapsed'), 'comment', className);
	  var rest = (0, _lib.getUnhandledProps)(Comment, props);
	  var ElementType = (0, _lib.getElementType)(Comment, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	Comment.handledProps = ['as', 'children', 'className', 'collapsed'];
	Comment._meta = {
	  name: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	Comment.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Comment can be collapsed, or hidden from view. */
	  collapsed: _propTypes2.default.bool
	} : {};
	
	Comment.Author = _CommentAuthor2.default;
	Comment.Action = _CommentAction2.default;
	Comment.Actions = _CommentActions2.default;
	Comment.Avatar = _CommentAvatar2.default;
	Comment.Content = _CommentContent2.default;
	Comment.Group = _CommentGroup2.default;
	Comment.Metadata = _CommentMetadata2.default;
	Comment.Text = _CommentText2.default;
	
	exports.default = Comment;

/***/ },
/* 3885 */
[4562, 3884],
/* 3886 */
[4563, 42, 72, 12, 11, 788, 496, 1709, 789, 790, 791, 792, 793, 794],
/* 3887 */
[4573, 3886],
/* 3888 */
[4581, 1710],
/* 3889 */
[4582, 1714],
/* 3890 */
[4186, 222, 82],
/* 3891 */
[4187, 3969, 3970, 3971, 3972, 3973],
/* 3892 */
[4193, 222, 82],
/* 3893 */
2606,
/* 3894 */
2607,
/* 3895 */
[4202, 1731],
/* 3896 */
2609,
/* 3897 */
2610,
/* 3898 */
[4205, 220],
/* 3899 */
[4207, 271, 825],
/* 3900 */
[4213, 220],
/* 3901 */
[4214, 225],
/* 3902 */
[4215, 220],
/* 3903 */
[4217, 3950],
/* 3904 */
2617,
/* 3905 */
2618,
/* 3906 */
2619,
/* 3907 */
[4223, 498, 500, 804, 162, 270, 508],
/* 3908 */
[4224, 499, 221, 826, 1756, 186],
/* 3909 */
[4225, 140, 83],
/* 3910 */
[4227, 803, 1743, 3962, 3963, 223, 49, 340, 521],
/* 3911 */
[4228, 223, 83],
/* 3912 */
[4229, 803, 808],
/* 3913 */
2626,
/* 3914 */
[4230, 224, 3980, 100, 1762],
/* 3915 */
[4231, 223, 83],
/* 3916 */
[4232, 140, 823, 83],
/* 3917 */
[4235, 100, 338, 3995],
/* 3918 */
2631,
/* 3919 */
[4237, 3912, 3964, 1752],
/* 3920 */
[4238, 808, 115, 1771, 816, 1751, 1752, 186],
/* 3921 */
[4239, 162, 336, 114, 1730, 3929, 270, 3942, 188, 49],
/* 3922 */
[4240, 3923, 1771],
/* 3923 */
[4241, 336, 1732, 221],
/* 3924 */
[4242, 336],
/* 3925 */
2636,
/* 3926 */
2637,
/* 3927 */
[4246, 4017, 1742, 188],
/* 3928 */
[4247, 220],
/* 3929 */
2640,
/* 3930 */
2641,
/* 3931 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(221),
	    last = __webpack_require__(826),
	    parent = __webpack_require__(1756),
	    toKey = __webpack_require__(186);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 3932 */
[4250, 162],
/* 3933 */
[4251, 519],
/* 3934 */
[4255, 505],
/* 3935 */
[4256, 505],
/* 3936 */
[4258, 82],
/* 3937 */
[4259, 811],
/* 3938 */
2648,
/* 3939 */
[4260, 269],
/* 3940 */
[4261, 811],
/* 3941 */
[4262, 225],
/* 3942 */
[4263, 3941],
/* 3943 */
[4265, 271, 814],
/* 3944 */
[4266, 271, 1748],
/* 3945 */
[4267, 82],
/* 3946 */
2656,
/* 3947 */
[4268, 3893, 3898, 114, 49],
/* 3948 */
[4269, 185, 515],
/* 3949 */
[4270, 126],
/* 3950 */
2660,
/* 3951 */
[4271, 510, 82],
/* 3952 */
[4272, 1737, 815, 1760, 165],
/* 3953 */
[4273, 1723, 1765, 4072],
/* 3954 */
[4275, 499, 510, 1740, 1741, 813, 517, 82],
/* 3955 */
[4276, 114, 126, 116],
/* 3956 */
[4277, 800, 512, 812, 1747, 49, 1750],
/* 3957 */
[4279, 499, 510, 82],
/* 3958 */
[4281, 82, 164, 523, 165],
/* 3959 */
[4282, 1718, 1774, 818],
/* 3960 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(341);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 3961 */
[4284, 3925],
/* 3962 */
[4287, 269, 1719, 339, 1743, 3991, 818],
/* 3963 */
[4288, 1745],
/* 3964 */
[4295, 1751, 116],
/* 3965 */
[4298, 269],
/* 3966 */
2675,
/* 3967 */
2676,
/* 3968 */
2677,
/* 3969 */
[4303, 516],
/* 3970 */
2679,
/* 3971 */
[4304, 516],
/* 3972 */
[4305, 516],
/* 3973 */
[4306, 516],
/* 3974 */
2683,
/* 3975 */
[4307, 811, 3937, 3938, 3939, 3940],
/* 3976 */
[4308, 335, 514, 338],
/* 3977 */
2686,
/* 3978 */
[4309, 269, 518, 49],
/* 3979 */
2688,
/* 3980 */
[4313, 3945],
/* 3981 */
2690,
/* 3982 */
[4315, 502],
/* 3983 */
[4316, 502],
/* 3984 */
[4317, 502],
/* 3985 */
[4318, 502],
/* 3986 */
[4319, 3891, 497, 801],
/* 3987 */
[4320, 513],
/* 3988 */
[4321, 513],
/* 3989 */
[4322, 513],
/* 3990 */
[4323, 513],
/* 3991 */
2700,
/* 3992 */
[4324, 4055],
/* 3993 */
[4325, 1738, 1739, 517],
/* 3994 */
[4328, 1754],
/* 3995 */
2704,
/* 3996 */
2705,
/* 3997 */
2707,
/* 3998 */
[4332, 509, 337],
/* 3999 */
2709,
/* 4000 */
2710,
/* 4001 */
[4337, 497],
/* 4002 */
2712,
/* 4003 */
2713,
/* 4004 */
2714,
/* 4005 */
[4338, 497, 801, 802],
/* 4006 */
2716,
/* 4007 */
[4339, 3895, 815, 4008],
/* 4008 */
2718,
/* 4009 */
2719,
/* 4010 */
2720,
/* 4011 */
[4343, 334, 500],
/* 4012 */
[4344, 799, 800, 509],
/* 4013 */
[4345, 511],
/* 4014 */
[4346, 501, 271, 3948, 126, 338, 116],
/* 4015 */
[4347, 1726, 523],
/* 4016 */
[4348, 806],
/* 4017 */
2727,
/* 4018 */
[4352, 507, 164],
/* 4019 */
[4354, 165],
/* 4020 */
[4355, 3894, 3900, 114, 49, 515],
/* 4021 */
[4359, 504],
/* 4022 */
[4360, 3956],
/* 4023 */
[4362, 4024, 56],
/* 4024 */
2733,
/* 4025 */
[4363, 4013, 1725, 4016, 1764, 334, 49, 4049, 224, 4052, 4053, 506, 4059, 164, 4067],
/* 4026 */
[4364, 57, 1763, 163, 56],
/* 4027 */
[4366, 57, 1764, 56],
/* 4028 */
[4367, 57, 1766, 56],
/* 4029 */
[4368, 57, 339, 56],
/* 4030 */
[4370, 57, 115, 56],
/* 4031 */
[4371, 57, 187, 56],
/* 4032 */
[4373, 57, 224, 163, 56],
/* 4033 */
[4374, 57, 91, 163, 56],
/* 4034 */
[4375, 57, 100, 163, 56],
/* 4035 */
[4376, 57, 341, 163, 56],
/* 4036 */
[4377, 57, 116, 163, 56],
/* 4037 */
[4378, 57, 72, 56],
/* 4038 */
[4379, 57, 4056, 163, 56],
/* 4039 */
[4380, 57, 827, 56],
/* 4040 */
[4381, 57, 4063, 56],
/* 4041 */
[4382, 57, 1777, 56],
/* 4042 */
[4383, 57, 1779, 163, 56],
/* 4043 */
[4384, 57, 4066, 56],
/* 4044 */
[4385, 57, 4069, 56],
/* 4045 */
[4386, 57, 524, 163, 56],
/* 4046 */
[4390, 3906, 1781, 523],
/* 4047 */
[4392, 162, 3907, 185, 3933],
/* 4048 */
[4397, 140, 83],
/* 4049 */
[4401, 140, 83, 341],
/* 4050 */
[4403, 3911, 270, 817],
/* 4051 */
[4406, 3915, 270, 817],
/* 4052 */
[4410, 223, 83],
/* 4053 */
[4411, 806, 114],
/* 4054 */
[4412, 503, 3947],
/* 4055 */
[4417, 802],
/* 4056 */
[4418, 3901, 3918, 188],
/* 4057 */
[4419, 185, 511, 813, 517],
/* 4058 */
[4421, 1731, 3924, 816, 186],
/* 4059 */
[4422, 511, 512],
/* 4060 */
[4424, 3958],
/* 4061 */
[4425, 1732],
/* 4062 */
[4426, 506, 223, 126, 824, 4007],
/* 4063 */
[4428, 504, 3921, 185, 515],
/* 4064 */
[4429, 3953, 4071],
/* 4065 */
2777,
/* 4066 */
[4432, 507, 164],
/* 4067 */
[4437, 162, 509, 49, 225, 1761, 186, 165],
/* 4068 */
[4439, 334, 335, 807, 114, 514, 49, 340, 224, 100, 521],
/* 4069 */
[4440, 810, 1737, 3934, 3935, 1760, 165],
/* 4070 */
[4441, 504, 185, 1735, 519],
/* 4071 */
[4443, 3952],
/* 4072 */
[4446, 3897, 3968, 165, 4010],
/* 4073 */
[4447, 799, 800, 809, 49, 83, 4012],
/* 4074 */
[4448, 4075],
/* 4075 */
2788,
/* 4076 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer
	
	var debug
	/* istanbul ignore next */
	if (typeof process === 'object' &&
	    process.env &&
	    process.env.NODE_DEBUG &&
	    /\bsemver\b/i.test(process.env.NODE_DEBUG)) {
	  debug = function () {
	    var args = Array.prototype.slice.call(arguments, 0)
	    args.unshift('SEMVER')
	    console.log.apply(console, args)
	  }
	} else {
	  debug = function () {}
	}
	
	// Note: this is the semver.org version of the spec that it implements
	// Not necessarily the package version of this code.
	exports.SEMVER_SPEC_VERSION = '2.0.0'
	
	var MAX_LENGTH = 256
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER ||
	  /* istanbul ignore next */ 9007199254740991
	
	// Max safe segment length for coercion.
	var MAX_SAFE_COMPONENT_LENGTH = 16
	
	// The actual regexps go on exports.re
	var re = exports.re = []
	var src = exports.src = []
	var R = 0
	
	// The following Regular Expressions can be used for tokenizing,
	// validating, and parsing SemVer version strings.
	
	// ## Numeric Identifier
	// A single `0`, or a non-zero digit followed by zero or more digits.
	
	var NUMERICIDENTIFIER = R++
	src[NUMERICIDENTIFIER] = '0|[1-9]\\d*'
	var NUMERICIDENTIFIERLOOSE = R++
	src[NUMERICIDENTIFIERLOOSE] = '[0-9]+'
	
	// ## Non-numeric Identifier
	// Zero or more digits, followed by a letter or hyphen, and then zero or
	// more letters, digits, or hyphens.
	
	var NONNUMERICIDENTIFIER = R++
	src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*'
	
	// ## Main Version
	// Three dot-separated numeric identifiers.
	
	var MAINVERSION = R++
	src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
	                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
	                   '(' + src[NUMERICIDENTIFIER] + ')'
	
	var MAINVERSIONLOOSE = R++
	src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
	                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
	                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')'
	
	// ## Pre-release Version Identifier
	// A numeric identifier, or a non-numeric identifier.
	
	var PRERELEASEIDENTIFIER = R++
	src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
	                            '|' + src[NONNUMERICIDENTIFIER] + ')'
	
	var PRERELEASEIDENTIFIERLOOSE = R++
	src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
	                                 '|' + src[NONNUMERICIDENTIFIER] + ')'
	
	// ## Pre-release Version
	// Hyphen, followed by one or more dot-separated pre-release version
	// identifiers.
	
	var PRERELEASE = R++
	src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
	                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))'
	
	var PRERELEASELOOSE = R++
	src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
	                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))'
	
	// ## Build Metadata Identifier
	// Any combination of digits, letters, or hyphens.
	
	var BUILDIDENTIFIER = R++
	src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+'
	
	// ## Build Metadata
	// Plus sign, followed by one or more period-separated build metadata
	// identifiers.
	
	var BUILD = R++
	src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
	             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))'
	
	// ## Full Version String
	// A main version, followed optionally by a pre-release version and
	// build metadata.
	
	// Note that the only major, minor, patch, and pre-release sections of
	// the version string are capturing groups.  The build metadata is not a
	// capturing group, because it should not ever be used in version
	// comparison.
	
	var FULL = R++
	var FULLPLAIN = 'v?' + src[MAINVERSION] +
	                src[PRERELEASE] + '?' +
	                src[BUILD] + '?'
	
	src[FULL] = '^' + FULLPLAIN + '$'
	
	// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
	// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
	// common in the npm registry.
	var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
	                 src[PRERELEASELOOSE] + '?' +
	                 src[BUILD] + '?'
	
	var LOOSE = R++
	src[LOOSE] = '^' + LOOSEPLAIN + '$'
	
	var GTLT = R++
	src[GTLT] = '((?:<|>)?=?)'
	
	// Something like "2.*" or "1.2.x".
	// Note that "x.x" is a valid xRange identifer, meaning "any version"
	// Only the first item is strictly required.
	var XRANGEIDENTIFIERLOOSE = R++
	src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*'
	var XRANGEIDENTIFIER = R++
	src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*'
	
	var XRANGEPLAIN = R++
	src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:' + src[PRERELEASE] + ')?' +
	                   src[BUILD] + '?' +
	                   ')?)?'
	
	var XRANGEPLAINLOOSE = R++
	src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:' + src[PRERELEASELOOSE] + ')?' +
	                        src[BUILD] + '?' +
	                        ')?)?'
	
	var XRANGE = R++
	src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$'
	var XRANGELOOSE = R++
	src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$'
	
	// Coercion.
	// Extract anything that could conceivably be a part of a valid semver
	var COERCE = R++
	src[COERCE] = '(?:^|[^\\d])' +
	              '(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '})' +
	              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
	              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
	              '(?:$|[^\\d])'
	
	// Tilde ranges.
	// Meaning is "reasonably at or greater than"
	var LONETILDE = R++
	src[LONETILDE] = '(?:~>?)'
	
	var TILDETRIM = R++
	src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+'
	re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g')
	var tildeTrimReplace = '$1~'
	
	var TILDE = R++
	src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$'
	var TILDELOOSE = R++
	src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$'
	
	// Caret ranges.
	// Meaning is "at least and backwards compatible with"
	var LONECARET = R++
	src[LONECARET] = '(?:\\^)'
	
	var CARETTRIM = R++
	src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+'
	re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g')
	var caretTrimReplace = '$1^'
	
	var CARET = R++
	src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$'
	var CARETLOOSE = R++
	src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$'
	
	// A simple gt/lt/eq thing, or just "" to indicate "any version"
	var COMPARATORLOOSE = R++
	src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$'
	var COMPARATOR = R++
	src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$'
	
	// An expression to strip any whitespace between the gtlt and the thing
	// it modifies, so that `> 1.2.3` ==> `>1.2.3`
	var COMPARATORTRIM = R++
	src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
	                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')'
	
	// this one has to use the /g flag
	re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g')
	var comparatorTrimReplace = '$1$2$3'
	
	// Something like `1.2.3 - 1.2.4`
	// Note that these all use the loose form, because they'll be
	// checked against either the strict or loose comparator form
	// later.
	var HYPHENRANGE = R++
	src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
	                   '\\s+-\\s+' +
	                   '(' + src[XRANGEPLAIN] + ')' +
	                   '\\s*$'
	
	var HYPHENRANGELOOSE = R++
	src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
	                        '\\s+-\\s+' +
	                        '(' + src[XRANGEPLAINLOOSE] + ')' +
	                        '\\s*$'
	
	// Star ranges basically just allow anything at all.
	var STAR = R++
	src[STAR] = '(<|>)?=?\\s*\\*'
	
	// Compile to actual regexp objects.
	// All are flag-free, unless they were created above with a flag.
	for (var i = 0; i < R; i++) {
	  debug(i, src[i])
	  if (!re[i]) {
	    re[i] = new RegExp(src[i])
	  }
	}
	
	exports.parse = parse
	function parse (version, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  if (version instanceof SemVer) {
	    return version
	  }
	
	  if (typeof version !== 'string') {
	    return null
	  }
	
	  if (version.length > MAX_LENGTH) {
	    return null
	  }
	
	  var r = options.loose ? re[LOOSE] : re[FULL]
	  if (!r.test(version)) {
	    return null
	  }
	
	  try {
	    return new SemVer(version, options)
	  } catch (er) {
	    return null
	  }
	}
	
	exports.valid = valid
	function valid (version, options) {
	  var v = parse(version, options)
	  return v ? v.version : null
	}
	
	exports.clean = clean
	function clean (version, options) {
	  var s = parse(version.trim().replace(/^[=v]+/, ''), options)
	  return s ? s.version : null
	}
	
	exports.SemVer = SemVer
	
	function SemVer (version, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	  if (version instanceof SemVer) {
	    if (version.loose === options.loose) {
	      return version
	    } else {
	      version = version.version
	    }
	  } else if (typeof version !== 'string') {
	    throw new TypeError('Invalid Version: ' + version)
	  }
	
	  if (version.length > MAX_LENGTH) {
	    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')
	  }
	
	  if (!(this instanceof SemVer)) {
	    return new SemVer(version, options)
	  }
	
	  debug('SemVer', version, options)
	  this.options = options
	  this.loose = !!options.loose
	
	  var m = version.trim().match(options.loose ? re[LOOSE] : re[FULL])
	
	  if (!m) {
	    throw new TypeError('Invalid Version: ' + version)
	  }
	
	  this.raw = version
	
	  // these are actually numbers
	  this.major = +m[1]
	  this.minor = +m[2]
	  this.patch = +m[3]
	
	  if (this.major > MAX_SAFE_INTEGER || this.major < 0) {
	    throw new TypeError('Invalid major version')
	  }
	
	  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) {
	    throw new TypeError('Invalid minor version')
	  }
	
	  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) {
	    throw new TypeError('Invalid patch version')
	  }
	
	  // numberify any prerelease numeric ids
	  if (!m[4]) {
	    this.prerelease = []
	  } else {
	    this.prerelease = m[4].split('.').map(function (id) {
	      if (/^[0-9]+$/.test(id)) {
	        var num = +id
	        if (num >= 0 && num < MAX_SAFE_INTEGER) {
	          return num
	        }
	      }
	      return id
	    })
	  }
	
	  this.build = m[5] ? m[5].split('.') : []
	  this.format()
	}
	
	SemVer.prototype.format = function () {
	  this.version = this.major + '.' + this.minor + '.' + this.patch
	  if (this.prerelease.length) {
	    this.version += '-' + this.prerelease.join('.')
	  }
	  return this.version
	}
	
	SemVer.prototype.toString = function () {
	  return this.version
	}
	
	SemVer.prototype.compare = function (other) {
	  debug('SemVer.compare', this.version, this.options, other)
	  if (!(other instanceof SemVer)) {
	    other = new SemVer(other, this.options)
	  }
	
	  return this.compareMain(other) || this.comparePre(other)
	}
	
	SemVer.prototype.compareMain = function (other) {
	  if (!(other instanceof SemVer)) {
	    other = new SemVer(other, this.options)
	  }
	
	  return compareIdentifiers(this.major, other.major) ||
	         compareIdentifiers(this.minor, other.minor) ||
	         compareIdentifiers(this.patch, other.patch)
	}
	
	SemVer.prototype.comparePre = function (other) {
	  if (!(other instanceof SemVer)) {
	    other = new SemVer(other, this.options)
	  }
	
	  // NOT having a prerelease is > having one
	  if (this.prerelease.length && !other.prerelease.length) {
	    return -1
	  } else if (!this.prerelease.length && other.prerelease.length) {
	    return 1
	  } else if (!this.prerelease.length && !other.prerelease.length) {
	    return 0
	  }
	
	  var i = 0
	  do {
	    var a = this.prerelease[i]
	    var b = other.prerelease[i]
	    debug('prerelease compare', i, a, b)
	    if (a === undefined && b === undefined) {
	      return 0
	    } else if (b === undefined) {
	      return 1
	    } else if (a === undefined) {
	      return -1
	    } else if (a === b) {
	      continue
	    } else {
	      return compareIdentifiers(a, b)
	    }
	  } while (++i)
	}
	
	// preminor will bump the version up to the next minor release, and immediately
	// down to pre-release. premajor and prepatch work the same way.
	SemVer.prototype.inc = function (release, identifier) {
	  switch (release) {
	    case 'premajor':
	      this.prerelease.length = 0
	      this.patch = 0
	      this.minor = 0
	      this.major++
	      this.inc('pre', identifier)
	      break
	    case 'preminor':
	      this.prerelease.length = 0
	      this.patch = 0
	      this.minor++
	      this.inc('pre', identifier)
	      break
	    case 'prepatch':
	      // If this is already a prerelease, it will bump to the next version
	      // drop any prereleases that might already exist, since they are not
	      // relevant at this point.
	      this.prerelease.length = 0
	      this.inc('patch', identifier)
	      this.inc('pre', identifier)
	      break
	    // If the input is a non-prerelease version, this acts the same as
	    // prepatch.
	    case 'prerelease':
	      if (this.prerelease.length === 0) {
	        this.inc('patch', identifier)
	      }
	      this.inc('pre', identifier)
	      break
	
	    case 'major':
	      // If this is a pre-major version, bump up to the same major version.
	      // Otherwise increment major.
	      // 1.0.0-5 bumps to 1.0.0
	      // 1.1.0 bumps to 2.0.0
	      if (this.minor !== 0 ||
	          this.patch !== 0 ||
	          this.prerelease.length === 0) {
	        this.major++
	      }
	      this.minor = 0
	      this.patch = 0
	      this.prerelease = []
	      break
	    case 'minor':
	      // If this is a pre-minor version, bump up to the same minor version.
	      // Otherwise increment minor.
	      // 1.2.0-5 bumps to 1.2.0
	      // 1.2.1 bumps to 1.3.0
	      if (this.patch !== 0 || this.prerelease.length === 0) {
	        this.minor++
	      }
	      this.patch = 0
	      this.prerelease = []
	      break
	    case 'patch':
	      // If this is not a pre-release version, it will increment the patch.
	      // If it is a pre-release it will bump up to the same patch version.
	      // 1.2.0-5 patches to 1.2.0
	      // 1.2.0 patches to 1.2.1
	      if (this.prerelease.length === 0) {
	        this.patch++
	      }
	      this.prerelease = []
	      break
	    // This probably shouldn't be used publicly.
	    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
	    case 'pre':
	      if (this.prerelease.length === 0) {
	        this.prerelease = [0]
	      } else {
	        var i = this.prerelease.length
	        while (--i >= 0) {
	          if (typeof this.prerelease[i] === 'number') {
	            this.prerelease[i]++
	            i = -2
	          }
	        }
	        if (i === -1) {
	          // didn't increment anything
	          this.prerelease.push(0)
	        }
	      }
	      if (identifier) {
	        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
	        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
	        if (this.prerelease[0] === identifier) {
	          if (isNaN(this.prerelease[1])) {
	            this.prerelease = [identifier, 0]
	          }
	        } else {
	          this.prerelease = [identifier, 0]
	        }
	      }
	      break
	
	    default:
	      throw new Error('invalid increment argument: ' + release)
	  }
	  this.format()
	  this.raw = this.version
	  return this
	}
	
	exports.inc = inc
	function inc (version, release, loose, identifier) {
	  if (typeof (loose) === 'string') {
	    identifier = loose
	    loose = undefined
	  }
	
	  try {
	    return new SemVer(version, loose).inc(release, identifier).version
	  } catch (er) {
	    return null
	  }
	}
	
	exports.diff = diff
	function diff (version1, version2) {
	  if (eq(version1, version2)) {
	    return null
	  } else {
	    var v1 = parse(version1)
	    var v2 = parse(version2)
	    var prefix = ''
	    if (v1.prerelease.length || v2.prerelease.length) {
	      prefix = 'pre'
	      var defaultResult = 'prerelease'
	    }
	    for (var key in v1) {
	      if (key === 'major' || key === 'minor' || key === 'patch') {
	        if (v1[key] !== v2[key]) {
	          return prefix + key
	        }
	      }
	    }
	    return defaultResult // may be undefined
	  }
	}
	
	exports.compareIdentifiers = compareIdentifiers
	
	var numeric = /^[0-9]+$/
	function compareIdentifiers (a, b) {
	  var anum = numeric.test(a)
	  var bnum = numeric.test(b)
	
	  if (anum && bnum) {
	    a = +a
	    b = +b
	  }
	
	  return a === b ? 0
	    : (anum && !bnum) ? -1
	    : (bnum && !anum) ? 1
	    : a < b ? -1
	    : 1
	}
	
	exports.rcompareIdentifiers = rcompareIdentifiers
	function rcompareIdentifiers (a, b) {
	  return compareIdentifiers(b, a)
	}
	
	exports.major = major
	function major (a, loose) {
	  return new SemVer(a, loose).major
	}
	
	exports.minor = minor
	function minor (a, loose) {
	  return new SemVer(a, loose).minor
	}
	
	exports.patch = patch
	function patch (a, loose) {
	  return new SemVer(a, loose).patch
	}
	
	exports.compare = compare
	function compare (a, b, loose) {
	  return new SemVer(a, loose).compare(new SemVer(b, loose))
	}
	
	exports.compareLoose = compareLoose
	function compareLoose (a, b) {
	  return compare(a, b, true)
	}
	
	exports.rcompare = rcompare
	function rcompare (a, b, loose) {
	  return compare(b, a, loose)
	}
	
	exports.sort = sort
	function sort (list, loose) {
	  return list.sort(function (a, b) {
	    return exports.compare(a, b, loose)
	  })
	}
	
	exports.rsort = rsort
	function rsort (list, loose) {
	  return list.sort(function (a, b) {
	    return exports.rcompare(a, b, loose)
	  })
	}
	
	exports.gt = gt
	function gt (a, b, loose) {
	  return compare(a, b, loose) > 0
	}
	
	exports.lt = lt
	function lt (a, b, loose) {
	  return compare(a, b, loose) < 0
	}
	
	exports.eq = eq
	function eq (a, b, loose) {
	  return compare(a, b, loose) === 0
	}
	
	exports.neq = neq
	function neq (a, b, loose) {
	  return compare(a, b, loose) !== 0
	}
	
	exports.gte = gte
	function gte (a, b, loose) {
	  return compare(a, b, loose) >= 0
	}
	
	exports.lte = lte
	function lte (a, b, loose) {
	  return compare(a, b, loose) <= 0
	}
	
	exports.cmp = cmp
	function cmp (a, op, b, loose) {
	  switch (op) {
	    case '===':
	      if (typeof a === 'object')
	        a = a.version
	      if (typeof b === 'object')
	        b = b.version
	      return a === b
	
	    case '!==':
	      if (typeof a === 'object')
	        a = a.version
	      if (typeof b === 'object')
	        b = b.version
	      return a !== b
	
	    case '':
	    case '=':
	    case '==':
	      return eq(a, b, loose)
	
	    case '!=':
	      return neq(a, b, loose)
	
	    case '>':
	      return gt(a, b, loose)
	
	    case '>=':
	      return gte(a, b, loose)
	
	    case '<':
	      return lt(a, b, loose)
	
	    case '<=':
	      return lte(a, b, loose)
	
	    default:
	      throw new TypeError('Invalid operator: ' + op)
	  }
	}
	
	exports.Comparator = Comparator
	function Comparator (comp, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  if (comp instanceof Comparator) {
	    if (comp.loose === !!options.loose) {
	      return comp
	    } else {
	      comp = comp.value
	    }
	  }
	
	  if (!(this instanceof Comparator)) {
	    return new Comparator(comp, options)
	  }
	
	  debug('comparator', comp, options)
	  this.options = options
	  this.loose = !!options.loose
	  this.parse(comp)
	
	  if (this.semver === ANY) {
	    this.value = ''
	  } else {
	    this.value = this.operator + this.semver.version
	  }
	
	  debug('comp', this)
	}
	
	var ANY = {}
	Comparator.prototype.parse = function (comp) {
	  var r = this.options.loose ? re[COMPARATORLOOSE] : re[COMPARATOR]
	  var m = comp.match(r)
	
	  if (!m) {
	    throw new TypeError('Invalid comparator: ' + comp)
	  }
	
	  this.operator = m[1]
	  if (this.operator === '=') {
	    this.operator = ''
	  }
	
	  // if it literally is just '>' or '' then allow anything.
	  if (!m[2]) {
	    this.semver = ANY
	  } else {
	    this.semver = new SemVer(m[2], this.options.loose)
	  }
	}
	
	Comparator.prototype.toString = function () {
	  return this.value
	}
	
	Comparator.prototype.test = function (version) {
	  debug('Comparator.test', version, this.options.loose)
	
	  if (this.semver === ANY) {
	    return true
	  }
	
	  if (typeof version === 'string') {
	    version = new SemVer(version, this.options)
	  }
	
	  return cmp(version, this.operator, this.semver, this.options)
	}
	
	Comparator.prototype.intersects = function (comp, options) {
	  if (!(comp instanceof Comparator)) {
	    throw new TypeError('a Comparator is required')
	  }
	
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  var rangeTmp
	
	  if (this.operator === '') {
	    rangeTmp = new Range(comp.value, options)
	    return satisfies(this.value, rangeTmp, options)
	  } else if (comp.operator === '') {
	    rangeTmp = new Range(this.value, options)
	    return satisfies(comp.semver, rangeTmp, options)
	  }
	
	  var sameDirectionIncreasing =
	    (this.operator === '>=' || this.operator === '>') &&
	    (comp.operator === '>=' || comp.operator === '>')
	  var sameDirectionDecreasing =
	    (this.operator === '<=' || this.operator === '<') &&
	    (comp.operator === '<=' || comp.operator === '<')
	  var sameSemVer = this.semver.version === comp.semver.version
	  var differentDirectionsInclusive =
	    (this.operator === '>=' || this.operator === '<=') &&
	    (comp.operator === '>=' || comp.operator === '<=')
	  var oppositeDirectionsLessThan =
	    cmp(this.semver, '<', comp.semver, options) &&
	    ((this.operator === '>=' || this.operator === '>') &&
	    (comp.operator === '<=' || comp.operator === '<'))
	  var oppositeDirectionsGreaterThan =
	    cmp(this.semver, '>', comp.semver, options) &&
	    ((this.operator === '<=' || this.operator === '<') &&
	    (comp.operator === '>=' || comp.operator === '>'))
	
	  return sameDirectionIncreasing || sameDirectionDecreasing ||
	    (sameSemVer && differentDirectionsInclusive) ||
	    oppositeDirectionsLessThan || oppositeDirectionsGreaterThan
	}
	
	exports.Range = Range
	function Range (range, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  if (range instanceof Range) {
	    if (range.loose === !!options.loose &&
	        range.includePrerelease === !!options.includePrerelease) {
	      return range
	    } else {
	      return new Range(range.raw, options)
	    }
	  }
	
	  if (range instanceof Comparator) {
	    return new Range(range.value, options)
	  }
	
	  if (!(this instanceof Range)) {
	    return new Range(range, options)
	  }
	
	  this.options = options
	  this.loose = !!options.loose
	  this.includePrerelease = !!options.includePrerelease
	
	  // First, split based on boolean or ||
	  this.raw = range
	  this.set = range.split(/\s*\|\|\s*/).map(function (range) {
	    return this.parseRange(range.trim())
	  }, this).filter(function (c) {
	    // throw out any that are not relevant for whatever reason
	    return c.length
	  })
	
	  if (!this.set.length) {
	    throw new TypeError('Invalid SemVer Range: ' + range)
	  }
	
	  this.format()
	}
	
	Range.prototype.format = function () {
	  this.range = this.set.map(function (comps) {
	    return comps.join(' ').trim()
	  }).join('||').trim()
	  return this.range
	}
	
	Range.prototype.toString = function () {
	  return this.range
	}
	
	Range.prototype.parseRange = function (range) {
	  var loose = this.options.loose
	  range = range.trim()
	  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
	  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE]
	  range = range.replace(hr, hyphenReplace)
	  debug('hyphen replace', range)
	  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
	  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace)
	  debug('comparator trim', range, re[COMPARATORTRIM])
	
	  // `~ 1.2.3` => `~1.2.3`
	  range = range.replace(re[TILDETRIM], tildeTrimReplace)
	
	  // `^ 1.2.3` => `^1.2.3`
	  range = range.replace(re[CARETTRIM], caretTrimReplace)
	
	  // normalize spaces
	  range = range.split(/\s+/).join(' ')
	
	  // At this point, the range is completely trimmed and
	  // ready to be split into comparators.
	
	  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR]
	  var set = range.split(' ').map(function (comp) {
	    return parseComparator(comp, this.options)
	  }, this).join(' ').split(/\s+/)
	  if (this.options.loose) {
	    // in loose mode, throw out any that are not valid comparators
	    set = set.filter(function (comp) {
	      return !!comp.match(compRe)
	    })
	  }
	  set = set.map(function (comp) {
	    return new Comparator(comp, this.options)
	  }, this)
	
	  return set
	}
	
	Range.prototype.intersects = function (range, options) {
	  if (!(range instanceof Range)) {
	    throw new TypeError('a Range is required')
	  }
	
	  return this.set.some(function (thisComparators) {
	    return thisComparators.every(function (thisComparator) {
	      return range.set.some(function (rangeComparators) {
	        return rangeComparators.every(function (rangeComparator) {
	          return thisComparator.intersects(rangeComparator, options)
	        })
	      })
	    })
	  })
	}
	
	// Mostly just for testing and legacy API reasons
	exports.toComparators = toComparators
	function toComparators (range, options) {
	  return new Range(range, options).set.map(function (comp) {
	    return comp.map(function (c) {
	      return c.value
	    }).join(' ').trim().split(' ')
	  })
	}
	
	// comprised of xranges, tildes, stars, and gtlt's at this point.
	// already replaced the hyphen ranges
	// turn into a set of JUST comparators.
	function parseComparator (comp, options) {
	  debug('comp', comp, options)
	  comp = replaceCarets(comp, options)
	  debug('caret', comp)
	  comp = replaceTildes(comp, options)
	  debug('tildes', comp)
	  comp = replaceXRanges(comp, options)
	  debug('xrange', comp)
	  comp = replaceStars(comp, options)
	  debug('stars', comp)
	  return comp
	}
	
	function isX (id) {
	  return !id || id.toLowerCase() === 'x' || id === '*'
	}
	
	// ~, ~> --> * (any, kinda silly)
	// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
	// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
	// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
	// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
	// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
	function replaceTildes (comp, options) {
	  return comp.trim().split(/\s+/).map(function (comp) {
	    return replaceTilde(comp, options)
	  }).join(' ')
	}
	
	function replaceTilde (comp, options) {
	  var r = options.loose ? re[TILDELOOSE] : re[TILDE]
	  return comp.replace(r, function (_, M, m, p, pr) {
	    debug('tilde', comp, _, M, m, p, pr)
	    var ret
	
	    if (isX(M)) {
	      ret = ''
	    } else if (isX(m)) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
	    } else if (isX(p)) {
	      // ~1.2 == >=1.2.0 <1.3.0
	      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
	    } else if (pr) {
	      debug('replaceTilde pr', pr)
	      ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	            ' <' + M + '.' + (+m + 1) + '.0'
	    } else {
	      // ~1.2.3 == >=1.2.3 <1.3.0
	      ret = '>=' + M + '.' + m + '.' + p +
	            ' <' + M + '.' + (+m + 1) + '.0'
	    }
	
	    debug('tilde return', ret)
	    return ret
	  })
	}
	
	// ^ --> * (any, kinda silly)
	// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
	// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
	// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
	// ^1.2.3 --> >=1.2.3 <2.0.0
	// ^1.2.0 --> >=1.2.0 <2.0.0
	function replaceCarets (comp, options) {
	  return comp.trim().split(/\s+/).map(function (comp) {
	    return replaceCaret(comp, options)
	  }).join(' ')
	}
	
	function replaceCaret (comp, options) {
	  debug('caret', comp, options)
	  var r = options.loose ? re[CARETLOOSE] : re[CARET]
	  return comp.replace(r, function (_, M, m, p, pr) {
	    debug('caret', comp, _, M, m, p, pr)
	    var ret
	
	    if (isX(M)) {
	      ret = ''
	    } else if (isX(m)) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
	    } else if (isX(p)) {
	      if (M === '0') {
	        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
	      } else {
	        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0'
	      }
	    } else if (pr) {
	      debug('replaceCaret pr', pr)
	      if (M === '0') {
	        if (m === '0') {
	          ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	                ' <' + M + '.' + m + '.' + (+p + 1)
	        } else {
	          ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	                ' <' + M + '.' + (+m + 1) + '.0'
	        }
	      } else {
	        ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	              ' <' + (+M + 1) + '.0.0'
	      }
	    } else {
	      debug('no pr')
	      if (M === '0') {
	        if (m === '0') {
	          ret = '>=' + M + '.' + m + '.' + p +
	                ' <' + M + '.' + m + '.' + (+p + 1)
	        } else {
	          ret = '>=' + M + '.' + m + '.' + p +
	                ' <' + M + '.' + (+m + 1) + '.0'
	        }
	      } else {
	        ret = '>=' + M + '.' + m + '.' + p +
	              ' <' + (+M + 1) + '.0.0'
	      }
	    }
	
	    debug('caret return', ret)
	    return ret
	  })
	}
	
	function replaceXRanges (comp, options) {
	  debug('replaceXRanges', comp, options)
	  return comp.split(/\s+/).map(function (comp) {
	    return replaceXRange(comp, options)
	  }).join(' ')
	}
	
	function replaceXRange (comp, options) {
	  comp = comp.trim()
	  var r = options.loose ? re[XRANGELOOSE] : re[XRANGE]
	  return comp.replace(r, function (ret, gtlt, M, m, p, pr) {
	    debug('xRange', comp, ret, gtlt, M, m, p, pr)
	    var xM = isX(M)
	    var xm = xM || isX(m)
	    var xp = xm || isX(p)
	    var anyX = xp
	
	    if (gtlt === '=' && anyX) {
	      gtlt = ''
	    }
	
	    if (xM) {
	      if (gtlt === '>' || gtlt === '<') {
	        // nothing is allowed
	        ret = '<0.0.0'
	      } else {
	        // nothing is forbidden
	        ret = '*'
	      }
	    } else if (gtlt && anyX) {
	      // we know patch is an x, because we have any x at all.
	      // replace X with 0
	      if (xm) {
	        m = 0
	      }
	      p = 0
	
	      if (gtlt === '>') {
	        // >1 => >=2.0.0
	        // >1.2 => >=1.3.0
	        // >1.2.3 => >= 1.2.4
	        gtlt = '>='
	        if (xm) {
	          M = +M + 1
	          m = 0
	          p = 0
	        } else {
	          m = +m + 1
	          p = 0
	        }
	      } else if (gtlt === '<=') {
	        // <=0.7.x is actually <0.8.0, since any 0.7.x should
	        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
	        gtlt = '<'
	        if (xm) {
	          M = +M + 1
	        } else {
	          m = +m + 1
	        }
	      }
	
	      ret = gtlt + M + '.' + m + '.' + p
	    } else if (xm) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
	    } else if (xp) {
	      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
	    }
	
	    debug('xRange return', ret)
	
	    return ret
	  })
	}
	
	// Because * is AND-ed with everything else in the comparator,
	// and '' means "any version", just remove the *s entirely.
	function replaceStars (comp, options) {
	  debug('replaceStars', comp, options)
	  // Looseness is ignored here.  star is always as loose as it gets!
	  return comp.trim().replace(re[STAR], '')
	}
	
	// This function is passed to string.replace(re[HYPHENRANGE])
	// M, m, patch, prerelease, build
	// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
	// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
	// 1.2 - 3.4 => >=1.2.0 <3.5.0
	function hyphenReplace ($0,
	  from, fM, fm, fp, fpr, fb,
	  to, tM, tm, tp, tpr, tb) {
	  if (isX(fM)) {
	    from = ''
	  } else if (isX(fm)) {
	    from = '>=' + fM + '.0.0'
	  } else if (isX(fp)) {
	    from = '>=' + fM + '.' + fm + '.0'
	  } else {
	    from = '>=' + from
	  }
	
	  if (isX(tM)) {
	    to = ''
	  } else if (isX(tm)) {
	    to = '<' + (+tM + 1) + '.0.0'
	  } else if (isX(tp)) {
	    to = '<' + tM + '.' + (+tm + 1) + '.0'
	  } else if (tpr) {
	    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr
	  } else {
	    to = '<=' + to
	  }
	
	  return (from + ' ' + to).trim()
	}
	
	// if ANY of the sets match ALL of its comparators, then pass
	Range.prototype.test = function (version) {
	  if (!version) {
	    return false
	  }
	
	  if (typeof version === 'string') {
	    version = new SemVer(version, this.options)
	  }
	
	  for (var i = 0; i < this.set.length; i++) {
	    if (testSet(this.set[i], version, this.options)) {
	      return true
	    }
	  }
	  return false
	}
	
	function testSet (set, version, options) {
	  for (var i = 0; i < set.length; i++) {
	    if (!set[i].test(version)) {
	      return false
	    }
	  }
	
	  if (version.prerelease.length && !options.includePrerelease) {
	    // Find the set of versions that are allowed to have prereleases
	    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
	    // That should allow `1.2.3-pr.2` to pass.
	    // However, `1.2.4-alpha.notready` should NOT be allowed,
	    // even though it's within the range set by the comparators.
	    for (i = 0; i < set.length; i++) {
	      debug(set[i].semver)
	      if (set[i].semver === ANY) {
	        continue
	      }
	
	      if (set[i].semver.prerelease.length > 0) {
	        var allowed = set[i].semver
	        if (allowed.major === version.major &&
	            allowed.minor === version.minor &&
	            allowed.patch === version.patch) {
	          return true
	        }
	      }
	    }
	
	    // Version has a -pre, but it's not one of the ones we like.
	    return false
	  }
	
	  return true
	}
	
	exports.satisfies = satisfies
	function satisfies (version, range, options) {
	  try {
	    range = new Range(range, options)
	  } catch (er) {
	    return false
	  }
	  return range.test(version)
	}
	
	exports.maxSatisfying = maxSatisfying
	function maxSatisfying (versions, range, options) {
	  var max = null
	  var maxSV = null
	  try {
	    var rangeObj = new Range(range, options)
	  } catch (er) {
	    return null
	  }
	  versions.forEach(function (v) {
	    if (rangeObj.test(v)) {
	      // satisfies(v, range, options)
	      if (!max || maxSV.compare(v) === -1) {
	        // compare(max, v, true)
	        max = v
	        maxSV = new SemVer(max, options)
	      }
	    }
	  })
	  return max
	}
	
	exports.minSatisfying = minSatisfying
	function minSatisfying (versions, range, options) {
	  var min = null
	  var minSV = null
	  try {
	    var rangeObj = new Range(range, options)
	  } catch (er) {
	    return null
	  }
	  versions.forEach(function (v) {
	    if (rangeObj.test(v)) {
	      // satisfies(v, range, options)
	      if (!min || minSV.compare(v) === 1) {
	        // compare(min, v, true)
	        min = v
	        minSV = new SemVer(min, options)
	      }
	    }
	  })
	  return min
	}
	
	exports.minVersion = minVersion
	function minVersion (range, loose) {
	  range = new Range(range, loose)
	
	  var minver = new SemVer('0.0.0')
	  if (range.test(minver)) {
	    return minver
	  }
	
	  minver = new SemVer('0.0.0-0')
	  if (range.test(minver)) {
	    return minver
	  }
	
	  minver = null
	  for (var i = 0; i < range.set.length; ++i) {
	    var comparators = range.set[i]
	
	    comparators.forEach(function (comparator) {
	      // Clone to avoid manipulating the comparator's semver object.
	      var compver = new SemVer(comparator.semver.version)
	      switch (comparator.operator) {
	        case '>':
	          if (compver.prerelease.length === 0) {
	            compver.patch++
	          } else {
	            compver.prerelease.push(0)
	          }
	          compver.raw = compver.format()
	          /* fallthrough */
	        case '':
	        case '>=':
	          if (!minver || gt(minver, compver)) {
	            minver = compver
	          }
	          break
	        case '<':
	        case '<=':
	          /* Ignore maximum versions */
	          break
	        /* istanbul ignore next */
	        default:
	          throw new Error('Unexpected operation: ' + comparator.operator)
	      }
	    })
	  }
	
	  if (minver && range.test(minver)) {
	    return minver
	  }
	
	  return null
	}
	
	exports.validRange = validRange
	function validRange (range, options) {
	  try {
	    // Return '*' instead of '' so that truthiness works.
	    // This will throw if it's invalid anyway
	    return new Range(range, options).range || '*'
	  } catch (er) {
	    return null
	  }
	}
	
	// Determine if version is less than all the versions possible in the range
	exports.ltr = ltr
	function ltr (version, range, options) {
	  return outside(version, range, '<', options)
	}
	
	// Determine if version is greater than all the versions possible in the range.
	exports.gtr = gtr
	function gtr (version, range, options) {
	  return outside(version, range, '>', options)
	}
	
	exports.outside = outside
	function outside (version, range, hilo, options) {
	  version = new SemVer(version, options)
	  range = new Range(range, options)
	
	  var gtfn, ltefn, ltfn, comp, ecomp
	  switch (hilo) {
	    case '>':
	      gtfn = gt
	      ltefn = lte
	      ltfn = lt
	      comp = '>'
	      ecomp = '>='
	      break
	    case '<':
	      gtfn = lt
	      ltefn = gte
	      ltfn = gt
	      comp = '<'
	      ecomp = '<='
	      break
	    default:
	      throw new TypeError('Must provide a hilo val of "<" or ">"')
	  }
	
	  // If it satisifes the range it is not outside
	  if (satisfies(version, range, options)) {
	    return false
	  }
	
	  // From now on, variable terms are as if we're in "gtr" mode.
	  // but note that everything is flipped for the "ltr" function.
	
	  for (var i = 0; i < range.set.length; ++i) {
	    var comparators = range.set[i]
	
	    var high = null
	    var low = null
	
	    comparators.forEach(function (comparator) {
	      if (comparator.semver === ANY) {
	        comparator = new Comparator('>=0.0.0')
	      }
	      high = high || comparator
	      low = low || comparator
	      if (gtfn(comparator.semver, high.semver, options)) {
	        high = comparator
	      } else if (ltfn(comparator.semver, low.semver, options)) {
	        low = comparator
	      }
	    })
	
	    // If the edge version comparator has a operator then our version
	    // isn't outside it
	    if (high.operator === comp || high.operator === ecomp) {
	      return false
	    }
	
	    // If the lowest version comparator has an operator and our version
	    // is less than it then it isn't higher than the range
	    if ((!low.operator || low.operator === comp) &&
	        ltefn(version, low.semver)) {
	      return false
	    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
	      return false
	    }
	  }
	  return true
	}
	
	exports.prerelease = prerelease
	function prerelease (version, options) {
	  var parsed = parse(version, options)
	  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null
	}
	
	exports.intersects = intersects
	function intersects (r1, r2, options) {
	  r1 = new Range(r1, options)
	  r2 = new Range(r2, options)
	  return r1.intersects(r2)
	}
	
	exports.coerce = coerce
	function coerce (version) {
	  if (version instanceof SemVer) {
	    return version
	  }
	
	  if (typeof version !== 'string') {
	    return null
	  }
	
	  var match = version.match(re[COERCE])
	
	  if (match == null) {
	    return null
	  }
	
	  return parse(match[1] +
	    '.' + (match[2] || '0') +
	    '.' + (match[3] || '0'))
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 4077 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016 SendBird DBA (Smile Family, Inc.)
	 * SendBird JavaScript SDK v3.0.17
	 */
	!function(root,factory){ true?module.exports=factory():"function"==typeof define&&define.amd?define([],factory()):"object"==typeof exports?exports.SendBird=factory():root.SendBird=factory()}(this,function(){var DEBUG=!1,DEBUG_HOST=!1,WS_HOST="wss://ws.sendbird.com",API_HOST="https://api.sendbird.com",DEBUG_WS_HOST="ws://localtest.me:9000",DEBUG_API_HOST="http://localtest.me:8000/api";DEBUG_HOST&&(WS_HOST=DEBUG_WS_HOST,API_HOST=DEBUG_API_HOST);var appId="",reconnectFactor=3e3,reconnectCount=0,reconnectDelay=0;try{var console=window.console||{log:function(){}}}catch(e){var console={log:function(){}}}var OS_VERSION="undefined";try{OS_VERSION=navigator.userAgent.replace(/,/g,".")}catch(e){OS_VERSION="undefined"}var _Xhr,SDK_VERSION="3.0.17",API_HEADER_PARAM="JS,"+OS_VERSION+","+SDK_VERSION+",",MIME_JSON="application/json; charset=utf-8";try{_Xhr="undefined"==typeof window?__webpack_require__(4172):null}catch(err){_Xhr=null}if(_Xhr){var Agent=__webpack_require__(840),HttpsAgent=__webpack_require__(840).HttpsAgent;try{var options={},nodejsHttpAgent=new Agent({keepAlive:!0,timeout:6e4,keepAliveTimeout:6e4});options.httpAgent=nodejsHttpAgent;var nodejsHttpsAgent=new HttpsAgent({keepAlive:!0,timeout:6e4,keepAliveTimeout:6e4});options.httpsAgent=nodejsHttpsAgent,_Xhr.nodejsSet(options)}catch(e){}}var _ajaxCall=function(url,data,method,header,cb){function _isIE(){try{if("undefined"==typeof navigator||"undefined"==typeof navigator.userAgent)return!1;var myNav=navigator.userAgent.toLowerCase();return myNav.indexOf("msie")!=-1&&parseInt(myNav.split("msie")[1])}catch(err){return!1}}var _AJAX_SUCCESS_CODE=200,_AJAX_ERROR_CODE=400;header.hasOwnProperty("SendBird")||(header.SendBird=API_HEADER_PARAM+appId);var request=_Xhr?new _Xhr:new XMLHttpRequest,_IE_version=_isIE();if(!("withCredentials"in request)&&_IE_version&&_IE_version<10){request=new XDomainRequest,request.withCredentials=!0,request.open(method,url);for(var i in header)data[i]=header[i];request.onload=function(){var resp=JSON.parse(request.responseText);resp.error?cb(null,{status:request.status,statusText:request.statusText,response:request.responseText}):cb(resp)},request.onerror=function(){cb(null,{status:404,statusText:"There was a connection error"})}}else{try{request=_Xhr?new _Xhr:new XMLHttpRequest,request.open(method,url),request.onload=function(){if(request.status>=_AJAX_SUCCESS_CODE&&request.status<_AJAX_ERROR_CODE){if("function"==typeof cb){var resp=request.responseText;cb(JSON.parse(resp),null)}}else cb(null,{status:request.status,statusText:request.statusText,response:request.responseText})},request.onerror=function(){cb(null,{status:404,statusText:"There was a connection error"})}}catch(err){request=new ActiveXObject("Microsoft.XMLHTTP"),request.open(method,url),request.onreadystatechange=function(){if(4==request.readyState)if(request.status>=_AJAX_SUCCESS_CODE&&request.status<_AJAX_ERROR_CODE){var resp=request.responseText;cb(JSON.parse(resp))}else cb(null,{status:request.status,statusText:request.statusText,reponse:request.responseText})}}try{for(var i in header)request.setRequestHeader(i,header[i]?header[i]:"sendbird")}catch(e){}}try{switch(method){case"get":case"GET":request.send();break;default:data instanceof FormData?request.send(data):(request.setRequestHeader("Content-Type",MIME_JSON),request.send(JSON.stringify(data)))}}catch(e){}},_inherit=function(){var F=function(){};return function(Parent,Child){F.prototype=new Parent,Child.prototype=new F,Child.super=Parent.prototype,Child.prototype.constructor=Child}}(),SendBirdObject=function(){var BaseMessage=function(jsonObject){this.isOpenChannel=function(){return this.channelType==BaseChannel.CHANNEL_TYPE_OPEN},this.isGroupChannel=function(){return this.channelType==BaseChannel.CHANNEL_TYPE_GROUP},this.isUserMessage=function(){return this.messageType==BaseMessage.MESSAGE_TYPE_USER},this.isAdminMessage=function(){return this.messageType==BaseMessage.MESSAGE_TYPE_ADMIN},this.isFileMessage=function(){return this.messageType==BaseMessage.MESSAGE_TYPE_FILE},this._update=function(jsonObject){this.messageId=jsonObject.hasOwnProperty("msg_id")?parseInt(jsonObject.msg_id):0,this.channelUrl=jsonObject.hasOwnProperty("channel_url")?String(jsonObject.channel_url):"",this.createdAt=jsonObject.hasOwnProperty("ts")?parseInt(jsonObject.ts):0,this.channelType=jsonObject.hasOwnProperty("channel_type")?String(jsonObject.channel_type):BaseChannel.CHANNEL_TYPE_GROUP},this.messageType=BaseMessage.MESSAGE_TYPE_BASE,jsonObject&&this._update(jsonObject)};BaseMessage.build=function(jsonObject,channel){var user,msgId,message,data,createdAt,customType,translations;switch(jsonObject.type){case"MESG":return user=new User(jsonObject.user),msgId=parseInt(jsonObject.message_id),message=String(jsonObject.message),data=String(jsonObject.data),createdAt=parseInt(jsonObject.created_at),customType=jsonObject.hasOwnProperty("custom_type")?String(jsonObject.custom_type):"",translations=jsonObject.hasOwnProperty("translations")?jsonObject.translations:{},new UserMessage(UserMessage.build("",msgId,user,channel,message,data,customType,translations,createdAt));case"FILE":user=new User(jsonObject.user),msgId=parseInt(jsonObject.message_id),message=String(jsonObject.message),createdAt=parseInt(jsonObject.created_at),customType=jsonObject.hasOwnProperty("custom_type")?String(jsonObject.custom_type):"";var file=jsonObject.file,url=String(file.url),name=String(file.name),fileType=String(file.type),size=parseInt(file.size)||0;return data=String(file.data),new FileMessage(FileMessage.build("",msgId,user,channel,url,name,fileType,size,data,customType,createdAt));case"BRDM":case"ADMM":return msgId=parseInt(jsonObject.message_id),message=String(jsonObject.message),data=String(jsonObject.data),createdAt=parseInt(jsonObject.created_at),customType=jsonObject.hasOwnProperty("custom_type")?String(jsonObject.custom_type):"",translations=jsonObject.hasOwnProperty("translations")?jsonObject.translations:{},new AdminMessage(AdminMessage.build(msgId,channel,message,data,customType,translations,createdAt))}return null},BaseMessage.MESSAGE_TYPE_BASE="base",BaseMessage.MESSAGE_TYPE_ADMIN="admin",BaseMessage.MESSAGE_TYPE_USER="user",BaseMessage.MESSAGE_TYPE_FILE="file";var AdminMessage=function(jsonObject){this.messageType=BaseMessage.MESSAGE_TYPE_ADMIN,jsonObject&&(this._update(jsonObject),this.message=String(jsonObject.message),this.data=jsonObject.hasOwnProperty("data")?String(jsonObject.data):"",this.customType=jsonObject.hasOwnProperty("custom_type")?String(jsonObject.custom_type):"",this.translations=jsonObject.hasOwnProperty("translations")?jsonObject.translations:{})};_inherit(BaseMessage,AdminMessage),AdminMessage.build=function(msgId,channel,message,data,customType,translations,createdAt){var obj={msg_id:msgId,channel_url:channel.url,channel_type:channel.isOpenChannel()?BaseChannel.CHANNEL_TYPE_OPEN:BaseChannel.CHANNEL_TYPE_GROUP,ts:createdAt,message:message,data:data};return customType&&(obj.custom_type=customType),translations&&(obj.translations=translations),obj};var UserMessage=function(jsonObject){this.messageType=BaseMessage.MESSAGE_TYPE_USER,jsonObject&&(this._update(jsonObject),this.message=String(jsonObject.message),this.data=jsonObject.hasOwnProperty("data")?String(jsonObject.data):"",this.sender=new User(jsonObject.user),this.reqId=jsonObject.hasOwnProperty("req_id")?String(jsonObject.req_id):"",this.customType=jsonObject.hasOwnProperty("custom_type")?String(jsonObject.custom_type):"",this.translations=jsonObject.hasOwnProperty("translations")?jsonObject.translations:{})};_inherit(BaseMessage,UserMessage),UserMessage.build=function(requestId,msgId,user,channel,message,data,customType,translations,createdAt){var obj={};obj.req_id=requestId,obj.msg_id=msgId,obj.channel_url=channel.url,obj.channel_type=channel.channelType==BaseChannel.CHANNEL_TYPE_OPEN?BaseChannel.CHANNEL_TYPE_OPEN:BaseChannel.CHANNEL_TYPE_GROUP,obj.ts=createdAt,obj.message=message,data&&(obj.data=data),customType&&(obj.custom_type=customType),translations&&(obj.translations=translations);var userObj={};return userObj.user_id=user.userId,userObj.nickname=user.nickname,userObj.profile_url=user.profileUrl,obj.user=userObj,obj};var FileMessage=function(jsonObject){this.messageType=BaseMessage.MESSAGE_TYPE_FILE,jsonObject&&(this._update(jsonObject),this.sender=new User(jsonObject.user),this.url=String(jsonObject.url),this.name=jsonObject.hasOwnProperty("name")?jsonObject.name:"File",this.size=parseInt(jsonObject.size)||0,this.type=String(jsonObject.type),this.data=jsonObject.hasOwnProperty("custom")?String(jsonObject.custom):"",this.reqId=jsonObject.hasOwnProperty("req_id")?String(jsonObject.req_id):"",this.customType=jsonObject.hasOwnProperty("custom_type")?String(jsonObject.custom_type):"")};_inherit(BaseMessage,FileMessage),FileMessage.build=function(requestId,msgId,user,channel,url,name,type,size,data,customType,createdAt){var obj={};obj.req_id=requestId,obj.msg_id=msgId,obj.channel_url=channel.url,obj.channel_type=channel.channelType==BaseChannel.CHANNEL_TYPE_OPEN?BaseChannel.CHANNEL_TYPE_OPEN:BaseChannel.CHANNEL_TYPE_GROUP,obj.ts=createdAt,obj.url=url,obj.name=name,obj.type=type,obj.size=size,obj.custom=data;var userObj={};return userObj.user_id=user.userId,userObj.nickname=user.nickname,userObj.profile_url=user.profileUrl,obj.user=userObj,customType&&(obj.custom_type=customType),obj};var BaseChannel=function(jsonObject){this._update=function(jsonObject){this.url=String(jsonObject.channel_url),this.name=String(jsonObject.name),this.coverUrl=String(jsonObject.cover_url),this.createdAt=jsonObject.hasOwnProperty("created_at")?1e3*jsonObject.created_at:0,this.data=String(jsonObject.data)},this.isGroupChannel=function(){return this.channelType==BaseChannel.CHANNEL_TYPE_GROUP},this.isOpenChannel=function(){return this.channelType==BaseChannel.CHANNEL_TYPE_OPEN},this.createPreviousMessageListQuery=function(){return new PreviousMessageListQuery(this)},this.createMessageListQuery=function(){return new MessageListQuery(this)},this._sendFileCommand=function(channelUrl,fileUrl,name,type,size,data,customType,callback){var requestId=Command.generateRequestId(),command=Command.bFile(requestId,channelUrl,fileUrl,name,type,size,data,customType);SendBird.getInstance().sendCommand(command,function(ackedCommand,error){if(error)return void(callback&&callback(null,error));var fileMessage=new FileMessage(ackedCommand.getJsonElement());callback&&callback(fileMessage)})},this.sendFileMessage=function(){var _SELF=this,file="",callback="",name="",type="",size="",data="";switch(arguments.length){case 2:file=arguments[0],callback=arguments[1],customType="","string"==typeof file?(name="",type="",size=0):(name=file.name,type=file.type,size=file.size);break;case 3:file=arguments[0],data=arguments[1],callback=arguments[2],customType="","string"==typeof file?(name="",type="",size=0):(name=file.name,type=file.type,size=file.size);break;case 4:file=arguments[0],data=arguments[1],customType=arguments[2],callback=arguments[3],"string"==typeof file?(name="",type="",size=0):(name=file.name,type=file.type,size=file.size);break;case 6:file=arguments[0],name=arguments[1],type=arguments[2],size=arguments[3],data=arguments[4],callback=arguments[5],customType="";break;case 7:file=arguments[0],name=arguments[1],type=arguments[2],size=arguments[3],data=arguments[4],customType=[5],callback=arguments[6]}var channelUrl=_SELF.url;"string"==typeof file?_SELF._sendFileCommand(channelUrl,file,name,type,size,data,customType,callback):APIClient.getInstance().uploadFile(file,function(response,error){if(error)return void(callback&&callback(null,error));var result=JSON.parse(response),fileUrl=result.url;_SELF._sendFileCommand(channelUrl,fileUrl,name,type,size,data,customType,callback)})},this.sendUserMessage=function(message,data,customType,targetLanguages,cb){"function"==typeof data&&(cb=data,data="",customType="",targetLanguages=[]),"function"==typeof customType&&(cb=customType,customType="",targetLanguages=[]),"function"==typeof targetLanguages&&(cb=targetLanguages,targetLanguages=[]),targetLanguages||(targetLanguages=[]),"string"==typeof targetLanguages&&(targetLanguages=[targetLanguages]);var cmd=Command.bMessage(this.url,message,data,customType,[],targetLanguages),msgObj=UserMessage.build(cmd.requestId,0,SendBird.getInstance().currentUser,this,message,data,(new Date).getTime()),msg=new UserMessage(msgObj);return SendBird.getInstance().sendCommand(cmd,function(ackedCommand,error){if(error)return void(cb&&cb(null,error));var userMessage=new UserMessage(ackedCommand.getJsonElement());cb&&cb(userMessage)}),msg},this.createMetaCounters=function(metaCounterMap,cb){APIClient.getInstance().createMetaCounters(this.isOpenChannel(),this.url,metaCounterMap,function(response,error){return error?void cb(null,error):void(cb&&cb(response))})},this.updateMetaCounters=function(metaCounterMap,upsert,cb){APIClient.getInstance().updateMetaCounters(this.isOpenChannel(),this.url,metaCounterMap,upsert,APIClient.UPDATE_META_COUNTER_MODE_SET,function(response,error){return error?void cb(null,error):void(cb&&cb(response))})},this.increaseMetaCounters=function(metaCounterMap,cb){APIClient.getInstance().updateMetaCounters(this.isOpenChannel(),this.url,metaCounterMap,!1,APIClient.UPDATE_META_COUNTER_MODE_INC,function(response,error){return error?void cb(null,error):void(cb&&cb(response))})},this.decreaseMetaCounters=function(metaCounterMap,cb){APIClient.getInstance().updateMetaCounters(this.isOpenChannel(),this.url,metaCounterMap,!1,APIClient.UPDATE_META_COUNTER_MODE_DEC,function(response,error){if(error)return void cb(null,error);var jsonObject=response,metas={};for(var i in jsonObject){var item=jsonObject[i];metas[i]=item}"function"==typeof cb&&cb(metas,null)})},this.getMetaCounters=function(keys,cb){APIClient.getInstance().getMetaCounters(this.isOpenChannel(),this.url,keys,function(response,error){return error?void cb(null,error):void("function"==typeof cb&&cb(response,null))})},this.getAllMetaCounters=function(cb){APIClient.getInstance().getAllMetaCounters(this.isOpenChannel(),this.url,function(response,error){return error?void cb(null,error):void("function"==typeof cb&&cb(response,null))})},this.deleteMetaCounter=function(key,cb){APIClient.getInstance().deleteMetaCounter(this.isOpenChannel(),this.url,key,function(response,error){return error?void cb(null,error):void(cb&&cb(response,null))})},this.deleteAllMetaCounters=function(cb){APIClient.getInstance().deleteAllMetaCounters(this.isOpenChannel(),this.url,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb(response,null))})},this.createMetaData=function(metaDataMap,cb){APIClient.getInstance().createMetaData(this.isOpenChannel(),this.url,metaDataMap,function(response,error){return error?void cb(null,error):void(cb&&cb(response,null))})},this.updateMetaData=function(metaDataMap,upsert,cb){APIClient.getInstance().updateMetaData(this.isOpenChannel(),this.url,metaDataMap,upsert,function(response,error){return error?void cb(null,error):void(cb&&cb(response,null))})},this.getMetaData=function(keys,cb){APIClient.getInstance().getMetaData(this.isOpenChannel(),this.url,keys,function(response,error){return error?void cb(null,error):void(cb&&cb(response,null))})},this.getAllMetaData=function(cb){APIClient.getInstance().getAllMetaData(this.isOpenChannel(),this.url,function(response,error){return error?void cb(null,error):void(cb&&cb(response,null))})},this.deleteMetaData=function(key,cb){APIClient.getInstance().deleteMetaData(this.isOpenChannel(),this.url,key,function(response,error){return error?void cb(null,error):void(cb&&cb(response,null))})},this.deleteAllMetaData=function(cb){APIClient.getInstance().deleteAllMetaData(this.isOpenChannel(),this.url,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb(response,null))})},this.deleteMessage=function(message,cb){var _SELF=this;return message?void APIClient.getInstance().deleteMessage(_SELF.isOpenChannel(),_SELF.url,message.messageId,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb())}):void(cb&&cb(null,new SendBirdException("Invalid arguments.",SendBirdError.INVALID_PARAMETER)))},this.channelType=BaseChannel.CHANNEL_TYPE_BASE,jsonObject&&this._update(jsonObject)};BaseChannel.CHANNEL_TYPE_OPEN="open",BaseChannel.CHANNEL_TYPE_GROUP="group",BaseChannel.CHANNEL_TYPE_BASE="base";var OpenChannel=function(jsonObject){this.parse=function(jsonObject){if(jsonObject.hasOwnProperty("participant_count")&&(this.participantCount=parseInt(jsonObject.participant_count)),jsonObject.hasOwnProperty("operators")&&jsonObject.operators){this.operators=[];for(var i in jsonObject.operators){var operator=new User(jsonObject.operators[i]);this.operators.push(operator)}}},this.refresh=function(cb){OpenChannel.getChannelWithoutCache(this.url,function(channel,error){return error?void(cb&&cb(null,error)):void(cb&&cb())})},this.update=function(jsonObject){this._update(jsonObject),this.parse(jsonObject)},this.enter=function(cb){var _SELF=this,cmd=Command.bEnter(_SELF.url);SendBird.getInstance().sendCommand(cmd,function(response,error){return error?void(cb&&cb(null,error)):(OpenChannel.enteredChannels[_SELF.url]=_SELF,void(cb&&cb(null)))})},this.exit=function(cb){var _SELF=this,cmd=Command.bExit(_SELF.url);SendBird.getInstance().sendCommand(cmd,function(response,error){return error?void(cb&&cb(null,error)):(delete OpenChannel.enteredChannels[_SELF.url],void(cb&&cb(null)))})},this.createParticipantListQuery=function(){return new UserListQuery(UserListQuery.PARTICIPANT,this)},this.createMutedUserListQuery=function(){return new UserListQuery(UserListQuery.MUTED_USER,this)},this.createBannedUserListQuery=function(){return new UserListQuery(UserListQuery.BANNED_USER,this)},this.banUser=function(user,seconds,cb){return!user||parseInt(seconds)<0?void(cb&&cb(null,new SendBirdException("Invalid parameter.",SendBirdError.INVALID_PARAMETER))):void this.banUserWithUserId(user.userId,seconds,cb)},this.banUserWithUserId=function(userId,seconds,cb){return!userId||parseInt(seconds)<0?void(cb&&cb(null,new SendBirdException("Invalid parameter.",SendBirdError.INVALID_PARAMETER))):void APIClient.getInstance().banUser(this.url,userId,null,seconds,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb())})},this.unbanUser=function(user,cb){return user?void this.unbanUserWithUserId(user.userId,cb):void(cb&&cb(null,new SendBirdException("Invalid parameter.",SendBirdError.INVALID_PARAMETER)))},this.unbanUserWithUserId=function(userId,cb){return userId?void APIClient.getInstance().unbanUser(this.url,userId,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb())}):void(cb&&cb(null,new SendBirdException("Invalid parameter.",SendBirdError.INVALID_PARAMETER)))},this.muteUser=function(user,cb){return user?void this.muteUserWithUserId(user.userId,cb):void(cb&&cb(null,new SendBirdException("Invalid parameter.",SendBirdError.INVALID_PARAMETER)))},this.muteUserWithUserId=function(userId,cb){return userId?void APIClient.getInstance().muteUser(this.url,userId,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb())}):void(cb&&cb(null,new SendBirdException("Invalid parameter.",SendBirdError.INVALID_PARAMETER)))},this.unmuteUser=function(user,cb){return user?void this.unmuteUserWithUserId(user.userId,cb):void(cb&&cb(null,new SendBirdException("Invalid parameter.",SendBirdError.INVALID_PARAMETER)))},this.unmuteUserWithUserId=function(userId,cb){return userId?void APIClient.getInstance().unmuteUser(this.url,userId,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb())}):void(cb&&cb(null,new SendBirdException("Invalid parameter.",SendBirdError.INVALID_PARAMETER)))},this.isOperator=function(user){return!!user&&this.isOperatorWithUserId(user.userId)},this.isOperatorWithUserId=function(userId){for(var i in this.operators)if(this.operators[i].userId==userId)return!0;return!1},this.channelType=BaseChannel.CHANNEL_TYPE_OPEN,this.participantCount=0,this.operators=[],jsonObject&&(this._update(jsonObject),this.parse(jsonObject))};_inherit(BaseChannel,OpenChannel),OpenChannel.enteredChannels={},OpenChannel.clearEnteredChannels=function(){OpenChannel.enteredChannels={}},OpenChannel.createOpenChannelListQuery=function(){return new OpenChannelListQuery},OpenChannel.createChannel=function(){var name,coverUrl,data,operatorUserIds,cb;switch(arguments.length){case 1:cb=arguments[0];break;case 4:name=arguments[0],coverUrl=arguments[1],data=arguments[2],cb=arguments[3];break;case 5:name=arguments[0],coverUrl=arguments[1],data=arguments[2],operatorUserIds=arguments[3],cb=arguments[4]}OpenChannel.createChannelWithOperatorUserIds(name,coverUrl,data,operatorUserIds,cb)},OpenChannel.upsert=function(jsonObject){var newChannel=new OpenChannel(jsonObject);return OpenChannel.cachedChannels.hasOwnProperty(newChannel.url)?OpenChannel.cachedChannels[newChannel.url].update(jsonObject):OpenChannel.cachedChannels[newChannel.url]=newChannel,OpenChannel.cachedChannels[newChannel.url]},OpenChannel.createChannelWithOperatorUserIds=function(name,coverUrl,data,operatorUserIds,cb){APIClient.getInstance().createOpenChannel(name,coverUrl,data,operatorUserIds,function(response,error){if(error)return void(cb&&cb(null,error));var channel=OpenChannel.upsert(response);cb&&cb(channel)})},OpenChannel.cachedChannels={},OpenChannel.clearCache=function(){OpenChannel.cachedChannels={}},OpenChannel.getChannel=function(channelUrl,cb){OpenChannel.cachedChannels.hasOwnProperty(channelUrl)?cb&&cb(OpenChannel.cachedChannels[channelUrl]):OpenChannel.getChannelWithoutCache(channelUrl,cb)},OpenChannel.getChannelWithoutCache=function(channelUrl,cb){APIClient.getInstance().getOpenChannel(channelUrl,function(response,error){return error?void(cb&&cb(null,error)):(OpenChannel.upsert(response),void(cb&&cb(OpenChannel.cachedChannels[channelUrl],null)))})};var GroupChannel=function(jsonObject){var startTypingLastSentAt,endTypingLastSentAt,cachedTypingStatus={},markAsReadScheduled=!1;this.parse=function(jsonObject){var _SELF=this;if(_SELF.isDistinct=!!jsonObject.is_distinct,_SELF.unreadMessageCount=parseInt(jsonObject.unread_message_count),jsonObject.hasOwnProperty("read_receipt")){_SELF.cachedReadReceiptStatus={};for(var key in jsonObject.read_receipt){var value=jsonObject.read_receipt[key];_SELF.updateReadReceipt(key,parseInt(value))}}if(jsonObject.hasOwnProperty("members")){_SELF.members=[],_SELF.memberMap={};var objMembers=jsonObject.members;objMembers.forEach(function(member){var user=new User(member);_SELF.members.push(user),_SELF.memberMap[user.userId]=user}),_SELF.memberCount=_SELF.members.length}jsonObject.hasOwnProperty("member_count")&&(_SELF.memberCount=parseInt(jsonObject.member_count)),jsonObject.hasOwnProperty("last_message")&&"object"==typeof jsonObject.last_message&&jsonObject.last_message?_SELF.lastMessage=BaseMessage.build(jsonObject.last_message,_SELF):_SELF.lastMessage=null},this.refresh=function(cb){GroupChannel.getChannelWithoutCache(this.url,function(channel,error){return error?void(cb&&cb(null,error)):void(cb&&cb())})},this.update=function(jsonObject){this._update(jsonObject),this.parse(jsonObject)};var userToIds=function(userId){var userIds=[];return userId instanceof User?(userIds=[],userIds.push(userId.userId),userIds):Array.isArray(userId)?(userIds=[],userId.forEach(function(user){user instanceof User&&userIds.push(user.userId),parseInt(user)>0&&userIds.push(user)}),userIds):parseInt(userId)>0?(userIds=[],userIds.push(userId),userIds):void 0};this.invite=function(_users,cb){var userIds=userToIds(_users);this.inviteWithUserIds(userIds,cb)},this.inviteWithUserIds=function(userIds,cb){APIClient.getInstance().groupChannelInvite(this.url,userIds,function(response,error){return error?void(cb&&cb(null,error)):(GroupChannel.upsert(response),void(cb&&cb(null)))})},this.hide=function(cb){APIClient.getInstance().groupChannelHide(this.url,SendBird.getInstance().currentUser.userId,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb(response))})},this.leave=function(cb){APIClient.getInstance().groupChannelLeave(this.url,SendBird.getInstance().currentUser.userId,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb())})},this.markAsRead=function(){markAsReadScheduled=!0},this.fireMarkAsRead=function(){markAsReadScheduled&&(markAsReadScheduled=!1,this.sendMarkAsRead(function(response,error){}))},this.sendMarkAsRead=function(timestamp,cb){var _SELF=this;return SendBird.getInstance().currentUser?void APIClient.getInstance().groupChannelMarkAsRead(_SELF.url,SendBird.getInstance().currentUser.userId,timestamp,function(response,error){return error?void(cb&&cb(error)):(_SELF.unreadMessageCount=0,void(cb&&cb()))}):void cb(null,new SendBirdException("Connection must be made before you mark as read.",SendBirdError.CONNECTION_REQUIRED))},this.getReadReceipt=function(message){if(message instanceof BaseMessage||console.log("message is not BaseMessage instance"),message.messageType==message.MESSAGE_TYPE_ADMIN)return 0;var me=SendBird.getInstance().currentUser,unreadMemberCount=0,createdAt=message.createdAt,members=this.members;for(var i in members){var member=members[i],key=member.userId;if(me.userId!=key){var value=this.cachedReadReceiptStatus[key];value<createdAt&&unreadMemberCount++}}return unreadMemberCount},this.getReadStatus=function(){var readStatus={};if(!SendBird.getInstance().currentUser)return readStatus;var allMembers=this.members;for(var i in allMembers){var member=allMembers[i],key=member.userId;if(member.userId!=SendBird.getInstance().currentUser.userId){var readReceiptStatus=this.cachedReadReceiptStatus[key];readStatus[key]={user:member,last_seen_at:parseInt(readReceiptStatus)}}}return readStatus},this.updateReadReceipt=function(userId,timestamp){var key=userId,value=this.cachedReadReceiptStatus[key],newValue=timestamp;(!value||value<newValue)&&(this.cachedReadReceiptStatus[key]=newValue)},this.startTyping=function(){var now=(new Date).getTime();if(!(now-startTypingLastSentAt<1e3)){endTypingLastSentAt=0,startTypingLastSentAt=now;var cmd=Command.bTypeStart(this.url,startTypingLastSentAt);SendBird.getInstance().sendCommand(cmd,null)}},this.endTyping=function(){var now=(new Date).getTime();if(!(now-endTypingLastSentAt<1e3)){startTypingLastSentAt=0,endTypingLastSentAt=now;var cmd=Command.bTypeEnd(this.url,endTypingLastSentAt);SendBird.getInstance().sendCommand(cmd,null)}},this.invalidateTypingStatus=function(){var removed=!1,now=(new Date).getTime();for(var i in cachedTypingStatus){var item=cachedTypingStatus[i];now-item>=1e4&&(delete cachedTypingStatus[i],removed=!0)}return removed},this.updateTypingStatus=function(user,start){start?cachedTypingStatus[user.userId]=(new Date).getTime():delete cachedTypingStatus[user.userId]},this.isTyping=function(){return 0!=Object.keys(cachedTypingStatus).length},this.getTypingMembers=function(){var result=[];for(var userId in cachedTypingStatus){var user=this.memberMap[userId];this.memberMap[userId]&&result.push(user)}return result},this.addMember=function(user){this.removeMember(user),this.memberMap[user.userId]=user,this.members.push(user),this.memberCount++,this.updateReadReceipt(user.userId,0)},this.removeMember=function(user){var targetUserId=user.userId;if(this.memberMap.hasOwnProperty(user.userId)){delete this.memberMap[user.userId];for(var i in this.members){var member=this.members[i];if(member.userId==targetUserId){this.members.splice(i,1);break}}this.memberCount--}},this.setPushPreference=function(pushOn,cb){return SendBird.getInstance().currentUser?void APIClient.getInstance().setPushPreference(SendBird.getInstance().currentUser.userId,this.url,pushOn,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb(response))}):void(cb&&cb(null,new SendBirdException("Connection must be made before you set push preference setting for this channel.",SendBirdError.CONNECTION_REQUIRED)))},this.getPushPreference=function(cb){return SendBird.getInstance().currentUser?void APIClient.getInstance().getPushPreference(SendBird.getInstance().currentUser.userId,this.url,function(response,error){if(error)return void(cb&&cb(null,error));if(cb){var pushOn;try{pushOn=response.enable}catch(e){pushOn=!1}cb(pushOn)}}):void(cb&&cb(null,new SendBirdException("Connection must be made before you get push preference setting for this channel.",SendBirdError.CONNECTION_REQUIRED)))},this.channelType=BaseChannel.CHANNEL_TYPE_GROUP,this.isDistinct=!1,this.unreadMessageCount=0,this.members=[],this.memberMap={},this.lastMessage={},this.memberCount=0,this.cachedReadReceiptStatus={},jsonObject&&(this._update(jsonObject),this.parse(jsonObject))};_inherit(BaseChannel,GroupChannel),GroupChannel.createMyGroupChannelListQuery=function(){return new GroupChannelListQuery(SendBird.getInstance().currentUser)},GroupChannel.getTotalUnreadMessageCount=function(cb){return SendBird.getInstance().currentUser?void APIClient.getInstance().getTotalUnreadMessageCount(SendBird.getInstance().currentUser.userId,function(response,error){if(error)return void(cb&&cb(null,error));var unreadCount=parseInt(response.unread_count);cb&&cb(unreadCount)}):void(cb&&cb(null,new SendBirdException("Connection must be made before you get total unread message count.",SendBirdError.CONNECTION_REQUIRED)))},GroupChannel.createChannel=function(){var users=null,isDistinct=null,name=null,coverUrl=null,data=null,callback=null;switch(arguments.length){case 3:users=arguments[0],isDistinct=arguments[1],callback=arguments[2];break;case 6:users=arguments[0],isDistinct=arguments[1],name=arguments[2],coverUrl=arguments[3],data=arguments[4],callback=arguments[5]}var userIds=[];users.forEach(function(user){userIds.push(user.userId)}),GroupChannel.createChannelWithUserIds(userIds,isDistinct,name,coverUrl,data,callback)},GroupChannel.createChannelWithUserIds=function(_userIds,isDistinct,name,coverUrl,data,cb){var userIdSet=_userIds.filter(function(elem,index,self){return index==self.indexOf(elem)}),me=SendBird.getInstance().currentUser;userIdSet.push(me.userId),APIClient.getInstance().createGroupChannel(userIdSet,isDistinct,name,coverUrl,data,function(response,error){if(error)return void(cb&&cb(null,error));var channel=new GroupChannel(response);GroupChannel.cachedChannels[channel.url]=channel,cb&&cb(channel,null)})},GroupChannel.cachedChannels={},GroupChannel.clearCache=function(){GroupChannel.cachedChannels={}},GroupChannel.upsert=function(jsonObject){var newChannel=new GroupChannel(jsonObject);return GroupChannel.cachedChannels.hasOwnProperty(newChannel.url)?GroupChannel.cachedChannels[newChannel.url].update(jsonObject):GroupChannel.cachedChannels[newChannel.url]=newChannel,GroupChannel.cachedChannels[newChannel.url]},GroupChannel.getChannelWithoutCache=function(channelUrl,cb){APIClient.getInstance().getGroupChannel(channelUrl,!0,!0,function(response,error){return error?void(cb&&cb(null,error)):(GroupChannel.upsert(response),void(cb&&cb(GroupChannel.cachedChannels[channelUrl],null)))})},GroupChannel.getChannel=function(channelUrl,cb){if(GroupChannel.cachedChannels.hasOwnProperty(channelUrl)){if(cb)return void cb(GroupChannel.cachedChannels[channelUrl],null)}else GroupChannel.getChannelWithoutCache(channelUrl,cb)},GroupChannel.markAsReadAllLastSentAt,GroupChannel.markAsReadAll=function(cb){var now=(new Date).getTime();return now-GroupChannel.markAsReadAllLastSentAt<1e3?void(cb&&cb(new SendBirdException("MarkAsRead rate limit exceeded.",SendBirdError.MARK_AS_READ_RATE_LIMIT_EXCEEDED))):(GroupChannel.markAsReadAllLastSentAt=now,void APIClient.getInstance().groupChannelMarkAsReadAll(SendBird.getInstance().currentUser.userId,function(response,error){if(error)return void(cb&&cb(error));for(var i in GroupChannel.cachedChannels)GroupChannel.cachedChannels[i].unreadMessageCount=0;cb&&cb(null)}))};var ChannelEvent=function(jsonObject){jsonObject&&(this.category=jsonObject.hasOwnProperty("cat")?parseInt(jsonObject.cat):0,
	this.data=jsonObject.hasOwnProperty("data")?jsonObject.data:null,this.channelUrl=jsonObject.hasOwnProperty("channel_url")?String(jsonObject.channel_url):"",this.channelType=jsonObject.hasOwnProperty("channel_type")?String(jsonObject.channel_type):BaseChannel.CHANNEL_TYPE_GROUP),this.isGroupChannel=function(){return this.channelType==BaseChannel.CHANNEL_TYPE_GROUP},this.isOpenChannel=function(){return this.channelType==BaseChannel.CHANNEL_TYPE_OPEN}};ChannelEvent.CATEGORY_NONE=0,ChannelEvent.CATEGORY_CHANNEL_ENTER=10102,ChannelEvent.CATEGORY_CHANNEL_EXIT=10103,ChannelEvent.CATEGORY_USER_CHANNEL_MUTE=10201,ChannelEvent.CATEGORY_USER_CHANNEL_UNMUTE=10200,ChannelEvent.CATEGORY_USER_CHANNEL_BAN=10601,ChannelEvent.CATEGORY_USER_CHANNEL_UNBAN=10600,ChannelEvent.CATEGORY_CHANNEL_FREEZE=10701,ChannelEvent.CATEGORY_CHANNEL_UNFREEZE=10700,ChannelEvent.CATEGORY_TYPING_START=10900,ChannelEvent.CATEGORY_TYPING_END=10901,ChannelEvent.CATEGORY_CHANNEL_JOIN=1e4,ChannelEvent.CATEGORY_CHANNEL_LEAVE=10001,ChannelEvent.CATEGORY_CHANNEL_PROP_CHANGED=11e3,ChannelEvent.CATEGORY_CHANNEL_DELETED=12e3;var ReadStatus=function(jsonObject){jsonObject&&(this.reader=new User(jsonObject.user),this.timestamp=parseInt(jsonObject.ts),this.channelUrl=jsonObject.hasOwnProperty("channel_url")?String(jsonObject.channel_url):"",this.channelType=jsonObject.hasOwnProperty("channel_type")?String(jsonObject.channel_type):BaseChannel.CHANNEL_TYPE_GROUP)},User=function(jsonObject){this.nickname="",this.profileUrl="",this.userId="",this.connectionStatus,this.lastSeenAt=null;var _SELF=this;if(jsonObject)try{jsonObject.hasOwnProperty("guest_id")&&(_SELF.userId=String(jsonObject.guest_id)),jsonObject.hasOwnProperty("user_id")&&(_SELF.userId=String(jsonObject.user_id)),jsonObject.hasOwnProperty("name")&&(_SELF.nickname=String(jsonObject.name)),jsonObject.hasOwnProperty("nickname")&&(_SELF.nickname=String(jsonObject.nickname)),jsonObject.hasOwnProperty("image")&&(_SELF.profileUrl=String(jsonObject.image)),jsonObject.hasOwnProperty("profile_url")&&(_SELF.profileUrl=String(jsonObject.profile_url)),jsonObject.hasOwnProperty("is_online")?_SELF.connectionStatus=jsonObject.is_online?User.ONLINE:User.OFFLINE:_SELF.connectionStatus=User.NON_AVAILABLE,jsonObject.hasOwnProperty("last_seen_at")?_SELF.lastSeenAt=parseInt(jsonObject.last_seen_at):_SELF.lastSeenAt=0}catch(e){console.log(e)}};User.NON_AVAILABLE="nonavailable",User.ONLINE="online",User.OFFLINE="offline",User.build=function(userId,nickname,profileUrl,isOnline,lastSeenAt){return{user_id:userId,nickname:nickname,profile_url:profileUrl,is_online:isOnline,last_seen_at:lastSeenAt}};var Command=function(_command,_payload,_requestId){this.isAckRequired=function(){return"MESG"==this.command||"FILE"==this.command||"ENTR"==this.command||"EXIT"==this.command},this.encode=function(){return this.command+this.payload+"\n"},this.decode=function(cmd){cmd=cmd.trim(),this.command=cmd.substring(0,4),this.payload=cmd.substring(4)},this.getJsonElement=function(){return JSON.parse(this.payload)},this.isRequestIdCommand=function(){return this.isAckRequired()||"EROR"==this.command},this.command,this.payload,this.requestId;var _SELF=this;if(0!=arguments.length){var reqId;switch(arguments.length){case 1:var data=arguments[0];if(!data||data.length<=4)return _SELF.command="NOOP",void(_SELF.payload="{}");if(data=data.trim(),_SELF.command=data.substring(0,4),_SELF.payload=data.substring(4),_SELF.isRequestIdCommand()){var obj=_SELF.getJsonElement();obj&&(_SELF.requestId=obj.hasOwnProperty("req_id")?obj.req_id:"")}break;case 3:reqId=arguments[2];case 2:var command=arguments[0],payload=arguments[1];reqId=reqId?reqId:"",_SELF.command=command,_SELF.requestId=reqId,_SELF.requestId||_SELF.isRequestIdCommand()&&(_SELF.requestId=Command.generateRequestId()),payload.req_id=_SELF.requestId,_SELF.payload=JSON.stringify(payload)}}};Command.bMessage=function(channelUrl,message,data,customType,mentionedUserIds,targetLanguages){var obj={};obj.channel_url=channelUrl,obj.message=message,obj.data=data,obj.mentioned=[];for(var i in mentionedUserIds){var item=mentionedUserIds[i];obj.mentioned.push(String(item))}return customType&&(obj.custom_type=customType),targetLanguages.length>0&&(obj.target_langs=targetLanguages),new Command("MESG",obj)},Command.bTypeStart=function(channelUrl,time){var obj={};return obj.channel_url=channelUrl,obj.time=time,new Command("TPST",obj)},Command.bTypeEnd=function(channelUrl,time){var obj={};return obj.channel_url=channelUrl,obj.time=time,new Command("TPEN",obj)},Command.bFile=function(requestId,channelUrl,url,name,type,size,data,customType){var obj={};return obj.channel_url=channelUrl,obj.url=url,obj.name=name,obj.type=type,obj.size=size,obj.custom=data,customType&&(obj.custom_type=customType),new Command("FILE",obj,requestId)},Command.bPing=function(){var obj={};return obj.id=(new Date).getTime(),new Command("PING",obj)},Command.bEnter=function(channelUrl){var obj={};return obj.channel_url=channelUrl,new Command("ENTR",obj)},Command.bExit=function(channelUrl){var obj={};return obj.channel_url=channelUrl,new Command("EXIT",obj)},Command.requestIdSeed=(new Date).getTime(),Command.generateRequestId=function(){return Command.requestIdSeed++,String(Command.requestIdSeed)};var GroupChannelListQuery=function(_user){this.isLoading=!1,this.limit=20,this.includeEmpty=!1,this.order=GroupChannelListQuery.ORDER_LATEST_LAST_MESSAGE,this.hasNext=!0,this.userIdsFilter=[],this.userIdsFilterExactMatch=!1,this.nicknameContainsFilter="",this.queryType="AND";var user=_user,token="",sInstance=this;this.next=function(cb){return sInstance.hasNext?(sInstance.isLoading&&cb(null,new SendBirdException("Query in progress.",SendBirdError.QUERY_IN_PROGRESS)),sInstance.isLoading=!0,void APIClient.getInstance().loadUserGroupChannelList(user.userId,token,sInstance.limit,sInstance.includeEmpty,sInstance.order,sInstance.userIdsFilter,sInstance.userIdsFilterExactMatch,sInstance.nicknameContainsFilter,sInstance.queryType,function(response,error){if(error)return sInstance.isLoading=!1,void(cb&&cb(null,error));var result=response;token=String(result.next),(!token||token.length<=0)&&(sInstance.hasNext=!1);var channelObjs=result.channels,channels=[];for(var i in channelObjs){var channel=GroupChannel.upsert(channelObjs[i]);channels.push(channel)}sInstance.isLoading=!1,cb&&cb(channels,null)})):void cb([],null)}};GroupChannelListQuery.ORDER_LATEST_LAST_MESSAGE="latest_last_message",GroupChannelListQuery.ORDER_CHRONOLOGICAL="chronological";var MessageListQuery=function(_channel){this.isLoading=!1;var channel=_channel,sInstance=this;this.next=function(messageTimestamp,limit,reverse,cb){return sInstance.isLoading?void cb(null,new SendBirdException("Query in progress.",SendBirdError.QUERY_IN_PROGRESS)):(sInstance.isLoading=!0,void APIClient.getInstance().messageList(channel.isOpenChannel(),channel.url,messageTimestamp,0,limit,!1,reverse,"",function(response,error){if(error)return sInstance.isLoading=!1,void(cb&&cb(null,error));var objs=response.messages,messages=[];for(var i in objs){var msg=BaseMessage.build(objs[i],channel);msg&&messages.push(msg)}sInstance.isLoading=!1,cb&&cb(messages)}))},this.prev=function(messageTimestamp,limit,reverse,cb){return sInstance.isLoading?void cb(null,new SendBirdException("Query in progress.",SendBirdError.QUERY_IN_PROGRESS)):(sInstance.isLoading=!0,void APIClient.getInstance().messageList(channel.isOpenChannel(),channel.url,messageTimestamp,limit,0,!1,reverse,"",function(response,error){if(error)return sInstance.isLoading=!1,void(cb&&cb(null,error));var objs=response.messages,messages=[];for(var i in objs){var msg=BaseMessage.build(objs[i],channel);msg&&messages.push(msg)}sInstance.isLoading=!1,cb&&cb(messages)}))},this.load=function(messageTimestamp,prevLimit,nextLimit,reverse,cb){return sInstance.isLoading?void cb(null,new SendBirdException("Query in progress.",SendBirdError.QUERY_IN_PROGRESS)):(sInstance.isLoading=!0,void APIClient.getInstance().messageList(channel.isOpenChannel(),channel.url,messageTimestamp,prevLimit,nextLimit,!0,reverse,"",function(response,error){if(error)return sInstance.isLoading=!1,void(cb&&cb(null,error));var objs=response.messages,messages=[];for(var i in objs){var msg=BaseMessage.build(objs[i],channel);msg&&messages.push(msg)}sInstance.isLoading=!1,cb&&cb(messages)}))}},OpenChannelListQuery=function(){var token="";this.limit=20,this.isLoading=!1,this.hasNext=!0,this.nameKeyword="",this.urlKeyword="";var sInstance=this;this.next=function(cb){return this.hasNext?this.isLoading?void cb(null,new SendBirdException("WS connection closed.",SendBirdError.QUERY_IN_PROGRESS)):(sInstance.isLoading=!0,void APIClient.getInstance().loadOpenChannelList(token,sInstance.limit,sInstance.nameKeyword,sInstance.urlKeyword,function(response,error){if(error)return sInstance.isLoading=!1,void(cb&&cb(null,error));var result=response;try{token=String(result.next)}catch(e){token=""}token||(sInstance.hasNext=!1);var channelObjs=result.channels,channels=[];channelObjs.forEach(function(item){var channel=OpenChannel.upsert(item);channels.push(channel)}),sInstance.isLoading=!1,cb(channels,null)})):void cb([],null)}},PreviousMessageListQuery=function(_channel){var channel=_channel,messageTimestamp=0x8000000000000000;this.hasMore=!0,this.isLoading=!1;var sInstance=this;this.load=function(limit,reverse,messageType,cb){if("function"==typeof messageType&&(cb=messageType,messageType=""),messageType==BaseMessage.MESSAGE_TYPE_ADMIN?messageType="ADMM":messageType==BaseMessage.MESSAGE_TYPE_USER&&(messageType="MESG"),messageType=messageType==BaseMessage.MESSAGE_TYPE_FILE?"FILE":"",sInstance.hasMore){if(sInstance.isLoading)return void cb(null,new SendBirdException("WS connection closed.",SendBirdError.QUERY_IN_PROGRESS));sInstance.isLoading=!0,APIClient.getInstance().messageList(channel.isOpenChannel(),channel.url,messageTimestamp,limit,0,!1,reverse,messageType,function(response,error){if(error)return sInstance.isLoading=!1,void(cb&&cb(null,error));var objs=response.messages,messages=[];for(var i in objs){var msg=BaseMessage.build(objs[i],channel);msg&&(messages.push(msg),msg.createdAt<=messageTimestamp&&(messageTimestamp=msg.createdAt))}(messages.length<=0||messages.length<limit)&&(sInstance.hasMore=!1),sInstance.isLoading=!1,cb&&cb(messages)})}}},UserListQuery=function(_queryType,_channel){var queryType,channel,jsonArrayName,token="";this.hasNext=!0,this.limit=20,this.isLoading=!1,this.userIds=[];var sInstance=this;switch(_channel&&(channel=_channel),queryType=_queryType){case UserListQuery.ALL_USER:case UserListQuery.BLOCKED_USER:jsonArrayName="users";break;case UserListQuery.FILTERED_USER:this.userIds=_channel,jsonArrayName="users";break;case UserListQuery.PARTICIPANT:jsonArrayName="participants";break;case UserListQuery.MUTED_USER:jsonArrayName="muted_list";break;case UserListQuery.BANNED_USER:jsonArrayName="banned_list"}this.next=function(cb){if(!sInstance.hasNext)return void(cb&&cb([],null));if(sInstance.isLoading)return void(cb&&cb(null,new SendBirdException("Query in progress.",SendBirdError.QUERY_IN_PROGRESS)));sInstance.isLoading=!0;var APIClientHandler=function(response,error){if(error)return sInstance.isLoading=!1,void(cb&&cb(null,error));token=response.next,token||(sInstance.hasNext=!1);var userObjs=response[jsonArrayName],users=[];for(var i in userObjs)_queryType==UserListQuery.BANNED_USER?users.push(new User(userObjs[i].user)):users.push(new User(userObjs[i]));sInstance.isLoading=!1,cb&&cb(users,null)};switch(queryType){case UserListQuery.ALL_USER:APIClient.getInstance().loadUserList(token,sInstance.limit,APIClientHandler);break;case UserListQuery.FILTERED_USER:APIClient.getInstance().loadUserList(token,sInstance.limit,sInstance.userIds,APIClientHandler);break;case UserListQuery.BLOCKED_USER:if(!SendBird.getInstance().currentUser)return void(cb&&cb(null,new SendBirdException("Connection must be made before you request the list.",SendBirdError.INVALID_INITIALIZATION)));APIClient.getInstance().loadBlockedUserList(SendBird.getInstance().currentUser.userId,token,sInstance.limit,APIClientHandler);break;case UserListQuery.PARTICIPANT:APIClient.getInstance().loadOpenChannelParticipantList(channel.url,token,sInstance.limit,APIClientHandler);break;case UserListQuery.MUTED_USER:APIClient.getInstance().loadOpenChannelMutedList(channel.url,token,sInstance.limit,APIClientHandler);break;case UserListQuery.BANNED_USER:APIClient.getInstance().loadOpenChannelBanList(channel.url,token,sInstance.limit,APIClientHandler)}}};UserListQuery.ALL_USER="alluser",UserListQuery.FILTERED_USER="filtereduser",UserListQuery.BLOCKED_USER="blockeduser",UserListQuery.PARTICIPANT="participant",UserListQuery.MUTED_USER="muteduser",UserListQuery.BANNED_USER="banneduser";var SendBirdError=function(){};SendBirdError.INVALID_INITIALIZATION=800100,SendBirdError.CONNECTION_REQUIRED=800101,SendBirdError.INVALID_PARAMETER=800110,SendBirdError.NETWORK_ERROR=800120,SendBirdError.NETWORK_ROUTING_ERROR=800121,SendBirdError.MALFORMED_DATA=800130,SendBirdError.MALFORMED_ERROR_DATA=800140,SendBirdError.WRONG_CHANNEL_TYPE=800150,SendBirdError.MARK_AS_READ_RATE_LIMIT_EXCEEDED=800160,SendBirdError.QUERY_IN_PROGRESS=800170,SendBirdError.ACK_TIMEOUT=800180,SendBirdError.LOGIN_TIMEOUT=800190,SendBirdError.WEBSOCKET_CONNECTION_CLOSED=800200,SendBirdError.WEBSOCKET_CONNECTION_FAILED=800210,SendBirdError.REQUEST_FAILED=800220;var SendBirdException=function(_message,_code){return this.code=_code?_code:0,this.message=_message,this},WSClient=function(WSClientHandler){var ws,connectWSHost,explicitDisconnect=!1,lastActiveMillis=0;WSClientHandler||(WSClientHandler=new WSClient.WSClientHandler);var active=function(){lastActiveMillis=(new Date).getTime()};this.getConnectionState=function(){return 1==ws.readyState?SendBird.getInstance().connectionState.OPEN:SendBird.getInstance().connectionState.CLOSED};var _pinger=function(){var pingTimer,pingTimeoutTimer,pingInterval=15e3,pingTimeoutTime=5e3;this.ping=function(){DEBUG&&console.log("PING"),clearTimeout(pingTimer),clearTimeout(pingTimeoutTimer),pingTimer=setTimeout(function(){var ping=Command.bPing();SendBird.getInstance().wsClient.send(ping),pingTimeoutTimer=setTimeout(function(){DEBUG&&console.log("PING Timeout"),clearTimeout(pingTimer),clearTimeout(pingTimeoutTimer),WSClientHandler.onError()},pingTimeoutTime)},pingInterval)},this.stop=function(){clearTimeout(pingTimer),clearTimeout(pingTimeoutTimer)}},pinger=new _pinger;this.connect=function(_user_id,_access_token,_WSHost){DEBUG&&console.log("WSClient connect called"),connectWSHost=_WSHost;var _WS=null;try{var _WS="undefined"==typeof WebSocket?__webpack_require__(4169).w3cwebsocket:WebSocket}catch(err){_WS=WebSocket}try{if(APIClient.getInstance().sessionKey)var WS_URL_PARAM="/?p=JS&pv="+encodeURIComponent(OS_VERSION)+"&sv="+encodeURIComponent(SDK_VERSION)+"&ai="+encodeURIComponent(appId)+"&key="+encodeURIComponent(APIClient.getInstance().sessionKey);else var WS_URL_PARAM="/?p=JS&pv="+encodeURIComponent(OS_VERSION)+"&sv="+encodeURIComponent(SDK_VERSION)+"&ai="+encodeURIComponent(appId)+"&user_id="+encodeURIComponent(_user_id)+"&access_token="+encodeURIComponent(_access_token);ws=new _WS(connectWSHost+WS_URL_PARAM)}catch(e){return void WSClientHandler.onError(e)}if(DEBUG)try{window.ws=ws}catch(e){}ws.onopen=function(e){pinger.ping(),DEBUG&&console.log("WSClient onopen called"),WSClientHandler.onOpen(e)},ws.onmessage=function(e){active();var data=e.data.split("\n");for(var i in data){var item=data[i];if(item&&"string"==typeof item){try{var command=item.substring(0,4);if("PONG"==command){pinger.ping();continue}}catch(e){}WSClientHandler.onMessage(item)}}},ws.onclose=function(e){DEBUG&&(console.log("WSClient ws.onclose called: ",e),console.log("WSClient ws.onclose [explicitDisconnect]: ",explicitDisconnect)),pinger.stop(),explicitDisconnect?WSClientHandler.onClose(e):WSClientHandler.onError(e),explicitDisconnect=!1},ws.onerror=function(e){DEBUG&&console.log("WSClient ws.onerror called: ",e),pinger.stop(),WSClientHandler.onError(e)}},this.disconnect=function(explicit,cb){DEBUG&&console.log("WSClient disconnect called [explicit]: ",explicit),pinger.stop(),pinger=null,explicitDisconnect=1==explicit,ws&&(ws.onopen=function(e){},ws.onmessage=function(e){},ws.onclose=function(e){cb&&cb()},ws.onerror=function(e){},ws.close(),ws=null),explicitDisconnect?WSClientHandler.onClose():WSClientHandler.onError(),explicitDisconnect=!1},this.send=function(command,cb){1!=ws.readyState?cb&&cb(null,new SendBirdException("WS connection closed.",SendBirdError.WEBSOCKET_CONNECTION_CLOSED)):(ws.send(command.encode()),cb&&cb(null))}};WSClient.WSClientHandler=function(){this.onReady=function(){},this.onOpen=function(){},this.onClose=function(){},this.onMessage=function(){},this.onError=function(){}};var APIClient=function(){var _singleton=APIClient.getInstance();if(_singleton)return _singleton;this.sessionKey;var sbRouterTimer=0;this.getTotalUnreadMessageCount=function(userId,cb){var url=APIClient.API_USERS_USERID_UNREADCOUNT.replace("%s",encodeURIComponent(userId));requestGET(url,cb)},this.checkRouting=function(cb){if(DEBUG_HOST)"function"==typeof cb&&cb({API_HOST:API_HOST,WS_HOST:WS_HOST});else{var now=(new Date).getTime()/1e3;0==sbRouterTimer||sbRouterTimer-now>300?_ajaxCall(APIClient.API_ROUTING_URL.replace("%s",appId),{},"GET",{SendBird:API_HEADER_PARAM+appId},function(result,error){return error?void cb(null,new SendBirdException("Server is unreachable.",SendBirdError.NETWORK_ROUTING_ERROR)):(WS_HOST=result.ws_server,API_HOST=result.api_server,sbRouterTimer=now,void("function"==typeof cb&&cb({API_HOST:API_HOST,WS_HOST:WS_HOST})))},function(errCode,errTxt){cb(null,new SendBirdException(errTxt,errCode))}):cb(null,null)}};var requestFILE=function(url,form,file,cb){APIClient.getInstance().checkRouting(function(result,error){if(error)cb(null,new SendBirdException("Request failed.",SendBirdError.REQUEST_FAILED));else{var request=new XMLHttpRequest;request.open("POST",API_HOST+url,!0),request.setRequestHeader("SendBird",API_HEADER_PARAM+appId),request.setRequestHeader("Session-Key",APIClient.getInstance().sessionKey);var formData=new FormData;formData.append("file",file),request.onload=function(){cb(request.response)},request.onerror=function(e){cb(null,new SendBirdException(request.statusText,SendBirdError.REQUEST_FAILED))},request.send(formData)}})},requestDELETE=function(url,params,cb){"function"==typeof params&&(cb=params,params={}),APIClient.getInstance().checkRouting(function(result,error){error?cb(null,new SendBirdException("Request failed.",SendBirdError.REQUEST_FAILED)):_ajaxCall(API_HOST+url,params,"DELETE",{"Session-Key":APIClient.getInstance().sessionKey,SendBird:API_HEADER_PARAM+appId},cb)})},encodeParams=function(params){var encodedParams="";for(var i in params){var tmp=encodeURIComponent(params[i]);encodedParams+=tmp+","}return encodedParams.length>1&&(encodedParams=encodedParams.substring(0,encodedParams.length-1)),encodedParams},requestGET=function(url,params,cb){"function"==typeof params&&(cb=params,params={});var fullUrl,urlParams="";if(params){for(var key in params)""!=urlParams&&(urlParams+="&"),urlParams+=key+"="+params[key];fullUrl=API_HOST+url+"?"+urlParams}else fullUrl=API_HOST+url;APIClient.getInstance().checkRouting(function(result,error){error?cb(null,new SendBirdException("Request failed.",SendBirdError.REQUEST_FAILED)):_ajaxCall(fullUrl,params,"GET",{"Session-Key":APIClient.getInstance().sessionKey,SendBird:API_HEADER_PARAM+appId},cb)})},requestPOST=function(url,params,cb){"function"==typeof params&&(cb=params,params={}),APIClient.getInstance().checkRouting(function(result,error){error||_ajaxCall(API_HOST+url,params,"POST",{"Session-Key":APIClient.getInstance().sessionKey,SendBird:API_HEADER_PARAM+appId},cb)})},requestPUT=function(url,params,cb){"function"==typeof params&&(cb=params,params={}),APIClient.getInstance().checkRouting(function(result,error){error||_ajaxCall(API_HOST+url,params,"PUT",{"Session-Key":APIClient.getInstance().sessionKey,SendBird:API_HEADER_PARAM+appId},cb)})};this.groupChannelInvite=function(channelUrl,_userIds,cb){var url=APIClient.API_GROUPCHANNELS_CHANNELURL_INVITE.replace("%s",encodeURIComponent(channelUrl)),form={},userIds=[];try{Array.isArray(_userIds)?userIds=_userIds:userIds.push(_userIds)}catch(e){console.log(e),cb(null,new SendBirdException("Invalid parameter.",SendBirdError.INVALID_PARAMETER))}form.user_ids=userIds,requestPOST(url,form,cb)},this.groupChannelHide=function(channelUrl,userId,cb){var url=APIClient.API_GROUPCHANNELS_CHANNELURL_HIDE.replace("%s",encodeURIComponent(channelUrl)),form={};form.user_id=userId,requestPUT(url,form,cb)},this.groupChannelLeave=function(channelUrl,userId,cb){var url=APIClient.API_GROUPCHANNELS_CHANNELURL_LEAVE.replace("%s",encodeURIComponent(channelUrl)),form={};form.user_id=userId,requestPUT(url,form,cb)},this.groupChannelMarkAsRead=function(channelUrl,userId,ts,cb){var url=APIClient.API_GROUPCHANNELS_CHANNELURL_MESSAGES_MARKASREAD.replace("%s",encodeURIComponent(channelUrl)),form={};form.user_id=userId,form.ts=ts,requestPUT(url,form,cb)},this.groupChannelMarkAsReadAll=function(userId,cb){var url=APIClient.API_USERS_USERID_MARKASREADALL.replace("%s",encodeURIComponent(userId)),form={};requestPUT(url,form,cb)},this.messageList=function(isOpenChannel,channelUrl,messageTimestamp,prevLimit,nextLimit,include,reverse,messageType,cb){var url;url=isOpenChannel?String(APIClient.API_OPENCHANNELS_CHANNELURL_MESSAGES.replace("%s",channelUrl)):String(APIClient.API_GROUPCHANNELS_CHANNELURL_MESSAGES.replace("%s",channelUrl));var params={};params.is_sdk=String(!0),params.message_ts=String(messageTimestamp),params.prev_limit=String(prevLimit),params.next_limit=String(nextLimit),params.include=String(include),params.reverse=String(reverse),messageType&&(params.message_type=String(messageType)),requestGET(url,params,cb)},this.login=function(userId,accessToken,cb){var url=APIClient.API_USERS_USERID_LOGIN.replace("%s",encodeURIComponent(userId)),form={};form.app_id=appId,accessToken&&(form.access_token=accessToken),requestPOST(url,form,function(response,error){error?cb(null,error):(APIClient.getInstance().sessionKey=response.key,cb(response,error))})},this.updateUserInfo=function(userId,nickname,profileUrl,cb){var form={};nickname&&(form.nickname=nickname),profileUrl&&(form.profile_url=profileUrl);var url=String(APIClient.API_USERS_USERID).replace("%s",encodeURIComponent(userId));requestPUT(url,form,cb)},this.getGroupChannel=function(channelUrl,member,readReceipt,cb){var url=APIClient.API_GROUPCHANNELS_CHANNELURL.replace("%s",encodeURIComponent(channelUrl)),params={member:String(member),read_receipt:String(readReceipt)};requestGET(url,params,cb)},this.getOpenChannel=function(channelUrl,cb){var url=APIClient.API_OPENCHANNELS_CHANNELURL.replace("%s",encodeURIComponent(channelUrl));requestGET(url,cb)},this.createGroupChannel=function(_userIds,isDistinct,name,coverUrlOrFile,data,cb){var url=APIClient.API_GROUPCHANNELS,userIds=[];"string"==typeof _userIds?userIds.push(_userIds):_userIds.forEach(function(userId){userIds.push(userId)});var form;coverUrlOrFile&&"string"!=typeof coverUrlOrFile?(form=new FormData,coverUrlOrFile&&form.append("cover_file",coverUrlOrFile,coverUrlOrFile.name),form.append("user_ids",userIds),form.append("is_distinct",isDistinct),name&&form.append("name",name),data&&form.append("data",data)):(form={},coverUrlOrFile&&(form.cover_url=coverUrlOrFile),form.user_ids=userIds,form.is_distinct=isDistinct,name&&(form.name=name),data&&(form.data=data)),requestPOST(url,form,cb)},this.createOpenChannel=function(name,coverUrlOrFile,data,operatorIds,cb){var form,url=String(APIClient.API_OPENCHANNELS);coverUrlOrFile&&"string"!=typeof coverUrlOrFile?(form=new FormData,coverUrlOrFile&&form.append("cover_file",coverUrlOrFile,coverUrlOrFile.name),name&&form.append("name",name),data&&form.append("data",data),operatorIds&&(Array.isArray(operatorIds)?form.append("operators",operatorIds):form.append("operators",[operatorIds]))):(form={},coverUrlOrFile&&(form.cover_url=coverUrlOrFile),name&&(form.name=name),data&&(form.data=data),operatorIds&&(Array.isArray(operatorIds)?form.operators=operatorIds:form.operators=[operatorIds])),requestPOST(url,form,cb)},this.createMetaCounters=function(isOpenChannel,channelUrl,metaCounterMap,cb){var url;url=isOpenChannel?APIClient.API_OPENCHANNELS_CHANNELURL_METACOUNTER.replace("%s",encodeURIComponent(channelUrl)):APIClient.API_GROUPCHANNELS_CHANNELURL_METACOUNTER.replace("%s",encodeURIComponent(channelUrl));var form={};form.metacounter=metaCounterMap,requestPOST(url,form,cb)},this.updateMetaCounters=function(isOpenChannel,channelUrl,metaCounterMap,upsert,mode,cb){var url;url=isOpenChannel?APIClient.API_OPENCHANNELS_CHANNELURL_METACOUNTER.replace("%s",encodeURIComponent(channelUrl)):APIClient.API_GROUPCHANNELS_CHANNELURL_METACOUNTER.replace("%s",encodeURIComponent(channelUrl));var form={};switch(form.metacounter=metaCounterMap,form.upsert=upsert,mode){case APIClient.UPDATE_META_COUNTER_MODE_SET:form.mode="set";break;case APIClient.UPDATE_META_COUNTER_MODE_INC:form.mode="increase";break;case APIClient.UPDATE_META_COUNTER_MODE_DEC:form.mode="decrease"}requestPUT(url,form,cb)},this.getAllMetaCounters=function(isOpenChannel,channelUrl,cb){this.getMetaCounters(isOpenChannel,channelUrl,{},cb)},this.getMetaCounters=function(isOpenChannel,channelUrl,keys,cb){var url;url=isOpenChannel?APIClient.API_OPENCHANNELS_CHANNELURL_METACOUNTER.replace("%s",encodeURIComponent(channelUrl)):APIClient.API_GROUPCHANNELS_CHANNELURL_METACOUNTER.replace("%s",encodeURIComponent(channelUrl));var joinedKeys=encodeParams(keys),params={keys:joinedKeys};requestGET(url,params,cb)},this.deleteMetaCounter=function(isOpenChannel,channelUrl,key,cb){var url="";url=isOpenChannel?APIClient.API_OPENCHANNELS_CHANNELURL_METACOUNTER_KEY.replace("%s",encodeURIComponent(channelUrl)).replace("%s",key):APIClient.API_GROUPCHANNELS_CHANNELURL_METACOUNTER_KEY.replace("%s",encodeURIComponent(channelUrl)).replace("%s",key);var form={};requestDELETE(url,form,cb)},this.deleteAllMetaCounters=function(isOpenChannel,channelUrl,cb){var url="";url=isOpenChannel?APIClient.API_OPENCHANNELS_CHANNELURL_METACOUNTER.replace("%s",encodeURIComponent(channelUrl)):APIClient.API_GROUPCHANNELS_CHANNELURL_METACOUNTER.replace("%s",encodeURIComponent(channelUrl));var form={};requestDELETE(url,form,cb)},this.createMetaData=function(isOpenChannel,channelUrl,metaDataMap,cb){var url="";url=isOpenChannel?APIClient.API_OPENCHANNELS_CHANNELURL_METADATA.replace("%s",encodeURIComponent(channelUrl)):APIClient.API_GROUPCHANNELS_CHANNELURL_METADATA.replace("%s",encodeURIComponent(channelUrl));var form={},metas={};for(var i in metaDataMap){var item=metaDataMap[i];metas[i]=item}form.metadata=metas,requestPOST(url,form,cb)},this.updateMetaData=function(isOpenChannel,channelUrl,metaDataMap,upsert,cb){var url="";url=isOpenChannel?APIClient.API_OPENCHANNELS_CHANNELURL_METADATA.replace("%s",encodeURIComponent(channelUrl)):APIClient.API_GROUPCHANNELS_CHANNELURL_METADATA.replace("%s",encodeURIComponent(channelUrl));var form={},metas={};for(var i in metaDataMap){var item=metaDataMap[i];metas[i]=item}form.metadata=metas,form.upsert=upsert,requestPUT(url,form,cb)},this.getAllMetaData=function(isOpenChannel,channelUrl,cb){this.getMetaData(isOpenChannel,channelUrl,{},cb)},this.getMetaData=function(isOpenChannel,channelUrl,keys,cb){var url="";url=isOpenChannel?APIClient.API_OPENCHANNELS_CHANNELURL_METADATA.replace("%s",encodeURIComponent(channelUrl)):APIClient.API_GROUPCHANNELS_CHANNELURL_METADATA.replace("%s",encodeURIComponent(channelUrl));var joinedKeys=encodeParams(keys),params={keys:joinedKeys};requestGET(url,params,cb)},this.deleteMetaData=function(isOpenChannel,channelUrl,key,cb){var url="";url=isOpenChannel?APIClient.API_OPENCHANNELS_CHANNELURL_METADATA_KEY.replace("%s",encodeURIComponent(channelUrl)).replace("%s",key):APIClient.API_GROUPCHANNELS_CHANNELURL_METADATA_KEY.replace("%s",encodeURIComponent(channelUrl)).replace("%s",key),requestDELETE(url,{},cb)},this.deleteAllMetaData=function(isOpenChannel,channelUrl,cb){var url="";url=isOpenChannel?APIClient.API_OPENCHANNELS_CHANNELURL_METADATA.replace("%s",encodeURIComponent(channelUrl)):APIClient.API_GROUPCHANNELS_CHANNELURL_METADATA.replace("%s",encodeURIComponent(channelUrl)),requestDELETE(url,{},cb)},this.loadUserList=function(token,limit,userIds,cb){var url=APIClient.API_USERS,params={token:encodeURIComponent(token),limit:String(limit)};if("function"==typeof userIds)cb=userIds;else try{var serializedUserIds="";for(var i in userIds){var userId=userIds[i];serializedUserIds+=userId+","}serializedUserIds.length>1&&(serializedUserIds=serializedUserIds.substring(0,serializedUserIds.length-1)),params.user_ids=serializedUserIds}catch(e){}requestGET(url,params,cb)},this.loadBlockedUserList=function(blockerUserId,token,limit,cb){var url=APIClient.API_USERS_USERID_BLOCK.replace("%s",encodeURIComponent(blockerUserId)),params={token:encodeURIComponent(token),limit:String(limit)};requestGET(url,params,cb)},this.loadOpenChannelList=function(token,limit,nameKeyword,urlKeyword,cb){var url=APIClient.API_OPENCHANNELS,params={token:encodeURIComponent(token),limit:String(limit)};nameKeyword&&(params.name_contains=encodeURIComponent(nameKeyword)),urlKeyword&&(params.url_contains=encodeURIComponent(urlKeyword)),requestGET(url,params,cb)},this.uploadFile=function(file,cb){requestFILE(APIClient.API_STORAGE_FILE,{},file,cb)},this.uploadProfileImage=function(file,cb){requestFILE(APIClient.API_STORAGE_PROFILE,{},file,cb)},this.loadUserGroupChannelList=function(userId,token,limit,includeEmpty,order,userIds,userIdsExactMatch,nicknameContainsFilter,queryType,cb){var url=APIClient.API_MYGROUPCHANNELS.replace("%s",encodeURIComponent(userId)),params={token:encodeURIComponent(token),limit:String(limit),show_member:!0,show_empty:String(includeEmpty),order:order};if(nicknameContainsFilter)try{params.members_nickname_contains=encodeURIComponent(nicknameContainsFilter)}catch(e){}if(userIds.length>0)try{userIdsExactMatch?params.members_exactly_in=encodeParams(userIds):(params.members_include_in=encodeParams(userIds),params.query_type=queryType)}catch(e){}requestGET(url,params,cb)},this.loadOpenChannelParticipantList=function(channelUrl,token,limit,cb){var url=APIClient.API_OPENCHANNELS_CHANNELURL_PARTICIPANTS.replace("%s",channelUrl),params={token:encodeURIComponent(token),limit:String(limit)};requestGET(url,params,cb)},this.loadOpenChannelMutedList=function(channelUrl,token,limit,cb){var url=APIClient.API_OPENCHANNELS_CHANNELURL_MUTE.replace("%s",channelUrl),params={token:encodeURIComponent(token),limit:String(limit)};requestGET(url,params,cb)},this.loadOpenChannelBanList=function(channelUrl,token,limit,cb){var url=APIClient.API_OPENCHANNELS_CHANNELURL_BAN.replace("%s",channelUrl),params={token:encodeURIComponent(token),limit:String(limit)};requestGET(url,params,cb)},this.setDoNotDisturb=function(userId,doNotDisturbOn,startHour,startMin,endHour,endMin,timezone,cb){var url=APIClient.API_USERS_USERID_PUSHPREFERENCE.replace("%s",encodeURIComponent(userId)),params={do_not_disturb:doNotDisturbOn,start_hour:startHour,start_min:startMin,end_hour:endHour,end_min:endMin,timezone:timezone};requestPUT(url,params,cb)},this.getDoNotDisturb=function(userId,cb){var url=APIClient.API_USERS_USERID_PUSHPREFERENCE.replace("%s",encodeURIComponent(userId));requestGET(url,cb)},this.setPushPreference=function(userId,channelUrl,value,cb){var url=APIClient.API_USERS_USERID_PUSHPREFERENCE_CHANNELURL.replace("%s",encodeURIComponent(userId)).replace("%s",encodeURIComponent(channelUrl)),params={};params.enable=value,requestPUT(url,params,cb)},this.getPushPreference=function(userId,channelUrl,cb){var url=APIClient.API_USERS_USERID_PUSHPREFERENCE_CHANNELURL.replace("%s",encodeURIComponent(userId)).replace("%s",encodeURIComponent(channelUrl));requestGET(url,cb)},this.registerGCMPushToken=function(userId,token,cb){var url=APIClient.API_USERS_USERID_PUSH_GCM.replace("%s",encodeURIComponent(userId)),params={
	gcm_reg_token:token};requestPOST(url,params,cb)},this.unregisterGCMPushToken=function(userId,token,cb){var url=APIClient.API_USERS_USERID_PUSH_GCM_TOKEN.replace("%s",encodeURIComponent(userId)).replace("%s",encodeURIComponent(token));requestDELETE(url,cb)},this.unregisterGCMPushTokenAll=function(userId,cb){var url=APIClient.API_USERS_USERID_PUSH_GCM.replace("%s",encodeURIComponent(userId));requestDELETE(url,cb)},this.registerAPNSPushToken=function(userId,token,cb){var url=APIClient.API_USERS_USERID_PUSH_APNS.replace("%s",encodeURIComponent(userId)),form={apns_device_token:token};requestPOST(url,form,cb)},this.unregisterAPNSPushToken=function(userId,token,cb){var url=APIClient.API_USERS_USERID_PUSH_APNS_TOKEN.replace("%s",encodeURIComponent(userId)).replace("%s",encodeURIComponent(token));requestPUT(url,cb)},this.unregisterAPNSPushTokenAll=function(userId,token,cb){var url=APIClient.API_USERS_USERID_PUSH_APNS.replace("%s",encodeURIComponent(userId));requestDELETE(url,cb)},this.blockUser=function(blockerUserId,blockeeUserId,cb){var url=APIClient.API_USERS_USERID_BLOCK.replace("%s",encodeURIComponent(blockerUserId)),params={target_id:blockeeUserId};requestPOST(url,params,cb)},this.unblockUser=function(blockerUserId,blockeeUserId,cb){var url=APIClient.API_USERS_USERID_BLOCK_TARGETID.replace("%s",encodeURIComponent(blockerUserId)).replace("%s",encodeURIComponent(blockeeUserId));requestDELETE(url,{},cb)},this.banUser=function(channelUrl,userId,description,seconds,cb){var url=APIClient.API_OPENCHANNELS_CHANNELURL_BAN.replace("%s",encodeURIComponent(channelUrl)),params={user_id:userId};description&&(params.description=description),params.seconds=String(seconds),requestPOST(url,params,cb)},this.unbanUser=function(channelUrl,userId,cb){var url=APIClient.API_OPENCHANNELS_CHANNELURL_BAN_USERID.replace("%s",encodeURIComponent(channelUrl)).replace("%s",encodeURIComponent(userId));requestDELETE(url,{},cb)},this.muteUser=function(channelUrl,userId,cb){var url=APIClient.API_OPENCHANNELS_CHANNELURL_MUTE.replace("%s",encodeURIComponent(channelUrl)),params={user_id:userId};requestPOST(url,params,cb)},this.unmuteUser=function(channelUrl,userId,cb){var url=APIClient.API_OPENCHANNELS_CHANNELURL_MUTE_USERID.replace("%s",encodeURIComponent(channelUrl)).replace("%s",encodeURIComponent(userId));requestDELETE(url,{},cb)},this.deleteMessage=function(isOpenChannel,channelUrl,messageId,cb){var url="";url=isOpenChannel?APIClient.API_OPENCHANNELS_CHANNELURL_MESSAGES_MESSAGEID.replace("%s",encodeURIComponent(channelUrl)).replace("%s",encodeURIComponent(messageId)):APIClient.API_GROUPCHANNELS_CHANNELURL_MESSAGES_MESSAGEID.replace("%s",encodeURIComponent(channelUrl)).replace("%s",encodeURIComponent(messageId)),requestDELETE(url,{},cb)}},apiClientInstance=null;APIClient.getInstance=function(){return null===apiClientInstance?null:apiClientInstance},APIClient.API_VERSION="v3",APIClient.API_ROUTING_URL="https://api-p.sendbird.com/routing/%s",APIClient.API_USERS="/%v/users".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID_LOGIN="/%v/users/%s/login".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID="/%v/users/%s".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID_UNREADCOUNT="/%v/users/%s/unread_count".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID_MARKASREADALL="/%v/users/%s/mark_as_read_all".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID_PUSH_GCM_TOKEN="/%v/users/%s/push/gcm/%s".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID_PUSH_GCM="/%v/users/%s/push/gcm".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID_PUSHPREFERENCE_CHANNELURL="/%v/users/%s/push_preference/%s".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID_PUSHPREFERENCE="/%v/users/%s/push_preference/".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID_BLOCK="/%v/users/%s/block".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID_BLOCK_TARGETID="/%v/users/%s/block/%s".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID_PUSH_APNS_TOKEN="/%v/users/%s/push/apns/%s".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID_PUSH_APNS="/%v/users/%s/push/apns".replace("%v",APIClient.API_VERSION),APIClient.API_USERS_USERID_PUSH="/%v/users/%s/push".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS="/%v/open_channels".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS_CHANNELURL="/%v/open_channels/%s".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS_CHANNELURL_MESSAGES="/%v/open_channels/%s/messages".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS_CHANNELURL_MESSAGES_MESSAGEID="/%v/open_channels/%s/messages/%s".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS_CHANNELURL_PARTICIPANTS="/%v/open_channels/%s/participants".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS_CHANNELURL_METADATA="/%v/open_channels/%s/metadata".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS_CHANNELURL_METADATA_KEY="/%v/open_channels/%s/metadata/%s".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS_CHANNELURL_METACOUNTER="/%v/open_channels/%s/metacounter".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS_CHANNELURL_METACOUNTER_KEY="/%v/open_channels/%s/metacounter/%s".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS_CHANNELURL_BAN="/%v/open_channels/%s/ban".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS_CHANNELURL_BAN_USERID="/%v/open_channels/%s/ban/%s".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS_CHANNELURL_MUTE="/%v/open_channels/%s/mute".replace("%v",APIClient.API_VERSION),APIClient.API_OPENCHANNELS_CHANNELURL_MUTE_USERID="/%v/open_channels/%s/mute/%s".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS="/%v/group_channels".replace("%v",APIClient.API_VERSION),APIClient.API_MYGROUPCHANNELS="/%v/users/%s/my_group_channels".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL="/%v/group_channels/%s".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_INVITE="/%v/group_channels/%s/invite".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_HIDE="/%v/group_channels/%s/hide".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_LEAVE="/%v/group_channels/%s/leave".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_MESSAGES="/%v/group_channels/%s/messages".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_MESSAGES_MARKASREAD="/%v/group_channels/%s/messages/mark_as_read".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_MESSAGES_TOTALCOUNT="/%v/group_channels/%s/messages/total_count".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_MESSAGES_UNREADCOUNT="/%v/group_channels/%s/messages/unread_count".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_MESSAGES_MESSAGEID="/%v/group_channels/%s/messages/%s".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_MEMBERS="/%v/group_channels/%s/members".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_METADATA="/%v/group_channels/%s/metadata".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_METADATA_KEY="/%v/group_channels/%s/metadata/%s".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_METACOUNTER="/%v/group_channels/%s/metacounter".replace("%v",APIClient.API_VERSION),APIClient.API_GROUPCHANNELS_CHANNELURL_METACOUNTER_KEY="/%v/group_channels/%s/metacounter/%s".replace("%v",APIClient.API_VERSION),APIClient.API_STORAGE_FILE="/%v/storage/file".replace("%v",APIClient.API_VERSION),APIClient.API_STORAGE_PROFILE="/%v/storage/profile".replace("%v",APIClient.API_VERSION),APIClient.UPDATE_META_COUNTER_MODE_SET=0,APIClient.UPDATE_META_COUNTER_MODE_INC=1,APIClient.UPDATE_META_COUNTER_MODE_DEC=2;var SendBird=function(_initParams){var _singleton=SendBird.getInstance();if(_singleton)return _singleton;try{if(!_initParams.hasOwnProperty("appId"))return console.log("Must be set appId"),{}}catch(e){return console.log("Must be set appId"),{}}this.GCMPushToken="",this.APNSPushToken="",this.pushTokenRegistrationState={SUCCESS:"success",PENDING:"pending",ERROR:"error"},this.loginTimer,this.onLoginTimerCancel,this.globalTimer,this.reconnectTimer,this.onReconnectTimerCancel,this.currentUser=null,this.wsClient,this.connectionState={CONNECTING:"CONNECTING",OPEN:"OPEN",CLOSING:"CLOSING",CLOSED:"CLOSED"},this.ConnectionState=this.connectionState,this.OpenChannel=OpenChannel,this.GroupChannel=GroupChannel,this.UserMessage=UserMessage,this.channelHandlers={},this.connectionHandlers={};var ackStateMap={},CMD_ACK_TIMEOUT=1e4;appId=_initParams.appId,sendbirdInstance=this,apiClientInstance=APIClient.getInstance(),apiClientInstance||(apiClientInstance=new APIClient),this.ChannelHandler=function(){this.onMessageReceived=function(channel,message){},this.onMessageDeleted=function(channel,msgId){},this.onReadReceiptUpdated=function(channel){},this.onTypingStatusUpdated=function(channel){},this.onUserJoined=function(channel,user){},this.onUserLeft=function(channel,user){},this.onUserEntered=function(channel,user){},this.onUserExited=function(channel,user){},this.onUserMuted=function(channel,user){},this.onUserUnmuted=function(channel,user){},this.onUserBanned=function(channel,user){},this.onUserUnbanned=function(channel,user){},this.onChannelFrozen=function(channel){},this.onChannelUnfrozen=function(channel){},this.onChannelChanged=function(channel){},this.onChannelDeleted=function(channel){}},this.addChannelHandler=function(id,handler){SendBird.getInstance().channelHandlers[id]=handler},this.removeChannelHandler=function(id){delete SendBird.getInstance().channelHandlers[id]},this.ConnectionHandler=function(){this.onReconnectStarted=function(){},this.onReconnectSucceeded=function(){},this.onReconnectFailed=function(){}},this.addConnectionHandler=function(id,cb){SendBird.getInstance().connectionHandlers[id]=cb},this.removeConnectionHandler=function(id){delete SendBird.getInstance().connectionHandlers[id]},this.createUserListQuery=function(userIds){return userIds?new UserListQuery(UserListQuery.FILTERED_USER,userIds):new UserListQuery(UserListQuery.ALL_USER)},this.createBlockedUserListQuery=function(){return new UserListQuery(UserListQuery.BLOCKED_USER)},this.getApplicationId=function(){return appId},this.getDebugMode=function(){return DEBUG},this.setDebugMode=function(isDebug){DEBUG=isDebug},this.setDebugHostMode=function(isDebug){DEBUG_HOST=isDebug},this.setAPIHost=function(host){API_HOST=host},this.setWSHost=function(host){WS_HOST=host},this.getConnectionState=function(){if(!SendBird.getInstance())return this.connectionState.CLOSED;try{return SendBird.getInstance().wsClient?SendBird.getInstance().wsClient.getConnectionState():SendBird.getInstance().connectionState.CLOSED}catch(e){return SendBird.getInstance().connectionState.CLOSED}};var getAckInfo=function(requestId){return ackStateMap.hasOwnProperty(requestId)?ackStateMap[requestId]:null},messageReceived=function(message){var cmd=new Command(message);if(cmd.requestId){var ackInfo=getAckInfo(cmd.requestId);if(null==ackInfo)return;clearTimeout(ackInfo.timer);var cb=ackInfo.handler;if(cb)if("EROR"==cmd.command){var error=cmd.getJsonElement(),errCode=error.code,errMessage=error.message;cb(cmd,new SendBirdException(errMessage,errCode))}else cb(cmd,null)}else switch(cmd.command){case"LOGI":if(SendBird.getInstance().loginTimer)if(clearTimeout(SendBird.getInstance().loginTimer),SendBird.getInstance().loginTimer=null,SendBird.getInstance().onLoginTimerCancel=null,logiPayload=cmd.getJsonElement(),logiPayload.hasOwnProperty("error")){var errCode=logiPayload.code,errMessage=logiPayload.message;SendBird.getInstance().loginHandler(null,new SendBirdException(errMessage,errCode))}else logiPayload.hasOwnProperty("key")&&(APIClient.getInstance().sessionKey=logiPayload.key),logiPayload.hasOwnProperty("user_id")&&(SendBird.getInstance().currentUser=new User(logiPayload)),SendBird.getInstance().loginHandler(SendBird.getInstance().currentUser,null);break;case"MESG":case"FILE":case"BRDM":case"ADMM":var msg="";if(msg="MESG"==cmd.command?new UserMessage(cmd.getJsonElement()):"FILE"==cmd.command?new FileMessage(cmd.getJsonElement()):new AdminMessage(cmd.getJsonElement()),!msg)return;msg.isGroupChannel()?GroupChannel.getChannel(msg.channelUrl,function(channel,error){if(error)return void(cb&&cb(null,error));channel.lastMessage=msg,msg.sender&&msg.sender.userId==SendBird.getInstance().currentUser.userId||channel.unreadMessageCount++;for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onMessageReceived(channel,msg)}}):OpenChannel.getChannel(msg.channelUrl,function(channel,error){if(error)return void(cb&&cb(null,error));for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onMessageReceived(channel,msg)}});break;case"READ":var rst=new ReadStatus(cmd.getJsonElement());GroupChannel.getChannel(rst.channelUrl,function(channel,error){if(error)return void(cb&&cb(null,error));channel.updateReadReceipt(rst.reader.userId,rst.timestamp);for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onReadReceiptUpdated(channel)}});break;case"TPST":case"TPEN":break;case"MTIO":break;case"SYEV":processChannelEvent(cmd);break;case"DELM":var obj=cmd.getJsonElement(),channelType=String(obj.channel_type),channelUrl=String(obj.channel_url),msgId=String(obj.msg_id);switch(channelType){case BaseChannel.CHANNEL_TYPE_OPEN:OpenChannel.getChannel(channelUrl,function(channel,error){if(error)return void console.log("Discard a command.");for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onMessageDeleted(channel,msgId)}});break;case BaseChannel.CHANNEL_TYPE_GROUP:GroupChannel.getChannel(channelUrl,function(channel,error){if(error)return void console.log("Discard a command.");for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onMessageDeleted(channel,msgId)}})}break;case"LEAV":break;case"JOIN":break;case"PONG":}},processChannelEvent=function(cmd){var event=new ChannelEvent(cmd.getJsonElement());switch(event.category){case ChannelEvent.CATEGORY_CHANNEL_JOIN:case ChannelEvent.CATEGORY_CHANNEL_LEAVE:GroupChannel.getChannel(event.channelUrl,function(channel,error){if(error)return void console.log("Discard a command: "+cmd.command+":"+event.category);var user=new User(event.data);if(event.category==ChannelEvent.CATEGORY_CHANNEL_JOIN){channel.addMember(user);for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onUserJoined(channel,user)}}else{channel.removeMember(user);for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onUserLeft(channel,user)}}});break;case ChannelEvent.CATEGORY_TYPING_START:case ChannelEvent.CATEGORY_TYPING_END:GroupChannel.getChannel(event.channelUrl,function(channel,error){if(error)return void console.log("Discard a command: "+cmd.command+":"+event.category);var user=new User(event.data);event.category==ChannelEvent.CATEGORY_TYPING_START?channel.updateTypingStatus(user,!0):channel.updateTypingStatus(user,!1);for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onTypingStatusUpdated(channel)}});break;case ChannelEvent.CATEGORY_CHANNEL_ENTER:case ChannelEvent.CATEGORY_CHANNEL_EXIT:OpenChannel.getChannel(event.channelUrl,function(channel,error){if(error)return void console.log("Discard a command: "+cmd.command+":"+event.category);event.data.hasOwnProperty("participant_count")&&(channel.participantCount=event.data.participant_count);var user=new User(event.data);if(event.category==ChannelEvent.CATEGORY_CHANNEL_ENTER)for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onUserEntered(channel,user)}else for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onUserExited(channel,user)}});break;case ChannelEvent.CATEGORY_USER_CHANNEL_MUTE:case ChannelEvent.CATEGORY_USER_CHANNEL_UNMUTE:OpenChannel.getChannel(event.channelUrl,function(channel,error){if(error)return void console.log("Discard a command: "+cmd.command+":"+event.category);var user=new User(event.data);if(event.category==ChannelEvent.CATEGORY_USER_CHANNEL_MUTE)for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onUserMuted(channel,user)}else for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onUserUnmuted(channel,user)}});break;case ChannelEvent.CATEGORY_USER_CHANNEL_BAN:case ChannelEvent.CATEGORY_USER_CHANNEL_UNBAN:OpenChannel.getChannel(event.channelUrl,function(channel,error){if(error)return void console.log("Discard a command: "+cmd.command+":"+event.category);var user=new User(event.data);if(event.category==ChannelEvent.CATEGORY_USER_CHANNEL_BAN)for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onUserBanned(channel,user)}else for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onUserUnbanned(channel,user)}});break;case ChannelEvent.CATEGORY_CHANNEL_FREEZE:case ChannelEvent.CATEGORY_CHANNEL_UNFREEZE:OpenChannel.getChannel(event.channelUrl,function(channel,error){if(error)return void console.log("Discard a command: "+cmd.command+":"+event.category);if(event.category==ChannelEvent.CATEGORY_CHANNEL_FREEZE)for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onChannelFrozen(channel)}else for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onChannelUnfrozen(channel)}});break;case ChannelEvent.CATEGORY_CHANNEL_DELETED:if(event.isGroupChannel())for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onChannelDeleted(event.channelUrl,"group")}else for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onChannelDeleted(event.channelUrl,"open")}break;case ChannelEvent.CATEGORY_CHANNEL_PROP_CHANGED:event.isOpenChannel()?OpenChannel.getChannelWithoutCache(event.channelUrl,function(channel,error){if(error)return void console.log("Discard a command: "+cmd.command+":"+event.category);for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onChannelChanged(channel)}}):GroupChannel.getChannelWithoutCache(event.channelUrl,function(channel,error){if(error)return void console.log("Discard a command: "+cmd.command+":"+event.category);for(var i in SendBird.getInstance().channelHandlers){var handler=SendBird.getInstance().channelHandlers[i];handler.onChannelChanged(channel)}})}};this.connect=function(userId,accessToken,cb){"function"==typeof accessToken&&(cb=accessToken,accessToken=null),disconnectWithLogout(!0,null),connectWS(userId,accessToken,cb)};var isBackgroundMode=!1,notClosed=!1;this.setBackgroundState=function(){isBackgroundMode||(isBackgroundMode=!0,this.getConnectionState()!=this.connectionState.CLOSED?(notClosed=!0,disconnectWithLogout(!1,null)):notClosed=!1)},this.setForegroundState=function(){isBackgroundMode&&(isBackgroundMode=!1,notClosed&&this.currentUser&&(reconnectCount=0,reconnectWS(this.currentUser.userId)))},this.disconnect=function(cb){disconnectWithLogout(!0,cb)};var disconnectWithLogout=function(isLogout,cb){if(SendBird.getInstance().loginTimer&&(clearTimeout(SendBird.getInstance().loginTimer),SendBird.getInstance().onLoginTimerCancel&&(SendBird.getInstance().onLoginTimerCancel(),SendBird.getInstance().onLoginTimerCancel=null),SendBird.getInstance().loginTimer=null),SendBird.getInstance().reconnectTimer&&(clearTimeout(SendBird.getInstance().reconnectTimer),SendBird.getInsance().onReconnectTimerCancel&&(SendBird.getInsance().onReconnectTimerCancel(),SendBird.getInsance().onReconnectTimerCancel=null),SendBird.getInstance().reconnectTimer=null),SendBird.getInstance().wsClient&&(reconnectCount=0,SendBird.getInstance().wsClient.disconnect(!0),SendBird.getInstance().wsClient=null),isLogout){OpenChannel.clearEnteredChannels(),OpenChannel.clearCache(),GroupChannel.clearCache(),SendBird.getInstance().globalTimer&&(clearTimeout(this.globalTimer),SendBird.getInstance().globalTimer=null);for(var reqId in SendBird.getInstance().ackStateMap)clearTimeout(SendBird.getInstance().ackStateMap[reqId].timer);SendBird.getInstance().ackStateMap={},SendBird.getInstance().connectionHandlers={},SendBird.getInstance().channelHandlers={},SendBird.getInstance().currentUser=null,APIClient.getInstance().sessionKey=null}cb&&cb()},reconnectWS=function(userId){if(SendBird.getInstance().reconnectTimer)DEBUG&&console.log("still reconnecting");else{if(reconnectCount+=1,reconnectCount<=1){for(var i in SendBird.getInstance().connectionHandlers){var handler=SendBird.getInstance().connectionHandlers[i];handler.onReconnectStarted(i)}reconnectDelay=0}else reconnectDelay=reconnectFactor*Math.pow(2,reconnectCount-2);if(!userId||!APIClient.getInstance().sessionKey||reconnectCount>=6){SendBird.getInstance().disconnect(null),reconnectCount=0;for(var i in SendBird.getInstance().connectionHandlers){var handler=SendBird.getInstance().connectionHandlers[i];handler.onReconnectFailed(i)}return}SendBird.getInstance().onReconnectTimerCancel=function(){reconnectCount=0;for(var i in SendBird.getInstance().connectionHandlers){var handler=SendBird.getInstance().connectionHandlers[i];handler.onReconnectFailed(i)}},SendBird.getInstance().reconnectTimer=setTimeout(function(){SendBird.getInstance().reconnectTimer=null,SendBird.getInstance().onReconnectTimerCancel=null,SendBird.getInstance().wsClient&&SendBird.getInstance().wsClient.disconnect(!0);var WSClientHandler=new WSClient.WSClientHandler;SendBird.getInstance().wsClient=new WSClient(WSClientHandler),SendBird.getInstance().loginHandler=function(user){for(var i in OpenChannel.enteredChannels){var channel=OpenChannel.enteredChannels[i];channel.enter()}for(var i in SendBird.getInstance().connectionHandlers){var handler=SendBird.getInstance().connectionHandlers[i];handler.onReconnectSucceeded(i)}reconnectCount=0},WSClientHandler.onOpen=function(e){DEBUG&&console.log("reconnectWS onOpen"),SendBird.getInstance().loginTimer=setTimeout(function(){DEBUG&&console.log("reconnectWS loginTimer timedout"),SendBird.getInstance().loginTimer=null,reconnectWS(userId)},CMD_ACK_TIMEOUT),SendBird.getInstance().onLoginTimerCancel=null},WSClientHandler.onMessage=function(message){messageReceived(message)},WSClientHandler.onError=function(message){DEBUG&&console.log("reconnectWS onError"),reconnectWS(userId)},WSClientHandler.onClose=function(message){DEBUG&&console.log("reconnectWS onClose")};var API_HOST_OLD=API_HOST;APIClient.getInstance().checkRouting(function(result,error){return error?void reconnectWS(userId):(API_HOST_OLD!=API_HOST&&_ajaxCall(API_HOST,{},"GET",{},null),void SendBird.getInstance().wsClient.connect(userId,null,WS_HOST))})},reconnectDelay)}},connectWS=function(userId,accessToken,cb){var WSClientHandler=new WSClient.WSClientHandler;SendBird.getInstance().wsClient=new WSClient(WSClientHandler),WSClientHandler.onMessage=function(message){messageReceived(message)},SendBird.getInstance().loginHandler=function(user,sendbirdException){if(sendbirdException)SendBird.getInstance().disconnect(null),cb&&cb(null,sendbirdException);else{clearTimeout(SendBird.getInstance().globalTimer);var globalTimerLoop=function(){if(GroupChannel.cachedChannels)for(var i in GroupChannel.cachedChannels){var channel=GroupChannel.cachedChannels[i];if(channel.fireMarkAsRead(),channel.invalidateTypingStatus())for(var i2 in SendBird.getInstance().channelHandlers){var channelHandler=SendBird.getInstance().channelHandlers[i2];channelHandler.onTypingStatusUpdated(channel)}}SendBird.getInstance().globalTimer=setTimeout(function(){globalTimerLoop()},1e3)};globalTimerLoop(),cb&&cb(user,null)}},WSClientHandler.onOpen=function(e){SendBird.getInstance().loginTimer=setTimeout(function(){SendBird.getInstance().loginTimer=null,SendBird.getInstance().onLoginTimerCancel=null,SendBird.getInstance().disconnect(null),cb&&cb(null,new SendBirdException("Connection timeout.",SendBirdError.LOGIN_TIMEOUT))},CMD_ACK_TIMEOUT),SendBird.getInstance().onLoginTimerCancel=function(){cb&&cb(null,new SendBirdException("Connection Cancelled.",SendBirdError.REQUEST_FAILED))}},WSClientHandler.onError=function(error){DEBUG&&console.log("WSClientHandler.onError",error),reconnectWS(userId)},WSClientHandler.onClose=function(message){DEBUG&&console.log("WSClientHandler.onClose")},APIClient.getInstance().checkRouting(function(result,error){return error?void(cb&&cb(null,new SendBirdException("Connection routing failed.",SendBirdError.REQUEST_FAILED))):(_ajaxCall(API_HOST,{},"GET",{},null),void SendBird.getInstance().wsClient.connect(userId,accessToken,WS_HOST))})};this.sendCommand=function(cmd,cb){if(null==SendBird.getInstance().wsClient||SendBird.getInstance().wsClient.getConnectionState()!=SendBird.getInstance().connectionState.OPEN)return void(cb&&cb(null,new SendBirdException("WS connection closed.",SendBirdError.WEBSOCKET_CONNECTION_CLOSED)));if(cmd.isAckRequired()){var reqId=cmd.requestId,obj={handler:cb,timer:setTimeout(function(){cb(null,new SendBirdException("Command received no ack.",SendBirdError.ACK_TIMEOUT)),delete ackStateMap[reqId]},CMD_ACK_TIMEOUT)};ackStateMap[reqId]=obj,SendBird.getInstance().wsClient.send(cmd,function(response,error){if(error)return clearTimeout(obj.timer),void cb(null,error)})}else SendBird.getInstance().wsClient.send(cmd,cb)},this.updateCurrentUserInfoWithProfileImage=function(nickname,profileImage,cb){var _SELF=this;return _SELF.currentUser?void(profileImage?APIClient.getInstance().uploadProfileImage(profileImage,function(response,error){if(error)return void(cb&&cb(error));var fileUrl=response.url;_SELF.updateCurrentUserInfo(nickname,fileUrl,cb)}):_SELF.updateCurrentUserInfo(nickname,null,cb)):void(cb&&cb(null,new SendBirdException("Connection must be made before you update user information.",SendBirdError.INVALID_INITIALIZATION)))},this.updateCurrentUserInfo=function(nickname,profileUrl,cb){var _SELF=this;return _SELF.currentUser?void APIClient.getInstance().updateUserInfo(_SELF.currentUser.userId,nickname,profileUrl,function(response,error){return error?void(cb&&cb(null,error)):(nickname&&(_SELF.currentUser.nickname=nickname),profileUrl&&(_SELF.currentUser.profileUrl=profileUrl),void(cb&&cb()))}):void(cb&&cb(null,new SendBirdException("Connection must be made before you update user information.",SendBirdError.INVALID_INITIALIZATION)))},this.getPendingGCMToken=function(){return this.GCMPushToken},this.getPendingAPNSToken=function(){return this.APNSPushToken},this.registerGCMPushTokenForCurrentUser=function(gcmRegToken,cb){var _SELF=this;return gcmRegToken?this.currentUser?void APIClient.getInstance().registerGCMPushToken(this.currentUser.userId,gcmRegToken,function(response,error){return error?void(cb&&cb(_SELF.pushTokenRegistrationState.ERROR,error)):(_SELF.GCMPushToken="",void(cb&&cb(_SELF.pushTokenRegistrationState.SUCCESS)))}):(_SELF.GCMPushToken=gcmRegToken,void cb(_SELF.pushTokenRegistrationState.PENDING)):void cb(_SELF.pushTokenRegistrationState.ERROR,new SendBirdException("Invalid token",SendBirdError.INVALID_PARAMETER))},this.unregisterGCMPushTokenForCurrentUser=function(gcmRegToken,cb){return this.currentUser?gcmRegToken?void APIClient.getInstance().unregisterGCMPushToken(this.currentUser.userId,gcmRegToken,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb())}):void cb(null,new SendBirdException("Invalid token",SendBirdError.INVALID_PARAMETER)):void cb(null,new SendBirdException("Connection must be made before you unregister push token.",SendBirdError.INVALID_INITIALIZATION))},this.unregisterGCMPushTokenAllForCurrentUser=function(cb){return this.currentUser?void APIClient.getInstance().unregisterGCMPushTokenAll(this.currentUser.userId,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb())}):void cb(null,new SendBirdException("Connection must be made before you unregister push token.",SendBirdError.INVALID_INITIALIZATION))},this.registerAPNSPushTokenForCurrentUser=function(apnsRegToken,cb){var _SELF=this;return apnsRegToken?this.currentUser?void APIClient.getInstance().registerAPNSPushToken(this.currentUser.userId,apnsRegToken,function(response,error){return error?void(cb&&cb(_SELF.pushTokenRegistrationState.ERROR,error)):(_SELF.APNSPushToken="",void(cb&&cb(_SELF.pushTokenRegistrationState.SUCCESS)))}):(_SELF.APNSPushToken=apnsRegToken,void cb(_SELF.pushTokenRegistrationState.PENDING)):void cb(_SELF.pushTokenRegistrationState.ERROR,new SendBirdException("Invalid token",SendBirdError.INVALID_PARAMETER))},this.unregisterAPNSPushTokenForCurrentUser=function(apnsRegToken,cb){return this.currentUser?void APIClient.getInstance().unregisterAPNSPushToken(this.currentUser.userId,apnsRegToken,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb())}):void cb(null,new SendBirdException("Connection must be made before you unregister push token.",SendBirdError.INVALID_INITIALIZATION))},this.unregisterAPNSPushTokenAllForCurrentUser=function(cb){return this.currentUser?void APIClient.getInstance().unregisterAPNSPushTokenAll(this.currentUser.userId,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb())}):void cb(null,new SendBirdException("Connection must be made before you unregister push token.",SendBirdError.INVALID_INITIALIZATION))},this.setDoNotDisturb=function(doNotDisturbOn,startHour,startMin,endHour,endMin,timezone,cb){var _SELF=this;return this.currentUser?startHour<0||startHour>23||startMin<0||startMin>59||endHour<0||endHour>23||endMin<0||endMin>59?void(cb&&cb(null,new SendBirdException("Invalid arguments.",SendBirdError.INVALID_PARAMETER))):void APIClient.getInstance().setDoNotDisturb(_SELF.currentUser.userId,doNotDisturbOn,startHour,startMin,endHour,endMin,timezone,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb())}):void(cb&&cb(null,new SendBirdException("Connection must be made before you set do-not-disturb.",SendBirdError.INVALID_INITIALIZATION)))},this.getDoNotDisturb=function(cb){var _SELF=this;return _SELF.currentUser?void APIClient.getInstance().getDoNotDisturb(_SELF.currentUser.userId,function(response,error){if(error)return void(cb&&cb(null,error));var data={doNotDisturbOn:response.do_not_disturb,startHour:response.start_hour,startMin:response.start_min,endHour:response.end_hour,endMin:response.end_min,timezone:response.timezone};cb&&cb(data)}):void(cb&&cb(null,new SendBirdException("Connection must be made before you get do-not-disturb setting.",SendBirdError.INVALID_INITIALIZATION)))},this.blockUser=function(userToBlock,cb){return this.currentUser&&this.currentUser.userId!=userToBlock.userId?void this.blockUserWithUserId(userToBlock.userId,cb):void(cb&&cb(null,new SendBirdException("Invalid operation.",SendBirdError.INVALID_INITIALIZATION)))},this.blockUserWithUserId=function(userIdToBlock,cb){return this.currentUser&&this.currentUser.userId!=userIdToBlock?void APIClient.getInstance().blockUser(this.currentUser.userId,userIdToBlock,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb(new User(response)))}):void(cb&&cb(null,new SendBirdException("Invalid operation.",SendBirdError.INVALID_INITIALIZATION)));
	},this.unblockUser=function(blockedUser,cb){return this.currentUser?void this.unblockUserWithUserId(blockedUser.userId,cb):void(cb&&cb(null,new SendBirdException("Connection must be made before you unblock users.",SendBirdError.INVALID_INITIALIZATION)))},this.unblockUserWithUserId=function(blockedUserId,cb){return this.currentUser?void APIClient.getInstance().unblockUser(this.currentUser.userId,blockedUserId,function(response,error){return error?void(cb&&cb(null,error)):void(cb&&cb())}):void(cb&&cb(null,new SendBirdException("Connection must be made before you unblock users.",SendBirdError.INVALID_INITIALIZATION)))}},sendbirdInstance=null;return SendBird.getInstance=function(){return null===sendbirdInstance?null:sendbirdInstance},{SendBird:SendBird}}();return SendBirdObject.SendBird});

/***/ },
/* 4078 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 4079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var encode = __webpack_require__(1783);
	var alphabet = __webpack_require__(526);
	
	// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
	// This number should be updated every year or so to keep the generated id short.
	// To regenerate `new Date() - 0` and bump the version. Always bump the version!
	var REDUCE_TIME = 1459707606518;
	
	// don't change unless we change the algos or REDUCE_TIME
	// must be an integer and less than 16
	var version = 6;
	
	// Counter is used when shortid is called multiple times in one second.
	var counter;
	
	// Remember the last time shortid was called in case counter is needed.
	var previousSeconds;
	
	/**
	 * Generate unique id
	 * Returns string id
	 */
	function build(clusterWorkerId) {
	
	    var str = '';
	
	    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);
	
	    if (seconds === previousSeconds) {
	        counter++;
	    } else {
	        counter = 0;
	        previousSeconds = seconds;
	    }
	
	    str = str + encode(alphabet.lookup, version);
	    str = str + encode(alphabet.lookup, clusterWorkerId);
	    if (counter > 0) {
	        str = str + encode(alphabet.lookup, counter);
	    }
	    str = str + encode(alphabet.lookup, seconds);
	
	    return str;
	}
	
	module.exports = build;


/***/ },
/* 4080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var alphabet = __webpack_require__(526);
	
	/**
	 * Decode the id to get the version and worker
	 * Mainly for debugging and testing.
	 * @param id - the shortid-generated id.
	 */
	function decode(id) {
	    var characters = alphabet.shuffled();
	    return {
	        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
	        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
	    };
	}
	
	module.exports = decode;


/***/ },
/* 4081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabet = __webpack_require__(526);
	var encode = __webpack_require__(1783);
	var decode = __webpack_require__(4080);
	var build = __webpack_require__(4079);
	var isValid = __webpack_require__(4082);
	
	// if you are using cluster or multiple servers use this to make each instance
	// has a unique value for worker
	// Note: I don't know if this is automatically set when using third
	// party cluster solutions such as pm2.
	var clusterWorkerId = __webpack_require__(4085) || 0;
	
	/**
	 * Set the seed.
	 * Highly recommended if you don't want people to try to figure out your id schema.
	 * exposed as shortid.seed(int)
	 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
	 */
	function seed(seedValue) {
	    alphabet.seed(seedValue);
	    return module.exports;
	}
	
	/**
	 * Set the cluster worker or machine id
	 * exposed as shortid.worker(int)
	 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
	 * returns shortid module so it can be chained.
	 */
	function worker(workerId) {
	    clusterWorkerId = workerId;
	    return module.exports;
	}
	
	/**
	 *
	 * sets new characters to use in the alphabet
	 * returns the shuffled alphabet
	 */
	function characters(newCharacters) {
	    if (newCharacters !== undefined) {
	        alphabet.characters(newCharacters);
	    }
	
	    return alphabet.shuffled();
	}
	
	/**
	 * Generate unique id
	 * Returns string id
	 */
	function generate() {
	  return build(clusterWorkerId);
	}
	
	// Export all other functions as properties of the generate function
	module.exports = generate;
	module.exports.generate = generate;
	module.exports.seed = seed;
	module.exports.worker = worker;
	module.exports.characters = characters;
	module.exports.decode = decode;
	module.exports.isValid = isValid;


/***/ },
/* 4082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var alphabet = __webpack_require__(526);
	
	function isShortId(id) {
	    if (!id || typeof id !== 'string' || id.length < 6 ) {
	        return false;
	    }
	
	    var characters = alphabet.characters();
	    var len = id.length;
	    for(var i = 0; i < len;i++) {
	        if (characters.indexOf(id[i]) === -1) {
	            return false;
	        }
	    }
	    return true;
	}
	
	module.exports = isShortId;


/***/ },
/* 4083 */
/***/ function(module, exports) {

	'use strict';
	
	var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto
	
	function randomByte() {
	    if (!crypto || !crypto.getRandomValues) {
	        return Math.floor(Math.random() * 256) & 0x30;
	    }
	    var dest = new Uint8Array(1);
	    crypto.getRandomValues(dest);
	    return dest[0] & 0x30;
	}
	
	module.exports = randomByte;


/***/ },
/* 4084 */
/***/ function(module, exports) {

	'use strict';
	
	// Found this seed-based random generator somewhere
	// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)
	
	var seed = 1;
	
	/**
	 * return a random number based on a seed
	 * @param seed
	 * @returns {number}
	 */
	function getNextValue() {
	    seed = (seed * 9301 + 49297) % 233280;
	    return seed/(233280.0);
	}
	
	function setSeed(_seed_) {
	    seed = _seed_;
	}
	
	module.exports = {
	    nextValue: getNextValue,
	    seed: setSeed
	};


/***/ },
/* 4085 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = 0;


/***/ },
/* 4086 */
/***/ function(module, exports) {

	'use strict';
	
	var Sister;
	
	/**
	* @link https://github.com/gajus/sister for the canonical source repository
	* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
	*/
	Sister = function () {
	    var sister = {},
	        events = {};
	
	    /**
	     * @name handler
	     * @function
	     * @param {Object} data Event data.
	     */
	
	    /**
	     * @param {String} name Event name.
	     * @param {handler} handler
	     * @return {listener}
	     */
	    sister.on = function (name, handler) {
	        var listener = {name: name, handler: handler};
	        events[name] = events[name] || [];
	        events[name].unshift(listener);
	        return listener;
	    };
	
	    /**
	     * @param {listener}
	     */
	    sister.off = function (listener) {
	        var index = events[listener.name].indexOf(listener);
	
	        if (index !== -1) {
	            events[listener.name].splice(index, 1);
	        }
	    };
	
	    /**
	     * @param {String} name Event name.
	     * @param {Object} data Event data.
	     */
	    sister.trigger = function (name, data) {
	        var listeners = events[name],
	            i;
	
	        if (listeners) {
	            i = listeners.length;
	            while (i--) {
	                listeners[i].handler(data);
	            }
	        }
	    };
	
	    return sister;
	};
	
	module.exports = Sister;


/***/ },
/* 4087 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 4088 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2542);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4087)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./index.scss", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./index.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 4089 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(576);
	var RequestBase = __webpack_require__(4091);
	var isObject = __webpack_require__(830);
	var isFunction = __webpack_require__(4090);
	var ResponseBase = __webpack_require__(4092);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = exports = module.exports = function(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new exports.Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new exports.Request('GET', method);
	  }
	
	  return new exports.Request(method, url);
	}
	
	exports.Request = Request;
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only verison of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  var status = this.xhr.status;
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	      status = 204;
	  }
	  this._setStatusProperties(status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	
	  if (null === this.text && req._responseType) {
	    this.body = this.xhr.response;
	  } else {
	    this.body = this.req.method != 'HEAD'
	      ? this._parseBody(this.text ? this.text : this.xhr.response)
	      : null;
	  }
	}
	
	ResponseBase(Response.prototype);
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str){
	  var parse = request.parse[this.type];
	  if(this.req._parser) {
	    return this.req._parser(this, str);
	  }
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      if (self.xhr) {
	        // ie9 doesn't have 'response' property
	        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
	        // issue #876: return the http status code if the response parsing fails
	        err.status = self.xhr.status ? self.xhr.status : null;
	        err.statusCode = err.status; // backwards-compat only
	      } else {
	        err.rawResponse = null;
	        err.status = null;
	      }
	
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (!self._isResponseOK(res)) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	        new_err.original = err;
	        new_err.response = res;
	        new_err.status = res.status;
	      }
	    } catch(e) {
	      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `RequestBase`.
	 */
	
	Emitter(Request.prototype);
	RequestBase(Request.prototype);
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'function' === typeof btoa ? 'basic' : 'auto',
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      this.set('Authorization', 'Basic ' + btoa(user + ':' + pass));
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `options` (or filename).
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String|Object} options
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, options){
	  if (this._data) {
	    throw Error("superagent can't mix .send() and .attach()");
	  }
	
	  this._getFormData().append(field, file, options || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	
	  if (err) {
	    this.emit('error', err);
	  }
	
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	// This only warns, because the request is still likely to work
	Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
	  console.warn("This is not supported in browser version of superagent");
	  return this;
	};
	
	// This throws, because it can't send/receive data as expected
	Request.prototype.pipe = Request.prototype.write = function(){
	  throw Error("Streaming is not supported in browser version of superagent");
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	
	Request.prototype._appendQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
	  }
	
	  if (this._sort) {
	    var index = this.url.indexOf('?');
	    if (index >= 0) {
	      var queryArr = this.url.substring(index + 1).split('&');
	      if (isFunction(this._sort)) {
	        queryArr.sort(this._sort);
	      } else {
	        queryArr.sort();
	      }
	      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
	    }
	  }
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	Request.prototype._isHost = function _isHost(obj) {
	  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
	  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
	}
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var data = this._formData || this._data;
	
	  if (this._endCalled) {
	    console.warn("Warning: .end() was called twice. This is not supported in superagent");
	  }
	  this._endCalled = true;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    var readyState = xhr.readyState;
	    if (readyState >= 2 && self._responseTimeoutTimer) {
	      clearTimeout(self._responseTimeoutTimer);
	    }
	    if (4 != readyState) {
	      return;
	    }
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (!status) {
	      if (self.timedout || self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(direction, e) {
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = direction;
	    self.emit('progress', e);
	  }
	  if (this.hasListeners('progress')) {
	    try {
	      xhr.onprogress = handleProgress.bind(null, 'download');
	      if (xhr.upload) {
	        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
	      }
	    } catch(e) {
	      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	      // Reported here:
	      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	    }
	  }
	
	  // querystring
	  this._appendQueryString();
	
	  this._setTimeouts();
	
	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) {
	      serialize = request.serialize['application/json'];
	    }
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn){
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ },
/* 4090 */
[4179, 830],
/* 4091 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(830);
	
	/**
	 * Expose `RequestBase`.
	 */
	
	module.exports = RequestBase;
	
	/**
	 * Initialize a new `RequestBase`.
	 *
	 * @api public
	 */
	
	function RequestBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in RequestBase.prototype) {
	    obj[key] = RequestBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  this._responseTimeout = 0;
	  clearTimeout(this._timer);
	  clearTimeout(this._responseTimeoutTimer);
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set format of binary response body.
	 * In browser valid formats are 'blob' and 'arraybuffer',
	 * which return Blob and ArrayBuffer, respectively.
	 *
	 * In Node all values result in Buffer.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeouts.
	 *
	 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
	 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
	 *
	 * Value of 0 or false means no timeout.
	 *
	 * @param {Number|Object} ms or {response, read, deadline}
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.timeout = function timeout(options){
	  if (!options || 'object' !== typeof options) {
	    this._timeout = options;
	    this._responseTimeout = 0;
	    return this;
	  }
	
	  if ('undefined' !== typeof options.deadline) {
	    this._timeout = options.deadline;
	  }
	  if ('undefined' !== typeof options.response) {
	    this._responseTimeout = options.response;
	  }
	  return this;
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	RequestBase.prototype.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    if (this._endCalled) {
	      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
	    }
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
	      self.end(function(err, res){
	        if (err) innerReject(err); else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	}
	
	RequestBase.prototype.catch = function(cb) {
	  return this.then(undefined, cb);
	};
	
	/**
	 * Allow for extension
	 */
	
	RequestBase.prototype.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	RequestBase.prototype.ok = function(cb) {
	  if ('function' !== typeof cb) throw Error("Callback required");
	  this._okCallback = cb;
	  return this;
	};
	
	RequestBase.prototype._isResponseOK = function(res) {
	  if (!res) {
	    return false;
	  }
	
	  if (this._okCallback) {
	    return this._okCallback(res);
	  }
	
	  return res.status >= 200 && res.status < 300;
	};
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	RequestBase.prototype.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	RequestBase.prototype.getHeader = RequestBase.prototype.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	RequestBase.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val`, or multiple fields with one object
	 * for "multipart/form-data" request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 *
	 * request.post('/upload')
	 *   .field({ foo: 'bar', baz: 'qux' })
	 *   .end(callback);
	 * ```
	 *
	 * @param {String|Object} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	RequestBase.prototype.field = function(name, val) {
	
	  // name should be either a string or an object.
	  if (null === name ||  undefined === name) {
	    throw new Error('.field(name, val) name can not be empty');
	  }
	
	  if (isObject(name)) {
	    for (var key in name) {
	      this.field(key, name[key]);
	    }
	    return this;
	  }
	
	  if (Array.isArray(val)) {
	    for (var i in val) {
	      this.field(name, val[i]);
	    }
	    return this;
	  }
	
	  // val should be defined now
	  if (null === val || undefined === val) {
	    throw new Error('.field(name, val) val can not be empty');
	  }
	  if ('boolean' === typeof val) {
	    val = '' + val;
	  }
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	RequestBase.prototype.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	RequestBase.prototype.withCredentials = function(){
	  // This is browser-only functionality. Node side is no-op.
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	RequestBase.prototype.toJSON = function(){
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header
	  };
	};
	
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.send = function(data){
	  var isObj = isObject(data);
	  var type = this._header['content-type'];
	
	  if (isObj && !this._data) {
	    if (Array.isArray(data)) {
	      this._data = [];
	    } else if (!this._isHost(data)) {
	      this._data = {};
	    }
	  } else if (data && this._data && this._isHost(this._data)) {
	    throw Error("Can't merge these send calls");
	  }
	
	  // merge
	  if (isObj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!isObj || this._isHost(data)) {
	    return this;
	  }
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};
	
	
	/**
	 * Sort `querystring` by the sort function
	 *
	 *
	 * Examples:
	 *
	 *       // default order
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery()
	 *         .end(callback)
	 *
	 *       // customized sort function
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery(function(a, b){
	 *           return a.length - b.length;
	 *         })
	 *         .end(callback)
	 *
	 *
	 * @param {Function} sort
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.sortQuery = function(sort) {
	  // _sort default to true but otherwise can be a function or boolean
	  this._sort = typeof sort === 'undefined' ? true : sort;
	  return this;
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	RequestBase.prototype._timeoutError = function(reason, timeout){
	  if (this._aborted) {
	    return;
	  }
	  var err = new Error(reason + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  err.code = 'ECONNABORTED';
	  this.timedout = true;
	  this.abort();
	  this.callback(err);
	};
	
	RequestBase.prototype._setTimeouts = function() {
	  var self = this;
	
	  // deadline
	  if (this._timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self._timeoutError('Timeout of ', self._timeout);
	    }, this._timeout);
	  }
	  // response timeout
	  if (this._responseTimeout && !this._responseTimeoutTimer) {
	    this._responseTimeoutTimer = setTimeout(function(){
	      self._timeoutError('Response timeout of ', self._responseTimeout);
	    }, this._responseTimeout);
	  }
	}


/***/ },
/* 4092 */
[4180, 4093],
/* 4093 */
/***/ function(module, exports) {

	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	exports.type = function(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.params = function(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */);
	    var key = parts.shift();
	    var val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Parse Link header fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.parseLinks = function(str){
	  return str.split(/ *, */).reduce(function(obj, str){
	    var parts = str.split(/ *; */);
	    var url = parts[0].slice(1, -1);
	    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
	    obj[rel] = url;
	    return obj;
	  }, {});
	};
	
	/**
	 * Strip content related fields from `header`.
	 *
	 * @param {Object} header
	 * @return {Object} header
	 * @api private
	 */
	
	exports.cleanHeader = function(header, shouldStripCookie){
	  delete header['content-type'];
	  delete header['content-length'];
	  delete header['transfer-encoding'];
	  delete header['host'];
	  if (shouldStripCookie) {
	    delete header['cookie'];
	  }
	  return header;
	};


/***/ },
/* 4094 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 4095 */
/***/ function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ },
/* 4096 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//  Underscore.string
	//  (c) 2010 Esa-Matti Suuronen <esa-matti aet suuronen dot org>
	//  Underscore.string is freely distributable under the terms of the MIT license.
	//  Documentation: https://github.com/epeli/underscore.string
	//  Some code is borrowed from MooTools and Alexandru Marasteanu.
	//  Version '2.3.2'
	
	!function(root, String){
	  'use strict';
	
	  // Defining helper functions.
	
	  var nativeTrim = String.prototype.trim;
	  var nativeTrimRight = String.prototype.trimRight;
	  var nativeTrimLeft = String.prototype.trimLeft;
	
	  var parseNumber = function(source) { return source * 1 || 0; };
	
	  var strRepeat = function(str, qty){
	    if (qty < 1) return '';
	    var result = '';
	    while (qty > 0) {
	      if (qty & 1) result += str;
	      qty >>= 1, str += str;
	    }
	    return result;
	  };
	
	  var slice = [].slice;
	
	  var defaultToWhiteSpace = function(characters) {
	    if (characters == null)
	      return '\\s';
	    else if (characters.source)
	      return characters.source;
	    else
	      return '[' + _s.escapeRegExp(characters) + ']';
	  };
	
	  // Helper for toBoolean
	  function boolMatch(s, matchers) {
	    var i, matcher, down = s.toLowerCase();
	    matchers = [].concat(matchers);
	    for (i = 0; i < matchers.length; i += 1) {
	      matcher = matchers[i];
	      if (!matcher) continue;
	      if (matcher.test && matcher.test(s)) return true;
	      if (matcher.toLowerCase() === down) return true;
	    }
	  }
	
	  var escapeChars = {
	    lt: '<',
	    gt: '>',
	    quot: '"',
	    amp: '&',
	    apos: "'"
	  };
	
	  var reversedEscapeChars = {};
	  for(var key in escapeChars) reversedEscapeChars[escapeChars[key]] = key;
	  reversedEscapeChars["'"] = '#39';
	
	  // sprintf() for JavaScript 0.7-beta1
	  // http://www.diveintojavascript.com/projects/javascript-sprintf
	  //
	  // Copyright (c) Alexandru Marasteanu <alexaholic [at) gmail (dot] com>
	  // All rights reserved.
	
	  var sprintf = (function() {
	    function get_type(variable) {
	      return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase();
	    }
	
	    var str_repeat = strRepeat;
	
	    var str_format = function() {
	      if (!str_format.cache.hasOwnProperty(arguments[0])) {
	        str_format.cache[arguments[0]] = str_format.parse(arguments[0]);
	      }
	      return str_format.format.call(null, str_format.cache[arguments[0]], arguments);
	    };
	
	    str_format.format = function(parse_tree, argv) {
	      var cursor = 1, tree_length = parse_tree.length, node_type = '', arg, output = [], i, k, match, pad, pad_character, pad_length;
	      for (i = 0; i < tree_length; i++) {
	        node_type = get_type(parse_tree[i]);
	        if (node_type === 'string') {
	          output.push(parse_tree[i]);
	        }
	        else if (node_type === 'array') {
	          match = parse_tree[i]; // convenience purposes only
	          if (match[2]) { // keyword argument
	            arg = argv[cursor];
	            for (k = 0; k < match[2].length; k++) {
	              if (!arg.hasOwnProperty(match[2][k])) {
	                throw new Error(sprintf('[_.sprintf] property "%s" does not exist', match[2][k]));
	              }
	              arg = arg[match[2][k]];
	            }
	          } else if (match[1]) { // positional argument (explicit)
	            arg = argv[match[1]];
	          }
	          else { // positional argument (implicit)
	            arg = argv[cursor++];
	          }
	
	          if (/[^s]/.test(match[8]) && (get_type(arg) != 'number')) {
	            throw new Error(sprintf('[_.sprintf] expecting number but found %s', get_type(arg)));
	          }
	          switch (match[8]) {
	            case 'b': arg = arg.toString(2); break;
	            case 'c': arg = String.fromCharCode(arg); break;
	            case 'd': arg = parseInt(arg, 10); break;
	            case 'e': arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential(); break;
	            case 'f': arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg); break;
	            case 'o': arg = arg.toString(8); break;
	            case 's': arg = ((arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg); break;
	            case 'u': arg = Math.abs(arg); break;
	            case 'x': arg = arg.toString(16); break;
	            case 'X': arg = arg.toString(16).toUpperCase(); break;
	          }
	          arg = (/[def]/.test(match[8]) && match[3] && arg >= 0 ? '+'+ arg : arg);
	          pad_character = match[4] ? match[4] == '0' ? '0' : match[4].charAt(1) : ' ';
	          pad_length = match[6] - String(arg).length;
	          pad = match[6] ? str_repeat(pad_character, pad_length) : '';
	          output.push(match[5] ? arg + pad : pad + arg);
	        }
	      }
	      return output.join('');
	    };
	
	    str_format.cache = {};
	
	    str_format.parse = function(fmt) {
	      var _fmt = fmt, match = [], parse_tree = [], arg_names = 0;
	      while (_fmt) {
	        if ((match = /^[^\x25]+/.exec(_fmt)) !== null) {
	          parse_tree.push(match[0]);
	        }
	        else if ((match = /^\x25{2}/.exec(_fmt)) !== null) {
	          parse_tree.push('%');
	        }
	        else if ((match = /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(_fmt)) !== null) {
	          if (match[2]) {
	            arg_names |= 1;
	            var field_list = [], replacement_field = match[2], field_match = [];
	            if ((field_match = /^([a-z_][a-z_\d]*)/i.exec(replacement_field)) !== null) {
	              field_list.push(field_match[1]);
	              while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
	                if ((field_match = /^\.([a-z_][a-z_\d]*)/i.exec(replacement_field)) !== null) {
	                  field_list.push(field_match[1]);
	                }
	                else if ((field_match = /^\[(\d+)\]/.exec(replacement_field)) !== null) {
	                  field_list.push(field_match[1]);
	                }
	                else {
	                  throw new Error('[_.sprintf] huh?');
	                }
	              }
	            }
	            else {
	              throw new Error('[_.sprintf] huh?');
	            }
	            match[2] = field_list;
	          }
	          else {
	            arg_names |= 2;
	          }
	          if (arg_names === 3) {
	            throw new Error('[_.sprintf] mixing positional and named placeholders is not (yet) supported');
	          }
	          parse_tree.push(match);
	        }
	        else {
	          throw new Error('[_.sprintf] huh?');
	        }
	        _fmt = _fmt.substring(match[0].length);
	      }
	      return parse_tree;
	    };
	
	    return str_format;
	  })();
	
	
	
	  // Defining underscore.string
	
	  var _s = {
	
	    VERSION: '2.3.0',
	
	    isBlank: function(str){
	      if (str == null) str = '';
	      return (/^\s*$/).test(str);
	    },
	
	    stripTags: function(str){
	      if (str == null) return '';
	      return String(str).replace(/<\/?[^>]+>/g, '');
	    },
	
	    capitalize : function(str){
	      str = str == null ? '' : String(str);
	      return str.charAt(0).toUpperCase() + str.slice(1);
	    },
	
	    chop: function(str, step){
	      if (str == null) return [];
	      str = String(str);
	      step = ~~step;
	      return step > 0 ? str.match(new RegExp('.{1,' + step + '}', 'g')) : [str];
	    },
	
	    clean: function(str){
	      return _s.strip(str).replace(/\s+/g, ' ');
	    },
	
	    count: function(str, substr){
	      if (str == null || substr == null) return 0;
	
	      str = String(str);
	      substr = String(substr);
	
	      var count = 0,
	        pos = 0,
	        length = substr.length;
	
	      while (true) {
	        pos = str.indexOf(substr, pos);
	        if (pos === -1) break;
	        count++;
	        pos += length;
	      }
	
	      return count;
	    },
	
	    chars: function(str) {
	      if (str == null) return [];
	      return String(str).split('');
	    },
	
	    swapCase: function(str) {
	      if (str == null) return '';
	      return String(str).replace(/\S/g, function(c){
	        return c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase();
	      });
	    },
	
	    escapeHTML: function(str) {
	      if (str == null) return '';
	      return String(str).replace(/[&<>"']/g, function(m){ return '&' + reversedEscapeChars[m] + ';'; });
	    },
	
	    unescapeHTML: function(str) {
	      if (str == null) return '';
	      return String(str).replace(/\&([^;]+);/g, function(entity, entityCode){
	        var match;
	
	        if (entityCode in escapeChars) {
	          return escapeChars[entityCode];
	        } else if (match = entityCode.match(/^#x([\da-fA-F]+)$/)) {
	          return String.fromCharCode(parseInt(match[1], 16));
	        } else if (match = entityCode.match(/^#(\d+)$/)) {
	          return String.fromCharCode(~~match[1]);
	        } else {
	          return entity;
	        }
	      });
	    },
	
	    escapeRegExp: function(str){
	      if (str == null) return '';
	      return String(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
	    },
	
	    splice: function(str, i, howmany, substr){
	      var arr = _s.chars(str);
	      arr.splice(~~i, ~~howmany, substr);
	      return arr.join('');
	    },
	
	    insert: function(str, i, substr){
	      return _s.splice(str, i, 0, substr);
	    },
	
	    include: function(str, needle){
	      if (needle === '') return true;
	      if (str == null) return false;
	      return String(str).indexOf(needle) !== -1;
	    },
	
	    join: function() {
	      var args = slice.call(arguments),
	        separator = args.shift();
	
	      if (separator == null) separator = '';
	
	      return args.join(separator);
	    },
	
	    lines: function(str) {
	      if (str == null) return [];
	      return String(str).split("\n");
	    },
	
	    reverse: function(str){
	      return _s.chars(str).reverse().join('');
	    },
	
	    startsWith: function(str, starts){
	      if (starts === '') return true;
	      if (str == null || starts == null) return false;
	      str = String(str); starts = String(starts);
	      return str.length >= starts.length && str.slice(0, starts.length) === starts;
	    },
	
	    endsWith: function(str, ends){
	      if (ends === '') return true;
	      if (str == null || ends == null) return false;
	      str = String(str); ends = String(ends);
	      return str.length >= ends.length && str.slice(str.length - ends.length) === ends;
	    },
	
	    succ: function(str){
	      if (str == null) return '';
	      str = String(str);
	      return str.slice(0, -1) + String.fromCharCode(str.charCodeAt(str.length-1) + 1);
	    },
	
	    titleize: function(str){
	      if (str == null) return '';
	      str  = String(str).toLowerCase();
	      return str.replace(/(?:^|\s|-)\S/g, function(c){ return c.toUpperCase(); });
	    },
	
	    camelize: function(str){
	      return _s.trim(str).replace(/[-_\s]+(.)?/g, function(match, c){ return c ? c.toUpperCase() : ""; });
	    },
	
	    underscored: function(str){
	      return _s.trim(str).replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
	    },
	
	    dasherize: function(str){
	      return _s.trim(str).replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase();
	    },
	
	    classify: function(str){
	      return _s.titleize(String(str).replace(/[\W_]/g, ' ')).replace(/\s/g, '');
	    },
	
	    humanize: function(str){
	      return _s.capitalize(_s.underscored(str).replace(/_id$/,'').replace(/_/g, ' '));
	    },
	
	    trim: function(str, characters){
	      if (str == null) return '';
	      if (!characters && nativeTrim) return nativeTrim.call(str);
	      characters = defaultToWhiteSpace(characters);
	      return String(str).replace(new RegExp('\^' + characters + '+|' + characters + '+$', 'g'), '');
	    },
	
	    ltrim: function(str, characters){
	      if (str == null) return '';
	      if (!characters && nativeTrimLeft) return nativeTrimLeft.call(str);
	      characters = defaultToWhiteSpace(characters);
	      return String(str).replace(new RegExp('^' + characters + '+'), '');
	    },
	
	    rtrim: function(str, characters){
	      if (str == null) return '';
	      if (!characters && nativeTrimRight) return nativeTrimRight.call(str);
	      characters = defaultToWhiteSpace(characters);
	      return String(str).replace(new RegExp(characters + '+$'), '');
	    },
	
	    truncate: function(str, length, truncateStr){
	      if (str == null) return '';
	      str = String(str); truncateStr = truncateStr || '...';
	      length = ~~length;
	      return str.length > length ? str.slice(0, length) + truncateStr : str;
	    },
	
	    /**
	     * _s.prune: a more elegant version of truncate
	     * prune extra chars, never leaving a half-chopped word.
	     * @author github.com/rwz
	     */
	    prune: function(str, length, pruneStr){
	      if (str == null) return '';
	
	      str = String(str); length = ~~length;
	      pruneStr = pruneStr != null ? String(pruneStr) : '...';
	
	      if (str.length <= length) return str;
	
	      var tmpl = function(c){ return c.toUpperCase() !== c.toLowerCase() ? 'A' : ' '; },
	        template = str.slice(0, length+1).replace(/.(?=\W*\w*$)/g, tmpl); // 'Hello, world' -> 'HellAA AAAAA'
	
	      if (template.slice(template.length-2).match(/\w\w/))
	        template = template.replace(/\s*\S+$/, '');
	      else
	        template = _s.rtrim(template.slice(0, template.length-1));
	
	      return (template+pruneStr).length > str.length ? str : str.slice(0, template.length)+pruneStr;
	    },
	
	    words: function(str, delimiter) {
	      if (_s.isBlank(str)) return [];
	      return _s.trim(str, delimiter).split(delimiter || /\s+/);
	    },
	
	    pad: function(str, length, padStr, type) {
	      str = str == null ? '' : String(str);
	      length = ~~length;
	
	      var padlen  = 0;
	
	      if (!padStr)
	        padStr = ' ';
	      else if (padStr.length > 1)
	        padStr = padStr.charAt(0);
	
	      switch(type) {
	        case 'right':
	          padlen = length - str.length;
	          return str + strRepeat(padStr, padlen);
	        case 'both':
	          padlen = length - str.length;
	          return strRepeat(padStr, Math.ceil(padlen/2)) + str
	                  + strRepeat(padStr, Math.floor(padlen/2));
	        default: // 'left'
	          padlen = length - str.length;
	          return strRepeat(padStr, padlen) + str;
	        }
	    },
	
	    lpad: function(str, length, padStr) {
	      return _s.pad(str, length, padStr);
	    },
	
	    rpad: function(str, length, padStr) {
	      return _s.pad(str, length, padStr, 'right');
	    },
	
	    lrpad: function(str, length, padStr) {
	      return _s.pad(str, length, padStr, 'both');
	    },
	
	    sprintf: sprintf,
	
	    vsprintf: function(fmt, argv){
	      argv.unshift(fmt);
	      return sprintf.apply(null, argv);
	    },
	
	    toNumber: function(str, decimals) {
	      if (!str) return 0;
	      str = _s.trim(str);
	      if (!str.match(/^-?\d+(?:\.\d+)?$/)) return NaN;
	      return parseNumber(parseNumber(str).toFixed(~~decimals));
	    },
	
	    numberFormat : function(number, dec, dsep, tsep) {
	      if (isNaN(number) || number == null) return '';
	
	      number = number.toFixed(~~dec);
	      tsep = typeof tsep == 'string' ? tsep : ',';
	
	      var parts = number.split('.'), fnums = parts[0],
	        decimals = parts[1] ? (dsep || '.') + parts[1] : '';
	
	      return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + tsep) + decimals;
	    },
	
	    strRight: function(str, sep){
	      if (str == null) return '';
	      str = String(str); sep = sep != null ? String(sep) : sep;
	      var pos = !sep ? -1 : str.indexOf(sep);
	      return ~pos ? str.slice(pos+sep.length, str.length) : str;
	    },
	
	    strRightBack: function(str, sep){
	      if (str == null) return '';
	      str = String(str); sep = sep != null ? String(sep) : sep;
	      var pos = !sep ? -1 : str.lastIndexOf(sep);
	      return ~pos ? str.slice(pos+sep.length, str.length) : str;
	    },
	
	    strLeft: function(str, sep){
	      if (str == null) return '';
	      str = String(str); sep = sep != null ? String(sep) : sep;
	      var pos = !sep ? -1 : str.indexOf(sep);
	      return ~pos ? str.slice(0, pos) : str;
	    },
	
	    strLeftBack: function(str, sep){
	      if (str == null) return '';
	      str += ''; sep = sep != null ? ''+sep : sep;
	      var pos = str.lastIndexOf(sep);
	      return ~pos ? str.slice(0, pos) : str;
	    },
	
	    toSentence: function(array, separator, lastSeparator, serial) {
	      separator = separator || ', ';
	      lastSeparator = lastSeparator || ' and ';
	      var a = array.slice(), lastMember = a.pop();
	
	      if (array.length > 2 && serial) lastSeparator = _s.rtrim(separator) + lastSeparator;
	
	      return a.length ? a.join(separator) + lastSeparator + lastMember : lastMember;
	    },
	
	    toSentenceSerial: function() {
	      var args = slice.call(arguments);
	      args[3] = true;
	      return _s.toSentence.apply(_s, args);
	    },
	
	    slugify: function(str) {
	      if (str == null) return '';
	
	      var from  = "ąàáäâãåæăćęèéëêìíïîłńòóöôõøśșțùúüûñçżź",
	          to    = "aaaaaaaaaceeeeeiiiilnoooooosstuuuunczz",
	          regex = new RegExp(defaultToWhiteSpace(from), 'g');
	
	      str = String(str).toLowerCase().replace(regex, function(c){
	        var index = from.indexOf(c);
	        return to.charAt(index) || '-';
	      });
	
	      return _s.dasherize(str.replace(/[^\w\s-]/g, ''));
	    },
	
	    surround: function(str, wrapper) {
	      return [wrapper, str, wrapper].join('');
	    },
	
	    quote: function(str, quoteChar) {
	      return _s.surround(str, quoteChar || '"');
	    },
	
	    unquote: function(str, quoteChar) {
	      quoteChar = quoteChar || '"';
	      if (str[0] === quoteChar && str[str.length-1] === quoteChar)
	        return str.slice(1,str.length-1);
	      else return str;
	    },
	
	    exports: function() {
	      var result = {};
	
	      for (var prop in this) {
	        if (!this.hasOwnProperty(prop) || prop.match(/^(?:include|contains|reverse)$/)) continue;
	        result[prop] = this[prop];
	      }
	
	      return result;
	    },
	
	    repeat: function(str, qty, separator){
	      if (str == null) return '';
	
	      qty = ~~qty;
	
	      // using faster implementation if separator is not needed;
	      if (separator == null) return strRepeat(String(str), qty);
	
	      // this one is about 300x slower in Google Chrome
	      for (var repeat = []; qty > 0; repeat[--qty] = str) {}
	      return repeat.join(separator);
	    },
	
	    naturalCmp: function(str1, str2){
	      if (str1 == str2) return 0;
	      if (!str1) return -1;
	      if (!str2) return 1;
	
	      var cmpRegex = /(\.\d+)|(\d+)|(\D+)/g,
	        tokens1 = String(str1).toLowerCase().match(cmpRegex),
	        tokens2 = String(str2).toLowerCase().match(cmpRegex),
	        count = Math.min(tokens1.length, tokens2.length);
	
	      for(var i = 0; i < count; i++) {
	        var a = tokens1[i], b = tokens2[i];
	
	        if (a !== b){
	          var num1 = parseInt(a, 10);
	          if (!isNaN(num1)){
	            var num2 = parseInt(b, 10);
	            if (!isNaN(num2) && num1 - num2)
	              return num1 - num2;
	          }
	          return a < b ? -1 : 1;
	        }
	      }
	
	      if (tokens1.length === tokens2.length)
	        return tokens1.length - tokens2.length;
	
	      return str1 < str2 ? -1 : 1;
	    },
	
	    levenshtein: function(str1, str2) {
	      if (str1 == null && str2 == null) return 0;
	      if (str1 == null) return String(str2).length;
	      if (str2 == null) return String(str1).length;
	
	      str1 = String(str1); str2 = String(str2);
	
	      var current = [], prev, value;
	
	      for (var i = 0; i <= str2.length; i++)
	        for (var j = 0; j <= str1.length; j++) {
	          if (i && j)
	            if (str1.charAt(j - 1) === str2.charAt(i - 1))
	              value = prev;
	            else
	              value = Math.min(current[j], current[j - 1], prev) + 1;
	          else
	            value = i + j;
	
	          prev = current[j];
	          current[j] = value;
	        }
	
	      return current.pop();
	    },
	
	    toBoolean: function(str, trueValues, falseValues) {
	      if (typeof str === "number") str = "" + str;
	      if (typeof str !== "string") return !!str;
	      str = _s.trim(str);
	      if (boolMatch(str, trueValues || ["true", "1"])) return true;
	      if (boolMatch(str, falseValues || ["false", "0"])) return false;
	    }
	  };
	
	  // Aliases
	
	  _s.strip    = _s.trim;
	  _s.lstrip   = _s.ltrim;
	  _s.rstrip   = _s.rtrim;
	  _s.center   = _s.lrpad;
	  _s.rjust    = _s.lpad;
	  _s.ljust    = _s.rpad;
	  _s.contains = _s.include;
	  _s.q        = _s.quote;
	  _s.toBool   = _s.toBoolean;
	
	  // Exporting
	
	  // CommonJS module is defined
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports)
	      module.exports = _s;
	
	    exports._s = _s;
	  }
	
	  // Register as a named module with AMD.
	  if (true)
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){ return _s; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	
	  // Integrate with Underscore.js if defined
	  // or create our own underscore object.
	  root._ = root._ || {};
	  root._.string = root._.str = _s;
	}(this, String);


/***/ },
/* 4097 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var punycode = __webpack_require__(3035);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(1428);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};
	
	function isString(arg) {
	  return typeof arg === "string";
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}


/***/ },
/* 4098 */
1825,
/* 4099 */
1826,
/* 4100 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(1786);
	var bytesToUuid = __webpack_require__(1785);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options == 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ },
/* 4101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toString = __webpack_require__(835);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function contains(str, elem) {
	  (0, _assertString2.default)(str);
	  return str.indexOf((0, _toString2.default)(elem)) >= 0;
	}
	module.exports = exports['default'];

/***/ },
/* 4102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = equals;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function equals(str, comparison) {
	  (0, _assertString2.default)(str);
	  return str === comparison;
	}
	module.exports = exports['default'];

/***/ },
/* 4103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	exports.default = escape;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escape(str) {
	      (0, _assertString2.default)(str);
	      return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
	}
	module.exports = exports['default'];

/***/ },
/* 4104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toDate = __webpack_require__(834);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAfter(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	
	  (0, _assertString2.default)(str);
	  var comparison = (0, _toDate2.default)(date);
	  var original = (0, _toDate2.default)(str);
	  return !!(original && comparison && original > comparison);
	}
	module.exports = exports['default'];

/***/ },
/* 4105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlpha;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(1788);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlpha(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	
	  (0, _assertString2.default)(str);
	  if (locale in _alpha.alpha) {
	    return _alpha.alpha[locale].test(str);
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ },
/* 4106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlphanumeric;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(1788);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlphanumeric(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	
	  (0, _assertString2.default)(str);
	  if (locale in _alpha.alphanumeric) {
	    return _alpha.alphanumeric[locale].test(str);
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ },
/* 4107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAscii;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var ascii = /^[\x00-\x7F]+$/;
	/* eslint-enable no-control-regex */
	
	function isAscii(str) {
	  (0, _assertString2.default)(str);
	  return ascii.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBase64;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notBase64 = /[^A-Z0-9+\/=]/i;
	
	function isBase64(str) {
	  (0, _assertString2.default)(str);
	  var len = str.length;
	  if (!len || len % 4 !== 0 || notBase64.test(str)) {
	    return false;
	  }
	  var firstPaddingChar = str.indexOf('=');
	  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
	}
	module.exports = exports['default'];

/***/ },
/* 4109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toDate = __webpack_require__(834);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBefore(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	
	  (0, _assertString2.default)(str);
	  var comparison = (0, _toDate2.default)(date);
	  var original = (0, _toDate2.default)(str);
	  return !!(original && comparison && original < comparison);
	}
	module.exports = exports['default'];

/***/ },
/* 4110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBoolean;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBoolean(str) {
	  (0, _assertString2.default)(str);
	  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
	}
	module.exports = exports['default'];

/***/ },
/* 4111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCreditCard;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})|62[0-9]{14}$/;
	/* eslint-enable max-len */
	
	function isCreditCard(str) {
	  (0, _assertString2.default)(str);
	  var sanitized = str.replace(/[^0-9]+/g, '');
	  if (!creditCard.test(sanitized)) {
	    return false;
	  }
	  var sum = 0;
	  var digit = void 0;
	  var tmpNum = void 0;
	  var shouldDouble = void 0;
	  for (var i = sanitized.length - 1; i >= 0; i--) {
	    digit = sanitized.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	    if (shouldDouble) {
	      tmpNum *= 2;
	      if (tmpNum >= 10) {
	        sum += tmpNum % 10 + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	    shouldDouble = !shouldDouble;
	  }
	  return !!(sum % 10 === 0 ? sanitized : false);
	}
	module.exports = exports['default'];

/***/ },
/* 4112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCurrency;
	
	var _merge = __webpack_require__(342);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function currencyRegex(options) {
	  var symbol = '(\\' + options.symbol.replace(/\./g, '\\.') + ')' + (options.require_symbol ? '' : '?'),
	      negative = '-?',
	      whole_dollar_amount_without_sep = '[1-9]\\d*',
	      whole_dollar_amount_with_sep = '[1-9]\\d{0,2}(\\' + options.thousands_separator + '\\d{3})*',
	      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
	      whole_dollar_amount = '(' + valid_whole_dollar_amounts.join('|') + ')?',
	      decimal_amount = '(\\' + options.decimal_separator + '\\d{2})?';
	  var pattern = whole_dollar_amount + decimal_amount;
	
	  // default is negative sign before symbol, but there are two other options (besides parens)
	  if (options.allow_negatives && !options.parens_for_negatives) {
	    if (options.negative_sign_after_digits) {
	      pattern += negative;
	    } else if (options.negative_sign_before_digits) {
	      pattern = negative + pattern;
	    }
	  }
	
	  // South African Rand, for example, uses R 123 (space) and R-123 (no space)
	  if (options.allow_negative_sign_placeholder) {
	    pattern = '( (?!\\-))?' + pattern;
	  } else if (options.allow_space_after_symbol) {
	    pattern = ' ?' + pattern;
	  } else if (options.allow_space_after_digits) {
	    pattern += '( (?!$))?';
	  }
	
	  if (options.symbol_after_digits) {
	    pattern += symbol;
	  } else {
	    pattern = symbol + pattern;
	  }
	
	  if (options.allow_negatives) {
	    if (options.parens_for_negatives) {
	      pattern = '(\\(' + pattern + '\\)|' + pattern + ')';
	    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
	      pattern = negative + pattern;
	    }
	  }
	
	  /* eslint-disable prefer-template */
	  return new RegExp('^' +
	  // ensure there's a dollar and/or decimal amount, and that
	  // it doesn't start with a space or a negative sign followed by a space
	  '(?!-? )(?=.*\\d)' + pattern + '$');
	  /* eslint-enable prefer-template */
	}
	
	var default_currency_options = {
	  symbol: '$',
	  require_symbol: false,
	  allow_space_after_symbol: false,
	  symbol_after_digits: false,
	  allow_negatives: true,
	  parens_for_negatives: false,
	  negative_sign_before_digits: false,
	  negative_sign_after_digits: false,
	  allow_negative_sign_placeholder: false,
	  thousands_separator: ',',
	  decimal_separator: '.',
	  allow_space_after_digits: false
	};
	
	function isCurrency(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_currency_options);
	  return currencyRegex(options).test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDataURI;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dataURI = /^\s*data:([a-z]+\/[a-z0-9\-\+]+(;[a-z\-]+=[a-z0-9\-]+)?)?(;base64)?,[a-z0-9!\$&',\(\)\*\+,;=\-\._~:@\/\?%\s]*\s*$/i; // eslint-disable-line max-len
	
	function isDataURI(str) {
	  (0, _assertString2.default)(str);
	  return dataURI.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDecimal;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var decimal = /^[-+]?([0-9]+|\.[0-9]+|[0-9]+\.[0-9]+)$/;
	
	function isDecimal(str) {
	  (0, _assertString2.default)(str);
	  return str !== '' && decimal.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDivisibleBy;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toFloat = __webpack_require__(1798);
	
	var _toFloat2 = _interopRequireDefault(_toFloat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isDivisibleBy(str, num) {
	  (0, _assertString2.default)(str);
	  return (0, _toFloat2.default)(str) % parseInt(num, 10) === 0;
	}
	module.exports = exports['default'];

/***/ },
/* 4116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmpty;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isEmpty(str) {
	  (0, _assertString2.default)(str);
	  return str.length === 0;
	}
	module.exports = exports['default'];

/***/ },
/* 4117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFloat;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var float = /^(?:[-+])?(?:[0-9]+)?(?:\.[0-9]*)?(?:[eE][\+\-]?(?:[0-9]+))?$/;
	
	function isFloat(str, options) {
	  (0, _assertString2.default)(str);
	  options = options || {};
	  if (str === '' || str === '.') {
	    return false;
	  }
	  return float.test(str) && (!options.hasOwnProperty('min') || str >= options.min) && (!options.hasOwnProperty('max') || str <= options.max) && (!options.hasOwnProperty('lt') || str < options.lt) && (!options.hasOwnProperty('gt') || str > options.gt);
	}
	module.exports = exports['default'];

/***/ },
/* 4118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexColor;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;
	
	function isHexColor(str) {
	  (0, _assertString2.default)(str);
	  return hexcolor.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISBN;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
	var isbn13Maybe = /^(?:[0-9]{13})$/;
	var factor = [1, 3];
	
	function isISBN(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  (0, _assertString2.default)(str);
	  version = String(version);
	  if (!version) {
	    return isISBN(str, 10) || isISBN(str, 13);
	  }
	  var sanitized = str.replace(/[\s-]+/g, '');
	  var checksum = 0;
	  var i = void 0;
	  if (version === '10') {
	    if (!isbn10Maybe.test(sanitized)) {
	      return false;
	    }
	    for (i = 0; i < 9; i++) {
	      checksum += (i + 1) * sanitized.charAt(i);
	    }
	    if (sanitized.charAt(9) === 'X') {
	      checksum += 10 * 10;
	    } else {
	      checksum += 10 * sanitized.charAt(9);
	    }
	    if (checksum % 11 === 0) {
	      return !!sanitized;
	    }
	  } else if (version === '13') {
	    if (!isbn13Maybe.test(sanitized)) {
	      return false;
	    }
	    for (i = 0; i < 12; i++) {
	      checksum += factor[i % 2] * sanitized.charAt(i);
	    }
	    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
	      return !!sanitized;
	    }
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 4120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISIN;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
	
	function isISIN(str) {
	  (0, _assertString2.default)(str);
	  if (!isin.test(str)) {
	    return false;
	  }
	
	  var checksumStr = str.replace(/[A-Z]/g, function (character) {
	    return parseInt(character, 36);
	  });
	
	  var sum = 0;
	  var digit = void 0;
	  var tmpNum = void 0;
	  var shouldDouble = true;
	  for (var i = checksumStr.length - 2; i >= 0; i--) {
	    digit = checksumStr.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	    if (shouldDouble) {
	      tmpNum *= 2;
	      if (tmpNum >= 10) {
	        sum += tmpNum + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	    shouldDouble = !shouldDouble;
	  }
	
	  return parseInt(str.substr(str.length - 1), 10) === (10000 - sum) % 10;
	}
	module.exports = exports['default'];

/***/ },
/* 4121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.iso8601 = undefined;
	
	exports.default = function (str) {
	  (0, _assertString2.default)(str);
	  return iso8601.test(str);
	};
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	// from http://goo.gl/0ejHHW
	var iso8601 = exports.iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
	/* eslint-enable max-len */

/***/ },
/* 4122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISSN;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var issn = '^\\d{4}-?\\d{3}[\\dX]$';
	
	function isISSN(str) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  (0, _assertString2.default)(str);
	  var testIssn = issn;
	  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
	  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');
	  if (!testIssn.test(str)) {
	    return false;
	  }
	  var issnDigits = str.replace('-', '');
	  var position = 8;
	  var checksum = 0;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = issnDigits[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var digit = _step.value;
	
	      var digitValue = digit.toUpperCase() === 'X' ? 10 : +digit;
	      checksum += digitValue * position;
	      --position;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return checksum % 11 === 0;
	}
	module.exports = exports['default'];

/***/ },
/* 4123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isIn;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toString = __webpack_require__(835);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isIn(str, options) {
	  (0, _assertString2.default)(str);
	  var i = void 0;
	  if (Object.prototype.toString.call(options) === '[object Array]') {
	    var array = [];
	    for (i in options) {
	      if ({}.hasOwnProperty.call(options, i)) {
	        array[i] = (0, _toString2.default)(options[i]);
	      }
	    }
	    return array.indexOf(str) >= 0;
	  } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    return options.hasOwnProperty(str);
	  } else if (options && typeof options.indexOf === 'function') {
	    return options.indexOf(str) >= 0;
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 4124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInt;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
	var intLeadingZeroes = /^[-+]?[0-9]+$/;
	
	function isInt(str, options) {
	  (0, _assertString2.default)(str);
	  options = options || {};
	
	  // Get the regex to use for testing, based on whether
	  // leading zeroes are allowed or not.
	  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes;
	
	  // Check min/max/lt/gt
	  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
	  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
	  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
	  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
	
	  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
	}
	module.exports = exports['default'];

/***/ },
/* 4125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isJSON;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isJSON(str) {
	  (0, _assertString2.default)(str);
	  try {
	    var obj = JSON.parse(str);
	    return !!obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	  } catch (e) {/* ignore */}
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 4126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isLength;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
	  var len = str.length - surrogatePairs.length;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];

/***/ },
/* 4127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLowercase;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isLowercase(str) {
	  (0, _assertString2.default)(str);
	  return str === str.toLowerCase();
	}
	module.exports = exports['default'];

/***/ },
/* 4128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMACAddress;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
	
	function isMACAddress(str) {
	  (0, _assertString2.default)(str);
	  return macAddress.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMD5;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var md5 = /^[a-f0-9]{32}$/;
	
	function isMD5(str) {
	  (0, _assertString2.default)(str);
	  return md5.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMobilePhone;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var phones = {
	  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
	  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
	  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
	  'en-US': /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
	  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'de-DE': /^(\+?49[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
	  'da-DK': /^(\+?45)?(\d{8})$/,
	  'el-GR': /^(\+?30)?(69\d{8})$/,
	  'en-AU': /^(\+?61|0)4\d{8}$/,
	  'en-GB': /^(\+?44|0)7\d{9}$/,
	  'en-HK': /^(\+?852\-?)?[569]\d{3}\-?\d{4}$/,
	  'en-IN': /^(\+?91|0)?[789]\d{9}$/,
	  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
	  'en-NZ': /^(\+?64|0)2\d{7,9}$/,
	  'en-ZA': /^(\+?27|0)\d{9}$/,
	  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
	  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
	  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5)?|50)\s?(\d\s?){4,8}\d$/,
	  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
	  'he-IL': /^(\+972|0)([23489]|5[0248]|77)[1-9]\d{6}/,
	  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
	  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
	  'ja-JP': /^(\+?81|0)\d{1,4}[ \-]?\d{1,4}[ \-]?\d{4}$/,
	  'ms-MY': /^(\+?6?01){1}(([145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
	  'nb-NO': /^(\+?47)?[49]\d{7}$/,
	  'nl-BE': /^(\+?32|0)4?\d{8}$/,
	  'nn-NO': /^(\+?47)?[49]\d{7}$/,
	  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
	  'pt-BR': /^(\+?55|0)\-?[1-9]{2}\-?[2-9]{1}\d{3,4}\-?\d{4}$/,
	  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
	  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
	  'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
	  'ru-RU': /^(\+?7|8)?9\d{9}$/,
	  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
	  'tr-TR': /^(\+?90|0)?5\d{9}$/,
	  'vi-VN': /^(\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
	  'zh-CN': /^(\+?0?86\-?)?1[345789]\d{9}$/,
	  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
	};
	/* eslint-enable max-len */
	
	// aliases
	phones['en-CA'] = phones['en-US'];
	phones['fr-BE'] = phones['nl-BE'];
	phones['zh-HK'] = phones['en-HK'];
	
	function isMobilePhone(str, locale) {
	  (0, _assertString2.default)(str);
	  if (locale in phones) {
	    return phones[locale].test(str);
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 4131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMongoId;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isHexadecimal = __webpack_require__(1794);
	
	var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isMongoId(str) {
	  (0, _assertString2.default)(str);
	  return (0, _isHexadecimal2.default)(str) && str.length === 24;
	}
	module.exports = exports['default'];

/***/ },
/* 4132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMultibyte;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var multibyte = /[^\x00-\x7F]/;
	/* eslint-enable no-control-regex */
	
	function isMultibyte(str) {
	  (0, _assertString2.default)(str);
	  return multibyte.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumeric;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numeric = /^[-+]?[0-9]+$/;
	
	function isNumeric(str) {
	  (0, _assertString2.default)(str);
	  return numeric.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSurrogatePair;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
	
	function isSurrogatePair(str) {
	  (0, _assertString2.default)(str);
	  return surrogatePair.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isURL;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isFQDN = __webpack_require__(833);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	var _isIP = __webpack_require__(1795);
	
	var _isIP2 = _interopRequireDefault(_isIP);
	
	var _merge = __webpack_require__(342);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_url_options = {
	  protocols: ['http', 'https', 'ftp'],
	  require_tld: true,
	  require_protocol: false,
	  require_host: true,
	  require_valid_protocol: true,
	  allow_underscores: false,
	  allow_trailing_dot: false,
	  allow_protocol_relative_urls: false
	};
	
	var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
	
	function isRegExp(obj) {
	  return Object.prototype.toString.call(obj) === '[object RegExp]';
	}
	
	function checkHost(host, matches) {
	  for (var i = 0; i < matches.length; i++) {
	    var match = matches[i];
	    if (host === match || isRegExp(match) && match.test(host)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function isURL(url, options) {
	  (0, _assertString2.default)(url);
	  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
	    return false;
	  }
	  if (url.indexOf('mailto:') === 0) {
	    return false;
	  }
	  options = (0, _merge2.default)(options, default_url_options);
	  var protocol = void 0,
	      auth = void 0,
	      host = void 0,
	      hostname = void 0,
	      port = void 0,
	      port_str = void 0,
	      split = void 0,
	      ipv6 = void 0;
	
	  split = url.split('#');
	  url = split.shift();
	
	  split = url.split('?');
	  url = split.shift();
	
	  split = url.split('://');
	  if (split.length > 1) {
	    protocol = split.shift();
	    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
	      return false;
	    }
	  } else if (options.require_protocol) {
	    return false;
	  } else if (options.allow_protocol_relative_urls && url.substr(0, 2) === '//') {
	    split[0] = url.substr(2);
	  }
	  url = split.join('://');
	
	  split = url.split('/');
	  url = split.shift();
	
	  if (url === '' && !options.require_host) {
	    return true;
	  }
	
	  split = url.split('@');
	  if (split.length > 1) {
	    auth = split.shift();
	    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
	      return false;
	    }
	  }
	  hostname = split.join('@');
	
	  port_str = ipv6 = null;
	  var ipv6_match = hostname.match(wrapped_ipv6);
	  if (ipv6_match) {
	    host = '';
	    ipv6 = ipv6_match[1];
	    port_str = ipv6_match[2] || null;
	  } else {
	    split = hostname.split(':');
	    host = split.shift();
	    if (split.length) {
	      port_str = split.join(':');
	    }
	  }
	
	  if (port_str !== null) {
	    port = parseInt(port_str, 10);
	    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
	      return false;
	    }
	  }
	
	  if (!(0, _isIP2.default)(host) && !(0, _isFQDN2.default)(host, options) && (!ipv6 || !(0, _isIP2.default)(ipv6, 6)) && host !== 'localhost') {
	    return false;
	  }
	
	  host = host || ipv6;
	
	  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
	    return false;
	  }
	  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
	    return false;
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ },
/* 4136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUUID;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uuid = {
	  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
	  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
	};
	
	function isUUID(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
	
	  (0, _assertString2.default)(str);
	  var pattern = uuid[version];
	  return pattern && pattern.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUppercase;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isUppercase(str) {
	  (0, _assertString2.default)(str);
	  return str === str.toUpperCase();
	}
	module.exports = exports['default'];

/***/ },
/* 4138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isVariableWidth;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isFullWidth = __webpack_require__(1792);
	
	var _isHalfWidth = __webpack_require__(1793);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isVariableWidth(str) {
	  (0, _assertString2.default)(str);
	  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWhitelisted;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isWhitelisted(str, chars) {
	  (0, _assertString2.default)(str);
	  for (var i = str.length - 1; i >= 0; i--) {
	    if (chars.indexOf(str[i]) === -1) {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];

/***/ },
/* 4140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matches;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matches(str, pattern, modifiers) {
	  (0, _assertString2.default)(str);
	  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
	    pattern = new RegExp(pattern, modifiers);
	  }
	  return pattern.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 4141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = normalizeEmail;
	
	var _isEmail = __webpack_require__(1791);
	
	var _isEmail2 = _interopRequireDefault(_isEmail);
	
	var _merge = __webpack_require__(342);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_normalize_email_options = {
	  // The following options apply to all email addresses
	  // Lowercases the local part of the email address.
	  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
	  // The domain is always lowercased, as per RFC 1035
	  all_lowercase: true,
	
	  // The following conversions are specific to GMail
	  // Lowercases the local part of the GMail address (known to be case-insensitive)
	  gmail_lowercase: true,
	  // Removes dots from the local part of the email address, as that's ignored by GMail
	  gmail_remove_dots: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  gmail_remove_subaddress: true,
	  // Conversts the googlemail.com domain to gmail.com
	  gmail_convert_googlemaildotcom: true,
	
	  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
	  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
	  outlookdotcom_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  outlookdotcom_remove_subaddress: true,
	
	  // The following conversions are specific to Yahoo
	  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
	  yahoo_lowercase: true,
	  // Removes the subaddress (e.g. "-foo") from the email address
	  yahoo_remove_subaddress: true,
	
	  // The following conversions are specific to iCloud
	  // Lowercases the local part of the iCloud address (known to be case-insensitive)
	  icloud_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  icloud_remove_subaddress: true
	};
	
	// List of domains used by iCloud
	var icloud_domains = ['icloud.com', 'me.com'];
	
	// List of domains used by Outlook.com and its predecessors
	// This list is likely incomplete.
	// Partial reference:
	// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/
	var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com'];
	
	// List of domains used by Yahoo Mail
	// This list is likely incomplete
	var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com'];
	
	function normalizeEmail(email, options) {
	  options = (0, _merge2.default)(options, default_normalize_email_options);
	
	  if (!(0, _isEmail2.default)(email)) {
	    return false;
	  }
	
	  var raw_parts = email.split('@');
	  var domain = raw_parts.pop();
	  var user = raw_parts.join('@');
	  var parts = [user, domain];
	
	  // The domain is always lowercased, as it's case-insensitive per RFC 1035
	  parts[1] = parts[1].toLowerCase();
	
	  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
	    // Address is GMail
	    if (options.gmail_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (options.gmail_remove_dots) {
	      parts[0] = parts[0].replace(/\./g, '');
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.gmail_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
	  } else if (~icloud_domains.indexOf(parts[1])) {
	    // Address is iCloud
	    if (options.icloud_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.icloud_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (~outlookdotcom_domains.indexOf(parts[1])) {
	    // Address is Outlook.com
	    if (options.outlookdotcom_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.outlookdotcom_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (~yahoo_domains.indexOf(parts[1])) {
	    // Address is Yahoo
	    if (options.yahoo_remove_subaddress) {
	      var components = parts[0].split('-');
	      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.yahoo_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (options.all_lowercase) {
	    // Any other address
	    parts[0] = parts[0].toLowerCase();
	  }
	  return parts.join('@');
	}
	module.exports = exports['default'];

/***/ },
/* 4142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stripLow;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _blacklist = __webpack_require__(1789);
	
	var _blacklist2 = _interopRequireDefault(_blacklist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stripLow(str, keep_new_lines) {
	  (0, _assertString2.default)(str);
	  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
	  return (0, _blacklist2.default)(str, chars);
	}
	module.exports = exports['default'];

/***/ },
/* 4143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toBoolean;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toBoolean(str, strict) {
	  (0, _assertString2.default)(str);
	  if (strict) {
	    return str === '1' || str === 'true';
	  }
	  return str !== '0' && str !== 'false' && str !== '';
	}
	module.exports = exports['default'];

/***/ },
/* 4144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInt;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toInt(str, radix) {
	  (0, _assertString2.default)(str);
	  return parseInt(str, radix || 10);
	}
	module.exports = exports['default'];

/***/ },
/* 4145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	
	var _rtrim = __webpack_require__(1797);
	
	var _rtrim2 = _interopRequireDefault(_rtrim);
	
	var _ltrim = __webpack_require__(1796);
	
	var _ltrim2 = _interopRequireDefault(_ltrim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function trim(str, chars) {
	  return (0, _rtrim2.default)((0, _ltrim2.default)(str, chars), chars);
	}
	module.exports = exports['default'];

/***/ },
/* 4146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	exports.default = unescape;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unescape(str) {
	      (0, _assertString2.default)(str);
	      return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#96;/g, '`');
	}
	module.exports = exports['default'];

/***/ },
/* 4147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = whitelist;
	
	var _assertString = __webpack_require__(25);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function whitelist(str, chars) {
	  (0, _assertString2.default)(str);
	  return str.replace(new RegExp('[^' + chars + ']+', 'g'), '');
	}
	module.exports = exports['default'];

/***/ },
/* 4148 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 4149 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(1799)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58).Buffer))

/***/ },
/* 4150 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58).Buffer))

/***/ },
/* 4151 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(4154)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(1799)
	
	exports.createHmac = __webpack_require__(4149)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(4153)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createCipher'
	, 'createCipheriv'
	, 'createDecipher'
	, 'createDecipheriv'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58).Buffer))

/***/ },
/* 4152 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(4150);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ },
/* 4153 */
/***/ function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(3023)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ },
/* 4154 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(4173)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(58).Buffer))

/***/ },
/* 4155 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 4156 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58).Buffer))

/***/ },
/* 4157 */
/***/ function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ },
/* 4158 */
/***/ function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(58).Buffer
	var Hash   = __webpack_require__(4157)(Buffer)
	
	exports.sha1 = __webpack_require__(4159)(Buffer, Hash)
	exports.sha256 = __webpack_require__(4160)(Buffer, Hash)
	exports.sha512 = __webpack_require__(4161)(Buffer, Hash)


/***/ },
/* 4159 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(838).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ },
/* 4160 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(838).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ },
/* 4161 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(838).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ },
/* 4162 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(227)


/***/ },
/* 4163 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1800)


/***/ },
/* 4164 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = __webpack_require__(1801);
	exports.Stream = __webpack_require__(226);
	exports.Readable = exports;
	exports.Writable = __webpack_require__(837);
	exports.Duplex = __webpack_require__(227);
	exports.Transform = __webpack_require__(836);
	exports.PassThrough = __webpack_require__(1800);
	if (!process.browser && process.env.READABLE_STREAM === 'disable') {
	  module.exports = __webpack_require__(226);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ },
/* 4165 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(836)


/***/ },
/* 4166 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(837)


/***/ },
/* 4167 */
1825,
/* 4168 */
1826,
/* 4169 */
/***/ function(module, exports, __webpack_require__) {

	var _global = (function() { return this; })();
	var nativeWebSocket = _global.WebSocket || _global.MozWebSocket;
	var websocket_version = __webpack_require__(4170);
	
	
	/**
	 * Expose a W3C WebSocket class with just one or two arguments.
	 */
	function W3CWebSocket(uri, protocols) {
		var native_instance;
	
		if (protocols) {
			native_instance = new nativeWebSocket(uri, protocols);
		}
		else {
			native_instance = new nativeWebSocket(uri);
		}
	
		/**
		 * 'native_instance' is an instance of nativeWebSocket (the browser's WebSocket
		 * class). Since it is an Object it will be returned as it is when creating an
		 * instance of W3CWebSocket via 'new W3CWebSocket()'.
		 *
		 * ECMAScript 5: http://bclary.com/2004/11/07/#a-13.2.2
		 */
		return native_instance;
	}
	
	
	/**
	 * Module exports.
	 */
	module.exports = {
	    'w3cwebsocket' : nativeWebSocket ? W3CWebSocket : null,
	    'version'      : websocket_version
	};


/***/ },
/* 4170 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2950).version;


/***/ },
/* 4171 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 4172 */
/***/ function(module, exports) {

	module.exports = XMLHttpRequest;


/***/ },
/* 4173 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 4174 */
4173,
/* 4175 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	module.exports = __webpack_require__(__webpack_module_template_argument_0__)


/***/ },
/* 4176 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var Promise = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = Promise;
	Promise.prototype.done = function (onFulfilled, onRejected) {
	  var self = arguments.length ? this.then.apply(this, arguments) : this;
	  self.then(null, function (err) {
	    setTimeout(function () {
	      throw err;
	    }, 0);
	  });
	};


/***/ },
/* 4177 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var Promise = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = Promise;
	Promise.prototype['finally'] = function (f) {
	  return this.then(function (value) {
	    return Promise.resolve(f()).then(function () {
	      return value;
	    });
	  }, function (err) {
	    return Promise.resolve(f()).then(function () {
	      throw err;
	    });
	  });
	};


/***/ },
/* 4178 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	
	module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	__webpack_require__(__webpack_module_template_argument_1__);
	__webpack_require__(__webpack_module_template_argument_2__);
	__webpack_require__(__webpack_module_template_argument_3__);
	__webpack_require__(__webpack_module_template_argument_4__);
	__webpack_require__(__webpack_module_template_argument_5__);


/***/ },
/* 4179 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Check if `fn` is a function.
	 *
	 * @param {Function} fn
	 * @return {Boolean}
	 * @api private
	 */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	
	function isFunction(fn) {
	  var tag = isObject(fn) ? Object.prototype.toString.call(fn) : '';
	  return tag === '[object Function]';
	}
	
	module.exports = isFunction;


/***/ },
/* 4180 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	
	/**
	 * Module dependencies.
	 */
	
	var utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Expose `ResponseBase`.
	 */
	
	module.exports = ResponseBase;
	
	/**
	 * Initialize a new `ResponseBase`.
	 *
	 * @api public
	 */
	
	function ResponseBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in ResponseBase.prototype) {
	    obj[key] = ResponseBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	ResponseBase.prototype.get = function(field){
	    return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	ResponseBase.prototype._setHeaderProperties = function(header){
	    // TODO: moar!
	    // TODO: make this a util
	
	    // content-type
	    var ct = header['content-type'] || '';
	    this.type = utils.type(ct);
	
	    // params
	    var params = utils.params(ct);
	    for (var key in params) this[key] = params[key];
	
	    this.links = {};
	
	    // links
	    try {
	        if (header.link) {
	            this.links = utils.parseLinks(header.link);
	        }
	    } catch (err) {
	        // ignore
	    }
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	ResponseBase.prototype._setStatusProperties = function(status){
	    var type = status / 100 | 0;
	
	    // status / class
	    this.status = this.statusCode = status;
	    this.statusType = type;
	
	    // basics
	    this.info = 1 == type;
	    this.ok = 2 == type;
	    this.redirect = 3 == type;
	    this.clientError = 4 == type;
	    this.serverError = 5 == type;
	    this.error = (4 == type || 5 == type)
	        ? this.toError()
	        : false;
	
	    // sugar
	    this.accepted = 202 == status;
	    this.noContent = 204 == status;
	    this.badRequest = 400 == status;
	    this.unauthorized = 401 == status;
	    this.notAcceptable = 406 == status;
	    this.forbidden = 403 == status;
	    this.notFound = 404 == status;
	};


/***/ },
/* 4181 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(__webpack_module_template_argument_0__);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(__webpack_module_template_argument_1__);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(66)))

/***/ },
/* 4182 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	var stringify = __webpack_require__(__webpack_module_template_argument_0__);
	var parse = __webpack_require__(__webpack_module_template_argument_1__);
	var formats = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ },
/* 4183 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = __webpack_require__(__webpack_module_template_argument_0__).default;

/***/ },
/* 4184 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadingDiscussions = loadingDiscussions;
	exports.reloadDiscussions = reloadDiscussions;
	exports.loadDiscussionsError = loadDiscussionsError;
	exports.loadingDiscussionsSuccess = loadingDiscussionsSuccess;
	exports.setReloadDiscussions = setReloadDiscussions;
	exports.clearDiscussions = clearDiscussions;
	
	var _constants = __webpack_require__(__webpack_module_template_argument_0__);
	
	function loadingDiscussions(campaignId) {
	  return {
	    type: _constants.LOAD_DISCUSSIONS,
	    campaignId: campaignId
	  };
	}
	
	function reloadDiscussions(data) {
	  return {
	    type: _constants.RELOAD_DISCUSSIONS,
	    data: data
	  };
	}
	
	function loadDiscussionsError(error) {
	  return {
	    type: _constants.LOAD_DISCUSSIONS_SUCCESS,
	    error: error
	  };
	}
	
	function loadingDiscussionsSuccess(discussions) {
	  return {
	    type: _constants.LOAD_DISCUSSIONS_ERROR,
	    discussions: discussions
	  };
	}
	
	function setReloadDiscussions(reloadDiscussions) {
	  return {
	    type: _constants.SET_RELOAD_DISCUSSIONS,
	    reloadDiscussions: reloadDiscussions
	  };
	}
	
	function clearDiscussions() {
	  return {
	    type: _constants.CLEAR_DISCUSSIONS
	  };
	}

/***/ },
/* 4185 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 4186 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 4187 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var hashClear = __webpack_require__(__webpack_module_template_argument_0__),
	    hashDelete = __webpack_require__(__webpack_module_template_argument_1__),
	    hashGet = __webpack_require__(__webpack_module_template_argument_2__),
	    hashHas = __webpack_require__(__webpack_module_template_argument_3__),
	    hashSet = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 4188 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseCreate = __webpack_require__(__webpack_module_template_argument_0__),
	    baseLodash = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 4189 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var listCacheClear = __webpack_require__(__webpack_module_template_argument_0__),
	    listCacheDelete = __webpack_require__(__webpack_module_template_argument_1__),
	    listCacheGet = __webpack_require__(__webpack_module_template_argument_2__),
	    listCacheHas = __webpack_require__(__webpack_module_template_argument_3__),
	    listCacheSet = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 4190 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseCreate = __webpack_require__(__webpack_module_template_argument_0__),
	    baseLodash = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 4191 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 4192 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var mapCacheClear = __webpack_require__(__webpack_module_template_argument_0__),
	    mapCacheDelete = __webpack_require__(__webpack_module_template_argument_1__),
	    mapCacheGet = __webpack_require__(__webpack_module_template_argument_2__),
	    mapCacheHas = __webpack_require__(__webpack_module_template_argument_3__),
	    mapCacheSet = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 4193 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 4194 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 4195 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var MapCache = __webpack_require__(__webpack_module_template_argument_0__),
	    setCacheAdd = __webpack_require__(__webpack_module_template_argument_1__),
	    setCacheHas = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 4196 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ListCache = __webpack_require__(__webpack_module_template_argument_0__),
	    stackClear = __webpack_require__(__webpack_module_template_argument_1__),
	    stackDelete = __webpack_require__(__webpack_module_template_argument_2__),
	    stackGet = __webpack_require__(__webpack_module_template_argument_3__),
	    stackHas = __webpack_require__(__webpack_module_template_argument_4__),
	    stackSet = __webpack_require__(__webpack_module_template_argument_5__);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 4197 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 4198 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 4199 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 4200 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 4201 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var baseTimes = __webpack_require__(__webpack_module_template_argument_0__),
	    isArguments = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__),
	    isBuffer = __webpack_require__(__webpack_module_template_argument_3__),
	    isIndex = __webpack_require__(__webpack_module_template_argument_4__),
	    isTypedArray = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 4202 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseProperty = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the size of an ASCII `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	var asciiSize = baseProperty('length');
	
	module.exports = asciiSize;


/***/ },
/* 4203 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseAssignValue = __webpack_require__(__webpack_module_template_argument_0__),
	    eq = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 4204 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var eq = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 4205 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseEach = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },
/* 4206 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var copyObject = __webpack_require__(__webpack_module_template_argument_0__),
	    keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 4207 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var copyObject = __webpack_require__(__webpack_module_template_argument_0__),
	    keysIn = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 4208 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 4209 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__) {

	var Stack = __webpack_require__(__webpack_module_template_argument_0__),
	    arrayEach = __webpack_require__(__webpack_module_template_argument_1__),
	    assignValue = __webpack_require__(__webpack_module_template_argument_2__),
	    baseAssign = __webpack_require__(__webpack_module_template_argument_3__),
	    baseAssignIn = __webpack_require__(__webpack_module_template_argument_4__),
	    cloneBuffer = __webpack_require__(__webpack_module_template_argument_5__),
	    copyArray = __webpack_require__(__webpack_module_template_argument_6__),
	    copySymbols = __webpack_require__(__webpack_module_template_argument_7__),
	    copySymbolsIn = __webpack_require__(__webpack_module_template_argument_8__),
	    getAllKeys = __webpack_require__(__webpack_module_template_argument_9__),
	    getAllKeysIn = __webpack_require__(__webpack_module_template_argument_10__),
	    getTag = __webpack_require__(__webpack_module_template_argument_11__),
	    initCloneArray = __webpack_require__(__webpack_module_template_argument_12__),
	    initCloneByTag = __webpack_require__(__webpack_module_template_argument_13__),
	    initCloneObject = __webpack_require__(__webpack_module_template_argument_14__),
	    isArray = __webpack_require__(__webpack_module_template_argument_15__),
	    isBuffer = __webpack_require__(__webpack_module_template_argument_16__),
	    isMap = __webpack_require__(__webpack_module_template_argument_17__),
	    isObject = __webpack_require__(__webpack_module_template_argument_18__),
	    isSet = __webpack_require__(__webpack_module_template_argument_19__),
	    keys = __webpack_require__(__webpack_module_template_argument_20__),
	    keysIn = __webpack_require__(__webpack_module_template_argument_21__);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 4210 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 4211 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var SetCache = __webpack_require__(__webpack_module_template_argument_0__),
	    arrayIncludes = __webpack_require__(__webpack_module_template_argument_1__),
	    arrayIncludesWith = __webpack_require__(__webpack_module_template_argument_2__),
	    arrayMap = __webpack_require__(__webpack_module_template_argument_3__),
	    baseUnary = __webpack_require__(__webpack_module_template_argument_4__),
	    cacheHas = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 4212 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseForOwn = __webpack_require__(__webpack_module_template_argument_0__),
	    createBaseEach = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 4213 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseEach = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 4214 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isSymbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ },
/* 4215 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseEach = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 4216 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var arrayPush = __webpack_require__(__webpack_module_template_argument_0__),
	    isFlattenable = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 4217 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var createBaseFor = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 4218 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseFor = __webpack_require__(__webpack_module_template_argument_0__),
	    keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 4219 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var castPath = __webpack_require__(__webpack_module_template_argument_0__),
	    toKey = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 4220 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var arrayPush = __webpack_require__(__webpack_module_template_argument_0__),
	    isArray = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 4221 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
	    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 4222 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseFindIndex = __webpack_require__(__webpack_module_template_argument_0__),
	    baseIsNaN = __webpack_require__(__webpack_module_template_argument_1__),
	    strictIndexOf = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 4223 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var SetCache = __webpack_require__(__webpack_module_template_argument_0__),
	    arrayIncludes = __webpack_require__(__webpack_module_template_argument_1__),
	    arrayIncludesWith = __webpack_require__(__webpack_module_template_argument_2__),
	    arrayMap = __webpack_require__(__webpack_module_template_argument_3__),
	    baseUnary = __webpack_require__(__webpack_module_template_argument_4__),
	    cacheHas = __webpack_require__(__webpack_module_template_argument_5__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 4224 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var apply = __webpack_require__(__webpack_module_template_argument_0__),
	    castPath = __webpack_require__(__webpack_module_template_argument_1__),
	    last = __webpack_require__(__webpack_module_template_argument_2__),
	    parent = __webpack_require__(__webpack_module_template_argument_3__),
	    toKey = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * The base implementation of `_.invoke` without support for individual
	 * method arguments.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {Array} args The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 */
	function baseInvoke(object, path, args) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  var func = object == null ? object : object[toKey(last(path))];
	  return func == null ? undefined : apply(func, object, args);
	}
	
	module.exports = baseInvoke;


/***/ },
/* 4225 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 4226 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseIsEqualDeep = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 4227 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	var Stack = __webpack_require__(__webpack_module_template_argument_0__),
	    equalArrays = __webpack_require__(__webpack_module_template_argument_1__),
	    equalByTag = __webpack_require__(__webpack_module_template_argument_2__),
	    equalObjects = __webpack_require__(__webpack_module_template_argument_3__),
	    getTag = __webpack_require__(__webpack_module_template_argument_4__),
	    isArray = __webpack_require__(__webpack_module_template_argument_5__),
	    isBuffer = __webpack_require__(__webpack_module_template_argument_6__),
	    isTypedArray = __webpack_require__(__webpack_module_template_argument_7__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 4228 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ },
/* 4229 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var Stack = __webpack_require__(__webpack_module_template_argument_0__),
	    baseIsEqual = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 4230 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
	    isMasked = __webpack_require__(__webpack_module_template_argument_1__),
	    isObject = __webpack_require__(__webpack_module_template_argument_2__),
	    toSource = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 4231 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ },
/* 4232 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isLength = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 4233 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var baseMatches = __webpack_require__(__webpack_module_template_argument_0__),
	    baseMatchesProperty = __webpack_require__(__webpack_module_template_argument_1__),
	    identity = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__),
	    property = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 4234 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isPrototype = __webpack_require__(__webpack_module_template_argument_0__),
	    nativeKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 4235 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__),
	    isPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    nativeKeysIn = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 4236 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseEach = __webpack_require__(__webpack_module_template_argument_0__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 4237 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseIsMatch = __webpack_require__(__webpack_module_template_argument_0__),
	    getMatchData = __webpack_require__(__webpack_module_template_argument_1__),
	    matchesStrictComparable = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 4238 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var baseIsEqual = __webpack_require__(__webpack_module_template_argument_0__),
	    get = __webpack_require__(__webpack_module_template_argument_1__),
	    hasIn = __webpack_require__(__webpack_module_template_argument_2__),
	    isKey = __webpack_require__(__webpack_module_template_argument_3__),
	    isStrictComparable = __webpack_require__(__webpack_module_template_argument_4__),
	    matchesStrictComparable = __webpack_require__(__webpack_module_template_argument_5__),
	    toKey = __webpack_require__(__webpack_module_template_argument_6__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 4239 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	var arrayMap = __webpack_require__(__webpack_module_template_argument_0__),
	    baseGet = __webpack_require__(__webpack_module_template_argument_1__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_2__),
	    baseMap = __webpack_require__(__webpack_module_template_argument_3__),
	    baseSortBy = __webpack_require__(__webpack_module_template_argument_4__),
	    baseUnary = __webpack_require__(__webpack_module_template_argument_5__),
	    compareMultiple = __webpack_require__(__webpack_module_template_argument_6__),
	    identity = __webpack_require__(__webpack_module_template_argument_7__),
	    isArray = __webpack_require__(__webpack_module_template_argument_8__);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 4240 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var basePickBy = __webpack_require__(__webpack_module_template_argument_0__),
	    hasIn = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ },
/* 4241 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGet = __webpack_require__(__webpack_module_template_argument_0__),
	    baseSet = __webpack_require__(__webpack_module_template_argument_1__),
	    castPath = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 4242 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseGet = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 4243 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var identity = __webpack_require__(__webpack_module_template_argument_0__),
	    overRest = __webpack_require__(__webpack_module_template_argument_1__),
	    setToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 4244 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var assignValue = __webpack_require__(__webpack_module_template_argument_0__),
	    castPath = __webpack_require__(__webpack_module_template_argument_1__),
	    isIndex = __webpack_require__(__webpack_module_template_argument_2__),
	    isObject = __webpack_require__(__webpack_module_template_argument_3__),
	    toKey = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	      return object;
	    }
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 4245 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var identity = __webpack_require__(__webpack_module_template_argument_0__),
	    metaMap = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 4246 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var constant = __webpack_require__(__webpack_module_template_argument_0__),
	    defineProperty = __webpack_require__(__webpack_module_template_argument_1__),
	    identity = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 4247 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseEach = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 4248 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    arrayMap = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__),
	    isSymbol = __webpack_require__(__webpack_module_template_argument_3__);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 4249 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var SetCache = __webpack_require__(__webpack_module_template_argument_0__),
	    arrayIncludes = __webpack_require__(__webpack_module_template_argument_1__),
	    arrayIncludesWith = __webpack_require__(__webpack_module_template_argument_2__),
	    cacheHas = __webpack_require__(__webpack_module_template_argument_3__),
	    createSet = __webpack_require__(__webpack_module_template_argument_4__),
	    setToArray = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 4250 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var arrayMap = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 4251 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isArrayLikeObject = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 4252 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var identity = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 4253 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var isArray = __webpack_require__(__webpack_module_template_argument_0__),
	    isKey = __webpack_require__(__webpack_module_template_argument_1__),
	    stringToPath = __webpack_require__(__webpack_module_template_argument_2__),
	    toString = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 4254 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseSlice = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ },
/* 4255 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsEndIndex;


/***/ },
/* 4256 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsStartIndex;


/***/ },
/* 4257 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Uint8Array = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 4258 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)(module)))

/***/ },
/* 4259 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var cloneArrayBuffer = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 4260 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 4261 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var cloneArrayBuffer = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 4262 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isSymbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 4263 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var compareAscending = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 4264 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var assignValue = __webpack_require__(__webpack_module_template_argument_0__),
	    baseAssignValue = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 4265 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var copyObject = __webpack_require__(__webpack_module_template_argument_0__),
	    getSymbols = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 4266 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var copyObject = __webpack_require__(__webpack_module_template_argument_0__),
	    getSymbolsIn = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 4267 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 4268 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var arrayAggregator = __webpack_require__(__webpack_module_template_argument_0__),
	    baseAggregator = __webpack_require__(__webpack_module_template_argument_1__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 4269 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseRest = __webpack_require__(__webpack_module_template_argument_0__),
	    isIterateeCall = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 4270 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isArrayLike = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 4271 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var createCtor = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ },
/* 4272 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var castSlice = __webpack_require__(__webpack_module_template_argument_0__),
	    hasUnicode = __webpack_require__(__webpack_module_template_argument_1__),
	    stringToArray = __webpack_require__(__webpack_module_template_argument_2__),
	    toString = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ },
/* 4273 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var arrayReduce = __webpack_require__(__webpack_module_template_argument_0__),
	    deburr = __webpack_require__(__webpack_module_template_argument_1__),
	    words = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ },
/* 4274 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseCreate = __webpack_require__(__webpack_module_template_argument_0__),
	    isObject = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ },
/* 4275 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var apply = __webpack_require__(__webpack_module_template_argument_0__),
	    createCtor = __webpack_require__(__webpack_module_template_argument_1__),
	    createHybrid = __webpack_require__(__webpack_module_template_argument_2__),
	    createRecurry = __webpack_require__(__webpack_module_template_argument_3__),
	    getHolder = __webpack_require__(__webpack_module_template_argument_4__),
	    replaceHolders = __webpack_require__(__webpack_module_template_argument_5__),
	    root = __webpack_require__(__webpack_module_template_argument_6__);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ },
/* 4276 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseIteratee = __webpack_require__(__webpack_module_template_argument_0__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_1__),
	    keys = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 4277 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var LodashWrapper = __webpack_require__(__webpack_module_template_argument_0__),
	    flatRest = __webpack_require__(__webpack_module_template_argument_1__),
	    getData = __webpack_require__(__webpack_module_template_argument_2__),
	    getFuncName = __webpack_require__(__webpack_module_template_argument_3__),
	    isArray = __webpack_require__(__webpack_module_template_argument_4__),
	    isLaziable = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return flatRest(function(funcs) {
	    var length = funcs.length,
	        index = length,
	        prereq = LodashWrapper.prototype.thru;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      var func = funcs[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	        var wrapper = new LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? index : length;
	    while (++index < length) {
	      func = funcs[index];
	
	      var funcName = getFuncName(func),
	          data = funcName == 'wrapper' ? getData(func) : undefined;
	
	      if (data && isLaziable(data[0]) &&
	            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	            !data[4].length && data[9] == 1
	          ) {
	        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && isLaziable(func))
	          ? wrapper[funcName]()
	          : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];
	
	      if (wrapper && args.length == 1 && isArray(value)) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	module.exports = createFlow;


/***/ },
/* 4278 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	var composeArgs = __webpack_require__(__webpack_module_template_argument_0__),
	    composeArgsRight = __webpack_require__(__webpack_module_template_argument_1__),
	    countHolders = __webpack_require__(__webpack_module_template_argument_2__),
	    createCtor = __webpack_require__(__webpack_module_template_argument_3__),
	    createRecurry = __webpack_require__(__webpack_module_template_argument_4__),
	    getHolder = __webpack_require__(__webpack_module_template_argument_5__),
	    reorder = __webpack_require__(__webpack_module_template_argument_6__),
	    replaceHolders = __webpack_require__(__webpack_module_template_argument_7__),
	    root = __webpack_require__(__webpack_module_template_argument_8__);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ },
/* 4279 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var apply = __webpack_require__(__webpack_module_template_argument_0__),
	    createCtor = __webpack_require__(__webpack_module_template_argument_1__),
	    root = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ },
/* 4280 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var isLaziable = __webpack_require__(__webpack_module_template_argument_0__),
	    setData = __webpack_require__(__webpack_module_template_argument_1__),
	    setWrapToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ },
/* 4281 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__),
	    toInteger = __webpack_require__(__webpack_module_template_argument_1__),
	    toNumber = __webpack_require__(__webpack_module_template_argument_2__),
	    toString = __webpack_require__(__webpack_module_template_argument_3__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsFinite = root.isFinite,
	    nativeMin = Math.min;
	
	/**
	 * Creates a function like `_.round`.
	 *
	 * @private
	 * @param {string} methodName The name of the `Math` method to use when rounding.
	 * @returns {Function} Returns the new round function.
	 */
	function createRound(methodName) {
	  var func = Math[methodName];
	  return function(number, precision) {
	    number = toNumber(number);
	    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	    if (precision && nativeIsFinite(number)) {
	      // Shift with exponential notation to avoid floating-point issues.
	      // See [MDN](https://mdn.io/round#Examples) for more details.
	      var pair = (toString(number) + 'e').split('e'),
	          value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	      pair = (toString(value) + 'e').split('e');
	      return +(pair[0] + 'e' + (+pair[1] - precision));
	    }
	    return func(number);
	  };
	}
	
	module.exports = createRound;


/***/ },
/* 4282 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Set = __webpack_require__(__webpack_module_template_argument_0__),
	    noop = __webpack_require__(__webpack_module_template_argument_1__),
	    setToArray = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 4283 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	var baseSetData = __webpack_require__(__webpack_module_template_argument_0__),
	    createBind = __webpack_require__(__webpack_module_template_argument_1__),
	    createCurry = __webpack_require__(__webpack_module_template_argument_2__),
	    createHybrid = __webpack_require__(__webpack_module_template_argument_3__),
	    createPartial = __webpack_require__(__webpack_module_template_argument_4__),
	    getData = __webpack_require__(__webpack_module_template_argument_5__),
	    mergeData = __webpack_require__(__webpack_module_template_argument_6__),
	    setData = __webpack_require__(__webpack_module_template_argument_7__),
	    setWrapToString = __webpack_require__(__webpack_module_template_argument_8__),
	    toInteger = __webpack_require__(__webpack_module_template_argument_9__);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ },
/* 4284 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var basePropertyOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ },
/* 4285 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 4286 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var SetCache = __webpack_require__(__webpack_module_template_argument_0__),
	    arraySome = __webpack_require__(__webpack_module_template_argument_1__),
	    cacheHas = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 4287 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    Uint8Array = __webpack_require__(__webpack_module_template_argument_1__),
	    eq = __webpack_require__(__webpack_module_template_argument_2__),
	    equalArrays = __webpack_require__(__webpack_module_template_argument_3__),
	    mapToArray = __webpack_require__(__webpack_module_template_argument_4__),
	    setToArray = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 4288 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getAllKeys = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 4289 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var flatten = __webpack_require__(__webpack_module_template_argument_0__),
	    overRest = __webpack_require__(__webpack_module_template_argument_1__),
	    setToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 4290 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetAllKeys = __webpack_require__(__webpack_module_template_argument_0__),
	    getSymbols = __webpack_require__(__webpack_module_template_argument_1__),
	    keys = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 4291 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetAllKeys = __webpack_require__(__webpack_module_template_argument_0__),
	    getSymbolsIn = __webpack_require__(__webpack_module_template_argument_1__),
	    keysIn = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 4292 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var metaMap = __webpack_require__(__webpack_module_template_argument_0__),
	    noop = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 4293 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var realNames = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 4294 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isKeyable = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 4295 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isStrictComparable = __webpack_require__(__webpack_module_template_argument_0__),
	    keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 4296 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseIsNative = __webpack_require__(__webpack_module_template_argument_0__),
	    getValue = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 4297 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 4298 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 4299 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var arrayFilter = __webpack_require__(__webpack_module_template_argument_0__),
	    stubArray = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 4300 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var arrayPush = __webpack_require__(__webpack_module_template_argument_0__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    getSymbols = __webpack_require__(__webpack_module_template_argument_2__),
	    stubArray = __webpack_require__(__webpack_module_template_argument_3__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 4301 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var DataView = __webpack_require__(__webpack_module_template_argument_0__),
	    Map = __webpack_require__(__webpack_module_template_argument_1__),
	    Promise = __webpack_require__(__webpack_module_template_argument_2__),
	    Set = __webpack_require__(__webpack_module_template_argument_3__),
	    WeakMap = __webpack_require__(__webpack_module_template_argument_4__),
	    baseGetTag = __webpack_require__(__webpack_module_template_argument_5__),
	    toSource = __webpack_require__(__webpack_module_template_argument_6__);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 4302 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var castPath = __webpack_require__(__webpack_module_template_argument_0__),
	    isArguments = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__),
	    isIndex = __webpack_require__(__webpack_module_template_argument_3__),
	    isLength = __webpack_require__(__webpack_module_template_argument_4__),
	    toKey = __webpack_require__(__webpack_module_template_argument_5__);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 4303 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 4304 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 4305 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 4306 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 4307 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var cloneArrayBuffer = __webpack_require__(__webpack_module_template_argument_0__),
	    cloneDataView = __webpack_require__(__webpack_module_template_argument_1__),
	    cloneRegExp = __webpack_require__(__webpack_module_template_argument_2__),
	    cloneSymbol = __webpack_require__(__webpack_module_template_argument_3__),
	    cloneTypedArray = __webpack_require__(__webpack_module_template_argument_4__);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 4308 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseCreate = __webpack_require__(__webpack_module_template_argument_0__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    isPrototype = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 4309 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    isArguments = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 4310 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var eq = __webpack_require__(__webpack_module_template_argument_0__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_1__),
	    isIndex = __webpack_require__(__webpack_module_template_argument_2__),
	    isObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 4311 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isArray = __webpack_require__(__webpack_module_template_argument_0__),
	    isSymbol = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 4312 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var LazyWrapper = __webpack_require__(__webpack_module_template_argument_0__),
	    getData = __webpack_require__(__webpack_module_template_argument_1__),
	    getFuncName = __webpack_require__(__webpack_module_template_argument_2__),
	    lodash = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 4313 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var coreJsData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 4314 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 4315 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 4316 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 4317 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 4318 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 4319 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Hash = __webpack_require__(__webpack_module_template_argument_0__),
	    ListCache = __webpack_require__(__webpack_module_template_argument_1__),
	    Map = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 4320 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 4321 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 4322 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 4323 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 4324 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var memoize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 4325 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var composeArgs = __webpack_require__(__webpack_module_template_argument_0__),
	    composeArgsRight = __webpack_require__(__webpack_module_template_argument_1__),
	    replaceHolders = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 4326 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var WeakMap = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ },
/* 4327 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 4328 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 4329 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)(module)))

/***/ },
/* 4330 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var apply = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 4331 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGet = __webpack_require__(__webpack_module_template_argument_0__),
	    baseSlice = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 4332 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var copyArray = __webpack_require__(__webpack_module_template_argument_0__),
	    isIndex = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 4333 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 4334 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseSetData = __webpack_require__(__webpack_module_template_argument_0__),
	    shortOut = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ },
/* 4335 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseSetToString = __webpack_require__(__webpack_module_template_argument_0__),
	    shortOut = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 4336 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var getWrapDetails = __webpack_require__(__webpack_module_template_argument_0__),
	    insertWrapDetails = __webpack_require__(__webpack_module_template_argument_1__),
	    setToString = __webpack_require__(__webpack_module_template_argument_2__),
	    updateWrapDetails = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ },
/* 4337 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ListCache = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 4338 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var ListCache = __webpack_require__(__webpack_module_template_argument_0__),
	    Map = __webpack_require__(__webpack_module_template_argument_1__),
	    MapCache = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 4339 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var asciiSize = __webpack_require__(__webpack_module_template_argument_0__),
	    hasUnicode = __webpack_require__(__webpack_module_template_argument_1__),
	    unicodeSize = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  return hasUnicode(string)
	    ? unicodeSize(string)
	    : asciiSize(string);
	}
	
	module.exports = stringSize;


/***/ },
/* 4340 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var asciiToArray = __webpack_require__(__webpack_module_template_argument_0__),
	    hasUnicode = __webpack_require__(__webpack_module_template_argument_1__),
	    unicodeToArray = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ },
/* 4341 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var memoizeCapped = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 4342 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isSymbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 4343 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var arrayEach = __webpack_require__(__webpack_module_template_argument_0__),
	    arrayIncludes = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ },
/* 4344 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var LazyWrapper = __webpack_require__(__webpack_module_template_argument_0__),
	    LodashWrapper = __webpack_require__(__webpack_module_template_argument_1__),
	    copyArray = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ },
/* 4345 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var createWrap = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_ARY_FLAG = 128;
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments,
	 * ignoring any additional arguments.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} [n=func.length] The arity cap.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new capped function.
	 * @example
	 *
	 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	 * // => [6, 8, 10]
	 */
	function ary(func, n, guard) {
	  n = guard ? undefined : n;
	  n = (func && n == null) ? func.length : n;
	  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	}
	
	module.exports = ary;


/***/ },
/* 4346 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var assignValue = __webpack_require__(__webpack_module_template_argument_0__),
	    copyObject = __webpack_require__(__webpack_module_template_argument_1__),
	    createAssigner = __webpack_require__(__webpack_module_template_argument_2__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_3__),
	    isPrototype = __webpack_require__(__webpack_module_template_argument_4__),
	    keys = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ },
/* 4347 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseClamp = __webpack_require__(__webpack_module_template_argument_0__),
	    toNumber = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Clamps `number` within the inclusive `lower` and `upper` bounds.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Number
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 * @example
	 *
	 * _.clamp(-10, -5, 5);
	 * // => -5
	 *
	 * _.clamp(10, -5, 5);
	 * // => 5
	 */
	function clamp(number, lower, upper) {
	  if (upper === undefined) {
	    upper = lower;
	    lower = undefined;
	  }
	  if (upper !== undefined) {
	    upper = toNumber(upper);
	    upper = upper === upper ? upper : 0;
	  }
	  if (lower !== undefined) {
	    lower = toNumber(lower);
	    lower = lower === lower ? lower : 0;
	  }
	  return baseClamp(toNumber(number), lower, upper);
	}
	
	module.exports = clamp;


/***/ },
/* 4348 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseClone = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ },
/* 4349 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var createWrap = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8;
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;


/***/ },
/* 4350 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var deburrLetter = __webpack_require__(__webpack_module_template_argument_0__),
	    toString = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ },
/* 4351 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var baseDifference = __webpack_require__(__webpack_module_template_argument_0__),
	    baseFlatten = __webpack_require__(__webpack_module_template_argument_1__),
	    baseRest = __webpack_require__(__webpack_module_template_argument_2__),
	    isArrayLikeObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ },
/* 4352 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseSlice = __webpack_require__(__webpack_module_template_argument_0__),
	    toInteger = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Creates a slice of `array` with `n` elements dropped from the end.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to drop.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.dropRight([1, 2, 3]);
	 * // => [1, 2]
	 *
	 * _.dropRight([1, 2, 3], 2);
	 * // => [1]
	 *
	 * _.dropRight([1, 2, 3], 5);
	 * // => []
	 *
	 * _.dropRight([1, 2, 3], 0);
	 * // => [1, 2, 3]
	 */
	function dropRight(array, n, guard) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  n = length - n;
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = dropRight;


/***/ },
/* 4353 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 4354 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toString = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	    reHasRegExpChar = RegExp(reRegExpChar.source);
	
	/**
	 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escapeRegExp('[lodash](https://lodash.com/)');
	 * // => '\[lodash\]\(https://lodash\.com/\)'
	 */
	function escapeRegExp(string) {
	  string = toString(string);
	  return (string && reHasRegExpChar.test(string))
	    ? string.replace(reRegExpChar, '\\$&')
	    : string;
	}
	
	module.exports = escapeRegExp;


/***/ },
/* 4355 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var arrayEvery = __webpack_require__(__webpack_module_template_argument_0__),
	    baseEvery = __webpack_require__(__webpack_module_template_argument_1__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__),
	    isIterateeCall = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ },
/* 4356 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var arrayFilter = __webpack_require__(__webpack_module_template_argument_0__),
	    baseFilter = __webpack_require__(__webpack_module_template_argument_1__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 4357 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var createFind = __webpack_require__(__webpack_module_template_argument_0__),
	    findIndex = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 4358 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseFindIndex = __webpack_require__(__webpack_module_template_argument_0__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_1__),
	    toInteger = __webpack_require__(__webpack_module_template_argument_2__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 4359 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseFlatten = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 4360 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var createFlow = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Creates a function that returns the result of invoking the given functions
	 * with the `this` binding of the created function, where each successive
	 * invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flowRight
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow([_.add, square]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = createFlow();
	
	module.exports = flow;


/***/ },
/* 4361 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var arrayEach = __webpack_require__(__webpack_module_template_argument_0__),
	    baseEach = __webpack_require__(__webpack_module_template_argument_1__),
	    castFunction = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 4362 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var mapping = __webpack_require__(__webpack_module_template_argument_0__),
	    fallbackHolder = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Built-in value reference. */
	var push = Array.prototype.push;
	
	/**
	 * Creates a function, with an arity of `n`, that invokes `func` with the
	 * arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} n The arity of the new function.
	 * @returns {Function} Returns the new function.
	 */
	function baseArity(func, n) {
	  return n == 2
	    ? function(a, b) { return func.apply(undefined, arguments); }
	    : function(a) { return func.apply(undefined, arguments); };
	}
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
	 * any additional arguments.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} n The arity cap.
	 * @returns {Function} Returns the new function.
	 */
	function baseAry(func, n) {
	  return n == 2
	    ? function(a, b) { return func(a, b); }
	    : function(a) { return func(a); };
	}
	
	/**
	 * Creates a clone of `array`.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the cloned array.
	 */
	function cloneArray(array) {
	  var length = array ? array.length : 0,
	      result = Array(length);
	
	  while (length--) {
	    result[length] = array[length];
	  }
	  return result;
	}
	
	/**
	 * Creates a function that clones a given object using the assignment `func`.
	 *
	 * @private
	 * @param {Function} func The assignment function.
	 * @returns {Function} Returns the new cloner function.
	 */
	function createCloner(func) {
	  return function(object) {
	    return func({}, object);
	  };
	}
	
	/**
	 * A specialized version of `_.spread` which flattens the spread array into
	 * the arguments of the invoked `func`.
	 *
	 * @private
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} start The start position of the spread.
	 * @returns {Function} Returns the new function.
	 */
	function flatSpread(func, start) {
	  return function() {
	    var length = arguments.length,
	        lastIndex = length - 1,
	        args = Array(length);
	
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var array = args[start],
	        otherArgs = args.slice(0, start);
	
	    if (array) {
	      push.apply(otherArgs, array);
	    }
	    if (start != lastIndex) {
	      push.apply(otherArgs, args.slice(start + 1));
	    }
	    return func.apply(this, otherArgs);
	  };
	}
	
	/**
	 * Creates a function that wraps `func` and uses `cloner` to clone the first
	 * argument it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} cloner The function to clone arguments.
	 * @returns {Function} Returns the new immutable function.
	 */
	function wrapImmutable(func, cloner) {
	  return function() {
	    var length = arguments.length;
	    if (!length) {
	      return;
	    }
	    var args = Array(length);
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var result = args[0] = cloner.apply(undefined, args);
	    func.apply(undefined, args);
	    return result;
	  };
	}
	
	/**
	 * The base implementation of `convert` which accepts a `util` object of methods
	 * required to perform conversions.
	 *
	 * @param {Object} util The util object.
	 * @param {string} name The name of the function to convert.
	 * @param {Function} func The function to convert.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
	 * @param {boolean} [options.curry=true] Specify currying.
	 * @param {boolean} [options.fixed=true] Specify fixed arity.
	 * @param {boolean} [options.immutable=true] Specify immutable operations.
	 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function baseConvert(util, name, func, options) {
	  var isLib = typeof name == 'function',
	      isObj = name === Object(name);
	
	  if (isObj) {
	    options = func;
	    func = name;
	    name = undefined;
	  }
	  if (func == null) {
	    throw new TypeError;
	  }
	  options || (options = {});
	
	  var config = {
	    'cap': 'cap' in options ? options.cap : true,
	    'curry': 'curry' in options ? options.curry : true,
	    'fixed': 'fixed' in options ? options.fixed : true,
	    'immutable': 'immutable' in options ? options.immutable : true,
	    'rearg': 'rearg' in options ? options.rearg : true
	  };
	
	  var defaultHolder = isLib ? func : fallbackHolder,
	      forceCurry = ('curry' in options) && options.curry,
	      forceFixed = ('fixed' in options) && options.fixed,
	      forceRearg = ('rearg' in options) && options.rearg,
	      pristine = isLib ? func.runInContext() : undefined;
	
	  var helpers = isLib ? func : {
	    'ary': util.ary,
	    'assign': util.assign,
	    'clone': util.clone,
	    'curry': util.curry,
	    'forEach': util.forEach,
	    'isArray': util.isArray,
	    'isError': util.isError,
	    'isFunction': util.isFunction,
	    'isWeakMap': util.isWeakMap,
	    'iteratee': util.iteratee,
	    'keys': util.keys,
	    'rearg': util.rearg,
	    'toInteger': util.toInteger,
	    'toPath': util.toPath
	  };
	
	  var ary = helpers.ary,
	      assign = helpers.assign,
	      clone = helpers.clone,
	      curry = helpers.curry,
	      each = helpers.forEach,
	      isArray = helpers.isArray,
	      isError = helpers.isError,
	      isFunction = helpers.isFunction,
	      isWeakMap = helpers.isWeakMap,
	      keys = helpers.keys,
	      rearg = helpers.rearg,
	      toInteger = helpers.toInteger,
	      toPath = helpers.toPath;
	
	  var aryMethodKeys = keys(mapping.aryMethod);
	
	  var wrappers = {
	    'castArray': function(castArray) {
	      return function() {
	        var value = arguments[0];
	        return isArray(value)
	          ? castArray(cloneArray(value))
	          : castArray.apply(undefined, arguments);
	      };
	    },
	    'iteratee': function(iteratee) {
	      return function() {
	        var func = arguments[0],
	            arity = arguments[1],
	            result = iteratee(func, arity),
	            length = result.length;
	
	        if (config.cap && typeof arity == 'number') {
	          arity = arity > 2 ? (arity - 2) : 1;
	          return (length && length <= arity) ? result : baseAry(result, arity);
	        }
	        return result;
	      };
	    },
	    'mixin': function(mixin) {
	      return function(source) {
	        var func = this;
	        if (!isFunction(func)) {
	          return mixin(func, Object(source));
	        }
	        var pairs = [];
	        each(keys(source), function(key) {
	          if (isFunction(source[key])) {
	            pairs.push([key, func.prototype[key]]);
	          }
	        });
	
	        mixin(func, Object(source));
	
	        each(pairs, function(pair) {
	          var value = pair[1];
	          if (isFunction(value)) {
	            func.prototype[pair[0]] = value;
	          } else {
	            delete func.prototype[pair[0]];
	          }
	        });
	        return func;
	      };
	    },
	    'nthArg': function(nthArg) {
	      return function(n) {
	        var arity = n < 0 ? 1 : (toInteger(n) + 1);
	        return curry(nthArg(n), arity);
	      };
	    },
	    'rearg': function(rearg) {
	      return function(func, indexes) {
	        var arity = indexes ? indexes.length : 0;
	        return curry(rearg(func, indexes), arity);
	      };
	    },
	    'runInContext': function(runInContext) {
	      return function(context) {
	        return baseConvert(util, runInContext(context), options);
	      };
	    }
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Casts `func` to a function with an arity capped iteratee if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCap(name, func) {
	    if (config.cap) {
	      var indexes = mapping.iterateeRearg[name];
	      if (indexes) {
	        return iterateeRearg(func, indexes);
	      }
	      var n = !isLib && mapping.iterateeAry[name];
	      if (n) {
	        return iterateeAry(func, n);
	      }
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to a curried function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCurry(name, func, n) {
	    return (forceCurry || (config.curry && n > 1))
	      ? curry(func, n)
	      : func;
	  }
	
	  /**
	   * Casts `func` to a fixed arity function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the cast function.
	   */
	  function castFixed(name, func, n) {
	    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
	      var data = mapping.methodSpread[name],
	          start = data && data.start;
	
	      return start  === undefined ? ary(func, n) : flatSpread(func, start);
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to an rearged function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castRearg(name, func, n) {
	    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
	      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
	      : func;
	  }
	
	  /**
	   * Creates a clone of `object` by `path`.
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @param {Array|string} path The path to clone by.
	   * @returns {Object} Returns the cloned object.
	   */
	  function cloneByPath(object, path) {
	    path = toPath(path);
	
	    var index = -1,
	        length = path.length,
	        lastIndex = length - 1,
	        result = clone(Object(object)),
	        nested = result;
	
	    while (nested != null && ++index < length) {
	      var key = path[index],
	          value = nested[key];
	
	      if (value != null &&
	          !(isFunction(value) || isError(value) || isWeakMap(value))) {
	        nested[key] = clone(index == lastIndex ? value : Object(value));
	      }
	      nested = nested[key];
	    }
	    return result;
	  }
	
	  /**
	   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
	   * version with conversion `options` applied.
	   *
	   * @param {Object} [options] The options object. See `baseConvert` for more details.
	   * @returns {Function} Returns the converted `lodash`.
	   */
	  function convertLib(options) {
	    return _.runInContext.convert(options)(undefined);
	  }
	
	  /**
	   * Create a converter function for `func` of `name`.
	   *
	   * @param {string} name The name of the function to convert.
	   * @param {Function} func The function to convert.
	   * @returns {Function} Returns the new converter function.
	   */
	  function createConverter(name, func) {
	    var realName = mapping.aliasToReal[name] || name,
	        methodName = mapping.remap[realName] || realName,
	        oldOptions = options;
	
	    return function(options) {
	      var newUtil = isLib ? pristine : helpers,
	          newFunc = isLib ? pristine[methodName] : func,
	          newOptions = assign(assign({}, oldOptions), options);
	
	      return baseConvert(newUtil, realName, newFunc, newOptions);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
	   * arguments, ignoring any additional arguments.
	   *
	   * @private
	   * @param {Function} func The function to cap iteratee arguments for.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeAry(func, n) {
	    return overArg(func, function(func) {
	      return typeof func == 'function' ? baseAry(func, n) : func;
	    });
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee with arguments
	   * arranged according to the specified `indexes` where the argument value at
	   * the first index is provided as the first argument, the argument value at
	   * the second index is provided as the second argument, and so on.
	   *
	   * @private
	   * @param {Function} func The function to rearrange iteratee arguments for.
	   * @param {number[]} indexes The arranged argument indexes.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeRearg(func, indexes) {
	    return overArg(func, function(func) {
	      var n = indexes.length;
	      return baseArity(rearg(baseAry(func, n), indexes), n);
	    });
	  }
	
	  /**
	   * Creates a function that invokes `func` with its first argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function() {
	      var length = arguments.length;
	      if (!length) {
	        return func();
	      }
	      var args = Array(length);
	      while (length--) {
	        args[length] = arguments[length];
	      }
	      var index = config.rearg ? 0 : (length - 1);
	      args[index] = transform(args[index]);
	      return func.apply(undefined, args);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` and applys the conversions
	   * rules by `name`.
	   *
	   * @private
	   * @param {string} name The name of the function to wrap.
	   * @param {Function} func The function to wrap.
	   * @returns {Function} Returns the converted function.
	   */
	  function wrap(name, func, placeholder) {
	    var result,
	        realName = mapping.aliasToReal[name] || name,
	        wrapped = func,
	        wrapper = wrappers[realName];
	
	    if (wrapper) {
	      wrapped = wrapper(func);
	    }
	    else if (config.immutable) {
	      if (mapping.mutate.array[realName]) {
	        wrapped = wrapImmutable(func, cloneArray);
	      }
	      else if (mapping.mutate.object[realName]) {
	        wrapped = wrapImmutable(func, createCloner(func));
	      }
	      else if (mapping.mutate.set[realName]) {
	        wrapped = wrapImmutable(func, cloneByPath);
	      }
	    }
	    each(aryMethodKeys, function(aryKey) {
	      each(mapping.aryMethod[aryKey], function(otherName) {
	        if (realName == otherName) {
	          var data = mapping.methodSpread[realName],
	              afterRearg = data && data.afterRearg;
	
	          result = afterRearg
	            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
	            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
	
	          result = castCap(realName, result);
	          result = castCurry(realName, result, aryKey);
	          return false;
	        }
	      });
	      return !result;
	    });
	
	    result || (result = wrapped);
	    if (result == func) {
	      result = forceCurry ? curry(result, 1) : function() {
	        return func.apply(this, arguments);
	      };
	    }
	    result.convert = createConverter(realName, func);
	    result.placeholder = func.placeholder = placeholder;
	
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  if (!isObj) {
	    return wrap(name, func, defaultHolder);
	  }
	  var _ = func;
	
	  // Convert methods by ary cap.
	  var pairs = [];
	  each(aryMethodKeys, function(aryKey) {
	    each(mapping.aryMethod[aryKey], function(key) {
	      var func = _[mapping.remap[key] || key];
	      if (func) {
	        pairs.push([key, wrap(key, func, _)]);
	      }
	    });
	  });
	
	  // Convert remaining methods.
	  each(keys(_), function(key) {
	    var func = _[key];
	    if (typeof func == 'function') {
	      var length = pairs.length;
	      while (length--) {
	        if (pairs[length][0] == key) {
	          return;
	        }
	      }
	      func.convert = createConverter(key, func);
	      pairs.push([key, func]);
	    }
	  });
	
	  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
	  each(pairs, function(pair) {
	    _[pair[0]] = pair[1];
	  });
	
	  _.convert = convertLib;
	  _.placeholder = _;
	
	  // Assign aliases.
	  each(keys(_), function(key) {
	    each(mapping.realToAlias[key] || [], function(alias) {
	      _[alias] = _[key];
	    });
	  });
	
	  return _;
	}
	
	module.exports = baseConvert;


/***/ },
/* 4363 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__) {

	module.exports = {
	  'ary': __webpack_require__(__webpack_module_template_argument_0__),
	  'assign': __webpack_require__(__webpack_module_template_argument_1__),
	  'clone': __webpack_require__(__webpack_module_template_argument_2__),
	  'curry': __webpack_require__(__webpack_module_template_argument_3__),
	  'forEach': __webpack_require__(__webpack_module_template_argument_4__),
	  'isArray': __webpack_require__(__webpack_module_template_argument_5__),
	  'isError': __webpack_require__(__webpack_module_template_argument_6__),
	  'isFunction': __webpack_require__(__webpack_module_template_argument_7__),
	  'isWeakMap': __webpack_require__(__webpack_module_template_argument_8__),
	  'iteratee': __webpack_require__(__webpack_module_template_argument_9__),
	  'keys': __webpack_require__(__webpack_module_template_argument_10__),
	  'rearg': __webpack_require__(__webpack_module_template_argument_11__),
	  'toInteger': __webpack_require__(__webpack_module_template_argument_12__),
	  'toPath': __webpack_require__(__webpack_module_template_argument_13__)
	};


/***/ },
/* 4364 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('compact', __webpack_require__(__webpack_module_template_argument_1__), __webpack_require__(__webpack_module_template_argument_2__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_3__);
	module.exports = func;


/***/ },
/* 4365 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseConvert = __webpack_require__(__webpack_module_template_argument_0__),
	    util = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
	 * version with conversion `options` applied. If `name` is an object its methods
	 * will be converted.
	 *
	 * @param {string} name The name of the function to wrap.
	 * @param {Function} [func] The function to wrap.
	 * @param {Object} [options] The options object. See `baseConvert` for more details.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function convert(name, func, options) {
	  return baseConvert(util, name, func, options);
	}
	
	module.exports = convert;


/***/ },
/* 4366 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('curry', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4367 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('difference', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4368 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('eq', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4369 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('flow', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4370 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('get', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4371 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('has', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4372 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('includes', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4373 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('isFunction', __webpack_require__(__webpack_module_template_argument_1__), __webpack_require__(__webpack_module_template_argument_2__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_3__);
	module.exports = func;


/***/ },
/* 4374 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('isNil', __webpack_require__(__webpack_module_template_argument_1__), __webpack_require__(__webpack_module_template_argument_2__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_3__);
	module.exports = func;


/***/ },
/* 4375 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('isObject', __webpack_require__(__webpack_module_template_argument_1__), __webpack_require__(__webpack_module_template_argument_2__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_3__);
	module.exports = func;


/***/ },
/* 4376 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('isPlainObject', __webpack_require__(__webpack_module_template_argument_1__), __webpack_require__(__webpack_module_template_argument_2__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_3__);
	module.exports = func;


/***/ },
/* 4377 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('keys', __webpack_require__(__webpack_module_template_argument_1__), __webpack_require__(__webpack_module_template_argument_2__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_3__);
	module.exports = func;


/***/ },
/* 4378 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('map', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4379 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('min', __webpack_require__(__webpack_module_template_argument_1__), __webpack_require__(__webpack_module_template_argument_2__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_3__);
	module.exports = func;


/***/ },
/* 4380 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('pick', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4381 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('sortBy', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4382 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('startsWith', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4383 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('sum', __webpack_require__(__webpack_module_template_argument_1__), __webpack_require__(__webpack_module_template_argument_2__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_3__);
	module.exports = func;


/***/ },
/* 4384 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('take', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4385 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('trim', __webpack_require__(__webpack_module_template_argument_1__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = func;


/***/ },
/* 4386 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var convert = __webpack_require__(__webpack_module_template_argument_0__),
	    func = convert('values', __webpack_require__(__webpack_module_template_argument_1__), __webpack_require__(__webpack_module_template_argument_2__));
	
	func.placeholder = __webpack_require__(__webpack_module_template_argument_3__);
	module.exports = func;


/***/ },
/* 4387 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseGet = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 4388 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseHas = __webpack_require__(__webpack_module_template_argument_0__),
	    hasPath = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ },
/* 4389 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseHasIn = __webpack_require__(__webpack_module_template_argument_0__),
	    hasPath = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 4390 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseInRange = __webpack_require__(__webpack_module_template_argument_0__),
	    toFinite = __webpack_require__(__webpack_module_template_argument_1__),
	    toNumber = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Checks if `n` is between `start` and up to, but not including, `end`. If
	 * `end` is not specified, it's set to `start` with `start` then set to `0`.
	 * If `start` is greater than `end` the params are swapped to support
	 * negative ranges.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.3.0
	 * @category Number
	 * @param {number} number The number to check.
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	 * @see _.range, _.rangeRight
	 * @example
	 *
	 * _.inRange(3, 2, 4);
	 * // => true
	 *
	 * _.inRange(4, 8);
	 * // => true
	 *
	 * _.inRange(4, 2);
	 * // => false
	 *
	 * _.inRange(2, 2);
	 * // => false
	 *
	 * _.inRange(1.2, 2);
	 * // => true
	 *
	 * _.inRange(5.2, 4);
	 * // => false
	 *
	 * _.inRange(-3, -2, -6);
	 * // => true
	 */
	function inRange(number, start, end) {
	  start = toFinite(start);
	  if (end === undefined) {
	    end = start;
	    start = 0;
	  } else {
	    end = toFinite(end);
	  }
	  number = toNumber(number);
	  return baseInRange(number, start, end);
	}
	
	module.exports = inRange;


/***/ },
/* 4391 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var baseIndexOf = __webpack_require__(__webpack_module_template_argument_0__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_1__),
	    isString = __webpack_require__(__webpack_module_template_argument_2__),
	    toInteger = __webpack_require__(__webpack_module_template_argument_3__),
	    values = __webpack_require__(__webpack_module_template_argument_4__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 4392 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var arrayMap = __webpack_require__(__webpack_module_template_argument_0__),
	    baseIntersection = __webpack_require__(__webpack_module_template_argument_1__),
	    baseRest = __webpack_require__(__webpack_module_template_argument_2__),
	    castArrayLikeObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 4393 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseInvoke = __webpack_require__(__webpack_module_template_argument_0__),
	    baseRest = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Invokes the method at `path` of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {...*} [args] The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	 *
	 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	 * // => [2, 3]
	 */
	var invoke = baseRest(baseInvoke);
	
	module.exports = invoke;


/***/ },
/* 4394 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseIsArguments = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 4395 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
	    isLength = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 4396 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isArrayLike = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 4397 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]';
	
	/**
	 * Checks if `value` is classified as a boolean primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	 * @example
	 *
	 * _.isBoolean(false);
	 * // => true
	 *
	 * _.isBoolean(null);
	 * // => false
	 */
	function isBoolean(value) {
	  return value === true || value === false ||
	    (isObjectLike(value) && baseGetTag(value) == boolTag);
	}
	
	module.exports = isBoolean;


/***/ },
/* 4398 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(__webpack_module_template_argument_0__),
	    stubFalse = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53)(module)))

/***/ },
/* 4399 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	var baseKeys = __webpack_require__(__webpack_module_template_argument_0__),
	    getTag = __webpack_require__(__webpack_module_template_argument_1__),
	    isArguments = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_4__),
	    isBuffer = __webpack_require__(__webpack_module_template_argument_5__),
	    isPrototype = __webpack_require__(__webpack_module_template_argument_6__),
	    isTypedArray = __webpack_require__(__webpack_module_template_argument_7__);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 4400 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseIsEqual = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 4401 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__),
	    isPlainObject = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var domExcTag = '[object DOMException]',
	    errorTag = '[object Error]';
	
	/**
	 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	 * `SyntaxError`, `TypeError`, or `URIError` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	 * @example
	 *
	 * _.isError(new Error);
	 * // => true
	 *
	 * _.isError(Error);
	 * // => false
	 */
	function isError(value) {
	  if (!isObjectLike(value)) {
	    return false;
	  }
	  var tag = baseGetTag(value);
	  return tag == errorTag || tag == domExcTag ||
	    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	}
	
	module.exports = isError;


/***/ },
/* 4402 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObject = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 4403 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseIsMap = __webpack_require__(__webpack_module_template_argument_0__),
	    baseUnary = __webpack_require__(__webpack_module_template_argument_1__),
	    nodeUtil = __webpack_require__(__webpack_module_template_argument_2__);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ },
/* 4404 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 4405 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 4406 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseIsSet = __webpack_require__(__webpack_module_template_argument_0__),
	    baseUnary = __webpack_require__(__webpack_module_template_argument_1__),
	    nodeUtil = __webpack_require__(__webpack_module_template_argument_2__);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ },
/* 4407 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isArray = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 4408 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 4409 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseIsTypedArray = __webpack_require__(__webpack_module_template_argument_0__),
	    baseUnary = __webpack_require__(__webpack_module_template_argument_1__),
	    nodeUtil = __webpack_require__(__webpack_module_template_argument_2__);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 4410 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var weakMapTag = '[object WeakMap]';
	
	/**
	 * Checks if `value` is classified as a `WeakMap` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	 * @example
	 *
	 * _.isWeakMap(new WeakMap);
	 * // => true
	 *
	 * _.isWeakMap(new Map);
	 * // => false
	 */
	function isWeakMap(value) {
	  return isObjectLike(value) && getTag(value) == weakMapTag;
	}
	
	module.exports = isWeakMap;


/***/ },
/* 4411 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseClone = __webpack_require__(__webpack_module_template_argument_0__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a function that invokes `func` with the arguments of the created
	 * function. If `func` is a property name, the created function returns the
	 * property value for a given element. If `func` is an array or object, the
	 * created function returns `true` for elements that contain the equivalent
	 * source properties, otherwise it returns `false`.
	 *
	 * @static
	 * @since 4.0.0
	 * @memberOf _
	 * @category Util
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @returns {Function} Returns the callback.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, _.iteratee(['user', 'fred']));
	 * // => [{ 'user': 'fred', 'age': 40 }]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, _.iteratee('user'));
	 * // => ['barney', 'fred']
	 *
	 * // Create custom iteratee shorthands.
	 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	 *     return func.test(string);
	 *   };
	 * });
	 *
	 * _.filter(['abc', 'def'], /ef/);
	 * // => ['def']
	 */
	function iteratee(func) {
	  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	}
	
	module.exports = iteratee;


/***/ },
/* 4412 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseAssignValue = __webpack_require__(__webpack_module_template_argument_0__),
	    createAggregator = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  baseAssignValue(result, key, value);
	});
	
	module.exports = keyBy;


/***/ },
/* 4413 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var arrayLikeKeys = __webpack_require__(__webpack_module_template_argument_0__),
	    baseKeys = __webpack_require__(__webpack_module_template_argument_1__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 4414 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var arrayLikeKeys = __webpack_require__(__webpack_module_template_argument_0__),
	    baseKeysIn = __webpack_require__(__webpack_module_template_argument_1__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 4415 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var arrayMap = __webpack_require__(__webpack_module_template_argument_0__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_1__),
	    baseMap = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 4416 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseAssignValue = __webpack_require__(__webpack_module_template_argument_0__),
	    baseForOwn = __webpack_require__(__webpack_module_template_argument_1__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 4417 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var MapCache = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 4418 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseExtremum = __webpack_require__(__webpack_module_template_argument_0__),
	    baseLt = __webpack_require__(__webpack_module_template_argument_1__),
	    identity = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ },
/* 4419 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var baseRest = __webpack_require__(__webpack_module_template_argument_0__),
	    createWrap = __webpack_require__(__webpack_module_template_argument_1__),
	    getHolder = __webpack_require__(__webpack_module_template_argument_2__),
	    replaceHolders = __webpack_require__(__webpack_module_template_argument_3__);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * This method is like `_.partial` except that partially applied arguments
	 * are appended to the arguments it receives.
	 *
	 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var greetFred = _.partialRight(greet, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 *
	 * // Partially applied with placeholders.
	 * var sayHelloTo = _.partialRight(greet, 'hello', _);
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 */
	var partialRight = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partialRight));
	  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partialRight.placeholder = {};
	
	module.exports = partialRight;


/***/ },
/* 4420 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var basePick = __webpack_require__(__webpack_module_template_argument_0__),
	    flatRest = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ },
/* 4421 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var baseProperty = __webpack_require__(__webpack_module_template_argument_0__),
	    basePropertyDeep = __webpack_require__(__webpack_module_template_argument_1__),
	    isKey = __webpack_require__(__webpack_module_template_argument_2__),
	    toKey = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 4422 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var createWrap = __webpack_require__(__webpack_module_template_argument_0__),
	    flatRest = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a function that invokes `func` with arguments arranged according
	 * to the specified `indexes` where the argument value at the first index is
	 * provided as the first argument, the argument value at the second index is
	 * provided as the second argument, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to rearrange arguments for.
	 * @param {...(number|number[])} indexes The arranged argument indexes.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var rearged = _.rearg(function(a, b, c) {
	 *   return [a, b, c];
	 * }, [2, 0, 1]);
	 *
	 * rearged('b', 'c', 'a')
	 * // => ['a', 'b', 'c']
	 */
	var rearg = flatRest(function(func, indexes) {
	  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	});
	
	module.exports = rearg;


/***/ },
/* 4423 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var arrayReduce = __webpack_require__(__webpack_module_template_argument_0__),
	    baseEach = __webpack_require__(__webpack_module_template_argument_1__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_2__),
	    baseReduce = __webpack_require__(__webpack_module_template_argument_3__),
	    isArray = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ },
/* 4424 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var createRound = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Computes `number` rounded to `precision`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.10.0
	 * @category Math
	 * @param {number} number The number to round.
	 * @param {number} [precision=0] The precision to round to.
	 * @returns {number} Returns the rounded number.
	 * @example
	 *
	 * _.round(4.006);
	 * // => 4
	 *
	 * _.round(4.006, 2);
	 * // => 4.01
	 *
	 * _.round(4060, -2);
	 * // => 4100
	 */
	var round = createRound('round');
	
	module.exports = round;


/***/ },
/* 4425 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseSet = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ },
/* 4426 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var baseKeys = __webpack_require__(__webpack_module_template_argument_0__),
	    getTag = __webpack_require__(__webpack_module_template_argument_1__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_2__),
	    isString = __webpack_require__(__webpack_module_template_argument_3__),
	    stringSize = __webpack_require__(__webpack_module_template_argument_4__);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Gets the size of `collection` by returning its length for array-like
	 * values or the number of own enumerable string keyed properties for objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @returns {number} Returns the collection size.
	 * @example
	 *
	 * _.size([1, 2, 3]);
	 * // => 3
	 *
	 * _.size({ 'a': 1, 'b': 2 });
	 * // => 2
	 *
	 * _.size('pebbles');
	 * // => 7
	 */
	function size(collection) {
	  if (collection == null) {
	    return 0;
	  }
	  if (isArrayLike(collection)) {
	    return isString(collection) ? stringSize(collection) : collection.length;
	  }
	  var tag = getTag(collection);
	  if (tag == mapTag || tag == setTag) {
	    return collection.size;
	  }
	  return baseKeys(collection).length;
	}
	
	module.exports = size;


/***/ },
/* 4427 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var arraySome = __webpack_require__(__webpack_module_template_argument_0__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_1__),
	    baseSome = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__),
	    isIterateeCall = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 4428 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var baseFlatten = __webpack_require__(__webpack_module_template_argument_0__),
	    baseOrderBy = __webpack_require__(__webpack_module_template_argument_1__),
	    baseRest = __webpack_require__(__webpack_module_template_argument_2__),
	    isIterateeCall = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 4429 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var createCompounder = __webpack_require__(__webpack_module_template_argument_0__),
	    upperFirst = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Converts `string` to
	 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.1.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the start cased string.
	 * @example
	 *
	 * _.startCase('--foo-bar--');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('fooBar');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('__FOO_BAR__');
	 * // => 'FOO BAR'
	 */
	var startCase = createCompounder(function(result, word, index) {
	  return result + (index ? ' ' : '') + upperFirst(word);
	});
	
	module.exports = startCase;


/***/ },
/* 4430 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var baseClamp = __webpack_require__(__webpack_module_template_argument_0__),
	    baseToString = __webpack_require__(__webpack_module_template_argument_1__),
	    toInteger = __webpack_require__(__webpack_module_template_argument_2__),
	    toString = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Checks if `string` starts with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=0] The position to search from.
	 * @returns {boolean} Returns `true` if `string` starts with `target`,
	 *  else `false`.
	 * @example
	 *
	 * _.startsWith('abc', 'a');
	 * // => true
	 *
	 * _.startsWith('abc', 'b');
	 * // => false
	 *
	 * _.startsWith('abc', 'b', 1);
	 * // => true
	 */
	function startsWith(string, target, position) {
	  string = toString(string);
	  position = position == null
	    ? 0
	    : baseClamp(toInteger(position), 0, string.length);
	
	  target = baseToString(target);
	  return string.slice(position, position + target.length) == target;
	}
	
	module.exports = startsWith;


/***/ },
/* 4431 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseSum = __webpack_require__(__webpack_module_template_argument_0__),
	    identity = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Computes the sum of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.4.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * _.sum([4, 2, 8, 6]);
	 * // => 20
	 */
	function sum(array) {
	  return (array && array.length)
	    ? baseSum(array, identity)
	    : 0;
	}
	
	module.exports = sum;


/***/ },
/* 4432 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseSlice = __webpack_require__(__webpack_module_template_argument_0__),
	    toInteger = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Creates a slice of `array` with `n` elements taken from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to take.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.take([1, 2, 3]);
	 * // => [1]
	 *
	 * _.take([1, 2, 3], 2);
	 * // => [1, 2]
	 *
	 * _.take([1, 2, 3], 5);
	 * // => [1, 2, 3]
	 *
	 * _.take([1, 2, 3], 0);
	 * // => []
	 */
	function take(array, n, guard) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = take;


/***/ },
/* 4433 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseTimes = __webpack_require__(__webpack_module_template_argument_0__),
	    castFunction = __webpack_require__(__webpack_module_template_argument_1__),
	    toInteger = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Invokes the iteratee `n` times, returning an array of the results of
	 * each invocation. The iteratee is invoked with one argument; (index).
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 * @example
	 *
	 * _.times(3, String);
	 * // => ['0', '1', '2']
	 *
	 *  _.times(4, _.constant(0));
	 * // => [0, 0, 0, 0]
	 */
	function times(n, iteratee) {
	  n = toInteger(n);
	  if (n < 1 || n > MAX_SAFE_INTEGER) {
	    return [];
	  }
	  var index = MAX_ARRAY_LENGTH,
	      length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	  iteratee = castFunction(iteratee);
	  n -= MAX_ARRAY_LENGTH;
	
	  var result = baseTimes(length, iteratee);
	  while (++index < n) {
	    iteratee(index);
	  }
	  return result;
	}
	
	module.exports = times;


/***/ },
/* 4434 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toNumber = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 4435 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toFinite = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 4436 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__),
	    isSymbol = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 4437 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var arrayMap = __webpack_require__(__webpack_module_template_argument_0__),
	    copyArray = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__),
	    isSymbol = __webpack_require__(__webpack_module_template_argument_3__),
	    stringToPath = __webpack_require__(__webpack_module_template_argument_4__),
	    toKey = __webpack_require__(__webpack_module_template_argument_5__),
	    toString = __webpack_require__(__webpack_module_template_argument_6__);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ },
/* 4438 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseToString = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 4439 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	var arrayEach = __webpack_require__(__webpack_module_template_argument_0__),
	    baseCreate = __webpack_require__(__webpack_module_template_argument_1__),
	    baseForOwn = __webpack_require__(__webpack_module_template_argument_2__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_3__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_4__),
	    isArray = __webpack_require__(__webpack_module_template_argument_5__),
	    isBuffer = __webpack_require__(__webpack_module_template_argument_6__),
	    isFunction = __webpack_require__(__webpack_module_template_argument_7__),
	    isObject = __webpack_require__(__webpack_module_template_argument_8__),
	    isTypedArray = __webpack_require__(__webpack_module_template_argument_9__);
	
	/**
	 * An alternative to `_.reduce`; this method transforms `object` to a new
	 * `accumulator` object which is the result of running each of its own
	 * enumerable string keyed properties thru `iteratee`, with each invocation
	 * potentially mutating the `accumulator` object. If `accumulator` is not
	 * provided, a new object with the same `[[Prototype]]` will be used. The
	 * iteratee is invoked with four arguments: (accumulator, value, key, object).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The custom accumulator value.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.transform([2, 3, 4], function(result, n) {
	 *   result.push(n *= n);
	 *   return n % 2 == 0;
	 * }, []);
	 * // => [4, 9]
	 *
	 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] }
	 */
	function transform(object, iteratee, accumulator) {
	  var isArr = isArray(object),
	      isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	  iteratee = baseIteratee(iteratee, 4);
	  if (accumulator == null) {
	    var Ctor = object && object.constructor;
	    if (isArrLike) {
	      accumulator = isArr ? new Ctor : [];
	    }
	    else if (isObject(object)) {
	      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	    }
	    else {
	      accumulator = {};
	    }
	  }
	  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	    return iteratee(accumulator, value, index, object);
	  });
	  return accumulator;
	}
	
	module.exports = transform;


/***/ },
/* 4440 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var baseToString = __webpack_require__(__webpack_module_template_argument_0__),
	    castSlice = __webpack_require__(__webpack_module_template_argument_1__),
	    charsEndIndex = __webpack_require__(__webpack_module_template_argument_2__),
	    charsStartIndex = __webpack_require__(__webpack_module_template_argument_3__),
	    stringToArray = __webpack_require__(__webpack_module_template_argument_4__),
	    toString = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return string.replace(reTrim, '');
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	module.exports = trim;


/***/ },
/* 4441 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var baseFlatten = __webpack_require__(__webpack_module_template_argument_0__),
	    baseRest = __webpack_require__(__webpack_module_template_argument_1__),
	    baseUniq = __webpack_require__(__webpack_module_template_argument_2__),
	    isArrayLikeObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ },
/* 4442 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseUniq = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ },
/* 4443 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var createCaseFirst = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	module.exports = upperFirst;


/***/ },
/* 4444 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseValues = __webpack_require__(__webpack_module_template_argument_0__),
	    keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 4445 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseDifference = __webpack_require__(__webpack_module_template_argument_0__),
	    baseRest = __webpack_require__(__webpack_module_template_argument_1__),
	    isArrayLikeObject = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 4446 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var asciiWords = __webpack_require__(__webpack_module_template_argument_0__),
	    hasUnicodeWord = __webpack_require__(__webpack_module_template_argument_1__),
	    toString = __webpack_require__(__webpack_module_template_argument_2__),
	    unicodeWords = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ },
/* 4447 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var LazyWrapper = __webpack_require__(__webpack_module_template_argument_0__),
	    LodashWrapper = __webpack_require__(__webpack_module_template_argument_1__),
	    baseLodash = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_4__),
	    wrapperClone = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ },
/* 4448 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(__webpack_module_template_argument_0__);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 4449 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__)();
	}


/***/ },
/* 4450 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 4451 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _metaProps = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultProps = {
	  target: '_blank'
	};
	
	var CSVDownload = function (_React$Component) {
	  _inherits(CSVDownload, _React$Component);
	
	  function CSVDownload(props) {
	    _classCallCheck(this, CSVDownload);
	
	    var _this = _possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CSVDownload, [{
	    key: 'buildURI',
	    value: function buildURI() {
	      return _core.buildURI.apply(undefined, arguments);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          headers = _props.headers,
	          separator = _props.separator,
	          uFEFF = _props.uFEFF,
	          target = _props.target,
	          specs = _props.specs,
	          replace = _props.replace;
	
	      this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator), target, specs, replace);
	    }
	  }, {
	    key: 'getWindow',
	    value: function getWindow() {
	      return this.state.page;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return CSVDownload;
	}(_react2.default.Component);
	
	CSVDownload.defaultProps = Object.assign(_metaProps.defaultProps, defaultProps);
	CSVDownload.propTypes = _metaProps.propTypes;
	exports.default = CSVDownload;

/***/ },
/* 4452 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _metaProps = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CSVLink = function (_React$Component) {
	  _inherits(CSVLink, _React$Component);
	
	  function CSVLink(props) {
	    _classCallCheck(this, CSVLink);
	
	    var _this = _possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));
	
	    _this.buildURI = _this.buildURI.bind(_this);
	    return _this;
	  }
	
	  _createClass(CSVLink, [{
	    key: 'buildURI',
	    value: function buildURI() {
	      return _core.buildURI.apply(undefined, arguments);
	    }
	  }, {
	    key: 'handleLegacy',
	    value: function handleLegacy(evt, data, headers, separator, filename) {
	      if (window.navigator.msSaveOrOpenBlob) {
	        evt.preventDefault();
	
	        var blob = new Blob([(0, _core.toCSV)(data, headers, separator)]);
	        window.navigator.msSaveBlob(blob, filename);
	
	        return false;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          headers = _props.headers,
	          separator = _props.separator,
	          filename = _props.filename,
	          uFEFF = _props.uFEFF,
	          children = _props.children,
	          rest = _objectWithoutProperties(_props, ['data', 'headers', 'separator', 'filename', 'uFEFF', 'children']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({ download: filename }, rest, {
	          ref: function ref(link) {
	            return _this2.link = link;
	          },
	          href: this.buildURI(data, uFEFF, headers, separator),
	          onClick: function onClick(evt) {
	            return _this2.handleLegacy(evt, data, headers, separator, filename);
	          } }),
	        children
	      );
	    }
	  }]);
	
	  return CSVLink;
	}(_react2.default.Component);
	
	CSVLink.defaultProps = _metaProps.defaultProps;
	CSVLink.propTypes = _metaProps.propTypes;
	exports.default = CSVLink;

/***/ },
/* 4453 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CSVLink = exports.CSVDownload = undefined;
	
	var _Download = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Download2 = _interopRequireDefault(_Download);
	
	var _Link = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CSVDownload = exports.CSVDownload = _Download2.default;
	var CSVLink = exports.CSVLink = _Link2.default;

/***/ },
/* 4454 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PropsNotForwarded = exports.defaultProps = exports.propTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = exports.propTypes = {
	  data: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array]).isRequired,
	  headers: _propTypes.array,
	  target: _propTypes.string,
	  separator: _propTypes.string,
	  filename: _propTypes.string,
	  uFEFF: _propTypes.bool
	};
	
	var defaultProps = exports.defaultProps = {
	  separator: ',',
	  filename: 'generatedBy_react-csv.csv',
	  uFEFF: true
	};
	
	var PropsNotForwarded = exports.PropsNotForwarded = ['data', 'headers'];

/***/ },
/* 4455 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _has2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _invoke2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _Button = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Modal = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A Confirm modal gives the user a choice to confirm or cancel an action/
	 * @see Modal
	 */
	var Confirm = function (_Component) {
	  (0, _inherits3.default)(Confirm, _Component);
	
	  function Confirm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Confirm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Confirm.__proto__ || Object.getPrototypeOf(Confirm)).call.apply(_ref, [this].concat(args))), _this), _this.handleCancel = function (e) {
	      (0, _invoke3.default)(_this.props, 'onCancel', e, _this.props);
	    }, _this.handleCancelOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e, buttonProps) {
	          (0, _invoke3.default)(predefinedProps, 'onClick', e, buttonProps);
	          _this.handleCancel(e);
	        }
	      };
	    }, _this.handleConfirmOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e, buttonProps) {
	          (0, _invoke3.default)(predefinedProps, 'onClick', e, buttonProps);
	          (0, _invoke3.default)(_this.props, 'onConfirm', e, _this.props);
	        }
	      };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Confirm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancelButton = _props.cancelButton,
	          confirmButton = _props.confirmButton,
	          content = _props.content,
	          header = _props.header,
	          open = _props.open;
	
	      var rest = (0, _lib.getUnhandledProps)(Confirm, this.props);
	
	      // `open` is auto controlled by the Modal
	      // It cannot be present (even undefined) with `defaultOpen`
	      // only apply it if the user provided an open prop
	      var openProp = {};
	      if ((0, _has3.default)(this.props, 'open')) openProp.open = open;
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        (0, _extends3.default)({}, rest, openProp, { size: 'small', onClose: this.handleCancel }),
	        _Modal2.default.Header.create(header),
	        _Modal2.default.Content.create(content),
	        _react2.default.createElement(
	          _Modal2.default.Actions,
	          null,
	          _Button2.default.create(cancelButton, { overrideProps: this.handleCancelOverrides }),
	          _Button2.default.create(confirmButton, {
	            defaultProps: { primary: true },
	            overrideProps: this.handleConfirmOverrides
	          })
	        )
	      );
	    }
	  }]);
	  return Confirm;
	}(_react.Component);
	
	Confirm.defaultProps = {
	  cancelButton: 'Cancel',
	  confirmButton: 'OK',
	  content: 'Are you sure?'
	};
	Confirm._meta = {
	  name: 'Confirm',
	  type: _lib.META.TYPES.ADDON
	};
	Confirm.handledProps = ['cancelButton', 'confirmButton', 'content', 'header', 'onCancel', 'onConfirm', 'open'];
	Confirm.propTypes =  false ? {
	  /** The cancel button text. */
	  cancelButton: _lib.customPropTypes.itemShorthand,
	
	  /** The OK button text. */
	  confirmButton: _lib.customPropTypes.itemShorthand,
	
	  /** The ModalContent text. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** The ModalHeader text. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /**
	   * Called when the Modal is closed without clicking confirm.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onCancel: _propTypes2.default.func,
	
	  /**
	   * Called when the OK button is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onConfirm: _propTypes2.default.func,
	
	  /** Whether or not the modal is visible. */
	  open: _propTypes2.default.bool
	} : {};
	exports.default = Confirm;

/***/ },
/* 4456 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Confirm = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Confirm2.default;

/***/ },
/* 4457 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Portal = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Portal2.default;

/***/ },
/* 4458 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Checkbox = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A Radio is sugar for <Checkbox radio />.
	 * Useful for exclusive groups of sliders or toggles.
	 * @see Checkbox
	 * @see Form
	 */
	function Radio(props) {
	  var slider = props.slider,
	      toggle = props.toggle,
	      type = props.type;
	
	  var rest = (0, _lib.getUnhandledProps)(Radio, props);
	  // const ElementType = getElementType(Radio, props)
	  // radio, slider, toggle are exclusive
	  // use an undefined radio if slider or toggle are present
	  var radio = !(slider || toggle) || undefined;
	
	  return _react2.default.createElement(_Checkbox2.default, (0, _extends3.default)({}, rest, { type: type, radio: radio, slider: slider, toggle: toggle }));
	}
	
	Radio.handledProps = ['slider', 'toggle', 'type'];
	Radio._meta = {
	  name: 'Radio',
	  type: _lib.META.TYPES.ADDON
	};
	
	Radio.propTypes =  false ? {
	  /** Format to emphasize the current selection state. */
	  slider: _Checkbox2.default.propTypes.slider,
	
	  /** Format to show an on or off choice. */
	  toggle: _Checkbox2.default.propTypes.toggle,
	
	  /** HTML input type, either checkbox or radio. */
	  type: _Checkbox2.default.propTypes.type
	} : {};
	
	Radio.defaultProps = {
	  type: 'radio'
	};
	
	exports.default = Radio;

/***/ },
/* 4459 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Radio = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Radio2.default;

/***/ },
/* 4460 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Responsive = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Responsive2 = _interopRequireDefault(_Responsive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Responsive2.default;

/***/ },
/* 4461 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Dropdown = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A Select is sugar for <Dropdown selection />.
	 * @see Dropdown
	 * @see Form
	 */
	function Select(props) {
	  return _react2.default.createElement(_Dropdown2.default, (0, _extends3.default)({}, props, { selection: true }));
	}
	
	Select.handledProps = [];
	Select._meta = {
	  name: 'Select',
	  type: _lib.META.TYPES.ADDON
	};
	
	Select.Divider = _Dropdown2.default.Divider;
	Select.Header = _Dropdown2.default.Header;
	Select.Item = _Dropdown2.default.Item;
	Select.Menu = _Dropdown2.default.Menu;
	
	exports.default = Select;

/***/ },
/* 4462 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Select = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Select2.default;

/***/ },
/* 4463 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextArea = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _TextArea2 = _interopRequireDefault(_TextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextArea2.default;

/***/ },
/* 4464 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Visibility = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Visibility2 = _interopRequireDefault(_Visibility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Visibility2.default;

/***/ },
/* 4465 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _each2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _BreadcrumbDivider = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _BreadcrumbDivider2 = _interopRequireDefault(_BreadcrumbDivider);
	
	var _BreadcrumbSection = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _BreadcrumbSection2 = _interopRequireDefault(_BreadcrumbSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A breadcrumb is used to show hierarchy between content.
	 */
	function Breadcrumb(props) {
	  var children = props.children,
	      className = props.className,
	      divider = props.divider,
	      icon = props.icon,
	      sections = props.sections,
	      size = props.size;
	
	
	  var classes = (0, _classnames2.default)('ui', size, 'breadcrumb', className);
	  var rest = (0, _lib.getUnhandledProps)(Breadcrumb, props);
	  var ElementType = (0, _lib.getElementType)(Breadcrumb, props);
	
	  if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	
	  var childElements = [];
	
	  (0, _each3.default)(sections, function (section, index) {
	    // section
	    var breadcrumbElement = _BreadcrumbSection2.default.create(section);
	    childElements.push(breadcrumbElement);
	
	    // divider
	    if (index !== sections.length - 1) {
	      var key = breadcrumbElement.key + '_divider' || JSON.stringify(section);
	      childElements.push(_BreadcrumbDivider2.default.create({ content: divider, icon: icon, key: key }));
	    }
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    childElements
	  );
	}
	
	Breadcrumb.handledProps = ['as', 'children', 'className', 'divider', 'icon', 'sections', 'size'];
	Breadcrumb._meta = {
	  name: 'Breadcrumb',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	Breadcrumb.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content of the Breadcrumb.Divider. */
	  divider: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['icon']), _lib.customPropTypes.contentShorthand]),
	
	  /** For use with the sections prop. Render as an `Icon` component with `divider` class instead of a `div` in
	   *  Breadcrumb.Divider. */
	  icon: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['divider']), _lib.customPropTypes.itemShorthand]),
	
	  /** Shorthand array of props for Breadcrumb.Section. */
	  sections: _lib.customPropTypes.collectionShorthand,
	
	  /** Size of Breadcrumb. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : {};
	
	Breadcrumb.Divider = _BreadcrumbDivider2.default;
	Breadcrumb.Section = _BreadcrumbSection2.default;
	
	exports.default = Breadcrumb;

/***/ },
/* 4466 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isNil2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _Icon = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A divider sub-component for Breadcrumb component.
	 */
	function BreadcrumbDivider(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      icon = props.icon;
	
	
	  var classes = (0, _classnames2.default)('divider', className);
	  var rest = (0, _lib.getUnhandledProps)(BreadcrumbDivider, props);
	  var ElementType = (0, _lib.getElementType)(BreadcrumbDivider, props);
	
	  if (!(0, _isNil3.default)(icon)) return _Icon2.default.create(icon, { defaultProps: (0, _extends3.default)({}, rest, { className: classes }) });
	  if (!(0, _isNil3.default)(content)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content
	  );
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? '/' : children
	  );
	}
	
	BreadcrumbDivider.handledProps = ['as', 'children', 'className', 'content', 'icon'];
	BreadcrumbDivider._meta = {
	  name: 'BreadcrumbDivider',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Breadcrumb'
	};
	
	BreadcrumbDivider.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Render as an `Icon` component with `divider` class instead of a `div`. */
	  icon: _lib.customPropTypes.itemShorthand
	} : {};
	
	BreadcrumbDivider.create = (0, _lib.createShorthandFactory)(BreadcrumbDivider, function (icon) {
	  return { icon: icon };
	});
	
	exports.default = BreadcrumbDivider;

/***/ },
/* 4467 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Breadcrumb = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Breadcrumb2.default;

/***/ },
/* 4468 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Button = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormField = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={Button} />.
	 * @see Button
	 * @see Form
	 */
	function FormButton(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormButton, props);
	  var ElementType = (0, _lib.getElementType)(FormButton, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormButton.handledProps = ['as', 'control'];
	FormButton._meta = {
	  name: 'FormButton',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	FormButton.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop. */
	  control: _FormField2.default.propTypes.control
	} : {};
	
	FormButton.defaultProps = {
	  as: _FormField2.default,
	  control: _Button2.default
	};
	
	exports.default = FormButton;

/***/ },
/* 4469 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Checkbox = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _FormField = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={Checkbox} />.
	 * @see Checkbox
	 * @see Form
	 */
	function FormCheckbox(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormCheckbox, props);
	  var ElementType = (0, _lib.getElementType)(FormCheckbox, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormCheckbox.handledProps = ['as', 'control'];
	FormCheckbox._meta = {
	  name: 'FormCheckbox',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	FormCheckbox.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop. */
	  control: _FormField2.default.propTypes.control
	} : {};
	
	FormCheckbox.defaultProps = {
	  as: _FormField2.default,
	  control: _Checkbox2.default
	};
	
	exports.default = FormCheckbox;

/***/ },
/* 4470 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Dropdown = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _FormField = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={Dropdown} />.
	 * @see Dropdown
	 * @see Form
	 */
	function FormDropdown(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormDropdown, props);
	  var ElementType = (0, _lib.getElementType)(FormDropdown, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormDropdown.handledProps = ['as', 'control'];
	FormDropdown._meta = {
	  name: 'FormDropdown',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	FormDropdown.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop. */
	  control: _FormField2.default.propTypes.control
	} : {};
	
	FormDropdown.defaultProps = {
	  as: _FormField2.default,
	  control: _Dropdown2.default
	};
	
	exports.default = FormDropdown;

/***/ },
/* 4471 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A set of fields can appear grouped together.
	 * @see Form
	 */
	function FormGroup(props) {
	  var children = props.children,
	      className = props.className,
	      grouped = props.grouped,
	      inline = props.inline,
	      unstackable = props.unstackable,
	      widths = props.widths;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(grouped, 'grouped'), (0, _lib.useKeyOnly)(inline, 'inline'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useWidthProp)(widths, null, true), 'fields', className);
	  var rest = (0, _lib.getUnhandledProps)(FormGroup, props);
	  var ElementType = (0, _lib.getElementType)(FormGroup, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	FormGroup.handledProps = ['as', 'children', 'className', 'grouped', 'inline', 'unstackable', 'widths'];
	FormGroup._meta = {
	  name: 'FormGroup',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	FormGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Fields can show related choices. */
	  grouped: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['inline']), _propTypes2.default.bool]),
	
	  /** Multiple fields may be inline in a row. */
	  inline: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['grouped']), _propTypes2.default.bool]),
	
	  /** A form group can prevent itself from stacking on mobile. */
	  unstackable: _propTypes2.default.bool,
	
	  /** Fields Groups can specify their width in grid columns or automatically divide fields to be equal width. */
	  widths: _propTypes2.default.oneOf([].concat((0, _toConsumableArray3.default)(_lib.SUI.WIDTHS), ['equal']))
	} : {};
	
	exports.default = FormGroup;

/***/ },
/* 4472 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Input = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _FormField = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={Input} />.
	 * @see Form
	 * @see Input
	 */
	function FormInput(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormInput, props);
	  var ElementType = (0, _lib.getElementType)(FormInput, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormInput.handledProps = ['as', 'control'];
	FormInput._meta = {
	  name: 'FormInput',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	FormInput.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop. */
	  control: _FormField2.default.propTypes.control
	} : {};
	
	FormInput.defaultProps = {
	  as: _FormField2.default,
	  control: _Input2.default
	};
	
	exports.default = FormInput;

/***/ },
/* 4473 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Radio = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _FormField = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={Radio} />.
	 * @see Form
	 * @see Radio
	 */
	function FormRadio(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormRadio, props);
	  var ElementType = (0, _lib.getElementType)(FormRadio, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormRadio.handledProps = ['as', 'control'];
	FormRadio._meta = {
	  name: 'FormRadio',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	FormRadio.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop. */
	  control: _FormField2.default.propTypes.control
	} : {};
	
	FormRadio.defaultProps = {
	  as: _FormField2.default,
	  control: _Radio2.default
	};
	
	exports.default = FormRadio;

/***/ },
/* 4474 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Select = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _FormField = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={Select} />.
	 * @see Form
	 * @see Select
	 */
	function FormSelect(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormSelect, props);
	  var ElementType = (0, _lib.getElementType)(FormSelect, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormSelect.handledProps = ['as', 'control'];
	FormSelect._meta = {
	  name: 'FormSelect',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	FormSelect.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop. */
	  control: _FormField2.default.propTypes.control
	} : {};
	
	FormSelect.defaultProps = {
	  as: _FormField2.default,
	  control: _Select2.default
	};
	
	exports.default = FormSelect;

/***/ },
/* 4475 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _TextArea = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _TextArea2 = _interopRequireDefault(_TextArea);
	
	var _FormField = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sugar for <Form.Field control={TextArea} />.
	 * @see Form
	 * @see TextArea
	 */
	function FormTextArea(props) {
	  var control = props.control;
	
	  var rest = (0, _lib.getUnhandledProps)(FormTextArea, props);
	  var ElementType = (0, _lib.getElementType)(FormTextArea, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { control: control }));
	}
	
	FormTextArea.handledProps = ['as', 'control'];
	FormTextArea._meta = {
	  name: 'FormTextArea',
	  parent: 'Form',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	FormTextArea.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A FormField control prop. */
	  control: _FormField2.default.propTypes.control
	} : {};
	
	FormTextArea.defaultProps = {
	  as: _FormField2.default,
	  control: _TextArea2.default
	};
	
	exports.default = FormTextArea;

/***/ },
/* 4476 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Form = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Form2.default;

/***/ },
/* 4477 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Grid = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Grid2.default;

/***/ },
/* 4478 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _map2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _invoke2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _MenuHeader = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _MenuHeader2 = _interopRequireDefault(_MenuHeader);
	
	var _MenuItem = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _MenuMenu = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _MenuMenu2 = _interopRequireDefault(_MenuMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A menu displays grouped navigation actions.
	 * @see Dropdown
	 */
	var Menu = function (_Component) {
	  (0, _inherits3.default)(Menu, _Component);
	
	  function Menu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Menu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e, itemProps) {
	          var index = itemProps.index;
	
	
	          _this.trySetState({ activeIndex: index });
	
	          (0, _invoke3.default)(predefinedProps, 'onClick', e, itemProps);
	          (0, _invoke3.default)(_this.props, 'onItemClick', e, itemProps);
	        }
	      };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'renderItems',
	    value: function renderItems() {
	      var _this2 = this;
	
	      var items = this.props.items;
	      var activeIndex = this.state.activeIndex;
	
	
	      return (0, _map3.default)(items, function (item, index) {
	        return _MenuItem2.default.create(item, {
	          defaultProps: {
	            active: parseInt(activeIndex, 10) === index,
	            index: index
	          },
	          overrideProps: _this2.handleItemOverrides
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          attached = _props.attached,
	          borderless = _props.borderless,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          compact = _props.compact,
	          fixed = _props.fixed,
	          floated = _props.floated,
	          fluid = _props.fluid,
	          icon = _props.icon,
	          inverted = _props.inverted,
	          pagination = _props.pagination,
	          pointing = _props.pointing,
	          secondary = _props.secondary,
	          size = _props.size,
	          stackable = _props.stackable,
	          tabular = _props.tabular,
	          text = _props.text,
	          vertical = _props.vertical,
	          widths = _props.widths;
	
	      var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(borderless, 'borderless'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(pagination, 'pagination'), (0, _lib.useKeyOnly)(pointing, 'pointing'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useKeyOnly)(text, 'text'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useKeyOrValueAndKey)(floated, 'floated'), (0, _lib.useKeyOrValueAndKey)(icon, 'icon'), (0, _lib.useKeyOrValueAndKey)(tabular, 'tabular'), (0, _lib.useValueAndKey)(fixed, 'fixed'), (0, _lib.useWidthProp)(widths, 'item'), className, 'menu');
	      var rest = (0, _lib.getUnhandledProps)(Menu, this.props);
	      var ElementType = (0, _lib.getElementType)(Menu, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        _lib.childrenUtils.isNil(children) ? this.renderItems() : children
	      );
	    }
	  }]);
	  return Menu;
	}(_lib.AutoControlledComponent);
	
	Menu._meta = {
	  name: 'Menu',
	  type: _lib.META.TYPES.COLLECTION
	};
	Menu.autoControlledProps = ['activeIndex'];
	Menu.Header = _MenuHeader2.default;
	Menu.Item = _MenuItem2.default;
	Menu.Menu = _MenuMenu2.default;
	Menu.handledProps = ['activeIndex', 'as', 'attached', 'borderless', 'children', 'className', 'color', 'compact', 'defaultActiveIndex', 'fixed', 'floated', 'fluid', 'icon', 'inverted', 'items', 'onItemClick', 'pagination', 'pointing', 'secondary', 'size', 'stackable', 'tabular', 'text', 'vertical', 'widths'];
	Menu.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Index of the currently active item. */
	  activeIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** A menu may be attached to other content segments. */
	  attached: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['top', 'bottom'])]),
	
	  /** A menu item or menu can have no borders. */
	  borderless: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Additional colors can be specified. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** A menu can take up only the space necessary to fit its content. */
	  compact: _propTypes2.default.bool,
	
	  /** Initial activeIndex value. */
	  defaultActiveIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** A menu can be fixed to a side of its context. */
	  fixed: _propTypes2.default.oneOf(['left', 'right', 'bottom', 'top']),
	
	  /** A menu can be floated. */
	  floated: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['right'])]),
	
	  /** A vertical menu may take the size of its container. */
	  fluid: _propTypes2.default.bool,
	
	  /** A menu may have just icons (bool) or labeled icons. */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['labeled'])]),
	
	  /** A menu may have its colors inverted to show greater contrast. */
	  inverted: _propTypes2.default.bool,
	
	  /** Shorthand array of props for Menu. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /**
	   * onClick handler for MenuItem. Mutually exclusive with children.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All item props.
	   */
	  onItemClick: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes2.default.func]),
	
	  /** A pagination menu is specially formatted to present links to pages of content. */
	  pagination: _propTypes2.default.bool,
	
	  /** A menu can point to show its relationship to nearby content. */
	  pointing: _propTypes2.default.bool,
	
	  /** A menu can adjust its appearance to de-emphasize its contents. */
	  secondary: _propTypes2.default.bool,
	
	  /** A menu can vary in size. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium', 'big')),
	
	  /** A menu can stack at mobile resolutions. */
	  stackable: _propTypes2.default.bool,
	
	  /** A menu can be formatted to show tabs of information. */
	  tabular: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['right'])]),
	
	  /** A menu can be formatted for text content. */
	  text: _propTypes2.default.bool,
	
	  /** A vertical menu displays elements vertically. */
	  vertical: _propTypes2.default.bool,
	
	  /** A menu can have its items divided evenly. */
	  widths: _propTypes2.default.oneOf(_lib.SUI.WIDTHS)
	} : {};
	
	
	Menu.create = (0, _lib.createShorthandFactory)(Menu, function (items) {
	  return { items: items };
	});
	
	exports.default = Menu;

/***/ },
/* 4479 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A menu item may include a header or may itself be a header.
	 */
	function MenuHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(MenuHeader, props);
	  var ElementType = (0, _lib.getElementType)(MenuHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	MenuHeader.handledProps = ['as', 'children', 'className', 'content'];
	MenuHeader._meta = {
	  name: 'MenuHeader',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Menu'
	};
	
	MenuHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = MenuHeader;

/***/ },
/* 4480 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Menu = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Menu2.default;

/***/ },
/* 4481 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A message can contain a header.
	 */
	function MessageHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageHeader, props);
	  var ElementType = (0, _lib.getElementType)(MessageHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	MessageHeader.handledProps = ['as', 'children', 'className', 'content'];
	MessageHeader._meta = {
	  name: 'MessageHeader',
	  parent: 'Message',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	MessageHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	MessageHeader.create = (0, _lib.createShorthandFactory)(MessageHeader, function (val) {
	  return { content: val };
	});
	
	exports.default = MessageHeader;

/***/ },
/* 4482 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A message list can contain an item.
	 */
	function MessageItem(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageItem, props);
	  var ElementType = (0, _lib.getElementType)(MessageItem, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	MessageItem.handledProps = ['as', 'children', 'className', 'content'];
	MessageItem._meta = {
	  name: 'MessageItem',
	  parent: 'Message',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	MessageItem.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	MessageItem.defaultProps = {
	  as: 'li'
	};
	
	MessageItem.create = (0, _lib.createShorthandFactory)(MessageItem, function (content) {
	  return { content: content };
	});
	
	exports.default = MessageItem;

/***/ },
/* 4483 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _MessageItem = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _MessageItem2 = _interopRequireDefault(_MessageItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A message can contain a list of items.
	 */
	function MessageList(props) {
	  var children = props.children,
	      className = props.className,
	      items = props.items;
	
	  var classes = (0, _classnames2.default)('list', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageList, props);
	  var ElementType = (0, _lib.getElementType)(MessageList, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? (0, _map3.default)(items, _MessageItem2.default.create) : children
	  );
	}
	
	MessageList.handledProps = ['as', 'children', 'className', 'items'];
	MessageList._meta = {
	  name: 'MessageList',
	  parent: 'Message',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	MessageList.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand Message.Items. */
	  items: _lib.customPropTypes.collectionShorthand
	} : {};
	
	MessageList.defaultProps = {
	  as: 'ul'
	};
	
	MessageList.create = (0, _lib.createShorthandFactory)(MessageList, function (val) {
	  return { items: val };
	});
	
	exports.default = MessageList;

/***/ },
/* 4484 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Message = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Message2.default;

/***/ },
/* 4485 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _TableBody = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _TableBody2 = _interopRequireDefault(_TableBody);
	
	var _TableCell = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	var _TableFooter = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _TableFooter2 = _interopRequireDefault(_TableFooter);
	
	var _TableHeader = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _TableHeader2 = _interopRequireDefault(_TableHeader);
	
	var _TableHeaderCell = __webpack_require__(__webpack_module_template_argument_8__);
	
	var _TableHeaderCell2 = _interopRequireDefault(_TableHeaderCell);
	
	var _TableRow = __webpack_require__(__webpack_module_template_argument_9__);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table displays a collections of data grouped into rows.
	 */
	function Table(props) {
	  var attached = props.attached,
	      basic = props.basic,
	      celled = props.celled,
	      children = props.children,
	      className = props.className,
	      collapsing = props.collapsing,
	      color = props.color,
	      columns = props.columns,
	      compact = props.compact,
	      definition = props.definition,
	      fixed = props.fixed,
	      footerRow = props.footerRow,
	      headerRow = props.headerRow,
	      inverted = props.inverted,
	      padded = props.padded,
	      renderBodyRow = props.renderBodyRow,
	      selectable = props.selectable,
	      singleLine = props.singleLine,
	      size = props.size,
	      sortable = props.sortable,
	      stackable = props.stackable,
	      striped = props.striped,
	      structured = props.structured,
	      tableData = props.tableData,
	      textAlign = props.textAlign,
	      unstackable = props.unstackable,
	      verticalAlign = props.verticalAlign;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(celled, 'celled'), (0, _lib.useKeyOnly)(collapsing, 'collapsing'), (0, _lib.useKeyOnly)(definition, 'definition'), (0, _lib.useKeyOnly)(fixed, 'fixed'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(selectable, 'selectable'), (0, _lib.useKeyOnly)(singleLine, 'single line'), (0, _lib.useKeyOnly)(sortable, 'sortable'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useKeyOnly)(striped, 'striped'), (0, _lib.useKeyOnly)(structured, 'structured'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useKeyOrValueAndKey)(basic, 'basic'), (0, _lib.useKeyOrValueAndKey)(compact, 'compact'), (0, _lib.useKeyOrValueAndKey)(padded, 'padded'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, 'column'), 'table', className);
	  var rest = (0, _lib.getUnhandledProps)(Table, props);
	  var ElementType = (0, _lib.getElementType)(Table, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    headerRow && _react2.default.createElement(
	      _TableHeader2.default,
	      null,
	      _TableRow2.default.create(headerRow, { defaultProps: { cellAs: 'th' } })
	    ),
	    _react2.default.createElement(
	      _TableBody2.default,
	      null,
	      renderBodyRow && (0, _map3.default)(tableData, function (data, index) {
	        return _TableRow2.default.create(renderBodyRow(data, index));
	      })
	    ),
	    footerRow && _react2.default.createElement(
	      _TableFooter2.default,
	      null,
	      _TableRow2.default.create(footerRow)
	    )
	  );
	}
	
	Table.handledProps = ['as', 'attached', 'basic', 'celled', 'children', 'className', 'collapsing', 'color', 'columns', 'compact', 'definition', 'fixed', 'footerRow', 'headerRow', 'inverted', 'padded', 'renderBodyRow', 'selectable', 'singleLine', 'size', 'sortable', 'stackable', 'striped', 'structured', 'tableData', 'textAlign', 'unstackable', 'verticalAlign'];
	Table._meta = {
	  name: 'Table',
	  type: _lib.META.TYPES.COLLECTION
	};
	
	Table.defaultProps = {
	  as: 'table'
	};
	
	Table.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Attach table to other content */
	  attached: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['top', 'bottom'])]),
	
	  /** A table can reduce its complexity to increase readability. */
	  basic: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['very']), _propTypes2.default.bool]),
	
	  /** A table may be divided each row into separate cells. */
	  celled: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A table can be collapsing, taking up only as much space as its rows. */
	  collapsing: _propTypes2.default.bool,
	
	  /** A table can be given a color to distinguish it from other tables. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** A table can specify its column count to divide its content evenly. */
	  columns: _propTypes2.default.oneOf(_lib.SUI.WIDTHS),
	
	  /** A table may sometimes need to be more compact to make more rows visible at a time. */
	  compact: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])]),
	
	  /** A table may be formatted to emphasize a first column that defines a rows content. */
	  definition: _propTypes2.default.bool,
	
	  /**
	   * A table can use fixed a special faster form of table rendering that does not resize table cells based on content
	   */
	  fixed: _propTypes2.default.bool,
	
	  /** Shorthand for a TableRow to be placed within Table.Footer. */
	  footerRow: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for a TableRow to be placed within Table.Header. */
	  headerRow: _lib.customPropTypes.itemShorthand,
	
	  /** A table's colors can be inverted. */
	  inverted: _propTypes2.default.bool,
	
	  /** A table may sometimes need to be more padded for legibility. */
	  padded: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['very'])]),
	
	  /**
	   * Mapped over `tableData` and should return shorthand for each Table.Row to be placed within Table.Body.
	   *
	   * @param {*} data - An element in the `tableData` array.
	   * @param {number} index - The index of the current element in `tableData`.
	   * @returns {*} Shorthand for a Table.Row.
	   */
	  renderBodyRow: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _lib.customPropTypes.demand(['tableData']), _propTypes2.default.func]),
	
	  /** A table can have its rows appear selectable. */
	  selectable: _propTypes2.default.bool,
	
	  /** A table can specify that its cell contents should remain on a single line and not wrap. */
	  singleLine: _propTypes2.default.bool,
	
	  /** A table can also be small or large. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive')),
	
	  /** A table may allow a user to sort contents by clicking on a table header. */
	  sortable: _propTypes2.default.bool,
	
	  /** A table can specify how it stacks table content responsively. */
	  stackable: _propTypes2.default.bool,
	
	  /** A table can stripe alternate rows of content with a darker color to increase contrast. */
	  striped: _propTypes2.default.bool,
	
	  /** A table can be formatted to display complex structured data. */
	  structured: _propTypes2.default.bool,
	
	  /** Data to be passed to the renderBodyRow function. */
	  tableData: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _lib.customPropTypes.demand(['renderBodyRow']), _propTypes2.default.array]),
	
	  /** A table can adjust its text alignment. */
	  textAlign: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified')),
	
	  /** A table can specify how it stacks table content responsively. */
	  unstackable: _propTypes2.default.bool,
	
	  /** A table can adjust its text alignment. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	
	Table.Body = _TableBody2.default;
	Table.Cell = _TableCell2.default;
	Table.Footer = _TableFooter2.default;
	Table.Header = _TableHeader2.default;
	Table.HeaderCell = _TableHeaderCell2.default;
	Table.Row = _TableRow2.default;
	
	exports.default = Table;

/***/ },
/* 4486 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TableBody(props) {
	  var children = props.children,
	      className = props.className;
	
	  var classes = (0, _classnames2.default)(className);
	  var rest = (0, _lib.getUnhandledProps)(TableBody, props);
	  var ElementType = (0, _lib.getElementType)(TableBody, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	}
	
	TableBody.handledProps = ['as', 'children', 'className'];
	TableBody._meta = {
	  name: 'TableBody',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	TableBody.defaultProps = {
	  as: 'tbody'
	};
	
	TableBody.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = TableBody;

/***/ },
/* 4487 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _Icon = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table row can have cells.
	 */
	function TableCell(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      collapsing = props.collapsing,
	      content = props.content,
	      disabled = props.disabled,
	      error = props.error,
	      icon = props.icon,
	      negative = props.negative,
	      positive = props.positive,
	      selectable = props.selectable,
	      singleLine = props.singleLine,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign,
	      warning = props.warning,
	      width = props.width;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(collapsing, 'collapsing'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(selectable, 'selectable'), (0, _lib.useKeyOnly)(singleLine, 'single line'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(width, 'wide'), className);
	  var rest = (0, _lib.getUnhandledProps)(TableCell, props);
	  var ElementType = (0, _lib.getElementType)(TableCell, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _Icon2.default.create(icon),
	    content
	  );
	}
	
	TableCell.handledProps = ['active', 'as', 'children', 'className', 'collapsing', 'content', 'disabled', 'error', 'icon', 'negative', 'positive', 'selectable', 'singleLine', 'textAlign', 'verticalAlign', 'warning', 'width'];
	TableCell._meta = {
	  name: 'TableCell',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	TableCell.defaultProps = {
	  as: 'td'
	};
	
	TableCell.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A cell can be active or selected by a user. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A cell can be collapsing so that it only uses as much space as required. */
	  collapsing: _propTypes2.default.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A cell can be disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** A cell may call attention to an error or a negative value. */
	  error: _propTypes2.default.bool,
	
	  /** Add an Icon by name, props object, or pass an <Icon /> */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** A cell may let a user know whether a value is bad. */
	  negative: _propTypes2.default.bool,
	
	  /** A cell may let a user know whether a value is good. */
	  positive: _propTypes2.default.bool,
	
	  /** A cell can be selectable. */
	  selectable: _propTypes2.default.bool,
	
	  /** A cell can specify that its contents should remain on a single line and not wrap. */
	  singleLine: _propTypes2.default.bool,
	
	  /** A table cell can adjust its text alignment. */
	  textAlign: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified')),
	
	  /** A table cell can adjust its text alignment. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** A cell may warn a user. */
	  warning: _propTypes2.default.bool,
	
	  /** A table can specify the width of individual columns independently. */
	  width: _propTypes2.default.oneOf(_lib.SUI.WIDTHS)
	} : {};
	
	TableCell.create = (0, _lib.createShorthandFactory)(TableCell, function (content) {
	  return { content: content };
	});
	
	exports.default = TableCell;

/***/ },
/* 4488 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _TableHeader = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _TableHeader2 = _interopRequireDefault(_TableHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table can have a footer.
	 */
	function TableFooter(props) {
	  var as = props.as;
	
	  var rest = (0, _lib.getUnhandledProps)(TableFooter, props);
	
	  return _react2.default.createElement(_TableHeader2.default, (0, _extends3.default)({}, rest, { as: as }));
	}
	
	TableFooter.handledProps = ['as'];
	TableFooter._meta = {
	  name: 'TableFooter',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	TableFooter.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as
	} : {};
	
	TableFooter.defaultProps = {
	  as: 'tfoot'
	};
	
	exports.default = TableFooter;

/***/ },
/* 4489 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _TableCell = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table can have a header cell.
	 */
	function TableHeaderCell(props) {
	  var as = props.as,
	      className = props.className,
	      sorted = props.sorted;
	
	  var classes = (0, _classnames2.default)((0, _lib.useValueAndKey)(sorted, 'sorted'), className);
	  var rest = (0, _lib.getUnhandledProps)(TableHeaderCell, props);
	
	  return _react2.default.createElement(_TableCell2.default, (0, _extends3.default)({}, rest, { as: as, className: classes }));
	}
	
	TableHeaderCell.handledProps = ['as', 'className', 'sorted'];
	TableHeaderCell._meta = {
	  name: 'TableHeaderCell',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	TableHeaderCell.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A header cell can be sorted in ascending or descending order. */
	  sorted: _propTypes2.default.oneOf(['ascending', 'descending'])
	} : {};
	
	TableHeaderCell.defaultProps = {
	  as: 'th'
	};
	
	exports.default = TableHeaderCell;

/***/ },
/* 4490 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _TableCell = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A table can have rows.
	 */
	function TableRow(props) {
	  var active = props.active,
	      cellAs = props.cellAs,
	      cells = props.cells,
	      children = props.children,
	      className = props.className,
	      disabled = props.disabled,
	      error = props.error,
	      negative = props.negative,
	      positive = props.positive,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign,
	      warning = props.warning;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), className);
	  var rest = (0, _lib.getUnhandledProps)(TableRow, props);
	  var ElementType = (0, _lib.getElementType)(TableRow, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _map3.default)(cells, function (cell) {
	      return _TableCell2.default.create(cell, { defaultProps: { as: cellAs } });
	    })
	  );
	}
	
	TableRow.handledProps = ['active', 'as', 'cellAs', 'cells', 'children', 'className', 'disabled', 'error', 'negative', 'positive', 'textAlign', 'verticalAlign', 'warning'];
	TableRow._meta = {
	  name: 'TableRow',
	  type: _lib.META.TYPES.COLLECTION,
	  parent: 'Table'
	};
	
	TableRow.defaultProps = {
	  as: 'tr',
	  cellAs: 'td'
	};
	
	TableRow.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A row can be active or selected by a user. */
	  active: _propTypes2.default.bool,
	
	  /** An element type to render as (string or function). */
	  cellAs: _lib.customPropTypes.as,
	
	  /** Shorthand array of props for TableCell. */
	  cells: _lib.customPropTypes.collectionShorthand,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A row can be disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** A row may call attention to an error or a negative value. */
	  error: _propTypes2.default.bool,
	
	  /** A row may let a user know whether a value is bad. */
	  negative: _propTypes2.default.bool,
	
	  /** A row may let a user know whether a value is good. */
	  positive: _propTypes2.default.bool,
	
	  /** A table row can adjust its text alignment. */
	  textAlign: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified')),
	
	  /** A table row can adjust its vertical alignment. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** A row may warn a user. */
	  warning: _propTypes2.default.bool
	} : {};
	
	TableRow.create = (0, _lib.createShorthandFactory)(TableRow, function (cells) {
	  return { cells: cells };
	});
	
	exports.default = TableRow;

/***/ },
/* 4491 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Table = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Table2.default;

/***/ },
/* 4492 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _isNil2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _Icon = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Label = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ButtonContent = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _ButtonContent2 = _interopRequireDefault(_ButtonContent);
	
	var _ButtonGroup = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _ButtonOr = __webpack_require__(__webpack_module_template_argument_8__);
	
	var _ButtonOr2 = _interopRequireDefault(_ButtonOr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A Button indicates a possible user action.
	 * @see Form
	 * @see Icon
	 * @see Label
	 */
	var Button = function (_Component) {
	  (0, _inherits3.default)(Button, _Component);
	
	  function Button() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Button);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.computeElementType = function () {
	      var _this$props = _this.props,
	          attached = _this$props.attached,
	          label = _this$props.label;
	
	
	      if (!(0, _isNil3.default)(attached) || !(0, _isNil3.default)(label)) return 'div';
	    }, _this.computeTabIndex = function (ElementType) {
	      var _this$props2 = _this.props,
	          disabled = _this$props2.disabled,
	          tabIndex = _this$props2.tabIndex;
	
	
	      if (!(0, _isNil3.default)(tabIndex)) return tabIndex;
	      if (disabled) return -1;
	      if (ElementType === 'div') return 0;
	    }, _this.focus = function () {
	      return (0, _invoke3.default)(_this.ref, 'focus');
	    }, _this.handleClick = function (e) {
	      var disabled = _this.props.disabled;
	
	
	      if (disabled) {
	        e.preventDefault();
	        return;
	      }
	
	      (0, _invoke3.default)(_this.props, 'onClick', e, _this.props);
	    }, _this.handleRef = function (c) {
	      return _this.ref = c;
	    }, _this.hasIconClass = function () {
	      var _this$props3 = _this.props,
	          labelPosition = _this$props3.labelPosition,
	          children = _this$props3.children,
	          content = _this$props3.content,
	          icon = _this$props3.icon;
	
	
	      if (icon === true) return true;
	      return icon && (labelPosition || _lib.childrenUtils.isNil(children) && (0, _isNil3.default)(content));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Button, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          animated = _props.animated,
	          attached = _props.attached,
	          basic = _props.basic,
	          children = _props.children,
	          circular = _props.circular,
	          className = _props.className,
	          color = _props.color,
	          compact = _props.compact,
	          content = _props.content,
	          disabled = _props.disabled,
	          floated = _props.floated,
	          fluid = _props.fluid,
	          icon = _props.icon,
	          inverted = _props.inverted,
	          label = _props.label,
	          labelPosition = _props.labelPosition,
	          loading = _props.loading,
	          negative = _props.negative,
	          positive = _props.positive,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          size = _props.size,
	          toggle = _props.toggle;
	
	
	      var baseClasses = (0, _classnames2.default)(color, size, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(this.hasIconClass(), 'icon'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(primary, 'primary'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(toggle, 'toggle'), (0, _lib.useKeyOrValueAndKey)(animated, 'animated'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'));
	      var labeledClasses = (0, _classnames2.default)((0, _lib.useKeyOrValueAndKey)(labelPosition || !!label, 'labeled'));
	      var wrapperClasses = (0, _classnames2.default)((0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useValueAndKey)(floated, 'floated'));
	
	      var rest = (0, _lib.getUnhandledProps)(Button, this.props);
	      var ElementType = (0, _lib.getElementType)(Button, this.props, this.computeElementType);
	      var tabIndex = this.computeTabIndex(ElementType);
	
	      if (!(0, _isNil3.default)(label)) {
	        var buttonClasses = (0, _classnames2.default)('ui', baseClasses, 'button', className);
	        var containerClasses = (0, _classnames2.default)('ui', labeledClasses, 'button', className, wrapperClasses);
	        var labelElement = _Label2.default.create(label, { defaultProps: {
	            basic: true,
	            pointing: labelPosition === 'left' ? 'right' : 'left'
	          } });
	
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: containerClasses, onClick: this.handleClick }),
	          labelPosition === 'left' && labelElement,
	          _react2.default.createElement(
	            'button',
	            { className: buttonClasses, disabled: disabled, ref: this.handleRef, tabIndex: tabIndex },
	            _Icon2.default.create(icon),
	            ' ',
	            content
	          ),
	          (labelPosition === 'right' || !labelPosition) && labelElement
	        );
	      }
	
	      var classes = (0, _classnames2.default)('ui', baseClasses, wrapperClasses, labeledClasses, 'button', className);
	      var hasChildren = !_lib.childrenUtils.isNil(children);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, {
	          className: classes,
	          disabled: disabled && ElementType === 'button' || undefined,
	          onClick: this.handleClick,
	          ref: this.handleRef,
	          role: 'button',
	          tabIndex: tabIndex
	        }),
	        hasChildren && children,
	        !hasChildren && _Icon2.default.create(icon),
	        !hasChildren && content
	      );
	    }
	  }]);
	  return Button;
	}(_react.Component);
	
	Button.defaultProps = {
	  as: 'button'
	};
	Button._meta = {
	  name: 'Button',
	  type: _lib.META.TYPES.ELEMENT
	};
	Button.Content = _ButtonContent2.default;
	Button.Group = _ButtonGroup2.default;
	Button.Or = _ButtonOr2.default;
	Button.handledProps = ['active', 'animated', 'as', 'attached', 'basic', 'children', 'circular', 'className', 'color', 'compact', 'content', 'disabled', 'floated', 'fluid', 'icon', 'inverted', 'label', 'labelPosition', 'loading', 'negative', 'onClick', 'positive', 'primary', 'secondary', 'size', 'tabIndex', 'toggle'];
	Button.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A button can show it is currently the active user selection. */
	  active: _propTypes2.default.bool,
	
	  /** A button can animate to show hidden content. */
	  animated: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['fade', 'vertical'])]),
	
	  /** A button can be attached to other content. */
	  attached: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom'])]),
	
	  /** A basic button is less pronounced. */
	  basic: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _lib.customPropTypes.every([_propTypes2.default.node, _lib.customPropTypes.disallow(['label']), _lib.customPropTypes.givenProps({
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string.isRequired, _propTypes2.default.object.isRequired, _propTypes2.default.element.isRequired])
	  }, _lib.customPropTypes.disallow(['icon']))]),
	
	  /** A button can be circular. */
	  circular: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A button can have different colors */
	  color: _propTypes2.default.oneOf([].concat((0, _toConsumableArray3.default)(_lib.SUI.COLORS), ['facebook', 'google plus', 'instagram', 'linkedin', 'twitter', 'vk', 'youtube'])),
	
	  /** A button can reduce its padding to fit into tighter spaces. */
	  compact: _propTypes2.default.bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A button can show it is currently unable to be interacted with. */
	  disabled: _propTypes2.default.bool,
	
	  /** A button can be aligned to the left or right of its container. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** A button can take the width of its container. */
	  fluid: _propTypes2.default.bool,
	
	  /** Add an Icon by name, props object, or pass an <Icon />. */
	  icon: _lib.customPropTypes.some([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]),
	
	  /** A button can be formatted to appear on dark backgrounds. */
	  inverted: _propTypes2.default.bool,
	
	  /** Add a Label by text, props object, or pass a <Label />. */
	  label: _lib.customPropTypes.some([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element]),
	
	  /** A labeled button can format a Label or Icon to appear on the left or right. */
	  labelPosition: _propTypes2.default.oneOf(['right', 'left']),
	
	  /** A button can show a loading indicator. */
	  loading: _propTypes2.default.bool,
	
	  /** A button can hint towards a negative consequence. */
	  negative: _propTypes2.default.bool,
	
	  /**
	   * Called after user's click.
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /** A button can hint towards a positive consequence. */
	  positive: _propTypes2.default.bool,
	
	  /** A button can be formatted to show different levels of emphasis. */
	  primary: _propTypes2.default.bool,
	
	  /** A button can be formatted to show different levels of emphasis. */
	  secondary: _propTypes2.default.bool,
	
	  /** A button can have different sizes. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES),
	
	  /** A button can receive focus. */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** A button can be formatted to toggle on and off. */
	  toggle: _propTypes2.default.bool
	} : {};
	
	
	Button.create = (0, _lib.createShorthandFactory)(Button, function (value) {
	  return { content: value };
	});
	
	exports.default = Button;

/***/ },
/* 4493 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Button groups can contain conditionals.
	 */
	function ButtonOr(props) {
	  var className = props.className,
	      text = props.text;
	
	  var classes = (0, _classnames2.default)('or', className);
	  var rest = (0, _lib.getUnhandledProps)(ButtonOr, props);
	  var ElementType = (0, _lib.getElementType)(ButtonOr, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { className: classes, 'data-text': text }));
	}
	
	ButtonOr.handledProps = ['as', 'className', 'text'];
	ButtonOr._meta = {
	  name: 'ButtonOr',
	  parent: 'Button',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ButtonOr.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Or buttons can have their text localized, or adjusted by using the text prop. */
	  text: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	} : {};
	
	exports.default = ButtonOr;

/***/ },
/* 4494 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Button = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Button2.default;

/***/ },
/* 4495 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Container = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Container2.default;

/***/ },
/* 4496 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Divider = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ },
/* 4497 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.names = undefined;
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var names = exports.names = ['ad', 'andorra', 'ae', 'united arab emirates', 'uae', 'af', 'afghanistan', 'ag', 'antigua', 'ai', 'anguilla', 'al', 'albania', 'am', 'armenia', 'an', 'netherlands antilles', 'ao', 'angola', 'ar', 'argentina', 'as', 'american samoa', 'at', 'austria', 'au', 'australia', 'aw', 'aruba', 'ax', 'aland islands', 'az', 'azerbaijan', 'ba', 'bosnia', 'bb', 'barbados', 'bd', 'bangladesh', 'be', 'belgium', 'bf', 'burkina faso', 'bg', 'bulgaria', 'bh', 'bahrain', 'bi', 'burundi', 'bj', 'benin', 'bm', 'bermuda', 'bn', 'brunei', 'bo', 'bolivia', 'br', 'brazil', 'bs', 'bahamas', 'bt', 'bhutan', 'bv', 'bouvet island', 'bw', 'botswana', 'by', 'belarus', 'bz', 'belize', 'ca', 'canada', 'cc', 'cocos islands', 'cd', 'congo', 'cf', 'central african republic', 'cg', 'congo brazzaville', 'ch', 'switzerland', 'ci', 'cote divoire', 'ck', 'cook islands', 'cl', 'chile', 'cm', 'cameroon', 'cn', 'china', 'co', 'colombia', 'cr', 'costa rica', 'cs', 'cu', 'cuba', 'cv', 'cape verde', 'cx', 'christmas island', 'cy', 'cyprus', 'cz', 'czech republic', 'de', 'germany', 'dj', 'djibouti', 'dk', 'denmark', 'dm', 'dominica', 'do', 'dominican republic', 'dz', 'algeria', 'ec', 'ecuador', 'ee', 'estonia', 'eg', 'egypt', 'eh', 'western sahara', 'er', 'eritrea', 'es', 'spain', 'et', 'ethiopia', 'eu', 'european union', 'fi', 'finland', 'fj', 'fiji', 'fk', 'falkland islands', 'fm', 'micronesia', 'fo', 'faroe islands', 'fr', 'france', 'ga', 'gabon', 'gb', 'united kingdom', 'gd', 'grenada', 'ge', 'georgia', 'gf', 'french guiana', 'gh', 'ghana', 'gi', 'gibraltar', 'gl', 'greenland', 'gm', 'gambia', 'gn', 'guinea', 'gp', 'guadeloupe', 'gq', 'equatorial guinea', 'gr', 'greece', 'gs', 'sandwich islands', 'gt', 'guatemala', 'gu', 'guam', 'gw', 'guinea-bissau', 'gy', 'guyana', 'hk', 'hong kong', 'hm', 'heard island', 'hn', 'honduras', 'hr', 'croatia', 'ht', 'haiti', 'hu', 'hungary', 'id', 'indonesia', 'ie', 'ireland', 'il', 'israel', 'in', 'india', 'io', 'indian ocean territory', 'iq', 'iraq', 'ir', 'iran', 'is', 'iceland', 'it', 'italy', 'jm', 'jamaica', 'jo', 'jordan', 'jp', 'japan', 'ke', 'kenya', 'kg', 'kyrgyzstan', 'kh', 'cambodia', 'ki', 'kiribati', 'km', 'comoros', 'kn', 'saint kitts and nevis', 'kp', 'north korea', 'kr', 'south korea', 'kw', 'kuwait', 'ky', 'cayman islands', 'kz', 'kazakhstan', 'la', 'laos', 'lb', 'lebanon', 'lc', 'saint lucia', 'li', 'liechtenstein', 'lk', 'sri lanka', 'lr', 'liberia', 'ls', 'lesotho', 'lt', 'lithuania', 'lu', 'luxembourg', 'lv', 'latvia', 'ly', 'libya', 'ma', 'morocco', 'mc', 'monaco', 'md', 'moldova', 'me', 'montenegro', 'mg', 'madagascar', 'mh', 'marshall islands', 'mk', 'macedonia', 'ml', 'mali', 'mm', 'myanmar', 'burma', 'mn', 'mongolia', 'mo', 'macau', 'mp', 'northern mariana islands', 'mq', 'martinique', 'mr', 'mauritania', 'ms', 'montserrat', 'mt', 'malta', 'mu', 'mauritius', 'mv', 'maldives', 'mw', 'malawi', 'mx', 'mexico', 'my', 'malaysia', 'mz', 'mozambique', 'na', 'namibia', 'nc', 'new caledonia', 'ne', 'niger', 'nf', 'norfolk island', 'ng', 'nigeria', 'ni', 'nicaragua', 'nl', 'netherlands', 'no', 'norway', 'np', 'nepal', 'nr', 'nauru', 'nu', 'niue', 'nz', 'new zealand', 'om', 'oman', 'pa', 'panama', 'pe', 'peru', 'pf', 'french polynesia', 'pg', 'new guinea', 'ph', 'philippines', 'pk', 'pakistan', 'pl', 'poland', 'pm', 'saint pierre', 'pn', 'pitcairn islands', 'pr', 'puerto rico', 'ps', 'palestine', 'pt', 'portugal', 'pw', 'palau', 'py', 'paraguay', 'qa', 'qatar', 're', 'reunion', 'ro', 'romania', 'rs', 'serbia', 'ru', 'russia', 'rw', 'rwanda', 'sa', 'saudi arabia', 'sb', 'solomon islands', 'sc', 'seychelles', 'gb sct', 'scotland', 'sd', 'sudan', 'se', 'sweden', 'sg', 'singapore', 'sh', 'saint helena', 'si', 'slovenia', 'sj', 'svalbard', 'jan mayen', 'sk', 'slovakia', 'sl', 'sierra leone', 'sm', 'san marino', 'sn', 'senegal', 'so', 'somalia', 'sr', 'suriname', 'st', 'sao tome', 'sv', 'el salvador', 'sy', 'syria', 'sz', 'swaziland', 'tc', 'caicos islands', 'td', 'chad', 'tf', 'french territories', 'tg', 'togo', 'th', 'thailand', 'tj', 'tajikistan', 'tk', 'tokelau', 'tl', 'timorleste', 'tm', 'turkmenistan', 'tn', 'tunisia', 'to', 'tonga', 'tr', 'turkey', 'tt', 'trinidad', 'tv', 'tuvalu', 'tw', 'taiwan', 'tz', 'tanzania', 'ua', 'ukraine', 'ug', 'uganda', 'um', 'us minor islands', 'us', 'america', 'united states', 'uy', 'uruguay', 'uz', 'uzbekistan', 'va', 'vatican city', 'vc', 'saint vincent', 've', 'venezuela', 'vg', 'british virgin islands', 'vi', 'us virgin islands', 'vn', 'vietnam', 'vu', 'vanuatu', 'gb wls', 'wales', 'wf', 'wallis and futuna', 'ws', 'samoa', 'ye', 'yemen', 'yt', 'mayotte', 'za', 'south africa', 'zm', 'zambia', 'zw', 'zimbabwe'];
	
	/**
	 * A flag is is used to represent a political state.
	 */
	
	var Flag = function (_Component) {
	  (0, _inherits3.default)(Flag, _Component);
	
	  function Flag() {
	    (0, _classCallCheck3.default)(this, Flag);
	    return (0, _possibleConstructorReturn3.default)(this, (Flag.__proto__ || Object.getPrototypeOf(Flag)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Flag, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _lib.shallowEqual)(this.props, nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          name = _props.name;
	
	      var classes = (0, _classnames2.default)(name, 'flag', className);
	      var rest = (0, _lib.getUnhandledProps)(Flag, this.props);
	      var ElementType = (0, _lib.getElementType)(Flag, this.props);
	
	      return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { className: classes }));
	    }
	  }]);
	  return Flag;
	}(_react.Component);
	
	Flag.defaultProps = {
	  as: 'i'
	};
	Flag._meta = {
	  name: 'Flag',
	  type: _lib.META.TYPES.ELEMENT
	};
	Flag.handledProps = ['as', 'className', 'name'];
	Flag.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Flag name, can use the two digit country code, the full name, or a common alias. */
	  name: _lib.customPropTypes.suggest(names)
	} : {};
	
	
	Flag.create = (0, _lib.createShorthandFactory)(Flag, function (value) {
	  return { name: value };
	});
	
	exports.default = Flag;

/***/ },
/* 4498 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Flag = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Flag2 = _interopRequireDefault(_Flag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Flag2.default;

/***/ },
/* 4499 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _Icon = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Image = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _HeaderSubheader = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _HeaderSubheader2 = _interopRequireDefault(_HeaderSubheader);
	
	var _HeaderContent = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _HeaderContent2 = _interopRequireDefault(_HeaderContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A header provides a short summary of content
	 */
	function Header(props) {
	  var attached = props.attached,
	      block = props.block,
	      children = props.children,
	      className = props.className,
	      color = props.color,
	      content = props.content,
	      disabled = props.disabled,
	      dividing = props.dividing,
	      floated = props.floated,
	      icon = props.icon,
	      image = props.image,
	      inverted = props.inverted,
	      size = props.size,
	      sub = props.sub,
	      subheader = props.subheader,
	      textAlign = props.textAlign;
	
	
	  var classes = (0, _classnames2.default)('ui', color, size, (0, _lib.useKeyOnly)(block, 'block'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(dividing, 'dividing'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useKeyOnly)(icon === true, 'icon'), (0, _lib.useKeyOnly)(image === true, 'image'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(sub, 'sub'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useTextAlignProp)(textAlign), 'header', className);
	  var rest = (0, _lib.getUnhandledProps)(Header, props);
	  var ElementType = (0, _lib.getElementType)(Header, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var iconElement = _Icon2.default.create(icon);
	  var imageElement = _Image2.default.create(image);
	  var subheaderElement = _HeaderSubheader2.default.create(subheader);
	
	  if (iconElement || imageElement) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      iconElement || imageElement,
	      (content || subheaderElement) && _react2.default.createElement(
	        _HeaderContent2.default,
	        null,
	        content,
	        subheaderElement
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content,
	    subheaderElement
	  );
	}
	
	Header.handledProps = ['as', 'attached', 'block', 'children', 'className', 'color', 'content', 'disabled', 'dividing', 'floated', 'icon', 'image', 'inverted', 'size', 'sub', 'subheader', 'textAlign'];
	Header._meta = {
	  name: 'Header',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Header.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Attach header  to other content, like a segment. */
	  attached: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['top', 'bottom'])]),
	
	  /** Format header to appear inside a content block. */
	  block: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Color of the header. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Show that the header is inactive. */
	  disabled: _propTypes2.default.bool,
	
	  /** Divide header from the content below it. */
	  dividing: _propTypes2.default.bool,
	
	  /** Header can sit to the left or right of other content. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** Add an icon by icon name or pass an Icon. */
	  icon: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['image']), _propTypes2.default.oneOfType([_propTypes2.default.bool, _lib.customPropTypes.itemShorthand])]),
	
	  /** Add an image by img src or pass an Image. */
	  image: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['icon']), _propTypes2.default.oneOfType([_propTypes2.default.bool, _lib.customPropTypes.itemShorthand])]),
	
	  /** Inverts the color of the header for dark backgrounds. */
	  inverted: _propTypes2.default.bool,
	
	  /** Content headings are sized with em and are based on the font-size of their container. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'big', 'massive', 'mini')),
	
	  /** Headers may be formatted to label smaller or de-emphasized content. */
	  sub: _propTypes2.default.bool,
	
	  /** Shorthand for Header.Subheader. */
	  subheader: _lib.customPropTypes.itemShorthand,
	
	  /** Align header content. */
	  textAlign: _propTypes2.default.oneOf(_lib.SUI.TEXT_ALIGNMENTS)
	} : {};
	
	Header.Content = _HeaderContent2.default;
	Header.Subheader = _HeaderSubheader2.default;
	
	exports.default = Header;

/***/ },
/* 4500 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Headers may contain subheaders.
	 */
	function HeaderSubheader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('sub header', className);
	  var rest = (0, _lib.getUnhandledProps)(HeaderSubheader, props);
	  var ElementType = (0, _lib.getElementType)(HeaderSubheader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	HeaderSubheader.handledProps = ['as', 'children', 'className', 'content'];
	HeaderSubheader._meta = {
	  name: 'HeaderSubheader',
	  parent: 'Header',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	HeaderSubheader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	HeaderSubheader.create = (0, _lib.createShorthandFactory)(HeaderSubheader, function (content) {
	  return { content: content };
	});
	
	exports.default = HeaderSubheader;

/***/ },
/* 4501 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Header = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Header2.default;

/***/ },
/* 4502 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _IconGroup = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _IconGroup2 = _interopRequireDefault(_IconGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An icon is a glyph used to represent something else.
	 * @see Image
	 */
	var Icon = function (_Component) {
	  (0, _inherits3.default)(Icon, _Component);
	
	  function Icon() {
	    (0, _classCallCheck3.default)(this, Icon);
	    return (0, _possibleConstructorReturn3.default)(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Icon, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _lib.shallowEqual)(this.props, nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bordered = _props.bordered,
	          circular = _props.circular,
	          className = _props.className,
	          color = _props.color,
	          corner = _props.corner,
	          disabled = _props.disabled,
	          fitted = _props.fitted,
	          flipped = _props.flipped,
	          inverted = _props.inverted,
	          link = _props.link,
	          loading = _props.loading,
	          name = _props.name,
	          rotated = _props.rotated,
	          size = _props.size;
	
	
	      var classes = (0, _classnames2.default)(color, name, size, (0, _lib.useKeyOnly)(bordered, 'bordered'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(corner, 'corner'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(fitted, 'fitted'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useValueAndKey)(flipped, 'flipped'), (0, _lib.useValueAndKey)(rotated, 'rotated'), 'icon', className);
	      var rest = (0, _lib.getUnhandledProps)(Icon, this.props);
	      var ElementType = (0, _lib.getElementType)(Icon, this.props);
	
	      return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { 'aria-hidden': 'true', className: classes }));
	    }
	  }]);
	  return Icon;
	}(_react.Component);
	
	Icon.defaultProps = {
	  as: 'i'
	};
	Icon._meta = {
	  name: 'Icon',
	  type: _lib.META.TYPES.ELEMENT
	};
	Icon.Group = _IconGroup2.default;
	Icon.handledProps = ['as', 'bordered', 'circular', 'className', 'color', 'corner', 'disabled', 'fitted', 'flipped', 'inverted', 'link', 'loading', 'name', 'rotated', 'size'];
	Icon.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Formatted to appear bordered. */
	  bordered: _propTypes2.default.bool,
	
	  /** Icon can formatted to appear circular. */
	  circular: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Color of the icon. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Icons can display a smaller corner icon. */
	  corner: _propTypes2.default.bool,
	
	  /** Show that the icon is inactive. */
	  disabled: _propTypes2.default.bool,
	
	  /** Fitted, without space to left or right of Icon. */
	  fitted: _propTypes2.default.bool,
	
	  /** Icon can flipped. */
	  flipped: _propTypes2.default.oneOf(['horizontally', 'vertically']),
	
	  /** Formatted to have its colors inverted for contrast. */
	  inverted: _propTypes2.default.bool,
	
	  /** Icon can be formatted as a link. */
	  link: _propTypes2.default.bool,
	
	  /** Icon can be used as a simple loader. */
	  loading: _propTypes2.default.bool,
	
	  /** Name of the icon. */
	  name: _lib.customPropTypes.suggest(_lib.SUI.ALL_ICONS_IN_ALL_CONTEXTS),
	
	  /** Icon can rotated. */
	  rotated: _propTypes2.default.oneOf(['clockwise', 'counterclockwise']),
	
	  /** Size of the icon. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium'))
	} : {};
	
	
	Icon.create = (0, _lib.createShorthandFactory)(Icon, function (value) {
	  return { name: value };
	});
	
	exports.default = Icon;

/***/ },
/* 4503 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Icon = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Icon2.default;

/***/ },
/* 4504 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Image = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Image2.default;

/***/ },
/* 4505 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Input = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Input2.default;

/***/ },
/* 4506 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isUndefined2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _invoke2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _Icon = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Image = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _LabelDetail = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _LabelDetail2 = _interopRequireDefault(_LabelDetail);
	
	var _LabelGroup = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _LabelGroup2 = _interopRequireDefault(_LabelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A label displays content classification.
	 */
	var Label = function (_Component) {
	  (0, _inherits3.default)(Label, _Component);
	
	  function Label() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Label);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Label.__proto__ || Object.getPrototypeOf(Label)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _this.handleIconOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e) {
	          (0, _invoke3.default)(predefinedProps, 'onClick', e);
	          (0, _invoke3.default)(_this.props, 'onRemove', e, _this.props);
	        }
	      };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Label, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          attached = _props.attached,
	          basic = _props.basic,
	          children = _props.children,
	          circular = _props.circular,
	          className = _props.className,
	          color = _props.color,
	          content = _props.content,
	          corner = _props.corner,
	          detail = _props.detail,
	          empty = _props.empty,
	          floating = _props.floating,
	          horizontal = _props.horizontal,
	          icon = _props.icon,
	          image = _props.image,
	          onRemove = _props.onRemove,
	          pointing = _props.pointing,
	          removeIcon = _props.removeIcon,
	          ribbon = _props.ribbon,
	          size = _props.size,
	          tag = _props.tag;
	
	
	      var pointingClass = pointing === true && 'pointing' || (pointing === 'left' || pointing === 'right') && pointing + ' pointing' || (pointing === 'above' || pointing === 'below') && 'pointing ' + pointing;
	
	      var classes = (0, _classnames2.default)('ui', color, pointingClass, size, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(empty, 'empty'), (0, _lib.useKeyOnly)(floating, 'floating'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(image === true, 'image'), (0, _lib.useKeyOnly)(tag, 'tag'), (0, _lib.useKeyOrValueAndKey)(corner, 'corner'), (0, _lib.useKeyOrValueAndKey)(ribbon, 'ribbon'), (0, _lib.useValueAndKey)(attached, 'attached'), 'label', className);
	      var rest = (0, _lib.getUnhandledProps)(Label, this.props);
	      var ElementType = (0, _lib.getElementType)(Label, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      var removeIconShorthand = (0, _isUndefined3.default)(removeIcon) ? 'delete' : removeIcon;
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({ className: classes, onClick: this.handleClick }, rest),
	        _Icon2.default.create(icon),
	        typeof image !== 'boolean' && _Image2.default.create(image),
	        content,
	        (0, _lib.createShorthand)(_LabelDetail2.default, function (val) {
	          return { content: val };
	        }, detail),
	        onRemove && _Icon2.default.create(removeIconShorthand, { overrideProps: this.handleIconOverrides })
	      );
	    }
	  }]);
	  return Label;
	}(_react.Component);
	
	Label._meta = {
	  name: 'Label',
	  type: _lib.META.TYPES.ELEMENT
	};
	Label.Detail = _LabelDetail2.default;
	Label.Group = _LabelGroup2.default;
	Label.handledProps = ['active', 'as', 'attached', 'basic', 'children', 'circular', 'className', 'color', 'content', 'corner', 'detail', 'empty', 'floating', 'horizontal', 'icon', 'image', 'onClick', 'onRemove', 'pointing', 'removeIcon', 'ribbon', 'size', 'tag'];
	exports.default = Label;
	Label.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A label can be active. */
	  active: _propTypes2.default.bool,
	
	  /** A label can attach to a content segment. */
	  attached: _propTypes2.default.oneOf(['top', 'bottom', 'top right', 'top left', 'bottom left', 'bottom right']),
	
	  /** A label can reduce its complexity. */
	  basic: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** A label can be circular. */
	  circular: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Color of the label. */
	  color: _propTypes2.default.oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A label can position itself in the corner of an element. */
	  corner: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['left', 'right'])]),
	
	  /** Shorthand for LabelDetail. */
	  detail: _lib.customPropTypes.itemShorthand,
	
	  /** Formats the label as a dot. */
	  empty: _lib.customPropTypes.every([_propTypes2.default.bool, _lib.customPropTypes.demand(['circular'])]),
	
	  /** Float above another element in the upper right corner. */
	  floating: _propTypes2.default.bool,
	
	  /** A horizontal label is formatted to label content along-side it horizontally. */
	  horizontal: _propTypes2.default.bool,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** A label can be formatted to emphasize an image or prop can be used as shorthand for Image. */
	  image: _propTypes2.default.oneOfType([_propTypes2.default.bool, _lib.customPropTypes.itemShorthand]),
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Adds an "x" icon, called when "x" is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onRemove: _propTypes2.default.func,
	
	  /** A label can point to content next to it. */
	  pointing: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['above', 'below', 'left', 'right'])]),
	
	  /** Shorthand for Icon to appear as the last child and trigger onRemove. */
	  removeIcon: _lib.customPropTypes.itemShorthand,
	
	  /** A label can appear as a ribbon attaching itself to an element. */
	  ribbon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['right'])]),
	
	  /** A label can have different sizes. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES),
	
	  /** A label can appear as a tag. */
	  tag: _propTypes2.default.bool
	} : {};
	
	
	Label.create = (0, _lib.createShorthandFactory)(Label, function (value) {
	  return { content: value };
	});

/***/ },
/* 4507 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LabelDetail(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('detail', className);
	  var rest = (0, _lib.getUnhandledProps)(LabelDetail, props);
	  var ElementType = (0, _lib.getElementType)(LabelDetail, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	LabelDetail.handledProps = ['as', 'children', 'className', 'content'];
	LabelDetail._meta = {
	  name: 'LabelDetail',
	  parent: 'Label',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	LabelDetail.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = LabelDetail;

/***/ },
/* 4508 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Label = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Label2.default;

/***/ },
/* 4509 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _ListDescription = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _ListDescription2 = _interopRequireDefault(_ListDescription);
	
	var _ListHeader = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list item can contain a content.
	 */
	function ListContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      floated = props.floated,
	      header = props.header,
	      verticalAlign = props.verticalAlign;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(ListContent, props);
	  var ElementType = (0, _lib.getElementType)(ListContent, props);
	
	  if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _ListHeader2.default.create(header),
	    _ListDescription2.default.create(description),
	    content
	  );
	}
	
	ListContent.handledProps = ['as', 'children', 'className', 'content', 'description', 'floated', 'header', 'verticalAlign'];
	ListContent._meta = {
	  name: 'ListContent',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ListContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for ListDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** An list content can be floated left or right. */
	  floated: _propTypes2.default.oneOf(_lib.SUI.FLOATS),
	
	  /** Shorthand for ListHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** An element inside a list can be vertically aligned. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	
	ListContent.create = (0, _lib.createShorthandFactory)(ListContent, function (content) {
	  return { content: content };
	});
	
	exports.default = ListContent;

/***/ },
/* 4510 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list item can contain a description.
	 */
	function ListDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)(className, 'description');
	  var rest = (0, _lib.getUnhandledProps)(ListDescription, props);
	  var ElementType = (0, _lib.getElementType)(ListDescription, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ListDescription.handledProps = ['as', 'children', 'className', 'content'];
	ListDescription._meta = {
	  name: 'ListDescription',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ListDescription.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	ListDescription.create = (0, _lib.createShorthandFactory)(ListDescription, function (content) {
	  return { content: content };
	});
	
	exports.default = ListDescription;

/***/ },
/* 4511 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list item can contain a header.
	 */
	function ListHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(ListHeader, props);
	  var ElementType = (0, _lib.getElementType)(ListHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ListHeader.handledProps = ['as', 'children', 'className', 'content'];
	ListHeader._meta = {
	  name: 'ListHeader',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ListHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	ListHeader.create = (0, _lib.createShorthandFactory)(ListHeader, function (content) {
	  return { content: content };
	});
	
	exports.default = ListHeader;

/***/ },
/* 4512 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Icon = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list item can contain an icon.
	 */
	function ListIcon(props) {
	  var className = props.className,
	      verticalAlign = props.verticalAlign;
	
	  var classes = (0, _classnames2.default)((0, _lib.useVerticalAlignProp)(verticalAlign), className);
	  var rest = (0, _lib.getUnhandledProps)(ListIcon, props);
	
	  return _react2.default.createElement(_Icon2.default, (0, _extends3.default)({}, rest, { className: classes }));
	}
	
	ListIcon.handledProps = ['className', 'verticalAlign'];
	ListIcon._meta = {
	  name: 'ListIcon',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	ListIcon.propTypes =  false ? {
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** An element inside a list can be vertically aligned. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	
	ListIcon.create = (0, _lib.createShorthandFactory)(ListIcon, function (name) {
	  return { name: name };
	});
	
	exports.default = ListIcon;

/***/ },
/* 4513 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isPlainObject2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _invoke2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _Image = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ListContent = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _ListContent2 = _interopRequireDefault(_ListContent);
	
	var _ListDescription = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _ListDescription2 = _interopRequireDefault(_ListDescription);
	
	var _ListHeader = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _ListIcon = __webpack_require__(__webpack_module_template_argument_8__);
	
	var _ListIcon2 = _interopRequireDefault(_ListIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A list item can contain a set of items.
	 */
	var ListItem = function (_Component) {
	  (0, _inherits3.default)(ListItem, _Component);
	
	  function ListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var disabled = _this.props.disabled;
	
	
	      if (!disabled) (0, _invoke3.default)(_this.props, 'onClick', e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content,
	          description = _props.description,
	          disabled = _props.disabled,
	          header = _props.header,
	          icon = _props.icon,
	          image = _props.image,
	          value = _props.value;
	
	
	      var ElementType = (0, _lib.getElementType)(ListItem, this.props);
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(ElementType !== 'li', 'item'), className);
	      var rest = (0, _lib.getUnhandledProps)(ListItem, this.props);
	      var valueProp = ElementType === 'li' ? { value: value } : { 'data-value': value };
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, valueProp, { role: 'listitem', className: classes, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      var iconElement = _ListIcon2.default.create(icon);
	      var imageElement = _Image2.default.create(image);
	
	      // See description of `content` prop for explanation about why this is necessary.
	      if (!(0, _react.isValidElement)(content) && (0, _isPlainObject3.default)(content)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, valueProp, { role: 'listitem', className: classes, onClick: this.handleClick }),
	          iconElement || imageElement,
	          _ListContent2.default.create(content, { header: header, description: description })
	        );
	      }
	
	      var headerElement = _ListHeader2.default.create(header);
	      var descriptionElement = _ListDescription2.default.create(description);
	      if (iconElement || imageElement) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, valueProp, { role: 'listitem', className: classes, onClick: this.handleClick }),
	          iconElement || imageElement,
	          (content || headerElement || descriptionElement) && _react2.default.createElement(
	            _ListContent2.default,
	            null,
	            headerElement,
	            descriptionElement,
	            content
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, valueProp, { role: 'listitem', className: classes, onClick: this.handleClick }),
	        headerElement,
	        descriptionElement,
	        content
	      );
	    }
	  }]);
	  return ListItem;
	}(_react.Component);
	
	ListItem._meta = {
	  name: 'ListItem',
	  parent: 'List',
	  type: _lib.META.TYPES.ELEMENT
	};
	ListItem.handledProps = ['active', 'as', 'children', 'className', 'content', 'description', 'disabled', 'header', 'icon', 'image', 'onClick', 'value'];
	ListItem.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A list item can active. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /**
	   * Shorthand for primary content.
	   *
	   * Heads up!
	   *
	   * This is handled slightly differently than the typical `content` prop since
	   * the wrapping ListContent is not used when there's no icon or image.
	   *
	   * If you pass content as:
	   * - an element/literal, it's treated as the sibling node to
	   * header/description (whether wrapped in Item.Content or not).
	   * - a props object, it forces the presence of Item.Content and passes those
	   * props to it. If you pass a content prop within that props object, it
	   * will be treated as the sibling node to header/description.
	   */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ListDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** A list item can disabled. */
	  disabled: _propTypes2.default.bool,
	
	  /** Shorthand for ListHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ListIcon. */
	  icon: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['image']), _lib.customPropTypes.itemShorthand]),
	
	  /** Shorthand for Image. */
	  image: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['icon']), _lib.customPropTypes.itemShorthand]),
	
	  /** A ListItem can be clicked */
	  onClick: _propTypes2.default.func,
	
	  /** A value for an ordered list. */
	  value: _propTypes2.default.string
	} : {};
	
	
	ListItem.create = (0, _lib.createShorthandFactory)(ListItem, function (content) {
	  return { content: content };
	});
	
	exports.default = ListItem;

/***/ },
/* 4514 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _List = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _List2.default;

/***/ },
/* 4515 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A loader alerts a user to wait for an activity to complete.
	 * @see Dimmer
	 */
	function Loader(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      disabled = props.disabled,
	      indeterminate = props.indeterminate,
	      inline = props.inline,
	      inverted = props.inverted,
	      size = props.size;
	
	
	  var classes = (0, _classnames2.default)('ui', size, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(indeterminate, 'indeterminate'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(children || content, 'text'), (0, _lib.useKeyOrValueAndKey)(inline, 'inline'), 'loader', className);
	  var rest = (0, _lib.getUnhandledProps)(Loader, props);
	  var ElementType = (0, _lib.getElementType)(Loader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	Loader.handledProps = ['active', 'as', 'children', 'className', 'content', 'disabled', 'indeterminate', 'inline', 'inverted', 'size'];
	Loader._meta = {
	  name: 'Loader',
	  type: _lib.META.TYPES.ELEMENT
	};
	
	Loader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A loader can be active or visible. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A loader can be disabled or hidden. */
	  disabled: _propTypes2.default.bool,
	
	  /** A loader can show it's unsure of how long a task will take. */
	  indeterminate: _propTypes2.default.bool,
	
	  /** Loaders can appear inline with content. */
	  inline: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['centered'])]),
	
	  /** Loaders can have their colors inverted. */
	  inverted: _propTypes2.default.bool,
	
	  /** Loaders can have different sizes. */
	  size: _propTypes2.default.oneOf(_lib.SUI.SIZES)
	} : {};
	
	exports.default = Loader;

/***/ },
/* 4516 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Loader = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Loader2.default;

/***/ },
/* 4517 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Rail = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Rail2 = _interopRequireDefault(_Rail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Rail2.default;

/***/ },
/* 4518 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Reveal = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Reveal2 = _interopRequireDefault(_Reveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Reveal2.default;

/***/ },
/* 4519 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Segment = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Segment2 = _interopRequireDefault(_Segment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Segment2.default;

/***/ },
/* 4520 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Step = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Step2.default;

/***/ },
/* 4521 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAutoControlledStateValue = undefined;
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _difference2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _difference3 = _interopRequireDefault(_difference2);
	
	var _isUndefined2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _startsWith2 = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _startsWith3 = _interopRequireDefault(_startsWith2);
	
	var _filter2 = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _isEmpty2 = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _keys2 = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _intersection2 = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _intersection3 = _interopRequireDefault(_intersection2);
	
	var _has2 = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _each2 = __webpack_require__(__webpack_module_template_argument_8__);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _invoke2 = __webpack_require__(__webpack_module_template_argument_9__);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDefaultPropName = function getDefaultPropName(prop) {
	  return 'default' + (prop[0].toUpperCase() + prop.slice(1));
	};
	
	/**
	 * Return the auto controlled state value for a give prop. The initial value is chosen in this order:
	 *  - regular props
	 *  - then, default props
	 *  - then, initial state
	 *  - then, `checked` defaults to false
	 *  - then, `value` defaults to '' or [] if props.multiple
	 *  - else, undefined
	 *
	 *  @param {string} propName A prop name
	 *  @param {object} [props] A props object
	 *  @param {object} [state] A state object
	 *  @param {boolean} [includeDefaults=false] Whether or not to heed the default props or initial state
	 */
	/* eslint-disable no-console */
	/**
	 * Why choose inheritance over a HOC?  Multiple advantages for this particular use case.
	 * In short, we need identical functionality to setState(), unless there is a prop defined
	 * for the state key.  Also:
	 *
	 * 1. Single Renders
	 *    Calling trySetState() in constructor(), componentWillMount(), or componentWillReceiveProps()
	 *    does not cause two renders. Consumers and tests do not have to wait two renders to get state.
	 *    See www.react.run/4kJFdKoxb/27 for an example of this issue.
	 *
	 * 2. Simple Testing
	 *    Using a HOC means you must either test the undecorated component or test through the decorator.
	 *    Testing the undecorated component means you must mock the decorator functionality.
	 *    Testing through the HOC means you can not simply shallow render your component.
	 *
	 * 3. Statics
	 *    HOC wrap instances, so statics are no longer accessible.  They can be hoisted, but this is more
	 *    looping over properties and storing references.  We rely heavily on statics for testing and sub
	 *    components.
	 *
	 * 4. Instance Methods
	 *    Some instance methods may be exposed to users via refs.  Again, these are lost with HOC unless
	 *    hoisted and exposed by the HOC.
	 */
	var getAutoControlledStateValue = exports.getAutoControlledStateValue = function getAutoControlledStateValue(propName, props, state) {
	  var includeDefaults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  // regular props
	  var propValue = props[propName];
	  if (propValue !== undefined) return propValue;
	
	  if (includeDefaults) {
	    // defaultProps
	    var defaultProp = props[getDefaultPropName(propName)];
	    if (defaultProp !== undefined) return defaultProp;
	
	    // initial state - state may be null or undefined
	    if (state) {
	      var initialState = state[propName];
	      if (initialState !== undefined) return initialState;
	    }
	  }
	
	  // React doesn't allow changing from uncontrolled to controlled components,
	  // default checked/value if they were not present.
	  if (propName === 'checked') return false;
	  if (propName === 'value') return props.multiple ? [] : '';
	
	  // otherwise, undefined
	};
	
	var AutoControlledComponent = function (_Component) {
	  (0, _inherits3.default)(AutoControlledComponent, _Component);
	
	  function AutoControlledComponent() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, AutoControlledComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoControlledComponent.__proto__ || Object.getPrototypeOf(AutoControlledComponent)).call.apply(_ref, [this].concat(args)));
	
	    _initialiseProps.call(_this);
	
	    var autoControlledProps = _this.constructor.autoControlledProps;
	
	    var state = (0, _invoke3.default)(_this, 'getInitialAutoControlledState', _this.props) || {};
	
	    if (false) {
	      var _this$constructor = _this.constructor,
	          defaultProps = _this$constructor.defaultProps,
	          name = _this$constructor.name,
	          propTypes = _this$constructor.propTypes;
	      // require static autoControlledProps
	
	      if (!autoControlledProps) {
	        console.error('Auto controlled ' + name + ' must specify a static autoControlledProps array.');
	      }
	
	      // require propTypes
	      (0, _each3.default)(autoControlledProps, function (prop) {
	        var defaultProp = getDefaultPropName(prop);
	        // regular prop
	        if (!(0, _has3.default)(propTypes, defaultProp)) {
	          console.error(name + ' is missing "' + defaultProp + '" propTypes validation for auto controlled prop "' + prop + '".');
	        }
	        // its default prop
	        if (!(0, _has3.default)(propTypes, prop)) {
	          console.error(name + ' is missing propTypes validation for auto controlled prop "' + prop + '".');
	        }
	      });
	
	      // prevent autoControlledProps in defaultProps
	      //
	      // When setting state, auto controlled props values always win (so the parent can manage them).
	      // It is not reasonable to decipher the difference between props from the parent and defaultProps.
	      // Allowing defaultProps results in trySetState always deferring to the defaultProp value.
	      // Auto controlled props also listed in defaultProps can never be updated.
	      //
	      // To set defaults for an AutoControlled prop, you can set the initial state in the
	      // constructor or by using an ES7 property initializer:
	      // https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers
	      var illegalDefaults = (0, _intersection3.default)(autoControlledProps, (0, _keys3.default)(defaultProps));
	      if (!(0, _isEmpty3.default)(illegalDefaults)) {
	        console.error(['Do not set defaultProps for autoControlledProps. You can set defaults by', 'setting state in the constructor or using an ES7 property initializer', '(https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers)', 'See ' + name + ' props: "' + illegalDefaults + '".'].join(' '));
	      }
	
	      // prevent listing defaultProps in autoControlledProps
	      //
	      // Default props are automatically handled.
	      // Listing defaults in autoControlledProps would result in allowing defaultDefaultValue props.
	      var illegalAutoControlled = (0, _filter3.default)(autoControlledProps, function (prop) {
	        return (0, _startsWith3.default)(prop, 'default');
	      });
	      if (!(0, _isEmpty3.default)(illegalAutoControlled)) {
	        console.error(['Do not add default props to autoControlledProps.', 'Default props are automatically handled.', 'See ' + name + ' autoControlledProps: "' + illegalAutoControlled + '".'].join(' '));
	      }
	    }
	
	    // Auto controlled props are copied to state.
	    // Set initial state by copying auto controlled props to state.
	    // Also look for the default prop for any auto controlled props (foo => defaultFoo)
	    // so we can set initial values from defaults.
	    var initialAutoControlledState = autoControlledProps.reduce(function (acc, prop) {
	      acc[prop] = getAutoControlledStateValue(prop, _this.props, state, true);
	
	      if (false) {
	        var defaultPropName = getDefaultPropName(prop);
	        var _name = _this.constructor.name;
	        // prevent defaultFoo={} along side foo={}
	
	        if (!(0, _isUndefined3.default)(_this.props[defaultPropName]) && !(0, _isUndefined3.default)(_this.props[prop])) {
	          console.error(_name + ' prop "' + prop + '" is auto controlled. Specify either ' + defaultPropName + ' or ' + prop + ', but not both.');
	        }
	      }
	
	      return acc;
	    }, {});
	
	    _this.state = (0, _extends3.default)({}, state, initialAutoControlledState);
	    return _this;
	  }
	
	  (0, _createClass3.default)(AutoControlledComponent, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var autoControlledProps = this.constructor.autoControlledProps;
	
	      // Solve the next state for autoControlledProps
	
	      var newState = autoControlledProps.reduce(function (acc, prop) {
	        var isNextUndefined = (0, _isUndefined3.default)(nextProps[prop]);
	        var propWasRemoved = !(0, _isUndefined3.default)(_this2.props[prop]) && isNextUndefined;
	
	        // if next is defined then use its value
	        if (!isNextUndefined) acc[prop] = nextProps[prop];
	
	        // reinitialize state for props just removed / set undefined
	        else if (propWasRemoved) acc[prop] = getAutoControlledStateValue(prop, nextProps);
	
	        return acc;
	      }, {});
	
	      if (Object.keys(newState).length > 0) this.setState(newState);
	    }
	
	    /**
	     * Safely attempt to set state for props that might be controlled by the user.
	     * Second argument is a state object that is always passed to setState.
	     * @param {object} maybeState State that corresponds to controlled props.
	     * @param {object} [state] Actual state, useful when you also need to setState.
	     */
	
	  }]);
	  return AutoControlledComponent;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.trySetState = function (maybeState, state) {
	    var autoControlledProps = _this3.constructor.autoControlledProps;
	
	    if (false) {
	      var name = _this3.constructor.name;
	      // warn about failed attempts to setState for keys not listed in autoControlledProps
	
	      var illegalKeys = (0, _difference3.default)((0, _keys3.default)(maybeState), autoControlledProps);
	      if (!(0, _isEmpty3.default)(illegalKeys)) {
	        console.error([name + ' called trySetState() with controlled props: "' + illegalKeys + '".', 'State will not be set.', 'Only props in static autoControlledProps will be set on state.'].join(' '));
	      }
	    }
	
	    var newState = Object.keys(maybeState).reduce(function (acc, prop) {
	      // ignore props defined by the parent
	      if (_this3.props[prop] !== undefined) return acc;
	
	      // ignore props not listed in auto controlled props
	      if (autoControlledProps.indexOf(prop) === -1) return acc;
	
	      acc[prop] = maybeState[prop];
	      return acc;
	    }, {});
	
	    if (state) newState = (0, _extends3.default)({}, newState, state);
	
	    if (Object.keys(newState).length > 0) _this3.setState(newState);
	  };
	};
	
	exports.default = AutoControlledComponent;

/***/ },
/* 4522 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPrivate = exports.isChild = exports.isParent = exports.isModule = exports.isView = exports.isElement = exports.isCollection = exports.isAddon = exports.isType = exports.isMeta = exports.TYPES = undefined;
	
	var _startsWith2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _startsWith3 = _interopRequireDefault(_startsWith2);
	
	var _has2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _eq2 = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _eq3 = _interopRequireDefault(_eq2);
	
	var _flow2 = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _curry2 = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _curry3 = _interopRequireDefault(_curry2);
	
	var _get2 = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _includes2 = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _values2 = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _values3 = _interopRequireDefault(_values2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  ADDON: 'addon',
	  BEHAVIOR: 'behavior',
	  COLLECTION: 'collection',
	  ELEMENT: 'element',
	  VIEW: 'view',
	  MODULE: 'module'
	};
	
	var TYPE_VALUES = (0, _values3.default)(TYPES);
	
	/**
	 * Determine if an object qualifies as a META object.
	 * It must have the required keys and valid values.
	 * @private
	 * @param {Object} _meta A proposed component _meta object.
	 * @returns {Boolean}
	 */
	var isMeta = exports.isMeta = function isMeta(_meta) {
	  return (0, _includes3.default)((0, _get3.default)('type', _meta), TYPE_VALUES);
	};
	
	/**
	 * Extract a component's _meta object and optional key.
	 * Handles literal _meta objects, classes with _meta, objects with _meta
	 * @private
	 * @param {function|object} metaArg A class, a component instance, or meta object..
	 * @returns {object|string|undefined}
	 */
	var getMeta = function getMeta(metaArg) {
	  // literal
	  if (isMeta(metaArg)) return metaArg;
	
	  // from prop
	  else if (isMeta((0, _get3.default)('_meta', metaArg))) return metaArg._meta;
	
	    // from class
	    else if (isMeta((0, _get3.default)('constructor._meta', metaArg))) return metaArg.constructor._meta;
	};
	
	var metaHasKeyValue = (0, _curry3.default)(function (key, val, metaArg) {
	  return (0, _flow3.default)(getMeta, (0, _get3.default)(key), (0, _eq3.default)(val))(metaArg);
	});
	var isType = exports.isType = metaHasKeyValue('type');
	
	// ----------------------------------------
	// Export
	// ----------------------------------------
	
	// type
	var isAddon = exports.isAddon = isType(TYPES.ADDON);
	var isCollection = exports.isCollection = isType(TYPES.COLLECTION);
	var isElement = exports.isElement = isType(TYPES.ELEMENT);
	var isView = exports.isView = isType(TYPES.VIEW);
	var isModule = exports.isModule = isType(TYPES.MODULE);
	
	// parent
	var isParent = exports.isParent = (0, _flow3.default)(getMeta, (0, _has3.default)('parent'), (0, _eq3.default)(false));
	var isChild = exports.isChild = (0, _flow3.default)(getMeta, (0, _has3.default)('parent'));
	
	// other
	var isPrivate = exports.isPrivate = (0, _flow3.default)(getMeta, (0, _get3.default)('name'), (0, _startsWith3.default)('_'));

/***/ },
/* 4523 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ALL_ICONS_IN_ALL_CONTEXTS = exports.COMPONENT_CONTEXT_SPECIFIC_ICONS = exports.ICONS_AND_ALIASES = exports.ICON_ALIASES = exports.ICONS = exports.NETWORKS_AND_WEBSITE_ICONS = exports.PAYMENT_OPTIONS_ICONS = exports.CURRENCY_ICONS = exports.TEXT_EDITOR_ICONS = exports.TABLES_ICONS = exports.MAP_LOCATIONS_TRANSPORTATION_ICONS = exports.AUDIO_ICONS = exports.RATING_ICONS = exports.TECHNOLOGIES_ICONS = exports.FILE_SYSTEM_ICONS = exports.COMPUTER_ICONS = exports.MOBILE_ICONS = exports.POINTERS_ICONS = exports.MEDIA_ICONS = exports.ITEM_SELECTION_ICONS = exports.SHAPES_ICONS = exports.LITERAL_OBJECTS_ICONS = exports.VIEW_ADJUSTMENT_ICONS = exports.ACCESSIBILITY_ICONS = exports.GENDER_SEXUALITY_ICONS = exports.USERS_ICONS = exports.MESSAGES_ICONS = exports.USER_ACTIONS_ICONS = exports.WEB_CONTENT_ICONS = exports.TRANSITIONS = exports.STATIC_TRANSITIONS = exports.DIRECTIONAL_TRANSITIONS = exports.WIDTHS = exports.VISIBILITY = exports.VERTICAL_ALIGNMENTS = exports.TEXT_ALIGNMENTS = exports.SIZES = exports.FLOATS = exports.COLORS = undefined;
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _values2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _values3 = _interopRequireDefault(_values2);
	
	var _keys2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _numberToWord = __webpack_require__(__webpack_module_template_argument_2__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COLORS = exports.COLORS = ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'];
	var FLOATS = exports.FLOATS = ['left', 'right'];
	var SIZES = exports.SIZES = ['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive'];
	var TEXT_ALIGNMENTS = exports.TEXT_ALIGNMENTS = ['left', 'center', 'right', 'justified'];
	var VERTICAL_ALIGNMENTS = exports.VERTICAL_ALIGNMENTS = ['bottom', 'middle', 'top'];
	
	var VISIBILITY = exports.VISIBILITY = ['mobile', 'tablet', 'computer', 'large screen', 'widescreen'];
	
	var WIDTHS = exports.WIDTHS = [].concat((0, _toConsumableArray3.default)((0, _keys3.default)(_numberToWord.numberToWordMap)), (0, _toConsumableArray3.default)((0, _keys3.default)(_numberToWord.numberToWordMap).map(Number)), (0, _toConsumableArray3.default)((0, _values3.default)(_numberToWord.numberToWordMap)));
	
	var DIRECTIONAL_TRANSITIONS = exports.DIRECTIONAL_TRANSITIONS = ['scale', 'fade', 'fade up', 'fade down', 'fade left', 'fade right', 'horizontal flip', 'vertical flip', 'drop', 'fly left', 'fly right', 'fly up', 'fly down', 'swing left', 'swing right', 'swing up', 'swing down', 'browse', 'browse right', 'slide down', 'slide up', 'slide right'];
	var STATIC_TRANSITIONS = exports.STATIC_TRANSITIONS = ['jiggle', 'flash', 'shake', 'pulse', 'tada', 'bounce'];
	var TRANSITIONS = exports.TRANSITIONS = [].concat(DIRECTIONAL_TRANSITIONS, STATIC_TRANSITIONS);
	
	// Generated from:
	// https://github.com/Semantic-Org/Semantic-UI/blob/master/dist/components/icon.css
	var WEB_CONTENT_ICONS = exports.WEB_CONTENT_ICONS = ['search', 'mail outline', 'signal', 'setting', 'home', 'inbox', 'browser', 'tag', 'tags', 'image', 'calendar', 'comment', 'shop', 'comments', 'external', 'privacy', 'settings', 'comments', 'external', 'trophy', 'payment', 'feed', 'alarm outline', 'tasks', 'cloud', 'lab', 'mail', 'dashboard', 'comment outline', 'comments outline', 'sitemap', 'idea', 'alarm', 'terminal', 'code', 'protect', 'calendar outline', 'ticket', 'external square', 'bug', 'mail square', 'history', 'options', 'text telephone', 'find', 'wifi', 'alarm mute', 'alarm mute outline', 'copyright', 'at', 'eyedropper', 'paint brush', 'heartbeat', 'mouse pointer', 'hourglass empty', 'hourglass start', 'hourglass half', 'hourglass end', 'hourglass full', 'hand pointer', 'trademark', 'registered', 'creative commons', 'add to calendar', 'remove from calendar', 'delete calendar', 'checked calendar', 'industry', 'shopping bag', 'shopping basket', 'hashtag', 'percent', 'address book', 'address book outline', 'address card', 'address card outline', 'id badge', 'id card', 'id card outline', 'podcast', 'window close', 'window close outline', 'window maximize', 'window minimize', 'window restore'];
	var USER_ACTIONS_ICONS = exports.USER_ACTIONS_ICONS = ['wait', 'download', 'repeat', 'refresh', 'lock', 'bookmark', 'print', 'write', 'adjust', 'theme', 'edit', 'external share', 'ban', 'mail forward', 'share', 'expand', 'compress', 'unhide', 'hide', 'random', 'retweet', 'sign out', 'pin', 'sign in', 'upload', 'call', 'remove bookmark', 'call square', 'unlock', 'configure', 'filter', 'wizard', 'undo', 'exchange', 'cloud download', 'cloud upload', 'reply', 'reply all', 'erase', 'unlock alternate', 'write square', 'share square', 'archive', 'translate', 'recycle', 'send', 'send outline', 'share alternate', 'share alternate square', 'add to cart', 'in cart', 'add user', 'remove user', 'object group', 'object ungroup', 'clone', 'talk', 'talk outline'];
	var MESSAGES_ICONS = exports.MESSAGES_ICONS = ['help circle', 'info circle', 'warning circle', 'warning sign', 'announcement', 'help', 'info', 'warning', 'birthday', 'help circle outline'];
	var USERS_ICONS = exports.USERS_ICONS = ['user', 'users', 'doctor', 'handicap', 'student', 'child', 'spy', 'user circle', 'user circle outline', 'user outline'];
	var GENDER_SEXUALITY_ICONS = exports.GENDER_SEXUALITY_ICONS = ['female', 'male', 'woman', 'man', 'non binary transgender', 'intergender', 'transgender', 'lesbian', 'gay', 'heterosexual', 'other gender', 'other gender vertical', 'other gender horizontal', 'neuter', 'genderless'];
	var ACCESSIBILITY_ICONS = exports.ACCESSIBILITY_ICONS = ['universal access', 'wheelchair', 'blind', 'audio description', 'volume control phone', 'braille', 'asl', 'assistive listening systems', 'deafness', 'sign language', 'low vision'];
	var VIEW_ADJUSTMENT_ICONS = exports.VIEW_ADJUSTMENT_ICONS = ['block layout', 'grid layout', 'list layout', 'zoom', 'zoom out', 'resize vertical', 'resize horizontal', 'maximize', 'crop'];
	var LITERAL_OBJECTS_ICONS = exports.LITERAL_OBJECTS_ICONS = ['cocktail', 'road', 'flag', 'book', 'gift', 'leaf', 'fire', 'plane', 'magnet', 'lemon', 'world', 'travel', 'shipping', 'money', 'legal', 'lightning', 'umbrella', 'treatment', 'suitcase', 'bar', 'flag outline', 'flag checkered', 'puzzle', 'fire extinguisher', 'rocket', 'anchor', 'bullseye', 'sun', 'moon', 'fax', 'life ring', 'bomb', 'soccer', 'calculator', 'diamond', 'sticky note', 'sticky note outline', 'law', 'hand peace', 'hand rock', 'hand paper', 'hand scissors', 'hand lizard', 'hand spock', 'tv', 'thermometer empty', 'thermometer full', 'thermometer half', 'thermometer quarter', 'thermometer three quarters', 'bath', 'snowflake outline'];
	var SHAPES_ICONS = exports.SHAPES_ICONS = ['crosshairs', 'asterisk', 'square outline', 'certificate', 'square', 'quote left', 'quote right', 'spinner', 'circle', 'ellipsis horizontal', 'ellipsis vertical', 'cube', 'cubes', 'circle notched', 'circle thin'];
	var ITEM_SELECTION_ICONS = exports.ITEM_SELECTION_ICONS = ['checkmark', 'remove', 'checkmark box', 'move', 'add circle', 'minus circle', 'remove circle', 'check circle', 'remove circle outline', 'check circle outline', 'plus', 'minus', 'add square', 'radio', 'minus square', 'minus square outline', 'check square', 'selected radio', 'plus square outline', 'toggle off', 'toggle on'];
	var MEDIA_ICONS = exports.MEDIA_ICONS = ['film', 'sound', 'photo', 'bar chart', 'camera retro', 'newspaper', 'area chart', 'pie chart', 'line chart'];
	var POINTERS_ICONS = exports.POINTERS_ICONS = ['arrow circle outline down', 'arrow circle outline up', 'chevron left', 'chevron right', 'arrow left', 'arrow right', 'arrow up', 'arrow down', 'chevron up', 'chevron down', 'pointing right', 'pointing left', 'pointing up', 'pointing down', 'arrow circle left', 'arrow circle right', 'arrow circle up', 'arrow circle down', 'caret down', 'caret up', 'caret left', 'caret right', 'angle double left', 'angle double right', 'angle double up', 'angle double down', 'angle left', 'angle right', 'angle up', 'angle down', 'chevron circle left', 'chevron circle right', 'chevron circle up', 'chevron circle down', 'toggle down', 'toggle up', 'toggle right', 'long arrow down', 'long arrow up', 'long arrow left', 'long arrow right', 'arrow circle outline right', 'arrow circle outline left', 'toggle left'];
	var MOBILE_ICONS = exports.MOBILE_ICONS = ['tablet', 'mobile', 'battery full', 'battery high', 'battery medium', 'battery low', 'battery empty'];
	var COMPUTER_ICONS = exports.COMPUTER_ICONS = ['power', 'trash outline', 'disk outline', 'desktop', 'laptop', 'game', 'keyboard', 'plug'];
	var FILE_SYSTEM_ICONS = exports.FILE_SYSTEM_ICONS = ['trash', 'file outline', 'folder', 'folder open', 'file text outline', 'folder outline', 'folder open outline', 'level up', 'level down', 'file', 'file text', 'file pdf outline', 'file word outline', 'file excel outline', 'file powerpoint outline', 'file image outline', 'file archive outline', 'file audio outline', 'file video outline', 'file code outline'];
	var TECHNOLOGIES_ICONS = exports.TECHNOLOGIES_ICONS = ['qrcode', 'barcode', 'rss', 'fork', 'html5', 'css3', 'rss square', 'openid', 'database', 'server', 'usb', 'bluetooth', 'bluetooth alternative', 'microchip'];
	var RATING_ICONS = exports.RATING_ICONS = ['heart', 'star', 'empty star', 'thumbs outline up', 'thumbs outline down', 'star half', 'empty heart', 'smile', 'frown', 'meh', 'star half empty', 'thumbs up', 'thumbs down'];
	var AUDIO_ICONS = exports.AUDIO_ICONS = ['music', 'video play outline', 'volume off', 'volume down', 'volume up', 'record', 'step backward', 'fast backward', 'backward', 'play', 'pause', 'stop', 'forward', 'fast forward', 'step forward', 'eject', 'unmute', 'mute', 'video play', 'closed captioning', 'pause circle', 'pause circle outline', 'stop circle', 'stop circle outline'];
	var MAP_LOCATIONS_TRANSPORTATION_ICONS = exports.MAP_LOCATIONS_TRANSPORTATION_ICONS = ['marker', 'coffee', 'food', 'building outline', 'hospital', 'emergency', 'first aid', 'military', 'h', 'location arrow', 'compass', 'space shuttle', 'university', 'building', 'paw', 'spoon', 'car', 'taxi', 'tree', 'bicycle', 'bus', 'ship', 'motorcycle', 'street view', 'hotel', 'train', 'subway', 'map pin', 'map signs', 'map outline', 'map'];
	var TABLES_ICONS = exports.TABLES_ICONS = ['table', 'columns', 'sort', 'sort descending', 'sort ascending', 'sort alphabet ascending', 'sort alphabet descending', 'sort content ascending', 'sort content descending', 'sort numeric ascending', 'sort numeric descending'];
	var TEXT_EDITOR_ICONS = exports.TEXT_EDITOR_ICONS = ['font', 'bold', 'italic', 'text height', 'text width', 'align left', 'align center', 'align right', 'align justify', 'list', 'outdent', 'indent', 'linkify', 'cut', 'copy', 'attach', 'save', 'content', 'unordered list', 'ordered list', 'strikethrough', 'underline', 'paste', 'unlinkify', 'superscript', 'subscript', 'header', 'paragraph', 'text cursor'];
	var CURRENCY_ICONS = exports.CURRENCY_ICONS = ['euro', 'pound', 'dollar', 'rupee', 'yen', 'ruble', 'won', 'bitcoin', 'lira', 'shekel'];
	var PAYMENT_OPTIONS_ICONS = exports.PAYMENT_OPTIONS_ICONS = ['paypal', 'google wallet', 'visa', 'mastercard', 'discover', 'american express', 'paypal card', 'stripe', 'japan credit bureau', 'diners club', 'credit card alternative'];
	var NETWORKS_AND_WEBSITE_ICONS = exports.NETWORKS_AND_WEBSITE_ICONS = ['twitter square', 'facebook square', 'linkedin square', 'github square', 'twitter', 'facebook f', 'github', 'pinterest', 'pinterest square', 'google plus square', 'google plus', 'linkedin', 'github alternate', 'maxcdn', 'youtube square', 'youtube', 'xing', 'xing square', 'youtube play', 'dropbox', 'stack overflow', 'instagram', 'flickr', 'adn', 'bitbucket', 'bitbucket square', 'tumblr', 'tumblr square', 'apple', 'windows', 'android', 'linux', 'dribble', 'skype', 'foursquare', 'trello', 'gittip', 'vk', 'weibo', 'renren', 'pagelines', 'stack exchange', 'vimeo square', 'slack', 'wordpress', 'yahoo', 'google', 'reddit', 'reddit square', 'stumbleupon circle', 'stumbleupon', 'delicious', 'digg', 'pied piper', 'pied piper alternate', 'drupal', 'joomla', 'behance', 'behance square', 'steam', 'steam square', 'spotify', 'deviantart', 'soundcloud', 'vine', 'codepen', 'jsfiddle', 'rebel', 'empire', 'git square', 'git', 'hacker news', 'tencent weibo', 'qq', 'wechat', 'slideshare', 'twitch', 'yelp', 'lastfm', 'lastfm square', 'ioxhost', 'angellist', 'meanpath', 'buysellads', 'connectdevelop', 'dashcube', 'forumbee', 'leanpub', 'sellsy', 'shirtsinbulk', 'simplybuilt', 'skyatlas', 'facebook', 'pinterest', 'whatsapp', 'viacoin', 'medium', 'y combinator', 'optinmonster', 'opencart', 'expeditedssl', 'gg', 'gg circle', 'tripadvisor', 'odnoklassniki', 'odnoklassniki square', 'pocket', 'wikipedia', 'safari', 'chrome', 'firefox', 'opera', 'internet explorer', 'contao', '500px', 'amazon', 'houzz', 'vimeo', 'black tie', 'fonticons', 'reddit alien', 'microsoft edge', 'codiepie', 'modx', 'fort awesome', 'product hunt', 'mixcloud', 'scribd', 'gitlab', 'wpbeginner', 'wpforms', 'envira gallery', 'glide', 'glide g', 'viadeo', 'viadeo square', 'snapchat', 'snapchat ghost', 'snapchat square', 'pied piper hat', 'first order', 'yoast', 'themeisle', 'google plus circle', 'font awesome', 'bandcamp', 'eercast', 'etsy', 'free code camp', 'grav', 'imdb', 'linode', 'meetup', 'quora', 'ravelry', 'superpowers', 'telegram', 'wpexplorer'];
	var ICONS = exports.ICONS = [].concat(WEB_CONTENT_ICONS, USER_ACTIONS_ICONS, MESSAGES_ICONS, USERS_ICONS, GENDER_SEXUALITY_ICONS, ACCESSIBILITY_ICONS, VIEW_ADJUSTMENT_ICONS, LITERAL_OBJECTS_ICONS, SHAPES_ICONS, ITEM_SELECTION_ICONS, MEDIA_ICONS, POINTERS_ICONS, MOBILE_ICONS, COMPUTER_ICONS, FILE_SYSTEM_ICONS, TECHNOLOGIES_ICONS, RATING_ICONS, AUDIO_ICONS, MAP_LOCATIONS_TRANSPORTATION_ICONS, TABLES_ICONS, TEXT_EDITOR_ICONS, CURRENCY_ICONS, PAYMENT_OPTIONS_ICONS, NETWORKS_AND_WEBSITE_ICONS);
	var ICON_ALIASES = exports.ICON_ALIASES = ['like', 'favorite', 'video', 'check', 'close', 'cancel', 'delete', 'x', 'zoom in', 'magnify', 'shutdown', 'clock', 'time', 'play circle outline', 'headphone', 'camera', 'video camera', 'picture', 'pencil', 'compose', 'point', 'tint', 'signup', 'plus circle', 'question circle', 'dont', 'minimize', 'add', 'exclamation circle', 'attention', 'eye', 'exclamation triangle', 'shuffle', 'chat', 'cart', 'shopping cart', 'bar graph', 'key', 'cogs', 'discussions', 'like outline', 'dislike outline', 'heart outline', 'log out', 'thumb tack', 'winner', 'phone', 'bookmark outline', 'phone square', 'credit card', 'hdd outline', 'bullhorn', 'bell outline', 'hand outline right', 'hand outline left', 'hand outline up', 'hand outline down', 'globe', 'wrench', 'briefcase', 'group', 'linkify', 'chain', 'flask', 'sidebar', 'bars', 'list ul', 'list ol', 'numbered list', 'magic', 'truck', 'currency', 'triangle down', 'dropdown', 'triangle up', 'triangle left', 'triangle right', 'envelope', 'conversation', 'rain', 'clipboard', 'lightbulb', 'bell', 'ambulance', 'medkit', 'fighter jet', 'beer', 'plus square', 'computer', 'circle outline', 'gamepad', 'star half full', 'broken chain', 'question', 'exclamation', 'eraser', 'microphone', 'microphone slash', 'shield', 'target', 'play circle', 'pencil square', 'eur', 'gbp', 'usd', 'inr', 'cny', 'rmb', 'jpy', 'rouble', 'rub', 'krw', 'btc', 'gratipay', 'zip', 'dot circle outline', 'try', 'graduation', 'circle outline', 'sliders', 'weixin', 'tty', 'teletype', 'binoculars', 'power cord', 'wifi', 'visa card', 'mastercard card', 'discover card', 'amex', 'american express card', 'stripe card', 'bell slash', 'bell slash outline', 'area graph', 'pie graph', 'line graph', 'cc', 'sheqel', 'ils', 'plus cart', 'arrow down cart', 'detective', 'venus', 'mars', 'mercury', 'intersex', 'venus double', 'female homosexual', 'mars double', 'male homosexual', 'venus mars', 'mars stroke', 'mars alternate', 'mars vertical', 'mars stroke vertical', 'mars horizontal', 'mars stroke horizontal', 'asexual', 'facebook official', 'user plus', 'user times', 'user close', 'user cancel', 'user delete', 'user x', 'bed', 'yc', 'ycombinator', 'battery four', 'battery three', 'battery three quarters', 'battery two', 'battery half', 'battery one', 'battery quarter', 'battery zero', 'i cursor', 'jcb', 'japan credit bureau card', 'diners club card', 'balance', 'hourglass outline', 'hourglass zero', 'hourglass one', 'hourglass two', 'hourglass three', 'hourglass four', 'grab', 'hand victory', 'tm', 'r circle', 'television', 'five hundred pixels', 'calendar plus', 'calendar minus', 'calendar times', 'calendar check', 'factory', 'commenting', 'commenting outline', 'edge', 'ms edge', 'wordpress beginner', 'wordpress forms', 'envira', 'question circle outline', 'assistive listening devices', 'als', 'ald', 'asl interpreting', 'deaf', 'american sign language interpreting', 'hard of hearing', 'signing', 'new pied piper', 'theme isle', 'google plus official', 'fa', 'bathtub', 'drivers license', 'drivers license outline', 's15', 'thermometer', 'times rectangle', 'times rectangle outline', 'vcard', 'vcard outline'];
	var ICONS_AND_ALIASES = exports.ICONS_AND_ALIASES = [].concat((0, _toConsumableArray3.default)(ICONS), ICON_ALIASES);
	
	// Some icon names are not part of icons.css.
	// These are only valid as children of other components.
	// Their CSS rules are defined by a specific component's CSS.
	// We don't want to show name warnings for those usages so we add them as valid names here.
	var COMPONENT_CONTEXT_SPECIFIC_ICONS = exports.COMPONENT_CONTEXT_SPECIFIC_ICONS = ['left dropdown'];
	var ALL_ICONS_IN_ALL_CONTEXTS = exports.ALL_ICONS_IN_ALL_CONTEXTS = [].concat((0, _toConsumableArray3.default)(ICONS_AND_ALIASES), COMPONENT_CONTEXT_SPECIFIC_ICONS);

/***/ },
/* 4524 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeChildMappings = exports.getChildMapping = undefined;
	
	var _slicedToArray2 = __webpack_require__(130);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _has2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _keys2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _forEach2 = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	var _filter2 = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _keyBy2 = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _keyBy3 = _interopRequireDefault(_keyBy2);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {object} children Element's children
	 * @return {object} Mapping of key to child
	 */
	var getChildMapping = exports.getChildMapping = function getChildMapping(children) {
	  return (0, _keyBy3.default)((0, _filter3.default)(_react.Children.toArray(children), _react.isValidElement), 'key');
	};
	
	var getPendingKeys = function getPendingKeys(prev, next) {
	  var nextKeysPending = {};
	  var pendingKeys = [];
	
	  (0, _forEach3.default)((0, _keys3.default)(prev), function (prevKey) {
	    if (!(0, _has3.default)(next, prevKey)) {
	      pendingKeys.push(prevKey);
	      return;
	    }
	
	    if (pendingKeys.length) {
	      nextKeysPending[prevKey] = pendingKeys;
	      pendingKeys = [];
	    }
	  });
	
	  return [nextKeysPending, pendingKeys];
	};
	
	var getValue = function getValue(key, prev, next) {
	  return (0, _has3.default)(next, key) ? next[key] : prev[key];
	};
	
	/**
	 * When you're adding or removing children some may be added or removed in the same render pass. We want to show *both*
	 * since we want to simultaneously animate elements in and out. This function takes a previous set of keys and a new set
	 * of keys and merges them with its best guess of the correct ordering.
	 *
	 * @param {object} prev Prev children as returned from `getChildMapping()`
	 * @param {object} next Next children as returned from `getChildMapping()`
	 * @return {object} A key set that contains all keys in `prev` and all keys in `next` in a reasonable order
	 */
	var mergeChildMappings = exports.mergeChildMappings = function mergeChildMappings() {
	  var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var childMapping = {};
	
	  var _getPendingKeys = getPendingKeys(prev, next),
	      _getPendingKeys2 = (0, _slicedToArray3.default)(_getPendingKeys, 2),
	      nextKeysPending = _getPendingKeys2[0],
	      pendingKeys = _getPendingKeys2[1];
	
	  (0, _forEach3.default)((0, _keys3.default)(next), function (nextKey) {
	    if ((0, _has3.default)(nextKeysPending, nextKey)) {
	      (0, _forEach3.default)(nextKeysPending[nextKey], function (pendingKey) {
	        childMapping[pendingKey] = getValue(pendingKey, prev, next);
	      });
	    }
	
	    childMapping[nextKey] = getValue(nextKey, prev, next);
	  });
	
	  (0, _forEach3.default)(pendingKeys, function (pendingKey) {
	    childMapping[pendingKey] = getValue(pendingKey, prev, next);
	  });
	
	  return childMapping;
	};

/***/ },
/* 4525 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isNil = exports.findByType = exports.someByType = undefined;
	
	var _find2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _some2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Determine if child by type exists in children.
	 * @param {Object} children The children prop of a component.
	 * @param {string|Function} type An html tag name string or React component.
	 * @returns {Boolean}
	 */
	var someByType = exports.someByType = function someByType(children, type) {
	  return (0, _some3.default)(_react.Children.toArray(children), { type: type });
	};
	
	/**
	 * Find child by type.
	 * @param {Object} children The children prop of a component.
	 * @param {string|Function} type An html tag name string or React component.
	 * @returns {undefined|Object}
	 */
	var findByType = exports.findByType = function findByType(children, type) {
	  return (0, _find3.default)(_react.Children.toArray(children), { type: type });
	};
	
	/**
	 * Tests if children are nil in React and Preact.
	 * @param {Object} children The children prop of a component.
	 * @returns {Boolean}
	 */
	var isNil = exports.isNil = function isNil(children) {
	  return children === null || children === undefined || Array.isArray(children) && children.length === 0;
	};

/***/ },
/* 4526 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _set2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _set3 = _interopRequireDefault(_set2);
	
	var _get2 = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _uniq2 = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _uniq3 = _interopRequireDefault(_uniq2);
	
	var _isEmpty2 = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _some2 = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _has2 = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _isArray2 = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _last2 = __webpack_require__(__webpack_module_template_argument_8__);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _forEach2 = __webpack_require__(__webpack_module_template_argument_9__);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventTarget = function EventTarget(target) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, EventTarget);
	  this._handlers = {};
	  this._pools = {};
	
	  this._emit = function (name) {
	    return function (event) {
	      (0, _forEach3.default)(_this._pools, function (pool, poolName) {
	        var handlers = pool[name];
	
	
	        if (!handlers) return;
	        if (poolName === 'default') {
	          (0, _forEach3.default)(handlers, function (handler) {
	            return handler(event);
	          });
	          return;
	        }
	        (0, _last3.default)(handlers)(event);
	      });
	    };
	  };
	
	  this._normalize = function (handlers) {
	    return (0, _isArray3.default)(handlers) ? handlers : [handlers];
	  };
	
	  this._listen = function (name) {
	    if ((0, _has3.default)(_this._handlers, name)) return;
	    var handler = _this._emit(name);
	
	    _this.target.addEventListener(name, handler);
	    _this._handlers[name] = handler;
	  };
	
	  this._unlisten = function (name) {
	    if ((0, _some3.default)(_this._pools, name)) return;
	    var handler = _this._handlers[name];
	
	
	    _this.target.removeEventListener(name, handler);
	    delete _this._handlers[name];
	  };
	
	  this.empty = function () {
	    return (0, _isEmpty3.default)(_this._handlers);
	  };
	
	  this.sub = function (name, handlers) {
	    var pool = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
	
	    var events = (0, _uniq3.default)([].concat((0, _toConsumableArray3.default)((0, _get3.default)(_this._pools, pool + '.' + name, [])), (0, _toConsumableArray3.default)(_this._normalize(handlers))));
	
	    _this._listen(name);
	    (0, _set3.default)(_this._pools, pool + '.' + name, events);
	  };
	
	  this.unsub = function (name, handlers) {
	    var pool = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
	
	    var events = _without3.default.apply(undefined, [(0, _get3.default)(_this._pools, pool + '.' + name, [])].concat((0, _toConsumableArray3.default)(_this._normalize(handlers))));
	
	    if (events.length > 0) {
	      (0, _set3.default)(_this._pools, pool + '.' + name, events);
	      return;
	    }
	
	    (0, _set3.default)(_this._pools, pool + '.' + name, undefined);
	    _this._unlisten(name);
	  };
	
	  this.target = target;
	}
	
	// ------------------------------------
	// Utils
	// ------------------------------------
	
	// ------------------------------------
	// Listeners handling
	// ------------------------------------
	
	// ------------------------------------
	// Pub/sub
	// ------------------------------------
	
	;
	
	exports.default = EventTarget;

/***/ },
/* 4527 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _eventStack = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _eventStack2 = _interopRequireDefault(_eventStack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _eventStack2.default;

/***/ },
/* 4528 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createHTMLParagraph = exports.createHTMLLabel = exports.createHTMLInput = exports.createHTMLImage = exports.createHTMLIframe = exports.createHTMLDivision = undefined;
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(131);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _uniq2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _uniq3 = _interopRequireDefault(_uniq2);
	
	var _isFunction2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isPlainObject2 = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isNumber2 = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _isString2 = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _isBoolean2 = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _isBoolean3 = _interopRequireDefault(_isBoolean2);
	
	var _isNil2 = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	exports.createShorthand = createShorthand;
	exports.createShorthandFactory = createShorthandFactory;
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// ============================================================
	// Factories
	// ============================================================
	
	/**
	 * A more robust React.createElement. It can create elements from primitive values.
	 *
	 * @param {function|string} Component A ReactClass or string
	 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
	 * @param {string|object|function} val The value to create a ReactElement from
	 * @param {Object} [options={}]
	 * @param {object} [options.defaultProps={}] Default props object
	 * @param {object|function} [options.overrideProps={}] Override props object or function (called with regular props)
	 * @returns {object|null}
	 */
	function createShorthand(Component, mapValueToProps, val) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  if (typeof Component !== 'function' && typeof Component !== 'string') {
	    throw new Error('createShorthandFactory() Component must be a string or function.');
	  }
	  // short circuit noop values
	  if ((0, _isNil3.default)(val) || (0, _isBoolean3.default)(val)) return null;
	
	  var valIsString = (0, _isString3.default)(val);
	  var valIsNumber = (0, _isNumber3.default)(val);
	
	  var isReactElement = (0, _react.isValidElement)(val);
	  var isPropsObject = (0, _isPlainObject3.default)(val);
	  var isPrimitiveValue = valIsString || valIsNumber || (0, _isArray3.default)(val);
	
	  // unhandled type return null
	  /* eslint-disable no-console */
	  if (!isReactElement && !isPropsObject && !isPrimitiveValue) {
	    if (false) {
	      console.error(['Shorthand value must be a string|number|array|object|ReactElement.', ' Use null|undefined|boolean for none', ' Received ' + (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) + '.'].join(''));
	    }
	    return null;
	  }
	  /* eslint-enable no-console */
	
	  // ----------------------------------------
	  // Build up props
	  // ----------------------------------------
	  var _options$defaultProps = options.defaultProps,
	      defaultProps = _options$defaultProps === undefined ? {} : _options$defaultProps;
	
	  // User's props
	
	  var usersProps = isReactElement && val.props || isPropsObject && val || isPrimitiveValue && mapValueToProps(val);
	
	  // Override props
	  var _options$overrideProp = options.overrideProps,
	      overrideProps = _options$overrideProp === undefined ? {} : _options$overrideProp;
	
	  overrideProps = (0, _isFunction3.default)(overrideProps) ? overrideProps((0, _extends3.default)({}, defaultProps, usersProps)) : overrideProps;
	
	  // Merge props
	  /* eslint-disable react/prop-types */
	  var props = (0, _extends3.default)({}, defaultProps, usersProps, overrideProps);
	
	  // Merge className
	  if (defaultProps.className || overrideProps.className || usersProps.className) {
	    var mergedClassesNames = (0, _classnames2.default)(defaultProps.className, overrideProps.className, usersProps.className);
	    props.className = (0, _uniq3.default)(mergedClassesNames.split(' ')).join(' ');
	  }
	
	  // Merge style
	  if (defaultProps.style || overrideProps.style || usersProps.style) {
	    props.style = (0, _extends3.default)({}, defaultProps.style, usersProps.style, overrideProps.style);
	  }
	
	  // ----------------------------------------
	  // Get key
	  // ----------------------------------------
	
	  // Use key, childKey, or generate key
	  if ((0, _isNil3.default)(props.key)) {
	    var childKey = props.childKey;
	
	
	    if (!(0, _isNil3.default)(childKey)) {
	      // apply and consume the childKey
	      props.key = typeof childKey === 'function' ? childKey(props) : childKey;
	      delete props.childKey;
	    } else if (valIsString || valIsNumber) {
	      // use string/number shorthand values as the key
	      props.key = val;
	    }
	  }
	  /* eslint-enable react/prop-types */
	
	  // ----------------------------------------
	  // Create Element
	  // ----------------------------------------
	
	  // Clone ReactElements
	  if (isReactElement) return (0, _react.cloneElement)(val, props);
	
	  // Create ReactElements from built up props
	  if (isPrimitiveValue || isPropsObject) return _react2.default.createElement(Component, props);
	}
	
	// ============================================================
	// Factory Creators
	// ============================================================
	
	/**
	 * Creates a `createShorthand` function that is waiting for a value and options.
	 *
	 * @param {function|string} Component A ReactClass or string
	 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
	 * @returns {function} A shorthand factory function waiting for `val` and `defaultProps`.
	 */
	createShorthand.handledProps = [];
	function createShorthandFactory(Component, mapValueToProps) {
	  if (typeof Component !== 'function' && typeof Component !== 'string') {
	    throw new Error('createShorthandFactory() Component must be a string or function.');
	  }
	
	  return function (val, options) {
	    return createShorthand(Component, mapValueToProps, val, options);
	  };
	}
	
	// ============================================================
	// HTML Factories
	// ============================================================
	var createHTMLDivision = exports.createHTMLDivision = createShorthandFactory('div', function (val) {
	  return { children: val };
	});
	var createHTMLIframe = exports.createHTMLIframe = createShorthandFactory('iframe', function (src) {
	  return { src: src };
	});
	var createHTMLImage = exports.createHTMLImage = createShorthandFactory('img', function (val) {
	  return { src: val };
	});
	var createHTMLInput = exports.createHTMLInput = createShorthandFactory('input', function (val) {
	  return { type: val };
	});
	var createHTMLLabel = exports.createHTMLLabel = createShorthandFactory('label', function (val) {
	  return { children: val };
	});
	var createHTMLParagraph = exports.createHTMLParagraph = createShorthandFactory('p', function (val) {
	  return { children: val };
	});

/***/ },
/* 4529 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.partitionHTMLInputProps = exports.htmlInputProps = exports.htmlInputEvents = exports.htmlInputAttrs = undefined;
	
	var _includes2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _forEach2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var htmlInputAttrs = exports.htmlInputAttrs = [
	// REACT
	'selected', 'defaultValue', 'defaultChecked',
	
	// LIMITED HTML PROPS
	'autoCapitalize', 'autoComplete', 'autoCorrect', 'autoFocus', 'checked', 'disabled', 'form', 'id', 'list', 'max', 'maxLength', 'min', 'minLength', 'multiple', 'name', 'pattern', 'placeholder', 'readOnly', 'required', 'step', 'type', 'value'];
	
	var htmlInputEvents = exports.htmlInputEvents = [
	// EVENTS
	// keyboard
	'onKeyDown', 'onKeyPress', 'onKeyUp',
	
	// focus
	'onFocus', 'onBlur',
	
	// form
	'onChange', 'onInput',
	
	// mouse
	'onClick', 'onContextMenu', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp',
	
	// selection
	'onSelect',
	
	// touch
	'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart'];
	
	var htmlInputProps = exports.htmlInputProps = [].concat(htmlInputAttrs, htmlInputEvents);
	
	/**
	 * Returns an array of objects consisting of: props of html input element and rest.
	 * @param {object} props A ReactElement props object
	 * @param {Object} [options={}]
	 * @param {Array} [options.htmlProps] An array of html input props
	 * @param {boolean} [options.includeAria] Includes all input props that starts with "aria-"
	 * @returns {[{}, {}]} An array of objects
	 */
	var partitionHTMLInputProps = exports.partitionHTMLInputProps = function partitionHTMLInputProps(props) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$htmlProps = options.htmlProps,
	      htmlProps = _options$htmlProps === undefined ? htmlInputProps : _options$htmlProps,
	      _options$includeAria = options.includeAria,
	      includeAria = _options$includeAria === undefined ? true : _options$includeAria;
	
	  var inputProps = {};
	  var rest = {};
	
	  (0, _forEach3.default)(props, function (val, prop) {
	    var possibleAria = includeAria && (/^aria-.*$/.test(prop) || prop === 'role');
	    var target = (0, _includes3.default)(htmlProps, prop) || possibleAria ? inputProps : rest;
	    target[prop] = val;
	  });
	
	  return [inputProps, rest];
	};

/***/ },
/* 4530 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isObject2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _times2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _times3 = _interopRequireDefault(_times2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * All previous KeyboardEvent key identifying properties are deprecated in favor of `key`.
	 * Unfortunately, `key` is not yet fully supported.
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
	 */
	var codes = {
	  // ----------------------------------------
	  // By Code
	  // ----------------------------------------
	  3: 'Cancel',
	  6: 'Help',
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  28: 'Convert',
	  29: 'NonConvert',
	  30: 'Accept',
	  31: 'ModeChange',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  41: 'Select',
	  42: 'Print',
	  43: 'Execute',
	  44: 'PrintScreen',
	  45: 'Insert',
	  46: 'Delete',
	  48: ['0', ')'],
	  49: ['1', '!'],
	  50: ['2', '@'],
	  51: ['3', '#'],
	  52: ['4', '$'],
	  53: ['5', '%'],
	  54: ['6', '^'],
	  55: ['7', '&'],
	  56: ['8', '*'],
	  57: ['9', '('],
	  91: 'OS',
	  93: 'ContextMenu',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  181: 'VolumeMute',
	  182: 'VolumeDown',
	  183: 'VolumeUp',
	  186: [';', ':'],
	  187: ['=', '+'],
	  188: [',', '<'],
	  189: ['-', '_'],
	  190: ['.', '>'],
	  191: ['/', '?'],
	  192: ['`', '~'],
	  219: ['[', '{'],
	  220: ['\\', '|'],
	  221: [']', '}'],
	  222: ["'", '"'],
	  224: 'Meta',
	  225: 'AltGraph',
	  246: 'Attn',
	  247: 'CrSel',
	  248: 'ExSel',
	  249: 'EraseEof',
	  250: 'Play',
	  251: 'ZoomOut'
	
	  // Function Keys (F1-24)
	};(0, _times3.default)(24, function (i) {
	  return codes[112 + i] = 'F' + (i + 1);
	});
	
	// Alphabet (a-Z)
	(0, _times3.default)(26, function (i) {
	  var n = i + 65;
	  codes[n] = [String.fromCharCode(n + 32), String.fromCharCode(n)];
	});
	
	var keyboardKey = {
	  codes: codes,
	
	  /**
	   * Get the `keyCode` or `which` value from a keyboard event or `key` name.
	   * @param {string|object} name A keyboard event like object or `key` name.
	   * @param {string} [name.key] If object, it must have one of these keys.
	   * @param {string} [name.keyCode] If object, it must have one of these keys.
	   * @param {string} [name.which] If object, it must have one of these keys.
	   * @returns {*}
	   */
	  getCode: function getCode(name) {
	    if ((0, _isObject3.default)(name)) {
	      return name.keyCode || name.which || this[name.key];
	    }
	    return this[name];
	  },
	
	
	  /**
	   * Get the key name from a keyboard event, `keyCode`, or `which` value.
	   * @param {number|object} code A keyboard event like object or key name.
	   * @param {number} [code.keyCode] If object, it must have one of these keys.
	   * @param {number} [code.which] If object, it must have one of these keys.
	   * @param {number} [code.shiftKey] If object, it must have one of these keys.
	   * @returns {*}
	   */
	  getName: function getName(code) {
	    var isEvent = (0, _isObject3.default)(code);
	    var name = codes[isEvent ? code.keyCode || code.which : code];
	
	    if (Array.isArray(name)) {
	      if (isEvent) {
	        name = name[code.shiftKey ? 1 : 0];
	      } else {
	        name = name[0];
	      }
	    }
	
	    return name;
	  },
	
	
	  // ----------------------------------------
	  // By Name
	  // ----------------------------------------
	  // declare these manually for static analysis
	  Cancel: 3,
	  Help: 6,
	  Backspace: 8,
	  Tab: 9,
	  Clear: 12,
	  Enter: 13,
	  Shift: 16,
	  Control: 17,
	  Alt: 18,
	  Pause: 19,
	  CapsLock: 20,
	  Escape: 27,
	  Convert: 28,
	  NonConvert: 29,
	  Accept: 30,
	  ModeChange: 31,
	  ' ': 32,
	  PageUp: 33,
	  PageDown: 34,
	  End: 35,
	  Home: 36,
	  ArrowLeft: 37,
	  ArrowUp: 38,
	  ArrowRight: 39,
	  ArrowDown: 40,
	  Select: 41,
	  Print: 42,
	  Execute: 43,
	  PrintScreen: 44,
	  Insert: 45,
	  Delete: 46,
	  0: 48,
	  ')': 48,
	  1: 49,
	  '!': 49,
	  2: 50,
	  '@': 50,
	  3: 51,
	  '#': 51,
	  4: 52,
	  $: 52,
	  5: 53,
	  '%': 53,
	  6: 54,
	  '^': 54,
	  7: 55,
	  '&': 55,
	  8: 56,
	  '*': 56,
	  9: 57,
	  '(': 57,
	  a: 65,
	  A: 65,
	  b: 66,
	  B: 66,
	  c: 67,
	  C: 67,
	  d: 68,
	  D: 68,
	  e: 69,
	  E: 69,
	  f: 70,
	  F: 70,
	  g: 71,
	  G: 71,
	  h: 72,
	  H: 72,
	  i: 73,
	  I: 73,
	  j: 74,
	  J: 74,
	  k: 75,
	  K: 75,
	  l: 76,
	  L: 76,
	  m: 77,
	  M: 77,
	  n: 78,
	  N: 78,
	  o: 79,
	  O: 79,
	  p: 80,
	  P: 80,
	  q: 81,
	  Q: 81,
	  r: 82,
	  R: 82,
	  s: 83,
	  S: 83,
	  t: 84,
	  T: 84,
	  u: 85,
	  U: 85,
	  v: 86,
	  V: 86,
	  w: 87,
	  W: 87,
	  x: 88,
	  X: 88,
	  y: 89,
	  Y: 89,
	  z: 90,
	  Z: 90,
	  OS: 91,
	  ContextMenu: 93,
	  F1: 112,
	  F2: 113,
	  F3: 114,
	  F4: 115,
	  F5: 116,
	  F6: 117,
	  F7: 118,
	  F8: 119,
	  F9: 120,
	  F10: 121,
	  F11: 122,
	  F12: 123,
	  F13: 124,
	  F14: 125,
	  F15: 126,
	  F16: 127,
	  F17: 128,
	  F18: 129,
	  F19: 130,
	  F20: 131,
	  F21: 132,
	  F22: 133,
	  F23: 134,
	  F24: 135,
	  NumLock: 144,
	  ScrollLock: 145,
	  VolumeMute: 181,
	  VolumeDown: 182,
	  VolumeUp: 183,
	  ';': 186,
	  ':': 186,
	  '=': 187,
	  '+': 187,
	  ',': 188,
	  '<': 188,
	  '-': 189,
	  _: 189,
	  '.': 190,
	  '>': 190,
	  '/': 191,
	  '?': 191,
	  '`': 192,
	  '~': 192,
	  '[': 219,
	  '{': 219,
	  '\\': 220,
	  '|': 220,
	  ']': 221,
	  '}': 221,
	  "'": 222,
	  '"': 222,
	  Meta: 224,
	  AltGraph: 225,
	  Attn: 246,
	  CrSel: 247,
	  ExSel: 248,
	  EraseEof: 249,
	  Play: 250,
	  ZoomOut: 251
	
	  // ----------------------------------------
	  // By Alias
	  // ----------------------------------------
	  // provide dot-notation accessible keys for all key names
	};keyboardKey.Spacebar = keyboardKey[' '];
	keyboardKey.Digit0 = keyboardKey['0'];
	keyboardKey.Digit1 = keyboardKey['1'];
	keyboardKey.Digit2 = keyboardKey['2'];
	keyboardKey.Digit3 = keyboardKey['3'];
	keyboardKey.Digit4 = keyboardKey['4'];
	keyboardKey.Digit5 = keyboardKey['5'];
	keyboardKey.Digit6 = keyboardKey['6'];
	keyboardKey.Digit7 = keyboardKey['7'];
	keyboardKey.Digit8 = keyboardKey['8'];
	keyboardKey.Digit9 = keyboardKey['9'];
	keyboardKey.Tilde = keyboardKey['~'];
	keyboardKey.GraveAccent = keyboardKey['`'];
	keyboardKey.ExclamationPoint = keyboardKey['!'];
	keyboardKey.AtSign = keyboardKey['@'];
	keyboardKey.PoundSign = keyboardKey['#'];
	keyboardKey.PercentSign = keyboardKey['%'];
	keyboardKey.Caret = keyboardKey['^'];
	keyboardKey.Ampersand = keyboardKey['&'];
	keyboardKey.PlusSign = keyboardKey['+'];
	keyboardKey.MinusSign = keyboardKey['-'];
	keyboardKey.EqualsSign = keyboardKey['='];
	keyboardKey.DivisionSign = keyboardKey['/'];
	keyboardKey.MultiplicationSign = keyboardKey['*'];
	keyboardKey.Comma = keyboardKey[','];
	keyboardKey.Decimal = keyboardKey['.'];
	keyboardKey.Colon = keyboardKey[':'];
	keyboardKey.Semicolon = keyboardKey[';'];
	keyboardKey.Pipe = keyboardKey['|'];
	keyboardKey.BackSlash = keyboardKey['\\'];
	keyboardKey.QuestionMark = keyboardKey['?'];
	keyboardKey.SingleQuote = keyboardKey['"'];
	keyboardKey.DoubleQuote = keyboardKey['"'];
	keyboardKey.LeftCurlyBrace = keyboardKey['{'];
	keyboardKey.RightCurlyBrace = keyboardKey['}'];
	keyboardKey.LeftParenthesis = keyboardKey['('];
	keyboardKey.RightParenthesis = keyboardKey[')'];
	keyboardKey.LeftAngleBracket = keyboardKey['<'];
	keyboardKey.RightAngleBracket = keyboardKey['>'];
	keyboardKey.LeftSquareBracket = keyboardKey['['];
	keyboardKey.RightSquareBracket = keyboardKey[']'];
	
	exports.default = keyboardKey;

/***/ },
/* 4531 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(63);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _each2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _invoke2 = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _includes2 = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _AccordionContent = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _AccordionContent2 = _interopRequireDefault(_AccordionContent);
	
	var _AccordionTitle = __webpack_require__(__webpack_module_template_argument_8__);
	
	var _AccordionTitle2 = _interopRequireDefault(_AccordionTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An Accordion can contain sub-accordions.
	 */
	var AccordionAccordion = function (_Component) {
	  (0, _inherits3.default)(AccordionAccordion, _Component);
	
	  function AccordionAccordion() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AccordionAccordion);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AccordionAccordion.__proto__ || Object.getPrototypeOf(AccordionAccordion)).call.apply(_ref, [this].concat(args))), _this), _this.computeNewIndex = function (index) {
	      var exclusive = _this.props.exclusive;
	      var activeIndex = _this.state.activeIndex;
	
	
	      if (exclusive) return index === activeIndex ? -1 : index;
	      // check to see if index is in array, and remove it, if not then add it
	      return (0, _includes3.default)(activeIndex, index) ? (0, _without3.default)(activeIndex, index) : [].concat((0, _toConsumableArray3.default)(activeIndex), [index]);
	    }, _this.handleTitleOverrides = function (predefinedProps) {
	      return {
	        onClick: function onClick(e, titleProps) {
	          var index = titleProps.index;
	
	          var activeIndex = _this.computeNewIndex(index);
	
	          _this.trySetState({ activeIndex: activeIndex });
	
	          (0, _invoke3.default)(predefinedProps, 'onClick', e, titleProps);
	          (0, _invoke3.default)(_this.props, 'onTitleClick', e, titleProps);
	        }
	      };
	    }, _this.isIndexActive = function (index) {
	      var exclusive = _this.props.exclusive;
	      var activeIndex = _this.state.activeIndex;
	
	
	      return exclusive ? activeIndex === index : (0, _includes3.default)(activeIndex, index);
	    }, _this.renderPanels = function () {
	      var children = [];
	      var panels = _this.props.panels;
	
	
	      (0, _each3.default)(panels, function (panel, index) {
	        var content = panel.content,
	            title = panel.title;
	
	        var active = _this.isIndexActive(index);
	
	        children.push(_AccordionTitle2.default.create(title, {
	          defaultProps: { active: active, index: index },
	          overrideProps: _this.handleTitleOverrides
	        }));
	        children.push(_AccordionContent2.default.create(content, { defaultProps: { active: active } }));
	      });
	
	      return children;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AccordionAccordion, [{
	    key: 'getInitialAutoControlledState',
	    value: function getInitialAutoControlledState(_ref2) {
	      var exclusive = _ref2.exclusive;
	
	      return { activeIndex: exclusive ? -1 : [-1] };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children;
	
	
	      var classes = (0, _classnames2.default)('accordion', className);
	      var rest = (0, _lib.getUnhandledProps)(AccordionAccordion, this.props);
	      var ElementType = (0, _lib.getElementType)(AccordionAccordion, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes }),
	        (0, _isNil3.default)(children) ? this.renderPanels() : children
	      );
	    }
	  }]);
	  return AccordionAccordion;
	}(_lib.AutoControlledComponent);
	
	AccordionAccordion.defaultProps = {
	  exclusive: true
	};
	AccordionAccordion.autoControlledProps = ['activeIndex'];
	AccordionAccordion._meta = {
	  name: 'AccordionAccordion',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Accordion'
	};
	AccordionAccordion.handledProps = ['activeIndex', 'as', 'children', 'className', 'defaultActiveIndex', 'exclusive', 'onTitleClick', 'panels'];
	exports.default = AccordionAccordion;
	AccordionAccordion.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Index of the currently active panel. */
	  activeIndex: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.number), _propTypes2.default.number])]),
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Initial activeIndex value. */
	  defaultActiveIndex: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.number), _propTypes2.default.number])]),
	
	  /** Only allow one panel open at a time. */
	  exclusive: _propTypes2.default.bool,
	
	  /**
	   * Called when a panel title is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All item props.
	   */
	  onTitleClick: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes2.default.func]),
	
	  /** Shorthand array of props for Accordion. */
	  panels: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    content: _lib.customPropTypes.itemShorthand,
	    title: _lib.customPropTypes.itemShorthand
	  }))])
	} : {};
	
	
	AccordionAccordion.create = (0, _lib.createShorthandFactory)(AccordionAccordion, function (content) {
	  return { content: content };
	});

/***/ },
/* 4532 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A content sub-component for Accordion component.
	 */
	function AccordionContent(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('content', (0, _lib.useKeyOnly)(active, 'active'), className);
	  var rest = (0, _lib.getUnhandledProps)(AccordionContent, props);
	  var ElementType = (0, _lib.getElementType)(AccordionContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	AccordionContent.handledProps = ['active', 'as', 'children', 'className', 'content'];
	AccordionContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Whether or not the content is visible. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	AccordionContent._meta = {
	  name: 'AccordionContent',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Accordion'
	};
	
	AccordionContent.create = (0, _lib.createShorthandFactory)(AccordionContent, function (content) {
	  return { content: content };
	});
	
	exports.default = AccordionContent;

/***/ },
/* 4533 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _isNil2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _invoke2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _Icon = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A title sub-component for Accordion component.
	 */
	var AccordionTitle = function (_Component) {
	  (0, _inherits3.default)(AccordionTitle, _Component);
	
	  function AccordionTitle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AccordionTitle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AccordionTitle.__proto__ || Object.getPrototypeOf(AccordionTitle)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      return (0, _invoke3.default)(_this.props, 'onClick', e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AccordionTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          content = _props.content;
	
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), 'title', className);
	      var rest = (0, _lib.getUnhandledProps)(AccordionTitle, this.props);
	      var ElementType = (0, _lib.getElementType)(AccordionTitle, this.props);
	
	      if ((0, _isNil3.default)(content)) {
	        return _react2.default.createElement(
	          ElementType,
	          (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, onClick: this.handleClick }),
	        _react2.default.createElement(_Icon2.default, { name: 'dropdown' }),
	        content
	      );
	    }
	  }]);
	  return AccordionTitle;
	}(_react.Component);
	
	AccordionTitle._meta = {
	  name: 'AccordionTitle',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Accordion'
	};
	AccordionTitle.handledProps = ['active', 'as', 'children', 'className', 'content', 'index', 'onClick'];
	exports.default = AccordionTitle;
	AccordionTitle.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Whether or not the title is in the open state. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** AccordionTitle index inside Accordion. */
	  index: _propTypes2.default.number,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func
	} : {};
	
	
	AccordionTitle.create = (0, _lib.createShorthandFactory)(AccordionTitle, function (content) {
	  return { content: content };
	});

/***/ },
/* 4534 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(130);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _isNil2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_3__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A checkbox allows a user to select a value from a small set of options, often binary.
	 * @see Form
	 * @see Radio
	 */
	var Checkbox = function (_Component) {
	  (0, _inherits3.default)(Checkbox, _Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.canToggle = function () {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          radio = _this$props.radio,
	          readOnly = _this$props.readOnly;
	      var checked = _this.state.checked;
	
	
	      return !disabled && !readOnly && !(radio && checked);
	    }, _this.computeTabIndex = function () {
	      var _this$props2 = _this.props,
	          disabled = _this$props2.disabled,
	          tabIndex = _this$props2.tabIndex;
	
	
	      if (!(0, _isNil3.default)(tabIndex)) return tabIndex;
	      return disabled ? -1 : 0;
	    }, _this.handleInputRef = function (c) {
	      return _this.inputRef = c;
	    }, _this.handleClick = function (e) {
	      var _this$state = _this.state,
	          checked = _this$state.checked,
	          indeterminate = _this$state.indeterminate;
	
	
	      if (!_this.canToggle()) return;
	
	      (0, _invoke3.default)(_this.props, 'onClick', e, (0, _extends3.default)({}, _this.props, { checked: !checked, indeterminate: !!indeterminate }));
	      (0, _invoke3.default)(_this.props, 'onChange', e, (0, _extends3.default)({}, _this.props, { checked: !checked, indeterminate: false }));
	
	      _this.trySetState({ checked: !checked, indeterminate: false });
	    }, _this.handleMouseDown = function (e) {
	      var _this$state2 = _this.state,
	          checked = _this$state2.checked,
	          indeterminate = _this$state2.indeterminate;
	
	
	      (0, _invoke3.default)(_this.props, 'onMouseDown', e, (0, _extends3.default)({}, _this.props, { checked: !!checked, indeterminate: !!indeterminate }));
	      (0, _invoke3.default)(_this.inputRef, 'focus');
	
	      e.preventDefault();
	    }, _this.setIndeterminate = function () {
	      var indeterminate = _this.state.indeterminate;
	
	
	      if (_this.inputRef) _this.inputRef.indeterminate = !!indeterminate;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Checkbox, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setIndeterminate();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setIndeterminate();
	    }
	
	    // Note: You can't directly set the indeterminate prop on the input, so we
	    // need to maintain a ref to the input and set it manually whenever the
	    // component updates.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          disabled = _props.disabled,
	          label = _props.label,
	          name = _props.name,
	          radio = _props.radio,
	          readOnly = _props.readOnly,
	          slider = _props.slider,
	          toggle = _props.toggle,
	          type = _props.type,
	          value = _props.value;
	      var _state = this.state,
	          checked = _state.checked,
	          indeterminate = _state.indeterminate;
	
	
	      var classes = (0, _classnames2.default)('ui', (0, _lib.useKeyOnly)(checked, 'checked'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(indeterminate, 'indeterminate'),
	      // auto apply fitted class to compact white space when there is no label
	      // https://semantic-ui.com/modules/checkbox.html#fitted
	      (0, _lib.useKeyOnly)(!label, 'fitted'), (0, _lib.useKeyOnly)(radio, 'radio'), (0, _lib.useKeyOnly)(readOnly, 'read-only'), (0, _lib.useKeyOnly)(slider, 'slider'), (0, _lib.useKeyOnly)(toggle, 'toggle'), 'checkbox', className);
	      var unhandled = (0, _lib.getUnhandledProps)(Checkbox, this.props);
	      var ElementType = (0, _lib.getElementType)(Checkbox, this.props);
	
	      var _partitionHTMLInputPr = (0, _lib.partitionHTMLInputProps)(unhandled, { htmlProps: [] }),
	          _partitionHTMLInputPr2 = (0, _slicedToArray3.default)(_partitionHTMLInputPr, 2),
	          htmlInputProps = _partitionHTMLInputPr2[0],
	          rest = _partitionHTMLInputPr2[1];
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, {
	          className: classes,
	          onChange: this.handleClick,
	          onClick: this.handleClick,
	          onMouseDown: this.handleMouseDown
	        }),
	        _react2.default.createElement('input', (0, _extends3.default)({}, htmlInputProps, {
	          checked: checked,
	          className: 'hidden',
	          name: name,
	          readOnly: true,
	          ref: this.handleInputRef,
	          tabIndex: this.computeTabIndex(),
	          type: type,
	          value: value
	        })),
	        (0, _lib.createHTMLLabel)(label) || _react2.default.createElement('label', null)
	      );
	    }
	  }]);
	  return Checkbox;
	}(_lib.AutoControlledComponent);
	
	Checkbox.defaultProps = {
	  type: 'checkbox'
	};
	Checkbox.autoControlledProps = ['checked', 'indeterminate'];
	Checkbox._meta = {
	  name: 'Checkbox',
	  type: _lib.META.TYPES.MODULE
	};
	Checkbox.handledProps = ['as', 'checked', 'className', 'defaultChecked', 'defaultIndeterminate', 'disabled', 'fitted', 'indeterminate', 'label', 'name', 'onChange', 'onClick', 'onMouseDown', 'radio', 'readOnly', 'slider', 'tabIndex', 'toggle', 'type', 'value'];
	exports.default = Checkbox;
	Checkbox.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Whether or not checkbox is checked. */
	  checked: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** The initial value of checked. */
	  defaultChecked: _propTypes2.default.bool,
	
	  /** Whether or not checkbox is indeterminate. */
	  defaultIndeterminate: _propTypes2.default.bool,
	
	  /** A checkbox can appear disabled and be unable to change states */
	  disabled: _propTypes2.default.bool,
	
	  /** Removes padding for a label. Auto applied when there is no label. */
	  fitted: _propTypes2.default.bool,
	
	  /** Whether or not checkbox is indeterminate. */
	  indeterminate: _propTypes2.default.bool,
	
	  /** The text of the associated label element. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** The HTML input name. */
	  name: _propTypes2.default.string,
	
	  /**
	   * Called when the user attempts to change the checked state.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed checked/indeterminate state.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * Called when the checkbox or label is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and current checked/indeterminate state.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Called when the user presses down on the mouse.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and current checked/indeterminate state.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /** Format as a radio element. This means it is an exclusive option. */
	  radio: _lib.customPropTypes.every([_propTypes2.default.bool, _lib.customPropTypes.disallow(['slider', 'toggle'])]),
	
	  /** A checkbox can be read-only and unable to change states. */
	  readOnly: _propTypes2.default.bool,
	
	  /** Format to emphasize the current selection state. */
	  slider: _lib.customPropTypes.every([_propTypes2.default.bool, _lib.customPropTypes.disallow(['radio', 'toggle'])]),
	
	  /** A checkbox can receive focus. */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** Format to show an on or off choice. */
	  toggle: _lib.customPropTypes.every([_propTypes2.default.bool, _lib.customPropTypes.disallow(['radio', 'slider'])]),
	
	  /** HTML input type, either checkbox or radio. */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio']),
	
	  /** The HTML input value. */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	} : {};

/***/ },
/* 4535 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ },
/* 4536 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dimmer = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Dimmer2 = _interopRequireDefault(_Dimmer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dimmer2.default;

/***/ },
/* 4537 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A dropdown menu can contain dividers to separate related content.
	 */
	function DropdownDivider(props) {
	  var className = props.className;
	
	  var classes = (0, _classnames2.default)('divider', className);
	  var rest = (0, _lib.getUnhandledProps)(DropdownDivider, props);
	  var ElementType = (0, _lib.getElementType)(DropdownDivider, props);
	
	  return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, { className: classes }));
	}
	
	DropdownDivider.handledProps = ['as', 'className'];
	DropdownDivider._meta = {
	  name: 'DropdownDivider',
	  parent: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	
	DropdownDivider.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = DropdownDivider;

/***/ },
/* 4538 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Icon = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A dropdown menu can contain a header.
	 */
	function DropdownHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      icon = props.icon;
	
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(DropdownHeader, props);
	  var ElementType = (0, _lib.getElementType)(DropdownHeader, props);
	
	  if (!_lib.childrenUtils.isNil(children)) return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    children
	  );
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _Icon2.default.create(icon),
	    content
	  );
	}
	
	DropdownHeader.handledProps = ['as', 'children', 'className', 'content', 'icon'];
	DropdownHeader._meta = {
	  name: 'DropdownHeader',
	  parent: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	
	DropdownHeader.propTypes =  false ? {
	  /** An element type to render as (string or function) */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand
	} : {};
	
	DropdownHeader.create = (0, _lib.createShorthandFactory)(DropdownHeader, function (content) {
	  return { content: content };
	});
	
	exports.default = DropdownHeader;

/***/ },
/* 4539 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _invoke2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _get2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_3__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A search item sub-component for Dropdown component.
	 */
	var DropdownSearchInput = function (_Component) {
	  (0, _inherits3.default)(DropdownSearchInput, _Component);
	
	  function DropdownSearchInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropdownSearchInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropdownSearchInput.__proto__ || Object.getPrototypeOf(DropdownSearchInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
	      var value = (0, _get3.default)(e, 'target.value');
	
	      (0, _invoke3.default)(_this.props, 'onChange', e, (0, _extends3.default)({}, _this.props, { value: value }));
	    }, _this.handleRef = function (c) {
	      return (0, _invoke3.default)(_this.props, 'inputRef', c);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DropdownSearchInput, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          tabIndex = _props.tabIndex,
	          type = _props.type,
	          value = _props.value;
	
	      var classes = (0, _classnames2.default)('search', className);
	      var rest = (0, _lib.getUnhandledProps)(DropdownSearchInput, this.props);
	
	      return _react2.default.createElement('input', (0, _extends3.default)({}, rest, {
	        'aria-autocomplete': 'list',
	        autoComplete: 'off',
	        className: classes,
	        onChange: this.handleChange,
	        ref: this.handleRef,
	        tabIndex: tabIndex,
	        type: type,
	        value: value
	      }));
	    }
	  }]);
	  return DropdownSearchInput;
	}(_react.Component);
	
	DropdownSearchInput.defaultProps = {
	  type: 'text'
	};
	DropdownSearchInput._meta = {
	  name: 'DropdownSearchInput',
	  parent: 'Dropdown',
	  type: _lib.META.TYPES.MODULE
	};
	DropdownSearchInput.handledProps = ['as', 'className', 'inputRef', 'tabIndex', 'type', 'value'];
	DropdownSearchInput.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** A ref handler for input. */
	  inputRef: _propTypes2.default.func,
	
	  /** An input can receive focus. */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** The HTML input type. */
	  type: _propTypes2.default.string,
	
	  /** Stored value. */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	} : {};
	
	
	DropdownSearchInput.create = (0, _lib.createShorthandFactory)(DropdownSearchInput, function (type) {
	  return { type: type };
	});
	
	exports.default = DropdownSearchInput;

/***/ },
/* 4540 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dropdown = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dropdown2.default;

/***/ },
/* 4541 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Embed = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Embed2 = _interopRequireDefault(_Embed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Embed2.default;

/***/ },
/* 4542 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A modal can contain content.
	 */
	function ModalContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      image = props.image,
	      scrolling = props.scrolling;
	
	
	  var classes = (0, _classnames2.default)(className, (0, _lib.useKeyOnly)(image, 'image'), (0, _lib.useKeyOnly)(scrolling, 'scrolling'), 'content');
	  var rest = (0, _lib.getUnhandledProps)(ModalContent, props);
	  var ElementType = (0, _lib.getElementType)(ModalContent, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ModalContent.handledProps = ['as', 'children', 'className', 'content', 'image', 'scrolling'];
	ModalContent._meta = {
	  name: 'ModalContent',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Modal'
	};
	
	ModalContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A modal can contain image content. */
	  image: _propTypes2.default.bool,
	
	  /** A modal can use the entire size of the screen. */
	  scrolling: _propTypes2.default.bool
	} : {};
	
	ModalContent.create = (0, _lib.createShorthandFactory)(ModalContent, function (content) {
	  return { content: content };
	});
	
	exports.default = ModalContent;

/***/ },
/* 4543 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A modal can have a header.
	 */
	function ModalHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)(className, 'header');
	  var rest = (0, _lib.getUnhandledProps)(ModalHeader, props);
	  var ElementType = (0, _lib.getElementType)(ModalHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ModalHeader.handledProps = ['as', 'children', 'className', 'content'];
	ModalHeader._meta = {
	  name: 'ModalHeader',
	  type: _lib.META.TYPES.MODULE,
	  parent: 'Modal'
	};
	
	ModalHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	ModalHeader.create = (0, _lib.createShorthandFactory)(ModalHeader, function (content) {
	  return { content: content };
	});
	
	exports.default = ModalHeader;

/***/ },
/* 4544 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Modal = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;

/***/ },
/* 4545 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Popup = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Popup2.default;

/***/ },
/* 4546 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Progress = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Progress2 = _interopRequireDefault(_Progress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Progress2.default;

/***/ },
/* 4547 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _times2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _times3 = _interopRequireDefault(_times2);
	
	var _invoke2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _RatingIcon = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _RatingIcon2 = _interopRequireDefault(_RatingIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A rating indicates user interest in content.
	 */
	var Rating = function (_Component) {
	  (0, _inherits3.default)(Rating, _Component);
	
	  function Rating() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Rating);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Rating.__proto__ || Object.getPrototypeOf(Rating)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Rating, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          disabled = _props.disabled,
	          icon = _props.icon,
	          maxRating = _props.maxRating,
	          size = _props.size;
	      var _state = this.state,
	          rating = _state.rating,
	          selectedIndex = _state.selectedIndex,
	          isSelecting = _state.isSelecting;
	
	
	      var classes = (0, _classnames2.default)('ui', icon, size, (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(isSelecting && !disabled && selectedIndex >= 0, 'selected'), 'rating', className);
	      var rest = (0, _lib.getUnhandledProps)(Rating, this.props);
	      var ElementType = (0, _lib.getElementType)(Rating, this.props);
	
	      return _react2.default.createElement(
	        ElementType,
	        (0, _extends3.default)({}, rest, { className: classes, role: 'radiogroup', onMouseLeave: this.handleMouseLeave }),
	        (0, _times3.default)(maxRating, function (i) {
	          return _react2.default.createElement(_RatingIcon2.default, {
	            active: rating >= i + 1,
	            'aria-checked': rating === i + 1,
	            'aria-posinset': i + 1,
	            'aria-setsize': maxRating,
	            index: i,
	            key: i,
	            onClick: _this2.handleIconClick,
	            onMouseEnter: _this2.handleIconMouseEnter,
	            selected: selectedIndex >= i && isSelecting
	          });
	        })
	      );
	    }
	  }]);
	  return Rating;
	}(_lib.AutoControlledComponent);
	
	Rating.autoControlledProps = ['rating'];
	Rating.defaultProps = {
	  clearable: 'auto',
	  maxRating: 1
	};
	Rating._meta = {
	  name: 'Rating',
	  type: _lib.META.TYPES.MODULE
	};
	Rating.Icon = _RatingIcon2.default;
	Rating.handledProps = ['as', 'className', 'clearable', 'defaultRating', 'disabled', 'icon', 'maxRating', 'onRate', 'rating', 'size'];
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleIconClick = function (e, _ref2) {
	    var index = _ref2.index;
	    var _props2 = _this3.props,
	        clearable = _props2.clearable,
	        disabled = _props2.disabled,
	        maxRating = _props2.maxRating,
	        onRate = _props2.onRate;
	    var rating = _this3.state.rating;
	
	    if (disabled) return;
	
	    // default newRating is the clicked icon
	    // allow toggling a binary rating
	    // allow clearing ratings
	    var newRating = index + 1;
	    if (clearable === 'auto' && maxRating === 1) {
	      newRating = +!rating;
	    } else if (clearable === true && newRating === rating) {
	      newRating = 0;
	    }
	
	    // set rating
	    _this3.trySetState({ rating: newRating }, { isSelecting: false });
	    if (onRate) onRate(e, (0, _extends3.default)({}, _this3.props, { rating: newRating }));
	  };
	
	  this.handleIconMouseEnter = function (e, _ref3) {
	    var index = _ref3.index;
	
	    if (_this3.props.disabled) return;
	
	    _this3.setState({ selectedIndex: index, isSelecting: true });
	  };
	
	  this.handleMouseLeave = function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    _invoke3.default.apply(undefined, [_this3.props, 'onMouseLeave'].concat(args));
	
	    if (_this3.props.disabled) return;
	
	    _this3.setState({ selectedIndex: -1, isSelecting: false });
	  };
	};
	
	exports.default = Rating;
	Rating.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /**
	   * You can clear the rating by clicking on the current start rating.
	   * By default a rating will be only clearable if there is 1 icon.
	   * Setting to `true`/`false` will allow or disallow a user to clear their rating.
	   */
	  clearable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['auto'])]),
	
	  /** The initial rating value. */
	  defaultRating: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** You can disable or enable interactive rating.  Makes a read-only rating. */
	  disabled: _propTypes2.default.bool,
	
	  /** A rating can use a set of star or heart icons. */
	  icon: _propTypes2.default.oneOf(['star', 'heart']),
	
	  /** The total number of icons. */
	  maxRating: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Called after user selects a new rating.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed rating.
	   */
	  onRate: _propTypes2.default.func,
	
	  /** The current number of active icons. */
	  rating: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** A progress bar can vary in size. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'medium', 'big'))
	} : {};

/***/ },
/* 4548 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An internal icon sub-component for Rating component
	 */
	var RatingIcon = function (_Component) {
	  (0, _inherits3.default)(RatingIcon, _Component);
	
	  function RatingIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RatingIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RatingIcon.__proto__ || Object.getPrototypeOf(RatingIcon)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var onClick = _this.props.onClick;
	
	
	      if (onClick) onClick(e, _this.props);
	    }, _this.handleKeyUp = function (e) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          onKeyUp = _this$props.onKeyUp;
	
	
	      if (onKeyUp) onKeyUp(e, _this.props);
	
	      if (onClick) {
	        switch (_lib.keyboardKey.getCode(e)) {
	          case _lib.keyboardKey.Enter:
	          case _lib.keyboardKey.Spacebar:
	            e.preventDefault();
	            onClick(e, _this.props);
	            break;
	          default:
	        }
	      }
	    }, _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	
	      if (onMouseEnter) onMouseEnter(e, _this.props);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RatingIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          className = _props.className,
	          selected = _props.selected;
	
	      var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(selected, 'selected'), 'icon', className);
	      var rest = (0, _lib.getUnhandledProps)(RatingIcon, this.props);
	      var ElementType = (0, _lib.getElementType)(RatingIcon, this.props);
	
	      return _react2.default.createElement(ElementType, (0, _extends3.default)({}, rest, {
	        className: classes,
	        onClick: this.handleClick,
	        onKeyUp: this.handleKeyUp,
	        onMouseEnter: this.handleMouseEnter,
	        tabIndex: 0,
	        role: 'radio'
	      }));
	    }
	  }]);
	  return RatingIcon;
	}(_react.Component);
	
	RatingIcon.defaultProps = {
	  as: 'i'
	};
	RatingIcon._meta = {
	  name: 'RatingIcon',
	  parent: 'Rating',
	  type: _lib.META.TYPES.MODULE
	};
	RatingIcon.handledProps = ['active', 'as', 'className', 'index', 'onClick', 'onKeyUp', 'onMouseEnter', 'selected'];
	exports.default = RatingIcon;
	RatingIcon.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Indicates activity of an icon. */
	  active: _propTypes2.default.bool,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** An index of icon inside Rating. */
	  index: _propTypes2.default.number,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Called on keyup.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * Called on mouseenter.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onMouseEnter: _propTypes2.default.func,
	
	  /** Indicates selection of an icon. */
	  selected: _propTypes2.default.bool
	} : {};

/***/ },
/* 4549 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Rating = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Rating2 = _interopRequireDefault(_Rating);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Rating2.default;

/***/ },
/* 4550 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Search = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Search2.default;

/***/ },
/* 4551 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Sidebar = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Sidebar2.default;

/***/ },
/* 4552 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Sticky = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Sticky2 = _interopRequireDefault(_Sticky);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Sticky2.default;

/***/ },
/* 4553 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(120);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(17);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _map2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _get2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _invoke2 = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _invoke3 = _interopRequireDefault(_invoke2);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _Grid = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _GridColumn = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _GridColumn2 = _interopRequireDefault(_GridColumn);
	
	var _Menu = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _TabPane = __webpack_require__(__webpack_module_template_argument_8__);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A Tab is a hidden section of content activated by a Menu.
	 * @see Menu
	 * @see Segment
	 */
	var Tab = function (_Component) {
	  (0, _inherits3.default)(Tab, _Component);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || Object.getPrototypeOf(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemClick = function (e, _ref2) {
	      var index = _ref2.index;
	
	      (0, _invoke3.default)(_this.props, 'onTabChange', e, (0, _extends3.default)({}, _this.props, { activeIndex: index }));
	      _this.trySetState({ activeIndex: index });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tab, [{
	    key: 'getInitialAutoControlledState',
	    value: function getInitialAutoControlledState() {
	      return { activeIndex: 0 };
	    }
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var _props = this.props,
	          panes = _props.panes,
	          renderActiveOnly = _props.renderActiveOnly;
	      var activeIndex = this.state.activeIndex;
	
	
	      if (renderActiveOnly) return (0, _invoke3.default)((0, _get3.default)(panes, '[' + activeIndex + ']'), 'render', this.props);
	      return (0, _map3.default)(panes, function (_ref3, index) {
	        var pane = _ref3.pane;
	        return _TabPane2.default.create(pane, {
	          overrideProps: {
	            active: index === activeIndex
	          }
	        });
	      });
	    }
	  }, {
	    key: 'renderMenu',
	    value: function renderMenu() {
	      var _props2 = this.props,
	          menu = _props2.menu,
	          panes = _props2.panes;
	      var activeIndex = this.state.activeIndex;
	
	
	      return _Menu2.default.create(menu, {
	        overrideProps: {
	          items: (0, _map3.default)(panes, 'menuItem'),
	          onItemClick: this.handleItemClick,
	          activeIndex: activeIndex
	        }
	      });
	    }
	  }, {
	    key: 'renderVertical',
	    value: function renderVertical(menu) {
	      var grid = this.props.grid;
	      var paneWidth = grid.paneWidth,
	          tabWidth = grid.tabWidth,
	          gridProps = (0, _objectWithoutProperties3.default)(grid, ['paneWidth', 'tabWidth']);
	
	
	      return _react2.default.createElement(
	        _Grid2.default,
	        gridProps,
	        menu.props.tabular !== 'right' && _GridColumn2.default.create({ width: tabWidth, children: menu }),
	        _GridColumn2.default.create({
	          width: paneWidth,
	          children: this.renderItems(),
	          stretched: true
	        }),
	        menu.props.tabular === 'right' && _GridColumn2.default.create({ width: tabWidth, children: menu })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var menu = this.renderMenu();
	      var rest = (0, _lib.getUnhandledProps)(Tab, this.props);
	      var ElementType = (0, _lib.getElementType)(Tab, this.props);
	
	      if (menu.props.vertical) {
	        return _react2.default.createElement(
	          ElementType,
	          rest,
	          this.renderVertical(menu)
	        );
	      }
	
	      return _react2.default.createElement(
	        ElementType,
	        rest,
	        menu.props.attached !== 'bottom' && menu,
	        this.renderItems(),
	        menu.props.attached === 'bottom' && menu
	      );
	    }
	  }]);
	  return Tab;
	}(_lib.AutoControlledComponent);
	
	Tab.autoControlledProps = ['activeIndex'];
	Tab.defaultProps = {
	  grid: { paneWidth: 12, tabWidth: 4 },
	  menu: { attached: true, tabular: true },
	  renderActiveOnly: true
	};
	Tab._meta = {
	  name: 'Tab',
	  type: _lib.META.TYPES.MODULE
	};
	Tab.Pane = _TabPane2.default;
	Tab.handledProps = ['activeIndex', 'as', 'defaultActiveIndex', 'grid', 'menu', 'onTabChange', 'panes', 'renderActiveOnly'];
	Tab.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** The initial activeIndex. */
	  defaultActiveIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** Index of the currently active tab. */
	  activeIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /** Shorthand props for the Menu. */
	  menu: _propTypes2.default.object,
	
	  /** Shorthand props for the Grid. */
	  grid: _propTypes2.default.object,
	
	  /**
	   * Called on tab change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed new activeIndex.
	   * @param {object} data.activeIndex - The new proposed activeIndex.
	   */
	  onTabChange: _propTypes2.default.func,
	
	  /**
	   * Array of objects describing each Menu.Item and Tab.Pane:
	   * { menuItem: 'Home', render: () => <Tab.Pane /> }
	   * or
	   * { menuItem: 'Home', pane: 'Welcome' }
	   */
	  panes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    menuItem: _lib.customPropTypes.itemShorthand,
	    pane: _lib.customPropTypes.itemShorthand,
	    render: _propTypes2.default.func
	  })),
	
	  /** A Tab can render only active pane. */
	  renderActiveOnly: _propTypes2.default.bool
	} : {};
	exports.default = Tab;

/***/ },
/* 4554 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Segment = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _Segment2 = _interopRequireDefault(_Segment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A tab pane holds the content of a tab.
	 */
	function TabPane(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      loading = props.loading;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(loading, 'loading'), 'tab', className);
	  var rest = (0, _lib.getUnhandledProps)(TabPane, props);
	  var ElementType = (0, _lib.getElementType)(TabPane, props);
	
	  var calculatedDefaultProps = {};
	  if (ElementType === _Segment2.default) {
	    calculatedDefaultProps.attached = 'bottom';
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, calculatedDefaultProps, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	TabPane.handledProps = ['active', 'as', 'children', 'className', 'content', 'loading'];
	TabPane._meta = {
	  name: 'TabPane',
	  parent: 'Tab',
	  type: _lib.META.TYPES.MODULE
	};
	
	TabPane.defaultProps = {
	  as: _Segment2.default,
	  active: true
	};
	
	TabPane.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** A tab pane can be active. */
	  active: _propTypes2.default.bool,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A Tab.Pane can display a loading indicator. */
	  loading: _propTypes2.default.bool
	} : {};
	
	TabPane.create = (0, _lib.createShorthandFactory)(TabPane, function (content) {
	  return { content: content };
	});
	
	exports.default = TabPane;

/***/ },
/* 4555 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Tab = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Tab2.default;

/***/ },
/* 4556 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Transition = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Transition2.default;

/***/ },
/* 4557 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Advertisement = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Advertisement2 = _interopRequireDefault(_Advertisement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Advertisement2.default;

/***/ },
/* 4558 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_2__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A card can contain a description with one or more paragraphs.
	 */
	function CardDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      textAlign = props.textAlign;
	
	  var classes = (0, _classnames2.default)((0, _lib.useTextAlignProp)(textAlign), 'description', className);
	  var rest = (0, _lib.getUnhandledProps)(CardDescription, props);
	  var ElementType = (0, _lib.getElementType)(CardDescription, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	CardDescription.handledProps = ['as', 'children', 'className', 'content', 'textAlign'];
	CardDescription._meta = {
	  name: 'CardDescription',
	  parent: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	
	CardDescription.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A card content can adjust its text alignment. */
	  textAlign: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified'))
	} : {};
	
	exports.default = CardDescription;

/***/ },
/* 4559 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_2__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A card can contain a header.
	 */
	function CardHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      textAlign = props.textAlign;
	
	  var classes = (0, _classnames2.default)((0, _lib.useTextAlignProp)(textAlign), 'header', className);
	  var rest = (0, _lib.getUnhandledProps)(CardHeader, props);
	  var ElementType = (0, _lib.getElementType)(CardHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	CardHeader.handledProps = ['as', 'children', 'className', 'content', 'textAlign'];
	CardHeader._meta = {
	  name: 'CardHeader',
	  parent: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	
	CardHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A card header can adjust its text alignment. */
	  textAlign: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified'))
	} : {};
	
	exports.default = CardHeader;

/***/ },
/* 4560 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_2__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A card can contain content metadata.
	 */
	function CardMeta(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      textAlign = props.textAlign;
	
	  var classes = (0, _classnames2.default)((0, _lib.useTextAlignProp)(textAlign), 'meta', className);
	  var rest = (0, _lib.getUnhandledProps)(CardMeta, props);
	  var ElementType = (0, _lib.getElementType)(CardMeta, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	CardMeta.handledProps = ['as', 'children', 'className', 'content', 'textAlign'];
	CardMeta._meta = {
	  name: 'CardMeta',
	  parent: 'Card',
	  type: _lib.META.TYPES.VIEW
	};
	
	CardMeta.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A card meta can adjust its text alignment. */
	  textAlign: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.TEXT_ALIGNMENTS, 'justified'))
	} : {};
	
	exports.default = CardMeta;

/***/ },
/* 4561 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A comment can contain an image or avatar.
	 */
	function CommentAvatar(props) {
	  var className = props.className,
	      src = props.src;
	
	  var classes = (0, _classnames2.default)('avatar', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentAvatar, props);
	  var ElementType = (0, _lib.getElementType)(CommentAvatar, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createHTMLImage)(src)
	  );
	}
	
	CommentAvatar.handledProps = ['as', 'className', 'src'];
	CommentAvatar._meta = {
	  name: 'CommentAvatar',
	  parent: 'Comment',
	  type: _lib.META.TYPES.VIEW
	};
	
	CommentAvatar.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Specifies the URL of the image. */
	  src: _propTypes2.default.string
	} : {};
	
	exports.default = CommentAvatar;

/***/ },
/* 4562 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Comment = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Comment2 = _interopRequireDefault(_Comment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Comment2.default;

/***/ },
/* 4563 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(120);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _without2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _map2 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _FeedContent = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _FeedContent2 = _interopRequireDefault(_FeedContent);
	
	var _FeedDate = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _FeedDate2 = _interopRequireDefault(_FeedDate);
	
	var _FeedEvent = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _FeedEvent2 = _interopRequireDefault(_FeedEvent);
	
	var _FeedExtra = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _FeedExtra2 = _interopRequireDefault(_FeedExtra);
	
	var _FeedLabel = __webpack_require__(__webpack_module_template_argument_8__);
	
	var _FeedLabel2 = _interopRequireDefault(_FeedLabel);
	
	var _FeedLike = __webpack_require__(__webpack_module_template_argument_9__);
	
	var _FeedLike2 = _interopRequireDefault(_FeedLike);
	
	var _FeedMeta = __webpack_require__(__webpack_module_template_argument_10__);
	
	var _FeedMeta2 = _interopRequireDefault(_FeedMeta);
	
	var _FeedSummary = __webpack_require__(__webpack_module_template_argument_11__);
	
	var _FeedSummary2 = _interopRequireDefault(_FeedSummary);
	
	var _FeedUser = __webpack_require__(__webpack_module_template_argument_12__);
	
	var _FeedUser2 = _interopRequireDefault(_FeedUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed presents user activity chronologically.
	 */
	function Feed(props) {
	  var children = props.children,
	      className = props.className,
	      events = props.events,
	      size = props.size;
	
	
	  var classes = (0, _classnames2.default)('ui', size, 'feed', className);
	  var rest = (0, _lib.getUnhandledProps)(Feed, props);
	  var ElementType = (0, _lib.getElementType)(Feed, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  var eventElements = (0, _map3.default)(events, function (eventProps) {
	    var childKey = eventProps.childKey,
	        date = eventProps.date,
	        meta = eventProps.meta,
	        summary = eventProps.summary,
	        eventData = (0, _objectWithoutProperties3.default)(eventProps, ['childKey', 'date', 'meta', 'summary']);
	
	    var finalKey = childKey || [date, meta, summary].join('-');
	
	    return _react2.default.createElement(_FeedEvent2.default, (0, _extends3.default)({
	      date: date,
	      key: finalKey,
	      meta: meta,
	      summary: summary
	    }, eventData));
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    eventElements
	  );
	}
	
	Feed.handledProps = ['as', 'children', 'className', 'events', 'size'];
	Feed._meta = {
	  name: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	Feed.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand array of props for FeedEvent. */
	  events: _lib.customPropTypes.collectionShorthand,
	
	  /** A feed can have different sizes. */
	  size: _propTypes2.default.oneOf((0, _without3.default)(_lib.SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive'))
	} : {};
	
	Feed.Content = _FeedContent2.default;
	Feed.Date = _FeedDate2.default;
	Feed.Event = _FeedEvent2.default;
	Feed.Extra = _FeedExtra2.default;
	Feed.Label = _FeedLabel2.default;
	Feed.Like = _FeedLike2.default;
	Feed.Meta = _FeedMeta2.default;
	Feed.Summary = _FeedSummary2.default;
	Feed.User = _FeedUser2.default;
	
	exports.default = Feed;

/***/ },
/* 4564 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _FeedDate = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _FeedDate2 = _interopRequireDefault(_FeedDate);
	
	var _FeedExtra = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _FeedExtra2 = _interopRequireDefault(_FeedExtra);
	
	var _FeedMeta = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _FeedMeta2 = _interopRequireDefault(_FeedMeta);
	
	var _FeedSummary = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _FeedSummary2 = _interopRequireDefault(_FeedSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FeedContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      extraImages = props.extraImages,
	      extraText = props.extraText,
	      date = props.date,
	      meta = props.meta,
	      summary = props.summary;
	
	
	  var classes = (0, _classnames2.default)('content', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedContent, props);
	  var ElementType = (0, _lib.getElementType)(FeedContent, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_FeedDate2.default, function (val) {
	      return { content: val };
	    }, date),
	    (0, _lib.createShorthand)(_FeedSummary2.default, function (val) {
	      return { content: val };
	    }, summary),
	    content,
	    (0, _lib.createShorthand)(_FeedExtra2.default, function (val) {
	      return { text: true, content: val };
	    }, extraText),
	    (0, _lib.createShorthand)(_FeedExtra2.default, function (val) {
	      return { images: val };
	    }, extraImages),
	    (0, _lib.createShorthand)(_FeedMeta2.default, function (val) {
	      return { content: val };
	    }, meta)
	  );
	}
	
	FeedContent.handledProps = ['as', 'children', 'className', 'content', 'date', 'extraImages', 'extraText', 'meta', 'summary'];
	FeedContent._meta = {
	  name: 'FeedContent',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	FeedContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** An event can contain a date. */
	  date: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedExtra with images. */
	  extraImages: _FeedExtra2.default.propTypes.images,
	
	  /** Shorthand for FeedExtra with text. */
	  extraText: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedSummary. */
	  summary: _lib.customPropTypes.itemShorthand
	} : {};
	
	exports.default = FeedContent;

/***/ },
/* 4565 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An event or an event summary can contain a date.
	 */
	function FeedDate(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('date', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedDate, props);
	  var ElementType = (0, _lib.getElementType)(FeedDate, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	FeedDate.handledProps = ['as', 'children', 'className', 'content'];
	FeedDate._meta = {
	  name: 'FeedDate',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	FeedDate.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	exports.default = FeedDate;

/***/ },
/* 4566 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _FeedContent = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _FeedContent2 = _interopRequireDefault(_FeedContent);
	
	var _FeedLabel = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _FeedLabel2 = _interopRequireDefault(_FeedLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed contains an event.
	 */
	function FeedEvent(props) {
	  var content = props.content,
	      children = props.children,
	      className = props.className,
	      date = props.date,
	      extraImages = props.extraImages,
	      extraText = props.extraText,
	      image = props.image,
	      icon = props.icon,
	      meta = props.meta,
	      summary = props.summary;
	
	
	  var classes = (0, _classnames2.default)('event', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedEvent, props);
	  var ElementType = (0, _lib.getElementType)(FeedEvent, props);
	
	  var hasContentProp = content || date || extraImages || extraText || meta || summary;
	  var contentProps = { content: content, date: date, extraImages: extraImages, extraText: extraText, meta: meta, summary: summary };
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_FeedLabel2.default, function (val) {
	      return { icon: val };
	    }, icon),
	    (0, _lib.createShorthand)(_FeedLabel2.default, function (val) {
	      return { image: val };
	    }, image),
	    hasContentProp && _react2.default.createElement(_FeedContent2.default, contentProps),
	    children
	  );
	}
	
	FeedEvent.handledProps = ['as', 'children', 'className', 'content', 'date', 'extraImages', 'extraText', 'icon', 'image', 'meta', 'summary'];
	FeedEvent._meta = {
	  name: 'FeedEvent',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	FeedEvent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for FeedContent. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedDate. */
	  date: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedExtra with images. */
	  extraImages: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedExtra with content. */
	  extraText: _lib.customPropTypes.itemShorthand,
	
	  /** An event can contain icon label. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** An event can contain image label. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedSummary. */
	  summary: _lib.customPropTypes.itemShorthand
	} : {};
	
	exports.default = FeedEvent;

/***/ },
/* 4567 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_2__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed can contain an extra content.
	 */
	function FeedExtra(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      images = props.images,
	      text = props.text;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useKeyOnly)(images, 'images'), (0, _lib.useKeyOnly)(content || text, 'text'), 'extra', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedExtra, props);
	  var ElementType = (0, _lib.getElementType)(FeedExtra, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  // TODO need a "collection factory" to handle creating multiple image elements and their keys
	  var imageElements = (0, _map3.default)(images, function (image, index) {
	    var key = [index, image].join('-');
	    return (0, _lib.createHTMLImage)(image, { key: key });
	  });
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content,
	    imageElements
	  );
	}
	
	FeedExtra.handledProps = ['as', 'children', 'className', 'content', 'images', 'text'];
	FeedExtra._meta = {
	  name: 'FeedExtra',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	FeedExtra.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** An event can contain additional information like a set of images. */
	  images: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['text']), _propTypes2.default.oneOfType([_propTypes2.default.bool, _lib.customPropTypes.collectionShorthand])]),
	
	  /** An event can contain additional text information. */
	  text: _propTypes2.default.bool
	} : {};
	
	exports.default = FeedExtra;

/***/ },
/* 4568 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Icon = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An event can contain an image or icon label.
	 */
	function FeedLabel(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      icon = props.icon,
	      image = props.image;
	
	
	  var classes = (0, _classnames2.default)('label', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedLabel, props);
	  var ElementType = (0, _lib.getElementType)(FeedLabel, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    content,
	    _Icon2.default.create(icon),
	    (0, _lib.createHTMLImage)(image)
	  );
	}
	
	FeedLabel.handledProps = ['as', 'children', 'className', 'content', 'icon', 'image'];
	FeedLabel._meta = {
	  name: 'FeedLabel',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	FeedLabel.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** An event can contain icon label. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** An event can contain image label. */
	  image: _lib.customPropTypes.itemShorthand
	} : {};
	
	exports.default = FeedLabel;

/***/ },
/* 4569 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Icon = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed can contain a like element.
	 */
	function FeedLike(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      icon = props.icon;
	
	
	  var classes = (0, _classnames2.default)('like', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedLike, props);
	  var ElementType = (0, _lib.getElementType)(FeedLike, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _Icon2.default.create(icon),
	    content
	  );
	}
	
	FeedLike.handledProps = ['as', 'children', 'className', 'content', 'icon'];
	FeedLike._meta = {
	  name: 'FeedLike',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	FeedLike.defaultProps = {
	  as: 'a'
	};
	
	FeedLike.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for icon. Mutually exclusive with children. */
	  icon: _lib.customPropTypes.itemShorthand
	} : {};
	
	exports.default = FeedLike;

/***/ },
/* 4570 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _FeedLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _FeedLike2 = _interopRequireDefault(_FeedLike);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed can contain a meta.
	 */
	function FeedMeta(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      like = props.like;
	
	
	  var classes = (0, _classnames2.default)('meta', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedMeta, props);
	  var ElementType = (0, _lib.getElementType)(FeedMeta, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_FeedLike2.default, function (val) {
	      return { content: val };
	    }, like),
	    content
	  );
	}
	
	FeedMeta.handledProps = ['as', 'children', 'className', 'content', 'like'];
	FeedMeta._meta = {
	  name: 'FeedMeta',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	FeedMeta.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for FeedLike. */
	  like: _lib.customPropTypes.itemShorthand
	} : {};
	
	exports.default = FeedMeta;

/***/ },
/* 4571 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _FeedDate = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _FeedDate2 = _interopRequireDefault(_FeedDate);
	
	var _FeedUser = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _FeedUser2 = _interopRequireDefault(_FeedUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed can contain a summary.
	 */
	function FeedSummary(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      date = props.date,
	      user = props.user;
	
	
	  var classes = (0, _classnames2.default)('summary', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedSummary, props);
	  var ElementType = (0, _lib.getElementType)(FeedSummary, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    (0, _lib.createShorthand)(_FeedUser2.default, function (val) {
	      return { content: val };
	    }, user),
	    content,
	    (0, _lib.createShorthand)(_FeedDate2.default, function (val) {
	      return { content: val };
	    }, date)
	  );
	}
	
	FeedSummary.handledProps = ['as', 'children', 'className', 'content', 'date', 'user'];
	FeedSummary._meta = {
	  name: 'FeedSummary',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	FeedSummary.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for FeedDate. */
	  date: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedUser. */
	  user: _lib.customPropTypes.itemShorthand
	} : {};
	
	exports.default = FeedSummary;

/***/ },
/* 4572 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A feed can contain a user element.
	 */
	function FeedUser(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('user', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedUser, props);
	  var ElementType = (0, _lib.getElementType)(FeedUser, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	FeedUser.handledProps = ['as', 'children', 'className', 'content'];
	FeedUser._meta = {
	  name: 'FeedUser',
	  parent: 'Feed',
	  type: _lib.META.TYPES.VIEW
	};
	
	FeedUser.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	FeedUser.defaultProps = {
	  as: 'a'
	};
	
	exports.default = FeedUser;

/***/ },
/* 4573 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Feed = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Feed2 = _interopRequireDefault(_Feed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Feed2.default;

/***/ },
/* 4574 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _ItemContent = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _ItemContent2 = _interopRequireDefault(_ItemContent);
	
	var _ItemDescription = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _ItemDescription2 = _interopRequireDefault(_ItemDescription);
	
	var _ItemExtra = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _ItemExtra2 = _interopRequireDefault(_ItemExtra);
	
	var _ItemGroup = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _ItemGroup2 = _interopRequireDefault(_ItemGroup);
	
	var _ItemHeader = __webpack_require__(__webpack_module_template_argument_6__);
	
	var _ItemHeader2 = _interopRequireDefault(_ItemHeader);
	
	var _ItemImage = __webpack_require__(__webpack_module_template_argument_7__);
	
	var _ItemImage2 = _interopRequireDefault(_ItemImage);
	
	var _ItemMeta = __webpack_require__(__webpack_module_template_argument_8__);
	
	var _ItemMeta2 = _interopRequireDefault(_ItemMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item view presents large collections of site content for display.
	 */
	function Item(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      extra = props.extra,
	      header = props.header,
	      image = props.image,
	      meta = props.meta;
	
	
	  var classes = (0, _classnames2.default)('item', className);
	  var rest = (0, _lib.getUnhandledProps)(Item, props);
	  var ElementType = (0, _lib.getElementType)(Item, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _ItemImage2.default.create(image),
	    _react2.default.createElement(_ItemContent2.default, {
	      content: content,
	      description: description,
	      extra: extra,
	      header: header,
	      meta: meta
	    })
	  );
	}
	
	Item.handledProps = ['as', 'children', 'className', 'content', 'description', 'extra', 'header', 'image', 'meta'];
	Item._meta = {
	  name: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	Item.Content = _ItemContent2.default;
	Item.Description = _ItemDescription2.default;
	Item.Extra = _ItemExtra2.default;
	Item.Group = _ItemGroup2.default;
	Item.Header = _ItemHeader2.default;
	Item.Image = _ItemImage2.default;
	Item.Meta = _ItemMeta2.default;
	
	Item.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for ItemContent component. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for ItemDescription component. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemExtra component. */
	  extra: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemHeader component. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemImage component. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemMeta component. */
	  meta: _lib.customPropTypes.itemShorthand
	} : {};
	
	exports.default = Item;

/***/ },
/* 4575 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _ItemHeader = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _ItemHeader2 = _interopRequireDefault(_ItemHeader);
	
	var _ItemDescription = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _ItemDescription2 = _interopRequireDefault(_ItemDescription);
	
	var _ItemExtra = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _ItemExtra2 = _interopRequireDefault(_ItemExtra);
	
	var _ItemMeta = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _ItemMeta2 = _interopRequireDefault(_ItemMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item can contain content.
	 */
	function ItemContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      extra = props.extra,
	      header = props.header,
	      meta = props.meta,
	      verticalAlign = props.verticalAlign;
	
	
	  var classes = (0, _classnames2.default)((0, _lib.useVerticalAlignProp)(verticalAlign), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemContent, props);
	  var ElementType = (0, _lib.getElementType)(ItemContent, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react2.default.createElement(
	      ElementType,
	      (0, _extends3.default)({}, rest, { className: classes }),
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _ItemHeader2.default.create(header),
	    _ItemMeta2.default.create(meta),
	    _ItemDescription2.default.create(description),
	    _ItemExtra2.default.create(extra),
	    content
	  );
	}
	
	ItemContent.handledProps = ['as', 'children', 'className', 'content', 'description', 'extra', 'header', 'meta', 'verticalAlign'];
	ItemContent._meta = {
	  name: 'ItemContent',
	  parent: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	ItemContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for ItemDescription component. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemExtra component. */
	  extra: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemHeader component. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemMeta component. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /** Content can specify its vertical alignment. */
	  verticalAlign: _propTypes2.default.oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	
	exports.default = ItemContent;

/***/ },
/* 4576 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item can contain a description with a single or multiple paragraphs.
	 */
	function ItemDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('description', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemDescription, props);
	  var ElementType = (0, _lib.getElementType)(ItemDescription, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ItemDescription.handledProps = ['as', 'children', 'className', 'content'];
	ItemDescription._meta = {
	  name: 'ItemDescription',
	  parent: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	ItemDescription.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	ItemDescription.create = (0, _lib.createShorthandFactory)(ItemDescription, function (content) {
	  return { content: content };
	});
	
	exports.default = ItemDescription;

/***/ },
/* 4577 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item can contain extra content meant to be formatted separately from the main content.
	 */
	function ItemExtra(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('extra', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemExtra, props);
	  var ElementType = (0, _lib.getElementType)(ItemExtra, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ItemExtra.handledProps = ['as', 'children', 'className', 'content'];
	ItemExtra._meta = {
	  name: 'ItemExtra',
	  parent: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	ItemExtra.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	ItemExtra.create = (0, _lib.createShorthandFactory)(ItemExtra, function (content) {
	  return { content: content };
	});
	
	exports.default = ItemExtra;

/***/ },
/* 4578 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item can contain a header.
	 */
	function ItemHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('header', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemHeader, props);
	  var ElementType = (0, _lib.getElementType)(ItemHeader, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ItemHeader.handledProps = ['as', 'children', 'className', 'content'];
	ItemHeader._meta = {
	  name: 'ItemHeader',
	  parent: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	ItemHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	ItemHeader.create = (0, _lib.createShorthandFactory)(ItemHeader, function (content) {
	  return { content: content };
	});
	
	exports.default = ItemHeader;

/***/ },
/* 4579 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Image = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item can contain an image.
	 */
	function ItemImage(props) {
	  var size = props.size;
	
	  var rest = (0, _lib.getUnhandledProps)(ItemImage, props);
	
	  return _react2.default.createElement(_Image2.default, (0, _extends3.default)({}, rest, { size: size, ui: !!size, wrapped: true }));
	}
	
	ItemImage.handledProps = ['size'];
	ItemImage._meta = {
	  name: 'ItemImage',
	  parent: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	ItemImage.propTypes =  false ? {
	  /** An image may appear at different sizes. */
	  size: _Image2.default.propTypes.size
	} : {};
	
	ItemImage.create = (0, _lib.createShorthandFactory)(ItemImage, function (src) {
	  return { src: src };
	});
	
	exports.default = ItemImage;

/***/ },
/* 4580 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An item can contain content metadata.
	 */
	function ItemMeta(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	
	  var classes = (0, _classnames2.default)('meta', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemMeta, props);
	  var ElementType = (0, _lib.getElementType)(ItemMeta, props);
	
	  return _react2.default.createElement(
	    ElementType,
	    (0, _extends3.default)({}, rest, { className: classes }),
	    _lib.childrenUtils.isNil(children) ? content : children
	  );
	}
	
	ItemMeta.handledProps = ['as', 'children', 'className', 'content'];
	ItemMeta._meta = {
	  name: 'ItemMeta',
	  parent: 'Item',
	  type: _lib.META.TYPES.VIEW
	};
	
	ItemMeta.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _lib.customPropTypes.as,
	
	  /** Primary content. */
	  children: _propTypes2.default.node,
	
	  /** Additional classes. */
	  className: _propTypes2.default.string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	
	ItemMeta.create = (0, _lib.createShorthandFactory)(ItemMeta, function (content) {
	  return { content: content };
	});
	
	exports.default = ItemMeta;

/***/ },
/* 4581 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Item = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Item2.default;

/***/ },
/* 4582 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Statistic = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Statistic2 = _interopRequireDefault(_Statistic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Statistic2.default;

/***/ },
/* 4583 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(36);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 4584 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.65115cbc.js
 **/